(function(){
  'use strict';
  angular
    .module('hub', ['ngCookies', 'ngSanitize', 'ngMessages', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'restangular', 'ngMap', 'ngDialog', 'ngSelectable', 'ngBootstrap', 'angularTreeview', 'fancyboxplus', 'uiSwitch', 'flow', 'vcRecaptcha', 'ui.bootstrap.contextMenu', 'ui-notification', 'ui.mask', 'oc.lazyLoad', 'highcharts-ng', 'ngMapAutocomplete', 'pascalprecht.translate', 'ngclipboard', 'multipleDatePicker', 'wysiwyg.module', 'gridstack-angular', 'angular-flexslider', 'angularUtils.directives.dirPagination', 'angularUtils.directives.dirPaginationClone']);//'gridster'
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SelectSocialController', SelectSocialController);

  /** @ngInject */
  function SelectSocialController($log, $scope, $rootScope, $filter, ContentLibrarySrv){
    $scope.thumbParam = "&h=60&w=90&q=80&zc=3";
    $scope.dThumbParam = "&h=60&w=90&q=80&zc=3";
    $scope.contentLoading = true;
    $scope.contentLibrary = {};
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";

    ContentLibrarySrv.getAll(0, "smw").then(
      function(data){
        $scope.contentLibrary = data;
        $scope.updateList();
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.folderContentFx = function(fId){
      $scope.contentLoading = true;
      ContentLibrarySrv.getAll(fId, "smw").then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getTooltip = function(isApproved, expiring){
      if(!isApproved && !expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.16');
      } else if(!isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.17');
      } else if(isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.18');
      } else{
        $scope.curTooltip="";
      }
      return $scope.curTooltip;
    }

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      if($scope.contentLibrary.info){
        $scope.bucket = $scope.contentLibrary.info.bucket;
        $scope.tim = $scope.contentLibrary.info.timthumb;

        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
          $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        }
        $scope.contentInfo = {tim:$scope.tim, cBucket:$scope.cBucket, cDetailBucket:$scope.cDetailBucket};
        $rootScope.$broadcast("contentInfo", $scope.contentInfo);
      }

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary.content){
        $scope.contentList = $scope.contentLibrary.contentLibrary.content;
      }
    }

    $scope.folderBriefFx = function(){ /* Do nothing */ }

    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.isDuplicate = false;
        angular.forEach($rootScope.selectSocialIems.widgets, function(listItem){
          if(listItem.id == item.id){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate && item.type != "folder" && item.type != "shortcut" && item.type != "sharepoint" && item.type != "SharePointC"){
          $scope.curItem = $scope.contentList.filter(function(obj){
            return obj.id == item.id;
          })[0];
          $rootScope.selectSocialIems.widgets.push({
            id:item.id,
            url:$scope.curItem.url,
            type:$scope.curItem.type,
            label:$scope.curItem.label,
            thumb:$scope.curItem.thumb,
            isCompleted:$scope.curItem.isCompleted
          });
        }
      });
    }

    $scope.closeFilteredFx = function(id){
      $scope.closeFiltered(id, $rootScope.selectSocialIems.widgets);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MoveTController', MoveTController);

  /** @ngInject */
  function MoveTController($log, $scope, $rootScope, $state, $filter, ngDialog, TemplatesSrv){
    $scope.moveProcessing = false;
    $scope.moveLoading = false;
    $rootScope.selectedT = 1;
    $scope.contentCount = 0;
    $scope.folderCount = 0;
    $scope.widgetCount = 0;
    $scope.serverList = [];
    $scope.moveItems = {};

    $scope.folderCount = $filter("filter")($scope.selectedItems, {type:"folder"}).length;
    angular.forEach($scope.selectedItems, function(item){
      if(item.type == "content" || item.type == "widget"){
        if($filter("filter")($scope.contentList, {id:item.id, type:"Widget"}).length){
          $scope.widgetCount = $filter("filter")($scope.contentList, {id:item.id, type:"Widget"}).length;
        } else{
          $scope.contentCount = $filter("filter")($scope.contentList, {id:item.id}).length;
        }
      }
    });

    $scope.allFalse = function(){
      $scope.arError = false;
      $scope.fError = false;
      $scope.cError = false;
      $scope.wError = false;
      $scope.hasErr = false;
    }

    $rootScope.selectedTabFx = function(){
      $scope.allFalse();
      if($scope.selectedT == 1){
        if($scope.moveObj.type == "copy"){
          if(!$scope.auth.upermissions.tf && $scope.folderCount > 0){
            $scope.fError = true;
          }
          if(($scope.auth.upermissions.tf && !$scope.auth.upermissions.t) || (!$scope.auth.upermissions.t && $scope.folderCount == 0)){
            $scope.cError = true;
          }
          if(!$scope.auth.upermissions.w && $scope.widgetCount > 0){
            $scope.wError = true;
          }
        } else{
          $scope.allFalse();
        }
      } else{
        $scope.moveObj.server = null;
      }
      if($scope.selectedT == 2 && $scope.serverList.length == 0){
        $scope.moveLoading = true;
        TemplatesSrv.getServersList().then(
          function(data){
            $scope.serverList = data.servers;
            $scope.moveLoading = false;
          }
        );
      }
    };
    $rootScope.selectedTabFx();

    $scope.changeTypeFx = function(){
      if($scope.selectedT == 1){
        $rootScope.selectedTabFx();
      }
    }

    $scope.changeServerFx = function(){
      $scope.allFalse();
      if($scope.moveObj.server != null){
        if(!$scope.moveObj.server.ar){
          $scope.arError = true;
        }
        if(!$scope.moveObj.server.f && $scope.folderCount > 0){
          $scope.fError = true;
        }
        if(!$scope.moveObj.server.c && $scope.contentCount > 0){
          $scope.cError = true;
        }
        if(!$scope.moveObj.server.w && $scope.widgetCount > 0){
          $scope.wError = true;
        }
      }
    }

    $scope.moveFx = function(action){
      $scope.moveOtherProcessing = false;
      $scope.moveProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.selectedT == 1){
        $scope.moveItems = {type:"folder", target:$("input[name='treeOpt']:checked").val(), selectedItems:$scope.selectedItems};
      } else{
        $scope.moveItems = {type:"server", target:$scope.moveObj.server, selectedItems:$scope.selectedItems};
      }
      if($scope.selectedT == 1 && $scope.moveItems.target == null){
        $scope.hasErr = true;
        $scope.errType = "folder";
        $("#folder").focus();
      } else if($scope.selectedT == 2 && $scope.moveObj.server == null){
        $scope.hasErr = true;
        $scope.errType = "server";
        $("#server").focus();
      } else if($scope.selectedT == 2 && $scope.moveObj.type == "move"){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
              <div class="panel-body">{{"cl.p_m.m10" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="moveOtherFx();" focus-me="true" ng-disabled="moveOtherProcessing"><span class="fa fa-repeat fa-spin" ng-if="moveOtherProcessing" aria-hidden="true"></span>{{"cl.p_m.8" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
          preCloseCallback:function(){
            $scope.moveOtherProcessing = false;
          }
        });
      } else{
        $scope.moveProcessing = true;
        if(action == "move"){
          $scope.moveOtherFx();
        }
        if(action == "copy"){
          TemplatesSrv.copy($scope.moveItems).then(
            function(data){
              ngDialog.close();
              $scope.loadSelectedTab();
              $scope.moveProcessing = false;
            },
            function(err){
              $scope.moveProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }
    $scope.moveOtherFx = function(){
      $scope.moveOtherProcessing = true;
      TemplatesSrv.move($scope.moveItems).then(
        function(data){
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.moveOtherProcessing = false;
          $scope.moveProcessing = false;
          $log.error(err);
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TFolderCUController', TFolderCUController);

  /** @ngInject */
  function TFolderCUController($log, $scope, $rootScope, $state, ngDialog, $timeout, $cookies, $interval, TemplatesSrv){
    $scope.folder = {info:{fid:$scope.ngDialogData.fid}};
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $rootScope.selectedSPfId = 0;
    $rootScope.selectedODfId = 0;
    $scope.odDisabled = true;
    $scope.isPEOpen = false;
    $scope.folderList = [];
    $scope.spStep = "auth";
    $scope.decId = "";

    if($scope.ngDialogData && $scope.ngDialogData.id){
      $scope.folder.info = $scope.ngDialogData;
      $scope.decId = $scope.ngDialogData.id;
      TemplatesSrv.getFolderDetails($scope.ngDialogData.id).then(
        function(data){
          $scope.folder = data;
          $scope.folder.info.fType = $scope.ngDialogData.fType;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $scope.folder = {info:{id:0, fid:$scope.ngDialogData.fid, label:"", fType:$scope.ngDialogData.fType}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        TemplatesSrv.getVerify().then(
          function(data){
            $scope.odProcessing = false;
            $scope.odDisabled = false;
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8194){
              $scope.errType = "odEmpty";
              $scope.showAuthBtn = true;
              $scope.hasErr = true;
              return;
            }
            if(data.code == 8195){
              $scope.errType = "authFailed";
              $scope.hasErr = true;
              return;
            }
            if(data.code == 8196){
              $scope.errType = "odNotExist";
              $scope.showAuthBtn = true;
              $scope.hasErr = true;
              return;
            } else{
              if(data.isClosed){
                $scope.odFolder = data;
                $scope.showAuthBtn = false;
                $scope.folder.data = data.info;
                if($scope.odFolder.od.folders[0].id){
                  $scope.selectednodeOD = $scope.odFolder.od.folders[0].id;
                }
              } else{
                $scope.errType = "authFailed";
                $scope.showAuthBtn = true;
                $scope.hasErr = true;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.folderCUFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.folder.info.label == undefined || $scope.folder.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      } else{
        $scope.saveProcessing = true;
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.folderCU();
          }, 250);
        } else{
          $scope.folderCU();
        }
      }
    }

    $scope.folderCU = function(){
      TemplatesSrv.folderCU($scope.folder).then(
        function(data){
          ngDialog.close();
          if($scope.ngDialogData.actionFrom == "pin"){
            $rootScope.loadPinnedItems();
          } else {
            $scope.loadSelectedTab();
            $scope.reloadTree();
          }
          $scope.saveProcessing = false;
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
    'use strict';
  
    angular
      .module('hub')
      .controller('TextEditorController', TextEditorController);
  
    /** @ngInject */
    function TextEditorController($log, $rootScope, $scope, $filter){
      
      $scope.curText = {
        tc:'#000000',
        tcTyp:'monochrome',
        bg:'#000000',
        bgTyp:'monochrome'
      };

      $scope.rgbaToHex = function(rgba) {
        var result = rgba.match(/rgba?\((\d+), ?(\d+), ?(\d+)(?:, ?([\d.]+))?\)/);
        if (!result) return null;
    
        var r = parseInt(result[1]);
        var g = parseInt(result[2]);
        var b = parseInt(result[3]);
        var a = result[4] !== undefined ? Math.round(parseFloat(result[4]) * 255) : 255;
    
        function toHex(n) {
          return ("0" + n.toString(16)).slice(-2).toUpperCase();
        }
    
        return '#' + toHex(r) + toHex(g) + toHex(b) + toHex(a);
      };

      $scope.monochromePallet = ["#000000", "#444444", "#666666", "#999999", "#cccccc", "#eeeeee", "#f3f3f3", "#ffffff"];
      $scope.basicPallet = ["#ff0000", "#ff9900", "#ffff00", "#00ff00", "#00ffff", "#0000ff", "#9900ff", "#ff00ff"];
      $scope.defaultPallet = ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc",
        "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd",
        "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0",
        "#cc0000", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79",
        "#990000", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47",
        "#660000", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"
      ];
      $scope.matchHaxType = function(colorHex){
        if($scope.monochromePallet.indexOf(colorHex) !== -1){
          return 'monochrome';
        } else if($scope.basicPallet.indexOf(colorHex) !== -1){
          return 'basic';
        } else if($scope.defaultPallet.indexOf(colorHex) !== -1){
          return 'default';
        } else{
          return 'custom';
        }
      }
    
      $scope.toRgba = function(rgbStr) {
        if(rgbStr.startsWith('rgba')){
          return rgbStr;
        } else{
          var rgb = rgbStr.match(/\d+/g);
          if (rgb && rgb.length === 3) {
            return 'rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)';
          }
        }
        return rgbStr; 
      }

      $scope.getAlpha = function(rgba) {
        var match = rgba.match(/rgba?\((\d+), ?(\d+), ?(\d+)(?:, ?([\d.]+))?\)/);
        return match ? (match[4] !== undefined ? parseFloat(match[4]) : 1) : 1;
      }
      
      $scope.saveSelection = function(){
        if (window.getSelection) {
          $scope.sel = window.getSelection();
          if ($scope.sel.getRangeAt && $scope.sel.rangeCount) {
            return $scope.sel.getRangeAt(0);
          }
        } else if (document.selection && document.selection.createRange) {
          return document.selection.createRange();
        }
        return null;
      }
      
      $scope.restoreSelection = function(range){
        if (range) {
          if (window.getSelection) {
            $scope.sel = window.getSelection();
            $scope.sel.removeAllRanges();
            $scope.sel.addRange(range);
          } else if (document.selection && range.select) {
            range.select();
          }
        }
      }
      
      var selRange;
      $scope.displayTextInserter = function(){
        selRange = $scope.saveSelection();
        document.getElementById("boldEditor").classList.remove("availableStyle");
        document.getElementById("italicEditor").classList.remove("availableStyle");
        document.getElementById("leftAlignEditor").classList.remove("availableStyle");
        document.getElementById("centerAlignEditor").classList.remove("availableStyle");
        document.getElementById("rightAlignEditor").classList.remove("availableStyle");
        document.getElementById("underlineEditor").classList.remove("availableStyle");
        document.getElementById("lineThroughEditor").classList.remove("availableStyle");
      }
  
      $scope.removeAllFormate = function(event){
        var clipboardData, pastedData;
        event.preventDefault();
        clipboardData = event.originalEvent.clipboardData
        pastedData = clipboardData.getData('Text');
          
        document.execCommand("insertHTML", false, pastedData);
      }
  
      $scope.getStyleText = function(){
        var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode
        var selectedDivBgcolor = window.getSelection().getRangeAt(0).startContainer.parentNode;
        if(window.getComputedStyle(selectedDivs).fontWeight == 600){
          document.getElementById("boldEditor").classList.add("availableStyle");
        }
        else{
          if($scope.themeSwitch.btn == 0){
            document.getElementById("boldEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("boldEditor").classList.remove("availableStyle");
          }
        }
        if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
          document.getElementById("italicEditor").classList.add("availableStyle");
        }
        else{
          if($scope.themeSwitch.btn == 0){
            document.getElementById("italicEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("italicEditor").classList.remove("availableStyle");
          }
        }
        if(window.getComputedStyle(selectedDivs).textAlign == "left"){
          document.getElementById("leftAlignEditor").classList.add("availableStyle");
        }
        else{
          if($scope.themeSwitch.btn == 0){
            document.getElementById("leftAlignEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("leftAlignEditor").classList.remove("availableStyle");
          }
        }
        if(window.getComputedStyle(selectedDivs).textAlign == "center"){
          document.getElementById("centerAlignEditor").classList.add("availableStyle");
        }
        else{
          if($scope.themeSwitch.btn == 0){
            document.getElementById("centerAlignEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("centerAlignEditor").classList.remove("availableStyle");
          }
        }
        if(window.getComputedStyle(selectedDivs).textAlign == "right"){
            document.getElementById("rightAlignEditor").classList.add("availableStyle");
        }
        else{
          if($scope.themeSwitch.btn == 0){
            document.getElementById("rightAlignEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("rightAlignEditor").classList.remove("availableStyle");
          }
        }
        var textDecorationFirst = window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect.split(" ")[0];
        if(textDecorationFirst == "underline"){
          document.getElementById("underlineEditor").classList.add("availableStyle");
        } 
        else if(textDecorationFirst != "underline"){
          if($scope.themeSwitch.btn == 0){
            document.getElementById("underlineEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("underlineEditor").classList.remove("availableStyle");
          }
        }
        if(textDecorationFirst == "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
        }
        else if(textDecorationFirst != "line-through"){
          if($scope.themeSwitch.btn == 0){
            document.getElementById("lineThroughEditor").classList.remove("availableStyle");
          }
          else if($scope.themeSwitch.btn == 1){
            document.getElementById("lineThroughEditor").classList.remove("availableStyle");
          }
        }
        if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect == "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect == "line-through underline"){
          document.getElementById("underlineEditor").classList.add("availableStyle");
          document.getElementById("lineThroughEditor").classList.add("availableStyle");
        }
        
        if(window.getSelection){
          if(!document.getElementById('tTextEditor') || document.getElementById('tTextEditor').innerHTML.trim() == ''){
            $scope.fontSizeValue = 24;
          } else{
            $scope.fontSizeValue = window.getComputedStyle(selectedDivs).fontSize.replace(/[^0-9\.]+/g,'')|0;
          }
  
          var changeColorEditor = window.getComputedStyle(selectedDivs).color;
          var hexColorEditor = '#' + changeColorEditor.slice(4,-1).split(',').map(function(x) {return (+x).toString(16).padStart(2,0)}).join('')
          $scope.curText.tc = hexColorEditor;
          $scope.curText.tcType = $scope.matchHaxType($scope.curText.tc);
          
          var changeBgColorEditor = window.getComputedStyle(selectedDivBgcolor).backgroundColor;
          if(changeBgColorEditor == 'rgba(0, 0, 0, 0)'){
            if($scope.frameBg.isChecked == true && $scope.curFrame.bg != '' && $rootScope.selectedT == '4'){
              var bgColorEditor1 = ""+ $scope.curFrame.bg.toUpperCase(); +"";
              $scope.curText.bg = bgColorEditor1;
              $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
            }else if($scope.frameBg.isChecked == false && $scope.curFrame.bg == '' && $rootScope.selectedT == '4'){
              $scope.curText.bg = 'transparent';
              $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
            }
          }else {
            var hexBgColorEditor = '#' + changeBgColorEditor.slice(4,-1).split(',').map(function(x){return (+x).toString(16).padStart(2,0)}).join('')
            $scope.curText.bg = hexBgColorEditor;
              $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
          }
          
  
          for(var i = 0; i < $scope.fontFamily.length; i++){
            if(window.getComputedStyle(selectedDivs).fontFamily.replace(/"/g,"").toLowerCase() === $scope.fontFamily[i].value.replace(/"/g,"").toLowerCase()){
              $scope.fontFamilyVal = $scope.fontFamily[i];
              break;
            }
            else{
              $scope.fontFamilyVal = $scope.fontFamilySelected;
            }
          }
        }
      }
  
      $scope.fontSizeValue = 24;
      $scope.fontFamilyVal = $scope.fontFamilySelected;
      $scope.insertSize = function(){        
        var mysize = document.getElementById("sizeToInsert").value;
        $scope.restoreSelection(selRange);
        document.execCommand('fontSize', false, mysize);
        var fontElements = document.getElementsByTagName("font");
        for(var i = 0; i < fontElements.length; i++){
          var parentNode1 = fontElements[i].parentNode.parentNode; //fontElements[i].parentNode.parentNode
          var parentNode2 = parentNode1.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode
          var parentNode3 = parentNode2.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(fontElements[i].size  == 1){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 1 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 2){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 2 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 3){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 3 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 4){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 4 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 5){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 5 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 6){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = 6 + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
          else if(fontElements[i].size  == 7){
            fontElements[i].removeAttribute("size");
            fontElements[i].style.fontSize = mysize + "px";
            if(parentNode1.nodeName == "OL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.nodeName == "UL"){
              parentNode1.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "OL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode1.parentNode.nodeName == "UL"){
              parentNode1.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "OL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.nodeName == "UL"){
              parentNode2.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "OL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode2.parentNode.nodeName == "UL"){
              parentNode2.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "OL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.nodeName == "UL"){
              parentNode3.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "OL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.nodeName == "UL"){
              parentNode3.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "OL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
            if(parentNode3.parentNode.parentNode.nodeName == "UL"){
              parentNode3.parentNode.parentNode.style.fontSize = mysize + "px";
            }
          }
        }         
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true});
          $("#textEditorHidden")[0].focus({ preventScroll: true});
        });
        // $scope.innerHtmlOfEditor('');
      }
      
      $scope.italicFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).textAlign == "left"){
            document.getElementById("leftAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "center"){
            document.getElementById("centerAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "right"){
            document.getElementById("rightAlignEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.remove("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).fontStyle == "normal"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          $scope.performAction('italic');
        }
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.boldFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).textAlign == "left"){
            document.getElementById("leftAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "center"){
            document.getElementById("centerAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "right"){
            document.getElementById("rightAlignEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.remove("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).fontWeight == 400){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          $scope.performAction('bold');
        }
        // $scope.innerHtmlOfEditor();
  
      }
  
      $scope.clearFont = function(color){
        document.execCommand('backColor', false, color);
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true });
          $("#textEditorHidden")[0].focus({ preventScroll: true });
        });
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.underlineFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          
          if(window.getComputedStyle(selectedDivs).textAlign == "left"){
            document.getElementById("leftAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "center"){
            document.getElementById("centerAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "right"){
            document.getElementById("rightAlignEditor").classList.add("availableStyle");
          } 
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect.split(" ")[0] === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect.split(" ")[1] === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect == "underline"){
            document.getElementById("underlineEditor").classList.remove("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect == "none"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          $scope.performAction('underline');
        }
  
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.strikethroughFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).textAlign == "left"){
            document.getElementById("leftAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "center"){
            document.getElementById("centerAlignEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textAlign == "right"){
            document.getElementById("rightAlignEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect.split(" ")[0] === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).textDecorationLine == "line-through"){
            document.getElementById("lineThroughEditor").classList.remove("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).textDecorationLine == "none"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          $scope.performAction('strikethrough');
        }
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.justifyLeftFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          document.getElementById("centerAlignEditor").classList.remove("availableStyle");
          document.getElementById("rightAlignEditor").classList.remove("availableStyle");
          $scope.performAction('justifyLeft');
          document.getElementById("leftAlignEditor").classList.add("availableStyle");
        }
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.justifyCenterFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          document.getElementById("leftAlignEditor").classList.remove("availableStyle");
          document.getElementById("rightAlignEditor").classList.remove("availableStyle");
          $scope.performAction('justifyCenter');
          document.getElementById("centerAlignEditor").classList.add("availableStyle");
        } 
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.justifyRightFont = function(){
        var selectedData = window.getSelection().toString()
        if(selectedData.length){
          var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode;
          if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through"){
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          else if(window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "underline line-through" || window.getComputedStyle(selectedDivs).webkitTextDecorationsInEffect === "line-through underline"){
            document.getElementById("underlineEditor").classList.add("availableStyle");
            document.getElementById("lineThroughEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontStyle == "italic"){
            document.getElementById("italicEditor").classList.add("availableStyle");
          }
          if(window.getComputedStyle(selectedDivs).fontWeight == 600){
            document.getElementById("boldEditor").classList.add("availableStyle");
          }
          document.getElementById("leftAlignEditor").classList.remove("availableStyle");
          document.getElementById("centerAlignEditor").classList.remove("availableStyle");
          $scope.performAction('justifyRight');
          document.getElementById("rightAlignEditor").classList.add("availableStyle");
        } 
        // $scope.innerHtmlOfEditor();
      }
  
      // Function to track changes and save state (for example, call this when the text changes)
      // $scope.trackChanges = function() {
      //     saveState();
      //     // Other code for tracking changes in the editor content
      // };
  
      $scope.insertOrderedListFont = function(){
        $scope.performAction('insertOrderedList');        
        var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode
        var textAreaId = document.getElementById('tTextEditor');
        var fontElements = textAreaId.getElementsByTagName("font");
        var spanElements = textAreaId.getElementsByTagName("span");
        var bElements = textAreaId.getElementsByTagName("b");
        var iElements = textAreaId.getElementsByTagName("i");
        var uElements = textAreaId.getElementsByTagName("u");
        var strikeElements = textAreaId.getElementsByTagName("strike");

        for(var i = 0; i < fontElements.length; i++){
          var fontParentNode1 = fontElements[i].parentNode.parentNode; //fontElements[i].parentNode.parentNode
          var fontParentNode2 = fontParentNode1.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode
          var fontParentNode3 = fontParentNode2.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(fontParentNode1.nodeName == "OL"){
            fontParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode1.style.listStyle = "decimal inside";
          }
          else if(fontParentNode1.parentNode.nodeName == "OL"){
            fontParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(fontParentNode2.nodeName == "OL"){
            fontParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode2.style.listStyle = "decimal inside";
          }
          else if(fontParentNode2.parentNode.nodeName == "OL"){
            fontParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(fontParentNode3.nodeName == "OL"){
            fontParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.style.fontSize = listStyle = "decimal inside";
          }
          else if(fontParentNode3.parentNode.nodeName == "OL"){
            fontParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.parentNode.style.listStyle = "decimal inside";
          }
          else if(fontParentNode3.parentNode.parentNode.nodeName == "OL"){
            fontParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.parentNode.parentNode.style.listStyle = "decimal inside";
          }
        }
        for(var i = 0; i < spanElements.length; i++){
          var spanParentNode1 = spanElements[i].parentNode.parentNode; //spanElements[i].parentNode.parentNode
          var spanParentNode2 = spanParentNode1.parentNode.parentNode; //spanElements[i].parentNode.parentNode.parentNode.parentNode
          var spanParentNode3 = spanParentNode2.parentNode.parentNode; //spanElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(spanParentNode1.nodeName == "OL"){
            spanParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode1.style.listStyle = "decimal inside";
          }
          else if(spanParentNode1.parentNode.nodeName == "OL"){
            spanParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(spanParentNode2.nodeName == "OL"){
            spanParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode2.style.listStyle = "decimal inside";
          }
          else if(spanParentNode2.parentNode.nodeName == "OL"){
            spanParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(spanParentNode3.nodeName == "OL"){
            spanParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode3.style.listStyle = "decimal inside";
          }
          else if(spanParentNode3.parentNode.nodeName == "OL"){
            spanParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode3.parentNode.style.listStyle = "decimal inside";
          }
        }
        for(var i = 0; i < bElements.length; i++){
          var bParentNode1 = bElements[i].parentNode.parentNode; //bElements[i].parentNode.parentNode
          var bParentNode2 = bParentNode1.parentNode.parentNode; //bElements[i].parentNode.parentNode.parentNode.parentNode
          var bParentNode3 = bParentNode2.parentNode.parentNode; //bElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(bParentNode1.nodeName == "OL"){
            bParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode1.style.listStyle = "decimal inside";
          }
          else if(bParentNode1.parentNode.nodeName == "OL"){
            bParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(bParentNode2.nodeName == "OL"){
            bParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode2.style.listStyle = "decimal inside";
          }
          else if(bParentNode2.parentNode.nodeName == "OL"){
            bParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(bParentNode3.nodeName == "OL"){
            bParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.style.listStyle = "decimal inside";
          }
          else if(bParentNode3.parentNode.nodeName == "OL"){
            bParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.parentNode.style.listStyle = "decimal inside";
          }
          else if(bParentNode3.parentNode.parentNode.nodeName == "OL"){
            bParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.parentNode.parentNode.style.listStyle = "decimal inside";
          }
        }
        for(var i = 0; i < iElements.length; i++){
          var iParentNode1 = iElements[i].parentNode.parentNode; //iElements[i].parentNode.parentNode
          var iParentNode2 = iParentNode1.parentNode.parentNode; //iElements[i].parentNode.parentNode.parentNode.parentNode
          var iParentNode3 = iParentNode2.parentNode.parentNode; //iElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(iParentNode1.nodeName == "OL"){
            iParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode1.style.listStyle = "decimal inside";
          }
          else if(iParentNode1.parentNode.nodeName == "OL"){
            iParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(iParentNode2.nodeName == "OL"){
            iParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode2.style.listStyle = "decimal inside";
          }
          else if(iParentNode2.parentNode.nodeName == "OL"){
            iParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(iParentNode3.nodeName == "OL"){
            iParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.style.listStyle = "decimal inside";
          }
          else if(iParentNode3.parentNode.nodeName == "OL"){
            iParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.parentNode.style.listStyle = "decimal inside";
          }
          else if(iParentNode3.parentNode.parentNode.nodeName == "OL"){
            iParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.parentNode.parentNode.style.listStyle = "decimal inside";
          }
        }
        for(var i = 0; i < uElements.length; i++){
          var uParentNode1 = uElements[i].parentNode.parentNode; //uElements[i].parentNode.parentNode
          var uParentNode2 = uParentNode1.parentNode.parentNode; //uElements[i].parentNode.parentNode.parentNode.parentNode
          var uParentNode3 = uParentNode2.parentNode.parentNode; //uElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(uParentNode1.nodeName == "OL"){
            uParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode1.style.listStyle = "decimal inside";
          }
          else if(uParentNode1.parentNode.nodeName == "OL"){
            uParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(uParentNode2.nodeName == "OL"){
            uParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode2.style.listStyle = "decimal inside";
          }
          else if(uParentNode2.parentNode.nodeName == "OL"){
            uParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(uParentNode3.nodeName == "OL"){
            uParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.style.listStyle = "decimal inside";
          }
          else if(uParentNode3.parentNode.nodeName == "OL"){
            uParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.parentNode.style.listStyle = "decimal inside";
          }
          else if(uParentNode3.parentNode.parentNode.nodeName == "OL"){
            uParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.parentNode.parentNode.style.listStyle = "decimal inside";
          }
        }
        for(var i = 0; i < strikeElements.length; i++){
          var strikeParentNode1 = strikeElements[i].parentNode.parentNode; //strikeElements[i].parentNode.parentNode
          var strikeParentNode2 = strikeParentNode1.parentNode.parentNode; //strikeElements[i].parentNode.parentNode.parentNode.parentNode
          var strikeParentNode3 = strikeParentNode2.parentNode.parentNode; //strikeElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(strikeParentNode1.nodeName == "OL"){
            strikeParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode1.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode1.parentNode.nodeName == "OL"){
            strikeParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode1.parentNode.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode2.nodeName == "OL"){
            strikeParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode2.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode2.parentNode.nodeName == "OL"){
            strikeParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode2.parentNode.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode3.nodeName == "OL"){
            strikeParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode3.parentNode.nodeName == "OL"){
            strikeParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.parentNode.style.listStyle = "decimal inside";
          }
          else if(strikeParentNode3.parentNode.parentNode.nodeName == "OL"){
            strikeParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.parentNode.parentNode.style.listStyle = "decimal inside";
          }
        }
        // $scope.innerHtnlOfEditor();
        $scope.insertSize();
      }
  
      $scope.insertUnorderedListFont = function(){
        $scope.performAction('insertUnorderedList');
  
        var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode
        var textAreaId = document.getElementById('tTextEditor');
        var fontElements = textAreaId.getElementsByTagName("font");
        var spanElements = textAreaId.getElementsByTagName("span");
        var bElements = textAreaId.getElementsByTagName("b");
        var iElements = textAreaId.getElementsByTagName("i");
        var uElements = textAreaId.getElementsByTagName("u");
        var strikeElements = textAreaId.getElementsByTagName("strike");
        
        for(var i = 0; i < fontElements.length; i++){
          var fontParentNode1 = fontElements[i].parentNode.parentNode; //fontElements[i].parentNode.parentNode
          var fontParentNode2 = fontParentNode1.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode
          var fontParentNode3 = fontParentNode2.parentNode.parentNode; //fontElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(fontParentNode1.nodeName == "UL"){
            fontParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode1.style.listStyle = " inside";
          }
          else if(fontParentNode1.parentNode.nodeName == "UL"){
            fontParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(fontParentNode2.nodeName == "UL"){
            fontParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode2.style.listStyle = " inside";
          }
          else if(fontParentNode2.parentNode.nodeName == "UL"){
            fontParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode2.parentNode.style.listStyle = " inside";
          }
          else if(fontParentNode3.nodeName == "UL"){
            fontParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.style.listStyle = " inside";
          }
          else if(fontParentNode3.parentNode.nodeName == "UL"){
            fontParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.parentNode.style.listStyle = " inside";
          }
          else if(fontParentNode3.parentNode.parentNode.nodeName == "UL"){
            fontParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            fontParentNode3.parentNode.parentNode.style.listStyle = " inside";
          }
        }
        for(var i = 0; i < spanElements.length; i++){
          var spanParentNode1 = spanElements[i].parentNode.parentNode; //spanElements[i].parentNode.parentNode
          var spanParentNode2 = spanParentNode1.parentNode.parentNode; //spanElements[i].parentNode.parentNode.parentNode.parentNode
          var spanParentNode3 = spanParentNode2.parentNode.parentNode; //spanElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(spanParentNode1.nodeName == "UL"){
            spanParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode1.style.listStyle = " inside";
          }
          else if(spanParentNode1.parentNode.nodeName == "UL"){
            spanParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(spanParentNode2.nodeName == "UL"){
            spanParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode2.style.listStyle = " inside";
          }
          else if(spanParentNode2.parentNode.nodeName == "UL"){
            spanParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode2.parentNode.style.listStyle = " inside";
          }
          else if(spanParentNode3.nodeName == "UL"){
            spanParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode3.style.listStyle = " inside";
          }
          else if(spanParentNode3.parentNode.nodeName == "UL"){
            spanParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            spanParentNode3.parentNode.style.listStyle = " inside";
          }
        }
        for(var i = 0; i < bElements.length; i++){
          var bParentNode1 = bElements[i].parentNode.parentNode; //bElements[i].parentNode.parentNode
          var bParentNode2 = bParentNode1.parentNode.parentNode; //bElements[i].parentNode.parentNode.parentNode.parentNode
          var bParentNode3 = bParentNode2.parentNode.parentNode; //bElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(bParentNode1.nodeName == "UL"){
            bParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode1.style.listStyle = " inside";
          }
          else if(bParentNode1.parentNode.nodeName == "UL"){
            bParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(bParentNode2.nodeName == "UL"){
            bParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode2.style.listStyle = " inside";
          }
          else if(bParentNode2.parentNode.nodeName == "UL"){
            bParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode2.parentNode.style.listStyle = " inside";
          }
          else if(bParentNode3.nodeName == "UL"){
            bParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.style.listStyle = " inside";
          }
          else if(bParentNode3.parentNode.nodeName == "UL"){
            bParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.parentNode.style.listStyle = " inside";
          }
          else if(bParentNode3.parentNode.parentNode.nodeName == "UL"){
            bParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            bParentNode3.parentNode.parentNode.style.listStyle = " inside";
          }
        }
        for(var i = 0; i < iElements.length; i++){
          var iParentNode1 = iElements[i].parentNode.parentNode; //iElements[i].parentNode.parentNode
          var iParentNode2 = iParentNode1.parentNode.parentNode; //iElements[i].parentNode.parentNode.parentNode.parentNode
          var iParentNode3 = iParentNode2.parentNode.parentNode; //iElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(iParentNode1.nodeName == "UL"){
            iParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode1.style.listStyle = " inside";
          }
          else if(iParentNode1.parentNode.nodeName == "UL"){
            iParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(iParentNode2.nodeName == "UL"){
            iParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode2.style.listStyle = " inside";
          }
          else if(iParentNode2.parentNode.nodeName == "UL"){
            iParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode2.parentNode.style.listStyle = " inside";
          }
          else if(iParentNode3.nodeName == "UL"){
            iParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.style.listStyle = " inside";
          }
          else if(iParentNode3.parentNode.nodeName == "UL"){
            iParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.parentNode.style.listStyle = " inside";
          }
          else if(iParentNode3.parentNode.parentNode.nodeName == "UL"){
            iParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            iParentNode3.parentNode.parentNode.style.listStyle = " inside";
          }
        }
        for(var i = 0; i < uElements.length; i++){
          var uParentNode1 = uElements[i].parentNode.parentNode; //uElements[i].parentNode.parentNode
          var uParentNode2 = uParentNode1.parentNode.parentNode; //uElements[i].parentNode.parentNode.parentNode.parentNode
          var uParentNode3 = uParentNode2.parentNode.parentNode; //uElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(uParentNode1.nodeName == "UL"){
            uParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode1.style.listStyle = " inside";
          }
          else if(uParentNode1.parentNode.nodeName == "UL"){
            uParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(uParentNode2.nodeName == "UL"){
            uParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode2.style.listStyle = " inside";
          }
          else if(uParentNode2.parentNode.nodeName == "UL"){
            uParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode2.parentNode.listStyle = " inside";
          }
          else if(uParentNode3.nodeName == "UL"){
            uParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.style.listStyle = " inside";
          }
          else if(uParentNode3.parentNode.nodeName == "UL"){
            uParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.parentNode.style.listStyle = " inside";
          }
          else if(uParentNode3.parentNode.parentNode.nodeName == "UL"){
            uParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            uParentNode3.parentNode.parentNode.style.listStyle = " inside";
          }
        }
        for(var i = 0; i < strikeElements.length; i++){
          var strikeParentNode1 = strikeElements[i].parentNode.parentNode; //strikeElements[i].parentNode.parentNode
          var strikeParentNode2 = strikeParentNode1.parentNode.parentNode; //strikeElements[i].parentNode.parentNode.parentNode.parentNode
          var strikeParentNode3 = strikeParentNode2.parentNode.parentNode; //strikeElements[i].parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
          if(strikeParentNode1.nodeName == "UL"){
            strikeParentNode1.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode1.style.listStyle = " inside";
          }
          else if(strikeParentNode1.parentNode.nodeName == "UL"){
            strikeParentNode1.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode1.parentNode.style.listStyle = " inside";
          }
          else if(strikeParentNode2.nodeName == "UL"){
            strikeParentNode2.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode2.style.listStyle = " inside";
          }
          else if(strikeParentNode2.parentNode.nodeName == "UL"){
            strikeParentNode2.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode2.parentNode.style.listStyle = " inside";
          }
          else if(strikeParentNode3.nodeName == "UL"){
            strikeParentNode3.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.style.listStyle = " inside";
          }
          else if(strikeParentNode3.parentNode.nodeName == "UL"){
            strikeParentNode3.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.parentNode.style.listStyle = " inside";
          }
          else if(strikeParentNode3.parentNode.parentNode.nodeName == "UL"){
            strikeParentNode3.parentNode.parentNode.style.fontSize = window.getComputedStyle(selectedDivs).fontSize;
            strikeParentNode3.parentNode.parentNode.style.listStyle = " inside";
          }
        }
        $scope.insertSize();
      }
  
      $scope.chooseBackColor = function(){
        var selectedDivs = window.getSelection().getRangeAt(0).startContainer.parentNode
        var changeColorEditor = window.getComputedStyle(selectedDivs).color;
        if(changeColorEditor == 'rgb(51, 51, 51)'){
          document.execCommand('foreColor', false, 'rgb(52, 52, 52)');
          document.querySelector("#colorEditor").value = '#343434';
          var backgroundColorEditor = document.getElementById("backgroundColorEditor").value;
          document.execCommand('backColor', false, backgroundColorEditor);
          window.addEventListener('mouseup', function(event){
          $scope.curFrame.text = document.getElementById('tTextEditor').innerHTML;
          })
        }else {
          var backgroundColorEditor = document.getElementById("backgroundColorEditor").value;
          document.execCommand('backColor', false, backgroundColorEditor);
          window.addEventListener('mouseup', function(event){
          $scope.curFrame.text = document.getElementById('tTextEditor').innerHTML;
          })
        }
      }
  
      $scope.changeFont = function(val){
        var myFont = val.value;
        document.execCommand('fontName', false, myFont);        
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true });
          $("#textEditorHidden")[0].focus({ preventScroll: true });
        });
        // $scope.innerHtmlOfEditor();
      }
  
      $scope.checkDiv = function(){ 
        var editorText = document.getElementById("tTextEditor").innerHTML;
        if(editorText === ''){
          document.getElementById("tTextEditor").style.border = '5px solid red';
        } 
      }
  
      $scope.removeBorder = function(){ 
        document.getElementById("tTextEditor").style.border = '1px solid transparent';
      }
  
      $scope.innerHtmlOfEditor = function(text){
        var newTextEditor = document.getElementById('tTextEditor').innerHTML
        $scope.curFrame.text = newTextEditor;
      }
  
      $scope.performAction = function(command){
        document.execCommand(command, false, null);
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true });
          $("#textEditorHidden")[0].focus({ preventScroll: true });
        });
      }
  
      $scope.changeSize = function(val){
        var mysize = val;
        document.execCommand('fontSize', false, mysize);
        // $scope.innerHtmlOfEditor();
      }

      // $scope.hexWithAlpha = function(hex, alpha) {
      //   hex = hex.replace('#', '');
      //   var a = Math.round(alpha * 255).toString(16).padStart(2, '0');
      //   return `#${hex}${a}`;
      // }

      $scope.colorPickerOpen = function($event, caller){
        $event.stopPropagation();
        
        var selectedEl = window.getSelection().getRangeAt(0).startContainer.parentNode;
        var styles = window.getComputedStyle(selectedEl);
        if(caller == "tc"){          
          var hexColorEditor = '#' + styles.color.slice(4,-1).split(',').map(function(x) {return (+x).toString(16).padStart(2,0)}).join('')
          $scope.curText.tc = hexColorEditor;
          $scope.curText.tcType = $scope.matchHaxType($scope.curText.tc);
        }
        if(caller == "bg"){
          if(styles.backgroundColor == 'rgba(0, 0, 0, 0)'){
            if($scope.frameBg.isChecked == true && $scope.curFrame.bg != '' && $rootScope.selectedT == '4'){
              var bgColorEditor1 = ""+ $scope.curFrame.bg.toUpperCase(); +"";
              $scope.curText.bg = bgColorEditor1;
              $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
            }else if($scope.frameBg.isChecked == false && $scope.curFrame.bg == '' && $rootScope.selectedT == '4'){
              $scope.curText.bg = 'transparent';
              $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
            }
          }else {
            var hexBgColorEditor = '#' + styles.backgroundColor.slice(4,-1).split(',').map(function(x){return (+x).toString(16).padStart(2,0)}).join('')
            $scope.curText.bg = hexBgColorEditor;
            $scope.curText.bgType = $scope.matchHaxType($scope.curText.bg);
          }
        }
      }

      $scope.$on('hubColorPicker', function (event, args){
        if(args.element == "tc"){
          $scope.curText.tc = args.color;
          $scope.curText.tcType = args.type;
          document.execCommand('foreColor', false, $scope.curText.tc);
          window.addEventListener('mouseup', function(event){
            $scope.curFrame.text = document.getElementById('tTextEditor').innerHTML;
          })
          setTimeout(function(){
            $("#tTextEditor")[0].focus({ preventScroll: true });
            $("#textEditorHidden")[0].focus({ preventScroll: true });
          });
        }
        if(args.element == "bg"){
          $scope.curText.bg = args.color;
          $scope.curText.bgType = args.type;
          document.execCommand('backColor', false, $scope.curText.bg);
          window.addEventListener('mouseup', function(event){
            $scope.curFrame.text = document.getElementById('tTextEditor').innerHTML;
          })
          setTimeout(function(){
            $("#tTextEditor")[0].focus({ preventScroll: true });
            $("#textEditorHidden")[0].focus({ preventScroll: true });
          });
        }
        // $scope.innerHtmlOfEditor();
      })

      $scope.lastSavedContent = "";

      $scope.saveHistory = function () {
        var editor = document.getElementById("tTextEditor");
        var currentContent = editor.innerHTML;      
        if ($scope.lastSavedContent !== currentContent) {
          $scope.history.back.push($scope.lastSavedContent);
          $scope.lastSavedContent = currentContent;
          $scope.history.forward = []; // Clear redo stack on new changes
        }
      };
      
      setTimeout(function(){
        var editor = document.getElementById("tTextEditor");
        if (editor) {
          $scope.lastSavedContent = editor.innerHTML;      
          editor.addEventListener("input", function () {
            $scope.saveHistory();
          });
        }
      });

      document.getElementById("tTextEditor").addEventListener("keydown", function (e) {
        if (e.ctrlKey && e.key === "z") {
          e.preventDefault();
          $scope.undoFont();
        } else if (e.ctrlKey && (e.key === "y" || (e.shiftKey && e.key === "z"))) {
          e.preventDefault();
          $scope.redoFont();
        }
      });      

      $scope.history = {
        back: [],
        forward: []
      };

      $scope.undoFont = function () {
        if (!$scope.history.back.length) return;
      
        var editor = document.getElementById("tTextEditor");
        $scope.history.forward.push(editor.innerHTML);
        var prevState = $scope.history.back.pop();
        editor.innerHTML = prevState;
        $scope.lastSavedContent = prevState;
        // $scope.innerHtmlOfEditor();        
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true });
          $("#textEditorHidden")[0].focus({ preventScroll: true });
        });
      };
      
      $scope.redoFont = function () {
        if (!$scope.history.forward.length) return;
      
        var editor = document.getElementById("tTextEditor");
        $scope.history.back.push(editor.innerHTML);
        var nextState = $scope.history.forward.pop();
        editor.innerHTML = nextState;
        $scope.lastSavedContent = nextState;
        // $scope.innerHtmlOfEditor();        
        setTimeout(function(){
          $("#tTextEditor")[0].focus({ preventScroll: true });
          $("#textEditorHidden")[0].focus({ preventScroll: true });
        });
      };
      
    }
  })();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AddToGroupController', AddToGroupController);

  /** @ngInject */
  function AddToGroupController($log, $scope, $rootScope, $state, ngDialog, UsersSrv){
    $scope.isGroupAvailable = false;
    $scope.saveProcessing = false;
    $scope.isGroupEmpty = false;
    $scope.hasErr = false;
    $scope.curUserGrp = {};
    $scope.curGroups = {};
    $scope.errType = "";

    if(angular.isArray($scope.curGroupIds)){
      if($scope.curGroupIds.length > 1){
        $scope.curGroupId = 0;
      } else{
        $scope.curGroupId = $scope.curGroupIds[0].id;
      }
    } else{
      $scope.curGroupId = $scope.curGroupIds;
    }

    $rootScope.getPermissionFx = function(){
      UsersSrv.getDefaultPermissions($scope.curGroupId).then(
        function(data){
          $scope.curGroups = {};
          $scope.isGroupAvailable = true;
          $scope.curGroups = data.permission;
          if($scope.user){
            if($scope.curGroups.primaryGroup == null){
              $scope.curGroups.primaryGroup = $scope.curGroups.groups[0];
            }
            $scope.user.permission = $scope.curGroups;
          }
          if($scope.curGroups.availableGroups.length > 0 || $scope.curGroups.groups.length > 0){
            $scope.isGroupEmpty = false;
            $scope.isGroupAvailable = true;
          } else{
            $scope.isGroupEmpty = true;
            $scope.curGroup = {
              label:"",
              type:"newGrp"
            };
            $scope.isGroupAvailable = false;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    if(!$scope.user){
      $rootScope.getPermissionFx();
    }

    $scope.updatePrimaryGroup = function(){
      if($scope.curGroups.primaryGroup == null){
        $scope.curGroups.primaryGroup = $scope.curGroups.groups[0];
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.saveUserGrpFx = function(){
      $scope.errType = "";
      $scope.hasErr = false;
      $scope.saveProcessing = true;
      $scope.curGroup.users = $scope.curGroupIds;
      $scope.curGroup.groups = $scope.curGroups.groups;
      $scope.curGroup.hiddenGroups = $scope.curGroups.hiddenGroups;
      if($scope.curGroup.type == "newGrp" && (!$scope.curGroup.label || $scope.curGroup.label == "")){
        $scope.saveProcessing = false;
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      }
      UsersSrv.updateAddToGroup($scope.curGroup).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.status == "error" && data.code == 13027){
            $scope.errType = "duplicate";
            $scope.hasErr = true;
          } else{
            $scope.closeAllFx();
            ngDialog.close();
            //$state.reload();
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('groupCUController', groupCUController);

  /** @ngInject */
  function groupCUController($log, $scope, $state, $rootScope, $timeout, ngDialog, SchedulesSrv){
    $scope.saveProcessing = false;
    $scope.isPEOpen = false;
    if(!$scope.sGrp.permission){
      if($scope.auth.sGrp.isPrimaryGrp){
        $scope.sGrp.permission.type = "c";
      } else{
        $scope.sGrp.permission.type = "p";
      }
    }

    $scope.groupCUFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.sGrp.label == undefined || $scope.sGrp.label == ""){
        $scope.saveProcessing = false;
        $scope.hasErr = true;
        $scope.errType = "empty";
        $("#sgName").focus();
        return;
      } else{
        $scope.saveProcessing = true;
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveGroupsFx();
          }, 250);
        } else{
          $scope.saveGroupsFx();
        }
      }
    }

    $scope.saveGroupsFx = function(){
      SchedulesSrv.saveGroups($scope.sGrp).then(
        function(data){
          if(data.code == 10041){
            $scope.saveProcessing = false;
            $scope.dataObj = data.schedules;
            ngDialog.open({
              template: '\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <p>{{"s.p_sg.m3" | translate}}</p>\
                    <p>{{"s.p_sg.m4" | translate}}</p>\
                    <div class="table no-th marT20">\
                      <div class="scrollQuad" ng-style="{\'max-height\': \'{{getAvailableHeight(380)}}px\'}">\
                        <div class="row" ng-repeat="schedule in dataObj">\
                          <div class="col-xs-12 word-break">{{schedule.label}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <!--<button type="button" class="btn btn-danger btn-sm" ng-click="confirmFx();" ng-disabled="confirmProcessing"><span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>-->\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain: true,
              width: 620,
              scope: $scope,
              closeByDocument: false,
              className: "ngdialog-theme-default ngdialog-confirm"
            });
          } else if(data.code == 10028){
            $scope.hasErr = true;
            $scope.errType = "groupExist";
            $scope.saveProcessing = false;
          } else{
            ngDialog.close();
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.confirmFx = function(){
      $scope.confirmProcessing = true;
      SchedulesSrv.saveGroupsConfirm($scope.sGrp).then(
        function(data){
          $scope.confirmProcessing = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
          $scope.confirmProcessing = false;
        }
      );
    }
  }
})();
(function(){
    'use strict';
  
    angular
      .module('hub')
      .controller('OtherInventoryController', OtherInventoryController);
  
    /** @ngInject */
    function OtherInventoryController($log, $rootScope, $scope, $state, ngDialog, DevicesSrv, FileModelUploadSrv, InventorySrv){
      $rootScope.selectedMenu = 11;
      $scope.invPopuLoading = true;
      $scope.inventoryType = [];
      $scope.devicesList = [];
      $scope.decStatus = "";
      $scope.encStatus = "";
      $scope.decId = "";
      $scope.encId = "";  
      $scope.hasErr = false;
      $scope.hasErrType = false;
      $scope.errType = "";  
      $scope.errAddType = "";  
      $scope.upRemAttachment = false;
      $scope.curFiles = [];  
      $scope.tmpFiles = {name:"", path:""};
      $scope.curFile = {name:"", path:""};
        
      $scope.subTabFx = function(caller){
          $scope.subTab = caller;
        $scope.invPopuLoading = true;
        if($scope.subTab == 1){
            $scope.invPopuLoading = false;
        }
        else if($scope.subTab == 2){
            $scope.invPopuLoading = false;
        }
        else if($scope.subTab == 3){
            $scope.invPopuLoading = false;
          $scope.historyOpen();
        }
      }

      $scope.getInventoryTypesFx = function(){
        InventorySrv.getInventoryTypes().then(
          function(data){
            $scope.inventoryType = data;
            $scope.invPopuLoading = false;
          },
          function(err){
            $scope.invPopuLoading = false;
            $log.error(err);
          }
        );
      }

      if($scope.editInvn){        
        $scope.subTab = 1;
        if($scope.editInvn.status == 1){
          $scope.tabstatus = 0;
        }
        else if($scope.editInvn.status == 2){
          $scope.tabstatus = 1;
        }
        else if($scope.editInvn.status == 3){
          $scope.tabstatus = 2;
        }
        
        $scope.updateOtherObj = {"invType":"h","status":$scope.tabstatus,"id":$scope.editInvn.id,"offset":0}
        InventorySrv.getInventory($scope.updateOtherObj).then(
          function(data){
            $scope.invObj = data;
            $scope.tim = $scope.invObj.info.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.invObj.info.bucket;
            if($scope.invObj.info.mbucket && $scope.invObj.info.mbucket != ""){
              $scope.detailBucket = $scope.invObj.info.mbucket;
            }
  
            if($scope.invObj.pOn){
              $scope.invObj.pOn = {startDate:moment($scope.invObj.pOn).format("YYYY-MM-DD"), endDate:moment($scope.invObj.pOn).format("YYYY-MM-DD")};
            }
            if($scope.invObj.iOn){
              $scope.invObj.iOn = {startDate:moment($scope.invObj.iOn).format("YYYY-MM-DD"), endDate:moment($scope.invObj.iOn).format("YYYY-MM-DD")};
            } 
            if($scope.invObj.rOn){
              $scope.invObj.rOn = {startDate:moment($scope.invObj.rOn).format("YYYY-MM-DD"), endDate:moment($scope.invObj.rOn).format("YYYY-MM-DD")};
            } 
            if($scope.invObj.wStOn){
              $scope.invObj.wStOn = {startDate:moment($scope.invObj.wStOn).format("YYYY-MM-DD"), endDate:moment($scope.invObj.wStOn).format("YYYY-MM-DD")};         
            }
            if($scope.invObj.status !== null){
              $scope.invObj.status = JSON.stringify($scope.invObj.status);
            }
            if($scope.invObj.a){
              $scope.curFiles = $scope.invObj.a;
            }
            $scope.getInventoryTypesFx();
          },
          function(err){
            $scope.invPopuLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.subTab = 1;
        $scope.invObj = {type:{id:0, label:""}, d:"", mf:"", model:"", serial:"", po:"", l:"", descr:"", status:"0", pOn:"", iOn:"", rOn:"", w:0, ew:0, wt:"d", ewt:"d"};
        $scope.getInventoryTypesFx();
      }  
  
      $rootScope.createFilelUploadFx = function(file){
        $scope.upRemAttachment = true;
        if(!$scope.curFiles.length){
          $scope.curFiles = file;
        } else{
          angular.forEach(file, function(curItem){
            $scope.isPopSFileDup = false;
            angular.forEach($scope.curFiles, function(item){
              if(curItem.name == item.name && curItem.size == item.size){
                $scope.isPopSFileDup = true;
                return false;
              }
            });
            if(!$scope.isPopSFileDup){
              $scope.curFiles.push(curItem);
            }
          });
        }
      }
  
      $scope.inventoryCUFx = function(){
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.invObj.id && $scope.subTab == "2"){
          $scope.saveProcessing = true;
          $scope.tempInvObj = {data:{id:$scope.invObj.id}, file:$scope.curFile.file};
          FileModelUploadSrv.uploadFileAndData("inventory/attachments", $scope.tempInvObj.data, $scope.curFiles).then(
            function(data){
              $scope.saveProcessing = false;
              if(data.code == 20006){
                $rootScope.toastNotificationFx("info", data);
                $scope.curFile = {name:"", file:""};
                $state.go("hub.inventory.others");
              }
            },
            function(err){
              $rootScope.toastNotificationFx("danger", {"code":5000});
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        } else{
          $scope.curInvObj = angular.copy($scope.invObj);
          if($scope.curInvObj.pOn){
            $scope.curInvObj.pOn = moment($scope.curInvObj.pOn.startDate).format("YYYY-MM-DD");
          }
          if($scope.curInvObj.iOn){
            $scope.curInvObj.iOn = moment($scope.curInvObj.iOn.startDate).format("YYYY-MM-DD");
          } 
          if($scope.curInvObj.rOn){
            $scope.curInvObj.rOn = moment($scope.curInvObj.rOn.startDate).format("YYYY-MM-DD");
          }
          if($scope.curInvObj.wStOn){
            $scope.curInvObj.wStOn = moment($scope.curInvObj.wStOn.startDate).format("YYYY-MM-DD");
          }
          if($scope.curInvObj.w == undefined){
            $scope.curInvObj.w = null;
          }
          if($scope.curInvObj.ew == undefined){
            $scope.curInvObj.ew = null;
          }
    
          $scope.curInvObj.status = JSON.parse($scope.curInvObj.status);    
          $scope.tempInvObj = {data:$scope.curInvObj, file:$scope.curFile.file};
          if($scope.curInvObj.serial == ""){
            $scope.hasErr = true;
            $scope.errType = "serial";
          }else if($scope.curInvObj.type.label == ""){
            $scope.hasErr = true;
            $scope.errType = "type";
          }else if($scope.curInvObj.w == null){
            $scope.hasErr = true;
            $scope.errType = "warranty";
          }else if($scope.curInvObj.ew == null){
            $scope.hasErr = true;
            $scope.errType = "extWarranty";
          }else{
            $scope.saveProcessing = true;
            FileModelUploadSrv.uploadFileAndData("inventory", $scope.tempInvObj.data, $scope.curFiles).then(
              function(data){
                $scope.saveProcessing = false;
                if(data.code == 20009){
                  $scope.hasErr = true;
                  $scope.errType = "serialExist";
                }
                if(data.code == 20001 || data.code == 20002){
                  $rootScope.toastNotificationFx("info", data);
                  $scope.curFile = {name:"", file:""};
                  $state.go("hub.inventory.others");
                  ngDialog.close();
                  $scope.loadSelectedTab("refresh")
                }
              },
              function(err){
                $rootScope.toastNotificationFx("danger", {"code":5000});
                $scope.saveProcessing = false;
                $log.error(err);
              }
            );
          }
        }
      }
  
      $scope.addNewType = function(){
        $scope.openPopup = ngDialog.open({
          template:"app/inventory/popup/addType.html",
          width:620,
          scope:$scope,
          closeByDocument:false,
          preCloseCallback:function(){
            $scope.hasErrType = false;
            $scope.errAddType = "";
          }
        });
      }

      $scope.createType = function(obj){
        $scope.addTypeProcessing = true;
        $scope.hasErrType = false;
        $scope.errAddType = "";
        InventorySrv.addTypes({"label":obj}).then(
          function(data){
            if(data.code == 8254){
              $scope.hasErrType = true;
              $scope.errAddType = "typeExists"
              $scope.addTypeProcessing = false;
            } else if(data.code == 1000){
              $scope.hasErrType = true;
              $scope.errAddType = "addType"
              $scope.addTypeProcessing = false;
            }else{
              $scope.addTypeProcessing = false;
              $scope.invObj.type = {"id":data.id,"label":data.label};
              $scope.getInventoryTypesFx();
              ngDialog.close($scope.openPopup.id);
            }
          },
          function(err){
            $log.error(err);
            $scope.addTypeProcessing = false;
          }
        );
      }
      $scope.st = {isOpen:false};
      $scope.selectTypeFx = function(selected, $event){
        $scope.invObj.type = {"id":selected.id,"label":selected.label};
        $scope.st.isOpen = !$scope.st.isOpen;
      }
  
      $scope.typeSearchFocus = function(){
        if($scope.inventoryType.length > 1){
          angular.element(document).find(".searchTbx.input-xs").children()[0].focus();
        }
      }

      $scope.toggleCallbackType= function(open){
        $scope.searchTList = "";
      }

      $scope.status = {isOpen:false};
      $scope.selectStatusFx = function(status){
        $scope.invObj.status = status;
        $scope.status.isOpen = !$scope.status.isOpen;
      }

      $scope.deleteOpen = function(index, id){
        $scope.deleteProcessing = false;
        $scope.deleteObj = {index:index, id:id};
        ngDialog.open({
          template: '\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" focus-me="true" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-class="btn-link" ng-click="closeThisDialog();">{{deleteErr?"cm.btn.1":"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain: true,
          width: 480,
          scope: $scope,
          closeByDocument: false,
          className: 'ngdialog-theme-default ngdialog-confirm'
        });
      }
  
      $scope.deleteFx = function(){
        if($scope.deleteObj.id){
          $scope.deleteProcessing = true;
          InventorySrv.deleteAttachment($scope.decId, $scope.deleteObj.id).then(
            function(data){
              $scope.deleteProcessing = false;
              if(data.code == 20007){
                $scope.curFiles.splice($scope.deleteObj.index, 1);
                ngDialog.close();
              }
            },
            function(err){
              $log.error(err);
              $scope.deleteProcessing = false;
            }
          );
        } else{
          ngDialog.close();
          $scope.curFiles.splice($scope.deleteObj.index, 1);
        }
      }
  
      $scope.historyOpen = function(){
        $scope.historyLoading = true;
        $scope.history = {info:$scope.invObj, list:[]};
        InventorySrv.history($scope.history.info.id).then(
          function(data){
            $scope.historyLoading = false;
            $scope.history.list = data;
          },
          function(err){
            $scope.historyLoading = false;
            $log.error(err);
          }
        );
      }
    }
  })();
angular.module('hub').service('FeatureRequestSrv', ['$http', '$q', '$rootScope', function ($http, $q, $rootScope){
  var httpReq;
  this.getRequested = function(){
    httpReq = $http.get($rootScope.apiHost + "featureRequest/requests");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAccepted = function(){
    httpReq = $http.get($rootScope.apiHost + "featureRequest/accepted");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getImplemented = function(){
    httpReq = $http.get($rootScope.apiHost + "featureRequest/implemented");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "featureRequest/requests/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveRequest = function(obj){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/requests", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveReport = function(obj){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/flag", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveComments = function(obj){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/requests/comments", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveVotes = function(id){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/requests/votes", {id:id});
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.putStatus = function(obj){
    httpReq = $http.put($rootScope.apiHost + "featureRequest/status", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Delete*/
  this.deleteRequest = function(id){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/requests/delete", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteComment = function(id){
    httpReq = $http.post($rootScope.apiHost + "featureRequest/requests/comments/delete", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function (response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    } else{
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function (response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);

angular
  .module('hub').directive('ngFeatuerList', function(){
    return {
      restrict: 'E',
      templateUrl: 'app/support/featureRequest/dir/featuerList.html'
    }
  });
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FeatureRequestController', FeatureRequestController);

  /** @ngInject */
  function FeatureRequestController($log, $rootScope, $scope, $state, $filter, ngDialog, FeatureRequestSrv){
    $rootScope.selectedMenu = 21;
    $rootScope.curTabFr=true;

    $scope.request = {title:"", description:""};
    $scope.selectedTab = $state.current.name;
    $scope.deleteProcessing = false;
    $scope.featureRLoading = false;
    $scope.saveProcessing = false;
    $scope.hasPopupErr = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
    }

    $scope.loadSelectedTab = function(){
      $scope.featureRLoading = true;
      $scope.hasPopupErr = false;
      $scope.hasErr = false;
      $rootScope.selectedItems = [];
      $scope.featureR = [];
      if($scope.selectedTab === "hub.support.fr.rf"){
        FeatureRequestSrv.getRequested().then(
          function(data){
            $scope.featureR = data;
            $scope.featureRLoading = false;
          }, function (err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.support.fr.af"){
        FeatureRequestSrv.getAccepted().then(
          function(data){
            $scope.featureR = data;
            $scope.featureRLoading = false;
          }, function (err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.support.fr.im"){
        FeatureRequestSrv.getImplemented().then(
          function(data){
            $scope.featureR = data;
            $scope.featureRLoading = false;
          }, function (err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.featureDetails"){
        if($scope.decId != ""){
          FeatureRequestSrv.getDetails($scope.decId).then(
            function(data){
              $scope.featureR = data;
              if($scope.featureR.info.isVoted){
                $scope.votedMsg = $filter("translate")('sc.fr.p_comment.msg.1');
              } else{
                $scope.votedMsg = $filter("translate")('sc.fr.p_comment.msg.2');
              }
              $scope.featureRLoading = false;
            }, function (err){
              $log.error(err);
            }
          );
        }
      }
    }
    $scope.loadSelectedTab();

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function (event, toState){
      $rootScope.curTabFr = true;
      $scope.searchText = "";
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
    });

    $scope.curReport={};
    $scope.reportRequestFx = function(id, caller){
      $scope.reportProcessing = true;
      $scope.curReport={id:$scope.encryptFx(id), type:caller};
      FeatureRequestSrv.saveReport($scope.curReport).then(
        function(data){
          if(data.reported){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"sc.fr.msg.3" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          }
          $scope.reportProcessing = false;
        }, function (err){
          $log.error(err);
          $scope.reportProcessing = false;
        }
      );
    }

    $rootScope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/support/popup/info.html',
        width:580,
        scope:$scope,
        data:$scope.readMeObj,
      });
    }

    $rootScope.requestOpen = function(caller, id){
      $scope.request = {title:"", description:""};
      $scope.hasErr = false;
      if(caller == "edit"){
        $scope.request.id = $scope.encryptFx(id);
        angular.forEach($scope.featureR, function(item){
          if(id == item.id){
            $scope.request.title = item.title;
            $scope.request.description = item.description;
          }
        });
      }
      ngDialog.open({
        template:"app/support/featureRequest/popup/request.html",
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {tabName:tabName};
      ngDialog.open({
        template:'app/support/featureRequest/popup/info.html',
        width:580,
        scope:$scope,
        data:$scope.readMeObj,
      });
    }

    $scope.saveRequestFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.request.title || $scope.request.title == ""){
        $scope.saveProcessing = false;
        $scope.errType = "title";
        $scope.hasErr = true;
        $("#title").focus();
      } else if(!$scope.request.description || $scope.request.description == ""){
        $scope.saveProcessing = false;
        $scope.errType = "description";
        $scope.hasErr = true;
        $("#description").focus();
      } else{
        FeatureRequestSrv.saveRequest($scope.request).then(
          function(data){
            $rootScope.toastNotificationFx("info", data);
            $scope.request = {title:"", description:""};
            $scope.saveProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function (err){
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.request = {title:"", description:""};
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.deleteOpen = function(id, caller){
      $scope.deleteObj = {};
      $scope.deleteObj.id = $scope.encryptFx(id);
      $scope.deleteObj.caller = caller;

      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{deleteObj.caller == "request"?"sc.fr.msg.2":"sc.fr.p_comment.msg.3" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-disabled="deleteProcessing" ng-click="deleteFx();"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.deleteFx = function(){
      $scope.deleteProcessing = true;
      if($scope.deleteObj.caller == "request"){
        FeatureRequestSrv.deleteRequest({id:$scope.deleteObj.id}).then(
          function(data){
            $rootScope.toastNotificationFx("info", data);
            $scope.deleteProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          }, function (err){
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.deleteProcessing = false;
            $log.error(err);
          }
        );
      } else{
        FeatureRequestSrv.deleteComment({id:$scope.deleteObj.id}).then(
          function(data){
            $rootScope.toastNotificationFx("info", data);
            $scope.deleteProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          }, function (err){
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.deleteProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.commentsOpen = function(id, comment){
      $scope.hasPopupErr = false;
      $scope.hasErr = false;
      $scope.commentObj = {};
      $scope.commentObj.cId = $scope.encryptFx(id);
      $scope.commentObj.comment = comment;
      ngDialog.open({
        template:"app/support/featureRequest/popup/comments.html",
        scope:$scope,
        closeByDocument:false,
        width:500
      });
    }

    $scope.saveCommentsFx = function(caller){
      $scope.curComments = {};
      $scope.hasPopupErr = false;
      $scope.hasErr = false;
      if(caller == "popup"){
        $scope.curComments = $scope.commentObj;
        $scope.popupProcessing = true;
      } else{
        $scope.curComments.comment = $scope.comment;
        $scope.saveProcessing = true;
      }
      if(!$scope.curComments.comment || $scope.curComments.comment == ""){
        if(caller == "popup"){
          $scope.popupProcessing = false;
          $scope.hasPopupErr = true;
        } else{
          $scope.saveProcessing = false;
          $scope.hasErr = true;
          $("#addNewComment").focus();
        }
      } else{
        $scope.hasPopupErr = false;
        $scope.hasErr = false;
        $scope.errType = "";
        $scope.curComments.id = $scope.encryptFx($scope.decId);
        FeatureRequestSrv.saveComments($scope.curComments).then(
          function(data){
            $scope.popupProcessing = false;
            $scope.saveProcessing = false;
            $scope.comment = "";
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function (err){
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.saveVotesFx = function(){
      $scope.votesProcessing = true;
      FeatureRequestSrv.saveVotes($scope.encryptFx($scope.decId)).then(
        function(data){
          $scope.loadSelectedTab();
          $scope.votesProcessing = false;
        }, function (err){
          $log.error(err);
          $scope.votesProcessing = false;
        }
      );
    }

    $scope.confirmOpen = function(id, caller, status){
      $scope.confirmObj = {id:id, caller:caller, status:status};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="confirmObj.caller==\'a\'">{{"sc.fr.p_comment.msg.6" | translate}}</span>\
              <span ng-if="confirmObj.caller==\'i\'">{{"sc.fr.p_comment.msg.7" | translate}}</span>\
              <span ng-if="confirmObj.caller==\'ro\'">{{"sc.fr.p_comment.msg.8" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-disabled="confirmProcessing" ng-click="confirmFx();"><span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
      });
    }
    $scope.confirmFx = function(){
      $scope.confirmProcessing = true;
      FeatureRequestSrv.putStatus($scope.confirmObj).then(
        function(data){
          $scope.loadSelectedTab();
          ngDialog.close();
          $scope.confirmProcessing = false;
        }, function (err){
          $log.error(err);
          $scope.confirmProcessing = false;
        }
      );
    }
  }
})();

angular.module('hub').service('SurveyDeskCommonSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.authenticate = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/surveyLogin", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSurvey = function(obj){
    httpReq = $http.get($rootScope.apiHost + "auth/surveyDesktop/"+ obj.id +"/"+ obj.mac);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSurvey = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/survey", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SurveyDeskCommonController', SurveyDeskCommonController);

  /** @ngInject */
  function SurveyDeskCommonController($log, $rootScope, $scope, $state, $cookies, SurveyDeskCommonSrv){
    if($state.params.id){
      $scope.credentials = {id:$state.params.id, mac:$state.params.mac};
    }

    $scope.loadSelectedTab = function(){
      $scope.surveyLoading = true;
      $scope.resultLoading = true;
      $scope.hasMsg = false;
      $scope.hasType = "";
      if($rootScope.curState == "sd.survey" && $scope.credentials){

        SurveyDeskCommonSrv.getSurvey($scope.credentials).then(
          function(data){
            $scope.surveyLoading = false;
            if(data && data.code){
              $scope.hasMsg = true;
              if(data.code == 6057){
                $scope.hasType = "already";
              } else if(data.code == 6046){
                $scope.hasType = "notActive";
              } else if(data.code == 6044){
                $scope.hasType = "notFound";
              } else if(data.code == 6045){
                $scope.hasType = "finished";
              }
            } else{
              $scope.survey = data;
              $scope.surveyCopy = angular.copy($scope.survey);
            }
          },
          function(err){
            $scope.surveyLoading = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.resetFx = function(){
      $scope.survey = angular.copy($scope.surveyCopy);
    }
    $scope.surveyFx = function(){
      $scope.surveyProcessing = true;
      $scope.hasMsg = false;
      $scope.hasType = "";
      //remove -1 from isSelected key
      if($scope.survey.questionList.length > 0){
        $scope.survey.questionList.forEach(function(item){
          if(item.isSelected < 0){
            item.isSelected = "";
          }
        });
      }
      SurveyDeskCommonSrv.saveSurvey($scope.survey).then(
        function(data){
          $scope.surveyProcessing = false;
          if(data.code == 6045){
            $scope.hasMsg = true;
            $scope.hasType = "oopsFinished";
          } else{
            $state.go("sd.thanks", $scope.credentials);
          }
        },
        function(err){
          $scope.surveyProcessing = false;
          $scope.errType = "api";
          $scope.hasErr = true;
        }
      );
    }

    $scope.showResult = function(){
      $state.go("sd.result", $scope.credentials);
      $scope.loadSelectedTab();
    }
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.loadSelectedTab();
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SurveyDeskLoginController', SurveyDeskLoginController);

  /** @ngInject */
  function SurveyDeskLoginController($log, $rootScope, $scope, $state, $cookies, SurveyDeskCommonSrv){
    $scope.authProcessing = false;
    $scope.credentials = {};
    if($state.params.id){
      $scope.credentials = {id:$state.params.id, mac:$state.params.mac};
    }
    $scope.loginFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.credentials.id || $scope.credentials.mac == ""){
        $scope.errType = "idMac";
        $scope.hasErr = true;
      } else{
        $scope.authProcessing = true;
        SurveyDeskCommonSrv.authenticate($scope.credentials).then(
          function(data){
            if(data.code && data.code == 6044){
              $scope.errType = "idNotFound";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6042){
              $scope.errType = "already";
              $scope.hasErr = true;
            } else{
              $state.go("sd.survey", {id:$scope.credentials.id, mac:$scope.credentials.mac});
            }
            $scope.authProcessing = false;
          },
          function(err){
            $scope.authProcessing = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    }
    $scope.loginFx();
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('QueueController', QueueController);

  /** @ngInject */
  function QueueController($log, $scope, $rootScope, $state, $cookies, $window, $http, $filter, $translate, ngDialog, Notification, CommonSrv, QueueSrv){
    $scope.detailLoading = false;
    $scope.settingsOpen = false;
    $scope.selectedData = {};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.queue = {};
    $scope.auth = {};

    /*Localization*/
    $translate.use("en_US");

    // $http.defaults.headers.common.Authorization = $scope.auth.token;
    $scope.getQueue = function(){
      $scope.detailLoading = true;
      QueueSrv.getQueue($scope.encId).then(
        function(data){
          $scope.queue = data;
          if($scope.queue.code == 8114){
            $scope.notAcces = true;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    if($state.params.id){
      $scope.encId = $state.params.id;
      $scope.getQueue();
    }

    $scope.incDecResetFx = function(caller){
      if(caller == "i" || caller == "d"){
        $scope.updateIncDecResetFx(caller);
      } else if(caller == "r"){
        $scope.resetProcessing = false;
        $scope.caller = caller;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">Are you sure you want to reset queue number?</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="resetFx(caller);"><span class="fa fa-repeat fa-spin" ng-if="resetProcessing" aria-hidden="true"></span>Yes</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">No</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }

    $scope.resetFx = function(caller){
      $scope.resetProcessing = true;
      ngDialog.close();
      $scope.updateIncDecResetFx(caller);
    }
    $scope.updateIncDecResetFx = function(caller){
      $scope.incDecObj = {eid:$scope.encId, type:caller};
      $scope.updateProcessing = true;
      QueueSrv.updateIncrDecrQueue($scope.incDecObj).then(
        function(data){
          $scope.updateProcessing = false;
          $scope.queue.current = data.current;
          $scope.queue.next = data.next;
          $scope.queue.incDisabled = data.incDisabled;
          $scope.queue.decDisabled = data.decDisabled;
        },
        function(err){
          $log.error(err);
          $scope.updateProcessing = false;
        }
      );
    }
    $scope.settingsOpenFx = function(){
      if($scope.settingsOpen){
        $scope.settingsOpen = false;
      } else{
        $scope.settingsOpen = true;
      }
    }

    $scope.queueFx = function(){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.queue.starting == null){
        $scope.errType = "start";
        $scope.hasErr = true;
      } else if($scope.queue.ending == null){
        $scope.errType = "end";
        $scope.hasErr = true;
      } else if($scope.queue.starting >= $scope.queue.ending){
        $scope.errType = "startEnd";
        $scope.hasErr = true;
      } else{
        $scope.saveProcessing = true;
        $scope.queue.eid = $scope.encId;
        QueueSrv.updateQueue($scope.queue).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.settingsOpen = false;
            $scope.getQueue();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.getLang = angular.fromJson(localStorage.getItem("lang"));
    $rootScope.toastNotificationFx = function(type, data, suffix){
      if(!suffix){
        suffix = "";
      }
      if($scope.connection){
        $scope.isConnection = true;
        if(data.code == 5000){
          Notification.error({message:'Something went wrong. Please try again.', positionX:'center', replaceMessage:true});
        } else if(data.code == 4004){
          Notification.error({message:'The item you are editing does not exists. Following user has removed it from your server:' + " " + suffix, positionX:'center', replaceMessage:true});
        }
      }
    }

    $scope.connection = navigator.onLine;
    $window.addEventListener("offline", function(){
      $rootScope.$apply(function(){
        $scope.connection = false;
        $scope.isConnection = false;
        $scope.connectionFx();
      });
    }, false);
    $window.addEventListener("online", function(){
      $rootScope.$apply(function(){
        $scope.connection = true;
        if(!$scope.isConnection){
          Notification.clearAll();
        }
      });
    }, false);
    $scope.connectionFx = function(){
      Notification.error({message:$filter("translate")('cm.msg.27'), positionX:'center', delay:null, replaceMessage:true});
    }
    if(!$scope.connection){
      $scope.connectionFx();
    }
  }
})();
angular.module('hub').service('QueueSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getQueue = function(id){
    httpReq = $http.get($rootScope.apiHost + "callback/queue/" + id +"/enc");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateQueue = function (obj){
   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/queue", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateIncrDecrQueue = function (obj){
   httpReq = $http.post($rootScope.apiHost + "callback/changeQueue", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SurveyCommonSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.authenticate = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/surveyLogin", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSurvey = function(obj){
    httpReq = $http.get($rootScope.apiHost + "auth/survey/" + obj.encId + "/" + obj.email);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSurvey = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/survey", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getResult = function(obj){
    httpReq = $http.get($rootScope.apiHost + "feed/survey/" + obj.encId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SurveyCommonController', SurveyCommonController);

  /** @ngInject */
  function SurveyCommonController($log, $rootScope, $scope, $state, $cookies, SurveyCommonSrv){
    if($state.params.id){
      $rootScope.auth = angular.fromJson(localStorage.getItem("surveyAuth"));
    }
    $scope.loadSelectedTab = function(){
      $scope.surveyLoading = true;
      $scope.resultLoading = true;
      $scope.hasMsg = false;
      $scope.hasType = "";
      if($rootScope.curState == "s.survey" && $rootScope.auth){
        SurveyCommonSrv.getSurvey($rootScope.auth).then(
          function(data){
            $scope.surveyLoading = false;
            if(data && data.code){
              $scope.hasMsg = true;
              if(data.code == 6042){
                $scope.hasType = "already";
              } else if(data.code == 6046){
                $scope.hasType = "notActive";
              } else if(data.code == 6044){
                $scope.hasType = "notFound";
              } else if(data.code == 6045){
                $scope.hasType = "finished";
              }
            } else{
              $scope.survey = data;
              $scope.surveyCopy = angular.copy($scope.survey);
            }
          },
          function(err){
            $scope.surveyLoading = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      } else if($rootScope.curState == "s.result"){
        SurveyCommonSrv.getResult($rootScope.auth).then(
          function(data){
            $scope.resultLoading = false;
            if(data && data.code){
              $scope.hasMsg = true;
              if(data.code == 6042){
                $scope.hasType = "already";
              } else if(data.code == 6046){
                $scope.hasType = "notActive";
              } else if(data.code == 6044){
                $scope.hasType = "notFound";
              } else if(data.code == 6045){
                $scope.hasType = "finished";
              }
            } else{
              $scope.result = data;
            }
          },
          function(err){
            $scope.resultLoading = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.resetFx = function(){
      $scope.survey = angular.copy($scope.surveyCopy);
    }
    $scope.surveyFx = function(){
      $scope.surveyProcessing = true;
      $scope.hasMsg = false;
      $scope.hasType = "";
      //remove -1 from isSelected key
      if($scope.survey.questionList.length>0){
        $scope.survey.questionList.forEach(function(item){
        if(item.isSelected < 0){
            item.isSelected = "";
        }
        });
      }
      $rootScope.auth.showResult = $scope.survey.info.showResult;
      SurveyCommonSrv.saveSurvey($scope.survey).then(
        function(data){
          $scope.surveyProcessing = false;
          if(data.code == 6045){
            $scope.hasMsg = true;
            $scope.hasType = "oopsFinished";
          } else{
            $state.go("s.thanks", {id:$rootScope.auth.encId});
          }
        },
        function(err){
          $scope.surveyProcessing = false;
          $scope.errType = "api";
          $scope.hasErr = true;
        }
      );
    }

    $scope.showResult = function(){
      $state.go("s.result", {id:$rootScope.auth.encId});
      $scope.loadSelectedTab();
    }

    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.loadSelectedTab();
    });
    if($rootScope.curState != "s.login" && !$rootScope.auth){
      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != ""){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SurveyLoginController', SurveyLoginController);

  /** @ngInject */
  function SurveyLoginController($log, $rootScope, $scope, $state, $cookies, vcRecaptchaService, SurveyCommonSrv){
    $scope.authProcessing = false;
    $rootScope.auth = {};
    localStorage.removeItem("surveyAuth");
    $scope.credentials = {};
    if($state.params.id){
      $scope.credentials.encId = $state.params.id;
    }
    $scope.vcResponse = null;
    $scope.vcWidgetId = null;
    $scope.setResponse = function(response){
      $scope.vcResponse = response;
    };
    $scope.setWidgetId = function(widgetId){
      $scope.vcWidgetId = widgetId;
    };
    $scope.cbExpiration = function(){
      vcRecaptchaService.reload($scope.vcWidgetId);
      $scope.vcResponse = null;
    };

    $scope.loginFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.credentials.email || $scope.credentials.email == ""){
        $scope.errType = "email";
        $scope.hasErr = true;
      } else if($scope.vcResponse == null){
        $scope.errType = "reCaptcha";
        $scope.hasErr = true;
        $scope.cbExpiration();
      } else{
        $scope.credentials.reCaptcha = $scope.vcResponse;
        $scope.authProcessing = true;
        SurveyCommonSrv.authenticate($scope.credentials).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code && data.code == 6039){
              $scope.errType = "reCaptcha";
              $scope.hasErr = true;
              $scope.cbExpiration();
            } else if(data.code && data.code == 6044){
              $scope.errType = "idNotFound";
              $scope.hasErr = true;
              $scope.cbExpiration();
            } else if(data.code && data.code == 6042){
              $scope.errType = "emailAlready";
              $scope.hasErr = true;
              $scope.cbExpiration();
            } else{
              $rootScope.auth = {
                encId:$scope.credentials.encId,
                email:$scope.credentials.email
              };
              localStorage.removeItem('surveyAuth');
              localStorage.setItem('surveyAuth', JSON.stringify($rootScope.auth));
              $state.go("s.survey", {id:$scope.credentials.encId});
            }
          },
          function(err){
            $scope.authProcessing = false;
            $scope.errType = "api";
            $scope.cbExpiration();
            $scope.hasErr = true;
          }
        );
      }
    }
  };
})();
angular.module('hub').service('IoTSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPlacement = function(id){
    httpReq = $http.get($rootScope.apiHost + "auth/iotButton/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePlacement = function (obj){
   httpReq = $http.post($rootScope.apiHost + "auth/iotButton", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateIncrDecrQueue = function (obj){
   httpReq = $http.post($rootScope.apiHost + "callback/changeQueue", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('IoTController', IoTController);

  /** @ngInject */
  function IoTController($log, $scope, $rootScope, $state, $cookies, $window, $http, $filter, $translate, ngDialog, Notification, CommonSrv, IoTSrv, LocalizationSrv){
    $scope.detailLoading = false;
    $scope.settingsOpen = false;
    $scope.selectedData = {};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.queue = {};
    $scope.auth = {};

    /*Localization*/
    $translate.use("en_US");

    // $http.defaults.headers.common.Authorization = $scope.auth.token;
    $scope.getPlacement = function(){
      $scope.detailLoading = true;
      IoTSrv.getPlacement($scope.encId).then(
        function(data){
          $scope.placements = data.list;
          if($scope.queue.code == 8114){
            $scope.notAcces = true;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    if($state.params.id){
      $scope.encId = $state.params.id;
      $scope.getPlacement();
    }

    /*Localization*/
    LocalizationSrv.getLocalization($scope.auth.lang).then(
      function(data){
        localStorage.setItem("authLang", JSON.stringify($scope.auth.lang));
        localStorage.setItem("lang", JSON.stringify(data));
        $scope.getLang = angular.fromJson(localStorage.getItem("lang"));
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.resetFx = function(caller){
      $scope.resetProcessing = true;
      ngDialog.close();
      $scope.updateIncDecResetFx(caller);
    }
    $scope.updatePlacementFx = function(obj){
      $scope.placementObj = {encId:$scope.encId, list:obj};
      $scope.updateProcessing = true;
      $scope.curId = obj.id;
      IoTSrv.updatePlacement($scope.placementObj).then(
        function(data){
          $scope.updateProcessing = false;
        },
        function(err){
          $log.error(err);
          $scope.updateProcessing = false;
        }
      );
    }
    $scope.settingsOpenFx = function(){
      if($scope.settingsOpen){
        $scope.settingsOpen = false;
      } else{
        $scope.settingsOpen = true;
      }
    }

    $rootScope.toastNotificationFx = function(type, data, suffix){
      if(!suffix){
        suffix = "";
      }
      if(data){
        if(data.code == 6059){
          Notification.warning({message:$filter("translate")('cl.widget.iot.m14') + suffix, positionX:'center', replaceMessage:true});
        } else if(data.code == 5000){
          Notification.error({message:'Something went wrong. Please try again.', positionX:'center', replaceMessage:true});
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
      .module('hub')
      .controller('SelectDeviceController', SelectDeviceController);

  /** @ngInject */
  function SelectDeviceController($log, $scope, $rootScope, $cookies, DevicesSrv, $filter){
    $scope.dThumbParam = "&h=34&w=60&q=80&zc=3";
    $scope.filter = "all";

    $scope.briefFx = function(){
      $scope.selectedSearch.text = "";
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "device"){
          $scope.isDuplicate = false;
          angular.forEach($rootScope.reportSelectedItems.devices, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.devices.devices.filter(function(obj){
              return obj.id == item.id;
            })[0];
            if($scope.auth.upreferences.deviceView == 'l'){
              $scope.curItem.tv = $scope.curItem.id;
            }
            $rootScope.reportSelectedItems.devices.push({
              id:item.id,
              tz:$scope.curItem.tz,
              timezone:$scope.curItem.timezone,
              h:$scope.curItem.h,
              l:$scope.curItem.l,
              t:$scope.curItem.t,
              lp:$scope.curItem.lp,
              tv:$scope.curItem.tv,
              factor:$scope.curItem.factor,
              cr:$scope.curItem.cr,
              slide:$scope.curItem.slide,
              sv:$scope.curItem.sv,
              wv:$scope.curItem.wv
            });
            $scope.addStatusKey($rootScope.reportSelectedItems.devices, $scope.auth.upreferences.dot);
          }
        } else if($scope.curState == 'hub.dContainer.dvwName'){
          $rootScope.wallSelectedItems.devices = []
          angular.forEach($rootScope.wallSelectedItems.devices, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate && item.type != "folder"){
            $scope.curItem = $scope.devices.devices.filter(function(obj){
              return obj.id == item.id;
            })[0];
            $rootScope.wallSelectedItems.devices.push({
              id:item.id,
              timezone:$scope.curItem.timezone,
              mac:$scope.curItem.h,
              label:$scope.curItem.l,
              dType:$scope.curItem.t,
              status:$scope.curItem.status,
              thumbV:$scope.curItem.tv,
              localIp:$scope.curItem.localIp


              // id:item.id,
              // tz:$scope.curItem.tz,
              // timezone:$scope.curItem.timezone,
              // h:$scope.curItem.h,
              // l:$scope.curItem.l,
              // t:$scope.curItem.t,
              // lp:$scope.curItem.lp,
              // tv:$scope.curItem.tv,
              // factor:$scope.curItem.factor,
              // cr:$scope.curItem.cr,
              // slide:$scope.curItem.slide,
              // sv:$scope.curItem.sv,
              // dType:$scope.curItem.dType,
              // status:$scope.curItem.status,
              // localIp:$scope.curItem.localIp
            });
          }
        }
      });

      $rootScope.copySelDevice = angular.copy($rootScope.reportSelectedItems.devices);
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on('advSearchfilteredData', function(event, args){
      $(".ui-selectable li").removeClass('ui-selected');
      $scope.advSearchInfo = args.info;
      $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
      $scope.addTypeKey($scope.devices);
      if(args.code == 8118 && !$scope.isAdvSearchActive){
        localStorage.removeItem("curDFId");
        $scope.advSApply = false;
        $scope.advSearchInfo = {};
      }
    });

    $scope.closeFilteredFx = function(id){
      $scope.closeFiltered(id, $rootScope.reportSelectedItems.devices);
    }

    $scope.closeFiltered = function(id, selectedObj, selectedDevices, selectedGroups){
      angular.forEach(selectedObj, function(item){
        if(id == item.id){
          if(selectedDevices && selectedObj[selectedObj.indexOf(item)].type == "device"){
          $scope.curItem = selectedDevices.filter(function( obj ){ return obj.id == item.id;})[0];
          selectedDevices.splice(selectedDevices.indexOf($scope.curItem), 1);
          } else if(selectedGroups && selectedObj[selectedObj.indexOf(item)].type == "group"){
            $scope.curItem = selectedGroups.filter(function( obj ){ return obj.id == item.id;})[0];
            selectedGroups.splice(selectedGroups.indexOf($scope.curItem), 1);
          }
          selectedObj.splice(selectedObj.indexOf(item), 1);
        }
      });
      $rootScope.reportSelectedItems.devices = angular.copy(selectedObj);
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        }
      });
      $rootScope.selectedItems = [];
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SelectContentController', SelectContentController);

  /** @ngInject */
  function SelectContentController($log, $scope, $rootScope, $filter, $state, ContentLibrarySrv){
    $scope.dThumbParam = "&h=60&w=90&q=80&zc=3";
    $scope.thumbParam = "&h=60&w=90&q=80&zc=3";
    $scope.odSp = {auth:false, breadCrumbs:[]};
    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.contentLibraryLoading = true;
    $scope.contentLibrary = {};
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.search.pText = "";
    $scope.searchText=''

    ContentLibrarySrv.getAll(0, "r").then(
      function(data){
        $scope.contentLibrary = data;
        $scope.updateList();
      },
      function(err){
        $log.error(err);
      }
    );
    $scope.folderContentFx = function(fId){
      $scope.odSp = {auth:false, breadCrumbs:[]};
      $scope.searchText=''
      $scope.splType = "";
      $scope.contentLibraryLoading = true;
      if($scope.selectedItems.length){
        $scope.splType = $scope.selectedItems[0].type;
      }
      ContentLibrarySrv.getAll(fId, "r", $scope.splType).then(
        function(data){
          if(data.code == 8197){
            $scope.odSp.auth = true;
            if(data.fType=="od"){
              $scope.odSp.curType = "OneDrive";
            } else if(data.fType=="sp"){
              $scope.odSp.curType = "SharePoint";
            } else if(data.fType=="sf"){
              $scope.odSp.curType = "SharedFolder";
            } else if(data.fType=="gd"){
              $scope.odSp.curType = "Googledrive";
            } else{
              $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
            }
            $scope.odSp.breadCrumbs = data.info.breadCrumbs;
          }
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.searchChangeFx("empty");
          $scope.contentLibrary = data;
          $scope.updateList();
          if($scope.auth.upreferences.isSplitV){
            $scope.contentObj.quadHeight = $scope.getAvailableHeight(316);
            $scope.contentObj.selectedHeight = $scope.getAvailableHeight(316);
          } else {
            $scope.contentObj.quadHeight = Math.round($scope.getAvailableHeight(425) * 0.6);
            $scope.contentObj.selectedHeight = Math.round($scope.getAvailableHeight(425) * 0.4);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getTooltip = function(isApproved, expiring){
      if(!isApproved && !expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.16');
      } else if(!isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.17');
      } else if(isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.18');
      } else{
        $scope.curTooltip="";
      }
      return $scope.curTooltip;
    }

    $scope.updateList = function(){
      $scope.searchChangeFx("empty");
      $scope.contentLibraryLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText='';
      if($scope.contentLibrary.info){
        $scope.bucket = $scope.contentLibrary.info.bucket;
        $scope.tim = $scope.contentLibrary.info.timthumb;
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
          $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        }
        $scope.contentInfo = {tim:$scope.tim, cBucket:$scope.cBucket, cDetailBucket:$scope.cDetailBucket};
        $rootScope.$broadcast("contentInfo", $scope.contentInfo);
      }

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.content){
        if($scope.contentObj.curTab=="hub.reports.hds.pp"){
          $scope.filteredContent = [];
          angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
            if(item.type == "Image" || item.type == "Video" || (item.splType && item.splType == "Image" || item.splType == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector")){
              $scope.filteredContent.push(item);
            }
          });
          $scope.contentList = $scope.filteredContent;
        } else{
          $scope.contentList = $scope.contentLibrary.contentLibrary.content;
        }
      }
    }

    $scope.folderBriefFx = function(){ /* Do nothing */ }

    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.isDuplicate = false;
        angular.forEach($rootScope.reportSelectedItems.content, function(listItem){
          if(listItem.id == item.id){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate && item.type != "folder" && item.type != "shortcut" && item.type != "sharepoint"){
          $scope.curItem = $scope.contentList.filter(function(obj){
            return obj.id == item.id;
          })[0];
          $rootScope.reportSelectedItems.content.push({
            id:item.id,
            d:$scope.curItem.d,
            ss:$scope.curItem.ss,
            url:$scope.curItem.url,
            cBy:$scope.curItem.cBy,
            type:$scope.curItem.type,
            extn:$scope.curItem.extn,
            btnExtn:$scope.curItem.btnExtn,
            pSize:$scope.curItem.pSize,
            label:$scope.curItem.label,
            thumb:$scope.curItem.thumb,
            ssImg:$scope.curItem.ssImg,
            createdOn:$scope.curItem.createdOn,
            path:$scope.contentLibrary.info.path,
            isCompleted:$scope.curItem.isCompleted,
          });
        }
      });
    }

    $scope.closeFilteredFx = function(id){
      $scope.closeFiltered(id, $rootScope.reportSelectedItems.content);
    }

    $scope.closeFiltered = function(id, selectedObj, selectedDevices, selectedGroups){
      angular.forEach(selectedObj, function(item){
        if(id == item.id){
          if(selectedDevices && selectedObj[selectedObj.indexOf(item)].type == "device"){
            $scope.curItem = selectedDevices.filter(function(obj){
              return obj.id == item.id;
            })[0];
            selectedDevices.splice(selectedDevices.indexOf($scope.curItem), 1);
          } else if(selectedGroups && selectedObj[selectedObj.indexOf(item)].type == "group"){
            $scope.curItem = selectedGroups.filter(function(obj){
              return obj.id == item.id;
            })[0];
            selectedGroups.splice(selectedGroups.indexOf($scope.curItem), 1);
          }
          selectedObj.splice(selectedObj.indexOf(item), 1);
        }
      });
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        }
      });
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.searchChangeFx("empty");
      $scope.advancedShow = true;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.advSearchInfo = args.info;
      if($scope.auth.upreferences.isSplitV){
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(392);
          $scope.contentObj.selectedHeight= $scope.getAvailableHeight(392);
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(316);
          $scope.contentObj.selectedHeight = $scope.getAvailableHeight(316);
        }
      } else {
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.contentObj.quadHeight = Math.round($scope.getAvailableHeight(502) * 0.6);
          $scope.contentObj.selectedHeight = Math.round($scope.getAvailableHeight(502) * 0.4);
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.contentObj.quadHeight = Math.round($scope.getAvailableHeight(425) * 0.6);
          $scope.contentObj.selectedHeight = Math.round($scope.getAvailableHeight(425) * 0.4);
        }
      }
      $scope.folderList = args.folder;
      if(args.content){
        $scope.contentList = args.content;
      }

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getAll($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          // $scope.selectContent()
          ContentLibrarySrv.getAll(0, "r").then(
            function(data){
              $scope.contentLibrary = data;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        }
        // else{
        //   ContentOnDemandSrv.getApproved().then(
        //     function(data){
        //       $scope.contentLibrary = data;
        //       $scope.advSearch = false;
        //       $scope.updateList();
        //     },
        //     function(err){
        //       $log.error(err);
        //     }
        //   );
        // }
      }
    });

    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.pText = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.pText;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('OnMapController', OnMapController);

  /** @ngInject */
  function OnMapController($log, $rootScope, $scope, $state, $resource, $http, $filter, NgMap, ngDialog, DashboardSrv){
    $rootScope.selectedMenu = 0;
    $scope.registerProcessing = false;
    $scope.mapCenter = [43.6532, -79.3832];
    $scope.map;

    $scope.addressType = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.onMap.info.type == "c"){
        $scope.mapFocus = [43.6532, -79.3832];
        if($scope.auth.uservices.m == "b"){
          setTimeout(function(){
            $scope.azMapPopupFx();
            $scope.deviceSelectionFx($scope.onMap.info.device);
          }, 100);
        }
      }
    }
    $scope.addressType();
    $scope.mapLoaded = function(map){
      $scope.map = map;
      $scope.$apply();
    }
    var azmap, datasource;
    $scope.azMapPopupFx = function(){
      // var keyArr = atob($scope.auth.uservices.mk).split("|");
      // var subKey = $scope.reverse(keyArr[0]);
      azmap = new atlas.Map('azMapPopup', {
        view:'Auto',
        center:[75.8577, 22.7196],
        zoom:8,
        showFeedbackLink:false,
        enableAccessibilityLocationFallback:false,
        // Add your Azure Maps subscription client ID to the map SDK.
        authOptions:{
          //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE: The primary key should be used as the key.
          authType:'subscriptionKey',
          // subscriptionKey:subKey
          subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
        },
        language: "en"
      });
      azmap.events.add('click', function(e){ addPin(e) });
    }
    function addPin(e){
      $scope.errType = "";
      $scope.hasErr = false;
      if(angular.isUndefined($scope.onMap.info.device)){
        $scope.errType = "device";
        $scope.hasErr = true;
        $scope.$apply();
      } else{
        azmap.markers.clear();
        if(e.type == "click"){
          var sColor = $filter('isDeviceOnline')($scope.onMap.info.device.lp, {minDeduct: $scope.auth.upreferences.dot}) == "online" ? "#4cae4c" :"#808080";
          var position = [e.position[0], e.position[1]];
          var pin = new atlas.HtmlMarker({
            position:position,
            htmlContent:atlas.getImageTemplate('marker'),
            color:sColor,
            popup:new atlas.Popup({
              pixelOffset:[0, -30]
            })
          });

          azmap.markers.add(pin);
          $scope.onMap.info.device.lat = e.position[1];
          $scope.onMap.info.device.lng = e.position[0];
          $scope.$apply();
        }
      }
    }

    $scope.$on('mapentrySelected', function(event, geoCoder){
      if(!angular.isUndefined(geoCoder)){
        angular.forEach(geoCoder.address_components, function(geo){
          if(geo.types[0]){
            if(geo.types[0] == "locality"){
              $scope.onMap.info.device.city = geo.long_name;
            } else if(geo.types[0] == "administrative_area_level_1"){
              $scope.onMap.info.device.province = geo.long_name;
            } else if(geo.types[0] == "postal_code"){
              $scope.onMap.info.device.zipCode = geo.long_name;
            } else if(geo.types[0] == "country"){
              $scope.onMap.info.device.country = geo.long_name;
            }
          }
        });
        $scope.onMap.info.device.lat = geoCoder.geometry.location.lat();
        $scope.onMap.info.device.lng = geoCoder.geometry.location.lng();
        $scope.onMap.info.device.address = geoCoder.formatted_address;
      }
    });

    $scope.vm = this;
    $scope.vm.positions = [];
    $scope.vm.addMarker = function(event){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.onMap.info.device){//&& !angular.isUndefined($scope.onMap.info.device)
        var ll = event.latLng;
        $scope.vm.positions[0] = { lat:ll.lat(), lng:ll.lng() };
        $scope.onMap.info.device.lat = $scope.vm.positions[0].lat;
        $scope.onMap.info.device.lng = $scope.vm.positions[0].lng;
      } else{
        $scope.hasErr = true;
        $scope.errType = "device";
      }
    }

    $scope.ds = { isOpen:false };
    $scope.search = { dList:"" };
    $scope.deviceSelectionFx = function(selected){
      $scope.errType = "";
      $scope.hasErr = false;

      // call a search function to get all the data
      if(selected && $scope.search.dList != ""){
        $scope.search.dList = "";
        $scope.ds.isOpen = false;
        $scope.searchChangeDataDyn("", "dom");
      }
      // console.warn("select", selected);
      if(selected && selected.reg){
        DashboardSrv.getDeviceAddress(selected.id).then(
          function(data){
            $scope.onMap.info.device = data;
            $scope.ds.isOpen = false;

            if($scope.auth.uservices.m == "g"){
              if($scope.onMap.info.device && $scope.onMap.info.device.lat && $scope.onMap.info.device.lng){
                $scope.hasErr = false;
                $scope.errType = "";
                $scope.vm.positions[0] = { lat:$scope.onMap.info.device.lat, lng:$scope.onMap.info.device.lng };
                $scope.mapCenter = [$scope.onMap.info.device.lat, $scope.onMap.info.device.lng];
                $scope.map.setCenter(new google.maps.LatLng($scope.onMap.info.device.lat, $scope.onMap.info.device.lng));
                $scope.map.setZoom(5);
              } else{
                $scope.map.setCenter(new google.maps.LatLng(43.6532, -79.3832));
                $scope.vm.positions = [];
                $scope.map.setZoom(5);
              }
            } else{
              if(!angular.isUndefined($scope.onMap.info.device)){
                var sColor = $filter('isDeviceOnline')($scope.onMap.info.device.lp, {minDeduct: $scope.auth.upreferences.dot}) == "online" ? "#4cae4c" :"#808080";
              }
              azmap.markers.clear();
              $scope.cordinates = [];
              if($scope.onMap.info.device && $scope.onMap.info.device.lat && $scope.onMap.info.device.lng){
                var position = [$scope.onMap.info.device.lng, $scope.onMap.info.device.lat];
                var pin = new atlas.HtmlMarker({
                  position:position,
                  htmlContent:atlas.getImageTemplate('marker'),
                  color:sColor,
                  popup:new atlas.Popup({
                    pixelOffset:[0, -30]
                  })
                });
                azmap.markers.add(pin);
                $scope.cordinates.push({ "type":"Feature", "geometry":{ "type":"Point", "coordinates":[$scope.onMap.info.device.lng, $scope.onMap.info.device.lat] }, "properties":{ "name":$scope.onMap.info.device.name, "status":$scope.onMap.info.device.status } })

                var positions = { "type":"FeatureCollection", "features":$scope.cordinates };
                azmap.setCamera({
                  center:atlas.data.BoundingBox.fromData(positions),
                  zoom:8
                });
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      } else {
        $scope.onMap.info.device = selected;
      }
    }

    $scope.registerOnMapFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.onMap.info.device){
        $scope.errType = "device";
        $scope.hasErr = true;
        $("#selectDevice").focus();
        return false;
      } else if($scope.onMap.info.type == "c"){
        if((angular.isUndefined($scope.onMap.info.device.lat) && $scope.onMap.info.device.lat != 0) || $scope.onMap.info.device.lat == null){
          $scope.errType = "latLng";
          $scope.hasErr = true;
          $("#lat").focus();
          return false;
        }
        if((angular.isUndefined($scope.onMap.info.device.lng) && $scope.onMap.info.device.lng != 0) || $scope.onMap.info.device.lng == null){
          $scope.errType = "latLng";
          $scope.hasErr = true;
          $("#lng").focus();
          return false;
        }
      } else if($scope.onMap.info.type == "a"){
        if(!$scope.onMap.info.device.address || $scope.onMap.info.device.address == ""){
          $scope.errType = "address";
          $scope.hasErr = true;
          $("#address").focus();
          return false;
        } else if(!$scope.onMap.info.device.city || $scope.onMap.info.device.city == ""){
          $scope.errType = "city";
          $scope.hasErr = true;
          $("#city").focus();
          return false;
        } else if(!$scope.onMap.info.device.province || $scope.onMap.info.device.province == ""){
          $scope.errType = "province";
          $scope.hasErr = true;
          $("#province").focus();
          return false;
        } else if(!$scope.onMap.info.device.zipCode || $scope.onMap.info.device.zipCode == ""){
          $scope.errType = "zipCode";
          $scope.hasErr = true;
          $("#zipCode").focus();
          return false;
        } else if(!$scope.onMap.info.device.country || $scope.onMap.info.device.country == ""){
          $scope.errType = "country";
          $scope.hasErr = true;
          $("#country").focus();
          return false;
        } else if(((angular.isUndefined($scope.onMap.info.device.lat) && $scope.onMap.info.device.lat != 0) || $scope.onMap.info.device.lat == null) || ((angular.isUndefined($scope.onMap.info.device.lng) && $scope.onMap.info.device.lng != 0) || $scope.onMap.info.device.lng == null)){
          $scope.errType = "addrNotVlid";
          $scope.hasErr = true;
          $("#address").focus();
          return false;
        }
      }
      $scope.registerProcessing = true;
      DashboardSrv.saveRegisterOnMap($scope.onMap.info).then(
        function(data){
          $scope.registerProcessing = false;
          ngDialog.close();
          $state.reload();
        },
        function(err){
          $log.error(err);
          $scope.registerProcessing = false;
        }
      );
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SelectGroupsController', SelectGroupsController);

  /** @ngInject */
  function SelectGroupsController($log, $scope, $rootScope, ngDialog, UsersSrv){
    $scope.groupListLoading = true;
    $scope.contextMenuOpt = [];
    $scope.filter = "all";
    $scope.users = {};

    UsersSrv.getGroups().then(
      function(data){
        $scope.groupListLoading = false;
        $scope.users = data;
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.isDuplicate = false;
        angular.forEach($scope.ngDialogData.groups, function(listItem){
          if(listItem.id == item.id){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate){
          $scope.curItem = $scope.users.users.filter(function(obj){
            return obj.id == item.id;
          })[0];
          $scope.ngDialogData.groups.push({
            id:item.id,
            label:$scope.curItem.label
          });
        }
      });
    }

    $scope.closeFilteredFx = function(id){
      angular.forEach($scope.ngDialogData.groups, function(item){
        if(id == item.id){
          $scope.curItem = $scope.ngDialogData.groups.filter(function(obj){
            return obj.id == item.id;
          })[0];
          $scope.ngDialogData.groups.splice($scope.ngDialogData.groups.indexOf($scope.curItem), 1);
        }
      });
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        }
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SelectFolderController', SelectFolderController);

  /** @ngInject */
  function SelectFolderController($log, $scope, $state, ngDialog, ContentLibrarySrv){
    $scope.selectProcessing = false;
    $scope.treeLoading = true;
    $scope.folderList = {};

    ContentLibrarySrv.getMoveTree('/0').then(
      function(data){
        $scope.treeLoading = false;
        $scope.folderList = data.tree;
      },
      function(err){
        $log.error(err);
      }
    );
  }
})();
angular.module('hub').service('DevicesTagSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.saveTagCU = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/tags", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DeviceLogSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDeviceLog = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceLog/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DeviceIdSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.updateDeviceId = function(id, mac, reason){
    var obj = {};
    obj.id = id;
    obj.mac = mac;
    obj.reason = reason;
    httpReq = $http.put($rootScope.apiHost + "devices/deviceId", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DeviceControlSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDeviceControl = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDeviceControl = function(obj){
    httpReq = $http.put($rootScope.apiHost + "devices/deviceControl", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWebOS = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/webOs/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateWebOS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/deviceControl/webOs", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setDefaultSetting = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/webOs/default/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWebOSTimezone = function(){
    httpReq = $http.get("app/libraries/json/webOS_timezone.json");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWebOSLang = function(){
    httpReq = $http.get("app/libraries/json/webOS_lang.json");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFWVersion = function(dm, fw){
    if(fw){
      httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/webOs/versions/"+ dm +"/"+ fw);
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/webOs/versions/"+ dm);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DataUsageSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDataUsage = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/dataUsage/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCustomDataUsage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/dataUsage/custom", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDataUsageSetting = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/dataUsageSettings/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDataUsageSetting = function(obj){
    httpReq = $http.put($rootScope.apiHost + "devices/dataUsageSettings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DSearchCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  /*Get Search details*/
  this.getDSDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/searches/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDSearch = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/searches", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AddToDeviceGrpSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDeviceGrp = function(id, isFolder){
    if(isFolder){
      httpReq = $http.get($rootScope.apiHost + "devices/addtoGroup/" + id +"?t=df");
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/addtoGroup/" + id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDeviceGrp = function(ids, obj){
    var grpObj = {};
    grpObj.info = obj;
    grpObj.info.ids = ids;
    httpReq = $http.put($rootScope.apiHost + "devices/addtoGroup", grpObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AddRemoveTagSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAddRemoveTag = function(ids){
    // httpReq = $http.get($rootScope.apiHost + "devices/addRemoveTag?type="+ caller +"&ids="+ ids);
    httpReq = $http.get($rootScope.apiHost + "devices/addRemoveTag?ids="+ ids);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAddRemoveTag = function(obj){
    httpReq = $http.put($rootScope.apiHost + "devices/addRemoveTag", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
    'use strict';

    angular
      .module('hub')
      .controller('MoveDController', MoveDController);

    /** @ngInject */
    function MoveDController($log, $scope, $rootScope, $state, $filter, ngDialog, DevicesSrv){
      $scope.moveProcessing = false;
      $scope.moveLoading = false;
      $rootScope.selectedT = 1;
      $scope.contentCount = 0;
      $scope.folderCount = 0;
      $scope.widgetCount = 0;
      $scope.serverList = [];
      $scope.moveItems = {};

      $scope.folderCount = $filter("filter")($scope.selectedItems, {type:"folder"}).length;

      $scope.allFalse = function(){
        $scope.arError = false;
        $scope.fError = false;
        $scope.cError = false;
        $scope.wError = false;
        $scope.hasErr = false;
      }

      $rootScope.selectedTabFx = function(){
        // console.warn("selectedTabFx move");
        $scope.allFalse();
        if($scope.selectedT == 1){
          if($scope.moveObj.type == "copy"){
            if(!$scope.auth.upermissions.tf && $scope.folderCount > 0){
              $scope.fError = true;
            }
            if(!$scope.auth.upermissions.c && $scope.contentCount > 0){
              $scope.cError = true;
            }
            if(!$scope.auth.upermissions.w && $scope.widgetCount > 0){
              $scope.wError = true;
            }
          } else{
            $scope.allFalse();
          }
        } else{
          $scope.moveObj.server = null;
        }
      };
      $rootScope.selectedTabFx();

      $scope.changeTypeFx = function(){
        if($scope.selectedT == 1){
          $rootScope.selectedTabFx();
        }
      }

      $scope.changeServerFx = function(){
        $scope.allFalse();
        if($scope.moveObj.server != null){
          if(!$scope.moveObj.server.ar){
            $scope.arError = true;
          }
          if(!$scope.moveObj.server.f && $scope.folderCount > 0){
            $scope.fError = true;
          }
          if(!$scope.moveObj.server.c && $scope.contentCount > 0){
            $scope.cError = true;
          }
          if(!$scope.moveObj.server.w && $scope.widgetCount > 0){
            $scope.wError = true;
          }
        }
      }

      $scope.moveFx = function(action){
        $scope.moveOtherProcessing = false;
        $scope.moveProcessing = false;
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.selectedT == 1){
          $scope.moveItems = {type:"folder", target:$("input[name='treeOpt']:checked").val(), selectedItems:$scope.selectedItems};
        }
        if($scope.selectedT == 1 && $scope.moveItems.target == null){
          $scope.hasErr = true;
          $scope.errType = "folder";
        }
        else{
          $scope.moveProcessing = true;
          if(action == "move"){
            $scope.moveOtherFx();
          }
        }
      }

      $scope.moveOtherFx = function(){
        $scope.moveOtherProcessing = true;
        DevicesSrv.move($scope.moveItems).then(
          function(data){
            $scope.devicesLoading = false;
            if(data.code == 12107){
              $scope.curFId = parseInt(localStorage.getItem("curDFId"));
              if($scope.curFId == null || angular.isUndefined($scope.curFId) || isNaN($scope.curFId)){
                $scope.curFId = 0;
              }
              if($scope.curFId !== parseInt($scope.moveItems.target)){
                ngDialog.close();
                $rootScope.closeAllFx();
                $scope.loadSelectedTab();
              } else {
                ngDialog.close();
                $rootScope.closeAllFx();
                $rootScope.selectedTabFx = $rootScope.copySelectedTabFx;
              }
            }
          },
          function(err){
            $scope.moveOtherProcessing = false;
            $scope.moveProcessing = false;
            $log.error(err);
          }
        );
      }
    }
  })();

(function(){
  'use strict';

    angular
      .module('hub')
      .controller('DFolderCUController', DFolderCUController);

    /** @ngInject */
    function DFolderCUController($log, $scope, $rootScope, $state, ngDialog, $timeout, $cookies, $interval, DevicesSrv, IndexedDB){
      $scope.folder = {info:{fid:$scope.ngDialogData.fid}};

      // $scope.auth = $cookies.getObject("auth");
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      $rootScope.selectedSPfId = 0;
      $rootScope.selectedODfId = 0;
      $scope.odDisabled = true;
      $scope.isPEOpen = false;
      $scope.folderList = [];
      $scope.spStep = "auth";
      $scope.decId = "";

      if($scope.ngDialogData && $scope.ngDialogData.id){
        $scope.folder.info = $scope.ngDialogData;
        $scope.decId = $scope.ngDialogData.id;
        DevicesSrv.getFolderDetails($scope.ngDialogData.id).then(
          function(data){
            $scope.folder = data;
            $scope.folder.info.fType = $scope.ngDialogData.fType;
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.folder = {info:{id:0, fid:$scope.ngDialogData.fid, label:"", fType:$scope.ngDialogData.fType}, permission:{type:$scope.auth.upreferences.defaultP}};
      }

      $scope.checkChild = function(){
        if($scope.childWindow.closed){
          $interval.cancel($scope.childWindowInt);
          DevicesSrv.getVerify().then(
            function(data){
              $scope.odProcessing = false;
              $scope.odDisabled = false;
              $scope.hasErr = false;
              $scope.errType = "";
              if(data.code == 8194){
                $scope.errType = "odEmpty";
                $scope.showAuthBtn = true;
                $scope.hasErr = true;
                return;
              }
              if(data.code == 8195){
                $scope.errType = "authFailed";
                $scope.hasErr = true;
                return;
              }
              if(data.code == 8196){
                $scope.errType = "odNotExist";
                $scope.showAuthBtn = true;
                $scope.hasErr = true;
                return;
              } else{
                if(data.isClosed){
                  $scope.odFolder = data;
                  $scope.showAuthBtn = false;
                  $scope.folder.data = data.info;
                  if($scope.odFolder.od.folders[0].id){
                    $scope.selectednodeOD = $scope.odFolder.od.folders[0].id;
                  }
                } else{
                  $scope.errType = "authFailed";
                  $scope.showAuthBtn = true;
                  $scope.hasErr = true;
                }
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }

      $scope.folderCUFx = function(){
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.folder.info.label == undefined || $scope.folder.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
          return;
        } else{
          $scope.saveProcessing = true;
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.folderCU();
            }, 250);
          } else{
            $scope.folderCU();
          }
        }
      }

      $scope.folderCU = function(){
        DevicesSrv.folderCU($scope.folder).then(
          function(data){
            $scope.saveProcessing = false;
            if($scope.ngDialogData.actionFrom == "pin"){
              $rootScope.loadPinnedItems();
            } else{
              $scope.loadSelectedTab();
              if($scope.auth.upreferences.isDFTreeOpen){
                $scope.reloadTree();
              }
            }
            ngDialog.close();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }

    }
  })();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DevicesTagController', DevicesTagController);

  /** @ngInject */
  function DevicesTagController($log, $rootScope, $scope, $state, $timeout, ngDialog, DevicesTagSrv){
    $scope.saveProcessing = false;
    $scope.isPEOpen = false;
    $scope.tag = {label:""};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.tempTag = "";

    if($scope.ngDialogData && $scope.ngDialogData.id){
      $scope.tempTag = angular.copy($scope.ngDialogData.label);
      $scope.tag = $scope.ngDialogData;
    } else{
      $scope.tag.permission = {type:$scope.auth.upreferences.defaultP};
    }
    $scope.tagCUFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      if($scope.tag.label == ""){
        $scope.saveProcessing = false;
        $scope.errType = "form";
        $scope.hasErr = true;
        return;
      } else{
        $scope.saveProcessing = true;
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveTagCUFx();
          }, 250);
        } else{
          $scope.saveTagCUFx();
        }
      }
    }
    $scope.saveTagCUFx = function(){
      DevicesTagSrv.saveTagCU($scope.tag).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 12007 || data.code == 12008){
            ngDialog.close();
            $scope.loadSelectedTab();
          } else{
            $scope.errType = "tag";
            $scope.hasErr = true;
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.$on('$destroy', function() {
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceIdController', DeviceIdController);

  /** @ngInject */
  function DeviceIdController($log, $scope, $state, ngDialog, DeviceIdSrv, IndexedDB){
    $scope.deviceId = $scope.ngDialogData;
    $scope.tempMac = $scope.deviceId.mac;
    $scope.saveProcessing = false;
    $scope.hasErr = false;

    /* Registered useful functions */
    // $scope.addItemsDB = function(){//for multiple items

    //   var curData = {
    //     stores:[
    //       {sName:"dData", value:$scope.curDevice},
    //     ]
    //   }
    //   IndexedDB.addItems(curData).then(function(message){
    //   }).catch(function(error){
    //   // console.error(error);
    //   });
    // };

    // $scope.getItemDB = function(store, key){
    //   IndexedDB.getItem(store, key).then(function(item){
    //     $scope.curDevice = item;
    //     $scope.curDevice.h = $scope.deviceId.mac;
    //     $scope.addItemsDB();
    //   }).catch(function(error){
    //     console.erorr(error);
    //   });
    //   setTimeout(function(){
    //     $scope.loadSelectedTab();
    //   });
    // };


    $scope.deviceIdFx = function(caller){
      if(localStorage.getItem("isDlAdvSearch")){
        localStorage.setItem("isActionOnDevice", true);
      } else{
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      $scope.saveProcessing = false;
      $scope.hasErr = false;
      if($scope.deviceId.mac == ""){
        $scope.hasErr = true;
        $scope.errType = "form";
        $("#mac").focus();
        return;
      } else{
        if($scope.deviceId.mac != $scope.tempMac){
          if(caller === "brief"){
            $scope.saveProcessing = true;
            DeviceIdSrv.updateDeviceId($scope.deviceId.id, $scope.deviceId.mac, $scope.deviceId.reason).then(
              function(data){
                $scope.saveProcessing = false;
                if(data.code == 12034){
                  $scope.hasErr = true;
                  $scope.errType = "idInvalid";
                  $("#mac").focus();
                } else if(data.code == 12020){
                  $scope.hasErr = true;
                  $scope.errType = "idExists";
                  $("#mac").focus();
                } else if(data.status == "success"){
                  ngDialog.close();
                  // $scope.getItemDB("dData", $scope.deviceId.id);
                  $scope.loadSelectedTab();
                }
              },
              function(err){
                $log.error(err);
              }
            );
          } else{
            $scope.saveProcessing = false;
            ngDialog.close();
            $scope.device.info.mac = $scope.deviceId.mac;
            $scope.device.info.reason = $scope.deviceId.reason;
          }
        } else{
          ngDialog.close();
          $scope.loadSelectedTab();
        }
      }
    }


  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceControlController', DeviceControlController);

  /** @ngInject */
  function DeviceControlController($log, $scope, $rootScope, $filter, ngDialog, DeviceControlSrv){
    $scope.numRegEx = /^[0-9]+$/;
    $scope.confirmProcessing = false;
    $rootScope.checkReboot = true;
    $scope.controlLoading = true;
    $scope.deviceConfirm = {};
    $scope.selectedTPop = 1;
    $scope.curPb = {s:null};

    $scope.getDeviceControl = function(caller){
      if($scope.curDeviceControl.dType != "mc"){
        DeviceControlSrv.getDeviceControl($scope.curDeviceControl.id).then(
          function(data){
            if(caller){
              $scope.deviceControl = data;

              if(data.pass){
                $scope.deviceControl.pass = $scope.decryptFx(data.pass);
              }
              
              $scope.transition = data.transition;
              $scope.deviceControl.rebootTime = $filter("momentTime")(data.rebootTime);
              $scope.isReboot = $scope.deviceControl.isReboot;
            } else{
              $scope.deviceControl.download = data.download;
              $scope.deviceControl.lastDownload = data.lastDownload;
              $scope.deviceControl.reboot = data.reboot;
              $scope.deviceControl.lastReboot = data.lastReboot;
              $scope.deviceControl.relaunch = data.relaunch;
              $scope.deviceControl.lastRelaunch = data.lastRelaunch;
              $scope.deviceControl.playback = data.playback;
              $scope.deviceControl.lastPlayback = data.lastPlayback;
              if(data.pass){
                $scope.deviceControl.pass = $scope.decryptFx(data.pass);
              }
              if(data.playback_list){
                $scope.deviceControl.playback_list = data.playback_list;
              }
              $scope.deviceControl.rebootTime = $filter("momentTime")(data.rebootTime);
            }
            $scope.checkRebootFx();
            $scope.tabLoading = false;
            $scope.controlLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.tabLoading = false;
          }
        );
      } else{
        $scope.controlLoading = false;
      }
    }
    $scope.getDeviceControl(1);

    $scope.checkRebootFx = function(){
      setTimeout(function(){
        if($rootScope.checkReboot && $scope.deviceControl && ($scope.deviceControl.reboot == "w" || $scope.deviceControl.relaunch == "w" || $scope.deviceControl.download == "w" || $scope.deviceControl.playback == "w")){
          $scope.getDeviceControl(0);
        } else{
          $rootScope.checkReboot = false;
        }
      }, 15000);
    }
    $scope.deviceConfirmOpen = function(caller){
      $scope.deviceConfirm = {type:caller};
      $scope.confirmProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.deviceConfirm.type == "transition"){
        $scope.deviceConfirm.transition = $scope.deviceControl.transition;
      }
      if($scope.deviceConfirm.type == "am" && $scope.deviceControl.iTime == ""){
        $scope.hasErr = true;
        $scope.errType = "iTime";
        $("#iTime").focus();
        return;
      } else if($scope.deviceConfirm.type == "am" && Number($scope.deviceControl.iTime) < 1){
        $scope.hasErr = true;
        $scope.errType = "iTime";
        $("#iTime").focus();
        return;
      } else if($scope.deviceConfirm.type == "am" && $scope.deviceControl.pass == ""){
        $scope.hasErr = true;
        $scope.errType = "pass";
        $("#pass").focus();
        return;
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="deviceConfirm.type == \'reboot\'">{{"d.p_dc.m1" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'relaunch\'">{{"d.p_dc.m2" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'download\'">{{"d.p_dc.m3" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'transition\'">{{"d.p_dc.m5" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'playback\'">{{"d.p_dc.m6" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'rebootTime\'">{{"d.p_dc.m7" | translate}}</span>\
              <span ng-if="deviceConfirm.type == \'am\'">{{"ms.p_am.m2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deviceConfirmFx();" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
      });
    }
    /*Second ngDialog close*/
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.pbChangeFx = function(){
      var curPb = angular.fromJson($scope.curPb.s);
        $scope.curPb.s = angular.fromJson($scope.curPb.s);
    }

    $scope.deviceConfirmFx = function(caller){
      $scope.confirmProcessing = true;
      $rootScope.checkReboot = true;
      if($scope.deviceConfirm.type == "playback"){
        $scope.curPb.s.selected = true;
        $scope.deviceConfirm = {type:$scope.deviceConfirm.type, id:$scope.curDeviceControl.id, playback:$scope.curPb.s};
      } else if(caller == "position"){
        $scope.deviceConfirm = {type:caller, id:$scope.curDeviceControl.id, top:$scope.deviceControl.positionTop};
      } else if(caller == "blankScreen"){
        $scope.deviceConfirm = {type:caller, id:$scope.curDeviceControl.id, blankScreen:$scope.deviceControl.blankScreen};
      } else if($scope.deviceConfirm.type == "rebootTime"){
        $scope.isReboot = $scope.deviceControl.isReboot;
        var rebootTime = moment($scope.deviceControl.rebootTime).format();
        $scope.deviceConfirm = {type:$scope.deviceConfirm.type, id:$scope.curDeviceControl.id, isReboot:$scope.deviceControl.isReboot, rebootTime:rebootTime.split("T")[1].split("+")[0].split("-")[0]};
      } else if($scope.deviceConfirm.type == "am"){
        $scope.deviceConfirm = {type:$scope.deviceConfirm.type, id:$scope.curDeviceControl.id, iTime:$scope.deviceControl.iTime, pass:$scope.encryptFx($scope.deviceControl.pass)};
      } else{
        $scope.deviceConfirm.id = $scope.curDeviceControl.id;
      }
      DeviceControlSrv.updateDeviceControl($scope.deviceConfirm).then(
        function(data){
          $scope.confirmProcessing = false;
          if(caller != "position" && caller != "blankScreen"){
            ngDialog.close($scope.confirmDialog);
          }
          if($scope.deviceConfirm.type == "reboot"){
            $scope.deviceControl.reboot = data.reboot;
            $scope.deviceControl.lastReboot = data.lastReboot;
            $scope.checkRebootFx();
          } else if($scope.deviceConfirm.type == "relaunch"){
            $scope.deviceControl.relaunch = data.relaunch;
            $scope.deviceControl.lastRelaunch = data.lastRelaunch;
            $scope.checkRebootFx();
          } else if($scope.deviceConfirm.type == "download"){
            $scope.deviceControl.download = data.download;
            $scope.deviceControl.lastDownload = data.lastDownload;
            $scope.checkRebootFx();
          } else if($scope.deviceConfirm.type == "transition"){
            $scope.deviceControl.transition = data.transition;
            $scope.transition = data.transition;
          } else if($scope.deviceConfirm.type == "playback"){
            $scope.deviceControl.lastPlayback = data.lastPlayback;
            $scope.deviceControl.playback = data.playback;
            $scope.checkRebootFx();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /** WebOS */
    $scope.pmModeList = [{label:"Power Off (Default)", value:"powerOff", "tl":$filter("translate")("d.p_dc.wos.l.8")}, {label:"Screen Off", value:"screenOff", "tl":$filter("translate")("d.p_dc.wos.l.9")}, {label:"Screen Off Always", value:"screenOffAlways", "tl":$filter("translate")("d.p_dc.wos.l.10")}, {label:"Screen Off & Backlight On", value:"screenOffBacklight", "tl":$filter("translate")("d.p_dc.wos.l.11")}, {label:"Sustain Aspect Ratio", value:"sustainAspectRatio", "tl":$filter("translate")("d.p_dc.wos.l.12")}];
    $scope.irLockList = [{label:"Off (Normal)", value:"normal", "tl":$filter("translate")("d.p_dc.wos.l.13")}, {label:"On (Power Key Only)", value:"usePwrOnly", "tl":$filter("translate")("d.p_dc.wos.l.14")}, {label:"On (Block All)", value:"blockAll", "tl":$filter("translate")("d.p_dc.wos.l.15")}];
    $scope.pStatusList = [{label:"PWR (Power On)", value:"PWR", "tl":$filter("translate")("d.p_dc.wos.l.16")}, {label:"STD (Standby)", value:"STD", "tl":$filter("translate")("d.p_dc.wos.l.17")}, {label:"LST (Last Status)", value:"LST", "tl":$filter("translate")("d.p_dc.wos.l.18")}];
    $scope.dpmWakeList = [{label:"Clock", value:"clock", "tl":$filter("translate")("d.p_dc.wos.l.6")}, {label:"Clock+Data", value:"clockAndData", "tl":$filter("translate")("d.p_dc.wos.l.7")}];
    $scope.dpmList = [{label:"Off", value:"off", "tl":$filter("translate")("d.p_dc.wos.l.1")}, {label:"1 Min", value:"1min", "tl":$filter("translate")("d.p_dc.wos.l.2")}, {label:"3 Min", value:"3min", "tl":$filter("translate")("d.p_dc.wos.l.3")}, {label:"5 Min", value:"5min", "tl":$filter("translate")("d.p_dc.wos.l.4")}, {label:"10 Min", value:"10min", "tl":$filter("translate")("d.p_dc.wos.l.5")}];
    $scope.countryList = [];
    $scope.cityList = [];

    $scope.curMd = {v:""};
    $scope.curFw = {fw:""};
    $scope.curFwu = {fw:""};

    $scope.getContinentFx = function(arr){
      $scope.continentList = [];
      $scope.isDuplicate = false;
      angular.forEach(arr, function(item){
        $scope.isDuplicate = false;
        angular.forEach($scope.continentList, function(item1){
          if(item1 == item.continent){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate){
          $scope.continentList.push(item.continent);
        }
      });
    }

    $scope.tabPopFx = function(caller){
      $scope.selectedTPop = caller;
      $scope.tabLoading = true;
      $scope.fwSaved = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == 1){
        $scope.getDeviceControl(1);
      } else if(caller == 2){
        $scope.hasPopErr = false;
        $scope.errPopType = "";
        DeviceControlSrv.getWebOSTimezone().then(
          function(data){
            $scope.webOSTimezone = data.timeZone;
            $scope.getContinentFx($scope.webOSTimezone);
          },
          function(err){
            $log.error(err);
          }
        );
        DeviceControlSrv.getWebOSLang().then(
          function(data){
            $scope.localeList = data.localeList;
          },
          function(err){
            $log.error(err);
          }
        );
        DeviceControlSrv.getWebOS($scope.curDeviceControl.id).then(
          function(data){
            $scope.blockObj = {id:0, p:null, d:"in", pr:"TCP", show:false};
            $scope.tabLoading = false;
            $scope.fw = {upgrades:""};

            $scope.blockAdd = false;
            if(data.tz){
              $scope.webOSTimezone = [];
              $scope.webOSTimezone = data.tz.timeZone;
              if($scope.webOSTimezone){
                $scope.getContinentFx($scope.webOSTimezone);
              }
            }

            var keysToProcess = ['as.changePwd.conpwd', 'as.changePwd.curpwd', 'as.changePwd.newpwd'];
            $scope.webOS = $scope.endeDataFx("d", data, keysToProcess);

            $scope.webOS = data;
            $scope.webOS.fw.cur = {version:$scope.webOS.fw.cur};

            if($scope.webOS.fw.mdls && $scope.webOS.fw.mdls.length){
              $scope.curMd.v = $scope.webOS.fw.mdls[0];
              $scope.fwVersionFx();
            }
            $scope.webOS.tz = null;
            $scope.bCount = 0;

            if($scope.webOS.gs.as.tvt){
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")(day.st);
                day.et = $filter("momentTime")(day.et);
              });
            } else{
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")("09:00:00");
                day.et = $filter("momentTime")("17:00:00");
              });
            }
            $scope.timeZoneFx("c", true);
          }, function(err){
            $log.error(err);
            $scope.tabLoading = false;
          }
        );
      }
    }

    $scope.fwUpgradesOpen = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.fwSaved = false;
      if($scope.curFwu.fw == "" || $scope.curFwu.fw.version == ""){
        $scope.errPopType = "emptyV";
        $scope.hasPopErr = true;
      } else if($scope.curFwu.fw.version == $scope.webOS.fw.cur.version){
        $scope.errPopType = "sameV";
        $scope.hasPopErr = true;
      } else{
        $scope.fwPopup = ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">\
                <span>{{"d.p_dc.wos.m16" | translate}}</span>\
              </div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fwUpgradesFx();" focus-me="true" ng-disabled="confirmProcessing">\
                  <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"d.p_dc.wos.12.8" | translate}}\
                </button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
        });
      }
    }

    $scope.fwUpgradesFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.fwSaved = false;
      $scope.confirmProcessing = true;
      $scope.curFwu.type = "firmware";
      $scope.curFwu.id = $scope.curDeviceControl.id;
      $scope.fwProcessing = true;
      DeviceControlSrv.updateDeviceControl($scope.curFwu).then(
        function(data){
          $scope.fwProcessing = false;
          $scope.confirmProcessing = false;
          $scope.webOS.fw.req = data.lastFirmware;
          $scope.webOS.fw.reqV = $scope.curFwu.fw.version;
          $scope.curFwu.fw = "";
          $scope.fwSaved = true;
          $scope.fwPopup.close();
        }, function(err){
          $log.error(err);
          $scope.fwProcessing = false;
          $scope.confirmProcessing = false;
        }
      );
    }

    $scope.getDTFx = function(){
      if(!$scope.webOS.gs.dt.set){
        $scope.webOS.gs.dt.t = $scope.custTime = moment().set('minute', '00').utc().format();
        $scope.webOS.gs.dt.d = {startDate:moment()._d, endDate:moment()._d};
      } else{
        $scope.timeZoneFx("c", true);
      }
    }

    $scope.timeZoneFx = function(caller, auto){
      if(caller == "c"){
        $scope.countryList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCExists = false;
          angular.forEach($scope.countryList, function(item1){
            if(angular.equals(item.country, item1)){
      			  $scope.isCExists = true;
      			}
          });
          if(!$scope.isCExists && item.continent == $scope.webOS.gs.dt.tz.c){
            $scope.countryList.push(item.country);
          }
        });
        if(auto){
          $scope.timeZoneFx("ct");
        }
      } else if(caller == "ct"){
        $scope.cityList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCtExists = false;
          angular.forEach($scope.cityList, function(item1){
            if(angular.equals(item.country, item1)){
      			  $scope.isExists = true;
      			}
          });
          if(!$scope.isCtExists && item.country == $scope.webOS.gs.dt.tz.ct){
            $scope.cityList.push(item.city);
          }
        });
      }
    }

    $scope.blockAddFx = function(){
      $scope.blockAdd = !$scope.blockAdd;
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.editArr = [];
    $scope.savePortFx = function(caller, port){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.webOS.ns.port){
        $scope.webOS.ns.port = [];
      }
      if(caller == "a"){
        if($scope.blockObj.p == ""){
          $scope.errType = "pEmpty";
          $scope.hasErr = true;
        } else{
          if(!$scope.webOS.ns.port.length){
            $scope.blockObj.id = $scope.bCount;
            $scope.webOS.ns.port.push($scope.blockObj);
            $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
            $scope.blockAdd = false;
            $scope.bCount++;
          } else{
            for(var i=0; i<$scope.webOS.ns.port.length; i++){
              if($scope.webOS.ns.port[i].p == $scope.blockObj.p && $scope.webOS.ns.port[i].d == $scope.blockObj.d && $scope.webOS.ns.port[i].pr == $scope.blockObj.pr){
                $scope.errType = "pSame";
                $scope.hasErr = true;
                return;
              }
            }
            if($scope.bCount <= 30){
              $scope.webOS.ns.port.push({id:$scope.bCount, p:$scope.blockObj.p, d:$scope.blockObj.d, pr:$scope.blockObj.pr});
              $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
              $scope.blockAdd = false;
              $scope.bCount++;
            }
          }
        }
      } else if(caller == "e"){
        $scope.editArr.push(angular.copy(port));
      } else if(caller == "s"){
        $scope.isSame = false;
        $scope.indexToUpdate;
        for(var i=0; i<$scope.webOS.ns.port.length; i++){
          if($scope.webOS.ns.port[i].id != port.id && ($scope.webOS.ns.port[i].p == port.p && $scope.webOS.ns.port[i].d == port.d && $scope.webOS.ns.port[i].pr == port.pr)){
            $scope.isSame = true;
            $scope.errType = "pSame";
            $scope.hasErr = true;
            break;
          } else if($scope.webOS.ns.port[i].id == port.id){
            $scope.indexToUpdate = i;
          }
        }
        if(!$scope.isSame){
          port.show = !port.show;
          $scope.webOS.ns.port[$scope.indexToUpdate] = port;
          for(var j=0; j<$scope.editArr.length; j++){
            if($scope.editArr[j].id == port.id){
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    $scope.cancelEditFx = function(id){
      $scope.hasErr = false;
      $scope.errType = "";
      for(var i=0; i<$scope.webOS.ns.port.length; i++){
        if($scope.webOS.ns.port[i].id == id){
          for(var j=0; j<$scope.editArr.length; j++){
            if($scope.editArr[j].id == id){
              $scope.webOS.ns.port[i] = $scope.editArr[j];
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    /*Second ngDialog close*/
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.deletePortOpen = function(index){
      $scope.portIndex = index;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePortFx(portIndex);" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deletePortFx = function(index){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.webOS.ns.port.splice(index, 1);
      ngDialog.close($scope.confirmDialog);
    }

    $scope.webOSPwdObj = {curpwd:"",newpwd:"",conpwd:""};
    $scope.webOSFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.eOpened = $filter("filter")($scope.webOS.ns.port, {show:true});

      if($scope.webOS.gs.as.tvt){
        var isCheckErr = true, isSTErr = false, isETErr = false;
        angular.forEach($scope.webOS.gs.as.days, function(day){
          if(day.val){
            isCheckErr = false;
          }
          if(day.val && !day.st){
            isSTErr = true;
          }
          if(day.val && !day.et){
            isETErr = true;
          }
        });
      }

      if($scope.eOpened && $scope.eOpened.length){
        $scope.hasErr = true;
        $scope.errType = "eOpened";
      } else if(isCheckErr){
        $scope.hasErr = true;
        $scope.errType = "check";
      } else if($scope.webOS.gs.as.tvt && isSTErr){
        $scope.hasErr = true;
        $scope.errType = "onTime";
      } else if($scope.webOS.gs.as.tvt && isETErr){
        $scope.hasErr = true;
        $scope.errType = "offTime";
      } else{
        if(($scope.webOSPwdObj.curpwd.length && !$scope.webOSPwdObj.curpwd.match($scope.numRegEx)) || ($scope.webOSPwdObj.newpwd.length && !$scope.webOSPwdObj.newpwd.match($scope.numRegEx)) || ($scope.webOSPwdObj.conpwd.length && !$scope.webOSPwdObj.conpwd.match($scope.numRegEx))){
          $scope.hasErr = true;
          $scope.errType = "noPwd";
        } else if($scope.webOSPwdObj.curpwd != "" && $scope.webOSPwdObj.newpwd == ""){
          $scope.hasErr = true;
          $scope.errType = "newPwd";
        } else if($scope.webOSPwdObj.curpwd != "" && $scope.webOSPwdObj.newpwd != "" && $scope.webOSPwdObj.conpwd == ""){
          $scope.hasErr = true;
          $scope.errType = "conPwd";
        } else if($scope.webOSPwdObj.curpwd == "" && $scope.webOSPwdObj.newpwd == $scope.webOSPwdObj.conpwd && $scope.webOSPwdObj.newpwd != "" && $scope.webOSPwdObj.conpwd != ""){
          $scope.hasErr = true;
          $scope.errType = "pass";
        } else if($scope.webOSPwdObj.curpwd.length && $scope.webOSPwdObj.newpwd.length && $scope.webOSPwdObj.curpwd == $scope.webOSPwdObj.newpwd){
          $scope.hasErr = true;
          $scope.errType = "same";
        } else if($scope.webOSPwdObj.newpwd != $scope.webOSPwdObj.conpwd){
          $scope.hasErr = true;
          $scope.errType = "match";
        } else{
          $scope.saveProcessing = true;
          $scope.copyWebOS = angular.copy($scope.webOS);
          if($scope.copyWebOS.gs.as.tvt){
            angular.forEach($scope.copyWebOS.gs.as.days, function(day){
              if(day.st){
                day.st = moment(day.st).format();
                day.st = day.st.split("T")[1].split("+")[0].split("-")[0];
              }
              if(day.et){
                day.et = moment(day.et).format();
                day.et = day.et.split("T")[1].split("+")[0].split("-")[0];
              }
            });
          }
          if($scope.webOSPwdObj.curpwd != ""){
            // $scope.copyWebOS.as.changePwd = $scope.webOSPwdObj;
            $scope.copyWebOS.as.changePwd = {curpwd:$scope.encryptFx($scope.webOSPwdObj.curpwd), newpwd:$scope.encryptFx($scope.webOSPwdObj.newpwd), conpwd:$scope.encryptFx($scope.webOSPwdObj.conpwd)};
          } else{
            $scope.copyWebOS.as.changePwd = {};
          }
          DeviceControlSrv.updateWebOS({webOS:$scope.copyWebOS, id:$scope.curDeviceControl.id}).then(
            function(data){
              $scope.saveProcessing = false;
              ngDialog.close();
              $scope.loadSelectedTab();
            }, function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
        }
      }
    }

    $scope.setDefaultFx = function(){
      $scope.webOSPwdObj = {curpwd:"",newpwd:"",conpwd:""};
      $scope.defautProcessing = true;
      DeviceControlSrv.setDefaultSetting($scope.curDeviceControl.id).then(
        function(data){
          $scope.defautProcessing = false;
          $scope.webOS.as = data.as;
          $scope.webOS.gs = data.gs;
          $scope.webOS.ns = data.ns;

          if($scope.webOS.gs.as.tvt){
            angular.forEach($scope.webOS.gs.as.days, function(day){
              day.st = $filter("momentTime")(day.st);
              day.et = $filter("momentTime")(day.et);
            });
          } else{
            angular.forEach($scope.webOS.gs.as.days, function(day){
              day.st = $filter("momentTime")("09:00:00");
              day.et = $filter("momentTime")("17:00:00");
            });
          }
        },
        function(err){
          $log.error(err);
          $scope.defautProcessing = false;
        }
      );
    }

    $scope.setTvTimerFx = function(caller, curTime){
      $scope.webOS.gs.as.days.forEach(function(item){
        if(caller==='Mon'){
          if(item.name != 'Sat' && item.name != 'Sun'){
            item.val = true;
            item.st = curTime.st;
            item.et = curTime.et;
          }
        } else if(caller=='Sat'){
          if(item.name == 'Sat' || item.name == 'Sun'){
            item.val = true;
            item.st = curTime.st;
            item.et = curTime.et;
          }
        } else if(caller == 'all'){
          item.val = true;
          item.st = curTime.st;
          item.et = curTime.et;
        }
      });
    }

    $scope.singleFwFx = function(){
      $scope.curFwu.fw = angular.fromJson($scope.curFwu.fw);
    }

    $scope.mdlsLoading = false;
    $scope.fwVersionFx = function(fw){
      $scope.mdlsLoading = true;
      DeviceControlSrv.getFWVersion($scope.curMd.v).then(
        function(data){
          $scope.curFwu.fw = "";
          $scope.mdlsLoading = false;
          $scope.webOS.fw.upg = data.fw.upg;
        }, function(err){
          $scope.mdlsLoading = false;
          $log.error(err);
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DataUsageController', DataUsageController);

  /** @ngInject */
  function DataUsageController($log, $scope, $filter, ngDialog, DataUsageSrv){
    $scope.saveProcessing = false;
    $scope.date = {};
    if($scope.ngDialogData.key == 'dataUsage'){
      DataUsageSrv.getDataUsage($scope.ngDialogData.id).then(
        function(data){
          $scope.dataUsage = data;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      DataUsageSrv.getDataUsageSetting($scope.ngDialogData.id).then(
        function(data){
          $scope.dataUsage = data;
          $scope.dataUsage.startTime = $filter("momentTime")($scope.dataUsage.startTime);
          $scope.dataUsage.endTime = $filter("momentTime")($scope.dataUsage.endTime);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.customDataUsageFx = function(){
      $scope.customData = {id:$scope.ngDialogData.id, date:$scope.date.range};
      $scope.customData.date.startDate = moment($scope.date.range.startDate).format("L");
      $scope.customData.date.endDate = moment($scope.date.range.endDate).format("L");
      DataUsageSrv.saveCustomDataUsage($scope.customData).then(
        function(data){
          $scope.customDataUsage = data;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.dataUsageSettingFx = function(){
      if(localStorage.getItem("isDlAdvSearch")){
        localStorage.setItem("isActionOnDevice", true);
      } else{
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      $scope.errType = "";
      $scope.hasErr = false;
      $scope.dataUsage.id = $scope.ngDialogData.id;
      $scope.copyDataUsage = angular.copy($scope.dataUsage);
      $scope.copyDataUsage.startTime = $filter("date")($scope.copyDataUsage.startTime, "HH:mm Z");
      $scope.copyDataUsage.endTime = $filter("date")($scope.copyDataUsage.endTime, "HH:mm Z");
      //setting default value if pollingDuration empty because we hide it
      if(!$scope.copyDataUsage.pollingDuration || angular.isUndefined($scope.copyDataUsage.pollingDuration) || $scope.copyDataUsage.pollingDuration == 0 || $scope.copyDataUsage.pollingDuration == ""){
        $scope.copyDataUsage.pollingDuration = 30;
      }
      if($scope.copyDataUsage.screenshots && ($scope.copyDataUsage.uploadInterval == null || $scope.copyDataUsage.uploadInterval == 0)){
        $scope.hasErr = true;
        $scope.errType = "screenshot";
      } else if($scope.copyDataUsage.restriction && ($scope.copyDataUsage.startTime == null || $scope.copyDataUsage.startTime == "")){
        $scope.hasErr = true;
        $scope.errType = "dStart";
      } else if($scope.copyDataUsage.restriction && ($scope.copyDataUsage.endTime == null || $scope.copyDataUsage.endTime == "")){
        $scope.hasErr = true;
        $scope.errType = "dEnd";
      } else if($scope.copyDataUsage.restriction && $scope.copyDataUsage.startTime >= $scope.copyDataUsage.endTime){
        $scope.hasErr = true;
        $scope.errType = "dStartEnd";
      } else if($scope.copyDataUsage.restriction && ($scope.copyDataUsage.overrideFS == null)){
        $scope.hasErr = true;
        $scope.errType = "dFSize";
      } else if($scope.copyDataUsage.pollingDuration == null){
        $scope.hasErr = true;
        $scope.errType = "polling";
      } else if($scope.copyDataUsage.pollingDuration < 30){
        $scope.hasErr = true;
        $scope.errType = "pollingDur";
      } else{
        $scope.saveProcessing = true;
        DataUsageSrv.updateDataUsageSetting($scope.copyDataUsage).then(
          function(data){
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DSearchCUController', DSearchCUController);

  /** @ngInject */
  function DSearchCUController($log, $rootScope, $scope, ngDialog, DSearchCUSrv){
    $scope.saveProcessing = false;
    $scope.dSearchLoading = true;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.curDSearchModel = {};

    DSearchCUSrv.getDSDetails($scope.decId).then(
      function(data){
        $scope.dSearchLoading = false;
        $scope.copySearch = data;
        $scope.dSearch = angular.copy($scope.copySearch);
        $scope.copyDSearch = {tag:$scope.copySearch.tag, seid:$scope.copySearch.seid, label:$scope.copySearch.label, isConfimed:$scope.copySearch.isConfimed};
        $scope.curDSearch = angular.copy($scope.copyDSearch);
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.listManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel){
      $rootScope.rootManipulateFx(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel);/*This function in CommonController*/
    }

    $scope.resetSearchFx = function(){
      $scope.dSearch = angular.copy($scope.copySearch);
      $scope.curDSearch = angular.copy($scope.copyDSearch);
    }

    $scope.curData = {};
    $scope.saveDSearchFx = function(caller, action){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curDSearch.label == ""){
        $scope.errType = "label";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.curDSearch.tag.include.length + $scope.curDSearch.tag.exclude.length == 0){
        $scope.errType = "tag";
        $scope.hasErr = true;
        $("#availableTag").focus();
      } else{
        $scope.saveProcessing = true;
        if(caller == "confirm"){
          $scope.curDSearch.isConfimed = 1;
          $scope.curDSearch.schedules = $scope.curData.schedules;
        }
        DSearchCUSrv.saveDSearch($scope.curDSearch).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 12052){
              $scope.errType = "tag";
              $scope.hasErr = true;
              $("#availableTag").focus();
            } else if(data.code == 12053){
              $scope.confirmOpen("list");
              $scope.curData.schedules = data.schedules;
            } else if(data.code == 12039){
              $scope.popupProcessing = false;
              $scope.errType = "deviceErr";
              $scope.hasErr = true;
            } else{
              ngDialog.close();
            }
          },
          function(err){
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.confirmOpen = function(caller){
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div ng-if="curData.schedules.isAllHidden">{{"d.msg.25.2" | translate}}<br>{{"d.msg.25.1" | translate}}</div>\
              <div ng-if="!curData.schedules.isAllHidden">\
                <div>{{"d.msg.25" | translate}}</div>\
                <div class="marT10">\
                  <div class="table marTB10">\
                    <div class="row th">\
                      <div class="col-xs-12">{{"cm.label.3s" | translate}}</div>\
                    </div>\
                    <div class="overflow-auto" ng-style="{\'max-height\': \'{{getAvailableHeight(360)}}px\'}">\
                      <div ng-repeat="s in curData.schedules.incomplete">\
                        <div class="row" ng-if="!s.isHidden">\
                          <div class="col-xs-12 text-ellipsis">{{s.label}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div>{{"d.msg.25.1" | translate}}</div>\
                </div>\
              </div>\
            </div>\
            <div class="panel-footer">\
              <button type="button" role="button" class="btn btn-success" ng-click="saveDSearchFx(\'confirm\');" ng-disable="saveProcessing">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </div>\
          </section>',
        plain: true,
        width: 700,
        scope: $scope,
        data: $scope.curData,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AddToDeviceGrpController', AddToDeviceGrpController);

  /** @ngInject */
  function AddToDeviceGrpController($log, $scope, $rootScope, $state, ngDialog, AddToDeviceGrpSrv){
    $scope.saveProcessing = false;
    $scope.isGroupAvailable = false;
    $scope.isGroupEmpty = false;
    $scope.curUserGrp = {};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.isFolder = false;
    if(angular.isArray($scope.curGroupIds)){
      if($scope.curGroupIds.length > 1){
        $scope.curGroupId = 0;
      } else{
        $scope.curGroupId = $scope.curGroupIds[0].id;
        if($scope.curGroupIds[0].type == "folder"){
          $scope.isFolder = true;
        }
      }
    } else{
      $scope.curGroupId = $scope.curGroupIds;
    }
    AddToDeviceGrpSrv.getDeviceGrp($scope.curGroupId, $scope.isFolder).then(
      function(data){
        $scope.isGroupAvailable = true;
        $scope.curGroup = data;
        if($scope.devices){
          $scope.devices.device = $scope.curGroup;
        }
        if($scope.curGroup.availableGroups.length > 0 || $scope.curGroup.groups.length > 0){
          $scope.curGroup.grpOpt = "updateGrp";
          $scope.isGroupEmpty = false;
          $scope.isGroupAvailable = true;
        } else{
          $scope.curGroup.grpOpt = "newGrp";
          $scope.isGroupEmpty = true;
          $scope.isGroupAvailable = false;
        }
      }
    );

    $scope.removeMsg = function(){
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.saveUserGrpFx = function(){
      if(localStorage.getItem("isDlAdvSearch")){
        localStorage.setItem("isActionOnDevice", true);
      } else{
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.selItems = $rootScope.selectedItems;

      if($scope.curGroup.grpOpt == "newGrp"){
        if(!$scope.curGroup.newGroup || $scope.curGroup.newGroup == ""){
          $scope.saveProcessing = false;
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#newGroup").focus();
          return;
        }
      }

      // ?New: separate folder and device ids in different key
      $scope.fids = $scope.selItems.filter(function(item){
        if(item.type == "folder"){
          return item;
        }
      });

      // if($scope.fids.length){
        $scope.curGroupIds = $scope.selItems.filter(function(item){
          if(item.type == "device"){
            return item;
          }
        });
      // }
      $scope.curGroup.fids = $scope.fids;
      AddToDeviceGrpSrv.updateDeviceGrp($scope.curGroupIds, $scope.curGroup).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code && data.code == 12022){
            $scope.errType = "exists";
            $scope.hasErr = true;
          } else if(data.code && data.code == 12023){
            $scope.errType = "noDevice";
            $scope.hasErr = true;
            $("#newGroup").focus();
          } else if(data.code && data.code == 12039){
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
            $("#newGroup").focus();
          } else if(data.code == 12090){
            $scope.errType = "eslError";
            $scope.hasErr = true;
            $("#newGroup").focus();
          } else if(data.code == 12042){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.p_dg.m4" | translate}}</div>\
                    <div class="table marT15">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="err in curData.devices">\
                          <div class="col-xs-12 word-break">{{err}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            ngDialog.close();
            $scope.loadSelectedTab("refresh");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AddRemoveTagController', AddRemoveTagController);

  /** @ngInject */
  function AddRemoveTagController($log, $scope, $rootScope, ngDialog, AddRemoveTagSrv, IndexedDB){
    $scope.saveProcessing = false;
    $scope.popupLoading = true;
    $scope.isTagEmpty = false;
    $scope.curUserTag = {};
    $scope.hasErr = false;
    $scope.errType = "";
    if($scope.curTagObj.ids.length > 1){
      $scope.stringIds = $scope.arraytoStringFx($scope.curTagObj.ids);
      $scope.curId = $scope.stringIds.toString();
    } else{
      $scope.curId = $scope.curTagObj.ids[0].id;
    }


    // AddRemoveTagSrv.getAddRemoveTag($scope.curTagObj.type, $scope.curId).then(
    AddRemoveTagSrv.getAddRemoveTag($scope.curId).then(
      function(data){
        $scope.popupLoading = false;
        $scope.curTag = {availableTags:[], assignedTags:[]};
        $scope.curTag.availableTags = data.availableTags;
        $scope.curTag.assignedTags = data.assignedTags;
        $scope.previousTag = angular.copy($scope.curTag.assignedTags);
      }
    );

    $scope.updateItemDB = function(store, key){
      // console.warn("addItemsDB----------- ", obj);
      IndexedDB.updateItem(store, key).then(function(message){
      }).catch(function(error){
      // console.error(error);
      });
    };

    $scope.updatedItems = [];
    $scope.getItemDB = function(store, key, caller){
      // console.log("Get ITem DB", store, key, caller);
      IndexedDB.getItem(store, key).then(function(item){
        $scope.updatedItems.push(item);
      }).catch(function(error){
      });
    };

    $scope.saveDeviceTagFx = function(){
      // console.warn("Herer 1");
      if(localStorage.getItem("isDlAdvSearch")){
        localStorage.setItem("isActionOnDevice", true);
      } else{
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";

      // Function to find missing objects from B compared to A
      function findMissingObjects(arrA, arrB) {
        function filterCallback(objA) {
          return !arrB.find(function (objB) {
            return objB.id === objA.id;
          });
        }

        return arrA.filter(filterCallback);
      }

      // Find missing objects from B compared to A
      $scope.missingObjects = findMissingObjects($scope.previousTag, $scope.curTag.assignedTags);

      // $scope.saveData = {info:$scope.curTagObj, tags:$scope.curTag.assignedTags};
      $scope.saveData = {info:$scope.curTagObj, tags:{assignable:$scope.curTag.assignedTags, removable:$scope.missingObjects}};
      AddRemoveTagSrv.saveAddRemoveTag($scope.saveData).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code && data.code == 12021){
            $scope.errType = "exists";
            $scope.hasErr = true;
          } else if(data.code && data.code == 12039){
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
          } else if(data.code == 12090){
            $scope.errType = "eslError";
            $scope.hasErr = true;
          } else if(data.code == 12042){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.p_dg.m4" | translate}}</div>\
                    <div class="table marT15">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="err in curData.devices">\
                          <div class="col-xs-12 word-break">{{err}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else if(data.code == 10046){
            $scope.errDataObj = data.data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <header class="panel-heading"><h1 role="heading" aria-level="1">{{"s.p_s.body.6" | translate}}</h1></header>\
                  <div class="panel-body">\
                    <div class="msg-warning" lang="{{auth.lang}}">{{"s.p_s.msg.55" | translate}}</div>\
                    <div class="table marT10">\
                      <div class="row th">\
                        <div class="col-xs-4">{{"cm.label.3" | translate}}</div>\
                        <div class="col-xs-4">{{"cm.label.4" | translate}}</div>\
                        <div class="col-xs-4">{{"as.btn.1" | translate}}</div>\
                      </div>\
                      <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(420)}}px">\
                        <div class="row" ng-repeat="list in errDataObj">\
                          <div class="col-xs-4">{{list.schedule.label}}</div>\
                          <div class="col-xs-4">{{list.device.label}}</div>\
                          <div class="col-xs-4">{{list.search.label}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <span class="btnQuad">\
                      <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                    </span>\
                    <div class="clearfix"></div>\
                  </footer>\
                </section>',
              plain:true,
              width:710,
              scope:$scope,
              closeByDocument:false
            });
          } else{
            ngDialog.close();
            // $scope.loadSelectedTab("refresh");
            // console.log($scope.updatedItems);

            // angular.forEach($scope.updatedItems, function(item){
            //   if(item.tl.length){
            //     var tempTL = [];
            //     angular.forEach(item.tl, function(tlId, i){
            //       console.warn("tlId", tlId);
            //       if(!$scope.tagIds.includes(tlId)){
            //         tempTL.push(tlId);
            //       }
            //     });
            //     item.tl = $scope.tagIds.concat(tempTL);
            //     console.warn("item.tl ", item.tl);
            //   }
            // });
            // console.warn($scope.updatedItems);
            // angular.forEach($scope.updatedItems, function(item){
            //   if(item.tl.length){
            //     console.warn("item.tl R ", item.tl);
            //     angular.forEach(item.tl, function(tlId, i){
            //       if($scope.mTagIds.includes(tlId)){
            //         item.tl.splice(i, 1);
            //       }
            //     })
            //   }
            //   console.warn("item ", item);
            //   $scope.updateItemDB("dData", item);

            // });

            $scope.loadSelectedTab("refresh");

          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
angular.module('hub').service('PreviewSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFeed= function(id, ts, t){
    httpReq = $http.get($rootScope.apiHost + "getfeeds3/preview?ip=" + id + "&ts=" + ts + "&t=" + t);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getEm= function(id){
    httpReq = $http.get($rootScope.apiHost + "feed/em/" + id + "/false");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {
      "code": 5000
    });
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PreviewController', PreviewController);

  /** @ngInject */
  function PreviewController($log, $scope, $rootScope, $state, $timeout, $window, $filter, $interval, ngDialog, PreviewSrv){
    $scope.bucket = $scope.devices.info.bucket;
    if(!angular.isUndefined($scope.bucket)){
      $scope.bucket = $scope.bucket.substr(0, $scope.bucket.length - 2);
    }
    $scope.tim = $scope.devices.info.timthumb;
    $scope.previewLoading = true;
    $scope.canvas = {zoom:'1'};
    $scope.previewVersion = 0;
    $scope.zoomLevels = [];
    $scope.fs = {item:[]};
    $scope.feed = {};
    $scope.em = {};
    $scope.fsCurItem;


    $scope.getAvailableHeight = function(deductableHeight){
      if(document.body && document.body.offsetWidth){
        $scope.winH = document.body.offsetHeight;
      }
      if(document.compatMode == 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth){
        $scope.winH = document.documentElement.offsetHeight;
      }
      if(window.innerWidth && window.innerHeight){
        $scope.winH = window.innerHeight;
      }
      $scope.winH = $scope.winH - deductableHeight;
      return $scope.winH;
    }

    $scope.previewHeight = $scope.getAvailableHeight(200);
    PreviewSrv.getFeed($scope.curPreviewObj.mac, $scope.curPreviewObj.timestamp, $scope.curPreviewObj.time).then(
      function(data){
        $scope.feed = data;
        if($scope.previewObj.isControls && $scope.feed.layout){
          $scope.feed.layout[0].w += 100;
        }
        $scope.previewLoading = false;
        $scope.previewVersion = data.device[0].version;
        $timeout(function(){
          $scope.scaleHeight = ($("#canvas").height()) / $scope.feed.layout[0].h;
          $scope.scaleWidth = ($("#canvas").width()) / ($scope.feed.layout[0].w);
    			if($scope.scaleWidth < $scope.scaleHeight){
    				$scope.canvas.zoom = Math.round($scope.scaleWidth * 100) / 100;
    			} else{
    				$scope.canvas.zoom = Math.round($scope.scaleHeight * 100) / 100;
    			}
          $scope.fitToFrame = $scope.canvas.zoom;
          $scope.zoomLevels = [{val:$scope.canvas.zoom, label:$filter("translate")('fl.p_cfl.label.23')},{val:1, label:"100%"},{val:0.75, label:"75%"},{val:0.5, label:"50%"},{val:0.25, label:"25%"},{val:0.1, label:"10%"}];
          $scope.canvas.zoom = $scope.zoomLevels[0].val;
          // todo update the  dialog size according to the feed size
          $(".ngdialog-content").css("width", $scope.feed.layout[0].w*$scope.canvas.zoom + 30);
        }, 100);
      },
      function(err){
        $scope.previewLoading = false;
        $log.error(err);
      }
    );

    $scope.hexToRgbA = function(hex, alpha){
      var c;
      if(hex == ""){
        return "";
      } else{
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
          c = hex.substring(1).split('');
          if(c.length == 3){
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c = '0x' + c.join('');
          return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', ' + alpha + ')';
        } else{
          return "rgba('255, 255, 255', " + alpha + ")";
        }
      }
    }

    // todo commnent out this code and add the code inside the PreviewSrv.getFeed timeout
    // setTimeout(function(){
      // $(".ngdialog-content").css("width", $(".bg-black").attr('data-size'));
    // }, 1200);
  }
})();
angular.module('hub').service('YoutubeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getYoutube = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/youtube/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveYoutube = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/youtube", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('YammerSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getYammer = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/yammer/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/yammer/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAuthList = function(id,netId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/yammer/verify/" + id + "?netId=" + netId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveYammer = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/yammer", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.saveYammer = function(obj,id,netId){
  //   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/yammer/verify/:"+id+"?netId="+netId, obj);
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }
  this.getCommunity = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/yammer/communities", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logoutIn = function(){
    httpReq = $http.get("https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=https://www.yammer.com/logout_landing");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('XovisSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getXovis = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/xovis/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveXovis = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/xovis", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resetOccupancy = function(id){
    httpReq = $http.delete($rootScope.apiHost + "contentlibrary/widgets/xovis/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WQMetroSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getMetro = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/wqMetro/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMetro = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/wqMetro", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WebexSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWebexDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webex/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webex/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAuthList = function(id, tId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webex/verify/" + id + "?teamId=" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveWebex = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webex/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSpaces = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webex/spaces", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logoutIn = function(){
    httpReq = $http.get("https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=https://www.yammer.com/logout_landing");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WebPageSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWebPage = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webPage/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWebPage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webPage", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WebLoginChromeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWebLoginChrome = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webLoginChrome/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWebLoginChrome = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webLoginChrome", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WebLoginSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWebLogin = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webLogin/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWebLogin = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webLogin", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WebCamSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWebCam = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/webCam/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWebCam = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/webCam", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WeatherSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getWeather = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/weather/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWeather = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/weather", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('VimeoSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getVimeo = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/vimeo/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveVimeo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/vimeo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('VerkadaSrv', ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {
  var httpReq;

  var requests = [];

  // Helper to add request to the list
  function addRequest(deferred) {
    requests.push(deferred);
  }

  // Helper to cancel all ongoing requests
  function cancelAllRequests() {
    requests.forEach(function (req) { req.resolve() });
    requests = []; // Clear the list after aborting
  }

  // Watch for tab/module change to abort
  $rootScope.$on('abortRequests', function () {
    cancelAllRequests();
  });

  this.getVerkada = function (id) {
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/verkada/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveVerkada = function (obj) {
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/verkada", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerkadaCameraList = function (startIndex) {
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/verkada/cameras?sti=" + startIndex , destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getSearchVerkadaCameraList = function (startIndex, text) {
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/verkada/cameras?sti=" + startIndex + "&&searchQ=" + encodeURIComponent(text), destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getVerkadaCameraTumb = function (cameraId) {
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/verkada/thumb?camera_id=" + cameraId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.cleanup = function(){
    cancelAllRequests()
  }

  this.handleSuccess = function (response) {
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function (response) {
    $rootScope.toastNotificationFx("danger", { "code": 5000 });
    if(response.data.desc == "Verkada settings are not configured for the server."){
      return ($q.reject(response.data.desc));
    }else if (!angular.isObject(response.data) || !response.data.message) {
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('UnisysSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getUnisys = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/unisys/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUnisys = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/unisys", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLocation = function(env){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/unisys/location/"+ env);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TwitterSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTwitter = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/twitter/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTwitter = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/twitter", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loginOtherUser = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/twitter/logout", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  } 
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/twitter/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TsccmSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTsccm = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/tscCountryMile/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTsccm = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/tscCountryMile", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TrainingModeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTrainingMode = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/trainingMode/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTrainingMode = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/trainingMode", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TrafficSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTraffic = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/traffic/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTraffic = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/traffic", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TouchLinkSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTouchLink = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/touchlinkMeetings/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTouchLink = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/touchlinkMeetings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('textSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getText = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/text/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveText = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/text", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TelaxSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTelax = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/telax/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTelax = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/telax", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TeamsRoomSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTeamsRoom = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTeamsRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/teamsRooms", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTeamsRoomVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVersionList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/version");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRoomList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/ss/devices");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.editRoom = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/room", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMSRooms = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamsRooms/roomlist/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TeamsChannelSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getChannelDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamschannel/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamschannel/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAuthList = function(id,netId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/teamschannel/verify/" + id + "?teamId=" + netId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveChannel = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/teamschannel", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getChannels = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/teamschannel/channels", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logoutIn = function(){
    httpReq = $http.get("https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=https://www.yammer.com/logout_landing");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TableauSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTableau = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/tableau/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getProjectList = function(wId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/tableau/projects/"+wId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWorkbookList = function(wId, pId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/tableau/workbooks/"+wId+"/"+pId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getViewList = function(wId, pId, wbId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/tableau/views/"+wId+"/"+pId+"/"+wbId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTableau = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/tableau", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SurveySrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSurvey = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/survey/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getResult = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/survey/result/"+ obj.id + "/" + obj.vid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.export = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/survey/result", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveStatus = function (obj){
   httpReq = $http.put($rootScope.apiHost + "contentLibrary/widgets/survey", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSurvey = function (obj){
   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/survey", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SunSmartSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSunSmart = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/sunSmart/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSunSmart = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/sunSmart", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('StormSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getStorm = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/storm/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveStorm = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/storm", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('StockPriceSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getStockPrice = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/stockPrice/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStockExc = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/stockPrice/exchange");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStockSym = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/stockPrice/symbol/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveStockPrice = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/stockPrice", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SocialChorusSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSch = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/socialChorus/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getChannelList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/socialChorus/channel");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSch = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/socialChorus", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SlackSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSlack = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/slack/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSlack = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/slack", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSlackVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/slack/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SelectSocialMediaSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSsm = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/socialMedia/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSsm = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/socialMedia", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ScheduleCalendarSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getScheduleCalendar = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/scheduleCalendar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSchedule = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/sc");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveScheduleCalendar = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/scheduleCalendar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getScheduleCalendarFeed = function(id){
    httpReq = $http.get($rootScope.apiHost + "feed/scheduleCalendar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('RSSFeedSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getRSSFeed = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/rssFeed/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveRSSFeed = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/rssFeed", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ReaderBoardSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getReaderBoard = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/readerBoard/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveReaderBoard = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/readerBoard", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('QuotesSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getQuotes = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/quotes/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibrary = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/quotes/library");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getChatGPTLibrary = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/quotes/chatGPT", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveQuotes = function (obj){
   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/quotes", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('QueueWSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getQueue = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/queue/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveQueue = function (obj){
   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/queue", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('QRCodeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getQR = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/qrcode/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getQRCode = function(data){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/qrcode/preview", data);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveQR = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/qrcode", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('QlikSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getQlik = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/qlik/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/qlik/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getApps = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/qlik/apps/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveQlik = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/qlik", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ProgressBarSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/progressBar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/progressBar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('PrayerSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPrayer = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/prayer/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMethods = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/prayermethods");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStockSym = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/stockPrice/symbol/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePrayer = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/prayer", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('PowerBISrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPowerBI = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/powerbi/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGroups = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/powerbi/groups/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVisualization = function(gId, type, id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/powerbi/groups/"+ gId +"/"+ type +"/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportTabs = function(gId, rId, wId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/Powerbi/groups/" + gId + "/reports/" + rId + "/pages/" + wId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePowerBI = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/powerbi", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPowerBIToken = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/powerbi/" + id + "?isET=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('PatientWaitSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPatientWait = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/patientWait/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePatientWait = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/patientWait", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('OutlookCalendarSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getOutlookCalendar = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveOutlookCalendar = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getOutlookVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVersionList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/version");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/ss/devices");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/outlookCalendar/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('OpenHoursSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getOpenHours = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/openHours/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveOpenHours = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/openHours", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDeviceData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/openHours/hours", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('OnlineRadioSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getOnlineRadio = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/onlineRadio/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStations = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/onlineradio/0");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveOnlineRadio = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/onlineRadio", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('NextVehicleSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getNextVehicle = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextVehicle/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveNextVehicle = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/nextVehicle", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('NextBusSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getNextBus = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextBus/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAgency = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextBus/agency");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRoute = function(tag){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextBus/route?a=" + tag);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDirections = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextBus/directions?a=" + obj.aTag + "&r=" + obj.rTag);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStops = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/nextBus/stops?a=" + obj.aTag + "&r=" + obj.rTag + "&dir=" + obj.dTag);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveNextBus = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/nextBus", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('NewsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getNews = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/news/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getNewsFeed = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/news/feed/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCountry = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/news/country");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveNews = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/news", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MusicChoiceSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getMCName = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/musicChoice/name/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMCCategories = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/musicChoice/category/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMCPlaylist = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/musicChoice/playlist/" + obj.id + "/" + obj.offset);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMCCategorySongs = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/musicChoice/category/song/" + obj.id + "/" + obj.categoryId + "/" + obj.count);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMusicChoiceWidgets = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/musicChoice/allwidget");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMCName = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/name", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMCCategories = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/category", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMCPlaylist = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/playlist", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMCCategorySongs = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/category/song", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.searchSongs = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/category/playlist/search", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMusicChoiceWidgets = function(idObj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/musicChoice/dontPlaySong", idObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MSTeamsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getMSTeams = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/msTeams/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMSTeams = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/msTeams", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MessageSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getMessage = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/message/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMessage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/message", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MeetingSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getMeeting = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/meeting/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMeeting = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/meeting", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/meeting/activeList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpireList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/meeting/expireList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addMeeting = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/meeting/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){//item id = iId
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/meeting/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMeetingCalendar = function(id, type){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/meetings/preview/" + id + "/" + type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/meeting/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/meeting/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/meeting/room/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.editRoom = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentLibrary/widgets/meeting/room", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('LiveStreamingSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getLiveStreaming = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/liveStreaming/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLiveStreaming = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/liveStreaming", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCaptionsLang = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/captions/lang");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('LinkedInSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;

  this.getLinkedIn = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/linkedin/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getInVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/linkedin/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveLinkedIn = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/linkedin", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logoutIn = function(){
    httpReq = $http.get("https://www.linkedin.com/m/logout/");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('JciMapSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
    var httpReq;
    this.getJciMap = function(id){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/jciMap/" + id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getKioskList = function(){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/jciMap/kiosk");
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.saveJciMap = function(obj){
      httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/jciMap", obj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.handleSuccess = function(response){
      $rootScope.toastNotificationFx("info", response.data);
      return (response.data);
    }
    this.handleError = function(response){
      $rootScope.toastNotificationFx("danger", {"code":5000});
      if(!angular.isObject(response.data) || !response.data.message){
        return ($q.reject("An unknown error occurred."));
      }
      return ($q.reject(response.data.message));
    }
  }]);
angular.module('hub').service('IoTButtonSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getIoT = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/iotButton/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveIoT = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/iotButton", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/iotButton/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/iotButton/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){//item id = iId
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/iotButton/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('InteractiveMenuSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getInteractiveMenu = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/interactiveMenu/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveInteractiveMenu = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/interactiveMenu", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SBSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSB = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/smartBuilding/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSB = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/smartBuilding", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('IntelCircuitRssSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getIntelCircuit = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/intelCircuitRss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveIntelCircuit = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/intelCircuitRss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('InstagramSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getInstagram = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/instagram/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveInstagram = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/instagram", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/instagram/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('IFrameSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getIFrame = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/iFrame/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveIFrame = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/iFrame", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('HDStethSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getHDSteth = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/hdSteth/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveHDSteth = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/hdSteth", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){//item id = iId
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/hdSteth/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/hdSteth/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAdvtList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/hdSteth/advt/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/ss/devices");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMapping = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/hdSteth/mapping/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/hdSteth/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addAdvt = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/hdSteth/advt", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/hdSteth/room/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.editMapping = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentLibrary/widgets/hdSteth/mapping", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('GrafanaSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDashboardList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/grafana/dashboardList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveGrafana = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/grafana", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGrafana = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/grafana/"+id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('GSlideSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getGSlide = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/gSlide/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveGSlide = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/gSlide", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('GCalendarSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getGCalendar = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/gCalendar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveGCalendar = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/gCalendar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/gCalendar/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/gCalendar/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/ss/devices");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/gCalendar/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/gCalendar/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FTPSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFTP = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/ftp/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFTP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/ftp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FSChromeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFSChrome = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/fsChrome/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFSChrome = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/fsChrome", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FlightScheduleSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFlightSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/flightSchedule/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAirportCodes = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/flightSchedule/aCode");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFlightSchedule = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/flightSchedule", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FillerContentSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFillerContent = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/fillerContent/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFillerContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/fillerContent", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FifaSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFifa = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/fifa/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFifa = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/fifa", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FacebookWpSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.saveFacebookWorkplace = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/facebookWorkplace", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGroup = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/facebookWorkplace/group", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFacebookWorkplace = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/facebookWorkplace/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/facebook/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FacebookSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFacebook = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/facebook/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFacebook = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/facebook", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/facebook/verify/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('WorkSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/work/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/work", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('StorySrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/workout/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/workout", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('StaySrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/stay/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/stay", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ProgressBarWithBreakSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/progressBarWithBreak/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/progressBarWithBreak", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('f45ProgressBarSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/progressBar/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/progressBar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MoveStationSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/moveStation/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/moveStation", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('HydrateSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/hydrate/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/hydrate", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CountdownCircleSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/countdownCircle/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/countdownCircle", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentTileSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/contentTile/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/contentTile", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTiles = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/tileLayout");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentScrollerSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/contentScroller/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/contentScroller", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AnimationSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
    var httpReq;
    this.getData = function(id){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/animation/" + id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.saveData = function(obj){
      httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/animation", obj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.handleSuccess = function(response){
      $rootScope.toastNotificationFx("info", response.data);
      return (response.data);
    }
    this.handleError = function(response){
      $rootScope.toastNotificationFx("danger", {"code":5000});
      if(!angular.isObject(response.data) || !response.data.message){
        return ($q.reject("An unknown error occurred."));
      }
      return ($q.reject(response.data.message));
    }
  }]);
angular.module('hub').service('F45Srv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getF45 = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveF45 = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addWorkout = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/workout/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWorkoutList = function(id, day){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/workout/"+ id +"/"+ day);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(wId, id){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/f45/workout/"+ wId +"/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAdvertList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/adv/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addAdvert = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/adv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ExtInputSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getExtInput = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/externalInput/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveExtInput = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/externalInput", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ExcelSheetSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getExcelSheet = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/excelSheet/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveExcelSheet = function (obj){
   httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/excelSheet", obj);
   return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DelimitedTextSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDelimitedText = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/delimitedText/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDelimitedText = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/delimitedText", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DateTimeSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDateTime = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/dateTime/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDateTime = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/dateTime", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CountSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCount = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/count/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCount = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/count", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentOnDemandSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCOD = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCOD = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCategory = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand/category/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addCategory = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(obj){
    if(obj.caller == "c"){
      httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand/category/"+ obj.wId +"/"+ obj.id);
    } else{
      httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/contentOnDemand/category/"+ obj.wId +"/"+ obj.id +"/"+ obj.wcodid);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getApproved = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved?cod=1&" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderApprovedContent = function(fId, splId, splType){
    if(splId === undefined || splId === ""){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?cod=1&" + new Date().getTime());
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?cod=1&splId=" + splId + "&splType=" + splType + "&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentGroupSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getContentGroup = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/contentgroup/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveContentGroup = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/contentgroup", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('pylonTextSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPylonText = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/comPylonText/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePylonText = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/comPylonText", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ComEventSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.saveActiveNet = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/comEvents", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){//item id = iId
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/comEvents/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/comEvents/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFacilityList = function(cId){
    httpReq = $http.get($rootScope.apiHost + "comEvents/facilities?comId=" + cId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getComAndFacilityList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentlibrary/widgets/comEvents/data");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveList = function(wId, cId, fId){
    httpReq = $http.get($rootScope.apiHost + "contentlibrary/widgets/comEvents/events/active/" + wId +"/" + cId +"/" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpireList = function(wId, cId, fId){
    httpReq = $http.get($rootScope.apiHost + "contentlibrary/widgets/comEvents/events/expired/" + wId +"/" + cId +"/" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveNet = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/comEvents/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/comEvents/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateEvent = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentlibrary/widgets/comEvents/events", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.syncEvent = function(wId, eId, comId, facId){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/comEvents/events/" + wId + "/" + eId + "?comId=" + comId + "&facId=" + facId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.syncData = function(type){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/comEvents/sync/"+type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setVisibility = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentlibrary/widgets/comEvents/hide", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('COESrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCE = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getCOEV = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEventsView/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveEvent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveEventVisibility = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/visibility", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/activeList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpireList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/expireList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveListView = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEventsView/activeList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpireListView = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEventsView/expireList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addEvent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id, type, iId){//item id = iId
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/" + id + "/" + type + "/" + iId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getMeetingCalendar = function(id, type){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/preview/" + id + "/" + type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/ss/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addSS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/ss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRoomList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/roomList/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getViewList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/viewList/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/room/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.editRoom = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/room", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEvents/roomList", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveView = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEventsView", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePrint = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/calendarOfEventsView/frame", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CoDButtonSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCODBtn = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/codbutton/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCODBtn = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/codbutton", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getApproved = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderApprovedContent = function(fId, splId, splType){
    if(splId === undefined || splId === ""){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?" + new Date().getTime());
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?splId=" + splId + "&splType=" + splType + "&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CloudFarmSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCloudFarm = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cloudFarm/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWCList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/agc/wc");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCloudFarm = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/cloudFarm", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CloudCoverMusicSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCloudCoverMusic = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cloudCoverMusic/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCloudCoverMusic = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/cloudCoverMusic", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CiscoSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCisco = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cisco/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getNetworkList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cisco/networks");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSensorList = function(netId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cisco/networks/devices/"+netId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReadingList = function(sId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/cisco/networks/devices/sensors/"+sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCisco = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/cisco", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('BlankSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getData = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/blank/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveData = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/f45/blank", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AutoLoginSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAutoLogin = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/autoLogin/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAutoLogin = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/autoLogin", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AQISrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAQI = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/aqi/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAQI = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/aqi", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AmazonQuickSightSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAQS = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/amazonQuickSight/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/amazonQuickSight/dashboard");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSList = function(dId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/amazonQuickSight/sheets?id=" + dId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveAQS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/amazonQuickSight/cu", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);

angular.module('hub').service('AlertSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAlert = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/alertmsg/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAlert = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/alertmsg", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AgcSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAgc = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/agc/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWCList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/agc/wc");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAgc = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/agc", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AchieversSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAchievers = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/achievers/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAchievers = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/widgets/achievers", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('YoutubeController', YoutubeController);

  /** @ngInject */
  function YoutubeController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, YoutubeSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      YoutubeSrv.getYoutube($scope.decId).then(
        function(data){
          $scope.youtube = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.youtube = {labelOpt:"a", label:"", playlistId:"", settings:{cc:false}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.youtubeFx = function(){
      $scope.youtube.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.youtube.labelOpt=='c' && $scope.youtube.label==""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.youtube.playlistId==""){
        $scope.errType = "id";
        $scope.hasErr = true;
        $("#playListId").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveYoutubeFx();
          }, 250);
        } else{
          $scope.saveYoutubeFx();
        }
      }
    }
    $scope.saveYoutubeFx = function(){
      YoutubeSrv.saveYoutube($scope.youtube).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 8089){
            $scope.errType = "invalid-id";
            $scope.hasErr = true;
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('YammerController', YammerController);

  /** @ngInject */
  function YammerController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, $interval,ngDialog, YammerSrv){
    // $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, arb:false, rt:false, art:false};
    // $scope.colorPicker = { b: false, hb: false, ht: false, rb: false, rt: false, arb: false, art: false };
    
    $scope.colorPicker = {headerBg: false, headerText: false,bg: false,rowBg: false,altBg: false,titleText: false,subtitleText:false, descText: false,altTitleText: false,altDescText: false,textBg: false,text: false,  altSubtitleText:false};
    // $scope.fid = $cookies.get("curFId");
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.authSaveDisable = false;
    $scope.authProcessing = false;
    $scope.showNetList = false;
    $scope.showCommList = false;
    $scope.showCommLoading = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.communityList = [];
    $scope.networkList = [];

    // $scope.settings = {
    //   settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#0b5394", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, rowText:"#444444", altRowText:"#444444", rowFont:$scope.fontFamilySelected, altRowFont:$scope.fontFamilySelected},
    //   ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", rowText:"monochrome",  altRowText:"monochrome"}
    // }
    // $scope.defaultSettings = angular.copy($scope.settings);

    $scope.list = {
      settings: { rotationOpt: "a", rotate: 12, hTextOpt: "a", hText: "", headerBg: "#ffffff", headerBga: 1, headerText: "#6fa8dc", headerFont: $scope.fontFamilySelected, bg: "#ffffff", bga: 1, rowBg: "#ffffff", rowBga: 1, altBg: "#f3f3f3", altBga: 1, titleText: "#6fa8dc", subtitleText: "#999999", descText: "#444444", altTitleText: "#6fa8dc", altSubtitleText: "#999999", altDescText: "#444444", rowFont: $scope.fontFamily[56], altRowFont: $scope.fontFamily[56], headerSize: 26, titleSize: 16, subtitleSize: 16, descSize: 18},
      ctype: { headerBg: "monochrome", headerText: "default", bg: "monochrome", rowBg: "monochrome", altBg: "monochrome", titleText: "default", descText: "monochrome", altTitleText: "default", altDescText: "monochrome", subtitleText:"monochrome",altSubtitleText:"monochrome"}
    }

    $scope.textMedia = {
      settings: {
        bg: "#ffffff", bga: 1,align:"l", textBg: "#ffffff", textBga: 1, titleText: "#6fa8dc", descText: "#444444", titleSize: 16, descSize: 18, titleFont: $scope.fontFamilySelected, descFont: $scope.fontFamilySelected, rotationOpt:"a", rotate:12
      },
      ctype: {bg: "monochrome", textBg: "monochrome", titleText: "default", descText: "monochrome"}
    }

    $scope.media = {
      settings: {bg: "#ffffff", bga: 1, rotationOpt:"a", rotate:12},
      ctype: {bg: "monochrome"}
    }

    $scope.defaultSettingsList = angular.copy($scope.list);
    $scope.defaultSettingstextMedia = angular.copy($scope.textMedia);
    $scope.defaultSettingsmedia = angular.copy($scope.media);

    $scope.settingsDefault = function(){
      if ($scope.yammer.dType == "l") {
        $scope.list = angular.copy({ settings: $scope.defaultSettingsList.settings, ctype: $scope.defaultSettingsList.ctype });
      } else if ($scope.yammer.dType == "t") {
        $scope.textMedia = angular.copy({ settings: $scope.defaultSettingstextMedia.settings, ctype: $scope.defaultSettingstextMedia.ctype });
      } else {
        $scope.media = angular.copy({ settings: $scope.defaultSettingsmedia.settings, ctype: $scope.defaultSettingsmedia.ctype });
      }
      // $scope.yammer.settings = angular.copy($scope.defaultSettings.settings);
      // $scope.yammer.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    
    $scope.dTypeChange = function(caller){
      $scope.yammer.settings = {};
      $scope.yammer.ctype = {};
      if(caller == "l"){
        $scope.yammer.settings = angular.copy($scope.list.settings);
        $scope.yammer.ctype = angular.copy($scope.list.ctype);
      } else if(caller == "t"){
        $scope.yammer.settings = angular.copy($scope.textMedia.settings);
        $scope.yammer.ctype = angular.copy($scope.textMedia.ctype);
      } else {
        $scope.yammer.settings = angular.copy($scope.media.settings);
        $scope.yammer.ctype = angular.copy($scope.media.ctype);
      }
    }
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      YammerSrv.getYammer($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.yammer = data;
          if($scope.yammer.isAuth){
            $scope.networkShow = true;
            $scope.showNetList = true;
            if($scope.yammer.comm){
              $scope.showCommList = true;
            }
          }
          // $scope.networkList = data.networkList;
          // if($scope.networkList && $scope.networkList.length > 0){
          //   $scope.yammer.network = $filter("filter")($scope.networkList, {isSelected:true})[0];
          //   $scope.networkShow = true;
          // }
          if (!data.dType) {
            $scope.yammer.dType = "t"
          }

          if($scope.yammer.dType == "l"){
            $scope.list.settings = angular.copy($scope.yammer.settings);
            $scope.list.ctype = angular.copy($scope.yammer.ctype);
          }
          else if($scope.yammer.dType == "t"){
            $scope.textMedia.settings = angular.copy($scope.yammer.settings);
            $scope.textMedia.ctype = angular.copy($scope.yammer.ctype);
            if(!$scope.yammer.settings.rotationOpt){
              $scope.textMedia.settings.rotationOpt = "a"
              $scope.textMedia.settings.rotate = 12
            }
          }
          else if($scope.yammer.dType == "m"){
            $scope.media.settings = angular.copy($scope.yammer.settings);
            $scope.media.ctype = angular.copy($scope.yammer.ctype);
            if(!$scope.yammer.settings.rotationOpt){
              $scope.media.settings.rotationOpt = "a"
              $scope.media.settings.rotate = 12
            }
          }
          
          // if(!$scope.yammer.ctype){
          //   $scope.yammer.settings = angular.copy($scope.settings.settings);
          //   $scope.yammer.ctype = angular.copy($scope.settings.ctype);
          // } else{
          //   $scope.settings.settings = angular.copy($scope.yammer.settings);
          //   $scope.settings.ctype = angular.copy($scope.yammer.ctype);
          // }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.yammer = {labelOpt:"a", label:"",comm:"",net:"", dType:"t", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings: angular.copy($scope.textMedia.settings),
        ctype: angular.copy($scope.textMedia.ctype)
      }
    }

    // YammerSrv.logoutIn().then(
    //   function(data){
    //   },
    //   function(err){
    //     $log.error(err);
    //   }
    // );

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){}
    }
    $rootScope.selectedTabFx();

    // $scope.openUrlFx = function(w, h){
    //   if($scope.networkShow){
    //     $scope.showNetList = false;
    //     $scope.showCommList = false;
    //     $scope.authSaveDisable = true;
    //     $scope.yammer.net = "";
    //     $scope.yammer.comm = "";
    //     $scope.communityList = [];
    //     $scope.networkList = [];
    //   }
    //   var left = (screen.width/2)-(w/2);
    //   var top = (screen.height/2)-(h/2);
    //   // var newWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);

    //   var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
    //   setTimeout(
    //     function(){
    //       newWindow.close();
    //       $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
    //       $scope.childWindowInt = $interval($scope.checkChild, 500);
    //     }, 2000);
    //   return false;
    // }
    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });
    $scope.openUrlFx = function(w, h, caller){
      if($scope.networkShow){
        $scope.showNetList = false;
        $scope.showCommList = false;
        $scope.authSaveDisable = true;
        $scope.yammer.net = "";
        $scope.yammer.comm = "";
        $scope.communityList = [];
        $scope.networkList = [];
      }
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      //$scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      // if($scope.groupShow){
      if(caller == "ou"){
        var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      if(caller != "at"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(
        function(){
          if(caller != "at"){
            if(caller == "ou"){
              newWindow.close();
            }
            ngDialog.close($scope.confirmDialog);
          }
          $scope.popProcessing = false;
          $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
        return false;
      //$scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'re\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'ou\'">{{"cl.widget.msg.10.2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        YammerSrv.getVerify($scope.yammer.id).then(
          function(data){
            $scope.authProcessing = false;
            $scope.errType = "";
            $scope.hasErr = false;
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
              return;
            }
            if(data.code == 8179){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "networkEmpty";
              //$scope.networkList = [];
              $scope.networkShow = false;
              return;
            } else{
              //$scope.networkList = data.networkList;
              $scope.networkShow = true;
              if(data.isClosed){
                $scope.authSuccess = true;
                $scope.showNetList = true;
                $scope.yammer.isAuth = true;
                $scope.networkList = data.net;
                // $scope.communityList = data.comm;
                // $scope.yammer.community = $filter("filter")($scope.communityList, {full_name:"My Feed"})[0].full_name;
              } else{
                $scope.hasErr = true;
                $scope.authSuccess = false;
                $scope.errType = "authFailed";
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }


    $scope.networkSearchFocus = function () {
      $scope.searchNetwork = { network_name: "" };
      if ($scope.networkList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $rootScope.changeNetworkSetting = function (net) {
      $scope.yammer.net = net
      $scope.showCommLoading = true;
      if($scope.yammer.comm){
        $scope.yammer.comm = ""
        $scope.authSaveDisable = true;
      }
      $scope.getCommunityFX(net)
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }

    $scope.communitySearchFocus = function () {
      $scope.searchCommunity = { full_name: "" };
      if ($scope.communityList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $rootScope.changeCommunitySetting = function (conn) {
      $scope.yammer.comm = conn
      $scope.authSaveDisable = false;
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }


    $scope.getCommunityFX = function(net){
      $scope.getComm = {"id":$scope.yammer.id, "net":net};
      YammerSrv.getCommunity($scope.getComm).then(
        function(data){
          $scope.showCommList = true;
          $scope.communityList = data.comm;
          $scope.showCommLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.showCommList = false;
          $scope.showCommLoading = false;
        }
      );
    }


    $scope.yammerFx = function(tab, caller){
      $scope.yammer.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.yammer.dType == "l"){
          $scope.yammer.settings = angular.copy($scope.list.settings);
          $scope.yammer.ctype = angular.copy($scope.list.ctype);
        } else if($scope.yammer.dType == "t"){
          $scope.yammer.settings = angular.copy($scope.textMedia.settings);
          $scope.yammer.ctype = angular.copy($scope.textMedia.ctype);
        } else if($scope.yammer.dType == "m"){
          $scope.yammer.settings = angular.copy($scope.media.settings);
          $scope.yammer.ctype = angular.copy($scope.media.ctype);
        }

        if($scope.yammer.labelOpt == "c" && $scope.yammer.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
        // }else if ($scope.yammer.channel == "") {
        //   $scope.errType = "channel";
        //   $scope.hasErr = true;
        } else if ($scope.yammer.dType === "l" && $scope.yammer.settings.reloadOpt == 'c' && !$scope.yammer.settings.reload) {
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else if ($scope.yammer.settings.rotationOpt  == 'c' && !$scope.yammer.settings.rotate) {
          $scope.errType = "rotate";
          $scope.hasErr = true;
        } else if ($scope.yammer.dType === "l" && !$scope.yammer.settings.headerSize) {
          $scope.errType = "hSize";
          $scope.hasErr = true;
        } else if ($scope.yammer.dType === "l" && !$scope.yammer.settings.subtitleSize) {
          $scope.errType = "sSize";
          $scope.hasErr = true;
        } else if (($scope.yammer.dType === "l" || $scope.yammer.dType === "t") && !$scope.yammer.settings.titleSize) {
          $scope.errType = "tSize";
          $scope.hasErr = true;
        } else if (($scope.yammer.dType === "l" || $scope.yammer.dType === "t") && !$scope.yammer.settings.descSize) {
          $scope.errType = "dSize";
          $scope.hasErr = true;
        } else if(tab == 1){
          $scope.authSaveDisable = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.yammer.isAuth == 1 && !$scope.yammer.net){
            YammerSrv.getVerify($scope.yammer.id).then(
              function(data){
                $scope.yammer.isAuth = true;
                $scope.networkList = data.net;
              },
              function(err){
                $log.error(err);
              }
            );
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveYammerFx();
              $scope.isPEOpen = false;
            }, 250);
          }
          else{
            $scope.saveYammerFx();
            $scope.isPEOpen = false;
          }
        }
        else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveYammerFx(caller);
            }, 250);
          } else{
            $scope.saveYammerFx(caller);
          }
        }
      }

    }

    $scope.saveYammerFx = function(caller){
      if(caller == "save"){
        $scope.yammer.toast = true;
      } else{
        $scope.yammer.toast = false;
      }
      if(caller == "save" && !$scope.yammer.isAuth){
        $scope.hasErr = true;
        $scope.errType = "authEmpty";
        $scope.saveProcessing = false;
      // }
      // else if(caller == "save" && $scope.networkList.length > 0 && !$scope.yammer.network){
      //   $scope.hasErr = true;
      //   $scope.errType = "network";
      //   $scope.saveProcessing = false;
      }
      else{
        //$scope.yammer.networkList = $scope.networkList;
        YammerSrv.saveYammer($scope.yammer).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.yammer.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
        if($scope.yammer.isAuth && $scope.yammer.net && $scope.yammer.comm){
          YammerSrv.getAuthList($scope.yammer.id, $scope.yammer.net.network_id).then(
            function(data){
              $scope.authSaveDisable = false;
              $scope.networkList = data.net;
              $scope.communityList = data.comm;
            },
            function(err){
              $log.error(err);
              $scope.authSaveDisable = true;
            }
          );
        }
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('XovisController', XovisController);

  /** @ngInject */
  function XovisController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, ngDialog, XovisSrv, ContentLibrarySrv){
    $scope.colorPicker = {ecb:false, cot:false, coct:false, mot:false, moct:false, wb:false, wt:false, wd:false, fb:false, wtl:false, fwt:false, ft:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.search = {text:""};

    $scope.settings = {
      ec:{/*Enter/exit count*/
        bg:"#ffffff", bga:1,
        coText:"#000000", coFont:$scope.fontFamilySelected, coSize:72,
        cocText:"#999999", cocFont:$scope.fontFamilySelected, cocSize:36,
        moText:"#999999", moFont:$scope.fontFamilySelected, moSize:36,
        mocText:"#999999", mocFont:$scope.fontFamilySelected, mocSize:36,
        wbg:"#ffffff", wbga:1,
        wText:"#999999", wFont:$scope.fontFamilySelected, wSize:36,
        wdText:"#999999", wdFont:$scope.fontFamilySelected, wdSize:36
      },
      fd:{/*Fit distance*/
        bg:"#ffffff", bga:1,
        wLabel:"", wTitle:"", logo:"",
        wtText:"#000000", wtFont:$scope.fontFamilySelected, wtSize:72,
        wtlText:"#999999", wtlFont:$scope.fontFamilySelected, wtlSize:36,
        fwtText:"#999999", fwtFont:$scope.fontFamilySelected, fwtSize:36,
        fText:"", ftText:"#999999", ftFont:$scope.fontFamilySelected, ftSize:36
      }
    }
    $scope.ctype = {
      ec:{bg:"monochrome", coText:"monochrome", cocText:"monochrome", moText:"monochrome", mocText:"monochrome", wbg:"monochrome", wText:"monochrome", wdText:"monochrome"},
      fd:{bg:"monochrome", wtText:"monochrome", wtlText:"monochrome", fwtText:"default", ftText:"monochrome"}
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      $scope.xovis.settings = angular.copy($scope.defaultSettings.settings);
      $scope.xovis.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      XovisSrv.getXovis($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.xovis = data;
          $scope.tim = $scope.xovis.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.xovis.info.bucket;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.xovis = {
        label:"", dType:"ec", mo:"", cnType:"s", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        ctype:angular.copy($scope.ctype),
        settings:angular.copy($scope.settings)
      };
    }

    $rootScope.selectedTabFx = function(){
      $scope.saveProcessing = false;
    }
    $rootScope.selectedTabFx();

    $scope.xovisFx = function(tab, caller){
      $scope.xovis.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.selectedT == 1 && (tab == 1 || caller == "save")){
        if($scope.xovis.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.xovis.mo){
          $scope.errType = "eMO";
          $scope.hasErr = true;
          $("#mo").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.coSize){
          $scope.errType = "coSize";
          $scope.hasErr = true;
          $("#coSize").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.cocSize){
          $scope.errType = "cocSize";
          $scope.hasErr = true;
          $("#cocSize").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.moSize){
          $scope.errType = "moSize";
          $scope.hasErr = true;
          $("#moSize").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.mocSize){
          $scope.errType = "mocSize";
          $scope.hasErr = true;
          $("#mocSize").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.wSize){
          $scope.errType = "wSize";
          $scope.hasErr = true;
          $("#wSize").focus();
        } else if($scope.xovis.dType == "ec" && !$scope.xovis.settings.ec.wdSize){
          $scope.errType = "wdSize";
          $scope.hasErr = true;
          $("#wdSize").focus();
        } else if($scope.xovis.dType == "fd" && !$scope.xovis.settings.fd.wTitle){
          $scope.errType = "wTitle";
          $scope.hasErr = true;
          $("#wTitle").focus();
        } else if($scope.xovis.dType == "fd" && !$scope.xovis.settings.fd.wtlSize){
          $scope.errType = "wtlSize";
          $scope.hasErr = true;
          $("#wtlSize").focus();
        } else if($scope.xovis.dType == "fd" && !$scope.xovis.settings.fd.fwtSize){
          $scope.errType = "fwtSize";
          $scope.hasErr = true;
          $("#fwtSize").focus();
        } else if($scope.xovis.dType == "fd" && !$scope.xovis.settings.fd.ftSize){
          $scope.errType = "ftSize";
          $scope.hasErr = true;
          $("#ftSize").focus();
        } else{
          $scope.nextProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveXovisFx(caller);
            }, 250);
          } else{
            $scope.saveXovisFx(caller);
          }
        }
      } else if(tab == 2 || caller == 'save'){
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveXovisFx(caller);
          }, 250);
        } else{
          $scope.saveXovisFx(caller);
        }
      }
    }
    $scope.saveXovisFx = function(caller){
      if(caller == "save"){
        $scope.xovis.toast = true;
      } else{
        $scope.xovis.toast = false;
      }
      if(caller == 'save'){
        $scope.saveProcessing = true;
      }
      XovisSrv.saveXovis($scope.xovis).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.nextProcessing = false;
          $scope.xovis.id = data.id;

          //URL client id decryption
          $scope.rUrl = data.rUrl;
          if(data.rUrl){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.rUrl);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.rUrl = updatedUrl;
              }
            }
          }
          
          if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          } else{
            $scope.tabFx(2, 'tabFx');
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
          $scope.nextProcessing = false;
        }
      );
    }

    /*Warning Image*/
    $scope.logoPopover = {templateUrl:"logo.html"};
    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.search = {text:""};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      $scope.xovis.settings.fd.wLogo = $scope.curContent;
      ngDialog.close();
    }
    $scope.removeImgFx = function(){
      $scope.xovis.settings.fd.wLogo = null;
    }

    $scope.resetOpen = function(){
      ngDialog.open({
        template:'\
        <section class="panel" role="dialog">\
          <div class="panel-body">{{"cl.widget.xovis.m1" | translate}}</div>\
          <footer class="panel-footer">\
            <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="resetOccupancyFx();" focus-me="true" ng-disabled="resetProcessing">\
              <span class="fa fa-repeat fa-spin fa-fw" ng-if="resetProcessing" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
            </button>\
            <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
          </footer>\
        </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.resetOccupancyFx = function(){
      $scope.resetProcessing = true;
      XovisSrv.resetOccupancy($scope.decId).then(
        function(data){
          ngDialog.close();
          $scope.resetProcessing = false;
        },
        function(err){
          $log.error(err);
          ngDialog.close();
          $scope.resetProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WQMetroController', WQMetroController);

  /** @ngInject */
  function WQMetroController($log, $rootScope, $scope, $state, $cookies, $timeout, WQMetroSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, t:false, tc:false, rb:false, arb:false, ct:false, nb:false, nt:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.hText = "";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsT = {header:{hTextOpt:"c", hText:"Average Wait Time", bg:"#990000", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:26}, bg:"#cc0000", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:72, reload:30, environment:"p"};
    $scope.ctypeT = {headerBg:"default", headerText:"monochrome", bg:"default", text:"monochrome"};

    $scope.settingsQ = {
      header:{hTextOpt:"c", hText:"Current Wait Queue", bg:"#0b5394", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:24},
      rowBg:"#f3f3f3", rowBga:1, altBg:"#ffffff", altBga:1, cText:"#073763", cFont:$scope.fontFamilySelected, cSize:24, numberBg:"#3d85c6", numberBga:1, numberText:"#cfe2f3", numberFont:$scope.fontFamilySelected, numberSize:32,
      bg:"#ffffff", bga:1, reload:30, timeText:"#000000"
    };
    $scope.ctypeQ = {headerBg:"default", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", cText:"default", numberBg:"default", numberText:"default", time:"monochrome"};

    $scope.defaultSettingsQ = angular.copy({settings:$scope.settingsQ, ctype:$scope.ctypeQ});
    $scope.defaultSettingsT = angular.copy({settings:$scope.settingsT, ctype:$scope.ctypeT});

    $scope.settingsDefault = function(){
      if($scope.metro.dType == "t"){
        $scope.settingsT = angular.copy($scope.defaultSettingsT.settings);
        $scope.ctypeT = angular.copy($scope.defaultSettingsT.ctype);
      } else{
        $scope.settingsQ = angular.copy($scope.defaultSettingsQ.settings);
        $scope.ctypeQ = angular.copy($scope.defaultSettingsQ.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WQMetroSrv.getMetro($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.metro = data;
          if($scope.metro.dType == "t"){
            $scope.settingsT = angular.copy($scope.metro.settings);
            $scope.ctypeT = angular.copy($scope.metro.ctype);
          } else{
            $scope.settingsQ = angular.copy($scope.settingsQ);
            $scope.ctypeQ = angular.copy($scope.ctypeQ);
          }
          if($scope.metro.dType == "q" || $scope.metro.dType == "b"){
            $scope.settingsQ = angular.copy($scope.metro.settings);
            $scope.ctypeQ = angular.copy($scope.metro.ctype);
          } else{
            $scope.settingsT = angular.copy($scope.settingsT);
            $scope.ctypeT = angular.copy($scope.ctypeT);
          }
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.metro = {label:"", storeId:"", dType:"q", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.metroFx = function(){
      $scope.metro.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.metro.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.metro.storeId == ""){
        $scope.errType = "store";
        $scope.hasErr = true;
        $("#storeId").focus();
      } else if($scope.metro.dType == "q" && $scope.settingsQ.header.hTextOpt == 'c' && $scope.settingsQ.header.hText == ""){
        $scope.errType = "hText";
        $scope.hasErr = true;
        $("#hText").focus();
      } else if($scope.metro.dType == "q" && $scope.settingsQ.header.hTextOpt == 'c' && !$scope.settingsQ.header.size){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#hSize").focus();
      } else if($scope.metro.dType == "t" && $scope.settingsT.header.hTextOpt == 'c' && $scope.settingsT.header.hText == ""){
        $scope.errType = "hText";
        $scope.hasErr = true;
        $("#thText").focus();
      } else if($scope.metro.dType == "t" && $scope.settingsT.header.hTextOpt == 'c' && !$scope.settingsT.header.size){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#thSize").focus();
      } else if($scope.metro.dType == "q" && !$scope.settingsQ.reload){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else if($scope.metro.dType == "q" && !$scope.settingsQ.numberSize){
        $scope.errType = "nSize";
        $scope.hasErr = true;
        $("#nSize").focus();
      } else if($scope.metro.dType == "q" && !$scope.settingsQ.cSize){
        $scope.errType = "cSize";
        $scope.hasErr = true;
        $("#cSize").focus();
      } else if($scope.metro.dType == "t" && !$scope.settingsT.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#tSize").focus();
      } else if($scope.metro.dType == "t" && !$scope.settingsT.reload){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#tReload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveMetroFx();
          }, 250);
        } else{
          $scope.saveMetroFx();
        }
      }
    }
    $scope.saveMetroFx = function(){
      if($scope.metro.dType == "t"){
        $scope.metro.settings = $scope.settingsT;
        $scope.metro.ctype = $scope.ctypeT;
      } else{
        $scope.metro.settings = $scope.settingsQ;
        $scope.metro.ctype = $scope.ctypeQ;
      }
      WQMetroSrv.saveMetro($scope.metro).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WebexController', WebexController);

  /** @ngInject */
  function WebexController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, $interval,ngDialog, WebexSrv){
    $scope.colorPicker = {pb:false, pt:false, htt:false, hst:false, hb:false, ht:false, b:false, rb:false, arb:false, tt:false, dt:false, att:false, adt:false, bc:false, tc:false};
    $scope.postList = [10,20,30,40,50];
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.authSaveDisable = false;
    $scope.authProcessing = false;
    $scope.showTeamsList = false;
    $scope.showSpaceList = false;
    $scope.webexLoading = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.webexList = [];
    $scope.teamsList = [];
    $scope.spaceList = [];
    $scope.searchTeams = {name:""};
    $scope.searchSpace = {name:""};

    // $scope.settings = {
    //   settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#3d85c6", descText:"#444444", rowFont:$scope.fontFamilySelected, altTitleText:"#3d85c6", altDescText:"#444444", altRowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18},
    //   ctype:{headerBg:"monochrome", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome"}
    // }
    // $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsNormal = {settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", profileBg:"#999999", profileBga:1, profileText:"#ffffff", profileFont:$scope.fontFamilySelected, headerBg:"#ffffff", headerBga:1, hTitleText:"#444444", hTitleFont:$scope.fontFamilySelected, hSubTitleText:"#444444", hSubTitleFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#3d85c6", descText:"#444444", rowFont:$scope.fontFamilySelected, altTitleText:"#3d85c6", altDescText:"#444444", altRowFont:$scope.fontFamilySelected, titleSize:24, descSize:18, profileSize:24, hTitleSize:24, hSubTitleSize:20},
    ctype:{profileBg:"monochrome", profileText:"monochrome", headerBg:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome"}};
    $scope.settingsCrawl = {settings:{speed:100, bg:"#000000", bga:1, bullet:"#990000", titleText:"#ffffff", font:$scope.fontFamilySelected, dir:"rl", align:"l", fontSizeOpt:"a", fontSize:16},
    ctype:{bg:"monochrome", bullet:"default", titleText:"monochrome"}};

    $scope.defaultNormal = angular.copy($scope.settingsNormal);
    $scope.defaultCrawl = angular.copy($scope.settingsCrawl);

    $scope.settingsDefault = function(){
      // RC
      // $scope.webex.settings = angular.copy($scope.defaultSettings.settings);
      // $scope.webex.ctype = angular.copy($scope.defaultSettings.ctype);
      // Dev
      if($scope.webex.dType == "normal"){
        $scope.webex.settings = angular.copy($scope.defaultNormal.settings);
        $scope.webex.ctype = angular.copy($scope.defaultNormal.ctype);
      } else if($scope.webex.dType == "crawl"){
        $scope.webex.settings = angular.copy($scope.defaultCrawl.settings);
        $scope.webex.ctype = angular.copy($scope.defaultCrawl.ctype);
      }
    }

    $scope.changeDType = function(caller){
      $scope.webex.settings = {};
      $scope.webex.ctype = {};
      if(caller == "normal"){
        $scope.webex.settings = angular.copy($scope.settingsNormal.settings);
        $scope.webex.ctype = angular.copy($scope.settingsNormal.ctype);
      } else if(caller == "crawl"){
        $scope.webex.settings = angular.copy($scope.settingsCrawl.settings);
        $scope.webex.ctype = angular.copy($scope.settingsCrawl.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WebexSrv.getWebexDetails($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.webex = data.data;
          $scope.webex.settings = data.data.settings;
          $scope.webex.ctype = data.data.ctype;
          if($scope.webex.isAuth){
            $scope.teamsShow = true;
            $scope.showTeamsList = true;
            if($scope.webex.space){
              $scope.showSpaceList = true;
            }
          }
          if(!$scope.webex.dType || $scope.webex.dType == ""){
            $scope.webex.dType = "normal";
          }
          // Dev
          if($scope.webex.dType == "normal"){
            $scope.settingsNormal.settings = angular.copy($scope.webex.settings);
            $scope.settingsNormal.ctype = angular.copy($scope.webex.ctype);
          } else if($scope.webex.dType == "crawl"){
            if(!$scope.webex.settings.fontSizeOpt){
              $scope.webex.settings.fontSizeOpt = "a";
              $scope.webex.settings.dir = "rl";
              $scope.webex.settings.fontSize = 16;
              $scope.webex.settings.align = "l";
            }
            $scope.settingsCrawl.settings = angular.copy($scope.webex.settings);
            $scope.settingsCrawl.ctype = angular.copy($scope.webex.ctype);
          }
          $scope.dTypeCopy = angular.copy($scope.webex.dType);
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.webex = {labelOpt:"a", label:"",dType:"normal", space:"",teams:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        //RC
        // settings: angular.copy($scope.settings.settings),
        // ctype: angular.copy($scope.settings.ctype)
        // Dev
        settings:angular.copy($scope.settingsNormal.settings),
        ctype:angular.copy($scope.settingsNormal.ctype),
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){}
    }
    $rootScope.selectedTabFx();


    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });
    $scope.openUrlFx = function(w, h, caller){
      if($scope.teamsShow){
        $scope.showTeamsList = false;
        $scope.showSpaceList = false;
        $scope.authSaveDisable = true;
        $scope.webex.teams = "";
        $scope.webex.channel = "";
        $scope.webexList = [];
        $scope.teamsList = [];
        $scope.spaceList = [];
      }
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "ou"){
        var newWindow = window;
      }
      if(caller != "at"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(
        function(){
          if(caller != "at"){
            if(caller == "ou"){
              newWindow.close();
            }
            ngDialog.close($scope.confirmDialog);
          }
          $scope.popProcessing = false;
          $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
      return false;
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template: '\
          <section class="panel">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'re\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'ou\'">{{"cl.widget.webex.m4" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
            <button type="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        WebexSrv.getVerify($scope.webex.id).then(
          function(data){
            $scope.authProcessing = false;
            $scope.errType = "";
            $scope.hasErr = false;
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
              return;
            }
            if(data.code == 8179){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "teamsEmpty";
              $scope.teamsShow = false;
              return;
            } else{
              $scope.teamsShow = true;
              if(data.isClosed=="1" || data.isClosed){
                $scope.authSuccess = true;
                $scope.showTeamsList = true;
                $scope.webex.isAuth = true;
                $scope.webex.teams = "";
                $scope.teamsList = data.teams;
              } else{
                $scope.hasErr = true;
                $scope.authSuccess = false;
                $scope.errType = "authFailed";
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.teamsSearchFocus = function () {
      $scope.searchTeams = {name:""};
      if ($scope.teamsList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }
    $scope.spaceSearchFocus = function () {
      $scope.searchSpace = {name:""};
      if ($scope.spaceList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }
    $scope.ss = {isOpen:false};
    $rootScope.selTeamsFx = function (team) {
      $scope.webex.teams = team;
      $scope.ss.isOpen = !$scope.ss.isOpen;
      $scope.webexLoading = true;
      if($scope.webex.space){
        $scope.webex.space = "";
        $scope.authSaveDisable = true;
      }
      $scope.getSpaceList(team)
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }
    $scope.toggleCallback= function(open){
      $scope.searchTeams.name = "";
      $scope.searchSpace.name = "";
    }

    // $scope.webexSearchFocus = function () {
    //   $scope.searchSpace = {name:""};
    //   if ($scope.webexList.length > 5) {
    //     angular.element(document).find(".findSearch").children()[0].focus();
    //   }
    // }
    $scope.sp = {isOpen:false};
    $rootScope.selSpaceFx = function (space) {
      $scope.webex.space = space;
      $scope.authSaveDisable = false;
      $scope.sp.isOpen = !$scope.sp.isOpen;
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }


    $scope.getSpaceList = function(team){
      $scope.spaceLoading = true;
      $scope.spaceObj = {"id":$scope.webex.id, "team":team};
      WebexSrv.getSpaces($scope.spaceObj).then(
        function(data){
          $scope.showSpaceList = true;
          $scope.spaceLoading = false;
          $scope.spaceList = data.space;
          $scope.webexLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.showSpaceList = false;
          $scope.webexLoading = false;
        }
      );
    }


    $scope.webexFx = function(tab, caller){
      $scope.webex.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.webex.labelOpt == "c" && $scope.webex.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
        }else if ($scope.selectedT == 2 && $scope.webex.space && $scope.webex.space == "") {
          $scope.errType = "space";
          $scope.hasErr = true;
        } else if ($scope.webex.dType === "l" && $scope.webex.settings.reloadOpt == 'c' && !$scope.webex.settings.reload) {
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else if ($scope.webex.settings.rotationOpt  == 'c' && !$scope.webex.settings.rotate) {
          $scope.errType = "rotate";
          $scope.hasErr = true;
        } else if($scope.webex.dType == "crawl" && $scope.webex.settings.speed == null){
          $scope.errType = "crawl";
          $scope.hasErr = true;
          $("#speed").focus();
        } else if($scope.webex.dType === "crawl" && ($scope.webex.settings.dir == "rl" || $scope.webex.settings.fontSizeOpt == "c") && $scope.webex.settings.fontSize == null){
          $scope.errType = "fSizeText";
          $scope.hasErr = true;
          $("#rlFontSize").focus();
        } else if($scope.webex.dType === "crawl" && $scope.webex.settings.dir == "bt" && $scope.webex.settings.fontSize == null){
          $scope.errType = "fSizeText";
          $scope.hasErr = true;
          $("#btFontSize").focus();
        } else if($scope.webex.dType == 'normal' && !$scope.webex.settings.profileSize){
          $scope.errType = "pSize";
          $scope.hasErr = true;
          $("#profileSize").focus();
        } else if($scope.webex.dType == 'normal' && $scope.webex.settings.hTextOpt != "n" && !$scope.webex.settings.hTitleSize){
          $scope.errType = "htSize";
          $scope.hasErr = true;
          $("#hTitleSize").focus();
        } else if($scope.webex.dType == 'normal' && $scope.webex.settings.hTextOpt != "n" && !$scope.webex.settings.hSubTitleSize){
          $scope.errType = "hstSize";
          $scope.hasErr = true;
          $("#hSubTitleSize").focus();
        }
        // else if($scope.webex.dType == 'normal' && $scope.webex.settings.hTextOpt != "n" && !$scope.webex.settings.headerSize){
        //   $scope.errType = "hSize";
        //   $scope.hasErr = true;
        //   $("#headerSize").focus();
        // }
        else if($scope.webex.dType == 'normal' && !$scope.webex.settings.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#titleSize").focus();
        } else if($scope.webex.dType == 'normal' && !$scope.webex.settings.descSize){
          $scope.errType = "dSize";
          $scope.hasErr = true;
          $("#descSize").focus();
        } else if($scope.webex.dType == 'normal' && $scope.webex.settings.hTextOpt == "c" && $scope.webex.settings.hText == ""){
          $scope.errType = "hText";
          $scope.hasErr = true;
          $("#hText").focus();
        } else if(tab == 1){
          $scope.authSaveDisable = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.webex.isAuth && !$scope.webex.teams){
            WebexSrv.getVerify($scope.webex.id).then(
              function(data){
                $scope.webex.isAuth = true;
                $scope.teamsList = data.teams;
              },
              function(err){
                $log.error(err);
              }
            );
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveWebexFx();
              $scope.isPEOpen = false;
            }, 250);
          }
          else{
            $scope.saveWebexFx();
            $scope.isPEOpen = false;
          }
        }
        else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveWebexFx(tab, caller);
            }, 250);
          } else{
            $scope.saveWebexFx(tab, caller);
          }
        }
      }

    }

    $scope.saveWebexFx = function(tab, caller){
      if(caller == "save"){
        $scope.webex.toast = true;
      } else{
        $scope.webex.toast = false;
      }
      if(caller == "save" && !$scope.webex.isAuth){
        $scope.hasErr = true;
        $scope.errType = "authEmpty";
        $scope.saveProcessing = false;
      }
      else{
        WebexSrv.saveWebex($scope.webex).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.webex.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(data.code == 86401){
              $scope.errType = "invalid";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
        if($scope.webex.isAuth && $scope.webex.teams && $scope.webex.space && caller != 'save'){
          WebexSrv.getAuthList($scope.webex.id, $scope.webex.teams.id).then(
            function(data){
              $scope.authSaveDisable = false;
              $scope.teamsList = data.teams;
              $scope.spaceList = data.space;
            },
            function(err){
              $log.error(err);
              $scope.authSaveDisable = true;
            }
          );
        }
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WebPageController', WebPageController);

  /** @ngInject */
  function WebPageController($log, $rootScope, $scope, $state, $cookies, $timeout, ngDialog, ContentLibrarySrv, WebPageSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.timestamp = moment().format('x');
    $scope.colorPicker = {b:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.search = {text:""};
    $scope.curBtnCaller = "";
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      reloadOpt:"n", reload:"", scroll:false, x:0, y:0, container:"if",
      clickable:{a:false,t:"fs"},bg:"#000000", bga:1, //fImg: ""
      ctype:{bg:"monochrome"}
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings)};

    $scope.settingsDefault = function(){
      $scope.webPage.fImg= "";
      $scope.webPage.settings = angular.copy($scope.defaultSettings.settings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WebPageSrv.getWebPage($scope.decId).then(
        function(data){
          $scope.webPage = data;
          $scope.tim = $scope.webPage.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.webPage.otherinfo.bucket;
          if($scope.webPage.otherinfo.mbucket && $scope.webPage.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.webPage.otherinfo.mbucket;
          }
          if(!$scope.webPage.settings.container){
            $scope.webPage.settings.container = "if";
          }
          if(!$scope.webPage.settings.clickable){
            $scope.webPage.settings.clickable = {a:false,t:"fs"};
          }
          if($scope.webPage.settings.clickable.a == false){
            $scope.webPage.fImg = "";
          }
          if(!$scope.webPage.settings.bg){
            $scope.webPage.settings.bg = "#000000";
            $scope.webPage.settings.bga = 1;
            $scope.webPage.settings.ctype = {bg:"monochrome"};
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.webPage = {label:"",url:"",fImg:"",ssType:"d",clImg:"",activePeriod:{type:"a"},permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings),ctype:angular.copy($scope.ctype)
      };
    }

    $scope.webPageFx = function(){
      $scope.webPage.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.webPage.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.webPage.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.webPage.ssType == 's' && $scope.webPage.clImg == ""){
        $scope.errType = "clImg";
        $scope.hasErr = true;
      } else if($scope.webPage.settings.clickable.a && $scope.webPage.fImg == ""){
        $scope.errType = "fImg";
        $scope.hasErr = true;
      } else if($scope.webPage.settings.reloadOpt == "c" && ($scope.webPage.settings.reload == "" || $scope.webPage.settings.reload == null)){
        $scope.errType = "reloadEmpty";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.webPage.settings.reload && $scope.webPage.settings.reload < 10){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.webPage.settings.x && $scope.webPage.settings.x < 0){
        $scope.errType = "left";
        $scope.hasErr = true;
        $("#left").focus();
      } else if($scope.webPage.settings.y && $scope.webPage.settings.y < 0){
        $scope.errType = "top";
        $scope.hasErr = true;
        $("#top").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveWebPageFx();
          }, 250);
        } else{
          $scope.saveWebPageFx();
        }
      }
    }
    $scope.saveWebPageFx = function(){
      $scope.saveProcessing = true;
      $scope.webPage.settings.x = !$scope.webPage.settings.x ? 0 : $scope.webPage.settings.x;
      $scope.webPage.settings.y = !$scope.webPage.settings.y ? 0 : $scope.webPage.settings.y;
      WebPageSrv.saveWebPage($scope.webPage).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.updateList = function(){
      // console.warn($scope.contentLibrary);
      $scope.timestamp = moment().format('x');
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      if($scope.contentLibrary.info.timthumb){
        $scope.tim = $scope.contentLibrary.info.timthumb;
      }
      if($scope.contentLibrary.info.thumbSize){
        $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      }
      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.info.bucket){
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      }
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(caller){
      $scope.timestamp = moment().format('x');
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curBtnCaller = caller;
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.curBg = "";
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.flId = fId;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $scope.timestamp = moment().format('x');
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      $scope.timestamp = moment().format('x');
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.curBtnCaller == "t"){
          $scope.webPage.clImg = $scope.curBg;
          $scope.webPage.isHidden = 0;
        } else{
          $scope.webPage.fImg = $scope.curBg;
          $scope.webPage.isHidden = 0;
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "t"){
        $scope.webPage.clImg = "";
      } else if(caller == "f"){
        $scope.webPage.fImg = "";
      }
    }
    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $scope.searchText = "";
      $scope.folderList = [];
      $scope.contentList = [];
      $scope.search = {text:""};
      $rootScope.selectedItems = [];
      $scope.folderList = args.folder;
      $scope.advSearchInfo = args.info;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;
      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WebLoginChromeController', WebLoginChromeController);

  /** @ngInject */
  function WebLoginChromeController($log, $rootScope, $scope, $state, $cookies, $timeout, WebLoginChromeSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {reloadOpt:"n", reload:""};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.webLogin.settings.reloadOpt = angular.copy($scope.defaultSettings.reloadOpt);
      $scope.webLogin.settings.reload = angular.copy($scope.defaultSettings.reload);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WebLoginChromeSrv.getWebLoginChrome($scope.decId).then(
        function(data){
          $scope.webLogin = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.webLogin = {label:"", url:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:{uVal:"", uType:"id", uId:"", pVal:"", pType:"id", pId:"", submitType:"id", submitId:"", delay:5, redirect:"", reloadOpt:"n", reload:""}
      };
    }

    $scope.webLoginFx = function(){
      $scope.webLogin.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      
      if($scope.webLogin.label != "" && $scope.webLogin.url != "" && $scope.webLogin.settings.uVal != "" && $scope.webLogin.settings.uId != "" && $scope.webLogin.settings.pVal != "" && $scope.webLogin.settings.pId != "" && $scope.webLogin.settings.submitId != "" && $scope.webLogin.settings.delay != "" && $scope.webLogin.settings.delay != null){
        if($scope.webLogin.settings.reloadOpt == "c" && ($scope.webLogin.settings.reload == "" || $scope.webLogin.settings.reload == null)){
          $scope.errType = "reload";
          $scope.hasErr = true;
          $("#reload").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveWebLoginFx();
            }, 250);
          } else{
            $scope.saveWebLoginFx();
          }
        }
      } else{
        $scope.errType = "allFields";
        $scope.hasErr = true;
        if($scope.webLogin.label == ""){
          $("#label").focus();
        } else if($scope.webLogin.url == ""){
          $("#url").focus();
        } else if($scope.webLogin.settings.uVal == ""){
          $("#uVal").focus();
        } else if($scope.webLogin.settings.uId == ""){
          $("#uId").focus();
        } else if($scope.webLogin.settings.pVal == ""){
          $("#pVal").focus();
        } else if($scope.webLogin.settings.pId == ""){
          $("#pId").focus();
        } else if($scope.webLogin.settings.delay == ""){
          $("#delay").focus();
        } else if($scope.webLogin.settings.submitId == ""){
          $("#submitId").focus();
        } else if($scope.webLogin.settings.redirect == ""){
          $("#redirect").focus();
        }
      }
    }

    $scope.saveWebLoginFx = function(){
      $scope.saveProcessing = true;
      WebLoginChromeSrv.saveWebLoginChrome($scope.webLogin).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WebLoginController', WebLoginController);

  /** @ngInject */
  function WebLoginController($log, $rootScope, $scope, $state, $cookies, $timeout, WebLoginSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {reloadOpt:"n", reload:""};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.webLogin.settings.reloadOpt = angular.copy($scope.defaultSettings.reloadOpt);
      $scope.webLogin.settings.reload = angular.copy($scope.defaultSettings.reload);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WebLoginSrv.getWebLogin($scope.decId).then(
        function(data){
          $scope.webLogin = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.webLogin = {
        label:"", url:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:{uVal:"", uType:"id", uId:"", pVal:"", pType:"id", pId:"", submitType:"id", submitId:"", delay:5, redirect:"", reloadOpt:"n", reload:""}
      };
    }

    $scope.webLoginFx = function(){
      $scope.webLogin.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.webLogin.label != "" && $scope.webLogin.url != "" && $scope.webLogin.settings.uVal != "" && $scope.webLogin.settings.uId != "" && $scope.webLogin.settings.pVal != "" && $scope.webLogin.settings.pId != "" && $scope.webLogin.settings.submitId != "" && $scope.webLogin.settings.delay != "" && $scope.webLogin.settings.delay != null){
        if($scope.webLogin.settings.reloadOpt == "c" && ($scope.webLogin.settings.reload == "" || $scope.webLogin.settings.reload == null)){
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveWebLoginFx();
            }, 250);
          } else{
            $scope.saveWebLoginFx();
          }
        }
      } else{
        $scope.errType = "allFields";
        $scope.hasErr = true;
      }
    }

    $scope.saveWebLoginFx = function(){
      $scope.saveProcessing = true;
      WebLoginSrv.saveWebLogin($scope.webLogin).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WebCamController', WebCamController);

  /** @ngInject */
  function WebCamController($log, $rootScope, $scope, $state, $cookies, $timeout, WebCamSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {fps:30, index:0, quality:100, fill:false};
    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.webCam.settings = angular.copy($scope.defaultSettings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WebCamSrv.getWebCam($scope.decId).then(
        function(data){
          $scope.webCam = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.webCam = {label:"", settings:angular.copy($scope.settings), activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.webCamFx = function(){
      $scope.webCam.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.webCam.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.webCam.settings.fps == null){
        $scope.errType = "all";
        $scope.hasErr = true;
        $("#fps").focus();
      } else if($scope.webCam.settings.quality > 100){
        $scope.errType = "quality";
        $scope.hasErr = true;
      } else if($scope.webCam.settings.quality == null){
        $scope.errType = "all";
        $scope.hasErr = true;
        $("#quality").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveWebCamFx();
          }, 250);
        } else{
          $scope.saveWebCamFx();
        }
      }
    }
    $scope.saveWebCamFx = function(){
      WebCamSrv.saveWebCam($scope.webCam).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WeatherController', WeatherController);

  /** @ngInject */
  function WeatherController($log, $rootScope, $scope, $state, $http, $cookies, $timeout, WeatherSrv){
    $scope.colorPicker = {c:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.curTS = moment().format('x');

    $scope.settingsTemp1 = {settings:{tint:"#ffffff", font:$scope.fontFamilySelected}, ctype:{tint:"monochrome"}};
    $scope.settingsTemp2n3 = {settings:{tint:"#3d85c6", font:$scope.fontFamilySelected}, ctype:{tint:"default"}};
    $scope.defaultSettings = angular.copy($scope.settingsTemp1);

    $scope.settingsDefault = function(){
      if($scope.weather.forecast == "0"){
        $scope.defaultSettings = angular.copy($scope.settingsTemp1);
      } else{
        $scope.defaultSettings = angular.copy($scope.settingsTemp2n3);
      }
      $scope.weather.settings.tint = angular.copy($scope.defaultSettings.settings.tint);
      $scope.weather.settings.font = angular.copy($scope.defaultSettings.settings.font);
      $scope.weather.ctype.tint = angular.copy($scope.defaultSettings.ctype.tint);
      $scope.weather.settings.wsu = "kh";
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WeatherSrv.getWeather($scope.decId).then(
        function(data){
          $scope.weather = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.weather = {
        forecast:"0", labelOpt:"a", label:"", cityOpt:"c", city:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:{template:"t1", tint:"#ffffff", lang:"en_US", font:$scope.fontFamilySelected, unit:"c", imgType:"static", imgSubType:"plain", orientation:"h", wsu:"kh"},
        ctype:{tint:"monochrome"}
      };
    }
    $scope.ratio = "2:1";
    $scope.typeFx = function(caller){
      if($scope.weather.forecast == '0'){
        $scope.ratio = "2:1";
      } else if($scope.weather.forecast == '1'){
        if($scope.weather.settings.orientation == "h"){
          $scope.ratio = "5:1";
        } else{
          $scope.ratio = "1:5";
        }
      } else if($scope.weather.forecast == '2'){
        if($scope.weather.settings.orientation == "h"){
          $scope.ratio = "3:1";
        } else{
          $scope.ratio = "1:6";
        }
      }
      if(caller == "f"){
        if($scope.weather.forecast == "0"){
          $scope.defaultSettings = angular.copy($scope.settingsTemp1);
        } else{
          $scope.defaultSettings = angular.copy($scope.settingsTemp2n3);
        }
        $scope.weather.settings.tint = angular.copy($scope.defaultSettings.settings.tint);
        $scope.weather.settings.font = angular.copy($scope.defaultSettings.settings.font);
        $scope.weather.ctype.tint = angular.copy($scope.defaultSettings.ctype.tint);
      }
    }

    /*Get weather City*/
    $scope.getLocation = function(val){
      if($scope.weather.city.length >= 3){
        return $http.get($rootScope.apiHost + 'contentLibrary/widgets/weather/city/' + val).then(function(response){
          if(response.data && response.data != undefined && response.data !== null){
            return response.data.map(function(value){
              var country = "";
              if(value.country !== null && value.country !== undefined){
                country = value.country;
              }
              return {
                woeid:value.woeid,
                label:value.name + ", " + country
              };
            });
          }
        });
      }
    };

    $scope.imgTypeFx = function(){
      if($scope.weather.settings.imgType == "static"){
        $scope.weather.settings.imgSubType = "plain";
      } else{
        $scope.weather.settings.imgSubType = "outline";
      }
    }

    $scope.weatherFx = function(tab, caller){
      $scope.weather.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || caller == "save"){
        if($scope.weather.labelOpt == "c" && $scope.weather.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.weather.cityOpt == "c" && !$scope.weather.city.woeid || $scope.weather.city.woeid == ""){
          $scope.errType = "woeid";
          $scope.hasErr = true;
          $("#weatherCity").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
            }, 50);
          } else if(caller == "save"){
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveWeatherFx();
              }, 250);
            } else{
              $scope.saveWeatherFx();
            }
          }
        }
      }
    }

    $scope.saveWeatherFx = function(){
      WeatherSrv.saveWeather($scope.weather).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $rootScope.selectedTabFx = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('VimeoController', VimeoController);

  /** @ngInject */
  function VimeoController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, VimeoSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      VimeoSrv.getVimeo($scope.decId).then(
        function(data){
          $scope.vimeo = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.vimeo = {labelOpt:"a", label:"", playlistId:"", settings:{cc:false}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.vimeoFx = function(){
      $scope.vimeo.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.vimeo.labelOpt=='c' && $scope.vimeo.label==""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.vimeo.playlistId==""){
        $scope.errType = "id";
        $scope.hasErr = true;
        $("#playListId").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveVimeoFx();
          }, 250);
        } else{
          $scope.saveVimeoFx();
        }
      }
    }
    $scope.saveVimeoFx = function(){
      VimeoSrv.saveVimeo($scope.vimeo).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 8202){
            $scope.errType = "invalid-id";
            $scope.hasErr = true;
          } else if(data.code == 8200 || data.code == 8201){
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('hub')
    .controller('VarkadaController', VarkadaController);

  /** @ngInject */
  function VarkadaController($log, $rootScope, $scope, $state, $timeout, VerkadaSrv) {
    $scope.fid = localStorage.getItem("curFId");
    $scope.detailLoading = true;
    $scope.saveProcessing = false;
    $scope.isPEOpen = false;
    $scope.allCameraLoaded = false;
    $scope.cameraListLoading = true;
    $scope.cameraThumbLoading = false;
    $scope.camera = {};
    $scope.cameraList = []
    $scope.thumbSrc = ""
    $scope.cs = { isOpen: false }
    $scope.searchCamera = { searchText: "" };
    $scope.encId = "";
    $scope.decId = "";
    $scope.isSearching = false;
    $scope.searchIndex = 0
    $scope.settings = {
      settings: {
        resolutioOpt: "low_res", // 
        streamingOpt: "l", // l: Live, h: Historical
        bg: "#fff2cc",
        bga: 1,
        pt: 1,
        st: 0,
        et: 0
      },
      ctype: {
        bg: "default",
        toLabel: "monochrome",
        toTxt: "monochrome",
        fLabel: "monochrome",
        fTxt: "monochrome",
        mSize: "monochrome",
        dmTxt: "monochrome",
        jdTxt: "monochrome"
      }
    }
    $scope.custTime = moment().set('minute', '00').utc().format();
    $scope.defaulttimeSetting = {
      start_time: $scope.custTime,
      end_time: $scope.custTime,
      date: { startDate: moment()._d, endDate: moment()._d },
    }

    // format maxDate as YYYY-MM-DD string
    $scope.maxDate = moment().format("YYYY-MM-DD");

    $scope.timeRangeSetting = angular.copy($scope.defaulttimeSetting);
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function () {
      $scope.wData.settings = angular.copy($scope.defaultSettings.settings);
      $scope.timeRangeSetting = angular.copy($scope.defaulttimeSetting);
    }

    $scope.getCameraList = function () {
      $scope.detailLoading = false
      VerkadaSrv.getVerkadaCameraList($scope.stIndex).then(
        function (data) {
          $scope.cameraListLoading = false
          if (data.code == 8336 && data.next_index !== null) {
            $scope.stIndex = data.next_index
            $scope.cameraList = data.cameras;
          }
        }
      )
        .catch(function (e) {
          if (e == "Verkada settings are not configured for the server.") {
            $scope.cameraListLoading = false
          }
        })
    }

    $scope.refineEpochToDateTime = function (streamingOpt, startTime, endTime) {
      if (streamingOpt == "h") {
        // Convert epoch seconds to moment objects
        var stEpoch = moment(startTime * 1000);
        var etEpoch = moment(endTime * 1000);
        // Keep JS Date objects for the calendar/datepicker
        $scope.timeRangeSetting.date.startDate = stEpoch.toDate();
        $scope.timeRangeSetting.date.endDate = etEpoch.toDate();

        // Use ISO string with timezone for start_time and end_time
        $scope.timeRangeSetting.start_time = stEpoch.toISOString();
        $scope.timeRangeSetting.end_time = etEpoch.toISOString();
      }
    };

    $scope.refinecameraobject = function () {
      $scope.camera = {}
      var camKey = Object.keys($scope.wData.camera)
      for (var i = 0; i < camKey.length; i++) {
        if (camKey[i] != "cam_id" && camKey[i] != "site_id") {
          switch (camKey[i]) {
            case "name":
              $scope.camera[camKey[i]] = {
                "v": $scope.wData.camera[camKey[i]],
                "t": "cm.brief.1" || camKey[i]
              }
              break;
            case "site":
              $scope.camera[camKey[i]] = {
                "v": $scope.wData.camera[camKey[i]],
                "t": "cl.widget.verkada.9" || camKey[i]
              }
              break;
            case "status":
              $scope.camera[camKey[i]] = {
                "v": $scope.wData.camera[camKey[i]],
                "t": "cm.label.46" || camKey[i]
              }
              break;
            case "location":
              $scope.camera[camKey[i]] = {
                "v": $scope.wData.camera[camKey[i]],
                "t": "cl.widget.qr.11.3" || camKey[i]
              }
              break;
            default:
              $scope.camera[camKey[i]] = {
                "v": $scope.wData.camera[camKey[i]],
                "t": camKey[i]
              }
              break;
          }
        }
      }
    }

    if ($state.params.id) {
      $scope.detailLoading = false
      $scope.cameraListLoading = true
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.stIndex = 0
      VerkadaSrv.getVerkada($scope.decId).then(
        function (data) {

          $scope.refineEpochToDateTime(data.settings.streamingOpt, data.settings.st, data.settings.et)
          $scope.wData = data;
          $scope.cameraThumbFx()
          $scope.getCameraList()
          $scope.refinecameraobject()
        }
      )
    } else {
      $rootScope.tabView = true;
      $scope.stIndex = 0
      $scope.wData = {
        camera: {
          "cam_id": "",
          "location": "",
          "name": "",
          "site": "",
          "site_id": "",
          "status": null
        },
        label: null,
        labelOpt: "a",
        activePeriod: { type: "a" },
        permission: { type: $scope.auth.upreferences.defaultP },
        settings: angular.copy($scope.settings.settings)
      };
      $scope.getCameraList()
    }

    // selected date time range to epoch
    $scope.refineStartEndTimeToEpoch = function () {
      if (!$scope.wData || !$scope.timeRangeSetting.date || !$scope.timeRangeSetting.start_time || !$scope.timeRangeSetting.end_time) {
        return null; // guard clause
      }

      try {
        // Extract date range
        var startDate = moment($scope.timeRangeSetting.date.startDate);
        var endDate = moment($scope.timeRangeSetting.date.endDate);

        // Merge date with time
        var startDateTime = moment(startDate)
          .set({
            hour: moment($scope.timeRangeSetting.start_time).hour(),
            minute: moment($scope.timeRangeSetting.start_time).minute(),
            second: 0,
            millisecond: 0
          })
          .utc(); // convert to UTC

        var endDateTime = moment(endDate)
          .set({
            hour: moment($scope.timeRangeSetting.end_time).hour(),
            minute: moment($scope.timeRangeSetting.end_time).minute(),
            second: 0,
            millisecond: 0
          })
          .utc(); // convert to UTC

        // Return both ISO strings & epoch seconds
        return {
          startLocal: startDateTime.local().format('MM/DD/YYYY'),
          endLocal: endDateTime.local().format('MM/DD/YYYY'),
          startEpoch: startDateTime.unix(),
          endEpoch: endDateTime.unix()
        };

      } catch (e) {
        console.error("Error refining start/end time:", e);
        return null;
      }
    };

    $scope.setStreamingOpt = function () {
      if ($scope.wData.camera.status != 1) {
        $scope.wData.settings.streamingOpt = "h"
      }
      else if ($scope.wData.camera.status == 1) {
        $scope.wData.settings.streamingOpt = "l"
      }
    }

    $scope.cameraThumbFx = function () {
      $scope.wData.camera = angular.fromJson($scope.wData.camera);
      $scope.cameraThumbLoading = true
      $scope.thumbSrc = ""
      VerkadaSrv.getVerkadaCameraTumb($scope.wData.camera.cam_id).then(
        function (data) {
          if (data.code == "8338" && $scope.wData.camera.cam_id == data.camera_id) {
            $scope.thumbSrc = data.thumb
          } else {
            console.warn(data.desc + " | camera " + $scope.wData.camera.name + " id: " + data.camera_id)
          }
          $scope.cameraThumbLoading = false
        }
      )
    }

    $scope.loadMoreCameras = function () {

      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;

      if ($scope.searchCamera.searchText.length > 0) {

        var text = $scope.searchCamera.searchText
        $scope.stIndex = $scope.searchIndex
        if ($scope.stIndex !== null && !$scope.isSearching) {
          $scope.isSearching = true;
          $scope.cameraListLoading = true;
          $scope.allCameraLoaded = false;
          VerkadaSrv.getSearchVerkadaCameraList($scope.stIndex, text).then(
            function (data) {
              $scope.cameraListLoading = false;
              if (data.code == 8336 && data.next_index !== null) {
                $scope.searchIndex = data.next_index;
                $scope.cameraList = $scope.cameraList.concat(data.cameras);
              } else {
                $scope.searchIndex = null;
                $scope.cameraList = $scope.cameraList.concat(data.cameras);
                $scope.allCameraLoaded = true;
              }
              $scope.isSearching = false;
              setTimeout(function () {
                $scope.$apply();
              });
            },
            function (err) {
              $scope.cameraListLoading = false;
              $log.error(err);
            }
          )
        }

      }
      else if (!$scope.allCameraLoaded && !$scope.cameraListLoading) {
        $scope.cameraListLoading = true
        if ($scope.stIndex !== null) {
          VerkadaSrv.getVerkadaCameraList($scope.stIndex).then(
            function (data) {
              $scope.cameraListLoading = false;
              if (data.code == 8336 && data.next_index != null) {
                $scope.stIndex = data.next_index;
                $scope.cameraList = $scope.cameraList.concat(data.cameras);
              } else if (data.code == 8336 && data.next_index == null) {
                $scope.stIndex = null;
                $scope.cameraList = $scope.cameraList.concat(data.cameras);
                $scope.allCameraLoaded = true;
              }
              $scope.isSearching = false;
            },
            function (err) {
              $scope.cameraListLoading = false;
              $log.error(err);
            }
          );
        } else {
          $scope.cameraListLoading = false
        }
      }
    }

    $scope.searchFrmCameraList = function (val) {
      var text = val.toLowerCase()
      VerkadaSrv.cleanup()
      $scope.isSearching = true;
      if ($scope.searchTimeout) {
        $timeout.cancel($scope.searchTimeout);
      }
      $scope.searchTimeout = $timeout(function () {
        var text = val.toLowerCase();
        if (!text) {
          $scope.cameraList = []
          $scope.stIndex = 0
          $scope.cameraListLoading = false;
          $scope.allCameraLoaded = false;
          $scope.loadMoreCameras()
        }
        else if (text && text.length > 0) {
          $scope.searchIndex = 0
          $scope.cameraListLoading = true;
          $scope.allCameraLoaded = false;
          $scope.cameraList = []
          VerkadaSrv.getSearchVerkadaCameraList($scope.searchIndex, text).then(
            function (data) {
              $scope.cameraListLoading = false;
              if (data.code == 8336 && data.next_index !== null) {
                $scope.searchIndex = data.next_index;
                $scope.cameraList = data.cameras;
              } else {
                $scope.searchIndex = null;
                $scope.cameraList = data.cameras;
              }
              $scope.isSearching = false;
              setTimeout(function () {
                $scope.$apply();
              });
            },
            function (err) {
              $scope.cameraListLoading = false;
              $log.error(err);
            }
          );
        }
      }, 300);
    }

    $scope.saveFx = function () {
      var refinedstartEndTime = $scope.refineStartEndTimeToEpoch()

      $scope.wData.fid = $scope.fid;
      $scope.wData.settings.st = refinedstartEndTime.startEpoch
      $scope.wData.settings.et = refinedstartEndTime.endEpoch
      if ($scope.wData.settings.streamingOpt == "l") {
        $scope.wData.settings.st = 0;
        $scope.wData.settings.et = 0;
      }

      $scope.hasErr = false;
      $scope.errType = "";
      var timerangediff = $scope.wData.settings.et - $scope.wData.settings.st
      var curDate = new Date()
      var curTime = curDate.getTime()
      // var curDt = String(curDate.getMonth() + 1).padStart(2, '0') + "/" + String(curDate.getDate()).padStart(2, '0') + "/" + String(curDate.getFullYear()) // formated in MM/DD/YYY
      var startDt = refinedstartEndTime.startLocal;
      var endDt = refinedstartEndTime.endLocal;

      if ($scope.wData.labelOpt == "c" && !$scope.wData.label) {
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if ($scope.wData.settings.rotationOpt == "c" && !$scope.wData.settings.rotate) {
        $scope.errType = "rotate";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else if ($scope.wData.camera && ($scope.wData.camera.cam_id == "" || $scope.wData.camera.name == "" || $scope.wData.camera.site_id == "" || $scope.wData.camera.site == "" || $scope.wData.camera.location == "")) {
        $scope.errType = "camerDetail";
        $scope.hasErr = true;
        $("#symbol").focus();
      } else if ($scope.wData.settings.streamingOpt == "h" && timerangediff > 3600) {
        $scope.wData.settings.streamingOpt = "h"
        $scope.errType = "timerange";
        $scope.hasErr = true;
        if (startDt !== endDt) {
          $("#timerange").focus();
        } else {
          $("#edr").focus();
        }
      } else if ($scope.wData.settings.streamingOpt == "h" && timerangediff < 0) {
        $scope.wData.settings.streamingOpt = "h"
        $scope.errType = "negativeTimeRange";
        $scope.hasErr = true;
        $("#edr").focus();
      } else if ($scope.wData.settings.streamingOpt == "h" && timerangediff == 0 && Math.round(curTime / 1000) >= $scope.wData.settings.st) {
        $scope.wData.settings.streamingOpt = "h"
        $scope.errType = "zeroTimerange";
        $scope.hasErr = true;
        $("#edr").focus();
      } else if ($scope.wData.settings.streamingOpt == "h" && Math.round(curTime / 1000) < $scope.wData.settings.st) {
        $scope.wData.settings.streamingOpt = "h"
        $scope.errType = "timeahed";
        $scope.hasErr = true;
        $("#sdr").focus();
      } else {
        $scope.saveProcessing = true;
        if ($rootScope.activePeriodOpen) {
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod', {});
        }
        if ($rootScope.isPermissionOpen) {
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission', {});
        }
        if ($scope.isPEOpen) {
          $timeout(function () {
            $scope.saveDataFx();
          }, 250);
        } else {
          $scope.saveDataFx();
        }
      }
    }

    $scope.saveDataFx = function () {
      VerkadaSrv.saveVerkada($scope.wData).then(
        function (data) {
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err) {
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('UnisysController', UnisysController);

  /** @ngInject */
  function UnisysController($log, $rootScope, $scope, $state, $cookies, $timeout, UnisysSrv){
    $scope.colorPicker = {b:false, hb:false, ht:false, cHB:false, cHT:false, rb:false, rt:false, arb:false, art:false, pb:false, pc:false, ph:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{
        bg:"#ffffff", bga:1,
        rotationOpt:"a", rotate:12, tokenType:"", token:"",
        headerBg:"#990000", headerBga:1, headerText:"#ffffff", headerFont:$scope.fontFamilySelected, headerSize:24,
        colHBg:"#990000", colHBga:1, colHText:"#ffffff", colHFont:$scope.fontFamily[56], colHSize:34,
        rowBg:"#f3f3f3", rowBga:1, rowText:"#444444", rowFont:$scope.fontFamily[56], rowSize:34,
        altBg:"#ffffff", altBga:1, altText:"#444444", altFont:$scope.fontFamily[56], altSize:34,
        pagingBg:"#ffffff", pagingBga:1, paging:"#444444", pagingFont:$scope.fontFamily[56], pagingSize:18, pagingHighlight:"#0b5394",
      },
      ctype:{bg:"monochrome", headerBg:"default", headerText:"monochrome", colHBg:"default", colHText:"monochrome", rowBg:"monochrome", rowText:"monochrome", altBg:"monochrome", altText:"monochrome", pagingBg:"monochrome", paging:"monochrome", pagingHighlight:"default"}
    };

    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.unisys.settings = angular.copy($scope.defaultSettings.settings);
      $scope.unisys.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.wcGetId = $scope.decId;
      UnisysSrv.getUnisys($scope.decId).then(
        function(data){
          $scope.unisys = data;
          $scope.getLocationFx($scope.unisys.env);
          $scope.detailLoading = false;
        }, function (err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.detailLoading = false;
      $scope.unisys = {
        label:"", env:"", laneType:"", listType:"", cruiseId:"", location:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.envLoading = false;
    $scope.getLocationFx = function(env){
      $scope.envLoading = true;
      UnisysSrv.getLocation(env).then(
        function(data){
          $scope.envLoading = false;
          $scope.locationList = data;
        }, function(err){
          $scope.envLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.unisysFx = function(){
      $scope.unisys.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.unisys.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.unisys.env == ""){
        $scope.errType = "env";
        $scope.hasErr = true;
        $("#env").focus();
      } else if(!$scope.unisys.location || $scope.unisys.location == ""){
        $scope.errType = "location";
        $scope.hasErr = true;
        $("#location").focus();
      } else if($scope.unisys.settings.rotationOpt == 'c' && !$scope.unisys.settings.rotate){
        $scope.errType = "rotate";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else if(!$scope.unisys.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#hSize").focus();
      } else if(!$scope.unisys.settings.rowSize){
        $scope.errType = "rSize";
        $scope.hasErr = true;
        $("#rSize").focus();
      } else if(!$scope.unisys.settings.altSize){
        $scope.errType = "aSize";
        $scope.hasErr = true;
        $("#aSize").focus();
      } else if(!$scope.unisys.settings.pagingSize){
        $scope.errType = "pSize";
        $scope.hasErr = true;
        $("#pSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveUnisysFx();
          }, 250);
        } else{
          $scope.saveUnisysFx();
        }
      }
    }
    $scope.saveUnisysFx = function(){
      UnisysSrv.saveUnisys($scope.unisys).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TwitterController', TwitterController);

  /** @ngInject */
  function TwitterController($log, $rootScope, $scope, $state, $cookies, $timeout, $interval, $filter, ngDialog, TwitterSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, arb:false, tt:false, st:false, dt:false, at:false, ast:false, adt:false};
    $scope.postList = [10,20,30,40,50,60,70,80,90,100];
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isClosed = false;
    $scope.isPEOpen = false;
    $scope.authProcessing = false;
    $scope.verifyBtn = false;
    $scope.otherUserAuth = false;
    $scope.userAuth = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#6fa8dc", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#6fa8dc", subtitleText:"#999999", descText:"#444444", altTitleText:"#6fa8dc", altSubtitleText:"#999999", altDescText:"#444444", rowFont:$scope.fontFamily[56], altRowFont:$scope.fontFamily[56], headerSize:26, titleSize:16, subtitleSize:16, descSize:18},
      ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", subtitleText:"monochrome", descText:"monochrome", altTitleText:"default", altSubtitleText:"monochrome", altDescText:"monochrome"}
    };
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.twitter.settings = angular.copy($scope.defaultSettings.settings);
      $scope.twitter.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TwitterSrv.getTwitter($scope.decId).then(
        function(data){
          $scope.twitter = data;
          $scope.detailLoading = false;
          if(!$scope.twitter.ctype){
            $scope.twitter.settings = angular.copy($scope.settings.settings);
            $scope.twitter.ctype = angular.copy($scope.settings.ctype);
          } else{
            $scope.settings.settings = angular.copy($scope.twitter.settings);
            $scope.settings.ctype = angular.copy($scope.twitter.ctype);
          }
          // if($scope.twitter.isAuthorized){
          //   $scope.pListShow = true;
          // }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.twitter = {labelOpt:"a", label:"", tType:"username", twitter:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
      $scope.twitter.post = $scope.postList[0];
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();


    $scope.openUrlFx = function(w, h,caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "userAuth"){
        $scope.verifyBtn = true;
        $scope.childWindow = window.open($scope.rUrl, 'Authorize access to your account', 'toolbar=no,location=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
      }
      if(caller == "otherUserAuth"){
        $scope.userAuth = true;
        $scope.otherUserAuth = true;
        var newWindow = window.open("https://twitter.com/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }

      
      // if(caller && caller=="otherUserAuth"){
      //   var newWindow = window.open("https://twitter.com/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      // }
      //   $scope.childWindow = window.open($scope.rUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
          
      // if(caller && caller=="otherUserAuth"){
      //   TwitterSrv.loginOtherUser({"id": $scope.twitter.id}).then(
      //     function(data){
      //       $scope.rUrl = data.rUrl;
      //       $scope.childWindow = window.open($scope.rUrl, 'Authorize access to your account', 'toolbar=no,location=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
      //       // $scope.childWindowInt = $interval($scope.checkChild, 500);
      //     },
      //     function(err){
      //       $log.error(err);
      //     }
      //   );
      // } else{
      //       $scope.childWindow = window.open($scope.rUrl, 'Authorize access to your account', 'toolbar=no,location=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
      //       // $scope.childWindowInt = $interval($scope.checkChild, 500);
      // }
    }

    $scope.verifyAuth = function(){
      $scope.authProcessing = true;
      TwitterSrv.getVerify($scope.twitter.id).then(
        function(data){
          $scope.hasErr = false;
          $scope.authProcessing = false;
          $scope.errType = "";
          if(data.code == 8115){
            $scope.hasErr = true;
            $scope.errType = "authFailed";
            $scope.authSuccess = false;
          } else{
            if(data.isClosed){
              $scope.isClosed = true;
              $scope.userAuth = false;
              $scope.verifyBtn = false;
              $scope.otherUserAuth = false;
              $scope.twitter.isAuthorized = true;
              $scope.authSuccess = true;
            } else{
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // $scope.checkChild = function(child){
    //   if($scope.childWindow.closed){
    //     $interval.cancel($scope.childWindowInt);
    //     TwitterSrv.getVerify($scope.twitter.id).then(
    //       function(data){
    //         $scope.hasErr = false;
    //         $scope.errType = "";
    //         if(data.code == 8115){
    //           $scope.hasErr = true;
    //           $scope.errType = "authFailed";
    //           $scope.authSuccess = false;
    //           $interval.cancel($scope.childWindowInt);
    //         } else{
    //           // $scope.pListShow = true;
    //           if(data.isClosed){
    //             // $interval.cancel($scope.childWindowInt);
    //             $scope.isClosed = true;
    //             $scope.twitter.isAuthorized = true;
    //             $scope.authSuccess = true;
    //             $scope.childWindow.close();
    //           } else{
    //             $scope.hasErr = true;
    //             $scope.errType = "authFailed";
    //             $scope.authSuccess = false;
    //           }
    //         }
    //       },
    //       function(err){
    //         $log.error(err);
    //       }
    //     );
    //   }
    // }

    $scope.twitterFx = function(tab, caller){
      $scope.twitter.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.selectedT == 1 && (tab == 1 || caller == "save")){
        if($scope.twitter.labelOpt == 'c' && $scope.twitter.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.twitter.twitter == "" && $scope.twitter.tType == 'hashtag'){
          $scope.errType = "tagId";
          $scope.hasErr = true;
          $("#twitter").focus();
        // } else if((/[-’/`~!*$@%+=.,^&(){}[\]|;:”<>?\\]/g.test($scope.twitter.twitter) || /_[a-zA-Z0-9]/.test($scope.twitter.twitter)) && $scope.twitter.tType == 'hashtag'){
        //   $scope.errType = "tagInvalid";
        //   $scope.hasErr = true;
        //   $("#twitter").focus();
        } else if($scope.twitter.settings.rotationOpt == "c" && !$scope.twitter.settings.rotate){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#cRotate").focus();
        } else if($scope.twitter.settings.hTextOpt == "c" && !$scope.twitter.settings.hText){
          $scope.errType = "headerText";
          $scope.hasErr = true;
          $("#hText").focus();
        } else if($scope.twitter.settings.hTextOpt != "n" && !$scope.twitter.settings.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#headerSize").focus();
        } else if(!$scope.twitter.settings.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#titleSize").focus();
        } else if(!$scope.twitter.settings.subtitleSize){
          $scope.errType = "sSize";
          $scope.hasErr = true;
          $("#subtitleSize").focus();
        } else if(!$scope.twitter.settings.descSize){
          $scope.errType = "dSize";
          $scope.hasErr = true;
          $("#descSize").focus();
        // } else if(caller == "save" && !$scope.twitter.isAuthorized){
        //   $scope.errType = "authFailed";
        //   $scope.hasErr = true;
        //   $("#authBtn").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveTwitterFx(caller);
            }, 250);
          } else{
            $scope.saveTwitterFx(caller);
          }
        }
      } else if(tab == 2 || caller == 'save'){
        if(!$scope.twitter.isAuthorized && !$scope.isClosed){
          $scope.errType = "authFailed";
          $scope.hasErr = true;
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveTwitterFx(caller);
            }, 250);
          }
          else{
            $scope.saveTwitterFx(caller);
          }
        }
      }
    }

    $scope.saveTwitterFx = function(caller){
      if(caller == "save"){
        $scope.twitter.toast = true;
      } else{
        $scope.twitter.toast = false;
      }
      if(caller == 'save'){
        $scope.saveProcessing = true;
      }
      TwitterSrv.saveTwitter($scope.twitter).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.twitter.id = data.id;
          
          //URL client id decryption
          $scope.rUrl = data.rUrl;
          if(data.rUrl){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.rUrl);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.rUrl = updatedUrl;
              }
            }
          }

          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          } else{
            $scope.tabFx(2, 'tabFx');
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TsccmController', TsccmController);

  /** @ngInject */
  function TsccmController($log, $rootScope, $scope, $state, $timeout, TsccmSrv){
    $scope.colorPicker = {bg:false, tl:false, tt:false, fl:false, ft:false, mt:false, dmt:false, jdt:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, bg:"#fff2cc", bga:1, text:"",
        sort:"d", //sort: ( d: Newest first | a: Oldest first )
        dType:{a:true, b:false}, // dType: ( all - All | a - Anniversary | b - Badge )
        toLabel:"#000000", toLabelFont:$scope.fontFamily[0], toLabelSize:32,
        toTxt:"#000000", toTxtFont:$scope.fontFamily[1], toTxtSize:32, 
        fLabel:"#000000", fLabelFont:$scope.fontFamily[0], fLabelSize:32,
        fTxt:"#000000", fTxtFont:$scope.fontFamily[1], fTxtSize:32,
        mTxt:"#000000", mFont:$scope.fontFamily[16], mSize:32,
        dmTxt:"#000000", dmFont:$scope.fontFamily[16], dmSize:32,
        jdTxt:"#000000", jdFont:$scope.fontFamily[16], jdSize:100
      },
      ctype:{bg:"default", toLabel:"monochrome", toTxt:"monochrome", fLabel:"monochrome", fTxt:"monochrome", mSize:"monochrome", dmTxt:"monochrome", jdTxt:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.wData.settings = angular.copy($scope.defaultSettings.settings);
      $scope.wData.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TsccmSrv.getTsccm($scope.decId).then(
        function(data){
          $scope.wData = data;
          $scope.detailLoading = false;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.wData = {
        label:"",
        activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.saveFx = function(){
      $scope.wData.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.wData.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.wData.settings.dType.a && !$scope.wData.settings.dType.b){
        $scope.errType = "dType";
        $scope.hasErr = true;
        $("#dType").focus();
      } else if($scope.wData.settings.rotationOpt == "c" && !$scope.wData.settings.rotate){
        $scope.errType = "rotate";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else if(!$scope.wData.settings.toLabelSize){
        $scope.errType = "toLabelSize";
        $scope.hasErr = true;
        $("#toLabelSize").focus();
      } else if(!$scope.wData.settings.toTxtSize){
        $scope.errType = "toTxtSize";
        $scope.hasErr = true;
        $("#toTxtSize").focus();
      } else if($scope.wData.settings.dType == "b" && !$scope.wData.settings.fLabelSize){
        $scope.errType = "fLabelSize";
        $scope.hasErr = true;
        $("#fLabelSize").focus();
      } else if($scope.wData.settings.dType == "b" && !$scope.wData.settings.fTxtSize){
        $scope.errType = "fTxtSize";
        $scope.hasErr = true;
        $("#fTxtSize").focus();
      } else if(!$scope.wData.settings.mSize){
        $scope.errType = "mSize";
        $scope.hasErr = true;
        $("#mSize").focus();
      } else if(!$scope.wData.settings.dmSize){
        $scope.errType = "dmSize";
        $scope.hasErr = true;
        $("#dmSize").focus();
      } else if($scope.wData.settings.dType == "a" && !$scope.wData.settings.jdSize){
        $scope.errType = "jdSize";
        $scope.hasErr = true;
        $("#jdSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      TsccmSrv.saveTsccm($scope.wData).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.setDTypeFx = function(key){
      // Reset all to false
      $scope.wData.settings.dType = { a: false, b: false };
      // Set the selected one to true
      $scope.wData.settings.dType[key] = true;
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TrainingModeController', TrainingModeController);

  /** @ngInject */
  function TrainingModeController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, fancyboxService, ContentLibrarySrv, TrainingModeSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.contentList = [];
    $scope.isPEOpen = false;
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(410);
      $scope.selectedHeight = $scope.getAvailableHeight(410);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
      $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      TrainingModeSrv.getTrainingMode($scope.decId).then(
        function(data){
          $scope.tm = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.tm = {label:"", activePeriod:{type:"a"}, content:[], permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 2){
        $scope.contentLibraryLoading = true;
        $scope.hasErr = false;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );

        $scope.updateList = function(){
          $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
          if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
            $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
          }

          $scope.tim = $scope.contentLibrary.info.timthumb;
          $scope.contentLibraryLoading = false;
          $rootScope.selectedItems = [];
          $scope.breadCrumbs = [];
          $scope.contentList = [];
          $scope.folderList = [];

          if($scope.contentLibrary.info.breadCrumbs){
            $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
          }
          if($scope.contentLibrary.contentLibrary.folder){
            $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
          }
          if($scope.contentLibrary.contentLibrary.content){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Image" || item.type == "Video" || (item.splType && item.splType == "Image" || item.splType == "Video")){
                $scope.contentList.push(item);
              }
            });
          }
        }
        /*For select content*/
        $scope.briefFx = function(){
          for(var i = 0; i < $rootScope.selectedItems.length; i++){
            if($rootScope.selectedItems[i].type != 'folder'){
              for(var j = 0; j < $scope.contentList.length; j++){
                if($rootScope.selectedItems[i].id == $scope.contentList[j].id){ //For normal Content
                  $scope.tm.content.push({
                    hidden:0,
                    isAccessible:true,
                    id:$scope.contentList[j].id,
                    fid:$scope.contentList[j].fid,
                    url:$scope.contentList[j].url,
                    extn:$scope.contentList[j].extn,
                    type:$scope.contentList[j].type,
                    label:$scope.contentList[j].label,
                    thumb:$scope.contentList[j].thumb,
                    width:$scope.contentList[j].width,
                    height:$scope.contentList[j].height,
                    splFid:$scope.contentList[j].splFid,
                    Length:$scope.contentList[j].Length,
                    path:$scope.contentLibrary.info.path,
                    splType:$scope.contentList[j].splType,
                    duration:$scope.contentList[j].duration,
                    MajorVersion:$scope.contentList[j].MajorVersion,
                    ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
                  });
                  break;
                }
              }
            }
          }
        }
      }
    }
    $rootScope.selectedTabFx();
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLibraryLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeContentFx = function(index){
      $scope.tm.content.splice(($scope.tm.content.length - 1) - index, 1);
    }
    $scope.folderBriefFx = function(){}

    $scope.tmFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if(tab == 1){
          if($scope.tm.label == ""){
            $scope.errType = "name";
            $scope.hasErr = true;
            $("#label").focus();
          } else{
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function (){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }
          }
        } else{
          if($scope.tm.content.length){
            angular.forEach($scope.tm.content, function(item){
              if((item.duration == "" || item.duration == "0" || isNaN(item.duration) || item.duration < 1) && !$scope.hasErr){
                $scope.errType = "durationEmpty";
                $scope.hasErr = true;
              }
            });
            if($scope.hasErr){
              return;
            }
          }
          if($scope.tm.label == ""){
            $scope.errType = "name";
            $scope.hasErr = true;
            $("#label").focus();
          } else{
            $scope.tm.fid = $scope.fid;
            $scope.saveProcessing = true;
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function (){
                $scope.saveFillerContent();
              }, 250);
            } else{
              $scope.saveFillerContent();
            }
          }
        }
      }
    }

    $scope.saveFillerContent = function(){
      TrainingModeSrv.saveTrainingMode($scope.tm).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.fbGalleryFx = function(index){
      $scope.fbGallery = {};
      $scope.curfbObj1 = [];
      $scope.curfbObj2 = [];
      angular.forEach($filter("reverse")($scope.tm.content), function(item, itemIndex){
        if(index === itemIndex){
          $scope.curfbObj1.push({href:$scope.cBucket + $filter("secureThumb")(item.thumb), title:item.label});
        } else{
          $scope.curfbObj2.push({href:$scope.cBucket + $filter("secureThumb")(item.thumb), title:item.label});
        }
      });
      $scope.fbGallery = $scope.curfbObj1.concat($scope.curfbObj2);
      fancyboxService.fancyboxPlus()($scope.fbGallery, $scope.fbGroup);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TrafficController', TrafficController);

  /** @ngInject */
  function TrafficController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, NgMap, TrafficSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    var vm = this;
    var azmap;

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TrafficSrv.getTraffic($scope.decId).then(
        function(data){
          $scope.traffic = data;
          if($scope.traffic.lat && $scope.traffic.lng){
            $scope.positions[0] = {lat:$scope.traffic.lat, lng:$scope.traffic.lng};
            $scope.mapCenter = [$scope.traffic.lat, $scope.traffic.lng];
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.traffic = {label:"", lat:"", lng:"", zoom:13, address:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
      $scope.mapCenter = [43.6532, -79.3832];
    }

    /*Azure Map*/
    $timeout(function(){
      // var keyArr = atob($scope.auth.uservices.mk).split("|");
      // var subKey = $scope.reverse(keyArr[0]);

      azmap = new atlas.Map('azMap', {
        view:'Auto',
        showFeedbackLink:false,
        enableAccessibilityLocationFallback:false,
        // Add your Azure Maps subscription client ID to the map SDK.
        authOptions:{
          //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
          authType:'subscriptionKey',
          // subscriptionKey:'KID57hqwgPX1MyuBvAcyizt5t_WBJU4KmafpfF-oiOM'
          // subscriptionKey:subKey
          subscriptionKey:$scope.encryptFx($scope.auth.uservices.mk)
        },
        language: "en"
      });

      //Wait until the map resources are ready.
      azmap.events.add("ready", function(){
        /* Show traffic on the map using the traffic options*/
        azmap.setTraffic({
          incidents:false,
          flow:"relative-delay"
        });

        if($scope.traffic.lat && $scope.traffic.lng){
          if($scope.auth.uservices.m == "b"){
            azmap.markers.clear();
            $scope.cordinates = [];
            var selPosition = [$scope.traffic.lng, $scope.traffic.lat];
            var pin = new atlas.HtmlMarker({
              htmlContent:atlas.getImageTemplate('marker'),
              color:"DodgerBlue",
              position:selPosition,
              popup:new atlas.Popup({
                pixelOffset:[0, -30]
              })
            });
            azmap.markers.add(pin);
          }

          azmap.setCamera({
            //center map
            center:[$scope.traffic.lng, $scope.traffic.lat],
            zoom:$scope.traffic.zoom,
          });
        } else{
          azmap.setCamera({
            center:[-97, 39],
            zoom:$scope.traffic.zoom
          });
        }
        $scope.changeForMap();
      });

      azmap.events.add('click', function(e){addPin(e)});
    }, 1000);

    function addPin(e){
      $scope.hasErr = false;
      $scope.errType = "";
      azmap.markers.clear();
      if(e.type == "click"){
        var position = [e.position[0], e.position[1]];
        var pin = new atlas.HtmlMarker({
          position:position,
          htmlContent:atlas.getImageTemplate('marker'),
          color:"DodgerBlue",
          popup:new atlas.Popup({
            pixelOffset:[0, -30]
          })
        });

        azmap.markers.add(pin);
        $scope.traffic.lat = e.position[1];
        $scope.traffic.lng = e.position[0];
        $scope.$apply();
      }
    }

    /** Google Map */
    NgMap.getMap().then(function(map){
      vm.map = map;
    });
    $scope.positions = [];
    $scope.addMarker = function(event){
      $scope.hasErr = false;
      $scope.errType = "";
      var ll = event.latLng;
      $scope.positions[0] = {lat:ll.lat(), lng:ll.lng()};
      $scope.traffic.lat = $scope.positions[0].lat;
      $scope.traffic.lng = $scope.positions[0].lng;
    }
    $scope.zoomChanged = function(event){
      $scope.traffic.zoom = this.zoom;
    }
    $scope.changeForMap = function(){
      if($scope.auth.uservices.m == "g"){
        vm.map.setZoom($scope.traffic.zoom);
        if($scope.traffic.lat){
          vm.home = new google.maps.LatLng($scope.traffic.lat, $scope.traffic.lng);
          vm.map.markers[0].setPosition({lat:$scope.traffic.lat, lng:$scope.traffic.lng});
        }
      } else{//Bing Map
        if($scope.traffic.lat && $scope.traffic.lng){
          azmap.setCamera({
            center:[$scope.traffic.lng, $scope.traffic.lat],
            zoom:$scope.traffic.zoom
          });
        } else{
          azmap.setCamera({
            center:[-97, 39],
            zoom:$scope.traffic.zoom
          });
        }
      }
    }

    $scope.trafficFx = function(){
      $scope.traffic.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.traffic.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.traffic.lat){
        $scope.errType = "latlong";
        $scope.hasErr = true;
        $("#lat").focus();
      } else if(!$scope.traffic.lng){
        $scope.errType = "latlong";
        $scope.hasErr = true;
        $("#long").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveTrafficFx();
          }, 250);
        } else{
          $scope.saveTrafficFx();
        }
      }
    }
    $scope.saveTrafficFx = function(){
      TrafficSrv.saveTraffic($scope.traffic).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TouchLinkController', TouchLinkController);

  /** @ngInject */
  function TouchLinkController($log, $rootScope, $scope, $state, $cookies, $timeout, TouchLinkSrv){
    $scope.colorPicker = {b:false, sb:false, tt:false, st:false, tm:false, hb:false, ht:false, att:false, atm:false, rt:false, art:false, rb:false, arb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsRB = {/*Rooomboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, logoOpt:true,
      titleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:72,
      subtitleText:"#999999", subtitleFont:$scope.fontFamilySelected, subtitleSize:36,
      timeText:"#444444", timeFont:$scope.fontFamily[0], timeSize:48,
      sos:{sType:"p", prior:30, eType:"a", after:30}
    };
    $scope.ctypeRB = {bg:"monochrome", ssbg:"monochrome", titleText:"monochrome", subtitleText:"monochrome", timeText:"monochrome"};
    $scope.settingsWB = {/*Wallboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, isTime:true, isRoom:true, logoOpt:true, rotationOpt:"a", rotate:12,
      header:{active:true, column1:"Event title", column2:"Time", column3:"Room"},
      headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26,
      titleText:"#000000", altTitleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:28,
      timeText:"#444444", altTimeText:"#444444", timeFont:$scope.fontFamily[0], timeSize:28,
      roomText:"#666666", altRoomText:"#000000", roomFont:$scope.fontFamilySelected, roomSize:28,
      rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1,
      sos:{sType:"s", prior:30, eType:"a", after:30}
    }
    $scope.ctypeWB = {bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", altTitleText:"monochrome", timeText:"monochrome", altTimeText:"monochrome", roomText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"};

    $scope.defaultSettingRB = angular.copy({setting:$scope.settingsRB, ctype:$scope.ctypeRB});
    $scope.defaultSettingWB = angular.copy({setting:$scope.settingsWB, ctype:$scope.ctypeWB});

    $scope.settingsDefault = function(){
      if($scope.touchLink.dType == "r"){
        $scope.settingsRB = angular.copy($scope.defaultSettingRB.setting);
        $scope.ctypeRB = angular.copy($scope.defaultSettingRB.ctype);
      } else{
        $scope.settingsWB = angular.copy($scope.defaultSettingWB.setting);
        $scope.ctypeWB = angular.copy($scope.defaultSettingWB.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TouchLinkSrv.getTouchLink($scope.decId).then(
        function(data){
          $scope.touchLink = data;
          if(!$scope.touchLink.settings.sos && $scope.touchLink.dType == "r"){
            $scope.touchLink.settings.sos = {sType:"p", prior:30, eType:"a", after:30};
          }
          if(!$scope.touchLink.settings.sos && $scope.touchLink.dType != "r"){
            $scope.touchLink.settings.sos = {sType:"s", prior:30, eType:"e", after:30};
          }
          if($scope.touchLink.dType == "r"){
            $scope.settingsRB = angular.copy($scope.touchLink.settings);
            $scope.ctypeRB = angular.copy($scope.touchLink.ctype);
          }
          if($scope.touchLink.dType != "r"){
            if(!$scope.touchLink.settings.headerSize){
              $scope.touchLink.settings.headerSize = 26;
              $scope.touchLink.settings.titleSize = 28;
              $scope.touchLink.settings.timeSize = 28;
              $scope.touchLink.settings.roomSize = 28
            }
            $scope.settingsWB = angular.copy($scope.touchLink.settings);
            $scope.ctypeWB = angular.copy($scope.touchLink.ctype);
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.touchLink = {label:"", dType:"r", settings:{feed:{url:"", logo:"", ss:""}}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.touchLinkFx = function(){
      $scope.touchLink.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.touchLink.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.touchLink.settings.feed.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.touchLink.settings.feed.logo == ""){
        $scope.errType = "logo";
        $scope.hasErr = true;
        $("#logo").focus();
      } else if($scope.touchLink.settings.feed.ss == ""){
        $scope.errType = "ss";
        $scope.hasErr = true;
        $("#ss").focus();
      } else if($scope.touchLink.dType == "r" && !$scope.settingsRB.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#rbTitleSize").focus();
      } else if($scope.touchLink.dType == "r" && !$scope.settingsRB.subtitleSize){
        $scope.errType = "stSize";
        $scope.hasErr = true;
        $("#rbSubtitleSize").focus();
      } else if($scope.touchLink.dType == "r" && !$scope.settingsRB.timeSize){
        $scope.errType = "tsSize";
        $scope.hasErr = true;
        $("#rbTimeSize").focus();
      } else if($scope.touchLink.dType == "r" && $scope.settingsRB.sos.sType == "p" && !$scope.settingsRB.sos.prior){
        $scope.errType = "rbSosP";
        $scope.hasErr = true;
        $("#rbSosP").focus();
      } else if($scope.touchLink.dType == "r" && $scope.settingsRB.sos.eType == "a" && !$scope.settingsRB.sos.after){
        $scope.errType = "rbSosA";
        $scope.hasErr = true;
        $("#rbSosA").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.rotationOpt == "c" && $scope.settingsWB.rotate == null){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#rotation").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.headerSize == null){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#wbHeaderSize").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.titleSize == null){
        $scope.errType = "titleSize";
        $scope.hasErr = true;
        $("#wbTitleSize").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.timeSize == null){
        $scope.errType = "timeSize";
        $scope.hasErr = true;
        $("#wbTimeSize").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.roomSize == null){
        $scope.errType = "roomSize";
        $scope.hasErr = true;
        $("#wbRoomSize").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.sos.sType == "p" && !$scope.settingsWB.sos.prior){
        $scope.errType = "wbSosP";
        $scope.hasErr = true;
        $("#wbSosP").focus();
      } else if($scope.touchLink.dType != "r" && $scope.settingsWB.sos.eType == "a" && !$scope.settingsWB.sos.after){
        $scope.errType = "wbSosA";
        $scope.hasErr = true;
        $("#wbSosA").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveTouchLinkFx();
          }, 250);
        } else{
          $scope.saveTouchLinkFx();
        }
      }
    }
    $scope.saveTouchLinkFx = function(){
      $scope.saveProcessing = true;
      $scope.feedCopy = angular.copy($scope.touchLink.settings.feed);
      if($scope.touchLink.dType == "r"){
        $scope.touchLink.settings = $scope.settingsRB;
        $scope.touchLink.ctype = $scope.ctypeRB;
      } else if($scope.touchLink.dType != "r"){
        $scope.touchLink.settings = $scope.settingsWB;
        $scope.touchLink.ctype = $scope.ctypeWB;
      }
      $scope.touchLink.settings.feed = $scope.feedCopy;
      TouchLinkSrv.saveTouchLink($scope.touchLink).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TextController', TextController);

  /** @ngInject */
  function TextController($log, $rootScope, $scope, $state, $cookies, $timeout, ngDialog, textSrv){
    $scope.colorPicker = {b:false, bc:false, tc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.hasErr = false;
    $scope.curTextId = 0;
    $scope.errType = "";
    $scope.decId = "";
    $scope.encId = "";

    $scope.settingsStatic = {settings:{rotationOpt:"a", size:16, rotate:12, bg:"#000000", bga:1, titleText:"#3d85c6", font:$scope.fontFamilySelected, align:"l", vAlign:"t"}, ctype:{bg:"monochrome", titleText:"default"}};
    $scope.settingsCrawl = {settings:{speed:100, bg:"#000000", bga:1, bullet:"#990000", titleText:"#ffffff", font:$scope.fontFamilySelected, dir:"rl", align:'l', fontSize:16, fontSizeOpt:"a"}, ctype:{bg:"monochrome", bullet:"default", titleText:"monochrome"}};

    $scope.defaultSettingsStatic = angular.copy($scope.settingsStatic);
    $scope.defaultSettingsCrawl = angular.copy($scope.settingsCrawl);

    $scope.settingsDefault = function(){
      if($scope.text.info.dType == "c"){
        $scope.settingsCrawl = angular.copy({settings:$scope.defaultSettingsCrawl.settings, ctype:$scope.defaultSettingsCrawl.ctype});
      } else{
        $scope.settingsStatic = angular.copy({settings:$scope.defaultSettingsStatic.settings, ctype:$scope.defaultSettingsStatic.ctype});
      }
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      textSrv.getText($scope.decId).then(
        function(data){
          $scope.text = data;
          $scope.detailLoading = false;
          if($scope.text.info.dType == "s"){
            $scope.settingsStatic.settings = angular.copy($scope.text.info.settings);
            $scope.settingsStatic.ctype = angular.copy($scope.text.info.ctype);
          } else if($scope.text.info.dType == "c"){
            if(!$scope.text.info.settings.dir){
              $scope.text.info.settings.dir = "rl";
            }
            if(!$scope.text.info.settings.fontSizeOpt){
              $scope.text.info.settings.fontSizeOpt = "a";
              $scope.text.info.settings.fontSize = 16;
            }
            $scope.settingsCrawl.settings = angular.copy($scope.text.info.settings);
            $scope.settingsCrawl.ctype = angular.copy($scope.text.info.ctype);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.text = {
        info:{
          id:0, label:"", dType:"c",
          settings:angular.copy($scope.settingsCrawl.settings),
          ctype:angular.copy($scope.settingsCrawl.ctype),
          activePeriod:{type:"a"}
        },
        permission:{type:$scope.auth.upreferences.defaultP},
        textList:[]
      }
    }

    $scope.sortCallback = function(){
      $scope.text.textList = [];
      angular.forEach(angular.element(".sortable-item"), function(item){
        $scope.text.textList.push({id:$(item).attr("data-id"), text:$(item).find(".codeText").text()});
      });
    }

    $scope.addText = {id:"", text:""};
    $scope.addTextFx = function(){
      $scope.addText.id = "t" + $scope.curTextId,
        $scope.text.textList.push($scope.addText);
      $scope.curTextId++;
      $scope.addText = {text:""};
      $("#addText").focus();
    }
    $scope.curText = "";
    $scope.saveTextFx = function(element){
      $scope.curText = $scope.trim($(element.target).closest(".codeQuad").find("input").val());
      if($scope.curText != ""){
        $(element.target).closest(".codeQuad").children(".codeText").text($scope.curText);
        $scope.sortCallback();
      }
    }

    $scope.inputCallbackFx = function(element){
      if($(element.target).val() == ""){
        $(element.target).closest(".input-group").find(".btn-success").attr('disabled', '');
      } else{
        $(element.target).closest(".input-group").find(".btn-success").removeAttr('disabled');
      }
    }

    $scope.cancelTextFx = function(element){
      $scope.curText = $(element.target).closest(".codeQuad").children(".codeText").text();
      $(element.target).closest(".codeQuad").find("input").val($scope.curText);
    }

    $scope.deleteProcessing = false;
    $scope.deleteTextOpen = function(id){
      $scope.deleteId = id;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteTextFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.deleteTextFx = function(){
      angular.forEach($scope.text.textList, function(list){
        if($scope.deleteId == list.id){
          $scope.text.textList.splice($scope.text.textList.indexOf(list), 1);
        }
      });
      ngDialog.close();
    }

    $scope.directionFx = function(){
      if(!$scope.settingsCrawl.settings.align){
        $scope.settingsCrawl.settings.align = "l";
      }
      if(!$scope.settingsCrawl.settings.fontSize || $scope.settingsCrawl.settings.fontSize == ""){
        $scope.settingsCrawl.settings.fontSize = 16;
      }
    }

    $scope.textFx = function(){
      $scope.text.info.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.text.info.dType == "s"){
        $scope.text.info.settings = angular.copy($scope.settingsStatic.settings);
        $scope.text.info.ctype = angular.copy($scope.settingsStatic.ctype);
      } else if($scope.text.info.dType == "c"){
        $scope.text.info.settings = angular.copy($scope.settingsCrawl.settings);
        $scope.text.info.ctype = angular.copy($scope.settingsCrawl.ctype);
      }

      if($scope.text.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.text.info.dType === "c" && $scope.text.info.settings.speed == null){
        $scope.errType = "crawl";
        $scope.hasErr = true;
        $("#speed").focus();
      } else if($scope.text.info.dType === "c" && ($scope.text.info.settings.dir == "bt" || $scope.text.info.settings.fontSizeOpt == "c") && $scope.text.info.settings.fontSize == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
        $("#fontSize").focus();
      } else if($scope.text.info.settings.rotationOpt == "c" && !$scope.text.info.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#rotation").focus();
      } else if($scope.text.info.dType === "s" && $scope.text.info.settings.size == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
        $("#size").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.textSaveFx();
          }, 250);
        } else{
          $scope.textSaveFx();
        }
      }
    }

    $scope.textSaveFx = function(){
      textSrv.saveText($scope.text).then(
        function(data){
          $state.go("hub.contentLibrary.c");
          $scope.saveProcessing = false;
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TelaxController', TelaxController);

  /** @ngInject */
  function TelaxController($log, $rootScope, $scope, $state, $cookies, $timeout, FileModelUploadSrv, TelaxSrv){
    $scope.colorPicker = {c1:false, c2:false, c3:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.curImg = {};
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TelaxSrv.getTelax($scope.decId).then(
        function(data){
          $scope.telax = data;
          $scope.curImg.img = $scope.telax.img;
          $scope.tim = $scope.telax.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.telax.otherinfo.bucket;
          if($scope.telax.otherinfo.mbucket && $scope.telax.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.telax.otherinfo.mbucket;
          }
          if($scope.telax.reportType != "cops"){
            $scope.telax.limit1 = 0;
            $scope.telax.color1 = "#006400"
            $scope.telax.limit2 = 10;
            $scope.telax.color2 = "#F69C55";
            $scope.telax.limit3 = 15;
            $scope.telax.color3 = "#FF0000";
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.telax = {label:"", reportType:"agent", img:{name:"", url:""}, limit1:0, c1Type:"default", color1:"#38761d", limit2:10, c2Type:"basic", color2:"#ff9900", limit3:15, c3Type:"basic", color3:"#ff0000", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.telaxFx = function(){
      $scope.telax.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.telax.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.telax.reportType == "cops" && $scope.telax.limit2 == null){
        $scope.errType = "limit";
        $scope.hasErr = true;
        $("#limit2").focus();
      } else if($scope.telax.reportType == "cops" && $scope.telax.limit3 == null){
        $scope.errType = "limit";
        $scope.hasErr = true;
        $("#limit3").focus();
      } else if($scope.telax.reportType == "cops" && $scope.telax.limit1 == $scope.telax.limit2){
        $scope.errType = "limitU";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.telax.reportType == "cops" && $scope.telax.limit2 == $scope.telax.limit3){
        $scope.errType = "limitU";
        $scope.hasErr = true;
        $("#limit2").focus();
      } else if($scope.telax.reportType == "cops" && $scope.telax.limit2 > $scope.telax.limit3){
        $scope.errType = "limitEqual";
        $scope.hasErr = true;
        $("#limit3").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveTelaxFx();
          }, 250);
        } else{
          $scope.saveTelaxFx();
        }
      }
    }
    $scope.saveTelaxFx = function(){
      $scope.saveProcessing = true;
      FileModelUploadSrv.uploadFileAndData("contentLibrary/widgets/telax", $scope.telax, $scope.curImg.img).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TeamsRoomController', TeamsRoomController);

  /** @ngInject */
  function TeamsRoomController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, ngDialog, TeamsRoomSrv, ContentLibrarySrv, MeetingSrv, DevicesSrv){
    $scope.colorPicker = {rb:false, rsb:false, rtt:false, rst:false, rtm:false, wb:false, wsb:false, whb:false, wht:false, wtt:false, wat:false, wtm:false, watm:false, wrt:false, wart:false, wrb:false, wab:false, wft:false, waft:false, wfb:false};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.curDeviceObj = {availableDevices:[], devices:[]};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.childWindowInt = null;
    $scope.authSuccess = false;
    $scope.isPEOpen = false;
    $scope.editMode = false;
    $scope.dListShow = false;
    $scope.encId = "";
    $scope.allRoomList = [];
    $scope.curRoomList = [];
    $scope.decId = 0;
    $scope.dgList = {d:[], g:[], r:[]};
    $scope.search = {text:""};
    $scope.teams = {info:{}, isAuthorized:false};
    // Todo to load data veriable and hold tab/button
    $scope.reponseLoad = false;

    $scope.settings = {
      rb:{/*Roomboard*/
        bg:"#efefff", bga:1, ssbg:"#000000", ssbga:1,
        titleText:"#444791", titleFont:$scope.fontFamilySelected, titleSize:72,
        subtitleText:"#7779b1", subtitleFont:$scope.fontFamilySelected, subtitleSize:36,
        timeText:"#444791", timeFont:$scope.fontFamily[0], timeSize:48,
        sos:{sType:"p", prior:30, eType:"a", after:30},
        feed:{url:"", logo:"", ss:""}
      },
      wb:{/*Wallboard*/
        bg:"#f3f3f3", bga:1, ssbg:"#000000", ssbga:1, isTime:true, isRoom:true, rotationOpt:"a", rotate:12,wdmOpt:"d",
        header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room", col3TxtAlign:"center"},
        headerBg:"#444791", headerBga:1, headerText:"#ffffff", headerFont:$scope.fontFamilySelected, headerSize:26,
        titleText:"#444791", timeText:"#444791", titleSize:28, titleTxtAlign:"left",
        altTitleText:"#444791", altTimeText:"#444791", timeSize:28, timeTxtAlign:"center",
        roomText:"#444791", altRoomText:"#444791", roomSize:28, roomTxtAlign:"center",
        titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected,
        rowBg:"#efefff", rowBga:1, altBg:"#d2d3f7", altBga:1,
        sos:{sType:"s", prior:30, eType:"a", after:30},
        feed:{url:"", logo:"", ss:""}
      }
    };
    $scope.ctype = {
      rb:{bg:"custom", ssbg:"monochrome", titleText:"custom", subtitleText:"custom", timeText:"custom"},
      wb:{bg:"monochrome", ssbg:"monochrome", headerBg:"custom", headerText:"monochrome", titleText:"custom", timeText:"custom", roomText:"custom", altTitleText:"custom", altTimeText:"custom", altRoomText:"custom", rowBg:"custom", altBg:"custom"}
    };

    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      $scope.teams.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.teams.info.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      TeamsRoomSrv.getTeamsRoom($scope.decId).then(
        function(data){
          $scope.teams.info = data.info;
          $scope.teams.isAuthorized = data.isAuthorized;
          if(!$scope.teams.info.teamsrooms.teamsroomsApp){
            $scope.teams.info.teamsrooms.teamsroomsApp = $scope.widgetList.teamsRoomApp;
          }

          $scope.tim = $scope.teams.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.teams.info.bucket;
          if($scope.teams.info.mbucket && $scope.teams.info.mbucket != ""){
            $scope.cDetailBucket = $scope.teams.info.mbucket;
          }

          /* Decrypt */
          if($scope.widgetList.teamsRoomApp == "ca"){
            $scope.teams.info.teamsrooms.credential.tenantId = $scope.decryptFx($scope.teams.info.teamsrooms.credential.tenantId);
            $scope.teams.info.teamsrooms.credential.clientId = $scope.decryptFx($scope.teams.info.teamsrooms.credential.clientId);
            $scope.teams.info.teamsrooms.credential.secret = $scope.decryptFx($scope.teams.info.teamsrooms.credential.secret);
          }

          //! No need to do this here start
          // $scope.dgList = angular.copy($scope.teams.info.roomList);
          // // angular.forEach($scope.dgList.d, function(d){
          // //   if(!d.type){d.type = "d"};
          // // });
          // $scope.dgrListCopy = angular.copy($scope.dgList);
          // $scope.curRoomList = $scope.dgList.d;
          //! No need to do this here ends

          if(!$scope.teams.info.settings.wb.header.col1TxtAlign){
            $scope.teams.info.settings.wb.header.col1TxtAlign = "left";
          }
          if(!$scope.teams.info.settings.wb.header.col2TxtAlign){
            $scope.teams.info.settings.wb.header.col2TxtAlign = "center";
          }
          if(!$scope.teams.info.settings.wb.header.col3TxtAlign){
            $scope.teams.info.settings.wb.header.col3TxtAlign = "center";
          }

          if(!$scope.teams.info.settings.wb.titleTxtAlign){
            $scope.teams.info.settings.wb.titleTxtAlign = "left";
          }
          if(!$scope.teams.info.settings.wb.timeTxtAlign){
            $scope.teams.info.settings.wb.timeTxtAlign = "center";
          }
          if(!$scope.teams.info.settings.wb.roomTxtAlign){
            $scope.teams.info.settings.wb.roomTxtAlign = "center";
          }

          $scope.curDSelected = $scope.teams.info.msRoomsList;
          $scope.allRoomList = $scope.teams.info.msAllRooms;
          if(data.isAuthorized){
            $scope.dListShow = true;
            $scope.idArr = $scope.curDSelected.map(function(item){
              return item.emailAddress;
            });
            $scope.allRoomList.forEach(function(item){
              if($scope.idArr.includes(item.emailAddress)){
                item.selected = true;
              }
            })
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.teams.info = {label:"",roomList:{d:[], r:[]}, teamsrooms:{credential:{tenantId:"", clientId:"", secret:"", auth:"u"}, teamsroomsApp:$scope.widgetList.teamsRoomApp}, msRoomsList:[], activePeriod:{type:"a"},ctype:angular.copy($scope.ctype),settings:angular.copy($scope.settings),permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.openUrlFx = function(w, h, caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      if(caller && caller=="otherUserAuth"){
        var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      $scope.timer = setTimeout(
        function(){
          if($scope.timer){
            clearTimeout($scope.timer);
          }
          if(caller=="otherUserAuth"){
            newWindow.close();
          }
          $scope.childWindow = window.open($scope.request_url, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
      return false;
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        TeamsRoomSrv.getTeamsRoomVerify($scope.teams.info.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8115){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              if(data.isClosed){
                $scope.teams.isAuthorized = true;
                $scope.authSuccess = true;
                $scope.getAuthRoomList($scope.teams.info.id);
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.getAuthRoomList = function(id){
      $scope.roomListLoading = true;
      TeamsRoomSrv.getMSRooms(id).then(
        function(data){
          $scope.roomListLoading = false;
          $scope.dListShow = true;
          $scope.allRoomList = data.info.roomList;
          // if(selRoom.length){
          //   $scope.allRoomList.forEach(function(list){
          //     selRoom.find(function(selItem){
          //       if(selItem.id === list.id){
          //         list.selected = true;
          //       }
          //     });
          //   });
          // }
        },
        function(err){
          $log.error(err);
          $scope.roomListLoading = false;
        }
      );
    }

    $scope.roomUCFx = function(caller, room, index){
      $scope.roomUProcessing = false;
      $scope.hasPopErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      // TODO: change the key name
      if(room.dt == "rb" && caller == "u" && (room.rm == '' || angular.isUndefined(room.rm) || room.rm == 'All')){
        $scope.hasErr = true;
        $scope.errType = "room";
        return false;
      }
      if(caller == "e"){
        $scope.roomCopy = angular.copy(room);
      } else if(caller == "u"){
        // TODO: change the key name
        if(room.dt=="rb"){
          room.rm = room.rm;
        }
        TeamsRoomSrv.editRoom({id:$scope.teams.info.id, room:room}).then(
          function(data){
            if(data.code == 8214 || data.code == 8215){
              $scope.roomUProcessing = false;
              room.show = false;
            }
          },
          function(err){
            $log.error(err);
            $scope.roomUProcessing = false;
          }
        );
      } else if(caller == "c"){
        // $scope.curRoomList.forEach(function(val, i){
        //   if(val && val.id == room.id){
        //     $scope.curRoomList[i] = $scope.roomCopy;
        //     return true;
        //   }
        // });
        room.show = false;
        $scope.roomCopy.show = false;
      }
    }

    $scope.teamsFx = function(tab, caller){
      // TODO: new code
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.teams.info.msRoomsList = $scope.allRoomList.filter(function(item){
        return item.selected;
      })
      if(tab == 1 ||  tab == 3 || tab == 4 || caller == "save"){
        // $scope.rbList = [];
        // if($scope.curRoomList.length){
        //   if(tab == 4){
        //     $scope.rbList = $scope.curRoomList.filter(function(item){
        //       // TODO: change the key name
        //       if(item.dt=='rb' && item.show && (item.rm == '' || item.rm == null || item.rm == 'All')){
        //         return item;
        //       }
        //     });
        //   } else {
        //     $scope.curRoomList.forEach(function(item){
        //       // TODO: change the key name
        //     if(item.rm == '' || item.rm == null || item.rm == 'All'){
        //         item.dt = 'wb';
        //         item.show = false;
        //       }
        //     });
        //   }
        // }

        if($scope.teams.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.widgetList.teamsRoomApp == "ca" && ($scope.teams.info.teamsrooms.credential.tenantId == "" || $scope.teams.info.teamsrooms.credential.clientId == "" || $scope.teams.info.teamsrooms.credential.secret == "")){
          $scope.errType = "allEmpty";
          $scope.hasErr = true;
          $("#wData").focus();
        } else if(!$scope.teams.info.settings.rb.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#rbTitleSize").focus();
        } else if(!$scope.teams.info.settings.rb.subtitleSize){
          $scope.errType = "stSize";
          $scope.hasErr = true;
          $("#rbSubtitleSize").focus();
        } else if(!$scope.teams.info.settings.rb.timeSize){
          $scope.errType = "tsSize";
          $scope.hasErr = true;
          $("#rbTimeSize").focus();
        } else if($scope.teams.info.settings.rb.sos.sType == "p" && !$scope.teams.info.settings.rb.sos.prior){
          $scope.errType = "rbSosP";
          $scope.hasErr = true;
          $("#rbPrior").focus();
        } else if($scope.teams.info.settings.rb.sos.eType == "a" && !$scope.teams.info.settings.rb.sos.after){
          $scope.errType = "rbSosA";
          $scope.hasErr = true;
          $("#rbAfter").focus();
        } else if($scope.teams.info.settings.wb.rotationOpt == "c" && $scope.teams.info.settings.wb.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#wbCRotate").focus();
        } else if($scope.teams.info.settings.wb.headerSize == null){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wbHeaderSize").focus();
        } else if($scope.teams.info.settings.wb.titleSize == null){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#wbTitleSize").focus();
        } else if($scope.teams.info.settings.wb.timeSize == null){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#wbTimeSize").focus();
        } else if($scope.teams.info.settings.wb.roomSize == null){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#wbRoomSize").focus();
        } else if($scope.teams.info.settings.wb.sos.sType == "p" && !$scope.teams.info.settings.wb.sos.prior){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wbPrior").focus();
        } else if($scope.teams.info.settings.wb.sos.eType == "a" && !$scope.teams.info.settings.wb.sos.after){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wbAfter").focus();
        // } else if($scope.rbList.length){
        //   $scope.hasErr = true;
        //   $scope.errType = "room";
        } else{

          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.teams.info.fid = $scope.fid;
          $scope.teams.info.toast = false;
          if(tab == 1 || tab == 3 || tab == 4){
            $scope.nextProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveTeamsFx(tab);
              }, 250);
            } else{
              $scope.saveTeamsFx(tab);
            }
          } else if(!$scope.teams.isAuthorized){
            $scope.errType = "authEmpty";
            $scope.hasErr = true;
          } else if($scope.teams.isAuthorized && $scope.allRoomList.length > 0 && $scope.teams.info.msRoomsList.length == 0){
            $scope.errType = "room";
            $scope.hasErr = true;
            $scope.saveProcessing = false;
          } else{
            $scope.teams.info.toast = true;
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveTeamsFx(tab);
              }, 250);
            } else{
              $scope.saveTeamsFx(tab);
            }
          }
        }
      }
    }

    $scope.saveTeamsFx = function(tab){
      $scope.reponseLoad = true;
      $scope.teams.info.fid = $scope.fid;
      $scope.teams.info.tzOffset = $scope.curTimezone;

      //! No need to do this here start
      // $scope.teams.info.roomList.d = $scope.curRoomList;
      //! No need to do this here end
      // TODO: new code
      if($scope.teams.info.roomList){
        delete $scope.teams.info.roomList
      }

      /* Encrypt */
      var tempTeams = angular.copy($scope.teams);
      if($scope.widgetList.teamsRoomApp == "ca"){
        tempTeams.info.teamsrooms.credential.tenantId = $scope.encryptFx($scope.teams.info.teamsrooms.credential.tenantId);
        tempTeams.info.teamsrooms.credential.clientId = $scope.encryptFx($scope.teams.info.teamsrooms.credential.clientId);
        tempTeams.info.teamsrooms.credential.secret = $scope.encryptFx($scope.teams.info.teamsrooms.credential.secret);
      }

      TeamsRoomSrv.saveTeamsRoom(tempTeams).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.nextProcessing = false;
          if(data.id){
            $scope.teams.info.id = data.id;
          }

          //URL client id decryption
          $scope.request_url = data.request_url;
          if(data.request_url){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.request_url);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.request_url = updatedUrl;
              }
            }
          }

          $scope.teams.isAuthorized = data.isAuthorized;
          if(data.code == ""){
            $scope.errType = "authEmpty";
            $scope.hasErr = true;
            $scope.saveProcessing = false;
          } else if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(data.code == 86401){
            $scope.errType = "invalid";
            $scope.hasErr = true;
          } else if(tab == 1 || tab == 3 || tab == 4){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 4){
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
          $scope.reponseLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          $scope.reponseLoad = false;
        }
      );
    }

    $scope.backBtnFx = function(){
      $rootScope.selectedT = $rootScope.selectedT - 1;
    }

    $scope.deleteOpen = function(caller, iId){
      $scope.removeProcessing = false;
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      TeamsRoomSrv.delete($scope.teams.info.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:""};
      $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      }
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:""};
      $scope.hasListErr = false;
      $scope.errType = "";
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // if($scope.decId == 0){
        //   $scope.detailLoading = true;
        //   TeamsRoomSrv.getRoomList($scope.decId).then(
        //     function(data){
        //       if($scope.selectedT == "1"){
        //         $scope.detailLoading = false;
        //         $scope.dgList = angular.copy(data.roomList);
        //         angular.forEach($scope.dgList.d, function(d){
        //           if(!d.type){d.type = "d"};
        //         });
        //         $scope.curRoomList = $scope.dgList.d;
        //         $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //       }
        //     },
        //     function(err){
        //       $log.error(err);
        //       $scope.detailLoading = false;
        //     }
        //   );
        // }
        //! No need to call this API here ends
      } else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        TeamsRoomSrv.getSSList($scope.teams.info.id).then(
          function(data){
            if($scope.selectedT == "3"){
              $scope.detailLoading = false;
              $scope.ssList = data.screenSaver;
              if(!$scope.ssList.length){
                $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
              } else{
                $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
        $scope.resetFx('s');
      } else if($scope.selectedT == "4"){
        // TODO: new code
        var obj = {subCaller: "wTeamsRoomRL", caller: "availD", offset: 0, id: $scope.teams.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // $scope.curRoomList.filter(function(list){
        //   list.show = false;
        // });
        TeamsRoomSrv.getTeamsRoom($scope.teams.info.id).then(
          function(data){
            $scope.curDRoomList = $scope.teams.info.msRoomsList;
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
        //! No need to call this API here ends
      }
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.loading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.addScreen.ss = $scope.curContent;
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModels, type){
      var curModel = [];
      angular.forEach(curModels, function(item){
        curModel.push(angular.fromJson(item));
      });

      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      $rootScope.dList = [];
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   });
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      //   // angular.forEach($scope.curDeviceObj.availableDevices, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i=0; i<$scope.curDeviceObj.devices.length; i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      //   // $scope.curDeviceObj.availableDevices = $scope.curAvailableDevices;
      // }
      //! No need to here ends

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to do here start
          // if(caller){
          //   if($scope.addScreen.d.length > 0){
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.curDeviceObj.availableDevices), devices:$scope.curDeviceObj.devices};
          //   } else {
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
          //   }
          // }
          //! No need to do here end
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wTeamsRoomSS", caller: "availD", offset: 0, id: $scope.teams.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wTeamsRoomSS", caller: "selD", offset: 0, id: $scope.teams.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: change the value
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.errType = "";
      $scope.hasListErr = false;
      $scope.hasErr = false;
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#ssLabel").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#contentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#deviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#ssDuration").focus();
      } else{
        $scope.addProcessing = true;
        $scope.ssPostObj = {info:{id:$scope.teams.info.id}, screenSaver:$scope.addScreen};
        TeamsRoomSrv.addSS($scope.ssPostObj).then(
          function(data){
            // TODO: add new changes
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.teams.info.screenSaver = [];
      $scope.teams.info.screenSaver = $scope.ssList;
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset selected device
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.selectedT != "3" && item.type == "Image"){
            $scope.curArgsContent.push(item);
          } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';
    $scope.loadingPaging = {}
    $scope.loadingMore = {}

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }


    // TODO get Scroll data for the event and room list tab
    $scope.getScrollListData = function(obj){
      $scope.detailLoading = true;
      $scope.detailListObj[obj.quadId] = {};
      $scope.scrollDataList[obj.quadId] = [];
      $scope.allScrollDataList[obj.quadId] = [];
      $scope.copyScrollObj[obj.quadId] = {};
      $scope.visibleObjects[obj.quadId] = [];
      $scope.haveMoreData[obj.quadId] = false;
      $scope.haveMoreSearchData[obj.quadId] = false;
      $scope.visibleData[obj.quadId] = [];
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.searchScroll[obj.quadId] = false;
      $scope.loadingMore[obj.quadId] = false;
      $scope.loadingPaging[obj.quadId] = true;

      $scope.detailListObj[obj.quadId] = {subCaller: obj.subCaller, caller: obj.caller, offset: obj.offset, id: obj.id, subCallerId: obj.subCallerId, quadId:obj.quadId};
      
      DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData[obj.quadId] = true;
          } else{
            $scope.haveMoreData[obj.quadId] = false;
          }

          // if(obj.quadId == "rl"){
          //   $scope.curRoomList = data.r;
          //   angular.forEach($scope.curRoomList, function(item){
          //     item.type = "r"
          //   })
          // }

          $scope.scrollDataList[obj.quadId] = data.d;
          $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

          $scope.detailLoading = false;

          $scope.loadingPaging[obj.quadId] = false;
        },
        function(err){
          $scope.detailLoading = false;
          $scope.loadingPaging[obj.quadId] = false;
          $log.error(err);
        }
      );
    }


    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.loadingMore[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: $scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        if($scope.searchScroll[obj.quadId]){
          $scope.detailListObj[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else if(data.d.length && data.d.length < 1000){
                $scope.haveMoreData[obj.quadId] = false;
              }

              $scope.allScrollDataList[obj.quadId] = [];
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = 0;
        $scope.etIndex[obj.quadId] = 300;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.scrollDataList[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if(obj.text){          
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        }
  
        if(obj.text){
          $scope.searchScroll[obj.quadId] = true;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length && data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = data.d;
  
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          $scope.haveMoreSearchData[obj.quadId] = false;
          $scope.searchScroll[obj.quadId] = false;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else{
                $scope.haveMoreData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = data.d;
              
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataList[obj.quadId] = [];
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
  
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = obj.st;
        $scope.etIndex[obj.quadId] = obj.et;
        $scope.visibleData[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
        setTimeout(function() {
          $scope.$apply();
        });
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      if($scope.selectedT == '2' || $scope.selectedT == '4'){
        var text = val.toLowerCase();
        var scrollElement = document.querySelector("#scroll-container-"+quadId);
        if (!text && $scope.searchScroll[quadId]) {
          // TODO Enter when have newVal is empty and user perform search operation already
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else if (text && text.length >= 3) {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreData[quadId]) {
            // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
            // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
            var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj , function (item) {
              if(keys.indexOf(item.h) === -1){
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if(filteredObj.length && filteredObj.length >= 1000){
              $scope.haveMoreSearchData[quadId] = true;
            } else{
              $scope.haveMoreSearchData[quadId] = false;
            }
                        
            $scope.scrollDataList[quadId] = filteredObj;
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            if ($scope.scrollDataList[quadId].length <= 300) {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
            } else {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
            }
            $scope.searchScroll[quadId] = true;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          } else {
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          }
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TeamsChannelController', TeamsChannelController);

  /** @ngInject */
  function TeamsChannelController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, $interval,ngDialog, TeamsChannelSrv){
    $scope.colorPicker = { b: false, tt:false, hb: false, ht: false, rb: false, rt: false, arb: false, art: false };
    $scope.postList = [10,20,30,40,50];
    $scope.fid = localStorage.getItem("curFId");
    $scope.searchChannel = {displayName:""};
    $scope.searchTeams = {teamName:""};
    $scope.saveProcessing = false;
    $scope.authSaveDisable = false;
    $scope.authProcessing = false;
    $scope.showTeamsList = false;
    $scope.showChannelList = false;
    $scope.channelLoading = false;
    $scope.detailLoading = false;
    $scope.tl = {isOpen:false};
    $scope.cl = {isOpen:false};
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.channelList = [];
    $scope.teamsList = [];

    $scope.list = {
      settings: { rotationOpt: "a", rotate: 12, hTextOpt: "a", hText: "", headerBg: "#ffffff", headerBga: 1, headerText: "#6fa8dc", headerFont: $scope.fontFamilySelected, bg: "#ffffff", bga: 1, rowBg: "#ffffff", rowBga: 1, altBg: "#f3f3f3", altBga: 1, titleText: "#6fa8dc", subtitleText: "#999999", descText: "#444444", altTitleText: "#6fa8dc", altSubtitleText: "#999999", altDescText: "#444444", rowFont: $scope.fontFamily[56], altRowFont: $scope.fontFamily[56], headerSize: 26, titleSize: 16, subtitleSize: 16, descSize: 18},
      ctype: { headerBg: "monochrome", headerText: "default", bg: "monochrome", rowBg: "monochrome", altBg: "monochrome", titleText: "default", subtitleText:"monochrome", descText: "monochrome", altTitleText: "default", altSubtitleText: "monochrome", altDescText: "monochrome"}
    }

    $scope.textMedia = {
      settings: {
        bg: "#efefff", bga: 1,align:"l", textBg: "#efefff", textBga: 1, titleText: "#444791", descText: "#7779b1", titleSize: 16, descSize: 18, titleFont: $scope.fontFamilySelected, descFont: $scope.fontFamilySelected, rotationOpt:"a", rotate:12
      },
      ctype: {bg: "monochrome", textBg: "monochrome", text: "default", titleText: "default", descText: "monochrome"}
    }

    $scope.media = {
      settings: {bg: "#ffffff", bga: 1, rotationOpt:"a", rotate:12},
      ctype: {bg: "monochrome"}
    }

    $scope.defaultSettingsList = angular.copy($scope.list);
    $scope.defaultSettingstextMedia = angular.copy($scope.textMedia);
    $scope.defaultSettingsmedia = angular.copy($scope.media);

    $scope.settingsDefault = function(){
      if ($scope.channel.dType == "l") {
        $scope.list = angular.copy({ settings: $scope.defaultSettingsList.settings, ctype: $scope.defaultSettingsList.ctype });
      } else if ($scope.channel.dType == "t") {
        $scope.textMedia = angular.copy({ settings: $scope.defaultSettingstextMedia.settings, ctype: $scope.defaultSettingstextMedia.ctype });
      } else {
        $scope.media = angular.copy({ settings: $scope.defaultSettingsmedia.settings, ctype: $scope.defaultSettingsmedia.ctype });
      }
      // $scope.channel.settings = angular.copy($scope.defaultSettings.settings);
      // $scope.channel.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      TeamsChannelSrv.getChannelDetails($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.channel = data;
          if($scope.channel.isAuth){
            $scope.teamsShow = true;
            $scope.showTeamsList = true;
            if($scope.channel.channel){
              $scope.showChannelList = true;
              if($scope.channel.channel.tenantId){
                $scope.channel.channel.tenantId = $scope.decryptFx($scope.channel.channel.tenantId);
              }
            }
          }
          if(!$scope.channel.teamsChannelApp){
            $scope.channel.teamsChannelApp = $scope.widgetList.teamsChannelApp;
          }
          if (!data.dType) {
            $scope.channel.dType = "t"
          }

          /* Decrypt */
          if($scope.channel.teamsChannelReq.teamsChannelApp == "ca"){
            $scope.channel.teamsChannelReq.tenantId = $scope.decryptFx($scope.channel.teamsChannelReq.tenantId);
            $scope.channel.teamsChannelReq.clientId = $scope.decryptFx($scope.channel.teamsChannelReq.clientId);
            $scope.channel.teamsChannelReq.secret = $scope.decryptFx($scope.channel.teamsChannelReq.secret);
          }

          if($scope.channel.dType == "l"){
            $scope.list.settings = angular.copy($scope.channel.settings);
            $scope.list.ctype = angular.copy($scope.channel.ctype);
          }
          else if($scope.channel.dType == "t"){
            $scope.textMedia.settings = angular.copy($scope.channel.settings);
            $scope.textMedia.ctype = angular.copy($scope.channel.ctype);
            if(!$scope.channel.settings.rotationOpt){
              $scope.textMedia.settings.rotationOpt = "a"
              $scope.textMedia.settings.rotate = 12
            }
          }
          else if($scope.channel.dType == "m"){
            $scope.media.settings = angular.copy($scope.channel.settings);
            $scope.media.ctype = angular.copy($scope.channel.ctype);
            if(!$scope.channel.settings.rotationOpt){
              $scope.media.settings.rotationOpt = "a"
              $scope.media.settings.rotate = 12
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.channel = {labelOpt:"a", label:"",channel:"",teams:"",post:10, dType:"t",teamsChannelReq:{tenantId:"", clientId:"", secret:"", teamsChannelApp:$scope.widgetList.teamsChannelApp}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings: angular.copy($scope.textMedia.settings),
        ctype: angular.copy($scope.textMedia.ctype)
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){}
    }
    $rootScope.selectedTabFx();


    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });
    $scope.openUrlFx = function(w, h, caller){
      if($scope.teamsShow){
        $scope.showTeamsList = false;
        $scope.showChannelList = false;
        $scope.authSaveDisable = true;
        $scope.channel.teams = "";
        $scope.channel.channel = "";
        $scope.channelList = [];
        $scope.teamsList = [];
      }
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "ou"){
        var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      if(caller != "at"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(
        function(){
          if(caller != "at"){
            if(caller == "ou"){
              newWindow.close();
            }
            ngDialog.close($scope.confirmDialog);
          }
          $scope.popProcessing = false;
          $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
      return false;
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template: '\
          <section class="panel">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'re\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'ou\'">{{"cl.widget.msg.10.2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
            <button type="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        // console.warn("dfsdfsdf");
        TeamsChannelSrv.getVerify($scope.channel.id).then(
          function(data){
            $scope.authProcessing = false;
            $scope.errType = "";
            $scope.hasErr = false;
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
              return;
            }
            if(data.code == 8179){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "teamsEmpty";
              $scope.teamsShow = false;
              return;
            } else{
              $scope.teamsShow = true;
              if(data.isClosed){
                $scope.authSuccess = true;
                $scope.showTeamsList = true;
                $scope.channel.isAuth = true;
                $scope.teamsList = data.teams;
              } else{
                $scope.hasErr = true;
                $scope.authSuccess = false;
                $scope.errType = "authFailed";
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }


    $scope.teamsSearchFocus = function () {
      $scope.searchTeams = {teamName:""};
      $scope.searchChannel = {displayName:""};
      if ($scope.teamsList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $rootScope.selTeamsFx = function (team) {
      $scope.tl.isOpen = !$scope.tl.isOpen;
      $scope.channel.teams = team;
      $scope.channelLoading = true;
      if($scope.channel.channel){
        $scope.channel.channel = "";
        $scope.authSaveDisable = true;
      }
      $scope.getChannelsFX(team)
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }

    $scope.channelSearchFocus = function () {
      $scope.searchChannel = { displayName: "" };
      if ($scope.channelList.length > 5) {
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $rootScope.selChannelFx = function (channel) {
      if(channel.tenantId){
        channel.tenantId = $scope.decryptFx(channel.tenantId);
      }

      $scope.channel.channel = channel;
      $scope.cl.isOpen = !$scope.cl.isOpen;
      $scope.authSaveDisable = false;
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }

    $scope.toggleCallback= function(open){
      $scope.searchTeams.teamName = "";
      $scope.searchChannel.displayName = "";
    }

    $scope.getChannelsFX = function(team){
      $scope.getChannel = {"id":$scope.channel.id, "team":team};
      TeamsChannelSrv.getChannels($scope.getChannel).then(
        function(data){
          $scope.showChannelList = true;
          $scope.channelList = data.channels;
          $scope.channelLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.showChannelList = false;
          $scope.channelLoading = false;
        }
      );
    }


    $scope.channelFx = function(tab, caller){
      $scope.channel.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.channel.dType == "l"){
          $scope.channel.settings = angular.copy($scope.list.settings);
          $scope.channel.ctype = angular.copy($scope.list.ctype);
        } else if($scope.channel.dType == "t"){
          $scope.channel.settings = angular.copy($scope.textMedia.settings);
          $scope.channel.ctype = angular.copy($scope.textMedia.ctype);
        } else if($scope.channel.dType == "m"){
          $scope.channel.settings = angular.copy($scope.media.settings);
          $scope.channel.ctype = angular.copy($scope.media.ctype);
        }

        if($scope.channel.labelOpt == "c" && $scope.channel.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
        // }else if ($scope.channel.channel == "") {
        //   $scope.errType = "channel";
        //   $scope.hasErr = true;
        } else if($scope.channel.teamsChannelReq.teamsChannelApp == "ca" && ($scope.channel.teamsChannelReq.tenantId == "" || $scope.channel.teamsChannelReq.clientId == "" || $scope.channel.teamsChannelReq.secret == "")){
          $scope.errType = "allEmpty";
          $scope.hasErr = true;
        } else if ($scope.channel.dType === "l" && $scope.channel.settings.reloadOpt == 'c' && !$scope.channel.settings.reload) {
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else if ($scope.channel.settings.rotationOpt  == 'c' && !$scope.channel.settings.rotate) {
          $scope.errType = "rotate";
          $scope.hasErr = true;
        } else if ($scope.channel.dType === "l" && !$scope.channel.settings.headerSize) {
          $scope.errType = "hSize";
          $scope.hasErr = true;
        } else if ($scope.channel.dType === "l" && !$scope.channel.settings.subtitleSize) {
          $scope.errType = "sSize";
          $scope.hasErr = true;
        } else if (($scope.channel.dType === "l" || $scope.channel.dType === "t") && !$scope.channel.settings.titleSize) {
          $scope.errType = "tSize";
          $scope.hasErr = true;
        } else if (($scope.channel.dType === "l" || $scope.channel.dType === "t") && !$scope.channel.settings.descSize) {
          $scope.errType = "dSize";
          $scope.hasErr = true;
        } else if(tab == 1){
          $scope.authSaveDisable = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.channel.isAuth == 1 && !$scope.channel.teams){
            TeamsChannelSrv.getVerify($scope.channel.id).then(
              function(data){
                $scope.channel.isAuth = true;
                $scope.teamsList = data.teams;
              },
              function(err){
                $log.error(err);
              }
            );
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveChannelFx();
              $scope.isPEOpen = false;
            }, 250);
          }
          else{
            $scope.saveChannelFx();
            $scope.isPEOpen = false;
          }
        }
        else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveChannelFx(caller);
            }, 250);
          } else{
            $scope.saveChannelFx(caller);
          }
        }
      }

    }

    $scope.saveChannelFx = function(caller){
      if(caller == "save"){
        $scope.channel.toast = true;
      } else{
        $scope.channel.toast = false;
      }
      if(caller == "save" && !$scope.channel.isAuth){
        $scope.hasErr = true;
        $scope.errType = "authEmpty";
        $scope.saveProcessing = false;
      }
      else{
        
        /* Encrypt */
        var tempChannel = angular.copy($scope.channel);
        if($scope.channel.teamsChannelReq.teamsChannelApp == "ca"){
          tempChannel.teamsChannelReq.tenantId = $scope.encryptFx($scope.channel.teamsChannelReq.tenantId);
          tempChannel.teamsChannelReq.clientId = $scope.encryptFx($scope.channel.teamsChannelReq.clientId);
          tempChannel.teamsChannelReq.secret = $scope.encryptFx($scope.channel.teamsChannelReq.secret);
        }

        if($scope.channel && $scope.channel.channel && $scope.channel.channel.tenantId){
          tempChannel.channel.tenantId = $scope.encryptFx($scope.channel.channel.tenantId);
        }

        TeamsChannelSrv.saveChannel(tempChannel).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.channel.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(data.code == 86401){
              $scope.errType = "invalid";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
        if($scope.channel.isAuth && $scope.channel.teams && $scope.channel.channel){
          TeamsChannelSrv.getAuthList($scope.channel.id, $scope.channel.teams.team_id).then(
            function(data){
              $scope.authSaveDisable = false;
              $scope.teamsList = data.teams;
              $scope.channelList = data.channel;
            },
            function(err){
              $log.error(err);
              $scope.authSaveDisable = true;
            }
          );
        }
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TableauController', TableauController);

  /** @ngInject */
  function TableauController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, TableauSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.authSuccess = false;
    $scope.groupShow = false;
    $scope.visualizShow = false;
    $scope.isLoading = false;
    $scope.isWorkspace = false;
    $scope.isPEOpen = false;
    $scope.groupList = [];
    $scope.encId = "";
    $scope.decId = 0;
    $scope.customData = {item:"", tab:""};
    $scope.selType = "single";
    $scope.settings = {reloadOpt:"n", reload:""};
    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.isReport = false;
    $scope.pages = [];

    $scope.settingsDefault = function(){
      $scope.tableau.settings = angular.copy($scope.defaultSettings);
    }

    $scope.getProjects = function(wId){
      $scope.proLoading = true;
      TableauSrv.getProjectList(wId).then(
        function(data){
          $scope.proLoading = false;
          $scope.projectList = data;
        }, function(err){
          $log.error(err);
        }
      );
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.isWorkspace = true;
      TableauSrv.getTableau($scope.decId).then(
        function(data){
          $scope.tableau = {info:data.info, settings:data.settings, tableau:data.tableau, activePeriod:data.activePeriod, permission:data.permission};
          $scope.tableauCopy = angular.copy(data);
          if($scope.tableau.info.wType=="ac"){
            $scope.getProjects($scope.decId);
            $scope.getWorkbook($scope.decId, $scope.tableau.tableau.project.projectId);
            $scope.getViews($scope.decId, $scope.tableau.tableau.project.projectId, $scope.tableau.tableau.workbook.workbookId);
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.tableau = {info:{label:"", wType:"ac", frameData:"", toast:false}, settings:angular.copy($scope.settings), tableau:{project:"", workbook:"", view:"", showTab:false, showToolBar:false}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
      $scope.getProjects($scope.decId);
    }

    $scope.getWorkbook = function(wId, pId){
      $scope.wbLoading = true;
      TableauSrv.getWorkbookList(wId, pId).then(
        function(data){
          $scope.wbLoading = false;
          $scope.wbList = data;
        }, function(err){
          $log.error(err);
        }
      );
    }

    $scope.getViews = function(wId, pId, wbId){
      $scope.viewLoading = true;
      TableauSrv.getViewList(wId, pId, wbId).then(
        function(data){
          $scope.viewLoading = false;
          $scope.viewList = data;
        }, function(err){
          $log.error(err);
        }
      );
    }

    $scope.selectItem = function(item, caller){
      if(caller=='p'){
        $scope.tableau.tableau.workbook = "";
        $scope.tableau.tableau.project = item;
        $scope.getWorkbook($scope.decId, item.projectId);
        angular.element(document).find('.customProject').removeClass('open');
      } else if(caller=='w'){
        $scope.tableau.tableau.view = "";
        $scope.tableau.tableau.workbook = item;
        $scope.getViews($scope.decId, $scope.tableau.tableau.projectId, item.workbookId);
        angular.element(document).find('.customWB').removeClass('open');
      } else {
        $scope.tableau.tableau.view = item;
        angular.element(document).find('.customView').removeClass('open');
      }
    }

    $scope.itemSearchFocus = function(caller){
      if(caller=='p'){
        $scope.searchItem = {project:""};
        if($scope.projectList.projects && $scope.projectList.projects.length > 5){
          angular.element(document).find(".findSearch").children()[0].focus();
        }
      } else if(caller=='w'){
        $scope.searchItem = {workbook:""};
        if($scope.wbList.workbooks && $scope.wbList.workbooks.length > 5){
          angular.element(document).find(".findSearch").children()[0].focus();
        }
      } else {
        $scope.searchItem = {view:""};
        if($scope.viewList.views && $scope.viewList.views.length > 5){
          angular.element(document).find(".findSearch").children()[0].focus();
        }
      }
    }

    $scope.tableauFx = function(tab, caller){
      $scope.tableau.info.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.tableau.info.label == ""){//$scope.tableau.labelOpt == "c" &&
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.tableau.info.wType == "epu" && $scope.tableau.info.frameData == ""){
        $scope.errType = "data";
        $scope.hasErr = true;
        $("#wData").focus();
      } else if($scope.tableau.info.wType == "ac" && $scope.tableau.tableau.project == ""){//$scope.tableau.labelOpt == "c" &&
        $scope.errType = "proId";
        $scope.hasErr = true;
        $("#project").focus();
      } else if($scope.tableau.info.wType == "ac" && $scope.tableau.tableau.workbook == ""){//$scope.tableau.labelOpt == "c" &&
        $scope.errType = "wbId";
        $scope.hasErr = true;
        $("#workbook").focus();
      } else if($scope.tableau.info.wType == "ac" && $scope.tableau.tableau.view == ""){//$scope.tableau.labelOpt == "c" &&
        $scope.errType = "viewId";
        $scope.hasErr = true;
        $("#view").focus();
      } else if($scope.tableau.settings.reloadOpt == "c" && ($scope.tableau.settings.reload == "" || $scope.tableau.settings.reload == null)){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveTableauFx();
          }, 250);
        } else{
          $scope.saveTableauFx();
        }
      }
    }

    $scope.selTypeFx = function(type){
      if(type == 's'){
        $scope.selType = "single";
      } else{
        $scope.selType = "custom";
      }
    }

    //get tab list on select report
    $scope.getTabList = function(rId){
      $scope.pages = [];
      $scope.isPLoading = true;
      TableauSrv.getReportTabs($scope.tableau.powerbi.group.id, rId, $scope.tableau.info.id).then(
        function(data){
          $scope.pages = data.pages;
          $scope.isPLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.isPLoading = false;
        }
      );
    }

    $scope.saveTableauFx = function(){
      $scope.tableau.info.toast = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.encId){
        $scope.tableau.info.toast = true;
      }
      if($scope.tableau.info.wType=="epu"){
        delete $scope.tableau.tableau.project;
        delete $scope.tableau.tableau.workbook;
        delete $scope.tableau.tableau.view;
      }
      TableauSrv.saveTableau($scope.tableau).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 8650){
            $scope.hasErr = true;
            $scope.errType = "invInfo";
          } else {
            $state.go("hub.contentLibrary.c");
          }
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SurveyController', SurveyController);

  /** @ngInject */
  function SurveyController($log, $rootScope, $scope, $state, $cookies, $filter, $window, $timeout, ngDialog, SurveySrv){
    $scope.colorPicker = {b:false, tt:false, dt:false, rb:false, rab:false, qc:false, ac:false, pb:false, p:false, pc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.refreshLoading = false;
    $scope.editQForm = {isEdit:false};
    $scope.isPEOpen = false;
    $scope.titleDesc = {};
    $scope.curResultGrp;
    $scope.survey = {};
    $scope.encId = "";
    $scope.decId = "";
    $scope.count = 1;
    $scope.columnArr = [];
    $scope.optLabel = "A";
    $scope.curSort = 1;
    $scope.isQDesc = false;
    $scope.optArr = [{id:"tmp-" + $scope.count, opt:"", label:$scope.optLabel}];

    $scope.settings = {
      settings:{
        info:{bg:"#ffffff", bga:0, title:"", titleText:"#ffffff", titleSize:30, titleFont:$scope.fontFamilySelected, desc:"", descText:"#ffffff", descSize:12, descFont:$scope.fontFamilySelected},
        result:{bg:"#ffffff", bga:1, altBg:"#f3f3f3", altBga:1, qColor:"#444444", qSize:24, qFont:$scope.fontFamilySelected, aColor:"#444444", aSize:16, aFont:$scope.fontFamilySelected, pBarBg:"#f3f3f3", pBarBga:1, pBg:"#3d85c6", pColor:"#ffffff"}
      },
      ctype:{
        info:{bg:"monochrome", titleText:"monochrome", descText:"monochrome"},
        result:{bg:"monochrome", altBg:"monochrome", qColor:"monochrome", aColor:"monochrome", pBarBg:"monochrome", pBg:"default", pColor:"monochrome"}
      }
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.titleDesc = angular.copy({title:$scope.survey.info.settings.title, desc:$scope.survey.info.settings.desc});
      $scope.survey.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.survey.info.ctype = angular.copy($scope.defaultSettings.ctype);

      $scope.survey.info.settings.title = angular.copy($scope.titleDesc.title);
      $scope.survey.info.settings.desc = angular.copy($scope.titleDesc.desc);
    }

    $scope.getSurveyFx = function(){
      $scope.detailLoading = true;
      SurveySrv.getSurvey($scope.decId).then(
        function(data){
          $scope.survey = data;
          $scope.titleDesc = angular.copy({title:$scope.survey.info.settings.title, desc:$scope.survey.info.settings.desc});
          $scope.detailLoading = false;
          $scope.resetTableCol($scope.survey.questionList);
        },
        function(err){
          $log.error(err);
        }
      );
    }
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.getSurveyFx();
    } else{
      $rootScope.tabView = true;
      $scope.survey = {
        info:{
          label:"",
          statusType:0,
          settings:angular.copy($scope.settings.settings),
          ctype:angular.copy($scope.settings.ctype)
        },
        permission:{type:$scope.auth.upreferences.defaultP},
        activePeriod:{type:"a"}
      };
    }

    //reset survey table column
    $scope.resetTableCol = function(arr){
      var x = 0;
      angular.forEach(arr, function(item, index){
        if(item.opt.length > x && item.selType != 2){
          x = item.opt.length;
          $scope.columnArr = item.opt;
          $scope.maxW = (100 / $scope.columnArr.length);
          $scope.colWidthStyle = {"width":$scope.maxW + "%"}
        } else if(item.opt.length == x && item.selType == 2){
          $scope.columnArr = [];
          $scope.colWidthStyle = {"width":"100%"};
        }
      });
    }

    $scope.addQuestion = {id:"q-" + $scope.curSort, question:"", opt:"", selType:0, sort:$scope.curSort};
    $scope.survey.questionList = [];
    $scope.addQuestionFx = function(action){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.curOptCount = 0;
      $scope.errType = "";

      if($scope.addQuestion.question == ""){
        $scope.hasListErr = true;
        $scope.errType = "question";
        $("#question").focus();
      } else if($scope.optArr.length < 2 && !$scope.isQDesc){
        $scope.hasListErr = true;
        $scope.errType = "opt";
      } else{
        var isEmpty = false;
        if(!$scope.isQDesc){
          if($scope.optEmptyCount($scope.optArr) < 2){
            isEmpty = true;
          }
        }
        if(isEmpty){
          $scope.hasListErr = true;
          $scope.errType = "opt";
        } else{
          $scope.optArr = $scope.reArrangeOpt($scope.optArr);
          if($scope.columnArr.length < $scope.optArr.length){
            $scope.columnArr = $scope.optArr;
            $scope.maxW = (100 / $scope.columnArr.length);
            $scope.colWidthStyle = {"width":$scope.maxW + "%"};
          }
          $scope.addQuestion.opt = $scope.optArr;
          if(action == 'e'){
            //update list
            angular.forEach($scope.survey.questionList, function(item, index){
              if(item.id == $scope.addQuestion.id){
                $scope.survey.questionList[index] = $scope.addQuestion;
              }
            });
            $scope.editQForm = {isEdit:false};
            $scope.resetTableCol($scope.survey.questionList);
          } else{
            $scope.survey.questionList.push($scope.addQuestion);
            $scope.curSort++;
          }
          $scope.resetQuestionFx();
        }
      }
    }

    $scope.resetQuestionFx = function(){
      $scope.hasListErr = false;
      $scope.isQDesc = false;
      $scope.count = 1;
      $scope.optLabel = "A";
      $scope.optArr = [{id:"tmp-" + $scope.count, opt:"", label:$scope.optLabel}];
      $scope.addQuestion = {id:"q-" + $scope.curSort, question:"", opt:[], selType:0, sort:$scope.curSort};
    }

    $scope.sortCallback = function(e, ui, index){
      $scope.questionListCopy = angular.copy($scope.survey.questionList);
      $scope.tempQuestionList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0;i < $scope.questionListCopy.length;i++){
          if(($scope.questionListCopy[i].id == $(this).attr("data-id"))){
            $scope.tempQuestionList.push($scope.questionListCopy[i]);
            $scope.questionListCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.survey.questionList = [];
      $scope.$apply(function(){
        $scope.survey.questionList = angular.copy($scope.tempQuestionList);
      });
    }

    //re-arrange alphabet order
    $scope.reArrangeOpt = function(optArr){
      var count = 1;
      var oChar = "A";
      $scope.newArr = [];
      angular.forEach(optArr, function(item, $index){
        if(item.opt != ""){
          $scope.newArr.push({id:"tmp-" + count, opt:item.opt, label:oChar});
          count++;
          oChar = $scope.increamentChar(oChar);
        }
      });
      return $scope.newArr;
    }

    $scope.optEmptyCount = function(){
      var count = 0;
      angular.forEach($scope.optArr, function(item){
        if(item.opt != ""){
          count++;
        }
      });
      return count;
    }

    $scope.addMoreOptFx = function(index){
      if($scope.optArr.length < 10){
        $scope.count++;
        $scope.optLabel = String.fromCharCode($scope.optLabel.charCodeAt(0) + 1);
        $scope.optArr.push({id:"tmp-" + $scope.count, opt:"", label:$scope.optLabel});
      } else{
        $scope.hasListErr = true;
        $scope.errType = "maxopt";
      }
    }

    $scope.increamentChar = function(char){
      return String.fromCharCode(char.charCodeAt(0) + 1);
    }

    $scope.delOpt = function(index){
      $scope.confirmOthObj = {index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.survey.m13" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger" ng-click="delOptFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-redo fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.delOptFx = function(){
      $scope.popupProcessing = false;
      $scope.hasListErr = false;
      $scope.optArr.splice($scope.confirmOthObj.index, 1);
      if($scope.optArr.length <= 1){
        $scope.count = 1;
        $scope.optLabel = "A";
        $scope.optArr = [{id:"tmp-" + $scope.count, opt:"", label:$scope.optLabel}];
      }
      ngDialog.close();
    }

    $scope.questionOpen = function(index){
      $scope.questionObj = {index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.survey.m6" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="removeQuestionFx();" focus-me="true">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.removeQuestionFx = function(){
      $scope.survey.questionList.splice($scope.questionObj.index, 1);
      $scope.resetTableCol($scope.survey.questionList);
      ngDialog.close();
    }

    $scope.editQFx = function(data){
      $scope.editQForm = {isEdit:true};
      $scope.addQuestion = angular.copy(data);
      $scope.optArr = angular.copy(data.opt);
      if(data.selType != 2){
        $scope.curSort = data.opt.length;
        $scope.optLabel = String.fromCharCode(data.opt[$scope.curSort - 1].label.charCodeAt(0));
      } else{
        $scope.queTypeFx(data.selType);
      }
    }

    $scope.statusOpen = function(caller){
      $scope.statusObj = {type:caller};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{statusObj.type=="f"?"cl.widget.survey.m7":"cl.widget.survey.m8" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-warning" ng-click="statusFx();" focus-me="true" ng-disabled="finishedProcessing"><span class="fa fa-repeat fa-spin" ng-if="finishedProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.statusFx = function(){
      $scope.finishedProcessing = true;
      SurveySrv.saveStatus({id:$scope.decId, type:$scope.statusObj.type}).then(
        function(data){
          $scope.finishedProcessing = false;
          $scope.survey.info.statusType = data.statusType;
          ngDialog.close();
          if($scope.statusObj.type == "r"){
            $scope.getSurveyFx();
          }
          if($rootScope.selectedT == "3"){
            $scope.getResultFx(0, "all");
          }
        },
        function(err){
          $log.error(err);
          $scope.finishedProcessing = false;
        }
      );
    }

    $scope.getResultFx = function(vid, caller, event){
      SurveySrv.getResult({id:$scope.decId, vid:vid}).then(
        function(data){
          if(caller == "all"){
            $scope.results = data;
          } else{
            angular.forEach($scope.results, function(item, $index){
              if(vid == item.id){
                $scope.results[$index].result = data.result;
                $(event.currentTarget).closest(".folder-heading").find(".replace-icon").addClass("icon-open text-primary");//fa-plus-square-o
                $(event.currentTarget).closest(".surveyQuad").children(".folder-content").addClass("show");
                $scope.refreshLoading = false;
              }
            });
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.refreshFx = function(event, vid){
      $scope.refreshLoading = true;
      $scope.getResultFx(vid, "single", event);
    }
    $scope.folderFx = function(event, vid, resultLength){
      if(!$(event.currentTarget).closest(".surveyQuad").children(".folder-content").hasClass('show') && resultLength == 0){
        $scope.getResultFx(vid, "single", event);
      } else{
        $(event.currentTarget).find('.replace-icon').toggleClass('icon-open text-primary');
        $(event.currentTarget).closest(".surveyQuad").children(".folder-content").toggleClass('show');
      }
    }

    $scope.exportFx = function(vid){
      SurveySrv.export({id:$scope.decId, version:vid}).then(
        function(data){
          if(data && data.download){
            $window.open(data.download, '_blank');
          }
        },
        function(err){
          $log.error(err);
        }
      )
    }

    $scope.surveyFx = function(tab, caller){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.survey.info.isSave = 1;

      if(tab == 2 || tab == 3 || tab == "save"){
        if(tab == 2 || tab == "save"){
          $scope.survey.info.fid = $scope.fid;
          if($scope.survey.info.label == ""){
            $scope.errType = "name";
            $scope.hasErr = true;
            $("#label").focus();
          } else if(!$scope.survey.info.settings.info.titleSize){
            $scope.errType = "tSize";
            $scope.hasErr = true;
            $("#titleSize").focus();
          } else if(!$scope.survey.info.settings.info.descSize){
            $scope.errType = "dSize";
            $scope.hasErr = true;
            $("#descSize").focus();
          } else if(!$scope.survey.info.settings.result.qSize){
            $scope.errType = "qSize";
            $scope.hasErr = true;
            $("#resultQSize").focus();
          } else if(!$scope.survey.info.settings.result.aSize){
            $scope.errType = "aSize";
            $scope.hasErr = true;
            $("#resultASize").focus();
          } else{
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                if(tab == 2){
                  $scope.tabFx(2);
                }
                if(tab == "save"){
                  $scope.saveSurvey();
                }
                $scope.isPEOpen = false;
              }, 250);
            } else{
              if(tab == 2){
                $scope.tabFx(2);
              }
              if(tab == "save"){
                $scope.saveSurvey();
              }
              $scope.isPEOpen = false;
            }
          }
        } else if(tab == 3){
          $scope.tabFx(3);
          $scope.survey.info.isSave = 0;
          $scope.saveSurvey(3);
          $scope.detailLoading = true;
        } else{
          $scope.survey.info.fid = $scope.fid;
          // if($scope.survey.info.label == ""){
          //   $scope.errType = "name";
          //   $scope.hasErr = true;
          //   $("#label").focus();
          // } else if(!$scope.survey.info.settings.info.titleSize){
          //   $scope.errType = "tSize";
          //   $scope.hasErr = true;
          //   $("#tSize").focus();
          // } else if(!$scope.survey.info.settings.info.descSize){
          //   $scope.errType = "dSize";
          //   $scope.hasErr = true;
          //   $("#dSize").focus();
          // } else if(!$scope.survey.info.settings.result.qSize){
          //   $scope.errType = "qSize";
          //   $scope.hasErr = true;
          //   $("#qSize").focus();
          // } else if(!$scope.survey.info.settings.result.aSize){
          //   $scope.errType = "aSize";
          //   $scope.hasErr = true;
          //   $("#aSize").focus();
          // } else{
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveSurvey();
              }, 250);
            } else{
              $scope.saveSurvey();
            }
          // }
        }
      }
    }

    $scope.saveSurvey = function(tab){
      $scope.saveProcessing = true;
      SurveySrv.saveSurvey($scope.survey).then(
        function(data){
          $scope.saveProcessing = false;
          if(tab != 3){
            $state.go("hub.contentLibrary.c");
          } else{
            $scope.getResultFx(0, "all");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.queTypeFx = function(qType){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      if(qType == 0 || qType == 1){
        $scope.isQDesc = false;
      } else{
        $scope.isQDesc = true;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('StormController', StormController);

  /** @ngInject */
  function StormController($log, $rootScope, $scope, $state, $timeout, StormSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.timestamp = moment().format('x');
    $scope.colorPicker = {b:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.search = {text:""};
    $scope.curBtnCaller = "";
    $scope.isPEOpen = false;
    $scope.isCred = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      reloadOpt:"n", reload:"", bg:"#000000", bga:1,
      ctype:{bg:"monochrome"}
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings)};

    $scope.settingsDefault = function(){
      $scope.storm.settings = angular.copy($scope.defaultSettings.settings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      StormSrv.getStorm($scope.decId).then(
        function(data){
          $scope.storm = data;
          $scope.tim = $scope.storm.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.storm.otherinfo.bucket;
          if($scope.storm.otherinfo.mbucket && $scope.storm.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.storm.otherinfo.mbucket;
          }
          if(!$scope.storm.settings.bg){
            $scope.storm.settings.bg = "#000000";
            $scope.storm.settings.bga = 1;
            $scope.storm.settings.ctype = {bg:"monochrome"};
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.isCred = true;
      $scope.storm = {label:"", u:"", p:"", cp:"", did:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings),ctype:angular.copy($scope.ctype)
      };
    }

    $scope.resetFx = function(){
      $scope.isCred = true;
    }

    $scope.stormFx = function(){
      $scope.storm.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.storm.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      }
      else if($scope.isCred && (!$scope.storm.u || $scope.storm.u == "")){
        $scope.errType = "uName";
        $scope.hasErr = true;
        $("#uName").focus();
      }
      else if($scope.isCred && (!$scope.storm.p || $scope.storm.p == "")){
        $scope.errType = "pass";
        $scope.hasErr = true;
        $("#pass").focus();
      }
      else if($scope.isCred && (!$scope.storm.cp || $scope.storm.cp == "")){
        $scope.errType = "cPass";
        $scope.hasErr = true;
        $("#cPass").focus();
      } else if($scope.isCred && $scope.storm.p != $scope.storm.cp){
        $scope.hasErr = true;
        $scope.errType = "match";
        $("#cPass").focus();
      } 
       else if($scope.storm.settings.reloadOpt == "c" && ($scope.storm.settings.reload == "" || $scope.storm.settings.reload == null)){
        $scope.errType = "reloadEmpty";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.storm.settings.reload && $scope.storm.settings.reload < 10){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveStormFx();
          }, 250);
        } else{
          $scope.saveStormFx();
        }
      }
    }
    $scope.saveStormFx = function(){
      $scope.saveProcessing = true;
      var curStorm = angular.copy($scope.storm);
      if($scope.isCred){
        curStorm.u = $scope.encryptFx($scope.storm.u);
        curStorm.p = $scope.encryptFx($scope.storm.p);
        curStorm.cp = $scope.encryptFx($scope.storm.cp);
      }
      StormSrv.saveStorm(curStorm).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('StockPriceController', StockPriceController);

  /** @ngInject */
  function StockPriceController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, StockPriceSrv){
    $scope.colorPicker = {b:false, s:false, n:false, p:false, hp:false, lp:false, cp:false, cn:false, e:false, bc:false, hb:false, ht:false, rb:false, arb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.curStock = {sym:""};
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.settingsS1 = {settings:{bg:"#444444", bga:1, s:"#cccccc",sSize:24,sFont:$scope.fontFamily[62], n:"#ffffff",nSize:24,nFont:$scope.fontFamily[62], p:"#ffff00",pSize:68,pFont:$scope.fontFamily[62], cp:"#00ff00", cn:"#ff0000",cpnSize:24,cpnFont:$scope.fontFamily[62], e:"#cccccc",eSize:24,eFont:$scope.fontFamily[62]},
      ctype:{bg:"monochrome", s:"monochrome", n:"monochrome", p:"basic", cp:"basic", cn:"basic", e:"monochrome"}
    };
    $scope.settingsS2 = {settings:{bg:"#444444", bga:1, s:"#cccccc",sSize:24,lang:"en_US",sFont:$scope.fontFamily[62], n:"#ffffff",nSize:24,nFont:$scope.fontFamily[62], p:"#ffff00",pSize:68,pFont:$scope.fontFamily[62], hp:"#6fa8dc",hpSize:14,hpFont:$scope.fontFamily[62], lp:"#6fa8dc",lpSize:14,lpFont:$scope.fontFamily[62], hpv:"#ffff00",hpvSize:14,hpvFont:$scope.fontFamily[62], lpv:"#ffff00",lpvSize:14,lpvFont:$scope.fontFamily[62], cp:"#00ff00", cn:"#ff0000",cpnSize:24,cpnFont:$scope.fontFamily[62], e:"#cccccc",eSize:24,eFont:$scope.fontFamily[62]},
      ctype:{bg:"monochrome", s:"monochrome", n:"monochrome", p:"basic",  hpv:"basic", lpv:"basic", hp:"default", lp:"default",cp:"basic", cn:"basic", e:"monochrome"}
    };
    $scope.settingsMC = {settings:{bg:"#0b5394", bga:1, s:"#ffffff", n:"#ffffff", p:"#ffff00", cp:"#00ff00", cn:"#ff0000", b:"#990000", speed:100, font:$scope.fontFamily[56], fontSizeOpt:"a", fontSize:16},
      ctype:{bg:"default", s:"monochrome", n:"monochrome", p:"basic", cp:"basic", cn:"basic", b:"default"}
    };
    $scope.settingsML = {settings:{rotationOpt:"a", rotate:12, s:"#cccccc", n:"#ffffff", p:"#ffff00", cp:"#00ff00", cn:"#ff0000", header:{active:true, column1:"NAME", column2:"VALUE", column3:"NET CHANGE", column4:"% CHANGE"}, hb:"#0b5394", hba:1, ht:"#ffffff", hf:$scope.fontFamily[56], hs:14, rb:"#444444", rba:1, ab:"#666666", aba:1, rf:$scope.fontFamily[56], rs:14},
      ctype:{bg:"default", s:"monochrome", n:"monochrome", p:"basic", cp:"basic", cn:"basic", hb:"default", ht:"monochrome", rb:"monochrome", ab:"monochrome"}
    };
    $scope.rgbaS1 = {bg:$scope.settingsS1.settings.bg};
    $scope.rgbaS2 = {bg:$scope.settingsS2.settings.bg};
    $scope.rgbaMC = {bg:$scope.settingsMC.settings.bg};
    $scope.rgbaML = {hb:$scope.settingsML.settings.hb, rb:$scope.settingsML.settings.rb, ab:$scope.settingsML.settings.ab};


    $scope.defaultSettingsS1 = angular.copy($scope.settingsS1);
    $scope.defaultSettingsS2 = angular.copy($scope.settingsS2);
    $scope.defaultSettingsMC = angular.copy($scope.settingsMC);
    $scope.defaultSettingsML = angular.copy($scope.settingsML);

    $scope.settingsDefault = function(){
      if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't1'){
        $scope.settingsS1 = angular.copy({settings:$scope.defaultSettingsS1.settings, ctype:$scope.defaultSettingsS1.ctype});
        $scope.rgbaS1 = {bg:$scope.settingsS1.settings.bg};
      } else if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't2'){
        $scope.settingsS2 = angular.copy({settings:$scope.defaultSettingsS2.settings, ctype:$scope.defaultSettingsS2.ctype});
        $scope.rgbaS2 = {bg:$scope.settingsS2.settings.bg};
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't1'){
        $scope.settingsMC = angular.copy({settings:$scope.defaultSettingsMC.settings, ctype:$scope.defaultSettingsMC.ctype});
        $scope.rgbaMC = {bg:$scope.settingsMC.settings.bg};
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't2'){
        $scope.settingsML = angular.copy({settings:$scope.defaultSettingsML.settings, ctype:$scope.defaultSettingsML.ctype});
        $scope.rgbaML = {hb:$scope.settingsML.settings.hb, rb:$scope.settingsML.settings.rb, ab:$scope.settingsML.settings.ab};
      }
    }


    $scope.getListFx = function(caller){
      $scope.curStock = {sym:""};
      if(caller == "exc"){
        $scope.detailLoading = true;
        StockPriceSrv.getStockExc().then(
          function(data){
            $scope.stockExcList = data;
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "sym" || caller == "symE"){
        $scope.stockSymLoading = true;
        StockPriceSrv.getStockSym($scope.stockPrice.stockExc.id).then(
          function(data){
            $scope.stockSymList = data;
            if($scope.stockPrice.type == "s"){
              if(caller == "symE"){
                $scope.curStock.sym = "";
              } else{
                $scope.curStock.sym = $scope.stockPrice.stockSym[0];
              }
            } else if($scope.stockPrice.type == "m"){
              angular.forEach($scope.stockPrice.stockSym, function(sym){
                angular.forEach($scope.stockSymList, function(sSym){
                  if(sym.id == sSym.id){
                    sSym.selected = true;
                  }
                });
              });
            }
            $scope.stockSymLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $scope.getListFx("exc");

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      StockPriceSrv.getStockPrice($scope.decId).then(
        function(data){
          $scope.stockPrice = data;
          if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't1'){
            if(!$scope.stockPrice.settings.sSize){
              $scope.stockPrice.settings.sSize = 24;
            }
            if(!$scope.stockPrice.settings.nSize){
              $scope.stockPrice.settings.nSize = 24;
            }
            if(!$scope.stockPrice.settings.pSize){
              $scope.stockPrice.settings.pSize = 68;
            }
            if(!$scope.stockPrice.settings.cpnSize){
              $scope.stockPrice.settings.cpnSize = 24;
            }
            // if(!$scope.stockPrice.settings.eSize){
            //   $scope.stockPrice.settings.eSize = 24;
            // }
            if(!$scope.stockPrice.settings.sFont){
              $scope.stockPrice.settings.sFont = $scope.fontFamily[56];
            }
            if(!$scope.stockPrice.settings.nFont){
              $scope.stockPrice.settings.nFont = $scope.fontFamily[56];
            }
            if(!$scope.stockPrice.settings.pFont){
              $scope.stockPrice.settings.pFont = $scope.fontFamily[56];
            }
            // if(!$scope.stockPrice.settings.eFont){
            //   $scope.stockPrice.settings.eFont = $scope.fontFamily[56];
            // }
            if(!$scope.stockPrice.settings.cpnFont){
              $scope.stockPrice.settings.cpnFont = $scope.fontFamily[56];
            }
            $scope.settingsS1.settings = angular.copy($scope.stockPrice.settings);
            $scope.settingsS1.ctype = angular.copy($scope.stockPrice.ctype);
            $scope.rgbaS1 = {bg:$scope.hax2rgba($scope.settingsS1.settings.bg, $scope.settingsS1.settings.bga)};
          } else if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't2'){
            $scope.settingsS2.settings = angular.copy($scope.stockPrice.settings);
            $scope.settingsS2.ctype = angular.copy($scope.stockPrice.ctype);
            $scope.rgbaS2 = {bg:$scope.hax2rgba($scope.settingsS2.settings.bg, $scope.settingsS2.settings.bga)};
          } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't1'){
            if(!$scope.stockPrice.settings.fontSizeOpt){
              $scope.stockPrice.settings.fontSizeOpt = "a";
            }
            if(!$scope.stockPrice.settings.fontSize){
              $scope.stockPrice.settings.fontSize = 16;
            }
            $scope.settingsMC.settings = angular.copy($scope.stockPrice.settings);
            $scope.settingsMC.ctype = angular.copy($scope.stockPrice.ctype);
            $scope.rgbaMC = {bg:$scope.hax2rgba($scope.settingsMC.settings.bg, $scope.settingsMC.settings.bga)};
          } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't2'){
            $scope.settingsML.settings = angular.copy($scope.stockPrice.settings);
            $scope.settingsML.ctype = angular.copy($scope.stockPrice.ctype);
            $scope.rgbaML = {hb:$scope.hax2rgba($scope.settingsML.settings.hb, $scope.settingsML.settings.hba), rb:$scope.hax2rgba($scope.settingsML.settings.rb, $scope.settingsML.settings.rba), ab:$scope.hax2rgba($scope.settingsML.settings.ab, $scope.settingsML.settings.aba)};
          }
          if($scope.stockPrice.stockExc){
            $scope.getListFx('sym');
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.stockPrice = {label:"", graph:false, type:"s",template:"t1", stockExc:"", stockSym:[], activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settingsS1.settings),
        ctype:angular.copy($scope.settingsS1.ctype)
      };//stockID:""
    }

    $scope.singleSymFx = function(){
      $scope.curStock.sym = angular.fromJson($scope.curStock.sym);
    }

    $scope.stockFx = function(){
      $scope.stockPrice.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.stockPrice.stockSym = [];

      if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't1'){
        $scope.stockPrice.settings = angular.copy($scope.settingsS1.settings);
        $scope.stockPrice.ctype = angular.copy($scope.settingsS1.ctype);
      }
      else if($scope.stockPrice.type == "s" && $scope.stockPrice.template == 't2'){
        $scope.stockPrice.settings = angular.copy($scope.settingsS2.settings);
        $scope.stockPrice.ctype = angular.copy($scope.settingsS2.ctype);
      }
      else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't1'){
        $scope.stockPrice.settings = angular.copy($scope.settingsMC.settings);
        $scope.stockPrice.ctype = angular.copy($scope.settingsMC.ctype);
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't2'){
        $scope.stockPrice.settings = angular.copy($scope.settingsML.settings);
        $scope.stockPrice.ctype = angular.copy($scope.settingsML.ctype);
      }

      if($scope.stockPrice.type == "s"){
        if($scope.curStock.sym){
          $scope.stockPrice.stockSym = [$scope.curStock.sym];
        }
      } else{
        $scope.stockPrice.stockSym = $filter("filter")($scope.stockSymList, {selected:true});
      }

      if($scope.stockPrice.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.stockPrice.stockExc == ""){
        $scope.errType = "exchange";
        $scope.hasErr = true;
        $("#countryList").focus();
      } else if(!$scope.stockPrice.stockSym.length){
        $scope.errType = "symbol";
        $scope.hasErr = true;
        $("#symbol").focus();
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.sSize){
        $scope.errType = "sSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.nSize){
        $scope.errType = "nSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.pSize){
        $scope.errType = "pSize";
        $scope.hasErr = true;
      // } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.eSize){
      //   $scope.errType = "eSize";
      //   $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.cpnSize){
        $scope.errType = "cpnSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.sSize){
        $scope.errType = "sSize";
        $scope.hasErr = true;
      // } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.nSize){
      //   $scope.errType = "nSize";
      //   $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.pSize){
        $scope.errType = "pSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.hpSize){
        $scope.errType = "hpSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.lpSize){
        $scope.errType = "lpSize";
        $scope.hasErr = true;
      // } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.hpvSize){
      //   $scope.errType = "hpvSize";
      //   $scope.hasErr = true;
      // } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.lpvSize){
      //   $scope.errType = "lpvSize";
      //   $scope.hasErr = true;
      // } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.eSize){
      //   $scope.errType = "eSize";
      //   $scope.hasErr = true;
      } else if($scope.stockPrice.type == 's' && $scope.stockPrice.template == 't2' && !$scope.stockPrice.settings.cpnSize){
        $scope.errType = "cpnSize";
        $scope.hasErr = true;
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't1' && !$scope.stockPrice.settings.speed){
        $scope.errType = "crawl";
        $scope.hasErr = true;
        $("#mcSpeed").focus();
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't1' &&  $scope.stockPrice.settings.fontSizeOpt == "c" && !$scope.stockPrice.settings.fontSize){
        $scope.errType = "fSize";
        $scope.hasErr = true;
        $("#mcFontSize").focus();
      } else if($scope.stockPrice.type == 'm' && $scope.stockPrice.template == 't2' && $scope.stockPrice.settings.rotationOpt == "c" && !$scope.stockPrice.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveStockPriceFx();
          }, 250);
        } else{
         $scope.saveStockPriceFx();
        }
      }
    }
    $scope.typeChange = function(caller){
      if(caller == "s"){
        $scope.stockPrice.template = "t1"
      }
      else{
        $scope.stockPrice.template = "t1"
      }
    }
    $scope.saveStockPriceFx = function(){
      StockPriceSrv.saveStockPrice($scope.stockPrice).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SocialChorusController', SocialChorusController);

  /** @ngInject */
  function SocialChorusController($log, $rootScope, $scope, $state, $cookies, $timeout, SocialChorusSrv){
    // $scope.colorPicker = {b:false, hb:false, ht:false, rb:false, rt:false, arb:false, art:false};
    $scope.colorPicker = {headerBg: false, headerText: false,bg: false,rowBg: false,altBg: false,titleText: false,descText: false,altTitleText: false,altDescText: false,textBg: false,text: false,subtitleText:false,  altSubtitleText:false};
    
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.chLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;

    $scope.list = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#6fa8dc", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#6fa8dc", subtitleText:"#999999", descText:"#444444", altTitleText:"#6fa8dc", altSubtitleText:"#999999", altDescText:"#444444", rowFont:$scope.fontFamily[56], altRowFont:$scope.fontFamily[56], headerSize:26, titleSize:16, subtitleSize:16, descSize:18},
      ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome", subtitleText:"monochrome", altSubtitleText:"monochrome"}
    }

    $scope.textMedia = {
      settings:{
        bg:"#ffffff", bga:1, align:"l", textBg:"#ffffff", textBga:1, titleText:"#6fa8dc", descText:"#444444", titleSize:16, descSize:18, titleFont:$scope.fontFamilySelected, descFont:$scope.fontFamilySelected, rotationOpt:"a", rotate:12
      },
      ctype:{bg:"monochrome", textBg:"monochrome", titleText:"default", descText:"monochrome"}
    }

    $scope.media = {
      settings:{bg:"#ffffff", bga:1, rotationOpt:"a", rotate:12},
      ctype:{bg:"monochrome"}
    }

    $scope.defaultSettingsList = angular.copy($scope.list);
    $scope.defaultSettingstextMedia = angular.copy($scope.textMedia);
    $scope.defaultSettingsmedia = angular.copy($scope.media);

    $scope.settingsDefault = function(){
      if($scope.sch.dType == "l"){
        $scope.list = angular.copy({settings:$scope.defaultSettingsList.settings, ctype:$scope.defaultSettingsList.ctype});
      } else if($scope.sch.dType == "t"){
        $scope.textMedia = angular.copy({settings:$scope.defaultSettingstextMedia.settings, ctype:$scope.defaultSettingstextMedia.ctype});
      } else{
        $scope.media = angular.copy({settings:$scope.defaultSettingsmedia.settings, ctype:$scope.defaultSettingsmedia.ctype});
      }
    }

    $scope.dTypeChange = function(caller){
      $scope.sch.settings = {};
      $scope.sch.ctype = {};
      if(caller == "l"){
        $scope.sch.settings = angular.copy($scope.list.settings);
        $scope.sch.ctype = angular.copy($scope.list.ctype);
      } else if(caller == "t"){
        $scope.sch.settings = angular.copy($scope.textMedia.settings);
        $scope.sch.ctype = angular.copy($scope.textMedia.ctype);
      } else {
        $scope.sch.settings = angular.copy($scope.media.settings);
        $scope.sch.ctype = angular.copy($scope.media.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.chLoading = true;
      SocialChorusSrv.getSch($scope.decId).then(
        function(data){
          $scope.sch = data;
          if(!data.dType){
            $scope.sch.dType = "t";
          }

          if($scope.sch.dType == "l"){
            $scope.list.settings = angular.copy($scope.sch.settings);
            $scope.list.ctype = angular.copy($scope.sch.ctype);
          } else if($scope.sch.dType == "t"){
            $scope.textMedia.settings = angular.copy($scope.sch.settings);
            $scope.textMedia.ctype = angular.copy($scope.sch.ctype);
            if(!$scope.sch.settings.rotationOpt){
              $scope.textMedia.settings.rotationOpt = "a";
              $scope.textMedia.settings.rotate = 12;
            }
          } else if($scope.sch.dType == "m"){
            $scope.media.settings = angular.copy($scope.sch.settings);
            $scope.media.ctype = angular.copy($scope.sch.ctype);
            if(!$scope.sch.settings.rotationOpt){
              $scope.media.settings.rotationOpt = "a";
              $scope.media.settings.rotate = 12;
            }
          }
          $scope.detailLoading = false;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.chLoading = true;
      $scope.sch = {
        label:"", channel:"", dType:"t", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.textMedia.settings),
        ctype:angular.copy($scope.textMedia.ctype)
      };
    }
    SocialChorusSrv.getChannelList().then(
      function(data){
        $scope.chLoading = false;
        $scope.channelList = data;
      }, function(err){
        $log.error(err);
      }
    );

    $scope.channelSearchFocus = function(){
      $scope.searchChannel = {name:""};
      if($scope.channelList.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $rootScope.changeChannelSetting = function(ch){
      $scope.sch.channel = ch;
      angular.element(document).find('.customSelectChannel').removeClass('open');
    }
    $scope.schFx = function(){
      $scope.sch.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.sch.dType == "l"){
        $scope.sch.settings = angular.copy($scope.list.settings);
        $scope.sch.ctype = angular.copy($scope.list.ctype);
      } else if($scope.sch.dType == "t"){
        $scope.sch.settings = angular.copy($scope.textMedia.settings);
        $scope.sch.ctype = angular.copy($scope.textMedia.ctype);
      } else if($scope.sch.dType == "m"){
        $scope.sch.settings = angular.copy($scope.media.settings);
        $scope.sch.ctype = angular.copy($scope.media.ctype);
      }
      
      if($scope.sch.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.sch.channel == ""){
        $scope.errType = "channel";
        $scope.hasErr = true;
        $("#channel").focus();
      } else if($scope.sch.dType === "t" && $scope.sch.settings.rotationOpt == 'c' && !$scope.sch.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#tRotate").focus();
      } else if($scope.sch.dType === "l" && $scope.sch.settings.rotationOpt == 'c' && !$scope.sch.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#lRotate").focus();
      } else if($scope.sch.dType === "m" && $scope.sch.settings.rotationOpt == 'c' && !$scope.sch.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#mRotate").focus();
      } else if($scope.sch.dType === "l" && $scope.sch.settings.hTextOpt == "c" && !$scope.sch.settings.hText){
        $scope.errType = "headerText";
        $scope.hasErr = true;
        $("#hText").focus();
      } else if($scope.sch.dType === "l" && $scope.sch.settings.hTextOpt != "n" && !$scope.sch.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#headerSize").focus();
      } else if(($scope.sch.dType === "l" || $scope.sch.dType === "t") && !$scope.sch.settings.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else if($scope.sch.dType === "l" && !$scope.sch.settings.subtitleSize){
        $scope.errType = "sSize";
        $scope.hasErr = true;
        $("#subtitleSize").focus();
      } else if(($scope.sch.dType === "l" || $scope.sch.dType === "t") && !$scope.sch.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
        $("#descSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveSchFx();
          }, 250);
        } else{
          $scope.saveSchFx();
        }
      }
    }
    $scope.saveSchFx = function(){
      SocialChorusSrv.saveSch($scope.sch).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SlackController', SlackController);

  /** @ngInject */
  function SlackController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, SlackSrv){
    $scope.colorPicker = {hb:false, ht:false, rb:false, arb:false, uc:false, dc:false, mc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.authSuccess = false;
    $scope.channelShow = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{ headerBg:"#ffffff", headerBga:1, headerText:"#6fa8dc", headerFont:$scope.fontFamilySelected, headerSize:24, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, font:$scope.fontFamilySelected, rowSize:16, userText:"#444444", dateText:"#999999", msgText:"#000000"},
      ctype:{headerBg:"monochrome", headerText:"default", rowBg:"monochrome", altBg:"monochrome", userText:"monochrome", dateText:"monochrome", msgText:"monochrome"}
    };
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.slack.settings = angular.copy($scope.defaultSettings.settings);
      $scope.slack.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      SlackSrv.getSlack($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.slack = data;
          $scope.channelList = data.channelList;
          if($scope.channelList && $scope.channelList.length > 0){
            $scope.slack.channel = $filter("filter")($scope.channelList, {isSelected:true})[0];
            $scope.channelShow = true;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.slack = {labelOpt:"a", label:"", toast:false, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){}
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      $scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        SlackSrv.getSlackVerify($scope.slack.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
            } else{
              $scope.channelList = data.channelList;
              $scope.channelShow = true;
              if(data.isClosed){
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.slackFx = function(tab, caller){
      $scope.slack.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.slack.labelOpt == "c" && $scope.slack.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.slack.settings.headerSize){
          $scope.errType = "headerSize";
          $scope.hasErr = true;
          $("#headerSize").focus();
        } else if(!$scope.slack.settings.rowSize){
          $scope.errType = "rowSize";
          $scope.hasErr = true;
          $("#rowSize").focus();
        } else if(tab == 1){
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveSlackFx(caller);
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $scope.saveSlackFx(caller);
            $scope.isPEOpen = false;
          }
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveSlackFx(caller);
            }, 250);
          } else{
            $scope.saveSlackFx(caller);
          }
        }
      }
    }

    $scope.saveSlackFx = function(caller){
      if(caller == "save"){
        $scope.slack.toast = true;
      } else{
        $scope.slack.toast = false;
      }
      if(caller == "save" && !$scope.channelList){
        $scope.errType = "authEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.channelList.length > 0 && !$scope.slack.channel){
        $scope.errType = "channel";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else{
        $scope.slack.channelList = null;
        SlackSrv.saveSlack($scope.slack).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.slack.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SelectSocialMediaController', SelectSocialMediaController);

  /** @ngInject */
  function SelectSocialMediaController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, ngDialog, SelectSocialMediaSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.authSuccess = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $rootScope.selectSocialIems = {widgets:[]};

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      SelectSocialMediaSrv.getSsm($scope.decId).then(
        function(data){
          $scope.ssm = data;

          $scope.cBucket = $scope.cDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.cDetailBucket = data.info.mbucket;
          }
          if($scope.ssm.widgets.length > 0){
            $rootScope.selectSocialIems.widgets = $scope.ssm.widgets;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.ssm = {label:"", toast:false,  activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
      8152
    }

    $scope.openSelectQuad = function(){
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectContent.html',
        width:1100,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        appendClassName:"ng-dialog-padT50",
        controller:'SelectSocialController'
      });
    }
    $scope.$on('contentInfo', function (event, args){
      $scope.tim = args.tim;
      $scope.cBucket = $scope.cDetailBucket = args.cBucket;
      $scope.cDetailBucket = args.cDetailBucket;
    });

    $scope.ssmFx = function(tab, caller){
      $scope.ssm.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.ssm.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveSsmFx(caller);
          }, 250);
        } else{
          $scope.saveSsmFx(caller);
        }
      }
    }

    $scope.saveSsmFx = function(caller){
      $scope.ssm.toast = true;
      $scope.ssm.widgets = $rootScope.selectSocialIems.widgets;
      SelectSocialMediaSrv.saveSsm($scope.ssm).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ScheduleCalendarController', ScheduleCalendarController);

  /** @ngInject */
  function ScheduleCalendarController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, ScheduleCalendarSrv){
    $scope.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    $scope.weekdays = [0, 1, 2, 3, 4, 5, 6];
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.currentPage = 0;
    $scope.encId = "";
    $scope.decId = "";
    $scope.weeks = [];
    $scope.curYear = new Date().getFullYear();
    $scope.curMonth = new Date().getMonth();
    $scope.previewProcessing = false;

    $scope.showCalendarFx = function(fx){
      $scope.currentPage += fx;
      $scope.generateCalendar($scope.preview.calendar[$scope.currentPage].label.split("|")[1], $scope.preview.calendar[$scope.currentPage].label.split("|")[0]);
    }

    $scope.generateCalendar = function(year, month){
      $scope.curMonth = month;
      $scope.startWeek = moment(new Date(year, month, 1)).startOf('month').week();
      $scope.endWeek = moment(new Date(year, month, 1)).endOf('month').week();
      if($scope.endWeek == 1){
        $scope.endWeek = 53;
      }
      $scope.curCalendar = [];
      for(var week = $scope.startWeek; week<=$scope.endWeek; week++){
        $scope.dateArr = [];
        for(var i=0; i<7; i++){
          $scope.dateArr.push(moment().week(week).startOf('week').clone().add(i, 'day'));
        }
        $scope.curCalendar.push({
          week:week,
          days:$scope.dateArr
        })
      }
    }

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(420);
      $scope.selectedHeight = $scope.getAvailableHeight(420);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(450) * 0.6;
      $scope.selectedHeight = $scope.getAvailableHeight(500) * 0.4;
    }

    $scope.generateMonthCalendar = function(fx){
      $scope.curYear += fx;
    }

    $scope.generateWeekCalendar = function(fx){
      $scope.curYear += fx;
      $scope.weeks = [];
      $scope.startDate = moment(new Date($scope.curYear,0,1)).isoWeekday(8);
      if($scope.startDate.date() == 8){
        $scope.startDate = $scope.startDate.isoWeekday(-6)
      }
      $scope.today = moment().isoWeekday('Sunday');
      $scope.endDate = moment(new Date($scope.curYear + 1,0,1)).isoWeekday('Sunday');

      while($scope.startDate.isBefore($scope.endDate)){
        $scope.startDateWeek = $scope.startDate.isoWeekday('Sunday').format('MM/DD/YYYY');
        $scope.endDateWeek = $scope.startDate.add(6,'days');
        $scope.endDateWeek = $scope.endDateWeek.format('MM/DD/YYYY')
        $scope.startDate.add(7,'days');
        $scope.weeks.push({sd:$scope.startDateWeek, ed:$scope.endDateWeek});
      }
    }
    $scope.generateWeekCalendar(0);
    $scope.selectedDay = [];
    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      ScheduleCalendarSrv.getScheduleCalendar($scope.decId).then(
        function(data){
          $scope.scheduleCalendar = data;
          if($scope.scheduleCalendar.dType == "d"){
            angular.forEach($scope.scheduleCalendar.selectedDates, function(item){
               $scope.selectedDay.push(moment(item));
            });
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.scheduleCalendar = {dType:"d", label:"", timezoneOpt:"z", toast:false, timezone:$scope.auth.defaultTimezone,
        activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP},
        date:{startDate:moment().format('L'), endDate:moment().format('L')},
        settings:{font:$scope.fontFamilySelected, colorOpt:"c", bg:"#ffffff", dateText:"#ffffff", timeText:"#000000", template:"t1", lang:"en_US", format:"12"},
        schedules:[],
        selectedDates:[],
        selectedWeeks:[],
        selectedMonths:[],
        selectedWeekDays:[true, true, true, true, true, true, true],
        ctype:{bg:"monochrome", date:"monochrome", time:"monochrome"}
      };
    }

    $scope.timezoneFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dateTime.timezoneOpt == "z" && $scope.dateTime.label == ""){
        $scope.dateTime.labelOpt = "a";
      } else{
        $scope.dateTime.labelOpt = "c";
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.errType = "";
      $scope.hasErr = false;
    }

    $scope.selectWeekFx = function(str){
      $scope.isDuplicate = false;
      angular.forEach($scope.scheduleCalendar.selectedWeeks, function(listItem){
        if(listItem == str){
          $scope.isDuplicate = true;
          return false;s
        }
      });
      if(!$scope.isDuplicate){
        $scope.scheduleCalendar.selectedWeeks.push(str);
      }
    }

    $scope.selectMonthFx = function(str){
      $scope.isDuplicate = false;
      angular.forEach($scope.scheduleCalendar.selectedMonths, function(listItem){
        if(listItem == str){
          $scope.isDuplicate = true;
          return false;s
        }
      });
      if(!$scope.isDuplicate){
        $scope.scheduleCalendar.selectedMonths.push(str);
      }
    }

    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.isDuplicate = false;
        angular.forEach($scope.scheduleCalendar.schedules, function(listItem){
          if(listItem.id == item.id){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate){
          $scope.curItem = $scope.schedulesList.schedules.filter(function(obj){
            return obj.id == item.id;
          })[0];
          $scope.scheduleCalendar.schedules.push($scope.curItem);
        }
      });
      $rootScope.selectedItems = [];
    }

    $scope.folderFx = function(event){
      $(event.currentTarget).find('.fa-folder').toggleClass('fa-folder-open text-primary');
      $(event.currentTarget).closest(".folderQuad").children(".folder-content").toggleClass('show');
    }

    $scope.removeFx = function(type, id){
      if(type == "selected-schedule"){
        $scope.remainingItem = $scope.scheduleCalendar.schedules.filter(function(obj){
          return obj.id !== id;
        });
        $scope.scheduleCalendar.schedules = $scope.remainingItem;
        $(".ui-selectable li.ui-selected[data-id='" + id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
      } else if(type == "selected-week"){
        angular.forEach($scope.scheduleCalendar.selectedWeeks, function(listItem){
          if(listItem.split("|")[0] == id){
            $scope.scheduleCalendar.selectedWeeks.splice($scope.scheduleCalendar.selectedWeeks.indexOf(listItem), 1);
            return false;
          }
        });
      } else if(type == "selected-month"){
        angular.forEach($scope.scheduleCalendar.selectedMonths, function(listItem){
          if(listItem == id){
            $scope.scheduleCalendar.selectedMonths.splice($scope.scheduleCalendar.selectedMonths.indexOf(listItem), 1);
            return false;
          }
        });
      }
    }

    $scope.departureDatepickerClick = function(){
      $scope.$watch('selectedDay', function(newValue, oldValue){
        if(newValue){
        }
      }, true);
    }

    $scope.previewFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.scheduleCalendar.dType == "d"){
        $scope.curSelectedDay = [];
        angular.forEach($scope.selectedDay, function(item){
          $scope.curSelectedDay.push(moment(item).format("L"));
        });
        $scope.scheduleCalendar.selectedDates = $scope.curSelectedDay;
      }
      if($scope.scheduleCalendar.schedules.length == 0){
        $scope.errType = "schedules";
        $scope.hasErr = true;
      } else if($scope.scheduleCalendar.dType == "d" && $scope.scheduleCalendar.selectedDates.length == 0){
        $scope.errType = "selected-dates";
        $scope.hasErr = true;
      } else if($scope.scheduleCalendar.dType == "w" && $scope.scheduleCalendar.selectedWeeks.length == 0){
        $scope.errType = "selected-weeks";
        $scope.hasErr = true;
      } else if($scope.scheduleCalendar.dType == "m" && $scope.scheduleCalendar.selectedMonths.length == 0){
        $scope.errType = "selected-months";
        $scope.hasErr = true;
      }
      if(!$scope.hasErr){
        // Save it first
        $scope.saveProcessing = true;
        $scope.previewProcessing = true;
        $scope.scheduleCalendar.toast = true;
        ScheduleCalendarSrv.saveScheduleCalendar($scope.scheduleCalendar).then(
        	function(data){
        	  $scope.saveProcessing = false;
        	  // Now show preview
            $scope.detailLoading = true;
            $scope.decId = data.id;
            ScheduleCalendarSrv.getScheduleCalendar($scope.decId).then(
              function(data){
                $scope.scheduleCalendar.toast = true;
                $scope.scheduleCalendar = data;
                $scope.detailLoading = false;
                $scope.currentPage = 0;
                ScheduleCalendarSrv.getScheduleCalendarFeed($scope.scheduleCalendar.id).then(
                  function(data){
                    $scope.preview = data;
                    if($scope.preview.type == "m"){
                      $scope.generateCalendar($scope.preview.calendar[0].label.split("|")[1], $scope.preview.calendar[0].label.split("|")[0]);
                    }
                    ngDialog.open({
                      template:'app/contentLibrary/widgets/popup/scPreview.html',
                      width:1000,
                      scope:$scope,
                      closeByDocument:false
                    });
                    $scope.previewProcessing = false;
                  },
                  function(err){
                    $scope.previewProcessing = false;
                    $scope.saveProcessing = false;
                    $log.error(err);
                  }
                );
              },
              function(err){
                $scope.previewProcessing = false;
                $scope.saveProcessing = false;
                $log.error(err);
              }
            );
        	},
        	function(err){
        	  $log.error(err);
        	  $scope.saveProcessing = false;
        	}
        );
      }
    }

    $scope.printDiv = function(divName, pageTitle){
      var printContents = document.getElementById(divName).innerHTML;
      var popupWin = window.open('', '_blank', 'width=600,height=800');
      popupWin.document.open();
      popupWin.document.write('<html><head><title>'+ pageTitle +'</title><style type="text/css">html{height:100%;}body{height:100%;padding:0;margin:0;font-family:\'Open Sans\',sans-serif;font-size:9px;font-weight:400;}.text-big{font-size:20px;margin:10px;}.text-center{text-align:center;}table{margin-bottom:0;border:1px solid #ddd;width:100%;max-width:100%;border-collapse:collapse;border-spacing:0;}th,td{padding:8px;vertical-align:top;border:1px solid #ddd;}.text-muted{color:#808080;}.marB5{margin-bottom:5px;}th,.text-bold{font-weight:600;}.text-sm{font-size:80%;}.bdr-btm-dashed{border-bottom:1px dashed #c7c7c7;padding-bottom:5px;margin-bottom:10px;}</style></head><body onload="window.print()">'+ printContents +'</body></html>');
      popupWin.document.close();
    }

    $scope.removeDateFx = function(date){
      $scope.selectedDay.splice($scope.selectedDay.indexOf(date), 1);
    };

    $scope.scheduleCalendarFx = function(tab, caller){
      $scope.scheduleCalendar.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 2 || tab == 3 || caller == "save"){
        if($scope.scheduleCalendar.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(tab == 3 && $scope.scheduleCalendar.schedules.length == 0){
          $scope.errType = "schedules";
          $scope.hasErr = true;
          $("#schedules").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.tabFx(tab);
            }, 250);
          } else{
            $scope.tabFx(tab);
          }
        }
      }
      if(tab == 2 && !$scope.hasErr){
        $scope.detailLoading = true;
        ScheduleCalendarSrv.getSchedule().then(
          function(data){
            $scope.schedulesList = data;
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      if(tab == 3 && !$scope.hasErr){
        if($scope.scheduleCalendar.dType == "d"){
          $scope.curSelectedDay = [];
          angular.forEach($scope.selectedDay, function(item){
            $scope.curSelectedDay.push(moment(item).format("L"));
          });
          $scope.scheduleCalendar.selectedDates = $scope.curSelectedDay;
        } else if($scope.scheduleCalendar.dType == "w"){
          $scope.scheduleCalendar.selectedDates = [];
        }
      }
      if(tab == 3 || caller == "save"){
        if(caller == "save"){
          $scope.saveProcessing = true;
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveScheduleCalendarFx(caller);
            }, 250);
          } else{
            $scope.saveScheduleCalendarFx(caller);
          }
        }
      }
    }

    $scope.saveScheduleCalendarFx = function(caller){
      if(caller == "save"){
        $scope.scheduleCalendar.toast = true;
      } else{
        $scope.scheduleCalendar.toast = false;
      }
      ScheduleCalendarSrv.saveScheduleCalendar($scope.scheduleCalendar).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('RSSFeedController', RSSFeedController);

  /** @ngInject */
  function RSSFeedController($log, $rootScope, $scope, $state, $cookies, $timeout, RSSFeedSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, arb:false, tt:false, dt:false, att:false, adt:false, bc:false, tc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.rssCrawl = "";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsNormal = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#3d85c6", descText:"#444444", rowFont:$scope.fontFamilySelected, altTitleText:"#3d85c6", altDescText:"#444444", altRowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18},
      ctype:{headerBg:"monochrome", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome"}
    };
    $scope.settingsCrawl = {
      settings:{speed:100, bg:"#000000", bga:1, bullet:"#990000", titleText:"#ffffff", font:$scope.fontFamilySelected, dir:"rl", align:"l", fontSize:16, fontSizeOpt:"a"},
      ctype:{bg:"monochrome", bullet:"default", titleText:"monochrome"}
    };

    $scope.defaultNormal = angular.copy($scope.settingsNormal);
    $scope.defaultCrawl = angular.copy($scope.settingsCrawl);

    $scope.settingsDefault = function(){
      if($scope.rss.dType == "normal"){
        $scope.rss.settings = angular.copy($scope.defaultNormal.settings);
        $scope.rss.ctype = angular.copy($scope.defaultNormal.ctype);
      } else if($scope.rss.dType == "crawl"){
        $scope.rss.settings = angular.copy($scope.defaultCrawl.settings);
        $scope.rss.ctype = angular.copy($scope.defaultCrawl.ctype);
      }
    }

    $scope.changeDType = function(caller){
      $scope.rss.settings = {};
      $scope.rss.ctype = {};
      if(caller == "normal"){
        $scope.rss.settings = angular.copy($scope.settingsNormal.settings);
        $scope.rss.ctype = angular.copy($scope.settingsNormal.ctype);
      }
      else if(caller == "crawl"){
        $scope.rss.settings = angular.copy($scope.settingsCrawl.settings);
        $scope.rss.ctype = angular.copy($scope.settingsCrawl.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      RSSFeedSrv.getRSSFeed($scope.decId).then(
        function(data){
          $scope.rss = data;
          $scope.detailLoading = false;
          if($scope.rss.dType == "normal"){
            $scope.settingsNormal.settings = angular.copy($scope.rss.settings);
            $scope.settingsNormal.ctype = angular.copy($scope.rss.ctype);
          }
          else if($scope.rss.dType == "crawl"){
            if(!$scope.rss.settings.dir){
              $scope.rss.settings.dir = "rl";
            }
            if(!$scope.rss.settings.fontSizeOpt){
              $scope.rss.settings.fontSizeOpt = "a";
              $scope.rss.settings.fontSize = 16;
            }
            $scope.settingsCrawl.settings = angular.copy($scope.rss.settings);
            $scope.settingsCrawl.ctype = angular.copy($scope.rss.ctype);
          }
          $scope.dTypeCopy = angular.copy($scope.rss.dType);
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.rss = {
        label:"", dType:"normal",
        settings:angular.copy($scope.settingsNormal.settings),
        ctype:angular.copy($scope.settingsNormal.ctype),
        feed:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.directionFx = function(){
      if(!$scope.rss.settings.align){
        $scope.rss.settings.align = "l";
      }
      if(!$scope.rss.settings.fontSize || $scope.rss.settings.fontSize == ""){
        $scope.rss.settings.fontSize = 16;
      }
    }

    $scope.rssFx = function(){
      $scope.rss.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.rss.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.rss.feed == ""){
        $scope.errType = "feed";
        $scope.hasErr = true;
        $("#feed").focus();
      } else if($scope.rss.dType == "crawl" && !$scope.rss.settings.speed){
        $scope.errType = "crawl";
        $scope.hasErr = true;
        $("#speed").focus();
      } else if($scope.rss.dType === "crawl" && ($scope.rss.settings.dir == "bt" || $scope.rss.settings.fontSizeOpt == "c") && $scope.rss.settings.fontSize == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
        $("#fontSize").focus();
      } else if($scope.rss.dType === "normal" && $scope.rss.settings.rotationOpt == "c" && !$scope.rss.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#cRotate").focus();
      } else if($scope.rss.dType == 'normal' && $scope.rss.settings.hTextOpt == "c" && $scope.rss.settings.hText == ""){
        $scope.errType = "hText";
        $scope.hasErr = true;
        $("#hText").focus();
      } else if($scope.rss.dType == 'normal' && $scope.rss.settings.hTextOpt != "n" && !$scope.rss.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#headerSize").focus();
      } else if($scope.rss.dType == 'normal' && !$scope.rss.settings.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else if($scope.rss.dType == 'normal' && !$scope.rss.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
        $("#descSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveRSSFeedFx();
          }, 250);
        } else{
          $scope.saveRSSFeedFx();
        }
      }
    }
    $scope.saveRSSFeedFx = function(){
      $scope.saveProcessing = true;
      RSSFeedSrv.saveRSSFeed($scope.rss).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ReaderBoardController', ReaderBoardController);

  /** @ngInject */
  function ReaderBoardController($log, $rootScope, $scope, $state, $cookies, $timeout, ReaderBoardSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ReaderBoardSrv.getReaderBoard($scope.decId).then(
        function(data){
          $scope.readerBoard = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.readerBoard = {label:"", dType:"r", feedUrl:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.readerBoardFx = function(){
      $scope.readerBoard.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.readerBoard.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.readerBoard.feedUrl == ""){
        $scope.errType = "feed";
        $scope.hasErr = true;
        $("#feed").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveReaderBoardFx();
          }, 250);
        } else{
          $scope.saveReaderBoardFx();
        }
      }
    }
    $scope.saveReaderBoardFx = function(){
      ReaderBoardSrv.saveReaderBoard($scope.readerBoard).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('QuotesController', QuotesController);

  /** @ngInject */
  function QuotesController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, ContentLibrarySrv, QuotesSrv){
    $scope.colorPicker = {b:false, qt:false, at:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.getQuoteLibrary = true;
    $scope.getQuoteChatGPTLibrary = false;
    $scope.detailLoading = false;
    $scope.quoteOpt = 'library';
    $scope.isPEOpen = false;
    $scope.selectAll = true;
    $scope.quotes = {};
    $scope.curBg = {};
    $scope.encId = "";
    $scope.decId = "";
    $scope.search = {text:""};

    $scope.settings = {
      settings:{bg:"#ffffff", bga:0, quotesText:"#ffffff", authorText:"#ffffff", rotationOpt:"a", rotate:12, quotesSize:30, authorSize:12, quotesFont:$scope.fontFamilySelected, authorFont:$scope.fontFamilySelected},
      ctype:{bg:"monochrome", quotesText:"monochrome", authorText:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.quotes.settings = angular.copy($scope.defaultSettings.settings);
      $scope.quotes.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(310);
      $scope.selectedHeight = $scope.getAvailableHeight(310);
    } else{
      $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
      $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      QuotesSrv.getQuotes($scope.decId).then(
        function(data){
          $scope.quotes = data;
          $scope.tim = $scope.quotes.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.quotes.otherinfo.bucket;
          if($scope.quotes.otherinfo.mbucket && $scope.quotes.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.quotes.otherinfo.mbucket;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.quotes = {
        label:"", bgImg:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }
    $scope.bgImgPopover = {templateUrl:"bgImg.html"}

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.quotes.bgImg = $scope.curBg;
        $scope.quotes.isHidden = 0;
        ngDialog.close();
      }
    }
    $scope.removeBgFx = function(){
      $scope.quotes.bgImg = {};
    }

    // $scope.quotesTextChange = function(){
    //   $scope.errType = "";
    // }
    $scope.chatGPT = {text:""};
    $scope.getQuotesChatGPT = function(){
      $scope.selectAll = true;
      $scope.quotesLoading = true;
      QuotesSrv.getChatGPTLibrary({"prompt":$scope.chatGPT.text}).then(
        function(data){
          $scope.quoteChatGPTLibrary = data.chatGPTQuotes;
          $scope.getQuoteChatGPTLibrary = true;
          $scope.selectAll = false;
          $scope.quotesLoading = false;
        },
        function(err){
          $scope.getQuoteChatGPTLibrary = false;
          $log.error(err);
        }
      );
    }

    $scope.addChatGPTQuoteFx = function(ql){
      angular.forEach($scope.quoteChatGPTLibrary, function(item){
        $scope.isDuplicate = false;
        if(ql == "all"){
            angular.forEach($scope.quotes.quoteList, function(listItem){
              if(listItem.quote == item.quote && listItem.author == item.author){
                $scope.isDuplicate = true;
                return false;
              }
            });
            if(!$scope.isDuplicate){
              $scope.curItem = $scope.quoteChatGPTLibrary.filter(function(obj){
                return obj.quote == item.quote;
              })[0];
              $scope.quotes.quoteList.push($scope.curItem);
            }
        } else if(ql.quote == item.quote && ql.author == item.author){
          angular.forEach($scope.quotes.quoteList, function(listItem){
            if(listItem.quote == item.quote && listItem.author == item.author){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.quoteChatGPTLibrary.filter(function(obj){
              return obj.quote == item.quote;
            })[0];
            $scope.quotes.quoteList.push($scope.curItem);
          }
        }
      });
    }

    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 1){
        $scope.detailLoading = false;
      } else if($rootScope.selectedT == 2){
        if($scope.getQuoteLibrary){
          $scope.detailLoading = true;
          QuotesSrv.getLibrary().then(
            function(data){
              $scope.quoteLibrary = data.quotesLibrary;
              $scope.getQuoteLibrary = false;
              $scope.detailLoading = false;
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }
    $rootScope.selectedTabFx();

    $scope.addQuote = {quote:"", author:""};
    $scope.quotes.quoteList = [];
    $scope.addQuoteFx = function(){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.addQuote.quote == ""){
        $scope.hasListErr = true;
        $scope.errType = "quote";
        $("#quote").focus();
      } else{
        $scope.quotes.quoteList.push($scope.addQuote);
        $scope.resetQuoteFx();
      }
    }
    $scope.resetQuoteFx = function(){
      $scope.addQuote = {quote:"", author:""};
    }
    $scope.isDuplicate = false;
    $scope.selectQuoteFx = function(id){
      angular.forEach($scope.quoteLibrary, function(item){
        $scope.isDuplicate = false;
        if(id == "all"){
          angular.forEach($scope.quotes.quoteList, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.quoteLibrary.filter(function(obj){
              return obj.id == item.id;
            })[0];
            $scope.quotes.quoteList.push($scope.curItem);
          }
        } else if(id == item.id){
          angular.forEach($scope.quotes.quoteList, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.quoteLibrary.filter(function(obj){
              return obj.id == item.id;
            })[0];
            $scope.quotes.quoteList.push($scope.curItem);
          }
        }
      });
    }
    $scope.removeQuoteOpen = function(index){
      $scope.removeObj = {index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{removeObj.index=="all"?"cm.msg.34s":"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeQuoteFx(removeObj.index);" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        data:$scope.removeObj,
        closeByEscape:false,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.removeQuoteFx = function(index){
      if(index == "all"){
        $scope.quotes.quoteList = [];
      } else{
        $scope.quotes.quoteList.splice(index, 1);
      }
      ngDialog.close();
    }

    $scope.removeImgFx = function(){
      $scope.quotes.bgImg = null;
    }

    $scope.quotesFx = function(tab, caller){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.quotes.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.quotes.settings.rotationOpt == "c" && !$scope.quotes.settings.rotate){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#rotation").focus();
        } else if(!$scope.quotes.settings.quotesSize){
          $scope.errType = "qFSize";
          $scope.hasErr = true;
          $("#quotesSize").focus();
        } else if(!$scope.quotes.settings.authorSize){
          $scope.errType = "aFSize";
          $scope.hasErr = true;
          $("#authorSize").focus();
        } else{
          $scope.quotes.fid = $scope.fid;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              if(tab == 1){
                $scope.tabFx(2, 'tabFx');
              }
              if(tab == 2){
                $scope.saveQuotes();
              }
              $scope.isPEOpen = false;
            }, 250);
          } else{
            if(tab == 1){
              $scope.tabFx(2, 'tabFx');
            }
            if(tab == 2){
              $scope.saveQuotes();
            }
            $scope.isPEOpen = false;
          }
        }
      } else{
        $scope.quotes.fid = $scope.fid;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveQuotes();
          }, 250);
        } else{
          $scope.saveQuotes();
        }
      }
    }

    $scope.saveQuotes = function(){
      $scope.saveProcessing = true;
      QuotesSrv.saveQuotes($scope.quotes).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('QueueWController', QueueWController);

  /** @ngInject */
  function QueueWController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, QueueWSrv, FileModelUploadSrv){
    $scope.colorPicker = {b:false, tc:false, pc:false, sc:false, cn:false, nt:false, hb:false, ht:false, fb:false, ft:false, rb:false, rt:false, at:false, art:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.generateProcessing = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.searchQu = {text:""};
    $scope.addRowBtn = false;
    $scope.isPEOpen = false;
    $scope.deleteBtn = true;
    $scope.isChecked = {};
    $scope.queue = {};
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsNarmal = {
      settings:{bg:"#ffffff", bga:0, titleText:"#ffffff", titleFont:$scope.fontFamilySelected, prefixText:"#ffffff", prefixFont:$scope.fontFamilySelected, suffixText:"#ffffff", suffixFont:$scope.fontFamilySelected, curText:"#ffffff", curFont:$scope.fontFamilySelected, reloadOpt:"a", reload:30},
      ctype:{bg:"monochrome", titleText:"monochrome", prefixText:"monochrome", suffixText:"monochrome", curText:"monochrome"}
    };
    $scope.settingsTabular = {
      settings:{bg:"#ffffff", bga:0, headerBg:"#eeeeee", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, footerBg:"#eeeeee", footerBga:1, footerText:"#444444", footerFont:$scope.fontFamilySelected, rowBg:"#ffffff", rowBga:1, rowText:"#444444", rowFont:$scope.fontFamilySelected, altBg:"#f3f3f3", altBga:1, altText:"#444444", altFont:$scope.fontFamilySelected, reloadOpt:"a", reload:30, rotateOpt:"a", rotate:30},
      ctype:{bg:"monochrome", headerBg:"monochrome", headerText:"monochrome", footerBg:"monochrome", footerText:"monochrome", rowBg:"monochrome", rowText:"monochrome", altBg:"monochrome", altText:"monochrome"}
    };

    $scope.defaultNarmal = angular.copy($scope.settingsNarmal);
    $scope.defaultTabular = angular.copy($scope.settingsTabular);

    $scope.settingsDefault = function(){
      if($scope.queue.dType == "normal"){
        $scope.queue.settings = angular.copy($scope.defaultNarmal.settings);
        $scope.queue.ctype = angular.copy($scope.defaultNarmal.ctype);
      } else{
        $scope.queue.settings = angular.copy($scope.defaultTabular.settings);
        $scope.queue.ctype = angular.copy($scope.defaultTabular.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      QueueWSrv.getQueue($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.queue = data;
          if($scope.queue.dType == "tabular"){
            $scope.curCount = angular.copy($scope.queue.columns);
            $scope.curDType = angular.copy($scope.queue.dType);
            $scope.curGType = angular.copy($scope.queue.gType);
            $scope.curFType = angular.copy($scope.queue.fType);
          }
          if($scope.queue.dType == "normal"){
            $scope.settingsNarmal.settings = angular.copy($scope.queue.settings);
            $scope.settingsNarmal.ctype = angular.copy($scope.queue.ctype);
          } else{
            $scope.settingsTabular.settings = angular.copy($scope.queue.settings);
            $scope.settingsTabular.ctype = angular.copy($scope.queue.ctype);
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $scope.queue = {label:"", dType:"normal", starting:1, ending:100, prefix:"", suffix:"", columns:2, gType:"g", fType:"csv", delimiter:"comma", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}, table:[],
        settings:angular.copy($scope.defaultNarmal.settings),
        ctype:angular.copy($scope.defaultNarmal.ctype)
      };
      $rootScope.tabView = true;
      $scope.curDType = angular.copy($scope.queue.dType);
      $scope.curGType = angular.copy($scope.queue.gType);
      $scope.curFType = angular.copy($scope.queue.fType);
    }

    $scope.changeType = function(caller){
      $scope.changeObj = {caller:caller};
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "dType"){
        if($scope.queue.dType == "normal"){
          $scope.queue.settings = angular.copy($scope.defaultNarmal.settings);
          $scope.queue.ctype = angular.copy($scope.defaultNarmal.ctype);
        } else{
          $scope.queue.settings = angular.copy($scope.settingsTabular.settings);
          $scope.queue.ctype = angular.copy($scope.settingsTabular.ctype);
        }

        if($scope.curDType == "tabular" && $scope.queue.table.head){
          $scope.changeTypeOpen("tabular");
          $scope.curDType = "tabular";
        } else if($scope.curDType == "tabular3p" && $scope.queue.table.head){
          $scope.changeTypeOpen("tabular3p");
          $scope.curDType = "tabular3p";
        } else{
          $scope.curDType = angular.copy($scope.queue.dType);
          $scope.queue.gType = "g";
          $scope.curGType = "g";
        }
      } else if(caller == "gType"){
        if($scope.queue.table.head){
          $scope.changeTypeOpen("gType");
          if($scope.queue.gType == 'f' && $scope.queue.fType == null){
            $scope.queue.fType = "csv";
            $scope.queue.delimiter = "comma";
          }
        } else{
          $scope.curGType = angular.copy($scope.queue.gType);
        }
      } else if(caller == "fType"){
        if($scope.queue.table.head){
          $scope.changeTypeOpen("fType");
        } else{
          $scope.curFType = angular.copy($scope.queue.fType);
        }
        if($scope.queue.fType == 'csv' && $scope.queue.delimiter == null){
          $scope.queue.delimiter = "comma";
        }
      }
    }
    $scope.changeTypeOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.queue.m9" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="changeTypeFx();" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        data:$scope.changeObj,
        closeByEscape:false,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(caller){
          if(caller == "$escape" || caller == "close"){
            if($scope.changeObj.caller == "dType"){
              $scope.queue.dType = $scope.curDType;
            } else if($scope.changeObj.caller == "gType"){
              $scope.queue.gType = $scope.curGType;
            } else if($scope.changeObj.caller == "fType"){
              $scope.queue.fType = $scope.curFType;
            }
          }
        }
      });
    }
    $scope.changeTypeFx = function(){
      if($scope.changeObj.caller == "dType"){
        if($scope.queue.dType == "normal"){
          $scope.curDType = "normal";
          $scope.queue.gType = "g";
          $scope.curGType = "g";
        } else if($scope.queue.dType == "tabular"){
          $scope.curCount = angular.copy($scope.queue.columns);
          $scope.curDType = "tabular";
        } else if($scope.queue.dType == "tabular3p"){
          $scope.curDType = "tabular3p";
          $scope.queue.gType = "g";
          $scope.curGType = "g";
        }
      } else if($scope.changeObj.caller == "gType"){
        $scope.curGType = $scope.queue.gType;
      } else if($scope.changeObj.caller == "fType"){
        $scope.curFType = $scope.queue.fType;
      }
      $scope.queue.table = [];
      ngDialog.close();
    }

    $scope.generateFx = function(){
      if($scope.queue.dType == "tabular" && $scope.queue.columns >= 1){
        $scope.errType = "";
        $scope.hasErr = false;
        if($scope.queue.table.head){
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"cl.widget.queue.m10" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="generatingFx();" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:480,
            scope:$scope,
            closeByDocument:false,
            className:'ngdialog-theme-default ngdialog-confirm',
            preCloseCallback:function(caller){
              if(caller == 'close'){
                $scope.queue.columns = $scope.curCount;
              }
            }
          });
        } else{
          $scope.generatingFx();
        }
      } else{
        $scope.errType = "columns";
        $scope.hasErr = true;
        $("#columns").focus();
      }
    }

    $scope.generatingFx = function(){
      ngDialog.close();
      $scope.searchQu.text = "";
      $scope.generateProcessing = true;
      $scope.curCount = angular.copy($scope.queue.columns);
      $scope.queue.table = {head:{hide:false, columns:[]}, row:[{id:1, isChecked:false, hide:false, columns:[]}]};
      for(var i=0; i<$scope.curCount; i++){
        $scope.queue.table.head.columns.push({id:1+i, label:"Column"+ (1+i), hide:false});
        $scope.queue.table.row[0].columns.push({label:""});
      }
      $scope.generateProcessing = false;
    }

    $scope.addRowFx = function(){
      $scope.addRowBtn = true;
      $scope.searchQu.text = "";
      if($scope.isChecked.selectAll){
        $scope.isChecked.selectAll = false;
      }
      $scope.queue.table.row.push({id:$scope.queue.table.row.length+1, isChecked:false, hide:false, columns:[]});
      for(var i=0; i<$scope.curCount; i++){
        $scope.queue.table.row[$scope.queue.table.row.length-1].columns.push({label:""});
      }
      angular.forEach($scope.queue.table.row, function(item, index){
        item.id = index+1;
      });
      $scope.addRowBtn = false;
    }

    $scope.isCheckedFx = function(caller){
      $scope.curChecked = false;
      if(caller == "all"){
        if($scope.isChecked.selectAll){
          angular.forEach($scope.queue.table.row, function(row){
            row.isChecked = true;
          });
        } else{
          angular.forEach($scope.queue.table.row, function(row){
            row.isChecked = false;
          });
        }
      } else{
        $scope.curChecked = true;
        angular.forEach($scope.queue.table.row, function(row){
          if(!row.isChecked){
            $scope.curChecked = false;
            return false;
          }
        });
        if($scope.curChecked){
          $scope.isChecked.selectAll = true;
        } else{
          $scope.isChecked.selectAll = false;
        }
      }
      if($filter("filter")($scope.queue.table.row, {isChecked:true}).length == 0){
        $scope.deleteBtn = true;
      } else{
        $scope.deleteBtn = false;
      }
    }

    $scope.deleteOpen = function(){
      $scope.deleteItemLength = $filter("filter")($scope.queue.table.row, {isChecked:true}).length;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{deleteItemLength > 1?"cm.msg.34s":"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.deleteBtn = true;
      $scope.searchQu.text = "";
      if($scope.isChecked.selectAll){
        $scope.queue.table.row = [];
        $scope.isChecked.selectAll = false;
      } else{
        $scope.curDelete = $filter("filter")($scope.queue.table.row, {isChecked:false});
        $scope.queue.table.row = $scope.curDelete;
      }
      ngDialog.close();
    }
    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.queue.table.row, function(item, index){
        angular.forEach($filter('filter')($scope.queue.table.row, {id:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.queue.table.row = [];
      $scope.queue.table.row = $scope.curRow;
    }

    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
      if($scope.queue.table.head){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.queue.m11" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileSelectFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.fileSelectFx();
      }
    }

    $scope.fileSelectFx = function(){
      $scope.fileModelLoading = true;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson", {delimiter:$scope.queue.delimiter}, $scope.curData).then(
        function(data){
          $scope.fileModelLoading = false;
          $scope.queue.table = [];
          $scope.convertData = data;
          ngDialog.close();
          if($scope.convertData.code == 8126){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.widget.queue.m12" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="convertFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else if(data && ((data.head && data.head.length > 0) || (data.row && data.row.length > 0))){
            $scope.queue.table = $scope.convertData;
            $scope.curCount = $scope.queue.table.head.columns.length;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }
    $scope.convertFx = function(){
      $scope.queue.table = $scope.convertData;
      $scope.curCount = $scope.queue.table.head.columns.length;
      ngDialog.close();
    }

    $scope.queueFx = function(){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.queue.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.queue.dType == "normal" && $scope.queue.starting == null){
        $scope.errType = "start";
        $scope.hasErr = true;
        $("#starting").focus();
      } else if($scope.queue.dType == "normal" && $scope.queue.ending == null){
        $scope.errType = "end";
        $scope.hasErr = true;
        $("#ending").focus();
      } else if($scope.queue.dType == "normal" && $scope.queue.starting >= $scope.queue.ending){
        $scope.errType = "startEnd";
        $scope.hasErr = true;
        $("#ending").focus();
      } else if($scope.queue.settings.reloadOpt == "c" && $scope.queue.settings.reload == null){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else if($scope.queue.dType != "normal" && $scope.queue.settings.rotateOpt == "c" && $scope.queue.settings.rotate == null){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else if($scope.queue.dType == "tabular3p" && (angular.isUndefined($scope.queue.url) || $scope.queue.url == "")){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.queue.dType == "tabular" && $scope.queue.gType == "g" && $scope.queue.columns == null){
        $scope.errType = "columns";
        $scope.hasErr = true;
        $("#columns").focus();
      } else if($scope.queue.dType == "tabular" && $scope.queue.table.length == 0){
        if($scope.queue.gType == "g"){
          $scope.errType = "grid";
          $scope.hasErr = true;
          $("#grid").focus();
        } else if($scope.queue.gType == "f"){
          $scope.errType = "file";
          $scope.hasErr = true;
          $("#file").focus();
        }
      } else{
        if($scope.queue.dType == "tabular"){
          $scope.queue.columns = $scope.curCount;
          angular.forEach($scope.queue.table.row, function(item, index){
            item.id = index+1;
            item.isChecked = false;
          });
        }
        $scope.queue.fid = $scope.fid;
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveQueue();
          }, 250);
        } else{
          $scope.saveQueue();
        }
      }
    }

    $scope.saveQueue = function(){
      QueueWSrv.saveQueue($scope.queue).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('QRCodeController', QRCodeController);

  /** @ngInject */
  function QRCodeController($log, $rootScope, $scope, $state, $cookies, $timeout, QRCodeSrv, NgMap, $filter, ContentLibrarySrv, DevicesSrv, ngDialog, CommonSrv){
    $scope.timestamp = moment().format('x');
    $scope.mapCenter = [43.6532, -79.3832];
    $scope.fid = localStorage.getItem("curFId");
    $scope.previewLoading = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPreview = false;
    $scope.isSelectDevice = true;
    $scope.isPEOpen = false;
    $scope.hasErr = false;
    $scope.qrPreview = "";
    $scope.errType = "";
    $scope.decId = "";
    $scope.encId = "";
    $scope.map;
    $scope.qr = {};

    $scope.mapLoaded = function(map){
      $scope.map = map;
      $scope.setMarker();
      $scope.$apply();
    }
    $scope.updateDefineVariable = function(){
      $scope.haveMoreData = false;
      $scope.haveMoreSearchData = false;
      $scope.visibleData = [];
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.searchScroll = false;
      $scope.dListLoading = false;
      $scope.loadingMore = false;
      $scope.searchDevice = {label:""};
    }

    $scope.getDeviceFx = function(){
      $scope.dpLoading = true;
      $scope.updateDefineVariable();
      $scope.scrollObj = {caller: 'qr', offset: 0, id: 0}
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.dpLoading = false;
        },
        function(err){
          $scope.dpLoading = false;
          $log.error(err);
        }
      );
      // $scope.dpLoading = true;
      // CommonSrv.getAvailDGT('d', 'qr').then(
      //   function(data){
      //     $scope.dpLoading = false;
      //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
      //     $scope.devicesList = data.devices;
      //   },
      //   function(err){
      //     $scope.dpLoading = false;
      //     $log.error(err);
      //   }
      // );
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.previewLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      QRCodeSrv.getQR($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.previewLoading = false;
          $scope.qr = data;
          $scope.isPreview = true;
          $scope.qrPreview = data;
          $scope.cBucket = $scope.cDetailBucket = $scope.qrPreview.bucket;
          if($scope.qrPreview.mbucket && $scope.qrPreview.mbucket != ""){
            $scope.cDetailBucket = $scope.qrPreview.mbucket;
          }
          $scope.tim = $scope.qrPreview.timthumb;
          if($scope.qr.dType == "location"){
            $scope.addressType();
          }
          if($scope.qr.dType == "content" && ($scope.qr.dataQR.content == null || $scope.qr.dataQR.content == "")){
            $scope.isPreview = false;
          }

          if($scope.qr.dType == "dp"){
            $scope.isSelectDevice = false;
            $scope.getDeviceFx();
          }
        },
        function(err){
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.qr = {
        label:"", dType:"", dValue:"", dataQR:{},
        activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP},
      }
    }

    $scope.qrPreviewFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.qr.dType == ""){
        $scope.errType = "type";
        $scope.hasErr = true;
        $("#dType").focus();
      } else if($scope.qr.dType == "url" && $scope.qr.dataQR.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.qr.dType == "txt" && $scope.qr.dataQR.txt == ""){
        $scope.errType = "txt";
        $scope.hasErr = true;
        $("#txt").focus();
      } else if($scope.qr.dType == "call" && $scope.qr.dataQR.no == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#contact").focus();
      } else if($scope.qr.dType == "call" && $scope.qr.dataQR.no != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.no)){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#contactInv").focus();
      } else if($scope.qr.dType == "content" && ($scope.qr.dataQR.content == "" || $scope.qr.dataQR.content == null)){
        $scope.errType = "content";
        $scope.hasErr = true;
        $("#contentBtn").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.no == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#smsContact").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.no != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.no)){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#smsContact").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.msg == ""){
        $scope.errType = "sMsg";
        $scope.hasErr = true;
        $("#sMsg").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.email == ""){
        $scope.errType = "email";
        $scope.hasErr = true;
        $("#email").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.email != "" && !$scope.checkRegex("em", $scope.qr.dataQR.email)){
        $scope.errType = "emailInv";
        $scope.hasErr = true;
        $("#email").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.sub == ""){
        $scope.errType = "eSub";
        $scope.hasErr = true;
        $("#eSub").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.msg == ""){
        $scope.errType = "eMsg";
        $scope.hasErr = true;
        $("#eMsg").focus();
      } else if($scope.qr.dType == "wifi" && $scope.qr.dataQR.ssId == ""){
        $scope.errType = "ssId";
        $scope.hasErr = true;
        $("#ssId").focus();
      } else if($scope.qr.dType == "wifi" && $scope.qr.dataQR.pwd == ""){
        $scope.errType = "pwd";
        $scope.hasErr = true;
        $("#pwd").focus();
      } else if($scope.qr.dType == "event" && $scope.qr.dataQR.title == ""){
        $scope.errType = "title";
        $scope.hasErr = true;
        $("#title").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "c" && $scope.qr.dataQR.lat == ""){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lat").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "c" && $scope.qr.dataQR.lng == ""){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lng").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.address == ""){
        $scope.errType = "address";
        $scope.hasErr = true;
        $("#address").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.city == ""){
        $scope.errType = "city";
        $scope.hasErr = true;
        $("#city").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.province == ""){
        $scope.errType = "province";
        $scope.hasErr = true;
        $("#province").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.country == ""){
        $scope.errType = "country";
        $scope.hasErr = true;
        $("#country").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && ($scope.qr.dataQR.lat == "" && $scope.qr.dataQR.lat == "")){
        $scope.errType = "addrNotVlid";
        $scope.hasErr = true;
        $("#addrNotVlid").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.fName == ""){
        $scope.errType = "fName";
        $scope.hasErr = true;
        $("#fName").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.lName == ""){
        $scope.errType = "lName";
        $scope.hasErr = true;
        $("#lName").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.contactM == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#contactM").focus();
      } else if($scope.qr.dType == "vCard" && (($scope.qr.dataQR.contactM != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactM)) || ($scope.qr.dataQR.contactH != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactH)) || ($scope.qr.dataQR.contactW != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactW)))){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#contactInv").focus();
      } else if($scope.qr.dType == "vCard" && (($scope.qr.dataQR.emailP != "" && !$scope.checkRegex("em", $scope.qr.dataQR.emailP)) || ($scope.qr.dataQR.emailW != "" && !$scope.checkRegex("em", $scope.qr.dataQR.emailW)))){
        $scope.errType = "emailsInv";
        $scope.hasErr = true;
        $("#emailsInv").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.isHomeAdd && ($scope.qr.dataQR.addressH.address == "" || $scope.qr.dataQR.addressH.city == "" || $scope.qr.dataQR.addressH.state == "" || $scope.qr.dataQR.addressH.zip == "" || $scope.qr.dataQR.addressH.country == "")){
        $scope.errType = "addressH";
        $scope.hasErr = true;
        if($scope.qr.dataQR.addressH.address == ""){
          $("#addressH").focus();
        } else if($scope.qr.dataQR.addressH.city == ""){
          $("#cityH").focus();
        } else if($scope.qr.dataQR.addressH.state == ""){
          $("#stateH").focus();
        } else if($scope.qr.dataQR.addressH.zip == ""){
          $("#zipH").focus();
        } else if($scope.qr.dataQR.addressH.country == ""){
          $("#countryH").focus();
        }
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.isWorkAdd && ($scope.qr.dataQR.addressW.address == "" || $scope.qr.dataQR.addressW.city == "" || $scope.qr.dataQR.addressW.state == "" || $scope.qr.dataQR.addressW.zip == "" || $scope.qr.dataQR.addressW.country == "")){
        $scope.errType = "addressW";
        $scope.hasErr = true;
        if($scope.qr.dataQR.addressW.address == ""){
          $("#addressW").focus();
        } else if($scope.qr.dataQR.addressW.city == ""){
          $("#cityW").focus();
        } else if($scope.qr.dataQR.addressW.state == ""){
          $("#stateW").focus();
        } else if($scope.qr.dataQR.addressW.zip == ""){
          $("#zipW").focus();
        } else if($scope.qr.dataQR.addressW.country == ""){
          $("#countryW").focus();
        }
      }

      // else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.isWorkAdd && ($scope.qr.dataQR.addressW.address == "" || $scope.qr.dataQR.addressW.city == "" || $scope.qr.dataQR.addressW.state == "" || $scope.qr.dataQR.addressW.zip == "" || $scope.qr.dataQR.addressW.country == "")){
      //   $scope.errType = "addressW";
      //   $scope.hasErr = true;
      //   $("#addressW").focus();
      // }

      else if($scope.qr.dType == "dp" && !$scope.qr.dataQR.id){
        $scope.errType = "device";
        $scope.hasErr = true;
        $("#device").focus();
      } else{
        if($scope.qr.dType == "location"){
          $scope.addressType();
        }

        if($scope.qr.dType == "event"){
          $scope.dateRange = angular.element(document).find(".picker").val();
          if(angular.isUndefined($scope.dateRange)){
            $scope.curDate = $scope.qr.dataQR.date;
          } else{
            $scope.curDate = $scope.dateRange.split(" - ");
          }

          $scope.currentDate = {startDate:$scope.curDate[0], endDate:$scope.curDate[1]};

          $scope.qr.dataQR.sd = moment($scope.currentDate.startDate).format("YYYY-MM-DD");
          $scope.qr.dataQR.ed = moment($scope.currentDate.endDate).format("YYYY-MM-DD");

          if(!$scope.qr.dataQR.isAllDay){
            $scope.qr.dataQR.st = $filter("date")($scope.qr.dataQR.sTime, "HH:mm");
            $scope.qr.dataQR.st = $scope.qr.dataQR.st + ":00";

            $scope.qr.dataQR.et = $filter("date")($scope.qr.dataQR.eTime, "HH:mm");
            $scope.qr.dataQR.et = $scope.qr.dataQR.et + ":00";

            if($scope.qr.dataQR.st >= $scope.qr.dataQR.et){
              $scope.errType = "startEnd";
              $scope.hasErr = true;
              $("#eTime").focus();
              return false;
            }
          }
        }
        if($scope.qr.dType == "vCard"){
          $scope.curSDate = moment($scope.qr.dataQR.dobDate).format("YYYY-MM-DD");
          $scope.qr.dataQR.dob = moment($scope.qr.dataQR.dobDate).format("YYYY-MM-DD");
        }

        $scope.qrObj = {dType:$scope.qr.dType, dataQR:$scope.qr.dataQR}
        $scope.previewLoading = true;

        if($scope.qrObj.dType == "dp"){
          $scope.qrObj.dataQR = {id:$scope.qr.dataQR.id, mac:$scope.qr.dataQR.h, h:$scope.qr.dataQR.h, l:$scope.qr.dataQR.l, label:$scope.qr.dataQR.l, isControls:$scope.qr.dataQR.isControls};
        }

        QRCodeSrv.getQRCode($scope.qrObj).then(
          function(data){
            $scope.previewLoading = false;
            $scope.detailLoading = false;
            $scope.isPreview = true;
            $scope.qrPreview = data;
            $scope.cBucket = $scope.cDetailBucket = $scope.qrPreview.bucket;
            if($scope.qrPreview.mbucket && $scope.qrPreview.mbucket != ""){
              $scope.cDetailBucket = $scope.qrPreview.mbucket;
            }
          },
          function(err){
            $scope.previewLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.dl = {isOpen:false};
    $scope.deviceSearchFocus = function(){
      $scope.searchDevice = {label:""};
      if($scope.dl.isOpen){
        $scope.searchChangeData($scope.searchDevice.label);
      }
      if($scope.allScrollDataList.length > 1){
      // if($scope.devicesList.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

  //   $rootScope.changeKioskSetting = function(k){
  //     $scope.jci.kiosk = k
  //     angular.element(document).find('.customSelectKiosk').removeClass('open')
  //   }
    $scope.singleDeviceFx = function(d){
      d.label = d.l;
      d.mac = d.h;
      $scope.qr.dataQR = d;
      $scope.isSelectDevice = false;
    }

    $scope.qrFx = function(){
      $scope.qr.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.qr.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.qr.dType == ""){
        $scope.errType = "type";
        $scope.hasErr = true;
        $("#dType").focus();
      } else if($scope.qr.dType == "url" && $scope.qr.dataQR.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.qr.dType == "txt" && $scope.qr.dataQR.txt == ""){
        $scope.errType = "txt";
        $scope.hasErr = true;
        $("#txt").focus();
      } else if($scope.qr.dType == "call" && $scope.qr.dataQR.no == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#contact").focus();
      } else if($scope.qr.dType == "call" && $scope.qr.dataQR.no != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.no)){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#contactInv").focus();
      } else if($scope.qr.dType == "content" && ($scope.qr.dataQR.content == "" || $scope.qr.dataQR.content == null)){
        $scope.errType = "content";
        $scope.hasErr = true;
        $("#contentBtn").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.no == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#smsContact").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.no != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.no)){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#smsContact").focus();
      } else if($scope.qr.dType == "sms" && $scope.qr.dataQR.msg == ""){
        $scope.errType = "sMsg";
        $scope.hasErr = true;
        $("#sMsg").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.email == ""){
        $scope.errType = "email";
        $scope.hasErr = true;
        $("#email").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.email != "" && !$scope.checkRegex("em", $scope.qr.dataQR.email)){
        $scope.errType = "emailInv";
        $scope.hasErr = true;
        $("#email").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.sub == ""){
        $scope.errType = "eSub";
        $scope.hasErr = true;
        $("#eSub").focus();
      } else if($scope.qr.dType == "email" && $scope.qr.dataQR.msg == ""){
        $scope.errType = "eMsg";
        $scope.hasErr = true;
        $("#eMsg").focus();
      } else if($scope.qr.dType == "wifi" && $scope.qr.dataQR.ssId == ""){
        $scope.errType = "ssId";
        $scope.hasErr = true;
        $("#ssId").focus();
      } else if($scope.qr.dType == "wifi" && $scope.qr.dataQR.pwd == ""){
        $scope.errType = "pwd";
        $scope.hasErr = true;
        $("#pwd").focus();
      } else if($scope.qr.dType == "event" && $scope.qr.dataQR.title == ""){
        $scope.errType = "title";
        $scope.hasErr = true;
        $("#title").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "c" && $scope.qr.dataQR.lat == ""){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lat").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "c" && $scope.qr.dataQR.lng == ""){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lng").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.address == ""){
        $scope.errType = "address";
        $scope.hasErr = true;
        $("#address").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.city == ""){
        $scope.errType = "city";
        $scope.hasErr = true;
        $("#city").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.province == ""){
        $scope.errType = "province";
        $scope.hasErr = true;
        $("#province").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && $scope.qr.dataQR.country == ""){
        $scope.errType = "country";
        $scope.hasErr = true;
        $("#country").focus();
      } else if($scope.qr.dType == "location" && $scope.qr.dataQR.info.type == "a" && ($scope.qr.dataQR.lat == "" && $scope.qr.dataQR.lat == "")){
        $scope.errType = "addrNotVlid";
        $scope.hasErr = true;
        $("#addrNotVlid").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.fName == ""){
        $scope.errType = "fName";
        $scope.hasErr = true;
        $("#fName").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.lName == ""){
        $scope.errType = "lName";
        $scope.hasErr = true;
        $("#lName").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.contactM == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#contactM").focus();
      } else if($scope.qr.dType == "vCard" && (($scope.qr.dataQR.contactM != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactM)) || ($scope.qr.dataQR.contactH != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactH)) || ($scope.qr.dataQR.contactW != "" && !$scope.checkRegex("ph", $scope.qr.dataQR.contactW)))){
        $scope.errType = "contactInv";
        $scope.hasErr = true;
        $("#contactInv").focus();
      } else if($scope.qr.dType == "vCard" && (($scope.qr.dataQR.emailP != "" && !$scope.checkRegex("em", $scope.qr.dataQR.emailP)) || ($scope.qr.dataQR.emailW != "" && !$scope.checkRegex("em", $scope.qr.dataQR.emailW)))){
        $scope.errType = "emailsInv";
        $scope.hasErr = true;
        $("#emailsInv").focus();
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.isHomeAdd && ($scope.qr.dataQR.addressH.address == "" || $scope.qr.dataQR.addressH.city == "" || $scope.qr.dataQR.addressH.state == "" || $scope.qr.dataQR.addressH.zip == "" || $scope.qr.dataQR.addressH.country == "")){
        $scope.errType = "addressH";
        $scope.hasErr = true;
        if($scope.qr.dataQR.addressH.address == ""){
          $("#addressH").focus();
        } else if($scope.qr.dataQR.addressH.city == ""){
          $("#cityH").focus();
        } else if($scope.qr.dataQR.addressH.state == ""){
          $("#stateH").focus();
        } else if($scope.qr.dataQR.addressH.zip == ""){
          $("#zipH").focus();
        } else if($scope.qr.dataQR.addressH.country == ""){
          $("#countryH").focus();
        }
      } else if($scope.qr.dType == "vCard" && $scope.qr.dataQR.isWorkAdd && ($scope.qr.dataQR.addressW.address == "" || $scope.qr.dataQR.addressW.city == "" || $scope.qr.dataQR.addressW.state == "" || $scope.qr.dataQR.addressW.zip == "" || $scope.qr.dataQR.addressW.country == "")){
        $scope.errType = "addressW";
        $scope.hasErr = true;
        if($scope.qr.dataQR.addressW.address == ""){
          $("#addressW").focus();
        } else if($scope.qr.dataQR.addressW.city == ""){
          $("#cityW").focus();
        } else if($scope.qr.dataQR.addressW.state == ""){
          $("#stateW").focus();
        } else if($scope.qr.dataQR.addressW.zip == ""){
          $("#zipW").focus();
        } else if($scope.qr.dataQR.addressW.country == ""){
          $("#countryW").focus();
        }
      } else if($scope.qr.dType == "dp" && !$scope.qr.dataQR.id){
        $scope.errType = "device";
        $scope.hasErr = true;
        $("#device").focus();
      } else{
        if($scope.qr.dType == "event"){
          $scope.dateRange = angular.element(document).find(".picker").val();
          if(angular.isUndefined($scope.dateRange)){
            $scope.curDate = $scope.qr.dataQR.date;
          } else{
            $scope.curDate = $scope.dateRange.split(" - ");
          }

          $scope.currentDate = {startDate:$scope.curDate[0], endDate:$scope.curDate[1]};

          $scope.qr.dataQR.sd = moment($scope.currentDate.startDate).format("YYYY-MM-DD");
          $scope.qr.dataQR.ed = moment($scope.currentDate.endDate).format("YYYY-MM-DD");

          if(!$scope.qr.dataQR.isAllDay){
            $scope.qr.dataQR.st = $filter("date")($scope.qr.dataQR.sTime, "HH:mm");
            $scope.qr.dataQR.st = $scope.qr.dataQR.st + ":00";

            $scope.qr.dataQR.et = $filter("date")($scope.qr.dataQR.eTime, "HH:mm");
            $scope.qr.dataQR.et = $scope.qr.dataQR.et + ":00";

            if($scope.qr.dataQR.st >= $scope.qr.dataQR.et){
              $scope.errType = "startEnd";
              $scope.hasErr = true;
              $("#eTime").focus();
              return false;
            }
          }
        }
        if($scope.qr.dType == "vCard"){
          $scope.curSDate = moment($scope.qr.dataQR.dobDate).format("YYYY-MM-DD");
          $scope.qr.dataQR.dob = moment($scope.qr.dataQR.dobDate).format("YYYY-MM-DD");
        }
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.qrSaveFx();
          }, 250);
        } else{
          $scope.qrSaveFx();
        }
      }
    }

    $scope.qrSaveFx = function(){
      delete $scope.qr.dValue;
      if($scope.qr.dType == "dp"){
        $scope.qr.dataQR = {id:$scope.qr.dataQR.id, mac:$scope.qr.dataQR.h, h:$scope.qr.dataQR.h, l:$scope.qr.dataQR.l, label:$scope.qr.dataQR.l, isControls:$scope.qr.dataQR.isControls};
      }
      QRCodeSrv.saveQR($scope.qr).then(
        function(data){
          $state.go("hub.contentLibrary.c");
          $scope.saveProcessing = false;
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.resetWarnMsgFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.resetHomeAddFx = function(){
      if(!$scope.qr.dataQR.isHomeAdd){
        $scope.qr.dataQR.addressH = {address:"", city:"", state:"", zip:"", country:""};
      }
    }
    $scope.resetWorkAddFx = function(){
      if(!$scope.qr.dataQR.isWorkAdd){
        $scope.qr.dataQR.addressW = {address:"", city:"", state:"", zip:"", country:""};
      }
    }

    /** Google Map */
    $scope.vm = this;
    $scope.vm.positions = [];
    $scope.inputLimit = 100;
    $scope.vm.addMarker = function(event){
      var ll = event.latLng;
      $scope.vm.positions[0] = {lat:ll.lat(), lng:ll.lng()};
      $scope.qr.dataQR.lat = $scope.vm.positions[0].lat;
      $scope.qr.dataQR.lng = $scope.vm.positions[0].lng;
    }

    $scope.$on('mapentrySelected', function(event, geoCoder){
      if(!angular.isUndefined(geoCoder)){
        angular.forEach(geoCoder.address_components, function(geo){
          if(geo.types[0]){
            if(geo.types[0] == "locality"){
              $scope.qr.dataQR.city = geo.long_name;
            } else if(geo.types[0] == "administrative_area_level_1"){
              $scope.qr.dataQR.province = geo.long_name;
            } else if(geo.types[0] == "postal_code"){
              $scope.qr.dataQR.zipCode = geo.long_name;
            } else if(geo.types[0] == "country"){
              $scope.qr.dataQR.country = geo.long_name;
            }
          }
        });
        $scope.qr.dataQR.lat = geoCoder.geometry.location.lat();
        $scope.qr.dataQR.lng = geoCoder.geometry.location.lng();
        $scope.qr.dataQR.address = geoCoder.formatted_address;
      }
    });

    var azmap;
    $scope.azMapFx = function(){
      // var keyArr = atob($scope.auth.uservices.mk).split("|");
      // var subKey = $scope.reverse(keyArr[0]);
      azmap = new atlas.Map('azMap', {
        view:'Auto',
        center:[75.8577, 22.7196],
        zoom:8,
        showFeedbackLink:false,
        enableAccessibilityLocationFallback:false,
        // Add your Azure Maps subscription client ID to the map SDK.
        authOptions:{
          //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
          authType:'subscriptionKey',
          // subscriptionKey:subKey
          subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
        },
        language: "en"
      });
      azmap.events.add('click', function(e){addPin(e)});
    }

    $scope.setMarker = function(){
      //google map marker
      if($scope.auth.uservices.m == "g"){
        if($scope.qr.dataQR.lat && $scope.qr.dataQR.lng){
          $scope.vm.positions[0] = {lat:$scope.qr.dataQR.lat, lng:$scope.qr.dataQR.lng};
          $scope.mapCenter = [$scope.qr.dataQR.lat, $scope.qr.dataQR.lng];
          $scope.map.setCenter(new google.maps.LatLng($scope.mapCenter[0], $scope.mapCenter[1]));
          $scope.map.setZoom(5);
        } else{
          $scope.map.setCenter(new google.maps.LatLng(43.6532, -79.3832));
          $scope.vm.positions = [];
          $scope.map.setZoom(5);
        }
      } else{
        if($scope.qr.dataQR.lat && $scope.qr.dataQR.lng){
          if($scope.auth.uservices.m == "b"){
            azmap.markers.clear();
            $scope.cordinates = [];
            var selPosition = [$scope.qr.dataQR.lng, $scope.qr.dataQR.lat];
            var pin = new atlas.HtmlMarker({
              htmlContent:atlas.getImageTemplate('marker'),
              color:"DodgerBlue",
              position:selPosition,
              popup:new atlas.Popup({
                pixelOffset:[0, -30]
              })
            });
            azmap.markers.add(pin);
          }

          azmap.setCamera({
            //center map
            center:[$scope.qr.dataQR.lng, $scope.qr.dataQR.lat]
          });
        } else{
          azmap.setCamera({
            center:[75.8577, 22.7196]
          });
        }
      }
    }

    //add pin on bing map
    function addPin(e){
      azmap.markers.clear();
      if(e.type == "click"){
        var position = [e.position[0], e.position[1]];
        var pin = new atlas.HtmlMarker({
          htmlContent:atlas.getImageTemplate('marker'),
          color:"DodgerBlue",
          position:position,
          popup:new atlas.Popup({
            pixelOffset:[0, -30]
          })
        });

        azmap.markers.add(pin);
        $scope.qr.dataQR.lat = e.position[1];
        $scope.qr.dataQR.lng = e.position[0];
        $scope.$apply();
      }
    }

    $scope.setTypeFx = function(type){
      $scope.qr.dataQR = {};
      $scope.isPreview = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(type == "call"){
        $scope.qr.dataQR = {no:""};
      } else if(type == "dp"){
        $scope.getDeviceFx();
      } else if(type == "sms"){
        $scope.qr.dataQR = {no:"", msg:""};
      } else if(type == "email"){
        $scope.qr.dataQR = {email:"", sub:"", msg:""};
      } else if(type == "wifi"){
        $scope.qr.dataQR = {ssId:"", pwd:"", nType:"WEP", isHidden:false};
      } else if(type == "location"){
        $scope.qr.dataQR = {lat:"", lng:"", info:{type:"c"}, address:"", city:"", province:"", country:""};
        setTimeout(function(){
          if($scope.auth.uservices.m == "b"){
            $scope.azMapFx();
            $scope.setMarker();
          }
        }, 1000);
      } else if(type == "event"){
        $scope.qr.dataQR = {title:"", loc:"", isAllDay:false, date:{startDate:moment()._d, endDate:moment()._d}, sd:"", st:"", sTime:moment().format(), eTime:moment().format(), ed:"", et:"", desc:"", tz:{label:"Asia/Kolkata"}};
      } else if(type == "vCard"){
        $scope.qr.dataQR = {fName:"", lName:"", mName:"", nName:"", dob:"", dobDate:moment()._d, emailP:"", emailW:"", contactM:"", contactH:"", contactW:"", org:"", jobTitle:"", website:"", isHomeAdd:false, addressH:{address:"", city:"", state:"", zip:"", country:""}, isWorkAdd:false, addressW:{address:"", city:"", state:"", zip:"", country:""}, note:""};
      } else if(type == "content"){
        $scope.qr.dataQR = {content:""};
        // $scope.qr.dataQR = {content:"", isControls:$scope.qr.dataQR.isControls};
      } else{
        $scope.qr.dataQR[type] = "";
      }
    }

    //dob popup
    $scope.inlineOptions = {
      minDate:new Date(),
      showWeeks:true
    };

    var maxDate = new Date();
    maxDate = maxDate.setDate(maxDate.getDate() - 0);

    $scope.dateOptions = {
      formatYear:'yy',
      maxDate:maxDate,
      startingDay:1
    };

    $scope.toggleMin = function(){
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null :new Date();
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };

    $scope.toggleMin();

    $scope.open1 = function(){
      $scope.popup1.opened = true;
    };

    $scope.popup1 = {
      opened:false
    };

    //select address/coordinate type
    $scope.addressType = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.qr.dataQR.info.type == "c"){
        $scope.mapFocus = [43.6532, -79.3832];
        setTimeout(function(){
          if($scope.auth.uservices.m == "b"){
            $scope.azMapFx();
            $scope.setMarker();
          }
        }, 1000);
      }
    }

    $scope.checkRegex = function(caller, val){
      if(caller == "em"){
        var em = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return em.test(val);
      } else if(caller == "ph"){
        var ph = /^\s*(?:\+?(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/;
        return ph.test(val);
      } else if(caller == "pr"){
        var pr = /^-?\d*\.?\d*$/;
        return pr.test(val);
      }
    }

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || (item.splType && (item.splType == "Image" || item.splType == "Video")) || (item.type == "Widget" && (item.extn == "IFrame" || item.extn == "Traffic" || item.extn == "Google Slide" || item.extn == "Microsoft Power BI"|| item.extn == "Live Streaming"|| item.extn == "Vimeo" || item.extn == "YouTube" || item.extn === "Web Page" || item.extn === "Count" || item.extn === "Date Time" || item.extn === "News" || item.extn === "Open Hours" || item.extn === "Quotes" || item.extn === "RSS Feed" || item.extn === "Stock Price" || item.extn === "Crawling Text" || item.extn === "Static Text" || item.extn === "Weather" || item.extn === "Meeting" || item.extn === "Firstup" || item.extn === "x" || item.extn === "Content on Demand" || item.extn === "Outlook Calendar" || item.extn === "Google Calendar"))){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.curBg = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              pSize: listItem.pSize,
              size: listItem.size,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.hasErr = false;
        $scope.errType = "";
        $scope.qr.dataQR.content = $scope.curBg;
        $scope.qr.dataQR.isHidden = 0;
        ngDialog.close();
      }
    }
    $scope.removeBgFx = function(){
      $scope.qr.dataQR.content = "";
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || (item.type == "Widget" && (item.extn == "IFrame" || item.extn == "Traffic" || item.extn == "Google Slide" || item.extn == "Microsoft Power BI"|| item.extn == "Live Streaming"|| item.extn == "Vimeo" || item.extn == "YouTube" || item.extn === "Web Page" || item.extn === "Count" || item.extn === "Date Time" || item.extn === "News" || item.extn === "Open Hours" || item.extn === "Quotes" || item.extn === "RSS Feed" || item.extn === "Stock Price" || item.extn === "Crawling Text" || item.extn === "Static Text" || item.extn === "Weather" || item.extn === "Meeting" || item.extn === "Firstup" || item.extn === "x" || item.extn === "Content on Demand" || item.extn === "Outlook Calendar" || item.extn === "Google Calendar"))){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // * scroll list data code START 2nd phase pagination
    $scope.updateDefineVariable();

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      $scope.loadingMore = true;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.loadingMore = false;
              $scope.$apply();
            });
          },
          function(err){
            $scope.loadingMore = false;
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.loadingMore = false;
              $scope.$apply();
            });
          },
          function(err){
            $scope.loadingMore = false;
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      $scope.dListLoading = true;
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });            
            $scope.dListLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.dListLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      });
    }, 0);

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: encodeURIComponent(text) });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: encodeURIComponent(text) });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }
    // * scroll list data code END 2nd phase pagination
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('QlikController', QlikController);

  /** @ngInject */
  function QlikController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, ngDialog, QlikSrv){
    $scope.colorPicker = {b:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.authSaveDisable = false;
    $scope.authProcessing = false;
    $scope.detailLoading = false;
    $scope.visualizShow = false;
    $scope.authSuccess = false;
    $scope.isWorkspace = false;
    $scope.groupShow = false;
    $scope.isLoading = false;
    $scope.isPEOpen = false;
    $scope.groupList = [];
    $scope.encId = "";
    $scope.decId = "";
    $scope.customData = {item:"", tab:""};
    $scope.selType="single";
    $scope.settings = {reloadOpt:"n", reload:"", bg:"#000000", bga:1, ctype:{bg:"monochrome"}};
    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.isReport = false;
    $scope.pages=[];
    $scope.appList = [];
    $scope.al = {isOpen:false};

    $scope.settingsDefault = function(){
      $scope.qlik.settings = angular.copy($scope.defaultSettings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.isWorkspace = true;
      QlikSrv.getQlik($scope.decId).then(
        function(data){
          $scope.qlik = data;
          if(!$scope.qlik.settings.bg){
            $scope.qlik.settings.bg = "#000000";
            $scope.qlik.settings.bga = 1;
            $scope.qlik.settings.ctype = {bg:"monochrome"};
          }
          if($scope.qlik.isAuth){
            $scope.appListShow = true;
          }
          $scope.qlikCopy = angular.copy(data);
          $scope.detailLoading = false;
         },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.qlik = {labelOpt:"a",label:"", toast:false, settings:angular.copy($scope.settings), apps:"", sheet:{id:'', name:''}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){
      }
    }
    $rootScope.selectedTabFx();

    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.openUrlFx = function(w, h, caller){
      if($scope.appListShow){
        $scope.authSaveDisable = true;
      }
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "ou"){
        var newWindow = window.open($scope.ouUrl, 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      if(caller != "at"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(
        function(){
          if(caller != "at"){
            if(caller == "ou"){
              newWindow.close();
            }
            ngDialog.close($scope.confirmDialog);
          }
          $scope.popProcessing = false;
          $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
      return false;
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template: '\
          <section class="panel">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'re\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'ou\'">{{"cl.widget.qlik.m10" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
            <button type="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        QlikSrv.getVerify($scope.qlik.id).then(
          function(data){
            $scope.authProcessing = false;
            $scope.errType = "";
            $scope.hasErr = false;
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
              return;
            } else if(data.isClosed){
              $scope.authSuccess = true;
              $scope.qlik.isAuth = true;
              $scope.authSaveDisable = false;
              $scope.getAppListFx();
            } else{
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.appListShow = false;
    $scope.getAppListFx = function(){
      $scope.appsLoading = true;
      QlikSrv.getApps($scope.qlik.id).then(
        function(data){
          $scope.appList = data.data;
          $scope.appListShow = true;
          $scope.appsLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.appsLoading = false;
        }
      );
    }

    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.qlikFx = function(tab, caller){
      $scope.qlik.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || caller == "save"){
        if($scope.qlik.labelOpt == "c" && $scope.qlik.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.qlik.settings.reloadOpt == "c" && ($scope.qlik.settings.reload == "" || $scope.qlik.settings.reload == null)){
          $scope.errType = "reload";
          $scope.hasErr = true;
          $("#cReload").focus();
        }else if(tab == 1){
          $scope.saveProcessing = true;
          $scope.authSaveDisable = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.qlik.isAuth == 1){
            QlikSrv.getVerify($scope.qlik.id).then(
              function(data){
                $scope.qlik.isAuth = true;
                $scope.authSaveDisable = false;
                $scope.getAppListFx();
              },
              function(err){
                $log.error(err);
              }
            );
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveQlikFx();
              $scope.isPEOpen = false;
            }, 250);
          }
          else{
            $scope.saveQlikFx();
            $scope.isPEOpen = false;
          }
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveQlikFx(caller);
            }, 250);
          } else{
            $scope.saveQlikFx(caller);
          }
        }
      }

    }

    $scope.saveQlikFx = function(caller){
      if(caller == "save"){
        $scope.qlik.toast = true;
      } else{
        $scope.qlik.toast = false;
      }
      if(caller == "save" && !$scope.qlik.isAuth){
        $scope.hasErr = true;
        $scope.errType = "authEmpty";
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.selectedT == 2 && $scope.qlik.apps == ""){
        $scope.errType = "app";
        $scope.hasErr = true;
        $("#app").focus();
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.selectedT == 2 && $scope.qlik.sheet.name == ""){
        $scope.errType = "sheet";
        $scope.hasErr = true;
        $("#sheet").focus();
        $scope.saveProcessing = false;
      } else{
        $scope.qlik.sheet.id = $scope.qlik.sheet.name;
        QlikSrv.saveQlik($scope.qlik).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.qlik.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }
            
            $scope.ouUrl = data.ouUrl;
            if(data.code == 8401){
              $scope.errType = "invTenant";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.backBtnFx = function(){
      $rootScope.selectedT = $rootScope.selectedT - 1;
    }

    $scope.toggleCallback= function(open){
      $scope.searchApp.name = "";
    }
    $scope.appSearchFocus = function () {
      $scope.searchApp = {name:""};
      if($scope.appList && $scope.appList.length > 5){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }
    $scope.selAppFx = function(app){
      $scope.al.isOpen = !$scope.al.isOpen;
      $scope.qlik.apps = app;
      angular.element(document).find('.customSelectChannel').removeClass('open')
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ProgressBarController', ProgressBarController);

  /** @ngInject */
  function ProgressBarController($log, $rootScope, $scope, $state, $cookies, $timeout, ProgressBarSrv){
    $scope.colorPicker = {b:false, bc:false,gc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#cccccc", bga:1, fill:"#444444", orientation:"h", fValType:"d", fVal:"", rcs:10, gl:false, glc:"#6fa8dc" , hoff:0.2, voff:0.2, blr:0.8, rc:false},
      ctype:{bg:"monochrome", fill:"monochrome", glc:"default"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.pb.settings = angular.copy($scope.defaultSettings.settings);
      $scope.pb.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ProgressBarSrv.getData($scope.decId).then(
        function(data){
          $scope.pb = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.pb = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.pbSaveFx = function(){
      $scope.pb.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.pb.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.pb.settings.fValType == 's' && !$scope.pb.settings.fVal){
        $scope.errType = "fVal";
        $scope.hasErr = true;
        $("#fValue").focus();
      } else if($scope.pb.settings.fVal > 100){
        $scope.errType = "invFVal";
        $scope.hasErr = true;
        $("#fValue").focus();
      } else if(!$scope.pb.settings.rcs){
        $scope.errType = "rcs";
        $scope.hasErr = true;
        $("#rcs").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      ProgressBarSrv.saveData($scope.pb).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PrayerController', PrayerController);

  /** @ngInject */
  function PrayerController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, PrayerSrv){
    $scope.colorPicker = {b:false, tt:false, tm:false, dt:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.methodList = [];
    $scope.encId = "";
    $scope.decId = "";
    $scope.copyAddr = "";

    $scope.list = {
      settings:{rotationOpt:"a", rotate:12, bg:"#006dd8", bga:1, titleText:"#ffffff", timeText:"#ffffff", descText:"#ffffff",  titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamilySelected, descFont:$scope.fontFamilySelected, titleSize:30, timeSize:50, descSize:20},
      ctype:{bg:"custom", titleText:"monochrome", timeText:"monochrome", descText:"monochrome"}
    }

    $scope.countdown = {
      settings:{
        bg:"#006dd8", bga:1, titleText:"#000000", titleSize:35, titleFont:$scope.fontFamilySelected, timeText:"#000000", timeSize:35, timeFont:$scope.fontFamilySelected
      },
      ctype:{bg:"custom", textBg:"monochrome", text:"monochrome", time:"monochrome"}
    }

    $scope.defaultSettingsList = angular.copy($scope.list);
    $scope.defaultSettingsCountdown = angular.copy($scope.countdown);

    $scope.settingsDefault = function(){
      if($scope.prayer.dType == "l"){
        $scope.list = angular.copy({settings:$scope.defaultSettingsList.settings, ctype:$scope.defaultSettingsList.ctype});
      } else if($scope.prayer.dType == "c"){
        $scope.countdown = angular.copy({settings:$scope.defaultSettingsCountdown.settings, ctype:$scope.defaultSettingsCountdown.ctype});
      }
    }

    $scope.getMethodList = function(){
      $scope.listLoading = true;
      PrayerSrv.getMethods().then(
        function(data){
          $scope.methodList = data;
          $scope.listLoading = false;
        },
        function(err){
          $scope.listLoading = false;
          $log.error(err);
        }
      );
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.getMethodList();
      PrayerSrv.getPrayer($scope.decId).then(
        function(data){
          $scope.prayer = data;
          $scope.copyAddr = {addr:data.addr, aType:data.aType};
          if($scope.prayer.dType == "l"){
            $scope.list.settings = angular.copy($scope.prayer.settings);
            $scope.list.ctype = angular.copy($scope.prayer.ctype);
            if(!$scope.prayer.settings.rotationOpt){
              $scope.list.settings.rotationOpt = "a";
              $scope.list.settings.rotate = 12;
            }
          } else if($scope.prayer.dType == "c"){
            $scope.countdown.settings = angular.copy($scope.prayer.settings);
            $scope.countdown.ctype = angular.copy($scope.prayer.ctype);
          }
          if($scope.prayer.aType == 'c'){
            $scope.addressType();
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.prayer = {label:"", religion:"", method:"", aType:"c", dType:"l", addr:{lat:"", lng:"", address:"", city:"", province:"", country:"", zipCode:""}, activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.list.settings),
        ctype:angular.copy($scope.list.ctype)
      };
    }

    $scope.selAddrTypeFx = function(){
      // console.warn($scope.prayer);
    }

    $scope.mapLoaded = function(map){
      $scope.map = map;
      $scope.setMarker();
      $scope.$apply();
    }

    $scope.selReligionFx = function(){
      $scope.getMethodList();
      setTimeout(function(){
        if($scope.auth.uservices.m == "b"){
          $scope.azMapFx();
          $scope.setMarker();
        }
      }, 1000);
    }



    /** Google Map */
    $scope.vm = this;
    $scope.vm.positions = [];
    $scope.inputLimit = 100;
    $scope.vm.addMarker = function(event){
      var ll = event.latLng;
      $scope.vm.positions[0] = {lat:ll.lat(), lng:ll.lng()};
      $scope.prayer.addr.lat = $scope.vm.positions[0].lat;
      $scope.prayer.addr.lng = $scope.vm.positions[0].lng;
    }

    $scope.$on('mapentrySelected', function(event, geoCoder){
      if(!angular.isUndefined(geoCoder)){
        angular.forEach(geoCoder.address_components, function(geo){
          if(geo.types[0]){
            if(geo.types[0] == "locality"){
              $scope.prayer.addr.city = geo.long_name;
            } else if(geo.types[0] == "administrative_area_level_1"){
              $scope.prayer.addr.province = geo.long_name;
            } else if(geo.types[0] == "postal_code"){
              $scope.prayer.addr.zipCode = geo.long_name;
            } else if(geo.types[0] == "country"){
              $scope.prayer.addr.country = geo.long_name;
            }
          }
        });
        $scope.prayer.addr.lat = geoCoder.geometry.location.lat();
        $scope.prayer.addr.lng = geoCoder.geometry.location.lng();
        $scope.prayer.addr.address = geoCoder.formatted_address;
      }
    });

    var azmap;
    $scope.azMapFx = function(){
      // var keyArr = atob($scope.auth.uservices.mk).split("|");
      // var subKey = $scope.reverse(keyArr[0]);
      azmap = new atlas.Map('azMap', {
        view:'Auto',
        center:[75.8577, 22.7196],
        zoom:8,
        showFeedbackLink:false,
        enableAccessibilityLocationFallback:false,
        // Add your Azure Maps subscription client ID to the map SDK.
        authOptions:{
          //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
          authType:'subscriptionKey',
          // subscriptionKey:subKey
          subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
        },
        language: "en"
      });
      azmap.events.add('click', function(e){addPin(e)});
    }

    $scope.setMarker = function(){
      //google map marker
      if($scope.auth.uservices.m == "g"){
        if($scope.prayer.addr.lat && $scope.prayer.addr.lng){
          $scope.vm.positions[0] = {lat:$scope.prayer.addr.lat, lng:$scope.prayer.addr.lng};
          $scope.mapCenter = [$scope.prayer.addr.lat, $scope.prayer.addr.lng];
          $scope.map.setCenter(new google.maps.LatLng($scope.mapCenter[0], $scope.mapCenter[1]));
          $scope.map.setZoom(5);
        } else{
          $scope.map.setCenter(new google.maps.LatLng(43.6532, -79.3832));
          $scope.vm.positions = [];
          $scope.map.setZoom(5);
        }
      } else{
        if($scope.prayer.addr.lat && $scope.prayer.addr.lng){
          if($scope.auth.uservices.m == "b"){
            azmap.markers.clear();
            $scope.cordinates = [];
            var selPosition = [$scope.prayer.addr.lng, $scope.prayer.addr.lat];
            var pin = new atlas.HtmlMarker({
              htmlContent:atlas.getImageTemplate('marker'),
              color:"DodgerBlue",
              position:selPosition,
              popup:new atlas.Popup({
                pixelOffset:[0, -30]
              })
            });
            azmap.markers.add(pin);
          }

          azmap.setCamera({
            //center map
            center:[$scope.prayer.addr.lng, $scope.prayer.addr.lat]
          });
        } else{
          azmap.setCamera({
            center:[75.8577, 22.7196]
          });
        }
      }
    }

    //add pin on bing map
    function addPin(e){
      azmap.markers.clear();
      if(e.type == "click"){
        var position = [e.position[0], e.position[1]];
        var pin = new atlas.HtmlMarker({
          htmlContent:atlas.getImageTemplate('marker'),
          color:"DodgerBlue",
          position:position,
          popup:new atlas.Popup({
            pixelOffset:[0, -30]
          })
        });

        azmap.markers.add(pin);
        $scope.prayer.addr.lat = e.position[1];
        $scope.prayer.addr.lng = e.position[0];
        $scope.$apply();
      }
    }

    //select address/coordinate type
    $scope.addressType = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.prayer.aType == "c"){
        $scope.mapFocus = [43.6532, -79.3832];
        setTimeout(function(){
          if($scope.auth.uservices.m == "b"){
            $scope.azMapFx();
            $scope.setMarker();
          }
        }, 1000);
      }
      if($scope.encId){
        if($scope.prayer.aType == "d"){
          $scope.prayer.addr = {lat:"", lng:"", address:"", city:"", province:"", country:"", zipCode:""};
        } else {
          $scope.prayer.addr = $scope.copyAddr.addr;
        }
      }
    }

    $scope.prayerFx = function(){
      $scope.prayer.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.prayer.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.prayer.religion == ""){
        $scope.errType = "religion";
        $scope.hasErr = true;
        $("#religion").focus();
      } else if($scope.prayer.method == ""){
        $scope.errType = "method";
        $scope.hasErr = true;
        $("#method").focus();
      } else if($scope.prayer.aType == "c" && ($scope.prayer.addr.lat == "" || $scope.prayer.addr.lat == null)){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lat").focus();
      } else if($scope.prayer.aType == "c" && ($scope.prayer.addr.lng == "" || $scope.prayer.addr.lng == null)){
        $scope.errType = "latLng";
        $scope.hasErr = true;
        $("#lng").focus();
      } else if($scope.prayer.aType == "a" && ($scope.prayer.addr.address == "" || $scope.prayer.addr.address == null)){
        $scope.errType = "address";
        $scope.hasErr = true;
        $("#address").focus();
      } else if($scope.prayer.aType == "a" && ($scope.prayer.addr.city == "" || $scope.prayer.addr.city == null)){
        $scope.errType = "city";
        $scope.hasErr = true;
        $("#city").focus();
      } else if($scope.prayer.aType == "a" && ($scope.prayer.addr.province == "" || $scope.prayer.addr.province == null)){
        $scope.errType = "province";
        $scope.hasErr = true;
        $("#province").focus();
      } else if($scope.prayer.aType == "a" && ($scope.prayer.addr.country == "" || $scope.prayer.addr.country == null)){
        $scope.errType = "country";
        $scope.hasErr = true;
        $("#country").focus();
      } else if($scope.prayer.aType == "a" && ($scope.prayer.addr.lat == "" && $scope.prayer.addr.lng == "")){
        $scope.errType = "addrNotVlid";
        $scope.hasErr = true;
        $("#addrNotVlid").focus();
      } else if($scope.prayer.dType == 'l' && $scope.list.settings.rotationOpt  == 'c' && !$scope.list.settings.rotate) {
        $scope.errType = "rotation";
        $scope.hasErr = true;
      } else if(($scope.prayer.dType == 'l' && !$scope.list.settings.titleSize) || ($scope.prayer.dType == 'c' && !$scope.countdown.settings.titleSize)){
        $scope.errType = "tSize";
        $scope.hasErr = true;
      } else if(($scope.prayer.dType == 'l' && !$scope.list.settings.timeSize) || ($scope.prayer.dType == 'c' && !$scope.countdown.settings.timeSize)){
        $scope.errType = "tmSize";
        $scope.hasErr = true;
      } else if($scope.prayer.dType == 'l' && !$scope.list.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
      } else{
        $scope.saveProcessing = true;
        $scope.prayer.settings = $scope.prayer.dType == 'l' ? $scope.list.settings : $scope.countdown.settings;
        $scope.prayer.ctype = $scope.prayer.dType == 'l' ? $scope.list.ctype : $scope.countdown.ctype;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.savePrayerFx();
          }, 250);
        } else{
         $scope.savePrayerFx();
        }
      }
    }
    $scope.savePrayerFx = function(){
      PrayerSrv.savePrayer($scope.prayer).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PowerBIController', PowerBIController);

  /** @ngInject */
  function PowerBIController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, ngDialog, SettingsSrv, PowerBISrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.authProcessing = false;
    $scope.detailLoading = false;
    $scope.visualizShow = false;
    $scope.authSuccess = false;
    $scope.isWorkspace = false;
    $scope.groupShow = false;
    $scope.isLoading = false;
    $scope.isPEOpen = false;
    $scope.isReport = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.pages = [];
    $scope.groupList = [];
    $scope.selType = "single";
    $scope.customData = {item:"", tab:""};
    $scope.settings = {reloadOpt:"n", reload:""};
    $scope.searchText = {p:"", f:""};

    $scope.imgGenTimeObj = {w:"mon", di:1};

    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.powerBI.settings = angular.copy($scope.defaultSettings);
      if($scope.auth.upermissions.pbi){
        $scope.powerBI.info.pbi = $scope.auth.upermissions.pbi;
      }
      $scope.powerBI.info.imggentime = {f:"d", d:""};
      $scope.imgGenTimeObj = {w:"mon", di:1};
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.isWorkspace = true;
      PowerBISrv.getPowerBI($scope.decId).then(
        function(data){
          if(data.info.imggentime){
            if(data.info.imggentime.f == "w"){
              $scope.imgGenTimeObj.w = data.info.imggentime.d;
            } else if(data.info.imggentime.f == "di"){
              $scope.imgGenTimeObj.di = data.info.imggentime.d;
            }
          } else{
            data.info.imggentime = {f:"d", d:""};
          }

          $scope.powerBI = {info:data.info, settings:data.settings, powerbi:data.powerbi, activePeriod:data.activePeriod, permission:data.permission};
          // visualization:data.powerbi.visualization,
          $scope.powerBICopy = angular.copy(data);
          if(!$scope.powerBI.powerbi.powerBIApp){
            $scope.powerBI.powerbi.powerBIApp = $scope.widgetList.powerBIApp;
          }

          /* Decrypt */
          if($scope.widgetList.powerBIApp == "ca"){
            $scope.powerBI.powerbi.credential.tenantId = $scope.decryptFx($scope.powerBI.powerbi.credential.tenantId);
            $scope.powerBI.powerbi.credential.clientId = $scope.decryptFx($scope.powerBI.powerbi.credential.clientId);
            $scope.powerBI.powerbi.credential.secret = $scope.decryptFx($scope.powerBI.powerbi.credential.secret);
          }

          if($scope.powerBI.powerbi.selType == "custom" && $scope.powerBI.powerbi.type == "dashboards"){
            $scope.customData = {item:$scope.powerBI.powerbi.customData.dashboard};
          } else if($scope.powerBI.powerbi.selType == "custom" && $scope.powerBI.powerbi.type == "reports"){
            $scope.customData = {item:$scope.powerBI.powerbi.customData.report, tab:$scope.powerBI.powerbi.customData.tab};
          }
          $scope.selType = $scope.powerBI.powerbi.selType;
          if(data){
            if(data.groups && data.groups.length > 0){
              $scope.groupList = data.groups;
            }
            if($scope.powerBI.powerbi.visualization){//&& data.visualization.length > 0
              // $scope.visualizationList = $scope.powerBI.powerbi.visualization;
              // if($scope.powerBI.powerbi.type == "reports"){
                $scope.getVisualizationFx();
              // }
              // $scope.getTabList($scope.powerBI.powerbi.visualization.id);
            } else{
              $scope.powerBI.powerbi.visualization = [];
            }

            if(data.powerbi.filList.length){
              $scope.filterList = data.powerbi.filList;
            }
            if(!data.powerbi.tab){
              $scope.powerBI.powerbi.tab = {displayname:$filter("translate")("cl.widget.pBI.31"), id:"01first", name:"01first"};
            }
            if(data.powerbi.rotDur){
              $scope.powerBI.powerbi.rotDur = data.powerbi.rotDur;
            }
          }
          if($scope.powerBI.powerbi.group){
            $scope.groupShow = true;
          }
          if($scope.powerBI.powerbi.visualization){
            $scope.visualizShow = true;
          }
          $scope.detailLoading = false;
         },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.powerBI = {info:{label:"", wType:"ac", frameData:"", pbi:$scope.auth.upermissions.pbi, imggentime:{f:"d", d:""}, toast:false}, settings:angular.copy($scope.settings), powerbi:{type:"dashboards", credential:{tenantId:"", clientId:"", secret:"", auth:"u"}, group:null, visualization:null, tab:"ReportSection", rotDur: 30, powerBIApp:$scope.widgetList.powerBIApp}, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $rootScope.selectedTabFx = function(){
      // todo clear search field
      $scope.searchText = {p:"", f:""};
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){
        $scope.hasErr = false;
        $scope.errType = "";
      } else if($scope.selectedT == "2"){
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.powerBI.powerbi.credential.auth == "sp"){
          if(!$scope.powerBI.powerbi.group || ($scope.powerBI.powerbi.group && !$scope.powerBI.powerbi.group.id)){
            $scope.isWorkspace = false;
          }
          PowerBISrv.getGroups($scope.powerBI.info.id).then(
            function(data){
              // need to add authorization failed
              $scope.spWarnMsg = false;
              if(data.code == 8145){
                $scope.hasErr = true;
                $scope.groupShow = false;
                $scope.spWarnMsg = true;
                $scope.authSuccess = false;
                $scope.errType = "authFailed";
              } else{
                if(data.groups){
                  $scope.groupList = data.groups;
                } else{
                  $scope.groupList = [];
                }
                $scope.groupShow = true;
                $scope.groupLoading = true;
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.selectedT == "3"){
        $scope.powerbi = window['powerbi-client'];
        $scope.report;
        $scope.loadReport()
      }
    }
    $rootScope.selectedTabFx();

    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.openUrlFx = function(w, h, caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "ou"){
        var newWindow = window.open("http://app.powerbi.com/Signout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      if(caller != "at"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(function(){
        if(caller != "at"){
          if(caller == "ou"){
            newWindow.close();
          }
          ngDialog.close($scope.confirmDialog);
        }
        $scope.popProcessing = false;
        $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
        $scope.childWindowInt = $interval($scope.checkChild, 500);
      }, 2000);
      return false;
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'re\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'ou\'">{{"cl.widget.msg.10.2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
            <button type="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        PowerBISrv.getGroups($scope.powerBI.info.id).then(
          function(data){
            $scope.authProcessing = false;
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8145){
              $scope.hasErr = true;
              $scope.groupShow = false;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
            } else{
              $scope.powerBI.powerbi.visualization = "";
              $scope.powerBI.powerbi.group = "";
              $scope.visualizShow = false;
              if(data.groups){
                $scope.groupList = data.groups;
              } else{
                $scope.groupList = [];
              }
              $scope.groupShow = true;
              if(data.isClosed){
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.getVisualizationFx = function(caller){
      $scope.visualizShow = false;
      $scope.isWorkspace = true;
      $scope.pages = [];
      if(caller){
        $scope.powerBI.powerbi.tab = {displayname:$filter("translate")("cl.widget.pBI.31"), id:"01first", name:"01first"};
        // $scope.powerBI.powerbi.tab = {};
        // TODO reset rotation
        $scope.resetRotationFx();
      }
      $scope.isLoading = true;
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.powerBI.powerbi.group || ($scope.powerBI.powerbi.group && !$scope.powerBI.powerbi.group.id)){
        $scope.isLoading = false;
        $scope.isWorkspace = false;
      } else{
        $scope.visualizLoading = true;
        PowerBISrv.getVisualization($scope.powerBI.powerbi.group.id, $scope.powerBI.powerbi.type, $scope.powerBI.info.id).then(
          function(data){
            $scope.visualizationList = data.visualization;
            $scope.visualizLoading = false;
            $scope.visualizShow = true;
            $scope.isLoading = false;
            // if(!caller && $scope.powerBI.powerbi.type == "reports" && $scope.selType == "single"){
            if($scope.powerBI.powerbi.type == "reports" && $scope.selType == "single"){
              $scope.getTabList($scope.powerBI.powerbi.visualization.id);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    //get tab list on select report
    $scope.getTabList = function(rId){
      $scope.pages = [];
      $scope.isPLoading = true;
      PowerBISrv.getReportTabs($scope.powerBI.powerbi.group.id, rId, $scope.powerBI.info.id).then(
        function(data){
          $scope.pages = data.pages;
          $scope.pageCount = $scope.pages.length;
          
          // todo Add custome object in the page array start
          var customePage = [
            {displayname:$filter("translate")("cl.widget.pBI.31"), id:"01first", name:"01first"},
            {displayname:$filter("translate")("cl.widget.pBI.32"), id:"02last", name:"02last"}
          ];
          if($scope.pages.length > 1){
            $scope.pages.unshift(customePage[0]);
            $scope.pages.push(customePage[1]);
          }
          if($scope.pages.length == 1 || !$scope.pages.length){
            $scope.powerBI.powerbi.tab = customePage[0];
          }
          // todo Add custome object in the page array end
          $scope.isPLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.isPLoading = false;
        }
      );
    }

    $scope.selTypeFx = function(type){
      if(type == 's'){
        $scope.selType = "single";
      } else{
        $scope.selType = "custom";
        $scope.powerBI.info.pbi = false;
      }
    }

    $scope.powerBIFx = function(tab, caller){
      $scope.powerBI.info.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || tab == 2 || caller == "save"){
        // if($scope.filterList.length){
        //   var haveFilterProp = $scope.filterList.every(function (fill) {
        //     return fill.prop && Object.keys(fill.prop).length > 0;
        //   });
        // }
        if($scope.powerBI.info.label == ""){//$scope.powerBI.labelOpt == "c" &&
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(($scope.widgetList.powerBIApp == "ca" && $scope.auth.upermissions.pba == 'ca' && !$scope.auth.upermissions.pbcred) && ($scope.powerBI.powerbi.credential.tenantId == "" || $scope.powerBI.powerbi.credential.clientId == "" || $scope.powerBI.powerbi.credential.secret == "")){
          $scope.errType = "allEmpty";
          $scope.hasErr = true;
          $("#wData").focus();
        } else if((($scope.powerBI.info.wType=='ac' && !$scope.powerBI.info.pbi) || $scope.powerBI.info.wType=='epu') && $scope.powerBI.settings.reloadOpt == "c" && ($scope.powerBI.settings.reload == "" || $scope.powerBI.settings.reload == null)){
          $scope.errType = "reload";
          $scope.hasErr = true;
          $("#cReload").focus();
        } else if($scope.powerBI.powerbi.tab && $scope.powerBI.powerbi.tab.id == '02last' && ($scope.selectedT == 2 || caller == "save") && ($scope.powerBI.powerbi.rotDur == "" || $scope.powerBI.powerbi.rotDur == null)){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#cRotation").focus();
          // } else if($scope.filterList.length && !haveFilterProp && caller == "save"){
            //   $scope.errType = "haveNoFil";
            //   $scope.hasErr = true;
        } else if($scope.powerBI.info.wType=='ac' && $scope.powerBI.info.pbi && $scope.powerBI.info.imggentime.f == 'di' && !$scope.imgGenTimeObj.di){
          $scope.errType = "di";
          $scope.hasErr = true;
          $("#ctM").focus();
        } else if(tab == 2 && $scope.selType == "single" && $scope.powerBI.powerbi.tab == ""){
          $scope.errType = "pages";
          $scope.hasErr = true;
        } else if(tab == 1 || tab == 2){
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.savePowerBIFx(caller, tab);
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $scope.savePowerBIFx(caller, tab);
            $scope.isPEOpen = false;
          }
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.savePowerBIFx(caller, tab);
            }, 250);
          } else{
            $scope.savePowerBIFx(caller, tab);
          }
        }
      }
    }

    $scope.savePowerBIFx = function(caller, tab){
      // if($scope.filterList.length){
        $scope.powerBI.powerbi.filList = $scope.filterList;
      // }
      if(caller == "save"){
        $scope.powerBI.info.toast = true;
      } else{
        $scope.powerBI.info.toast = false;
      }
      $scope.isVisualization = false;
      if($scope.powerBI.powerbi.visualization){
        angular.forEach($scope.visualizationList, function(item){
          if(item.id == $scope.powerBI.powerbi.visualization.id){
            $scope.isVisualization = true;
          }
        });
      }
      if(caller == "save" && !$scope.groupShow){
        $scope.errType = "authEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.selectedT == 2 && $scope.groupList.length == 0){
        $scope.errType = "groupListEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if((caller == "save" || tab == '2') && $scope.groupList.length > 0 && !$scope.powerBI.powerbi.group){
        $scope.errType = "groupEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if((caller == 'save' || tab == '2') && $scope.selType =='single' && !$scope.isVisualization && $scope.powerBI.powerbi.type=='reports'){
        $scope.errType = "selREmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if(caller == 'save' && $scope.selType =='single' && !$scope.isVisualization && $scope.powerBI.powerbi.type=='dashboards'){
        $scope.errType = "selDEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if(caller == 'save' && $scope.selType =='custom' && $scope.customData.item==''){
        $scope.errType = "custEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      }
      // else if(caller == 'save' && $scope.selType =='single' && $scope.powerBI.powerbi.type=='reports' && $scope.powerBI.powerbi.tab==''){
      //   $scope.errType = "page";
      //   $scope.hasErr = true;
      //   $scope.saveProcessing = false;
      // }
      else{
        if($scope.selType=="custom" && $scope.powerBI.powerbi.type=="dashboards"){
          $scope.powerBI.powerbi.customData = {dashboard:$scope.customData.item};
          $scope.powerBI.powerbi.visualization = $scope.visualizationList;
        } else if($scope.selType=="custom" && $scope.powerBI.powerbi.type=="reports"){
          $scope.powerBI.powerbi.customData = {report:$scope.customData.item, tab:$scope.customData.tab};
          $scope.powerBI.powerbi.visualization = $scope.visualizationList;
        }
        $scope.powerBI.powerbi.selType = $scope.selType;
        if(!$scope.powerBI.powerbi.powerBIApp){
          $scope.powerBI.powerbi.powerBIApp = $scope.widgetList.powerBIApp;
        }

        if($scope.powerBI.powerbi.type == "dashboards"){
          $scope.powerBI.powerbi.tab = "";
          $scope.powerBI.powerbi.filList = [];
        }

        if($scope.powerBI.powerbi.type == "reports" && $scope.powerBI.powerbi.tab.id == "02last"){
          $scope.powerBI.powerbi.totDur = ($scope.pageCount * $scope.powerBI.powerbi.rotDur);          
        } else{
          $scope.powerBI.powerbi.totDur = 0;
        }

        /* Encrypt */
        var tempPowerBI = angular.copy($scope.powerBI);
        if($scope.widgetList.powerBIApp == "ca"){
          tempPowerBI.powerbi.credential.tenantId = $scope.encryptFx($scope.powerBI.powerbi.credential.tenantId);
          tempPowerBI.powerbi.credential.clientId = $scope.encryptFx($scope.powerBI.powerbi.credential.clientId);
          tempPowerBI.powerbi.credential.secret = $scope.encryptFx($scope.powerBI.powerbi.credential.secret);
        }

        if(tempPowerBI.info.imggentime.f == "w"){
          tempPowerBI.info.imggentime.d = $scope.imgGenTimeObj.w;
        } else if(tempPowerBI.info.imggentime.f == "di"){
          tempPowerBI.info.imggentime.d = $scope.imgGenTimeObj.di;
        } else{
          tempPowerBI.info.imggentime.d = 1;
        }
 
        PowerBISrv.savePowerBI(tempPowerBI).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.powerBI.info.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            // if(data.code == 8089){
            //   $scope.errType = "";
            //   $scope.hasErr = true;
            // } else
            if(data.code == 8146){
              $scope.errType = "visualizListEmpty";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              if(tab == '2'){
                $scope.tabFx(3, 'tabFx');
              } else{
                $scope.tabFx(2, 'tabFx');
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.powerBIUrlFx = function(caller){
      $scope.powerBI.info.fid = $scope.fid;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.powerBI.info.label == ""){//$scope.powerBI.labelOpt == "c" &&
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.powerBI.info.frameData == ""){
        $scope.errType = "data";
        $scope.hasErr = true;
        $("#wData").focus();
      } else if($scope.powerBI.settings.reloadOpt == "c" && ($scope.powerBI.settings.reload == "" || $scope.powerBI.settings.reload == null)){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else{
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.savePowerBIUrlFx(caller);
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $scope.savePowerBIUrlFx(caller);
          $scope.isPEOpen = false;
        }
      }
    }
    $scope.savePowerBIUrlFx = function(caller){
      $scope.powerBI.info.toast = true;
      $scope.saveProcessing = true;
      PowerBISrv.savePowerBI($scope.powerBI).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.powerBI.info.id = data.id;
          $scope.rUrl = data.rUrl;
          //need to add new code here
          // if(data.code == 8089){
          //   $scope.errType = "";
          //   $scope.hasErr = true;
          // } else
          if(data.code == 8146){
            $scope.errType = "visualizListEmpty";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.resetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.selectPageFx = function(obj){
      $scope.powerBI.powerbi.tab = obj;
    }

    $scope.resetRotationFx = function(){
      $scope.powerBI.powerbi.rotDur = 30;
    }

    $scope.embedReport = function(containerId, embedConfig){
      // Get the Power BI service
      var powerbi = window.powerbi;

      // Get the container for embedding the report
      var container = document.getElementById(containerId);

      // Embed the report
      return powerbi.embed(container, embedConfig);
    }
    
    // Function to Load Power BI Report by Report ID
    $scope.loadFilter = {f:true, p:true};

    $scope.loadReport = function(caller){
      $scope.loadFilter.f = true;
      $scope.loadFilter.p = true;
      // if(caller && caller == "load"){
        // $scope.filterList = [];
      // }
      if(!caller){
        if($scope.filterList.length && !caller){
          $scope.loadFilter.f = false;
        }
        SettingsSrv.getDP($scope.auth.server).then(
          function(data){
            $scope.dProperties = data.properties;
            $scope.loadFilter.p = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      if(!$scope.filterList.length || (caller && caller == 'load')){
        if(caller){
          $scope.loadFilter.p = false;
        }
        PowerBISrv.getPowerBIToken($scope.powerBI.info.id).then(
          function(data){
            if(data.et == ""){
              $scope.loadFilter.f = false;
              $scope.filterList = [];
            } else{
              $scope.powerbi = document.getElementById("powerbi-container");
              // Embed the report using the PowerBIService
              $scope.report = $scope.embedReport("powerbi-container", {
                  type: "report",
                  id: $scope.powerBI.powerbi.visualization.id,
                  embedUrl: 'https://app.powerbi.com/reportEmbed?reportId='+ $scope.powerBI.powerbi.visualization.id +'&groupId='+ $scope.powerBI.powerbi.group.id,
                  accessToken: data.et,
                  tokenType: !data.act?window['powerbi-client'].models.TokenType.Embed:null,
                  // tokenType: window['powerbi-client'].models.TokenType.Embed,
                  permissions: window['powerbi-client'].models.Permissions.All,
                  settings: {
                    filterPaneEnabled: false
                  },
              });
              // Add event listeners (optional)
              $scope.report.on("loaded", function(){
                $scope.getFilters();
              });
            }
           },
          function(err){
            $log.error(err);
          }
        );
      }
    };

    $scope.filterList = [];
    $scope.filters = [];
    // Function to Get Filters Applied on the Report
    $scope.getFilters = function(){
      if(!$scope.report){
        console.error("No report is currently loaded.");
        return;
      }

      $scope.report.getFilters()
        .then(function (filters) {
          $scope.loadFilter.f = false;
          $scope.filters = filters; // Save the filters to display in the UI
          if($scope.filterList.length){
            if($scope.filters.length){
              angular.forEach($scope.filterList, function(obj){
                var exists = $scope.filters.some(function (fill) {
                  return fill.target.column == obj.target.column && fill.target.table == obj.target.table;
                });
                if (!exists) {
                  $scope.filterList.splice(obj, 1);
                }
              })
            } else{
              $scope.filterList = [];
            }
          }
          $scope.$apply(); // Update the view
        })
        .catch(function(error){
          console.error("Error retrieving filters:", error);
        });
    };

    $scope.singleFilFx = function(dp, fil){
      angular.forEach($scope.filterList, function(obj){
        if(obj.target.column == fil.target.column && obj.target.table == fil.target.table){
          // if($rootScope.isObjectEmpty(obj.pro)){
            obj.prop = dp;
          // } else{
          //   if(obj.prop.id != dp.id){
          //     obj.prop = dp;
          //   }
          // }
        }
      })
    }

    $scope.clearFilersFx = function(){
      $scope.filterList = [];
      $scope.powerBI.powerbi.filList = [];
    }

    // Watch both variables
    $scope.$watchGroup(['loadFilter.p' , 'loadFilter.f'], function(newValues, oldValues){
      var status1 = newValues[0]; // First variable
      var status2 = newValues[1]; // Second variable
      if($scope.selectedT == "3" && status1 == false && status2 == false){
        if($scope.filters.length){
          if($scope.filterList.length){
            $scope.filterListCopy = angular.copy($scope.filterList);
            angular.forEach($scope.filters, function(obj){
              var exists = $scope.filterListCopy.some(function(fill){
                return fill.target.column == obj.target.column && fill.target.table == obj.target.table;
              });
              if(!exists){
                $scope.filterList.push({target: obj.target, prop:{}});
              }
            })
          } else{
            angular.forEach($scope.filters, function(obj){
              $scope.filterList.push({target: obj.target, prop:{}});
            })
          }
        }
      }
    });

    $scope.clearFilersFx = function(caller){
      $scope.filterList = [];
      $scope.powerBI.powerbi.filList = [];
      if(caller == "r"){
        $scope.powerBI.powerbi.tab.displayname = "";
        // $scope.powerBI.powerbi.tab = "";
      }
    }

    // // Get all pages (tabs)
    // $scope.getPages = function () {
    //   if (!$scope.report) {
    //     console.error("No report is currently loaded.");
    //     return;
    //   }
    //   $scope.report.getPages()
    //     .then(function (pages) {
    //       $scope.$apply(function () {
    //         $scope.reportTabs = pages;
    //         console.log("$scope.reportTabs",$scope.reportTabs);
    //         $scope.selectedTabPage = pages[3]; // Select the first tab by default
    //       });
    //     })
    //     .catch(function (error) {
    //       console.error("Error fetching pages:", error);
    //     });
    // };

    // // Set default tab
    // $scope.setDefaultTab = function () {
    //   if ($scope.selectedTabPage) {
    //     $scope.selectedTabPage.setActive()
    //       .then(function () {
    //         console.log("Default tab set to:", $scope.selectedTabPage.displayName);
    //       })
    //       .catch(function (error) {
    //         console.error("Error setting default tab:", error);
    //       });
    //   } else {
    //     console.warn("No tab selected to set as default.");
    //   }
    // };
      
    // $scope.setFilters = function(){
    //   if (!$scope.report) {
    //     console.error("No report is currently loaded.");
    //     return;
    //   }

    //   var filter = {
    //     $schema: "http://powerbi.com/product/schema#basic",
    //     target: {
    //         table: "INFO_Districts",
    //         column: "REGION_NO"
    //     },
    //     operator: "In",
    //     values: [1],
    //     filterType: 1
    //   };

    //   $scope.report.setFilters([filter])
    //     .then(function () {
    //       console.log("Filters applied successfully");
    //     })
    //     .catch(function (error) {
    //       console.error("Error retrieving filters:", error);
    //     });
    // }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PatientWaitController', PatientWaitController);

  /** @ngInject */
  function PatientWaitController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, ngDialog, FileModelUploadSrv, PatientWaitSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, t:false, rb:false, arb:false, nb:false, nt:false, ic:false, aic:false, fb:false, ft:false, at:false, uat:false, wt:false, as:false, uas:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.isChecked = {disabled:true};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.deletableItem = [];
    $scope.addRowBtn = false;
    $scope.isPEOpen = false;
    $scope.hTextA = "";
    $scope.otherQ = {};
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsA = {header:{hText:"Average Wait Time", bg:"#990000", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:26}, bg:"#cc0000", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:72, reload:30, environment:"p"};
    $scope.ctypeA = {headerBg:"default", headerText:"monochrome", bg:"default", text:"monochrome"};

    $scope.settingsQ = {
      header:{bg:"#0b5394", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:24, hText:"Current Wait Queue"},
      rowBg:"#f3f3f3", rowBga:1, altBg:"#ffffff", altBga:1, rowFont:$scope.fontFamilySelected, rowSize:24, numberBg:"#3d85c6", numberBga:1, numberText:"#cfe2f3", numberFont:$scope.fontFamilySelected, numberSize:32, iconColor:"#3d85c6", altIconColor:"#3d85c6",
      footer:{bg:"#0b5394", bga:1, text:"#ffffff", font:$scope.fontFamilySelected, size:24, fText:"Scheduled appointments take precedence, please schedule your appointment to reduce your wait."},
      bg:"#ffffff", bga:1, reload:30, arrived:"#444444", unarrived:"#cccccc", walkIn:"#3d85c6", aCheckIn:"#3d85c6", uCheckIn:"#cccccc", template:"t1", iconA:"a1", iconW:"w1", iconC:"c1", textFormat:"d", environment:"p", ep:"GetPatientQueueForPSCTV", onWS:"1"
    };
    $scope.ctypeQ = {headerBg:"default", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", numberBg:"default", numberText:"default", iconColor:"default", altIconColor:"default", footerBg:"default", footerText:"monochrome", arrived:"monochrome", unarrived:"monochrome", walkIn:"default", aCheckIn:"default", uCheckIn:"monochrome"};

    $scope.defaultSettingA = angular.copy({setting:$scope.settingsA, ctype:$scope.ctypeA});
    $scope.defaultSettingQ = angular.copy({setting:$scope.settingsQ, ctype:$scope.ctypeQ});

    $scope.settingsDefault = function(){
      if($scope.patientWait.dType == "a"){
        $scope.hTextA = angular.copy($scope.settingsA.header.hText);

        $scope.settingsA = angular.copy($scope.defaultSettingA.setting);
        $scope.ctypeA = angular.copy($scope.defaultSettingA.ctype);

        $scope.settingsA.header.hText = angular.copy($scope.hTextA);
      } else{
        $scope.otherQ = angular.copy({header:$scope.settingsQ.header.hText, footer:$scope.settingsQ.footer.fText, template:$scope.settingsQ.template, iconA:$scope.settingsQ.iconA, iconW:$scope.settingsQ.iconW});

        $scope.settingsQ = angular.copy($scope.defaultSettingQ.setting);
        $scope.ctypeQ = angular.copy($scope.defaultSettingQ.ctype);

        $scope.settingsQ.header.hText = angular.copy($scope.otherQ.header);
        $scope.settingsQ.footer.fText = angular.copy($scope.otherQ.footer);
        $scope.settingsQ.template = angular.copy($scope.otherQ.template);
        $scope.settingsQ.iconA = angular.copy($scope.otherQ.iconA);
        $scope.settingsQ.iconW = angular.copy($scope.otherQ.iconW);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      PatientWaitSrv.getPatientWait($scope.decId).then(
        function(data){
          $scope.patientWait = data;
          $scope.patientWait.fType = "excel";

          if($scope.patientWait.table.row.length){
            $scope.isChecked.disabled = false;
          }
          $scope.curCount = angular.copy($scope.patientWait.columns);
          $scope.curFType = angular.copy($scope.patientWait.fType);
          if($scope.patientWait.dType == "a"){
            $scope.settingsA = angular.copy($scope.patientWait.settings);
            $scope.ctypeA = angular.copy($scope.patientWait.ctype);
          } else{
            $scope.settingsQ = angular.copy($scope.patientWait.settings);
            $scope.ctypeQ = angular.copy($scope.patientWait.ctype);
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.patientWait = {label:"", dType:"a", fType:"excel", delimiter:"comma", columns:2, activePeriod:{type:"a"}, table:{row:[]}, permission:{type:$scope.auth.upreferences.defaultP}};
      $scope.curFType = angular.copy($scope.patientWait.fType);
    }

    $scope.changeType = function(caller){
      $scope.changeObj = {caller:caller};
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "fType"){
        if($scope.patientWait.table.row.length){
          $scope.changeTypeOpen("fType");
        } else{
          $scope.isChecked.disabled = true;
          $scope.curFType = angular.copy($scope.patientWait.fType);
        }
        if($scope.patientWait.fType == 'csv' && $scope.patientWait.delimiter == null){
          $scope.patientWait.delimiter = "comma";
        }
      }
    }

    $scope.changeTypeOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.queue.m9" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="changeTypeFx();" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        data:$scope.changeObj,
        closeByEscape:false,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(caller){
          if(caller == "$escape" || caller == "close"){
            if($scope.changeObj.caller == "fType"){
              $scope.patientWait.fType = $scope.curFType;
            }
          }
        }
      });
    }

    $scope.changeTypeFx = function(){
      if($scope.changeObj.caller == "fType"){
        $scope.curFType = $scope.patientWait.fType;
      }
      $scope.patientWait.table.row = [];
      $scope.isChecked.selectAll = false;
      $scope.isChecked.disabled = true;
      ngDialog.close();
    }

    $scope.searchQu = {text:""};
    $scope.generateProcessing = false;

    $scope.generatingFx = function(){
      ngDialog.close();
      $scope.searchQu.text = "";
      $scope.generateProcessing = true;
      $scope.curCount = angular.copy($scope.patientWait.columns);
      $scope.patientWait.table = {row:[{id:1, isChecked:false, columns:[]}]};
      for(var i=0; i<$scope.curCount; i++){
        $scope.patientWait.table.row[0].columns.push({label:""});
      }
      $scope.generateProcessing = false;
    }

    $scope.addRowFx = function(){
      $scope.isChecked.disabled = false;
      $scope.addRowBtn = true;
      $scope.curCount = angular.copy($scope.patientWait.columns);
      $scope.searchQu.text = "";
      if($scope.isChecked.selectAll){
        $scope.isChecked.selectAll = false;
      }
      $scope.patientWait.table.row.push({id:$scope.patientWait.table.row.length+1, isChecked:false, columns:[]});
      for(var i=0; i<$scope.curCount; i++){
        $scope.patientWait.table.row[$scope.patientWait.table.row.length-1].columns.push({label:""});
      }
      angular.forEach($scope.patientWait.table.row, function(item, index){
        item.id = index+1;
      });
      $scope.addRowBtn = false;
    }

    $scope.isCheckedFx = function(caller, event){
      $scope.curChecked = true;
      $scope.deletableItem = [];
      angular.forEach($scope.patientWait.table.row, function(row){
        if(caller == "all"){
          row.isChecked = event.target.checked;
          if(event.target.checked){
            $scope.deletableItem.push(row.id);
          }
        } else{
          if(row.isChecked){
            $scope.deletableItem.push(row.id);
          }
        }
        if(!row.isChecked){
          $scope.curChecked = false;
          return false;
        }
      });
      if($scope.curChecked){
        $scope.isChecked.selectAll = true;
      } else{
        $scope.isChecked.selectAll = false;
      }
    }

    $scope.searchChangeFx = function(){
      setTimeout(function(){
        if($(".table tbody tr").length == 0){
          $scope.$apply(function(){
            $scope.isChecked.selectAll = false;
            $scope.isChecked.disabled = true;
            $scope.deletableItem = [];
          });
          angular.forEach($scope.patientWait.table.row, function(row){
            row.isChecked = false;
          });
        } else{
          $scope.$apply(function(){
            $scope.isChecked.disabled = false;
          });
        }
      }, 10);
    }

    $scope.deleteOpen = function(){
      $scope.deleteItemLength = $filter("filter")($scope.patientWait.table.row, {isChecked:true}).length;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{deleteItemLength > 1?"cm.msg.34s":"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.tempArr = [];
      $scope.curDelete = [];
      $(".table tbody tr").each(function(){
        $scope.deletableItem = $filter("orderBy")($scope.deletableItem);
        for(var i=0; i<$scope.deletableItem.length; i++){
          if($(this).attr("data-id") == $scope.deletableItem[i]){
            $scope.tempArr.push($scope.deletableItem[i]);
            break;
          }
        }
      });
      $scope.tempArr = $filter("orderBy")($scope.tempArr);
      for(var i=0; i<$scope.patientWait.table.row.length; i++){
        for(var j=0; j<$scope.tempArr.length; j++){
          if($scope.patientWait.table.row[i].id == $scope.tempArr[j]){
            $scope.patientWait.table.row.splice(i, 1);
          }
        }
      }
      if($scope.patientWait.table.row.length == 0){
        $scope.isChecked.selectAll = false;
        $scope.isChecked.disabled = true;
        $scope.deletableItem = [];
      }
      $scope.searchQu.text = "";
      ngDialog.close();
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.patientWait.table.row, function(item, index){
        angular.forEach($filter('filter')($scope.patientWait.table.row, {id:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.patientWait.table.row = [];
      $scope.patientWait.table.row = $scope.curRow;
    }

    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
      if($scope.patientWait.table.row.length > 0){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.queue.m11" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileSelectFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.fileSelectFx();
      }
    }

    $scope.fileSelectFx = function(){
      $scope.fileModelLoading = true;
      $scope.errType = "";
      $scope.hasErr = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson", {delimiter:$scope.patientWait.delimiter, header:false}, $scope.curData).then(
        function(data){
          $scope.fileModelLoading = false;
          $scope.patientWait.table = [];
          $scope.convertData = data;
          ngDialog.close();
          if($scope.convertData.code == 8126){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.widget.queue.m12" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="convertFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else if(data && (data.row && data.row.length > 0)){
            $scope.isChecked.disabled = false;
            $scope.patientWait.table = $scope.convertData;
            $scope.curCount = $scope.patientWait.table.row[0].columns.length;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }
    $scope.convertFx = function(){
      $scope.patientWait.table = $scope.convertData;
      $scope.curCount = $scope.patientWait.table.row[0].columns.length;
      if($scope.patientWait.table.row.length > 0){
        $scope.isChecked.disabled = false;
      }
      ngDialog.close();
    }

    $scope.patientWaitFx = function(tab, caller){
      $scope.patientWait.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1){
        $timeout(function(){
          $scope.tabFx(2, 'tabFx');
        }, 50);
      }
      if(tab == 2 && $scope.patientWait.dType == "q"){
        $timeout(function(){
          $scope.tabFx(3, 'tabFx');
        }, 50);
      }
      if(caller == "save"){
        if($scope.patientWait.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.patientWait.dType == "a" && !$scope.settingsA.header.size){
          $scope.errType = "headerSize";
          $scope.hasErr = true;
          $("#headerSize").focus();
        } else if($scope.patientWait.dType == "a" && !$scope.settingsA.size){
          $scope.errType = "size";
          $scope.hasErr = true;
          $("#size").focus();
        } else if($scope.patientWait.dType == "a" && !$scope.settingsA.reload){
          $scope.errType = "reload";
          $scope.hasErr = true;
          $("#reload").focus();
        } else if($scope.patientWait.dType == "q" && !$scope.settingsQ.header.size){
          $scope.errType = "headerSize";
          $scope.hasErr = true;
          $("#headerSize").focus();
        } else if($scope.patientWait.dType == "q" && !$scope.settingsQ.rowSize){
          $scope.errType = "rowSize";
          $scope.hasErr = true;
          $("#rowSize").focus();
        } else if($scope.patientWait.dType == "q" && !$scope.settingsQ.numberSize){
          $scope.errType = "numberSize";
          $scope.hasErr = true;
          $("#numberSize").focus();
        } else if($scope.patientWait.dType == "q" && !$scope.settingsQ.footer.size){
          $scope.errType = "footerSize";
          $scope.hasErr = true;
          $("#footerSize").focus();
        } else if(!$scope.settingsQ.reload){
          $scope.errType = "reload";
          $scope.hasErr = true;
          $("#reload").focus();
        } else if($scope.patientWait.table.row.length == 0){
          $scope.errType = "file";
          $scope.hasErr = true;
          $("#file").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.savePatientWaitFx();
            }, 250);
          } else{
            $scope.savePatientWaitFx();
          }
        }
      }
    }

    $scope.savePatientWaitFx = function(){
      $scope.saveProcessing = true;
      if($scope.patientWait.dType == "a"){
        $scope.patientWait.settings = $scope.settingsA;
        $scope.patientWait.ctype = $scope.ctypeA;
      } else{
        $scope.patientWait.settings = $scope.settingsQ;
        $scope.patientWait.ctype = $scope.ctypeQ;
      }

      PatientWaitSrv.savePatientWait($scope.patientWait).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 8153){
            $scope.errType = "fileValid";
            $scope.hasErr = true;
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $rootScope.selectedTabFx = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('OutlookCalendarController', OutlookCalendarController);

  /** @ngInject */
  function OutlookCalendarController($log, $rootScope, $scope, $state, $sce, $cookies, $timeout, $window, $interval, $filter, ngDialog, OutlookCalendarSrv, ContentLibrarySrv, DevicesSrv){
    $scope.colorPicker = {b:false, tt:false, st:false, tm:false, hb:false, ht:false, rt:false, att:false, atm:false, art:false, rb:false, arb:false, thb:false, tht:false, tfb:false, tft:false, tlb:false, tlt:false, trt:false, tat:false, trb:false, tab:false, teb:false, tet:false, trbo:false};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.curDeviceObj = {availableDevices:[], devices:[]};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.childWindowInt = null;
    $scope.authSuccess = false;
    $scope.isPEOpen = false;
    $scope.editMode = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.dgList = {d:[]};
    $scope.search = {text:""};

    $scope.settingsRB = {/*Rooomboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:0, logoOpt:false,
      titleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:72,
      subtitleText:"#999999", subtitleFont:$scope.fontFamilySelected, subtitleSize:36,
      timeText:"#444444", timeFont:$scope.fontFamily[0], timeSize:48,
      sos:{sType:"p", prior:30, eType:"a", after:30},
      feed:{url:"", logo:"", ss:""}
    };
    $scope.ctypeRB = {bg:"monochrome", ssbg:"monochrome", titleText:"monochrome", subtitleText:"monochrome", timeText:"monochrome"};
    $scope.settingsWBT1 = {/*Wallboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:0, isTime:true, isRoom:true, logoOpt:false,
      header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room", col3TxtAlign:"center"},
      headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26,
      titleText:"#000000", timeText:"#444444", titleSize:28, titleTxtAlign:"left",
      altTitleText:"#000000", altTimeText:"#444444",
      roomText:"#666666", altRoomText:"#000000", timeSize:28, timeTxtAlign:"center",
      futureDateEv:1,
      titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected, roomSize:28, roomTxtAlign:"center",
      rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, rotationOpt:"a", rotate:12,
      sos:{sType:"s", prior:30, eType:"a", after:30},
      feed:{url:"", logo:"", ss:""}
    }
    $scope.ctypeWBT1 = {bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", timeText:"monochrome", roomText:"monochrome", altTitleText:"monochrome", altTimeText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"};
    $scope.settingsWBT2 = {/*Wallboard Default Font Roboto regular*/
      headerBg:"#444444", headerBga:1, headerText:"#ffffff", headerFont:$scope.fontFamily[84], headerSize:26,
      footerBg:"#444444", footerBga:1, footerText:"#ffffff", footerFont:$scope.fontFamilySelected, footerSize:28,
      leftBg:"#6fa8dc", leftBga:1, leftText:"#000000", leftFont:$scope.fontFamily[84], leftSize:28,
      rowBg:"#ffffff", rowBga:1, altBg:"#ffffff", altBga:1, rowSize:28,
      rowText:"#000000", altRowText:"#000000",
      futureDateEv:1,
      rowFont:$scope.fontFamily[84], eventBg:"#6fa8dc", eventBga:1, eventText:"#000000",
      isRowBdr:true, rowBdr:"#cccccc", logoOpt:false, rotationOpt:"a", rotate:12,
      sos:{sType:"s", prior:30, eType:"a", after:30}
    }
    $scope.ctypeWBT2 = {headerBg:"monochrome", headerText:"monochrome", footerBg:"monochrome", footerText:"monochrome", leftBg:"default", leftText:"monochrome", rowText:"monochrome", altRowText:"monochrome", rowBg:"monochrome", altBg:"monochrome", eventBg:"default", eventText:"monochrome", rowBdr:"monochrome"};

    $scope.defaultSettingRB = angular.copy({setting:$scope.settingsRB, ctype:$scope.ctypeRB});
    $scope.defaultSettingWBT1 = angular.copy({setting:$scope.settingsWBT1, ctype:$scope.ctypeWBT1});
    $scope.defaultSettingWBT2 = angular.copy({setting:$scope.settingsWBT2, ctype:$scope.ctypeWBT2});

    $scope.settingsDefault = function(){
      if($scope.outlook.dType == "r"){
        $scope.settingsRB = angular.copy($scope.defaultSettingRB.setting);
        $scope.ctypeRB = angular.copy($scope.defaultSettingRB.ctype);
      } else{
        if($scope.outlook.template == "t1"){
          $scope.settingsWBT1 = angular.copy($scope.defaultSettingWBT1.setting);
          $scope.ctypeWBT1 = angular.copy($scope.defaultSettingWBT1.ctype);
        } else{
          $scope.settingsWBT2 = angular.copy($scope.defaultSettingWBT2.setting);
          $scope.ctypeWBT2 = angular.copy($scope.defaultSettingWBT2.ctype);
        }
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      OutlookCalendarSrv.getOutlookCalendar($scope.decId).then(
        function(data){
          $scope.outlook = data;

          if($scope.outlook.password){
            $scope.outlook.password = $scope.decryptFx($scope.outlook.password);
          }
          if($scope.outlook.retypePassword){
            $scope.outlook.retypePassword = $scope.decryptFx($scope.outlook.retypePassword);
          }
          
          if(!$scope.outlook.settings.sos && $scope.outlook.dType == "r"){
            $scope.outlook.settings.sos = {sType:"p", prior:30, eType:"a", after:30};
          }
          if(!$scope.outlook.settings.sos && $scope.outlook.dType == "wc"){
            $scope.outlook.settings.sos = {sType:"s", prior:30, eType:"e", after:30};
          }
          if($scope.outlook.dType == "r"){
            $scope.settingsRB = angular.copy($scope.outlook.settings);
            $scope.ctypeRB = angular.copy($scope.outlook.ctype);
          }
          if($scope.outlook.dType == "wc"){
            if(!$scope.outlook.settings.futureDateEv){
              $scope.outlook.settings.futureDateEv = 1;
            }
            if(!$scope.outlook.settings.rotationOpt){
              $scope.outlook.settings.rotationOpt = "a";
              $scope.outlook.settings.rotate = 12;
              $scope.outlook.settings.logoOpt = false;
            }
            if($scope.outlook.template == "t1"){
              if(!$scope.outlook.settings.headerSize){
                $scope.outlook.settings.headerSize = 26;
                $scope.outlook.settings.titleSize = 28;
                $scope.outlook.settings.timeSize = 28;
                $scope.outlook.settings.roomSize = 28;
              }
              $scope.settingsWBT1 = angular.copy($scope.outlook.settings);
              $scope.ctypeWBT1 = angular.copy($scope.outlook.ctype);
            } else{
              if($scope.outlook.settings && !$scope.outlook.settings.headerSize){
                $scope.outlook.settings.headerSize = 26;
                $scope.outlook.settings.footerSize = 28;
                $scope.outlook.settings.leftSize = 28;
                $scope.outlook.settings.rowSize = 28;
              }
              $scope.settingsWBT2 = angular.copy($scope.outlook.settings);
              $scope.ctypeWBT2 = angular.copy($scope.outlook.ctype);
            }

            if($scope.outlook.settings.header && !$scope.outlook.settings.header.col1TxtAlign){
              $scope.settingsWBT1.header.col1TxtAlign = "left";
            }
            if($scope.outlook.settings.header && !$scope.outlook.settings.header.col2TxtAlign){
              $scope.settingsWBT1.header.col2TxtAlign = "center";
            }
            if($scope.outlook.settings.header && !$scope.outlook.settings.header.col3TxtAlign){
              $scope.settingsWBT1.header.col3TxtAlign = "center";
            }

            if($scope.outlook.settings && !$scope.outlook.settings.titleTxtAlign){
              $scope.settingsWBT1.titleTxtAlign = "left";
            }
            if($scope.outlook.settings && !$scope.outlook.settings.timeTxtAlign){
              $scope.settingsWBT1.timeTxtAlign = "center";
            }
            if($scope.outlook.settings && !$scope.outlook.settings.roomTxtAlign){
              $scope.settingsWBT1.roomTxtAlign = "center";
            }
          }
          // todo update the code position start
          $scope.tim = $scope.outlook.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.outlook.bucket;
          if($scope.outlook.mbucket && $scope.outlook.mbucket != ""){
            $scope.cDetailBucket = $scope.outlook.mbucket;
          }
          // todo update the code position end

          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.outlook = {label:"", wType:"e", dType:"r", template:"t1", rId:"", wallboardList:[], settings:{}, toast:false, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.versionList = [];
    OutlookCalendarSrv.getVersionList().then(
      function(data){
        $scope.versionList = data.version;
      },
      function(err){
        $log.error(err);
      }
    );

    $rootScope.selectedTabFx = function(){}

    $scope.openUrlFx = function(w, h, caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      if(caller && caller=="otherUserAuth"){
        var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      $scope.timer = setTimeout(
        function(){
          if($scope.timer){
            clearTimeout($scope.timer);
          }
          if(caller=="otherUserAuth"){
            newWindow.close();
          }
          $scope.childWindow = window.open($scope.request_url, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ top +', left='+ left);
          $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, 2000);
      return false;
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        OutlookCalendarSrv.getOutlookVerify($scope.outlook.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8115){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              if(data.isClosed){
                $scope.outlook.isAuthorized = true;
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.editWallFx = function(index){
      $scope.outlook.wallboardList[index].edited = 1;
    }
    $scope.addRowFx = function(){
      $scope.outlook.wallboardList.push({email:"", edited:1});
    }

    $scope.confirmOpen = function(index){
      $scope.dataObj = {index:index};
      if($scope.outlook.wallboardList[index].email){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{\'cm.msg.34\' | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="removeWallFx(dataObj.index);" focus-me="true">\{{\'cm.btn.2\' | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.removeWallFx(index);
      }
    }
    $scope.removeWallFx = function(index){
      $scope.outlook.wallboardList.splice(index, 1);
      ngDialog.close();
    }

    $scope.outlookFx = function(tab, caller){
      // TODO: new code
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.outlook.fid = $scope.fid;
      $scope.wallFieldEmply = false;
      $scope.sameEmail = false;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.outlook.dType == "wc" && $scope.outlook.wallboardList.length > 0){
        angular.forEach($scope.outlook.wallboardList, function(list){
          if(!list.email || list.email == ""){
            $scope.wallFieldEmply = true;
          }
          if(!$scope.wallFieldEmply && list.edited){
            list.edited = 0;
          }
        });
        if(!$scope.wallFieldEmply){
          angular.forEach($scope.outlook.wallboardList, function(list, intex){
            var filtered = $filter("filter")($scope.outlook.wallboardList, {email:$scope.outlook.wallboardList[intex].email}, true);
            if(filtered.length>1){
              $scope.sameEmail = true;
              list.edited = 1;
            }
          });
        }
      }
      if(tab == 1 || tab == 2 || caller == "save"){
        if($scope.outlook.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.outlook.version){
          $scope.errType = "version";
          $scope.hasErr = true;
          $("#version").focus();
        } else if($scope.outlook.version.value != 'Office365' && (!$scope.outlook.host || $scope.outlook.host == "")){
          $scope.errType = "host";
          $scope.hasErr = true;
          $("#host").focus();
        } else if($scope.outlook.version.value != 'Office365' && (!$scope.outlook.userName || $scope.outlook.userName == "")){
          $scope.errType = "uName";
          $scope.hasErr = true;
          $("#userName").focus();
        } else if($scope.outlook.version.value != 'Office365' && (!$scope.outlook.password || $scope.outlook.password == "")){
          $scope.errType = "pass";
          $scope.hasErr = true;
          $("#password").focus();
        } else if($scope.outlook.version.value != 'Office365' && (!$scope.outlook.retypePassword || $scope.outlook.retypePassword == "")){
          $scope.errType = "retypePass";
          $scope.hasErr = true;
          $("#retypePassword").focus();
        } else if($scope.outlook.version.value != 'Office365' && ($scope.outlook.password !== $scope.outlook.retypePassword)){
          $scope.errType = "passNotMach";
          $scope.hasErr = true;
          $("#retypePassword").focus();
        } else if($scope.wallFieldEmply){
          $scope.errType = "wallFieldEmply";
          $scope.hasErr = true;
          $("#wbL input").each(function(){
            if(!$(this).val()){
              $(this).focus();
            }
          });
        } else if($scope.sameEmail){
          $scope.errType = "sameEmail";
          $scope.hasErr = true;
          $("#sameEmail").focus();
        } else if($scope.outlook.dType == "r" && !$scope.settingsRB.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#rbTitleSize").focus();
        } else if($scope.outlook.dType == "r" && !$scope.settingsRB.subtitleSize){
          $scope.errType = "stSize";
          $scope.hasErr = true;
          $("#rbSubtitleSize").focus();
        } else if($scope.outlook.dType == "r" && !$scope.settingsRB.timeSize){
          $scope.errType = "tsSize";
          $scope.hasErr = true;
          $("#rbTimeSize").focus();
        } else if($scope.outlook.dType == "r" && $scope.settingsRB.sos.sType == "p" && !$scope.settingsRB.sos.prior){
          $scope.errType = "rbSosP";
          $scope.hasErr = true;
          $("#rbSosP").focus();
        } else if($scope.outlook.dType == "r" && $scope.settingsRB.sos.eType == "a" && !$scope.settingsRB.sos.after){
          $scope.errType = "rbSosA";
          $scope.hasErr = true;
          $("#rbSosA").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && $scope.settingsWBT1.rotationOpt == "c" && $scope.settingsWBT1.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#wb1Rotation").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && $scope.settingsWBT1.headerSize == null){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wb1HeaderSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && $scope.settingsWBT1.titleSize == null){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#wb1TitleSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && $scope.settingsWBT1.timeSize == null){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#wb1TimeSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && $scope.settingsWBT1.roomSize == null){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#wb1RoomSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && ($scope.settingsWBT1.sos.sType == "p" && !$scope.settingsWBT1.sos.prior)){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wb1SosP").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t1" && ($scope.settingsWBT1.sos.eType == "a" && !$scope.settingsWBT1.sos.after)){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wb1SosA").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && $scope.settingsWBT2.rotationOpt == "c" && $scope.settingsWBT2.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#wb2Rotation").focus();
        } else if($scope.outlook.dType == "wc" && ($scope.settingsWBT1.futureDateEv == null || $scope.settingsWBT2.futureDateEv == null)){
          $scope.errType = "futureDate";
          $scope.hasErr = true;
          $("#futureDateEv").focus();
        } else if($scope.outlook.dType == "wc" && ($scope.settingsWBT1.futureDateEv > 365 || $scope.settingsWBT2.futureDateEv > 365)){
          $scope.errType = "futureDateInvalid";
          $scope.hasErr = true;
          $("#futureDateEv").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && $scope.settingsWBT2.headerSize == null){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wb2HeaderSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && $scope.settingsWBT2.footerSize == null){
          $scope.errType = "fSize";
          $scope.hasErr = true;
          $("#fSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && $scope.settingsWBT2.leftSize == null){
          $scope.errType = "lSize";
          $scope.hasErr = true;
          $("#wb2LeftSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && $scope.settingsWBT2.rowSize == null){
          $scope.errType = "rSize";
          $scope.hasErr = true;
          $("#wb2RowSize").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && ($scope.settingsWBT2.sos.sType == "p" && !$scope.settingsWBT2.sos.prior)){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wb2SosP").focus();
        } else if($scope.outlook.dType == "wc" && $scope.outlook.template == "t2" && ($scope.settingsWBT2.sos.eType == "a" && !$scope.settingsWBT2.sos.after)){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wb2SosA").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1 || tab == 2){
            $scope.nextProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveOutlookFx(tab);
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.saveOutlookFx(tab);
              $scope.isPEOpen = false;
            }
          } else if(!$scope.outlook.isAuthorized && $scope.outlook.version.value == 'Office365'){
            $scope.errType = "authEmpty";
            $scope.hasErr = true;
          } else{
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveOutlookFx(caller);
              }, 250);
            } else{
              $scope.saveOutlookFx(caller);
            }
          }
        }
      }
    }

    $scope.saveOutlookFx = function(caller){
      if(caller == "save"){
        $scope.outlook.toast = true;
      } else{
        $scope.outlook.toast = false;
      }
      $scope.outlook.settings = {};
      if($scope.outlook.dType == "r"){
        if(!$scope.settingsRB.titleSize){
          $scope.settingsRB.titleSize = 72;
        }
        if(!$scope.settingsRB.subtitleSize){
          $scope.settingsRB.subtitleSize = 36;
        }
        if(!$scope.settingsRB.timeSize){
          $scope.settingsRB.timeSize = 48;
        }
        $scope.outlook.settings = $scope.settingsRB;
        $scope.outlook.ctype = $scope.ctypeRB;
        $scope.outlook.wallboardList = [];
      } else if($scope.outlook.dType == "wc"){
        if($scope.outlook.template == "t1"){
          $scope.outlook.settings = $scope.settingsWBT1;
          $scope.outlook.ctype = $scope.ctypeWBT1;
        } else{
          $scope.outlook.settings = $scope.settingsWBT2;
          $scope.outlook.ctype = $scope.ctypeWBT2;
        }
        $scope.outlook.rId = "";
      }

      var outlookCopy = angular.copy($scope.outlook);
      if($scope.outlook.password){
        outlookCopy.password = $scope.encryptFx($scope.outlook.password);
      }
      if($scope.outlook.retypePassword){
        outlookCopy.retypePassword = $scope.encryptFx($scope.outlook.retypePassword);
      }

      OutlookCalendarSrv.saveOutlookCalendar(outlookCopy).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.nextProcessing = false;
          $scope.outlook.id = data.id;

          //URL client id decryption
          $scope.request_url = data.request_url;
          if(data.request_url){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.request_url);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.request_url = updatedUrl;
              }
            }
          }

          if(data.code == ""){
            $scope.errType = "authEmpty";
            $scope.hasErr = true;
            $scope.saveProcessing = false;
          } else if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == 1 || caller == 2){
            if(caller == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(caller == 2){
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.backBtnFx = function(){
      if($scope.outlook.version.value != 'Office365'){
        $rootScope.selectedT = $rootScope.selectedT - 2;
      } else{
        $rootScope.selectedT = $rootScope.selectedT - 1;
      }
    }

    $scope.deleteOpen = function(caller, iId){
      $scope.removeProcessing = false;
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      OutlookCalendarSrv.delete($scope.outlook.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:""};
      $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      }
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:""};
      $scope.hasListErr = false;
      $scope.errType = "";
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // OutlookCalendarSrv.getSSDevices().then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
        //     $scope.dgList.d = angular.copy(data.devices);
        //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here start
      } else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        OutlookCalendarSrv.getSSList($scope.outlook.id).then(
          function(data){
            $scope.detailLoading = false;
            $scope.ssList = data.screenSaver;
            $scope.outlook.info = data.info;
            if(!$scope.ssList.length){
              $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
            } else{
              $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
        $scope.resetFx('s');
      }
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.loading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.addScreen.ss = $scope.curContent;
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel, type){
      // var curModel = [];
      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });

      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dList = [];
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   });
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      //   // angular.forEach($scope.curDeviceObj.availableDevices, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i=0; i<$scope.curDeviceObj.devices.length; i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      // }
      //! No need to do here end

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to do here start
          // if(caller){
          //   if($scope.addScreen.d.length > 0){
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.curDeviceObj.availableDevices), devices:$scope.curDeviceObj.devices};
          //   } else {
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
          //   }
          // }
          //! No need to do here end
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wOCalSS", caller: "availD", offset: 0, id: $scope.outlook.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wOCalSS", caller: "selD", offset: 0, id: $scope.outlook.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: change the value
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.errType = "";
      $scope.hasListErr = false;
      $scope.hasErr = false;
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#ssLabel").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#contentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#deviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#ssDuration").focus();
      } else{
        $scope.addProcessing = true;
        $scope.ssPostObj = {info:{id:$scope.outlook.id}, screenSaver:$scope.addScreen};
        OutlookCalendarSrv.addSS($scope.ssPostObj).then(
          function(data){
            // TODO: add new changes
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.outlook.info.screenSaver = [];
      $scope.outlook.info.screenSaver = $scope.ssList;
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset selected device
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.selectedT != "3" && item.type == "Image"){
            $scope.curArgsContent.push(item);
          } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('OpenHoursController', OpenHoursController);

  /** @ngInject */
  function OpenHoursController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, ngDialog, ContentLibrarySrv, OpenHoursSrv, DevicesSrv){
    $scope.colorPicker = {b:false, fb:false, ht:false, pt:false, rt:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = true;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.search = {text:""};
    // Todo to load data veriable and hold tab/button
    $scope.reponseLoad = false;
    
    $scope.updateDefineVariable = function(){
      $scope.haveMoreData = false;
      $scope.haveMoreSearchData = false;
      $scope.visibleData = [];
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.searchScroll = false;
      $scope.dListLoading = false;
      $scope.loadingMore = false;
      $scope.searchDevice = {label:""};
    }

    $scope.getDeviceFx = function(id){
      $scope.dLoading = true;
      $scope.updateDefineVariable();
      $scope.scrollObj = {subCaller: "wOpenHrs", caller: "availD", offset: 0, id: id};
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          // TODO fixed haveMoreData variable value as a false only for the open hour widget because client have less than 1000 device
          // if(data.d.length >= 1000){
          //   $scope.haveMoreData = true;
          // } else{
            $scope.haveMoreData = false;
          // }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.dLoading = false;
          $scope.detailLoading = false;
        },
        function(err){
          $scope.dLoading = false;
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.settings = {
      settings:{hoursEn:"", hoursFr:"", pickupEn:"", pickupFr:"", hoursEs:"", pickupEs:"", bg:"#073763", bga:1, footerBg:"#073763", footerBga:1, hourTxt:"#ffffff", hourFont:$scope.fontFamilySelected, pickuptTxt:"#fff2cc", pickupFont:$scope.fontFamilySelected, rowTxt:"#ffffff", rowFont:$scope.fontFamilySelected},
      ctype:{hour:"monochrome", pickupt:"default", bg:"default", row:"monochrome", footer:"default"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.defaultSettings.settings.hoursEn = $scope.openHours.settings.hoursEn;
      $scope.defaultSettings.settings.hoursFr = $scope.openHours.settings.hoursFr;
      $scope.defaultSettings.settings.hoursEs = $scope.openHours.settings.hoursEs;
      $scope.defaultSettings.settings.pickupEn = $scope.openHours.settings.pickupEn;
      $scope.defaultSettings.settings.pickupFr = $scope.openHours.settings.pickupFr;
      $scope.defaultSettings.settings.pickupEs = $scope.openHours.settings.pickupEs;

      $scope.openHours.settings = angular.copy($scope.defaultSettings.settings);
      $scope.openHours.ctype = angular.copy($scope.defaultSettings.ctype);
    }
    
    $scope.celEventBack = angular.fromJson(localStorage.getItem("celEventBack"));

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.curId = angular.copy($scope.decId);
    } else{
      localStorage.removeItem("celEventBack");
      $scope.celEventBack = null;
      $rootScope.tabView = true;
      $scope.curId = 0;
      $scope.openHours = {
        label:"", footerImg:"",
        activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype),
        // list:[]
      }
    }

    
    $rootScope.selectedTabFx = function(){
      $scope.detailLoading = true;
      if($scope.selectedT == "1"){
        OpenHoursSrv.getOpenHours($scope.curId).then(
          function(data){
            if(!$scope.curId){
              //! no need to do this code start
              // $scope.openHours.list = data.list;
              //! no need to do this code end
              // $scope.addStatusKey($scope.openHours.list, $scope.auth.upreferences.dot);
              // $scope.addTypeKey($scope.openHours);
            } else{
              $scope.openHours = data;
              // $scope.addStatusKey($scope.openHours.list, $scope.auth.upreferences.dot);
              // $scope.addTypeKey($scope.openHours);
              $scope.tim = $scope.openHours.timthumb;
              $scope.cBucket = $scope.cDetailBucket = $scope.openHours.bucket;
              if($scope.openHours.mbucket && $scope.openHours.mbucket != ""){
                $scope.cDetailBucket = $scope.openHours.mbucket;
              }
            }
            $scope.detailLoading = false;
          },
          function(err){
            $scope.detailLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedT == "2"){
        $scope.getDeviceFx($scope.curId);
      }
    }
    $rootScope.selectedTabFx();

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.curBg = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.openHours.footerImg = $scope.curBg;
        $scope.openHours.isHidden = 0;
        ngDialog.close();
      }
    }
    $scope.removeBgFx = function(){
      $scope.openHours.footerImg = {};
    }

    $scope.openHoursFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.scrollDataList && $scope.scrollDataList.length){
        $scope.openHours.list = $scope.scrollDataList;
      }

      if(tab == 1 || caller == "save"){
        if($scope.openHours.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.openHours.title == ""){
          $scope.errType = "title";
          $scope.hasErr = true;
          $("#title").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          
          $scope.openHours.fid = $scope.fid;
          $scope.openHours.toast = false;

          if(tab == 1){
            $scope.nextProcessing = true;
          } else{
            $scope.openHours.toast = true;
            $scope.saveProcessing = true;
          }

          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveOpenHoursFx(tab);
            }, 250);
          } else{
            $scope.saveOpenHoursFx(tab);
          }
        }
      } else{
        $timeout(function(){
          $scope.tabFx(2, 'tabFx');
          $scope.isPEOpen = false;
        }, 250);
      }
    }

    $scope.saveOpenHoursFx = function(tab, caller){
      $scope.reponseLoad = true;
      // $scope.saveProcessing = true;
      if(!$scope.openHours.settings.hoursEs){
        $scope.openHours.settings.hoursEs = "";
      }
      if(!$scope.openHours.settings.pickupEs){
        $scope.openHours.settings.pickupEs = "";
      }
      OpenHoursSrv.saveOpenHours($scope.openHours).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          
          if(data.id){
            $scope.curId = data.id;
            $scope.decId = data.id;
            $scope.openHours.id = data.id;
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $state.go("hub.contentLibrary.c");
          }
          $scope.reponseLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          $scope.reponseLoad = false;
        }
      );
    }

    $scope.cancelFx = function(){
      localStorage.removeItem("celEventBack");
      $state.go("hub.contentLibrary.c");
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    $scope.updateDeviceDataFx = function(caller, dData){
      if(caller == 'e'){
        $scope.dataCopy = angular.copy(dData);
      } else if(caller == 'u'){
        $scope.updateProcessing = true;
        var updateObj = {id:$scope.curId, d:dData}
        OpenHoursSrv.updateDeviceData(updateObj).then(
          function(data){
            $scope.updateProcessing = false;
            dData.show = false;
          },
          function(err){
            $scope.updateProcessing = false;
            $log.error(err);
          }
        );
      } else if(caller == 'c'){
        // dData.mo = $scope.dataCopy.mo
        // dData.tu = $scope.dataCopy.tu
        // dData.we = $scope.dataCopy.we
        // dData.th = $scope.dataCopy.th
        // dData.fr = $scope.dataCopy.fr
        // dData.sa = $scope.dataCopy.sa
        // dData.su = $scope.dataCopy.su
        // dData.pd = $scope.dataCopy.pd
        // dData.pt = $scope.dataCopy.pt
        // dData.la = $scope.dataCopy.la
        dData.show = false;
      }

    }

    // * scroll list data code START 2nd phase pagination
    $scope.updateDefineVariable();

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      // TODO return the function only for the open hour widget because client have less than 1000 device
      return;
      $scope.loadingMore = true;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {subCaller: $scope.copyScrollObj.subCaller, caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.loadingMore = false;
              $scope.$apply();
            });
          },
          function(err){
            $scope.loadingMore = false;
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.loadingMore = false;
              $scope.$apply();
            });
          },
          function(err){
            $scope.loadingMore = false;
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      $scope.dListLoading = true;
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {subCaller: $scope.copyScrollObj.subCaller, caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            // TODO fixed haveMoreData variable value as a false only for the open hour widget because client have less than 1000 device
            // if(data.d.length && data.d.length >= 1000){
            //   $scope.haveMoreSearchData = true;
            // } else{
              $scope.haveMoreSearchData = false;
            // }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });            
            $scope.dListLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {subCaller: $scope.copyScrollObj.subCaller, caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            // TODO fixed haveMoreData variable value as a false only for the open hour widget because client have less than 1000 device
            // if(data.d.length >= 1000){
            //   $scope.haveMoreData = true;
            // } else{
              $scope.haveMoreData = false;
            // }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.dListLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      });
    }, 0);

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      // if (!text && $scope.searchScroll) {
      //   // TODO Enter when have newVal is empty and user perform search operation already
      //   if(scrollElement != null){
      //     scrollElement.scrollTo(0, 0);
      //   }
      //   $scope.stIndex = 0
      //   $scope.etIndex = 300;
      //   $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
      //   $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
      //   $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      // } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: encodeURIComponent(text) });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: encodeURIComponent(text) });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      // }
    }
    // * scroll list data code END 2nd phase pagination
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('OnlineRadioController', OnlineRadioController);

  /** @ngInject */
  function OnlineRadioController($log, $rootScope, $scope, $state, $cookies, $timeout, OnlineRadioSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading=true;
      OnlineRadioSrv.getOnlineRadio($scope.decId).then(
        function(data){
          $scope.radio = data;
          $scope.detailLoading=false;
        }, function (err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.radio = {labelOpt:"a", label:"", volume:5, station:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.getStationsFx = function(){
      $scope.stationLoading = true;
      OnlineRadioSrv.getStations().then(
        function(data){
          $scope.stations = data;
          $scope.stationLoading = false;
        }, function(err){
          $log.error(err);
          $scope.stationLoading = false;
        }
      );
    }
    $scope.getStationsFx();

    $scope.onlineRadioFx = function(){
      $scope.radio.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.radio.labelOpt == "c" && $scope.radio.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.radio.station == "" || $scope.radio.station == null){
        $scope.errType = "station";
        $scope.hasErr = true;
        $("#station").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveOnlineRadioFx();
          }, 250);
        } else{
          $scope.saveOnlineRadioFx();
        }
      }
    }
    $scope.saveOnlineRadioFx = function(){
      $scope.saveProcessing = true;
      OnlineRadioSrv.saveOnlineRadio($scope.radio).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    // $scope.stations=[
    //   /*{lang:"--------------- English ---------------"},*/
    //   {"value":35, "name":"1 Dance FM", "lang":"English"},
    //   {"value":25, "name":"181 FM", "lang":"English"},
    //   {"value":32, "name":"181 FM - Power 181", "lang":"English"},
    //   {"value":37, "name":"181 FM - The Mix Channel", "lang":"English"},
    //   {"value":15, "name":"1FM", "lang":"English"},
    //   {"value":34, "name":"All Hits Station", "lang":"English"},
    //   {"value":29, "name":"Boing", "lang":"English"},
    //   {"value":4, "name":"Box UK Radio", "lang":"English"},
    //   {"value":11, "name":"Champion 5768 FM", "lang":"English"},
    //   {"value":20, "name":"Chart Hits FM", "lang":"English"},
    //   {"value":18, "name":"Direct FM", "lang":"English"},
    //   {"value":5, "name":"Dublins Kiss", "lang":"English"},
    //   {"value":10, "name":"Easy Hits Radio", "lang":"English"},
    //   {"value":2, "name":"Energy FM", "lang":"English"},
    //   {"value":36, "name":"Enter Zagreb", "lang":"English"},
    //   {"value":13, "name":"Folly Radio", "lang":"English"},
    //   {"value":16, "name":"Gravity Bradford", "lang":"English"},
    //   {"value":31, "name":"Hiper FM", "lang":"English"},
    //   {"value":27, "name":"Hot Dance Radio", "lang":"English"},
    //   {"value":30, "name":"Jewish Hits", "lang":"English"},
    //   {"value":3, "name":"Kiss Hits", "lang":"English"},
    //   {"value":17, "name":"LDN FM", "lang":"English"},
    //   {"value":22, "name":"Lolli Radio Hits", "lang":"English"},
    //   {"value":8, "name":"Love Radio", "lang":"English"},
    //   {"value":23, "name":"Lubimoe Radio", "lang":"English"},
    //   {"value":14, "name":"Magic 60s Florida", "lang":"English"},
    //   {"value":7, "name":"Magic 70s Florida", "lang":"English"},
    //   {"value":6, "name":"Magic 80s Florida", "lang":"English"},
    //   {"value":28, "name":"Mega Hit Radio Die", "lang":"English"},
    //   {"value":12, "name":"Party Vibe Radio", "lang":"English"},
    //   {"value":21, "name":"Raute Musik FM", "lang":"English"},
    //   {"value":9, "name":"Real Dance Radio", "lang":"English"},
    //   {"value":1, "name":"Smash FM", "lang":"English"},
    //   {"value":19, "name":"Venus FM", "lang":"English"},
    //   /*{lang:"--------------- French ---------------"},*/
    //   {"value":79, "name":"Radio Cosmopolite", "lang":"French"},
    //   {"value":78, "name":"Radio Flemme", "lang":"French"},
    //   {"value":26, "name":"Radio Hit FM", "lang":"French"},
    //   {"value":38, "name":"Radio Kymata", "lang":"French"},
    //   /*{lang:"--------------- Hindi ---------------"},*/
    //   {"value":45, "name":"Bollywood - Sada Bahar Music Radio", "lang":"Hindi"},
    //   {"value":48, "name":"Bollywood Hits", "lang":"Hindi"},
    //   {"value":43, "name":"Desi Music Mix", "lang":"Hindi"},
    //   {"value":41, "name":"Hindi Desi Bollywood Evergreen Hits", "lang":"Hindi"},
    //   {"value":44, "name":"Hits Of Bollywood", "lang":"Hindi"},
    //   {"value":42, "name":"Planet Radio City", "lang":"Hindi"},
    //   {"value":47, "name":"Radio Afsana", "lang":"Hindi"},
    //   {"value":39, "name":"Radio HSL", "lang":"Hindi"},
    //   {"value":46, "name":"Radio Teen Taal", "lang":"Hindi"},
    //   {"value":40, "name":"The Voice Asia", "lang":"Hindi"},
    //   {"value":49, "name":"Tune India Radio", "lang":"Hindi"},
    //   /*{lang:"--------------- Japanese / Chinese ---------------"},*/
    //   {"value":70, "name":"Chinamerica Radio", "lang":"Japanese / Chinese"},
    //   {"value":73, "name":"Chinese Buddhism radio", "lang":"Japanese / Chinese"},
    //   {"value":71, "name":"Free China Radio", "lang":"Japanese / Chinese"},
    //   {"value":75, "name":"Friends Forever", "lang":"Japanese / Chinese"},
    //   {"value":77, "name":"Hitsujikai Radio", "lang":"Japanese / Chinese"},
    //   {"value":74, "name":"Japan A Radio", "lang":"Japanese / Chinese"},
    //   {"value":76, "name":"Jazz Up Japan Radio", "lang":"Japanese / Chinese"},
    //   {"value":72, "name":"Voice for Canadian Chinese", "lang":"Japanese / Chinese"},
    //   /*{lang:"--------------- Punjabi ---------------"},*/
    //   {"value":65, "name":"Apna Punjab", "lang":"Punjabi"},
    //   {"value":61, "name":"Dhol Radio", "lang":"Punjabi"},
    //   {"value":62, "name":"Gurbani Radio", "lang":"Punjabi"},
    //   {"value":66, "name":"Hungama Punjabi Hits", "lang":"Punjabi"},
    //   {"value":67, "name":"JUS Radio", "lang":"Punjabi"},
    //   {"value":63, "name":"Non Stop Punjabi Radio", "lang":"Punjabi"},
    //   {"value":68, "name":"Punjab Rocks Radio", "lang":"Punjabi"},
    //   {"value":64, "name":"Punjabi Radio Canada", "lang":"Punjabi"},
    //   {"value":60, "name":"Punjabi Radio USA", "lang":"Punjabi"},
    //   {"value":69, "name":"Sanjha FM", "lang":"Punjabi"},
    //   /*{lang:"--------------- Tamil ---------------"},*/
    //   {"value":52, "name":"Chellam FM", "lang":"Tamil"},
    //   {"value":59, "name":"Hungama Tamil Hits", "lang":"Tamil"},
    //   {"value":51, "name":"IBC Tamil", "lang":"Tamil"},
    //   {"value":57, "name":"ILC Tamil", "lang":"Tamil"},
    //   {"value":50, "name":"Lankasri FM", "lang":"Tamil"},
    //   {"value":55, "name":"Paris Tamil FM", "lang":"Tamil"},
    //   {"value":58, "name":"Puradsi Isaiyaruvi", "lang":"Tamil"},
    //   {"value":54, "name":"Radio City Tamil", "lang":"Tamil"},
    //   {"value":56, "name":"Thuthi FM", "lang":"Tamil"},
    //   {"value":53, "name":"Varnam FM", "lang":"Tamil"}
    // ];
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('NextVehicleController', NextVehicleController);

  /** @ngInject */
  function NextVehicleController($log, $rootScope, $scope, $state, $cookies, $timeout, NextVehicleSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      NextVehicleSrv.getNextVehicle($scope.decId).then(
        function(data){
          $scope.nextVehicle = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.nextVehicle = {label:"", place:"", lat:"", lng:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.$on('mapentrySelected', function(event, geoCoder){
      if(!angular.isUndefined(geoCoder)){
        $scope.nextVehicle.place = geoCoder.formatted_address;
        $scope.nextVehicle.lat = geoCoder.geometry.location.lat();
        $scope.nextVehicle.lng = geoCoder.geometry.location.lng();
      }
    });

    $scope.nextVehicleFx = function(){
      $scope.nextVehicle.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.nextVehicle.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.nextVehicle.place == "" && $scope.nextVehicle.lat == "" && $scope.nextVehicle.lng == ""){
        $scope.errType = "address";
        $scope.hasErr = true;
        $("#address").focus();
      } else{
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveNextVehicleFx();
          }, 250);
        } else{
          $scope.saveNextVehicleFx();
        }
      }
    }

    $scope.saveNextVehicleFx = function(){
      $scope.saveProcessing = true;
      NextVehicleSrv.saveNextVehicle($scope.nextVehicle).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('NextBusController', NextBusController);

  /** @ngInject */
  function NextBusController($log, $rootScope, $scope, $state, $cookies, $timeout, NextBusSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      NextBusSrv.getNextBus($scope.decId).then(
        function(data){
          $scope.nextBus = data;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.detailLoading = true;
      $scope.nextBus = {
        labelOpt:"a", label:"", dType:"r", nextBus:{agency:"", route:"", direction:"", stop:""},
        activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.getAgency = function(){
      NextBusSrv.getAgency().then(
        function(data){
          $scope.agencyList = data.agency;
          if($state.params.id){
            $scope.getListFx("r", true);
          } else{
            $scope.detailLoading = false;
          }
        }, function(err){
          $log.error(err);
        }
      );
    }
    $scope.getAgency();

    $scope.typeFx = function(){
      $scope.nextBus.nextBus.direction = "";
      $scope.nextBus.nextBus.agency = "";
      $scope.nextBus.nextBus.route = "";
      $scope.nextBus.nextBus.stop = "";
      $scope.directionsList = {};
      $scope.routeList = {};
      $scope.stopsList = {};
    }

    $scope.getListFx = function(caller, auto){
      if(caller == "r"){
        $scope.routeLoading = true;
        $scope.directionsList = {};
        $scope.routeList = {};
        $scope.stopsList = {};
        if(!$state.params.id || auto){
          $scope.nextBus.nextBus.direction = "";
          $scope.nextBus.nextBus.stop = "";
        }
        NextBusSrv.getRoute($scope.nextBus.nextBus.agency.tag).then(
          function(data){
            $scope.routeLoading = false;
            $scope.routeList = data.route;
             if($scope.nextBus.dType == "s" && $scope.nextBus.nextBus.direction){
               $scope.getListFx("d");
             } else{
               $scope.detailLoading = false;
             }
          }, function(err){
            $log.error(err);
          }
        );
      } else if(caller == "d"){
        $scope.directionsLoading = true;
        $scope.directionsList = {};
        $scope.stopsList = {};
        if(!$state.params.id || auto){
          $scope.nextBus.nextBus.direction = "";
          $scope.nextBus.nextBus.stop = "";
        }
        NextBusSrv.getDirections({aTag:$scope.nextBus.nextBus.agency.tag, rTag:$scope.nextBus.nextBus.route.tag}).then(
          function(data){
            $scope.directionsLoading = false;
            $scope.directionsList = data.direction;
            if($scope.nextBus.dType == "s" && $scope.nextBus.nextBus.direction){
              $scope.getListFx("s");
            } else{
              $scope.detailLoading = false;
            }
          }, function(err){
            $log.error(err);
          }
        );
      } else if(caller == "s" && $scope.nextBus.dType == "s"){
        $scope.stopLoading = true;
        $scope.stopsList = {};
        NextBusSrv.getStops({aTag:$scope.nextBus.nextBus.agency.tag, rTag:$scope.nextBus.nextBus.route.tag, dTag:$scope.nextBus.nextBus.direction.tag}).then(
          function(data){
            $scope.detailLoading = false;
            $scope.stopLoading = false;
            $scope.stopsList = data.stop;
          }, function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.nextBusFx = function(){
      $scope.nextBus.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.nextBus.labelOpt == "c" && $scope.nextBus.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.nextBus.nextBus.agency == ""){
        $scope.errType = "agency";
        $scope.hasErr = true;
        $("#agency").focus();
      } else if($scope.nextBus.nextBus.route == ""){
        $scope.errType = "route";
        $scope.hasErr = true;
        $("#route").focus();
      } else if($scope.nextBus.dType == "s" && $scope.nextBus.nextBus.direction == ""){
        $scope.errType = "direction";
        $scope.hasErr = true;
        $("#direction").focus();
      } else if($scope.nextBus.dType == "s" && $scope.nextBus.nextBus.stop == ""){
        $scope.errType = "stop";
        $scope.hasErr = true;
        $("#stop").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveNextBusFx();
          }, 250);
        } else{
          $scope.saveNextBusFx();
        }
      }
    }
    $scope.saveNextBusFx = function(){
      NextBusSrv.saveNextBus($scope.nextBus).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('NewsController', NewsController);

  /** @ngInject */
  function NewsController($log, $rootScope, $scope, $state, $cookies, $timeout, NewsSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, arb:false, tt:false, dt:false, att:false, adt:false, bc:false, tc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.categoryLoading = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.categorys = {};
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsNormal = {settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#3d85c6", descText:"#444444", rowFont:$scope.fontFamilySelected, altTitleText:"#3d85c6", altDescText:"#444444", altRowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18},
    ctype:{headerBg:"monochrome", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome"}};
    $scope.settingsCrawl = {settings:{speed:100, bg:"#000000", bga:1, bullet:"#990000", titleText:"#ffffff", font:$scope.fontFamilySelected, dir:"rl", align:"l", fontSizeOpt:"a", fontSize:16},
    ctype:{bg:"monochrome", bullet:"default", titleText:"monochrome"}};

    $scope.defaultNormal = angular.copy($scope.settingsNormal);
    $scope.defaultCrawl = angular.copy($scope.settingsCrawl);

    $scope.settingsDefault = function(){
      if($scope.news.dType == "normal"){
        $scope.news.settings = angular.copy($scope.defaultNormal.settings);
        $scope.news.ctype = angular.copy($scope.defaultNormal.ctype);
      } else if($scope.news.dType == "crawl"){
        $scope.news.settings = angular.copy($scope.defaultCrawl.settings);
        $scope.news.ctype = angular.copy($scope.defaultCrawl.ctype);
      }
    }

    $scope.changeDType = function(caller){
      $scope.news.settings = {};
      $scope.news.ctype = {};
      if(caller == "normal"){
        $scope.news.settings = angular.copy($scope.settingsNormal.settings);
        $scope.news.ctype = angular.copy($scope.settingsNormal.ctype);
      } else if(caller == "crawl"){
        $scope.news.settings = angular.copy($scope.settingsCrawl.settings);
        $scope.news.ctype = angular.copy($scope.settingsCrawl.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      NewsSrv.getNews($scope.decId).then(
        function(data){
          $scope.news = data;
          $scope.detailLoading = false;
          $scope.categorys.feed = $scope.news.feed;
          if($scope.news.provider == "Bing"){
            $scope.getCountryFx();
          }
          if($scope.news.dType == "normal"){
            $scope.settingsNormal.settings = angular.copy($scope.news.settings);
            $scope.settingsNormal.ctype = angular.copy($scope.news.ctype);
          } else if($scope.news.dType == "crawl"){
            if(!$scope.news.settings.fontSizeOpt){
              $scope.news.settings.fontSizeOpt = "a";
              $scope.news.settings.dir = "rl";
              $scope.news.settings.fontSize = 16;
              $scope.news.settings.align = "l";
            }
            $scope.settingsCrawl.settings = angular.copy($scope.news.settings);
            $scope.settingsCrawl.ctype = angular.copy($scope.news.ctype);
          }
          $scope.dTypeCopy = angular.copy($scope.news.dType);
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.news = {labelOpt:"a", label:"", dType:"normal",
        settings:angular.copy($scope.settingsNormal.settings),
        ctype:angular.copy($scope.settingsNormal.ctype),
        provider:"", category:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.getCountryFx = function(){
      $scope.countryLoading = true;
      NewsSrv.getCountry().then(
        function(data){
          $scope.countrys = data.country;
          $scope.countryLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.countryLoading = false;
        }
      );
    }
    $scope.newsProviderFx = function(){ //For News Feed
      if($scope.news.provider != ""){
        $scope.categoryLoading = true;
        NewsSrv.getNewsFeed($scope.news.provider).then(
          function(data){
            $scope.categorys = data;
            $scope.categoryLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.categoryLoading = false;
          }
        );
        if($scope.news.provider == "Bing"){
          $scope.getCountryFx();
        }
      }
    }

    $scope.newsFx = function(){
      $scope.news.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.news.labelOpt == "c" && $scope.news.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.news.provider == ""){
        $scope.errType = "provider";
        $scope.hasErr = true;
        $("#provider").focus();
      } else if($scope.news.category == ""){
        $scope.errType = "category";
        $scope.hasErr = true;
        $("#category").focus();
      } else if($scope.news.settings.rotationOpt == "c" && !$scope.news.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#cRotate").focus();
      } else if($scope.news.dType == "crawl" && $scope.news.settings.speed == null){
        $scope.errType = "crawl";
        $scope.hasErr = true;
        $("#speed").focus();
      } else if($scope.news.dType === "crawl" && ($scope.news.settings.dir == "rl" || $scope.news.settings.fontSizeOpt == "c") && $scope.news.settings.fontSize == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
        $("#rlFontSize").focus();
      } else if($scope.news.dType === "crawl" && $scope.news.settings.dir == "bt" && $scope.news.settings.fontSize == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
        $("#btFontSize").focus();
      } else if($scope.news.dType == 'normal' && $scope.news.settings.hTextOpt == "c" && $scope.news.settings.hText == ""){
        $scope.errType = "hText";
        $scope.hasErr = true;
        $("#hText").focus();
      } else if($scope.news.dType == 'normal' && $scope.news.settings.hTextOpt != "n" && !$scope.news.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#headerSize").focus();
      } else if($scope.news.dType == 'normal' && !$scope.news.settings.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else if($scope.news.dType == 'normal' && !$scope.news.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
        $("#descSize").focus();
      } else if($scope.news.provider == 'Bing' && !$scope.news.country){
        $scope.errType = "country";
        $scope.hasErr = true;
        $("#country").focus();
      } else{
        $scope.isValid = false;
        angular.forEach($scope.categorys.feed, function(item){
          if($scope.news.category.id == item.id){
            $scope.isValid = true;
          }
        });
        if(!$scope.isValid){
          $scope.errType = "category";
          $scope.hasErr = true;
          $("#category").focus();
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function (){
              $scope.saveNews();
            }, 250);
          } else{
            $scope.saveNews();
          }
        }
      }
    }

    $scope.saveNews = function(){
      NewsSrv.saveNews($scope.news).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MusicChoiceController', MusicChoiceController);

  /** @ngInject */
  function MusicChoiceController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, $document, MusicChoiceSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.categorySongsLoading = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.curScInAc = [];
    $scope.curSC = [];
    $scope.encId = "";
    $scope.decId = "";

    //new Start
    $scope.categories = {availableCategories:[], selectedCategories:[]};
    $scope.categorySongs = {availableSongs:[], selectedSongs:[]};
    $scope.playList = {playSongs:[], dontPlaySongs:[]};
    $scope.mcName = {};
    //new end

    if($state.params.id){
      $scope.status = "u";
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.curId = $scope.decId;
      $scope.detailLoading = true;
      MusicChoiceSrv.getMCName($scope.decId).then(
        function(data){
          $scope.mcName = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $scope.status = "c";
      $rootScope.tabView = true;
      $scope.mcName = {label:"", isRandom:false, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $rootScope.selectedTabFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.tabProcessing = false;
      if($rootScope.selectedT == 1){
        $scope.detailLoading = false;
      } else if($rootScope.selectedT == 2){
        $scope.detailLoading = true;
        MusicChoiceSrv.getMCCategories($scope.categories.id).then(
          function(data){
            $scope.categories = data;
            $scope.curScInAc = $scope.categories.selectedCategories;
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );

      } else if($rootScope.selectedT == 3){
        $scope.detailLoading = true;
        MusicChoiceSrv.getMCPlaylist({id:$scope.playList.id, offset:0}).then(
          function(data){
            $scope.playList = data;
            $scope.curPlayListOffset = $scope.playList.playSongs.length;
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
    }
    $rootScope.selectedTabFx();

    $scope.donotPlayDeleteBtn = false;
    $scope.chkList = {playList:false, dontPlay:false, aSongs:false, sSongs:false};
    $scope.checkAllFx = function(caller, value){
      if(caller == "aSongs"){
        angular.forEach($scope.curCategorySongs.availableSongs, function(item){
          if(!item.isDontPlay){
            item.isSelected = value;
          }
        });
      } else if(caller == "sSongs"){
        angular.forEach($scope.curCategorySongs.selectedSongs, function(item){
          item.isSelected = value;
        });
      } else if(caller == "playList"){
        angular.forEach($scope.playList.playSongs, function(item){
          item.isSelected = value;
        });
      } else if(caller == "dontPlay"){
        angular.forEach($scope.playList.dontPlaySongs, function(item){
          item.isSelected = value;
        });
        if(value){
          $scope.donotPlayDeleteBtn = true;
        } else{
          $scope.donotPlayDeleteBtn = false;
        }
      }
    }

    $scope.checkboxFx = function(caller){
      if(caller == "as"){
        if($filter("filter")($scope.curCategorySongs.availableSongs, {isSelected:false}).length == 0){
          $scope.chkList.aSongs = true;
        } else{
          $scope.chkList.aSongs = false;
        }
      } else if(caller == "ss"){
        if($filter("filter")($scope.curCategorySongs.selectedSongs, {isSelected:false}).length == 0){
          $scope.chkList.sSongs = true;
        } else{
          $scope.chkList.sSongs = false;
        }
      } else if(caller == "pl"){
        if($filter("filter")($scope.playList.playSongs, {isSelected:false}).length == 0){
          $scope.chkList.playList = true;
        } else{
          $scope.chkList.playList = false;
        }
      } else if(caller == "dp"){
        if($filter("filter")($scope.playList.dontPlaySongs, {isSelected:false}).length == 0){
          $scope.chkList.dontPlay = true;
        } else{
          $scope.chkList.dontPlay = false;
        }
        if($filter("filter")($scope.playList.dontPlaySongs, {isSelected:true}).length > 0){
          $scope.donotPlayDeleteBtn = true;
        } else{
          $scope.donotPlayDeleteBtn = false;
        }
      }
    }

    $scope.addCategoryFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      angular.forEach($scope.categories.availableCategories, function(item){
        if(item.isSelected){
          $scope.curScInAc.push(item);
        }
      });
      if($scope.curScInAc.length > 0){
        $scope.curSC = [];
        angular.forEach($scope.curScInAc, function(value, key){
          var exists = false;
          angular.forEach($scope.curSC, function(val2, key){
            if(angular.equals(value.CategoryNumber, val2.CategoryNumber)){
              exists = true;
            };
          });
          if(!exists && value.CategoryNumber != ""){
            $scope.curSC.push(value);
            value.isSelected = false;
            if(!value.count){
              value.count = value.totalCount;
            }
          }
        });
        $scope.categories.selectedCategories = $scope.curScInAc = $scope.curSC;
      } else{
        $scope.hasErr = true;
        $scope.errType = "addMsg";
      }
    }

    $scope.openCategoriesFx = function(cId, count, categoryName){
      if(count){
        $scope.openPopupLoading = true;
        $scope.curCategorySongs = {availableSongs:[], selectedSongs:[], categoryName:categoryName};
        $scope.curCategory = {id:$scope.categories.id, categoryId:cId, count:count};
        $scope.search.ssTbx = $scope.search.asTbx = "";
        $scope.chkList.aSongs = $scope.chkList.sSongs = false;
        ngDialog.open({
          template:'app/contentLibrary/widgets/popup/musicChoice.html',
          width:1000,
          scope:$scope,
          closeByDocument:false,
        });
        MusicChoiceSrv.getMCCategorySongs($scope.curCategory).then(
          function(data){
            $scope.curCategorySongs = data;
            $scope.curCategorySongs.categoryName = categoryName;
            $scope.openPopupLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.openPopupLoading = false;
          }
        );
      }
    }

    $scope.pLSearch = {playList:"", dontPlay:""};
    $scope.search = {asTbx:"", ssTbx:""};
    $scope.checkboxListManipulateFx = function(caller, array1, array2){
      if(caller == "add"){
        for(var i = array1.length - 1; i >= 0; i--){
          if(array1[i].isSelected){
            array1[i].isSelected = false;
            array2.push(array1[i]);
            array1.splice(i, 1);
          }
        }
        if(array1.length == 0){
          $scope.search.asTbx = "";
          $scope.pLSearch.playList = "";
          $scope.chkList.playList = false;
        }
        $scope.chkList.dontPlay = $scope.chkList.aSongs = $scope.chkList.sSongs = false;
      } else if(caller == "remove"){
        for(var i = array2.length - 1; i >= 0; i--){
          if(array2[i].isSelected){
            array2[i].isSelected = false;
            array1.push(array2[i]);
            array2.splice(i, 1);
          }
        }
        if(array2.length == 0){
          $scope.search.ssTbx = "";
        }
      }
      $scope.chkList.aSongs = $scope.chkList.sSongs = false;
    }
    $scope.selectedSongsFx = function(){
      $scope.selectedSongsObj = {id:$scope.categories.id, categoryId:$scope.curCategory.categoryId, selectedSongs:$scope.curCategorySongs.selectedSongs};
      $scope.songsProcessing = true;
      $scope.maxCountPop = false;
      MusicChoiceSrv.saveMCCategorySongs($scope.selectedSongsObj).then(
        function(data){
          $scope.songsProcessing = false;
          if(data.code == 8133){
            $scope.maxCountPop = true;
          } else{
            angular.forEach($scope.categories.selectedCategories, function(item){
              if(item.CategoryNumber == data.categoryId){
                item.songs = data.songs;
                item.count = data.count;
              }
            });
            ngDialog.close();
          }
        },
        function(err){
          $log.error(err);
          $scope.songsProcessing = false;
        }
      );
    }

    $scope.loadMoreLogs = function(){
      if($scope.curPlayListOffset == 0){
        $scope.playList.playSongs = [];
        $scope.detailLoading = true;
        $scope.allDataLoaded = false;
      }
      if(!$scope.allDataLoaded){
        MusicChoiceSrv.getMCPlaylist({id:$scope.playList.id, offset:$scope.curPlayListOffset}).then(
          function(data){
            if(data && data.playSongs.length == 0){
              $scope.allDataLoaded = true;
            } else{
              $scope.playList.playSongs = $scope.playList.playSongs.concat(data.playSongs);
              $scope.curPlayListOffset = $scope.playList.playSongs.length;
              $scope.allDataLoaded = false;
            }
            $scope.detailLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
    }

    $scope.removeOpen = function(caller, id){
      $scope.removeObject = {caller:caller, id:id, multiple:false};
      if($filter("filter")($scope.playList.dontPlaySongs, {isSelected:true}).length > 1){
        $scope.removeObject.multiple = true;
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="removeObject.caller == \'sc\'">{{"cl.widget.mc.m5" | translate}}</span>\
              <span ng-if="removeObject.caller == \'dp\'">{{removeObject.multiple?"cm.msg.34s":"cm.msg.34" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeFx(removeObject.caller, removeObject.id);" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        data:$scope.removeObject,
        closeByEscape:false,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.removeFx = function(caller, id){
      if(caller == "sc"){
        angular.forEach($scope.categories.selectedCategories, function(item, $index){
          if(id === item.CategoryNumber){
            $scope.categories.selectedCategories.splice($index, 1);
          }
        });
        angular.forEach($scope.curScInAc, function(item, $index){
          if(id === item.CategoryNumber){
            $scope.curScInAc.splice($index, 1);
          }
        });
      } else if(caller ==  "dp"){
        if(angular.isUndefined(id)){
          $scope.playList.dontPlaySongs = $filter("filter")($scope.playList.dontPlaySongs, {isSelected:false});
          $scope.chkList.dontPlay = false;
        } else{
          angular.forEach($scope.playList.dontPlaySongs, function(item, $index){
            if(id === item.SongID){
              $scope.playList.dontPlaySongs.splice($index, 1);
              item.isSelected = false;
            }
          });
          if($filter("filter")($scope.playList.dontPlaySongs, {isSelected:true}).length == 0){
            $scope.donotPlayDeleteBtn = false;
            $scope.chkList.dontPlay = false;
          }
        }
        if($scope.playList.dontPlaySongs.length <= 0){
          $scope.pLSearch.dontPlay = "";
          $scope.donotPlayDeleteBtn = false;
          $scope.chkList.dontPlay = false;
        }
      }
      ngDialog.close();
    }

    $scope.searchedEmpty = false;
    $scope.searchSongsFx = function(){
      $scope.allCategories = [];
      MusicChoiceSrv.searchSongs({searchKey:$scope.pLSearch.playList, categories:$scope.playList.selectedCategories}).then(
        function(data){
          $scope.searchedEmpty = false;
          $scope.searchedSongs = data;
          if(!$scope.searchedSongs.length){
            $scope.searchedEmpty = true;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $scope.searchedEmpty = false;
      $scope.searchedSongs = [];
      $scope.pLSearch.playList = "";
    }

    $scope.openDoNotPlaylist = function(){
      $scope.isChecked = {};
      $scope.curDoNot = [];
      $scope.openPopupLoading = true;
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/mcDoNotPlaylist.html',
        width:750,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(){
          $scope.hasErr = false;
          $scope.errType = "";
        }
      });
      MusicChoiceSrv.getMusicChoiceWidgets().then(
        function(data){
          $scope.mcWidgets = data;
          $scope.openPopupLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.openPopupLoading = false;
        }
      );
    }
    $scope.openConfirmFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curDoNot.length == 0){
        $scope.errType = "empty";
        $scope.hasErr = true;
        return false;
      } else if($scope.playList.dontPlaySongs.length > 0){
        ngDialog.open({
          template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.mc.m13" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="doNotPlaylistFx(); closeThisDialog();" data-dismiss="modal">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        $scope.doNotPlaylistFx();
      }
    }

    $scope.doNotPlaylistFx = function(){
      $scope.donotPlayDeleteBtn = false;
      $scope.chkList.dontPlay = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curDoNot.length == 0){
        $scope.errType = "empty";
        $scope.hasErr = true;
        return false;
      } else{
        $scope.saveDoNotPlayProcessing = true;
        MusicChoiceSrv.saveMusicChoiceWidgets($scope.curDoNot).then(
          function(data){
            angular.forEach(data, function(item){
              $scope.isDuplicate = false;
              for(var i=0; i<$scope.playList.dontPlaySongs.length; i++){
                if(!$scope.isDuplicate && item.SongID == $scope.playList.dontPlaySongs[i].SongID){
                  $scope.isDuplicate = true;
                  break;
                }
              }
              if(!$scope.isDuplicate){
                $scope.playList.dontPlaySongs.push(item);
              }
            });
            $scope.saveDoNotPlayProcessing = false;
            ngDialog.close();
          },
          function(err){
            $log.error(err);
            $scope.saveDoNotPlayProcessing = false;
          }
        );
      }
    }
    $scope.checkedFx = function(id){
      if($scope.isChecked[id]){
        $scope.curDoNot.push(id);
      } else{
        $scope.curDoNot.splice($scope.curDoNot.indexOf(id), 1);
      }
    }

    $scope.musicChoiceFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($rootScope.selectedT == 1){
        $scope.mcName.fid = $scope.fid;
        if($scope.id){
          $scope.mcName.id = $scope.id;
        }
        if($scope.mcName.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if(caller == "save"){
            $scope.mcName.toast = true;
            $scope.saveProcessing = true;
          } else{
            $scope.mcName.toast = false;
            $scope.tabProcessing = true;
          }
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveMCNameFx(tab, caller);
            }, 250);
          } else{
            $scope.saveMCNameFx(tab, caller);
          }
        }
      } else if($rootScope.selectedT == 2){
        $scope.categories.fid = $scope.fid;
        if($scope.id){
          $scope.categories.id = $scope.id;
        }
        if(caller == "save"){
          $scope.categories.toast = true;
          $scope.saveProcessing = true;
        } else{
          $scope.categories.toast = false;
          $scope.tabProcessing = true;
        }
        $scope.saveProcessing = false;
        $scope.curCategories = {id:$scope.categories.id, fid:$scope.categories.fid, toast:$scope.categories.toast, status:$scope.status, selectedCategories:$scope.categories.selectedCategories};
        MusicChoiceSrv.saveMCCategories($scope.curCategories).then(
          function(data){
            if(data.code == 8132){
              $scope.errType = "songsCount";
              $scope.hasErr = true;
              $scope.saveProcessing = false;
              $scope.tabProcessing = false;
            } else if(data.code == 8133){
              $scope.errType = "maxCount";
              $scope.hasErr = true;
              $scope.saveProcessing = false;
              $scope.tabProcessing = false;
            } else{
              $scope.id = $scope.mcName.id = $scope.categories.id = $scope.playList.id = data.id;
              $scope.saveProcessing = false;
              $scope.tabProcessing = false;
              if(caller == "save"){
                $state.go("hub.contentLibrary.c");
              } else{
                if(tab == 1){
                  $scope.tabFx(1, 'tabFx');
                } else if(tab == 3){
                  $scope.tabFx(3, 'tabFx');
                }
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
            $scope.tabProcessing = false;
          }
        );
      } else if($rootScope.selectedT == 3){
        $scope.playList.fid = $scope.fid;
        if($scope.id){
          $scope.playList.id = $scope.id;
        }
        if(caller == "save"){
          $scope.playList.toast = true;
          $scope.saveProcessing = true;
        } else{
          $scope.playList.toast = false;
          $scope.tabProcessing = true;
        }
        $scope.curPlayList = {id:$scope.playList.id, fid:$scope.playList.fid, toast:$scope.playList.toast, status:$scope.status, dontPlaySongs:$scope.playList.dontPlaySongs};
        if($scope.playList.playSongs.length == 0){
          $scope.hasErr = true;
          $scope.errType = "minCount";
          $scope.saveProcessing = false;
          $scope.tabProcessing = false;
          $scope.curPlayList.playlistEmpty = true;
        } else{
          $scope.chkList.playList = false;
          $scope.chkList.dontPlay = false;
          $scope.donotPlayDeleteBtn = false;
          $scope.curPlayList.playlistEmpty = false;
          MusicChoiceSrv.saveMCPlaylist($scope.curPlayList).then(
            function(data){
              $scope.id = $scope.mcName.id = $scope.categories.id = $scope.playList.id = data.id;
              $scope.saveProcessing = false;
              $scope.tabProcessing = false;
              if(data.code == 8131){
                $scope.hasErr = true;
                $scope.errType = "minCount";
              } else{
                if(caller == "save"){
                  $state.go("hub.contentLibrary.c");
                } else{
                  if(tab == 1){
                    $scope.tabFx(1, 'tabFx');
                  } else if(tab == 2){
                    $scope.tabFx(2, 'tabFx');
                  }
                }
              }
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
              $scope.tabProcessing = false;
            }
          );
        }
      }
    }
    $scope.saveMCNameFx = function(tab, caller){
      $scope.mcName.status = $scope.status;
      MusicChoiceSrv.saveMCName($scope.mcName).then(
        function(data){
          $scope.id = $scope.mcName.id = $scope.categories.id = $scope.playList.id = data.id;
          if(caller == "save"){
            $scope.saveProcessing = false;
            $state.go("hub.contentLibrary.c");
          } else{
            if(tab == 2){
              $scope.tabProcessing = false;
              $scope.tabFx(2, 'tabFx');
            } else if(tab == 3){
              $scope.tabFx(3, 'tabFx');
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
          $scope.tabProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MSTeamsController', MSTeamsController);

  /** @ngInject */
  function MSTeamsController($log, $rootScope, $scope, $state, $cookies, $timeout, MSTeamsSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      MSTeamsSrv.getMSTeams($scope.decId).then(
        function(data){
          $scope.msTeams = data;
          $scope.detailLoading = false;
        }, function (err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.msTeams = {
        label:"", dType:"m", url:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
      };
    }

    $scope.msTeamsFx = function(){
      $scope.msTeams.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.msTeams.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.msTeams.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveMSTeamsFx();
          }, 250);
        } else{
          $scope.saveMSTeamsFx();
        }
      }
    }
    $scope.saveMSTeamsFx = function(){
      MSTeamsSrv.saveMSTeams($scope.msTeams).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MessageController', MessageController);

  /** @ngInject */
  function MessageController($log, $rootScope, $scope, $state, $cookies, $filter, $window, $timeout, ngDialog, MessageSrv, ContentLibrarySrv){
    $scope.colorPicker = {b:false, tt:false, dt:false, rb:false, rab:false, qc:false, ac:false, pb:false, p:false, pc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.message = {};
    $scope.encId = "";
    $scope.decId = "";
    $scope.search = {text:""};

    $scope.settings = {
      settings:{
        imgPosition:"t", titleText:"#ffffff", titleSize:30, titleFont:$scope.fontFamilySelected, descText:"#ffffff", descSize:12, descFont:$scope.fontFamilySelected
      },
      ctype:{
        titleText:"monochrome", descText:"monochrome"
      }
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.message.settings = angular.copy($scope.defaultSettings.settings);
      $scope.message.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.getMessageFx = function(){
      $scope.detailLoading = true;
      MessageSrv.getMessage($scope.decId).then(
        function(data){
          $scope.message = data;
          $scope.tim = $scope.message.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.message.otherinfo.bucket;
          if($scope.message.otherinfo.mbucket && $scope.message.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.message.otherinfo.mbucket;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.getMessageFx();
    } else{
      $rootScope.tabView = true;
      $scope.message = {label:"", title:"", desc:"", content:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              path:$scope.contentLibrary.info.path
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.message.content = $scope.curBg;
        $scope.message.isHidden = 0;
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(){
      $scope.message.content = {};
    }
    $scope.contentImgPopover = {templateUrl:"bgImg.html"}

    $scope.messageFx = function(){
      $scope.message.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.message.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.message.title == ""){
        $scope.errType = "title";
        $scope.hasErr = true;
        $("#title").focus();
      } else if($scope.message.desc == ""){
        $scope.errType = "desc";
        $scope.hasErr = true;
        $("#desc").focus();
      } else if((!$scope.message.content || Object.keys($scope.message.content).length == 0)){
        $scope.errType = "content";
        $scope.hasErr = true;
        $("#contentBtn").focus();
      } else if(!$scope.message.settings.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else if(!$scope.message.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
        $("#descSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveMessageFx();
          }, 250);
        } else{
          $scope.saveMessageFx();
        }
      }
    }
    $scope.saveMessageFx = function(){
      MessageSrv.saveMessage($scope.message).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MeetingController', MeetingController);

  /** @ngInject */
  function MeetingController($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, DevicesSrv, ContentLibrarySrv, FileModelUploadSrv, CommonSrv, MeetingSrv){
    $scope.colorPicker = {rb:false, rsb:false, rtt:false, rst:false, rtm:false, wb:false, wsb:false, whb:false, wht:false, wtt:false, wat:false, wtm:false, watm:false, wrt:false, wart:false, wrb:false, wab:false, wft:false, waft:false, wfb:false};
    $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.curDeviceObj = {availableDevices:[], devices:[]};
    $scope.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.weekdays = [0, 1, 2, 3, 4, 5, 6];
    $scope.fid = localStorage.getItem("curFId");
    $scope.searchList = {d:"", g:"", r:""};
    $scope.roomProcessing = false;
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = true;
    $scope.meeting = {info:{}};
    $scope.isPEOpen = false;
    $scope.meetingList = [];
    $scope.currentPage = 0;
    $scope.addMeeting = {};
    $scope.roomList = [];
    $scope.curLogo = {};
    $scope.ssList = [];
    $scope.encId = "";
    $scope.decId = 0;
    $scope.dgList = {d:[], g:[], r:[]};
    $scope.rendered = false;
    $scope.search = {text:""};
    // Todo to load data veriable and hold tab/button
    $scope.reponseLoad = false;

    $scope.settings = {
      rb:{/*Roomboard*/
        bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, logoOpt:true,
        titleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:72,
        subtitleText:"#999999", subtitleFont:$scope.fontFamilySelected, subtitleSize:36,
        timeText:"#444444", timeFont:$scope.fontFamily[0], timeSize:48,
        sos:{sType:"p", prior:30, eType:"a", after:30},
        feed:{url:"", logo:"", ss:""}
      },
      wb:{/*Wallboard*/
        bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, isTime:true, isRoom:true, isFloor:true, logoOpt:true, rotationOpt:"a", rotate:12,wdmOpt:"d", isRF:true,
        header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room", col3TxtAlign:"center", column4:"Floor", col4TxtAlign:"center"},
        headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26,
        titleText:"#000000", timeText:"#444444", titleSize:28, titleTxtAlign:"left",
        altTitleText:"#000000", altTimeText:"#444444", timeSize:28, timeTxtAlign:"center",
        roomText:"#666666", altRoomText:"#000000", roomSize:28, roomTxtAlign:"center",
        floorText:"#666666", altFloorText:"#000000", floorSize:28, floorTxtAlign:"center",
        titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected, floorFont:$scope.fontFamilySelected,
        rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1,
        sos:{sType:"s", prior:30, eType:"a", after:30},
        feed:{url:"", logo:"", ss:""}
      },
      mt:{/*Meeting*/
        draType:"p"
      }
    };
    $scope.ctype = {
      rb:{bg:"monochrome", ssbg:"monochrome", titleText:"monochrome", subtitleText:"monochrome", timeText:"monochrome"},
      wb:{bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", timeText:"monochrome", roomText:"monochrome", altTitleText:"monochrome", altTimeText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"}
    };

    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      $scope.meeting.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.meeting.info.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.groupedMeetingFx = function(){
      $scope.groupedMeetingList = [];
      var isMDuplicate = false;
      for(var i=0; i<$scope.meetingList.length; i++){
        isMDuplicate = false;
        for(var j=0; j<$scope.groupedMeetingList.length; j++){
          if($scope.meetingList[i].title.toLowerCase() == $scope.groupedMeetingList[j].title.toLowerCase()){
            $scope.groupedMeetingList[j].meeting.push($scope.meetingList[i]);
            $scope.groupedMeetingList[j].type = "m";
            isMDuplicate = true;
            break;
          }
        }
        if(!isMDuplicate){
          $scope.groupedMeetingList.push({title:$scope.meetingList[i].title, meeting:[$scope.meetingList[i]], type:"s"});
        }
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      MeetingSrv.getMeeting($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.meeting.info = data.info;
          if(!$scope.meeting.info.settings.rb.sos){
            $scope.meeting.info.settings.rb.sos = {sType:"p", prior:30, eType:"a", after:30};
          }
          if(!$scope.meeting.info.settings.wb.sos){
            $scope.meeting.info.settings.wb.sos = {sType:"s", prior:30, eType:"e", after:30};
          }
          if(!$scope.meeting.info.settings.mt.draType){
            $scope.meeting.info.settings.mt.draType = "p";
          }
          if(!$scope.meeting.info.settings.wb.rotationOpt){
            $scope.meeting.info.settings.wb.rotationOpt = "a";
            $scope.meeting.info.settings.wb.rotate = 12;
            $scope.meeting.info.settings.wb.logoOpt = true;
            $scope.meeting.info.settings.rb.logoOpt = true;
          }
          if(!$scope.meeting.info.settings.wb.wdmOpt){
            $scope.meeting.info.settings.wb.wdmOpt = "d";
          }
          if(!$scope.meeting.info.settings.wb.headerSize){
            $scope.meeting.info.settings.wb.headerSize = 26;
            $scope.meeting.info.settings.wb.titleSize = 28;
            $scope.meeting.info.settings.wb.timeSize = 28;
            $scope.meeting.info.settings.wb.roomSize = 28;
          }
          if(!$scope.meeting.info.settings.wb.hasOwnProperty("isFloor")){
            $scope.meeting.info.settings.wb.floorText = "#666666";
            $scope.meeting.info.settings.wb.altFloorText = "#000000";
            $scope.meeting.info.settings.wb.floorSize = 28;
            $scope.meeting.info.settings.wb.isFloor = true;
            $scope.meeting.info.settings.wb.floorFont = $scope.fontFamilySelected;
            $scope.meeting.info.settings.wb.isRF = true;
          }
          if(!$scope.meeting.info.settings.wb.header.column4){
            $scope.meeting.info.settings.wb.header.column4 = "Floor";
          }

          if(!$scope.meeting.info.settings.wb.header.col1TxtAlign){
            $scope.meeting.info.settings.wb.header.col1TxtAlign = "left";
          }
          if(!$scope.meeting.info.settings.wb.header.col2TxtAlign){
            $scope.meeting.info.settings.wb.header.col2TxtAlign = "center";
          }
          if(!$scope.meeting.info.settings.wb.header.col3TxtAlign){
            $scope.meeting.info.settings.wb.header.col3TxtAlign = "center";
          }
          if(!$scope.meeting.info.settings.wb.header.col4TxtAlign){
            $scope.meeting.info.settings.wb.header.col4TxtAlign = "center";
          }
          if(!$scope.meeting.info.settings.wb.titleTxtAlign){
            $scope.meeting.info.settings.wb.titleTxtAlign = "left";
          }
          if(!$scope.meeting.info.settings.wb.timeTxtAlign){
            $scope.meeting.info.settings.wb.timeTxtAlign = "center";
          }
          if(!$scope.meeting.info.settings.wb.roomTxtAlign){
            $scope.meeting.info.settings.wb.roomTxtAlign = "center";
          }
          if(!$scope.meeting.info.settings.wb.floorTxtAlign){
            $scope.meeting.info.settings.wb.floorTxtAlign = "center";
          }

          $scope.tim = $scope.meeting.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.meeting.info.bucket;
          if($scope.meeting.info.mbucket && $scope.meeting.info.mbucket != ""){
            $scope.cDetailBucket = $scope.meeting.info.mbucket;
          }
          //! No need to do this here start
          // $scope.dgList = angular.copy($scope.meeting.info.roomList);
          // angular.forEach($scope.dgList.d, function(d){
          //   if(!d.type){d.type = "d"};
          // });
          // angular.forEach($scope.dgList.r, function(r){
          //   if(!r.type){r.type = "r"};
          // });
          // $scope.dgrListCopy = angular.copy($scope.dgList);
          // $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);

          // if(!$scope.curRoomList.length){
          //   $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
          // } else if($scope.editRForm.isEdit){
          //   $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
          // };
          //! No need to do this here ends
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    else{
      // TODO: do detailLoading false 
      $scope.detailLoading = false;
      $rootScope.tabView = true;
      $scope.meeting.info = {
        label:"",
        roomList:{d:[], r:[]},
        activePeriod:{type:"a"},
        ctype:angular.copy($scope.ctype),
        settings:angular.copy($scope.settings),
        permission:{type:$scope.auth.upreferences.defaultP}
      };
    }
    $scope.subTab = 1;
    $scope.subTabFx = function(caller){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.subTab = caller;
      $scope.subLoading = true;
      if(caller == 1 && $scope.selectedT == "2"){
        MeetingSrv.getActiveList($scope.meeting.info.id).then(
          function(data){
            if(caller == 1){
            $scope.subLoading = false;
            $scope.meetingList = data.meeting;
            $scope.meetingListInfo = data.info;

            angular.forEach($scope.meetingList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });
            if(!$scope.meetingList.length){
              $scope.editMForm = {isShow:true, isAdd:true, isEdit:false};
            } else if($scope.editMForm.isEdit){
              $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
            }
            $scope.groupedMeetingFx();
          }
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      } else{
        MeetingSrv.getExpireList($scope.meeting.info.id).then(
          function(data){
            if(caller != 1 && $scope.selectedT == "2"){
            $scope.subLoading = false;
            $scope.meetingList = data.meeting;
            $scope.meetingListInfo = data.info;
            angular.forEach($scope.meetingList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });
            if($scope.editMForm.isEdit){
              $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
            }
            $scope.groupedMeetingFx();
          }
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      }
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.hasListErr = false;
      $scope.errType = "";
      if(caller == "m"){
        // TODO: new code
        $scope.selectedRoom.n = {d:[], dg:[], r:[]};
        $scope.curLogo.img = {};
        $scope.addMeeting = angular.copy($scope.defaultMeeting);
        $scope.dgList = angular.copy($scope.dgrListCopy);
      } else if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        // $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
      } else if(caller == "r"){
        // TODO: new code update the keys name
        $scope.roomCU = {l:"", fl:"", dt:"rb", type:"r"};
      }
    }

    $rootScope.selectedTabFx = function(caller){
      $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
      // console.warn($scope.selectedT);
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // if($scope.decId == 0){
        //   $scope.detailLoading = true;
        //   MeetingSrv.getMeeting($scope.decId).then(
        //     function(data){
        //       if($scope.selectedT == "1"){
        //         $scope.detailLoading = false;
        //         $scope.dgList = angular.copy(data.roomList);
        //         angular.forEach($scope.dgList.d, function(d){
        //           if(!d.type){d.type = "d"};
        //         });
        //         angular.forEach($scope.dgList.r, function(r){
        //           if(!r.type){r.type = "r"};
        //         });
        //         $scope.dgrListCopy = angular.copy($scope.dgList);
        //         $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
        //         $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //       }
        //     },
        //     function(err){
        //       $log.error(err);
        //       $scope.detailLoading = false;
        //     }
        //   );
        // }
        //! No need to call this API here ends
      } else if($scope.selectedT == "2"){
        if(caller == "sort"){
          $scope.subTabFx($scope.subTab);
        } else{
          $scope.subTabFx(1);
        }
        $scope.resetFx('m');
      } else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        MeetingSrv.getSSList($scope.meeting.info.id).then(
          function(data){
            if($scope.selectedT == "3"){
              $scope.detailLoading = false;
              $scope.ssList = data.screenSaver;
              if(!$scope.ssList.length){
                $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
              } else{
                $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
        $scope.resetFx('s');
      } else if($scope.selectedT == "4"){
        // TODO: new code
        var obj = {subCaller: "wMeetRL", caller: "availD", offset: 0, id: $scope.meeting.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // $scope.roomCU = {room:"", floor:"", dType:"rb", type:"r"};
        // MeetingSrv.getMeeting($scope.meeting.info.id).then(
        //   function(data){
        //     if($scope.selectedT == "4"){
        //       $scope.detailLoading = false;
        //       $scope.dgList = angular.copy(data.info.roomList);
        //       angular.forEach($scope.dgList.d, function(d){
        //         if(!d.type){d.type = "d"};
        //       });
        //       angular.forEach($scope.dgList.r, function(r){
        //         if(!r.type){r.type = "r"};
        //       });
        //       $scope.dgrListCopy = angular.copy($scope.dgList);
        //       $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
        //       if(!$scope.curRoomList.length){
        //         $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
        //       } else if($scope.editRForm.isEdit){
        //         $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
        //       };
        //     }
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here ends
      }
    }
    $rootScope.selectedTabFx();

    $scope.printDiv = function(divName, pageTitle){
      var printContents = document.getElementById(divName).innerHTML;
      var popupWin = window.open('', '_blank', 'width=600,height=800');
      popupWin.document.open();
      popupWin.document.write('<html><head><title>' + pageTitle + '</title><style type="text/css">html{height:100%;}body{padding:0;margin:0;font-family:\'Open Sans\',sans-serif;font-size:9px;font-weight:400;}.text-big{font-size:20px;margin:10px;}.text-center{text-align:center;}table{margin-bottom:0;border:1px solid #ddd;width:100%;max-width:100%;border-collapse:collapse;border-spacing:0;}th,td{padding:8px;vertical-align:top;border:1px solid #ddd;}.text-muted{color:#808080;}.marB5{margin-bottom:5px;}th,.text-bold{font-weight:600;}.text-sm{font-size:80%;}.bdr-btm-dashed{border-bottom:1px dashed #c7c7c7;padding-bottom:8px;margin-bottom:8px;}</style></head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
    }

    $scope.showCalendarFx = function(fx){
      $scope.currentPage += fx;
      $scope.generateCalendar($scope.preview.calendar[$scope.currentPage].label.split("|")[1], $scope.preview.calendar[$scope.currentPage].label.split("|")[0]);
    }

    $scope.generateCalendar = function(year, month){
      $scope.curMonth = month;
      $scope.startWeek = moment(new Date(year, month, 1)).startOf('month').week();
      $scope.endWeek = moment(new Date(year, month, 1)).endOf('month').week();
      if($scope.endWeek == 1){
        $scope.endWeek = 53;
      }

      $scope.curCalendar = [];
      for(var week = $scope.startWeek; week<=$scope.endWeek; week++){
        $scope.dateArr = [];
        for(var i=0; i<7; i++){
          $scope.dateArr.push(moment().week(week).startOf('week').clone().add(i, 'day'));
        }
        $scope.curCalendar.push({
          week:week,
          days:$scope.dateArr
        })
      }
    }

    $scope.meetingPrint = function(type){
      MeetingSrv.getMeetingCalendar($scope.meeting.info.id, type).then(
        function(data){
          $scope.currentPage = 0;
          $scope.preview = data;
          if($scope.preview.type == "m" && $scope.preview.calendar.length){
            $scope.generateCalendar($scope.preview.calendar[0].label.split("|")[1], $scope.preview.calendar[0].label.split("|")[0]);
          }
          ngDialog.open({
            template:"app/contentLibrary/widgets/popup/meetingPreview.html",
            width:1050,
            scope:$scope,
            closeByDocument:false
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Logo*/
    $scope.logoPopover = {templateUrl:"logo.html"};
    $scope.screenPopover = {templateUrl:"screen.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        console.warn("$scope.contentList ", $scope.contentList);
        
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      console.warn("$scope.curContent ", $scope.curContent);
      
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "2"){
          $scope.addMeeting.logo = $scope.curContent;
        } else if($scope.selectedT == "3"){
          $scope.addScreen.ss = $scope.curContent;
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "l"){
        $scope.addMeeting.logo = null;
      } else if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }
    $scope.saveRoomFx = function(){
      $scope.roomProcessing = true;
    }

    //Add Meeting
    $scope.custTime = moment().set('minute', '00').utc().format();
    $scope.defaultMeeting = {
      room:"",
      title:"",
      roomOpt:"d",
      showOnScreen:true,
      showOnWB:true,
      endTime:$scope.custTime,
      startTime:$scope.custTime,
      date:{startDate:moment()._d, endDate:moment()._d},
      // TODO: new code
      rc:0
    };

    $scope.addMeeting = angular.copy($scope.defaultMeeting);

    $scope.addMeetingFx = function(caller){
      $scope.errType = "";
      $scope.curMeeting = {};
      $scope.hasListErr = false;
      if($scope.id){
        $scope.meeting.info.id = $scope.id;
      }

      $scope.curDate = angular.element(document).find(".picker").val();
      $scope.curDate = $scope.curDate.split(" - ");
      $scope.addMeeting.date.startDate = moment($scope.curDate[0]).format("ddd MMM D YYYY HH:MM:SS [GMT]Z");
      $scope.addMeeting.date.endDate = moment($scope.curDate[1]).format("ddd MMM D YYYY HH:MM:SS [GMT]Z");

      $scope.copyAddMeeting = angular.copy($scope.addMeeting);
      $scope.copyAddMeeting.dateShow = {startDate:$scope.copyAddMeeting.date.startDate, endDate:$scope.copyAddMeeting.date.endDate};
      $scope.copyAddMeeting.date = {startDate:moment($scope.copyAddMeeting.date.startDate).format("L"), endDate:moment($scope.copyAddMeeting.date.endDate).format("L")};
      $scope.copyAddMeeting.startTime = moment($scope.copyAddMeeting.startTime).format();
      $scope.copyAddMeeting.endTime = moment($scope.copyAddMeeting.endTime).format();

      // ! no need to this code
      // if($scope.copyAddMeeting.roomOpt == "d"){
      //   $scope.copyAddMeeting.room = {d:$filter("filter")($scope.dgList.d, {selected:true}), g:$filter("filter")($scope.dgList.g, {selected:true}), r:$filter("filter")($scope.dgList.r, {selected:true})};
      // }

      if($scope.copyAddMeeting.title == ""){
        $scope.errType = "title";
        $scope.hasListErr = true;
        $("#title").focus();
        // TODO: change the keys
      } else if($scope.copyAddMeeting.roomOpt == 'd' && $scope.copyAddMeeting.rc == 0){
        $scope.errType = "room";
        $scope.hasListErr = true;
        $("#roomD").focus();
      } else if($scope.copyAddMeeting.roomOpt == 'c' && ($scope.copyAddMeeting.roomLabel == null || $scope.copyAddMeeting.roomLabel == "")){
        $scope.errType = "room";
        $scope.hasListErr = true;
        $("#roomLabel").focus();
      } else if($scope.copyAddMeeting.startTime == null){
        $scope.errType = "start";
        $scope.hasListErr = true;
        $("#startTime").focus();
      } else if($scope.copyAddMeeting.endTime == null){
        $scope.errType = "end";
        $scope.hasListErr = true;
        $("#endTime").focus();
      } else if(($scope.copyAddMeeting.date.startDate == $scope.copyAddMeeting.date.endDate) && ($scope.copyAddMeeting.startTime >= $scope.copyAddMeeting.endTime)){
        $scope.errType = "startEnd";
        $scope.hasListErr = true;
        $("#endTime").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.copyAddMeeting.startTime = $scope.copyAddMeeting.startTime.split("T")[1].split("+")[0].split("-")[0];
        $scope.copyAddMeeting.endTime = $scope.copyAddMeeting.endTime.split("T")[1].split("+")[0].split("-")[0];
        $scope.curMeeting = {info:{id:$scope.meeting.info.id}, meeting:$scope.copyAddMeeting};
        if($scope.curMeeting.meeting.roomOpt == "c"){
          $scope.curMeeting.meeting.room = "";
        } else if($scope.curMeeting.meeting.roomOpt == "d"){
          $scope.curMeeting.meeting.roomLabel = "";
          $scope.curMeeting.meeting.roomFloor = "";
        }
        MeetingSrv.addMeeting($scope.curMeeting).then(
          function(data){
            $scope.addMoreProcessing = false;
            $scope.addProcessing = false;
            $scope.id = data.id;
            if(data.timthumb){
              $scope.tim = data.timthumb;
            }
            if(caller == "s"){
              $scope.editMForm.isShow = false;
            } else{
              $scope.editMForm.isShow = true;
            }
            // TODO: new code
            $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}
            $scope.subTabFx($scope.subTab);
            $scope.resetFx('m');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.editFx = function(caller, data){
      if($scope.curDeviceObj.devices){
        $scope.curDeviceObj.devices = [];
      }
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:"", g:"", r:""};
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "m"){
        // TODO: new code
        $scope.selectedRoom.u = {d:[], dg:[], r:[]};
        $scope.editMForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addMeeting = angular.copy(data);
        // ! no need to this code
        // if($scope.addMeeting.roomOpt == "d"){
        //   $scope.dgList = angular.copy($scope.dgrListCopy);
        //   angular.forEach($scope.dgList.d, function(item){
        //     angular.forEach($scope.addMeeting.room.d, function(d){
        //       if(item.id === d.id){
        //         item.selected = true;
        //       }
        //     });
        //   });
        //   angular.forEach($scope.dgList.g, function(item){
        //     angular.forEach($scope.addMeeting.room.g, function(g){
        //       if(item.id === g.id){
        //         item.selected = true;
        //       }
        //     });
        //   });
        //   angular.forEach($scope.dgList.r, function(item){
        //     angular.forEach($scope.addMeeting.room.r, function(r){
        //       if(item.id === r.id){
        //         item.selected = true;
        //       }
        //     });
        //   });
        // }
        $scope.addMeeting.startTime = $scope.addMeeting.startTime;
        $scope.addMeeting.endTime = $scope.addMeeting.endTime;
      } else if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      } else if(caller == "r"){
        $scope.editRForm = {isShow:true, isAdd:false, isEdit:true};
        if(!data.type){
          data.type = "d";
        }
        $scope.roomCU = angular.copy(data);
      }
    }

    $scope.deleteOpen = function(caller, iId){
      $scope.removeProcessing = false;
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      MeetingSrv.delete($scope.meeting.info.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "m"){
            angular.forEach($scope.meetingList, function(list, index){
              if($scope.deleteObj.iId == list.mId){
                $scope.meetingList.splice(index, 1);
                $scope.groupedMeetingFx();
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
            if($scope.meetingList == 0 && $scope.subTab == 1){
              $scope.editMForm = {isShow:true, isAdd:true, isEdit:false};
            }
          } else if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          } else if($scope.deleteObj.caller == "r"){
            if(data.code == 8212){
              ngDialog.close();
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"cl.widget.meeting.m8" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            } else if(data.code == 8213){
              angular.forEach($scope.curRoomList, function(list, index){
                if($scope.deleteObj.iId == list.id){
                  $scope.curRoomList.splice(index, 1);
                  $scope.removeProcessing = false;
                  $scope.resetFx($scope.deleteObj.caller);
                  ngDialog.close();
                  if(!$scope.curRoomList.length){
                    $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
                  } else if($scope.editRForm.isEdit){
                    $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
                  }
                }
              });
              // angular.forEach($scope.dgList.r, function(list, index){
              //   if($scope.deleteObj.iId == list.id){
              //     $scope.dgList.r.splice(index, 1);
              //     $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
              //     $scope.dgrListCopy = angular.copy($scope.dgList);
              //     $scope.removeProcessing = false;
              //     $scope.resetFx($scope.deleteObj.caller);
              //     ngDialog.close();
              //     if(!$scope.curRoomList.length){
              //       $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
              //     } else if($scope.editRForm.isEdit){
              //       $scope.editRForm = {isShow:false, isAdd:false, isEdit:false}
              //     }
              //   }
              // });
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel,type){
      // var curModel = [];

      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });

      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dList = [];
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   });
      //   // angular.forEach($scope.dgList.d, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i=0; i<$scope.curDeviceObj.devices.length; i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      // }
      //! No need to here ends

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to here start
          // if(caller){
          //   if($scope.addScreen.d.length > 0){
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.curDeviceObj.availableDevices), devices:$scope.curDeviceObj.devices};
          //   } else {
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
          //   }
          // }
          //! No need to here ends
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wMeetSS", caller: "availD", offset: 0, id: $scope.meeting.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wMeetSS", caller: "selD", offset: 0, id: $scope.meeting.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: new code
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.errType = "";
      $scope.hasListErr = false;
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#label").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#contentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#deviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#duration").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.ssPostObj = {info:{id:$scope.meeting.info.id}, screenSaver:$scope.addScreen};
        MeetingSrv.addSS($scope.ssPostObj).then(
          function(data){
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.meeting.info.screenSaver = [];
      $scope.meeting.info.screenSaver = $scope.ssList;
    }

    /*Rooms*/
    $scope.roomCUOpen = function(caller, id){
      $scope.curRoomCU = $filter("filter")($scope.curRoomList, {id:id}, true);
      $scope.roomCUCopy = angular.copy($scope.curRoomCU[0]);
      $scope.addProcessing = false;
      $scope.hasPopErr = false;
      $scope.errType = "";

      ngDialog.open({
        template:"app/contentLibrary/widgets/popup/meetingRoomCU.html",
        width:600,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller == "$closeButton"){};
        }
      });
      if(caller == "a"){
        $scope.roomCU = {room:"", floor:"", dType:"rb", type:"r"};
      } else if(caller == "e"){
        $scope.roomCU = angular.copy($scope.curRoomCU[0]);
      }
    }

    $scope.roomCUFx = function(caller){
      $scope.hasPopErr = false;
      $scope.hasListErr = false;
      $scope.errType = "";
      // TODO: change the key name
      if(!$scope.roomCU.l || $scope.roomCU.l == ""){
        $scope.hasPopErr = true;
        $scope.hasListErr = true;
        $scope.errType = "room";
        $("#room").focus();
      } else{
        $scope.isDuplicateRoom = false;
        angular.forEach($scope.curRoomList, function(r){
          // TODO: change the kay name
          if(angular.lowercase(r.l) == angular.lowercase($scope.roomCU.l) && angular.lowercase(r.fl) == angular.lowercase($scope.roomCU.fl) && r.dt == $scope.roomCU.dt && r.type == $scope.roomCU.type && r.id != $scope.roomCU.id){
            $scope.isDuplicateRoom = true;
            return true;
          }
        });
        if(!$scope.isDuplicateRoom){
          if(caller == "s" || caller == "e"){
            $scope.addProcessing = true;
          } else{
            $scope.addMoreProcessing = true;
          }
          if(caller == "s" || caller == "sm"){
            MeetingSrv.addRoom({id:$scope.meeting.info.id, room:$scope.roomCU}).then(
              function(data){
                // ! no need to do this
                // $scope.dgList.r.push({id:data.id, room:$scope.roomCU.room, floor:$scope.roomCU.floor, dType:$scope.roomCU.dType, type:'r'});
                // $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
                // $scope.dgrListCopy = angular.copy($scope.dgList);
                // TODO: new code
                $scope.curRoomList.push({id:data.id, l:$scope.roomCU.l, fl:$scope.roomCU.fl, dt:$scope.roomCU.dt, type:'r'})
                $scope.addMoreProcessing = false;
                $scope.addProcessing = false;
                // TODO: new code
                $scope.subTabRL = 2;
                ngDialog.close();

                if(caller == "s"){
                  $scope.editRForm.isShow = false;
                } else{
                  $scope.editRForm.isShow = true;
                }
                $scope.resetFx("r");
              },
              function(err){
                $log.error(err);
                $scope.addMoreProcessing = false;
                $scope.addProcessing = false;
              }
            );
          } else if(caller == "e"){
            // TODO: added key name
            MeetingSrv.editRoom({id:$scope.meeting.info.id, l:$scope.roomCU}).then(
              function(data){
                $scope.addProcessing = false;
                if(data.code == 8214 || data.code == 8215){
                  if($scope.roomCU.type == "d"){
                    angular.forEach($scope.dgList.d, function(d, index){
                      // TODO: short key added
                      if(d.id == $scope.roomCU.id){
                        d.fl = $scope.roomCU.fl;
                        d.dt = $scope.roomCU.dt;
                      }
                    });
                  } else if($scope.roomCU.type == "r"){
                    angular.forEach($scope.dgList.r, function(rl, index){
                      // TODO: short key added
                      if(rl.id == $scope.roomCU.id){
                        rl.l = $scope.roomCU.l;
                        rl.fl = $scope.roomCU.fl;
                        rl.dt = $scope.roomCU.dt;
                      }
                    });
                  }
                  $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
                  $scope.dgrListCopy = angular.copy($scope.dgList);
                  ngDialog.close();
                  $scope.editRForm.isShow = false;
                  $scope.resetFx("r");
                }
              },
              function(err){
                $log.error(err);
                $scope.addProcessing = false;
              }
            );
          }
        } else{
          $scope.hasPopErr = true;
          $scope.hasListErr = true;
          $scope.errType = "roomExists";
        }
      }
    }

    $scope.roomUCFx = function(caller, room, index){
      $scope.roomUProcessing = false;
      $scope.hasPopErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "e"){
        $scope.roomCopy = angular.copy(room);
      } else if(caller == "u"){
        $scope.isDuplicateRoom = false;
        angular.forEach($scope.curRoomList, function(r){
          // TODO: change the key name
          if(angular.lowercase(r.l) == angular.lowercase(room.l) && angular.lowercase(r.fl) == angular.lowercase(room.fl) && r.dt == room.dt && r.type == room.type && r.id != room.id){
            $scope.isDuplicateRoom = true;
            return true;
          }
        });
        if(!$scope.isDuplicateRoom){
          MeetingSrv.editRoom({id:$scope.meeting.info.id, room:room}).then(
            function(data){
              if(data.code == 8214 || data.code == 8215){
                $scope.roomUProcessing = false;
                room.show = false;
              }
            },
            function(err){
              $log.error(err);
              $scope.roomUProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          $scope.errType = "roomExists";
        }
      } else if(caller == "c"){
        $scope.curRoomList.forEach(function(val, i){
          if(val.id == room.id){
            $scope.curRoomList[i] = $scope.roomCopy;
            return true;
          }
        });
        room.show = false;
        $scope.roomCopy.show = false;
      }
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $rootScope.selectedTabFx("sort");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.meetingFx = function(tab, caller){
      // TODO: new code
      $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      // console.warn($scope.meeting);
      if(tab == 1 || tab == 3 || tab == 4 || caller == "save"){
        if($scope.meeting.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.meeting.info.settings.rb.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#rbTitleSize").focus();
        } else if(!$scope.meeting.info.settings.rb.subtitleSize){
          $scope.errType = "stSize";
          $scope.hasErr = true;
          $("#rbSubtitleSize").focus();
        } else if(!$scope.meeting.info.settings.rb.timeSize){
          $scope.errType = "tsSize";
          $scope.hasErr = true;
          $("#rbTimeSize").focus();
        } else if($scope.meeting.info.settings.rb.sos.sType == "p" && !$scope.meeting.info.settings.rb.sos.prior){
          $scope.errType = "rbSosP";
          $scope.hasErr = true;
          $("#rbPrior").focus();
        } else if($scope.meeting.info.settings.rb.sos.eType == "a" && !$scope.meeting.info.settings.rb.sos.after){
          $scope.errType = "rbSosA";
          $scope.hasErr = true;
          $("#rbAfter").focus();
        } else if($scope.meeting.info.settings.wb.rotationOpt == "c" && $scope.meeting.info.settings.wb.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#wbCRotate").focus();
        } else if($scope.meeting.info.settings.wb.headerSize == null){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wbHeaderSize").focus();
        } else if($scope.meeting.info.settings.wb.titleSize == null){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#wbTitleSize").focus();
        } else if($scope.meeting.info.settings.wb.timeSize == null){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#wbTimeSize").focus();
        } else if($scope.meeting.info.settings.wb.roomSize == null){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#wbRoomSize").focus();
        } else if($scope.meeting.info.settings.wb.sos.sType == "p" && !$scope.meeting.info.settings.wb.sos.prior){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wbPrior").focus();
        } else if($scope.meeting.info.settings.wb.sos.eType == "a" && !$scope.meeting.info.settings.wb.sos.after){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wbAfter").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.meeting.info.fid = $scope.fid;
          $scope.meeting.info.toast = false;
          $scope.meeting.meetings = [];
          if(tab == 1 || tab == 3 || tab == 4){
            $scope.nextProcessing = true;
          } else{
            $scope.meeting.info.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveMeetingFx(tab);
            }, 250);
          } else{
            $scope.saveMeetingFx(tab);
          }
        }
      }
    }

    $scope.saveMeetingFx = function(tab){
      $scope.reponseLoad = true;
      $scope.meeting.info.fid = $scope.fid;
      $scope.meeting.info.tzOffset = $scope.curTimezone;
      //! No need to do this here start
      // $scope.tempRoomList = {d:[], r:[]};
      // angular.forEach($scope.curRoomList, function(rl){
      //   if(rl.type == "r"){
      //     $scope.tempRoomList.r.push(rl);
      //   } else{
      //     $scope.tempRoomList.d.push(rl);
      //   }
      // });
      // $scope.meeting.info.roomList.r = $scope.tempRoomList.r;
      // $scope.meeting.info.roomList.d = $scope.tempRoomList.d;
      //! No need to do this here ends
      // TODO: new code
      if($scope.meeting.info.roomList){
        delete $scope.meeting.info.roomList
      }

      if(!$scope.meeting.info.settings.wb.isRoom || !$scope.meeting.info.settings.wb.isFloor){
        $scope.meeting.info.settings.wb.isRF = false;
      }
      MeetingSrv.saveMeeting($scope.meeting).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.meeting.info.id = data.id;
          }
          if(tab == 1 || tab == 3 || tab == 4){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 4){
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $scope.tabFx(1, 'tabFx');
            $state.go("hub.contentLibrary.c");
          }
          $scope.reponseLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          $scope.reponseLoad = false;
        }
      );
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse,lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse,lType:'device'};
      }
    }

    //reset selected devices
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
           if($scope.selectedT != "3" && item.type == "Image" ){
              $scope.curArgsContent.push(item);
           } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
              $scope.curArgsContent.push(item);
           }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';
    $scope.loadingPaging = {}
    $scope.loadingMore = {}
    $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}

    $scope.subTabRL = 1;
    $scope.subTabRLFx = function(caller){
      $scope.subTabRL = caller;
      if(caller == 1){
        // TODO: new code
        var obj = {subCaller: "wMeetRL", caller: "availD", offset: 0, id: $scope.meeting.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
      }
    }

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    $scope.selectRoomItem = function(caller, value, id){
      if(!$scope.selectedRoom[$scope.roomViewObj.caller][caller].length){
        $scope.selectedRoom[$scope.roomViewObj.caller][caller].push(id);
      } else{
        if(value){
          $scope.selectedRoom[$scope.roomViewObj.caller][caller].push(id);
        } else{
          var index = $scope.selectedRoom[$scope.roomViewObj.caller][caller].indexOf(id);
          if (index !== -1) {
            $scope.selectedRoom[$scope.roomViewObj.caller][caller].splice(index, 1)[0];
          }
        }
      }
      $scope.addMeeting.rc = ($scope.selectedRoom[$scope.roomViewObj.caller].d.length + $scope.selectedRoom[$scope.roomViewObj.caller].dg.length + $scope.selectedRoom[$scope.roomViewObj.caller].r.length);
      $scope.addMeeting.room = angular.copy($scope.selectedRoom[$scope.roomViewObj.caller]);
    }

    // TODO get Scroll data for the event and room list tab
    $scope.getScrollListData = function(obj){
      if(obj.quadId == "ev"){
        $scope.detailPopupLoading = true;
      } else{
        $scope.roomListLoading = true;
      }
      $scope.detailListObj[obj.quadId] = {};
      $scope.scrollDataList[obj.quadId] = [];
      $scope.allScrollDataList[obj.quadId] = [];
      $scope.copyScrollObj[obj.quadId] = {};
      $scope.visibleObjects[obj.quadId] = [];
      $scope.haveMoreData[obj.quadId] = false;
      $scope.haveMoreSearchData[obj.quadId] = false;
      $scope.visibleData[obj.quadId] = [];
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.searchScroll[obj.quadId] = false;
      $scope.loadingMore[obj.quadId] = false;
      $scope.loadingPaging[obj.quadId] = true;

      $scope.detailListObj[obj.quadId] = {subCaller: obj.subCaller, caller: obj.caller, offset: obj.offset, id: obj.id, subCallerId: obj.subCallerId, quadId:obj.quadId};
      
      DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData[obj.quadId] = true;
          } else{
            $scope.haveMoreData[obj.quadId] = false;
          }

          if(obj.quadId == "ev"){
            var tempListUpdate = {
              d: data.d,
              dg: data.dg,
              r: data.r
            };
            if($scope.roomViewObj.caller == 'n'){
              if($scope.roomViewObjCopy.caller == 'u'){
                $scope.selectedRoom.n = {d:[], dg:[], r:[]}
              } else{
                angular.forEach(tempListUpdate, function (list, key) {
                  if(list.length){
                    list = $scope.updateArr(list, $scope.selectedRoom.n[key]);
                  }
                });
              }
            }
            if($scope.roomViewObj.caller == 'u'){
              if(($scope.selectedRoom.u.d.length + $scope.selectedRoom.u.dg.length +$scope.selectedRoom.u.r.length) > 0 && $scope.roomViewObjCopy.caller == $scope.roomViewObj.caller && $scope.roomViewObjCopy.id == $scope.roomViewObj.id){
                $scope.addMeeting.room = angular.copy($scope.selectedRoom.u);
              } else{
                $scope.selectedRoom.u = angular.copy(data.srl);
                $scope.addMeeting.room = angular.copy($scope.selectedRoom.u);
              }
              angular.forEach(tempListUpdate, function (list, key) {
                if(list.length){
                  list = $scope.updateArr(list, $scope.selectedRoom.u[key]);
                }
              });
            }
            if($scope.roomViewObj.caller == 'v'){
             angular.forEach(tempListUpdate, function (list, key) {
              if(list.length){
                angular.forEach(list, function (dObj) {
                   dObj.selected = true;
                });
              }
             });
            }
            $scope.selectedRoomCopy = angular.copy($scope.selectedRoom);
            
            $scope.dgList = {d:[], g:[], r:[]};
            $scope.dgList.g = angular.copy(data.dg);
            $scope.dgList.r = angular.copy(data.r);
          }
          if(obj.quadId == "rl"){
            $scope.curRoomList = data.r;
            angular.forEach($scope.curRoomList, function(item){
              item.type = "r"
            })
          }

          $scope.scrollDataList[obj.quadId] = data.d;
          $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.roomListLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
        },
        function(err){
          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.roomListLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
          $log.error(err);
        }
      );
    }

    // TODO room list popup
    $scope.roomViewObjCopy = {caller: "", id: undefined}
    $scope.roomListView = function(caller, id){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.roomViewObj = {caller: caller, id: id}
      if(caller && caller == "v"){
        var obj = {subCaller: "wMeetEvView", caller: "availD", offset: 0, id: $scope.meeting.info.id, subCallerId: id, quadId:"ev"};
      } else{
        if(id){
          var obj = {subCaller: "wMeetEv", caller: "availD", offset: 0, id: $scope.meeting.info.id, subCallerId: id, quadId:"ev"};
        } else{
          var obj = {subCaller: "wMeetEv", caller: "availD", offset: 0, id: $scope.meeting.info.id, subCallerId: 0, quadId:"ev"};
        }
      }
      $scope.getScrollListData(obj);
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/roomList.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          if(caller == 'c' || caller == '$closeButton'){
            $scope.selectedRoom = $scope.selectedRoomCopy;            
            if($scope.roomViewObj.caller != 'v'){
              $scope.addMeeting.rc = ($scope.selectedRoom[$scope.roomViewObj.caller].d.length + $scope.selectedRoom[$scope.roomViewObj.caller].dg.length + $scope.selectedRoom[$scope.roomViewObj.caller].r.length);
            }
            if($scope.roomViewObj.caller == 'u'){
              $scope.addMeeting.room = angular.copy($scope.selectedRoom[$scope.roomViewObj.caller]);
            }
          } else{
            $scope.roomViewObjCopy = angular.copy($scope.roomViewObj);
          }
        }
      });
    }

    $scope.selectRoomListFx = function(caller){
      ngDialog.close();
    }


    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.loadingMore[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: $scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        if($scope.searchScroll[obj.quadId]){
          $scope.detailListObj[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else if(data.d.length && data.d.length < 1000){
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.allScrollDataList[obj.quadId] = [];
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = 0;
        $scope.etIndex[obj.quadId] = 300;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.scrollDataList[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if(obj.text){          
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        }
  
        if(obj.text){
          $scope.searchScroll[obj.quadId] = true;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length && data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
  
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          $scope.haveMoreSearchData[obj.quadId] = false;
          $scope.searchScroll[obj.quadId] = false;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else{
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
              
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataList[obj.quadId] = [];
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
  
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = obj.st;
        $scope.etIndex[obj.quadId] = obj.et;
        $scope.visibleData[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
        setTimeout(function() {
          $scope.$apply();
        });
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      if($scope.selectedT == '2' || ($scope.selectedT == '4' && $scope.subTabRL == 1)){
        var text = val.toLowerCase();
        var scrollElement = document.querySelector("#scroll-container-"+quadId);
        if (!text && $scope.searchScroll[quadId]) {
          // TODO Enter when have newVal is empty and user perform search operation already
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else if (text && text.length >= 3) {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreData[quadId]) {
            // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
            // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
            var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj , function (item) {
              if(keys.indexOf(item.h) === -1){
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if(filteredObj.length && filteredObj.length >= 1000){
              $scope.haveMoreSearchData[quadId] = true;
            } else{
              $scope.haveMoreSearchData[quadId] = false;
            }

            if(quadId == "ev"){
              if($scope.roomViewObj.caller == "v"){
                if(filteredObj.length){angular.forEach(filteredObj, function(item){item.selected = true;})}
              }
              if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){filteredObj = $scope.updateArr(filteredObj, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
              }
            }
                        
            $scope.scrollDataList[quadId] = filteredObj;
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            if ($scope.scrollDataList[quadId].length <= 300) {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
            } else {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
            }
            $scope.searchScroll[quadId] = true;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          } else {
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          }
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('LiveStreamingController', LiveStreamingController);

  /** @ngInject */
  function LiveStreamingController($log, $rootScope, $scope, $state, $cookies, $timeout, LiveStreamingSrv, ContentLibrarySrv, ngDialog){
    $scope.fid = localStorage.getItem("curFId");
    $scope.curLangObj = {id:"", label:""};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.placeHolder = "https://moctobpltc-i.akamaihd.net/hls/live/571329/eight/playlist.m3u8";
    $scope.settings = {
      settings:{bg:"#073763", bga:1, capTxt:"#ffffff", capFont:$scope.fontFamilySelected, capSize:18},
      ctype:{hour:"monochrome", pickupt:"default", bg:"default", row:"monochrome", footer:"default"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      LiveStreamingSrv.getLiveStreaming($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.liveS = data;

          if(data.type != "hls"){
            $scope.settingsDefault();
          }

          if($scope.liveS.caption.length > 0){
            angular.forEach($scope.liveS.caption, function(item){
              item = item.lang = {id:item.id, label:item.label, url:item.url};
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.liveS = {label:"", type:"hls", url:"", caption:[], activePeriod:{type:"a"}, settings:angular.copy($scope.settings.settings), ctype:angular.copy($scope.settings.ctype), permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.settingsDefault = function(){
      $scope.liveS.settings = angular.copy($scope.defaultSettings.settings);
      $scope.liveS.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.liveStreamingFx = function(){
      $scope.liveS.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.liveS.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.liveS.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.liveS.type == "hls" && (!$scope.liveS.settings.capSize || $scope.liveS.settings.capSize == "")){
        $scope.errType = "capSize";
        $scope.hasErr = true;
        $("#capSize").focus();
      } else{
        $scope.isUrlEmpty = false;
        $scope.isLangEmpty = false;
        $scope.isSameLang = false;
        if($scope.liveS.type == "hls" && $scope.liveS.caption.length > 0){
          angular.forEach($scope.liveS.caption, function(item){
            if(!item.lang){
              $scope.isLangEmpty = true;
              return;
            }
            if(item.url == ""){
              $scope.isUrlEmpty = true;
              return;
            }
          });
          $scope.isSameLang = $scope.checkIfArrayIsUnique($scope.liveS.caption);
        }

        if($scope.liveS.type == "hls" && $scope.isLangEmpty){
          $scope.hasErr = true;
          $scope.errType = "eLang";
        } else if($scope.liveS.type == "hls" && $scope.isUrlEmpty){
          $scope.hasErr = true;
          $scope.errType = "eURL";
        } else if($scope.isSameLang){
          $scope.hasErr = true;
          $scope.errType = "langExist";
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveLiveStreamingFx();
            }, 250);
          } else{
            $scope.saveLiveStreamingFx();
          }
        }
      }
    }
    $scope.saveLiveStreamingFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.saveProcessing = true;
      $scope.captionArr = [];
      $scope.curLangArr = [];
      if($scope.liveS.type == "hls" && $scope.liveS.caption.length > 0){
        angular.forEach($scope.liveS.caption, function(item){
          $scope.captionArr.push({id:item.lang.id, label:item.lang.label, url:item.url});
          $scope.curLangArr.push(item);
        });
      }
      $scope.liveS.caption = angular.copy($scope.captionArr);
      $scope.confirmObj = angular.copy($scope.liveS);
      $scope.liveS.caption = $scope.curLangArr;

      LiveStreamingSrv.saveLiveStreaming($scope.confirmObj).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.checkIfArrayIsUnique = function(myArray){
      for(var i = 0; i < myArray.length; i++){
        for(var j = 0; j < myArray.length; j++){
          if(i != j){
            if(myArray[i].lang.id == myArray[j].lang.id){
              return true;
            }
          }
        }
      }
      return false; // means there are no duplicate values.
    }

    $scope.langObj = {languages:[]}
    $scope.openLanguageFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.popupLoading = true;
      LiveStreamingSrv.getCaptionsLang().then(
        function(data){
          $scope.popupLoading = false;
          $scope.langObj.languages = data;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );

      ngDialog.open({
        template:"app/contentLibrary/widgets/popup/captionLanguages.html",
        width:680,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default'
      });
    }

    $scope.langAddFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if(!$scope.curLangObj.label){
        $scope.hasErrPop = true;
        $scope.errTypePop = "label";
        $("#language").focus();
      } else{
        $scope.langProcessing = true;
        $scope.langDataLoading = true;
        ContentLibrarySrv.saveLanguage($scope.curLangObj).then(
          function(data){
            if (data.code == 8254){
              $scope.hasErrPop = true;
              $scope.errTypePop = "same";
              $scope.langProcessing = false;
              $scope.langDataLoading = false;
              $("#language").focus();
            } else if(data.code == 8258 || data.code == 8259){
              LiveStreamingSrv.getCaptionsLang().then(
                function(data){
                  $scope.langDataLoading = false;
                  $scope.langProcessing = false;
                  $scope.langObj.languages = data;
                  $scope.langResetFx();
                },
                function(err){
                  $scope.langDataLoading = false;
                  $scope.langProcessing = false;
                  $log.error(err);
                }
              );
            }
          },
          function(err){
            $scope.langProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.langEditFx = function(obj){
      $scope.curLangObj = angular.copy(obj);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.langResetFx = function(){
      $scope.curLangObj = {id:"", label:""};
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.langDeleteOpen = function(id){
      $scope.langDObj = {id:id, processing:false};
      $scope.dialogId = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.msg.44" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="langDeleteFx();" focus-me="true" ng-disabled="langDObj.processing"><span class="fa fa-repeat fa-spin" ng-if="langDObj.processing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.langDeleteFx = function(){
      $scope.langDObj.processing = true;
      ContentLibrarySrv.delLanguage($scope.langDObj.id).then(
        function(data){
          $scope.langDObj.processing = false;
          if(data.code == 8260){
            for(var i=0; i<$scope.langObj.languages.length; i++){
              if($scope.langObj.languages[i].id == $scope.langDObj.id){
                $scope.langObj.languages.splice(i, 1);
              }
            }
            $scope.dialogId.close();
          } else if(data.code == 8261){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.widget.ls.m4" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:420,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          }
        },
        function(err){
          $scope.langDObj.processing = false;
          $log.error(err);
        }
      );
    }

    $scope.getLanguage = function(){
      LiveStreamingSrv.getCaptionsLang().then(
        function(data){
          $scope.langObj.languages = data;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getLanguage();

    $scope.addRowFx = function(){
      $scope.liveS.caption.push({url:""});
    }
    $scope.confirmOpen = function(index){
      $scope.dataObj = {index:index};
      if($scope.liveS.caption[index].label && $scope.liveS.caption[index].url){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{\'cl.widget.ls.m6\' | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="removeCapFx(dataObj.index);" focus-me="true">\{{\'cm.btn.2\' | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.removeCapFx(index);
      }
    }
    $scope.removeCapFx = function(index){
      $scope.liveS.caption.splice(index, 1);
      ngDialog.close();
    }

    $scope.setPlaceHolderFx = function(){
      if($scope.liveS.type == "https"){
        $scope.placeHolder = "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4";
      } else if($scope.liveS.type == "rtsp"){
        $scope.placeHolder = "rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mov";
      } else if($scope.liveS.type == "yt"){
        $scope.placeHolder = "https://www.youtube.com/watch?v=l8q-2EKwgVo";
      } else if($scope.liveS.type == "udp"){
        $scope.placeHolder = "udp://@224.0.0.1:1234";
      } else{
        $scope.placeHolder = "https://moctobpltc-i.akamaihd.net/hls/live/571329/eight/playlist.m3u8";
      }
    }

    $scope.infoOpen = function(){
      $scope.dialogId = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.ls.p.1" | translate}}</h1></header>\
            <div class="panel-body">\
              <p class="marB25">{{"cl.widget.ls.p.2" | translate}}</p>\
              <h5 role="subHeading">{{"cl.widget.ls.p.3" | translate}}</h5>\
              <p class="bdr-top-dashed marT5 marB25">{{"cl.widget.ls.p.3-1" | translate}}</p>\
              <h5 role="subHeading">{{"cl.widget.ls.p.4" | translate}}</h5>\
              <p class="bdr-top-dashed marT5 marB25">{{"cl.widget.ls.p.4-1" | translate}}</p>\
              <h5 role="subHeading">{{"cl.widget.ls.p.5" | translate}}</h5>\
              <p class="bdr-top-dashed marT5 marB25">{{"cl.widget.ls.p.5-1" | translate}}</p>\
              <h5 role="subHeading">{{"cl.widget.ls.p.6" | translate}}</h5>\
              <p class="bdr-top-dashed marT5 noMarB">{{"cl.widget.ls.p.6-1" | translate}}</p>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
              </sapn>\
            </footer>\
          </section>',
        plain:true,
        width:650,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default'
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('LinkedInController', LinkedInController);

  /** @ngInject */
  function LinkedInController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, $interval, LinkedInSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, rt:false, ab:false, at:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#0b5394", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, rowText:"#444444", altRowText:"#444444", rowFont:$scope.fontFamilySelected, altRowFont:$scope.fontFamilySelected},
      ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", rowText:"monochrome",  altRowText:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.in.settings = angular.copy($scope.defaultSettings.settings);
      $scope.in.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      LinkedInSrv.getLinkedIn($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.in = data;
          $scope.companyList = data.companyList;
          if($scope.companyList && $scope.companyList.length > 0){
            $scope.companyShow = true;
            // $scope.in.company = $filter("filter")($scope.companyList, {isSelected:true})[0];
          }
          if(!$scope.in.ctype){
            $scope.in.settings = angular.copy($scope.settings.settings);
            $scope.in.ctype = angular.copy($scope.settings.ctype);
          } else{
            $scope.settings.settings = angular.copy($scope.in.settings);
            $scope.settings.ctype = angular.copy($scope.in.ctype);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.in = {labelOpt:"a", label:"", postCount:10, dType:"t", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
      if($scope.selectedT == "1"){}
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      // var newWindow = window.open("https://www.linkedin.com/m/logout/", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      
      var timeout = setTimeout(
        function(){
          if(timeout){
            clearTimeout(timeout);
          }
          // newWindow.close();
          // var newWindow = window.open("https://www.linkedin.com/m/logout/", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
          // setTimeout(
          //   function(){
          //     newWindow.close();
            $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
            $scope.childWindowInt = $interval($scope.checkChild, 500);
          // }, 2000);
        }, 500);
      return false;
    }


    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        LinkedInSrv.getInVerify($scope.in.id).then(
          function(data){
            $scope.errType = "";
            $scope.hasErr = false;
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "authFailed";
              return;
            }
            if(data.auth){
              $scope.in.auth = data.auth;
            }
            if(data.code == 8179){
              $scope.hasErr = true;
              $scope.authSuccess = false;
              $scope.errType = "companyEmpty";
              $scope.companyList = [];
              $scope.companyShow = false;
              return;
            } else{
              $scope.companyList = data.companyList;
              $scope.companyShow = true;
              if(data.isClosed){
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.authSuccess = false;
                $scope.errType = "authFailed";
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.inFx = function(tab, caller){
      $scope.in.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
      }
      if($scope.in.labelOpt == "c" && $scope.in.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.in.postCount){
        $scope.errType = "pc";
        $scope.hasErr = true;
        $("#pc").focus();
      } else if($scope.in.dType == "t" && $scope.in.settings.rotationOpt == "c" && !$scope.in.settings.rotate){
        $scope.errType = "rotate";
        $scope.hasErr = true;
        $("#cRotate").focus();
      } else if($scope.in.dType == "t" && $scope.in.settings.hTextOpt == "c" && !$scope.in.settings.hText){
        $scope.errType = "hText";
        $scope.hasErr = true;
        $("#hText").focus();
      } else if(tab == 1){
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveLinkedInFx();
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $scope.saveLinkedInFx();
          $scope.isPEOpen = false;
        }
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveLinkedInFx(caller);
          }, 250);
        } else{
          $scope.saveLinkedInFx(caller);
        }
      }
    }

    $scope.saveLinkedInFx = function(caller){
      if(caller == "save"){
        $scope.in.toast = true;
      } else{
        $scope.in.toast = false;
      }
      if(caller == "save" && !$scope.companyList){
        $scope.hasErr = true;
        $scope.errType = "authEmpty";
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.companyList.length > 0 && !$scope.in.company){
        $scope.hasErr = true;
        $scope.errType = "company";
        $scope.saveProcessing = false;
      } else{
        $scope.in.companyList = null;
        LinkedInSrv.saveLinkedIn($scope.in).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.in.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(caller == "save"){
              $state.go("hub.contentLibrary.c");
            } else{
              $scope.tabFx(2, 'tabFx');
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }
  }
})();
(function(){
    'use strict';

    angular
      .module('hub')
      .controller('JciMapController', JciMapController);

    /** @ngInject */
    function JciMapController($log, $rootScope, $scope, $state, $cookies, $timeout, JciMapSrv){
      $scope.colorPicker = {b:false, hb:false, ht:false, rb:false, rt:false, arb:false, art:false};
      $scope.fid = localStorage.getItem("curFId");
      $scope.saveProcessing = false;
      $scope.detailLoading = false;
      $scope.chLoading = false;
      $scope.isPEOpen = false;
      $scope.encId = "";
      $scope.decId = "";
      $scope.wcList = [];
      $scope.wcGetId = 0;

    //   $scope.list = {
    //     settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#6fa8dc", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#6fa8dc", subtitleText:"#999999", descText:"#444444", altTitleText:"#6fa8dc", altSubtitleText:"#999999", altDescText:"#444444", rowFont:$scope.fontFamily[56], altRowFont:$scope.fontFamily[56], headerSize:26, titleSize:16, subtitleSize:16, descSize:18},
    //     ctype:{headerBg:"monochrome", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"default", descText:"monochrome", altTitleText:"default", altDescText:"monochrome"}
    //   }

    //   $scope.textMedia = {
    //     settings:{
    //       bg:"#ffffff", bga:1, align:"l", textBg:"#ffffff", textBga:1, titleText:"#6fa8dc", descText:"#444444", titleSize:16, descSize:18, titleFont:$scope.fontFamilySelected, descFont:$scope.fontFamilySelected, rotationOpt:"a", rotate:12
    //     },
    //     ctype:{bg:"monochrome", textBg:"monochrome", text:"default", descText:"monochrome"}
    //   }

    //   $scope.media = {
    //     settings:{bg:"#ffffff", bga:1, rotationOpt:"a", rotate:12},
    //     ctype:{bg:"monochrome"}
    //   }

    //   $scope.defaultSettingsList = angular.copy($scope.list);
    //   $scope.defaultSettingstextMedia = angular.copy($scope.textMedia);
    //   $scope.defaultSettingsmedia = angular.copy($scope.media);

    //   $scope.settingsDefault = function(){
    //     if($scope.jci.dType == "l"){
    //       $scope.list = angular.copy({settings:$scope.defaultSettingsList.settings, ctype:$scope.defaultSettingsList.ctype});
    //     } else if($scope.jci.dType == "t"){
    //       $scope.textMedia = angular.copy({settings:$scope.defaultSettingstextMedia.settings, ctype:$scope.defaultSettingstextMedia.ctype});
    //     } else{
    //       $scope.media = angular.copy({settings:$scope.defaultSettingsmedia.settings, ctype:$scope.defaultSettingsmedia.ctype});
    //     }
    //   }

      $scope.settings = {reloadOpt:"n", reload:"", kType:false};
      $scope.defaultSettings = angular.copy($scope.settings);

      $scope.settingsDefault = function(){
        $scope.jci.settings = angular.copy($scope.defaultSettings);
      }

      if($state.params.id){
        $scope.decId = $scope.hubDecrypt($state.params.id);
        $scope.encId = $state.params.id;
        $scope.detailLoading = true;
        $scope.chLoading = true;
        JciMapSrv.getJciMap($scope.decId).then(
          function(data){
            $scope.jci = data;
            // if(!data.dType){
            //   $scope.jci.dType = "t"
            // }
            if(!$scope.jci.settings.kType){
              $scope.jci.settings.kType = false;
            }
            // if($scope.jci.dType == "l"){
            //   $scope.list.settings = angular.copy($scope.jci.settings);
            //   $scope.list.ctype = angular.copy($scope.jci.ctype);
            // } else if($scope.jci.dType == "t"){
            //   $scope.textMedia.settings = angular.copy($scope.jci.settings);
            //   $scope.textMedia.ctype = angular.copy($scope.jci.ctype);
            //   if(!$scope.jci.settings.rotationOpt){
            //     $scope.textMedia.settings.rotationOpt = "a"
            //     $scope.textMedia.settings.rotate = 12
            //   }
            // } else if($scope.jci.dType == "m"){
            //   $scope.media.settings = angular.copy($scope.jci.settings);
            //   $scope.media.ctype = angular.copy($scope.jci.ctype);
            //   if(!$scope.jci.settings.rotationOpt){
            //     $scope.media.settings.rotationOpt = "a"
            //     $scope.media.settings.rotate = 12
            //   }
            // }
            $scope.detailLoading = false;
          }, function(err){
            $log.error(err);
          }
        );
      } else{
        $rootScope.tabView = true;
        $scope.chLoading = true;
        $scope.jci = {
          label:"", kiosk:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}, settings:angular.copy($scope.settings)
        //   ctype:angular.copy($scope.textMedia.ctype)
        };
      }
      JciMapSrv.getKioskList().then(
        function(data){
          $scope.chLoading = false;
          $scope.kioskList = data;
        }, function(err){
          $log.error(err);
        }
      );

      $scope.kioskSearchFocus = function(){
        $scope.searchKiosk = {kioskName:""};
        if($scope.kioskList.length > 1){
          angular.element(document).find(".findSearch").children()[0].focus();
        }
      }

    //   $rootScope.changeKioskSetting = function(k){
    //     $scope.jci.kiosk = k
    //     angular.element(document).find('.customSelectKiosk').removeClass('open')
    //   }
      $scope.singleKioskFx = function(k){
        $scope.jci.kiosk = k;
      }
      $scope.jciMapFx = function(){
        $scope.jci.fid = $scope.fid;
        $scope.hasErr = false;
        $scope.errType = "";

        // if($scope.jci.dType == "l"){
        //   $scope.jci.settings = angular.copy($scope.list.settings);
        //   $scope.jci.ctype = angular.copy($scope.list.ctype);
        // } else if($scope.jci.dType == "t"){
        //   $scope.jci.settings = angular.copy($scope.textMedia.settings);
        //   $scope.jci.ctype = angular.copy($scope.textMedia.ctype);
        // } else if($scope.jci.dType == "m"){
        //   $scope.jci.settings = angular.copy($scope.media.settings);
        //   $scope.jci.ctype = angular.copy($scope.media.ctype);
        // }

        if($scope.jci.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.jci.kiosk == "" && !$scope.jci.settings.kType){
          $scope.errType = "kiosk";
          $scope.hasErr = true;
        // } else if($scope.jci.dType === "l" && $scope.jci.settings.reloadOpt == 'c' && !$scope.jci.settings.reload){
        //   $scope.errType = "reload";
        //   $scope.hasErr = true;
        // } else if($scope.jci.settings.rotationOpt == 'c' && !$scope.jci.settings.rotate){
        //   $scope.errType = "rotate";
        //   $scope.hasErr = true;
        // } else if($scope.jci.dType === "l" && !$scope.jci.settings.headerSize){
        //   $scope.errType = "hSize";
        //   $scope.hasErr = true;
        // } else if($scope.jci.dType === "l" && !$scope.jci.settings.subtitleSize){
        //   $scope.errType = "sSize";
        //   $scope.hasErr = true;
        // } else if(($scope.jci.dType === "l" || $scope.jci.dType === "t") && !$scope.jci.settings.titleSize){
        //   $scope.errType = "tSize";
        //   $scope.hasErr = true;
        // } else if(($scope.jci.dType === "l" || $scope.jci.dType === "t") && !$scope.jci.settings.descSize){
        //   $scope.errType = "dSize";
        //   $scope.hasErr = true;
        } else if($scope.jci.settings.reloadOpt == "c" && ($scope.jci.settings.reload == "" || $scope.jci.settings.reload == null)){
          $scope.errType = "reloadEmpty";
          $scope.hasErr = true;
        } else if($scope.jci.settings.reloadOpt == "c" && $scope.jci.settings.reload && $scope.jci.settings.reload < 10){
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveJciMapFx();
            }, 250);
          } else{
            $scope.saveJciMapFx();
          }
        }
      }
      $scope.saveJciMapFx = function(){
        if($scope.jci.settings.kType){
          delete $scope.jci.kiosk;
        }
        JciMapSrv.saveJciMap($scope.jci).then(
          function(data){
            $scope.saveProcessing = false;
            $state.go("hub.contentLibrary.c");
          }, function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }
  })();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('IoTButtonController', IoTButtonController);

  /** @ngInject */
  function IoTButtonController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, ngDialog, IoTButtonSrv, ContentLibrarySrv){
    $scope.colorPicker = {b:false, sep:false, tt:false, nt:false, qtt:false, qBg:false, qt:false, ab:false, at:false};
    $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.dgList = {d:[]};
    $scope.ssList = [];
    $scope.curBg = {};
    $scope.search = {text:""};

    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{
        bg:"#ffffff", bga:1,
        orientation:"l", grid:50, qcol:3, qmax:6, hd:10, sep:"#eeeeee",
        title:"Please proceed to counter #", titleText:"#0b5394", titleFont:$scope.fontFamily[51], titleSize:60,
        numText:"#ff9900", numFont:$scope.fontFamily[50], numSize:300,
        qTitle:"Other available counters:", qtText:"#0b5394", qtFont:$scope.fontFamily[51], qtSize:60,
        qBg:"#ff9900", qBga:0.2, qText:"#0b5394", qFont:$scope.fontFamily[50], qSize:100,
        altBg:"#0b5394", altBga:0.2, altText:"#0b5394", altFont:$scope.fontFamily[50], altSize:100
      },
      ctype:{bg:"monochrome", sep:"monochrome", tt:"basic", nt:"basic", qtt:"default", qBg:"monochrome", qText:"monochrome", altBg:"monochrome", altText:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.iot.settings = angular.copy($scope.defaultSettings.settings);
      $scope.iot.ctype = angular.copy($scope.defaultSettings.ctype);
      $scope.removeImgFx();
    }

    $scope.defaultIoT = {id:"", p:"", v:"", s:""};
    $scope.addIoT = angular.copy($scope.defaultIoT);

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.id = $scope.decId;
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      IoTButtonSrv.getIoT($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.iot = data;

          $scope.tim = $scope.iot.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.iot.otherinfo.bucket;
          if($scope.iot.otherinfo.mbucket && $scope.iot.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.iot.otherinfo.mbucket;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.iot = {
        label:"", bgImg:"", list:[], activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }


    $scope.addPMFx = function(caller){
      $scope.hasListErr = false;
      $scope.errType = false;
      if($scope.addIoT.p == ""){
        $scope.hasListErr = true;
        $scope.errType = "placement";
        $("#placement").focus();
      } else{
        if($scope.editForm.isEdit){
          for(var i=0; i<$scope.iot.list.length; i++){
            if($scope.iot.list[i].id == $scope.addIoT.id){
              $scope.iot.list[i] = $scope.addIoT;
            }
          };
        } else{
          $scope.addIoT.id = Number(Math.floor(Math.random()*1000) +""+ Math.floor(Math.random()*1000));
          $scope.iot.list.push($scope.addIoT);
        }
        $scope.addIoT = angular.copy($scope.defaultIoT);
        if(caller == "s"){
          $scope.editForm.isShow = false;
        } else{
          $scope.editForm.isShow = true;
        }
      }
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.hasListErr = false;
      $scope.errType = false;
      if(caller == "pm"){
        $scope.editForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addIoT = angular.copy(data);
      } else if(caller == "s"){
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      }
    }

    $scope.resetFx = function(caller){
      $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
      $scope.editForm = {isShow:true, isAdd:true, isEdit:false};
      $scope.addIoT = angular.copy($scope.defaultIoT);
      $('.widgetForm').scrollTop(0);
      $scope.hasListErr = false;
      $scope.errType = "";
      if(caller == "s"){
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
      }
    }

    $scope.deleteProcessing = false;
    $scope.deleteOpen = function(caller, id){
      $scope.deleteObj = {caller:caller, id:id};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.deleteFx = function(){
      if($scope.deleteObj.caller == "s"){
        IoTButtonSrv.delete($scope.id, $scope.deleteObj.caller, $scope.deleteObj.id).then(
          function(data){
          angular.forEach($scope.ssList, function(list, index){
            if($scope.deleteObj.id == list.sId){
              $scope.ssList.splice(index, 1);
              $scope.removeProcessing = false;
              $scope.resetFx($scope.deleteObj.caller);
              ngDialog.close();
            }
          });
        });
      } else{
        angular.forEach($scope.iot.list, function(list){
          if($scope.deleteObj.id == list.id){
            $scope.iot.list.splice($scope.iot.list.indexOf(list), 1);
          }
        });
      }
      ngDialog.close();
    }

    $rootScope.selectedTabFx = function(){
      $scope.hasListErr = false;
      $scope.errType = "";
      if($scope.selectedT=="2"){
        if(!$scope.iot.list.length){
          $scope.editForm = {isShow:true, isAdd:true, isEdit:false};
        } else if($scope.editForm.isEdit){
          $scope.editForm = {isShow:false, isAdd:false, isEdit:false};
        } else{
          $scope.editForm = {isShow:false, isAdd:false, isEdit:false};
        }
      } else if($scope.selectedT=="3"){
        $scope.detailLoading = true;
        IoTButtonSrv.getSSList($scope.iot.id).then(
          function(data){
            $scope.detailLoading = false;
            $scope.ssList = data.screenSaver;
            if(!$scope.ssList.length){
              $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
            } else{
              $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
    }

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      if($rootScope.soundObj.type=="audio"){
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Audio"){
            $scope.curImages.push(item);
          }
        });
      } else{
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
            $scope.curImages.push(item);
          }
          if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
            $scope.curVideos.push(item);
          }
        });
      }
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(caller){
      $scope.useContentErr = {empty:false};
      $rootScope.soundObj = {type:caller};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($rootScope.soundObj.type == "audio"){
          if($scope.selectedT == "2"){
            $scope.addIoT.s = $scope.curContent;
          } else{
            $scope.iot.sound = $scope.curContent;
          }
        } else{
          if($scope.selectedT == "3"){
            $scope.addScreen.ss = $scope.curContent;
          } else{
            $scope.iot.bgImg = $scope.curContent;
            $scope.iot.isHidden = 0;
          }
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(){
      $scope.addScreen.ss = null;
      $scope.iot.bgImg = {};
    }
    $scope.removeAudioFx = function(caller){
      if(caller=="pm"){
        $scope.addIoT.s = null;
      } else{
        $scope.iot.sound = {};
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModels){
      var curModel = [];
      angular.forEach(curModels, function(item){
        curModel.push(angular.fromJson(item));
      });

      if(caller == "add"){
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      $rootScope.dList = [];
    }

    $scope.addScreensaverFx = function(caller){
      $scope.errType = "";
      $scope.hasListErr = false;
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#asLabel").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#asContentBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#asDuration").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.ssPostObj = {info:{id:$scope.iot.id}, screenSaver:$scope.addScreen};
        IoTButtonSrv.addSS($scope.ssPostObj).then(
          function(data){
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editForm.isShow = false;
            } else{
              $scope.editForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.iot.screenSaver = [];
      $scope.iot.screenSaver = $scope.ssList;
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        if($rootScope.soundObj.type == "audio"){
          angular.forEach(args.content, function(item){
            if(item.type == "Audio"){
              $scope.curArgsContent.push(item);
            }
          });
        } else{
          angular.forEach(args.content, function(item){
            if($scope.selectedT == "1" && item.type == "Image"){
              $scope.curArgsContent.push(item);
            } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
              $scope.curArgsContent.push(item);
            }
          });
        }
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.advSearch = false;
            $scope.updateList();
          },
          function(err){
            $scope.contentLibraryLoading = false;
            $log.error(err);
          }
        );
      }
    });

    $scope.iotFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || tab == 3 || caller == "save"){
        if($scope.iot.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.iot.settings.grid){
          $scope.errType = "grid";
          $scope.hasErr = true;
          $("#grid").focus();
        } else if(!$scope.iot.settings.qcol){
          $scope.errType = "qcol";
          $scope.hasErr = true;
          $("#qcol").focus();
        } else if(!$scope.iot.settings.qmax){
          $scope.errType = "qmax";
          $scope.hasErr = true;
          $("#qmax").focus();
        } else if(!$scope.iot.settings.hd){
          $scope.errType = "hd";
          $scope.hasErr = true;
          $("#sTimeOut").focus();
        } else if(!$scope.iot.settings.titleSize){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#titleSize").focus();
        } else if(!$scope.iot.settings.numSize){
          $scope.errType = "numSize";
          $scope.hasErr = true;
          $("#numSize").focus();
        } else if(!$scope.iot.settings.qtSize){
          $scope.errType = "qtSize";
          $scope.hasErr = true;
          $("#qtSize").focus();
        } else if(!$scope.iot.settings.qSize){
          $scope.errType = "qSize";
          $scope.hasErr = true;
          $("#qSize").focus();
        } else if(!$scope.iot.settings.altSize){
          $scope.errType = "altSize";
          $scope.hasErr = true;
          $("#altSize").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.iot.toast = false;
          if(tab == 1 || tab == 3){
            $scope.nextProcessing = true;
          } else{
            $scope.iot.toast = true;
            $scope.saveProcessing = true;
          }

          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveIoTFx(tab);
            }, 250);
          } else{
            $scope.saveIoTFx(tab);
          }
        }
      }
    }

    $scope.saveIoTFx = function(tab){
      $scope.iot.fid = $scope.fid;
      $scope.iot.screenSaver = $scope.ssList;
      IoTButtonSrv.saveIoT($scope.iot).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.iot.id = data.id;
          }
          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(tab == 1 || tab == 3){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
 (function(){
  'use strict';

  angular
    .module('hub')
    .controller('InteractiveMenuController', InteractiveMenuController);

  /** @ngInject */
  function InteractiveMenuController($log, $rootScope, $scope, $state, $document, $cookies, $filter, $timeout, ngDialog, ContentLibrarySrv, InteractiveMenuSrv){
    $scope.colorPicker = {bc:false, bt:false, bb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.hiddenContent = false;
    $scope.iMenu = {"menus":[]};
    $scope.isLoading = true;
    $scope.treeErr = false;
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";
    $scope.renderedMenu = 0;
    $scope.search = {text:""};

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(365);
      $scope.selectedHeight = $scope.getAvailableHeight(365);
    } else{
      $scope.selectedHeight = Math.round($scope.getAvailableHeight(425) * 0.4);
      $scope.quadHeight = Math.round($scope.getAvailableHeight(425) * 0.6);
    }

    $scope.settings = {
      settings:{btnW:400, btnH:80, btnBg:"#ffffff", btnBga:1, btnFontSize:24, btnTxt:"#000000", btnTxtAlign:"left", btnBdrOpt:true, btnBdr:"#ffffff", btnBdrSize:4, btnBdrRadius:1, icon:true, iconPosition:"left"},
      ctype:{btnBg:"monochrome", btnText:"monochrome", btnBdr:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.iMenu.settings = angular.copy($scope.defaultSettings.settings);
      $scope.iMenu.ctype = angular.copy($scope.defaultSettings.ctype);
    }


    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.text = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.text;
      }
    }
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      InteractiveMenuSrv.getInteractiveMenu($scope.decId).then(
        function(data){
          $scope.iMenu = data;
          $scope.detailLoading = false;
          $scope.tim = $scope.iMenu.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.iMenu.otherinfo.bucket;
          if($scope.iMenu.otherinfo.mbucket && $scope.iMenu.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.iMenu.otherinfo.mbucket;
          }

          if(!$scope.iMenu.ctype){
            $scope.iMenu.settings = angular.copy($scope.settings.settings);
            $scope.iMenu.ctype = angular.copy($scope.settings.ctype);
          } else{
            $scope.settings.settings = angular.copy($scope.iMenu.settings);
            $scope.settings.ctype = angular.copy($scope.iMenu.ctype);
          }

          angular.forEach($scope.iMenu.menus, function(item){
            item.curCount = 0;
            angular.forEach(item.target, function(target){
              if(target.hidden){
                item.curCount++;
              }
            });
          });
          $scope.menuArr = $scope.iMenu.menus;
          $scope.parentChange();
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.iMenu = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        menus:[{id:"m1", label:"Menu1", parent:"", curCount:0, target:[]}],
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      }
    }

    //Add new menu
    $scope.iMenuCount = $scope.iMenu.menus.length;
    $scope.addMenuFx = function(){
      $scope.iMenuCount++;
      $scope.iMenu.menus.push({
        id:"m" + new Date().getTime(),
        label:"Menu" + $scope.iMenuCount,
        parent:"",
        target:[]
      });
      $scope.parentChange();
    }
    $scope.removeMenuRow = function(index){
      $scope.deletedMenuId = $scope.iMenu.menus[index].id;
      if($scope.iMenu.menus.length > 1){
        $scope.iMenu.menus.splice(index, 1);
        for(var i = 0; i < $scope.iMenu.menus.length; i++){
          if($scope.iMenu.menus[i].parent == $scope.deletedMenuId){
            $scope.iMenu.menus[i].parent = "";
          }
        }
        $scope.parentChange();
      }
    }

    $scope.iconPopover = {templateUrl:"iconPopover.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      if($scope.curItem.caller == "i"){
        $scope.contentList = $filter("filter")($scope.contentLibrary.contentLibrary.content, {type:"Image"}, true); //For normal Content
      } else if($scope.curItem.caller == "t"){
        $scope.contentLibraryLoading = false;
        $rootScope.selectedItems = [];
        $scope.breadCrumbs = [];
        $scope.folderList = [];

        if($scope.contentLibrary.info){
          $scope.bucket = $scope.contentLibrary.info.bucket;
          $scope.tim = $scope.contentLibrary.info.timthumb;

          $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
          if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
            $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
          }
          $scope.contentInfo = {tim:$scope.tim, cBucket:$scope.cBucket, cDetailBucket:$scope.cDetailBucket};
          $rootScope.$broadcast("contentInfo", $scope.contentInfo);
        }

        if($scope.contentLibrary.info.breadCrumbs){
          $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        }
        if($scope.contentLibrary.contentLibrary.folder){
          $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
        }
        if($scope.contentLibrary.contentLibrary.content){
          $scope.contentList = $scope.contentLibrary.contentLibrary.content;
        }
      }
    }

    $scope.getApprovedFx = function(){
      if($scope.isLoading){
        $scope.contentLoading = true;
        $scope.openingLoading = true;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.isLoading = false;
            $scope.updateList();
          },
          function(err){
            $scope.contentLoading = false;
            $scope.openingLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.updateList();
      }
    }

    $scope.selectContentOpen = function(id, caller){
      $scope.curItem = {id:id, caller:caller};
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      $scope.getApprovedFx();
      if(caller == "i"){
        $scope.search = {text:""};
        ngDialog.open({
          template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
          width:845,
          scope:$scope,
          closeByDocument:false
        });
      } else if(caller == "t"){
        $scope.selectedContent = {id:id, content:"", count:0};
        angular.forEach($scope.iMenu.menus, function(item){
          if(item.id == id){
            $scope.selectedContent.count = item.curCount;
            $scope.selectedContentCopy = angular.copy(item.target);
            $scope.selectedContent.content = angular.copy($scope.selectedContentCopy);
          }
        })
        $scope.contentObj = {
          thumbParam:$scope.thumbParam,
          quadHeight:$scope.quadHeight,
          thumbBigParam:$scope.thumbBigParam,
          selectedHeight:$scope.selectedHeight,
          isSplitV:$scope.auth.upreferences.isSplitV
        };
        ngDialog.open({
          template:'app/contentLibrary/widgets/popup/iMenuContentList.html',
          width:'90%',
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false
        });
      }
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.searchChangeFx("empty");
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }

    $scope.useContentFx = function(caller){
      if(caller == "t"){
        angular.forEach($scope.iMenu.menus, function(item){
          if($scope.selectedContent.id == item.id){
            item.target = $scope.selectedContent.content;
          }
        });
      } else{
        if($scope.curBg == ""){
          $scope.useContentErr.empty = true;
        } else{
          angular.forEach($scope.iMenu.menus, function(item){
            if($scope.curItem.id == item.id){
              item.icon = $scope.curBg;
            }
          });
        }
      }
      ngDialog.close();
    }

    $scope.removeContentFx = function(id, caller, i){
      if(caller == "i"){
        angular.forEach($scope.iMenu.menus, function(item){
          if(id == item.id){
            item.icon = "";
          }
        });
      } else if(caller == "t"){
        angular.forEach($scope.selectedContent.content, function(item, index){
          if(id == item.id && index == i){
            $scope.selectedContent.content.splice($scope.selectedContent.content.indexOf(item), 1);
          }
        });
        angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
          if($(item).attr('data-id') == id){
            $(item).removeClass('ui-selected');
            $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
          }
        });
      }
    }

    $scope.folderBriefFx = function(){ /* Do nothing */ }

    $scope.briefFx = function(){
      for(var i = 0; i < $rootScope.selectedItems.length; i++){
        if($rootScope.selectedItems[i].type != 'folder' && $rootScope.selectedItems[i].type != 'shortcut'){
          for(var j = 0; j < $scope.contentList.length; j++){
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){
              $scope.selectedContent.content.push({
                isAccessible:true,
                id:$scope.contentList[j].id,
                fid:$scope.contentList[j].fid,
                url:$scope.contentList[j].url,
                type:$scope.contentList[j].type,
                extn:$scope.contentList[j].extn,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                width:$scope.contentList[j].width,
                hidden:$scope.contentList[j].hidden,
                height:$scope.contentList[j].height,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                isCompleted:$scope.contentList[j].isCompleted,
                MajorVersion:$scope.contentList[j].MajorVersion,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              break;
            }
          }
        }
      }
    }

    $scope.sortCallback = function(e, ui, index){
      $scope.selectedContentCopy = angular.copy($scope.selectedContent.content);
      $scope.tempContentList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0; i < $scope.selectedContentCopy.length; i++){
          if($scope.selectedContentCopy[i].id == $(this).attr("data-id")){
            $scope.tempContentList.push($scope.selectedContentCopy[i]);
            $scope.selectedContentCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.selectedContent.content = [];
      $scope.$apply(function(){
        $scope.selectedContent.content = angular.copy($scope.tempContentList);
      });
    }

    $scope.iMenuFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if(tab == 1){
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function (){
              $scope.tabFx(2);
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $scope.tabFx(2);
            $scope.isPEOpen = false;
          }
        } else{
          if($scope.iMenu.label != "" && $scope.iMenu.settings.btnW != null && $scope.iMenu.settings.btnH != null && $scope.iMenu.settings.btnFontSize != null && $scope.iMenu.settings.btnBdrSize != null && $scope.iMenu.settings.btnBdrRadius != null){
            $scope.iMenu.fid = $scope.fid;
            $scope.labelEmpty = false;
            angular.forEach($scope.iMenu.menus, function(item){
              if(item.label == ""){
                $scope.labelEmpty = true;
              }
            });
            if($scope.labelEmpty){
              $scope.errType = "title";
              $scope.hasErr = true;
              $("#title").focus();
            } else if($scope.treeErr){
              $scope.errType = "tree";
              $scope.hasErr = true;
              $("#tree").focus();
            } else{
              $scope.saveProcessing = true;
              $scope.saveIMenuFx();
            }
          } else{
            $scope.errType = "allFields";
            $scope.hasErr = true;
          }
        }
      }
    }

    $scope.saveIMenuFx = function(){
      InteractiveMenuSrv.saveInteractiveMenu($scope.iMenu).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.menuArr = $scope.iMenu.menus;
    $scope.htmStr = "";
    $scope.treeArr = [];
    $scope.curArr = [];

    $scope.createChild = function($arr){
      $scope.renderedMenu = 0;
      $scope.htmStr += "<ul class='list-unstyled tree'>";
      for(var i = 0; i < $arr.length; i++){
        $scope.renderedMenu++;
        $scope.htmStr += '<li><span class="' + $arr[i].id + '" ng-mouseenter="menuHighlight($event, \'' + $arr[i].id + '\')">' + $arr[i].label + '</span>';
        $scope.findChild($arr[i].id);
        $scope.htmStr += "</li>";
      }
      $scope.htmStr += "</ul>";

      if($scope.menuArr.length != $scope.renderedMenu){
        $scope.treeErr = true;
      } else{
        $scope.treeErr = false;
      }
    }

    $scope.findChild = function($id){
      for(var i = 0; i < $scope.curArr.length; i++){
        if($scope.curArr[i].parent == $id){
          $scope.renderedMenu++;
          $scope.htmStr += '<ul class="list-unstyled tree"><li><span class="' + $scope.curArr[i].id + '" ng-mouseenter="menuHighlight($event, \'' + $scope.curArr[i].id + '\')">' + $scope.curArr[i].label + '</span>';
          $scope.findChild($scope.curArr[i].id);
          $scope.htmStr += "</li></ul>";
        }
      }
    }

    $scope.parentChange = function(){
      $scope.treeArr = [];
      $scope.curArr = [];
      $scope.htmStr = "";
      for(var i = 0; i < $scope.menuArr.length; i++){
        if($scope.menuArr[i].parent == ""){
          $scope.treeArr.push({
            id:$scope.menuArr[i].id,
            label:$scope.menuArr[i].label,
            parent:"",
            target:[]
          });
        } else{
          $scope.curArr.push({
            id:$scope.menuArr[i].id,
            label:$scope.menuArr[i].label,
            parent:$scope.menuArr[i].parent,
            target:[]
          });
        }
      }
      if($scope.menuArr.length > 0 && $scope.treeArr.length == 0){
        $scope.treeErr = true;
      } else{
        $scope.treeErr = false;
        $scope.createChild($scope.treeArr);
      }
    }
    $scope.parentChange();

    $scope.menuHighlight = function(e, id){
      $document.find('.tree li span').removeClass('menuHover');
      $document.find('.table .row').removeClass('rowHover');
      $(".table .row#" + id).addClass('rowHover');
      $(e.currentTarget).addClass('menuHover');
    }

    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.loading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SBController', SBController);

  /** @ngInject */
  function SBController($log, $rootScope, $scope, $state, $timeout, $filter, ngDialog, ContentLibrarySrv, TemplatesSrv, SBSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.timestamp = moment().format('x');
    $scope.templatesLoading = true;
    $scope.openingLoading = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.advancedShow = true;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.btnList = [
      {id:1, label:"Home", icon:"", isRemovable:true, content:""},
      {id:2, label:"Map & Facilities", icon:"", isRemovable:false, content:""},
      {id:3, label:"Message Board", icon:"", isRemovable:true, content:""},
      {id:4, label:"Food & Dining", icon:"", isRemovable:true, content:""},
      {id:5, label:"Workplace Services", icon:"", isRemovable:true, content:""},
      {id:6, label:"Commute", icon:"", isRemovable:true, content:""},
      // {id:1, label:"Home", icon:"", isRemovable:true, url:"https://ptk1staging.westeurope.cloudapp.intel.com/PTK1PublicDisplay/#/home/restaurants?buildingId=912&tenantId=1&timezone=Asia%2FJerusalem"},
      // {id:2, label:"Map & Facilities", icon:"", isRemovable:false, url:""},
      // {id:3, label:"Message Board", icon:"", isRemovable:true, url:"https://ptk1staging.westeurope.cloudapp.intel.com/PTK1PublicDisplay/#/bulletin?floorno=9&buildingId=912&tenantId=1&displayArea=Cafeteria"},
      // {id:4, label:"Food & Dining", icon:"", isRemovable:true, url:"https://ptk1staging.westeurope.cloudapp.intel.com/PTK1PublicDisplay/#/food_and_dining?buildingId=912&tenantId=1&displayArea=Cafeteria"},
      // {id:5, label:"Workplace Services", icon:"", isRemovable:true, url:"https://ptk1staging.westeurope.cloudapp.intel.com/PTK1PublicDisplay/#/services?floorno=9&buildingId=912&tenantId=1&displayArea=Cafeteria"},
      // {id:6, label:"Commute", icon:"", isRemovable:true, url:"https://ptk1staging.westeurope.cloudapp.intel.com/PTK1PublicDisplay/#/park_and_ride?buildingId=912&tenantId=1&displayArea=Cafeteria"},
    ];

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      SBSrv.getSB($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.sb = data;
          $scope.tim = $scope.sb.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.sb.otherinfo.bucket;
          if($scope.sb.otherinfo.mbucket && $scope.sb.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.sb.otherinfo.mbucket;
          }
          $scope.tBucket = $scope.tDetailBucket = $scope.sb.otherinfo.tBucket;
          if($scope.sb.otherinfo.tmBucket && $scope.sb.otherinfo.tmBucket != ""){
            $scope.tDetailBucket = $scope.sb.otherinfo.tmBucket;
          }
          if($scope.sb.templates && $scope.sb.templates.length){
            angular.forEach($scope.sb.templates, function(item){
              item.st = $filter("momentTime")(item.st);
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.sb = {label:"", templates:[], activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:{btnList:angular.copy($scope.btnList), isDefault:2}
      };
    }

    /*list item*/
    $scope.btnActionsFx = function(data){
      if(data.c == "a"){
        var highestNumber = Math.max.apply(null, $scope.sb.settings.btnList.map(function(item){
          return item.id;
        }));
        $scope.sb.settings.btnList.push({id:highestNumber+1, label:"Button-"+(highestNumber+1), icon:"", isRemovable:true, content:""});
      } else if(data.c == "cp"){
        $scope.dataObj = data;
        ngDialog.open({
          template:'\
            <section class="panel">\
              <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="btnActionsFx({c:\'r\'});" focus-me="true">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else if(data.c == "r"){
        angular.forEach($scope.sb.settings.btnList, function(list){
          if(list.isRemovable && list.id == $scope.dataObj.id){
            if($scope.sb.settings.isDefault == $scope.dataObj.id){
              $scope.sb.settings.isDefault = 2;
            }
            $scope.sb.settings.btnList.splice($scope.sb.settings.btnList.indexOf(list), 1);
            ngDialog.close($scope.dialogId);
          }
        });
      }
    }

    $scope.sortCallback = function(){
      $scope.copyBtnList = angular.copy($scope.sb.settings.btnList);
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      var btnMap = $scope.copyBtnList.reduce(function(map, obj) {
        map[obj.id] = obj;
        return map;
      }, {});
      
      var sortedArray = $scope.curId.map(function(id) {
          return btnMap[id];
      }).filter(Boolean); // Removes undefined values if any `id` is not found.

      // Assign the new sorted array without duplicates
      $scope.sb.settings.btnList = [];
      $scope.sb.settings.btnList = sortedArray;
    }

    /*ICON*/
    /*Select Content*/
    $scope.selectContentOpen = function(id, caller){
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      $scope.curContentId = id;
      $scope.curContent = "";
      // TODO below variable define the advance search call from the icon or content
      $rootScope.advSearchType = caller;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList(caller);
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:1000,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback: function(){
          $scope.openingLoading = false;
        }
      });
    }

    /*Select Template*/
    $scope.selectTemplatesOpen = function(){
      $scope.templatesLoading = true;
      $scope.openingLoading = true;
      $scope.advancedShow = false;
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      $scope.flTId = 0;


      TemplatesSrv.getTemplatesContent($scope.flTId).then(
        function(data){
          // $scope.curTemplates = data;
          $scope.templates = data;
          $scope.updateList("t");
        },
        function(err){
          $scope.templatesLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/templateList.html',
        width:1000,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback: function(){
          $scope.openingLoading = false;
        }
      });
    }

    $scope.folderBriefFx = function(caller, id, splId, type){
    }

    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item, index){
        if(item.type == "template"){
          $scope.curItem = $scope.templateList.filter(function(obj){return obj.id == item.id;})[0];
          if($scope.curItem.isApproved){
            $scope.sb.templates.push({id:item.id + Math.floor((Math.random() * 10000) + 1), st:"", et:null,
              t:{id:item.id, type:"template", label:$scope.curItem.label, userid:$scope.auth.uid, thumb:$scope.curItem.thumb, thumbV:$scope.curItem.thumbV, duration:$scope.curItem.duration, isCompleted:$scope.curItem.isCompleted, fullscreen:false, mute:$scope.mic, hidden:0}
            });
          } else{
            angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(liItem){
              if($(liItem).attr('data-id') == item.id){
                $(liItem).removeClass('ui-selected');
              }
            });
          }
        }
      });
    }

    /*Content / Teamplate*/
    $scope.folderContentFx = function(fId, splId, splType, a){
      $scope.search = {text:""};
      if($scope.selectedT == "1"){
        $scope.contentLoading = true;
        ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
          function(data){
            $scope.contentLibrary = data;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.flId = fId;
            $scope.updateList($rootScope.advSearchType);
          },
          function(err){
            $scope.contentLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedT == "2"){
        $scope.templatesLoading = true;
        $rootScope.selectedItems = [];

        $scope.contextMenuOpt = [];
        $scope.templates = {};
        localStorage.setItem("curSBTFId", fId);
        TemplatesSrv.getTemplatesContent(fId).then(
          function(data){
            $scope.templates = data;
            $scope.flTId = fId;
            $scope.updateList("t");
          },
          function(err){
            $scope.templatesLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.updateList = function(caller){
      if($scope.selectedT == "1"){
        $scope.contentLoading = false;
        $scope.openingLoading = false;
        $scope.breadCrumbs = [];
        $scope.folderList = [];
        $scope.tim = $scope.contentLibrary.info.timthumb;
        $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
          $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        }
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
        if(caller == 'i'){
          $scope.curImages = [];
          angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
            if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
              $scope.curImages.push(item);
            }
          });
          $scope.contentList = $scope.curImages;
        } else{
          $scope.contentList = [];
          angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
            if(item.type == "Image" || item.type == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || (item.splType && (item.splType == "Image" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD" || item.splType == "Vector")) || (item.type == "Widget" && (item.extn == "Microsoft Power BI"|| item.extn == "Live Streaming"|| item.extn == "Vimeo" || item.extn == "YouTube" || item.extn === "Web Page" || item.extn === "Date Time" || item.extn === "Filler Content" || item.extn === "QR Code" || item.extn === "News" || item.extn === "Quotes" || item.extn === "Stock Price" || item.extn === "Static Text" || item.extn === "Weather" || item.extn === "Meetings" || item.extn === "Microsoft Outlook Calendar" || item.extn === "Google Calendar"))){
              $scope.contentList.push(item);
            }
          });
        }
      

        // if($scope.contentLibrary.info.timthumb){
        //   $scope.tim = $scope.contentLibrary.info.timthumb;
        // }
        // if($scope.contentLibrary.info.thumbSize){
        //   $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
        // }
        // if($scope.contentLibrary.info.breadCrumbs){
        //   $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        // }
        // if($scope.contentLibrary.info.bucket){
        //   $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        // }
        // if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        //   $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        // }
        // $scope.folderList = $scope.contentLibrary.contentLibrary.folder;        
      } else if($scope.selectedT == "2"){
        $scope.templatesLoading = false;
        $scope.openingLoading = false;
        $scope.templateList = [];
        $scope.breadCrumbs = [];
        $scope.folderList = [];

        if($scope.templates.info.timthumb){
          $scope.tim = $scope.templates.info.timthumb;
        }
        // if($scope.templates.info.thumbSize){
        //   $scope.thumbSize = $scope.templates.info.thumbSize; //sm, n, md, lg, xl
        // }
        if($scope.templates.info.breadCrumbs){
          $scope.breadCrumbs = $scope.templates.info.breadCrumbs;
        }
        if($scope.templates.info.bucket){
          $scope.tBucket = $scope.tDetailBucket = $scope.templates.info.bucket;
        }
        if($scope.templates.info.mbucket && $scope.templates.info.mbucket != ""){
          $scope.tDetailBucket = $scope.templates.info.mbucket;
        }

        $scope.folderList = $scope.templates.templates.folder;

        // $scope.templateList = $scope.templates.templates.template;
        angular.forEach($scope.templates.templates.template, function(template){
          if(template.isApproved === 1){
            $scope.templateList.push(template);
          }
        });
      }
    }

    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      if($scope.selectedT == "1"){
        $scope.useContentErr = {empty:false};
        $scope.contentLoading = true;
        $scope.curContent = "";

        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
              $scope.loading = false;
              $scope.updateList($rootScope.advSearchType);
            },
            function(err){
              $scope.contentLoading = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
              $scope.loading = false;
              $scope.updateList($rootScope.advSearchType);
            },
            function(err){
              $scope.contentLoading = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
      }
      else if($scope.selectedT == "2"){
        $scope.templatesLoading = true;
        $scope.advancedShow = false;
        TemplatesSrv.getTemplatesContent($scope.flTId).then(
          function(data){
            // $scope.curTemplates = data;
            $scope.advSearch = false;
            $scope.templates = data;
            $scope.loading = false;
            $scope.updateList("t");
          },
          function(err){
            $scope.templatesLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.folderid ? listItem.folderid : listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              // isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.hasErr = false;
        $scope.errType = "";
        angular.forEach($scope.sb.settings.btnList, function(list){
          if(list.id == $scope.curContentId){
            if($rootScope.advSearchType === 'i'){
              list.icon = $scope.curContent;
            } else{
              list.content = $scope.curContent;
            }
          }
        });
        ngDialog.close();
      }
    }
    $scope.removeIconFx = function(id, caller){
      angular.forEach($scope.sb.settings.btnList, function(list){
        if(list.id == id){
          if(caller === 'i'){
            list.icon = "";
          } else{
            list.content = "";
          }
        }
      });
    }

    /*list item*/
    $scope.removeTemplateFx = function(data){
      if(data.c == "cp"){
        $scope.tempObj = data;
        ngDialog.open({
          template:'\
            <section class="panel">\
              <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeTemplateFx({c:\'r\'});" focus-me="true">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else if(data.c == "r"){
        angular.forEach($scope.sb.templates, function(list){
          if(list.id == $scope.tempObj.id){
            $scope.sb.templates.splice($scope.sb.templates.indexOf(list), 1);
            ngDialog.close($scope.dialogId);
          }
        });
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.searchChangeFx("empty");
      $rootScope.selectedItems = [];
      $scope.advancedShow = true;
      $scope.search = {text:""};

      if(args.info.module == "cl"){
        $scope.contentList = [];
        $scope.folderList = [];
        $scope.advSearchInfo = args.info;
        $scope.folderList = args.folder;
        $scope.contentLibrary.contentLibrary.folder = [];
        $scope.contentLibrary.contentLibrary.folder = args.folder;
        if(args.content){
          $scope.curArgsContent = [];
          angular.forEach(args.content, function(item){
            if($rootScope.advSearchType === 'i'){
              if(item.type == "Image"){
                $scope.curArgsContent.push(item);
              }
            } else{
              if(item.type == "Image" || item.type == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || (item.splType && (item.splType == "Image" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD" || item.splType == "Vector")) || (item.type == "Widget" && (item.extn == "Microsoft Power BI"|| item.extn == "Live Streaming"|| item.extn == "Vimeo" || item.extn == "YouTube" || item.extn === "Web Page" || item.extn === "Date Time" || item.extn === "Filler Content" || item.extn === "QR Code" || item.extn === "News" || item.extn === "Quotes" || item.extn === "Stock Price" || item.extn === "Static Text" || item.extn === "Weather" || item.extn === "Meetings" || item.extn === "Microsoft Outlook Calendar" || item.extn === "Google Calendar"))){
                $scope.curArgsContent.push(item);
              }
            }
          });
          $scope.contentList = $scope.curArgsContent;
        }
        if(!$scope.contentList.length && !$scope.folderList.length){
          $scope.advSearchInfo.isEmpty = true;
        }
        $scope.contentLibrary.contentLibrary.content = $scope.contentList;

        $scope.advSearch = true;
        if(args.code == 8118){
          $scope.contentLibraryLoading = true;
          $scope.contentLoading = true;

          if($scope.flId){
            ContentLibrarySrv.getFolderApprovedContent($scope.flId).then( 
              function(data){
                $scope.contentLibrary = data;
                $scope.advSearch = false;
                $scope.updateList($rootScope.advSearchType);
              },
              function(err){
                $scope.contentLibraryLoading = false;
                $log.error(err);
              }
            );
          } else{
            ContentLibrarySrv.getApproved().then(
              function(data){
                $scope.contentLibrary = data;
                $scope.advSearch = false;
                $scope.updateList($rootScope.advSearchType);
              },
              function(err){
                $scope.contentLibraryLoading = false;
                $log.error(err);
              }
            );
          }
        }
      } else{
        $scope.advancedShow = true;
        $scope.folderList = [];

        $scope.advSearchInfo = args.info;

        if(args.template){
          $scope.templateList = args.template.filter(function(item){
            if(item.isApproved == 1){
              return item;
            }
          });
        }
        $scope.folderList = args.folder;
        $scope.advSearch = true;

        if(args.code == 8118){
          $scope.templatesLoading = true;
          TemplatesSrv.getTemplatesContent($scope.flTId).then(
            function(data){
              $scope.templates = data;
              $scope.advSearch = false;
              $scope.updateList("t");
            },
            function(err){
              $log.error(err);
            }
          );
        }

      }
    });


    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.text = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.text;
      }
    }


    $scope.sbFx = function(caller){
      $scope.sb.fid = $scope.fid;
      // $scope.copySB = angular.copy($scope.sb);
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "save"){
        if($scope.sb.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          var emptyData = $scope.sb.settings.btnList.filter(function(item){
            if(item.label == ""){
              $scope.errType = "label";
              return item.label == "";
            }
            //  else if(item.isRemovable && item.url == ""){
            //   $scope.errType = "url";
            //   return (item.isRemovable && item.url == "");
            // }
          });
          if(emptyData.length){
            $scope.hasErr = true;
          }
        }

        // else if(caller == "save" && $scope.sb.templates.length){
        //   var isSTEmpty = false;
        //   for(var i=0; i < $scope.sb.templates.length; i++){
        //     if($scope.sb.templates && !$scope.sb.templates[i].st){
        //       $scope.errType = "st";
        //       $scope.hasErr = true;
        //       isSTEmpty = true;
        //       break;
        //     }
        //   }

        //   if(!isSTEmpty){
        //     for(var i=0; i < $scope.copySB.templates.length; i++){
        //       var curSt = moment($scope.copySB.templates[i].st).format();
        //       $scope.copySB.templates[i].st = curSt.split("T")[1].split("+")[0].split("-")[0];
        //       var curStTemp = $scope.copySB.templates[i].st.split(":");
        //       $scope.copySB.templates[i].tempSt = curStTemp[0] + curStTemp[1];
        //     }

        //     for(var i=0; i < $scope.copySB.templates.length; i++){
        //       if($filter('filter')($scope.copySB.templates, { tempSt:$scope.copySB.templates[i].tempSt }).length > 1){
        //         $scope.errType = "stol";
        //         $scope.hasErr = true;
        //         break;
        //       }
        //     }
        //   }
        // }

        if(!$scope.hasErr){
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(caller == "save"){
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveSBFx(caller);
              }, 250);
            } else{
              $scope.saveSBFx(caller);
            }
          }
        }
      }
    }

    $scope.saveSBFx = function(caller){
      $scope.copySB = angular.copy($scope.sb);
      $scope.errType = "";
      $scope.hasErr = false;
      $scope.saveProcessing = true;
      if(caller == "save"){
        $scope.copySB.toast = true;
      } else{
        $scope.copySB.toast = false;
      }
      SBSrv.saveSB($scope.copySB).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.copySB.id = data.id;
          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $rootScope.selectedTabFx = function(){
      $scope.openingLoading = false;
      $scope.timestamp = moment().format('x');
    };

    $rootScope.$on('ngDialog.closed', function(e, $dialog){
      $scope.openingLoading = false;
      $scope.$apply();
    });

    $scope.cancelPromise = function(){}

    $scope.openContentFolderFx = function(id, fId, type, splId, splType, gid, gType){
      localStorage.setItem("curPathId", id);
      localStorage.setItem('curPathFId', true);
      localStorage.setItem('curFId', fId);
      localStorage.setItem('curDFId', fId);
      localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
      if(gType){
        localStorage.setItem("curGroupId", gid);
        localStorage.setItem("curGroupType", gType);
      }
      $state.go("hub.contentLibrary.c");
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('IntelCircuitRssController', IntelCircuitRssController);

  /** @ngInject */
  function IntelCircuitRssController($log, $rootScope, $scope, $state, $cookies, $timeout, IntelCircuitRssSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, arb:false, tt:false, dt:false, att:false, adt:false, bc:false, tc:false, takeoverS:{b:false, hb:false, ht:false, mb:false, mt:false}};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.rssCrawl = "";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settingsNormal = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, titleText:"#3d85c6", descText:"#444444", rowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18, takeover:false, takeoverS:{bg:"#cc0000", bga:1,hBg:"#ffffff", hBga:1, hText:"#cc0000", hFont:{label:"Century Gothic", value:"century gothic"}, hSize:110, mBg:"#ffff00", mBga:1, mText:"#000000", mFont:{label:"Century Gothic", value:"century gothic"}, mSize:90, ctype:{bg:"default", hb:"monochrome", ht:"default", mb:"basic", mt:"monochrome"}}},
      ctype:{headerBg:"monochrome", headerText:"monochrome", bg:"monochrome", rowBg:"monochrome", titleText:"default", descText:"monochrome"}
    };
    $scope.settingsCrawl = {
      settings:{speed:100, bg:"#000000", bga:1, bullet:"#990000", titleText:"#ffffff", font:$scope.fontFamilySelected, dir:"rl", align:"l", fontSize:16, fontSizeOpt:"a"},
      ctype:{bg:"monochrome", bullet:"default", titleText:"monochrome"}
    };

    $scope.defaultNormal = angular.copy($scope.settingsNormal);
    $scope.defaultCrawl = angular.copy($scope.settingsCrawl);

    $scope.settingsDefault = function(){
      if($scope.iCircuit.dType == "normal"){
        $scope.iCircuit.settings = angular.copy($scope.defaultNormal.settings);
        $scope.iCircuit.ctype = angular.copy($scope.defaultNormal.ctype);
      } else if($scope.iCircuit.dType == "crawl"){
        $scope.iCircuit.settings = angular.copy($scope.defaultCrawl.settings);
        $scope.iCircuit.ctype = angular.copy($scope.defaultCrawl.ctype);
      }
    }

    $scope.changeDType = function(caller){
      $scope.iCircuit.settings = {};
      $scope.iCircuit.ctype = {};
      if(caller == "normal"){
        $scope.iCircuit.settings = angular.copy($scope.settingsNormal.settings);
        $scope.iCircuit.ctype = angular.copy($scope.settingsNormal.ctype);
      }
      else if(caller == "crawl"){
        $scope.iCircuit.settings = angular.copy($scope.settingsCrawl.settings);
        $scope.iCircuit.ctype = angular.copy($scope.settingsCrawl.ctype);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      IntelCircuitRssSrv.getIntelCircuit($scope.decId).then(
        function(data){
          $scope.iCircuit = data;
          $scope.detailLoading = false;
          if($scope.iCircuit.dType == "normal"){
            if(!$scope.iCircuit.settings.takeover){
              $scope.iCircuit.settings.takeover = false;
            }
            $scope.settingsNormal.settings = angular.copy($scope.iCircuit.settings);
            $scope.settingsNormal.ctype = angular.copy($scope.iCircuit.ctype);

          }
          else if($scope.iCircuit.dType == "crawl"){
            if(!$scope.iCircuit.settings.dir){
              $scope.iCircuit.settings.dir = "rl";
            }
            if(!$scope.iCircuit.settings.fontSizeOpt){
              $scope.iCircuit.settings.fontSizeOpt = "a";
              $scope.iCircuit.settings.fontSize = 16;
            }
            $scope.settingsCrawl.settings = angular.copy($scope.iCircuit.settings);
            $scope.settingsCrawl.ctype = angular.copy($scope.iCircuit.ctype);
          }
          $scope.dTypeCopy = angular.copy($scope.iCircuit.dType);
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.iCircuit = {
        label:"", dType:"normal",
        settings:angular.copy($scope.settingsNormal.settings),
        ctype:angular.copy($scope.settingsNormal.ctype),
        activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.directionFx = function(){
      if(!$scope.iCircuit.settings.align){
        $scope.iCircuit.settings.align = "l";
      }
      if(!$scope.iCircuit.settings.fontSize || $scope.iCircuit.settings.fontSize == ""){
        $scope.iCircuit.settings.fontSize = 16;
      }
    }

    $scope.rssFx = function(){
      $scope.iCircuit.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.iCircuit.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
      } else if($scope.iCircuit.dType == "crawl" && !$scope.iCircuit.settings.speed){
        $scope.errType = "crawl";
        $scope.hasErr = true;
      } else if($scope.iCircuit.dType === "crawl" && ($scope.iCircuit.settings.dir == "bt" || $scope.iCircuit.settings.fontSizeOpt == "c") && $scope.iCircuit.settings.fontSize == null){
        $scope.errType = "fSizeText";
        $scope.hasErr = true;
      } else if($scope.iCircuit.settings.rotationOpt == "c" && !$scope.iCircuit.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
      } else if($scope.iCircuit.dType == 'normal' && $scope.iCircuit.settings.hTextOpt == "c" && $scope.iCircuit.settings.hText == ""){
        $scope.errType = "hText";
        $scope.hasErr = true;
      } else if($scope.iCircuit.dType == 'normal' && (($scope.iCircuit.settings.takeover && ($scope.iCircuit.settings.takeoverS.hSize == "" || $scope.iCircuit.settings.takeoverS.hSize == null)) || ($scope.iCircuit.settings.headerSize == "" || $scope.iCircuit.settings.headerSize == null))){
        $scope.errType = "hSize";
        $scope.hasErr = true;
      } else if($scope.iCircuit.dType == 'normal' && ($scope.iCircuit.settings.takeover && ($scope.iCircuit.settings.takeoverS.mSize == "" || $scope.iCircuit.settings.takeoverS.mSize == null))){
        $scope.errType = "mSize";
        $scope.hasErr = true;
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveIntelCircuitFx();
          }, 250);
        }
        else{
          $scope.saveIntelCircuitFx();
        }
      }
    }
    $scope.saveIntelCircuitFx = function(){
      $scope.saveProcessing = true;
      IntelCircuitRssSrv.saveIntelCircuit($scope.iCircuit).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('InstagramController', InstagramController);

  /** @ngInject */
  function InstagramController($log, $rootScope, $scope, $state, $cookies, $timeout, $interval, InstagramSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, rt:false, ab:false, at:false};
    $scope.postList = [10,20,30,40,50];
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerText:"#0b5394", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, headerSize:26, footerText:"#0b5394", footerFont:$scope.fontFamilySelected, footerSize:18},
      ctype:{headerText:"default", footerText:"default", bg:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.instagram.settings = angular.copy($scope.defaultSettings.settings);
      $scope.instagram.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      InstagramSrv.getInstagram($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.instagram = data;
          // $scope.instagram.dType = "l";
          if(!$scope.instagram.ctype){
            $scope.instagram.settings = angular.copy($scope.settings.settings);
            $scope.instagram.ctype = angular.copy($scope.settings.ctype);
          } else{
            $scope.settings.settings = angular.copy($scope.instagram.settings);
            $scope.settings.ctype = angular.copy($scope.instagram.ctype);
          }
          if(!$scope.instagram.settings.footerText){
            $scope.instagram.settings.footerText = "#0b5394";           
          }
          if(!$scope.instagram.settings.footerFont){
            $scope.instagram.settings.footerFont = $scope.fontFamilySelected;
          }
          if(!$scope.instagram.settings.footerSize){
            $scope.instagram.settings.footerSize = 18;
          }
          if(!$scope.instagram.ctype.footerText){
            $scope.instagram.ctype.footerText = "default";
          }
          if($scope.instagram.instagramData){
            $scope.pListShow = true;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.instagram = {labelOpt:"a", label:"", type:"", instagram:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
      settings:angular.copy($scope.settings.settings),
      ctype:angular.copy($scope.settings.ctype)
    };
      $scope.instagram.post = $scope.postList[0];
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      $scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        InstagramSrv.getVerify($scope.instagram.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              $scope.pListShow = true;
              if(data.isClosed){
                $scope.isClosed = true;
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.instagramFx = function(tab, caller){
      $scope.instagram.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.selectedT == 1 && (tab == 1 || caller == "save")){
        if($scope.instagram.labelOpt == "c" && $scope.instagram.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.instagram.settings.rotationOpt == "c" && $scope.instagram.settings.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#rotation").focus();
        } else if($scope.instagram.settings.hTextOpt == "c" && !$scope.instagram.settings.hText){
          $scope.errType = "hText";
          $scope.hasErr = true;
          $("#hText").focus();
        } else if($scope.instagram.settings.hTextOpt !== "n" && !$scope.instagram.settings.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#hSize").focus();
        } else if(!$scope.instagram.settings.footerSize){
          $scope.errType = "fSize";
          $scope.hasErr = true;
          $("#fSize").focus();
        } else if(caller == "save" && !$scope.instagram.instagramData){
          $scope.errType = "authFailed";
          $scope.hasErr = true;
          $("#authBtn").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveInstagramFx(caller);
            }, 250);
          } else{
            $scope.saveInstagramFx(caller);
          }
        }
      } else if(tab == 2 || caller == 'save'){
        if(!$scope.instagram.instagramData && !$scope.isClosed){
          $scope.errType = "authFailed";
          $scope.hasErr = true;
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveInstagramFx(caller);
            }, 250);
          }
          else{
            $scope.saveInstagramFx(caller);
          }
        }
      }
    }
    $scope.saveInstagramFx = function(caller){
      if(caller == "save"){
        $scope.instagram.toast = true;
      } else{
        $scope.instagram.toast = false;
      }
      if(caller == 'save'){
        $scope.saveProcessing = true;
      }
      InstagramSrv.saveInstagram($scope.instagram).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.instagram.id = data.id;

          //URL client id decryption
          $scope.rUrl = data.rUrl;
          if(data.rUrl){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.rUrl);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.rUrl = updatedUrl;
              }
            }
          }

          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          } else{
            $scope.tabFx(2, 'tabFx');
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('IFrameController', IFrameController);

  /** @ngInject */
  function IFrameController($log, $rootScope, $scope, $state, $cookies, $timeout, IFrameSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      IFrameSrv.getIFrame($scope.decId).then(
        function(data){
          $scope.iFrame = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.iFrame = {label:"", frameData:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.iFrameFx = function(){
      $scope.iFrame.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.iFrame.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.iFrame.frameData == ""){
        $scope.errType = "data";
        $scope.hasErr = true;
        $("#wData").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveIFrameFx();
          }, 250);
        } else{
          $scope.saveIFrameFx();
        }
      }
    }
    $scope.saveIFrameFx = function(){
      $scope.saveProcessing = true;
      IFrameSrv.saveIFrame($scope.iFrame).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('HDStethController', HDStethController);

  /** @ngInject */
  function HDStethController($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, DevicesSrv, ContentLibrarySrv, FileModelUploadSrv, CommonSrv, HDStethSrv){
    $scope.colorPicker = {rb:false, rs:false, rt:false, rst:false, rtm:false, wb:false, ws:false, whb:false, wht:false, wt:false, wat:false, wtm:false, watm:false, wr:false, war:false, wrb:false, warb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editAForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.curDeviceObj = {availableDevices:[], devices:[], caller:"steth"};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.curContentType = {target:false};
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = true;
    $scope.steth = {info:{}};
    $scope.isPEOpen = false;
    $scope.eventList = [];
    $scope.currentPage = 0;
    $scope.addEvent = {};
    $scope.viewList = [];
    $scope.curLogo = {};
    $scope.ssList = [];
    $scope.advtList = [];
    $scope.encId = "";
    $scope.decId = 0;
    $scope.dgList = {d:[], g:[], r:[]};
    $scope.search = {text:""};
    // Todo to load data veriable and hold tab/button
    $scope.reponseLoad = false;

    $scope.settings = {iTime:120,rTime:10,lang:"en_US",format:"12"};
    $scope.ctype = {};
    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      $scope.steth.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.format = angular.copy($scope.steth.info.settings.format);
      $scope.steth.info.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.celEventBack = angular.fromJson(localStorage.getItem("celEventBack"));

    //! No need to do this here start
    // CommonSrv.getAvailableDevice().then(
    //   function(data){
    //     $scope.deviceList = data;
    //   },
    //   function(err){
    //     $log.error(err);
    //   }
    // );
    //! No need to do this here end

    $scope.formatFx = function(caller){
      if($scope.steth.info.settings.lang == 'en_US' || $scope.steth.info.settings.lang == 'es_ES' || $scope.steth.info.settings.lang == 'pt_PT'){
        $scope.formats = [
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"12"}), value:"12"},
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"24"}), value:"24"}
        ];
      }
      if($scope.steth.info.settings.lang == 'fr_FR'){
        $scope.formats = [
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"24"}), value:"24"},
          {label:$filter("translate")('cl.widget.dt.9.2', {value:"24"}), value:"24h"}
        ];
      }
      if(caller == "n"){
        $scope.steth.info.settings.format = $scope.formats[0].value;
      }
    }
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      HDStethSrv.getHDSteth($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.steth = data;
          if(!$scope.steth.info.settings.iTime){
            $scope.steth.info.settings.iTime = 120;
          }
          if($scope.steth.info.settings.rb){
            delete $scope.steth.info.settings.rb;
          }
          if($scope.steth.info.settings.wb){
            delete $scope.steth.info.settings.wb;
          }
          if(!$scope.steth.info.settings.rTime){
            $scope.steth.info.settings.rTime = 10;
          } else{
            $scope.steth.info.settings.rTime = parseInt($scope.steth.info.settings.rTime);
          }
          if(!$scope.steth.info.settings.lang){
            $scope.steth.info.settings.lang = "en_US";
            $scope.formatFx("n");
          }
          $scope.tim = $scope.steth.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.steth.info.bucket;
          if($scope.steth.info.mbucket && $scope.steth.info.mbucket != ""){
            $scope.cDetailBucket = $scope.steth.info.mbucket;
          }
          $scope.formatFx("e");
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      localStorage.removeItem("celEventBack");
      $scope.detailLoading = false;
      $scope.celEventBack = null;
      $rootScope.tabView = true;

      $scope.steth.info = {
        label:"",
        activePeriod:{type:"a"},
        ctype:angular.copy($scope.ctype),
        settings:angular.copy($scope.settings),
        permission:{type:$scope.auth.upreferences.defaultP}
      };
      $scope.formatFx("n");
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.errType = "";
      $scope.hasListErr = false;
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.deviceList), devices:[], caller:"steth"};
      } else if(caller == "a"){
        $scope.addAdvt = {aId:null, label:"", type:"content", advt:"", target:"", url:""};
      } else if(caller == "r"){
        $scope.roomCU = {l:"", fl:"", dt:"rb", type:"r"};
      }
    }

    $scope.getSSFx = function(caller){
      HDStethSrv.getSSList($scope.steth.info.id).then(
        function(data){
          $scope.detailLoading = false;
          $scope.ssList = data.screenSaver;
          if(!$scope.ssList.length){
            $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
          } else if(caller !== "ss"){
            $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    $scope.getAdvtFx = function(caller){
      HDStethSrv.getAdvtList($scope.steth.info.id).then(
        function(data){
          $scope.detailLoading = false;
          $scope.advtList = data.advt;
          if(!$scope.advtList.length){
            $scope.editAForm = {isShow:true, isAdd:true, isEdit:false};
          } else if(caller !== "advt"){
            $scope.editAForm = {isShow:false, isAdd:false, isEdit:false};
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    $rootScope.selectedTabFx = function(){
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editAForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // HDStethSrv.getSSDevices().then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
        //     $scope.dgList.d = angular.copy(data.devices);
        //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here end
      }
      else if($scope.selectedT == "2"){
        $scope.detailLoading = true;
        $scope.getSSFx();
        $scope.resetFx('s');
      }
      else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        $scope.getAdvtFx();
        $scope.resetFx('a');
      }
      else if($scope.selectedT == "4"){
        // TODO: new code
        var obj = {subCaller: "wHDStethRL", caller: "availD", offset: 0, id: $scope.steth.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // HDStethSrv.getMapping($scope.decId).then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.mapList = angular.copy(data.d);
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here end
      }
    }
    $rootScope.selectedTabFx();

    /*Logo*/
    $scope.logoPopover = {templateUrl:"logo.html"};
    $scope.screenPopover = {templateUrl:"screen.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if(item.type == "Video" || item.splType == "Video"){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(caller){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.search = {text:""};

      if(caller=="target"){
        $scope.curContentType.target = true;
      } else{
        $scope.curContentType.target = false;
      }
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "2"){
          $scope.addScreen.ss = $scope.curContent;
        } else if($scope.selectedT == "3"){
          if($scope.curContentType.target){
            $scope.addAdvt.target = $scope.curContent;
          } else{
            $scope.addAdvt.advt = $scope.curContent;
          }
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "l"){
        $scope.addEvent.logo = null;
      } else if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    $scope.removeProcessing = false;
    $scope.deleteOpen = function(caller, iId){
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      HDStethSrv.delete($scope.steth.info.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.editSForm = {isAdd:true, isEdit:false};
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          } else if($scope.deleteObj.caller == "a"){
            angular.forEach($scope.advtList, function(list, index){
              if($scope.deleteObj.iId == list.aId){
                $scope.advtList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.editAForm = {isAdd:true, isEdit:false};
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:"", g:"", r:""};
      $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      } else if(caller == "a"){
        $scope.editAForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addAdvt = angular.copy(data);
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel, type){
      // var curModel = [];
      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });
      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        // $scope.resetD(caller);
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      }
      else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        // $scope.resetD(caller);
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dAList = [];
      // $rootScope.dSList = [];
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   });
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      //   // angular.forEach($scope.curDeviceObj.availableDevices, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i=0; i<$scope.curDeviceObj.devices.length; i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      //   // $scope.curDeviceObj.availableDevices = $scope.curAvailableDevices;
      // }
      //! No need to do here end

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to do here start
          // if(caller){
          //   if($scope.addScreen.d.length > 0){
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.curDeviceObj.availableDevices), devices:$scope.curDeviceObj.devices, caller:"steth"};
          //   } else {
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[], caller:"steth"};
          //   }
          // }
          //! No need to do here start
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wHDStethSS", caller: "availD", offset: 0, id: $scope.steth.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wHDStethSS", caller: "selD", offset: 0, id: $scope.steth.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: change the value
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.hasListErr = false;
      $scope.errType = "";
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#ssLabel").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#ssContentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#ssDeviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#ssDuration").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.ssPostObj = {info:{id:$scope.steth.info.id}, screenSaver:$scope.addScreen};
        HDStethSrv.addSS($scope.ssPostObj).then(
          function(data){
            // TODO: add new changes
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      if($scope.selectedT==2){
        angular.forEach($scope.ssList, function(item, index){
          angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
            $scope.curRow.push(obj);
          });
        });
        $scope.ssList = [];
        $scope.ssList = $scope.curRow;
        $scope.steth.info.screenSaver = [];
        $scope.steth.info.screenSaver = $scope.ssList;
      }
      if($scope.selectedT==3){
        angular.forEach($scope.advtList, function(item, index){
          angular.forEach($filter('filter')($scope.advtList, {aId:$scope.curId[index]}), function(obj){
            $scope.curRow.push(obj);
          });
        });
        $scope.advtList = [];
        $scope.advtList = $scope.curRow;

        $scope.steth.info.advt = [];
        $scope.steth.info.advt = $scope.advtList;
      }
    }

    /*Advertizment */
    $scope.addAdvtFx = function(caller){
      $scope.hasListErr = false;
      $scope.errType = "";
      if(!$scope.addAdvt.advt || $scope.addAdvt.advt == ""){
        $scope.errType = "advt";
        $scope.hasListErr = true;
        $("#contentBtn").focus();
      } else if($scope.addAdvt.type == "content" && (!$scope.addAdvt.target || $scope.addAdvt.target == "")){
        $scope.errType = "target";
        $scope.hasListErr = true;
        $("#tContentBtn").focus();
      } else if($scope.addAdvt.type == "url" && (!$scope.addAdvt.url || $scope.addAdvt.url == "")){
        $scope.errType = "url";
        $scope.hasListErr = true;
        $("#url").focus();
      } else if($scope.addAdvt.advt && !$scope.addAdvt.advt.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#duration").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.advtPostObj = {info:{id:$scope.steth.info.id}, advt:$scope.addAdvt};
        HDStethSrv.addAdvt($scope.advtPostObj).then(
          function(data){
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.advtList, {"aId":data.aId}, true);
            if(filterd.length){
              angular.forEach($scope.advtList, function(advt, index){
                if(advt.aId == data.aId){
                  $scope.advtList[index].aId = data.aId;
                  $scope.advtList[index].advt = $scope.addAdvt.advt;
                  $scope.advtList[index].label = $scope.addAdvt.label;
                  $scope.advtList[index].target = $scope.addAdvt.target;
                  $scope.advtList[index].type = $scope.addAdvt.type;
                  $scope.advtList[index].url = $scope.addAdvt.url;
                }
              });
            } else{
              $scope.advtList.push({aId:data.aId, label:$scope.addAdvt.label, advt:$scope.addAdvt.advt, target:$scope.addAdvt.target, type:$scope.addAdvt.type, url:$scope.addAdvt.url});
            }
            if(caller == "s"){
              $scope.editAForm.isShow = false;
            } else{
              $scope.editAForm.isShow = true;
            }
            $scope.resetFx('a');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }
    /*Mapping*/
    $scope.deviceMapFx = function(caller, map, index){
      $scope.mapProcessing = false;
      $scope.hasPopErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(caller == "e"){
        $scope.mapCopy = angular.copy(map);
      } else if(caller == "u"){
        HDStethSrv.editMapping({id:$scope.steth.info.id, d:map}).then(
          function(data){
            if(data.code == 8629){
              $scope.mapProcessing = false;
              map.show = false;
            }
          },
          function(err){
            $log.error(err);
            $scope.mapProcessing = false;
          }
        );
      } else if(caller == "c"){
        // $scope.mapList.forEach(function(val, i){
        //   if(val.id == map.id){
        //     $scope.mapList[i] = $scope.mapCopy;
        //     return true;
        //   }
        // });

        map.show = false;
        $scope.mapCopy.show = false;
      }
    }

    $scope.stethFx = function(tab, caller){
      // TODO: new code
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || tab == 2 || tab == 3 || caller == "save"){
        if($scope.steth.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if(!$scope.steth.info.settings.iTime || $scope.steth.info.settings.iTime == ""){
          $scope.errType = "iTime";
          $scope.hasErr = true;
          $("#iTime").focus();
        } else if(!$scope.steth.info.settings.rTime || $scope.steth.info.settings.rTime == ""){
          $scope.errType = "rTime";
          $scope.hasErr = true;
          $("#rTime").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.steth.info.fid = $scope.fid;
          $scope.steth.info.toast = false;

          if(tab == 1 || tab == 2 || tab == 3){
            $scope.nextProcessing = true;
          } else{
            $scope.steth.info.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveStethFx(tab);
            }, 250);
          } else{
            $scope.saveStethFx(tab);
          }
        }
      } else{
        if(tab == 1){
          $timeout(function(){
            $scope.tabFx(2, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else
        if(tab == 2){
          $timeout(function(){
            $scope.tabFx(3, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $timeout(function(){
            $scope.tabFx(4, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        }
      }
    }

    $scope.saveStethFx = function(tab, caller){
      $scope.reponseLoad = true;
      $scope.steth.info.fid = $scope.fid;
      $scope.steth.info.tzOffset = $scope.curTimezone;
      //! No need to do this here start
      // $scope.steth.info.d = $scope.mapList;
      //! No need to do this here end
      $scope.steth.info.settings.rTime = parseInt($scope.steth.info.settings.rTime);
      HDStethSrv.saveHDSteth($scope.steth).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.steth.info.id = data.id;
            $scope.decId = data.id;
          }
          if(tab == 1 || tab == 2 || tab == 3){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 2){
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
          $scope.reponseLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          $scope.reponseLoad = false;
        }
      );
    }

    $scope.cancelFx = function(){
      localStorage.removeItem("celEventBack");
      $state.go("hub.contentLibrary.c");
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="steth"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="steth"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset selected devices
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.search = {text:""};
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Video"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';
    $scope.loadingPaging = {}
    $scope.loadingMore = {}

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }


    // TODO get Scroll data for the event and room list tab
    $scope.getScrollListData = function(obj){
      $scope.detailLoading = true;
      $scope.detailListObj[obj.quadId] = {};
      $scope.scrollDataList[obj.quadId] = [];
      $scope.allScrollDataList[obj.quadId] = [];
      $scope.copyScrollObj[obj.quadId] = {};
      $scope.visibleObjects[obj.quadId] = [];
      $scope.haveMoreData[obj.quadId] = false;
      $scope.haveMoreSearchData[obj.quadId] = false;
      $scope.visibleData[obj.quadId] = [];
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.searchScroll[obj.quadId] = false;
      $scope.loadingMore[obj.quadId] = false;
      $scope.loadingPaging[obj.quadId] = true;

      $scope.detailListObj[obj.quadId] = {subCaller: obj.subCaller, caller: obj.caller, offset: obj.offset, id: obj.id, subCallerId: obj.subCallerId, quadId:obj.quadId};
      
      DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData[obj.quadId] = true;
          } else{
            $scope.haveMoreData[obj.quadId] = false;
          }

          // if(obj.quadId == "rl"){
          //   $scope.curRoomList = data.r;
          //   angular.forEach($scope.curRoomList, function(item){
          //     item.type = "r"
          //   })
          // }

          $scope.scrollDataList[obj.quadId] = data.d;
          $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

          $scope.detailLoading = false;

          $scope.loadingPaging[obj.quadId] = false;
        },
        function(err){
          $scope.detailLoading = false;
          $scope.loadingPaging[obj.quadId] = false;
          $log.error(err);
        }
      );
    }


    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      if($scope.selectedT != '2'){
        $scope.loadingMore[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: $scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        if($scope.searchScroll[obj.quadId]){
          $scope.detailListObj[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else if(data.d.length && data.d.length < 1000){
                $scope.haveMoreData[obj.quadId] = false;
              }

              $scope.allScrollDataList[obj.quadId] = [];
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      if($scope.selectedT != '2'){
        $scope.stIndex[obj.quadId] = 0;
        $scope.etIndex[obj.quadId] = 300;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.scrollDataList[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if(obj.text){          
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        }
  
        if(obj.text){
          $scope.searchScroll[obj.quadId] = true;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length && data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = data.d;
  
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          $scope.haveMoreSearchData[obj.quadId] = false;
          $scope.searchScroll[obj.quadId] = false;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else{
                $scope.haveMoreData[obj.quadId] = false;
              }

              $scope.scrollDataList[obj.quadId] = data.d;
              
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataList[obj.quadId] = [];
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
  
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      if($scope.selectedT != '2'){
        $scope.stIndex[obj.quadId] = obj.st;
        $scope.etIndex[obj.quadId] = obj.et;
        $scope.visibleData[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
        setTimeout(function() {
          $scope.$apply();
        });
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      if($scope.selectedT == '2' || $scope.selectedT == '4'){
        var text = val.toLowerCase();
        var scrollElement = document.querySelector("#scroll-container-"+quadId);
        if (!text && $scope.searchScroll[quadId]) {
          // TODO Enter when have newVal is empty and user perform search operation already
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else if (text && text.length >= 3) {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreData[quadId]) {
            // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
            // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
            var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj , function (item) {
              if(keys.indexOf(item.h) === -1){
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if(filteredObj.length && filteredObj.length >= 1000){
              $scope.haveMoreSearchData[quadId] = true;
            } else{
              $scope.haveMoreSearchData[quadId] = false;
            }
                        
            $scope.scrollDataList[quadId] = filteredObj;
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            if ($scope.scrollDataList[quadId].length <= 300) {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
            } else {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
            }
            $scope.searchScroll[quadId] = true;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          } else {
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          }
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('GrafanaController', GrafanaController);

  /** @ngInject */
  function GrafanaController($log, $rootScope, $scope, $state, $cookies, $timeout, ngDialog, ContentLibrarySrv, GrafanaSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.timestamp = moment().format('x');
    $scope.colorPicker = {b:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.search = {text:""};
    $scope.curBtnCaller = "";
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      reloadOpt:"n", reload:""
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings)};

    $scope.settingsDefault = function(){
      $scope.grafana.settings = angular.copy($scope.defaultSettings.settings);
    }

    if($state.params.id){
      $scope.listLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      GrafanaSrv.getGrafana($scope.decId).then(
        function(data){
          $scope.grafana = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $scope.listLoading = true;

      $scope.grafana = {label:"",labelOpt:"a",dashboard:"",activePeriod:{type:"a"},permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings),ctype:angular.copy($scope.ctype)
      };
    }
    GrafanaSrv.getDashboardList().then(
      function(data){
        $scope.listLoading = false;
        $scope.dList = data.dList;
        console.warn(data);
      }, function(err){
        $log.error(err);
      }
    );


    $scope.grafanaFx = function(){
      $scope.grafana.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.grafana.labelOpt == "c" && $scope.grafana.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.grafana.dashboard == ""){
        $scope.errType = "db";
        $scope.hasErr = true;
        $("#dashboard").focus();
      } else if($scope.grafana.settings.reloadOpt == "c" && ($scope.grafana.settings.reload == "" || $scope.grafana.settings.reload == null)){
        $scope.errType = "reloadEmpty";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.grafana.settings.reload && $scope.grafana.settings.reload < 10){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveGrafanaFx();
          }, 250);
        } else{
          $scope.saveGrafanaFx();
        }
      }
    }
    $scope.saveGrafanaFx = function(){
      $scope.saveProcessing = true;
      GrafanaSrv.saveGrafana($scope.grafana).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('GSlideController', GSlideController);

  /** @ngInject */
  function GSlideController($log, $rootScope, $scope, $state, $cookies, $timeout, GSlideSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.gSlideCrawl = "";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {rotationOpt:"a", reloadOpt:"n", reload:300, rotate:12, toolbar:false};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.gSlide.settings = angular.copy($scope.defaultSettings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      GSlideSrv.getGSlide($scope.decId).then(
        function(data){
          $scope.gSlide = data;
          $scope.detailLoading = false;
          $scope.dTypeCopy = angular.copy($scope.gSlide.dType);
          if(!data.settings){
            $scope.gSlide.settings = angular.copy($scope.settings);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.gSlide = {label:"", url:"", settings:angular.copy($scope.settings), activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.gSlideFx = function(){
      $scope.gSlide.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.gSlide.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.gSlide.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.gSlide.settings.reloadOpt == "c" && ($scope.gSlide.settings.reload == "" || $scope.gSlide.settings.reload == null)){
        $scope.errType = "reloadEmpty";
        $scope.hasErr = true;
        $("#reload").focus();
      } else if($scope.gSlide.settings.reloadOpt == "c" && $scope.gSlide.settings.reload && $scope.gSlide.settings.reload < 30){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveGSlideFx();
          }, 250);
        } else{
          $scope.saveGSlideFx();
        }
      }
    }
    $scope.saveGSlideFx = function(){
      $scope.saveProcessing = true;
      if($scope.gSlide.settings.reloadOpt == 'n'){
        $scope.gSlide.settings.reload = 300;
      }
      GSlideSrv.saveGSlide($scope.gSlide).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('GCalendarController', GCalendarController);

  /** @ngInject */
  function GCalendarController($log, $rootScope, $scope, $state, $cookies, $timeout, $interval, $filter, ngDialog, GCalendarSrv, ContentLibrarySrv, DevicesSrv){
    $scope.colorPicker = {b:false, tt:false, st:false, tm:false, hb:false, ht:false, rt:false, at:false, atm:false, ar:false, rb:false, ab:false};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.curDeviceObj = {availableDevices:[], devices:[]};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.dgList = {d:[], g:[], r:[]};
    $scope.search = {text:""};

    $scope.settingsRB = {/*Rooomboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:0, logoOpt:false,
      titleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:72,
      subtitleText:"#999999", subtitleFont:$scope.fontFamilySelected, subtitleSize:36,
      timeText:"#444444", timeFont:$scope.fontFamily[0],
      sos:{sType:"p", prior:30, eType:"a", after:30}, timeSize:48,
      feed:{url:"", logo:"", ss:""}
    };
    $scope.ctypeRB = {bg:"monochrome", ssbg:"monochrome", titleText:"monochrome", subtitleText:"monochrome", timeText:"monochrome"};
    $scope.settingsWB = {/*Wallboard*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:0, isTime:true, isRoom:true, logoOpt:false, rotationOpt:"a", rotate:12,
      header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room", col3TxtAlign:"center"},
      headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26,
      titleText:"#000000", timeText:"#444444", titleSize:28, titleTxtAlign:"left",
      altTitleText:"#000000", altTimeText:"#444444", timeSize:28, timeTxtAlign:"center",
      roomText:"#666666", altRoomText:"#000000", roomSize:28, roomTxtAlign:"center",
      titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected,
      rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1,
      sos:{sType:"s", prior:30, eType:"a", after:30},
      feed:{url:"", logo:"", ss:""}
    }
    $scope.ctypeWB = {bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", timeText:"monochrome", roomText:"monochrome", altTitleText:"monochrome", altTimeText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"};
    $scope.settingsAE = {/*All Events*/
      bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:0, isTime:true, isRoom:true, logoOpt:false, rotationOpt:"a", rotate:12,
      header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room", col3TxtAlign:"center"},
      headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26,
      titleText:"#000000", timeText:"#444444", titleSize:28, titleTxtAlign:"left",
      altTitleText:"#000000", altTimeText:"#444444", timeSize:28, timeTxtAlign:"center",
      roomText:"#666666", altRoomText:"#000000", roomSize:28, roomTxtAlign:"center",
      titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected,
      rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1,
      sos:{sType:"s", prior:30, eType:"a", after:30},
      feed:{url:"", logo:"", ss:""}
    };
    $scope.ctypeAE = {bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", timeText:"monochrome", roomText:"monochrome", altTitleText:"monochrome", altTimeText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"};

    $scope.defaultSettingRB = angular.copy({setting:$scope.settingsRB, ctype:$scope.ctypeRB});
    $scope.defaultSettingWB = angular.copy({setting:$scope.settingsWB, ctype:$scope.ctypeWB});
    $scope.defaultSettingAE = angular.copy({setting:$scope.settingsAE, ctype:$scope.ctypeAE});

    $scope.settingsDefault = function(){
      if($scope.gCalendar.dType == "r"){
        $scope.settingsRB = angular.copy($scope.defaultSettingRB.setting);
        $scope.ctypeRB = angular.copy($scope.defaultSettingRB.ctype);
      } else if($scope.gCalendar.dType == "wc"){
        $scope.settingsWB = angular.copy($scope.defaultSettingWB.setting);
        $scope.ctypeWB = angular.copy($scope.defaultSettingWB.ctype);
      } else{
        $scope.settingsAE = angular.copy($scope.defaultSettingAE.setting);
        $scope.ctypeAE = angular.copy($scope.defaultSettingAE.ctype);
      }
    }

    $scope.cList = [];
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      GCalendarSrv.getGCalendar($scope.decId).then(
        function(data){
          $scope.gCalendar = data;
          $scope.cList = data.calendarList;
          if(!$scope.gCalendar.settings.sos && $scope.gCalendar.dType == "r"){
            $scope.gCalendar.settings.sos = {sType:"p", prior:30, eType:"a", after:30};
          }
          if(!$scope.gCalendar.settings.sos && $scope.gCalendar.dType == "wc"){
            $scope.gCalendar.settings.sos = {sType:"s", prior:30, eType:"e", after:30};
          }
          if(!$scope.gCalendar.settings.sos && $scope.gCalendar.dType == "ae"){
            $scope.gCalendar.settings.sos = {sType:"s", prior:30, eType:"e", after:30};
          }
          if(!$scope.gCalendar.settings.rotationOpt){
            $scope.gCalendar.settings.rotationOpt = "a";
            $scope.gCalendar.settings.rotate = 12;
            $scope.gCalendar.settings.logoOpt = false;
          }
          if($scope.gCalendar.dType == "r"){
            $scope.settingsRB = angular.copy($scope.gCalendar.settings);
            $scope.ctypeRB = angular.copy($scope.gCalendar.ctype);
          } else if($scope.gCalendar.dType == "wc"){
            if(!$scope.gCalendar.settings.headerSize){
              $scope.gCalendar.settings.headerSize = 26;
              $scope.gCalendar.settings.titleSize = 28;
              $scope.gCalendar.settings.timeSize = 28;
              $scope.gCalendar.settings.roomSize = 28
            }
            $scope.settingsWB = angular.copy($scope.gCalendar.settings);
            $scope.ctypeWB = angular.copy($scope.gCalendar.ctype);

            if(!$scope.gCalendar.settings.header.col1TxtAlign){
              $scope.settingsWB.header.col1TxtAlign = "left";
            }
            if(!$scope.gCalendar.settings.header.col2TxtAlign){
              $scope.settingsWB.header.col2TxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.header.col3TxtAlign){
              $scope.settingsWB.header.col3TxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.titleTxtAlign){
              $scope.settingsWB.titleTxtAlign = "left";
            }
            if(!$scope.gCalendar.settings.timeTxtAlign){
              $scope.settingsWB.timeTxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.roomTxtAlign){
              $scope.settingsWB.roomTxtAlign = "center";
            }

          } else if($scope.gCalendar.dType == "ae"){
            $scope.settingsAE = angular.copy($scope.gCalendar.settings);
            $scope.ctypeAE = angular.copy($scope.gCalendar.ctype);

            if(!$scope.gCalendar.settings.header.col1TxtAlign){
              $scope.settingsAE.header.col1TxtAlign = "left";
            }
            if(!$scope.gCalendar.settings.header.col2TxtAlign){
              $scope.settingsAE.header.col2TxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.header.col3TxtAlign){
              $scope.settingsAE.header.col3TxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.titleTxtAlign){
              $scope.settingsAE.titleTxtAlign = "left";
            }
            if(!$scope.gCalendar.settings.timeTxtAlign){
              $scope.settingsAE.timeTxtAlign = "center";
            }
            if(!$scope.gCalendar.settings.roomTxtAlign){
              $scope.settingsAE.roomTxtAlign = "center";
            }

            $scope.gCalendar.wallboardList = [];
            $scope.gCalendar.roomId = "";
          }
          if($scope.gCalendar.calendar || $scope.cList.length > 0){
            $scope.cListShow = true;
          }
          // todo update the code location start
          $scope.tim = $scope.gCalendar.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.gCalendar.bucket;
          if($scope.gCalendar.mbucket && $scope.gCalendar.mbucket != ""){
            $scope.cDetailBucket = $scope.gCalendar.mbucket;
          }
          // todo update the code location end

          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.gCalendar = {label:"", dType:"r", roomId:"", wallboardList:[], toast:false, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.editWallFx = function(index){
      $scope.gCalendar.wallboardList[index].edited = 1;
    }
    $scope.addRowFx = function(){
      $scope.gCalendar.wallboardList.push({label:"", email:"", edited:1, highlight:0});
    }
    $scope.confirmOpen = function(index){
      $scope.dataObj = {index:index};
      if($scope.gCalendar.wallboardList[index].label && $scope.gCalendar.wallboardList[index].email){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{\'cm.msg.34\' | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="removeWallFx(dataObj.index);" focus-me="true">\{{\'cm.btn.2\' | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.removeWallFx(index);
      }
    }
    $scope.removeWallFx = function(index){
      $scope.gCalendar.wallboardList.splice(index, 1);
      ngDialog.close();
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h, caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller=="ou"){
        var newWindow = window.open("https://accounts.google.com/Logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      }
      $scope.timer = setTimeout(function(){
        if($scope.timer){
          clearTimeout($scope.timer);
        }
        if(caller=="ou"){
          newWindow.close();
        }
        $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
        $scope.childWindowInt = $interval($scope.checkChild, 500);
      }, 2000);
      return false;
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        GCalendarSrv.getVerify($scope.gCalendar.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              $scope.cList = data.calendarList;
              $scope.cListShow = true;
              if(data.isClosed){
                $scope.gCalendar.isAuthorized = true;
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
                // $interval.cancel($scope.childWindowInt);
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.gCalendarFx = function(tab, caller){
      // TODO: new code
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.gCalendar.fid = $scope.fid;
      $scope.wallFieldEmply = false;
      $scope.sameEmail = false;
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.gCalendar.dType == "wc" && $scope.gCalendar.wallboardList.length > 0){
        angular.forEach($scope.gCalendar.wallboardList, function(list){
          if(list.label == "" || !list.email || list.email == ""){
            $scope.wallFieldEmply = true;
          }
          if(!$scope.wallFieldEmply && list.edited){
            list.edited = 0;
          }
        });
        if(!$scope.wallFieldEmply){
          angular.forEach($scope.gCalendar.wallboardList, function(list, intex){
            var filtered = $filter("filter")($scope.gCalendar.wallboardList, {email:$scope.gCalendar.wallboardList[intex].email}, true);
            if(filtered.length > 1){
              $scope.sameEmail = true;
              list.edited = 1;
            }
          });
        }
      }
      if(tab == 1 || tab == 2 || caller == "save"){
        if($scope.gCalendar.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.wallFieldEmply){
          $scope.errType = "wallFieldEmply";
          $scope.hasErr = true;
          $("#wallFieldEmply").focus();
        } else if($scope.sameEmail){
          $scope.errType = "sameEmail";
          $scope.hasErr = true;
          $("#sameEmail").focus();
        } else if($scope.gCalendar.dType == "r" && !$scope.settingsRB.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#rbTitleSize").focus();
        } else if($scope.gCalendar.dType == "r" && !$scope.settingsRB.subtitleSize){
          $scope.errType = "stSize";
          $scope.hasErr = true;
          $("#rbSubtTitleSize").focus();
        } else if($scope.gCalendar.dType == "r" && !$scope.settingsRB.timeSize){
          $scope.errType = "tsSize";
          $scope.hasErr = true;
          $("#rbTimeSize").focus();
        } else if($scope.gCalendar.dType == "r" && $scope.settingsRB.sos.sType == "p" && !$scope.settingsRB.sos.prior){
          $scope.errType = "rbSosP";
          $scope.hasErr = true;
          $("#rbSosP").focus();
        } else if($scope.gCalendar.dType == "r" && $scope.settingsRB.sos.eType == "a" && !$scope.settingsRB.sos.after){
          $scope.errType = "rbSosA";
          $scope.hasErr = true;
          $("#rbSosA").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.rotationOpt == "c" && !$scope.settingsWB.rotate){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#wbRotation").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.header.active && !$scope.settingsWB.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wbHeaderSize").focus();
        } else if($scope.gCalendar.dType == "wc" && !$scope.settingsWB.titleSize){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#wbTitleSize").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.isTime && !$scope.settingsWB.timeSize){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#wbTimeSize").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.isRoom && !$scope.settingsWB.roomSize){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#wbRoomSize").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.sos.sType == "p" && !$scope.settingsWB.sos.prior){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wbSosP").focus();
        } else if($scope.gCalendar.dType == "wc" && $scope.settingsWB.sos.eType == "a" && !$scope.settingsWB.sos.after){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wbSosA").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.rotationOpt == "c" && !$scope.settingsAE.rotate){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#aeRotation").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.header.active && !$scope.settingsAE.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#aeHeaderSize").focus();
        } else if($scope.gCalendar.dType == "ae" && !$scope.settingsAE.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#aeTitleSize").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.isTime && !$scope.settingsAE.timeSize){
          $scope.errType = "tsSize";
          $scope.hasErr = true;
          $("#aeTimeSize").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.isRoom && !$scope.settingsAE.roomSize){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#aeRoomSize").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.sos.sType == "p" && !$scope.settingsAE.sos.prior){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#aeSosP").focus();
        } else if($scope.gCalendar.dType == "ae" && $scope.settingsAE.sos.eType == "a" && !$scope.settingsAE.sos.after){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#aeSosA").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1 || tab == 2){
            $scope.nextProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveGCalendarFx(tab);
              }, 250);
            } else{
              $scope.saveGCalendarFx(tab);
            }
          } else if(!$scope.cListShow){
            $scope.errType = "authEmpty";
            $scope.hasErr = true;
          } else{
            $scope.gCalendar.toast = true;
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveGCalendarFx(caller);
              }, 250);
            } else{
              $scope.saveGCalendarFx(caller);
            }
          }
        }
      }
    }

    $scope.saveGCalendarFx = function(caller){
      if(caller == "save"){
        $scope.gCalendar.toast = true;
      } else{
        $scope.gCalendar.toast = false;
      }

      if(caller == "save" && !$scope.cList){
        $scope.errType = "authEmpty";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else if(caller == "save" && $scope.cList.length > 0 && !$scope.gCalendar.calendar){
        $scope.errType = "calendar";
        $scope.hasErr = true;
        $scope.saveProcessing = false;
      } else{
        $scope.gCalendar.calendarList = null;
        $scope.gCalendar.settings = {};
        if($scope.gCalendar.dType == "r"){
          if(!$scope.settingsRB.titleSize){
            $scope.settingsRB.titleSize = 72;
          }
          if(!$scope.settingsRB.subtitleSize){
            $scope.settingsRB.subtitleSize = 36;
          }
          if(!$scope.settingsRB.timeSize){
            $scope.settingsRB.timeSize = 48;
          }
          $scope.gCalendar.settings = $scope.settingsRB;
          $scope.gCalendar.ctype = $scope.ctypeRB;
        } else if($scope.gCalendar.dType == "wc"){
          $scope.gCalendar.settings = $scope.settingsWB;
          $scope.gCalendar.ctype = $scope.ctypeWB;
        } else if($scope.gCalendar.dType == "ae"){
          $scope.gCalendar.settings = $scope.settingsAE;
          $scope.gCalendar.ctype = $scope.ctypeAE;
        }
        GCalendarSrv.saveGCalendar($scope.gCalendar).then(
          function(data){
            $scope.nextProcessing = false;
            $scope.saveProcessing = false;
            $scope.gCalendar.id = data.id;
            
            //URL client id decryption
            $scope.rUrl = data.rUrl;
            if(data.rUrl){
              var client_id = "";
              if(data.client_id){
                client_id = $scope.decryptFx(data.client_id);
              }
              var urlObj = new URL(data.rUrl);
              var params = urlObj.searchParams;
              if(!params.has("client_id")){
                params.set("client_id", client_id);
                var updatedUrl = urlObj.toString();
                if(updatedUrl){
                  $scope.rUrl = updatedUrl;
                }
              }
            }

            if(data.code == ""){
              $scope.errType = "authEmpty";
              $scope.hasErr = true;
              $scope.saveProcessing = false;
            } else if(data.code == 8089){
              $scope.errType = "";
              $scope.hasErr = true;
            } else if(caller == 1 || caller == 2){
              if(caller == 1){
                $timeout(function(){
                  $scope.tabFx(2, 'tabFx');
                  $scope.isPEOpen = false;
                }, 250);
              } else if(caller == 2){
                $timeout(function(){
                  $scope.tabFx(3, 'tabFx');
                  $scope.isPEOpen = false;
                }, 250);
              }
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $log.error(err);
            $scope.nextProcessing = false;
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.deleteOpen = function(caller, iId){
      $scope.removeProcessing = false;
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      GCalendarSrv.delete($scope.gCalendar.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:""};
      $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      }
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:""};
      $scope.hasListErr = false;
      $scope.errType = "";
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
      }
    }

    $rootScope.selectedTabFx = function(caller){
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // GCalendarSrv.getSSDevices().then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
        //     $scope.dgList.d = angular.copy(data.devices);
        //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here start
      } else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        GCalendarSrv.getSSList($scope.gCalendar.id).then(
          function(data){
            $scope.detailLoading = false;
            $scope.ssList = data.screenSaver;
            $scope.gCalendar.info = data.info;
            if(!$scope.ssList.length){
              $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
            } else{
              $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
        $scope.resetFx('s');
      }
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.addScreen.ss = $scope.curContent;
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel, type){
      // var curModel = [];
      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });

      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dList = [];
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.gCalendar.info.screenSaver = [];
      $scope.gCalendar.info.screenSaver = $scope.ssList;
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i = 0;i < $scope.ssList.length;i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j = 0;j < $scope.curDeviceObj.availableDevices.length;j++){
      //         for(var k = 0;k < $scope.ssList[i].d.length;k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   })
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      //   // angular.forEach($scope.curDeviceObj.availableDevices, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i = 0;i < $scope.curDeviceObj.devices.length;i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      //   // $scope.curDeviceObj.availableDevices = $scope.curAvailableDevices;
      // }
      //! No need to do here end

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to do here start
          // if(caller){
          //   if($scope.addScreen.d.length > 0){
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.curDeviceObj.availableDevices), devices:$scope.curDeviceObj.devices};
          //   } else {
          //     $scope.curDeviceObj = {availableDevices:angular.copy($scope.dgList.d), devices:[]};
          //   }
          // }
          //! No need to do here end
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wGCalSS", caller: "availD", offset: 0, id: $scope.gCalendar.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wGCalSS", caller: "selD", offset: 0, id: $scope.gCalendar.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: change the value
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.errType = "";
      $scope.hasListErr = false;
      $scope.hasErr = false;
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#ssLabel").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#ssContentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#ssDeviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#ssDuration").focus();
      } else{
        $scope.addProcessing = true;
        $scope.ssPostObj = {info:{id:$scope.gCalendar.id}, screenSaver:$scope.addScreen};
        GCalendarSrv.addSS($scope.ssPostObj).then(
          function(data){
            // TODO: add new changes
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller == "a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id == selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller == "a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller == "coe" ? 'label' :'room'), val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller == "coe" ? 'label' :'room'), val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset device
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.search = {text:""};
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.selectedT != "3" && item.type == "Image"){
            $scope.curArgsContent.push(item);
          } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FTPController', FTPController);

  /** @ngInject */
  function FTPController($log, $rootScope, $scope, $state, $cookies, $timeout, FTPSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FTPSrv.getFTP($scope.decId).then(
        function(data){
          $scope.ftp = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.ftp = {label:"", host:"", user:"", pass:"", cPass:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.ftpFx = function(){
      $scope.ftp.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.ftp.label == ""){
        $("#label").focus();
      } else if($scope.ftp.host == ""){
        $("#host").focus();
      } else if( $scope.ftp.user == ""){
        $("#user").focus();
      } else if($scope.ftp.pass == ""){
        $("#pass").focus();
      } else if($scope.ftp.cPass == ""){
        $("#cPass").focus();
      }
      if($scope.ftp.label != "" && $scope.ftp.host != "" && $scope.ftp.user != "" && $scope.ftp.pass != "" && $scope.ftp.cPass != ""){
        if($scope.ftp.pass !== $scope.ftp.cPass){
          $scope.errType = "pass";
          $scope.hasErr = true;
          $("#cPass").focus();
        } else{
          $scope.saveProcessing = true;
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveFTPfX();
            }, 250);
          } else{
            $scope.saveFTPfX();
          }
        }
      } else{
        $scope.errType = "allFields";
        $scope.hasErr = true;
      }
      $scope.saveFTPfX = function(){
        FTPSrv.saveFTP($scope.ftp).then(
          function(data){
            $scope.saveProcessing = false;
            $state.go("hub.contentLibrary.c");
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FSChromeController', FSChromeController);

  /** @ngInject */
  function FSChromeController($log, $rootScope, $scope, $state, $cookies, $timeout, FSChromeSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FSChromeSrv.getFSChrome($scope.decId).then(
        function(data){
          $scope.fsChrome = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.fsChrome = {label:"", url:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.fsChromeFx = function(){
      $scope.fsChrome.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.fsChrome.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.fsChrome.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveFSChromeFx();
          }, 250);
        } else{
          $scope.saveFSChromeFx();
        }
      }
    }
    $scope.saveFSChromeFx = function(){
      FSChromeSrv.saveFSChrome($scope.fsChrome).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FreeFormController', FreeFormController);

  /** @ngInject */
  function FreeFormController($log, $rootScope, $scope, $state, $cookies, $timeout, FreeFormSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FreeFormSrv.getFreeForm($scope.decId).then(
        function(data){
          $scope.freeForm = data;
          $scope.detailLoading = false;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.freeForm = {label:"", frameW:"", frameH:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.freeFormFx = function(){
      $scope.freeForm.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.freeForm.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveFreeFormFx();
          }, 250);
        } else{
          $scope.saveFreeFormFx();
        }
      }
    }
    $scope.saveFreeFormFx = function(){
      FreeFormSrv.saveFreeForm($scope.freeForm).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FlightScheduleController', FlightScheduleController);

  /** @ngInject */
  function FlightScheduleController($log, $rootScope, $scope, $state, $cookies, $timeout, FlightScheduleSrv){
    $scope.colorPicker = {b:false, hb:false, ht:false, rb:false, ab:false, fc:false, an:false, cn:false, tm:false, te:false, sd:false, os:false, ca:false, de:false, ad:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#000000", bga:1, headerBg:"#cc0000", headerBga:1, headerText:"#ffffff", headerFont:$scope.fontFamilySelected, rowBg:"#000000", rowBga:1, rowFont:$scope.fontFamily[56], rowSize:24, altBg:"#444444", altBga:1, altFont:$scope.fontFamily[56], altSize:24, ontimeText:"#6aa84f", canceledText:"#cc0000", delayedText:"#ff9900", arrivedText:"#3d85c6", flight:"#6aa84f", airline:"#cccccc", city:"#ffffff", time:"#ffffff", terminal:"#ffffff", statusDefault:"#ffffff"},
      ctype:{bg:"monochrome", headerBg:"default", headerText:"monochrome", rowBg:"monochrome", altBg:"monochrome", ontime:"default", canceled:"default", delayed:"basic", arrived:"default", flight:"default", airline:"monochrome", city:"monochrome", time:"monochrome", terminal:"monochrome", statusDefault:"monochrome"}
    };
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.flight.settings = angular.copy($scope.defaultSettings.settings);
      $scope.flight.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FlightScheduleSrv.getFlightSchedule($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.flight = data;
          $scope.settings.settings = angular.copy($scope.flight.settings);
          $scope.settings.ctype = angular.copy($scope.flight.ctype);
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.detailLoading = true;
      $scope.flight = {
        labelOpt:"a", label:"", airport:"", airportCode:"", dType:"Arrival", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    /*Get Airport Codes*/
    FlightScheduleSrv.getAirportCodes().then(
      function(data){
        $scope.airportCodes = data.iata_airport_codes;
        $scope.detailLoading = false;
      }, function(err){
        $log.error(err);
        $scope.detailLoading = false;
      }
    );

    $scope.matchAirportCode = function(){
      for(var i = 0;i < $scope.airportCodes.length;i++){
        if($scope.airportCodes[i].code == $scope.flight.airportCode){
          return $scope.airportCodes[i].airport;
        }
      }
    }

    $scope.onSelect = function($model){
      angular.forEach($scope.airportCodes, function(item){
        if($model == item.airport){
          $scope.flight.airportCode = item.code;
        }
      });
    }

    $scope.flightFx = function(){
      $scope.flight.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.flight.labelOpt == "c" && $scope.flight.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.flight.airport == "" || $scope.flight.airportCode == ""){
        $scope.errType = "airport";
        $scope.hasErr = true;
        $("#airport").focus();
      } else if(!$scope.flight.settings.rowSize){
        $scope.errType = "rowSize";
        $scope.hasErr = true;
        $("#rowSize").focus();
      } else if(!$scope.flight.settings.altSize){
        $scope.errType = "altSize";
        $scope.hasErr = true;
        $("#altSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveFlightScheduleFx();
          }, 250);
        } else{
          $scope.saveFlightScheduleFx();
        }
      }
    }

    $scope.saveFlightScheduleFx = function(){
      $scope.saveProcessing = true;
      FlightScheduleSrv.saveFlightSchedule($scope.flight).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FillerContentController', FillerContentController);

  /** @ngInject */
  function FillerContentController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, fancyboxService, ContentLibrarySrv, FillerContentSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.contentList = [];
    $scope.isPEOpen = false;
    $scope.thumbSize = "n";
    $scope.search = {text:""};
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{pbs:"r"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.fillerContent.settings = angular.copy($scope.defaultSettings.settings);
    }

    $scope.setQuadHeightFx = function(){
      if($scope.auth.upreferences.isSplitV){
        $scope.quadHeight = $scope.getAvailableHeight(400);
        $scope.selectedHeight = $scope.getAvailableHeight(400);
        if(!$state.params.id){
          $scope.quadHeight = $scope.getAvailableHeight(425);
          $scope.selectedHeight = $scope.getAvailableHeight(425);
        }
      } else{
        $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
        $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
      }
    }
    $scope.setQuadHeightFx();

    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.text = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.text;
      }
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      FillerContentSrv.getFillerContent($scope.decId).then(
        function(data){
          $scope.fillerContent = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.fillerContent = {label:"", activePeriod:{type:"a"}, content:[], permission:{type:$scope.auth.upreferences.defaultP}, settings:angular.copy($scope.settings.settings)};
    }

    $rootScope.selectedTabFx = function(){
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.advancedShow = false;
      $scope.searchChangeFx("empty");
      if($rootScope.selectedT == 2){
        $scope.contentLibraryLoading = true;
        $scope.hasErr = false;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );

        $scope.updateList = function(){
          $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
          if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
            $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
          }

          $scope.tim = $scope.contentLibrary.info.timthumb;
          $scope.contentLibraryLoading = false;
          $rootScope.selectedItems = [];
          $scope.breadCrumbs = [];
          $scope.contentList = [];
          $scope.folderList = [];

          if($scope.contentLibrary.info.breadCrumbs){
            $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
          }
          if($scope.contentLibrary.contentLibrary.folder){
            $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
          }
          if($scope.contentLibrary.contentLibrary.content){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Image" || item.type == "Video" || (item.type == "Widget" && item.extn == "Live Streaming") || (item.splType && item.splType == "Image" || item.splType == "Video")){
                $scope.contentList.push(item);
              }
            });
          }
        }
        /*For select content*/
        $scope.briefFx = function(){
          for(var i = 0;i < $rootScope.selectedItems.length;i++){
            if($rootScope.selectedItems[i].type != 'folder'){
              for(var j = 0;j < $scope.contentList.length;j++){
                if($rootScope.selectedItems[i].id == $scope.contentList[j].id){ //For normal Content
                  $scope.fillerContent.content.push({
                    hidden:0,
                    isAccessible:true,
                    id:$scope.contentList[j].id,
                    fid:$scope.contentList[j].fid,
                    url:$scope.contentList[j].url,
                    extn:$scope.contentList[j].extn,
                    btnExtn:$scope.contentList[j].btnExtn,
                    type:$scope.contentList[j].type,
                    label:$scope.contentList[j].label,
                    thumb:$scope.contentList[j].thumb,
                    width:$scope.contentList[j].width,
                    height:$scope.contentList[j].height,
                    splFid:$scope.contentList[j].splFid,
                    Length:$scope.contentList[j].Length,
                    path:$scope.contentLibrary.info.path,
                    splType:$scope.contentList[j].splType,
                    duration:$scope.contentList[j].duration,
                    isCompleted:$scope.contentList[j].isCompleted,
                    MajorVersion:$scope.contentList[j].MajorVersion,
                    ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
                  });
                  break;
                }
              }
            }
          }
        }
        $scope.setQuadHeightFx();
      } else {
        $scope.setQuadHeightFx();
      }
    }
    $rootScope.selectedTabFx();
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLibraryLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.searchChangeFx("empty");
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.advancedShow = false;
          $scope.updateList();
          $scope.setQuadHeightFx();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeContentFx = function(id, i){
      for(i = 0;i < $scope.fillerContent.content.length;i++){
        if($scope.fillerContent.content[i].id == id){
          $scope.fillerContent.content.splice(i, 1);
          break;
        }
      }
    }
    $scope.folderBriefFx = function(){}

    $scope.fillerContentFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.fillerContent.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      } else if(!$scope.auth.upermissions.dmb_c && $scope.fillerContent.settings.pbs == "s"){
        $scope.errType = "playback";
        $scope.hasErr = true;
        return;
      }

      if(tab == 1 || caller == "save"){
        if(tab == 1){
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $scope.tabFx(2, 'tabFx');
            $scope.isPEOpen = false;
          }
        } else{
          if($scope.fillerContent.content.length){
            angular.forEach($scope.fillerContent.content, function(item){
              if((item.duration == "" || item.duration == "0" || isNaN(item.duration) || item.duration < 1) && !$scope.hasErr){
                $scope.errType = "durationEmpty";
                $scope.hasErr = true;
              }
            });
            if($scope.hasErr){
              return;
            }
          }
          if($scope.fillerContent.label == ""){
            $scope.errType = "name";
            $scope.hasErr = true;
            $("#label").focus();
          } else if(!$scope.auth.upermissions.dmb_c && $scope.fillerContent.settings.pbs == "s"){
            $scope.errType = "playback";
            $scope.hasErr = true;
          } else{
            $scope.fillerContent.fid = $scope.fid;
            $scope.saveProcessing = true;
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveFillerContent();
              }, 250);
            } else{
              $scope.saveFillerContent();
            }
          }
        }
      }
    }

    $scope.saveFillerContent = function(){
      FillerContentSrv.saveFillerContent($scope.fillerContent).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.fbGalleryFx = function(index){
      $scope.fbGallery = {};
      $scope.curfbObj1 = [];
      $scope.curfbObj2 = [];
      angular.forEach($filter("reverse")($scope.fillerContent.content), function(item, itemIndex){
        if(index === itemIndex){
          $scope.curfbObj1.push({href:$scope.cBucket + $filter("secureThumb")(item.thumb), title:item.label});
        } else{
          $scope.curfbObj2.push({href:$scope.cBucket + $filter("secureThumb")(item.thumb), title:item.label});
        }
      });
      $scope.fbGallery = $scope.curfbObj1.concat($scope.curfbObj2);
      fancyboxService.fancyboxPlus()($scope.fbGallery, $scope.fbGroup);
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.searchChangeFx("empty");
      $scope.advancedShow = true;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.advSearchInfo = args.info;

      if($scope.auth.upreferences.isSplitV){
        console.warn("Vertical");
        if($scope.advSearchInfo.name != undefined || $scope.advSearchInfo.createdBy != undefined || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.quadHeight = $scope.getAvailableHeight(480);
          $scope.selectedHeight = $scope.getAvailableHeight(480);
        } else if($scope.advSearchInfo.name == undefined && $scope.advSearchInfo.createdBy == undefined && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.quadHeight = $scope.getAvailableHeight(400);
          $scope.selectedHeight = $scope.getAvailableHeight(400);
          if(!$state.params.id){
            $scope.quadHeight = $scope.getAvailableHeight(425);
            $scope.selectedHeight = $scope.getAvailableHeight(425);
          }
          console.warn("clear");
        }
      } else {
        console.warn("horizontal");
        if($scope.advSearchInfo.name != undefined || $scope.advSearchInfo.createdBy != undefined || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.quadHeight = $scope.getAvailableHeight(500) * 0.55;
          $scope.selectedHeight = $scope.getAvailableHeight(480) * 0.45;
        } else if($scope.advSearchInfo.name == undefined && $scope.advSearchInfo.createdBy == undefined && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          // $scope.quadHeight = $scope.getAvailableHeight(480) * 0.55;
          // $scope.selectedHeight = $scope.getAvailableHeight(460) * 0.45;
          $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
          $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
        }
      }

      // if(!$state.params.id){
      //   if(($scope.advSearchInfo.name && $scope.advSearchInfo.name != null) || ($scope.advSearchInfo.createdBy && $scope.advSearchInfo.createdBy != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.type != null || $scope.advSearchInfo.type != ""){
      //     $scope.quadHeight = $scope.getAvailableHeight(505);
      //     $scope.selectedHeight = $scope.getAvailableHeight(505);
      //   } else if(($scope.advSearchInfo.name && $scope.advSearchInfo.name == null) && ($scope.advSearchInfo.createdBy && $scope.advSearchInfo.createdBy == null) && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
      //     $scope.quadHeight = $scope.getAvailableHeight(435);
      //     $scope.selectedHeight = $scope.getAvailableHeight(435);
      //     console.warn("BBBB");
      //   }
      // }
      $scope.folderList = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Video" || (item.type == "Widget" && item.extn == "Live Streaming")){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    $scope.sortCallback = function(e, ui, index){
      $scope.contentListCopy = angular.copy($scope.fillerContent.content);
      $scope.tempContentList = [];

      $(".sortable-item").each(function($index){
        for(var i = 0;i < $scope.contentListCopy.length;i++){
          if(($scope.contentListCopy[i].id == $(this).attr("data-id")) && ($scope.contentListCopy[i].duration == $(this).find(".duration").val())){
            $scope.tempContentList.push($scope.contentListCopy[i]);
            $scope.contentListCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.fillerContent.content = [];
      $scope.$apply(function(){
        $scope.fillerContent.content = angular.copy($scope.tempContentList);
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FifaController', FifaController);

  /** @ngInject */
  function FifaController($log, $rootScope, $scope, $state, $cookies, $timeout, FifaSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FifaSrv.getFifa($scope.decId).then(
        function(data){
          $scope.fifa = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.fifa = {label:"FIFA World Cup - Russia 2018", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.fifaFx = function(){
      $scope.fifa.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.fifa.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveFifaFx();
          }, 250);
        } else{
          $scope.saveFifaFx();
        }
      }
    }
    $scope.saveFifaFx = function(){
      FifaSrv.saveFifa($scope.fifa).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FacebookWorkplaceController', FacebookWorkplaceController);

  /** @ngInject */
  function FacebookWorkplaceController($log, $rootScope, $scope, $state, $interval, $cookies, $timeout, FacebookWpSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, rt:false, ab:false, at:false};
    $scope.fid = localStorage.getItem("curFId");

    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isClosed = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.selectedOption = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#0b5394", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#444444", altTitleText:"#444444", rowFont:$scope.fontFamilySelected, altRowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18},
      ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"monochrome", altTitleText:"monochrome"}
    }
    $scope.settingsV = {mute:false};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.facebookWp.settings = angular.copy($scope.defaultSettings.settings);
      $scope.facebookWp.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.resetGrp = function(){
      $scope.groupList = [];
      $scope.facebookWp.appSecret = "";
      $scope.facebookWp.wGroupSel = "";
    }

    $scope.pList = [];
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FacebookWpSrv.getFacebookWorkplace($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.facebookWp = data;

          if($scope.facebookWp.wGroupAll.length > 0){
            $scope.groupList = $scope.facebookWp.wGroupAll;
          }
          $scope.pList = data.pageList;
          if($scope.facebookWp.dType == 't'){
            if(!$scope.facebookWp.ctype){
              $scope.facebookWp.settings = angular.copy($scope.facebookWp.settings);
              $scope.facebookWp.ctype = angular.copy($scope.settings.ctype);
            } else{
              $scope.settings.settings = angular.copy($scope.facebookWp.settings);
              $scope.settings.ctype = angular.copy($scope.facebookWp.ctype);
            }
          }

          // Decrypt
          if(data.accessToken){
            var decryptedToken = $scope.decryptChunksFx(data.accessToken);
            $scope.facebookWp.accessToken = decryptedToken;
          }
          if(data.appId){
            $scope.facebookWp.appId = $scope.decryptFx(data.appId);
          }
          if(data.appSecret){
            $scope.facebookWp.appSecret = $scope.decryptFx(data.appSecret);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.facebookWp = {
        labelOpt:"c", label:"", isAppSecret:false, accessToken:"", appSecret:"", appId:"", wGroupSel:"", wGroupAll:"", dType:"t", page:null, activePeriod:{type:"a"}, toast:false, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.dTypeChange = function(caller){
      if(caller == "t"){
        if(!$scope.facebookWp.ctype){
          $scope.settingsDefault();
        }
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h){
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      $scope.childWindow = window.open($scope.rUrl, 'Authorize access to your account', 'toolbar=0,directories=no,status=0,width=' + w + ',height=' + h + ',top=' + top + ', left=' + left);
      $scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        FacebookWpSrv.getVerify($scope.facebookWp.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              $scope.pList = data.pageList;
              $scope.pListShow = true;
              if(data.isClosed){
                $scope.isClosed = true;
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.facebookWpFx = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "save"){
        if($scope.facebookWp.labelOpt == 'c' && $scope.facebookWp.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.facebookWp.dType == 't' && $scope.facebookWp.settings.rotationOpt == "c" && $scope.facebookWp.settings.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#rotation").focus();
        } else if($scope.facebookWp.dType == 't' && $scope.facebookWp.settings.hTextOpt == "c" && $scope.facebookWp.settings.hText == ""){
          $scope.errType = "headerText";
          $scope.hasErr = true;
          $("#hText").focus();
        } else if($scope.facebookWp.dType == "t" && !$scope.facebookWp.settings.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#hSize").focus();
        } else if($scope.facebookWp.dType == "t" && !$scope.facebookWp.settings.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#tSize").focus();
        } else if($scope.facebookWp.accessToken == ""){
          $scope.errType = "accessToken";
          $scope.hasErr = true;
          $("#accessToken").focus();
        } else if($scope.facebookWp.isAppSecret && ($scope.facebookWp.appSecret == "" || $scope.facebookWp.appSecret == undefined)){
          $scope.errType = "appSecret";
          $scope.hasErr = true;
          $("#appSecret").focus();
        } else if($scope.facebookWp.wGroupSel == "" || ($scope.facebookWp.wGroupAll.length > 0 && $scope.facebookWp.wGroupSel == "")){
          $scope.errType = "group";
          $scope.hasErr = true;
          $("#group").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveFacebookFx(caller);
            }, 250);
          } else{
            $scope.saveFacebookFx(caller);
          }
        }
      }
    }

    $scope.searchGroupFx = function(){
      $scope.hasErr = false;
      if($scope.facebookWp.accessToken == ""){
        $scope.errType = "accessToken";
        $scope.hasErr = true;
        $("#accessToken").focus();
      } else if($scope.facebookWp.isAppSecret && ($scope.facebookWp.appSecret == "" || $scope.facebookWp.appSecret == undefined)){
        $scope.errType = "appSecret";
        $scope.hasErr = true;
        $("#appSecret").focus();
      } else{
        $scope.groupObj = {accessToken:$scope.encryptedChunksFx($scope.facebookWp.accessToken), appSecret:$scope.encryptFx($scope.facebookWp.appSecret), isAppSecret:$scope.facebookWp.isAppSecret};

        FacebookWpSrv.getGroup($scope.groupObj).then(
          function(data){
            $scope.groupList = data.g;
            if($scope.groupList.length > 0){
              $scope.facebookWp.wGroupAll = $scope.groupList;
            }
            if(data.g.length == 0 && angular.isArray(data.e)){
              $scope.errType = "noGrp";
              $scope.hasErr = true;
              $("#searchGroupBtn").focus();
            }
            if(data.g.length == 0 && !angular.isArray(data.e)){
              $scope.facebookWp.wGroupSel = "";
              $scope.errType = "invalid";
              $scope.hasErr = true;
              $("#searchGroupBtn").focus();
            }
            $scope.saveProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.saveFacebookFx = function(caller){
      if(caller == "save"){
        $scope.facebookWp.toast = true;
      } else{
        $scope.facebookWp.toast = false;
      }
      $scope.facebookWp.fid = $scope.fid;
      if($scope.facebookWp.dType == "m"){
        $scope.facebookWp.settings = null;
        $scope.facebookWp.ctype = null;
      } else if($scope.facebookWp.dType == "v"){
        $scope.facebookWp.settings = angular.copy($scope.settingsV);
        $scope.facebookWp.ctype = null;
      }
      if(caller == 'save'){
        $scope.saveProcessing = true;
      }
      if(!$scope.facebookWp.isAppSecret){
        $scope.facebookWp.appSecret = "";
      }
      $scope.facebookWp.labelOpt = "c"; // Temporally solution

      var tempFacebookWp = angular.copy($scope.facebookWp);
      if($scope.facebookWp.accessToken){
        tempFacebookWp.accessToken = $scope.encryptedChunksFx($scope.facebookWp.accessToken);
      }
      if($scope.facebookWp.appId){
        tempFacebookWp.appId = $scope.encryptFx($scope.facebookWp.appId);
      }
      if($scope.facebookWp.isAppSecret && $scope.facebookWp.appSecret){
        tempFacebookWp.appSecret = $scope.encryptFx($scope.facebookWp.appSecret);
      }

      FacebookWpSrv.saveFacebookWorkplace(tempFacebookWp).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.facebookWp.id = data.id;
          $scope.rUrl = data.rUrl;
          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FacebookController', FacebookController);

  /** @ngInject */
  function FacebookController($log, $rootScope, $scope, $state, $interval, $cookies, $timeout, FacebookSrv){
    $scope.colorPicker = {hb:false, ht:false, b:false, rb:false, rt:false, ab:false, at:false};
    $scope.fid = localStorage.getItem("curFId");

    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isClosed = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, hTextOpt:"a", hText:"", headerBg:"#ffffff", headerBga:1, headerText:"#0b5394", headerFont:$scope.fontFamilySelected, bg:"#ffffff", bga:1, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleText:"#444444", altTitleText:"#444444", rowFont:$scope.fontFamilySelected, altRowFont:$scope.fontFamilySelected, headerSize:26, titleSize:24, descSize:18},
      ctype:{headerBg:"monochrome", headerText:"default", bg:"monochrome", rowBg:"monochrome", altBg:"monochrome", titleText:"monochrome",  altTitleText:"monochrome"}
    }
    $scope.settingsV = {mute:false};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.facebook.settings = angular.copy($scope.defaultSettings.settings);
      $scope.facebook.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.pList = [];
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      FacebookSrv.getFacebook($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.facebook = data;
          $scope.pList = data.pageList;
          if($scope.facebook.dType=='t'){
            if(!$scope.facebook.ctype){
              $scope.facebook.settings = angular.copy($scope.settings.settings);
              $scope.facebook.ctype = angular.copy($scope.settings.ctype);
            } else{
              $scope.settings.settings = angular.copy($scope.facebook.settings);
              $scope.settings.ctype = angular.copy($scope.facebook.ctype);
            }
          } else if($scope.facebook.dType=='v'){
            $scope.settingsV = angular.copy($scope.facebook.settings);
          }
          if($scope.pList.length > 0 || $scope.facebook.facebookData){
            $scope.pListShow = true;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.facebook = {
        labelOpt:"c", label:"", url:"", dType:"t", page:null, activePeriod:{type:"a"}, toast:false, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.dTypeChange = function(caller){
      if(caller == "t"){
        if(!$scope.facebook.ctype){
          $scope.settingsDefault();
        }
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.authSuccess = false;
    }
    $rootScope.selectedTabFx();

    $scope.openUrlFx = function(w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      $scope.childWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      $scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        FacebookSrv.getVerify($scope.facebook.id).then(
          function(data){
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8136){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.authSuccess = false;
              $interval.cancel($scope.childWindowInt);
            } else{
              $scope.pList = data.pageList;
              $scope.pListShow = true;
              if(data.isClosed){
                $scope.isClosed = true;
                //$scope.gCalendar.isAuthorized = true;
                $scope.authSuccess = true;
              } else{
                $scope.hasErr = true;
                $scope.errType = "authFailed";
                $scope.authSuccess = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.facebookFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.selectedT == 1 && (tab == 1 || caller == "save")){
        if($scope.facebook.labelOpt == 'c' && $scope.facebook.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.facebook.dType == 'v' && $scope.facebook.url == ""){
          $scope.errType = "url";
          $scope.hasErr = true;
          $("#url").focus();
        } else if($scope.facebook.dType == 't' && $scope.facebook.settings.rotationOpt == "c" && $scope.facebook.settings.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#rotation").focus();
        } else if($scope.facebook.dType == 't' && $scope.facebook.settings.hTextOpt == "c" && $scope.facebook.settings.hText == ""){
          $scope.errType = "headerText";
          $scope.hasErr = true;
          $("#headerText").focus();
        } else if($scope.facebook.dType == "t" && !$scope.facebook.settings.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#hSize").focus();
        } else if($scope.facebook.dType == "t" && !$scope.facebook.settings.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#tSize").focus();
        } else if($scope.facebook.dType != 'v' && caller == "save" && !$scope.facebook.facebookData){
          $scope.errType = "authFailed";
          $scope.hasErr = true;
          $("#authFailed").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveFacebookFx(caller);
            }, 250);
          } else{
            $scope.saveFacebookFx(caller);
          }
        }
      } else if(tab == 2 || caller == 'save'){
        if(!$scope.facebook.facebookData && !$scope.isClosed){
          $scope.errType = "authFailed";
          $scope.hasErr = true;
        } else if(!$scope.pList.length || !$scope.facebook.page){
          $scope.errType = "pList";
          $scope.hasErr = true;
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveFacebookFx(caller);
            }, 250);
          } else{
            $scope.saveFacebookFx(caller);
          }
        }
      }
    }

    $scope.saveFacebookFx = function(caller){
      if(caller == "save"){
        $scope.facebook.toast = true;
      } else{
        $scope.facebook.toast = false;
      }
      $scope.facebook.fid = $scope.fid;
      if($scope.facebook.dType == "m"){
        $scope.facebook.settings = null;
        $scope.facebook.ctype = null;
      } else if($scope.facebook.dType == "v"){
        $scope.facebook.settings = angular.copy($scope.settingsV);
        $scope.facebook.ctype = null;
      }
      if(caller == 'save'){
        $scope.saveProcessing = true;
      }
      $scope.facebook.labelOpt = "c"; // Temporally solution
      FacebookSrv.saveFacebook($scope.facebook).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.facebook.id = data.id;
          
          //URL client id decryption
          $scope.rUrl = data.rUrl;
          if(data.rUrl){
            var client_id = "";
            if(data.client_id){
              client_id = $scope.decryptFx(data.client_id);
            }
            var urlObj = new URL(data.rUrl);
            var params = urlObj.searchParams;
            if(!params.has("client_id")){
              params.set("client_id", client_id);
              var updatedUrl = urlObj.toString();
              if(updatedUrl){
                $scope.rUrl = updatedUrl;
              }
            }
          }

          if(data.code == 8089){
            $scope.errType = "";
            $scope.hasErr = true;
          } else if(caller == "save"){
            $state.go("hub.contentLibrary.c");
          } else{
            $scope.tabFx(2, 'tabFx');
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('WorkController', WorkController);

  /** @ngInject */
  function WorkController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, WorkSrv){
    $scope.colorPicker = {b:false, c:false, t:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#ffffff", bga:1, icColor:"#ff0000", text:"#000000", font:$scope.fontFamilySelected, size:24, p:"t", txt:"WORK"},
      ctype:{bg:"monochrome", icColor:"basic", text:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      WorkSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#size").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      WorkSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('StoryController', StoryController);

  /** @ngInject */
  function StoryController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, TemplatesSrv, StorySrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.templateList = [];
    $scope.isPEOpen = false;
    $scope.curScreen = [];
    $scope.subTab = 1;
    $scope.encId = "";
    $scope.decId = "";

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(425);
      $scope.selectedHeight = $scope.getAvailableHeight(425);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
      $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      StorySrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        screens:[]
      };
      for(var i=0; i<$scope.widgetList.f45S.screen; i++){
        $scope.f45Data.screens.push({value:i+1, scene:[]});
      }
    }

    $scope.updateList = function(){
      $scope.templatesLoading = false;
      $rootScope.selectedItems = [];
      $scope.templateList = [];
      $scope.tim = $scope.templates.info.timthumb;
      $scope.cBucket = $scope.cDetailBucket = $scope.templates.info.bucket;
      if($scope.templates.info.mbucket && $scope.templates.info.mbucket != ""){
        $scope.cDetailBucket = $scope.templates.info.mbucket;
      }
      if($scope.templates && $scope.templates.templates){
        $scope.templateList = $scope.templates.templates;
      }
    }

    $scope.subTabFx = function(caller, action){
      $scope.subTab = caller;
      $scope.curScreen = [];
      $scope.curScreen = $filter("filter")($scope.f45Data.screens, {value:$scope.subTab})[0];
    }

    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 2){
        $scope.templatesLoading = true;
        $scope.hasErr = false;
        TemplatesSrv.getTemplates("ts").then(
          function(data){
            $scope.templatesLoading = false;
            $scope.templates = data;
            $scope.updateList();
            $scope.subTabFx(1);
          },
          function(err){
            $scope.templatesLoading = false;
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx();

    /*For select templates*/
    $scope.curItem;
    $scope.briefFx = function(){
      var curScene = $filter("filter")($scope.f45Data.screens, {value:$scope.subTab});
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.curItem = $scope.templateList.filter(function(obj){return obj.id == item.id;})[0];
        curScene[0].scene.push({
          id:item.id, label:$scope.curItem.label, userid:$scope.auth.uid, thumb:$scope.curItem.thumb, thumbV:$scope.curItem.thumbV, duration:$scope.curItem.duration, isCompleted:$scope.curItem.isCompleted, mute:$scope.mic, hidden:0
        });
      });
      angular.forEach($scope.f45Data.screens, function(item){
        if(item.value == $scope.subTab){
          item = curScene;
        }
      });
    }

    $scope.closeFilteredFx = function(id, i){
      angular.forEach($scope.curScreen.scene, function(item, index){
        if(id == item.id && index == i){
          $scope.curScreen.scene.splice($scope.curScreen.scene.indexOf(item), 1);
        }
      });
    }

    $scope.sortCallback = function(e, ui, index){
      $scope.curSceneCopy = angular.copy($scope.curScreen.scene);
      $scope.tempSceneList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0; i < $scope.curSceneCopy.length; i++){
          if(($scope.curSceneCopy[i].id == $(this).attr("data-id"))){
            $scope.tempSceneList.push($scope.curSceneCopy[i]);
            $scope.curSceneCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.curScreen.scene = [];
      $scope.$apply(function(){
        $scope.curScreen.scene = angular.copy($scope.tempSceneList);
      });
    }

    $scope.f45SaveFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.f45Data.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }
          } else{
            if($scope.f45Data.screens.length){
              angular.forEach($scope.f45Data.screens, function(screen){
                angular.forEach(screen.scene, function(scene){
                  if((scene.duration == "" || scene.duration == "0" || isNaN(scene.duration) || scene.duration < 1) && !$scope.hasErr){
                    $scope.errType = "durationEmpty";
                    $scope.hasErr = true;
                  }
                });
              });
              if($scope.hasErr){
                return;
              }
            }
            $scope.f45Data.fid = $scope.fid;
            $scope.saveProcessing = true;
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveDataFx();
              }, 250);
            } else{
              $scope.saveDataFx();
            }
          }
        }
      }
    }

    $scope.saveDataFx = function(){
      StorySrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.filterValue = function($event){
      if(isNaN(String.fromCharCode($event.keyCode))){
        $event.preventDefault();
      }
    };

    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('StayController', StayController);

  /** @ngInject */
  function StayController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, StaySrv){
    $scope.colorPicker = {b:false, c:false, t:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{dType:"h", bg:"#ffffff", bga:1, icColor:"#0b5394", text:"#000000", font:$scope.fontFamilySelected, size:24, p:"t", txt:"STAY"},
      ctype:{bg:"monochrome", icColor:"default", text:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      StaySrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#size").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      StaySrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ProgressBarWithBreakController', ProgressBarWithBreakController);

  /** @ngInject */
  function ProgressBarWithBreakController($log, $rootScope, $scope, $state, $cookies, $timeout, ngDialog, ProgressBarWithBreakSrv){
    $scope.colorPicker = {b:false, f:false, bk:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.curTblId = 0;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#ffffff", bga:1, fill:"#444444", break:"#000000"},
      ctype:{bg:"monochrome", fill:"monochrome", break:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ProgressBarWithBreakSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", list:[], activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.sortCallback = function(){
      $scope.f45Data.list = [];
      angular.forEach(angular.element(".sortable-item"), function(item){
        $scope.f45Data.list.push({id:$(item).attr("data-id"), type:$(item).find(".codeType").text(), d:$(item).find(".codeDuration").text()});
      });
    }

    $scope.curData = {id:"", type:"Bar", d:1};
    $scope.addFx = function(){
      $scope.addErr = false;
      if(!$scope.curData.d){
        $scope.addErr = true;
        $("#curDataD").focus();
        return;
      }
      $scope.curData.id = "t" + $scope.curTblId,
      $scope.f45Data.list.push($scope.curData);
      $scope.curTblId++;
      $scope.curData = {type:"Bar", d:1};
      $("#type").focus();
    }

    $scope.editFx = function(element){
      $scope.curItem = {type:$(element.target).closest(".item-row").find(".codeType").text(), d:Number($(element.target).closest(".item-row").find(".codeDuration").text())};
      $(element.target).closest(".item-row").find("select").val($scope.curItem.type);
      $(element.target).closest(".item-row").find("input").val($scope.curItem.d);
    }

    $scope.curItem = {type:"", d:1};
    $scope.saveItemFx = function(element){
      $scope.curItem = {type:$(element.target).closest(".item-row").find("select").val(), d:Number($(element.target).closest(".item-row").find("input").val())};
      if($scope.curVal.type != "" || $scope.curVal.d >= 1){
        $(element.target).closest(".item-row").find(".codeType").text($scope.curItem.type);
        $(element.target).closest(".item-row").find(".codeDuration").text($scope.curItem.d);
      }
      $scope.sortCallback();
    }

    $scope.inputCallbackFx = function(element){
      $scope.curVal = {type:$(element.target).closest(".item-row").find("select").val(), d:Number($(element.target).closest(".item-row").find("input").val())};
      if($scope.curVal.type == "" || $scope.curVal.d <= 0){
        $(element.target).closest(".item-row").find(".btn-success").attr('disabled', '');
      } else{
        $(element.target).closest(".item-row").find(".btn-success").removeAttr('disabled');
      }
    }

    $scope.cancelItemFx = function(element){
      $scope.curItem = {type:$(element.target).closest(".item-row").find(".codeType").text(), d:Number($(element.target).closest(".item-row").find(".codeDuration").text())};
      $(element.target).closest(".item-row").find("select").val($scope.curItem.type);
      $(element.target).closest(".item-row").find("input").val($scope.curItem.d);
    }

    $scope.deleteProcessing = false;
    $scope.deleteOpen = function(id){
      $scope.deleteId = id;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.deleteFx = function(){
      angular.forEach($scope.f45Data.list, function(list){
        if($scope.deleteId == list.id){
          $scope.f45Data.list.splice($scope.f45Data.list.indexOf(list), 1);
        }
      });
      ngDialog.close();
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      ProgressBarWithBreakSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('F45ProgressBarController', F45ProgressBarController);

  /** @ngInject */
  function F45ProgressBarController($log, $rootScope, $scope, $state, $cookies, $timeout, ProgressBarSrv){
    $scope.colorPicker = {b:false, bc:false,gc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{d:12, bg:"#cccccc", bga:1, fill:"#444444", st:3,gl:true, glc:"#6fa8dc" , hoff:0.2, voff:0.2, blr:0.8, rc:true},
      ctype:{bg:"monochrome", fill:"monochrome", glc:"default"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ProgressBarSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.d){
        $scope.errType = "duration";
        $scope.hasErr = true;
        $("#duration").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      ProgressBarSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MoveStationController', MoveStationController);

  /** @ngInject */
  function MoveStationController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, MoveStationSrv){
    $scope.colorPicker = {b:false, c:false, t:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#ffffff", bga:1, icColor:"#0b5394", font:$scope.fontFamilySelected, size:24, text:"#000000", p:"t", txt:"MOVE STATION"},
      ctype:{bg:"monochrome", icColor:"default", text:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      MoveStationSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#size").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      MoveStationSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('HydrateController', HydrateController);

  /** @ngInject */
  function HydrateController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, HydrateSrv){
    $scope.colorPicker = {b:false, c:false, t:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#ffffff", bga:1, icColor:"#0b5394", text:"#000000", font:$scope.fontFamilySelected, size:24, p:"t", txt:"HYDRATE"},
      ctype:{bg:"monochrome", icColor:"default", text:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      HydrateSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      HydrateSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CountdownCircleController', CountdownCircleController);

  /** @ngInject */
  function CountdownCircleController($log, $rootScope, $scope, $state, $cookies, $timeout, CountdownCircleSrv){
    $scope.colorPicker = {b:false, t:false, gc:false, bb:false, f:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{d:12, bg:"#ffffff", bga:1, barBg:"#ffffff", barBga:1, fill:"#444444", text:"#0b5394", font:$scope.fontFamilySelected, size:24, st:3, gl:true, glc:"#6fa8dc" , hoff:0.2, voff:0.2, blr:0.8, rc:true
    },
      ctype:{bg:"monochrome", text:"default",  barBg:"monochrome", fill:"monochrome", glc:"default"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      CountdownCircleSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.settings.d){
        $scope.errType = "duration";
        $scope.hasErr = true;
        $("#duration").focus();
      } else if(!$scope.f45Data.settings.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#fontSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      CountdownCircleSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentTileController', ContentTileController);

  /** @ngInject */
  function ContentTileController($log, $rootScope, $scope, $state, $cookies, $timeout, ContentLibrarySrv, ContentTileSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.colorPicker = {b:false, c:false, lb:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.contentList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(425);
      $scope.selectedHeight = $scope.getAvailableHeight(425);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
      $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
    }

    $scope.settings = {
      settings:{bg:"#000000", bga:1, lBg:"#999999", text:"#cccccc", font:$scope.fontFamilySelected, size:24, tileType:"", p:"b", w:1},
      ctype:{bg:"monochrome", lBg:"monochrome", text:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ContentTileSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
          $scope.tilePreviewFx();
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", content:[], activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.updateList = function(){
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }

      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.contentLibraryLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary.content){
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Image" || item.type == "Video" || (item.splType && item.splType == "Image" || item.splType == "Video")){
            $scope.contentList.push(item);
          }
        });
      }
    }

    $scope.getTileList = function(){
      $scope.tileLoading = true;
      ContentTileSrv.getTiles().then(
        function(data){
          $scope.tileLoading = false;
          $scope.tileList = data.templates;
          $scope.tiles = data;

          $scope.tim = $scope.tiles.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.tiles.info.bucket;
          if($scope.tiles.info.mbucket && $scope.tiles.info.mbucket != ""){
            $scope.cDetailBucket = $scope.tiles.info.mbucket;
          }
        },
        function(err){
          $log.error(err);
          $scope.tileLoading = false;
        }
      );
    }
    $scope.getTileList();
    $scope.tilePreviewFx = function(){
      angular.forEach($scope.tiles.templates, function(item){
        if(item.id == $scope.f45Data.settings.tileType.id){
          $scope.tileImg = item;
        }
      })
    }
    /*For select content*/
    $scope.briefFx = function(){
      for(var i = 0; i < $rootScope.selectedItems.length; i++){
        if($rootScope.selectedItems[i].type != 'folder'){
          for(var j = 0; j < $scope.contentList.length; j++){
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){ //For normal Content
              $scope.f45Data.content.push({
                hidden:0,
                isAccessible:true,
                id:$scope.contentList[j].id,
                fid:$scope.contentList[j].fid,
                url:$scope.contentList[j].url,
                extn:$scope.contentList[j].extn,
                type:$scope.contentList[j].type,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                width:$scope.contentList[j].width,
                height:$scope.contentList[j].height,
                splFid:$scope.contentList[j].splFid,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                duration:$scope.contentList[j].duration,
                cLabel:"",
                MajorVersion:$scope.contentList[j].MajorVersion,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              break;
            }
          }
        }
      }
    }

    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 2){
        $scope.contentLibraryLoading = true;
        $scope.hasErr = false;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx();
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLibraryLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeContentFx = function(id, i){
      angular.forEach($scope.f45Data.content, function(item, index){
        if(id == item.id && index == i){
          $scope.f45Data.content.splice($scope.f45Data.content.indexOf(item), 1);
        }
      });
    }
    $scope.folderBriefFx = function(){}

    $scope.sortCallback = function(e, ui, index){
      $scope.contentListCopy = angular.copy($scope.f45Data.content);
      $scope.tempContentList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0; i < $scope.contentListCopy.length; i++){
          if(($scope.contentListCopy[i].id == $(this).attr("data-id"))){
            $scope.tempContentList.push($scope.contentListCopy[i]);
            $scope.contentListCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.f45Data.content = [];
      $scope.$apply(function(){
        $scope.f45Data.content = angular.copy($scope.tempContentList);
      });
    }


    $scope.f45SaveFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.f45Data.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.tiles.templates.length == 0){
	        $scope.errType = "eTile";
	        $scope.hasErr = true;
	      } else if(!$scope.f45Data.settings.tileType){
	        $scope.errType = "tile";
	        $scope.hasErr = true;
          $("#tileType").focus();
	      } else if(!$scope.f45Data.settings.size){
          $scope.errType = "size";
          $scope.hasErr = true;
          $("#size").focus();
        } else if(($scope.f45Data.settings.p == "r" || $scope.f45Data.settings.p == "l") && !$scope.f45Data.settings.w){
          $scope.errType = "lWidth";
          $scope.hasErr = true;
          $("#lWidth").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }
          } else{
            $scope.f45Data.fid = $scope.fid;
            $scope.saveProcessing = true;
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveDataFx();
              }, 250);
            } else{
              $scope.saveDataFx();
            }
          }
        }
      }
    }
    $scope.saveDataFx = function(){
      ContentTileSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentScrollerController', ContentScrollerController);

  /** @ngInject */
  function ContentScrollerController($log, $rootScope, $scope, $state, $cookies, $timeout, ContentLibrarySrv, ContentScrollerSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.colorPicker = {bg:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.contentList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(425);
      $scope.selectedHeight = $scope.getAvailableHeight(425);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
      $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
    }

    $scope.settings = {
      settings:{bg:"#000000", bga:0.5},
      ctype:{bg:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ContentScrollerSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", content:[], activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.updateList = function(){
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }

      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.contentLibraryLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary.content){
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Image" || item.type == "Video" || (item.splType && item.splType == "Image" || item.splType == "Video")){
            $scope.contentList.push(item);
          }
        });
      }
    }
    /*For select content*/
    $scope.briefFx = function(){
      for(var i = 0;i < $rootScope.selectedItems.length;i++){
        if($rootScope.selectedItems[i].type != 'folder'){
          for(var j = 0;j < $scope.contentList.length;j++){
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){ //For normal Content
              $scope.f45Data.content.push({
                hidden:0,
                isAccessible:true,
                id:$scope.contentList[j].id,
                fid:$scope.contentList[j].fid,
                url:$scope.contentList[j].url,
                extn:$scope.contentList[j].extn,
                type:$scope.contentList[j].type,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                width:$scope.contentList[j].width,
                height:$scope.contentList[j].height,
                splFid:$scope.contentList[j].splFid,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                duration:$scope.contentList[j].duration,
                MajorVersion:$scope.contentList[j].MajorVersion,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              break;
            }
          }
        }
      }
    }

    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 2){
        $scope.contentLibraryLoading = true;
        $scope.hasErr = false;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx();
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLibraryLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeContentFx = function(id, i){
      angular.forEach($scope.f45Data.content, function(item, index){
        if(id == item.id && index == i){
          $scope.f45Data.content.splice($scope.f45Data.content.indexOf(item), 1);
        }
      });
    }
    $scope.folderBriefFx = function(){}

    $scope.sortCallback = function(e, ui, index){
      $scope.contentListCopy = angular.copy($scope.f45Data.content);
      $scope.tempContentList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0;i < $scope.contentListCopy.length;i++){
          if(($scope.contentListCopy[i].id == $(this).attr("data-id"))){
            $scope.tempContentList.push($scope.contentListCopy[i]);
            $scope.contentListCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.f45Data.content = [];
      $scope.$apply(function(){
        $scope.f45Data.content = angular.copy($scope.tempContentList);
      });
    }

    $scope.f45SaveFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.f45Data.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }
          } else{
            if($scope.f45Data.content.length){
              angular.forEach($scope.f45Data.content, function(item){
                if((item.duration == "" || item.duration == "0" || isNaN(item.duration) || item.duration < 1) && !$scope.hasErr){
                  $scope.errType = "duration";
                  $scope.hasErr = true;
                }
              });
              if($scope.hasErr){
                return;
              }
            }
            $scope.f45Data.fid = $scope.fid;
            $scope.saveProcessing = true;
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveDataFx();
              }, 250);
            } else{
              $scope.saveDataFx();
            }
          }
        }
      }
    }

    $scope.saveDataFx = function(){
      ContentScrollerSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AnimationController', AnimationController);

  /** @ngInject */
  function AnimationController($log, $rootScope, $scope, $state, $cookies, $timeout, AnimationSrv){
    $scope.colorPicker = {b:false, bc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.previewLoading = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{fill:"#444444", extraCss:""},
      ctype:{fill:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.f45Data.settings = angular.copy($scope.defaultSettings.settings);
      $scope.f45Data.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.previewLoading = true;
      $scope.detailLoading = true;
      AnimationSrv.getData($scope.decId).then(
        function(data){
          $scope.f45Data = data;
          $scope.detailLoading = false;
          $scope.previewLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45Data = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        animation:"none",
        svgcode:"",
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.f45SaveFx = function(){
      $scope.f45Data.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.f45Data.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(!$scope.f45Data.svgcode){
        $scope.errType = "svgCode";
        $scope.hasErr = true;
        $("#svgCode").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      AnimationSrv.saveData($scope.f45Data).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('F45Controller', F45Controller);

  /** @ngInject */
  function F45Controller($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, ContentLibrarySrv, DevicesSrv, F45Srv){
    $scope.curDeviceObj = {availableDevices:[], devices:[], caller:"coe"};
    $scope.editWForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.addAdvert = {aId:null, label:"", adv:"", d:[]};
    $scope.minDate = moment().format("MM-DD-YYYY");
    $scope.thumbLandscape = "&h=30&w=40&q=80&zc=0";
    $scope.thumbPorait = "&h=40&w=25&q=80&zc=0";
    $scope.allSelectedDevices = {devices:[]};
    $scope.devices = {devices:"", info:{}};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.workoutList = [];
    $scope.addWorkout = {};
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";
    $scope.f45 = {};
    $scope.search = {text:""};

    if($scope.auth.upreferences.isPopup){
      if($scope.auth.upreferences.isSplitV){
        $scope.quadHeight = $scope.getAvailableHeight(440);
        $scope.selectedHeight = $scope.getAvailableHeight(442);
        if($state.params.id){
          $scope.quadHeight = $scope.getAvailableHeight(410);
          $scope.selectedHeight = $scope.getAvailableHeight(412);
        }
      } else{
        $scope.quadHeight = $scope.getAvailableHeight(400) * 0.50;
        $scope.selectedHeight = $scope.getAvailableHeight(325) * 0.50;
      }
    } else{
      if($scope.auth.upreferences.isSplitV){
        $scope.quadHeight = $scope.getAvailableHeight(230);
        $scope.selectedHeight = $scope.getAvailableHeight(232);
      } else{
        $scope.quadHeight = $scope.getAvailableHeight(250) * 0.55;
        $scope.selectedHeight = $scope.getAvailableHeight(290) * 0.45;
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      F45Srv.getF45($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.f45 = data;
          $scope.tim = $scope.f45.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.f45.bucket;
          if($scope.f45.mbucket && $scope.f45.mbucket != ""){
            $scope.cDetailBucket = $scope.f45.mbucket;
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.f45 = {
        day:0,
        label:"",
        devices:[],
        activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.subTab = 0;
    $scope.subTabFx = function(caller, action){
      $scope.subTab = caller;
      $scope.subLoading = true;
      $scope.f45.day = $scope.subTab;
      F45Srv.getWorkoutList($scope.f45.id, $scope.f45.day).then(
        function(data){
          $scope.subLoading = false;
          $scope.workoutList = data.workouts;
          $scope.workoutListInfo = data.info;

          $scope.tim = $scope.workoutListInfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.workoutListInfo.bucket;
          if($scope.workoutListInfo.mbucket && $scope.workoutListInfo.mbucket != ""){
            $scope.cDetailBucket = $scope.workoutListInfo.mbucket;
          }

          angular.forEach($scope.workoutList, function(w){
            w.startTime = $filter("momentTime")(w.startTime);
            w.endTime = $filter("momentTime")(w.endTime);
          });

          $scope.resetFx();
          if(!$scope.workoutList.length){
            $scope.editWForm = {isShow:true, isAdd:true, isEdit:false};
          } else if(!action){
            $scope.editWForm = {isShow:false, isAdd:false, isEdit:false};
          }
        },
        function(err){
          $log.error(err);
          $scope.subLoading = false;
        }
      );
    }

    $rootScope.selectedTabFx = function(caller){
      $scope.editWForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
      } else if($scope.selectedT == "2"){
        if(caller == "sort"){
          $scope.subTabFx($scope.subTab);
        } else{
          $scope.subTabFx(0);
        }
        $scope.resetFx();
      } else if($scope.selectedT == "3"){
        $scope.deviceListLoading = true;
        DevicesSrv.getAssignableDevices(0).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.deviceList = data;
            $scope.devices.devices = [];
            angular.forEach($scope.deviceList.devices, function(item){
              if(item.dType != "mc"){
                $scope.devices.devices.push(item);
              }
            });
          },
          function(err){
            $scope.deviceListLoading = false;
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx();

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.contentList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary.content){
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.extn == "F45 Workout"){
            $scope.contentList.push(item);
          }
        });
      }
    }

    $scope.selectContentOpen = function(caller){
      $scope.scCaller = caller;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.showAllTypeContent = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              isCompleted:listItem.isCompleted,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "2"){
          $scope.addWorkout.widget = {
            id:$scope.curContent.id,
            screenId:$scope.scCaller,
            fid:$scope.curContent.fid,
            url:$scope.curContent.url,
            extn:$scope.curContent.extn,
            type:$scope.curContent.type,
            path:$scope.curContent.path,
            label:$scope.curContent.label,
            thumb:$scope.curContent.thumb,
            duration:$scope.curContent.duration,
            isCompleted:$scope.curContent.isCompleted,
            isAccessible:$scope.curContent.isAccessible
          }
        }
        ngDialog.close();
      }
    }

    //Add Workout
    $scope.custTime = moment().set('minute', '00').utc().format();
    $scope.defaultWorkout = {
      title:"na",
      widget:"",
      repetition:5,
      endTime:$scope.custTime,
      startTime:$scope.custTime,
      dateRange:{startDate:moment().format("MM-DD-YYYY"), endDate:moment().format("MM-DD-YYYY")}
    };

    $scope.addWorkout = angular.copy($scope.defaultWorkout);

    $scope.addF45Fx = function(caller){
      $scope.hasListErr = false;
      $scope.curWorkout = {};
      $scope.errType = "";
      if($scope.id){
        $scope.f45.id = $scope.id;
      }
      $scope.copyAddWorkout = angular.copy($scope.addWorkout);
      $scope.copyAddWorkout.endTime = moment($scope.copyAddWorkout.endTime).format();
      $scope.copyAddWorkout.startTime = moment($scope.copyAddWorkout.startTime).format();
      $scope.copyAddWorkout.date = moment($scope.addWorkout.dateRange.startDate).format("YYYY-MM-DD");

      if($scope.copyAddWorkout.startTime == null || $scope.copyAddWorkout.startTime == "Invalid date"){
        $scope.errType = "start";
        $scope.hasListErr = true;
        $("#startTime").focus();
        return;
      } else if($scope.copyAddWorkout.endTime == null || $scope.copyAddWorkout.endTime == "Invalid date"){
        $scope.errType = "end";
        $scope.hasListErr = true;
        $("#endTime").focus();
        return;
      } else if($scope.copyAddWorkout.startTime >= $scope.copyAddWorkout.endTime){
        $scope.errType = "startEnd";
        $scope.hasListErr = true;
        $("#endTime").focus();
        return;
      } else if(!$scope.copyAddWorkout.widget.thumb){
        $scope.errType = "widget";
        $scope.hasListErr = true;
        $("#storyBtn").focus();
        return;
      }
      if(caller == "s"){
        $scope.addProcessing = true;
      } else{
        $scope.addMoreProcessing = true;
      }

      $scope.copyAddWorkout.startTime = $scope.copyAddWorkout.startTime.split("T")[1].split("+")[0].split("-")[0];
      $scope.copyAddWorkout.endTime = $scope.copyAddWorkout.endTime.split("T")[1].split("+")[0].split("-")[0];
      $scope.copyAddWorkout.day = $scope.f45.day;
      $scope.curWorkout = {id:$scope.f45.id, workout:$scope.copyAddWorkout};

      F45Srv.addWorkout($scope.curWorkout).then(
        function(data){
          $scope.addMoreProcessing = false;
          $scope.addProcessing = false;
          if(data.timthumb){
            $scope.tim = data.timthumb;
          }
          if(caller == "s"){
            $scope.editWForm.isShow = false;
          } else{
            $scope.editWForm.isShow = true;
          }
          $scope.subTabFx($scope.subTab, caller);
          $scope.resetFx();
        },
        function(err){
          $log.error(err);
          $scope.addProcessing = false;
          $scope.addMoreProcessing = false;
        }
      );
    }

    $scope.editFx = function(data){
      $scope.hasListErr = false;
      $scope.errType = "";
      $('.widgetForm').scrollTop(0);
      $scope.editWForm = {isShow:true, isAdd:false, isEdit:true};
      $scope.addWorkout = angular.copy(data);
      $scope.addWorkout.dateRange = {startDate:moment($scope.addWorkout.date).format("MM-DD-YYYY"), endDate:moment($scope.addWorkout.date).format("MM-DD-YYYY")};
    }

    $scope.resetFx = function(){
      $scope.hasListErr = false;
      $scope.errType = "";
      $scope.addWorkout = angular.copy($scope.defaultWorkout);
    }

    $scope.removeContentFx = function(){
      $scope.addWorkout.widget = {label:"", path:"", thumb:"", type:""};
    }

    $scope.deleteOpen = function(wId){
      $scope.removeProcessing = false;
      $scope.deleteObj = {wId:wId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      F45Srv.delete($scope.f45.id, $scope.deleteObj.wId).then(
        function(data){
          if(data.code == 8242){
            angular.forEach($scope.workoutList, function(list, index){
              if($scope.deleteObj.wId == list.id){
                $scope.workoutList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx();
                ngDialog.close();
              }
            });
            if($scope.workoutList == 0 && $scope.subTab == 1){
              $scope.editWForm = {isShow:true, isAdd:true, isEdit:false};
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.briefFx = function(){
      $scope.curDevices = angular.copy($scope.devices.devices);
      if($scope.allSelectedDevices.devices.length){
        $scope.curDevices = angular.copy($scope.allSelectedDevices.devices);
        if($scope.devices.info.allIds){
          angular.forEach($scope.devices.info.allIds, function(item){
            $rootScope.selectedItems.push({id:item, type:"device", subType:"device"});
          });
        } else{
          angular.forEach($scope.curDevices, function(item){
            $rootScope.selectedItems.push({id:item.id, type:"device", subType:"device"});
          });
        }
      }

      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "device"){
          $scope.isDuplicate = false;
          angular.forEach($scope.f45.devices, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          angular.forEach($scope.curDevices, function(listItem){
            if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
              $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.curDevices.filter(function(obj){return obj.id == item.id;})[0];
            $scope.f45.devices.push({id:item.id, label:$scope.curItem.label, thumbV:$scope.curItem.thumbV, mac:$scope.curItem.mac, dType:$scope.curItem.dType, assignments:$scope.curItem.assignments, frame:$scope.curItem.frame, layout:$scope.curItem.layout});
          }
        }
      });
      $rootScope.selectedItems = [];
    }
    $scope.removeFilteredFx = function(id, type){
      if(id == "all"){
        $scope.f45.devices = [];
      } else{
        angular.forEach($scope.f45.devices, function(item){
          if(id == item.id){
            $scope.f45.devices.splice($scope.f45.devices.indexOf(item), 1);
            return false;
          }
        });
        angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
          if($(item).attr('data-id') == id && $(item).attr('data-type') == "device"){
            $(item).removeClass('ui-selected');
            $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
          }
        });
        $rootScope.selectedItems = [];
      }
    }

    $scope.f45Fx = function(tab, caller){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || tab == 2 || caller == "save"){
        if($scope.f45.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.f45.fid = $scope.fid;
          $scope.f45.toast = false;

          if(tab == 1 || tab == 2){
            $scope.nextProcessing = true;
          } else{
            $scope.f45.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveF45Fx(tab);
            }, 250);
          } else{
            $scope.saveF45Fx(tab);
          }
        }
      }
    }

    $scope.saveF45Fx = function(tab){
      $scope.f45.fid = $scope.fid;
      $scope.f45.tzOffset = $scope.curTimezone;
      F45Srv.saveF45($scope.f45).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.f45.id = data.id;
          }
          if(tab == 1 || tab == 2){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 2){
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ExtInputController', ExtInputController);

  /** @ngInject */
  function ExtInputController($log, $rootScope, $scope, $state, $cookies, $timeout, ExtInputSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ExtInputSrv.getExtInput($scope.decId).then(
        function(data){
          $scope.extInput = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.extInput = {label:"", inputSrc:"ext://hdmi:1", mute:true, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.extInputFx = function(){
      $scope.extInput.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.extInput.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveExtInputFx();
          }, 250);
        } else{
          $scope.saveExtInputFx();
        }
      }
    }
    $scope.saveExtInputFx = function(){
      ExtInputSrv.saveExtInput($scope.extInput).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ExcelSheetController', ExcelSheetController);

  /** @ngInject */
  function ExcelSheetController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, ExcelSheetSrv, FileModelUploadSrv, TemplateCUSrv){
    $scope.colorPicker = {b:false, hb:false, ht:false, fb:false, ft:false, rb:false, rt:false, ab:false, at:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.generateProcessing = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.searchQu = {text:""};
    $scope.addRowBtn = false;
    $scope.isPEOpen = false;
    $scope.deleteBtn = true;
    $scope.excelSheet = {};
    $scope.isChecked = {};
    $scope.encId = "";
    $scope.decId = "";
    $scope.curData = null;
    $scope.curSheetIndex = 0;
    $scope.styleData = {
      "border-top": "2px solid #000000",
      "border-bottom": "2px solid #000000",
      "border-left": "2px solid #000000",
      "border-right": "2px solid #000000",
      "color": "red",
      "font-weight": "bold",
      "text-align": "right",
    };

    $scope.settings = {
      settings:{bg:"#ffffff", bga:0, headerBg:"#eeeeee", headerBga:1, headerText:"#444444", headerFont:$scope.fontFamilySelected, isFooterBg:true, footerBg:"#eeeeee", footerBga:1, footerText:"#444444", footerFont:$scope.fontFamilySelected, rowBg:"#ffffff", rowBga:1, rowText:"#444444", rowFont:$scope.fontFamilySelected, altBg:"#f3f3f3", altBga:1, altText:"#444444", altFont:$scope.fontFamilySelected, reloadOpt:"a", reload:500, rotateOpt:"a", rotate:30},
      ctype:{bg:"monochrome", headerBg:"monochrome", headerText:"monochrome", footerBg:"monochrome", footerText:"monochrome", rowBg:"monochrome", rowText:"monochrome", altBg:"monochrome", altText:"monochrome"}
    };

    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.excelSheet.settings = angular.copy($scope.defaultSettings.settings);
      $scope.excelSheet.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      ExcelSheetSrv.getExcelSheet($scope.decId).then(
        function(data){
          $scope.excelSheet = data;
          $scope.copyTableData = angular.copy($scope.excelSheet.table);
          $scope.detailLoading = false;
          // $scope.excelSheet.table = {file:data.file,head:data.head,row:data.row,url:data.url};

          $scope.curCount = angular.copy($scope.excelSheet.columns);
          $scope.curGType = angular.copy($scope.excelSheet.gType);

          $scope.excelSheet.table = data.table;
          $scope.excelSheet.sheet = data.table[0];

          if($scope.excelSheet.table.length){
            $scope.excelSheet.table.forEach(function(table){
              if(table.d.length){
                for (var i = 0; i < table.d.length; i++) {
                  table.d[i] = {isChecked:false, row:table.d[i]};
                  if(table.d[i].row.length){
                    for (var j = 0; j < table.d[i].row.length; j++) {
                      table.d[i].row[j] = {label:table.d[i].row[j]};
                    }
                  }
                }
              }
            })
          }
          $scope.excelSheet.sheetIndex = $scope.excelSheet.table.indexOf($scope.excelSheet.sheet);

          $scope.settings.settings = angular.copy($scope.excelSheet.settings);
          $scope.settings.ctype = angular.copy($scope.excelSheet.ctype);
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    else{
      $scope.excelSheet = {label:"", columns:2, gType:"f", sheet:0, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}, table:[],
        settings:angular.copy($scope.defaultSettings.settings),
        ctype:angular.copy($scope.defaultSettings.ctype)
      };
      $rootScope.tabView = true;
      $scope.curGType = angular.copy($scope.excelSheet.gType);
    }

    // $scope.searchFx = function(key){
    //   console.warn(JSON.stringify($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d));
    //   $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d = $filter("filter")($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, {keyName:key}, true);
    // }
    $scope.changeType = function(caller){
      $scope.changeObj = {caller:caller};
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "dType"){
        $scope.excelSheet.settings = angular.copy($scope.settings.settings);
        $scope.excelSheet.ctype = angular.copy($scope.settings.ctype);

        if($scope.excelSheet.table.head){
          $scope.changeTypeOpen("tabular");
        } else{
          $scope.excelSheet.gType = "g";
          $scope.curGType = "g";
        }
      } else if(caller == "gType"){
        // if($scope.excelSheet.table.head){
        //   $scope.changeTypeOpen("gType");
        // } else{
        //   $scope.curGType = angular.copy($scope.excelSheet.gType);
        // }
        $scope.excelSheet.sheetIndex = $scope.curSheetIndex;
        if($scope.excelSheet.table.length && $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d){
          $scope.changeTypeOpen("gType");
        } else{
          $scope.curGType = angular.copy($scope.excelSheet.gType);
        }
      } else if(caller == "fType"){
        if($scope.excelSheet.table.head){
          $scope.changeTypeOpen("fType");
        } else{
          $scope.curFType = "excel";
        }
      } else if(caller == "imgType"){
        $scope.excelSheet.sheetIndex = 0;
        if($scope.excelSheet.table.length && $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d){
          $scope.changeTypeOpen("imgType");
        } else{
          $scope.curGType = angular.copy($scope.excelSheet.gType);
        }
      }
    }
    $scope.changeTypeOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.queue.m9" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="changeTypeFx();" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        data:$scope.changeObj,
        closeByEscape:false,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(caller){
          if(caller == "$escape" || caller == "close"){
            if($scope.changeObj.caller == "gType" || $scope.changeObj.caller == "imgType"){
              $scope.excelSheet.gType = $scope.curGType;
            }
          }
        }
      });
    }
    $scope.changeTypeFx = function(){
      if($scope.changeObj.caller == "gType"){
        $scope.curGType = $scope.excelSheet.gType;
        $scope.excelSheet.sheetIndex = 0;
      }
      $scope.excelSheet.table = [];
      ngDialog.close();
    }

    $scope.generateFx = function(){
      $scope.errType = "";
      $scope.hasErr = false;
      if($scope.excelSheet.gType == "g" && $scope.excelSheet.columns > 999){
        $scope.errType = "maxCol";
        $scope.hasErr = true;
        $("#columns").focus();
        return;
      }
      if($scope.excelSheet.columns >= 1){
        $scope.errType = "";
        $scope.hasErr = false;
        if($scope.excelSheet.table.length){
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"cl.widget.queue.m10" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="generatingFx();" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="generateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:480,
            scope:$scope,
            closeByDocument:false,
            className:'ngdialog-theme-default ngdialog-confirm',
            preCloseCallback:function(caller){
              if(caller == 'close'){
                $scope.excelSheet.columns = $scope.curCount;
              }
            }
          });
        } else{
          $scope.generatingFx();
        }
      } else{
        $scope.errType = "columns";
        $scope.hasErr = true;
        $("#columns").focus();
      }
    }

    $scope.generatingFx = function(){
      ngDialog.close();
      $scope.searchQu.text = "";
      $scope.generateProcessing = true;
      $scope.curCount = angular.copy($scope.excelSheet.columns);
      $scope.excelSheet.table = [{d:[], l:"Sheet 1"}];
      $scope.col = [];
      for(var i=0; i<$scope.curCount; i++){
        $scope.col.push({label:"Column"+ (1+i)});
      }
      $scope.excelSheet.table[0].d.push({isChecked:false, row:$scope.col});
      $scope.emptyArr = Array.from({length:$scope.curCount}, function () {
        return {label:""};
      });
      $scope.excelSheet.table[0].d.push({isChecked:false, row:$scope.emptyArr});
      $scope.generateProcessing = false;
    }

    $scope.addRowFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.addRowBtn = true;
      $scope.searchQu.text = "";
      if($scope.isChecked.selectAll){
        $scope.isChecked.selectAll = false;
      }

      $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.push({isChecked:false, row:[]});
      for(var i=0; i<$scope.curCount; i++){
        $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d[$scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.length-1].row.push({label:""});
      }
      angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, function(item, index){
        item.id = index+1;
      });
      $scope.addRowBtn = false;

      // $scope.excelSheet.table.row.push({id:$scope.excelSheet.table.row.length+1, isChecked:false, hide:false, columns:[]});
      // for(var i=0; i<$scope.curCount; i++){
      //   $scope.excelSheet.table.row[$scope.excelSheet.table.row.length-1].columns.push({label:""});
      // }
      // angular.forEach($scope.excelSheet.table.row, function(item, index){
      //   item.id = index+1;
      // });
      // $scope.addRowBtn = false;
    }

    $scope.isCheckedFx = function(caller, index){
      $scope.curChecked = false;
      if(caller == "all"){
        if($scope.isChecked.selectAll){
          angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.slice(1), function(row){
            row.isChecked = true;
          });
        } else{
          angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.slice(1), function(row){
            row.isChecked = false;
          });
        }
      } else{
        $scope.curChecked = true;
        angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.slice(1), function(row){
          if(!row.isChecked){
            $scope.curChecked = false;
            return false;
          }
        });
        if($scope.curChecked){
          $scope.isChecked.selectAll = true;
        } else{
          $scope.isChecked.selectAll = false;
        }
      }

      if($filter("filter")($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.slice(1), {isChecked:true}).length == 0){
        $scope.deleteBtn = true;
      } else{
        $scope.deleteBtn = false;
      }
      // if(caller == "all"){
      //   if($scope.isChecked.selectAll){
      //     angular.forEach($scope.excelSheet.table.row, function(row){
      //       console.warn(row);
      //       row.isChecked = true;
      //     });
      //   } else{
      //     angular.forEach($scope.excelSheet.table.row, function(row){
      //       row.isChecked = false;
      //     });
      //   }
      // } else{
      //   $scope.curChecked = true;
      //   angular.forEach($scope.excelSheet.table.row, function(row){
      //     if(!row.isChecked){
      //       $scope.curChecked = false;
      //       return false;
      //     }
      //   });
      //   if($scope.curChecked){
      //     $scope.isChecked.selectAll = true;
      //   } else{
      //     $scope.isChecked.selectAll = false;
      //   }
      // }
      // if($filter("filter")($scope.excelSheet.table.row, {isChecked:true}).length == 0){
      //   $scope.deleteBtn = true;
      // } else{
      //   $scope.deleteBtn = false;
      // }
    }

    $scope.deleteOpen = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.unDeletable = false;

      $scope.selRow = $filter("filter")($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, {isChecked:true});
      $scope.selRow.forEach(function(item){
        if(item.row.length){
          for (var i = 0; i < item.row.length; i++) {
            if(item.row[i].label.d){
              $scope.unDeletable = true;
              break;
            }
          }
        }
      })
      if($scope.unDeletable){
        $scope.hasErr = true;
        $scope.errType = "unDelete";
      } else {
        $scope.deleteItemLength = $filter("filter")($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, {isChecked:true}).length;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{deleteItemLength > 1?"cm.msg.34s":"cm.msg.34" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }
    $scope.deleteFx = function(){
      $scope.deleteBtn = true;
      $scope.searchQu.text = "";

      if($scope.isChecked.selectAll){
        $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d = $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d.splice(0, 1);
        $scope.isChecked.selectAll = false;
      } else{
        $scope.curDelete = $filter("filter")($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, {isChecked:false});
        $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d = $scope.curDelete;
      }

      // if($scope.isChecked.selectAll){
      //   $scope.excelSheet.table.row = [];
      //   $scope.isChecked.selectAll = false;
      // } else{
      //   $scope.curDelete = $filter("filter")($scope.excelSheet.table.row, {isChecked:false});
      //   $scope.excelSheet.table.row = $scope.curDelete;
      // }
      ngDialog.close();
    }
    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.excelSheet.table.row, function(item, index){
        angular.forEach($filter('filter')($scope.excelSheet.table.row, {id:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.excelSheet.table.row = [];
      $scope.excelSheet.table.row = $scope.curRow;
    }

    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
      if($scope.excelSheet.table.head){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.queue.m11" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileSelectFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.fileSelectFx();
      }
    }

    $scope.fileSelectFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.excelSheet.gType != "img"){
        $scope.fileModelLoading = true;
        FileModelUploadSrv.uploadFileAndData("common/convertTojson_v2?excelWidget=1&"+ new Date().getTime(), {delimiter:$scope.excelSheet.delimiter}, $scope.curData).then(
        // FileModelUploadSrv.uploadFileAndData("excelTojson?"+ new Date().getTime(), {delimiter:$scope.excelSheet.delimiter}, $scope.curData).then(
          function(data){
            $scope.fileModelLoading = false;
            $scope.excelSheet.table = [];
            if($scope.encId){
              $scope.excelSheet.excelDUrl = null;
            }
            $scope.convertData = data;
            ngDialog.close();
            if(data.code == 17070){
              $scope.hasErr = true;
              $scope.errType = "exIssue";
            } else{
              if($scope.convertData.code == 8126){
                ngDialog.open({
                  template:'\
                    <section class="panel">\
                      <div class="panel-body">{{"cl.widget.queue.m12" | translate}}</div>\
                      <footer class="panel-footer">\
                        <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="convertFx();" focus-me="true" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                        <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                      </footer>\
                    </section>',
                  plain:true,
                  width:480,
                  scope:$scope,
                  closeByDocument:false,
                  className:'ngdialog-theme-default ngdialog-confirm'
                });
              } else if(data && ((data.table && data.table.length > 0) || (data.row && data.row.length > 0))){
                $scope.excelSheet.table = $scope.convertData.table;
                $scope.excelSheet.sheet = $scope.convertData.table[0];

                if($scope.excelSheet.table.length){
                  $scope.excelSheet.table.forEach(function(table){
                    if(table.d.length){
                      for (var i = 0; i < table.d.length; i++) {
                        table.d[i] = {isChecked:false, row:table.d[i]};
                        if(table.d[i].row.length){
                          for (var j = 0; j < table.d[i].row.length; j++) {
                            table.d[i].row[j] = {label:table.d[i].row[j]};
                          }
                        }
                      }
                    }
                  })
                }

                $scope.excelSheet.sheetIndex = $scope.excelSheet.table.indexOf($scope.excelSheet.sheet);
                $scope.curCount = $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d[0].row.length;
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.fileModelLoading = false;
            ngDialog.close();
            $rootScope.toastNotificationFx("danger", {"code":5000});
          }
        );
      }
    }
    $scope.convertFx = function(){
      $scope.excelSheet.table = $scope.convertData;
      $scope.curCount = $scope.excelSheet.table.head.columns.length;
      ngDialog.close();
    }

    $scope.changeSheetFx = function(data){
      $scope.sIndex = 0;
      $scope.curSheetIndex = 0;
      $scope.isChecked.selectAll = false;
      $scope.deleteBtn = true;
      angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, function(row){
        row.isChecked = false;
      });
      $scope.excelSheet.table.forEach(function(item, index){
        if(item.l.toLowerCase() == $scope.excelSheet.sheet.l.toLowerCase()){
          $scope.sIndex = index;
        }
      })
      $scope.excelSheet.sheetIndex = $scope.sIndex;
      $scope.curSheetIndex = angular.copy($scope.sIndex);
      $scope.curCount = $scope.excelSheet.table[$scope.excelSheet.sheetIndex].d[0].row.length;
    }

    $scope.excelSheetFx = function(){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.excelSheet.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.excelSheet.settings.reloadOpt == "c" && $scope.excelSheet.settings.reload == null){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else if($scope.excelSheet.settings.rotateOpt == "c" && $scope.excelSheet.settings.rotate == null){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#rotation").focus();
      } else if($scope.excelSheet.gType == "img" && !$scope.curData){
        $scope.errType = "upFile";
        $scope.hasErr = true;
        $("#fileBtn").focus();
      }
      // else if($scope.excelSheet.gType == "g" && $scope.excelSheet.columns == null){
      //   $scope.errType = "columns";
      //   $scope.hasErr = true;
      //   $("#columns").focus();
      // }
      else if($scope.excelSheet.gType != "img" && $scope.excelSheet.table.length == 0){
        if($scope.excelSheet.gType == "g"){
          $scope.errType = "grid";
          $scope.hasErr = true;
          $("#generateBtn").focus();
        } else if($scope.excelSheet.gType == "f"){
          $scope.errType = "file";
          $scope.hasErr = true;
          $("#fileBtn").focus();
        }
      } else{
        if($scope.excelSheet.gType != "img"){
          $scope.excelSheet.columns = $scope.curCount;

          angular.forEach($scope.excelSheet.table[$scope.excelSheet.sheetIndex].d, function(item, index){
            // console.warn(item);
            // item.id = index+1;
            item.isChecked = false;
          });
        }
        // angular.forEach($scope.excelSheet.table.row, function(item, index){
        //   item.id = index+1;
        //   item.isChecked = false;
        // });
        $scope.excelSheet.fid = $scope.fid;
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveExcelSheet();
          }, 250);
        } else{
          $scope.saveExcelSheet();
        }
      }
    }

    $scope.saveExcelSheet = function(){
      $scope.copySheetData = angular.copy($scope.excelSheet);
      if($scope.excelSheet.gType != "img"){
        if($scope.copySheetData.table.length){
          $scope.copySheetData.table.forEach(function(table){
            if(table.d.length){
              for (var i = 0; i < table.d.length; i++) {
                $scope.tmpArr = [];
                if(table.d[i].row.length){
                  for (var j = 0; j < table.d[i].row.length; j++) {
                    $scope.tmpArr.push(table.d[i].row[j].label);
                  }
                }
                table.d[i] = $scope.tmpArr;
              }
            }
          })
        }

        $scope.newData = JSON.stringify($scope.copySheetData.table);
        $scope.copyData = JSON.stringify($scope.copyTableData);
        if($scope.newData !== $scope.copyData){
          $scope.copySheetData.isFDataChanged = true;
        }
        if($scope.convertData && $scope.convertData.excelSrc){
          $scope.copySheetData.excelSrc = $scope.convertData.excelSrc;
        }
      }

      if($scope.excelSheet.gType == "img"){
        $scope.excelSheet.table = [];
        FileModelUploadSrv.uploadFileAndData("contentLibrary/widgets/excelSheet", $scope.excelSheet, $scope.curData).then(
          function(data){
            $scope.saveProcessing = false;
            $state.go("hub.contentLibrary.c");
            $rootScope.toastNotificationFx("info", data);
          },
          function(err){
            $scope.saveProcessing = false;
          }
        );
      } else {
        ExcelSheetSrv.saveExcelSheet($scope.copySheetData).then(
          function(data){
            $scope.saveProcessing = false;
            $state.go("hub.contentLibrary.c");
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }

    }

    $scope.downloadSheetFx = function(url){
      $rootScope.linkOpenObj = {loading:false, url:url, surl:""};
      $scope.linkOpenFx('d');
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DelimitedTextController', DelimitedTextController);

  /** @ngInject */
  function DelimitedTextController($log, $rootScope, $scope, $state, $cookies, $timeout, DelimitedTextSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      DelimitedTextSrv.getDelimitedText($scope.decId).then(
        function(data){
          $scope.delimitedText = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.delimitedText = {label:"", dataSource:"", refreshInterval:60, delimiter:"comma", chartType:"table", fWidth:"", fHeight:"", sampleData:"", bgImg:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.delimitedTextFx = function(){
      $scope.delimitedText.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.delimitedText.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDelimitedTextFx();
          }, 250);
        } else{
          $scope.saveDelimitedTextFx();
        }
      }
    }
    $scope.saveDelimitedTextFx = function(){
      DelimitedTextSrv.saveDelimitedText($scope.delimitedText).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DateTimeController', DateTimeController);

  /** @ngInject */
  function DateTimeController($log, $rootScope, $scope, $state, $filter, $timeout, DateTimeSrv){
    $scope.colorPicker = {bc:false, dc:false, tc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.curTS = moment().format('x');
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.colorOpt = "";
    $scope.format = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.lang = "";

    $scope.settingsTemplate1 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", bg:"#ffffff", bga:1, dateText:"#ffffff", timeText:"#000000", template:'t1', lang:"en_US", format:"12"}, ctype:{bg:"monochrome", date:"monochrome", time:"monochrome"}};
    $scope.settingsTemplate2 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", timeText:"#ffffff", template:'t2', lang:"en_US", format:"12"}, ctype:{date:"monochrome", time:"monochrome"}};
    $scope.settingsTemplate3 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", bg:"#ffffff", bga:1, timeText:"#000000", template:'t3', lang:"en_US", format:"12"}, ctype:{bg:"monochrome", time:"monochrome"}};
    $scope.settingsTemplate4 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", timeText:"#ffffff", template:'t4', lang:"en_US", format:"12"}, ctype:{time:"monochrome"}};
    $scope.settingsTemplate5 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", template:'t5', lang:"en_US", format:"12"}, ctype:{date:"monochrome"}};
    $scope.settingsTemplate6 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", template:'t6', lang:"en_US", format:"12"}, ctype:{date:"monochrome"}};
    $scope.settingsTemplate7 = {settings:{font:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", timeText:"#ffffff", template:'t7', lang:"en_US", format:"12"}, ctype:{date:"monochrome", time:"monochrome"}};
    $scope.settingsTemplate8 = {settings:{dateFont:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", timeText:"#ffffff" ,timeFont:$scope.fontFamilySelected,dayText:"#ffffff",dayFont:$scope.fontFamilySelected, monthText:"#ffffff",monthFont:$scope.fontFamilySelected, template:'t8', lang:"en_US", format:"12"}, ctype:{date:"monochrome", time:"monochrome", day:"monochrome", month:"monochrome"}};
    $scope.settingsTemplate9 = {settings:{dateFont:$scope.fontFamilySelected, colorOpt:"c", dateText:"#ffffff", timeText:"#ffffff" ,timeFont:$scope.fontFamilySelected,dayText:"#ffffff",dayFont:$scope.fontFamilySelected, monthText:"#ffffff",monthFont:$scope.fontFamilySelected, template:'t9', lang:"en_US", format:"12"}, ctype:{date:"monochrome", time:"monochrome", day:"monochrome", month:"monochrome"}};

    $scope.defaultTemplate1 = angular.copy($scope.settingsTemplate1);
    $scope.defaultTemplate2 = angular.copy($scope.settingsTemplate2);
    $scope.defaultTemplate3 = angular.copy($scope.settingsTemplate3);
    $scope.defaultTemplate4 = angular.copy($scope.settingsTemplate4);
    $scope.defaultTemplate5 = angular.copy($scope.settingsTemplate5);
    $scope.defaultTemplate6 = angular.copy($scope.settingsTemplate6);
    $scope.defaultTemplate7 = angular.copy($scope.settingsTemplate7);
    $scope.defaultTemplate8 = angular.copy($scope.settingsTemplate8);
    $scope.defaultTemplate9 = angular.copy($scope.settingsTemplate9);

    $scope.settingsDefault = function(){
      $scope.colorOpt = angular.copy($scope.dateTime.settings.colorOpt);
      $scope.format = angular.copy($scope.dateTime.settings.format);
      $scope.lang = angular.copy($scope.dateTime.settings.lang);
      if($scope.dateTime.settings.template == "t1"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate1.settings);
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate1.ctype);
      } else if($scope.dateTime.settings.template == "t2"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate2.settings);
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate2.ctype);
      } else if($scope.dateTime.settings.template == "t3"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate3.settings);
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate3.ctype);
      } else if($scope.dateTime.settings.template == "t4"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate4.settings);
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate4.ctype);
      } else if($scope.dateTime.settings.template == "t5"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate5.settings);
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate5.ctype);
      } else if($scope.dateTime.settings.template == "t6"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate6.settings)
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate6.ctype);
      } else if($scope.dateTime.settings.template == "t7"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate7.settings)
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate7.ctype);
      } else if($scope.dateTime.settings.template == "t8"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate8.settings)
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate8.ctype);
      } else if($scope.dateTime.settings.template == "t9"){
        $scope.dateTime.settings = angular.copy($scope.defaultTemplate9.settings)
        $scope.dateTime.ctype = angular.copy($scope.defaultTemplate9.ctype);
      }
      $scope.dateTime.settings.colorOpt = $scope.colorOpt;
      $scope.dateTime.settings.format = $scope.format;
      $scope.dateTime.settings.lang = $scope.lang;
    }

    $scope.changeTemplate = function(caller){
      $scope.colorOpt = angular.copy($scope.dateTime.settings.colorOpt);
      $scope.format = angular.copy($scope.dateTime.settings.format);
      $scope.lang = angular.copy($scope.dateTime.settings.lang);
      $scope.dateTime.settings = {};
      $scope.dateTime.ctype = {};
      if(caller == "t1"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate1.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate1.ctype);
      } else if(caller == "t2"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate2.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate2.ctype);
      } else if(caller == "t3"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate3.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate3.ctype);
      } else if(caller == "t4"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate4.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate4.ctype);
      } else if(caller == "t5"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate5.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate5.ctype);
      } else if(caller == "t6"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate6.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate6.ctype);
      } else if(caller == "t7"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate7.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate7.ctype);
      } else if(caller == "t8"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate8.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate8.ctype);
      } else if(caller == "t9"){
        $scope.dateTime.settings = angular.copy($scope.settingsTemplate9.settings);
        $scope.dateTime.ctype = angular.copy($scope.settingsTemplate9.ctype);
      }
      $scope.dateTime.settings.colorOpt = $scope.colorOpt;
      $scope.dateTime.settings.format = $scope.format;
      $scope.dateTime.settings.lang = $scope.lang;
    }

    $scope.formatFx = function(caller){
      if($scope.dateTime.settings.lang == 'en_US' || $scope.dateTime.settings.lang == 'es_ES' || $scope.dateTime.settings.lang == 'pt_PT' || $scope.dateTime.settings.lang == 'de_DE' || $scope.dateTime.settings.lang == 'pl_PL'){
        $scope.formats = [
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"12"}), value:"12"},
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"24"}), value:"24"}
        ];
      }
      if($scope.dateTime.settings.lang == 'fr_FR'){
        $scope.formats = [
          {label:$filter("translate")('cl.widget.dt.9.1', {value:"24"}), value:"24"},
          {label:$filter("translate")('cl.widget.dt.9.2', {value:"24"}), value:"24h"}
        ];
      }
      if(caller == "n"){
        $scope.dateTime.settings.format = $scope.formats[0].value;
      }
    }
    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      DateTimeSrv.getDateTime($scope.decId).then(
        function(data){
          $scope.dateTime = data;
          if($scope.dateTime.settings.template == "t1"){
            $scope.settingsTemplate1.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate1.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t2"){
            $scope.settingsTemplate2.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate2.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t3"){
            $scope.settingsTemplate3.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate3.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t4"){
            $scope.settingsTemplate4.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate4.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t5"){
            $scope.settingsTemplate5.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate5.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t6"){
            $scope.settingsTemplate6.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate6.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t7"){
            $scope.settingsTemplate7.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate7.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t8"){
            $scope.settingsTemplate8.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate8.ctype = angular.copy($scope.dateTime.ctype);
          } else if($scope.dateTime.settings.template == "t9"){
            $scope.settingsTemplate9.settings = angular.copy($scope.dateTime.settings);
            $scope.settingsTemplate9.ctype = angular.copy($scope.dateTime.ctype);
          }
          $scope.detailLoading = false;
          $scope.formatFx("e");
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.dateTime = {
        labelOpt:"a", label:"", timezoneOpt:"z", timezone:$scope.auth.defaultTimezone, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settingsTemplate1.settings),
        ctype:angular.copy($scope.settingsTemplate1.ctype)
      };
      $scope.formatFx("n");
    }

    $scope.timezoneFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dateTime.timezoneOpt == "z" && $scope.dateTime.label == ""){
        $scope.dateTime.labelOpt = "a";
      } else{
        $scope.dateTime.labelOpt = "c";
      }
    }


    $scope.dateTimeFx = function(tab, caller){
      $scope.dateTime.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.dateTime.labelOpt == "c" && $scope.dateTime.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
            }, 50);
          } else if(caller == "save"){
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveDateTimeFx();
              }, 250);
            } else{
              $scope.saveDateTimeFx();
            }
          }
        }
      }
    }
    $scope.saveDateTimeFx = function(){
     DateTimeSrv.saveDateTime($scope.dateTime).then(
       function(data){
         $scope.saveProcessing = false;
         $state.go("hub.contentLibrary.c");
       },
       function(err){
         $log.error(err);
         $scope.saveProcessing = false;
       }
     );
   }

   $rootScope.selectedTabFx = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CountController', CountController);

  /** @ngInject */
  function CountController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, CountSrv){
    $scope.colorPicker = {tt:false, ct:false,bg:false, ht:false, ft:false, lt:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{up:{type:"a", date:moment().format(), time:moment().format()}, down:{type:"a", end:100, date:moment().format(), time:moment().format()}, countSize:26, countText:"#ffffff", countFont:{label:"Century Gothic", value:"century gothic"}, type:'d', ct:'dt', dType:'ddhhmmss', tt:'ss', bg:"#000000", bga:1, isHeader: true, hText:"", headerSize:16, headerText:"#ffffff", headerFont:{label:"Century Gothic", value:"century gothic"}, isFooter: true, fText:"", footerSize:16, footerText:"#ffffff", footerFont:{label:"Century Gothic", value:"century gothic"}, isLabel: true, labelSize:12, labelText:"#ffffff", labelFont:{label:"Century Gothic", value:"century gothic"},lang:"en_US",date:moment().format(), time:moment().format()},
      ctype:{countText:"monochrome", bg:"monochrome", headerText:"monochrome", footerText:"monochrome", labelText:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.count.settings = angular.copy($scope.defaultSettings.settings);
      $scope.count.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      CountSrv.getCount($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.count = data;
          if($scope.count.settings.ct == 'dt'){
            $scope.previewCount();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.count = {
        label:"", dType:"u", cnType:"s", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.countFx = function(){
      $scope.count.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      
      if($scope.count.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.count.settings.ct == 'no' && !angular.isNumber($scope.count.settings.stc)){
        $scope.errType = "stc";
        $scope.hasErr = true;
        $("#sCount").focus();
      } else if($scope.count.settings.ct == 'no' && !angular.isNumber($scope.count.settings.etc)){
        $scope.errType = "etc";
        $scope.hasErr = true;
        $("#eCount").focus();
      } else if($scope.count.settings.ct == 'no' && $scope.count.settings.type == 'u' && $scope.count.settings.stc > $scope.count.settings.etc){
        $scope.errType = "stcValidL";
        $scope.hasErr = true;
        $("#sCount").focus();
      } else if($scope.count.settings.ct == 'no' && $scope.count.settings.type == 'd' && $scope.count.settings.stc < $scope.count.settings.etc){
        $scope.errType = "stcValidG";
        $scope.hasErr = true;
        $("#eCount").focus();
      } else if($scope.count.settings.isHeader && !$scope.count.settings.headerSize){
        $scope.errType = "headerSize";
        $scope.hasErr = true;
      } else if(!$scope.count.settings.countSize){
        $scope.errType = "countSize";
        $scope.hasErr = true;
        $("#countSize").focus();
      } else if($scope.count.settings.isLabel && !$scope.count.settings.labelSize){
        $scope.errType = "labelSize";
        $scope.hasErr = true;
      } else if($scope.count.settings.isFooter && !$scope.count.settings.footerSize){
        $scope.errType = "footerSize";
        $scope.hasErr = true;
      } else {
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveCountFx();
          }, 250);
        } else{
          $scope.saveCountFx();
        }
      }
    }
    $scope.saveCountFx = function(){
      // if($scope.count.dType == "u" && $scope.count.settings.up.type == "c"){
      //   $scope.curSDate = angular.element(document).find(".picker.up").val();
      //   $scope.curSDate = $scope.curSDate.split(" - ");
      //   $scope.count.settings.up.dateStr = $scope.curSDate[0];
      //   $scope.count.settings.up.timeStr = $filter("date")($scope.count.settings.up.time, "HH:mm");
      // } else if($scope.count.dType == "d" && $scope.count.settings.down.type == "c"){
      //   $scope.curEDate = angular.element(document).find(".picker.down").val();
      //   $scope.curEDate = $scope.curEDate.split(" - ");
      //   $scope.count.settings.down.dateStr = $scope.curEDate[0];
      //   $scope.count.settings.down.timeStr = $filter("date")($scope.count.settings.down.time, "HH:mm");
      // }
      if($scope.count.settings.ct == "dt" && ($scope.count.settings.type == 'd' || $scope.count.settings.type == 'u')){
        var curSDate = angular.element(document).find(".picker.down").val();
        curSDate = curSDate.split(" - ");
        $scope.count.settings.dateStr = curSDate[0];
        $scope.count.settings.timeStr = $filter("date")($scope.count.settings.time, "HH:mm");
      }
      CountSrv.saveCount($scope.count).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
   
    $scope.padStr = function(num){
      return num.toString().padStart(2, '0');
    }   

    $scope.previewCount = function(){
      if($scope.count.settings.ct == 'dt'){
        setTimeout(function() {
          var curSDate = angular.element(document).find(".picker.down").val();
          curSDate = curSDate.split(" - ");
          var dateStr = curSDate[0];
          var timeStr = $filter("date")($scope.count.settings.time, "HH:mm");
          
          var now = new Date().getTime();
          var end = Date.parse(dateStr + " " + timeStr);
          if (end < now) {
            $scope.dayPreview = '00';  
            $scope.hoursPreview = '00';
            $scope.minutesPreview = '00';
            $scope.secondsPreview = '00'; 
          } else{
            $scope.difference = end - now;
            $scope.days = Math.floor($scope.difference / (1000 * 60 * 60 * 24));
            $scope.difference -= $scope.days * (1000 * 60 * 60 * 24);
            $scope.hours = Math.floor($scope.difference / (1000 * 60*60));
            $scope.difference -= $scope.hours   * (1000 * 60*60);
            $scope.minutes  = Math.floor($scope.difference / (1000 * 60));
            $scope.difference -= $scope.minutes * (1000 * 60);
            $scope.seconds = Math.floor($scope.difference/ 1000);
            
            $scope.dayPreview = $scope.padStr($scope.days);
            $scope.hoursPreview = $scope.padStr($scope.hours);
            $scope.minutesPreview = $scope.padStr($scope.minutes);
            $scope.secondsPreview = $scope.padStr($scope.seconds); 
          }   
        }, 100);
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentOnDemandController', ContentOnDemandController);

  /** @ngInject */
  function ContentOnDemandController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, ContentOnDemandSrv){
    $scope.allowedSize = {size:$scope.auth.upermissions.codSize, unit:$filter("filesize")($scope.auth.upermissions.codSize).split(" ")[1]};
    $scope.editCForm = {isShow:false, isAdd:false, isEdit:false, curWinH:55};
    $scope.colorPicker = {lb:false, cb:false, tBg:false};
    $scope.categorySize = {size:null, isShow:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.category = {info:"", category:[]};
    $scope.curTime = new Date().getTime();
    $scope.search = {text:"", pText:""};
    // $rootScope.codSelectedItems = [];
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = false;
    $scope.advancedShow = true;
    $scope.isPEOpen = false;
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{
        listBg:"#eeeeee", listBga:1,
        contentBg:"#999999", contentBga:1,
        thumbBg:"#9fc5e8", thumbBga:1, thumbFont:$scope.fontFamilySelected, thumbSize:24,
      },
      ctype:{listBg:"monochrome", contentBg:"monochrome", thumbBg:"default"}
    };

    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.cod.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.cod.info.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(390);
      $scope.selectedHeight = $scope.getAvailableHeight(390);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
      $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      ContentOnDemandSrv.getCOD($scope.decId).then(
        function(data){
          $scope.cod = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.cod = {
        info:{
          label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
          settings:angular.copy($scope.settings.settings),
          ctype:angular.copy($scope.settings.ctype)
        }
      };
    }

    $scope.updateList = function(){
      $scope.searchChangeFx("empty");
      $scope.contentLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      if($scope.contentLibrary.info){
        $scope.bucket = $scope.contentLibrary.info.bucket;
        $scope.tim = $scope.contentLibrary.info.timthumb;
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
          $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        }
      }

      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }

      if($scope.contentLibrary.contentLibrary.content){
        $scope.contentList = $scope.contentLibrary.contentLibrary.content;
      }
    }

    $scope.categoryFx = function(caller){
      $scope.categoryLoading = true;
      $scope.categorySize = {size:null, isShow:false};
      ContentOnDemandSrv.getCategory($scope.cod.info.id).then(
        function(data){
          $scope.categoryLoading = false;
          $scope.category = data;
          var curContentArr = [];
          angular.forEach($scope.category.category, function(category){
            if(category.content && category.content.length){
              curContentArr.push(category.content);
            }
          });
          $scope.filteredContentArr = [];
          angular.forEach([].concat.apply([], curContentArr), function(list){
            $scope.isDuplicate = false;
            for(var i = 0;i < $scope.filteredContentArr.length;i++){
              if(!$scope.isDuplicate && list.id == $scope.filteredContentArr[i].id){
                $scope.isDuplicate = true;
                break;
              }
            }
            if(!$scope.isDuplicate){
              $scope.filteredContentArr.push(list);
            }
          });
          angular.forEach($scope.filteredContentArr, function(content){
            if(content.pSize){
              $scope.categorySize.size += content.pSize;
            } else if(!content.pSize && content.size){
              $scope.categorySize.size += content.size * 1024;
            }
            if(content.hidden){
              $scope.categorySize.isShow = true;
            }
          });
          if($scope.categorySize.size){
            $scope.categorySize = {size:$scope.categorySize.size, isShow:$scope.categorySize.isShow};
          }
          if(!$scope.category.category.length){
            $scope.editCForm = {isShow:true, isAdd:true, isEdit:false, curWinH:195};
          } else if($scope.editCForm.isEdit){
            $scope.editCForm = {isShow:false, isAdd:false, isEdit:false, curWinH:55};
          }
          if(caller == "cod"){
            $scope.codFx(2, 'save');
          }
        },
        function(err){
          $scope.categoryLoading = false;
          $log.error(err);
        }
      );
    }

    $rootScope.selectedTabFx = function(){
      $scope.search.text = "";
      $scope.curTime = new Date().getTime();
      if($rootScope.selectedT == 2){
        $scope.contentLoading = true;
        $scope.hasErr = false;
        $scope.categoryFx();
        ContentOnDemandSrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx();

    /*For select content*/
    var tempIndex = 0;
    $scope.briefFx = function(){
      for(var i = 0;i < $rootScope.selectedItems.length;i++){
        if($rootScope.selectedItems[i].type != 'folder'){
          for(var j = 0;j < $scope.contentList.length;j++){
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){
              $scope.addCategory.content.push({
                hidden:0,
                mute:true,
                isAccessible:true,
                id:$scope.contentList[j].id,
                ss:$scope.contentList[j].ss,
                fid:$scope.contentList[j].fid,
                url:$scope.contentList[j].url,
                extn:$scope.contentList[j].extn,
                btnExtn:$scope.contentList[j].btnExtn,
                type:$scope.contentList[j].type,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                ssImg:$scope.contentList[j].ssImg,
                width:$scope.contentList[j].width,
                height:$scope.contentList[j].height,
                splFid:$scope.contentList[j].splFid,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                caption:$scope.contentList[j].caption,
                duration:$scope.contentList[j].duration,
                isCaption:$scope.contentList[j].isCaption,
                tempId:$scope.contentList[j].id + tempIndex,
                isCompleted:$scope.contentList[j].isCompleted,
                MajorVersion:$scope.contentList[j].MajorVersion,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              tempIndex++;
              break;
            }
          }
        }
      }
      // $scope.addCategory.content = $rootScope.codSelectedItems;
    }

    $scope.closeFilteredFx = function(id, wcodid, tempId){
      for(var i = 0;i < $scope.addCategory.content.length;i++){
        if(wcodid && $scope.addCategory.content[i].wcodid == wcodid && $scope.addCategory.content[i].id == id){
          $scope.addCategory.content.splice(i, 1);
          break;
        } else if(tempId && $scope.addCategory.content[i].tempId == tempId && $scope.addCategory.content[i].id == id){
          $scope.addCategory.content.splice(i, 1);
        }
      }
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
        }
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      ContentOnDemandSrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.searchChangeFx("empty");
          $scope.updateList();
          if($scope.auth.upreferences.isSplitV){
            $scope.contentObj.quadHeight = $scope.getAvailableHeight(390);
            $scope.contentObj.selectedHeight = $scope.getAvailableHeight(390);
          } else{
            $scope.contentObj.quadHeight = $scope.getAvailableHeight(460) * 0.55;
            $scope.contentObj.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.folderBriefFx = function(){}

    $scope.codFx = function(tab, caller){
      $scope.search.text = "";
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.cod.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if(tab == 2 && ($scope.addCategory.label || $scope.addCategory.content.length)){
        $scope.addFx('cod');
      } else if($scope.categorySize.size > $scope.allowedSize.size){
        $scope.errType = "size";
        $scope.hasErr = true;
        $("#size").focus();
      } else{
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if(tab == 1){
          $scope.cod.info.toast = false;
          $scope.nextProcessing = true;
        } else{
          $scope.cod.info.toast = true;
          $scope.saveProcessing = true;
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveCODFx(tab);
          }, 250);
        } else{
          $scope.saveCODFx(tab);
        }
      }
    }

    $scope.saveCODFx = function(tab){
      $scope.cod.info.tzOffset = $scope.curTimezone;
      $scope.cod.info.fid = $scope.fid;
      $scope.cod.category = $scope.category.category;
      ContentOnDemandSrv.saveCOD($scope.cod).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.cod.info.id = data.id;
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }, 250);
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.selectContent = function(obj){
      // TODO advance search cleared when popup open
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.searchChangeFx("empty");
      $scope.openPopupLoading = true;
      $scope.advancedShow = false;
      $scope.contentObj = {
        isSplitV:$scope.auth.upreferences.isSplitV,
        thumbParam:$scope.thumbParam,
        thumbBigParam:$scope.thumbBigParam,
        quadHeight:$scope.quadHeight,
        selectedHeight:$scope.selectedHeight
      };

      if(obj.content.length){
        $scope.addCategory.content = obj.content;
        // $rootScope.codSelectedItems = obj.content;
      } else{
        // $rootScope.codSelectedItems = [];
        $scope.addCategory.content = [];
      }

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/codContentSelect.html',
        width:'95%',
        scope:$scope,
        data:$scope.contentObj,
        closeByDocument:false,
        closeByEscape:false
      });

      ContentOnDemandSrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.openPopupLoading = false;
          $scope.updateList();
        },
        function(err){
          $scope.openPopupLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.$on('contentInfo', function(event, args){
      $scope.tim = args.tim;
      $scope.cBucket = $scope.cDetailBucket = args.cBucket;
      $scope.cDetailBucket = args.cDetailBucket;
    });

    $scope.defaultCategory = {label:"", content:[]};
    $scope.addCategory = angular.copy($scope.defaultCategory);

    $scope.resetFx = function(){
      $scope.searchList = {c:""};
      $scope.hasListErr = false;
      $scope.errType = "";
      $scope.addCategory = angular.copy($scope.defaultCategory);
    }

    $scope.addFx = function(caller){
      $scope.isNameExists = false;
      $scope.hasListErr = false;
      $scope.curCategory = {};
      $scope.search.text = "";
      $scope.errType = "";

      $scope.copyAddCategory = angular.copy($scope.addCategory);

      if($scope.copyAddCategory.label == ""){
        $scope.errType = "cName";
        $scope.hasListErr = true;
        $("#cName").focus();
        return;
      }
      angular.forEach($scope.category.category, function(c){
        if(angular.lowercase(c.label) === angular.lowercase($scope.copyAddCategory.label)){
          $scope.isNameExists = true;
          if(c.id == $scope.copyAddCategory.id){
            $scope.isNameExists = false;
          }
        }
      });

      if($scope.isNameExists){
        $scope.errType = "cNameExists";
        $scope.hasListErr = true;
      } else{
        if(caller == "s" || caller == "cod"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.curCategory = {info:{id:$scope.cod.info.id}, category:$scope.copyAddCategory};

        ContentOnDemandSrv.addCategory($scope.curCategory).then(
          function(data){
            $scope.addMoreProcessing = false;
            $scope.addProcessing = false;
            if(data.code == 8249 || data.code == 8250){
              $scope.categoryFx(caller);
            }
            if(caller == "s" || caller == "cod"){
              $scope.editCForm.isShow = false;
              $scope.editCForm.curWinH = 55;
            } else{
              $scope.editCForm.isShow = true;
              $scope.editCForm.curWinH = 195;
            }
            $scope.resetFx();
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.editFx = function(data){
      $scope.editCForm = {isShow:true, isAdd:false, isEdit:true, curWinH:195};
      $('.widgetForm').scrollTop(0);
      $scope.addCategory = angular.copy(data);
    }

    $scope.deleteOpen = function(caller, id, wcodid){
      $scope.removeProcessing = false;
      $scope.deleteObj = {caller:caller, id:id, wcodid:wcodid, wId:$scope.cod.info.id};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{deleteObj.caller=="c"?"fl.msg.16":"cl.widget.cod.m4" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";
      ContentOnDemandSrv.delete($scope.deleteObj).then(
        function(data){
          $scope.removeProcessing = false;
          if(data.code == 8251){//category delete
            angular.forEach($scope.category.category, function(list, index){
              if($scope.deleteObj.id == list.id){
                $scope.category.category.splice(index, 1);
                $scope.resetFx();
                ngDialog.close();
              }
            });
            if($scope.category.category.length == 0){
              $scope.editCForm = {isShow:true, isAdd:true, isEdit:false, curWinH:195};
            } else{
              $scope.editCForm = {isShow:false, isAdd:false, isEdit:false, curWinH:55};
            }
          } else if(data.code === 8254){//content delete
            ngDialog.close();
            angular.forEach($scope.category.category, function(category){
              if(category.id == $scope.deleteObj.id){
                angular.forEach(category.content, function(item){
                  if(item.wcodid == $scope.deleteObj.wcodid){
                    category.content.splice(category.content.indexOf(item), 1);
                  }
                });
              }
            });
          }

          var curContentArr = [];
          angular.forEach($scope.category.category, function(category){
            curContentArr.push(category.content);
          });
          $scope.filteredContentArr = [];
          angular.forEach([].concat.apply([], curContentArr), function(list){
            $scope.isDuplicate = false;
            for(var i = 0;i < $scope.filteredContentArr.length;i++){
              if(!$scope.isDuplicate && list.id == $scope.filteredContentArr[i].id){
                $scope.isDuplicate = true;
                break;
              }
            }
            if(!$scope.isDuplicate){
              $scope.filteredContentArr.push(list);
            }
          });
          $scope.categorySize = {size:null, isShow:false};
          angular.forEach($scope.filteredContentArr, function(content){
            if(content.pSize){
              $scope.categorySize.size += content.pSize;
            } else if(!content.pSize && content.size){
              $scope.categorySize.size += content.size * 1024;
            }
            if(content.hidden){
              $scope.categorySize.isShow = true;
            }
          });
          if($scope.categorySize.size){
            $scope.categorySize = {size:$scope.categorySize.size, isShow:$scope.categorySize.isShow};
          }
        },
        function(err){
          $scope.removeProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.getTooltip = function(isApproved, expiring){
      if(!isApproved && !expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.16');
      } else if(!isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.17');
      } else if(isApproved && expiring){
        $scope.curTooltip = $filter("translate")('cl.tool.18');
      } else{
        $scope.curTooltip = "";
      }
      return $scope.curTooltip;
    }

    $scope.codFilterFx = function(search){
      if(!search){
        $scope.search.text = "";
      }
      var filtered = [];
      angular.forEach($scope.category.category, function(category){
        filtered = $filter("filter")(category.content, {label:search});
        angular.forEach(category.content, function(content){
          if(search && filtered.length){
            $("li[data-id=" + category.id + '-' + content.wcodid + "]").addClass("unapprovedFile text-muted");
            angular.forEach(filtered, function(item){
              $("li[data-id=" + category.id + '-' + item.wcodid + "]").removeClass("unapprovedFile text-muted");
            });
          } else if(search){
            $("li[data-id=" + category.id + '-' + content.wcodid + "]").addClass("unapprovedFile text-muted");
          } else{
            $("li[data-id=" + category.id + '-' + content.wcodid + "]").removeClass("unapprovedFile text-muted");
          }
        });
      });
    }


    // Custom search function
    $scope.customSearchFx = function(item){
      // If item is a category, check its label and content
      if(item.content){
        if(!$scope.search.text || $scope.search.text.trim() === ''){
          item.categoryMatches = false; // Reset flag
          return true; // Show all if no search query or query is empty
        }

        var query = $scope.search.text.toLowerCase().trim();

        // Check if category label matches
        item.categoryMatches = item.label.toLowerCase().indexOf(query) !== -1;
        if(item.categoryMatches){
          return true; // Show category and all its content if label matches
        }

        // Check if any content label matches
        return item.content.some(function(content) {
          return content.label.toLowerCase().indexOf(query) !== -1;
        });
      } 
      // If item is a content object, check its label directly
      else{
        if(!$scope.search.text || $scope.search.text.trim() === ''){
          return true;
        }
        var query = $scope.search.text.toLowerCase().trim();
        return item.label.toLowerCase().indexOf(query) !== -1;
      }
    };


    $scope.sortCallback = function(caller){
      if(caller){
        $scope.contentListPopupCopy = angular.copy($scope.addCategory.content);
        var tempContentList = [];
        $(".sortable-item").each(function($index){
          for(var i = 0;i < $scope.contentListPopupCopy.length;i++){
            if(($scope.contentListPopupCopy[i].id == $(this).attr("data-id"))){
              tempContentList.push($scope.contentListPopupCopy[i]);
              $scope.contentListPopupCopy.splice(i, 1);
              break;
            }
          }
        });
        $scope.addCategory.content = [];
        $scope.$apply(function(){
          $scope.addCategory.content = angular.copy(tempContentList);
        });
      } else{
        $scope.contentListCopy = angular.copy($scope.category.category);
        angular.forEach($scope.contentListCopy, function(category){
          var categoryArr = [];
          angular.forEach(angular.element(".sortable-item"), function(item){
            var sortId = $(item).attr("data-id").split("-");
            if(category.id == Number(sortId[0])){
              categoryArr.push($filter("filter")(category.content, {wcodid:Number(sortId[1])}, true)[0]);
            }
          });
          $scope.$apply(function(){
            category.content = categoryArr;
          });
        });
        $scope.category.category = $scope.contentListCopy;
      }
    }

    $scope.moveFx = function(caller, index){
      if(caller == "up"){
        if(index > 0){
          var tmp = $scope.category.category[index - 1];
          $scope.category.category[index - 1] = $scope.category.category[index];
          $scope.category.category[index] = tmp;
        }
      } else if(caller == "down"){
        if(index < $scope.category.category.length - 1){
          var tmp = $scope.category.category[index + 1];
          $scope.category.category[index + 1] = $scope.category.category[index];
          $scope.category.category[index] = tmp;
        }
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.searchChangeFx("empty");
      $scope.advancedShow = true;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.advSearchInfo = args.info;
      if($scope.auth.upreferences.isSplitV){
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(465);
          $scope.contentObj.selectedHeight = $scope.getAvailableHeight(465);
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(390);
          $scope.contentObj.selectedHeight = $scope.getAvailableHeight(390);
        }
      } else {
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(565) * 0.55;
          $scope.contentObj.selectedHeight = $scope.getAvailableHeight(480) * 0.45;
          console.warn("AAAAAA");
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.contentObj.quadHeight = $scope.getAvailableHeight(460) * 0.55;
          $scope.contentObj.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
        }
      }

      $scope.folderList = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Video" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || (item.splType && item.splType == "Image" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD") || (item.type == "Widget" && (item.extn == "Content Group" || item.extn == "External Input" || item.extn == "IFrame" || item.extn == "Live Streaming" || item.extn == "Microsoft Power BI" || item.extn == "Vimeo" || item.extn == "Web Page" || item.extn == "YouTube"))){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentOnDemandSrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          ContentOnDemandSrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    });

    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.pText = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.pText;
      }
    }
    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentGroupController', ContentGroupController);

  /** @ngInject */
  function ContentGroupController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, fancyboxService, ContentLibrarySrv, ContentGroupSrv){
    $scope.allowedSize = {size:$scope.auth.upermissions.codSize, unit:$filter("filesize")($scope.auth.upermissions.codSize).split(" ")[1]};
    $scope.fid = localStorage.getItem("curFId");
    $scope.cgSize = {size:null, isShow:false};
    $scope.timestamp = moment().format('x');
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.search = {text:""};
    $scope.contentList = [];
    $scope.isPEOpen = false;
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    $scope.setQuadHeightFx = function(){
      if($scope.auth.upreferences.isSplitV){
        $scope.quadHeight = $scope.getAvailableHeight(425);
        $scope.selectedHeight = $scope.getAvailableHeight(425);
        if($state.params.id){
          $scope.quadHeight = $scope.getAvailableHeight(400);
          $scope.selectedHeight = $scope.getAvailableHeight(400);
        }
      } else{
        $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
        $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
      }
    }
    $scope.setQuadHeightFx();

    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.text = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.text;
      }
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      ContentGroupSrv.getContentGroup($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.contentGroup = data;
          $scope.cgSize = {size:null, isShow:false};
          $scope.filteredContentArr = [];
          angular.forEach($scope.contentGroup.content, function(list){
            $scope.isDuplicate = false;
            for(var i = 0;i < $scope.filteredContentArr.length;i++){
              if(!$scope.isDuplicate && list.id == $scope.filteredContentArr[i].id){
                $scope.isDuplicate = true;
                break;
              }
            }
            if(!$scope.isDuplicate){
              $scope.filteredContentArr.push(list);
            }
          });
          angular.forEach($scope.filteredContentArr, function(content){
            if(content.pSize){
              $scope.cgSize.size += content.pSize;
            } else if(!content.pSize && content.size){
              $scope.cgSize.size += content.size * 1024;
            }
            if(content.hidden){
              $scope.cgSize.isShow = true;
            }
          });
          if($scope.cgSize.size){
            $scope.cgSize = {size:$scope.cgSize.size, isShow:$scope.cgSize.isShow};
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.contentGroup = {label:"", activePeriod:{type:"a"}, content:[], permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $rootScope.selectedTabFx = function(){
      $scope.timestamp = moment().format('x');
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.advancedShow = false;
      $scope.searchChangeFx("empty");
      if($rootScope.selectedT == 2){
        $scope.contentLibraryLoading = true;
        $scope.hasErr = false;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );

        $scope.updateList = function(){
          $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
          if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
            $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
          }

          $scope.tim = $scope.contentLibrary.info.timthumb;
          $scope.contentLibraryLoading = false;
          $rootScope.selectedItems = [];
          $scope.breadCrumbs = [];
          $scope.contentList = [];
          $scope.folderList = [];

          if($scope.contentLibrary.info.breadCrumbs){
            $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
          }
          if($scope.contentLibrary.contentLibrary.folder){
            $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
          }
          if($scope.contentLibrary.contentLibrary.content){
            $scope.filteredContent = [];
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.extn != "Content on Demand" && item.extn != "Content Group" && item.extn != "Content on Demand Button" && item.extn != "Button"){
                $scope.filteredContent.push(item);
              }
            });
            $scope.contentList = $scope.filteredContent;
          }
        }
        $scope.setQuadHeightFx();
      } else {
        $scope.setQuadHeightFx();
      }
    }
    $rootScope.selectedTabFx();
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLibraryLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.searchChangeFx("empty");
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.advancedShow = false;
          $scope.updateList();
          $scope.setQuadHeightFx();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.folderBriefFx = function(){}

    /*For select content*/
    var tempIndex = 0;
    $scope.briefFx = function(){
      for(var i = 0;i < $rootScope.selectedItems.length;i++){
        if($rootScope.selectedItems[i].type != 'folder'){
          for(var j = 0;j < $scope.contentList.length;j++){
            $scope.curScale = null;
            if($rootScope.selectedItems[i].type != "Widget"){
              $scope.curScale = $scope.auth.upreferences.scale;
            }
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){ //For normal Content
              $scope.contentGroup.content.push({
                hidden:0,
                fullscreen:false,
                isAccessible:true,
                scale:$scope.curScale,
                ss:$scope.contentList[j].ss,
                id:$scope.contentList[j].id,
                fid:$scope.contentList[j].fid,
                url:$scope.contentList[j].url,
                extn:$scope.contentList[j].extn,
                btnExtn:$scope.contentList[j].btnExtn,
                type:$scope.contentList[j].type,
                size:$scope.contentList[j].size,
                pSize:$scope.contentList[j].pSize,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                ssImg:$scope.contentList[j].ssImg,
                width:$scope.contentList[j].width,
                height:$scope.contentList[j].height,
                splFid:$scope.contentList[j].splFid,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                duration:$scope.contentList[j].duration,
                tempId:$scope.contentList[j].id + tempIndex,
                isCompleted:$scope.contentList[j].isCompleted,
                MajorVersion:$scope.contentList[j].MajorVersion,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              tempIndex++;
              break;
            }
          }
        }
      }
      $scope.cgSize = {size:null, isShow:false};
      $scope.filteredContentArr = [];
      angular.forEach($scope.contentGroup.content, function(list){
        $scope.isDuplicate = false;
        for(var i = 0;i < $scope.filteredContentArr.length;i++){
          if(!$scope.isDuplicate && list.id == $scope.filteredContentArr[i].id){
            $scope.isDuplicate = true;
            break;
          }
        }
        if(!$scope.isDuplicate){
          $scope.filteredContentArr.push(list);
        }
      });
      angular.forEach($scope.filteredContentArr, function(content){
        if(content.pSize){
          $scope.cgSize.size += content.pSize;
        } else if(!content.pSize && content.size){
          $scope.cgSize.size += content.size * 1024;
        }
        if(content.hidden){
          $scope.cgSize.isShow = true;
        }
      });
      if($scope.cgSize.size){
        $scope.cgSize = {size:$scope.cgSize.size, isShow:$scope.cgSize.isShow};
      }
    }

    $scope.contentGroupFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.contentGroup.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if(tab == 1){
            if($rootScope.activePeriodOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('saveActivePeriod',{});
            }
            if($rootScope.isPermissionOpen){
              $scope.isPEOpen = true;
              $rootScope.$broadcast('savePermission',{});
            }
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $scope.tabFx(2, 'tabFx');
              $scope.isPEOpen = false;
            }
          } else{
            if($scope.contentGroup.content.length){
              angular.forEach($scope.contentGroup.content, function(item, $index){
                if((item.duration == "" || item.duration == "0" || isNaN(item.duration) || item.duration < 1) && !$scope.hasErr){
                  $scope.errType = "durationEmpty";
                  $scope.hasErr = true;
                  // $("#duration-"+$index).focus();
                }
              });
              if($scope.hasErr){
                return;
              }
            }
            if($scope.contentGroup.label == ""){
              $scope.errType = "name";
              $scope.hasErr = true;
              $("#label").focus();
            } else if($scope.cgSize.size > $scope.allowedSize.size){
              $scope.errType = "size";
              $scope.hasErr = true;
              $("#size").focus();
            } else{
              $scope.contentGroup.fid = $scope.fid;
              $scope.saveProcessing = true;
              if($rootScope.activePeriodOpen){
                $scope.isPEOpen = true;
                $rootScope.$broadcast('saveActivePeriod',{});
              }
              if($rootScope.isPermissionOpen){
                $scope.isPEOpen = true;
                $rootScope.$broadcast('savePermission',{});
              }
              if($scope.isPEOpen){
                $timeout(function(){
                  $scope.saveContentGroup();
                }, 250);
              } else{
                $scope.saveContentGroup();
              }
            }
          }
        }
      }
    }

    $scope.saveContentGroup = function(){
      ContentGroupSrv.saveContentGroup($scope.contentGroup).then(
        function(data){
          $scope.errorObj = data;
          $scope.errorObj.size = $filter("filesize")($scope.allowedSize.size);
          $scope.saveProcessing = false;

          var remaningSize = 0;
          angular.forEach($scope.errorObj.cod, function(content){
            if(content.size){
              remaningSize += content.size;
            }
          });
          $scope.errorObj.rSize = $filter("filesize")(remaningSize - $scope.allowedSize.size);
          if($scope.errorObj.code == 8267){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.cg.m1" | translate}}</h1></header>\
                  <div class="panel-body">\
                    <div class="bg-warning pad10">{{"cl.widget.cg.m1.1" | translate:{limit:errorObj.size, remaning:errorObj.rSize} }}</div>\
                    <div class="marT15">{{"cl.widget.cg.m1.2" | translate}}</div>\
                    <div class="table table-scroll marT5">\
                      <div class="row th">\
                        <div class="col-xs-9">{{"cm.brief.1" | translate}}</div>\
                        <div class="col-xs-3">{{"cm.label.83" | translate}}</div>\
                      </div>\
                      <div class="scrollQuad" style="max-height:{{getAvailableHeight(500)}}px">\
                        <div class="row" ng-repeat="item in errorObj.cod">\
                          <div class="col-xs-9 word-break">{{item.label}}</div>\
                          <div class="col-xs-3 word-break">{{(item.size) | filesize}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <span class="btnQuad">\
                      <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" focus-me="true" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                    </span>\
                    <div class="clearfix"></div>\
                  </footer>\
                </section>',
              plain:true,
              width:650,
              scope:$scope,
              closeByDocument:false
            });
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.fbGalleryFx = function(index){
      $scope.fbGallery = {};
      $scope.curfbObj1 = [];
      $scope.curfbObj2 = [];
      angular.forEach($filter("reverse")($scope.contentGroup.content), function(item, itemIndex){
        if(index === itemIndex){
          $scope.curfbObj1.push({href:$scope.cBucket + item.thumb, title:item.label});
        } else{
          $scope.curfbObj2.push({href:$scope.cBucket + item.thumb, title:item.label});
        }
      });
      $scope.fbGallery = $scope.curfbObj1.concat($scope.curfbObj2);
      fancyboxService.fancyboxPlus()($scope.fbGallery, $scope.fbGroup);
    }

    $scope.sortCallback = function(e, ui, index){
      $scope.contentListCopy = angular.copy($scope.contentGroup.content);
      $scope.tempContentList = [];
      $(".sortable-item").each(function($index){
        for(var i = 0;i < $scope.contentListCopy.length;i++){
          if(($scope.contentListCopy[i].id == $(this).attr("data-id")) && ($scope.contentListCopy[i].duration == $(this).find(".duration").val())){
            $scope.tempContentList.push($scope.contentListCopy[i]);
            $scope.contentListCopy.splice(i, 1);
            break;
          }
        }
      });
      $scope.contentGroup.content = [];
      $scope.$apply(function(){
        $scope.contentGroup.content = angular.copy($scope.tempContentList);
      });
    }

    $scope.closeFilteredFx = function(id, wcgid, tempId, i){
      for(i = 0;i < $scope.contentGroup.content.length;i++){
        if(wcgid && $scope.contentGroup.content[i].wcgid == wcgid && $scope.contentGroup.content[i].id == id){
          $scope.contentGroup.content.splice(i, 1);
          break;
        } else if(tempId && $scope.contentGroup.content[i].tempId == tempId && $scope.contentGroup.content[i].id == id){
          $scope.contentGroup.content.splice(i, 1);
        }
      }
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
        }
      });
      $scope.cgSize = {size:null, isShow:false};
      $scope.filteredContentArr = [];
      angular.forEach($scope.contentGroup.content, function(list){
        $scope.isDuplicate = false;
        for(var i = 0;i < $scope.filteredContentArr.length;i++){
          if(!$scope.isDuplicate && list.id == $scope.filteredContentArr[i].id){
            $scope.isDuplicate = true;
            break;
          }
        }
        if(!$scope.isDuplicate){
          $scope.filteredContentArr.push(list);
        }
      });
      angular.forEach($scope.filteredContentArr, function(content){
        if(content.pSize){
          $scope.cgSize.size += content.pSize;
        } else if(!content.pSize && content.size){
          $scope.cgSize.size += content.size * 1024;
        }
        if(content.hidden){
          $scope.cgSize.isShow = true;
        }
      });
      if($scope.cgSize.size){
        $scope.cgSize = {size:$scope.cgSize.size, isShow:$scope.cgSize.isShow};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.searchChangeFx("empty");
      $scope.advancedShow = true;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.advSearchInfo = args.info;
      if($scope.auth.upreferences.isSplitV){
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.quadHeight = $scope.getAvailableHeight(480);
          $scope.selectedHeight = $scope.getAvailableHeight(480);
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          $scope.quadHeight = $scope.getAvailableHeight(410);
          $scope.selectedHeight = $scope.getAvailableHeight(410);
        }
      } else {
        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          $scope.quadHeight = $scope.getAvailableHeight(500) * 0.55;
          $scope.selectedHeight = $scope.getAvailableHeight(480) * 0.45;
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          // $scope.quadHeight = $scope.getAvailableHeight(480) * 0.55;
          // $scope.selectedHeight = $scope.getAvailableHeight(460) * 0.45;
          $scope.quadHeight = $scope.getAvailableHeight(460) * 0.55;
          $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.45;
        }
      }
      // if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.type != null){
      //   $scope.quadHeight = $scope.getAvailableHeight(480);
      //   $scope.selectedHeight = $scope.getAvailableHeight(480);
      // } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.type == null){
      //   $scope.quadHeight = $scope.getAvailableHeight(410);
      //   $scope.selectedHeight = $scope.getAvailableHeight(410);
      // }
      // if(!$state.params.id){
      //   if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.type != null){
      //     $scope.quadHeight = $scope.getAvailableHeight(505);
      //     $scope.selectedHeight = $scope.getAvailableHeight(505);
      //   } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.type == null){
      //     $scope.quadHeight = $scope.getAvailableHeight(435);
      //     $scope.selectedHeight = $scope.getAvailableHeight(435);
      //   }
      // }
      $scope.folderList = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.extn != "Content on Demand" && item.extn != "Content Group" && item.extn != "Content on Demand Button" && item.extn != "Button"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CoMPylonTextController', CoMPylonTextController);

  /** @ngInject */
  function CoMPylonTextController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, ngDialog, pylonTextSrv){
    $scope.colorPicker = {b:false, bc:false, tc:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.hasErr = false;
    $scope.curTextId = 0;
    $scope.errType = "";
    $scope.decId = "";
    $scope.encId = "";
    $scope.textEdit = {edit:false};

    $scope.settings = {settings:{fontSize:11, noOfLines:3}};
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.pylonText.settings = angular.copy($scope.defaultSettings.settings);
    }

    $scope.subTab = 1;    
    $scope.subLoading = false;
    $scope.subTabFx = function(caller){
      $scope.subTabList = [];
      $scope.subTab = caller;
      if($scope.pylonText.textList.length){
        $scope.subLoading = true;
        var count = 0;
        var currentDate = new Date();
        
        if(caller == 1){
          $scope.pylonText.textList.forEach(function(obj) {
            count++;
            var startDate = new Date(obj.dateRange.startDate);
            var endDate = new Date(obj.dateRange.endDate);
    
            if ((currentDate >= startDate && currentDate <= endDate) || currentDate <= startDate) {
              $scope.subTabList.push(obj);
            }
            if(count == $scope.pylonText.textList.length){
              $scope.subLoading = false;
            }
          });
        } else{
          $scope.pylonText.textList.forEach(function(obj) {
            count++;
            var endDate = new Date(obj.dateRange.endDate);
    
            if (currentDate > endDate) {
              $scope.subTabList.push(obj);
            }
            if(count == $scope.pylonText.textList.length){
              $scope.subLoading = false;
            }
          });
        }
      }
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      pylonTextSrv.getPylonText($scope.decId).then(
        function(data){
          $scope.pylonText = data;
          if($scope.pylonText.textList.length){
            angular.forEach($scope.pylonText.textList, function(list){
              if(!list.st && !list.et){
                list.st = "00:00";
                list.et = "23:59";
              }
            })
          }
          $scope.subTabFx($scope.subTab)
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $scope.pylonText = {
        label:"",
        settings:angular.copy($scope.defaultSettings.settings),
        ctype:angular.copy($scope.defaultSettings.ctype),
        activePeriod:{type:"a"},
        permission:{type:$scope.auth.upreferences.defaultP},
        textList:[]
      }
      $scope.subTabFx($scope.subTab)
    }

    $scope.pylonTextFx = function(){
      $scope.pylonText.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.pylonText.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.pylonText.textList.length == 0){
        $scope.errType = "text";
        $scope.hasErr = true;
        $("#text").focus();
      }
      // else if($scope.pylonText.settings.speed == null){
      //   $scope.errType = "crawl";
      //   $scope.hasErr = true;
      //   $("#speed").focus();
      // }
      // else if($scope.pylonText.settings.width == null){
      //   $scope.errType = "width";
      //   $scope.hasErr = true;
      //   $("#width").focus();
      // }
      else if($scope.pylonText.settings.noOfLines == null){
        $scope.errType = "noOfLines";
        $scope.hasErr = true;
        $("#noOfLines").focus();
      } else if($scope.pylonText.settings.fontSize == null){
        $scope.errType = "fSize";
        $scope.hasErr = true;
        $("#fontSize").focus();
      }
      // else if($scope.pylonText.settings.fontSize < 11){
      //   $scope.errType = "invFSize";
      //   $scope.hasErr = true;
      //   $("#fontSize").focus();
      // }
      else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.pylonTextSaveFx();
          }, 250);
        } else{
          $scope.pylonTextSaveFx();
        }
      }
    }

    $scope.pylonTextSaveFx = function(){
      pylonTextSrv.savePylonText($scope.pylonText).then(
        function(data){
          $state.go("hub.contentLibrary.c");
          $scope.saveProcessing = false;
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.sortCallback = function(){
      $scope.pylonText.textList = [];
      angular.forEach(angular.element(".sortable-item"), function(item){
        $scope.pylonText.textList.push({id:$(item).attr("data-id"), text:$(item).find(".codeText").text(), dateRange:{startDate:$(item).attr("data-start"), endDate:$(item).attr("data-end")}, st:$(item).attr("data-st").replace(/\s*[APMapm]*$/, ''), et:$(item).attr("data-et").replace(/\s*[APMapm]*$/, '')});
      });
    }

    // $scope.customTime = {startTime:moment().format(), endTime:moment().add(5, "m").format()};
    $scope.customTime = {startTime:moment().startOf('day').format("YYYY-MM-DDTHH:mm:ssZ"), endTime:moment().startOf('day').add(23, 'hours').add(59, 'minutes').format("YYYY-MM-DDTHH:mm:ssZ")};
    $scope.addText = {id:"", text:"", dateRange:{startDate:moment()._d, endDate:moment().add(1, "days")._d}};
    $scope.addTextFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";

      $scope.curSTime = $filter("date")($scope.customTime.startTime, "HH:mm");
      $scope.curETime = $filter("date")($scope.customTime.endTime, "HH:mm");
      $scope.calculatedStartTime = new Date($scope.customTime.startTime).getTime()/1000;
      $scope.calculatedEndTime = new Date($scope.customTime.endTime).getTime()/1000;

      if($scope.calculatedEndTime - $scope.calculatedStartTime <= 0){
        $scope.errType = "startEnd";
        $scope.hasErr = true;
        $("#endTime").focus();
      } else {
        $scope.curDate = angular.element(document).find(".picker").val();
        $scope.curDate = $scope.curDate.split(" - ");
        // $scope.addText.dateRange = {startDate:moment($scope.curDate[0], 'MM/DD/YYYY').format('YYYY-MM-DD'), endDate:moment($scope.curDate[1], 'MM/DD/YYYY').format('YYYY-MM-DD')}
        $scope.addText.dateRange = {startDate:moment($scope.curDate[0]).format('MM/DD/YYYY'), endDate:moment($scope.curDate[1]).format('MM/DD/YYYY')};
        $scope.addText.id = "t" + $scope.curTextId;

        $scope.addText.st = $scope.curSTime;
        $scope.addText.et = $scope.curETime;

        $scope.pylonText.textList.push($scope.addText);
        $scope.curTextId++;
        $scope.addText = {text:"", dateRange:{startDate:moment()._d, endDate:moment().add(1, "days")._d}, st:$scope.customTime.startTime, et:$scope.customTime.endTime};
        $scope.customTime = {startTime:moment().startOf('day').format("YYYY-MM-DDTHH:mm:ssZ"), endTime:moment().startOf('day').add(23, 'hours').add(59, 'minutes').format("YYYY-MM-DDTHH:mm:ssZ")};
        $("#addText").focus();
        $scope.subTabFx($scope.subTab)
      }
    }

    $scope.deleteTextOpen = function(id){
      $scope.deleteId = id;
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteTextFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteTextFx = function(){
      angular.forEach($scope.pylonText.textList, function(list){
        if($scope.deleteId == list.id){
          $scope.pylonText.textList.splice($scope.pylonText.textList.indexOf(list), 1);
        }
      });
      $scope.subTabFx($scope.subTab);
      ngDialog.close();
    }

    $scope.editFx = function(data){
      $scope.textEdit = {edit:true};
      $scope.customTime.startTime =  moment(data.st, "HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      $scope.customTime.endTime = moment(data.et, "HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      $scope.addText = angular.copy(data);
      $("#addText").focus();
    }

    $scope.cancelTextFx = function(element){
      $scope.textEdit.edit = !$scope.textEdit.edit;
      $scope.addText = {id:"", text:"", dateRange:{startDate:moment()._d, endDate:moment().add(1, "days")._d}, st:$scope.customTime.startTime, et:$scope.customTime.endTime};
      $scope.customTime = {startTime:moment().startOf('day').format("YYYY-MM-DDTHH:mm:ssZ"), endTime:moment().startOf('day').add(23, 'hours').add(59, 'minutes').format("YYYY-MM-DDTHH:mm:ssZ")};
    }

    $scope.curText = "";
    $scope.saveTextFx = function(element){
      $scope.curDate = angular.element(document).find(".picker").val();
      element.dateRange.startDate = $scope.curDate.split(" - ")[0];
      element.dateRange.endDate = $scope.curDate.split(" - ")[1];
      $scope.curSTime = $filter("date")($scope.customTime.startTime, "HH:mm");
      $scope.curETime = $filter("date")($scope.customTime.endTime, "HH:mm");
      $scope.pylonText.textList.find(function(item){
        if(item.id === element.id){
          item.text = element.text;
          item.dateRange = element.dateRange;
          // item.dateRange = element.dateRange;
          item.dateRange = {startDate:moment(element.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(element.dateRange.endDate).format('MM/DD/YYYY')}


          item.st = $scope.curSTime;
          item.et = $scope.curETime;
        };
      });
      $scope.textEdit.edit = false;
      $scope.addText = {id:"", text:"", dateRange:{startDate:moment()._d, endDate:moment().add(1, "days")._d}, st:$scope.customTime.startTime, et:$scope.customTime.endTime};
      $scope.customTime = {startTime:moment().startOf('day').format("YYYY-MM-DDTHH:mm:ssZ"), endTime:moment().startOf('day').add(23, 'hours').add(59, 'minutes').format("YYYY-MM-DDTHH:mm:ssZ")};
      $scope.subTabFx($scope.subTab);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ComEventController', ComEventController);

  /** @ngInject */
  function ComEventController($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, ComEventSrv, ContentLibrarySrv, FileModelUploadSrv, CommonSrv, HDStethSrv, DevicesSrv){
    // $scope.colorPicker = {bg:false,ssbg:false,hb:false,ht:false,rt:false,art:false,rb:false,ab:false,titleText:false};
    $scope.colorPicker = {rssbg:false, rshb:false, dshb:false, cshb:false, rsrb:false, dsrb:false, csrb:false, rsrt:false, dsrt:false, csrt:false, rsht:false, dsht:false, csht:false, rsarb:false, dsarb:false, csarb:false, dssbg:false, cssbg:false, tt:false, rsb:false, dsb:false, csb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editEForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.curDeviceObj = {availableDevices:[], devices:[], caller:"comEvent"};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.curContentType = {target:false};
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = true;
    $scope.isEditable = false;
    $scope.isSelectCom = false;
    $scope.isSelectFac = false;
    $scope.aNet = {info:{}};
    $scope.isPEOpen = false;
    $scope.eventList = [];
    $scope.addEvent = {};
    $scope.curLogo = {};
    $scope.ssList = [];
    $scope.encId = "";
    $scope.decId = 0;
    $scope.search = {text:""};
    $scope.dgList = {d:[], g:[], r:[]};

    $scope.searchCom = {label:""};
    $scope.searchFac = {label:""};

    $scope.settings = {
      rs:{/*Rink schedule*/
        column1:"Time", column2:"Rink/Floor", column3:"Home", column4:"Room", column5:"Visitor", column6:"Room", rotationOpt:"a", rotate:12, bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, hb:"#1d7dd4", hba:1, ht:"#ffffff", rt:"#444444", art:"#444444", hf:$scope.fontFamilySelected, hs:20, rb:"#ffffff", rba:1, ab:"#c4e1ff", aba:1, rf:$scope.fontFamilySelected, arf:$scope.fontFamilySelected, rs:20, ars:20
      },
      ds:{/*Day schedule*/
        header:"TODAY'S ACTIVITIES", rotationOpt:"a", rotate:12, bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, hb:"#1d7dd4", hba:1, ht:"#ffffff", rt:"#444444", art:"#444444", hf:$scope.fontFamilySelected, hs:50, rb:"#ffffff", rba:1, ab:"#c4e1ff", aba:1, rf:$scope.fontFamilySelected, arf:$scope.fontFamilySelected, rs:25, ars:25
      },
      cs:{/*Civic committee*/
        title:"Today at Civic Centre", titleSize:80, titleText:"#ffffff", titleFont:{label:"Century Gothic", value:"century gothic"}, column1:"Time", column2:"Event", column3:"Location", rotationOpt:"a", rotate:12, bg:"#1d7dd4", bga:1, ssbg:"#000000", ssbga:1, ht:"#ffffff", rt:"#ffffff", art:"#ffffff", hf:$scope.fontFamilySelected, hs:25, rf:$scope.fontFamilySelected, arf:$scope.fontFamilySelected, rs:25, ars:25
      },
      sos:{sType:"s", prior:60, eType:"a", after:60}
    };
    $scope.rgbaS1 = {hb:$scope.settings.rs.hb,ab:$scope.settings.rs.ab};
    $scope.rgbaS2 = {hb:$scope.settings.ds.hb,ab:$scope.settings.ds.ab};
    $scope.rgbas3 = {bg:$scope.settings.cs.bg};

    $scope.ctype = {
      rs:{bg:"monochrome", ssbg:"monochrome", hb:"custom", ht:"monochrome", rt:"monochrome", art:"monochrome", rb:"monochrome", ab:"custom"},
      ds:{bg:"monochrome", ssbg:"monochrome", hb:"custom", ht:"monochrome", rt:"monochrome", art:"monochrome", rb:"monochrome", ab:"custom"},
      cs:{bg:"monochrome", ssbg:"monochrome", ht:"monochrome", rt:"monochrome", art:"monochrome", rb:"monochrome", ab:"custom", titleText:"monochrome"}
    };

    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      if($scope.auth.upermissions.cfo){
        return false;
      }
      $scope.aNet.settings = angular.copy($scope.defaultSettings.settings);
      $scope.aNet.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.celEventBack = angular.fromJson(localStorage.getItem("celEventBack"));

    //! No need to do this here start
    // CommonSrv.getAvailableDevice().then(
    //   function(data){
    //     $scope.deviceList = data;
    //   },
    //   function(err){
    //     $log.error(err);
    //   }
    // );
    //! No need to do this here end

    if($state.params.id){
      $scope.isEditable = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      ComEventSrv.getActiveNet($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.aNet = data;
          $scope.tim = $scope.aNet.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.aNet.bucket;
          if($scope.aNet.mbucket && $scope.aNet.mbucket != ""){
            $scope.cDetailBucket = $scope.aNet.mbucket;
          }
          if(!$scope.aNet.settings.sos){
            $scope.aNet.settings.sos = {sType:"s", prior:60, eType:"a", after:60};
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $scope.detailLoading = false;
      $scope.celEventBack = null;
      $rootScope.tabView = true;

      $scope.aNet = {label:"", dType:"r", type:"r", com:{}, fac:"", activePeriod:{type:"a"}, ctype:angular.copy($scope.ctype),
      settings:angular.copy($scope.settings), permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.getSSFx = function(caller){
      ComEventSrv.getSSList($scope.aNet.id).then(
        function(data){
          $scope.detailLoading = false;
          $scope.ssList = data.screenSaver;
          if(!$scope.ssList.length){
            $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
          } else if(caller !== "ss"){
            $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.errType = "";
      $scope.hasListErr = false;
      if(caller == "e"){
        $scope.addEvent = angular.copy($scope.defaultEvent);
      } else if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.deviceList), devices:[], caller:"comEvent"};
      }
    }

    $scope.subTab = 1;
    $scope.subTabFx = function(caller){
      $scope.curBookingId = localStorage.removeItem("curDupEvent");
      $scope.subTab = caller;
      if($scope.aNet.fac){
        $scope.subLoading = true;
        $scope.getEventListFx();
      }
    }
    $rootScope.selectedTabFx = function(caller){
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editEForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.isSelectCom = false;
      $scope.isSelectFac = false;
      $scope.detailLoading = true;
      $scope.complexList = [];
      $scope.facilityList = [];
      if($scope.selectedT == "1"){
        $scope.detailLoading = false;
        //! No need to call this API here start
        // $scope.editEForm.isShow = false;
        // HDStethSrv.getSSDevices().then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.dgList.d = angular.copy(data.devices);
        //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        // $scope.aNet.com = null;
        // $scope.aNet.fac = null;
        //! No need to call this API here end
      } else if($scope.selectedT == "2"){
        if(caller != "sort"){
          $scope.complexList = [];
          $scope.aNet.com = null;
          $scope.aNet.fac = null;
        }
        ComEventSrv.getComAndFacilityList().then(
          function(data){
            $scope.detailLoading = false;
            if(data.length){
              $scope.comFacilityList = data;
              if($scope.comFacilityList.length){
                $scope.complexList = $scope.comFacilityList.filter(function(value, index, self){
                  return (
                    self.findIndex(function(v){ return v.cv=== value.cv}) === index
                  );
                });
              }
              if($scope.decId && $scope.aNet.com != null){
                $scope.getFacilityFx($scope.aNet.com.cv);
              } else {
                $scope.eventList = [];
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
        if($scope.decId && $scope.aNet.com != null){
          if(caller == "sort"){
            $scope.subTabFx($scope.subTab);
          } else{
            $scope.subTabFx(1);
          }
        }
      } else if($scope.selectedT == "3"){
        $scope.editEForm.isShow = false;
        $scope.aNet.com = null;
        $scope.aNet.fac = null;
        $scope.getSSFx();
        $scope.resetFx('s');
      }
    }
    $rootScope.selectedTabFx();

    $scope.selComplex = function(com){
      $("#com").removeClass("open");
      $scope.isSelectCom = true;
      $scope.isSelectFac = false;
      $scope.subTab = 1;
      $scope.aNet.fac = null;
      $scope.aNet.com = com;
      $scope.getFacilityFx($scope.aNet.com.cv)
    }
    $scope.selFacility = function(fac){
      $("#fac").removeClass("open");
      $scope.isSelectFac = true;
      $scope.aNet.fac = fac;
      $scope.getEventListFx();
    }

    $scope.getFacilityFx = function(comId){
      if($scope.comFacilityList.length){
        $scope.facilityList = $scope.comFacilityList.filter(function(item){
          if(item.cv == comId){
            return item;
          }
        });
        if($scope.aNet.fac == null || $scope.facilityList[0].fv == 0){
          $scope.isSelectFac = false;
          $scope.aNet.fac = {fv:0};
          $scope.getEventListFx();
        } else {
          $scope.isSelectFac = true;
        }
      }
      $scope.isSelectCom = true;
    }

    $scope.getEventListFx = function(caller){
      $scope.eventList = [];
      $scope.curBookingId = "";
      // if($scope.aNet.fac != null && $scope.aNet.fac.fv){
        $scope.subLoading = true;
        if(caller=='copy'){
          $scope.curBookingId = localStorage.getItem('curDupEvent');
        } else {
          localStorage.removeItem('curDupEvent');
        }
        if($scope.subTab == 1){
          ComEventSrv.getActiveList($scope.decId, $scope.aNet.com.cv, $scope.aNet.fac.fv).then(
            function(data){
              $scope.subLoading = false;
              $scope.eventList = data.data;
              $scope.eventListInfo = data.info;
              // $scope.editEForm = {isShow:false, isAdd:false, isEdit:false};
              setTimeout(function(){
                angular.forEach(angular.element('.event-list li'), function(item){
                  if($(item).attr('data-bookingId') == $scope.curBookingId){
                    $(item).addClass('ui-highlight');
                  }
                });
              }, 100);
            },
            function(err){
              $log.error(err);
              $scope.subLoading = false;
            }
          );
        } else {
          ComEventSrv.getExpireList($scope.decId, $scope.aNet.com.cv, $scope.aNet.fac.fv).then(
            function(data){
              $scope.subLoading = false;
              $scope.eventList = data.data;
              $scope.eventListInfo = data.info;
              // $scope.editEForm = {isShow:false, isAdd:false, isEdit:false};
              setTimeout(function(){
                angular.forEach(angular.element('.event-list li'), function(item){
                  if($(item).attr('data-bookingId') == $scope.curBookingId){
                    $(item).addClass('ui-highlight');
                  }
                });
              }, 100);
            },
            function(err){
              $log.error(err);
              $scope.subLoading = false;
            }
          );
        }

      // }
    }

    $scope.setVisibilityOpen = function(obj){
      $scope.status = (obj.isHid && obj.isHid==1)?0:1;
      $scope.confirmObj = {status:$scope.status,data:obj,id:$scope.aNet.id};
      if(obj.isHid && obj.isHid){
        $scope.setVisibilityFx();
      } else {
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.aNet.m6" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="setVisibilityFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }
    $scope.setVisibilityFx = function(){
      $scope.removeProcessing = true;
      $scope.confirmObj.comId = parseInt($scope.aNet.com.cv);
      $scope.confirmObj.facId = parseInt($scope.aNet.com.fv);
      ComEventSrv.setVisibility($scope.confirmObj).then(
        function(data){
          $scope.removeProcessing = false;
          ngDialog.close();
          $scope.getEventListFx();
        },
        function(err){
          $log.error(err);
          $scope.removeProcessing = false;
        }
      );
    }

    /*Logo*/
    $scope.logoPopover = {templateUrl:"logo.html"};
    $scope.screenPopover = {templateUrl:"screen.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if(item.type == "Video" || item.splType == "Video"){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(caller){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.search = {text:""};

      if(caller=="target"){
        $scope.curContentType.target = true;
      } else{
        $scope.curContentType.target = false;
      }
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.loading = false;
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".thumb-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "3"){
          $scope.addScreen.ss = $scope.curContent;
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "l"){
        $scope.addEvent.logo = null;
      } else if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    //Add Event
    $scope.custTime = moment().set('minute', '00').utc().format();
    $scope.defaultEvent = {
      activityName:"",
      startDateTime:$scope.custTime,
      endDateTime:$scope.custTime,
      ht:"",htr:"",vt:"",vtr:"",
      date:{startDate:moment()._d, endDate:moment()._d}
    };

    $scope.addEvent = angular.copy($scope.defaultEvent);

    function padWithLeadingZeros(num, totalLength) {
      return String(num).padStart(totalLength, '0');
    }


    $scope.addEventFx = function(caller){
      $scope.errType = "";
      $scope.curEvent = {};
      $scope.hasListErr = false;
      if($scope.id){
        $scope.aNet.id = $scope.id;
      }
      $scope.copyAddEvent = angular.copy($scope.addEvent);

      $scope.curDate = angular.element(document).find("#date").val();
      $scope.curDate = $scope.curDate.split(" - ");

      $scope.curTime = {sdr:angular.element(document).find("#sdr").val(), edr:angular.element(document).find("#edr").val()};

      if($scope.curTime.sdr.split(" ")[1] == "PM"){
        if(Number($scope.curTime.sdr.split(":")[0])==12){
          $scope.curTime.sdr = Number($scope.curTime.sdr.split(":")[0]) +":"+ padWithLeadingZeros($scope.curTime.sdr.split(":")[1].split(" ")[0], 2) +":00";
        } else {
          $scope.curTime.sdr = Number($scope.curTime.sdr.split(":")[0]) + 12 +":"+ padWithLeadingZeros($scope.curTime.sdr.split(":")[1].split(" ")[0], 2) +":00";
        }
      }
      if($scope.curTime.edr.split(" ")[1] == "PM"){
        if(Number($scope.curTime.edr.split(":")[0])==12){
          $scope.curTime.edr = Number($scope.curTime.edr.split(":")[0]) +":"+ padWithLeadingZeros($scope.curTime.edr.split(":")[1].split(" ")[0], 2) +":00";
        } else {
          $scope.curTime.edr = Number($scope.curTime.edr.split(":")[0]) + 12 +":"+ padWithLeadingZeros($scope.curTime.edr.split(":")[1].split(" ")[0], 2) +":00";
        }
      }

      if($scope.curTime.sdr.split(" ")[1] == "AM"){
        $scope.curTime.sdr = padWithLeadingZeros($scope.curTime.sdr.split(":")[0]==12 ? '00' : $scope.curTime.sdr.split(":")[0], 2) +":"+ padWithLeadingZeros($scope.curTime.sdr.split(":")[1].split(" ")[0], 2) +":00";
      }
      if($scope.curTime.edr.split(" ")[1] == "AM"){
        $scope.curTime.edr = padWithLeadingZeros($scope.curTime.edr.split(":")[0]==12 ? '00' : $scope.curTime.edr.split(":")[0], 2) +":"+ padWithLeadingZeros($scope.curTime.edr.split(":")[1].split(" ")[0], 2) +":00";
      }

      $scope.copyAddEvent.startDateTime = moment($scope.curDate[0]).format("YYYY-MM-DDT")+$scope.curTime.sdr;
      $scope.copyAddEvent.endDateTime = moment($scope.curDate[1]).format("YYYY-MM-DDT")+$scope.curTime.edr;

      // if($scope.editEForm.isAdd && $scope.copyAddEvent.activityName == ""){
      //   $scope.errType = "aName";
      //   $scope.hasListErr = true;
      //   $("#activityName").focus();
      // } else
      if($scope.curTime.sdr == null){
        $scope.errType = "start";
        $scope.hasListErr = true;
        $("#start").focus();
      } else if($scope.curTime.edr == null){
        $scope.errType = "end";
        $scope.hasListErr = true;
        $("#end").focus();
      } else if($scope.curTime.sdr >= $scope.curTime.edr){
        $scope.errType = "startEnd";
        $scope.hasListErr = true;
        $("#end").focus();
      } else{
        $scope.addProcessing = true;
        if($scope.editEForm.isAdd){
          $scope.copyAddEvent.bookingId = 0;
          $scope.copyAddEvent.complexId = parseInt($scope.aNet.com.cv);
          $scope.copyAddEvent.facilityId = parseInt($scope.aNet.fac.fv);
          $scope.copyAddEvent.facilityTypeId = 0;
          $scope.copyAddEvent.rentalIdOrActivityId = 0;
          $scope.copyAddEvent.courseId = 0;
          $scope.copyAddEvent.facilityName = $scope.aNet.fac.flabel ? $scope.aNet.fac.flabel.split("(")[0].trim() : "";
          $scope.copyAddEvent.facilityTypeName = "";
          $scope.copyAddEvent.complexName = $scope.aNet.com.clabel.split("(")[0].trim();
          $scope.copyAddEvent.startWeekDay = "";
          $scope.copyAddEvent.bookingType = "";
          $scope.copyAddEvent.dateOfCreation = $scope.custTime.split("+")[0];
          $scope.copyAddEvent.isActive = true;
        }
        $scope.curEvent = {id:$scope.aNet.id, data:$scope.copyAddEvent, comId:parseInt($scope.aNet.com.cv), facId:parseInt($scope.aNet.fac.fv)};
        ComEventSrv.updateEvent($scope.curEvent).then(
          function(data){
            $scope.id = data.id;
            $scope.addProcessing = false;
            if(data.timthumb){
              $scope.tim = data.timthumb;
            }
            if(caller == "s"){
              $scope.editEForm.isShow = false;
            } else{
              $scope.editEForm.isShow = true;
            }
            $scope.subTabFx($scope.subTab);
            $scope.resetFx('e');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.syncOpen = function(id, caller){
      $scope.syncObj = {id:id, caller:caller};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{syncObj.caller==\'s\' ? "an.msg.6" : "cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="syncFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.syncFx = function(){
      $scope.removeProcessing = true;
      ComEventSrv.syncEvent($scope.decId, $scope.syncObj.id, parseInt($scope.aNet.com.cv), parseInt($scope.aNet.com.fv)).then(
        function(data){
          if(data.code == 8296 || data.code == 8300){
            $scope.removeProcessing = false;
            ngDialog.close();
            $scope.subTabFx($scope.subTab);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.removeProcessing = false;
    $scope.deleteOpen = function(caller, iId){
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      ComEventSrv.delete($scope.aNet.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.editSForm = {isAdd:true, isEdit:false};
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      $('.widgetForm').scrollTop(0);
      $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      } else if(caller == "ev"){
        $scope.editEForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addEvent = angular.copy(data);
        $scope.addEvent.startTime = $scope.addEvent.startTime;
        $scope.addEvent.endTime = $scope.addEvent.endTime;
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel, type){
      // var curModel = [];
      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });
      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        // $scope.resetD(caller);
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      }
      else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        // $scope.resetD(caller);
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dAList = [];
      // $rootScope.dSList = [];
    }

    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }

      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   });
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      //   // angular.forEach($scope.curDeviceObj.availableDevices, function(list){
      //   //   $scope.isDuplicate = false;
      //   //   for(var i=0; i<$scope.curDeviceObj.devices.length; i++){
      //   //     if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //   //       $scope.isDuplicate = true;
      //   //       break;
      //   //     }
      //   //   }
      //   //   if(!$scope.isDuplicate){
      //   //     $scope.curAvailableDevices.push(list);
      //   //   }
      //   // });
      //   // $scope.curDeviceObj.availableDevices = $scope.curAvailableDevices;
      // }
      //! No need to do here end

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
          //! No need to do here start
          // if(caller){
          //   $scope.curDeviceObj = {availableDevices:angular.copy($scope.deviceList), devices:[], caller:"comEvent"};
          // }
          //! No need to do here end
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wComEvtSS", caller: "availD", offset: 0, id: $scope.aNet.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wComEvtSS", caller: "selD", offset: 0, id: $scope.aNet.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: change the value
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }

    $scope.addScreensaverFx = function(caller){
      $scope.hasListErr = false;
      $scope.errType = "";
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#deviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.ssPostObj = {info:{id:$scope.aNet.id}, screenSaver:$scope.addScreen};
        ComEventSrv.addSS($scope.ssPostObj).then(
          function(data){
            // TODO: add new changes
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            var filterd = $filter("filter")($scope.ssList, {"sId":data.sId}, true);
            if(filterd.length){
              angular.forEach($scope.ssList, function(ss, index){
                if(ss.sId == data.sId){
                  $scope.ssList[index].sId = data.sId;
                  $scope.ssList[index].d = $scope.addScreen.d;
                  $scope.ssList[index].ss = $scope.addScreen.ss;
                  $scope.ssList[index].label = $scope.addScreen.label;
                }
              });
            } else{
              $scope.ssList.push({sId:data.sId, label:$scope.addScreen.label, ss:$scope.addScreen.ss, d:$scope.addScreen.d});
            }
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $rootScope.selectedTabFx("sort");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];

      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      if($scope.selectedT==3){
        angular.forEach($scope.ssList, function(item, index){
          angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
            $scope.curRow.push(obj);
          });
        });
        $scope.ssList = [];
        $scope.ssList = $scope.curRow;

        $scope.aNet.screenSaver = [];
        $scope.aNet.screenSaver = $scope.ssList;
      }
    }

    $scope.aNetFx = function(tab, caller){
      // TODO: new code
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || tab == 2 || tab == 3 || caller == "save"){
        if($scope.aNet.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
        } else if($scope.aNet.settings.sos.sType == "p" && !$scope.aNet.settings.sos.prior){
          $scope.errType = "sosP";
          $scope.hasErr = true;
        } else if($scope.aNet.settings.sos.eType == "a" && !$scope.aNet.settings.sos.after){
          $scope.errType = "sosA";
          $scope.hasErr = true;
        } else if(!$scope.aNet.settings.rs.hs || !$scope.aNet.settings.ds.hs || !$scope.aNet.settings.cs.hs){
          $scope.errType = "hSize";
          $scope.hasErr = true;
        } else if(!$scope.aNet.settings.rs.rs || !$scope.aNet.settings.ds.rs || !$scope.aNet.settings.cs.rs){
          $scope.errType = "rSize";
          $scope.hasErr = true;
        } else if(!$scope.aNet.settings.rs.ars || !$scope.aNet.settings.ds.ars || !$scope.aNet.settings.cs.ars){
          $scope.errType = "arSize";
          $scope.hasErr = true;
        } else if(($scope.aNet.settings.rs.rotationOpt == "c" && $scope.aNet.settings.rs.rotate == null) || ($scope.aNet.settings.ds.rotationOpt == "c" && $scope.aNet.settings.ds.rotate == null) || ($scope.aNet.settings.cs.rotationOpt == "c" && $scope.aNet.settings.cs.rotate == null)){
          $scope.errType = "rotation";
          $scope.hasErr = true;
        } else if($scope.aNet.settings.rs.column1 == "" || $scope.aNet.settings.rs.column2 == "" || $scope.aNet.settings.rs.column3 == "" || $scope.aNet.settings.rs.column4 == "" || $scope.aNet.settings.rs.column5 == "" || $scope.aNet.settings.rs.column6 == "" || $scope.aNet.settings.cs.column1 == "" || $scope.aNet.settings.cs.column2 == "" || $scope.aNet.settings.cs.column3 == ""){
          $scope.errType = "headCol";
          $scope.hasErr = true;
        } else if($scope.aNet.settings.ds.header == ""){
          $scope.errType = "dsHeader";
          $scope.hasErr = true;
        } else if($scope.aNet.settings.cs.title == ""){
          $scope.errType = "title";
          $scope.hasErr = true;
        } else if(!$scope.aNet.settings.cs.titleSize){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.aNet.fid = $scope.fid;
          $scope.aNet.toast = false;

          if(tab == 1 || tab == 2 || tab == 3){
            $scope.nextProcessing = true;
          } else{
            $scope.aNet.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveActiveNetFx(tab);
            }, 250);
          } else{
            $scope.saveActiveNetFx(tab);
          }
        }
      } else{
        if(tab == 1){
          $timeout(function(){
            $scope.tabFx(2, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else
        if(tab == 2){
          $timeout(function(){
            $scope.tabFx(3, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $timeout(function(){
            $scope.tabFx(4, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        }
      }
    }

    $scope.saveActiveNetFx = function(tab, caller){
      $scope.aNet.fid = $scope.fid;
      $scope.aNet.tzOffset = $scope.curTimezone;
      // todo No need to send the screen saver data
      // $scope.aNet.screenSaver = $scope.ssList;
      ComEventSrv.saveActiveNet($scope.aNet).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.aNet.id = data.id;
            $scope.decId = data.id;
          }
          if(tab == 1 || tab == 2 || tab == 3){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
            else if(tab == 2){
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
            else{
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.cancelFx = function(){
      localStorage.removeItem("celEventBack");
      $state.go("hub.contentLibrary.c");
    }

    $scope.syncComFacFx = function(caller){
      if(caller=="c"){
        $scope.syncingCom = true;
        $scope.sType = "complex";
      } else {
        $scope.syncingFac = true;
        $scope.sType = "facility";
      }
      ComEventSrv.syncData($scope.sType).then(
        function(data){
          if(data.code == 8638 || data.code == 8639){
            $scope.syncingFac = false;
            $scope.syncingCom = false;
            $scope.getComAndFacilityList();
          }
        },
        function(err){
          $scope.syncingFac = false;
          $scope.syncingCom = false;
          $log.error(err);
        }
      );
    }

    $scope.getComAndFacilityList = function(){
      ComEventSrv.getComAndFacilityList().then(
        function(data){
          $scope.detailLoading = false;
          if(data.length){
            $scope.comFacilityList = data;
            if($scope.comFacilityList.length){
              $scope.complexList = $scope.comFacilityList.filter(function(value, index, self){
                return (
                  self.findIndex(function(v){ return v.cv=== value.cv}) === index
                );
              });
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="comEvent"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="comEvent"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset selected devices
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.search = {text:""};
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Video"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    $scope.searchFocus = function(type){
      if(type=='c'){
        $scope.searchCom = {label:""};
        if($scope.complexList.length > 5){
          angular.element(document).find(".findCSearch").children()[0].focus();
        }
      } else {
        $scope.searchFac = {label:""};
        if($scope.facilityList.length > 5){
          angular.element(document).find(".findFSearch").children()[0].focus();
        }
      }
    }

    $scope.duplicateOpen = function(obj){
      $scope.copyObj = obj;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.widget.aNet.m10" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="duplicateFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.duplicateFx = function(){
      $scope.removeProcessing = true;
      $scope.copyObj.bookingId = 0;
      $scope.curEvent = {id:$scope.aNet.id, data:$scope.copyObj, isDup:true, comId:parseInt($scope.aNet.com.cv), facId:parseInt($scope.aNet.com.fv)};
      ComEventSrv.updateEvent($scope.curEvent).then(
        function(data){
          $scope.removeProcessing = false;
          ngDialog.close();
          localStorage.setItem("curDupEvent", data.bookingId);
          $scope.getEventListFx("copy");
        },
        function(err){
          $log.error(err);
          $scope.removeProcessing = false;
        }
      );
    }

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('COEVController', COEVController);

  /** @ngInject */
  function COEVController($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, DevicesSrv, ContentLibrarySrv, FileModelUploadSrv, COESrv){
    $scope.colorPicker = {hb:false, ht:false, db:false, dt:false, cb:false, et:false, rt:false, tt:false, tb:false, isOpen:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    $scope.weekdays = [0, 1, 2, 3, 4, 5, 6];

    $scope.curDeviceObj = {availableDevices:[], devices:[]};
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = true;
    $scope.coev = {info:{}};
    $scope.isPEOpen = false;
    $scope.meetingList = [];
    $scope.currentPage = 0;
    $scope.curLogo = {};
    $scope.ssList = [];
    $scope.encId = "";
    $scope.decId = 0;

    $scope.frameBg = {isChecked:false};
    $scope.curFrameIndex;
    $scope.curLayer = 0;
    $scope.frameId = 0;
    $scope.tableZ = 0;
    $scope.curZ = 1;
    $scope.curFrame;

    $scope.settings = {
      d:{headerBg:"#f3f3f3", headerBga:1, headerText:"#444444", rowBg:"#f3f3f3", rowBga:1, eventText:"#000000", roomText:"#999999", timeBg:"#cfe2f3", timeBga:1, timeText:"#444444"}, /*Day*/
      wm:{headerBg:"#f3f3f3", headerBga:1, headerText:"#444444", dayNameBg:"#cfe2f3", dayNameBga:1, dayNameText:"#073763", cellBg:"#ffffff", cellBga:1, eventText:"#000000", roomText:"#999999", timeText:"#444444"} /*Week / moanth*/
    };
    $scope.ctype = {
      d:{hBg:"monochrome", hText:"monochrome", rowBg:"monochrome", eText:"monochrome", rText:"monochrome", tBg:"default", tText:"monochrome"},/*Day*/
      wm:{hBg:"monochrome", hText:"monochrome", dnBg:"default", dnText:"default", cBg:"monochrome", eText:"monochrome", rText:"monochrome", tText:"monochrome"}/*Week | moanth*/
    };

    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsDefault = function(){
      if($scope.coev.info.type == "d"){
        $scope.coev.info.settings = angular.copy($scope.defaultSettings.settings.d);
        $scope.coev.info.ctype = angular.copy($scope.defaultSettings.ctype.d);
      } else{
        $scope.coev.info.settings = angular.copy($scope.defaultSettings.settings.wm);
        $scope.coev.info.ctype = angular.copy($scope.defaultSettings.ctype.wm);
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      COESrv.getCOEV($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.coev = data;

          $scope.tim = $scope.coev.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.coev.info.bucket;
          if($scope.coev.info.mbucket && $scope.coev.info.mbucket != ""){
            $scope.cDetailBucket = $scope.coev.info.mbucket;
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }

    $scope.subTab = 1;
    $scope.subTabFx = function(caller){
      $scope.subTab = caller;
      $scope.subLoading = true;
      if(caller == "1"){
        COESrv.getActiveList($scope.coev.info.wid).then(
          function(data){
            $scope.subLoading = false;
            $scope.meetingList = data.meeting;

            angular.forEach($scope.meetingList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      } else{
        COESrv.getExpireList($scope.coev.info.wid).then(
          function(data){
            $scope.subLoading = false;
            $scope.meetingList = data.meeting;

            angular.forEach($scope.meetingList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      }
    }
    $rootScope.selectedTabFx = function(){
      if($scope.selectedT == "1"){
      } else if($scope.selectedT == "2"){
        $scope.subTabFx(1);
      } else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        COESrv.getSSList($scope.coev.info.wid).then(
          function(data){
            $scope.detailLoading = false;
            $scope.ssList = data.screenSaver;
            if(!$scope.ssList.length){
              $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
            } else{
              $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
            }
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
    }
    $rootScope.selectedTabFx();

    $scope.printDiv = function(divName, pageTitle){
      var printContents = document.getElementById("canvas").innerHTML;
      var popupWin = window.open('', '_blank', 'width=1000,height=800');
      popupWin.document.open();
      popupWin.document.write('<html><head><title>' + $scope.preview.calendar[$scope.currentPage].label + '</title><style type="text/css">html{height:100%;}body{padding:0;margin:0;font-family:\'Open Sans\',sans-serif;font-size:9px;font-weight:400;}.text-big{font-size:20px;margin:10px;}.text-center{text-align:center;}table{margin-bottom:0;border:1px solid #ddd;width:100%;max-width:100%;border-collapse:collapse;border-spacing:0;}th,td{padding:8px;vertical-align:top;border:1px solid #ddd;}.text-muted{color:#808080;}.marB5{margin-bottom:5px;}th,.text-bold{font-weight:600;}.text-sm{font-size:80%;}.bdr-btm-dashed{border-bottom:1px dashed #c7c7c7;padding-bottom:5px;margin-bottom:10px;}</style></head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
    }

    $scope.addFrame = function(frameType){
      if(frameType == "content"){
        $scope.curAlign = "m-c";
      } else{
        $scope.curAlign = "left";
      }
      $scope.preview.frames.push({
        id:"t" + $scope.frameId,
        label:"Placeholder " + parseInt($scope.preview.frames.length + 1),
        width:100,
        height:100,
        rotation:0,
        bg:"",
        fill:"fit",
        x:Math.round($("#canvas").scrollLeft()),
        y:Math.round($("#canvas").scrollTop()),
        z:$scope.curZ,
        type:frameType,
        text:"",
        font:$scope.fontFamilySelected,
        size:24,
        color:"#000000",
        bold:"normal",
        italic:"none",
        underline:"none",
        align:$scope.curAlign,
        content:[],
        feedRef:0,
        isNew:1
      });
      $scope.frameId++;
      $scope.curZ++;

      $(".sortable-containment").sortable({
        cancel:".span"
      });
    }

    $scope.duplicateFrame = function(frameType){
      $scope.preview.frames.push({
        id:"t" + $scope.frameId,
        label:$scope.curFrame.label + " - Copy",
        width:$scope.curFrame.width,
        height:$scope.curFrame.height,
        rotation:$scope.curFrame.rotation,
        bg:$scope.curFrame.bg,
        fill:$scope.curFrame.fill,
        x:$scope.curFrame.x,
        y:$scope.curFrame.y,
        z:$scope.curZ,
        type:$scope.curFrame.type,
        text:$scope.curFrame.text,
        font:$scope.curFrame.font,
        size:$scope.curFrame.size,
        color:$scope.curFrame.color,
        bold:$scope.curFrame.bold,
        italic:$scope.curFrame.italic,
        underline:$scope.curFrame.underline,
        align:$scope.curFrame.align,
        content:angular.copy($scope.curFrame.content),
        feedRef:$scope.curFrame.feedRef,
        isNew:1
      });
      $scope.frameId++;
      $scope.curZ++;

      $(".sortable-containment").sortable({
        cancel:".span"
      });
    }

    $scope.frameDragStart = function(e, ui, index){
      $scope.preview.frames[index].x = ui.position.left;
      $scope.preview.frames[index].y = ui.position.top;
    }

    $scope.frameResize = function(e, ui, index){
      $scope.preview.frames[index].width = ui.size.width;
      $scope.preview.frames[index].height = ui.size.height;
    }

    $scope.frameDrag = function(e, ui, index){
      $scope.preview.frames[index].x = ui.position.left;
      $scope.preview.frames[index].y = ui.position.top;
    }

    $scope.selectFrame = function(e, frame, index){
      e.stopPropagation();
      $scope.colorPicker.isOpen = false;
      $scope.curFrameIndex = index;
      $scope.curFrame = frame;

      if($scope.curFrame.type == "content" && $scope.popupTab == 4){
        $scope.popupTab = '3';
      } else if($scope.curFrame.type == "text" && $scope.popupTab == 3){
        $scope.popupTab = '4';
      } else if(($scope.curFrame.type == "rectangle" || $scope.curFrame.type == "circle") && ($scope.popupTab == 3 || $scope.popupTab == 4)){
        $scope.popupTab = '1';
      }

      $(".layer-container .layer").removeClass("selected");
      $(".frame").removeClass("selected");

      $(".layer[data-id=" + frame.id + "]").addClass("selected");
      $(".frame[data-id=" + frame.id + "]").addClass("selected");

      if($scope.curFrame.bg != ''){
        $scope.frameBg.isChecked = true;
      } else{
        $scope.frameBg.isChecked = false;
      }
    }

    $scope.sortCallback = function(e, ui, index){
      $scope.curLayer = $(".layer").length + 1;
      $(".layer").each(function(){
        for(var i = 0; i < $scope.preview.frames.length; i++){
          if($scope.preview.frames[i].id == $(this).data("id")){
            $scope.preview.frames[i].z = $scope.curLayer - 1;
            if($scope.preview.frames[i].type == 'table'){
              $scope.tableZ = $scope.preview.frames[i].z;
            }
            break;
          }
        }
        $scope.curLayer--;
      });
      $(".tab-success.active a").click();
    }

    $scope.deselectAllFrames = function(){
      $(".layer").removeClass("selected");
      $(".frame").removeClass("selected");
      $scope.colorPicker.isOpen = false;
      $scope.frameBg.isChecked = false;
      //$rootScope.selectedT = '1';
      $scope.curFrame = null;
    }

    angular.element(document).bind('keyup', function(e){
      if(e.keyCode == 46){
        if(!$(document.activeElement).is('input[type="text"], input[type="number"], textarea')){
          if($scope.curFrame && $scope.curFrame.type != 'table'){
            $scope.isConfirmOpen = false;
            $scope.removePlaceholder();
          }
        }
      }
    });

    $scope.removePlaceholder = function(id, type){
      if(!$scope.isConfirmOpen){
        if(type){
          $scope.removeObj = {id:id, type:type};
        } else{
          $scope.removeObj = null;
        }
        $scope.confirmDeletePlaceholder();
      }
    }

    $scope.confirmDeletePlaceholder = function(){
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"t.msg.10" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePlaceholder();" ng-disabled="templateProcessing">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deletePlaceholder = function(){
      if($scope.removeObj){
        if($scope.removeObj.type == "l"){
          $scope.preview.frames.splice($scope.preview.frames.indexOf($scope.preview.frames.filter(function(obj){
            return obj.id == $scope.removeObj.id;
          })[0]), 1);
        }
      } else{
        $scope.preview.frames.splice($scope.curFrameIndex, 1);
      }
      $timeout(function(){$("#canvas").click();}, 250);
      ngDialog.close($scope.ngDialogId, "coev");
    }

    $scope.textPropFx = function(prop){
      if(prop == "bold"){
        $scope.curFrame.bold = $scope.curFrame.bold == "bold" ? "normal" :"bold";
      } else if(prop == "italic"){
        $scope.curFrame.italic = $scope.curFrame.italic == "italic" ? "none" :"italic";
      } else if(prop == "underline"){
        $scope.curFrame.underline = $scope.curFrame.underline == "underline" ? "none" :"underline";
      } else if(prop == "left" || prop == "center" || prop == "right"){
        $scope.curFrame.align = prop;
      }
    }

    $scope.frameBgFx = function(e){
      if(!$(e.currentTarget).children("input")[0].checked){
        $scope.curFrame.bg = '';
      }
    }

    $scope.popupTab = 1;
    $scope.popupTabFx = function(caller){
      $scope.popupTab = caller;
    }

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = $filter("filter")($scope.contentLibrary.contentLibrary.content, {type:"Image"}, true); //For normal Content
    }
    $scope.isLoading = true;
    $scope.getApprovedFx = function(){
      if($scope.isLoading){
        $scope.contentLoading = true;
        $scope.openingLoading = true;
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.isLoading = false;
            $scope.updateList();
          },
          function(err){
            $scope.contentLoading = false;
            $scope.openingLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.updateList();
      }
    }

    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.searchText = "";
      $scope.curContent = "";
      $scope.getApprovedFx();
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.curFrame.content = [];
        $scope.curFrame.content.push($scope.curContent);
        ngDialog.close($scope.ngDialogId, "coev1");
      }
    }

    $scope.removeContentFx = function(index){
      $scope.curFrame.content.splice(($scope.curFrame.content.length - 1) - index, 1);
    }

    $scope.updateCurrentPage = function(fx){
      $scope.currentPage += fx;
    }

    $scope.showCalendarFx = function(fx){
      $scope.currentPage += fx;
      $scope.generateCalendar($scope.preview.calendar[$scope.currentPage].label.split("|")[1], $scope.preview.calendar[$scope.currentPage].label.split("|")[0]);
    }

    $scope.generateCalendar = function(year, month){
      $scope.curMonth = month;
      $scope.startWeek = moment(new Date(year, month, 1)).startOf('month').week();
      $scope.endWeek = moment(new Date(year, month, 1)).endOf('month').week();
      if($scope.endWeek == 1){
        $scope.endWeek = 53;
      }

      $scope.curCalendar = [];
      for(var week = $scope.startWeek; week<=$scope.endWeek; week++){
        $scope.dateArr = [];
        for(var i=0; i<7; i++){
          $scope.dateArr.push(moment().week(week).startOf('week').clone().add(i, 'day'));
        }
        $scope.curCalendar.push({
          week:week,
          days:$scope.dateArr
        })
      }
    }

    $scope.meetingPrint = function(type){
      $scope.printSProcessing = false;
      $scope.printSCProcessing = false;
      COESrv.getMeetingCalendar($scope.coev.info.id, type).then(
        function(data){
          $scope.currentPage = 0;
          $scope.preview = data;
          if($scope.preview.frames){
            $scope.curZ = $scope.preview.frames.length + 1;
            $scope.frameId = $scope.preview.frames.length;
          } else{
            $scope.preview.frames = [];
            $scope.frameId = 0;
            $scope.curZ = 0;
          }
          if($scope.preview.frames.length == 0){
            $scope.preview.frames.push({id:0, type:"table", label:"Calendar", z:0, isNew:1});
            $scope.tableZ = 0;
          } else{
            angular.forEach($scope.preview.frames, function(item){
              if(item.type == 'table'){
                $scope.tableZ = item.z;
              }
            });
          }
          if($scope.preview.type == "m"){
            $scope.generateCalendar($scope.preview.calendar[0].label.split("|")[1], $scope.preview.calendar[0].label.split("|")[0]);
          }
          ngDialog.open({
            template:'app/contentLibrary/widgets/popup/coevPreview.html',
            width:'90%',
            scope:$scope,
            closeByEscape:false,
            appendClassName:"ng-dialog-padT50 noPadB",
            closeByDocument:false
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeProcessing = false;

    $scope.meetingFx = function(tab, caller){
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.selectedT == 1 && (tab == 1 || tab == 2 || tab == 3) || caller == "save"){
        if($scope.coev.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.coev.info.fid = $scope.fid;
          $scope.coev.info.toast = false;

          if(tab == 1 || tab == 2 || tab == 3){
            $scope.nextProcessing = true;
          } else{
            $scope.coev.info.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveMeetingFx(tab);
            }, 250);
          } else{
            $scope.saveMeetingFx(tab);
          }
        }
      } else{
        if(tab == 1){
          $timeout(function(){
            $scope.tabFx(2, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else if(tab == 2){
          $timeout(function(){
            $scope.tabFx(3, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else if(tab == 3){
          $timeout(function(){
            $scope.tabFx(4, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $timeout(function(){
            $scope.tabFx(5, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        }
      }
    }

    $scope.saveMeetingFx = function(tab, caller){
      $scope.coev.info.fid = $scope.fid;
      $scope.coev.info.tzOffset = $scope.curTimezone;
      $log.log(tab);
      $log.info(caller);
      COESrv.saveView($scope.coev).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.coev.info.id = data.id;
          }
          if(tab == 1 || tab == 2 || tab == 3){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 3){
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else{
            $state.go("hub.contentLibrary.c");
          }
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.cancelFx = function(){
      $state.go("hub.contentLibrary.c");
    }

    $scope.savePrintFx = function(caller){
      if(caller == "s"){
        $scope.printSProcessing = true;
      } else{
        $scope.printSCProcessing = true;
      }
      COESrv.savePrint({info:{id:$scope.coev.info.id, type:$scope.coev.info.viewType}, frames:$scope.preview.frames}).then(
        function(data){
          if(caller == "s"){
            $scope.printSProcessing = false;
          } else{
            $scope.printSCProcessing = false;
            ngDialog.close($scope.ngDialogId, "coev");
          }
        },
        function(err){
          $log.error(err);
          $scope.printSProcessing = false;
          $scope.printSCProcessing = false;
        }
      );
    }

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';
    $scope.loadingPaging = {}
    $scope.loadingMore = {}
    $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    // TODO get Scroll data for the event and room list tab
    $scope.getScrollListData = function(obj){
      if(obj.quadId == "ev"){
        $scope.detailPopupLoading = true;
      } else{
        $scope.detailLoading = true;
      }
      $scope.detailListObj[obj.quadId] = {};
      $scope.scrollDataList[obj.quadId] = [];
      $scope.allScrollDataList[obj.quadId] = [];
      $scope.copyScrollObj[obj.quadId] = {};
      $scope.visibleObjects[obj.quadId] = [];
      $scope.haveMoreData[obj.quadId] = false;
      $scope.haveMoreSearchData[obj.quadId] = false;
      $scope.visibleData[obj.quadId] = [];
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.searchScroll[obj.quadId] = false;
      $scope.loadingMore[obj.quadId] = false;
      $scope.loadingPaging[obj.quadId] = true;

      $scope.detailListObj[obj.quadId] = {subCaller: obj.subCaller, caller: obj.caller, offset: obj.offset, id: obj.id, subCallerId: obj.subCallerId, quadId:obj.quadId};
      
      DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData[obj.quadId] = true;
          } else{
            $scope.haveMoreData[obj.quadId] = false;
          }

          if(obj.quadId == "ev"){
            var tempListUpdate = {
              d: data.d,
              dg: data.dg,
              r: data.r
            };
            if($scope.roomViewObj.caller == 'n'){
              if($scope.roomViewObjCopy.caller == 'u'){
                $scope.selectedRoom.n = {d:[], dg:[], r:[]}
              } else{
                angular.forEach(tempListUpdate, function (list, key) {
                  if(list.length){
                    list = $scope.updateArr(list, $scope.selectedRoom.n[key]);
                  }
                });
              }
            }
            if($scope.roomViewObj.caller == 'u'){
              if(($scope.selectedRoom.u.d.length + $scope.selectedRoom.u.dg.length +$scope.selectedRoom.u.r.length) > 0 && $scope.roomViewObjCopy.caller == $scope.roomViewObj.caller && $scope.roomViewObjCopy.id == $scope.roomViewObj.id){
                $scope.addEvent.room = angular.copy($scope.selectedRoom.u);
              } else{
                $scope.selectedRoom.u = angular.copy(data.srl);
                $scope.addEvent.room = angular.copy($scope.selectedRoom.u);
              }
              angular.forEach(tempListUpdate, function (list, key) {
                if(list.length){
                  list = $scope.updateArr(list, $scope.selectedRoom.u[key]);
                }
              });
            }
            if($scope.roomViewObj.caller == 'v'){
              angular.forEach(tempListUpdate, function (list, key) {
              if(list.length){
                angular.forEach(list, function (dObj) {
                    dObj.selected = true;
                });
              }
              });
            }
            $scope.selectedRoomCopy = angular.copy($scope.selectedRoom);
            
            $scope.dgList = {d:[], g:[], r:[]};
            $scope.dgList.g = angular.copy(data.dg);
            $scope.dgList.r = angular.copy(data.r);
          }
          if(obj.quadId == "rl"){
            $scope.curRoomList = data.r;
            angular.forEach($scope.curRoomList, function(item){
              item.type = "r"
            })
          }

          $scope.scrollDataList[obj.quadId] = data.d;
          $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.detailLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
        },
        function(err){
          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.detailLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
          $log.error(err);
        }
      );
    }

    // TODO room list popup
    $scope.roomViewObjCopy = {caller: "", id: undefined}
    $scope.roomListView = function(caller, id){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.roomViewObj = {caller: caller, id: id}
      if(caller && caller == "v"){
        var obj = {subCaller: "wCoEEvView", caller: "availD", offset: 0, id: $scope.coev.info.wid, subCallerId: id, quadId:"ev"};
      } else{
        if(id){
          var obj = {subCaller: "wCoEEv", caller: "availD", offset: 0, id: $scope.coev.info.wid, subCallerId: id, quadId:"ev"};
        } else{
          var obj = {subCaller: "wCoEEv", caller: "availD", offset: 0, id: $scope.coev.info.wid, subCallerId: 0, quadId:"ev"};
        }
      }
      $scope.getScrollListData(obj);
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/roomList.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          if(caller == 'c' || caller == '$closeButton'){
            $scope.selectedRoom = $scope.selectedRoomCopy;
          } else{
            $scope.roomViewObjCopy = angular.copy($scope.roomViewObj);
          }
        }
      });
    }

    $scope.selectRoomListFx = function(caller){
      ngDialog.close();
    }

    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.loadingMore[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: $scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        if($scope.searchScroll[obj.quadId]){
          $scope.detailListObj[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else if(data.d.length && data.d.length < 1000){
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.allScrollDataList[obj.quadId] = [];
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = 0;
        $scope.etIndex[obj.quadId] = 300;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.scrollDataList[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if(obj.text){          
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        }
  
        if(obj.text){
          $scope.searchScroll[obj.quadId] = true;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length && data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
  
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          $scope.haveMoreSearchData[obj.quadId] = false;
          $scope.searchScroll[obj.quadId] = false;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else{
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
              
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataList[obj.quadId] = [];
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
  
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = obj.st;
        $scope.etIndex[obj.quadId] = obj.et;
        $scope.visibleData[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
        setTimeout(function() {
          $scope.$apply();
        });
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      if($scope.selectedT == '2' || ($scope.selectedT == '4' && $scope.subTabRL == 1)){
        var text = val.toLowerCase();
        var scrollElement = document.querySelector("#scroll-container-"+quadId);
        if (!text && $scope.searchScroll[quadId]) {
          // TODO Enter when have newVal is empty and user perform search operation already
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else if (text && text.length >= 3) {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreData[quadId]) {
            // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
            // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
            var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj , function (item) {
              if(keys.indexOf(item.h) === -1){
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if(filteredObj.length && filteredObj.length >= 1000){
              $scope.haveMoreSearchData[quadId] = true;
            } else{
              $scope.haveMoreSearchData[quadId] = false;
            }

            if(quadId == "ev"){
              if($scope.roomViewObj.caller == "v"){
                if(filteredObj.length){angular.forEach(filteredObj, function(item){item.selected = true;})}
              }
              if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){filteredObj = $scope.updateArr(filteredObj, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
              }
            }
                        
            $scope.scrollDataList[quadId] = filteredObj;
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            if ($scope.scrollDataList[quadId].length <= 300) {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
            } else {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
            }
            $scope.searchScroll[quadId] = true;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          } else {
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          }
        }
      }
    }
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('COEController', COEController);

  /** @ngInject */
  function COEController($log, $rootScope, $scope, $sce, $state, $filter, $cookies, $timeout, ngDialog, DevicesSrv, ContentLibrarySrv, FileModelUploadSrv, CommonSrv, COESrv){
    $scope.colorPicker = {rb:false, rs:false, rt:false, rst:false, rtm:false, wb:false, ws:false, whb:false, wht:false, wt:false, wat:false, wtm:false, watm:false, wr:false, war:false, wrb:false, warb:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    $scope.weekdays = [0, 1, 2, 3, 4, 5, 6];
    $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.curDeviceObj = {availableDevices:[], devices:[], caller:"coe"};
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = true;
    $scope.coe = {info:{}};
    $scope.isPEOpen = false;
    $scope.eventList = [];
    $scope.currentPage = 0;
    $scope.addEvent = {};
    $scope.viewList = [];
    $scope.curLogo = {};
    $scope.ssList = [];
    $scope.encId = "";
    $scope.decId = 0;
    $scope.dgList = {d:[], g:[], r:[]};
    $scope.search = {text:""};
    // Todo to load data veriable and hold tab/button
    $scope.reponseLoad = false;

    $scope.settings = {
      rb:{/*Roomboard*/
        bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, logoOpt:true, titleText:"#000000", titleFont:$scope.fontFamilySelected, titleSize:72, subtitleText:"#999999", subtitleFont:$scope.fontFamilySelected, subtitleSize:36, timeText:"#444444", timeFont:$scope.fontFamily[0], timeSize:48, sos:{sType:"p", prior:30, eType:"a", after:30}, feed:{url:"", logo:"", ss:""}
      },
      wb:{/*Wallboard*/
        bg:"#ffffff", bga:1, ssbg:"#000000", ssbga:1, isTime:true, isRoom:true, logoOpt:true, rotationOpt:"a", rotate:12,
        header:{active:true, column1:"Event title", col1TxtAlign:"left", column2:"Time", col2TxtAlign:"center", column3:"Room ", col3TxtAlign:"center"},
        headerBg:"#f3f3f3", headerBga:1, headerText:"#073763", headerFont:$scope.fontFamilySelected, headerSize:26, titleText:"#000000", titleSize:28, timeText:"#444444", timeSize:28, altTitleText:"#000000", altTimeText:"#444444", roomText:"#666666", roomSize:28, altRoomText:"#000000", titleFont:$scope.fontFamilySelected, timeFont:$scope.fontFamily[0], roomFont:$scope.fontFamilySelected, rowBg:"#ffffff", rowBga:1, altBg:"#f3f3f3", altBga:1, titleTxtAlign:"left", timeTxtAlign:"center", roomTxtAlign:"center", sos:{sType:"s", prior:30, eType:"a", after:30}, feed:{url:"", logo:"", ss:""}
      }
    };
    $scope.ctype = {
      rb:{bg:"monochrome", ssbg:"monochrome", titleText:"monochrome", subtitleText:"monochrome", timeText:"monochrome"},
      wb:{bg:"monochrome", ssbg:"monochrome", headerBg:"monochrome", headerText:"default", titleText:"monochrome", timeText:"monochrome", roomText:"monochrome", altTitleText:"monochrome", altTimeText:"monochrome", altRoomText:"monochrome", rowBg:"monochrome", altBg:"monochrome"}
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings), ctype:angular.copy($scope.ctype)};

    $scope.settingsView = {
      d:{headerBg:"#f3f3f3", headerBga:1, headerText:"#444444", rowBg:"#f3f3f3", rowBga:1, eventText:"#000000", roomText:"#999999", timeBg:"#cfe2f3", timeBga:1, timeText:"#444444"},/*Day*/
      wm:{headerBg:"#f3f3f3", headerBga:1, headerText:"#444444", dayNameBg:"#cfe2f3", dayNameBga:1, dayNameText:"#073763", cellBg:"#ffffff", cellBga:1, eventText:"#000000", roomText:"#999999", timeText:"#444444"}/*Week / moanth*/
    };
    $scope.ctypeView = {
      d:{hBg:"monochrome", hText:"monochrome", rowBg:"monochrome", eText:"monochrome", rText:"monochrome", tBg:"default", tText:"monochrome"},/*Day*/
      wm:{hBg:"monochrome", hText:"monochrome", dnBg:"default", dnText:"default", cBg:"monochrome", eText:"monochrome", rText:"monochrome", tText:"monochrome"}/*Week | moanth*/
    };

    $scope.settingsDefault = function(){
      $scope.coe.info.settings = angular.copy($scope.defaultSettings.settings);
      $scope.coe.info.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    $scope.celEventBack = angular.fromJson(localStorage.getItem("celEventBack"));

    //! No need to call the API here start
    // CommonSrv.getAvailableDevice().then(
    //   function(data){
    //     $scope.deviceList = data;
    //   },
    //   function(err){
    //     $log.error(err);
    //   }
    // );
    //! No need to call the API here end

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.id = $scope.decId;
      $scope.detailLoading = true;
      COESrv.getCE($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.coe.info = data.info;

          $scope.tim = $scope.coe.info.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.coe.info.bucket;
          if($scope.coe.info.mbucket && $scope.coe.info.mbucket != ""){
            $scope.cDetailBucket = $scope.coe.info.mbucket;
          }
          if(!$scope.coe.info.settings.rb.sos){
            $scope.coe.info.settings.rb.sos = {sType:"p", prior:30, eType:"a", after:30};
          }
          if(!$scope.coe.info.settings.wb.sos){
            $scope.coe.info.settings.wb.sos = {sType:"s", prior:30, eType:"e", after:30};
          }

          if(!$scope.coe.info.settings.wb.rotationOpt){
            $scope.coe.info.settings.wb.rotationOpt = "a";
            $scope.coe.info.settings.wb.rotate = 12;
            $scope.coe.info.settings.wb.logoOpt = true;
            $scope.coe.info.settings.rb.logoOpt = true;
          }
          if(!$scope.coe.info.settings.wb.headerSize){
            $scope.coe.info.settings.wb.headerSize = 26;
            $scope.coe.info.settings.wb.titleSize = 28;
            $scope.coe.info.settings.wb.timeSize = 28;
            $scope.coe.info.settings.wb.roomSize = 28
          }
          if(!$scope.coe.info.settings.wb.header.col1TxtAlign){
            $scope.coe.info.settings.wb.header.col1TxtAlign = "left";
          }
          if(!$scope.coe.info.settings.wb.header.col2TxtAlign){
            $scope.coe.info.settings.wb.header.col2TxtAlign = "center";
          }
          if(!$scope.coe.info.settings.wb.header.col3TxtAlign){
            $scope.coe.info.settings.wb.header.col3TxtAlign = "center";
          }

          if(!$scope.coe.info.settings.wb.titleTxtAlign){
            $scope.coe.info.settings.wb.titleTxtAlign = "left";
          }
          if(!$scope.coe.info.settings.wb.timeTxtAlign){
            $scope.coe.info.settings.wb.timeTxtAlign = "center";
          }
          if(!$scope.coe.info.settings.wb.roomTxtAlign){
            $scope.coe.info.settings.wb.roomTxtAlign = "center";
          }

          if($scope.celEventBack && $scope.celEventBack.back){
            $rootScope.selectedT = 2;
            localStorage.setItem("curFId", $scope.celEventBack.curFId);
            $scope.subTabFx(1);
            localStorage.removeItem("celEventBack");
            $scope.celEventBack = null;
          }
          //! No need to do this here start
          // $scope.dgList = angular.copy($scope.coe.info.roomList);
          // angular.forEach($scope.dgList.d, function(d){
          //   if(!d.type){d.type = "d"};
          // });
          // angular.forEach($scope.dgList.r, function(r){
          //   if(!r.type){r.type = "r"};
          // });
          // $scope.dgrListCopy = angular.copy($scope.dgList);
          // $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);

          // if(!$scope.curRoomList.length){
          //   $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
          // } else if($scope.editRForm.isEdit){
          //   $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
          // };
          //! No need to do this here ends
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      localStorage.removeItem("celEventBack");
      $scope.detailLoading = false;
      $scope.celEventBack = null;
      $rootScope.tabView = true;

      $scope.coe.info = {
        label:"",
        roomList:{d:[], r:[]},
        activePeriod:{type:"a"},
        ctype:angular.copy($scope.ctype),
        settings:angular.copy($scope.settings),
        permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.resetFx = function(caller){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.errType = "";
      $scope.hasListErr = false;
      if(caller == "m"){
        // TODO: new code
        $scope.selectedRoom.n = {d:[], dg:[], r:[]};
        $scope.curLogo.img = {};
        $scope.addEvent = angular.copy($scope.defaultEvent);
        $scope.dgList = angular.copy($scope.dgrListCopy);
      } else if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.n = [];
        $scope.addScreen = {sId:null, label:"", ss:"", d:[]};
        $scope.curDeviceObj = {availableDevices:angular.copy($scope.deviceList), devices:[], caller:"coe"};
      } else if(caller == "r"){
        // TODO: new code update the keys name
        $scope.roomCU = {l:"", fl:"", dt:"rb", type:"r"};
      }
    }

    $scope.subTab = 1;
    $scope.subTabFx = function(caller){
      $scope.subTab = caller;
      $scope.subLoading = true;
      if(caller == "1"){
        COESrv.getActiveList($scope.coe.info.id).then(
          function(data){
            $scope.subLoading = false;
            $scope.eventList = data.meeting;
            $scope.eventListInfo = data.info;

            angular.forEach($scope.eventList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });

            if(!$scope.eventList.length){
              $scope.editMForm = {isShow:true, isAdd:true, isEdit:false};
            } else if($scope.editMForm.isEdit){
              $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
            };
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      } else{
        COESrv.getExpireList($scope.coe.info.id).then(
          function(data){
            $scope.subLoading = false;
            $scope.eventList = data.meeting;
            $scope.eventListInfo = data.info;
            angular.forEach($scope.eventList, function(m){
              m.startTime = $filter("momentTime")(m.startTime);
              m.endTime = $filter("momentTime")(m.endTime);
            });
            if($scope.editMForm.isEdit){
              $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
            };
          },
          function(err){
            $log.error(err);
            $scope.subLoading = false;
          }
        );
      }
    }
    $scope.getSSFx = function(caller){
      COESrv.getSSList($scope.coe.info.id).then(
        function(data){
          $scope.detailLoading = false;
          $scope.ssList = data.screenSaver;
          if(!$scope.ssList.length){
            $scope.editSForm = {isShow:true, isAdd:true, isEdit:false};
          } else if(caller !== "ss"){
            $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }
    $rootScope.selectedTabFx = function(caller){
      $scope.editMForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editSForm = {isShow:false, isAdd:false, isEdit:false};
      $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
      if($scope.selectedT == "1"){
        //! No need to call this API here start
        // if($scope.decId == 0){
          // $scope.detailLoading = true;
          // COESrv.getCE($scope.decId).then(
          //   function(data){
          //     $scope.detailLoading = false;
          //     $scope.dgList = angular.copy(data.roomList);
          //     angular.forEach($scope.dgList.d, function(d){
          //       if(!d.type){d.type = "d"};
          //     });
          //     angular.forEach($scope.dgList.r, function(r){
          //       if(!r.type){r.type = "r"};
          //     });
          //     $scope.dgrListCopy = angular.copy($scope.dgList);
          //     $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
          //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
          //   },
          //   function(err){
          //     $log.error(err);
          //     $scope.detailLoading = false;
          //   }
          // );
          // }
          //! No need to call this API here ends
      } else if($scope.selectedT == "2"){
        if(caller == "sort"){
          $scope.subTabFx($scope.subTab);
        } else{
          $scope.subTabFx(1);
        }
        $scope.resetFx('m');
      }
      else if($scope.selectedT == "3"){
        $scope.detailLoading = true;
        $scope.getSSFx();
        $scope.resetFx('s');
      }
      else if($scope.selectedT == "4"){
        // TODO: new code
        var obj = {subCaller: "wCoERL", caller: "availD", offset: 0, id: $scope.coe.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
        //! No need to call this API here start
        // $scope.detailLoading = true;
        // $scope.roomCU = {room:"", floor:"", dType:"rb", type:"r"};
        // COESrv.getCE($scope.decId).then(
        //   function(data){
        //     $scope.detailLoading = false;
        //     $scope.dgList = angular.copy(data.info.roomList);
        //     angular.forEach($scope.dgList.d, function(d){
        //       if(!d.type){d.type = "d"};
        //     });
        //     angular.forEach($scope.dgList.r, function(r){
        //       if(!r.type){r.type = "r"};
        //     });
        //     $scope.dgrListCopy = angular.copy($scope.dgList);
        //     $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
        //     $scope.curDeviceObj.availableDevices = $scope.dgList.d;
        //     if(!$scope.curRoomList.length){
        //       $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
        //     } else if($scope.editRForm.isEdit){
        //       $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
        //     };
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.detailLoading = false;
        //   }
        // );
        //! No need to call this API here ends
      }
      else if($scope.selectedT == "5"){
        $scope.detailLoading = true;
        COESrv.getViewList($scope.coe.info.id).then(
          function(data){
            $scope.detailLoading = false;
            $scope.viewList = data;
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
      else if($scope.selectedT == "6"){
        $scope.detailLoading = false;
      }
    }
    $rootScope.selectedTabFx();

    $scope.printDiv = function(divName, pageTitle){
      var printContents = document.getElementById(divName).innerHTML;
      var popupWin = window.open('', '_blank', 'width=600,height=800');
      popupWin.document.open();
      popupWin.document.write('<html><head><title>' + pageTitle + '</title><style type="text/css">html{height:100%;}body{padding:0;margin:0;font-family:\'Open Sans\',sans-serif;font-size:9px;font-weight:400;}.text-big{font-size:20px;margin:10px;}.text-center{text-align:center;}table{margin-bottom:0;border:1px solid #ddd;width:100%;max-width:100%;border-collapse:collapse;border-spacing:0;}th,td{padding:8px;vertical-align:top;border:1px solid #ddd;}.text-muted{color:#808080;}.marB5{margin-bottom:5px;}th,.text-bold{font-weight:600;}.text-sm{font-size:80%;}.bdr-btm-dashed{border-bottom:1px dashed #c7c7c7;padding-bottom:5px;margin-bottom:10px;}</style></head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
    }

    $scope.showCalendarFx = function(fx){
      $scope.currentPage += fx;
      $scope.generateCalendar($scope.preview.calendar[$scope.currentPage].label.split("|")[1], $scope.preview.calendar[$scope.currentPage].label.split("|")[0]);
    }

    $scope.setVisibility = function(item){
      $scope.itemObj = item;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.coe.7" | translate}}</h1></header>\
            <div class="panel-body">\
              <div><label><input type="checkbox" ng-model="itemObj.visible.rb" role="checkbox"><label></label>{{"cl.widget.coe.7.1" | translate}}</label></div>\
              <div><label><input type="checkbox" ng-model="itemObj.visible.wb" role="checkbox"><label></label>{{"cl.widget.coe.7.2" | translate}}</label></div>\
              <div><label><input type="checkbox" ng-model="itemObj.visible.cl" role="checkbox"><label></label>{{"cl.widget.coe.7.3" | translate}}</label></div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="saveEventVisibility();" ng-disabled="settingVisibility"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }

    $scope.saveEventVisibility = function(){
      $scope.settingVisibility = true;
      COESrv.saveEventVisibility({id:$scope.itemObj.mId, visible:$scope.itemObj.visible}).then(
        function(data){
          $scope.settingVisibility = false;
          ngDialog.close();
        },
        function(err){
          $log.error(err);
          $scope.settingVisibility = false;
        }
      );
    }

    $scope.generateCalendar = function(year, month){
      $scope.curMonth = month;
      $scope.startWeek = moment(new Date(year, month, 1)).startOf('month').week();
      $scope.endWeek = moment(new Date(year, month, 1)).endOf('month').week();
      if($scope.endWeek == 1){
        $scope.endWeek = 53;
      }

      $scope.curCalendar = [];
      for(var week = $scope.startWeek; week<=$scope.endWeek; week++){
        $scope.dateArr = [];
        for(var i=0; i<7; i++){
          $scope.dateArr.push(moment().week(week).startOf('week').clone().add(i, 'day'));
        }
        $scope.curCalendar.push({
          week:week,
          days:$scope.dateArr
        });
      }
    }

    $scope.createView = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.viewProcessing = false;
      $scope.viewObj = {info:{label:"", type:"", wid:$scope.coe.info.id, toast:true, activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}}};
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/createView.html',
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.createViewFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.viewObj.info.label == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "name";
      }
      else if($scope.viewObj.info.type == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "type";
      }
      else{
        $scope.viewProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        $timeout(function(){
          if($scope.viewObj.info.type == "d"){
            $scope.viewObj.info.settings = angular.copy($scope.settingsView.d);
            $scope.viewObj.info.ctype = angular.copy($scope.ctypeView.d);
          } else{
            $scope.viewObj.info.settings = angular.copy($scope.settingsView.wm);
            $scope.viewObj.info.ctype = angular.copy($scope.ctypeView.wm);
          }
          COESrv.saveView($scope.viewObj).then(
            function(data){
              $scope.viewProcessing = false;
              ngDialog.close();
            },
            function(err){
              $log.error(err);
            }
          );
        }, 250);
      }
    }

    /*Logo*/
    $scope.logoPopover = {templateUrl:"logo.html"};
    $scope.screenPopover = {templateUrl:"screen.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curVideos = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Flash")){
          $scope.curImages.push(item);
        }
        if($scope.selectedT == "3" && (item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video" || item.splType == "Video" || item.splType == "POWERPOINT" || item.splType == "WORD")){
          $scope.curVideos.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curVideos);
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.search = {text:""};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "2"){
          $scope.addEvent.logo = $scope.curContent;
        } else if($scope.selectedT == "3"){
          $scope.addScreen.ss = $scope.curContent;
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "l"){
        $scope.addEvent.logo = null;
      } else if(caller == "i"){
        $scope.addScreen.ss = null;
      }
    }

    //Add Event
    $scope.custTime = moment().set('minute', '00').utc().format();
    $scope.defaultEvent = {
      roomOpt:"d",
      room:"",
      title:"",
      endTime:$scope.custTime,
      startTime:$scope.custTime,
      visible:{rb:true,wb:true,cl:true},
      date:{startDate:moment()._d, endDate:moment()._d},
      // TODO: new code
      rc:0
    };

    $scope.addEvent = angular.copy($scope.defaultEvent);

    $scope.addEventFx = function(caller){
      $scope.errType = "";
      $scope.curEvent = {};
      $scope.hasListErr = false;
      if($scope.id){
        $scope.coe.info.id = $scope.id;
      }
      $scope.copyAddEvent = angular.copy($scope.addEvent);
      $scope.copyAddEvent.dateShow = {startDate:$scope.copyAddEvent.date.startDate, endDate:$scope.copyAddEvent.date.endDate};
      $scope.copyAddEvent.date = {startDate:moment($scope.copyAddEvent.date.startDate).format("L"), endDate:moment($scope.copyAddEvent.date.endDate).format("L")};

      $scope.copyAddEvent.startTime = moment($scope.copyAddEvent.startTime).format();
      $scope.copyAddEvent.endTime = moment($scope.copyAddEvent.endTime).format();

      // ! no need to this code
      // if($scope.copyAddEvent.roomOpt == "d"){
      //   $scope.copyAddEvent.room = {d:$filter("filter")($scope.dgList.d, {selected:true}), g:$filter("filter")($scope.dgList.g, {selected:true}), r:$filter("filter")($scope.dgList.r, {selected:true})};
      // }

      if($scope.copyAddEvent.title == ""){
        $scope.errType = "title";
        $scope.hasListErr = true;
        $("#title").focus();
      // TODO: change the keys
      } else if($scope.copyAddEvent.roomOpt == "d" && $scope.copyAddEvent.rc == 0 || $scope.copyAddEvent.roomOpt == "c" && ($scope.copyAddEvent.roomLabel == null || $scope.copyAddEvent.roomLabel == "")){
        $scope.errType = "room";
        $scope.hasListErr = true;
        $("#roomLabel").focus();
      } else if($scope.copyAddEvent.startTime == null){
        $scope.errType = "start";
        $scope.hasListErr = true;
        $("#start").focus();
      } else if($scope.copyAddEvent.endTime == null){
        $scope.errType = "end";
        $scope.hasListErr = true;
        $("#end").focus();
      } else if($scope.copyAddEvent.startTime >= $scope.copyAddEvent.endTime){
        $scope.errType = "startEnd";
        $scope.hasListErr = true;
        $("#end").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }

        $scope.copyAddEvent.startTime = $scope.copyAddEvent.startTime.split("T")[1].split("+")[0].split("-")[0];
        $scope.copyAddEvent.endTime = $scope.copyAddEvent.endTime.split("T")[1].split("+")[0].split("-")[0];
        $scope.curEvent = {info:{id:$scope.coe.info.id}, meeting:$scope.copyAddEvent};
        if($scope.curEvent.meeting.roomOpt == "c"){
          $scope.curEvent.meeting.room = "";
        } else if($scope.curEvent.meeting.roomOpt == "d"){
          $scope.curEvent.meeting.roomLabel = "";
          $scope.curEvent.meeting.roomFloor = "";
        }
        COESrv.addEvent($scope.curEvent).then(
          function(data){
            $scope.id = data.id;
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
            if(data.timthumb){
              $scope.tim = data.timthumb;
            }
            if(caller == "s"){
              $scope.editMForm.isShow = false;
            } else{
              $scope.editMForm.isShow = true;
            }
            // TODO: new code
            $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}
            $scope.subTabFx($scope.subTab);
            $scope.resetFx('m');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.removeProcessing = false;
    $scope.deleteOpen = function(caller, iId){
      $scope.deleteObj = {caller:caller, iId:iId};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" ng-disabled="removeProcessing"><span class="fa fa-repeat fa-spin" ng-if="removeProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteFx = function(){
      $scope.removeProcessing = true;
      COESrv.delete($scope.coe.info.id, $scope.deleteObj.caller, $scope.deleteObj.iId).then(
        function(data){
          if($scope.deleteObj.caller == "m"){
            angular.forEach($scope.eventList, function(list, index){
              if($scope.deleteObj.iId == list.mId){
                $scope.eventList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
            if($scope.eventList == 0 && $scope.subTab == 1){
              $scope.editMForm = {isShow:true, isAdd:true, isEdit:false};
            }
          } else if($scope.deleteObj.caller == "s"){
            angular.forEach($scope.ssList, function(list, index){
              if($scope.deleteObj.iId == list.sId){
                $scope.ssList.splice(index, 1);
                $scope.removeProcessing = false;
                $scope.resetFx($scope.deleteObj.caller);
                ngDialog.close();
              }
            });
          } else if($scope.deleteObj.caller == "r"){
            if(data.code == 8227){
              $scope.removeProcessing = false;
              ngDialog.close();
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"cl.widget.meeting.m8" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            } else if(data.code == 8226){
              angular.forEach($scope.curRoomList, function(list, index){
                if($scope.deleteObj.iId == list.id){
                  $scope.curRoomList.splice(index, 1);
                  $scope.removeProcessing = false;
                  $scope.resetFx($scope.deleteObj.caller);
                  ngDialog.close();
                  if(!$scope.curRoomList.length){
                    $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
                  } else if($scope.editRForm.isEdit){
                    $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
                  }
                }
              });
              // angular.forEach($scope.dgList.r, function(list, index){
              //   if($scope.deleteObj.iId == list.id){
              //     $scope.dgList.r.splice(index, 1);
              //     $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
              //     $scope.dgrListCopy = angular.copy($scope.dgList);
              //     $scope.removeProcessing = false;
              //     $scope.resetFx($scope.deleteObj.caller);
              //     ngDialog.close();
              //     if(!$scope.curRoomList.length){
              //       $scope.editRForm = {isShow:true, isAdd:true, isEdit:false};
              //     } else if($scope.editRForm.isEdit){
              //       $scope.editRForm = {isShow:false, isAdd:false, isEdit:false};
              //     }
              //   }
              // });
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editFx = function(caller, data){
      if($scope.curDeviceObj.devices){
        $scope.curDeviceObj.devices = [];
      }
      $('.widgetForm').scrollTop(0);
      $scope.searchList = {d:"", g:"", r:""};
      if(caller == "m"){
        // TODO: new code
        $scope.selectedRoom.u = {d:[], dg:[], r:[]};
        $scope.editMForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addEvent = angular.copy(data);
        $scope.addEvent.startTime = $scope.addEvent.startTime;
        $scope.addEvent.endTime = $scope.addEvent.endTime;
      } else if(caller == "s"){
        // TODO: new code
        $scope.selectedDeviceSS.u = [];
        $scope.editSForm = {isShow:true, isAdd:false, isEdit:true};
        $scope.addScreen = angular.copy(data);
      } else if(caller == "r"){
        $scope.editRForm = {isShow:true, isAdd:false, isEdit:true};
        if(!data.type){
          data.type = "d";
        }
        $scope.roomCU = angular.copy(data);
      }
    }

    /*Screensaver*/
    $scope.manipulateFx = function(caller, availableList, assignedList, curModel, type){
      // var curModel = [];
      // angular.forEach(curModels, function(item){
      //   curModel.push(angular.fromJson(item));
      // });
      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      }
      else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
      }
      // $rootScope.dAList = [];
      // $rootScope.dSList = [];
    }

    
    // TODO: new code
    $scope.deviceViewObjCopy = {data:{}, caller:""};
    $scope.selectedDeviceSS = {n:[], u:[], v:[]};
    $scope.devicesView = function(caller, data){
      //! No need to do here start
      // if($scope.curDeviceObj.devices){
      //   $scope.curDeviceObj.devices = [];
      // }
      // $scope.curDeviceObj.availableDevices = angular.copy($scope.dgList.d);
      // $scope.deSelAllDeviceFx('a', $scope.curDeviceObj.availableDevices);
      // $scope.deSelAllDeviceFx('s', data.d);
      // $scope.deviceViewObj = {data:data, caller:caller};
      // $scope.popupErr = false;
      // if(data.sId){
      //   for(var i=0; i<$scope.ssList.length; i++){
      //     if($scope.ssList[i].sId == data.sId){
      //       for(var j=0; j<$scope.curDeviceObj.availableDevices.length; j++){
      //         for(var k=0; k<$scope.ssList[i].d.length; k++){
      //           if($scope.ssList[i].d[k].id === $scope.curDeviceObj.availableDevices[j].id){
      //             $scope.curDeviceObj.devices.push($scope.curDeviceObj.availableDevices[j]);
      //           }
      //         }
      //       }
      //     }
      //   }
      //   $scope.curAvailableDevices = [];
      //   angular.forEach($scope.dgList.d, function(list){
      //     list.isDuplicate = false;
      //   });
      //   angular.forEach($scope.dgList.d, function(list){
      //     for(var i = 0; i < $scope.curDeviceObj.devices.length; i++){
      //       if(!$scope.isDuplicate && list.id == $scope.curDeviceObj.devices[i].id){
      //         list.isDuplicate = true;
      //       }
      //     }
      //   });
      //   $scope.curAvailableDevices = $scope.dgList.d.filter(function(list){
      //     return !list.isDuplicate;
      //   })
      //   $scope.curDeviceObj.availableDevices = angular.copy($scope.curAvailableDevices);
      // }
      //! No need to here ends

      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/devices.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          // TODO: new code
          $scope.deviceViewObjCopy = angular.copy($scope.deviceViewObj);
        }
      });
      // TODO: new code
      $scope.popupErr = false;
      $scope.deviceViewObj = {data:data, caller:caller};
      $rootScope.devicesLoading = true;
      $scope.dataLoaded = {};
      $scope.scrollObjDyn = {};
      $scope.haveMoreDataDyn = {};
      $scope.scrollDataListDyn = {};
      $scope.allScrollDataListDyn = {};
      $scope.totalDeviceCount = {};
      $scope.selDIds = [];
      $scope.pageTab = "ss"
      $scope.scrollObjDyn.a = {subCaller: "wCoESS", caller: "availD", offset: 0, id: $scope.coe.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.scrollObjDyn.s = {subCaller: "wCoESS", caller: "selD", offset: 0, id: $scope.coe.info.id, sortType: "l", sortVal: "asc", subCallerId: data.sId}
      $scope.getListData("a");
      if(caller != 'n'){
        $scope.getListData("s");
      } else{        
        $scope.haveMoreDataDyn.s = false;
        $scope.totalDeviceCount.s = 0;
        if($scope.deviceViewObjCopy.caller == 'u'){
          $scope.selectedDeviceSS.n = [];
        }
        if($scope.selectedDeviceSS.n.length){
          $scope.scrollDataListDyn.s = $scope.selectedDeviceSS.n;
        } else{
          $scope.scrollDataListDyn.s = data.d;
        }
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      }
    }
    $scope.saveDevicesFx = function(){
      $scope.popupErr = false;
      if(!$scope.curDeviceObj.devices.length){
        $scope.popupErr = true;
      } else{
        // TODO: change the value
        if($scope.deviceViewObj.caller == "v"){
          $scope.editSForm.isShow = false;
          $scope.addScreen = {sId:$scope.deviceViewObj.data.sId, label:$scope.deviceViewObj.data.label, ss:$scope.deviceViewObj.data.ss, d:$scope.curDeviceObj.devices};
          $scope.addScreensaverFx("s");
        } else{
          // TODO: new code
          $scope.selectedDeviceSS[$scope.deviceViewObj.caller] = $scope.screenSaverSelDevice;
          $scope.addScreen.d = $scope.curDeviceObj.devices;
        }
        ngDialog.close();
      }
    }
    $scope.addScreensaverFx = function(caller){
      $scope.hasListErr = false;
      $scope.errType = "";
      if($scope.addScreen.label == ""){
        $scope.errType = "label";
        $scope.hasListErr = true;
        $("#screenName").focus();
      } else if(!$scope.addScreen.ss || $scope.addScreen.ss == ""){
        $scope.errType = "ss";
        $scope.hasListErr = true;
        $("#contentBtn").focus();
      } else if(!$scope.addScreen.d.length){
        $scope.errType = "device";
        $scope.hasListErr = true;
        $("#deviceBtn").focus();
      } else if($scope.addScreen.ss && !$scope.addScreen.ss.duration){
        $scope.errType = "duration";
        $scope.hasListErr = true;
        $("#sDuration").focus();
      } else{
        if(caller == "s"){
          $scope.addProcessing = true;
        } else{
          $scope.addMoreProcessing = true;
        }
        $scope.ssPostObj = {info:{id:$scope.coe.info.id}, screenSaver:$scope.addScreen};
        COESrv.addSS($scope.ssPostObj).then(
          function(data){
            $scope.selectedDeviceSS = {n:[], u:[], v:[]}
            $scope.addMoreProcessing = false;
            $scope.addProcessing = false;
            if(caller == "s"){
              $scope.editSForm.isShow = false;
            } else{
              $scope.editSForm.isShow = true;
            }
            $scope.getSSFx("ss");
            $scope.resetFx('s');
          },
          function(err){
            $log.error(err);
            $scope.addProcessing = false;
            $scope.addMoreProcessing = false;
          }
        );
      }
    }

    $scope.sortCallback = function(){
      $scope.curRow = [];
      $scope.curId = [];
      $(".sortable-item").each(function(index){
        $scope.curId.push($(this).attr("data-id"));
      });
      angular.forEach($scope.ssList, function(item, index){
        angular.forEach($filter('filter')($scope.ssList, {sId:$scope.curId[index]}), function(obj){
          $scope.curRow.push(obj);
        });
      });
      $scope.ssList = [];
      $scope.ssList = $scope.curRow;
      $scope.coe.info.screenSaver = [];
      $scope.coe.info.screenSaver = $scope.ssList;
    }

    /*Rooms*/
    $scope.roomCUOpen = function(caller, id){
      $scope.curRoomCU = $filter("filter")($scope.curRoomList, {id:id}, true);
      $scope.roomCUCopy = angular.copy($scope.curRoomCU[0]);
      $scope.addProcessing = false;
      $scope.hasPopErr = false;
      $scope.errType = "";

      ngDialog.open({
        template:"app/contentLibrary/widgets/popup/meetingRoomCU.html",
        width:600,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller == "$closeButton"){};
        }
      });
      if(caller == "a"){
        $scope.roomCU = {room:"", floor:"", dType:"rb", type:"r"};
      }
      else if(caller == "e"){
        $scope.roomCU = angular.copy($scope.curRoomCU[0]);
      }
    }

    $scope.roomCUFx = function(caller){
      $scope.hasPopErr = false;
      $scope.errType = "";
      $scope.hasListErr = false;
      // TODO: change the key name
      if(!$scope.roomCU.l || $scope.roomCU.l == ""){
        $scope.hasPopErr = true;
        $scope.hasListErr = true;
        $scope.errType = "room";
        $("#room").focus();
      } else{
        $scope.isDuplicateRoom = false;
        angular.forEach($scope.curRoomList, function(r){
          // TODO: change the kay name
          if(angular.lowercase(r.l) == angular.lowercase($scope.roomCU.l) && angular.lowercase(r.fl) == angular.lowercase($scope.roomCU.fl) && r.dt == $scope.roomCU.dt && r.type == $scope.roomCU.type && r.id != $scope.roomCU.id){
            $scope.isDuplicateRoom = true;
            return true;
          }
        });
        if(!$scope.isDuplicateRoom){
          if(caller == "s" || caller == "e"){
            $scope.addProcessing = true;
          } else{
            $scope.addMoreProcessing = true;
          }
          if(caller == "s" || caller == "sm"){
            COESrv.addRoom({id:$scope.coe.info.id, room:$scope.roomCU}).then(
              function(data){
                // ! no need to do this
                // $scope.dgList.r.push({id:data.id, l:$scope.roomCU.l, fl:$scope.roomCU.fl, dt:$scope.roomCU.dt, type:'r'});
                // $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
                // $scope.dgrListCopy = angular.copy($scope.dgList);
                // TODO: new code
                $scope.curRoomList.push({id:data.id, l:$scope.roomCU.l, fl:$scope.roomCU.fl, dt:$scope.roomCU.dt, type:'r'})
                $scope.addMoreProcessing = false;
                $scope.addProcessing = false;
                // TODO: new code
                $scope.subTabRL = 2;
                ngDialog.close();

                if(caller == "s"){
                  $scope.editRForm.isShow = false;
                } else{
                  $scope.editRForm.isShow = true;
                }
                $scope.resetFx("r");
              },
              function(err){
                $log.error(err);
                $scope.addMoreProcessing = false;
                $scope.addProcessing = false;
              }
            );
          } else if(caller == "e"){
            // TODO: added key name
            COESrv.editRoom({id:$scope.coe.info.id, l:$scope.roomCU}).then(
              function(data){
                $scope.addProcessing = false;
                if(data.code == 8224 || data.code == 8225){
                  if($scope.roomCU.type == "d"){
                    angular.forEach($scope.dgList.d, function(d, index){
                      // TODO: short key added
                      if(d.id == $scope.roomCU.id){
                        d.fl = $scope.roomCU.fl;
                        d.dt = $scope.roomCU.dt;
                      }
                    });
                  } else if($scope.roomCU.type == "r"){
                    angular.forEach($scope.dgList.r, function(rl, index){
                      // TODO: short key added
                      if(rl.id == $scope.roomCU.id){
                        rl.l = $scope.roomCU.l;
                        rl.fl = $scope.roomCU.fl;
                        rl.dt = $scope.roomCU.dt;
                      }
                    });
                  }
                  $scope.curRoomList = $scope.dgList.d.concat($scope.dgList.r);
                  $scope.dgrListCopy = angular.copy($scope.dgList);
                  ngDialog.close();
                  $scope.editRForm.isShow = false;
                  $scope.resetFx("r");
                }
              },
              function(err){
                $log.error(err);
                $scope.addProcessing = false;
              }
            );
          }
        } else{
          $scope.hasPopErr = true;
          $scope.hasListErr = true;
          $scope.errType = "roomExists";
        }
      }
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $rootScope.selectedTabFx("sort");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.roomUCFx = function(caller, room, index){
      $scope.roomUProcessing = false;
      $scope.hasPopErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "e"){
        $scope.roomCopy = angular.copy(room);
      } else if(caller == "u"){
        $scope.isDuplicateRoom = false;
        angular.forEach($scope.curRoomList, function(r){
          // TODO: change the key name
          if(angular.lowercase(r.l) == angular.lowercase(room.l) && angular.lowercase(r.fl) == angular.lowercase(room.fl) && r.dt == room.dt && r.id != room.id){
            $scope.isDuplicateRoom = true;
            return true;
          }
        });
        if(!$scope.isDuplicateRoom){
          COESrv.editRoom({id:$scope.coe.info.id, room:room}).then(
            function(data){
              if(data.code == 8214 || data.code == 8215){
                $scope.roomUProcessing = false;
                room.show = false;
              }
            },
            function(err){
              $log.error(err);
              $scope.roomUProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          $scope.errType = "roomExists";
        }
      } else if(caller == "c"){
        $scope.curRoomList.forEach(function(val, i){
          if(val.id == room.id){
            $scope.curRoomList[i] = $scope.roomCopy;
            return true;
          }
        });
        room.show = false;
        $scope.roomCopy.show = false;
      }
    }


    $scope.coeFx = function(tab, caller){
      // TODO: new code
      $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}
      $scope.selectedDeviceSS = {n:[], u:[], v:[]}
      $scope.hasListErr = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if(tab == 1 || tab == 2 || tab == 3 || caller == "save"){
        if($scope.coe.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.coe.info.settings.rb.titleSize == null){
          $scope.errType = "tSize";
          $scope.hasErr = true;
          $("#rbTitleSize").focus();
        } else if($scope.coe.info.settings.rb.subtitleSize == null){
          $scope.errType = "rbSubTSize";
          $scope.hasErr = true;
          $("#rbSubTSize").focus();
        } else if($scope.coe.info.settings.rb.timeSize == null){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#rbTimeSize").focus();
        } else if($scope.coe.info.settings.rb.sos.sType == "p" && !$scope.coe.info.settings.rb.sos.prior){
          $scope.errType = "rbSosP";
          $scope.hasErr = true;
          $("#rbSosP").focus();
        } else if($scope.coe.info.settings.rb.sos.eType == "a" && !$scope.coe.info.settings.rb.sos.after){
          $scope.errType = "rbSosA";
          $scope.hasErr = true;
          $("#rbSosA").focus();
        } else if($scope.coe.info.settings.wb.rotationOpt == "c" && $scope.coe.info.settings.wb.rotate == null){
          $scope.errType = "rotation";
          $scope.hasErr = true;
          $("#rotation").focus();
        } else if($scope.coe.info.settings.wb.headerSize == null){
          $scope.errType = "hSize";
          $scope.hasErr = true;
          $("#wbHSize").focus();
        } else if($scope.coe.info.settings.wb.titleSize == null){
          $scope.errType = "titleSize";
          $scope.hasErr = true;
          $("#wbTitleSize").focus();
        } else if($scope.coe.info.settings.wb.timeSize == null){
          $scope.errType = "timeSize";
          $scope.hasErr = true;
          $("#wbTimeSize").focus();
        } else if($scope.coe.info.settings.wb.roomSize == null){
          $scope.errType = "roomSize";
          $scope.hasErr = true;
          $("#wbRoomSize").focus();
        } else if($scope.coe.info.settings.wb.sos.sType == "p" && !$scope.coe.info.settings.wb.sos.prior){
          $scope.errType = "wbSosP";
          $scope.hasErr = true;
          $("#wbSosP").focus();
        } else if($scope.coe.info.settings.wb.sos.eType == "a" && !$scope.coe.info.settings.wb.sos.after){
          $scope.errType = "wbSosA";
          $scope.hasErr = true;
          $("#wbSosA").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }

          $scope.coe.info.fid = $scope.fid;
          $scope.coe.info.toast = false;
          $scope.coe.meetings = [];

          if(tab == 1 || tab == 2 || tab == 3){
            $scope.nextProcessing = true;
          } else{
            $scope.coe.info.toast = true;
            $scope.saveProcessing = true;
          }
          if($scope.isPEOpen){
            $timeout(function(){
              $scope.saveCoeFx(tab);
            }, 250);
          } else{
            $scope.saveCoeFx(tab);
          }
        }
      } else{
        if(tab == 1){
          $timeout(function(){
            $scope.tabFx(2, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else if(tab == 2){
          $timeout(function(){
            $scope.tabFx(3, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        } else{
          $timeout(function(){
            $scope.tabFx(4, 'tabFx');
            $scope.isPEOpen = false;
          }, 250);
        }
      }
    }

    $scope.saveCoeFx = function(tab, caller){
      $scope.reponseLoad = true;
      $scope.coe.info.fid = $scope.fid;
      $scope.coe.info.tzOffset = $scope.curTimezone;
      //! No need to do this here start
      // $scope.tempRoomList = {d:[], r:[]};

      // angular.forEach($scope.curRoomList, function(rl){
      //   if(rl.type == "r"){
      //     $scope.tempRoomList.r.push(rl);
      //   } else{
      //     $scope.tempRoomList.d.push(rl);
      //   }
      // });
      // $scope.coe.info.roomList.r = $scope.tempRoomList.r;
      // angular.forEach($scope.tempRoomList.d, function(item){
      //   delete item.isDuplicate;
      // });
      // $scope.coe.info.roomList.d = $scope.tempRoomList.d;
      //! No need to do this here ends
      // TODO: new code
      if($scope.coe.info.roomList){
        delete $scope.coe.info.roomList
      }
      COESrv.saveEvent($scope.coe).then(
        function(data){
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          if(data.id){
            $scope.coe.info.id = data.id;
          }
          if(tab == 1 || tab == 2 || tab == 3){
            if(tab == 1){
              $timeout(function(){
                $scope.tabFx(2, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else if(tab == 3){
              $timeout(function(){
                $scope.tabFx(4, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            } else{
              $timeout(function(){
                $scope.tabFx(3, 'tabFx');
                $scope.isPEOpen = false;
              }, 250);
            }
          } else if(tab == 5){
            localStorage.setItem("celEventBack", JSON.stringify({id:$scope.id, back:true, label:caller, curFId:$scope.fid}));
            $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
          } else{
            $state.go("hub.contentLibrary.c");
          }
          $scope.reponseLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.nextProcessing = false;
          $scope.saveProcessing = false;
          $scope.reponseLoad = false;
        }
      );
    }

    $scope.cancelFx = function(){
      localStorage.removeItem("celEventBack");
      $state.go("hub.contentLibrary.c");
    }

    //select all assign & available devices
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //device sorting
    $rootScope.mADeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mSDeviceSort = {type:($scope.curDeviceObj.caller =="coe"?'label':'room'),val:"asc", reverse:false, lType:'device'};
    $rootScope.mDeviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.mADeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $scope.mSDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //reset selected devices
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.search = {text:""};
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.selectedT != "3" && item.type == "Image"){
            $scope.curArgsContent.push(item);
          } else if($scope.selectedT == "3" && (item.type == "Image" || item.type == "POWERPOINT" || item.type == "WORD" || item.type == "Vector" || item.type == "Video")){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });



    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';
    $scope.loadingPaging = {}
    $scope.loadingMore = {}
    $scope.selectedRoom = {n: {d:[], dg:[], r:[]}, u: {d:[], dg:[], r:[]}, v: {d:[], dg:[], r:[]}}

    $scope.subTabRL = 1;
    $scope.subTabRLFx = function(caller){
      $scope.subTabRL = caller;
      if(caller == 1){
        // TODO: new code
        var obj = {subCaller: "wCoERL", caller: "availD", offset: 0, id: $scope.coe.info.id, subCallerId: 0, quadId:"rl"};
        $scope.getScrollListData(obj);
      }
    }

    // TODO assignable UI API call start
    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;

            if($scope.deviceViewObj.caller == 'n' && data.d.length){
              if($scope.deviceViewObjCopy.caller == 'u'){
                $scope.selectedDeviceSS.n = [];
              }
              if($scope.selectedDeviceSS.n.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.n));
              }
            }
            if($scope.deviceViewObj.caller == 'u' && data.d.length){
              if($scope.selectedDeviceSS.u.length){
                data.d = $scope.updateArr(data.d, $scope.arraytoStringFx($scope.selectedDeviceSS.u));
              }
            }

            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            if(data.d.length){
              if($scope.deviceViewObj.caller == 'u' && $scope.selectedDeviceSS.u.length){
                tempArr = $scope.selectedDeviceSS.u;
              } else{
                angular.forEach(data.d, function(obj){
                  tempArr.push({
                    id: Number(obj.split("|")[0]),
                    h: obj.split("|")[2],
                    l: obj.split("|")[3],
                    lp: Number(obj.split("|")[1])
                  });
                });
              }
              $scope.scrollDataListDyn[caller] = tempArr;
            } else{
              if($scope.deviceViewObj.caller == 'n'){
                if($scope.deviceViewObjCopy.caller == 'u'){
                  $scope.selectedDeviceSS.n = [];
                }
                if($scope.selectedDeviceSS.n.length){                  
                  $scope.scrollDataListDyn[caller] = $scope.selectedDeviceSS.n;
                } else{
                  $scope.scrollDataListDyn[caller] = data.d;
                }
              } else {
                $scope.scrollDataListDyn[caller] = data.d;
              }
            }
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.deviceViewObj.caller == 'n'){
              $rootScope.devicesLoading = false;
            } else if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $rootScope.devicesLoading = false;
            }
            $scope.$apply();
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.updateArr = function(arr1, arr2){
      arr1.forEach(function (item) {
        if (arr2.includes(item.id)) {
          if($scope.selectedT == '2'){
            item.selected = true; // Add key-value pair
          }
          if($scope.selectedT == '3'){
            item.sel = true; // Add key-value pair
          }
        }
      });
      return arr1;
    }

    $scope.selectRoomItem = function(caller, value, id){
      if(!$scope.selectedRoom[$scope.roomViewObj.caller][caller].length){
        $scope.selectedRoom[$scope.roomViewObj.caller][caller].push(id);
      } else{
        if(value){
          $scope.selectedRoom[$scope.roomViewObj.caller][caller].push(id);
        } else{
          var index = $scope.selectedRoom[$scope.roomViewObj.caller][caller].indexOf(id);
          if (index !== -1) {
            $scope.selectedRoom[$scope.roomViewObj.caller][caller].splice(index, 1)[0];
          }
        }
      }
      $scope.addEvent.rc = ($scope.selectedRoom[$scope.roomViewObj.caller].d.length + $scope.selectedRoom[$scope.roomViewObj.caller].dg.length + $scope.selectedRoom[$scope.roomViewObj.caller].r.length);
      $scope.addEvent.room = angular.copy($scope.selectedRoom[$scope.roomViewObj.caller]);
    }

    // TODO get Scroll data for the event and room list tab
    $scope.getScrollListData = function(obj){
      if(obj.quadId == "ev"){
        $scope.detailPopupLoading = true;
      } else{
        $scope.roomListLoading = true;
      }
      $scope.detailListObj[obj.quadId] = {};
      $scope.scrollDataList[obj.quadId] = [];
      $scope.allScrollDataList[obj.quadId] = [];
      $scope.copyScrollObj[obj.quadId] = {};
      $scope.visibleObjects[obj.quadId] = [];
      $scope.haveMoreData[obj.quadId] = false;
      $scope.haveMoreSearchData[obj.quadId] = false;
      $scope.visibleData[obj.quadId] = [];
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.searchScroll[obj.quadId] = false;
      $scope.loadingMore[obj.quadId] = false;
      $scope.loadingPaging[obj.quadId] = true;

      $scope.detailListObj[obj.quadId] = {subCaller: obj.subCaller, caller: obj.caller, offset: obj.offset, id: obj.id, subCallerId: obj.subCallerId, quadId:obj.quadId};
      
      DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData[obj.quadId] = true;
          } else{
            $scope.haveMoreData[obj.quadId] = false;
          }

          if(obj.quadId == "ev"){
            var tempListUpdate = {
              d: data.d,
              dg: data.dg,
              r: data.r
            };
            if($scope.roomViewObj.caller == 'n'){
              if($scope.roomViewObjCopy.caller == 'u'){
                $scope.selectedRoom.n = {d:[], dg:[], r:[]}
              } else{
                angular.forEach(tempListUpdate, function (list, key) {
                  if(list.length){
                    list = $scope.updateArr(list, $scope.selectedRoom.n[key]);
                  }
                });
              }
            }
            if($scope.roomViewObj.caller == 'u'){
              if(($scope.selectedRoom.u.d.length + $scope.selectedRoom.u.dg.length +$scope.selectedRoom.u.r.length) > 0 && $scope.roomViewObjCopy.caller == $scope.roomViewObj.caller && $scope.roomViewObjCopy.id == $scope.roomViewObj.id){
                $scope.addEvent.room = angular.copy($scope.selectedRoom.u);
              } else{
                $scope.selectedRoom.u = angular.copy(data.srl);
                $scope.addEvent.room = angular.copy($scope.selectedRoom.u);
              }
              angular.forEach(tempListUpdate, function (list, key) {
                if(list.length){
                  list = $scope.updateArr(list, $scope.selectedRoom.u[key]);
                }
              });
            }
            if($scope.roomViewObj.caller == 'v'){
             angular.forEach(tempListUpdate, function (list, key) {
              if(list.length){
                angular.forEach(list, function (dObj) {
                   dObj.selected = true;
                });
              }
             });
            }
            $scope.selectedRoomCopy = angular.copy($scope.selectedRoom);
            
            $scope.dgList = {d:[], g:[], r:[]};
            $scope.dgList.g = angular.copy(data.dg);
            $scope.dgList.r = angular.copy(data.r);
          }
          if(obj.quadId == "rl"){
            $scope.curRoomList = data.r;
            angular.forEach($scope.curRoomList, function(item){
              item.type = "r"
            })
          }

          $scope.scrollDataList[obj.quadId] = data.d;
          $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.roomListLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
        },
        function(err){
          if(obj.quadId == "ev"){
            $scope.detailPopupLoading = false;
          } else{
            $scope.roomListLoading = false;
          }
          $scope.loadingPaging[obj.quadId] = false;
          $log.error(err);
        }
      );
    }

    // TODO room list popup
    $scope.roomViewObjCopy = {caller: "", id: undefined}
    $scope.roomListView = function(caller, id){
      $scope.searchList = {d:"", g:"", r:""};
      $scope.roomViewObj = {caller: caller, id: id}
      if(caller && caller == "v"){
        var obj = {subCaller: "wCoEEvView", caller: "availD", offset: 0, id: $scope.coe.info.id, subCallerId: id, quadId:"ev"};
      } else{
        if(id){
          var obj = {subCaller: "wCoEEv", caller: "availD", offset: 0, id: $scope.coe.info.id, subCallerId: id, quadId:"ev"};
        } else{
          var obj = {subCaller: "wCoEEv", caller: "availD", offset: 0, id: $scope.coe.info.id, subCallerId: 0, quadId:"ev"};
        }
      }
      $scope.getScrollListData(obj);
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/roomList.html',
        width:800,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller, value){
          if(caller == 'c' || caller == '$closeButton'){
            $scope.selectedRoom = $scope.selectedRoomCopy;
            if($scope.roomViewObj.caller != 'v'){
              $scope.addEvent.rc = ($scope.selectedRoom[$scope.roomViewObj.caller].d.length + $scope.selectedRoom[$scope.roomViewObj.caller].dg.length + $scope.selectedRoom[$scope.roomViewObj.caller].r.length);
            }
            if($scope.roomViewObj.caller == 'u'){
              $scope.addEvent.room = angular.copy($scope.selectedRoom[$scope.roomViewObj.caller]);
            }
          } else{
            $scope.roomViewObjCopy = angular.copy($scope.roomViewObj);
          }
        }
      });
    }

    $scope.selectRoomListFx = function(caller){
      ngDialog.close();
    }


    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.loadingMore[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: $scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        if($scope.searchScroll[obj.quadId]){
          $scope.detailListObj[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else if(data.d.length && data.d.length < 1000){
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.allScrollDataList[obj.quadId] = [];
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
              setTimeout(function() {
                $scope.loadingMore[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = 0;
        $scope.etIndex[obj.quadId] = 300;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        $scope.scrollDataList[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if(obj.text){          
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {subCaller: $scope.copyScrollObj[obj.quadId].subCaller, caller: $scope.copyScrollObj[obj.quadId].caller, offset: 0, id: $scope.copyScrollObj[obj.quadId].id, subCallerId: $scope.copyScrollObj[obj.quadId].subCallerId, quadId:$scope.copyScrollObj[obj.quadId].quadId};
        }
  
        if(obj.text){
          $scope.searchScroll[obj.quadId] = true;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length && data.d.length >= 1000){
                $scope.haveMoreSearchData[obj.quadId] = true;
              } else{
                $scope.haveMoreSearchData[obj.quadId] = false;
              }
              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
  
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else{
          $scope.haveMoreSearchData[obj.quadId] = false;
          $scope.searchScroll[obj.quadId] = false;
          $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData[obj.quadId] = true;
              } else{
                $scope.haveMoreData[obj.quadId] = false;
              }

              if(obj.quadId == "ev"){
                if($scope.roomViewObj.caller == "v"){
                  if(data.d.length){angular.forEach(data.d, function(item){item.selected = true;})}
                }
                if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                  if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){data.d = $scope.updateArr(data.d, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
                }
              }

              $scope.scrollDataList[obj.quadId] = data.d;
              
              $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
              $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataList[obj.quadId] = [];
              $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
  
              // $scope.dpLoading = false;
              setTimeout(function() {
                $scope.loadingPaging[obj.quadId] = false;
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      if($scope.selectedT != '3'){
        $scope.stIndex[obj.quadId] = obj.st;
        $scope.etIndex[obj.quadId] = obj.et;
        $scope.visibleData[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
        setTimeout(function() {
          $scope.$apply();
        });
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      if($scope.selectedT == '2' || ($scope.selectedT == '4' && $scope.subTabRL == 1)){
        var text = val.toLowerCase();
        var scrollElement = document.querySelector("#scroll-container-"+quadId);
        if (!text && $scope.searchScroll[quadId]) {
          // TODO Enter when have newVal is empty and user perform search operation already
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else if (text && text.length >= 3) {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if(scrollElement != null){
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreData[quadId]) {
            // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
            // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
            var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj , function (item) {
              if(keys.indexOf(item.h) === -1){
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if(filteredObj.length && filteredObj.length >= 1000){
              $scope.haveMoreSearchData[quadId] = true;
            } else{
              $scope.haveMoreSearchData[quadId] = false;
            }

            if(quadId == "ev"){
              if($scope.roomViewObj.caller == "v"){
                if(filteredObj.length){angular.forEach(filteredObj, function(item){item.selected = true;})}
              }
              if($scope.roomViewObj.caller == "n" || $scope.roomViewObj.caller == "u"){
                if($scope.selectedRoom[$scope.roomViewObj.caller].d.length){filteredObj = $scope.updateArr(filteredObj, $scope.selectedRoom[$scope.roomViewObj.caller].d);}
              }
            }
                        
            $scope.scrollDataList[quadId] = filteredObj;
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            if ($scope.scrollDataList[quadId].length <= 300) {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
            } else {
              $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
            }
            $scope.searchScroll[quadId] = true;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          } else {
            $scope.stIndex[quadId] = 0;
            $scope.etIndex[quadId] = 300;
            $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
          }
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ss"){
        // $scope.curDeviceObj.devices = obj.selDevice;
        $scope.screenSaverSelDevice = obj.selDevice;
        $scope.curDeviceObj.devices = $scope.arraytoStringFx(obj.selDevice);
      }
    });
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CoDButtonController', CoDButtonController);

  /** @ngInject */
  function CoDButtonController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, ngDialog, CoDButtonSrv, ContentLibrarySrv){
    $scope.colorPicker = {lb:false, cb:false, tBg:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.search = {text:"", pText:""};
    $rootScope.codSelectedItems = [];
    $rootScope.codObj = {type:""};
    $scope.saveProcessing = false;
    $scope.addProcessing = false;
    $scope.detailLoading = false;
    $scope.advancedShow = true;
    $scope.contentCaller = {type: ""};
    $scope.isPEOpen = false;
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      settings:{bg:"#eeeeee", bga:1, text:"Content on Demand", iconP:"l", bType:"i", textSize:24, textColor:"#444444", textFont:{label:"Century Gothic", value:"century gothic"}, idleTimeout:"n", timeout:"", closeBtn:true},
      ctype:{bg:"monochrome", textColor:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      // console.warn($scope.settings);
      $scope.timeoutDisable = false;
      // $scope.copyImgIcon = "";
      // $scope.copyBg = "#eeeeee";
      $scope.codBtn.iconImg = "";
      $scope.codBtnCopy.iconImg = "";
      $scope.codBtnCopy.settings = angular.copy($scope.settings.settings);
      $scope.codBtnCopy.ctype = angular.copy($scope.defaultSettings.ctype);
      $scope.codBtn.tContent = angular.copy($scope.codBtn.tContent);
      $scope.codBtn.settings = angular.copy($scope.defaultSettings.settings);
      $scope.codBtn.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      CoDButtonSrv.getCODBtn($scope.decId).then(
        function(data){
          $scope.codBtn = data;
          $scope.codBtnCopy = angular.copy(data);
          $scope.codBtn.type = $scope.codBtn.settings.type;
          // if($scope.codBtn.iconImg != ''){
          //   $scope.copyImgIcon = angular.copy($scope.codBtn.iconImg);
          // }
          // if($scope.codBtn.tContent != ''){
          //   $scope.copyCIcon = angular.copy($scope.codBtn.tContent);
          // }
          if(!$scope.codBtn.settings.idleTimeout){
            $scope.codBtn.settings.idleTimeout = "n";
            $scope.codBtn.settings.timeout = "";
          }
          if(!$scope.codBtn.settings.closeBtn){
            $scope.codBtn.settings.closeBtn = false;
          }
          $scope.copyBType = angular.copy($scope.codBtn.settings.bType);
          $scope.copyType = angular.copy($scope.codBtn.type);
          $scope.tim = $scope.codBtn.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.codBtn.otherinfo.bucket;
          if($scope.codBtn.otherinfo.mbucket && $scope.codBtn.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.codBtn.otherinfo.mbucket;
          }
          $scope.copyBg = angular.copy($scope.codBtn.settings.bg)
          $scope.detailLoading = false;
          $scope.selCloseBtnFx();
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.codBtn = {
        label:"", iconImg:"", tContent:"", type:"cod", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.codBtn.type == "jci" && $scope.contentCaller.type == "content" && item.type == "Widget" && item.extn === "Intel JCI Map"){
            $scope.curArgsContent.push(item);
          } else if($scope.codBtn.type == "url" && $scope.contentCaller.type == "content" && item.type == "Widget" && item.extn === "Web Page"){
            $scope.curArgsContent.push(item);
          } else if($scope.codBtn.type == "sb" && $scope.contentCaller.type == "content" && item.type == "Widget" && item.extn === "Intel Smart Building"){
            $scope.curArgsContent.push(item);
          } else if($scope.contentCaller.type != "content"){
            if(item.type == "Image"){
              $scope.curArgsContent.push(item);
            }
          }

        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });


    $scope.selCloseBtnFx = function(){
      if($scope.codBtn.settings.closeBtn){
        $scope.timeoutDisable = false;
      } else {
        $scope.timeoutDisable = true;
        $scope.codBtn.settings.idleTimeout = "c";
      }
    }

    $scope.checkScrollFx = function(){
      setTimeout(function(){
        if($scope.codBtn.settings.iconP == "l" || $scope.codBtn.settings.iconP == "r"){
          if($(".previewBox").innerWidth() < $("#btnText").innerWidth() + $("#iconImg2").innerWidth()){
            $(".previewBox").removeClass("justify-center");
          } else {
            if(!$(".previewBox").hasClass("justify-center")){
              $(".previewBox").addClass("justify-center");
            }
          }
        }
      },500);
    }

    $scope.selectContentPopOpen = function(caller){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.contentCaller.type = caller;
      if(caller=='content'){
        $rootScope.codObj.type = $scope.codBtn.type;
      } else {
        $rootScope.codObj.type = "";
      }
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList(caller);
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.updateList = function(caller){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if($scope.contentCaller.type == "content"){
          if($scope.codBtn.type == "jci" && item.type == "Widget" && item.extn === "Intel JCI Map"){
            $scope.contentList.push(item);
          } else if($scope.codBtn.type == "url" && item.type == "Widget" && item.extn === "Web Page"){
            $scope.contentList.push(item);
          } else if($scope.codBtn.type == "sb" && item.type == "Widget" && item.extn === "Intel Smart Building"){
            $scope.contentList.push(item);
          }
        } else {
          if(item.type == "Image" || (item.splType && item.splType == "Image")){
            $scope.contentList.push(item);
          }
        }
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      CoDButtonSrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.folderBriefFx = function(){}

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              btnExtn:listItem.btnExtn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible,
              ss:listItem.ss,
              ssImg:listItem.ssImg,
              url:listItem.url
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.contentCaller.type == "content"){
          $scope.codBtn.tContent = $scope.curBg;
          $scope.codBtn.tContent.isHidden = 0;
        } else {
          $scope.codBtn.iconImg = $scope.curBg;
          $scope.codBtn.iconImg.isHidden = 0;
        }
        $scope.checkScrollFx();
        ngDialog.close();
      }
    }
    $scope.removeBgFx = function(){
      $scope.codBtn.iconImg = "";
      $scope.codBtn.settings.iconP = "l";
    }
    $scope.removeTBgFx = function(){
      $scope.codBtn.tContent = null;
    }

    $scope.codBtnFx = function(tab, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.codBtn.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.codBtn.type != 'cod' && (!$scope.codBtn.tContent || $scope.codBtn.tContent == '' || $scope.codBtn.tContent.length == 0)){
        $scope.hasErr = true;
        $scope.errType = "cEmpty";
      } else if($scope.codBtn.type != 'cod' && $scope.codBtn.settings.idleTimeout == "c" && ($scope.codBtn.settings.timeout == "" || $scope.codBtn.settings.timeout == null)){
        $scope.errType = "timeoutEmpty";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.codBtn.settings.bType == 'i' && (!$scope.codBtn.iconImg || $scope.codBtn.iconImg == '' || $scope.codBtn.iconImg.length == 0)){
        $scope.hasErr = true;
        $scope.errType = "iEmpty";
      } else if(!$scope.codBtn.iconImg && $scope.codBtn.settings.text == ""){
        $scope.hasErr = true;
        $scope.errType = "iconText";
        $("#sText").focus();
      } else if(!$scope.codBtn.settings.textSize){
        $scope.hasErr = true;
        $scope.errType = "textSize";
        $("#textSize").focus();
      } else{
        $scope.saveProcessing = true;
        $scope.codBtn.fid = $scope.fid;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveCODBtnFx();
          }, 250);
        } else{
          $scope.saveCODBtnFx();
        }
      }
    }

    $scope.saveCODBtnFx = function(){
      if($scope.codBtn.settings.idleTimeout == 'n'){
        $scope.codBtn.settings.timeout = "";
      }
      $scope.codBtn.settings.type = angular.copy($scope.codBtn.type);
      $scope.finalObj = angular.copy($scope.codBtn);
      delete $scope.finalObj.type;

      CoDButtonSrv.saveCODBtn($scope.finalObj).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }

    $scope.resetImgFx = function(caller){
      if($scope.encId){
        if(caller == 'content'){
          if($scope.copyType !=  $scope.codBtn.type){
            $scope.codBtn.tContent = "";
          } else {
            $scope.codBtn.tContent = $scope.codBtnCopy.tContent;
          }
        } else {
          if($scope.copyBType !=  $scope.codBtn.settings.bType){
            $scope.codBtn.iconImg = "";
          } else {
            // $scope.codBtn.iconImg = $scope.copyImgIcon;
            $scope.codBtn.iconImg = $scope.codBtnCopy.iconImg;
          }
          if($scope.codBtn.settings.bType == "i"){
            $scope.codBtn.settings.bg = $scope.settings.settings.bg;
            $scope.codBtn.settings.iconP = $scope.settings.settings.iconP;
            $scope.codBtn.settings.text = $scope.settings.settings.text;
            $scope.codBtn.settings.textColor = $scope.settings.settings.textColor;
            $scope.codBtn.settings.textSize = $scope.settings.settings.textSize;
            $scope.codBtn.settings.textFont = $scope.settings.settings.textFont;
            $scope.codBtn.ctype = $scope.settings.ctype;
          } else {
            // $scope.codBtn.settings.bg = $scope.copyBg;
            $scope.codBtn.settings.bg = $scope.codBtnCopy.settings.bg;
            $scope.codBtn.settings.iconP = $scope.codBtnCopy.settings.iconP;
            $scope.codBtn.settings.text = $scope.codBtnCopy.settings.text;
            $scope.codBtn.settings.textColor = $scope.codBtnCopy.settings.textColor;
            $scope.codBtn.settings.textSize = $scope.codBtnCopy.settings.textSize;
            $scope.codBtn.settings.textFont = $scope.codBtnCopy.settings.textFont;
            $scope.codBtn.ctype = $scope.codBtnCopy.ctype;
          }
        }
      } else {
        $scope.codBtn.settings.bg = "#eeeeee";
        if(caller == 'content'){
          $scope.codBtn.tContent = "";
        }
        $scope.codBtn.iconImg = "";
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CloudFarmController', CloudFarmController);

  /** @ngInject */
  function CloudFarmController($log, $rootScope, $scope, $state, $cookies, $timeout, CloudFarmSrv){
    $scope.colorPicker = {b:false, hb:false, ht:false, rb:false, rt:false, arb:false, art:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPassShow = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;

    $scope.settings = {
      settings:{
        url:"", uName:"", pass:"", fId:"", reloadOpt:"a", reload:30
      }
    };

    $scope.showPassFx = function(status){
      $scope.isPassShow = status;
      var passFeild = $("#pass");
      var passFieldType = passFeild.attr("type");
      if (passFieldType === "password" && $scope.isPassShow) {
        passFeild.attr("type", "text");
      } else {
        passFeild.attr("type", "password");
      }
    }

    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.cloudFarm.settings = angular.copy($scope.defaultSettings.settings);
      $scope.cloudFarm.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.wcGetId = $scope.decId;
      CloudFarmSrv.getCloudFarm($scope.decId).then(
        function(data){
          $scope.cloudFarm = data;
          $scope.cloudFarm.settings.pass = $scope.hubDec($scope.cloudFarm.settings.pass);
          $scope.detailLoading = false;
        }, function (err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.cloudFarm = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.cloudFarmFx = function(){
      $scope.cloudFarm.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.cloudFarm.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.cloudFarm.settings.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.cloudFarm.settings.uName == ""){
        $scope.errType = "uname";
        $scope.hasErr = true;
        $("#uName").focus();
      } else if($scope.cloudFarm.settings.pass == ""){
        $scope.errType = "pass";
        $scope.hasErr = true;
        $("#pass").focus();
      } else if($scope.cloudFarm.settings.fId == ""){
        $scope.errType = "fId";
        $scope.hasErr = true;
        $("#fId").focus();
      } else if($scope.cloudFarm.settings.reloadOpt == 'c' && !$scope.cloudFarm.settings.reload){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveCloudFarmFx();
          }, 250);
        } else{
          $scope.saveCloudFarmFx();
        }
      }
    }
    $scope.saveCloudFarmFx = function(){
      $scope.cloudFarm.settings.pass = $scope.hubEnc($scope.cloudFarm.settings.pass);
      CloudFarmSrv.saveCloudFarm($scope.cloudFarm).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.hubEnc = function(pass){
      return btoa($scope.reverse($scope.cloudFarm.settings.pass) + "|-|-|" + pass);
    }
    $scope.hubDec = function(pass){
      return atob($scope.cloudFarm.settings.pass).split("|-|-|")[1];
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CloudCoverMusicController', CloudCoverMusicController);

  /** @ngInject */
  function CloudCoverMusicController($log, $rootScope, $scope, $state, $cookies, $timeout, CloudCoverMusicSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      CloudCoverMusicSrv.getCloudCoverMusic($scope.decId).then(
        function(data){
          $scope.ccm = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.ccm = {label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
    }

    $scope.ccmFx = function(tab, caller){
      $scope.ccm.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.ccm.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
            }, 50);
          } else if(caller == "save"){
            $scope.saveProcessing = true;
            if($scope.isPEOpen){
              $timeout(function(){
                $scope.saveCCMFx();
              }, 250);
            } else{
              $scope.saveCCMFx();
            }
          }
        }
      }
    }
    $scope.saveCCMFx = function(){
     CloudCoverMusicSrv.saveCloudCoverMusic($scope.ccm).then(
       function(data){
         $scope.saveProcessing = false;
         $state.go("hub.contentLibrary.c");
       },
       function(err){
         $log.error(err);
         $scope.saveProcessing = false;
       }
     );
   }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CiscoController', CiscoController);

  /** @ngInject */
  function CiscoController($log, $rootScope, $scope, $state, $cookies, $timeout, CiscoSrv){
    $scope.colorPicker = {hvbg:false, hvt:false, hvv:false, hvu:false, sbg:false, sht:false, srt:false, srv:false, sru:false, st:false,sv:false,su:false, li:false, lp:false, lf:false, lg:false,ex:false,hg:false, hf:false, hp:false,hi:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.netLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;
    $scope.orgId = "1257609";
    $scope.defaultReadList = [
      {"temperature":{
      "li":{"value":62,"src":"#cc0000","srca":1},
      "lp":{"value":64,"src":"#ff9900","srca":1},
      "lf":{"value":66,"src":"#f1c232","srca":1},
      "lg":{"value":68,"src":"#8fbc42","srca":1},
      "ex":{"value":76,"src":"#40b940","srca":1},
      "hg":{"value":78, "src":"#8fbc42","srca":1},
      "hf":{"value":80,"src":"#f1c232","srca":1},
      "hp":{"value":82,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"humidity":{
      "li":{"value":10,"src":"#cc0000","srca":1},
      "lp":{"value":20,"src":"#ff9900","srca":1},
      "lf":{"value":30,"src":"#f1c232","srca":1},
      "lg":{"value":40,"src":"#8fbc42","srca":1},
      "ex":{"value":60,"src":"#40b940","srca":1},
      "hg":{"value":70, "src":"#8fbc42","srca":1},
      "hf":{"value":80,"src":"#f1c232","srca":1},
      "hp":{"value":90,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"tvoc":{
      "ex":{"value":300,"src":"#40b940","srca":1},
      "hg":{"value":1000, "src":"#8fbc42","srca":1},
      "hf":{"value":3000,"src":"#f1c232","srca":1},
      "hp":{"value":10000,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"pm25":{
      "ex":{"value":23,"src":"#40b940","srca":1},
      "hg":{"value":41, "src":"#8fbc42","srca":1},
      "hf":{"value":53,"src":"#f1c232","srca":1},
      "hp":{"value":64,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"noise":{
      "ex":{"value":50,"src":"#40b940","srca":1},
      "hg":{"value":60, "src":"#8fbc42","srca":1},
      "hf":{"value":70,"src":"#f1c232","srca":1},
      "hp":{"value":80,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"indoorAirQuality":{
      "li":{"value": 39,"src":"#cc0000","srca":1,"unit":"Inadequate"},
      "lp":{"value":59,"src":"#ff9900","srca":1,"unit":"Poor"},
      "lf":{"value":79,"src":"#f1c232","srca":1,"unit":"Fair"},
      "lg":{"value":92,"src":"#8fbc42","srca":1,"unit":"Good"},
      "ex":{"value":100000,"src":"#40b940","srca":1,"unit":"Excellent"},
     }},
     {"eco2":{
      "ex":{"value":400,"src":"#40b940","srca":1},
      "hg":{"value":1000, "src":"#8fbc42","srca":1},
      "hp":{"value":5000,"src":"#ff9900","srca":1},
      "hi":{"value":100000,"src":"#cc0000","srca":1}
     }},
     {"battery":{
      "li":{"value":20,"src":"#cc0000","srca":1,"unit":"Inadequate"},
      "lp":{"value":40,"src":"#ff9900","srca":1,"unit":"Poor"},
      "lf":{"value":60,"src":"#f1c232","srca":1,"unit":"Fair"},
      "lg":{"value":80,"src":"#8fbc42","srca":1,"unit":"Good"},
      "ex":{"value":100,"src":"#40b940","srca":1,"unit":"Excellent"},
     }}
    ]

    $scope.hvl = {
      settings:{
        hvbg:"#cccccc", "hvbga":1,  hvt:"#6fa8dc", hvv:"#999999", hvu:"#999999", titleFont:$scope.fontFamily[87], valueFont:$scope.fontFamily[87], unitFont:$scope.fontFamily[87], titleSize:20, valueSize:18, unitSize:14,readList:[],unit:"f"
      },
      ctype:{hvbg:"monochrome", hvt:"default", hvv:"monochrome", hvu:"monochrome",li:"default",lp:"basic", lf:"default", lg:"custom",ex:"custom",hg:"custom", hf:"default", hp:"basic",hi:"default"}
    }

    $scope.slide = {
      settings:{
        rotationOpt:"a", rotate:12,sbg:"#ffffff","sbga":1,  sht:"#ffffff",  srt:"#444444", srv:"#666666",  sru:"#666666", st:"#444444", sv:"#999999", su:"#999999", readSize:20, headerSize:20, readVSize:22, readUSize:20, titleSize:22, valueSize:18, unitSize:14, headerFont:$scope.fontFamily[87], readFont:$scope.fontFamily[87], readVFont:$scope.fontFamily[87], readUFont:$scope.fontFamily[87], titleFont:$scope.fontFamily[87], valueFont:$scope.fontFamily[87], unitFont:$scope.fontFamily[87],readList:[],unit:"f"
      },
      ctype:{sbg:"monochrome", sht:"monochrome", srt:"monochrome", srv:"monochrome", sru:"monochrome", st:"monochrome", sv:"monochrome", su:"monochrome",li:"default",lp:"basic", lf:"default", lg:"custom",ex:"custom",hg:"custom", hf:"default", hp:"basic",hi:"default"}
    }

    $scope.defaultSettingsHvl = angular.copy($scope.hvl);
    $scope.defaultSettingsSlide = angular.copy($scope.slide);

    $scope.settingsDefault = function(){
      if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
        $scope.hvl = angular.copy({settings:$scope.defaultSettingsHvl.settings, ctype:$scope.defaultSettingsHvl.ctype});
        angular.forEach($scope.cisco.readings, function(val){
          if(val.value == true){
            $scope.readTypeFx(val);
          }
        });
      } else {
        $scope.slide = angular.copy({settings:$scope.defaultSettingsSlide.settings, ctype:$scope.defaultSettingsSlide.ctype});
        angular.forEach($scope.cisco.readings, function(val){
          if(val.value == true){
            $scope.readTypeFx(val);
          }
        });
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.chLoading = true;
      CiscoSrv.getCisco($scope.decId).then(
        function(data){
          $scope.cisco = data;
          if(!data.dType){
            $scope.cisco.dType = "hl"
          }
          if($scope.cisco.dType == "ss"){
            $scope.slide.settings = angular.copy($scope.cisco.settings);
            $scope.slide.ctype = angular.copy($scope.cisco.ctype);
            if(!$scope.cisco.settings.rotationOpt){
              $scope.slide.settings.rotationOpt = "a"
              $scope.slide.settings.rotate = 12
            }
          } else if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
            $scope.hvl.settings = angular.copy($scope.cisco.settings);
            $scope.hvl.ctype = angular.copy($scope.cisco.ctype);
            if(!$scope.cisco.settings.rotationOpt){
              $scope.hvl.settings.rotationOpt = "a"
              $scope.hvl.settings.rotate = 12
            }
          }
          // angular.forEach($scope.cisco.readings, function(val){
          //   $scope.readTypeFx(val);
          // });


          $scope.sensorListFx($scope.cisco.network.id);
          $scope.detailLoading = false;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.netLoading = true;
      // $scope.networkList = [{"id":"L_3695766444210913893","label":"North York"}];
      // $scope.deviceList = [{"label":"device 1"}, {"label":"device 2"}];
      //device is sensor and sensor is reading acc to s
      // $scope.sensorList = [{"label":"MT10","id":"a8:46:9d:ff:c9:be"}, {"label":"MT11","id":"a8:46:9d:76:1c:d6"}, {"label":"MT14", "id":"c4:8b:a3:fc:63:a0"}];
      $scope.cisco = {
        label:"", network:"", sensor:"", dType:"hl", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.hvl.settings),
        ctype:angular.copy($scope.hvl.ctype)
      };
    }
    CiscoSrv.getNetworkList($scope.orgId).then(
      function(data){
        $scope.netLoading = false;
        if(data.code == 1000){
          $scope.networkList = "";
        }else
        {
          $scope.networkList = data;
        }
      }, function(err){
        $log.error(err);
      }
    );

    $scope.sensorListFx = function(){
      $scope.sLoading = true;
      CiscoSrv.getSensorList($scope.cisco.network.id).then(
        function(data){
          $scope.sLoading = false;
          $scope.sensorList = data;
        }, function(err){
          $log.error(err);
        }
      );
    }

    $scope.readingListFx = function(){
      $scope.rLoading = true;
      CiscoSrv.getReadingList($scope.cisco.sensor.serial).then(
        function(data){
          $scope.rLoading = false;
          $scope.cisco.readings = data.metrics;
          if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
            $scope.hvl.settings.readList = [];
          }else{
            $scope.slide.settings.readList = [];
          }
          angular.forEach($scope.cisco.readings, function(read){
            read.value = true;
            $scope.readTypeFx(read);
          });
        }, function(err){
          $log.error(err);
        }
      );
    }
    $scope.readTypeFx = function(read){
      if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
        if(read.value == true){
          angular.forEach(angular.copy($scope.defaultReadList), function(val){
            angular.forEach(val, function(data, key){
              if(read.label == "temperature"){
                $scope.hvl.settings.unit = "f";
              }
              if($scope.trim(read.label).toLowerCase() == $scope.trim(key).toLowerCase()){
                $scope.hvl.settings.readList.push(val);
              }
            });
          });
        } else{
          angular.forEach($scope.hvl.settings.readList, function(val){
            angular.forEach(val, function(data, key){
              if($scope.trim(read.label).toLowerCase() == $scope.trim(key).toLowerCase()){
                $scope.hvl.settings.readList.splice($scope.hvl.settings.readList.indexOf(val), 1);
              }
            });
          });
        }
      } else{
        if(read.value == true){
          angular.forEach(angular.copy($scope.defaultReadList), function(val){
            angular.forEach(val, function(data, key){
              if(read.label == "temperature"){
                $scope.slide.settings.unit = "f";
              }
              if($scope.trim(read.label).toLowerCase() == $scope.trim(key).toLowerCase()){
                $scope.slide.settings.readList.push(val);
              }
            });
          });
        } else{
          angular.forEach($scope.slide.settings.readList, function(val){
            angular.forEach(val, function(data, key){
              if($scope.trim(read.label).toLowerCase() == $scope.trim(key).toLowerCase()){
                $scope.slide.settings.readList.splice($scope.slide.settings.readList.indexOf(val), 1);
              }
            });
          });
        }
      }
    }

    $scope.dTypeChange = function(type){
      if(type == "hl" || type == "vl"){
        $scope.hvl.settings.readList = [];
        angular.forEach($scope.cisco.readings, function(val){
          $scope.readTypeFx(val);
        });
      } else{
        $scope.slide.settings.readList = [];
        angular.forEach($scope.cisco.readings, function(val){
          $scope.readTypeFx(val);
        });
      }
    }

    $scope.changeUnit = function(unit){
      if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
        if(unit == "f"){
          angular.forEach($scope.hvl.settings.readList, function(val){
            angular.forEach(val, function(list,key){
            if(key == "temperature"){
              angular.forEach(list, function(data, name){
                data.value = Math.round(data.value * 9 / 5 + 32);
                });
              }
            });
          });
        } else{
          angular.forEach($scope.hvl.settings.readList, function(val){
            angular.forEach(val, function(list,key){
            if(key == "temperature"){
              angular.forEach(list, function(data, name){
                data.value = Math.round((data.value - 32) * 5 / 9);
                });
              }
            });
          });
        }
      } else{
        if(unit == "f"){
          angular.forEach($scope.slide.settings.readList, function(val){
            angular.forEach(val, function(list,key){
            if(key == "temperature"){
              angular.forEach(list, function(data, name){
                data.value = data.value * 9 / 5 + 32;
                });
              }
            });
          });
        } else{
          angular.forEach($scope.slide.settings.readList, function(val){
            angular.forEach(val, function(list,key){
            if(key == "temperature"){
              angular.forEach(list, function(data, name){
                data.value = (data.value - 32) * 5 / 9;
                });
              }
            });
          });
        }
      }
    }

    $scope.checkIfArrayIsValue = function(myArray){
      angular.forEach(myArray, function(val){
        angular.forEach(val, function(list,key){
          if(key == "temperature"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "humidity"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "tvoc"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "pm25"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "noise"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "indoorAirQuality"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "eco2"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
          if(key == "battery"){
            angular.forEach(list, function(data){
              if(data.value == null){
                $scope.isValue = true;
              }
            });
          }
        });
      });
    }
    $scope.checkIfArrayIsDiffPoint = function(myArray){
      angular.forEach(myArray, function(val){
        angular.forEach(val, function(list,key){
          var value;
          if(key == "temperature"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "humidity"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "tvoc"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "pm25"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "noise"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "indoorAirQuality"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "eco2"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
          if(key == "battery"){
            angular.forEach(list, function(data){
              if(value > data.value || value == data.value){
                $scope.isDiffPoint = true;
              } else{
                value = data.value
              }
            });
          }
        });
      });
    }

    $scope.ciscoFx = function(caller){
      $scope.cisco.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
        $scope.cisco.settings = angular.copy($scope.hvl.settings);
        $scope.cisco.ctype = angular.copy($scope.hvl.ctype);
      } else if($scope.cisco.dType == "ss"){
        $scope.cisco.settings = angular.copy($scope.slide.settings);
        $scope.cisco.ctype = angular.copy($scope.slide.ctype);
      }

      if($scope.cisco.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
      } else if($scope.cisco.network == ""){
        $scope.errType = "network";
        $scope.hasErr = true;
      } else if($scope.cisco.device == ""){
        $scope.errType = "device";
        $scope.hasErr = true;
      } else if($scope.cisco.sensor == ""){
        $scope.errType = "sensor";
        $scope.hasErr = true;
      // } else if($scope.cisco.readings.length && !$scope.isReading){
      } else {
        $scope.isReading = false;
        if($scope.cisco.readings.length){
          angular.forEach($scope.cisco.readings, function(read){
            if(read.value){
              $scope.isReading = true;
            }
          });
        } else{
          $scope.isReading = true;
        }
        if(!$scope.isReading){
          $scope.errType = "reading";
          $scope.hasErr = true;
        } else if(($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl") && $scope.cisco.settings.reloadOpt == 'c' && !$scope.cisco.settings.reload){
          $scope.errType = "reload";
          $scope.hasErr = true;
        } else if($scope.cisco.settings.rotationOpt == 'c' && !$scope.cisco.settings.rotate){
          $scope.errType = "rotate";
          $scope.hasErr = true;
        } else if(($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl" || $scope.cisco.dType === "ss") && !$scope.cisco.settings.titleSize){
          $scope.errType = "tSize";
          $scope.hasErr = true;
        } else if(($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl" || $scope.cisco.dType === "ss") && !$scope.cisco.settings.valueSize){
          $scope.errType = "vSize";
          $scope.hasErr = true;
        } else if(($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl" || $scope.cisco.dType === "ss") && !$scope.cisco.settings.unitSize){
          $scope.errType = "uSize";
          $scope.hasErr = true;
        } else if($scope.cisco.dType === "ss" && !$scope.cisco.settings.readSize){
          $scope.errType = "rSize";
          $scope.hasErr = true;
        } else if($scope.cisco.dType === "ss" && !$scope.cisco.settings.headerSize){
          $scope.errType = "hSize";
          $scope.hasErr = true;
        } else if($scope.cisco.dType === "ss" && !$scope.cisco.settings.readVSize){
          $scope.errType = "rvSize";
          $scope.hasErr = true;
        } else if($scope.cisco.dType === "ss" && !$scope.cisco.settings.readUSize){
          $scope.errType = "ruSize";
          $scope.hasErr = true;
        } else{
          if(caller == "save"){
            $scope.isValue = false;
            $scope.isColor = false;
            $scope.isDiffPoint = false;
            if($scope.cisco.dType == "hl" || $scope.cisco.dType == "vl"){
              $scope.checkIfArrayIsValue($scope.hvl.settings.readList);
              $scope.checkIfArrayIsDiffPoint($scope.hvl.settings.readList);
            } else{
              $scope.checkIfArrayIsValue($scope.slide.settings.readList);
              $scope.checkIfArrayIsDiffPoint($scope.slide.settings.readList);
            }
            if($scope.isValue){
              $scope.errType = "value";
              $scope.hasErr = true;
            } else if($scope.isDiffPoint){
              $scope.errType = "scaleRange";
              $scope.hasErr = true;
            } else if($scope.sameValue){
              $scope.errType = "sameValue";
              $scope.hasErr = true;
            } else if($scope.isColor){
              $scope.errType = "sameScaleColor";
              $scope.hasErr = true;
            } else if(!$scope.isValue && !$scope.isDiffPoint ){
              $scope.saveProcessing = true;
              if($rootScope.activePeriodOpen){
                $scope.isPEOpen = true;
                $rootScope.$broadcast('saveActivePeriod',{});
              }
              if($rootScope.isPermissionOpen){
                $scope.isPEOpen = true;
                $rootScope.$broadcast('savePermission',{});
              }
              if($scope.isPEOpen){
                $timeout(function(){
                  $scope.saveCiscoFx();
                }, 250);
              } else{
                $scope.saveCiscoFx();
              }
            }
          }
        }
      }
    }
    $scope.saveCiscoFx = function(){
      CiscoSrv.saveCisco($scope.cisco).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('BlankController', BlankController);

  /** @ngInject */
  function BlankController($log, $rootScope, $scope, $state, $cookies, $timeout, BlankSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      BlankSrv.getData($scope.decId).then(
        function(data){
          $scope.blank = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.blank = {
        label:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.blankSaveFx = function(){
      $scope.blank.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.blank.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveDataFx();
          }, 250);
        } else{
          $scope.saveDataFx();
        }
      }
    }
    $scope.saveDataFx = function(){
      BlankSrv.saveData($scope.blank).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AutoLoginController', AutoLoginController);

  /** @ngInject */
  function AutoLoginController($log, $rootScope, $scope, $state, $timeout, ngDialog, ContentLibrarySrv, AutoLoginSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.timestamp = moment().format('x');
    $scope.colorPicker = {b:false};
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.search = {text:""};
    $scope.curBtnCaller = "";
    $scope.isPEOpen = false;
    $scope.isCred = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.settings = {
      reloadOpt:"n", reload:"", bg:"#000000", bga:1,
      ctype:{bg:"monochrome"}
    };
    $scope.defaultSettings = {settings:angular.copy($scope.settings)};

    $scope.settingsDefault = function(){
      $scope.al.settings = angular.copy($scope.defaultSettings.settings);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      AutoLoginSrv.getAutoLogin($scope.decId).then(
        function(data){
          $scope.al = data;
          $scope.tim = $scope.al.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.al.otherinfo.bucket;
          if($scope.al.otherinfo.mbucket && $scope.al.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.al.otherinfo.mbucket;
          }
          if(!$scope.al.settings.bg){
            $scope.al.settings.bg = "#000000";
            $scope.al.settings.bga = 1;
            $scope.al.settings.ctype = {bg:"monochrome"};
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.isCred = true;
      $scope.al = {label:"", url:"", u:"", p:"", cp:"", ssType:"g",clImg:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings),ctype:angular.copy($scope.ctype)
      };
    }

    $scope.resetFx = function(){
      $scope.isCred = true;
    }

    $scope.alFx = function(){
      $scope.al.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.al.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      }
      else if($scope.isCred && $scope.al.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      }
      else if($scope.isCred && (!$scope.al.u || $scope.al.u == "")){
        $scope.errType = "uName";
        $scope.hasErr = true;
        $("#uName").focus();
      }
      else if($scope.isCred && (!$scope.al.p || $scope.al.p == "")){
        $scope.errType = "pass";
        $scope.hasErr = true;
        $("#pass").focus();
      }
      else if($scope.isCred && (!$scope.al.cp || $scope.al.cp == "")){
        $scope.errType = "cPass";
        $scope.hasErr = true;
        $("#cPass").focus();
      } else if($scope.isCred && $scope.al.p != $scope.al.cp){
        $scope.hasErr = true;
        $scope.errType = "match";
        $("#cPass").focus();
      } 
      else if($scope.al.ssType == 's' && $scope.al.clImg == ""){
        $scope.errType = "clImg";
        $scope.hasErr = true;
      } else if($scope.al.settings.reloadOpt == "c" && ($scope.al.settings.reload == "" || $scope.al.settings.reload == null)){
        $scope.errType = "reloadEmpty";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else if($scope.al.settings.reload && $scope.al.settings.reload < 10){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#cReload").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveALFx();
          }, 250);
        } else{
          $scope.saveALFx();
        }
      }
    }
    $scope.saveALFx = function(){
      $scope.saveProcessing = true;
      var curAL = angular.copy($scope.al);
      if($scope.isCred){
        curAL.u = $scope.encryptFx($scope.al.u);
        curAL.p = $scope.encryptFx($scope.al.p);
        curAL.cp = $scope.encryptFx($scope.al.cp);
      }
      AutoLoginSrv.saveAutoLogin(curAL).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $scope.updateList = function(){
      // console.warn($scope.contentLibrary);
      $scope.timestamp = moment().format('x');
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      if($scope.contentLibrary.info.timthumb){
        $scope.tim = $scope.contentLibrary.info.timthumb;
      }
      if($scope.contentLibrary.info.thumbSize){
        $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      }
      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.info.bucket){
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      }
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(caller){
      $scope.timestamp = moment().format('x');
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curBtnCaller = caller;
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.curBg = "";
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.flId = fId;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $scope.timestamp = moment().format('x');
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }

    $scope.useContentFx = function(){
      $scope.timestamp = moment().format('x');
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.curBtnCaller == "t"){
          $scope.al.clImg = $scope.curBg;
          $scope.al.isHidden = 0;
        }
        ngDialog.close();
      }
    }
    $scope.removeImgFx = function(caller){
      if(caller == "t"){
        $scope.al.clImg = "";
      }
    }
    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $scope.searchText = "";
      $scope.folderList = [];
      $scope.contentList = [];
      $scope.search = {text:""};
      $rootScope.selectedItems = [];
      $scope.folderList = args.folder;
      $scope.advSearchInfo = args.info;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;
      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AQIController', AQIController);

  /** @ngInject */
  function AQIController($log, $rootScope, $scope, $state, $cookies, $timeout, $filter, NgMap, AQISrv, ngDialog) {
    $scope.colorPicker = { bg: false, sbg: false, src: false, lt: false, st: false, sat: false, vt: false, vat: false };
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    var vm = this;

    $scope.settings = {
      settings:{
        label:"", p:"b", bg:"#ffffff", bga:1, sbg:"#000000", sbga:1, lt:"#000000", st:"#000000", sat:"#000000", vt:"#ffffff", vat:"#ffffff",
        lf:$scope.fontFamilySelected, ls:24, sf:$scope.fontFamilySelected, ss:24, saf:$scope.fontFamilySelected, sas:12, vf:$scope.fontFamilySelected, vs:24,
        vaf:$scope.fontFamilySelected, vas:12, scale:[], lang:"en_US", forecast:"0", orientation:"h", wsu:"kh", template:"t1"
      },
      ctype:{bg:"monochrome", sbg:"monochrome", lt:"monochrome", st:"monochrome", sat:"monochrome", vt:"monochrome", vat:"monochrome", src:"monochrome"}
    }
    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.aqi.settings = angular.copy($scope.defaultSettings.settings);
      $scope.aqi.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      AQISrv.getAQI($scope.decId).then(
        function(data){
          $scope.aqi = data;
          $scope.settings.settings = angular.copy($scope.aqi.settings);
          $scope.settings.ctype = angular.copy($scope.aqi.ctype);
          if($scope.aqi.lat && $scope.aqi.lng){
            $scope.positions[0] = {lat:$scope.aqi.lat, lng:$scope.aqi.lng};
            $scope.mapCenter = [$scope.aqi.lat, $scope.aqi.lng];
          }
          $scope.loadMap();
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.aqi = {
        label:"", lat:"", lng:"", address:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
      $scope.mapCenter = [43.6532, -79.3832];
    }

    /*Azure Map*/
    var azmap;
    $scope.loadMap = function(){
      $timeout(function(){
        // var keyArr = atob($scope.auth.uservices.mk).split("|");
        // var subKey = $scope.reverse(keyArr[0]);

        azmap = new atlas.Map('azMap',{
          view:'Auto',
          showFeedbackLink:false,
          // Add your Azure Maps subscription client ID to the map SDK.
          authOptions:{
            //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
            authType:'subscriptionKey',
            // subscriptionKey:'KID57hqwgPX1MyuBvAcyizt5t_WBJU4KmafpfF-oiOM'
            // subscriptionKey:subKey
            subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
          },
          language: "en"
        });

        //Wait until the map resources are ready.
        azmap.events.add("ready", function(){
          if($scope.aqi.lat && $scope.aqi.lng){
            if($scope.auth.uservices.m == "b"){
              azmap.markers.clear();
              $scope.cordinates = [];
              var selPosition = [$scope.aqi.lng, $scope.aqi.lat];
              var pin = new atlas.HtmlMarker({
                htmlContent:atlas.getImageTemplate('marker'),
                color:"DodgerBlue",
                position:selPosition,
                popup:new atlas.Popup({
                  pixelOffset:[0, -30]
                })
              });
              azmap.markers.add(pin);
            }

            azmap.setCamera({
              //center map
              center:[$scope.aqi.lng, $scope.aqi.lat],
              zoom:8,
            });
          } else{
            azmap.setCamera({
              center:[75.8577, 22.7196],
              zoom:8
            });
          }
          $scope.changeForMap();
        });

        azmap.events.add('click', function(e){addPin(e)});
      }, 1000);
    }
    $scope.loadMap();

    function addPin(e){
      $scope.hasErr = false;
      $scope.errType = "";
      azmap.markers.clear();
      if(e.type == "click"){
        var position = [e.position[0], e.position[1]];
        var pin = new atlas.HtmlMarker({
          htmlContent:atlas.getImageTemplate('marker'),
          color:"DodgerBlue",
          position:position,
          popup:new atlas.Popup({
            pixelOffset:[0, -30]
          })
        });

        azmap.markers.add(pin);
        $scope.aqi.lat = e.position[1];
        $scope.aqi.lng = e.position[0];
        $scope.$apply();
      }
    }

    /** Google Map */
    NgMap.getMap().then(function(map){
      vm.map = map;
    });
    $scope.positions = [];
    $scope.addMarker = function(event){
      $scope.hasErr = false;
      $scope.errType = "";
      var ll = event.latLng;
      $scope.positions[0] = {lat:ll.lat(), lng:ll.lng()};
      $scope.aqi.lat = $scope.positions[0].lat;
      $scope.aqi.lng = $scope.positions[0].lng;
    }
    $scope.zoomChanged = function(event){
      $scope.aqi.zoom = this.zoom;
    }
    $scope.changeForMap = function(){
      if($scope.auth.uservices.m == "g"){
        vm.map.setZoom($scope.aqi.zoom);
        if($scope.aqi.lat){
          vm.home = new google.maps.LatLng($scope.aqi.lat, $scope.aqi.lng);
          vm.map.markers[0].setPosition({lat:$scope.aqi.lat, lng:$scope.aqi.lng});
        }
      } else{
        azmap.setCamera({
          //center map
          zoom:8
        });
      }
    }
    $scope.slider = {
      value:50,
      options:{
        floor:0,
        ceil:100,
        readOnly:true
      }
    };
    $scope.AQIFx = function(tab, caller){
      $scope.aqi.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";
      if(tab == 1 || caller == "save"){
        if($scope.aqi.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#name").focus();
        } else if(!$scope.aqi.lat || !$scope.aqi.lng){
          $scope.errType = "latlong";
          $scope.hasErr = true;
          if(!$scope.aqi.lat){
            $("#lat").focus();
          } else{
            $("#lng").focus();
          }
        } else{
          if($rootScope.activePeriodOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('saveActivePeriod',{});
          }
          if($rootScope.isPermissionOpen){
            $scope.isPEOpen = true;
            $rootScope.$broadcast('savePermission',{});
          }
          if(tab == 1){
            $timeout(function(){
              $scope.tabFx(2, 'tabFx');
            }, 50);
          } else if($scope.aqi.settings.scale.length == 0){
            $scope.hasErr = true;
            $scope.errType = "scale";
            $("#addRowBtn").focus();
          } else if(!$scope.aqi.settings.ls){
            $scope.hasErr = true;
            $scope.errType = "ls";
            $("#ls").focus();
          } else if(!$scope.aqi.settings.ss){
            $scope.hasErr = true;
            $scope.errType = "ss";
            $("#ss").focus();
          } else if(!$scope.aqi.settings.sas){
            $scope.hasErr = true;
            $scope.errType = "sas";
            $("#sas").focus();
          } else if(!$scope.aqi.settings.vs){
            $scope.hasErr = true;
            $scope.errType = "vs";
            $("#vs").focus();
          } else if(!$scope.aqi.settings.vas){
            $scope.hasErr = true
            $scope.errType = "vas";
            $("#vas").focus();
          } else if(caller == "save"){
            $scope.isValue = false;
            $scope.isColor = false;
            $scope.isDiffPoint = false;
            $scope.sameValue = false;
            $scope.isValue = $scope.checkIfArrayIsValue($scope.aqi.settings.scale);
            $scope.sameValue = $scope.checkIfArrayIsUnique($scope.aqi.settings.scale);
            $scope.isDiffPoint = $scope.checkIfArrayIsDiffPoint($scope.aqi.settings.scale);
            $scope.isColor = $scope.checkIfArrayUniqueColor($scope.aqi.settings.scale);
            if($scope.isValue){
              $scope.hasErr = true;
              $scope.errType = "value";
            } else if($scope.isDiffPoint){
              $scope.hasErr = true;
              $scope.errType = "scaleRange";
            } else if($scope.sameValue){
              $scope.hasErr = true;
              $scope.errType = "sameValue";
            } else if($scope.isColor){
              $scope.hasErr = true;
              $scope.errType = "sameScaleColor";
            } else if(!$scope.isValue && !$scope.isDiffPoint && !$scope.sameValue && !$scope.isColor){
              $scope.saveProcessing = true;
              if($scope.isPEOpen){
                $timeout(function(){
                  $scope.saveAQIFx();
                }, 250);
              } else{
                $scope.saveAQIFx();
              }
            }
          }
        }
      }
    }
    $scope.addScaleDisable = false;
    $scope.addRowFx = function(){
      if($scope.aqi.settings.scale.length < 10){
        $scope.aqi.settings.scale.push({value:"", src:"#000000", srca:"1"});
      } else{
        $scope.addScaleDisable = true;
      }
    }
    $scope.confirmOpen = function(index){
      $scope.dataObj = {index:index};
      if($scope.aqi.settings.scale[index].value && $scope.aqi.settings.scale[index].src){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{\'cl.widget.aqi.m12\' | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="removeScaleFx(dataObj.index);" focus-me="true">\{{\'cm.btn.2\' | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      } else{
        $scope.removeScaleFx(index);
      }
    }
    $scope.removeScaleFx = function(index){
      if($scope.aqi.settings.scale.length < 10){
        $scope.aqi.settings.scale.splice(index, 1);
        ngDialog.close();
      } else{
        $scope.aqi.settings.scale.splice(index, 1);
        ngDialog.close();
        $scope.addScaleDisable = false;
      }

    }
    $scope.checkIfArrayIsValue = function(myArray){
      for(var i = 0;i < myArray.length;i++){
        if(myArray[i].value.length == 0){
          return true;
        }
      }
      return false;
    }
    $scope.checkIfArrayUniqueColor = function(myArray){
      for(var i = 0;i < myArray.length;i++){
        for(var j = 0;j < myArray.length;j++){
          if(i != j){
            if(myArray[i].src == myArray[j].src){;
              return true;
            }
          }
        }
      }
      return false;
    }
    $scope.checkIfArrayIsDiffPoint = function(myArray){
      var value = 0;
      for(var i = 0;i < myArray.length;i++){
        if(value > myArray[i].value){
          return true;
        } else{
          value = myArray[i].value
        }
      }
      return false; // means there are no duplicate values.
    }
    $scope.checkIfArrayIsUnique = function(myArray){
      for(var i = 0;i < myArray.length;i++){
        for(var j = 0;j < myArray.length;j++){
          if(i != j){
            if(myArray[i].value == myArray[j].value){
              return true;
            }
          }
        }
      }
      return false; // means there are no duplicate values.
    }

    $scope.saveAQIFx = function(){
      AQISrv.saveAQI($scope.aqi).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
    $rootScope.selectedTabFx = function(){}
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AmazonQuickSightController', AmazonQuickSightController);

  /** @ngInject */
  function AmazonQuickSightController($log, $rootScope, $scope, $state, $timeout, AmazonQuickSightSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.chLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";

    $scope.status = {dl:false, sl:false, gl:false, ds:false, ss:false, sg:false};
    $scope.aqsCopy = "";

    $scope.dList = [];
    $scope.sList = [];
    $scope.vList = [];

    $scope.settings = {
      settings:{reloadOpt:"a", reload:500}
    }
    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.aqs.settings = angular.copy($scope.defaultSettings.settings);
    }

    $scope.getList = function(caller){
      // console.warn("getList ",  caller);
      // console.warn($scope.aqs);
      
      if(caller == "d" || caller == "da"){
        $scope.status.sv = false;
        $scope.status.ss = false;
        $scope.status.ds = true;
        $scope.status.dl = true;

        AmazonQuickSightSrv.getDList().then(
          function(data){
            $scope.dList = data.dList;
            // console.warn("$scope.dList ", $scope.dList);
            $scope.status.dl = false;
            if($state.params.id && caller == "da"){
              $scope.getList("sa");
            }
          }, function(err){
            $log.error(err);
            $scope.status.dl = false;
          }
        );
      } else if(caller == "s" || caller == "sa"){
        $scope.status.sv = false;
        $scope.status.ss = true;
        $scope.status.sl = true;

        AmazonQuickSightSrv.getSList($scope.aqs.d.id).then(
          function(data){
            $scope.sList = data.sList;
            $scope.status.sl = false;

            if($state.params.id && caller == "sa"){
              for(var i=0; i<$scope.sList.length; i++){
                if($scope.sList[i].id == $scope.aqsCopy.s.id){
                  $scope.aqs.s = $scope.sList[i];
                  break;
                } else{
                  $scope.aqs.s = "";
                }
              }
              $scope.getList("v");
            } else{
              for(var i=0; i<$scope.sList.length; i++){
                if($scope.sList[i].id == $scope.aqsCopy.s.id){
                  $scope.aqs.s = $scope.sList[i];
                  $scope.getList("v");
                  break;
                } else{
                  $scope.aqs.s = "";
                }
              }
              // $scope.status.sv = true;
              // $scope.getList("v");
              
              // if($scope.aqsCopy.s && ($scope.aqsCopy.s.id == $scope.aqs.s.id)){
              //   $scope.aqs.s = angular.copy($scope.aqsCopy.s);
              // } else{
              //   $scope.aqs.s = "";
              // }
            }
          }, function(err){
            $log.error(err);
            $scope.status.sl = false;
          }
        );
      } else if(caller == "v"){
        $scope.status.sv = true;
        $scope.vList = $scope.aqs.s.visuals;
        // $scope.vList = $scope.sList.visuals;
        for(var i=0; i<$scope.vList.length; i++){
          if($scope.vList[i].id == $scope.aqsCopy.v.id){
            $scope.aqs.v = $scope.vList[i];
            break;
          } else{
            $scope.aqs.v = "";
          }
        }
      } else if(caller == "vc"){
        $scope.vList = $scope.aqs.s.visuals;
        for(var i=0; i<$scope.vList.length; i++){
          if($scope.vList[i].id == $scope.aqsCopy.v.id){
            $scope.aqs.v = $scope.vList[i];
            break;
          } else{
            $scope.aqs.v = "";
          }
        }
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      AmazonQuickSightSrv.getAQS($scope.decId).then(
        function(data){
          $scope.aqs = data;
          $scope.aqsCopy = angular.copy($scope.aqs);
          $scope.detailLoading = false;
          $scope.getList("da");
        }, function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.aqs = {
        label:"", d:"", s:"", v:"", dType:"s", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings)
      };
      $scope.getList("d");
    }

    $scope.aqsFx = function(){
      $scope.aqs.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.aqs.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.aqs.d == ""){
        $scope.errType = "dashboard";
        $scope.hasErr = true;
        $("#dashboard").focus();
      } else if($scope.aqs.s == ""){
        $scope.errType = "sheet";
        $scope.hasErr = true;
        $("#sheet").focus();
      } else if($scope.aqs.dType == "v" && (!$scope.aqs.v || $scope.aqs.v == "")){
        $scope.errType = "visual";
        $scope.hasErr = true;
        $("#visual").focus();
      } 
      else if($scope.aqs.settings.reloadOpt == "c" && $scope.aqs.settings.reload == null){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } 
      else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveAQSFx();
          }, 250);
        } else{
          $scope.saveAQSFx();
        }
      }
    }
    $scope.saveAQSFx = function(){
      $scope.aqs.s.visuals = "";
      AmazonQuickSightSrv.saveAQS($scope.aqs).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AlertController', AlertController);

  /** @ngInject */
  function AlertController($log, $rootScope, $scope, $state, $cookies, $timeout, ngDialog, ContentLibrarySrv, AlertSrv){
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;
    $scope.search = {text:""};

    $scope.toolbar = [
      ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'quote', 'paragraph', 'font-color', 'hilite-color', 'link', 'remove-format'],
      ['ordered-list', 'unordered-list', 'outdent', 'indent'],['left-justify', 'center-justify', 'right-justify'],
      ['format-block'],
      ['font'],
      ['font-size']
    ];

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.wcGetId = $scope.decId;
      AlertSrv.getAlert($scope.decId).then(
        function(data){
          $scope.alert = data;
          $scope.detailLoading = false;
          $scope.tim = $scope.alert.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.alert.otherinfo.bucket;
          if($scope.alert.otherinfo.mbucket && $scope.alert.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.alert.otherinfo.mbucket;
          }
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.alert = {
        label:"", title:"", dType:"t", description:"", content:[], whenDisplay:"i", deleteOnceRead:false,
        activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}
      };
    }

    $scope.alertFx = function(){
      $scope.alert.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.alert.dType == "t"){
        $scope.alert.content = [];
      } else{
        $scope.alert.description = "";
      }
      if($scope.alert.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.alert.dType == "t" && $scope.alert.description == ""){
        $scope.errType = "text";
        $scope.hasErr = true;
        $("#question").focus();
      } else if($scope.alert.dType == "c" && $scope.alert.content.length == 0){
        $scope.errType = "content";
        $scope.hasErr = true;
        $("#content").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveAlertFx();
          }, 250);
        } else{
          $scope.saveAlertFx();
        }
      }
    }
    $scope.saveAlertFx = function(){
      AlertSrv.saveAlert($scope.alert).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    /*Content*/
    $scope.contentPopover = {templateUrl:"content.html"};

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImgVid = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || item.type == "Video" || item.type == "Flash" || (item.splType && item.splType == "Image" || item.splType == "Video" || item.splType == "Flash")){
          $scope.curImgVid.push(item);
        }
      });
      $scope.contentList = $scope.curImgVid;
    }
    $scope.selectContentOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.search = {text:""};
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = {text:""};
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.alert.content = $scope.curContent;
        ngDialog.close();
      }
    }
    $scope.removeContentFx = function(){
      $scope.alert.content = [];
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function (event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "Flash" || item.type == "Video"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AgcController', AgcController);

  /** @ngInject */
  function AgcController($log, $rootScope, $scope, $state, $cookies, $timeout, AgcSrv){
    $scope.colorPicker = {b:false, hb:false, ht:false, rb:false, rt:false, arb:false, art:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;

    $scope.settings = {
      settings:{
        bg:"#ffffff", bga:1,
        headerBg:"#0b5394", headerBga:1, headerText:"#ffffff", headerFont:$scope.fontFamilySelected, headerSize:24,
        rowBg:"#ffffff", rowBga:1, rowText:"#444444", rowFont:$scope.fontFamily[56], rowSize:34,
        altBg:"#f3f3f3", altBga:1, altText:"#444444", altFont:$scope.fontFamily[56], altSize:34,
        reloadOpt:"a", reload:30, rotateOpt:"a", rotate:30
      },
      ctype:{bg:"monochrome", headerBg:"default", headerText:"monochrome", rowBg:"monochrome", rowText:"monochrome", altBg:"monochrome", altText:"monochrome"}
    };

    $scope.defaultSettings = angular.copy($scope.settings);
    $scope.settingsDefault = function(){
      $scope.agc.settings = angular.copy($scope.defaultSettings.settings);
      $scope.agc.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.wcGetId = $scope.decId;
      AgcSrv.getAgc($scope.decId).then(
        function(data){
          $scope.agc = data;
          $scope.detailLoading = false;
        }, function (err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.detailLoading = true;
      $scope.agc = {
        label:"", url:"", wc:"", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }
    AgcSrv.getWCList($scope.wcGetId).then(
      function(data){
        $scope.detailLoading = false;
        $scope.wcList = data.wc;
      }, function(err){
        $log.error(err);
      }
    );

    $scope.agcFx = function(){
      $scope.agc.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.agc.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.agc.url == ""){
        $scope.errType = "url";
        $scope.hasErr = true;
        $("#url").focus();
      } else if($scope.agc.wc == ""){
        $scope.errType = "wc";
        $scope.hasErr = true;
        $("#wc").focus();
      } else if($scope.agc.settings.reloadOpt == 'c' && !$scope.agc.settings.reload){
        $scope.errType = "reload";
        $scope.hasErr = true;
        $("#reload").focus();
      } else if($scope.agc.settings.rotateOpt == 'c' && !$scope.agc.settings.rotate){
        $scope.errType = "rotate";
        $scope.hasErr = true;
        $("#rotate").focus();
      } else if(!$scope.agc.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#hSize").focus();
      } else if(!$scope.agc.settings.rowSize){
        $scope.errType = "rSize";
        $scope.hasErr = true;
        $("#rowSize").focus();
      } else if(!$scope.agc.settings.altSize){
        $scope.errType = "aSize";
        $scope.hasErr = true;
        $("#altSize").focus();
      }
      else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveAgcFx();
          }, 250);
        } else{
          $scope.saveAgcFx();
        }
      }
    }
    $scope.saveAgcFx = function(){
      AgcSrv.saveAgc($scope.agc).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function (err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AchieversController', AchieversController);

  /** @ngInject */
  function AchieversController($log, $rootScope, $scope, $state, $cookies, $timeout, AchieversSrv){
    $scope.colorPicker = {ht:false, dt:false, pt:false, tt:false, dct:false, ct:false, cot:false};
    $scope.fid = localStorage.getItem("curFId");
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.chLoading = false;
    $scope.isPEOpen = false;
    $scope.encId = "";
    $scope.decId = "";
    $scope.wcList = [];
    $scope.wcGetId = 0;
    $scope.postList = [10,20,30,40,50];

    $scope.settings = {
      settings:{rotationOpt:"a", rotate:12, headerText:"#000000", headerFont:$scope.fontFamilySelected, dateText:"#666666", dateFont:$scope.fontFamilySelected, participantText:"#3d85c6", participantFont:$scope.fontFamilySelected, titleText:"#000000", titleFont:$scope.fontFamilySelected, descText:"#444444", descFont:$scope.fontFamilySelected, creatorText:"#3d85c6", creatorFont:$scope.fontFamilySelected, createdOnText:"#3d85c6", createdOnFont:$scope.fontFamilySelected, headerSize:30, dateSize:14, titleSize:20, descSize:16, participantSize:12, creatorSize:12, createdOnSize:10},
      ctype:{headerText:"monochrome", dateText:"monochrome", participantText:"default", titleText:"monochrome",  descText:"monochrome", creatorText:"default", createdOnText:"default"}
    }

    $scope.defaultSettings = angular.copy($scope.settings);

    $scope.settingsDefault = function(){
      $scope.achievers.settings = angular.copy($scope.defaultSettings.settings);
      $scope.achievers.ctype = angular.copy($scope.defaultSettings.ctype);
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.chLoading = true;
      AchieversSrv.getAchievers($scope.decId).then(
        function(data){
          $scope.achievers = data;
          $scope.detailLoading = false;
        }, function(err){
          $log.error(err);
        }
      );
    } else{
      $rootScope.tabView = true;
      $scope.chLoading = true;
      $scope.achievers = {
        label:"", eventType:"all", count:"10", dType:"t", activePeriod:{type:"a"}, permission:{type:$scope.auth.upreferences.defaultP},
        settings:angular.copy($scope.settings.settings),
        ctype:angular.copy($scope.settings.ctype)
      };
    }

    $scope.achieversFx = function(){
      $scope.achievers.fid = $scope.fid;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.achievers.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.achievers.eventType == ""){
        $scope.errType = "event";
        $scope.hasErr = true;
        $("#eventType").focus();
      } else if($scope.achievers.settings.rotationOpt == 'c' && !$scope.achievers.settings.rotate){
        $scope.errType = "rotation";
        $scope.hasErr = true;
        $("#tRotate").focus();
      } else if(!$scope.achievers.settings.headerSize){
        $scope.errType = "hSize";
        $scope.hasErr = true;
        $("#headerSize").focus();
      } else if(!$scope.achievers.settings.dateSize){
        $scope.errType = "dtSize";
        $scope.hasErr = true;
        $("#dateSize").focus();
      } else if(!$scope.achievers.settings.participantSize){
        $scope.errType = "pSize";
        $scope.hasErr = true;
        $("#participantSize").focus();
      } else if(!$scope.achievers.settings.titleSize){
        $scope.errType = "tSize";
        $scope.hasErr = true;
        $("#titleSize").focus();
      } else if(!$scope.achievers.settings.descSize){
        $scope.errType = "dSize";
        $scope.hasErr = true;
        $("#descSize").focus();
      } else if(!$scope.achievers.settings.creatorSize){
        $scope.errType = "cSize";
        $scope.hasErr = true;
        $("#creatorSize").focus();
      } else if(!$scope.achievers.settings.createdOnSize){
        $scope.errType = "coSize";
        $scope.hasErr = true;
        $("#createdOnSize").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveAchieversFx();
          }, 250);
        } else{
          $scope.saveAchieversFx();
        }
      }
    }
    $scope.saveAchieversFx = function(){
      AchieversSrv.saveAchievers($scope.achievers).then(
        function(data){
          $scope.saveProcessing = false;
          $state.go("hub.contentLibrary.c");
        }, function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('VersionsController', VersionsController);

  /** @ngInject */
  function VersionsController($log, $scope, $state, ngDialog, ContentLibrarySrv){
    $scope.selectContentFx = function(e, id, current, isCompleted, isApproved, approval){
      if($(e.target).hasClass("fa")){
        return true;
      }
      if(isCompleted && (isApproved || approval)){
        if(current == undefined){
          $scope.selectedContent = {cid:$scope.versions.cid, rid:id};
          $(e.currentTarget.parentElement).children("li").removeClass("ui-selected");
          $(e.currentTarget).addClass("ui-selected");
        }
      }
    }

    $scope.useConfirmOpen = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(angular.isUndefined($scope.selectedContent)){
        $scope.hasErr = true;
        $scope.errType = "empty";
      } else if(!$scope.versions.info.isSelectable){
        $scope.hasErr = true;
        $scope.errType = "selectable";
      } else if($scope.versions.info.isParentWriteProtected){
        $scope.hasErr = true;
        $scope.errType = "pWriteProtected";
      } else{
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.p_v.m3" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="useFx();" focus-me="true" ng-disabled="useProcessing"><span class="fa fa-repeat fa-spin" ng-if="useProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      }
    }
    $scope.useFx = function(){
      $scope.useProcessing = true;
      ContentLibrarySrv.updateVersions($scope.selectedContent).then(
        function(data){
          ngDialog.close();
          $scope.loadSelectedTab();
          $scope.useProcessing = false;
        },
        function(err){
          $log.error(err);
          $scope.useProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ReplaceController', ReplaceController);

  /** @ngInject */
  function ReplaceController($log, $scope, $rootScope, $filter, ngDialog, FileModelUploadSrv){
    $rootScope.uploading = false;
    $scope.msgRefresh = false;
    $rootScope.isSPSize = false;
    
    $scope.replaceFx = function(){
      $scope.hasErr = false;
      $scope.errMsg = "";
      if($scope.curImg == undefined){
        $scope.hasErr = true;
        $scope.errMsg = "empty";
      } else if(!$rootScope.isSPSize){
        //set isActionOnContent true if adv search applied
        if(localStorage.getItem("isAdvSearch")){
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.setItem("isActionOnContent", true);
        } else{
          localStorage.removeItem("isActionOnContent");
          localStorage.removeItem("curFilterObj");
          localStorage.removeItem("isAdvSearch");
        }
        $scope.msgRefresh = true;
        $scope.saveProcessing = true;
        $rootScope.uploading = true;
        FileModelUploadSrv.uploadFileAndData("contentLibrary/replace", $scope.replaceObj, $scope.curImg).then(
          function(data){
            $rootScope.uploading = false;
            ngDialog.close();
            $scope.saveProcessing = false;
            $rootScope.toastNotificationFx("info", data);
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $rootScope.toastNotificationFx("danger", {"code":5000});
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MoveController', MoveController);

  /** @ngInject */
  function MoveController($log, $scope, $rootScope, $state, $filter, ngDialog, ContentLibrarySrv){
    $scope.status = {isopen:false};
    $scope.moveProcessing = false;
    $scope.moveLoading = false;
    $rootScope.selectedT = 1;
    $scope.contentCount = 0;
    $scope.folderCount = 0;
    $scope.widgetCount = 0;
    $scope.serverList = [];
    $scope.moveItems = {};

    $scope.folderCount = $filter("filter")($scope.selectedItems, {type:"folder"}).length;
    angular.forEach($scope.selectedItems, function(item){
      if(item.type == "content" || item.type == "widget"){
        if($filter("filter")($scope.contentList, {id:item.id, type:"Widget"}).length){
          $scope.widgetCount = $filter("filter")($scope.contentList, {id:item.id, type:"Widget"}).length;
        } else{
          $scope.contentCount = $filter("filter")($scope.contentList, {id:item.id}).length;
        }
      }
    });

    $scope.allFalse = function(){
      $scope.arError = false;
      $scope.fError = false;
      $scope.cError = false;
      $scope.wError = false;
      $scope.hasErr = false;
    }

    $rootScope.selectedTabFx = function(){
      $scope.allFalse();
      if($scope.selectedT == 1){
        if($scope.moveObj.type == "copy"){
          if(!$scope.auth.upermissions.cf && $scope.folderCount > 0){
            $scope.fError = true;
          }
          if(!$scope.auth.upermissions.c && $scope.contentCount > 0){
            $scope.cError = true;
          }
          if(!$scope.auth.upermissions.w && $scope.widgetCount > 0){
            $scope.wError = true;
          }
        } else{
          $scope.allFalse();
        }
      } else{
        $scope.moveObj.server = null;
      }
      if($scope.selectedT == 2 && $scope.serverList.length == 0){
        $scope.moveLoading = true;
        ContentLibrarySrv.getServersList().then(
          function(data){
            $scope.serverList = data.servers;
            $scope.moveLoading = false;
          }
        );
      }
    };
    $rootScope.selectedTabFx();

    $scope.changeTypeFx = function(){
      if($scope.selectedT == 1){
        $rootScope.selectedTabFx();
      }
    }

    $scope.changeServerFx = function(){
      $scope.allFalse();
      if($scope.moveObj.server != null){
        if(!$scope.moveObj.server.ar){
          $scope.arError = true;
        }
        if(!$scope.moveObj.server.f && $scope.folderCount > 0){
          $scope.fError = true;
        }
        if(!$scope.moveObj.server.c && $scope.contentCount > 0){
          $scope.cError = true;
        }
        if(!$scope.moveObj.server.w && $scope.widgetCount > 0){
          $scope.wError = true;
        }
      }
    }

    $scope.moveFx = function(action){
      $scope.moveOtherProcessing = false;
      $scope.moveProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.selectedT == 1){
        $scope.moveItems = {type:"folder", target:$("input[name='treeOpt']:checked").val(), selectedItems:$scope.selectedItems};
      } else{
        $scope.moveItems = {type:"server", target:$scope.moveObj.server, selectedItems:$scope.selectedItems};
      }
      if($scope.selectedT == 1 && $scope.moveItems.target == null){
        $scope.hasErr = true;
        $scope.errType = "folder";
        $("#folder").focus();
      } else if($scope.selectedT == 2 && $scope.moveObj.server == null){
        $scope.hasErr = true;
        $scope.errType = "server";
        $("#server").focus();
      } else if($scope.selectedT == 2 && $scope.moveObj.type == "move"){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
              <div class="panel-body">{{"cl.p_m.m10" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="moveOtherFx();" focus-me="true" ng-disabled="moveOtherProcessing"><span class="fa fa-repeat fa-spin" ng-if="moveOtherProcessing" aria-hidden="true"></span>{{"cl.p_m.8" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
          preCloseCallback:function(){
            $scope.moveOtherProcessing = false;
          }
        });
      } else{
        $scope.moveProcessing = true;
        if(action == "move"){
          $scope.moveOtherFx();
        } else if(action == "copy"){
          if($scope.moveItems.selectedItems.length){
            $scope.moveItems.selectedItems.forEach(function(item){
              if(item.type == "excelfolder"){
                item.type = "folder";
              }
            })
          }
          ContentLibrarySrv.copy($scope.moveItems).then(
            function(data){
              ngDialog.close();
              $scope.loadSelectedTab();
              $scope.reloadTree();
              $scope.moveProcessing = false;
            },
            function(err){
              $scope.moveProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.moveOtherFx = function(){
      $scope.moveOtherProcessing = true;
      ContentLibrarySrv.move($scope.moveItems).then(
        function(data){
          if(data.code == 8333){
            $scope.fList = data.f;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>\
                      {{\'cm.asn.m9\' | translate}}\
                      <h5 class="panel-inner-tab marT25 marB10">{{\'cm.asn.7\' | translate}}</h5>\
                      <div ng-if="!fList.length" class="msg-warning">{{\'cm.asn.m10\' | translate}}</div>\
                      <div class="table table-sm" ng-if="fList.length">\
                        <div class="row th">\
                          <div class="col-xs-6">{{\'cm.brief.1\' | translate}}</div>\
                          <div class="col-xs-6">{{\'cl.brief.8\' | translate}}</div>\
                        </div>\
                        <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(450)}}px">\
                          <div class="row" ng-repeat="f in fList">\
                            <div class="col-xs-6">{{f.label}}</div>\
                            <div class="col-xs-6 word-break"><span class="fa fa-home marR5" aria-hidden="true"></span>{{f.path}}</div>\
                          </div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeAll();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:580,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else{
            ngDialog.close();
            $scope.loadSelectedTab();
            $scope.reloadTree();
          }
        },
        function(err){
          $scope.moveOtherProcessing = false;
          $scope.moveProcessing = false;
          $log.error(err);
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MetaTagsController', MetaTagsController);

  /** @ngInject */
  function MetaTagsController($log, $scope, $rootScope, $state, ngDialog, ContentLibrarySrv){
    $scope.curMT = {};
    $scope.addMTFx = function(){
      ContentLibrarySrv.updateMT({id:$rootScope.selectedItems[0].id, tag:$scope.curMT.tag}).then(
        function(data){
          $scope.curMT.tag = "";
          $scope.mtObj.tags = data.tags;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Second ngDialog close*/
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.confirmMTOpen = function(index){
      $scope.mtCObj = {index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.p_mt.m2" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteMTFx();" focus-me="true" ng-disabled="mtProcessing"><span class="fa fa-repeat fa-spin" ng-if="mtProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.deleteMTFx = function(){
      $scope.mtProcessing = true;
      ContentLibrarySrv.deleteMT({id:$rootScope.selectedItems[0].id, tag:$scope.mtObj.tags[$scope.mtCObj.index]}).then(
        function(data){
          $scope.mtObj.tags = data.tags;
          ngDialog.close($scope.confirmDialog);
          $scope.mtProcessing = false;
        },
        function(err){
          $log.error(err);
          $scope.mtProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FolderCUController', FolderCUController);

  /** @ngInject */
  function FolderCUController($log, $scope, $rootScope, $state, ngDialog, $timeout, $cookies, $interval, ContentLibrarySrv, FileModelUploadSrv){
    $scope.folder = {info:{fid:$scope.ngDialogData.fid}};
    $scope.actionFrom = $scope.ngDialogData.actionFrom;
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.curStatus = {step:"a", isVerified:false};
    $scope.status = {ssOpen:false, sfOpen:false};
    $scope.authProcessing = false;
    $rootScope.selectedSPfId = 0;
    $rootScope.selectedODfId = 0;
    $scope.checkDisable = false;
    $scope.isLibrary = false;
    $scope.isPEOpen = false;
    $scope.folderList = [];
    $scope.spStep = "auth";
    $scope.decId = "";
    $scope.sitesLoading = false;

    $scope.hasErrSP = false;
    $scope.errTypeSP = "";
    $scope.userInfo = "";
    $scope.sitesLoading = false;

    /*Google Drive*/
    $scope.gdHasErr = false;
    $scope.gdErrType = "";
    $scope.gdFolder = "";
    $scope.gdSelectOptFx = function(caller){
      $scope.curStatus.isVerified = false;
      $scope.authProcessing = false;
      $scope.folderLoading = false;
      $scope.gdHasErr = false;
      $scope.gdErrType = "";
      $scope.gdFolder = "";

      if($scope.folder.info.gdType == "sp"){
        $rootScope.curFType = "gdSP";
        $scope.folderLoading = true;
      } else if($scope.folder.info.gdType == "oauth"){
        $rootScope.curFType = "oauth";
      }
      
      if(caller == "first"){
        $scope.authProcessing = true;
        ContentLibrarySrv.getGdUrl($scope.folder.info.gdType).then(
          function(data){
            $scope.folderLoading = false;
            $scope.authProcessing = false;
            if(!data || data.status_code == 9999 || data.code == 8824){
              $scope.gdHasErr = true;
              $scope.gdErrType = "dataEmpt";
              return;
            }
            if($scope.folder.info.gdType == "sp"){
              $scope.gdFolder = data.data;
              $rootScope.driveId = data.drive_id;
            } else{
              $scope.gdUrl = data.url;
              $scope.openUrlFx(626, 450, 'gd');
            }
          },
          function(err){
            $scope.folderLoading = false;
            $scope.authProcessing = false;
            $log.error(err);
          }
        );
      } else{
        // $scope.getGDFolderFx();
      }
    }

    window.addEventListener("message", function(event){
      if(event.data && event.data.id){
        $rootScope.driveId = event.data.id;
        $scope.getGDFolderFx($scope.driveId);
      } else{
        $scope.curStatus.step = "a";
        $scope.errType = "authFailed";
        $scope.curStatus.isVerified = false;
        $scope.hasErr = true;
      }
    }, false);
    

    $scope.authenticationTypeFx = function(caller){
      $scope.hasErrSP = false;
      $scope.errTypeSP = "";

      if(caller == 'ssp'){
        $scope.sitesLoading = true;
        $scope.folder.info.auth = "ssp";
        $scope.folder.data = {url:"", sites:"", library:"", folder:""};
        $scope.isLibrary = false;
        $scope.curStatus.isVerified = false;        
        ContentLibrarySrv.getSpUrl($scope.curFolderId, caller).then(
          function(data){
            $scope.sitesLoading = false;
            if(data.code == 56000){
              $scope.errTypeSP = "spAuthTC";
              $scope.hasErrSP = true;
              return;
            } else if(data.code == 56001){
              $scope.errTypeSP = "spAuthC";
              $scope.hasErrSP = true;
              return;
            }
            $scope.curStatus.isVerified = true;        
            $scope.authProcessing = true;
            $scope.curStatus.step = "sl";
            $scope.sitesList = data.sp.sites;
          },
          function(err){
            $scope.authProcessing = true;
            $scope.sitesLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.curStatus.step = "a";
        $scope.folder.data = {url:"", sites:"", library:"", folder:""};
        $scope.isLibrary = false;
        $scope.curStatus.isVerified = false;
        ContentLibrarySrv.getSpUrl().then(
          function(data){
            $scope.authProcessing = false;
            $scope.spUrl = data.url;
          },
          function(err){
            $scope.authProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    // TODO create the variables fo the new UI of the SS sited and library
    $scope.listIsOpen = {site:false, lib:false}
    $scope.search = {site:"", lib:""};


    $scope.hasErrSP = false;
    $scope.errTypeSP = "";

    $scope.authenticationTypeFx = function(caller){
      $scope.hasErrSP = false;
      $scope.errTypeSP = "";

      if(caller == 'ssp'){
        $scope.sitesLoading = true;
        $scope.folder.info.auth = "ssp";
        $scope.folder.data = {url:"", sites:"", library:"", folder:""};
        $scope.isLibrary = false;
        $scope.curStatus.isVerified = false;        
        ContentLibrarySrv.getSpUrl($scope.curFolderId, caller).then(
          function(data){
            $scope.sitesLoading = false;
            if(data.code == 56000){
              $scope.errTypeSP = "spAuthTC";
              $scope.hasErrSP = true;
              return;
            } else if(data.code == 56001){
              $scope.errTypeSP = "spAuthC";
              $scope.hasErrSP = true;
              return;
            }
            $scope.curStatus.isVerified = true;        
            $scope.authProcessing = true;
            $scope.curStatus.step = "sl";
            $scope.sitesList = data.sp.sites;
          },
          function(err){
            $scope.authProcessing = true;
            $scope.sitesLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.curStatus.step = "a";
        $scope.folder.data = {url:"", sites:"", library:"", folder:""};
        $scope.isLibrary = false;
        $scope.curStatus.isVerified = false;
        ContentLibrarySrv.getSpUrl().then(
          function(data){
            $scope.authProcessing = false;
            $scope.spUrl = data.url;
          },
          function(err){
            $scope.authProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    // TODO create the variables fo the new UI of the SS sited and library
    $scope.listIsOpen = {site:false, lib:false}
    $scope.search = {site:"", lib:""};

    if($scope.ngDialogData && $scope.ngDialogData.id){
      $scope.curStatus.isVerified = true;
      $scope.folder.info = $scope.ngDialogData;
      $scope.decId = $scope.ngDialogData.id;
      ContentLibrarySrv.getFolderDetails($scope.ngDialogData.id).then(
        function(data){
          $scope.folder = data;
          $scope.folder.info.fType = $scope.ngDialogData.fType;
          if($scope.folder.info.sf){
            $scope.sfObj = {s:$scope.folder.info.data.server.id, f:$scope.folder.info.data.folder.id};
            $scope.sfObjEdit = {s:$scope.folder.info.data.server, f:$scope.folder.info.data.folder};
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      $scope.authProcessing = false;
      if($scope.ngDialogData.fType == "sf"){
        $scope.authProcessing = true;
        $scope.sfObj = {s:"", f:""};
        $scope.folder = {info:{id:0, fid:$scope.ngDialogData.fid, label:"", fType:$scope.ngDialogData.fType}, data:{serverid:"", folderid:""}, permission:{type:$scope.auth.upreferences.defaultP}};
      } if($scope.ngDialogData.fType == "gd"){/*Google Drive*/
        var gdType = "";
        if($scope.auth.uservices.gd.sp){
          $scope.authProcessing = true;
          gdType = "sp";  
        } else if($scope.auth.uservices.gd.oauth){
          gdType = "oauth";
        }
        $scope.folder = {info:{id:0, fid:$scope.ngDialogData.fid, label:"", fType:$scope.ngDialogData.fType, gdType:gdType}, permission:{type:$scope.auth.upreferences.defaultP}};
      } else{
        $scope.authProcessing = true;
        $scope.folder = {info:{id:0, fid:$scope.ngDialogData.fid, label:"", fType:$scope.ngDialogData.fType}, permission:{type:$scope.auth.upreferences.defaultP}};
      }

      if($scope.folder.info.fType === "sp"){
        if($scope.auth.uservices.msspApp == 'ca'){
          $scope.authenticationTypeFx("ssp");
        } else{
          $scope.authenticationTypeFx("u");
        }
      } else if($scope.folder.info.fType === "od"){
        $scope.folder.data = {folder:""};
        $scope.curStatus.isVerified = false;
        ContentLibrarySrv.getOdUrl().then(
          function(data){
            $scope.authProcessing = false;
            $scope.odUrl = data.url;
            // $scope.odrdUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri="+data.url;
            // $scope.odrdUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
          },
          function(err){
            $scope.authProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.folder.info.fType === "gd" && $scope.auth.uservices.gd.sp){/*Google Drive*/
        $scope.gdSelectOptFx("first");//First call
      }
    }

    $scope.ssChange = function(){
      $rootScope.curFType = "move";
      $scope.treeLoading = true;
      ContentLibrarySrv.sharedFolder($scope.sfObj.s.id).then(
        function(data){
          $scope.treeLoading = false;
          $scope.sfList = data.tree;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.openUrlFx = function(w, h, caller){
      $scope.gdfCaller = caller;//TODO It is in use?
      $scope.fCaller = caller;
      if(caller == "spRe" || caller == "spReOu"){
        $scope.popProcessing = true;
        $scope.fCaller = "sp";
      }
      if(caller == "odRe" || caller == "odReOu"){
        $scope.popProcessing = true;
        $scope.fCaller = "od";
      }
      if(caller == "gdRe" || caller == "gdReOu"){/*Google Drive*/
        $scope.popProcessing = true;
        $scope.fCaller = "gd";
      }

      if($scope.fCaller != "gd"){
        ContentLibrarySrv.clearSession($scope.fCaller).then(
          function(data){
            $scope.left = (screen.width/2)-(w/2);
            $scope.top = (screen.height/2)-(h/2);

            $scope.authProcessing = true;

            $scope.hasErr = false;
            $scope.errType = "";
            if(caller == "spReOu" || caller == "odReOu"){
              var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ $scope.top +', left='+ $scope.left);
            }
            $scope.timer = setTimeout(
              function(){
                if($scope.timer){
                  clearTimeout($scope.timer);
                }
                if(caller != "sp" && caller != "od"){
                  $scope.popProcessing = false;
                  ngDialog.close($scope.confirmDialog);
                  $scope.folder.data = {url:"", sites:"", library:"", folder:""};
                  $scope.odFolder = {};
                  if(caller == "spReOu" || caller == "odReOu"){
                    newWindow.close();
                  }
                }
                if($scope.fCaller == "sp"){
                  $scope.childWindow = window.open($scope.spUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
                } else if($scope.fCaller == "od"){
                  $scope.childWindow = window.open($scope.odUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
                }
                $scope.childWindowInt = $interval($scope.checkChild, 500);
            }, 2000);
            return false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.fCaller == "gd"){/*Google Drive*/
        // var newWindow = "";
        // $scope.timer1 = setTimeout(
        //   function(){
        //     if($scope.timer1){
        //       clearTimeout($scope.timer1);
        //     }
        var timerVal = 100;
        if(caller == "gdReOu"){
          var newWindow = window.open("https://accounts.google.com/Logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ $scope.top +', left='+ $scope.left);
          timerVal = 1000;
        }
        // }, 1000);

        if(caller != "gd"){
          $scope.popProcessing = false;
          ngDialog.close($scope.confirmDialog);
        }
        $scope.timer = setTimeout(
          function(){
            if($scope.timer){
              clearTimeout($scope.timer);
            }
            if(caller == "gdReOu"){
              newWindow.close();
            }
            $scope.childWindow = window.open($scope.gdUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
            $scope.childWindowInt = $interval($scope.checkChild, 500);
        }, timerVal);
      }
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'spRe\' || reAuthObj == \'odRe\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'spReOu\' || reAuthObj == \'odReOu\'">{{"cl.widget.msg.10.2" | translate}}</span>\
              <span ng-if="reAuthObj == \'gdRe\'">{{"cl.widget.msg.10.1" | translate}}</span><!--Google Drive-->\
              <span ng-if="reAuthObj == \'gdReOu\'">{{"cl.widget.msg.10.3" | translate}}</span><!--Google Drive-->\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.getGDFolderFx = function(gdDId){
      $scope.gdFolder = "";
      $scope.folderLoading = true;
      ContentLibrarySrv.getGdFolder($scope.folder.info.gdType, gdDId).then(
        function(data){
          $scope.folderLoading = false;
          $scope.authProcessing = false;
          if(data.code){
            $scope.errType = "authFailed";
            $scope.curStatus.isVerified = false;
            $scope.hasErr = true;
          } else{
            $scope.gdFolder = data.data;
            $scope.userInfo = data.owners;
            $scope.curStatus.isVerified = true;
          }
          // $scope.curStatus.step = "sl";
          // $scope.curStatus.step = "a";
          // if($scope.odFolder.od.folders[0].id){
          //   $scope.selectednodeGD = $scope.odFolder.od.folders[0].id;
          // }
        },
        function(err){
          $scope.folderLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        if($scope.fCaller == "sp"){
          ContentLibrarySrv.getSpSites().then(
            function(data){
              $scope.authProcessing = false;
              if(data.isClosed){
                $scope.curStatus.step = "sl";
                $scope.sitesList = data.sp.sites;
                $scope.curStatus.isVerified = true;
              } else{
                $scope.curStatus.step = "a";
                $scope.errType = "authFailed";
                $scope.curStatus.isVerified = false;
                $scope.hasErr = true;
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.fCaller == "od"){
          ContentLibrarySrv.getVerify().then(
            function(data){
              $scope.authProcessing = false;
              $scope.hasErr = false;
              $scope.errType = "";
              if(data.code == 8194){
                $scope.errType = "odEmpty";
                $scope.curStatus.isVerified = false;
                $scope.hasErr = true;
                return;
              }
              if(data.code == 8195){
                $scope.curStatus.step = "a";
                $scope.errType = "authFailed";
                $scope.hasErr = true;
                return;
              }
              if(data.code == 8196){
                $scope.errType = "odNotExist";
                $scope.curStatus.isVerified = false;
                $scope.hasErr = true;
                return;
              } else{
                if(data.isClosed){
                  $scope.odFolder = data;
                  $rootScope.driveId = $scope.odFolder.info.driveId;
                  $scope.curStatus.isVerified = true;
                  $scope.folder.data = data.info;
                  if($scope.odFolder.od.folders[0].id){
                    $scope.selectednodeOD = $scope.odFolder.od.folders[0].id;
                  }
                } else{
                  $scope.curStatus.step = "a";
                  $scope.errType = "authFailed";
                  $scope.curStatus.isVerified = false;
                  $scope.hasErr = true;
                }
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.fCaller == "gd"){/*Google Drive*/
          // $scope.getGDFolderFx();
        }
      }
    }

    /*For click on tree folder view*/
    $scope.$on('treeId', function(event, treeFolderId, splId, type, treeId){
      if(treeId == "sharedFolderList"){
        $scope.sfObj.f = treeFolderId;
      }
    });

    $scope.folderCUFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.decId == "" && $scope.folder.info.fType == "sp"){
        $rootScope.selectedSPfId = $("input[name='treeOpt']:checked").val();
        $scope.folder.data.folder = $rootScope.selectedSPfId;
      } else if($scope.decId == "" && $scope.folder.info.fType == "od"){
        $rootScope.selectedODfId = $("input[name='treeOpt']:checked").val();
        $scope.folder.data.folder = $rootScope.selectedODfId;
      } else if($scope.decId == "" && $scope.folder.info.fType == "sf"){
        $scope.folder.data = {serverid:$scope.sfObj.s.id, folderid:$("input[name='treeOpt']:checked").val()};
      } else if($scope.decId == "" && $scope.folder.info.fType == "gd"){
        $scope.folder.data = {folderid:$("input[name='treeOpt']:checked").val(), drive_id:$scope.driveId};
      }

      if($scope.folder.info.label == undefined || $scope.folder.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      } else if($scope.folder.info.fType == "sp" && !$scope.curStatus.isVerified){
        $scope.errType = "authFirst";
        $scope.hasErr = true;
        $("#spBtn").focus();
        return;
      } else if($scope.folder.info.fType == "od" && !$scope.curStatus.isVerified){
        $scope.errType = "authFirst";
        $scope.hasErr = true;
        $("#odBtn").focus();
        return;
      } else if($scope.decId == "" && $scope.curStatus.step == "sl" && $scope.folder.info.fType == "sp" && !$scope.folder.data.sites.id){
        $scope.errType = "sites";
        $scope.hasErr = true;
        $("#sites").focus();
        return;
      } else if($scope.decId == "" && $scope.curStatus.step == "sl" && $scope.folder.info.fType == "sp" && !$scope.folder.data.library.id){
        $scope.errType = "library";
        $scope.hasErr = true;
        $("#library").focus();
        return;
      } else if($scope.decId == "" && $scope.folder.info.fType == "sp" && !$scope.folder.data.folder){
        $scope.errType = "folder";
        $scope.hasErr = true;
        $("#folder").focus();
        return;
      } else if($scope.decId == "" && $scope.folder.info.fType == "od" && !$scope.folder.data.folder){
        $scope.errType = "folder";
        $scope.hasErr = true;
        $("#folder").focus();
        return;
      } else if($scope.decId == "" && $scope.folder.info.fType == "sf" && !$scope.folder.data.serverid){
        $scope.errType = "ss";
        $scope.hasErr = true;
        $("#ss").focus();
        return;
      } else if($scope.decId == "" && $scope.folder.info.fType == "sf" && !$scope.folder.data.folderid){
        $scope.errType = "sf";
        $scope.hasErr = true;
        $("#sf").focus();
        return;
      } else if($scope.decId == "" && $scope.folder.info.fType == "gd" && !$scope.folder.data.folderid){
        $scope.errType = "sf";
        $scope.hasErr = true;
        $("#sf").focus();
        return;
      } else{
        $scope.saveProcessing = true;
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.folderCU();
          }, 250);
        } else{
          $scope.folderCU();
        }
      }
    }

    $scope.folderCU = function(){
      if($scope.decId == "" && $scope.folder.info.fType == "sp"){
        $scope.spFolderData = angular.copy($scope.folder.data);
        $scope.folder.data = {};
        $scope.folder.data.refresh_token = $scope.spFolderInfo.refresh_token;
        $scope.folder.data.access_token = $scope.spFolderInfo.access_token;
        $scope.folder.data.expired_at = $scope.spFolderInfo.expired_at;
        $scope.folder.data.libId = $scope.spFolderData.library.id;
        $scope.folder.data.siteId = $scope.spFolderData.sites.id;
        $scope.folder.data.folder = $scope.spFolderData.folder;
        $scope.folder.info.spType = "graph";
      }
      if($scope.folder.info.fType == 'ef' && !angular.isUndefined($scope.curData)){
        FileModelUploadSrv.uploadFileAndData("contentLibrary/folders", $scope.folder, $scope.curData).then(
          function(data){
            ngDialog.close();
            $scope.loadSelectedTab();
            $scope.reloadTree();
            $scope.saveProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      } else{
        ContentLibrarySrv.folderCU($scope.folder).then(
          function(data){
            ngDialog.close();
            if($scope.actionFrom == "pin"){
              $rootScope.loadPinnedItems();
            } else{
              $scope.loadSelectedTab();
              $scope.reloadTree();
            }
            $scope.saveProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.spSelectFx = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "lib"){
        $scope.isLibrary = false;
        $scope.libraryLoading = true;
        // TODO when select the sites
        $scope.folder.data.library = "";
        $scope.folder.data.sites = angular.fromJson($scope.folder.data.sites);
        $scope.listIsOpen.site = !$scope.listIsOpen.site;
        ContentLibrarySrv.getSpLibraries($scope.folder.data.sites.id, $scope.folder.info.auth).then(
          function(data){
            $scope.libraryLoading = false;
            $scope.curStatus.step = "sl";
            $scope.isLibrary = true;
            $scope.libraryList = data.sp.lib;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "folder"){
        if(!$scope.folder.data.sites && !$scope.folder.data.sites.id){
          $scope.hasErr = true;
          $scope.errType = "sites";
          $("#sites").focus();
        } else if(!$scope.folder.data.library.id){
          $scope.hasErr = true;
          $scope.errType = "library";
          $("#library").focus();
        } else{
          $scope.spProcessing = true;
          $rootScope.siteId = $scope.folder.data.sites.id;
          $rootScope.libId = $scope.folder.data.library.id;
          ContentLibrarySrv.getSpFolder($scope.folder.data.sites.id, $scope.folder.data.library.id, $scope.folder.info.auth).then(
            function(data){
              $scope.spProcessing = false;
              $scope.curStatus.step = "f";
              $scope.folderList = data.sp.dir;
              $scope.spFolderInfo = data.info;
              if($scope.folderList[0].id){
                $scope.selectednode = $scope.folderList[0].id;
              }
            },
            function(err){
              $log.error(err);
              $scope.spProcessing = false;
            }
          );
        }
      }
    }

    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
    }

    $scope.backBtnFx = function(){
      $scope.curStatus.step = "sl";
    }

    $scope.downloadSheetFx = function(url){
      $rootScope.linkOpenObj = {loading:false, url:url, surl:""};
      $scope.linkOpenFx('d');
    }

    // Todo when select the library
    $scope.librarySelectFx = function(){
      $scope.folder.data.library = angular.fromJson($scope.folder.data.library);
      $scope.listIsOpen.lib = !$scope.listIsOpen.lib;
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentEditController', ContentEditController);

  /** @ngInject */
  function ContentEditController($log, $scope, $rootScope, $state, $timeout, ngDialog, ContentLibrarySrv){
    $scope.content = $scope.ngDialogData;
    $scope.isPEOpen = false;
    $scope.contentEditFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.content.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        $scope.saveProcessing = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.updateContentEditFx();
          }, 250);
        } else{
          $scope.updateContentEditFx();
        }
      }
    }
    $scope.updateContentEditFx = function(){
      $scope.saveProcessing = true;
      ContentLibrarySrv.updateContentEdit($scope.content).then(
        function(data){
          $scope.saveProcessing = false;
          ngDialog.close();
          if($scope.content.actionFrom == 'pin'){
            $rootScope.loadPinnedItems();
          } else {
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }
  }
})();
angular.module('hub').service('SettingsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.primeAdmin = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/primeAdmin/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePrimeAdmin = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/primeAdmin", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getNotifications = function(id){
    httpReq = $http.get($rootScope.apiHost + "mySettings/notifications/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateNotifications = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/notifications", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPollingFrequency = function(id){
    httpReq = $http.get($rootScope.apiHost + "mySettings/pollingFrequency/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePollingFrequency = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/pollingFrequency", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDefaultClientImage = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/defaultClientImage/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTelexSettings = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/telaxsetting/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateTelexSettings = function(sid, obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/telaxsetting/" + sid, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAvailableExtension = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/availableExtension/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateAvailableExtension = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/availableExtension", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPermissions = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/serverPermissions/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePermissions = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/serverPermissions", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMusicChoice = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/musicChoice/category/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateMusicChoice = function(sid, obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/musicChoice/category/" + sid, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCustomRoom = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/meetingCustomRoom/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSSO = function(sid, type){
    httpReq = $http.get($rootScope.apiHost + "mySettings/sso/" + type + "/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateSSO = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/sso", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWebOS = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/webos/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateWebOS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/webos", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateCustomRoom = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/meetingCustomRoom", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteCustomRoom = function(id){
    httpReq = $http.delete($rootScope.apiHost + "mySettings/meetingCustomRoom/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDMBSettings = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/dmb/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addBrand = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/dmb", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addDMBUser = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/dmb/users", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.sendPwd = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mysettings/dmb/users/pwd", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteDMBbu = function(id, sid, caller){
    if(caller == "b"){
      httpReq = $http.delete($rootScope.apiHost + "mySettings/dmb/"+ id +"/"+ sid);
    } else{
      httpReq = $http.delete($rootScope.apiHost + "mySettings/dmb/users/"+ id +"/"+ sid);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateTheme = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/dmb/scss", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTheme = function(brand){
    httpReq = $http.get($rootScope.apiHost + "mySettings/dmb/scss/"+brand);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resetTheme = function(brand){
    httpReq = $http.delete($rootScope.apiHost + "mySettings/dmb/scss/"+brand);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.DMBDevice = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/dmb/devices/"+sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIoTCSettings = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/iotc/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateIoTCSettings = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/iotc", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDP = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/dp/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/dp/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteDP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/dp/delete", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSortDP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/dp/sort", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getDMBLabels = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/dmb/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDMBLabels = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/dmb/settings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resetDMBLabels = function(sid){
    httpReq = $http.delete($rootScope.apiHost + "mySettings/dmb/settings/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.webosDefault = function(){
    httpReq = $http.get($rootScope.apiHost + "mySettings/webos_default");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.registrationKey = function(key){
    httpReq = $http.post($rootScope.apiHost + "mySettings/drsk", key);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.appMenu = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/appMenu/settings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCoD = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/cod/settings/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCoD = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/cod/settings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*AWS IoT*/
  this.getPlacements = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/awsIoT1Click/"+sid+"/placements");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPlacement = function(sid, pl){
    httpReq = $http.get($rootScope.apiHost + "mySettings/awsIoT1Click/"+sid+"/placements/"+pl);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePlacement = function(sid, pl, obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/awsIoT1Click/"+sid+"/placements/"+pl, obj);
    $rootScope.toastNotificationFx("info", {code:1710102});
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePlacements = function(sid, obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/awsIoT1Click/"+sid+"/placements", obj);
    $rootScope.toastNotificationFx("info", {code:1710101});
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCBSettings = function(sid){
    httpReq = $http.get($rootScope.apiHost + "mySettings/cb/settings/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateCBSettings = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/cb/settings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resetCBSettings = function(sid){
    httpReq = $http.put($rootScope.apiHost + "mySettings/cb/reset/"+ sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAuthUrl = function(){
    httpReq = $http.get($rootScope.apiHost + "videoIndexer/authorize");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAuthUrlCallback = function(){
    httpReq = $http.get($rootScope.apiHost + "videoIndexer/authorize/status");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*R&G Reports*/
  this.rgReports = function(caller, obj){
    var apiPoint = "";
    if(caller == "rgl"){
      if(obj.rType == "l"){
        apiPoint = "loginCount";
      }
    } else if(caller == "rgc"){
      if(obj.rType == "cc"){
        apiPoint = "contentCount";
      } else if(obj.rType == "cnc"){
        apiPoint = "canvaContentCount";
      } else if(obj.rType == "pc"){
        apiPoint = "pptContentCount";
      } else if(obj.rType == "dc"){
        apiPoint = "deletedContent";
      } else if(obj.rType == "sc"){
        apiPoint = "scheduledContentCount";
      } else if(obj.rType == "wc"){
        apiPoint = "widgetCount";
      }
    } else if(caller == "rgs"){
      if(obj.rType == "es"){
        apiPoint = "scheduleEditedCount";
      } else if(obj.rType == "exs"){
        apiPoint = "expiredSchedule";
      } else if(obj.rType == "st"){
        apiPoint = "scheduleType";
      }
    }
    httpReq = $http.post($rootScope.apiHost +"analytics/"+ apiPoint, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
    return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);

angular.module('hub').service('AddToDashboardSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
    var httpReq;
    this.getDashboardUser = function(id){
      httpReq = $http.get($rootScope.apiHost + "mySettings/availableUsers");
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.saveAddUser = function(obj){
      httpReq = $http.post($rootScope.apiHost + "mySettings/availableUsers", obj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.makeDefault = function(){
      httpReq = $http.put($rootScope.apiHost + "mySettings/makeDefaultDashboard");
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.handleSuccess = function(response){
      $rootScope.toastNotificationFx("info", response.data);
      return (response.data);
    }
    this.handleError = function(response){
      $rootScope.toastNotificationFx("danger", {
        "code": 5000
      });
      if(!angular.isObject(response.data) || !response.data.message){
        return ($q.reject("An unknown error occurred."));
      }
      return ($q.reject(response.data.message));
    }
  }]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($log, $scope, $rootScope, $state, $cookies, $filter, $window, $timeout, ngDialog, SettingsSrv, ReportsSrv, CommonSrv, DevicesSrv, DeviceControlSrv, FileModelUploadSrv, MySettingsSrv, ContentLibrarySrv){
    $scope.numRegEx = /^[0-9]+$/;
    $scope.saveProcessing = false;
    $scope.dmbNewUser = {label:"", email:"", pwd:"", sid:$scope.settingsObj.sid, brand:"", devices:[]};
    $scope.curDSelected = [];
    $scope.dmbStoreObj = {store:""};
    $scope.curUrl = $window.location.origin;
    $scope.theme = {data:""};

    $scope.selectTabFx = function(caller){
      $scope.settingLoading = true;
      $scope.selectTab = caller;
      $scope.hasErr = false;
      if(caller == 1){
        $scope.primeObj = {};
        SettingsSrv.primeAdmin($scope.settingsObj.sid).then(
          function(data){
            $scope.primeObj = data;
            if($scope.primeObj.info){
              $scope.tim = $scope.primeObj.info.timthumb;
              $scope.bucket = $scope.detailBucket = $scope.primeObj.info.bucket;
              if($scope.primeObj.info.mbucket && $scope.primeObj.info.mbucket != ""){
                $scope.detailBucket = $scope.primeObj.info.mbucket;
              }
            }
            $scope.settingLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 2){
        $scope.isPEOpen = false;
        SettingsSrv.getNotifications($scope.settingsObj.sid).then(
          function(data){
            $scope.notifications = data;
            $scope.settingLoading = false;
            if($scope.notifications.offline.startTime && $scope.notifications.offline.endTime){
              $scope.offline = {startTime:$filter("momentTime")($scope.notifications.offline.startTime), endTime:$filter("momentTime")($scope.notifications.offline.endTime), timeout:$scope.notifications.offline.timeout, isExcluded:$scope.notifications.offline.isExcluded, threshold:$scope.notifications.offline.threshold};
            } else{
              //before $scope.offline.timeout value was 5, but we change it to dynamic
              $scope.offline = {startTime:moment().format(), endTime:moment().add(5, "m").format(), timeout:$scope.notifications.offline.timeout, isExcluded:$scope.notifications.offline.isExcluded, threshold:$scope.notifications.offline.threshold};
            }

            for(var i=0; i<$scope.notifications.email.length; i++){}

            $scope.emailArr = [];
            angular.forEach($scope.notifications.email, function(item, index){
              if(item.id == 16){
                $scope.emailArr.push({id:16.1, value:false});
              }
              if(item.id == 19){
                $scope.emailArr.push({id:19.1, value:false});
              }
              if(item.id == 24){
                $scope.emailArr.push({id:24.1, value:false});
              }
              $scope.emailArr.push(item);
            });
            $scope.notifications.email = $scope.emailArr;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 3){
        SettingsSrv.getPollingFrequency($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            $scope.polling = data;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 4){
        ReportsSrv.getAdapters($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            if(data.code == 18003){
              $scope.adapters = "";
            } else{
              $scope.adapters = data;
            }
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 5){
        SettingsSrv.getDefaultClientImage($scope.settingsObj.sid).then(
          function(data){
            $scope.defaultImg = data;
            $scope.bucket = $scope.detailBucket = $scope.defaultImg.info.bucket;
            if($scope.defaultImg.info.mbucket && $scope.defaultImg.info.mbucket != ""){
              $scope.detailBucket = $scope.defaultImg.info.mbucket;
            }
            $scope.settingLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 6){
        SettingsSrv.getAvailableExtension($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            $scope.allowedFiles = data;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 7){
        SettingsSrv.getPermissions($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            $scope.server = data;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      } else if(caller == 8){
        $scope.popupLoading = true;
        $scope.curDSelected = [];
        $scope.hasErrPop = false;
        $scope.errTypePop = "";

        SettingsSrv.getDMBSettings($scope.settingsObj.sid).then(
          function(data){
            $scope.dmbNewUser = {sid:$scope.settingsObj.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
            $scope.dmbSettings = data;
            SettingsSrv.DMBDevice($scope.settingsObj.sid).then(
              function(data){
                $scope.popupLoading = false;
                $scope.settingLoading = false;
                $scope.devices = data;
              },
              function(err){
                $log.error(err);
              }
            );
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      } else if(caller == 9){
        $scope.hasErrPop = false;
        $scope.errTypePop = "";

        $scope.curDPObj = {label:"", value:""};
        SettingsSrv.getDP($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            $scope.dpObj = data;
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      } else if(caller == 10){
        $scope.hasErrPop = false;
        $scope.errTypePop = "";
      } else if(caller == 11){
        $scope.settingLoading = true;
        $scope.hasErrPop = false;
        $scope.errTypePop = "";
        $scope.curIoTAttrObj = {label:"", value:""};
        $scope.iotObj = {placements:[]};
        SettingsSrv.getPlacements($scope.settingsObj.sid).then(
          function(data){
            $scope.settingLoading = false;
            $scope.iotObj.placements = data.data;
          },
          function(err){
            $log.error(err);
            $scope.settingLoading = false;
          }
        );
      }
    }

    $scope.placementsFx = function(index, caller, isReload){
      if(!isReload){
        $scope.iotObj.placements[index].isOpen = !$scope.iotObj.placements[index].isOpen;
      }
      if($scope.iotObj.placements[index].isOpen){
        $scope.iotObj.placements[index].loading = true;
        SettingsSrv.getPlacement($scope.settingsObj.sid, caller).then(
          function(data){
            $scope.iotObj.placements[index].placement = data.data;
            $scope.iotObj.placements[index].loading = false;
            $scope.iotObj.placements[index].isEmpty = angular.isArray($scope.iotObj.placements[index].placement);
          },
          function(err){
            $log.error(err);
            $scope.iotObj.placements[index].loading = false;
          }
        );
      }
    }

    $scope.attrAddProcessing = false;
    $scope.iotBtnAttrAddFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curIoTAttrObj.label == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "label";
      } else if($scope.curIoTAttrObj.value == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "value";
      } else{
        var selectedPL = $filter("filter")($scope.iotObj.placements, {selected:true});
        if(!selectedPL.length){
          $scope.hasErrPop = true;
          $scope.errTypePop = "placement";
        } else{
          $scope.attrAddProcessing = true;
          var iotAttrObj = Object.fromEntries(new Map([[$scope.curIoTAttrObj.label, $scope.curIoTAttrObj.value]]));

          $scope.saveObj = [];
          angular.forEach(selectedPL, function(list){
            $scope.saveObj.push({name:list.placementName, attributes:iotAttrObj});
          });

          SettingsSrv.updatePlacements($scope.settingsObj.sid, $scope.saveObj).then(
            function(data){
              if(data.code == 17101){
                $scope.attrAddProcessing = false;
                angular.forEach($scope.iotObj.placements, function(list){
                  list.selected = false;
                  list.isOpen = false;
                });
                $scope.iotBtnAttrResetFx();
              }
            },
            function(err){
              $log.error(err);
              $scope.attrAddProcessing = false;
            }
          );
        }
      }
    }

    $scope.iotBtnAttrResetFx = function(){
      angular.forEach($scope.iotObj.placements, function(list){
        list.selected = false;
      });
      $scope.curIoTAttrObj = {isShow:true, label:"", value:""};
      $scope.attrAddProcessing = false;
      $scope.plSelect = {all:false};
      $scope.hasErrPop = false;
      $scope.searchList = "";
      $scope.errTypePop = "";
    }

    $scope.plSelect = {all:false};
    $scope.plSelectFx = function(caller){
      if(caller == "all"){
        var toggleStatus = $scope.plSelect.all;
        angular.forEach($scope.iotObj.placements, function(list){
          list.selected = toggleStatus;
        });
      } else{
        $scope.plSelect.all = $scope.iotObj.placements.every(function(list){
          return list.selected;
        });
      }
    }


    $scope.iotBtnAttrDeleteOpen = function(parentIndex, index, caller, obj){
      $scope.iotPlObj = {pIndex:parentIndex, index:index, caller:caller, obj:obj};
      $scope.deleteProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div>{{"cm.msg.35" | translate}}</div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="iotBtnAttrDeleteFx();" focus-me="true" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.iotBtnAttrDeleteFx = function(){
      var placementObj = angular.copy($scope.iotObj.placements[$scope.iotPlObj.pIndex].placement);
      Object.keys(placementObj).forEach(function(key, index){
        if($scope.iotPlObj.index == index){
          placementObj[key] = "";
        }
      });
      $scope.deleteProcessing = true;
      SettingsSrv.updatePlacement($scope.settingsObj.sid, $scope.iotPlObj.caller, {attributes:placementObj}).then(
        function(data){
          if(data.code == 17101){
            $scope.deleteProcessing = false;
            $scope.placementsFx($scope.iotPlObj.pIndex, $scope.iotPlObj.caller, true);
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.sortCallback = function(){
      $scope.dpObj.properties = [];
      angular.forEach(angular.element(".sortable-item"), function(item){
        $scope.dpObj.properties.push({id:$(item).attr("data-id"), label:$(item).find(".dpLabel").text(), value:$(item).find(".dpValue").text(), desc:$(item).find(".dpDesc").text()});
      });
    }

    $scope.dpSaveFx = function(caller){
      $scope.dpObj.sid = $scope.settingsObj.sid;
      if(caller){
        $scope.dpSProcessing = true;
      } else{
        $scope.dpCProcessing = true;
      }
      SettingsSrv.saveSortDP($scope.dpObj).then(
        function(data){
          $scope.dpSProcessing = false;
          $scope.dpCProcessing = false;
          $scope.dpObj.properties = [];
          $scope.dpObj.properties = data.properties;
          $rootScope.toastNotificationFx("danger", {"code":5000});
        },
        function(err){
          $scope.dpSProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.curDPObj = {label:"", value:""};
    $scope.dpAddFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if(!$scope.curDPObj.label){
        $scope.errTypePop = "label";
        $scope.hasErrPop = true;
      } else{
        $scope.dpProcessing = true;
        $scope.curDPObj.sid = $scope.settingsObj.sid;
        SettingsSrv.saveDP($scope.curDPObj).then(
          function(data){
            $scope.dpProcessing = false;
            if(data.code == 17076){
              $scope.errTypePop = "same";
              $scope.hasErrPop = true;
            } else if(data.code == 17073){
              $scope.dpObj.properties.push({id:data.id, label:$scope.curDPObj.label, value:$scope.curDPObj.value});
              $scope.curDPObj = {label:"", value:""};
            } else if(data.code == 17074){
              for(var i=0; i<$scope.dpObj.properties.length; i++){
                if($scope.dpObj.properties[i].id == $scope.curDPObj.id){
                  $scope.dpObj.properties[i] = $scope.curDPObj;
                }
              }
              $scope.curDPObj = {label:"", value:""};
            } else if(data.code == 12095){
              $scope.curData = data;
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">\
                      <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m15" | translate}}</span></div>\
                      <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row alt-row-bg padLR10">\
                          <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                            <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                          </div>\
                        </div>\
                      </div>\
                    </div>\
                    <div class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                    </div>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                data:$scope.curData,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            }
            if(data.code != 17076){
              $scope.dpDataLoading = true;
              SettingsSrv.getDP($scope.settingsObj.sid).then(
                function(data){
                  $scope.dpDataLoading = false;
                  $scope.dpObj = data;
                },
                function(err){
                  $scope.dpDataLoading = false;
                  $log.error(err);
                }
              );
            }
          },
          function(err){
            $scope.dpProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.dpEditFx = function(obj){
      $scope.curDPObj = angular.copy(obj);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.dpDeleteOpen = function(id){
      $scope.hasErrPopDP = false;
      $scope.errType = "";
      $scope.dpDObj = {id:id, processing:false, pass:""};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading text-bold"><h1 class="text-danger">{{"cm.body.16" | translate}}</h1></header>\
            <div class="panel-body">\
              <div>{{"ms.p_s.dp.m4" | translate}}</div>\
              <div class="form-group marT15">\
                <label>{{\'cl.widget.telax.9.3\' | translate}}</label>\
                <input type="password" autocomplete="new-password" class="form-control" ng-model="dpDObj.pass">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="dpDeleteFx();" focus-me="true" ng-disabled="dpDObj.processing"><span class="fa fa-repeat fa-spin" ng-if="dpDObj.processing" aria-hidden="true"></span>{{"ms.p_s.dp.4" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right" ng-if="hasErrPopDP" aria-live="polite" role="status">\
                <span ng-if="errType==\'emptyPass\'" aria-live="polite" role="status">{{\'lock.m1\' | translate}}</span>\
                <span ng-if="errType==\'invPass\'" aria-live="polite" role="status">{{\'cl.widget.oc.m10\' | translate}}</span>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.dpDeleteFx = function(){
      $scope.hasErrPopDP = false;
      $scope.errType = "";
      if($scope.dpDObj.pass == ""){
        $scope.hasErrPopDP = true;
        $scope.errType = "emptyPass";
      } else{
        $scope.dpDObj.processing = true;
        // $scope.passEnc = $scope.hubEnc($scope.auth.email, $scope.dpDObj.pass);
        // SettingsSrv.deleteDP($scope.settingsObj.sid, $scope.dpDObj.id, $scope.passEnc).then(
        SettingsSrv.deleteDP({sid:$scope.settingsObj.sid, id:$scope.dpDObj.id, pass:$scope.encryptFx($scope.dpDObj.pass)}).then(
          function(data){
            $scope.dpDObj.processing = false;
            if(data.code == 17097){
              $scope.hasErrPopDP = true;
              $scope.errType = "invPass";
            } else if(data.code == 17075){
              for(var i=0; i<$scope.dpObj.properties.length; i++){
                if($scope.dpObj.properties[i].id == $scope.dpDObj.id){
                  $scope.dpObj.properties.splice(i, 1);
                }
              }
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $scope.dpDObj.processing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.dpResetFx = function(){
      $scope.curDPObj = {label:"", value:""};
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.hubEnc = function(email, pass){
      $scope.emailPass = email+"|"+pass;
      return btoa($scope.reverse($scope.emailPass));
    }

    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.dialogId = $dialog.attr('id');
    });

    // "hg" is using for "device health"
    $scope.reportsFx = function(caller){
      if(caller == "rs" && !$scope.server.reports.rs){
        $scope.subscriptionConfirm(caller);
      }
      if($scope.server.reports.rs){
        if((caller == "pp" && !$scope.server.reports.pp) || (caller == "ds" && !$scope.server.reports.ds) || (caller == "cs" && !$scope.server.reports.cs) || (caller == "op" && !$scope.server.reports.op) || (caller == "od" && !$scope.server.reports.od) || (caller == "cc" && !$scope.server.reports.cc) || (caller == "ir" && !$scope.server.reports.ir) || (caller == "dst" && !$scope.server.reports.dst) || (caller == "poh" && !$scope.server.reports.poh) && (caller == "hg" && !$scope.server.reports.hg) && (caller == "ci" && !$scope.server.reports.ci)){
          $scope.subscriptionConfirm(caller);
        }
      }
      if(caller == "r"){
        if($scope.server.reports.r){
          $scope.server.reports = {r:true, pp:true, ds:true, cs:true, op:true, od:true, cc:true, ir:true, hg:true, rs:false, dst:true, poh:true};// ofd:true
        } else{
          if($scope.server.reports.rs){
            $scope.reportsCopy = angular.copy($scope.server.reports);
            $scope.subscriptionConfirm(caller);
          }
          $scope.server.reports = {r:false, pp:false, ds:false, cs:false, op:false, od:false, cc:false, ir:false, hg:false, dst:false, poh:false};
        }
      }
      if(!$scope.server.reports.pp && !$scope.server.reports.ds && !$scope.server.reports.cs && !$scope.server.reports.op && !$scope.server.reports.od && !$scope.server.reports.cc && !$scope.server.reports.ir && !$scope.server.reports.hg && !$scope.server.reports.dst && !$scope.server.reports.poh && !$scope.server.reports.ci){
        $scope.server.reports.r = false;
        $scope.server.reports.rs = false;
      } else{
        $scope.server.reports.r = true;
      }
    }

    // "hg" is using for "device health"
    $scope.subUncheckFx = function(){
      if($scope.subCaller == "r"){
        $scope.server.reports = $scope.reportsCopy;
        $scope.server.reports.r = true;
      } else if($scope.subCaller == "pp"){
        $scope.server.reports.pp = true;
      } else if($scope.subCaller == "ds"){
        $scope.server.reports.ds = true;
      } else if($scope.subCaller == "cs"){
        $scope.server.reports.cs = true;
      } else if($scope.subCaller == "op"){
        $scope.server.reports.op = true;
      } else if($scope.subCaller == "od"){
        $scope.server.reports.od = true;
      } else if($scope.subCaller == "cc"){
        $scope.server.reports.cc = true;
      } else if($scope.subCaller == "rs"){
        $scope.server.reports.rs = true;
      } else if($scope.subCaller == "ir"){
        $scope.server.reports.ir = true;
      } else if($scope.subCaller == "hg"){
        $scope.server.reports.hg = true;
      } else if($scope.subCaller == "dst"){
        $scope.server.reports.dst = true;
      } else if($scope.subCaller == "poh"){
        $scope.server.reports.poh = true;
      } else if($scope.subCaller == "ci"){
        $scope.server.reports.ci = true;
      }
      ngDialog.close($scope.dialogId);
    }

    $scope.subscriptionConfirm = function(caller){
      $scope.subCaller = caller;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{subCaller=="rs"?"cm.msg.41.1":"cm.msg.41" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="closeThisDialog();" data-dismiss="modal" focus-me="true">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="subUncheckFx();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.uploadFileCount = 0;
    $rootScope.fileModelUploadFx = function(file, res){
      var reader = new FileReader();
      reader.onload = function(e){
        $("#"+res).parents(".diThumbQuad").addClass("show");
        $("#"+res).siblings(".diUploadedThumb").addClass("hide");
        $("#"+res).attr("src", e.target.result);
        if(res == "default"){
          $scope.defaultImg.default.uploading = true;
        } else{
          angular.forEach($scope.defaultImg.resolutions, function(item){
            if(item.res == res){
              item.uploading = true;
            }
          });
        }
      }
      reader.readAsDataURL(file);

      if(res == "default"){
        $scope.defaultImg.default = {label:file.name, curImg:true, uploading:true}
      } else{
        angular.forEach($scope.defaultImg.resolutions, function(item){
          if(item.res == res){
            item.label = file.name;
            item.curImg = true;
            item.uploading = true;
          }
        });
      }

      $scope.uploadFileCount++;
      FileModelUploadSrv.uploadFileAndData("mySettings/defaultClientImage", {sid:$scope.settingsObj.sid, res:res}, file).then(
        function(data){
          $scope.uploadFileCount--;
          if(res == "default"){
            $scope.defaultImg.default.uploading = false;
          } else{
            angular.forEach($scope.defaultImg.resolutions, function(item){
              if(item.res == res){
                item.uploading = false;
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.deleteConfirmFx = function(res){
      $scope.resObj = res;
      $scope.deleteProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"ms.p_s.defaultImg.m2" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="deleteThumbFx(resObj);"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteThumbFx = function(res){
      $scope.deleteProcessing = true;
      FileModelUploadSrv.uploadFileAndData("mySettings/defaultClientImage", {sid:$scope.settingsObj.sid, res:res}).then(
        function(data){
          $("#"+res).parents(".diThumbQuad").removeClass("show").addClass("hide");
          if(res == "default"){
            $scope.defaultImg.default = {label:null, thumb:null, curImg:false, uploading:false};
            $("#fileDefault").val('');
          } else{
            angular.forEach($scope.defaultImg.resolutions, function(item){
              if(item.res == res){
                $("#file"+res).val('');
                item.uploading = false;
                item.curImg = false;
                item.label = null;
                item.thumb = null;
              }
            });
          }
          ngDialog.close($scope.dialogId);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.selectEntity = function(caller, index){
      $scope.isChecked = false;
      $scope.cbxStatus;
      if(caller == "all"){
        $scope.isChecked = $scope.allowedFiles[index].selected;
        $scope.curCbx = $scope.allowedFiles[index];
        angular.forEach($scope.curCbx.ext, function(type){
          type.selected = $scope.isChecked;
        });
      } else{
        angular.forEach($scope.allowedFiles, function(type){
          $scope.cbxStatus = type.ext[0].selected;
          if($scope.cbxStatus == false){
            type.selected = false;
          } else{
            $scope.isChecked = true;
            angular.forEach(type.ext, function(exts){
              if(!exts.selected){
                $scope.isChecked = false;
                return false;
              }
            });
            if(!$scope.isChecked){
              type.selected = false;
            } else{
              type.selected = true;
            }
          }
        });
      }
    };

    $scope.updateTabFx = function(caller, subCaller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == 1){
        $scope.saveProcessing = true;
        SettingsSrv.updatePrimeAdmin({sid:$scope.settingsObj.sid, uid:$scope.primeObj.info.prime, isNotify:$scope.primeObj.info.isNotify}).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 17020){
              ngDialog.close($scope.ngDialogId, "cpa");
            } else if(data.code == 17034){
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"ms.msg.27" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:480,
                scope:$scope,
                closeByDocument:false,
                className:'ngdialog-theme-default ngdialog-confirm',
              });
            } else{
              ngDialog.close();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == 2){
        $scope.notifications.sid = $scope.settingsObj.sid;
        if($scope.offline){
          $scope.curSTime = $filter("date")($scope.offline.startTime, "HH:mm:00");
          $scope.curETime = $filter("date")($scope.offline.endTime, "HH:mm:00");
          $scope.notifications.offline = {startTime:($scope.offline.isExcluded ? $scope.curSTime :null), endTime:($scope.offline.isExcluded ? $scope.curETime :null), timeout:$scope.offline.timeout, isExcluded:$scope.offline.isExcluded, threshold:$scope.offline.threshold};
        }
        angular.forEach($scope.notifications.email, function(item){
          if(item.id==15){
            $scope.isDeviceOffline = item.value;
          }
        });
        if((!$scope.offline.timeout || $scope.offline.timeout == "") && $scope.isDeviceOffline){
          $scope.hasErr = true;
          $scope.errType = "offline";
        } else if(!$scope.offline.threshold && $scope.isDeviceOffline){
          $scope.hasErr = true;
          $scope.errType = "threshold";
        } else{
          $scope.saveProcessing = true;
          SettingsSrv.updateNotifications($scope.notifications).then(
            function(data){
              $scope.saveProcessing = false;
              ngDialog.close();
            },
            function(err){
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        }
      } else if(caller == 3){
        if($scope.polling.pollingDuration == null){
          $scope.hasErr = true;
        } else{
          if(subCaller == 1){
            $scope.savePProcessing = true;
          } else{
            $scope.saveProcessing = true;
          }
          $scope.polling.type = subCaller;
          $scope.polling.sid = $scope.settingsObj.sid;
          SettingsSrv.updatePollingFrequency($scope.polling).then(
            function(data){
              ngDialog.close();
              $scope.saveProcessing = false;
              $scope.savePProcessing = false;
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
              $scope.savePProcessing = false;
            }
          );
        }
      } else if(caller == 4){}
      else if(caller == 5){}
      else if(caller == 6){
        $scope.saveProcessing = true;
        SettingsSrv.updateAvailableExtension({sid:$scope.settingsObj.sid, supportedFiles:$scope.allowedFiles}).then(
          function(data){
            $scope.saveProcessing = false;
            ngDialog.close();
            $scope.supportedFilesFx();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      } else if(caller == 7){
        if($scope.server.cst == null && !angular.isUndefined($scope.server.cst)){
          $scope.hasErr = true;
          $scope.errType = "cst";
          return false;
        } else if($scope.server.cst < 20 || angular.isUndefined($scope.server.cst)){
          $scope.hasErr = true;
          $scope.errType = "cstMore";
          return false;
        } else if($scope.server.iTime == "" || Number($scope.server.iTime) < 1){
          $scope.hasErr = true;
          $scope.errType = "iTime";
          return false;
        } else if($scope.server.pass == ""){
          $scope.hasErr = true;
          $scope.errType = "pass";
          return false;
        }
        $scope.server.sid = $scope.settingsObj.sid;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">\
                <div class="marB15" translate="{{\'ms.p_s.serverPer.m2\'}}" translate-values="{serverName:\'<b>{{settingsObj.label}}</b>\'}"></div>\
                <label class="noMarB"><input type="checkbox" ng-model="server.isNotify" role="checkbox"><label></label> {{"ms.p_s.prime.5" | translate}}</label>\
              </div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="confirmFx();" focus-me="true" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">\
                  <span ng-if="errType==\'urlS\'" aria-live="polite" role="status" translate="{{\'ms.p_s.serverPer.m9.1\'}}" translate-values="{serverName:existsServer}"></span>\
                </div>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
        });
      }
    }
    $scope.confirmFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";
      SettingsSrv.updatePermissions($scope.server).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 17044){
            $scope.existsServer = data.name;
            $scope.errType = "urlS";
            $scope.hasErr = true;
          }
          if(data.status == "Success"){
            if($scope.server.sid == $scope.auth.server){
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              $scope.auth.upermissions.gf = $scope.server.gf;
              $scope.auth.upermissions.mc = $scope.server.mc;
              $scope.auth.upermissions.vd = $scope.server.vd;
              $scope.auth.upermissions.dgrp = $scope.server.dgrp;
              $scope.auth.upermissions.gbdt = $scope.server.gbdt;
              $scope.auth.upermissions.webos = $scope.server.webos;
              $scope.auth.upermissions.tizen = $scope.server.tizen;
              $scope.auth.upermissions.desktop = $scope.server.desktop;
              $scope.auth.upermissions.f45Workout = $scope.server.widgets.f45;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
            }
            ngDialog.close();
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    /*Second ngDialog close*/
    $scope.listPopOpen = function(caller){
      $scope.popupLoading = true;
      $scope.openList = {caller:caller, list:[], selectAll:false};
      if($scope.openList.caller == "mc"){
        SettingsSrv.getMusicChoice($scope.settingsObj.sid).then(
          function(data){
            $scope.popupLoading = false;
            $scope.openList.list = data;
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      }
      ngDialog.open({
        template:'app/common/popup/openList.html',
        width:850,
        scope:$scope,
        data:$scope.openList,
        closeByDocument:false
      });
    }
    $scope.listPopFx = function(){
      $scope.popupProcessing = true;
      if($scope.openList.caller == "mc"){
        SettingsSrv.updateMusicChoice($scope.settingsObj.sid, $scope.openList.list).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17036){
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    $scope.offlineOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.30" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div>\
                <label>{{"cm.label.47" | translate}}</label>\
                <input type="email" class="form-control" ng-model="server.odne">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="offlineFx();" focus-me="true" ng-disabled="saveProcessing"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'email\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m3" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.offlineFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.odne){
        $scope.hasErrPop = true;
        $scope.errTypePop = "email";
      } else{
        ngDialog.close($scope.dialogId);
      }
    }

    /** BigPanda */
     $scope.bigPandaOpen = function(){
      $scope.tmpBpObj = angular.copy($scope.server.bpa);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.33" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="bpatoken">{{"ms.label.37" | translate}}</label>\
                <input type="text" class="form-control" ng-model="server.bpa.token" id="bpatoken" aria-label="bpatoken" aria-labelledby="bpatoken">\
              </div>\
              <div class="form-group noMarB">\
                <label for="bpakey">{{"ms.label.38" | translate}}</label>\
                <input type="text" class="form-control" ng-model="server.bpa.key" id="bpakey" aria-label="bpakey" aria-labelledby="bpakey">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="bigPandaFx();" focus-me="true" ng-disabled="saveProcessing"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="resetBigPDataFx(); closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'token\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m6" | translate}}</div>\
                <div ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m7" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.bigPandaFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.bpa.token){
        $scope.hasErrPop = true;
        $scope.errTypePop = "token";
      } else if(!$scope.server.bpa.key){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
      } else{
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.resetBigPDataFx = function(){
      $scope.server.bpa.token = $scope.tmpBpObj.token;
      $scope.server.bpa.key = $scope.tmpBpObj.key;
    }

    /** SSO */
    $scope.ssoPopOpen = function(){
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      SettingsSrv.getSSO($scope.settingsObj.sid, $scope.server.sso.type).then(
        function(data){
          $scope.popupLoading = false;
          $scope.curSSO = data.sso;
          $scope.curSSO.id = $scope.settingsObj.sid;
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/ssoSettings.html',
        width:500,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.ssoSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if(!$scope.curSSO.text || $scope.curSSO.text == ""){
        $scope.errTypePop = "text";
        $scope.hasErrPop = true;
      } else if(!$scope.curSSO.url || $scope.curSSO.url == ""){
        $scope.errTypePop = "url";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type!="idaptive" && !$scope.curSSO.clientId || $scope.curSSO.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type!="idaptive" && !$scope.curSSO.clientSecret || $scope.curSSO.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="azure" && (!$scope.curSSO.tenantId || $scope.curSSO.tenantId == "")){
        $scope.errTypePop = "tId";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="okta" && (!$scope.curSSO.appDomain || $scope.curSSO.appDomain == "")){
        $scope.errTypePop = "appD";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="idaptive" && (!$scope.curSSO.entityId || $scope.curSSO.entityId == "")){
        $scope.errTypePop = "eId";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="idaptive" && (!$scope.curSSO.sso || $scope.curSSO.sso == "")){
        $scope.errTypePop = "sso";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="idaptive" && (!$scope.curSSO.slo || $scope.curSSO.slo == "")){
        $scope.errTypePop = "slo";
        $scope.hasErrPop = true;
      } else if($scope.server.sso.type=="idaptive" && (!$scope.curSSO.cert || $scope.curSSO.cert == "")){
        $scope.errTypePop = "cert";
        $scope.hasErrPop = true;
      } else{
        $scope.popupProcessing = true;
        var curSSO = angular.copy($scope.curSSO);
        curSSO.clientId = $scope.encryptFx(curSSO.clientId);
        curSSO.clientSecret = $scope.encryptFx(curSSO.clientSecret);
        curSSO.tenantId = $scope.encryptFx(curSSO.tenantId);
        curSSO.appDomain = $scope.encryptFx(curSSO.appDomain);

        SettingsSrv.updateSSO(curSSO).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17044){
              $scope.existsServer = data.name;
              $scope.errTypePop = "urlS";
              $scope.hasErrPop = true;
            } else if(data.code == 17045){
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    /** WebOS */
    $scope.pmModeList = [{label:"Power Off (Default)", value:"powerOff"}, {label:"Sustain Aspect Ratio", value:"sustainAspectRatio"}, {label:"Screen Off", value:"screenOff"}, {label:"Screen Off Always", value:"screenOffAlways"}, {label:"Screen Off & Backlight On", value:"screenOffBacklight"}];
    $scope.irLockList = [{label:"Off (Normal)", value:"normal"}, {label:"On (Power Key Only)", value:"usePwrOnly"}, {label:"On (Block All)", value:"blockAll"}];
    $scope.pStatusList = [{label:"PWR (Power On)", value:"PWR"}, {label:"STD (Standby)", value:"STD"}, {label:"LST (Last Status)", value:"LST"}];
    $scope.continentList = ["Africa", "Asia", "CIS", "Europe", "Middle East", "North America", "Oceania", "Pacific", "South America"];
    $scope.dpmWakeList = [{label:"Clock", value:"clock"}, {label:"Clock+Data", value:"clockAndData"}];
    $scope.dpmList = [{label:"Off", value:"off"}, {label:"1 Min", value:"1min"}, {label:"3 Min", value:"3min"}, {label:"5 Min", value:"5min"}, {label:"10 Min", value:"10min"}];
    $scope.countryList = [];
    $scope.cityList = [];

    $scope.webOSPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      DeviceControlSrv.getWebOSTimezone().then(
        function(data){
          $scope.webOSTimezone = data.timeZone;
        },
        function(err){
          $log.error(err);
        }
      );
      DeviceControlSrv.getWebOSLang().then(
        function(data){
          $scope.localeList = data.localeList;
        },
        function(err){
          $log.error(err);
        }
      );

      $scope.popupLoading = true;
      SettingsSrv.getWebOS($scope.settingsObj.sid).then(
        function(data){
          $scope.popupLoading = false;
          if(data != ""){
            $scope.webOS = data;
            if($scope.webOS.gs.as.tvt){
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")(day.st);
                day.et = $filter("momentTime")(day.et);
              });
            } else{
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")("09:00:00");
                day.et = $filter("momentTime")("17:00:00");
              });
            }
          } else{
            $scope.webOS = {
              gs:{
                l:{
                  menu:{language:"English", languageCode:"en", countries:[{name:"", specifier:"en-US"}]},
                  key:{language:"English", languageCode:"en", countries:[{name:"", specifier:"en-US"}]}
                },
                si:{s:false},
                dt:{set:true, t:"", d:"", tz:{c:"North America", ct:"Canada", ci:"Toronto"}, ntp:{s:false, ip:""}},
                p:{signal:false, ir:false, dpm:{label:"Off", value:"off"}, wakeUp:{label:"Clock", value:"clock"}, pm:{label:"Power Off (Default)", value:"powerOff"}, delay:0, status:{label:"PWR (Power On)", value:"PWR"}, wired:false,wireless:false},
                n:{
                  lan:{wired:true},
                  cpc:{ip:"",mask:"",gateway:"",dns:""}
                },
                as:{b:false, w:true, tvt:false,
                  days:[
                    {label:1, name:"Mon", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:2, name:"Tue", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:3, name:"Wed", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:4, name:"Thu", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:5, name:"Fri", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:6, name:"Sat", val:false, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:0, name:"Sun", val:false, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")}
                  ]
                }
              },
              as:{h:false, usb:false, osd:false, ir:{label:"Off (Normal)", value:"normal"}, local:{label:"Off (Normal)", value:"normal"}, wifi:true, ss:true},
              ns:{port:[], tcp:""}
            }
          }
          $scope.blockObj = {id:0, p:null, d:"in", pr:"TCP", show:false};
          $scope.blockAdd = false;
          $scope.bCount = 0;
          $scope.timeZoneFx("c", true);
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      $scope.webOSPop = ngDialog.open({
        template:'app/common/popup/webOSSettings.html',
        width:900,
        scope:$scope,
        closeByDocument:false,
        closeByEscape:false,
        className:'ngdialog-theme-default ngdialog-preview'
      });
    }

    $scope.webosDefaultOpen = function(){
      $scope.confirmProcessing = false;
      $scope.webosDefault = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"d.p_dc.wos.m12" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="webosDefaultFx();" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.webosDefaultFx = function(){
      $scope.confirmProcessing = true;
      $scope.webOSPwdObj = {curpwd:"",newpwd:"",conpwd:""};
      SettingsSrv.webosDefault().then(
        function(data){
          $scope.confirmProcessing = false;
          if(data.settings){
            $scope.webOS = data.settings;
            if($scope.webOS.gs.as.tvt){
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")(day.st);
                day.et = $filter("momentTime")(day.et);
              });
            } else{
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")("09:00:00");
                day.et = $filter("momentTime")("17:00:00");
              });
            }
            ngDialog.close($scope.webosDefault.id);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getDTFx = function(){
      if(!$scope.webOS.gs.dt.set){
        $scope.webOS.gs.dt.t = $scope.custTime = moment().set('minute', '00').utc().format();
        $scope.webOS.gs.dt.d = {startDate:moment()._d, endDate:moment()._d};
      } else{
        $scope.timeZoneFx("c", true);
      }
    }
    $scope.timeZoneFx = function(caller, auto){
      if(caller == "c"){
        $scope.countryList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCExists = false;
          angular.forEach($scope.countryList, function(item1){
            if(angular.equals(item.country, item1)){
      			  $scope.isCExists = true;
      			}
          });
          if(!$scope.isCExists && item.continent == $scope.webOS.gs.dt.tz.c){
            $scope.countryList.push(item.country);
          }
        });
        if(auto){
          $scope.timeZoneFx("ct");
        }
      } else if(caller == "ct"){
        $scope.cityList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCtExists = false;
          angular.forEach($scope.cityList, function(item1){
            if(angular.equals(item.country, item1)){
      			  $scope.isExists = true;
      			}
          });
          if(!$scope.isCtExists && item.country == $scope.webOS.gs.dt.tz.ct){
            $scope.cityList.push(item.city);
          }
        });
      }
    }

    $scope.blockAddFx = function(){
      $scope.blockAdd = !$scope.blockAdd;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.editArr = [];
    $scope.savePortFx = function(caller, port){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.webOS.ns.port){
        $scope.webOS.ns.port = [];
      }
      if(caller == "a"){
        if($scope.blockObj.p == ""){
          $scope.errTypePop = "pEmpty";
          $scope.hasErrPop = true;
        } else{
          if(!$scope.webOS.ns.port.length){
            $scope.blockObj.id = $scope.bCount;
            $scope.webOS.ns.port.push($scope.blockObj);
            $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
            $scope.blockAdd = false;
            $scope.bCount++;
          } else{
            for(var i=0; i<$scope.webOS.ns.port.length; i++){
              if($scope.webOS.ns.port[i].p == $scope.blockObj.p && $scope.webOS.ns.port[i].d == $scope.blockObj.d && $scope.webOS.ns.port[i].pr == $scope.blockObj.pr){
                $scope.errTypePop = "pSame";
                $scope.hasErrPop = true;
                return;
              }
            }
            if($scope.bCount <= 30){
              $scope.webOS.ns.port.push({id:$scope.bCount, p:$scope.blockObj.p, d:$scope.blockObj.d, pr:$scope.blockObj.pr});
              $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
              $scope.blockAdd = false;
              $scope.bCount++;
            }
          }
        }
      } else if(caller == "e"){
        $scope.editArr.push(angular.copy(port));
      } else if(caller == "s"){
        $scope.isSame = false;
        $scope.indexToUpdate;
        for(var i=0; i<$scope.webOS.ns.port.length; i++){
          if($scope.webOS.ns.port[i].id != port.id && ($scope.webOS.ns.port[i].p == port.p && $scope.webOS.ns.port[i].d == port.d && $scope.webOS.ns.port[i].pr == port.pr)){
            $scope.isSame = true;
            $scope.errTypePop = "pSame";
            $scope.hasErrPop = true;
            break;
          } else if($scope.webOS.ns.port[i].id == port.id){
            $scope.indexToUpdate = i;
          }
        }
        if(!$scope.isSame){
          port.show = !port.show;
          $scope.webOS.ns.port[$scope.indexToUpdate] = port;
          for(var j=0; j<$scope.editArr.length; j++){
            if($scope.editArr[j].id == port.id){
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    $scope.cancelEditFx = function(id){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      for(var i=0; i<$scope.webOS.ns.port.length; i++){
        if($scope.webOS.ns.port[i].id == id){
          for(var j=0; j<$scope.editArr.length; j++){
            if($scope.editArr[j].id == id){
              $scope.webOS.ns.port[i] = $scope.editArr[j];
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    $scope.deletePortOpen = function(index){
      $scope.portIndex = index;
      $scope.deletePort = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePortFx(portIndex);" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deletePortFx = function(index){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dialogId = "";
      $scope.webOS.ns.port.splice(index, 1);
      ngDialog.close($scope.deletePort.id);
    }

    $scope.webOSPwdObj = {curpwd:"",newpwd:"",conpwd:""};
    $scope.webOSPopFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.eOpened = $filter("filter")($scope.webOS.ns.port, {show:true});
      if($scope.webOS.gs.as.tvt){
        var isSTErr = false, isETErr = false;
        angular.forEach($scope.webOS.gs.as.days, function(day){
          if(day.val && !day.st){
            isSTErr = true;
          }
          if(day.val && !day.et){
            isETErr = true;
          }
        });
      }
      if($scope.eOpened && $scope.eOpened.length){
        $scope.hasErrPop = true;
        $scope.errTypePop = "eOpened";
      } else if($scope.webOS.gs.as.tvt && isSTErr){
        $scope.hasErrPop = true;
        $scope.errTypePop = "onTime";
      } else if($scope.webOS.gs.as.tvt && isETErr){
        $scope.hasErrPop = true;
        $scope.errTypePop = "offTime";
      } else{

        if(($scope.webOSPwdObj.curpwd.length && !$scope.webOSPwdObj.curpwd.match($scope.numRegEx)) || ($scope.webOSPwdObj.newpwd.length && !$scope.webOSPwdObj.newpwd.match($scope.numRegEx)) || ($scope.webOSPwdObj.conpwd.length && !$scope.webOSPwdObj.conpwd.match($scope.numRegEx))){
          $scope.hasErrPop = true;
          $scope.errTypePop = "noPwd";
        } else if($scope.webOSPwdObj.curpwd != "" && $scope.webOSPwdObj.newpwd == ""){
          $scope.hasErrPop = true;
          $scope.errTypePop = "newPwd";
        } else if($scope.webOSPwdObj.curpwd != "" && $scope.webOSPwdObj.newpwd != "" && $scope.webOSPwdObj.conpwd == ""){
          $scope.hasErrPop = true;
          $scope.errTypePop = "conPwd";
        } else if($scope.webOSPwdObj.curpwd == "" && $scope.webOSPwdObj.newpwd == $scope.webOSPwdObj.conpwd && $scope.webOSPwdObj.newpwd != "" && $scope.webOSPwdObj.conpwd != ""){
          $scope.hasErrPop = true;
          $scope.errTypePop = "pass";
        } else if($scope.webOSPwdObj.curpwd.length && $scope.webOSPwdObj.newpwd.length && $scope.webOSPwdObj.curpwd == $scope.webOSPwdObj.newpwd){
          $scope.hasErrPop = true;
          $scope.errTypePop = "same";
        } else if($scope.webOSPwdObj.newpwd != $scope.webOSPwdObj.conpwd){
          $scope.hasErrPop = true;
          $scope.errTypePop = "match";
        } else{

          $scope.copyWebOS = angular.copy($scope.webOS);
          if($scope.copyWebOS.gs.as.tvt){
            angular.forEach($scope.copyWebOS.gs.as.days, function(day){
              if(day.st){
                day.st = moment(day.st).format();
                day.st = day.st.split("T")[1].split("+")[0].split("-")[0];
              }
              if(day.et){
                day.et = moment(day.et).format();
                day.et = day.et.split("T")[1].split("+")[0].split("-")[0];
              }
            });
          }
          if($scope.webOSPwdObj.curpwd != ""){
            $scope.copyWebOS.as.changePwd = $scope.webOSPwdObj;
          } else{
            $scope.copyWebOS.as.changePwd = {};
          }
          $scope.popupProcessing = true;

          var copyWebOS = angular.copy($scope.copyWebOS);
          var keysToProcess = ['as.changePwd.conpwd', 'as.changePwd.curpwd', 'as.changePwd.newpwd'];

          copyWebOS = $scope.endeDataFx("e", $scope.copyWebOS, keysToProcess);

          SettingsSrv.updateWebOS({id:$scope.settingsObj.sid, settings:copyWebOS}).then(
            function(data){
              $scope.popupProcessing = false;
              if(data.code == 17043){
                ngDialog.close($scope.webOSPop.id);
              }
            },
            function(err){
              $log.error(err);
              $scope.popupProcessing = false;
            }
          );
        }
      }
    }

    $scope.telexPopOpen = function(){
      $scope.popupLoading = true;
      SettingsSrv.getTelexSettings($scope.settingsObj.sid).then(
        function(data){
          $scope.popupLoading = false;
          $scope.telexSettings = data;
          $scope.decodePass = {ac:$scope.reverse(atob($scope.telexSettings.settings.telaxpassword).split("|")[0]), ftp:$scope.reverse(atob($scope.telexSettings.settings.telaxftppassword).split("|")[0])};
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/telexSettings.html',
        width:850,
        scope:$scope,
        data:$scope.openList,
        closeByDocument:false
      });
    }
    $scope.telexPopFx = function(){
      $scope.popupProcessing = true;
      $scope.encodePass = {ac:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.decodePass.ac)), ftp:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.decodePass.ftp))};
      $scope.telexSettings.settings.telaxpassword = $scope.encodePass.ac;
      $scope.telexSettings.settings.telaxftppassword = $scope.encodePass.ftp;
      SettingsSrv.updateTelexSettings($scope.settingsObj.sid, $scope.telexSettings).then(
        function(data){
          $scope.popupProcessing = false;
          if(data.code == 17037){
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.popupProcessing = false;
        }
      );
    }

    $scope.dmbPopOpen = function(){
      $scope.dmbBrand = {sid:$scope.settingsObj.sid, brand:"", url:""};
      $scope.dmbBrandProcessing = false;
      $scope.dmbUserProcessing = false;
      $scope.popupLoading = true;
      $scope.curDSelected = [];
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbTab = 1;

      SettingsSrv.getDMBSettings($scope.settingsObj.sid).then(
        function(data){
          $scope.dmbNewUser = {sid:$scope.settingsObj.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
          $scope.curDMBLabels = {};
          $scope.dmbSettings = data;
          SettingsSrv.DMBDevice($scope.settingsObj.sid).then(
            function(data){
              $scope.popupLoading = false;
              $scope.devices = data;
            },
            function(err){
              $log.error(err);
            }
            );

            SettingsSrv.getDMBLabels($scope.settingsObj.sid).then(
              function(data){
                $scope.popupLoading = false;
                $scope.dmbLabels = data.settings.labels;
                $scope.curDMBLabels = data.settings.labels.et;
              },
              function(err){
                $log.error(err);
              }
            );
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
        ngDialog.open({
          template:'app/common/popup/dmbSettings.html',
          width:1000,
          scope:$scope,
          closeByDocument:false
        });
    }

    $scope.editThemeOpen = function(url, label){
      $scope.brandLabel = label;
      $scope.hasErrPop1 = false;
      $scope.brandUrl = url;
      $scope.popupLoad = true;

      SettingsSrv.getTheme($scope.brandUrl).then(
        function(data){
          $scope.settingLoading = false;
          $scope.theme.data = data.scss;
          $scope.popupLoad = false;
        },
        function(err){
          $log.error(err);
          $scope.settingLoading = false;
          $scope.popupLoad = false;
      });
      ngDialog.open({
        template:'app/common/popup/editTheme.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.saveTheme = function(dialog){
      $scope.saveThemeProcess = true;
      $scope.themeObj = {url:$scope.brandUrl, scss:$scope.theme.data}
      SettingsSrv.updateTheme($scope.themeObj).then(
        function(data){
          $scope.saveThemeProcess = false;
          if(data.code == 17055){
            dialog.closeThisDialog();
          }
          if(data.code == 17057){
            $scope.hasErrPop1 = true;
            $scope.errTypePop = 'tInvalid';
          }
        },
        function(err){
          $log.error(err);
          $scope.saveThemeProcess = false;
      });
    }

    $scope.resetTheme = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.dmb.m8" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="resetThemeFx();" focus-me="true" ng-disabled="resetThemeProcess"><span class="fa fa-repeat fa-spin" ng-if="resetThemeProcess" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.resetThemeFx = function(){
      $scope.isConfirmOpen = false;
      $scope.resetThemeProcess = true;
      SettingsSrv.resetTheme($scope.brandUrl).then(
        function(data){
          if(data.status == 'success'){
            SettingsSrv.getTheme($scope.brandUrl).then(
              function(data){
                ngDialog.close($scope.dialogId);
                $scope.resetThemeProcess = false;
                $scope.settingLoading = false;
                $scope.theme.data = data.scss;
              },
              function(err){
                $log.error(err);
                ngDialog.close($scope.dialogId);
                $scope.settingLoading = false;
                $scope.resetThemeProcess = false;
            });
          }
        },
        function(err){
          $log.error(err);
          $scope.settingLoading = false;
          $scope.resetThemeProcess = false;
      });
    }

    $scope.dmbTab = 1;
    $scope.dmbTabFx = function(tab){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbTab = tab;
    }

    $scope.dmbBrand = {sid:$scope.settingsObj.sid, brand:"", url:""};
    $scope.addBrandFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dmbBrand.brand == ""){
        $scope.errTypePop = "eBrand";
        $scope.hasErrPop = true;
        $("#brand").focus();
      } else{
        $scope.dmbBrandProcessing = true;
        SettingsSrv.addBrand($scope.dmbBrand).then(
          function(data){
            $scope.dmbBrandProcessing = false;
            if(data.code == 17052){
              $scope.errTypePop = "aBrand";
              $scope.hasErrPop = true;
              $("#brand").focus();
            } else if(data.code == 17054){
              $scope.errTypePop = "aURL";
              $scope.hasErrPop = true;
              $("#url").focus();
            } else if(data.code == 17051){
              $scope.dmbSettings.brands.unshift({id:data.id, label:$scope.dmbBrand.brand, url:$scope.dmbBrand.url});
              $scope.dmbBrand = {sid:$scope.settingsObj.sid, brand:"", url:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbBrandProcessing = false;
          }
        );
      }
    }

    $scope.addDMBUserFx = function(){
      $scope.dmbNewUser.devices = $filter("filter")($scope.devices.devices, {selected:true});
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if($scope.dmbNewUser.label != "" && $scope.dmbNewUser.email != "" && $scope.dmbNewUser.email && $scope.dmbNewUser.pwd != "" && $scope.dmbNewUser.brand != "" && $scope.dmbNewUser.devices.length){
        $scope.dmbUserProcessing = true;
        SettingsSrv.addDMBUser($scope.dmbNewUser).then(
          function(data){
            $scope.dmbUserProcessing = false;
            if(data.code == 17049){
              $scope.hasErrPop = true;
              $scope.errTypePop = "uExist";
            } else if(data.code == 17047){
              $scope.dmbNewUser.userId = data.userId;
              $scope.dmbSettings.users.unshift($scope.dmbNewUser);
              $scope.dmbNewUser = {sid:$scope.settingsObj.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
            } else if(data.code == 17048){
              $scope.dmbNewUser.userId = data.userId;
              for(var i=0; i<$scope.dmbSettings.users.length; i++){
                if($scope.dmbSettings.users[i].id === $scope.dmbNewUser.id){
                  $scope.dmbSettings.users[i] = $scope.dmbNewUser;
                }
              }
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
              $scope.dmbNewUser = {sid:$scope.settingsObj.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbUserProcessing = false;
          }
        );
      } else{
        $scope.hasErrPop = true;
        $scope.errTypePop = "eField";
      }
    }

    $scope.updateDMBLablesFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curDMBLabels.dv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t1Empty";
      } else if($scope.curDMBLabels.lv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t2Empty";
      } else if($scope.curDMBLabels.pv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t3Empty";
      } else{
        $scope.dmbLabels.et = $scope.curDMBLabels;
        $scope.dataObj = {sid:$scope.settingsObj.sid, labels:$scope.dmbLabels};

        $scope.updateProcessing = true;
        SettingsSrv.updateDMBLabels($scope.dataObj).then(
          function(data){
            $scope.updateProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.updateProcessing = false;
          }
        );
      }
    }

    $scope.dmbLabelsResetFx = function(){
      SettingsSrv.resetDMBLabels($scope.settingsObj.sid).then(
        function(data){
          $scope.updateProcessing = false;
          if(data.code == 17125){
            $scope.curDMBLabels = data.settings.et;
          }
        },
        function(err){
          $log.error(err);
          $scope.updateProcessing = false;
        }
      );
    }

    $scope.editOpen = function(obj, index){
      obj.sid = $scope.settingsObj.sid;
      $scope.dmbNewUser = angular.copy(obj);
      $scope.dList = angular.copy(obj.devices);
      angular.forEach($scope.devices.devices, function(d){
          d.selected = false;
      });
      angular.forEach($scope.dList, function(item){
        angular.forEach($scope.devices.devices, function(d){
          if(item.id === d.id){
            d.selected = true;
          }
        });
      });
    }

    $scope.cancelDMBUserFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbNewUser = {sid:$scope.settingsObj.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
      angular.forEach($scope.devices.devices, function(d){
        d.selected = false;
      });
    }

    $scope.deleteOpen = function(caller, id, index){
      $scope.isConfirmOpen = true;
      $scope.deleteErr = false;
      $scope.dmbDeleteObj = {caller:caller, id:id, index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dmbDeleteObj.caller == \'b\'">{{deleteErr?"cm.dmb.m5":"cm.dmb.m10" | translate}}</span>\
              <span ng-if="dmbDeleteObj.caller == \'u\'">{{"cm.dmb.m11" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" focus-me="true" ng-if="!deleteErr" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm" ng-class="deleteErr?\'btn-default\':\'btn-link\'" ng-click="closeThisDialog();" data-dismiss="modal">{{deleteErr?"cm.btn.1":"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deleteFx = function(){
      $scope.deleteProcessing = true;
      SettingsSrv.deleteDMBbu($scope.dmbDeleteObj.id, $scope.settingsObj.sid, $scope.dmbDeleteObj.caller).then(
        function(data){
          $scope.deleteProcessing = false;
          if($scope.dmbDeleteObj.caller == "b"){
            if(data.code == 17052){
              $scope.deleteErr = true;
            } else if(data.code == 17053){
              $scope.dmbSettings.brands.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          } else{
            if(data.code == 17050){
              $scope.dmbSettings.users.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.sendPwdProcessing = false;
    $scope.sendPwdFx = function(id){
      $scope.sendPwdProcessing = true;
      SettingsSrv.sendPwd({id:id, sid:$scope.settingsObj.sid}).then(
        function(data){
          $scope.sendPwdProcessing = false;
          if(data.code == 17049){}
        },
        function(err){
          $scope.sendPwdProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.dmbPopFx = function(){
      $scope.popupProcessing = true;
      $scope.encodePass = {ac:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.decodePass.ac)), ftp:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.decodePass.ftp))};
      $scope.telexSettings.settings.telaxpassword = $scope.encodePass.ac;
      $scope.telexSettings.settings.telaxftppassword = $scope.encodePass.ftp;
      SettingsSrv.updateTelexSettings($scope.settingsObj.sid, $scope.telexSettings).then(
        function(data){
          $scope.popupProcessing = false;
          if(data.code == 17037){
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.popupProcessing = false;
        }
      );
    }

    $scope.meetingPopOpen = function(){
      $scope.curRoom = {label:"", floor:""};
      $scope.popupProcessing = false;
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.isAddMode = true;
      $scope.errTypePop = "";
      $scope.roomList = [];
      SettingsSrv.getCustomRoom($scope.settingsObj.sid).then(
        function(data){
          $scope.popupLoading = false;
          $scope.roomList = data;
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/customRoom.html',
        width:850,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.addEditRoomFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(angular.isUndefined($scope.curRoom.label) || $scope.curRoom.label == ""){
        $scope.errTypePop = "empty";
        $scope.hasErrPop = true;
      } else{
        $scope.curRoom.sId = $scope.settingsObj.sid;
        $scope.popupProcessing = true;
        SettingsSrv.updateCustomRoom($scope.curRoom).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17041){
              $scope.errTypePop = "exist";
              $scope.hasErrPop = true;
            } else if(data.code == 17038){
              $scope.roomList.push({label:$scope.curRoom.label, floor:$scope.curRoom.floor, id:data.id});
              $scope.curRoom = {label:"", floor:""};
            } else if(data.code == 17039){
              angular.forEach($scope.roomList, function(list){
                if($scope.curRoom.id === list.id){
                  list.id = $scope.curRoom.id;
                  list.label = $scope.curRoom.label;
                  list.floor = $scope.curRoom.floor;
                  $scope.curRoom = {label:"", floor:""};
                  $scope.isAddMode = true;
                }
              });
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }
    $scope.meetingActionFx = function(caller, obj){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dataObj = obj;
      if(caller == "e"){
        $scope.isAddMode = false;
        $scope.curRoom = angular.copy($scope.dataObj);
      } else{
        $scope.deleteProcessing = false;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.meeting.m7" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="deleteRoomFx();" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }
    $scope.deleteRoomFx = function(){
      $scope.deleteProcessing = true;
      SettingsSrv.deleteCustomRoom($scope.dataObj.id).then(
        function(data){
          $scope.deleteProcessing = false;
          if(data.code == 17042){
            ngDialog.close($scope.dialogId);
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.widget.meeting.m8" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            $scope.roomList.splice($scope.roomList.indexOf($scope.dataObj), 1);
            if($scope.curRoom.id){
              $scope.curRoom = {label:"", floor:""};
              $scope.isAddMode = true;
            }
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.iotCPopOpen = function(){
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      SettingsSrv.getIoTCSettings($scope.settingsObj.sid).then(
        function(data){
          $scope.popupLoading = false;
          // $scope.iotCSettings = data;
          var keysToProcess = ['settings.admin_token_id', 'settings.application_id', 'settings.template_id'];
          $scope.iotCSettings = $scope.endeDataFx("d", data, keysToProcess);
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      $scope.iotCPop = ngDialog.open({
        template:'app/common/popup/iotCSettings.html',
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.iotCPopFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.iotCSettings.settings.admin_token_id == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aToken";
        $("#admin_token_id").focus();
      } else if($scope.iotCSettings.settings.subdomain == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "sDomain";
        $("#subdomain").focus();
      } else if($scope.iotCSettings.settings.dns == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "dns";
        $("#dns").focus();
      } else if($scope.iotCSettings.settings.application_id == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aId";
        $("#application_id").focus();
      } else{
        $scope.popupProcessing = true;

        var keysToProcess = ['settings.admin_token_id', 'settings.application_id', 'settings.template_id'];

        var iotCSettings = angular.copy($scope.iotCSettings);
        iotCSettings = $scope.endeDataFx("e", $scope.iotCSettings, keysToProcess);
        SettingsSrv.updateIoTCSettings(iotCSettings).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17061){
              ngDialog.close($scope.dialogId);
            }
            if(data.code == 17060){
              $scope.hasErrPop = true;
              $scope.errTypePop = "invalid";
              $("#admin_token_id").focus();
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    $scope.dsOpen = function(caller){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dsObj = {caller:caller};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 ng-if="dsObj.caller==\'dtps\'" role="heading" aria-level="1">{{"ms.label.35.12.1" | translate}}</h1>\
              <h1 ng-if="dsObj.caller==\'ot\'" role="heading" aria-level="1">{{"ms.label.35.15.1" | translate}}</h1>\
              <h1 ng-if="dsObj.caller==\'dps\'" role="heading" aria-level="1">{{"ms.label.35.9.1" | translate}}</h1>\
            </header>\
            <div class="panel-body">\
              <div ng-if="dsObj.caller == \'dtps\'">\
                <div class="form-group">\
                  <label for="dtpsc">{{"ms.label.35.12.2" | translate}} <span class="text-muted text-sm">(&deg;C)</span></label>\
                  <input type="number" id="dtpsc" class="form-control" ng-model="server.dashboard.dtpsc" min="1" focus-me="true" aria-label="{{\'ms.label.35.12.2\' | translate}}" aria-labelledby="{{\'ms.label.35.12.2\' | translate}}">\
                </div>\
                <div class="form-group noMarB">\
                  <label for="dtpsd">{{"ms.label.35.12.3" | translate}} <span class="text-muted text-sm">(&deg;C)</span></label>\
                  <input type="number" id="dtpsd" class="form-control" ng-model="server.dashboard.dtpsd" min="1" aria-label="{{\'ms.label.35.12.3\' | translate}}" aria-labelledby="{{\'ms.label.35.12.3\' | translate}}">\
                </div>\
              </div>\
              <div ng-if="dsObj.caller == \'ot\'">\
                <div class="form-group noMarB">\
                  <label for="otc">{{"ms.label.35.15.2" | translate}}</label>\
                  <input type="text" id="otc" class="form-control" ng-model="server.dashboard.otc" focus-me="true" aria-label="{{\'ms.label.35.15.2\' | translate}}" aria-labelledby="{{\'ms.label.35.15.2\' | translate}}">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success" ng-click="dsFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'caution\'" aria-live="polite" role="status">{{"ms.msg.33" | translate}}</div>\
                <div ng-if="errTypePop==\'danger\'" aria-live="polite" role="status">{{"ms.msg.34" | translate}}</div>\
                <div ng-if="errTypePop==\'cId\'" aria-live="polite" role="status">{{"ms.msg.35" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.dsFx = function(caller){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dsObj.caller == "dtps"){
        if(!$scope.server.dashboard.dtpsc){
          $scope.hasErrPop = true;
          $scope.errTypePop = "caution";
          $("#dtpsc").focus();
        } else if(!$scope.server.dashboard.dtpsd){
          $scope.hasErrPop = true;
          $scope.errTypePop = "danger";
          $("#dtpsd").focus();
        } else{
          ngDialog.close($scope.dialogId);
        }
      } else if($scope.dsObj.caller == "ot"){
        if(!$scope.server.dashboard.otc){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cId";
          $("#otc").focus();
        } else{
          ngDialog.close($scope.dialogId);
        }
      }
    }
    
    /*EPD*/
    $scope.epdOpenFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.epdObj = angular.copy($scope.server.epdS);
      ngDialog.open({
        template:'app/common/popup/epdSettings.html',
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.epdFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.epdObj.ep || $scope.epdObj.ep == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
        $("#ep").focus();
      } else if(!$scope.epdObj.u || $scope.epdObj.u == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "user";
        $("#user").focus();
      } else if(!$scope.epdObj.p || $scope.epdObj.p == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "pass";
        $("#pass").focus();
      } else if(!$scope.epdObj.c || $scope.epdObj.c == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "client";
        $("#client").focus();
      } else if(!$scope.epdObj.s || $scope.epdObj.s == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "clientS";
        $("#clientS").focus();
      } else{
        $scope.server.epdS = angular.copy($scope.epdObj);
        ngDialog.close($scope.dialogId);
      }
    }

    $scope.appMenuFx = function(){
      $scope.appMenuProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.server.iTime == "" || Number($scope.server.iTime) < 1){
        $scope.hasErr = true;
        $scope.errType = "iTime";
        return false;
      } else if($scope.server.pass == ""){
        $scope.hasErr = true;
        $scope.errType = "pass";
        return false;
      } else{
        $scope.appMenuProcessing = true;
        SettingsSrv.appMenu({sid:$scope.settingsObj.sid, iTime:$scope.server.iTime, pass:$scope.encryptFx($scope.server.pass)}).then(
          function(data){
            $scope.appMenuProcessing = false;
          },
          function(err){
            $scope.appMenuProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.f45Open = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.wf45.16.6" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group noMarB">\
                <label for="screen">{{"cl.widget.wf45.16.7" | translate}}</label>\
                <input type="number" id="screen" class="form-control" ng-model="server.widgets.f45S.screen" min="1" focus-me="true" aria-label="{{\'cl.widget.wf45.16.7\' | translate}}" aria-labelledby="{{\'cl.widget.wf45.16.7\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success" ng-click="f45Fx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'screen\'" aria-live="polite" role="status">{{"cl.widget.wf45.m5" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.f45Fx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.widgets.f45S.screen){
        $scope.hasErrPop = true;
        $scope.errTypePop = "screen";
        $("#screen").focus();
      } else{
        ngDialog.close($scope.dialogId);
      }
    }

    $scope.iotBtnPopOpen = function(){
      $scope.curIoTBtnCopy = angular.copy($scope.server.widgets.iotButtonS);
      $scope.curIoTBtn = $scope.server.widgets.iotButtonS;
      if($scope.server.widgets.iotButtonS.length==0){
        $scope.curIoTBtn = {ep:'', dvcCert:'', privateKey:'', rootCACert:''};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.39" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="ep">{{"cl.widget.pw.27" | translate}}</label>\
                <input type="text" id="ep" class="form-control" ng-model="curIoTBtn.ep" aria-label="{{\'cl.widget.pw.27\' | translate}}" aria-labelledby="{{\'cl.widget.pw.27\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="dvcCert">{{"ms.p_s.serverPer.39.1" | translate}}<span class="text-muted text-sm">&nbsp;(*.crt)</span></label>\
                <input type="text" id="dvcCert" class="form-control" ng-model="curIoTBtn.dvcCert" aria-label="{{\'ms.p_s.serverPer.39.1\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.1\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="privateKey">{{"ms.p_s.serverPer.39.2" | translate}}<span class="text-muted text-sm">&nbsp;(*.key)</span></label>\
                <input type="text" id="privateKey" class="form-control" ng-model="curIoTBtn.privateKey" aria-label="{{\'ms.p_s.serverPer.39.2\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.2\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="rootCACert">{{"ms.p_s.serverPer.39.3" | translate}}<span class="text-muted text-sm">&nbsp;(*.pem)</span></label>\
                <input type="text" id="rootCACert" class="form-control" ng-model="curIoTBtn.rootCACert" aria-label="{{\'ms.p_s.serverPer.39.3\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.3\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="iotBtnFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'ep\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'dc\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m2" | translate}}</span>\
                <span ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m3" | translate}}</span>\
                <span ng-if="errTypePop==\'rc\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m4" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.iotBtnCloseFx();
          }
        }
      });
    }
    $scope.iotBtnFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curIoTBtn.ep == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
        $("#ep").focus();
      } else if($scope.curIoTBtn.dvcCert == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "dc";
        $("#dvcCert").focus();
      } else if($scope.curIoTBtn.privateKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
        $("#privateKey").focus();
      } else if($scope.curIoTBtn.rootCACert == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "rc";
        $("#rootCACert").focus();
      } else{
        $scope.server.widgets.iotButtonS = $scope.curIoTBtn;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.iotBtnCloseFx = function(){
      $scope.server.widgets.iotButtonS = angular.copy($scope.curIoTBtnCopy);
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AdvancedSearchController', AdvancedSearchController);

  /** @ngInject */
  function AdvancedSearchController($log, $scope, $rootScope, $filter, $cookies, $state, ngDialog, IndexedDB, CommonSrv){
    $scope.curCopyAdvSearch = {module:$scope.advSearchObj.caller, step:$scope.advSearchObj.step, id:$scope.advSearchObj.id, opt:$scope.advSearchObj.opt, creationRange:false,status:$scope.advSearchObj.status , serial:$scope.advSearchObj.serial};
    $scope.contentHeadingDisplayed = false;
    $scope.widgetHeadingDisplayed = false;
    $rootScope.nameOrFile = {nfKey:"n"};
    $scope.searchPList = {text:""};
    $scope.tagSearch = {text:""};
    $scope.tagIncSearch = {text:""};
    $scope.tagExcSearch = {text:""};
    $scope.grpSearch = {text:""};
    $scope.grpIncSearch = {text:""};
    $scope.grpExcSearch = {text:""};
    // if($scope.curCopyAdvSearch.module == "d" && localStorage.getItem("isDlAdvSearch") == null){
    // if($scope.curCopyAdvSearch.module == "d"){
    //   $rootScope.importXls = {file:""};
    // }

    var appliedFilter = JSON.parse(localStorage.getItem("filterType"));
    if(appliedFilter){
      $scope.curCopyAdvSearch.fil = appliedFilter;
    } else{
      $scope.curCopyAdvSearch.fil = "all";
    }

    $scope.searchWidget = { name: "" };
    if($scope.curCopyAdvSearch.module != "cl"){
      $scope.curCopyAdvSearch.scheduleRange = false;
      $scope.curCopyAdvSearch.tag = {include:[], exclude:[], iType:"or", eType:"or"};
      $scope.curCopyAdvSearch.userGroup = {include:[], exclude:[], iType:"or", eType:"or"};
      $scope.curCopyAdvSearch.os = null;
      if($scope.advSearchObj.id == "mp"){
        $scope.curCopyAdvSearch.os = 1;
      } else if($scope.advSearchObj.id == "webos"){
        $scope.curCopyAdvSearch.os = 2;
      } else if($scope.advSearchObj.id == "tizen"){
        $scope.curCopyAdvSearch.os = 3;
      }
    }
    $scope.curAdvSearch = angular.copy($scope.curCopyAdvSearch);
    if(!$scope.curAdvSearch.type){
      $scope.curAdvSearch.type = "";
    }
    $scope.searchProcessing = false;
    $scope.curAdvSearchModel = {};
    if($scope.curCopyAdvSearch.module != "inv"){
      $scope.advSearchLoading = true;
      $scope.getAdvSearch = true;
    } else{
      $scope.getAdvSearch = false;
      $scope.advSearchLoading = false;
    }
    $scope.curType = "";
    if($scope.getAdvSearch){
      
      if($scope.curAdvSearch.module == "d" || $scope.curAdvSearch.module == "dt" || $scope.curAdvSearch.module == "dg" || $scope.curAdvSearch.module == "s" || $scope.curAdvSearch.module == "fla" || $scope.curAdvSearch.module == "r"){
        $rootScope.importXls = {file:""};
        $scope.callerAdvSearch = "d";
      } else{
        $scope.callerAdvSearch = $scope.curAdvSearch.module;
      }
      
      if($state.current.name == "hub.contentAdd.widgetAddTab.contentOnDemand"){
        $scope.curType = "cod";
      } else if($state.current.name == "hub.tContainer.tDesign" || $state.current.name.startsWith("hub.tContainer") || $state.current.name.startsWith("hub.templates")){
        $scope.curType = "t";
      } else if($state.current.name == "hub.sContainer.sContent" || $state.current.name.startsWith("hub.sContainer") || $state.current.name.startsWith("hub.schedules")){
        $scope.curType = "s";
      } else if($state.current.name == "hub.dContainer.dName" || $state.current.name.startsWith("hub.dContainer") || $state.current.name.startsWith("hub.devices")){
        $scope.curType = "d";
      } else if($state.current.name == "hub.reports.c.pp" || $state.current.name.startsWith("hub.reports")){
        $scope.curType = "r";
      } else{
        $scope.curType = "cl";
      }
      
      CommonSrv.getAdvSearch($scope.callerAdvSearch, $scope.curType).then(
        function(data){
          $scope.getAdvSearch = false;
          $scope.advSearchLoading = false;
          $scope.copyAdvSearch = data;
          if($scope.curAdvSearch.step == "w-cod"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
            });
            $scope.copyAdvSearch.types = data.types;
          } else if($scope.curAdvSearch.step == "w-cg"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
              if(item.label != "contentOnDemand" && item.label != "contentGroup" && item.label != "button"){
                curStepArr.push(item);
              }
            });
            $scope.copyAdvSearch.types = curStepArr;
          } else if($scope.curAdvSearch.step == "w-fc"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
              if(item.label == "Image" || item.label == "Video" || (item.type == "Widget" && item.label == "liveStreaming")){
                curStepArr.push(item);
              }
            });
            $scope.copyAdvSearch.types = curStepArr;
          } else if($scope.curAdvSearch.step == "w-sc"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
              if($state.current.name == "hub.contentAdd.widgetAddTab.alertMsg"){
                if(item.label == "Image" || item.label == "Video" || item.label == "Flash"){
                  curStepArr.push(item);
                }
              }
              if($state.current.name == "hub.contentAdd.widgetAddTab.gCalendar"){
                if($scope.selectedT != "3"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else if($scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.outlookCalendar" || $state.current.name == "hub.contentAdd.widgetAddTab.teamsRoom"){
                if($scope.selectedT != "3"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else if($scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.dContainer.dName" || $state.current.name == "hub.devices.d"){
                if(item.label == "Image" || item.label == "Word" || item.label == "Vector"){
                  curStepArr.push(item);
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.f45"){
                if(item.label == "Image" || item.label == "Flash" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                  curStepArr.push(item);
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.message"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.openHours"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.webPage"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.qrCode"){
                if(item.label == "Image" || item.label == "Video" || item.label == "Powerpoint" || item.label == "Vector" || item.label === "googleSlide" || item.label === "iframe" || item.label === "liveStreaming" || item.label === "microsoftPowerBi" || item.label === "traffic" || item.label === "vimeo" || item.label === "youtube" || item.label === "webPage" || item.label === "count" || item.label === "dateTime" || item.label === "news" || item.label === "openHours" || item.label === "quotes" || item.label === "rssFeed" || item.label === "stockPrice" || item.label === "text" || item.label === "weather" || item.label === "meeting" || item.label === "socialChorus" || item.label === "x" || item.label === "contentOnDemand" || item.label === "outlookCalendar" || item.label === "googleCalendar"){
                  curStepArr.push(item);
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.quotes"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.meeting"){
                if($scope.selectedT != "3"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else if($scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.coe"){
                if($scope.selectedT != "3"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else if($scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.iotButton"){
                if($scope.selectedT == "3"){
                  if($rootScope.soundObj.type == "audio"){
                    if(item.label == "Audio"){
                      curStepArr.push(item);
                    }
                  } else{
                    if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                      curStepArr.push(item);
                    }
                  }
                } else{
                  $scope.default = true;
                  if($rootScope.soundObj.type == "audio"){
                    curStepArr = [{label:$filter("translate")('cm.label.39'), id:"audio", c:'Content'}];
                  } else{
                    curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  }
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                }
              } else if($state.current.name == "hub.devices.di"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.hdSteth"){
                if($scope.selectedT == "2" || $scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.codButton"){
                // var curStepArr = [];
                // angular.forEach($scope.copyAdvSearch.types, function(item){
                //   if(item.label == "Image"){
                //     curStepArr.push(item);
                //   }
                // });
                // $scope.default = true;
                // curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0 }];
                // $scope.curAdvSearch.type = curStepArr[0];
                $scope.default = true;
                if($rootScope.codObj.type == "jci"){
                  curStepArr = [{label:$filter("translate")('cl.widget.jci.1'), id:88, c:'Widget'}];
                } else if($rootScope.codObj.type == "sb"){
                  curStepArr = [{label:$filter("translate")('cl.widget.isb.1'), id:105, c:'Widget'}];
                } else if($rootScope.codObj.type == "url"){
                  curStepArr = [{label:$filter("translate")('cl.widget.wp.1'), id:1, c:'Widget'}];
                } else{
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0 }];
                }
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.comEvent"){
                if($scope.selectedT != "3"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else if($scope.selectedT == "3"){
                  if(item.label == "Image" || item.label == "Video" || item.label == "Word" || item.label == "Powerpoint" || item.label == "Vector"){
                    curStepArr.push(item);
                  }
                }
              } else if($state.current.name == "hub.tContainer.tName"){
                $scope.default = true;
                curStepArr = [{label:$filter("translate")('t.label.28'), id:"excel", c:0}];
                $scope.curAdvSearch.type = curStepArr[0];
                $scope.advSearch = angular.copy($scope.copyAdvSearch);
              } else if($state.current.name == "hub.contentAdd.widgetAddTab.intelSmartBuilding"){
                if($rootScope.advSearchType === 'i'){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                  $scope.advSearch = angular.copy($scope.copyAdvSearch);
                } else{
                  if(item.label === "Image" || item.label === "Video" || item.label === "Powerpoint" || item.label === "Word" || item.label === "Vector" || item.label === "microsoftPowerBi"|| item.label === "liveStreaming"|| item.label === "vimeo" || item.label === "youtube" || item.label === "webPage" || item.label === "dateTime" || item.label === "fillerContent" || item.label === "qrCode" || item.label === "news" || item.label === "quotes" || item.label === "stockPrice" || item.label === "text" || item.label === "weather" || item.label === "meetings" || item.label === "microsoftOutlookCalendar" || item.label === "googleCalendar"){
                    curStepArr.push(item);
                  }
                }
              }
            });
            $scope.copyAdvSearch.types = curStepArr;
          } else if($scope.curAdvSearch.step == "tcl"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
                if(item.c != null && item.c){
                  // item.c = $filter("translate")('cl.tool.8');
                  item.c = "Widget";
                } else{
                  // item.c = $filter("translate")('cl.tab.1');
                  item.c = "Content";
                }
                if($scope.templateTType !== 4 && item.label != "contentOnDemand" && item.label != "contentGroup"){
                  curStepArr.push(item);
                }
                if($scope.templateTType == 4 && item.label == "Video"){
                  $scope.default = true;
                  curStepArr = [{label:$filter("translate")('cm.label.38'), id:"video", c:0}];
                  $scope.curAdvSearch.type = curStepArr[0];
                }
            });
            $scope.copyAdvSearch.types = curStepArr;
          } else if($scope.curAdvSearch.step == "r" && $state.current.name == "hub.reports.hds.pp"){
            var curStepArr = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
              if(item.label == "Image" || item.label == "Video"){
                curStepArr.push(item);
              }
            });
            $scope.copyAdvSearch.types = curStepArr;
          } else{
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.c != null && item.c){
                // item.c = $filter("translate")('cl.tool.8');
                item.c = "Widget";
              } else{
                // item.c = $filter("translate")('cl.tab.1');
                item.c = "Content";
              }
            });
            $scope.curAdvSearch.step == "w-fc";
          }
          if($scope.curCopyAdvSearch.opt == 1){
            $scope.imageList = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.label === "Image"){
                item.label = $filter("translate")('cm.label.37');
                $scope.imageList.push(item);
                return false;
              }
            });
            $scope.copyAdvSearch.types = $scope.imageList;
            if($scope.copyAdvSearch.types.length){
              $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
            }
            $scope.advSearch = angular.copy($scope.copyAdvSearch);

            // $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
            // $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
            // $scope.advSearch = angular.copy($scope.copyAdvSearch);
          } else if($scope.curCopyAdvSearch.opt == 2){
            $scope.ccWidgetList = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.label === "survey" || item.label === "corpcommAlertMessage"){
                if(item.label === "survey"){
                  item.label = $filter("translate")('cl.widget.survey.1');
                } else{
                  item.label = $filter("translate")('cl.widget.alert.1');
                }
                $scope.ccWidgetList.push(item);
                return false;
              }
            });
            $scope.copyAdvSearch.types = $scope.ccWidgetList;
            $scope.advSearch = angular.copy($scope.copyAdvSearch);
          } else if($scope.curCopyAdvSearch.opt == 4){
            $scope.codWidgetList = [];
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.label === "contentOnDemand"){
                item.label = $filter("translate")('cl.widget.cod.1');
                $scope.codWidgetList.push(item);
                return false;
              }
            });
            $scope.copyAdvSearch.types = $scope.codWidgetList;
            $scope.advSearch = angular.copy($scope.copyAdvSearch);
          } else if($scope.copyAdvSearch.types){
            angular.forEach($scope.copyAdvSearch.types, function(item){
              if(item.label === "cAll"){
                item.label = $filter("translate")('as.label.11');
                return false;
              } else if(item.label === "Image"){
                item.label = $filter("translate")('cm.label.37');
                return false;
              } else if(item.label === "Video"){
                item.label = $filter("translate")('cm.label.38');
                return false;
              } else if(item.label === "Audio"){
                item.label = $filter("translate")('cm.label.39');
                return false;
              } else if(item.label === "Vector"){
                item.label = $filter("translate")('cm.label.86');
                return false;
              } else if(item.label === "wAll"){
                item.label = $filter("translate")('as.label.12');
                return false;
              } else if(item.label === "comEvents"){
                item.label = $filter("translate")('cl.widget.aNet.1');
                return false;
              } else if(item.label === "agc"){
                item.label = $filter("translate")('cl.widget.agc.1');
                return false;
              } else if(item.label === "airQualityIndex"){
                item.label = $filter("translate")('cl.widget.aqi.1');
                return false;
              } else if(item.label === "corpcommAlertMessage"){
                item.label = $filter("translate")('cl.widget.alert.1');
                return false;
              } else if(item.label === "achievers"){
                item.label = $filter("translate")('cl.widget.achievers.1');
                return false;
              } else if(item.label === "amazonQuicksight"){
                item.label = $filter("translate")('cl.widget.aqs.1');
                return false;
              } else if(item.label === "autoLoginBasicAuth"){
                item.label = $filter("translate")('cl.widget.al.1');
                return false;
              } else if(item.label === "calendarOfEvents"){
                item.label = $filter("translate")('cl.widget.coe.1');
                return false;
              } else if(item.label === "calendarOfEventsView"){
                item.label = $filter("translate")('cl.widget.coev.1');
                return false;
              } else if(item.label === "ciscoMeraki"){
                item.label = $filter("translate")('cl.widget.cisco.1');
                return false;
              } else if(item.label === "pandoraCloudcover"){
                item.label = $filter("translate")('cl.widget.ccm.1');
                return false;
              } else if(item.label === "contentGroup"){
                item.label = $filter("translate")('cl.widget.cg.1');
                return false;
              } else if(item.label === "contentOnDemand"){
                item.label = $filter("translate")('cl.widget.cod.1');
                return false;
              } else if(item.label === "button"){
                item.label = $filter("translate")('cl.widget.codBtn.1');
                return false;
              } else if(item.label === "count"){
                item.label = $filter("translate")('cl.widget.count.1');
                return false;
              } else if(item.label === "cloudFarm"){
                item.label = $filter("translate")('cl.widget.clFarm.1');
                return false;
              } else if(item.label === "countdownCircle"){
                item.label = $filter("translate")('cl.widget.wf45.2');
                return false;
              } else if(item.label === "comPylonText"){
                item.label = $filter("translate")('cl.widget.pylonText.1');
                return false;
              } else if(item.label === "dateTime"){
                item.label = $filter("translate")('cl.widget.dt.1');
                return false;
              } else if(item.label === "delimitedText"){
                item.label = $filter("translate")('cl.widget.dText.1');
                return false;
              } else if(item.label === "microsoftExcelSheet"){
                item.label = $filter("translate")('cl.widget.es.1');
                return false;
              } else if(item.label === "externalInput"){
                item.label = $filter("translate")('cl.widget.ei.1');
                return false;
              } else if(item.label === "facebook"){
                item.label = $filter("translate")('cl.widget.fb.1');
                return false;
              } else if(item.label === "facebookWorkplace"){
                item.label = $filter("translate")('cl.widget.fwp.1');
                return false;
              } else if(item.label === "fifa"){
                item.label = "FIFA World Cup";
                return false;
              } else if(item.label === "fillerContent"){
                item.label = $filter("translate")('cl.widget.fc.1');
                return false;
              } else if(item.label === "flightSchedule"){
                item.label = $filter("translate")('cl.widget.fs.1');
                return false;
              } else if(item.label === "fullscreenChrome"){
                item.label = $filter("translate")('cl.widget.fsc.1');
                return false;
              } else if(item.label === "f45ContentScroller"){
                item.label = $filter("translate")('cl.widget.wf45.1');
                return false;
              } else if(item.label === "f45ContentTile"){
                item.label = $filter("translate")('cl.widget.wf45.7');
                return false;
              } else if(item.label === "f45Hydrate"){
                item.label = $filter("translate")('cl.widget.wf45.3');
                return false;
              } else if(item.label === "f45MoveStation"){
                item.label = $filter("translate")('cl.widget.wf45.4');
                return false;
              } else if(item.label === "f45ProgressBar"){
                item.label = $filter("translate")('cl.widget.wf45.5');
                return false;
              } else if(item.label === "f45Animation"){
                item.label = $filter("translate")('cl.widget.wf45.18');
                return false;
              } else if(item.label === "f45ProgressBarwithBreak"){
                item.label = $filter("translate")('cl.widget.wf45.16');
                return false;
              } else if(item.label === "f45Stay"){
                item.label = $filter("translate")('cl.widget.wf45.13');
                return false;
              } else if(item.label === "f45Work"){
                item.label = $filter("translate")('cl.widget.wf45.12');
                return false;
              } else if(item.label === "f45Workout"){
                item.label = $filter("translate")('cl.widget.wf45.14');
                return false;
              } else if(item.label === "googleCalendar"){
                item.label = $filter("translate")('cl.widget.gc.1');
                return false;
              } else if(item.label === "googleSlide"){
                item.label = $filter("translate")('cl.widget.gs.1');
                return false;
              } else if(item.label === "grafanaCloud"){
                item.label = $filter("translate")('cl.widget.grafana.1');
                return false;
              } else if(item.label === "hdSteth"){
                item.label = $filter("translate")('cl.widget.steth.1');
                return false;
              } else if(item.label === "iframe"){
                item.label = $filter("translate")('cl.widget.iFrame.1');
                return false;
              } else if(item.label === "instagram"){
                item.label = $filter("translate")('cl.widget.instagram.1');
                return false;
              } else if(item.label === "intelCircuitBench"){
                item.label = $filter("translate")('cl.widget.inC.1');
                return false;
              } else if(item.label === "interactiveMenu"){
                item.label = $filter("translate")('cl.widget.iMenu.1');
                return false;
              } else if(item.label === "iotButton"){
                item.label = $filter("translate")('cl.widget.iot.1');
                return false;
              } else if(item.label === "intelJciMap"){
                item.label = $filter("translate")('cl.widget.jci.1');
                return false;
              } else if(item.label === "intelSmartBuilding"){
                item.label = $filter("translate")('cl.widget.isb.1');
                return false;
              } else if(item.label === "linkedin"){
                item.label = $filter("translate")('cl.widget.in.1');
                return false;
              } else if(item.label === "liveStreaming"){
                item.label = $filter("translate")('cl.widget.ls.1');
                return false;
              } else if(item.label === "meetings"){
                item.label = $filter("translate")('cl.widget.meeting.1');
                return false;
              } else if(item.label === "message"){
                item.label = $filter("translate")('cl.widget.message.1');
                return false;
              } else if(item.label === "microsoftTeams"){
                item.label = $filter("translate")('cl.widget.msTeams.1');
                return false;
              } else if(item.label === "microsoftTeamsRooms"){
                item.label = $filter("translate")('cl.widget.tRoom.1');
                return false;
              } else if(item.label === "microsoftTeamsChannels"){
                item.label = $filter("translate")('cl.widget.tChannel.1');
                return false;
              } else if(item.label === "musicChoice"){
                item.label = $filter("translate")('cl.widget.mc.1');
                return false;
              } else if(item.label === "news"){
                item.label = $filter("translate")('cl.widget.news.1');
                return false;
              } else if(item.label === "nextbus"){
                item.label = $filter("translate")('cl.widget.nb.1');
                return false;
              } else if(item.label === "nextVehicle"){
                item.label = $filter("translate")('cl.widget.nv.1');
                return false;
              } else if(item.label === "lifelabsPatientWait"){
                item.label = $filter("translate")('cl.widget.pw.1');
                return false;
              } else if(item.label === "microsoftPowerBi"){
                item.label = $filter("translate")('cl.widget.pBI.1');
                return false;
              } else if(item.label === "onlineRadio"){
                item.label = $filter("translate")('cl.widget.or.1');
                return false;
              } else if(item.label === "openHours"){
                item.label = $filter("translate")('cl.widget.oh.1');
                return false;
              } else if(item.label === "microsoftOutlookCalendar"){
                item.label = $filter("translate")('cl.widget.oc.1');
                return false;
              } else if(item.label === "progressBar"){
                item.label = $filter("translate")('cl.widget.pb.1');
                return false;
              } else if(item.label === "prayer"){
                item.label = $filter("translate")('cl.widget.prayer.1');
                return false;
              } else if(item.label === "queue"){
                item.label = $filter("translate")('cl.widget.queue.1');
                return false;
              } else if(item.label === "quotes"){
                item.label = $filter("translate")('cl.widget.quotes.1s');
                return false;
              } else if(item.label === "qrCode"){
                item.label = $filter("translate")('cl.widget.qr.1');
                return false;
              } else if(item.label === "qlik"){
                item.label = $filter("translate")('cl.widget.qlik.1');
                return false;
              } else if(item.label === "readerboard"){
                item.label = $filter("translate")('cl.widget.rb.1');
                return false;
              } else if(item.label === "rssFeed"){
                item.label = $filter("translate")('cl.widget.rss.1');
                return false;
              } else if(item.label === "scheduleCalendar"){
                item.label = $filter("translate")('cl.widget.sc.1');
                return false;
              } else if(item.label === "slack"){
                item.label = $filter("translate")('cl.widget.slack.1');
                return false;
              } else if(item.label === "firstup"){
                item.label = $filter("translate")('cl.widget.sch.1');
                return false;
              } else if(item.label === "socialMedia"){
                item.label = $filter("translate")('cl.widget.ssm.1');
                return false;
              } else if(item.label === "stockPrice"){
                item.label = $filter("translate")('cl.widget.sp.1');
                return false;
              } else if(item.label === "storm"){
                item.label = $filter("translate")('cl.widget.storm.1');
                return false;
              } else if(item.label === "survey"){
                item.label = $filter("translate")('cl.widget.survey.1');
                return false;
              } else if(item.label === "tableau"){
                item.label = $filter("translate")('cl.widget.tb.1');
                return false;
              } else if(item.label === "telax"){
                item.label = $filter("translate")('cl.widget.telax.1');
                return false;
              } else if(item.label === "text"){
                item.label = $filter("translate")('cl.widget.text.1');
                return false;
              } else if(item.label === "touchlinkMeetings"){
                item.label = $filter("translate")('cl.widget.tl.1');
                return false;
              } else if(item.label === "traffic"){
                item.label = $filter("translate")('cl.widget.traffic.1');
                return false;
              } else if(item.label === "trainingMode"){
                item.label = $filter("translate")('cl.widget.tm.1');
                return false;
              } else if(item.label === "tscCountryMile"){
                item.label = $filter("translate")('cl.widget.tsccm.1');
                return false;
              } else if(item.label === "x"){
                item.label = $filter("translate")('cl.widget.twitter.1');
                return false;
              } else if(item.label === "unisys"){
                item.label = $filter("translate")('cl.widget.unisys.1');
                return false;
              } else if(item.label === "vimeo"){
                item.label = $filter("translate")('cl.widget.vimeo.1');
                return false;
              } else if(item.label === "waitQueueMetro"){
                item.label = $filter("translate")('cl.widget.wqMetro.1');
                return false;
              } else if(item.label === "weather"){
                item.label = $filter("translate")('cl.widget.weather.1');
                return false;
              } else if(item.label === "webCam"){
                item.label = $filter("translate")('cl.widget.wc.1');
                return false;
              } else if(item.label === "webLogin"){
                item.label = $filter("translate")('cl.widget.wl.1');
                return false;
              } else if(item.label === "webLoginChrome"){
                item.label = $filter("translate")('cl.widget.wl.1.1');
                return false;
              } else if(item.label === "webPage"){
                item.label = $filter("translate")('cl.widget.wp.1');
                return false;
              } else if(item.label === "webexByCisco"){
                item.label = $filter("translate")('cl.widget.webex.1');
                return false;
              } else if(item.label === "xovis"){
                item.label = $filter("translate")('cl.widget.xovis.1');
                return false;
              } else if(item.label === "microsoftVivaEngage"){
                item.label = $filter("translate")('cl.widget.yammer.1');
                return false;
              } else if(item.label === "youtube"){
                item.label = $filter("translate")('cl.widget.youTube.1');
                return false;
              }else if(item.label === "verkada"){
                item.label = $filter("translate")('cl.widget.verkada.1');
                return false;
              }
            });

            //for hide "COD" and "CG" widget from adv search in schedule sel content
            if($scope.curCopyAdvSearch.step == "scl"){
              $scope.normalWidgetList = [];
              angular.forEach($scope.copyAdvSearch.types, function(item){
                if(item.label !== "Content on Demand" && item.label !== "Content Group"){
                  $scope.normalWidgetList.push(item);
                  return false;
                }
              });
              $scope.copyAdvSearch.types = $scope.normalWidgetList;
            }
          }
          $scope.advSearch = angular.copy($scope.copyAdvSearch);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.ss = {isOpen:false};
    $scope.selTypeFx = function(option){
      $scope.curAdvSearch.type = option;
      $scope.authSaveDisable = false;
      $scope.ss.isOpen = !$scope.ss.isOpen;
      angular.element(document).find('.customSelectChannel').removeClass('open');
    }

    $scope.contentSearchFocus = function(){
      $scope.searchWidget = { name:"" };
      if($scope.advSearch.types.length > 5){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $scope.listManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type){
      $rootScope.rootManipulateFx(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type);/*This function in CommonController*/
    }

    $scope.toggleCallback= function(open){
      $scope.searchPList.text = "";
      $scope.searchWidget.name = "";
    }

    $scope.ss = {isOpen:false};
    $scope.selectPropFx = function(selected, $event){
      $scope.selectedProp = selected;
      $scope.curAdvSearch.prop = selected;
      $scope.ss.isOpen = !$scope.ss.isOpen;
    }

    $scope.dateRangeFx = function(caller){
      if(caller == "c"){
        $scope.curAdvSearch.creationRange = true;
      } else{
        $scope.curAdvSearch.scheduleRange = true;
      }
    }

    $scope.resetFx = function(){
      $rootScope.nameOrFile = {nfKey:"n"};
      $scope.selectedProp = "";
      $scope.searchPList.text = "";
      $scope.advSearch = angular.copy($scope.copyAdvSearch);
      $scope.curAdvSearch = angular.copy($scope.curCopyAdvSearch);
      if(!$scope.curAdvSearch.type){
        $scope.curAdvSearch.type = "";
      }
      if($scope.curCopyAdvSearch.opt == 1){
        $scope.imageList = [];
        angular.forEach($scope.copyAdvSearch.types, function(item){
          if(item.label === "Images" || item.label === "Image"){
            item.label = $filter("translate")('cm.label.37');
            $scope.imageList.push(item);
            return false;
          }
        });
        $scope.copyAdvSearch.types = $scope.imageList;
        if($scope.copyAdvSearch.types.length){
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
        // $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
        // $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.meeting"){
        if($scope.selectedT != "3"){
          $scope.default = true;
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.gCalendar"){
        if($scope.selectedT != "3"){
          $scope.default = true;
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.message"){
        $scope.default = true;
        $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.devices.di"){
        if($scope.selectedT == "11"){
          $scope.default = true;
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.openHours"){
        $scope.default = true;
        $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.webPage"){
        $scope.default = true;
        $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.quotes"){
        $scope.default = true;
        $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.coe"){
        if($scope.selectedT != "3"){
          $scope.default = true;
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
      } else if($state.current.name == "hub.tContainer.tName"){
        $scope.default = true;
        $scope.curAdvSearch.type = [{label:$filter("translate")('t.label.28'), id:"excel", c:0}];
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.intelSmartBuilding"){
        if($rootScope.advSearchType === 'i'){
          $scope.default = true;
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0}];
          $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
        }
      } else if($state.current.name == "hub.contentAdd.widgetAddTab.codButton"){
        if($rootScope.codObj.type == "jci"){
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cl.widget.jci.1'), id:88, c:'Widget'}];
        } else if($rootScope.codObj.type == "sb"){
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cl.widget.isb.1'), id:105, c:'Widget'}];
        } else if($rootScope.codObj.type == "url"){
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cl.widget.wp.1'), id:1, c:'Widget'}];
        } else{
          $scope.copyAdvSearch.types = [{label:$filter("translate")('cm.label.37'), id:"image", c:0 }];
        }
        $scope.curAdvSearch.type = $scope.copyAdvSearch.types[0];
      }

      if($scope.curCopyAdvSearch.module == 'd' || $scope.curCopyAdvSearch.module == 'dt' || $scope.curCopyAdvSearch.module == 'dg' || $scope.curCopyAdvSearch.module == 's' || $scope.curCopyAdvSearch.module == 'fla' || $scope.curCopyAdvSearch.module == 'r'){
        $rootScope.importXls = {file:""};
      }
      $rootScope.resetTagFx();
      $rootScope.resetGrpFx();
    }

    /*Second ngDialog close*/
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.advSearchFx = function(){
      $scope.hasErr = false;
      $scope.curAdvSearchCopy = angular.copy($scope.curAdvSearch);
      // localStorage.removeItem("filterType");
      if($scope.curAdvSearch.module != "s"){
        $scope.curAdvSearchCopy.creationDateRange = {startDate:moment($scope.curAdvSearch.creationDateRange.startDate).format("L"), endDate:moment($scope.curAdvSearch.creationDateRange.endDate).format("L")};
      }
      if($scope.curAdvSearch.module == "cl"){
        if($scope.curAdvSearchCopy.type || $scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.createdBy){
          $scope.searchProcessing = true;
          $scope.curAdvSearchCl = {name:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, type:$scope.curAdvSearchCopy.type, step:$scope.curAdvSearchCopy.step};
          //filter adv search with schedule type
          if(!angular.isUndefined($scope.curAdvSearchCopy.opt)){
            $scope.curAdvSearchCl.ls = $scope.curAdvSearchCopy.opt;
          }

          //store search data for show after edit widget
          localStorage.removeItem("curFilterObj");
          localStorage.setItem("curFilterObj", JSON.stringify($scope.curAdvSearchCl));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.curAdvSearchCopy));
          localStorage.setItem("isAdvSearch", true);
          localStorage.removeItem("isWidgetEdited");
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.removeItem("isActionOnContent");
          if($state.current.name == "hub.reports.hds.pp"){
            $scope.curAdvSearchCl.step = "w-sc";
          }
          CommonSrv.updateAdvSearchCL($scope.curAdvSearchCl).then(
            function(data){
              $scope.searchProcessing = false;
              $scope.filteredData = data;
              $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, content:$scope.filteredData.content, groups:$scope.filteredData.groups, folder:$scope.filteredData.folder, code:data.code, advObj:$scope.curAdvSearchCl};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              ngDialog.close($scope.confirmDialog);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          if(!$scope.curAdvSearchCopy.name){
            $("#adName").focus();
          }
        }
      } else if($scope.curAdvSearch.module == "sm"){
        if($scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.scheduleRange || $scope.curAdvSearchCopy.createdBy){
          $scope.hasErr = false;
          $scope.searchProcessing = true;
          $scope.curAdvSearchCopy.scheduleDateRange = {startDate:moment($scope.curAdvSearch.scheduleDateRange.startDate).format("L"), endDate:moment($scope.curAdvSearch.scheduleDateRange.endDate).format("L")};
          $scope.curAdvSearchSM = {module:$scope.curAdvSearchCopy.module, sName:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, scheduleRange:$scope.curAdvSearchCopy.scheduleRange, scheduleDateRange:$scope.curAdvSearchCopy.scheduleDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, step:$scope.curAdvSearchCopy.step};

          //store search data for show after edit widget
          localStorage.removeItem("curFilterSMObj");
          localStorage.setItem("curFilterSMObj", JSON.stringify($scope.curAdvSearchSM));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.curAdvSearchCopy));
          localStorage.setItem("isSMAdvSearch", true);
          localStorage.removeItem("isActionOnSchedule");

          // TODO
          CommonSrv.updateAdvSearchS($scope.curAdvSearchSM).then(
            function(data){
              $scope.searchProcessing = false;
              $scope.filteredData = data;
              $scope.curAdvSearchCopy.isEmpty = data.isem;
              //TODO
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, schedules:{i:$scope.filteredData.i, g:$scope.filteredData.g, s:$scope.filteredData.s}, code:data.code, advObj:$scope.curAdvSearchSM};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              ngDialog.close($scope.confirmDialog);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          if(!$scope.curAdvSearchCopy.name){
            $("#adName").focus();
          }
        }
        return true;
      } else if($scope.curAdvSearch.module == "s"){
        if($scope.curAdvSearch.scheduleDateRange){
          $scope.curAdvSearchCopy.scheduleDateRange = {startDate:moment($scope.curAdvSearch.scheduleDateRange.startDate).format("L"), endDate:moment($scope.curAdvSearch.scheduleDateRange.endDate).format("L")};
        }
        if($scope.curAdvSearch.creationDateRange){
          $scope.curAdvSearchCopy.creationDateRange = {startDate:moment($scope.curAdvSearch.creationDateRange.startDate).format("L"), endDate:moment($scope.curAdvSearch.creationDateRange.endDate).format("L")};
        }
        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == "dt"){
          $scope.curAdvSearchCopy.offset = 0;
          var curDTypeS = angular.fromJson(localStorage.getItem("curDTypeS"));
          if(curDTypeS){
            $scope.curAdvSearchCopy.gtype = curDTypeS.type;
          }
        }
        if($rootScope.importXls.file){
          $scope.curAdvSearchCopy.dName = $rootScope.importXls.file;
          $scope.curAdvSearchCopy.excelData = $rootScope.importXls;
        }
        if($scope.curAdvSearchCopy.dName || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.scheduleRange || $scope.curAdvSearchCopy.createdBy || $scope.curAdvSearchCopy.sName || $scope.curAdvSearchCopy.os || $scope.curAdvSearchCopy.tag.include.length > 0 || $scope.curAdvSearchCopy.tag.exclude.length > 0 || ($scope.curAdvSearchCopy.prop && $scope.curAdvSearchCopy.prop.value) || $scope.curAdvSearchCopy.userGroup.include.length > 0 || $scope.curAdvSearchCopy.userGroup.exclude.length > 0 || $scope.curAdvSearchCopy.fil == "online" || $scope.curAdvSearchCopy.fil == "offline"){
          $scope.schType = $scope.curAdvSearchCopy.opt;
          $scope.searchProcessing = true;

          $scope.curAdvSearchCopyS = {dName:$scope.curAdvSearchCopy.dName, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, scheduleRange:$scope.curAdvSearchCopy.scheduleRange, scheduleDateRange:$scope.curAdvSearchCopy.scheduleDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, sName:$scope.curAdvSearchCopy.sName, os:$scope.curAdvSearchCopy.os, client:$scope.curAdvSearchCopy.client, tag:$scope.curAdvSearchCopy.tag, step:$scope.curAdvSearchCopy.step, prop:$scope.curAdvSearchCopy.prop, value:($scope.curAdvSearchCopy.prop?$scope.curAdvSearchCopy.prop.value:""),fil:$scope.curAdvSearchCopy.fil};


          if($scope.curAdvSearchCopy.fil != "all"){
            localStorage.setItem("filterType", JSON.stringify($scope.curAdvSearchCopy.fil));
          }
          //filter adv search with schedule type
          if($scope.schType != null){
            $scope.curAdvSearchCopy.ls = $scope.schType;
          }

          localStorage.setItem("curAdvSearchCopyS", JSON.stringify($scope.curAdvSearchCopy));

          if($scope.curAdvSearchCopy.module == "s"){
            IndexedDB.getItem("scuData", 0).then(function(item){
              if(item){
                $scope.curAdvSearchCopy.csdr = {s:item.schedule.dateRange.startDate, e:item.schedule.dateRange.endDate};
                CommonSrv.updateAdvSearch($scope.curAdvSearchCopy).then(
                  function(data){
                    $scope.searchProcessing = false;
                    $scope.filteredData = data;
                    // $scope.auth = $cookies.getObject("auth");
                    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
                    $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
                    if(data.info.rdc || data.info.rdc == 0){
                      $scope.curAdvSearchCopy.rdc = data.info.rdc;
                    }
                    $scope.curAdvSearchCopy.sortType = data.info.sortType;
                    $scope.curAdvSearchCopy.sortVal = data.info.sortVal;
                    $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchCopy, t:data.t};
                    if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == "dt"){
                      $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
                    } else{
                      $scope.advSearchfilteredData.dInfo = {allIds:$scope.filteredData.info.allIds, count:$scope.filteredData.info.count};
                    }
                    $rootScope.clearSearch = true;
                    $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                    ngDialog.close($scope.confirmDialog);
                  },
                  function(err){
                    $log.error(err);
                    $scope.searchProcessing = false;
                  }
                );
              }
            }).catch(function(error){
              console.error(error);
            });
          } else{
            // TODO
            // CommonSrv.updateAdvSearchS($scope.curAdvSearchCopy).then(
            CommonSrv.updateAdvSearch($scope.curAdvSearchCopy).then(
              function(data){
                $scope.searchProcessing = false;
                $scope.filteredData = data;
                // $scope.auth = $cookies.getObject("auth");
                $scope.auth = angular.fromJson(localStorage.getItem("auth"));
                $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
                if(data.info.rdc || data.info.rdc == 0){
                  $scope.curAdvSearchCopy.rdc = data.info.rdc;
                }
                $scope.curAdvSearchCopy.sortType = data.info.sortType;
                $scope.curAdvSearchCopy.sortVal = data.info.sortVal;
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchCopy, t:data.t};
                if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == "dt"){
                  $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
                } else{
                  $scope.advSearchfilteredData.dInfo = {allIds:$scope.filteredData.info.allIds, count:$scope.filteredData.info.count};
                }
                $rootScope.clearSearch = true;
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                ngDialog.close($scope.confirmDialog);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          }
        } else{
          $scope.hasErr = true;
          // if(!$scope.curAdvSearchCopy.dName){
            $("#adName").focus();
          // }
        }
      } else if($scope.curAdvSearch.module == "t"){
        if($scope.curAdvSearchCopy.type || $scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.createdBy){
          $scope.searchProcessing = true;
          $scope.curAdvSearchTm = {name:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, type:$scope.curAdvSearchCopy.type, step:$scope.curAdvSearchCopy.step};

          //store search data for show after edit widget
          localStorage.removeItem("curFilterTmObj");
          localStorage.setItem("curFilterTmObj", JSON.stringify($scope.curAdvSearchTm));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.curAdvSearchCopy));
          localStorage.setItem("isTmAdvSearch", true);
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.removeItem("isActionOnTemplate");

          CommonSrv.updateAdvSearchTM($scope.curAdvSearchTm).then(
            function(data){
              $scope.searchProcessing = false;
              $scope.filteredData = data;
              $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, template:$scope.filteredData.template, groups:$scope.filteredData.groups, folder:$scope.filteredData.folder, code:data.code, advObj:$scope.curAdvSearchTm};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              ngDialog.close($scope.confirmDialog);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          if(!$scope.curAdvSearchCopy.name){
            $("#adName").focus();
          }
        }
      } else if($scope.curAdvSearch.module == "inv"){
        if($scope.curAdvSearchCopy.dType || $scope.curAdvSearchCopy.oType || $scope.curAdvSearchCopy.searchId || $scope.curAdvSearchCopy.dName || $scope.curAdvSearchCopy.serial || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.createdBy){
          $scope.searchProcessing = true;
          if($scope.curAdvSearchCopy.step == "d"){
            $scope.curAdvSearchInv = {module:$scope.curAdvSearchCopy.module , status:$scope.curAdvSearchCopy.status, invType:$scope.curAdvSearchCopy.step,createdBy:"",dType:"",dName:"",searchId:"",id:0};
            if($scope.auth.upermissions.dp){
              $scope.curAdvSearchInv.offset = 0;
            }
            if($scope.curAdvSearchCopy.createdBy != undefined){
              $scope.curAdvSearchInv.createdBy = $scope.curAdvSearchCopy.createdBy.id;
            }
            if($scope.curAdvSearchCopy.creationRange == true){
              $scope.curAdvSearchInv.creationDateRange = $scope.curAdvSearchCopy.creationDateRange;
            }
            if($scope.curAdvSearchCopy.dType != undefined  || $scope.curAdvSearchCopy.dType == ""){
              $scope.curAdvSearchInv.dType = $scope.curAdvSearchCopy.dType;
            }
            if($scope.curAdvSearchCopy.dName != undefined || $scope.curAdvSearchCopy.dName == ""){
              $scope.curAdvSearchInv.dName = $scope.curAdvSearchCopy.dName;
            }
            if($scope.curAdvSearchCopy.searchId != undefined){
              $scope.curAdvSearchInv.searchId = $scope.curAdvSearchCopy.searchId;
            }
          } else{
            $scope.curAdvSearchInv = {module:$scope.curAdvSearchCopy.module , status:$scope.curAdvSearchCopy.status, invType:$scope.curAdvSearchCopy.step,createdBy:"",oType:"",serial:"",id:0};
            if($scope.auth.upermissions.dp){
              $scope.curAdvSearchInv.offset = 0;
            }
            if($scope.curAdvSearchCopy.createdBy != undefined){
              $scope.curAdvSearchInv.createdBy = $scope.curAdvSearchCopy.createdBy.id;
            }
            if($scope.curAdvSearchCopy.creationRange == true){
              $scope.curAdvSearchInv.creationDateRange = $scope.curAdvSearchCopy.creationDateRange;
            }
            if($scope.curAdvSearchCopy.oType != undefined || $scope.curAdvSearchCopy.oType == ""){
              $scope.curAdvSearchInv.oType = $scope.curAdvSearchCopy.oType.id;
            }
            if($scope.curAdvSearchCopy.name != undefined){
              $scope.curAdvSearchInv.name = $scope.curAdvSearchCopy.name;
            }
            if($scope.curAdvSearchCopy.serial != undefined){
              $scope.curAdvSearchInv.serial = $scope.curAdvSearchCopy.serial;
            }
          }

          //store search data for show after edit widget
          localStorage.removeItem("curFilterInvObj");
          localStorage.setItem("curFilterInvObj", JSON.stringify($scope.curAdvSearchInv));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.curAdvSearchCopy));
          localStorage.setItem("isInvAdvSearch", true);
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.removeItem("isActionOnInventory");

          CommonSrv.updateAdvSearchInv($scope.curAdvSearchInv).then(
            function(data){
              $scope.searchProcessing = false;
              $scope.filteredData = data;
              $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, inventory:$scope.filteredData.data, invInfo:$scope.filteredData, code:data.code, advObj:$scope.curAdvSearchInv};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              ngDialog.close($scope.confirmDialog);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
        }
      } else{
        // console.log("Inner");
        if($scope.curAdvSearch.scheduleDateRange){
          $scope.curAdvSearchCopy.scheduleDateRange = {startDate:moment($scope.curAdvSearch.scheduleDateRange.startDate).format("L"), endDate:moment($scope.curAdvSearch.scheduleDateRange.endDate).format("L")};
        }
        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == "dt"){
          $scope.curAdvSearchCopy.offset = 0;
          var curDType = angular.fromJson(localStorage.getItem("curDType"));
          if(curDType){
            $scope.curAdvSearchCopy.gtype = curDType.type;
          }
        }
        if($scope.auth.upermissions.dp){
          $scope.curAdvSearchCopy.offset = 0;
        }

        if($rootScope.importXls.file){
          $scope.curAdvSearchCopy.dName = $rootScope.importXls.file;
          $scope.curAdvSearchCopy.excelData = $rootScope.importXls;
        }

        if($scope.curAdvSearchCopy.dName || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.scheduleRange || $scope.curAdvSearchCopy.createdBy || $scope.curAdvSearchCopy.sName || $scope.curAdvSearchCopy.os || $scope.curAdvSearchCopy.tag.include.length > 0 || $scope.curAdvSearchCopy.tag.exclude.length > 0 || ($scope.curAdvSearchCopy.prop && $scope.curAdvSearchCopy.prop.value) || $scope.curAdvSearchCopy.userGroup.include.length > 0 || $scope.curAdvSearchCopy.userGroup.exclude.length > 0 || $scope.curAdvSearchCopy.fil == "online" || $scope.curAdvSearchCopy.fil == "offline"){
          $scope.searchProcessing = true;
          // if (!$scope.auth.upermissions.dp) {
          //   delete $scope.curAdvSearchCopy.offset;
          // }
          $scope.curAdvSearchDl = {dName:$scope.curAdvSearchCopy.dName, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, scheduleRange:$scope.curAdvSearchCopy.scheduleRange, scheduleDateRange:$scope.curAdvSearchCopy.scheduleDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, sName:$scope.curAdvSearchCopy.sName, os:$scope.curAdvSearchCopy.os ,client:$scope.curAdvSearchCopy.client, tag:$scope.curAdvSearchCopy.tag, step:$scope.curAdvSearchCopy.step, prop:$scope.curAdvSearchCopy.prop, value:($scope.curAdvSearchCopy.prop ? $scope.curAdvSearchCopy.prop.value : ''),fil:$scope.curAdvSearchCopy.fil};
          //store search data for show after edit widget
          localStorage.removeItem("curFilterDlObj");
          localStorage.setItem("curFilterDlObj", JSON.stringify($scope.curAdvSearchDl));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.curAdvSearchCopy));
          localStorage.setItem("isDlAdvSearch", true);
          localStorage.removeItem("isActionOnDevice");

          localStorage.setItem("filterType", JSON.stringify($scope.curAdvSearchCopy.fil));
          // if($scope.curAdvSearchCopy.fil == "all"){
          //   delete $scope.curAdvSearchCopy.fil;
          // } else {
          //   localStorage.setItem("filterType", JSON.stringify($scope.curAdvSearchCopy.fil));
          // }

          if($scope.curAdvSearch.opt == 'videowall'){
            $scope.curAdvSearchCopy.vdw = true;
            if($scope.curAdvSearch.id){
              $scope.curAdvSearchCopy.vdwId = $scope.curAdvSearch.id;
            }
          }

          $scope.curAdvSearchCopy.offset = 0;
          CommonSrv.updateAdvSearch($scope.curAdvSearchCopy, $scope.auth).then(
            function(data){
              $scope.searchProcessing = false;
              $scope.filteredData = data;
              // $scope.auth = $cookies.getObject("auth");
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
              $scope.curAdvSearchCopy.rdc = data.info.rdc;
              $scope.curAdvSearchCopy.sortType = data.info.sortType;
              $scope.curAdvSearchCopy.sortVal = data.info.sortVal;
              $scope.curAdvSearchCopy.vl = data.info.vl ? data.info.vl : data.info.tc;
              // console.log($scope.curAdvSearchCopy, data);
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchCopy, t:data.t, deviceInfo:data.info};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == "dt"){
                $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:$scope.filteredData.info.allIds, count:$scope.filteredData.info.count};
              }

              if($scope.auth.upermissions.dp){
                $scope.advSearchfilteredData.info.count = $scope.filteredData.info.count;
              }
              $rootScope.clearSearch = true;
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              ngDialog.close($scope.confirmDialog);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.hasErr = true;
          $("#adDName").focus();
        }
      }
    }

    $rootScope.avTagList = [];
    $rootScope.inTagList = [];
    $rootScope.exTagList = [];
    $scope.selTagFx = function(caller, selectedItems, tagList){
      angular.forEach(tagList, function(item){
        if(item.id == selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            $scope.curAdvSearchModel.includeTag = [];
            $scope.curAdvSearchModel.excludeTag = [];
            if(item.selected){
              $rootScope.avTagList.push(item);
            } else{
              angular.forEach($rootScope.avTagList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.avTagList.splice(i, 1);
                }
              });
            }
          } else if(caller == "i" || caller == "e"){
            if(!$rootScope.avTagList.length){
              $rootScope.avTagList = [];
            }
            $scope.curAdvSearchModel.avTagList = [];
            if(item.selected){
              if(caller == "i"){
                $rootScope.inTagList.push(item);
              } else {
                $rootScope.exTagList.push(item);
              }
            } else{
              if(caller == "i"){
                angular.forEach($rootScope.inTagList, function(listItem, i){
                  if(!listItem.selected || listItem.id == selectedItems.id){
                    $rootScope.inTagList.splice(i, 1);
                  }
                });
              } else {
                angular.forEach($rootScope.exTagList, function(listItem, i){
                  if(!listItem.selected || listItem.id == selectedItems.id){
                    $rootScope.exTagList.splice(i, 1);
                  }
                });
              }
            }
          }
          $scope.curAdvSearchModel = {availableTag:$rootScope.avTagList, includeTag:$rootScope.inTagList, excludeTag:$rootScope.exTagList};
        }
      });

      $scope.allGroups = $scope.advSearch.userGroupList.concat($scope.curAdvSearch.userGroup.include, $scope.curAdvSearch.userGroup.exclude);
      if($scope.allGroups.length){
        $scope.deSelAllGrpFx(null, $scope.allGroups);
      }
    }
    $scope.deSelAllTagFx = function(caller, tagList){
      angular.forEach(tagList, function(item){
        item.selected = false;
      });
      if(caller == "a"){
        $rootScope.avTagList = [];
        $scope.curAdvSearchModel.availableTag = [];
      } else if(caller == "i"){
        $rootScope.inTagList = [];
        $scope.curAdvSearchModel.includeTag = [];
      } else if(caller == "e"){
        $rootScope.exTagList = [];
        $scope.curAdvSearchModel.excludeTag = [];
      } else{
        $rootScope.avTagList = [];
        $rootScope.inTagList = [];
        $rootScope.exTagList = [];
        $scope.curAdvSearchModel.availableTag = [];
        $scope.curAdvSearchModel.includeTag = [];
        $scope.curAdvSearchModel.excludeTag = [];
      }
    }
    //Reset selected devices, groups and tag list
    $rootScope.resetTagFx = function(caller, type){
      if(type == "incTag" || type == "excTag"){
        $rootScope.avTagList = [];
        $scope.curAdvSearchModel = {availableTag:[], includeTag:$rootScope.inTagList, excludeTag:$rootScope.exTagList};
      } else if(type == "remTag"){
        $rootScope.inTagList = [];
        $rootScope.exTagList = [];
        $scope.curAdvSearchModel = {availableTag:$rootScope.avTagList, includeTag:[], excludeTag:[]};
      } else{
        $rootScope.avTagList = [];
        $rootScope.inTagList = [];
        $rootScope.exTagList = [];
        if($scope.advSearch.tagList || $scope.curAdvSearch.tag){
          $scope.allTags = $scope.advSearch.tagList.concat($scope.curAdvSearch.tag.include, $scope.curAdvSearch.tag.exclude);
          if($scope.allTags.length){
            $scope.deSelAllTagFx(null, $scope.allTags);
          }
        }
      }
      $scope.tagSearch.text = "";
      $scope.tagIncSearch.text = "";
      $scope.tagExcSearch.text = "";
    }


    $rootScope.avGrpList = [];
    $rootScope.inGrpList = [];
    $rootScope.exGrpList = [];
    $scope.selGrpFx = function(caller, selectedItems, grpList){
      angular.forEach(grpList, function(item){
        if(item.id == selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            $scope.curAdvSearchModel.includeGroup = [];
            $scope.curAdvSearchModel.excludeGroup = [];
            if(item.selected){
              $rootScope.avGrpList.push(item);
            } else{
              angular.forEach($rootScope.avGrpList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.avGrpList.splice(i, 1);
                }
              });
            }
          } else if(caller == "i" || caller == "e"){
            if(!$rootScope.avGrpList.length){
              $rootScope.avGrpList = [];
            }
            $scope.curAdvSearchModel.avGrpList = [];
            if(item.selected){
              if(caller == "i"){
                $rootScope.inGrpList.push(item);
              } else{
                $rootScope.exGrpList.push(item);
              }
            } else{
              if(caller == "i"){
                angular.forEach($rootScope.inGrpList, function(listItem, i){
                  if(!listItem.selected || listItem.id == selectedItems.id){
                    $rootScope.inGrpList.splice(i, 1);
                  }
                });
              } else{
                angular.forEach($rootScope.exGrpList, function(listItem, i){
                  if(!listItem.selected || listItem.id == selectedItems.id){
                    $rootScope.exGrpList.splice(i, 1);
                  }
                });
              }
            }
          }
          $scope.curAdvSearchModel = {availableGroup:$rootScope.avGrpList, includeGroup:$rootScope.inGrpList, excludeGroup:$rootScope.exGrpList};
        }
      });

      $scope.allTags = $scope.advSearch.tagList.concat($scope.curAdvSearch.tag.include, $scope.curAdvSearch.tag.exclude);
      if($scope.allTags.length){
        $scope.deSelAllTagFx(null, $scope.allTags);
      }
    }
    $scope.deSelAllGrpFx = function(caller, grpList){
      angular.forEach(grpList, function(item){
        item.selected = false;
      });
      if(caller == "a"){
        $rootScope.avGrpList = [];
        $scope.curAdvSearchModel.availableGroup = [];
      } else if(caller == "i"){
        $rootScope.inGrpList = [];
        $scope.curAdvSearchModel.includeGroup = [];
      } else if(caller == "e"){
        $rootScope.exGrpList = [];
        $scope.curAdvSearchModel.excludeGroup = [];
      } else{
        $rootScope.avGrpList = [];
        $rootScope.inGrpList = [];
        $rootScope.exGrpList = [];
        $scope.curAdvSearchModel.availableGroup = [];
        $scope.curAdvSearchModel.includeGroup = [];
        $scope.curAdvSearchModel.excludeGroup = [];
      }
    }
    //Reset selected devices, groups and group list
    $rootScope.resetGrpFx = function(type){
      if(type == "incGrp" || type == "excGrp"){
        $rootScope.avGrpList = [];
        $scope.curAdvSearchModel = {availableGroup:[], includeGroup:$rootScope.inGrpList, excludeGroup:$rootScope.exGrpList};
      } else if(type == "remGrp"){
        $rootScope.inGrpList = [];
        $rootScope.exGrpList = [];
        $scope.curAdvSearchModel = {availableGroup:$rootScope.avGrpList, includeGroup:[], excludeGroup:[]};
      } else{
        $rootScope.avGrpList = [];
        $rootScope.inGrpList = [];
        $rootScope.exGrpList = [];
        $scope.allGroups = $scope.advSearch.userGroupList.concat($scope.curAdvSearch.userGroup.include, $scope.curAdvSearch.userGroup.exclude);
        if($scope.allGroups.length){
          $scope.deSelAllGrpFx(null, $scope.allGroups);
        }
      }
      $scope.grpSearch.text = "";
      $scope.grpIncSearch.text = "";
      $scope.grpExcSearch.text = "";
    }

    $scope.nfKey = function(val){
      if(val == "n"){
        $('#excelFile').val("");
        $rootScope.importXls = {file:""};
      }
      if(val == "f"){
        $scope.curAdvSearch.dName = "";
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AddtoScheduleController', AddtoScheduleController);

  /** @ngInject */
  function AddtoScheduleController($log, $rootScope, $scope, $state, ngDialog, SchedulesSrv){
    $scope.saveProcessing = false;
    $scope.hasErrList = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.isChecked = {};
    $scope.curSplId = [];
    // if($scope.selectedTab!='hub.contentLibrary.c'){
    //   $scope.checkedFx = function(id){
    //     if($scope.isChecked[id]){
    //       $scope.curSplId.push(id);
    //     } else{
    //       $scope.curSplId.splice($scope.curSplId.indexOf(id), 1);
    //     }
    //   }
    // }

    $scope.addToScheduleFx = function(caller){
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      $scope.hasErr = false;
      $scope.errorList = "";
      $scope.errType = "";
      var isIdtype;
      $scope.curUncheckSch = [];

      $scope.curSplId = $scope.scheduleList.filter(function(item){
        return item.isChecked;
      }).map(function(item){
        return item.id;
      });

      if($scope.selectedSch && $scope.selectedSch.length){
        $scope.curUncheckSch = $scope.selectedSch.filter(function(item){
          return !$scope.curSplId.includes(item);
        })
      }
      if($scope.curSplId.length == 0 && $rootScope.selectedItems.length > 1 || $scope.curSplId.length == 0 && $scope.curUncheckSch.length == 0){
        $scope.errType = "empty";
        $scope.hasErr = true;
        return false;
      }
      $scope.saveProcessing = true;

      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type.toLowerCase() == "sharepoint"){
          isIdtype = "sp";
          item.fid = item.id;
        }
        if(item.type.toLowerCase() == "onedrive"){
          isIdtype = "spl";
          item.fid = item.id;
        }
        if(item.type.toLowerCase() == "googledrive"){
          isIdtype = "spl";
          item.fid = item.id;
        }
        if(item.type.toLowerCase() == "excelfolder"){
          item.type = "folder";
        }
      });
      if($scope.contentLibrary){
        //set isActionOnContent true if adv search applied
        if(localStorage.getItem("isAdvSearch")){
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.setItem("isActionOnContent", true);
        } else{
          localStorage.removeItem("isActionOnContent");
          localStorage.removeItem("curFilterObj");
          localStorage.removeItem("isAdvSearch");
        }
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(content){
          angular.forEach($rootScope.selectedItems, function(item){
            if(item.type.toLowerCase() == "sharepointc" && content.id == item.id){
              isIdtype = "sp";
              item.size = content.size;
              item.label = content.label;
              item.spfid = content.spfid;
              item.width = content.width;
              item.splFid = content.splFid;
              item.height = content.height;
              item.Length = content.Length;
              item.duration = content.duration;
              item.MajorVersion = content.MajorVersion;
              item.fid = JSON.parse($scope.curFolderId);
              item.ServerRelativeUrl = content.ServerRelativeUrl;
            }
            if(item.type.toLowerCase() == "onedrivec" && content.id == item.id){
              isIdtype = "spl";
              item.size = content.size;
              item.label = content.label;
              item.width = content.width;
              item.height = content.height;
              item.splFid = content.splFid;
              item.duration = content.duration;
              item.fid = JSON.parse($scope.curFolderId);
            }
            if(item.type.toLowerCase() == "googledrivec" && content.id == item.id){
              isIdtype = "spl";
              item.size = content.size;
              item.label = content.label;
              item.width = content.width;
              item.height = content.height;
              item.splFid = content.splFid;
              item.duration = content.duration;
              item.fid = JSON.parse($scope.curFolderId);
            }
          });
        });
      }

      if($rootScope.selectedItems.length == 1){
        var tempSelectedItems = angular.copy($rootScope.selectedItems);
        angular.forEach(tempSelectedItems, function(item){
          if(item.type.toLowerCase() == "sharepoint"){
            isIdtype = "sp";
            item.fid = item.id;
            item.type = item.type.toLowerCase();
          }
          if(item.type.toLowerCase() == "onedrive"){
            isIdtype = "spl";
            item.fid = item.id;
            item.type = item.type.toLowerCase();
          }
          if(item.type.toLowerCase() == "googledrive"){
            isIdtype = "spl";
            item.fid = item.id;
            item.type = item.type.toLowerCase();
          }
          if(item.type.toLowerCase() == "excelfolder"){
            item.type = "folder";
          }
        });
        $scope.addToSchedule = {ids:tempSelectedItems};
      } else{
        $scope.addToSchedule = {ids:$rootScope.selectedItems};
      }

      $scope.addToSchedule.sid = $scope.curSplId;
      // if($scope.selectedTab=='hub.contentLibrary.c'){
        $scope.addToSchedule.rsid = $scope.curUncheckSch;
      // }

      if($state.current.name == "hub.templates.t"){
        $scope.addToSchedule.module = "t";
      } else{
        $scope.addToSchedule.module = "cl";
      }
      if(caller == "rs"){
        $scope.addToSchedule.isRemoved = true;
      }

      SchedulesSrv.updateAddToSchedules($scope.addToSchedule).then(
        function(data){
          $scope.saveProcessing = false;
          if(!data.code){
            $scope.errorList = data;
          } else if(data.code == 10034){
            $scope.errType = "contentConfig";
            $scope.hasErr = true;
          } else if(data.code == 10038){
            $scope.errType = $state.current.name == "hub.templates.t" ? "tFolderConfig" : "folderConfig";
            $scope.hasErr = true;
          } else if(data.code == 10060){
            $scope.errType = "imgConfig";
            $scope.hasErr = true;
          } else if(data.code == 10061){
            $scope.errType = "widConfig";
            $scope.hasErr = true;
          } else if(data.code == 10067){
            $scope.errType = "codError";
            $scope.hasErr = true;
          } else if(data.code == 10068){
            $scope.errType = "codWError";
            $scope.hasErr = true;
          } else if(data.code == 10069){
            $scope.errType = "cgError";
            $scope.hasErr = true;
          } else if(data.code == 10070){
            $scope.errType = "eslCError";
            $scope.hasErr = true;
          } else if(data.code == 10073){
            $scope.errType = "codWError";
            $scope.hasErr = true;
          } else if(data.code == 10066){
            $scope.errType = "overrideError";
            $scope.hasErr = true;
          } else if(data.code == 8663){
            ngDialog.open({
              template:'\
                <section class="panel">\
                  <div class="panel-body">\
                  <span ng-if="addToSchedule.module!=\'t\'">{{\'cl.msg.58\' | translate}}</span>\
                  <span ng-if="addToSchedule.module==\'t\'">{{\'cl.msg.59\' | translate}}</span>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="addToScheduleFx(\'rs\');" focus-me="true" ng-disabled="confirmProcessing">\
                      <span class="fa fa-repeat fa-spin fa-fw" ng-if="confirmProcessing" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
                    </button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm',
              preCloseCallback:function(){
                $scope.isConfirmOpen = false;
              }
            });
          } else{
            $scope.hasErr = false;
            ngDialog.close();
            if(!$scope.ngDialogData || $scope.ngDialogData.actionFrom != 'pin'){
              $scope.loadSelectedTab();
            }
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $scope.errType = "";
          $log.error(err);
        }
      );
    }
  }
})();

(function(){
    'use strict';

    angular
      .module('hub')
      .controller('AddToDashboardController', AddToDashboardController);

    /** @ngInject */
    function AddToDashboardController($log, $scope, $rootScope, $state, ngDialog, AddToDashboardSrv){
      $scope.saveProcessing = false;
      $scope.popupLoading = true;
      $scope.isTagEmpty = false;
      $scope.curUserList = {};
      $scope.hasErr = false;
      $scope.errType = "";
      AddToDashboardSrv.getDashboardUser($scope.curUserObj.type).then(
        function(data){
          $scope.popupLoading = false;
          $scope.curUser = {availableUser:[], assignedUser:[]};
          $scope.curUser.availableUser = data.userList;
        }
      );

      $scope.saveUserFx = function(){
        $scope.hasErr = false;
        $scope.errType = "";
        if(!$scope.curUser.assignedUser.length){
          $scope.hasErr = true;
          $scope.errType = "user";
        } else{
          $scope.saveProcessing = true;
          $scope.saveData = {userList:$scope.curUser.assignedUser};
          AddToDashboardSrv.saveAddUser($scope.saveData).then(
            function(data){
              if(data.code && data.code == 12021){
                $scope.saveProcessing = false;
                $scope.errType = "exists";
                $scope.hasErr = true;
              } else if(data.code && data.code == 12039){
                $scope.saveProcessing = false;
                $scope.errType = "mcDevice";
                $scope.hasErr = true;
              } else if(data.code == 12090){
                $scope.errType = "eslError";
                $scope.hasErr = true;
              } else if(data.code == 12042){
                $scope.saveProcessing = false;
                $scope.curData = data;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <div>{{"d.p_dg.m4" | translate}}</div>\
                        <div class="table marT15">\
                          <div class="row th">\
                            <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                          </div>\
                          <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                            <div class="row" ng-repeat="err in curData.devices">\
                              <div class="col-xs-12 word-break">{{err}}</div>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                      </div>\
                    </section>',
                  plain:true,
                  width:700,
                  scope:$scope,
                  data:$scope.curData,
                  closeByDocument:false,
                  className:"ngdialog-theme-default ngdialog-confirm"
                });
              } else{
                ngDialog.close();
                $scope.loadSelectedTab();
              }
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
        }
      }

      $scope.makeDefaultFx = function(){
        AddToDashboardSrv.makeDefault().then(
          function(data){
            ngDialog.close();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
  })();
(function(){
  'use strict';

  angular
    .module('hub')
    .factory('xmlToJsonFactory', xmlToJsonFactory);

  /** @ngInject */
  function xmlToJsonFactory($http, $cacheFactory, $rootScope){
    var factory = [];

    factory.getJSONData = function(xmlPath){
      return $http.get(xmlPath);
    }
    return factory;
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .factory('colorPickerFactory', colorPickerFactory);

  /** @ngInject */
  function colorPickerFactory($http, $cacheFactory, $rootScope){
    var colorFactory = {};
    var cache = $cacheFactory('getCustomColors');
    colorFactory.getCustomColors = function(){
      var colorURL = $rootScope.apiHost + "common/customColors";
      return cache.get(colorURL) || cache.put(colorURL, $http.get(colorURL)
        .then(function(response){
          return response.data;
        })
      )
    };
    return colorFactory;
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TimezoneController', TimezoneController);

  /** @ngInject */
  function TimezoneController($scope, $rootScope){

    if($scope.timezone && $scope.timezone.label){
      angular.forEach($scope.timezoneList, function(list){
        if(list.label === $scope.timezone.label){
          $scope.curTimeZone = list;
        }
      });
    } else{
      $scope.curTimeZone = {};
    }

    $scope.selectTimeZone = function(timezone){
      $scope.curTimeZone = timezone;
      $scope.timezone.label = timezone.label;
    }

    $scope.searchFilter = function (tz) {
      if (!$scope.searchList) return true;
      var search = $scope.searchList.toLowerCase();
      return (
        tz.label.toLowerCase().includes(search) ||
        tz.zone.toLowerCase().includes(search) ||
        tz.tag.toLowerCase().includes(search)
      );
    };
    
    // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };
	}
})();

(function() {
	'use strict';

	angular
		.module('hub')
		.controller('PinItemsController', PinItemsController);

	/** @ngInject */
	function PinItemsController($log, $rootScope, $scope, $cookies, $filter, $state, $interval, ContentLibrarySrv, DashboardSrv, CommonSrv, SchedulesSrv, DevicesSrv, TemplatesSrv, ngDialog) {

    $scope.inputLimit = 100;
		$scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.curExtn = {id:"", type:"", extn:""};
		$scope.cpinLoading = false;
		$scope.thumbSize = 'n'; //sm, n, md, lg, xl
    $scope.searchRegExp = new RegExp("'", "gi");
    $scope.searchReplaceChar = "&apos;"//&apos; &#39;
    $scope.pinItems = [];
    $scope.contentList = [];
    // $scope.dbPinItems = $scope.pinItemsList;
    $scope.contentLibrary = [];
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.templates = {templates:[], folders:[], info:""};
    $scope.devices = {devices:[], folders:[],info:""};
    $scope.schedules = {schedules:[]};

    $scope.getAvailableHeight = function(deductableHeight){
      if(document.body && document.body.offsetWidth){
        $scope.winH = document.body.offsetHeight;
      }
      if(document.compatMode == 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth){
        $scope.winH = document.documentElement.offsetHeight;
      }
      if(window.innerWidth && window.innerHeight){
        $scope.winH = window.innerHeight;
      }
      $scope.winH = $scope.winH - deductableHeight;
      return $scope.winH;
    }

    $scope.$on('pinitemClear', function(){
      $scope.searchPin={text:''};
    });

    $rootScope.loadPinnedItems = function(){
      $scope.searchPin={text:''};
      // if(!angular.isArray($scope.dbPinItems)){
        $scope.pinItemsLoading = true;
        DashboardSrv.getPinnedItems().then(
          function(data){
            $scope.pinItems = data.pinItems;

            if(Array.isArray($scope.pinItems) && $scope.pinItems.length == 0){
              $scope.pinItemsLoading = false;
              return;
            }

            if(!Array.isArray(data.pinItems.devices)){
              $scope.devices = {devices:data.pinItems.devices.devices, folders:data.pinItems.devices.folders, info:data.pinItems.devices.info};
            }
            if(!Array.isArray(data.pinItems.content)){
              $scope.contentLibrary = {contentLibrary:data.pinItems.content, info:data.pinItems.content.info};
            }
            if(!Array.isArray(data.pinItems.schedules)){
              $scope.schedules = data.pinItems.schedules;
            }
            if(!Array.isArray(data.pinItems.templates)){
              if(data.pinItems.templates.templates.length){
                $scope.templates.templates = data.pinItems.templates.templates;
              }
              if(data.pinItems.templates.folders && data.pinItems.templates.folders.length){
                $scope.templates.folders = data.pinItems.templates.folders;
              }
              $scope.templates.info = data.pinItems.templates.info;
            }
            $scope.pinItemsLoading = false;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
            $scope.pinItemsLoading = false;
          }
        );
      // }
    }
    $rootScope.loadPinnedItems();

		$scope.updateList = function(){
      $scope.contentList= [];
			if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.folder) {
				$scope.folderList = $scope.contentLibrary.contentLibrary.folder;
			}
			if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.content) {
				$scope.contentList = $scope.contentLibrary.contentLibrary.content;
			}
			if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.groups) {
				$scope.contentGroup = $scope.contentLibrary.contentLibrary.groups;
			}

      if($scope.templates.info){
        $scope.tim = $scope.templates.info.timthumb;
        $scope.tBucket = $scope.tDetailBucket = $scope.templates.info.bucket;
        if($scope.templates.info.mbucket && $scope.templates.info.mbucket != ""){
          $scope.tDetailBucket = $scope.templates.info.mbucket;
        }
      }

      if($scope.templates.templates && $scope.templates.templates.folder){
        $scope.tFolderList = $scope.templates.templates.folder;
      }
      if($scope.templates.templates && $scope.templates.templates.template){
        $scope.templateList = $scope.templates.templates.template;
      }
      if($scope.templates.templates && !$scope.templates.templates.folder && !$scope.templates.templates.template){
        $scope.templateList = $scope.templates.templates;
      }
		}

		$scope.getActionBtns = function(obj, caller){
      // console.warn("getActionBtns ", caller, obj);
			$scope.contextMenuOpt = [];
      $scope.loadMenuItems = true;
      if(obj.status && obj.status.toLowerCase()=="archived"){
        $scope.status = "archive";
      } else if(obj.status && obj.status.toLowerCase()=="deleted"){
        $scope.status = "delete";
      } else if(obj.status && obj.status.toLowerCase()=="approved"){
        $scope.status = "approve";
      } else if(obj.status && obj.status.toLowerCase()=="expired"){
        $scope.status = "expire";
      } else if(obj.status && obj.status.toLowerCase()=="unapproved"){
        $scope.status = "unapprove";
      } else {
        $scope.status = "";
      }


			if(caller == "content" || caller=="folder"){
        $rootScope.selectedItems = [];
        if(caller=="folder"){
          angular.forEach($scope.contentLibrary.contentLibrary.folder, function(folder){
            if(folder.id == obj.id){
              $rootScope.selectedItems.push({
                id: folder.id,
                type: folder.type.toLowerCase(),
                pid: folder.id,
                splId: folder.splId,
                subType: 'f'
              });
            }
          });
        } else {
          $rootScope.selectedItems.push({
            id: obj.id,
            type: obj.type == 'Widget'?'widget':obj.type=='SharePointC'?'SharePointC':obj.type=='OneDriveC'?'OneDriveC':obj.type=='GoogleDriveC'?'GoogleDriveC':'content',
            pid: obj.pid,
            splId: obj.splId,
            subType: obj.type
          });
        }

				ContentLibrarySrv.getCLActionBtn($scope.status, $rootScope.selectedItems).then(
					function(data){
						$scope.updateContextMenu(data, "content");
            $scope.loadMenuItems = false;
					},
					function(err){
						$log.error(err);
					}
				);
			} else if(caller == "device"){
				$scope.dObj = [{ id:obj.id, type:obj.type.toLowerCase(), subType: (obj.type.toLowerCase() =="folder" ? 'f' : 'device'), splId:obj.splId, spid:obj.spid, pid:obj.pid }];
				CommonSrv.getDeviceBtn($scope.dObj).then( /*Button api*/
					function(data){
						$scope.updateContextMenu(data, "device");
            $scope.loadMenuItems = false;
					},
					function(err){
						$log.error(err);
					}
				);
			} else if(caller == "schedule"){
        $scope.sObj = [{id:obj.id}];
        CommonSrv.getScheduleBtn($scope.sObj).then( /*Button api*/
          function(data){
            $scope.updateContextMenu(data, "schedule");
            $scope.loadMenuItems = false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "template"){
        if(obj.type.toLowerCase() == "folder"){
          $scope.tObj = [{id:obj.id, pid:obj.pid, splId:obj.splId, subType:(obj.type.toLowerCase() =="folder" ?'f':0), type:obj.type}];
        } else {
          if(obj.status == 'incompleted' || obj.status == 'unapproved'){
            $scope.tObj = [{id:obj.id, type:'template'}];
          } else {
            // $scope.tObj = [{id:obj.id, type:obj.type, subType:0}];
            $scope.tObj = [{id:obj.id, type:'template', subType:obj.type}];
          }
        }
        CommonSrv.getTemplateBtn($scope.tObj).then(
          function(data){
            $scope.updateContextMenu(data, "template");
            $scope.loadMenuItems = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
		}


		/*ContextMenu*/
    $scope.deviceBtn = ["dEdit","dPreview","dUnPin","dOpenFolder","dEditFolder"];
    $scope.scheduleBtn = ["sEdit","sUnPin"];
    $scope.templateBtn = ["tOpen","tEdit","tSchedule","tAddToSchedule","tUnPin","tOcFolder"];
    $scope.contentBtn = ["clOpenFolder","clEdit","clSchedule","clAddToSchedule","clUnPinItems","ocFolder"];
    $scope.updateContextMenu = function(menuList, caller){
      $scope.contextMenuOpt = [];
      menuList.buttons = menuList.buttons.filter(function(item){
        if(caller=="device"){
          if($scope.deviceBtn.includes(item.key)){
            return item;
          }
        } else if(caller=="content"){
          if($scope.contentBtn.includes(item.key)){
            return item;
          }
        } else if(caller=="schedule"){
          if($scope.scheduleBtn.includes(item.key)){
            return item;
          }
        } else if(caller=="template"){
          if($scope.templateBtn.includes(item.key)){
            return item;
          }
        }
      })
      angular.forEach(menuList.buttons, function(menuItem){
        if(caller=="content"){
          if(menuItem.key=="clOpenFolder"){
            $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
          } else if(menuItem.key == "clEdit"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.22');
          } else if(menuItem.key=="clSchedule"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.27');
          } else if(menuItem.key=="clAddToSchedule"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.28');
          } else if(menuItem.key=="clUnPinItems"){
            $scope.menuItemLabel = $filter("translate")('cm.label.99');
          } else if(menuItem.key=="ocFolder"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.46');
          }
          $scope.curIndex = $scope.contextMenuOpt.length;
          $scope.contextMenuOpt.push([$scope.menuItemLabel, menuItem.key]);
        } else if(caller=="device"){
          if (menuItem.key == "dOpenFolder") {
            $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
          } else if(menuItem.key == "dEdit" || menuItem.key == "dEditFolder"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
          } else if(menuItem.key=="dPreview"){
            $scope.menuItemLabel = $filter("translate")('d.btn.7');
          } else if (menuItem.key == "dUnPin") {
            $scope.menuItemLabel = $filter("translate")('cm.label.99');
          }

          $scope.curIndex = $scope.contextMenuOpt.length;
          $scope.contextMenuOpt.push([$scope.menuItemLabel, menuItem.key]);
          if(menuItem.key == "dEdit"){
            $scope.tempSubMenu = [];
            angular.forEach(menuItem.steps, function(subMenuItem){
              if(subMenuItem.key == "dStep1"){
                $scope.subMenu = $filter("translate")('d.btn.4');
              } else if(subMenuItem.key == "dStep2"){
                $scope.subMenu = $filter("translate")('d.btn.5');
              } else if(subMenuItem.key == "dStep3"){
                $scope.subMenu = $filter("translate")('d.btn.6');
              } else if(subMenuItem.key == "dtStep1"){
                $scope.subMenu = $filter("translate")('cm.brief.1');
              } else if(subMenuItem.key == "dtStep2"){
                $scope.subMenu = $filter("translate")('cm.label.31');
              } else if(subMenuItem.key == "dgStep1"){
                $scope.subMenu = $filter("translate")('cm.brief.1');
              } else if(subMenuItem.key == "dgStep2"){
                $scope.subMenu = $filter("camelCase")($filter("translate")('d.btn.13'));
                /*Without tag*/
                // $scope.subMenu = $filter("camelCase")($filter("translate")('cm.label.31'));
              } else if(subMenuItem.key == "tStep1"){
                $scope.subMenu = $filter("translate")('fl.btn.5');
              } else if(subMenuItem.key == "tStep2"){
                $scope.subMenu = $filter("translate")('cm.btn.20');
              }
              $scope.tempSubMenu.push([$scope.subMenu, subMenuItem]);
            });
            $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
          }
        } else if(caller=="schedule"){
          if(menuItem.key == "sEdit"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
          } else if(menuItem.key == "sUnPin"){
            $scope.menuItemLabel = $filter("translate")('cm.label.99');
          }

          $scope.curIndex = $scope.contextMenuOpt.length;
          $scope.contextMenuOpt.push([$scope.menuItemLabel, menuItem.key]);
          if(menuItem.key == "sEdit"){
            $scope.tempSubMenu = [];
            angular.forEach(menuItem.steps, function(subMenuItem){
              if(subMenuItem.key == "sStep1"){
                $scope.subMenu = $filter("translate")('cm.brief.1');
              } else if(subMenuItem.key == "sStep2"){
                $scope.subMenu = $filter("translate")('cm.label.3');
              } else if(subMenuItem.key == "sStep3"){
                $scope.subMenu = $filter("translate")('cm.label.1');
              } else if(subMenuItem.key == "sStep4"){
                $scope.subMenu = $filter("translate")('cm.label.4');
              } else if(subMenuItem.key == "sStep5"){
                $scope.subMenu = $filter("translate")('s.body.4');
              }
              $scope.tempSubMenu.push([$scope.subMenu, subMenuItem]);
            });
            $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
          }
        } else if(caller=="template"){
          if(menuItem.key == "tOpen"){
            $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
          } else if(menuItem.key == "tEdit" || menuItem.key == "sEdit"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
          } else if(menuItem.key == "tSchedule"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.27');
          } else if(menuItem.key == "tAddToSchedule"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.28');
          } else if(menuItem.key == "tUnPin"){
            $scope.menuItemLabel = $filter("translate")('cm.label.99');
          } else if(menuItem.key=="tOcFolder"){
            $scope.menuItemLabel = $filter("translate")('cm.btn.46');
          }
          $scope.curIndex = $scope.contextMenuOpt.length;
          $scope.contextMenuOpt.push([$scope.menuItemLabel, menuItem.key]);
          if(menuItem.key == "tEdit"){
            $scope.tempSubMenu = [];
            if(menuItem && menuItem.steps){
              angular.forEach(menuItem.steps, function(subMenuItem){
                if(subMenuItem.key == "tStep1"){
                  $scope.subMenu = $filter("translate")("cm.btn.40");
                } else if(subMenuItem.key == "tStep2"){
                  $scope.subMenu = $filter("translate")("t.btn.3");
                }
                $scope.tempSubMenu.push([$scope.subMenu, subMenuItem]);
              });
              $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
            }
          }
        }
      });
    }

    /* Unpin from dashboard */
		$scope.unpinToDBFx = function(item, type, subType){
      if(type.toLowerCase() == "content" && item.type.toLowerCase()=="widget"){
        subType = "Widget";
      }

      CommonSrv.pinUnpinItems({"selectedItems":[{id:item.id,type:type,subType:subType}]}, "unpin").then(
        function(data){
          $scope.tempList = [];
          if(data.code == 8305){
            if(type.toLowerCase() == 'content'){
              $scope.tempList = ((item.type.toLowerCase() == "folder" || item.type.toLowerCase() == "sharedfolder" || item.type.toLowerCase() == "sharepoint" || item.type.toLowerCase() == "onedrive") ? $scope.folderList : $scope.contentList);
            }
            if(type.toLowerCase() == 'schedule'){
              $scope.tempList = $scope.schedules.schedules;
            }
            if(type.toLowerCase() == 'template'){
              $scope.tempList = (item.type.toLowerCase() == "folder" ? $scope.templates.folders : $scope.templateList);
            }
            if(type.toLowerCase() == 'device'){
              $scope.tempList = (item.type.toLowerCase() == "folder" ? $scope.devices.folders : $scope.devices.devices);
            }
            if($scope.tempList.length){
              for (var i = 0; i < $scope.tempList.length; i++) {
                if ($scope.tempList[i].id === item.id) {
                  $scope.tempList.splice(i, 1);
                  break;  // Exit the loop after removing the element
                }
              }
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

		/*Widget's edit button*/
    $scope.editFx = function(data){
      $rootScope.tabView = false;
      if(data.folderid > 0){
        localStorage.setItem('curFId', data.folderid);
      }

      //set isWidget true if adv search applied
      if(localStorage.getItem("isAdvSearch")){
        localStorage.setItem("isWidgetEdited", true);
      } else{
        localStorage.removeItem("isWidgetEdited");
        localStorage.removeItem("curFilterObj");
        localStorage.removeItem("isAdvSearch");
      }
      if($scope.curExtn.type == "Folder" || $scope.curExtn.type == "Sharepoint" || $scope.curExtn.type == "Onedrive" || $scope.curExtn.type == "SharedFolder"){
        var fType = "n";
        if($scope.curExtn.type == "Sharepoint"){
          fType = "sp";
        } else if($scope.curExtn.type == "Onedrive"){
          fType = "od";
        } else if($scope.curExtn.type == "SharedFolder"){
          fType = "sf";
        }
        $scope.folderCUOpen(fType, "edit");
      } else if($scope.curExtn.type != "Folder" && $scope.curExtn.type != "Widget" && $scope.curExtn.type != "Sharepoint" && $scope.curExtn.type != "Onedrive" && $scope.curExtn.type != "SharedFolder"){
        $scope.contentEditOpen(data);
      } else if($scope.curExtn.type == "Widget"){
        if($scope.curExtn.extn == "Audio"){
          $scope.contentEditOpen(data);
        } else if($scope.curExtn.extn == "CoM Events"){
          $state.go("hub.contentAdd.widgetAddTab.comEvent", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "CoM Pylon Text"){
          $state.go("hub.contentAdd.widgetAddTab.comPylonText", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "AGC"){
          $state.go("hub.contentAdd.widgetAddTab.agc", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Crop Comm: Alert Message"){
          $state.go("hub.contentAdd.widgetAddTab.alertMsg", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Achievers"){
          $state.go("hub.contentAdd.widgetAddTab.achievers", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Air Quality Index"){
          $state.go("hub.contentAdd.widgetAddTab.aqi", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Auto Login (Basic Auth)"){
          $state.go("hub.contentAdd.widgetAddTab.autoLogin", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Calendar of Events"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Calendar of Events View"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coev", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Cisco Meraki"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Content on Demand"){
          $state.go("hub.contentAdd.widgetAddTab.contentOnDemand", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Button"){
          $state.go("hub.contentAdd.widgetAddTab.codButton", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Pandora CloudCover"){
          $state.go("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Content Group"){
          $state.go("hub.contentAdd.widgetAddTab.contentGroup", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Count"){
          $state.go("hub.contentAdd.widgetAddTab.count", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Cloud Farm"){
          $state.go("hub.contentAdd.widgetAddTab.cloudFarm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Date Time"){
          $state.go("hub.contentAdd.widgetAddTab.dateTime", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Delimited Text"){
          $state.go("hub.contentAdd.widgetAddTab.delimitedText", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "External Input"){
          $state.go("hub.contentAdd.widgetAddTab.externalInput", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Excel Sheet"){
          $state.go("hub.contentAdd.widgetAddTab.excelSheet", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Facebook"){
          $state.go("hub.contentAdd.widgetAddTab.facebook", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Facebook Workplace"){
          $state.go("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Fifa"){
          $state.go("hub.contentAdd.widgetAddTab.fifa", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Filler Content"){
          $state.go("hub.contentAdd.widgetAddTab.fillerContent", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Flight Schedule"){
          $state.go("hub.contentAdd.widgetAddTab.flightSchedule", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Free Form"){
          $state.go("hub.contentAdd.widgetAddTab.freeForm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "FTP"){
          $state.go("hub.contentAdd.widgetAddTab.ftp", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Fullscreen Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.fsChrome", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45"){
          $state.go("hub.contentAdd.widgetAddTab.f45", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Blank"){
          $state.go("hub.contentAdd.widgetAddTab.blank", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Content Scroller"){
          $state.go("hub.contentAdd.widgetAddTab.contentScroller", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Content Tile"){
          $state.go("hub.contentAdd.widgetAddTab.contentTile", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Countdown Circle"){
          $state.go("hub.contentAdd.widgetAddTab.countdownCircle", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Hydrate"){
          $state.go("hub.contentAdd.widgetAddTab.hydrate", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Move Station"){
          $state.go("hub.contentAdd.widgetAddTab.moveStation", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.progressBar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Animation"){
          $state.go("hub.contentAdd.widgetAddTab.animation", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Progress Bar With Break"){
          $state.go("hub.contentAdd.widgetAddTab.progressBarWithBreak", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Stay"){
          $state.go("hub.contentAdd.widgetAddTab.stay", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Work"){
          $state.go("hub.contentAdd.widgetAddTab.work", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Workout"){
          $state.go("hub.contentAdd.widgetAddTab.story", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Google Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.gCalendar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Google Slide"){
          $state.go("hub.contentAdd.widgetAddTab.gSlide", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Grafana Cloud"){
          $state.go("hub.contentAdd.widgetAddTab.grafana", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "HD Steth"){
          $state.go("hub.contentAdd.widgetAddTab.hdSteth", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "IFrame"){
          $state.go("hub.contentAdd.widgetAddTab.iFrame", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Instagram"){
          $state.go("hub.contentAdd.widgetAddTab.instagram", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel Circuit Bench"){
          $state.go("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "LinkedIn"){
          $state.go("hub.contentAdd.widgetAddTab.linkedIn", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Interactive Menu"){
          $state.go("hub.contentAdd.widgetAddTab.iMenu", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "IoT Button"){
          $state.go("hub.contentAdd.widgetAddTab.iotButton", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel JCI Map"){
          $state.go("hub.contentAdd.widgetAddTab.jciMap", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel Smart Building"){
          $state.go("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Live Streaming"){
          $state.go("hub.contentAdd.widgetAddTab.liveStreaming", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.meeting", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Message"){
          $state.go("hub.contentAdd.widgetAddTab.message", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams"){
          $state.go("hub.contentAdd.widgetAddTab.msTeams", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Music Choice"){
          $state.go("hub.contentAdd.widgetAddTab.musicChoice", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "News"){
          $state.go("hub.contentAdd.widgetAddTab.news", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "NextBus"){
          $state.go("hub.contentAdd.widgetAddTab.nextBus", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Next Vehicle"){
          $state.go("hub.contentAdd.widgetAddTab.nextVehicle", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Online Radio"){
          $state.go("hub.contentAdd.widgetAddTab.onlineRadio", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Outlook Calendar"){
           $state.go("hub.contentAdd.widgetAddTab.outlookCalendar", {
             id:$scope.hubEncrypt($scope.curExtn.id)
           });
        } else if($scope.curExtn.extn == "LifeLabs Patient Wait"){
          $state.go("hub.contentAdd.widgetAddTab.patientWait", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Power BI"){
          $state.go("hub.contentAdd.widgetAddTab.powerBI", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Prayer"){
          $state.go("hub.contentAdd.widgetAddTab.prayer", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Open Hours"){
          $state.go("hub.contentAdd.widgetAddTab.openHours", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Queue"){
          $state.go("hub.contentAdd.widgetAddTab.queue", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Quotes"){
          $state.go("hub.contentAdd.widgetAddTab.quotes", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "QR Code"){
          $state.go("hub.contentAdd.widgetAddTab.qrCode", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Readerboard"){
          $state.go("hub.contentAdd.widgetAddTab.readerboard", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "RSS Feed"){
          $state.go("hub.contentAdd.widgetAddTab.rssFeed", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Schedule Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Slack"){
          $state.go("hub.contentAdd.widgetAddTab.slack", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Firstup"){
          $state.go("hub.contentAdd.widgetAddTab.socialChorus", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Social Media"){
          $state.go("hub.contentAdd.widgetAddTab.socialMedia", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Stock Price"){
          $state.go("hub.contentAdd.widgetAddTab.stockPrice", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Storm"){
          $state.go("hub.contentAdd.widgetAddTab.storm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Sun Smart"){
          $state.go("hub.contentAdd.widgetAddTab.sunSmart", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Survey"){
          $state.go("hub.contentAdd.widgetAddTab.survey", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Telax"){
          $state.go("hub.contentAdd.widgetAddTab.telax", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams Rooms"){
          $state.go("hub.contentAdd.widgetAddTab.teamsRoom", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams Channels"){
          $state.go("hub.contentAdd.widgetAddTab.teamsChannel", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Crawling Text" || $scope.curExtn.extn == "Static Text"){
          $state.go("hub.contentAdd.widgetAddTab.text", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Traffic"){
          $state.go("hub.contentAdd.widgetAddTab.traffic", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "TouchLink Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.touchLink", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Training Mode"){
          $state.go("hub.contentAdd.widgetAddTab.trainingMode", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "TSC Country Mile"){
          $state.go("hub.contentAdd.widgetAddTab.tsccm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "X"){
          $state.go("hub.contentAdd.widgetAddTab.twitter", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Ungerboeck"){
          $state.go("hub.contentAdd.widgetAddTab.ungerboeck", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Unisys"){
          $state.go("hub.contentAdd.widgetAddTab.unisys", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Vimeo"){
          $state.go("hub.contentAdd.widgetAddTab.vimeo", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Weather"){
          $state.go("hub.contentAdd.widgetAddTab.weather", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Cam"){
          $state.go("hub.contentAdd.widgetAddTab.webCam", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Login"){
          $state.go("hub.contentAdd.widgetAddTab.webLogin", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Login Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.webLoginChrome", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Page"){
          $state.go("hub.contentAdd.widgetAddTab.webPage", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Wait Queue Metro"){
          $state.go("hub.contentAdd.widgetAddTab.wqMetro", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "webex by CISCO"){
          $state.go("hub.contentAdd.widgetAddTab.webex", {
            id:$scope.tempId
          });
        } else if($scope.curExtn.extn == "Xovis"){
          $state.go("hub.contentAdd.widgetAddTab.xovis", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Viva Engage"){
          $state.go("hub.contentAdd.widgetAddTab.yammer", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "YouTube"){
          $state.go("hub.contentAdd.widgetAddTab.youTube", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        }
      }
    }

    $scope.contentEditOpen = function(data){
      $scope.editObj = {info:{id:data.id, label:data.label}};
      ContentLibrarySrv.getContentDetails(data.id).then(
        function(data){
          $scope.editObj.activePeriod = data.activePeriod;
          $scope.editObj.permission = data.permission;
          $scope.editObj.actionFrom = "pin";
          ngDialog.open({
            template:"app/contentLibrary/popup/contentEdit.html",
            width:680,
            scope:$scope,
            data:$scope.editObj,
            closeByDocument:false,
            controller:"ContentEditController",
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.performActionFx = function(data, actionType, type, subType) {
      // console.warn(data, actionType, type, subType);
      if(actionType=="tEdit" && subType=="template"){
        return false;
      }

      $scope.curActionType = actionType;
      $scope.curExtn.id = data.id;
      $scope.curExtn.type = data.type;
      $scope.curExtn.extn = data.extn;
      $scope.brief = data;
      if(actionType != 'clSchedule'){
        $rootScope.selectedItems = [data];
      }
      if(actionType=="clUnPinItems" || actionType=="dUnPin" || actionType=="sUnPin" || actionType=="tUnPin"){
        if(data.type.toLowerCase()=="onedrive" || data.type.toLowerCase()=="sharedfolder" || data.type.toLowerCase()=="sharepoint"){
          subType = data.type.toLowerCase();
        }
        $scope.unpinToDBFx(data, type, subType);
      } else if(actionType=="clOpenFolder"){
        $scope.folderContentFx(data.id, data.splId, data.type);
      } else if(actionType=="clEdit"){
        $scope.editFx(data);
      } else if(actionType=="clSchedule" || actionType=="tSchedule"){
        $scope.scheduleFx(null, 'pin');
      } else if(actionType=="clAddToSchedule" || actionType=="tAddToSchedule"){
        $scope.addToScheduleOpen(type);
      } else if(actionType=="dOpenFolder"){
        $scope.folderDeviceFx(data.id, data.splId, data.splType);
      } else if(actionType=="dEditFolder" || actionType=="tEdit"){
        $scope.folderCUOpen(type,'edit');
      } else if(actionType=="dPreview"){
        $scope.previewOpen();
      } else if(actionType=="tOpen"){
        $scope.folderTemplateFx(data.id,data.splId,data.type);
      } else if(actionType=="ocFolder"){
        $scope.openContentFolderFx(data.id,data.folderid,data.type,data.splId,data.splType,data.gid,data.gType);
      } else if(actionType=="tOcFolder"){
        $scope.openContentFolderFx(data.id,data.folderid,type,data.splId,data.splType,data.gid,data.gType);
      }
    };

    $scope.performStepFx = function(data, stepType, caller){
      $rootScope.selectedItems = [data];
      $scope.encType = $scope.hubEnc("s");
      $scope.encId = $scope.hubEncrypt($rootScope.selectedItems[0].id);

      if(caller=="schedule"){
        if(stepType.key=="sStep1"){
          $state.go("hub.sContainer.sName", {type: $scope.encType, id: $scope.encId});
        } else if(stepType.key=="sStep2"){
          $state.go("hub.sContainer.sSchedule", {type: $scope.encType, id: $scope.encId});
        } else if(stepType.key=="sStep3"){
          $state.go("hub.sContainer.sContent", {type: $scope.encType, id: $scope.encId});
        } else if(stepType.key=="sStep4"){
          $state.go("hub.sContainer.sDevice", {type: $scope.encType, id: $scope.encId});
        } else if(stepType.key=="sStep5"){
          $state.go("hub.sContainer.sFrame", {type: $scope.encType, id: $scope.encId});
        }
      } else if(caller=="template"){
        if(data.folderid){
          localStorage.setItem("curTFId", data.folderid);
        }
        if(stepType.key=="tStep1"){
          if(data.status == "incompleted"){
            $state.go("hub.tContainer.tName", {type:$scope.hubEnc("it"), id:$scope.encId});
          } else if(data.status == "unapproved"){
            $state.go("hub.tContainer.tName", {type:$scope.hubEnc("ut"), id:$scope.encId});
          } else if(data.status == "approved"){
            $state.go("hub.tContainer.tName", {type:$scope.hubEnc("t"), id:$scope.encId});
          }
        } else if(stepType.key=="tStep2"){
          if(data.status == "incompleted"){
            $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("it"), id:$scope.encId});
          } else if(data.status == "unapproved"){
            $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("ut"), id:$scope.encId});
          } else if(data.status == "approved"){
            $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("t"), id:$scope.encId});
          }
        }
      } else if(caller=="device"){
        if (data.folderid) {
          localStorage.setItem("curDFId", data.folderid);
        }
        if(stepType.key=="dStep1"){
          $state.go("hub.dContainer.dName", {id: $scope.encId});
        } else if(stepType.key=="dStep2"){
          $state.go("hub.dContainer.dFrameLayout", {id: $scope.encId});
        } else if(stepType.key=="dStep3"){
          $state.go("hub.dContainer.dTag", {id: $scope.encId});
        }
      }
    }

    $scope.statusFx = function(id){
      $(".switch-sm").each(function(){
        if(id == $(this).attr("data-id")){
          $(this).addClass("disabled");
        }
      });
      SchedulesSrv.changeStatus(id).then(
        function(data){
          $(".switch-sm").each(function(){
            if(id == $(this).attr("data-id")){
              $(this).removeClass("disabled");
            }
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.openContentFolderFx = function(id, fId, type, splId, splType, gid, gType){
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
        $state.go("hub.templates.t");
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curDFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
        if(gType){
          localStorage.setItem("curGroupId", gid);
          localStorage.setItem("curGroupType", gType);
        }
        $state.go("hub.contentLibrary.c");
      }
    }

    /* Content Library Functions */
    $scope.folderContentFx = function(fId, splId, type){
      $scope.odSp = {auth:false, breadCrumbs:[]};
      $scope.contentLibraryLoading = true;
      $rootScope.showTimeoutMsg = false;
      // $rootScope.selectedItems = [];
      $rootScope.sessionTimoutFx();

      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curFId");

      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curFolderId = 0;
      $scope.curSPlObj = {};

      //for OD & SP breadcrumb
      if(fId == 0){
        $scope.odSp.breadCrumbs = [];
      }
      if(fId){
        localStorage.setItem("curFId", fId);
        $scope.curFolderId = fId;
      }
      if(splId){
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:type}));
        $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      }

      if($scope.curFolderId == 0){
        localStorage.setItem("inFolder", 0);
        localStorage.removeItem("curPathFId");
      }

      if(splId && fId != splId){
        ContentLibrarySrv.getAllSPL($scope.curFolderId, $scope.curSPlObj.id, $scope.curSPlObj.type).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else if(data.fType=="gd"){
                $scope.odSp.curType = "Googledrive";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        // $scope.selectedTreeItem($scope.curFolderId);
        ContentLibrarySrv.getAll($scope.curFolderId).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else if(data.fType=="gd"){
                $scope.odSp.curType = "Googledrive";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      }
      $state.go("hub.contentLibrary.c");
    }

    /* Device section functions */
    $scope.folderDeviceFx = function (fId, splId, splType) {
      $scope.isAdvSearch = false;
      $scope.advSearchInfo = {};
      $rootScope.advSearchArgObj = {};
      $scope.filterCount = 0;
      $scope.devicesLength = 0;
      localStorage.removeItem("isDlAdvSearch");
      localStorage.removeItem("fc");
      // ?New: this "if" code is for device folder
      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df' && $scope.selectedTab !== "hub.devices.di") {
        // $scope.breadCrumbs = [];
        // $scope.filter = "all";
        // $cookies.remove("filterType");
        // $cookies.remove("pageStatus");
        // localStorage.removeItem("filterType");
        localStorage.removeItem("pageStatus");
        $rootScope.offset = 0;
        $scope.currentPage = 1;

        $scope.devicesLoading = true;
        $scope.search = { text: "" };
        $rootScope.selectedItems = [];
        // $cookies.remove("curPathId");
        // $cookies.remove('curSPlObj');
        // $cookies.remove("curDFId");
        localStorage.removeItem("curPathId");
        localStorage.removeItem("curSPlObj");
        localStorage.removeItem("curDFId");
        $scope.advSearch = false;
        $scope.curFolderId = 0;

        if ($scope.auth.upermissions.dp) {
          $scope.unselectTypeFx();
        }

        if (fId == 0) {
          $scope.breadCrumbs = [];
        }
        if (fId) {
          // $cookies.put("curDFId", fId);
          localStorage.setItem("curDFId", fId);
          // $scope.curFolderId = $cookies.get("curDFId");
          $scope.curFolderId = localStorage.getItem("curDFId");
        }

        if ($scope.curFolderId == 0) {
          // $cookies.put("inFolder", 0);
          localStorage.setItem("inFolder", 0);
          localStorage.removeItem("curPathFId");
        }

        //get current page and offset
        var pageStatus = localStorage.getItem("pageStatus");
        if(pageStatus){
          $scope.pageObj = pageStatus;
          $scope.currentPage = $scope.pageObj.curPage;
          $rootScope.offset = $scope.pageObj.offset;
        }

        if(!$scope.auth.upermissions.dp){
          $rootScope.offset = null;
        }

        $scope.folObj = {fId:fId, offset:0, obj:null, caller:null, filType:$scope.filterType};
        // DevicesSrv.getFolderData(fId, $rootScope.offset, "", "", $scope.filterType).then(
        DevicesSrv.getFolderData($scope.folObj).then(
          function (data) {
            $scope.flId = fId;
            $scope.devicesLoading = false;
            $scope.devices = data;
            // $scope.devicesLength = $scope.devices.info.tc;
            // if($scope.filter != 'all'){
            //   $scope.devicesLength = $scope.devices.info.tc;
            // } else {
            //   $scope.devicesLength = $scope.devices.info.al?$scope.devices.info.al:$scope.devices.info.tc;
            //   $scope.filterCount = $scope.devices.info.count ? $scope.devices.info.count : $scope.devices.devices.length;
            //   $scope.searchTotal = angular.copy($scope.filterCount);
            // }
            $scope.searchTotal = angular.copy($scope.devices.info.count?$scope.devices.info.count:$scope.devices.devices.length);
            $scope.brief = data;
            $scope.updateList();

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.fCount = $scope.devices.devices;
            } else {
              $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
            }

            if($scope.auth.upermissions.dp && !$scope.devices.types){
              if($scope.isAdvSearch){
                $scope.setDeviceRange($scope.devices, $scope.currentPage);
              } else {
                $scope.setDeviceRange($scope.devices, null);
              }
            }
          },
          function (err) {
            $scope.devicesLoading = false;
            $log.error(err);
          }
        );
      } else {
        // ?this was old code no change
        $scope.contentLoading = true;
        $scope.search = { text: "" };
        ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
          function (data) {
            $scope.flId = fId;
            $scope.contentLibrary = data;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.updateListContentFx();
          },
          function (err) {
            $scope.contentLoading = false;
            $log.error(err);
          }
        );
      }
      $state.go("hub.devices.d");
    }
    $scope.unselectTypeFx = function(){
      $rootScope.tmpBriefDevices = [];
      $rootScope.multiSelDevices = [];
      $rootScope.selectedItems = [];
      $rootScope.curItems = [];
      $scope.contextMenuOpt = [];
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      setTimeout(function(){
        angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        });
      }, 100);
    }

    /* Template */
    $scope.folderTemplateFx = function(fId, splId, type){
      $rootScope.showTimeoutMsg = false;
      $scope.templatesLoading = true;
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathTId");
      $rootScope.sessionTimoutFx();
      localStorage.removeItem("curTFId");
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curTFolderId = 0;

      if(fId){
        localStorage.setItem("curTFId", fId);
        $scope.curTFolderId = localStorage.getItem("curTFId");
      }
      if($scope.curTFolderId == 0){
        localStorage.setItem("inTFolder", 0);
        localStorage.removeItem("curTPathFId");
      }
      $scope.searchText = "";
      TemplatesSrv.getTemplatesContent($scope.curTFolderId).then(
        function(data){
          $scope.templates = data;
          $scope.updateList();
          $scope.curPathTId = angular.fromJson(localStorage.getItem("curPathTId"));
          if($scope.curPathTId){
            setTimeout(function(){
              angular.forEach(angular.element('.ui-selectable li'), function(item){
                if($(item).attr('data-id') == $scope.curPathTId){
                  $(item).addClass('ui-highlight');
                }
              });
            }, 100);
          }
        },
        function(err){
          $log.error(err);
        }
      );
      $state.go("hub.templates.t");
    }

    /*ContextMenu*/
    $scope.contextMenuBaseFx = function(){
      $scope.contextMenuBase=[];
      if(($scope.contentLibrary.info.writable && $scope.auth.upermissions.c && $scope.auth.upermissions.w) || ($scope.contentLibrary.info.writable && $scope.auth.upermissions.c)){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.1"), function($itemScope){$state.go("hub.contentAdd.contentAddTab");}]);
      } else if($scope.contentLibrary.info.writable && $scope.auth.upermissions.w && !$scope.auth.upermissions.c){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.2"), function($itemScope){$state.go("hub.contentAdd.widgetAddTab.dateTime");}]);
      }
      if($scope.contentLibrary.info.writable && $scope.auth.upermissions.cf){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.3"), function($itemScope){$scope.folderCUOpen('n');}]);
      }
    }

    /*ngDialog*/
    $scope.folderCUOpen = function(type, caller){
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      localStorage.removeItem("curPathId");
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");

      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.folderObj = {fType:type};
      if(caller == "edit"){
        $scope.folderObj.label = $scope.brief.label;
        $scope.folderObj.id = $scope.brief.id;
      } else{
        $scope.folderObj.fid = $scope.curFolderId;
      }

      if($scope.curActionType=="dEditFolder"){
        $scope.templateUrl = "app/devices/popup/folderCU.html";
        $scope.ctrlType = "DFolderCUController";
      } else if($scope.curActionType=="clEdit"){
        if(type == "sf"){
          $scope.folderLoading = true;
          $scope.serverList = [];
          ContentLibrarySrv.getServersList().then(
            function(data){
              $scope.serverList = data.servers;
              $scope.folderLoading = false;
            },
            function(err){
              $log.error(err);
              $scope.folderLoading = false;
            }
          );
        }

        if($scope.curSPlObj && $scope.curSPlObj.id){
          $scope.folderObj.fid = $scope.curSPlObj.id;
        }
        $scope.templateUrl = "app/contentLibrary/popup/folderCU.html";
        $scope.ctrlType = "FolderCUController";
      } else if($scope.curActionType=="tEdit"){
        $scope.templateUrl = "app/templates/popup/folderCU.html";
        $scope.ctrlType = "TFolderCUController";
      }
      $scope.folderObj.actionFrom = "pin";
      ngDialog.open({
        template:$scope.templateUrl,
        width:620,
        scope:$scope,
        data:$scope.folderObj,
        closeByDocument:false,
        controller:$scope.ctrlType,
      });
    }

    /* Preview */
    $scope.previewObj = {};
    $scope.previewOpen = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!caller){
        $scope.previewObj = {isControls:false, id:$rootScope.selectedItems[0].id, label:$rootScope.selectedItems[0].label, eip:$rootScope.selectedItems[0].eip, mac:$rootScope.selectedItems[0].mac, time:moment().format(), date:{startDate:moment().format('L'), endDate:moment().format('L')}};
      }
      ngDialog.close();
      ngDialog.open({
        template:'\
          <section class="panel">\
            <header class="panel-heading"><h1>{{"d.btn.11" | translate}}</h1> <span class="text-sm text-muted">[ {{previewObj.label}} ]</span></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cm.label.7" | translate}}</label>\
                <div class="input-group">\
                  <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                  <input type="daterange" class="form-control picker" ng-model="previewObj.date" format="MM/DD/YYYY" singleDatePicker="true" readonly="" aria-label="{{\'cm.label.7\' | translate}}" aria-labelledby="{{\'cm.label.7\' | translate}}">\
                </div>\
              </div>\
              <div class="form-group timepicker">\
                <label>{{"cm.label.8" | translate}}</label>\
                <span uib-dropdown auto-close="outsideClick" dropdown-append-to-body>\
                  <div class="input-group">\
                    <span class="input-group-addon"><span class="fa fa-clock-o" aria-hidden="true"></span></span>\
                    <input type="text" class="form-control picker" uib-dropdown-toggle ng-value="previewObj.time | date:\'shortTime\'" readonly="" aria-label="{{\'cm.label.8\' | translate}}" aria-labelledby="{{\'cm.label.8\' | translate}}">\
                  </div>\
                  <div class="dropdown-menu dropdown-to-body" uib-dropdown-menu>\
                    <div uib-timepicker ng-model="previewObj.time" hour-step="1" minute-step="5"></div>\
                  </div>\
                </span>\
              </div>\
              <div><label class="noMar"><input type="checkbox" ng-model="previewObj.isControls"><label></label> {{"d.label.28" | translate}}</label></div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="previewFx();"><span class="fa fa-film" aria-hidden="true"></span> {{"d.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErr">\
                <span ng-if="errType == \'date\'">{{"cm.msg.21" | translate}}</span>\
                <span ng-if="errType == \'time\'">{{"cm.msg.22" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:400,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
      });
    }
    $scope.previewFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.previewObj.date == "" || $scope.previewObj.date == null){
        $scope.hasErr = true;
        $scope.errType = "date";
        return false;
      }
      if($scope.previewObj.time == "" || $scope.previewObj.time == null){
        $scope.hasErr = true;
        $scope.errType = "time";
        return false;
      }
      $scope.curPreviewObj = angular.copy($scope.previewObj);
      $scope.curPreviewObj.timestamp = moment($scope.previewObj.date.startDate).format('MM-DD-YYYY');
      $scope.curPreviewObj.time = moment(angular.copy($scope.previewObj).time).format("HH:mm");
      $scope.curPreviewObj.offset = new Date($scope.previewObj.date.startDate).getTimezoneOffset();

      $scope.curPreviewObj.iFrameUrl = $rootScope.dPreviewPath + $scope.previewObj.mac +"&cc="+ $scope.previewObj.isControls +"&ts="+ $scope.curPreviewObj.timestamp +"&t="+ $scope.curPreviewObj.time +"&"+ new Date().getTime();

      ngDialog.close();
      ngDialog.open({
        template:'app/devices/preview/preview.html',
        width:"98%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        controller:"PreviewController",
        className:"ngdialog-theme-default ngdialog-preview",
        preCloseCallback:function(){
          $interval.cancel($rootScope.emTimer);
        }
      });
    }

    $scope.scheduleFx = function(type, caller){
      // Remove from local storage
      localStorage.removeItem("clSchedule");
      localStorage.removeItem("clfSchedule");
      localStorage.removeItem("tSchedule");
      localStorage.removeItem("tfSchedule");
      localStorage.removeItem("tiSchedule");

      if($scope.curActionType=="tSchedule"){
        $scope.curTItems = [];
        $scope.curTFolders = [];

        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type.toLowerCase() == "content"){
            $scope.curTItems.push({
              hidden:0,
              mute:true,
              id:item.id,
              type:"template",
              fullscreen:false,
              label:item.label,
              tType:item.tType,
              thumb:item.thumb,
              upper:item.upper,
              status:item.status,
              thumbV:item.thumbV,
              userid:$scope.auth.uid,
              duration:item.duration,
              folderid:item.folderid,
              dimension:item.dimension
            });
          } else if(item.type.toLowerCase() == "folder"){
            $scope.curTFolders.push({
              id:item.id,
              wp:item.wp,
              type:"folder",
              label:item.label,
              upper:item.upper
            });
          }
        });

        if($scope.curTItems.length){
          localStorage.setItem("tSchedule", JSON.stringify($scope.curTItems));
        }

        if($scope.curTFolders.length){
          localStorage.setItem("tfSchedule", JSON.stringify($scope.curTFolders));
        }

        localStorage.setItem("tiSchedule", JSON.stringify({tim:$scope.tim, tBucket:$scope.tBucket, mbucket:$scope.tDetailBucket}));

        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
      } else{
        /* // Old Code Commented on 27082024 Schedules single sort save
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder"){
            item.fid = item.id;
          }
        });
        console.warn("$scope.contentLibrary.contentLibrary.content ", $scope.contentLibrary.contentLibrary.content);

        // angular.forEach($scope.contentLibrary.contentLibrary.content, function(content){
        //   angular.forEach($rootScope.selectedItems, function(item){
        //     if(item.type == "SharePointC" && content.id == item.id){
        //       item.size = content.size;
        //       item.width = content.width;
        //       item.spfid = content.spfid;
        //       item.label = content.label;
        //       item.Length = content.Length;
        //       item.height = content.height;
        //       item.splFid = content.splFid;
        //       item.duration = content.duration;
        //       item.MajorVersion = content.MajorVersion;
        //       item.fid = JSON.parse($scope.curFolderId);
        //       item.ServerRelativeUrl = content.ServerRelativeUrl;
        //     }
        //     if(item.type == "OneDriveC" && content.id == item.id){
        //       item.size = content.size;
        //       item.label = content.label;
        //       item.splId = content.splId;
        //       item.width = content.width;
        //       item.height = content.height;
        //       item.splFid = content.splFid;
        //       item.duration = content.duration;
        //       item.fid = JSON.parse($scope.curFolderId);
        //     }
        //     if(item.type == "SharedFolderC" && content.id == item.id){
        //       item.size = content.size;
        //       item.label = content.label;
        //       item.splId = content.splId;
        //       item.width = content.width;
        //       item.height = content.height;
        //       item.splFid = content.splFid;
        //       item.duration = content.duration;
        //       item.fid = JSON.parse($scope.curFolderId);
        //     }
        //   });
        // });
        localStorage.setItem("clSchedule", JSON.stringify($rootScope.selectedItems));
        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
        // Old Code End
        */

        // New Code added on 27082024 Schedules single sort save
        $scope.curSelectedItems = [];
        $scope.curSelectedFolders = [];
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type.toLowerCase() == "folder" || item.type.toLowerCase() == "sharepoint" || item.type.toLowerCase() == "onedrive" || item.type.toLowerCase() == "sharedfolder" || item.type.toLowerCase() == "excelfolder"){
            item.fid = item.id;
            if(item.type == "excelfolder"){
              item.type = "folder";
            }
            $scope.curSelectedFolders.push(item);
          }
        });
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(content){
          angular.forEach($rootScope.selectedItems, function(item){
            if(item.type == "SharePointC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted
              });
            }
            if(item.type == "OneDriveC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted
              });

            }
            if(item.type == "SharedFolderC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                height:content.height,
                splFid:content.splFid,
                fid:JSON.parse($scope.curFolderId),

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted
              });
            }
            if(item.type == "GoogleDriveC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted
              });

            }
            if((item.type != "SharePointC" && item.type != "OneDriveC" && item.type != "SharedFolderC" && item.type != "GoogleDriveC") && content.id == item.id){
              $scope.curSelectedItems.push({
                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted
              });
              /*
                captionLang: []
                captionSel: []
                path: "/"
                sortOrder: 0
              */
            }
          });
        });

        if($scope.curSelectedItems.length){
          localStorage.setItem("clSchedule", JSON.stringify($scope.curSelectedItems));
        }
        if($scope.curSelectedFolders.length){
          localStorage.setItem("clfSchedule", JSON.stringify($scope.curSelectedFolders));
        }
        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
        // New Code End
      }
    };

    $scope.addToScheduleOpen = function(type){
      $scope.scheduleList = {};
      var isType = "";
      if(type=="template"){
        isType = "t";
      }
      SchedulesSrv.getAddToSchedules('', isType).then(
        function(data){
          $scope.scheduleList = data;
          $scope.actionObj = {actionFrom:"pin"};
          ngDialog.open({
            template:"app/common/popup/addToSchedule.html",
            width:800,
            scope:$scope,
            data:$scope.actionObj,
            closeByDocument:false,
            controller:"AddtoScheduleController",
            preCloseCallback:function(){
              $scope.saveProcessing = false;
              $scope.hasErr = false;
              $scope.errType = "";
            }
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.hubEnc = function(id){
      return btoa($scope.reverse($scope.auth.token) + id + $scope.auth.uid);
    }

    $scope.hubEncrypt = function(id){
      return btoa($scope.auth.token + id + $scope.auth.uname);
    }
    $scope.hubDecrypt = function(id){
      return atob(id).split($scope.auth.token)[1].split($scope.auth.uname)[0];
    }
    
    // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };
	}
})();

(function () {
  'use strict';

  angular
    .module('hub')
    .controller('PermissionsController', PermissionsController);

  /** @ngInject */
  function PermissionsController($log, $rootScope, $scope, $cookies, CommonSrv) {
    $rootScope.isPermissionOpen = false;
    $scope.curAuth = angular.fromJson(localStorage.getItem("auth"));
    $rootScope.permission = {};
    $scope.permissionLoading = true;
    $scope.curPermissonModel = {};
    $scope.getPermissions = true;
    $scope.curPermisson = {};

    if ($scope.pid == "") {
      $scope.pid = 0;
    }
    $scope.curPermissonObj = { id: $scope.pid, module: $scope.module };

    $scope.listManipulateFx = function (caller, availableList, assignedList, curModel) {
      $rootScope.rootManipulateFx(caller, availableList, assignedList, curModel);/*This function in CommonController*/
    }

    $scope.permissionFx = function (caller) {
      if ($scope.other && $scope.other.sig == "sig") {
        $scope.curPermissonObj = { sid: $scope.other.id, id: $scope.pid, module: $scope.module };
      }
      if (caller == "edit") {
        $rootScope.isPermissionOpen = true;
        if ($scope.getPermissions) {
          CommonSrv.getPermissions($scope.curPermissonObj).then(
            function (data) {
              $scope.copyPermisson = data;
              $scope.permissionLoading = false;
              if ($scope.other && $scope.other.sig == "sig") {
                $scope.getPermissions = true;
                $scope.copyPermisson.other = $scope.other.sig;
              } else {
                $scope.getPermissions = false;
              }
              if ($scope.curPermissonObj.module == 'schedule' || $scope.curPermissonObj.module == 'schedulegroupschedule') {
                if($scope.assignable.type == 'c' && $scope.assignable.groups && $scope.assignable.groups.length){
                  $scope.tempAvlGroups = $scope.copyPermisson.availableGroups.concat(angular.copy($scope.copyPermisson.groups))
                  $scope.copyPermisson.groups = $scope.assignable.groups
                  $scope.copyPermisson.hiddenGroups = $scope.copyPermisson.hiddenGroups
                  $scope.copyPermisson.type = $scope.assignable.type
                  angular.forEach($scope.assignable.groups, function (val) {
                    angular.forEach($scope.tempAvlGroups, function (obj, index) {
                      if (val.id == obj.id) {
                        $scope.tempAvlGroups.splice(index, 1);
                      }
                    });
                  });
                  $scope.copyPermisson.availableGroups = $scope.tempAvlGroups;
                } else if($scope.assignable.type == 'p'){
                  $scope.copyPermisson.availableGroups = $scope.copyPermisson.availableGroups.concat(angular.copy($scope.copyPermisson.groups));
                  $scope.copyPermisson.hiddenGroups = $scope.copyPermisson.hiddenGroups;
                  $scope.copyPermisson.type = $scope.assignable.type;
                  $scope.copyPermisson.groups = [];
                }                
                $scope.curPermisson = angular.copy($scope.copyPermisson);
              } else{
                $scope.curPermisson = angular.copy($scope.copyPermisson);
              }
            },
            function (err) {
              $log.error(err);
            }
          );
        }
      } else if (caller == "save") {
        $rootScope.isPermissionOpen = false;
        $scope.curPermis = angular.copy($scope.curPermisson);
        if ($scope.curPermis.type == "p") {
          $scope.permission = { type: $scope.curPermis.type };
        } else {
          $scope.permission = { type: $scope.curPermis.type, groups: $scope.curPermis.groups, hiddenGroups: $scope.curPermis.hiddenGroups };
        }
      } else if (caller == "cancel") {
        $rootScope.isPermissionOpen = false;
        $scope.curPermisson = angular.copy($scope.copyPermisson);
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('HubColorPickerController', HubColorPickerController);

  /** @ngInject */
  function HubColorPickerController($log, $rootScope, $scope, $filter, colorPickerFactory, CommonSrv){
    $rootScope.colorPickerOpen = false;
    $scope.customPallet = [];
    $scope.addColor = "";

    if($scope.isAlpha && $scope.selectedAlpha == undefined){
      $scope.selectedAlpha = 1;
    }

    $scope.colorRegExp = /^[\#]?([a-fA-F0-9]{3}){1,2}$/i;
    $scope.monochromePallet = ["#000000", "#444444", "#666666", "#999999", "#cccccc", "#eeeeee", "#f3f3f3", "#ffffff"];
    $scope.basicPallet = ["#ff0000", "#ff9900", "#ffff00", "#00ff00", "#00ffff", "#0000ff", "#9900ff", "#ff00ff"];
    $scope.defaultPallet = ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc",
      "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd",
      "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0",
      "#cc0000", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79",
      "#990000", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47",
      "#660000", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"
    ];
    $scope.customPalletLoading = true;

    colorPickerFactory.getCustomColors().then(
      function(data){
        $scope.customPallet = data;
        $scope.customPalletLoading = false;
        // Check if the default custom color is in the palette
        var defaultCustomColor = $scope.selectedColor; // Replace with the actual default custom color
        var defaultColorExists = false;
        if($scope.selectedType == 'custom'){
          defaultColorExists = $scope.customPallet.some(function(color) {
            return color.toLowerCase() === defaultCustomColor.toLowerCase();
          });
        }

        // If the default custom color is in the palette, set selectedType to 'custom'
        if(!defaultColorExists && $scope.selectedType == 'custom'){
          $scope.addColor = $scope.selectedColor.toUpperCase();
          $scope.addColorFx();
          $scope.applyColor('apply', $scope.selectedType)
        }
        if(defaultColorExists){
          $scope.selectedType = 'custom';
          $scope.selectedColor = defaultCustomColor.toUpperCase();
        }
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.checkEmpty = function(){
      if($scope.addColor == ""){
        $scope.invalidColorCode = false;
        $scope.colorDuplicate = false;
      }
    }

    $scope.addColorFx = function(){
      $scope.colorDuplicate = false;
      $scope.invalidColorCode = false;
      if($scope.customPallet.length > 0){
        angular.forEach($scope.customPallet, function(color){
          if($filter("lowercase")(color) == $filter("lowercase")($scope.addColor)){
            $scope.colorDuplicate = true;
          }
        });
      }
      if(!$scope.colorRegExp.test($scope.addColor)){
        $scope.invalidColorCode = true;
      }
      if(!$scope.colorDuplicate && !$scope.invalidColorCode){
        if($scope.addColor.indexOf('#') <= 0 && $scope.addColor.length <= 7){
          CommonSrv.saveCustomColors($scope.addColor).then(
            function(data){
              $log.info(data);
              if(data.code == 2001){
                $scope.invalidColorCode = true;
              } else if(data.code == 2002){
                $scope.colorDuplicate = true;
              } else{
                $scope.customPallet.push(data.color);
                $scope.addColor = "";
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.invalidColorCode = true;
        }
      }
    }

    $scope.applyColor = function(index, type){
      if(index == 'apply'){
        $scope.selectedColor = $scope.addColor;
      } else{
        if(type == 'monochrome'){
          $scope.selectedColor = $scope.monochromePallet[index];
        } else if(type == 'basic'){
          $scope.selectedColor = $scope.basicPallet[index];
        } else if(type == 'default'){
          $scope.selectedColor = $scope.defaultPallet[index];
        } else if(type == 'custom'){
          $scope.selectedColor = $scope.customPallet[index];
        }
      }
      $scope.selectedType = type;
      if($scope.selectedElm){
        $scope.curHubColorPicker = {type:$scope.selectedType, color:$scope.selectedColor, alpha:$scope.selectedAlpha, element:$scope.selectedElm};
      } else{
        $scope.curHubColorPicker = {type:$scope.selectedType, color:$scope.selectedColor, alpha:$scope.selectedAlpha};
      }

      if($scope.selectedRgba != undefined){
        var curHax = color_convert.to_rgba($scope.selectedColor);
        $scope.selectedRgba = curHax.split(",")[0]+","+curHax.split(",")[1]+","+curHax.split(",")[2]+","+$scope.selectedAlpha+")";
        $scope.curHubColorPicker.rgba = $scope.selectedRgba;
      }
      $rootScope.$broadcast("hubColorPicker", $scope.curHubColorPicker);
    }

    $scope.applyAlpha = function(){
      if($scope.selectedElm){
        $scope.curHubColorPicker = {type:$scope.selectedType, color:$scope.selectedColor, alpha:$scope.selectedAlpha, element:$scope.selectedElm};
      } else{
        $scope.curHubColorPicker = {type:$scope.selectedType, color:$scope.selectedColor, alpha:$scope.selectedAlpha};
      }

      if($scope.selectedRgba != undefined){
        var curHax = color_convert.to_rgba($scope.selectedColor);
        $scope.selectedRgba = curHax.split(",")[0]+","+curHax.split(",")[1]+","+curHax.split(",")[2]+","+$scope.selectedAlpha+")";
        $scope.curHubColorPicker.rgba = $scope.selectedRgba;
      }
      $rootScope.$broadcast("hubColorPicker", $scope.curHubColorPicker);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FramePermissionsController', FramePermissionsController);

  /** @ngInject */
  function FramePermissionsController($log, $rootScope, $scope, $cookies, CommonSrv){
    $scope.getPermissions = true;
    $scope.curPermissonModel = {};
    $scope.curAuth = angular.fromJson(localStorage.getItem("auth"));
    if($scope.pid == ""){
      $scope.pid = 0;
    }
    $scope.curPermissonObj = {id:$scope.pid, module:$scope.module};

    $scope.listManipulateFx = function(caller, availableList, assignedList, curModel){
      $rootScope.rootManipulateFx(caller, availableList, assignedList, curModel);/*This function in CommonController*/
    }

    $rootScope.framePermissionFx = function(id){
      $scope.curPermissonObj.id = id;
      $scope.permissionFx('cancel');
      $scope.getPermissions = true;
    }
  }
})();
(function () {
    'use strict';
  
    angular
      .module('hub')
      .controller('DeviceStoreAssignableController', DeviceStoreAssignableController);
  
    /** @ngInject */
    function DeviceStoreAssignableController($log, $rootScope, $scope, $filter, $timeout, DevicesSrv) {
      // * scroll list data code START 2nd phase pagination
      $scope.inputLimit = 100;
      $scope.loadingPaging = {a:false, s:false};
      $scope.disabledAddBtn = false;
      $scope.detailListObjDyn = {a:{}, s:{}};
      $scope.scrollDataListDyn = {a:[], s:[]};
      $scope.allScrollDataListDyn = {a:[], s:[]};
      $scope.copyScrollObjDyn = {a:{}, s:{}};
      $scope.visibleObjectsDyn = {a:[], s:[]};
      $scope.haveMoreDataDyn = {a:false, s:false};
      $scope.haveMoreSearchDataDyn = {a:false, s:false};
      $scope.visibleDataDyn = {a:[], s:[]};
      $scope.stIndexDyn = {a:0, s:0};
      $scope.etIndexDyn = {a:300, s:300};
      $scope.searchScrollDyn = {a:false, s:false};
      $scope.detailListObjDyn.a = $scope.assignableScrollObj.a;
      $scope.haveMoreDataDyn.a = $scope.haveMoreAssignableData.a;
      $scope.scrollDataListDyn.a = $scope.assignableListData.a;
      $scope.allScrollDataListDyn.a =  angular.copy($scope.scrollDataListDyn.a);
      $scope.detailListObjDyn.s = $scope.assignableScrollObj.s;
      $scope.haveMoreDataDyn.s = $scope.haveMoreAssignableData.s;
      $scope.scrollDataListDyn.s = $scope.assignableListData.s;
      $scope.allScrollDataListDyn.s =  angular.copy($scope.scrollDataListDyn.s);
      $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:[]};
      $scope.searchTextDyn = {a:"", s:""};
      $scope.avlSort = {type:"l",val:"asc", reverse:false, lType:'device'};
      $scope.selSort = {type:"l",val:"asc", reverse:false, lType:'device'};
      $scope.loadingMore = {a:false, s:false};

      $scope.arraytoStringFx = function(object){
        $scope.stringIds = [];
        angular.forEach(object, function(obj){
          $scope.stringIds.push(obj.id);
        });
        return $scope.stringIds;
      }
      
      $scope.addStatusKey = function(devices, minDeduct){
        if(devices && devices.length){
          angular.forEach(devices, function(device){
            if(device.lp){
              device.status = $filter('isDeviceOnline')(device.lp, {minDeduct: minDeduct});
            } else {
              device.status = "offline";
            }
          })
        }
      }
  
      $scope.triggerWatch = function() {
        var obj = {copyScrollObjDyn: $scope.copyScrollObjDyn, visibleObjectsDyn: $scope.visibleObjectsDyn, haveMoreSearchDataDyn: $scope.haveMoreSearchDataDyn, visibleDataDyn: $scope.visibleDataDyn, stIndexDyn: $scope.stIndexDyn, etIndexDyn: $scope.etIndexDyn, searchScrollDyn: $scope.searchScrollDyn, detailListObjDyn: $scope.detailListObjDyn, haveMoreDataDyn: $scope.haveMoreDataDyn, scrollDataListDyn: $scope.scrollDataListDyn, allScrollDataListDyn: $scope.allScrollDataListDyn, curDevicesDyn: $scope.curDevicesDyn, searchTextDyn: $scope.searchTextDyn, avlSort:$scope.avlSort, selSort:$scope.selSort}
        $rootScope.$broadcast('curSelDevice', { caller:$scope.pageTab, selDevice: $scope.allScrollDataListDyn.s, obj: obj});
      };

      $scope.dbSortFx = function(tempList){
        if($scope.selSort.type == "id"){
          if(!$scope.selSort.reverse){
            tempList = tempList.sort(function(a, b){
              return a.id - b.id;
            });
            return tempList;
          } else if($scope.selSort.reverse){
            tempList = tempList.sort(function(a, b){
              return b.id - a.id;
            });
            return tempList;
          }
        } else{
          var numbers = $filter('filter')(tempList, function (item) {
            return /^\d+/.test(item.l)
          });
          var specialChars = $filter('filter')(tempList, function (item) {
            return /^[^a-zA-Z0-9]/.test(item.l)
          });
          var alphabetic = $filter('filter')(tempList, function (item) {
            return /^[a-zA-Z]/.test(item.l)
          });
          
          if(!$scope.selSort.reverse){
            numbers = numbers.sort(function(a, b){
              return a.l.localeCompare(b.l, undefined, { numeric: false, ignorePunctuation: true });
            });
            specialChars = specialChars.sort(function(a, b){
              return a.l.localeCompare(b.l);
            });
            alphabetic = alphabetic.sort(function(a, b){
              return a.l.localeCompare(b.l, undefined, {ignorePunctuation: true });
            });
            return numbers.concat(specialChars, alphabetic);
          } else if($scope.selSort.reverse){
            numbers = numbers.sort(function(a, b){
              return a.l.localeCompare(b.l, undefined, { numeric: false, ignorePunctuation: true });
            });
            specialChars = specialChars.sort(function(a, b){
              return a.l.localeCompare(b.l);
            });
            alphabetic = alphabetic.sort(function(a, b){
              return a.l.localeCompare(b.l, undefined, {ignorePunctuation: true });
            });
            return numbers.concat(specialChars, alphabetic).reverse();
          }
        }
      }

      //device sorting where we assign devices
      $scope.deviceSortFx = function(caller, sortType, sortVal, reverse){
        if(caller == "a"){
          $scope.disabledAddBtn = true;
          $scope.loadingPaging.a = true;
          $scope.avlSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
          
          $scope.quadIdDyn = caller;
          var tempDetailObj = angular.copy($scope.detailListObjDyn[$scope.quadIdDyn]);
          if($scope.searchScrollDyn[$scope.quadIdDyn]){
            $scope.detailListObjDyn[$scope.quadIdDyn] = {subCaller: tempDetailObj.subCaller, caller: tempDetailObj.caller, offset: 0, id: tempDetailObj.id, searchQ: $scope.searchTextDyn.a, sortType: $scope.avlSort.type, sortVal: $scope.avlSort.val}
            $scope.haveMoreDataDyn[$scope.quadIdDyn] = true;
            $scope.searchChangeDataDyn($scope.searchTextDyn.a, "a")
          } else{
            $scope.detailListObjDyn[$scope.quadIdDyn] = {};
            $scope.scrollDataListDyn[$scope.quadIdDyn] = [];
            $scope.allScrollDataListDyn[$scope.quadIdDyn] = [];
            $scope.copyScrollObjDyn[$scope.quadIdDyn] = {};
            $scope.visibleObjectsDyn[$scope.quadIdDyn] = [];
            $scope.haveMoreDataDyn[$scope.quadIdDyn] = false;
            $scope.haveMoreSearchDataDyn[$scope.quadIdDyn] = false;
            $scope.visibleDataDyn[$scope.quadIdDyn] = [];
            $scope.stIndexDyn[$scope.quadIdDyn] = 0;
            $scope.etIndexDyn[$scope.quadIdDyn] = 300;
            $scope.detailListObjDyn[$scope.quadIdDyn] = {subCaller: tempDetailObj.subCaller, caller: tempDetailObj.caller, offset: 0, id: tempDetailObj.id, sortType: $scope.avlSort.type, sortVal: $scope.avlSort.val}
            DevicesSrv.getScrollListData($scope.detailListObjDyn[$scope.quadIdDyn]).then(
              function(data){
                angular.forEach(data.d, function(obj){
                  obj.disabled = false;
                })
                if($scope.allScrollDataListDyn.s.length){
                  angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                    angular.forEach(data.d, function(dObj){
                      if(obj.id == dObj.id){
                        dObj.disabled = true;
                      }
                      if(dObj.sel && obj.id != dObj.id){
                        dObj.disabled = true;
                      }
                    });
                  });
                }
                if(data.d.length >= 1000){
                  $scope.haveMoreDataDyn[$scope.quadIdDyn] = true;
                } else{
                  $scope.haveMoreDataDyn[$scope.quadIdDyn] = false;
                }
                
                $scope.scrollDataListDyn[$scope.quadIdDyn] = data.d;
                $scope.visibleObjectsDyn[$scope.quadIdDyn] = $scope.scrollDataListDyn[$scope.quadIdDyn].slice($scope.stIndexDyn[$scope.quadIdDyn], $scope.stIndexDyn[$scope.quadIdDyn] + $scope.etIndexDyn[$scope.quadIdDyn]);
                $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[$scope.quadIdDyn], st: $scope.stIndexDyn[$scope.quadIdDyn], et: $scope.etIndexDyn[$scope.quadIdDyn], quadId: $scope.quadIdDyn });
                $scope.allScrollDataListDyn[$scope.quadIdDyn] = angular.copy($scope.scrollDataListDyn[$scope.quadIdDyn]);
                
                $scope.loadingPaging.a = false;
                $scope.disabledAddBtn = false;
                setTimeout(function () {
                  $scope.$apply();
                });
              },
              function(err){
                $scope.loadingPaging.a = false;
                $scope.disabledAddBtn = false;
                $log.error(err);
              }
            );
          }
        } else{
          $scope.loadingPaging[caller] = true;
          $scope.stIndexDyn[caller] = 0;
          $scope.etIndexDyn[caller] = 300;      
          var ScrollElm = document.querySelector("#scroll-container-s");
          ScrollElm.scrollTop = 0;
          $scope.selSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
          var tempList = [];
          tempList = angular.copy($scope.allScrollDataListDyn.s);
          $scope.allScrollDataListDyn.s = [];
          $scope.allScrollDataListDyn.s = angular.copy($scope.dbSortFx(tempList));
        
        
          $scope.scrollDataListDyn.s = [];
          if($scope.searchScrollDyn.s){
            var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
            $scope.scrollDataListDyn.s = getList;
          } else{
            $scope.scrollDataListDyn.s = $scope.allScrollDataListDyn.s;
          }
          $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
          $scope.loadingPaging.s = false;
        }
        $scope.deSelAllDeviceFx(caller, $scope.allScrollDataListDyn[caller]);
        $scope.triggerWatch();
      }
  
      $scope.getAvlList = function(data, text){
        var arr1 = $filter('filter')(data, function (item) {
          return item.l && item.l.toLowerCase().includes(text);
        });
        var arr2 = $filter('filter')(data, function (item) {
          return item.h && item.h.toLowerCase().includes(text);
        });
        var concatArr = arr1.concat(arr2);
        var filteredArr = [], keys = [];
        angular.forEach(concatArr, function (item) {
          if (keys.indexOf(item.h) === -1) {
            keys.push(item.h);
            filteredArr.push(item);
          }
        })
        return filteredArr;
      }
      
      $scope.resetD = function(caller){
        var callerObj = caller == "add"? 'a' : 's';
        if(callerObj == 'a'){
          $rootScope.dAList = [];
        } else{
          $rootScope.dSList = [];
        }

        var callerLists = [
          $scope.allScrollDataListDyn[callerObj],
          $scope.scrollDataListDyn[callerObj],
          $scope.visibleDataDyn[callerObj]
        ];       
        
        angular.forEach(callerLists, function (list) {
          angular.forEach(list, function (dObj) {
            dObj.selected = false;
          });
        });

        if(caller == "add" || caller == "remove"){
          var itemWithId = {};
          angular.forEach($scope.allScrollDataListDyn.s, function(item) {
            itemWithId[item.id] = item;
          });

          angular.forEach($scope.allScrollDataListDyn.a, function(avlItem) {
            var item = itemWithId[avlItem.id];
            if (item) {
              avlItem.disabled = true;
            } else{
              avlItem.disabled = false;
            }
          });
          angular.forEach($scope.scrollDataListDyn.a, function(avlItem) {
            var item = itemWithId[avlItem.id];
            if (item) {
              avlItem.disabled = true;
            } else{
              avlItem.disabled = false;
            }
          });
          angular.forEach($scope.visibleDataDyn.a, function(avlItem) {
            var item = itemWithId[avlItem.id];
            if (item) {
              avlItem.disabled = true;
            } else{
              avlItem.disabled = false;
            }
          });
        }      
        setTimeout(function () {
          $scope.$apply();
        });
        
        if(caller == "add" && $scope.curDevicesDyn.assignedDevicesDyn.length){
          $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:$scope.curDevicesDyn.assignedDevicesDyn};
        } else if(caller == "remove" && $scope.curDevicesDyn.availableDevicesDyn.length){
          $scope.curDevicesDyn = {availableDevicesDyn:$scope.curDevicesDyn.availableDevicesDyn, assignedDevicesDyn:[]};
        } else{
          $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:[]};
        }
      }
  
      $scope.listManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type){
        if(caller == "add"){
          if($rootScope.dAList.length){
            var itemLookup = {};
            angular.forEach(availableList, function(item) {
                itemLookup[item.id] = item;
            });
            $timeout(function() {
              angular.forEach(curModel, function(avlItem) {
                  var item = itemLookup[avlItem.id];
                  if (item && !avlItem.disabled) {
                      avlItem.selected = false;
                      item.selected = false;
                      item.disabled = true;
                  }
              });
            }, 0);
            angular.forEach($rootScope.dAList, function(dlistObj){
              dlistObj.selected = false;
            });
            assignedList = angular.copy(assignedList.concat($rootScope.dAList));
            $scope.scrollDataListDyn.s = assignedList;
            $scope.loadingPaging.s = true;
            $scope.stIndexDyn.s = 0;
            $scope.etIndexDyn.s = 300;
            
            if($scope.searchScrollDyn.s){
              var tempList = [];
              if($scope.allScrollDataListDyn.s.length){
                angular.forEach($scope.scrollDataListDyn.s, function(obj) {
                  // Check if the object with the same id already exists
                  var exists = $scope.allScrollDataListDyn.s.some(function(item) {
                    return item.id === obj.id;
                  });          
                  // Only push the object if it does not already exist
                  if (!exists) {
                    $scope.allScrollDataListDyn.s.push(obj);
                  }
                });
              }
              var tempList = angular.copy($scope.allScrollDataListDyn.s);
              $scope.allScrollDataListDyn.s = [];
              $scope.allScrollDataListDyn.s = angular.copy($scope.dbSortFx(tempList));
              $scope.scrollDataListDyn.s = [];
              var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
              $scope.scrollDataListDyn.s = getList;
              $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
              $scope.visibleDataDyn.s = [];
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
            } else{
              var tempList = $scope.scrollDataListDyn.s;
              $scope.scrollDataListDyn.s = [];
              $scope.scrollDataListDyn.s = angular.copy($scope.dbSortFx(tempList));
            
              $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
              $scope.allScrollDataListDyn.s = [];
              $scope.allScrollDataListDyn.s = angular.copy($scope.scrollDataListDyn.s);
            }
            $scope.loadingPaging.s = false;
            if(type == "d"){
              $scope.resetD(caller);
            }
          }
        } else if(caller == "remove"){
          if($rootScope.dSList.length){

            var itemLookup = {};
            angular.forEach(assignedList, function(item) {
                itemLookup[item.id] = item;
            });

            angular.forEach(curModel, function(assigItem) {
              var item = itemLookup[assigItem.id]; 
              if (item && assigItem.id == item.id) {
                assigItem.selected = false;
              }
            });

            var idArray = $scope.arraytoStringFx($rootScope.dSList);
            for (var i = assignedList.length - 1; i >= 0; i--) {
              if (idArray.includes(assignedList[i].id)) {
                assignedList.splice(i, 1); // Remove the element
              }
            }

            var sScrollElm = document.querySelector("#scroll-container-s");
            if (sScrollElm != null) {
              sScrollElm.scrollTo(0, 0);
            }
            $scope.loadingPaging.s = true;
            $scope.stIndexDyn.s = 0;
            $scope.etIndexDyn.s = 300;
            if($scope.searchScrollDyn.s){
              $scope.scrollDataListDyn.s = [];
              var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
              $scope.scrollDataListDyn.s = angular.copy($scope.dbSortFx(getList));
              $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
              $scope.visibleDataDyn.s = [];
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
            } else{
              $scope.scrollDataListDyn.s = [];
              $scope.scrollDataListDyn.s = angular.copy($scope.dbSortFx($scope.allScrollDataListDyn.s));
              $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
              $scope.allScrollDataListDyn.s = [];
              $scope.allScrollDataListDyn.s = angular.copy($scope.scrollDataListDyn.s);
            }
            if(!$scope.allScrollDataListDyn.s.length){
              $scope.searchTextDyn.s = "";
              $scope.searchScrollDyn.s = false;
            }
            $scope.loadingPaging.s = false;
            if(type == "d"){
              $scope.resetD(caller);
            }
          }
        }
        setTimeout(function () {
          $scope.$apply();
        });
      }
  
      //select all assign & available devices
      $scope.selAllDeviceFx = function(caller, deviceList){
        $scope.nonSelDevices = [];
        $scope.visibleDataDyn[caller].forEach(function(obj){
          if((!obj.disabled && caller=="a") || caller=="s"){
            obj.selected = true;
          }
        });
        $scope.nonSelDevices = deviceList.filter(function (item) {
          if((!item.disabled && caller=="a") || caller=="s"){
            item.selected = true;
            return true;
          }
          return false;
        });
        if($scope.nonSelDevices.length){
          deviceList = $scope.nonSelDevices;
        }
        if(caller=="a"){
          if($scope.curDevicesDyn.assignedDevicesDyn.length){
            $scope.curDevicesDyn = {availableDevicesDyn:angular.copy($scope.nonSelDevices), assignedDevicesDyn:$scope.curDevicesDyn.assignedDevicesDyn};
            $rootScope.dSList = $scope.curDevicesDyn.assignedDevicesDyn;
          } else{
            $rootScope.dSList = [];
            $scope.curDevicesDyn = {availableDevicesDyn:angular.copy($scope.nonSelDevices), assignedDevicesDyn:[]};
          }
          $rootScope.dAList = $scope.curDevicesDyn.availableDevicesDyn;
        } else{
          if($scope.curDevicesDyn.availableDevicesDyn.length){
            $scope.curDevicesDyn = {availableDevicesDyn:$scope.curDevicesDyn.availableDevicesDyn, assignedDevicesDyn:angular.copy(deviceList)};
            $rootScope.dAList = $scope.curDevicesDyn.availableDevicesDyn;
          } else{
            $rootScope.dAList = [];
            $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:angular.copy(deviceList)};
          }
          $rootScope.dSList = $scope.curDevicesDyn.assignedDevicesDyn;
        }
      }
      //select/deselect single assign & available devices
      $scope.selDeviceFx = function(caller, selectedItems, deviceList){
        if((!selectedItems.disabled && caller=="a") || caller=="s"){
          if(caller == "a"){
            $scope.allScrollDataListDyn[caller].forEach(function(obj){
              if(obj.id == selectedItems.id){
                obj.selected = false;
              }
            });
          }
          angular.forEach(deviceList, function(item){
            if(item.id==selectedItems.id){
              item.selected = !item.selected;
              if(caller == "a"){
                if(item.selected){
                  $rootScope.dAList.push(item);
                } else{
                  angular.forEach($rootScope.dAList, function(listItem, i){
                    if(!listItem.selected || listItem.id==selectedItems.id){
                      $rootScope.dAList.splice(i, 1);
                    }
                  });
                }
              } else if(caller == "s"){
                if(item.selected){
                  $rootScope.dSList.push(item);
                } else{
                  angular.forEach($rootScope.dSList, function(listItem, i){
                    if(!listItem.selected || listItem.id==selectedItems.id){
                      $rootScope.dSList.splice(i, 1);
                    }
                  });
                }
              }
              $scope.curDevicesDyn = {availableDevicesDyn:$rootScope.dAList, assignedDevicesDyn:$rootScope.dSList};
            }
          });
        }
      }
      //deselect all assign & available devices
      $scope.deSelAllDeviceFx = function(caller, deviceList){
        $scope.visibleDataDyn[caller].forEach(function(obj){
          obj.selected = false;
        });
        angular.forEach(deviceList, function(item){
          item.selected = false;
        });
        if(caller=="a"){
          $rootScope.dAList = [];
          $scope.curDevicesDyn.availableDevicesDyn = [];
        } else{
          $rootScope.dSList = [];
          $scope.curDevicesDyn.assignedDevicesDyn = [];
        }
      }
  
      // TODO load next data
      $scope.$on('loadNextDataDyn', function (e, obj){
        $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
        $scope.detailListObjDyn[obj.quadId] = {subCaller: $scope.copyScrollObjDyn[obj.quadId].subCaller, caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset:$scope.scrollDataListDyn[obj.quadId].length, id:$scope.copyScrollObjDyn[obj.quadId].id , sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
        $scope.loadingMore[obj.quadId] = true;
        if ($scope.searchScrollDyn[obj.quadId]) {
          $scope.detailListObjDyn[obj.quadId].searchQ = obj.text;
          DevicesSrv.getSearchScrollData($scope.detailListObjDyn[obj.quadId]).then(
            function (data) {
              if(obj.quadId == 'a'){
                angular.forEach(data.d, function(obj){
                  obj.disabled = false;
                })
                if($scope.allScrollDataListDyn.s.length){
                  angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                    angular.forEach(data.d, function(dObj){
                      if(obj.id == dObj.id){
                        dObj.disabled = true;
                      }
                      if(dObj.sel && obj.id != dObj.id){
                        dObj.disabled = true;
                      }
                    });
                  });
                }
              }
              if (data.d.length >= 1000) {  
                $scope.haveMoreSearchDataDyn[obj.quadId] = true;
              } else {
                $scope.haveMoreSearchDataDyn[obj.quadId] = false;
              }
              $scope.allScrollDataListDyn[obj.quadId] = [];
              $scope.scrollDataListDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].concat(data.d);
              $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
              setTimeout(function () {
                $scope.$apply();
                $scope.loadingMore[obj.quadId] = false;
              });
            },
            function (err) {
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        } else {
          DevicesSrv.getScrollListData($scope.detailListObjDyn[obj.quadId]).then(
            function (data) {              
              if(obj.quadId == 'a'){
                angular.forEach(data.d, function(obj){
                  obj.disabled = false;
                })
                if($scope.allScrollDataListDyn.s.length){
                  angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                    angular.forEach(data.d, function(dObj){
                      if(obj.id == dObj.id){
                        dObj.disabled = true;
                      }
                      if(dObj.sel && obj.id != dObj.id){
                        dObj.disabled = true;
                      }
                    });
                  });
                }
              }
              if (data.d.length >= 1000) {
                $scope.haveMoreDataDyn[obj.quadId] = true;
              } else if (data.d.length && data.d.length < 1000) {
                $scope.haveMoreDataDyn[obj.quadId] = false;
              }
              $scope.allScrollDataListDyn[obj.quadId] = [];
              $scope.scrollDataListDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].concat(data.d);
              $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
              setTimeout(function () {
                $scope.$apply();
                $scope.loadingMore[obj.quadId] = false;
              });
            },
            function (err) {
              $scope.loadingMore[obj.quadId] = false;
              $log.error(err);
            }
          );
        }
      });
  
      // TODO get search data API call
      $scope.$on('searchScrollDynDataDyn', function (e, obj){
        $scope.stIndexDyn[obj.quadId] = 0;
        $scope.etIndexDyn[obj.quadId] = 300;
        $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
        $scope.scrollDataListDyn[obj.quadId] = [];
        $scope.loadingPaging[obj.quadId] = true;
        if (obj.text) {
          $scope.detailListObjDyn[obj.quadId] = {subCaller: $scope.copyScrollObjDyn[obj.quadId].subCaller, caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset: 0, searchQ: obj.text, id:$scope.copyScrollObjDyn[obj.quadId].id, sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
        } else {
          $scope.detailListObjDyn[obj.quadId] = {subCaller: $scope.copyScrollObjDyn[obj.quadId].subCaller, caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset: 0, id:$scope.copyScrollObjDyn[obj.quadId].id, sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
        }

        if (obj.text) {
          $scope.searchScrollDyn[obj.quadId] = true;
          $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
          DevicesSrv.getSearchScrollData($scope.detailListObjDyn[obj.quadId]).then(
            function (data) {
              if(obj.quadId == 'a'){
                angular.forEach(data.d, function(obj){
                  obj.disabled = false;
                })
                if($scope.allScrollDataListDyn.s.length){
                  angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                    angular.forEach(data.d, function(dObj){
                      if(obj.id == dObj.id){
                        dObj.disabled = true;
                      }
                      if(dObj.sel && obj.id != dObj.id){
                        dObj.disabled = true;
                      }
                    });
                  });
                }
              }
              if (data.d.length && data.d.length >= 1000) {
                $scope.haveMoreSearchDataDyn[obj.quadId] = true;
              } else {
                $scope.haveMoreSearchDataDyn[obj.quadId] = false;
              }
              $scope.scrollDataListDyn[obj.quadId] = data.d;
              $scope.visibleObjectsDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].slice($scope.stIndexDyn[obj.quadId], $scope.stIndexDyn[obj.quadId] + $scope.etIndexDyn[obj.quadId]);
              setTimeout(function () {
                $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[obj.quadId], st: $scope.stIndexDyn[obj.quadId], et: $scope.etIndexDyn[obj.quadId], quadId: obj.quadId });
                $scope.allScrollDataListDyn[obj.quadId] = [];
                $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
                $scope.loadingPaging[obj.quadId] = false;
                $scope.disabledAddBtn = false;
                $scope.$apply();
              }, 100);
            },
            function (err) {
              $scope.loadingPaging[obj.quadId] = false;
              $scope.disabledAddBtn = false;
              $log.error(err);
            }
          );
        } else {
          $scope.haveMoreSearchDataDyn[obj.quadId] = false;
          $scope.searchScrollDyn[obj.quadId] = false;
          $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
          DevicesSrv.getScrollListData($scope.detailListObjDyn[obj.quadId]).then(
            function (data) {
              if(obj.quadId == 'a'){
                angular.forEach(data.d, function(obj){
                  obj.disabled = false;
                })
                if($scope.allScrollDataListDyn.s.length){
                  angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                    angular.forEach(data.d, function(dObj){
                      if(obj.id == dObj.id){
                        dObj.disabled = true;
                      }
                      if(dObj.sel && obj.id != dObj.id){
                        dObj.disabled = true;
                      }
                    });
                  });
                }
              }
              if (data.d.length >= 1000) {
                $scope.haveMoreDataDyn[obj.quadId] = true;
              } else {
                $scope.haveMoreDataDyn[obj.quadId] = false;
              }
              $scope.scrollDataListDyn[obj.quadId] = data.d;
              $scope.visibleObjectsDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].slice($scope.stIndexDyn[obj.quadId], $scope.stIndexDyn[obj.quadId] + $scope.etIndexDyn[obj.quadId]);
              setTimeout(function () {
                $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[obj.quadId], st: $scope.stIndexDyn[obj.quadId], et: $scope.etIndexDyn[obj.quadId], quadId: obj.quadId });
                $scope.allScrollDataListDyn[obj.quadId] = [];
                $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
    
                $scope.loadingPaging[obj.quadId] = false;
                $scope.disabledAddBtn = false;
                $scope.$apply();
              }, 100);
            },
            function (err) {
              $scope.loadingPaging[obj.quadId] = false;
              $scope.disabledAddBtn = false;
              $log.error(err);
            }
          );
        }
      });
  
      // TODO visibleDataDyn come from the directive
      $scope.$on('visibleDataDyn', function (e, obj){
        $scope.stIndexDyn[obj.quadId] = obj.st;
        $scope.etIndexDyn[obj.quadId] = obj.et;
        $scope.visibleDataDyn[obj.quadId] = obj.vObj;
        $scope.addStatusKey($scope.visibleDataDyn[obj.quadId], $scope.minDeduct);
        setTimeout(function () {
          $scope.$apply();
        }, 0);
      });
  
      $scope.searchChangeDataDyn = function (val, quadId){
        var text = val.toLowerCase();
        $scope.deSelAllDeviceFx(quadId, $scope.allScrollDataListDyn[quadId]);
        angular.forEach($scope.allScrollDataListDyn[quadId], function(dObj){
          dObj.selected = false;
        });
        angular.forEach($scope.visibleDataDyn[quadId], function(dObj){
          dObj.selected = false;
        });
        angular.forEach($scope.scrollDataListDyn[quadId], function(dObj){
          dObj.selected = false;
        });
        var scrollElement = document.querySelector("#scroll-container-" + quadId);
        if (!text && $scope.searchScrollDyn[quadId] && quadId == "a") {
          // TODO Enter when have newVal is empty and user perform search operation already
          $scope.disabledAddBtn = true;
          if (scrollElement != null) {
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndexDyn[quadId] = 0;
          $scope.etIndexDyn[quadId] = 300;
          $scope.visibleObjectsDyn[quadId] = $scope.allScrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
          $rootScope.$broadcast('searchScrollDynDataDyn', { text: '', st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
        } else if (text && text.length >= 3 && quadId == "a") {
          // TODO Enter when have newVal has 3 or grater than 3 character
          $scope.disabledAddBtn = true;
          if (scrollElement != null) {
            scrollElement.scrollTo(0, 0);
          }
          if (!$scope.haveMoreDataDyn[quadId]) {
            var obj1 = $filter('filter')($scope.allScrollDataListDyn[quadId], function (item) {
              return item.l && item.l.toLowerCase().includes(text);
            });
            var obj2 = $filter('filter')($scope.allScrollDataListDyn[quadId], function (item) {
              return item.h && item.h.toLowerCase().includes(text);
            });
  
            var concatObj = obj1.concat(obj2);
            var filteredObj = [], keys = [];
            angular.forEach(concatObj, function (item) {
              if (keys.indexOf(item.h) === -1) {
                keys.push(item.h);
                filteredObj.push(item);
              }
            })
            if (filteredObj.length && filteredObj.length >= 1000) {
              $scope.haveMoreSearchDataDyn[quadId] = true;
            } else {
              $scope.haveMoreSearchDataDyn[quadId] = false;
            }
            $scope.scrollDataListDyn[quadId] = filteredObj;
            $scope.stIndexDyn[quadId] = 0;
            $scope.etIndexDyn[quadId] = 300;
            if ($scope.scrollDataListDyn[quadId].length <= 300) {
              $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId];
            } else {
              $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
            }
            $scope.searchScrollDyn[quadId] = true;
            setTimeout(function(){
              $scope.disabledAddBtn = false;
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
            }, 100)
          } else {
            $scope.stIndexDyn[quadId] = 0;
            $scope.etIndexDyn[quadId] = 300;
            $rootScope.$broadcast('searchScrollDynDataDyn', { text: text, st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
          }
        } else if (text && text.length >= 3 && quadId == "s") {
          // TODO Enter when have newVal has 3 or grater than 3 character
          if (scrollElement != null) {
            scrollElement.scrollTo(0, 0);
          }
          var obj1 = $filter('filter')($scope.allScrollDataListDyn.s, function (item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataListDyn.s, function (item) {
            return item.h && item.h.toLowerCase().includes(text);
          });
  
          var concatObj = obj1.concat(obj2);
          // var filteredObj = [], keys = [];
          // angular.forEach(concatObj, function (item) {
          //   if (keys.indexOf(item.h) === -1) {
          //     keys.push(item.h);
          //     filteredObj.push(item);
          //   }
          // })
          // Use Set for tracking unique 'h' values
          var filteredObj = [];
          var keys = new Set();  // Using Set for faster lookup

          // Merge arrays using push.apply for better performance with large arrays
          var concatObj = obj1.concat(obj2);

          // Loop through the merged array
          angular.forEach(concatObj, function (item) {
            if (!keys.has(item.h)) {  // Use Set's has() method for faster lookup
              keys.add(item.h);       // Add the 'h' value to the Set
              filteredObj.push(item); // Push the item to the filtered array
            }
          });
          if (filteredObj.length && filteredObj.length >= 1000) {
            $scope.haveMoreSearchDataDyn.s = true;
          } else {
            $scope.haveMoreSearchDataDyn.s = false;
          }
          $scope.scrollDataListDyn.s = filteredObj;
          $scope.stIndexDyn.s = 0;
          $scope.etIndexDyn.s = 300;
          if ($scope.scrollDataListDyn.s.length <= 300) {
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s;
          } else {
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
          }
          $scope.searchScrollDyn.s = true;
          setTimeout(function(){
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: quadId });
          }, 100)
        } else if(!text && quadId == "s"){
          $scope.haveMoreSearchDataDyn.s = false;
          $scope.searchScrollDyn.s = false;
          if (scrollElement != null) {
            scrollElement.scrollTo(0, 0);
          }
          $scope.stIndexDyn[quadId] = 0;
          $scope.etIndexDyn[quadId] = 300;
          // $scope.visibleObjectsDyn[quadId] = $scope.allScrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
          // $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
          $scope.scrollDataListDyn[quadId] = [];
          $scope.scrollDataListDyn[quadId] = $scope.allScrollDataListDyn[quadId];
          $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
          $scope.allScrollDataListDyn[quadId] = [];
          $scope.allScrollDataListDyn[quadId] = angular.copy($scope.scrollDataListDyn[quadId]);
        }
      }
  
      // Use $watch to monitor currentPageDevice for changes
      $scope.$watch('allScrollDataListDyn.s', function(newVal, oldVal) {
        var obj = {copyScrollObjDyn: $scope.copyScrollObjDyn, visibleObjectsDyn: $scope.visibleObjectsDyn, haveMoreSearchDataDyn: $scope.haveMoreSearchDataDyn, visibleDataDyn: $scope.visibleDataDyn, stIndexDyn: $scope.stIndexDyn, etIndexDyn: $scope.etIndexDyn, searchScrollDyn: $scope.searchScrollDyn, detailListObjDyn: $scope.detailListObjDyn, haveMoreDataDyn: $scope.haveMoreDataDyn, scrollDataListDyn: $scope.scrollDataListDyn, allScrollDataListDyn: $scope.allScrollDataListDyn, curDevicesDyn: $scope.curDevicesDyn, searchTextDyn: $scope.searchTextDyn, avlSort:$scope.avlSort, selSort:$scope.selSort}
        $rootScope.$broadcast('curSelDevice', { caller:$scope.pageTab, selDevice: $scope.allScrollDataListDyn.s, obj: obj});
      }, true); // 'true' for deep watch
      
      // * scroll list data code END 2nd phase pagination

      // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('hub')
    .controller('DeviceAssignableController', DeviceAssignableController);

  /** @ngInject */
  function DeviceAssignableController($log, $rootScope, $scope, $filter, $timeout, DevicesSrv) {
    // * scroll list data code START 2nd phase pagination
    $scope.inputLimit = 100;
    $scope.loadingPaging = {a:false, s:false};
    $scope.disabledAddBtn = false;
    if($scope.callApi){
      $scope.detailListObjDyn = {a:{}, s:{}};
      $scope.scrollDataListDyn = {a:[], s:[]};
      $scope.allScrollDataListDyn = {a:[], s:[]};
      $scope.copyScrollObjDyn = {a:{}, s:{}};
      $scope.visibleObjectsDyn = {a:[], s:[]};
      $scope.haveMoreDataDyn = {a:false, s:false};
      $scope.haveMoreSearchDataDyn = {a:false, s:false};
      $scope.visibleDataDyn = {a:[], s:[]};
      $scope.stIndexDyn = {a:0, s:0};
      $scope.etIndexDyn = {a:300, s:300};
      $scope.searchScrollDyn = {a:false, s:false};
      $scope.quadIdDyn = 'a';
      $scope.detailListObjDyn[$scope.quadIdDyn] = $scope.assignableScrollObj;
      $scope.haveMoreDataDyn[$scope.quadIdDyn] = $scope.haveMoreAssignableData;
      $scope.scrollDataListDyn[$scope.quadIdDyn] = $scope.assignableListData;
      $scope.allScrollDataListDyn[$scope.quadIdDyn] =  angular.copy($scope.scrollDataListDyn[$scope.quadIdDyn]);
      $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:[]};
      $scope.searchTextDyn = {a:"", s:""};
      $scope.avlSort = {type:"l",val:"asc", reverse:false, lType:'device'};
      $scope.selSort = {type:"l",val:"asc", reverse:false, lType:'device'};
    } else {      
      $scope.detailListObjDyn = {a:{}, s:$scope.storeDataList.detailListObjDyn.s};
      $scope.scrollDataListDyn = {a:[], s:$scope.storeDataList.scrollDataListDyn.s};
      $scope.allScrollDataListDyn = {a:[], s:$scope.storeDataList.allScrollDataListDyn.s};
      $scope.copyScrollObjDyn = {a:{}, s:$scope.storeDataList.copyScrollObjDyn.s};
      $scope.visibleObjectsDyn = {a:[], s:[]};
      $scope.haveMoreDataDyn = {a:false, s:$scope.storeDataList.haveMoreDataDyn.s};
      $scope.haveMoreSearchDataDyn = {a:false, s:$scope.storeDataList.haveMoreSearchDataDyn.s};
      $scope.visibleDataDyn = {a:[], s:[]};
      $scope.stIndexDyn = {a:0, s:0};
      $scope.etIndexDyn = {a:300, s:300};
      $scope.searchScrollDyn = {a:false, s:false};
      $scope.searchTextDyn = {a:"", s:""};
      $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:[]};
      // $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:$scope.storeDataList.allScrollDataListDyn.s};
      $scope.quadIdDyn = "a";
      $scope.loadingPaging.a = true;
      $scope.avlSort = $scope.storeDataList.avlSort;
      $scope.selSort = $scope.storeDataList.selSort;
      $scope.detailListObjDyn[$scope.quadIdDyn] = {caller: $scope.storeDataList.detailListObjDyn[$scope.quadIdDyn].caller, offset: 0, id: 0, sortType: $scope.avlSort.type, sortVal: $scope.avlSort.val}
      $scope.disabledAddBtn = true;
      DevicesSrv.getScrollListData($scope.detailListObjDyn[$scope.quadIdDyn]).then(
        function(data){
          angular.forEach(data.d, function(obj){
            obj.disabled = false;
          })
          if($scope.allScrollDataListDyn.s.length){
            angular.forEach($scope.allScrollDataListDyn.s, function(obj){
              angular.forEach(data.d, function(dObj){
                if(obj.id == dObj.id){
                  dObj.disabled = true;
                }
              });
            });
          }
          if(data.d.length >= 1000){
            $scope.haveMoreDataDyn[$scope.quadIdDyn] = true;
          } else{
            $scope.haveMoreDataDyn[$scope.quadIdDyn] = false;
          }
          
          $scope.scrollDataListDyn[$scope.quadIdDyn] = data.d;
          $scope.visibleObjectsDyn[$scope.quadIdDyn] = $scope.scrollDataListDyn[$scope.quadIdDyn].slice($scope.stIndexDyn[$scope.quadIdDyn], $scope.stIndexDyn[$scope.quadIdDyn] + $scope.etIndexDyn[$scope.quadIdDyn]);
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[$scope.quadIdDyn], st: $scope.stIndexDyn[$scope.quadIdDyn], et: $scope.etIndexDyn[$scope.quadIdDyn], quadId: $scope.quadIdDyn });
          $scope.allScrollDataListDyn[$scope.quadIdDyn] = angular.copy($scope.scrollDataListDyn[$scope.quadIdDyn]);
          
          $scope.loadingPaging.a = false;
          $scope.disabledAddBtn = false;

          setTimeout(function () {
            $scope.$apply();
          });
        },
        function(err){
          $scope.loadingPaging.a = false;
          $scope.disabledAddBtn = false;
          $log.error(err);
        }
      );
      
      angular.forEach($scope.allScrollDataListDyn.s, function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.visibleDataDyn.s, function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.scrollDataListDyn.s, function(dObj){
        dObj.selected = false;
      });      
      var scrollElement = document.querySelector("#scroll-container-s");
      if (scrollElement != null) {
        scrollElement.scrollTo(0, 0);
      }
      $scope.scrollDataListDyn.s = [];
      $scope.scrollDataListDyn.s = $scope.allScrollDataListDyn.s;
      $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
      $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
      $scope.allScrollDataListDyn.s = [];
      $scope.allScrollDataListDyn.s = angular.copy($scope.scrollDataListDyn.s);
    }

    $scope.addStatusKey = function(devices, minDeduct){
      if(devices && devices.length){
        angular.forEach(devices, function(device){
          if(device.lp){
            device.status = $filter('isDeviceOnline')(device.lp, {minDeduct: minDeduct});
          } else {
            device.status = "offline";
          }
        })
      }
    }

    $scope.triggerWatch = function() {
      var obj = {copyScrollObjDyn: $scope.copyScrollObjDyn, visibleObjectsDyn: $scope.visibleObjectsDyn, haveMoreSearchDataDyn: $scope.haveMoreSearchDataDyn, visibleDataDyn: $scope.visibleDataDyn, stIndexDyn: $scope.stIndexDyn, etIndexDyn: $scope.etIndexDyn, searchScrollDyn: $scope.searchScrollDyn, detailListObjDyn: $scope.detailListObjDyn, haveMoreDataDyn: $scope.haveMoreDataDyn, scrollDataListDyn: $scope.scrollDataListDyn, allScrollDataListDyn: $scope.allScrollDataListDyn, curDevicesDyn: $scope.curDevicesDyn, searchTextDyn: $scope.searchTextDyn, avlSort:$scope.avlSort, selSort:$scope.selSort}
      $rootScope.$broadcast('curSelDevice', { caller:$scope.pageTab, selDevice: $scope.allScrollDataListDyn.s, obj: obj});
    };
    //device sorting where we assign devices
    $scope.deviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $scope.disabledAddBtn = true;
        $scope.loadingPaging.a = true;
        $scope.avlSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
        
        $scope.quadIdDyn = caller;
        var tempDetailObj = angular.copy($scope.detailListObjDyn[$scope.quadIdDyn]);
        if($scope.searchScrollDyn[$scope.quadIdDyn]){
          $scope.detailListObjDyn[$scope.quadIdDyn] = {caller: tempDetailObj.caller, offset: 0, id: 0, searchQ: $scope.searchTextDyn.a, sortType: $scope.avlSort.type, sortVal: $scope.avlSort.val}
          $scope.haveMoreDataDyn[$scope.quadIdDyn] = true;
          $scope.searchChangeDataDyn($scope.searchTextDyn.a, "a")
        } else{
          $scope.detailListObjDyn[$scope.quadIdDyn] = {};
          $scope.scrollDataListDyn[$scope.quadIdDyn] = [];
          $scope.allScrollDataListDyn[$scope.quadIdDyn] = [];
          $scope.copyScrollObjDyn[$scope.quadIdDyn] = {};
          $scope.visibleObjectsDyn[$scope.quadIdDyn] = [];
          $scope.haveMoreDataDyn[$scope.quadIdDyn] = false;
          $scope.haveMoreSearchDataDyn[$scope.quadIdDyn] = false;
          $scope.visibleDataDyn[$scope.quadIdDyn] = [];
          $scope.stIndexDyn[$scope.quadIdDyn] = 0;
          $scope.etIndexDyn[$scope.quadIdDyn] = 300;
          $scope.detailListObjDyn[$scope.quadIdDyn] = {caller: tempDetailObj.caller, offset: 0, id: 0, sortType: $scope.avlSort.type, sortVal: $scope.avlSort.val}
          DevicesSrv.getScrollListData($scope.detailListObjDyn[$scope.quadIdDyn]).then(
            function(data){
              angular.forEach(data.d, function(obj){
                obj.disabled = false;
              })
              if($scope.allScrollDataListDyn.s.length){
                angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                  angular.forEach(data.d, function(dObj){
                    if(obj.id == dObj.id){
                      dObj.disabled = true;
                    }
                  });
                });
              }
              if(data.d.length >= 1000){
                $scope.haveMoreDataDyn[$scope.quadIdDyn] = true;
              } else{
                $scope.haveMoreDataDyn[$scope.quadIdDyn] = false;
              }
              
              $scope.scrollDataListDyn[$scope.quadIdDyn] = data.d;
              $scope.visibleObjectsDyn[$scope.quadIdDyn] = $scope.scrollDataListDyn[$scope.quadIdDyn].slice($scope.stIndexDyn[$scope.quadIdDyn], $scope.stIndexDyn[$scope.quadIdDyn] + $scope.etIndexDyn[$scope.quadIdDyn]);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[$scope.quadIdDyn], st: $scope.stIndexDyn[$scope.quadIdDyn], et: $scope.etIndexDyn[$scope.quadIdDyn], quadId: $scope.quadIdDyn });
              $scope.allScrollDataListDyn[$scope.quadIdDyn] = angular.copy($scope.scrollDataListDyn[$scope.quadIdDyn]);
              
              $scope.loadingPaging.a = false;
              $scope.disabledAddBtn = false;
              setTimeout(function () {
                $scope.$apply();
              });
            },
            function(err){
              $scope.loadingPaging.a = false;
              $scope.disabledAddBtn = false;
              $log.error(err);
            }
          );
        }
      } else{
        $scope.loadingPaging[caller] = true;
        $scope.stIndexDyn[caller] = 0;
        $scope.etIndexDyn[caller] = 300;      
        var ScrollElm = document.querySelector("#scroll-container-s");
        ScrollElm.scrollTop = 0;
        $scope.selSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
        var tempList = [];
        tempList = angular.copy($scope.allScrollDataListDyn.s);
        $scope.allScrollDataListDyn.s = [];
        $scope.allScrollDataListDyn.s = $filter('orderBy')(tempList, $scope.selSort.type, $scope.selSort.reverse);
        $scope.scrollDataListDyn.s = [];
        if($scope.searchScrollDyn.s){
          var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
          $scope.scrollDataListDyn.s = getList;
        } else{
          $scope.scrollDataListDyn.s = $scope.allScrollDataListDyn.s;
        }
        $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
        // setTimeout(function(){
          $scope.loadingPaging.s = false;
        // })
      }
      $scope.deSelAllDeviceFx(caller, $scope.allScrollDataListDyn[caller]);
      $scope.triggerWatch();
    }

    $scope.getAvlList = function(data, text){
      var arr1 = $filter('filter')(data, function (item) {
        return item.l && item.l.toLowerCase().includes(text);
      });
      var arr2 = $filter('filter')(data, function (item) {
        return item.h && item.h.toLowerCase().includes(text);
      });
      var concatArr = arr1.concat(arr2);
      var filteredArr = [], keys = [];
      angular.forEach(concatArr, function (item) {
        if (keys.indexOf(item.h) === -1) {
          keys.push(item.h);
          filteredArr.push(item);
        }
      })
      return filteredArr;
    }
    
    $scope.resetD = function(caller){
      var callerObj = caller == "add"? 'a' : 's';
      if(callerObj == 'a'){
        $rootScope.dAList = [];
      } else{
        $rootScope.dSList = [];
      }
      angular.forEach($scope.allScrollDataListDyn.a, function(dObj){
        dObj.disabled = false;
      });
      angular.forEach($scope.scrollDataListDyn.a, function(dObj){
        dObj.disabled = false;
      });
      angular.forEach($scope.visibleDataDyn.a, function(dObj){
        dObj.disabled = false;
      });
      angular.forEach($scope.allScrollDataListDyn[callerObj], function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.scrollDataListDyn[callerObj], function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.visibleDataDyn[callerObj], function(dObj){
        dObj.selected = false;
      });
      if($scope.allScrollDataListDyn.s.length && (caller == "add" || caller == "remove")){
        angular.forEach($scope.allScrollDataListDyn.s, function(obj){
          angular.forEach($scope.allScrollDataListDyn.a, function(dObj){
            if(obj.id == dObj.id){
              dObj.disabled = true;
            }
          });
        });
        angular.forEach($scope.allScrollDataListDyn.s, function(obj){
          angular.forEach($scope.scrollDataListDyn.a, function(dObj){
            if(obj.id == dObj.id){
              dObj.disabled = true;
            }
          });
        });
        angular.forEach($scope.allScrollDataListDyn.s, function(obj){
          angular.forEach($scope.visibleDataDyn.a, function(dObj){
            if(obj.id == dObj.id){
              dObj.disabled = true;
            }
          });
        });
      }      
      setTimeout(function () {
        $scope.$apply();
      });
      
      if(caller == "add" && $scope.curDevicesDyn.assignedDevicesDyn.length){
        $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:$scope.curDevicesDyn.assignedDevicesDyn};
      } else if(caller == "remove" && $scope.curDevicesDyn.availableDevicesDyn.length){
        $scope.curDevicesDyn = {availableDevicesDyn:$scope.curDevicesDyn.availableDevicesDyn, assignedDevicesDyn:[]};
      } else{
        $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:[]};
      }
    }

    $scope.listManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type){
      if(caller == "add"){
        if($rootScope.dAList.length){
          angular.forEach(curModel, function(avlItem){
            angular.forEach(availableList, function(item){
              if(avlItem.id == item.id && !avlItem.disabled){
                avlItem.selected = false;
                var valObj = angular.copy(avlItem);
                assignedList.push(valObj);
                item.selected = false;
                item.disabled = true;
              }
            });
          });
          $scope.loadingPaging.s = true;
          $scope.stIndexDyn.s = 0;
          $scope.etIndexDyn.s = 300;
          
          if($scope.searchScrollDyn.s){
            var tempList = [];
            if($scope.allScrollDataListDyn.s.length){
              angular.forEach($scope.scrollDataListDyn.s, function(obj) {
                // Check if the object with the same id already exists
                var exists = $scope.allScrollDataListDyn.s.some(function(item) {
                  return item.id === obj.id;
                });          
                // Only push the object if it does not already exist
                if (!exists) {
                  $scope.allScrollDataListDyn.s.push(obj);
                }
              });
            }
            var tempList = angular.copy($scope.allScrollDataListDyn.s);
            $scope.allScrollDataListDyn.s = [];
            $scope.allScrollDataListDyn.s = $filter('orderBy')(tempList, $scope.selSort.type, $scope.selSort.reverse);
            $scope.scrollDataListDyn.s = [];
            var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
            $scope.scrollDataListDyn.s = getList;
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
            $scope.visibleDataDyn.s = [];
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
            // setTimeout(function(){
            // })
          } else{
            var tempList = $scope.scrollDataListDyn.s;
            $scope.scrollDataListDyn.s = [];
            $scope.scrollDataListDyn.s = $filter('orderBy')(tempList, $scope.selSort.type, $scope.selSort.reverse);
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
            $scope.allScrollDataListDyn.s = [];
            $scope.allScrollDataListDyn.s = angular.copy($scope.scrollDataListDyn.s);
          }
          $scope.loadingPaging.s = false;
          if(type == "d"){
            $scope.resetD(caller);
          }
        }
      } else if(caller == "remove"){
        if($rootScope.dSList.length){
          angular.forEach(curModel, function(assigItem){
            angular.forEach(assignedList, function(item){
              if(assigItem.id == item.id){
                assigItem.selected = false;
                assignedList.splice(assignedList.indexOf(item), 1);
              }
            });
          });
          var sScrollElm = document.querySelector("#scroll-container-s");
          if (sScrollElm != null) {
            sScrollElm.scrollTo(0, 0);
          }
          $scope.loadingPaging.s = true;
          $scope.stIndexDyn.s = 0;
          $scope.etIndexDyn.s = 300;
          if($scope.searchScrollDyn.s){
            $scope.scrollDataListDyn.s = [];
            var getList = $scope.getAvlList($scope.allScrollDataListDyn.s, $scope.searchTextDyn.s.toLowerCase());
            $scope.scrollDataListDyn.s = $filter('orderBy')(getList, $scope.selSort.type, $scope.selSort.reverse);;
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
            $scope.visibleDataDyn.s = [];
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
          } else{
            $scope.scrollDataListDyn.s = [];
            $scope.scrollDataListDyn.s = $filter('orderBy')($scope.allScrollDataListDyn.s, $scope.selSort.type, $scope.selSort.reverse);
            $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: "s" });
            $scope.allScrollDataListDyn.s = [];
            $scope.allScrollDataListDyn.s = angular.copy($scope.scrollDataListDyn.s);
          }
          if(!$scope.allScrollDataListDyn.s.length){
            $scope.searchTextDyn.s = "";
            $scope.searchScrollDyn.s = false;
          }
          $scope.loadingPaging.s = false;
          if(type == "d"){
            $scope.resetD(caller);
          }
        }
      }
      setTimeout(function () {
        $scope.$apply();
      });
    }

    //select all assign & available devices
    $scope.selAllDeviceFx = function(caller, deviceList){
      $scope.nonSelDevices = [];
      $scope.visibleDataDyn[caller].forEach(function(obj){
        if((!obj.disabled && caller=="a") || caller=="s"){
          obj.selected = true;
        }
      });
      deviceList.forEach(function(item){
        if((!item.disabled && caller=="a") || caller=="s"){
          item.selected = true;
          $scope.nonSelDevices.push(item);
        }
      });
      if($scope.nonSelDevices.length){
        deviceList = $scope.nonSelDevices;
      }
      if(caller=="a"){
        if($scope.curDevicesDyn.assignedDevicesDyn.length){
          $scope.curDevicesDyn = {availableDevicesDyn:angular.copy(deviceList), assignedDevicesDyn:$scope.curDevicesDyn.assignedDevicesDyn};
          $rootScope.dSList = $scope.curDevicesDyn.assignedDevicesDyn;
        } else{
          $rootScope.dSList = [];
          $scope.curDevicesDyn = {availableDevicesDyn:angular.copy(deviceList), assignedDevicesDyn:[]};
        }
        $rootScope.dAList = $scope.curDevicesDyn.availableDevicesDyn;
      } else{
        if($scope.curDevicesDyn.availableDevicesDyn.length){
          $scope.curDevicesDyn = {availableDevicesDyn:$scope.curDevicesDyn.availableDevicesDyn, assignedDevicesDyn:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevicesDyn.availableDevicesDyn;
        } else{
          $rootScope.dAList = [];
          $scope.curDevicesDyn = {availableDevicesDyn:[], assignedDevicesDyn:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevicesDyn.assignedDevicesDyn;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      if((!selectedItems.disabled && caller=="a") || caller=="s"){
        if(caller == "a"){
          $scope.allScrollDataListDyn[caller].forEach(function(obj){
            if(obj.id == selectedItems.id){
              obj.selected = false;
            }
          });
        }
        angular.forEach(deviceList, function(item){
          if(item.id==selectedItems.id){
            item.selected = !item.selected;
            if(caller == "a"){
              if(item.selected){
                $rootScope.dAList.push(item);
              } else{
                angular.forEach($rootScope.dAList, function(listItem, i){
                  if(!listItem.selected || listItem.id==selectedItems.id){
                    $rootScope.dAList.splice(i, 1);
                  }
                });
              }
            } else if(caller == "s"){
              if(item.selected){
                $rootScope.dSList.push(item);
              } else{
                angular.forEach($rootScope.dSList, function(listItem, i){
                  if(!listItem.selected || listItem.id==selectedItems.id){
                    $rootScope.dSList.splice(i, 1);
                  }
                });
              }
            }
            $scope.curDevicesDyn = {availableDevicesDyn:$rootScope.dAList, assignedDevicesDyn:$rootScope.dSList};
          }
        });
      }
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      $scope.visibleDataDyn[caller].forEach(function(obj){
        obj.selected = false;
      });
      angular.forEach(deviceList, function(item){
        item.selected = false;
      });
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevicesDyn.availableDevicesDyn = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevicesDyn.assignedDevicesDyn = [];
      }
    }

    // TODO load next data
    $scope.$on('loadNextDataDyn', function (e, obj){
      $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
      $scope.detailListObjDyn[obj.quadId] = { caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset:$scope.scrollDataListDyn[obj.quadId].length, id:0 , sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
      if ($scope.searchScrollDyn[obj.quadId]) {
        $scope.detailListObjDyn[obj.quadId].searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.detailListObjDyn[obj.quadId]).then(
          function (data) {
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            if($scope.allScrollDataListDyn.s.length){
              angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                angular.forEach(data.d, function(dObj){
                  if(obj.id == dObj.id){
                    dObj.disabled = true;
                  }
                });
              });
            }
            if (data.d.length >= 1000) {
              $scope.haveMoreSearchDataDyn[obj.quadId] = true;
            } else {
              $scope.haveMoreSearchDataDyn[obj.quadId] = false;
            }
            $scope.allScrollDataListDyn[obj.quadId] = [];
            $scope.scrollDataListDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].concat(data.d);
            $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
            setTimeout(function () {
              $scope.$apply();
            });
          },
          function (err) {
            $log.error(err);
          }
        );
      } else {
        DevicesSrv.getScrollListData($scope.detailListObjDyn[obj.quadId]).then(
          function (data) {
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            if($scope.allScrollDataListDyn.s.length){
              angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                angular.forEach(data.d, function(dObj){
                  if(obj.id == dObj.id){
                    dObj.disabled = true;
                  }
                });
              });
            }
            if (data.d.length >= 1000) {
              $scope.haveMoreDataDyn[obj.quadId] = true;
            } else if (data.d.length && data.d.length < 1000) {
              $scope.haveMoreDataDyn[obj.quadId] = false;
            }
            $scope.allScrollDataListDyn[obj.quadId] = [];
            $scope.scrollDataListDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].concat(data.d);
            $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
            setTimeout(function () {
              $scope.$apply();
            });
          },
          function (err) {
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDynDataDyn', function (e, obj){
      $scope.stIndexDyn[obj.quadId] = 0;
      $scope.etIndexDyn[obj.quadId] = 300;
      $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
      $scope.scrollDataListDyn[obj.quadId] = [];
      $scope.loadingPaging[obj.quadId] = true;
      if (obj.text) {
        $scope.detailListObjDyn[obj.quadId] = { caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset: 0, searchQ: obj.text, id:0, sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
      } else {
        $scope.detailListObjDyn[obj.quadId] = { caller: $scope.copyScrollObjDyn[obj.quadId].caller, offset: 0, id:0, sortType: $scope.copyScrollObjDyn[obj.quadId].sortType, sortVal: $scope.copyScrollObjDyn[obj.quadId].sortVal};
      }
      if (obj.text) {
        $scope.searchScrollDyn[obj.quadId] = true;
        $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
        DevicesSrv.getSearchScrollData($scope.detailListObjDyn[obj.quadId]).then(
          function (data) {
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            if($scope.allScrollDataListDyn.s.length){
              angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                angular.forEach(data.d, function(dObj){
                  if(obj.id == dObj.id){
                    dObj.disabled = true;
                  }
                });
              });
            }
            if (data.d.length && data.d.length >= 1000) {
              $scope.haveMoreSearchDataDyn[obj.quadId] = true;
            } else {
              $scope.haveMoreSearchDataDyn[obj.quadId] = false;
            }
            $scope.scrollDataListDyn[obj.quadId] = data.d;
            $scope.visibleObjectsDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].slice($scope.stIndexDyn[obj.quadId], $scope.stIndexDyn[obj.quadId] + $scope.etIndexDyn[obj.quadId]);
            setTimeout(function () {
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[obj.quadId], st: $scope.stIndexDyn[obj.quadId], et: $scope.etIndexDyn[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataListDyn[obj.quadId] = [];
              $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);

              $scope.loadingPaging[obj.quadId] = false;
              $scope.disabledAddBtn = false;
              $scope.$apply();
            }, 100);
          },
          function (err) {
            $scope.loadingPaging[obj.quadId] = false;
            $scope.disabledAddBtn = false;
            $log.error(err);
          }
        );
      } else {
        $scope.haveMoreSearchDataDyn[obj.quadId] = false;
        $scope.searchScrollDyn[obj.quadId] = false;
        $scope.copyScrollObjDyn[obj.quadId] = angular.copy($scope.detailListObjDyn[obj.quadId]);
        DevicesSrv.getScrollListData($scope.detailListObjDyn[obj.quadId]).then(
          function (data) {
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            if($scope.allScrollDataListDyn.s.length){
              angular.forEach($scope.allScrollDataListDyn.s, function(obj){
                angular.forEach(data.d, function(dObj){
                  if(obj.id == dObj.id){
                    dObj.disabled = true;
                  }
                });
              });
            }
            if (data.d.length >= 1000) {
              $scope.haveMoreDataDyn[obj.quadId] = true;
            } else {
              $scope.haveMoreDataDyn[obj.quadId] = false;
            }
            $scope.scrollDataListDyn[obj.quadId] = data.d;
            $scope.visibleObjectsDyn[obj.quadId] = $scope.scrollDataListDyn[obj.quadId].slice($scope.stIndexDyn[obj.quadId], $scope.stIndexDyn[obj.quadId] + $scope.etIndexDyn[obj.quadId]);
            setTimeout(function () {
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[obj.quadId], st: $scope.stIndexDyn[obj.quadId], et: $scope.etIndexDyn[obj.quadId], quadId: obj.quadId });
              $scope.allScrollDataListDyn[obj.quadId] = [];
              $scope.allScrollDataListDyn[obj.quadId] = angular.copy($scope.scrollDataListDyn[obj.quadId]);
  
              $scope.loadingPaging[obj.quadId] = false;
              $scope.disabledAddBtn = false;
              $scope.$apply();
            }, 100);
          },
          function (err) {
            $scope.loadingPaging[obj.quadId] = false;
            $scope.disabledAddBtn = false;
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleDataDyn come from the directive
    $scope.$on('visibleDataDyn', function (e, obj){
      $scope.stIndexDyn[obj.quadId] = obj.st;
      $scope.etIndexDyn[obj.quadId] = obj.et;
      $scope.visibleDataDyn[obj.quadId] = obj.vObj;
      $scope.addStatusKey($scope.visibleDataDyn[obj.quadId], $scope.minDeduct);
      setTimeout(function () {
        $scope.$apply();
      }, 0);
    });

    $scope.searchChangeDataDyn = function (val, quadId){
      var text = val.toLowerCase();
      $scope.deSelAllDeviceFx(quadId, $scope.allScrollDataListDyn[quadId]);
      angular.forEach($scope.allScrollDataListDyn[quadId], function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.visibleDataDyn[quadId], function(dObj){
        dObj.selected = false;
      });
      angular.forEach($scope.scrollDataListDyn[quadId], function(dObj){
        dObj.selected = false;
      });
      var scrollElement = document.querySelector("#scroll-container-" + quadId);
      if (!text && $scope.searchScrollDyn[quadId] && quadId == "a") {
        // TODO Enter when have newVal is empty and user perform search operation already
        $scope.disabledAddBtn = true;
        if (scrollElement != null) {
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndexDyn[quadId] = 0;
        $scope.etIndexDyn[quadId] = 300;
        $scope.visibleObjectsDyn[quadId] = $scope.allScrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
        $rootScope.$broadcast('searchScrollDynDataDyn', { text: '', st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
      } else if (text && text.length >= 3 && quadId == "a") {
        // TODO Enter when have newVal has 3 or grater than 3 character
        $scope.disabledAddBtn = true;
        if (scrollElement != null) {
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreDataDyn[quadId]) {
          var obj1 = $filter('filter')($scope.allScrollDataListDyn[quadId], function (item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataListDyn[quadId], function (item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj, function (item) {
            if (keys.indexOf(item.h) === -1) {
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if (filteredObj.length && filteredObj.length >= 1000) {
            $scope.haveMoreSearchDataDyn[quadId] = true;
          } else {
            $scope.haveMoreSearchDataDyn[quadId] = false;
          }
          $scope.scrollDataListDyn[quadId] = filteredObj;
          $scope.stIndexDyn[quadId] = 0;
          $scope.etIndexDyn[quadId] = 300;
          if ($scope.scrollDataListDyn[quadId].length <= 300) {
            $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId];
          } else {
            $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
          }
          $scope.searchScrollDyn[quadId] = true;
          setTimeout(function(){
            $scope.disabledAddBtn = false;
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
          }, 100)
        } else {
          $scope.stIndexDyn[quadId] = 0;
          $scope.etIndexDyn[quadId] = 300;
          $rootScope.$broadcast('searchScrollDynDataDyn', { text: text, st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
        }
      } else if (text && text.length >= 3 && quadId == "s") {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if (scrollElement != null) {
          scrollElement.scrollTo(0, 0);
        }
        var obj1 = $filter('filter')($scope.allScrollDataListDyn.s, function (item) {
          return item.l && item.l.toLowerCase().includes(text);
        });
        var obj2 = $filter('filter')($scope.allScrollDataListDyn.s, function (item) {
          return item.h && item.h.toLowerCase().includes(text);
        });

        var concatObj = obj1.concat(obj2);
        var filteredObj = [], keys = [];
        angular.forEach(concatObj, function (item) {
          if (keys.indexOf(item.h) === -1) {
            keys.push(item.h);
            filteredObj.push(item);
          }
        })
        if (filteredObj.length && filteredObj.length >= 1000) {
          $scope.haveMoreSearchDataDyn.s = true;
        } else {
          $scope.haveMoreSearchDataDyn.s = false;
        }
        $scope.scrollDataListDyn.s = filteredObj;
        $scope.stIndexDyn.s = 0;
        $scope.etIndexDyn.s = 300;
        if ($scope.scrollDataListDyn.s.length <= 300) {
          $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s;
        } else {
          $scope.visibleObjectsDyn.s = $scope.scrollDataListDyn.s.slice($scope.stIndexDyn.s, $scope.stIndexDyn.s + $scope.etIndexDyn.s);
        }
        $scope.searchScrollDyn.s = true;
        setTimeout(function(){
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn.s, st: $scope.stIndexDyn.s, et: $scope.etIndexDyn.s, quadId: quadId });
        }, 100)
      } else if(!text && quadId == "s"){
        $scope.haveMoreSearchDataDyn.s = false;
        $scope.searchScrollDyn.s = false;
        if (scrollElement != null) {
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndexDyn[quadId] = 0;
        $scope.etIndexDyn[quadId] = 300;
        // $scope.visibleObjectsDyn[quadId] = $scope.allScrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
        // $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
        $scope.scrollDataListDyn[quadId] = [];
        $scope.scrollDataListDyn[quadId] = $scope.allScrollDataListDyn[quadId];
        $scope.visibleObjectsDyn[quadId] = $scope.scrollDataListDyn[quadId].slice($scope.stIndexDyn[quadId], $scope.stIndexDyn[quadId] + $scope.etIndexDyn[quadId]);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjectsDyn[quadId], st: $scope.stIndexDyn[quadId], et: $scope.etIndexDyn[quadId], quadId: quadId });
        $scope.allScrollDataListDyn[quadId] = [];
        $scope.allScrollDataListDyn[quadId] = angular.copy($scope.scrollDataListDyn[quadId]);
      }
    }

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('allScrollDataListDyn.s', function(newVal, oldVal) {
      var obj = {copyScrollObjDyn: $scope.copyScrollObjDyn, visibleObjectsDyn: $scope.visibleObjectsDyn, haveMoreSearchDataDyn: $scope.haveMoreSearchDataDyn, visibleDataDyn: $scope.visibleDataDyn, stIndexDyn: $scope.stIndexDyn, etIndexDyn: $scope.etIndexDyn, searchScrollDyn: $scope.searchScrollDyn, detailListObjDyn: $scope.detailListObjDyn, haveMoreDataDyn: $scope.haveMoreDataDyn, scrollDataListDyn: $scope.scrollDataListDyn, allScrollDataListDyn: $scope.allScrollDataListDyn, curDevicesDyn: $scope.curDevicesDyn, searchTextDyn: $scope.searchTextDyn, avlSort:$scope.avlSort, selSort:$scope.selSort}
      $rootScope.$broadcast('curSelDevice', { caller:$scope.pageTab, selDevice: $scope.allScrollDataListDyn.s, obj: obj});
    }, true); // 'true' for deep watch

    // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };

    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';
  angular
    .module('hub')
    .controller('AdvSearchDirController', AdvSearchDirController);

  /** @ngInject */
  function AdvSearchDirController($log, $scope, $rootScope, $cookies, IndexedDB, CommonSrv){
    $scope.removeAdvSearchFilterFx = function(caller, id, step){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      if(caller == "cr"){
        $scope.advSearchInfo.creationRange = false;
      } else if(caller == "sr"){
        $scope.advSearchInfo.scheduleRange = false;
      } else if(caller == "cb"){
        $scope.advSearchInfo.createdBy = null
      } else if(caller == "sn"){
        $scope.advSearchInfo.sName = null;
      } else if(caller == "os"){
        $scope.advSearchInfo.os = null;
      } else if(caller == "client"){
        $scope.advSearchInfo.client = null;
      } else if(caller == "ti"){
        angular.forEach($scope.advSearchInfo.tag.include, function(item){
          if(item.id == id){
            $scope.advSearchInfo.tag.include.splice($scope.advSearchInfo.tag.include.indexOf(item), 1);
          }
        });
      } else if(caller == "te"){
        angular.forEach($scope.advSearchInfo.tag.exclude, function(item){
          if(item.id == id){
            $scope.advSearchInfo.tag.exclude.splice($scope.advSearchInfo.tag.exclude.indexOf(item), 1);
          }
        });
      } else if(caller == "cn"){
        $scope.advSearchInfo.name = null;
      } else if(caller == "ct"){
        $scope.advSearchInfo.type = null;
      } else if(caller == "dn"){
        $scope.advSearchInfo.dName = null;

        if($rootScope.importXls.file){
          $rootScope.importXls = {file:""};
        }
      } else if(caller == "dt"){
        $scope.advSearchInfo.dType = null;
      } else if(caller == "ot"){
        $scope.advSearchInfo.oType = null;
      } else if(caller == "serial"){
        $scope.advSearchInfo.serial = null;
      } else if(caller == "searchId"){
        $scope.advSearchInfo.searchId = null;
      } else if(caller == "ugi"){
        angular.forEach($scope.advSearchInfo.userGroup.include, function(item){
          if(item.id == id){
            $scope.advSearchInfo.userGroup.include.splice($scope.advSearchInfo.userGroup.include.indexOf(item), 1);
          }
        });
      } else if(caller == "uge"){
        angular.forEach($scope.advSearchInfo.userGroup.exclude, function(item){
          if(item.id == id){
            $scope.advSearchInfo.userGroup.exclude.splice($scope.advSearchInfo.userGroup.exclude.indexOf(item), 1);
          }
        });
      } else if(caller == "pv"){
        $scope.advSearchInfo.prop = null;
      } else if(caller == "fil"){
        $scope.advSearchInfo.fil = "";
        localStorage.setItem("filterType", JSON.stringify($scope.advSearchInfo.fil));
      }

      if($scope.advSearchInfo.module == "cl"){
        $scope.advSearchInfoCl = {creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, name:$scope.advSearchInfo.name, type:$scope.advSearchInfo.type, step:$scope.advSearchInfo.step};
        if($scope.advSearchInfoCl.creationRange == false && $scope.advSearchInfoCl.createdBy == null && $scope.advSearchInfoCl.name == null && ($scope.advSearchInfoCl.type == null || $scope.advSearchInfoCl.type == '')){
          //reset content library adv search state (all search clear)
          localStorage.removeItem("curfilterObj");
          localStorage.removeItem("isAdvSearch");
          localStorage.removeItem("isWidgetEdited");
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.removeItem("isActionOnContent");

          setTimeout(function(){
            $scope.advSearchfilteredData = {info:$scope.advSearchInfo, content:[], folder:[], code:8118};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          }, 1000);
        } else{
          if(!angular.isUndefined($scope.advSearchInfo.opt)){
            $scope.advSearchInfoCl.ls = $scope.advSearchInfo.opt;
          }
          localStorage.removeItem("curfilterObj");
          localStorage.removeItem("curAdvSearchCopy");
          localStorage.setItem("curFilterObj", JSON.stringify($scope.advSearchInfoCl));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));
          CommonSrv.updateAdvSearchCL($scope.advSearchInfoCl).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, content:data.content, folder:data.folder, groups:data.groups, code:data.code, advObj:$scope.advSearchInfoCl};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.advSearchInfo.module == "sm"){
        $scope.advSearchInfoSM = {module:$scope.advSearchInfo.module, sName:$scope.advSearchInfo.name, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, scheduleRange:$scope.advSearchInfo.scheduleRange, scheduleDateRange:$scope.advSearchInfo.scheduleDateRange, createdBy:$scope.advSearchInfo.createdBy, step:$scope.advSearchInfo.step};

        if($scope.advSearchInfoSM.creationRange == false && $scope.advSearchInfoSM.scheduleRange == false && $scope.advSearchInfoSM.createdBy == null && $scope.advSearchInfoSM.sName == null){
          //reset content library adv search state (all search clear)
          localStorage.removeItem("curFilterSMObj");
          localStorage.removeItem("isSMAdvSearch");
          localStorage.removeItem("isActionOnSchedule");
          $scope.advSearchfilteredData = {info:$scope.advSearchInfo, schedules:{g:[], s:[]}, code:8118};
          $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        } else{
          localStorage.removeItem("curFilterSMObj");
          localStorage.removeItem("curAdvSearchCopy");
          localStorage.setItem("curFilterSMObj", JSON.stringify($scope.advSearchInfoSM));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));

          // TODO
          CommonSrv.updateAdvSearchS($scope.advSearchInfoSM).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isem;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, schedules:{i:data.i, g:data.g, s:data.s}, code:data.code, advObj:$scope.advSearchInfoSM};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.advSearchInfo.module == "t"){
        $scope.advSearchInfoTm = {creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, name:$scope.advSearchInfo.name, type:$scope.advSearchInfo.type, step:$scope.advSearchInfo.step};

        if(angular.isUndefined($scope.advSearchInfoTm.fil) || $scope.advSearchInfoTm.fil == "all"){
          $scope.advSearchInfoTm.fil = "";
        }
        if($scope.advSearchInfoTm.creationRange == false && ($scope.advSearchInfoTm.createdBy == null || $scope.advSearchInfoTm.createdBy == "" || angular.isUndefined($scope.advSearchInfoTm.createdBy)) && ($scope.advSearchInfoTm.name == null || $scope.advSearchInfoTm.name == "" || angular.isUndefined($scope.advSearchInfoTm.name)) && ($scope.advSearchInfoTm.type == null || $scope.advSearchInfoTm.type == "" || angular.isUndefined($scope.advSearchInfoTm.type))){
          //reset content library adv search state (all search clear)
          localStorage.removeItem("curFilterTmObj");
          localStorage.removeItem("isTmAdvSearch");
          //action like del, add to sch, replace, archive, and approve/unapprove
          localStorage.removeItem("isActionOnTemplate");

          $scope.advSearchfilteredData = {info:$scope.advSearchInfo, template:[], folder:[], code:8118};
          $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        } else{
          localStorage.removeItem("curFilterTmObj");
          localStorage.removeItem("curAdvSearchCopy");
          localStorage.setItem("curFilterTmObj", JSON.stringify($scope.advSearchInfoTm));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));

          CommonSrv.updateAdvSearchTM($scope.advSearchInfoTm).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, template:data.template, folder:data.folder, code:data.code, advObj:$scope.advSearchInfoTm};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.advSearchInfo.module == "d"){
        $scope.advSearchInfoD = {module:$scope.advSearchInfo.module, dName:$scope.advSearchInfo.dName, sName:$scope.advSearchInfo.sName, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, scheduleRange:$scope.advSearchInfo.scheduleRange, scheduleDateRange:$scope.advSearchInfo.scheduleDateRange, createdBy:$scope.advSearchInfo.createdBy, os:$scope.advSearchInfo.os, client:$scope.advSearchInfo.client, step:$scope.advSearchInfo.step, tag:$scope.advSearchInfo.tag, prop:$scope.advSearchInfo.prop, userGroup:$scope.advSearchInfo.userGroup, fil:$scope.advSearchInfo.fil};

        if($rootScope.importXls.file){
          $scope.advSearchInfoD.dName = $rootScope.importXls.file;
          $scope.advSearchInfoD.excelData = $rootScope.importXls;
        }
        if(angular.isUndefined($scope.advSearchInfoD.fil) || $scope.advSearchInfoD.fil == "all"){
          $scope.advSearchInfoD.fil = "";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.advSearchInfoD.fil));

        if($scope.advSearchInfoD.dName == null && $scope.advSearchInfoD.creationRange == false && $scope.advSearchInfoD.scheduleRange == false && $scope.advSearchInfoD.createdBy == null && $scope.advSearchInfoD.sName == null && $scope.advSearchInfoD.os == null && ($scope.advSearchInfoD.prop == null || ($scope.advSearchInfoD.prop && !$scope.advSearchInfoD.prop.value)) && $scope.advSearchInfoD.client == null && !$scope.advSearchInfoD.tag.include.length && !$scope.advSearchInfoD.tag.exclude.length && !$scope.advSearchInfoD.userGroup.include.length && !$scope.advSearchInfoD.userGroup.exclude.length && !$scope.advSearchInfoD.fil){
           //reset content library adv search state (all search clear)
           localStorage.removeItem("curFilterDlObj");
           localStorage.removeItem("isDlAdvSearch");
           localStorage.removeItem("isActionOnDevice");
           localStorage.removeItem("curDFId");
          $scope.advSearchfilteredData = {info:$scope.advSearchInfo, devices:[], code:8118};
          $scope.advSearchfilteredData.info.isRemove = true;
          $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        } else{
          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
            var curDType = angular.fromJson(localStorage.getItem("curDType"));
            if(curDType){
              $scope.advSearchInfoD.gtype = curDType.type;
            }
          }
          localStorage.removeItem("curFilterDlObj");
          localStorage.removeItem("curAdvSearchCopy");
          localStorage.setItem("curFilterDlObj", JSON.stringify($scope.advSearchInfoD));
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));

          // if($scope.auth.upermissions.dp){
          //   var filterType = angular.fromJson(localStorage.getItem("filterType"));
            // $scope.advSearchInfoD.offset = $rootScope.offset?$rootScope.offset:0;
            $scope.advSearchInfoD.offset = 0;
          //   if(filterType){
          //     $scope.advSearchInfoD.fil = filterType;
          //   } else{
          //     $scope.advSearchInfoD.fil = "all";
          //   }
          // }
          if($scope.advSearchInfo.opt == 'videowall'){
            $scope.advSearchInfoD.vdw = true;
            if($scope.advSearchInfo.id){
              $scope.advSearchInfoD.vdwId = $scope.advSearchInfo.id;
            }
          }

          CommonSrv.updateAdvSearchD($scope.advSearchInfoD, $scope.auth, $rootScope.search.text).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:data.code , devices:data.devices, advObj:$scope.advSearchInfoD, t:data.t, deviceInfo:data.info};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds, count:data.info.count};
              }
              if($scope.auth.upermissions.dp){
                $scope.advSearchfilteredData.info.count = data.info.count;
              }
              $scope.advSearchfilteredData.info.rdc = data.info.rdc;
              $scope.advSearchfilteredData.info.isRemove = true;
              $rootScope.clearSearch = false;
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }

      } else if($scope.advSearchInfo.module == "s"){
        // $scope.advSearchInfoS = {module:$scope.advSearchInfo.module, dName:$scope.advSearchInfo.dName, step:$scope.advSearchInfo.step, tag:$scope.advSearchInfo.tag};
        $scope.advSearchInfoS = {module:$scope.advSearchInfo.module, dName:$scope.advSearchInfo.dName, sName:$scope.advSearchInfo.sName, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, scheduleRange:$scope.advSearchInfo.scheduleRange, scheduleDateRange:$scope.advSearchInfo.scheduleDateRange, createdBy:$scope.advSearchInfo.createdBy, os:$scope.advSearchInfo.os, client:$scope.advSearchInfo.client, step:$scope.advSearchInfo.step, tag:$scope.advSearchInfo.tag, prop:$scope.advSearchInfo.prop, userGroup:$scope.advSearchInfo.userGroup,fil:$scope.advSearchInfo.fil};

        if($rootScope.importXls.file){
          $scope.advSearchInfoS.dName = $rootScope.importXls.file;
          $scope.advSearchInfoS.excelData = $rootScope.importXls;
        }
        if(angular.isUndefined($scope.advSearchInfoS.fil) || $scope.advSearchInfoS.fil == "all"){
          $scope.advSearchInfoS.fil = "";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.advSearchInfoS.fil));

        if($scope.advSearchInfoS.dName == null && $scope.advSearchInfoS.creationRange == false && $scope.advSearchInfoS.scheduleRange == false && $scope.advSearchInfoS.createdBy == null && $scope.advSearchInfoS.sName == null && $scope.advSearchInfoS.os == null && ($scope.advSearchInfoS.prop == null || ($scope.advSearchInfoS.prop && !$scope.advSearchInfoS.prop.value)) && $scope.advSearchInfoS.client == null && !$scope.advSearchInfoS.tag.include.length && !$scope.advSearchInfoS.tag.exclude.length && !$scope.advSearchInfoS.userGroup.include.length && !$scope.advSearchInfoS.userGroup.exclude.length && !$scope.advSearchInfoS.fil){
          $scope.advSearchfilteredData = {info:$scope.advSearchInfo, devices:[], code:8118};
          $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        } else{
          $scope.advSearchInfoS.offset = 0;
          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
            var curDTypeS = angular.fromJson(localStorage.getItem("curDTypeS"));
            if(curDTypeS){
              $scope.advSearchInfoS.gtype = curDTypeS.type;
            }
          }
          //filter adv search with schedule type
          if(!angular.isUndefined($scope.advSearchInfo.ls)){
            $scope.advSearchInfoS.ls = $scope.advSearchInfo.ls;
          }
          localStorage.setItem("curFilterDlObj", JSON.stringify($scope.advSearchInfoS));
          localStorage.setItem("curAdvSearchCopyS", JSON.stringify($scope.advSearchInfoS));
          // var filterType = angular.fromJson(localStorage.getItem("filterType"));
          // if(filterType){
          //   $scope.advSearchInfo.fil = filterType;
          // } else{
          //   $scope.advSearchInfo.fil = "all";
          // }

          IndexedDB.getItem("scuData", 0).then(function(item){
            if(item){
              $scope.advSearchInfoS.csdr = {s:item.schedule.dateRange.startDate, e:item.schedule.dateRange.endDate};
              // TODO
              CommonSrv.updateAdvSearchD($scope.advSearchInfoS, $scope.auth, $rootScope.search.text).then(
                function(data){
                  $scope.advSearchInfo.isEmpty = data.isEmpty;
                  $scope.advSearchfilteredData = {info:$scope.advSearchInfo, devices:data.devices, code:data.code, advObj:$scope.advSearchInfoS};
                  if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                    $scope.advSearchfilteredData.dInfo = data.info;
                  } else{
                    $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds, count:data.info.count};
                  }
                  $scope.advSearchfilteredData.info.rdc = data.info.rdc;
                  $scope.advSearchfilteredData.info.isRemove = true;
                  $rootScope.clearSearch = false;
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          }).catch(function(error){
            console.error(error);
          });


        }
      } else if($scope.advSearchInfo.module == "r"){
         $scope.advSearchInfoR = {module:$scope.advSearchInfo.module, dName:$scope.advSearchInfo.dName, sName:$scope.advSearchInfo.sName, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, scheduleRange:$scope.advSearchInfo.scheduleRange, scheduleDateRange:$scope.advSearchInfo.scheduleDateRange, createdBy:$scope.advSearchInfo.createdBy, os:$scope.advSearchInfo.os, client:$scope.advSearchInfo.client, step:$scope.advSearchInfo.step, tag:$scope.advSearchInfo.tag, prop:$scope.advSearchInfo.prop, userGroup:$scope.advSearchInfo.userGroup,fil:$scope.advSearchInfo.fil};

         if($rootScope.importXls.file){
          $scope.advSearchInfoR.dName = $rootScope.importXls.file;
          $scope.advSearchInfoR.excelData = $rootScope.importXls;
        }
        if(angular.isUndefined($scope.advSearchInfoR.fil) || $scope.advSearchInfoR.fil == "all"){
          $scope.advSearchInfoR.fil = "";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.advSearchInfoR.fil));
         if($scope.advSearchInfoR.dName == null && $scope.advSearchInfoR.creationRange == false && $scope.advSearchInfoR.scheduleRange == false && $scope.advSearchInfoR.createdBy == null && $scope.advSearchInfoR.sName == null && $scope.advSearchInfoR.os == null && $scope.advSearchInfoR.client == null && ($scope.advSearchInfoR.prop == null || ($scope.advSearchInfoR.prop && !$scope.advSearchInfoR.prop.value)) && !$scope.advSearchInfoR.tag.include.length && !$scope.advSearchInfoR.tag.exclude.length && !$scope.advSearchInfoR.userGroup.include.length && !$scope.advSearchInfoR.userGroup.exclude.length && !$scope.advSearchInfoR.fil){
           $scope.advSearchfilteredData = {info:$scope.advSearchInfoR, devices:[], code:8118};
           $scope.advSearchfilteredData.info.isRemove = true;
           $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
         } else{
           $scope.advSearchInfoR.offset = 0;
          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
            var curDType = angular.fromJson(localStorage.getItem("curDType"));
            if(curDType){
              $scope.advSearchInfoR.gtype = curDType.type;
            }
          }
          // var filterType = angular.fromJson(localStorage.getItem("filterType"));
          // if(filterType){
          //   $scope.advSearchInfoR.fil = filterType;
          // } else{
          //   $scope.advSearchInfoR.fil = "all";
          // }

          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfoR));
          if(angular.isUndefined($rootScope.commonSearchVar)){
            $rootScope.commonSearchVar = "";
          }
          CommonSrv.updateAdvSearch($scope.advSearchInfoR, $scope.auth, $rootScope.commonSearchVar).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:data.code, devices:data.devices, advObj:$scope.advSearchInfoR};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              }
              $scope.advSearchfilteredData.info.rdc = data.info.rdc;
              $scope.advSearchfilteredData.info.isRemove = true;
              $rootScope.clearSearch = false;
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.advSearchInfo.module == "fla" || $scope.advSearchInfo.module == "dg" || $scope.advSearchInfo.module == "dt"){
        $scope.advSearchInfoFla = {module:$scope.advSearchInfo.module, id:$scope.advSearchInfo.id, dName:$scope.advSearchInfo.dName, sName:$scope.advSearchInfo.sName, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, scheduleRange:$scope.advSearchInfo.scheduleRange, scheduleDateRange:$scope.advSearchInfo.scheduleDateRange, createdBy:$scope.advSearchInfo.createdBy, os:$scope.advSearchInfo.os, client:$scope.advSearchInfo.client, step:$scope.advSearchInfo.step, tag:$scope.advSearchInfo.tag, prop:$scope.advSearchInfo.prop, userGroup:$scope.advSearchInfo.userGroup,fil:$scope.advSearchInfo.fil};

        if($rootScope.importXls.file){
          $scope.advSearchInfoFla.dName = $rootScope.importXls.file;
          $scope.advSearchInfoFla.excelData = $rootScope.importXls;
        }

        if(angular.isUndefined($scope.advSearchInfoFla.fil) || $scope.advSearchInfoFla.fil == "all"){
          $scope.advSearchInfoFla.fil = "";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.advSearchInfoFla.fil));

        if($scope.advSearchInfoFla.dName == null && $scope.advSearchInfoFla.creationRange == false && $scope.advSearchInfoFla.scheduleRange == false && $scope.advSearchInfoFla.createdBy == null && $scope.advSearchInfoFla.sName == null && $scope.advSearchInfoFla.os == null && ($scope.advSearchInfoFla.prop == null || ($scope.advSearchInfoFla.prop && !$scope.advSearchInfoFla.prop.value)) && $scope.advSearchInfoFla.client == null && !$scope.advSearchInfoFla.tag.include.length && !$scope.advSearchInfoFla.tag.exclude.length && !$scope.advSearchInfoFla.userGroup.include.length && !$scope.advSearchInfoFla.userGroup.exclude.length && !$scope.advSearchInfoFla.fil){
          $scope.advSearchfilteredData = {info:$scope.advSearchInfo, devices:[], code:8118};
          $scope.advSearchfilteredData.info.isRemove = true;
          $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        } else{
          // var filterType = angular.fromJson(localStorage.getItem("filterType"));
          // if(filterType){
          //   $scope.advSearchInfoFla.fil = filterType;
          // } else{
          //   $scope.advSearchInfoFla.fil = "all";
          // }
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfoFla));
          if(angular.isUndefined($rootScope.commonSearchVar)){
            $rootScope.commonSearchVar = "";
          }
          CommonSrv.updateAdvSearch($scope.advSearchInfoFla, $scope.auth, $rootScope.commonSearchVar).then(
            function(data){
              $scope.advSearchInfo.isEmpty = data.isEmpty;
              $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:data.code, devices:data.devices, advObj:$scope.advSearchInfoFla};
              if($scope.auth.upermissions.gbdt){
                $scope.advSearchfilteredData.dInfo = data.info;
              }
              $scope.advSearchfilteredData.info.rdc = data.info.rdc;
              $scope.advSearchfilteredData.info.isRemove = true;
              $rootScope.clearSearch = false;
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.advSearchInfo.module == "inv"){
        if($scope.advSearchInfo.step == "d"){
          $scope.advSearchInfoInv = {status:$scope.advSearchInfo.status, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, dName:$scope.advSearchInfo.dName, dType:$scope.advSearchInfo.dType,searchId:$scope.advSearchInfo.searchId, invType:$scope.advSearchInfo.step,id:0};
          if($scope.auth.upermissions.dp){
            $scope.advSearchInfoInv.offset = 0;
          }
          if($scope.advSearchInfoInv.creationRange == false && $scope.advSearchInfoInv.createdBy == null &&  $scope.advSearchInfoInv.dName == null && $scope.advSearchInfoInv.searchId == null && $scope.advSearchInfoInv.dType == null){
            //reset content library adv search state (all search clear)
            localStorage.removeItem("curFilterInvObj");
            localStorage.removeItem("isInvAdvSearch");
            //action like del, add to sch, replace, archive, and approve/unapprove
            localStorage.removeItem("isActionOnInventory");

            $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:8118};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          } else{
            if($scope.advSearchInfoInv.createdBy == undefined || $scope.advSearchInfoInv.createdBy == null){
              $scope.advSearchInfoInv.createdBy = "";
            } else {
              $scope.advSearchInfoInv.createdBy = $scope.advSearchInfoInv.createdBy.id;
            }
            if($scope.advSearchInfoInv.creationRange == false){
              $scope.advSearchInfoInv.creationDateRange = {};
            }
            if($scope.advSearchInfoInv.dType == null || $scope.advSearchInfoInv.dType == undefined){
              $scope.advSearchInfoInv.dType = "";
            }
            if($scope.advSearchInfoInv.dName == null || $scope.advSearchInfoInv.dName == undefined){
              $scope.advSearchInfoInv.dName = "";
            }
            if($scope.advSearchInfoInv.searchId == null || $scope.advSearchInfoInv.searchId == undefined){
              $scope.advSearchInfoInv.searchId = "";
            }
            localStorage.removeItem("curFilterInvObj");
            localStorage.removeItem("curAdvSearchCopy");
            localStorage.setItem("curFilterInvObj", JSON.stringify($scope.advSearchInfoInv));
            localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));

            CommonSrv.updateAdvSearchInv($scope.advSearchInfoInv).then(
              function(data){
                // $scope.filteredData = data;
                $scope.advSearchInfo.isEmpty = data.isEmpty;
                $scope.advSearchfilteredData = {info:$scope.advSearchInfo, inventory:data.data, invInfo:data, code:data.code, advObj:$scope.advSearchInfoInv};
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
              }
            );
          }
        } else{
          $scope.advSearchInfoInv = {status:$scope.advSearchInfo.status, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, oType:$scope.advSearchInfo.oType,serial:$scope.advSearchInfo.serial, invType:$scope.advSearchInfo.step,id:0};
          if($scope.auth.upermissions.dp){
            $scope.advSearchInfoInv.offset = 0;
          }

          if($scope.advSearchInfoInv.creationRange == false && $scope.advSearchInfoInv.createdBy == null &&  $scope.advSearchInfoInv.serial == null && $scope.advSearchInfoInv.oType == null){
            //reset content library adv search state (all search clear)
            localStorage.removeItem("curFilterInvObj");
            localStorage.removeItem("isInvAdvSearch");
            //action like del, add to sch, replace, archive, and approve/unapprove
            localStorage.removeItem("isActionOnInventory");

            $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:8118};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          } else{
            if($scope.advSearchInfoInv.createdBy == null || $scope.advSearchInfoInv.createdBy == undefined){
              $scope.advSearchInfoInv.createdBy = "";
            } else{
              $scope.advSearchInfoInv.createdBy = $scope.advSearchInfoInv.createdBy.id;;
            }
            if($scope.advSearchInfoInv.creationRange == false){
              $scope.advSearchInfoInv.creationDateRange = {};
            }
            if($scope.advSearchInfoInv.oType == null || $scope.advSearchInfoInv.oType == undefined){
              $scope.advSearchInfoInv.oType = "";
            } else{
              $scope.advSearchInfoInv.oType = $scope.advSearchInfoInv.oType.id;
            }
            if($scope.advSearchInfoInv.name == null || $scope.advSearchInfoInv.name == undefined){
              $scope.advSearchInfoInv.name = "";
            }
            if($scope.advSearchInfoInv.serial == null || $scope.advSearchInfoInv.serial == undefined){
              $scope.advSearchInfoInv.serial = "";
            }
            localStorage.removeItem("curFilterInvObj");
            localStorage.removeItem("curAdvSearchCopy");
            localStorage.setItem("curFilterInvObj", JSON.stringify($scope.advSearchInfoInv));
            localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));

            CommonSrv.updateAdvSearchInv($scope.advSearchInfoInv).then(
              function(data){
                $scope.advSearchInfo.isEmpty = data.isEmpty;
                $scope.advSearchfilteredData = {info:$scope.advSearchInfo, inventory:data.data, invInfo:data, code:data.code, advObj:$scope.advSearchInfoInv};
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
      } else{
        // var filterType = angular.fromJson(localStorage.getItem("filterType"));
        // if(filterType){
        //   $scope.advSearchInfo.fil = filterType;
        // } else{
        //   $scope.advSearchInfo.fil = "all";
        // }
        $scope.advSearchfilteredData = {info:$scope.advSearchInfo, devices:[], code:8118};
        $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
        if(angular.isUndefined($rootScope.commonSearchVar)){
          $rootScope.commonSearchVar = "";
        }
        CommonSrv.updateAdvSearch($scope.advSearchInfoR, $scope.auth, $rootScope.commonSearchVar).then(
          function(data){
            $scope.advSearchInfo.isEmpty = data.isEmpty;
            $scope.advSearchfilteredData = {info:$scope.advSearchInfo, code:data.code, devices:data.devices, advObj:$scope.advSearchInfoR, t:data.t};
            if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
              $scope.advSearchfilteredData.dInfo = data.info;
            }
            $scope.advSearchfilteredData.info.isRemove = true;
            $rootScope.clearSearch = false;
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
	}
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ActivePeriodController', ActivePeriodController);

  /** @ngInject */
  function ActivePeriodController($log, $rootScope, $scope, $filter, $timeout){
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.curPeriod = {};
    $rootScope.activePeriodOpen = false;

    $scope.activePeriodFx = function(caller){
      if(angular.isUndefined($scope.activePeriod)){
        $scope.activePeriod = {time:"11:59", date:{startDate:moment().format('L'), endDate:moment().format('L')}};
      } else if(!$scope.activePeriod.time && !$scope.activePeriod.date){
        $scope.activePeriod.time = "11:59";
        $scope.activePeriod.date = {startDate:moment().format('L'), endDate:moment().format('L')};
      }
      if(caller == "edit"){
        $rootScope.activePeriodOpen = true;
        $scope.editExpiry = true;
        $scope.copySetExpiry = {
          type:$scope.activePeriod.type,
          time:$filter("momentTime")($scope.activePeriod.time),
          date:{
            startDate:$filter("momentDate")($scope.activePeriod.date.startDate),
            endDate:$filter("momentDate")($scope.activePeriod.date.endDate)
          }
        };
        $scope.curPeriod = angular.copy($scope.copySetExpiry);
      } else if(caller == 'save'){
        $rootScope.activePeriodOpen = false;
        $scope.editExpiry = false;
        if($scope.curPeriod.type == "a"){
          $scope.activePeriod = {"type":"a"};
        } else{
          $scope.curSetExpiry = {
            type:angular.copy($scope.curPeriod).type,
            time:moment(angular.copy($scope.curPeriod).time).format("HH:mm Z"),
            date:{
              startDate:moment(angular.copy($scope.curPeriod).date.startDate).format("L"),
              endDate:moment(angular.copy($scope.curPeriod).date.endDate).format("L")
            }
          };
          $scope.activePeriod = $scope.curSetExpiry;
        }
      } else if(caller == 'cancel'){
        $rootScope.activePeriodOpen = false;
        $scope.editExpiry = false;
        $scope.curPeriod = angular.copy($scope.copySetExpiry);
      }
      $scope.setDate();
    }

    $scope.setDate = function() {
      $scope.curSD = moment($scope.curPeriod.date.startDate).format('MM/DD/YYYY');
      $scope.curED = moment($scope.curPeriod.date.endDate).format('MM/DD/YYYY');

      // Set the start and end dates to the scope variables
      $scope.startDate = $scope.curSD;
      $scope.endDate = $scope.curED;

      // console.warn($scope.curSetExpiry);

      // Use $timeout to delay the initialization of daterangepicker
      $timeout(function() {
        // Initialize the Date Range Picker with current start and end dates
        $("input[name='datetimes']").daterangepicker({
          startDate: $scope.curSD,
          endDate: $scope.curED,
        }, function(start, end, label) {
          // Update the scope variables with selected dates
          $scope.$apply(function() {
            // $scope.startDate = start.format("MM/DD/YYYY");
            // $scope.endDate = end.format("MM/DD/YYYY");

            // Update the date range in the schedule object
            $scope.curPeriod.date = {
                startDate: start,
                endDate: end
            };
          });
        });
      });
    }
  }
})();
angular.module('hub').service('TemplatesSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTemplates = function(caller){
    var isScene = 0;
    if(caller == "ts"){
      isScene = 1;
    }
    httpReq = $http.get($rootScope.apiHost + "templates/?isScene=" + isScene +"&"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTemplatesScenes = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getESLTemplates = function(fid){
    httpReq = $http.get($rootScope.apiHost + "templates/"+fid+"?" + new Date().getTime() + "&tType=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUnapproved = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/unapproved?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getApproved = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/approved/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIncomplete = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/incomplete?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Library*/
  this.getLibrary = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/library?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibraryContent = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/library/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUseTemplates = function(id){
    httpReq = $http.post($rootScope.apiHost + "templates/use", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteCategory = function(id){
    httpReq = $http.delete($rootScope.apiHost + "templates/category/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Brief*/
  this.getTemplateBrief = function(tId){
    httpReq = $http.get($rootScope.apiHost + "templates/briefs/" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Price List*/
  this.getDTextList = function(templateId){
    httpReq = $http.get($rootScope.apiHost + "templates/dText/" + templateId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDTextList = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/dText", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Count list*/
  this.getScheduleList = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/scheduleList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/scheduleList/" + id +"/a");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInactiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/scheduleList/" + id +"/i");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Button*/
  this.saveTemplateBtn = function(tId){
    httpReq = $http.post($rootScope.apiHost + "action/templates", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Button Actions*/
  this.duplicateTemplates = function(tId){
    httpReq = $http.post($rootScope.apiHost + "templates/duplicate", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateApproveTemplate = function(tId){
    httpReq = $http.post($rootScope.apiHost + "templates/approve", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateUnapproveTemplate = function(tId){
    httpReq = $http.post($rootScope.apiHost + "templates/unapprove", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteTemplate = function(tId){
    httpReq = $http.delete($rootScope.apiHost + "templates/" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteFT = function(obj){
    httpReq = $http.delete($rootScope.apiHost + "templates/", {
      "params": obj
    });
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteLibrary = function(tId){
    httpReq = $http.delete($rootScope.apiHost + "templates/library/" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*****Folder*****/
  this.folderCU = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/folders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderDetails = function(fId){
    httpReq = $http.get($rootScope.apiHost + "templates/folders/details/" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTemplatesFolder = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/scheduleList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.move = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/move", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.copy = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/copy", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMoveTree = function(fId){
    if(fId === undefined){
      fId = 0;
    }
    httpReq = $http.get($rootScope.apiHost + "templates/moveTree" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getTemplateList = function(fId){
    httpReq = $http.get($rootScope.apiHost + "templates/templateList/" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getTemplatesContent = function(fId, tType){
    if(tType){
      httpReq = $http.get($rootScope.apiHost + "templates/" + fId + "?isScene=0&tType=1");
    } else{
      httpReq = $http.get($rootScope.apiHost + "templates/" + fId + "?isScene=0");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Brief*/
  this.getFolderBrief = function(fId, splId, splType){
    if(splType == "folder"){
      httpReq = $http.get($rootScope.apiHost + "templates/folders/briefs/" + fId);
    } else{
      httpReq = $http.get($rootScope.apiHost + "templates/folders/briefs/" + fId + "&splType=" + splType);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Download Sample Excel*/
  this.getDExcel = function(templateId){
    httpReq = $http.get($rootScope.apiHost + "templates/oneDrive/excel/" + templateId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('TemplateCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getTemplateDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibraryDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "templates/library/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTemplate = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveODContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/oneDrive/content", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLibrary = function(obj){
    httpReq = $http.post($rootScope.apiHost + "templates/library", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderApprovedContent = function(fId, tId){
    httpReq = $http.get($rootScope.apiHost + "templates/oneDrive/folder/" + fId + "/" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getOloStore = function(){
    httpReq = $http.get($rootScope.apiHost + "templates/oloStoreList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFeedData = function(url, isOlo){
    if(isOlo){
      // httpReq = $http.get(url +"?"+ new Date().getTime());
      httpReq = $http.get(url+"?"+new Date().getTime(),{
        // Other request configuration options go here
        headers: {
          // You can override the Authorization header with an empty value to remove it
          Authorization: undefined
        }
      });
    } else{
      // console.error("NOT A OLO")
      httpReq = $http.get($rootScope.apiHost + "feed/reverseCall?url=" + url +"?"+ new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExcelSheets = function(url){
    httpReq = $http.get(url+"?rowData=1&"+new Date().getTime(),{
      // Other request configuration options go here
      headers: {
        // You can override the Authorization header with an empty value to remove it
        Authorization: undefined
      }
    });
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // https://rc.lsquared.com/rc-lsquared-hub/t/xlsx/01QBTQK7JWTXT3QLM35FAKXXBSAAQZVGIW.xlsx
  // "https://dev2.lsquared.com/dev-lsquared-hub/t/xlsx/01KM37CHMLGDK637T7QFE2MG6CKOHGYQLS.json"

  this.getExcelXLSX = function(url){
    httpReq = $http.post($rootScope.apiHost + "common/storagecontentinfo", {url:url});
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.downloadSheet = function(id){
    httpReq = $http.get($rootScope.apiHost + "common/devices/export/sampleAutoReg?dsg=0");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }

  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module("hub").directive('videoPlayer', function($rootScope){
  return{
    // A = attribute, E = Element, C = Class and M = HTML Comment
    restrict:'A',
    scope:{seekTime:'='},
    link:function($scope, element, attrs){
      var video = document.getElementById("dynamicVideo");
      video.onseeked = function(){
        $scope.$emit('videoSeekerClick', {seekTime:(Math.round(video.currentTime * 100) / 100).toFixed(2)});
      };
      video.onplaying = function(){
        $("#playPause").removeClass("fa fa-play").addClass("fa fa-pause");
        $scope.interval = setInterval(function(){
          $scope.$emit('videoSeeking', {seekTime:(Math.floor(video.currentTime * 100) / 100).toFixed(2)});
          if((Math.floor(video.currentTime * 100) / 100).toFixed(2) == Math.floor(video.duration)){
            clearInterval($scope.interval);
          }
        }, 0);
      };
      video.onpause = function(){
        $("#playPause").removeClass("fa fa-pause").addClass("fa fa-play");
        clearInterval($scope.interval);
      };
      video.onended = function(){
        clearInterval($scope.interval);
        $("#playPause").removeClass("fa fa-pause").addClass("fa fa-play");
      }
    }
  };
});
angular.module("hub").directive('timelineSlider', function($filter, $rootScope){
  return {
    // A = attribute, E = Element, C = Class and M = HTML Comment
    restrict:'A',
    link:function($scope, element, attrs){
      $rootScope.$on('videoSeekerClick', function(event, data){
        $scope.seeker = data.seekTime;
        $(".slider").css("left", $scope.seeker * 20);
        $("#playPause").removeClass("fa fa-pause").addClass("fa fa-play");
        $(".inner-content").each(function(index, item){
          if((Number($scope.seeker) >= $(item).data('start') && Number($scope.seeker) <= $(item).data('end')) || ($(item).data('start') == 0 && $(item).data('end') == 0)){
            $(item).parent().show();
          } else{
            $(item).parent().hide();
          }
        });
      });

      $rootScope.$on('videoSeeking', function(event, data, type){
        $scope.seeker = data.seekTime;
        $(".slider").css("left", $scope.seeker * 20);
        $(".inner-content").each(function(index, item){
          if(Number($scope.seeker) < Math.floor(document.getElementById("dynamicVideo").duration)){
            if((Number($scope.seeker) >= $(item).data('start') && Number($scope.seeker) <= $(item).data('end')) || ($(item).data('start') == 0 && $(item).data('end') == 0)){
              $(item).parent().show();
            } else{
              $(item).parent().hide();
            }
          }
        });
      });

      element.draggable({
        axis:"x",
        containment:"#containment-wrapper",
        scroll:false,
        drag:function(event, ui){
          $rootScope.ruleClick = false;
          $scope.seeker = ui.position.left / 20;
          var video = document.getElementById("dynamicVideo");
          if(video != null){
            if($scope.seeker < video.duration){
              video.currentTime = $scope.seeker;
            }
          }
          $(".inner-content").each(function(index, item){
            if($scope.seeker >= $(item).data('start') && $scope.seeker <= $(item).data('end')){
              if($(item).children().children("#dynamicVideo").attr("id") == "dynamicVideo"){
                $("#playPause").parent().show();
              }
              $(item).parent().show();
            } else{
              if($(item).children().children("#dynamicVideo").attr("id") == "dynamicVideo"){
                $("#playPause").parent().hide();
              }
              $(item).parent().hide();
            }
          });
        },
        create:function(event, ui){
          $scope.seeker = 0;
          $(".inner-content").each(function(index, item){
            setTimeout(function(){
              if($scope.seeker >= $(item).data('start') && $scope.seeker <= $(item).data('end')){
                $(item).parent().show();
              } else{
                $(item).parent().hide();
              }
            }, 100);
          });

          $(".tl-ruler").click(function(e){
            $rootScope.ruleClick = true;
            var offset = this.getClientRects()[0];
            $scope.seeker = (e.clientX - offset.left) / 20;
            $(".slider").css("left", e.clientX - offset.left);
            var video = document.getElementById("dynamicVideo");
            video.pause();
            if($scope.seeker < video.duration){
              video.currentTime = $scope.seeker;
            }
            $(".inner-content").each(function(index, item){
              if($scope.seeker >= $(item).data('start') && $scope.seeker <= $(item).data('end')){
                if($(item).children().children("#dynamicVideo").attr("id") == "dynamicVideo"){
                  $("#playPause").parent().show();
                }
                $(item).parent().show();
              } else{
                if($(item).children().children("#dynamicVideo").attr("id") == "dynamicVideo"){
                  $("#playPause").parent().hide();
                }
                $(item).parent().hide();
              }
            });
          });
        }
      });

      $scope.$on('resetTimeline', function(event, data){
        //call directive function here
        $scope.seeker = data;
        $(".slider").css("left", $scope.seeker * 20);
        $(".inner-content").each(function(index, item){
          if($scope.seeker >= $(item).data('start') && $scope.seeker <= $(item).data('end')){
            $(item).parent().show();
          } else{
            $(item).parent().hide();
          }
        });
      });
    }
  };
});
angular
  .module('hub').directive('textEditor', function(){
    return {
      restrict:'A',
      controller:"TextEditorController",
      templateUrl:'app/templates/dir/textEditor.html'
    }
  });

angular
  .module('hub').directive('ngTemplateListView', function(){
    return {
      restrict:'E',
      templateUrl:'app/templates/dir/templateListView.html'
    }
  });

angular
  .module('hub').directive('ngTemplateList', function(){
    return {
      restrict:'E',
      templateUrl:'app/templates/dir/templateList.html'
    }
  });
angular
  .module('hub').directive('ngTemplateBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/templates/dir/templateBrief.html'
    }
  });
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TemplatesCUController', TemplatesCUController);

  /** @ngInject */
  function TemplatesCUController($log, $rootScope, $scope, $state, $stateParams, $timeout, $filter, $cookies, $sce, $interval, ngDialog, ContentLibrarySrv, DevicesCUSrv, TemplatesSrv, TemplateCUSrv){
    $rootScope.selectedMenu = 2;
    $rootScope.selectedT = '1';

    localStorage.removeItem("successXMLData");
    $scope.curStage = $state.current.name;
    $scope.content = {info:"", items:""};
    $scope.colorPicker = {isOpen:false, tc:false, fc:false, bgc:false};
    $scope.fId = localStorage.getItem("curTFId");
    $scope.frameBg = {isChecked:false};
    $scope.saveCloseProcessing = false;
    $scope.isTimeline = {toggle:false};
    $scope.isContentSelected = false;
    $scope.isInvalidDuration = false;
    $scope.feedTreeLoaded = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.XMLData = true;
    $scope.isDuplicate = false;
    $scope.isTLActive = false;
    $scope.frameFeedRef = "";
    $scope.isPEOpen = false;
    $scope.contentList = [];
    $scope.selectedTab = 0;
    $scope.folderList = {};
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.hasErr = false;
    $scope.isPlay = true;
    $scope.curFrameIndex;
    $scope.template = {};
    $scope.errType = "";
    $scope.encType = "";
    $scope.decType = "";
    $scope.curLayer = 0;
    $scope.frameId = 0;
    $scope.tHeight = 0;
    $scope.imgUrl = "";
    $scope.imgStr = "";
    $scope.tWidth = 0;
    $scope.encId = "";
    $scope.decId = "";
    $scope.odUrl = "";
    $scope.curZ = 1;
    $scope.curFrame;
    $scope.tim = "";
    $scope.cent = ($scope.auth.lang == 'fr_FR') ? ' 7<sup class="valign-middle" style="position:relative; top:-0.2em;">50</sup> $' :' $ 7<sup class="valign-middle" style="position:relative; top:-0.2em;">50</sup>';
    $scope.htmlTooltip = $sce.trustAsHtml($filter("translate")('t.msg.19') + $scope.cent);

    $scope.searchList = {t:""};

    $scope.curStore = {store:""};
    $scope.canvas = {};
    $scope.canvas.zoom = '0.5';
    $scope.search = {text:""};

    $scope.odLSLoading = false;
    $scope.odLS = "";

    if($state.params.id){
      $scope.decType = $scope.hubDec($state.params.type);
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encType = $state.params.type;
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.XMLData = false;

      if($scope.decType == "l"){
        TemplateCUSrv.getLibraryDetails($scope.decId).then(
          function(data){
            $scope.template = data;
            if($scope.template.info.tType != 4 && $scope.template.info.tType != 2){
              $scope.isTimeline.toggle = false;
            }
            if($scope.template.info.feedUrl == ""){
              $scope.template.info.feedOpt = false;
              $scope.template.info.refreshOpt = 'n';
            } else if($scope.template.info.feedUrl){
              $scope.template.info.feedOpt = true;
            }

            if($scope.template.info.refresh == 0 || $scope.template.info.refresh == null){
              $scope.template.info.refreshOpt = 'n'
            } else if($scope.template.info.feedUrl && $scope.template.info.refresh > 0){
              $scope.template.info.refreshOpt = 'c'
            }
            if($scope.template.permission){
              $scope.permission = $scope.template.permission;
            }
            if($scope.template.frames){
              $scope.curZ = $scope.template.frames.length + 1;
              $scope.frameId = $scope.template.frames.length;
            }
            if($scope.template.info.tType == 6 && $scope.template.info.oloFile){
              $scope.template.info.feedUrl = $scope.template.info.oloFile;
            }
            if($scope.template.info.feedUrl != "" && $scope.curStage === "hub.tContainer.tDesign"){
              $scope.feedTreeLoaded = false;
              $scope.loadFeed();
            }else{
              $scope.XMLData = true;
            }
            $scope.detailLoading = false;
            $scope.durationCountFx("all");
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        TemplateCUSrv.getTemplateDetails($scope.decId).then(
          function(data){
            $scope.template = data;

            if($scope.template.info.tType == 1){
              $scope.template.info.detail = angular.fromJson($scope.template.info.detail);
              // if($scope.template.info && $scope.template.info.eslOd){
              //   localStorage.setItem("epdDriveId", $scope.template.info.eslOd.driveId);
              // }
              $scope.getModelsFx();
            }

            if($scope.template.info.tType != 4 && $scope.template.info.tType != 2){
              $scope.isTimeline.toggle = false;
            }

            if($scope.template.info.tType == 3 && $scope.template.info.subType == 'cl'){
              $scope.curContent = $scope.template.info.excelCl ? $scope.template.info.excelCl : [];
            }

            if($scope.template && $scope.template.info){
              $scope.cBucket = $scope.cDetailBucket = $scope.template.info.bucket;
              if($scope.template.info.mbucket && $scope.template.info.mbucket != ""){
                $scope.cDetailBucket = $scope.template.info.mbucket;
              }
            }

            $rootScope.templateTType = $scope.template.info.tType;
            if($scope.template.info.tType == 4){
              angular.forEach($scope.template.frames, function(item){
                if(item.type == "content"){
                  $scope.isContentSelected = true;
                  return;
                }
              });
            }

            if($scope.template.info.feedUrl == ""){
              $scope.template.info.feedOpt = false;
              $scope.template.info.refreshOpt = 'n';
            } else if($scope.template.info.feedUrl){
              $scope.template.info.feedOpt = true;
            }

            if($scope.template.info.refresh == 0 || $scope.template.info.refresh == null){
              $scope.template.info.refreshOpt = 'n'
            } else if($scope.template.info.feedUrl && $scope.template.info.refresh > 0){
              $scope.template.info.refreshOpt = 'c'
            }
            if($scope.template.info.tType == 6 && $scope.template.info.oloFile){
              $scope.template.info.feedUrl = $scope.template.info.oloFile;
            }
            if($scope.template.info.tType == 6 && $scope.template.info.oloStoreDetail.id){
              $scope.storedOloId = angular.copy($scope.template.info.oloStoreDetail.id);
              $scope.curStore.store = $scope.template.info.oloStoreDetail
              if($scope.curStage === "hub.tContainer.tName"){
                $scope.getStoreFx("update");
              }
            }
            // if($scope.template.info.tType == 6 && $scope.template.info.oloFile != "" && $scope.curStage === "hub.tContainer.tDesign"){
            //   $scope.feedTreeLoaded = false;
            // }

            if($scope.template.permission){
              $scope.permission = $scope.template.permission;
            }
            if($scope.template.frames){
              $scope.curZ = $scope.template.frames.length + 1;
              $scope.frameId = $scope.template.frames.length;
            }
            if($scope.template.info.feedUrl != "" && $scope.curStage === "hub.tContainer.tDesign"){
              $scope.feedTreeLoaded = false;
              $scope.loadFeed();
            } else{
              $scope.XMLData = true;
            }
            $scope.detailLoading = false;

            if(($scope.template.info.tType == 2 || $scope.template.info.tType == 4) && $scope.curStage == "hub.tContainer.tDesign" && $scope.template.frames.length > 0){
              $timeout(function(){
                var video = document.getElementById('dynamicVideo');
                if(video != null){
                  if(video.readyState !== 4){
                    video.load();
                    $scope.isPlay = true;
                    }
                  video.addEventListener('play', function(){
                    $scope.isPlay = false;
                  });
                  video.addEventListener('pause', function(){
                    $scope.isPlay = true;
                  });
                }
                $scope.setContentTimeFx($scope.template);
              }, 2000);
            }
            $scope.odUrl = data.info.url;

            if(data.info.isAuthorized){
              if(data.info.tType == 3){
                if($scope.template.info.excelOd && $scope.template.info.excelOd.length != 0){
                  $scope.contentName = data.info.excelOd.path + data.info.excelOd.name;
                }
              } else if(data.info.eslOd.name){
                $scope.contentName = data.info.eslOd.path + data.info.eslOd.name;
              }
            } else{
              if($scope.template.info.excelCl && $scope.template.info.excelCl.length != 0){
                $scope.contentName = data.info.excelCl.path + data.info.excelCl.name;
              }
            }

            if($scope.template.info.file && Object.keys($scope.template.info.file).length > 0){
              if($scope.template.info.tType!=1){
                $scope.getExcelJsonFx($scope.template.info.file.bucket, $scope.template.info.file.json);
              }
              if($scope.template.info.file.xlsx){
                $scope.getExcelXLSXFx($scope.template.info.file.bucket, $scope.template.info.file.xlsx);
              }
            }

            $scope.setContentTimeFx($scope.template);
            $scope.durationCountFx("all");
          },
          function(err){
            $log.error(err);
          }
        );
      }
    } else{
      $scope.template = {
        info:{label:"", width:1280, height:720, rlf:false, scv:false,feedOpt:false, refreshOpt:"n", tType:false, subType:"", ssTime:5,
          detail:{
            epd:{
              dt:"s", m:{}, w:1280, h:720
            }
          }//For EPD
        },
        permission:{type:$scope.auth.upreferences.defaultP},
        frames:[]
      }
    }



    // EPD Type
    $scope.epdDType = {isOpen:false};
    $scope.epdSearchFocus = function(){
      $scope.searchEpd = {l:""};
      if($scope.epdGrouped.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $scope.getModelsFx = function(){
      $scope.storeErr = false;
      $scope.modelsLoading = true;
      DevicesCUSrv.getModels().then(
        function(data){
          if(data.code == 12089){
            $scope.hasErr = true;
            $scope.eslNotAuth = true;
            $scope.errType = "eslAuth";
          }
          $scope.epdModels = data.models;
          $scope.modelsLoading = false;
  
          // Group by model
          $scope.epdGrouped = $scope.epdModels.reduce(function(result, epd){
            if(!result[epd.model]){
              result[epd.model] = [];
            }
            result[epd.model].push(epd);
            return result;
          }, {});
        },
        function(err){
          $scope.modelsLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectEpdFx = function(epd){
      $scope.template.info.detail.epd.m = epd;
      $scope.epdDType.isOpen = !$scope.epdDType.isOpen;

      // if($scope.template.info.detail.epd.m.resolution){
      //   var res = $scope.template.info.detail.epd.m.resolution.split("*");
      //   $scope.template.info.detail.epd.w = Number(res[0]);
      //   $scope.template.info.detail.epd.h = Number(res[1]);
      // }
    }

    $scope.changeSubTypeFx = function(){
      if($scope.template.info.subType == 'cl'){
        delete $scope.template.info.excelOd;
      } else {
        delete $scope.template.info.excelCl;
      }
    }

    $scope.setContentTimeFx = function(template){
      var maxDuration = $scope.allDuration;
      angular.forEach(template.frames, function(frame){
        if(frame.content.length){
          var startTime = 0;
          var tmpStartTime = 0;
          var tmpEndTime = 0;
          var endTime = 0;
          for(var i = 0;i < frame.content.length;i++){
            if(i == 0){
              tmpStartTime = startTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            } else{
              tmpStartTime = endTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = endTime + frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            }
          }
        } else{
          var dTextBlock = [];
          var startTime = 0;
          var endTime = 0;
          if(frame.type == "dText"){
            var maxBlock = frame.showAfter == 0 ? 2 :3;
            for(var i = 0;i < maxBlock;i++){
              if(maxBlock == 2){
                if(i == 0){
                  dTextBlock.push({start:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.showAfter), 'HH:mm:ss'), end:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.hideAfter), 'HH:mm:ss'), blank:false, duration:Math.abs(frame.showAfter - frame.hideAfter)});
                } else{
                  dTextBlock.push({start:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.showAfter), 'HH:mm:ss'), end:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.hideAfter), 'HH:mm:ss'), blank:true, duration:Math.abs(frame.hideAfter - maxDuration)});
                }
              } else{
                if(i == 0){
                  dTextBlock.push({start:$filter('date')(new Date(1970, 0, 1).setSeconds(startTime), 'HH:mm:ss'), end:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.showAfter), 'HH:mm:ss'), blank:true, duration:Math.abs(startTime - frame.showAfter)});
                } else if(i == 1){
                  dTextBlock.push({start:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.showAfter), 'HH:mm:ss'), end:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.hideAfter), 'HH:mm:ss'), blank:false, duration:Math.abs(frame.showAfter - frame.hideAfter)});
                } else{
                  dTextBlock.push({start:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.showAfter), 'HH:mm:ss'), end:$filter('date')(new Date(1970, 0, 1).setSeconds(frame.hideAfter), 'HH:mm:ss'), blank:true, duration:Math.abs(frame.hideAfter - maxDuration)});
                }
              }
            }
            frame.duration = dTextBlock;
          }
        }
      });
    }

    $scope.feedRefreshInterval = function(){
      if($scope.template.info.feedUrl && !$scope.template.info.refresh){
        $scope.template.info.refresh = 5;
      }
    }

    $scope.frameAlignFx = function(val){
      $scope.curFrame.align = val;
    }

    $scope.addFrame = function(frameType){
      $scope.isDContent = 0;
      angular.forEach($scope.template.frames, function(item){
        if(item.type == "dContent"){
          $scope.isDContent = 1;
          return;
        }
      });
      if($scope.template.info.tType == 4 && frameType == "content"){
        $scope.isContentSelected = true;
      }

      if(($scope.auth.upermissions.dmb && $scope.auth.upermissions.dmb_t) && $scope.template.info.tType == 2 && frameType == "dContent" && $scope.isDContent > 0){
        // we can show error message here
      } else{
        if(frameType == "content" || frameType == "dContent"){
          $scope.curAlign = "m-c";
        } else{
          $scope.curAlign = "left";
        }
        $scope.frameObj = {
          id:"t" + $scope.frameId,
          label:"Placeholder " + parseInt($scope.template.frames.length + 1),
          width:100,
          height:100,
          rotation:0,
          bg:"",
          bga:1,
          rgba:"",
          bgType:"",
          fill:"fit",
          // br:{tl:0, tr:0, bl:0, br:0},
          settings:{br:{tl:0, tr:0, bl:0, br:0, isBorder:false}, ish:{hl:0, vl:0, br:10, sr:5, sc:"#000000", sca:0.75, rgba:'rgba(0,0,0,1)',scType:"monochrome", isShadow:false}, rotation:0},
          x:Math.round($("#canvas").scrollLeft()) * (1 / $scope.canvas.zoom),
          y:Math.round($("#canvas").scrollTop()) * (1 / $scope.canvas.zoom),
          z:$scope.curZ,
          type:frameType,
          text:"",
          font:$scope.fontFamilySelected,
          size:24,
          color:"#000000",
          cType:"monochrome",
          bold:"normal",
          italic:"none",
          underline:"none",
          align:$scope.curAlign,
          folder:{},
          content:[],
          feedRef:0,
          showAfter:0,
          hideAfter:0,
          isNew:1
        }
        if($scope.template.info.tType == 3 && frameType == 'dText'){
          $scope.frameObj.cell = {sheet:"",cellNo:"", isMap:false, row:"", col:""};
          $scope.frameObj.sheet = "";
        }

        /* Allow Multiple Text Start*/
        if(frameType == 'dText' && ($scope.template.info.tType == 0 || $scope.template.info.tType == 4)){
          $scope.frameObj.isMT = false;
          $scope.frameObj.mt = [];
        }
        /* Allow Multiple Text End*/

        $scope.template.frames.push($scope.frameObj);
        $scope.frameId++;
        $scope.curZ++;

        $(".sortable-containment").sortable({
          cancel:".span"
        });
      }
    }

    $scope.duplicateFrame = function(frameType){
      $scope.frameObj = {
        id:"t" + $scope.frameId,
        label:$scope.curFrame.label + " - Copy",
        width:$scope.curFrame.width,
        height:$scope.curFrame.height,
        rotation:$scope.curFrame.rotation,
        br:$scope.curFrame.br,
        settings:angular.copy($scope.curFrame.settings),
        bg:$scope.curFrame.bg,
        bga:$scope.curFrame.bga,
        rgba:$scope.curFrame.rgba,
        bgType:$scope.curFrame.bgType,
        fill:$scope.curFrame.fill,
        x:$scope.curFrame.x,
        y:$scope.curFrame.y,
        z:$scope.curZ,
        type:$scope.curFrame.type,
        text:$scope.curFrame.text,
        font:$scope.curFrame.font,
        size:$scope.curFrame.size,
        color:$scope.curFrame.color,
        cType:$scope.curFrame.cType,
        bold:$scope.curFrame.bold,
        italic:$scope.curFrame.italic,
        underline:$scope.curFrame.underline,
        align:$scope.curFrame.align,
        folder:angular.copy($scope.curFrame.folder),
        content:angular.copy($scope.curFrame.content),
        feedRef:$scope.curFrame.feedRef,
        showAfter:$scope.curFrame.showAfter,
        hideAfter:$scope.curFrame.hideAfter,
        isNew:1
      };

      if($scope.template.info.tType == 3 && $scope.curFrame.type == 'dText'){
        if($scope.curFrame.cell){
          $scope.frameObj.cell = {sheet:$scope.curFrame.cell.sheet,cellNo:$scope.curFrame.cell.cellNo, isMap:$scope.curFrame.cell.isMap, row:$scope.curFrame.cell.row, col:$scope.curFrame.cell.col};
        }
        if($scope.curFrame.sheet){
          $scope.frameObj.sheet = $scope.curFrame.sheet;
        }
      }
      /* Allow Multiple Text Start*/
      if($scope.curFrame.type == 'dText' && ($scope.template.info.tType == 0 || $scope.template.info.tType == 4)){
        $scope.frameObj.isMT = angular.copy($scope.curFrame.isMT);
        $scope.frameObj.mt = angular.copy($scope.curFrame.mt);
      }
      /* Allow Multiple Text End*/

      $scope.template.frames.push($scope.frameObj);
      $scope.frameId++;
      $scope.curZ++;

      $(".sortable-containment").sortable({
        cancel:".span"
      });
    }

    $scope.durationCountFx = function(caller, state){
      var video = document.getElementById("dynamicVideo");
      if(video != null){
        if(video.paused){
          $scope.isPlay = true;
        } else{
          $scope.isPlay = false;
        }
        if(!$scope.isTimeline.toggle && state == "toggle"){
          video.load();
        }
      }

      if(!caller){
        $scope.curDuration = 0;
        angular.forEach($scope.curFrame.content, function(item){
          if(item.isAccessible == true){
            $scope.curDuration += item.duration;
          }
        });
      }

      $scope.allDuration = 0;
      var curDuration = {d:0, arr:[]};
      angular.forEach($scope.template.frames, function(frame){
        curDuration.d = 0;
        angular.forEach(frame.content, function(item){
          if(item.isAccessible == true){
            curDuration.d += item.duration;
          }
          if(item.type == "Video"){
            $scope.isTLActive = true;
          }
        });
        curDuration.arr.push(curDuration.d);
      });
      $scope.allDuration = Math.max.apply(Math, curDuration.arr.map(function(item){return item;}));
      $scope.rularCount = (Math.ceil($scope.allDuration));
      $scope.rulerCountArr = [];
      for(var i = 0;i < $scope.rularCount;i++){
        $scope.rulerCountArr.push(i);
      }

      setTimeout(function(){
        $('.bdr-top-dashed').scroll(function(){
          $(this).find('.tl-left').css('left', $(this).scrollLeft());
        });
      }, 1000);
      $scope.setContentTimeFx($scope.template);
    }

    $scope.selectFrame = function(e, frame, index){
      $timeout(function(){
        var elementH = document.querySelector('#templateToolbarHeight');
        $scope.clientHeightHeader = elementH.offsetHeight;
      }, 10);
      e.stopPropagation();
      $scope.colorPicker.isOpen = false;
      $scope.curFrameIndex = index;
      if($scope.sheetList && $scope.sheetList.length){
        $scope.sheetList.forEach(function(item){
          if(frame.cell && frame.cell.isMap == true && frame.sheet && item.index == frame.sheet.index){
            frame.sheet = item;
          }
        })
      }
      $scope.curFrame = frame;
      
      /* Allow Multiple Text Start*/
      if(!$scope.curFrame.isMTOnce){
        $scope.curFrame.isMTOnce = false;
      }
      if($scope.curFrame.isMT){
        if($scope.curFrame.mt.length>0){
          $scope.curFrame.isMTOnce = true;
        }
        if(!$scope.curFrame.mt.length){
          $scope.curFrame.mt.unshift({t:$scope.curFrame.text, dt:true});
        }
      }
      /* Allow Multiple Text End */


      $scope.curDuration = 0;
      
      if(($scope.curFrame.type == "content" || $scope.curFrame.type == "dContent") && $rootScope.selectedT == 4){
        $rootScope.selectedT = '3';
      } else if(($scope.curFrame.type == "text" || $scope.curFrame.type == "dText") && $rootScope.selectedT == 3){
        $rootScope.selectedT = '4';
      } else if(($scope.curFrame.type == "rectangle" || $scope.curFrame.type == "circle") && ($rootScope.selectedT == 3 || $rootScope.selectedT == 4)){
        $rootScope.selectedT = '1';
      }

      if($scope.template.info.tType != 6 && $scope.curFrame.type == "dContent"  && $rootScope.selectedT == 5){
        $rootScope.selectedT = '1';
      }
      if($scope.template.info.tType == 6 && ($scope.curFrame.type == "content" || $scope.curFrame.type == "dContent" || $scope.curFrame.type == "text")  && $rootScope.selectedT == 5){
        $rootScope.selectedT = '1';
      }

      $(".layer-container .layer").removeClass("selected");
      $(".frame").removeClass("selected");

      $(".tl-container .layer").removeClass("selected");

      $(".layer[data-id=" + frame.id + "]").addClass("selected");
      $(".frame[data-id=" + frame.id + "]").addClass("selected");

      if($scope.curFrame.bg != ''){
        $scope.frameBg.isChecked = true;
      } else{
        $scope.frameBg.isChecked = false;
      }

      // setTimeout(function(){
      //   $scope.redC = parseInt($scope.curFrame.bg[1]+$scope.curFrame.bg[2],16);
      //   $scope.greenC = parseInt($scope.curFrame.bg[3]+$scope.curFrame.bg[4],16);
      //   $scope.blueC = parseInt($scope.curFrame.bg[5]+$scope.curFrame.bg[6],16);
      //   $scope.bgColorEditor1Rgba = "rgba("+$scope.redC+","+$scope.greenC+","+$scope.blueC+","+$scope.curFrame.bga+")";
      //   if($scope.frameBg.isChecked == true && $scope.curFrame.bg != '' && $rootScope.selectedT == '4'){
      //     // $scope.bgColorEditor1 = ""+ $scope.curFrame.bg.toUpperCase(); +"";
      //       // document.getElementById("tTextEditor").style.backgroundColor = $scope.bgColorEditor1;
      //       document.getElementById("tTextEditor").style.backgroundColor = $scope.bgColorEditor1Rgba;
      //   }else if($scope.frameBg.isChecked == false && $scope.curFrame.bg == '' && $rootScope.selectedT == '4'){
      //     document.getElementById("tTextEditor").style.backgroundColor = 'transparent';
      //   }
      // }, 50);

      // duration count
      $scope.durationCountFx();
    }

    // $rootScope.selectedTabFx = function(caller){
    //   if($rootScope.selectedT == "4"){
    //     $scope.redC = parseInt($scope.curFrame.bg[1]+$scope.curFrame.bg[2],16);
    //     $scope.greenC = parseInt($scope.curFrame.bg[3]+$scope.curFrame.bg[4],16);
    //     $scope.blueC = parseInt($scope.curFrame.bg[5]+$scope.curFrame.bg[6],16);
    //     $scope.bgColorEditor1Rgba = "rgba("+$scope.redC+","+$scope.greenC+","+$scope.blueC+","+$scope.curFrame.bga+")";
    //     if($scope.frameBg.isChecked == true && $scope.curFrame.bg != ''){
    //       // var bgColorEditor1 = ""+ $scope.curFrame.bg.toUpperCase(); +"";
    //       // document.getElementById("tTextEditor").style.backgroundColor = bgColorEditor1;
    //       document.getElementById("tTextEditor").style.backgroundColor = $scope.bgColorEditor1Rgba;
    //     }else {
    //       document.getElementById("tTextEditor").style.backgroundColor = 'transparent';
    //     }
    //   }
    //   $scope.durationCountFx();
    // }

    $scope.layerEyeFx = function(e, frame){
      e.stopPropagation();
      $(".layer[data-id=" + frame.id + "] .fa-eye").toggleClass("eyeClose");
      $(".frame[data-id=" + frame.id + "]").toggleClass("hide");
    }

    $scope.deselectAllFrames = function(){
      $(".layer").removeClass("selected");
      $(".frame").removeClass("selected");
      $scope.colorPicker.isOpen = false;
      $scope.frameBg.isChecked = false;
      $rootScope.selectedT = '1';
      $scope.curFrame = null;
    }

    $rootScope.deleteCallback = function(){
      if($scope.curFrame){
        if((($scope.auth.upermissions.dmb && $scope.auth.upermissions.dmb_t) && $scope.template.info.tType == 2 && $scope.curFrame.type != 'dContent') || $scope.template.info.tType != 2){
          $scope.removePlaceholder();
        }
      }
    }

    $scope.removePlaceholder = function(id, type){
      if(!$scope.isConfirmOpen){
        if(type){
          $scope.removeObj = {id:id, type:type};
        } else{
          $scope.removeObj = null;
        }
        $scope.confirmDeletePlaceholder();
      }
    }

    $scope.confirmDeletePlaceholder = function(){
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"t.msg.10" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePlaceholder();" ng-disabled="templateProcessing">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deletePlaceholder = function(){
      if($scope.removeObj){
        if($scope.removeObj.type == "l"){
          $scope.template.frames.splice($scope.template.frames.indexOf($scope.template.frames.filter(function(obj){
            return obj.id == $scope.removeObj.id;
          })[0]), 1);
        }
      } else{
        $scope.template.frames.splice($scope.curFrameIndex, 1);
      }

      if($scope.template.info.tType == 4){
        $scope.isContentSelected = false;
        angular.forEach($scope.template.frames, function(item){
          if(item.type == "content"){
            $scope.isContentSelected = true;
            return;
          }
        });
      }
      $timeout(function(){$("#canvas").click();}, 250);
      ngDialog.close();
    }

    $scope.frameResize = function(e, index, ui){
      $scope.template.frames[index].width = (1 / $scope.canvas.zoom) * ui.size.width;
      $scope.template.frames[index].height = (1 / $scope.canvas.zoom) * ui.size.height;
    }

    $scope.frameDrag = function(e, ui, index){
      $scope.template.frames[index].x = (1 / $scope.canvas.zoom) * ui.position.left;
      $scope.template.frames[index].y = (1 / $scope.canvas.zoom) * ui.position.top;
    }

    $scope.frameDragStart = function(e, ui, index){
      $scope.template.frames[index].x = (1 / $scope.canvas.zoom) * ui.position.left;
      $scope.template.frames[index].y = (1 / $scope.canvas.zoom) * ui.position.top;
    }

    $scope.sortCallback = function(e, ui, index){
      if(e == "tl"){
        $scope.tlCurLayer = $(".tl-layer").length + 1;
        $(".tl-layer").each(function(){
          for(var i = 0;i < $scope.template.frames.length;i++){
            if($scope.template.frames[i].id == $(this).data("id")){
              $scope.template.frames[i].z = $scope.tlCurLayer - 1;
              break;
            }
          }
          $scope.tlCurLayer--;
        });
      } else{
        $scope.curLayer = $(".template-layer").length + 1;
        $(".template-layer").each(function(){
          for(var i = 0;i < $scope.template.frames.length;i++){
            if($scope.template.frames[i].id == $(this).data("id")){
              $scope.template.frames[i].z = $scope.curLayer - 1;
              break;
            }
          }
          $scope.curLayer--;
        });
      }
      $(".tab-success.active a").click();
    }

    $scope.snapGridFx = function(e){
      if($(e.currentTarget).is(":checked")){
        $(".frame:not(.notSelectable)").draggable({
          grid:[(10 * $scope.canvas.zoom), (10 * $scope.canvas.zoom)]
        });
        $(".frame:not(.notSelectable)").resizable({
          grid:[(10 * $scope.canvas.zoom), (10 * $scope.canvas.zoom)]
        });
      } else{
        $(".frame:not(.notSelectable)").draggable({
          grid:[1, 1]
        });
        $(".frame:not(.notSelectable)").resizable({
          grid:[1, 1]
        });
      }
    }

    $scope.JSONToCollapsibleTreeView = function (jsonData, containerSelector) {
      var container = document.querySelector(containerSelector);
      container.innerHTML = '';

      var rootUL = document.createElement('ul');
      rootUL.className = 'treeview';
      container.appendChild(rootUL);

      $scope.buildTree = function (data, parentElement, isParentCollapsed, path) {
          for (var key in data) {
              var value = data[key];
              var li = document.createElement('li');
              parentElement.appendChild(li);
              var newPath = (path === '' || path === undefined) ? key : path + '.' + key;
              var keySpan = document.createElement('span');
              li.appendChild(keySpan);

              var isCollapsible = typeof value === 'object';
              var plusBtn = document.createElement('span');
              plusBtn.className = 'plusMin collapsed';

              if (isCollapsible) {
                  var toggleButton = document.createElement('button');
                  toggleButton.className = 'toggle-button';
                  toggleButton.textContent = '-';
                  plusBtn.textContent = '-';
                  keySpan.appendChild(toggleButton);
                  keySpan.className = 'tree_node';
                  plusBtn.addEventListener('click', function () {
                      $scope.toggleNode(this, plusBtn);
                  });

                  keySpan.textContent = key;

                  var nestedUL = document.createElement('ul');
                  nestedUL.style.display = 'block';

                  li.appendChild(nestedUL);
                  li.appendChild(plusBtn);


                  // Call the buildTree function with the updated path
                  $scope.buildTree(value, nestedUL, !isParentCollapsed, newPath);

                  // $scope.buildTree(value, nestedUL, !isParentCollapsed);
              } else {
                  keySpan.textContent = key + ': ' + value;

                  // Show "Apply" button for leaf nodes
                  var applyButton = document.createElement('button');
                  applyButton.setAttribute('data-txt', key);
                  $scope.formatPath = function(path) {
                    return path.replace(/\.(0|[1-9]\d*)/g, '[$1]');
                  };
                  applyButton.setAttribute('data-ref', $scope.formatPath(newPath)); // Set the path in the data attribute
                  applyButton.className = 'apply-button btn btn-xs btn-primary';
                  applyButton.textContent = 'Apply';
                  li.appendChild(applyButton);
                  applyButton.addEventListener('click', function () {
                    var pathAndValue = this.getAttribute('data-ref');
                    $scope.curFrame.feedRef = 1;
                    $scope.$apply(function () {
                      $scope.curFrame.text = '{{' + pathAndValue + '}}';
                    });
                  });
              }
          }
      };

      $scope.toggleNode = function (node, plusBtn) {
          var ul = node.parentElement.querySelector('ul');
          if (ul) {
              if (ul.style.display === 'none') {
                  ul.style.display = 'block';
                  node.innerText = '-';
              } else {
                  ul.style.display = 'none';
                  node.innerText = '+';
              }
              node.classList.toggle('collapsed');
          }
      };

      $scope.buildTree(jsonData, rootUL, true); // Initially, parent is considered collapsed
    };

    $scope.allSet = function(){
      $rootScope.$apply(function(){
        $scope.XMLData = true;
      });
    }

    $scope.loadFeed = function(){
      if(!$scope.feedTreeLoaded){
        $scope.feedTreeLoaded = true;
        var url = $scope.template.info.feedUrl;
        $timeout(function(){
          $scope.treeObj = {
            fpath:$scope.template.info.tType == 6? url : $rootScope.apiHost + 'feed/reverseCall?url=' + url,
            container:'#feedTreeContainer',
            startExpanded:true,
            isOlo:$scope.template.info.tType == 6? true : false
          }
          TemplateCUSrv.getFeedData(url, $scope.treeObj.isOlo).then(
            function(data){
              if (typeof data === 'object') {
                $scope.JSONToCollapsibleTreeView(data, '#feedTreeContainer');
                $scope.XMLData = true;
              } else if (typeof data === 'string') {
                // Handle XML
                $scope.treeObj.xml = data;
                $scope.tree = new XMLTree($scope.treeObj);
                $scope.XMLData = true;
                // $scope.interval = setInterval(function(){
                //   var successXMLData = localStorage.getItem("successXMLData");
                //   if(successXMLData){
                //     $scope.allSet();
                //     localStorage.removeItem("successXMLData");
                //     clearInterval($scope.interval);
                //   }
                // }, 5000);
              }
              $scope.feedTreeLoaded = false;
            },
            function(err){
              $log.error(err);
            }
          );
        }, 500);
      }
    }

    $(document).off("click", ".btnFeed").on("click", ".btnFeed", function(e){
      e.stopPropagation();
      $scope.frameFeedRef = "";
      if($(this).attr("data-ref") != ""){
        $scope.frameFeedRef = $(this).attr("data-ref") + "." + $(this).attr("data-txt");
      } else{
        $scope.frameFeedRef = $(this).attr("data-txt");
      }
      $scope.curFrame.feedRef = 1;
      $scope.curFrame.text = "{{" + $scope.frameFeedRef + "}}";
      if($scope.treeObj.isOlo){
        $scope.frameFeedName = $(this).attr("data-val").replace(/^\((.*)\)$/, '$1');
        $scope.curFrame.settings.dynText = $scope.frameFeedName;
      }
      if($scope.curFrame.type == "content"){
        $scope.curFrame.content = [];
        $scope.curFrame.folder = [];
      }
      $(".frame[data-id=" + $scope.curFrame.id + "]").click();
    });

    $scope.textPropFx = function(prop){
      if(prop == "bold"){
        $scope.curFrame.bold = $scope.curFrame.bold == "bold" ? "normal" :"bold";
      } else if(prop == "italic"){
        $scope.curFrame.italic = $scope.curFrame.italic == "italic" ? "none" :"italic";
      } else if(prop == "underline"){
        $scope.curFrame.underline = $scope.curFrame.underline == "underline" ? "none" :"underline";
      } else if(prop == "left" || prop == "center" || prop == "right"){
        $scope.curFrame.align = prop;
      }
    }

    $scope.frameBgFx = function(e){
      if(!$(e.currentTarget).children("input")[0].checked){
        $scope.curFrame.bg = '';
        $scope.curFrame.bga = 1;
        $scope.curFrame.rgba = '';
        $scope.curFrame.bgType = '';
      } else{
        $scope.colorPickerOpen(e);
      }
    }
    $scope.colorPickerOpen = function($event, caller){
      $event.stopPropagation();
      if(caller=="sc"){
        $scope.colorPicker.isSc = true;
        if(!$scope.curFrame.ish){
          $scope.curFrame.ish.sca = 1;
          $scope.curFrame.ish.sc = '#000000';
          $scope.curFrame.ish.scType = 'monochrome';
          $scope.curFrame.ish.rgba = 'rgba(0,0,0,1)';
        }
      } else {
        $scope.colorPicker.isOpen = true;
        if(!$scope.curFrame.bg){
          $scope.curFrame.bga = 1;
          $scope.curFrame.bg = '#000000';
          $scope.curFrame.bgType = 'monochrome';
          $scope.curFrame.rgba = 'rgba(0,0,0,1)';
        }
      }
    }
    $scope.resetAdSettingFx = function(isShadow, caller){
      if(!isShadow){
        if(caller=='b'){
          $scope.curFrame.settings.br = {tl:0, tr:0, bl:0, br:0, isBorder:false};
        } else {
          $scope.curFrame.settings.ish = {hl:0, vl:0, br:10, sr:5, sc:"#000000", sca:0.75, rgba:'rgba(0,0,0,1)', scType:"monochrome", isShadow:false};
        }
      }
    }

    if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.curStage == "hub.tContainer.tName" && $scope.decType != "t"){
      TemplatesSrv.getLibrary().then(
        function(data){
          if($scope.curStage == "hub.tContainer.tName"){
            $scope.librarys = data.templates;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.contentObj = {type:"", id:""};
    $scope.selectFolderOpen = function(id){
      $scope.folderLoading = true;
      $scope.folderProcessing = false;
      $scope.selectednode = id;
      ContentLibrarySrv.getTree(0, true).then(
        function(data){
          $scope.folderLoading = false;
          $scope.treeList = data.tree;
        },
        function(err){
          $log.error(err);
          $scope.folderLoading = false;
        }
      );

      ngDialog.open({
        template:'app/templates/popup/selectFolder.html',
        width:580,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }

    $scope.folderFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$("input[name='treeOpt']:checked").val()){
        $scope.hasErrPop = true;
        $scope.errTypePop = "target";
      } else{
        $scope.folderProcessing = true;
        if($scope.curFrame.folder.id != Number($("input[name='treeOpt']:checked").val())){
          $scope.curFrame.content = [];
        }
        $scope.curFrame.folder = {id:$("input[name='treeOpt']:checked").val(), label:$("input[name='treeOpt']:checked").attr("data-label"), path:$("input[name='treeOpt']:checked").attr("data-path")};
        ngDialog.close();
      }
    }

    $scope.searchChangeFx = function(caller){
      if(caller){
        $scope.search.text = "";
        $scope.searchText = "";
      } else{
        $scope.searchText = $scope.search.text;
      }
    }

    $scope.selectContentOpen = function(id){
      $scope.searchText = "";
      $scope.searchChangeFx("empty");
      $scope.curFolderIds = localStorage.getItem("folderId");
      if($scope.curFolderIds == undefined){
        $scope.curFolderIds = 0;
      }
      if(id){
        $scope.folderContentFx(id);
        $scope.contentObj = {type:"dmb", id:id};
      } else{
        $scope.folderContentFx($scope.curFolderIds);
        $scope.contentObj = {type:"", id:null};
      }

      var contentPopUrl = "app/templates/popup/selectContent.html";
      if((($scope.auth.upermissions.dmb && $scope.auth.upermissions.dmb_t) && $scope.template.info.tType == 2) || $scope.template.info.tType == 4){
        contentPopUrl = "app/templates/popup/selectSingleDContent.html";
      }
      ngDialog.open({
        template:contentPopUrl,
        width:845,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }

    if($scope.curStage === "hub.tContainer.tDesign"){
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curFolderIds = localStorage.getItem("folderId");
      if($scope.curFolderIds == undefined){
        $scope.curFolderIds = 0;
      }

      ContentLibrarySrv.getFolderApprovedContent($scope.curFolderIds).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.folderContentFx = function(fId, splId, splType, caller){
      if(caller == 'refresh'){
        $scope.loading = true;
      }

      $scope.contentLibraryLoading = true;
      $scope.curFolderIds = fId;
      if($scope.curFolderIds === undefined){
        $("div[data-tree-model] li span.selected").removeClass("selected");
      }
      if($rootScope.curState != 'hub.tContainer.tName'){
        ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
          function(data){
            $scope.searchChangeFx("empty");
            if($scope.contentObj.type != "dmb"){
              localStorage.removeItem("folderId");
              localStorage.setItem("folderId", fId);
            }
            if($scope.contentObj.type == "dmb"){
              localStorage.setItem("folderId", fId);
            }
            $scope.loading = false;
            $scope.contentLibrary = data;
            $scope.flId = fId;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
            $scope.contentLibraryLoading = false;
            $scope.loading = false;
          }
        );
      } else {
        $scope.contentLoading = true;
        $scope.search = {text:""};
        ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
          function(data){
            $scope.contentLibrary = data;
            $scope.flId = fId;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.updateList();
          },
          function(err){
            $scope.contentLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.updateList = function(){
      $scope.loading = false;
      $scope.contentLoading = false;
      $scope.contentLibraryLoading = false;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.tim = $scope.contentLibrary.info.timthumb;

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentObj.type == "dmb"){
        $scope.curBreadCrumbs = angular.copy($scope.breadCrumbs);
        $scope.setClickable = false;
        angular.forEach($scope.breadCrumbs, function(b){
          if(b.id == $scope.contentObj.id){
            $scope.setClickable = true;
            b.clickable = $scope.setClickable;
          } else{
            b.clickable = $scope.setClickable;
          }
        });
      }

      if($scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }

      if($scope.contentLibrary.contentLibrary.content){
        $scope.filteredContent = [];
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if($scope.template.info.tType == 4){
            if(item.type == "Video"){
              $scope.contentList.push(item);
            }
          } else if($scope.template.info && $scope.template.info.tType == 1){
            if(item.type == "Image" || item.splType == "Image"){
              $scope.contentList.push(item);
            }
          } else if($scope.template.info.tType == 3 && $rootScope.curState == 'hub.tContainer.tName'){
            if(item.type == "Widget" && item.extn == "Excel Sheet"){
              $scope.contentList.push(item);
            }
          } else{
            if(item.extn != "Content on Demand" && item.extn != "Content Group" && item.extn != "Intel Smart Building"){
              $scope.filteredContent.push(item);
            }
            $scope.contentList = $scope.filteredContent;
          }
        });
      }
      $scope.contentLoading = false;
      $scope.openingLoading = false;
    }

    $scope.updateODList = function(){
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];

      $scope.breadCrumbs = $scope.content.info.breadCrumbs;
      if($scope.content.items){
        angular.forEach($scope.content.items, function(item){
          $scope.contentList.push(item);
        });
      }
    }

    //one drive content
    // $scope.searchTextPopup = {txt:""};
    // $scope.selectODContentOpen = function(){
    //   $scope.ODContentLoading = false;
    //   $scope.hasPopErr = false;
    //   $scope.errType = "";
    //   $scope.curContent = "";
    //   $scope.searchTextPopup.txt = "";
    //   if($scope.template.info.isAuthorized){
    //     $scope.contentLoading = true;
    //     $scope.openingLoading = true;
    //     ContentLibrarySrv.getVerifyTemp($scope.decId).then(
    //       function(data){
    //         $scope.contentLoading = false;
    //         $scope.openingLoading = false;
    //         $scope.content = data;
    //         $scope.updateODList();
    //       },
    //       function(err){
    //         $log.error(err);
    //         $scope.contentLoading = false;
    //         $scope.openingLoading = false;
    //       }
    //     );
    //   }
    //   ngDialog.open({
    //     template:'app/templates/popup/odContent.html',
    //     width:1024,
    //     scope:$scope,
    //     closeByEscape:false,
    //     closeByDocument:false
    //   });
    // }

    $scope.folderODContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      if($scope.curFolderIds === undefined){
        $("div[data-tree-model] li span.selected").removeClass("selected");
      }
      $scope.searchTextPopup.txt = "";
      TemplateCUSrv.getFolderApprovedContent(fId, $scope.decId).then(
        function(data){
          localStorage.removeItem("folderId");
          $scope.content = data;
          $scope.contentLoading = false;
          $scope.updateODList();
        },
        function(err){
          $log.error(err);
          $scope.contentLoading = false;
        }
      );
    }

    $scope.saveODContentFx = function(){
      $scope.hasPopErr = false;
      $scope.errType = "";
      if(!$scope.curContent){
        $scope.hasPopErr = true;
        $scope.errType = "odContent";
      } else{
        $scope.ODContentLoading = true;
        $scope.contentObj = {info:$scope.content.info, item:$scope.curContent[0]};

        TemplateCUSrv.saveODContent($scope.contentObj).then(
          function(data){
            if($scope.template.info.tType == 3 && $scope.template.info.subType == 'od'){
              $scope.contentName = data.excelOd.path + data.excelOd.name;
              $scope.contentObj.info = data.excelOd;
            } else{
              $scope.contentName = data.eslOd.path + data.eslOd.name;
              $scope.contentObj.info = data.eslOd;
            }
            $scope.odLS = "";
            localStorage.removeItem("folderId");
            $scope.ODContentLoading = false;
            ngDialog.close();
          },
          function(err){
            $scope.ODContentLoading = false;
            $log.error(err);
            ngDialog.close();
          }
        );
      }
    }

    $scope.useContentFx = function(){
      if($scope.curContent == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($scope.selectedT == "2"){
          $scope.addEvent.logo = $scope.curContent;
        } else if($scope.selectedT == "3"){
          $scope.addScreen.ss = $scope.curContent;
        }
        ngDialog.close();
      }
    }

    $scope.resetSettingsFx = function(){
      if($scope.template.info.tType){
        $scope.template.info.feedUrl = "";
        $scope.template.info.feedOpt = false;
        $scope.template.info.refreshOpt = "n";
        $scope.template.info.rlf = false;
        $scope.template.info.scv = false;
        $scope.template.info.ssTime = 5;
        $scope.template.info.newCategory = "";
        $scope.template.info.category = null;
        $scope.template.info.libraryOpt = false;
        $scope.template.info.subType = "cl";
        $scope.template.info.refresh = 5;
      }
      if($scope.template.info.tType == 1){
        $scope.getModelsFx();
      }
    }

    //for select one drive content
    $scope.selectODFx = function(e, caller, content){
      $scope.id = content.id;
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        $scope.curContent = [];
        $scope.curContent.push({
          id:content.id,
          name:content.name,
          type:content.type,
          dUrl:content.dUrl
        });
      } else{
        $scope.folderODContentFx($scope.id);
      }
    }

    //for select single dynamic content
    $scope.selectFx = function(e, caller, content, type, splId, cData){
      $scope.hasErr = false;
      $scope.errType = "";
      if($rootScope.curState == 'hub.tContainer.tName'){
        $scope.id = content;
      } else {
        $scope.id = content.id;
      }

      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        if($rootScope.curState == 'hub.tContainer.tName' && $scope.template.info.tType == 3){
          $scope.curContent = cData;
          $scope.template.info.excelCl = cData;
          $scope.contentName = "/ " + cData.label;
        } else {
          $scope.curFrame.feedRef = 0;
          $scope.curFrame.text = "";
          $scope.curFrame.content = [];
          $scope.curFrame.content.push({
            hidden:0,
            id:content.id,
            fid:content.fid,
            extn:content.extn,
            btnExtn:content.btnExtn,
            type:content.type,
            label:content.label,
            thumb:content.thumb,
            width:content.width,
            height:content.height,
            splFid:content.splFid,
            Length:content.Length,
            url:content.url,
            path:$scope.contentLibrary.info.path,
            splType:content.splType,
            duration:content.duration,
            MajorVersion:content.MajorVersion,
            isAccessible:true,
            ServerRelativeUrl:content.ServerRelativeUrl
          });
          if(type == 'Video'){
            var video = document.getElementById('dynamicVideo');
            if(video != null){
              if(video.readyState == 4 || video.readyState == 0){
                video.pause();
                video.load();
              }
            }
          }
          $scope.durationCountFx();
        }
      } else{
        $scope.folderContentFx($scope.id, splId, type, caller);
      }
    }

    $scope.briefFx = function(){
      $scope.curFolderIds = localStorage.getItem("folderId");
      if($scope.curFolderIds == undefined){
        $scope.curFolderIds = 0;
      }
      for(var i = 0;i < $rootScope.selectedItems.length;i++){
        if($rootScope.selectedItems[i].type != 'folder'){
          for(var j = 0;j < $scope.contentList.length;j++){
            if($rootScope.selectedItems[i].id == $scope.contentList[j].id){
              //make content single selection with esl type
              $scope.curFrame.feedRef = 0;
              $scope.curFrame.text = "";
              if($scope.template.info.tType == 1){
                $scope.curFrame.content = [];
              }
              $scope.curFrame.content.push({
                hidden:0,
                ss:$scope.contentList[j].ss,
                id:$scope.contentList[j].id,
                fid:$scope.contentList[j].fid,
                extn:$scope.contentList[j].extn,
                btnExtn:$scope.contentList[j].btnExtn,
                type:$scope.contentList[j].type,
                label:$scope.contentList[j].label,
                thumb:$scope.contentList[j].thumb,
                width:$scope.contentList[j].width,
                ssImg:$scope.contentList[j].ssImg,
                height:$scope.contentList[j].height,
                splFid:$scope.contentList[j].splFid,
                Length:$scope.contentList[j].Length,
                path:$scope.contentLibrary.info.path,
                splType:$scope.contentList[j].splType,
                duration:$scope.contentList[j].duration,
                MajorVersion:$scope.contentList[j].MajorVersion,
                url:$scope.contentList[j].url,
                isAccessible:true,
                ServerRelativeUrl:$scope.contentList[j].ServerRelativeUrl
              });
              break;
            }
          }
        }
      }
      $scope.durationCountFx();
    }

    $rootScope.$on('selectedItems', function(event, args){
      for(var i = 0;i < args.length;i++){
        if(args[i].type != 'folder'){
          $scope.isDuplicate = false;
          for(var j = 0;j < $scope.curFrame.content.length;j++){
            if(args[i].id == $scope.curFrame.content[j].id){
              $scope.isDuplicate = true;
              break;
            }
          }
          if(!$scope.isDuplicate){
            $scope.curFrame.content.push({
              id:args[i].id,
              label:args[i].label,
              img:args[i].image,
              duration:12,
              extn:args[i].extn,
              btnExtn:args[i].btnExtn,
            });
          }
        }
      }
    });

    $scope.folderBriefFx = function(){}

    $scope.cancelFx = function(){
      if($scope.decType == "l"){
        $state.go("hub.templates.tl");
      } else{
        $state.go("hub.templates.t");
      }
    }

    $scope.removeContentFx = function(index, content){
      if($scope.template.info.tType == '2' || $scope.template.info.tType == '4' && content.type == "Video"){
        $scope.isTLActive = false;
        $scope.isTimeline.toggle = false;
      }

      var cIndex = $scope.curFrame.content.findIndex(function(c){
        return c.id === content.id;
      })
      if(cIndex !== -1) $scope.curFrame.content.splice(cIndex, 1);
      $scope.durationCountFx();
    }

    $scope.saveTemplate = function(caller, action, step){
      $scope.template.info.type = $scope.hubDec($state.params.type);
      $rootScope.templateType = $scope.template.info.tType;
      $scope.template.info.fId = $scope.fId;
      $scope.template.info.oloStoreDetail = $scope.curStore.store;
      $scope.hasErr = false;
      $scope.errType == "";

      if($scope.template.info.tType == 3 && $scope.auth.upermissions.texl_cl && !$scope.auth.upermissions.texl_od){
        $scope.template.info.subType = 'cl';
      } else if($scope.template.info.tType == 3 && !$scope.auth.upermissions.texl_cl && $scope.auth.upermissions.texl_od){
        $scope.template.info.subType = 'od';
      }

      $scope.isSheetEmpty = false;
      $scope.isCellNo = false;
      $scope.invalidCell = false;

      if($scope.template.frames){
        angular.forEach($scope.template.frames, function(frame){
          $(".layer[data-id=" + frame.id + "] .fa-eye").removeClass("eyeClose");
          $(".frame[data-id=" + frame.id + "]").removeClass("hide");
          // frame.text = "";
          if($scope.template.info.tType == 3 && frame.type == 'dText' && caller == 'design' && frame.cell && frame.cell.isMap){
            if(!$scope.isSheetEmpty){
              if(!frame.sheet || frame.sheet == ''){
                $scope.isSheetEmpty = true;
              }
            }
            if(!$scope.isCellNo){
              if(frame.cell && !frame.cell.cellNo){
                $scope.isCellNo = true;
              }
            }
            if(!$scope.invalidCell){
              if(frame.cell && frame.cell.cellNo){
                $scope.invCell = $scope.excelCellToIndices(frame.cell.cellNo);
                if($scope.invCell == "invCell"){
                  $scope.invalidCell = true;
                }
              }
            }
          }
        });
      }

      if($scope.isSheetEmpty){
        $scope.hasErr = true;
        $scope.errType = 'sheet';
        return;
      } else if($scope.isCellNo){
        $scope.hasErr = true;
        $scope.errType = 'cell';
        return;
      } else if($scope.invalidCell){
        $scope.hasErr = true;
        $scope.errType = 'invCell';
        return;
      }
      // else if($scope.template.info.label != '' && $scope.template.info.tType == 3 && $scope.template.info.subType == "cl" && (!$scope.template.info.excelCl || $scope.template.info.excelCl.length == 0)){
      //   console.warn("ddd");
      //   $scope.hasErr = true;
      //   $scope.errType = 'content';
      //   return;
      // }

      // check if hideAfter time duration is greater than video time
      var hAfInvalid = false;
      var sAfInvalid = false;

      if($scope.template.frames.length && ($scope.template.info.tType == 2 || $scope.template.info.tType == 4)){
        var video = document.getElementById('dynamicVideo');
        if(video != null){
          $scope.isPlay = true;
          video.pause();
          var duration = video.duration;
          video.load();
          angular.forEach($scope.template.frames, function(item){
            if(item.type == "dText"){
              if(item.hideAfter > Math.round(duration + 1)){
                hAfInvalid = true;
              }
              if(item.showAfter > item.hideAfter){
                sAfInvalid = true;
              }
            }
          });
        }
      }

      if($scope.template.frames.length){
        $scope.dNameEmpty = false;
        angular.forEach($scope.template.frames, function(frame){
          if(frame.label == ""){
            $scope.dNameEmpty = true;
          }
        })
      }
      if(($scope.template.info.tType == 2 || $scope.template.info.tType == 4) && $state.current.name == "hub.tContainer.tDesign" && hAfInvalid){
        $scope.hasErr = true;
        $scope.errType = "hAduration";
      } else if($scope.dNameEmpty && $state.current.name == "hub.tContainer.tDesign"){
        $scope.errType = "dName";
        $scope.hasErr = true;
      } else{
        $timeout(function(){$("#canvas").click();}, 250);
        if(action == undefined){
          $scope.template.info.toast = false;
        } else{
          $scope.template.info.toast = true;
        }
        if(step == "saveStore"){
          $scope.storedOloId = angular.copy($scope.template.info.oloStoreDetail.id);
        }
        if(action == "saveAnyway"){
          $scope.saveAnywayProcessing = true;
        } else{
          $scope.saveAnywayProcessing = false;
        }
        if(caller == "design"){
          $scope.isInvalidDuration = false;
          if(action == "s"){
            $scope.saveProcessing = true;
          } else{
            $scope.saveCloseProcessing = true;
          }

          angular.forEach($scope.template.frames, function(item){
            if(item.content.length > 0){
              angular.forEach(item.content, function(content){
                if(isNaN(content.duration) || content.duration < 1){
                  $scope.isInvalidDuration = true;
                }
                if($scope.template.info.tType == 4 && content.type == "Video"){
                  $scope.template.info.duration = content.duration;
                }
              });
            }
          });

          if($scope.isInvalidDuration){
            $scope.saveCloseProcessing = false;
            $scope.saveProcessing = false;
            $scope.errType = "duration";
            $scope.hasErr = true;
          } else{

            if(action != "saveAnyway" && $scope.template.frames.length == 0){
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">\
                      <div>{{"t.msg.14" | translate}}</div>\
                    </div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-success" ng-click="closeThisDialog();">{{\'fl.p_cfl.label.17\' | translate}}</button>\
                      <button type="button" role="button" class="btn btn-danger" ng-click="saveTemplate(\'design\', \'saveAnyway\');">{{\'fl.p_cfl.label.18\' | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:600,
                scope:$scope,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
              $scope.saveProcessing = false;
              $scope.saveCloseProcessing = false;
              return true;
            } else{
              ngDialog.close();
            }
            $scope.template.info.step = "frame";
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"cm.msg.10" | translate}}</div>\
                  </div>\
                </section>',
              plain:true,
              width:300,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            $(".frame").removeClass("selected");
            if(action == "s" || action == "sc"){

              $scope.copyInfo = {zoom:angular.copy($scope.canvas.zoom), height:$("#canvas").outerHeight()};
              $scope.canvas.zoom = "0.5";
              $("#canvas").css("overflow", "auto");
              $("#canvas").css("height", "auto");
              $(".frame").css("border", "1px solid #003E66");
              $("#dynamicVideo").css("display", "none");
              $("#vidThumb").css("display", "block");
            }

            html2canvas($(".flGrid"), {
              useCORS:true,
              onrendered:function(canvas){
                $scope.imgUrl = canvas.toDataURL("image/png");
                $scope.template.base64 = $scope.imgUrl;
                if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.template.info.libraryOpt){
                  $scope.setContentOdrFx($scope.template);

                  TemplateCUSrv.saveLibrary($scope.template).then(
                    function(data){
                      ngDialog.close();
                      $scope.saveProcessing = false;
                      $scope.saveCloseProcessing = false;
                      if(action == "s"){
                        $state.go("hub.tContainer.tDesign", {type:$scope.encType, id:$scope.encId});
                        $("#vidThumb").css("display", "none");
                        if($scope.template.info.feedUrl != ""){
                          $scope.feedTreeLoaded = false;
                          $scope.XMLData = false;
                          $scope.loadFeed();
                        }
                      } else{
                        if($state.current.name == "hub.tContainer.tDesign"){
                          $state.go("hub.templates.tl");
                        }
                      }
                    },
                    function(err){
                      $log.error(err);
                      ngDialog.close();
                      $scope.saveProcessing = false;
                      $scope.saveCloseProcessing = false;
                    }
                  );
                } else{
                  $scope.isSheetEmpty = false;
                  $scope.isCellNo = false;

                  if($scope.template.frames){
                    angular.forEach($scope.template.frames, function(frame){
                      $(".layer[data-id=" + frame.id + "] .fa-eye").removeClass("eyeClose");
                      $(".frame[data-id=" + frame.id + "]").removeClass("hide");

                    });
                  }

                  $scope.setContentOdrFx($scope.template);
                  $scope.errType = "";
                  $scope.hasErr = false;

                  if($scope.template.info.tType==3 && $scope.template.info.file){
                    angular.forEach($scope.template.frames, function(frame){
                      if(frame.type == 'dText' && frame.cell && frame.cell.cellNo != '' && frame.cell.isMap){
                        $scope.cellData = $scope.excelCellToIndices(frame.cell.cellNo);
                        if($scope.cellData){
                          frame.cell.row = $scope.cellData.row;
                          frame.cell.col = $scope.cellData.col;
                        }
                        frame.cell.sheet = frame.sheet.index;
                        frame.text = "";
                        if($scope.mainExcelSheet.length){
                          angular.forEach($scope.mainExcelSheet, function(sheet, sIndex){
                            if(frame.cell.sheet === sIndex){
                              if(sheet.d.length){
                                angular.forEach(sheet.d, function(data, rIndex){
                                  if(frame.cell.row === rIndex){
                                    frame.text = data.find(function(d, i){
                                      return i == frame.cell.col;
                                    });
                                    if(frame.text && frame.text.f){
                                      if(frame.text.f.color){
                                        frame.color = frame.text.f.color;
                                      }
                                      if(frame.text.f["font-weight"]){
                                        frame.bold = frame.text.f["font-weight"];
                                      }
                                      if(frame.text.f["text-decoration"]){
                                        frame.underline = frame.text.f["text-decoration"];
                                      }
                                      if(frame.text.f["font-style"]){
                                        frame.italic = frame.text.f["font-style"];
                                      }
                                      if(frame.text.f["text-align"]){
                                        frame.align = frame.text.f["text-align"];
                                      }
                                      // if(frame.text.f["font-size"]){
                                      //   frame.size = parseInt(frame.text.f["font-size"].split("px")[0]);
                                      // }
                                    }
                                    if(frame.text && frame.text.s){
                                      if(frame.text.s["background-color"]){
                                        frame.bg = frame.text.s["background-color"];
                                        frame.rgba = $scope.hax2rgba(frame.text.s["background-color"], frame.bga);
                                      } else {
                                        frame.bg = "";
                                        frame.rgba = "";
                                      }
                                    }
                                    if(frame.text && frame.text.t){
                                      frame.text = frame.text.t;
                                    }else{
                                      frame.text = "";
                                    }
                                    // if(angular.isUndefined(frame.text)){
                                    //   frame.text = "";
                                    // }
                                  }
                                });
                              }
                            }
                          })
                        }
                      }
                    });
                  }
                  if($scope.template.frames.length){
                    angular.forEach($scope.template.frames, function(frame){
                      if(frame.cell && !frame.cell.isMap){
                        delete frame.cell;
                        delete frame.sheet;
                      }
                    });
                  }

                  TemplateCUSrv.saveTemplate($scope.template).then(
                    function(data){
                      ngDialog.close();
                      $scope.saveProcessing = false;
                      $scope.saveCloseProcessing = false;
                      if(action == "s"){
                        if($state.current.name === "hub.tContainer.tDesign"){
                          $state.go("hub.tContainer.tDesign", {type:$scope.encType, id:$scope.encId});
                          $scope.canvas.zoom = $scope.copyInfo.zoom;
                          $("#canvas").css("overflow", "auto");
                          $("#canvas").css("height", $scope.copyInfo.height);
                          $(".frame").css("border", "none");
                          $("#dynamicVideo").css("display", "block");
                          $("#vidThumb").css("display", "none");
                          if($scope.template.info.feedUrl != ""){
                            $scope.feedTreeLoaded = false;
                            $scope.XMLData = false;
                            $scope.loadFeed();
                          }
                        }
                      } else{
                        if($state.current.name === "hub.tContainer.tDesign"){
                          $state.go("hub.templates.t");
                        }
                      }
                    },
                    function(err){
                      $log.error(err);
                      ngDialog.close();
                      $scope.saveProcessing = false;
                      $scope.saveCloseProcessing = false;
                    }
                  );
                }
              }
            });
          }
        } else if(caller == "name"){
          $scope.template.info.step = "info";
          $scope.newCategory = false;
          if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.template.info.libraryOpt && $scope.template.info.newCategory){
            angular.forEach($scope.librarys, function(item){
              if(angular.lowercase(item.label) == angular.lowercase($scope.template.info.newCategory)){
                $scope.newCategory = true;
              }
            });
          }

          if($scope.template.info.feedOpt == false){
            $scope.template.info.feedUrl = "";
          }
          if($scope.template.info.refreshOpt == 'n' && $scope.template.info.tType != 1){
            $scope.template.info.refresh = 0;
          }

          if($scope.template.info.tType == 1){
            $scope.template.info.width = null;
            $scope.template.info.height = null;
            if($scope.template.info.detail.epd.dt == "s" && $scope.template.info.detail.epd.m.resolution){
              var res = $scope.template.info.detail.epd.m.resolution.split("*");
              $scope.template.info.width = res[0];
              $scope.template.info.height = res[1];
            } else if($scope.template.info.detail.epd.dt == "c"){
              $scope.template.info.width = $scope.template.info.detail.epd.w;
              $scope.template.info.height = $scope.template.info.detail.epd.h;
            }
          }
          
          if($scope.template.info.label == ""){
            $scope.errType = "name";
            $scope.hasErr = true;
            $("#label").focus();
          } else if(!$scope.template.info.width || $scope.template.info.width == "" || !$scope.template.info.height || $scope.template.info.height == ""){
            if($scope.template.info.tType == 1 && $scope.template.info.detail.epd.dt == "s"){
              $scope.errType = "epdModel";
            } else{
              $scope.errType = "dim";
            }
            $scope.hasErr = true;
            if(!$scope.template.info.width || $scope.template.info.width == ""){
              $("#width").focus();
            } else if(!$scope.template.info.height || $scope.template.info.height == ""){
              $("#height").focus();
            }
          }

          // if($scope.template.info.tType == 1){
          //   if($scope.template.info.detail.epd.dt == "s" && $scope.template.info.detail.epd.m.resolution){
          //     var res = $scope.template.info.detail.epd.m.resolution.split("*");
          //     $scope.template.info.width = res[0];
          //     $scope.template.info.height = res[1];
          //   }
          //   if($scope.template.info.detail.epd.dt == "c"){
          //     $scope.template.info.width = $scope.template.info.detail.epd.w;
          //     $scope.template.info.height = $scope.template.info.detail.epd.h;
          //   }
          // }
          
          else if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.template.info.libraryOpt && !$scope.template.info.category && (!$scope.template.info.newCategory || $scope.template.info.newCategory == "")){
            $scope.errType = "library";
            $scope.hasErr = true;
          } else if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.template.info.libraryOpt && !$scope.template.info.category && $scope.newCategory){
            $scope.errType = "categoryExists";
            $scope.hasErr = true;
          } else if($scope.template.info.tType == 6 && !$scope.template.info.oloStoreDetail.id){
            $scope.errType = "hasStore";
            $scope.hasErr = true;
            $("#store").focus();
          } else if(step != "saveStore" && $scope.storedOloId && $scope.template.info.oloStoreDetail.id != $scope.storedOloId){
            $scope.storeAnyway = {call: caller, act: action};
              ngDialog.open({
                template:'\
                  <section class="panel">\
                    <div class="panel-body">\
                      <div>{{"t.msg.39" | translate}}</div>\
                    </div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-success" ng-click="closeThisDialog();">{{\'fl.p_cfl.label.17\' | translate}}</button>\
                      <button type="button" role="button" class="btn btn-danger" ng-click="saveTemplate(storeAnyway.call, storeAnyway.act, \'saveStore\');">{{\'fl.p_cfl.label.18\' | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:600,
                scope:$scope,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
              $scope.saveProcessing = false;
              $scope.saveCloseProcessing = false;
              return true;
          } else{
            if(action == undefined){
              $scope.saveProcessing = true;
            } else{
              $scope.saveCloseProcessing = true;
            }
            $scope.template.info.step = "info";

            if(($scope.auth.uType == 0 || $scope.auth.uType == 1) && $scope.template.info.libraryOpt){
              $scope.setContentOdrFx($scope.template);
              TemplateCUSrv.saveLibrary($scope.template).then(
                function(data){
                  $scope.encId = $scope.hubEncrypt(data.templateId);
                  $scope.tHeight = $scope.template.info.height;
                  $scope.tWidth = $scope.template.info.width;
                  $scope.encType = $scope.hubEnc("l");
                  $scope.saveCloseProcessing = false;
                  $scope.saveProcessing = false;
                  if(action == undefined){
                    if($state.current.name === "hub.tContainer.tName"){
                      $state.go("hub.tContainer.tDesign", {type:$scope.encType, id:$scope.encId});
                    }
                  } else{
                    if($state.current.name === "hub.tContainer.tName"){
                      $state.go("hub.templates.tl");
                    }
                  }
                },
                function(err){
                  $scope.saveCloseProcessing = false;
                  $scope.saveProcessing = false;
                  $log.error(err);
                }
              );
            } else{
              if($rootScope.isPermissionOpen){
                $scope.isPEOpen = true;
                $rootScope.$broadcast('savePermission',{});
              }
              if($scope.isPEOpen){
                $timeout(function(){
                  $scope.saveTemplateObj(caller, action);
                }, 250);
              } else{
                $scope.saveTemplateObj(caller, action);
              }
            }
          }
        }
      }
    }

    $scope.saveTemplateObj = function(caller, action){
      $scope.setContentOdrFx($scope.template);
      TemplateCUSrv.saveTemplate($scope.template).then(
        function(data){
          $scope.encId = $scope.hubEncrypt(data.templateId);
          $scope.tHeight = $scope.template.info.height;
          $scope.tWidth = $scope.template.info.width;
          $scope.encType = $scope.hubEnc("t");
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          if(action == undefined){
            if($state.current.name === "hub.tContainer.tName"){
              $state.go("hub.tContainer.tDesign", {type:$scope.encType, id:$scope.encId});
            }
          } else{
            if($state.current.name === "hub.tContainer.tName"){
              $state.go("hub.templates.t");
            }
          }
        },
        function(err){
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    //add "sortOdr" key for content order
    $scope.setContentOdrFx = function(template){
      $scope.setContentTimeFx(template);
      if(template.frames.length){
        angular.forEach($scope.template.frames, function(frame){
          if(frame.content.length){
            angular.forEach(frame.content, function(cont, j){
              cont.sortOdr = j + 1;
            });
          }
        });
      }
    }

    $scope.closeESLAuthFx = function(){
      if($scope.esl.action == "s"){
        $state.go("hub.tContainer.tDesign", {type:$scope.esl.type, id:$scope.esl.id});
      } else{
        $state.go("hub.templates.t");
      }
      ngDialog.close();
    }

    $scope.openUrlFx = function(w, h, caller){
      // ContentLibrarySrv.clearSession().then(
      //   function(data){
          $scope.left = (screen.width / 2) - (w / 2);
          $scope.top = (screen.height / 2) - (h / 2);
          $scope.odProcessing = true;
          $scope.odDisabled = true;
          $scope.hasErr = false;
          $scope.errType = "";

          // if(caller == "rAuth"){
          //   var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout', 'toolbar=0,directories=no,status=0,width=' + w + ',height=' + h + ',top=' + $scope.top + ', left=' + $scope.left);
          // }
          setTimeout(
            function(){
              // if(caller == "rAuth"){
              //   newWindow.close();
              // }
              $scope.childWindow = window.open($scope.odUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width=' + w + ', height=' + h + ', top=' + $scope.top + ', left=' + $scope.left);
              $scope.childWindowInt = $interval($scope.checkChild, 500);
            }, 1000);
          return false;
      //   },
      //   function(err){
      //     $log.error(err);
      //   }
      // );
    }

    $scope.openConfirmFx = function(){
      if(!$scope.template.info.isHidden && $scope.contentName != '' && $scope.contentName != null){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{template.info.tType==1?"t.msg.21":"t.msg.21-1" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="openUrlFx(626, 450); closeThisDialog();" data-dismiss="modal"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        $scope.openUrlFx(626, 450);
      }
    }

    //one drive content
    $scope.searchTextPopup = {txt:""};
    $scope.checkChild = function(){
      $scope.contentLoading = true;
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        
        $scope.contentLoading = true;
        $scope.openingLoading = true;
        $scope.contentLoading = false;
        $scope.ODContentLoading = false;
        $scope.hasPopErr = false;
        $scope.errType = "";
        $scope.curContent = "";
        $scope.searchTextPopup.txt = "";
        
        ContentLibrarySrv.getVerifyTemp($scope.decId).then(
          function(data){
            $scope.odProcessing = false;
            $scope.odDisabled = false;
            $scope.contentLoading = false;
            $scope.hasErr = false;
            $scope.errType = "";
            if(data.code == 8196){
              $scope.errType = "odNotExist";
              $scope.showAuthBtn = true;
              $scope.hasErr = true;
              return;
            } else{
              $scope.content.info = data.info;
              $scope.content.items = data.items;
              if(data.info){
                $scope.template.info.isAuthorized = data.info.isAuthorized;

                // $scope.selectODContentOpen();

                $scope.openingLoading = false;
                $scope.content = data;
                $scope.updateODList();

                ngDialog.open({
                  template:'app/templates/popup/odContent.html',
                  width:1024,
                  scope:$scope,
                  closeByEscape:false,
                  closeByDocument:false
                });

                // $scope.epdDriveId = localStorage.getItem("epdDriveId");
                // if(data.info.driveId != $scope.epdDriveId){
                //   // console.warn("hello i am New...!");
                //   $scope.contentName = "";
                // }
              }
            }
          },
          function(err){
            $log.error(err);
            $scope.contentLoading = false;
            $scope.openingLoading = false;
          }
        );
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        // console.warn($scope.template);
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if($scope.template.info.tType == 4){
            if(item.type == "Video"){
              $scope.curArgsContent.push(item);
            }
          }
          // comment it because we need all things for excel type also
          // else if($scope.template.info.tType == 3){
          //   if(item.type == "Widget" && item.extn == "Excel Sheet"){
          //     $scope.curArgsContent.push(item);
          //   }
          // }
          else{
            if(item.extn != "Content on Demand" && item.extn != "Content Group" && item.extn != "Intel Smart Building"){
              $scope.curArgsContent.push(item);
            }
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      // console.warn($scope.contentList);
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      // console.warn(args);
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    });

    $(document).on("click", "#toggle_fullscreen", function(e){
      if(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement){
        if(document.exitFullscreen){
          document.exitFullscreen();
        } else if(document.mozCancelFullScreen){
          document.mozCancelFullScreen();
        } else if(document.webkitExitFullscreen){
          document.webkitExitFullscreen();
        } else if(document.msExitFullscreen){
          document.msExitFullscreen();
        }
      } else{
        var fselement = $('#fs-container').get(0);
        if(fselement.requestFullscreen){
          fselement.requestFullscreen();
        } else if(fselement.mozRequestFullScreen){
          fselement.mozRequestFullScreen();
        } else if(fselement.webkitRequestFullscreen){
          fselement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if(fselement.msRequestFullscreen){
          fselement.msRequestFullscreen();
        }
      }
    });

    $scope.playPauseFx = function(){
      var video = document.getElementById('dynamicVideo');
      if(video.paused){
        $scope.isPlay = !$scope.isPlay;
        video.play();
      } else{
        $scope.isPlay = !$scope.isPlay;
        video.pause();
      }
    }

    $scope.checkDurationFx = function(){
      var video = document.getElementById('dynamicVideo');
      $scope.hasErr = false;
      $scope.errType = "";
      if(video != null && $scope.curFrame && $scope.curFrame.hideAfter > Math.round(video.duration) + 1){
        $scope.hasErr = true;
        $scope.errType = "hAduration";
      } else{
        $scope.setContentTimeFx($scope.template);
        $scope.durationCountFx("all");
      }
    }

    $scope.getExcelJsonFx = function(bucket, json){
      console.warn("getExcelJsonFx ");

      $scope.sheetsLoading = true;
      TemplateCUSrv.getExcelSheets(bucket + json).then(
        function(data){
          if(data.length){
            $scope.mainExcelSheet = angular.copy(data);
            $scope.sheetList = data.map(function(list, i){
              return {l:list.l, index:i}
            })
          }
          // $scope.sheetList = data;
          $scope.sheetsLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getExcelXLSXFx = function(bucket, xlsx){
      $scope.odLSLoading = true;
      TemplateCUSrv.getExcelXLSX(bucket + xlsx).then(
        function(data){
          $scope.odLSLoading = false;
          if(data.code == 5003){
            $scope.odLS = data.ls;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getStoreFx = function(caller){
      $scope.oloStoreLoading = true;
      if(caller != "update"){
        $scope.curStore = {store:""};
      }
      TemplateCUSrv.getOloStore().then(
        function(data){
          $scope.oloStoreList = data
          $scope.oloStoreLoading = false;
        },
        function(err){
          $scope.oloStoreLoading = false;
          $log.error(err);
        }
      );
    }


    $scope.excelCellToIndices = function(cell) {
      if (!cell) {
        return "invCell";
      }

      cell = cell.toUpperCase();
      var regex = /^([A-Z]+)(\d+)$/; // Use ^ and $ to ensure the entire string matches the pattern
      var match = cell.match(regex);

      if (!match) {
        return "invCell";
      }

      var column = match[1];
      var row = parseInt(match[2], 10) - 1; // Subtract 1 to convert to zero-based index
      var colIndex = 0;

      // Calculate the column index based on the letters (A=0, B=1, ..., Z=25, AA=26, AB=27, ...)
      for (var i = 0; i < column.length; i++) {
        colIndex = colIndex * 26 + (column.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
      }

      // Subtract 1 to convert to zero-based index
      colIndex -= 1;

      if (row < 0 || colIndex < 0) {
        return "invCell"; // Check if row or column index is negative
      }

      return { row: row, col: colIndex };
    }

    $scope.selSubTypeFx = function(){
      if($scope.template.info.subType == "" || $scope.template.info.subType == null && !$scope.decId){
        if($scope.auth.upermissions.texl_cl && $scope.auth.upermissions.texl_od){
          $scope.template.info.subType = "cl";
        } else if($scope.auth.upermissions.texl_cl && !$scope.auth.upermissions.texl_od){
          $scope.template.info.subType = "cl";
        } else if(!$scope.auth.upermissions.texl_cl && $scope.auth.upermissions.texl_od){
          $scope.template.info.subType = "od";
        }
      }
    }

    $scope.selectExcelOpen = function(){
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      // $scope.curContent = "";
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      // $scope.curContent = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.singleStoreFx = function(){
      $scope.curStore.store = angular.fromJson($scope.curStore.store);// Close the dropdown
    }
    // Assuming you have a controller function to initialize the dropdown state
    $scope.dropdownOpen = {isOpen:false};
    $scope.closeDropdown = function() {
      // Assuming you have a variable to control the dropdown state, you can set it to false to close the dropdown.
      $scope.dropdownOpen.isOpen = false;
    };

    // TODO update the text according to the zoom level
    $scope.getScaledHtml = function(text, zoom) {
      return text.replace(/font-size\s*:\s*(\d+(?:\.\d+)?)px/gi, function(match, size) {
        var scaledSize = parseFloat(size) * zoom;
        return 'font-size: ' + scaledSize + 'px';
      });
    };

    $scope.removeAllFormate = function(event){
      var clipboardData, pastedData;
      event.preventDefault();
      clipboardData = event.originalEvent.clipboardData
      pastedData = clipboardData.getData('Text');
      document.execCommand("insertHTML", false, pastedData);
    }

    /* Allow Multiple Text Start*/
    $scope.mtActionFx = function(caller, i){
      $scope.mlObj = {caller:caller, i:i};
      if(caller == "a"){
        $scope.curFrame.mt.push({t:""});
      } else if(caller == "dc"){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="mtActionFx(\'d\', mlObj.i);" ng-disabled="templateProcessing">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm",
          preCloseCallback:function(){
            $scope.isConfirmOpen = false;
          }
        });
      } else if(caller == "d"){
        $scope.curFrame.mt.splice(i, 1);
        ngDialog.close();
      }
    }

    $scope.textChangeFx = function(){
      if($scope.curFrame.isMT && $scope.curFrame.mt.length>0){
        $scope.curFrame.isMTOnce = true;
      }
      if($scope.curFrame.isMT && $scope.curFrame.isMTOnce){   
        for(var i = 0; i<$scope.curFrame.mt.length; i++){
          if($scope.curFrame.mt[i].dt){            
            $scope.curFrame.mt[i].t = $scope.curFrame.text;
            break;
          }
        };
      }
    }
    $scope.isMTFx = function(){      
      if($scope.curFrame.isMT && !$scope.curFrame.isMTOnce){
        $scope.curFrame.isMTOnce = true;
        $scope.curFrame.mt.unshift({t:$scope.curFrame.text, dt:true});
      } else{
        for(var i = 0; i<$scope.curFrame.mt.length; i++){
          if($scope.curFrame.mt[i].dt){            
            $scope.curFrame.mt[i].t = $scope.curFrame.text;
            break;
          }
        };
      }
    }
    /* Allow Multiple Text End*/
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TemplatesController', TemplatesController);

  /** @ngInject */
  function TemplatesController($log, $rootScope, $scope, $state, $filter, $timeout, ngDialog, CommonSrv, ContentLibrarySrv, SchedulesSrv, TemplatesSrv){
    $rootScope.selectedMenu = 2;
    $scope.curSort = {sortType:"", sortVal:""};
    $scope.selectedTab = $state.current.name;
    $scope.templateProcessing = false;
    $scope.templatesLoading = true;
    $scope.isConfirmOpen = false;
    $scope.templateList = [];
    $scope.folderList = [];
    $scope.thumbSize = 'n'; //sm, n, md, lg, xl
    $scope.searchText = "";
    $scope.templates = {};
    $scope.filter = "all";
    $scope.encType = "";
    $scope.encId = "";

    localStorage.removeItem("tSchedule");
    localStorage.removeItem("tfSchedule");

    $scope.curTFolderId = localStorage.getItem("curTFId");
    if(!$scope.curTFolderId || angular.isUndefined($scope.curTFolderId)){
      $scope.curTFolderId = 0;
    }

    $scope.openFolderFx = function(caller, id, splId, type){
      $scope.templatesLoading = true;
      $rootScope.selectedItems = [];
      $scope.contextMenuOpt = [];
      $scope.templates = {};
      $scope.searchText = "";
      if(caller == "t"){
        localStorage.setItem("curTlId", id);
        TemplatesSrv.getTemplatesContent(id).then(
          function(data){
            $scope.templates = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "tl"){
        localStorage.setItem("curTlId", id);
        TemplatesSrv.getLibraryContent(id).then(
          function(data){
            $scope.templates = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }

    $scope.loadSelectedTab = function(caller){
      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        localStorage.removeItem("curTemplateId");
        angular.element('.ui-selectable li').removeClass('ui-highlight');
      }
      if($scope.curTFolderId == 0){
        localStorage.setItem("inTFolder", 0);
      }

      if(caller !== "sort"){
        $scope.advSearchInfo = {};
        $scope.advSearch = false;
      }

      $scope.templatesLoading = true;
      $rootScope.selectedItems = [];
      $scope.searchText = "";
      $scope.templates = {};
      if($scope.selectedTab === "hub.templates.t"){
        $scope.encType = $scope.hubEnc("t");
        if(angular.isUndefined($scope.curTFolderId)){
          $scope.curTFolderId = 0;
        }
        //get stored adv search data after search
        $scope.curFilterTmObj = angular.fromJson(localStorage.getItem("curFilterTmObj"));
        $scope.curAdvSearchCopy = angular.fromJson(localStorage.getItem("curAdvSearchCopy"));
        $scope.isTmAdvSearch = localStorage.getItem("isTmAdvSearch");
        //action like del, add to sch, replace, archive, and approve/unapprove
        $scope.isActionOnTemplate = localStorage.getItem("isActionOnTemplate");

        if(caller == "sort" && $scope.advSearch){
          CommonSrv.updateAdvSearchTM($scope.advObj).then(
            function(data){
              $rootScope.selectedItems = [];
              $scope.folderList = [];
              $scope.templateList = [];
              $scope.searchText = "";
              $scope.templateList = data.template;
              $scope.folderList = data.folder;
              $scope.advSearchInfo = $scope.advSearchInfo;

              $scope.templates = {templates:{folder:data.folder, template:data.template}, info:data.info};
              $scope.curPathTId = localStorage.getItem("curPathTId");
              if($scope.curPathTId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathTId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
              $scope.updateList();
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          if(localStorage.getItem("isActionOnTemplate")){
            localStorage.removeItem("isActionOnTemplate");
          }
          //store search state if edit
          if($scope.isActionOnTemplate){
            if($scope.curAdvSearchCopy.type || $scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.createdBy){
              $scope.searchProcessing = true;
              $scope.curFilterTmObj = {name:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, type:$scope.curAdvSearchCopy.type, step:$scope.curAdvSearchCopy.step};
              CommonSrv.updateAdvSearchTM($scope.curFilterTmObj).then(
                function(data){
                  $scope.searchProcessing = false;
                  $scope.filteredData = data;

                  $scope.templates = {templates:{template:data.template, folder:data.folder}, info:data.info, rightKey:[]};
                  $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
                  $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, template:$scope.filteredData.template, folder:$scope.filteredData.folder, code:data.code, advObj:$scope.curFilterTmObj};
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                  $scope.curPathTId = angular.fromJson(localStorage.getItem("curPathTId"));
                  if($scope.curPathTId){
                    setTimeout(function(){
                      angular.forEach(angular.element('.ui-selectable li'), function(item){
                        if($(item).attr('data-id') == $scope.curPathTId){
                          $(item).addClass('ui-highlight');
                        }
                      });
                    }, 100);
                  }
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            }
          } else{
            localStorage.removeItem("isTmAdvSearch");
            localStorage.removeItem("curFilterTmObj");
            TemplatesSrv.getTemplatesContent($scope.curTFolderId).then(
              function(data){
                $scope.templates = data;
                $scope.updateList();

                $scope.curTemplateId = angular.fromJson(localStorage.getItem("curTemplateId"));
                if($scope.curTemplateId){
                  setTimeout(function(){
                    angular.forEach(angular.element('.ui-selectable li'), function(item){
                      if($(item).attr('data-id') == $scope.curTemplateId){
                        $(item).addClass('ui-highlight');
                      }
                    });
                  }, 100);
                }
                $scope.loadingMain = false;
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
      } else if($scope.selectedTab === "hub.templates.ts"){
        $scope.encType = $scope.hubEnc("t");
        TemplatesSrv.getTemplates("ts").then(
          function(data){
            if($scope.selectedTab === "hub.templates.ts"){
              $scope.templates = data;
              $scope.updateList();
              $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
              if($scope.curPathId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
              $scope.loadingMain = false;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.templates.ut"){
        TemplatesSrv.getUnapproved().then(
          function(data){
            if($scope.selectedTab === "hub.templates.ut"){
              $scope.templates = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curTemplateId = angular.fromJson(localStorage.getItem("curTemplateId"));
              if($scope.curTemplateId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curTemplateId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.templates.it"){
        $scope.encType = $scope.hubEnc("it");
        TemplatesSrv.getIncomplete().then(
          function(data){
            if($scope.selectedTab === "hub.templates.it"){
              $scope.templates = data;
              $scope.updateList();
              $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.templates.tl"){
        $scope.encType = $scope.hubEnc("l");
        if(caller == "home"){
          localStorage.removeItem("curTlId");
        }
        if(!localStorage.getItem("curTlId")){
          TemplatesSrv.getLibrary().then(
            function(data){
              if($scope.selectedTab === "hub.templates.tl"){
                $scope.templates = data;
                $scope.updateList();
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.openFolderFx("tl", localStorage.getItem("curTlId"));
        }
      }
    }
    $scope.loadSelectedTab();

    $scope.isTemplateSorting = true;
    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2, fromTemplate){
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if(fromTemplate == "tList"){
        if($scope.curSort.sortType == sortType && $scope.curSort.sortVal == "asc"){
          sortVal = "desc";
        } else if($scope.curSort.sortType == sortType && $scope.curSort.sortVal == "desc"){
          sortVal = "asc";
        }
      }
      $scope.curSort = {sortType:sortType, sortVal:sortVal};
      CommonSrv.setSort({"type":sortType, "val":sortVal, "module":moduleName}).then(
        function(data){
          $scope.loadSelectedTab("sort");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.updateList = function(){
      $scope.templatesLoading = false;
      if($scope.templates.info){
        $scope.tim = $scope.templates.info.timthumb;
        $scope.tBucket = $scope.tDetailBucket = $scope.templates.info.bucket;
        if($scope.templates.info.mbucket && $scope.templates.info.mbucket != ""){
          $scope.tDetailBucket = $scope.templates.info.mbucket;
        }
        if($scope.templates.info.breadCrumbs){
          $scope.breadCrumbs = $scope.templates.info.breadCrumbs;
        }
      }

      if($scope.templates.templates.folder){
        $scope.folderList = $scope.templates.templates.folder;
      }
      if($scope.templates.templates.template){
        $scope.templateList = $scope.templates.templates.template;
      }
      if($scope.templates.templates && !$scope.templates.templates.folder && !$scope.templates.templates.template){
        $scope.templateList = $scope.templates.templates;
      }
      if($scope.templates.info){
        $scope.curSort = {sortType:$scope.templates.info.sortType, sortVal:$scope.templates.info.sortVal};
      }
      // $scope.tabIndexFx("t");
      $scope.contextMenuBaseFx();
    }

    $scope.closeBriefFx = function(){
      $rootScope.selectedItems = [];
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      $(".thumb-list li.ui-selected").removeClass('ui-selected');
      $(".list-unstyled li.ui-selected").removeClass('ui-selected');
    }
    $scope.selectFolderFx = function(e, selectedItems){
      localStorage.setItem("curTlId", selectedItems.id);
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      $(".thumb-list li.ui-selected").removeClass('ui-selected');
      $(".list-unstyled li.ui-selected").removeClass('ui-selected');
      $(e.currentTarget).addClass("ui-selected");
      $rootScope.selectedItems = [selectedItems];
      $scope.templateBtn = {buttons:[{key:"tlOpen"}]};
      $scope.updateContextMenu($scope.templateBtn);
    }
    $scope.selectableFx = function(e){
      if(e.target.tagName == "UL"){
        $scope.closeBriefFx();
      }
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchText = "";
      $scope.templates = {};
      $state.current = toState;
      $scope.contextMenuOpt = [];
      $scope.selectedTab = $state.current.name;
      $scope.curTFolderId = localStorage.getItem("curTFId");

      if($scope.selectedTab != "hub.templates.tl" && $scope.selectedTab != "hub.tContainer.tName" && $scope.selectedTab != "hub.tContainer.tDesign"){
        localStorage.removeItem("curTlId");
      }
      if(toState.name != "hub.templates.t" && !localStorage.getItem("isTmAdvSearch")){
        localStorage.removeItem("isTmAdvSearch");
        localStorage.removeItem("curFilterTmObj");
      }
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      $scope.loadSelectedTab();
    });


    $rootScope.reloadTTree = function(){
      $scope.curTFolderId = localStorage.getItem("curTFId");
      if(!$scope.curTFolderId){
        $scope.curTFolderId = 0;
      }
    }

    $scope.folderContentFx = function(fId, splId, type){
      if($scope.selectedTab === "hub.templates.t"){
        $rootScope.showTimeoutMsg = false;
        $scope.templatesLoading = true;
        $rootScope.selectedItems = [];
        localStorage.removeItem("curPathTId");
        $rootScope.sessionTimoutFx();
        localStorage.removeItem("curTFId");
        $scope.advSearchInfo = {};
        $scope.advSearch = false;
        $scope.curTFolderId = 0;

        if(fId){
          localStorage.setItem("curTFId", fId);
          $scope.curTFolderId = localStorage.getItem("curTFId");
        }
        if($scope.curTFolderId == 0){
          localStorage.setItem("inTFolder", 0);
          localStorage.removeItem("curTPathFId");
        }
        $scope.searchText = "";
        TemplatesSrv.getTemplatesContent($scope.curTFolderId).then(
          function(data){
            $scope.templates = data;
            $scope.updateList();
            $scope.curPathTId = angular.fromJson(localStorage.getItem("curPathTId"));
            if($scope.curPathTId){
              setTimeout(function(){
                angular.forEach(angular.element('.ui-selectable li'), function(item){
                  if($(item).attr('data-id') == $scope.curPathTId){
                    $(item).addClass('ui-highlight');
                  }
                });
              }, 100);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.folderBriefFx = function(obj){ /*Get folder briefs*/
      $scope.templateBtn = [];
      $scope.templateBrief = [];
      $scope.contextMenuOpt = [];
      $timeout.cancel($scope.promise);
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      TemplatesSrv.getFolderBrief(obj[0].id, obj[0].splId, obj[0].type).then(
        function(data){
          $scope.templateBrief = data;
          if($scope.selectedTab === "hub.templates.t" && obj[0].type != "folder"){/*Button api*/
            $scope.getBtnFx("t");
          }
        },
        function(err){
          $log.error(err);
        }
      );
      /*Button api*/
      if($scope.selectedTab === "hub.templates.t" && obj[0].type == "folder"){
        $scope.getBtnFx("t");
      }
    }

    $scope.briefFx = function(selectedItems){ /*Get template brief*/
      $scope.encId = $scope.hubEncrypt(selectedItems[0].id);
      $scope.templateBtn = [];
      $scope.templateBrief = [];
      $scope.contextMenuOpt = [];
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if($scope.selectedTab == "hub.templates.tl"){
        var filtered = $filter("filter")($scope.templates.templates, {id:$scope.selectedItems[0].id}, true);
        var isUseBtn = false;
        if(filtered[0].content && $scope.auth.upermissions.c && $scope.auth.upermissions.cf){
          isUseBtn = true;
        } else if(!filtered[0].content && filtered[0].widget && $scope.auth.upermissions.w){
          isUseBtn = true;
        } else if(!filtered[0].content && !filtered[0].widget){
          isUseBtn = true;
        }
        if($scope.auth.upermissions.t){
          $scope.filterIncompleted = $filter("filter")($scope.templates.templates, {id:$scope.selectedItems[0].id, thumb:""}, true).length;
          if($scope.auth.uType == 0 || $scope.auth.uType == 1){
            $scope.templateBtn = {"buttons":[{key:"tDelete"}]};
            if($scope.filterIncompleted == 0 && isUseBtn){
              $scope.templateBtn.buttons.unshift({key:"tlUse"});
            }
            if($scope.selectedItems.length == 1){
              $scope.templateBtn.buttons.unshift({"key":"tEdit", "label":"Edit", "steps":[{key:"tStep1"}, {key:"tStep2"}]});
            }
          } else if(isUseBtn){
            $scope.templateBtn = {buttons:[{key:"tlUse"}]};
          } else{
            $scope.templateBtn = {buttons:[], info:[{key:"tlUse", code:2002101}]};
          }
          $scope.btnLoading = false;
          if(selectedItems.length > 1){
            $scope.templateBtn = {buttons:[], info:[{key:"tlUse", code:2002105}]};
          }
        } else{
          $scope.templateBtn = {buttons:[], info:[{key:"tlUse", code:2002101}]};
          $scope.btnLoading = false;
        }
        $scope.updateContextMenu($scope.templateBtn);
      } else{
        if(selectedItems.length == 1){
          TemplatesSrv.getTemplateBrief(selectedItems[0].id).then(
            function(data){
              $scope.templateBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        TemplatesSrv.saveTemplateBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.templateBtn = data;
            $scope.updateContextMenu($scope.templateBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/templates/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.getBtnFx = function(caller){/*Button api*/
      if(caller == "t"){
        TemplatesSrv.saveTemplateBtn($rootScope.selectedItems).then(
          function(data){
            $scope.templateBtn = data;
            $scope.updateContextMenu($scope.templateBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function(menuItem){
        if(menuItem.key == "tOpen"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
        } else if(menuItem.key == "tEdit" || menuItem.key == "sEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
        } else if(menuItem.key == "tEditDText"){
          $scope.menuItemLabel = $filter("translate")('t.btn.4'); //menuItem.label;
        } else if(menuItem.key == "tMove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.50'); //menuItem.label;
        } else if(menuItem.key == "tDuplicate"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.30');
        } else if(menuItem.key == "tDownload"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.49');
        } else if(menuItem.key == "tSchedule"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.27');
        } else if(menuItem.key == "tAddToSchedule"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.28');
        } else if(menuItem.key == "tApprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.24');
        } else if(menuItem.key == "tUnapprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.25');
        } else if(menuItem.key == "tDelete" || menuItem.key == "sDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key == "tlUse"){
          $scope.menuItemLabel = $filter("translate")('t.btn.2');
        } else if(menuItem.key == "tlOpen"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.8');
        } else if(menuItem.key == "tPin"){
          $scope.menuItemLabel = $filter("translate")('cm.label.98');
        }

        $scope.curIndex = $scope.contextMenuOpt.length;
        $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
        if(menuItem.key == "tEdit"){
          $scope.tempSubMenu = [];
          if(menuItem && menuItem.steps){
            angular.forEach(menuItem.steps, function(subMenuItem){
              if(subMenuItem.key == "tStep1"){
                $scope.subMenu = $filter("translate")("cm.btn.40");
              } else if(subMenuItem.key == "tStep2"){
                $scope.subMenu = $filter("translate")("t.btn.3");
              }
              $scope.tempSubMenu.push([$scope.subMenu, function($itemScope){$scope.contextMenuFx(subMenuItem);}]);
            });
            $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
          }
        }
      });
    }
    $scope.contextMenuFx = function(menuItem){
      if(menuItem.key == "tOpen"){
        $scope.openFolderFx('t', $rootScope.selectedItems[0].id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type);
      } else if(menuItem.key == "tEdit" || menuItem.key == "tStep1"){
        $scope.editFx('tName');
      } else if(menuItem.key == "tStep2"){
        $scope.editFx('tDesign');
      } else if(menuItem.key == "tEditDText"){
        $scope.dTextEditOpen();
      } else if(menuItem.key == "tDuplicate"){
        $scope.duplicateFx();
      } else if(menuItem.key == "tMove"){
        $scope.moveOpen();
      } else if(menuItem.key == "tDuplicate"){
        $scope.duplicateFx();
      } else if(menuItem.key == "tDownload"){
        $scope.dExcelOpen();
      } else if(menuItem.key == "tSchedule"){
        $scope.scheduleFx();
      } else if(menuItem.key == "tAddToSchedule"){
        $scope.addToScheduleOpen();
      } else if(menuItem.key == "tApprove"){
        $scope.approveTemplateFx();
      } else if(menuItem.key == "tUnapprove"){
        $scope.confirmTemplateOpen('unapprove');
      } else if(menuItem.key == "tDelete"){
        $scope.confirmTemplateOpen('delete');
      } else if(menuItem.key == "tlUse"){
        $scope.useTemplateFx();
      } else if(menuItem.key == "tlOpen"){
        $scope.openFolderFx("tl", localStorage.getItem("curTlId"));
      } else if(menuItem.key == "sEdit" || menuItem.key == "sStep1"){
        $scope.editFx('tName');
      } else if(menuItem.key == "sStep2"){
        $scope.editFx('sDesign');
      } else if(menuItem.key == "sDelete"){
        $scope.confirmTemplateOpen('sDelete');
      } else if(menuItem.key == "tPin"){
        $scope.pinToDBFx($rootScope.selectedItems, "t");
      }
    }

    /*ContextMenu*/
    $scope.contextMenuBaseFx = function(){
      $scope.contextMenuBase = [];
      $scope.contextMenuFolder = [];
      if(($scope.auth.upermissions.t && $scope.auth.upermissions.art) || ($scope.auth.upermissions.t && (!$scope.auth.upermissions.art && $scope.curTFolderId != 0))){
        $scope.contextMenuBase.push([$filter("translate")("t.btn.1"), function($itemScope){$state.go("hub.tContainer.tName", {type:$scope.encType});}]);
      }
      if(($scope.auth.upermissions.tf && $scope.auth.upermissions.art) || ($scope.auth.upermissions.tf && (!$scope.auth.upermissions.art && $scope.curTFolderId != 0))){
        $scope.contextMenuBase.push([$filter("translate")('cl.btn.3'), function($itemScope){$scope.folderCUOpen('n');}]);
      }
    }


    $scope.editFx = function(caller){
      if($rootScope.selectedItems[0].type == "folder"){
        $scope.folderCUOpen('n', "edit");
      } else if(caller == "tName"){
        if($scope.selectedTab == "hub.templates.tl"){
          $state.go("hub.tContainer.tName", {type:$scope.hubEnc("l"), id:$scope.encId});
        } else if($scope.selectedTab == "hub.templates.it"){
          $state.go("hub.tContainer.tName", {type:$scope.hubEnc("it"), id:$scope.encId});
        } else{
          $state.go("hub.tContainer.tName", {type:$scope.hubEnc("t"), id:$scope.encId});
        }
      } else if(caller == "tDesign"){
        if($scope.selectedTab == "hub.templates.tl"){
          $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("l"), id:$scope.encId});
        } else if($scope.selectedTab == "hub.templates.it"){
          $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("it"), id:$scope.encId});
        } else{
          $state.go("hub.tContainer.tDesign", {type:$scope.hubEnc("t"), id:$scope.encId});
        }
      }
    }

    /*Template Action Button*/
    $scope.confirmTemplateOpen = function(action){
      $scope.isConfirmOpen = true;
      $scope.dataObj = {action:action};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dataObj.action==\'unapprove\'">{{selectedItems.length > 1?"t.msg.6s":"t.msg.6" | translate}}</span>\
              <span ng-if="dataObj.action==\'delete\'">{{selectedItems.length > 1?"t.msg.7s":"t.msg.7" | translate}}</span>\
              <span ng-if="dataObj.action==\'category\'">{{"fl.msg.16" | translate}}</span>\
              <span ng-if="dataObj.action==\'sDelete\'">{{selectedItems.length > 1?"t.msg.24s":"t.msg.24" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-warning btn-sm" ng-class="{\'btn-danger\':dataObj.action!=\'unapprove\'}" ng-click="confirmTemplateFx();" ng-disabled="templateProcessing"><span class="fa fa-repeat fa-spin" ng-if="templateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.confirmTemplateFx = function(){ /* Delete and Unapproved */
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      $scope.templateProcessing = true;
      if($scope.dataObj.action == "delete" || $scope.dataObj.action == "sDelete"){
        $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
        if($scope.selectedTab == "hub.templates.tl"){
          TemplatesSrv.deleteLibrary($scope.stringIds).then(
            function(data){
              $scope.templateProcessing = false;
              ngDialog.close();
              $scope.loadSelectedTab();
            },
            function(err){
              $scope.templateProcessing = false;
              $log.error(err);
            }
          );
        } else{
          $scope.sendObj = {templateIds:"", folderIds:"", status:2};
          angular.forEach($rootScope.selectedItems, function(item){
            if($filter("lowercase")(item.type) == "template"){
              if($scope.sendObj.templateIds.length > 0){
                $scope.sendObj.templateIds += "," + item.id.toString();
              } else{
                $scope.sendObj.templateIds = item.id.toString();
              }
            } else if($filter("lowercase")(item.type) == "folder"){
              if($scope.sendObj.folderIds.length > 0){
                $scope.sendObj.folderIds += "," + item.id.toString();
              } else{
                $scope.sendObj.folderIds = item.id.toString();
              }
            }
          });
          TemplatesSrv.deleteFT($scope.sendObj).then(
            function(data){
              $scope.templateProcessing = false;
              ngDialog.close();
              $scope.loadSelectedTab();
            },
            function(err){
              $scope.templateProcessing = false;
              $log.error(err);
            }
          );
        }
      } else if($scope.dataObj.action == "category"){
        $scope.deleteTLCategory($scope.templates.info.id);
      } else if($scope.dataObj.action == "unapprove"){
        $scope.sendObj = {templateIds:[], folderIds:[]};
        angular.forEach($rootScope.selectedItems, function(item){
          if($filter("lowercase")(item.type) == "template"){
            $scope.sendObj.templateIds.push(item.id);
          } else if($filter("lowercase")(item.type) == "folder"){
            $scope.sendObj.folderIds.push(item.id);
          }
        });
        TemplatesSrv.updateUnapproveTemplate($scope.sendObj).then(
          function(data){
            $scope.templateProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.templateProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.approveTemplateFx = function(){
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      $scope.sendObj = {templateIds:[], folderIds:[]}
      angular.forEach($rootScope.selectedItems, function(item){
        if($filter("lowercase")(item.type) == "template"){
          $scope.sendObj.templateIds.push(item.id);
        } else if($filter("lowercase")(item.type) == "folder"){
          $scope.sendObj.folderIds.push(item.id);
        }
      });
      TemplatesSrv.updateApproveTemplate($scope.sendObj).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.deleteTLCategory = function(id){
      TemplatesSrv.deleteCategory(id).then(
        function(data){
          ngDialog.close();
          $scope.templateProcessing = false;
          $scope.loadSelectedTab('home');
        },
        function(err){
          $scope.templateProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.moveOpen = function(caller){
      $rootScope.curFType = "move";
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      $scope.folderListStr = "";
      angular.forEach($scope.selectedItems, function(item){
        if(item.type == "folder" || item.type == "shortcut"){
          if($scope.folderListStr == ""){
            $scope.folderListStr = "/" + item.id;
          } else{
            $scope.folderListStr += "," + item.id;
          }
        }
      });
      $scope.curMoveObj = [];
      TemplatesSrv.getMoveTree($scope.folderListStr).then(
        function(data){
          $scope.moveObj = {type:"move", server:null, curServerTree:data.tree};
          ngDialog.open({
            template:"app/templates/popup/move.html",
            width:580,
            scope:$scope,
            data:$scope.moveObj,
            closeByDocument:false,
            controller:"MoveTController"
          });
        }
      );
    }

    $scope.scheduleListFx = function(id, label){
      $scope.popupLabel = label;
      $scope.scheduleList = [];
      TemplatesSrv.getScheduleList(id).then(
        function(data){
          $scope.scheduleList = data;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/templates/popup/scheduleList.html',
        width:800,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.addToScheduleOpen = function(){
      $scope.scheduleList = {};
      SchedulesSrv.getAddToSchedules($rootScope.selectedItems, "t").then(
        function(data){
          $scope.scheduleList = data;
          $scope.selectedSch = data.filter(function(item){
            return item.isChecked == true;
          }).map(function(item){
            return item.id;
          });
          ngDialog.open({
            template:"app/common/popup/addToSchedule.html",
            width:800,
            scope:$scope,
            closeByDocument:false,
            controller:"AddtoScheduleController",
            preCloseCallback:function(){
              $scope.saveProcessing = false;
              $scope.hasErr = false;
              $scope.errType = "";
            }
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editScheduleFx = function(id, step){
      ngDialog.close();
      if(!step){
        if($scope.auth.upermissions.se.np){
          $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.s){
          $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.c){
          $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.f){
          $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        }
      } else if(step == "np"){
        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "s"){
        $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "c"){
        $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "d"){
        $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "f"){
        $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      }
    }

    $scope.duplicateFx = function(){
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      $scope.isConfirmOpen = true;
      $scope.templateProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{selectedItems.length > 1?"t.msg.11s":"t.msg.11" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-click="confirmDuplicateFx();" ng-disabled="templateProcessing"><span class="fa fa-repeat fa-spin" ng-if="templateProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.confirmDuplicateFx = function(){
      $scope.templateProcessing = true;
      $scope.copyObj = {selectedItems:$rootScope.selectedItems, target:$scope.curTFolderId, type:"folder"};
      TemplatesSrv.copy($scope.copyObj).then(
        function(data){
          if(data.status == "success"){
            $scope.templateProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $scope.templateProcessing = false;
          ngDialog.close();
          $log.error(err);
        }
      );
    }

    $scope.scheduleFx = function(){
      $scope.curSelectedItems = [];
      $scope.curSelectedFolders = [];

      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type.toLowerCase() == "folder"){
          $scope.curSelectedFolders.push(item);
        }
      });

      angular.forEach($scope.templateList, function(template){
        angular.forEach($rootScope.selectedItems, function(item){
          if(template.isApproved && template.id == item.id){
            $scope.curSelectedItems.push({
              hidden:0,
              mute:true,
              id:template.id,
              type:"template",
              fullscreen:false,
              tType:template.tType,
              label:template.label,
              thumb:template.thumb,
              thumbV:template.thumbV,
              userid:$scope.auth.uid,
              duration:template.duration
            });
          }
        });
      });

      if($scope.curSelectedItems.length){
        localStorage.setItem("tSchedule", JSON.stringify($scope.curSelectedItems));
      }
      if($scope.curSelectedFolders.length){
        localStorage.setItem("tfSchedule", JSON.stringify($scope.curSelectedFolders));
      }
      localStorage.setItem("tiSchedule", JSON.stringify({tim:$scope.tim, tBucket:$scope.tBucket, mbucket:$scope.tDetailBucket}));
      $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
    };

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/templates/popup/info.html',
        data:$scope.readMeObj,
        scope:$scope,
        width:580
      });
    }

    $scope.useTemplateFx = function(){
      $scope.templateProcessing = false;
      $scope.useBtnLoading = false;
      $scope.isConfirmOpen = true;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.auth.uservices.c){
        $scope.useBtnLoading = true;
        $scope.curMoveObj = [];
        TemplatesSrv.getMoveTree("").then(
          function(dataTF){
            ContentLibrarySrv.getMoveTree("").then(
              function(data){
                $scope.useBtnLoading = false;
                $scope.useTampObj = {name:"", folderName:"", curFolderTree:dataTF.tree, curServerTree:data.tree, permission:{type:$scope.auth.upreferences.defaultP}};
                ngDialog.open({
                  template:"app/templates/popup/useTemplate.html",
                  closeByDocument:false,
                  scope:$scope,
                  width:650,
                  preCloseCallback:function(){
                    $scope.isConfirmOpen = false;
                  }
                });
              }
            );
          }
        );
      } else{
        ngDialog.open({
          template: '\
            <section class="panel" role="dialog">\
              <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.msg.56" | translate}}</h1></header>\
              <div class="panel-body">{{"t.msg.41" | translate}}</div>\
              <div class="panel-footer">\
                <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();">{{"cm.btn.1" | translate}}</button>\
              </div>\
            </section>',
          plain: true,
          width: 480,
          closeByDocument: false,
          className: "ngdialog-theme-default ngdialog-confirm"
        });
      }
    }

    $scope.confirmUseFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.useTampObj.target = $("input[name='treeOpt']:checked").val();
      $scope.useTampObj.targetTF = $("input[name='treeOptTF']:checked").val();
      if($scope.useTampObj.name == ""){
        $scope.hasErr = true;
        $scope.errType = "name";
        $("#name").focus();
      } else if(!$scope.useTampObj.targetTF){
        $scope.hasErr = true;
        $scope.errType = "targetTF";
        // $("#folderName").focus();
      } else if(!$scope.useTampObj.target){
        $scope.hasErr = true;
        $scope.errType = "target";
        // $("#folderName").focus();
      } else{
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveConfirmUseFx();
          }, 250);
        } else{
          $scope.saveConfirmUseFx();
        }
      }
    }

    $scope.saveConfirmUseFx = function(){
      $scope.templateProcessing = true;
      if($scope.useTampObj.folderName == ""){
        $scope.useTampObj.folderName = $scope.useTampObj.name + "-files";
      }
      TemplatesSrv.saveUseTemplates({info:{name:$scope.useTampObj.name, folderName:$scope.useTampObj.folderName, target:$scope.useTampObj.target, targetTF:$scope.useTampObj.targetTF, permission:$scope.useTampObj.permission}, template:$rootScope.selectedItems[0]}).then(
        function(data){
          $scope.templateProcessing = false;
          if(data.code == 9019){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"t.msg.16" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeAllFx();">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm",
              preCloseCallback:function(){
                $scope.isConfirmOpen = false;
              }
            });
          } else if(data.code == 9028){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"t.msg.16-1" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm",
              preCloseCallback:function(){
                $scope.isConfirmOpen = false;
              }
            });
          } else{
            ngDialog.close();
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $scope.templateProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.dTextEditOpen = function(label){
      // console.error(label,"label")
      // console.warn($scope.templateBrief,"IN");
      // $scope.popupLabel = $filter("filter")($scope.templates.templates.template, {id:$rootScope.selectedItems[0].id})[0].label;
      $scope.dTextListProcessing = false;
      $scope.popupLabel = label;
      $scope.dTextList = [];
      $scope.hasErr = false;
      $scope.errType = "";

      TemplatesSrv.getDTextList($rootScope.selectedItems[0].id).then(
        function(data){
          $scope.dTextList = data;
          /* Allow Multiple Text Start*/
          angular.forEach($scope.dTextList.dText, function(item){
            if(item.isMT){
              if(!item.mt.length){
                item.mt.push({t:item.frametext, editText:item.frametext, editing:true});
              }
            }
          });
          /* Allow Multiple Text End*/
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/templates/popup/dTextList.html',
        width:750,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.dTextEditFx = function(){
      if(localStorage.getItem("isTmAdvSearch")){
        localStorage.setItem("isActionOnTemplate", true);
      } else{
        localStorage.removeItem("isActionOnTemplate");
        localStorage.removeItem("curFilterTmObj");
        localStorage.removeItem("isTmAdvSearch");
      }
      
      /* Allow Multiple Text Start*/
      $scope.hasErr = false;
      $scope.errType = "";

      $scope.isMtEditMode = false;
      angular.forEach($scope.dTextList.dText, function(item){
        if(item.isMT){
          if(item.mt.length > 0){
            for(var i=0; i<item.mt.length; i++){
              if(item.mt[i].editing){
                $scope.isMtEditMode = true;
                break;
              }
            }
            for(var i=0; i<item.mt.length; i++){
              if(item.mt[i].dt){
                item.frametext = item.mt[i].t;
                break;
              }
            }
          }
        }
      });
      if($scope.isMtEditMode){
        $scope.hasErr = true;
        $scope.errType = "editMode";
      } else{
        $scope.dTextListProcessing = true;
        TemplatesSrv.saveDTextList($scope.dTextList).then(
          function(data){
            $scope.dTextListProcessing = false;
            if(data.code == 9027){
              ngDialog.close();
            } else{
              $scope.hasErr = true;
              $scope.errType = "data";
            }
          },
          function(err){
            $scope.dTextListProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    /* Allow Multiple Text Start*/
    // Start editing a tag
    $scope.mtActionFx = function(caller, mtItem){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "e"){
        mtItem.editing = true;
        mtItem.editText = mtItem.t;
      } else if(caller == "s"){// Save the edited tag
        if(mtItem.editText && mtItem.editText.trim() !== ''){
          mtItem.t = mtItem.editText.trim();
          delete mtItem.editText;
          delete mtItem.editing;
        } else{
          $scope.hasErr = true;
          $scope.errType = "editEmpty";
        }
      } else if(caller == "c"){// Cancel editing
        if(!mtItem.t && !mtItem.editText && mtItem.editText.trim() == ''){
          $scope.hasErr = true;
          $scope.errType = "editEmpty";
        } else{
          delete mtItem.editText;
          delete mtItem.editing;
        }
      }
    };

    // Handle key events (Enter to save, Escape to cancel)
    $scope.handleKeyDown = function(event, mtItem){
      var key = event.key || event.keyCode;
      if(key === 'Enter' || key === 13){
        $scope.mtActionFx('s', mtItem);
        event.preventDefault();
      } else if(key === 'Escape' || key === 27){
        $scope.mtActionFx('c', mtItem);
      }
    };
    /* Allow Multiple Text End*/


    $scope.dExcelOpen = function(){
      $rootScope.excelOpenObj = {loading:true, url:"", surl:""};
      TemplatesSrv.getDExcel($scope.templateBrief.id).then(
        function(data){
          if(data.url){
            $rootScope.excelOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/templates/popup/dSampleExcel.html",
        width:500,
        scope:$scope,
        data:$scope.excelOpenObj, //{url:url, surl:surl, label:label, type:type, size:size, pSize:pSize},
        closeByDocument:false
      });
    }

    $scope.closeAllFx = function(){
      ngDialog.closeAll();
      $scope.loadSelectedTab();
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen){
        angular.forEach($scope.templateBtn.buttons, function(btn){
          if(btn.key == "tDelete"){
            $scope.isDeletable = true;
          }
        });
        if($scope.isDeletable){
          $scope.confirmTemplateOpen('delete');
        }
      }
    }

    /******Folder*******/
    /*ngDialog*/
    $scope.templateCountFx = function(id){
      $scope.templateCountList = [];
      TemplatesSrv.getTemplateList(id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type).then(
        function(data){
          $scope.templateCountList = data;
          $scope.cBucket = $scope.cDetailBucket = $scope.templateCountList.info.bucket;
          if($scope.templateCountList.info.mbucket && $scope.templateCountList.info.mbucket != ""){
            $scope.cDetailBucket = $scope.templateCountList.info.mbucket;
          }
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/templates/popup/templateList.html',
        width:755,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
      });
    }

    $scope.folderCUOpen = function(type, caller){
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.folderObj = {fType:type};
      if(caller == "edit"){
        $scope.folderObj.label = $scope.templateBrief.label;
        $scope.folderObj.id = $scope.templateBrief.id;
      } else{
        $scope.folderObj.fid = $scope.curTFolderId;
      }
      ngDialog.open({
        template:"app/templates/popup/folderCU.html",
        width:620,
        scope:$scope,
        data:$scope.folderObj,
        closeByDocument:false,
        controller:"TFolderCUController",
      });
    }
    $scope.countListFx = function(id, name, label, schedule){
      $scope.popupLabel = label;
      $scope.expType = name;
      $scope.countList = [];
      $scope.dataObj = {id:id, name:name, label:label};
      $scope.scheduleObj = {id:id, name:name, label:label, schedule:schedule};
      $scope.filtered = {a:[], i:[]};
      if(name == 'schedule'){
        $scope.isSorted = false;
        $scope.popupLoading = true;
        $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
        if(schedule.a){
          TemplatesSrv.getActiveSchedule(id).then(
            function(data){
              if(!schedule.i){
                $scope.popupLoading = false;
              }
              $scope.countList.info = data.info;
              $scope.countList.schedules.a = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.a = $scope.countList.schedules.a;
            },
            function(err){
              $scope.popupLoading = false;
              $log.error(err);
            }
          );
        }
        if(schedule.i){
          TemplatesSrv.getInactiveSchedule(id).then(
            function(data){
              $scope.popupLoading = false;
              $scope.countList.info = data.info;
              $scope.countList.schedules.i = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.i = $scope.countList.schedules.i;
            },
            function(err){
              $scope.popupLoading = false;
              $log.error(err);
            }
          );
        }

        ngDialog.open({
          template:'app/templates/popup/scheduleList.html',
          width:800,
          scope:$scope,
          data:$scope.dataObj,
          closeByDocument:false,
        });
      }
    }
    $scope.refreshPopupListFx = function(){
      $scope.popupLoading = true;
      $scope.loading = true;
      $scope.popupLabel = $scope.scheduleObj.label;
      $scope.expType = $scope.scheduleObj.name;
      $scope.countList = [];
      $scope.filtered = {a:[], i:[]};

      $scope.isSorted = false;
      $scope.popupLoading = true;
      $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
      if($scope.scheduleObj.schedule.a){
        TemplatesSrv.getActiveSchedule($scope.scheduleObj.id).then(
          function(data){
            if(!$scope.scheduleObj.schedule.i){
              $scope.popupLoading = false;
              $scope.loading = false;
            }
            $scope.countList.info = data.info;
            $scope.countList.schedules.a = data.schedules;
            $scope.countList.framelayout = data.framelayout;
            $scope.filtered.a = $scope.countList.schedules.a;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
      if($scope.scheduleObj.schedule.i){
        TemplatesSrv.getInactiveSchedule($scope.scheduleObj.id).then(
          function(data){
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.countList.info = data.info;
            $scope.countList.schedules.i = data.schedules;
            $scope.countList.framelayout = data.framelayout;
            $scope.filtered.i = $scope.countList.schedules.i;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }
    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.templateList = args.template;
      $scope.folderList = args.folder;
      $scope.templates.templates.template = args.template;
      $scope.templates.templates.folder = args.folder;
      $scope.advSearchInfo = args.info;
      $scope.advObj = args.advObj;
      $scope.advSearch = true;
      if($scope.isActionOnTemplate || $scope.groupType == "type"){
        $scope.updateList();
      }
      if(args.code == 8118){
        $scope.loadSelectedTab();
      }
    });

    /*Advanced Search*/
    $scope.advancedSearchTempOpen = function(caller, step, id){
      localStorage.removeItem("curPathTId");
      localStorage.removeItem("curTemplateId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.advSearchObj = {caller:caller, step:step};
      $scope.redirectFolderId = localStorage.getItem("curTFId");
      if($scope.redirectFolderId != 0){
        localStorage.setItem("curTFId", 0);
        $scope.curTFolderId = 0;
        $scope.loadSelectedTab();
      }
      ngDialog.open({
        template:"app/common/popup/advancedSearch.html",
        width:1024,
        scope:$scope,
        data:$scope.advSearchObj,
        closeByEscape:false,
        closeByDocument:false,
        controller:"AdvancedSearchController",
        preCloseCallback:function(caller){
          if(caller == "close" && $scope.redirectFolderId != 0){
            localStorage.setItem("curTFId", $scope.redirectFolderId);
            $scope.curTFolderId = localStorage.getItem("curTFId");
            $scope.loadSelectedTab();
          }
        }
      });
    }

    // setTimeout(function(){
    //   var tabIndex = 17;
    //   $(".tabIndex:not(:hidden)").each(function(i){
    //     $(this).attr('tabindex', tabIndex);
    //     tabIndex++;
    //   });
    // }, 5000);

    $scope.$on('folderBriefFx',function(event, data){
      $scope.folderBriefFx(data);
    });

    $scope.$on('briefFx',function(event, data){
      $scope.briefFx(data);
    });
  }
})();

angular.module('hub').service('UsersSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
    var httpReq;
    this.getActive = function(caller){
      if(caller){
        httpReq = $http.get($rootScope.apiHost + "users/"+ caller + "?" + new Date().getTime());
      } else{
        httpReq = $http.get($rootScope.apiHost + "users/?" + new Date().getTime());
      }
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getGroups = function(){
      httpReq = $http.get($rootScope.apiHost + "users/groups?" + new Date().getTime());
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getUnapproved = function(){
      httpReq = $http.get($rootScope.apiHost + "users/unapproved?" + new Date().getTime());
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getInactive = function(){
      httpReq = $http.get($rootScope.apiHost + "users/inactive?" + new Date().getTime());
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getRoles = function(){
      httpReq = $http.get($rootScope.apiHost + "users/roles?" + new Date().getTime());
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getUsers = function(){
      httpReq = $http.get($rootScope.apiHost + "users/dmb/users?" + new Date().getTime());
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Get Brief*/
    this.getUserBrief = function(userId){
      httpReq = $http.get($rootScope.apiHost + "users/briefs/" + userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getUserGroupBrief = function(userId){
      httpReq = $http.get($rootScope.apiHost + "users/groups/briefs/" + userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Get Count list*/
    this.getUserCountList = function(id){
      httpReq = $http.get($rootScope.apiHost + "users/groups/userList/"+ id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getRoleUserList = function(id){
      httpReq = $http.get($rootScope.apiHost + "users/roles/userList/"+ id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getDevice = function(uid){
      httpReq = $http.get($rootScope.apiHost + "users/devices?uid=" + uid);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    this.updateSendPassword = function(userId){
      httpReq = $http.get($rootScope.apiHost + "users/sendPassword/" + userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    this.updateAddToGroup = function(grpObj){
      httpReq = $http.put($rootScope.apiHost + "users/addtoGroup", grpObj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    this.exportUsers = function(){
      httpReq = $http.get($rootScope.apiHost + "users/export");
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.loadMoreLogs = function(dateObj){
      httpReq = $http.get($rootScope.apiHost + "users/logs/"+ dateObj.uid +"/"+ dateObj.offset);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.saveLogs = function(dateObj){
      httpReq = $http.post($rootScope.apiHost + "dashboard/logs", dateObj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Get user group list for permission*/
    this.getDefaultPermissions = function(id){
      httpReq = $http.get($rootScope.apiHost + "users/defaultPermissions/"+id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    
    this.getAvailAndAssinDevices = function(id){
      httpReq = $http.get($rootScope.apiHost + "users/dmb/users/devices/" + id);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    // this.saveAvailAndAssinDevices = function(obj){
    //   httpReq = $http.post($rootScope.apiHost + "users/dmb/users/devices", obj);
    //   return httpReq.then(this.handleSuccess, this.handleError);
    // }
    this.saveAvailAndAssinDevices = function(uid, obj){
      httpReq = $http.post($rootScope.apiHost + "users/dmb/users/"+uid+"/devices", obj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Get Buttons*/
    this.getUserBtn = function(userId){
      httpReq = $http.post($rootScope.apiHost + "action/users", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.getUserGroupBtn = function(userId){
      httpReq = $http.post($rootScope.apiHost + "action/userGroups", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Button Action*/
    this.saveInviteAgain = function(userObj){
      httpReq = $http.put($rootScope.apiHost + "users/inviteAgain", userObj);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.updateActivateUser = function(userId){
      httpReq = $http.put($rootScope.apiHost + "users/activate", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.updateDeactivateUser = function(userId){
      httpReq = $http.put($rootScope.apiHost + "users/deactivate", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.updateApproveUser = function(userId){
      httpReq = $http.put($rootScope.apiHost + "users/approve", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.updateUnapproveUser = function(userId){
      httpReq = $http.put($rootScope.apiHost + "users/unapproveUser", userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.updatePrimaryGroup = function(primGrp){
      httpReq = $http.put($rootScope.apiHost + "users/primaryGroup", primGrp);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.mbAdmin = function(mbAdmin){
      httpReq = $http.put($rootScope.apiHost + "users/dmb/admin", mbAdmin);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    /*Delete*/
    this.deleteUsers = function(userId){
      httpReq = $http.delete($rootScope.apiHost + "users/"+userId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.deleteGroups = function(grpId){
      httpReq = $http.delete($rootScope.apiHost + "users/groups/"+grpId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }
    this.deleteRoles = function(roleId){
      httpReq = $http.delete($rootScope.apiHost + "users/roles/"+roleId);
      return httpReq.then(this.handleSuccess, this.handleError);
    }

    this.handleSuccess = function(response){
      if(response.data.code == 13022){
        $rootScope.toastNotificationFx("info", response.data, response.data.email);
      }
      else{
        $rootScope.toastNotificationFx("info", response.data);
      }
      return (response.data);
    }
    this.handleError = function(response){
      $rootScope.toastNotificationFx("danger", {"code":5000});
      if(!angular.isObject(response.data) || !response.data.message){
        return ($q.reject("An unknown error occurred."));
      }
      return ($q.reject(response.data.message));
    }
}]);
angular.module('hub').service('UserGrpCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getUserGrpDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "users/groups/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUserGrpHierarchy = function(id){
    httpReq = $http.get($rootScope.apiHost + "users/groups/hierarchy/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUserGrp = function(obj){
    httpReq = $http.post($rootScope.apiHost + "users/groups", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('UserCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getUserDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "users/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUser = function(obj){
    httpReq = $http.post($rootScope.apiHost + "users/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('RoleCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getRoleDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "users/roles/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUserRole = function(obj){
    httpReq = $http.post($rootScope.apiHost + "users/roles", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular
  .module('hub').directive('ngUserList', function(){
    return {
      restrict:'E',
      templateUrl:'app/users/dir/userList.html'
    }
  });
angular
  .module('hub').directive('ngUserBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/users/dir/userBrief.html'
    }
  });
angular.module('hub').directive('ngAddToGroup', function(){
  return {
    restrict:'E',
    controller:"AddToGroupController",
    templateUrl:'app/users/dir/addToGroup.html'
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('UsersController', UsersController);

  /** @ngInject */
  function UsersController($log, $rootScope, $sce, $scope, $state, $cookies, $filter, $window, ngDialog, DashboardSrv, CommonSrv, SettingsSrv, UsersSrv, DevicesSrv){
    $rootScope.selectedMenu = 6;
    $scope.dmbNewUser = {label:"", email:"", pwd:"", sid:$scope.auth.server, brand:"", devices:[]};
    $scope.selectedTab = $state.current.name;
    $scope.saveProcessing = false;
    $scope.userProcessing = false;
    $scope.isConfirmOpen = false;
    $scope.usersLoading = true;
    $scope.uGEditOption = [];
    $scope.uEditOption = [];
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $scope.curUser = {};
    $scope.encId = "";
    $scope.decId = "";
    $scope.users = {};

    $scope.loadSelectedTab = function(caller){
      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        localStorage.removeItem("userGroupId");
        localStorage.removeItem("aId");
        angular.element('.ui-selectable li').removeClass('ui-highlight');
        localStorage.removeItem("curRoleId");
        angular.element('.roleList').removeClass('div-highlight');
      }
      $rootScope.selectedItems = [];
      $scope.searchText = "";
      $scope.users = {};
      if($scope.selectedTab === "hub.users.au"){
        $scope.usersLoading = true;
        UsersSrv.getActive().then(
          function(data){
            if($scope.selectedTab === "hub.users.au"){
              $scope.users = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.aId = angular.fromJson(localStorage.getItem("aId"));
              if($scope.aId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.aId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.ug"){
        $scope.usersLoading = true;
        UsersSrv.getGroups().then(
          function(data){
            if($scope.selectedTab === "hub.users.ug"){
              $scope.users = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.userGroupId = angular.fromJson(localStorage.getItem("userGroupId"));
              if($scope.userGroupId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.userGroupId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.uu"){
        $scope.usersLoading = true;
        UsersSrv.getUnapproved().then(
          function(data){
            if($scope.selectedTab === "hub.users.uu"){
              $scope.users = data;
              $scope.updateList();
              $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.bu"){
        $scope.usersLoading = true;
        UsersSrv.getInactive().then(
          function(data){
            if($scope.selectedTab === "hub.users.bu"){
              $scope.users = data;
              $scope.updateList();
              $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.rr"){
        $scope.usersLoading = true;
        UsersSrv.getRoles().then(
          function(data){
            if($scope.selectedTab === "hub.users.rr"){
              $scope.users = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curRoleId = angular.fromJson(localStorage.getItem("curRoleId"));
              if($scope.curRoleId){
                setTimeout(function(){
                  angular.forEach(angular.element('.roleList'), function(item){
                    if($(item).attr('data-id') == $scope.curRoleId){
                      $(item).addClass('div-highlight');
                    }
                  });
                }, 1000);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.mb"){ //MB code
        $scope.curDSelected = [];
        $scope.usersMBLoading = true;
        $scope.hasErrPop = false;
        $scope.errTypePop = "";

        if($scope.selectedT == 1){
          UsersSrv.getActive("dmb").then(
            function(data){
              if($scope.selectedTab === "hub.users.mb" && $scope.selectedT == 1){
                $scope.usersMBLoading = false;
                $scope.users = data;
                $scope.updateList();
                $scope.loadingMain = false;
              }
            },
            function(err){
              $scope.loadingMain = false;
              $scope.usersMBLoading = false;
              $log.error(err);
            }
          );
        } else{
          UsersSrv.getUsers().then(
            function(data){
              if($scope.selectedTab === "hub.users.mb" && $scope.selectedT != 1){
                $scope.usersMBLoading = false;
                $scope.users = data;
                $scope.updateList();
                $scope.loadingMain = false;
              }
            },
            function(err){
              $scope.loadingMain = false;
              $scope.usersMBLoading = false;
              $log.error(err);
            }
          );
        }
      }
    }
    $scope.loadSelectedTab();

    $rootScope.selectedTabFx = function(){
      $scope.hasErr = false;
      $scope.searchText = "";
      $scope.loadSelectedTab();
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      localStorage.removeItem("userGroupId");
      localStorage.removeItem("aId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.updateList = function(){
      $scope.usersLoading = false;
      if($scope.users.info){
        $scope.tim = $scope.users.info.timthumb;
        $scope.bucket = $scope.detailBucket = $scope.users.info.bucket;
        if($scope.users.info.mbucket && $scope.users.info.mbucket != ""){
          $scope.detailBucket = $scope.users.info.mbucket;
        }
      }
      // $scope.tabIndexFx("u");
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchText = "";
      $state.current = toState;
      $scope.contextMenuOpt = [];
      $scope.selectedTab = $state.current.name;
      localStorage.removeItem("userGroupId");
      localStorage.removeItem("aId");
      localStorage.removeItem("curRoleId");
      $scope.loadSelectedTab();
      $scope.contextMenuBaseFx();
    });

    $scope.briefFx = function(selectedItems){ /*Get User brief*/
      $scope.encId = $scope.hubEncrypt(selectedItems[0].id);
      $scope.userBtn=[];
      $scope.userBrief=[];
      $scope.contextMenuOpt=[];
      localStorage.removeItem("userGroupId");
      localStorage.removeItem("aId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if($scope.selectedTab == "hub.users.ug"){
        if(selectedItems.length == 1){
          UsersSrv.getUserGroupBrief(selectedItems[0].id).then(
            function(data){
              $scope.userBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        UsersSrv.getUserGroupBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.userBtn = data;
            $scope.updateContextMenu($scope.userBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        if(selectedItems.length == 1){
          UsersSrv.getUserBrief(selectedItems[0].id).then(
            function(data){
              $scope.userBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        UsersSrv.getUserBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.userBtn = data;
            $scope.updateContextMenu($scope.userBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/users/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }
    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function(menuItem){
        if(menuItem.key == "uInviteAgain"){
          $scope.menuItemLabel = $filter("translate")('u.btn.6'); //menuItem.label;
        } else if(menuItem.key=="uEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key=="uGroup"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.29');
        } else if(menuItem.key=="uInactive"){
          $scope.menuItemLabel = $filter("translate")('u.btn.8');
        } else if(menuItem.key=="uApprove"){
          $scope.menuItemLabel=menuItem.label;
        } else if(menuItem.key=="uActive"){
          $scope.menuItemLabel = $filter("translate")('u.btn.9');
        } else if(menuItem.key=="uDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key=="uGEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key=="uGDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        }

        if(menuItem.key == "uInviteAgain"){
          if($scope.auth.uType != 4){
            $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
          }
        } else{
          $scope.curIndex = $scope.contextMenuOpt.length;
          $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
          if(menuItem.key == "uGEdit"){
            $scope.tempSubMenu = [];
            angular.forEach(menuItem.steps, function(subMenuItem){
              if(subMenuItem.key == "uGStep1"){
                $scope.subMenu = $filter("translate")("cm.brief.1");
              } else if(subMenuItem.key == "uGStep2"){
                $scope.subMenu = $filter("translate")("u.btn.10");
              }
              $scope.tempSubMenu.push([$scope.subMenu, function($itemScope){$scope.contextMenuFx(subMenuItem);}]);
            });
            $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
          }
        }
      });
    }
    $scope.contextMenuFx = function(menuItem){
      if(menuItem.key == "uInviteAgain"){
        $scope.inviteAgainOpen($scope.userBrief.id, $scope.userBrief.email, $scope.userBrief.lang);
      } else if(menuItem.key == "uEdit"){
        $state.go("hub.uContainer.userCU", {id:$scope.hubEncrypt($scope.userBrief.id)});
      } else if(menuItem.key == "uGroup"){
        $scope.addToGrpOpen($scope.userBrief.id);
      } else if(menuItem.key == "uInactive"){
        $scope.confirmOpen('deactivate');
      } else if(menuItem.key == "uApprove"){
        $scope.approveUserFx($scope.userBrief.id);
      } else if(menuItem.key == "uActive"){
        $scope.activateUserFx();
      } else if(menuItem.key == "uDelete"){
        $scope.confirmOpen("inactive");
      } else if(menuItem.key == "uGEdit" || menuItem.key == "uGStep1"){
        $state.go("hub.uContainer.ugName", {id:$scope.hubEncrypt($scope.userBrief.id)});
      } else if(menuItem.key == "uGStep2"){
        $state.go("hub.uContainer.ugUsers", {id:$scope.hubEncrypt($scope.userBrief.id)});
      } else if(menuItem.key == "uGDelete"){
        $scope.confirmOpen('group');
      }
    }
    $scope.contextMenuBaseFx = function(){
      $scope.contextMenuBase = [];
      if($scope.auth.upermissions.u && $scope.selectedTab == "hub.users.au"){
        $scope.contextMenuBase.push([$filter("translate")("u.btn.1"), function($itemScope){$state.go("hub.uContainer.userCU");}]);
      } else if($scope.auth.upermissions.ug && $scope.selectedTab == "hub.users.ug"){
        $scope.contextMenuBase.push([$filter("translate")("u.btn.2"), function($itemScope){$state.go("hub.uContainer.ugName");}]);
      } else if($scope.auth.upermissions.ur && $scope.selectedTab == "hub.users.rr"){
        $scope.contextMenuBase.push([$filter("translate")("u.btn.3"), function($itemScope){$state.go("hub.uContainer.rr");}]);
      }
    }
    $scope.contextMenuBaseFx();

    $scope.exportUsersFx = function(){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      UsersSrv.exportUsers().then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.download, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Action Botton*/
    $scope.activateUserFx = function(){
      UsersSrv.updateActivateUser($rootScope.selectedItems).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.approveUserFx = function(){
      UsersSrv.updateApproveUser($rootScope.selectedItems).then(
        function(data){
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    //ngDialog
    $scope.addToGrpOpen = function(){
      $scope.curGroup = {type:"addGrp"};
      $scope.curGroupIds = $rootScope.selectedItems;
      ngDialog.open({
        template:"app/users/popup/addToGroup.html",
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }

    /*User Logs*/
    $scope.loadMoreLogs = function(caller){
      $scope.dateObj = {uid:$rootScope.selectedItems[0].id, offset:$scope.logObj.logList.length};
      if(caller == "refresh"){
        $scope.logLoading = true;
        $scope.loading = true;
        $scope.allLogsLoaded = false;
        $scope.dateObj.offset = 0;
      }
      if(!$scope.allLogsLoaded){
        UsersSrv.loadMoreLogs($scope.dateObj).then(
          function(data){
            $scope.logLoading = false;
            $scope.loading = false;
            if(data.code == 7002){
              $scope.allLogsLoaded = true;
            } else{
              if(caller == "refresh"){
                $scope.logObj.logList = [];
              }
              $scope.logObj.logList = $scope.logObj.logList.concat(data.logs);
            }
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.userLogOpen = function(label){
      $scope.logObj = {info:{module:"User", label:label, id:$rootScope.selectedItems[0].id}, logList:[]};
      $scope.logLoading = true;
      $scope.loading = false;
      $scope.allLogsLoaded = false;
      $scope.loadMoreLogs();
      ngDialog.open({
        template:"app/common/popup/logList.html",
        width:650,
        scope:$scope,
        data:$scope.logObj,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-logList",
      });
    }
    $scope.downloadLogOpen = function(){
      $scope.saveProcessing = false;
      $scope.hasErr = false;
      $scope.logs = {module:"u", note:true, noteC:"db.msg.14", date:{startDate:moment().subtract(1, "day")._d, endDate:moment()._d}};
      ngDialog.open({
        template:"app/common/popup/downloadLog.html",
        width:500,
        scope:$scope,
        trapFocus:false,
        data:$scope.logs,
        closeByDocument:false
      });
    }
    $scope.logsFx = function(){
      $scope.hasErr = false;
      $scope.saveProcessing = true;
      $scope.logsCopy = angular.copy({uid:$rootScope.selectedItems[0].id, date:{startDate:moment($scope.logs.date.startDate).format("L"), endDate:moment($scope.logs.date.endDate).format("L")}});
      UsersSrv.saveLogs($scope.logsCopy).then(
        function(data){
          if(data.code == 6027){
            $scope.saveProcessing = false;
            $scope.hasErr = true;
          } else{
            $scope.logs.url = data.download;
            $scope.saveProcessing = false;
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.getListData = function(caller){
      $scope.dataLoaded[caller] = true;
      DevicesSrv.getScrollListData($scope.scrollObjDyn[caller]).then(
        function(data){
          if(caller == 'a'){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn[caller] = true;
            } else{
              $scope.haveMoreDataDyn[caller] = false;
            }
            $scope.totalDeviceCount[caller] = data.tc;
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
              if(obj.sel && caller == 'a'){
                obj.disabled = true;
              }
            });
            $scope.scrollDataListDyn[caller] = data.d;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }
          if(caller == 's'){
            $scope.haveMoreDataDyn[caller] = false;
            $scope.totalDeviceCount[caller] = data.d.length;
            var tempArr = [];
            angular.forEach(data.d, function(obj){
              tempArr.push({
                id: Number(obj.split("|")[0]),
                h: obj.split("|")[2],
                l: obj.split("|")[3],
                lp: Number(obj.split("|")[1])
              });
            });            
            $scope.scrollDataListDyn[caller] = tempArr;
            $scope.allScrollDataListDyn[caller] = [];
            $scope.allScrollDataListDyn[caller] =  angular.copy($scope.scrollDataListDyn[caller]);
          }

          $scope.dataLoaded[caller] = false;
          setTimeout(function() {
            if($scope.dataLoaded.a == false && $scope.dataLoaded.s == false){
              $scope.popupLoading = false;
              $scope.$apply();
            }
          }, 0);
        },
        function(err){
          $scope.dataLoaded[caller] = false;
          $log.error(err);
        }
      );
    }

    $scope.deviceListOpen = function(uid, label){
      $scope.selectedUserId = uid;
      $scope.popupLabel = label;
      $scope.deviceListUserObj = {uid:uid, label:label};
      if($scope.selectedT=="1"){
        $scope.deviceList = [];
        ngDialog.open({
          template:"app/users/popup/deviceList.html",
          width:650,
          scope:$scope,
          closeByDocument:false
        });
        $scope.popupLoading = true;
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: 'u', offset: 0, id: uid}
        // UsersSrv.getDevice(uid).then(
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            if(!data.d.length){
              $scope.scrollDataList = [];
            } else{
              $scope.scrollDataList = data.d;
            }
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.popupLoading = false;
            $scope.refreshObj = { l: false, b: true };
          },
          function(err){
            $scope.popupLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.deviceList = [];
        ngDialog.open({
          template:"app/users/popup/selectDevice.html",
          width:650,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-logList",
        });
        $scope.popupLoading = true;
        $scope.dataLoaded = {}
        $scope.scrollObjDyn = {};
        $scope.haveMoreDataDyn = {};
        $scope.scrollDataListDyn = {};
        $scope.allScrollDataListDyn = {};
        $scope.totalDeviceCount = {};
        $scope.selDIds = [];

        $scope.scrollObjDyn.a = {subCaller: "dmbU", caller: "availD", offset: 0, id: $scope.selectedUserId, sortType: "l", sortVal: "asc"}
        $scope.scrollObjDyn.s = {subCaller: "dmbU", caller: "selD", offset: 0, id: $scope.selectedUserId, sortType: "l", sortVal: "asc"}
        $scope.getListData("a");
        $scope.getListData("s");
        // $scope.popupLoading = false;
        
        // $scope.popupLoading = true;
        // UsersSrv.getAvailAndAssinDevices(uid).then(
        //   function(data){
        //     $scope.mbDevice = data;
        //     $scope.popupLoading = false;
        //   },
        //   function(err){
        //     $scope.popupLoading = false;
        //     $log.error(err);
        //   }
        // );
      }
    }

    $scope.saveAvailAndAssinDevicesFx = function(){
      $scope.saveProcessing = true;
      if($scope.assignedDevices.length){
        $scope.auth.server
        $scope.selectedUserId
        var ids = $scope.arraytoStringFx($scope.assignedDevices);
        var finalArr = ids.map(function(did) {
          return $scope.selectedUserId + ',' + did + ',' + $scope.auth.server;
        });
        $scope.mbDeviceObj = finalArr;
      } else{
        $scope.mbDeviceObj = {noData: true}
      }
      console.warn("$scope.mbDeviceObj",$scope.mbDeviceObj);
      // $scope.mbDeviceObj = {uid:$scope.selectedUserId, assigned:$scope.mbDevice.assigned}
      UsersSrv.saveAvailAndAssinDevices($scope.selectedUserId, $scope.mbDeviceObj).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 13051){
            ngDialog.close();
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.groupListOpen = function(){
      $scope.curGroups = {userGroups:$scope.userBrief.userGroups};
      ngDialog.open({
        template:"app/users/popup/groupsList.html",
        width:580,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.primaryGrpOpen = function(){
      $scope.saveProcessing = false;
      $scope.primaryGrp = {};
      $scope.primaryGrp.userGroups = $scope.userBrief.userGroups;

      if($scope.userBrief.primaryGroup){
        $scope.primaryGrp.permission = "c";
        $scope.primaryGrp.userPrimGrp = $scope.userBrief.primaryGroup;
      } else{
        $scope.primaryGrp.permission = "p";
        $scope.primaryGrp.userPrimGrp = $scope.userBrief.userGroups[0];
      }

      ngDialog.open({
        template:"app/users/popup/primaryGrp.html",
        width:580,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.savePrimaryGrpFx = function(){
      $scope.saveProcessing = true;
      $scope.curPrimaryGrp = {userId:$scope.userBrief.id, serverId:$scope.auth.server, primaryGroup:null};
      if($scope.primaryGrp.permission == "c"){
        $scope.curPrimaryGrp.primaryGroup = $scope.primaryGrp.userPrimGrp;
      }
      UsersSrv.updatePrimaryGroup($scope.curPrimaryGrp).then(
        function(data){
          if(data.code == 13019){
            UsersSrv.getUserBrief($scope.userBrief.id).then(
              function(data){
                $scope.userBrief = data;
                if($scope.auth.uType === 4){
                  $scope.auth = angular.fromJson(localStorage.getItem("auth"));
                  if($scope.userBrief.userGroups == null){
                    $scope.auth.upreferences.defaultP = "p";
                  } else if($scope.userBrief.userGroups && $scope.userBrief.primaryGroup == null){
                    $scope.auth.upreferences.defaultP = "i";
                  } else if($scope.userBrief.userGroups && $scope.userBrief.primaryGroup){
                    if($scope.userBrief.userGroups.length > 1){
                      $scope.auth.upreferences.defaultP = "c";
                    } else{
                      $scope.auth.upreferences.defaultP = "i";
                    }
                  }
                  localStorage.setItem('auth', JSON.stringify($scope.auth));
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.inviteAgainOpen = function(id, email, lang){
      $scope.saveProcessing = false;
      $scope.inviteObj = {id:id, email:email, lang:lang};
      ngDialog.open({
        template:"app/users/popup/inviteAgain.html",
        width:580,
        scope:$scope,
        data:$scope.inviteObj,
        closeByDocument:false,
      });
    }
    $scope.inviteAgainFx = function(){
      $scope.saveProcessing = true;
      $scope.userObj = {invitingId:$scope.inviteObj.id, lang:$scope.inviteObj.lang};
      UsersSrv.saveInviteAgain($scope.userObj).then(
        function(data){
          ngDialog.close();
          $scope.userBrief.lang = $scope.inviteObj.lang;
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.userCountListFx = function(id, label){
      $scope.popupLabel = label;
      $scope.userCountObj = {id:id, label:label};
      $scope.countList = {};
      UsersSrv.getUserCountList(id).then(
        function(data){
          $scope.countList = data;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/users/popup/countList.html",
        width:680,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.scrollPos = 0;
    $scope.roleUserListFx = function(id, label){
      $scope.roleUserObj = {id:id, label:label};
      $scope.scrollPos = $("body").scrollTop();
      $scope.countList = {info:"", user:""};
      $scope.popupLabel = label;
      localStorage.removeItem("curRoleId");
      angular.element('.roleList').removeClass('div-highlight');

      UsersSrv.getRoleUserList(id).then(
        function(data){
          $scope.countList.user = data;
          $scope.curLabel = $filter("filter")($scope.users.roles, {id:id}, true);
          $scope.countList.info = {label:$scope.curLabel[0].role};
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/users/popup/roleUserList.html",
        width:680,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          setTimeout(function(){
            $window.scrollTo(0, $scope.scrollPos);
          }, 800);
        }
      });
    }


    $scope.refreshPopupListFx = function(caller){
      $scope.loading = true;

      $scope.countList = {};
      if(caller === 'count'){
        $scope.popupLabel = $scope.userCountObj.label;
        UsersSrv.getUserCountList($scope.userCountObj.id).then(
          function(data){
            $scope.countList = data;
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
      if(caller === 'roleUser'){
        $scope.scrollPos = $("body").scrollTop();
        $scope.countList = {info:"", user:""};
        $scope.popupLabel = $scope.roleUserObj.label;
        UsersSrv.getRoleUserList($scope.roleUserObj.id).then(
          function(data){
            $scope.countList.user = data;
            $scope.loading = false;
            $scope.curLabel = $filter("filter")($scope.users.roles, {id:$scope.roleUserObj.id}, true);
            $scope.countList.info = {label:$scope.curLabel[0].role};
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
      if(caller === 'device'){
        $scope.deviceList = [];

        $scope.popupLoading = true;
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: 'u', offset: 0, id: $scope.deviceListUserObj.uid}
        // UsersSrv.getDevice($scope.deviceListUserObj.uid).then(
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            if(!data.d.length){
              $scope.scrollDataList = [];
            } else{
              $scope.scrollDataList = data.d;
            }
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.refreshObj.l = false;
            if(!$scope.scrollDataList.length){
              $scope.refreshObj.b = false;
            }
            $scope.popupLoading = false;
            $scope.loading = false;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.editRole = function(roleId){
      $scope.encId = $scope.hubEncrypt(roleId);
      $state.go("hub.uContainer.rr", {
        id:$scope.encId
      })
    }

    $scope.confirmSendPassword = function(email, id, isSso){
      $scope.sendPassObj = {email:email, id:id, isSso:isSso};
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div ng-if="!sendPassObj.isSso">{{"u.body.5" | translate}}:<br> <span class="text-bold">{{sendPassObj.email}}</span></div>\
              <div ng-if="sendPassObj.isSso">{{"u.msg.16" | translate}}</div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-success" ng-click="sendPasswordFx(sendPassObj.id);" ng-disabled="userProcessing" focus-me="true" ng-if="!sendPassObj.isSso"><span class="fa fa-repeat fa-spin" ng-if="userProcessing" aria-hidden="true"></span>{{"cm.btn.1" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-link" ng-click="closeThisDialog();" ng-if="!sendPassObj.isSso" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-default" ng-click="closeThisDialog();" ng-if="sendPassObj.isSso" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.sendPasswordFx = function(){
      $scope.userProcessing = true;
      UsersSrv.updateSendPassword($rootScope.selectedItems[0].id).then(
        function(data){
          $scope.userProcessing = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.userProcessing = false;
          $log.error(err);
          ngDialog.close();
        }
      );
    }

    $scope.confirmOpen = function(tabName, id, userCount){
      localStorage.removeItem("curRoleId");
      angular.element('.roleList').removeClass('div-highlight');
      $scope.isConfirmOpen = true;
      $scope.confirmObj = {tabName:tabName, id:id, userCount:userCount};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading text-bold" ng-if="confirmObj.tabName==\'group\'"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
            <div class="panel-body">\
              <span ng-if="confirmObj.tabName == \'deactivate\'">\
                {{selectedItems.length > 1?"u.msg.9s":"u.msg.9" | translate}}\
              </span>\
              <span ng-if="confirmObj.tabName == \'inactive\'">\
                {{selectedItems.length > 1?"u.msg.10s":"u.msg.10" | translate}}\
              </span>\
              <span ng-if="confirmObj.tabName == \'group\'">\
                {{selectedItems.length > 1?"u.msg.11s":"u.msg.11" | translate}}\
              </span>\
              <span ng-if="confirmObj.tabName == \'role\' && confirmObj.userCount == 0">\
                {{"u.msg.12" | translate}}\
              </span>\
              <span ng-if="confirmObj.tabName == \'role\' && confirmObj.userCount > 0">\
                {{"u.msg.13" | translate}}\
              </span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" ng-if="confirmObj.tabName == \'group\'" class="btn btn-danger btn-sm" ng-click="confirmFx(confirmObj.id);" ng-disabled="userProcessing" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="userProcessing" aria-hidden="true"></span>{{selectedItems.length > 1?"u.p_delete.1s":"u.p_delete.1" | translate}}</button>\
              <button type="button" role="button" ng-if="confirmObj.tabName == \'role\' && confirmObj.userCount > 0" class="btn btn-default btn-sm" ng-click="closeThisDialog();" focus-me="true" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
              <button type="button" role="button" ng-if="confirmObj.tabName != \'group\' && ((confirmObj.tabName ==\'role\' && confirmObj.userCount == 0) || confirmObj.tabName != \'role\')" class="btn btn-sm" ng-class="confirmObj.tabName == \'deactivate\' ? \'btn-warning\':\'btn-danger\'" ng-click="confirmFx(confirmObj.id);" ng-disabled="userProcessing" focus-me="true"><span class="fa fa-repeat fa-spin" ng-if="userProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" ng-if="(confirmObj.tabName == \'role\' && confirmObj.userCount == 0) || (confirmObj.tabName != \'role\')" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.confirmFx = function(id){
      $scope.userProcessing = true;
      $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
      if($scope.selectedTab === "hub.users.au" || $scope.selectedTab === "hub.users.mb"){
        UsersSrv.updateDeactivateUser($rootScope.selectedItems).then(
          function(data){
            $scope.userProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.userProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.ug"){
        UsersSrv.deleteGroups($scope.stringIds).then(
          function(data){
            $scope.userProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.userProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.bu"){
        UsersSrv.deleteUsers($scope.stringIds).then(
          function(data){
            $scope.userProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.userProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.users.rr"){
        UsersSrv.deleteRoles(id).then(
          function(data){
            $scope.userProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.userProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.videoFx = function(tabName){
      $scope.videoObj={tabName:tabName};
      if($scope.videoObj.tabName == "u"){
        $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "ntkmLB5zueQ" + $scope.videoParam);
      } else if($scope.videoObj.tabName == "ug"){
        $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "XYbidk9jWYM" + $scope.videoParam);
      } else if($scope.videoObj.tabName == "ur"){
        $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "zICBipz50uM" + $scope.videoParam);
      }
      ngDialog.open({
        template:'app/users/popup/video.html',
        width:580,
        scope:$scope,
        data:$scope.videoObj,
      });
    }

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {tabName:tabName};
      ngDialog.open({
        template:'app/users/popup/info.html',
        width:580,
        scope:$scope,
        data:$scope.readMeObj,
      });
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen){
        angular.forEach($scope.userBtn.buttons, function(btn){
          if(btn.key == "uDelete" || btn.key == "uGDelete"){
            $scope.isDeletable = true;
          }
        });
        if($scope.isDeletable){
          if($scope.selectedTab === "hub.users.bu"){
            $scope.confirmOpen('inactive');
          } else if($scope.selectedTab === "hub.users.ug"){
            $scope.confirmOpen('group');
          }
        }
      }
    }

    $scope.mbAdminFx = function(uId, mbAdmin){
      UsersSrv.mbAdmin({uid:uId, status:mbAdmin}).then(
        function(data){
          console.log(data);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*For dmb*/
    $scope.dmbBrand = {sid:$scope.auth.server, brand:"", url:""};
    $scope.addBrandFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dmbBrand.brand == ""){
        $scope.errTypePop = "eBrand";
        $scope.hasErrPop = true;
        $("#brand").focus();
      } else{
        $scope.dmbBrandProcessing = true;
        SettingsSrv.addBrand($scope.dmbBrand).then(
          function(data){
            $scope.dmbBrandProcessing = false;
            if(data.code == 17052){
              $scope.errTypePop = "aBrand";
              $scope.hasErrPop = true;
              $("#brand").focus();
            } else if(data.code == 17054){
              $scope.errTypePop = "aURL";
              $scope.hasErrPop = true;
              $("#url").focus();
            } else if(data.code == 17051){
              $scope.dmbSettings.brands.unshift({id:data.id, label:$scope.dmbBrand.brand, url:$scope.dmbBrand.url});
              $scope.dmbBrand = {sid:$scope.auth.server, brand:"", url:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbBrandProcessing = false;
          }
        );
      }
    }

    $scope.addDMBUserFx = function(){
      $scope.dmbNewUser.devices = $filter("filter")($scope.devices.devices, {selected:true});
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dmbNewUser.label != "" && $scope.dmbNewUser.email != "" && $scope.dmbNewUser.email && $scope.dmbNewUser.pwd != "" && $scope.dmbNewUser.brand != "" && $scope.dmbNewUser.devices.length){
        $scope.dmbUserProcessing = true;
        SettingsSrv.addDMBUser($scope.dmbNewUser).then(
          function(data){
            $scope.dmbUserProcessing = false;
            if(data.code == 17049){
              $scope.hasErrPop = true;
              $scope.errTypePop = "uExist";
            } else if(data.code == 17047){
              $scope.dmbNewUser.userId = data.userId;
              $scope.dmbSettings.users.unshift($scope.dmbNewUser);
              $scope.dmbNewUser = {sid:$scope.auth.server, label:"", email:"", pwd:"", brand:"", devices:[]};
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
            } else if(data.code == 17048){
              $scope.dmbNewUser.userId = data.userId;
              for(var i=0; i<$scope.dmbSettings.users.length; i++){
                if($scope.dmbSettings.users[i].id === $scope.dmbNewUser.id){
                  $scope.dmbSettings.users[i] = $scope.dmbNewUser;
                }
              }
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
              $scope.dmbNewUser = {sid:$scope.auth.server, label:"", email:"", pwd:"", brand:"", devices:[]};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbUserProcessing = false;
          }
        );
      } else{
        $scope.hasErrPop = true;
        $scope.errTypePop = "eField";
      }
    }

    $scope.editOpen = function(obj, index){
      obj.sid = $scope.auth.server;
      $scope.dmbNewUser = angular.copy(obj);
      $scope.dList = angular.copy(obj.devices);
      angular.forEach($scope.devices.devices, function(d){
          d.selected = false;
      });
      angular.forEach($scope.dList, function(item){
        angular.forEach($scope.devices.devices, function(d){
          if(item.id === d.id){
            d.selected = true;
          }
        });
      });
    }

    $scope.cancelDMBUserFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbNewUser = {sid:$scope.auth.server, label:"", email:"", pwd:"", brand:"", devices:[]};
      angular.forEach($scope.devices.devices, function(d){
        d.selected = false;
      });
    }

    $scope.deleteOpen = function(caller, id, index){
      $scope.isConfirmOpen = true;
      $scope.deleteErr = false;
      $scope.dmbDeleteObj = {caller:caller, id:id, index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dmbDeleteObj.caller==\'b\'">{{deleteErr?"cm.dmb.m5":"cm.dmb.m10" | translate}}</span>\
              <span ng-if="dmbDeleteObj.caller==\'u\'">{{"cm.dmb.m11" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" focus-me="true" ng-if="!deleteErr" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm" ng-class="deleteErr?\'btn-default\':\'btn-link\'" ng-click="closeThisDialog();" data-dismiss="modal">{{deleteErr?"cm.btn.1":"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deleteFx = function(){
      $scope.deleteProcessing = true;
      SettingsSrv.deleteDMBbu($scope.dmbDeleteObj.id, $scope.auth.server, $scope.dmbDeleteObj.caller).then(
        function(data){
          $scope.deleteProcessing = false;
          if($scope.dmbDeleteObj.caller == "b"){
            if(data.code == 17052){
              $scope.deleteErr = true;
            } else if(data.code == 17053){
              $scope.dmbSettings.brands.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          } else{
            if(data.code == 17050){
              $scope.dmbSettings.users.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.sendPwdProcessing = false;
    $scope.sendPwdFx = function(id){
      $scope.sendPwdProcessing = true;
      SettingsSrv.sendPwd({id:id, sid:$scope.auth.server}).then(
        function(data){
          $scope.sendPwdProcessing = false;
          if(data.code == 17049){}
        },
        function(err){
          $scope.sendPwdProcessing = false;
          $log.error(err);
        }
      );
    }

    //select all assign & available devices
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices && $scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices && $scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //reset selected devices
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      // console.warn($scope.curDevices);
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    $scope.$on('briefFx',function(event, data){
      $scope.briefFx(data);
    });

    // * scroll list data code START 2nd phase pagination
    $scope.haveMoreData = false;
    $scope.haveMoreSearchData = false;
    $scope.visibleData = [];
    $scope.stIndex = 0
    $scope.etIndex = 300;
    $scope.searchScroll = false;

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData  = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }

    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "u"){
        $scope.popupLoading = true;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "u"){
              $scope.popupLoading = false;
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "u"){
              $scope.popupLoading = false;
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      // console.warn("visibleData",obj);
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      }, 0);
    });

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);

          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "dmbU"){
        $scope.assignedDevices = obj.selDevice;
      }
    });
    // * scroll list data code END 2nd phase pagination
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('UserGrpCUController', UserGrpCUController);

  /** @ngInject */
  function UserGrpCUController($log, $rootScope, $scope, $state, UsersSrv, UserGrpCUSrv){
    $rootScope.selectedMenu = 6;
    $scope.selectedTab = $state.current.name;
    $scope.saveCloseProcessing = false;
    $scope.saveProcessing = false;
    $scope.detailLoading = false;
    $scope.hasErr = false;
    $scope.userGrp = {};
    $scope.encId = "";
    $scope.decId = "";

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(312);
      $scope.selectedHeight = $scope.getAvailableHeight(312);
    } else{
      $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
      $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
    }

    if($state.params.id){
      $scope.detailLoading = true;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;

      UserGrpCUSrv.getUserGrpDetails($scope.decId).then(
        function(data){
          $scope.userGrp = data;
          $scope.detailLoading = false;

          if($scope.selectedTab === "hub.uContainer.ugUsers"){
            $scope.detailLoading = true;
            UserGrpCUSrv.getUserGrpHierarchy($scope.decId).then(
              function(data){
                $scope.detailLoading = false;
                $scope.userGroup = data;
                angular.forEach($scope.userGroup.groups, function(ug){
                  angular.forEach($scope.userGrp.groups, function(sug){
                    if(ug.id == sug.id){
                      ug.isConflict = 0;
                    }
                  });
                });
              },
              function(err){
                $log.error(err);
                $scope.detailLoading = false;
              }
            );
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $scope.userGrp = {info:{label:""}, users:[], groups:[]};
    }

    /*Selected Devices and device groups*/
    if($scope.selectedTab === "hub.uContainer.ugUsers"){
      $scope.usersLoading = true;
      UsersSrv.getActive().then(
        function(data){
          $scope.curUsers = data;
          $scope.tabFx(1,'tabFx');
          $scope.usersLoading = false;
          if($scope.curUsers.info){
            $scope.tim = $scope.curUsers.info.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.curUsers.info.bucket;
            if($scope.curUsers.info.mbucket && $scope.curUsers.info.mbucket != ""){
              $scope.detailBucket = $scope.curUsers.info.mbucket;
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.usersLoading = false;
        }
      );

      /*Pre Selected Devices*/
      $scope.curItem;
      $scope.isDuplicate = false;
      $scope.isDuplicateG = false;
      $scope.briefFx = function(){
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "u"){
            $scope.isDuplicate = false;
            angular.forEach($scope.userGrp.users, function(listItem){
              if(listItem.id == item.id){
                $scope.isDuplicate = true;
                return false;
              }
            });
            angular.forEach($scope.users.users, function(listItem){
              if(listItem.id == item.id && listItem.uType != 4){
                $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                $scope.isDuplicate = true;
                return false;
              }
            });
            if(!$scope.isDuplicate){
              $scope.curItem = $scope.users.users.filter(function( obj ){ return obj.id == item.id;})[0];
              $scope.userGrp.users.push({id:item.id, label:$scope.curItem.label, email:$scope.curItem.email, thumb:$scope.curItem.thumb, active:$scope.curItem.active});
            }
          } else if(item.type == "ug"){
            $scope.isDuplicateG = false;
            angular.forEach($scope.userGrp.groups, function(listItem){
              if(listItem.id == item.id){
                $scope.isDuplicateG = true;
                return false;
              }
            });
            angular.forEach($scope.userGroup.groups, function(listItem){
              if(listItem.id == item.id && listItem.isConflict){
                $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                $scope.isDuplicateG = true;
                return false;
              }
            });
            if(!$scope.isDuplicateG){
              $scope.curItem = $scope.userGroup.groups.filter(function(obj){return obj.id == item.id;})[0];
              $scope.userGrp.groups.push({id:item.id, label:$scope.curItem.label, createdOn:$scope.curItem.createdOn});
            }
          }
        });
        $rootScope.selectedItems = [];
      }
    }

    $scope.searchText = {ug:""};
    $rootScope.selectedTabFx = function(){
      $scope.searchText = {ug:""};
      $scope.users = "";
      if($scope.selectedT == 1){
        $scope.users = $scope.curUsers;
      } else{
        $scope.users = $scope.userGroup;
      }
    }

    $scope.closeFilteredFx = function(id, caller){
      if(caller == "u"){
        $scope.closeFiltered(id, $scope.userGrp.users);
      } else{
        $scope.closeFiltered(id, $scope.userGrp.groups);
      }
    }

    $scope.saveUserGrpFx = function(caller, action){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "name" && $scope.userGrp.info.label == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      }
      if(action == undefined){
        $scope.saveProcessing = true;
        $scope.userGrp.info.toast = false;
      } else{
        $scope.saveCloseProcessing = true;
        $scope.userGrp.info.toast = true;
      }
      $scope.userGrp.step = caller;
      UserGrpCUSrv.saveUserGrp($scope.userGrp).then(
        function(data){
          if(data.status == "error" && data.code == 13027){
            $scope.saveProcessing = false;
            $scope.saveCloseProcessing = false;
            $scope.errType = "duplicate";
            $scope.hasErr = true;
          } else{
            $scope.encId = $scope.hubEncrypt(data.userGroupId);
            if(action == undefined){
              if(caller == "name"){
                if($state.current.name == "hub.uContainer.ugName"){
                  $state.go("hub.uContainer.ugUsers", {id:$scope.encId});
                }
              } else if(caller == "users"){
                $state.go("hub.users.ug");
                $scope.saveProcessing = false;
                $scope.saveCloseProcessing = false;
              }
            } else{
              $state.go("hub.users.ug");
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
          $scope.saveCloseProcessing = false;
        }
      );
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('UserCUController', UserCUController);

  /** @ngInject */
  function UserCUController($log, $rootScope, $scope, $state, UserCUSrv){
    $rootScope.selectedMenu = 6;
    $scope.selectedTab = $state.current.name;
    $scope.saveProcessing = false;
    $scope.isRoleSelected = false;
    $scope.userLoading = true;
    $scope.curGroupIds = {};
    $scope.tempRoles = {};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.user = {};

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
    } else{
      $scope.decId = 0;
    }
    $scope.curGroupIds = $scope.decId;
    UserCUSrv.getUserDetails($scope.decId).then(
      function(data){
        $scope.user = data;
        $scope.userLoading = false;
        setTimeout(function(){
          $rootScope.getPermissionFx();
        }, 10);
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.resetRoleFx = function(){
      angular.forEach($scope.user.roles.predefinedRoles, function(roles){
        if(roles.selected != null){
          roles.selected = null;
        }
        angular.forEach(roles.role, function(role){
          if(role.selected == true){
            role.selected = false;
          }
        });
      });
    }
    $scope.resetCustomRoleFx = function(){
      angular.forEach($scope.user.roles.customRoles, function(roles){
        if(roles.selected != null){
          roles.selected = null;
        }
        angular.forEach(roles.role, function(role){
          if(role.selected == true){
            role.selected = false;
          }
        });
      });
    }

    $scope.saveUserFx = function(caller){
      $scope.tempAvailableGroup = angular.copy($scope.user.permission.availableGroups);
      $scope.tempRoles = angular.copy($scope.user.roles);
      $scope.isRoleSelected = false;
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.user.info.email === null || $scope.user.info.email == ""){
        $scope.saveProcessing = false;
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#email").focus();
      } else if($scope.user.info.email === undefined){
        $scope.saveProcessing = false;
        $scope.errType = "invalid";
        $scope.hasErr = true;
        $("#email").focus();
      } else{
        $scope.user.permission.availableGroups = [];
        if($scope.user.info.roleOpt == "admin" || $scope.user.info.roleOpt == "mbu"){
          $scope.isRoleSelected = true;
          $scope.user.roles = {};
        } else if($scope.user.info.roleOpt == "predefined"){
          $scope.user.roles.customRoles = [];
          angular.forEach($scope.user.roles.predefinedRoles, function(roles){
            if(!$scope.isRoleSelected){
              if(roles.key != null && roles.selected != null && roles.selected != false){
                $scope.isRoleSelected = true;
              } else if(roles.key == null){
                angular.forEach(roles.role, function(role){
                  if(role.selected != null && role.selected != false){
                    $scope.isRoleSelected = true;
                  }
                });
              }
            }
          });
        } else if($scope.user.info.roleOpt == "custom"){
          $scope.user.roles.predefinedRoles = [];
          angular.forEach($scope.user.roles.customRoles, function(roles){
            if(!$scope.isRoleSelected){
              if(roles.selected != null && roles.selected != false){
                $scope.isRoleSelected = true;
              }
            }
          });
        }
        $scope.checkPrimaryGroup = true;
        if($scope.user.permission.groups.length > 0 && $scope.curGroups.primaryGroup != null && $scope.curGroups.type == "c"){
          angular.forEach($scope.user.permission.groups, function(group){
            if(group.id == $scope.curGroups.primaryGroup.id && $scope.checkPrimaryGroup){
              $scope.checkPrimaryGroup = false;
            }
          });
        }
        if($scope.checkPrimaryGroup){
          $scope.curGroups.primaryGroup = {};
          $scope.curGroups.type = "p";
        }
        if($scope.isRoleSelected){
          UserCUSrv.saveUser($scope.user).then(
            function(data){
              if(data.status == "success"){
                $scope.saveProcessing = false;
                $state.go("hub.users.au");
              } else{
                if(data.code == 13023){
                  $scope.errType = "invalid";
                } else if(data.code == 13024){
                  $scope.errType = "exists";
                } else if(data.code == 13037){
                  $scope.errType = "adminRoleOnly";
                }
                $scope.user.permission.availableGroups = $scope.tempAvailableGroup;
                $scope.user.roles = $scope.tempRoles;
                $scope.saveProcessing = false;
                $scope.hasErr = true;
              }
            },
            function(err){
              $scope.user.permission.availableGroups = $scope.tempAvailableGroup;
              $scope.user.roles = $scope.tempRoles;
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        } else{
          $scope.user.permission.availableGroups = $scope.tempAvailableGroup;
          $scope.user.roles = $scope.tempRoles;
          $scope.saveProcessing = false;
          $scope.errType = "role";
          $scope.hasErr = true;
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('RoleCUController', RoleCUController);

  /** @ngInject */
  function RoleCUController($log, $rootScope, $scope, $state, $filter, RoleCUSrv){
    $rootScope.selectedMenu = 6;
    $scope.selectedTab = $state.current.name;
    $scope.isRoleSelected = false;
    $scope.saveProcessing = false;
    $scope.ur = {searchText:"", filterdList:[]};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.decId = "";
    $scope.encId = "";
    $scope.role = {};

    if($state.params.id){ /*Grt selected Id*/
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
    } else{
      $scope.decId = 0;
    }
    RoleCUSrv.getRoleDetails($scope.decId).then(
      function(data){
        $scope.role = data;
        $scope.selectEntity();
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.selectEntity = function(caller, index){
      $scope.isChecked = false;
      $scope.cbxStatus;
      if(caller == "all"){
        $scope.isChecked = $scope.role.rightsGroups[index].selected;
        $scope.curCbx = $scope.role.rightsGroups[index];
        angular.forEach($scope.curCbx.rights, function(right){
          right.selected = $scope.isChecked;
        });
      } else{
        angular.forEach($scope.role.rightsGroups, function(role){
          $scope.cbxStatus = role.rights[0].selected;

          role.label = $filter("translate")('rights.'+role.id);

          angular.forEach(role.rights, function(right){
            right.label = $filter("translate")('rights.'+right.key);
          });

          /*For schedule add*/
          for(var i=0; i<role.rights.length; i++){
            if(role.rights[i].key == "3.1" && !role.rights[i].selected){
              for(var j=0; j<role.rights.length; j++){
                if(role.rights[j].key == "3.2" || role.rights[j].key == "3.4" || role.rights[j].key == "3.8"){
                  role.rights[j].selected = false;
                };
              }
              break;
            }
            break;
    			}
          if(!$scope.cbxStatus){
            role.selected = false;
          } else{
            $scope.isChecked = true;
            for(var i=0; i<role.rights.length; i++){
              if(!role.rights[i].selected){
                $scope.isChecked = false;
                break;
              }
            }
            if(!$scope.isChecked){
              role.selected = false;
            } else{
              role.selected = true;
            }
          }
        });
      }
    };

    $scope.saveRoleFx = function(){
      $scope.isRoleSelected = false;
      $scope.saveProcessing = true;
      $scope.sAddValid = true;
      $scope.hasErr = false;
      $scope.errType = "";
      var sAddCount = 0;

      if($scope.role.info.label === null || $scope.role.info.label == ""){
        $scope.saveProcessing = false;
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else{
        angular.forEach($scope.role.rightsGroups, function(role){
          angular.forEach(role.rights, function(rights){
            if(rights.key == "3.1" && rights.selected){
              angular.forEach(role.rights, function(sRights){
                if((sRights.key == "3.2" && !sRights.selected) || (sRights.key == "3.4" && !sRights.selected) || (sRights.key == "3.8" && !sRights.selected)){
                  sAddCount++;
                }
              });
              if(sAddCount==3){
                $scope.sAddValid = false;
              }
            }
            if(rights.selected){
              $scope.isRoleSelected = true;
              return false;
            }
          });
          if($scope.isRoleSelected){
            return false;
          }
        });
        if($scope.isRoleSelected && $scope.sAddValid){
          $scope.saveProcessing = false;
          RoleCUSrv.saveUserRole($scope.role).then(
            function(data){
              if(data.code == 13029){
                $scope.saveProcessing = false;
                $scope.errType = "exists";
                $scope.hasErr = true;
                $("#label").focus();
              } else{
                $state.go("hub.users.rr");
              }
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
        } else if(!$scope.sAddValid){
          $scope.saveProcessing = false;
          $scope.errType = "sAdd";
          $scope.hasErr = true;
        } else{
          $scope.saveProcessing = false;
          $scope.errType = "right";
          $scope.hasErr = true;
          angular.forEach($scope.role.rightsGroups, function(role){
            if(role.id == 1){
              $('input[data-id=1]').focus();
            } else if(role.id == 2){
              $('input[data-id=2]').focus();
            } else if(role.id == 3){
              $('input[data-id=3]').focus();
            } else if(role.id == 4){
              $('input[data-id=4]').focus();
            } else if(role.id == 5){
              $('input[data-id=5]').focus();
            } else if(role.id == 6){
              $('input[data-id=6]').focus();
            } else if(role.id == 7){
              $('input[data-id=7]').focus();
            }
          });
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TeamsAppController', TeamsAppController);

  /** @ngInject */
  function TeamsAppController($log, $rootScope, $scope, $state, $cookies){
    $scope.teamsApp = localStorage.getItem("teamsApp");
    if($scope.teamsApp){
      $state.go($scope.teamsApp);
    } else{
      $state.go("hub.dashboard");
    }
  }
})();
angular.module('hub').service('SchedulesCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  this.getSchedulesDetails = function(id){
    // httpReq = $http.get($rootScope.apiHost + "schedules/details/new1/" + id);
    httpReq = $http.get($rootScope.apiHost + "schedules/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSchedulesGroups = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/groups");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLayouts = function(id){
    httpReq = $http.get($rootScope.apiHost + "schedules/layouts/new1/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGroupDevices = function(gType, id, offSet){
    if(angular.isUndefined(offSet)){
      var dUrl = "devices/gbdt/assignableDevices/"+ id +"?type=s&gtype="+ gType;
    } else{
      var dUrl = "devices/gbdt/assignableDevices/"+ id +"?type=s&gtype="+ gType +"&offset="+ offSet;
    }
    httpReq = $http.get($rootScope.apiHost + dUrl);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveSchedules = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPreviewDates = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/previewDates", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getValidateDeviceList = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/validateDeviceList", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVWDevices = function(id){
    httpReq = $http.get($rootScope.apiHost + "schedules/videowall/deviceList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateVWInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/processVW", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  //One time save
  this.saveSchedules1 = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/sc1", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getApproved = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if(canceler){
      canceler.resolve();
    }
    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {timeout:canceler.promise};

    httpReq = $http.post($rootScope.apiHost + "contentLibrary/approved/"+obj.fId, obj, config); //" + fId + "?" + new Date().getTime()
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getDeviceList1 = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if(canceler){
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {timeout: canceler.promise};
    
    httpReq = $http.post($rootScope.apiHost + "devices/assignableDevices/new1", obj, config);

    // if(obj.caller == "d"){
    //   if(obj.auth && obj.auth.upreferences.deviceView == 'l'){
    //   }
    // } else{
    //   // httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1" + "?caller="+obj.caller +"&"+ new Date().getTime());
    //   //  devices/assignableDevices/new1/19472?fid=0&caller=dt&type=s&isLV=1&offset=0&1718012192465
    //   // devices/assignableDevices/new1/19472?fid=0&caller=dg&type=s&isLV=1&offset=0&1718012996614
    // }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  // https://cpostrc.lsquared.com/api/v1/devices/assignableDevices
  // {
  //   "s": "2024-05-01",
  //   "e": "2024-05-31",
  //   "t": "0"
  // }

  this.layouts = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/layouts", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getFolderItems = function(obj){
    var url = "";
    if(obj.m == "clf"){
      url = "contentLibrary/foldersContentList";
    } else if(obj.m == "tf"){
      url = "templates/foldersContentList";
    }
    httpReq = $http.post($rootScope.apiHost + url, obj.data);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SchedulesSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSchedules = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/new1/?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUnapproved = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/unapproved/new1?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIncompleted = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/incomplete/new1?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpired = function(){
    httpReq = $http.get($rootScope.apiHost + "schedules/expired/new1?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Get Brief*/
  this.getScheduleBrief = function(scheduleId){
    httpReq = $http.get($rootScope.apiHost + "schedules/briefs/new1/" + scheduleId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Count List*/
  this.getContentList = function(id){
    httpReq = $http.get($rootScope.apiHost + "schedules/contentList/new1/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceList = function(id, exp){
    if(exp){
      httpReq = $http.get($rootScope.apiHost + "schedules/deviceList/new1/"+ id +"?isExport=1");
    } else{
      httpReq = $http.get($rootScope.apiHost + "schedules/deviceList/new1/"+ id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getAddToSchedules = function(item, module){
    if(item && item.length === 1){
      if(item[0].subType == "f"){
        var tempModule = "folderId=";
        if(module=="t"){
          tempModule = "tFolderId=";
        }
        httpReq = $http.get($rootScope.apiHost + "schedules/addToSchedule?"+ tempModule + item[0].id + (module=="t"?"&module=t":""));
      } else if(item[0].type !== "OneDriveC" && item[0].type !== "SharePointC" && item[0].type !== "GoogleDriveC"){
        httpReq = $http.get($rootScope.apiHost + "schedules/addToSchedule?contentId="+item[0].id + (module=="t"?"&module=t":""));
      } else{
        httpReq = $http.get($rootScope.apiHost + "schedules/addToSchedule" + (module=="t"?"?module=t":""));
      }
    } else{
      httpReq = $http.get($rootScope.apiHost + "schedules/addToSchedule" + (module=="t"?"?module=t":""));
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateAddToSchedules = function(obj){
    httpReq = $http.post($rootScope.apiHost + "schedules/addToSchedule", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*ngSwitch*/
  this.changeStatus = function(id){
    httpReq = $http.patch($rootScope.apiHost + "schedules/status/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.updateAssignGrp = function(ids, group){
    var grpObj = {};
    grpObj.ids = ids;
    grpObj.group = group;
    httpReq = $http.put($rootScope.apiHost + "schedules/assigntoGroup", grpObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Get Button*/
  this.getScheduleBtn = function(sId){
    httpReq = $http.post($rootScope.apiHost + "action/schedules", sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.updateApprove = function(sId){
    httpReq = $http.post($rootScope.apiHost + "schedules/approve", sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateUnapprove = function(sId){
    httpReq = $http.post($rootScope.apiHost + "schedules/unapprove", sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveGroups = function(groupObj){
    httpReq = $http.post($rootScope.apiHost + "schedules/groups", groupObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveGroupsConfirm = function(groupObj){
    httpReq = $http.put($rootScope.apiHost + "schedules/groups/confirm", groupObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Delete*/
  this.deleteSchedules = function(sId){
    httpReq = $http.delete($rootScope.apiHost + "schedules/" + sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteGroups = function(groupId){
    httpReq = $http.delete($rootScope.apiHost + "schedules/groups/" + groupId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAllTypeSchedules = function(sId){
    if(sId){
      httpReq = $http.get($rootScope.apiHost + "schedules/?notify=1&sid="+sId+"&" + new Date().getTime());
    } else {
      httpReq = $http.get($rootScope.apiHost + "schedules/?notify=1&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DexieSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  // Initialize Dexie database
  const db = new Dexie('scu');

  // Define database schema
  db.version(1).stores({
    scuData: '++id'//,name,age
  });

  // Add data to the database
  this.addData = function(data){
    // console.warn("addData ", data);
    return $q.when(db.scuData.add(data));
  };

  // Get data from the database
  this.getData = function(id){
    // console.warn("getData ", id);
    return $q.when(db.scuData.get(id));
  };

  // Update data in the database
  this.updateData = function(data){
    // console.warn("updateData ", data);
    return $q.when(db.scuData.put(data));
  };

  // Delete data from the database
  this.deleteData = function(id){
    // console.warn("deleteData ", id);
    return $q.when(db.scuData.delete(id));
  };

  // Clear the entire database
  this.clearData = function(){
    // console.warn("clearData ");
    return $q.when(db.delete().then(function(){
      // Reinitialize the database after deleting
      // db.version(1).stores({
      //   myObjectStore: '++id,name,age'
      // });
    }));
  };

}]);
angular
  .module('hub').directive('ngScheduleList', function(){
    return {
      restrict:'E',
      templateUrl:'app/schedules/dir/schedulesList.html'
    }
  });
angular
  .module('hub').directive('ngScheduleBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/schedules/dir/scheduleBrief.html'
    }
  });
angular
  .module('hub').directive('ngBtnList', function(){
    return {
      restrict:'E',
      scope:{
        info:'=',
        permission:'=',
        backBtn:'&',
        nextCallback:'&',
        saveCallback:'&',
        nextSelect:'&',
        cancelFx:'&',
        appliedDeviceList:'&'
      },
      templateUrl:'app/schedules/dir/button-list.html'
    }
  });
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SchedulesCUController', SchedulesCUController);

  /** @ngInject */
  function SchedulesCUController($log, $rootScope, $scope, $state, $filter, $timeout, ngDialog, ContentLibrarySrv, TemplatesSrv, DevicesSrv, CommonSrv, SchedulesCUSrv, FileModelUploadSrv, IndexedDB){
    $rootScope.selectedMenu = 3;

    $rootScope.importXls = {file: ""};
    $rootScope.commonSearchVar = "";
    $rootScope.filteredDevices = []; //For advanced search
    $rootScope.selectedItems = [];

    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.devices = {devices: "", info: {}};
    $scope.isAllFramesSelected = false;
    $scope.saveCloseProcessing = false;
    $scope.scheduleCanvasHeight = 100;
    $scope.paginationLoading = false;
    $scope.dateRange = {type: "s"};
    $scope.saveProcessing = false;
    $scope.accessibleFrame = true;
    $scope.hiddenDevices = false;
    $scope.hiddenContent = false;
    $scope.remainingDuration = 0;
    $scope.detailLoading = true;
    $scope.footerLoading = true;
    $scope.advancedShow = true;
    $scope.remainingCount = 0;
    $scope.allowedFolder = "";
    $scope.advSearch = false;
    $scope.isPEOpen = false;
    $scope.sDeviceList = [];
    $scope.selFrameIds = [];
    $scope.thumbSize = "n";
    $scope.filter = "all";
    $scope.excludeDR = [];
    $scope.schedule = [];
    $scope.scheduleFirstCopy = [];
    $scope.decType = "";
    $scope.encType = "";
    $scope.decId = "";
    $scope.encId = "";
    $scope.rdc = 0;

    $scope.celEventBack = angular.fromJson(localStorage.getItem("celEventBack"));
    $scope.se = {b: 0, c: 0, d: 0, s: 0, f: 0, curStep: "", nextStep: "", isBack: 0};
    $scope.decType = $scope.hubDec($state.params.type);
    $scope.encType = $state.params.type;
    $scope.searchTextS = {text: ""};
    $scope.selectedSearch = {text: ""};
    $scope.templatesLoading = true;
    $scope.searchText = "";

    localStorage.removeItem("gpo");

    $scope.getCutDate = moment().format('L');
    $scope.allSelectedDevices = {devices: []};
    $scope.paginationControls = {boundaryLinks: false, maxSize: 7, currPage: 1, pageSize: $scope.auth.upreferences.dpc, dataCount: $scope.auth.upreferences.dpcc ? $scope.auth.upreferences.dpcc : 1000};
    $scope.selPaginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.getAllData = {search: false, advSearch: false, filter: false, list: false};
    $scope.statusObj = {d: false, s: false, as: false, f: false};
    $scope.copyDevices = {devices: [], folders: []};
    $scope.stored = {devices: [], folders: []};
    $scope.apiCalledArr = [];
    $scope.folderList = [];
    $scope.vwInfo = {vw:[]};

    $scope.isFilterApplied = false;
    $scope.isAdvSearchMsg = false;
    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.advSApply = false;
    $scope.totalDPages = 0;
    $scope.dOffset = 0;
    $scope.dData = {};
    $scope.sData = {};
    $scope.fData = {};
    $scope.asData = {};
    $scope.curNum = 0;
    $scope.filterIsAppliedAlready = false;
    $rootScope.addStatusKeyVal = {value: true};
    $scope.isPageApiLoad = false;
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter: false, search: false};
    $rootScope.search = {text: ""};
    $scope.copySelData = [];

    if($scope.selectedTab == "hub.sContainer.sName"){
      $rootScope.stateName = "n";
    } else if($scope.selectedTab == "hub.sContainer.sSchedule"){
      $rootScope.stateName = "s";
    } else if($scope.selectedTab == "hub.sContainer.sContent"){
      $rootScope.stateName = "c";
    } else if($scope.selectedTab == "hub.sContainer.sDevice"){
      $rootScope.stateName = "d";
      // $rootScope.selectedT = $scope.auth.upreferences.sdtf ? 2 : 1;
    } else if($scope.selectedTab == "hub.sContainer.sFrame"){
      $rootScope.stateName = "f";
    }

    // Todo content sync schedule
    $scope.ssGroups = [];
    $scope.sGroupSch = [];
    $scope.searchList = {sch: ""};
    $scope.syncScheduleOpen = function(caller){
      if(caller == 'edit'){
        SchedulesCUSrv.getSyncGroups().then(
          function(data){
            angular.forEach(data.sg, function(obj){
              angular.forEach($scope.schedule.info.sg, function(val){
                if(obj.id == val.id){
                  obj.selected = true;
                }
              })
            })
            $scope.ssGroups = $filter('orderBy')(data.sg, 'l');
            $scope.bucket = $scope.dDetailBucket = data.info.bucket;
            if(data.info.mbucket && data.info.mbucket != ""){
              $scope.dDetailBucket = data.info.mbucket;
            }
            $scope.tim = data.info.timthumb;
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.schedule.info.isSync = true;
        SchedulesCUSrv.getSyncGroups().then(
          function(data){
            $scope.ssGroups = $filter('orderBy')(data.sg, 'l');
            $scope.bucket = $scope.dDetailBucket = data.info.bucket;
            if(data.info.mbucket && data.info.mbucket != ""){
              $scope.dDetailBucket = data.info.mbucket;
            }
            $scope.tim = data.info.timthumb;
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.ssGroupsFx = function(caller){
      if(caller == 'edit'){
        var dIds = $scope.arraytoStringFx($scope.schedule.info.sg);
        SchedulesCUSrv.getSyncGroupsSchedule(dIds).then(
          function(data){
            angular.forEach(data, function(obj){
              angular.forEach($scope.schedule.info.sgsch, function(val){
                if(obj.id == val.id){
                  obj.selected = true;
                }
              })
            })
            $scope.sGroupSch = data;
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        var selSyncGrpArr = $filter("filter")($scope.ssGroups, {selected:true});
        $scope.schedule.info.sg = [];
        $scope.schedule.devices.device = [];
        $scope.sGroupSch = [];
        $scope.searchList.sch = "";
        if(selSyncGrpArr.length){
          angular.forEach(selSyncGrpArr, function(obj){
            $scope.schedule.info.sg.push({id:obj.id, l:obj.l})
            $scope.schedule.devices.device.push(obj.md);
          })
        }
        var dIds = $scope.arraytoStringFx(selSyncGrpArr);
        if($scope.schedule.info.sg.length){
          SchedulesCUSrv.getSyncGroupsSchedule(dIds).then(
            function(data){
              $scope.sGroupSch = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.ssScheduleFx =  function(){
      var selScheduleArr = $filter("filter")($scope.sGroupSch, {selected:true});
      $scope.schedule.info.sgsch = angular.copy(selScheduleArr);
    }

    // TODO New Code 070824
    $scope.setTabFx = function(obj){
      if(obj && obj.c == "c"){
        if($scope.auth.upreferences.sdtf && $scope.auth.upermissions.sa.dt){
          $rootScope.selectedT = 2;
        } else{
          if($scope.auth.upermissions.sa.d){
            $rootScope.selectedT = 1;
          } else if($scope.auth.upermissions.sa.dt){
            $rootScope.selectedT = 2;
          } else if($scope.auth.upermissions.sa.dg){
            $rootScope.selectedT = 3;
          }
        }
      } else if(obj && obj.c == "cl"){
        if($scope.schedule.info.ls == 3){
          $rootScope.selectedT = 2;
        } else{
          $rootScope.selectedT = 1;
        }
      } else{
        if($scope.auth.upreferences.sdtf && (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt))){
          $rootScope.selectedT = 2;
        } else{
          if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.d) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.d)){
            $rootScope.selectedT = 1;
          } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)){
            $rootScope.selectedT = 2;
          } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dg) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dg)){
            $rootScope.selectedT = 3;
          }
        }
      }
      if(obj && obj.isLFx){
        $scope.isLoadedFx();
      }
    }

    /* IDB Start */
    $scope.sCUdb = "";
    var dbInfo = {// Set IDB Info
      dbN:"scu",
      dbV:1,
      sArr:[{name:"scuData"}]
    }

    // setTimeout(function(){
    IndexedDB.setIDBInfo(dbInfo);

    /* Registered useful functions */
    $scope.addItemsDB = function(obj){
      obj.id = 0;
      IndexedDB.addItems({stores: [{sName: "scuData", value: obj}]}).then(function(message){
      }).catch(function(error){
        console.error(error);
      });
    };

    $scope.getItemDB = function(store, key, caller){
      IndexedDB.getItem(store, key).then(function(item){
        $scope.sCUdb = item;
        if($scope.sCUdb){
          $scope.setInfoFx(caller);
        } else{
          localStorage.setItem("scuData", false);
          if($scope.selectedTab != "hub.sContainer.sName" || $state.params.id){
            $scope.clearStoreDB("scuData");
            $state.go("hub.schedules.s");
          }
        }
      }).catch(function(error){
        console.error(error);
      });
    };

    $scope.clearStoreDB = function(store){
      $rootScope.askToChange = true;
      IndexedDB.clearStore(store).then(function(message){
      }).catch(function(error){
        console.error(error);
      });
    };
    /* IDB End */

    $scope.setInfoFx = function(caller){
      $scope.schedule = $scope.sCUdb;
      $scope.scheduleFirstCopy = angular.copy($scope.schedule);
      if($scope.schedule.devices.group.length){
        $scope.schedule.devices.group.forEach(function(item){
          item.t = "g";
        });
      }
      if($scope.schedule.devices.tag.length){
        $scope.schedule.devices.tag.forEach(function(item){
          item.t = "t";
        });
      }
      if($scope.schedule.devices.search.length){
        $scope.schedule.devices.search.forEach(function(item){
          item.t = "s";
        });
      }
      var mergeData = angular.copy([].concat($scope.schedule.devices.device, $scope.schedule.devices.group, $scope.schedule.devices.search, $scope.schedule.devices.tag));
      $scope.allSelItems = {list:angular.copy(mergeData)};
      $scope.copySelData = angular.copy($scope.allSelItems);
      $scope.tempSchedule = angular.copy($scope.schedule);
      $scope.editPermissionFx();
      if($rootScope.stateName === "d"){
        $scope.setTabFx({c:caller, isLFx:true}); //TODO New Code 070824
      } else{
        $scope.isLoadedFx();
      }

      // Todo we need to comment code here
      // if($scope.celEventBack && $scope.celEventBack.back){
      //   $scope.schedule.info.label = $scope.celEventBack.label;
      // }

      var tiSchedule = angular.fromJson(localStorage.getItem("tiSchedule"));
      if(tiSchedule){
        $scope.tim = tiSchedule.tim;
        $scope.tBucket = $scope.tDetailBucket = tiSchedule.tBucket;
        if(tiSchedule.mbucket && tiSchedule.mbucket != ""){
          $scope.tDetailBucket = tiSchedule.mbucket;
        }
      } else{
        $scope.tBucket = $scope.tDetailBucket = $scope.schedule.info.tBucket;
        if($scope.schedule.info.tMbucket && $scope.schedule.info.tMbucket != ""){
          $scope.tDetailBucket = $scope.schedule.info.tMbucket;
        }
      }

      $scope.tim = $scope.schedule.info.timthumb;
      $scope.cBucket = $scope.cDetailBucket = $scope.schedule.info.cBucket;
      if($scope.schedule.info.cMbucket && $scope.schedule.info.cMbucket != ""){
        $scope.cDetailBucket = $scope.schedule.info.cMbucket;
      }
      $scope.dBucket = $scope.dDetailBucket = $scope.schedule.info.dBucket;
      if($scope.schedule.info.dMbucket && $scope.schedule.info.dMbucket != ""){
        $scope.dDetailBucket = $scope.schedule.info.dMbucket;
      }

      // if($scope.selectedTab === "hub.sContainer.sName" && !$scope.schedule.stepOne){
      if($rootScope.stateName === "n" && !$scope.schedule.stepOne){
        if($scope.auth.upermissions.sar){
          $scope.schedule.info.group = {id:0, label:$filter("translate")('s.p_s.label.1.1')};
        } else{
          $scope.schedule.info.group = {};
        }
      }

      // if($scope.selectedTab === "hub.sContainer.sSchedule"){
      if($rootScope.stateName === "s"){
        if($scope.schedule.schedule.subType == "dc"){
          $scope.dateRange.type = "m";
        } else if($scope.schedule.schedule.subType != "c"){
          $scope.schedule.schedule.subType == "d";
        }
        $scope.dateRangeCopy = angular.copy($scope.schedule.schedule.dateRange);
        $scope.subTypeFx();
      }

      // TODO For IDB
      // if($scope.selectedTab === "hub.sContainer.sFrame"){
      if($rootScope.stateName === "f"){
        var minmaxDate = {minStartDate:$scope.schedule.schedule.dateRange.startDate, maxEndDate:$scope.schedule.schedule.dateRange.endDate};
        if($scope.schedule.schedule.subType == "dc" && $scope.schedule.schedule.timingList.length > 0){
          minmaxDate = $filter("minmaxDate")($scope.schedule.schedule.timingList);
        }

        var payload = {
          id:$scope.schedule.info.id,
          s:moment(minmaxDate.minStartDate).format('MM/DD/YYYY'),
          e:moment(minmaxDate.maxEndDate).format('MM/DD/YYYY'),
          t:$scope.schedule.info.ls?$scope.schedule.info.ls:0, //schedule type
          dids:$scope.arraytoStringFx($scope.schedule.devices.device),
          gids:$scope.arraytoStringFx($scope.schedule.devices.group),
          tids:$scope.arraytoStringFx($scope.schedule.devices.tag),
          sids:$scope.arraytoStringFx($scope.schedule.devices.search)
        }
        SchedulesCUSrv.layouts(payload).then(
          function(data){
            $scope.saveLoadProcessing = true;
            $scope.accessibleFrame = false;
            $scope.detailLoading = false;
            $scope.footerLoading = false;
            $scope.frameLayout = data;
            $scope.frameLayoutsCount = $scope.frameLayout.frameLayouts.length;

            if($scope.frameLayout.frameLayouts.length > 1){
              $scope.isAllFramesSelected = false;
            } else{
              $scope.isAllFramesSelected = true;
            }
            if($scope.frameLayout.frameLayouts.length > 0){
              $scope.saveLoadProcessing = false;
              $timeout(function(){
                // if($scope.selectedTab === "hub.sContainer.sFrame"){
                if($rootScope.stateName === "f"){
                  angular.element(document).find('.fl')[0].click();
                }
              }, 500);
            } else{
              $scope.accessibleFrame = true;
              $scope.timer = $timeout($scope.timerFx, 1000);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.detailLoading = false;
      }
    }

    $scope.curFolderId = localStorage.getItem("curDFId");
    if(angular.isUndefined($scope.curFolderId)){
      $scope.curFolderId = 0;
    }

    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      }, 2000);
    }

    $scope.getDeviceStatus = function(){
      // console.error("GET DEVICE STATUS");
      if($rootScope.stateName == "d"){
        $scope.deviceUpdating = true;
        setTimeout(function(){
          if($scope.pageDeviceArr.length){
            var currentTime = new Date().getTime();
            $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
            angular.forEach($scope.pageDeviceArr, function(obj){
              if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
                obj.tz = currentTime;
                DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                  function(data){
                    angular.forEach($scope.devices.devices, function(dData){
                      angular.forEach(Object.keys(data), function(key){
                        var value = data[key];
                        if(key == dData.id){
                          dData.lp = value;
                        }
                      })
                    });
                    if($scope.schedule.devices.device.length){
                      angular.forEach($scope.schedule.devices.device, function(sData){
                        angular.forEach(Object.keys(data), function(key){
                          var value = data[key];
                          if(key == sData.id){
                            sData.status = $filter('isDeviceOnline')(value, {minDeduct: $scope.auth.upreferences.dot});
                          }
                        })
                      })
                    }
                    $scope.deviceUpdating = false;
                  },
                  function(err){
                    $log.error(err);
                  }
                );
              }
            })
          }
        }, 100);
        $scope.updateSelectedDevice();
      }
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($scope.schedule.devices.device, function(data){
          if(data.id == obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.thumbV = obj.tv;
            }
            data.status = $filter('isDeviceOnline')(obj.lp, {minDeduct:$scope.auth.upreferences.dot});
          }
        });
        outerLoopCounter++;
        if(outerLoopCounter === totalOuterLoops){
          $scope.temSelectedArr = angular.copy($scope.schedule.devices.device);
          $scope.schedule.devices.device = [];
          $scope.schedule.devices.device = $scope.temSelectedArr;
        }
      });
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length ? $scope.devices.devices.length : 0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages - 1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        $scope.dReqObj = {id: $scope.schedule.info.id, type: "s", auth: $scope.auth, offset: $rootScope.offset, text: $scope.searchTextS.text, filter: $scope.filter, caller: $rootScope.selectedT == 1 ? "d" : $rootScope.selectedT == 2 ? "dt" : "dg", fId: (($scope.curFolderId > 0 && $rootScope.selectedT == 1) ? $scope.curFolderId : 0)};

        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopyS"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          if($scope.curAdvSearchObj.module == "s"){
            $scope.curAdvSearchObj.csdr = {s:$scope.schedule.schedule.dateRange.startDate, e:$scope.schedule.schedule.dateRange.endDate};
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isem;
              $scope.curAdvSearchObj.isLoadMore = true;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info: $scope.curAdvSearchObj, devices: $scope.filteredData.devices, advObj: $scope.curAdvSearchObj, isLV: true};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.i;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds: data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    }

    $scope.selPageChangeHandler = function(){
      $('#pagingCtrlClone li').removeClass('active');
      // console.warn("Count", $scope.allSelItems.list.length);
      var pages = Math.ceil($scope.allSelItems.list.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.allSelItems.list.length / $scope.paginationControls.pageSize);
    };

    $scope.resetSelPagination = function(caller){
      if(caller=="all"){
        $scope.resetSelFx();
      }
      var searchData = angular.copy($filter("customSearch")($scope.allSelItems.list, {key:$scope.selectedSearch.text, module:'d'}));
      if(searchData.length>$scope.auth.upreferences.dpc && !caller){
        resetSelPageFx(1);
      }
    }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore, action){
      var ls = $scope.schedule.info.ls ? $scope.schedule.info.ls : 0; //schedule type
      var minmaxDate = {minStartDate: $scope.schedule.schedule.dateRange.startDate, maxEndDate: $scope.schedule.schedule.dateRange.endDate};
      if($scope.schedule.schedule.subType == "dc" && $scope.schedule.schedule.timingList.length > 0){
        minmaxDate = $filter("minmaxDate")($scope.schedule.schedule.timingList);
      }

      // $scope.setTabFx();

      // if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.d) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.d)){
      //   if(!$scope.auth.upermissions.se.dt && !$scope.auth.upermissions.sa.dt){
      //     if($scope.auth.upreferences.sdtf){
      //       $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //     } else {
      //       $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //     }
      //   }
      //   else {
      //     if($scope.auth.upreferences.sdtf){
      //       $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //     }
      //   }
      //   if(caller == "changeView"){
      //     $rootScope.selectedT = 1;
      //   }
      // } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)){
      //   if(!$scope.auth.upermissions.se.d || !$scope.auth.upermissions.sa.d){
      //     if($scope.auth.upreferences.sdtf){
      //       $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //     } else {
      //       $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //     }
      //   }
      // } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dg) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dg)){
      //   $rootScope.selectedT = 3;
      // }

      var dAPIObj = {
        caller:$rootScope.selectedT == 1?"d":$rootScope.selectedT == 2?"dt":"dg",
        s:moment(minmaxDate.minStartDate).format('MM/DD/YYYY'),
        e:moment(minmaxDate.maxEndDate).format('MM/DD/YYYY'),
        offset:dReqObj.offset,
        fil:dReqObj.filter,
        type:dReqObj.type,
        fId:dReqObj.fId,
        id:dReqObj.id,
        dr:[],
        t:ls
      }

      if(dAPIObj.caller == "d" && $scope.auth && $scope.auth.upreferences.deviceView == "l"){
        dAPIObj.isLV = 1;
      } else{
        dAPIObj.isLV = 0;
      }
      if(dReqObj.text && dReqObj.text.length){
        // dAPIObj.searchQ = encodeURIComponent(dReqObj.text);
        dAPIObj.searchQ = dReqObj.text;
      }

      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }

      SchedulesCUSrv.getDeviceList1(dAPIObj).then(
        function(data){
          $scope.isPageApiLoad = false;
          $scope.devicesLoading = false;
          $scope.moreDeviceLoading = false;
          $scope.deviceListLoading = false;
          $scope.tim = data.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.dDetailBucket = data.info.mbucket;
          }
          if(!$rootScope.addStatusKeyVal.value){}
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }

          if($rootScope.selectedT != 1){
            $scope.sDeviceList = angular.copy(data);
            return;
          }

          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);
          // get device of types
          if(caller == 'openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller == "search"){// get searched devices
            if(isLoadMore && $scope.sData.devices.length){
              $scope.sData.devices = $scope.sData.devices.concat(data.devices);
            } else{
              $scope.sData = angular.copy(data);
            }
            if($scope.rdc == $scope.sData.devices.length){
              $scope.sData.isAll = true;
            } else{
              $scope.sData.isAll = false;
            }
            localStorage.setItem("sData", JSON.stringify($scope.sData));
            $scope.devices = angular.copy($scope.sData);
          }
          else if(caller == "filter"){// get filterd devices
            if(isLoadMore && $scope.fData.devices.length){
              $scope.fData.devices = $scope.fData.devices.concat(data.devices);
            } else{
              $scope.fData = angular.copy(data);
            }
            if($scope.rdc == $scope.fData.devices.length){
              $scope.fData.isAll = true;
            } else{
              $scope.fData.isAll = false;
            }
            localStorage.setItem("fData", JSON.stringify($scope.fData));
            // $scope.devices = angular.copy($scope.fData);
            $scope.devices.devices = angular.copy($scope.fData.devices);
          }
          else if(caller == "advSearch"){// get adv searched devices
            if(isLoadMore && $scope.asData.devices.length){
              $scope.asData.devices = $scope.asData.devices.concat(data.devices);
            } else{
              $scope.asData = angular.copy(data);
            }
            if($scope.rdc == $scope.asData.devices.length){
              $scope.asData.isAll = true;
            } else{
              $scope.asData.isAll = false;
            }
            localStorage.setItem("asData", JSON.stringify($scope.asData));

            $scope.devices = angular.copy($scope.asData);
            $scope.isGbdt = false;
            $scope.updateList();
          }
          else if(caller == 'dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else{
              $scope.dData = angular.copy(data);
            }
            // if($scope.rdc != 0 && $scope.dData.devices.length != 0 && $scope.rdc == $scope.dData.devices.length){
            //   $scope.dData.isAll = true;
            // } else{
            //   $scope.dData.isAll = false;
            // }
            // localStorage.setItem("dData", JSON.stringify($scope.dData));
            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType == "all"){
              $scope.filterType = "";
              $scope.filter = "all";
            } else{
              $scope.filter = $scope.filterType;
            }

            if($scope.dData.tags && $rootScope.selectedT == 2){
              $scope.devices = angular.copy($scope.dData);
            } else if($scope.dData.groups || $scope.dData.searches && $rootScope.selectedT == 3){
              $scope.devices = angular.copy($scope.dData);
            } else{
              $scope.devices = angular.copy($scope.dData);
              $scope.folderList = $scope.devices.folders;
            }
            $scope.loadingMain = false;
          }

          $scope.updateList();
          $scope.setCountFx();
          if(action && action != "changeView"){
            $scope.updateSelectedDevice();
          }
        },
        function(err){
          $log.error(err);
        }
      );

      // DevicesSrv.getAssignableDevices(dReqObj).then(
      //   function(data){
      //     $scope.deviceListLoading = false;
      //     if(!$rootScope.addStatusKeyVal.value){
      //     }
      //     $scope.isPageApiLoad = false;
      //     $scope.moreDeviceLoading = false;
      //     $scope.devicesLoading = false;
      //     $scope.tim = data.info.timthumb;
      //     $scope.bucket = $scope.dDetailBucket = data.info.bucket;
      //     if(data.info.mbucket && data.info.mbucket != ""){
      //       $scope.dDetailBucket = data.info.mbucket;
      //     }
      //     $scope.brief = data;
      //     if(data.info.rdc){
      //       $scope.rdc = data.info.rdc;
      //     }

      //     if($scope.selectedT != 1){
      //       $scope.sDeviceList = angular.copy(data);
      //       return;
      //     }

      //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
      //     $scope.addTypeKey(data);

      //     // get device of types
      //     if(caller=='openType'){
      //       $scope.loadingMain = false;
      //       if(data.code == 12064){
      //         $scope.auth.upermissions.gbdt = false;
      //         localStorage.setItem('auth', JSON.stringify($scope.auth));
      //         $scope.loadSelectedTab();
      //       } else{
      //         $scope.isGbdt = false;
      //       }
      //     }

      //     if(caller=="search"){// get searched devices
      //       if(isLoadMore && $scope.sData.devices.length){
      //         $scope.sData.devices = $scope.sData.devices.concat(data.devices);
      //       } else {
      //         $scope.sData = angular.copy(data);
      //       }
      //       if($scope.rdc == $scope.sData.devices.length){
      //         $scope.sData.isAll = true;
      //       } else {
      //         $scope.sData.isAll = false;
      //       }
      //       localStorage.setItem("sData", JSON.stringify($scope.sData));
      //       $scope.devices = angular.copy($scope.sData);
      //     }
      //     else if(caller=="filter"){// get filterd devices
      //       if(isLoadMore && $scope.fData.devices.length){
      //         $scope.fData.devices = $scope.fData.devices.concat(data.devices);
      //       } else {
      //         $scope.fData = angular.copy(data);
      //       }
      //       if($scope.rdc == $scope.fData.devices.length){
      //         $scope.fData.isAll = true;
      //       } else {
      //         $scope.fData.isAll = false;
      //       }
      //       localStorage.setItem("fData", JSON.stringify($scope.fData));
      //       $scope.devices = angular.copy($scope.fData);
      //     }
      //     else if(caller=="advSearch"){// get adv searched devices
      //       if(isLoadMore && $scope.asData.devices.length){
      //         $scope.asData.devices = $scope.asData.devices.concat(data.devices);
      //       } else {
      //         $scope.asData = angular.copy(data);
      //       }
      //       if($scope.rdc == $scope.asData.devices.length){
      //         $scope.asData.isAll = true;
      //       } else {
      //         $scope.asData.isAll = false;
      //       }
      //       localStorage.setItem("asData", JSON.stringify($scope.asData));

      //       $scope.devices = angular.copy($scope.asData);
      //       $scope.isGbdt = false;
      //       $scope.updateList();
      //     }
      //     else if(caller=='dList'){// get device list
      //       if(isLoadMore && $scope.dData.devices.length){
      //         $scope.dData.devices = $scope.dData.devices.concat(data.devices);
      //       } else {
      //         $scope.dData = angular.copy(data);
      //       }
      //       if($scope.rdc != 0 && $scope.dData.devices.length != 0 && $scope.rdc == $scope.dData.devices.length){
      //         $scope.dData.isAll = true;
      //       } else {
      //         $scope.dData.isAll = false;
      //       }

      //       localStorage.setItem("dData", JSON.stringify($scope.dData));
      //       $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      //       if(!$scope.filterType || $scope.filterType=="all"){
      //         $scope.filterType = "";
      //         $scope.filter = "all";
      //       } else{
      //         $scope.filter = $scope.filterType;
      //       }

      //       $scope.devices = angular.copy($scope.dData);
      //       $scope.folderList = $scope.devices.folders;
      //       $scope.loadingMain = false;
      //     }

      //     $scope.updateList();
      //     $scope.setCountFx();
      //   },
      //   function(err){
      //     $log.error(err);
      //   }
      // );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.deviceListLoading = true;
      $scope.searchTextS.text = "";
      $scope.searchText = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      if($rootScope.selectedT == 1){
        //Adv search implemented
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj = $scope.advSearchInfo;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isem;
              $scope.curAdvSearchObj.isLoadMore = false;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.advSApply = false;
          $scope.deviceListLoading = true;
          $scope.filter = JSON.parse(localStorage.getItem("filterType"));
          $scope.dReqObj = {id:0, type:"s", auth:$scope.auth, offset:0, text:$scope.searchTextS.text, filter:$scope.filter, caller:'d', fId:(($scope.curFolderId > 0 && $rootScope.selectedT == 1)?$scope.curFolderId:0)};
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
        }
      } else{
        $scope.deviceListLoading = false;
      }
    }

    // if($scope.selectedTab == "hub.sContainer.sDevice"){
    // if($scope.stateName == "d"){
    //   $scope.setTabFx();
    // }
    $scope.setQuadHeightFx = function(){
      if($scope.auth.upreferences.isPopup){
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(315);
          $scope.selectedHeight = $scope.getAvailableHeight(315);
        } else{
          $scope.quadHeight = $scope.getAvailableHeight(415) * 0.6;
          $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
        }
      } else{
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(230);
          $scope.selectedHeight = $scope.getAvailableHeight(232);
        } else{
          $scope.quadHeight = $scope.getAvailableHeight(250) * 0.55;
          $scope.selectedHeight = $scope.getAvailableHeight(290) * 0.45;
        }
      }
    }
    $scope.setQuadHeightFx();

    $scope.setDate = function() {
      $scope.curSD = moment($scope.schedule.schedule.dateRange.startDate).format('MM/DD/YYYY');
      $scope.curED = moment($scope.schedule.schedule.dateRange.endDate).format('MM/DD/YYYY');

      // Set the start and end dates to the scope variables
      $scope.startDate = $scope.curSD;
      $scope.endDate = $scope.curED;

      // console.warn($scope.schedule.schedule.dateRange);

      // Use $timeout to delay the initialization of daterangepicker
      $timeout(function() {
        // Initialize the Date Range Picker with current start and end dates
        $("input[name='datetimes']").daterangepicker({
          startDate: $scope.curSD,
          endDate: $scope.curED,
        }, function(start, end, label) {
          // Update the scope variables with selected dates
          $scope.$apply(function() {
            // $scope.startDate = start.format("MM/DD/YYYY");
            // $scope.endDate = end.format("MM/DD/YYYY");

            // Update the date range in the schedule object
            $scope.schedule.schedule.dateRange = {
              startDate: start,
              endDate: end
            };
            // console.warn($scope.schedule.schedule.dateRange);
          });
        });
      });
    }

    $scope.openFolderFx = function(caller, id, splId, type){
      $scope.templatesLoading = true;
      $rootScope.selectedItems = [];
      $scope.contextMenuOpt = [];
      $scope.templates = {};
      $scope.searchTextS.text = "";
      $scope.searchText = "";
      $rootScope.commonSearchVar = "";
      if(caller == "t"){
        localStorage.setItem("curTlId", id);
        TemplatesSrv.getTemplatesContent(id).then(
          function(data){
            $scope.templates = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "tl"){
        localStorage.setItem("curTlId", id);
        TemplatesSrv.getLibraryContent(id).then(
          function(data){
            $scope.templates = data;
            $scope.updateList();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }

    $scope.getAvailableGroupsFx = function(){
      SchedulesCUSrv.getSchedulesGroups().then(
        function(data){
          $scope.sGroups = $filter('orderBy')(data, 'label');
          if(data){
            if($scope.auth.upermissions.sar || ($state.params.id && $scope.schedule.info.isCompleted && $scope.schedule.info.group.id == 0)){
              $scope.sGroups.unshift({id: 0, label: $filter("translate")('s.p_s.label.1.1')});
            } else if(!$scope.auth.upermissions.sar && $scope.sGroups.length == 1){
              $scope.schedule.info.group = $scope.sGroups[0];
              $scope.sGroupsFx();//added on 10082018
            }
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.editPermissionFx = function(){
      $scope.se = {b: 0, c: 0, d: 0, s: 0, f: 0, curStep: "", nextStep: "", isBack: 0, appliedDeviceBtn: false};
      // if($scope.selectedTab === "hub.sContainer.sName"){
      if($rootScope.stateName === "n"){
        if(!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted){
          $scope.se.s = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "s";
        } else if($scope.auth.upermissions.se.s){
          $scope.se.s = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "s";
        } else if($scope.auth.upermissions.se.c){
          $scope.se.c = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "c";
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $scope.se.d = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "d";
        } else if($scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection){
          $scope.se.f = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "f";
        }
        $scope.se.step = "np";
        // } else if($scope.selectedTab === "hub.sContainer.sSchedule"){
      } else if($rootScope.stateName === "s"){
        if(!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted){
          $scope.se.c = 1;
          $scope.se.b = 1;
          $scope.se.isBack = 1;
          $scope.se.nextStep = "c";
        } else if($scope.auth.upermissions.se.c){
          $scope.se.c = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "c";
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $scope.se.d = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "d";
        } else if($scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection){
          $scope.se.f = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "f";
        }
        if($scope.auth.upermissions.se.np){
          $scope.se.isBack = 1;
        }
        $scope.se.step = "s";
        // } else if($scope.selectedTab === "hub.sContainer.sContent"){
      } else if($rootScope.stateName === "c"){
        if(!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted){
          $scope.se.d = 1;
          $scope.se.b = 1;
          $scope.se.isBack = 1;
          $scope.se.nextStep = "d";
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $scope.se.d = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "d";
        } else if($scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection && !$scope.schedule.info.ls){
          $scope.se.f = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "f";
        } else if(!$scope.schedule.info.isCompleted && $scope.schedule.info.onceCompleted && (!$scope.auth.upermissions.se.d || !$scope.auth.upermissions.se.dt || !$scope.auth.upermissions.se.dg)){
          $scope.se.d = 0;
          $scope.se.b = 0;
          $scope.se.nextStep = "";
        } else if(!$scope.schedule.info.isCompleted && $scope.schedule.info.onceCompleted && (!$scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection)){
          $scope.se.f = 0;
          $scope.se.b = 0;
          $scope.se.nextStep = "";
        }

        if($scope.auth.upermissions.se.np || $scope.auth.upermissions.se.s){
          $scope.se.isBack = 1;
        }
        $scope.se.step = "c";
        // } else if($scope.selectedTab === "hub.sContainer.sDevice"){
      } else if($rootScope.stateName === "d"){
        $scope.getTotalDeviceCountFx();
        if(!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted){
          $scope.se.f = 1;
          $scope.se.b = 1;
          $scope.se.isBack = 1;
          $scope.se.nextStep = "f";
        } else if($scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection && !$scope.schedule.info.ls){
          $scope.se.f = 1;
          $scope.se.b = 1;
          $scope.se.nextStep = "f";
        } else if($scope.schedule.info.isCompleted && $scope.schedule.info.onceCompleted && $scope.schedule.info.ls){
          $scope.se.nextStep = "";
        }
        if($scope.auth.upermissions.se.np || $scope.auth.upermissions.se.s || $scope.auth.upermissions.se.c){
          $scope.se.isBack = 1;
        }
        if($scope.schedule.devices.search.length){
          $scope.se.appliedDeviceBtn = true;
        }
        $scope.se.step = "d";
        // } else if($scope.selectedTab === "hub.sContainer.sFrame"){
      } else if($rootScope.stateName === "f"){
        if($scope.auth.upermissions.se.np || $scope.auth.upermissions.se.c || $scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg || $scope.auth.upermissions.se.s){
          $scope.se.isBack = 1;
        }
        $scope.se.step = "f";
      }
    }

    $scope.allSelItems = {list:[]};
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $rootScope.schPriority = angular.fromJson(localStorage.getItem("schPriority"));
      // console.warn($scope.previousState);
      if($scope.previousState == "hub.schedules.s" || $scope.previousState == "hub.schedules.us" || $scope.previousState == "hub.schedules.is" || $scope.previousState == "hub.schedules.es" || $scope.previousState == "hub.devices.d" || $scope.previousState == "hub.contentLibrary.c" || $scope.previousState == "hub.dashboard" || $scope.previousState == "hub.templates.t"){
        SchedulesCUSrv.getSchedulesDetails($scope.decId).then(
          function(data){
            $scope.schedule = data.schedule;
            $scope.scheduleFirstCopy = angular.copy($scope.schedule);

            $scope.schedule.stepOne = 1;
            if(data.vw){
              $scope.vwInfo.vw = data.vw;
            }
            $scope.tempSchedule = angular.copy($scope.schedule);
            if($scope.schedule.schedule.subType == "dc"){
              $scope.dateRange.type = "m";
            } else if($scope.schedule.schedule.subType != "c"){
              //$scope.schedule.schedule.subType=="d"; //TODO What is this?
            }
            if($scope.stateName === "d"){
              $scope.setTabFx({c:"e"}); //TODO New Code 070824
            }
            $scope.isLoadedFx();
            $scope.editPermissionFx();
            if(data.sGroups){
              $scope.sGroups = $filter('orderBy')(data.sGroups, 'label');
              if($scope.auth.upermissions.sar){
                $scope.sGroups.unshift({id:0, label:$filter("translate")('s.p_s.label.1.1')});
              }
            }
            if($scope.schedule.devices.hiddenDeviceGroup == ""){
              $scope.hiddenDevices = false;
            } else{
              $scope.hiddenDevices = true;
            }
            $scope.restrictSched = data.restrictSched;
            $scope.detailLoading = false;

            //Add Data on IDB
            localStorage.setItem("scuData", true);
            $scope.addItemsDB($scope.schedule);

            $scope.tim = $scope.schedule.info.timthumb;
            $scope.cBucket = $scope.cDetailBucket = $scope.schedule.info.cBucket;
            if($scope.schedule.info.cMbucket && $scope.schedule.info.cMbucket != ""){
              $scope.cDetailBucket = $scope.schedule.info.cMbucket;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.schedule.info.tBucket;
            if($scope.schedule.info.tMbucket && $scope.schedule.info.tMbucket != ""){
              $scope.tDetailBucket = $scope.schedule.info.tMbucket;
            }
            $scope.dBucket = $scope.dDetailBucket = $scope.schedule.info.dBucket;
            if($scope.schedule.info.dMbucket && $scope.schedule.info.dMbucket != ""){
              $scope.dDetailBucket = $scope.schedule.info.dMbucket;
            }
            // if($scope.selectedTab === "hub.sContainer.sName"){
            if($rootScope.stateName === "n"){
              $scope.detailLoading = true;
              $scope.getAvailableGroupsFx();
              // } else if($scope.selectedTab === "hub.sContainer.sSchedule"){
            } else if($rootScope.stateName === "s"){
              if($scope.schedule.schedule.subType == "dc"){
                $scope.dateRange.type = "m";
              } else if($scope.schedule.schedule.subType != "c"){
                $scope.schedule.schedule.subType == "d";
              }
              if(!$scope.schedule.schedule.dateRange.startDate || !$scope.schedule.schedule.dateRange.endDate){
                if($scope.auth.upreferences.sddr == "m"){
                  $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "month")._d}
                } else if($scope.auth.upreferences.sddr == "w"){
                  $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "week")._d}
                } else {
                  $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "year")._d}
                }
              } else {
                $scope.schedule.schedule.dateRange = {
                  startDate:$filter("momentDate")($scope.schedule.schedule.dateRange.startDate),
                  endDate:$filter("momentDate")($scope.schedule.schedule.dateRange.endDate)
                }
              }
              $scope.dateRangeCopy = angular.copy($scope.schedule.schedule.dateRange);
              $scope.subTypeFx();
              // } else if($scope.selectedTab === "hub.sContainer.sContent"){
            } else if($rootScope.stateName === "c"){
              $scope.hiddenContent = false;
              angular.forEach($scope.schedule.content, function(item){
                if(!$scope.hiddenContent && item.hidden == 1){
                  $scope.hiddenContent = true;
                }
              });
              // } else if($scope.selectedTab === "hub.sContainer.sDevice"){
            } else if($rootScope.stateName === "d"){
              // console.warn("Device Section :", $scope.schedule);
              if($scope.schedule.devices.group.length){
                $scope.schedule.devices.group.forEach(function(item){
                  item.t = "g";
                });
              }
              if($scope.schedule.devices.tag.length){
                $scope.schedule.devices.tag.forEach(function(item){
                  item.t = "t";
                });
              }
              if($scope.schedule.devices.search.length){
                $scope.schedule.devices.search.forEach(function(item){
                  item.t = "s";
                });
              }
              var mergeData = angular.copy([].concat($scope.schedule.devices.device, $scope.schedule.devices.group, $scope.schedule.devices.search, $scope.schedule.devices.tag));
              $scope.allSelItems = {list:angular.copy(mergeData)};
              $scope.copySelData = angular.copy($scope.allSelItems);
            } else if($rootScope.stateName === "f"){
              $scope.accessibleFrame = false;
              $scope.saveLoadProcessing = true;
              var minmaxDate = {minStartDate:$scope.schedule.schedule.dateRange.startDate, maxEndDate:$scope.schedule.schedule.dateRange.endDate};
              if($scope.schedule.schedule.subType == "dc" && $scope.schedule.schedule.timingList.length > 0){
                minmaxDate = $filter("minmaxDate")($scope.schedule.schedule.timingList);
              }
              var payload = {
                // s:$scope.schedule.schedule.dateRange.startDate,
                // e:$scope.schedule.schedule.dateRange.endDate,
                id:$scope.schedule.info.id,
                s:moment(minmaxDate.minStartDate).format('MM/DD/YYYY'),
                e:moment(minmaxDate.maxEndDate).format('MM/DD/YYYY'),
                t:$scope.schedule.info.ls?$scope.schedule.info.ls:0, //schedule type
                dids:$scope.arraytoStringFx($scope.schedule.devices.device),
                gids:$scope.arraytoStringFx($scope.schedule.devices.group),
                tids:$scope.arraytoStringFx($scope.schedule.devices.tag),
                sids:$scope.arraytoStringFx($scope.schedule.devices.search)
              }
              // SchedulesCUSrv.layouts($scope.decId).then(
              SchedulesCUSrv.layouts(payload).then(
                function(data){
                  $scope.frameLayout = data;
                  $scope.footerLoading = false;
                  $scope.frameLayoutsCount = $scope.frameLayout.frameLayouts.length;

                  if($scope.frameLayout.frameLayouts.length > 1){
                    $scope.isAllFramesSelected = false;
                  } else{
                    $scope.isAllFramesSelected = true;
                  }
                  if($scope.frameLayout.frameLayouts.length > 0){
                    $scope.saveLoadProcessing = false;
                    $timeout(function(){
                      // if($scope.selectedTab === "hub.sContainer.sFrame"){
                      if($rootScope.stateName === "f"){
                        angular.element(document).find('.fl')[0].click();
                      }
                    }, 500);
                  } else{
                    $scope.accessibleFrame = true;
                    $scope.timer = $timeout($scope.timerFx, 1000);
                  }
                },
                function(err){
                  $log.error(err);
                }
              );
            }
            $scope.updateSelectedDevice();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        // if($scope.selectedTab === "hub.sContainer.sName"){
        if($rootScope.stateName === "n"){
          $scope.detailLoading = true;
          $scope.getAvailableGroupsFx();
        }
        $scope.getItemDB("scuData", 0, "e");
      }
    } else{
      $scope.getItemDB("scuData", 0, "c");
      var tiSchedule = angular.fromJson(localStorage.getItem("tiSchedule"));
      if(tiSchedule){
        $scope.tim = tiSchedule.tim;
        $scope.tBucket = $scope.tDetailBucket = tiSchedule.tBucket;
        if(tiSchedule.mbucket && tiSchedule.mbucket != ""){
          $scope.tDetailBucket = tiSchedule.mbucket;
        }
      }
      // if($scope.selectedTab === "hub.sContainer.sName"){
      if($rootScope.stateName === "n"){
        // For Contents
        var clSchedule = angular.fromJson(localStorage.getItem("clSchedule"));
        if(!clSchedule){
          clSchedule = [];
        }

        // For Templates
        var tSchedule = angular.fromJson(localStorage.getItem("tSchedule"));
        if(!tSchedule){
          tSchedule = [];
        }

        // For Content folder inside contents
        var clfSchedule = angular.fromJson(localStorage.getItem("clfSchedule"));
        // For Templates folder inside templates.
        var tfSchedule = angular.fromJson(localStorage.getItem("tfSchedule"));

        if(clfSchedule){
          SchedulesCUSrv.getFolderItems({m:"clf", data:{folders:clfSchedule}}).then(
            function(data){
              // console.warn("data ", data);
              if(data && data.content.length){
                var curContent = [];
                angular.forEach(data.content, function(content){
                  if(content.isApproved){
                    curContent.push(content);
                  }
                });
                // clSchedule = [].concat(data.content);
                $scope.schedule.content = clSchedule.concat(curContent);
                angular.forEach($scope.schedule.content, function(item){
                  item.hidden = 0;
                  item.mute = true;
                  if(item.type != "Widget"){
                    item.scale = $scope.auth.upreferences.scale;
                    item.dimension = item.dimension?item.dimension:item.d;
                  }
                });
                if(data && data.info){
                  $scope.tim = data.info.timthumb;
                  $scope.cBucket = $scope.cDetailBucket = data.info.bucket;
                  if(data.info.mbucket && data.info.mbucket != ""){
                    $scope.cDetailBucket = data.info.mbucket;
                  }
                }
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
        if(tfSchedule){
          CommonSrv.updateAdvSearchTM({folderIds:$scope.arraytoStringFx(tfSchedule)}).then(
            function(data){
              if(data && data.template.length){
                var curTemplate = [];
                angular.forEach(data.template, function(template){
                  if(template.isApproved){
                    curTemplate.push(template);
                  }
                });
                // clSchedule = [].concat(data.content);
                $scope.schedule.content = tSchedule.concat(curTemplate);
                angular.forEach($scope.schedule.content, function(item){
                  item.type = "template";
                  item.hidden = 0;
                });
                if(data && data.info){
                  $scope.tim = data.info.timthumb;
                  $scope.tBucket = $scope.tDetailBucket = data.info.bucket;
                  if(data.info.mbucket && data.info.mbucket != ""){
                    $scope.tDetailBucket = data.info.mbucket;
                  }
                }
              }
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        }

        $scope.schedule = {
          info: {label: "", id: 0, isCompleted: 0, onceCompleted: 0, priority: 1, toast: false, fs: true, mic:true},
          schedule: {
            dateRange: {startDate: moment()._d, endDate: moment().add(1, "month")._d},
            forever: false, type: "a", subType: "d", timingList: []
          },
          permission: {type: $scope.auth.upreferences.defaultP},
          content: clSchedule.concat(tSchedule),
          devices: {
            device: [], group: [], tag: [], search: [],
            hiddenDevice: "", hiddenDeviceGroup: "", hiddenDeviceTag: "", hiddenDeviceSearch: ""
          },
          frameLayouts: []
        };

        if($scope.schedule.content.length){
          angular.forEach($scope.schedule.content, function(item){
            if(item.type != "Widget"){
              item.scale = $scope.auth.upreferences.scale;
            }
          });
        }

        if($scope.auth.upreferences.sddr == "m"){
          $scope.schedule.schedule.dateRange = {startDate: moment()._d, endDate: moment().add(1, "month")._d}
        } else if($scope.auth.upreferences.sddr == "w"){
          $scope.schedule.schedule.dateRange = {startDate: moment()._d, endDate: moment().add(1, "week")._d}
        } else{
          $scope.schedule.schedule.dateRange = {startDate: moment()._d, endDate: moment().add(1, "year")._d}
        }

        // if(!$scope.schedule.schedule.dateRange.startDate || !$scope.schedule.schedule.dateRange.endDate){
        //   if($scope.auth.upreferences.sddr == "m"){
        //     $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "month")._d}
        //   } else if($scope.auth.upreferences.sddr == "w"){
        //     $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "week")._d}
        //   } else{
        //     $scope.schedule.schedule.dateRange = {startDate:moment()._d, endDate:moment().add(1, "year")._d}
        //   }
        // } else{
        //   $scope.schedule.schedule.dateRange = {
        //     startDate:$filter("momentDate")($scope.schedule.schedule.dateRange.startDate),
        //     endDate:$filter("momentDate")($scope.schedule.schedule.dateRange.endDate)
        //   }
        // }

        if($scope.auth.upermissions.sar){
          $scope.schedule.info.group = {id: 0, label: $filter("translate")('s.p_s.label.1.1')};
        } else{
          $scope.schedule.info.group = {};
        }
        $scope.getAvailableGroupsFx();
        $scope.editPermissionFx();

        // Todo we need to add code here
        if($scope.celEventBack && $scope.celEventBack.back){
          $scope.schedule.info.label = $scope.celEventBack.label;
        }
      }


      $rootScope.schPriority = angular.fromJson(localStorage.getItem("schPriority"));
      $scope.updateSelectedDevice();

      // if($scope.stateName === "d"){
      //   $scope.setTabFx({c:"c"}); //TODO New Code 070824
      // }
    }

    $scope.getTooltip = function(isApproved, expiring, caller){
      if(caller == "Music Choice" && $scope.isNonSelectable){
        $scope.curTooltip = $filter("translate")('s.tool.6');
      } else if(caller == "Zkong" && $scope.isNonSelectable){
        $scope.curTooltip = $filter("translate")('s.tool.7');
      } else{
        $scope.curTooltip = "";
      }
      return $scope.curTooltip;
    }

    $scope.selectAllSDFx = function(){
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt' && $rootScope.selectedT == 1 && ($scope.devices.info.count / $scope.devices.info.pl > 1)){
        if($scope.devices.info.allIds){
          CommonSrv.selectAllSD($scope.devices.info.allIds.join()).then(
            function(data){
              $scope.allSelectedDevices = data;
              $scope.briefFx();
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          SchedulesCUSrv.getGroupDevices($scope.curDType.type, $scope.decId).then(
            function(data){
              $scope.allSelectedDevices = data;
              $scope.briefFx();
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.getAdvSearchFx = function(offset){
      $scope.advSearchInfo.offset = offset;
      CommonSrv.updateAdvSearch($scope.advSearchInfo).then(
        function(data){
          $scope.paginationLoading = false;
          $scope.isGbdt = false;
          $scope.devices = data;
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
        },
        function(err){
          $log.error(err);
          $scope.searchProcessing = false;
        }
      );
    }

    $scope.devicePreviewFx = function(){
      $scope.paginationControls.currPage = 1;
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    }

    $scope.getTypesFx = function(caller){
      $scope.allSelectedDevices = {devices: []};
      $scope.deviceListLoading = true;
      localStorage.removeItem("curDTypeS");
      $scope.curDType = "";
      $scope.breadCrumbs = [];
      $scope.isGbdt = true;
      $scope.devices = {};
      if(caller == "home"){
        $scope.breadCrumbs = [];
      }
      DevicesSrv.getDType($scope.schedule.info.ls, "s").then(
        function(data){
          $scope.deviceListLoading = false;
          if(data.code == 12064){
            $scope.auth.upermissions.gbdt = false;
            localStorage.setItem('auth', JSON.stringify($scope.auth));
            $scope.isLoadedFx();
          } else{
            if($scope.schedule.info.ls == 1 || $scope.schedule.info.ls == 2){
              $scope.deviceTypes = {info: data.info, types: $filter("filter")(data.types, {type: "desktop"})};
              localStorage.setItem('curDTypeS', JSON.stringify($scope.deviceTypes.types[0]));
            } else if($scope.schedule.info.ls == 3){
              $scope.deviceTypes = {info: data.info, types: $filter("filter")(data.types, {type: "epd"})};
              localStorage.setItem('curDTypeS', JSON.stringify($scope.deviceTypes.types[0]));
            } else if($scope.schedule.info.ls == 4 || $scope.schedule.info.ls == 5){
              $scope.deviceTypes = {
                info: data.info,
                types: $filter("filter")(data.types, function(data){
                  if(data.type != "desktop" && data.type != "mc"){
                    return data;
                  }
                })
              };
            } else{
              $scope.deviceTypes = data;
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.openVideoWallFx = function(wall){
      $scope.deviceListLoading = true;
      $scope.vwBreadCrumbs = [wall];
      SchedulesCUSrv.getVWDevices(wall.id).then(
        function(data){
          $scope.devices = data;
          $scope.deviceListLoading = false;
          // $scope.devices.devices = $scope.sDeviceList.devices;
        },
        function(err){
          $scope.deviceListLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.getVideoWallFx = function(caller){
      $scope.deviceListLoading = true;
      $scope.devices = {};
      if(caller == "home"){
        $scope.vwBreadCrumbs = [];
      }
      DevicesSrv.getVideoWalls().then(
        function(data){
          $scope.devices = {walls:data.videowalls};
          $scope.deviceListLoading = false;
        },
        function(err){
          $scope.deviceListLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.openTypeFx = function(type, page, caller){
      localStorage.setItem('curDTypeS', JSON.stringify(type));
      $scope.deviceListLoading = true;
      $rootScope.commonSearchVar = "";
      $scope.searchTextS.text = "";
      $rootScope.selectedItems = [];
      $scope.contextMenuOpt = [];
      $scope.breadCrumbs = [type];
      $scope.deviceTypes = {};
      $scope.searchText = "";
      $scope.curDType = type;
      $scope.devices = {};
      if(!caller){
        localStorage.setItem("filterType", JSON.stringify("all"));
      }
      SchedulesCUSrv.getGroupDevices(type.type, $scope.decId, 0).then(
        function(data){
          $scope.deviceListLoading = false;
          if(data.code == 12064){
            $scope.auth.upermissions.gbdt = false;
            localStorage.setItem('auth', JSON.stringify(type));
            $scope.isLoadedFx();
          } else {
            $scope.isGbdt = false;
            $scope.devices = data;
            if($scope.devices.length){
              $scope.devicesLength = $scope.devices.info.count;
            }
          }
          $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
          if(!$scope.filterType || $scope.filterType == "all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.filter = $scope.filterType;
            $scope.fCount = $filter("filter")($scope.devices.devices, {status: $scope.filterType}, true);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.isLoadedFx = function(caller){
      // console.warn("isLoadedFx");
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      // if($scope.selectedTab === "hub.sContainer.sSchedule"){
      if($rootScope.stateName === "s"){
        if($scope.schedule.info.ls==3){
          $scope.schedule.schedule.forever = true;
        }
        $scope.customTime = {startTime:moment().format(), endTime:moment().add(5, "m").format()};
        $(document).on("click", ".input-group-addon", function(e){
          e.preventDefault();
          e.stopPropagation();
          if(!$(this).siblings(".picker").is(':disabled')){
            $(this).siblings(".picker").click();
          }
        });
        $scope.subTypeFx = function(){
          if($scope.schedule.schedule.type == "c" && $scope.schedule.schedule.subType == "dc"){
            $scope.schedule.schedule.subType = "d";
          }
          if($scope.schedule.schedule.subType == "d"){
            $scope.customTime.frequency = $filter("translate")('s.p_s.label.4.1');
            $scope.curDays = [{id: 0, label: $filter("translate")('s.p_s.label.4.1')}];
            $scope.customTime.days = [0];
          } else if($scope.schedule.schedule.subType == "w"){
            $scope.customTime.frequency = $filter("translate")('s.p_s.label.4.2');
            $scope.curDays = [
              {id: 1, label: $filter("translate")('s.p_s.label.4.2.1')},
              {id: 2, label: $filter("translate")('s.p_s.label.4.2.2')},
              {id: 3, label: $filter("translate")('s.p_s.label.4.2.3')},
              {id: 4, label: $filter("translate")('s.p_s.label.4.2.4')},
              {id: 5, label: $filter("translate")('s.p_s.label.4.2.5')},
              {id: 6, label: $filter("translate")('s.p_s.label.4.2.6')},
              {id: 7, label: $filter("translate")('s.p_s.label.4.2.7')}
            ];
            $scope.customTime.days = [1];
          } else if($scope.schedule.schedule.subType == "m"){
            $scope.customTime.frequency = $filter("translate")('s.p_s.label.4.3');
            $scope.customTime.days = [1];
          } else{
            if($scope.schedule.schedule.subType == 'dce'){
              $scope.schedule.schedule.forever = 0;
            }
            $scope.customTime.frequency = $filter("translate")('s.p_s.label.4.4.1');
            $scope.customTime.days = 1;
          }
        }

        $scope.addTimingFx = function(){
          $scope.hasErr = false;
          $scope.tempDays = [];
          $scope.errType = "";
          $scope.curSTime = $filter("date")($scope.customTime.startTime, "HH:mm");
          $scope.curETime = $filter("date")($scope.customTime.endTime, "HH:mm");
          $scope.calculatedStartTime = new Date($scope.customTime.startTime).getTime() / 1000;
          $scope.calculatedEndTime = new Date($scope.customTime.endTime).getTime() / 1000;
          if($scope.curETime == "00:00"){
            $scope.deductSec = new Date($scope.customTime.endTime).getSeconds() + 1;
            $scope.calculatedEndTime = ($scope.calculatedEndTime - $scope.deductSec) + 86400;
          }

          if($scope.curSTime == null){
            $scope.errType = "start";
            $scope.hasErr = true;
          } else if($scope.curETime == null){
            $scope.errType = "end";
            $scope.hasErr = true;
          } else if($scope.calculatedEndTime - $scope.calculatedStartTime <= 0){
            $scope.errType = "time";
            $scope.hasErr = true;
          } else if($scope.customTime.days > 365){
            $scope.errType = "repeat";
            $scope.hasErr = true;
          } else{
            if($scope.customTime.days && $scope.schedule.schedule.subType == "d"){
              for(var i = 0;i < $scope.schedule.schedule.timingList.length;i++){
                if($scope.curSTime >= $scope.schedule.schedule.timingList[i].startTime && $scope.curSTime <= $scope.schedule.schedule.timingList[i].endTime || $scope.curETime >= $scope.schedule.schedule.timingList[i].startTime && $scope.curETime <= $scope.schedule.schedule.timingList[i].endTime){
                  $scope.errType = "timeRange";
                  $scope.hasErr = true;
                  return;
                }
              }
            }

            if($scope.customTime.days && ($scope.schedule.schedule.subType == "w" || $scope.schedule.schedule.subType == "r" || $scope.schedule.schedule.subType == "m")){
              for(var i = 0;i < $scope.schedule.schedule.timingList.length;i++){
                if($scope.schedule.schedule.timingList[i].day == $scope.customTime.days && ($scope.curSTime >= $scope.schedule.schedule.timingList[i].startTime && $scope.curSTime <= $scope.schedule.schedule.timingList[i].endTime || $scope.curETime >= $scope.schedule.schedule.timingList[i].startTime && $scope.curETime <= $scope.schedule.schedule.timingList[i].endTime)){
                  $scope.errType = "sameDate";
                  $scope.hasErr = true;
                  return;
                }
              }
            }
            if($scope.customTime.days && ($scope.schedule.schedule.subType == "d" || $scope.schedule.schedule.subType == "w")){
              angular.forEach($scope.curDays, function(day){
                angular.forEach($scope.customTime.days, function(curDay){
                  if(day.id == curDay){
                    $scope.tempDays.push({frequency: $scope.customTime.frequency, day: day.id, label: day.label, startTime: $scope.curSTime, endTime: $scope.curETime});
                  }
                });
              });
            } else if($scope.customTime.days && $scope.schedule.schedule.subType == "m"){
              angular.forEach($scope.customTime.days, function(day){
                $scope.tempDays.push({frequency: $scope.customTime.frequency, day: day, label: day, startTime: $scope.curSTime, endTime: $scope.curETime});
              });
            } else if($scope.customTime.days && $scope.schedule.schedule.subType == "r"){
              $scope.tempDays.push({frequency: $scope.customTime.frequency, day: $scope.customTime.days, label: $scope.customTime.days, startTime: $scope.curSTime, endTime: $scope.curETime});
            }
            $scope.customTime = $scope.tempDays;
            $scope.schedule.schedule.timingList.push.apply($scope.schedule.schedule.timingList, $scope.customTime);
            $scope.customTime = {startTime: moment().format(), endTime: moment().add(5, "m").format()};
            $scope.subTypeFx();
          }
        }
        $scope.removeTimingOpen = function(index){
          $scope.removeTimingObg = {index: index};
          ngDialog.open({
            template: '\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeTimingFx(removeTimingObg.index);">{{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                </footer>\
              </section>',
            plain: true,
            width: 480,
            scope: $scope,
            closeByDocument: false,
            className: 'ngdialog-theme-default ngdialog-confirm',
          });
        }
        $scope.removeTimingFx = function(index){
          $scope.schedule.schedule.timingList.splice(index, 1);
          $scope.tempSchedule.schedule.timingList = angular.copy($scope.schedule.schedule.timingList);
          ngDialog.close();
        }

        //used for exclude date range validation
        $scope.excludeDRValidate = function(action){
          $scope.invalidExclude = false;
          $scope.curDate = angular.element(document).find(".picker").val();
          $scope.curDate = $scope.curDate.split(" - ");
          $scope.mainDate = {startDate: moment($scope.curDate[0]).format('YYYY-MM-DD'), endDate: moment($scope.curDate[1]).format('YYYY-MM-DD')};

          $scope.curExDate = angular.element(document).find(".ex-picker").val();
          $scope.curExDate = $scope.curExDate.split(" - ");
          $scope.custExDate = {startDate: moment($scope.curExDate[0]).format('YYYY-MM-DD'), endDate: moment($scope.curExDate[1]).format('YYYY-MM-DD')};

          if(action == 'save'){
            for(var i = 0;i < $scope.schedule.schedule.timingList.length;i++){
              if(($scope.mainDate.startDate >= $scope.schedule.schedule.timingList[i].startDate || $scope.mainDate.endDate <= $scope.schedule.schedule.timingList[i].endDate)){
                $scope.invalidExclude = true;
                break;
              }
            }
          } else{
            if(($scope.mainDate.startDate >= $scope.custExDate.startDate || $scope.mainDate.endDate <= $scope.custExDate.endDate)){
              $scope.invalidExclude = true;
            }
          }
          return $scope.invalidExclude;
        }

        $scope.addMultipleDateFx = function(){
          $scope.hasErr = false;
          $scope.isSameDate = false;
          if($scope.dateRange.type == 'm'){
            $scope.schedule.schedule.type = "a";
            $scope.schedule.schedule.subType = "dc";
          }
          if($scope.dateRange.type == "m"){
            $scope.curDate = angular.element(document).find(".picker").val();
            $scope.curDate = $scope.curDate.split(" - ");
            $scope.customDate = {startDate: moment($scope.curDate[0]).format('YYYY-MM-DD'), endDate: moment($scope.curDate[1]).format('YYYY-MM-DD')};
            for(var i = 0;i < $scope.schedule.schedule.timingList.length;i++){
              if($scope.schedule.schedule.timingList[i].startDate <= $scope.customDate.endDate && $scope.schedule.schedule.timingList[i].endDate >= $scope.customDate.startDate){
                $scope.isSameDate = true;
                $scope.errType = "sameDate";
                $scope.hasErr = true;
                break;
              }
              if($scope.schedule.schedule.timingList[i].startDate == $scope.customDate.startDate && $scope.schedule.schedule.timingList[i].endDate == $scope.customDate.endDate){
                $scope.isSameDate = true;
                $scope.errType = "sameDate";
                $scope.hasErr = true;
                break;
              }
            }
            if(!$scope.isSameDate){
              $scope.customDate.ex = [];
              $scope.schedule.schedule.timingList.push($scope.customDate);
            }
          } else if($scope.schedule.schedule.subType == "dce"){
            $scope.invalidExclude = $scope.excludeDRValidate();
            if($scope.invalidExclude){
              $scope.errType = "inExclude";
              $scope.hasErr = true;
              return;
            }
            for(var i = 0;i < $scope.schedule.schedule.timingList.length;i++){
              if(($scope.schedule.schedule.timingList[i].startDate <= $scope.custExDate.endDate && $scope.schedule.schedule.timingList[i].endDate >= $scope.custExDate.startDate) || ($scope.schedule.schedule.timingList[i].startDate == $scope.custExDate.startDate && $scope.schedule.schedule.timingList[i].endDate == $scope.custExDate.endDate)){
                $scope.isSameDate = true;
                $scope.errType = "sameDate";
                $scope.hasErr = true;
                break;
              }
            }
            if(!$scope.isSameDate && !$scope.invalidExclude){
              $scope.schedule.schedule.timingList.push($scope.custExDate);
            }
          }
        }

        $scope.resetFx = function(type){
          $scope.hasErr = false;
          $scope.schedule.schedule.subType = $scope.tempSchedule.schedule.subType;
          if($scope.schedule.schedule.subType != type){
            $scope.schedule.schedule.timingList = [];
          } else {
            $scope.schedule.schedule.timingList = angular.copy($scope.tempSchedule.schedule.timingList);
          }
          $scope.subTypeFx();
        }
        // } else if($scope.selectedTab === "hub.sContainer.sContent"){
      } else if($rootScope.stateName === "c"){
        $scope.contentLibraryLoading = true;
        $scope.templatesLoading = true;

        $scope.setTabFx({c:"cl"});

        if($scope.schedule.schedule.type == "a" || $scope.schedule.schedule.subType == "d"){
          $scope.isNonSelectable = false;
        }

        $scope.curFolderIds = localStorage.getItem("folderId");
        if($scope.curFolderIds == undefined){
          $scope.curFolderIds = 0;
        }

        var ls = $scope.schedule.info.ls?$scope.schedule.info.ls:0; //schedule type
        var dAPIObj = {
          fId:$scope.curFolderIds,
          dr:[],
          t:ls
        }

        if($scope.schedule.schedule.timingList.length){
          angular.forEach($scope.schedule.schedule.timingList, function(tl){
            dAPIObj.dr.push({
              s:moment($scope.schedule.schedule.dateRange.startDate).format('MM/DD/YYYY'),
              e:moment($scope.schedule.schedule.dateRange.endDate).format('MM/DD/YYYY'),
              st:tl.startTime,
              et:tl.endTime
            });
          });
        } else{
          dAPIObj.dr.push({s:moment($scope.schedule.schedule.dateRange.startDate).format('MM/DD/YYYY'), e:moment($scope.schedule.schedule.dateRange.endDate).format('MM/DD/YYYY')});
        }

        if($scope.schedule.info.ls !== 3){
          SchedulesCUSrv.getApproved(dAPIObj).then(
            // ContentLibrarySrv.getFolderApprovedContent($scope.curFolderIds).then(
            function(data){
              if(data.code && data.code == 8117){
                $scope.folderContentFx(0);
              } else{
                $scope.contentLibrary = data;
                $scope.tim = $scope.contentLibrary.info.timthumb;
                $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
                if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
                  $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
                }
                $scope.updateList();
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
        $scope.curTemplates = "";
        if(!$scope.schedule.info.ls || $scope.schedule.info.ls == 6){
          // TemplatesSrv.getTemplatesScenes().then(
          $scope.curTFolderId = localStorage.getItem("inTFolder");
          if($scope.curTFolderId == undefined){
            $scope.curTFolderId = 0;
          }
          TemplatesSrv.getTemplatesContent($scope.curTFolderId).then(
            function(data){
              $scope.curTemplates = data;
              $scope.templates = data;
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.schedule.info.ls == 3){
          $scope.curTFolderId = localStorage.getItem("inTFolder");
          if($scope.curTFolderId == undefined){
            $scope.curTFolderId = 0;
          }
          TemplatesSrv.getESLTemplates($scope.curTFolderId).then(
            function(data){
              $scope.curTemplates = data;
              $scope.templates = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        $rootScope.selectedTabFx = function(){
          $scope.searchChangeFx("empty");
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.breadCrumbs = [];
          if($rootScope.selectedT == 1){
            $scope.advancedShow = false;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.updateList();
          } else if($rootScope.selectedT == 2){
            $scope.advancedShow = false;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.templates = $scope.curTemplates;
            if($scope.advSApply){
              $scope.quadHeight = $scope.getAvailableHeight(320);
              $scope.selectedHeight = $scope.getAvailableHeight(320);
            }
            $scope.updateList();
          }
          $scope.setQuadHeightFx();
        }

        $scope.sortCallback = function(e, ui, index){
          $scope.contentListCopy = angular.copy($scope.schedule.content);
          $scope.tempContentList = [];
          $(".sortable-item").each(function($index){
            for(var i = 0;i < $scope.contentListCopy.length;i++){
              if(($scope.contentListCopy[i].id == $(this).attr("data-id")) && ($scope.contentListCopy[i].duration == $(this).find(".duration").val())){
                $scope.tempContentList.push($scope.contentListCopy[i]);
                $scope.contentListCopy.splice(i, 1);
                break;
              }
            }
          });
          $scope.schedule.content = [];
          $scope.$apply(function(){
            $scope.schedule.content = angular.copy($scope.tempContentList);
          });
        }

        $scope.curItem;
        $scope.isDuplicate = false;
        $scope.briefFx = function(){
          $scope.timestamp = moment().format('x');
          $scope.mic = false;
          if($scope.schedule.info.mic){
            $scope.mic = true;
          }

          angular.forEach($rootScope.selectedItems, function(item, index){
            if(item.type == "content" || item.type == "widget" || item.type == "SharePointC" || item.type == "OneDriveC" || item.type == "GoogleDriveC"){
              $scope.curItem = $scope.contentList.filter(function(obj){return obj.id == item.id;})[0];
              // console.warn("$scope.curItem ", $scope.curItem);
              var curFId = 0;
              if($scope.curItem.folderid){
                curFId = $scope.curItem.folderid;
              } else if($scope.curItem.fid){
                curFId = $scope.curItem.fid;
              } else if($scope.curItem.fId){
                curFId = $scope.curItem.fId;
              }
              if(item.type == "SharePointC"){
                $scope.curScale = null;
                if($scope.curItem.type != "Widget"){
                  $scope.curScale = $scope.auth.upreferences.scale;
                }
                $scope.schedule.content.push({
                  hidden: 0,
                  id: item.id,
                  fId: curFId,
                  fid: curFId,
                  folderid: curFId,
                  mute: $scope.mic,
                  fullscreen: false,
                  scale: $scope.curScale,
                  userid: $scope.auth.uid,
                  url: $scope.curItem.url,
                  type: $scope.curItem.type,
                  extn: $scope.curItem.extn,
                  btnExtn: $scope.curItem.btnExtn,
                  size: $scope.curItem.size,
                  pSize: $scope.curItem.pSize,
                  label: $scope.curItem.label,
                  thumb: $scope.curItem.thumb,
                  spfid: $scope.curItem.spfid,
                  splFid: $scope.curItem.splFid,
                  Length: $scope.curItem.Length,
                  duration: $scope.curItem.duration,
                  path: $scope.contentLibrary.info.path,
                  isCompleted: $scope.curItem.isCompleted,
                  MajorVersion: $scope.curItem.MajorVersion,
                  activePeriod: $scope.curItem.activePeriod,
                  ServerRelativeUrl: $scope.curItem.ServerRelativeUrl,
                  isAccessible: $scope.contentLibrary.info.isAccessible,
                  dimension: $scope.curItem.dimension?$scope.curItem.dimension:$scope.curItem.d
                });
              } else if(item.type == "OneDriveC"){
                $scope.curScale = null;
                if($scope.curItem.type != "Widget"){
                  $scope.curScale = $scope.auth.upreferences.scale;
                }
                $scope.schedule.content.push({
                  hidden: 0,
                  mute: $scope.mic,
                  id: item.id,
                  fId: curFId,
                  fid: curFId,
                  folderid: curFId,
                  fullscreen: false,
                  scale: $scope.curScale,
                  userid: $scope.auth.uid,
                  url: $scope.curItem.url,
                  type: $scope.curItem.type,
                  extn: $scope.curItem.extn,
                  btnExtn: $scope.curItem.btnExtn,
                  size: $scope.curItem.size,
                  label: $scope.curItem.label,
                  thumb: $scope.curItem.thumb,
                  spfid: $scope.curItem.spfid,
                  splFid: $scope.curItem.splFid,
                  Length: $scope.curItem.Length,
                  duration: $scope.curItem.duration,
                  path: $scope.contentLibrary.info.path,
                  isCompleted: $scope.curItem.isCompleted,
                  MajorVersion: $scope.curItem.MajorVersion,
                  ServerRelativeUrl: $scope.curItem.ServerRelativeUrl,
                  isAccessible: $scope.contentLibrary.info.isAccessible,
                  dimension: $scope.curItem.dimension?$scope.curItem.dimension:$scope.curItem.d
                });
              } else if(item.type == "GoogleDriveC"){
                $scope.curScale = null;
                if($scope.curItem.type != "Widget"){
                  $scope.curScale = $scope.auth.upreferences.scale;
                }
                $scope.schedule.content.push({
                  hidden: 0,
                  mute: $scope.mic,
                  id: item.id,
                  fId: curFId,
                  fid: curFId,
                  folderid: curFId,
                  fullscreen: false,
                  scale: $scope.curScale,
                  userid: $scope.auth.uid,
                  url: $scope.curItem.url,
                  type: $scope.curItem.type,
                  extn: $scope.curItem.extn,
                  btnExtn: $scope.curItem.btnExtn,
                  size: $scope.curItem.size,
                  pSize: $scope.curItem.pSize,
                  label: $scope.curItem.label,
                  thumb: $scope.curItem.thumb,
                  spfid: $scope.curItem.spfid,
                  splFid: $scope.curItem.splFid,
                  Length: $scope.curItem.Length,
                  duration: $scope.curItem.duration,
                  path: $scope.contentLibrary.info.path,
                  isCompleted: $scope.curItem.isCompleted,
                  MajorVersion: $scope.curItem.MajorVersion,
                  activePeriod: $scope.curItem.activePeriod,
                  ServerRelativeUrl: $scope.curItem.ServerRelativeUrl,
                  isAccessible: $scope.contentLibrary.info.isAccessible,
                  dimension: $scope.curItem.dimension?$scope.curItem.dimension:$scope.curItem.d
                });
              } else{
                $scope.curScale = null;
                if($scope.curItem.type != "Widget"){
                  $scope.curScale = $scope.auth.upreferences.scale;
                }
                if($scope.schedule.info.ls == 3){
                  $scope.schedule.content = [];
                  $scope.schedule.content.push({
                    hidden: 0,
                    mute: $scope.mic,
                    id: item.id,
                    fId: curFId,
                    fid: curFId,
                    folderid: curFId,
                    fullscreen: false,
                    scale: $scope.curScale,
                    userid: $scope.auth.uid,
                    url: $scope.curItem.url,
                    type: $scope.curItem.type,
                    extn: $scope.curItem.extn,
                    size: $scope.curItem.size,
                    pSize: $scope.curItem.pSize,
                    btnExtn: $scope.curItem.btnExtn,
                    label: $scope.curItem.label,
                    thumb: $scope.curItem.thumb,
                    splFid: $scope.curItem.splFid,
                    Length: $scope.curItem.Length,
                    caption: $scope.curItem.caption,
                    duration: $scope.curItem.duration,
                    path: $scope.contentLibrary.info.path,
                    isCompleted: $scope.curItem.isCompleted,
                    activePeriod: $scope.curItem.activePeriod,
                    dimension: $scope.curItem.dimension?$scope.curItem.dimension:$scope.curItem.d
                  });
                } else {
                  $scope.schedule.content.push({
                    hidden: 0,
                    mute: $scope.mic,
                    id: item.id,
                    fId: curFId,
                    fid: curFId,
                    folderid: curFId,
                    fullscreen: false,
                    ss: $scope.curItem.ss,
                    ssImg: $scope.curItem.ssImg,
                    scale: $scope.curScale,
                    userid: $scope.auth.uid,
                    url: $scope.curItem.url,
                    type: $scope.curItem.type,
                    extn: $scope.curItem.extn,
                    size: $scope.curItem.size,
                    pSize: $scope.curItem.pSize,
                    btnExtn: $scope.curItem.btnExtn,
                    label: $scope.curItem.label,
                    thumb: $scope.curItem.thumb,
                    splFid: $scope.curItem.splFid,
                    Length: $scope.curItem.Length,
                    duration: $scope.curItem.duration,
                    path: $scope.contentLibrary.info.path,
                    isCompleted: $scope.curItem.isCompleted,
                    caption: $scope.curItem.caption,
                    captionSel: $scope.curItem.captionSel,
                    captionLang: $scope.curItem.captionLang,
                    activePeriod: $scope.curItem.activePeriod,
                    dimension: $scope.curItem.dimension?$scope.curItem.dimension:$scope.curItem.d
                  });
                }
              }
            } else if(item.type == "template"){
              $scope.curItem = $scope.templateList.filter(function(obj){return obj.id == item.id;})[0];
              var curFId = 0;
              if($scope.curItem.folderid){
                curFId = $scope.curItem.folderid;
              } else if($scope.curItem.fid){
                curFId = $scope.curItem.fid;
              } else if($scope.curItem.fId){
                curFId = $scope.curItem.fId;
              }
              if($scope.schedule.info.ls == 3){
                $scope.schedule.content = [];
              }
              $scope.schedule.content.push({
                hidden: 0,
                id: item.id,
                fId: curFId,
                fid: curFId,
                folderid: curFId,
                type: "template",
                mute: $scope.mic,
                fullscreen: false,
                userid: $scope.auth.uid,
                tType: $scope.curItem.tType,
                label: $scope.curItem.label,
                thumb: $scope.curItem.thumb,
                thumbV: $scope.curItem.thumbV,
                duration: $scope.curItem.duration,
                path: $scope.curTemplates.info.path,
                isCompleted: $scope.curItem.isCompleted
              });
            }
          });
        }
        $scope.closeFilteredFx = function(id, index){
          for(var i = 0;i < $scope.schedule.content.length;i++){
            if($scope.schedule.content[i].id == id){
              $scope.schedule.content.splice(i, 1);
              break;
            }
          }
          angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
            if($(item).attr('data-id') == id){
              $(item).removeClass('ui-selected');
              $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
            }
          });
        }
        // } else if($scope.selectedTab === "hub.sContainer.sDevice"){
      } else if($rootScope.stateName === "d"){
        $scope.getTotalDeviceCountFx();
        $scope.changeDataTab(caller);
        $rootScope.selectedTabFx = function(){
          $scope.deviceListLoading = true;
          $rootScope.addStatusKeyVal.value = true;
          $scope.searchTextS.text = "";
          $scope.searchText = "";
          $scope.changeDataTab();
          $scope.advSearchInfo = {};
          $scope.breadCrumbs = [];
          if(!$scope.advSApply){
            $scope.advSearchInfo = {};
          }
          localStorage.removeItem("curDTypeS");
          if($rootScope.selectedT == 1){
            $scope.getTotalDeviceCountFx();
            $rootScope.addStatusKeyVal.value = false;
            // setTimeout(function(){
            //   $scope.advSearchInfo = {};
            //   $scope.$apply()
            // }, 0);
            $scope.devices = {};
            if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
              $scope.getTypesFx();
              // } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df'){
            }
            // else if($scope.totalDeviceOnServer > $scope.auth.upreferences.dpc){
            //   $scope.devices.devices = $scope.sDeviceList.devices;
            //   $scope.devices.folders = $scope.sDeviceList.folders;
            //   $scope.folderList = $scope.sDeviceList.folders;
            // } else{
            //   $scope.devices.devices = $scope.sDeviceList.devices;
            // }

            if(!$scope.filterType || $scope.filterType == "all"){
              $scope.fCount = $scope.devices.devices;
            } else {
              $scope.fCount = $filter("filter")($scope.devices.devices, {status: $scope.filterType}, true);
            }
            $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.12');
            $scope.epdDeviceConflictMsg = $filter("translate")('s.p_s.msg.59');

            $scope.dReqObj.offset = 0;
            $scope.paginationControls.currPage = 1;
            $scope.apiCalledArr = [];
            $scope.updateList();
          } else if($rootScope.selectedT == 2){
            $rootScope.addStatusKeyVal.value = false;
            setTimeout(function(){
              $scope.advSearchInfo = {};
              if($scope.advSApply){
                $scope.quadHeight = $scope.getAvailableHeight(320);
                $scope.selectedHeight = $scope.getAvailableHeight(320);
              }
              $scope.$apply()
            }, 0);
            $scope.devices.devices = $scope.sDeviceList.tags;
            
            /*EPD Select device > Tag*/
            $scope.dtMsgEpd1 = $filter("translate")('s.p_s.msg.59-2');
            $scope.dtMsgEpd2 = $filter("translate")('s.p_s.msg.59-3');
            $scope.dtMsgEpd3 = $filter("translate")('s.p_s.msg.59-4');

            $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.25');

          } else if($rootScope.selectedT == 3){
            $rootScope.addStatusKeyVal.value = false;
            setTimeout(function(){
              $scope.advSearchInfo = {};
              if($scope.advSApply){
                $scope.quadHeight = $scope.getAvailableHeight(320);
                $scope.selectedHeight = $scope.getAvailableHeight(320);
              }
              $scope.$apply()
            }, 0);
            $scope.devices = {devices: $scope.sDeviceList.groupss, searches: $scope.sDeviceList.searches};
            $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.13');
            $scope.deviceConflictMsg1 = $filter("translate")('s.p_s.msg.33');
            $scope.conflictSearchMsg = $filter("translate")('s.p_s.msg.34');
            $scope.conflictSearchMsg1 = $filter("translate")('s.p_s.msg.35');

            /*EPD Select device > Group*/
            $scope.dgMsgEpd1 = $filter("translate")('s.p_s.msg.59-5');
            $scope.dgMsgEpd2 = $filter("translate")('s.p_s.msg.59-6');
            $scope.dgMsgEpd3 = $filter("translate")('s.p_s.msg.59-7');
            
          } else if($rootScope.selectedT == 4){
            $scope.deviceListLoading = true;
            $scope.vwBreadCrumbs = [];
            DevicesSrv.getVideoWalls().then(
              function(data){
                $scope.devices = {walls:data.videowalls};
                $scope.deviceListLoading = false;
              },
              function(err){
                $scope.deviceListLoading = false;
                $log.error(err);
              }
            );
          }
        }

        $scope.briefFx = function(){
          $scope.selectedSearch.text = "";
          $scope.allSelItems = {list:[]};
          $scope.curDevices = angular.copy($scope.devices.devices);
          if($scope.allSelectedDevices.devices.length){
            $scope.curDevices = angular.copy($scope.allSelectedDevices.devices);
            if($scope.devices.info.allIds){
              angular.forEach($scope.devices.info.allIds, function(item){
                $rootScope.selectedItems.push({id: item, type: "device", subType: "device"});
              });
            } else {
              angular.forEach($scope.curDevices, function(item){
                $rootScope.selectedItems.push({id: item.id, type: "device", subType: "device"});
              });
            }
          }

          angular.forEach($rootScope.selectedItems, function(item){
            if(item.type == "device"){
              $scope.isDuplicate = false;
              angular.forEach($scope.schedule.devices.device, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              angular.forEach($scope.curDevices, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.curDevices.filter(function(obj){return obj.id == item.id;})[0];
                if($scope.auth.upreferences.deviceView == 'l'){
                  $scope.curItem.tv = $scope.curItem.id;
                }
                $scope.schedule.devices.device.push({id: item.id, label: $scope.curItem.l, thumbV: $scope.curItem.tv, mac: $scope.curItem.h, dType: $rootScope.dTypeObj[$scope.curItem.t], t: $scope.curItem.t, status: $filter('isDeviceOnline')($scope.curItem.lp, {minDeduct: $scope.auth.upreferences.dot}), assignments: $scope.curItem.assignments, frame: $scope.curItem.frame, layout: $scope.curItem.layout});
              }
            } else if(item.type == "tag"){
              $scope.isDuplicate = false;
              angular.forEach($scope.schedule.devices.tag, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              angular.forEach($scope.sDeviceList.tags, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.sDeviceList.tags.filter(function(obj){return obj.id == item.id;})[0];
                $scope.schedule.devices.tag.push({id: item.id, label: $scope.curItem.label, tagColor: $scope.curItem.tagColor});
              }
            } else if(item.type == "group"){
              $scope.isDuplicate = false;
              angular.forEach($scope.schedule.devices.group, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.sDeviceList.groups.length){
                $scope.sDeviceList.groups = [];
              }
              angular.forEach($scope.sDeviceList.groups, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.sDeviceList.groups.filter(function(obj){return obj.id == item.id;})[0];
                $scope.schedule.devices.group.push({id: item.id, label: $scope.curItem.label});
              }
            } else if(item.type == "search"){
              $scope.isDuplicate = false;
              angular.forEach($scope.schedule.devices.search, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              angular.forEach($scope.sDeviceList.searches, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.sDeviceList.searches.filter(function(obj){return obj.id == item.id;})[0];
                $scope.schedule.devices.search.push({id: item.id, label: $scope.curItem.label});
              }
            }
          });
          if($scope.schedule.devices.group.length){
            $scope.schedule.devices.group.forEach(function(item){
              item.t = "g";
            });
          }
          if($scope.schedule.devices.tag.length){
            $scope.schedule.devices.tag.forEach(function(item){
              item.t = "t";
            });
          }
          if($scope.schedule.devices.search.length){
            $scope.schedule.devices.search.forEach(function(item){
              item.t = "s";
            });
          }
          var mergeData = angular.copy([].concat($scope.schedule.devices.device, $scope.schedule.devices.group, $scope.schedule.devices.search, $scope.schedule.devices.tag));
          $scope.allSelItems.list = angular.copy(mergeData);
          $scope.copySelData = angular.copy($scope.allSelItems);
          if($scope.schedule.devices.search.length){
            $scope.se.appliedDeviceBtn = true;
          }
          $rootScope.selectedItems = [];
          if($scope.selectedSearch.text.length > 0){
            $scope.searchSelFx($scope.selectedSearch.text);
          }
        }
        $scope.removeFilteredFx = function(id, type){
          if(id == "all"){
            $scope.schedule.devices.device = [];
            $scope.schedule.devices.search = [];
            $scope.schedule.devices.group = [];
            $scope.schedule.devices.tag = [];
            $scope.allSelItems.list = [];
            if(!$scope.schedule.devices.search.length){
              $scope.se.appliedDeviceBtn = false;
            }
          } else {
            if(type == "d"){
              angular.forEach($scope.schedule.devices.device, function(item){
                if(id == item.id){
                  $scope.schedule.devices.device.splice($scope.schedule.devices.device.indexOf(item), 1);
                  return false;
                }
              });
              angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
                if($(item).attr('data-id') == id && $(item).attr('data-type') == "device"){
                  $(item).removeClass('ui-selected');
                  $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                }
              });
            } else if(type == "t"){
              angular.forEach($scope.schedule.devices.tag, function(item){
                if(id == item.id){
                  $scope.schedule.devices.tag.splice($scope.schedule.devices.tag.indexOf(item), 1);
                  return false;
                }
              });
              angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
                if($(item).attr('data-id') == id && $(item).attr('data-type') == "tag"){
                  $(item).removeClass('ui-selected');
                  $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                }
              });
            } else if(type == "g"){
              angular.forEach($scope.schedule.devices.group, function(item){
                if(id == item.id){
                  $scope.schedule.devices.group.splice($scope.schedule.devices.group.indexOf(item), 1);
                  return false;
                }
              });
              angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
                if($(item).attr('data-id') == id && $(item).attr('data-type') == "group"){
                  $(item).removeClass('ui-selected');
                  $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                }
              });
            } else if(type == "s"){
              angular.forEach($scope.schedule.devices.search, function(item){
                if(id == item.id){
                  $scope.schedule.devices.search.splice($scope.schedule.devices.search.indexOf(item), 1);
                  return false;
                }
              });
              angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
                if($(item).attr('data-id') == id && $(item).attr('data-type') == "search"){
                  $(item).removeClass('ui-selected');
                  $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                }
              });
              if(!$scope.schedule.devices.search.length){
                $scope.se.appliedDeviceBtn = false;
              }
            }
            var mergeData = angular.copy([].concat($scope.schedule.devices.device, $scope.schedule.devices.group, $scope.schedule.devices.search, $scope.schedule.devices.tag));
            $scope.allSelItems = {list:angular.copy(mergeData)};
            $scope.copySelData = angular.copy($scope.allSelItems);
            $rootScope.selectedItems = [];
            if($scope.selectedSearch.text.length > 0){
              $scope.searchSelFx($scope.selectedSearch.text);
            }
          }
        }
        // } else if($scope.selectedTab === "hub.sContainer.sFrame"){
      } else if($rootScope.stateName === "f"){
        $scope.canvas = {zoom: "0.5"};
        $scope.counter = 10;
        $scope.timerFx = function(){
          $scope.counter--;
          if($scope.counter > 0){
            $scope.timer = $timeout($scope.timerFx, 1000);
          } else{
            $scope.clearStoreDB("scuData");
            $state.go("hub.schedules.s");
          }
        }

        $scope.layoutFx = function(e, layout, index){
          // console.warn("layoutFx ", layout, " index ", index);

          $(".list-inline li").removeClass("ui-selected");
          $(e.currentTarget).addClass("ui-selected");
          $scope.canvas.zoom = "0.5";
          $scope.curLayout = layout;
          $scope.scaleWidth = $("#canvas").width() / $scope.curLayout.width;
          $scope.scaleHeight = $("#canvas").height() / $scope.curLayout.height;
          if($scope.scaleWidth < $scope.scaleHeight){
            $scope.canvas.zoom = $scope.scaleWidth.toFixed(5);
          } else{
            $scope.canvas.zoom = $scope.scaleHeight.toFixed(5);
          }
          $scope.fitToFrame = $scope.canvas.zoom;

          $scope.isSelected = false;
          $scope.frameIndex = 0;
          angular.forEach($scope.curLayout.frames, function(frame, $index){
            if(frame.selected){
              $scope.frameIndex = $index;
              $scope.isSelected = true;
            }
          });

          // console.warn("$scope.isSelected ", $scope.isSelected);
          // console.warn("$scope.frameIndex ", $scope.frameIndex);


          if($scope.isSelected){
            $scope.selectFrame(e, $scope.curLayout.frames[$scope.frameIndex], $scope.curLayout.layoutId, $scope.curLayout.assignment, $scope.curLayout.dids, "innerCall");
          } else {
            angular.forEach($scope.curLayout.frames, function(frame, $index){
              if(frame.id == $scope.curLayout.defaultframeid){
                $scope.frameIndex = $index;
              }
            });
            $scope.selectFrame(e, $scope.curLayout.frames[$scope.frameIndex], $scope.curLayout.layoutId, $scope.curLayout.assignment, $scope.curLayout.dids, "innerCall");
          }

          if($scope.frameLayoutsCount == index){
            $scope.nextFrameFx(true);
          }
        }

        $scope.selectFrame = function(e, frame, layoutId, assignment, dids, callback){
          // console.warn("selectFrame ", e, frame, layoutId, assignment, dids, callback);
          // console.warn("$scope.curLayout ", $scope.curLayout);

          $scope.selFrameIds = [];
          $scope.selFrameIds.push(frame.id);
          if(frame.selectable){
            $scope.curFrame = frame;
            if(!callback){
              angular.forEach($scope.curLayout.frames, function(frames){
                frames.selected = false;
              });
              $scope.curFrame.selected = true;
            } else{
              angular.forEach($scope.frameLayout.frameLayouts, function(layout, index){
                if($filter("filter")(layout.frames, {selected:true}).length){
                  $scope.anySelected = true;
                } else{
                  angular.forEach($scope.curLayout.frames, function(frames){
                    if(frames.selectable && layout.defaultframeid == frames.id){
                      $scope.curFrame = frames;
                      $scope.curFrame.selected = true;
                    }
                  });
                }
              });
            }
            $scope.curFlIndex = -1;
            if($scope.schedule.frameLayouts.length){
              angular.forEach($scope.schedule.frameLayouts, function(frameLayout, $index){
                if(frameLayout.id == layoutId && $scope.curFlIndex == -1){
                  $scope.curFlIndex = $index;
                }
              });
            }
            if($scope.curFlIndex == -1){
              $scope.schedule.frameLayouts.push({id: layoutId, frame: frame.id, assignment: assignment, dids: dids});
            } else{
              $scope.schedule.frameLayouts[$scope.curFlIndex].dids = dids;
              $scope.schedule.frameLayouts[$scope.curFlIndex].frame = frame.id;
              $scope.schedule.frameLayouts[$scope.curFlIndex].assignment = assignment;
            }
          }
        }
      }
    }

    $scope.searchSelFx = function(text){
      $scope.searchData = angular.copy($scope.copySelData.list);
      if(text != ''){
        $scope.allSelItems.list = angular.copy($filter("customSearch")($scope.searchData, {key:text, module:'dSel'}));
      } else {
        $scope.resetSelFx();
      }
    }

    $scope.resetSelFx = function(){
      $scope.allSelItems.list = angular.copy($scope.copySelData.list);
    }

    $scope.changeDataTab = function(caller){
      console.warn(" changeDataTab ", $scope.schedule.info.ls==3);
      
      $scope.curFolderId = 0;
      $scope.deviceListLoading = true;
      $scope.deviceLoading = true;
      $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.12');
      
      if($scope.schedule.info.ls==3){
        $scope.epdDeviceConflictMsg = $filter("translate")('s.p_s.msg.59-1');
      } else{
        $scope.epdDeviceConflictMsg = $filter("translate")('s.p_s.msg.59');
      }

      if(!caller || caller != "changeView"){
        $scope.searchTextS.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.firstApply = {filter: false, search: false};
      localStorage.removeItem("curDFId");
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        $scope.getTypesFx();
      }
      if($rootScope.selectedT == 1){
        $rootScope.addStatusKeyVal.value = false;
        $scope.deviceListLoading = true;
      }

      // if($scope.schedule.info.hideJBD){
      //   $scope.devices.devices = [];
      //   angular.forEach($scope.sDeviceList.devices, function(item){
      //     if(item.dt != 7){
      //       $scope.devices.devices.push(item);
      //     }
      //   });
      // } else{
      //   if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.d) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.d)){
      //     // $rootScope.selectedT = 1;
      //     if(!$scope.auth.upermissions.se.dt && !$scope.auth.upermissions.sa.dt){
      //       if($scope.auth.upreferences.sdtf){
      //         $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //       } else {
      //         $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //       }
      //     }
      //     else {
      //       if($scope.auth.upreferences.sdtf){
      //         $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //       }
      //     }
      //   } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)){
      //     // $rootScope.selectedT = 2;
      //     if(!$scope.auth.upermissions.se.d || !$scope.auth.upermissions.sa.d){
      //       if($scope.auth.upreferences.sdtf){
      //         $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //       } else {
      //         $rootScope.selectedT = (($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dt) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dt)) ? 2 : 1;
      //       }
      //     }
      //   } else if(($scope.schedule.info.onceCompleted && $scope.auth.upermissions.se.dg) || (!$scope.schedule.info.onceCompleted && $scope.auth.upermissions.sa.dg)){
      //     $rootScope.selectedT = 3;
      //   }
      // }
      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      $scope.dReqObj = {id: $scope.schedule.info.id, type: "s", auth: $scope.auth, offset: $scope.dOffset, text: $scope.searchTextS.text, filter: $scope.filter, caller: $rootScope.selectedT == 1 ? 'd' : $rootScope.selectedT == 2 ? "dt" : "dg", fId: (($scope.curFolderId > 0 && $rootScope.selectedT == 1) ? $scope.curFolderId : 0)};

      if($scope.advSApply && $rootScope.selectedT == 1){
        $scope.apiCalledArr = [];
        $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopyS"));
        $scope.curAdvSearchObj.offset = 0;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }

        //show properly
        $scope.quadHeight = $scope.getAvailableHeight(400);
        $scope.selectedHeight = $scope.getAvailableHeight(400);

        if($scope.curAdvSearchObj.module == "s"){
          $scope.curAdvSearchObj.csdr = {s:$scope.schedule.schedule.dateRange.startDate, e:$scope.schedule.schedule.dateRange.endDate};
        }

        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.rdc = data.info.rdc;
            }
            $scope.curAdvSearchObj.isEmpty = data.isem;
            $scope.advSearchfilteredData = {info: $scope.curAdvSearchObj, devices: $scope.filteredData.devices, advObj: $scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else{
        // if($scope.firstApply.search && !$scope.firstApply.filter){
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
        // } else if(!$scope.firstApply.search && $scope.firstApply.filter){
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "filter", false);
        // } else{
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false, caller);
        // }
        // if($scope.searchTextS.text && $scope.searchTextS.text.length){
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
        // } else {
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
        // }
      }
    }

    $scope.previewProcessing = false;
    $scope.previewDateFx = function(item){
      $scope.previewDatesCopy = angular.copy($scope.schedule.schedule);
      $scope.curDate1 = angular.element(document).find(".picker").val();
      $scope.curDate1 = $scope.curDate1.split(" - ");
      $scope.previewDatesCopy.dateRange = {startDate: $scope.curDate1[0], endDate: $scope.curDate1[1]};
      if(item){
        $scope.previewDatesCopy.timingList = [item];
        $scope.previewProcessingEye = true;
      } else {
        $scope.previewProcessing = true;
      }
      SchedulesCUSrv.getPreviewDates($scope.previewDatesCopy).then(
        function(data){
          $scope.previewProcessing = false;
          $scope.previewProcessingEye = false;
          $scope.previewDateList = data.dates;
          ngDialog.open({
            template: "app/schedules/popup/previewDates.html",
            width: 750,
            scope: $scope,
            closeByDocument: false
          });
        },
        function(err){
          $scope.previewProcessing = false;
          $scope.previewProcessingEye = false;
          $log.error(err);
        }
      );
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      // $scope.breadCrumbs = []; //for fix breadCrumbs hide on cancel button
      $state.current = toState;
      // $scope.selectedTab = $state.current.name;
      localStorage.removeItem("curDTypeS");
      $timeout.cancel($scope.timer);
      if($scope.selectedTab == "hub.sContainer.sName" || $rootScope.stateName == "n"){
        $rootScope.stateName = "n";
        $scope.selectedTab = "hub.sContainer.sName";
      } else if($scope.selectedTab == "hub.sContainer.sSchedule" || $rootScope.stateName == "s"){
        $rootScope.stateName = "s";
        $scope.selectedTab = "hub.sContainer.sSchedule";
      } else if($scope.selectedTab == "hub.sContainer.sContent" || $rootScope.stateName == "c"){
        $rootScope.stateName = "c";
        $scope.selectedTab = "hub.sContainer.sContent";
      } else if($scope.selectedTab == "hub.sContainer.sDevice" || $rootScope.stateName == "d"){
        $rootScope.stateName = "d";
        $scope.selectedTab = "hub.sContainer.sDevice";
      } else if($scope.selectedTab == "hub.sContainer.sFrame" || $rootScope.stateName == "f"){
        $rootScope.stateName = "f";
        $scope.selectedTab = "hub.sContainer.sFrame";
      }
      // console.warn($scope.selectedTab, $rootScope.selectedT);
    });

    $scope.saveSearchOpen = function(){
      $scope.popupProcessing = false;
      $scope.popupErr = false;
      $scope.saveSearchObg = {label: ""};
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"s.p_s.btn.4" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cm.brief.1" | translate}}</label>\
                <input type="text" class="form-control" ng-model="saveSearchObg.label" focus-me="true" aria-label="{{\'cm.brief.1\' | translate}}" aria-labelledby="{{\'cm.brief.1\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="saveSearchFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-spin fa-repeat\':\'fa-check\'" aria-hidden="true"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="popupErr" aria-live="polite" role="status">\
                <span ng-if="errType==\'name\'" aria-live="polite" role="status">{{"cm.msg.37" | translate}}</span>\
                <span ng-if="errType==\'exists\'" aria-live="polite" role="status">{{"d.p_dg.m5" | translate}}</span>\
                <span ng-if="errType==\'deviceErr\'" aria-live="polite" role="status">{{"as.msg.3" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false
      });
    }

    $scope.saveSearchFx = function(){
      $scope.popupErr = false;
      $scope.errType = "";
      if($scope.saveSearchObg.label == ""){
        $scope.errType = "name";
        $scope.popupErr = true;
      } else{
        $scope.popupProcessing = true;
        $scope.advSearchInfo.devices = [];
        $scope.advSearchInfo.label = $scope.saveSearchObg.label;
        if($scope.devices.dInfo){
          if(!$scope.devices.dInfo.allIds){
            $scope.arraytoStringFx($scope.devices.devices);
            $scope.advSearchInfo.allIds = $scope.stringIds;
          } else{
            $scope.advSearchInfo.allIds = $scope.devices.dInfo.allIds;
          }
        }
        DevicesSrv.savedSearched($scope.advSearchInfo).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 12022){
              $scope.errType = "exists";
              $scope.popupErr = true;
            } else if(data.code == 12039){
              $scope.errType = "deviceErr";
              $scope.popupErr = true;
            } else if(data.code == 12048){
              $scope.filter = JSON.parse(localStorage.getItem("filterType"));
              // Commented on 260625
              // $scope.dReqObj = {id: $scope.schedule.info.id, type: "s", auth: null, offset: $scope.dOffset, text: $scope.searchTextS.text, filter: $scope.filter, fId: ($scope.curFolderId > 0 ? $scope.curFolderId : 0), caller: "dg"};
              // $scope.getAssignableDevicesFx($scope.dReqObj, "saveSearch"); //TODO 26-06-24

              // Added on 260625
              $scope.dReqObj = {caller:"dg", offset:$scope.dOffset, fil:$scope.filter, type:"s", fId:($scope.curFolderId>0?$scope.curFolderId:0), id:$scope.schedule.info.id, text:$scope.searchTextS.text};
              // {"s":"06/25/2025","e":"07/02/2025","dr":[],"t":0,"isLV":0}
              $scope.sDeviceList = data;
              $rootScope.selectedT = 3;
              $rootScope.selectedTabFx();
              
              ngDialog.close();
            } else{
              $scope.getSearchFx();
            }
          },
          function(err){
            $scope.popupProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.getSearchFx = function(){
      DevicesSrv.getSearch(1).then(
        function(data){
          $scope.sDeviceList.searches = data;
          $scope.devices.devices = $scope.sDeviceList.searches;
          ngDialog.close();
          $rootScope.selectedT = 3;
          $rootScope.selectedTabFx();
          $scope.popupProcessing = false;
        },
        function(err){
          $scope.popupProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.groupCUOpen = function(){
      $scope.clearStoreDB("scuData");
      $state.go("hub.schedules.s");
      localStorage.setItem("gpo", "true");
    }

    $scope.cancelFx = function(caller){
      if(!caller && $scope.schedule.info.id == 0 && $scope.schedule.info.label != ""){//TODO New added.
      } else{
        // localStorage.removeItem("clSchedule");
        // localStorage.removeItem("tSchedule");
        // localStorage.removeItem("tiSchedule");

        if($scope.celEventBack && $scope.celEventBack.back){
          $rootScope.tabView = false;
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id: $scope.hubEncrypt($scope.celEventBack.id)
          });
        } else if(caller == "pop"){
          // $scope.clearStoreDB("scuData");
          $state.go("hub.schedules.s");
        }
      }
    }

    $scope.backBtn = function(step){
      if(step == 's'){
        if($scope.auth.upermissions.se.np || (!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted)){
          $state.go("hub.sContainer.sName", {type: $scope.encType, id: $scope.encId});
        }
      } else if(step == 'c'){
        if($scope.auth.upermissions.se.s || (!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted)){
          $state.go("hub.sContainer.sSchedule", {type: $scope.encType, id: $scope.encId});
        } else {
          $scope.backBtn('s');
        }
      } else if(step == 'd'){
        if($scope.auth.upermissions.se.c || (!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted)){
          $state.go("hub.sContainer.sContent", {type: $scope.encType, id: $scope.encId});
        } else {
          $scope.backBtn('c');
        }
      } else if(step == 'f'){
        if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg || (!$scope.schedule.info.isCompleted && !$scope.schedule.info.onceCompleted)){
          $state.go("hub.sContainer.sDevice", {type: $scope.encType, id: $scope.encId});
        } else {
          $scope.backBtn('d');
        }
      }
    }

    $scope.nextFrameFx = function(caller){
      $scope.curIndex = angular.element(document).find('.fl.ui-selected').data("id");
      if(caller){
        $scope.isAllFramesSelected = true;
      } else {
        setTimeout(function(){
          if($scope.frameLayoutsCount == $scope.curIndex + 1){
            $scope.$apply(function(){
              $scope.isAllFramesSelected = true;
            });
          } else if($scope.frameLayoutsCount == $scope.curIndex){
            return true;
          }
          angular.element(document).find('.fl')[$scope.curIndex].click();
        }, 10);
      }
    }

    $scope.sGroupsFx = function(){
      if($scope.schedule.info.group.id){
        $scope.schedule.permission.type= "i";
        $scope.schedule.info.group.permission = {type: "i"};
      }
      $rootScope.$broadcast('savePermission', {});
    }

    // t == 1 //Windows:- Media Player / mp
    // t == 2 //LG WebOS:- Media Player / webos
    // t == 3 //Tizen:- Media Player / tizen
    // t == 4 //Chrome OS:- Chrome / chrome
    // t == 5 //Linux:- Media Player / mp
    // t == 6 //MacOS:- Media Player / mp
    // t == 7 //MC:- Music Choice / mc
    // t == 8 //Windows:- desktop / desktop
    // t == 9 //EPD:- EPD / epd
    // t == 10 //Geo Fence:- Geo Fence / gf
    // t == 11 //Virtual:- Virtual / v


    // var invalidCombinations = [
    //   {type:7, invalidWith:[1, 2, 3, 4, 8, 9, 10, 11]},
    //   {type:9, invalidWith:[1, 2, 3, 4, 7, 8, 10, 11]}
    // ];
    // $scope.validateSelection = function(selectedArr){
    //   for(var i = 0; i < selectedArr.length; i++){
    //     for(var j = i + 1; j < selectedArr.length; j++){
    //       var type1 = selectedArr[i];
    //       var type2 = selectedArr[j];

    //       for(var k = 0; k < invalidCombinations.length; k++){
    //         if(invalidCombinations[k].type === type1 && invalidCombinations[k].invalidWith.includes(type2)){
    //           return { isValid:false, errorType:type1 };
    //         }
    //         if(invalidCombinations[k].type === type2 && invalidCombinations[k].invalidWith.includes(type1)){
    //           return { isValid:false, errorType:type2 };
    //         }
    //       }
    //     }
    //   }
    //   return{isValid:true, errorType:0};
    // };

    $scope.validatorFx = function(obj){
      var odArr = [1, 2, 3, 4, 8, 10, 11];//mp:1; webos:2; tizen:3; chrome:4; linux:5 mp; mac:6 mp; desktop:8; gf:10; v:11;
      var isOD = false; //mp
      var isMC = false; //mc
      var isEPD = false; //epd
      var selectedDeviceArr = [];

      if(obj.data.devices && obj.data.devices.device.length){
        selectedDeviceArr = $filter("unique")(obj.data.devices.device, "t", "t");
        isEPD = $filter("filter")(selectedDeviceArr, 9).length ? true : false;//epd:9
        isMC = $filter("filter")(selectedDeviceArr, 7).length ? true : false;//mc:7
        for(var i = 0;i < selectedDeviceArr.length;i++){
          for(var j = 0;j < odArr.length;j++){
            if(selectedDeviceArr[i] == odArr[j]){
              isOD = true;
              break;
            }
          }
        }
      }

      var selectedContentArr = [];
      if(obj.data.content && obj.data.content.length){
        selectedContentArr = $filter("unique")(obj.data.content, "extn", "extn");
      }

      if(isOD && (isMC || isEPD)){
        $scope.errType = "mcDevice";
        $scope.hasErr = true;
        // return;
      }

      if(selectedContentArr.length){
        for(var i = 0;i < selectedContentArr.length;i++){
          var content = selectedContentArr[i];
          for(var j = i + 1;j < selectedContentArr.length;j++){
            var type1 = selectedContentArr[i];
            var type2 = selectedContentArr[j];
            if((type1 == "Music Choice" && type2 != "Music Choice") || (type1 != "Music Choice" && type2 == "Music Choice")){
              $scope.errType = "mcContent";
              $scope.hasErr = true;
              // return;
              break;
            }
          }
          if(content == "Music Choice" && isOD){
            // $scope.errType = "mcContent";
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
            // return;
            break;
          }
          if(content != "Music Choice" && isMC){
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
            // return;
            break;
          }
          if(content == "Music Choice" && selectedDeviceArr.length && !isMC){
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
            break;
            // return;
          }
        }
      }
      if($scope.hasErr){
        return
      }
    }

    $scope.butActionsFx = function(obj){
      // console.warn("butActionsFx ", obj);
      if(obj.content.length){
        var mc = $filter("filter")(obj.content, "Music Choice").length;
        if(mc){
          // console.warn("Hello show only 4 steps. mc ");
          $scope.schedule.info.hideFrameSelection = true;
        } else if($scope.schedule.info.ls == 1 || $scope.schedule.info.ls == 2 || $scope.schedule.info.ls == 3 || $scope.schedule.info.ls == 4 || $scope.schedule.info.ls == 6){
          // console.warn("Hello show only 4 steps. edp ");
          $scope.schedule.info.hideFrameSelection = true;
        }
        //mp:1; webos:2; tizen:3; chrome:4; linux:5 mp; mac:6 mp; desktop:8; gf:10; v:11;
      } else if($scope.schedule.info.ls == 1 || $scope.schedule.info.ls == 2 || $scope.schedule.info.ls == 3 || $scope.schedule.info.ls == 4 || $scope.schedule.info.ls == 6){
        // console.warn("Hello show only 4 steps. edp ");
        $scope.schedule.info.hideFrameSelection = true;
      }
    }

    // $scope.isValidCombination = function(arr){
    //   console.warn("isValidCombination ", arr);
    //   var uniqueTypes = arr.map(function(item){
    //     return item.t;
    //   }).filter(function(value, index, self){
    //     return self.indexOf(value) === index;
    //   });

    //   var notAllowedTypes = [7,9];
    //   console.warn("uniqueTypes ", uniqueTypes);
    //   for(var i = 0; i < uniqueTypes.length; i++){
    //     if(notAllowedTypes.indexOf(uniqueTypes[i]) !== -1){
    //       console.warn("uniqueTypes[i] ", uniqueTypes[i]);
    //       return { isValid: false, errorType: uniqueTypes[i] }; // Error Type 1: Not allowed types present
    //     }
    //   }
    //   return { isValid: true, errorType: 0 }; // No error;
    // };

    $scope.saveSchedule = function(caller, action){
      // console.warn("saveSchedule...", caller, action);
      $scope.hasErr = false;
      $scope.isPEOpen = false;
      $scope.schedule.info.step = caller;
      $scope.schedule.info.type = $scope.decType;

      $scope.scheduleCopy = angular.copy($scope.schedule);
      $scope.validatorFx({caller:caller, data:$scope.scheduleCopy});

      if(caller == "np"){
        if($scope.scheduleCopy.info.label == ""){
          $scope.errType = "formN";
          $scope.hasErr = true;
          $("#label").focus();
          return;
        } else if(!$scope.schedule.info.priority || $scope.scheduleCopy.info.priority < 1){
          $scope.errType = "priorityMin";
          $scope.hasErr = true;
          return;
        } else if($scope.scheduleCopy.info.priority && $scope.scheduleCopy.info.priority > 99999999){
          $scope.errType = "priority";
          $scope.hasErr = true;
          return;
        } else if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission', {});
        } else if($scope.scheduleCopy.info.group.id == 0 && $rootScope.isPermissionOpen){
          $scope.errType = "permission";
          $scope.hasErr = true;
          return;
        } else if(!$scope.auth.upermissions.sar && angular.isUndefined($scope.scheduleCopy.info.group.id)){
          $scope.errType = "selectGroup";
          $scope.hasErr = true;
          return;
        } else if($scope.schedule.info.isSync && !$scope.schedule.info.sg.length){
          $scope.errType = "formSg";
          $scope.hasErr = true;
          return;
        }
        // else if($scope.schedule.info.isSync && !$scope.schedule.info.sgsch.length){
        //   $scope.errType = "formSgsch";
        //   $scope.hasErr = true;
        //   return;
        // }

        if($scope.schedule.info.ls==3){
          $scope.schedule.schedule.forever = true;
          if($scope.schedule.schedule.forever){
            var today = moment();
            var hundredYearsLater = moment().add(100, 'years');
            $scope.curDateCheck = new Date(today.format('MM/DD/YYYY'));
            $scope.scheduleCopy.schedule.dateRange = {
              startDate:moment(today).format('MM/DD/YYYY'), endDate:moment(hundredYearsLater).format('MM/DD/YYYY')
            };
          }
        }
      } else if(caller == "s"){
        $scope.curDate = angular.element(document).find(".picker").val();
        $scope.curDate = $scope.curDate.split(" - ");
        $scope.scheduleCopy.schedule.dateRange = {startDate: $scope.curDate[0], endDate: $scope.curDate[1]};
        if($scope.scheduleCopy.schedule.type == "c" && $scope.scheduleCopy.schedule.timingList.length == 0){
          $scope.errType = "formS";
          $scope.hasErr = true;
          $("#addTiming").focus();
          return;
        }
        if($scope.dateRange.type == "m" && $scope.scheduleCopy.schedule.timingList.length == 0){
          $scope.errType = "date";
          $scope.hasErr = true;
          $("#addMultipleDate").focus();
          return;
        }
        if($scope.curData && $scope.curData.devices){
          $scope.scheduleCopy.devices.device.concat($scope.curData.devices.device);
          $scope.scheduleCopy.devices.group.concat($scope.curData.devices.group);
        }
      } else if(caller == "c"){
        if($scope.scheduleCopy.content.length == 0 && !$scope.hiddenContent){
          $scope.errType = "formC";
          $scope.hasErr = true;
          return;
        } else{
          $scope.isLSConflict = false;
          angular.forEach($scope.scheduleCopy.content, function(item, $index){
            if((item.duration == "" || item.duration == "0" || isNaN(item.duration) || item.duration < 1) && !$scope.hasErr){
              $scope.errType = "durationEmpty";
              $scope.hasErr = true;
              $("#content-" + $index).focus();
            }
            if($scope.scheduleCopy.info.ls && $scope.scheduleCopy.info.ls == 1){
              // console.warn("$scope.scheduleCopy.content ", item , " item.type ", item.type);
              if(item.type != "Image" || item.type == "Template"){
                $scope.isLSConflict = true;
              }
            }
          });

          if($scope.hasErr || $scope.isLSConflict){
            $scope.hasErr = true;
            return;
          }
        }
      } else if(caller == "d"){
        /*With tag*/
        $scope.updateSelectedDevice();
        if(!$scope.hiddenDevices && $scope.scheduleCopy.devices.device.length == 0 && $scope.scheduleCopy.devices.tag.length == 0 && $scope.scheduleCopy.devices.group.length == 0 && $scope.scheduleCopy.devices.search.length == 0){
          $scope.errType = "formD";
          $scope.hasErr = true;
          return;
        }
      } else if(caller == "f"){
        $scope.frameLayoutCount = 0;
        $scope.selectableCount = 0;
        $scope.selectedCount = 0;
        $scope.frameCount = 0;

        angular.forEach($scope.frameLayout.frameLayouts, function(frames){
          angular.forEach(frames.frames, function(frame){
            // if(frame.selectable && frame.selected){
            //   console.warn("frame ", frame);
            // }
            $scope.frameCount++;
            if(frame.selectable && frame.selected){
              $scope.selectedCount++;
            } else if(frame.selectable && !frame.selected){
              $scope.selectableCount++;
            }
            if(frame.selectable){
              frames.selectable = true;
            }
          });
          if($scope.frameCount == $scope.selectableCount){
            $scope.selectedCount++;
          }
          if(frames.selectable){
            $scope.frameLayoutCount++;
          }
        });

        if($scope.frameLayoutCount != $scope.selectedCount){
          $scope.errType = "formF";
          $scope.hasErr = true;
          return;
        }
      }


      if($scope.scheduleCopy.content.length){
        // console.warn("$scope.scheduleCopy.info.ls ", $scope.scheduleCopy.info.ls);
        // Content group widget not allowed to any type of schedule.
        var isCG = [];
        isCG = $filter("filter")($scope.scheduleCopy.content, {type:"Widget", extn:"Content Group"}, true);
        if(isCG.length){
          $scope.errType = "cgError";
          $scope.hasErr = true;
          return;
        }
        // CoD Only Content on Demand widget allowed.
        var isCoD = [];
        isCoD = $filter("filter")($scope.scheduleCopy.content, {type:"Widget", extn:"Content on Demand"}, true);
        // console.warn("isCoD ", isCoD);
        if(isCoD.length && $scope.scheduleCopy.info.ls != "4"){
          $scope.errType = "codError";
          $scope.hasErr = true;
          return;
        } else if(isCoD.length && isCoD.length != $scope.scheduleCopy.content.length){
          $scope.errType = "codWError";
          $scope.hasErr = true;
          return;
        }
        // Lock Screen Only Image allowed.
        if($scope.scheduleCopy.info.ls == "1"){
          var isImg = [];
          isImg = $filter("filter")($scope.scheduleCopy.content, {type:"Image"}, true);
          if(!isImg.length || (isImg.length != $scope.scheduleCopy.content.length)){
            $scope.errType = "lsError";
            $scope.hasErr = true;
            return;
          }
        }
        // Lock Screen Only Image allowed.
        if($scope.scheduleCopy.info.ls == "2"){
          var isAlert = [];
          var isSurvey = [];
          isAlert = $filter("filter")($scope.scheduleCopy.content, {type:"Widget", extn:"Crop Comm: Alert Message"}, true);
          isSurvey = $filter("filter")($scope.scheduleCopy.content, {type:"Widget", extn:"Survey"}, true);
          var isAS = isAlert.concat(isSurvey);
          // console.warn("isAS ", isAS);

          if(!isAS.length || (isAS.length != $scope.scheduleCopy.content.length)){
            $scope.errType = "ccError";
            $scope.hasErr = true;
            return;
          }
        }
        // EPD Only content allowed.
        if($scope.scheduleCopy.info.ls == "3"){
          // var isImg = [];
          var isTempleate = [];
          // isImg = $filter("filter")($scope.scheduleCopy.content, {type:"Image"}, true);
          isTempleate = $filter("filter")($scope.scheduleCopy.content, {type:"template", tType:1}, true);

          // if((isImg.length + isTempleate.length) > 1){
          if(isTempleate.length > 1){
            $scope.errType = "eslCError";//EPD content error
            $scope.hasErr = true;
            return;
          }

          // if((isImg.length + isTempleate.length) != $scope.scheduleCopy.content.length){
          if(isTempleate.length != $scope.scheduleCopy.content.length){
            $scope.errType = "eslError";
            $scope.hasErr = true;
            return;
          }
        }

        // Content on Demand widget allowed.
        if($scope.scheduleCopy.info.ls == "4" && !isCoD.length){
          $scope.errType = "codWError";
          $scope.hasErr = true;
          return;
        }

        // Override schedule == 6
        if($scope.scheduleCopy.info.ls == "6"){
          var hasTemplate = [];
          hasTemplate = $filter("filter")($scope.scheduleCopy.content, {type:"template"}, true);
          if(hasTemplate.length){
            $scope.errType = "sovrError";
            $scope.hasErr = true;
            return;
          }
        }
        /*
          if(data.code == 10064){
            $scope.lsTypeSId = data.id;
            $scope.errType = "eslError";
            $scope.hasErr = true;
          }
        */
      }

      if(!$scope.auth.upermissions.sar && !$scope.schedule.info.isCompleted && $scope.schedule.info.group.id == 0){
        $scope.errType = "selectGroup";
        $scope.hasErr = true;
      } else if(!$scope.hasErr){
        if(action == undefined){
          $scope.saveProcessing = true;
          $scope.scheduleCopy.info.toast = false;
        } else{
          $scope.saveCloseProcessing = true;
          $scope.scheduleCopy.info.toast = true;
        }

        // if($scope.isPEOpen){
        //   $timeout(function(){
        //     if(!$scope.schedule.permission.groups || ($scope.schedule.permission.groups && !$scope.schedule.permission.groups.length)){
        //       $scope.schedule.permission.type = "p";
        //     }
        //     if($scope.schedule.info.group.permission){
        //       $scope.scheduleCopy.info.group.permission = angular.copy($scope.schedule.info.group.permission);
        //       $scope.scheduleCopy.permission = angular.copy($scope.schedule.info.group.permission);
        //     } else{
        //       $scope.scheduleCopy.permission = angular.copy($scope.schedule.permission);
        //     }
        //     $scope.saveScheduleObj(caller, action);
        //   }, 250);
        // } else{
        //   if(!$scope.schedule.permission.groups || ($scope.schedule.permission.groups && !$scope.schedule.permission.groups.length)){
        //     $scope.schedule.permission.type = "p";
        //   }
        //   if($scope.scheduleCopy.info.group.permission){
        //     $scope.scheduleCopy.permission = $scope.scheduleCopy.info.group.permission;
        //   }
        //   $scope.saveScheduleObj(caller, action);
        // }

        if($scope.isPEOpen){
          $timeout(function(){
            if($scope.schedule.info.group.permission){
              $scope.scheduleCopy.permission = $scope.schedule.info.group.permission;
            } else{
              $scope.scheduleCopy.permission = angular.copy($scope.schedule.permission);
            }
            $scope.saveScheduleObj(caller, action);
          }, 250);
        } else{
          if($scope.scheduleCopy.info.group.permission){
            $scope.scheduleCopy.permission = $scope.scheduleCopy.info.group.permission;
          }
          $scope.saveScheduleObj(caller, action);
        }
      }
    }

    $scope.saveScheduleObj = function(caller, action){
      // console.warn(" $scope.saveScheduleObj ", $scope.scheduleCopy);
      if(caller == "f" && $scope.auth.upermissions.cda){
        // console.warn("$scope.frameLayout.frameLayouts ", $scope.frameLayout.frameLayouts);

        /*----------------------------------------------------------------------------------------------------*/
        if($scope.frameLayout && $scope.frameLayout.frameLayouts.length > 1){
          // console.warn("More then 1 ***** ");
          $scope.uniqueIds = {};
          // Create an array to store the final unique id values
          $scope.selFrameIds = [];
          for(var i = 0;i < $scope.scheduleCopy.frameLayouts.length;i++){
            var obj = $scope.scheduleCopy.frameLayouts[i];
            var id = obj.frame;
            // Check if the id is not already in the uniqueIds object
            if(!$scope.uniqueIds[id]){
              $scope.uniqueIds[id] = true;
              $scope.selFrameIds.push(id);
            }
          }
        }

        // console.warn("$scope.selFrameIds_____++++++_____ ", $scope.selFrameIds);

        $scope.uniqueFramesArr = [];
        if($scope.frameLayout && $scope.frameLayout.frameLayouts){
          $scope.frameLayout.frameLayouts.forEach(function(fl, i){
            if(fl.frames.length){
              fl.frames.filter(function(frame){
                if($scope.selFrameIds.includes(frame.id)){
                  $scope.uniqueFramesArr.push({id:frame.id, width:frame.width, height:frame.height, label:frame.label, dimension:frame.dimension, layout:fl.label});
                }
              });
            }
          })
        }

        $scope.misMatchContent = [];
        if($scope.scheduleCopy.content.length){
          $scope.misMatch = false;
          $scope.scheduleCopy.content.forEach(function(content){
            // console.warn("content ", content);

            if(content.type == "Image" && content.dimension && content.hidden == 0){
              $scope.dimensions = content.dimension.match(/\[([0-9]+)\]/g);
              var wDimen = $scope.dimensions[0];
              var hDimen = $scope.dimensions[1];

              $scope.cWidth = parseInt(wDimen.slice(1, -1), 10);
              $scope.cHeight = parseInt(hDimen.slice(1, -1), 10);

              $scope.uniqueFramesArr.forEach(function(fl){
                if(fl.width != $scope.cWidth || fl.height != $scope.cHeight){
                  if(!$scope.misMatchContent.includes(content)){
                    $scope.misMatchContent.push({content:content, fDimen:'W [' + fl.width + '], H [' + fl.height + ']', fLabel:fl.label, layout:fl.layout});
                  }
                  $scope.misMatch = true;
                }
              });
            }
          })
        }
      }

      if($scope.misMatch){
        $scope.saveProcessing = false;
        $scope.saveCloseProcessing = false;
        $scope.contentObj = {caller: caller, action: action, data: $scope.misMatchContent};
        ngDialog.open({
          template: '\
            <section class="panel">\
              <header class="panel-heading">\
                <h1>{{\'s.tool.8\' | translate}}</h1>\
              </header>\
              <div class="panel-body">\
                <div class="padB15 bdrBtm">{{"s.msg.11" | translate}} <a href="" style="text-decoration:underline" role="link" ng-click="readMeFx(\'dimen\')">{{\'s.btn.5\' | translate}}</a></div>\
                <div class="table marT20 scrollQuad" style="max-height:{{getAvailableHeight(400)}}px">\
                  <div class="row th">\
                    <div ng-if="frameLayout.frameLayouts.length > 1" class="col-xs-2 word-break">{{\'fl.body.3\' | translate}}</div>\
                    <div class="col-xs-3 word-break">{{\'r.body.6\' | translate}}</div>\
                    <div class="col-xs-3 word-break">{{\'fl.p_assign.body.3\' | translate}}</div>\
                    <div ng-class="frameLayout.frameLayouts.length > 1 ? \'col-xs-2\': \'col-xs-3\'" class="word-break">{{\'s.p_s.label.23\' | translate}}</div>\
                    <div ng-class="frameLayout.frameLayouts.length > 1 ? \'col-xs-2\': \'col-xs-3\'" class="word-break">{{\'s.p_s.label.24\' | translate}}</div>\
                  </div>\
                  <div class="row" ng-repeat="data in contentObj.data">\
                    <div ng-if="frameLayout.frameLayouts.length>1" class="col-xs-2 word-break">{{data.layout}}</div>\
                    <div class="col-xs-3 word-break">{{data.content.label}}</div>\
                    <div class="col-xs-3 word-break">{{data.fLabel}}</div>\
                    <div ng-class="frameLayout.frameLayouts.length > 1 ? \'col-xs-2\': \'col-xs-3\'" class="word-break">{{data.content.dimension ? data.content.dimension : \'N/A\'}}</div>\
                    <div ng-class="frameLayout.frameLayouts.length > 1 ? \'col-xs-2\': \'col-xs-3\'" class="word-break">{{data.fDimen}}</div>\
                  </div>\
                </div>\
              </div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-success" ng-click="closeThisDialog();" data-dismiss="modal">{{\'fl.p_cfl.label.17\' | translate}}</button>\
                <button type="button" role="button" class="btn btn-danger" ng-click="saveScheduleFx(contentObj.caller, contentObj.action, scheduleCopy);closeThisDialog();">{{\'fl.p_cfl.label.18\' | translate}}</button>\
              </footer>\
            </section>',
          plain: true,
          width: 890,
          scope: $scope,
          closeByDocument: false,
          className: "ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        // console.warn("saveScheduleFx #####$$$$$$ ");
        $scope.saveScheduleFx(caller, action, $scope.scheduleCopy);
      }
    }

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName: tabName
      };
      ngDialog.open({
        template: 'app/schedules/popup/info.html',
        width: 580,
        scope: $scope,
        data: $scope.readMeObj
      });
    }

    function isCommaSeparated(value){
      return value.includes(',');
    }

    $scope.saveScheduleFx = function(caller, action, scheduleCopy){
      // console.error("caller ", caller, " action ", action, " scheduleCopy ", scheduleCopy);
      if(action == undefined){
        $scope.saveProcessing = true;
        scheduleCopy.info.toast = false;
      } else{
        $scope.saveCloseProcessing = true;
        scheduleCopy.info.toast = true;
      }

      $scope.butActionsFx(scheduleCopy);

      if($scope.selectedTab == 'hub.sContainer.sSchedule'){
        if($scope.schedule.schedule.subType == "dce" && $scope.schedule.schedule.type == "c"){
          $scope.invalidExclude = $scope.excludeDRValidate('save');
          if($scope.invalidExclude){
            $scope.errType = "inExclude";
            $scope.hasErr = true;
            $scope.saveCloseProcessing = false;
            $scope.saveProcessing = false;
            return;
          }
        } else if($scope.schedule.schedule.subType == "dce" && $scope.schedule.schedule.type == "a"){
          scheduleCopy.schedule.subType = "";
        }
      }

      if($scope.lsTypeSId){
        scheduleCopy.info.id = $scope.lsTypeSId;
      }

      if(caller == "dc"){/*Device conflict list confirm*/
        $scope.saveProcessing = true;
        scheduleCopy.info.conflictCode = $scope.errDataObj.code;
      }

      if(localStorage.getItem("isSchTemp")){
        scheduleCopy.info.module = "t";
      }

      if(scheduleCopy){
        if(scheduleCopy.info.step == "np"){
          scheduleCopy.stepOne = 1;
        }
        // console.warn("scheduleCopy.frameLayouts ", scheduleCopy.frameLayouts);
        var curFrameLayouts = [];
        if(scheduleCopy.frameLayouts){
          angular.forEach(scheduleCopy.frameLayouts, function(layout){
            // console.warn("layout ", layout);
            if(layout.dids && isCommaSeparated(layout.dids)){
              // console.warn("Hello **** 1");
              var didsArr = $filter("split")(layout.dids, ",");
              angular.forEach(didsArr, function(dids){
                curFrameLayouts.push({
                  id: layout.id,
                  frame: layout.frame,
                  assignment: layout.assignment,
                  deviceid: dids
                });
              });
            } else if(layout.dids){
              // console.warn("Hello **** 2 ", layout.dids);
              curFrameLayouts.push({
                id: layout.id,
                frame: layout.frame,
                assignment: layout.assignment,
                deviceid: layout.dids
              });
            } else if(!layout.dids && layout.deviceid){
              // console.warn("Hello **** 3 ", layout.deviceid);
              curFrameLayouts.push({
                id: layout.id,
                frame: layout.frame,
                assignment: layout.assignment,
                deviceid: layout.deviceid
              });
            }
          });
        }

        localStorage.setItem("scuData", true);

        if(scheduleCopy.info.step == "f"){
          if(!scheduleCopy.info.ls){
            scheduleCopy.info.ls = 0;
          }
        }

        // toast:true
        if($scope.encId != 0){
          var tmpChange = {i:false,s:false,c:false,d:false,fl:false,p:false};

          if(scheduleCopy.change && scheduleCopy.change.i){
            tmpChange.i = scheduleCopy.change.i;
          }
          if(scheduleCopy.change && scheduleCopy.change.s){
            tmpChange.s = scheduleCopy.change.s;
          }
          if(scheduleCopy.change && scheduleCopy.change.c){
            tmpChange.c = scheduleCopy.change.c;
          }
          if(scheduleCopy.change && scheduleCopy.change.d){
            tmpChange.d = scheduleCopy.change.d;
          }
          if(scheduleCopy.change && scheduleCopy.change.fl){
            tmpChange.fl = scheduleCopy.change.fl;
          }
          if(scheduleCopy.change && scheduleCopy.change.p){
            tmpChange.p = scheduleCopy.change.p;
          }
          scheduleCopy.change = angular.copy(tmpChange);
          // console.error($scope.schedule.schedule.dateRange.startDate);
          $scope.schedule.schedule.dateRange.startDate = moment($scope.schedule.schedule.dateRange.startDate).format('MM/DD/YYYY');
          $scope.schedule.schedule.dateRange.endDate = moment($scope.schedule.schedule.dateRange.endDate).format('MM/DD/YYYY');

          // console.log("edit case", JSON.stringify($scope.scheduleFirstCopy.schedule), JSON.stringify($scope.schedule.schedule));
          if($scope.scheduleFirstCopy.info.label.toLowerCase() !== $scope.schedule.info.label.toLowerCase() || $scope.scheduleFirstCopy.info.group.id != $scope.schedule.info.group.id || $scope.scheduleFirstCopy.info.priority != $scope.schedule.info.priority){
            scheduleCopy.change.i = true;
          }
          if($scope.scheduleFirstCopy.permission.type != $scope.schedule.permission.type || ($scope.schedule.permission.type == "c" && ($scope.scheduleFirstCopy.permission.groups && $scope.scheduleFirstCopy.permission.groups.length) != ($scope.schedule.permission.groups && $scope.schedule.permission.groups.length))){
            scheduleCopy.change.p = true;
          }

          if(!$rootScope.deepEqualWithoutHashKey($scope.scheduleFirstCopy.schedule, $scope.schedule.schedule)){
            scheduleCopy.change.s = true;
          }
          if(!$rootScope.deepEqualWithoutHashKey($scope.scheduleFirstCopy.content, $scope.schedule.content)){
            scheduleCopy.change.c = true;
          }
          if(!$rootScope.deepEqualWithoutHashKey($scope.scheduleFirstCopy.devices, $scope.schedule.devices)){
            scheduleCopy.change.d = true;
          }
          if(!$rootScope.deepEqualWithoutHashKey($scope.scheduleFirstCopy.frameLayouts, $scope.schedule.frameLayouts)){
            scheduleCopy.change.fl = true;
          }
        }

        if(action == "sc"){
          scheduleCopy.info.toast = true;
          if(caller == "clExcluded"){
            scheduleCopy.info.clExcluded = true;
          } else{
            scheduleCopy.info.clExcluded = false;
          }

          // scheduleCopy.frameLayouts = [];
          scheduleCopy.frameLayouts = curFrameLayouts;
          SchedulesCUSrv.saveSchedules1(scheduleCopy).then(
            function(data){
              $scope.saveCloseProcessing = false;
              $scope.saveProcessing = false;
              $scope.curData = data;
              if(data.code == 10023){
                $scope.remainingCount = data.count;
                $scope.errType = "count";
                $scope.hasErr = true;
              } else if(data.code == 10060){
                $scope.lsTypeSId = data.id;
                $scope.errType = "lsError";
                $scope.hasErr = true;
              } else if(data.code == 10061){
                $scope.lsTypeSId = data.id;
                $scope.errType = "ccError";
                $scope.hasErr = true;
              } else if(data.code == 10064){
                $scope.lsTypeSId = data.id;
                $scope.errType = "eslError";
                $scope.hasErr = true;
              } else if(data.code == 10067){
                $scope.lsTypeSId = data.id;
                $scope.errType = "codError";
                $scope.hasErr = true;
              } else if(data.code == 10068){
                $scope.lsTypeSId = data.id;
                $scope.errType = "codWError";
                $scope.hasErr = true;
              } else if(data.code == 10069){
                $scope.lsTypeSId = data.id;
                $scope.errType = "cgError";
                $scope.hasErr = true;
              } else if(data.code == 10024){
                $scope.remainingDuration = data.duration;
                $scope.errType = "duration";
                $scope.hasErr = true;
              } else if(data.code == 10025){
                $scope.allowedFolder = data.folder;
                $scope.errType = "folder";
                $scope.hasErr = true;
              } else if(data.code == 10026){
                $scope.errType = "conflict";
                $scope.hasErr = true;
              } else if(scheduleCopy.info.step == "np" && data.code == 1000){//|| data.code == 10030 || data.code == 10031 || data.code == 10020
                $scope.errType = "formN";
                $scope.hasErr = true;
              } else if(scheduleCopy.info.step == "s" && data.code == 1000){// || data.code == 10030 || data.code == 10031 || data.code == 10020
                $scope.errType = "formS";
                $scope.hasErr = true;
              } else if(data.code == 10030){//|| data.code == 10030 || data.code == 10031 || data.code == 10020
                $scope.errType = "formC";
                $scope.hasErr = true;
              } else if(data.code == 10031){// || data.code == 10030 || data.code == 10031 || data.code == 10020
                $scope.errType = "formD";
                $scope.hasErr = true;
              } else if(data.code == 10020){
                $scope.errType = "formF";
                $scope.hasErr = true;
              } else if(data.code == 10033){
                $scope.errType = "selectGroup";
                $scope.hasErr = true;
              } else if(data.code == 10034 || data.code == 10037){
                $scope.errType = "mcContent";
                $scope.hasErr = true;
              } else if(data.code == 10035 || data.code == 10036){
                $scope.errType = "mcDevice";
                $scope.hasErr = true;
              } else if(data.code == 12090){
                $scope.errType = "eslError";
                $scope.hasErr = true;
              } else if(data.code == 10039){
                $scope.errType = "mcSchedule";
                $scope.hasErr = true;
              } else if(data.code == 100010){
                $scope.errType = "thirdPartyCA";
                $scope.hasErr = true;
              } else if(data.code == 10044){
                ngDialog.open({
                  template: '\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        {{"s.p_s.msg.36" | translate}}\
                      </div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                      </div>\
                    </section>',
                  plain: true,
                  width: 550,
                  scope: $scope,
                  closeByDocument: false,
                  className: "ngdialog-theme-default ngdialog-confirm"
                });
              } else if(data.code == 10062){
                $scope.errType = "eslDevice";
                $scope.hasErr = true;
              } else if(data.code == 10063){
                $scope.errType = "eslSchedule";
                $scope.hasErr = true;
              } else if(data.code == 17127){
                $scope.errType = "bcExist";
                $scope.hasErr = true;
              } else if(data.code == 17122){
                $scope.errType = "cExist";
                $scope.hasErr = true;
              } else if(data.code == 10070){
                $scope.errType = "eslCError";//EPD content error
                $scope.hasErr = true;
              } else if(data.code == 10040){
                $scope.errType = "noDevice";
                $scope.hasErr = true;
              } else if(data.code == 10046){
                $scope.errDataObj = data;
                for(var i = 0;i < $scope.errDataObj.data.length;i++){
                  if($scope.errDataObj.data[i].excl){
                    for(var j = 0;j < $scope.errDataObj.data[i].excl.length;j++){
                      if($scope.errDataObj.data[i].devices){
                        for(var k = 0;k < $scope.errDataObj.data[i].devices.length;k++){
                          if($scope.errDataObj.data[i].devices[k].atags){
                            for(var l = 0;l < $scope.errDataObj.data[i].devices[k].atags.length;l++){
                              if($scope.errDataObj.data[i].excl[j].id == $scope.errDataObj.data[i].devices[k].atags[l].id){
                                $scope.errDataObj.data[i].devices[k].atags[l].isSelect = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                ngDialog.open({
                  template: '\
                    <section class="panel" role="dialog">\
                      <header class="panel-heading"><h1 role="heading" aria-level="1">{{"s.p_s.body.6" | translate}}</h1></header>\
                      <div class="panel-body">\
                        <div class="msg-warning" lang="{{auth.lang}}"><span class="text-warning"><span class="fa fa-exclamation-triangle" aria-hidden="true"></span> {{"s.p_s.msg.59" | translate}}</span></div>\
                        <div class="table marT15">\
                          <div class="row th">\
                            <div class="col-xs-3">{{"cm.label.4" | translate}}</div>\
                            <div class="col-xs-3">{{"s.p_s.label.17" | translate}}</div>\
                            <div class="col-xs-3">{{"s.p_s.label.18" | translate}}</div>\
                            <div class="col-xs-3">{{"s.p_s.label.19" | translate}}</div>\
                          </div>\
                          <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(440)}}px">\
                            <div ng-repeat="list in errDataObj.data">\
                              <div class="row" ng-repeat="d in list.devices">\
                                <div class="col-xs-3">{{d.label}}</div>\
                                <div class="col-xs-3">\
                                  <div ng-if="d.group"><span class="text-bold">{{"cm.label.79" | translate}}:</span> <span ng-repeat="g in d.group">{{g.label}}</span></div>\
                                  <div ng-if="d.tag"><span class="text-bold">{{"cm.label.94" | translate}}:</span> <span ng-repeat="t in d.tag">{{t.label}}</span></div>\
                                  <div ng-if="!d.group && !d.tag">{{"s.p_s.label.20" | translate}}</div>\
                                </div>\
                                <div class="col-xs-3">\
                                  <span ng-repeat="t in d.atags">\
                                    <span ng-class="{\'text-danger\':t.isSelect}">\
                                      {{t.label}}<span ng-if="!$last">, </span>\
                                    </span>\
                                  </span>\
                                </div>\
                                <div class="col-xs-3">\
                                  <div>{{"d.tab.5" | translate}}:{{list.label}}</div>\
                                  <span ng-repeat="t in list.excl">{{t.label}}<span ng-if="(list.excl_op==\'and\') && !$last"> AND </span><span ng-if="list.excl_op==\'or\'"> OR </span></span>\
                                </div>\
                              </div>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <footer class="panel-footer">\
                        <span class="btnQuad">\
                          <button type="button" role="button" class="btn btn-success" ng-click="saveScheduleObj(\'dc\');" ng-disabled="saveProcessing"><span class="fa fa-check" ng-class="{\'fa-repeat fa-spin\':saveProcessing}" aria-hidden="true"></span> {{"s.p_s.btn.7" | translate}}</button>\
                          <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                        </span>\
                        <div class="clearfix"></div>\
                      </footer>\
                    </section>',
                  plain: true,
                  width: 850,
                  scope: $scope,
                  closeByDocument: false
                });
              } else if(data.code == 13013 || data.code == 13014){ // 13013 = deleted content but some content is remaning // 13014 = no content remaning
                ngDialog.open({
                  template: '\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        {{"s.p_s.msg.69" | translate}}\
                      </div>\
                      <footer class="panel-footer">\
                        <span class="btnQuad noMarB">\
                          <button type="button" role="button" class="btn btn-success" ng-click="closeThisDialog();" data-dismiss="modal">{{\'fl.p_cfl.label.17\' | translate}}</button>\
                          <button type="button" role="button" class="btn btn-danger" ng-click="saveScheduleObj(\'clExcluded\', \'sc\'); closeThisDialog();" ng-disabled="saveProcessing"><span class="fa fa-check" ng-class="{\'fa-repeat fa-spin\':saveProcessing}" aria-hidden="true"></span> {{\'fl.p_cfl.label.18\' | translate}}</button>\
                        </span>\
                        <div class="clearfix"></div>\
                      </footer>\
                    </section>',
                  plain: true,
                  width: 550,
                  scope: $scope,
                  closeByDocument: false,
                  className: "ngdialog-theme-default ngdialog-confirm"
                });
              } else if(data.status != "error"){
                // console.warn("Hello SAve in Else ");
                $scope.encId = $scope.hubEncrypt(data.scheduleId);
                // Remove from local storage
                localStorage.removeItem("clSchedule");
                localStorage.removeItem("clfSchedule");
                localStorage.removeItem("tSchedule");
                localStorage.removeItem("tfSchedule");
                localStorage.removeItem("tiSchedule");

                if(data.isSchComplete && scheduleCopy.info.step != "np" && scheduleCopy.info.step != "s"){
                  $scope.vwObj = {sid:scheduleCopy.info.id,vw:$scope.vwInfo.vw,isSchComplete:data.isSchComplete};
                  SchedulesCUSrv.updateVWInfo($scope.vwObj).then(
                    function(data){},
                    function(err){
                      $log.error(err);
                    }
                  );
                }
                
                if(action == undefined){
                  if($scope.se.nextStep == "s"){
                    $state.go("hub.sContainer.sSchedule", {type: $scope.encType, id: $scope.encId});
                    $rootScope.selectedT = 1;
                  } else if($scope.se.nextStep == "c"){
                    if(data.code == 10029){
                      $scope.confirmOpen("schedule");
                    } else {
                      $state.go("hub.sContainer.sContent", {type: $scope.encType, id: $scope.encId});
                      $rootScope.selectedT = 1;
                    }
                  } else if($scope.se.nextStep == "d"){
                    $state.go("hub.sContainer.sDevice", {type: $scope.encType, id: $scope.encId});
                    $rootScope.selectedT = 1;
                  } else if($scope.se.nextStep == "f"){
                    if(data.code == 10029){
                      $scope.confirmOpen("frames");
                    } else {
                      $state.go("hub.sContainer.sFrame", {type: $scope.encType, id: $scope.encId});
                      $rootScope.selectedT = 1;
                    }
                  }
                } else if(data.code == 10029 && caller != "f"){
                  $scope.confirmOpen();
                } else if(data.code == 10029 && caller == "f"){
                  if((scheduleCopy.frameLayouts.length > 0) || ($scope.selectedCount == 0 && $scope.selectableCount == 0)){
                    $scope.confirmOpen();
                  } else{
                    $rootScope.askToChange = true;
                    $state.go("hub.schedules.is");
                    $rootScope.selectedT = 1;
                  }
                } else{
                  $scope.confirmFx();
                }
              }
            },
            function(err){
              $scope.saveCloseProcessing = false;
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        } else{
          if(scheduleCopy.info.ls == 1 || scheduleCopy.info.ls == 2 || scheduleCopy.info.ls == 3 || scheduleCopy.info.ls == 4 || scheduleCopy.info.ls == 6){
            scheduleCopy.info.hideFrameSelection = true;
          }

          $scope.addItemsDB(scheduleCopy);
          if(scheduleCopy.step !== "f"){
            $scope.saveCloseProcessing = false;
            $scope.saveProcessing = false;
            if($scope.sCUdb && $scope.sCUdb.info){
              scheduleCopy.info = $scope.sCUdb.info;
            }
            if($scope.se.nextStep == "s"){
              $state.go("hub.sContainer.sSchedule", {type:$scope.encType, id:$scope.encId});
            } else if($scope.se.nextStep == "c"){
              $state.go("hub.sContainer.sContent", {type:$scope.encType, id:$scope.encId});
            } else if($scope.se.nextStep == "d"){
              $state.go("hub.sContainer.sDevice", {type:$scope.encType, id:$scope.encId});
            } else if($scope.se.nextStep == "f"){
              $state.go("hub.sContainer.sFrame", {type:$scope.encType, id:$scope.encId});
            }
          }
        }
      }
    }

    $scope.confirmOpen = function(caller){
      $scope.curData.caller = caller;
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div ng-if="curData.success == 0">\
                <span ng-if="curData.type == \'c\'">{{"s.p_s.msg.17" | translate}}</span>\
                <span ng-if="curData.type == \'d\'">{{"s.p_s.msg.18" | translate}}</span>\
                <span ng-if="curData.type == \'s\'">{{"s.p_s.msg.19" | translate}}</span>\
                <span ng-if="curData.type == \'f\'">{{"s.p_s.msg.20" | translate}}</span>\
              </div>\
              <div ng-if="curData.success > 0">\
                <span ng-if="curData.type == \'d\'">{{"s.p_s.msg.22" | translate}}</span>\
                <span ng-if="curData.type == \'s\'">{{"s.p_s.msg.19" | translate}}</span>\
                <span ng-if="curData.type == \'f\'">{{"s.p_s.msg.21" | translate}}</span>\
              </div>\
              <div class="marT10" ng-if="curData.devices.length > 0 && curData.type == \'d\'">\
                <div>\
                  <label>{{"s.p_s.msg.23" | translate}}</label>:\
                  <p>{{scheduleCopy.schedule.dateRange.startDate | momentDate | date:"mediumDate"}} {{"r.label.4" | translate}} {{scheduleCopy.schedule.dateRange.endDate | momentDate | date:"mediumDate"}}</p>\
                </div>\
                <div class="table marT10">\
                  <div class="row th">\
                    <div class="col-xs-3">{{"cm.label.4" | translate}}</div>\
                    <div class="col-xs-3">{{"d.tab.3" | translate}}</div>\
                    <div class="col-xs-3">{{"d.tab.2" | translate}}</div>\
                    <div class="col-xs-3 text-right">{{"s.p_s.label.10" | translate}}</div>\
                  </div>\
                  <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                    <div ng-repeat="d in curData.devices">\
                      <div class="row">\
                        <div class="col-xs-3 text-ellipsis">{{d.device}}</div>\
                        <div class="col-xs-3 text-ellipsis">\
                          <div ng-repeat="tag in d.tag" ng-if="d.tag.length > 0">{{tag}}</div>\
                          <div class="text-muted text-sm" ng-if="!d.tag.length">N/A</div>\
                        </div>\
                        <div class="col-xs-3 text-ellipsis">\
                          <div ng-repeat="dg in d.group" ng-if="d.group.length > 0">{{dg}}</div>\
                          <div class="text-muted text-sm" ng-if="!d.group.length">N/A</div>\
                        </div>\
                        <div class="col-xs-3 text-sm">\
                          <div ng-repeat="date in d.dateRange">{{date}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                </div>\
              </div>\
              <div class="marT10" ng-if="(curData.devices.device.length > 0 || curData.devices.group.length > 0) && curData.type == \'f\'">\
                <div class="table marT10">\
                  <div class="row th">\
                    <div class="col-xs-7">{{"cm.label.71" | translate}}</div>\
                    <div class="col-xs-5">{{"cm.label.78" | translate}}</div>\
                  </div>\
                  <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                    <div ng-repeat="dg in curData.devices.group">\
                      <div class="row" ng-repeat="d in dg.device">\
                        <div class="col-xs-7 text-ellipsis">{{d.label}}</div>\
                        <div class="col-xs-5 text-ellipsis">{{dg.label}}</div>\
                      </div>\
                    </div>\
                    <div class="row" ng-repeat="d in curData.devices.device">\
                      <div class="col-xs-7 text-ellipsis">{{d.label}}</div>\
                      <div class="col-xs-5 text-muted text-sm">N/A</div>\
                    </div>\
                  </div>\
                </div>\
              </div>\
            </div>\
            <div class="panel-footer">\
              <button type="button" role="button" class="btn btn-primary" ng-click="closeThisDialog();" data-dismiss="modal">{{"s.p_s.btn.1" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="confirmFx(curData.caller);">{{"s.p_s.btn.3" | translate}}</button>\
            </div>\
          </section>',
        plain: true,
        width: 700,
        scope: $scope,
        data: $scope.curData,
        closeByDocument: false,
        className: "ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.confirmFx = function(caller){
      // console.warn("confirmFx ", caller);
      ngDialog.close();
      if(caller == "schedule" && $scope.auth.upermissions.se.c){
        $state.go("hub.sContainer.sContent", {type: $scope.encType, id: $scope.encId});
        $rootScope.selectedT = 1;
      } else if(caller == "schedule" && ($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg)){
        $state.go("hub.sContainer.sDevice", {type: $scope.encType, id: $scope.encId});
        $rootScope.selectedT = 1;
      } else if((caller == "frames" || caller == "schedule") && $scope.auth.upermissions.se.f && !$scope.schedule.info.hideFrameSelection){
        $state.go("hub.sContainer.sFrame", {type: $scope.encType, id: $scope.encId});
        $rootScope.selectedT = 1;
      } else {
        // console.warn("$scope.celEventBack ", $scope.celEventBack);
        if($scope.celEventBack && $scope.celEventBack.back){
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id: $scope.hubEncrypt($scope.celEventBack.id)
          });
          $rootScope.selectedT = 1;
        } else {
          // console.warn("$state.current.name ", $state.current.name);
          // if($state.current.name == "hub.sContainer.sName" || $state.current.name == "hub.sContainer.sSchedule" || $state.current.name == "hub.sContainer.sContent" || $state.current.name == "hub.sContainer.sDevice" || $state.current.name == "hub.sContainer.sFrame"){
          $scope.clearStoreDB("scuData");
          $state.go("hub.schedules.s");
          $rootScope.selectedT = 1;
          // }
        }
      }
    }

    $scope.curDateBeforForever = "";
    $scope.foreverFx = function(){
      var curDate = angular.element(document).find("#sDateRange").val();
      $scope.curDate = curDate.split(" - ");
      $scope.curDateCheck = new Date(moment().format('MM/DD/YYYY'));
      $scope.currentDate = moment().format('MM/DD/YYYY').split("/");

      $scope.curDateS = $scope.curDate[0].split("/");

      if($scope.schedule.schedule.forever){
        var curDateBF = angular.element(document).find("#sDateRange").val();
        var dateBF = curDateBF.split(" - ");
        $scope.curDateBeforForever = {startDate:moment(dateBF[0]).format('MM/DD/YYYY'), endDate:moment(dateBF[1]).format('MM/DD/YYYY')};

        // $scope.curDateE = angular.copy($scope.curDate[1].split("/"));
        $scope.schedule.schedule.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0], $scope.curDateS[1]]).add(100, "year")._d};
      } else{
        $scope.schedule.schedule.dateRange = $scope.curDateBeforForever;
        // $scope.schedule.schedule.dateRange = $scope.dateRangeCopy;

        // {startDate: $scope.dateRangeCopy.startDate, endDate: moment([$scope.curDateS[2], $scope.curDateS[1], $scope.curDateS[0]]).add(1, "year")._d};

        // $scope.selStartDate = new Date(moment($scope.curDateS.join('-'), 'MM-DD-YYYY').format('MM/DD/YYYY'));
        // if($scope.curDateE){
        //   $scope.selEndDate = new Date(moment($scope.curDateE.join('-'), 'MM-DD-YYYY').format('MM/DD/YYYY'));
        // }
        // $scope.curDate = new Date(moment().format('MM/DD/YYYY'));
        // $scope.curDateC = moment().format('MM/DD/YYYY').split("/");

        // if($scope.selEndDate){
        //   console.warn("Hello.... #@$$$#%%$");
        //   if($scope.selEndDate.getTime() === $scope.curDate.getTime()){
        //   } else if($scope.selEndDate > $scope.curDate){
        //     if($scope.auth.upreferences.sddr == "m"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "month")._d};
        //     } else if($scope.auth.upreferences.sddr == "w"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "week")._d};
        //     } else {
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "year")._d};
        //     }
        //   } else{
        //     if($scope.auth.upreferences.sddr == "m"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "month")._d};
        //     } else if($scope.auth.upreferences.sddr == "w"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "week")._d};
        //     } else {
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "year")._d};
        //     }
        //   }
        // } else{
        //   if($scope.selStartDate > $scope.curDate){
        //     if($scope.auth.upreferences.sddr == "m"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "month")._d};
        //     } else if($scope.auth.upreferences.sddr == "w"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "week")._d};
        //     } else{
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "year")._d};
        //     }
        //   } else{
        //     if($scope.auth.upreferences.sddr == "m"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "month")._d};
        //     } else if($scope.auth.upreferences.sddr == "w"){
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "week")._d};
        //     } else{
        //       $scope.schedule.schedule.dateRange = {startDate: moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate: moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "year")._d};
        //     }
        //   }
        // }
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      // console.warn(args);
      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchTextS.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchTextS.text = "";
        $scope.searchText = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }
      // if($scope.selectedTab === "hub.sContainer.sContent"){
      if($rootScope.stateName === "c"){
        $scope.advancedShow = true;
        $scope.folderList = [];
        $scope.advSearchInfo = args.info;

        if($scope.advSearchInfo.name != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.creationRange == true || ($scope.advSearchInfo.type != "" && $scope.advSearchInfo.type != null)){
          if($scope.auth.upreferences.isPopup){
            if($scope.auth.upreferences.isSplitV){
              $scope.quadHeight = $scope.getAvailableHeight(380);
              $scope.selectedHeight = $scope.getAvailableHeight(380);
            } else {
              $scope.quadHeight = $scope.getAvailableHeight(485) * 0.50;
              $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.50;
            }
          } else {
            if($scope.auth.upreferences.isSplitV){
              $scope.quadHeight = $scope.getAvailableHeight(230);
              $scope.selectedHeight = $scope.getAvailableHeight(232);
            } else {
              $scope.quadHeight = $scope.getAvailableHeight(250) * 0.55;
              $scope.selectedHeight = $scope.getAvailableHeight(290) * 0.45;
            }
          }
        } else if($scope.advSearchInfo.name == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.creationRange == false && ($scope.advSearchInfo.type == null || $scope.advSearchInfo.type == "")){
          if($scope.auth.upreferences.isPopup){
            if($scope.auth.upreferences.isSplitV){
              $scope.quadHeight = $scope.getAvailableHeight(315);
              $scope.selectedHeight = $scope.getAvailableHeight(315);
            } else {
              $scope.quadHeight = $scope.getAvailableHeight(415) * 0.6;
              $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
            }
          } else {
            if($scope.auth.upreferences.isSplitV){
              $scope.quadHeight = $scope.getAvailableHeight(230);
              $scope.selectedHeight = $scope.getAvailableHeight(232);
            } else {
              $scope.quadHeight = $scope.getAvailableHeight(250) * 0.55;
              $scope.selectedHeight = $scope.getAvailableHeight(290) * 0.45;
            }
          }
        }
        if(args.content){
          if(args.info.step == "scl" && (angular.isUndefined(args.info.opt) || args.info.opt == '6')){
            $scope.curArgsContent = [];
            angular.forEach(args.content, function(item){
              if(item.extn != "Content on Demand" && item.extn != "Content Group" && angular.isUndefined(args.info.opt)){
                $scope.curArgsContent.push(item);
              } else if(item.extn != "Content on Demand" && args.info.opt == '6'){
                $scope.curArgsContent.push(item);
              }
            });
            $scope.contentList = $scope.curArgsContent;
          } else {
            $scope.contentList = args.content;
          }
        }
        if(args.template){
          $scope.templateList = args.template.filter(function(item){
            if(item.isApproved == 1){
              return item;
            }
          })
        }
        $scope.folderList = args.folder;
        $scope.advSearch = true;
        if(args.code == 8118){
          $scope.searchTextS.text = "";
          $scope.searchText = "";
          $scope.paginationControls.currPage = 1;
          $scope.advSearchInfo = {};
          $scope.apiCalledArr = [];
          $scope.advSApply = false;
          $scope.contentLibraryLoading = true;
          $scope.templatesLoading = true;
          $scope.curFolderId = 0;

          if($scope.flId){
            // console.warn("IF.../");
            var ls = $scope.schedule.info.ls ? $scope.schedule.info.ls : 0; //schedule type
            var dAPIObj = {
              fId: $scope.flId,
              dr: [],
              t: ls
            }

            if($scope.schedule.schedule.timingList.length){
              angular.forEach($scope.schedule.schedule.timingList, function(tl){
                dAPIObj.dr.push({s: tl.startDate, e: tl.endDate});
              });
            } else {
              dAPIObj.dr.push({s: $scope.schedule.schedule.dateRange.startDate, e: $scope.schedule.schedule.dateRange.endDate});
            }
            SchedulesCUSrv.getApproved(dAPIObj).then(
              // ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
              function(data){
                $scope.contentLibrary = data;
                $scope.advSearch = false;
                $scope.updateList();
              },
              function(err){
                $log.error(err);
              }
            );
          } else{
            // console.warn("ELSE.../");
            var ls = $scope.schedule.info.ls ? $scope.schedule.info.ls : 0; //schedule type
            // console.warn("$scope.dReqObj ", $scope.dReqObj);
            // console.log("LS ", ls);
            var dAPIObj = {
              fId: 0,
              id: $scope.schedule.info.id,
              dr: [],
              t: ls
            }

            if($scope.schedule.schedule.timingList.length){
              angular.forEach($scope.schedule.schedule.timingList, function(tl){
                dAPIObj.dr.push({s: tl.startDate, e: tl.endDate});
              });
            } else {
              dAPIObj.dr.push({s: $scope.schedule.schedule.dateRange.startDate, e: $scope.schedule.schedule.dateRange.endDate});
            }

            SchedulesCUSrv.getApproved(dAPIObj).then(
              function(data){
                $scope.contentLibrary = data;
                $scope.advSearch = false;
                $scope.updateList();
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
        // } else if($scope.selectedTab === "hub.sContainer.sDevice"){
      } else if($rootScope.stateName === "d"){
        $scope.searchMsg = false;
        $scope.deviceTypes = "";
        $scope.folderList = [];
        $scope.breadCrumbs = [];

        if(args.devices){
          $scope.dData = angular.copy(args);
          if($scope.dData.devices.length){
            if($scope.searchTextS.text && $scope.searchTextS.text.length){
              if(args.info.isLoadMore){
                $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
              } else {
                $scope.sData = angular.copy($scope.dData);
              }
              $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey($scope.sData);
              $scope.devices = angular.copy($scope.sData);
            } else {
              if(args.info.isLoadMore){
                $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
              } else {
                $scope.asData = angular.copy($scope.dData);
              }
              $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey($scope.asData);
              $scope.devices = angular.copy($scope.asData);
              $scope.statusObj.as = true;
            }
          } else {
            $scope.asData = {devices: args.devices ? args.devices : [], info: args.info};
            $scope.devices.devices = angular.copy($scope.asData.devices);
            $scope.devices.info = angular.copy($scope.asData.info);
          }

          $scope.setCountFx();

          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
            if(args.dInfo && args.dInfo.allIds){
              $scope.devices.info.allIds = args.dInfo.allIds;
            }
          }

          $scope.isAdvSearch = true;
        }
        $scope.advSearchInfo = args.info;

        if($scope.advSearchInfo.os != null || ($scope.advSearchInfo.hasOwnProperty("client") && $scope.advSearchInfo.client != null) || ($scope.advSearchInfo.hasOwnProperty("dName") && $scope.advSearchInfo.dName != null) || ($scope.advSearchInfo.hasOwnProperty("createdBy") && $scope.advSearchInfo.createdBy != null) || ($scope.advSearchInfo.hasOwnProperty("sName") && $scope.advSearchInfo.sName != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || $scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length || $scope.advSearchInfo.userGroup.include.length || $scope.advSearchInfo.userGroup.exclude.length || ($scope.advSearchInfo.hasOwnProperty("fil") && $scope.advSearchInfo.fil != "" && $scope.advSearchInfo.fil != "all") || $scope.advSearchInfo.prop != null){
          if($scope.auth.upreferences.isSplitV){
            $scope.quadHeight = $scope.getAvailableHeight(385);
            $scope.selectedHeight = $scope.getAvailableHeight(387);
          } else {
            $scope.quadHeight = $scope.getAvailableHeight(485) * 0.50;
            $scope.selectedHeight = $scope.getAvailableHeight(440) * 0.50;
          }
        } else if($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length && !$scope.advSearchInfo.userGroup.include.length && !$scope.advSearchInfo.userGroup.exclude.length && ($scope.advSearchInfo.fil == "all" || !$scope.advSearchInfo.fil) && $scope.advSearchInfo.prop == null){
          if($scope.auth.upreferences.isSplitV){
            $scope.quadHeight = $scope.getAvailableHeight(318);
            $scope.selectedHeight = $scope.getAvailableHeight(320);
          } else {
            $scope.quadHeight = $scope.getAvailableHeight(415) * 0.6;
            $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
          }
        }

        $scope.advSearch = true;
        $scope.advSearchInfo = args.info;

        $scope.filterType = $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        if(!$scope.filterType || $scope.filterType == "all"){
          $scope.filterType = "";
        }
        if(args.code == 8118){
          $scope.searchTextS.text = "";
          $scope.searchText = "";
          $scope.advSApply = false;
          localStorage.removeItem("curDFId");
          $scope.apiCalledArr = [];
          $scope.paginationControls.currPage = 1;
          $scope.isAdvSearch = false;
          $scope.advSearchInfo = {};
          $scope.allSelectedDevices = {devices: []};
          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
            if($scope.curDType){
              $scope.openTypeFx($scope.curDType, null, "call");
            } else {
              $scope.getTypesFx();
            }
          } else {
            $scope.isLoadedFx();
          }
        }
      }
    });

    // var searchTimeout;
    $scope.searchChangeFx = function(caller, text){
      $rootScope.commonSearchVar = text;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      // if($scope.selectedTab == "hub.sContainer.sDevice" && !text){
      if($rootScope.stateName == "d" && !text){
        $scope.clearSearchFx();
        return;
      } else {
        $scope.searchTextS.text = text;
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        // if($scope.selectedTab == "hub.sContainer.sDevice" && $rootScope.selectedT == 1 && text){
        if($rootScope.stateName == "d" && $rootScope.selectedT == 1 && text){
          if(text){
            $scope.deviceListLoading = true;
            $rootScope.clearSearch = false;
            $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopyS"));
            //Adv search implemented
            $scope.paginationControls.currPage = 1;
            $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
            if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
              $scope.curAdvSearchObj = $scope.advSearchInfo;
              if($scope.filter != "all"){
                $scope.filterType = $scope.filter
                $scope.curAdvSearchObj.fil = $scope.filter;
              } else {
                $scope.filterType = "";
              }
              $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
              $scope.curAdvSearchObj.offset = 0;
              CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
                function(data){
                  $scope.deviceListLoading = false;
                  $scope.filteredData = data;
                  $scope.curAdvSearchObj.isEmpty = data.isem;
                  $scope.curAdvSearchObj.isLoadMore = false;
                  if(data.info.rdc || data.info.rdc == 0){
                    $scope.curAdvSearchObj.rdc = data.info.rdc;
                  }
                  $scope.advSearchfilteredData = {info: $scope.curAdvSearchObj, devices: $scope.filteredData.devices, advObj: $scope.curAdvSearchObj};
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            } else{
              $rootScope.offset = 0;
              $scope.devicesLoading = true;
              $scope.filter = JSON.parse(localStorage.getItem("filterType"));
              $scope.dReqObj = {id: $scope.schedule.info.id, type: "s", auth: $scope.auth, offset: 0, text: $scope.searchTextS.text, filter: $scope.filter, caller: $rootScope.selectedT == 1 ? 'd' : $rootScope.selectedT == 2 ? "dt" : "dg", fId: (($scope.curFolderId > 0 && $rootScope.selectedT == 1) ? $scope.curFolderId : 0)};
              $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
            }
          } else {
            $scope.devicesLoading = false;
          }
        } else {
          $scope.deviceListLoading = false;
          if(caller){
            $rootScope.commonSearchVar = "";
            $rootScope.clearSearch = true;
            $scope.searchTextS.text = "";
            $scope.searchText = "";
          } else {
            $scope.searchText = $scope.searchTextS.text;
          }
        }
      }
    }

    $scope.folderBriefFx = function(){}
    $rootScope.deleteCallback = function(){}

    $scope.exDateOpenFx = function(mainDate, index){
      $scope.exObj = {dRange: {startDate: mainDate.startDate, endDate: mainDate.endDate}, mDate: mainDate, index: index};
      $scope.minDate = $scope.exObj.mDate.startDate;
      $scope.maxDate = $scope.exObj.mDate.endDate;
      $scope.hasErrPop = false;
      ngDialog.open({
        template: "app/schedules/popup/exceptionDate.html",
        width: 650,
        scope: $scope,
        closeByDocument: false
      });
    }
    $scope.exDateFx = function(){
      $scope.hasErr = false;
      $scope.hasErrPop = false;
      $scope.errType = "";
      $scope.curDate = angular.element(document).find(".exDate-picker").val();
      $scope.curDate = $scope.curDate.split(" - ");
      $scope.customDate = {startDate: moment($scope.curDate[0]).format('YYYY-MM-DD'), endDate: moment($scope.curDate[1]).format('YYYY-MM-DD')};

      if($scope.exObj.mDate.startDate <= $scope.customDate.startDate && $scope.exObj.mDate.endDate >= $scope.customDate.endDate){
        if($scope.schedule.schedule.timingList.length){
          if($scope.schedule.schedule.timingList[$scope.exObj.index].ex.length === 0){
            $scope.schedule.schedule.timingList[$scope.exObj.index].ex.push($scope.customDate);
            ngDialog.close();
          } else {
            $scope.isSameDate = false;
            for(var i = 0;i < $scope.schedule.schedule.timingList[$scope.exObj.index].ex.length;i++){
              if($scope.schedule.schedule.timingList[$scope.exObj.index].ex[i].startDate <= $scope.customDate.endDate && $scope.schedule.schedule.timingList[$scope.exObj.index].ex[i].endDate >= $scope.customDate.startDate){
                $scope.isSameDate = true;
                break;
              }
            }
            if($scope.isSameDate){
              $scope.hasErrPop = true;
              $scope.errType = "sameDate";
            } else {
              $scope.schedule.schedule.timingList[$scope.exObj.index].ex.push($scope.customDate);
              ngDialog.close();
            }
          }
        }
      } else {
        $scope.hasErrPop = true;
        $scope.errType = "invDate";
      }
    }
    $scope.removeExDateOpen = function(index, list){
      $scope.exObj = {index: index, list: list};
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeExDateFx(exObj.index);">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain: true,
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: 'ngdialog-theme-default ngdialog-confirm',
      });
    }
    $scope.removeExDateFx = function(){
      $scope.exObj.list.splice($scope.exObj.index, 1);
      ngDialog.close();
    }

    $scope.appliedDeviceListFx = function(au){
      $scope.popupLoading = true;
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"s.p_s.btn.6" | translate}}</h1></header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(304)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div ng-if="!popupLoading">\
                <h5 class="panel-inner-tab marB10">{{"as.label.6" | translate}}</h5>\
                <div ng-if="!appliedList.incl.length" class="msg-warning" lang="{{auth.lang}}">{{"s.p_s.msg.56" | translate}}</div>\
                <div class="table no-th" ng-if="appliedList.incl.length">\
                  <div class="row" ng-repeat="list in appliedList.incl">\
                    <div class="col-xs-12">{{list.name}}</div>\
                  </div>\
                </div>\
                <div ng-if="appliedList.excl.length">\
                  <h5 class="panel-inner-tab marT20 marB10">{{"as.label.7" | translate}}</h5>\
                  <div class="table no-th">\
                    <div class="row" ng-repeat="list in appliedList.excl">\
                      <div class="col-xs-12">{{list.name}}</div>\
                    </div>\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
              </span>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain: true,
        width: 600,
        scope: $scope,
        closeByDocument: false
      });

      SchedulesCUSrv.getValidateDeviceList($scope.schedule).then(
        function(data){
          $scope.popupLoading = false;
          $scope.appliedList = data.data;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.deviceListLoading = true;
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
        // $scope.firstApply.filter = true;
      } else {
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.deviceListLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isem;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info: $scope.curAdvSearchObj, devices: $scope.filteredData.devices, advObj: $scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller: "gbdt", type: $scope.curDType.type, offset: $rootScope.offset, isDP: ($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false), filter: $scope.filter, isLV: ($scope.auth.upreferences.deviceView == 'l' ? true : false), text: $scope.searchTextS.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else {
        $rootScope.offset = 0;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {id: $scope.schedule.info.id, type: "s", auth: $scope.auth, offset: 0, text: $scope.searchTextS.text, filter: $scope.filter, caller: $rootScope.selectedT == 1 ? 'd' : $rootScope.selectedT == 2 ? "dt" : "dg", fId: (($scope.curFolderId > 0 && $rootScope.selectedT == 1) ? $scope.curFolderId : 0)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type == "offline"){
        $rootScope.deviceFilter = "off";
      } else if(type == "online"){
        $rootScope.deviceFilter = "on";
      } else {
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else {
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      // $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else {
        obj.offset = 1000;
      }
      for(var i = tempList.length;i < obj.dList.length;i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else {
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    // $scope.setCountFx = function(caller){
    //   $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
    //   if(caller=='last'){
    //     $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
    //   } else{
    //     $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
    //   }

    //   // if($scope.filter && $scope.filter != "all" && !$scope.devices.devices.length && $scope.dData.devices.length){
    //   if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isFilterMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     // if($scope.filter && $scope.filter != "all" && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //     if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isFilterMsg = true;
    //     }else{
    //       $scope.isFilterMsg = false;
    //     }
    //   }
    //   if($scope.searchTextS.text && $scope.searchTextS.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isSearchMsg = true;
    //     $scope.isFilterMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     $scope.isSearchMsg = false;
    //   }

    //   if(!$scope.searchTextS.text && $scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
    //     $scope.isAdvSearchMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isFilterMsg = false;
    //   } else {
    //     if($scope.searchTextS.text && $scope.searchTextS.text.length && $scope.dData.advObj && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //       $scope.isSearchMsg = true;
    //       $scope.isAdvSearchMsg = false;
    //       $scope.isFilterMsg = false;
    //     } else {
    //       $scope.isAdvSearchMsg = false;
    //     }
    //   }
    // }

    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.setCountFx = function(caller){
      // console.error("setCountFx", caller);
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller == 'last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
      } else {
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
      }

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else {
        // console.log($rootScope.isObjectEmpty($scope.dData), ($rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length), !$scope.devices.devices.length, !$scope.advSApply);
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
          // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
          // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else {
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else {
        if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
          // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else {
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchTextS.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else {
        $scope.isAdvSearchMsg = false;
      }
    }

    $scope.folderContentFx = function(fId, splId, type, caller){
      // ?New: this "if" code is for device folder
      $scope.apiCalledArr = [];
      $scope.curNum = 0;
      // console.warn($rootScope.stateName);
      // if($scope.selectedTab == "hub.sContainer.sDevice"){
      if($rootScope.stateName == "d"){// For Device
        $scope.paginationControls.currPage = 1;

        $scope.deviceListLoading = true;
        if(!caller || caller != "changeView"){
          $scope.searchTextS.text = "";
          $scope.searchText = "";
        }

        $scope.deviceListLoading = true;
        $scope.search = {text: ""};
        $rootScope.selectedItems = [];
        localStorage.removeItem("curPathId");
        localStorage.removeItem('curSPlObj');
        localStorage.removeItem("curDFId");
        $scope.advSearch = false;
        $scope.curFolderId = 0;

        if(fId == 0){
          $scope.breadCrumbs = [];
        }
        if(fId){
          localStorage.setItem("curDFId", fId);
          $scope.curFolderId = localStorage.getItem("curDFId");
        }

        if($scope.curFolderId == 0){
          localStorage.setItem("inFolder", 0);
          localStorage.setItem("curDFId", 0);
          localStorage.removeItem("curPathFId");
        }

        $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
        if($scope.filterType != "all"){
          // $scope.dData.isAll = false;
          $scope.filterIsAppliedAlready = true;
        }
        // console.warn($scope.schedule, $scope.selectedTab, $rootScope.curState);
        $scope.selectedTab = $rootScope.curState;

        // $scope.schObj = {id:$scope.schedule.info.id, type:'s'};
        // $scope.folObj = {fId:fId, offset:0, obj:$scope.schObj, caller:null,filType:$scope.filterType,text:$scope.searchTextS.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};

        var ls = $scope.schedule.info.ls ? $scope.schedule.info.ls : 0; //schedule type
        var minmaxDate = {minStartDate: $scope.schedule.schedule.dateRange.startDate, maxEndDate: $scope.schedule.schedule.dateRange.endDate};

        var dAPIObj = {
          caller: $rootScope.selectedT == 1 ? "d" : $rootScope.selectedT == 2 ? "dt" : "dg",
          s: moment(minmaxDate.minStartDate).format('MM/DD/YYYY'),
          e: moment(minmaxDate.maxEndDate).format('MM/DD/YYYY'),
          id: $scope.schedule.info.id,
          fil: $scope.filterType,
          type: type, offset: 0, fId: fId, dr: [], t: ls
        }

        if(dAPIObj.caller == "d" && $scope.auth && $scope.auth.upreferences.deviceView == "l"){
          dAPIObj.isLV = 1;
        } else{
          dAPIObj.isLV = 0;
        }
        if($scope.searchTextS.text && $scope.searchTextS.text.length){
          // dAPIObj.searchQ = encodeURIComponent($scope.searchTextS.text);
          dAPIObj.searchQ = $scope.searchTextS.text;
        }

        //  DevicesSrv.getFolderData(fId, null, $scope.schObj, null, $scope.filterType, $scope.searchTextS.text).then(
        //  DevicesSrv.getFolderData($scope.folObj).then(
        SchedulesCUSrv.getDeviceList1(dAPIObj).then(
          function(data){
            $scope.flId = fId;
            $scope.deviceListLoading = false;
            $scope.devices = angular.copy(data);
            if(data.info.rdc || data.info.rdc == 0){
              $scope.rdc = data.info.rdc;
            }
            $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.devices);
            //  if($scope.searchTextS.text && $scope.searchTextS.text.length){
            //   $scope.sData = angular.copy($scope.devices)
            //  } else{
            //   $scope.dData = angular.copy($scope.devices)
            //   if($scope.filter && $scope.filter != 'all'){
            //     // $scope.fData.folders = angular.copy($scope.devices.folders)
            //     $scope.fData = angular.copy($scope.devices);
            //   }
            //  }
            $scope.dData = angular.copy($scope.devices)
            $scope.searchTotal = angular.copy($scope.devices.info.count ? $scope.devices.info.count : $scope.devices.devices.length);
            $scope.brief = data;
            $scope.setCountFx();
            $scope.updateList();

            if(!$scope.filterType || $scope.filterType == "all"){
              $scope.filterType = "";
              $scope.filter = "all";
              $scope.fCount = $scope.devices.devices;
            } else {
              $scope.fCount = $filter("filter")($scope.devices.devices, {status: $scope.filterType}, true);
            }

            //  if(($scope.flId == 0 && $scope.rdc > 0 && ($scope.rdc == $scope.dData.devices.length)) || ($scope.flId > 0 && $scope.dData.devices.length < $scope.auth.upreferences.dpc)){
            // //  if($scope.rdc > 0 && ($scope.rdc == $scope.dData.devices.length)){
            //    $scope.dData.isAll = true;
            //  } else{
            //    $scope.dData.isAll = false;
            //  }
          },
          function(err){
            $scope.deviceListLoading = false;
            $log.error(err);
          }
        );
      } else{// For Content
        $scope.contentLibraryLoading = true;
        $scope.templatesLoading = true;
        if($rootScope.selectedT == 2){//For Template Tab
          if(fId){
            localStorage.setItem("inTFolder", fId);
            $scope.curTFolderId = localStorage.getItem("inTFolder");
          }
          if(fId == 0){
            localStorage.setItem("inTFolder", fId);
            $scope.curTFolderId = localStorage.getItem("inTFolder");
          }

          TemplatesSrv.getTemplatesContent($scope.curTFolderId, $scope.schedule.info.ls==3?1:0).then(
            function(data){
              $scope.curTemplates = data;
              $scope.templates = data;
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
              $scope.searchChangeFx("empty");
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        } else{ //For Content Tab
          // var cAPIObj = {fId:fId, splId:splId, type:type, dr:[], t:ls};

          var ls = $scope.schedule.info.ls ? $scope.schedule.info.ls : 0; //schedule type
          var minmaxDate = {minStartDate: $scope.schedule.schedule.dateRange.startDate, maxEndDate: $scope.schedule.schedule.dateRange.endDate};
          if($scope.schedule.schedule.subType == "dc" && $scope.schedule.schedule.timingList.length > 0){
            minmaxDate = $filter("minmaxDate")($scope.schedule.schedule.timingList);
          }

          // if($scope.schedule.schedule.subType == "dc" && $scope.schedule.schedule.timingList.length > 0){
          //   angular.forEach($scope.schedule.schedule.timingList, function(tl){
          //     cAPIObj.dr.push({s:tl.startDate, e:tl.endDate});
          //   });
          // } else{
          //   cAPIObj.dr.push({s:moment(minmaxDate.minStartDate).format('MM/DD/YYYY'), e:moment(minmaxDate.maxEndDate).format('MM/DD/YYYY')});
          // }

          var cAPIObj = {
            s: moment(minmaxDate.minStartDate).format('MM/DD/YYYY'),
            e: moment(minmaxDate.maxEndDate).format('MM/DD/YYYY'),
            fId: fId, splId: splId, type: type,
            dr: [],
            t: ls
          }

          // ContentLibrarySrv.getFolderApprovedContent(fId, splId, type).then(
          SchedulesCUSrv.getApproved(cAPIObj).then(
            function(data){
              localStorage.removeItem("folderId");
              localStorage.setItem("folderId", fId);
              $scope.flId = fId;
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
              $scope.searchChangeFx("empty");

              $scope.contentLibrary = {info: "", contentLibrary: {folder: [], content: []}};
              if($scope.schedule.info.hideJBW){
                $scope.contentLibrary.info = data.info;
                $scope.contentLibrary.contentLibrary.folder = data.contentLibrary.folder;
                angular.forEach(data.contentLibrary.content, function(item){
                  if(item.extn != "Jukebox"){
                    $scope.contentLibrary.contentLibrary.content.push(item);
                  }
                });
              } else{
                $scope.contentLibrary = data;
              }
              $scope.updateList();
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
      $scope.setQuadHeightFx();
    }

    $scope.updateList = function(){
      $rootScope.selectedItems = [];
      $scope.templateList = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      if($scope.searchTextS.text && $scope.searchTextS.text.length){
        $scope.folderList = [];
      }
      //?New: if condition is for schedule device section
      // if($scope.selectedTab=='hub.sContainer.sDevice'){
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df' && $rootScope.stateName == 'd'){
        if(!$rootScope.addStatusKeyVal.value){
          $scope.deviceListLoading = false;
        }
        if($scope.devices.info && $scope.devices.info.breadCrumbs){
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
        // if($rootScope.totalDeviceOnServer > $scope.auth.upreferences.dpc){
        if($scope.devices.folders){
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchTextS.text){
          $scope.folderList = $scope.dData.folders;
        }
        // }
      }
      // else if($scope.selectedTab=='hub.sContainer.sContent'){
      else if($rootScope.stateName == 'c'){
        $scope.tim = $scope.contentLibrary.info.timthumb;
        $scope.contentLibraryLoading = false;
        $scope.templatesLoading = false;

        if($scope.contentLibrary.info.breadCrumbs){
          $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        }
        if($scope.contentLibrary.contentLibrary.folder){
          $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
        }

        if($scope.contentLibrary.contentLibrary.content){
          if($scope.schedule.info.ls == 1){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Image" || (item.splType && item.splType == "Image")){
                $scope.contentList.push(item);
              }
            });
          } else if($scope.schedule.info.ls == 2){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Widget" && (item.extn == "Survey" || item.extn == "Crop Comm: Alert Message")){
                $scope.contentList.push(item);
              }
            });
          } else if($scope.schedule.info.ls == 3){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if((item.type == "POWERPOINT" && item.pages == 1) || item.type == "Image" || (item.splType && item.splType == "Image")){
                $scope.contentList.push(item);
              }
            });
          } else if($scope.schedule.info.ls == 4){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Widget" && (item.extn == "Content on Demand")){
                $scope.contentList.push(item);
              }
            });
          } else if($scope.schedule.info.ls == 5){
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.type == "Widget" && (item.extn == "F45 Workout")){
                $scope.contentList.push(item);
              }
            });
          } else{
            angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
              if(item.extn != "Content on Demand" && item.extn != "Content Group"){
                $scope.contentList.push(item);
              }
            });
          }
        }
        // console.error($scope.templates, $rootScope.selectedT);
        if($rootScope.selectedT == 2){
          // console.warn("$scope.templates ", $scope.templates);
          $scope.tim = $scope.templates.info.timthumb;
          $scope.tBucket = $scope.tDetailBucket = $scope.templates.info.bucket;
          if($scope.templates.info.mbucket && $scope.templates.info.mbucket != ""){
            $scope.tDetailBucket = $scope.templates.info.mbucket;
          }
          localStorage.setItem("tiSchedule", JSON.stringify({tim:$scope.tim, tBucket:$scope.tBucket, mbucket:$scope.tDetailBucket}));
          if($scope.templates.info.breadCrumbs){
            $scope.breadCrumbs = $scope.templates.info.breadCrumbs;
          }

          if($scope.templates.templates.folder){
            $scope.folderList = $scope.templates.templates.folder;
          }
          if($scope.templates.templates.template){
            angular.forEach($scope.templates.templates.template, function(val){
              if(val.isApproved === 1){
                $scope.templateList = $scope.templates.templates.template
              }
            })
          }
          if($scope.templates.templates && !$scope.templates.templates.folder && !$scope.templates.templates.template){
            $scope.templateList = $scope.templates.templates;
          }
        }
      }
    }

    $scope.$on('$destroy', function(){
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
      $scope.advSearchInfo = {};
    });

    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow, {}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code": 5000});
        }
      );
    }

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.deviceListLoading = true;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      $rootScope.offset = 0;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      // if($scope.selectedTab === "hub.sContainer.sDevice"){
      if($rootScope.stateName === "d"){
        var fId = localStorage.getItem("curDFId");
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj.offset = 0;
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isem;
              $scope.curAdvSearchObj.isLoadMore = false;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.curAdvSearchObj.sortType = data.i.sortType;
              $scope.curAdvSearchObj.sortVal = data.i.sortVal;
              $scope.advSearchfilteredData = {info: $scope.curAdvSearchObj, devices: $scope.filteredData.devices, advObj: $scope.curAdvSearchObj};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds: $scope.filteredData.info.allIds, count: $scope.filteredData.info.count};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.deviceListLoading = false;
            }
          );
        } else{
          if(fId > 0){
            $scope.folderContentFx(fId, null, null, "changeView");
          } else{
            $scope.isLoadedFx('changeView');
          }
        }
      }
      // deregister();
    });

    $scope.apiCalledArr = [];

    $scope.getAssignableDevicesFx = function(obj, caller){
      // DevicesSrv.getAssignableDevices(obj).then(  //TODO 26-06-24 how to replase with SchedulesCUSrv.getDeviceList1
      SchedulesCUSrv.getDeviceList1(obj).then(  //TODO 26-06-24 how to replase with SchedulesCUSrv.getDeviceList1
        function(data){
          if(caller != 'saveSearch'){
            $scope.folderList = [];
            $scope.sDeviceList = data;
            if($rootScope.selectedT == 1){
              $scope.addStatusKey($scope.sDeviceList.devices, $scope.auth.upreferences.dot);
            }
            $scope.addTypeKey($scope.sDeviceList);
            $scope.folderList = $scope.sDeviceList.folders;
            if($scope.schedule.info.hideJBD){
              $scope.devices.devices = [];
              angular.forEach($scope.sDeviceList.devices, function(item){
                if(item.dType != "mc"){
                  $scope.devices.devices.push(item);
                }
              });
            } else{
              $scope.devices.devices = $scope.sDeviceList.devices;
              $scope.setTabFx(); // TODO New Code 070824
            }
            $scope.devices.folders = $scope.sDeviceList.folders;
            $scope.devices.info = $scope.sDeviceList.info;
            $scope.bucket = $scope.dDetailBucket = $scope.sDeviceList.info.bucket;
            if($scope.sDeviceList.info.mbucket && $scope.sDeviceList.info.mbucket != ""){
              $scope.dDetailBucket = $scope.sDeviceList.info.mbucket;
            }
            $scope.tim = $scope.sDeviceList.info.timthumb;
            $scope.deviceListLoading = false;

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType == "all"){
              $scope.filterType = "";
              $scope.filter = "all";
              $scope.fCount = $scope.devices.devices;
            } else{
              $scope.filter = $scope.filterType;
              $scope.fCount = $filter("filter")($scope.devices.devices, {status: $scope.filterType}, true);
            }
          } else if(caller == 'saveSearch'){
            $scope.sDeviceList = data;
            $rootScope.selectedT = 3;
            $rootScope.selectedTabFx();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData){
      // Deep compare the new data with the current data
      if(!angular.equals($scope.currentPageDevice, newData.curData)){
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if(!angular.equals($scope.allPageDevice, newData.allData.length)){
        $scope.allPageDevice = angular.copy(newData.allData.length);
      }
    }

    // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data){
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function(){
      return $scope.currentPageDevice.map(function(obj){
        return obj.id;
      }).join(',');
    };


    /*Content info popup actions Start*/
    $scope.getInsideContentFx = function(id, caller){
      $scope.contentInfo.isCallFrom = "scu";
      if(caller == "cg" || caller == "template"){
        $scope.innerLoading = true;
        $scope.contentInfo.content = [];
        CommonSrv.getCGList(id, caller).then(
          function(data){
            $scope.innerLoading = false;
            $scope.contentInfoCopy.content = angular.copy(data.content);
            $scope.contentInfo.content = data.content;
          },
          function(err){
            $log.error(err);
            $scope.innerLoading = false;
          }
        );
      } else{
        $scope.innerLoading = true;
        ContentLibrarySrv.briefContentList(id, caller).then(
          function(data){
            $scope.innerLoading = false;
            // $scope.contentCountList = data;
            if(caller != "filler" && data.content.length){
              $scope.contentInfoCopy.content = angular.copy(data.content);
            }
            $scope.contentInfo.content = data.content;
            // $scope.cBucket = $scope.cDetailBucket = $scope.contentCountList.info.bucket;
            // if($scope.contentCountList.info.mbucket && $scope.contentCountList.info.mbucket != ""){
              //   $scope.cDetailBucket = $scope.contentCountList.info.mbucket;
              // }
            },
            function(err){
            $scope.innerLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.infoBC = [];
    $scope.contentOpenFx = function(cl){      
      $scope.searchInfo = {text:""};
      $scope.infoBC.push({id:cl.id, label:cl.label, type:cl.type, extn:cl.extn});
      if(cl.type == "Widget" && cl.extn == "Content Group"){
        $scope.innerLoading = true;
        $scope.contentInfo.content = [];
        CommonSrv.getCGList(cl.id, cl.extn).then(
          function(data){
            $scope.innerLoading = false;
            $scope.contentInfo.content = data.content;
          },
          function(err){
            $log.error(err);
            $scope.innerLoading = false;
          }
        );
      } else if(cl.extn == "Filler Content" && (!cl.content || (cl.content && !cl.content.length))){
        $scope.getInsideContentFx(cl.id, "filler");
      } else if(cl.extn == "QR Code"){
        $scope.getInsideContentFx(cl.id, "qr");
      } else if(cl.extn == "Content on Demand"){
        $scope.getInsideContentFx(cl.id, "cod");
      } else if(cl.extn == "Content Group"){
        $scope.getInsideContentFx(cl.id, "cg");
      } else{
        $scope.contentInfo.content = cl.content;
      }
    }

    $scope.contentInfoOpen = function(clObj){
      $scope.searchInfo = {text:""};
      $scope.contentBtn = [];
      $scope.infoBC = [];
      if(clObj.path == "Templates"){
        clObj.path = $filter("translate")('cm.menu.2');
      }
      if(clObj.folderid){
        clObj.fid = clObj.folderid;
      }
      if(clObj.fId){
        clObj.fid = clObj.fId;
      }

      $scope.contentInfoCopy = angular.copy(clObj);
      $scope.contentInfo = angular.copy(clObj);

      // TODO Key Sort change to full key becose the info popup is common.
      $scope.tempCInfo = angular.copy(clObj);
      $scope.contentInfo.fId = $scope.tempCInfo.fid?$scope.tempCInfo.fid:0;
      $scope.contentInfo.type = $scope.tempCInfo.type;
      $scope.contentInfo.label = $scope.tempCInfo.label;
      $scope.contentInfo.size = $scope.tempCInfo.size;
      $scope.contentInfo.extn = $scope.tempCInfo.extn;
      $scope.contentInfo.path = $scope.tempCInfo.path;
      $scope.contentInfo.duration = $scope.tempCInfo.duration;
      $scope.contentInfo.dimension = $scope.tempCInfo.dimension;
      $scope.contentInfo.content = $scope.tempCInfo.content;
      if($scope.contentInfo.type.toLowerCase() == "widget"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:$scope.contentInfo.type}]
        if($scope.contentInfo.extn == "Filler Content"){
          $scope.getInsideContentFx($scope.contentInfo.id, "filler");
        } else if($scope.contentInfo.extn == "QR Code"){
          $scope.getInsideContentFx($scope.contentInfo.id, "qr");
        } else if($scope.contentInfo.extn == "Content on Demand"){
          $scope.getInsideContentFx($scope.contentInfo.id, "cod");
        } else if($scope.contentInfo.extn == "Content Group"){
          $scope.getInsideContentFx($scope.contentInfo.id, "cg");
        }
      } else if($scope.contentInfo.type.toLowerCase() != "widget" && $scope.contentInfo.type.toLowerCase() != "template"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:"content", subType:$scope.contentInfo.type}]
      } else if($scope.contentInfo.type.toLowerCase() != "widget" && $scope.contentInfo.type.toLowerCase() == "template"){
        $scope.getInsideContentFx($scope.contentInfo.id, "template");
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:"content"}]
      }

      if($scope.contentInfo.content && $scope.contentInfo.content.length){
        $scope.isLabel = $scope.contentInfo.content[0].label?"label":"l";
      } else{
        $scope.isLabel = "label";
      }

      $scope.timthumb = $scope.tim;
      
      $scope.customFilter = function(item){
        var itemValue = (item[$scope.isLabel] || '').toLowerCase();
        var searchText = ($scope.searchInfo.text || '').toLowerCase();
        return itemValue.indexOf(searchText) !== -1;
        // return item[$scope.isLabel].indexOf($scope.searchInfo.text) !== -1;
      };

      $scope.customOrder = function(item){
        return item[$scope.isLabel];
      };

      if($scope.contentInfo.type != "template"){
        $scope.btnProcessing = true;
        ContentLibrarySrv.getApproveBtn($scope.contentInfoData).then(
          function(data){
            $scope.btnProcessing = false;
            $scope.contentBtn = data;
          },
          function(err){
            $scope.btnProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.contentInfo.type == "template"){
        $scope.btnProcessing = true;
        TemplatesSrv.saveTemplateBtn($scope.contentInfoData).then(
          function(data){
            $scope.btnProcessing = false;
            $scope.contentBtn = data;
          },
          function(err){
            $scope.btnProcessing = false;
            $log.error(err);
          }
        );
      }

      ngDialog.open({
        template:'app/common/popup/contentInfo.html',
        width:760,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }

    $scope.infoBCFx = function(cl){
      $scope.searchInfo = {text:""};
      $scope.infoBC = [];
      if(cl){
        $scope.contentOpenFx(cl);
      } else{
        $scope.contentInfo = angular.copy($scope.contentInfoCopy);
        $scope.contentInfo.isCallFrom = "scu";
      }
    }

    $scope.openContentFolderFx = function(id, fId, type, splId, splType, gid, gType){
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
        $state.go("hub.templates.t");
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
        if(gType){
          localStorage.setItem("curGroupId", gid);
          localStorage.setItem("curGroupType", gType);
        }
        $state.go("hub.contentLibrary.c");
      }
    }

    $scope.downloadOpen = function(contentInfo){
      $scope.downloadSurl = "";
      // var cBucket = $scope.contentList.info.cb;
      // if($scope.contentList.i.cmb && $scope.contentList.i.cmb != ""){
      //   cBucket = $scope.contentList.i.cmb;
      // }
      if(contentInfo.type == "Image"){
        $scope.downloadUrl = $scope.cDetailBucket + contentInfo.thumb;
      } else if(contentInfo.type == "Video" || contentInfo.type == "Audio" || contentInfo.type == "POWERPOINT" || contentInfo.type == "WORD" || contentInfo.type == "Vector" || contentInfo.type == "Flash"){
        $scope.downloadUrl = $scope.cDetailBucket + contentInfo.url;
      }
      if(contentInfo.sUrl){
        $scope.downloadSurl = $scope.cDetailBucket + contentInfo.sUrl;
      } else if(contentInfo.url){
        $scope.downloadSurl = $scope.cDetailBucket + contentInfo.url;
      }
      $scope.linkOpenFx('m', $scope.downloadUrl, $scope.downloadSurl, contentInfo.thumb, contentInfo.type, contentInfo.size, contentInfo.pSize);
    }

    $scope.editFx = function(id, fId, type, extn, label, splId, splType){
      $rootScope.tabView = false;
      $scope.tempId = $scope.hubEncrypt(id);
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
      }
      if(type == "Widget"){
        if(extn == "AGC"){
          $state.go("hub.contentAdd.widgetAddTab.agc", {
            id:$scope.tempId
          });
        } else if(extn == "Crop Comm: Alert Message"){
          $state.go("hub.contentAdd.widgetAddTab.alertMsg", {
            id:$scope.tempId
          });
        } else if(extn == "Achievers"){
          $state.go("hub.contentAdd.widgetAddTab.achievers", {
            id:$scope.tempId
          });
        } else if(extn == "Air Quality Index"){
          $state.go("hub.contentAdd.widgetAddTab.aqi", {
            id:$scope.tempId
          });
        } else if(extn == "Amazon QuickSight"){
          $state.go("hub.contentAdd.widgetAddTab.amazonQuickSight", {
            id:$scope.tempId
          });
        } else if(extn == "Auto Login (Basic Auth)"){
          $state.go("hub.contentAdd.widgetAddTab.autoLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id:$scope.tempId
          });
        } else if(extn == "Cisco Meraki"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events View"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coev", {
            id:$scope.tempId
          });
        } else if(extn == "Content on Demand"){
          $state.go("hub.contentAdd.widgetAddTab.contentOnDemand", {
            id:$scope.tempId
          });
        } else if(extn == "Button"){
          $state.go("hub.contentAdd.widgetAddTab.codButton", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Events"){
          $state.go("hub.contentAdd.widgetAddTab.comEvent", {
            id:$scope.tempId
          });
        } else if(extn == "Pandora CloudCover"){
          $state.go("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            id:$scope.tempId
          });
        } else if(extn == "Content Group"){
          $state.go("hub.contentAdd.widgetAddTab.contentGroup", {
            id:$scope.tempId
          });
        } else if(extn == "Count"){
          $state.go("hub.contentAdd.widgetAddTab.count", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Pylon Text"){
          $state.go("hub.contentAdd.widgetAddTab.comPylonText", {
            id:$scope.tempId
          });
        } else if(extn == "Cloud Farm"){
          $state.go("hub.contentAdd.widgetAddTab.cloudFarm", {
            id:$scope.tempId
          });
        } else if(extn == "Date Time"){
          $state.go("hub.contentAdd.widgetAddTab.dateTime", {
            id:$scope.tempId
          });
        } else if(extn == "Delimited Text"){
          $state.go("hub.contentAdd.widgetAddTab.delimitedText", {
            id:$scope.tempId
          });
        } else if(extn == "External Input"){
          $state.go("hub.contentAdd.widgetAddTab.externalInput", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Excel Sheet"){
          $state.go("hub.contentAdd.widgetAddTab.excelSheet", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook"){
          $state.go("hub.contentAdd.widgetAddTab.facebook", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook Workplace"){
          $state.go("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            id:$scope.tempId
          });
        } else if(extn == "Fifa"){
          $state.go("hub.contentAdd.widgetAddTab.fifa", {
            id:$scope.tempId
          });
        } else if(extn == "Filler Content"){
          $state.go("hub.contentAdd.widgetAddTab.fillerContent", {
            id:$scope.tempId
          });
        } else if(extn == "Flight Schedule"){
          $state.go("hub.contentAdd.widgetAddTab.flightSchedule", {
            id:$scope.tempId
          });
        } else if(extn == "Free Form"){
          $state.go("hub.contentAdd.widgetAddTab.freeForm", {
            id:$scope.tempId
          });
        } else if(extn == "FTP"){
          $state.go("hub.contentAdd.widgetAddTab.ftp", {
            id:$scope.tempId
          });
        } else if(extn == "Fullscreen Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.fsChrome", {
            id:$scope.tempId
          });
        } else if(extn == "F45"){
          $state.go("hub.contentAdd.widgetAddTab.f45", {
            id:$scope.tempId
          });
        } else if(extn == "Blank"){
          $state.go("hub.contentAdd.widgetAddTab.blank", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Scroller"){
          $state.go("hub.contentAdd.widgetAddTab.contentScroller", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Tile"){
          $state.go("hub.contentAdd.widgetAddTab.contentTile", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Countdown Circle"){
          $state.go("hub.contentAdd.widgetAddTab.countdownCircle", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Hydrate"){
          $state.go("hub.contentAdd.widgetAddTab.hydrate", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Move Station"){
          $state.go("hub.contentAdd.widgetAddTab.moveStation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.f45progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Animation"){
          $state.go("hub.contentAdd.widgetAddTab.animation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar With Break"){
          $state.go("hub.contentAdd.widgetAddTab.progressBarWithBreak", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Stay"){
          $state.go("hub.contentAdd.widgetAddTab.stay", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Work"){
          $state.go("hub.contentAdd.widgetAddTab.work", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Workout"){
          $state.go("hub.contentAdd.widgetAddTab.story", {
            id:$scope.tempId
          });
        } else if(extn == "Google Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.gCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Google Slide"){
          $state.go("hub.contentAdd.widgetAddTab.gSlide", {
            id:$scope.tempId
          });
        } else if(extn == "Grafana Cloud"){
          $state.go("hub.contentAdd.widgetAddTab.grafana", {
            id:$scope.tempId
          });
        } else if(extn == "HD Steth"){
          $state.go("hub.contentAdd.widgetAddTab.hdSteth", {
            id:$scope.tempId
          });
        } else if(extn == "IFrame"){
          $state.go("hub.contentAdd.widgetAddTab.iFrame", {
            id:$scope.tempId
          });
        } else if(extn == "Instagram"){
          $state.go("hub.contentAdd.widgetAddTab.instagram", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Circuit Bench"){
          $state.go("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            id:$scope.tempId
          });
        } else if(extn == "LinkedIn"){
          $state.go("hub.contentAdd.widgetAddTab.linkedIn", {
            id:$scope.tempId
          });
        } else if(extn == "Interactive Menu"){
          $state.go("hub.contentAdd.widgetAddTab.iMenu", {
            id:$scope.tempId
          });
        } else if(extn == "IoT Button"){
          $state.go("hub.contentAdd.widgetAddTab.iotButton", {
            id:$scope.tempId
          });
        } else if(extn == "Intel JCI Map"){
          $state.go("hub.contentAdd.widgetAddTab.jciMap", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Smart Building"){
          $state.go("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            id:$scope.tempId
          });
        } else if(extn == "Live Streaming"){
          $state.go("hub.contentAdd.widgetAddTab.liveStreaming", {
            id:$scope.tempId
          });
        } else if(extn == "Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.meeting", {
            id:$scope.tempId
          });
        } else if(extn == "Message"){
          $state.go("hub.contentAdd.widgetAddTab.message", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams"){
          $state.go("hub.contentAdd.widgetAddTab.msTeams", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Rooms"){
          $state.go("hub.contentAdd.widgetAddTab.teamsRoom", {
            id:$scope.tempId
          });
        } else if(extn == "Music Choice"){
          $state.go("hub.contentAdd.widgetAddTab.musicChoice", {
            id:$scope.tempId
          });
        } else if(extn == "News"){
          $state.go("hub.contentAdd.widgetAddTab.news", {
            id:$scope.tempId
          });
        } else if(extn == "NextBus"){
          $state.go("hub.contentAdd.widgetAddTab.nextBus", {
            id:$scope.tempId
          });
        } else if(extn == "Next Vehicle"){
          $state.go("hub.contentAdd.widgetAddTab.nextVehicle", {
            id:$scope.tempId
          });
        } else if(extn == "Online Radio"){
          $state.go("hub.contentAdd.widgetAddTab.onlineRadio", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Outlook Calendar"){
           $state.go("hub.contentAdd.widgetAddTab.outlookCalendar", {
             id:$scope.tempId
           });
        } else if(extn == "LifeLabs Patient Wait"){
          $state.go("hub.contentAdd.widgetAddTab.patientWait", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Power BI"){
          $state.go("hub.contentAdd.widgetAddTab.powerBI", {
            id:$scope.tempId
          });
        } else if(extn == "Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "Prayer"){
          $state.go("hub.contentAdd.widgetAddTab.prayer", {
            id:$scope.tempId
          });
        } else if(extn == "Open Hours"){
          $state.go("hub.contentAdd.widgetAddTab.openHours", {
            id:$scope.tempId
          });
        } else if(extn == "Queue"){
          $state.go("hub.contentAdd.widgetAddTab.queue", {
            id:$scope.tempId
          });
        } else if(extn == "Quotes"){
          $state.go("hub.contentAdd.widgetAddTab.quotes", {
            id:$scope.tempId
          });
        } else if(extn == "QR Code"){
          $state.go("hub.contentAdd.widgetAddTab.qrCode", {
            id:$scope.tempId
          });
        } else if(extn == "Qlik"){
          $state.go("hub.contentAdd.widgetAddTab.qlik", {
            id:$scope.tempId
          });
        } else if(extn == "Readerboard"){
          $state.go("hub.contentAdd.widgetAddTab.readerboard", {
            id:$scope.tempId
          });
        } else if(extn == "RSS Feed"){
          $state.go("hub.contentAdd.widgetAddTab.rssFeed", {
            id:$scope.tempId
          });
        } else if(extn == "Schedule Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Slack"){
          $state.go("hub.contentAdd.widgetAddTab.slack", {
            id:$scope.tempId
          });
        } else if(extn == "Firstup"){
          $state.go("hub.contentAdd.widgetAddTab.socialChorus", {
            id:$scope.tempId
          });
        } else if(extn == "Social Media"){
          $state.go("hub.contentAdd.widgetAddTab.socialMedia", {
            id:$scope.tempId
          });
        } else if(extn == "Stock Price"){
          $state.go("hub.contentAdd.widgetAddTab.stockPrice", {
            id:$scope.tempId
          });
        } else if(extn == "Storm"){
          $state.go("hub.contentAdd.widgetAddTab.storm", {
            id:$scope.tempId
          });
        } else if(extn == "Sun Smart"){
          $state.go("hub.contentAdd.widgetAddTab.sunSmart", {
            id:$scope.tempId
          });
        } else if(extn == "Survey"){
          $state.go("hub.contentAdd.widgetAddTab.survey", {
            id:$scope.tempId
          });
        } else if(extn == "Tableau"){
          $state.go("hub.contentAdd.widgetAddTab.tableau", {
            id:$scope.tempId
          });
        } else if(extn == "Telax"){
          $state.go("hub.contentAdd.widgetAddTab.telax", {
            id:$scope.tempId
          });
        } else if(extn == "Crawling Text" || extn == "Static Text"){
          $state.go("hub.contentAdd.widgetAddTab.text", {
            id:$scope.tempId
          });
        } else if(extn == "Traffic"){
          $state.go("hub.contentAdd.widgetAddTab.traffic", {
            id:$scope.tempId
          });
        } else if(extn == "TouchLink Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.touchLink", {
            id:$scope.tempId
          });
        } else if(extn == "Training Mode"){
          $state.go("hub.contentAdd.widgetAddTab.trainingMode", {
            id:$scope.tempId
          });
        } else if(extn == "TSC Country Mile"){
          $state.go("hub.contentAdd.widgetAddTab.tsccm", {
            id:$scope.tempId
          });
        } else if(extn == "X"){
          $state.go("hub.contentAdd.widgetAddTab.twitter", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Channels"){
          $state.go("hub.contentAdd.widgetAddTab.teamsChannel", {
            id:$scope.tempId
          });
        } else if(extn == "Ungerboeck"){
          $state.go("hub.contentAdd.widgetAddTab.ungerboeck", {
            id:$scope.tempId
          });
        } else if(extn == "Unisys"){
          $state.go("hub.contentAdd.widgetAddTab.unisys", {
            id:$scope.tempId
          });
        } else if(extn == "Vimeo"){
          $state.go("hub.contentAdd.widgetAddTab.vimeo", {
            id:$scope.tempId
          });
        } else if(extn == "Weather"){
          $state.go("hub.contentAdd.widgetAddTab.weather", {
            id:$scope.tempId
          });
        } else if(extn == "Web Cam"){
          $state.go("hub.contentAdd.widgetAddTab.webCam", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login"){
          $state.go("hub.contentAdd.widgetAddTab.webLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.webLoginChrome", {
            id:$scope.tempId
          });
        } else if(extn == "Web Page"){
          $state.go("hub.contentAdd.widgetAddTab.webPage", {
            id:$scope.tempId
          });
        } else if(extn == "Wait Queue Metro"){
          $state.go("hub.contentAdd.widgetAddTab.wqMetro", {
            id:$scope.tempId
          });
        } else if(extn == "webex by CISCO"){
          $state.go("hub.contentAdd.widgetAddTab.webex", {
            id:$scope.tempId
          });
        } else if(extn == "Xovis"){
          $state.go("hub.contentAdd.widgetAddTab.xovis", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Viva Engage"){
          $state.go("hub.contentAdd.widgetAddTab.yammer", {
            id:$scope.tempId
          });
        } else if(extn == "YouTube"){
          $state.go("hub.contentAdd.widgetAddTab.youTube", {
            id:$scope.tempId
          });
        }else if(extn == "Verkada"){
          $state.go("hub.contentAdd.widgetAddTab.verkada", {
            id:$scope.tempId
          });
        }
      } else{
        $state.go("hub.tContainer.tName", {type:$scope.hubEnc("t"), id:$scope.tempId});
      }
    }

    /*Content info popup actions End */

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal){
      if(!angular.equals(newVal, oldVal)){
        $scope.currentPageDevice = newVal;
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal){
      if(!angular.equals(newVal, oldVal)){
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for(var i = 1;i <= allPagesCount;i++){
              $scope.pageDeviceArr.push({pNo: i, tz: new Date().getTime()});
            }
          } else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for(var i = 1;i <= allPagesCount - start;i++){
              $scope.pageDeviceArr.push({pNo: start + i, tz: new Date().getTime()});
            }
          }
        }
      }
    }, true); // 'true' for deep watch
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SchedulesController', SchedulesController);

  /** @ngInject */
  function SchedulesController($log, $rootScope, $scope, $state, $sce, $filter, $cookies, ngDialog, CommonSrv, SchedulesSrv, TemplatesSrv, ReportsSrv, ContentLibrarySrv, DevicesSrv){
    $rootScope.selectedMenu = 3;
    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.scheduleLoading = true;
    $scope.saveProcessing = false;
    $scope.isConfirmOpen = false;
    $scope.allChildHidden = true;
    $scope.innerLoading = false;
    $scope.isDeletable = false;
    $scope.searchMsg = false;
    $scope.filterCount = "";
    $scope.curGrpSchedule;
    $scope.schedules = {};
    $scope.encType = "";
    $scope.searchRegExp;
    $scope.sgId = [];
    $scope.contentInfoData = [];
    $scope.folderList = [];
    $scope.schData = {copy:""};

    // Remove frome Local Storage
    localStorage.removeItem("clSchedule");
    localStorage.removeItem("clfSchedule");
    localStorage.removeItem("celEventBack");

    localStorage.removeItem("tSchedule");
    localStorage.removeItem("tfSchedule");
    localStorage.removeItem("tiSchedule");


    $scope.groupCUOpen = function(id, label, permission){
      localStorage.removeItem("curScheduleId");
      localStorage.removeItem("curScheduleGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.sGrp = {id:id, label:label, permission:permission};
      if(!$scope.sGrp.permission){
        $scope.sGrp.permission = {};
        $scope.sGrp.permission.type = $scope.auth.upreferences.defaultP;
      } else{
        $scope.sGrp.permission = {type:permission.t?permission.t:permission.type};
      }
      ngDialog.open({
        template:'app/schedules/popup/groupCU.html',
        width:620,
        scope:$scope,
        data:$scope.sGrp,
        closeByDocument:false,
        controller:'groupCUController'
      });
    }

    $scope.loadSelectedTab = function(caller){
      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        localStorage.removeItem("curScheduleId");
        localStorage.removeItem("curScheduleGroupId");
        angular.element('.ui-selectable li').removeClass('ui-highlight');
      }
      $scope.scheduleLoading = true;
      $rootScope.selectedItems = [];
      $scope.searchMsg = false;
      $scope.searchText = "";
      $scope.schedules = {};
      if(caller !== "sort"){
        $scope.advSearchInfo = {};
        $scope.advSearch = false;
      }
      if($scope.selectedTab === "hub.schedules.s"){
        localStorage.setItem("scuData", false);
        //get stored adv search data after search
        $scope.curFilterSMObj = angular.fromJson(localStorage.getItem("curFilterSMObj"));
        $scope.curAdvSearchCopy = angular.fromJson(localStorage.getItem("curAdvSearchCopy"));
        $scope.isSMAdvSearch = localStorage.getItem("isSMAdvSearch");
        $scope.isActionOnSchedule = localStorage.getItem("isActionOnSchedule");
        if(localStorage.getItem("gpo")){//Add to root permission false and no group added
          $scope.groupCUOpen();
          localStorage.removeItem("gpo");
        }
        $scope.encType = $scope.hubEnc("s");
        if(caller == "sort" && $scope.advSearch){
          CommonSrv.updateAdvSearchS($scope.advObj).then(
            function(data){
              $scope.schedules = data;
              $scope.filterCount = $scope.schedules.s.length;
              $scope.updateList();
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          if(localStorage.getItem("isActionOnSchedule")){
            localStorage.removeItem("isActionOnSchedule");
          }
          //store search state if edit
          if($scope.isActionOnSchedule){
            if($scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.cr || $scope.curAdvSearchCopy.sr || $scope.curAdvSearchCopy.cb || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.scheduleRange || $scope.curAdvSearchCopy.createdBy){
              $scope.searchProcessing = true;
              $scope.hasErr = false;
              $scope.curFilterSMObj = { module:$scope.curAdvSearchCopy.module, sName:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, scheduleRange:$scope.curAdvSearchCopy.scheduleRange, scheduleDateRange:$scope.curAdvSearchCopy.scheduleDateRange, createdBy:$scope.curAdvSearchCopy.cb?$scope.curAdvSearchCopy.cb:$scope.curAdvSearchCopy.createdBy, step:$scope.curAdvSearchCopy.step };
              CommonSrv.updateAdvSearchS($scope.curFilterSMObj).then(
                function(data){
                  $scope.searchProcessing = false;
                  $scope.filteredData = data;
                  $scope.curAdvSearchCopy.isEmpty = data.isem;
                  // $scope.advSearchfilteredData = { info:$scope.curAdvSearchCopy, schedules:{ info:$scope.filteredData.info, groups:$scope.filteredData.groups, schedules:$scope.filteredData.schedules }, code:data.code, advObj:$scope.curFilterSMObj };
                  $scope.advSearchfilteredData = { info:$scope.curAdvSearchCopy, schedules:{i:$scope.filteredData.i, g:$scope.filteredData.g, s:$scope.filteredData.s}, code:data.code, advObj:$scope.curFilterSMObj };
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                  $scope.updateList();
                  ngDialog.close($scope.confirmDialog);
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            } else{
              $scope.hasErr = true;
            }
          } else{
            localStorage.removeItem("isSMAdvSearch");
            localStorage.removeItem("curFilterSMObj");
            SchedulesSrv.getSchedules().then(
              function(data){
                if($scope.selectedTab === "hub.schedules.s"){
                  $scope.schedules = data;
                  $rootScope.schPriority = $scope.schedules.i.sp;
                  localStorage.setItem('schPriority', JSON.stringify($rootScope.schPriority));
                  $scope.filterCount = $scope.schedules.s.length;
                  $scope.updateList();
                  $scope.loadingMain = false;
                  $scope.curScheduleId = angular.fromJson(localStorage.getItem("curScheduleId"));
                  if($scope.curScheduleId){
                    setTimeout(function(){
                      angular.forEach(angular.element('.ui-selectable li'), function(item){
                        if($(item).attr('data-id') == $scope.curScheduleId){
                          $(item).addClass('ui-highlight');
                        }
                      });
                    }, 100);
                  }
                  $scope.curScheduleGroupId = angular.fromJson(localStorage.getItem("curScheduleGroupId"));
                  if($scope.curScheduleGroupId){
                    setTimeout(function(){
                      angular.forEach(angular.element('.ui-selectable div'), function(item){
                        if($(item).attr('data-id') == $scope.curScheduleGroupId){
                          $(item).addClass('ui-highlight');
                        }
                      });
                    }, 100);
                  }
                }
              },
              function(err){
                $scope.loadingMain = false;
                $log.error(err);
              }
            );
          }
        }
      } else if($scope.selectedTab === "hub.schedules.us"){
        $scope.encType = $scope.hubEnc("us");
        SchedulesSrv.getUnapproved().then(
          function(data){
            if($scope.selectedTab === "hub.schedules.us"){
              $scope.schedules = data;
              // $scope.schedules = {schedules:data.s, groups:data.g, info:data.i};
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curScheduleId = angular.fromJson(localStorage.getItem("curScheduleId"));
              if($scope.curScheduleId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curScheduleId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.schedules.is"){
        $scope.encType = $scope.hubEnc("is");
        SchedulesSrv.getIncompleted().then(
          function(data){
            if($scope.selectedTab === "hub.schedules.is"){
              $scope.schedules = data;
              // $scope.schedules = {schedules:data.s, groups:data.g, info:data.i};
              $scope.updateList();
              $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.schedules.es"){
        $scope.encType = $scope.hubEnc("es");
        SchedulesSrv.getExpired().then(
          function(data){
            if($scope.selectedTab === "hub.schedules.es"){
              $scope.schedules = data;
              // $scope.schedules = {schedules:data.s, groups:data.g, info:data.i};
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curScheduleId = angular.fromJson(localStorage.getItem("curScheduleId"));
              if($scope.curScheduleId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curScheduleId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      localStorage.removeItem("curScheduleId");
      localStorage.removeItem("curScheduleGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $scope.loadSelectedTab("sort");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.updateList = function(){
      $scope.scheduleLoading = false;
      $scope.tim = $scope.schedules.i.tth;
      $scope.cBucket = $scope.cDetailBucket = $scope.schedules.i.cb;
      if($scope.schedules.i.cmb && $scope.schedules.i.cmb != ""){
        $scope.cDetailBucket = $scope.schedules.i.cmb;
      }
      $scope.tBucket = $scope.tDetailBucket = $scope.schedules.i.tb;
      if($scope.schedules.i.tmb && $scope.schedules.i.tmb != ""){
        $scope.tDetailBucket = $scope.schedules.i.tmb;
      }
      $rootScope.folderIdArray = localStorage.getItem("folderIdArrTemp");
      $rootScope.folderIdArr = JSON.parse($rootScope.folderIdArray);
      setTimeout(function(){
        if($rootScope.folderIdArr != null){
          for(var i = 0; i <= $rootScope.folderIdArr.length; i++){
            $(".folder-heading").each(function(item){
              if($(this).attr("data-id") == $rootScope.folderIdArr[i]){
                $(this).find('.fa-folder').addClass('fa-folder-open text-primary');
                $(this).closest(".folderQuad").children(".folder-content").addClass('show');
              }
            });
          }
        }
      },100);
      // $scope.tabIndexFx("s");
    }

    $scope.editSchedule = function(){
      if($scope.auth.upermissions.se.np){
        $state.go("hub.sContainer.sName", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if($scope.auth.upermissions.se.s){
        $state.go("hub.sContainer.sSchedule", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if($scope.auth.upermissions.se.c){
        $state.go("hub.sContainer.sContent", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
        $state.go("hub.sContainer.sDevice", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if($scope.auth.upermissions.se.f){
        $state.go("hub.sContainer.sFrame", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      }
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchText = "";
      $scope.contextMenuOpt = [];
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      if(toState.name != "hub.schedules.s" && !localStorage.getItem("isSMAdvSearch")){
        localStorage.removeItem("isSMAdvSearch");
        localStorage.removeItem("curFilterSMObj");
      }
      localStorage.removeItem("curScheduleId");
      localStorage.removeItem("curScheduleGroupId");
      $scope.loadSelectedTab();
    });

    $scope.briefFx = function(selectedItems){ /*Get frameLayouts brief*/
      console.warn("briefFx ", selectedItems);
      
      $scope.encId = $scope.hubEncrypt(selectedItems[0].id);
      $scope.scheduleBtn = [];
      $scope.scheduleBrief = [];
      $scope.contextMenuOpt = [];
      localStorage.removeItem("curScheduleId");
      localStorage.removeItem("curScheduleGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if(selectedItems.length == 1){
        SchedulesSrv.getScheduleBrief(selectedItems[0].id).then(
          function(data){
            $scope.scheduleBrief = data;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      SchedulesSrv.getScheduleBtn($rootScope.selectedItems).then( /*Button api*/
        function(data){
          $scope.scheduleBtn = data;
          $scope.updateContextMenu($scope.scheduleBtn);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.scheduleSearchFx = function(key){
      $scope.folderCount = $scope.contentCount = 0;
      $scope.searchRegExp = new RegExp(key, "gi");
      $scope.searchMsg = false;
      $scope.curSearch = $scope.escapeSearchText($scope.searchText);
      // $scope.curSearch = $filter('findAndReplace')($scope.searchText,"'", $scope.searchReplaceChar);
    	if($("#schedule-list").length > 0){
        $scope.allFolderCount = $("#schedule-list .folderQuad").length;
        $scope.allContentCount = $("#schedule-list li").length;
    		$("#schedule-list li").each(function(e){
    			$scope.searchRegExp.lastIndex = 0;
    			if($scope.searchRegExp.test($(this).find("div:nth-child(1)").text())){
            $(this).removeClass("sch-hide");
            $(this).show();
    			} else{
            $(this).addClass("sch-hide");
    				$(this).hide();
            if($(this).length){
              $scope.contentCount++;
            }
    			}
    		});
        $("#schedule-list .folderQuad").each(function(e){
          $scope.searchRegExp.lastIndex = 0;
          if($scope.searchRegExp.test($(this).find("a").text())){
            $(this).show();
            $(this).find("li").each(function(e){
              $(this).removeClass("sch-hide");
              $(this).show();
            })
    			} else{
            $scope.allChildHidden = true;
            $(this).find("li").each(function(e){
              if(!$(this).hasClass("sch-hide")){
                $scope.allChildHidden = false;
                return false;
              }
            });
            if($scope.allChildHidden){
              $(this).hide();
            } else{
              $(this).show();
            }
            if($(this).length){
              $scope.folderCount++;
            }
          }
        });
        if(($scope.folderCount == $scope.allFolderCount) && ($scope.contentCount == $scope.allContentCount)){
          $scope.searchMsg = true;
        }
    	}
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/schedules/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }
    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function(menuItem){
        if(menuItem.key == "sEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
        } else if(menuItem.key == "sAssignToGroup"){
          $scope.menuItemLabel = $filter("translate")('s.btn.3');
        } else if(menuItem.key == "sApprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.24');
        } else if(menuItem.key == "sUnapprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.25');
        } else if(menuItem.key == "sDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key == "sPin"){
          $scope.menuItemLabel = $filter("translate")('cm.label.98');
        }

        $scope.curIndex = $scope.contextMenuOpt.length;
        $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
        if(menuItem.key == "sEdit"){
          $scope.tempSubMenu = [];
          angular.forEach(menuItem.steps, function(subMenuItem){
            if(subMenuItem.key == "sStep1"){
              $scope.subMenu = $filter("translate")('cm.brief.1');
            } else if(subMenuItem.key == "sStep2"){
              $scope.subMenu = $filter("translate")('cm.label.3');
            } else if(subMenuItem.key == "sStep3"){
              $scope.subMenu = $filter("translate")('cm.label.1');
            } else if(subMenuItem.key == "sStep4"){
              $scope.subMenu = $filter("translate")('cm.label.4');
            } else if(subMenuItem.key == "sStep5"){
              $scope.subMenu = $filter("translate")('s.body.4');
            }
            $scope.tempSubMenu.push([$scope.subMenu, function($itemScope){$scope.contextMenuFx(subMenuItem);}]);
          });
          $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
        }
      });
    }
    $scope.contextMenuFx = function(menuItem){
      if(menuItem.key == "sEdit" || menuItem.key == "sStep1"){
        $state.go("hub.sContainer.sName", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if(menuItem.key == "sStep2"){
        $state.go("hub.sContainer.sSchedule", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if(menuItem.key == "sStep3"){
        $state.go("hub.sContainer.sContent", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if(menuItem.key == "sStep4"){
        $state.go("hub.sContainer.sDevice", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if(menuItem.key == "sStep5"){
        $state.go("hub.sContainer.sFrame", {type:$scope.encType, id:$scope.hubEncrypt($scope.scheduleBrief.id)});
      } else if(menuItem.key == "sAssignToGroup"){
        $scope.assignToGrpOpen($scope.scheduleBrief.id, $scope.scheduleBrief.gid);
      } else if(menuItem.key == "sApprove"){
        $scope.approveFx();
      } else if(menuItem.key == "sUnapprove"){
        $scope.confirmOpen('unapprove');
      } else if(menuItem.key == "sDelete"){
        $scope.confirmOpen('delete');
      } else if(menuItem.key == "sPin"){
        $scope.pinToDBFx($rootScope.selectedItems, "s");
      }
    }
    $scope.contextMenuBase=[];
    $scope.contextMenuFolder=[];
    if($scope.auth.upermissions.s){
      $scope.contextMenuBase.push([$filter("translate")('s.btn.1'), function($itemScope){$state.go("hub.sContainer.sName", {type:$scope.encType});}]);
    }
    if($scope.auth.upermissions.s && $scope.auth.upermissions.sg){
      $scope.contextMenuBase.push([$filter("translate")('s.btn.2'), function($itemScope){$scope.groupCUOpen();}]);
    }

    $rootScope.folderIdArr =[];
    $scope.folderFx = function(event){
      $(event.currentTarget).find('.fa-folder').toggleClass('fa-folder-open text-primary');
      $(event.currentTarget).closest(".folderQuad").children(".folder-content").toggleClass('show');
      if( $(event.currentTarget).find('.fa-folder').hasClass('fa-folder-open')){
        $scope.sgId.push($(event.currentTarget).attr("data-id"));
        $rootScope.folderIdArr = $scope.sgId;
      } else{
        angular.forEach($rootScope.folderIdArr,function(list){
          if(list == $(event.currentTarget).attr("data-id")){
            $rootScope.folderIdArr.splice($rootScope.folderIdArr.indexOf(list),1);
          }
        });
      }
      localStorage.setItem('folderIdArrTemp', JSON.stringify($rootScope.folderIdArr));
    }

    $scope.statusFx = function(id){
      $(".switch-sm").each(function(){
        if(id == $(this).attr("data-id")){
          $(this).addClass("disabled");
        }
      });
      SchedulesSrv.changeStatus(id).then(
        function(data){
          $(".switch-sm").each(function(){
            if(id == $(this).attr("data-id")){
              $(this).removeClass("disabled");
            }
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.approveFx = function(){
      SchedulesSrv.updateApprove($rootScope.selectedItems).then(
        function(data){
          if(data.code == 10045){
            $scope.approvalObj = data.s;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    {{"s.msg.10" | translate}}\
                    <div class="table table-scroll no-th scrollQuad marT20" style="max-height:{{getAvailableHeight(350)}}px">\
                      <div class="row" ng-repeat="item in approvalObj">\
                        <div class="col-xs-12 word-break">{{item.label}}</div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:550,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*ngDialog*/
    $scope.load = false;
    $scope.contentListFx = function(id, label){
      $scope.load = false;
      $scope.contentView = {id:id, label:label};
      $scope.popupLabel = label;
      $scope.contentList = [];
      SchedulesSrv.getContentList(id).then(
        function(data){
          $scope.contentList = data;
          $scope.timthumb = $scope.contentList.i.tth;
          $scope.cBucket = $scope.cDetailBucket = $scope.contentList.i.cb;
          if($scope.contentList.i.cmb && $scope.contentList.i.cmb != ""){
            $scope.cDetailBucket = $scope.contentList.i.cmb;
          }
          $scope.tBucket = $scope.tDetailBucket = $scope.contentList.i.tb;
          if($scope.contentList.i.tmb && $scope.contentList.i.tmb != ""){
            $scope.tDetailBucket = $scope.contentList.i.tmb;
          }
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/schedules/popup/contentList.html',
        width:845,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }
    $scope.contentInfoOpen = function(clObj){
      $scope.searchInfo = {text:""};
      $scope.contentBtn = [];
      $scope.infoBC = [];

      if(clObj.path == "Templates"){
        clObj.path = $filter("translate")('cm.menu.2');
      }
      $scope.contentInfoCopy = angular.copy(clObj);
      $scope.contentInfo = angular.copy(clObj);

      // TODO Key Sort change to full key becose the info popup is common.
      $scope.tempCInfo = angular.copy(clObj);
      $scope.contentInfo.type = $scope.tempCInfo.t;
      $scope.contentInfo.label = $scope.tempCInfo.l;
      $scope.contentInfo.size = $scope.tempCInfo.si;
      $scope.contentInfo.extn = $scope.tempCInfo.extn;
      $scope.contentInfo.path = $scope.tempCInfo.path;
      $scope.contentInfo.duration = $scope.tempCInfo.du;
      $scope.contentInfo.dimension = $scope.tempCInfo.di;
      $scope.contentInfo.content = $scope.tempCInfo.content;

      if($scope.contentInfo.type == "widget"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:$scope.contentInfo.type}]
      } else if($scope.contentInfo.type != "widget" && $scope.contentInfo.type != "template"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:"content", subType:$scope.contentInfo.type}]
      } else if($scope.contentInfo.type != "widget" && $scope.contentInfo.type == "template"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:"content"}]
      }

      if($scope.contentInfo.content && $scope.contentInfo.content.length){
        $scope.isLabel = $scope.contentInfo.content[0].label?"label":"l";
      } else{
        $scope.isLabel = "label";
      }

      $scope.customFilter = function(item){
        var itemValue = (item[$scope.isLabel] || '').toLowerCase();
        var searchText = ($scope.searchInfo.text || '').toLowerCase();
        return itemValue.indexOf(searchText) !== -1;
        // return item[$scope.isLabel].indexOf($scope.searchInfo.text) !== -1;
      };

      $scope.customOrder = function(item){
        return item[$scope.isLabel];
      };

      if($scope.contentInfo.type != "template"){
        $scope.btnProcessing = true;
        ContentLibrarySrv.getApproveBtn($scope.contentInfoData).then(
          function(data){
            $scope.btnProcessing = false;
            $scope.contentBtn = data;
          },
          function(err){
            $scope.btnProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.contentInfo.type === "template"){
        $scope.btnProcessing = true;
        TemplatesSrv.saveTemplateBtn($scope.contentInfoData).then(
          function(data){
            $scope.btnProcessing = false;
            $scope.contentBtn = data;
          },
          function(err){
            $scope.btnProcessing = false;
            $log.error(err);
          }
        );
      }

      ngDialog.open({
        template:'app/common/popup/contentInfo.html',
        width:760,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }

    $scope.editFx = function(id, fId, type, extn,label, splId, splType){
      $rootScope.tabView = false;
      $scope.tempId = $scope.hubEncrypt(id);
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
      }
      if(type == "Widget"){
        if(extn == "AGC"){
          $state.go("hub.contentAdd.widgetAddTab.agc", {
            id:$scope.tempId
          });
        } else if(extn == "Crop Comm: Alert Message"){
          $state.go("hub.contentAdd.widgetAddTab.alertMsg", {
            id:$scope.tempId
          });
        } else if(extn == "Achievers"){
          $state.go("hub.contentAdd.widgetAddTab.achievers", {
            id:$scope.tempId
          });
        } else if(extn == "Air Quality Index"){
          $state.go("hub.contentAdd.widgetAddTab.aqi", {
            id:$scope.tempId
          });
        } else if(extn == "Amazon QuickSight"){
          $state.go("hub.contentAdd.widgetAddTab.amazonQuickSight", {
            id:$scope.tempId
          });
        } else if(extn == "Auto Login (Basic Auth)"){
          $state.go("hub.contentAdd.widgetAddTab.autoLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id:$scope.tempId
          });
        } else if(extn == "Cisco Meraki"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events View"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coev", {
            id:$scope.tempId
          });
        } else if(extn == "Content on Demand"){
          $state.go("hub.contentAdd.widgetAddTab.contentOnDemand", {
            id:$scope.tempId
          });
        } else if(extn == "Button"){
          $state.go("hub.contentAdd.widgetAddTab.codButton", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Events"){
          $state.go("hub.contentAdd.widgetAddTab.comEvent", {
            id:$scope.tempId
          });
        } else if(extn == "Pandora CloudCover"){
          $state.go("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            id:$scope.tempId
          });
        } else if(extn == "Content Group"){
          $state.go("hub.contentAdd.widgetAddTab.contentGroup", {
            id:$scope.tempId
          });
        } else if(extn == "Count"){
          $state.go("hub.contentAdd.widgetAddTab.count", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Pylon Text"){
          $state.go("hub.contentAdd.widgetAddTab.comPylonText", {
            id:$scope.tempId
          });
        } else if(extn == "Cloud Farm"){
          $state.go("hub.contentAdd.widgetAddTab.cloudFarm", {
            id:$scope.tempId
          });
        } else if(extn == "Date Time"){
          $state.go("hub.contentAdd.widgetAddTab.dateTime", {
            id:$scope.tempId
          });
        } else if(extn == "Delimited Text"){
          $state.go("hub.contentAdd.widgetAddTab.delimitedText", {
            id:$scope.tempId
          });
        } else if(extn == "External Input"){
          $state.go("hub.contentAdd.widgetAddTab.externalInput", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Excel Sheet"){
          $state.go("hub.contentAdd.widgetAddTab.excelSheet", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook"){
          $state.go("hub.contentAdd.widgetAddTab.facebook", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook Workplace"){
          $state.go("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            id:$scope.tempId
          });
        } else if(extn == "Fifa"){
          $state.go("hub.contentAdd.widgetAddTab.fifa", {
            id:$scope.tempId
          });
        } else if(extn == "Filler Content"){
          $state.go("hub.contentAdd.widgetAddTab.fillerContent", {
            id:$scope.tempId
          });
        } else if(extn == "Flight Schedule"){
          $state.go("hub.contentAdd.widgetAddTab.flightSchedule", {
            id:$scope.tempId
          });
        } else if(extn == "Free Form"){
          $state.go("hub.contentAdd.widgetAddTab.freeForm", {
            id:$scope.tempId
          });
        } else if(extn == "FTP"){
          $state.go("hub.contentAdd.widgetAddTab.ftp", {
            id:$scope.tempId
          });
        } else if(extn == "Fullscreen Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.fsChrome", {
            id:$scope.tempId
          });
        } else if(extn == "F45"){
          $state.go("hub.contentAdd.widgetAddTab.f45", {
            id:$scope.tempId
          });
        } else if(extn == "Blank"){
          $state.go("hub.contentAdd.widgetAddTab.blank", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Scroller"){
          $state.go("hub.contentAdd.widgetAddTab.contentScroller", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Tile"){
          $state.go("hub.contentAdd.widgetAddTab.contentTile", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Countdown Circle"){
          $state.go("hub.contentAdd.widgetAddTab.countdownCircle", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Hydrate"){
          $state.go("hub.contentAdd.widgetAddTab.hydrate", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Move Station"){
          $state.go("hub.contentAdd.widgetAddTab.moveStation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.f45progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Animation"){
          $state.go("hub.contentAdd.widgetAddTab.animation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar With Break"){
          $state.go("hub.contentAdd.widgetAddTab.progressBarWithBreak", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Stay"){
          $state.go("hub.contentAdd.widgetAddTab.stay", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Work"){
          $state.go("hub.contentAdd.widgetAddTab.work", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Workout"){
          $state.go("hub.contentAdd.widgetAddTab.story", {
            id:$scope.tempId
          });
        } else if(extn == "Google Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.gCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Google Slide"){
          $state.go("hub.contentAdd.widgetAddTab.gSlide", {
            id:$scope.tempId
          });
        } else if(extn == "Grafana Cloud"){
          $state.go("hub.contentAdd.widgetAddTab.grafana", {
            id:$scope.tempId
          });
        } else if(extn == "HD Steth"){
          $state.go("hub.contentAdd.widgetAddTab.hdSteth", {
            id:$scope.tempId
          });
        } else if(extn == "IFrame"){
          $state.go("hub.contentAdd.widgetAddTab.iFrame", {
            id:$scope.tempId
          });
        } else if(extn == "Instagram"){
          $state.go("hub.contentAdd.widgetAddTab.instagram", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Circuit Bench"){
          $state.go("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            id:$scope.tempId
          });
        } else if(extn == "LinkedIn"){
          $state.go("hub.contentAdd.widgetAddTab.linkedIn", {
            id:$scope.tempId
          });
        } else if(extn == "Interactive Menu"){
          $state.go("hub.contentAdd.widgetAddTab.iMenu", {
            id:$scope.tempId
          });
        } else if(extn == "IoT Button"){
          $state.go("hub.contentAdd.widgetAddTab.iotButton", {
            id:$scope.tempId
          });
        } else if(extn == "Intel JCI Map"){
          $state.go("hub.contentAdd.widgetAddTab.jciMap", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Smart Building"){
          $state.go("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            id:$scope.tempId
          });
        } else if(extn == "Live Streaming"){
          $state.go("hub.contentAdd.widgetAddTab.liveStreaming", {
            id:$scope.tempId
          });
        } else if(extn == "Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.meeting", {
            id:$scope.tempId
          });
        } else if(extn == "Message"){
          $state.go("hub.contentAdd.widgetAddTab.message", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams"){
          $state.go("hub.contentAdd.widgetAddTab.msTeams", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Rooms"){
          $state.go("hub.contentAdd.widgetAddTab.teamsRoom", {
            id:$scope.tempId
          });
        } else if(extn == "Music Choice"){
          $state.go("hub.contentAdd.widgetAddTab.musicChoice", {
            id:$scope.tempId
          });
        } else if(extn == "News"){
          $state.go("hub.contentAdd.widgetAddTab.news", {
            id:$scope.tempId
          });
        } else if(extn == "NextBus"){
          $state.go("hub.contentAdd.widgetAddTab.nextBus", {
            id:$scope.tempId
          });
        } else if(extn == "Next Vehicle"){
          $state.go("hub.contentAdd.widgetAddTab.nextVehicle", {
            id:$scope.tempId
          });
        } else if(extn == "Online Radio"){
          $state.go("hub.contentAdd.widgetAddTab.onlineRadio", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Outlook Calendar"){
           $state.go("hub.contentAdd.widgetAddTab.outlookCalendar", {
             id:$scope.tempId
           });
        } else if(extn == "LifeLabs Patient Wait"){
          $state.go("hub.contentAdd.widgetAddTab.patientWait", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Power BI"){
          $state.go("hub.contentAdd.widgetAddTab.powerBI", {
            id:$scope.tempId
          });
        } else if(extn == "Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "Prayer"){
          $state.go("hub.contentAdd.widgetAddTab.prayer", {
            id:$scope.tempId
          });
        } else if(extn == "Open Hours"){
          $state.go("hub.contentAdd.widgetAddTab.openHours", {
            id:$scope.tempId
          });
        } else if(extn == "Queue"){
          $state.go("hub.contentAdd.widgetAddTab.queue", {
            id:$scope.tempId
          });
        } else if(extn == "Quotes"){
          $state.go("hub.contentAdd.widgetAddTab.quotes", {
            id:$scope.tempId
          });
        } else if(extn == "QR Code"){
          $state.go("hub.contentAdd.widgetAddTab.qrCode", {
            id:$scope.tempId
          });
        } else if(extn == "Qlik"){
          $state.go("hub.contentAdd.widgetAddTab.qlik", {
            id:$scope.tempId
          });
        } else if(extn == "Readerboard"){
          $state.go("hub.contentAdd.widgetAddTab.readerboard", {
            id:$scope.tempId
          });
        } else if(extn == "RSS Feed"){
          $state.go("hub.contentAdd.widgetAddTab.rssFeed", {
            id:$scope.tempId
          });
        } else if(extn == "Schedule Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Slack"){
          $state.go("hub.contentAdd.widgetAddTab.slack", {
            id:$scope.tempId
          });
        } else if(extn == "Firstup"){
          $state.go("hub.contentAdd.widgetAddTab.socialChorus", {
            id:$scope.tempId
          });
        } else if(extn == "Social Media"){
          $state.go("hub.contentAdd.widgetAddTab.socialMedia", {
            id:$scope.tempId
          });
        } else if(extn == "Stock Price"){
          $state.go("hub.contentAdd.widgetAddTab.stockPrice", {
            id:$scope.tempId
          });
        } else if(extn == "Storm"){
          $state.go("hub.contentAdd.widgetAddTab.storm", {
            id:$scope.tempId
          });
        } else if(extn == "Sun Smart"){
          $state.go("hub.contentAdd.widgetAddTab.sunSmart", {
            id:$scope.tempId
          });
        } else if(extn == "Survey"){
          $state.go("hub.contentAdd.widgetAddTab.survey", {
            id:$scope.tempId
          });
        } else if(extn == "Tableau"){
          $state.go("hub.contentAdd.widgetAddTab.tableau", {
            id:$scope.tempId
          });
        } else if(extn == "Telax"){
          $state.go("hub.contentAdd.widgetAddTab.telax", {
            id:$scope.tempId
          });
        } else if(extn == "Crawling Text" || extn == "Static Text"){
          $state.go("hub.contentAdd.widgetAddTab.text", {
            id:$scope.tempId
          });
        } else if(extn == "Traffic"){
          $state.go("hub.contentAdd.widgetAddTab.traffic", {
            id:$scope.tempId
          });
        } else if(extn == "TouchLink Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.touchLink", {
            id:$scope.tempId
          });
        } else if(extn == "Training Mode"){
          $state.go("hub.contentAdd.widgetAddTab.trainingMode", {
            id:$scope.tempId
          });
        } else if(extn == "TSC Country Mile"){
          $state.go("hub.contentAdd.widgetAddTab.tsccm", {
            // id:$scope.hubEncrypt($scope.tempId)
            id:$scope.tempId
          });
        } else if(extn == "X"){
          $state.go("hub.contentAdd.widgetAddTab.twitter", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Channels"){
          $state.go("hub.contentAdd.widgetAddTab.teamsChannel", {
            id:$scope.tempId
          });
        } else if(extn == "Ungerboeck"){
          $state.go("hub.contentAdd.widgetAddTab.ungerboeck", {
            id:$scope.tempId
          });
        } else if(extn == "Unisys"){
          $state.go("hub.contentAdd.widgetAddTab.unisys", {
            id:$scope.tempId
          });
        } else if(extn == "Vimeo"){
          $state.go("hub.contentAdd.widgetAddTab.vimeo", {
            id:$scope.tempId
          });
        } else if(extn == "Weather"){
          $state.go("hub.contentAdd.widgetAddTab.weather", {
            id:$scope.tempId
          });
        } else if(extn == "Web Cam"){
          $state.go("hub.contentAdd.widgetAddTab.webCam", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login"){
          $state.go("hub.contentAdd.widgetAddTab.webLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.webLoginChrome", {
            id:$scope.tempId
          });
        } else if(extn == "Web Page"){
          $state.go("hub.contentAdd.widgetAddTab.webPage", {
            id:$scope.tempId
          });
        } else if(extn == "Wait Queue Metro"){
          $state.go("hub.contentAdd.widgetAddTab.wqMetro", {
            id:$scope.tempId
          });
        } else if(extn == "webex by CISCO"){
          $state.go("hub.contentAdd.widgetAddTab.webex", {
            id:$scope.tempId
          });
        } else if(extn == "Xovis"){
          $state.go("hub.contentAdd.widgetAddTab.xovis", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Viva Engage"){
          $state.go("hub.contentAdd.widgetAddTab.yammer", {
            id:$scope.tempId
          });
        } else if(extn == "YouTube"){
          $state.go("hub.contentAdd.widgetAddTab.youTube", {
            id:$scope.tempId
          });
        }else if(extn == "Verkada"){
          $state.go("hub.contentAdd.widgetAddTab.verkada", {
            id:$scope.tempId
          });
        }
      } else{
        $state.go("hub.tContainer.tName", {type:$scope.hubEnc("t"), id:$scope.tempId});
      }
    }
    $scope.contentEditOpen = function(id,label){
      $scope.editObj = {info:{id:id, label:label}};
      $scope.editBtnProcess = true;
      ContentLibrarySrv.getContentDetails(id).then(
        function(data){
          $scope.editBtnProcess = false;
          $scope.editObj.activePeriod = data.activePeriod;
          $scope.editObj.permission = data.permission;
          ngDialog.open({
            template:"app/contentLibrary/popup/contentEdit.html",
            width:680,
            scope:$scope,
            data:$scope.editObj,
            closeByDocument:false,
            controller:"ContentEditController"
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.setContentTimeFx = function(template){
      angular.forEach(template.frames, function(frame){
        if(frame.content.length){
          var startTime = 0;
          var tmpStartTime = 0;
          var tmpEndTime = 0;
          var endTime = 0;
          for(var i = 0; i < frame.content.length; i++){
            if(i == 0){
              tmpStartTime = startTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            } else{
              tmpStartTime = endTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = endTime + frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            }
          }
        }
      });
    }

    $scope.openContentFolderFx = function(id, fId, type, splId, splType, gid, gType){
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
        $state.go("hub.templates.t");
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
        if(gType){
          localStorage.setItem("curGroupId", gid);
          localStorage.setItem("curGroupType", gType);
        }
        $state.go("hub.contentLibrary.c");
      }
    }

    $scope.deviceListFx = function(id, label){
      $scope.load = false;
      $scope.deviceView = {id:id, label:label};
      $scope.popupLabel = label;
      $scope.deviceList = [];
      $scope.deviceListObj = {id:id};
      $scope.marRemove = true;
      $scope.refreshObj = {l:true, b:false};
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.searchScroll = false;
      $scope.haveMoreSearchData = false;
      $scope.scrollObj = {caller: 's', offset: 0, id: id}
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.marRemove = false;
          $scope.refreshObj = { l: false, b: true };
        },
        function(err){
          $log.error(err);
        }
      );
      // SchedulesSrv.getDeviceList(id).then(
      //   function(data){
      //     $scope.deviceList = data;
      //     $scope.marRemove = false;
      //     $scope.refreshObj = {l:false, b:true};
      //   },
      //   function(err){
      //     $log.error(err);
      //   }
      // );
      ngDialog.open({
        template:'app/schedules/popup/deviceList.html',
        width:985,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
      });
    }

    $scope.refreshPopupListFx = function(caller){
      $scope.loading = true;
      if(caller === 'content'){
        $scope.popupLabel = $scope.contentView.label;
        $scope.contentList = [];
        SchedulesSrv.getContentList($scope.contentView.id).then(
          function(data){
            $scope.loading = false;
            $scope.contentList = data;
            $scope.cBucket = $scope.cDetailBucket = $scope.contentList.i.cb;
            if($scope.contentList.i.cmb && $scope.contentList.i.cmb != ""){
              $scope.cDetailBucket = $scope.contentList.i.cmb;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.contentList.i.tb;
            if($scope.contentList.i.tmb && $scope.contentList.i.tmb != ""){
              $scope.tDetailBucket = $scope.contentList.i.tmb;
            }
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'device'){
        $scope.deviceList = [];
        $scope.scrollDataList = [];
        $scope.refreshObj = { l: true, b: true };
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.searchScroll = false;
        $scope.haveMoreSearchData = false;
        $scope.scrollObj = {caller: 's', offset: 0, id: $scope.deviceView.id}
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.refreshObj.l = false;
            if(!$scope.scrollDataList.length){
              $scope.refreshObj.b = false;
            }
            $scope.loading = false;
          },
          function(err){
            $log.error(err);
          }
        );

        // $scope.deviceList = [];
        // $scope.refreshObj = {l:true, b:true};
        // SchedulesSrv.getDeviceList($scope.deviceView.id).then(
        //   function(data){
        //     $scope.deviceList = data;
        //     $scope.refreshObj.l = false;
        //     if(!$scope.deviceList.length){
        //       $scope.refreshObj.b = false;
        //     }
        //     $scope.loading = false;
        //   },
        //   function(err){
        //     $scope.loading = false;
        //     $log.error(err);
        //   }
        // );
      }
    }

    $scope.infoBC = [];
    $scope.contentOpenFx = function(cl){
      $scope.searchInfo = {text:""};
      $scope.infoBC.push({id:cl.id, label:cl.label, type:cl.type, extn:cl.extn});
      if(cl.type == "Widget" && cl.extn == "Content Group"){
        $scope.innerLoading = true;
        $scope.contentInfo.content = [];
        CommonSrv.getCGList(cl.id, cl.extn).then(
          function(data){
            $scope.innerLoading = false;
            $scope.contentInfo.content = data.content;
          },
          function(err){
            $log.error(err);
            $scope.innerLoading = false;
          }
        );
      } else{
        $scope.contentInfo.content = cl.content;
      }
    }

    $scope.infoBCFx = function(cl){
      $scope.searchInfo = {text:""};
      $scope.infoBC = [];
      if(cl){
        $scope.contentOpenFx(cl);
      } else{
        $scope.contentInfoCopy.type = $scope.contentInfoCopy.t;
        $scope.contentInfoCopy.label = $scope.contentInfoCopy.l;
        $scope.contentInfoCopy.size = $scope.contentInfoCopy.si;
        $scope.contentInfoCopy.extn = $scope.contentInfoCopy.extn;
        $scope.contentInfoCopy.path = $scope.contentInfoCopy.path;
        $scope.contentInfoCopy.duration = $scope.contentInfoCopy.du;
        $scope.contentInfoCopy.dimension = $scope.contentInfoCopy.di;
        $scope.contentInfo = angular.copy($scope.contentInfoCopy);
      }
    }

    $scope.downloadListFx = function(){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      SchedulesSrv.getDeviceList($scope.deviceListObj.id, true).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.downloadOpen = function(contentInfo){
      $scope.downloadSurl = "";
      var cBucket = $scope.contentList.i.cb;
      if($scope.contentList.i.cmb && $scope.contentList.i.cmb != ""){
        cBucket = $scope.contentList.i.cmb;
      }
      if(contentInfo.t == "Image"){
        $scope.downloadUrl = cBucket + contentInfo.th;
      } else if(contentInfo.t == "Video" || contentInfo.t == "Audio" || contentInfo.t == "POWERPOINT" || contentInfo.t == "WORD" || contentInfo.t == "Vector" || contentInfo.t == "Flash"){
        $scope.downloadUrl = cBucket + contentInfo.url;
      }
      if(contentInfo.sUrl){
        $scope.downloadSurl = cBucket + contentInfo.sUrl;
      }
      $scope.linkOpenFx('m', $scope.downloadUrl, $scope.downloadSurl, contentInfo.thumb, contentInfo.t, contentInfo.size, contentInfo.pSize);
    }

    $scope.assignToGrpOpen = function(id, gid, label){
      $scope.hasErr = false;
      $scope.errType = ""
      $scope.assignGrp = {grp:{id:gid, gid:gid}};
      $scope.sGrp = {gList:$scope.schedules.g};
      ngDialog.open({
        template:'app/schedules/popup/assignToGrp.html',
        width:580,
        scope:$scope,
        data:$scope.sGrp,
        closeByDocument:false
      });
    }
    $scope.assignToGrpFx = function(){
      if(localStorage.getItem("isSMAdvSearch")){
        localStorage.setItem("isActionOnSchedule", true);
      } else{
        localStorage.removeItem("isActionOnSchedule");
        localStorage.removeItem("isSMAdvSearch");
        localStorage.removeItem("curFilterSMObj");
      }
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.errType = ""
      SchedulesSrv.updateAssignGrp($rootScope.selectedItems, $scope.assignGrp.grp).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 10032){
            $scope.hasErr = true;
            $scope.errType = "notFind";
            $scope.deletedBy = data.deletedBy;
            return;
          }
          if(data.code == 10042){
            $scope.assignObj = data;
            ngDialog.open({
              template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">\
                  <div class="marB20">The schedule can not be assigned to this group because the schedule is associated to some other permission.</div>\
                  <div class="table no-th">\
                    <div class="scrollQuad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                      <div class="row" ng-repeat="schedule in assignObj.s">\
                        <div class="col-xs-12 word-break">\
                          {{schedule.label}}\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                </div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                </footer>\
              </section>',
              plain:true,
              width:580,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          }
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    $scope.confirmOpen = function(caller, id){
      $scope.dataObj = {caller:caller, id:id};
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dataObj.caller == \'unapprove\'">{{selectedItems.length > 1?"s.msg.6s":"s.msg.6" | translate}}</span>\
              <span ng-if="dataObj.caller == \'delete\'">{{selectedItems.length > 1?"s.msg.7s":"s.msg.7" | translate}}</span>\
              <span ng-if="dataObj.caller == \'group\'">\
                <p>{{"s.msg.8" | translate}}</p>\
                <b>{{"cm.label.66" | translate}}:</b> {{"s.msg.9" | translate}}\
              </span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-warning btn-sm" ng-class="{\'btn-danger\':dataObj.caller!=\'unapprove\'}" ng-click="confirmFx(dataObj.caller,dataObj.id);" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.confirmFx = function(caller, id){
      $scope.saveProcessing = true;
      if(caller == "unapprove"){
        if(localStorage.getItem("isSMAdvSearch")){
          if($scope.selectedTab == "hub.schedules.s"){
            localStorage.setItem("isActionOnSchedule", true);
          } else {
            localStorage.removeItem("isActionOnSchedule");
          }
        } else{
          localStorage.removeItem("isActionOnSchedule");
          localStorage.removeItem("isSMAdvSearch");
          localStorage.removeItem("curFilterSMObj");
        }
        SchedulesSrv.updateUnapprove($rootScope.selectedItems).then(
          function(data){
            ngDialog.close();
            $scope.saveProcessing = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      } else if(caller == "group"){
        SchedulesSrv.deleteGroups(id).then(
          function(data){
            ngDialog.close();
            $scope.saveProcessing = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      } else{
        if(localStorage.getItem("isSMAdvSearch")){
          if($scope.selectedTab == "hub.schedules.s"){
            localStorage.setItem("isActionOnSchedule", true);
          } else {
            localStorage.removeItem("isActionOnSchedule");
          }
        } else{
          localStorage.removeItem("isActionOnSchedule");
          localStorage.removeItem("isSMAdvSearch");
          localStorage.removeItem("curFilterSMObj");
        }
        $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
        SchedulesSrv.deleteSchedules($scope.stringIds).then(
          function(data){
            ngDialog.close();
            $scope.saveProcessing = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen){
        angular.forEach($scope.scheduleBtn.buttons, function(btn){
          if(btn.key == "sDelete"){
            $scope.isDeletable = true;
          }
        });
        if($scope.isDeletable){
          $scope.confirmOpen('delete');
        }
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.schedulesList = [];
      $scope.searchMsg = false;
      $scope.searchText = "";
      if(args.schedules.s){
        $scope.schedules = args.schedules;
        $scope.filterCount = args.schedules.s.length;
      }
      $scope.advSearchInfo = args.info;
      $scope.advObj = args.advObj;
      $scope.advSearch = true;
      // if($scope.isActionOnSchedule){ //TODO Is not identified why it works so we commentout this code.
      //   $scope.updateList();
      // }
      if(args.code == 8118){
        $scope.loadSelectedTab();
      }
    });

    /*Knowledge base*/
    $scope.videoFx = function(tabName){
      $scope.videoObj = {
        tabName:tabName
      };
      $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "U9BGJMnVsMg" + $scope.videoParam);
      ngDialog.open({
        template:'app/schedules/popup/video.html',
        width:580,
        scope:$scope,
        data:$scope.videoObj
      });
    }
    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/schedules/popup/info.html',
        width:580,
        scope:$scope,
        data:$scope.readMeObj
      });
    }

    /*Content Confirmation*/
    $scope.downloadCCFx = function(id){
      $scope.deviceObj = {id:$scope.deviceView.id, caller:"schedule"};
      ReportsSrv.getReportsCC($scope.deviceObj).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          $scope.linkOpenFx(data.url);
        },
        function(err){
          $log.error(err);
        }
      );
    }



    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.folderContentFx = function (fId, splId, splType) {
      // ?New: this "if" code is for device folder
      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
        $scope.deviceListLoading = true;
        $scope.search = { text: "" };
        $rootScope.selectedItems = [];
        // $cookies.remove("curPathId");
        // $cookies.remove('curSPlObj');
        // $cookies.remove("curDFId");
        localStorage.removeItem("curPathId");
        localStorage.removeItem('curSPlObj');
        localStorage.removeItem("curDFId");
        $scope.advSearch = false;
        $scope.curFolderId = 0;

        if (fId == 0) {
          $scope.breadCrumbs = [];
        }
        if (fId) {
          // $cookies.put("curDFId", fId);
          localStorage.setItem("curDFId", fId);
          // $scope.curFolderId = $cookies.get("curDFId");
          $scope.curFolderId = localStorage.getItem("curDFId");
        }

        if ($scope.curFolderId == 0) {
          // $cookies.put("inFolder", 0);
          localStorage.setItem("inFolder", 0);
          // $cookies.remove("curPathFId");
          localStorage.removeItem("curPathFId");
        }
        $scope.folObj = {fId:fId, offset:0, obj:null};
        // DevicesSrv.getFolderData(fId, null, null).then(
        DevicesSrv.getFolderData($scope.folObj).then(
          function (data) {
            $scope.flId = fId;
            $scope.deviceListLoading = false;
            $scope.devices = data;
            $scope.brief = data;
            $scope.updateList();
          },
          function (err) {
            $scope.deviceListLoading = false;
            $log.error(err);
          }
        );
      }
    }


    // * scroll list data code START 2nd phase pagination
    $scope.haveMoreData = false;
    $scope.haveMoreSearchData = false;
    $scope.visibleData = [];
    $scope.stIndex = 0
    $scope.etIndex = 300;
    $scope.searchScroll = false;

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }

    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "s"){
        $scope.loading = false;
        $scope.refreshObj = {l:true, b:false};
        $scope.marginLoad = true;
        $scope.marRemove = false;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "s"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "s"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      // console.warn("visibleData",obj);
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      }, 0);
    });

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });
          var concatObj = obj1.concat(obj2);

          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    // * scroll list data code END 2nd phase pagination
  }
})();

angular.module('hub').service('InventorySrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getInventory = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory/getInventoryData", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.getInventory = function(caller,id,offset,type){
  //   if((caller || caller == 0) && id){
  //     if(type == "h"){
  //       httpReq = $http.get($rootScope.apiHost + "inventory/h/"+caller+"/"+id);
  //     }
  //   } else if(caller || caller == 0){
  //     if(type == "d"){
  //       if(offset){
  //         httpReq = $http.get($rootScope.apiHost + "inventory/d/"+caller+"?dOff="+offset);
  //       } else{
  //         httpReq = $http.get($rootScope.apiHost + "inventory/d/"+caller);
  //       }
  //     }else if(type == "h"){
  //       if(offset){
  //         httpReq = $http.get($rootScope.apiHost + "inventory/h/"+caller+"?hOff="+offset);
  //       } else{
  //         httpReq = $http.get($rootScope.apiHost + "inventory/h/"+caller);
  //       }
  //     }
  //   } else{
  //     httpReq = $http.get($rootScope.apiHost + "inventory/");
  //   }
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }

  this.getDashboard = function(){
    httpReq = $http.get($rootScope.apiHost + "inventory/dashboard");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInventoryTypes = function(caller){
    if(caller == "export"){
      httpReq = $http.get($rootScope.apiHost + "inventory/types?isExport=1");
    } else{
      httpReq = $http.get($rootScope.apiHost + "inventory/types");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInvAdvanceSearched = function(caller){
    if(caller == "d"){
      httpReq = $http.get($rootScope.apiHost + "inventory/advanceSearch/d");
    } else{
      httpReq = $http.get($rootScope.apiHost + "inventory/advanceSearch/h");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addTypes = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory/types",obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSampleFile = function(caller){
    httpReq = $http.get($rootScope.apiHost + "inventory/h/"+caller+"?isExport=1"+"&isSample=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addEdit = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delete = function(id){
    httpReq = $http.delete($rootScope.apiHost + "inventory/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteAttachment = function(iid, aid){
    httpReq = $http.delete($rootScope.apiHost + "inventory/attachments/"+ iid +"/"+ aid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.exportInventory = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory/getInventoryData", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.exportInventory = function(caller,invType,typeId){
  //   if(invType == "d"){
  //     if(caller || caller == 0){
  //       httpReq = $http.get($rootScope.apiHost + "inventory/d/"+caller+"?isExport=1");
  //     } else{
  //       httpReq = $http.get($rootScope.apiHost + "inventory/d/?isExport=1");
  //     }
  //   }else if(invType == "h"){
  //     if(caller || caller == 0){
  //       httpReq = $http.get($rootScope.apiHost + "inventory/h/"+caller+"?isExport=1"+"&typeId="+typeId);
  //     } else{
  //       httpReq = $http.get($rootScope.apiHost + "inventory/h/?isExport=1"+"&typeId="+typeId);
  //     }
  //   }
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }

  this.importInventory = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory/import", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.history = function(id){
    httpReq = $http.get($rootScope.apiHost + "inventory/logs/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.cols = function(obj){
    httpReq = $http.post($rootScope.apiHost + "inventory/cols", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);
angular.module('hub').directive('ngInvList', function(){
  return{
    restrict:'E',
    templateUrl:'app/inventory/dir/invList.html'
  }
});
angular.module('hub').service('SupportSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFeedback = function(){
    httpReq = $http.get($rootScope.apiHost + "support/feedback");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getBugs = function(){
    httpReq = $http.get($rootScope.apiHost + "support/bugs");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getURL = function(){
    httpReq = $http.get($rootScope.apiHost + "support/getUrl");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVidKb = function(){
    httpReq = $http.get($rootScope.apiHost + "support/vidKbList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveMailSupport = function(obj){
    httpReq = $http.post($rootScope.apiHost + "support/email", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFeedback = function(obj){
    httpReq = $http.post($rootScope.apiHost + "support/feedback", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDocuments = function(){
    httpReq = $http.get($rootScope.apiHost + "support/docs");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDownloads = function(){
    httpReq = $http.get($rootScope.apiHost + "support/apps");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRReleaseNotes = function(curCaller, version){
    httpReq = $http.get($rootScope.releaseNotesHost +"releaseNotes/filtered?c="+ curCaller +"&v="+ version);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    } else{
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
  (function () {
  'use strict';

  angular
    .module('hub')
    .controller('InventoryController', InventoryController);

  /** @ngInject */
  function InventoryController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, ngDialog, CommonSrv, FileModelUploadSrv, InventorySrv){
    $rootScope.selectedMenu = 11;
    $scope.selectedTab = $state.current.name;
    $scope.inventoryProcessing = false;
    $scope.inventoryLoading = true;
    $scope.paginationLoading = false;
    $scope.formPagination = false;
    $scope.inventory = {};
    $scope.allDataLoaded = false;
    $scope.invLoading = true;
    $scope.inventorySort = {type:"name",value:"asc"};
    $scope.isOther = false;
    $scope.isDevice = false;
    $scope.isAdvSearch = false;
    $scope.columns = [];
    $scope.invFilter = {};
    $scope.searchInvText = {text:""}

    // temporary commented this
    $scope.dashboardFx = function () {
      InventorySrv.getDashboard(0).then(
        function(data){
          $scope.invLoading = false;
          $scope.dbLoading = false;
          $scope.invData = data;
          $scope.filterdData = [];
          if ($scope.invData.t.values.length > 0) {
            angular.forEach($scope.invData.t.values, function (val) {
              $scope.filterdSt = [];
              angular.forEach(val.st, function (st) {
                if (st.stId !== 2 && st.stId !== 3) {
                  $scope.filterdSt.push(st);
                }
              });
              $scope.filterdData.push({ label: val.label, st: $scope.filterdSt, typeId: val.typeId });
            });
            $scope.invData.t.values = $scope.filterdData;
          }
          /*Item Type*/
          if ($scope.invData.t.values.length > 0) {
            $scope.itArr = [];
            var itOpts = {
              chart: {
                width: 180,
                height: 180,
                type: 'pie',
                plotShadow: false,
                plotBorderWidth: 0,
                margin: [0, 0, 0, 0],
                backgroundColor: 'rgba(0,0,0,0)'
              },
              navigation: {
                buttonOptions: {
                  enabled: false
                }
              },
              tooltip:{
                headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                pointFormat:'{point.name}:<b>{point.y}</b>'
              },
              plotOptions: {
                pie: {
                  cursor: 'pointer',
                  dataLabels: {
                    size: '100%',
                    distance: -16,
                    enabled: true,
                    style: {
                      color: 'white',
                      fontSize: '10px',
                      textShadow: '0 1px 1px #333333'
                    },
                    formatter: function () {
                      return this.y;
                    }
                  },
                  showInLegend: false,
                  center: ['50%', '50%']
                }
              }
            };

            var curItArr = [];
            // console.warn($scope.invData.t.values,"$scope.invData.t.values");
            angular.forEach($scope.invData.t.values, function (val) {
              var curCount = 0;
              angular.forEach(val.st, function(st){
                if(st.label != "Retired"){
                  curCount += st.count;
                }
              });
              if(curCount){
                if(val.label == "mp") {
                  curItArr.push({ name: $filter("translate")('d.label.1.1'), y: curCount, yl:curCount, t: "mp", color: "#6fa8dc" });
                }
                if(val.label == "webos") {
                  curItArr.push({ name: $filter("translate")('d.label.1.5'), y: curCount, yl:curCount, t: "webos", color: "#444444" });
                }
                if(val.label == "mc") {
                  curItArr.push({ name: $filter("translate")('d.label.1.4'), y: curCount, yl:curCount, t: "mc", color: "#00ff00" });
                }
                if(val.label == "tizen") {
                  curItArr.push({ name: $filter("translate")('d.label.1.6'), y: curCount, yl:curCount, t: "tizen", color: "#ff9900" });
                }
                if(val.label == "gf") {
                  curItArr.push({ name: $filter("translate")('d.label.1.2'), y: curCount, yl:curCount, t: "gf", color: "#3d85c6" });
                }
                if(val.label == "v") {
                  curItArr.push({ name: $filter("translate")('d.label.1.3'), y: curCount, yl:curCount, t: "v", color: "#e06666" });
                }
                if(val.label == "desktop") {
                  curItArr.push({ name: $filter("translate")('d.label.1.7'), y: curCount, yl:curCount, t: "desktop", color: "#f1c232" });
                }
                if(val.label == "epd") {
                  curItArr.push({ name: $filter("translate")('d.label.1.8'), y: curCount, yl:curCount, t: "epd", color: "#6aa84f" });
                }
              }
            });
            $scope.itArr.push(
              {
                options:itOpts,
                series:[{
                  size:'100%',
                  data:curItArr,
                  name:$scope.invData.t.label=="Item types"?$filter("translate")('in.body.1'):$scope.invData.t.label,
                  innerSize:'60%',
                  cursor:'pointer',
                  colorByPoint:true,
                  showInLegend:false,
                }],
                title: ' ',
                xAxis: { categories: [] },
                yAxis: { title: ' ' },
              }
            );
          }
          /*Item Status*/
          if ($scope.invData.t.values.length > 0) {
            $scope.itStatusArr = [];
            var itStatusOpts = {
              chart: {
                width: 60,
                height: 60,
                type: 'pie',
                plotShadow: false,
                plotBorderWidth: 0,
                margin: [0, 0, 0, 0],
                backgroundColor: 'rgba(0,0,0,0)'
              },
              navigation: {
                buttonOptions: {
                  enabled: false
                }
              },
              tooltip:{
                headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                pointFormat:'{point.name}:<b>{point.y}</b>',
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-9,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter: function () {
                      return this.y;
                    }
                  },
                  showInLegend: false,
                  center: ['50%', '50%']
                }
              }
            };
            var tmpArr = [];
            var tmpArrJB = $filter("filter")($scope.invData.t.values, {label:"jb"}, true);
            var txtAval = $filter("translate")('in.p_i.15.0');
            var txtDep = $filter("translate")('in.p_i.15.1');
            var txtRet = $filter("translate")('in.p_i.15.2');
            angular.forEach($scope.invData.t.values, function(val){
              var curCount = 0;
              var curArr = [];
              var label = "";
              if(val.label == "jb" && val.label == "mc") {
                angular.forEach(val.st, function(st){
                  if(st.label == "Available"){
                    var aval = $filter("filter")(tmpArrJB[0].st, {label:"Available"}, true);
                    st.count += aval[0].count;
                  }
                  if(st.label == "Deployed"){
                    var dep = $filter("filter")(tmpArrJB[0].st, {label:"Deployed"}, true);
                    st.count += dep[0].count;
                  }
                  if(st.label == "Retired"){
                    var ret = $filter("filter")(tmpArrJB[0].st, {label:"Retired"}, true);
                    st.count += ret[0].count;
                  }
                });
              }
              if(val.label == "mp") {
                val.label = $filter("translate")('d.label.1.1');
              }
              if(val.label == "webos") {
                val.label = $filter("translate")('d.label.1.5');
              }
              if(val.label == "mc") {
                val.label = $filter("translate")('d.label.1.4');
              }
              if(val.label == "tizen") {
                val.label = $filter("translate")('d.label.1.6');
              }
              if(val.label == "gf") {
                val.label = $filter("translate")('d.label.1.2');
              }
              if(val.label == "v") {
                val.label = $filter("translate")('d.label.1.3');
              }
              if(val.label == "desktop") {
                val.label = $filter("translate")('d.label.1.7');
              }
              if(val.label == "epd") {
                val.label = $filter("translate")('d.label.1.8');
              }
              angular.forEach(val.st, function (st) {
                curCount += st.count;
                if(st.label == "Available"){
                  st.color = "#53bbd4";
                  st.name = txtAval;
                }
                if(st.label == "Deployed"){
                  st.color = "#2cc059";
                  st.name = txtDep;
                }
                if(st.label == "Retired"){
                  st.color = "#0a4d79";
                  st.name = txtRet;
                }
              });
              if(curCount){
                angular.forEach(val.st, function(st){
                  if(val.label == "mp"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "webos"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "mc"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "tizen"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "gf"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "v"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "desktop"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label == "epd"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                  if(val.label !== "mp" && val.label !== "webos" && val.label !== "mc" && val.label !== "tizen" && val.label !== "gf" && val.label !== "v" && val.label !== "desktop" && val.label !== "epd"){
                    curArr.push({ name: st.name, y: st.count, yl: st.count, total: "it", title: val.label, color: st.color});
                  }
                });
                $scope.itStatusArr.push(
                  {
                    type:"pie",
                    options:itStatusOpts,
                    series:[{
                      size:'60px',
                      data:curArr,
                      name:val.label,
                      innerSize:'50%',
                      cursor:'pointer',
                      colorByPoint:true,
                      showInLegend:false,
                    }],
                    title: ' ',
                    xAxis: { categories: [] },
                    yAxis: { title: ' ' },
                  }
                );
              }
            });
            $scope.pieArr = [];
            for(var i=0; i<$scope.itStatusArr.length; i++){
              if($scope.itStatusArr[i].series[0].data.length){
                $scope.pieArr.push($scope.itStatusArr[i]);
              }
            }
          }
        },
        function(err){
          $scope.invLoading = false;
          $scope.dbLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.dashboardFx();

    $scope.loadSelectedTab = function(caller){
      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $scope.resetPagination();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        $scope.allDataLoaded = false;
        $scope.isAdvSearch = false;
        $scope.isOther = false;
        $scope.isDevice = false;
      }
      var pageObj = JSON.parse(localStorage.getItem("invPageStatus"));
      if(pageObj){
        $scope.pageObj = pageObj;
        $scope.currentPage = $scope.pageObj.curPage;
        $rootScope.offset = !angular.isUndefined($scope.pageObj.offset)?$scope.pageObj.offset:0;
      }
      $scope.isOther = false;
      $scope.isDevice = false;
      $scope.inventoryLoading = true;
      $scope.paginationLoading = true;
      $scope.allDataLoaded = false;
      // $rootScope.selectedItems = [];
      $scope.searchInvText.text = "";
      $scope.inventory = {};
      $scope.deployedInv = {}
      $scope.advSearchInfo = {}
      if($scope.selectedTab === "hub.inventory.devices"){
        if($rootScope.selectedT == 1){
          $scope.tabCaller = 0;
        }
        else if($rootScope.selectedT == 2){
          $scope.tabCaller = 1;
        }
        else if($rootScope.selectedT == 3){
          $scope.tabCaller = 2;
        }
        // if($scope.inventory.length){
        //   $rootScope.offset = $scope.inventory.length;
        // }else {
        //   $rootScope.offset = 0;
        // }
        if($rootScope.offset == undefined || $rootScope.offset == 0){
          $rootScope.offset = 0;
        }
        if($scope.auth.upermissions.dp){
          $scope.invDeviceObj = {"invType":"d","status":$scope.tabCaller,"id":0,"offset":$rootScope.offset}
        } else{
          $scope.invDeviceObj = {"invType":"d","status":$scope.tabCaller,"id":0}
        }
        InventorySrv.getInventory($scope.invDeviceObj).then(
        // InventorySrv.getInventory($scope.tabCaller,0,$rootScope.offset,"d").then(
          function(data){
            $scope.inventoryLoading = false;
            $scope.paginationLoading = false;
            $scope.loadingMain = false;
            if($rootScope.selectedT == 1){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 2){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 3){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            if($scope.auth.upermissions.dp){
              if($scope.isAdvSearch || $scope.formPagination){
                $scope.setInvRange($scope.invinfo, $scope.currentPage);
              } else {
                $scope.setInvRange($scope.invinfo, null);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        )
      }
      if($scope.selectedTab === "hub.inventory.others"){
        if($rootScope.selectedT == 1){
          $scope.tabCaller = 0;
        }
        else if($rootScope.selectedT == 2){
          $scope.tabCaller = 1;
        }
        else if($rootScope.selectedT == 3){
          $scope.tabCaller = 2;
        }
        // if($scope.inventory.length){
        //   $rootScope.offset = $scope.inventory.length;
        // }else {
        //   $rootScope.offset = 0;
        // }

        if($rootScope.offset == undefined || $rootScope.offset == 0){
          $rootScope.offset = 0;
        }
        if($scope.auth.upermissions.dp){
          $scope.invOtherObj = {"invType":"h","status":$scope.tabCaller,"id":0,"offset":$rootScope.offset}
        } else{
          $scope.invOtherObj = {"invType":"h","status":$scope.tabCaller,"id":0}
        }
        InventorySrv.getInventory($scope.invOtherObj).then(
        // InventorySrv.getInventory($scope.tabCaller,0,$rootScope.offset,"h").then(
          function(data){
            if(caller == "delete" && data.code == 7003){
              $scope.resetPagination();
              $scope.loadSelectedTab();
            } else{
              $scope.inventoryLoading = false;
              $scope.paginationLoading = false;
              $scope.loadingMain = false;
              if($rootScope.selectedT == 1){
                $scope.inventory = data.data;
                $scope.invFilter = data.data;
                $scope.invinfo = data;
              }
              else if($rootScope.selectedT == 2){
                $scope.inventory = data.data;
                $scope.invFilter = data.data;
                $scope.invinfo = data;
              }
              else if($rootScope.selectedT == 3){
                $scope.inventory = data.data;
                $scope.invFilter = data.data;
                $scope.invinfo = data;
              }
              if($scope.auth.upermissions.dp){
                if($scope.isAdvSearch || $scope.formPagination){
                  $scope.setInvRange($scope.invinfo, $scope.currentPage);
                } else {
                  $scope.setInvRange($scope.invinfo, null);
                }
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      }
    }
    localStorage.removeItem("invPageStatus");
    $scope.loadSelectedTab();

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchInvText.text = "";
      $state.current = toState;
      $scope.contextMenuOpt = [];
      $scope.selectedTab = $state.current.name;
      localStorage.removeItem("dTotalCount")
      localStorage.removeItem("invPageStatus");
      $scope.resetPagination();
      $scope.isAdvSearch = false;
      $scope.loadSelectedTab();
    });

    /*ngDialog*/
    $scope.inventoryCUOpen = function(obj){
      $scope.editInvn = obj;
      ngDialog.open({
        template:"app/inventory/popup/otherInv.html",
        width:680,
        scope:$scope,
        closeByDocument:false,
        controller:"OtherInventoryController"
      });
    }

    $scope.inventoryCU = function(){
      $scope.curInvObj = angular.copy($scope.invObj);
      if($scope.curInvObj.pOn){
        $scope.curInvObj.pOn = moment($scope.curInvObj.pOn.startDate).format("YYYY-MM-DD");
      }
      if($scope.curInvObj.isiOn && $scope.curInvObj.iOn){
        $scope.curInvObj.iOn = moment($scope.curInvObj.iOn.startDate).format("YYYY-MM-DD");
      } else{
        $scope.curInvObj.iOn = null;
      }
      if($scope.curInvObj.isrOn && $scope.curInvObj.rOn){
        $scope.curInvObj.rOn = moment($scope.curInvObj.rOn.startDate).format("YYYY-MM-DD");
      } else{
        $scope.curInvObj.rOn = null;
      }
      if($scope.curInvObj.isdOn && $scope.curInvObj.dOn){
        $scope.curInvObj.dOn = moment($scope.curInvObj.dOn.startDate).format("YYYY-MM-DD");
      } else{
        $scope.curInvObj.dOn = null;
      }

      $scope.curInvObj.status = JSON.parse($scope.curInvObj.status);

      $scope.saveProcessing = true;
      InventorySrv.addEdit($scope.curInvObj).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 20001 || data.code == 20002){
            ngDialog.close();
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.deleteOpen = function(id){
      $scope.deleteObj = {id:id};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" focus-me="true" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-class="btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{deleteErr?"cm.btn.1":"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.deleteFx = function () {
      $scope.deleteProcessing = true;
      InventorySrv.delete($scope.deleteObj.id).then(
        function (data) {
          $scope.deleteProcessing = false;
          if (data.code == 20003) {
            ngDialog.close();
            $scope.loadSelectedTab("delete");
          }
        },
        function (err) {
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.historyOpen = function (obj) {
      $scope.historyLoading = true;
      $scope.history = { info: obj, list: [] };
      InventorySrv.history(obj.id).then(
        function (data) {
          $scope.historyLoading = false;
          $scope.history.list = data;
        },
        function (err) {
          $scope.historyLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/inventory/popup/history.html",
        width:620,
        scope:$scope,
        data:$scope.history,
        closeByDocument:false
      });
    }

    $scope.downloadOpen = function(type){
      $scope.advDownloadSetting = [];
      $scope.dColumnOneList = [];
      $scope.dColumnTwoList = [];
      $scope.dColumnThreeList = [];
      if($scope.isAdvSearch){
        $scope.confirmObj = {type:type, status:$scope.advObj.status ,advSearch:true};
      } else{
        $scope.confirmObj = {type:type, status:3};
      }
      if(type == "h"){
        $scope.loadProcessing = true;
        InventorySrv.getInventoryTypes("export").then(
          function(data){
            $scope.advDownloadSetting = data
            $scope.advDownloadSetting = $scope.advDownloadSetting.sort(function(a, b){
              return a.label.localeCompare(b.label);
            });
            $scope.listLength = $scope.advDownloadSetting.length;
            $scope.listCount = parseInt($scope.advDownloadSetting.length/3);
            $scope.listReminder = $scope.advDownloadSetting.length%3;
            if($scope.listReminder == 0){
              for(var i = 0; i <= $scope.listLength; i++){
                $scope.dColumnOneList[i] = $scope.advDownloadSetting[i];
                var j = i;
                if(i === $scope.listCount - 1){break;}
              }
              $scope.listCount = $scope.listCount + j
              j = j+1
              var m = 0;
              for(j; j < $scope.listLength; j++){
                $scope.dColumnTwoList[m] = $scope.advDownloadSetting[j];
                m++
                var k = j;
                if(j === $scope.listCount){ break;}
              }
              k = k+1
              var l = 0
              for(k+1; k < $scope.listLength; k++){
                $scope.dColumnThreeList[l] = $scope.advDownloadSetting[k];
                l++
              }
            } else if($scope.listReminder == 1 || $scope.listReminder == 2){
              for(var i = 0; i <= $scope.listLength; i++){
                $scope.dColumnOneList[i] = $scope.advDownloadSetting[i];
                var j = i;
                if(i === $scope.listCount){break;}
              }
              $scope.listCount = $scope.listCount + j
              j = j+1
              var m = 0;
              for(j; j < $scope.listLength; j++){
                $scope.dColumnTwoList[m] = $scope.advDownloadSetting[j];
                m++
                var k = j;
                if(j === $scope.listCount + 1){break;}
              }
              k = k+1
              var l = 0;
              for(k+1; k < $scope.listLength; k++){
                $scope.dColumnThreeList[l] = $scope.advDownloadSetting[k];
                l++
              }
            }
            $scope.loadProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.loadProcessing = false;
          }
        );
      }
      ngDialog.open({
        template:"app/inventory/popup/export.html",
        width:760,
        scope:$scope,
        data:$scope.viewData,
        closeByDocument:false,
        preCloseCallback:function(){
          $scope.selectData = [];
        }
      });
    }

    $scope.downloadFx = function(caller,invType){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx();
      $scope.selectData = $scope.advDownloadSetting.filter(function(obj){
        if(obj.checkbox == true){
          return obj;
        }
      });
      $scope.typeIds = $scope.arraytoStringFx($scope.selectData);
      if($scope.isAdvSearch){
        $scope.advObj.isExport = 1;
        $scope.advObj.typeIds = $scope.typeIds;
        $scope.invExportObj = $scope.advObj
      } else{
        $scope.invExportObj = {"status":caller,"invType":invType,"typeIds":$scope.typeIds,"isExport":1, "id":0}
      }
      InventorySrv.exportInventory($scope.invExportObj).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.download, surl:""};
        },
        function (err) {
          $log.error(err);
        }
      );
    }

    $scope.uploadOpen = function(){
      $scope.curData = ""
      $scope.hasErr = false;
      $scope.errType = "";
      ngDialog.open({
        template:"app/inventory/popup/import.html",
        width:500,
        scope:$scope,
        data:$scope.cols,
        closeByDocument:false
      });
    }
    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      if($scope.selectedT == 1  || $scope.selectedT == 2 || $scope.selectedT == 3){
        $scope.emptyRow = "?getEmptyRow=1&inventory=true";
      }
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          $scope.fileModelLoading = false;
          if(data.code == 17070){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else{
            $scope.convertData = data;
            if(data && ((data.head && data.head.length > 0) || (data.row && data.row.length > 0))){
              $scope.exceldata = $scope.convertData;
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    $scope.uploadProcessing = false;
    $scope.uploadFx = function(){
      $scope.uploadProcessing = true;
      InventorySrv.importInventory({exceldata:$scope.exceldata}).then(
        function(data){
          $scope.uploadProcessing = false;
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.uploadProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.60" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            ngDialog.close();
            $scope.loadSelectedTab("refresh")
          }
        },
        function(err){
          $log.error(err);
          $scope.uploadProcessing = false;
        }
      );
    }

    $scope.sampleFile = function(){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx();
      if($rootScope.selectedT == 1){
        $scope.status = 0;
      }
      else if($rootScope.selectedT == 2){
        $scope.status = 1;
      }
      else if($rootScope.selectedT == 3){
        $scope.status = 2;
      }
      InventorySrv.getSampleFile($scope.status).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.download, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // $scope.loadMoreList = function (count) {
    //   if(count == 0) {
    //     $scope.searchInvText.text = "";
    //     $scope.inventory = {};
    //   }
    //   $scope.searchInvText.text = "";

    //   if($scope.selectedTab === "hub.inventory.devices"){
    //     if($rootScope.selectedT == 1){
    //       $scope.tabCaller = 0;
    //     }
    //     else if($rootScope.selectedT == 2){
    //       $scope.tabCaller = 1;
    //     }
    //     else if($rootScope.selectedT == 3){
    //       $scope.tabCaller = 2;
    //     }
    //     if($scope.inventory.length){
    //       $rootScope.offset = $scope.inventory.length;
    //     }else {
    //       $rootScope.offset = 0;
    //     }
    //     if(!$scope.allDataLoaded){
    //       $scope.invDeviceObj = {"invType":"d","status":$scope.tabCaller,"id":0,"offset":$rootScope.offset}
    //       InventorySrv.getInventory($scope.invDeviceObj).then(
    //       // InventorySrv.getInventory($scope.tabCaller,0,$rootScope.offset,"d").then(
    //         function(data){
    //           $scope.inventoryLoading = false;
    //           $scope.loadingMain = false;
    //           if(data.code == 7002){
    //             $scope.allDataLoaded = true;
    //           } else{
    //             if($rootScope.selectedT === 1){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             } else if($rootScope.selectedT === 2){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             } else if($rootScope.selectedT === 3){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             }
    //             var curDate = new Date();
    //             angular.forEach($scope.inventory, function(key){
    //               var curDT = moment(parseInt(key.iOn + '000')).format("MMM, DD YYYY");
    //               var deviceW = new Date(curDT);
    //               var numbarW = key.w + Math.floor(key.ew)
    //               deviceW.setDate(deviceW.getDate() + numbarW)
    //               var difference = deviceW.getTime() - curDate.getTime();
    //               var diffDays = Math.ceil(difference / (1000 * 3600 * 24));
    //               if(diffDays > 0){
    //                 key.War = diffDays;
    //               } else{
    //                 key.War = 0;
    //               }
    //             })
    //           }
    //         },
    //         function (err) {
    //           $scope.loadingMain = false;
    //           $log.error(err);
    //         }
    //       );
    //     }
    //   }
    //   if($scope.selectedTab === "hub.inventory.others"){
    //     if($rootScope.selectedT == 1){
    //       $scope.tabCaller = 0;
    //     }
    //     else if($rootScope.selectedT == 2){
    //       $scope.tabCaller = 1;
    //     }
    //     else if($rootScope.selectedT == 3){
    //       $scope.tabCaller = 2;
    //     }
    //     if($scope.inventory.length){
    //       $rootScope.offset = $scope.inventory.length;
    //     }else {
    //       $rootScope.offset = 0;
    //     }
    //     if(!$scope.allDataLoaded){
    //       $scope.invOtherObj = {"invType":"h","status":$scope.tabCaller,"id":0,"offset":$rootScope.offset}
    //       InventorySrv.getInventory($scope.invOtherObj).then(
    //       // InventorySrv.getInventory($scope.tabCaller,0,$rootScope.offset,"h").then(
    //         function(data){
    //           $scope.inventoryLoading = false;
    //           $scope.loadingMain = false;
    //           if(data.code == 7002){
    //             $scope.allDataLoaded = true;
    //           } else{
    //             if($rootScope.selectedT === 1){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             } else if($rootScope.selectedT === 2){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             } else if($rootScope.selectedT === 3){
    //               if(data.data && data.data.length > 0){
    //                 $scope.inventory = $scope.inventory.concat(data.data);
    //               }
    //               $scope.info = data.info;
    //             }
    //             var curDate = new Date();
    //             angular.forEach($scope.inventory, function(key){
    //               var curDT = moment(parseInt(key.iOn + '000')).format("MMM, DD YYYY");
    //               var deviceW = new Date(curDT);
    //               var numbarW = key.w + Math.floor(key.ew)
    //               deviceW.setDate(deviceW.getDate() + numbarW)
    //               var difference = deviceW.getTime() - curDate.getTime();
    //               var diffDays = Math.ceil(difference / (1000 * 3600 * 24));
    //               if(diffDays > 0){
    //                 key.War = diffDays;
    //               } else{
    //                 key.War = 0;
    //               }
    //             })
    //           }
    //         },
    //         function (err) {
    //           $scope.loadingMain = false;
    //           $log.error(err);
    //         }
    //       );
    //     }
    //   }
    // }

    $scope.curCount = 1;
    $scope.pageChangedFx = function (curPage) {
      $scope.searchInvText.text = "";
      // $scope.inventoryLoading = false;
      $scope.currentPage = curPage;

      $scope.formPagination = false;
      $rootScope.offset = $scope.invinfo.info.pl * curPage - $scope.invinfo.info.pl;
      localStorage.setItem("invPageStatus", JSON.stringify({curPage:$scope.currentPage, offset:$rootScope.offset}));
      if (!angular.isUndefined($scope.advSearchInfo.step)) {
        //Adv search
        $scope.getAdvSearchFx($rootScope.offset);
      } else{
        // $scope.paginationLoading = true;
        $scope.formPagination = true;
        $scope.loadSelectedTab();
        $scope.setInvRange($scope.invinfo, curPage);
      }
    }

    // reset pagination
    $scope.resetPagination = function () {
      $rootScope.offset = 0;
      $scope.currentPage = 1;
      $scope.loadingMain = false;
      localStorage.removeItem("invTotalCount");
      localStorage.removeItem("invPageStatus");
      localStorage.setItem("invPageStatus", JSON.stringify({curPage:$scope.currentPage, offset:$rootScope.offset}));
    }

    $scope.setInvRange = function(inv, curPage){
      if(curPage){
        if($scope.isAdvSearch){
          if($scope.invinfo.info.tc > $scope.inventory.length){
            $scope.pageList = $scope.invinfo.data;
          }
        }
        $scope.pageFilter = angular.copy($scope.invinfo.info.pl > 0 ? $scope.invinfo.info.pl : $scope.invinfo.info.tc);
        if(curPage==1){
          $scope.drFrom = 1;
          $scope.drTo = $scope.pageFilter;
        } else if(curPage==2){
          $scope.drFrom = $scope.pageFilter + 1;
          $scope.drTo = $scope.pageFilter += $scope.pageFilter;
        } else if(curPage > 2){
          $scope.drTo = curPage * $scope.pageFilter;
          $scope.drFrom = $scope.drTo - $scope.pageFilter + 1;
        }
        if($scope.invinfo.info.tc < $scope.drTo){
          $scope.drTo = $scope.invinfo.info.tc;
        }
        $scope.inventoryRange = $scope.drFrom + " - " + $scope.drTo;
      } else {
        $scope.drFrom = 1;
        if(inv.info.tc < inv.info.pl){
          $scope.drTo = inv.info.tc;
          $scope.inventoryRange = $scope.drFrom + " - " + $scope.drTo;
        } else {
          $scope.inventoryRange = $scope.drFrom + " - " + (inv.info.pl ? inv.info.pl: inv.data.length);
        }
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.isAdvSearch = false;
      if($rootScope.selectedT == 1){
        $scope.resetPagination();
        $scope.loadSelectedTab();
      }
      else if($rootScope.selectedT == 2){
        $scope.resetPagination();
        $scope.loadSelectedTab();
      }
      else if($rootScope.selectedT == 3){
        $scope.resetPagination();
        $scope.loadSelectedTab();
      }
    }

    setTimeout(function(){
      $scope.slideCount = $('#sliderInv ul li').length;
      $scope.slideWidth = $('#sliderInv ul li').width();
      $scope.slideHeight = $('#sliderInv ul li').height();
      $scope.sliderUlWidth = $scope.slideCount * $scope.slideWidth;
      $('#slider').css({ width: $scope.slideWidth, height: $scope.slideHeight });
      $('#slider ul').css({ width: $scope.sliderUlWidth, marginLeft: - $scope.slideWidth });
      $('#sliderInv ul li:last-child').prependTo('#sliderInv ul');
    }, 2000);

    $scope.prevSlider = function(){
      $('#sliderInv ul').animate({
          left: + $scope.slideWidth
      }, 200, function () {
          $('#sliderInv ul li:last-child').prependTo('#sliderInv ul');
          $('#sliderInv ul').css('left', '');
      });
    };

    $scope.nextSlider = function(){
      $('#sliderInv ul').animate({
          left: - $scope.slideWidth
      }, 200, function () {
          $('#sliderInv ul li:first-child').appendTo('#sliderInv ul');
          $('#sliderInv ul').css('left', '');
      });
    };

    $scope.searchInv = function(search){
      $scope.invFilter = $filter("filter")($scope.inventory, search);
    }

    $scope.getAdvSearchFx = function (offset) {
      var pageObj = JSON.parse(localStorage.getItem("invPageStatus"));
      if(pageObj){
        $scope.pageObj = pageObj;
        $scope.currentPage = $scope.pageObj.curPage;
        $rootScope.offset = !angular.isUndefined($scope.pageObj.offset)?$scope.pageObj.offset:0;
      }
      $scope.isOther = false;
      $scope.isDevice = false;
      $scope.inventoryLoading = true;
      $scope.paginationLoading = true;
      $scope.allDataLoaded = false;
      $scope.searchInvText.text = "";
      $scope.inventory = {};
      $scope.deployedInv = {}
      if($scope.advSearchInfo.step == "d"){
        $scope.advSearchInfoInv = {status:$scope.advSearchInfo.status, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, dName:$scope.advSearchInfo.dName, dType:$scope.advSearchInfo.dType,searchId:$scope.advSearchInfo.searchId, invType:$scope.advSearchInfo.step,id:0,offset:$rootScope.offset};

        if($scope.advSearchInfoInv.createdBy == undefined || $scope.advSearchInfoInv.createdBy == null){
          $scope.advSearchInfoInv.createdBy = "";
        } else {
          $scope.advSearchInfoInv.createdBy = $scope.advSearchInfoInv.createdBy.id;
        }
        if($scope.advSearchInfoInv.creationRange == false){
          $scope.advSearchInfoInv.creationDateRange = {};
        }
        if($scope.advSearchInfoInv.dType == null || $scope.advSearchInfoInv.dType == undefined){
          $scope.advSearchInfoInv.dType = "";
        }
        if($scope.advSearchInfoInv.dName == null || $scope.advSearchInfoInv.dName == undefined){
          $scope.advSearchInfoInv.dName = "";
        }
        if($scope.advSearchInfoInv.searchId == null || $scope.advSearchInfoInv.searchId == undefined){
          $scope.advSearchInfoInv.searchId = "";
        }
        InventorySrv.getInventory($scope.advSearchInfoInv).then(
          function(data){
            $scope.inventoryLoading = false;
            $scope.paginationLoading = false;
            $scope.loadingMain = false;
            if($rootScope.selectedT == 1){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 2){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 3){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            if($scope.auth.upermissions.dp){
              if($scope.isAdvSearch){
                $scope.setInvRange($scope.invinfo, $scope.currentPage);
              } else {
                $scope.setInvRange($scope.invinfo, null);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        )

      } else{
        $scope.advSearchInfoInv = {status:$scope.advSearchInfo.status, creationRange:$scope.advSearchInfo.creationRange, creationDateRange:$scope.advSearchInfo.creationDateRange, createdBy:$scope.advSearchInfo.createdBy, oType:$scope.advSearchInfo.oType,serial:$scope.advSearchInfo.serial, invType:$scope.advSearchInfo.step,id:0,offset:$rootScope.offset};
        if($scope.advSearchInfoInv.createdBy == null || $scope.advSearchInfoInv.createdBy == undefined){
          $scope.advSearchInfoInv.createdBy = "";
        } else{
          $scope.advSearchInfoInv.createdBy = $scope.advSearchInfoInv.createdBy.id;;
        }
        if($scope.advSearchInfoInv.creationRange == false){
          $scope.advSearchInfoInv.creationDateRange = {};
        }
        if($scope.advSearchInfoInv.oType == null || $scope.advSearchInfoInv.oType == undefined){
          $scope.advSearchInfoInv.oType = "";
        } else{
          $scope.advSearchInfoInv.oType = $scope.advSearchInfoInv.oType.id;
        }
        if($scope.advSearchInfoInv.name == null || $scope.advSearchInfoInv.name == undefined){
          $scope.advSearchInfoInv.name = "";
        }
        if($scope.advSearchInfoInv.serial == null || $scope.advSearchInfoInv.serial == undefined){
          $scope.advSearchInfoInv.serial = "";
        }

        InventorySrv.getInventory($scope.advSearchInfoInv).then(
          function(data){
            $scope.inventoryLoading = false;
            $scope.paginationLoading = false;
            $scope.loadingMain = false;
            if($rootScope.selectedT == 1){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 2){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            else if($rootScope.selectedT == 3){
              $scope.inventory = data.data;
              $scope.invFilter = data.data;
              $scope.invinfo = data;
            }
            if($scope.auth.upermissions.dp){
              if($scope.isAdvSearch){
                $scope.setInvRange($scope.invinfo, $scope.currentPage);
              } else {
                $scope.setInvRange($scope.invinfo, null);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.searchInvText.text = "";
      $scope.info = args.invInfo;
      $scope.isAdvSearch = true;
      // console.warn("args",args);
      $scope.inventory = args.inventory;
      $scope.invFilter = args.inventory;
      // $scope.searchFilterInv = args.inventory;
      if(args.invInfo){
        $scope.invinfo = args.invInfo;
        if($scope.auth.upermissions.dp && $scope.invinfo.code != 7003){
          $scope.resetPagination();
          $scope.setInvRange($scope.invinfo, $scope.currentPage);
        }
      }
      $scope.currentPage = 1;
      $rootScope.offset = 0;
      localStorage.setItem("invPageStatus", JSON.stringify({curPage:$scope.currentPage, offset:$rootScope.offset}));
      $scope.advSearchInfo = args.info;
      $scope.advObj = args.advObj;
      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.isAdvSearch = false;
        $scope.pageList = {};
        $scope.loadSelectedTab();
      }
    });

    /*Advanced Search*/
    $scope.advancedSearchOpen = function(caller, step){
      $scope.searchInvText.text = "";
      $scope.searchInv('');
      if($rootScope.selectedT == 1){
        $scope.tabCaller = 0;
      }
      else if($rootScope.selectedT == 2){
        $scope.tabCaller = 1;
      }
      else if($rootScope.selectedT == 3){
        $scope.tabCaller = 2;
      }
      InventorySrv.getInvAdvanceSearched(step).then(
        function(data){
          $scope.getSearchList = data;
          if(step == "d"){
            $scope.advSearchObj = {caller:caller, step:step,status:$scope.tabCaller, userList:$scope.getSearchList.userList};
            $scope.dialogW = 596;
          } else{
            $scope.advSearchObj = {caller:caller, step:step,status:$scope.tabCaller ,type:$scope.getSearchList.oTypes ,userList:$scope.getSearchList.userList};
            $scope.dialogW = 1024;
          }
          ngDialog.open({
            template:"app/common/popup/advancedSearch.html",
            width:$scope.dialogW,
            scope:$scope,
            data:$scope.advSearchObj,
            closeByEscape:false,
            closeByDocument:false,
            controller:"AdvancedSearchController"
          });
        },
        function(err){
          $log.error(err);
        }
      );
      // console.warn("OPENSEARCH",$scope.advSearchObj);

      // console.error($scope.advSearchObj)

    }

    $scope.sortTypeInv = function(caller){
      $scope.sortedlist = angular.copy($scope.inventory);
      if(caller === "tlabel"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.tlabel.localeCompare(b.tlabel);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.tlabel.localeCompare(a.tlabel);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "name"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.name.localeCompare(b.name);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.name.localeCompare(a.name);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "mac"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.mac.localeCompare(b.mac);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.mac.localeCompare(a.mac);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "model"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.model.localeCompare(b.model);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.model.localeCompare(a.model);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "mf"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.mf.localeCompare(b.mf);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.mf.localeCompare(a.mf);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "serial"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.serial.localeCompare(b.serial);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.serial.localeCompare(a.serial);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "l"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return a.l.localeCompare(b.l);
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b){
            return b.l.localeCompare(a.l);
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "crOn"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return a.crOn - b.crOn;
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return b.crOn - a.crOn;
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "iOn"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return a.iOn - b.iOn;
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return b.iOn - a.iOn;
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "rOn"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return a.rOn - b.rOn;
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            return b.rOn - a.rOn;
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "w"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return a.rw - b.rw;
            if (a.w === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.w === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return a.w - b.w; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return b.rw - a.rw;
            if (a.w === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.w === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return b.w - a.w; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "ew"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return a.ew - b.ew;
            if (a.ew === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.ew === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return a.ew - b.ew; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return b.ew - a.ew;
            if (a.ew === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.ew === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return b.ew - a.ew; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
      } else if(caller == "rw"){
        if($scope.inventorySort.value == "asc"){
          $scope.isSort = true;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return a.rw - b.rw;
            if (a.rw === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.rw === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return a.rw - b.rw; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"desc"};
        } else if($scope.inventorySort.value == "desc"){
          $scope.isSort = false;
          $scope.inventory = $scope.sortedlist.sort(function(a, b) {
            // return b.rw - a.rw;
            if (a.rw === null) {
              return 1; // treat null as greater than any non-null value
            } else if (b.rw === null) {
              return -1; // treat null as less than any non-null value
            } else {
              return b.rw - a.rw; // compare non-null values normally
            }
          });
          $scope.inventorySort = {type:caller,value:"asc"};
        }
        // console.warn("LIST",$scope.inventory);
      }

        // else if(sortVal === "desc"){
        //   targetList = targetList.sort(function(a, b){
        //     return b.label.localeCompare(a.label);
        //   });
        //   if(targetList2){
        //     targetList2 = targetList2.sort(function(a, b){
        //       return b.label.localeCompare(a.label);
        //     });
        //   }
        // }
      // }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SupportController', SupportController);

  /** @ngInject */
  function SupportController($log, $rootScope, $scope, $state, $sce, ngDialog, $window, FileModelUploadSrv, SupportSrv){
    $scope.bugs = {subject:"", description:"", d:[], img:""};//uid:$scope.auth.uid,
    $scope.mail = {subject:"", message:""};//uid:$scope.auth.uid,
    $scope.feedback = {feedback:""};//uid:$scope.auth.uid,
    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.saveProcessing = false;
    $scope.bugsProcessing = false;
    $rootScope.curTabFr = false;
    $scope.hasErr = false;
    $scope.licenseKey = "";
    $scope.videoObj = {};
    $scope.support = {};
    $scope.errType = "";

    $scope.loadSelectedTab = function(){
      $scope.supportLoading = true;
      $scope.support = {};
      if($scope.selectedTab === "hub.support.s"){
        $scope.timestamp = moment().format('x');
        SupportSrv.getFeedback().then(
          function(data){
            $scope.support = data;
            $scope.supportLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.support.ts"){
        $scope.timestamp = moment().format('x');
        SupportSrv.getURL().then(
          function(data){
            $scope.support = data;
            $scope.licenseKey = data.key;
          },
          function(err){
            $log.error(err);
          }
        );
        $scope.docsLoading = true;
        SupportSrv.getDocuments().then(
          function(data){
            $scope.docsLoading = false;
            $scope.documentList = data.list;
          },
          function(err){
            $scope.docsLoading = false;
            $log.error(err);
          }
        );
        $scope.appsLoading = true;
        $scope.isPublisherExists = false;
        SupportSrv.getDownloads().then(
          function(data){
            $scope.appsLoading = false;
            if(data.fps){
              $scope.fps = data.fps;
            }
            $scope.downloadList = data.list;
            angular.forEach($scope.downloadList, function(item){
              if(item.hubAppType.id == 2){
                item.type = 'windows';
              } else if(item.hubAppType.id == 4){
                item.type = 'webos';
              } else if(item.hubAppType.id == 5){
                item.type = 'tizen';
              } else if(item.hubAppType.id == 11){
                item.type = 'android';
              } else if(item.hubAppType.id == 12){
                item.type = 'playstore';
              } else if(item.hubAppType.id == 14){
                item.type = 'pwa';
              } else if(item.hubAppType.id == 13){
                item.type = 'raspberry';
              } else if(item.hubAppType.id == 7){
                item.type = 'publisher';
              } else if(item.hubAppType.id == 15){
                item.type = 'brightSign';
              }
              if(item.isPublisher){
                $scope.isPublisherExists = true;
                return;
              }
            });
          },
          function(err){
            $scope.appsLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.support.rb.oi"){
        SupportSrv.getBugs().then(
          function(data){
            $scope.support = data;
            $scope.supportLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.support.kb"){
        SupportSrv.getVidKb().then(
          function(data){
            $scope.vidKb = data;
            $scope.supportLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.supportLoading = false;
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.portSettingOpen = function(){
      ngDialog.open({
        template:"app/support/popup/portSettings.html",
        scope:$scope,
        closeByDocument:false,
        width:500
      });
    }
    $scope.unblockOpen = function(){
      ngDialog.open({
        template:'\
        <section class="panel" role="dialog">\
          <header class="panel-heading"><h1 role="heading" aria-level="1">{{"sc.ts.body.5" | translate}}</h1></header>\
          <div class="panel-body"><div class="marB20">{{"sc.ts.body.4" | translate}}</div><img alt="" src="assets/images/unblock.jpg" alt="Unblock"></div>\
          <footer class="panel-footer">\
            <span class="btnQuad">\
              <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </span>\
          </footer>\
        </section>',
        plain:true,
        width:646,
        closeByDocument:false,
      });
    }

    $scope.publisherOpen = function(){
      ngDialog.open({
        template:'\
        <section class="panel" role="dialog">\
          <header class="panel-heading"><h1 role="heading" aria-level="1">{{"sc.ts.btn.10.7" | translate}}</h1></header>\
          <div class="panel-body text-center">\
            <div class="marB10">\
              <div class="marB5">{{"sc.ts.body.6" | translate}}</div>\
              <div class="form-group marB10">\
                <div class="input-group input-group-sm">\
                  <input type="text" class="form-control picker" value="{{licenseKey}}" readonly="" aria-label="{{\'sc.ts.body.6\' | translate}}" aria-labelledby="{{\'sc.ts.body.6\' | translate}}">\
                  <div class="input-group-btn"><button type="button" role="button" class="btn btn-default" ngclipboard data-clipboard-text="{{licenseKey}}" uib-tooltip="{{\'cl.p_m.5\' | translate}}" tooltip-append-to-body="true"><span class="fa fa-files-o text-primary" aria-hidden="true"></span></button></div>\
                </div>\
              </div>\
            </div>\
          <div><a href="{{support.url}}{{support.bucket}}/support/downloads/app/LSquaredPublisher.zip?{{timestamp}}" role="link" class="btn btn-link text-lg" target="_blank" download><span class="fa fa-download" aria-hidden="true"></span> {{"cm.btn.17" | translate}}</a></div></div>\
          <footer class="panel-footer">\
            <span class="btnQuad">\
              <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </span>\
          </footer>\
        </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        trapFocus:false
      });
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
    });

    /*For Mail to Support*/
    $scope.mailSupportOpen = function(){
      $scope.mail = {subject:"", message:""};//uid:$scope.auth.uid,
      $scope.savePopProcessing = false;
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      ngDialog.open({
        template:"app/support/popup/mailToSupport.html",
        closeByDocument:false,
        scope:$scope,
        width:500
      });
    }
    $scope.saveMailSupportFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      if(!$scope.mail.subject || $scope.mail.subject == ""){
        $scope.errPopType = "subject";
        $scope.hasPopErr = true;
        $("#subject").focus();
      } else if(!$scope.mail.message || $scope.mail.message == ""){
        $scope.errPopType = "message";
        $scope.hasPopErr = true;
        $("#message").focus();
      } else{
        $scope.savePopProcessing = true;
        SupportSrv.saveMailSupport($scope.mail).then(
          function(data){
            $scope.mail = {subject:"", message:""};//uid:$scope.auth.uid,
            $scope.savePopProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.mail = {subject:"", message:""};//uid:$scope.auth.uid,
            $scope.savePopProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.videoFx = function(vidId, vidLabel){
      $scope.videoObj = {};
      $scope.videoObj.label = vidLabel;
      $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + vidId + $scope.videoParam);
      ngDialog.open({
        template:'app/support/popup/video.html',
        width:820,
        data:$scope.videoObj,
        scope:$scope
      });
    }
    /*For Feedback*/
    $scope.saveFeedbackFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;

      if($scope.feedback.feedback == ""){
        $scope.saveProcessing = false;
        $scope.hasErr = true;
        $("#feedback").focus();
      } else{
        SupportSrv.saveFeedback($scope.feedback).then(
          function(data){
            $scope.feedback = {feedback:""};//uid:$scope.auth.uid,
            $scope.saveProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.feedback = {feedback:""};//uid:$scope.auth.uid,
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    /*For bugs*/
    $scope.saveBugsFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.bugs.subject == ""){
        $scope.hasErr = true;
        $scope.errType = "title";
        $("#subject").focus();
      } else if(!$scope.bugs.description || $scope.bugs.description == ""){
        $scope.hasErr = true;
        $scope.errType = "des";
        $("#description").focus();
      } else{
        $scope.bugsProcessing = true;
        FileModelUploadSrv.uploadFileAndData("support/bugs", {subject:$scope.bugs.subject, description:$scope.bugs.description, d:$scope.bugs.d}, $scope.bugs.img).then(//uid:$scope.bugs.uid,
          function(data){
            $scope.bugs = {subject:"", description:"", d:[], img:""};//uid:$scope.auth.uid,
            $rootScope.toastNotificationFx("info", data);
            $scope.bugsProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.bugs = {subject:"", description:"", d:[], img:""};//uid:$scope.auth.uid,
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.bugsProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.downloadApk = function(url, type){
      if(type == 'publisher'){
        $scope.publisherOpen();
      } else if(type == 'pwa' || type == 'playstore'){
        if(type == 'pwa'){
          $window.open(url +'?'+ $scope.timestamp, '_blank');
        } else{
          $window.open(url +'&'+ $scope.timestamp, '_blank');
        }
      } else{
        $window.location.href = url +'?'+ $scope.timestamp;
      }
    }
  }
})();

angular.module('hub').service('ReportsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getUrl = function(obj){
    httpReq = $http.get($rootScope.apiHost + "reports/getUrl");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsPP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/proofOfPlay", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsDS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/deviceStatus", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsCS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/cs", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsOP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/op", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsOD = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/od", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsCC = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/cc", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsPOD = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/ofd", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsIR = function(){
    httpReq = $http.post($rootScope.apiHost + "reports/ir");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsHG = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/temperature", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsDST = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/dst", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsPOH = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/poh", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStethReports = function(caller, obj){
    httpReq = $http.post($rootScope.apiHost + "hdstethreports/"+caller, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStethReportsPP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "hdstethreports/proofOfPlay", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReportsHK = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/hk", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get CSV*/
  this.getCSVReportsPP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/pp/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSVReportsDS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/ds/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSVReportsCS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/cs/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSVReportsHG = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/hg/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSVReportsDST = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/dst/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSVReportsPOH = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/poh/csv", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get XLS*/
  this.getXLSXReportsPP = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/pp/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsDS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/ds/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsCS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/cs/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsHG = function(obj){
    if(obj.info.dType=="d"){
      httpReq = $http.post($rootScope.apiHost + "reports/dh", obj);
    } else{
      httpReq = $http.post($rootScope.apiHost + "reports/dt/xlsx", obj);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsBL = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/bl", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsDST = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/dst/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsPOH = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/poh/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get eMail*/
  this.getMailXLSXReportsPP = function(obj, email){
    httpReq = $http.post($rootScope.apiHost + "reports/pp/xlsx/"+ email, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMailXLSXReportsDS = function(obj, email){
    httpReq = $http.post($rootScope.apiHost + "reports/ds/xlsx/"+ email, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMailXLSXReportsCS = function(obj, email){
    httpReq = $http.post($rootScope.apiHost + "reports/cs/xlsx/"+ email, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMailXLSXReportsHG = function(obj, email){
    httpReq = $http.post($rootScope.apiHost + "reports/hg/xlsx/"+ email, obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAdapters = function(id){
    httpReq = $http.get($rootScope.apiHost + "reports/downloadAdapters/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSubscribe = function(){
    httpReq = $http.get($rootScope.apiHost + "reports/subscribe");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.subscribe = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/subscribe", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.unsubscribe = function(id){
    httpReq = $http.delete($rootScope.apiHost + "reports/unsubscribe/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getXLSXReportsCI = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/ci", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getReporthistory = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/reporthistory", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTaskstatus = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/taskstatus", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.reportsAction = function(obj){
    httpReq = $http.post($rootScope.apiHost + "reports/action", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    if(response.data == 18002){
      $rootScope.toastNotificationFx("danger", response.data);
    } if(response.data.code == 18001){
      $rootScope.toastNotificationFx("info", response.data, response.data.email);
    } else{
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ReportsController', ReportsController);

  /** @ngInject */
  function ReportsController($log, $rootScope, $scope, $state, $cookies, $filter, $timeout, $interval, ngDialog, DevicesSrv, ReportsSrv, CommonSrv, FileModelUploadSrv){
    $rootScope.selectedMenu = 8;
    $rootScope.reportSelectedItems = {info:{}, devices:[], content:[]};
    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.devices = {devices:"", info:{}};
    $scope.deviceListLoading = false;
    $scope.dASAllCheck = {box:false};
    $scope.searchTextR = {text:""};
    $rootScope.search = {pText:"", text:""};
    $rootScope.selectedItems = [];
    $scope.sendProcessing = false;
    $scope.searchFromRoot = true;
    $scope.chartLoading = false;
    $scope.csChartShow = false;
    $scope.advSearchInfo = {};
    $scope.chartShow = false;
    $scope.reportArr = [];
    $scope.filter = "all";
    $scope.bucket = "";
    $scope.decId = "";
    $scope.flId = "";
    $scope.tim = "";
    $scope.curInfo = {};
    $scope.folderList = [];
    $scope.thumbSize = 'n'
    $scope.dOffset = 0;
    $scope.isAPISearch = {enable:false};
    $rootScope.clearSearch = false;
    $rootScope.importXls = {file:""};
    $scope.advSearchInfo = {};

    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.selPaginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.getAllData = {search:false,advSearch:false,filter:false,list:false};
    $scope.copyDevices = {devices:[],folders:[]};
    $scope.stored = {devices:[], folders:[]};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.statusObj = {d:false,s:false,as:false,f:false};

    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.isAdvSearchMsg = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.advSApply = false;
    $scope.filterIsAppliedAlready = false;
    $scope.rdc = 0;
    $rootScope.addStatusKeyVal = {value: true};
    $scope.isPageApiLoad = false;
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $rootScope.commonSearchVar = "";
    $rootScope.copySelDevice = [];
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));

    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getTotalDeviceCountFx();

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(316);
      $scope.selectedHeight = $scope.getAvailableHeight(316);
    } else{
      $scope.selectedHeight = Math.round($scope.getAvailableHeight(425) * 0.4);
      $scope.quadHeight = Math.round($scope.getAvailableHeight(425) * 0.6);
    }

    hs.downloadDropdownPP = function(){
      $(".ContantropdownPP").toggle();
    }

    // Close the dropdown if the user clicks outside of it
    window.onclick = function(event){
      if(!event.target.matches('.dropbtnPP')){
        var dropdowns = document.getElementsByClassName("dropdown-contentPP");
        var i;
        for (i = 0; i < dropdowns.length; i++){
          var openDropdown = dropdowns[i];
          openDropdown.style.display = "none";
        }
      }
    }
    hs.downloadCSV = function(){
      $scope.indexPP = localStorage.getItem("indexPP");
      $scope.selectedId = localStorage.getItem("selectedId");
      $scope.reportArrPpCopy = angular.copy($scope.reportArr[$scope.indexPP].info);
      $scope.reportArrPpCopy.info.dateRange = {
        startDate:moment($scope.reportArr[$scope.indexPP].info.info.dateRange.startDate).format("L"),
        endDate:moment($scope.reportArr[$scope.indexPP].info.info.dateRange.endDate).format("L")
      };
      $scope.reportArrPpCopy.info.sTime = moment($scope.report.info.sTime).format("HH:mm Z");
      $scope.reportArrPpCopy.info.eTime = moment($scope.report.info.eTime).format("HH:mm Z");
      if($rootScope.reportSelectedItems.devices.length == 0){
        $scope.report.devices = $scope.devices.devices;
        $scope.reportArrPpCopy.info.deviceEmpty = true;
      } else{
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.reportArrPpCopy.info.deviceEmpty = false;
      }
      if($rootScope.reportSelectedItems.content.length == 0){
        $scope.reportArrPpCopy.info.contentEmpty = true;
      } else{
        $scope.reportArrPpCopy.info.contentEmpty = false;
      }
      $scope.reportArrPpCopy.info.selectedPoint = localStorage.getItem("selectedPoint");
      $scope.reportArrPpCopy.selectedId = localStorage.getItem("selectedId");
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      ReportsSrv.getCSVReportsPP($scope.reportArrPpCopy).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }
    hs.downloadXLSX = function(){
      $scope.indexPP = localStorage.getItem("indexPP");
      $scope.selectedId = localStorage.getItem("selectedId");
      $scope.reportArrPpCopy = angular.copy($scope.reportArr[$scope.indexPP].info);
      $scope.reportArrPpCopy.info.dateRange = {
        startDate:moment($scope.reportArr[$scope.indexPP].info.info.dateRange.startDate).format("L"),
        endDate:moment($scope.reportArr[$scope.indexPP].info.info.dateRange.endDate).format("L")
      };
      $scope.reportArrPpCopy.info.sTime = moment($scope.report.info.sTime).format("HH:mm Z");
      $scope.reportArrPpCopy.info.eTime = moment($scope.report.info.eTime).format("HH:mm Z");
      if($rootScope.reportSelectedItems.devices.length == 0){
        $scope.report.devices = $scope.devices.devices;
        $scope.reportArrPpCopy.info.deviceEmpty = true;
      } else{
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.reportArrPpCopy.info.deviceEmpty = false;
      }
      if($rootScope.reportSelectedItems.content.length == 0){
        $scope.reportArrPpCopy.info.contentEmpty = true;
      } else{
        $scope.reportArrPpCopy.info.contentEmpty = false;
      }
      $scope.reportArrPpCopy.info.selectedPoint = localStorage.getItem("selectedPoint");
      $scope.reportArrPpCopy.selectedId = localStorage.getItem("selectedId");
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      ReportsSrv.getXLSXReportsPP($scope.reportArrPpCopy).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.reportActionOpen = function(caller, id){
      $scope.confirmProcessing = false;
      $scope.dataObj = {action:caller, tid:id};
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dataObj.action == \'d\'">{{\'r.msg.15\' | translate}}</span>\
              <span ng-if="dataObj.action == \'c\'">{{\'r.msg.16\' | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="confirmActionFx(dataObj.action);" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin fa-fw" ng-if="confirmProcessing" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.confirmActionFx = function(caller){
      if(caller == 'd'){
        ReportsSrv.reportsAction($scope.dataObj).then(
          function(data){
            if(data.code == 108){
              angular.forEach($scope.reportHistory, function(obj, index){
                if(obj.id == $scope.dataObj.tid){
                  $scope.reportHistory.splice(index, 1);
                  return;
                }
              });
              ngDialog.close();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
      if(caller == 'c'){
        ReportsSrv.reportsAction($scope.dataObj).then(
          function(data){
            if(data.code == 107){
              angular.forEach($scope.processingTaskIds, function(val, index){
                if(val == $scope.dataObj.tid){
                  $scope.processingTaskIds.splice(index, 1);
                }
              })
              angular.forEach($scope.inProcessTaskList, function(obj, index){
                if(obj.id == $scope.dataObj.tid){
                  $scope.inProcessTaskList.splice(index, 1);
                  return;
                }
              });
              ngDialog.close();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.getTaskStatusFx = function(obj){
      ReportsSrv.getTaskstatus({tids:$scope.processingTaskIds}).then(
        function(data){
          $scope.statusLoading = false;
          $scope.inProcessTaskList = data;
        },
        function(err){
          $log.error(err);
        }
      );
      $rootScope.isStatusInterval = $interval(function(){
        if($scope.processingTaskIds.length){
          ReportsSrv.getTaskstatus({tids:$scope.processingTaskIds}).then(
            function(data){
              $scope.inProcessTaskList = data;
              var isAllSucess = $scope.inProcessTaskList.every(function(item){return item.s === 'success'});
              var isAllFail = $scope.inProcessTaskList.every(function(item){return item.s === 'fail'});
              if(!data.length || isAllSucess || isAllFail){
                $interval.cancel($rootScope.isStatusInterval);
              }
            },
            function(err){
              $scope.detailloadingDetail = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }else{
          $interval.cancel($rootScope.isStatusInterval);
        }
      }, 5000);
    }

    $scope.loadSubTab = function(caller){
      if($scope.auth.upermissions.drg == 'v2'){
        $scope.reportHistory = [];
        $scope.notMatchDateRange = false;
        if(caller == 'hg'){
          caller = 'dh';
        }
        if(caller != 'ir' && caller != 'hk' && caller != 'ci'){
          $scope.historyLoading = true;
          $scope.statusLoading = false;
          $scope.processingTaskIds = [];
          $scope.reportHistory = [];
          $scope.inProcessTaskList = [];
          $scope.historyObj = {'caller': caller}
          if($rootScope.isStatusInterval){
            $interval.cancel($rootScope.isStatusInterval);
          }
          ReportsSrv.getReporthistory($scope.historyObj).then(
            function(data){
              $scope.processingTaskIds = data.tids;
              $scope.reportHistory = data.h;
              // $scope.reportHistory = [
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx", id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx", id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx", id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx", id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx" },
              //   {dr: {st:1724136178, et:1724136178}, gOn: 1724136178, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx", id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"}
              // ]
              $scope.copyReportHistory = angular.copy($scope.reportHistory);
              if($scope.processingTaskIds.length){
                $scope.statusLoading = true;
                $scope.getTaskStatusFx({tids:$scope.processingTaskIds})
              }
              $scope.historyLoading = false;
              // if(caller == 'ds' || caller == 'dh' || caller == 'dt' || caller == 'op'){
              //   $scope.checkHaveReportFx($scope.report.info.dateRange)
              // }
            },
            function(err){
              $log.error(err);
            }
          );
        }

        // $scope.inProcessTaskList = [
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": null,"p": "0","s": "fet" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": null,"p": "0","s": "pen" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": 1000,"p": "0","s": "pro" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": 1000,"p": "45.23","s": "pro" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": null,"p": "0","s": "fail" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": 1000,"p": "80.11","s": "pro" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx","s": "success","c": 12108,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": null,"p": "0","s": "pen" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": 1000,"p": "20.88","s": "pro" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx","s": "success","c": 12108,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": 1000,"p": "60.55","s": "pro" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "tdc": 1200,"pdc": null,"p": "0","s": "fail" ,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"},
        //   {dr: {st:1724136178, et:1724136178}, "url": "https://lldev.lsquared.com/lldev-lsquared-hub/storage/logs/08-08-2024-06-49-B00000m-50k-offline-devices.xlsx","s": "success","c": 12108,id:"a7d4d71e-a4a8-4614-818b-5d532bd0cc5"}
        // ]
      }
    }
    if($scope.auth.upermissions.drg == 'v2' && ($scope.selectedTab == "hub.reports.d.ds" || $scope.selectedTab == "hub.reports.d.hg" || $scope.selectedTab == "hub.reports.d.od" || $scope.selectedTab == "hub.reports.d.op" || $scope.selectedTab == "hub.reports.d.ir" || $scope.selectedTab == "hub.reports.d.dst" || $scope.selectedTab == "hub.reports.d.poh" || $scope.selectedTab == "hub.reports.d.hk" || $scope.selectedTab == "hub.reports.d.ci")){
      $scope.loadSubTab($scope.selectedTab.split('.')[3]);
    }

    $scope.dateFormateConverter = function(val){
      return moment(val).format("MM/DD/YYYY")
        // return moment(val, "MMM D, YYYY").format("L")
    }
    $scope.notMatchDateRange = false;
    $scope.checkHaveReportFx = function(date){
      if($scope.auth.upermissions.drg == 'v2'){
        $scope.notMatchDateRange = false;
        angular.element('.table .reportHS').removeClass('report-highlight');
        $scope.stDate = moment(date.startDate).format("L");
        $scope.etDate = moment(date.endDate).format("L");
        angular.forEach($scope.copyReportHistory,function(obj){
          var startDate = $scope.dateFormateConverter(obj.dr.st * 1000);
          var endDate = $scope.dateFormateConverter(obj.dr.et * 1000);
          if($scope.stDate == startDate && $scope.etDate == endDate){
            // Or if you want to keep `dr` matched item on top:
            $scope.notMatchDateRange = true;
            $scope.reportHistory = $filter('orderBy')($scope.reportHistory, function(item) {
              return item.dr.st == obj.dr.st && item.dr.et == obj.dr.et ? -1 : 1;
            });
            angular.forEach(angular.element('.table .reportHS'), function(itemAttr){
              if($(itemAttr).attr('data-id') == obj.id){
                $(itemAttr).addClass('report-highlight');
              }
            });
          }
        });
      }
    }

    $scope.loadReportSubTab = function(type){
      $scope.getDeviceStatus("r");
      if(type == "c"){
        if($scope.auth.upermissions.rcc){
          $state.go("hub.reports.c.cc");
        } else if($scope.auth.upermissions.rcs){
          $state.go("hub.reports.c.cs");
        } else if($scope.auth.upermissions.rpp){
          $state.go("hub.reports.c.pp");
        }
      } else if(type == "d"){
        $scope.defaultSDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        if($scope.auth.upermissions.rds){
          $scope.loadSubTab('ds');
          $state.go("hub.reports.d.ds");
        } else if($scope.auth.upermissions.rhg){
          $scope.loadSubTab('dh');
          $state.go("hub.reports.d.hg");
        } else if($scope.auth.upermissions.rod){
          $scope.loadSubTab('od');
          $state.go("hub.reports.d.od");
        } else if($scope.auth.upermissions.rop){
          $scope.loadSubTab('op');
          $state.go("hub.reports.d.op");
        } else if($scope.auth.upermissions.ir){
          $scope.loadSubTab('ir');
          $state.go("hub.reports.d.ir");
        } else if($scope.auth.upermissions.rdst){
          $scope.loadSubTab('dst');
          $state.go("hub.reports.d.dst");
        } else if($scope.auth.upermissions.rpoh){
          $scope.loadSubTab('poh');
          $state.go("hub.reports.d.poh");
        } else if($scope.auth.upermissions.rhk){
          $scope.loadSubTab('hk');
          $state.go("hub.reports.d.hk");
        } else if($scope.auth.upermissions.ci){
          $scope.loadSubTab('ci');
          $state.go("hub.reports.d.ci");
        }
      } else if(type == "hds"){
        $scope.defaultSDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $state.go("hub.reports.hds.ac");
      }
    }
    $scope.maxDate = moment().format('YYYY-MM-DD');


    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceStatus = function(caller){
      setTimeout(function(){
        if($scope.pageDeviceArr.length && caller != "r"){
          var currentTime = new Date().getTime();
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          angular.forEach($scope.pageDeviceArr, function(obj){
            if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
              obj.tz = currentTime;
              DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                function(data){
                  angular.forEach($scope.devices.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  });
                  if($rootScope.reportSelectedItems.devices.length){
                    angular.forEach($rootScope.reportSelectedItems.devices, function(dData){
                      angular.forEach(Object.keys(data),function(key){
                        var value = data[key];
                        if(key == dData.id){
                          dData.lp = value;
                        }
                      })
                    })
                  }
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          })
        } else if(caller == "r"){
          $scope.currentPageDevice = $rootScope.reportSelectedItems.devices;
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          if($scope.commaSeparatedIds != ""){
            DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
              function(data){
                angular.forEach($scope.devices.devices, function(dData){
                  angular.forEach(Object.keys(data),function(key){
                    var value = data[key];
                    if(key == dData.id){
                      dData.lp = value;
                    }
                  })
                });
                if($rootScope.reportSelectedItems.devices.length){
                  angular.forEach($rootScope.reportSelectedItems.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  })
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
      },100)
      $scope.updateSelectedDevice();
    }

    $scope.subTabChangeFx = function(){
      setTimeout(function(){
        $scope.currentPageDevice = $rootScope.reportSelectedItems.devices;
        $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
        if($scope.commaSeparatedIds != ""){
          $scope.deviceUpdating = true;
          DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
            function(data){
              angular.forEach($scope.devices.devices, function(dData){
                angular.forEach(Object.keys(data),function(key){
                  var value = data[key];
                  if(key == dData.id){
                    dData.lp = value;
                  }
                })
              });
              if($rootScope.reportSelectedItems.devices.length){
                angular.forEach($rootScope.reportSelectedItems.devices, function(dData){
                  angular.forEach(Object.keys(data),function(key){
                    var value = data[key];
                    if(key == dData.id){
                      dData.lp = value;
                    }
                  })
                })
              }
              $scope.deviceUpdating = false;
            },
            function(err){
              $log.error(err);
              $scope.deviceUpdating = false;
            }
          );
        }
      },100)
      $scope.updateSelectedDevice();
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($rootScope.reportSelectedItems.devices, function(data){
          if(data.id == obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.tv = obj.tv;
            }
            data.lp = obj.lp;
          }
        })
        outerLoopCounter++;
        if (outerLoopCounter === totalOuterLoops) {
          $scope.temSelectedArr = angular.copy($rootScope.reportSelectedItems.devices);
          $rootScope.reportSelectedItems.devices = [];
          $rootScope.reportSelectedItems.devices = $scope.temSelectedArr;
        }
      })
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        var caller = "r";
        if($scope.selectedTab == "hub.reports.hds.pp"){
          caller = "hdsr"
        }
        $scope.dReqObj = {caller:caller,type:null,offset:$rootScope.offset,filter:$scope.filter,fId:($scope.curFolderId>0)?$scope.curFolderId:0,text:$scope.searchTextR.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};

        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextR.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = true;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    };

    $scope.selPageChangeHandler = function(){
      $('#pagingCtrlClone li').removeClass('active');
    };

    $scope.resetSelPagination = function(){
      var searchData = angular.copy($filter("customSearch")($rootScope.reportSelectedItems.devices, {key:$scope.selectedSearch.text, module:'dSelOp'}));
      if(searchData.length>$scope.auth.upreferences.dpc || (searchData.length==0 && $rootScope.reportSelectedItems.devices.length)){
        resetSelPageFx(1);
      }
    }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore, action){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }
      DevicesSrv.getDevice(dReqObj).then(
        function(data){
          if(!$rootScope.addStatusKeyVal.value){
            $scope.deviceListLoading = false;
          }
          $scope.firstDeviceLoading = false;
          $scope.isPageApiLoad = false;
          $scope.moreDeviceLoading = false;
          $scope.devicesLoading = false;
          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);

          // $scope.tim = data.info.timthumb;
          // $scope.bucket = $scope.dDetailBucket = data.info.bucket;
          // if(data.info.mbucket && data.info.mbucket != ""){
          //   $scope.dDetailBucket = data.info.mbucket;
          // }

          $scope.tim = data.info.timthumb;
          $scope.bucket = $scope.dBucket = $scope.dDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.detailBucket = $scope.dDetailBucket = data.info.mbucket;
          }
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }

          // get device of types
          if(caller=='openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller=='dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else {
              $scope.dData = angular.copy(data);
            }

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.filter = "all";
            } else{
              $scope.filter = $scope.filterType;
            }

            $scope.devices = angular.copy($scope.dData);
            $scope.folderList = $scope.devices.folders;
            $scope.loadingMain = false;

            $scope.devicesCopy = angular.copy(data);
            $scope.devicesLength = data.devices.length;
          }

          $scope.updateList();
          $scope.setCountFx();
          //for fix #9
          if(action && action != "changeView"){
            $scope.updateSelectedDevice();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.deviceListLoading = true;
      $scope.searchTextR.text = "";
      $scope.searchText = "";
      $scope.search.text = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      //Adv search implemented
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextR.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else {
        $scope.advSApply = false;
        $scope.deviceListLoading = true;
        var caller = "r";
        if($scope.selectedTab == "hub.reports.hds.pp"){
          caller = "hdsr"
        }
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:caller,type:null,offset:0,filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextR.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.deviceListLoading = true;
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
        // $scope.firstApply.filter = true;
      } else{
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.deviceListLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextR.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.searchTextR.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        var caller = "r";
        if($scope.selectedTab == "hub.reports.hds.pp"){
          caller = "hdsr"
        }
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:caller,type:null,offset:0,filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextR.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    // $scope.setCountFx = function(caller){
    //   // $scope.deviceListLoading = false;
    //   $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
    //   if(caller=='last'){
    //     $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
    //   } else{
    //       $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
    //   }


    //   // if($scope.filter && $scope.filter != "all" && !$scope.devices.devices.length && $scope.dData.devices.length){
    //   if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isFilterMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     // if($scope.filter && $scope.filter != "all" && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //     if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isFilterMsg = true;
    //     }else{
    //       $scope.isFilterMsg = false;
    //     }
    //   }
    //   if($scope.searchTextR.text && $scope.searchTextR.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isSearchMsg = true;
    //     $scope.isFilterMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     if($scope.searchTextR.text && $scope.searchTextR.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isSearchMsg = true;
    //     } else{
    //       $scope.isSearchMsg = false;
    //     }
    //   }

    //   if(!$scope.searchTextR.text && $scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
    //     $scope.isAdvSearchMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isFilterMsg = false;
    //   } else {
    //     if($scope.searchTextR.text && $scope.searchTextR.text.length && $scope.dData.advObj && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //       $scope.isSearchMsg = true;
    //       $scope.isAdvSearchMsg = false;
    //       $scope.isFilterMsg = false;
    //     } else {
    //       $scope.isAdvSearchMsg = false;
    //     }
    //   }
    // }
    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller=='last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
      } else{
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
      }

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
      // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchTextR.text && $scope.searchTextR.text.length && !$scope.devices.devices.length){
      // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
      // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.searchTextR.text && $scope.searchTextR.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchTextR.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }

    $scope.getDevicesFx = function(action){
      $scope.deviceListLoading = true;
      $rootScope.addStatusKeyVal.value = true;
      var caller = "r";
      if($scope.selectedTab == "hub.reports.hds.pp"){
        caller = "hdsr"
      }
      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      $scope.dReqObj = {caller:caller,type:null,offset:0,filter:$scope.filter,fId:($scope.curFolderId>0)?$scope.curFolderId:0,text:$scope.searchTextR.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
      $scope.getDeviceAndProcessFx($scope.dReqObj, 'dList', false, action);
    }
    // $scope.getDevicesFx();

    $scope.openTypeFx = function(type, page, caller){
      $scope.searchFromRoot = false;
      $scope.deviceListLoading = true;
      $rootScope.selectedItems = [];
      $rootScope.commonSearchVar = "";
      $scope.searchText = "";
      $scope.search.text = "";
      $scope.curType = type;
      localStorage.setItem('curDType', JSON.stringify(type));
      $scope.devices = {};
      $scope.breadCrumbs = [type];
      $scope.deviceTypes = {};
      if(!caller){
        localStorage.setItem("filterType", JSON.stringify("all"));
      }
      $scope.dReqObj = {caller:"gbdt",type:type,offset:$rootScope.offset};
      DevicesSrv.getDevice($scope.dReqObj).then(
        function(data){
          $scope.deviceListLoading = false;
          if(data.code == 12064){
            $scope.auth.upermissions.gbdt = false;
            localStorage.setItem('auth', JSON.stringify($scope.auth));
            $scope.getDevicesFx();
          } else{
            $scope.isGbdt = false;
            $scope.devices = data;
            $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.devices);
            if($scope.devices.info){
              $scope.tim = $scope.devices.info.timthumb;
              $scope.bucket = $scope.dBucket = $scope.dDetailBucket = $scope.devices.info.bucket;
              if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
                $scope.detailBucket = $scope.dDetailBucket = $scope.devices.info.mbucket;
              }
            }
            $scope.devicesLength = $scope.devices.info.count;
            $scope.updateList();
          }
          $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.fCount = ($scope.devices.devices.length > 0 ? $scope.devices.devices : null);
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // var searchTimeout;
    $scope.searchChangeFx = function(caller, text){
      $rootScope.commonSearchVar = text;
      if(!text){
        $scope.clearSearchFx();
        return;
      } else {
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        if($rootScope.selectedT == 1 && text){
          $scope.searchTextR.text = text;
          $scope.searchText = text;
          $scope.search.text = text;
          if(text){
            $scope.deviceListLoading = true;
            $rootScope.clearSearch = false;
            $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
            //Adv search implemented
            $scope.paginationControls.currPage = 1;
            $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
            if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
              $scope.curAdvSearchObj = $scope.advSearchInfo;
              if($scope.filter != "all"){
                $scope.filterType = $scope.filter
                $scope.curAdvSearchObj.fil = $scope.filter;
              } else{
                $scope.filterType = "";
              }
              $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
              $scope.curAdvSearchObj.offset = 0;
              CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextR.text).then(
                function(data){
                  $scope.deviceListLoading = false;
                  $scope.filteredData = data;
                  $scope.folderList = [];
                  $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                  $scope.curAdvSearchObj.isLoadMore = false;
                  if(data.info.rdc || data.info.rdc == 0){
                    $scope.curAdvSearchObj.rdc = data.info.rdc;
                  }
                  $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            } else{
              $rootScope.offset = 0;
              $scope.deviceListLoading = true;
              $scope.filter = JSON.parse(localStorage.getItem("filterType"));
              var caller = "r";
              if($scope.selectedTab == "hub.reports.hds.pp"){
                caller = "hdsr"
              }
              $scope.dReqObj = {caller:caller,type:null,offset:0,auth:$scope.auth,text:$scope.searchTextR.text,filter:$scope.filter,fId:$scope.curFolderId};
              $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
            }
          }
        } else {
          if(caller){
            $scope.searchTextR.text = "";
            $scope.searchText = "";
            $scope.search.text = "";
            $rootScope.clearSearch = true;
            $rootScope.commonSearchVar = "";
          } else{
            $scope.searchText = $scope.searchTextR.text;
            $scope.search.text = $scope.searchTextR.text;
          }
        }
      }
    }

    $scope.resetFx = function(){
      var directiveElement = angular.element(document.querySelector('dir-pagination-clone'));
      var directiveController = directiveElement.controller('dirPaginateClone');

      if (directiveController && directiveController.myDirectiveFunction) {
          directiveController.goToPage();  // Call the directive's function
      }
      // var storeData = angular.copy($scope.reportSelectedItems.devices);
      // $scope.reportSelectedItems.devices = [];
      // $scope.reportSelectedItems.devices = storeData;
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.resetFx();
      $scope.selPaginationControls.currPage = 1;
      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchTextR.text = "";
        $scope.searchText = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchTextR.text = "";
        $scope.search.text = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }

      $scope.advSearchInfo = args.info;
      $scope.searchMsg = false;
      $scope.deviceTypes = "";
      $scope.folderList = [];
      $scope.breadCrumbs = [];
      $scope.isAdvSearchActive = false;
      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.searchTextR.text && $scope.searchTextR.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            $scope.devices = angular.copy($scope.sData);
            $scope.setCountFx();
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            $scope.devices = angular.copy($scope.asData);
            $scope.statusObj.as = true;
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};
          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          $scope.devices.info = args.dInfo;
          if($scope.devices.info){
            $scope.tim = $scope.devices.info.timthumb;
            $scope.bucket = $scope.dBucket = $scope.detailBucket = $scope.devices.info.bucket;
            if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
              $scope.detailBucket = $scope.dDetailBucket = $scope.devices.info.mbucket;
            }
          }
        }
        $scope.isAdvSearch = true;
      }
      $scope.devices.folders = args.folders;
      $scope.advSearchInfo = args.info;

      if($scope.advSearchInfo.module=="r" && ($scope.advSearchInfo.os != null || ($scope.advSearchInfo.hasOwnProperty("client") && $scope.advSearchInfo.client != null) || ($scope.advSearchInfo.hasOwnProperty("dName") && $scope.advSearchInfo.dName != null) || ($scope.advSearchInfo.hasOwnProperty("createdBy") && $scope.advSearchInfo.createdBy != null) || ($scope.advSearchInfo.hasOwnProperty("sName") && $scope.advSearchInfo.sName != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || $scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length || $scope.advSearchInfo.userGroup.include.length || $scope.advSearchInfo.userGroup.exclude.length || ($scope.advSearchInfo.hasOwnProperty("fil") && $scope.advSearchInfo.fil != "" && $scope.advSearchInfo.fil != "all") || $scope.advSearchInfo.prop != null)){
        if($scope.auth.upreferences.isSplitV){
          $scope.deviceObj.quadHeight = $scope.getAvailableHeight(395);
          $scope.deviceObj.selectedHeight = $scope.getAvailableHeight(395);
        } else {
          $scope.deviceObj.quadHeight = Math.round($scope.getAvailableHeight(502) * 0.6);
          $scope.deviceObj.selectedHeight = Math.round($scope.getAvailableHeight(502) * 0.4);
        }
      } else if($scope.advSearchInfo.module=="r" && ($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length && !$scope.advSearchInfo.userGroup.include.length && !$scope.advSearchInfo.userGroup.exclude.length && ($scope.advSearchInfo.fil == "all" || !$scope.advSearchInfo.fil) && $scope.advSearchInfo.prop == null)){
        if($scope.auth.upreferences.isSplitV){
          $scope.deviceObj.quadHeight = $scope.getAvailableHeight(316);
          $scope.deviceObj.selectedHeight = $scope.getAvailableHeight(316);
        } else {
          $scope.deviceObj.selectedHeight = Math.round($scope.getAvailableHeight(425) * 0.4);
          $scope.deviceObj.quadHeight = Math.round($scope.getAvailableHeight(425) * 0.6);
        }
      }

      $scope.advSearch = true;
      //clear folder list if adv search active
      if($scope.isAdvSearchActive && ($scope.totalDeviceOnServer > $scope.auth.upreferences.dpc)){
        $scope.folderList = [];
        $scope.breadCrumbs = [];
      }
      if($scope.advSearchInfo.module == "r"){
        $scope.setCountFx();
      }
      $scope.filterType = $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
      }
      if(args.code == 8118 && !$scope.isAdvSearchActive){
        $scope.searchTextR.text = "";
        $scope.search.text = "";
        $scope.searchText = "";
        $scope.curFolderId = 0;
        localStorage.removeItem("curDFId");
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.advSApply = false;
        $scope.advSearchInfo = {};
        $scope.folderList = [];
        $scope.curFolderId = 0;
        $rootScope.commonSearchVar = "";

        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          if($scope.curType && !$scope.searchFromRoot){
            $scope.openTypeFx($scope.curType, null, "call");
          } else{
            $scope.getTypesFx();
          }
        } else{
          $scope.getDevicesFx();
        }
      }
    });

    $scope.selectAllSDFx = function(){
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt' && ($scope.devices.info.count / $scope.devices.info.pl > 1)){
        if($scope.devices.info.allIds){
          CommonSrv.selectAllSD($scope.devices.info.allIds.join()).then(
            function(data){
              $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
              $rootScope.reportSelectedItems.devices = angular.copy(data.devices);
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.dReqObj = {caller:"gbdt",type:$scope.curType.type};
          DevicesSrv.getDevice($scope.dReqObj).then(
            function(data){
              if(data.code == 12064){
                $scope.auth.upermissions.gbdt = false;
                localStorage.setItem('auth', JSON.stringify($scope.auth));
                $scope.getDevicesFx();
              } else{
                $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
                $rootScope.reportSelectedItems.devices = angular.copy(data.devices);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.getAdvSearchFx = function(offset){
      $scope.advSearchInfo.offset = offset;
      CommonSrv.updateAdvSearch($scope.advSearchInfo).then(
        function(data){
          $scope.paginationLoading = false;
          $scope.isGbdt = false;
          $scope.devices = data;
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.updateList();
        },
        function(err){
          $log.error(err);
          $scope.searchProcessing = false;
        }
      );
    }

    $scope.updateList = function(){
      // $scope.searchChangeFx('empty');
      $scope.dASAll = [];
      $scope.dASAllCheck.box = false;
      if(!$rootScope.addStatusKeyVal.value){
        $scope.deviceListLoading = false;
      }
      if($scope.searchTextR.text && $scope.searchTextR.text.length){
        $scope.folderList = [];
      }

      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchTextR.text){
          $scope.folderList = $scope.dData.folders;
        }
        if ($scope.devices.info && $scope.devices.info.breadCrumbs) {
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
      }
      if($scope.searchTextR.text && $scope.searchTextR.text.length){
        $scope.folderList = [];
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.devices.types){
        if(!$scope.filterType || $scope.filterType=="all"){
          $scope.filterType = "";
          $scope.filter = "all";
        }
      }
      //?New: end
    }

    $scope.removeFilteredFx = function(id, type){
      if(id == "all"){
        $rootScope.reportSelectedItems.devices = [];
      }
    }

    $scope.getTypesFx = function(caller){
      $scope.deviceListLoading = true;
      $scope.breadCrumbs = [];
      $scope.isGbdt = true;
      $scope.devices = {};
      if(caller == "home"){
        localStorage.removeItem("curDType");
        localStorage.removeItem("filterType");
        // $scope.getTypesInFx();
        $scope.curType = {};
        $scope.searchFromRoot = true;
        $scope.breadCrumbs = [];
        $rootScope.selectedItems = [];
        $scope.advSearchInfo = {};
      }
      DevicesSrv.getDType().then(
        function(data){
          $scope.deviceTypes = data;
          $scope.addStatusKey($scope.deviceTypes, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.deviceTypes);
          $scope.deviceListLoading = false;
          $scope.fCount = null;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.12');

    // ===========
    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $rootScope.hasErrEx = false;
      $rootScope.errTypeEx = "";
      $scope.resetReportFx();
      $scope.spliceReportArr();
      if($scope.selectedTab == "hub.reports.d.op" || $scope.selectedTab == "hub.reports.d.od" || $scope.selectedTab == "hub.reports.s" || $scope.selectedTab == "hub.reports.c.pp" || $scope.selectedTab == "hub.reports.c.cs" || $scope.selectedTab == "hub.reports.d.ds" || $scope.selectedTab == "hub.reports.d.hg" || $scope.selectedTab == "hub.reports.d.od" || $scope.selectedTab == "hub.reports.d.dst" || $scope.selectedTab == "hub.reports.d.poh" || $scope.selectedTab == "hub.reports.hds.pp" || $scope.selectedTab == "hub.reports.hds.es" || $scope.selectedTab == "hub.reports.hds.rv" || $scope.selectedTab == "hub.reports.hds.ac" || $scope.selectedTab == "hub.reports.d.hk"){
        $scope.loadSelectedTab();
      }
      $scope.errType = "";
      $scope.hasErr = false;
      if($rootScope.isStatusInterval){
        $interval.cancel($rootScope.isStatusInterval);
      }
    });
    $scope.loadSelectedTab = function(){
      $scope.report = {};
      if($scope.selectedTab == "hub.reports.c.pp"){
        $scope.defaultSDate=moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.maxDate=moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            timeRangeType:"a",
            loopOpt:false,
            tableInfo:{
              cName:$filter("translate")('r.body.6'),
              msg1:$filter("translate")('r.msg.1')
            },
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
        $scope.apiPath = $rootScope.apiHost + "reports/pp";
      } else if($scope.selectedTab == "hub.reports.ds"){
        $scope.report = {
          info:{}
        };
        $scope.apiPath = $rootScope.apiHost + "reports/ds";
      } else if($scope.selectedTab == "hub.reports.c.cs"){
        $scope.report = {
          info:{csFrameType:"a"}
        };
      } else if($scope.selectedTab == "hub.reports.op"){
        $scope.defaultSDate = moment().subtract(7, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.od"){
        $scope.report = {hour:1};
      } else if($scope.selectedTab == "hub.reports.s"){
        $scope.sReportLoading = true;
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
        ReportsSrv.getSubscribe().then(
          function(data){
            $scope.sReportLoading = false;
            $scope.report = data;
          },
          function(err){
            $scope.sReportLoading = false;
            $log.error(err);
          }
        );
        $scope.report = {hour:1};
      } else if($scope.selectedTab == "hub.reports.d.ds"){
        $scope.defaultSDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{dType:"d",
            dateRange:{
              // startDate:moment().subtract(1, "days").format("L"),
              // endDate:moment().subtract(1, "days").format("L")
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.hg"){
        $scope.defaultSDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{dType:"d",
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.op"){
        $scope.defaultSDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{dType:"d",
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.dst"){
        $scope.defaultSDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            curDateRange:{
              startDate:$scope.maxDate,
              endDate:$scope.maxDate
            },
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.poh"){
        $scope.defaultSDate = moment().subtract(15, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.hds.pp"){
        $scope.defaultSDate = moment().subtract(7, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            timeRangeType:"a",
            loopOpt:false,
            tableInfo:{
              cName:$filter("translate")('r.body.6'),
              msg1:$filter("translate")('r.msg.1')
            },
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
        $scope.apiPath = $rootScope.apiHost + "reports/pp";
      } else if($scope.selectedTab == "hub.reports.hds.es" || $scope.selectedTab == "hub.reports.hds.rv" || $scope.selectedTab == "hub.reports.hds.ac"){
        $scope.defaultSDate = moment().subtract(7, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      } else if($scope.selectedTab == "hub.reports.d.ci"){
        $scope.report = {
          info:{dType:"d"}
        };
      } else if($scope.selectedTab == "hub.reports.d.hk"){
        $scope.defaultSDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.maxDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.report = {
          info:{
            dateRange:{
              startDate:$scope.defaultSDate,
              endDate:$scope.maxDate
            }
          }
        };
      }
    }
    $scope.loadSelectedTab();

    $scope.deviceViewFx = function(){
      $scope.deviceObj.deviceView = $scope.auth.upreferences.deviceView;
    }

    $scope.resetSelFx = function(){
      var data = angular.copy($rootScope.copySelDevice);
      $rootScope.reportSelectedItems.devices = data;
    }


    $scope.selectDevice = function(){
      // $scope.searchChangeFx("empty");
      $scope.firstDeviceLoading = true;
      $scope.advSApply = false;
      $scope.searchTextR.text = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.curFolderId = 0;
      localStorage.removeItem("curDFId");

      $scope.isAdvSearch = false;
      $scope.advSearchInfo = {};
      // $scope.advSearchInfo.step = undefined;
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        $scope.getTypesFx();
      } else{
        $scope.getDevicesFx();
      }
      $scope.selectedSearch = {text:""};
      $scope.searchTextR.text = "";
      $scope.searchText = "";
      $scope.search.text = "";
      $rootScope.commonSearchVar = "";
      $scope.deviceObj = {
        isSplitV:$scope.auth.upreferences.isSplitV,
        deviceView:$scope.auth.upreferences.deviceView,
        thumbBigParam:$scope.thumbBigParam,
        quadHeight:$scope.quadHeight,
        selectedHeight:$scope.selectedHeight
      };

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));

      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
        $scope.rFilter = "all";
        $scope.fCount = $scope.devices.devices;
      } else {
        $scope.rFilter = $scope.filterType;
        $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
      }
      ngDialog.open({
        template:'app/reports/popup/selectDevice.html',
        width:1500,
        scope:$scope,
        data:$scope.deviceObj,
        closeByEscape:false,
        closeByDocument:false,
        appendClassName:"ng-dialog-padT50",
        controller:'SelectDeviceController',
        preCloseCallback:function(){
          $rootScope.selectedItems = [];
          $scope.advSearchInfo = {};
          localStorage.removeItem("curDType");
          // $scope.resetSelFx();
          $scope.resetSelPagination("copy");
        }
      // }).closePromise.then(function(){
      //   $rootScope.reportSelectedItems.devices = angular.copy($rootScope.copySelDevice);
      });
    }
    $scope.selectContent = function(){
      // TODO advance search cleared when popup open
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.searchTextR.text = "";
      // $scope.searchChangeFx("empty");
      $scope.searchText = "";
      $scope.search.text = "";
      $scope.search.pText = "";
      $rootScope.commonSearchVar = "";
      $scope.contentObj = {
        curTab:$scope.selectedTab,
        isSplitV:$scope.auth.upreferences.isSplitV,
        thumbParam:$scope.thumbParam,
        thumbBigParam:$scope.thumbBigParam,
        quadHeight:$scope.quadHeight,
        selectedHeight:$scope.selectedHeight
      };
      ngDialog.open({
        template:'app/reports/popup/selectContent.html',
        width:1100,
        scope:$scope,
        data:$scope.contentObj,
        closeByEscape:false,
        closeByDocument:false,
        appendClassName:"ng-dialog-padT50",
        controller:'SelectContentController'
      });
    }
    $scope.$on('contentInfo', function(event, args){
      $scope.tim = args.tim;
      $scope.cBucket = $scope.cDetailBucket = args.cBucket;
      $scope.cDetailBucket = args.cDetailBucket;
    });

    // "hg" is using for "device health"
    $scope.exportFx = function(caller, type, index){
      $scope.reportArrCopy = angular.copy($scope.reportArr[index].info);
      $scope.reportArrCopy.info.dateRange = {
        startDate:moment($scope.reportArr[index].info.info.dateRange.startDate).format("L"),
        endDate:moment($scope.reportArr[index].info.info.dateRange.endDate).format("L")
      };
      $scope.reportArrCopy.info.sTime = moment($scope.report.info.sTime).format("HH:mm Z");
      $scope.reportArrCopy.info.eTime = moment($scope.report.info.eTime).format("HH:mm Z");
      if(type == "pp" || type == "hg"){
        if($rootScope.reportSelectedItems.devices.length == 0){
          $scope.report.devices = $scope.devices.devices;
          $scope.reportArrCopy.info.deviceEmpty = true;
        } else{
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.reportArrCopy.info.deviceEmpty = false;
        }
        if($rootScope.reportSelectedItems.content.length == 0){
          $scope.reportArrCopy.info.contentEmpty = true;
        } else{
          $scope.reportArrCopy.info.contentEmpty = false;
        }
      }
      if(caller == "csv"){
        if(type == "pp"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getCSVReportsPP($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "ds"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getCSVReportsDS($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "cs"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getCSVReportsCS($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              // $scope.linkOpenFx(data.url);
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "hg"){
          // "hg" is using for "device health"
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getCSVReportsHG($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if(caller == "xlsx"){
        if(type == "pp"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsPP($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "ds"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsDS($scope.reportArrCopy).then(
            function(data){
              if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab("ds")
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "cs"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsCS($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "hg"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsHG($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "dst"){
          $scope.reportArrCopy.info.dateRange = {
            startDate:moment($scope.reportInfoCopy.dateRange.startDate).format("L"),
            endDate:moment($scope.reportInfoCopy.dateRange.endDate).format("L")
          };

          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsDST($scope.reportArrCopy).then(
            function(data){
              if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab("dst")
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "poh"){
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsPOH($scope.reportArrCopy).then(
            function(data){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if(caller == "mail"){
        $scope.errEmail = false;
        if(angular.isUndefined($scope.curInfo.email) || $scope.curInfo.email == ""){
          $scope.errEmail = true;
          $("#email").focus();
        } else{
          $scope.sendProcessing = true;
          if(type == "pp"){
            ReportsSrv.getMailXLSXReportsPP($scope.reportArrCopy, $scope.curInfo.email).then(
              function(data){
                $scope.sendProcessing = false;
                $scope.reportArr[index].isOpen = false;
              },
              function(err){
                $log.error(err);
                $scope.sendProcessing = false;
              }
            );
          } else if(type == "ds"){
            ReportsSrv.getMailXLSXReportsDS($scope.reportArrCopy, $scope.curInfo.email).then(
              function(data){
                $scope.sendProcessing = false;
                $scope.reportArr[index].isOpen = false;
              },
              function(err){
                $log.error(err);
                $scope.sendProcessing = false;
              }
            );
          } else if(type == "cs"){
            ReportsSrv.getMailXLSXReportsCS($scope.reportArrCopy, $scope.curInfo.email).then(
              function(data){
                $scope.sendProcessing = false;
                $scope.reportArr[index].isOpen = false;
              },
              function(err){
                $log.error(err);
                $scope.sendProcessing = false;
              }
            );
          } else if(type == "hg"){
            ReportsSrv.getMailXLSXReportsHG($scope.reportArrCopy, $scope.curInfo.email).then(
              function(data){
                $scope.sendProcessing = false;
                $scope.reportArr[index].isOpen = false;
              },
              function(err){
                $log.error(err);
                $scope.sendProcessing = false;
              }
            );
          }
        }
      }
    }

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/reports/popup/info.html',
        width:580,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    $scope.closeReport = function(index){
      $scope.reportArr.splice(index, 1);
    }

    $scope.resetReportFx = function(){
      $scope.report = {};
      $scope.curInfo = {};
      $scope.chartLoading = false;
      if($scope.selectedTab == "hub.reports.pp"){
        $scope.report = {
          info:{
            timeRangeType:"a"
          }
        };
      } else if($scope.selectedTab == "hub.reports.ds"){
        $scope.report = {};
      } else if($scope.selectedTab == "hub.reports.cs"){
        $scope.report = {
          info:{
            csFrameType:"a",
            loopOpt:false
          }
        };
      }
    }

    $scope.exportReportNewFx = function(caller, type, data){
      $scope.reportArrCopy = data;
      $scope.reportArrCopy.info.dateRange = {
        startDate:moment(data.info.dateRange.startDate).format("L"),
        endDate:moment(data.info.dateRange.endDate).format("L")
      };
      $scope.reportArrCopy.info.sTime = moment($scope.report.info.sTime).format("HH:mm Z");
      $scope.reportArrCopy.info.eTime = moment($scope.report.info.eTime).format("HH:mm Z");
      if(type == "pp" || type == "hg"){
        if($rootScope.reportSelectedItems.devices.length == 0){
          $scope.report.devices = $scope.devices.devices;
          $scope.reportArrCopy.info.deviceEmpty = true;
        } else{
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.reportArrCopy.info.deviceEmpty = false;
        }
        if($rootScope.reportSelectedItems.content.length == 0){
          $scope.reportArrCopy.info.contentEmpty = true;
        } else{
          $scope.reportArrCopy.info.contentEmpty = false;
        }
      }
      if(caller == "xlsx"){
        if(type == "ds"){
          $scope.dsReportLoading = true;
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsDS($scope.reportArrCopy).then(
            function(data){
              $scope.dsReportLoading = false;
              if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab("ds")
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if(type == "dst"){
          $scope.dstReportLoading = true;
          $scope.reportArrCopy.info.dateRange = {
            startDate:moment($scope.reportInfoCopy.dateRange.startDate).format("L"),
            endDate:moment($scope.reportInfoCopy.dateRange.endDate).format("L")
          };

          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsDST($scope.reportArrCopy).then(
            function(data){
              $scope.dstReportLoading = false;
              if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab("dst")
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.generateReportFx = function(caller){
      $scope.hasErr = false;
      $scope.curReport = "";
      $scope.errType = "";
      $scope.spliceReportArr();
      $scope.chartLoading = true;
      $scope.chartShow = true;
      $scope.reports = [];

      $scope.localiz = {
        label:$filter("translate")('r.body.6'),
        msg1:$filter("translate")('r.msg.1'),
        msg2:$filter("translate")('r.msg.2'),
        msg3:$filter("translate")('r.msg.3'),
        sec:$filter("translate")('cm.label.27s'),
        min:$filter("translate")('cm.label.28'),
        mins:$filter("translate")('cm.label.28s'),
        total:$filter("translate")('r.body.9'),
        used:$filter("translate")('r.body.10'),
        avl:$filter("translate")('r.body.11'),
        timeR:$filter("translate")('r.label.2')
      };
      if(caller != "od" && caller != "cc" && caller != "ir" && caller != "ci"){
        $scope.reportInfoCopy = angular.copy($scope.report.info);
        if(caller == "dst" && $rootScope.reportSelectedItems.devices.length > 1){
          $scope.reportInfoCopy.dateRange = {
            startDate:moment($scope.report.info.curDateRange.startDate).format("L"),
            endDate:moment($scope.report.info.curDateRange.endDate).format("L")
          }
        } else{
          $scope.reportInfoCopy.dateRange = {
            startDate:moment($scope.report.info.dateRange.startDate).format("L"),
            endDate:moment($scope.report.info.dateRange.endDate).format("L")
          }
        }
      }

      if(caller == "pp"){
        localStorage.setItem('allDeviceData', JSON.stringify($scope.devicesCopy.devices));
        if($rootScope.reportSelectedItems.devices.length == 0){
          $scope.report.devices = $scope.devicesCopy.devices;
          $scope.reportInfoCopy.deviceEmpty = true;
        } else{
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.reportInfoCopy.deviceEmpty = false;
        }
        if($rootScope.reportSelectedItems.content.length == 0){
          $scope.reportInfoCopy.contentEmpty = true;
        } else{
          $scope.reportInfoCopy.contentEmpty = false;
        }
        $scope.report.content = $rootScope.reportSelectedItems.content;
        $scope.arraytoStringFx($scope.report.content);
        if($scope.report.info.timeRangeType == "c" && (angular.isUndefined($scope.report.info.sTime) || angular.isUndefined($scope.report.info.eTime))){
          $scope.chartLoading = false;
          $scope.chartShow = false;
          $scope.errType = "time";
          $scope.hasErr = true;
          $scope.timeMsg = $filter("translate")('r.msg.4');
          if(angular.isUndefined($scope.report.info.sTime)){
            $("#sTime").focus();
          } else if(angular.isUndefined($scope.report.info.eTime)){
            $("#eTime").focus();
          }
          return;
        } else if($scope.report.info.loopOpt && (angular.isUndefined($scope.report.info.loopLength) || $scope.report.info.loopLength == null)){
          $scope.chartShow = false;
          $scope.chartLoading = false;
          $scope.errType = "loop";
          $scope.hasErr = true;
          $scope.loopLength = $filter("translate")('r.msg.6');
          $("#loop").focus();
          return;
        }

        $scope.reportInfoCopy.sTime = moment($scope.report.info.sTime).format("HH:mm Z");
        $scope.reportInfoCopy.eTime = moment($scope.report.info.eTime).format("HH:mm Z");
        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices,
          content:$scope.report.content
        });

        if($scope.report.info.timeRangeType == "c" && ($scope.reportInfoCopy.sTime >= $scope.reportInfoCopy.eTime)){
          $scope.chartLoading = false;
          $scope.chartShow = false;
          $scope.errType = "time";
          $scope.hasErr = true;
          $scope.timeMsg = $filter("translate")('r.msg.5');
          $("#eTime").focus();
          return;
        }
        ReportsSrv.getReportsPP($scope.curReport).then(
          function(data){
            $scope.reports = data;
            if($scope.reports.reportType == "pp"){
              $scope.report.info.tableInfo = {
                Devicelabel:$filter("translate")('r.body.14'),
                label:$filter("translate")('r.body.6')
              };
              $scope.apiPath = $rootScope.apiHost + "reports/pp";
            } else if($scope.reports.reportType == "ppDevice"){
              $scope.report.info.tableInfo = {
                label:$filter("camelCase")($filter("translate")('cm.label.71'))
              };
              $scope.apiPath = $rootScope.apiHost + "reports/ppDevice";
            }

            $scope.report.info.reportType = $scope.reports.reportType;
            $scope.reportArr.unshift({
              data:$scope.reports,
              type:"pp",
              isPinned:false,
              isOpen:false,
              actionShow:true,
              info:$scope.report
            });
            $scope.chartLoading = false;
            $scope.ppPopupFx();
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "ds"){
        $scope.apiPath = $rootScope.apiHost + "reports/ds";
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices
        });
        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 14 && $scope.auth.upermissions.drg == 'v2'){
          $scope.hasErr = true;
          $scope.chartLoading = false;
          $scope.dsReportLoading = false
          $scope.errType = "date";
          return;
        }else if($scope.curReport.devices.length > 10 && $scope.auth.upermissions.drg == 'v2'){
          $scope.chartLoading = false;
          $scope.dsReportLoading = false
          $scope.exportReportNewFx('xlsx', caller, $scope.curReport);
        } else{
          ReportsSrv.getReportsDS($scope.curReport).then(
            function(data){
              $scope.reports = data;
              $scope.reportArr.unshift({
                data:$scope.reports,
                type:"ds",
                isPinned:false,
                isOpen:false,
                actionShow:true,
                info:$scope.report
              });
              $scope.chartLoading = false;
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if(caller == "cs"){
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices
        });
        ReportsSrv.getReportsCS($scope.curReport).then(
          function(data){
            $scope.reports = data;
            $scope.chartLoading = false;
            $scope.actionShow = false;
            angular.forEach($scope.reports.data, function(data){
              if(data.assignment.length && !$scope.actionShow){
                $scope.actionShow = true;
              }
            });
            $scope.reportArr.unshift({
              data:$scope.reports,
              type:"cs",
              isPinned:false,
              isOpen:false,
              actionShow:$scope.actionShow,
              info:$scope.report
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "op"){
        $scope.chartLoading = false;
        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 14 && $scope.auth.upermissions.drg == 'v2'){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        }
        $scope.opReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        // $scope.linkOpenFx('d');
        ReportsSrv.getReportsOP({info:$scope.reportInfoCopy}).then(
          function(data){
            $scope.opReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
              $scope.loadSubTab("op")
            } else{
              $scope.linkOpenFx('d');
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.opReportLoading = false;
          }
        );
      } else if(caller == "od"){
        $scope.chartLoading = false;
        if($scope.report.hour == null || $scope.report.hour == ""){
          $scope.hasErr = true;
          $scope.errType = "hour";
          $("#hour").focus();
          return;
        }
        $scope.odReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        // $scope.linkOpenFx('d');
        ReportsSrv.getReportsOD({hour:$scope.report.hour}).then(
          function(data){
            $scope.odReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
              $scope.loadSubTab("od")
            } else{
              $scope.linkOpenFx('d');
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $scope.odReportLoading = false;
            $log.error(err);
          }
        );
      } else if(caller == "cc"){
        $scope.chartLoading = false;
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.curReport = angular.extend({devices:$scope.report.devices});
        $scope.ccReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsCC($scope.curReport).then(
          function(data){
            $scope.ccReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $scope.ccReportLoading = false;
            $log.error(err);
          }
        );
      } else if(caller == "ir"){
        $scope.chartLoading = false;
        $scope.irReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsIR($scope.curReport).then(
          function(data){
            $scope.irReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            // }  else if(data.id && data.id == 106){
            //   $scope.loadSubTab("ir")
            } else{
              // $scope.linkOpenFx('d');
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $scope.irReportLoading = false;
            $log.error(err);
          }
        );
      } else if(caller == "hg"){
        if($scope.report.info.dType == "bl"){
          $scope.chartLoading = false;
          $scope.apiPath = $rootScope.apiHost + "reports/dh";
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.curReport = angular.extend({
            devices:$scope.report.devices
          });
          $scope.hgReportLoading = true;
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsBL($scope.curReport).then(
            function(data){
              $scope.hgReportLoading = false;
              if(data.code == 18009){
                ngDialog.close();
                $scope.hasErr = true;
                $scope.errType = "noData";
              } else if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab("bl")
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
              $scope.hgReportLoading = false;
            }
          );
        } else{
          $scope.chartLoading = false;
          $scope.apiPath = $rootScope.apiHost + "reports/dh";
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.curReport = angular.extend({
            info:$scope.reportInfoCopy,
            devices:$scope.report.devices
          });
          var sDate = new Date($scope.curReport.info.dateRange.startDate);
          var eDate = new Date($scope.curReport.info.dateRange.endDate);
          // To calculate the time difference of two dates
          $scope.differenceInTime = eDate.getTime() - sDate.getTime();
          // To calculate the no. of days between two dates
          $scope.differenceInDays = $scope.differenceInTime / (1000 * 3600 * 24);
          if($scope.differenceInDays > 31 && $scope.auth.upermissions.drg == 'v1'){
            $scope.hasErr = true;
            $scope.errType = "maxDay";
            $scope.dayMsg = $filter("translate")('r.msg.10');
            return;
          }
          if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 14 && $scope.auth.upermissions.drg == 'v2'){
            $scope.hasErr = true;
            $scope.errType = "date";
            return;
          }
          $scope.hgReportLoading = true;
          $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
          // $scope.linkOpenFx('d');
          ReportsSrv.getXLSXReportsHG($scope.curReport).then(
            function(data){
              $scope.hgReportLoading = false;
              if(data.code == 18009){
                ngDialog.close();
                $scope.hasErr = true;
                $scope.errType = "noData";
              } else if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
                $scope.loadSubTab($scope.report.info.dType == 'd'? 'dh':'dt')
              } else{
                $scope.linkOpenFx('d');
                $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              }
            },
            function(err){
              $log.error(err);
              $scope.hgReportLoading = false;
            }
          );
        }
      } else if(caller == "dst"){
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        if($rootScope.reportSelectedItems.devices.length > 1){
          $scope.reportInfoCopy.dateRange.startDate = moment($scope.report.info.curDateRange.startDate).format("L");
          $scope.reportInfoCopy.dateRange.endDate = moment($scope.report.info.curDateRange.startDate).format("L");
        }

        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices
        });


        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 14 && $scope.curReport.devices.length == 1 && $scope.auth.upermissions.drg == 'v2'){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        } else if($scope.curReport.devices.length > 10 && $scope.auth.upermissions.drg == 'v2'){
          $scope.chartLoading = false;
          $scope.dstReportLoading = false
          $scope.exportReportNewFx('xlsx', caller, $scope.curReport);
        } else{
          ReportsSrv.getReportsDST($scope.curReport).then(
            function(data){
              $scope.chartLoading = false;
              $scope.reportArr.unshift({
                data:data,
                type:"dst",
                info:$scope.report
              });
            },
            function(err){
              $log.error(err);
            }
          );
        }

      } else if(caller == "poh"){
        $scope.chartLoading = false;
        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 15){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        }
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices
        });
        $scope.pohReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        // $scope.linkOpenFx('d');
        ReportsSrv.getXLSXReportsPOH($scope.curReport).then(
          function(data){
            $scope.pohReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else if(data.id && data.id == 106 && $scope.auth.upermissions.drg == 'v2'){
              $scope.loadSubTab('poh')
            } else{
              $scope.linkOpenFx('d');
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            // } else{
            //   $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            //   // $scope.linkOpenFx(data.url);
            }
          },
          function(err){
            $log.error(err);
            $scope.pohReportLoading = false;
          }
        );
      } else if(caller == "mailSent" || caller == "mailLinkClick" || caller == "advtClick"){
        $scope.chartLoading = false;
        $scope.curDate = angular.element(document).find(".picker").val();
        $scope.curDate = $scope.curDate.split(" - ");
        $scope.reportInfoCopy.dateRange = {startDate:moment($scope.curDate[0]).format('MM/DD/YYYY'), endDate:moment($scope.curDate[1]).format('MM/DD/YYYY')};

        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 15){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        }
        $scope.opReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');

        ReportsSrv.getStethReports(caller, {info:$scope.reportInfoCopy}).then(
          function(data){
            $scope.opReportLoading = false;
            if(data.code == 18009 || data.code == 18005){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.opReportLoading = false;
          }
        );
      } else if(caller == "hdpp"){
        $scope.chartLoading = false;
        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 15){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        }
        localStorage.setItem('allDeviceData', JSON.stringify($scope.devicesCopy.devices));
        if($rootScope.reportSelectedItems.devices.length == 0){
          $scope.report.devices = $scope.devicesCopy.devices;
          $scope.reportInfoCopy.deviceEmpty = true;
        } else{
          $scope.report.devices = $rootScope.reportSelectedItems.devices;
          $scope.reportInfoCopy.deviceEmpty = false;
        }
        if($rootScope.reportSelectedItems.content.length == 0){
          $scope.reportInfoCopy.contentEmpty = true;
        } else{
          $scope.reportInfoCopy.contentEmpty = false;
        }
        $scope.report.content = $rootScope.reportSelectedItems.content;
        $scope.arraytoStringFx($scope.report.content);

        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices,
          content:$scope.report.content
        });
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getStethReportsPP($scope.curReport).then(
          function(data){
            if(data.code == 18009 || data.code == 18005){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
              // $scope.linkOpenFx(data.url);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "hk"){
        $scope.chartLoading = false;
        if($filter("dateDifference")($scope.reportInfoCopy.dateRange.startDate, $scope.reportInfoCopy.dateRange.endDate) > 15){
          $scope.hasErr = true;
          $scope.errType = "date";
          return;
        }
        $scope.hkReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsHK({info:$scope.reportInfoCopy}).then(
          function(data){
            $scope.hkReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            // }  else if(data.id && data.id == 106){
            //   $scope.loadSubTab("hk")
            } else{
              // $scope.linkOpenFx('d');
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.hkReportLoading = false;
          }
        );
      } else if(caller == "ci"){
        $scope.chartLoading = false;
        $scope.apiPath = $rootScope.apiHost + "reports/ci";
        $scope.report.devices = $rootScope.reportSelectedItems.devices;
        $scope.curReport = angular.extend({
          info:$scope.reportInfoCopy,
          devices:$scope.report.devices
        });
        $scope.hgReportLoading = true;
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getXLSXReportsCI($scope.curReport).then(
          function(data){
            $scope.hgReportLoading = false;
            if(data.code == 18009){
              ngDialog.close();
              $scope.hasErr = true;
              $scope.errType = "noData";
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.hgReportLoading = false;
          }
        );
      }
    }

    $scope.ppPopupFx = function(){
      if($scope.report.info){
        if($scope.report.info.loopOpt){
          $scope.report.info.tableInfo.type = $filter("translate")('r.body.8');
        } else{
          $scope.report.info.tableInfo.type = $filter("translate")('r.body.7.1');
        }
      }
    }

    $scope.subscribeOpen = function(caller){
      $scope.report.devices = $rootScope.reportSelectedItems.devices;
      if(caller == "pp"){
        $scope.report.content = $rootScope.reportSelectedItems.content;
      }
      $scope.subObj = angular.copy({report:caller, type:"d", detail:$scope.report});
      if($scope.subObj.report == "pp"){
        if($scope.subObj.detail.info.timeRangeType == "c" && (angular.isUndefined($scope.subObj.detail.info.sTime) || angular.isUndefined($scope.subObj.detail.info.eTime))){
          $scope.chartLoading = false;
          $scope.chartShow = false;
          $scope.errType = "time";
          $scope.hasErr = true;
          $scope.timeMsg = $filter("translate")('r.msg.4');
          return;
        } else{
          $scope.hasErr = false;
          $scope.errType = "";
        }
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"r.ph.2" | translate}}</h1>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'cc\'">[ {{"r.tab.1.1" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'cs\'">[ {{"r.tab.1.2" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'pp\'">[ {{"r.tab.1.3" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'ds\'">[ {{"r.tab.2.1" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'hg\'">[ {{"r.tab.2.2" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'ir\'">[ {{"r.tab.2.5" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'od\'">[ {{"r.tab.2.3" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'op\'">[ {{"r.tab.2.4" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'dst\'">[ {{"r.tab.2.6" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'poh\'">[ {{"r.tab.2.7" | translate}} ]</span>\
              <span class="text-muted text-sm marL5"  ng-if="subObj.report == \'ci\'">[ {{"r.tab.7" | translate}} ]</span>\
            </header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"r.label.10" | translate}}</label>\
                <div role="radiogroup" aria-labelledby="radiogroup">\
                  <label class="noMarB"><input type="radio" role="radio" ng-model="subObj.type" value="d"><label></label>{{"b.o.2.1" | translate}}</label>\
                  <label class="noMarB marL10 marR10"><input type="radio" role="radio" ng-model="subObj.type" value="w"><label></label>{{"b.o.2.2" | translate}}</label>\
                  <label class="noMarB"><input type="radio" role="radio" ng-model="subObj.type" value="m"><label></label>{{"b.o.2.3" | translate}}</label>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="subscribeFx();" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span>{{"r.btn.5" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.subscribeFx = function(){
      $scope.saveProcessing = true;
      if($scope.subObj.report != "od" && $scope.subObj.report != "cc" && $scope.subObj.report != "ci"){
        $scope.subObj.detail.info.dateRange = {
          startDate:moment($scope.subObj.detail.info.dateRange.startDate).format("L"),
          endDate:moment($scope.subObj.detail.info.dateRange.endDate).format("L")
        }
      }

      if($scope.subObj.report == "pp"){
        $scope.subObj.detail.info.sTime = moment($scope.subObj.detail.info.sTime).format("HH:mm Z");
        $scope.subObj.detail.info.eTime = moment($scope.subObj.detail.info.eTime).format("HH:mm Z");
      }

      ReportsSrv.subscribe($scope.subObj).then(
        function(data){
          $scope.saveProcessing = false;
          ngDialog.close();
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.unsubscribeOpen = function(id){
      $scope.saveProcessing = false;
      $scope.unsubId = id;
      ngDialog.open({
        template:'\
        <section class="panel" role="dialog">\
          <div class="panel-body">{{"r.msg.9" | translate}}</div>\
          <footer class="panel-footer">\
            <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="unsubscribeFx();" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
            <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
          </footer>\
        </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.unsubscribeFx = function(){
      $scope.saveProcessing = true;
      ReportsSrv.unsubscribe($scope.unsubId).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.removeInArray($scope.report, $scope.unsubId);
          ngDialog.close();
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.reportPinFx = function(index){
      if($scope.reportArr[index].isPinned){
        $scope.reportArr[index].isPinned = false;
      } else{
        $scope.reportArr[index].isPinned = true;
      }
    }
    $scope.spliceReportArr = function(){
      $scope.recheck = false;
      angular.forEach($scope.reportArr, function(item, i){
        if(!item.isPinned && !$scope.recheck){
          $scope.reportArr.splice(i, 1);
          $scope.recheck = true;
        }
      });
      if($scope.recheck){
        $scope.spliceReportArr();
      }
    }
    // js date conversion
    $scope.stringToDate = function(s){
      s = '' + s;
      s = s.split(/[-:]/);
      return Date.UTC(s[0], s[1] - 1, s[2], s[3], s[4], s[5]);
    }

    $scope.devicePreviewFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    }


    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.folderContentFx = function (fId, splId, splType, caller) {
      $scope.apiCalledArr = [];
      // ?New: this "if" code is for device folder
      $scope.paginationControls.currPage = 1;

      $scope.deviceListLoading = true;
      if(!caller || caller != "changeView"){
        $scope.searchTextR.text = "";
        $scope.searchText = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.search = { text: "" };
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curDFId");
      $scope.advSearch = false;
      $scope.curFolderId = 0;

      if (fId == 0) {
        $scope.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curDFId", fId);
        $scope.curFolderId = localStorage.getItem("curDFId");
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.setItem("curDFId", 0);
        localStorage.removeItem("curPathFId");
      }

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType != "all"){
        $scope.filterIsAppliedAlready = true;
      }
      $scope.folObj = {fId:fId, offset:0, obj:null, caller:"r",filType:$scope.filterType,text:$scope.searchTextR.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};
      // DevicesSrv.getFolderData(fId, null, null, "r", $scope.filterType, $scope.searchTextR.text).then(
      DevicesSrv.getFolderData($scope.folObj).then(
        function (data) {
          $scope.flId = fId;
          $scope.deviceListLoading = false;
          $scope.devices = angular.copy(data);
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.dData = angular.copy($scope.devices)
          $scope.brief = data;
          $scope.setCountFx();
          $scope.updateList();

          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function (err) {
          $scope.deviceListLoading = false;
          $log.error(err);
        }
      );

    }
    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/}

    $scope.$on('$destroy', function() {
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
      $scope.advSearchInfo = {};
    });

    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.deviceListLoading = true;
      // $scope.isAdvSearch = false;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      $rootScope.offset = 0;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      var fId = localStorage.getItem("curDFId");
      $scope.curAdvSearchObj = $scope.advSearchInfo;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && !$rootScope.isObjectEmpty($scope.advSearchInfo) && $scope.isAdvSearch)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        } else{
          $scope.curAdvSearchObj.fil = "all";
        }
        $scope.curAdvSearchObj.offset = 0;
        $scope.curAdvSearchObj.r = 1;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextR.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.curAdvSearchObj.sortType = data.info.sortType;
            $scope.curAdvSearchObj.sortVal = data.info.sortVal;
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj };
            if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
              $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
            } else{
              $scope.advSearchfilteredData.dInfo = {allIds:$scope.filteredData.info.allIds};
            }
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.deviceListLoading = false;
          }
        );
      } else {
        if(fId > 0){
          $scope.folderContentFx(fId,null,null,"changeView");
        } else {
          $scope.getDevicesFx("changeView");
        }
      }
      // deregister();
    });

    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData) {
      // Deep compare the new data with the current data
      if (!angular.equals($scope.currentPageDevice, newData.curData)) {
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if (!angular.equals($scope.allPageDevice, newData.allData.length)) {
        $scope.allPageDevice = angular.copy(newData.allData.length);
      }
    }

    // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data) {
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function() {
      return $scope.currentPageDevice.map(function(obj) {
          return obj.id;
      }).join(',');
    };

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.currentPageDevice = newVal;
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for (var i = 1; i <= allPagesCount; i++) {
              $scope.pageDeviceArr.push({pNo:i, tz:new Date().getTime()})
            }
          }else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for (var i = 1; i <= allPagesCount - start; i++) {
              $scope.pageDeviceArr.push({pNo:start +i, tz:new Date().getTime()})
            }
          }
        }
      }
    }, true); // 'true' for deep watch
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceReportsController', DeviceReportsController);

  /** @ngInject */
  function DeviceReportsController($log, $rootScope, $scope, $state, $cookies, $filter, ngDialog, DevicesSrv, ReportsSrv, CommonSrv){
    $rootScope.selectedMenu = 8;
    $rootScope.reportSelectedItems = {info:{}, devices:[], content:[]};

    $scope.selectedTab = $state.current.name;
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CSReportController', CSReportController);

  /** @ngInject */
  function CSReportController($log, $rootScope, $scope){
    $scope.stringToDate = function(s){
  		s = ''+s;
  		s = s.split(/[-: ]/);
  		return Date.UTC(s[0], s[1]-1, s[2], s[3], s[4], s[5]);
  	}
    $scope.curCSOpts = {
      chart: {
        type: 'column',
        height: 400,
        width: null
      },
      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      legend: {
        enabled: false
      },
      tooltip:{
        followPointer: true,
        formatter: function(){
          var tooltip = '';
          $scope.d1 = this.series.userOptions.slot[this.point.index];
          var dValue = $scope.d1.split(" - ");
          if(this.series.name == 'Overlimit'){
            tooltip += $scope.localiz.total + ': <b>' + (this.total - this.y) + '</b><br/>';
            tooltip += $scope.localiz.used + ': <b>' + this.total + '</b><br/>';
            tooltip += $scope.localiz.avl + ': <b>-' + this.y + '</b><br/>';
          } else if(this.series.name == 'Used'){
            if((this.series.userOptions.isOverLimit[this.point.index])){
              tooltip += $scope.localiz.total + ': <b>' + this.y + '</b><br/>';
              tooltip += $scope.localiz.used + ': <b>' + this.total + '</b><br/>';
              tooltip += $scope.localiz.avl + ': <b>-' + (this.total - this.y) + '</b><br/>';
            } else{
              tooltip += $scope.localiz.total + ': <b>' + (this.total) + '</b><br/>';
              tooltip += $scope.localiz.used + ': <b>' + this.y + '</b><br/>';
              tooltip += $scope.localiz.avl + ': <b>' + (this.total - this.y) + '</b><br/>';
            }
          } else if(this.series.name == 'Available'){
            tooltip += $scope.localiz.total + ': <b>' + this.total + '</b><br/>';
            tooltip += $scope.localiz.used + ': <b>' + (this.total - this.y) + '</b><br/>';
            tooltip += $scope.localiz.avl + ': <b>' + this.y + '</b><br/>';
          } else if(this.series.name == 'noThreshold'){
            if(this.series.userOptions.frameHavingThreshold[this.point.index]){
              tooltip += $scope.localiz.used + ': <b>' + this.series.userOptions.thresholdValueOnFrame[this.point.index] + '</b><br/>';
            } else{
              tooltip += $scope.localiz.used + ': <b>' + this.series.userOptions.data[this.point.index] + '</b><br/>';
            }
          } else{
            tooltip += $scope.localiz.total + ': <b>' + this.total + '</b><br/>';
            tooltip += $scope.localiz.used + ': <b>' + (this.total - this.y) + '</b><br/>';
            tooltip += $scope.localiz.avl + ': <b>' + this.y + '</b><br/>';
          }
          tooltip += $scope.localiz.timeR + ': <b>' + Highcharts.dateFormat('%l:%M %p', $scope.stringToDate(dValue[0])) + ' to ' + Highcharts.dateFormat('%l:%M %p', $scope.stringToDate(dValue[1])) + '</b><br/>';
          if(Highcharts.dateFormat('%l:%M %p', $scope.stringToDate(dValue[0])) != "" && Highcharts.dateFormat('%l:%M %p', $scope.stringToDate(dValue[1])) != ""){
            return tooltip;
          } else{
            tooltip = '';
            return false;
          }
        }
      }
    };

    $scope.csChartData = [];
    if($scope.data.data.length > 0){
      angular.forEach($scope.data.data, function(item, d){
        if($scope.data.data[d].assignment.length > 0){
          angular.forEach($scope.data.data[d].assignment, function(item, i){
            $scope.curCsChart = {title:{text:""}, options: $scope.curCSOpts, xAxis:{categories: []}, yAxis:{title:{text:"Threshold Value"}, labels:{enabled: false}, gridLineColor:'transparent', allowDecimals:false, min:0, plotLines:[]}, tooltip:{followPointer:""}, series:[]};
            $scope.curCsChart.title.text = $scope.data.data[d].name + " (" + $scope.data.data[d].assignment[i].name + ")";
            $scope.curCsChart.xAxis.categories = $scope.data.data[d].assignment[i].frame.name;
            $scope.curCsChart.series = $scope.data.data[d].assignment[i].frame.data;

            $scope.seriesData = [];
            $scope.frameData = $scope.data.data[d].assignment[i].frame.data;
            angular.forEach($scope.data.data[d].assignment[i].frame.thresholdValueOnFrame, function(val, key1){
              var flTh;
              if(!item.frame['frameHavingThreshold'][key1]){
                flTh = 0;
              } else{
                flTh = val;
              }
              $scope.curCsChart.yAxis.plotLines.push({
                startOnTick: true,
                dashStyle: 'line',
                color: '#ccccfc',
                endOnTick: true,
                tickInterval: 1,
                value: flTh,
                width: 1,
                label: {
                  style:{
                    fontStyle: '600',
                    color: 'red'
                  },
                  align: 'left',
                  zIndex: 555,
                  rotation: 0,
                  text: flTh,
                  y: -3,
                  x: 0
                }
              });
            });

            angular.forEach($scope.frameData, function(val, key1){
              $scope.seriesData.push({isOverLimit : val['isOverLimit'], color: val['color'], data: val['data'].map($scope.stringToDate)});
            });

            angular.forEach($scope.frameData, function(val, key){
              $scope.seriesData.push({isOverLimit : val['isOverLimit'], color: val['color'], name: val['name'], slot: val['slot'], data: val['data'], showInLegend: val['showInLegend'], frameHavingThreshold: item.frame['frameHavingThreshold'], thresholdValueOnFrame: item.frame['thresholdValueOnFrame'], usedSlotsWithNoThreshold: val['usedSlotsWithNoThreshold'], stack: val['stack']});
            });
            $scope.curCsChart.tooltip.followPointer = true;
            $scope.curCsChart.series = $scope.seriesData;

            // hide repeated legend
            var onLegendClick = function(event){
              var myname = this.name;
              var myvis = !this.visible;
              this.chart.series.forEach(function(elem){
                if(elem.name == myname){
                  elem.setVisible(myvis);
                }
              });
              return false;
            }

            $scope.curCsChart.series.forEach(function(serie){
              serie.events = {
                legendItemClick: onLegendClick
              }
            });
            $scope.csChartData.push({cfg:$scope.curCsChart, isEmpty:false});
          });
        } else{
          $scope.csChartData.push({isEmpty:true, title:$scope.data.data[d].name});
        }
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('hcPpChart', hcPpChart);

  /** @ngInject */
  function hcPpChart($http,$filter,ngDialog){
    return {
      restrict:'E',
      template:'<div></div>',
      scope:{
        chartFx:'=',
        data:'=',
        path:'=',
        date:'=',
        info:'=',
        localiz:'=',
        devices:'=',
        content:'=',
        deviceEmpty:'=',
        contentEmpty:'=',
        devicesCount:'=',
        contentIds:'=',
        index:'='
      },
      link:function($scope,element){
        $scope.chart = Highcharts.stockChart(element[0], {
          chart:{
            plotBorderWidth:1,
            type:'column',
            zoomType:'x',
            height:400
          },
          credits:{
          	enabled:false
          },
          title:{
            text:($scope.data.title == "Hour wise Proof of Play Report" ? $filter("translate")("r.label.14"):$scope.data.title == "Day wise Proof of Play Report" ?$filter("translate")("r.label.15"):$filter("translate")("r.label.16"))
          },
          xAxis:{
            title:{
              text:($scope.data.xAxisTitle == "Hours" ? $filter("translate")("r.label.17"):$scope.data.xAxisTitle == "Days" ?$filter("translate")("r.label.18"):$filter("translate")("r.label.19"))
            },
            labels:{
              enabled:true,
              formatter:function(){
                return $scope.data.categories[this.value];
              }
            },
            lineColor:'#ccc'
          },
          yAxis:{
            lineColor:'#ccc',
            tickColor:'#ccc',
            opposite:false,
            lineWidth:1,
            tickWidth:1,
            min:0,
            title:{
              text:$scope.localiz.sec, //$scope.localiz.sec, //"Seconds", //$scope.data.yAxisTitle
              x:-15
            },
            labels:{
              align:'left',
              x:-7,
              rotation:-90,
              formatter:function(){
                return Highcharts.numberFormat(this.value, 0,',',',');
              }
            },
          },
          legend:{
            backgroundColor:'#f8f8f8',
            verticalAlign:'top',
            layout:'vertical',
            align:'right',
            enabled:true,
            width:180,
            itemStyle:{
              textOverflow:"ellipsis",
              width:'150px',
            },
            y:30,
          },
          rangeSelector:{
            allButtonsEnabled:true,
            inputEnabled:false,
            enabled:false,
            selected:0
          },
          scrollbar:{
            liveRedraw:false,
            enabled:true
          },
          plotOptions:{
            column:{
              pointPadding:0.1,
              borderWidth:0
            },
            series:{
      				cursor:'pointer',
      				point:{
      					events:{
      						click:function(e){
                    if(($scope.devices.length > 0 && $scope.content.length == 0) || ($scope.devices.length != 1 && $scope.content.length > 0) || ($scope.devices.length > 0 && $scope.content.length > 0)){
                      $scope.seriesName = this.series.name;
                      //$scope.deviceName = this.series.name;
                      $scope.clickIndex = this.series.colorIndex;
                      for(var i=0; i<$scope.devices.length; i++){
                        if($scope.devices[i].l == $scope.seriesName){
                          $scope.selectedId = $scope.devices[i].id
                        }
                      }
                      for(var i=0; i<$scope.content.length; i++){
                        if($scope.content[i].label == $scope.seriesName){
                          $scope.selectedId = $scope.content[i].id
                        }
                      }
                      if($scope.devices.length){
                        $scope.allDeviceList = $scope.devices
                      } else{
                        $scope.allDeviceList = JSON.parse(localStorage.getItem('allDeviceData'));
                      }
                      $scope.curTime = new Date();
                      $scope.selectedPoint = this.category; //value of xAxis
                      $scope.info.dateRange = {
                        startDate:moment($scope.info.dateRange.startDate).format("L"),
                        endDate:moment($scope.info.dateRange.endDate).format("L")
                      }
                      $scope.cutData = {devices:$scope.allDeviceList ,info:{dateRange:$scope.info.dateRange, timeRangeType:$scope.info.timeRangeType, selectedPoint:$scope.selectedPoint, loopOpt:$scope.info.loopOpt, loopLength:$scope.info.loopLength, deviceEmpty:$scope.deviceEmpty, contentEmpty:$scope.contentEmpty}, cid:[], deviceName:$scope.seriesName, selectedId:$scope.selectedId};
                      localStorage.setItem("selectedPoint",$scope.selectedPoint);
                      localStorage.setItem("indexPP",$scope.index);
                      localStorage.setItem("selectedId",$scope.selectedId);
                      if($scope.contentIds.length > 0){
                        $scope.cutData.cid = $scope.contentIds;
                      }
                      $scope.cutData.info.sTime = moment($scope.info.sTime).format("HH:mm Z");
                      $scope.cutData.info.eTime = moment($scope.info.eTime).format("HH:mm Z");
                      $http.post($scope.path, $scope.cutData).success(function(data){
                        if(data.status != "error"){//&& data.length > 0
                          hs.align = "center";
                          hs.expandDuration = 0;
                          hs.restoreDuration = 0;
                          hs.dimmingOpacity = 0.7;
                          hs.allowMultipleInstances = false;
                          // var htmlTable = '<table border="0" class="table">';
                          // if(data.length == undefined){
                          //   if(data.macReport == true){
                          //     $scope.info.tableInfo.label = $scope.info.tableInfo.Devicelabel;
                          //   }
                          //   htmlTable += '<thead>\
                          //   <tr class="row th">\
                          //   <th >'+ $scope.info.tableInfo.label +'</th>\
                          //   <th class="text-right">'+ $scope.info.tableInfo.type +'</th>\
                          //   </tr>\
                          //   </thead><tbody>';
                          //   for(var key in data){
                          //     for(var key1 in data[key]){
                          //       htmlTable += '<tr class="row">\
                          //         <td class="word-break">' + key1 + '</td>\
                          //         <td class="text-right">' + data[key][key1] + '</td>\
                          //       </tr>';
                          //     }
                          //   }
                          // } else{
                          //   htmlTable += '<tr><td class="msg-warning noBdr" lang="{{auth.lang}}">'+ $scope.localiz.msg2 +'</td></tr>';
                          // }
                          // htmlTable += '</tbody></table>';


                          // // Create a new chart on Highslide popup open
                          // hs.htmlExpand(null, {
                          //   pageOrigin:{
                          //     x:e.pageX || e.clientX,
                          //     y:e.pageY || e.clientY
                          //   },
                          //   wrapperClassName:'draggable-header',
                          //   headingText:$scope.seriesName,
                          //   maincontentText:htmlTable,
                          //   width:"auto"
                          // });

                          $scope.ppHtml = '<div class="table table-scroll dTable" role="table">';
                          if(data.length == undefined){
                            if(data.macReport == true){
                              $scope.info.tableInfo.label = $scope.info.tableInfo.Devicelabel;
                            }
                            $scope.ppHtml += '<div class="row th">\
                                                <div class="col-xs-6">'+ $scope.info.tableInfo.label +'</div>\
                                                <div class="col-xs-6 text-right">'+ $scope.info.tableInfo.type +'</div>\
                                              </div>\
                                              <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(340)}}px">'
                            for(var key in data){
                              for(var key1 in data[key]){
                                $scope.ppHtml += '<div class="row">\
                                                <div class="col-xs-6">' + key1 + '</div>\
                                                <div class="col-xs-6 text-right">' + data[key][key1] + '</div>\
                                              </div>';
                              }
                            }
                            $scope.ppHtml += '</div>'
                          } else{
                            $scope.ppHtml += '<div class="msg-warning" lang="{{auth.lang}}">'+ $scope.localiz.msg2 +'</div>';
                          }
                          $scope.ppHtml += '</div>';
                          ngDialog.open({
                            template:'\
                            <section class="panel" role="dialog">\
                              <header class="panel-heading">\
                                <h1 role="heading" aria-level="1">{{"r.body.15" | translate}}</h1>\
                                <div class="pull-right bdrR">\
                                  <a href="" role="link" class="padL5 padR7 bdrR" uib-tooltip="{{\'cm.btn.17\' | translate}}" tooltip-append-to-body="true" ng-click="downloadXLSX($event)">\
                                    <span class="fa fa-download"></span>\
                                  </a>\
                                </div>\
                              </header>\
                              <div class="panel-body">'+$scope.ppHtml+'</div>\
                            </section>',
                            plain:true,
                            width:655,
                            scope:$scope,
                            closeByEscape:false,
                            closeByDocument:true,
                            className:"ngdialog-theme-default",
                          });
                        }
                      });
                    }
                  }
                }
              },
              marker:{
      					lineWidth:1
      				}
            }
          },
          tooltip:{
            shared:false,
            formatter:function(){
              var d = Number(this.y);
              var h = Math.floor(d / 3600);
              var m = Math.floor(d % 3600 / 60);
              var s = Math.floor(d % 3600 % 60);
              var hDisplay = (h>9?h:"0"+h);
              var mDisplay = (m>9?m:"0"+m);
              var sDisplay = (s>9?s:"0"+s);
              return '<div><span style="color:'+this.series.color+'">●</span> '+ this.series.name + ':<b>' + hDisplay + ":" + mDisplay + ":" + sDisplay + '</b></div>';
            },
            useHTML:true
          },
          navigator:{
            xAxis:{ // you are missing this level
              labels:{
                formatter:function(){
                  return this.value;
                }
              }
            }
          },
          series:$scope.data.data,
        });
        $scope.chartFx.chartReflow = function(){
          $scope.chart.reflow();
        }
        $scope.downloadXLSX = function(event){
          hs.downloadXLSX(event.target);
        }
        $scope.getAvailableHeight = function(deductableHeight){
          if(document.body && document.body.offsetWidth){
            $scope.winH = document.body.offsetHeight;
          }
          if(document.compatMode == 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth){
            $scope.winH = document.documentElement.offsetHeight;
          }
          if(window.innerWidth && window.innerHeight){
            $scope.winH = window.innerHeight;
          }
          $scope.winH = $scope.winH - deductableHeight;
          return $scope.winH;
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('hcHgChart', hcHgChart);

  /** @ngInject */
  function hcHgChart($http){
    return {
      restrict:'E',
      template:'<div></div>',
      scope:{
        chartFx:'=',
        data:'=',
        path:'=',
        date:'=',
        info:'=',
        localiz:'=',
        devices:'=',
        content:'=',
        deviceEmpty:'=',
        contentEmpty:'=',
        devicesCount:'=',
        contentIds:'='
      },
      link:function($scope, element){
        $scope.chart = Highcharts.stockChart(element[0], {
          chart:{
            plotBorderWidth:1,
            type:'column',
            zoomType:'x',
            height:400
          },
          credits:{
          	enabled:false
          },
          title:{
            text:$scope.data.title
          },
          xAxis:{
            title:{
              text:$scope.data.xAxisTitle
            },
            labels:{
              enabled:true,
              formatter:function(){
                return $scope.data.categories[this.value];
              }
            },
            lineColor:'#ccc'
          },
          yAxis:{
            lineColor:'#ccc',
            tickColor:'#ccc',
            opposite:false,
            lineWidth:1,
            tickWidth:1,
            min:0,
            title:{
              text:$scope.localiz.sec, //$scope.localiz.sec, //"Seconds", //$scope.data.yAxisTitle
              x:-15
            },
            labels:{
              align:'left',
              x:-7,
              rotation:-90,
              formatter:function(){
                return Highcharts.numberFormat(this.value, 0,',',',');
              }
            },
          },
          legend:{
            backgroundColor:'#f8f8f8',
            verticalAlign:'top',
            layout:'vertical',
            align:'right',
            enabled:true,
            width:180,
            y:30
          },
          rangeSelector:{
            allButtonsEnabled:true,
            inputEnabled:false,
            enabled:false,
            selected:0
          },
          scrollbar:{
            liveRedraw:false,
            enabled:true
          },
          plotOptions:{
            column:{
              pointPadding:0.1,
              borderWidth:0
            },
            series:{
      				cursor:'pointer',
      				point:{
      					events:{
      						click:function(e){
                    if(($scope.devices.length > 0 && $scope.content.length == 0) || ($scope.devices.length != 1 && $scope.content.length > 0)){
                      $scope.seriesName = this.series.name;
                      $scope.clickIndex = this.series.colorIndex;
                      $scope.curTime = new Date();
                      $scope.selectedPoint = this.category; //value of xAxis
                      $scope.info.dateRange = {
                        startDate:moment($scope.info.dateRange.startDate).format("L"),
                        endDate:moment($scope.info.dateRange.endDate).format("L")
                      }
                      $scope.cutData = {info:{dateRange:$scope.info.dateRange, timeRangeType:$scope.info.timeRangeType, selectedPoint:$scope.selectedPoint, loopOpt:$scope.info.loopOpt, loopLength:$scope.info.loopLength, deviceEmpty:$scope.deviceEmpty, contentEmpty:$scope.contentEmpty}, cid:[], deviceName:$scope.seriesName};
                      if($scope.contentIds.length > 0){
                        $scope.cutData.cid = $scope.contentIds;
                      }
                      $scope.cutData.info.sTime = moment($scope.info.sTime).format("HH:mm Z");
                      $scope.cutData.info.eTime = moment($scope.info.eTime).format("HH:mm Z");

                      $http.post($scope.path, $scope.cutData).success(function(data){
                        if(data.status != "error"){//&& data.length > 0
                          hs.align = "center";
                          hs.expandDuration = 0;
                          hs.restoreDuration = 0;
                          hs.dimmingOpacity = 0.7;
                          hs.allowMultipleInstances = false;
                          var htmlTable = '<table border="0" class="table">';
                          if(data.length == undefined){
                            htmlTable += '<thead>\
                              <tr class="row th">\
                                <th>'+ $scope.info.tableInfo.label +'</th>\
                                <th class="text-right">'+ $scope.info.tableInfo.type +'</th>\
                              </tr>\
                            </thead><tbody>';
                            for(var key in data){
                              for(var key1 in data[key]){
                                htmlTable += '<tr class="row">\
                                  <td class="word-break">' + key1 + '</td>\
                                  <td class="text-right">' + data[key][key1] + '</td>\
                                </tr>';
                              }
                            }
                          } else{
                            htmlTable += '<tr><td class="msg-warning noBdr" lang="{{auth.lang}}">'+ $scope.localiz.msg2 +'</td></tr>';
                          }
                          htmlTable += '</tbody></table>';
                          // Create a new chart on Highslide popup open
                          hs.htmlExpand(null, {
                            pageOrigin:{
                              x:e.pageX || e.clientX,
                              y:e.pageY || e.clientY
                            },
                            wrapperClassName:'draggable-header',
                            headingText:$scope.seriesName,
                            maincontentText:htmlTable,
                            width:"auto"
                          });
                        }
                      });
                    }
                  }
                }
              },
              marker:{
      					lineWidth:1
      				}
            }
          },
          tooltip:{
            shared:false,
            formatter:function(){
              var d = Number(this.y);
              var h = Math.floor(d / 3600);
              var m = Math.floor(d % 3600 / 60);
              var s = Math.floor(d % 3600 % 60);
              var hDisplay = (h>9?h:"0"+h);
              var mDisplay = (m>9?m:"0"+m);
              var sDisplay = (s>9?s:"0"+s);
              return '<div><span style="color:'+this.series.color+'">●</span> '+ this.series.name + ':<b>' + hDisplay + ":" + mDisplay + ":" + sDisplay + '</b></div>';
            },
            useHTML:true
          },
          navigator:{
            xAxis:{ // you are missing this level
              labels:{
                formatter:function(){
                  return this.value;
                }
              }
            }
          },
          series:$scope.data.data,
        });
        $scope.chartFx.chartReflow = function(){
          $scope.chart.reflow();
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('hcDsChart', hcDsChart);

  /** @ngInject */
  function hcDsChart($filter){
    return {
      restrict:'E',
      template:'<div></div>',
      scope:{
        chartFx:'=',
        data:'=',
        localiz:'='
      },
      
      link:function($scope, element){
        $scope.chart = Highcharts.stockChart(element[0], {
          chart:{
            type:'column',
            plotBorderWidth:1,
            height:400,
          },
          credits:{
          	enabled:false
          },
          title:{
            text:$filter("translate")("r.label.13")
          },
          xAxis:{
            title:{
              text:$scope.data.xAxisTitle
            },
            labels:{
              enabled:true,
              formatter:function(){
                return $scope.data.categories[this.value];
              }
            },
            lineColor:'#ccc',
          },

          yAxis:{
            opposite:false,
            lineColor:'#ccc',
            tickColor:'#ccc',
            lineWidth:1,
            tickWidth:1,
            min:0,
            title:{
              text:$scope.localiz.min, //"Minutes",//$scope.data.yAxisTitle
              x:-15,
            },
            labels:{
              x:-7,
              rotation:-90,
              align:'left',
              formatter:function(){
                return Highcharts.numberFormat(this.value, 0,',',',');
              }
            },
          },
          legend:{
            enabled:true
          },
          rangeSelector:{
            allButtonsEnabled:true,
            selected:0,
            inputEnabled:false,
            enabled:false
          },
          scrollbar:{
            enabled:true,
            liveRedraw:false
          },
          plotOptions:{
            column:{
              stacking:'normal',
              pointPadding:0.1,
              borderWidth:0
            },
            series:{
      				cursor:'pointer',
              marker:{
      					lineWidth:1
      				}
            }
          },
          tooltip:{
            shared:false,
            crosshairs:true,
            borderColor:"#cccccc",
            formatter:function(){
    					if(this.point != undefined){
                var tooltip = '';
                var tipSeries = '';
    						var stackSelected = this.point.series.options.stack;
    						var categorySelected = this.point.category;
    						tooltip = '<b>' + this.series.options.deviceName + '</b><br/>';
                
    						var ii = 0;
    						var total = 0;
    						$.each(this.series.chart.series, function(i, s){
    							if(s.options.stack == stackSelected){
    								$.each(s.data, function(j, point){
    									if(point != undefined && point.category == categorySelected && s.name != "Navigator 1" && s.name != "Navigator 2"){
                        if((s.name == "Off" && point.y > 0) || (s.name == "Offline" && point.y > 0) || (s.name == "Online" && point.y > 0) || (s.name == "No data" && point.y > 0)){
                          var min = $scope.localiz.min; //"minute";
                          if(point.y > 1){
                            min = $scope.localiz.mins; //"minutes";
                          }
                          if(s.name != "No data"){
                            tipSeries = '<svg class="tooltipPath marR5" role="img"><path d='+ JSON.stringify(this.series.userOptions.path) +' stroke='+ this.series.color +' stroke-width='+ this.series.color.strokeWidth +' fill='+ this.series.color +'></svg>'+ s.name +':<b>'+ Highcharts.numberFormat(point.y, 0,',',',') + '</b> '+ min +'<br>'+ tipSeries;
                          }else{
                            tipSeries = '<svg class="tooltipPath marR5" role="img"><path d='+ JSON.stringify(this.series.userOptions.path) +' stroke='+ this.series.color.stroke +' stroke-width='+ this.series.color.strokeWidth +' fill='+ this.series.color.color1 +'></svg>'+ s.name +':<b>'+ Highcharts.numberFormat(point.y, 0,',',',') + '</b> '+ min +'<br>'+ tipSeries;
                          }
                        }
    										ii++;
    										total = parseInt(total) + parseInt(point.y);
    									}
    								});
    							}
    						});
    						if(ii == 1 || ii == 0 || total == 0){
                  tipSeries = $scope.localiz.msg3 //'No data available'
                }
    						return tooltip+''+tipSeries;
    					}
    				},
            useHTML:true
          },
          // navigator:{
          //   enabled:true,
          //   xAxis:{ // you are missing this level
          //     labels:{
          //       formatter:function(){
          //         return this.value;
          //       }
          //     }
          //   }
          // },
          navigator: {
                enabled: true, // Enable the navigator
                height: 40, // Fix the height of the navigator
                maskFill: 'rgba(102, 102, 255, 0.3)', // Customize the mask fill
                handles: {
                    enabled: true // Enable handles for resizing
                },
                xAxis:{ // you are missing this level
                  labels:{
                    formatter:function(){
                      return this.value;
                    }
                  }
                },
                series: $scope.data.data
            },
          series:$scope.data.data
        });

        $scope.chartFx.chartReflow = function(){
          $scope.chart.reflow();
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('hcCsChart', hcCsChart);

  /** @ngInject */
  function hcCsChart(){
    return {
      restrict:'E',
      scope:{
        data:'=',
        localiz:'='
      },
      controller:'CSReportController',
      templateUrl:'app/reports/dir/tmpl/csChart.html',
    }
  }
})();
angular.module('hub').service('TwoFASrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.verifyTwoFA = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/twoFA", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.sendEmailTwoFA = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/twoFA/email", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logOut = function(obj){
    httpReq = $http.put($rootScope.apiHost + "auth/logoutWoServer", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('SignupSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.saveSingUp = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/signUp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
angular.module('hub').service('SetPassSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.checkLink = function(id){
    httpReq = $http.get($rootScope.apiHost + "trial/verify/"+id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setPass = function(obj){
    httpReq = $http.post($rootScope.apiHost + "trial/servers", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return(response.data);
  }
}]);
angular.module('hub').service('SelectServerSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.saveSelectServer = function(selectedData){
    httpReq = $http.post($rootScope.apiHost + "auth/selectserver", selectedData);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logOut = function(obj){
    httpReq = $http.put($rootScope.apiHost + "auth/logoutWoServer", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
angular.module('hub').service('ResetPassSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.checkLink = function(key){
    httpReq = $http.get($rootScope.apiHost + "auth/resetPassword?key="+key);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resetPass = function(obj){
    httpReq = $http.put($rootScope.apiHost + "auth/resetPassword", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return(response.data);
  }
}]);
angular.module('hub').service('LoginSrv', ['$http', '$q', '$rootScope', '$httpParamSerializer', function($http, $q, $rootScope, $httpParamSerializer){
  var httpReq;
  this.authenticate = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/login", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.resendEmail = function(uid){
    httpReq = $http.get($rootScope.apiHost + "auth/resendResetPwdMail/"+ uid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loginSSO = function(obj, type){
    if(type == "idaptive" || type == "saml"){
      var fd = new FormData();
      fd.append('SAMLResponse', obj.SAMLResponse);
      fd.append('RelayState', obj.RelayState);
      fd.append('type', obj.type);
      httpReq = $http.post($rootScope.apiHost + "callback/sso/"+ type +"/token", fd, {
        transformRequest:angular.identity,
        headers:{'Content-Type':undefined}
      })
    } else if(type == "google"){
      var queryString = $httpParamSerializer(obj);
      httpReq = $http.get($rootScope.apiHost + "callback/sso/"+ type +"/token?"+ queryString);
    }else{
      httpReq = $http.post($rootScope.apiHost + "callback/sso/"+ type +"/token", obj);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getFreeTrialLink = function(){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/aad/url/1/1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.freeTrialLogin = function(obj){
    httpReq = $http.post($rootScope.apiHost + "njyczdnm/trial/users?isAAD=isAAD&isSignIn=isSignIn", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.signInCallback = function(obj){
    httpReq = $http.post($rootScope.apiHost + "callback/saas/SignInCallback", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saasSubscribe = function(obj){
    httpReq = $http.post($rootScope.apiHost + "callback/saas/subscribe", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
angular.module('hub').service('LockSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.authenticate = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/unlock", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
angular.module('hub').service('ForgotPassSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.forgotPass = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/forgotPassword", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.showPass = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/showPassword", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.approveItem = function(obj){
    httpReq = $http.post($rootScope.apiHost + "auth/approve", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('TwoFAController', TwoFAController);

  /** @ngInject */
  function TwoFAController($log, $scope, $rootScope, $state, $cookies, $window, $http, $filter, $translate, $sce, Notification, LocalizationSrv, TwoFASrv){
    $scope.authProcessing = false;
    $scope.isEmailSent = false;
    $scope.selectedData = {};
    $scope.hasErr = false;
    $scope.code1 = null;
    $scope.errType = "";
    $scope.auth = {};
    $scope.authServer = angular.fromJson(localStorage.getItem("authServer"));
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    /*Localization*/
    $translate.use($scope.auth.lang);
    $scope.selectedData.token = $scope.auth.token;
    $scope.selectedData.uid = $scope.auth.uid;
    $scope.userName = $scope.auth.uname;
    // $scope.userImg = $scope.auth.uimg;
    $scope.userImg = {uImg:$scope.auth.uimg};
    $http.defaults.headers.common.Authorization = $scope.auth.token;

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.encryptFx = function(val){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(val);
    };

    $scope.curTwoFA = {userId:$scope.auth.uid, token:$scope.auth.token, otp:""};
    $scope.twoFAFx = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == "e"){
        $scope.emailProcessing = true;
        TwoFASrv.sendEmailTwoFA($scope.curTwoFA).then(
          function(data){
            $scope.emailProcessing = false;
            if(data.code == 6055){
              Notification.warning({message:$filter("translate")('ms.msg.31'), positionX:'center', replaceMessage:true});
              $scope.curTwoFA.code1 = data.code1;
              $scope.isEmailSent = true;
              localStorage.setItem("code1", data.code1);
            } else if(data.code == 6056){
              Notification.error({message:$filter("translate")('ms.msg.32'), positionX:'center', replaceMessage:true});
            }
          },
          function(err){
            $log.error(err);
            $scope.emailProcessing = false;
          }
        );
      } else{
        if($scope.curTwoFA.otp == ""){
          $scope.hasErr = true;
          $scope.errType = "empty";
        } else{
          $scope.authProcessing = true;
          $scope.code1 = localStorage.getItem("code1");
          if($scope.code1){
            $scope.curTwoFA.code1 = $scope.code1;
          }

          $scope.encTwoFA = angular.copy($scope.curTwoFA);

          // $scope.hubEnc = function(){
          //   $scope.otpEnc = $scope.auth.email+"|"+$scope.curTwoFA.otp;
          //   return btoa($scope.reverse($scope.otpEnc));
          // }
          // $scope.encTwoFA.otp = $scope.hubEnc();

          $scope.encTwoFA.otp = $scope.encryptFx($scope.curTwoFA.otp);

          TwoFASrv.verifyTwoFA($scope.encTwoFA).then(
            function(data){
              $scope.authProcessing = false;
              $scope.hasErr = false;
              if(data.code == 6054){
                $scope.hasErr = true;
                $scope.errType = "otp";
              } else if(data.code == 6053){
                $scope.auth.is2faCode = true;
                localStorage.setItem('auth', JSON.stringify($scope.auth));
                localStorage.removeItem("code1");
                if($scope.authServer.length > 1){
                  $state.go("selectServer");
                } else{
                  $state.go("hub.dashboard");
                }
              }
            },
            function(err){
              $log.error(err);
              $scope.authProcessing = false;
            }
          );
        }
      }
    }

    $rootScope.ssLogOutFx = function(){
      TwoFASrv.logOut({"token":$scope.auth.token});
      localStorage.removeItem("authServer");
      localStorage.removeItem("authLang");
      localStorage.removeItem("teamsApp");
      localStorage.removeItem("code1");
      //reset content library adv search state
      localStorage.removeItem("isAdvSearch");
      localStorage.removeItem("curFilterObj");
      localStorage.removeItem("isWidgetEdited");
      localStorage.removeItem("isActionOnContent");

      if($rootScope.sso){
        $scope.ssoLogoutURL = $sce.trustAsResourceUrl($rootScope.sso.logout_url);
      }
      // Remove all saved data from localStorage
      localStorage.clear();

      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != ""){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
    }

    $scope.connection = navigator.onLine;
    $window.addEventListener("offline", function(){
      $rootScope.$apply(function(){
        $scope.connection = false;
        $scope.isConnection = false;
        $scope.connectionFx();
      });
    }, false);
    $window.addEventListener("online", function(){
      $rootScope.$apply(function(){
        $scope.connection = true;
        if(!$scope.isConnection){
          Notification.clearAll();
        }
      });
    }, false);
    $scope.connectionFx = function(){
      Notification.error({message:$filter("translate")('cm.msg.27'), positionX:'center', delay:null, replaceMessage:true});
    }
    if(!$scope.connection){
      $scope.connectionFx();
    }
  }
})();

(function(){
  'use strict';
  angular
    .module('hub')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController($log, $rootScope, $scope, $state, $translate, $window, vcRecaptchaService, CommonSrv, SignupSrv){
    $scope.splCharRegExp = new RegExp("(?=.*[!@#$%&])", "gi");
    $scope.charRegExp = /(?=.*[a-z])(?=.*[A-Z])/; // new RegExp("(?=.*[a-z])", "gi");
    $scope.numRegExp = new RegExp("(?=.*[0-9])", "gi");
    $scope.pwdSplCharValid = false;
    $scope.pwdLengthValid = false;
    $scope.authProcessing = false;
    $scope.signupComplete = false;
    $scope.pwdCharValid = false;
    $scope.pwdNumValid = false;
    $scope.signupFail = false;
    $scope.pwdValid = false;
    $scope.hasErr = false;
    // $scope.loading = true;
    $scope.isDmbUser = "";
    $scope.errType = "";

    if($window.location.href.search("signup") > 0){
      $scope.domain = "https://" + $window.location.host + "/mb/#/";
    }

    // if(!$state.params.id){
    //   $scope.curLang = localStorage.getItem("loginLang");
    //   if($scope.curLang != "" && ($scope.curLang == "en" || $scope.curLang == "es" || $scope.curLang == "fr" || $scope.curLang == "hi")){
    //     $state.go("login", {id:$scope.curLang});
    //   } else{
    //     $state.go("login");
    //   }
    // }

    /*Localization*/
    // if($state.params.lang){
    //   if($state.params.lang == "es_ES"){
    //     $translate.use("es");
    //   } else if($state.params.lang == "fr_FR"){
    //     $translate.use("fr");
    //   } else if($state.params.lang == "hi_IN"){
    //     $translate.use("hi");
    //   } else{
    //     $translate.use("en");
    //   }
    //   $scope.loading = false;
    // }

    /*Localization Start*/
    $scope.isLang = false;
    $scope.curLang = "";
    document.body.classList.add('no-clickable');
    $scope.initLangFx = function(lang, showLoading){
      if(showLoading){
        localStorage.setItem("loginLang", lang);
        $translate.use("auth/"+ lang).then(function(){
          document.getElementById('awesome-loader').classList.add('awesome-loaded');
          document.getElementById('awesome-loader').classList.remove('awesome-loading');
          document.body.classList.remove('no-clickable');
        });
      } else{
        $translate.use(lang).then(function(){
          document.getElementById('awesome-loader').classList.add('awesome-loaded');
          document.getElementById('awesome-loader').classList.remove('awesome-loading');
          document.body.classList.remove('no-clickable');
        });
      }
    }

    $scope.findLangFx = function(data, lang){
      var result = data.find(function(item){
        return item.tag
          .toLowerCase()
          .split(',')
          .map(function(t){ return t.trim(); })
          .includes(lang.toLowerCase());
      });
      return result ? result.v : null;
    };

    $scope.getLangListFx = function(){
      document.getElementById('awesome-loader').classList.remove('hidden');
      document.getElementById('awesome-loader').classList.remove('awesome-loaded');
      document.getElementById('awesome-loader').classList.add('awesome-loading');
      CommonSrv.getLangList().then(
        function(data){
          $scope.langList = data;
          $scope.curLang = $scope.findLangFx($scope.langList, $state.params.lang);
          if($scope.curLang){
            $scope.isLang = true;
            // console.warn("Wow, I'm getting lang :)");
            $scope.initLangFx($scope.curLang, true);
          } else{
            // console.warn("Ohhh! lang not found :(");
            $scope.initLangFx("en_US");
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    if($state.params.lang){
      var curLang = $scope.findLangFx([{"v":"en_US", "tag":"en_US,en-us,en,us,enus"}], $state.params.lang);
      if(curLang){
        $scope.isLang = true;
        $scope.initLangFx("en_US");
      } else{
        $scope.getLangListFx();
      }
    } else{
      $scope.initLangFx("en_US");
    }
    /*Localization End*/

    $scope.signup = {fName:"", lName:"", pass:"", cPass:"", id:$state.params.id};

    $scope.showSignup = function(){
      $scope.authProcessing = false;
      $scope.signupComplete = false;
      $scope.signupFail = false;
    }

    $scope.pwdValidate = function(){
      if($scope.signup.pass.length >= 8){
        $scope.pwdLengthValid = true;
      } else{
        $scope.pwdLengthValid = false;
      }
      if($scope.charRegExp.test($scope.signup.pass)){
        $scope.pwdCharValid = true;
      } else{
        $scope.pwdCharValid = false;
      }
      if($scope.numRegExp.test($scope.signup.pass)){
        $scope.pwdNumValid = true;
      } else{
        $scope.pwdNumValid = false;
      }
      if($scope.splCharRegExp.test($scope.signup.pass)){
        $scope.pwdSplCharValid = true;
      } else{
        $scope.pwdSplCharValid = false;
      }
      if($scope.pwdLengthValid && $scope.pwdCharValid && $scope.pwdNumValid && $scope.pwdSplCharValid){
        $scope.pwdValid = true;
      } else{
        $scope.pwdValid = false;
      }
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.encryptFx = function(val){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(val);
    };

    $scope.signupFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.signup.fName == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#fName").focus();
      } else if($scope.signup.lName == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#lName").focus();
      }  else if($scope.signup.pass == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#nPassword").focus();
      }  else if($scope.signup.cPass == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#scpw").focus();
      } else if($scope.signup.pass != $scope.signup.cPass){
        $scope.errType = "cpass";
        $scope.hasErr = true;
        $("#scpw").focus();
      } else if(!$scope.pwdValid){
        $scope.errType = "invalid";
        $scope.hasErr = true;
        $("#invalid").focus();
      } else if(vcRecaptchaService.getResponse() == ""){
        $scope.errType = "reCaptcha";
        $scope.hasErr = true;
        $("#reCaptcha").focus();
      } else{
        $scope.signup.reCaptcha = vcRecaptchaService.getResponse();
        $scope.authProcessing = true;

        // $scope.encodePass = {pass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.signup.pass)), cPass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.signup.cPass))};
        // $scope.curInfo = {fName:angular.copy($scope.signup.fName), lName:angular.copy($scope.signup.lName), pass:$scope.encodePass.pass, cPass:$scope.encodePass.cPass, id:$scope.signup.id, reCaptcha:$scope.signup.reCaptcha};

        $scope.curInfo = {fName:angular.copy($scope.signup.fName), lName:angular.copy($scope.signup.lName), pass:$scope.encryptFx($scope.signup.pass), cPass:$scope.encryptFx($scope.signup.cPass), id:$scope.signup.id, reCaptcha:$scope.signup.reCaptcha};

        SignupSrv.saveSingUp($scope.curInfo).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code == 6005){
              $scope.errType = "cpass";
              $scope.hasErr = true;
            } else if(data.code == 6039){
              $scope.errType = "reCaptcha";
              $scope.hasErr = true;
            } else if(data.code == 6015){
              $scope.errType = "userExist";
              $scope.hasErr = true;
            } else if(data.code == 6016){
              $scope.signupComplete = true;
              $scope.isDmbUser = data.isDmbUser;
            } else{
              $scope.signupFail = true;
            }
          },
          function(err){
            $log.error(err);
            $scope.authProcessing = false;
            $scope.signupFail = true;
          }
        );
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ShowPasswordController', ShowPasswordController);

  /** @ngInject */
  function ShowPasswordController($log, $rootScope, $scope, $state, $translate, ngDialog, ForgotPassSrv){
    /*Localization*/
    $translate.use("en_US");
    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.decryptFx = function(val){
      var decrypt = new JSEncrypt();
      decrypt.setPrivateKey($scope.priKey);
      return decrypt.decrypt(val);
    };

    if($state.params.id){
      $scope.user = {id:$state.params.id, email:$state.params.email}
      $scope.pwdLoading = true;
      $scope.pwd = {};
      ForgotPassSrv.showPass($scope.user).then(
        function(data){
          $scope.pwdLoading = false;
          $scope.pwd = data;
          if($scope.pwd.code == 6021){
            // $scope.pwd.password = $scope.reverse(atob($scope.pwd.password)).split("|")[1];
            $scope.pwd.password = $scope.decryptFx($scope.pwd.password);
          }
        },
        function(err){
          $scope.pwdLoading = false;
          $log.error(err);
        }
      );
    } else{
      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != "" && ($scope.curLang == "en" || $scope.curLang == "es" || $scope.curLang == "fr" || $scope.curLang == "hi")){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
    }
  };
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SetPassController', SetPassController);

  /** @ngInject */
  function SetPassController($log, $rootScope, $scope, $state, $http, $cookies, $translate, $location, LocalizationSrv, LoginSrv, SetPassSrv){
    $scope.splCharRegExp = new RegExp("(?=.*[!@#$%&])", "gi");
    $scope.charRegExp = new RegExp("(?=.*[a-z])", "gi");
    $scope.numRegExp = new RegExp("(?=.*[0-9])", "gi");
    $scope.pwdSplCharValid = false;
    $scope.pwdLengthValid = false;
    $scope.pwdValid = false;
    $scope.isSetPass = false;
    $scope.pageLoading = true;

    $scope.credentials = {id:"", pass:"", cPass:"", url:window.location.href};
    $scope.hostURL = $location.protocol() + "://" + $location.host();

    /*Localization*/
    $translate.use("en_US");

    if($state.params.id){
      $scope.credentials.id = $state.params.id;
      $scope.isUserErr = false;
      SetPassSrv.checkLink($scope.credentials.id).then(
        function(data){
          $scope.pageLoading = false;
          if(data.code == 19005){
            $scope.isLinkValid = true;
            $scope.email = data.email;
          } else if(data.code == 1000){
            $scope.isLinkValid = false;
          } else if(data.code == 19002){
            $scope.isLinkValid = false;
            $scope.curLang = localStorage.getItem("loginLang");
            if($scope.curLang != "" && ($scope.curLang == "en" || $scope.curLang == "es" || $scope.curLang == "fr" || $scope.curLang == "hi")){
              $state.go("login", {id: $scope.curLang});
            } else{
              $state.go("login");
            }
          }
        }, function(err){
          $scope.pageLoading = false;
          $log.error(err);
        }
      );
    } else{
      $scope.isUserErr = true;
    }

    $scope.pwdValidate = function(){
      if($scope.credentials.pass && $scope.credentials.pass.length >= 8){
        $scope.pwdLengthValid = true;
      } else{
        $scope.pwdLengthValid = false;
      }
      if($scope.charRegExp.test($scope.credentials.pass)){
        $scope.pwdCharValid = true;
      } else{
        $scope.pwdCharValid = false;
      }
      if($scope.numRegExp.test($scope.credentials.pass)){
        $scope.pwdNumValid = true;
      } else{
        $scope.pwdNumValid = false;
      }
      if($scope.splCharRegExp.test($scope.credentials.pass)){
        $scope.pwdSplCharValid = true;
      } else{
        $scope.pwdSplCharValid = false;
      }
      if($scope.pwdLengthValid && $scope.pwdCharValid && $scope.pwdNumValid && $scope.pwdSplCharValid){
        $scope.pwdValid = true;
      } else{
        $scope.pwdValid = false;
      }
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.setPassFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.credentials.pass == ""){
        $scope.errType = "pass";
        $scope.hasErr = true;
        $("#pass").focus();
      } else if($scope.credentials.cPass == ""){
        $scope.errType = "cPass";
        $scope.hasErr = true;
        $("#cPass").focus();
      } else if($scope.credentials.pass != $scope.credentials.cPass){
        $scope.errType = "notMach";
        $scope.hasErr = true;
        $("#cPass").focus();
      } else if(!$scope.pwdValid){
        $scope.errType = "invalid";
        $scope.hasErr = true;
        $("#cPass").focus();
      } else{
        $scope.authProcessing = true;
        $scope.encodePass = {pass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.credentials.pass)), cPass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.credentials.cPass))};
        SetPassSrv.setPass({id:$scope.credentials.id, pass:$scope.encodePass.pass, cPass:$scope.encodePass.cPass, url:$scope.credentials.url}).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code == 19010){
              $scope.isSetPass = true;
              $scope.name = data.name;
              $scope.email = data.email;
            } else if(data.code == 19004){
              $scope.errType = "notMach";
              $scope.hasErr = true;
              $("#cPass").focus();
            }
          }, function(err){
            $log.error(err);
            $scope.authProcessing = false;
          }
        );
      }
		}

    $scope.authenticate = function(){
      $scope.authProcessing = true;
      $scope.hubEnc = function(){
        $scope.emailPass = $scope.email+"|"+$scope.credentials.pass;
        return btoa($scope.reverse($scope.emailPass));
      }

      LoginSrv.authenticate({email:$scope.email, pass:$scope.hubEnc()}).then(
        function(data){
          $scope.authProcessing = false;
          if(data.code && (data.code == 6009 || data.code == 6010)){
            $scope.errType = "noServer";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6048){
            $scope.errType = "block";
            $scope.hasErr = true;
            if(data.uid){
              $scope.uid = data.uid;
            }
          } else if(data.code && data.code == 6011){
            $scope.errType = "auth";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6041){
            $scope.errType = "itemNotAcce";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6049){
            $scope.errType = "lastAttem";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6061){
            $scope.errType = "userNotInSer";
            $scope.hasErr = true;
          } else{
            $scope.setInfoFx(data);
          }
        }, function(err){
          $scope.authProcessing = false;
          $scope.errType = "api";
          $scope.hasErr = true;
        }
      );
    }

    $scope.setInfoFx = function(data){
      $http.defaults.headers.common.Authorization = data.info.token;
      $scope.authServer = data.servers;
      $scope.auth = data.info;
      $scope.auth.is2faCode = false;
      $scope.redirect = data.redirect;

      localStorage.setItem('authServer', JSON.stringify($scope.authServer));
      localStorage.setItem('authLang', JSON.stringify($scope.auth.lang));
      $scope.auth.email = $scope.credentials.email;
      localStorage.setItem('auth', JSON.stringify($scope.auth));

      /*Localization*/
      LocalizationSrv.getLocalization($scope.auth.lang).then(
        function(data){
          localStorage.setItem("authLang", JSON.stringify($scope.auth.lang));
          localStorage.setItem("lang", JSON.stringify(data));
        },
        function(err){
          $log.error(err);
        }
      );
      if($scope.redirect && $scope.redirect.type == "queue"){
        $state.go("queue", {id:$scope.redirect.id});
      } else if($scope.auth.is2fa){
        $state.go("twoFA");
      } else if($scope.authServer.length > 1){
        $state.go("selectServer");
      } else{
        $state.go("hub.dashboard");
      }
    }
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('selectServerController', selectServerController);

  /** @ngInject */
  function selectServerController($log, $scope, $rootScope, $state, $cookies, $window, $http, $filter, $translate, $sce, $timeout, Notification, SelectServerSrv, DexieSrv, CommonSrv){
    $scope.authProcessing = false;
    $scope.selectedData = {};
    $scope.authServer = {};
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.auth = {};

    $scope.authServer = angular.fromJson(localStorage.getItem("authServer"));
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));

    if($scope.auth.theme){
      $rootScope.myTheme.theme = $scope.auth.theme;
      $(".mobiContainer").addClass($scope.auth.theme);
    } else{
      $rootScope.myTheme.theme = $scope.auth.upreferences.theme;
      $(".mobiContainer").addClass($scope.auth.upreferences.theme);
    }


    /*Localization Start*/
    $scope.authLang = angular.fromJson(localStorage.getItem("authLang"));
    $scope.initLangFx = function(lang){
      document.body.classList.add('no-clickable');
      if(lang != "en_US"){
        document.getElementById('awesome-loader').classList.remove('hidden');
        document.getElementById('awesome-loader').classList.remove('awesome-loaded');
        document.getElementById('awesome-loader').classList.add('awesome-loading');
      }
      $translate.use(lang).then(function(){
        document.getElementById('awesome-loader').classList.add('awesome-loaded');
        document.getElementById('awesome-loader').classList.remove('awesome-loading');
        document.body.classList.remove('no-clickable');
      });
    }
    
    if($scope.authLang){
      $scope.initLangFx($scope.authLang);
    } else{
      $scope.initLangFx("en_US");
    }
    /*Localization End*/

    $scope.selectedData.token = $scope.auth.token;
    $scope.selectedData.uid = $scope.auth.uid;
    $scope.serverList = $filter("orderBy")($scope.authServer, 'label');
    $scope.userName = $scope.auth.uname;
    // $scope.userImg = $scope.auth.uimg;
    $scope.userImg = {uImg:$scope.auth.uimg};

    $http.defaults.headers.common.Authorization = $scope.auth.token;

    if($scope.authServer.length > 1){
      if($scope.auth.server == undefined){
        $scope.selectedServer = $scope.serverList[0];;
      } else{
        angular.forEach($scope.authServer, function(server){
          if($scope.auth.server == server.id){
            $scope.selectedServer = server;
          }
        });
      }
    }

    $scope.ss = {isOpen:false};
    $scope.selectServerFx = function(selected, $event){
      $scope.selectedServer = selected;
      $scope.ss.isOpen = !$scope.ss.isOpen;
    }

    $scope.serverSearchFocus = function(){
      if($scope.authServer.length > 1){
        angular.element(document).find(".searchTbx.input-xs").children()[0].focus();
      }
    }
    $scope.toggleCallback= function(open){
      $scope.searchSList = "";
    }

    $scope.gotoDashboard = function(){
      $scope.authProcessing = true;
      $scope.hasErr = false;
      $scope.selectedData.sid = $scope.selectedServer.id;
      SelectServerSrv.saveSelectServer($scope.selectedData).then(
        function(data){
          $http.defaults.headers.common.Authorization = data.info.token;
          $scope.authServer = data.servers;
          $scope.auth = data.info;

          localStorage.removeItem("authServer");
          localStorage.removeItem('auth');
          localStorage.setItem('auth', JSON.stringify($scope.auth));
          localStorage.setItem("authServer", JSON.stringify($scope.authServer));
          localStorage.removeItem("pageStatus");
          localStorage.removeItem("filterType");
          localStorage.removeItem("advSearchOpen");
          localStorage.removeItem("dTotalCount");

          /*Localization*/
          $scope.auth = angular.fromJson(localStorage.getItem("auth"));
          $scope.lang = angular.fromJson(localStorage.getItem("lang"));
          $state.go('hub.dashboard');
          // $timeout(function(){
          //   $window.location.reload();
          // }, 500);
        }, function(err){
          $scope.authProcessing = false;
          $scope.hasErr = true;
          $scope.errType = "api";
        }
      )
    };

    $rootScope.ssLogOutFx = function(){
      SelectServerSrv.logOut({"token":$scope.auth.token});
      localStorage.removeItem("authServer");
      localStorage.removeItem("authLang");
      localStorage.removeItem("teamsApp");
      //reset content library adv search state
      localStorage.removeItem("isAdvSearch");
      localStorage.removeItem("curFilterObj");
      localStorage.removeItem("isWidgetEdited");
      localStorage.removeItem("isActionOnContent");
      if($rootScope.sso){/**For SSO*/
        $scope.ssoLogoutURL = $sce.trustAsResourceUrl($rootScope.sso.logout_url);
        $timeout(function(){
          // Remove all saved data from localStorage
          localStorage.clear();
          $scope.curLang = localStorage.getItem("loginLang");
          if($scope.curLang != ""){
            $state.go("login", {id:$scope.curLang});
          } else{
            $window.location.reload();
          }
        }, 1000);
      } else{
        // Remove all saved data from localStorage
        localStorage.clear();
        $scope.curLang = localStorage.getItem("loginLang");
        if($scope.curLang != ""){
          $state.go("login", {id:$scope.curLang});
        } else{
          $state.go("login");
        }
      }
    }
    $scope.connection = navigator.onLine;
    $window.addEventListener("offline", function(){
      $rootScope.$apply(function(){
        $scope.connection = false;
        $scope.isConnection = false;
        $scope.connectionFx();
      });
    }, false);
    $window.addEventListener("online", function(){
      $rootScope.$apply(function(){
        $scope.connection = true;
        if(!$scope.isConnection){
          Notification.clearAll();
        }
      });
    }, false);
    $scope.connectionFx = function(){
      Notification.error({message:$filter("translate")('cm.msg.27'), positionX:'center', delay:null, replaceMessage:true});
    }
    if(!$scope.connection){
      $scope.connectionFx();
    }


    /* IDB Start */
    // Remove all saved data from IndexedDB.
    DexieSrv.clearData().then(function(){
      // console.log('Database cleared');
    });


    // var dbArr = ["scu"];
    // var dbCount = 0;

    // function deleteAllDB(){
    //   if(dbCount < dbArr.length){
    //     deleteDatabase(dbArr[dbCount]);
    //   } else{
    //     console.log("All databases deleted successfully!");
    //   }
    // }

    // function deleteDatabase(dbName){
    //   var request = window.indexedDB.deleteDatabase(dbName);
    //   request.onsuccess = function(event){
    //     console.log("Database ", dbName, " deleted successfully");
    //     dbCount++;
    //     deleteAllDB();
    //   };
    //   request.onerror = function(event){
    //     console.error("Failed to delete database ", dbName, ", ", event);
    //   };
    //   request.onblocked = function(event){
    //     console.warn("Delete operation is blocked for database ", dbName ,", ", event);
    //   };
    // }
    // deleteAllDB();

    /* IDB End */

    // $scope.openSupport = function(){
    //   $scope.iframeUrl = "https://lsquared-2347217.hs-sites.com/chatbot-landing-page"
    //   $("#chatBtn").addClass("chatBtn-launcher");
    //   $("#supportPage").addClass("transitionSupportPage");
    //   $("#closebtn").addClass("transitionCloseBtn");
    //   $("#iframeId").addClass("iframePage");
    //   $("#closebtn").removeClass("gzfPCr");
    //   $("#openSupport").removeClass("bwsciD");
    //   $("#closebtn").addClass("dsOmqW");
    //   $("#openSupport").addClass("RGfWb");
    //   document.querySelector(".supportBtn").style.display = "none";
    //   document.querySelector(".supportCloseBtn").style.display = "block";
    // }

    // $scope.closwSupportPage = function(){
    //   $scope.iframeUrl = ""
    //   $("#chatBtn").removeClass("chatBtn-launcher");
    //   $("#chatBtn").addClass("chatBtn-launcher");
    //   $("#supportPage").removeClass("transitionSupportPage");
    //   $("#closebtn").removeClass("transitionCloseBtn");
    //   $("#closebtn").removeClass("dsOmqW");
    //   $("#openSupport").removeClass("RGfWb");
    //   $("#closebtn").addClass("gzfPCr");
    //   $("#openSupport").addClass("bwsciD");
    //   document.querySelector(".supportCloseBtn").style.display = "none";
    //   document.querySelector(".supportBtn").style.display = "block";
    // }

    // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };
  }
})();
(function(){
    'use strict';

    angular
      .module('hub')
      .controller('SaaSSubscribeController', SaaSSubscribeController);

    /** @ngInject */
    function SaaSSubscribeController($log, $scope, $rootScope, $state, $cookies, $window, $http, Notification, vcRecaptchaService, LocalizationSrv, SelectServerSrv, LoginSrv){
      $scope.splCharRegExp = new RegExp("(?=.*[!@#$%&])", "gi");
      $scope.charRegExp = new RegExp("(?=.*[a-z])", "gi");
      $scope.numRegExp = new RegExp("(?=.*[0-9])", "gi");

      $scope.authProcessing = false;
      $scope.selectedData = {};
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.saas = {};
      $scope.saas = angular.fromJson(localStorage.getItem("saasData"));

      $scope.reverse = function(s){
        $scope.reverseStr = "";
        for(var i = s.length - 1; i >= 0; i--)
          $scope.reverseStr += s[i];
        return $scope.reverseStr;
      }


      $scope.setInfoFx = function(data){
        $http.defaults.headers.common.Authorization = data.info.token;
        $scope.authServer = data.servers;
        $scope.auth = data.info;
        $scope.auth.is2faCode = false;
        $scope.redirect = data.redirect;

        localStorage.setItem('authServer', JSON.stringify($scope.authServer));
        localStorage.setItem('authLang', JSON.stringify($scope.auth.lang));
        $scope.auth.email = $scope.saas.email;
        localStorage.setItem('auth', JSON.stringify($scope.auth));

        /*Localization*/
        LocalizationSrv.getLocalization($scope.auth.lang).then(
          function(data){
            localStorage.setItem("authLang", JSON.stringify($scope.auth.lang));
            localStorage.setItem("lang", JSON.stringify(data));
          },
          function(err){
            $log.error(err);
          }
        );
        if($scope.redirect && $scope.redirect.type == "queue"){
          $state.go("queue", {id:$scope.redirect.id});
        } else if($scope.auth.is2fa){
          $state.go("twoFA");
        } else if($scope.authServer.length > 1){
          $state.go("selectServer");
        } else{
          $state.go("hub.dashboard");
        }
      }

      $scope.showSignup = function(){
        $scope.authProcessing = false;
        $scope.signupComplete = false;
        $scope.signupFail = false;
      }

      $scope.signupFx = function(){
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.saas.fName == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#fn").focus();
        } else if($scope.saas.lName == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#ln").focus();
        } else if($scope.saas.pass == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#pass").focus();
        } else if($scope.saas.cPass == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#cpw").focus();
        } else if($scope.saas.pass != $scope.saas.cPass){
          $scope.errType = "cpass";
          $scope.hasErr = true;
          $("#cpw").focus();
        } else if(!$scope.pwdValid){
          $scope.errType = "invalid";
          $scope.hasErr = true;
          $("#cpw").focus();
        } else if(vcRecaptchaService.getResponse() == ""){
          $scope.errType = "reCaptcha";
          $scope.hasErr = true;
        } else{
          $scope.saas.reCaptcha = vcRecaptchaService.getResponse();
          $scope.authProcessing = true;

          $scope.saasData = angular.copy($scope.saas);

          $scope.encodePass = {pass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.saas.pass)), cPass:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.saas.cPass))};
          $scope.saasData.pass = $scope.encodePass.pass;
          $scope.saasData.cPass = $scope.encodePass.cPass;

          LoginSrv.saasSubscribe($scope.saasData).then(
            function(data){
              $scope.authProcessing = false;
              if(data.code == 6005){
                $scope.errType = "cpass";
                $scope.hasErr = true;
                $("#cpw").focus();
              } else if(data.code == 6039){
                $scope.errType = "reCaptcha";
                $scope.hasErr = true;
              } else if(data.code == 6015){
                $scope.errType = "userExist";
                $scope.hasErr = true;
              } else if(data.code == 6016){
                $scope.signupComplete = true;
              } else{
                $scope.signupFail = true;
              }
              if(data.status !== "error"){
                $scope.signupComplete = true;
                $scope.setInfoFx(data);
              }
            },
            function(err){
              $log.error(err);
              $scope.authProcessing = false;
              $scope.signupFail = true;
            }
          );
        }
      }

      $scope.pwdValidate = function(){
        if($scope.saas.pass.length >= 8){
          $scope.pwdLengthValid = true;
        } else{
          $scope.pwdLengthValid = false;
        }
        if($scope.charRegExp.test($scope.saas.pass)){
          $scope.pwdCharValid = true;
        } else{
          $scope.pwdCharValid = false;
        }
        if($scope.numRegExp.test($scope.saas.pass)){
          $scope.pwdNumValid = true;
        } else{
          $scope.pwdNumValid = false;
        }
        if($scope.splCharRegExp.test($scope.saas.pass)){
          $scope.pwdSplCharValid = true;
        } else{
          $scope.pwdSplCharValid = false;
        }
        if($scope.pwdLengthValid && $scope.pwdCharValid && $scope.pwdNumValid && $scope.pwdSplCharValid){
          $scope.pwdValid = true;
        } else{
          $scope.pwdValid = false;
        }
      }

      $scope.connection = navigator.onLine;
      $window.addEventListener("offline", function(){
        $rootScope.$apply(function(){
          $scope.connection = false;
          $scope.isConnection = false;
          $scope.connectionFx();
        });
      }, false);
      $window.addEventListener("online", function(){
        $rootScope.$apply(function(){
          $scope.connection = true;
          if(!$scope.isConnection){
            Notification.clearAll();
          }
        });
      }, false);
      $scope.connectionFx = function(){
        Notification.error({message:'No Internet found. Please check your connection.', positionX:'center', delay:null, replaceMessage:true});
      }
      if(!$scope.connection){
        $scope.connectionFx();
      }
    }
  })();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ResetPassController', ResetPassController);

  /** @ngInject */
  function ResetPassController($log, $rootScope, $scope, $state, $translate, $location, ngDialog, vcRecaptchaService, ResetPassSrv){
    $scope.splCharRegExp = new RegExp("(?=.*[!@#$%&])", "gi");
    $scope.charRegExp = /(?=.*[a-z])(?=.*[A-Z])/; // new RegExp("(?=.*[a-z])", "gi");
    $scope.numRegExp = new RegExp("(?=.*[0-9])", "gi");
    $scope.pwdSplCharValid = false;
    $scope.pwdLengthValid = false;
    $scope.pwdValid = false;
    $scope.isReset = false;
    $scope.pageLoading = true;

    $scope.credentials = {nPass:"", cPass:"", reCaptcha:""};
    $scope.urlType = $location.search().p;
    $scope.hostURL = $location.protocol() + "://" + $location.host();

    /*Localization*/
    $translate.use("en_US");
    if($state.params.id){
      $scope.credentials.key = $state.params.id;
      $scope.isUserErr = false;
      ResetPassSrv.checkLink($scope.credentials.key).then(
        function(data){
          $scope.pageLoading = false;
          if(data.code == 6050){
            $scope.isLinkValid = false;
          } else if(data.code == 1000){
            $scope.isLinkValid = false;
          } else{
            $scope.isLinkValid = true;
          }
        }, function(err){
          $scope.pageLoading = false;
          $log.error(err);
        }
      );
    } else{
      $scope.isUserErr = true;
    }

    $scope.pwdValidate = function(){
      if($scope.credentials.nPass.length >= 8){
        $scope.pwdLengthValid = true;
      } else{
        $scope.pwdLengthValid = false;
      }
      if($scope.charRegExp.test($scope.credentials.nPass)){
        $scope.pwdCharValid = true;
      } else{
        $scope.pwdCharValid = false;
      }
      if($scope.numRegExp.test($scope.credentials.nPass)){
        $scope.pwdNumValid = true;
      } else{
        $scope.pwdNumValid = false;
      }
      if($scope.splCharRegExp.test($scope.credentials.nPass)){
        $scope.pwdSplCharValid = true;
      } else{
        $scope.pwdSplCharValid = false;
      }
      if($scope.pwdLengthValid && $scope.pwdCharValid && $scope.pwdNumValid && $scope.pwdSplCharValid){
        $scope.pwdValid = true;
      } else{
        $scope.pwdValid = false;
      }
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.encryptFx = function(val){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(val);
    };

    $scope.resetPassFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.credentials.nPass == ""){
        $scope.errType = "nPass";
        $scope.hasErr = true;
        $("#password").focus();
      } else if($scope.credentials.cPass == ""){
        $scope.errType = "cPass";
        $scope.hasErr = true;
        $("#cPassword").focus();
      } else if($scope.credentials.nPass != $scope.credentials.cPass){
        $scope.errType = "notMach";
        $scope.hasErr = true;
        $("#cPassword").focus();
      } else if(!$scope.pwdValid){
        $scope.errType = "invalid";
        $scope.hasErr = true;
        $("#password").focus();
      } else if(vcRecaptchaService.getResponse() == ""){
        $scope.errType = "reCaptcha";
        $scope.hasErr = true;
      } else{
        $scope.credentials.reCaptcha = vcRecaptchaService.getResponse();
        $scope.authProcessing = true;

        // $scope.encodePass = {c:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.credentials.cPass)), n:btoa($scope.reverse("noAnyEmai@here.com|"+$scope.credentials.nPass))};
        // ResetPassSrv.resetPass({cPass:$scope.encodePass.c, nPass:$scope.encodePass.n, key:$scope.credentials.key, reCaptcha:$scope.credentials.reCaptcha}).then(

        ResetPassSrv.resetPass({cPass:$scope.encryptFx($scope.credentials.cPass), nPass:$scope.encryptFx($scope.credentials.nPass), key:$scope.credentials.key, reCaptcha:$scope.credentials.reCaptcha}).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code == 6051){
              $scope.isReset = true;
            } else if(data.code == 6050){

            }
          }, function(err){
            $log.error(err);
            $scope.authProcessing = false;
          }
        );
      }
		}
  };
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('LSController', LSController);

  /** @ngInject */
  function LSController($log, $scope, $state, $window, $translate, $interval){

    /*Localization*/
    $scope.curLang = localStorage.getItem("loginLang");
    if($scope.curLang != ""){
      if($scope.curLang == "es"){
        $translate.use("es");
      } else if($scope.curLang == "fr"){
        $translate.use("fr");
      } else if($scope.curLang == "hi"){
        $translate.use("hi");
      } else{
        $translate.use("en_US");
      }
    } else{
      $translate.use("en_US");
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, $scope, $rootScope, $state, $http, $cookies, $translate, $location, $window, $sce, LoginSrv, CommonSrv){
    $scope.authProcessing = false;
    $scope.checkSaaS = false;
    $scope.credentials = {};
    $scope.authServer = [];
    $scope.checkSSO = true;
    $scope.saasErr = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.auth = [];

    /*Localization Start*/
    $scope.isLang = false;
    $scope.curLang = "";
    document.body.classList.add('no-clickable');
    $scope.initLangFx = function(lang, showLoading){
      if(showLoading){
        localStorage.setItem("loginLang", lang);
        $translate.use("auth/"+ lang).then(function(){
          document.getElementById('awesome-loader').classList.add('awesome-loaded');
          document.getElementById('awesome-loader').classList.remove('awesome-loading');
          document.body.classList.remove('no-clickable');
        });
      } else{
        $translate.use(lang).then(function(){
          document.getElementById('awesome-loader').classList.add('awesome-loaded');
          document.getElementById('awesome-loader').classList.remove('awesome-loading');
          document.body.classList.remove('no-clickable');
        });
      }
    }

    $scope.findLangFx = function(data, lang){
      var result = data.find(function(item){
        return item.tag
          .toLowerCase()
          .split(',')
          .map(function(t){ return t.trim(); })
          .includes(lang.toLowerCase());
      });
      return result ? result.v : null;
    };

    $scope.getLangListFx = function(){
      document.getElementById('awesome-loader').classList.remove('hidden');
      document.getElementById('awesome-loader').classList.remove('awesome-loaded');
      document.getElementById('awesome-loader').classList.add('awesome-loading');
      CommonSrv.getLangList().then(
        function(data){
          $scope.langList = data;
          $scope.curLang = $scope.findLangFx($scope.langList, $state.params.id);
          if($scope.curLang){
            $scope.isLang = true;
            // console.warn("Wow, I'm getting lang :)");
            $scope.initLangFx($scope.curLang, true);
          } else{
            // console.warn("Ohhh! lang not found :(");
            if(angular.isUndefined($rootScope.sso) || ($rootScope.sso && $rootScope.sso.type != "azure" && $rootScope.sso.type != "okta" && $rootScope.sso.type != "idaptive" && $rootScope.sso.type != "saml")){
              $location.url('/');
            }
            $scope.initLangFx("en_US");
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    if($state.params.id){
      var curLang = $scope.findLangFx([{"v":"en_US", "tag":"en_US,en-us,en,us,enus"}], $state.params.id);
      if(curLang){
        $scope.isLang = true;
        $scope.initLangFx("en_US");
      } else{
        $scope.getLangListFx();
      }
    } else{
      $scope.initLangFx("en_US");
    }
    /*Localization End*/


    if($state.params.id == "SaaSSignInCallback"){
      $scope.checkSaaS = true;
      LoginSrv.signInCallback($location.search()).then(
        function(data){
          if(data.code && (data.code == 6009 || data.code == 6010)){
            $scope.saasErr = true;
            $scope.errType = "noServer";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6048){
            $scope.errType = "block";
            $scope.hasErr = true;
            if(data.uid){
              $scope.uid = data.uid;
            }
          } else if(data.code && data.code == 6011){
            $scope.errType = "auth";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6041){
            $scope.errType = "itemNotAcce";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6049){
            $scope.errType = "lastAttem";
            $scope.hasErr = true;
          } else if(data.code && data.code == 6061){
            $scope.errType = "userNotInSer";
            $scope.hasErr = true;
          }
          if(data.servers){
            $http.defaults.headers.common.Authorization = data.info.token;
            $scope.authServer = data.servers;
            $scope.auth = data.info;
            $scope.auth.lang = JSON.stringify($state.params.lang);
            $scope.auth.is2faCode = false;
            $scope.redirect = data.redirect;

            localStorage.setItem('authServer', JSON.stringify($scope.authServer));
            localStorage.setItem('authLang', JSON.stringify($scope.auth.lang));
            $scope.auth.email = $scope.credentials.email;
            localStorage.setItem('auth', JSON.stringify($scope.auth));

            if($scope.redirect && $scope.redirect.type == "queue"){
              $scope.checkSaaS = false;
              $state.go("queue", {id:$scope.redirect.id});
            } else if($scope.auth.is2fa){
              $scope.checkSaaS = false;
              $state.go("twoFA");
            } else if($scope.authServer.length > 1){
              $state.go("selectServer");
            } else{
              $state.go("hub.dashboard");
            }

          } else if(data.status == "success"){
            localStorage.setItem('saasData', JSON.stringify(data.data));
            $state.go('SaaSSubscribe');
          }
        }, function(err){
          $scope.authProcessing = false;
        }
      );
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.encryptFx = function(val){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(val);
    };


    $scope.authenticate = function(caller){
      if(caller == "ft"){
        $scope.ftProcessing = true;
        LoginSrv.getFreeTrialLink().then(
          function(data){
            $scope.ftProcessing = false;
            $window.open(data.url, "_self");
          }, function(err){
            $scope.ftProcessing = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
        return;
      }

      $scope.authProcessing = false;
      $scope.hasErr = false;
      if(!$scope.credentials.email || $scope.credentials.email == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#email").focus();
      } else if(!$scope.credentials.pass || $scope.credentials.pass == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#password").focus();
      } else{
        if($state.params.id && $state.params.id != "azureSignInCallback"){
          $scope.credentials.id = $state.params.id;
        }
        $scope.hubEnc = function(){
          $scope.emailPass = $scope.credentials.email+"|"+$scope.credentials.pass;
          return btoa($scope.reverse($scope.emailPass));
        }

        /*Localization Start*/
        if($state.params.id && $scope.isLang){
          delete $scope.credentials.id;
        }
        /*Localization End*/

        $scope.authProcessing = true;

        // LoginSrv.authenticate({email:$scope.credentials.email, pass:$scope.hubEnc(), id:$scope.credentials.id}).then(
        LoginSrv.authenticate({email:$scope.credentials.email, pass:$scope.encryptFx($scope.credentials.pass), id:$scope.credentials.id}).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code && (data.code == 6009 || data.code == 6010)){
              $scope.errType = "noServer";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6048){
              $scope.errType = "block";
              $scope.hasErr = true;
              if(data.uid){
                $scope.uid = data.uid;
              }
            } else if(data.code && data.code == 6011){
              $scope.errType = "auth";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6041){
              $scope.errType = "itemNotAcce";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6049){
              $scope.errType = "lastAttem";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6061){
              $scope.errType = "userNotInSer";
              $scope.hasErr = true;
            } else{
              $scope.setInfoFx(data);
            }
          }, function(err){
            $scope.authProcessing = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    }

    $scope.setInfoFx = function(data){
      $http.defaults.headers.common.Authorization = data.info.token;
      $scope.authServer = data.servers;
      $scope.auth = data.info;
      $scope.auth.is2faCode = false;
      $scope.redirect = data.redirect;


      localStorage.setItem('authServer', JSON.stringify($scope.authServer));
      localStorage.setItem('authLang', JSON.stringify($scope.auth.lang));
      $scope.auth.email = $scope.credentials.email;
      localStorage.setItem('auth', JSON.stringify($scope.auth));


      if($scope.redirect && $scope.redirect.type == "queue"){
        $state.go("queue", {id:$scope.redirect.id});
      } else if($scope.auth.is2fa){
        $state.go("twoFA");
      } else if($scope.authServer.length > 1){
        $rootScope.myTheme.theme = $scope.auth.theme;
        $(".mobiContainer").addClass($scope.auth.theme);
        $state.go("selectServer");
      } else{
        $rootScope.myTheme.theme = $scope.auth.theme;
        $(".mobiContainer").addClass($scope.auth.theme);
        $state.go("hub.dashboard");
      }
    }

    $scope.resendFx = function(){
      LoginSrv.resendEmail($scope.uid).then(
        function(data){
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.freeTrailLogin = false;
    if($window.location.host == $rootScope.locationHost){
      $scope.freeTrailLogin = true;
      if($state.params.id == "msal"){
        $scope.authenticate("ft");
      }

      if($state.params.id == "azureSignInCallback"){
        $scope.isSsoAuth = true;
        var absUrl = $location.absUrl();
        LoginSrv.freeTrialLogin($location.search()).then(
          function(data){
            $scope.authProcessing = false;
            $scope.isSsoAuth = false;
            if(data.status == "error"){
            }
            if(data.code && (data.code == 6009 || data.code == 6010)){
              $scope.errType = "noServer";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6048){
              $scope.errType = "block";
              $scope.hasErr = true;
              if(data.uid){
                $scope.uid = data.uid;
              }
            } else if(data.code && data.code == 6011){
              $scope.errType = "auth";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6041){
              $scope.errType = "itemNotAcce";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6049){
              $scope.errType = "lastAttem";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6061){
              $scope.errType = "userNotInSer";
              $scope.hasErr = true;
            } else if(data.code && data.code == 4004){
              $scope.errType = "uNotFound";
              $scope.hasErr = true;
            } else if(data.status !== "error"){
              $scope.isSsoAuth = true;
              $scope.setInfoFx(data);
              localStorage.setItem('msal', true);
            }
          }, function(err){
            $scope.authProcessing = false;
          }
        );
      }
    }

    /**For SSO*/
    $scope.loginSSOFx = function(){
      $scope.authProcessing = true;
      if($rootScope.sso.type == "okta"){
        setTimeout(function(){
          $window.open($rootScope.sso.sso_url, "_self");
        }, 50);
      } else if($rootScope.sso.type == "azure"){
        setTimeout(function(){
          $window.open($rootScope.sso.sso_url, "_self");
        }, 1000);
      } else if($rootScope.sso.type == "idaptive"){
        setTimeout(function(){
          $window.open($rootScope.sso.sso_url, "_self");
        }, 1000);
      } else if($rootScope.sso.type == "saml"){
        setTimeout(function(){
          $window.open($rootScope.sso.sso_url, "_self");
        }, 1000);
      } else if($rootScope.sso.type == "google"){
        setTimeout(function(){
          $window.open($rootScope.sso.sso_url, "_self");
        }, 1000);
      }
    }
    if($rootScope.sso){
      $scope.ssoLogoutURL = null;
      $scope.isSsoAuth = false;
      $scope.checkSSO = false;
      var absUrl = $location.absUrl();
      if($location.search().state || $location.search().RelayState){
        $scope.authProcessing = true;
        $scope.isSsoAuth = true;
        LoginSrv.loginSSO($location.search(), $rootScope.sso.type).then(
          function(data){
            $scope.authProcessing = false;
            $scope.isSsoAuth = false;
            if(data.status == "error"){
              setTimeout(function(){
                $scope.ssoLogoutURL = $sce.trustAsResourceUrl($rootScope.sso.logout_url);
              }, 50);
            }
            if(data.code && (data.code == 6009 || data.code == 6010)){
              $scope.errType = "noServer";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6048){
              $scope.errType = "block";
              $scope.hasErr = true;
              if(data.uid){
                $scope.uid = data.uid;
              }
            } else if(data.code && data.code == 6011){
              $scope.errType = "auth";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6041){
              $scope.errType = "itemNotAcce";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6049){
              $scope.errType = "lastAttem";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6061){
              $scope.errType = "userNotInSer";
              $scope.hasErr = true;
            } else if(data.status !== "error"){
              $scope.isSsoAuth = true;
              $scope.setInfoFx(data);
            } else if(data.code && data.code == 8139){
              $scope.errType = "samlErr";
              $scope.hasErr = true;
            }
          }, function(err){
            $scope.authProcessing = false;
          }
        );
      } else{
      }
    } else{
      $scope.checkSSO = false;
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('LockController', LockController);

  /** @ngInject */
  function LockController($log, $scope, $rootScope, $state, $http, $cookies, $timeout, $translate, $window, CommonSrv, LockSrv){
    $scope.authProcessing = false;
    $scope.credentials = {};
    $scope.authServer = [];
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $http.defaults.headers.common.Authorization = $scope.auth.token;

    /*Localization*/
    $translate.use($scope.auth.lang);

    $scope.$on("$stateChangeStart", function(event, toState){
      if(toState.name != "lock" && !$scope.authProcessing){
        event.preventDefault();
      }
    });

    $scope.logOutFx = function(){
      $scope.authProcessing = true;
      CommonSrv.logOut({"token":$scope.auth.token});
      localStorage.removeItem("redirectState");
      localStorage.removeItem("authServer");
      localStorage.removeItem("authLang");
      localStorage.removeItem("teamsApp");

      // Remove all saved data from localStorage
      localStorage.clear();

      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != "" && ($scope.curLang == "en" || $scope.curLang == "es" || $scope.curLang == "fr" || $scope.curLang == "hi")){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
      $window.location.reload();
    }

    $scope.hubEnc = function(id){
      return btoa(id);
    }
    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }
    $scope.encryptFx = function(val){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(val);
    };

    $scope.unlockFx = function(){
      $scope.authProcessing = true;
      $scope.hasErr = false;
      $scope.credentials.uid = $scope.hubEnc($scope.reverse($scope.auth.token) +"|"+ $scope.auth.uid +"|"+ $scope.auth.server);
      $scope.credentials.sid = $scope.hubEnc($scope.auth.server);
      if(!$scope.credentials.uid || !$scope.credentials.pass || $scope.credentials.pass == ""){
        $scope.authProcessing = false;
        $scope.errType = "form";
        $scope.hasErr = true;
      } else{
        // $scope.credentials.pass = $scope.hubEnc($scope.auth.token +"|"+ $scope.credentials.pass +"|"+ $scope.auth.uid);
        $scope.credentials.pass = $scope.encryptFx($scope.credentials.pass) ;
        LockSrv.authenticate($scope.credentials).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code && (data.code == 6009 || data.code == 6010)){
              $scope.errType = "block";
              $scope.hasErr = true;
            } else if(data.code && data.code == 6011){
              $scope.errType = "auth";
              $scope.hasErr = true;
            } else{
              $scope.authProcessing = true;
              if(data.isServerAccessible){
                localStorage.removeItem('auth');
                localStorage.setItem('auth', JSON.stringify(data.auth));
                $scope.redirectState = localStorage.getItem("redirectState");
                if($scope.redirectState && $scope.redirectState != ""){
                  $state.go($scope.redirectState);
                } else{
                  $state.go('hub.dashboard');
                }
              } else{
                $state.go('hub.selectServer');
              }
            }
          }, function(err){
            $scope.authProcessing = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FPController', FPController);

  /** @ngInject */
  function FPController($log, $scope, $state, $timeout, $window, $translate, $filter, ngDialog, vcRecaptchaService, ForgotPassSrv){
    $scope.authProcessing = false;
    $scope.isPwdSuccess = false;
    $scope.isSupport = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.pwd = {};

    /*Localization Start*/
    $scope.curLang = localStorage.getItem("loginLang");
    
    document.body.classList.add('no-clickable');
    $scope.initLangFx = function(lang, showLoading){
      if(showLoading){
        document.getElementById('awesome-loader').classList.remove('hidden');
        $translate.use("auth/"+ lang).then(function(){
          document.getElementById('awesome-loader').classList.add('awesome-loaded');
          document.getElementById('awesome-loader').classList.remove('awesome-loading');
          document.body.classList.remove('no-clickable');
        });
      } else{
        $translate.use(lang);
        document.getElementById('awesome-loader').classList.add('awesome-loaded');
        document.getElementById('awesome-loader').classList.remove('awesome-loading');
        document.body.classList.remove('no-clickable');
      }
    }

    if($scope.curLang && $scope.curLang != "en_US"){
      $scope.initLangFx($scope.curLang, true);
    } else{
      $scope.initLangFx("en_US");
    }
    /*Localization End*/

    $scope.credentials = {email:"", reCaptcha:""};
		$scope.goLoginFx = function(){
      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != ""){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
      setTimeout(function(){
        $window.location.reload();
      }, 10);
    }
		$scope.forgotPassFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.email || $scope.email == ""){
        $scope.errType = "email";
        $scope.hasErr = true;
        $("#email").focus();
      } else if(vcRecaptchaService.getResponse() == ""){
        $scope.errType = "reCaptcha";
        $scope.hasErr = true;
      } else{
        $scope.credentials = {email:$filter('lowercase')($scope.email), reCaptcha:vcRecaptchaService.getResponse()};
        $scope.authProcessing = true;
        ForgotPassSrv.forgotPass($scope.credentials).then(
          function(data){
            $scope.authProcessing = false;
            $scope.pwd = data;
            if($scope.pwd.code == 6019 || $scope.pwd.code == 6020){
              $scope.isPwdSuccess = true;
            }
            if($scope.pwd.code == 6047){
              $scope.isSupport = true;
            }
          }, function(err){
            $log.error(err);
            $scope.authProcessing = false;
          }
        );
      }
		}

    $scope.cancelForgetPassFx = function(){
      $scope.curLang = localStorage.getItem("loginLang");
      if($scope.curLang != ""){
        $state.go("login", {id:$scope.curLang});
      } else{
        $state.go("login");
      }
    }
  }
})();
(function(){
  'use strict';
  angular
    .module('hub')
    .controller('ApproveItemController', ApproveItemController);

  /** @ngInject */
  function ApproveItemController($log, $rootScope, $scope, $state, $translate, ngDialog, ForgotPassSrv){
    /*Localization*/
    $translate.use("en");
      $scope.item = {type:$state.params.type, id:$state.params.id, sentTime:$state.params.sentTime, sid:$state.params.sid, uid:$state.params.uid};
      $scope.infoLoading = true;
      $scope.info = {};

      ForgotPassSrv.approveItem($scope.item).then(
        function(data){
          $scope.infoLoading = false;
          $scope.info = data;
        },
        function(err){
          $scope.infoLoading = false;
          $log.error(err);
        }
      );
  };
})();
/**
 * @license ng-bs-daterangepicker v0.0.5
 * (c) 2013 Luis Farzati http://github.com/luisfarzati/ng-bs-daterangepicker
 * License: MIT
 */
(function(angular){
  'use strict';
  angular
    .module('ngBootstrap', [])
    .directive('input', ['$compile', '$parse', '$filter', function($compile, $parse, $filter){
      return {
        restrict: 'E',
        require: '?ngModel',
        link: function($scope, $element, $attributes, ngModel){
          if($attributes.type !== 'daterange' || ngModel === null){
            return;
          }
          var options = {};
          options.format = $attributes.format || 'YYYY-MM-DD';
          options.separator = $attributes.separator || ' - ';
          options.minDate = $attributes.minDate && moment($attributes.minDate);
          options.maxDate = $attributes.maxDate && moment($attributes.maxDate);
          options.dateLimit = $attributes.limit && moment.duration.apply(this, $attributes.limit.split(' ').map(function(elem, index){
            return index === 0 && parseInt(elem, 10) || elem;
          }));
          options.ranges = $attributes.ranges && $parse($attributes.ranges)($scope);
          options.locale = $attributes.locale && $parse($attributes.locale)($scope);
          options.opens = $attributes.opens || $parse($attributes.opens)($scope);
          options.singleDatePicker = $attributes.singledatepicker && $parse($attributes.singledatepicker)($scope);
          if($attributes.enabletimepicker){
            options.timePicker = true;
            angular.extend(options, $parse($attributes.enabletimepicker)($scope));
          }
          function datify(date){
            return moment.isMoment(date) ? date.toDate() : date;
          }
          function momentify(date){
            return (!moment.isMoment(date)) ? moment(date) : date;
          }
          function format(date){
            return $filter('date')(datify(date), options.format.replace(/Y/g, 'y').replace(/D/g, 'd')); //date.format(options.format);
          }
          function formatted(dates){
            return [format(dates.startDate), format(dates.endDate)].join(options.separator);
          }

          ngModel.$render = function(){
            if(!ngModel.$viewValue || !ngModel.$viewValue.startDate){
              return;
            }
            $element.val(formatted(ngModel.$viewValue));
          };

          $scope.$watch($attributes.ngModel, function(modelValue){
            if(!modelValue || (!modelValue.startDate)){
              ngModel.$setViewValue({
               startDate: moment().startOf('day'),
               endDate: moment().startOf('day')
              });
              return;
            }
            // $element.data('daterangepicker').setStartDate(modelValue.startDate);
            // $element.data('daterangepicker').setEndDate(modelValue.endDate);

            $element.data('daterangepicker').startDate = momentify(ngModel.$modelValue.startDate);
           	$element.data('daterangepicker').endDate = momentify(ngModel.$modelValue.endDate);

            $element.data('daterangepicker').updateView();
            $element.data('daterangepicker').updateCalendars();
            $element.data('daterangepicker').updateInputText();
          });

          // $scope.$watch(function(){
          // 	return $attributes.ngModel;
          // }, function(modelValue, oldModelValue){
          // 	if(!ngModel.$modelValue || (!ngModel.$modelValue.startDate)){
          // 		ngModel.$setViewValue({
          // 			startDate: moment().startOf('day'),
          // 			endDate: moment().startOf('day')
          // 		});
          // 		return;
          // 	}
          // 	if(oldModelValue !== modelValue){
          // 		return;
          // 	}
          // 	$element.data('daterangepicker').startDate = momentify(ngModel.$modelValue.startDate);
          // 	$element.data('daterangepicker').endDate = momentify(ngModel.$modelValue.endDate);
          // 	$element.data('daterangepicker').updateView();
          // 	$element.data('daterangepicker').updateCalendars();
          // 	$element.data('daterangepicker').updateInputText();
          // });

          $element.daterangepicker(options, function(start, end, label){
            var modelValue = ngModel.$viewValue;
            if(angular.equals(start, modelValue.startDate) && angular.equals(end, modelValue.endDate)){
              return;
            }
            $scope.$apply(function(){
              ngModel.$setViewValue({
                startDate: (moment.isMoment(modelValue.startDate)) ? start : start.toDate(),
                endDate: (moment.isMoment(modelValue.endDate)) ? end : end.toDate()
              });
              ngModel.$render();
            });
          });
        }
      };
    }]);
})(angular);

/**
 * @version: 1.3.17
 * @author: Dan Grossman http://www.dangrossman.info/
 * @date: 2014-11-25
 * @copyright: Copyright (c) 2012-2014 Dan Grossman. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: http://www.improvely.com/
 */

(function(root, factory){

  if(typeof define === 'function' && define.amd){
    define(['moment', 'jquery', 'exports'], function(momentjs, $, exports){
      root.daterangepicker = factory(root, exports, momentjs, $);
    });

  } else if(typeof exports !== 'undefined'){
    var momentjs = require('moment');
    var jQuery;
    try {
      jQuery = require('jquery');
    } catch (err){
      jQuery = window.jQuery;
      if(!jQuery) throw new Error('jQuery dependency not found');
    }

    factory(root, exports, momentjs, jQuery);

    // Finally, as a browser global.
  } else{
    root.daterangepicker = factory(root, {}, root.moment, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(root, daterangepicker, moment, $){

  var DateRangePicker = function(element, options, cb){

    // by default, the daterangepicker element is placed at the bottom of HTML body
    this.parentEl = 'body';

    //element that triggered the date range picker
    this.element = $(element);

    //tracks visible state
    this.isShowing = false;

    //create the picker HTML object
    var DRPTemplate = '<div class="daterangepicker dropdown-menu">' +
      '<div class="calendar first left"></div>' +
      '<div class="calendar second right"></div>' +
      '<div class="ranges">' +
        '<div class="range_inputs">' +
          '<div class="daterangepicker_start_input">' +
            '<label for="daterangepicker_start"></label>' +
            '<input class="input-mini" type="text" name="daterangepicker_start" value="" />' +
          '</div>' +
          '<div class="daterangepicker_end_input">' +
            '<label for="daterangepicker_end"></label>' +
            '<input class="input-mini" type="text" name="daterangepicker_end" value="" />' +
          '</div>' +
          '<button type="button" role="button" class="applyBtn" disabled="disabled"></button>&nbsp;' +
          '<button type="button" role="button" class="cancelBtn"></button>' +
        '</div>' +
      '</div>' +
    '</div>';

    //custom options
    if(typeof options !== 'object' || options === null)
      options = {};

    this.parentEl = (typeof options === 'object' && options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
    this.container = $(DRPTemplate).appendTo(this.parentEl);

    this.setOptions(options, cb);

    //apply CSS classes and labels to buttons
    var c = this.container;
    $.each(this.buttonClasses, function(idx, val){
      c.find('button').addClass(val);
    });
    this.container.find('.daterangepicker_start_input label').html(this.locale.fromLabel);
    this.container.find('.daterangepicker_end_input label').html(this.locale.toLabel);
    if(this.applyClass.length)
      this.container.find('.applyBtn').addClass(this.applyClass);
    if(this.cancelClass.length)
      this.container.find('.cancelBtn').addClass(this.cancelClass);
    this.container.find('.applyBtn').html(this.locale.applyLabel);
    this.container.find('.cancelBtn').html(this.locale.cancelLabel);

    //event listeners

    this.container.find('.calendar')
      .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
      .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
      .on('click.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
      .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
      .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
      .on('change.daterangepicker', 'select.yearselect', $.proxy(this.updateMonthYear, this))
      .on('change.daterangepicker', 'select.monthselect', $.proxy(this.updateMonthYear, this))
      .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.updateTime, this));

    this.container.find('.ranges')
      .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
      .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
      .on('click.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.showCalendars, this))
      .on('change.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.inputsChanged, this))
      .on('keydown.daterangepicker', '.daterangepicker_start_input,.daterangepicker_end_input', $.proxy(this.inputsKeydown, this))
      .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
      .on('mouseenter.daterangepicker', 'li', $.proxy(this.enterRange, this))
      .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

    if(this.element.is('input')){
      this.element.on({
        'click.daterangepicker': $.proxy(this.show, this),
        'focus.daterangepicker': $.proxy(this.show, this),
        'keyup.daterangepicker': $.proxy(this.updateFromControl, this)
      });
    } else{
      this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
    }

  };

  DateRangePicker.prototype = {
    constructor: DateRangePicker,
    setOptions: function(options, callback){
      this.startDate = moment().startOf('day');
      this.endDate = moment().endOf('day');
      this.timeZone = moment().zone();
      this.minDate = false;
      this.maxDate = false;
      this.dateLimit = false;
      this.showDropdowns = false;
      this.showWeekNumbers = false;
      this.timePicker = false;
      this.timePickerSeconds = false;
      this.timePickerIncrement = 30;
      this.timePicker12Hour = true;
      this.singleDatePicker = false;
      this.ranges = {};

      if(options.opens) //Custom
        this.opens = options.opens;
      else
        this.opens = 'right';

      if(this.element.hasClass('pull-right'))
        this.opens = 'left';

      this.buttonClasses = ['btn', 'btn-small btn-sm'];
      this.applyClass = 'btn-success';
      this.cancelClass = 'btn-default';

      this.format = 'MM/DD/YYYY';
      this.separator = ' - ';

      this.locale = {
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        fromLabel: 'From',
        toLabel: 'To',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: moment.localeData()._week.dow
      };

      this.cb = function(){};

      if(typeof options.format === 'string')
        this.format = options.format;

      if(typeof options.separator === 'string')
        this.separator = options.separator;

      if(typeof options.startDate === 'string')
        this.startDate = moment(options.startDate, this.format);

      if(typeof options.endDate === 'string')
        this.endDate = moment(options.endDate, this.format);

      if(typeof options.minDate === 'string')
        this.minDate = moment(options.minDate, this.format);

      if(typeof options.maxDate === 'string')
        this.maxDate = moment(options.maxDate, this.format);

      if(typeof options.startDate === 'object')
        this.startDate = moment(options.startDate);

      if(typeof options.endDate === 'object')
        this.endDate = moment(options.endDate);

      if(typeof options.minDate === 'object')
        this.minDate = moment(options.minDate);

      if(typeof options.maxDate === 'object')
        this.maxDate = moment(options.maxDate);

      if(typeof options.applyClass === 'string')
        this.applyClass = options.applyClass;

      if(typeof options.cancelClass === 'string')
        this.cancelClass = options.cancelClass;

      if(typeof options.dateLimit === 'object')
        this.dateLimit = options.dateLimit;

      if(typeof options.locale === 'object'){

        if(typeof options.locale.daysOfWeek === 'object'){
          // Create a copy of daysOfWeek to avoid modification of original
          // options object for reusability in multiple daterangepicker instances
          this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
        }

        if(typeof options.locale.monthNames === 'object'){
          this.locale.monthNames = options.locale.monthNames.slice();
        }

        if(typeof options.locale.firstDay === 'number'){
          this.locale.firstDay = options.locale.firstDay;
        }

        if(typeof options.locale.applyLabel === 'string'){
          this.locale.applyLabel = options.locale.applyLabel;
        }

        if(typeof options.locale.cancelLabel === 'string'){
          this.locale.cancelLabel = options.locale.cancelLabel;
        }

        if(typeof options.locale.fromLabel === 'string'){
          this.locale.fromLabel = options.locale.fromLabel;
        }

        if(typeof options.locale.toLabel === 'string'){
          this.locale.toLabel = options.locale.toLabel;
        }

        if(typeof options.locale.weekLabel === 'string'){
          this.locale.weekLabel = options.locale.weekLabel;
        }

        if(typeof options.locale.customRangeLabel === 'string'){
          this.locale.customRangeLabel = options.locale.customRangeLabel;
        }
      }

      if(typeof options.opens === 'string')
        this.opens = options.opens;

      if(typeof options.showWeekNumbers === 'boolean'){
        this.showWeekNumbers = options.showWeekNumbers;
      }

      if(typeof options.buttonClasses === 'string'){
        this.buttonClasses = [options.buttonClasses];
      }

      if(typeof options.buttonClasses === 'object'){
        this.buttonClasses = options.buttonClasses;
      }

      if(typeof options.showDropdowns === 'boolean'){
        this.showDropdowns = options.showDropdowns;
      }

      if(typeof options.singleDatePicker === 'boolean'){
        this.singleDatePicker = options.singleDatePicker;
        if(this.singleDatePicker){
          this.endDate = this.startDate.clone();
        }
      }

      if(typeof options.timePicker === 'boolean'){
        this.timePicker = options.timePicker;
      }

      if(typeof options.timePickerSeconds === 'boolean'){
        this.timePickerSeconds = options.timePickerSeconds;
      }

      if(typeof options.timePickerIncrement === 'number'){
        this.timePickerIncrement = options.timePickerIncrement;
      }

      if(typeof options.timePicker12Hour === 'boolean'){
        this.timePicker12Hour = options.timePicker12Hour;
      }

      // update day names order to firstDay
      if(this.locale.firstDay != 0){
        var iterator = this.locale.firstDay;
        while (iterator > 0){
          this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
          iterator--;
        }
      }

      var start, end, range;

      //if no start/end dates set, check if an input element contains initial values
      if(typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined'){
        if($(this.element).is('input[type=text]')){
          var val = $(this.element).val(),
            split = val.split(this.separator);

          start = end = null;

          if(split.length == 2){
            start = moment(split[0], this.format);
            end = moment(split[1], this.format);
          } else if(this.singleDatePicker && val !== ""){
            start = moment(val, this.format);
            end = moment(val, this.format);
          }
          if(start !== null && end !== null){
            this.startDate = start;
            this.endDate = end;
          }
        }
      }

      // bind the time zone used to build the calendar to either the timeZone passed in through the options or the zone of the startDate (which will be the local time zone by default)
      if(typeof options.timeZone === 'string' || typeof options.timeZone === 'number'){
        this.timeZone = options.timeZone;
        this.startDate.zone(this.timeZone);
        this.endDate.zone(this.timeZone);
      } else{
        this.timeZone = moment(this.startDate).zone();
      }

      if(typeof options.ranges === 'object'){
        for(range in options.ranges){

          if(typeof options.ranges[range][0] === 'string')
            start = moment(options.ranges[range][0], this.format);
          else
            start = moment(options.ranges[range][0]);

          if(typeof options.ranges[range][1] === 'string')
            end = moment(options.ranges[range][1], this.format);
          else
            end = moment(options.ranges[range][1]);

          // If we have a min/max date set, bound this range
          // to it, but only if it would otherwise fall
          // outside of the min/max.
          if(this.minDate && start.isBefore(this.minDate))
            start = moment(this.minDate);

          if(this.maxDate && end.isAfter(this.maxDate))
            end = moment(this.maxDate);

          // If the end of the range is before the minimum (if min is set) OR
          // the start of the range is after the max (also if set) don't display this
          // range option.
          if((this.minDate && end.isBefore(this.minDate)) || (this.maxDate && start.isAfter(this.maxDate))){
            continue;
          }

          this.ranges[range] = [start, end];
        }

        var list = '<ul>';
        for(range in this.ranges){
          list += '<li>' + range + '</li>';
        }
        list += '<li>' + this.locale.customRangeLabel + '</li>';
        list += '</ul>';
        this.container.find('.ranges ul').remove();
        this.container.find('.ranges').prepend(list);
      }

      if(typeof callback === 'function'){
        this.cb = callback;
      }

      if(!this.timePicker){
        this.startDate = this.startDate.startOf('day');
        this.endDate = this.endDate.endOf('day');
      }

      if(this.singleDatePicker){
        //this.opens = 'right';
        this.container.addClass('single');
        this.container.find('.calendar.right').show();
        this.container.find('.calendar.left').hide();
        if(!this.timePicker){
          this.container.find('.ranges').hide();
        } else{
          this.container.find('.ranges .daterangepicker_start_input, .ranges .daterangepicker_end_input').hide();
        }
        if(!this.container.find('.calendar.right').hasClass('single'))
          this.container.find('.calendar.right').addClass('single');
      } else{
        this.container.removeClass('single');
        this.container.find('.calendar.right').removeClass('single');
        this.container.find('.ranges').show();
      }

      this.oldStartDate = this.startDate.clone();
      this.oldEndDate = this.endDate.clone();
      this.oldChosenLabel = this.chosenLabel;

      this.leftCalendar = {
        month: moment([this.startDate.year(), this.startDate.month(), 1, this.startDate.hour(), this.startDate.minute(), this.startDate.second()]),
        calendar: []
      };

      this.rightCalendar = {
        month: moment([this.endDate.year(), this.endDate.month(), 1, this.endDate.hour(), this.endDate.minute(), this.endDate.second()]),
        calendar: []
      };

      if(this.opens == 'right' || this.opens == 'center'){
        //swap calendar positions
        var first = this.container.find('.calendar.first');
        var second = this.container.find('.calendar.second');

        if(second.hasClass('single')){
          second.removeClass('single');
          first.addClass('single');
        }

        first.removeClass('left').addClass('right');
        second.removeClass('right').addClass('left');

        if(this.singleDatePicker){
          first.show();
          second.hide();
        }
      }

      if(typeof options.ranges === 'undefined' && !this.singleDatePicker){
        this.container.addClass('show-calendar');
      }

      this.container.addClass('opens' + this.opens);

      this.updateView();
      this.updateCalendars();

    },

    setStartDate: function(startDate){
      if(typeof startDate === 'string')
        this.startDate = moment(startDate, this.format).zone(this.timeZone);

      if(typeof startDate === 'object')
        this.startDate = moment(startDate);

      if(!this.timePicker)
        this.startDate = this.startDate.startOf('day');

      this.oldStartDate = this.startDate.clone();

      this.updateView();
      this.updateCalendars();
      this.updateInputText();
    },

    setEndDate: function(endDate){
      if(typeof endDate === 'string')
        this.endDate = moment(endDate, this.format).zone(this.timeZone);

      if(typeof endDate === 'object')
        this.endDate = moment(endDate);

      if(!this.timePicker)
        this.endDate = this.endDate.endOf('day');

      this.oldEndDate = this.endDate.clone();

      this.updateView();
      this.updateCalendars();
      this.updateInputText();
    },

    updateView: function(){
      this.leftCalendar.month.month(this.startDate.month()).year(this.startDate.year()).hour(this.startDate.hour()).minute(this.startDate.minute());
      this.rightCalendar.month.month(this.endDate.month()).year(this.endDate.year()).hour(this.endDate.hour()).minute(this.endDate.minute());
      this.updateFormInputs();
    },

    updateFormInputs: function(){
      this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.format));
      this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.format));

      if(this.startDate.isSame(this.endDate) || this.startDate.isBefore(this.endDate)){
        this.container.find('button.applyBtn').removeAttr('disabled');
      } else{
        this.container.find('button.applyBtn').attr('disabled', 'disabled');
      }
    },

    updateFromControl: function(){
      if(!this.element.is('input')) return;
      if(!this.element.val().length) return;

      var dateString = this.element.val().split(this.separator),
        start = null,
        end = null;

      if(dateString.length === 2){
        start = moment(dateString[0], this.format).zone(this.timeZone);
        end = moment(dateString[1], this.format).zone(this.timeZone);
      }

      if(this.singleDatePicker || start === null || end === null){
        start = moment(this.element.val(), this.format).zone(this.timeZone);
        end = start;
      }

      if(end.isBefore(start)) return;

      this.oldStartDate = this.startDate.clone();
      this.oldEndDate = this.endDate.clone();

      this.startDate = start;
      this.endDate = end;

      if(!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
        this.notify();

      this.updateCalendars();
    },

    notify: function(){
      this.updateView();
      this.cb(this.startDate, this.endDate, this.chosenLabel);
    },

    move: function(){
      var parentOffset = {
        top: 0,
        left: 0
      };
      var parentRightEdge = $(window).width();
      if(!this.parentEl.is('body')){
        parentOffset = {
          top: this.parentEl.offset().top - this.parentEl.scrollTop(),
          left: this.parentEl.offset().left - this.parentEl.scrollLeft()
        };
        parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
      }

      if(this.opens == 'left'){
        this.container.css({
          top: this.element.offset().top + this.element.outerHeight() - parentOffset.top,
          right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
          left: 'auto'
        });
        if(this.container.offset().left < 0){
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else if(this.opens == 'center'){
        this.container.css({
          top: this.element.offset().top + this.element.outerHeight() - parentOffset.top,
          left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 -
            this.container.outerWidth() / 2,
          right: 'auto'
        });
        if(this.container.offset().left < 0){
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else{
        this.container.css({
          top: this.element.offset().top + this.element.outerHeight() - parentOffset.top,
          left: this.element.offset().left - parentOffset.left,
          right: 'auto'
        });
        if(this.container.offset().left + this.container.outerWidth() > $(window).width()){
          this.container.css({
            left: 'auto',
            right: 0
          });
        }
      }
    },

    toggle: function(e){
      if(this.element.hasClass('active')){
        this.hide();
      } else{
        this.show();
      }
    },

    show: function(e){
      if(this.isShowing) return;

      this.element.addClass('active');
      this.container.show();
      this.move();

      // Create a click proxy that is private to this instance of datepicker, for unbinding
      this._outsideClickProxy = $.proxy(function(e){
        this.outsideClick(e);
      }, this);
      // Bind global datepicker mousedown for hiding and
      $(document)
        .on('mousedown.daterangepicker', this._outsideClickProxy)
        // also support mobile devices
        .on('touchend.daterangepicker', this._outsideClickProxy)
        // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
        .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
        // and also close when focus changes to outside the picker(eg. tabbing between controls)
        .on('focusin.daterangepicker', this._outsideClickProxy);

      this.isShowing = true;
      this.element.trigger('show.daterangepicker', this);
    },

    outsideClick: function(e){
      var target = $(e.target);
      // if the page is clicked anywhere except within the daterangerpicker/button
      // itself then call this.hide()
      if(
        // ie modal dialog fix
        e.type == "focusin" ||
        target.closest(this.element).length ||
        target.closest(this.container).length ||
        target.closest('.calendar-date').length
      ) return;
      this.hide();
    },

    hide: function(e){
      if(!this.isShowing) return;

      $(document)
        .off('.daterangepicker');

      this.element.removeClass('active');
      this.container.hide();

      if(!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
        this.notify();

      this.oldStartDate = this.startDate.clone();
      this.oldEndDate = this.endDate.clone();

      this.isShowing = false;
      this.element.trigger('hide.daterangepicker', this);
    },

    enterRange: function(e){
      // mouse pointer has entered a range label
      var label = e.target.innerHTML;
      if(label == this.locale.customRangeLabel){
        this.updateView();
      } else{
        var dates = this.ranges[label];
        this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.format));
        this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.format));
      }
    },

    showCalendars: function(){
      this.container.addClass('show-calendar');
      this.move();
      this.element.trigger('showCalendar.daterangepicker', this);
    },

    hideCalendars: function(){
      this.container.removeClass('show-calendar');
      this.element.trigger('hideCalendar.daterangepicker', this);
    },

    // when a date is typed into the start to end date textboxes
    inputsChanged: function(e){
      var el = $(e.target);
      var date = moment(el.val(), this.format);
      if(!date.isValid()) return;

      var startDate, endDate;
      if(el.attr('name') === 'daterangepicker_start'){
        startDate = date;
        endDate = this.endDate;
      } else{
        startDate = this.startDate;
        endDate = date;
      }
      this.setCustomDates(startDate, endDate);
    },

    inputsKeydown: function(e){
      if(e.keyCode === 13){
        this.inputsChanged(e);
        this.notify();
      }
    },

    updateInputText: function(){
      if(this.element.is('input') && !this.singleDatePicker){
        this.element.val(this.startDate.format(this.format) + this.separator + this.endDate.format(this.format));
      } else if(this.element.is('input')){
        this.element.val(this.endDate.format(this.format));
      }
    },

    clickRange: function(e){
      var label = e.target.innerHTML;
      this.chosenLabel = label;
      if(label == this.locale.customRangeLabel){
        this.showCalendars();
      } else{
        var dates = this.ranges[label];

        this.startDate = dates[0];
        this.endDate = dates[1];

        if(!this.timePicker){
          this.startDate.startOf('day');
          this.endDate.endOf('day');
        }

        this.leftCalendar.month.month(this.startDate.month()).year(this.startDate.year()).hour(this.startDate.hour()).minute(this.startDate.minute());
        this.rightCalendar.month.month(this.endDate.month()).year(this.endDate.year()).hour(this.endDate.hour()).minute(this.endDate.minute());
        this.updateCalendars();

        this.updateInputText();

        this.hideCalendars();
        this.hide();
        this.element.trigger('apply.daterangepicker', this);
      }
    },

    clickPrev: function(e){
      var cal = $(e.target).parents('.calendar');
      if(cal.hasClass('left')){
        this.leftCalendar.month.subtract(1, 'month');
      } else{
        this.rightCalendar.month.subtract(1, 'month');
      }
      this.updateCalendars();
    },

    clickNext: function(e){
      var cal = $(e.target).parents('.calendar');
      if(cal.hasClass('left')){
        this.leftCalendar.month.add(1, 'month');
      } else{
        this.rightCalendar.month.add(1, 'month');
      }
      this.updateCalendars();
    },

    hoverDate: function(e){
      var title = $(e.target).attr('data-title');
      var row = title.substr(1, 1);
      var col = title.substr(3, 1);
      var cal = $(e.target).parents('.calendar');

      if(cal.hasClass('left')){
        this.container.find('input[name=daterangepicker_start]').val(this.leftCalendar.calendar[row][col].format(this.format));
      } else{
        this.container.find('input[name=daterangepicker_end]').val(this.rightCalendar.calendar[row][col].format(this.format));
      }
    },

    setCustomDates: function(startDate, endDate){
      this.chosenLabel = this.locale.customRangeLabel;
      if(startDate.isAfter(endDate)){
        var difference = this.endDate.diff(this.startDate);
        endDate = moment(startDate).add(difference, 'ms');
      }
      this.startDate = startDate;
      this.endDate = endDate;

      this.updateView();
      this.updateCalendars();
    },

    clickDate: function(e){
      var title = $(e.target).attr('data-title');
      var row = title.substr(1, 1);
      var col = title.substr(3, 1);
      var cal = $(e.target).parents('.calendar');

      var startDate, endDate;
      if(cal.hasClass('left')){
        startDate = this.leftCalendar.calendar[row][col];
        endDate = this.endDate;
        if(typeof this.dateLimit === 'object'){
          var maxDate = moment(startDate).add(this.dateLimit).startOf('day');
          if(endDate.isAfter(maxDate)){
            endDate = maxDate;
          }
        }
      } else{
        startDate = this.startDate;
        endDate = this.rightCalendar.calendar[row][col];
        if(typeof this.dateLimit === 'object'){
          var minDate = moment(endDate).subtract(this.dateLimit).startOf('day');
          if(startDate.isBefore(minDate)){
            startDate = minDate;
          }
        }
      }

      if(this.singleDatePicker && cal.hasClass('left')){
        endDate = startDate.clone();
      } else if(this.singleDatePicker && cal.hasClass('right')){
        startDate = endDate.clone();
      }

      cal.find('td').removeClass('active');

      $(e.target).addClass('active');

      this.setCustomDates(startDate, endDate);

      if(!this.timePicker)
        endDate.endOf('day');

      if(this.singleDatePicker && !this.timePicker)
        this.clickApply();
    },

    clickApply: function(e){
      this.updateInputText();
      this.hide();
      this.element.trigger('apply.daterangepicker', this);
    },

    clickCancel: function(e){
      // commented below code to fix date change on cancel
      this.startDate = this.oldStartDate;
      this.endDate = this.oldEndDate;
      this.chosenLabel = this.oldChosenLabel;
      this.updateView();
      this.updateCalendars();
      this.hide();
      this.element.trigger('cancel.daterangepicker', this);
    },

    updateMonthYear: function(e){
      var isLeft = $(e.target).closest('.calendar').hasClass('left'),
        leftOrRight = isLeft ? 'left' : 'right',
        cal = this.container.find('.calendar.' + leftOrRight);

      // Month must be Number for new moment versions
      var month = parseInt(cal.find('.monthselect').val(), 10);
      var year = cal.find('.yearselect').val();

      this[leftOrRight + 'Calendar'].month.month(month).year(year);
      this.updateCalendars();
    },

    updateTime: function(e){

      var cal = $(e.target).closest('.calendar'),
        isLeft = cal.hasClass('left');

      var hour = parseInt(cal.find('.hourselect').val(), 10);
      var minute = parseInt(cal.find('.minuteselect').val(), 10);
      var second = 0;

      if(this.timePickerSeconds){
        second = parseInt(cal.find('.secondselect').val(), 10);
      }

      if(this.timePicker12Hour){
        var ampm = cal.find('.ampmselect').val();
        if(ampm === 'PM' && hour < 12)
          hour += 12;
        if(ampm === 'AM' && hour === 12)
          hour = 0;
      }

      if(isLeft){
        var start = this.startDate.clone();
        start.hour(hour);
        start.minute(minute);
        start.second(second);
        this.startDate = start;
        this.leftCalendar.month.hour(hour).minute(minute).second(second);
        if(this.singleDatePicker)
          this.endDate = start.clone();
      } else{
        var end = this.endDate.clone();
        end.hour(hour);
        end.minute(minute);
        end.second(second);
        this.endDate = end;
        if(this.singleDatePicker)
          this.startDate = end.clone();
        this.rightCalendar.month.hour(hour).minute(minute).second(second);
      }

      this.updateView();
      this.updateCalendars();
    },

    updateCalendars: function(){
      this.leftCalendar.calendar = this.buildCalendar(this.leftCalendar.month.month(), this.leftCalendar.month.year(), this.leftCalendar.month.hour(), this.leftCalendar.month.minute(), this.leftCalendar.month.second(), 'left');
      this.rightCalendar.calendar = this.buildCalendar(this.rightCalendar.month.month(), this.rightCalendar.month.year(), this.rightCalendar.month.hour(), this.rightCalendar.month.minute(), this.rightCalendar.month.second(), 'right');
      this.container.find('.calendar.left').empty().html(this.renderCalendar(this.leftCalendar.calendar, this.startDate, this.minDate, this.maxDate, 'left'));
      this.container.find('.calendar.right').empty().html(this.renderCalendar(this.rightCalendar.calendar, this.endDate, this.singleDatePicker ? this.minDate : this.startDate, this.maxDate, 'right'));

      this.container.find('.ranges li').removeClass('active');
      var customRange = true;
      var i = 0;
      for(var range in this.ranges){
        if(this.timePicker){
          if(this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])){
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')')
              .addClass('active').html();
          }
        } else{
          //ignore times when comparing dates if time picker is not enabled
          if(this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')){
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')')
              .addClass('active').html();
          }
        }
        i++;
      }
      if(customRange){
        this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
        this.showCalendars();
      }
    },

    buildCalendar: function(month, year, hour, minute, second, side){
      var daysInMonth = moment([year, month]).daysInMonth();
      var firstDay = moment([year, month, 1]);
      var lastDay = moment([year, month, daysInMonth]);
      var lastMonth = moment(firstDay).subtract(1, 'month').month();
      var lastYear = moment(firstDay).subtract(1, 'month').year();

      var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();

      var dayOfWeek = firstDay.day();

      var i;

      //initialize a 6 rows x 7 columns array for the calendar
      var calendar = [];
      calendar.firstDay = firstDay;
      calendar.lastDay = lastDay;

      for(i = 0; i < 6; i++){
        calendar[i] = [];
      }

      //populate the calendar with date objects
      var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
      if(startDay > daysInLastMonth)
        startDay -= 7;

      if(dayOfWeek == this.locale.firstDay)
        startDay = daysInLastMonth - 6;

      var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]).zone(this.timeZone);

      var col, row;
      for(i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')){
        if(i > 0 && col % 7 === 0){
          col = 0;
          row++;
        }
        calendar[row][col] = curDate.clone().hour(hour);
        curDate.hour(12);

        if(this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left'){
          calendar[row][col] = this.minDate.clone();
        }

        if(this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right'){
          calendar[row][col] = this.maxDate.clone();
        }

      }

      return calendar;
    },

    renderDropdowns: function(selected, minDate, maxDate){
      var currentMonth = selected.month();
      var currentYear = selected.year();
      var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
      var minYear = (minDate && minDate.year()) || (currentYear - 50);

      var monthHtml = '<select class="monthselect">';
      var inMinYear = currentYear == minYear;
      var inMaxYear = currentYear == maxYear;

      for(var m = 0; m < 12; m++){
        if((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())){
          monthHtml += "<option value='" + m + "'" +
            (m === currentMonth ? " selected='selected'" : "") +
            ">" + this.locale.monthNames[m] + "</option>";
        }
      }
      monthHtml += "</select>";

      var yearHtml = '<select class="yearselect">';

      for(var y = minYear; y <= maxYear; y++){
        yearHtml += '<option value="' + y + '"' +
          (y === currentYear ? ' selected="selected"' : '') +
          '>' + y + '</option>';
      }

      yearHtml += '</select>';

      return monthHtml + yearHtml;
    },

    renderCalendar: function(calendar, selected, minDate, maxDate, side){

      var html = '<div class="calendar-date">';
      html += '<table class="table-condensed">';
      html += '<thead>';
      html += '<tr>';

      // add empty cell for week number
      if(this.showWeekNumbers)
        html += '<th></th>';

      if(!minDate || minDate.isBefore(calendar.firstDay)){
        html += '<th class="prev available"><i class="fa fa-arrow-left icon-arrow-left glyphicon glyphicon-arrow-left" aria-hidden="true"></i></th>';
      } else{
        html += '<th></th>';
      }

      var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

      if(this.showDropdowns){
        dateHtml = this.renderDropdowns(calendar[1][1], minDate, maxDate);
      }

      html += '<th colspan="5" class="month">' + dateHtml + '</th>';
      if(!maxDate || maxDate.isAfter(calendar.lastDay)){
        html += '<th class="next available"><i class="fa fa-arrow-right icon-arrow-right glyphicon glyphicon-arrow-right" aria-hidden="true"></i></th>';
      } else{
        html += '<th></th>';
      }

      html += '</tr>';
      html += '<tr>';

      // add week number label
      if(this.showWeekNumbers)
        html += '<th class="week">' + this.locale.weekLabel + '</th>';

      $.each(this.locale.daysOfWeek, function(index, dayOfWeek){
        html += '<th>' + dayOfWeek + '</th>';
      });

      html += '</tr>';
      html += '</thead>';
      html += '<tbody>';

      for(var row = 0; row < 6; row++){
        html += '<tr>';

        // add week number
        if(this.showWeekNumbers)
          html += '<td class="week">' + calendar[row][0].week() + '</td>';

        for(var col = 0; col < 7; col++){
          var cname = 'available ';
          cname += (calendar[row][col].month() == calendar[1][1].month()) ? '' : 'off';

          if((minDate && calendar[row][col].isBefore(minDate, 'day')) || (maxDate && calendar[row][col].isAfter(maxDate, 'day'))){
            cname = ' off disabled ';
          } else if(calendar[row][col].format('YYYY-MM-DD') == selected.format('YYYY-MM-DD')){
            cname += ' active ';
            if(calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')){
              cname += ' start-date ';
            }
            if(calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')){
              cname += ' end-date ';
            }
          } else if(calendar[row][col] >= this.startDate && calendar[row][col] <= this.endDate){
            cname += ' in-range ';
            if(calendar[row][col].isSame(this.startDate)){
              cname += ' start-date ';
            }
            if(calendar[row][col].isSame(this.endDate)){
              cname += ' end-date ';
            }
          }

          var title = 'r' + row + 'c' + col;
          html += '<td class="' + cname.replace(/\s+/g, ' ').replace(/^\s?(.*?)\s?$/, '$1') + '" data-title="' + title + '">' + calendar[row][col].date() + '</td>';
        }
        html += '</tr>';
      }

      html += '</tbody>';
      html += '</table>';
      html += '</div>';

      var i;
      if(this.timePicker){

        html += '<div class="calendar-time">';
        html += '<select class="hourselect">';

        // Disallow selections before the minDate or after the maxDate
        var min_hour = 0;
        var max_hour = 23;

        if(minDate && (side == 'left' || this.singleDatePicker) && selected.format('YYYY-MM-DD') == minDate.format('YYYY-MM-DD')){
          min_hour = minDate.hour();
          if(selected.hour() < min_hour)
            selected.hour(min_hour);
          if(this.timePicker12Hour && min_hour >= 12 && selected.hour() >= 12)
            min_hour -= 12;
          if(this.timePicker12Hour && min_hour == 12)
            min_hour = 1;
        }

        if(maxDate && (side == 'right' || this.singleDatePicker) && selected.format('YYYY-MM-DD') == maxDate.format('YYYY-MM-DD')){
          max_hour = maxDate.hour();
          if(selected.hour() > max_hour)
            selected.hour(max_hour);
          if(this.timePicker12Hour && max_hour >= 12 && selected.hour() >= 12)
            max_hour -= 12;
        }

        var start = 0;
        var end = 23;
        var selected_hour = selected.hour();
        if(this.timePicker12Hour){
          start = 1;
          end = 12;
          if(selected_hour >= 12)
            selected_hour -= 12;
          if(selected_hour === 0)
            selected_hour = 12;
        }

        for(i = start; i <= end; i++){

          if(i == selected_hour){
            html += '<option value="' + i + '" selected="selected">' + i + '</option>';
          } else if(i < min_hour || i > max_hour){
            html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
          } else{
            html += '<option value="' + i + '">' + i + '</option>';
          }
        }

        html += '</select> : ';

        html += '<select class="minuteselect">';

        // Disallow selections before the minDate or after the maxDate
        var min_minute = 0;
        var max_minute = 59;

        if(minDate && (side == 'left' || this.singleDatePicker) && selected.format('YYYY-MM-DD h A') == minDate.format('YYYY-MM-DD h A')){
          min_minute = minDate.minute();
          if(selected.minute() < min_minute)
            selected.minute(min_minute);
        }

        if(maxDate && (side == 'right' || this.singleDatePicker) && selected.format('YYYY-MM-DD h A') == maxDate.format('YYYY-MM-DD h A')){
          max_minute = maxDate.minute();
          if(selected.minute() > max_minute)
            selected.minute(max_minute);
        }

        for(i = 0; i < 60; i += this.timePickerIncrement){
          var num = i;
          if(num < 10)
            num = '0' + num;
          if(i == selected.minute()){
            html += '<option value="' + i + '" selected="selected">' + num + '</option>';
          } else if(i < min_minute || i > max_minute){
            html += '<option value="' + i + '" disabled="disabled" class="disabled">' + num + '</option>';
          } else{
            html += '<option value="' + i + '">' + num + '</option>';
          }
        }

        html += '</select> ';

        if(this.timePickerSeconds){
          html += ': <select class="secondselect">';

          for(i = 0; i < 60; i += this.timePickerIncrement){
            var num = i;
            if(num < 10)
              num = '0' + num;
            if(i == selected.second()){
              html += '<option value="' + i + '" selected="selected">' + num + '</option>';
            } else{
              html += '<option value="' + i + '">' + num + '</option>';
            }
          }

          html += '</select>';
        }

        if(this.timePicker12Hour){
          html += '<select class="ampmselect">';

          // Disallow selection before the minDate or after the maxDate
          var am_html = '';
          var pm_html = '';

          if(minDate && (side == 'left' || this.singleDatePicker) && selected.format('YYYY-MM-DD') == minDate.format('YYYY-MM-DD') && minDate.hour() >= 12){
            am_html = ' disabled="disabled" class="disabled"';
          }

          if(maxDate && (side == 'right' || this.singleDatePicker) && selected.format('YYYY-MM-DD') == maxDate.format('YYYY-MM-DD') && maxDate.hour() < 12){
            pm_html = ' disabled="disabled" class="disabled"';
          }

          if(selected.hour() >= 12){
            html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
          } else{
            html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
          }
          html += '</select>';
        }

        html += '</div>';

      }

      return html;

    },

    remove: function(){

      this.container.remove();
      this.element.off('.daterangepicker');
      this.element.removeData('daterangepicker');

    }

  };

  $.fn.daterangepicker = function(options, cb){
    this.each(function(){
      var el = $(this);
      if(el.data('daterangepicker'))
        el.data('daterangepicker').remove();
      el.data('daterangepicker', new DateRangePicker(el, options, cb));
    });
    return this;
  };

}));

/*
 Highstock JS v5.0.7 (2017-01-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(K,a){"object"===typeof module&&module.exports?module.exports=K.document?a(K):a:K.Highcharts=a(K)})("undefined"!==typeof window?window:this,function(K){K=function(){var a=window,E=a.document,D=a.navigator&&a.navigator.userAgent||"",H=E&&E.createElementNS&&!!E.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,I=/(edge|msie|trident)/i.test(D)&&!window.opera,v=!H,n=/Firefox/.test(D),m=n&&4>parseInt(D.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highstock",
version:"5.0.7",deg2rad:2*Math.PI/360,doc:E,hasBidiBug:m,hasTouch:E&&void 0!==E.documentElement.ontouchstart,isMS:I,isWebKit:/AppleWebKit/.test(D),isFirefox:n,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(D),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:H,vml:v,win:a,charts:[],marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){}}}();(function(a){var E=[],D=a.charts,H=a.doc,I=a.win;a.error=function(v,n){v=a.isNumber(v)?"Highcharts error #"+
v+": www.highcharts.com/errors/"+v:v;if(n)throw Error(v);I.console&&console.log(v)};a.Fx=function(a,n,m){this.options=n;this.elem=a;this.prop=m};a.Fx.prototype={dSetter:function(){var a=this.paths[0],n=this.paths[1],m=[],z=this.now,t=a.length,q;if(1===z)m=this.toD;else if(t===n.length&&1>z)for(;t--;)q=parseFloat(a[t]),m[t]=isNaN(q)?a[t]:z*parseFloat(n[t]-q)+q;else m=n;this.elem.attr("d",m,null,!0)},update:function(){var a=this.elem,n=this.prop,m=this.now,z=this.options.step;if(this[n+"Setter"])this[n+
"Setter"]();else a.attr?a.element&&a.attr(n,m,null,!0):a.style[n]=m+this.unit;z&&z.call(a,m,this)},run:function(a,n,m){var v=this,t=function(a){return t.stopped?!1:v.step(a)},q;this.startTime=+new Date;this.start=a;this.end=n;this.unit=m;this.now=this.start;this.pos=0;t.elem=this.elem;t.prop=this.prop;t()&&1===E.push(t)&&(t.timerId=setInterval(function(){for(q=0;q<E.length;q++)E[q]()||E.splice(q--,1);E.length||clearInterval(t.timerId)},13))},step:function(a){var n=+new Date,m,v=this.options;m=this.elem;
var t=v.complete,q=v.duration,e=v.curAnim,b;if(m.attr&&!m.element)m=!1;else if(a||n>=q+this.startTime){this.now=this.end;this.pos=1;this.update();a=e[this.prop]=!0;for(b in e)!0!==e[b]&&(a=!1);a&&t&&t.call(m);m=!1}else this.pos=v.easing((n-this.startTime)/q),this.now=this.start+(this.end-this.start)*this.pos,this.update(),m=!0;return m},initPath:function(v,n,m){function z(a){var d,f;for(F=a.length;F--;)d="M"===a[F]||"L"===a[F],f=/[a-zA-Z]/.test(a[F+3]),d&&f&&a.splice(F+1,0,a[F+1],a[F+2],a[F+1],a[F+
2])}function t(a,d){for(;a.length<l;){a[0]=d[l-a.length];var f=a.slice(0,k);[].splice.apply(a,[0,0].concat(f));r&&(f=a.slice(a.length-k),[].splice.apply(a,[a.length,0].concat(f)),F--)}a[0]="M"}function q(a,d){for(var f=(l-a.length)/k;0<f&&f--;)g=a.slice().splice(a.length/u-k,k*u),g[0]=d[l-k-f*k],w&&(g[k-6]=g[k-2],g[k-5]=g[k-1]),[].splice.apply(a,[a.length/u,0].concat(g)),r&&f--}n=n||"";var e,b=v.startX,p=v.endX,w=-1<n.indexOf("C"),k=w?7:3,l,g,F;n=n.split(" ");m=m.slice();var r=v.isArea,u=r?2:1,f;
w&&(z(n),z(m));if(b&&p){for(F=0;F<b.length;F++)if(b[F]===p[0]){e=F;break}else if(b[0]===p[p.length-b.length+F]){e=F;f=!0;break}void 0===e&&(n=[])}n.length&&a.isNumber(e)&&(l=m.length+e*u*k,f?(t(n,m),q(m,n)):(t(m,n),q(n,m)));return[n,m]}};a.extend=function(a,n){var m;a||(a={});for(m in n)a[m]=n[m];return a};a.merge=function(){var v,n=arguments,m,z={},t=function(q,e){var b,p;"object"!==typeof q&&(q={});for(p in e)e.hasOwnProperty(p)&&(b=e[p],a.isObject(b,!0)&&"renderTo"!==p&&"number"!==typeof b.nodeType?
q[p]=t(q[p]||{},b):q[p]=e[p]);return q};!0===n[0]&&(z=n[1],n=Array.prototype.slice.call(n,2));m=n.length;for(v=0;v<m;v++)z=t(z,n[v]);return z};a.pInt=function(a,n){return parseInt(a,n||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(v,n){return v&&"object"===typeof v&&(!n||!a.isArray(v))};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
function(a,n){for(var m=a.length;m--;)if(a[m]===n){a.splice(m,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(v,n,m){var z,t;if(a.isString(n))a.defined(m)?v.setAttribute(n,m):v&&v.getAttribute&&(t=v.getAttribute(n));else if(a.defined(n)&&a.isObject(n))for(z in n)v.setAttribute(z,n[z]);return t};a.splat=function(v){return a.isArray(v)?v:[v]};a.syncTimeout=function(a,n,m){if(n)return setTimeout(a,n,m);a.call(0,m)};a.pick=function(){var a=arguments,n,m,z=a.length;for(n=
0;n<z;n++)if(m=a[n],void 0!==m&&null!==m)return m};a.css=function(v,n){a.isMS&&!a.svg&&n&&void 0!==n.opacity&&(n.filter="alpha(opacity\x3d"+100*n.opacity+")");a.extend(v.style,n)};a.createElement=function(v,n,m,z,t){v=H.createElement(v);var q=a.css;n&&a.extend(v,n);t&&q(v,{padding:0,border:"none",margin:0});m&&q(v,m);z&&z.appendChild(v);return v};a.extendClass=function(v,n){var m=function(){};m.prototype=new v;a.extend(m.prototype,n);return m};a.pad=function(a,n,m){return Array((n||2)+1-String(a).length).join(m||
0)+a};a.relativeLength=function(a,n){return/%$/.test(a)?n*parseFloat(a)/100:parseFloat(a)};a.wrap=function(a,n,m){var v=a[n];a[n]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,e=this;e.proceed=function(){v.apply(e,arguments.length?arguments:q)};a.unshift(v);a=m.apply(this,a);e.proceed=null;return a}};a.getTZOffset=function(v){var n=a.Date;return 6E4*(n.hcGetTimezoneOffset&&n.hcGetTimezoneOffset(v)||n.hcTimezoneOffset||0)};a.dateFormat=function(v,n,m){if(!a.defined(n)||isNaN(n))return a.defaultOptions.lang.invalidDate||
"";v=a.pick(v,"%Y-%m-%d %H:%M:%S");var z=a.Date,t=new z(n-a.getTZOffset(n)),q,e=t[z.hcGetHours](),b=t[z.hcGetDay](),p=t[z.hcGetDate](),w=t[z.hcGetMonth](),k=t[z.hcGetFullYear](),l=a.defaultOptions.lang,g=l.weekdays,F=l.shortWeekdays,r=a.pad,z=a.extend({a:F?F[b]:g[b].substr(0,3),A:g[b],d:r(p),e:r(p,2," "),w:b,b:l.shortMonths[w],B:l.months[w],m:r(w+1),y:k.toString().substr(2,2),Y:k,H:r(e),k:e,I:r(e%12||12),l:e%12||12,M:r(t[z.hcGetMinutes]()),p:12>e?"AM":"PM",P:12>e?"am":"pm",S:r(t.getSeconds()),L:r(Math.round(n%
1E3),3)},a.dateFormats);for(q in z)for(;-1!==v.indexOf("%"+q);)v=v.replace("%"+q,"function"===typeof z[q]?z[q](n):z[q]);return m?v.substr(0,1).toUpperCase()+v.substr(1):v};a.formatSingle=function(v,n){var m=/\.([0-9])/,z=a.defaultOptions.lang;/f$/.test(v)?(m=(m=v.match(m))?m[1]:-1,null!==n&&(n=a.numberFormat(n,m,z.decimalPoint,-1<v.indexOf(",")?z.thousandsSep:""))):n=a.dateFormat(v,n);return n};a.format=function(v,n){for(var m="{",z=!1,t,q,e,b,p=[],w;v;){m=v.indexOf(m);if(-1===m)break;t=v.slice(0,
m);if(z){t=t.split(":");q=t.shift().split(".");b=q.length;w=n;for(e=0;e<b;e++)w=w[q[e]];t.length&&(w=a.formatSingle(t.join(":"),w));p.push(w)}else p.push(t);v=v.slice(m+1);m=(z=!z)?"}":"{"}p.push(v);return p.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(v,n,m,z,t){var q,e=v;m=a.pick(m,1);q=v/m;n||(n=t?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===z&&(1===m?n=a.grep(n,function(a){return 0===a%1}):.1>=m&&(n=[1/m])));
for(z=0;z<n.length&&!(e=n[z],t&&e*m>=v||!t&&q<=(n[z]+(n[z+1]||n[z]))/2);z++);return e=a.correctFloat(e*m,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,n){var m=a.length,v,t;for(t=0;t<m;t++)a[t].safeI=t;a.sort(function(a,e){v=n(a,e);return 0===v?a.safeI-e.safeI:v});for(t=0;t<m;t++)delete a[t].safeI};a.arrayMin=function(a){for(var n=a.length,m=a[0];n--;)a[n]<m&&(m=a[n]);return m};a.arrayMax=function(a){for(var n=a.length,m=a[0];n--;)a[n]>m&&(m=a[n]);return m};a.destroyObjectProperties=
function(a,n){for(var m in a)a[m]&&a[m]!==n&&a[m].destroy&&a[m].destroy(),delete a[m]};a.discardElement=function(v){var n=a.garbageBin;n||(n=a.createElement("div"));v&&n.appendChild(v);n.innerHTML=""};a.correctFloat=function(a,n){return parseFloat(a.toPrecision(n||14))};a.setAnimation=function(v,n){n.renderer.globalAnimation=a.pick(v,n.options.chart.animation,!0)};a.animObject=function(v){return a.isObject(v)?a.merge(v):{duration:v?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,
day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(v,n,m,z){v=+v||0;n=+n;var t=a.defaultOptions.lang,q=(v.toString().split(".")[1]||"").length,e,b;-1===n?n=Math.min(q,20):a.isNumber(n)||(n=2);b=(Math.abs(v)+Math.pow(10,-Math.max(n,q)-1)).toFixed(n);q=String(a.pInt(b));e=3<q.length?q.length%3:0;m=a.pick(m,t.decimalPoint);z=a.pick(z,t.thousandsSep);v=(0>v?"-":"")+(e?q.substr(0,e)+z:"");v+=q.substr(e).replace(/(\d{3})(?=\d)/g,"$1"+z);n&&(v+=m+b.slice(-n));return v};Math.easeInOutSine=
function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(v,n){return"width"===n?Math.min(v.offsetWidth,v.scrollWidth)-a.getStyle(v,"padding-left")-a.getStyle(v,"padding-right"):"height"===n?Math.min(v.offsetHeight,v.scrollHeight)-a.getStyle(v,"padding-top")-a.getStyle(v,"padding-bottom"):(v=I.getComputedStyle(v,void 0))&&a.pInt(v.getPropertyValue(n))};a.inArray=function(a,n){return n.indexOf?n.indexOf(a):[].indexOf.call(n,a)};a.grep=function(a,n){return[].filter.call(a,n)};a.find=function(a,
n){return[].find.call(a,n)};a.map=function(a,n){for(var m=[],z=0,t=a.length;z<t;z++)m[z]=n.call(a[z],a[z],z,a);return m};a.offset=function(a){var n=H.documentElement;a=a.getBoundingClientRect();return{top:a.top+(I.pageYOffset||n.scrollTop)-(n.clientTop||0),left:a.left+(I.pageXOffset||n.scrollLeft)-(n.clientLeft||0)}};a.stop=function(a,n){for(var m=E.length;m--;)E[m].elem!==a||n&&n!==E[m].prop||(E[m].stopped=!0)};a.each=function(a,n,m){return Array.prototype.forEach.call(a,n,m)};a.addEvent=function(v,
n,m){function z(a){a.target=a.srcElement||I;m.call(v,a)}var t=v.hcEvents=v.hcEvents||{};v.addEventListener?v.addEventListener(n,m,!1):v.attachEvent&&(v.hcEventsIE||(v.hcEventsIE={}),v.hcEventsIE[m.toString()]=z,v.attachEvent("on"+n,z));t[n]||(t[n]=[]);t[n].push(m);return function(){a.removeEvent(v,n,m)}};a.removeEvent=function(v,n,m){function z(a,b){v.removeEventListener?v.removeEventListener(a,b,!1):v.attachEvent&&(b=v.hcEventsIE[b.toString()],v.detachEvent("on"+a,b))}function t(){var a,b;if(v.nodeName)for(b in n?
(a={},a[n]=!0):a=e,a)if(e[b])for(a=e[b].length;a--;)z(b,e[b][a])}var q,e=v.hcEvents,b;e&&(n?(q=e[n]||[],m?(b=a.inArray(m,q),-1<b&&(q.splice(b,1),e[n]=q),z(n,m)):(t(),e[n]=[])):(t(),v.hcEvents={}))};a.fireEvent=function(v,n,m,z){var t;t=v.hcEvents;var q,e;m=m||{};if(H.createEvent&&(v.dispatchEvent||v.fireEvent))t=H.createEvent("Events"),t.initEvent(n,!0,!0),a.extend(t,m),v.dispatchEvent?v.dispatchEvent(t):v.fireEvent(n,t);else if(t)for(t=t[n]||[],q=t.length,m.target||a.extend(m,{preventDefault:function(){m.defaultPrevented=
!0},target:v,type:n}),n=0;n<q;n++)(e=t[n])&&!1===e.call(v,m)&&m.preventDefault();z&&!m.defaultPrevented&&z(m)};a.animate=function(v,n,m){var z,t="",q,e,b;a.isObject(m)||(z=arguments,m={duration:z[2],easing:z[3],complete:z[4]});a.isNumber(m.duration)||(m.duration=400);m.easing="function"===typeof m.easing?m.easing:Math[m.easing]||Math.easeInOutSine;m.curAnim=a.merge(n);for(b in n)a.stop(v,b),e=new a.Fx(v,m,b),q=null,"d"===b?(e.paths=e.initPath(v,v.d,n.d),e.toD=n.d,z=0,q=1):v.attr?z=v.attr(b):(z=parseFloat(a.getStyle(v,
b))||0,"opacity"!==b&&(t="px")),q||(q=n[b]),q.match&&q.match("px")&&(q=q.replace(/px/g,"")),e.run(z,q,t)};a.seriesType=function(v,n,m,z,t){var q=a.getOptions(),e=a.seriesTypes;q.plotOptions[v]=a.merge(q.plotOptions[n],m);e[v]=a.extendClass(e[n]||function(){},z);e[v].prototype.type=v;t&&(e[v].prototype.pointClass=a.extendClass(a.Point,t));return e[v]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),n=0;return function(){return"highcharts-"+a+"-"+n++}}();I.jQuery&&(I.jQuery.fn.highcharts=
function(){var v=[].slice.call(arguments);if(this[0])return v[0]?(new (a[a.isString(v[0])?v.shift():"Chart"])(this[0],v[0],v[1]),this):D[a.attr(this[0],"data-highcharts-chart")]});H&&!H.defaultView&&(a.getStyle=function(v,n){var m={width:"clientWidth",height:"clientHeight"}[n];if(v.style[n])return a.pInt(v.style[n]);"opacity"===n&&(n="filter");if(m)return v.style.zoom=1,Math.max(v[m]-2*a.getStyle(v,"padding"),0);v=v.currentStyle[n.replace(/\-(\w)/g,function(a,t){return t.toUpperCase()})];"filter"===
n&&(v=v.replace(/alpha\(opacity=([0-9]+)\)/,function(a,t){return t/100}));return""===v?1:a.pInt(v)});Array.prototype.forEach||(a.each=function(a,n,m){for(var z=0,t=a.length;z<t;z++)if(!1===n.call(m,a[z],z,a))return z});Array.prototype.indexOf||(a.inArray=function(a,n){var m,z=0;if(n)for(m=n.length;z<m;z++)if(n[z]===a)return z;return-1});Array.prototype.filter||(a.grep=function(a,n){for(var m=[],z=0,t=a.length;z<t;z++)n(a[z],z)&&m.push(a[z]);return m});Array.prototype.find||(a.find=function(a,n){var m,
z=a.length;for(m=0;m<z;m++)if(n(a[m],m))return a[m]})})(K);(function(a){var E=a.each,D=a.isNumber,H=a.map,I=a.merge,v=a.pInt;a.Color=function(n){if(!(this instanceof a.Color))return new a.Color(n);this.init(n)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[v(a[1]),v(a[2]),v(a[3]),parseFloat(a[4],10)]}},{regex:/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,parse:function(a){return[v(a[1],
16),v(a[2],16),v(a[3],16),1]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[v(a[1]),v(a[2]),v(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(n){var m,z,t,q;if((this.input=n=this.names[n]||n)&&n.stops)this.stops=H(n.stops,function(e){return new a.Color(e[1])});else for(t=this.parsers.length;t--&&!z;)q=this.parsers[t],(m=q.regex.exec(n))&&(z=q.parse(m));this.rgba=z||[]},get:function(a){var m=this.input,n=this.rgba,t;this.stops?
(t=I(m),t.stops=[].concat(t.stops),E(this.stops,function(q,e){t.stops[e]=[t.stops[e][0],q.get(a)]})):t=n&&D(n[0])?"rgb"===a||!a&&1===n[3]?"rgb("+n[0]+","+n[1]+","+n[2]+")":"a"===a?n[3]:"rgba("+n.join(",")+")":m;return t},brighten:function(a){var m,n=this.rgba;if(this.stops)E(this.stops,function(t){t.brighten(a)});else if(D(a)&&0!==a)for(m=0;3>m;m++)n[m]+=v(255*a),0>n[m]&&(n[m]=0),255<n[m]&&(n[m]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this}};a.color=function(n){return new a.Color(n)}})(K);
(function(a){var E,D,H=a.addEvent,I=a.animate,v=a.attr,n=a.charts,m=a.color,z=a.css,t=a.createElement,q=a.defined,e=a.deg2rad,b=a.destroyObjectProperties,p=a.doc,w=a.each,k=a.extend,l=a.erase,g=a.grep,F=a.hasTouch,r=a.inArray,u=a.isArray,f=a.isFirefox,B=a.isMS,d=a.isObject,x=a.isString,c=a.isWebKit,y=a.merge,L=a.noop,A=a.pick,J=a.pInt,h=a.removeEvent,G=a.stop,Q=a.svg,P=a.SVG_NS,N=a.symbolSizes,S=a.win;E=a.SVGElement=function(){return this};E.prototype={opacity:1,SVG_NS:P,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textDecoration textOverflow textOutline".split(" "),
init:function(a,h){this.element="span"===h?t(h):p.createElementNS(this.SVG_NS,h);this.renderer=a},animate:function(C,h,d){h=a.animObject(A(h,this.renderer.globalAnimation,!0));0!==h.duration?(d&&(h.complete=d),I(this,C,h)):this.attr(C,null,d);return this},colorGradient:function(C,h,d){var c=this.renderer,f,G,b,A,g,B,x,M,l,r,k,J=[],e;C.linearGradient?G="linearGradient":C.radialGradient&&(G="radialGradient");if(G){b=C[G];g=c.gradients;x=C.stops;r=d.radialReference;u(b)&&(C[G]=b={x1:b[0],y1:b[1],x2:b[2],
y2:b[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===G&&r&&!q(b.gradientUnits)&&(A=b,b=y(b,c.getRadialAttr(r,A),{gradientUnits:"userSpaceOnUse"}));for(k in b)"id"!==k&&J.push(k,b[k]);for(k in x)J.push(x[k]);J=J.join(",");g[J]?r=g[J].attr("id"):(b.id=r=a.uniqueKey(),g[J]=B=c.createElement(G).attr(b).add(c.defs),B.radAttr=A,B.stops=[],w(x,function(C){0===C[1].indexOf("rgba")?(f=a.color(C[1]),M=f.get("rgb"),l=f.get("a")):(M=C[1],l=1);C=c.createElement("stop").attr({offset:C[0],"stop-color":M,
"stop-opacity":l}).add(B);B.stops.push(C)}));e="url("+c.url+"#"+r+")";d.setAttribute(h,e);d.gradient=J;C.toString=function(){return e}}},applyTextOutline:function(a){var C=this.element,h,d,c,f;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(C.style.fill)));this.fakeTS=!0;this.ySetter=this.xSetter;h=[].slice.call(C.getElementsByTagName("tspan"));a=a.split(" ");d=a[a.length-1];(c=a[0])&&"none"!==c&&(c=c.replace(/(^[\d\.]+)(.*?)$/g,function(a,C,h){return 2*C+h}),w(h,function(a){"highcharts-text-outline"===
a.getAttribute("class")&&l(h,C.removeChild(a))}),f=C.firstChild,w(h,function(a,h){0===h&&(a.setAttribute("x",C.getAttribute("x")),h=C.getAttribute("y"),a.setAttribute("y",h||0),null===h&&C.setAttribute("y",0));a=a.cloneNode(1);v(a,{"class":"highcharts-text-outline",fill:d,stroke:d,"stroke-width":c,"stroke-linejoin":"round"});C.insertBefore(a,f)}))},attr:function(a,h,d,c){var C,f=this.element,b,y=this,A;"string"===typeof a&&void 0!==h&&(C=a,a={},a[C]=h);if("string"===typeof a)y=(this[a+"Getter"]||
this._defaultGetter).call(this,a,f);else{for(C in a)h=a[C],A=!1,c||G(this,C),this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(C)&&(b||(this.symbolAttr(a),b=!0),A=!0),!this.rotation||"x"!==C&&"y"!==C||(this.doTransform=!0),A||(A=this[C+"Setter"]||this._defaultSetter,A.call(this,h,C,f),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(C)&&this.updateShadows(C,h,A));this.doTransform&&(this.updateTransform(),this.doTransform=!1)}d&&d();return y},updateShadows:function(a,
h,d){for(var C=this.shadows,c=C.length;c--;)d.call(C[c],"height"===a?Math.max(h-(C[c].cutHeight||0),0):"d"===a?this.d:h,a,C[c])},addClass:function(a,h){var C=this.attr("class")||"";-1===C.indexOf(a)&&(h||(a=(C+(C?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==v(this.element,"class").indexOf(a)},removeClass:function(a){v(this.element,"class",(v(this.element,"class")||"").replace(a,""));return this},symbolAttr:function(a){var C=this;w("x y r start end width height innerR anchorX anchorY".split(" "),
function(h){C[h]=A(a[h],C[h])});C.attr({d:C.renderer.symbols[C.symbolName](C.x,C.y,C.width,C.height,C)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,h){var C,d={},c;h=h||a.strokeWidth||0;c=Math.round(h)%2/2;a.x=Math.floor(a.x||this.x||0)+c;a.y=Math.floor(a.y||this.y||0)+c;a.width=Math.floor((a.width||this.width||0)-2*c);a.height=Math.floor((a.height||this.height||0)-2*c);q(a.strokeWidth)&&(a.strokeWidth=h);for(C in a)this[C]!==a[C]&&
(this[C]=d[C]=a[C]);return d},css:function(a){var C=this.styles,h={},d=this.element,c,f,G="";c=!C;var b=["textOverflow","width"];a&&a.color&&(a.fill=a.color);if(C)for(f in a)a[f]!==C[f]&&(h[f]=a[f],c=!0);if(c){c=this.textWidth=a&&a.width&&"text"===d.nodeName.toLowerCase()&&J(a.width)||this.textWidth;C&&(a=k(C,h));this.styles=a;c&&!Q&&this.renderer.forExport&&delete a.width;if(B&&!Q)z(this.element,a);else{C=function(a,C){return"-"+C.toLowerCase()};for(f in a)-1===r(f,b)&&(G+=f.replace(/([A-Z])/g,C)+
":"+a[f]+";");G&&v(d,"style",G)}this.added&&(c&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,h){var C=this,d=C.element;F&&"click"===a?(d.ontouchstart=function(a){C.touchEventFired=Date.now();a.preventDefault();h.call(d,a)},d.onclick=function(a){(-1===S.navigator.userAgent.indexOf("Android")||1100<Date.now()-(C.touchEventFired||0))&&h.call(d,a)}):d["on"+a]=h;return this},setRadialReference:function(a){var C=
this.renderer.gradients[this.element.gradient];this.element.radialReference=a;C&&C.radAttr&&C.animate(this.renderer.getRadialAttr(a,C.radAttr));return this},translate:function(a,h){return this.attr({translateX:a,translateY:h})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,h=this.translateY||0,d=this.scaleX,c=this.scaleY,f=this.inverted,G=this.rotation,b=this.element;f&&(a+=this.width,h+=this.height);a=["translate("+a+","+
h+")"];f?a.push("rotate(90) scale(-1,1)"):G&&a.push("rotate("+G+" "+(b.getAttribute("x")||0)+" "+(b.getAttribute("y")||0)+")");(q(d)||q(c))&&a.push("scale("+A(d,1)+" "+A(c,1)+")");a.length&&b.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,h,d){var C,c,f,G,b={};c=this.renderer;f=c.alignedObjects;var y,g;if(a){if(this.alignOptions=a,this.alignByTranslate=h,!d||x(d))this.alignTo=C=d||"renderer",l(f,this),f.push(this),
d=null}else a=this.alignOptions,h=this.alignByTranslate,C=this.alignTo;d=A(d,c[C],c);C=a.align;c=a.verticalAlign;f=(d.x||0)+(a.x||0);G=(d.y||0)+(a.y||0);"right"===C?y=1:"center"===C&&(y=2);y&&(f+=(d.width-(a.width||0))/y);b[h?"translateX":"x"]=Math.round(f);"bottom"===c?g=1:"middle"===c&&(g=2);g&&(G+=(d.height-(a.height||0))/g);b[h?"translateY":"y"]=Math.round(G);this[this.placed?"animate":"attr"](b);this.placed=!0;this.alignAttr=b;return this},getBBox:function(a,h){var C,d=this.renderer,c,f=this.element,
G=this.styles,b,y=this.textStr,g,B=d.cache,x=d.cacheKeys,r;h=A(h,this.rotation);c=h*e;b=G&&G.fontSize;void 0!==y&&(r=y.toString(),-1===r.indexOf("\x3c")&&(r=r.replace(/[0-9]/g,"0")),r+=["",h||0,b,G&&G.width,G&&G.textOverflow].join());r&&!a&&(C=B[r]);if(!C){if(f.namespaceURI===this.SVG_NS||d.forExport){try{(g=this.fakeTS&&function(a){w(f.querySelectorAll(".highcharts-text-outline"),function(C){C.style.display=a})})&&g("none"),C=f.getBBox?k({},f.getBBox()):{width:f.offsetWidth,height:f.offsetHeight},
g&&g("")}catch(U){}if(!C||0>C.width)C={width:0,height:0}}else C=this.htmlGetBBox();d.isSVG&&(a=C.width,d=C.height,G&&"11px"===G.fontSize&&17===Math.round(d)&&(C.height=d=14),h&&(C.width=Math.abs(d*Math.sin(c))+Math.abs(a*Math.cos(c)),C.height=Math.abs(d*Math.cos(c))+Math.abs(a*Math.sin(c))));if(r&&0<C.height){for(;250<x.length;)delete B[x.shift()];B[r]||x.push(r);B[r]=C}}return C},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},
fadeOut:function(a){var C=this;C.animate({opacity:0},{duration:a||150,complete:function(){C.attr({y:-9999})}})},add:function(a){var C=this.renderer,h=this.element,d;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&C.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)d=this.zIndexSetter();d||(a?a.element:C.box).appendChild(h);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var h=a.parentNode;h&&h.removeChild(a)},destroy:function(){var a=
this.element||{},h=this.renderer.isSVG&&"SPAN"===a.nodeName&&this.parentGroup,d,c;a.onclick=a.onmouseout=a.onmouseover=a.onmousemove=a.point=null;G(this);this.clipPath&&(this.clipPath=this.clipPath.destroy());if(this.stops){for(c=0;c<this.stops.length;c++)this.stops[c]=this.stops[c].destroy();this.stops=null}this.safeRemoveChild(a);for(this.destroyShadows();h&&h.div&&0===h.div.childNodes.length;)a=h.parentGroup,this.safeRemoveChild(h.div),delete h.div,h=a;this.alignTo&&l(this.renderer.alignedObjects,
this);for(d in this)delete this[d];return null},shadow:function(a,h,d){var C=[],c,f,G=this.element,b,y,g,B;if(!a)this.destroyShadows();else if(!this.shadows){y=A(a.width,3);g=(a.opacity||.15)/y;B=this.parentInverted?"(-1,-1)":"("+A(a.offsetX,1)+", "+A(a.offsetY,1)+")";for(c=1;c<=y;c++)f=G.cloneNode(0),b=2*y+1-2*c,v(f,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":g*c,"stroke-width":b,transform:"translate"+B,fill:"none"}),d&&(v(f,"height",Math.max(v(f,"height")-b,0)),f.cutHeight=b),h?
h.element.appendChild(f):G.parentNode.insertBefore(f,G),C.push(f);this.shadows=C}return this},destroyShadows:function(){w(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=A(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,h,d){a&&a.join&&(a=
a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");d.setAttribute(h,a);this[h]=a},dashstyleSetter:function(a){var h,C=this["stroke-width"];"inherit"===C&&(C=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(h=a.length;h--;)a[h]=J(a[h])*C;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",
a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,h,d){this[h]=a;d.setAttribute(h,a)},titleSetter:function(a){var h=this.element.getElementsByTagName("title")[0];h||(h=p.createElementNS(this.SVG_NS,"title"),this.element.appendChild(h));h.firstChild&&h.removeChild(h.firstChild);h.appendChild(p.createTextNode(String(A(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,
this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,h,d){"string"===typeof a?d.setAttribute(h,a):a&&this.colorGradient(a,h,d)},visibilitySetter:function(a,h,d){"inherit"===a?d.removeAttribute(h):d.setAttribute(h,a)},zIndexSetter:function(a,h){var C=this.renderer,d=this.parentGroup,c=(d||C).element||C.box,f,G=this.element,b;f=this.added;var y;q(a)&&(G.zIndex=a,a=+a,this[h]===a&&(f=!1),this[h]=a);if(f){(a=this.zIndex)&&d&&(d.handleZ=!0);h=c.childNodes;for(y=0;y<h.length&&
!b;y++)d=h[y],f=d.zIndex,d!==G&&(J(f)>a||!q(a)&&q(f)||0>a&&!q(f)&&c!==C.box)&&(c.insertBefore(G,d),b=!0);b||c.appendChild(G)}return b},_defaultSetter:function(a,h,d){d.setAttribute(h,a)}};E.prototype.yGetter=E.prototype.xGetter;E.prototype.translateXSetter=E.prototype.translateYSetter=E.prototype.rotationSetter=E.prototype.verticalAlignSetter=E.prototype.scaleXSetter=E.prototype.scaleYSetter=function(a,h){this[h]=a;this.doTransform=!0};E.prototype["stroke-widthSetter"]=E.prototype.strokeSetter=function(a,
h,d){this[h]=a;this.stroke&&this["stroke-width"]?(E.prototype.fillSetter.call(this,this.stroke,"stroke",d),d.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===h&&0===a&&this.hasStroke&&(d.removeAttribute("stroke"),this.hasStroke=!1)};D=a.SVGRenderer=function(){this.init.apply(this,arguments)};D.prototype={Element:E,SVG_NS:P,init:function(a,h,d,G,b,y){var C;G=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(G));C=G.element;
a.appendChild(C);-1===a.innerHTML.indexOf("xmlns")&&v(C,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=C;this.boxWrapper=G;this.alignedObjects=[];this.url=(f||c)&&p.getElementsByTagName("base").length?S.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highstock 5.0.7"));this.defs=this.createElement("defs").add();this.allowHTML=y;this.forExport=b;this.gradients=
{};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(h,d,!1);var A;f&&a.getBoundingClientRect&&(h=function(){z(a,{left:0,top:0});A=a.getBoundingClientRect();z(a,{left:Math.ceil(A.left)-A.left+"px",top:Math.ceil(A.top)-A.top+"px"})},h(),this.unSubPixelFix=H(S,"resize",h))},getStyle:function(a){return this.style=k({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},
destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();b(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var h=new this.Element;h.init(this,a);return h},draw:L,getRadialAttr:function(a,h){return{cx:a[0]-a[2]/2+h.cx*a[2],cy:a[1]-a[2]/2+h.cy*a[2],r:h.r*a[2]}},buildText:function(a){var h=a.element,d=this,c=d.forExport,f=A(a.textStr,"").toString(),
C=-1!==f.indexOf("\x3c"),G=h.childNodes,b,y,B,r,x=v(h,"x"),l=a.styles,u=a.textWidth,k=l&&l.lineHeight,e=l&&l.textOutline,F=l&&"ellipsis"===l.textOverflow,L=l&&"nowrap"===l.whiteSpace,t=l&&l.fontSize,q,m=G.length,l=u&&!a.added&&this.box,n=function(a){var c;c=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:t||d.style.fontSize||12;return k?J(k):d.fontMetrics(c,a.getAttribute("style")?a:h).h};q=[f,F,L,k,e,t,u].join();if(q!==a.textCache){for(a.textCache=q;m--;)h.removeChild(G[m]);C||e||F||u||-1!==
f.indexOf(" ")?(b=/<.*class="([^"]+)".*>/,y=/<.*style="([^"]+)".*>/,B=/<.*href="(http[^"]+)".*>/,l&&l.appendChild(h),f=C?f.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[f],f=g(f,function(a){return""!==a}),w(f,function(f,C){var G,A=0;f=f.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");
G=f.split("|||");w(G,function(f){if(""!==f||1===G.length){var g={},l=p.createElementNS(d.SVG_NS,"tspan"),k,J;b.test(f)&&(k=f.match(b)[1],v(l,"class",k));y.test(f)&&(J=f.match(y)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),v(l,"style",J));B.test(f)&&!c&&(v(l,"onclick",'location.href\x3d"'+f.match(B)[1]+'"'),z(l,{cursor:"pointer"}));f=(f.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==f){l.appendChild(p.createTextNode(f));A?g.dx=0:C&&null!==x&&(g.x=x);v(l,g);
h.appendChild(l);!A&&C&&(!Q&&c&&z(l,{display:"block"}),v(l,"dy",n(l)));if(u){g=f.replace(/([^\^])-/g,"$1- ").split(" ");k=1<G.length||C||1<g.length&&!L;for(var e,w,M=[],t=n(l),q=a.rotation,m=f,N=m.length;(k||F)&&(g.length||M.length);)a.rotation=0,e=a.getBBox(!0),w=e.width,!Q&&d.forExport&&(w=d.measureSpanWidth(l.firstChild.data,a.styles)),e=w>u,void 0===r&&(r=e),F&&r?(N/=2,""===m||!e&&.5>N?g=[]:(m=f.substring(0,m.length+(e?-1:1)*Math.ceil(N)),g=[m+(3<u?"\u2026":"")],l.removeChild(l.firstChild))):
e&&1!==g.length?(l.removeChild(l.firstChild),M.unshift(g.pop())):(g=M,M=[],g.length&&!L&&(l=p.createElementNS(P,"tspan"),v(l,{dy:t,x:x}),J&&v(l,"style",J),h.appendChild(l)),w>u&&(u=w)),g.length&&l.appendChild(p.createTextNode(g.join(" ").replace(/- /g,"-")));a.rotation=q}A++}}})}),r&&a.attr("title",a.textStr),l&&l.removeChild(h),e&&a.applyTextOutline&&a.applyTextOutline(e)):h.appendChild(p.createTextNode(f.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=m(a).rgba;return 510<
a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,h,d,f,c,G,b,g,A){var C=this.label(a,h,d,A,null,null,null,null,"button"),l=0;C.attr(y({padding:8,r:2},c));var r,x,u,J;c=y({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},c);r=c.style;delete c.style;G=y(c,{fill:"#e6e6e6"},G);x=G.style;delete G.style;b=y(c,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},b);u=b.style;delete b.style;g=y(c,{style:{color:"#cccccc"}},g);J=g.style;
delete g.style;H(C.element,B?"mouseover":"mouseenter",function(){3!==l&&C.setState(1)});H(C.element,B?"mouseout":"mouseleave",function(){3!==l&&C.setState(l)});C.setState=function(a){1!==a&&(C.state=l=a);C.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);C.attr([c,G,b,g][a||0]).css([r,x,u,J][a||0])};C.attr(c).css(k({cursor:"default"},r));return C.on("click",function(a){3!==l&&f.call(C,a)})},crispLine:function(a,
h){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-h%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+h%2/2);return a},path:function(a){var h={fill:"none"};u(a)?h.d=a:d(a)&&k(h,a);return this.createElement("path").attr(h)},circle:function(a,h,c){a=d(a)?a:{x:a,y:h,r:c};h=this.createElement("circle");h.xSetter=h.ySetter=function(a,h,d){d.setAttribute("c"+h,a)};return h.attr(a)},arc:function(a,h,c,f,G,b){d(a)&&(h=a.y,c=a.r,f=a.innerR,G=a.start,b=a.end,a=a.x);a=this.symbol("arc",a||0,h||0,c||0,c||0,{innerR:f||
0,start:G||0,end:b||0});a.r=c;return a},rect:function(a,h,c,f,G,b){G=d(a)?a.r:G;var C=this.createElement("rect");a=d(a)?a:void 0===a?{}:{x:a,y:h,width:Math.max(c,0),height:Math.max(f,0)};void 0!==b&&(a.strokeWidth=b,a=C.crisp(a));a.fill="none";G&&(a.r=G);C.rSetter=function(a,h,d){v(d,{rx:a,ry:a})};return C.attr(a)},setSize:function(a,h,d){var c=this.alignedObjects,f=c.length;this.width=a;this.height=h;for(this.boxWrapper.animate({width:a,height:h},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+
" "+this.attr("height")})},duration:A(d,!0)?void 0:0});f--;)c[f].align()},g:function(a){var h=this.createElement("g");return a?h.attr({"class":"highcharts-"+a}):h},image:function(a,h,d,c,f){var G={preserveAspectRatio:"none"};1<arguments.length&&k(G,{x:h,y:d,width:c,height:f});G=this.createElement("image").attr(G);G.element.setAttributeNS?G.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):G.element.setAttribute("hc-svg-href",a);return G},symbol:function(a,h,d,c,f,G){var b=this,C,y=this.symbols[a],
g=q(h)&&y&&this.symbols[a](Math.round(h),Math.round(d),c,f,G),l=/^url\((.*?)\)$/,B,r;y?(C=this.path(g),C.attr("fill","none"),k(C,{symbolName:a,x:h,y:d,width:c,height:f}),G&&k(C,G)):l.test(a)&&(B=a.match(l)[1],C=this.image(B),C.imgwidth=A(N[B]&&N[B].width,G&&G.width),C.imgheight=A(N[B]&&N[B].height,G&&G.height),r=function(){C.attr({width:C.width,height:C.height})},w(["width","height"],function(a){C[a+"Setter"]=function(a,h){var d={},c=this["img"+h],f="width"===h?"translateX":"translateY";this[h]=a;
q(c)&&(this.element&&this.element.setAttribute(h,c),this.alignByTranslate||(d[f]=((this[h]||0)-c)/2,this.attr(d)))}}),q(h)&&C.attr({x:h,y:d}),C.isImg=!0,q(C.imgwidth)&&q(C.imgheight)?r():(C.attr({width:0,height:0}),t("img",{onload:function(){var a=n[b.chartIndex];0===this.width&&(z(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));N[B]={width:this.width,height:this.height};C.imgwidth=this.width;C.imgheight=this.height;C.element&&r();this.parentNode&&this.parentNode.removeChild(this);
b.imgCount--;if(!b.imgCount&&a&&a.onload)a.onload()},src:B}),this.imgCount++));return C},symbols:{circle:function(a,h,d,c){return this.arc(a+d/2,h+c/2,d/2,c/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,h,d,c){return["M",a,h,"L",a+d,h,a+d,h+c,a,h+c,"Z"]},triangle:function(a,h,d,c){return["M",a+d/2,h,"L",a+d,h+c,a,h+c,"Z"]},"triangle-down":function(a,h,d,c){return["M",a,h,"L",a+d,h,a+d/2,h+c,"Z"]},diamond:function(a,h,d,c){return["M",a+d/2,h,"L",a+d,h+c/2,a+d/2,h+c,a,h+c/2,"Z"]},arc:function(a,
h,d,c,f){var G=f.start,b=f.r||d,C=f.r||c||d,y=f.end-.001;d=f.innerR;c=f.open;var g=Math.cos(G),A=Math.sin(G),l=Math.cos(y),y=Math.sin(y);f=f.end-G<Math.PI?0:1;b=["M",a+b*g,h+C*A,"A",b,C,0,f,1,a+b*l,h+C*y];q(d)&&b.push(c?"M":"L",a+d*l,h+d*y,"A",d,d,0,f,0,a+d*g,h+d*A);b.push(c?"":"Z");return b},callout:function(a,h,d,c,f){var G=Math.min(f&&f.r||0,d,c),b=G+6,y=f&&f.anchorX;f=f&&f.anchorY;var g;g=["M",a+G,h,"L",a+d-G,h,"C",a+d,h,a+d,h,a+d,h+G,"L",a+d,h+c-G,"C",a+d,h+c,a+d,h+c,a+d-G,h+c,"L",a+G,h+c,"C",
a,h+c,a,h+c,a,h+c-G,"L",a,h+G,"C",a,h,a,h,a+G,h];y&&y>d?f>h+b&&f<h+c-b?g.splice(13,3,"L",a+d,f-6,a+d+6,f,a+d,f+6,a+d,h+c-G):g.splice(13,3,"L",a+d,c/2,y,f,a+d,c/2,a+d,h+c-G):y&&0>y?f>h+b&&f<h+c-b?g.splice(33,3,"L",a,f+6,a-6,f,a,f-6,a,h+G):g.splice(33,3,"L",a,c/2,y,f,a,c/2,a,h+G):f&&f>c&&y>a+b&&y<a+d-b?g.splice(23,3,"L",y+6,h+c,y,h+c+6,y-6,h+c,a+G,h+c):f&&0>f&&y>a+b&&y<a+d-b&&g.splice(3,3,"L",y-6,h,y,h-6,y+6,h,d-G,h);return g}},clipRect:function(h,d,c,f){var G=a.uniqueKey(),b=this.createElement("clipPath").attr({id:G}).add(this.defs);
h=this.rect(h,d,c,f,0).add(b);h.id=G;h.clipPath=b;h.count=0;return h},text:function(a,h,d,c){var f=!Q&&this.forExport,G={};if(c&&(this.allowHTML||!this.forExport))return this.html(a,h,d);G.x=Math.round(h||0);d&&(G.y=Math.round(d));if(a||0===a)G.text=a;a=this.createElement("text").attr(G);f&&a.css({position:"absolute"});c||(a.xSetter=function(a,h,d){var c=d.getElementsByTagName("tspan"),f,G=d.getAttribute(h),b;for(b=0;b<c.length;b++)f=c[b],f.getAttribute(h)===G&&f.setAttribute(h,a);d.setAttribute(h,
a)});return a},fontMetrics:function(a,h){a=a||h&&h.style&&h.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?J(a):/em/.test(a)?parseFloat(a)*(h?this.fontMetrics(null,h.parentNode).f:16):12;h=24>a?a+3:Math.round(1.2*a);return{h:h,b:Math.round(.8*h),f:a}},rotCorr:function(a,h,d){var c=a;h&&d&&(c=Math.max(c*Math.cos(h*e),4));return{x:-a/3*Math.sin(h*e),y:c}},label:function(a,d,c,f,G,b,g,A,l){var C=this,B=C.g("button"!==l&&"label"),r=B.text=C.text("",0,0,g).attr({zIndex:1}),x,u,J=0,e=3,
p=0,F,L,Q,P,t,m={},n,N,z=/^url\((.*?)\)$/.test(f),M=z,v,S,R,O;l&&B.addClass("highcharts-"+l);M=z;v=function(){return(n||0)%2/2};S=function(){var a=r.element.style,h={};u=(void 0===F||void 0===L||t)&&q(r.textStr)&&r.getBBox();B.width=(F||u.width||0)+2*e+p;B.height=(L||u.height||0)+2*e;N=e+C.fontMetrics(a&&a.fontSize,r).b;M&&(x||(B.box=x=C.symbols[f]||z?C.symbol(f):C.rect(),x.addClass(("button"===l?"":"highcharts-label-box")+(l?" highcharts-"+l+"-box":"")),x.add(B),a=v(),h.x=a,h.y=(A?-N:0)+a),h.width=
Math.round(B.width),h.height=Math.round(B.height),x.attr(k(h,m)),m={})};R=function(){var a=p+e,h;h=A?0:N;q(F)&&u&&("center"===t||"right"===t)&&(a+={center:.5,right:1}[t]*(F-u.width));if(a!==r.x||h!==r.y)r.attr("x",a),void 0!==h&&r.attr("y",h);r.x=a;r.y=h};O=function(a,h){x?x.attr(a,h):m[a]=h};B.onAdd=function(){r.add(B);B.attr({text:a||0===a?a:"",x:d,y:c});x&&q(G)&&B.attr({anchorX:G,anchorY:b})};B.widthSetter=function(a){F=a};B.heightSetter=function(a){L=a};B["text-alignSetter"]=function(a){t=a};
B.paddingSetter=function(a){q(a)&&a!==e&&(e=B.padding=a,R())};B.paddingLeftSetter=function(a){q(a)&&a!==p&&(p=a,R())};B.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==J&&(J=a,u&&B.attr({x:Q}))};B.textSetter=function(a){void 0!==a&&r.textSetter(a);S();R()};B["stroke-widthSetter"]=function(a,h){a&&(M=!0);n=this["stroke-width"]=a;O(h,a)};B.strokeSetter=B.fillSetter=B.rSetter=function(a,h){"fill"===h&&a&&(M=!0);O(h,a)};B.anchorXSetter=function(a,h){G=a;O(h,Math.round(a)-v()-Q)};B.anchorYSetter=
function(a,h){b=a;O(h,a-P)};B.xSetter=function(a){B.x=a;J&&(a-=J*((F||u.width)+2*e));Q=Math.round(a);B.attr("translateX",Q)};B.ySetter=function(a){P=B.y=Math.round(a);B.attr("translateY",P)};var T=B.css;return k(B,{css:function(a){if(a){var h={};a=y(a);w(B.textProps,function(d){void 0!==a[d]&&(h[d]=a[d],delete a[d])});r.css(h)}return T.call(B,a)},getBBox:function(){return{width:u.width+2*e,height:u.height+2*e,x:u.x-e,y:u.y-e}},shadow:function(a){a&&(S(),x&&x.shadow(a));return B},destroy:function(){h(B.element,
"mouseenter");h(B.element,"mouseleave");r&&(r=r.destroy());x&&(x=x.destroy());E.prototype.destroy.call(B);B=C=S=R=O=null}})}};a.Renderer=D})(K);(function(a){var E=a.attr,D=a.createElement,H=a.css,I=a.defined,v=a.each,n=a.extend,m=a.isFirefox,z=a.isMS,t=a.isWebKit,q=a.pInt,e=a.SVGRenderer,b=a.win,p=a.wrap;n(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace=
"nowrap",a.overflow="hidden");this.styles=n(this.styles,a);H(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position="absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,l=this.translateX||0,g=this.translateY||0,e=this.x||0,r=this.y||0,u=this.textAlign||"left",f={left:0,center:.5,right:1}[u],B=this.styles;H(b,{marginLeft:l,marginTop:g});
this.shadows&&v(this.shadows,function(a){H(a,{marginLeft:l+1,marginTop:g+1})});this.inverted&&v(b.childNodes,function(d){a.invertChild(d,b)});if("SPAN"===b.tagName){var d=this.rotation,x=q(this.textWidth),c=B&&B.whiteSpace,y=[d,u,b.innerHTML,this.textWidth,this.textAlign].join();y!==this.cTT&&(B=a.fontMetrics(b.style.fontSize).b,I(d)&&this.setSpanRotation(d,f,B),H(b,{width:"",whiteSpace:c||"nowrap"}),b.offsetWidth>x&&/[ \-]/.test(b.textContent||b.innerText)&&H(b,{width:x+"px",display:"block",whiteSpace:c||
"normal"}),this.getSpanCorrection(b.offsetWidth,B,f,d,u));H(b,{left:e+(this.xCorr||0)+"px",top:r+(this.yCorr||0)+"px"});t&&(B=b.offsetHeight);this.cTT=y}}else this.alignOnAdd=!0},setSpanRotation:function(a,k,l){var g={},e=z?"-ms-transform":t?"-webkit-transform":m?"MozTransform":b.opera?"-o-transform":"";g[e]=g.transform="rotate("+a+"deg)";g[e+(m?"Origin":"-origin")]=g.transformOrigin=100*k+"% "+l+"px";H(this.element,g)},getSpanCorrection:function(a,b,l){this.xCorr=-a*l;this.yCorr=-b}});n(e.prototype,
{html:function(a,b,l){var g=this.createElement("span"),k=g.element,r=g.renderer,u=r.isSVG,f=function(a,d){v(["opacity","visibility"],function(f){p(a,f+"Setter",function(a,f,b,g){a.call(this,f,b,g);d[b]=f})})};g.textSetter=function(a){a!==k.innerHTML&&delete this.bBox;k.innerHTML=this.textStr=a;g.htmlUpdateTransform()};u&&f(g,g.element.style);g.xSetter=g.ySetter=g.alignSetter=g.rotationSetter=function(a,d){"align"===d&&(d="textAlign");g[d]=a;g.htmlUpdateTransform()};g.attr({text:a,x:Math.round(b),
y:Math.round(l)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});k.style.whiteSpace="nowrap";g.css=g.htmlCss;u&&(g.add=function(a){var d,b=r.box.parentNode,c=[];if(this.parentGroup=a){if(d=a.div,!d){for(;a;)c.push(a),a=a.parentGroup;v(c.reverse(),function(a){var y,A=E(a.element,"class");A&&(A={className:A});d=a.div=a.div||D("div",A,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&
a.styles.pointerEvents},d||b);y=d.style;n(a,{on:function(){g.on.apply({element:c[0].div},arguments);return a},translateXSetter:function(d,h){y.left=d+"px";a[h]=d;a.doTransform=!0},translateYSetter:function(d,h){y.top=d+"px";a[h]=d;a.doTransform=!0}});f(a,y)})}}else d=b;d.appendChild(k);g.added=!0;g.alignOnAdd&&g.htmlUpdateTransform();return g});return g}})})(K);(function(a){var E,D,H=a.createElement,I=a.css,v=a.defined,n=a.deg2rad,m=a.discardElement,z=a.doc,t=a.each,q=a.erase,e=a.extend;E=a.extendClass;
var b=a.isArray,p=a.isNumber,w=a.isObject,k=a.merge;D=a.noop;var l=a.pick,g=a.pInt,F=a.SVGElement,r=a.SVGRenderer,u=a.win;a.svg||(D={docMode8:z&&8===z.documentMode,init:function(a,b){var d=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],f=["position: ","absolute",";"],c="div"===b;("shape"===b||c)&&f.push("left:0;top:0;width:1px;height:1px;");f.push("visibility: ",c?"hidden":"visible");d.push(' style\x3d"',f.join(""),'"/\x3e');b&&(d=c||"span"===b||"img"===b?d.join(""):a.prepVML(d),this.element=H(d));this.renderer=
a},add:function(a){var f=this.renderer,d=this.element,b=f.box,c=a&&a.inverted,b=a?a.element||a:b;a&&(this.parentGroup=a);c&&f.invertChild(d,b);b.appendChild(d);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:F.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*n),d=Math.sin(a*n);I(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",
b,", M12\x3d",-d,", M21\x3d",d,", M22\x3d",b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,d,g,c){var f=g?Math.cos(g*n):1,B=g?Math.sin(g*n):0,A=l(this.elemHeight,this.element.offsetHeight),r;this.xCorr=0>f&&-a;this.yCorr=0>B&&-A;r=0>f*B;this.xCorr+=B*b*(r?1-d:d);this.yCorr-=f*b*(g?r?d:1-d:1);c&&"left"!==c&&(this.xCorr-=a*d*(0>f?-1:1),g&&(this.yCorr-=A*d*(0>B?-1:1)),I(this.element,{textAlign:c}))},pathToVML:function(a){for(var f=a.length,d=[];f--;)p(a[f])?d[f]=
Math.round(10*a[f])-5:"Z"===a[f]?d[f]="x":(d[f]=a[f],!a.isArc||"wa"!==a[f]&&"at"!==a[f]||(d[f+5]===d[f+7]&&(d[f+7]+=a[f+7]>a[f+5]?1:-1),d[f+6]===d[f+8]&&(d[f+8]+=a[f+8]>a[f+6]?1:-1)));return d.join(" ")||"x"},clip:function(a){var f=this,d;a?(d=a.members,q(d,f),d.push(f),f.destroyClip=function(){q(d,f)},a=a.getCSS(f)):(f.destroyClip&&f.destroyClip(),a={clip:f.docMode8?"inherit":"rect(auto)"});return f.css(a)},css:F.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&m(a)},destroy:function(){this.destroyClip&&
this.destroyClip();return F.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=u.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var d;a=a.split(/[ ,]/);d=a.length;if(9===d||11===d)a[d-4]=a[d-2]=g(a[d-2])-10*b;return a.join(" ")},shadow:function(a,b,d){var f=[],c,y=this.element,r=this.renderer,A,B=y.style,h,G=y.path,u,k,e,p;G&&"string"!==typeof G.value&&(G="x");k=G;if(a){e=l(a.width,3);p=(a.opacity||.15)/e;for(c=1;3>=c;c++)u=2*e+1-2*c,d&&
(k=this.cutOffPath(G.value,u+.5)),h=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',u,'" filled\x3d"false" path\x3d"',k,'" coordsize\x3d"10 10" style\x3d"',y.style.cssText,'" /\x3e'],A=H(r.prepVML(h),null,{left:g(B.left)+l(a.offsetX,1),top:g(B.top)+l(a.offsetY,1)}),d&&(A.cutOff=u+1),h=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',p*c,'"/\x3e'],H(r.prepVML(h),null,null,A),b?b.element.appendChild(A):y.parentNode.insertBefore(A,y),f.push(A);this.shadows=f}return this},updateShadows:D,
setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,d){(d.getElementsByTagName("stroke")[0]||H(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,d))[b]=a||"solid";this[b]=a},dSetter:function(a,b,d){var f=this.shadows;a=a||[];this.d=a.join&&a.join(" ");d.path=a=this.pathToVML(a);if(f)for(d=f.length;d--;)f[d].path=f[d].cutOff?this.cutOffPath(a,f[d].cutOff):a;this.setAttr(b,
a)},fillSetter:function(a,b,d){var f=d.nodeName;"SPAN"===f?d.style.color=a:"IMG"!==f&&(d.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,d,b,this)))},"fill-opacitySetter":function(a,b,d){H(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,d)},opacitySetter:D,rotationSetter:function(a,b,d){d=d.style;this[b]=d[b]=a;d.left=-Math.round(Math.sin(a*n)+1)+"px";d.top=Math.round(Math.cos(a*n))+"px"},strokeSetter:function(a,b,d){this.setAttr("strokecolor",
this.renderer.color(a,d,b,this))},"stroke-widthSetter":function(a,b,d){d.stroked=!!a;this[b]=a;p(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,d){"inherit"===a&&(a="visible");this.shadows&&t(this.shadows,function(d){d.style[b]=a});"DIV"===d.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(d.style[b]=a?"visible":"hidden"),b="top");d.style[b]=a},xSetter:function(a,b,d){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?
(this[b]=a,this.updateClipping()):d.style[b]=a},zIndexSetter:function(a,b,d){d.style[b]=a}},D["stroke-opacitySetter"]=D["fill-opacitySetter"],a.VMLElement=D=E(F,D),D.prototype.ySetter=D.prototype.widthSetter=D.prototype.heightSetter=D.prototype.xSetter,D={Element:D,isIE8:-1<u.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,d){var f,c;this.alignedObjects=[];f=this.createElement("div").css({position:"relative"});c=f.element;a.appendChild(f.element);this.isVML=!0;this.box=c;this.boxWrapper=
f;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,d,!1);if(!z.namespaces.hcv){z.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{z.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(y){z.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},
clipRect:function(a,b,d,g){var c=this.createElement(),f=w(a);return e(c,{members:[],count:0,left:(f?a.x:a)+1,top:(f?a.y:b)+1,width:(f?a.width:d)-1,height:(f?a.height:g)-1,getCSS:function(a){var d=a.element,c=d.nodeName,h=a.inverted,b=this.top-("shape"===c?d.offsetTop:0),f=this.left,d=f+this.width,g=b+this.height,b={clip:"rect("+Math.round(h?f:b)+"px,"+Math.round(h?g:d)+"px,"+Math.round(h?d:g)+"px,"+Math.round(h?b:f)+"px)"};!h&&a.docMode8&&"DIV"===c&&e(b,{width:d+"px",height:g+"px"});return b},updateClipping:function(){t(c.members,
function(a){a.element&&a.css(c.getCSS(a))})}})},color:function(b,g,d,l){var c=this,f,r=/^rgba/,A,u,h="none";b&&b.linearGradient?u="gradient":b&&b.radialGradient&&(u="pattern");if(u){var G,x,k=b.linearGradient||b.radialGradient,e,B,C,p,F,w="";b=b.stops;var q,m=[],n=function(){A=['\x3cfill colors\x3d"'+m.join(",")+'" opacity\x3d"',C,'" o:opacity2\x3d"',B,'" type\x3d"',u,'" ',w,'focus\x3d"100%" method\x3d"any" /\x3e'];H(c.prepVML(A),null,null,g)};e=b[0];q=b[b.length-1];0<e[0]&&b.unshift([0,e[1]]);1>
q[0]&&b.push([1,q[1]]);t(b,function(h,d){r.test(h[1])?(f=a.color(h[1]),G=f.get("rgb"),x=f.get("a")):(G=h[1],x=1);m.push(100*h[0]+"% "+G);d?(C=x,p=G):(B=x,F=G)});if("fill"===d)if("gradient"===u)d=k.x1||k[0]||0,b=k.y1||k[1]||0,e=k.x2||k[2]||0,k=k.y2||k[3]||0,w='angle\x3d"'+(90-180*Math.atan((k-b)/(e-d))/Math.PI)+'"',n();else{var h=k.r,z=2*h,v=2*h,D=k.cx,E=k.cy,I=g.radialReference,K,h=function(){I&&(K=l.getBBox(),D+=(I[0]-K.x)/K.width-.5,E+=(I[1]-K.y)/K.height-.5,z*=I[2]/K.width,v*=I[2]/K.height);w=
'src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+z+","+v+'" origin\x3d"0.5,0.5" position\x3d"'+D+","+E+'" color2\x3d"'+F+'" ';n()};l.added?h():l.onAdd=h;h=p}else h=G}else r.test(b)&&"IMG"!==g.tagName?(f=a.color(b),l[d+"-opacitySetter"](f.get("a"),d,g),h=f.get("rgb")):(h=g.getElementsByTagName(d),h.length&&(h[0].opacity=1,h[0].type="solid"),h=b);return h},prepVML:function(a){var b=this.isIE8;a=a.join("");b?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=
-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:r.prototype.html,path:function(a){var f={coordsize:"10 10"};b(a)?f.d=a:w(a)&&e(f,a);return this.createElement("shape").attr(f)},circle:function(a,b,d){var f=this.symbol("circle");w(a)&&(d=a.r,b=a.y,a=a.x);f.isCircle=!0;f.r=d;return f.attr({x:a,y:b})},g:function(a){var b;
a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(b)},image:function(a,b,d,g,c){var f=this.createElement("img").attr({src:a});1<arguments.length&&f.attr({x:b,y:d,width:g,height:c});return f},createElement:function(a){return"rect"===a?this.symbol(a):r.prototype.createElement.call(this,a)},invertChild:function(a,b){var d=this;b=b.style;var f="IMG"===a.tagName&&a.style;I(a,{flip:"x",left:g(b.width)-(f?g(f.top):1),top:g(b.height)-(f?g(f.left):1),rotation:-90});
t(a.childNodes,function(b){d.invertChild(b,a)})},symbols:{arc:function(a,b,d,g,c){var f=c.start,l=c.end,A=c.r||d||g;d=c.innerR;g=Math.cos(f);var r=Math.sin(f),h=Math.cos(l),G=Math.sin(l);if(0===l-f)return["x"];f=["wa",a-A,b-A,a+A,b+A,a+A*g,b+A*r,a+A*h,b+A*G];c.open&&!d&&f.push("e","M",a,b);f.push("at",a-d,b-d,a+d,b+d,a+d*h,b+d*G,a+d*g,b+d*r,"x","e");f.isArc=!0;return f},circle:function(a,b,d,g,c){c&&v(c.r)&&(d=g=2*c.r);c&&c.isCircle&&(a-=d/2,b-=g/2);return["wa",a,b,a+d,b+g,a+d,b+g/2,a+d,b+g/2,"e"]},
rect:function(a,b,d,g,c){return r.prototype.symbols[v(c)&&c.r?"callout":"square"].call(0,a,b,d,g,c)}}},a.VMLRenderer=E=function(){this.init.apply(this,arguments)},E.prototype=k(r.prototype,D),a.Renderer=E);r.prototype.measureSpanWidth=function(a,b){var d=z.createElement("span");a=z.createTextNode(a);d.appendChild(a);I(d,b);this.box.appendChild(d);b=d.offsetWidth;m(d);return b}})(K);(function(a){function E(){var t=a.defaultOptions.global,q=z.moment;if(t.timezone){if(q)return function(a){return-q.tz(a,
t.timezone).utcOffset()};a.error(25)}return t.useUTC&&t.getTimezoneOffset}function D(){var t=a.defaultOptions.global,q,e=t.useUTC,b=e?"getUTC":"get",p=e?"setUTC":"set";a.Date=q=t.Date||z.Date;q.hcTimezoneOffset=e&&t.timezoneOffset;q.hcGetTimezoneOffset=E();q.hcMakeTime=function(a,b,l,g,p,r){var u;e?(u=q.UTC.apply(0,arguments),u+=v(u)):u=(new q(a,b,m(l,1),m(g,0),m(p,0),m(r,0))).getTime();return u};I("Minutes Hours Day Date Month FullYear".split(" "),function(a){q["hcGet"+a]=b+a});I("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),
function(a){q["hcSet"+a]=p+a})}var H=a.color,I=a.each,v=a.getTZOffset,n=a.merge,m=a.pick,z=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.7/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",
width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",
month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:H("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",
position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(t){a.defaultOptions=n(!0,a.defaultOptions,t);D();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;D()})(K);(function(a){var E=a.arrayMax,D=a.arrayMin,H=a.defined,I=a.destroyObjectProperties,v=a.each,n=a.erase,m=a.merge,z=a.pick;a.PlotLineOrBand=function(a,q){this.axis=
a;q&&(this.options=q,this.id=q.id)};a.PlotLineOrBand.prototype={render:function(){var a=this,q=a.axis,e=q.horiz,b=a.options,p=b.label,w=a.label,k=b.to,l=b.from,g=b.value,F=H(l)&&H(k),r=H(g),u=a.svgElem,f=!u,B=[],d,x=b.color,c=z(b.zIndex,0),y=b.events,B={"class":"highcharts-plot-"+(F?"band ":"line ")+(b.className||"")},L={},A=q.chart.renderer,J=F?"bands":"lines",h=q.log2lin;q.isLog&&(l=h(l),k=h(k),g=h(g));r?(B={stroke:x,"stroke-width":b.width},b.dashStyle&&(B.dashstyle=b.dashStyle)):F&&(x&&(B.fill=
x),b.borderWidth&&(B.stroke=b.borderColor,B["stroke-width"]=b.borderWidth));L.zIndex=c;J+="-"+c;(x=q[J])||(q[J]=x=A.g("plot-"+J).attr(L).add());f&&(a.svgElem=u=A.path().attr(B).add(x));if(r)B=q.getPlotLinePath(g,u.strokeWidth());else if(F)B=q.getPlotBandPath(l,k,b);else return;if(f&&B&&B.length){if(u.attr({d:B}),y)for(d in b=function(h){u.on(h,function(b){y[h].apply(a,[b])})},y)b(d)}else u&&(B?(u.show(),u.animate({d:B})):(u.hide(),w&&(a.label=w=w.destroy())));p&&H(p.text)&&B&&B.length&&0<q.width&&
0<q.height&&!B.flat?(p=m({align:e&&F&&"center",x:e?!F&&4:10,verticalAlign:!e&&F&&"middle",y:e?F?16:10:F?6:-4,rotation:e&&!F&&90},p),this.renderLabel(p,B,F,c)):w&&w.hide();return a},renderLabel:function(a,q,e,b){var p=this.label,w=this.axis.chart.renderer;p||(p={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(e?"band":"line")+"-label "+(a.className||"")},p.zIndex=b,this.label=p=w.text(a.text,0,0,a.useHTML).attr(p).add(),p.css(a.style));b=[q[1],q[4],e?q[6]:q[1]];q=[q[2],q[5],
e?q[7]:q[2]];e=D(b);w=D(q);p.align(a,!1,{x:e,y:w,width:E(b)-e,height:E(q)-w});p.show()},destroy:function(){n(this.axis.plotLinesAndBands,this);delete this.axis;I(this)}};a.AxisPlotLineOrBandExtension={getPlotBandPath:function(a,q){q=this.getPlotLinePath(q,null,null,!0);(a=this.getPlotLinePath(a,null,null,!0))&&q?(a.flat=a.toString()===q.toString(),a.push(q[4],q[5],q[1],q[2],"z")):a=null;return a},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,
"plotLines")},addPlotBandOrLine:function(m,q){var e=(new a.PlotLineOrBand(this,m)).render(),b=this.userOptions;e&&(q&&(b[q]=b[q]||[],b[q].push(m)),this.plotLinesAndBands.push(e));return e},removePlotBandOrLine:function(a){for(var q=this.plotLinesAndBands,e=this.options,b=this.userOptions,p=q.length;p--;)q[p].id===a&&q[p].destroy();v([e.plotLines||[],b.plotLines||[],e.plotBands||[],b.plotBands||[]],function(b){for(p=b.length;p--;)b[p].id===a&&n(b,b[p])})}}})(K);(function(a){var E=a.correctFloat,D=
a.defined,H=a.destroyObjectProperties,I=a.isNumber,v=a.merge,n=a.pick,m=a.deg2rad;a.Tick=function(a,m,q,e){this.axis=a;this.pos=m;this.type=q||"";this.isNew=!0;q||e||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,m=a.options,q=a.chart,e=a.categories,b=a.names,p=this.pos,w=m.labels,k=a.tickPositions,l=p===k[0],g=p===k[k.length-1],b=e?n(e[p],b[p],p):p,e=this.label,k=k.info,F;a.isDatetimeAxis&&k&&(F=m.dateTimeLabelFormats[k.higherRanks[p]||k.unitName]);this.isFirst=l;this.isLast=
g;m=a.labelFormatter.call({axis:a,chart:q,isFirst:l,isLast:g,dateTimeLabelFormat:F,value:a.isLog?E(a.lin2log(b)):b});D(e)?e&&e.attr({text:m}):(this.labelLength=(this.label=e=D(m)&&w.enabled?q.renderer.text(m,0,0,w.useHTML).css(v(w.style)).add(a.labelGroup):null)&&e.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var t=this.axis,q=a.x,e=t.chart.chartWidth,b=t.chart.spacing,p=n(t.labelLeft,
Math.min(t.pos,b[3])),b=n(t.labelRight,Math.max(t.pos+t.len,e-b[1])),w=this.label,k=this.rotation,l={left:0,center:.5,right:1}[t.labelAlign],g=w.getBBox().width,F=t.getSlotWidth(),r=F,u=1,f,B={};if(k)0>k&&q-l*g<p?f=Math.round(q/Math.cos(k*m)-p):0<k&&q+l*g>b&&(f=Math.round((e-q)/Math.cos(k*m)));else if(e=q+(1-l)*g,q-l*g<p?r=a.x+r*(1-l)-p:e>b&&(r=b-a.x+r*l,u=-1),r=Math.min(F,r),r<F&&"center"===t.labelAlign&&(a.x+=u*(F-r-l*(F-Math.min(g,r)))),g>r||t.autoRotation&&(w.styles||{}).width)f=r;f&&(B.width=
f,(t.options.labels.style||{}).textOverflow||(B.textOverflow="ellipsis"),w.css(B))},getPosition:function(a,m,q,e){var b=this.axis,p=b.chart,w=e&&p.oldChartHeight||p.chartHeight;return{x:a?b.translate(m+q,null,null,e)+b.transB:b.left+b.offset+(b.opposite?(e&&p.oldChartWidth||p.chartWidth)-b.right-b.left:0),y:a?w-b.bottom+b.offset-(b.opposite?b.height:0):w-b.translate(m+q,null,null,e)-b.transB}},getLabelPosition:function(a,n,q,e,b,p,w,k){var l=this.axis,g=l.transA,F=l.reversed,r=l.staggerLines,u=l.tickRotCorr||
{x:0,y:0},f=b.y;D(f)||(f=0===l.side?q.rotation?-8:-q.getBBox().height:2===l.side?u.y+8:Math.cos(q.rotation*m)*(u.y-q.getBBox(!1,0).height/2));a=a+b.x+u.x-(p&&e?p*g*(F?-1:1):0);n=n+f-(p&&!e?p*g*(F?1:-1):0);r&&(q=w/(k||1)%r,l.opposite&&(q=r-q-1),n+=l.labelOffset/r*q);return{x:a,y:Math.round(n)}},getMarkPath:function(a,m,q,e,b,p){return p.crispLine(["M",a,m,"L",a+(b?0:-q),m+(b?q:0)],e)},render:function(a,m,q){var e=this.axis,b=e.options,p=e.chart.renderer,w=e.horiz,k=this.type,l=this.label,g=this.pos,
F=b.labels,r=this.gridLine,u=k?k+"Tick":"tick",f=e.tickSize(u),B=this.mark,d=!B,x=F.step,c={},y=!0,L=e.tickmarkOffset,A=this.getPosition(w,g,L,m),J=A.x,A=A.y,h=w&&J===e.pos+e.len||!w&&A===e.pos?-1:1,G=k?k+"Grid":"grid",Q=b[G+"LineWidth"],P=b[G+"LineColor"],t=b[G+"LineDashStyle"],G=n(b[u+"Width"],!k&&e.isXAxis?1:0),u=b[u+"Color"];q=n(q,1);this.isActive=!0;r||(c.stroke=P,c["stroke-width"]=Q,t&&(c.dashstyle=t),k||(c.zIndex=1),m&&(c.opacity=0),this.gridLine=r=p.path().attr(c).addClass("highcharts-"+(k?
k+"-":"")+"grid-line").add(e.gridGroup));if(!m&&r&&(g=e.getPlotLinePath(g+L,r.strokeWidth()*h,m,!0)))r[this.isNew?"attr":"animate"]({d:g,opacity:q});f&&(e.opposite&&(f[0]=-f[0]),d&&(this.mark=B=p.path().addClass("highcharts-"+(k?k+"-":"")+"tick").add(e.axisGroup),B.attr({stroke:u,"stroke-width":G})),B[d?"attr":"animate"]({d:this.getMarkPath(J,A,f[0],B.strokeWidth()*h,w,p),opacity:q}));l&&I(J)&&(l.xy=A=this.getLabelPosition(J,A,l,w,F,L,a,x),this.isFirst&&!this.isLast&&!n(b.showFirstLabel,1)||this.isLast&&
!this.isFirst&&!n(b.showLastLabel,1)?y=!1:!w||e.isRadial||F.step||F.rotation||m||0===q||this.handleOverflow(A),x&&a%x&&(y=!1),y&&I(A.y)?(A.opacity=q,l[this.isNew?"attr":"animate"](A)):l.attr("y",-9999),this.isNew=!1)},destroy:function(){H(this,this.axis)}}})(K);(function(a){var E=a.addEvent,D=a.animObject,H=a.arrayMax,I=a.arrayMin,v=a.AxisPlotLineOrBandExtension,n=a.color,m=a.correctFloat,z=a.defaultOptions,t=a.defined,q=a.deg2rad,e=a.destroyObjectProperties,b=a.each,p=a.extend,w=a.fireEvent,k=a.format,
l=a.getMagnitude,g=a.grep,F=a.inArray,r=a.isArray,u=a.isNumber,f=a.isString,B=a.merge,d=a.normalizeTickInterval,x=a.pick,c=a.PlotLineOrBand,y=a.removeEvent,L=a.splat,A=a.syncTimeout,J=a.Tick;a.Axis=function(){this.init.apply(this,arguments)};a.Axis.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},
x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,
minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],
x:0},title:{rotation:0}},init:function(a,b){var h=b.isX;this.chart=a;this.horiz=a.inverted?!h:h;this.isXAxis=h;this.coll=this.coll||(h?"xAxis":"yAxis");this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var d=this.options,c=d.type;this.labelFormatter=d.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=d.reversed;this.visible=!1!==d.visible;this.zoomEnabled=!1!==d.zoomEnabled;this.hasNames=
"category"===c||!0===d.categories;this.categories=d.categories||this.hasNames;this.names=this.names||[];this.isLog="logarithmic"===c;this.isDatetimeAxis="datetime"===c;this.isLinked=t(d.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=d.minRange||d.maxZoom;this.range=d.range;this.offset=d.offset||0;this.stacks={};this.oldStacks={};this.stacksTouched=0;this.min=this.max=null;this.crosshair=x(d.crosshair,
L(a.options.tooltip.crosshairs)[h?0:1],!1);var G;b=this.options.events;-1===F(this,a.axes)&&(h?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];a.inverted&&h&&void 0===this.reversed&&(this.reversed=!0);this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(G in b)E(this,G,b[G]);this.isLog&&(this.val2lin=this.log2lin,this.lin2val=this.lin2log)},setOptions:function(a){this.options=B(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,
[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],B(z[this.coll],a))},defaultLabelFormatter:function(){var h=this.axis,b=this.value,d=h.categories,c=this.dateTimeLabelFormat,f=z.lang,g=f.numericSymbols,f=f.numericSymbolMagnitude||1E3,y=g&&g.length,l,A=h.options.labels.format,h=h.isLog?b:h.tickInterval;if(A)l=k(A,this);else if(d)l=b;else if(c)l=a.dateFormat(c,b);else if(y&&1E3<=h)for(;y--&&void 0===l;)d=Math.pow(f,y+1),h>=
d&&0===10*b%d&&null!==g[y]&&0!==b&&(l=a.numberFormat(b/d,-1)+g[y]);void 0===l&&(l=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return l},getSeriesExtremes:function(){var a=this,d=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();b(a.series,function(h){if(h.visible||!d.options.chart.ignoreHiddenSeries){var b=h.options,c=b.threshold,G;a.hasVisibleSeries=!0;a.isLog&&0>=c&&(c=null);if(a.isXAxis)b=h.xData,
b.length&&(h=I(b),u(h)||h instanceof Date||(b=g(b,function(a){return u(a)}),h=I(b)),a.dataMin=Math.min(x(a.dataMin,b[0]),h),a.dataMax=Math.max(x(a.dataMax,b[0]),H(b)));else if(h.getExtremes(),G=h.dataMax,h=h.dataMin,t(h)&&t(G)&&(a.dataMin=Math.min(x(a.dataMin,h),h),a.dataMax=Math.max(x(a.dataMax,G),G)),t(c)&&(a.threshold=c),!b.softThreshold||a.isLog)a.softThreshold=!1}})},translate:function(a,b,d,c,f,g){var h=this.linkedParent||this,G=1,y=0,l=c?h.oldTransA:h.transA;c=c?h.oldMin:h.min;var A=h.minPixelPadding;
f=(h.isOrdinal||h.isBroken||h.isLog&&f)&&h.lin2val;l||(l=h.transA);d&&(G*=-1,y=h.len);h.reversed&&(G*=-1,y-=G*(h.sector||h.len));b?(a=(a*G+y-A)/l+c,f&&(a=h.lin2val(a))):(f&&(a=h.val2lin(a)),a=G*(a-c)*l+y+G*A+(u(g)?l*g:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,d,c,f){var h=this.chart,G=this.left,g=this.top,y,l,A=d&&h.oldChartHeight||
h.chartHeight,r=d&&h.oldChartWidth||h.chartWidth,k;y=this.transB;var e=function(a,h,b){if(a<h||a>b)c?a=Math.min(Math.max(h,a),b):k=!0;return a};f=x(f,this.translate(a,null,null,d));a=d=Math.round(f+y);y=l=Math.round(A-f-y);u(f)?this.horiz?(y=g,l=A-this.bottom,a=d=e(a,G,G+this.width)):(a=G,d=r-this.right,y=l=e(y,g,g+this.height)):k=!0;return k&&!c?null:h.renderer.crispLine(["M",a,y,"L",d,l],b||1)},getLinearTickPositions:function(a,b,d){var h,c=m(Math.floor(b/a)*a),f=m(Math.ceil(d/a)*a),G=[];if(b===
d&&u(b))return[b];for(b=c;b<=f;){G.push(b);b=m(b+a);if(b===h)break;h=b}return G},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,d=this.minorTickInterval,c=[],f,g=this.pointRangePadding||0;f=this.min-g;var g=this.max+g,y=g-f;if(y&&y/d<this.len/3)if(this.isLog)for(g=b.length,f=1;f<g;f++)c=c.concat(this.getLogTickPositions(d,b[f-1],b[f],!0));else if(this.isDatetimeAxis&&"auto"===a.minorTickInterval)c=c.concat(this.getTimeTicks(this.normalizeTimeTickInterval(d),f,g,a.startOfWeek));
else for(b=f+(b[0]-f)%d;b<=g&&b!==c[0];b+=d)c.push(b);0!==c.length&&this.trimTicks(c,a.startOnTick,a.endOnTick);return c},adjustForMinRange:function(){var a=this.options,d=this.min,c=this.max,f,g=this.dataMax-this.dataMin>=this.minRange,y,l,A,r,u,k;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(t(a.min)||t(a.max)?this.minRange=null:(b(this.series,function(a){r=a.xData;for(l=u=a.xIncrement?1:r.length-1;0<l;l--)if(A=r[l]-r[l-1],void 0===y||A<y)y=A}),this.minRange=Math.min(5*y,this.dataMax-this.dataMin)));
c-d<this.minRange&&(k=this.minRange,f=(k-c+d)/2,f=[d-f,x(a.min,d-f)],g&&(f[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),d=H(f),c=[d+k,x(a.max,d+k)],g&&(c[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),c=I(c),c-d<k&&(f[0]=c-k,f[1]=x(a.min,c-k),d=H(f)));this.min=d;this.max=c},getClosest:function(){var a;this.categories?a=1:b(this.series,function(h){var b=h.closestPointRange,d=h.visible||!h.chart.options.chart.ignoreHiddenSeries;!h.noSharedTooltip&&t(b)&&d&&(a=t(a)?Math.min(a,b):b)});
return a},nameToX:function(a){var h=r(this.categories),b=h?this.categories:this.names,d=a.options.x,c;a.series.requireSorting=!1;t(d)||(d=!1===this.options.uniqueNames?a.series.autoIncrement():F(a.name,b));-1===d?h||(c=b.length):c=d;this.names[c]=a.name;return c},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=void 0,b(this.series||[],function(h){h.xIncrement=null;if(!h.points||h.isDirtyData)h.processData(),h.generatePoints();b(h.points,function(b,d){var c;
b.options&&(c=a.nameToX(b),c!==b.x&&(b.x=c,h.xData[d]=c))})}))},setAxisTranslation:function(a){var h=this,d=h.max-h.min,c=h.axisPointRange||0,g,y=0,l=0,A=h.linkedParent,r=!!h.categories,u=h.transA,k=h.isXAxis;if(k||r||c)g=h.getClosest(),A?(y=A.minPointOffset,l=A.pointRangePadding):b(h.series,function(a){var b=r?1:k?x(a.options.pointRange,g,0):h.axisPointRange||0;a=a.options.pointPlacement;c=Math.max(c,b);h.single||(y=Math.max(y,f(a)?0:b/2),l=Math.max(l,"on"===a?0:b))}),A=h.ordinalSlope&&g?h.ordinalSlope/
g:1,h.minPointOffset=y*=A,h.pointRangePadding=l*=A,h.pointRange=Math.min(c,d),k&&(h.closestPointRange=g);a&&(h.oldTransA=u);h.translationSlope=h.transA=u=h.len/(d+l||1);h.transB=h.horiz?h.left:h.bottom;h.minPixelPadding=u*y},minFromRange:function(){return this.max-this.range},setTickInterval:function(h){var c=this,f=c.chart,g=c.options,y=c.isLog,A=c.log2lin,r=c.isDatetimeAxis,k=c.isXAxis,e=c.isLinked,J=g.maxPadding,p=g.minPadding,B=g.tickInterval,F=g.tickPixelInterval,L=c.categories,q=c.threshold,
n=c.softThreshold,v,z,D,E;r||L||e||this.getTickAmount();D=x(c.userMin,g.min);E=x(c.userMax,g.max);e?(c.linkedParent=f[c.coll][g.linkedTo],f=c.linkedParent.getExtremes(),c.min=x(f.min,f.dataMin),c.max=x(f.max,f.dataMax),g.type!==c.linkedParent.options.type&&a.error(11,1)):(!n&&t(q)&&(c.dataMin>=q?(v=q,p=0):c.dataMax<=q&&(z=q,J=0)),c.min=x(D,v,c.dataMin),c.max=x(E,z,c.dataMax));y&&(!h&&0>=Math.min(c.min,x(c.dataMin,c.min))&&a.error(10,1),c.min=m(A(c.min),15),c.max=m(A(c.max),15));c.range&&t(c.max)&&
(c.userMin=c.min=D=Math.max(c.min,c.minFromRange()),c.userMax=E=c.max,c.range=null);w(c,"foundExtremes");c.beforePadding&&c.beforePadding();c.adjustForMinRange();!(L||c.axisPointRange||c.usePercentage||e)&&t(c.min)&&t(c.max)&&(A=c.max-c.min)&&(!t(D)&&p&&(c.min-=A*p),!t(E)&&J&&(c.max+=A*J));u(g.floor)?c.min=Math.max(c.min,g.floor):u(g.softMin)&&(c.min=Math.min(c.min,g.softMin));u(g.ceiling)?c.max=Math.min(c.max,g.ceiling):u(g.softMax)&&(c.max=Math.max(c.max,g.softMax));n&&t(c.dataMin)&&(q=q||0,!t(D)&&
c.min<q&&c.dataMin>=q?c.min=q:!t(E)&&c.max>q&&c.dataMax<=q&&(c.max=q));c.tickInterval=c.min===c.max||void 0===c.min||void 0===c.max?1:e&&!B&&F===c.linkedParent.options.tickPixelInterval?B=c.linkedParent.tickInterval:x(B,this.tickAmount?(c.max-c.min)/Math.max(this.tickAmount-1,1):void 0,L?1:(c.max-c.min)*F/Math.max(c.len,F));k&&!h&&b(c.series,function(a){a.processData(c.min!==c.oldMin||c.max!==c.oldMax)});c.setAxisTranslation(!0);c.beforeSetTickPositions&&c.beforeSetTickPositions();c.postProcessTickInterval&&
(c.tickInterval=c.postProcessTickInterval(c.tickInterval));c.pointRange&&!B&&(c.tickInterval=Math.max(c.pointRange,c.tickInterval));h=x(g.minTickInterval,c.isDatetimeAxis&&c.closestPointRange);!B&&c.tickInterval<h&&(c.tickInterval=h);r||y||B||(c.tickInterval=d(c.tickInterval,null,l(c.tickInterval),x(g.allowDecimals,!(.5<c.tickInterval&&5>c.tickInterval&&1E3<c.max&&9999>c.max)),!!this.tickAmount));this.tickAmount||(c.tickInterval=c.unsquish());this.setTickPositions()},setTickPositions:function(){var a=
this.options,c,b=a.tickPositions,d=a.tickPositioner,f=a.startOnTick,g=a.endOnTick,y;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.tickPositions=c=b&&b.slice();!c&&(c=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,
!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),c.length>this.len&&(c=[c[0],c.pop()]),this.tickPositions=c,d&&(d=d.apply(this,[this.min,this.max])))&&(this.tickPositions=c=d);this.trimTicks(c,f,g);this.isLinked||(this.min===this.max&&t(this.min)&&!this.tickAmount&&(y=!0,this.min-=.5,this.max+=.5),this.single=y,b||d||this.adjustTickAmount())},trimTicks:function(a,c,b){var h=a[0],d=a[a.length-1],f=this.minPointOffset||
0;if(!this.isLinked){if(c)this.min=h;else for(;this.min-f>a[0];)a.shift();if(b)this.max=d;else for(;this.max+f<a[a.length-1];)a.pop();0===a.length&&t(h)&&a.push((d+h)/2)}},alignToOthers:function(){var a={},c,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||this.isLog||b(this.chart[this.coll],function(h){var b=h.options,b=[h.horiz?b.left:b.top,b.width,b.height,b.pane].join();h.series.length&&(a[b]?c=!0:a[b]=1)});return c},getTickAmount:function(){var a=this.options,c=a.tickAmount,
b=a.tickPixelInterval;!t(a.tickInterval)&&this.len<b&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(c=2);!c&&this.alignToOthers()&&(c=Math.ceil(this.len/b)+1);4>c&&(this.finalTickAmt=c,c=5);this.tickAmount=c},adjustTickAmount:function(){var a=this.tickInterval,c=this.tickPositions,b=this.tickAmount,d=this.finalTickAmt,f=c&&c.length;if(f<b){for(;c.length<b;)c.push(m(c[c.length-1]+a));this.transA*=(f-1)/(b-1);this.max=c[c.length-1]}else f>b&&(this.tickInterval*=2,this.setTickPositions());
if(t(d)){for(a=b=c.length;a--;)(3===d&&1===a%2||2>=d&&0<a&&a<b-1)&&c.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,c;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();c=this.len!==this.oldAxisLength;b(this.series,function(h){if(h.isDirtyData||h.isDirty||h.xAxis.isDirty)a=!0});c||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=
!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=c||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,c,d,f,g){var h=this,y=h.chart;d=x(d,!0);b(h.series,function(a){delete a.kdTree});g=p(g,{min:a,max:c});w(h,"setExtremes",g,function(){h.userMin=a;h.userMax=c;h.eventArgs=g;d&&y.redraw(f)})},zoom:function(a,c){var h=this.dataMin,b=this.dataMax,d=this.options,
f=Math.min(h,x(d.min,h)),d=Math.max(b,x(d.max,b));if(a!==this.min||c!==this.max)this.allowZoomOutside||(t(h)&&(a<f&&(a=f),a>d&&(a=d)),t(b)&&(c<f&&(c=f),c>d&&(c=d))),this.displayBtn=void 0!==a||void 0!==c,this.setExtremes(a,c,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,c=this.options,b=c.offsets||[0,0,0,0],d=this.horiz,f=x(c.width,a.plotWidth-b[3]+b[1]),g=x(c.height,a.plotHeight-b[0]+b[2]),y=x(c.top,a.plotTop+b[0]),c=x(c.left,a.plotLeft+b[3]),b=/%$/;b.test(g)&&(g=
Math.round(parseFloat(g)/100*a.plotHeight));b.test(y)&&(y=Math.round(parseFloat(y)/100*a.plotHeight+a.plotTop));this.left=c;this.top=y;this.width=f;this.height=g;this.bottom=a.chartHeight-g-y;this.right=a.chartWidth-f-c;this.len=Math.max(d?f:g,0);this.pos=d?c:y},getExtremes:function(){var a=this.isLog,c=this.lin2log;return{min:a?m(c(this.min)):this.min,max:a?m(c(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var c=
this.isLog,h=this.lin2log,b=c?h(this.min):this.min,c=c?h(this.max):this.max;null===a?a=b:b>a?a=b:c<a&&(a=c);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(x(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var c=this.options,h=c[a+"Length"],b=x(c[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(b&&h)return"inside"===c[a+"Position"]&&(h=-h),[h,b]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style&&
this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,c=this.horiz,d=this.tickInterval,f=d,g=this.len/(((this.categories?1:0)+this.max-this.min)/d),y,l=a.rotation,A=this.labelMetrics(),r,u=Number.MAX_VALUE,k,e=function(a){a/=g||1;a=1<a?Math.ceil(a):1;return a*d};c?(k=!a.staggerLines&&!a.step&&(t(l)?[l]:g<x(a.autoRotationLimit,80)&&a.autoRotation))&&b(k,function(a){var c;if(a===l||a&&-90<=a&&90>=a)r=e(Math.abs(A.h/Math.sin(q*a))),c=r+
Math.abs(a/360),c<u&&(u=c,y=a,f=r)}):a.step||(f=e(A.h));this.autoRotation=k;this.labelRotation=x(y,l);return f},getSlotWidth:function(){var a=this.chart,c=this.horiz,b=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),f=a.margin[3];return c&&2>(b.step||0)&&!b.rotation&&(this.staggerLines||1)*this.len/d||!c&&(f&&f-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,c=a.renderer,d=this.tickPositions,g=this.ticks,y=this.options.labels,l=this.horiz,
A=this.getSlotWidth(),r=Math.max(1,Math.round(A-2*(y.padding||5))),u={},k=this.labelMetrics(),e=y.style&&y.style.textOverflow,x,J=0,p,F;f(y.rotation)||(u.rotation=y.rotation||0);b(d,function(a){(a=g[a])&&a.labelLength>J&&(J=a.labelLength)});this.maxLabelLength=J;if(this.autoRotation)J>r&&J>k.h?u.rotation=this.labelRotation:this.labelRotation=0;else if(A&&(x={width:r+"px"},!e))for(x.textOverflow="clip",p=d.length;!l&&p--;)if(F=d[p],r=g[F].label)r.styles&&"ellipsis"===r.styles.textOverflow?r.css({textOverflow:"clip"}):
g[F].labelLength>A&&r.css({width:A+"px"}),r.getBBox().height>this.len/d.length-(k.h-k.f)&&(r.specCss={textOverflow:"ellipsis"});u.rotation&&(x={width:(J>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},e||(x.textOverflow="ellipsis"));if(this.labelAlign=y.align||this.autoLabelAlign(this.labelRotation))u.align=this.labelAlign;b(d,function(a){var c=(a=g[a])&&a.label;c&&(c.attr(u),x&&c.css(B(x,c.specCss)),delete c.specCss,a.rotation=u.rotation)});this.tickRotCorr=c.rotCorr(k.b,this.labelRotation||
0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||t(this.min)&&t(this.max)&&!!this.tickPositions},addTitle:function(a){var c=this.chart.renderer,b=this.horiz,h=this.opposite,d=this.options.title,f;this.axisTitle||((f=d.textAlign)||(f=(b?{low:"left",middle:"center",high:"right"}:{low:h?"right":"left",middle:"center",high:h?"left":"right"})[d.align]),this.axisTitle=c.text(d.text,0,0,d.useHTML).attr({zIndex:7,rotation:d.rotation||0,align:f}).addClass("highcharts-axis-title").css(d.style).add(this.axisGroup),
this.axisTitle.isNew=!0);this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var c=this.ticks;c[a]?c[a].addLabel():c[a]=new J(this,a)},getOffset:function(){var a=this,c=a.chart,d=c.renderer,f=a.options,g=a.tickPositions,y=a.ticks,l=a.horiz,A=a.side,r=c.inverted?[1,0,3,2][A]:A,u,k,e=0,J,p=0,B=f.title,F=f.labels,w=0,L=c.axisOffset,c=c.clipOffset,m=[-1,1,1,-1][A],q,n=f.className,v=a.axisParent,z=this.tickSize("tick");u=a.hasData();a.showAxis=k=u||x(f.showEmpty,!0);a.staggerLines=a.horiz&&F.staggerLines;
a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:f.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(n||"")).add(v),a.axisGroup=d.g("axis").attr({zIndex:f.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(n||"")).add(v),a.labelGroup=d.g("axis-labels").attr({zIndex:F.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(n||"")).add(v));if(u||a.isLinked)b(g,function(c,b){a.generateTick(c,b)}),a.renderUnsquish(),!1===F.reserveSpace||0!==A&&2!==A&&
{1:"left",3:"right"}[A]!==a.labelAlign&&"center"!==a.labelAlign||b(g,function(a){w=Math.max(y[a].getLabelSize(),w)}),a.staggerLines&&(w*=a.staggerLines,a.labelOffset=w*(a.opposite?-1:1));else for(q in y)y[q].destroy(),delete y[q];B&&B.text&&!1!==B.enabled&&(a.addTitle(k),k&&(e=a.axisTitle.getBBox()[l?"height":"width"],J=B.offset,p=t(J)?0:x(B.margin,l?5:10)));a.renderLine();a.offset=m*x(f.offset,L[A]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===A?-a.labelMetrics().h:2===A?a.tickRotCorr.y:0;p=Math.abs(w)+
p;w&&(p=p-d+m*(l?x(F.y,a.tickRotCorr.y+8*m):F.x));a.axisTitleMargin=x(J,p);L[A]=Math.max(L[A],a.axisTitleMargin+e+m*a.offset,p,u&&g.length&&z?z[0]:0);f=f.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);c[r]=Math.max(c[r],f)},getLinePath:function(a){var c=this.chart,b=this.opposite,d=this.offset,h=this.horiz,f=this.left+(b?this.width:0)+d,d=c.chartHeight-this.bottom-(b?this.height:0)+d;b&&(a*=-1);return c.renderer.crispLine(["M",h?this.left:f,h?d:this.top,"L",h?c.chartWidth-this.right:f,h?d:c.chartHeight-
this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,c=this.left,b=this.top,d=this.len,f=this.options.title,g=a?c:b,y=this.opposite,A=this.offset,l=f.x||0,r=f.y||0,u=this.chart.renderer.fontMetrics(f.style&&f.style.fontSize,this.axisTitle).f,d={low:g+(a?0:d),
middle:g+d/2,high:g+(a?d:0)}[f.align],c=(a?b+this.height:c)+(a?1:-1)*(y?-1:1)*this.axisTitleMargin+(2===this.side?u:0);return{x:a?d+l:c+(y?this.width:0)+A+l,y:a?c+r-(y?this.height:0)+A:d+r}},renderMinorTick:function(a){var c=this.chart.hasRendered&&u(this.oldMin),b=this.minorTicks;b[a]||(b[a]=new J(this,a,"minor"));c&&b[a].isNew&&b[a].render(null,!0);b[a].render(null,!1,1)},renderTick:function(a,c){var b=this.isLinked,d=this.ticks,h=this.chart.hasRendered&&u(this.oldMin);if(!b||a>=this.min&&a<=this.max)d[a]||
(d[a]=new J(this,a)),h&&d[a].isNew&&d[a].render(c,!0,.1),d[a].render(c)},render:function(){var a=this,d=a.chart,f=a.options,g=a.isLog,y=a.lin2log,l=a.isLinked,r=a.tickPositions,u=a.axisTitle,k=a.ticks,e=a.minorTicks,x=a.alternateBands,p=f.stackLabels,B=f.alternateGridColor,F=a.tickmarkOffset,w=a.axisLine,L=a.showAxis,m=D(d.renderer.globalAnimation),q,n;a.labelEdge.length=0;a.overlap=!1;b([k,e,x],function(a){for(var c in a)a[c].isActive=!1});if(a.hasData()||l)a.minorTickInterval&&!a.categories&&b(a.getMinorTickPositions(),
function(c){a.renderMinorTick(c)}),r.length&&(b(r,function(c,b){a.renderTick(c,b)}),F&&(0===a.min||a.single)&&(k[-1]||(k[-1]=new J(a,-1,null,!0)),k[-1].render(-1))),B&&b(r,function(b,h){n=void 0!==r[h+1]?r[h+1]+F:a.max-F;0===h%2&&b<a.max&&n<=a.max+(d.polar?-F:F)&&(x[b]||(x[b]=new c(a)),q=b+F,x[b].options={from:g?y(q):q,to:g?y(n):n,color:B},x[b].render(),x[b].isActive=!0)}),a._addedPlotLB||(b((f.plotLines||[]).concat(f.plotBands||[]),function(c){a.addPlotBandOrLine(c)}),a._addedPlotLB=!0);b([k,e,x],
function(a){var c,b,h=[],f=m.duration;for(c in a)a[c].isActive||(a[c].render(c,!1,0),a[c].isActive=!1,h.push(c));A(function(){for(b=h.length;b--;)a[h[b]]&&!a[h[b]].isActive&&(a[h[b]].destroy(),delete a[h[b]])},a!==x&&d.hasRendered&&f?f:0)});w&&(w[w.isPlaced?"animate":"attr"]({d:this.getLinePath(w.strokeWidth())}),w.isPlaced=!0,w[L?"show":"hide"](!0));u&&L&&(u[u.isNew?"attr":"animate"](a.getTitlePosition()),u.isNew=!1);p&&p.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&
(this.render(),b(this.plotLinesAndBands,function(a){a.render()}));b(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,d=c.stacks,h,f=c.plotLinesAndBands,g;a||y(c);for(h in d)e(d[h]),d[h]=null;b([c.ticks,c.minorTicks,c.alternateBands],function(a){e(a)});if(f)for(a=f.length;a--;)f[a].destroy();b("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){c[a]&&(c[a]=c[a].destroy())});
for(g in c)c.hasOwnProperty(g)&&-1===F(g,c.keepProps)&&delete c[g]},drawCrosshair:function(a,c){var b,d=this.crosshair,h=x(d.snap,!0),f,g=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(t(c)||!h)?(h?t(c)&&(f=this.isXAxis?c.plotX:this.len-c.plotY):f=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),t(f)&&(b=this.getPlotLinePath(c&&(this.isXAxis?c.x:x(c.stackY,c.y)),null,null,null,f)||null),t(b)?(c=this.categories&&!this.isRadial,g||(this.cross=g=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
(c?"category ":"thin ")+d.className).attr({zIndex:x(d.zIndex,2)}).add(),g.attr({stroke:d.color||(c?n("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":x(d.width,1)}),d.dashStyle&&g.attr({dashstyle:d.dashStyle})),g.show().attr({d:b}),c&&!d.width&&g.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}};p(a.Axis.prototype,v)})(K);(function(a){var E=a.Axis,D=a.Date,H=a.dateFormat,I=a.defaultOptions,
v=a.defined,n=a.each,m=a.extend,z=a.getMagnitude,t=a.getTZOffset,q=a.normalizeTickInterval,e=a.pick,b=a.timeUnits;E.prototype.getTimeTicks=function(a,w,k,l){var g=[],p={},r=I.global.useUTC,u,f=new D(w-t(w)),B=D.hcMakeTime,d=a.unitRange,x=a.count,c;if(v(w)){f[D.hcSetMilliseconds](d>=b.second?0:x*Math.floor(f.getMilliseconds()/x));if(d>=b.second)f[D.hcSetSeconds](d>=b.minute?0:x*Math.floor(f.getSeconds()/x));if(d>=b.minute)f[D.hcSetMinutes](d>=b.hour?0:x*Math.floor(f[D.hcGetMinutes]()/x));if(d>=b.hour)f[D.hcSetHours](d>=
b.day?0:x*Math.floor(f[D.hcGetHours]()/x));if(d>=b.day)f[D.hcSetDate](d>=b.month?1:x*Math.floor(f[D.hcGetDate]()/x));d>=b.month&&(f[D.hcSetMonth](d>=b.year?0:x*Math.floor(f[D.hcGetMonth]()/x)),u=f[D.hcGetFullYear]());if(d>=b.year)f[D.hcSetFullYear](u-u%x);if(d===b.week)f[D.hcSetDate](f[D.hcGetDate]()-f[D.hcGetDay]()+e(l,1));u=f[D.hcGetFullYear]();l=f[D.hcGetMonth]();var y=f[D.hcGetDate](),L=f[D.hcGetHours]();if(D.hcTimezoneOffset||D.hcGetTimezoneOffset)c=(!r||!!D.hcGetTimezoneOffset)&&(k-w>4*b.month||
t(w)!==t(k)),f=f.getTime(),f=new D(f+t(f));r=f.getTime();for(w=1;r<k;)g.push(r),r=d===b.year?B(u+w*x,0):d===b.month?B(u,l+w*x):!c||d!==b.day&&d!==b.week?c&&d===b.hour?B(u,l,y,L+w*x):r+d*x:B(u,l,y+w*x*(d===b.day?1:7)),w++;g.push(r);d<=b.hour&&1E4>g.length&&n(g,function(a){0===a%18E5&&"000000000"===H("%H%M%S%L",a)&&(p[a]="day")})}g.info=m(a,{higherRanks:p,totalRange:d*x});return g};E.prototype.normalizeTimeTickInterval=function(a,e){var k=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",
[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];e=k[k.length-1];var l=b[e[0]],g=e[1],p;for(p=0;p<k.length&&!(e=k[p],l=b[e[0]],g=e[1],k[p+1]&&a<=(l*g[g.length-1]+b[k[p+1][0]])/2);p++);l===b.year&&a<5*l&&(g=[1,2,5]);a=q(a/l,g,"year"===e[0]?Math.max(z(a/l),1):1);return{unitRange:l,count:a,unitName:e[0]}}})(K);(function(a){var E=a.Axis,D=a.getMagnitude,H=a.map,I=a.normalizeTickInterval,v=a.pick;E.prototype.getLogTickPositions=
function(a,m,z,t){var q=this.options,e=this.len,b=this.lin2log,p=this.log2lin,w=[];t||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),w=this.getLinearTickPositions(a,m,z);else if(.08<=a)for(var e=Math.floor(m),k,l,g,F,r,q=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];e<z+1&&!r;e++)for(l=q.length,k=0;k<l&&!r;k++)g=p(b(e)*q[k]),g>m&&(!t||F<=z)&&void 0!==F&&w.push(F),F>z&&(r=!0),F=g;else m=b(m),z=b(z),a=q[t?"minorTickInterval":"tickInterval"],a=v("auto"===a?null:a,this._minorAutoInterval,
q.tickPixelInterval/(t?5:1)*(z-m)/((t?e/this.tickPositions.length:e)||1)),a=I(a,null,D(a)),w=H(this.getLinearTickPositions(a,m,z),p),t||(this._minorAutoInterval=a/5);t||(this.tickInterval=a);return w};E.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};E.prototype.lin2log=function(a){return Math.pow(10,a)}})(K);(function(a){var E=a.dateFormat,D=a.each,H=a.extend,I=a.format,v=a.isNumber,n=a.map,m=a.merge,z=a.pick,t=a.splat,q=a.syncTimeout,e=a.timeUnits;a.Tooltip=function(){this.init.apply(this,
arguments)};a.Tooltip.prototype={init:function(a,e){this.chart=a;this.options=e;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=e.split&&!a.inverted;this.shared=e.shared||this.split},cleanSplit:function(a){D(this.chart.series,function(b){var e=b&&b.tt;e&&(!e.isActive||a?b.tt=e.destroy():e.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,e=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,e.shape||"callout",null,null,e.useHTML,
null,"tooltip").attr({padding:e.padding,r:e.borderRadius}),this.label.attr({fill:e.backgroundColor,"stroke-width":e.borderWidth}).css(e.style).shadow(e.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();this.init(this.chart,m(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},
move:function(a,e,w,k){var b=this,g=b.now,p=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(a-g.x)||1<Math.abs(e-g.y)),r=b.followPointer||1<b.len;H(g,{x:p?(2*g.x+a)/3:a,y:p?(g.y+e)/2:e,anchorX:r?void 0:p?(2*g.anchorX+w)/3:w,anchorY:r?void 0:p?(g.anchorY+k)/2:k});b.getLabel().attr(g);p&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(a,e,w,k)},32))},hide:function(a){var b=this;clearTimeout(this.hideTimer);a=z(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=
q(function(){b.getLabel()[a?"fadeOut":"hide"]();b.isHidden=!0},a))},getAnchor:function(a,e){var b,k=this.chart,l=k.inverted,g=k.plotTop,p=k.plotLeft,r=0,u=0,f,B;a=t(a);b=a[0].tooltipPos;this.followPointer&&e&&(void 0===e.chartX&&(e=k.pointer.normalize(e)),b=[e.chartX-k.plotLeft,e.chartY-g]);b||(D(a,function(a){f=a.series.yAxis;B=a.series.xAxis;r+=a.plotX+(!l&&B?B.left-p:0);u+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!l&&f?f.top-g:0)}),r/=a.length,u/=a.length,b=[l?k.plotWidth-u:r,this.shared&&
!l&&1<a.length&&e?e.chartY-g:l?k.plotHeight-r:u]);return n(b,Math.round)},getPosition:function(a,e,w){var b=this.chart,l=this.distance,g={},p=w.h||0,r,u=["y",b.chartHeight,e,w.plotY+b.plotTop,b.plotTop,b.plotTop+b.plotHeight],f=["x",b.chartWidth,a,w.plotX+b.plotLeft,b.plotLeft,b.plotLeft+b.plotWidth],B=!this.followPointer&&z(w.ttBelow,!b.inverted===!!w.negative),d=function(a,c,b,d,f,y){var h=b<d-l,A=d+l+b<c,r=d-l-b;d+=l;if(B&&A)g[a]=d;else if(!B&&h)g[a]=r;else if(h)g[a]=Math.min(y-b,0>r-p?r:r-p);
else if(A)g[a]=Math.max(f,d+p+b>c?d:d+p);else return!1},x=function(a,c,b,d){var h;d<l||d>c-l?h=!1:g[a]=d<b/2?1:d>c-b/2?c-b-2:d-b/2;return h},c=function(a){var c=u;u=f;f=c;r=a},y=function(){!1!==d.apply(0,u)?!1!==x.apply(0,f)||r||(c(!0),y()):r?g.x=g.y=0:(c(!0),y())};(b.inverted||1<this.len)&&c();y();return g},defaultFormatter:function(a){var b=this.points||t(this),e;e=[a.tooltipFooterHeaderFormatter(b[0])];e=e.concat(a.bodyFormatter(b));e.push(a.tooltipFooterHeaderFormatter(b[0],!0));return e},refresh:function(a,
e){var b=this.chart,k,l=this.options,g,p,r={},u=[];k=l.formatter||this.defaultFormatter;var r=b.hoverPoints,f=this.shared;clearTimeout(this.hideTimer);this.followPointer=t(a)[0].series.tooltipOptions.followPointer;p=this.getAnchor(a,e);e=p[0];g=p[1];!f||a.series&&a.series.noSharedTooltip?r=a.getLabelConfig():(b.hoverPoints=a,r&&D(r,function(a){a.setState()}),D(a,function(a){a.setState("hover");u.push(a.getLabelConfig())}),r={x:a[0].category,y:a[0].y},r.points=u,a=a[0]);this.len=u.length;r=k.call(r,
this);f=a.series;this.distance=z(f.tooltipOptions.distance,16);!1===r?this.hide():(k=this.getLabel(),this.isHidden&&k.attr({opacity:1}).show(),this.split?this.renderSplit(r,b.hoverPoints):(k.attr({text:r&&r.join?r.join(""):r}),k.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+z(a.colorIndex,f.colorIndex)),k.attr({stroke:l.borderColor||a.color||f.color||"#666666"}),this.updatePosition({plotX:e,plotY:g,negative:a.negative,ttBelow:a.ttBelow,h:p[2]||0})),this.isHidden=!1)},renderSplit:function(b,
e){var p=this,k=[],l=this.chart,g=l.renderer,F=!0,r=this.options,u,f=this.getLabel();D(b.slice(0,e.length+1),function(a,b){b=e[b-1]||{isHeader:!0,plotX:e[0].plotX};var d=b.series||p,c=d.tt,y=b.series||{},B="highcharts-color-"+z(b.colorIndex,y.colorIndex,"none");c||(d.tt=c=g.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+B).attr({padding:r.padding,r:r.borderRadius,fill:r.backgroundColor,stroke:b.color||y.color||"#333333","stroke-width":r.borderWidth}).add(f));c.isActive=!0;c.attr({text:a});
c.css(r.style);a=c.getBBox();y=a.width+c.strokeWidth();b.isHeader?(u=a.height,y=Math.max(0,Math.min(b.plotX+l.plotLeft-y/2,l.chartWidth-y))):y=b.plotX+l.plotLeft-z(r.distance,16)-y;0>y&&(F=!1);a=(b.series&&b.series.yAxis&&b.series.yAxis.pos)+(b.plotY||0);a-=l.plotTop;k.push({target:b.isHeader?l.plotHeight+u:a,rank:b.isHeader?1:0,size:d.tt.getBBox().height+1,point:b,x:y,tt:c})});this.cleanSplit();a.distribute(k,l.plotHeight+u);D(k,function(a){var b=a.point,f=b.series;a.tt.attr({visibility:void 0===
a.pos?"hidden":"inherit",x:F||b.isHeader?a.x:b.plotX+l.plotLeft+z(r.distance,16),y:a.pos+l.plotTop,anchorX:b.isHeader?b.plotX+l.plotLeft:b.plotX+f.xAxis.pos,anchorY:b.isHeader?a.pos+l.plotTop-15:b.plotY+f.yAxis.pos})})},updatePosition:function(a){var b=this.chart,e=this.getLabel(),e=(this.options.positioner||this.getPosition).call(this,e.width,e.height,a);this.move(Math.round(e.x),Math.round(e.y||0),a.plotX+b.plotLeft,a.plotY+b.plotTop)},getDateFormat:function(a,p,w,k){var b=E("%m-%d %H:%M:%S.%L",
p),g,F,r={millisecond:15,second:12,minute:9,hour:6,day:3},u="millisecond";for(F in e){if(a===e.week&&+E("%w",p)===w&&"00:00:00.000"===b.substr(6)){F="week";break}if(e[F]>a){F=u;break}if(r[F]&&b.substr(r[F])!=="01-01 00:00:00.000".substr(r[F]))break;"week"!==F&&(u=F)}F&&(g=k[F]);return g},getXDateFormat:function(a,e,w){e=e.dateTimeLabelFormats;var b=w&&w.closestPointRange;return(b?this.getDateFormat(b,a.x,w.options.startOfWeek,e):e.day)||e.year},tooltipFooterHeaderFormatter:function(a,e){var b=e?"footer":
"header";e=a.series;var k=e.tooltipOptions,l=k.xDateFormat,g=e.xAxis,F=g&&"datetime"===g.options.type&&v(a.key),b=k[b+"Format"];F&&!l&&(l=this.getXDateFormat(a,k,g));F&&l&&(b=b.replace("{point.key}","{point.key:"+l+"}"));return I(b,{point:a,series:e})},bodyFormatter:function(a){return n(a,function(a){var b=a.series.tooltipOptions;return(b.pointFormatter||a.point.tooltipFormatter).call(a.point,b.pointFormat)})}}})(K);(function(a){var E=a.addEvent,D=a.attr,H=a.charts,I=a.color,v=a.css,n=a.defined,m=
a.doc,z=a.each,t=a.extend,q=a.fireEvent,e=a.offset,b=a.pick,p=a.removeEvent,w=a.splat,k=a.Tooltip,l=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,l){this.options=l;this.chart=a;this.runChartClick=l.chart.events&&!!l.chart.events.click;this.pinchDown=[];this.lastValidTouch={};k&&l.tooltip.enabled&&(a.tooltip=new k(a,l.tooltip),this.followTouchMove=b(l.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var g=this.chart,l=g.options.chart,e=l.zoomType||
"",g=g.inverted;/touch/.test(a.type)&&(e=b(l.pinchType,e));this.zoomX=a=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=a&&!g||e&&g;this.zoomVert=e&&!g||a&&g;this.hasZoom=a||e},normalize:function(a,b){var g,u;a=a||l.event;a.target||(a.target=a.srcElement);u=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=e(this.chart.container));void 0===u.pageX?(g=Math.max(a.x,a.clientX-b.left),b=a.y):(g=u.pageX-b.left,b=u.pageY-b.top);return t(a,{chartX:Math.round(g),
chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};z(this.chart.axes,function(g){b[g.isXAxis?"xAxis":"yAxis"].push({axis:g,value:g.toValue(a[g.horiz?"chartX":"chartY"])})});return b},runPointActions:function(g){var l=this.chart,r=l.series,e=l.tooltip,f=e?e.shared:!1,k=!0,d=l.hoverPoint,x=l.hoverSeries,c,y,p,A=[],J;if(!f&&!x)for(c=0;c<r.length;c++)if(r[c].directTouch||!r[c].options.stickyTracking)r=[];x&&(f?x.noSharedTooltip:x.directTouch)&&d?A=[d]:(f||!x||x.options.stickyTracking||
(r=[x]),z(r,function(a){y=a.noSharedTooltip&&f;p=!f&&a.directTouch;a.visible&&!y&&!p&&b(a.options.enableMouseTracking,!0)&&(J=a.searchPoint(g,!y&&1===a.kdDimensions))&&J.series&&A.push(J)}),A.sort(function(a,c){var b=a.distX-c.distX,d=a.dist-c.dist,h=(c.series.group&&c.series.group.zIndex)-(a.series.group&&a.series.group.zIndex);return 0!==b&&f?b:0!==d?d:0!==h?h:a.series.index>c.series.index?-1:1}));if(f)for(c=A.length;c--;)(A[c].x!==A[0].x||A[c].series.noSharedTooltip)&&A.splice(c,1);if(A[0]&&(A[0]!==
this.prevKDPoint||e&&e.isHidden)){if(f&&!A[0].series.noSharedTooltip){for(c=0;c<A.length;c++)A[c].onMouseOver(g,A[c]!==(x&&x.directTouch&&d||A[0]));A.length&&e&&e.refresh(A.sort(function(a,c){return a.series.index-c.series.index}),g)}else if(e&&e.refresh(A[0],g),!x||!x.directTouch)A[0].onMouseOver(g);this.prevKDPoint=A[0];k=!1}k&&(r=x&&x.tooltipOptions.followPointer,e&&r&&!e.isHidden&&(r=e.getAnchor([{}],g),e.updatePosition({plotX:r[0],plotY:r[1]})));this.unDocMouseMove||(this.unDocMouseMove=E(m,
"mousemove",function(c){if(H[a.hoverChartIndex])H[a.hoverChartIndex].pointer.onDocumentMouseMove(c)}));z(f?A:[b(d,A[0])],function(a){z(l.axes,function(c){(!a||a.series&&a.series[c.coll]===c)&&c.drawCrosshair(g,a)})})},reset:function(a,b){var g=this.chart,l=g.hoverSeries,f=g.hoverPoint,e=g.hoverPoints,d=g.tooltip,k=d&&d.shared?e:f;a&&k&&z(w(k),function(c){c.series.isCartesian&&void 0===c.plotX&&(a=!1)});if(a)d&&k&&(d.refresh(k),f&&(f.setState(f.state,!0),z(g.axes,function(a){a.crosshair&&a.drawCrosshair(null,
f)})));else{if(f)f.onMouseOut();e&&z(e,function(a){a.setState()});if(l)l.onMouseOut();d&&d.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());z(g.axes,function(a){a.hideCrosshair()});this.hoverX=this.prevKDPoint=g.hoverPoints=g.hoverPoint=null}},scaleGroups:function(a,b){var g=this.chart,l;z(g.series,function(f){l=a||f.getPlotBox();f.xAxis&&f.xAxis.zoomEnabled&&f.group&&(f.group.attr(l),f.markerGroup&&(f.markerGroup.attr(l),f.markerGroup.clip(b?g.clipRect:null)),f.dataLabelsGroup&&
f.dataLabelsGroup.attr(l))});g.clipRect.attr(b||g.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,g=b.options.chart,l=a.chartX,f=a.chartY,e=this.zoomHor,d=this.zoomVert,k=b.plotLeft,c=b.plotTop,y=b.plotWidth,p=b.plotHeight,A,J=this.selectionMarker,h=this.mouseDownX,q=this.mouseDownY,w=g.panKey&&a[g.panKey+"Key"];J&&J.touch||(l<k?l=k:l>k+y&&(l=k+y),f<
c?f=c:f>c+p&&(f=c+p),this.hasDragged=Math.sqrt(Math.pow(h-l,2)+Math.pow(q-f,2)),10<this.hasDragged&&(A=b.isInsidePlot(h-k,q-c),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&A&&!w&&!J&&(this.selectionMarker=J=b.renderer.rect(k,c,e?1:y,d?1:p,0).attr({fill:g.selectionMarkerFill||I("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),J&&e&&(l-=h,J.attr({width:Math.abs(l),x:(0<l?0:l)+h})),J&&d&&(l=f-q,J.attr({height:Math.abs(l),y:(0<l?0:l)+q})),A&&!J&&g.panning&&b.pan(a,
g.panning)))},drop:function(a){var b=this,g=this.chart,l=this.hasPinched;if(this.selectionMarker){var f={originalEvent:a,xAxis:[],yAxis:[]},e=this.selectionMarker,d=e.attr?e.attr("x"):e.x,k=e.attr?e.attr("y"):e.y,c=e.attr?e.attr("width"):e.width,y=e.attr?e.attr("height"):e.height,p;if(this.hasDragged||l)z(g.axes,function(g){if(g.zoomEnabled&&n(g.min)&&(l||b[{xAxis:"zoomX",yAxis:"zoomY"}[g.coll]])){var e=g.horiz,h="touchend"===a.type?g.minPixelPadding:0,A=g.toValue((e?d:k)+h),e=g.toValue((e?d+c:k+
y)-h);f[g.coll].push({axis:g,min:Math.min(A,e),max:Math.max(A,e)});p=!0}}),p&&q(g,"selection",f,function(a){g.zoom(t(a,l?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();l&&this.scaleGroups()}g&&(v(g.container,{cursor:g._cursor}),g.cancelClick=10<this.hasDragged,g.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){H[a.hoverChartIndex]&&
H[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,g=this.chartPosition;a=this.normalize(a,g);!g||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var g=H[a.hoverChartIndex];g&&(b.relatedTarget||b.toElement)&&(g.pointer.reset(),g.pointer.chartPosition=null)},onContainerMouseMove:function(b){var g=this.chart;n(a.hoverChartIndex)&&H[a.hoverChartIndex]&&H[a.hoverChartIndex].mouseIsDown||
(a.hoverChartIndex=g.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===g.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!g.isInsidePlot(b.chartX-g.plotLeft,b.chartY-g.plotTop)||g.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var g;a;){if(g=D(a,"class")){if(-1!==g.indexOf(b))return!0;if(-1!==g.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;if(!(!b||!a||
b.options.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,g=b.hoverPoint,l=b.plotLeft,f=b.plotTop;a=this.normalize(a);b.cancelClick||(g&&this.inClass(a.target,"highcharts-tracker")?(q(g.series,"click",t(a,{point:g})),b.hoverPoint&&g.firePointEvent("click",a)):(t(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-l,a.chartY-f)&&q(b,"click",a)))},setDOMEvents:function(){var b=
this,l=b.chart.container;l.onmousedown=function(a){b.onContainerMouseDown(a)};l.onmousemove=function(a){b.onContainerMouseMove(a)};l.onclick=function(a){b.onContainerClick(a)};E(l,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&E(m,"mouseup",b.onDocumentMouseUp);a.hasTouch&&(l.ontouchstart=function(a){b.onContainerTouchStart(a)},l.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&E(m,"touchend",b.onDocumentTouchEnd))},destroy:function(){var b;p(this.chart.container,"mouseleave",
this.onContainerMouseLeave);a.chartCount||(p(m,"mouseup",this.onDocumentMouseUp),p(m,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(b in this)this[b]=null}}})(K);(function(a){var E=a.charts,D=a.each,H=a.extend,I=a.map,v=a.noop,n=a.pick;H(a.Pointer.prototype,{pinchTranslate:function(a,n,t,q,e,b){this.zoomHor&&this.pinchTranslateDirection(!0,a,n,t,q,e,b);this.zoomVert&&this.pinchTranslateDirection(!1,a,n,t,q,e,b)},pinchTranslateDirection:function(a,n,t,q,e,b,p,w){var k=
this.chart,l=a?"x":"y",g=a?"X":"Y",m="chart"+g,r=a?"width":"height",u=k["plot"+(a?"Left":"Top")],f,B,d=w||1,x=k.inverted,c=k.bounds[a?"h":"v"],y=1===n.length,L=n[0][m],A=t[0][m],J=!y&&n[1][m],h=!y&&t[1][m],G;t=function(){!y&&20<Math.abs(L-J)&&(d=w||Math.abs(A-h)/Math.abs(L-J));B=(u-A)/d+L;f=k["plot"+(a?"Width":"Height")]/d};t();n=B;n<c.min?(n=c.min,G=!0):n+f>c.max&&(n=c.max-f,G=!0);G?(A-=.8*(A-p[l][0]),y||(h-=.8*(h-p[l][1])),t()):p[l]=[A,h];x||(b[l]=B-u,b[r]=f);b=x?1/d:d;e[r]=f;e[l]=n;q[x?a?"scaleY":
"scaleX":"scale"+g]=d;q["translate"+g]=b*u+(A-b*L)},pinch:function(a){var m=this,t=m.chart,q=m.pinchDown,e=a.touches,b=e.length,p=m.lastValidTouch,w=m.hasZoom,k=m.selectionMarker,l={},g=1===b&&(m.inClass(a.target,"highcharts-tracker")&&t.runTrackerClick||m.runChartClick),F={};1<b&&(m.initiated=!0);w&&m.initiated&&!g&&a.preventDefault();I(e,function(a){return m.normalize(a)});"touchstart"===a.type?(D(e,function(a,b){q[b]={chartX:a.chartX,chartY:a.chartY}}),p.x=[q[0].chartX,q[1]&&q[1].chartX],p.y=[q[0].chartY,
q[1]&&q[1].chartY],D(t.axes,function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],f=a.minPixelPadding,g=a.toPixels(n(a.options.min,a.dataMin)),d=a.toPixels(n(a.options.max,a.dataMax)),l=Math.max(g,d);b.min=Math.min(a.pos,Math.min(g,d)-f);b.max=Math.max(a.pos+a.len,l+f)}}),m.res=!0):m.followTouchMove&&1===b?this.runPointActions(m.normalize(a)):q.length&&(k||(m.selectionMarker=k=H({destroy:v,touch:!0},t.plotBox)),m.pinchTranslate(q,e,l,k,F,p),m.hasPinched=w,m.scaleGroups(l,F),m.res&&(m.res=
!1,this.reset(!1,0)))},touch:function(m,v){var t=this.chart,q,e;if(t.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=t.index;1===m.touches.length?(m=this.normalize(m),(e=t.isInsidePlot(m.chartX-t.plotLeft,m.chartY-t.plotTop))&&!t.openMenu?(v&&this.runPointActions(m),"touchmove"===m.type&&(v=this.pinchDown,q=v[0]?4<=Math.sqrt(Math.pow(v[0].chartX-m.chartX,2)+Math.pow(v[0].chartY-m.chartY,2)):!1),n(q,!0)&&this.pinch(m)):v&&this.reset()):2===m.touches.length&&
this.pinch(m)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(m){E[a.hoverChartIndex]&&E[a.hoverChartIndex].pointer.drop(m)}})})(K);(function(a){var E=a.addEvent,D=a.charts,H=a.css,I=a.doc,v=a.extend,n=a.noop,m=a.Pointer,z=a.removeEvent,t=a.win,q=a.wrap;if(t.PointerEvent||t.MSPointerEvent){var e={},b=!!t.PointerEvent,p=function(){var a,b=[];b.item=function(a){return this[a]};for(a in e)e.hasOwnProperty(a)&&
b.push({pageX:e[a].pageX,pageY:e[a].pageY,target:e[a].target});return b},w=function(b,l,g,e){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!D[a.hoverChartIndex]||(e(b),e=D[a.hoverChartIndex].pointer,e[l]({type:g,target:b.currentTarget,preventDefault:n,touches:p()}))};v(m.prototype,{onContainerPointerDown:function(a){w(a,"onContainerTouchStart","touchstart",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){w(a,"onContainerTouchMove",
"touchmove",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY};e[a.pointerId].target||(e[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){w(a,"onDocumentTouchEnd","touchend",function(a){delete e[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,b?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,b?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(I,b?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});q(m.prototype,
"init",function(a,b,g){a.call(this,b,g);this.hasZoom&&H(b.container,{"-ms-touch-action":"none","touch-action":"none"})});q(m.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(E)});q(m.prototype,"destroy",function(a){this.batchMSEvents(z);a.call(this)})}})(K);(function(a){var E,D=a.addEvent,H=a.css,I=a.discardElement,v=a.defined,n=a.each,m=a.extend,z=a.isFirefox,t=a.marginNames,q=a.merge,e=a.pick,b=a.setAnimation,p=a.stableSort,w=a.win,k=a.wrap;
E=a.Legend=function(a,b){this.init(a,b)};E.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),D(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var b=e(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.initialItemX=this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=e(a.symbolWidth,
16);this.pages=[]},update:function(a,b){var g=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();g.isDirtyLegend=g.isDirtyBox=!0;e(b,!0)&&g.redraw()},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");var g=this.options,e=a.legendItem,l=a.legendLine,f=a.legendSymbol,k=this.itemHiddenStyle.color,g=b?g.itemStyle.color:k,d=b?a.color||k:k,x=a.options&&a.options.marker,c={fill:d},y;e&&e.css({fill:g,color:g});l&&l.attr({stroke:d});if(f){if(x&&
f.isMarker&&(c=a.pointAttribs(),!b))for(y in c)c[y]=k;f.attr(c)}},positionItem:function(a){var b=this.options,e=b.symbolPadding,b=!b.rtl,l=a._legendItemPos,k=l[0],l=l[1],f=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?k:this.legendWidth-k-2*e-4,l);f&&(f.x=k,f.y=l)},destroyItem:function(a){var b=a.checkbox;n(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&I(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}
n(this.getAllItems(),function(b){n(["legendItem","legendGroup"],a,b)});n(["box","title","group"],a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,e,l=this.clipHeight||this.legendHeight,k=this.titleHeight;b&&(e=b.translateY,n(this.allItems,function(f){var g=f.checkbox,d;g&&(d=e+k+g.y+(a||0)+3,H(g,{left:b.translateX+f.checkboxOffset+g.x-20+"px",top:d+"px",display:d>e-6&&d<e+l-6?"":"none"}))}))},renderTitle:function(){var a=this.padding,b=this.options.title,
e=0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,a-3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),e=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(b){var g=this.options;b.legendItem.attr({text:g.labelFormat?a.format(g.labelFormat,b):g.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,l=b.renderer,k=this.options,u="horizontal"===
k.layout,f=this.symbolWidth,p=k.symbolPadding,d=this.itemStyle,x=this.itemHiddenStyle,c=this.padding,y=u?e(k.itemDistance,20):0,m=!k.rtl,A=k.width,J=k.itemMarginBottom||0,h=this.itemMarginTop,w=this.initialItemX,n=a.legendItem,t=!a.series,v=!t&&a.series.drawLegendSymbol?a.series:a,z=v.options,z=this.createCheckboxForItem&&z&&z.showCheckbox,C=k.useHTML;n||(a.legendGroup=l.g("legend-item").addClass("highcharts-"+v.type+"-series highcharts-color-"+a.colorIndex+(a.options.className?" "+a.options.className:
"")+(t?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=n=l.text("",m?f+p:-p,this.baseline||0,C).css(q(a.visible?d:x)).attr({align:m?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(d=d.fontSize,this.fontMetrics=l.fontMetrics(d,n),this.baseline=this.fontMetrics.f+3+h,n.attr("y",this.baseline)),this.symbolHeight=k.symbolHeight||this.fontMetrics.f,v.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,n,C),z&&this.createCheckboxForItem(a));
this.colorizeItem(a,a.visible);this.setText(a);l=n.getBBox();f=a.checkboxOffset=k.itemWidth||a.legendItemWidth||f+p+l.width+y+(z?20:0);this.itemHeight=p=Math.round(a.legendItemHeight||l.height);u&&this.itemX-w+f>(A||b.chartWidth-2*c-w-k.x)&&(this.itemX=w,this.itemY+=h+this.lastLineHeight+J,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,f);this.lastItemY=h+this.itemY+J;this.lastLineHeight=Math.max(p,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];u?this.itemX+=f:
(this.itemY+=h+p+J,this.lastLineHeight=p);this.offsetWidth=A||Math.max((u?this.itemX-w-y:f)+c,this.offsetWidth)},getAllItems:function(){var a=[];n(this.chart.series,function(b){var g=b&&b.options;b&&e(g.showInLegend,v(g.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===g.legendType?b.data:b)))});return a},adjustMargins:function(a,b){var g=this.chart,l=this.options,k=l.align.charAt(0)+l.verticalAlign.charAt(0)+l.layout.charAt(0);l.floating||n([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,
/(lbv|lm|ltv)/],function(f,r){f.test(k)&&!v(a[r])&&(g[t[r]]=Math.max(g[t[r]],g.legend[(r+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][r]*l[r%2?"x":"y"]+e(l.margin,12)+b[r]))})},render:function(){var a=this,b=a.chart,e=b.renderer,k=a.group,u,f,B,d,x=a.box,c=a.options,y=a.padding;a.itemX=a.initialItemX;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;k||(a.group=k=e.g("legend").attr({zIndex:7}).add(),a.contentGroup=e.g().attr({zIndex:1}).add(k),a.scrollGroup=e.g().add(a.contentGroup));a.renderTitle();
u=a.getAllItems();p(u,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});c.reversed&&u.reverse();a.allItems=u;a.display=f=!!u.length;a.lastLineHeight=0;n(u,function(b){a.renderItem(b)});B=(c.width||a.offsetWidth)+y;d=a.lastItemY+a.lastLineHeight+a.titleHeight;d=a.handleOverflow(d);d+=y;x||(a.box=x=e.rect().addClass("highcharts-legend-box").attr({r:c.borderRadius}).add(k),x.isNew=!0);x.attr({stroke:c.borderColor,"stroke-width":c.borderWidth||0,fill:c.backgroundColor||
"none"}).shadow(c.shadow);0<B&&0<d&&(x[x.isNew?"attr":"animate"](x.crisp({x:0,y:0,width:B,height:d},x.strokeWidth())),x.isNew=!1);x[f?"show":"hide"]();a.legendWidth=B;a.legendHeight=d;n(u,function(b){a.positionItem(b)});f&&k.align(m({width:B,height:d},c),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,l=this.chart,k=l.renderer,u=this.options,f=u.y,l=l.spacingBox.height+("top"===u.verticalAlign?-f:f)-this.padding,f=u.maxHeight,p,d=this.clipRect,x=u.navigation,
c=e(x.animation,!0),y=x.arrowSize||12,w=this.nav,A=this.pages,J=this.padding,h,m=this.allItems,q=function(a){a?d.attr({height:a}):d&&(b.clipRect=d.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+J+"px,9999px,"+(J+a)+"px,0)":"auto")};"horizontal"!==u.layout||"middle"===u.verticalAlign||u.floating||(l/=2);f&&(l=Math.min(l,f));A.length=0;a>l&&!1!==x.enabled?(this.clipHeight=p=Math.max(l-20-this.titleHeight-J,0),this.currentPage=e(this.currentPage,1),this.fullHeight=
a,n(m,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=A.length;if(!d||c-A[d-1]>p&&(h||c)!==A[d-1])A.push(h||c),d++;b===m.length-1&&c+a-A[d-1]>p&&A.push(c);c!==h&&(h=c)}),d||(d=b.clipRect=k.clipRect(0,J,9999,0),b.contentGroup.clip(d)),q(p),w||(this.nav=w=k.g().attr({zIndex:1}).add(this.group),this.up=k.symbol("triangle",0,0,y,y).on("click",function(){b.scroll(-1,c)}).add(w),this.pager=k.text("",15,10).addClass("highcharts-legend-navigation").css(x.style).add(w),
this.down=k.symbol("triangle-down",0,0,y,y).on("click",function(){b.scroll(1,c)}).add(w)),b.scroll(0),a=l):w&&(q(),w.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,g){var e=this.pages,k=e.length;a=this.currentPage+a;var l=this.clipHeight,f=this.options.navigation,p=this.pager,d=this.padding;a>k&&(a=k);0<a&&(void 0!==g&&b(g,this.chart),this.nav.attr({translateX:d,translateY:l+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===
a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),p.attr({text:a+"/"+k}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===k?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?f.inactiveColor:f.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===k?f.inactiveColor:f.activeColor}).css({cursor:a===k?"default":"pointer"}),g=-e[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:g}),this.currentPage=
a,this.positionCheckboxes(g))}};a.LegendSymbolMixin={drawRectangle:function(a,b){var g=a.symbolHeight,k=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(k?(a.symbolWidth-g)/2:0,a.baseline-g+1,k?g:a.symbolWidth,g,e(a.options.symbolRadius,g/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,k=b.marker,l=a.symbolWidth,u=a.symbolHeight,f=u/2,p=this.chart.renderer,d=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);
var x;x={"stroke-width":b.lineWidth||0};b.dashStyle&&(x.dashstyle=b.dashStyle);this.legendLine=p.path(["M",0,a,"L",l,a]).addClass("highcharts-graph").attr(x).add(d);k&&!1!==k.enabled&&(b=Math.min(e(k.radius,f),f),0===this.symbol.indexOf("url")&&(k=q(k,{width:u,height:u}),b=0),this.legendSymbol=k=p.symbol(this.symbol,l/2-b,a-b,2*b,2*b,k).addClass("highcharts-point").add(d),k.isMarker=!0)}};(/Trident\/7\.0/.test(w.navigator.userAgent)||z)&&k(E.prototype,"positionItem",function(a,b){var e=this,g=function(){b._legendItemPos&&
a.call(e,b)};g();setTimeout(g)})})(K);(function(a){var E=a.addEvent,D=a.animate,H=a.animObject,I=a.attr,v=a.doc,n=a.Axis,m=a.createElement,z=a.defaultOptions,t=a.discardElement,q=a.charts,e=a.css,b=a.defined,p=a.each,w=a.extend,k=a.find,l=a.fireEvent,g=a.getStyle,F=a.grep,r=a.isNumber,u=a.isObject,f=a.isString,B=a.Legend,d=a.marginNames,x=a.merge,c=a.Pointer,y=a.pick,L=a.pInt,A=a.removeEvent,J=a.seriesTypes,h=a.splat,G=a.svg,Q=a.syncTimeout,P=a.win,N=a.Renderer,S=a.Chart=function(){this.getArgs.apply(this,
arguments)};a.chart=function(a,b,c){return new S(a,b,c)};S.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(f(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var d,h=b.series;b.series=null;d=x(z,b);d.series=b.series=h;this.userOptions=b;this.respRules=[];b=d.chart;h=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=d;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;
var f;this.index=q.length;q.push(this);a.chartCount++;if(h)for(f in h)E(this,f,h[f]);this.xAxis=[];this.yAxis=[];this.pointCount=this.colorCounter=this.symbolCounter=0;this.firstRender()},initSeries:function(b){var c=this.options.chart;(c=J[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var d=c?
b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,d=this.series,h=this.pointer,f=this.legend,e=this.isDirtyLegend,y,g,A=this.hasCartesianSeries,k=this.isDirtyBox,u=d.length,r=u,x=this.renderer,J=x.isHidden(),C=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);J&&this.cloneRenderTo();for(this.layOutTitles();r--;)if(b=d[r],b.options.stacking&&(y=!0,b.isDirty)){g=!0;break}if(g)for(r=u;r--;)b=d[r],b.options.stacking&&(b.isDirty=
!0);p(d,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),e=!0);a.isDirtyData&&l(a,"updatedData")});e&&f.options.enabled&&(f.render(),this.isDirtyLegend=!1);y&&this.getStacks();A&&p(c,function(a){a.updateNames();a.setScale()});this.getMargins();A&&(p(c,function(a){a.isDirty&&(k=!0)}),p(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,C.push(function(){l(a,"afterSetExtremes",w(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(k||y)&&a.redraw()}));
k&&this.drawChartBox();l(this,"predraw");p(d,function(a){(k||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);x.draw();l(this,"redraw");l(this,"render");J&&this.cloneRenderTo(!0);p(C,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,h;c=k(this.axes,b)||k(this.series,b);for(h=0;!c&&h<d.length;h++)c=k(d[h].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=h(b.xAxis||{}),b=b.yAxis=h(b.yAxis||
{});p(c,function(a,b){a.index=b;a.isX=!0});p(b,function(a,b){a.index=b});c=c.concat(b);p(c,function(b){new n(a,b)})},getSelectedPoints:function(){var a=[];p(this.series,function(b){a=a.concat(F(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return F(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var d=this,h=d.options,f;f=h.title=x({style:{color:"#333333",fontSize:h.isStock?"16px":"18px"}},h.title,a);h=h.subtitle=x({style:{color:"#666666"}},
h.subtitle,b);p([["title",a,f],["subtitle",b,h]],function(a,b){var c=a[0],h=d[c],f=a[1];a=a[2];h&&f&&(d[c]=h=h.destroy());a&&a.text&&!h&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c,d=this.renderer,h=this.spacingBox;p(["title","subtitle"],function(a){var c=this[a],f=this.options[a],e;c&&(e=f.style.fontSize,
e=d.fontMetrics(e,c).b,c.css({width:(f.width||h.width+f.widthAdjust)+"px"}).align(w({y:b+e+("title"===a?-3:2)},f),!1,"spacingBox"),f.floating||f.verticalAlign||(b=Math.ceil(b+c.getBBox().height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=c,this.hasRendered&&y(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=this.options.chart,c=a.width,a=a.height,d=this.renderToClone||this.renderTo;b(c)||(this.containerWidth=g(d,"width"));b(a)||(this.containerHeight=
g(d,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a||this.containerHeight||400)},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;if(a){if(b){for(;b.childNodes.length;)this.renderTo.appendChild(b.firstChild);t(b);delete this.renderToClone}}else c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),e(b,{position:"absolute",top:"-9999px",display:"block"}),b.style.setProperty&&
b.style.setProperty("display","block","important"),v.body.appendChild(b),c&&b.appendChild(c)},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,d=c.chart,h,e;b=this.renderTo;var y=a.uniqueKey(),g;b||(this.renderTo=b=d.renderTo);f(b)&&(this.renderTo=b=v.getElementById(b));b||a.error(13,!0);h=L(I(b,"data-highcharts-chart"));r(h)&&q[h]&&q[h].hasRendered&&q[h].destroy();I(b,"data-highcharts-chart",this.index);b.innerHTML="";
d.skipClone||b.offsetWidth||this.cloneRenderTo();this.getChartSize();h=this.chartWidth;e=this.chartHeight;g=w({position:"relative",overflow:"hidden",width:h+"px",height:e+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},d.style);this.container=b=m("div",{id:y},g,this.renderToClone||b);this._cursor=b.style.cursor;this.renderer=new (a[d.renderer]||N)(b,h,e,null,d.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(d.className);this.renderer.setStyle(d.style);
this.renderer.chartIndex=this.index},getMargins:function(a){var c=this.spacing,d=this.margin,h=this.titleOffset;this.resetMargins();h&&!b(d[0])&&(this.plotTop=Math.max(this.plotTop,h+this.options.title.margin+c[0]));this.legend.display&&this.legend.adjustMargins(d,c);this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,c=a.axisOffset=
[0,0,0,0],h=a.margin;a.hasCartesianSeries&&p(a.axes,function(a){a.visible&&a.getOffset()});p(d,function(d,f){b(h[f])||(a[d]+=c[f])});a.setChartSize()},reflow:function(a){var c=this,d=c.options.chart,h=c.renderTo,f=b(d.width),e=d.width||g(h,"width"),d=d.height||g(h,"height"),h=a?a.target:P;if(!f&&!c.isPrinting&&e&&d&&(h===P||h===v)){if(e!==c.containerWidth||d!==c.containerHeight)clearTimeout(c.reflowTimeout),c.reflowTimeout=Q(function(){c.container&&c.setSize(void 0,void 0,!1)},a?100:0);c.containerWidth=
e;c.containerHeight=d}},initReflow:function(){var a=this,b;b=E(P,"resize",function(b){a.reflow(b)});E(a,"destroy",b)},setSize:function(b,c,d){var h=this,f=h.renderer;h.isResizing+=1;a.setAnimation(d,h);h.oldChartHeight=h.chartHeight;h.oldChartWidth=h.chartWidth;void 0!==b&&(h.options.chart.width=b);void 0!==c&&(h.options.chart.height=c);h.getChartSize();b=f.globalAnimation;(b?D:e)(h.container,{width:h.chartWidth+"px",height:h.chartHeight+"px"},b);h.setChartSize(!0);f.setSize(h.chartWidth,h.chartHeight,
d);p(h.axes,function(a){a.isDirty=!0;a.setScale()});h.isDirtyLegend=!0;h.isDirtyBox=!0;h.layOutTitles();h.getMargins();h.redraw(d);h.oldChartHeight=null;l(h,"resize");Q(function(){h&&l(h,"endResize",null,function(){--h.isResizing})},H(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,h=this.chartHeight,f=this.options.chart,e=this.spacing,y=this.clipOffset,g,A,k,l;this.plotLeft=g=Math.round(this.plotLeft);this.plotTop=A=Math.round(this.plotTop);this.plotWidth=
k=Math.max(0,Math.round(d-g-this.marginRight));this.plotHeight=l=Math.max(0,Math.round(h-A-this.marginBottom));this.plotSizeX=b?l:k;this.plotSizeY=b?k:l;this.plotBorderWidth=f.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:e[3],y:e[0],width:d-e[3]-e[1],height:h-e[0]-e[2]};this.plotBox=c.plotBox={x:g,y:A,width:k,height:l};d=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(d,y[3])/2);c=Math.ceil(Math.max(d,y[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(d,y[1])/
2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(d,y[2])/2-c))};a||p(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;p(["margin","spacing"],function(c){var d=b[c],h=u(d)?d:[d,d,d,d];p(["Top","Right","Bottom","Left"],function(d,f){a[c][f]=y(b[c+d],h[f])})});p(d,function(b,c){a[b]=y(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=
this.chartWidth,d=this.chartHeight,h=this.chartBackground,f=this.plotBackground,e=this.plotBorder,y,g=this.plotBGImage,A=a.backgroundColor,k=a.plotBackgroundColor,l=a.plotBackgroundImage,u,r=this.plotLeft,x=this.plotTop,J=this.plotWidth,p=this.plotHeight,w=this.plotBox,m=this.clipRect,q=this.clipBox,B="animate";h||(this.chartBackground=h=b.rect().addClass("highcharts-background").add(),B="attr");y=a.borderWidth||0;u=y+(a.shadow?8:0);A={fill:A||"none"};if(y||h["stroke-width"])A.stroke=a.borderColor,
A["stroke-width"]=y;h.attr(A).shadow(a.shadow);h[B]({x:u/2,y:u/2,width:c-u-y%2,height:d-u-y%2,r:a.borderRadius});B="animate";f||(B="attr",this.plotBackground=f=b.rect().addClass("highcharts-plot-background").add());f[B](w);f.attr({fill:k||"none"}).shadow(a.plotShadow);l&&(g?g.animate(w):this.plotBGImage=b.image(l,r,x,J,p).add());m?m.animate({width:q.width,height:q.height}):this.clipRect=b.clipRect(q);B="animate";e||(B="attr",this.plotBorder=e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());
e.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});e[B](e.crisp({x:r,y:x,width:J,height:p},-e.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,h,f;p(["inverted","angular","polar"],function(e){c=J[b.type||b.defaultSeriesType];f=b[e]||c&&c.prototype[e];for(h=d&&d.length;!f&&h--;)(c=J[d[h].type])&&c.prototype[e]&&(f=!0);a[e]=f})},linkSeries:function(){var a=this,b=a.series;p(b,function(a){a.linkedSeries.length=
0});p(b,function(b){var c=b.options.linkedTo;f(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=y(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){p(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&p(b.items,function(c){var d=w(b.style,c.style),h=L(d.left)+a.plotLeft,f=L(d.top)+a.plotTop+12;delete d.left;delete d.top;a.renderer.text(c.html,
h,f).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,h,f;this.setTitle();this.legend=new B(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;d=this.plotHeight-=21;p(a,function(a){a.setScale()});this.getAxisMargins();h=1.1<c/this.plotWidth;f=1.05<d/this.plotHeight;if(h||f)p(a,function(a){(a.horiz&&h||!a.horiz&&f)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&
p(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=x(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(P.location.href=a.href)}).attr({align:a.position.align,
zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,d=b.series,h=b.container,f,e=h&&h.parentNode;l(b,"destroy");q[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");A(b);for(f=c.length;f--;)c[f]=c[f].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(f=d.length;f--;)d[f]=d[f].destroy();p("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),
function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});h&&(h.innerHTML="",A(h),e&&t(h));for(f in b)delete b[f]},isReadyToRender:function(){var a=this;return G||P!=P.top||"complete"===v.readyState?!0:(v.attachEvent("onreadystatechange",function(){v.detachEvent("onreadystatechange",a.firstRender);"complete"===v.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();l(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();
a.getAxes();p(b.series||[],function(b){a.initSeries(b)});a.linkSeries();l(a,"beforeRender");c&&(a.pointer=new c(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.cloneRenderTo(!0)}},onload:function(){p([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);l(this,"load");l(this,"render");b(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}}})(K);(function(a){var E,D=a.each,H=a.extend,I=a.erase,v=a.fireEvent,
n=a.format,m=a.isArray,z=a.isNumber,t=a.pick,q=a.removeEvent;E=a.Point=function(){};E.prototype={init:function(a,b,p){this.series=a;this.color=a.color;this.applyOptions(b,p);a.options.colorByPoint?(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter],b=b.length,p=a.colorCounter,a.colorCounter++,a.colorCounter===b&&(a.colorCounter=0)):p=a.colorIndex;this.colorIndex=t(this.colorIndex,p);a.chart.pointCount++;return this},applyOptions:function(a,b){var e=this.series,w=e.options.pointValKey||
e.pointValKey;a=E.prototype.optionsToObject.call(this,a);H(this,a);this.options=this.options?H(this.options,a):a;a.group&&delete this.group;w&&(this.y=this[w]);this.isNull=t(this.isValid&&!this.isValid(),null===this.x||!z(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===b&&e.xAxis&&e.xAxis.hasNames&&(this.x=e.xAxis.nameToX(this));void 0===this.x&&e&&(this.x=void 0===b?e.autoIncrement(this):b);return this},optionsToObject:function(a){var b={},e=this.series,w=e.options.keys,
k=w||e.pointArrayMap||["y"],l=k.length,g=0,q=0;if(z(a)||null===a)b[k[0]]=a;else if(m(a))for(!w&&a.length>l&&(e=typeof a[0],"string"===e?b.name=a[0]:"number"===e&&(b.x=a[0]),g++);q<l;)w&&void 0===a[g]||(b[k[q]]=a[g]),g++,q++;else"object"===typeof a&&(b=a,a.dataLabels&&(e._hasPointLabels=!0),a.marker&&(e._hasPointMarkers=!0));return b},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":
"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,b=a.zones,a=a.zoneAxis||"y",p=0,w;for(w=b[p];this[a]>=w.value;)w=b[++p];w&&w.color&&!this.options.color&&(this.color=w.color);return w},destroy:function(){var a=this.series.chart,b=a.hoverPoints,p;a.pointCount--;b&&(this.setState(),I(b,this),b.length||
(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)q(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(p in this)this[p]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],b,p=6;p--;)b=a[p],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,
point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,e=b.tooltipOptions,w=t(e.valueDecimals,""),k=e.valuePrefix||"",l=e.valueSuffix||"";D(b.pointArrayMap||["y"],function(b){b="{point."+b;if(k||l)a=a.replace(b+"}",k+b+"}"+l);a=a.replace(b+"}",b+":,."+w+"f}")});return n(a,{point:this,series:this.series})},firePointEvent:function(a,b,p){var e=this,k=this.series.options;(k.point.events[a]||e.options&&e.options.events&&e.options.events[a])&&
this.importEvents();"click"===a&&k.allowPointSelect&&(p=function(a){e.select&&e.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});v(this,a,b,p)},visible:!0}})(K);(function(a){var E=a.addEvent,D=a.animObject,H=a.arrayMax,I=a.arrayMin,v=a.correctFloat,n=a.Date,m=a.defaultOptions,z=a.defaultPlotOptions,t=a.defined,q=a.each,e=a.erase,b=a.extend,p=a.fireEvent,w=a.grep,k=a.isArray,l=a.isNumber,g=a.isString,F=a.merge,r=a.pick,u=a.removeEvent,f=a.splat,B=a.SVGElement,d=a.syncTimeout,x=a.win;a.Series=a.seriesType("line",
null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",
x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,d){var c=this,f,e,h=a.series,y;c.chart=a;c.options=d=c.setOptions(d);c.linkedSeries=[];c.bindAxes();b(c,{name:d.name,state:"",visible:!1!==
d.visible,selected:!0===d.selected});e=d.events;for(f in e)E(c,f,e[f]);if(e&&e.click||d.point&&d.point.events&&d.point.events.click||d.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();q(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(d.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);h.length&&(y=h[h.length-1]);c._i=r(y&&y._i,-1)+1;a.orderSeries(this.insert(h))},insert:function(a){var b=this.options.index,c;if(l(b)){for(c=a.length;c--;)if(b>=r(a[c].options.index,a[c]._i)){a.splice(c+
1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return r(c,a.length-1)},bindAxes:function(){var b=this,d=b.options,f=b.chart,e;q(b.axisTypes||[],function(c){q(f[c],function(a){e=a.options;if(d[c]===e.index||void 0!==d[c]&&d[c]===e.id||void 0===d[c]&&0===e.index)b.insert(a.series),b[c]=a,a.isDirty=!0});b[c]||b.optionalAxis===c||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,f=l(b)?function(d){var h="y"===d&&c.toYData?c.toYData(a):a[d];c[d+"Data"][b]=
h}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,f)},autoIncrement:function(){var a=this.options,b=this.xIncrement,d,f=a.pointIntervalUnit,b=r(b,a.pointStart,0);this.pointInterval=d=r(this.pointInterval,a.pointInterval,1);f&&(a=new n(b),"day"===f?a=+a[n.hcSetDate](a[n.hcGetDate]()+d):"month"===f?a=+a[n.hcSetMonth](a[n.hcGetMonth]()+d):"year"===f&&(a=+a[n.hcSetFullYear](a[n.hcGetFullYear]()+d)),d=a-b);this.xIncrement=b+d;return b},setOptions:function(a){var b=
this.chart,c=b.options.plotOptions,b=b.userOptions||{},d=b.plotOptions||{},f=c[this.type];this.userOptions=a;c=F(f,c.series,a);this.tooltipOptions=F(m.tooltip,m.plotOptions[this.type].tooltip,b.tooltip,d.series&&d.series.tooltip,d[this.type]&&d[this.type].tooltip,a.tooltip);null===f.marker&&delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();!c.negativeColor&&!c.negativeFillColor||c.zones||a.push({value:c[this.zoneAxis+"Threshold"]||c.threshold||0,className:"highcharts-negative",
color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&t(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,d){var c,f=this.chart,h=this.userOptions,e=a+"Index",g=a+"Counter",y=d?d.length:r(f.options.chart[a+"Count"],f[a+"Count"]);b||(c=r(h[e],h["_"+e]),t(c)||(f.series.length||(f[g]=0),h["_"+e]=c=f[g]%y,f[g]+=1),d&&(b=d[c]));void 0!==c&&(this[e]=c);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",
this.options.color||z[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,d,f,e){var c=this,h=c.points,y=h&&h.length||0,A,u=c.options,x=c.chart,p=null,w=c.xAxis,m=u.turboThreshold,B=this.xData,n=this.yData,t=(A=c.pointArrayMap)&&A.length;b=b||[];A=b.length;d=r(d,!0);if(!1!==e&&A&&y===A&&!c.cropped&&!c.hasGroupedData&&c.visible)q(b,function(a,
b){h[b].update&&a!==u.data[b]&&h[b].update(a,!1,null,!1)});else{c.xIncrement=null;c.colorCounter=0;q(this.parallelArrays,function(a){c[a+"Data"].length=0});if(m&&A>m){for(f=0;null===p&&f<A;)p=b[f],f++;if(l(p))for(f=0;f<A;f++)B[f]=this.autoIncrement(),n[f]=b[f];else if(k(p))if(t)for(f=0;f<A;f++)p=b[f],B[f]=p[0],n[f]=p.slice(1,t+1);else for(f=0;f<A;f++)p=b[f],B[f]=p[0],n[f]=p[1];else a.error(12)}else for(f=0;f<A;f++)void 0!==b[f]&&(p={series:c},c.pointClass.prototype.applyOptions.apply(p,[b[f]]),c.updateParallelArrays(p,
f));g(n[0])&&a.error(14,!0);c.data=[];c.options.data=c.userOptions.data=b;for(f=y;f--;)h[f]&&h[f].destroy&&h[f].destroy();w&&(w.minRange=w.userMinRange);c.isDirty=x.isDirtyBox=!0;c.isDirtyData=!!h;f=!1}"point"===u.legendType&&(this.processData(),this.generatePoints());d&&x.redraw(f)},processData:function(b){var c=this.xData,d=this.yData,f=c.length,e;e=0;var h,g,k=this.xAxis,l,u=this.options;l=u.cropThreshold;var r=this.getExtremesFromAll||u.getExtremesFromAll,x=this.isCartesian,u=k&&k.val2lin,p=k&&
k.isLog,q,w;if(x&&!this.isDirty&&!k.isDirty&&!this.yAxis.isDirty&&!b)return!1;k&&(b=k.getExtremes(),q=b.min,w=b.max);if(x&&this.sorted&&!r&&(!l||f>l||this.forceCrop))if(c[f-1]<q||c[0]>w)c=[],d=[];else if(c[0]<q||c[f-1]>w)e=this.cropData(this.xData,this.yData,q,w),c=e.xData,d=e.yData,e=e.start,h=!0;for(l=c.length||1;--l;)f=p?u(c[l])-u(c[l-1]):c[l]-c[l-1],0<f&&(void 0===g||f<g)?g=f:0>f&&this.requireSorting&&a.error(15);this.cropped=h;this.cropStart=e;this.processedXData=c;this.processedYData=d;this.closestPointRange=
g},cropData:function(a,b,d,f){var c=a.length,h=0,e=c,g=r(this.cropShoulder,1),y;for(y=0;y<c;y++)if(a[y]>=d){h=Math.max(0,y-g);break}for(d=y;d<c;d++)if(a[d]>f){e=d+g;break}return{xData:a.slice(h,e),yData:b.slice(h,e),start:h,end:e}},generatePoints:function(){var a=this.options.data,b=this.data,d,e=this.processedXData,g=this.processedYData,h=this.pointClass,k=e.length,l=this.cropStart||0,u,r=this.hasGroupedData,x,p=[],q;b||r||(b=[],b.length=a.length,b=this.data=b);for(q=0;q<k;q++)u=l+q,r?(x=(new h).init(this,
[e[q]].concat(f(g[q]))),x.dataGroup=this.groupMap[q]):(x=b[u])||void 0===a[u]||(b[u]=x=(new h).init(this,a[u],e[q])),x.index=u,p[q]=x;if(b&&(k!==(d=b.length)||r))for(q=0;q<d;q++)q!==l||r||(q+=k),b[q]&&(b[q].destroyElements(),b[q].plotX=void 0);this.data=b;this.points=p},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,f=[],h=0;d=this.xAxis.getExtremes();var e=d.min,g=d.max,u,r,x,p;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(p=0;p<d;p++)if(r=c[p],x=a[p],u=(l(x,!0)||
k(x))&&(!b.isLog||x.length||0<x),r=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[p+1]||r)>=e&&(c[p-1]||r)<=g,u&&r)if(u=x.length)for(;u--;)null!==x[u]&&(f[h++]=x[u]);else f[h++]=x;this.dataMin=I(f);this.dataMax=H(f)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,d=this.xAxis,f=d.categories,e=this.yAxis,h=this.points,g=h.length,k=!!this.modifyValue,u=a.pointPlacement,x="between"===u||l(u),p=a.threshold,
q=a.startFromThreshold?p:0,w,m,B,n,F=Number.MAX_VALUE;"between"===u&&(u=.5);l(u)&&(u*=r(a.pointRange||d.pointRange));for(a=0;a<g;a++){var z=h[a],D=z.x,E=z.y;m=z.low;var I=b&&e.stacks[(this.negStacks&&E<(q?0:p)?"-":"")+this.stackKey],H;e.isLog&&null!==E&&0>=E&&(z.isNull=!0);z.plotX=w=v(Math.min(Math.max(-1E5,d.translate(D,0,0,0,1,u,"flags"===this.type)),1E5));b&&this.visible&&!z.isNull&&I&&I[D]&&(n=this.getStackIndicator(n,D,this.index),H=I[D],E=H.points[n.key],m=E[0],E=E[1],m===q&&n.key===I[D].base&&
(m=r(p,e.min)),e.isLog&&0>=m&&(m=null),z.total=z.stackTotal=H.total,z.percentage=H.total&&z.y/H.total*100,z.stackY=E,H.setOffset(this.pointXOffset||0,this.barW||0));z.yBottom=t(m)?e.translate(m,0,1,0,1):null;k&&(E=this.modifyValue(E,z));z.plotY=m="number"===typeof E&&Infinity!==E?Math.min(Math.max(-1E5,e.translate(E,0,1,0,1)),1E5):void 0;z.isInside=void 0!==m&&0<=m&&m<=e.len&&0<=w&&w<=d.len;z.clientX=x?v(d.translate(D,0,0,0,1,u)):w;z.negative=z.y<(p||0);z.category=f&&void 0!==f[z.x]?f[z.x]:z.x;z.isNull||
(void 0!==B&&(F=Math.min(F,Math.abs(w-B))),B=w);z.zone=this.zones.length&&z.getZone()}this.closestPointRangePx=F},getValidPoints:function(a,b){var c=this.chart;return w(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,f=b.inverted,h=this.clipBox,e=h||b.clipBox,g=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,e.height,c.xAxis,c.yAxis].join(),k=b[g],l=b[g+"m"];k||(a&&(e.width=
0,b[g+"m"]=l=d.clipRect(-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[g]=k=d.clipRect(e),k.count={length:0});a&&!k.count[this.index]&&(k.count[this.index]=!0,k.count.length+=1);!1!==c.clip&&(this.group.clip(a||h?k:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=g);a||(k.count[this.index]&&(delete k.count[this.index],--k.count.length),0===k.count.length&&g&&b[g]&&(h||(b[g]=b[g].destroy()),b[g+"m"]&&(this.markerGroup.clip(),b[g+"m"]=b[g+"m"].destroy())))},animate:function(a){var b=
this.chart,c=D(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();p(this,"afterAnimate")},drawPoints:function(){var a=this.points,b=this.chart,d,f,e,h,g=this.options.marker,k,u,x,p,q=this.markerGroup,w=r(g.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>2*g.radius);if(!1!==g.enabled||this._hasPointMarkers)for(f=0;f<a.length;f++)e=
a[f],d=e.plotY,h=e.graphic,k=e.marker||{},u=!!e.marker,x=w&&void 0===k.enabled||k.enabled,p=e.isInside,x&&l(d)&&null!==e.y?(d=r(k.symbol,this.symbol),e.hasImage=0===d.indexOf("url"),x=this.markerAttribs(e,e.selected&&"select"),h?h[p?"show":"hide"](!0).animate(x):p&&(0<x.width||e.hasImage)&&(e.graphic=h=b.renderer.symbol(d,x.x,x.y,x.width,x.height,u?k:g).add(q)),h&&h.attr(this.pointAttribs(e,e.selected&&"select")),h&&h.addClass(e.getClassName(),!0)):h&&(e.graphic=h.destroy())},markerAttribs:function(a,
b){var c=this.options.marker,d=a.marker||{},f=r(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],f=r(b&&b.radius,c&&c.radius,f+(c&&c.radiusPlus||0)));a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,f=d&&d.marker||{},h=this.color,e=d&&d.color,g=a&&a.color,d=r(f.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;h=e||a||g||h;a=f.fillColor||c.fillColor||h;h=f.lineColor||c.lineColor||
h;b&&(c=c.states[b],b=f.states&&f.states[b]||{},d=r(b.lineWidth,c.lineWidth,d+r(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,h=b.lineColor||c.lineColor||h);return{stroke:h,"stroke-width":d,fill:a}},destroy:function(){var a=this,b=a.chart,d=/AppleWebKit\/533/.test(x.navigator.userAgent),f,g=a.data||[],h,k,l;p(a,"destroy");u(a);q(a.axisTypes||[],function(b){(l=a[b])&&l.series&&(e(l.series,a),l.isDirty=l.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(f=g.length;f--;)(h=
g[f])&&h.destroy&&h.destroy();a.points=null;clearTimeout(a.animationTimeout);for(k in a)a[k]instanceof B&&!a[k].survive&&(f=d&&"group"===k?"hide":"destroy",a[k][f]());b.hoverSeries===a&&(b.hoverSeries=null);e(b.series,a);b.orderSeries();for(k in a)delete a[k]},getGraphPath:function(a,b,d){var c=this,f=c.options,h=f.step,e,g=[],k=[],l;a=a||c.points;(e=a.reversed)&&a.reverse();(h={right:1,center:2}[h]||h&&3)&&e&&(h=4-h);!f.connectNulls||b||d||(a=this.getValidPoints(a));q(a,function(e,y){var u=e.plotX,
A=e.plotY,x=a[y-1];(e.leftCliff||x&&x.rightCliff)&&!d&&(l=!0);e.isNull&&!t(b)&&0<y?l=!f.connectNulls:e.isNull&&!b?l=!0:(0===y||l?y=["M",e.plotX,e.plotY]:c.getPointSpline?y=c.getPointSpline(a,e,y):h?(y=1===h?["L",x.plotX,A]:2===h?["L",(x.plotX+u)/2,x.plotY,"L",(x.plotX+u)/2,A]:["L",u,x.plotY],y.push("L",u,A)):y=["L",u,A],k.push(e.x),h&&k.push(e.x),g.push.apply(g,y),l=!1)});g.xMap=k;return c.graphPath=g},drawGraph:function(){var a=this,b=this.options,d=(this.gappedPath||this.getGraphPath).call(this),
f=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];q(this.zones,function(c,d){f.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});q(f,function(c,f){var h=c[0],e=a[h];e?(e.endX=d.xMap,e.animate({d:d})):d.length&&(a[h]=a.chart.renderer.path(d).addClass(c[1]).attr({zIndex:1}).add(a.group),e={stroke:c[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},c[3]?e.dashstyle=c[3]:"square"!==b.linecap&&
(e["stroke-linecap"]=e["stroke-linejoin"]="round"),e=a[h].attr(e).shadow(2>f&&b.shadow));e&&(e.startX=d.xMap,e.isArea=d.isArea)})},applyZones:function(){var a=this,b=this.chart,d=b.renderer,f=this.zones,e,h,g=this.clips||[],k,l=this.graph,u=this.area,x=Math.max(b.chartWidth,b.chartHeight),p=this[(this.zoneAxis||"y")+"Axis"],w,m,B=b.inverted,n,t,v,F,z=!1;f.length&&(l||u)&&p&&void 0!==p.min&&(m=p.reversed,n=p.horiz,l&&l.hide(),u&&u.hide(),w=p.getExtremes(),q(f,function(c,f){e=m?n?b.plotWidth:0:n?0:
p.toPixels(w.min);e=Math.min(Math.max(r(h,e),0),x);h=Math.min(Math.max(Math.round(p.toPixels(r(c.value,w.max),!0)),0),x);z&&(e=h=p.toPixels(w.max));t=Math.abs(e-h);v=Math.min(e,h);F=Math.max(e,h);p.isXAxis?(k={x:B?F:v,y:0,width:t,height:x},n||(k.x=b.plotHeight-k.x)):(k={x:0,y:B?F:v,width:x,height:t},n&&(k.y=b.plotWidth-k.y));B&&d.isVML&&(k=p.isXAxis?{x:0,y:m?v:F,height:k.width,width:b.chartWidth}:{x:k.y-b.plotLeft-b.spacingBox.x,y:0,width:k.height,height:b.chartHeight});g[f]?g[f].animate(k):(g[f]=
d.clipRect(k),l&&a["zone-graph-"+f].clip(g[f]),u&&a["zone-area-"+f].clip(g[f]));z=c.value>w.max}),this.clips=g)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d;c.xAxis&&(d=E(c.chart,"resize",b),E(c,"destroy",d),b(a),c.invertGroups=b)},plotGroup:function(a,b,d,f,e){var c=this[a],g=!c;g&&(this[a]=c=this.chart.renderer.g(b).attr({zIndex:f||.1}).add(e),c.addClass("highcharts-series-"+this.index+
" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+" "+(this.options.className||"")));c.attr({visibility:d})[g?"attr":"animate"](this.getPlotBox());return c},getPlotBox:function(){var a=this.chart,b=this.xAxis,d=this.yAxis;a.inverted&&(b=d,d=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,f,e=a.options,g=!!a.animate&&b.renderer.isSVG&&D(e.animation).duration,h=a.visible?"inherit":"hidden",k=
e.zIndex,l=a.hasRendered,u=b.seriesGroup,x=b.inverted;f=a.plotGroup("group","series",h,k,u);a.markerGroup=a.plotGroup("markerGroup","markers",h,k,u);g&&a.animate(!0);f.inverted=a.isCartesian?x:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(x);!1===e.clip||a.sharedClipKey||l||f.clip(b.clipRect);g&&a.animate();l||(a.animationTimeout=d(function(){a.afterAnimate()},
g));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,f=this.xAxis,e=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:r(f&&f.left,a.plotLeft),translateY:r(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdDimensions:1,kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?
c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(d,c,f){var h,e;if(e=d&&d.length)return h=b.kdAxisArray[c%f],d.sort(function(a,b){return a[h]-b[h]}),e=Math.floor(e/2),{point:d[e],left:a(d.slice(0,e),c+1,f),right:a(d.slice(e+1),c+1,f)}}this.buildingKdTree=!0;var b=this,f=b.kdDimensions;delete b.kdTree;d(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),f,f);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,
b){function d(a,b,g,k){var l=b.point,u=c.kdAxisArray[g%k],x,y,A=l;y=t(a[f])&&t(l[f])?Math.pow(a[f]-l[f],2):null;x=t(a[h])&&t(l[h])?Math.pow(a[h]-l[h],2):null;x=(y||0)+(x||0);l.dist=t(x)?Math.sqrt(x):Number.MAX_VALUE;l.distX=t(y)?Math.sqrt(y):Number.MAX_VALUE;u=a[u]-l[u];x=0>u?"left":"right";y=0>u?"right":"left";b[x]&&(x=d(a,b[x],g+1,k),A=x[e]<A[e]?x:l);b[y]&&Math.sqrt(u*u)<A[e]&&(a=d(a,b[y],g+1,k),A=a[e]<A[e]?a:A);return A}var c=this,f=this.kdAxisArray[0],h=this.kdAxisArray[1],e=b?"distX":"dist";
this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return d(a,this.kdTree,this.kdDimensions,this.kdDimensions)}})})(K);(function(a){function E(a,e,b,p,w){var k=a.chart.inverted;this.axis=a;this.isNegative=b;this.options=e;this.x=p;this.total=null;this.points={};this.stack=w;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(k?b?"left":"right":"center"),verticalAlign:e.verticalAlign||(k?"middle":b?"bottom":"top"),y:t(e.y,k?4:b?14:-6),x:t(e.x,k?b?-6:6:0)};this.textAlign=
e.textAlign||(k?b?"right":"left":"center")}var D=a.Axis,H=a.Chart,I=a.correctFloat,v=a.defined,n=a.destroyObjectProperties,m=a.each,z=a.format,t=a.pick;a=a.Series;E.prototype={destroy:function(){n(this,this.axis)},render:function(a){var e=this.options,b=e.format,b=b?z(b,this):e.formatter.call(this);this.label?this.label.attr({text:b,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(b,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a)},
setOffset:function(a,e){var b=this.axis,p=b.chart,w=p.inverted,k=b.reversed,k=this.isNegative&&!k||!this.isNegative&&k,l=b.translate(b.usePercentage?100:this.total,0,0,0,1),b=b.translate(0),b=Math.abs(l-b);a=p.xAxis[0].translate(this.x)+a;var g=p.plotHeight,w={x:w?k?l:l-b:a,y:w?g-a-e:k?g-l-b:g-l,width:w?b:e,height:w?e:b};if(e=this.label)e.align(this.alignOptions,null,w),w=e.alignAttr,e[!1===this.options.crop||p.isInsidePlot(w.x,w.y)?"show":"hide"](!0)}};H.prototype.getStacks=function(){var a=this;
m(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});m(a.series,function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+t(e.options.stack,""))})};D.prototype.buildStacks=function(){var a=this.series,e,b=t(this.options.reversedStacks,!0),p=a.length,w;if(!this.isXAxis){this.usePercentage=!1;for(w=p;w--;)a[b?w:p-w-1].setStackedPoints();for(w=p;w--;)e=a[b?w:p-w-1],e.setStackCliffs&&e.setStackCliffs();if(this.usePercentage)for(w=
0;w<p;w++)a[w].setPercentStacks()}};D.prototype.renderStackTotals=function(){var a=this.chart,e=a.renderer,b=this.stacks,p,w,k=this.stackTotalGroup;k||(this.stackTotalGroup=k=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());k.translate(a.plotLeft,a.plotTop);for(p in b)for(w in a=b[p],a)a[w].render(k)};D.prototype.resetStacks=function(){var a=this.stacks,e,b;if(!this.isXAxis)for(e in a)for(b in a[e])a[e][b].touched<this.stacksTouched?(a[e][b].destroy(),delete a[e][b]):(a[e][b].total=
null,a[e][b].cum=null)};D.prototype.cleanStacks=function(){var a,e,b;if(!this.isXAxis)for(e in this.oldStacks&&(a=this.stacks=this.oldStacks),a)for(b in a[e])a[e][b].cum=a[e][b].total};a.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var a=this.processedXData,e=this.processedYData,b=[],p=e.length,w=this.options,k=w.threshold,l=w.startFromThreshold?k:0,g=w.stack,w=w.stacking,m=this.stackKey,r="-"+m,u=this.negStacks,
f=this.yAxis,B=f.stacks,d=f.oldStacks,x,c,y,n,A,J,h;f.stacksTouched+=1;for(A=0;A<p;A++)J=a[A],h=e[A],x=this.getStackIndicator(x,J,this.index),n=x.key,y=(c=u&&h<(l?0:k))?r:m,B[y]||(B[y]={}),B[y][J]||(d[y]&&d[y][J]?(B[y][J]=d[y][J],B[y][J].total=null):B[y][J]=new E(f,f.options.stackLabels,c,J,g)),y=B[y][J],null!==h&&(y.points[n]=y.points[this.index]=[t(y.cum,l)],v(y.cum)||(y.base=n),y.touched=f.stacksTouched,0<x.index&&!1===this.singleStacks&&(y.points[n][0]=y.points[this.index+","+J+",0"][0])),"percent"===
w?(c=c?m:r,u&&B[c]&&B[c][J]?(c=B[c][J],y.total=c.total=Math.max(c.total,y.total)+Math.abs(h)||0):y.total=I(y.total+(Math.abs(h)||0))):y.total=I(y.total+(h||0)),y.cum=t(y.cum,l)+(h||0),null!==h&&(y.points[n].push(y.cum),b[A]=y.cum);"percent"===w&&(f.usePercentage=!0);this.stackedYData=b;f.oldStacks={}}};a.prototype.setPercentStacks=function(){var a=this,e=a.stackKey,b=a.yAxis.stacks,p=a.processedXData,w;m([e,"-"+e],function(e){for(var k=p.length,g,m;k--;)if(g=p[k],w=a.getStackIndicator(w,g,a.index,
e),g=(m=b[e]&&b[e][g])&&m.points[w.key])m=m.total?100/m.total:0,g[0]=I(g[0]*m),g[1]=I(g[1]*m),a.stackedYData[k]=g[1]})};a.prototype.getStackIndicator=function(a,e,b,p){!v(a)||a.x!==e||p&&a.key!==p?a={x:e,index:0,key:p}:a.index++;a.key=[b,e,a.index].join();return a}})(K);(function(a){var E=a.addEvent,D=a.animate,H=a.Axis,I=a.createElement,v=a.css,n=a.defined,m=a.each,z=a.erase,t=a.extend,q=a.fireEvent,e=a.inArray,b=a.isNumber,p=a.isObject,w=a.merge,k=a.pick,l=a.Point,g=a.Series,F=a.seriesTypes,r=a.setAnimation,
u=a.splat;t(a.Chart.prototype,{addSeries:function(a,b,d){var f,c=this;a&&(b=k(b,!0),q(c,"addSeries",{options:a},function(){f=c.initSeries(a);c.isDirtyLegend=!0;c.linkSeries();b&&c.redraw(d)}));return f},addAxis:function(a,b,d,e){var c=b?"xAxis":"yAxis",f=this.options;a=w(a,{index:this[c].length,isX:b});new H(this,a);f[c]=u(f[c]||{});f[c].push(a);k(d,!0)&&this.redraw(e)},showLoading:function(a){var b=this,d=b.options,f=b.loadingDiv,c=d.loading,e=function(){f&&v(f,{left:b.plotLeft+"px",top:b.plotTop+
"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};f||(b.loadingDiv=f=I("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=I("span",{className:"highcharts-loading-inner"},null,f),E(b,"redraw",e));f.className="highcharts-loading";b.loadingSpan.innerHTML=a||d.lang.loading;v(f,t(c.style,{zIndex:10}));v(b.loadingSpan,c.labelStyle);b.loadingShown||(v(f,{opacity:0,display:""}),D(f,{opacity:c.style.opacity||.5},{duration:c.showDuration||0}));b.loadingShown=
!0;e()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",D(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){v(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions".split(" "),update:function(a,g){var d,f={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},c=a.chart,l,r;if(c){w(!0,this.options.chart,c);"className"in c&&this.setClassName(c.className);if("inverted"in c||"polar"in c)this.propFromSeries(),l=!0;for(d in c)c.hasOwnProperty(d)&&(-1!==e("chart."+d,this.propsRequireUpdateSeries)&&(r=!0),-1!==e(d,this.propsRequireDirtyBox)&&(this.isDirtyBox=
!0));"style"in c&&this.renderer.setStyle(c.style)}for(d in a){if(this[d]&&"function"===typeof this[d].update)this[d].update(a[d],!1);else if("function"===typeof this[f[d]])this[f[d]](a[d]);"chart"!==d&&-1!==e(d,this.propsRequireUpdateSeries)&&(r=!0)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&w(!0,this.options.plotOptions,a.plotOptions);m(["xAxis","yAxis","series"],function(b){a[b]&&m(u(a[b]),function(a,d){(d=n(a.id)&&this.get(a.id)||this[b][d])&&d.coll===b&&d.update(a,!1)},this)},this);
l&&m(this.axes,function(a){a.update({},!1)});r&&m(this.series,function(a){a.update({},!1)});a.loading&&w(!0,this.options.loading,a.loading);d=c&&c.width;c=c&&c.height;b(d)&&d!==this.chartWidth||b(c)&&c!==this.chartHeight?this.setSize(d,c):k(g,!0)&&this.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});t(l.prototype,{update:function(a,b,d,e){function c(){f.applyOptions(a);null===f.y&&l&&(f.graphic=l.destroy());p(a,!0)&&(l&&l.element&&a&&a.marker&&a.marker.symbol&&(f.graphic=l.destroy()),
a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));u=f.index;g.updateParallelArrays(f,u);x.data[u]=p(x.data[u],!0)?f.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(h.isDirtyBox=!0);"point"===x.legendType&&(h.isDirtyLegend=!0);b&&h.redraw(d)}var f=this,g=f.series,l=f.graphic,u,h=g.chart,x=g.options;b=k(b,!0);!1===e?c():f.firePointEvent("update",{options:a},c)},remove:function(a,b){this.series.removePoint(e(this,this.series.data),a,b)}});t(g.prototype,{addPoint:function(a,
b,d,e){var c=this.options,f=this.data,g=this.chart,l=this.xAxis,l=l&&l.hasNames&&l.names,u=c.data,h,x,r=this.xData,p,m;b=k(b,!0);h={series:this};this.pointClass.prototype.applyOptions.apply(h,[a]);m=h.x;p=r.length;if(this.requireSorting&&m<r[p-1])for(x=!0;p&&r[p-1]>m;)p--;this.updateParallelArrays(h,"splice",p,0,0);this.updateParallelArrays(h,p);l&&h.name&&(l[m]=h.name);u.splice(p,0,a);x&&(this.data.splice(p,0,null),this.processData());"point"===c.legendType&&this.generatePoints();d&&(f[0]&&f[0].remove?
f[0].remove(!1):(f.shift(),this.updateParallelArrays(h,"shift"),u.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(e)},removePoint:function(a,b,d){var f=this,c=f.data,e=c[a],g=f.points,l=f.chart,u=function(){g&&g.length===c.length&&g.splice(a,1);c.splice(a,1);f.options.data.splice(a,1);f.updateParallelArrays(e||{series:f},"splice",a,1);e&&e.destroy();f.isDirty=!0;f.isDirtyData=!0;b&&l.redraw()};r(d,l);b=k(b,!0);e?e.firePointEvent("remove",null,u):u()},remove:function(a,b,d){function f(){c.destroy();
e.isDirtyLegend=e.isDirtyBox=!0;e.linkSeries();k(a,!0)&&e.redraw(b)}var c=this,e=c.chart;!1!==d?q(c,"remove",null,f):f()},update:function(a,b){var d=this,f=this.chart,c=this.userOptions,e=this.type,g=a.type||c.type||f.options.chart.type,l=F[e].prototype,u=["group","markerGroup","dataLabelsGroup"],h;if(g&&g!==e||void 0!==a.zIndex)u.length=0;m(u,function(a){u[a]=d[a];delete d[a]});a=w(c,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1,null,!1);for(h in l)this[h]=
void 0;t(this,F[g||e].prototype);m(u,function(a){d[a]=u[a]});this.init(f,a);f.linkSeries();k(b,!0)&&f.redraw(!1)}});t(H.prototype,{update:function(a,b){var d=this.chart;a=d.options[this.coll][this.options.index]=w(this.userOptions,a);this.destroy(!0);this.init(d,t(a,{events:void 0}));d.isDirtyBox=!0;k(b,!0)&&d.redraw()},remove:function(a){for(var b=this.chart,d=this.coll,f=this.series,c=f.length;c--;)f[c]&&f[c].remove(!1);z(b.axes,this);z(b[d],this);b.options[d].splice(this.options.index,1);m(b[d],
function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;k(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var E=a.color,D=a.each,H=a.map,I=a.pick,v=a.Series,n=a.seriesType;n("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(){var a=[],n=[],t=this.xAxis,q=this.yAxis,e=q.stacks[this.stackKey],b={},p=this.points,w=this.index,k=q.series,l=k.length,g,v=I(q.options.reversedStacks,
!0)?1:-1,r,u;if(this.options.stacking){for(r=0;r<p.length;r++)b[p[r].x]=p[r];for(u in e)null!==e[u].total&&n.push(u);n.sort(function(a,b){return a-b});g=H(k,function(){return this.visible});D(n,function(f,k){var d=0,u,c;if(b[f]&&!b[f].isNull)a.push(b[f]),D([-1,1],function(a){var d=1===a?"rightNull":"leftNull",x=0,p=e[n[k+a]];if(p)for(r=w;0<=r&&r<l;)u=p.points[r],u||(r===w?b[f][d]=!0:g[r]&&(c=e[f].points[r])&&(x-=c[1]-c[0])),r+=v;b[f][1===a?"rightCliff":"leftCliff"]=x});else{for(r=w;0<=r&&r<l;){if(u=
e[f].points[r]){d=u[1];break}r+=v}d=q.toPixels(d,!0);a.push({isNull:!0,plotX:t.toPixels(f,!0),plotY:d,yBottom:d})}})}return a},getGraphPath:function(a){var m=v.prototype.getGraphPath,n=this.options,q=n.stacking,e=this.yAxis,b,p,w=[],k=[],l=this.index,g,F=e.stacks[this.stackKey],r=n.threshold,u=e.getThreshold(n.threshold),f,n=n.connectNulls||"percent"===q,B=function(b,f,c){var d=a[b];b=q&&F[d.x].points[l];var p=d[c+"Null"]||0;c=d[c+"Cliff"]||0;var x,m,d=!0;c||p?(x=(p?b[0]:b[1])+c,m=b[0]+c,d=!!p):!q&&
a[f]&&a[f].isNull&&(x=m=r);void 0!==x&&(k.push({plotX:g,plotY:null===x?u:e.getThreshold(x),isNull:d}),w.push({plotX:g,plotY:null===m?u:e.getThreshold(m),doCurve:!1}))};a=a||this.points;q&&(a=this.getStackPoints());for(b=0;b<a.length;b++)if(p=a[b].isNull,g=I(a[b].rectPlotX,a[b].plotX),f=I(a[b].yBottom,u),!p||n)n||B(b,b-1,"left"),p&&!q&&n||(k.push(a[b]),w.push({x:b,plotX:g,plotY:f})),n||B(b,b+1,"right");b=m.call(this,k,!0,!0);w.reversed=!0;p=m.call(this,w,!0,!0);p.length&&(p[0]="L");p=b.concat(p);m=
m.call(this,k,!1,n);p.xMap=b.xMap;this.areaPath=p;return m},drawGraph:function(){this.areaPath=[];v.prototype.drawGraph.apply(this);var a=this,n=this.areaPath,t=this.options,q=[["area","highcharts-area",this.color,t.fillColor]];D(this.zones,function(e,b){q.push(["zone-area-"+b,"highcharts-area highcharts-zone-area-"+b+" "+e.className,e.color||a.color,e.fillColor||t.fillColor])});D(q,function(e){var b=e[0],p=a[b];p?(p.endX=n.xMap,p.animate({d:n})):(p=a[b]=a.chart.renderer.path(n).addClass(e[1]).attr({fill:I(e[3],
E(e[2]).setOpacity(I(t.fillOpacity,.75)).get()),zIndex:0}).add(a.group),p.isArea=!0);p.startX=n.xMap;p.shiftUnit=t.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var E=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,H,I){var v=H.plotX,n=H.plotY,m=a[I-1];I=a[I+1];var z,t,q,e;if(m&&!m.isNull&&!1!==m.doCurve&&I&&!I.isNull&&!1!==I.doCurve){a=m.plotY;q=I.plotX;I=I.plotY;var b=0;z=(1.5*v+m.plotX)/2.5;t=(1.5*n+a)/2.5;q=(1.5*v+q)/2.5;e=(1.5*n+I)/2.5;
q!==z&&(b=(e-t)*(q-v)/(q-z)+n-e);t+=b;e+=b;t>a&&t>n?(t=Math.max(a,n),e=2*n-t):t<a&&t<n&&(t=Math.min(a,n),e=2*n-t);e>I&&e>n?(e=Math.max(I,n),t=2*n-e):e<I&&e<n&&(e=Math.min(I,n),t=2*n-e);H.rightContX=q;H.rightContY=e}H=["C",E(m.rightContX,m.plotX),E(m.rightContY,m.plotY),E(z,v),E(t,n),v,n];m.rightContX=m.rightContY=null;return H}})})(K);(function(a){var E=a.seriesTypes.area.prototype,D=a.seriesType;D("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:E.getStackPoints,getGraphPath:E.getGraphPath,
setStackCliffs:E.setStackCliffs,drawGraph:E.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var E=a.animObject,D=a.color,H=a.each,I=a.extend,v=a.isNumber,n=a.merge,m=a.pick,z=a.Series,t=a.seriesType,q=a.svg;t("column","line",{borderRadius:0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,
y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){z.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)})},getColumnMetrics:function(){var a=this,b=a.options,p=a.xAxis,w=a.yAxis,k=p.reversed,l,g={},n=0;!1===b.grouping?n=1:H(a.chart.series,function(b){var d=
b.options,f=b.yAxis,c;b.type===a.type&&b.visible&&w.len===f.len&&w.pos===f.pos&&(d.stacking?(l=b.stackKey,void 0===g[l]&&(g[l]=n++),c=g[l]):!1!==d.grouping&&(c=n++),b.columnIndex=c)});var r=Math.min(Math.abs(p.transA)*(p.ordinalSlope||b.pointRange||p.closestPointRange||p.tickInterval||1),p.len),u=r*b.groupPadding,f=(r-2*u)/(n||1),b=Math.min(b.maxPointWidth||p.len,m(b.pointWidth,f*(1-2*b.pointPadding)));a.columnMetrics={width:b,offset:(f-b)/2+(u+((a.columnIndex||0)+(k?1:0))*f-r/2)*(k?-1:1)};return a.columnMetrics},
crispCol:function(a,b,p,m){var e=this.chart,l=this.borderWidth,g=-(l%2?.5:0),l=l%2?.5:1;e.inverted&&e.renderer.isVML&&(l+=1);p=Math.round(a+p)+g;a=Math.round(a)+g;m=Math.round(b+m)+l;g=.5>=Math.abs(b)&&.5<m;b=Math.round(b)+l;m-=b;g&&m&&(--b,m+=1);return{x:a,y:b,width:p-a,height:m}},translate:function(){var a=this,b=a.chart,p=a.options,w=a.dense=2>a.closestPointRange*a.xAxis.transA,w=a.borderWidth=m(p.borderWidth,w?0:1),k=a.yAxis,l=a.translatedThreshold=k.getThreshold(p.threshold),g=m(p.minPointLength,
5),n=a.getColumnMetrics(),r=n.width,u=a.barW=Math.max(r,1+2*w),f=a.pointXOffset=n.offset;b.inverted&&(l-=.5);p.pointPadding&&(u=Math.ceil(u));z.prototype.translate.apply(a);H(a.points,function(e){var d=m(e.yBottom,l),x=999+Math.abs(d),x=Math.min(Math.max(-x,e.plotY),k.len+x),c=e.plotX+f,p=u,w=Math.min(x,d),A,n=Math.max(x,d)-w;Math.abs(n)<g&&g&&(n=g,A=!k.reversed&&!e.negative||k.reversed&&e.negative,w=Math.abs(w-l)>g?d-g:l-(A?g:0));e.barX=c;e.pointWidth=r;e.tooltipPos=b.inverted?[k.len+k.pos-b.plotLeft-
x,a.xAxis.len-c-p/2,n]:[c+p/2,x+k.pos-b.plotTop,n];e.shapeType="rect";e.shapeArgs=a.crispCol.apply(a,e.isNull?[e.plotX,k.len/2,0,0]:[c,w,p,n])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,b){var e=this.options,m,k=this.pointAttrToOptions||{};m=k.stroke||"borderColor";var l=k["stroke-width"]||"borderWidth",g=a&&a.color||this.color,n=a[m]||e[m]||this.color||
g,r=a[l]||e[l]||this[l]||0,k=e.dashStyle;a&&this.zones.length&&(g=(g=a.getZone())&&g.color||a.options.color||this.color);b&&(a=e.states[b],b=a.brightness,g=a.color||void 0!==b&&D(g).brighten(a.brightness).get()||g,n=a[m]||n,r=a[l]||r,k=a.dashStyle||k);m={fill:g,stroke:n,"stroke-width":r};e.borderRadius&&(m.r=e.borderRadius);k&&(m.dashstyle=k);return m},drawPoints:function(){var a=this,b=this.chart,p=a.options,m=b.renderer,k=p.animationLimit||250,l;H(a.points,function(e){var g=e.graphic;if(v(e.plotY)&&
null!==e.y){l=e.shapeArgs;if(g)g[b.pointCount<k?"animate":"attr"](n(l));else e.graphic=g=m[e.shapeType](l).attr({"class":e.getClassName()}).add(e.group||a.group);g.attr(a.pointAttribs(e,e.selected&&"select")).shadow(p.shadow,null,p.stacking&&!p.borderRadius)}else g&&(e.graphic=g.destroy())})},animate:function(a){var b=this,e=this.yAxis,m=b.options,k=this.chart.inverted,l={};q&&(a?(l.scaleY=.001,a=Math.min(e.pos+e.len,Math.max(e.pos,e.toPixels(m.threshold))),k?l.translateX=a-e.len:l.translateY=a,b.group.attr(l)):
(l[k?"translateX":"translateY"]=e.pos,b.group.animate(l,I(E(b.options.animation),{step:function(a,e){b.group.attr({scaleY:Math.max(.001,e.pos)})}})),b.animate=null))},remove:function(){var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)});z.prototype.remove.apply(a,arguments)}})})(K);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var E=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,kdDimensions:2,drawGraph:function(){this.options.lineWidth&&E.prototype.drawGraph.call(this)}})})(K);(function(a){var E=a.pick,D=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,I=this.chart,v=2*(a.slicedOffset||0),n=I.plotWidth-2*v,I=I.plotHeight-
2*v,m=a.center,m=[E(m[0],"50%"),E(m[1],"50%"),a.size||"100%",a.innerSize||0],z=Math.min(n,I),t,q;for(t=0;4>t;++t)q=m[t],a=2>t||2===t&&/%$/.test(q),m[t]=D(q,[n,I,z,m[2]][t])+(a?v:0);m[3]>m[2]&&(m[3]=m[2]);return m}}})(K);(function(a){var E=a.addEvent,D=a.defined,H=a.each,I=a.extend,v=a.inArray,n=a.noop,m=a.pick,z=a.Point,t=a.Series,q=a.seriesType,e=a.setAnimation;q("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return null===this.y?
void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var b=this,e=b.points,k=b.startAngleRad;a||(H(e,function(a){var e=
a.graphic,l=a.shapeArgs;e&&(e.attr({r:a.startR||b.center[3]/2,start:k,end:k}),e.animate({r:l.r,start:l.start,end:l.end},b.options.animation))}),b.animate=null)},updateTotals:function(){var a,e=0,m=this.points,k=m.length,l,g=this.options.ignoreHiddenPoint;for(a=0;a<k;a++)l=m[a],0>l.y&&(l.y=null),e+=g&&!l.visible?0:l.y;this.total=e;for(a=0;a<k;a++)l=m[a],l.percentage=0<e&&(l.visible||!g)?l.y/e*100:0,l.total=e},generatePoints:function(){t.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();
var b=0,e=this.options,k=e.slicedOffset,l=k+(e.borderWidth||0),g,n,r,u=e.startAngle||0,f=this.startAngleRad=Math.PI/180*(u-90),u=(this.endAngleRad=Math.PI/180*(m(e.endAngle,u+360)-90))-f,q=this.points,d=e.dataLabels.distance,e=e.ignoreHiddenPoint,x,c=q.length,y;a||(this.center=a=this.getCenter());this.getX=function(b,c){r=Math.asin(Math.min((b-a[1])/(a[2]/2+d),1));return a[0]+(c?-1:1)*Math.cos(r)*(a[2]/2+d)};for(x=0;x<c;x++){y=q[x];g=f+b*u;if(!e||y.visible)b+=y.percentage/100;n=f+b*u;y.shapeType=
"arc";y.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*g)/1E3,end:Math.round(1E3*n)/1E3};r=(n+g)/2;r>1.5*Math.PI?r-=2*Math.PI:r<-Math.PI/2&&(r+=2*Math.PI);y.slicedTranslation={translateX:Math.round(Math.cos(r)*k),translateY:Math.round(Math.sin(r)*k)};g=Math.cos(r)*a[2]/2;n=Math.sin(r)*a[2]/2;y.tooltipPos=[a[0]+.7*g,a[1]+.7*n];y.half=r<-Math.PI/2||r>Math.PI/2?1:0;y.angle=r;l=Math.min(l,d/5);y.labelPos=[a[0]+g+Math.cos(r)*d,a[1]+n+Math.sin(r)*d,a[0]+g+Math.cos(r)*l,a[1]+n+Math.sin(r)*
l,a[0]+g,a[1]+n,0>d?"center":y.half?"right":"left",r]}},drawGraph:null,drawPoints:function(){var a=this,e=a.chart.renderer,m,k,l,g,n=a.options.shadow;n&&!a.shadowGroup&&(a.shadowGroup=e.g("shadow").add(a.group));H(a.points,function(b){if(null!==b.y){k=b.graphic;g=b.shapeArgs;m=b.sliced?b.slicedTranslation:{};var u=b.shadowGroup;n&&!u&&(u=b.shadowGroup=e.g("shadow").add(a.shadowGroup));u&&u.attr(m);l=a.pointAttribs(b,b.selected&&"select");k?k.setRadialReference(a.center).attr(l).animate(I(g,m)):(b.graphic=
k=e[b.shapeType](g).addClass(b.getClassName()).setRadialReference(a.center).attr(m).add(a.group),b.visible||k.attr({visibility:"hidden"}),k.attr(l).attr({"stroke-linejoin":"round"}).shadow(n,u))}})},searchPoint:n,sortByAngle:function(a,e){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*e})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:n},{init:function(){z.prototype.init.apply(this,arguments);var a=this,e;a.name=m(a.name,"Slice");
e=function(b){a.slice("select"===b.type)};E(a,"select",e);E(a,"unselect",e);return a},setVisible:function(a,e){var b=this,k=b.series,l=k.chart,g=k.options.ignoreHiddenPoint;e=m(e,g);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,k.options.data[v(b,k.data)]=b.options,H(["graphic","dataLabel","connector","shadowGroup"],function(e){if(b[e])b[e][a?"show":"hide"](!0)}),b.legendItem&&l.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),g&&(k.isDirty=!0),e&&l.redraw())},
slice:function(a,p,n){var b=this.series;e(n,b.chart);m(p,!0);this.sliced=this.options.sliced=a=D(a)?a:!this.sliced;b.options.data[v(this,b.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}})})(K);(function(a){var E=
a.addEvent,D=a.arrayMax,H=a.defined,I=a.each,v=a.extend,n=a.format,m=a.map,z=a.merge,t=a.noop,q=a.pick,e=a.relativeLength,b=a.Series,p=a.seriesTypes,w=a.stableSort;a.distribute=function(a,b){function e(a,b){return a.target-b.target}var k,l=!0,u=a,f=[],p;p=0;for(k=a.length;k--;)p+=a[k].size;if(p>b){w(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(p=k=0;p<=b;)p+=a[k].size,k++;f=a.splice(k-1,a.length)}w(a,e);for(a=m(a,function(a){return{size:a.size,targets:[a.target]}});l;){for(k=a.length;k--;)l=
a[k],p=(Math.min.apply(0,l.targets)+Math.max.apply(0,l.targets))/2,l.pos=Math.min(Math.max(0,p-l.size/2),b-l.size);k=a.length;for(l=!1;k--;)0<k&&a[k-1].pos+a[k-1].size>a[k].pos&&(a[k-1].size+=a[k].size,a[k-1].targets=a[k-1].targets.concat(a[k].targets),a[k-1].pos+a[k-1].size>b&&(a[k-1].pos=b-a[k-1].size),a.splice(k,1),l=!0)}k=0;I(a,function(a){var b=0;I(a.targets,function(){u[k].pos=a.pos+b;b+=u[k].size;k++})});u.push.apply(u,f);w(u,e)};b.prototype.drawDataLabels=function(){var a=this,b=a.options,
e=b.dataLabels,p=a.points,r,u,f=a.hasRendered||0,m,d,x=q(e.defer,!0),c=a.chart.renderer;if(e.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(e),d=a.plotGroup("dataLabelsGroup","data-labels",x&&!f?"hidden":"visible",e.zIndex||6),x&&(d.attr({opacity:+f}),f||E(a,"afterAnimate",function(){a.visible&&d.show(!0);d[b.animation?"animate":"attr"]({opacity:1},{duration:200})})),u=e,I(p,function(f){var g,k=f.dataLabel,l,h,x,p=f.connector,y=!k,w;r=f.dlOptions||f.options&&f.options.dataLabels;
if(g=q(r&&r.enabled,u.enabled)&&null!==f.y)for(h in e=z(u,r),l=f.getLabelConfig(),m=e.format?n(e.format,l):e.formatter.call(l,e),w=e.style,x=e.rotation,w.color=q(e.color,w.color,a.color,"#000000"),"contrast"===w.color&&(w.color=e.inside||0>e.distance||b.stacking?c.getContrast(f.color||a.color):"#000000"),b.cursor&&(w.cursor=b.cursor),l={fill:e.backgroundColor,stroke:e.borderColor,"stroke-width":e.borderWidth,r:e.borderRadius||0,rotation:x,padding:e.padding,zIndex:1},l)void 0===l[h]&&delete l[h];!k||
g&&H(m)?g&&H(m)&&(k?l.text=m:(k=f.dataLabel=c[x?"text":"label"](m,0,-9999,e.shape,null,null,e.useHTML,null,"data-label"),k.addClass("highcharts-data-label-color-"+f.colorIndex+" "+(e.className||"")+(e.useHTML?"highcharts-tracker":""))),k.attr(l),k.css(w).shadow(e.shadow),k.added||k.add(d),a.alignDataLabel(f,k,e,null,y)):(f.dataLabel=k.destroy(),p&&(f.connector=p.destroy()))})};b.prototype.alignDataLabel=function(a,b,e,p,r){var g=this.chart,f=g.inverted,k=q(a.plotX,-9999),d=q(a.plotY,-9999),l=b.getBBox(),
c,y=e.rotation,m=e.align,A=this.visible&&(a.series.forceDL||g.isInsidePlot(k,Math.round(d),f)||p&&g.isInsidePlot(k,f?p.x+1:p.y+p.height-1,f)),n="justify"===q(e.overflow,"justify");A&&(c=e.style.fontSize,c=g.renderer.fontMetrics(c,b).b,p=v({x:f?g.plotWidth-d:k,y:Math.round(f?g.plotHeight-k:d),width:0,height:0},p),v(e,{width:l.width,height:l.height}),y?(n=!1,f=g.renderer.rotCorr(c,y),f={x:p.x+e.x+p.width/2+f.x,y:p.y+e.y+{top:0,middle:.5,bottom:1}[e.verticalAlign]*p.height},b[r?"attr":"animate"](f).attr({align:m}),
k=(y+720)%360,k=180<k&&360>k,"left"===m?f.y-=k?l.height:0:"center"===m?(f.x-=l.width/2,f.y-=l.height/2):"right"===m&&(f.x-=l.width,f.y-=k?0:l.height)):(b.align(e,null,p),f=b.alignAttr),n?this.justifyDataLabel(b,e,f,l,p,r):q(e.crop,!0)&&(A=g.isInsidePlot(f.x,f.y)&&g.isInsidePlot(f.x+l.width,f.y+l.height)),e.shape&&!y&&b.attr({anchorX:a.plotX,anchorY:a.plotY}));A||(b.attr({y:-9999}),b.placed=!1)};b.prototype.justifyDataLabel=function(a,b,e,p,r,u){var f=this.chart,g=b.align,d=b.verticalAlign,k,c,l=a.box?
0:a.padding||0;k=e.x+l;0>k&&("right"===g?b.align="left":b.x=-k,c=!0);k=e.x+p.width-l;k>f.plotWidth&&("left"===g?b.align="right":b.x=f.plotWidth-k,c=!0);k=e.y+l;0>k&&("bottom"===d?b.verticalAlign="top":b.y=-k,c=!0);k=e.y+p.height-l;k>f.plotHeight&&("top"===d?b.verticalAlign="bottom":b.y=f.plotHeight-k,c=!0);c&&(a.placed=!u,a.align(b,null,r))};p.pie&&(p.pie.prototype.drawDataLabels=function(){var e=this,l=e.data,g,p=e.chart,r=e.options.dataLabels,u=q(r.connectorPadding,10),f=q(r.connectorWidth,1),n=
p.plotWidth,d=p.plotHeight,x,c=r.distance,y=e.center,w=y[2]/2,A=y[1],t=0<c,h,v,z,E,N=[[],[]],H,C,M,R,O=[0,0,0,0];e.visible&&(r.enabled||e._hasPointLabels)&&(b.prototype.drawDataLabels.apply(e),I(l,function(a){a.dataLabel&&a.visible&&(N[a.half].push(a),a.dataLabel._pos=null)}),I(N,function(b,f){var k,l,x=b.length,q,t,B;if(x)for(e.sortByAngle(b,f-.5),0<c&&(k=Math.max(0,A-w-c),l=Math.min(A+w+c,p.plotHeight),q=m(b,function(a){if(a.dataLabel)return B=a.dataLabel.getBBox().height||21,{target:a.labelPos[1]-
k+B/2,size:B,rank:a.y}}),a.distribute(q,l+B-k)),R=0;R<x;R++)g=b[R],z=g.labelPos,h=g.dataLabel,M=!1===g.visible?"hidden":"inherit",t=z[1],q?void 0===q[R].pos?M="hidden":(E=q[R].size,C=k+q[R].pos):C=t,H=r.justify?y[0]+(f?-1:1)*(w+c):e.getX(C<k+2||C>l-2?t:C,f),h._attr={visibility:M,align:z[6]},h._pos={x:H+r.x+({left:u,right:-u}[z[6]]||0),y:C+r.y-10},z.x=H,z.y=C,null===e.options.size&&(v=h.width,H-v<u?O[3]=Math.max(Math.round(v-H+u),O[3]):H+v>n-u&&(O[1]=Math.max(Math.round(H+v-n+u),O[1])),0>C-E/2?O[0]=
Math.max(Math.round(-C+E/2),O[0]):C+E/2>d&&(O[2]=Math.max(Math.round(C+E/2-d),O[2])))}),0===D(O)||this.verifyDataLabelOverflow(O))&&(this.placeDataLabels(),t&&f&&I(this.points,function(a){var b;x=a.connector;if((h=a.dataLabel)&&h._pos&&a.visible){M=h._attr.visibility;if(b=!x)a.connector=x=p.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(e.dataLabelsGroup),x.attr({"stroke-width":f,stroke:r.connectorColor||a.color||"#666666"});x[b?"attr":"animate"]({d:e.connectorPath(a.labelPos)});
x.attr("visibility",M)}else x&&(a.connector=x.destroy())}))},p.pie.prototype.connectorPath=function(a){var b=a.x,e=a.y;return q(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),e,"C",b,e,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),e,"L",a[2],a[3],"L",a[4],a[5]]},p.pie.prototype.placeDataLabels=function(){I(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))})},
p.pie.prototype.alignDataLabel=t,p.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,g=this.options,k=g.center,r=g.minSize||80,u,f;null!==k[0]?u=Math.max(b[2]-Math.max(a[1],a[3]),r):(u=Math.max(b[2]-a[1]-a[3],r),b[0]+=(a[3]-a[1])/2);null!==k[1]?u=Math.max(Math.min(u,b[2]-Math.max(a[0],a[2])),r):(u=Math.max(Math.min(u,b[2]-a[0]-a[2]),r),b[1]+=(a[0]-a[2])/2);u<b[2]?(b[2]=u,b[3]=Math.min(e(g.innerSize||0,u),u),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):f=!0;return f});
p.column&&(p.column.prototype.alignDataLabel=function(a,e,g,p,r){var k=this.chart.inverted,f=a.series,l=a.dlBox||a.shapeArgs,d=q(a.below,a.plotY>q(this.translatedThreshold,f.yAxis.len)),x=q(g.inside,!!this.options.stacking);l&&(p=z(l),0>p.y&&(p.height+=p.y,p.y=0),l=p.y+p.height-f.yAxis.len,0<l&&(p.height-=l),k&&(p={x:f.yAxis.len-p.y-p.height,y:f.xAxis.len-p.x-p.width,width:p.height,height:p.width}),x||(k?(p.x+=d?0:p.width,p.width=0):(p.y+=d?p.height:0,p.height=0)));g.align=q(g.align,!k||x?"center":
d?"right":"left");g.verticalAlign=q(g.verticalAlign,k||x?"middle":d?"top":"bottom");b.prototype.alignDataLabel.call(this,a,e,g,p,r)})})(K);(function(a){var E=a.Chart,D=a.each,H=a.pick,I=a.addEvent;E.prototype.callbacks.push(function(a){function n(){var m=[];D(a.series,function(a){var n=a.options.dataLabels,q=a.dataLabelCollections||["dataLabel"];(n.enabled||a._hasPointLabels)&&!n.allowOverlap&&a.visible&&D(q,function(e){D(a.points,function(a){a[e]&&(a[e].labelrank=H(a.labelrank,a.shapeArgs&&a.shapeArgs.height),
m.push(a[e]))})})});a.hideOverlappingLabels(m)}n();I(a,"redraw",n)});E.prototype.hideOverlappingLabels=function(a){var n=a.length,m,v,t,q,e,b,p,w,k,l=function(a,b,e,k,f,l,d,p){return!(f>a+e||f+d<a||l>b+k||l+p<b)};for(v=0;v<n;v++)if(m=a[v])m.oldOpacity=m.opacity,m.newOpacity=1;a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(v=0;v<n;v++)for(t=a[v],m=v+1;m<n;++m)if(q=a[m],t&&q&&t.placed&&q.placed&&0!==t.newOpacity&&0!==q.newOpacity&&(e=t.alignAttr,b=q.alignAttr,p=t.parentGroup,w=q.parentGroup,
k=2*(t.box?0:t.padding),e=l(e.x+p.translateX,e.y+p.translateY,t.width-k,t.height-k,b.x+w.translateX,b.y+w.translateY,q.width-k,q.height-k)))(t.labelrank<q.labelrank?t:q).newOpacity=0;D(a,function(a){var b,e;a&&(e=a.newOpacity,a.oldOpacity!==e&&a.placed&&(e?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=e,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(K);(function(a){var E=a.addEvent,D=a.Chart,H=a.createElement,I=a.css,v=a.defaultOptions,n=a.defaultPlotOptions,m=a.each,z=
a.extend,t=a.fireEvent,q=a.hasTouch,e=a.inArray,b=a.isObject,p=a.Legend,w=a.merge,k=a.pick,l=a.Point,g=a.Series,F=a.seriesTypes,r=a.svg;a=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,e=b.pointer,d=function(a){for(var d=a.target,f;d&&!f;)f=d.point,d=d.parentNode;if(void 0!==f&&f!==b.hoverPoint)f.onMouseOver(a)};m(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(m(a.trackerGroups,
function(b){if(a[b]){a[b].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){e.onTrackerMouseOut(a)});if(q)a[b].on("touchstart",d);a.options.cursor&&a[b].css(I).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,e=b.trackByArea,d=[].concat(e?a.areaPath:a.graphPath),g=d.length,c=a.chart,k=c.pointer,l=c.renderer,p=c.options.tooltip.snap,n=a.tracker,h,w=function(){if(c.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+
(r?.0001:.002)+")";if(g&&!e)for(h=g+1;h--;)"M"===d[h]&&d.splice(h+1,0,d[h+1]-p,d[h+2],"L"),(h&&"M"===d[h]||h===g)&&d.splice(h,0,"L",d[h-2]+p,d[h-1]);n?n.attr({d:d}):a.graph&&(a.tracker=l.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,fill:e?t:"none","stroke-width":a.graph.strokeWidth()+(e?0:2*p),zIndex:2}).add(a.group),m([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",w).on("mouseout",function(a){k.onTrackerMouseOut(a)});
b.cursor&&a.css({cursor:b.cursor});if(q)a.on("touchstart",w)}))}};F.column&&(F.column.prototype.drawTracker=a.drawTrackerPoint);F.pie&&(F.pie.prototype.drawTracker=a.drawTrackerPoint);F.scatter&&(F.scatter.prototype.drawTracker=a.drawTrackerPoint);z(p.prototype,{setItemEvents:function(a,b,e){var d=this,f=d.chart,c="highcharts-legend-"+(a.series?"point":"series")+"-active";(e?b:a.legendGroup).on("mouseover",function(){a.setState("hover");f.seriesGroup.addClass(c);b.css(d.options.itemHoverStyle)}).on("mouseout",
function(){b.css(a.visible?d.itemStyle:d.itemHiddenStyle);f.seriesGroup.removeClass(c);a.setState()}).on("click",function(b){var d=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,d):t(a,"legendItemClick",b,d)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);E(a.checkbox,"click",function(b){t(a.series||a,"checkboxClick",
{checked:b.target.checked,item:a},function(){a.select()})})}});v.legend.itemStyle.cursor="pointer";z(D.prototype,{showResetZoom:function(){var a=this,b=v.lang,e=a.options.chart.resetZoomButton,d=e.theme,g=d.states,c="chart"===e.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,g&&g.hover).attr({align:e.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(e.position,!1,c)},zoomOut:function(){var a=this;
t(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var f,e=this.pointer,d=!1,g;!a||a.resetSelection?m(this.axes,function(a){f=a.zoom()}):m(a.xAxis.concat(a.yAxis),function(a){var b=a.axis;e[b.isXAxis?"zoomX":"zoomY"]&&(f=b.zoom(a.min,a.max),b.displayBtn&&(d=!0))});g=this.resetZoomButton;d&&!g?this.showResetZoom():!d&&b(g)&&(this.resetZoomButton=g.destroy());f&&this.redraw(k(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var f=this,d=f.hoverPoints,
e;d&&m(d,function(a){a.setState()});m("xy"===b?[1,0]:[1],function(b){b=f[b?"xAxis":"yAxis"][0];var d=b.horiz,c=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=f[d],k=(b.pointRange||0)/2,h=b.getExtremes(),l=b.toValue(g-c,!0)+k,k=b.toValue(g+b.len-c,!0)-k,p=k<l,g=p?k:l,l=p?l:k,k=Math.min(h.dataMin,h.min)-g,h=l-Math.max(h.dataMax,h.max);b.series.length&&0>k&&0>h&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),e=!0);f[d]=c});e&&f.redraw(!1);I(f.container,{cursor:"move"})}});z(l.prototype,{select:function(a,
b){var f=this,d=f.series,g=d.chart;a=k(a,!f.selected);f.firePointEvent(a?"select":"unselect",{accumulate:b},function(){f.selected=f.options.selected=a;d.options.data[e(f,d.data)]=f.options;f.setState(a&&"select");b||m(g.getSelectedPoints(),function(a){a.selected&&a!==f&&(a.selected=a.options.selected=!1,d.options.data[e(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a,b){var f=this.series,d=f.chart,e=d.tooltip,c=d.hoverPoint;if(this.series){if(!b){if(c&&
c!==this)c.onMouseOut();if(d.hoverSeries!==f)f.onMouseOver();d.hoverPoint=this}!e||e.shared&&!f.noSharedTooltip?e||this.setState("hover"):(this.setState("hover"),e.refresh(this,a));this.firePointEvent("mouseOver")}},onMouseOut:function(){var a=this.series.chart,b=a.hoverPoints;this.firePointEvent("mouseOut");b&&-1!==e(this,b)||(this.setState(),a.hoverPoint=null)},importEvents:function(){if(!this.hasImportedEvents){var a=w(this.series.options.point,this.options).events,b;this.events=a;for(b in a)E(this,
b,a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var f=Math.floor(this.plotX),d=this.plotY,e=this.series,c=e.options.states[a]||{},g=n[e.type].marker&&e.options.marker,l=g&&!1===g.enabled,p=g&&g.states&&g.states[a]||{},r=!1===p.enabled,h=e.stateMarkerGraphic,u=this.marker||{},m=e.chart,q=e.halo,w,t=g&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===c.enabled||a&&(r||l&&!1===p.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){t&&(w=e.markerAttribs(this,
a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.attr(e.pointAttribs(this,a)),w&&this.graphic.animate(w,k(m.options.chart.animation,p.animation,g.animation)),h&&h.hide();else{if(a&&p){g=u.symbol||e.symbol;h&&h.currentSymbol!==g&&(h=h.destroy());if(h)h[b?"animate":"attr"]({x:w.x,y:w.y});else g&&(e.stateMarkerGraphic=h=m.renderer.symbol(g,w.x,w.y,w.width,w.height).add(e.markerGroup),h.currentSymbol=
g);h&&h.attr(e.pointAttribs(this,a))}h&&(h[a&&m.isInsidePlot(f,d,m.inverted)?"show":"hide"](),h.element.point=this)}(f=c.halo)&&f.size?(q||(e.halo=q=m.renderer.path().add(t?e.markerGroup:e.group)),q[b?"animate":"attr"]({d:this.haloPath(f.size)}),q.attr({"class":"highcharts-halo highcharts-color-"+k(this.colorIndex,e.colorIndex)}),q.point=this,q.attr(z({fill:this.color||e.color,"fill-opacity":f.opacity,zIndex:-1},f.attributes))):q&&q.point&&q.point.haloPath&&q.animate({d:q.point.haloPath(0)});this.state=
a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});z(g.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&t(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,e=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&t(this,"mouseOut");!e||a.stickyTracking||
e.shared&&!this.noSharedTooltip||e.hide();this.setState()},setState:function(a){var b=this,e=b.options,d=b.graph,g=e.states,c=e.lineWidth,e=0;a=a||"";if(b.state!==a&&(m([b.group,b.markerGroup],function(d){d&&(b.state&&d.removeClass("highcharts-series-"+b.state),a&&d.addClass("highcharts-series-"+a))}),b.state=a,!g[a]||!1!==g[a].enabled)&&(a&&(c=g[a].lineWidth||c+(g[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":c},d.attr(g);b["zone-graph-"+e];)b["zone-graph-"+e].attr(g),e+=1},setVisible:function(a,
b){var f=this,d=f.chart,e=f.legendItem,c,g=d.options.chart.ignoreHiddenSeries,k=f.visible;c=(f.visible=a=f.options.visible=f.userOptions.visible=void 0===a?!k:a)?"show":"hide";m(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(f[a])f[a][c]()});if(d.hoverSeries===f||(d.hoverPoint&&d.hoverPoint.series)===f)f.onMouseOut();e&&d.legend.colorizeItem(f,a);f.isDirty=!0;f.options.stacking&&m(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});m(f.linkedSeries,function(b){b.setVisible(a,
!1)});g&&(d.isDirtyBox=!0);!1!==b&&d.redraw();t(f,c)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);t(this,a?"select":"unselect")},drawTracker:a.drawTrackerGraph})})(K);(function(a){var E=a.Chart,D=a.each,H=a.inArray,I=a.isObject,v=a.pick,n=a.splat;E.prototype.setResponsive=function(a){var m=this.options.responsive;m&&m.rules&&D(m.rules,function(m){this.matchResponsiveRule(m,
a)},this)};E.prototype.matchResponsiveRule=function(m,n){var t=this.respRules,q=m.condition,e;e=q.callback||function(){return this.chartWidth<=v(q.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=v(q.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=v(q.minWidth,0)&&this.chartHeight>=v(q.minHeight,0)};void 0===m._id&&(m._id=a.uniqueKey());e=e.call(this);!t[m._id]&&e?m.chartOptions&&(t[m._id]=this.currentOptions(m.chartOptions),this.update(m.chartOptions,n)):t[m._id]&&!e&&(this.update(t[m._id],n),delete t[m._id])};
E.prototype.currentOptions=function(a){function m(a,e,b,p){var w,k;for(w in a)if(!p&&-1<H(w,["series","xAxis","yAxis"]))for(a[w]=n(a[w]),b[w]=[],k=0;k<a[w].length;k++)b[w][k]={},m(a[w][k],e[w][k],b[w][k],p+1);else I(a[w])?(b[w]={},m(a[w],e[w]||{},b[w],p+1)):b[w]=e[w]||null}var t={};m(a,this.options,t,0);return t}})(K);(function(a){var E=a.addEvent,D=a.Axis,H=a.Chart,I=a.css,v=a.dateFormat,n=a.defined,m=a.each,z=a.extend,t=a.noop,q=a.Series,e=a.timeUnits;a=a.wrap;a(q.prototype,"init",function(a){var b;
a.apply(this,Array.prototype.slice.call(arguments,1));(b=this.xAxis)&&b.options.ordinal&&E(this,"updatedData",function(){delete b.ordinalIndex})});a(D.prototype,"getTimeTicks",function(a,p,m,k,l,g,q,r){var b=0,f,w,d={},x,c,y,t=[],A=-Number.MAX_VALUE,J=this.options.tickPixelInterval;if(!this.options.ordinal&&!this.options.breaks||!g||3>g.length||void 0===m)return a.call(this,p,m,k,l);c=g.length;for(f=0;f<c;f++){y=f&&g[f-1]>k;g[f]<m&&(b=f);if(f===c-1||g[f+1]-g[f]>5*q||y){if(g[f]>A){for(w=a.call(this,
p,g[b],g[f],l);w.length&&w[0]<=A;)w.shift();w.length&&(A=w[w.length-1]);t=t.concat(w)}b=f+1}if(y)break}a=w.info;if(r&&a.unitRange<=e.hour){f=t.length-1;for(b=1;b<f;b++)v("%d",t[b])!==v("%d",t[b-1])&&(d[t[b]]="day",x=!0);x&&(d[t[0]]="day");a.higherRanks=d}t.info=a;if(r&&n(J)){r=a=t.length;f=[];var h;for(x=[];r--;)b=this.translate(t[r]),h&&(x[r]=h-b),f[r]=h=b;x.sort();x=x[Math.floor(x.length/2)];x<.6*J&&(x=null);r=t[a-1]>k?a-1:a;for(h=void 0;r--;)b=f[r],k=Math.abs(h-b),h&&k<.8*J&&(null===x||k<.8*x)?
(d[t[r]]&&!d[t[r+1]]?(k=r+1,h=b):k=r,t.splice(k,1)):h=b}return t});z(D.prototype,{beforeSetTickPositions:function(){var a,e=[],n=!1,k,l=this.getExtremes(),g=l.min,q=l.max,r,u=this.isXAxis&&!!this.options.breaks,l=this.options.ordinal,f=this.chart.options.chart.ignoreHiddenSeries;if(l||u){m(this.series,function(b,d){if(!(f&&!1===b.visible||!1===b.takeOrdinalPosition&&!u)&&(e=e.concat(b.processedXData),a=e.length,e.sort(function(a,b){return a-b}),a))for(d=a-1;d--;)e[d]===e[d+1]&&e.splice(d,1)});a=e.length;
if(2<a){k=e[1]-e[0];for(r=a-1;r--&&!n;)e[r+1]-e[r]!==k&&(n=!0);!this.options.keepOrdinalPadding&&(e[0]-g>k||q-e[e.length-1]>k)&&(n=!0)}n?(this.ordinalPositions=e,k=this.ordinal2lin(Math.max(g,e[0]),!0),r=Math.max(this.ordinal2lin(Math.min(q,e[e.length-1]),!0),1),this.ordinalSlope=q=(q-g)/(r-k),this.ordinalOffset=g-k*q):this.ordinalPositions=this.ordinalSlope=this.ordinalOffset=void 0}this.isOrdinal=l&&n;this.groupIntervalFactor=null},val2lin:function(a,e){var b=this.ordinalPositions;if(b){var k=b.length,
l,g;for(l=k;l--;)if(b[l]===a){g=l;break}for(l=k-1;l--;)if(a>b[l]||0===l){a=(a-b[l])/(b[l+1]-b[l]);g=l+a;break}e=e?g:this.ordinalSlope*(g||0)+this.ordinalOffset}else e=a;return e},lin2val:function(a,e){var b=this.ordinalPositions;if(b){var k=this.ordinalSlope,l=this.ordinalOffset,g=b.length-1,p;if(e)0>a?a=b[0]:a>g?a=b[g]:(g=Math.floor(a),p=a-g);else for(;g--;)if(e=k*g+l,a>=e){k=k*(g+1)+l;p=(a-e)/(k-e);break}return void 0!==p&&void 0!==b[g]?b[g]+(p?p*(b[g+1]-b[g]):0):a}return a},getExtendedPositions:function(){var a=
this.chart,e=this.series[0].currentDataGrouping,n=this.ordinalIndex,k=e?e.count+e.unitName:"raw",l=this.getExtremes(),g,q;n||(n=this.ordinalIndex={});n[k]||(g={series:[],chart:a,getExtremes:function(){return{min:l.dataMin,max:l.dataMax}},options:{ordinal:!0},val2lin:D.prototype.val2lin},m(this.series,function(b){q={xAxis:g,xData:b.xData,chart:a,destroyGroupedData:t};q.options={dataGrouping:e?{enabled:!0,forced:!0,approximation:"open",units:[[e.unitName,[e.count]]]}:{enabled:!1}};b.processData.apply(q);
g.series.push(q)}),this.beforeSetTickPositions.apply(g),n[k]=g.ordinalPositions);return n[k]},getGroupIntervalFactor:function(a,e,m){var b;m=m.processedXData;var l=m.length,g=[];b=this.groupIntervalFactor;if(!b){for(b=0;b<l-1;b++)g[b]=m[b+1]-m[b];g.sort(function(a,b){return a-b});g=g[Math.floor(l/2)];a=Math.max(a,m[0]);e=Math.min(e,m[l-1]);this.groupIntervalFactor=b=l*g/(e-a)}return b},postProcessTickInterval:function(a){var b=this.ordinalSlope;return b?this.options.breaks?this.closestPointRange:
a/(b/this.closestPointRange):a}});D.prototype.ordinal2lin=D.prototype.val2lin;a(H.prototype,"pan",function(a,e){var b=this.xAxis[0],k=e.chartX,l=!1;if(b.options.ordinal&&b.series.length){var g=this.mouseDownX,p=b.getExtremes(),r=p.dataMax,n=p.min,f=p.max,q=this.hoverPoints,d=b.closestPointRange,g=(g-k)/(b.translationSlope*(b.ordinalSlope||d)),x={ordinalPositions:b.getExtendedPositions()},d=b.lin2val,c=b.val2lin,y;x.ordinalPositions?1<Math.abs(g)&&(q&&m(q,function(a){a.setState()}),0>g?(q=x,y=b.ordinalPositions?
b:x):(q=b.ordinalPositions?b:x,y=x),x=y.ordinalPositions,r>x[x.length-1]&&x.push(r),this.fixedRange=f-n,g=b.toFixedRange(null,null,d.apply(q,[c.apply(q,[n,!0])+g,!0]),d.apply(y,[c.apply(y,[f,!0])+g,!0])),g.min>=Math.min(p.dataMin,n)&&g.max<=Math.max(r,f)&&b.setExtremes(g.min,g.max,!0,!1,{trigger:"pan"}),this.mouseDownX=k,I(this.container,{cursor:"move"})):l=!0}else l=!0;l&&a.apply(this,Array.prototype.slice.call(arguments,1))});q.prototype.gappedPath=function(){var a=this.options.gapSize,e=this.points.slice(),
m=e.length-1;if(a&&0<m)for(;m--;)e[m+1].x-e[m].x>this.closestPointRange*a&&e.splice(m+1,0,{isNull:!0});return this.getGraphPath(e)}})(K);(function(a){function E(){return Array.prototype.slice.call(arguments,1)}function D(a){a.apply(this);this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,H(this.pointArrayMap,["y"]))}var H=a.pick,I=a.wrap,v=a.each,n=a.extend,m=a.isArray,z=a.fireEvent,t=a.Axis,q=a.Series;n(t.prototype,{isInBreak:function(a,b){var e=a.repeat||Infinity,m=a.from,k=a.to-a.from;
b=b>=m?(b-m)%e:e-(m-b)%e;return a.inclusive?b<=k:b<k&&0!==b},isInAnyBreak:function(a,b){var e=this.options.breaks,m=e&&e.length,k,l,g;if(m){for(;m--;)this.isInBreak(e[m],a)&&(k=!0,l||(l=H(e[m].showPoints,this.isXAxis?!1:!0)));g=k&&b?k&&!l:k}return g}});I(t.prototype,"setTickPositions",function(a){a.apply(this,Array.prototype.slice.call(arguments,1));if(this.options.breaks){var b=this.tickPositions,e=this.tickPositions.info,m=[],k;for(k=0;k<b.length;k++)this.isInAnyBreak(b[k])||m.push(b[k]);this.tickPositions=
m;this.tickPositions.info=e}});I(t.prototype,"init",function(a,b,p){var e=this;p.breaks&&p.breaks.length&&(p.ordinal=!1);a.call(this,b,p);a=this.options.breaks;e.isBroken=m(a)&&!!a.length;e.isBroken&&(e.val2lin=function(a){var b=a,g,k;for(k=0;k<e.breakArray.length;k++)if(g=e.breakArray[k],g.to<=a)b-=g.len;else if(g.from>=a)break;else if(e.isInBreak(g,a)){b-=a-g.from;break}return b},e.lin2val=function(a){var b,g;for(g=0;g<e.breakArray.length&&!(b=e.breakArray[g],b.from>=a);g++)b.to<a?a+=b.len:e.isInBreak(b,
a)&&(a+=b.len);return a},e.setExtremes=function(a,b,e,m,r){for(;this.isInAnyBreak(a);)a-=this.closestPointRange;for(;this.isInAnyBreak(b);)b-=this.closestPointRange;t.prototype.setExtremes.call(this,a,b,e,m,r)},e.setAxisTranslation=function(a){t.prototype.setAxisTranslation.call(this,a);var b=e.options.breaks;a=[];var g=[],k=0,m,p,f=e.userMin||e.min,n=e.userMax||e.max,d,x;for(x in b)p=b[x],m=p.repeat||Infinity,e.isInBreak(p,f)&&(f+=p.to%m-f%m),e.isInBreak(p,n)&&(n-=n%m-p.from%m);for(x in b){p=b[x];
d=p.from;for(m=p.repeat||Infinity;d-m>f;)d-=m;for(;d<f;)d+=m;for(;d<n;d+=m)a.push({value:d,move:"in"}),a.push({value:d+(p.to-p.from),move:"out",size:p.breakSize})}a.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-b.value});b=0;d=f;for(x in a)p=a[x],b+="in"===p.move?1:-1,1===b&&"in"===p.move&&(d=p.value),0===b&&(g.push({from:d,to:p.value,len:p.value-d-(p.size||0)}),k+=p.value-d-(p.size||0));e.breakArray=g;z(e,"afterBreaks");e.transA*=(n-e.min)/(n-f-k);e.min=
f;e.max=n})});I(q.prototype,"generatePoints",function(a){a.apply(this,E(arguments));var b=this.xAxis,e=this.yAxis,m=this.points,k,l=m.length,g=this.options.connectNulls,n;if(b&&e&&(b.options.breaks||e.options.breaks))for(;l--;)k=m[l],n=null===k.y&&!1===g,n||!b.isInAnyBreak(k.x,!0)&&!e.isInAnyBreak(k.y,!0)||(m.splice(l,1),this.data[l]&&this.data[l].destroyElements())});a.Series.prototype.drawBreaks=function(a,b){var e=this,m=e.points,k,l,g,n;a&&v(b,function(b){k=a.breakArray||[];l=a.isXAxis?a.min:
H(e.options.threshold,a.min);v(m,function(e){n=H(e["stack"+b.toUpperCase()],e[b]);v(k,function(b){g=!1;if(l<b.from&&n>b.to||l>b.from&&n<b.from)g="pointBreak";else if(l<b.from&&n>b.from&&n<b.to||l>b.from&&n>b.to&&n<b.from)g="pointInBreak";g&&z(a,g,{point:e,brk:b})})})})};I(a.seriesTypes.column.prototype,"drawPoints",D);I(a.Series.prototype,"drawPoints",D)})(K);(function(a){var E=a.arrayMax,D=a.arrayMin,H=a.Axis,I=a.defaultPlotOptions,v=a.defined,n=a.each,m=a.extend,z=a.format,t=a.isNumber,q=a.merge,
e=a.pick,b=a.Point,p=a.Tooltip,w=a.wrap,k=a.Series.prototype,l=k.processData,g=k.generatePoints,F=k.destroy,r={approximation:"average",groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L","%A, %b %e, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y",
"%A, %b %e","-%A, %b %e, %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},u={line:{},spline:{},area:{},areaspline:{},column:{approximation:"sum",groupPixelWidth:10},arearange:{approximation:"range"},areasplinerange:{approximation:"range"},columnrange:{approximation:"range",groupPixelWidth:10},candlestick:{approximation:"ohlc",groupPixelWidth:10},ohlc:{approximation:"ohlc",groupPixelWidth:5}},f=a.defaultDataGroupingUnits=[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,
10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]],B={sum:function(a){var b=a.length,d;if(!b&&a.hasNulls)d=null;else if(b)for(d=0;b--;)d+=a[b];return d},average:function(a){var b=a.length;a=B.sum(a);t(a)&&b&&(a/=b);return a},open:function(a){return a.length?a[0]:a.hasNulls?null:void 0},high:function(a){return a.length?E(a):a.hasNulls?null:void 0},low:function(a){return a.length?D(a):a.hasNulls?null:void 0},close:function(a){return a.length?
a[a.length-1]:a.hasNulls?null:void 0},ohlc:function(a,b,c,e){a=B.open(a);b=B.high(b);c=B.low(c);e=B.close(e);if(t(a)||t(b)||t(c)||t(e))return[a,b,c,e]},range:function(a,b){a=B.low(a);b=B.high(b);if(t(a)||t(b))return[a,b]}};k.groupData=function(a,b,c,e){var d=this.data,f=this.options.data,g=[],h=[],k=[],l=a.length,m,p,n=!!b,r=[[],[],[],[]];e="function"===typeof e?e:B[e];var q=this.pointArrayMap,y=q&&q.length,u,x=0;for(u=p=0;u<=l&&!(a[u]>=c[0]);u++);for(u;u<=l;u++){for(;(void 0!==c[x+1]&&a[u]>=c[x+
1]||u===l)&&(m=c[x],this.dataGroupInfo={start:p,length:r[0].length},p=e.apply(this,r),void 0!==p&&(g.push(m),h.push(p),k.push(this.dataGroupInfo)),p=u,r[0]=[],r[1]=[],r[2]=[],r[3]=[],x+=1,u!==l););if(u===l)break;if(q){m=this.cropStart+u;m=d&&d[m]||this.pointClass.prototype.applyOptions.apply({series:this},[f[m]]);var w,v;for(w=0;w<y;w++)v=m[q[w]],t(v)?r[w].push(v):null===v&&(r[w].hasNulls=!0)}else m=n?b[u]:null,t(m)?r[0].push(m):null===m&&(r[0].hasNulls=!0)}return[g,h,k]};k.processData=function(){var a=
this.chart,b=this.options.dataGrouping,c=!1!==this.allowDG&&b&&e(b.enabled,a.options.isStock),g=this.visible||!a.options.chart.ignoreHiddenSeries,m;this.forceCrop=c;this.groupPixelWidth=null;this.hasProcessed=!0;if(!1!==l.apply(this,arguments)&&c&&g){this.destroyGroupedData();var p=this.processedXData,r=this.processedYData,h=a.plotSizeX,a=this.xAxis,n=a.options.ordinal,u=this.groupPixelWidth=a.getGroupPixelWidth&&a.getGroupPixelWidth();if(u){this.isDirty=m=!0;g=a.getExtremes();c=g.min;g=g.max;n=n&&
a.getGroupIntervalFactor(c,g,this)||1;h=u*(g-c)/h*n;u=a.getTimeTicks(a.normalizeTimeTickInterval(h,b.units||f),Math.min(c,p[0]),Math.max(g,p[p.length-1]),a.options.startOfWeek,p,this.closestPointRange);p=k.groupData.apply(this,[p,r,u,b.approximation]);r=p[0];n=p[1];if(b.smoothed){b=r.length-1;for(r[b]=Math.min(r[b],g);b--&&0<b;)r[b]+=h/2;r[0]=Math.max(r[0],c)}this.currentDataGrouping=u.info;this.closestPointRange=u.info.totalRange;this.groupMap=p[2];v(r[0])&&r[0]<a.dataMin&&(a.min===a.dataMin&&(a.min=
r[0]),a.dataMin=r[0]);this.processedXData=r;this.processedYData=n}else this.currentDataGrouping=this.groupMap=null;this.hasGroupedData=m}};k.destroyGroupedData=function(){var a=this.groupedData;n(a||[],function(b,d){b&&(a[d]=b.destroy?b.destroy():null)});this.groupedData=null};k.generatePoints=function(){g.apply(this);this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null};w(b.prototype,"update",function(b){this.dataGroup?a.error(24):b.apply(this,[].slice.call(arguments,1))});
w(p.prototype,"tooltipFooterHeaderFormatter",function(b,e,c){var d=e.series,f=d.tooltipOptions,g=d.options.dataGrouping,k=f.xDateFormat,h,l=d.xAxis,p=a.dateFormat;return l&&"datetime"===l.options.type&&g&&t(e.key)?(b=d.currentDataGrouping,g=g.dateTimeLabelFormats,b?(l=g[b.unitName],1===b.count?k=l[0]:(k=l[1],h=l[2])):!k&&g&&(k=this.getXDateFormat(e,f,l)),k=p(k,e.key),h&&(k+=p(h,e.key+b.totalRange-1)),z(f[(c?"footer":"header")+"Format"],{point:m(e.point,{key:k}),series:d})):b.call(this,e,c)});k.destroy=
function(){for(var a=this.groupedData||[],b=a.length;b--;)a[b]&&a[b].destroy();F.apply(this)};w(k,"setOptions",function(a,b){a=a.call(this,b);var d=this.type,e=this.chart.options.plotOptions,f=I[d].dataGrouping;u[d]&&(f||(f=q(r,u[d])),a.dataGrouping=q(f,e.series&&e.series.dataGrouping,e[d].dataGrouping,b.dataGrouping));this.chart.options.isStock&&(this.requireSorting=!0);return a});w(H.prototype,"setScale",function(a){a.call(this);n(this.series,function(a){a.hasProcessed=!1})});H.prototype.getGroupPixelWidth=
function(){var a=this.series,b=a.length,c,e=0,f=!1,g;for(c=b;c--;)(g=a[c].options.dataGrouping)&&(e=Math.max(e,g.groupPixelWidth));for(c=b;c--;)(g=a[c].options.dataGrouping)&&a[c].hasProcessed&&(b=(a[c].processedXData||a[c].data).length,a[c].groupPixelWidth||b>this.chart.plotSizeX/e||b&&g.forced)&&(f=!0);return f?e:0};H.prototype.setDataGrouping=function(a,b){var c;b=e(b,!0);a||(a={forced:!1,units:null});if(this instanceof H)for(c=this.series.length;c--;)this.series[c].update({dataGrouping:a},!1);
else n(this.chart.options.series,function(b){b.dataGrouping=a},!1);b&&this.chart.redraw()}})(K);(function(a){var E=a.each,D=a.Point,H=a.seriesType,I=a.seriesTypes;H("ohlc","column",{lineWidth:1,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eOpen: {point.open}\x3cbr/\x3eHigh: {point.high}\x3cbr/\x3eLow: {point.low}\x3cbr/\x3eClose: {point.close}\x3cbr/\x3e'},threshold:null,states:{hover:{lineWidth:3}}},{pointArrayMap:["open",
"high","low","close"],toYData:function(a){return[a.open,a.high,a.low,a.close]},pointValKey:"high",pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},pointAttribs:function(a,n){n=I.column.prototype.pointAttribs.call(this,a,n);var m=this.options;delete n.fill;!a.options.color&&m.upColor&&a.open<a.close&&(n.stroke=m.upColor);return n},translate:function(){var a=this,n=a.yAxis,m=!!a.modifyValue,z=["plotOpen","yBottom","plotClose"];I.column.prototype.translate.apply(a);E(a.points,function(t){E([t.open,
t.low,t.close],function(q,e){null!==q&&(m&&(q=a.modifyValue(q)),t[z[e]]=n.toPixels(q,!0))})})},drawPoints:function(){var a=this,n=a.chart;E(a.points,function(m){var v,t,q,e,b=m.graphic,p,w=!b;void 0!==m.plotY&&(b||(m.graphic=b=n.renderer.path().add(a.group)),b.attr(a.pointAttribs(m,m.selected&&"select")),t=b.strokeWidth()%2/2,p=Math.round(m.plotX)-t,q=Math.round(m.shapeArgs.width/2),e=["M",p,Math.round(m.yBottom),"L",p,Math.round(m.plotY)],null!==m.open&&(v=Math.round(m.plotOpen)+t,e.push("M",p,v,
"L",p-q,v)),null!==m.close&&(v=Math.round(m.plotClose)+t,e.push("M",p,v,"L",p+q,v)),b[w?"attr":"animate"]({d:e}).addClass(m.getClassName(),!0))})},animate:null},{getClassName:function(){return D.prototype.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}})})(K);(function(a){var E=a.defaultPlotOptions,D=a.each,H=a.merge,I=a.seriesType,v=a.seriesTypes;I("candlestick","ohlc",H(E.column,{states:{hover:{lineWidth:2}},tooltip:E.ohlc.tooltip,threshold:null,lineColor:"#000000",
lineWidth:1,upColor:"#ffffff"}),{pointAttribs:function(a,m){var n=v.column.prototype.pointAttribs.call(this,a,m),t=this.options,q=a.open<a.close,e=t.lineColor||this.color;n["stroke-width"]=t.lineWidth;n.fill=a.options.color||(q?t.upColor||this.color:this.color);n.stroke=a.lineColor||(q?t.upLineColor||e:e);m&&(a=t.states[m],n.fill=a.color||n.fill,n.stroke=a.lineColor||n.stroke,n["stroke-width"]=a.lineWidth||n["stroke-width"]);return n},drawPoints:function(){var a=this,m=a.chart;D(a.points,function(n){var t=
n.graphic,q,e,b,p,w,k,l,g=!t;void 0!==n.plotY&&(t||(n.graphic=t=m.renderer.path().add(a.group)),t.attr(a.pointAttribs(n,n.selected&&"select")).shadow(a.options.shadow),w=t.strokeWidth()%2/2,k=Math.round(n.plotX)-w,q=n.plotOpen,e=n.plotClose,b=Math.min(q,e),q=Math.max(q,e),l=Math.round(n.shapeArgs.width/2),e=Math.round(b)!==Math.round(n.plotY),p=q!==n.yBottom,b=Math.round(b)+w,q=Math.round(q)+w,w=[],w.push("M",k-l,q,"L",k-l,b,"L",k+l,b,"L",k+l,q,"Z","M",k,b,"L",k,e?Math.round(n.plotY):b,"M",k,q,"L",
k,p?Math.round(n.yBottom):q),t[g?"attr":"animate"]({d:w}).addClass(n.getClassName(),!0))})}})})(K);(function(a){var E=a.addEvent,D=a.each,H=a.merge,I=a.noop,v=a.Renderer,n=a.seriesType,m=a.seriesTypes,z=a.TrackerMixin,t=a.VMLRenderer,q=a.SVGRenderer.prototype.symbols;n("flags","column",{pointRange:0,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}\x3cbr/\x3e"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},
style:{fontSize:"11px",fontWeight:"bold"}},{sorted:!1,noSharedTooltip:!0,allowDG:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],forceCrop:!0,init:a.Series.prototype.init,pointAttribs:function(a,b){var e=this.options,m=a&&a.color||this.color,k=e.lineColor,l=a&&a.lineWidth;a=a&&a.fillColor||e.fillColor;b&&(a=e.states[b].fillColor,k=e.states[b].lineColor,l=e.states[b].lineWidth);return{fill:a||m,stroke:k||m,"stroke-width":l||e.lineWidth||0}},translate:function(){m.column.prototype.translate.apply(this);
var a=this.options,b=this.chart,p=this.points,n=p.length-1,k,l,g=a.onSeries;k=g&&b.get(g);var a=a.onKey||"y",g=k&&k.options.step,q=k&&k.points,r=q&&q.length,u=this.xAxis,f=u.getExtremes(),t=0,d,x,c;if(k&&k.visible&&r)for(t=(k.pointXOffset||0)+(k.barW||0)/2,k=k.currentDataGrouping,x=q[r-1].x+(k?k.totalRange:0),p.sort(function(a,b){return a.x-b.x}),a="plot"+a[0].toUpperCase()+a.substr(1);r--&&p[n]&&!(k=p[n],d=q[r],d.x<=k.x&&void 0!==d[a]&&(k.x<=x&&(k.plotY=d[a],d.x<k.x&&!g&&(c=q[r+1])&&void 0!==c[a]&&
(k.plotY+=(k.x-d.x)/(c.x-d.x)*(c[a]-d[a]))),n--,r++,0>n)););D(p,function(a,c){var d;void 0===a.plotY&&(a.x>=f.min&&a.x<=f.max?a.plotY=b.chartHeight-u.bottom-(u.opposite?u.height:0)+u.offset-b.plotTop:a.shapeArgs={});a.plotX+=t;(l=p[c-1])&&l.plotX===a.plotX&&(void 0===l.stackIndex&&(l.stackIndex=0),d=l.stackIndex+1);a.stackIndex=d})},drawPoints:function(){var a=this.points,b=this.chart,m=b.renderer,n,k,l=this.options,g=l.y,q,r,u,f,t,d,x,c=this.yAxis;for(r=a.length;r--;)u=a[r],x=u.plotX>this.xAxis.len,
n=u.plotX,f=u.stackIndex,q=u.options.shape||l.shape,k=u.plotY,void 0!==k&&(k=u.plotY+g-(void 0!==f&&f*l.stackDistance)),t=f?void 0:u.plotX,d=f?void 0:u.plotY,f=u.graphic,void 0!==k&&0<=n&&!x?(f||(f=u.graphic=m.label("",null,null,q,null,null,l.useHTML).attr(this.pointAttribs(u)).css(H(l.style,u.style)).attr({align:"flag"===q?"left":"center",width:l.width,height:l.height,"text-align":l.textAlign}).addClass("highcharts-point").add(this.markerGroup),f.shadow(l.shadow)),0<n&&(n-=f.strokeWidth()%2),f.attr({text:u.options.title||
l.title||"A",x:n,y:k,anchorX:t,anchorY:d}),u.tooltipPos=b.inverted?[c.len+c.pos-b.plotLeft-k,this.xAxis.len-n]:[n,k]):f&&(u.graphic=f.destroy())},drawTracker:function(){var a=this.points;z.drawTrackerPoint.apply(this);D(a,function(b){var e=b.graphic;e&&E(e.element,"mouseover",function(){0<b.stackIndex&&!b.raised&&(b._y=e.y,e.attr({y:b._y-8}),b.raised=!0);D(a,function(a){a!==b&&a.raised&&a.graphic&&(a.graphic.attr({y:a._y}),a.raised=!1)})})})},animate:I,buildKDTree:I,setClip:I});q.flag=function(a,
b,m,n,k){return["M",k&&k.anchorX||a,k&&k.anchorY||b,"L",a,b+n,a,b,a+m,b,a+m,b+n,a,b+n,"Z"]};D(["circle","square"],function(a){q[a+"pin"]=function(b,e,m,k,l){var g=l&&l.anchorX;l=l&&l.anchorY;"circle"===a&&k>m&&(b-=Math.round((k-m)/2),m=k);b=q[a](b,e,m,k);g&&l&&b.push("M",g,e>l?e:e+k,"L",g,l);return b}});v===t&&D(["flag","circlepin","squarepin"],function(a){t.prototype.symbols[a]=q[a]})})(K);(function(a){function E(a,b,e){this.init(a,b,e)}var D=a.addEvent,H=a.Axis,I=a.correctFloat,v=a.defaultOptions,
n=a.defined,m=a.destroyObjectProperties,z=a.doc,t=a.each,q=a.fireEvent,e=a.hasTouch,b=a.isTouchDevice,p=a.merge,w=a.pick,k=a.removeEvent,l=a.wrap,g,F={height:b?20:14,barBorderRadius:0,buttonBorderRadius:0,liveRedraw:a.svg&&!b,margin:10,minWidth:6,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",
trackBorderWidth:1};v.scrollbar=p(!0,F,v.scrollbar);a.swapXY=g=function(a,b){var e=a.length,g;if(b)for(b=0;b<e;b+=3)g=a[b+1],a[b+1]=a[b+2],a[b+2]=g;return a};E.prototype={init:function(a,b,e){this.scrollbarButtons=[];this.renderer=a;this.userOptions=b;this.options=p(F,b);this.chart=e;this.size=w(this.options.size,this.options.height);b.enabled&&(this.render(),this.initEvents(),this.addEvents())},render:function(){var a=this.renderer,b=this.options,e=this.size,k;this.group=k=a.g("scrollbar").attr({zIndex:b.zIndex,
translateY:-99999}).add();this.track=a.rect().addClass("highcharts-scrollbar-track").attr({x:0,r:b.trackBorderRadius||0,height:e,width:e}).add(k);this.track.attr({fill:b.trackBackgroundColor,stroke:b.trackBorderColor,"stroke-width":b.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=a.g().add(k);this.scrollbar=a.rect().addClass("highcharts-scrollbar-thumb").attr({height:e,width:e,r:b.barBorderRadius||0}).add(this.scrollbarGroup);
this.scrollbarRifles=a.path(g(["M",-3,e/4,"L",-3,2*e/3,"M",0,e/4,"L",0,2*e/3,"M",3,e/4,"L",3,2*e/3],b.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);this.scrollbar.attr({fill:b.barBackgroundColor,stroke:b.barBorderColor,"stroke-width":b.barBorderWidth});this.scrollbarRifles.attr({stroke:b.rifleColor,"stroke-width":1});this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);
this.drawScrollbarButton(1)},position:function(a,b,e,g){var d=this.options.vertical,f=0,c=this.rendered?"animate":"attr";this.x=a;this.y=b+this.trackBorderWidth;this.width=e;this.xOffset=this.height=g;this.yOffset=f;d?(this.width=this.yOffset=e=f=this.size,this.xOffset=b=0,this.barWidth=g-2*e,this.x=a+=this.options.margin):(this.height=this.xOffset=g=b=this.size,this.barWidth=e-2*g,this.y+=this.options.margin);this.group[c]({translateX:a,translateY:this.y});this.track[c]({width:e,height:g});this.scrollbarButtons[1][c]({translateX:d?
0:e-b,translateY:d?g-f:0})},drawScrollbarButton:function(a){var b=this.renderer,e=this.scrollbarButtons,k=this.options,d=this.size,l;l=b.g().add(this.group);e.push(l);l=b.rect().addClass("highcharts-scrollbar-button").add(l);l.attr({stroke:k.buttonBorderColor,"stroke-width":k.buttonBorderWidth,fill:k.buttonBackgroundColor});l.attr(l.crisp({x:-.5,y:-.5,width:d+1,height:d+1,r:k.buttonBorderRadius},l.strokeWidth()));l=b.path(g(["M",d/2+(a?-1:1),d/2-3,"L",d/2+(a?-1:1),d/2+3,"L",d/2+(a?2:-2),d/2],k.vertical)).addClass("highcharts-scrollbar-arrow").add(e[a]);
l.attr({fill:k.buttonArrowColor})},setRange:function(a,b){var e=this.options,g=e.vertical,d=e.minWidth,k=this.barWidth,c,l,m=this.rendered&&!this.hasDragged?"animate":"attr";n(k)&&(a=Math.max(a,0),c=k*a,this.calculatedWidth=l=I(k*Math.min(b,1)-c),l<d&&(c=(k-d+l)*a,l=d),d=Math.floor(c+this.xOffset+this.yOffset),k=l/2-.5,this.from=a,this.to=b,g?(this.scrollbarGroup[m]({translateY:d}),this.scrollbar[m]({height:l}),this.scrollbarRifles[m]({translateY:k}),this.scrollbarTop=d,this.scrollbarLeft=0):(this.scrollbarGroup[m]({translateX:d}),
this.scrollbar[m]({width:l}),this.scrollbarRifles[m]({translateX:k}),this.scrollbarLeft=d,this.scrollbarTop=0),12>=l?this.scrollbarRifles.hide():this.scrollbarRifles.show(!0),!1===e.showFull&&(0>=a&&1<=b?this.group.hide():this.group.show()),this.rendered=!0)},initEvents:function(){var a=this;a.mouseMoveHandler=function(b){var e=a.chart.pointer.normalize(b),g=a.options.vertical?"chartY":"chartX",d=a.initPositions;!a.grabbedCenter||b.touches&&0===b.touches[0][g]||(e=a.cursorToScrollbarPosition(e)[g],
g=a[g],g=e-g,a.hasDragged=!0,a.updatePosition(d[0]+g,d[1]+g),a.hasDragged&&q(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b}))};a.mouseUpHandler=function(b){a.hasDragged&&q(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b});a.grabbedCenter=a.hasDragged=a.chartX=a.chartY=null};a.mouseDownHandler=function(b){b=a.chart.pointer.normalize(b);b=a.cursorToScrollbarPosition(b);a.chartX=b.chartX;a.chartY=b.chartY;a.initPositions=[a.from,a.to];a.grabbedCenter=
!0};a.buttonToMinClick=function(b){var e=I(a.to-a.from)*a.options.step;a.updatePosition(I(a.from-e),I(a.to-e));q(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.buttonToMaxClick=function(b){var e=(a.to-a.from)*a.options.step;a.updatePosition(a.from+e,a.to+e);q(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.trackClick=function(b){var e=a.chart.pointer.normalize(b),g=a.to-a.from,d=a.y+a.scrollbarTop,k=a.x+a.scrollbarLeft;a.options.vertical&&e.chartY>d||!a.options.vertical&&
e.chartX>k?a.updatePosition(a.from+g,a.to+g):a.updatePosition(a.from-g,a.to-g);q(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})}},cursorToScrollbarPosition:function(a){var b=this.options,b=b.minWidth>this.calculatedWidth?b.minWidth:0;return{chartX:(a.chartX-this.x-this.xOffset)/(this.barWidth-b),chartY:(a.chartY-this.y-this.yOffset)/(this.barWidth-b)}},updatePosition:function(a,b){1<b&&(a=I(1-I(b-a)),b=1);0>a&&(b=I(b-a),a=0);this.from=a;this.to=b},update:function(a){this.destroy();
this.init(this.chart.renderer,p(!0,this.options,a),this.chart)},addEvents:function(){var a=this.options.inverted?[1,0]:[0,1],b=this.scrollbarButtons,f=this.scrollbarGroup.element,g=this.mouseDownHandler,d=this.mouseMoveHandler,k=this.mouseUpHandler,a=[[b[a[0]].element,"click",this.buttonToMinClick],[b[a[1]].element,"click",this.buttonToMaxClick],[this.track.element,"click",this.trackClick],[f,"mousedown",g],[z,"mousemove",d],[z,"mouseup",k]];e&&a.push([f,"touchstart",g],[z,"touchmove",d],[z,"touchend",
k]);t(a,function(a){D.apply(null,a)});this._events=a},removeEvents:function(){t(this._events,function(a){k.apply(null,a)});this._events=void 0},destroy:function(){var a=this.chart.scroller;this.removeEvents();t(["track","scrollbarRifles","scrollbar","scrollbarGroup","group"],function(a){this[a]&&this[a].destroy&&(this[a]=this[a].destroy())},this);a&&(a.scrollbar=null,m(a.scrollbarButtons))}};l(H.prototype,"init",function(a){var b=this;a.apply(b,[].slice.call(arguments,1));b.options.scrollbar&&b.options.scrollbar.enabled&&
(b.options.scrollbar.vertical=!b.horiz,b.options.startOnTick=b.options.endOnTick=!1,b.scrollbar=new E(b.chart.renderer,b.options.scrollbar,b.chart),D(b.scrollbar,"changed",function(a){var e=Math.min(w(b.options.min,b.min),b.min,b.dataMin),d=Math.max(w(b.options.max,b.max),b.max,b.dataMax)-e,f;b.horiz&&!b.reversed||!b.horiz&&b.reversed?(f=e+d*this.to,e+=d*this.from):(f=e+d*(1-this.from),e+=d*(1-this.to));b.setExtremes(e,f,!0,!1,a)}))});l(H.prototype,"render",function(a){var b=Math.min(w(this.options.min,
this.min),this.min,this.dataMin),e=Math.max(w(this.options.max,this.max),this.max,this.dataMax),g=this.scrollbar,d;a.apply(this,[].slice.call(arguments,1));g&&(this.horiz?g.position(this.left,this.top+this.height+this.offset+2+(this.opposite?0:this.axisTitleMargin),this.width,this.height):g.position(this.left+this.width+2+this.offset+(this.opposite?this.axisTitleMargin:0),this.top,this.width,this.height),isNaN(b)||isNaN(e)||!n(this.min)||!n(this.max)?g.setRange(0,0):(d=(this.min-b)/(e-b),b=(this.max-
b)/(e-b),this.horiz&&!this.reversed||!this.horiz&&this.reversed?g.setRange(d,b):g.setRange(1-b,1-d)))});l(H.prototype,"getOffset",function(a){var b=this.horiz?2:1,e=this.scrollbar;a.apply(this,[].slice.call(arguments,1));e&&(this.chart.axisOffset[b]+=e.size+e.options.margin)});l(H.prototype,"destroy",function(a){this.scrollbar&&(this.scrollbar=this.scrollbar.destroy());a.apply(this,[].slice.call(arguments,1))});a.Scrollbar=E})(K);(function(a){function E(a){this.init(a)}var D=a.addEvent,H=a.Axis,I=
a.Chart,v=a.color,n=a.defaultOptions,m=a.defined,z=a.destroyObjectProperties,t=a.doc,q=a.each,e=a.erase,b=a.error,p=a.extend,w=a.grep,k=a.hasTouch,l=a.isNumber,g=a.isObject,F=a.merge,r=a.pick,u=a.removeEvent,f=a.Scrollbar,B=a.Series,d=a.seriesTypes,x=a.wrap,c=a.swapXY,y=[].concat(a.defaultDataGroupingUnits),L=function(a){var b=w(arguments,l);if(b.length)return Math[a].apply(0,b)};y[4]=["day",[1,2,3,4]];y[5]=["week",[1,2,3]];d=void 0===d.areaspline?"line":"areaspline";p(n,{navigator:{height:40,margin:25,
maskInside:!0,handles:{backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:v("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:d,color:"#335cad",fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,smoothed:!0,units:y},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},pointRange:0,shadow:!1,threshold:null},xAxis:{className:"highcharts-navigator-xaxis",
tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}});E.prototype={drawHandle:function(a,b,c,d){this.handles[b][d](c?{translateX:Math.round(this.left+this.height/2-8),translateY:Math.round(this.top+parseInt(a,
10)+.5)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-8)})},getHandlePath:function(a){return c(["M",-4.5,.5,"L",3.5,.5,"L",3.5,15.5,"L",-4.5,15.5,"L",-4.5,.5,"M",-1.5,4,"L",-1.5,12,"M",.5,4,"L",.5,12],a)},drawOutline:function(a,b,c,d){var e=this.navigatorOptions.maskInside,f=this.outline.strokeWidth()/2,h=this.outlineHeight,g=this.scrollbarHeight,k=this.size,l=this.left-g,m=this.top;c?(l-=f,c=m+b+f,b=m+a+f,a=["M",l+h,m-g-f,"L",l+h,c,"L",l,c,"L",l,b,
"L",l+h,b,"L",l+h,m+k+g].concat(e?["M",l+h,c-f,"L",l+h,b+f]:[])):(a+=l+g-f,b+=l+g-f,m+=f,a=["M",l,m,"L",a,m,"L",a,m+h,"L",b,m+h,"L",b,m,"L",l+k+2*g,m].concat(e?["M",a-f,m,"L",b+f,m]:[]));this.outline[d]({d:a})},drawMasks:function(a,b,c,d){var e=this.left,f=this.top,h=this.height,g,k,l,m;c?(l=[e,e,e],m=[f,f+a,f+b],k=[h,h,h],g=[a,b-a,this.size-b]):(l=[e,e+a,e+b],m=[f,f,f],k=[a,b-a,this.size-b],g=[h,h,h]);q(this.shades,function(a,b){a[d]({x:l[b],y:m[b],width:k[b],height:g[b]})})},renderElements:function(){var a=
this,b=a.navigatorOptions,c=b.maskInside,d=a.chart,e=d.inverted,f=d.renderer,g;a.navigatorGroup=g=f.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();var k={cursor:e?"ns-resize":"ew-resize"};q([!c,c,!c],function(c,d){a.shades[d]=f.rect().addClass("highcharts-navigator-mask"+(1===d?"-inside":"-outside")).attr({fill:c?b.maskFill:"transparent"}).css(1===d&&k).add(g)});a.outline=f.path().addClass("highcharts-navigator-outline").attr({"stroke-width":b.outlineWidth,stroke:b.outlineColor}).add(g);
q([0,1],function(c){a.handles[c]=f.path(a.getHandlePath(e)).attr({zIndex:7-c}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][c]).add(g);var d=b.handles;a.handles[c].attr({fill:d.backgroundColor,stroke:d.borderColor,"stroke-width":1}).css(k)})},update:function(a){this.destroy();F(!0,this.chart.options.navigator,this.options,a);this.init(this.chart)},render:function(a,b,c,d){var e=this.chart,f,h,g=this.scrollbarHeight,k,n=this.xAxis;f=this.navigatorEnabled;var p,
q=this.rendered;h=e.inverted;var A=e.xAxis[0].minRange;if(!this.hasDragged||m(c)){if(!l(a)||!l(b))if(q)c=0,d=n.width;else return;this.left=r(n.left,e.plotLeft+g);h?(this.size=p=k=r(n.len,e.plotHeight-2*g),e=g):(this.size=p=k=r(n.len,e.plotWidth-2*g),e=k+2*g);c=r(c,n.toPixels(a,!0));d=r(d,n.toPixels(b,!0));l(c)&&Infinity!==Math.abs(c)||(c=0,d=e);a=n.toValue(c,!0);b=n.toValue(d,!0);if(Math.abs(b-a)<A)if(this.grabbedLeft)c=n.toPixels(b-A,!0);else if(this.grabbedRight)d=n.toPixels(a+A,!0);else return;
this.zoomedMax=Math.min(Math.max(c,d,0),p);this.zoomedMin=Math.min(Math.max(this.fixedWidth?this.zoomedMax-this.fixedWidth:Math.min(c,d),0),p);this.range=this.zoomedMax-this.zoomedMin;p=Math.round(this.zoomedMax);c=Math.round(this.zoomedMin);f&&(this.navigatorGroup.attr({visibility:"visible"}),q=q&&!this.hasDragged?"animate":"attr",this.drawMasks(c,p,h,q),this.drawOutline(c,p,h,q),this.drawHandle(c,0,h,q),this.drawHandle(p,1,h,q));this.scrollbar&&(h?(h=this.top-g,f=this.left-g+(f?0:this.height),g=
k+2*g):(h=this.top+(f?this.height:-g),f=this.left-g),this.scrollbar.position(f,h,e,g),this.scrollbar.setRange(c/k,p/k));this.rendered=!0}},addMouseEvents:function(){var a=this,b=a.chart,c=b.container,d=[],e,f;a.mouseMoveHandler=e=function(b){a.onMouseMove(b)};a.mouseUpHandler=f=function(b){a.onMouseUp(b)};d=a.getPartsEvents("mousedown");d.push(D(c,"mousemove",e),D(t,"mouseup",f));k&&(d.push(D(c,"touchmove",e),D(t,"touchend",f)),d.concat(a.getPartsEvents("touchstart")));a.eventsToUnbind=d;a.series&&
a.series[0]&&d.push(D(a.series[0].xAxis,"foundExtremes",function(){b.navigator.modifyNavigatorAxisExtremes()}))},getPartsEvents:function(a){var b=this,c=[];q(["shades","handles"],function(d){q(b[d],function(e,f){c.push(D(e.element,a,function(a){b[d+"Mousedown"](a,f)}))})});return c},shadesMousedown:function(a,b){a=this.chart.pointer.normalize(a);var c=this.chart,d=this.xAxis,e=this.zoomedMin,f=this.left,g=this.size,k=this.range,l=a.chartX,m;c.inverted&&(l=a.chartY,f=this.top);1===b?(this.grabbedCenter=
l,this.fixedWidth=k,this.dragOffset=l-e):(a=l-f-k/2,0===b?a=Math.max(0,a):2===b&&a+k>=g&&(a=g-k,m=this.getUnionExtremes().dataMax),a!==e&&(this.fixedWidth=k,b=d.toFixedRange(a,a+k,null,m),c.xAxis[0].setExtremes(Math.min(b.min,b.max),Math.max(b.min,b.max),!0,null,{trigger:"navigator"})))},handlesMousedown:function(a,b){this.chart.pointer.normalize(a);a=this.chart;var c=a.xAxis[0],d=a.inverted&&!c.reversed||!a.inverted&&c.reversed;0===b?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=
d?c.min:c.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=d?c.max:c.min);a.fixedRange=null},onMouseMove:function(a){var b=this,c=b.chart,d=b.left,e=b.navigatorSize,f=b.range,g=b.dragOffset,k=c.inverted;a.touches&&0===a.touches[0].pageX||(a=c.pointer.normalize(a),c=a.chartX,k&&(d=b.top,c=a.chartY),b.grabbedLeft?(b.hasDragged=!0,b.render(0,0,c-d,b.otherHandlePos)):b.grabbedRight?(b.hasDragged=!0,b.render(0,0,b.otherHandlePos,c-d)):b.grabbedCenter&&(b.hasDragged=!0,c<
g?c=g:c>e+g-f&&(c=e+g-f),b.render(0,0,c-g,c-g+f)),b.hasDragged&&b.scrollbar&&b.scrollbar.options.liveRedraw&&(a.DOMType=a.type,setTimeout(function(){b.onMouseUp(a)},0)))},onMouseUp:function(a){var b=this.chart,c=this.xAxis,d,e,f=a.DOMEvent||a;if(this.hasDragged||"scrollbar"===a.trigger)this.zoomedMin===this.otherHandlePos?d=this.fixedExtreme:this.zoomedMax===this.otherHandlePos&&(e=this.fixedExtreme),this.zoomedMax===this.navigatorSize&&(e=this.getUnionExtremes().dataMax),c=c.toFixedRange(this.zoomedMin,
this.zoomedMax,d,e),m(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:f});"mousemove"!==a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=this.hasDragged=this.dragOffset=null)},removeEvents:function(){this.eventsToUnbind&&(q(this.eventsToUnbind,function(a){a()}),this.eventsToUnbind=void 0);this.removeBaseSeriesEvents()},
removeBaseSeriesEvents:function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&!1!==this.navigatorOptions.adaptToUpdatedData&&(q(a,function(a){u(a,"updatedData",this.updatedDataHandler)},this),a[0].xAxis&&u(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))},init:function(a){var b=a.options,c=b.navigator,d=c.enabled,e=b.scrollbar,g=e.enabled,b=d?c.height:0,k=g?e.height:0;this.handles=[];this.shades=[];this.chart=a;this.setBaseSeries();this.height=b;this.scrollbarHeight=k;this.scrollbarEnabled=
g;this.navigatorEnabled=d;this.navigatorOptions=c;this.scrollbarOptions=e;this.outlineHeight=b+k;var l=this,d=l.baseSeries,e=a.xAxis.length,g=a.yAxis.length,m=d&&d[0]&&d[0].xAxis||a.xAxis[0];a.extraMargin={type:c.opposite?"plotTop":"marginBottom",value:l.outlineHeight+c.margin};a.inverted&&(a.extraMargin.type=c.opposite?"marginRight":"plotLeft");a.isDirtyBox=!0;l.navigatorEnabled?(l.xAxis=new H(a,F({breaks:m.options.breaks,ordinal:m.options.ordinal},c.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",
isX:!0,type:"datetime",index:e,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[k,0,-k,0],width:b}:{offsets:[0,-k,0,k],height:b})),l.yAxis=new H(a,F(c.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:g,zoomEnabled:!1},a.inverted?{width:b}:{height:b})),d||c.series.data?l.addBaseSeries():0===a.series.length&&x(a,"redraw",function(b,c){0<a.series.length&&!l.series&&(l.setBaseSeries(),a.redraw=b);b.call(a,c)}),l.renderElements(),
l.addMouseEvents()):l.xAxis={translate:function(b,c){var d=a.xAxis[0],e=d.getExtremes(),f=a.plotWidth-2*k,h=L("min",d.options.min,e.dataMin),d=L("max",d.options.max,e.dataMax)-h;return c?b*d/f+h:f*(b-h)/d},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,!0)},toFixedRange:H.prototype.toFixedRange,fake:!0};a.options.scrollbar.enabled&&(a.scrollbar=l.scrollbar=new f(a.renderer,F(a.options.scrollbar,{margin:l.navigatorEnabled?0:10,vertical:a.inverted}),a),D(l.scrollbar,
"changed",function(b){var c=l.size,d=c*this.to,c=c*this.from;l.hasDragged=l.scrollbar.hasDragged;l.render(0,0,c,d);(a.options.scrollbar.liveRedraw||"mousemove"!==b.DOMType)&&setTimeout(function(){l.onMouseUp(b)})}));l.addBaseSeriesEvents();l.addChartEvents()},getUnionExtremes:function(a){var b=this.chart.xAxis[0],c=this.xAxis,d=c.options,e=b.options,f;a&&null===b.dataMin||(f={dataMin:r(d&&d.min,L("min",e.min,b.dataMin,c.dataMin,c.min)),dataMax:r(d&&d.max,L("max",e.max,b.dataMax,c.dataMax,c.max))});
return f},setBaseSeries:function(a){var b=this.chart,c=this.baseSeries=[];a=a||b.options&&b.options.navigator.baseSeries||0;this.series&&(this.removeBaseSeriesEvents(),q(this.series,function(a){a.destroy()}));q(b.series||[],function(b,d){(b.options.showInNavigator||(d===a||b.options.id===a)&&!1!==b.options.showInNavigator)&&c.push(b)});this.xAxis&&!this.xAxis.fake&&this.addBaseSeries()},addBaseSeries:function(){var a=this,b=a.chart,c=a.series=[],d=a.baseSeries,e,f,g=a.navigatorOptions.series,k,l=
{enableMouseTracking:!1,index:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:!1,isInternal:!0,visible:!0};d?q(d,function(d,h){l.name="Navigator "+(h+1);e=d.options||{};k=e.navigatorOptions||{};f=F(e,l,g,k);h=k.data||g.data;a.hasNavigatorData=a.hasNavigatorData||!!h;f.data=h||e.data&&e.data.slice(0);d.navigatorSeries=b.initSeries(f);c.push(d.navigatorSeries)}):(f=F(g,l),f.data=g.data,a.hasNavigatorData=!!f.data,c.push(b.initSeries(f)));this.addBaseSeriesEvents()},
addBaseSeriesEvents:function(){var a=this,b=a.baseSeries||[];b[0]&&b[0].xAxis&&D(b[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes);!1!==this.navigatorOptions.adaptToUpdatedData&&q(b,function(b){b.xAxis&&(D(b,"updatedData",this.updatedDataHandler),b.userOptions.events=p(b.userOptions.event,{updatedData:this.updatedDataHandler}));D(b,"remove",function(){this.navigatorSeries&&(e(a.series,this.navigatorSeries),this.navigatorSeries.remove(),delete this.navigatorSeries)})},this)},modifyNavigatorAxisExtremes:function(){var a=
this.xAxis,b;a.getExtremes&&(!(b=this.getUnionExtremes(!0))||b.dataMin===a.min&&b.dataMax===a.max||(a.min=b.dataMin,a.max=b.dataMax))},modifyBaseAxisExtremes:function(){var a=this.chart.navigator,b=this.getExtremes(),c=b.dataMin,d=b.dataMax,b=b.max-b.min,e=a.stickToMin,f=a.stickToMax,g,k,m=a.series&&a.series[0],n=!!this.setExtremes;this.eventArgs&&"rangeSelectorButton"===this.eventArgs.trigger||(e&&(k=c,g=k+b),f&&(g=d,e||(k=Math.max(g-b,m&&m.xData?m.xData[0]:-Number.MAX_VALUE))),n&&(e||f)&&l(k)&&
(this.min=this.userMin=k,this.max=this.userMax=g));a.stickToMin=a.stickToMax=null},updatedDataHandler:function(){var a=this.chart.navigator,b=this.navigatorSeries;a.stickToMin=l(this.xAxis.min)&&this.xAxis.min<=this.xData[0];a.stickToMax=Math.round(a.zoomedMax)>=Math.round(a.size);b&&!a.hasNavigatorData&&(b.options.pointStart=this.xData[0],b.setData(this.options.data,!1,null,!1))},addChartEvents:function(){D(this.chart,"redraw",function(){var a=this.navigator,b=a&&(a.baseSeries&&a.baseSeries[0]&&
a.baseSeries[0].xAxis||a.scrollbar&&this.xAxis[0]);b&&a.render(b.min,b.max)})},destroy:function(){this.removeEvents();this.xAxis&&(e(this.chart.xAxis,this.xAxis),e(this.chart.axes,this.xAxis));this.yAxis&&(e(this.chart.yAxis,this.yAxis),e(this.chart.axes,this.yAxis));q(this.series||[],function(a){a.destroy&&a.destroy()});q("series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" "),function(a){this[a]&&this[a].destroy&&this[a].destroy();
this[a]=null},this);q([this.handles],function(a){z(a)},this)}};a.Navigator=E;x(H.prototype,"zoom",function(a,b,c){var d=this.chart,e=d.options,f=e.chart.zoomType,h=e.navigator,e=e.rangeSelector,g;this.isXAxis&&(h&&h.enabled||e&&e.enabled)&&("x"===f?d.resetZoomButton="blocked":"y"===f?g=!1:"xy"===f&&(d=this.previousZoom,m(b)?this.previousZoom=[this.min,this.max]:d&&(b=d[0],c=d[1],delete this.previousZoom)));return void 0!==g?g:a.call(this,b,c)});x(I.prototype,"init",function(a,b,c){D(this,"beforeRender",
function(){var a=this.options;if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=this.navigator=new E(this)});a.call(this,b,c)});x(I.prototype,"setChartSize",function(a){var b=this.legend,c=this.navigator,d,e,f,g;a.apply(this,[].slice.call(arguments,1));c&&(e=b.options,f=c.xAxis,g=c.yAxis,d=c.scrollbarHeight,this.inverted?(c.left=c.navigatorOptions.opposite?this.chartWidth-d-c.height:this.spacing[3]+d,c.top=this.plotTop+d):(c.left=this.plotLeft+d,c.top=c.navigatorOptions.top||this.chartHeight-
c.height-d-this.spacing[2]-("bottom"===e.verticalAlign&&e.enabled&&!e.floating?b.legendHeight+r(e.margin,10):0)),f&&g&&(this.inverted?f.options.left=g.options.left=c.left:f.options.top=g.options.top=c.top,f.setAxisSize(),g.setAxisSize()))});x(B.prototype,"addPoint",function(a,c,d,e,f){var h=this.options.turboThreshold;h&&this.xData.length>h&&g(c,!0)&&this.chart.navigator&&b(20,!0);a.call(this,c,d,e,f)});x(I.prototype,"addSeries",function(a,b,c,d){a=a.call(this,b,!1,d);this.navigator&&this.navigator.setBaseSeries();
r(c,!0)&&this.redraw();return a});x(B.prototype,"update",function(a,b,c){a.call(this,b,!1);this.chart.navigator&&this.chart.navigator.setBaseSeries();r(c,!0)&&this.chart.redraw()});I.prototype.callbacks.push(function(a){var b=a.navigator;b&&(a=a.xAxis[0].getExtremes(),b.render(a.min,a.max))})})(K);(function(a){function E(a){this.init(a)}var D=a.addEvent,H=a.Axis,I=a.Chart,v=a.css,n=a.createElement,m=a.dateFormat,z=a.defaultOptions,t=z.global.useUTC,q=a.defined,e=a.destroyObjectProperties,b=a.discardElement,
p=a.each,w=a.extend,k=a.fireEvent,l=a.Date,g=a.isNumber,F=a.merge,r=a.pick,u=a.pInt,f=a.splat,B=a.wrap;w(z,{rangeSelector:{buttonTheme:{"stroke-width":0,width:28,height:18,padding:2,zIndex:7},height:35,inputPosition:{align:"right"},labelStyle:{color:"#666666"}}});z.lang=F(z.lang,{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"From",rangeSelectorTo:"To"});E.prototype={clickButton:function(a,b){var c=this,d=c.chart,e=c.buttonOptions[a],k=d.xAxis[0],l=d.scroller&&d.scroller.getUnionExtremes()||k||{},h=
l.dataMin,m=l.dataMax,n,q=k&&Math.round(Math.min(k.max,r(m,k.max))),x=e.type,u,l=e._range,v,w,z,B=e.dataGrouping;if(null!==h&&null!==m){d.fixedRange=l;B&&(this.forcedDataGrouping=!0,H.prototype.setDataGrouping.call(k||{chart:this.chart},B,!1));if("month"===x||"year"===x)k?(x={range:e,max:q,dataMin:h,dataMax:m},n=k.minFromRange.call(x),g(x.newMax)&&(q=x.newMax)):l=e;else if(l)n=Math.max(q-l,h),q=Math.min(n+l,m);else if("ytd"===x)if(k)void 0===m&&(h=Number.MAX_VALUE,m=Number.MIN_VALUE,p(d.series,function(a){a=
a.xData;h=Math.min(a[0],h);m=Math.max(a[a.length-1],m)}),b=!1),q=c.getYTDExtremes(m,h,t),n=v=q.min,q=q.max;else{D(d,"beforeRender",function(){c.clickButton(a)});return}else"all"===x&&k&&(n=h,q=m);c.setSelected(a);k?k.setExtremes(n,q,r(b,1),null,{trigger:"rangeSelectorButton",rangeSelectorButton:e}):(u=f(d.options.xAxis)[0],z=u.range,u.range=l,w=u.min,u.min=v,D(d,"load",function(){u.range=z;u.min=w}))}},setSelected:function(a){this.selected=this.options.selected=a},defaultButtons:[{type:"month",count:1,
text:"1m"},{type:"month",count:3,text:"3m"},{type:"month",count:6,text:"6m"},{type:"ytd",text:"YTD"},{type:"year",count:1,text:"1y"},{type:"all",text:"All"}],init:function(a){var b=this,c=a.options.rangeSelector,d=c.buttons||[].concat(b.defaultButtons),e=c.selected,f=function(){var a=b.minInput,c=b.maxInput;a&&a.blur&&k(a,"blur");c&&c.blur&&k(c,"blur")};b.chart=a;b.options=c;b.buttons=[];a.extraTopMargin=c.height;b.buttonOptions=d;this.unMouseDown=D(a.container,"mousedown",f);this.unResize=D(a,"resize",
f);p(d,b.computeButtonRange);void 0!==e&&d[e]&&this.clickButton(e,!1);D(a,"load",function(){D(a.xAxis[0],"setExtremes",function(c){this.max-this.min!==a.fixedRange&&"rangeSelectorButton"!==c.trigger&&"updatedData"!==c.trigger&&b.forcedDataGrouping&&this.setDataGrouping(!1,!1)})})},updateButtonStates:function(){var a=this.chart,b=a.xAxis[0],c=Math.round(b.max-b.min),e=!b.hasVisibleSeries,a=a.scroller&&a.scroller.getUnionExtremes()||b,f=a.dataMin,k=a.dataMax,a=this.getYTDExtremes(k,f,t),l=a.min,h=a.max,
m=this.selected,n=g(m),q=this.options.allButtonsEnabled,r=this.buttons;p(this.buttonOptions,function(a,d){var g=a._range,p=a.type,t=a.count||1;a=r[d];var y=0;d=d===m;var u=g>k-f,x=g<b.minRange,v=!1,w=!1,g=g===c;("month"===p||"year"===p)&&c>=864E5*{month:28,year:365}[p]*t&&c<=864E5*{month:31,year:366}[p]*t?g=!0:"ytd"===p?(g=h-l===c,v=!d):"all"===p&&(g=b.max-b.min>=k-f,w=!d&&n&&g);p=!q&&(u||x||w||e);g=d&&g||g&&!n&&!v;p?y=3:g&&(n=!0,y=2);a.state!==y&&a.setState(y)})},computeButtonRange:function(a){var b=
a.type,c=a.count||1,d={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5};if(d[b])a._range=d[b]*c;else if("month"===b||"year"===b)a._range=864E5*{month:30,year:365}[b]*c},setInputValue:function(a,b){var c=this.chart.options.rangeSelector,d=this[a+"Input"];q(b)&&(d.previousValue=d.HCTime,d.HCTime=b);d.value=m(c.inputEditDateFormat||"%Y-%m-%d",d.HCTime);this[a+"DateBox"].attr({text:m(c.inputDateFormat||"%b %e, %Y",d.HCTime)})},showInput:function(a){var b=this.inputGroup,c=this[a+"DateBox"];
v(this[a+"Input"],{left:b.translateX+c.x+"px",top:b.translateY+"px",width:c.width-2+"px",height:c.height-2+"px",border:"2px solid silver"})},hideInput:function(a){v(this[a+"Input"],{border:0,width:"1px",height:"1px"});this.setInputValue(a)},drawInput:function(a){function b(){var a=m.value,b=(k.inputDateParser||Date.parse)(a),e=d.xAxis[0],f=d.scroller&&d.scroller.xAxis?d.scroller.xAxis:e,h=f.dataMin,f=f.dataMax;b!==m.previousValue&&(m.previousValue=b,g(b)||(b=a.split("-"),b=Date.UTC(u(b[0]),u(b[1])-
1,u(b[2]))),g(b)&&(t||(b+=6E4*(new Date).getTimezoneOffset()),l?b>c.maxInput.HCTime?b=void 0:b<h&&(b=h):b<c.minInput.HCTime?b=void 0:b>f&&(b=f),void 0!==b&&e.setExtremes(l?b:e.min,l?e.max:b,void 0,void 0,{trigger:"rangeSelectorInput"})))}var c=this,d=c.chart,e=d.renderer.style||{},f=d.renderer,k=d.options.rangeSelector,h=c.div,l="min"===a,m,p,q=this.inputGroup;this[a+"Label"]=p=f.label(z.lang[l?"rangeSelectorFrom":"rangeSelectorTo"],this.inputGroup.offset).addClass("highcharts-range-label").attr({padding:2}).add(q);
q.offset+=p.width+5;this[a+"DateBox"]=f=f.label("",q.offset).addClass("highcharts-range-input").attr({padding:2,width:k.inputBoxWidth||90,height:k.inputBoxHeight||17,stroke:k.inputBoxBorderColor||"#cccccc","stroke-width":1,"text-align":"center"}).on("click",function(){c.showInput(a);c[a+"Input"].focus()}).add(q);q.offset+=f.width+(l?10:0);this[a+"Input"]=m=n("input",{name:a,className:"highcharts-range-selector",type:"text"},{top:d.plotTop+"px"},h);p.css(F(e,k.labelStyle));f.css(F({color:"#333333"},
e,k.inputStyle));v(m,w({position:"absolute",border:0,width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:e.fontSize,fontFamily:e.fontFamily,left:"-9em"},k.inputStyle));m.onfocus=function(){c.showInput(a)};m.onblur=function(){c.hideInput(a)};m.onchange=b;m.onkeypress=function(a){13===a.keyCode&&b()}},getPosition:function(){var a=this.chart,b=a.options.rangeSelector,a=r((b.buttonPosition||{}).y,a.plotTop-a.axisOffset[0]-b.height);return{buttonTop:a,inputTop:a-10}},getYTDExtremes:function(a,
b,c){var d=new l(a),e=d[l.hcGetFullYear]();c=c?l.UTC(e,0,1):+new l(e,0,1);b=Math.max(b||0,c);d=d.getTime();return{max:Math.min(a||d,d),min:b}},render:function(a,b){var c=this,d=c.chart,e=d.renderer,f=d.container,g=d.options,h=g.exporting&&!1!==g.exporting.enabled&&g.navigation&&g.navigation.buttonOptions,k=g.rangeSelector,l=c.buttons,g=z.lang,m=c.div,m=c.inputGroup,t=k.buttonTheme,u=k.buttonPosition||{},x=k.inputEnabled,v=t&&t.states,B=d.plotLeft,D,E=this.getPosition(),F=c.group,H=c.rendered;!1!==
k.enabled&&(H||(c.group=F=e.g("range-selector-buttons").add(),c.zoomText=e.text(g.rangeSelectorZoom,r(u.x,B),15).css(k.labelStyle).add(F),D=r(u.x,B)+c.zoomText.getBBox().width+5,p(c.buttonOptions,function(a,b){l[b]=e.button(a.text,D,0,function(){c.clickButton(b);c.isActive=!0},t,v&&v.hover,v&&v.select,v&&v.disabled).attr({"text-align":"center"}).add(F);D+=l[b].width+r(k.buttonSpacing,5)}),!1!==x&&(c.div=m=n("div",null,{position:"relative",height:0,zIndex:1}),f.parentNode.insertBefore(m,f),c.inputGroup=
m=e.g("input-group").add(),m.offset=0,c.drawInput("min"),c.drawInput("max"))),c.updateButtonStates(),F[H?"animate":"attr"]({translateY:E.buttonTop}),!1!==x&&(m.align(w({y:E.inputTop,width:m.offset,x:h&&E.inputTop<(h.y||0)+h.height-d.spacing[0]?-40:0},k.inputPosition),!0,d.spacingBox),q(x)||(d=F.getBBox(),m[m.alignAttr.translateX<d.x+d.width+10?"hide":"show"]()),c.setInputValue("min",a),c.setInputValue("max",b)),c.rendered=!0)},update:function(a){var b=this.chart;F(!0,b.options.rangeSelector,a);this.destroy();
this.init(b)},destroy:function(){var a=this.minInput,f=this.maxInput,c;this.unMouseDown();this.unResize();e(this.buttons);a&&(a.onfocus=a.onblur=a.onchange=null);f&&(f.onfocus=f.onblur=f.onchange=null);for(c in this)this[c]&&"chart"!==c&&(this[c].destroy?this[c].destroy():this[c].nodeType&&b(this[c])),this[c]!==E.prototype[c]&&(this[c]=null)}};H.prototype.toFixedRange=function(a,b,c,e){var d=this.chart&&this.chart.fixedRange;a=r(c,this.translate(a,!0,!this.horiz));b=r(e,this.translate(b,!0,!this.horiz));
c=d&&(b-a)/d;.7<c&&1.3>c&&(e?a=b-d:b=a+d);g(a)||(a=b=void 0);return{min:a,max:b}};H.prototype.minFromRange=function(){var a=this.range,b={month:"Month",year:"FullYear"}[a.type],c,e=this.max,f,k,l=function(a,c){var d=new Date(a);d["set"+b](d["get"+b]()+c);return d.getTime()-a};g(a)?(c=e-a,k=a):(c=e+l(e,-a.count),this.chart&&(this.chart.fixedRange=e-c));f=r(this.dataMin,Number.MIN_VALUE);g(c)||(c=f);c<=f&&(c=f,void 0===k&&(k=l(c,a.count)),this.newMax=Math.min(c+k,this.dataMax));g(e)||(c=void 0);return c};
B(I.prototype,"init",function(a,b,c){D(this,"init",function(){this.options.rangeSelector.enabled&&(this.rangeSelector=new E(this))});a.call(this,b,c)});I.prototype.callbacks.push(function(a){function b(){c=a.xAxis[0].getExtremes();g(c.min)&&d.render(c.min,c.max)}var c,d=a.rangeSelector,e,f;d&&(f=D(a.xAxis[0],"afterSetExtremes",function(a){d.render(a.min,a.max)}),e=D(a,"redraw",b),b());D(a,"destroy",function(){d&&(e(),f())})});a.RangeSelector=E})(K);(function(a){var E=a.arrayMax,D=a.arrayMin,H=a.Axis,
I=a.Chart,v=a.defined,n=a.each,m=a.extend,z=a.format,t=a.inArray,q=a.isNumber,e=a.isString,b=a.map,p=a.merge,w=a.pick,k=a.Point,l=a.Renderer,g=a.Series,F=a.splat,r=a.SVGRenderer,u=a.VMLRenderer,f=a.wrap,B=g.prototype,d=B.init,x=B.processData,c=k.prototype.tooltipFormatter;a.StockChart=a.stockChart=function(c,d,f){var g=e(c)||c.nodeName,h=arguments[g?1:0],k=h.series,l=a.getOptions(),m,n=w(h.navigator&&h.navigator.enabled,l.navigator.enabled,!0),q=n?{startOnTick:!1,endOnTick:!1}:null,r={marker:{enabled:!1,
radius:2}},t={shadow:!1,borderWidth:0};h.xAxis=b(F(h.xAxis||{}),function(a){return p({minPadding:0,maxPadding:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0},l.xAxis,a,{type:"datetime",categories:null},q)});h.yAxis=b(F(h.yAxis||{}),function(a){m=w(a.opposite,!0);return p({labels:{y:-2},opposite:m,showLastLabel:!1,title:{text:null}},l.yAxis,a)});h.series=null;h=p({chart:{panning:!0,pinchType:"x"},navigator:{enabled:n},scrollbar:{enabled:w(l.scrollbar.enabled,!0)},rangeSelector:{enabled:w(l.rangeSelector.enabled,
!0)},title:{text:null},tooltip:{shared:!0,crosshairs:!0},legend:{enabled:!1},plotOptions:{line:r,spline:r,area:r,areaspline:r,arearange:r,areasplinerange:r,column:t,columnrange:t,candlestick:t,ohlc:t}},h,{isStock:!0});h.series=k;return g?new I(c,h,f):new I(h,d)};f(H.prototype,"autoLabelAlign",function(a){var b=this.chart,c=this.options,b=b._labelPanes=b._labelPanes||{},d=this.options.labels;return this.chart.options.isStock&&"yAxis"===this.coll&&(c=c.top+","+c.height,!b[c]&&d.enabled)?(15===d.x&&
(d.x=0),void 0===d.align&&(d.align="right"),b[c]=1,"right"):a.call(this,[].slice.call(arguments,1))});f(H.prototype,"getPlotLinePath",function(a,c,d,f,g,k){var h=this,l=this.isLinked&&!this.series?this.linkedParent.series:this.series,m=h.chart,p=m.renderer,r=h.left,u=h.top,y,x,z,A,B=[],D=[],E,G;if("colorAxis"===h.coll)return a.apply(this,[].slice.call(arguments,1));D=function(a){var c="xAxis"===a?"yAxis":"xAxis";a=h.options[c];return q(a)?[m[c][a]]:e(a)?[m.get(a)]:b(l,function(a){return a[c]})}(h.coll);
n(h.isXAxis?m.yAxis:m.xAxis,function(a){if(v(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var b=a.isXAxis?"yAxis":"xAxis",b=v(a.options[b])?m[b][a.options[b]]:m[b][0];h===b&&D.push(a)}});E=D.length?[]:[h.isXAxis?m.yAxis[0]:m.xAxis[0]];n(D,function(a){-1===t(a,E)&&E.push(a)});G=w(k,h.translate(c,null,null,f));q(G)&&(h.horiz?n(E,function(a){var b;x=a.pos;A=x+a.len;y=z=Math.round(G+h.transB);if(y<r||y>r+h.width)g?y=z=Math.min(Math.max(r,y),r+h.width):b=!0;b||B.push("M",y,x,"L",z,A)}):n(E,
function(a){var b;y=a.pos;z=y+a.len;x=A=Math.round(u+h.height-G);if(x<u||x>u+h.height)g?x=A=Math.min(Math.max(u,x),h.top+h.height):b=!0;b||B.push("M",y,x,"L",z,A)}));return 0<B.length?p.crispPolyLine(B,d||1):null});H.prototype.getPlotBandPath=function(a,b){b=this.getPlotLinePath(b,null,null,!0);a=this.getPlotLinePath(a,null,null,!0);var c=[],d;if(a&&b)if(a.toString()===b.toString())c=a,c.flat=!0;else for(d=0;d<a.length;d+=6)c.push("M",a[d+1],a[d+2],"L",a[d+4],a[d+5],b[d+4],b[d+5],b[d+1],b[d+2],"z");
else c=null;return c};r.prototype.crispPolyLine=function(a,b){var c;for(c=0;c<a.length;c+=6)a[c+1]===a[c+4]&&(a[c+1]=a[c+4]=Math.round(a[c+1])-b%2/2),a[c+2]===a[c+5]&&(a[c+2]=a[c+5]=Math.round(a[c+2])+b%2/2);return a};l===u&&(u.prototype.crispPolyLine=r.prototype.crispPolyLine);f(H.prototype,"hideCrosshair",function(a,b){a.call(this,b);this.crossLabel&&(this.crossLabel=this.crossLabel.hide())});f(H.prototype,"drawCrosshair",function(a,b,c){var d,e;a.call(this,b,c);if(v(this.crosshair.label)&&this.crosshair.label.enabled&&
this.cross){a=this.chart;var f=this.options.crosshair.label,g=this.horiz;d=this.opposite;e=this.left;var k=this.top,l=this.crossLabel,n,p=f.format,q="",r="inside"===this.options.tickPosition,t=!1!==this.crosshair.snap,u=0;b||(b=this.cross&&this.cross.e);n=g?"center":d?"right"===this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";l||(l=this.crossLabel=a.renderer.label(null,null,null,f.shape||"callout").addClass("highcharts-crosshair-label"+(this.series[0]&&" highcharts-color-"+
this.series[0].colorIndex)).attr({align:f.align||n,padding:w(f.padding,8),r:w(f.borderRadius,3),zIndex:2}).add(this.labelGroup),l.attr({fill:f.backgroundColor||this.series[0]&&this.series[0].color||"#666666",stroke:f.borderColor||"","stroke-width":f.borderWidth||0}).css(m({color:"#ffffff",fontWeight:"normal",fontSize:"11px",textAlign:"center"},f.style)));g?(n=t?c.plotX+e:b.chartX,k+=d?0:this.height):(n=d?this.width+e:0,k=t?c.plotY+k:b.chartY);p||f.formatter||(this.isDatetimeAxis&&(q="%b %d, %Y"),
p="{value"+(q?":"+q:"")+"}");b=t?c[this.isXAxis?"x":"y"]:this.toValue(g?b.chartX:b.chartY);l.attr({text:p?z(p,{value:b}):f.formatter.call(this,b),x:n,y:k,visibility:"visible"});b=l.getBBox();if(g){if(r&&!d||!r&&d)k=l.y-b.height}else k=l.y-b.height/2;g?(d=e-b.x,e=e+this.width-b.x):(d="left"===this.labelAlign?e:0,e="right"===this.labelAlign?e+this.width:a.chartWidth);l.translateX<d&&(u=d-l.translateX);l.translateX+b.width>=e&&(u=-(l.translateX+b.width-e));l.attr({x:n+u,y:k,anchorX:g?n:this.opposite?
0:a.chartWidth,anchorY:g?this.opposite?a.chartHeight:0:k+b.height/2})}});B.init=function(){d.apply(this,arguments);this.setCompare(this.options.compare)};B.setCompare=function(a){this.modifyValue="value"===a||"percent"===a?function(b,c){var d=this.compareValue;if(void 0!==b&&void 0!==d)return b="value"===a?b-d:b/d*100-(100===this.options.compareBase?0:100),c&&(c.change=b),b}:null;this.userOptions.compare=a;this.chart.hasRendered&&(this.isDirty=!0)};B.processData=function(){var a,b=-1,c,d,e,f;x.apply(this,
arguments);if(this.xAxis&&this.processedYData)for(c=this.processedXData,d=this.processedYData,e=d.length,this.pointArrayMap&&(b=t("close",this.pointArrayMap),-1===b&&(b=t(this.pointValKey||"y",this.pointArrayMap))),a=0;a<e-1;a++)if(f=-1<b?d[a][b]:d[a],q(f)&&c[a+1]>=this.xAxis.min&&0!==f){this.compareValue=f;break}};f(B,"getExtremes",function(a){var b;a.apply(this,[].slice.call(arguments,1));this.modifyValue&&(b=[this.modifyValue(this.dataMin),this.modifyValue(this.dataMax)],this.dataMin=D(b),this.dataMax=
E(b))});H.prototype.setCompare=function(a,b){this.isXAxis||(n(this.series,function(b){b.setCompare(a)}),w(b,!0)&&this.chart.redraw())};k.prototype.tooltipFormatter=function(b){b=b.replace("{point.change}",(0<this.change?"+":"")+a.numberFormat(this.change,w(this.series.tooltipOptions.changeDecimals,2)));return c.apply(this,[b])};f(g.prototype,"render",function(a){this.chart.is3d&&this.chart.is3d()||this.chart.polar||!this.xAxis||this.xAxis.isRadial||(!this.clipBox&&this.animate?(this.clipBox=p(this.chart.clipBox),
this.clipBox.width=this.xAxis.len,this.clipBox.height=this.yAxis.len):this.chart[this.sharedClipKey]?this.chart[this.sharedClipKey].attr({width:this.xAxis.len,height:this.yAxis.len}):this.clipBox&&(this.clipBox.width=this.xAxis.len,this.clipBox.height=this.yAxis.len));a.call(this)})})(K);return K});

/**
 * Highcharts pattern fill plugin
 *
 * Author:         Torstein Honsi
 * Last revision:  2014-04-29
 * License:        MIT License
 *
 * Options:
 * - pattern:      The URL for a pattern image file
 * - width:        The width of the image file
 * - height:       The height of the image file
 * - color1:       In oldIE, bright colors in the pattern image are replaced by this color. 
 *                 Not yet implemented in SVG.
 * - color2:       In oldIE, dark colors are replaced by this. 
 */
/*global Highcharts */
(function(){
  'use strict';
  var idCounter = 0;
  Highcharts.wrap(Highcharts.SVGElement.prototype, 'fillSetter', function (proceed, color, prop, elem){
    var markup,
      id,
      pattern,
      image;
    if(color && color.pattern && prop === 'fill'){
      id = 'highcharts-pattern-' + idCounter++;
      pattern = this.renderer.createElement('pattern').attr({
        id: id,
        patternUnits: 'userSpaceOnUse',
        width: color.width,
        height: color.height
      }).add(this.renderer.defs);
      image = this.renderer.path(["m", 0, 0, "l", 20, 20])
        .attr({
          'stroke-width': 0.3,
           stroke: 'black',
           fill: "none",
           class: "changeBar" 
        })
    .add(pattern);
      // image = this.renderer.image(
      //   color.pattern, 0, 0, color.width, color.height
      // ).add(pattern);
      elem.setAttribute(prop, 'url(' + this.renderer.url + '#' + id + ')');
    } else{
      return proceed.call(this, color, prop, elem);
    }
  });
  
  if(Highcharts.VMLElement){
    Highcharts.wrap(Highcharts.Renderer.prototype.Element.prototype, 'fillSetter', function (proceed, color, prop, elem){
      if(color && color.pattern && prop === 'fill'){
        // Remove previous fills
        if(elem.getElementsByTagName('fill').length){
          elem.removeChild(elem.getElementsByTagName('fill')[0]);                  
        } 
        // If colors are given, use those, else use the original colors
        // of the pattern tile
        if(color.color1 && color.color2){
            markup = ['<hcv:', prop, ' color="', color.color1, '" color2="', color.color2, '" type="pattern" src="', color.pattern, '" />'].join('');
        } else{
          markup = this.renderer.prepVML(['<', prop, ' type="tile" src="', color.pattern, '" />']);
        }
        
        elem.appendChild(
          document.createElement(markup)
        );   
        
        // Work around display bug on updating attached nodes
        if(elem.parentNode.nodeType === 1){
          elem.outerHTML = elem.outerHTML
        }
      } else{
        return proceed.call(this, color, prop, elem);
      }
    });
  }
})();
/******************************************************************************
Name:    Highslide JS
Version: 4.1.8 (October 27 2009)
Config:  default +events +unobtrusive +imagemap +slideshow +positioning +transitions +viewport +thumbstrip +inline +ajax +iframe +flash
Author:  Torstein HÃ¸nsi
Support: http://highslide.com/support

Licence:
Highslide JS is licensed under a Creative Commons Attribution-NonCommercial 2.5
License (http://creativecommons.org/licenses/by-nc/2.5/).

You are free:
	* to copy, distribute, display, and perform the work
	* to make derivative works

Under the following conditions:
	* Attribution. You must attribute the work in the manner  specified by  the
	  author or licensor.
	* Noncommercial. You may not use this work for commercial purposes.

* For  any  reuse  or  distribution, you  must make clear to others the license
  terms of this work.
* Any  of  these  conditions  can  be  waived  if  you  get permission from the
  copyright holder.

Your fair use and other rights are in no way affected by the above.
******************************************************************************/
var getLang  = angular.fromJson(localStorage.getItem("authLang"));
var getCsvLabel = "Export CSV";
var getXlsxLabel = "Export XLSX";
if(getLang == "en_US"){
	getCsvLabel = "Export CSV";
	getXlsxLabel = "Export XLSX";
}else if(getLang == "fr_FR"){
	getCsvLabel = "Exporter CSV";
	getXlsxLabel = "Exporter XLSX";
}else if(getLang == "es_ES"){
	getCsvLabel = "Exportar CSV";
	getXlsxLabel = "Exportar XLSX";
}
if(!hs){ var hs = {
// Language strings
lang : {
	cssDirection: 'ltr',
	loadingText : 'Loading...',
	loadingTitle : 'Click to cancel',
	focusTitle : 'Click to bring to front',
	fullExpandTitle : 'Expand to actual size (f)',
	creditsText : 'Powered by <i>Highslide JS</i>',
	creditsTitle : 'Go to the Highslide JS homepage',
	previousText : 'Previous',
	nextText : 'Next',
	moveText : 'Move',
	closeText : 'Close',
	closeTitle : 'Close (esc)',
	resizeTitle : 'Resize',
	playText : 'Play',
	playTitle : 'Play slideshow (spacebar)',
	pauseText : 'Pause',
	pauseTitle : 'Pause slideshow (spacebar)',
	previousTitle : 'Previous (arrow left)',
	nextTitle : 'Next (arrow right)',
	moveTitle : 'Move',
	fullExpandText : '1:1',
	number: 'Image %1 of %2',
	restoreTitle : 'Click to close image, click and drag to move. Use arrow keys for next and previous.',
	csv : getCsvLabel,
	xlsx : getXlsxLabel
},
// See http://highslide.com/ref for examples of settings
// See http://www.highcharts.com/joomla/media/com_demo/graphics
graphicsDir : 'assets/images/highslide/',
expandCursor : 'zoomin.cur', // null disables
restoreCursor : 'zoomout.cur', // null disables
expandDuration : 250, // milliseconds
restoreDuration : 250,
marginLeft : 15,
marginRight : 15,
marginTop : 15,
marginBottom : 15,
zIndexCounter : 1001, // adjust to other absolutely positioned elements
loadingOpacity : 0.75,
allowMultipleInstances: true,
numberOfImagesToPreload : 5,
outlineWhileAnimating : 2, // 0 = never, 1 = always, 2 = HTML only
outlineStartOffset : 3, // ends at 10
padToMinWidth : false, // pad the popup width to make room for wide caption
fullExpandPosition : 'bottom right',
fullExpandOpacity : 1,
showCredits : false, // you can set this to false if you want
creditsHref : 'http://highslide.com/',
creditsTarget : '_self',
enableKeyListener : true,
openerTagNames : ['a', 'area'], // Add more to allow slideshow indexing
transitions : [],
transitionDuration: 250,
dimmingOpacity: 0, // Lightbox style dimming background
dimmingDuration: 50, // 0 for instant dimming

allowWidthReduction : false,
allowHeightReduction : true,
preserveContent : true, // Preserve changes made to the content and position of HTML popups.
objectLoadTime : 'before', // Load iframes 'before' or 'after' expansion.
cacheAjax : true, // Cache ajax popups for instant display. Can be overridden for each popup.
anchor : 'auto', // where the image expands from
align : 'auto', // position in the client (overrides anchor)
targetX: null, // the id of a target element
targetY: null,
dragByHeading: true,
minWidth: 200,
minHeight: 200,
allowSizeReduction: true, // allow the image to reduce to fit client size. If false, this overrides minWidth and minHeight
outlineType : 'drop-shadow', // set null to disable outlines
skin : {
	controls:
		'<div class="highslide-controls"><ul>'+
			'<li class="highslide-previous">'+
				'<a href="#" title="{hs.lang.previousTitle}">'+
				'<span>{hs.lang.previousText}</span></a>'+
			'</li>'+
			'<li class="highslide-play">'+
				'<a href="#" title="{hs.lang.playTitle}">'+
				'<span>{hs.lang.playText}</span></a>'+
			'</li>'+
			'<li class="highslide-pause">'+
				'<a href="#" title="{hs.lang.pauseTitle}">'+
				'<span>{hs.lang.pauseText}</span></a>'+
			'</li>'+
			'<li class="highslide-next">'+
				'<a href="#" title="{hs.lang.nextTitle}">'+
				'<span>{hs.lang.nextText}</span></a>'+
			'</li>'+
			'<li class="highslide-move">'+
				'<a href="#" title="{hs.lang.moveTitle}">'+
				'<span>{hs.lang.moveText}</span></a>'+
			'</li>'+
			'<li class="highslide-full-expand">'+
				'<a href="#" title="{hs.lang.fullExpandTitle}">'+
				'<span>{hs.lang.fullExpandText}</span></a>'+
			'</li>'+
			'<li class="highslide-close">'+
				'<a href="#" title="{hs.lang.closeTitle}" >'+
				'<span>{hs.lang.closeText}</span></a>'+
			'</li>'+
		'</ul></div>'
	,
	contentWrapper:

		'<div class="highslide-header"><ul>'+
			'<li class="highslide-previous">'+
				'<a href="#" title="{hs.lang.previousTitle}" onclick="return hs.previous(this)">'+
				'<span>{hs.lang.previousText}</span></a>'+
			'</li>'+
			'<li class="highslide-next">'+
				'<a href="#" title="{hs.lang.nextTitle}" onclick="return hs.next(this)">'+
				'<span>{hs.lang.nextText}</span></a>'+
			'</li>'+
			'<li class="highslide-move">'+
				'<a href="#" title="{hs.lang.moveTitle}" onclick="return false">'+
				'<span>{hs.lang.moveText}</span></a>'+
			'</li>'+
			'<li class="highslide-download pull-right">'+
			   '<div class="dropdownPP padL5 padR7 marT13 marR35 bdrR">'+
				 '<span onclick="return hs.downloadXLSX(this)" class="dropbtnPP fa fa-download"></span>'+
				'</div>'+
				//  '<div class="dropdown-contentPP ContantropdownPP" style="display:none">'+
				//    '<a class="text-file" onclick="return hs.downloadCSV(this)">{hs.lang.csv} </a>'+
				//    '<a class="excel-file" onclick="return hs.downloadXLSX(this)">{hs.lang.xlsx}</a>'+
				// '</div>'+
			'</li>'+
			'<li class="highslide-close">'+
				// '<a href="#" title="{hs.lang.closeTitle}" onclick="return hs.close(this)">'+
				'<a href="#/hub/reports/c/pp/" onclick="return hs.close(this)">'+
				'<span>{hs.lang.closeText}</span></a>'+
			'</li>'+
		'</ul></div>'+
		'<div class="highslide-body"></div>'+
		'<div class="highslide-footer"><div>'+
			'<span class="highslide-resize" title="{hs.lang.resizeTitle}"><span></span></span>'+
		'</div></div>'
},
// END OF YOUR SETTINGS


// declare internal properties
preloadTheseImages : [],
continuePreloading: true,
expanders : [],
overrides : [
	'allowSizeReduction',
	'useBox',
	'anchor',
	'align',
	'targetX',
	'targetY',
	'outlineType',
	'outlineWhileAnimating',
	'captionId',
	'captionText',
	'captionEval',
	'captionOverlay',
	'headingId',
	'headingText',
	'headingEval',
	'headingOverlay',
	'creditsPosition',
	'dragByHeading',
	'autoplay',
	'numberPosition',
	'transitions',
	'dimmingOpacity',

	'width',
	'height',

	'contentId',
	'allowWidthReduction',
	'allowHeightReduction',
	'preserveContent',
	'maincontentId',
	'maincontentText',
	'maincontentEval',
	'objectType',
	'cacheAjax',
	'objectWidth',
	'objectHeight',
	'objectLoadTime',
	'swfOptions',
	'wrapperClassName',
	'minWidth',
	'minHeight',
	'maxWidth',
	'maxHeight',
	'pageOrigin',
	'slideshowGroup',
	'easing',
	'easingClose',
	'fadeInOut',
	'src'
],
overlays : [],
idCounter : 0,
oPos : {
	x: ['leftpanel', 'left', 'center', 'right', 'rightpanel'],
	y: ['above', 'top', 'middle', 'bottom', 'below']
},
mouse: {},
headingOverlay: {},
captionOverlay: {},
swfOptions: { flashvars: {}, params: {}, attributes: {} },
timers : [],

slideshows : [],

pendingOutlines : {},
sleeping : [],
preloadTheseAjax : [],
cacheBindings : [],
cachedGets : {},
clones : {},
onReady: [],
uaVersion: /Trident\/4\.0/.test(navigator.userAgent) ? 8 :
	parseFloat((navigator.userAgent.toLowerCase().match( /.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/ ) || [0,'0'])[1]),
ie : (document.all && !window.opera),
safari : /Safari/.test(navigator.userAgent),
geckoMac : /Macintosh.+rv:1\.[0-8].+Gecko/.test(navigator.userAgent),

$ : function (id){
	if(id) return document.getElementById(id);
},
push : function (arr, val){
	arr[arr.length] = val;
},

createElement : function (tag, attribs, styles, parent, nopad){
	var el = document.createElement(tag);
	if(attribs) hs.extend(el, attribs);
	if(nopad) hs.setStyles(el, {padding: 0, border: 'none', margin: 0});
	if(styles) hs.setStyles(el, styles);
	if(parent) parent.appendChild(el);
	return el;
},

extend : function (el, attribs){
	for(var x in attribs) el[x] = attribs[x];
	return el;
},

setStyles : function (el, styles){
	for(var x in styles){
		if(hs.ie && x == 'opacity'){
			if(styles[x] > 0.99) el.style.removeAttribute('filter');
			else el.style.filter = 'alpha(opacity='+ (styles[x] * 100) +')';
		}
		else el.style[x] = styles[x];
	}
},
animate: function(el, prop, opt){
	var start,
		end,
		unit;
	if(typeof opt != 'object' || opt === null){
		var args = arguments;
		opt = {
			duration: args[2],
			easing: args[3],
			complete: args[4]
		};
	}
	if(typeof opt.duration != 'number') opt.duration = 250;
	opt.easing = Math[opt.easing] || Math.easeInQuad;
	opt.curAnim = hs.extend({}, prop);
	for(var name in prop){
		var e = new hs.fx(el, opt , name );

		start = parseFloat(hs.css(el, name)) || 0;
		end = parseFloat(prop[name]);
		unit = name != 'opacity' ? 'px' : '';

		e.custom( start, end, unit );
	}
},
css: function(el, prop){
	if(el.style[prop]){
		return el.style[prop];
	} else if(document.defaultView){
		return document.defaultView.getComputedStyle(el, null).getPropertyValue(prop);

	} else{
		if(prop == 'opacity') prop = 'filter';
		var val = el.currentStyle[prop.replace(/\-(\w)/g, function (a, b){ return b.toUpperCase(); })];
		if(prop == 'filter')
			val = val.replace(/alpha\(opacity=([0-9]+)\)/,
				function (a, b){ return b / 100 });
		return val === '' ? 1 : val;
	}
},

getPageSize : function (){
	var d = document, w = window, iebody = d.compatMode && d.compatMode != 'BackCompat'
		? d.documentElement : d.body;

	var width = hs.ie ? iebody.clientWidth :
			(d.documentElement.clientWidth || self.innerWidth),
		height = hs.ie ? iebody.clientHeight : self.innerHeight;

	hs.page = {
		width: width,
		height: height,
		scrollLeft: hs.ie ? iebody.scrollLeft : pageXOffset,
		scrollTop: hs.ie ? iebody.scrollTop : pageYOffset
	};
	return hs.page;
},

getPosition : function(el)	{
	if(/area/i.test(el.tagName)){
		var imgs = document.getElementsByTagName('img');
		for(var i = 0; i < imgs.length; i++){
			var u = imgs[i].useMap;
			if(u && u.replace(/^.*?#/, '') == el.parentNode.name){
				el = imgs[i];
				break;
			}
		}
	}
	var p = { x: el.offsetLeft, y: el.offsetTop };
	while (el.offsetParent)	{
		el = el.offsetParent;
		p.x += el.offsetLeft;
		p.y += el.offsetTop;
		if(el != document.body && el != document.documentElement){
			p.x -= el.scrollLeft;
			p.y -= el.scrollTop;
		}
	}
	return p;
},

expand : function(a, params, custom, type){
	if(!a) a = hs.createElement('a', null, { display: 'none' }, hs.container);
	if(typeof a.getParams == 'function') return params;
	if(type == 'html'){
		for(var i = 0; i < hs.sleeping.length; i++){
			if(hs.sleeping[i] && hs.sleeping[i].a == a){
				hs.sleeping[i].awake();
				hs.sleeping[i] = null;
				return false;
			}
		}
		hs.hasHtmlExpanders = true;
	}
	try {
		new hs.Expander(a, params, custom, type);
		return false;
	} catch (e){ return true; }
},

htmlExpand : function(a, params, custom){
	return hs.expand(a, params, custom, 'html');
},

getSelfRendered : function(){
	document.body.classList.add('removeScrollBody');
	return hs.createElement('div', {
		className: 'highslide-html-content',
		innerHTML: hs.replaceLang(hs.skin.contentWrapper)
	});
},
getElementByClass : function (el, tagName, className){
	var els = el.getElementsByTagName(tagName);
	for(var i = 0; i < els.length; i++){
    	if((new RegExp(className)).test(els[i].className)){
			return els[i];
		}
	}
	return null;
},
replaceLang : function(s){
	s = s.replace(/\s/g, ' ');
	var re = /{hs\.lang\.([^}]+)\}/g,
		matches = s.match(re),
		lang;
	if(matches) for(var i = 0; i < matches.length; i++){
		lang = matches[i].replace(re, "$1");
		if(typeof hs.lang[lang] != 'undefined') s = s.replace(matches[i], hs.lang[lang]);
	}
	return s;
},


setClickEvents : function (){
	var els = document.getElementsByTagName('a');
	for(var i = 0; i < els.length; i++){
		var type = hs.isUnobtrusiveAnchor(els[i]);
		if(type && !els[i].hsHasSetClick){
			(function(){
				var t = type;
				if(hs.fireEvent(hs, 'onSetClickEvent', { element: els[i], type: t })){
					els[i].onclick =(type == 'image') ?function(){ return hs.expand(this) }:
						function(){ return hs.htmlExpand(this, { objectType: t } );};
				}
			})();
			els[i].hsHasSetClick = true;
		}
	}
	hs.getAnchors();
},
isUnobtrusiveAnchor: function(el){
	if(el.rel == 'highslide') return 'image';
	else if(el.rel == 'highslide-ajax') return 'ajax';
	else if(el.rel == 'highslide-iframe') return 'iframe';
	else if(el.rel == 'highslide-swf') return 'swf';
},

getCacheBinding : function (a){
	for(var i = 0; i < hs.cacheBindings.length; i++){
		if(hs.cacheBindings[i][0] == a){
			var c = hs.cacheBindings[i][1];
			hs.cacheBindings[i][1] = c.cloneNode(1);
			return c;
		}
	}
	return null;
},

preloadAjax : function (e){
	var arr = hs.getAnchors();
	for(var i = 0; i < arr.htmls.length; i++){
		var a = arr.htmls[i];
		if(hs.getParam(a, 'objectType') == 'ajax' && hs.getParam(a, 'cacheAjax'))
			hs.push(hs.preloadTheseAjax, a);
	}

	hs.preloadAjaxElement(0);
},

preloadAjaxElement : function (i){
	if(!hs.preloadTheseAjax[i]) return;
	var a = hs.preloadTheseAjax[i];
	var cache = hs.getNode(hs.getParam(a, 'contentId'));
	if(!cache) cache = hs.getSelfRendered();
	var ajax = new hs.Ajax(a, cache, 1);
   	ajax.onError = function (){ };
   	ajax.onLoad = function (){
   		hs.push(hs.cacheBindings, [a, cache]);
   		hs.preloadAjaxElement(i + 1);
   	};
   	ajax.run();
},

focusTopmost : function(){
	var topZ = 0,
		topmostKey = -1,
		expanders = hs.expanders,
		exp,
		zIndex;
	for(var i = 0; i < expanders.length; i++){
		exp = expanders[i];
		if(exp){
			zIndex = exp.wrapper.style.zIndex;
			if(zIndex && zIndex > topZ){
				topZ = zIndex;
				topmostKey = i;
			}
		}
	}
	if(topmostKey == -1) hs.focusKey = -1;
	else expanders[topmostKey].focus();
},

getParam : function (a, param){
	a.getParams = a.onclick;
	var p = a.getParams ? a.getParams() : null;
	a.getParams = null;

	return (p && typeof p[param] != 'undefined') ? p[param] :
		(typeof hs[param] != 'undefined' ? hs[param] : null);
},

getSrc : function (a){
	var src = hs.getParam(a, 'src');
	if(src) return src;
	return a.href;
},

getNode : function (id){
	var node = hs.$(id), clone = hs.clones[id], a = {};
	if(!node && !clone) return null;
	if(!clone){
		clone = node.cloneNode(true);
		clone.id = '';
		hs.clones[id] = clone;
		return node;
	} else{
		return clone.cloneNode(true);
	}
},

discardElement : function(d){
	if(d) hs.garbageBin.appendChild(d);
	hs.garbageBin.innerHTML = '';
},
dim : function(exp){
	if(!hs.dimmer){
		hs.dimmer = hs.createElement ('div', {
				className: 'highslide-dimming highslide-viewport-size',
				owner: '',
				onclick: function(){
					if(hs.fireEvent(hs, 'onDimmerClick'))

						hs.close();
				}
			}, {
                visibility: 'visible',
				opacity: 0
			}, hs.container, true);
	}

	hs.dimmer.style.display = '';

	hs.dimmer.owner += '|'+ exp.key;
	if(hs.geckoMac && hs.dimmingGeckoFix)
		hs.setStyles(hs.dimmer, {
			background: 'url('+ hs.graphicsDir + 'geckodimmer.png)',
			opacity: 1
		});
	else
		hs.animate(hs.dimmer, { opacity: exp.dimmingOpacity }, hs.dimmingDuration);
},
undim : function(key){
	if(!hs.dimmer) return;
	if(typeof key != 'undefined') hs.dimmer.owner = hs.dimmer.owner.replace('|'+ key, '');

	if(
		(typeof key != 'undefined' && hs.dimmer.owner != '')
		|| (hs.upcoming && hs.getParam(hs.upcoming, 'dimmingOpacity'))
	) return;

	if(hs.geckoMac && hs.dimmingGeckoFix) hs.dimmer.style.display = 'none';
	else hs.animate(hs.dimmer, { opacity: 0 }, hs.dimmingDuration, null, function(){
		hs.dimmer.style.display = 'none';
	});
},
transit : function (adj, exp){
	var last = exp || hs.getExpander();
	exp = last;
	if(hs.upcoming) return false;
	else hs.last = last;
	hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
	try {
		hs.upcoming = adj;
		adj.onclick();
	} catch (e){
		hs.last = hs.upcoming = null;
	}
	try {
		if(!adj || exp.transitions[1] != 'crossfade')
		exp.close();
	} catch (e){}
	return false;
},

previousOrNext : function (el, op){
	var exp = hs.getExpander(el);
	if(exp) return hs.transit(exp.getAdjacentAnchor(op), exp);
	else return false;
},

previous : function (el){
	return hs.previousOrNext(el, -1);
},

next : function (el){
	return hs.previousOrNext(el, 1);
},

keyHandler : function(e){
	if(!e) e = window.event;
	if(!e.target) e.target = e.srcElement; // ie
	if(typeof e.target.form != 'undefined') return true; // form element has focus
	if(!hs.fireEvent(hs, 'onKeyDown', e)) return true;
	var exp = hs.getExpander();

	var op = null;
	switch (e.keyCode){
		case 70: // f
			if(exp) exp.doFullExpand();
			return true;
		case 32: // Space
			op = 2;
			break;
		case 34: // Page Down
		case 39: // Arrow right
		case 40: // Arrow down
			op = 1;
			break;
		case 8:  // Backspace
		case 33: // Page Up
		case 37: // Arrow left
		case 38: // Arrow up
			op = -1;
			break;
		case 27: // Escape
		case 13: // Enter
			op = 0;
	}
	if(op !== null){
		hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
		if(!hs.enableKeyListener) return true;

		if(e.preventDefault) e.preventDefault();
    	else e.returnValue = false;
    	if(exp){
			if(op == 0){
				exp.close();
			} else if(op == 2){
				if(exp.slideshow) exp.slideshow.hitSpace();
			} else{
				if(exp.slideshow) exp.slideshow.pause();
				hs.previousOrNext(exp.key, op);
			}
			return false;
		}
	}
	return true;
},


registerOverlay : function (overlay){
	hs.push(hs.overlays, hs.extend(overlay, { hsId: 'hsId'+ hs.idCounter++ } ));
},


addSlideshow : function (options){
	var sg = options.slideshowGroup;
	if(typeof sg == 'object'){
		for(var i = 0; i < sg.length; i++){
			var o = {};
			for(var x in options) o[x] = options[x];
			o.slideshowGroup = sg[i];
			hs.push(hs.slideshows, o);
		}
	} else{
		hs.push(hs.slideshows, options);
	}
},

getWrapperKey : function (element, expOnly){
	var el, re = /^highslide-wrapper-([0-9]+)$/;
	// 1. look in open expanders
	el = element;
	while (el.parentNode)	{
		if(el.hsKey !== undefined) return el.hsKey;
		if(el.id && re.test(el.id)) return el.id.replace(re, "$1");
		el = el.parentNode;
	}
	// 2. look in thumbnail
	if(!expOnly){
		el = element;
		while (el.parentNode)	{
			if(el.tagName && hs.isHsAnchor(el)){
				for(var key = 0; key < hs.expanders.length; key++){
					var exp = hs.expanders[key];
					if(exp && exp.a == el) return key;
				}
			}
			el = el.parentNode;
		}
	}
	return null;
},

getExpander : function (el, expOnly){
	if(typeof el == 'undefined') return hs.expanders[hs.focusKey] || null;
	if(typeof el == 'number') return hs.expanders[el] || null;
	if(typeof el == 'string') el = hs.$(el);
	return hs.expanders[hs.getWrapperKey(el, expOnly)] || null;
},

isHsAnchor : function (a){
	return (a.onclick && a.onclick.toString().replace(/\s/g, ' ').match(/hs.(htmlE|e)xpand/));
},

reOrder : function (){
	for(var i = 0; i < hs.expanders.length; i++)
		if(hs.expanders[i] && hs.expanders[i].isExpanded) hs.focusTopmost();
},
fireEvent : function (obj, evt, args){
	return obj && obj[evt] ? (obj[evt](obj, args) !== false) : true;
},

mouseClickHandler : function(e)
{
	if(!e) e = window.event;
	if(e.button > 1) return true;
	if(!e.target) e.target = e.srcElement;

	var el = e.target;
	while (el.parentNode
		&& !(/highslide-(image|move|html|resize)/.test(el.className)))
	{
		el = el.parentNode;
	}
	var exp = hs.getExpander(el);
	if(exp && (exp.isClosing || !exp.isExpanded)) return true;

	if(exp && e.type == 'mousedown'){
		if(e.target.form) return true;
		var match = el.className.match(/highslide-(image|move|resize)/);
		if(match){
			hs.dragArgs = {
				exp: exp ,
				type: match[1],
				left: exp.x.pos,
				width: exp.x.size,
				top: exp.y.pos,
				height: exp.y.size,
				clickX: e.clientX,
				clickY: e.clientY
			};


			hs.addEventListener(document, 'mousemove', hs.dragHandler);
			if(e.preventDefault) e.preventDefault(); // FF

			if(/highslide-(image|html)-blur/.test(exp.content.className)){
				exp.focus();
				hs.hasFocused = true;
			}
			return false;
		}
		else if(/highslide-html/.test(el.className) && hs.focusKey != exp.key){
			exp.focus();
			exp.doShowHide('hidden');
		}
	} else if(e.type == 'mouseup'){

		hs.removeEventListener(document, 'mousemove', hs.dragHandler);

		if(hs.dragArgs){
			if(hs.styleRestoreCursor && hs.dragArgs.type == 'image')
				hs.dragArgs.exp.content.style.cursor = hs.styleRestoreCursor;
			var hasDragged = hs.dragArgs.hasDragged;

			if(!hasDragged &&!hs.hasFocused && !/(move|resize)/.test(hs.dragArgs.type)){
				if(hs.fireEvent(exp, 'onImageClick'))
				exp.close();
			}
			else if(hasDragged || (!hasDragged && hs.hasHtmlExpanders)){
				hs.dragArgs.exp.doShowHide('hidden');
			}

			if(hs.dragArgs.exp.releaseMask)
				hs.dragArgs.exp.releaseMask.style.display = 'none';

			if(hasDragged) hs.fireEvent(hs.dragArgs.exp, 'onDrop', hs.dragArgs);
			hs.hasFocused = false;
			hs.dragArgs = null;

		} else if(/highslide-image-blur/.test(el.className)){
			el.style.cursor = hs.styleRestoreCursor;
		}
	}
	return false;
},

dragHandler : function(e)
{
	if(!hs.dragArgs) return true;
	if(!e) e = window.event;
	var a = hs.dragArgs, exp = a.exp;
	if(exp.iframe){
		if(!exp.releaseMask) exp.releaseMask = hs.createElement('div', null,
			{ position: 'absolute', width: exp.x.size+'px', height: exp.y.size+'px',
				left: exp.x.cb+'px', top: exp.y.cb+'px', zIndex: 4,	background: (hs.ie ? 'white' : 'none'),
				opacity: 0.01 },
			exp.wrapper, true);
		if(exp.releaseMask.style.display == 'none')
			exp.releaseMask.style.display = '';
	}

	a.dX = e.clientX - a.clickX;
	a.dY = e.clientY - a.clickY;

	var distance = Math.sqrt(Math.pow(a.dX, 2) + Math.pow(a.dY, 2));
	if(!a.hasDragged) a.hasDragged = (a.type != 'image' && distance > 0)
		|| (distance > (hs.dragSensitivity || 5));

	if(a.hasDragged && e.clientX > 5 && e.clientY > 5){
		if(!hs.fireEvent(exp, 'onDrag', a)) return false;

		if(a.type == 'resize') exp.resize(a);
		else{
			exp.moveTo(a.left + a.dX, a.top + a.dY);
			if(a.type == 'image') exp.content.style.cursor = 'move';
		}
	}
	return false;
},

wrapperMouseHandler : function (e){
	try {
		if(!e) e = window.event;
		var over = /mouseover/i.test(e.type);
		if(!e.target) e.target = e.srcElement; // ie
		if(hs.ie) e.relatedTarget =
			over ? e.fromElement : e.toElement; // ie
		var exp = hs.getExpander(e.target);
		if(!exp.isExpanded) return;
		if(!exp || !e.relatedTarget || hs.getExpander(e.relatedTarget, true) == exp
			|| hs.dragArgs) return;
		hs.fireEvent(exp, over ? 'onMouseOver' : 'onMouseOut', e);
		for(var i = 0; i < exp.overlays.length; i++) (function(){
			var o = hs.$('hsId'+ exp.overlays[i]);
			if(o && o.hideOnMouseOut){
				if(over) hs.setStyles(o, { visibility: 'visible', display: '' });
				hs.animate(o, { opacity: over ? o.opacity : 0 }, o.dur);
			}
		})();
	} catch (e){}
},
addEventListener : function (el, event, func){
	if(el == document && event == 'ready'){
		hs.push(hs.onReady, func);
	}
	try {
		el.addEventListener(event, func, false);
	} catch (e){
		try {
			el.detachEvent('on'+ event, func);
			el.attachEvent('on'+ event, func);
		} catch (e){
			el['on'+ event] = func;
		}
	}
},

removeEventListener : function (el, event, func){
	try {
		el.removeEventListener(event, func, false);
	} catch (e){
		try {
			el.detachEvent('on'+ event, func);
		} catch (e){
			el['on'+ event] = null;
		}
	}
},

preloadFullImage : function (i){
	if(hs.continuePreloading && hs.preloadTheseImages[i] && hs.preloadTheseImages[i] != 'undefined'){
		var img = document.createElement('img');
		img.onload = function(){
			img = null;
			hs.preloadFullImage(i + 1);
		};
		img.src = hs.preloadTheseImages[i];
	}
},
preloadImages : function (number){
	if(number && typeof number != 'object') hs.numberOfImagesToPreload = number;

	var arr = hs.getAnchors();
	for(var i = 0; i < arr.images.length && i < hs.numberOfImagesToPreload; i++){
		hs.push(hs.preloadTheseImages, hs.getSrc(arr.images[i]));
	}

	// preload outlines
	if(hs.outlineType)	new hs.Outline(hs.outlineType, function (){ hs.preloadFullImage(0)} );
	else

	hs.preloadFullImage(0);

	// preload cursor
	if(hs.restoreCursor) var cur = hs.createElement('img', { src: hs.graphicsDir + hs.restoreCursor });
},


init : function (){
	if(!hs.container){

		hs.getPageSize();
		hs.ieLt7 = hs.ie && hs.uaVersion < 7;
		hs.ie6SSL = hs.ieLt7 && location.protocol == 'https:';
		for(var x in hs.langDefaults){
			if(typeof hs[x] != 'undefined') hs.lang[x] = hs[x];
			else if(typeof hs.lang[x] == 'undefined' && typeof hs.langDefaults[x] != 'undefined')
				hs.lang[x] = hs.langDefaults[x];
		}

		hs.container = hs.createElement('div', {
				className: 'highslide-container'
			}, {
				position: 'absolute',
				left: 0,
				top: 0,
				width: '100%',
				zIndex: hs.zIndexCounter,
				direction: 'ltr'
			},
			document.body,
			true
		);
		hs.loading = hs.createElement('a', {
				className: 'highslide-loading',
				title: hs.lang.loadingTitle,
				innerHTML: hs.lang.loadingText,
				href: 'javascript:;'
			}, {
				position: 'absolute',
				top: '-9999px',
				opacity: hs.loadingOpacity,
				zIndex: 1
			}, hs.container
		);
		hs.garbageBin = hs.createElement('div', null, { display: 'none' }, hs.container);
		hs.viewport = hs.createElement('div', {
				className: 'highslide-viewport highslide-viewport-size'
			}, {
				visibility: (hs.safari && hs.uaVersion < 525) ? 'visible' : 'hidden'
			}, hs.container, 1
		);
		hs.clearing = hs.createElement('div', null,
			{ clear: 'both', paddingTop: '1px' }, null, true);

		// http://www.robertpenner.com/easing/
		Math.linearTween = function (t, b, c, d){
			return c*t/d + b;
		};
		Math.easeInQuad = function (t, b, c, d){
			return c*(t/=d)*t + b;
		};
		Math.easeOutQuad = function (t, b, c, d){
			return -c *(t/=d)*(t-2) + b;
		};

		hs.hideSelects = hs.ieLt7;
		hs.hideIframes = ((window.opera && hs.uaVersion < 9) || navigator.vendor == 'KDE'
			|| (hs.ie && hs.uaVersion < 5.5));
		hs.fireEvent(this, 'onActivate');
	}
},
ready : function(){
	if(hs.isReady) return;
	hs.isReady = true;
	for(var i = 0; i < hs.onReady.length; i++) hs.onReady[i]();
},

updateAnchors : function(){
	var el, els, all = [], images = [], htmls = [],groups = {}, re;

	for(var i = 0; i < hs.openerTagNames.length; i++){
		els = document.getElementsByTagName(hs.openerTagNames[i]);
		for(var j = 0; j < els.length; j++){
			el = els[j];
			re = hs.isHsAnchor(el);
			if(re){
				hs.push(all, el);
				if(re[0] == 'hs.expand') hs.push(images, el);
				else if(re[0] == 'hs.htmlExpand') hs.push(htmls, el);
				var g = hs.getParam(el, 'slideshowGroup') || 'none';
				if(!groups[g]) groups[g] = [];
				hs.push(groups[g], el);
			}
		}
	}
	hs.anchors = { all: all, groups: groups, images: images, htmls: htmls };
	return hs.anchors;

},

getAnchors : function(){
	return hs.anchors || hs.updateAnchors();
},


close : function(el){
	var exp = hs.getExpander(el);
	if(exp) exp.close();
	return false;
}
}; // end hs object
hs.fx = function( elem, options, prop ){
	this.options = options;
	this.elem = elem;
	this.prop = prop;

	if(!options.orig) options.orig = {};
};
hs.fx.prototype = {
	update: function(){
		(hs.fx.step[this.prop] || hs.fx.step._default)(this);

		if(this.options.step)
			this.options.step.call(this.elem, this.now, this);

	},
	custom: function(from, to, unit){
		this.startTime = (new Date()).getTime();
		this.start = from;
		this.end = to;
		this.unit = unit;// || this.unit || "px";
		this.now = this.start;
		this.pos = this.state = 0;

		var self = this;
		function t(gotoEnd){
			return self.step(gotoEnd);
		}

		t.elem = this.elem;

		if( t() && hs.timers.push(t) == 1 ){
			hs.timerId = setInterval(function(){
				var timers = hs.timers;

				for( var i = 0; i < timers.length; i++ )
					if( !timers[i]() )
						timers.splice(i--, 1);

				if( !timers.length ){
					clearInterval(hs.timerId);
				}
			}, 13);
		}
	},
	step: function(gotoEnd){
		var t = (new Date()).getTime();
		if( gotoEnd || t >= this.options.duration + this.startTime ){
			this.now = this.end;
			this.pos = this.state = 1;
			this.update();

			this.options.curAnim[ this.prop ] = true;

			var done = true;
			for( var i in this.options.curAnim )
				if( this.options.curAnim[i] !== true )
					done = false;

			if( done ){
				if(this.options.complete) this.options.complete.call(this.elem);
			}
			return false;
		} else{
			var n = t - this.startTime;
			this.state = n / this.options.duration;
			this.pos = this.options.easing(n, 0, 1, this.options.duration);
			this.now = this.start + ((this.end - this.start) * this.pos);
			this.update();
		}
		return true;
	}

};

hs.extend( hs.fx, {
	step: {

		opacity: function(fx){
			hs.setStyles(fx.elem, { opacity: fx.now });
		},

		_default: function(fx){
			try {
				if( fx.elem.style && fx.elem.style[ fx.prop ] != null )
					fx.elem.style[ fx.prop ] = fx.now + fx.unit;
				else
					fx.elem[ fx.prop ] = fx.now;
			} catch (e){}
		}
	}
});

hs.Outline =  function (outlineType, onLoad){
	this.onLoad = onLoad;
	this.outlineType = outlineType;
	var v = hs.uaVersion, tr;

	this.hasAlphaImageLoader = hs.ie && v >= 5.5 && v < 7;
	if(!outlineType){
		if(onLoad) onLoad();
		return;
	}

	hs.init();
	this.table = hs.createElement(
		'table', {
			cellSpacing: 0
		}, {
			visibility: 'hidden',
			position: 'absolute',
			borderCollapse: 'collapse',
			width: 0
		},
		hs.container,
		true
	);
	var tbody = hs.createElement('tbody', null, null, this.table, 1);

	this.td = [];
	for(var i = 0; i <= 8; i++){
		if(i % 3 == 0) tr = hs.createElement('tr', null, { height: 'auto' }, tbody, true);
		this.td[i] = hs.createElement('td', null, null, tr, true);
		var style = i != 4 ? { lineHeight: 0, fontSize: 0} : { position : 'relative' };
		hs.setStyles(this.td[i], style);
	}
	this.td[4].className = outlineType +' highslide-outline';

	this.preloadGraphic();
};

hs.Outline.prototype = {
preloadGraphic : function (){
	var src = hs.graphicsDir + (hs.outlinesDir || "outlines/")+ this.outlineType +".png";

	var appendTo = hs.safari ? hs.container : null;
	this.graphic = hs.createElement('img', null, { position: 'absolute',
		top: '-9999px' }, appendTo, true); // for onload trigger

	var pThis = this;
	this.graphic.onload = function(){ pThis.onGraphicLoad(); };

	this.graphic.src = src;
	this.graphic.alt = "drop-shadow";
},

onGraphicLoad : function (){
	var o = this.offset = this.graphic.width / 4,
		pos = [[0,0],[0,-4],[-2,0],[0,-8],0,[-2,-8],[0,-2],[0,-6],[-2,-2]],
		dim = { height: (2*o) +'px', width: (2*o) +'px' };
	for(var i = 0; i <= 8; i++){
		if(pos[i]){
			if(this.hasAlphaImageLoader){
				var w = (i == 1 || i == 7) ? '100%' : this.graphic.width +'px';
				var div = hs.createElement('div', null, { width: '100%', height: '100%', position: 'relative', overflow: 'hidden'}, this.td[i], true);
				hs.createElement ('div', null, {
						filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod=scale, src='"+ this.graphic.src + "')",
						position: 'absolute',
						width: w,
						height: this.graphic.height +'px',
						left: (pos[i][0]*o)+'px',
						top: (pos[i][1]*o)+'px'
					},
				div,
				true);
			} else{
				hs.setStyles(this.td[i], { background: 'url('+ this.graphic.src +') '+ (pos[i][0]*o)+'px '+(pos[i][1]*o)+'px'});
			}

			if(window.opera && (i == 3 || i ==5))
				hs.createElement('div', null, dim, this.td[i], true);

			hs.setStyles (this.td[i], dim);
		}
	}
	this.graphic = null;
	if(hs.pendingOutlines[this.outlineType]) hs.pendingOutlines[this.outlineType].destroy();
	hs.pendingOutlines[this.outlineType] = this;
	if(this.onLoad) this.onLoad();
},

setPosition : function (pos, offset, vis, dur, easing){
	var exp = this.exp,
		stl = exp.wrapper.style,
		offset = offset || 0,
		pos = pos || {
			x: exp.x.pos + offset,
			y: exp.y.pos + offset,
			w: exp.x.get('wsize') - 2 * offset,
			h: exp.y.get('wsize') - 2 * offset
		};
	if(vis) this.table.style.visibility = (pos.h >= 4 * this.offset)
		? 'visible' : 'hidden';
	hs.setStyles(this.table, {
		left: (pos.x - this.offset) +'px',
		top: (pos.y - this.offset) +'px',
		width: (pos.w + 2 * this.offset) +'px'
	});

	pos.w -= 2 * this.offset;
	pos.h -= 2 * this.offset;
	hs.setStyles (this.td[4], {
		width: pos.w >= 0 ? pos.w +'px' : 0,
		height: pos.h >= 0 ? pos.h +'px' : 0
	});
	if(this.hasAlphaImageLoader) this.td[3].style.height
		= this.td[5].style.height = this.td[4].style.height;

},

destroy : function(hide){
	if(hide) this.table.style.visibility = 'hidden';
	else hs.discardElement(this.table);
}
};

hs.Dimension = function(exp, dim){
	this.exp = exp;
	this.dim = dim;
	this.ucwh = dim == 'x' ? 'Width' : 'Height';
	this.wh = this.ucwh.toLowerCase();
	this.uclt = dim == 'x' ? 'Left' : 'Top';
	this.lt = this.uclt.toLowerCase();
	this.ucrb = dim == 'x' ? 'Right' : 'Bottom';
	this.rb = this.ucrb.toLowerCase();
	this.p1 = this.p2 = 0;
};
hs.Dimension.prototype = {
get : function(key){
	switch (key){
		case 'loadingPos':
			return this.tpos + this.tb + (this.t - hs.loading['offset'+ this.ucwh]) / 2;
		case 'loadingPosXfade':
			return this.pos + this.cb+ this.p1 + (this.size - hs.loading['offset'+ this.ucwh]) / 2;
		case 'wsize':
			return this.size + 2 * this.cb + this.p1 + this.p2;
		case 'fitsize':
			return this.clientSize - this.marginMin - this.marginMax;
		case 'maxsize':
			return this.get('fitsize') - 2 * this.cb - this.p1 - this.p2 ;
		case 'opos':
			return this.pos - (this.exp.outline ? this.exp.outline.offset : 0);
		case 'osize':
			return this.get('wsize') + (this.exp.outline ? 2*this.exp.outline.offset : 0);
		case 'imgPad':
			return this.imgSize ? Math.round((this.size - this.imgSize) / 2) : 0;

	}
},
calcBorders: function(){
	// correct for borders
	this.cb = (this.exp.content['offset'+ this.ucwh] - this.t) / 2;

	this.marginMax = hs['margin'+ this.ucrb];
},
calcThumb: function(){
	this.t = this.exp.el[this.wh] ? parseInt(this.exp.el[this.wh]) :
		this.exp.el['offset'+ this.ucwh];
	this.tpos = this.exp.tpos[this.dim];
	this.tb = (this.exp.el['offset'+ this.ucwh] - this.t) / 2;
	if(this.tpos == 0 || this.tpos == -1){
		this.tpos = (hs.page[this.wh] / 2) + hs.page['scroll'+ this.uclt];
	};
},
calcExpanded: function(){
	var exp = this.exp;
	this.justify = 'auto';

	// get alignment
	if(exp.align == 'center') this.justify = 'center';
	else if(new RegExp(this.lt).test(exp.anchor)) this.justify = null;
	else if(new RegExp(this.rb).test(exp.anchor)) this.justify = 'max';


	// size and position
	this.pos = this.tpos - this.cb + this.tb;

	if(this.maxHeight && this.dim == 'x')
		exp.maxWidth = Math.min(exp.maxWidth || this.full, exp.maxHeight * this.full / exp.y.full);

	this.size = Math.min(this.full, exp['max'+ this.ucwh] || this.full);
	this.minSize = exp.allowSizeReduction ?
		Math.min(exp['min'+ this.ucwh], this.full) :this.full;
	if(exp.isImage && exp.useBox)	{
		this.size = exp[this.wh];
		this.imgSize = this.full;
	}
	if(this.dim == 'x' && hs.padToMinWidth) this.minSize = exp.minWidth;
	this.target = exp['target'+ this.dim.toUpperCase()];
	this.marginMin = hs['margin'+ this.uclt];
	this.scroll = hs.page['scroll'+ this.uclt];
	this.clientSize = hs.page[this.wh];
},
setSize: function(i){
	var exp = this.exp;
	if(exp.isImage && (exp.useBox || hs.padToMinWidth)){
		this.imgSize = i;
		this.size = Math.max(this.size, this.imgSize);
		exp.content.style[this.lt] = this.get('imgPad')+'px';
	} else
	this.size = i;

	exp.content.style[this.wh] = i +'px';
	exp.wrapper.style[this.wh] = this.get('wsize') +'px';
	if(exp.outline) exp.outline.setPosition();
	if(exp.releaseMask) exp.releaseMask.style[this.wh] = i +'px';
	if(this.dim == 'y' && exp.iDoc && exp.body.style.height != 'auto') try {
		exp.iDoc.body.style.overflow = 'auto';
	} catch (e){}
	if(exp.isHtml){
		var d = exp.scrollerDiv;
		if(this.sizeDiff === undefined)
			this.sizeDiff = exp.innerContent['offset'+ this.ucwh] - d['offset'+ this.ucwh];
		d.style[this.wh] = (this.size - this.sizeDiff) +'px';

		if(this.dim == 'x') exp.mediumContent.style.width = 'auto';
		if(exp.body) exp.body.style[this.wh] = 'auto';
	}
	if(this.dim == 'x' && exp.overlayBox) exp.sizeOverlayBox(true);
	if(this.dim == 'x' && exp.slideshow && exp.isImage){
		if(i == this.full) exp.slideshow.disable('full-expand');
		else exp.slideshow.enable('full-expand');
	}
},
setPos: function(i){
	this.pos = i;
	this.exp.wrapper.style[this.lt] = i +'px';

	if(this.exp.outline) this.exp.outline.setPosition();

}
};

hs.Expander = function(a, params, custom, contentType){
	if(document.readyState && hs.ie && !hs.isReady){
		hs.addEventListener(document, 'ready', function(){
			new hs.Expander(a, params, custom, contentType);
		});
		return;
	}
	this.a = a;
	this.custom = custom;
	this.contentType = contentType || 'image';
	this.isHtml = (contentType == 'html');
	this.isImage = !this.isHtml;

	hs.continuePreloading = false;
	this.overlays = [];
	this.last = hs.last;
	hs.last = null;
	hs.init();
	var key = this.key = hs.expanders.length;
	// override inline parameters
	for(var i = 0; i < hs.overrides.length; i++){
		var name = hs.overrides[i];
		this[name] = params && typeof params[name] != 'undefined' ?
			params[name] : hs[name];
	}
	if(!this.src) this.src = a.href;

	// get thumb
	var el = (params && params.thumbnailId) ? hs.$(params.thumbnailId) : a;
	el = this.thumb = el.getElementsByTagName('img')[0] || el;
	this.thumbsUserSetId = el.id || a.id;
	if(!hs.fireEvent(this, 'onInit')) return true;

	// check if already open
	for(var i = 0; i < hs.expanders.length; i++){
		if(hs.expanders[i] && hs.expanders[i].a == a
			&& !(this.last && this.transitions[1] == 'crossfade')){
			hs.expanders[i].focus();
			return false;
		}
	}

	// cancel other
	if(!hs.allowSimultaneousLoading) for(var i = 0; i < hs.expanders.length; i++){
		if(hs.expanders[i] && hs.expanders[i].thumb != el && !hs.expanders[i].onLoadStarted){
			hs.expanders[i].cancelLoading();
		}
	}
	hs.expanders[key] = this;
	if(!hs.allowMultipleInstances && !hs.upcoming){
		if(hs.expanders[key-1]) hs.expanders[key-1].close();
		if(typeof hs.focusKey != 'undefined' && hs.expanders[hs.focusKey])
			hs.expanders[hs.focusKey].close();
	}

	// initiate metrics
	this.el = el;
	this.tpos = this.pageOrigin || hs.getPosition(el);
	hs.getPageSize();
	var x = this.x = new hs.Dimension(this, 'x');
	x.calcThumb();
	var y = this.y = new hs.Dimension(this, 'y');
	y.calcThumb();
	if(/area/i.test(el.tagName)) this.getImageMapAreaCorrection(el);
	this.wrapper = hs.createElement(
		'div', {
			id: 'highslide-wrapper-'+ this.key,
			className: 'highslide-wrapper '+ this.wrapperClassName
		}, {
			visibility: 'hidden',
			position: 'absolute',
			zIndex: hs.zIndexCounter += 2
		}, null, true );

	this.wrapper.onmouseover = this.wrapper.onmouseout = hs.wrapperMouseHandler;
	if(this.contentType == 'image' && this.outlineWhileAnimating == 2)
		this.outlineWhileAnimating = 0;

	// get the outline
	if(!this.outlineType
		|| (this.last && this.isImage && this.transitions[1] == 'crossfade')){
		this[this.contentType +'Create']();

	} else if(hs.pendingOutlines[this.outlineType]){
		this.connectOutline();
		this[this.contentType +'Create']();

	} else{
		this.showLoading();
		var exp = this;
		new hs.Outline(this.outlineType,
			function (){
				exp.connectOutline();
				exp[exp.contentType +'Create']();
			}
		);
	}
	return true;
};

hs.Expander.prototype = {
error : function(e){
	if(hs.debug) alert ('Line '+ e.lineNumber +': '+ e.message);
	else window.location.href = this.src;
},

connectOutline : function(){
	var outline = this.outline = hs.pendingOutlines[this.outlineType];
	outline.exp = this;
	outline.table.style.zIndex = this.wrapper.style.zIndex - 1;
	hs.pendingOutlines[this.outlineType] = null;
},

showLoading : function(){
	if(this.onLoadStarted || this.loading) return;

	this.loading = hs.loading;
	var exp = this;
	this.loading.onclick = function(){
		exp.cancelLoading();
	};


	if(!hs.fireEvent(this, 'onShowLoading')) return;
	var exp = this,
		l = this.x.get('loadingPos') +'px',
		t = this.y.get('loadingPos') +'px';
	if(!tgt && this.last && this.transitions[1] == 'crossfade')
		var tgt = this.last;
	if(tgt){
		l = tgt.x.get('loadingPosXfade') +'px';
		t = tgt.y.get('loadingPosXfade') +'px';
		this.loading.style.zIndex = hs.zIndexCounter++;
	}
	setTimeout(function (){
		if(exp.loading) hs.setStyles(exp.loading, { left: l, top: t, zIndex: hs.zIndexCounter++ })}
	, 100);
},

imageCreate : function(){
	var exp = this;

	var img = document.createElement('img');
    this.content = img;
    img.onload = function (){
    	if(hs.expanders[exp.key]) exp.contentLoaded();
	};
    if(hs.blockRightClick) img.oncontextmenu = function(){ return false; };
    img.className = 'highslide-image';
    hs.setStyles(img, {
    	visibility: 'hidden',
    	display: 'block',
    	position: 'absolute',
		maxWidth: '9999px',
		zIndex: 3
	});
    img.title = hs.lang.restoreTitle;
    if(hs.safari) hs.container.appendChild(img);
    if(hs.ie && hs.flushImgSize) img.src = null;
	img.src = this.src;

	this.showLoading();
},

htmlCreate : function (){
	if(!hs.fireEvent(this, 'onBeforeGetContent')) return;

	this.content = hs.getCacheBinding(this.a);
	if(!this.content)
		this.content = hs.getNode(this.contentId);
	if(!this.content)
		this.content = hs.getSelfRendered();
	this.getInline(['maincontent']);
	if(this.maincontent){
		var body = hs.getElementByClass(this.content, 'div', 'highslide-body');
		if(body) body.appendChild(this.maincontent);
		this.maincontent.style.display = 'block';
	}
	hs.fireEvent(this, 'onAfterGetContent');

	var innerContent = this.innerContent = this.content;

	if(/(swf|iframe)/.test(this.objectType)) this.setObjContainerSize(innerContent);

	// the content tree
	hs.container.appendChild(this.wrapper);
	hs.setStyles( this.wrapper, {
		position: 'static',
		padding: '0 '+ hs.marginRight +'px 0 '+ hs.marginLeft +'px'
	});
	this.content = hs.createElement(
    	'div', {
    		className: 'highslide-html'
    	}, {
			position: 'relative',
			zIndex: 3,
			height: 0,
			overflow: 'hidden'
		},
		this.wrapper
	);
	this.mediumContent = hs.createElement('div', null, null, this.content, 1);
	this.mediumContent.appendChild(innerContent);

	hs.setStyles (innerContent, {
		position: 'relative',
		display: 'block',
		direction: hs.lang.cssDirection || ''
	});
	if(this.width) innerContent.style.width = this.width +'px';
	if(this.height) hs.setStyles(innerContent, {
		height: this.height +'px',
		overflow: 'hidden'
	});
	if(innerContent.offsetWidth < this.minWidth)
		innerContent.style.width = this.minWidth +'px';



	if(this.objectType == 'ajax' && !hs.getCacheBinding(this.a)){
		this.showLoading();
    	var exp = this;
    	var ajax = new hs.Ajax(this.a, innerContent);
		ajax.src = this.src;
    	ajax.onLoad = function (){	if(hs.expanders[exp.key]) exp.contentLoaded(); };
    	ajax.onError = function (){ location.href = exp.src; };
    	ajax.run();
	}
    else

    if(this.objectType == 'iframe' && this.objectLoadTime == 'before'){
		this.writeExtendedContent();
	}
    else
    	this.contentLoaded();
},

contentLoaded : function(){
	try {
		if(!this.content) return;
		this.content.onload = null;
		if(this.onLoadStarted) return;
		else this.onLoadStarted = true;

		var x = this.x, y = this.y;

		if(this.loading){
			hs.setStyles(this.loading, { top: '-9999px' });
			this.loading = null;
			hs.fireEvent(this, 'onHideLoading');
		}
		if(this.isImage){
			x.full = this.content.width;
			y.full = this.content.height;

			hs.setStyles(this.content, {
				width: x.t +'px',
				height: y.t +'px'
			});
			this.wrapper.appendChild(this.content);
			hs.container.appendChild(this.wrapper);
		} else if(this.htmlGetSize) this.htmlGetSize();

		x.calcBorders();
		y.calcBorders();

		hs.setStyles (this.wrapper, {
			left: (x.tpos + x.tb - x.cb) +'px',
			top: (y.tpos + x.tb - y.cb) +'px'
		});


		this.initSlideshow();
		this.getOverlays();

		var ratio = x.full / y.full;
		x.calcExpanded();
		this.justify(x);

		y.calcExpanded();
		this.justify(y);
		if(this.isHtml) this.htmlSizeOperations();
		if(this.overlayBox) this.sizeOverlayBox(0, 1);


		if(this.allowSizeReduction){
			if(this.isImage)
				this.correctRatio(ratio);
			else this.fitOverlayBox();
			var ss = this.slideshow;
			if(ss && this.last && ss.controls && ss.fixedControls){
				var pos = ss.overlayOptions.position || '', p;
				for(var dim in hs.oPos) for(var i = 0; i < 5; i++){
					p = this[dim];
					if(pos.match(hs.oPos[dim][i])){
						p.pos = this.last[dim].pos
							+ (this.last[dim].p1 - p.p1)
							+ (this.last[dim].size - p.size) * [0, 0, .5, 1, 1][i];
						if(ss.fixedControls == 'fit'){
							if(p.pos + p.size + p.p1 + p.p2 > p.scroll + p.clientSize - p.marginMax)
								p.pos = p.scroll + p.clientSize - p.size - p.marginMin - p.marginMax - p.p1 - p.p2;
							if(p.pos < p.scroll + p.marginMin) p.pos = p.scroll + p.marginMin;
						}
					}
				}
			}
			if(this.isImage && this.x.full > (this.x.imgSize || this.x.size)){
				this.createFullExpand();
				if(this.overlays.length == 1) this.sizeOverlayBox();
			}
		}
		this.show();

	} catch (e){
		this.error(e);
	}
},


setObjContainerSize : function(parent, auto){
	var c = hs.getElementByClass(parent, 'DIV', 'highslide-body');
	if(/(iframe|swf)/.test(this.objectType)){
		if(this.objectWidth) c.style.width = this.objectWidth +'px';
		if(this.objectHeight) c.style.height = this.objectHeight +'px';
	}
},

writeExtendedContent : function (){
	if(this.hasExtendedContent) return;
	var exp = this;
	this.body = hs.getElementByClass(this.innerContent, 'DIV', 'highslide-body');
	if(this.objectType == 'iframe'){
		this.showLoading();
		var ruler = hs.clearing.cloneNode(1);
		this.body.appendChild(ruler);
		this.newWidth = this.innerContent.offsetWidth;
		if(!this.objectWidth) this.objectWidth = ruler.offsetWidth;
		var hDiff = this.innerContent.offsetHeight - this.body.offsetHeight,
			h = this.objectHeight || hs.page.height - hDiff - hs.marginTop - hs.marginBottom,
			onload = this.objectLoadTime == 'before' ?
				' onload="if(hs.expanders['+ this.key +']) hs.expanders['+ this.key +'].contentLoaded()" ' : '';
		this.body.innerHTML += '<iframe name="hs'+ (new Date()).getTime() +'" frameborder="0" key="'+ this.key +'" '
			+' style="width:'+ this.objectWidth +'px; height:'+ h +'px" '
			+ onload +' src="'+ this.src +'"></iframe>';
		this.ruler = this.body.getElementsByTagName('div')[0];
		this.iframe = this.body.getElementsByTagName('iframe')[0];

		if(this.objectLoadTime == 'after') this.correctIframeSize();

	}
	if(this.objectType == 'swf'){
		this.body.id = this.body.id || 'hs-flash-id-' + this.key;
		var a = this.swfOptions;
		if(!a.params) a.params = {};
		if(typeof a.params.wmode == 'undefined') a.params.wmode = 'transparent';
		if(swfobject) swfobject.embedSWF(this.src, this.body.id, this.objectWidth, this.objectHeight,
			a.version || '7', a.expressInstallSwfurl, a.flashvars, a.params, a.attributes);
	}
	this.hasExtendedContent = true;
},
htmlGetSize : function(){
	if(this.iframe && !this.objectHeight){ // loadtime before
		this.iframe.style.height = this.body.style.height = this.getIframePageHeight() +'px';
	}
	this.innerContent.appendChild(hs.clearing);
	if(!this.x.full) this.x.full = this.innerContent.offsetWidth;
    this.y.full = this.innerContent.offsetHeight;
    this.innerContent.removeChild(hs.clearing);
    if(hs.ie && this.newHeight > parseInt(this.innerContent.currentStyle.height)){ // ie css bug
		this.newHeight = parseInt(this.innerContent.currentStyle.height);
	}
	hs.setStyles( this.wrapper, { position: 'absolute',	padding: '0'});
	hs.setStyles( this.content, { width: this.x.t +'px', height: this.y.t +'px'});

},

getIframePageHeight : function(){
	var h;
	try {
		var doc = this.iDoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
		var clearing = doc.createElement('div');
		clearing.style.clear = 'both';
		doc.body.appendChild(clearing);
		h = clearing.offsetTop;
		if(hs.ie) h += parseInt(doc.body.currentStyle.marginTop)
			+ parseInt(doc.body.currentStyle.marginBottom) - 1;
	} catch (e){ // other domain
		h = 300;
	}
	return h;
},
correctIframeSize : function (){
	var wDiff = this.innerContent.offsetWidth - this.ruler.offsetWidth;
	hs.discardElement(this.ruler);
	if(wDiff < 0) wDiff = 0;

	var hDiff = this.innerContent.offsetHeight - this.iframe.offsetHeight;
	if(this.iDoc && !this.objectHeight && !this.height && this.y.size == this.y.full) try {
		this.iDoc.body.style.overflow = 'hidden';
	} catch (e){}
	hs.setStyles(this.iframe, {
		width: Math.abs(this.x.size - wDiff) +'px',
		height: Math.abs(this.y.size - hDiff) +'px'
	});
    hs.setStyles(this.body, {
		width: this.iframe.style.width,
    	height: this.iframe.style.height
	});

    this.scrollingContent = this.iframe;
    this.scrollerDiv = this.scrollingContent;

},
htmlSizeOperations : function (){

	this.setObjContainerSize(this.innerContent);


	if(this.objectType == 'swf' && this.objectLoadTime == 'before') this.writeExtendedContent();

    // handle minimum size
    if(this.x.size < this.x.full && !this.allowWidthReduction) this.x.size = this.x.full;
    if(this.y.size < this.y.full && !this.allowHeightReduction) this.y.size = this.y.full;
	this.scrollerDiv = this.innerContent;
    hs.setStyles(this.mediumContent, {
		position: 'relative',
		width: this.x.size +'px'
	});
    hs.setStyles(this.innerContent, {
    	border: 'none',
    	width: 'auto',
    	height: 'auto'
    });
	var node = hs.getElementByClass(this.innerContent, 'DIV', 'highslide-body');
    if(node && !/(iframe|swf)/.test(this.objectType)){
    	var cNode = node; // wrap to get true size
    	node = hs.createElement(cNode.nodeName, null, {overflow: 'hidden'}, null, true);
    	cNode.parentNode.insertBefore(node, cNode);
    	node.appendChild(hs.clearing); // IE6
    	node.appendChild(cNode);

    	var wDiff = this.innerContent.offsetWidth - node.offsetWidth;
    	var hDiff = this.innerContent.offsetHeight - node.offsetHeight;
		node.removeChild(hs.clearing);

    	var kdeBugCorr = hs.safari || navigator.vendor == 'KDE' ? 1 : 0; // KDE repainting bug
    	hs.setStyles(node, {
    			width: (this.x.size - wDiff - kdeBugCorr) +'px',
    			height: (this.y.size - hDiff) +'px',
    			overflow: 'auto',
    			position: 'relative'
    		}
    	);
		if(kdeBugCorr && cNode.offsetHeight > node.offsetHeight)	{
    		node.style.width = (parseInt(node.style.width) + kdeBugCorr) + 'px';
		}
    	this.scrollingContent = node;
    	this.scrollerDiv = this.scrollingContent;
	}
    if(this.iframe && this.objectLoadTime == 'before') this.correctIframeSize();
    if(!this.scrollingContent && this.y.size < this.mediumContent.offsetHeight) this.scrollerDiv = this.content;

	if(this.scrollerDiv == this.content && !this.allowWidthReduction && !/(iframe|swf)/.test(this.objectType)){
		this.x.size += 17; // room for scrollbars
	}
	if(this.scrollerDiv && this.scrollerDiv.offsetHeight > this.scrollerDiv.parentNode.offsetHeight){
		setTimeout("try { hs.expanders["+ this.key +"].scrollerDiv.style.overflow = 'auto'; } catch(e){}",
			 hs.expandDuration);
	}
},

getImageMapAreaCorrection : function(area){
	var c = area.coords.split(',');
	for(var i = 0; i < c.length; i++) c[i] = parseInt(c[i]);

	if(area.shape.toLowerCase() == 'circle'){
		this.x.tpos += c[0] - c[2];
		this.y.tpos += c[1] - c[2];
		this.x.t = this.y.t = 2 * c[2];
	} else{
		var maxX, maxY, minX = maxX = c[0], minY = maxY = c[1];
		for(var i = 0; i < c.length; i++){
			if(i % 2 == 0){
				minX = Math.min(minX, c[i]);
				maxX = Math.max(maxX, c[i]);
			} else{
				minY = Math.min(minY, c[i]);
				maxY = Math.max(maxY, c[i]);
			}
		}
		this.x.tpos += minX;
		this.x.t = maxX - minX;
		this.y.tpos += minY;
		this.y.t = maxY - minY;
	}
},
justify : function (p, moveOnly){
	var tgtArr, tgt = p.target, dim = p == this.x ? 'x' : 'y';

	if(tgt && tgt.match(/ /)){
		tgtArr = tgt.split(' ');
		tgt = tgtArr[0];
	}
	if(tgt && hs.$(tgt)){
		p.pos = hs.getPosition(hs.$(tgt))[dim];
		if(tgtArr && tgtArr[1] && tgtArr[1].match(/^[-]?[0-9]+px$/))
			p.pos += parseInt(tgtArr[1]);
		if(p.size < p.minSize) p.size = p.minSize;

	} else if(p.justify == 'auto' || p.justify == 'center'){

		var hasMovedMin = false;

		var allowReduce = p.exp.allowSizeReduction;
		if(p.justify == 'center')
			p.pos = Math.round(p.scroll + (p.clientSize + p.marginMin - p.marginMax - p.get('wsize')) / 2);
		else
			p.pos = Math.round(p.pos - ((p.get('wsize') - p.t) / 2));
		if(p.pos < p.scroll + p.marginMin){
			p.pos = p.scroll + p.marginMin;
			hasMovedMin = true;
		}
		if(!moveOnly && p.size < p.minSize){
			p.size = p.minSize;
			allowReduce = false;
		}
		if(p.pos + p.get('wsize') > p.scroll + p.clientSize - p.marginMax){
			if(!moveOnly && hasMovedMin && allowReduce){
				p.size = Math.min(p.size, p.get(dim == 'y' ? 'fitsize' : 'maxsize'));
			} else if(p.get('wsize') < p.get('fitsize')){
				p.pos = p.scroll + p.clientSize - p.marginMax - p.get('wsize');
			} else{ // image larger than viewport
				p.pos = p.scroll + p.marginMin;
				if(!moveOnly && allowReduce) p.size = p.get(dim == 'y' ? 'fitsize' : 'maxsize');
			}
		}

		if(!moveOnly && p.size < p.minSize){
			p.size = p.minSize;
			allowReduce = false;
		}


	} else if(p.justify == 'max'){
		p.pos = Math.floor(p.pos - p.size + p.t);
	}


	if(p.pos < p.marginMin){
		var tmpMin = p.pos;
		p.pos = p.marginMin;

		if(allowReduce && !moveOnly) p.size = p.size - (p.pos - tmpMin);

	}
},

correctRatio : function(ratio){
	var x = this.x,
		y = this.y,
		changed = false,
		xSize = Math.min(x.full, x.size),
		ySize = Math.min(y.full, y.size),
		useBox = (this.useBox || hs.padToMinWidth);

	if(xSize / ySize > ratio){ // width greater
		xSize = ySize * ratio;
		if(xSize < x.minSize){ // below minWidth
			xSize = x.minSize;
			ySize = xSize / ratio;
		}
		changed = true;

	} else if(xSize / ySize < ratio){ // height greater
		ySize = xSize / ratio;
		changed = true;
	}

	if(hs.padToMinWidth && x.full < x.minSize){
		x.imgSize = x.full;
		y.size = y.imgSize = y.full;
	} else if(this.useBox){
		x.imgSize = xSize;
		y.imgSize = ySize;
	} else{
		x.size = xSize;
		y.size = ySize;
	}
	changed = this.fitOverlayBox(useBox ? null : ratio, changed);
	if(useBox && y.size < y.imgSize){
		y.imgSize = y.size;
		x.imgSize = y.size * ratio;
	}
	if(changed || useBox){
		x.pos = x.tpos - x.cb + x.tb;
		x.minSize = x.size;
		this.justify(x, true);

		y.pos = y.tpos - y.cb + y.tb;
		y.minSize = y.size;
		this.justify(y, true);
		if(this.overlayBox) this.sizeOverlayBox();
	}
},
fitOverlayBox : function(ratio, changed){
	var x = this.x, y = this.y;
	if(this.overlayBox && (this.isImage || this.allowHeightReduction)){
		while (y.size > this.minHeight && x.size > this.minWidth
				&&  y.get('wsize') > y.get('fitsize')){
			y.size -= 10;
			if(ratio) x.size = y.size * ratio;
			this.sizeOverlayBox(0, 1);
			changed = true;
		}
	}
	return changed;
},

reflow : function (){
	if(this.scrollerDiv){
		var h = /iframe/i.test(this.scrollerDiv.tagName) ? (this.getIframePageHeight() + 1) +'px' : 'auto';
		if(this.body) this.body.style.height = h;
		this.scrollerDiv.style.height = h;
		this.y.setSize(this.innerContent.offsetHeight);
	}
},

show : function (){
	var x = this.x, y = this.y;
	this.doShowHide('hidden');
	hs.fireEvent(this, 'onBeforeExpand');
	if(this.slideshow && this.slideshow.thumbstrip) this.slideshow.thumbstrip.selectThumb();

	// Apply size change
	this.changeSize(
		1, {
			wrapper: {
				width : x.get('wsize'),
				height : y.get('wsize'),
				left: x.pos,
				top: y.pos
			},
			content: {
				left: x.p1 + x.get('imgPad'),
				top: y.p1 + y.get('imgPad'),
				width:x.imgSize ||x.size,
				height:y.imgSize ||y.size
			}
		},
		hs.expandDuration
	);
},

changeSize : function(up, to, dur){
	// transition
	var trans = this.transitions,
	other = up ? (this.last ? this.last.a : null) : hs.upcoming,
	t = (trans[1] && other
			&& hs.getParam(other, 'transitions')[1] == trans[1]) ?
		trans[1] : trans[0];

	if(this[t] && t != 'expand'){
		this[t](up, to);
		return;
	}

	if(this.outline && !this.outlineWhileAnimating){
		if(up) this.outline.setPosition();
		else this.outline.destroy(
				(this.isHtml && this.preserveContent));
	}


	if(!up) this.destroyOverlays();

	var exp = this,
		x = exp.x,
		y = exp.y,
		easing = this.easing;
	if(!up) easing = this.easingClose || easing;
	var after = up ?
		function(){

			if(exp.outline) exp.outline.table.style.visibility = "visible";
			setTimeout(function(){
				exp.afterExpand();
			}, 50);
		} :
		function(){
			exp.afterClose();
		};
	if(up) hs.setStyles( this.wrapper, {
		width: x.t +'px',
		height: y.t +'px'
	});
	if(up && this.isHtml){
		hs.setStyles(this.wrapper, {
			left: (x.tpos - x.cb + x.tb) +'px',
			top: (y.tpos - y.cb + y.tb) +'px'
		});
	}
	if(this.fadeInOut){
		hs.setStyles(this.wrapper, { opacity: up ? 0 : 1 });
		hs.extend(to.wrapper, { opacity: up });
	}
	hs.animate( this.wrapper, to.wrapper, {
		duration: dur,
		easing: easing,
		step: function(val, args){
			if(exp.outline && exp.outlineWhileAnimating && args.prop == 'top'){
				var fac = up ? args.pos : 1 - args.pos;
				var pos = {
					w: x.t + (x.get('wsize') - x.t) * fac,
					h: y.t + (y.get('wsize') - y.t) * fac,
					x: x.tpos + (x.pos - x.tpos) * fac,
					y: y.tpos + (y.pos - y.tpos) * fac
				};
				exp.outline.setPosition(pos, 0, 1);
			}
			if(exp.isHtml){
				if(args.prop == 'left')
					exp.mediumContent.style.left = (x.pos - val) +'px';
				if(args.prop == 'top')
					exp.mediumContent.style.top = (y.pos - val) +'px';
			}
		}
	});
	hs.animate( this.content, to.content, dur, easing, after);
	if(up){
		this.wrapper.style.visibility = 'visible';
		this.content.style.visibility = 'visible';
		if(this.isHtml) this.innerContent.style.visibility = 'visible';
	}
},



fade : function(up, to){
	this.outlineWhileAnimating = false;
	var exp = this,	t = up ? hs.expandDuration : 0;

	if(up){
		hs.animate(this.wrapper, to.wrapper, 0);
		hs.setStyles(this.wrapper, { opacity: 0, visibility: 'visible' });
		hs.animate(this.content, to.content, 0);
		this.content.style.visibility = 'visible';

		hs.animate(this.wrapper, { opacity: 1 }, t, null,
			function(){ exp.afterExpand(); });
	}

	if(this.outline){
		this.outline.table.style.zIndex = this.wrapper.style.zIndex;
		var dir = up || -1,
			offset = this.outline.offset,
			startOff = up ? 3 : offset,
			endOff = up? offset : 3;
		for(var i = startOff; dir * i <= dir * endOff; i += dir, t += 25){
			(function(){
				var o = up ? endOff - i : startOff - i;
				setTimeout(function(){
					exp.outline.setPosition(0, o, 1);
				}, t);
			})();
		}
	}


	if(up){}//setTimeout(function(){ exp.afterExpand(); }, t+50);
	else{
		setTimeout( function(){
			if(exp.outline) exp.outline.destroy(exp.preserveContent);

			exp.destroyOverlays();

			hs.animate( exp.wrapper, { opacity: 0 }, hs.restoreDuration, null, function(){
				exp.afterClose();
			});
		}, t);
	}
},
crossfade : function (up, to, from){
	if(!up) return;
	var exp = this,
		last = this.last,
		x = this.x,
		y = this.y,
		lastX = last.x,
		lastY = last.y,
		wrapper = this.wrapper,
		content = this.content,
		overlayBox = this.overlayBox;
	hs.removeEventListener(document, 'mousemove', hs.dragHandler);

	hs.setStyles(content, {
		width: (x.imgSize || x.size) +'px',
		height: (y.imgSize || y.size) +'px'
	});
	if(overlayBox) overlayBox.style.overflow = 'visible';
	this.outline = last.outline;
	if(this.outline) this.outline.exp = exp;
	last.outline = null;
	var fadeBox = hs.createElement('div', {
			className: 'highslide-'+ this.contentType
		}, {
			position: 'absolute',
			zIndex: 4,
			overflow: 'hidden',
			display: 'none'
		}
	);
	var names = { oldImg: last, newImg: this };
	for(var n in names){
		this[n] = names[n].content.cloneNode(1);
		hs.setStyles(this[n], {
			position: 'absolute',
			border: 0,
			visibility: 'visible'
		});
		fadeBox.appendChild(this[n]);
	}
	wrapper.appendChild(fadeBox);
	if(this.isHtml) hs.setStyles(this.mediumContent, {
		left: 0,
		top: 0
	});
	if(overlayBox){
		overlayBox.className = '';
		wrapper.appendChild(overlayBox);
	}
	fadeBox.style.display = '';
	last.content.style.display = 'none';


	if(hs.safari){
		var match = navigator.userAgent.match(/Safari\/([0-9]{3})/);
		if(match && parseInt(match[1]) < 525) this.wrapper.style.visibility = 'visible';
	}
	hs.animate(wrapper, {
		width: x.size
	}, {
		duration: hs.transitionDuration,
		step: function(val, args){
			var pos = args.pos,
				invPos = 1 - pos;
			var prop,
				size = {},
				props = ['pos', 'size', 'p1', 'p2'];
			for(var n in props){
				prop = props[n];
				size['x'+ prop] = Math.round(invPos * lastX[prop] + pos * x[prop]);
				size['y'+ prop] = Math.round(invPos * lastY[prop] + pos * y[prop]);
				size.ximgSize = Math.round(
					invPos * (lastX.imgSize || lastX.size) + pos * (x.imgSize || x.size));
				size.ximgPad = Math.round(invPos * lastX.get('imgPad') + pos * x.get('imgPad'));
				size.yimgSize = Math.round(
					invPos * (lastY.imgSize || lastY.size) + pos * (y.imgSize || y.size));
				size.yimgPad = Math.round(invPos * lastY.get('imgPad') + pos * y.get('imgPad'));
			}
			if(exp.outline) exp.outline.setPosition({
				x: size.xpos,
				y: size.ypos,
				w: size.xsize + size.xp1 + size.xp2 + 2 * x.cb,
				h: size.ysize + size.yp1 + size.yp2 + 2 * y.cb
			});
			last.wrapper.style.clip = 'rect('
				+ (size.ypos - lastY.pos)+'px, '
				+ (size.xsize + size.xp1 + size.xp2 + size.xpos + 2 * lastX.cb - lastX.pos) +'px, '
				+ (size.ysize + size.yp1 + size.yp2 + size.ypos + 2 * lastY.cb - lastY.pos) +'px, '
				+ (size.xpos - lastX.pos)+'px)';

			hs.setStyles(content, {
				top: (size.yp1 + y.get('imgPad')) +'px',
				left: (size.xp1 + x.get('imgPad')) +'px',
				marginTop: (y.pos - size.ypos) +'px',
				marginLeft: (x.pos - size.xpos) +'px'
			});
			hs.setStyles(wrapper, {
				top: size.ypos +'px',
				left: size.xpos +'px',
				width: (size.xp1 + size.xp2 + size.xsize + 2 * x.cb)+ 'px',
				height: (size.yp1 + size.yp2 + size.ysize + 2 * y.cb) + 'px'
			});
			hs.setStyles(fadeBox, {
				width: (size.ximgSize || size.xsize) + 'px',
				height: (size.yimgSize || size.ysize) +'px',
				left: (size.xp1 + size.ximgPad)  +'px',
				top: (size.yp1 + size.yimgPad) +'px',
				visibility: 'visible'
			});

			hs.setStyles(exp.oldImg, {
				top: (lastY.pos - size.ypos + lastY.p1 - size.yp1 + lastY.get('imgPad') - size.yimgPad)+'px',
				left: (lastX.pos - size.xpos + lastX.p1 - size.xp1 + lastX.get('imgPad') - size.ximgPad)+'px'
			});

			hs.setStyles(exp.newImg, {
				opacity: pos,
				top: (y.pos - size.ypos + y.p1 - size.yp1 + y.get('imgPad') - size.yimgPad) +'px',
				left: (x.pos - size.xpos + x.p1 - size.xp1 + x.get('imgPad') - size.ximgPad) +'px'
			});
			if(overlayBox) hs.setStyles(overlayBox, {
				width: size.xsize + 'px',
				height: size.ysize +'px',
				left: (size.xp1 + x.cb)  +'px',
				top: (size.yp1 + y.cb) +'px'
			});
		},
		complete: function (){
			wrapper.style.visibility = content.style.visibility = 'visible';
			content.style.display = 'block';
			hs.discardElement(fadeBox);
			exp.afterExpand();
			last.afterClose();
			exp.last = null;
		}

	});
},
reuseOverlay : function(o, el){
	if(!this.last) return false;
	for(var i = 0; i < this.last.overlays.length; i++){
		var oDiv = hs.$('hsId'+ this.last.overlays[i]);
		if(oDiv && oDiv.hsId == o.hsId){
			this.genOverlayBox();
			oDiv.reuse = this.key;
			hs.push(this.overlays, this.last.overlays[i]);
			return true;
		}
	}
	return false;
},


afterExpand : function(){
	this.isExpanded = true;

	this.a.className += ' highslide-active-anchor';
	this.focus();

	if(this.isHtml && this.objectLoadTime == 'after') this.writeExtendedContent();
	if(this.iframe){
		try {
			var exp = this,
				doc = this.iframe.contentDocument || this.iframe.contentWindow.document;
			hs.addEventListener(doc, 'mousedown', function (){
				if(hs.focusKey != exp.key) exp.focus();
			});
		} catch(e){}
		if(hs.ie && typeof this.isClosing != 'boolean') // first open
			this.iframe.style.width = (this.objectWidth - 1) +'px'; // hasLayout
	}
	if(this.dimmingOpacity) hs.dim(this);
	if(hs.upcoming && hs.upcoming == this.a) hs.upcoming = null;
	this.prepareNextOutline();
	var p = hs.page, mX = hs.mouse.x + p.scrollLeft, mY = hs.mouse.y + p.scrollTop;
	this.mouseIsOver = this.x.pos < mX && mX < this.x.pos + this.x.get('wsize')
		&& this.y.pos < mY && mY < this.y.pos + this.y.get('wsize');
	if(this.overlayBox) this.showOverlays();
	hs.fireEvent(this, 'onAfterExpand');

},


prepareNextOutline : function(){
	var key = this.key;
	var outlineType = this.outlineType;
	new hs.Outline(outlineType,
		function (){ try { hs.expanders[key].preloadNext(); } catch (e){} });
},


preloadNext : function(){
	var next = this.getAdjacentAnchor(1);
	if(next && next.onclick.toString().match(/hs\.expand/))
		var img = hs.createElement('img', { src: hs.getSrc(next) });
},


getAdjacentAnchor : function(op){
	var current = this.getAnchorIndex(), as = hs.anchors.groups[this.slideshowGroup || 'none'];

	/*< ? if($cfg->slideshow) : ?>s*/
	if(!as[current + op] && this.slideshow && this.slideshow.repeat){
		if(op == 1) return as[0];
		else if(op == -1) return as[as.length-1];
	}
	/*< ? endif ?>s*/
	return as[current + op] || null;
},

getAnchorIndex : function(){
	var arr = hs.getAnchors().groups[this.slideshowGroup || 'none'];
	if(arr) for(var i = 0; i < arr.length; i++){
		if(arr[i] == this.a) return i;
	}
	return null;
},


getNumber : function(){
	if(this[this.numberPosition]){
		var arr = hs.anchors.groups[this.slideshowGroup || 'none'];
		if(arr){
			var s = hs.lang.number.replace('%1', this.getAnchorIndex() + 1).replace('%2', arr.length);
			this[this.numberPosition].innerHTML =
				'<div class="highslide-number">'+ s +'</div>'+ this[this.numberPosition].innerHTML;
		}
	}
},
initSlideshow : function(){
	if(!this.last){
		for(var i = 0; i < hs.slideshows.length; i++){
			var ss = hs.slideshows[i], sg = ss.slideshowGroup;
			if(typeof sg == 'undefined' || sg === null || sg === this.slideshowGroup)
				this.slideshow = new hs.Slideshow(this.key, ss);
		}
	} else{
		this.slideshow = this.last.slideshow;
	}
	var ss = this.slideshow;
	if(!ss) return;
	var key = ss.expKey = this.key;

	ss.checkFirstAndLast();
	ss.disable('full-expand');
	if(ss.controls){
		this.createOverlay(hs.extend(ss.overlayOptions || {}, {
			overlayId: ss.controls,
			hsId: 'controls',
			zIndex: 5
		}));
	}
	if(ss.thumbstrip) ss.thumbstrip.add(this);
	if(!this.last && this.autoplay) ss.play(true);
	if(ss.autoplay){
		ss.autoplay = setTimeout(function(){
			hs.next(key);
		}, (ss.interval || 500));
	}
},

cancelLoading : function(){
	hs.discardElement (this.wrapper);
	hs.expanders[this.key] = null;
	if(hs.upcoming == this.a) hs.upcoming = null;
	hs.undim(this.key);
	if(this.loading) hs.loading.style.left = '-9999px';
	hs.fireEvent(this, 'onHideLoading');
},

writeCredits : function (){
	if(this.credits) return;
	this.credits = hs.createElement('a', {
		href: hs.creditsHref,
		target: hs.creditsTarget,
		className: 'highslide-credits',
		innerHTML: hs.lang.creditsText,
		title: hs.lang.creditsTitle
	});
	this.createOverlay({
		overlayId: this.credits,
		position: this.creditsPosition || 'top left',
		hsId: 'credits'
	});
},

getInline : function(types, addOverlay){
	for(var i = 0; i < types.length; i++){
		var type = types[i], s = null;
		if(type == 'caption' && !hs.fireEvent(this, 'onBeforeGetCaption')) return;
		else if(type == 'heading' && !hs.fireEvent(this, 'onBeforeGetHeading')) return;
		if(!this[type +'Id'] && this.thumbsUserSetId)
			this[type +'Id'] = type +'-for-'+ this.thumbsUserSetId;
		if(this[type +'Id']) this[type] = hs.getNode(this[type +'Id']);
		if(!this[type] && !this[type +'Text'] && this[type +'Eval']) try {
			s = eval(this[type +'Eval']);
		} catch (e){}
		if(!this[type] && this[type +'Text']){
			s = this[type +'Text'];
		}
		if(!this[type] && !s){
			this[type] = hs.getNode(this.a['_'+ type + 'Id']);
			if(!this[type]){
				var next = this.a.nextSibling;
				while (next && !hs.isHsAnchor(next)){
					if((new RegExp('highslide-'+ type)).test(next.className || null)){
						if(!next.id) this.a['_'+ type + 'Id'] = next.id = 'hsId'+ hs.idCounter++;
						this[type] = hs.getNode(next.id);
						break;
					}
					next = next.nextSibling;
				}
			}
		}
		if(!this[type] && !s && this.numberPosition == type) s = '\n';

		if(!this[type] && s) this[type] = hs.createElement('div',
				{ className: 'highslide-'+ type, innerHTML: s } );

		if(addOverlay && this[type]){
			var o = { position: (type == 'heading') ? 'above' : 'below' };
			for(var x in this[type+'Overlay']) o[x] = this[type+'Overlay'][x];
			o.overlayId = this[type];
			this.createOverlay(o);
		}
	}
},


// on end move and resize
doShowHide : function(visibility){
	if(hs.hideSelects) this.showHideElements('SELECT', visibility);
	if(hs.hideIframes) this.showHideElements('IFRAME', visibility);
	if(hs.geckoMac) this.showHideElements('*', visibility);
},
showHideElements : function (tagName, visibility){
	var els = document.getElementsByTagName(tagName);
	var prop = tagName == '*' ? 'overflow' : 'visibility';
	for(var i = 0; i < els.length; i++){
		if(prop == 'visibility' || (document.defaultView.getComputedStyle(
				els[i], "").getPropertyValue('overflow') == 'auto'
				|| els[i].getAttribute('hidden-by') != null)){
			var hiddenBy = els[i].getAttribute('hidden-by');
			if(visibility == 'visible' && hiddenBy){
				hiddenBy = hiddenBy.replace('['+ this.key +']', '');
				els[i].setAttribute('hidden-by', hiddenBy);
				if(!hiddenBy) els[i].style[prop] = els[i].origProp;
			} else if(visibility == 'hidden'){ // hide if behind
				var elPos = hs.getPosition(els[i]);
				elPos.w = els[i].offsetWidth;
				elPos.h = els[i].offsetHeight;
				if(!this.dimmingOpacity){ // hide all if dimming

					var clearsX = (elPos.x + elPos.w < this.x.get('opos')
						|| elPos.x > this.x.get('opos') + this.x.get('osize'));
					var clearsY = (elPos.y + elPos.h < this.y.get('opos')
						|| elPos.y > this.y.get('opos') + this.y.get('osize'));
				}
				var wrapperKey = hs.getWrapperKey(els[i]);
				if(!clearsX && !clearsY && wrapperKey != this.key){ // element falls behind image
					if(!hiddenBy){
						els[i].setAttribute('hidden-by', '['+ this.key +']');
						els[i].origProp = els[i].style[prop];
						els[i].style[prop] = 'hidden';

					} else if(hiddenBy.indexOf('['+ this.key +']') == -1){
						els[i].setAttribute('hidden-by', hiddenBy + '['+ this.key +']');
					}
				} else if((hiddenBy == '['+ this.key +']' || hs.focusKey == wrapperKey)
						&& wrapperKey != this.key){ // on move
					els[i].setAttribute('hidden-by', '');
					els[i].style[prop] = els[i].origProp || '';
				} else if(hiddenBy && hiddenBy.indexOf('['+ this.key +']') > -1){
					els[i].setAttribute('hidden-by', hiddenBy.replace('['+ this.key +']', ''));
				}

			}
		}
	}
},

focus : function(){
	this.wrapper.style.zIndex = hs.zIndexCounter += 2;
	// blur others
	for(var i = 0; i < hs.expanders.length; i++){
		if(hs.expanders[i] && i == hs.focusKey){
			var blurExp = hs.expanders[i];
			blurExp.content.className += ' highslide-'+ blurExp.contentType +'-blur';
			if(blurExp.isImage){
				blurExp.content.style.cursor = hs.ie ? 'hand' : 'pointer';
				blurExp.content.title = hs.lang.focusTitle;
			}
			hs.fireEvent(blurExp, 'onBlur');
		}
	}

	// focus this
	if(this.outline) this.outline.table.style.zIndex
		= this.wrapper.style.zIndex - 1;
	this.content.className = 'highslide-'+ this.contentType;
	if(this.isImage){
		this.content.title = hs.lang.restoreTitle;

		if(hs.restoreCursor){
			hs.styleRestoreCursor = window.opera ? 'pointer' : 'url('+ hs.graphicsDir + hs.restoreCursor +'), pointer';
			if(hs.ie && hs.uaVersion < 6) hs.styleRestoreCursor = 'hand';
			this.content.style.cursor = hs.styleRestoreCursor;
		}
	}
	hs.focusKey = this.key;
	hs.addEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);
	hs.fireEvent(this, 'onFocus');
},
moveTo: function(x, y){
	this.x.setPos(x);
	this.y.setPos(y);
},
resize : function (e){
	var w, h, r = e.width / e.height;
	w = Math.max(e.width + e.dX, Math.min(this.minWidth, this.x.full));
	if(this.isImage && Math.abs(w - this.x.full) < 12) w = this.x.full;
	h = this.isHtml ? e.height + e.dY : w / r;
	if(h < Math.min(this.minHeight, this.y.full)){
		h = Math.min(this.minHeight, this.y.full);
		if(this.isImage) w = h * r;
	}
	this.resizeTo(w, h);
},
resizeTo: function(w, h){
	this.y.setSize(h);
	this.x.setSize(w);
	this.wrapper.style.height = this.y.get('wsize') +'px';
},

close : function(){
	document.body.classList.remove('removeScrollBody');
	if(this.isClosing || !this.isExpanded) return;
	if(this.transitions[1] == 'crossfade' && hs.upcoming){
		hs.getExpander(hs.upcoming).cancelLoading();
		hs.upcoming = null;
	}
	if(!hs.fireEvent(this, 'onBeforeClose')) return;
	this.isClosing = true;
	if(this.slideshow && !hs.upcoming) this.slideshow.pause();

	hs.removeEventListener(document, window.opera ? 'keypress' : 'keydown', hs.keyHandler);

	try {
		if(this.isHtml) this.htmlPrepareClose();
		this.content.style.cursor = 'default';
		this.changeSize(
			0, {
				wrapper: {
					width : this.x.t,
					height : this.y.t,
					left: this.x.tpos - this.x.cb + this.x.tb,
					top: this.y.tpos - this.y.cb + this.y.tb
				},
				content: {
					left: 0,
					top: 0,
					width: this.x.t,
					height: this.y.t
				}
			}, hs.restoreDuration
		);
	} catch (e){ this.afterClose(); }
},

htmlPrepareClose : function(){
	if(hs.geckoMac){ // bad redraws
		if(!hs.mask) hs.mask = hs.createElement('div', null,
			{ position: 'absolute' }, hs.container);
		hs.setStyles(hs.mask, { width: this.x.size +'px', height: this.y.size +'px',
			left: this.x.pos +'px', top: this.y.pos +'px', display: 'block' });
	}
	if(this.objectType == 'swf') try { hs.$(this.body.id).StopPlay(); } catch (e){}

	if(this.objectLoadTime == 'after' && !this.preserveContent) this.destroyObject();
	if(this.scrollerDiv && this.scrollerDiv != this.scrollingContent)
		this.scrollerDiv.style.overflow = 'hidden';
},

destroyObject : function (){
	if(hs.ie && this.iframe)
		try { this.iframe.contentWindow.document.body.innerHTML = ''; } catch (e){}
	if(this.objectType == 'swf') swfobject.removeSWF(this.body.id);
	this.body.innerHTML = '';
},

sleep : function(){
	if(this.outline) this.outline.table.style.display = 'none';
	this.releaseMask = null;
	this.wrapper.style.display = 'none';
	hs.push(hs.sleeping, this);
},

awake : function(){try {

	hs.expanders[this.key] = this;

	if(!hs.allowMultipleInstances &&hs.focusKey != this.key){
		try { hs.expanders[hs.focusKey].close(); } catch (e){}
	}

	var z = hs.zIndexCounter++, stl = { display: '', zIndex: z };
	hs.setStyles (this.wrapper, stl);
	this.isClosing = false;

	var o = this.outline || 0;
	if(o){
		if(!this.outlineWhileAnimating) stl.visibility = 'hidden';
		hs.setStyles (o.table, stl);
	}
	if(this.slideshow){
		this.initSlideshow();
	}

	this.show();
} catch (e){}


},

createOverlay : function (o){
	var el = o.overlayId,
		relToVP = (o.relativeTo == 'viewport' && !/panel$/.test(o.position));
	if(typeof el == 'string') el = hs.getNode(el);
	if(o.html) el = hs.createElement('div', { innerHTML: o.html });
	if(!el || typeof el == 'string') return;
	if(!hs.fireEvent(this, 'onCreateOverlay', { overlay: el })) return;
	el.style.display = 'block';
	o.hsId = o.hsId || o.overlayId;
	if(this.transitions[1] == 'crossfade' && this.reuseOverlay(o, el)) return;
	this.genOverlayBox();
	var width = o.width && /^[0-9]+(px|%)$/.test(o.width) ? o.width : 'auto';
	if(/^(left|right)panel$/.test(o.position) && !/^[0-9]+px$/.test(o.width)) width = '200px';
	var overlay = hs.createElement(
		'div', {
			id: 'hsId'+ hs.idCounter++,
			hsId: o.hsId
		}, {
			position: 'absolute',
			visibility: 'hidden',
			width: width,
			direction: hs.lang.cssDirection || '',
			opacity: 0
		},
		relToVP ? hs.viewport :this.overlayBox,
		true
	);
	if(relToVP) overlay.hsKey = this.key;

	overlay.appendChild(el);
	hs.extend(overlay, {
		opacity: 1,
		offsetX: 0,
		offsetY: 0,
		dur: (o.fade === 0 || o.fade === false || (o.fade == 2 && hs.ie)) ? 0 : 250
	});
	hs.extend(overlay, o);


	if(this.gotOverlays){
		this.positionOverlay(overlay);
		if(!overlay.hideOnMouseOut || this.mouseIsOver)
			hs.animate(overlay, { opacity: overlay.opacity }, overlay.dur);
	}
	hs.push(this.overlays, hs.idCounter - 1);
},
positionOverlay : function(overlay){
	var p = overlay.position || 'middle center',
		relToVP = (overlay.relativeTo == 'viewport'),
		offX = overlay.offsetX,
		offY = overlay.offsetY;
	if(relToVP){
		hs.viewport.style.display = 'block';
		overlay.hsKey = this.key;
		if(overlay.offsetWidth > overlay.parentNode.offsetWidth)
			overlay.style.width = '100%';
	} else
	if(overlay.parentNode != this.overlayBox) this.overlayBox.appendChild(overlay);
	if(/left$/.test(p)) overlay.style.left = offX +'px';

	if(/center$/.test(p))	hs.setStyles (overlay, {
		left: '50%',
		marginLeft: (offX - Math.round(overlay.offsetWidth / 2)) +'px'
	});

	if(/right$/.test(p)) overlay.style.right = - offX +'px';

	if(/^leftpanel$/.test(p)){
		hs.setStyles(overlay, {
			right: '100%',
			marginRight: this.x.cb +'px',
			top: - this.y.cb +'px',
			bottom: - this.y.cb +'px',
			overflow: 'auto'
		});
		this.x.p1 = overlay.offsetWidth;

	} else if(/^rightpanel$/.test(p)){
		hs.setStyles(overlay, {
			left: '100%',
			marginLeft: this.x.cb +'px',
			top: - this.y.cb +'px',
			bottom: - this.y.cb +'px',
			overflow: 'auto'
		});
		this.x.p2 = overlay.offsetWidth;
	}
	var parOff = overlay.parentNode.offsetHeight;
	overlay.style.height = 'auto';
	if(relToVP && overlay.offsetHeight > parOff)
		overlay.style.height = hs.ieLt7 ? parOff +'px' : '100%';

	if(/^top/.test(p)) overlay.style.top = offY +'px';
	if(/^middle/.test(p))	hs.setStyles (overlay, {
		top: '50%',
		marginTop: (offY - Math.round(overlay.offsetHeight / 2)) +'px'
	});
	if(/^bottom/.test(p)) overlay.style.bottom = - offY +'px';
	if(/^above$/.test(p)){
		hs.setStyles(overlay, {
			left: (- this.x.p1 - this.x.cb) +'px',
			right: (- this.x.p2 - this.x.cb) +'px',
			bottom: '100%',
			marginBottom: this.y.cb +'px',
			width: 'auto'
		});
		this.y.p1 = overlay.offsetHeight;

	} else if(/^below$/.test(p)){
		hs.setStyles(overlay, {
			position: 'relative',
			left: (- this.x.p1 - this.x.cb) +'px',
			right: (- this.x.p2 - this.x.cb) +'px',
			top: '100%',
			marginTop: this.y.cb +'px',
			width: 'auto'
		});
		this.y.p2 = overlay.offsetHeight;
		overlay.style.position = 'absolute';
	}
},

getOverlays : function(){
	this.getInline(['heading', 'caption'], true);
	this.getNumber();
	if(this.caption) hs.fireEvent(this, 'onAfterGetCaption');
	if(this.heading) hs.fireEvent(this, 'onAfterGetHeading');
	if(this.heading && this.dragByHeading) this.heading.className += ' highslide-move';
	if(hs.showCredits) this.writeCredits();
	for(var i = 0; i < hs.overlays.length; i++){
		var o = hs.overlays[i], tId = o.thumbnailId, sg = o.slideshowGroup;
		if((!tId && !sg) || (tId && tId == this.thumbsUserSetId)
				|| (sg && sg === this.slideshowGroup)){
			if(this.isImage || (this.isHtml && o.useOnHtml))
			this.createOverlay(o);
		}
	}
	var os = [];
	for(var i = 0; i < this.overlays.length; i++){
		var o = hs.$('hsId'+ this.overlays[i]);
		if(/panel$/.test(o.position)) this.positionOverlay(o);
		else hs.push(os, o);
	}
	for(var i = 0; i < os.length; i++) this.positionOverlay(os[i]);
	this.gotOverlays = true;
},
genOverlayBox : function(){
	if(!this.overlayBox) this.overlayBox = hs.createElement (
		'div', {
			className: this.wrapperClassName
		}, {
			position : 'absolute',
			width: (this.x.size || (this.useBox ? this.width : null)
				|| this.x.full) +'px',
			height: (this.y.size || this.y.full) +'px',
			visibility : 'hidden',
			overflow : 'hidden',
			zIndex : hs.ie ? 4 : 'auto'
		},
		hs.container,
		true
	);
},
sizeOverlayBox : function(doWrapper, doPanels){
	var overlayBox = this.overlayBox,
		x = this.x,
		y = this.y;
	hs.setStyles( overlayBox, {
		width: x.size +'px',
		height: y.size +'px'
	});
	if(doWrapper || doPanels){
		for(var i = 0; i < this.overlays.length; i++){
			var o = hs.$('hsId'+ this.overlays[i]);
			var ie6 = (hs.ieLt7 || document.compatMode == 'BackCompat');
			if(o && /^(above|below)$/.test(o.position)){
				if(ie6){
					o.style.width = (overlayBox.offsetWidth + 2 * x.cb
						+ x.p1 + x.p2) +'px';
				}
				y[o.position == 'above' ? 'p1' : 'p2'] = o.offsetHeight;
			}
			if(o && ie6 && /^(left|right)panel$/.test(o.position)){
				o.style.height = (overlayBox.offsetHeight + 2* y.cb) +'px';
			}
		}
	}
	if(doWrapper){
		hs.setStyles(this.content, {
			top: y.p1 +'px'
		});
		hs.setStyles(overlayBox, {
			top: (y.p1 + y.cb) +'px'
		});
	}
},

showOverlays : function(){
	var b = this.overlayBox;
	b.className = '';
	hs.setStyles(b, {
		top: (this.y.p1 + this.y.cb) +'px',
		left: (this.x.p1 + this.x.cb) +'px',
		overflow : 'visible'
	});
	if(hs.safari) b.style.visibility = 'visible';
	this.wrapper.appendChild (b);
	for(var i = 0; i < this.overlays.length; i++){
		var o = hs.$('hsId'+ this.overlays[i]);
		o.style.zIndex = o.zIndex || 4;
		if(!o.hideOnMouseOut || this.mouseIsOver){
			o.style.visibility = 'visible';
			hs.setStyles(o, { visibility: 'visible', display: '' });
			hs.animate(o, { opacity: o.opacity }, o.dur);
		}
	}
},

destroyOverlays : function(){
	if(!this.overlays.length) return;
	if(this.slideshow){
		var c = this.slideshow.controls;
		if(c && hs.getExpander(c) == this) c.parentNode.removeChild(c);
	}
	for(var i = 0; i < this.overlays.length; i++){
		var o = hs.$('hsId'+ this.overlays[i]);
		if(o && o.parentNode == hs.viewport && hs.getExpander(o) == this) hs.discardElement(o);
	}
	if(this.isHtml && this.preserveContent){
		this.overlayBox.style.top = '-9999px';
		hs.container.appendChild(this.overlayBox);
	} else
	hs.discardElement(this.overlayBox);
},



createFullExpand : function (){
	if(this.slideshow && this.slideshow.controls){
		this.slideshow.enable('full-expand');
		return;
	}
	this.fullExpandLabel = hs.createElement(
		'a', {
			href: 'javascript:hs.expanders['+ this.key +'].doFullExpand();',
			title: hs.lang.fullExpandTitle,
			className: 'highslide-full-expand'
		}
	);
	if(!hs.fireEvent(this, 'onCreateFullExpand')) return;

	this.createOverlay({
		overlayId: this.fullExpandLabel,
		position: hs.fullExpandPosition,
		hideOnMouseOut: true,
		opacity: hs.fullExpandOpacity
	});
},

doFullExpand : function (){
	try {
		if(!hs.fireEvent(this, 'onDoFullExpand')) return;
		if(this.fullExpandLabel) hs.discardElement(this.fullExpandLabel);

		this.focus();
		var xSize = this.x.size;
		this.resizeTo(this.x.full, this.y.full);

		var xpos = this.x.pos - (this.x.size - xSize) / 2;
		if(xpos < hs.marginLeft) xpos = hs.marginLeft;

		this.moveTo(xpos, this.y.pos);
		this.doShowHide('hidden');

	} catch (e){
		this.error(e);
	}
},


afterClose : function (){
	this.a.className = this.a.className.replace('highslide-active-anchor', '');

	this.doShowHide('visible');

	if(this.isHtml && this.preserveContent
			 && this.transitions[1] != 'crossfade'){
		this.sleep();
	} else{
		if(this.outline && this.outlineWhileAnimating) this.outline.destroy();

		hs.discardElement(this.wrapper);
	}
	if(hs.mask) hs.mask.style.display = 'none';
	this.destroyOverlays();
	if(!hs.viewport.childNodes.length) hs.viewport.style.display = 'none';

	if(this.dimmingOpacity) hs.undim(this.key);
	hs.fireEvent(this, 'onAfterClose');
	hs.expanders[this.key] = null;
	hs.reOrder();
}

};


// hs.Ajax object prototype
hs.Ajax = function (a, content, pre){
	this.a = a;
	this.content = content;
	this.pre = pre;
};

hs.Ajax.prototype = {
run : function (){
	var xhr;
	if(!this.src) this.src = hs.getSrc(this.a);
	if(this.src.match('#')){
		var arr = this.src.split('#');
		this.src = arr[0];
		this.id = arr[1];
	}
	if(hs.cachedGets[this.src]){
		this.cachedGet = hs.cachedGets[this.src];
		if(this.id) this.getElementContent();
		else this.loadHTML();
		return;
	}
	try { xhr = new XMLHttpRequest(); }
	catch (e){
		try { xhr = new ActiveXObject("Msxml2.XMLHTTP"); }
		catch (e){
			try { xhr = new ActiveXObject("Microsoft.XMLHTTP"); }
			catch (e){ this.onError(); }
		}
	}
	var pThis = this;
	xhr.onreadystatechange = function(){
		if(pThis.xhr.readyState == 4){
			if(pThis.id) pThis.getElementContent();
			else pThis.loadHTML();
		}
	};
	var src = this.src;
	this.xhr = xhr;
	if(hs.forceAjaxReload)
		src = src.replace(/$/, (/\?/.test(src) ? '&' : '?') +'dummy='+ (new Date()).getTime());
	xhr.open('GET', src, true);
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(null);
},

getElementContent : function(){
	hs.init();
	var attribs = window.opera || hs.ie6SSL ? { src: 'about:blank' } : null;

	this.iframe = hs.createElement('iframe', attribs,
		{ position: 'absolute', top: '-9999px' }, hs.container);

	this.loadHTML();
},

loadHTML : function(){
	var s = this.cachedGet || this.xhr.responseText,
		regBody;
	if(this.pre) hs.cachedGets[this.src] = s;
	if(!hs.ie || hs.uaVersion >= 5.5){
		s = s.replace(new RegExp('<link[^>]*>', 'gi'), '')
			.replace(new RegExp('<script[^>]*>.*?</script>', 'gi'), '');
		if(this.iframe){
			var doc = this.iframe.contentDocument;
			if(!doc && this.iframe.contentWindow) doc = this.iframe.contentWindow.document;
			if(!doc){ // Opera
				var pThis = this;
				setTimeout(function(){	pThis.loadHTML(); }, 25);
				return;
			}
			doc.open();
			doc.write(s);
			doc.close();
			try { s = doc.getElementById(this.id).innerHTML; } catch (e){
				try { s = this.iframe.document.getElementById(this.id).innerHTML; } catch (e){} // opera
			}
			hs.discardElement(this.iframe);
		} else{
			regBody = /(<body[^>]*>|<\/body>)/ig;
			if(regBody.test(s)) s = s.split(regBody)[hs.ie ? 1 : 2];

		}
	}
	hs.getElementByClass(this.content, 'DIV', 'highslide-body').innerHTML = s;
	this.onLoad();
	for(var x in this) this[x] = null;
}
};


hs.Slideshow = function (expKey, options){
	if(hs.dynamicallyUpdateAnchors !== false) hs.updateAnchors();
	this.expKey = expKey;
	for(var x in options) this[x] = options[x];
	if(this.useControls) this.getControls();
	if(this.thumbstrip) this.thumbstrip = hs.Thumbstrip(this);
};
hs.Slideshow.prototype = {
getControls: function(){
	this.controls = hs.createElement('div', { innerHTML: hs.replaceLang(hs.skin.controls) },
		null, hs.container);

	var buttons = ['play', 'pause', 'previous', 'next', 'move', 'full-expand', 'close','download'];
	this.btn = {};
	var pThis = this;
	for(var i = 0; i < buttons.length; i++){
		this.btn[buttons[i]] = hs.getElementByClass(this.controls, 'li', 'highslide-'+ buttons[i]);
		this.enable(buttons[i]);
	}
	this.btn.pause.style.display = 'none';
	//this.disable('full-expand');
},
checkFirstAndLast: function(){
	if(this.repeat || !this.controls) return;
	var exp = hs.expanders[this.expKey],
		cur = exp.getAnchorIndex(),
		re = /disabled$/;
	if(cur == 0)
		this.disable('previous');
	else if(re.test(this.btn.previous.getElementsByTagName('a')[0].className))
		this.enable('previous');
	if(cur + 1 == hs.anchors.groups[exp.slideshowGroup || 'none'].length){
		this.disable('next');
		this.disable('play');
	} else if(re.test(this.btn.next.getElementsByTagName('a')[0].className)){
		this.enable('next');
		this.enable('play');
	}
},
enable: function(btn){
	if(!this.btn) return;
	var sls = this, a = this.btn[btn].getElementsByTagName('a')[0], re = /disabled$/;
	a.onclick = function(){
		sls[btn]();
		return false;
	};
	if(re.test(a.className)) a.className = a.className.replace(re, '');
},
disable: function(btn){
	if(!this.btn) return;
	var a = this.btn[btn].getElementsByTagName('a')[0];
	a.onclick = function(){ return false; };
	if(!/disabled$/.test(a.className)) a.className += ' disabled';
},
hitSpace: function(){
	if(this.autoplay) this.pause();
	else this.play();
},
play: function(wait){
	if(this.btn){
		this.btn.play.style.display = 'none';
		this.btn.pause.style.display = '';
	}

	this.autoplay = true;
	if(!wait) hs.next(this.expKey);
},
pause: function(){
	if(this.btn){
		this.btn.pause.style.display = 'none';
		this.btn.play.style.display = '';
	}

	clearTimeout(this.autoplay);
	this.autoplay = null;
},
previous: function(){
	this.pause();
	hs.previous(this.btn.previous);
},
next: function(){
	this.pause();
	hs.next(this.btn.next);
},
move: function(){},
'full-expand': function(){
	hs.getExpander().doFullExpand();
},
close: function(){
	hs.close(this.btn.close);
}
};
// hs.download = function(){
// 	$('.downloadPopupPpReport').click(function() {
// 		// $PopupPpReport();
// 	  });
// }

hs.Thumbstrip = function(slideshow){
	function add (exp){
		hs.extend(options || {}, {
			overlayId: dom,
			hsId: 'thumbstrip',
			className: 'highslide-thumbstrip-'+ mode +'-overlay ' + (options.className || '')
		});
		if(hs.ieLt7) options.fade = 0;
		exp.createOverlay(options);
		hs.setStyles(dom.parentNode, { overflow: 'hidden' });
	};

	function scroll (delta){
		selectThumb(undefined, Math.round(delta * dom[isX ? 'offsetWidth' : 'offsetHeight'] * 0.7));
	};

	function selectThumb (i, scrollBy){
		if(i === undefined) for(var j = 0; j < group.length; j++){
			if(group[j] == hs.expanders[slideshow.expKey].a){
				i = j;
				break;
			}
		}
		if(i === undefined) return;
		var as = dom.getElementsByTagName('a'),
			active = as[i],
			cell = active.parentNode,
			left = isX ? 'Left' : 'Top',
			right = isX ? 'Right' : 'Bottom',
			width = isX ? 'Width' : 'Height',
			offsetLeft = 'offset' + left,
			offsetWidth = 'offset' + width,
			overlayWidth = div.parentNode.parentNode[offsetWidth],
			minTblPos = overlayWidth - table[offsetWidth],
			curTblPos = parseInt(table.style[isX ? 'left' : 'top']) || 0,
			tblPos = curTblPos,
			mgnRight = 20;
		if(scrollBy !== undefined){
			tblPos = curTblPos - scrollBy;

			if(minTblPos > 0) minTblPos = 0;
			if(tblPos > 0) tblPos = 0;
			if(tblPos < minTblPos) tblPos = minTblPos;


		} else{
			for(var j = 0; j < as.length; j++) as[j].className = '';
			active.className = 'highslide-active-anchor';
			var activeLeft = i > 0 ? as[i - 1].parentNode[offsetLeft] : cell[offsetLeft],
				activeRight = cell[offsetLeft] + cell[offsetWidth] +
					(as[i + 1] ? as[i + 1].parentNode[offsetWidth] : 0);
			if(activeRight > overlayWidth - curTblPos) tblPos = overlayWidth - activeRight;
			else if(activeLeft < -curTblPos) tblPos = -activeLeft;
		}
		var markerPos = cell[offsetLeft] + (cell[offsetWidth] - marker[offsetWidth]) / 2 + tblPos;
		hs.animate(table, isX ? { left: tblPos } : { top: tblPos }, null, 'easeOutQuad');
		hs.animate(marker, isX ? { left: markerPos } : { top: markerPos }, null, 'easeOutQuad');
		scrollUp.style.display = tblPos < 0 ? 'block' : 'none';
		scrollDown.style.display = (tblPos > minTblPos)  ? 'block' : 'none';

	};


	// initialize
	var group = hs.anchors.groups[hs.expanders[slideshow.expKey].slideshowGroup || 'none'],
		options = slideshow.thumbstrip,
		mode = options.mode || 'horizontal',
		floatMode = (mode == 'float'),
		tree = floatMode ? ['div', 'ul', 'li', 'span'] : ['table', 'tbody', 'tr', 'td'],
		isX = (mode == 'horizontal'),
		dom = hs.createElement('div', {
				className: 'highslide-thumbstrip highslide-thumbstrip-'+ mode,
				innerHTML:
					'<div class="highslide-thumbstrip-inner">'+
					'<'+ tree[0] +'><'+ tree[1] +'></'+ tree[1] +'></'+ tree[0] +'></div>'+
					'<div class="highslide-scroll-up"><div></div></div>'+
					'<div class="highslide-scroll-down"><div></div></div>'+
					'<div class="highslide-marker"><div></div></div>'
			}, {
				display: 'none'
			}, hs.container),
		domCh = dom.childNodes,
		div = domCh[0],
		scrollUp = domCh[1],
		scrollDown = domCh[2],
		marker = domCh[3],
		table = div.firstChild,
		tbody = dom.getElementsByTagName(tree[1])[0],
		tr;
	for(var i = 0; i < group.length; i++){
		if(i == 0 || !isX) tr = hs.createElement(tree[2], null, null, tbody);
		(function(){
			var a = group[i],
				cell = hs.createElement(tree[3], null, null, tr),
				pI = i;
			hs.createElement('a', {
				href: a.href,
				onclick: function(){
					hs.getExpander(this).focus();
					return hs.transit(a);
				},
				innerHTML: hs.stripItemFormatter ? hs.stripItemFormatter(a) : a.innerHTML
			}, null, cell);
		})();
	}
	if(!floatMode){
		scrollUp.onclick = function (){ scroll(-1); };
		scrollDown.onclick = function(){ scroll(1); };
		hs.addEventListener(tbody, document.onmousewheel !== undefined ?
				'mousewheel' : 'DOMMouseScroll', function(e){
			var delta = 0;
	        e = e || window.event;
	        if(e.wheelDelta){
				delta = e.wheelDelta/120;
				if(hs.opera) delta = -delta;
	        } else if(e.detail){
				delta = -e.detail/3;
	        }
	        if(delta) scroll(-delta * 0.2);
			if(e.preventDefault) e.preventDefault();
			e.returnValue = false;
		});
	}

	return {
		add: add,
		selectThumb: selectThumb
	}
};
hs.langDefaults = hs.lang;
// history
var HsExpander = hs.Expander;
if(hs.ie && window == window.top){
	(function (){
		try {
			document.documentElement.doScroll('left');
		} catch (e){
			setTimeout(arguments.callee, 50);
			return;
		}
		hs.ready();
	})();
}
hs.addEventListener(document, 'DOMContentLoaded', hs.ready);
hs.addEventListener(window, 'load', hs.ready);

// set handlers
hs.addEventListener(document, 'ready', function(){
	if(hs.expandCursor || hs.dimmingOpacity){
		var style = hs.createElement('style', { type: 'text/css' }, null,
			document.getElementsByTagName('HEAD')[0]);

		function addRule(sel, dec){
			if(!hs.ie){
				style.appendChild(document.createTextNode(sel + " {" + dec + "}"));
			} else{
				var last = document.styleSheets[document.styleSheets.length - 1];
				if(typeof(last.addRule) == "object") last.addRule(sel, dec);
			}
		}
		function fix(prop){
			return 'expression( ( ( ignoreMe = document.documentElement.'+ prop +
				' ? document.documentElement.'+ prop +' : document.body.'+ prop +' ) ) + \'px\' );';
		}
		if(hs.expandCursor) addRule ('.highslide img',
			'cursor: url('+ hs.graphicsDir + hs.expandCursor +'), pointer !important;');
		addRule ('.highslide-viewport-size',
			hs.ie && (hs.uaVersion < 7 || document.compatMode == 'BackCompat') ?
				'position: absolute; '+
				'left:'+ fix('scrollLeft') +
				'top:'+ fix('scrollTop') +
				'width:'+ fix('clientWidth') +
				'height:'+ fix('clientHeight') :
				'position: fixed; width: 100%; height: 100%; left: 0; top: 0');
	}
});
hs.addEventListener(window, 'resize', function(){
	hs.getPageSize();
	if(hs.viewport) for(var i = 0; i < hs.viewport.childNodes.length; i++){
		var node = hs.viewport.childNodes[i],
			exp = hs.getExpander(node);
		exp.positionOverlay(node);
		if(node.hsId == 'thumbstrip') exp.slideshow.thumbstrip.selectThumb();
	}
});
hs.addEventListener(document, 'mousemove', function(e){
	hs.mouse = { x: e.clientX, y: e.clientY	};
});
hs.addEventListener(document, 'mousedown', hs.mouseClickHandler);
hs.addEventListener(document, 'mouseup', hs.mouseClickHandler);
hs.addEventListener(document, 'ready', hs.setClickEvents);
hs.addEventListener(window, 'load', hs.preloadImages);
hs.addEventListener(window, 'load', hs.preloadAjax);
}

'use strict';
/*global angular: false, Highcharts: false */

angular.module('highcharts-ng', [])
  .factory('highchartsNGUtils', function (){
    return {
      //IE8 support
      indexOf: function (arr, find, i /*opt*/){
        if(i === undefined) i = 0;
        if(i < 0) i += arr.length;
        if(i < 0) i = 0;
        for(var n = arr.length; i < n; i++)
          if(i in arr && arr[i] === find)
            return i;
        return -1;
      },

      prependMethod: function (obj, method, func){
        var original = obj[method];
        obj[method] = function (){
          var args = Array.prototype.slice.call(arguments);
          func.apply(this, args);
          if(original){
            return original.apply(this, args);
          } else{
            return;
          }
        };
      },

      deepExtend: function deepExtend(destination, source){
        //Slightly strange behaviour in edge cases (e.g. passing in non objects)
        //But does the job for current use cases.
        if(angular.isArray(source)){
          destination = angular.isArray(destination) ? destination : [];
          for(var i = 0; i < source.length; i++){
            destination[i] = deepExtend(destination[i] || {}, source[i]);
          }
        } else if(angular.isObject(source)){
          for(var property in source){
            destination[property] = deepExtend(destination[property] || {}, source[property]);
          }
        } else{
          destination = source;
        }
        return destination;
      }
    };

  }).directive('highchart', function (highchartsNGUtils){

    // acceptable shared state
    var seriesId = 0;
    var ensureIds = function (series){
      var changed = false;
      angular.forEach(series, function(s){
        if(!angular.isDefined(s.id)){
          s.id = 'series-' + seriesId++;
          changed = true;
        }
      });
      return changed;
    };

    // immutable
    var axisNames = [ 'xAxis', 'yAxis' ];

    var getMergedOptions = function (scope, element, config){
      var mergedOptions = {};

      var defaultOptions = {
        chart: {
          events: {}
        },
        title: {},
        subtitle: {},
        series: [],
        credits: {},
        plotOptions: {},
        navigator: {enabled: false}
      };

      if(config.options){
        mergedOptions = highchartsNGUtils.deepExtend(defaultOptions, config.options);
      } else{
        mergedOptions = defaultOptions;
      }
      mergedOptions.chart.renderTo = element[0];

      angular.forEach(axisNames, function(axisName){
        if(angular.isDefined(config[axisName])){
          mergedOptions[axisName] = angular.copy(config[axisName]);

          if(angular.isDefined(config[axisName].currentMin) ||
              angular.isDefined(config[axisName].currentMax)){

            highchartsNGUtils.prependMethod(mergedOptions.chart.events, 'selection', function(e){
              var thisChart = this;
              if(e[axisName]){
                scope.$apply(function (){
                  scope.config[axisName].currentMin = e[axisName][0].min;
                  scope.config[axisName].currentMax = e[axisName][0].max;
                });
              } else{
                //handle reset button - zoom out to all
                scope.$apply(function (){
                  scope.config[axisName].currentMin = thisChart[axisName][0].dataMin;
                  scope.config[axisName].currentMax = thisChart[axisName][0].dataMax;
                });
              }
            });

            highchartsNGUtils.prependMethod(mergedOptions.chart.events, 'addSeries', function(e){
              scope.config[axisName].currentMin = this[axisName][0].min || scope.config[axisName].currentMin;
              scope.config[axisName].currentMax = this[axisName][0].max || scope.config[axisName].currentMax;
            });
          }
        }
      });

      if(config.title){
        mergedOptions.title = config.title;
      }
      if(config.subtitle){
        mergedOptions.subtitle = config.subtitle;
      }
      if(config.credits){
        mergedOptions.credits = config.credits;
      }
      if(config.size){
        if(config.size.width){
          mergedOptions.chart.width = config.size.width;
        }
        if(config.size.height){
          mergedOptions.chart.height = config.size.height;
        }
      }
      return mergedOptions;
    };

    var updateZoom = function (axis, modelAxis){
      var extremes = axis.getExtremes();
      if(modelAxis.currentMin !== extremes.dataMin || modelAxis.currentMax !== extremes.dataMax){
        axis.setExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
      }
    };

    var processExtremes = function(chart, axis, axisName){
      if(axis.currentMin || axis.currentMax){
        chart[axisName][0].setExtremes(axis.currentMin, axis.currentMax, true);
      }
    };

    var chartOptionsWithoutEasyOptions = function (options){
      return angular.extend({}, options, {data: null, visible: null});
    };

    return {
      restrict: 'EAC',
      replace: true,
      template: '<div></div>',
      scope: {
        config: '=',
        disableDataWatch: '='
      },
      link: function (scope, element, attrs){
        // We keep some chart-specific variables here as a closure
        // instead of storing them on 'scope'.

        // prevSeriesOptions is maintained by processSeries
        var prevSeriesOptions = {};

        var processSeries = function(series){
          var i;
          var ids = [];

          if(series){
            var setIds = ensureIds(series);
            if(setIds && !scope.disableDataWatch){
              //If we have set some ids this will trigger another digest cycle.
              //In this scenario just return early and let the next cycle take care of changes
              return false;
            }

            //Find series to add or update
            angular.forEach(series, function(s){
              ids.push(s.id);
              var chartSeries = chart.get(s.id);
              if(chartSeries){
                if(!angular.equals(prevSeriesOptions[s.id], chartOptionsWithoutEasyOptions(s))){
                  chartSeries.update(angular.copy(s), false);
                } else{
                  if(s.visible !== undefined && chartSeries.visible !== s.visible){
                    chartSeries.setVisible(s.visible, false);
                  }
                  chartSeries.setData(angular.copy(s.data), false);
                }
              } else{
                chart.addSeries(angular.copy(s), false);
              }
              prevSeriesOptions[s.id] = chartOptionsWithoutEasyOptions(s);
            });

            //  Shows no data text if all series are empty
            if(scope.config.noData){
              var chartContainsData = false;
              for(i = 0; i < series.length; i++){
                if(series[i].data && series[i].data.length > 0){
                  chartContainsData = true;
                  break;
                }
              }

              if(!chartContainsData){
                chart.showLoading(scope.config.noData);
              } else{
                chart.hideLoading();
              }
            }
          }

          //Now remove any missing series
          for(i = chart.series.length - 1; i >= 0; i--){
            var s = chart.series[i];
            if(highchartsNGUtils.indexOf(ids, s.options.id) < 0){
              s.remove(false);
            }
          }
          return true;
        };

        // chart is maintained by initChart
        var chart = false;
        var initChart = function(){
          if(chart) chart.destroy();
          prevSeriesOptions = {};
          var config = scope.config || {};
          var mergedOptions = getMergedOptions(scope, element, config);
          var func = config.func || undefined;
          chart = config.useHighStocks ?
            new Highcharts.StockChart(mergedOptions, func) :
            new Highcharts.Chart(mergedOptions, func);
          for(var i = 0; i < axisNames.length; i++){
            if(config[axisNames[i]]){
              processExtremes(chart, config[axisNames[i]], axisNames[i]);
            }
          }
          if(config.loading){
            chart.showLoading();
          }

        };
        initChart();


        if(scope.disableDataWatch){
          scope.$watchCollection('config.series', function (newSeries, oldSeries){
            processSeries(newSeries);
            chart.redraw();
          });
        } else{
          scope.$watch('config.series', function (newSeries, oldSeries){
            var needsRedraw = processSeries(newSeries);
            if(needsRedraw){
              chart.redraw();
            }
          }, true);
        }

        scope.$watch('config.title', function (newTitle){
          chart.setTitle(newTitle, true);
        }, true);

        scope.$watch('config.subtitle', function (newSubtitle){
          chart.setTitle(true, newSubtitle);
        }, true);

        scope.$watch('config.loading', function (loading){
          if(loading){
            chart.showLoading();
          } else{
            chart.hideLoading();
          }
        });

        scope.$watch('config.credits.enabled', function (enabled){
          if(enabled){
            chart.credits.show();
          } else if(chart.credits){
            chart.credits.hide();
          }
        });

        scope.$watch('config.useHighStocks', function (useHighStocks, oldUseHighStocks){
          if(useHighStocks === oldUseHighStocks) return;
          initChart();
        });

        angular.forEach(axisNames, function(axisName){
          scope.$watch('config.' + axisName, function (newAxes, oldAxes){
            if(newAxes === oldAxes) return;
            if(newAxes){
              chart[axisName][0].update(newAxes, false);
              updateZoom(chart[axisName][0], angular.copy(newAxes));
              chart.redraw();
            }
          }, true);
        });
        scope.$watch('config.options', function (newOptions, oldOptions, scope){
          //do nothing when called on registration
          if(newOptions === oldOptions) return;
          initChart();
          processSeries(scope.config.series);
          chart.redraw();
        }, true);

        scope.$watch('config.size', function (newSize, oldSize){
          if(newSize === oldSize) return;
          if(newSize){
            chart.setSize(newSize.width || undefined, newSize.height || undefined);
          }
        }, true);

        scope.$on('highchartsng.reflow', function (){
          chart.reflow();
        });

        scope.$on('$destroy', function(){
          if(chart) chart.destroy();
          element.remove();
        });
      }
    };
  });

/*
 Highcharts JS v5.0.7 (2017-01-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(u){"object"===typeof module&&module.exports?module.exports=u:u(Highcharts)})(function(u){(function(a){function p(a,b,d){this.init(a,b,d)}var v=a.each,w=a.extend,l=a.merge,q=a.splat;w(p.prototype,{init:function(a,b,d){var k=this,m=k.defaultOptions;k.chart=b;k.options=a=l(m,b.angular?{background:{}}:void 0,a);(a=a.background)&&v([].concat(q(a)).reverse(),function(b){var c,m=d.userOptions;c=l(k.defaultBackgroundOptions,b);b.backgroundColor&&(c.backgroundColor=b.backgroundColor);c.color=c.backgroundColor;
d.options.plotBands.unshift(c);m.plotBands=m.plotBands||[];m.plotBands!==d.options.plotBands&&m.plotBands.unshift(c)})},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{className:"highcharts-pane",shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"}});a.Pane=p})(u);(function(a){var p=a.CenteredSeriesMixin,
v=a.each,w=a.extend,l=a.map,q=a.merge,f=a.noop,b=a.Pane,d=a.pick,k=a.pInt,m=a.splat,n=a.wrap,c,g,h=a.Axis.prototype;a=a.Tick.prototype;c={getOffset:f,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:f,setCategories:f,setTitle:f};g={defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},
defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(b){b=this.options=q(this.defaultOptions,this.defaultRadialOptions,b);b.plotBands||(b.plotBands=[])},getOffset:function(){h.getOffset.call(this);this.chart.axisOffset[this.side]=0;this.center=this.pane.center=
p.getCenter.call(this.pane)},getLinePath:function(b,e){b=this.center;var c=this.chart,k=d(e,b[2]/2-this.offset);this.isCircular||void 0!==e?e=this.chart.renderer.symbols.arc(this.left+b[0],this.top+b[1],k,k,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}):(e=this.postTranslate(this.angleRad,k),e=["M",b[0]+c.plotLeft,b[1]+c.plotTop,"L",e.x,e.y]);return e},setAxisTranslation:function(){h.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/
(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&void 0===d(this.userMax,this.options.max)&&this.endAngleRad-this.startAngleRad===2*Math.PI)this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){h.setAxisSize.call(this);this.isRadial&&(this.center=this.pane.center=p.getCenter.call(this.pane),this.isCircular&&
(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*d(this.sector,1)/2)},getPosition:function(b,e){return this.postTranslate(this.isCircular?this.translate(b):this.angleRad,d(this.isCircular?e:this.translate(b),this.center[2]/2)-this.offset)},postTranslate:function(b,e){var d=this.chart,c=this.center;b=this.startAngleRad+b;return{x:d.plotLeft+c[0]+Math.cos(b)*e,y:d.plotTop+c[1]+Math.sin(b)*e}},getPlotBandPath:function(b,e,c){var m=this.center,t=this.startAngleRad,
h=m[2]/2,a=[d(c.outerRadius,"100%"),c.innerRadius,d(c.thickness,10)],r=Math.min(this.offset,0),g=/%$/,n,f=this.isCircular;"polygon"===this.options.gridLineInterpolation?m=this.getPlotLinePath(b).concat(this.getPlotLinePath(e,!0)):(b=Math.max(b,this.min),e=Math.min(e,this.max),f||(a[0]=this.translate(b),a[1]=this.translate(e)),a=l(a,function(b){g.test(b)&&(b=k(b,10)*h/100);return b}),"circle"!==c.shape&&f?(b=t+this.translate(b),e=t+this.translate(e)):(b=-Math.PI/2,e=1.5*Math.PI,n=!0),a[0]-=r,a[2]-=
r,m=this.chart.renderer.symbols.arc(this.left+m[0],this.top+m[1],a[0],a[0],{start:Math.min(b,e),end:Math.max(b,e),innerR:d(a[1],a[0]-a[2]),open:n}));return m},getPlotLinePath:function(b,e){var c=this,d=c.center,k=c.chart,m=c.getPosition(b),a,h,g;c.isCircular?g=["M",d[0]+k.plotLeft,d[1]+k.plotTop,"L",m.x,m.y]:"circle"===c.options.gridLineInterpolation?(b=c.translate(b))&&(g=c.getLinePath(0,b)):(v(k.xAxis,function(b){b.pane===c.pane&&(a=b)}),g=[],b=c.translate(b),d=a.tickPositions,a.autoConnect&&(d=
d.concat([d[0]])),e&&(d=[].concat(d).reverse()),v(d,function(c,d){h=a.getPosition(c,b);g.push(d?"L":"M",h.x,h.y)}));return g},getTitlePosition:function(){var b=this.center,c=this.chart,d=this.options.title;return{x:c.plotLeft+b[0]+(d.x||0),y:c.plotTop+b[1]-{high:.5,middle:.25,low:0}[d.align]*b[2]+(d.y||0)}}};n(h,"init",function(k,e,a){var h=e.angular,n=e.polar,t=a.isX,r=h&&t,f,x=e.options,l=a.pane||0;if(h){if(w(this,r?c:g),f=!t)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else n&&(w(this,
g),this.defaultRadialOptions=(f=t)?this.defaultRadialXOptions:q(this.defaultYAxisOptions,this.defaultRadialYOptions));h||n?(this.isRadial=!0,e.inverted=!1,x.chart.zoomType=null):this.isRadial=!1;k.call(this,e,a);r||!h&&!n||(k=this.options,e.panes||(e.panes=[]),this.pane=e=e.panes[l]=e.panes[l]||new b(m(x.pane)[l],e,this),e=e.options,this.angleRad=(k.angle||0)*Math.PI/180,this.startAngleRad=(e.startAngle-90)*Math.PI/180,this.endAngleRad=(d(e.endAngle,e.startAngle+360)-90)*Math.PI/180,this.offset=k.offset||
0,this.isCircular=f)});n(h,"autoLabelAlign",function(b){if(!this.isRadial)return b.apply(this,[].slice.call(arguments,1))});n(a,"getPosition",function(b,c,d,k,a){var e=this.axis;return e.getPosition?e.getPosition(d):b.call(this,c,d,k,a)});n(a,"getLabelPosition",function(b,c,k,a,m,h,g,n,f){var e=this.axis,t=h.y,r=20,z=h.align,x=(e.translate(this.pos)+e.startAngleRad+Math.PI/2)/Math.PI*180%360;e.isRadial?(b=e.getPosition(this.pos,e.center[2]/2+d(h.distance,-25)),"auto"===h.rotation?a.attr({rotation:x}):
null===t&&(t=e.chart.renderer.fontMetrics(a.styles.fontSize).b-a.getBBox().height/2),null===z&&(e.isCircular?(this.label.getBBox().width>e.len*e.tickInterval/(e.max-e.min)&&(r=0),z=x>r&&x<180-r?"left":x>180+r&&x<360-r?"right":"center"):z="center",a.attr({align:z})),b.x+=h.x,b.y+=t):b=b.call(this,c,k,a,m,h,g,n,f);return b});n(a,"getMarkPath",function(b,c,d,k,a,m,h){var e=this.axis;e.isRadial?(b=e.getPosition(this.pos,e.center[2]/2+k),c=["M",c,d,"L",b.x,b.y]):c=b.call(this,c,d,k,a,m,h);return c})})(u);
(function(a){var p=a.each,v=a.noop,w=a.pick,l=a.Series,q=a.seriesType,f=a.seriesTypes;q("arearange","area",{lineWidth:1,marker:null,threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{series.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0},states:{hover:{halo:!1}}},{pointArrayMap:["low","high"],dataLabelCollections:["dataLabel",
"dataLabelUpper"],toYData:function(b){return[b.low,b.high]},pointValKey:"low",deferTranslatePolar:!0,highToXY:function(b){var d=this.chart,k=this.xAxis.postTranslate(b.rectPlotX,this.yAxis.len-b.plotHigh);b.plotHighX=k.x-d.plotLeft;b.plotHigh=k.y-d.plotTop},translate:function(){var b=this,d=b.yAxis,k=!!b.modifyValue;f.area.prototype.translate.apply(b);p(b.points,function(a){var m=a.low,c=a.high,g=a.plotY;null===c||null===m?a.isNull=!0:(a.plotLow=g,a.plotHigh=d.translate(k?b.modifyValue(c,a):c,0,1,
0,1),k&&(a.yBottom=a.plotHigh))});this.chart.polar&&p(this.points,function(d){b.highToXY(d)})},getGraphPath:function(b){var d=[],k=[],a,n=f.area.prototype.getGraphPath,c,g,h;h=this.options;var r=this.chart.polar&&!1!==h.connectEnds,e=h.step;b=b||this.points;for(a=b.length;a--;)c=b[a],c.isNull||r||b[a+1]&&!b[a+1].isNull||k.push({plotX:c.plotX,plotY:c.plotY,doCurve:!1}),g={polarPlotY:c.polarPlotY,rectPlotX:c.rectPlotX,yBottom:c.yBottom,plotX:w(c.plotHighX,c.plotX),plotY:c.plotHigh,isNull:c.isNull},
k.push(g),d.push(g),c.isNull||r||b[a-1]&&!b[a-1].isNull||k.push({plotX:c.plotX,plotY:c.plotY,doCurve:!1});b=n.call(this,b);e&&(!0===e&&(e="left"),h.step={left:"right",center:"center",right:"left"}[e]);d=n.call(this,d);k=n.call(this,k);h.step=e;h=[].concat(b,d);this.chart.polar||"M"!==k[0]||(k[0]="L");this.graphPath=h;this.areaPath=this.areaPath.concat(b,k);h.isArea=!0;h.xMap=b.xMap;this.areaPath.xMap=b.xMap;return h},drawDataLabels:function(){var b=this.data,d=b.length,a,m=[],n=l.prototype,c=this.options.dataLabels,
g=c.align,h=c.verticalAlign,r=c.inside,e,t,f=this.chart.inverted;if(c.enabled||this._hasPointLabels){for(a=d;a--;)if(e=b[a])t=r?e.plotHigh<e.plotLow:e.plotHigh>e.plotLow,e.y=e.high,e._plotY=e.plotY,e.plotY=e.plotHigh,m[a]=e.dataLabel,e.dataLabel=e.dataLabelUpper,e.below=t,f?g||(c.align=t?"right":"left"):h||(c.verticalAlign=t?"top":"bottom"),c.x=c.xHigh,c.y=c.yHigh;n.drawDataLabels&&n.drawDataLabels.apply(this,arguments);for(a=d;a--;)if(e=b[a])t=r?e.plotHigh<e.plotLow:e.plotHigh>e.plotLow,e.dataLabelUpper=
e.dataLabel,e.dataLabel=m[a],e.y=e.low,e.plotY=e._plotY,e.below=!t,f?g||(c.align=t?"left":"right"):h||(c.verticalAlign=t?"bottom":"top"),c.x=c.xLow,c.y=c.yLow;n.drawDataLabels&&n.drawDataLabels.apply(this,arguments)}c.align=g;c.verticalAlign=h},alignDataLabel:function(){f.column.prototype.alignDataLabel.apply(this,arguments)},setStackedPoints:v,getSymbol:v,drawPoints:v})})(u);(function(a){var p=a.seriesType;p("areasplinerange","arearange",null,{getPointSpline:a.seriesTypes.spline.prototype.getPointSpline})})(u);
(function(a){var p=a.defaultPlotOptions,v=a.each,w=a.merge,l=a.noop,q=a.pick,f=a.seriesType,b=a.seriesTypes.column.prototype;f("columnrange","arearange",w(p.column,p.arearange,{lineWidth:1,pointRange:null}),{translate:function(){var d=this,a=d.yAxis,m=d.xAxis,n=m.startAngleRad,c,g=d.chart,h=d.xAxis.isRadial,r;b.translate.apply(d);v(d.points,function(b){var e=b.shapeArgs,k=d.options.minPointLength,f,l;b.plotHigh=r=a.translate(b.high,0,1,0,1);b.plotLow=b.plotY;l=r;f=q(b.rectPlotY,b.plotY)-r;Math.abs(f)<
k?(k-=f,f+=k,l-=k/2):0>f&&(f*=-1,l-=f);h?(c=b.barX+n,b.shapeType="path",b.shapeArgs={d:d.polarArc(l+f,l,c,c+b.pointWidth)}):(e.height=f,e.y=l,b.tooltipPos=g.inverted?[a.len+a.pos-g.plotLeft-l-f/2,m.len+m.pos-g.plotTop-e.x-e.width/2,f]:[m.left-g.plotLeft+e.x+e.width/2,a.pos-g.plotTop+l+f/2,f])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:l,crispCol:b.crispCol,drawPoints:b.drawPoints,drawTracker:b.drawTracker,getColumnMetrics:b.getColumnMetrics,animate:function(){return b.animate.apply(this,
arguments)},polarArc:function(){return b.polarArc.apply(this,arguments)},pointAttribs:b.pointAttribs})})(u);(function(a){var p=a.each,v=a.isNumber,w=a.merge,l=a.pick,q=a.pInt,f=a.Series,b=a.seriesType,d=a.TrackerMixin;b("gauge","line",{dataLabels:{enabled:!0,defer:!1,y:15,borderRadius:3,crop:!1,verticalAlign:"top",zIndex:2,borderWidth:1,borderColor:"#cccccc"},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:a.noop,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,
trackerGroups:["group","dataLabelsGroup"],translate:function(){var b=this.yAxis,a=this.options,d=b.center;this.generatePoints();p(this.points,function(c){var k=w(a.dial,c.dial),h=q(l(k.radius,80))*d[2]/200,m=q(l(k.baseLength,70))*h/100,e=q(l(k.rearLength,10))*h/100,n=k.baseWidth||3,f=k.topWidth||1,p=a.overshoot,y=b.startAngleRad+b.translate(c.y,null,null,null,!0);v(p)?(p=p/180*Math.PI,y=Math.max(b.startAngleRad-p,Math.min(b.endAngleRad+p,y))):!1===a.wrap&&(y=Math.max(b.startAngleRad,Math.min(b.endAngleRad,
y)));y=180*y/Math.PI;c.shapeType="path";c.shapeArgs={d:k.path||["M",-e,-n/2,"L",m,-n/2,h,-f/2,h,f/2,m,n/2,-e,n/2,"z"],translateX:d[0],translateY:d[1],rotation:y};c.plotX=d[0];c.plotY=d[1]})},drawPoints:function(){var b=this,a=b.yAxis.center,d=b.pivot,c=b.options,g=c.pivot,h=b.chart.renderer;p(b.points,function(a){var d=a.graphic,k=a.shapeArgs,g=k.d,m=w(c.dial,a.dial);d?(d.animate(k),k.d=g):(a.graphic=h[a.shapeType](k).attr({rotation:k.rotation,zIndex:1}).addClass("highcharts-dial").add(b.group),a.graphic.attr({stroke:m.borderColor||
"none","stroke-width":m.borderWidth||0,fill:m.backgroundColor||"#000000"}))});d?d.animate({translateX:a[0],translateY:a[1]}):(b.pivot=h.circle(0,0,l(g.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(a[0],a[1]).add(b.group),b.pivot.attr({"stroke-width":g.borderWidth||0,stroke:g.borderColor||"#cccccc",fill:g.backgroundColor||"#000000"}))},animate:function(b){var a=this;b||(p(a.points,function(b){var d=b.graphic;d&&(d.attr({rotation:180*a.yAxis.startAngleRad/Math.PI}),d.animate({rotation:b.shapeArgs.rotation},
a.options.animation))}),a.animate=null)},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);f.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(b,a){f.prototype.setData.call(this,b,!1);this.processData();this.generatePoints();l(a,!0)&&this.chart.redraw()},drawTracker:d&&d.drawTrackerPoint},{setState:function(b){this.state=b}})})(u);(function(a){var p=a.each,v=a.noop,w=a.pick,l=a.seriesType,
q=a.seriesTypes;l("boxplot","column",{threshold:null,tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cb\x3e {series.name}\x3c/b\x3e\x3cbr/\x3eMaximum: {point.high}\x3cbr/\x3eUpper quartile: {point.q3}\x3cbr/\x3eMedian: {point.median}\x3cbr/\x3eLower quartile: {point.q1}\x3cbr/\x3eMinimum: {point.low}\x3cbr/\x3e'},whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,states:{hover:{brightness:-.3}},whiskerWidth:2},{pointArrayMap:["low","q1","median",
"q3","high"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttribs:function(a){var b=this.options,d=a&&a.color||this.color;return{fill:a.fillColor||b.fillColor||d,stroke:b.lineColor||d,"stroke-width":b.lineWidth||0}},drawDataLabels:v,translate:function(){var a=this.yAxis,b=this.pointArrayMap;q.column.prototype.translate.apply(this);p(this.points,function(d){p(b,function(b){null!==d[b]&&(d[b+"Plot"]=a.translate(d[b],0,1,0,1))})})},drawPoints:function(){var a=
this,b=a.options,d=a.chart.renderer,k,m,n,c,g,h,r=0,e,t,l,q,y=!1!==a.doQuartiles,v,B=a.options.whiskerLength;p(a.points,function(f){var p=f.graphic,z=p?"animate":"attr",x=f.shapeArgs,u={},D={},H={},I=f.color||a.color;void 0!==f.plotY&&(e=x.width,t=Math.floor(x.x),l=t+e,q=Math.round(e/2),k=Math.floor(y?f.q1Plot:f.lowPlot),m=Math.floor(y?f.q3Plot:f.lowPlot),n=Math.floor(f.highPlot),c=Math.floor(f.lowPlot),p||(f.graphic=p=d.g("point").add(a.group),f.stem=d.path().addClass("highcharts-boxplot-stem").add(p),
B&&(f.whiskers=d.path().addClass("highcharts-boxplot-whisker").add(p)),y&&(f.box=d.path(void 0).addClass("highcharts-boxplot-box").add(p)),f.medianShape=d.path(void 0).addClass("highcharts-boxplot-median").add(p),u.stroke=f.stemColor||b.stemColor||I,u["stroke-width"]=w(f.stemWidth,b.stemWidth,b.lineWidth),u.dashstyle=f.stemDashStyle||b.stemDashStyle,f.stem.attr(u),B&&(D.stroke=f.whiskerColor||b.whiskerColor||I,D["stroke-width"]=w(f.whiskerWidth,b.whiskerWidth,b.lineWidth),f.whiskers.attr(D)),y&&(p=
a.pointAttribs(f),f.box.attr(p)),H.stroke=f.medianColor||b.medianColor||I,H["stroke-width"]=w(f.medianWidth,b.medianWidth,b.lineWidth),f.medianShape.attr(H)),h=f.stem.strokeWidth()%2/2,r=t+q+h,f.stem[z]({d:["M",r,m,"L",r,n,"M",r,k,"L",r,c]}),y&&(h=f.box.strokeWidth()%2/2,k=Math.floor(k)+h,m=Math.floor(m)+h,t+=h,l+=h,f.box[z]({d:["M",t,m,"L",t,k,"L",l,k,"L",l,m,"L",t,m,"z"]})),B&&(h=f.whiskers.strokeWidth()%2/2,n+=h,c+=h,v=/%$/.test(B)?q*parseFloat(B)/100:B/2,f.whiskers[z]({d:["M",r-v,n,"L",r+v,n,
"M",r-v,c,"L",r+v,c]})),g=Math.round(f.medianPlot),h=f.medianShape.strokeWidth()%2/2,g+=h,f.medianShape[z]({d:["M",t,g,"L",l,g]}))})},setStackedPoints:v})})(u);(function(a){var p=a.each,v=a.noop,w=a.seriesType,l=a.seriesTypes;w("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.low}\x3c/b\x3e - \x3cb\x3e{point.high}\x3c/b\x3e\x3cbr/\x3e'},whiskerWidth:null},{type:"errorbar",
pointArrayMap:["low","high"],toYData:function(a){return[a.low,a.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:l.arearange?function(){var a=this.pointValKey;l.arearange.prototype.drawDataLabels.call(this);p(this.data,function(f){f.y=f[a]})}:v,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||l.column.prototype.getColumnMetrics.call(this)}})})(u);(function(a){var p=a.correctFloat,v=a.isNumber,w=a.pick,l=a.Point,q=a.Series,f=a.seriesType,b=a.seriesTypes;
f("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",translate:function(){var a=this.options,k=this.yAxis,m,f,c,g,h,r,e,t,l,q=w(a.minPointLength,5),y=a.threshold,v=a.stacking,u=0,x=0,A;b.column.prototype.translate.apply(this);e=t=y;f=this.points;m=0;for(a=f.length;m<a;m++)c=f[m],r=this.processedYData[m],g=c.shapeArgs,h=v&&k.stacks[(this.negStacks&&r<y?"-":"")+this.stackKey],A=this.getStackIndicator(A,
c.x),l=h?h[c.x].points[this.index+","+m+","+A.index]:[0,r],c.isSum?c.y=p(r):c.isIntermediateSum&&(c.y=p(r-t)),h=Math.max(e,e+c.y)+l[0],g.y=k.toPixels(h,!0),c.isSum?(g.y=k.toPixels(l[1],!0),g.height=Math.min(k.toPixels(l[0],!0),k.len)-g.y+u+x):c.isIntermediateSum?(g.y=k.toPixels(l[1],!0),g.height=Math.min(k.toPixels(t,!0),k.len)-g.y+u+x,t=l[1]):(g.height=0<r?k.toPixels(e,!0)-g.y:k.toPixels(e,!0)-k.toPixels(e-r,!0),e+=r),0>g.height&&(g.y+=g.height,g.height*=-1),c.plotY=g.y=Math.round(g.y)-this.borderWidth%
2/2,g.height=Math.max(Math.round(g.height),.001),c.yBottom=g.y+g.height,g.y-=x,g.height<=q&&!c.isNull&&(g.height=q,0>c.y?x-=q:u+=q),g.y-=u,g=c.plotY-x-u+(c.negative&&0<=x?g.height:0),this.chart.inverted?c.tooltipPos[0]=k.len-g:c.tooltipPos[1]=g},processData:function(b){var a=this.yData,d=this.options.data,f,c=a.length,g,h,r,e,t,l;h=g=r=e=this.options.threshold||0;for(l=0;l<c;l++)t=a[l],f=d&&d[l]?d[l]:{},"sum"===t||f.isSum?a[l]=p(h):"intermediateSum"===t||f.isIntermediateSum?a[l]=p(g):(h+=t,g+=t),
r=Math.min(h,r),e=Math.max(h,e);q.prototype.processData.call(this,b);this.dataMin=r;this.dataMax=e},toYData:function(b){return b.isSum?0===b.x?null:"sum":b.isIntermediateSum?0===b.x?null:"intermediateSum":b.y},pointAttribs:function(a,k){var d=this.options.upColor;d&&!a.options.color&&(a.color=0<a.y?d:null);a=b.column.prototype.pointAttribs.call(this,a,k);delete a.dashstyle;return a},getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var b=this.data,a=b.length,f=this.graph.strokeWidth()+
this.borderWidth,f=Math.round(f)%2/2,n=[],c,g,h;for(h=1;h<a;h++)g=b[h].shapeArgs,c=b[h-1].shapeArgs,g=["M",c.x+c.width,c.y+f,"L",g.x,c.y+f],0>b[h-1].y&&(g[2]+=c.height,g[5]+=c.height),n=n.concat(g);return n},drawGraph:function(){q.prototype.drawGraph.call(this);this.graph.attr({d:this.getCrispPath()})},getExtremes:a.noop},{getClassName:function(){var b=l.prototype.getClassName.call(this);this.isSum?b+=" highcharts-sum":this.isIntermediateSum&&(b+=" highcharts-intermediate-sum");return b},isValid:function(){return v(this.y,
!0)||this.isSum||this.isIntermediateSum}})})(u);(function(a){var p=a.Series,v=a.seriesType,u=a.seriesTypes;v("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var a=p.prototype.getGraphPath.call(this),q=a.length+1;q--;)(q===a.length||"M"===a[q])&&0<q&&a.splice(q,0,"z");return this.areaPath=a},drawGraph:function(){this.options.fillColor=this.color;u.area.prototype.drawGraph.call(this)},
drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawTracker:p.prototype.drawTracker,setStackedPoints:a.noop})})(u);(function(a){var p=a.arrayMax,v=a.arrayMin,u=a.Axis,l=a.color,q=a.each,f=a.isNumber,b=a.noop,d=a.pick,k=a.pInt,m=a.Point,n=a.Series,c=a.seriesType,g=a.seriesTypes;c("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},marker:{lineColor:null,lineWidth:1,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",
softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["markerGroup","dataLabelsGroup"],bubblePadding:!0,zoneAxis:"z",pointAttribs:function(b,a){var c=d(this.options.marker.fillOpacity,.5);b=n.prototype.pointAttribs.call(this,b,a);1!==c&&(b.fill=l(b.fill).setOpacity(c).get("rgba"));return b},getRadii:function(b,a,c,d){var e,k,h,g=
this.zData,f=[],m=this.options,n="width"!==m.sizeBy,t=m.zThreshold,l=a-b;k=0;for(e=g.length;k<e;k++)h=g[k],m.sizeByAbsoluteValue&&null!==h&&(h=Math.abs(h-t),a=Math.max(a-t,Math.abs(b-t)),b=0),null===h?h=null:h<b?h=c/2-1:(h=0<l?(h-b)/l:.5,n&&0<=h&&(h=Math.sqrt(h)),h=Math.ceil(c+h*(d-c))/2),f.push(h);this.radii=f},animate:function(b){var a=this.options.animation;b||(q(this.points,function(b){var c=b.graphic,d;c&&c.width&&(d={x:c.x,y:c.y,width:c.width,height:c.height},c.attr({x:b.plotX,y:b.plotY,width:1,
height:1}),c.animate(d,a))}),this.animate=null)},translate:function(){var b,a=this.data,c,d,k=this.radii;g.scatter.prototype.translate.call(this);for(b=a.length;b--;)c=a[b],d=k?k[b]:0,f(d)&&d>=this.minPxSize/2?(c.marker={radius:d,width:2*d,height:2*d},c.dlBox={x:c.plotX-d,y:c.plotY-d,width:2*d,height:2*d}):c.shapeArgs=c.plotY=c.dlBox=void 0},alignDataLabel:g.column.prototype.alignDataLabel,buildKDTree:b,applyZones:b},{haloPath:function(b){return m.prototype.haloPath.call(this,0===b?0:this.marker.radius+
b)},ttBelow:!1});u.prototype.beforePadding=function(){var b=this,a=this.len,c=this.chart,g=0,m=a,n=this.isXAxis,l=n?"xData":"yData",u=this.min,w={},x=Math.min(c.plotWidth,c.plotHeight),A=Number.MAX_VALUE,E=-Number.MAX_VALUE,F=this.max-u,C=a/F,G=[];q(this.series,function(a){var e=a.options;!a.bubblePadding||!a.visible&&c.options.chart.ignoreHiddenSeries||(b.allowZoomOutside=!0,G.push(a),n&&(q(["minSize","maxSize"],function(b){var a=e[b],c=/%$/.test(a),a=k(a);w[b]=c?x*a/100:a}),a.minPxSize=w.minSize,
a.maxPxSize=Math.max(w.maxSize,w.minSize),a=a.zData,a.length&&(A=d(e.zMin,Math.min(A,Math.max(v(a),!1===e.displayNegative?e.zThreshold:-Number.MAX_VALUE))),E=d(e.zMax,Math.max(E,p(a))))))});q(G,function(a){var c=a[l],d=c.length,e;n&&a.getRadii(A,E,a.minPxSize,a.maxPxSize);if(0<F)for(;d--;)f(c[d])&&b.dataMin<=c[d]&&c[d]<=b.dataMax&&(e=a.radii[d],g=Math.min((c[d]-u)*C-e,g),m=Math.max((c[d]-u)*C+e,m))});G.length&&0<F&&!this.isLog&&(m-=a,C*=(a+g-m)/a,q([["min","userMin",g],["max","userMax",m]],function(a){void 0===
d(b.options[a[0]],b[a[1]])&&(b[a[0]]+=a[2]/C)}))}})(u);(function(a){function p(b,a){var d=this.chart,f=this.options.animation,n=this.group,c=this.markerGroup,g=this.xAxis.center,h=d.plotLeft,l=d.plotTop;d.polar?d.renderer.isSVG&&(!0===f&&(f={}),a?(b={translateX:g[0]+h,translateY:g[1]+l,scaleX:.001,scaleY:.001},n.attr(b),c&&c.attr(b)):(b={translateX:h,translateY:l,scaleX:1,scaleY:1},n.animate(b,f),c&&c.animate(b,f),this.animate=null)):b.call(this,a)}var u=a.each,w=a.pick,l=a.seriesTypes,q=a.wrap,f=
a.Series.prototype;a=a.Pointer.prototype;f.searchPointByAngle=function(b){var a=this.chart,k=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(b.chartX-k[0]-a.plotLeft,b.chartY-k[1]-a.plotTop)})};q(f,"buildKDTree",function(b){this.chart.polar&&(this.kdByAngle?this.searchPoint=this.searchPointByAngle:this.kdDimensions=2);b.apply(this)});f.toXY=function(b){var a,k=this.chart,f=b.plotX;a=b.plotY;b.rectPlotX=f;b.rectPlotY=a;a=this.xAxis.postTranslate(b.plotX,this.yAxis.len-
a);b.plotX=b.polarPlotX=a.x-k.plotLeft;b.plotY=b.polarPlotY=a.y-k.plotTop;this.kdByAngle?(k=(f/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>k&&(k+=360),b.clientX=k):b.clientX=b.plotX};l.spline&&q(l.spline.prototype,"getPointSpline",function(b,a,k,f){var d,c,g,h,m,e,l;this.chart.polar?(d=k.plotX,c=k.plotY,b=a[f-1],g=a[f+1],this.connectEnds&&(b||(b=a[a.length-2]),g||(g=a[1])),b&&g&&(h=b.plotX,m=b.plotY,a=g.plotX,e=g.plotY,h=(1.5*d+h)/2.5,m=(1.5*c+m)/2.5,g=(1.5*d+a)/2.5,l=(1.5*c+e)/2.5,a=Math.sqrt(Math.pow(h-
d,2)+Math.pow(m-c,2)),e=Math.sqrt(Math.pow(g-d,2)+Math.pow(l-c,2)),h=Math.atan2(m-c,h-d),m=Math.atan2(l-c,g-d),l=Math.PI/2+(h+m)/2,Math.abs(h-l)>Math.PI/2&&(l-=Math.PI),h=d+Math.cos(l)*a,m=c+Math.sin(l)*a,g=d+Math.cos(Math.PI+l)*e,l=c+Math.sin(Math.PI+l)*e,k.rightContX=g,k.rightContY=l),f?(k=["C",b.rightContX||b.plotX,b.rightContY||b.plotY,h||d,m||c,d,c],b.rightContX=b.rightContY=null):k=["M",d,c]):k=b.call(this,a,k,f);return k});q(f,"translate",function(a){var b=this.chart;a.call(this);if(b.polar&&
(this.kdByAngle=b.tooltip&&b.tooltip.shared,!this.preventPostTranslate))for(a=this.points,b=a.length;b--;)this.toXY(a[b])});q(f,"getGraphPath",function(a,d){var b=this,f,l;if(this.chart.polar){d=d||this.points;for(f=0;f<d.length;f++)if(!d[f].isNull){l=f;break}!1!==this.options.connectEnds&&void 0!==l&&(this.connectEnds=!0,d.splice(d.length,0,d[l]));u(d,function(a){void 0===a.polarPlotY&&b.toXY(a)})}return a.apply(this,[].slice.call(arguments,1))});q(f,"animate",p);l.column&&(l=l.column.prototype,
l.polarArc=function(a,d,f,l){var b=this.xAxis.center,c=this.yAxis.len;return this.chart.renderer.symbols.arc(b[0],b[1],c-d,null,{start:f,end:l,innerR:c-w(a,c)})},q(l,"animate",p),q(l,"translate",function(a){var b=this.xAxis,f=b.startAngleRad,l,n,c;this.preventPostTranslate=!0;a.call(this);if(b.isRadial)for(l=this.points,c=l.length;c--;)n=l[c],a=n.barX+f,n.shapeType="path",n.shapeArgs={d:this.polarArc(n.yBottom,n.plotY,a,a+n.pointWidth)},this.toXY(n),n.tooltipPos=[n.plotX,n.plotY],n.ttBelow=n.plotY>
b.center[1]}),q(l,"alignDataLabel",function(a,d,k,l,n,c){this.chart.polar?(a=d.rectPlotX/Math.PI*180,null===l.align&&(l.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===l.verticalAlign&&(l.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),f.alignDataLabel.call(this,d,k,l,n,c)):a.call(this,d,k,l,n,c)}));q(a,"getCoordinates",function(a,d){var b=this.chart,f={xAxis:[],yAxis:[]};b.polar?u(b.axes,function(a){var c=a.isXAxis,g=a.center,h=d.chartX-g[0]-b.plotLeft,g=d.chartY-g[1]-
b.plotTop;f[c?"xAxis":"yAxis"].push({axis:a,value:a.translate(c?Math.PI-Math.atan2(h,g):Math.sqrt(Math.pow(h,2)+Math.pow(g,2)),!0)})}):f=a.call(this,d);return f})})(u)});

/*
 Highcharts JS v5.0.7 (2017-01-17)
 Exporting module

 (c) 2010-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(h){"object"===typeof module&&module.exports?module.exports=h:h(Highcharts)})(function(h){(function(f){var h=f.defaultOptions,n=f.doc,A=f.Chart,u=f.addEvent,F=f.removeEvent,D=f.fireEvent,q=f.createElement,B=f.discardElement,v=f.css,p=f.merge,C=f.pick,k=f.each,r=f.extend,G=f.isTouchDevice,E=f.win,H=f.Renderer.prototype.symbols;r(h.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",
contextButtonTitle:"Chart context menu"});h.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};p(!0,h.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",color:"#333333",fontSize:G?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",
symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});h.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:[{textKey:"printChart",onclick:function(){this.print()}},{separator:!0},{textKey:"downloadPNG",onclick:function(){this.exportChart()}},{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},
{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}]}}};f.post=function(a,c,e){var b;a=q("form",p({method:"post",action:a,enctype:"multipart/form-data"},e),{display:"none"},n.body);for(b in c)q("input",{type:"hidden",name:b,value:c[b]},null,a);a.submit();B(a)};r(A.prototype,{sanitizeSVG:function(a,c){if(c&&c.exporting&&c.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&(e=
'\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+c.chart.width+'" height\x3d"'+c.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (NS[0-9]+\:)?href=/g,
" xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");return a=a.replace(/<IMG /g,"\x3cimage ").replace(/<(\/?)TITLE>/g,"\x3c$1title\x3e").replace(/height=([^" ]+)/g,'height\x3d"$1"').replace(/width=([^" ]+)/g,'width\x3d"$1"').replace(/hc-svg-href="([^"]+)">/g,'xlink:href\x3d"$1"/\x3e').replace(/ id=([^" >]+)/g,' id\x3d"$1"').replace(/class=([^" >]+)/g,
'class\x3d"$1"').replace(/ transform /g," ").replace(/:(path|rect)/g,"$1").replace(/style="([^"]+)"/g,function(a){return a.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var c,e,b,w,m,g=p(this.options,a);n.createElementNS||(n.createElementNS=function(a,c){return n.createElement(c)});e=q("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},n.body);b=this.renderTo.style.width;m=this.renderTo.style.height;
b=g.exporting.sourceWidth||g.chart.width||/px$/.test(b)&&parseInt(b,10)||600;m=g.exporting.sourceHeight||g.chart.height||/px$/.test(m)&&parseInt(m,10)||400;r(g.chart,{animation:!1,renderTo:e,forExport:!0,renderer:"SVGRenderer",width:b,height:m});g.exporting.enabled=!1;delete g.data;g.series=[];k(this.series,function(a){w=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});w.isInternal||g.series.push(w)});k(this.axes,function(a){a.userOptions.internalKey=f.uniqueKey()});
c=new f.Chart(g,this.callback);a&&k(["xAxis","yAxis","series"],function(b){var d={};a[b]&&(d[b]=a[b],c.update(d))});k(this.axes,function(a){var b=f.find(c.axes,function(b){return b.options.internalKey===a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;!b||void 0===e&&void 0===d||b.setExtremes(e,d,!0,!1)});b=c.getChartHTML();b=this.sanitizeSVG(b,g);g=null;c.destroy();B(e);return b},getSVGForExport:function(a,c){var e=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},
e.chartOptions,c,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,c){c=this.getSVGForExport(a,c);a=p(this.options.exporting,a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,svg:c},a.formAttributes)},print:function(){var a=this,c=a.container,e=[],b=c.parentNode,f=n.body,m=f.childNodes,g=a.options.exporting.printMaxWidth,d,t;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,
0);D(a,"beforePrint");if(t=g&&a.chartWidth>g)d=[a.options.chart.width,void 0,!1],a.setSize(g,void 0,!1);k(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(c);E.focus();E.print();setTimeout(function(){b.appendChild(c);k(m,function(a,b){1===a.nodeType&&(a.style.display=e[b])});a.isPrinting=!1;t&&a.setSize.apply(a,d);D(a,"afterPrint")},1E3)}},contextMenu:function(a,c,e,b,f,m,g){var d=this,t=d.options.navigation,w=d.chartWidth,h=d.chartHeight,p="cache-"+a,
l=d[p],x=Math.max(f,m),y,z;l||(d[p]=l=q("div",{className:a},{position:"absolute",zIndex:1E3,padding:x+"px"},d.container),y=q("div",{className:"highcharts-menu"},null,l),v(y,r({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},t.menuStyle)),z=function(){v(l,{display:"none"});g&&g.setState(0);d.openMenu=!1},u(l,"mouseleave",function(){l.hideTimer=setTimeout(z,500)}),u(l,"mouseenter",function(){clearTimeout(l.hideTimer)}),p=u(n,"mouseup",function(b){d.pointer.inClass(b.target,
a)||z()}),u(d,"destroy",p),k(c,function(a){if(a){var b;a.separator?b=q("hr",null,null,y):(b=q("div",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();z();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,y),b.onmouseover=function(){v(this,t.menuItemHoverStyle)},b.onmouseout=function(){v(this,t.menuItemStyle)},v(b,r({cursor:"pointer"},t.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(y,l),d.exportMenuWidth=
l.offsetWidth,d.exportMenuHeight=l.offsetHeight);c={display:"block"};e+d.exportMenuWidth>w?c.right=w-e-f-x+"px":c.left=e-x+"px";b+m+d.exportMenuHeight>h&&"top"!==g.alignOptions.verticalAlign?c.bottom=h-b-x+"px":c.top=b+m-x+"px";v(l,c);d.openMenu=!0},addButton:function(a){var c=this,e=c.renderer,b=p(c.options.navigation.buttonOptions,a),f=b.onclick,m=b.menuItems,g,d,h=b.symbolSize||12;c.btnCount||(c.btnCount=0);c.exportDivElements||(c.exportDivElements=[],c.exportSVGElements=[]);if(!1!==b.enabled){var k=
b.theme,n=k.states,q=n&&n.hover,n=n&&n.select,l;delete k.states;f?l=function(a){a.stopPropagation();f.call(c,a)}:m&&(l=function(){c.contextMenu(d.menuClassName,m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});b.text&&b.symbol?k.paddingLeft=C(k.paddingLeft,25):b.text||r(k,{width:b.width,height:b.height,padding:0});d=e.button(b.text,0,0,l,k,q,n).addClass(a.className).attr({"stroke-linecap":"round",title:c.options.lang[b._titleKey],zIndex:3});d.menuClassName=a.menuClassName||"highcharts-menu-"+
c.btnCount++;b.symbol&&(g=e.symbol(b.symbol,b.symbolX-h/2,b.symbolY-h/2,h,h).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),g.attr({stroke:b.symbolStroke,fill:b.symbolFill,"stroke-width":b.symbolStrokeWidth||1}));d.add().align(r(b,{width:d.width,x:C(b.x,c.buttonOffset)}),!0,"spacingBox");c.buttonOffset+=(d.width+b.buttonSpacing)*("right"===b.align?-1:1);c.exportSVGElements.push(d,g)}},destroyExport:function(a){var c=a?a.target:this;a=c.exportSVGElements;var e=c.exportDivElements;a&&
(k(a,function(a,e){a&&(a.onclick=a.ontouchstart=null,c.exportSVGElements[e]=a.destroy())}),a.length=0);e&&(k(e,function(a,e){clearTimeout(a.hideTimer);F(a,"mouseleave");c.exportDivElements[e]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;B(a)}),e.length=0)}});H.menu=function(a,c,e,b){return["M",a,c+2.5,"L",a+e,c+2.5,"M",a,c+b/2+.5,"L",a+e,c+b/2+.5,"M",a,c+b-1.5,"L",a+e,c+b-1.5]};A.prototype.renderExporting=function(){var a,c=this.options.exporting,e=c.buttons,b=this.isDirtyExporting||!this.exportSVGElements;
this.buttonOffset=0;this.isDirtyExporting&&this.destroyExport();if(b&&!1!==c.enabled){for(a in e)this.addButton(e[a]);this.isDirtyExporting=!1}u(this,"destroy",this.destroyExport)};A.prototype.callbacks.push(function(a){a.renderExporting();u(a,"redraw",a.renderExporting);k(["exporting","navigation"],function(c){a[c]={update:function(e,b){a.isDirtyExporting=!0;p(!0,a.options[c],e);C(b,!0)&&a.redraw()}}})})})(h)});

/**
 * @license
 * lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function t(t,n){return t.set(n[0],n[1]),t}function n(t,n){return t.add(n),t}function r(t,n,r){switch(r.length){case 0:return t.call(n);case 1:return t.call(n,r[0]);case 2:return t.call(n,r[0],r[1]);case 3:return t.call(n,r[0],r[1],r[2])}return t.apply(n,r)}function e(t,n,r,e){for(var u=-1,o=t?t.length:0;++u<o;){var i=t[u];n(e,i,r(i),t)}return e}function u(t,n){for(var r=-1,e=t?t.length:0;++r<e&&false!==n(t[r],r,t););return t}function o(t,n){for(var r=t?t.length:0;r--&&false!==n(t[r],r,t););
return t}function i(t,n){for(var r=-1,e=t?t.length:0;++r<e;)if(!n(t[r],r,t))return false;return true}function f(t,n){for(var r=-1,e=t?t.length:0,u=0,o=[];++r<e;){var i=t[r];n(i,r,t)&&(o[u++]=i)}return o}function c(t,n){return!(!t||!t.length)&&-1<d(t,n,0)}function a(t,n,r){for(var e=-1,u=t?t.length:0;++e<u;)if(r(n,t[e]))return true;return false}function l(t,n){for(var r=-1,e=t?t.length:0,u=Array(e);++r<e;)u[r]=n(t[r],r,t);return u}function s(t,n){for(var r=-1,e=n.length,u=t.length;++r<e;)t[u+r]=n[r];return t}function h(t,n,r,e){
var u=-1,o=t?t.length:0;for(e&&o&&(r=t[++u]);++u<o;)r=n(r,t[u],u,t);return r}function p(t,n,r,e){var u=t?t.length:0;for(e&&u&&(r=t[--u]);u--;)r=n(r,t[u],u,t);return r}function _(t,n){for(var r=-1,e=t?t.length:0;++r<e;)if(n(t[r],r,t))return true;return false}function v(t,n,r){var e;return r(t,function(t,r,u){if(n(t,r,u))return e=r,false}),e}function g(t,n,r,e){var u=t.length;for(r+=e?1:-1;e?r--:++r<u;)if(n(t[r],r,t))return r;return-1}function d(t,n,r){if(n!==n)return g(t,b,r);--r;for(var e=t.length;++r<e;)if(t[r]===n)return r;
return-1}function y(t,n,r,e){--r;for(var u=t.length;++r<u;)if(e(t[r],n))return r;return-1}function b(t){return t!==t}function x(t,n){var r=t?t.length:0;return r?k(t,n)/r:q}function j(t){return function(n){return null==n?P:n[t]}}function w(t){return function(n){return null==t?P:t[n]}}function m(t,n,r,e,u){return u(t,function(t,u,o){r=e?(e=false,t):n(r,t,u,o)}),r}function A(t,n){var r=t.length;for(t.sort(n);r--;)t[r]=t[r].c;return t}function k(t,n){for(var r,e=-1,u=t.length;++e<u;){var o=n(t[e]);o!==P&&(r=r===P?o:r+o);
}return r}function E(t,n){for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);return e}function O(t,n){return l(n,function(n){return[n,t[n]]})}function S(t){return function(n){return t(n)}}function I(t,n){return l(n,function(n){return t[n]})}function R(t,n){return t.has(n)}function W(t,n){for(var r=-1,e=t.length;++r<e&&-1<d(n,t[r],0););return r}function B(t,n){for(var r=t.length;r--&&-1<d(n,t[r],0););return r}function L(t){return"\\"+Ft[t]}function C(t){var n=false;if(null!=t&&typeof t.toString!="function")try{
n=!!(t+"")}catch(t){}return n}function U(t){var n=-1,r=Array(t.size);return t.forEach(function(t,e){r[++n]=[e,t]}),r}function M(t,n){return function(r){return t(n(r))}}function z(t,n){for(var r=-1,e=t.length,u=0,o=[];++r<e;){var i=t[r];i!==n&&"__lodash_placeholder__"!==i||(t[r]="__lodash_placeholder__",o[u++]=r)}return o}function D(t){var n=-1,r=Array(t.size);return t.forEach(function(t){r[++n]=t}),r}function T(t){var n=-1,r=Array(t.size);return t.forEach(function(t){r[++n]=[t,t]}),r}function $(t){
if(Ut.test(t)){for(var n=Lt.lastIndex=0;Lt.test(t);)n++;t=n}else t=en(t);return t}function F(t){return Ut.test(t)?t.match(Lt)||[]:t.split("")}function N(w){function St(t){return Hu.call(t)}function It(t){if(ou(t)&&!Fi(t)&&!(t instanceof $t)){if(t instanceof Lt)return t;if(Gu.call(t,"__wrapped__"))return Oe(t)}return new Lt(t)}function Rt(){}function Lt(t,n){this.__wrapped__=t,this.__actions__=[],this.__chain__=!!n,this.__index__=0,this.__values__=P}function $t(t){this.__wrapped__=t,this.__actions__=[],
this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Ft(t){var n=-1,r=t?t.length:0;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}function Zt(t){var n=-1,r=t?t.length:0;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}function qt(t){var n=-1,r=t?t.length:0;for(this.clear();++n<r;){var e=t[n];this.set(e[0],e[1])}}function Kt(t){var n=-1,r=t?t.length:0;for(this.__data__=new qt;++n<r;)this.add(t[n])}function Gt(t){this.__data__=new Zt(t);
}function Yt(t,n){var r,e=Fi(t)||He(t)?E(t.length,Fu):[],u=e.length,o=!!u;for(r in t)!n&&!Gu.call(t,r)||o&&("length"==r||ge(r,u))||e.push(r);return e}function en(t,n,r,e){return t===P||Ye(t,Zu[r])&&!Gu.call(e,r)?n:t}function an(t,n,r){(r===P||Ye(t[n],r))&&(typeof n!="number"||r!==P||n in t)||(t[n]=r)}function ln(t,n,r){var e=t[n];Gu.call(t,n)&&Ye(e,r)&&(r!==P||n in t)||(t[n]=r)}function sn(t,n){for(var r=t.length;r--;)if(Ye(t[r][0],n))return r;return-1}function hn(t,n,r,e){return Po(t,function(t,u,o){
n(e,t,r(t),o)}),e}function pn(t,n){return t&&Br(n,bu(n),t)}function _n(t,n){for(var r=-1,e=null==t,u=n.length,o=Cu(u);++r<u;)o[r]=e?P:du(t,n[r]);return o}function vn(t,n,r){return t===t&&(r!==P&&(t=t<=r?t:r),n!==P&&(t=t>=n?t:n)),t}function gn(t,n,r,e,o,i,f){var c;if(e&&(c=i?e(t,o,i,f):e(t)),c!==P)return c;if(!uu(t))return t;if(o=Fi(t)){if(c=he(t),!n)return Wr(t,c)}else{var a=St(t),l="[object Function]"==a||"[object GeneratorFunction]"==a;if(Pi(t))return Er(t,n);if("[object Object]"==a||"[object Arguments]"==a||l&&!i){
if(C(t))return i?t:{};if(c=pe(l?{}:t),!n)return Lr(t,pn(c,t))}else{if(!Tt[a])return i?t:{};c=_e(t,a,gn,n)}}if(f||(f=new Gt),i=f.get(t))return i;if(f.set(t,c),!o)var s=r?Rn(t,bu,Ho):bu(t);return u(s||t,function(u,o){s&&(o=u,u=t[o]),ln(c,o,gn(u,n,r,e,o,t,f))}),c}function dn(t){var n=bu(t);return function(r){return yn(r,t,n)}}function yn(t,n,r){var e=r.length;if(null==t)return!e;for(t=Tu(t);e--;){var u=r[e],o=n[u],i=t[u];if(i===P&&!(u in t)||!o(i))return false}return true}function bn(t){return uu(t)?oo(t):{};
}function xn(t,n,r){if(typeof t!="function")throw new Nu("Expected a function");return ni(function(){t.apply(P,r)},n)}function jn(t,n,r,e){var u=-1,o=c,i=true,f=t.length,s=[],h=n.length;if(!f)return s;r&&(n=l(n,S(r))),e?(o=a,i=false):200<=n.length&&(o=R,i=false,n=new Kt(n));t:for(;++u<f;){var p=t[u],_=r?r(p):p,p=e||0!==p?p:0;if(i&&_===_){for(var v=h;v--;)if(n[v]===_)continue t;s.push(p)}else o(n,_,e)||s.push(p)}return s}function wn(t,n){var r=true;return Po(t,function(t,e,u){return r=!!n(t,e,u)}),r}function mn(t,n,r){
for(var e=-1,u=t.length;++e<u;){var o=t[e],i=n(o);if(null!=i&&(f===P?i===i&&!au(i):r(i,f)))var f=i,c=o}return c}function An(t,n){var r=[];return Po(t,function(t,e,u){n(t,e,u)&&r.push(t)}),r}function kn(t,n,r,e,u){var o=-1,i=t.length;for(r||(r=ve),u||(u=[]);++o<i;){var f=t[o];0<n&&r(f)?1<n?kn(f,n-1,r,e,u):s(u,f):e||(u[u.length]=f)}return u}function En(t,n){return t&&qo(t,n,bu)}function On(t,n){return t&&Vo(t,n,bu)}function Sn(t,n){return f(n,function(n){return nu(t[n])})}function In(t,n){n=ye(n,t)?[n]:Ar(n);
for(var r=0,e=n.length;null!=t&&r<e;)t=t[Ae(n[r++])];return r&&r==e?t:P}function Rn(t,n,r){return n=n(t),Fi(t)?n:s(n,r(t))}function Wn(t,n){return t>n}function Bn(t,n){return null!=t&&Gu.call(t,n)}function Ln(t,n){return null!=t&&n in Tu(t)}function Cn(t,n,r){for(var e=r?a:c,u=t[0].length,o=t.length,i=o,f=Cu(o),s=1/0,h=[];i--;){var p=t[i];i&&n&&(p=l(p,S(n))),s=jo(p.length,s),f[i]=!r&&(n||120<=u&&120<=p.length)?new Kt(i&&p):P}var p=t[0],_=-1,v=f[0];t:for(;++_<u&&h.length<s;){var g=p[_],d=n?n(g):g,g=r||0!==g?g:0;
if(v?!R(v,d):!e(h,d,r)){for(i=o;--i;){var y=f[i];if(y?!R(y,d):!e(t[i],d,r))continue t}v&&v.push(d),h.push(g)}}return h}function Un(t,n,r){var e={};return En(t,function(t,u,o){n(e,r(t),u,o)}),e}function Mn(t,n,e){return ye(n,t)||(n=Ar(n),t=me(t,n),n=We(n)),n=null==t?t:t[Ae(n)],null==n?P:r(n,t,e)}function zn(t){return ou(t)&&"[object ArrayBuffer]"==Hu.call(t)}function Dn(t){return ou(t)&&"[object Date]"==Hu.call(t)}function Tn(t,n,r,e,u){if(t===n)n=true;else if(null==t||null==n||!uu(t)&&!ou(n))n=t!==t&&n!==n;else t:{
var o=Fi(t),i=Fi(n),f="[object Array]",c="[object Array]";o||(f=St(t),f="[object Arguments]"==f?"[object Object]":f),i||(c=St(n),c="[object Arguments]"==c?"[object Object]":c);var a="[object Object]"==f&&!C(t),i="[object Object]"==c&&!C(n);if((c=f==c)&&!a)u||(u=new Gt),n=o||Gi(t)?ee(t,n,Tn,r,e,u):ue(t,n,f,Tn,r,e,u);else{if(!(2&e)&&(o=a&&Gu.call(t,"__wrapped__"),f=i&&Gu.call(n,"__wrapped__"),o||f)){t=o?t.value():t,n=f?n.value():n,u||(u=new Gt),n=Tn(t,n,r,e,u);break t}if(c)n:if(u||(u=new Gt),o=2&e,
f=bu(t),i=f.length,c=bu(n).length,i==c||o){for(a=i;a--;){var l=f[a];if(!(o?l in n:Gu.call(n,l))){n=false;break n}}if((c=u.get(t))&&u.get(n))n=c==n;else{c=true,u.set(t,n),u.set(n,t);for(var s=o;++a<i;){var l=f[a],h=t[l],p=n[l];if(r)var _=o?r(p,h,l,n,t,u):r(h,p,l,t,n,u);if(_===P?h!==p&&!Tn(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l)}c&&!s&&(r=t.constructor,e=n.constructor,r!=e&&"constructor"in t&&"constructor"in n&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),
u.delete(t),u.delete(n),n=c}}else n=false;else n=false}}return n}function $n(t){return ou(t)&&"[object Map]"==St(t)}function Fn(t,n,r,e){var u=r.length,o=u,i=!e;if(null==t)return!o;for(t=Tu(t);u--;){var f=r[u];if(i&&f[2]?f[1]!==t[f[0]]:!(f[0]in t))return false}for(;++u<o;){var f=r[u],c=f[0],a=t[c],l=f[1];if(i&&f[2]){if(a===P&&!(c in t))return false}else{if(f=new Gt,e)var s=e(a,l,c,t,n,f);if(s===P?!Tn(l,a,e,3,f):!s)return false}}return true}function Nn(t){return!(!uu(t)||Vu&&Vu in t)&&(nu(t)||C(t)?Xu:wt).test(ke(t))}function Pn(t){
return uu(t)&&"[object RegExp]"==Hu.call(t)}function Zn(t){return ou(t)&&"[object Set]"==St(t)}function qn(t){return ou(t)&&eu(t.length)&&!!Dt[Hu.call(t)]}function Vn(t){return typeof t=="function"?t:null==t?Ou:typeof t=="object"?Fi(t)?Qn(t[0],t[1]):Hn(t):Wu(t)}function Kn(t){if(!xe(t))return bo(t);var n,r=[];for(n in Tu(t))Gu.call(t,n)&&"constructor"!=n&&r.push(n);return r}function Gn(t){if(!uu(t)){var n=[];if(null!=t)for(var r in Tu(t))n.push(r);return n}r=xe(t);var e=[];for(n in t)("constructor"!=n||!r&&Gu.call(t,n))&&e.push(n);
return e}function Jn(t,n){return t<n}function Yn(t,n){var r=-1,e=Qe(t)?Cu(t.length):[];return Po(t,function(t,u,o){e[++r]=n(t,u,o)}),e}function Hn(t){var n=ae(t);return 1==n.length&&n[0][2]?je(n[0][0],n[0][1]):function(r){return r===t||Fn(r,t,n)}}function Qn(t,n){return ye(t)&&n===n&&!uu(n)?je(Ae(t),n):function(r){var e=du(r,t);return e===P&&e===n?yu(r,t):Tn(n,e,P,3)}}function Xn(t,n,r,e,o){if(t!==n){if(!Fi(n)&&!Gi(n))var i=Gn(n);u(i||n,function(u,f){if(i&&(f=u,u=n[f]),uu(u)){o||(o=new Gt);var c=f,a=o,l=t[c],s=n[c],h=a.get(s);
if(h)an(t,c,h);else{var h=e?e(l,s,c+"",t,n,a):P,p=h===P;p&&(h=s,Fi(s)||Gi(s)?Fi(l)?h=l:Xe(l)?h=Wr(l):(p=false,h=gn(s,true)):fu(s)||He(s)?He(l)?h=vu(l):!uu(l)||r&&nu(l)?(p=false,h=gn(s,true)):h=l:p=false),p&&(a.set(s,h),Xn(h,s,r,e,a),a.delete(s)),an(t,c,h)}}else c=e?e(t[f],u,f+"",t,n,o):P,c===P&&(c=u),an(t,f,c)})}}function tr(t,n){var r=t.length;if(r)return n+=0>n?r:0,ge(n,r)?t[n]:P}function nr(t,n,r){var e=-1;return n=l(n.length?n:[Ou],S(fe())),t=Yn(t,function(t){return{a:l(n,function(n){return n(t)}),b:++e,c:t
}}),A(t,function(t,n){var e;t:{e=-1;for(var u=t.a,o=n.a,i=u.length,f=r.length;++e<i;){var c=Sr(u[e],o[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);break t}}e=t.b-n.b}return e})}function rr(t,n){return t=Tu(t),er(t,n,function(n,r){return r in t})}function er(t,n,r){for(var e=-1,u=n.length,o={};++e<u;){var i=n[e],f=t[i];r(f,i)&&(o[i]=f)}return o}function ur(t){return function(n){return In(n,t)}}function or(t,n,r,e){var u=e?y:d,o=-1,i=n.length,f=t;for(t===n&&(n=Wr(n)),r&&(f=l(t,S(r)));++o<i;)for(var c=0,a=n[o],a=r?r(a):a;-1<(c=u(f,a,c,e));)f!==t&&fo.call(f,c,1),
fo.call(t,c,1);return t}function ir(t,n){for(var r=t?n.length:0,e=r-1;r--;){var u=n[r];if(r==e||u!==o){var o=u;if(ge(u))fo.call(t,u,1);else if(ye(u,t))delete t[Ae(u)];else{var u=Ar(u),i=me(t,u);null!=i&&delete i[Ae(We(u))]}}}}function fr(t,n){return t+po(mo()*(n-t+1))}function cr(t,n){var r="";if(!t||1>n||9007199254740991<n)return r;do n%2&&(r+=t),(n=po(n/2))&&(t+=t);while(n);return r}function ar(t,n){return n=xo(n===P?t.length-1:n,0),function(){for(var e=arguments,u=-1,o=xo(e.length-n,0),i=Cu(o);++u<o;)i[u]=e[n+u];
for(u=-1,o=Cu(n+1);++u<n;)o[u]=e[u];return o[n]=i,r(t,this,o)}}function lr(t,n,r,e){if(!uu(t))return t;n=ye(n,t)?[n]:Ar(n);for(var u=-1,o=n.length,i=o-1,f=t;null!=f&&++u<o;){var c=Ae(n[u]),a=r;if(u!=i){var l=f[c],a=e?e(l,c,f):P;a===P&&(a=uu(l)?l:ge(n[u+1])?[]:{})}ln(f,c,a),f=f[c]}return t}function sr(t,n,r){var e=-1,u=t.length;for(0>n&&(n=-n>u?0:u+n),r=r>u?u:r,0>r&&(r+=u),u=n>r?0:r-n>>>0,n>>>=0,r=Cu(u);++e<u;)r[e]=t[e+n];return r}function hr(t,n){var r;return Po(t,function(t,e,u){return r=n(t,e,u),
!r}),!!r}function pr(t,n,r){var e=0,u=t?t.length:e;if(typeof n=="number"&&n===n&&2147483647>=u){for(;e<u;){var o=e+u>>>1,i=t[o];null!==i&&!au(i)&&(r?i<=n:i<n)?e=o+1:u=o}return u}return _r(t,n,Ou,r)}function _r(t,n,r,e){n=r(n);for(var u=0,o=t?t.length:0,i=n!==n,f=null===n,c=au(n),a=n===P;u<o;){var l=po((u+o)/2),s=r(t[l]),h=s!==P,p=null===s,_=s===s,v=au(s);(i?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=n:s<n)?u=l+1:o=l}return jo(o,4294967294)}function vr(t,n){for(var r=-1,e=t.length,u=0,o=[];++r<e;){
var i=t[r],f=n?n(i):i;if(!r||!Ye(f,c)){var c=f;o[u++]=0===i?0:i}}return o}function gr(t){return typeof t=="number"?t:au(t)?q:+t}function dr(t){if(typeof t=="string")return t;if(au(t))return No?No.call(t):"";var n=t+"";return"0"==n&&1/t==-Z?"-0":n}function yr(t,n,r){var e=-1,u=c,o=t.length,i=true,f=[],l=f;if(r)i=false,u=a;else if(200<=o){if(u=n?null:Jo(t))return D(u);i=false,u=R,l=new Kt}else l=n?[]:f;t:for(;++e<o;){var s=t[e],h=n?n(s):s,s=r||0!==s?s:0;if(i&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue t;
n&&l.push(h),f.push(s)}else u(l,h,r)||(l!==f&&l.push(h),f.push(s))}return f}function br(t,n,r,e){for(var u=t.length,o=e?u:-1;(e?o--:++o<u)&&n(t[o],o,t););return r?sr(t,e?0:o,e?o+1:u):sr(t,e?o+1:0,e?u:o)}function xr(t,n){var r=t;return r instanceof $t&&(r=r.value()),h(n,function(t,n){return n.func.apply(n.thisArg,s([t],n.args))},r)}function jr(t,n,r){for(var e=-1,u=t.length;++e<u;)var o=o?s(jn(o,t[e],n,r),jn(t[e],o,n,r)):t[e];return o&&o.length?yr(o,n,r):[]}function wr(t,n,r){for(var e=-1,u=t.length,o=n.length,i={};++e<u;)r(i,t[e],e<o?n[e]:P);
return i}function mr(t){return Xe(t)?t:[]}function Ar(t){return Fi(t)?t:ei(t)}function kr(t,n,r){var e=t.length;return r=r===P?e:r,!n&&r>=e?t:sr(t,n,r)}function Er(t,n){if(n)return t.slice();var r=new t.constructor(t.length);return t.copy(r),r}function Or(t){var n=new t.constructor(t.byteLength);return new ro(n).set(new ro(t)),n}function Sr(t,n){if(t!==n){var r=t!==P,e=null===t,u=t===t,o=au(t),i=n!==P,f=null===n,c=n===n,a=au(n);if(!f&&!a&&!o&&t>n||o&&i&&c&&!f&&!a||e&&i&&c||!r&&c||!u)return 1;if(!e&&!o&&!a&&t<n||a&&r&&u&&!e&&!o||f&&r&&u||!i&&u||!c)return-1;
}return 0}function Ir(t,n,r,e){var u=-1,o=t.length,i=r.length,f=-1,c=n.length,a=xo(o-i,0),l=Cu(c+a);for(e=!e;++f<c;)l[f]=n[f];for(;++u<i;)(e||u<o)&&(l[r[u]]=t[u]);for(;a--;)l[f++]=t[u++];return l}function Rr(t,n,r,e){var u=-1,o=t.length,i=-1,f=r.length,c=-1,a=n.length,l=xo(o-f,0),s=Cu(l+a);for(e=!e;++u<l;)s[u]=t[u];for(l=u;++c<a;)s[l+c]=n[c];for(;++i<f;)(e||u<o)&&(s[l+r[i]]=t[u++]);return s}function Wr(t,n){var r=-1,e=t.length;for(n||(n=Cu(e));++r<e;)n[r]=t[r];return n}function Br(t,n,r,e){r||(r={});
for(var u=-1,o=n.length;++u<o;){var i=n[u],f=e?e(r[i],t[i],i,r,t):P;ln(r,i,f===P?t[i]:f)}return r}function Lr(t,n){return Br(t,Ho(t),n)}function Cr(t,n){return function(r,u){var o=Fi(r)?e:hn,i=n?n():{};return o(r,t,fe(u,2),i)}}function Ur(t){return ar(function(n,r){var e=-1,u=r.length,o=1<u?r[u-1]:P,i=2<u?r[2]:P,o=3<t.length&&typeof o=="function"?(u--,o):P;for(i&&de(r[0],r[1],i)&&(o=3>u?P:o,u=1),n=Tu(n);++e<u;)(i=r[e])&&t(n,i,e,o);return n})}function Mr(t,n){return function(r,e){if(null==r)return r;
if(!Qe(r))return t(r,e);for(var u=r.length,o=n?u:-1,i=Tu(r);(n?o--:++o<u)&&false!==e(i[o],o,i););return r}}function zr(t){return function(n,r,e){var u=-1,o=Tu(n);e=e(n);for(var i=e.length;i--;){var f=e[t?i:++u];if(false===r(o[f],f,o))break}return n}}function Dr(t,n,r){function e(){return(this&&this!==Vt&&this instanceof e?o:t).apply(u?r:this,arguments)}var u=1&n,o=Fr(t);return e}function Tr(t){return function(n){n=gu(n);var r=Ut.test(n)?F(n):P,e=r?r[0]:n.charAt(0);return n=r?kr(r,1).join(""):n.slice(1),
e[t]()+n}}function $r(t){return function(n){return h(ku(Au(n).replace(Wt,"")),t,"")}}function Fr(t){return function(){var n=arguments;switch(n.length){case 0:return new t;case 1:return new t(n[0]);case 2:return new t(n[0],n[1]);case 3:return new t(n[0],n[1],n[2]);case 4:return new t(n[0],n[1],n[2],n[3]);case 5:return new t(n[0],n[1],n[2],n[3],n[4]);case 6:return new t(n[0],n[1],n[2],n[3],n[4],n[5]);case 7:return new t(n[0],n[1],n[2],n[3],n[4],n[5],n[6])}var r=bn(t.prototype),n=t.apply(r,n);return uu(n)?n:r;
}}function Nr(t,n,e){function u(){for(var i=arguments.length,f=Cu(i),c=i,a=ie(u);c--;)f[c]=arguments[c];return c=3>i&&f[0]!==a&&f[i-1]!==a?[]:z(f,a),i-=c.length,i<e?Xr(t,n,qr,u.placeholder,P,f,c,P,P,e-i):r(this&&this!==Vt&&this instanceof u?o:t,this,f)}var o=Fr(t);return u}function Pr(t){return function(n,r,e){var u=Tu(n);if(!Qe(n)){var o=fe(r,3);n=bu(n),r=function(t){return o(u[t],t,u)}}return r=t(n,r,e),-1<r?u[o?n[r]:r]:P}}function Zr(t){return ar(function(n){n=kn(n,1);var r=n.length,e=r,u=Lt.prototype.thru;
for(t&&n.reverse();e--;){var o=n[e];if(typeof o!="function")throw new Nu("Expected a function");if(u&&!i&&"wrapper"==oe(o))var i=new Lt([],(true))}for(e=i?e:r;++e<r;)var o=n[e],u=oe(o),f="wrapper"==u?Yo(o):P,i=f&&be(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?i[oe(f[0])].apply(i,f[3]):1==o.length&&be(o)?i[u]():i.thru(o);return function(){var t=arguments,e=t[0];if(i&&1==t.length&&Fi(e)&&200<=e.length)return i.plant(e).value();for(var u=0,t=r?n[u].apply(this,t):e;++u<r;)t=n[u].call(this,t);return t}})}function qr(t,n,r,e,u,o,i,f,c,a){
function l(){for(var d=arguments.length,y=Cu(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=ie(l),b=y.length;for(x=0;b--;)y[b]===j&&x++}if(e&&(y=Ir(y,e,u,_)),o&&(y=Rr(y,o,i,_)),d-=x,_&&d<a)return j=z(y,j),Xr(t,n,qr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[t]:t,d=y.length,f){x=y.length;for(var w=jo(f.length,x),m=Wr(y);w--;){var A=f[w];y[w]=ge(A,x)?m[A]:P}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==Vt&&this instanceof l&&(b=g||Fr(b)),b.apply(j,y)}var s=128&n,h=1&n,p=2&n,_=24&n,v=512&n,g=p?P:Fr(t);
return l}function Vr(t,n){return function(r,e){return Un(r,t,n(e))}}function Kr(t,n){return function(r,e){var u;if(r===P&&e===P)return n;if(r!==P&&(u=r),e!==P){if(u===P)return e;typeof r=="string"||typeof e=="string"?(r=dr(r),e=dr(e)):(r=gr(r),e=gr(e)),u=t(r,e)}return u}}function Gr(t){return ar(function(n){return n=1==n.length&&Fi(n[0])?l(n[0],S(fe())):l(kn(n,1),S(fe())),ar(function(e){var u=this;return t(n,function(t){return r(t,u,e)})})})}function Jr(t,n){n=n===P?" ":dr(n);var r=n.length;return 2>r?r?cr(n,t):n:(r=cr(n,ho(t/$(n))),
Ut.test(n)?kr(F(r),0,t).join(""):r.slice(0,t))}function Yr(t,n,e,u){function o(){for(var n=-1,c=arguments.length,a=-1,l=u.length,s=Cu(l+c),h=this&&this!==Vt&&this instanceof o?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++n];return r(h,i?e:this,s)}var i=1&n,f=Fr(t);return o}function Hr(t){return function(n,r,e){e&&typeof e!="number"&&de(n,r,e)&&(r=e=P),n=su(n),r===P?(r=n,n=0):r=su(r),e=e===P?n<r?1:-1:su(e);var u=-1;r=xo(ho((r-n)/(e||1)),0);for(var o=Cu(r);r--;)o[t?r:++u]=n,n+=e;return o}}function Qr(t){
return function(n,r){return typeof n=="string"&&typeof r=="string"||(n=_u(n),r=_u(r)),t(n,r)}}function Xr(t,n,r,e,u,o,i,f,c,a){var l=8&n,s=l?i:P;i=l?P:i;var h=l?o:P;return o=l?P:o,n=(n|(l?32:64))&~(l?64:32),4&n||(n&=-4),u=[t,n,u,h,s,o,i,f,c,a],r=r.apply(P,u),be(t)&&ti(r,u),r.placeholder=e,ri(r,t,n)}function te(t){var n=Du[t];return function(t,r){if(t=_u(t),r=jo(hu(r),292)){var e=(gu(t)+"e").split("e"),e=n(e[0]+"e"+(+e[1]+r)),e=(gu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return n(t)}}function ne(t){
return function(n){var r=St(n);return"[object Map]"==r?U(n):"[object Set]"==r?T(n):O(n,t(n))}}function re(t,n,r,e,u,o,i,f){var c=2&n;if(!c&&typeof t!="function")throw new Nu("Expected a function");var a=e?e.length:0;if(a||(n&=-97,e=u=P),i=i===P?i:xo(hu(i),0),f=f===P?f:hu(f),a-=u?u.length:0,64&n){var l=e,s=u;e=u=P}var h=c?P:Yo(t);return o=[t,n,r,e,u,l,s,o,i,f],h&&(r=o[1],t=h[1],n=r|t,e=128==t&&8==r||128==t&&256==r&&o[7].length<=h[8]||384==t&&h[7].length<=h[8]&&8==r,131>n||e)&&(1&t&&(o[2]=h[2],n|=1&r?0:4),
(r=h[3])&&(e=o[3],o[3]=e?Ir(e,r,h[4]):r,o[4]=e?z(o[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=o[5],o[5]=e?Rr(e,r,h[6]):r,o[6]=e?z(o[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(o[7]=r),128&t&&(o[8]=null==o[8]?h[8]:jo(o[8],h[8])),null==o[9]&&(o[9]=h[9]),o[0]=h[0],o[1]=n),t=o[0],n=o[1],r=o[2],e=o[3],u=o[4],f=o[9]=null==o[9]?c?0:t.length:xo(o[9]-a,0),!f&&24&n&&(n&=-25),ri((h?Ko:ti)(n&&1!=n?8==n||16==n?Nr(t,n,f):32!=n&&33!=n||u.length?qr.apply(P,o):Yr(t,n,r,e):Dr(t,n,r),o),t,n)}function ee(t,n,r,e,u,o){
var i=2&u,f=t.length,c=n.length;if(f!=c&&!(i&&c>f))return false;if((c=o.get(t))&&o.get(n))return c==n;var c=-1,a=true,l=1&u?new Kt:P;for(o.set(t,n),o.set(n,t);++c<f;){var s=t[c],h=n[c];if(e)var p=i?e(h,s,c,n,t,o):e(s,h,c,t,n,o);if(p!==P){if(p)continue;a=false;break}if(l){if(!_(n,function(t,n){if(!l.has(n)&&(s===t||r(s,t,e,u,o)))return l.add(n)})){a=false;break}}else if(s!==h&&!r(s,h,e,u,o)){a=false;break}}return o.delete(t),o.delete(n),a}function ue(t,n,r,e,u,o,i){switch(r){case"[object DataView]":if(t.byteLength!=n.byteLength||t.byteOffset!=n.byteOffset)break;
t=t.buffer,n=n.buffer;case"[object ArrayBuffer]":if(t.byteLength!=n.byteLength||!e(new ro(t),new ro(n)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return Ye(+t,+n);case"[object Error]":return t.name==n.name&&t.message==n.message;case"[object RegExp]":case"[object String]":return t==n+"";case"[object Map]":var f=U;case"[object Set]":if(f||(f=D),t.size!=n.size&&!(2&o))break;return(r=i.get(t))?r==n:(o|=1,i.set(t,n),n=ee(f(t),f(n),e,u,o,i),i.delete(t),n);case"[object Symbol]":
if(Fo)return Fo.call(t)==Fo.call(n)}return false}function oe(t){for(var n=t.name+"",r=Co[n],e=Gu.call(Co,n)?r.length:0;e--;){var u=r[e],o=u.func;if(null==o||o==t)return u.name}return n}function ie(t){return(Gu.call(It,"placeholder")?It:t).placeholder}function fe(){var t=It.iteratee||Su,t=t===Su?Vn:t;return arguments.length?t(arguments[0],arguments[1]):t}function ce(t,n){var r=t.__data__,e=typeof n;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==n:null===n)?r[typeof n=="string"?"string":"hash"]:r.map;
}function ae(t){for(var n=bu(t),r=n.length;r--;){var e=n[r],u=t[e];n[r]=[e,u,u===u&&!uu(u)]}return n}function le(t,n){var r=null==t?P:t[n];return Nn(r)?r:P}function se(t,n,r){n=ye(n,t)?[n]:Ar(n);for(var e,u=-1,o=n.length;++u<o;){var i=Ae(n[u]);if(!(e=null!=t&&r(t,i)))break;t=t[i]}return e?e:(o=t?t.length:0,!!o&&eu(o)&&ge(i,o)&&(Fi(t)||He(t)))}function he(t){var n=t.length,r=t.constructor(n);return n&&"string"==typeof t[0]&&Gu.call(t,"index")&&(r.index=t.index,r.input=t.input),r}function pe(t){return typeof t.constructor!="function"||xe(t)?{}:bn(eo(t));
}function _e(r,e,u,o){var i=r.constructor;switch(e){case"[object ArrayBuffer]":return Or(r);case"[object Boolean]":case"[object Date]":return new i((+r));case"[object DataView]":return e=o?Or(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":
return e=o?Or(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.length);case"[object Map]":return e=o?u(U(r),true):U(r),h(e,t,new r.constructor);case"[object Number]":case"[object String]":return new i(r);case"[object RegExp]":return e=new r.constructor(r.source,yt.exec(r)),e.lastIndex=r.lastIndex,e;case"[object Set]":return e=o?u(D(r),true):D(r),h(e,n,new r.constructor);case"[object Symbol]":return Fo?Tu(Fo.call(r)):{}}}function ve(t){return Fi(t)||He(t)||!!(co&&t&&t[co])}function ge(t,n){return n=null==n?9007199254740991:n,
!!n&&(typeof t=="number"||At.test(t))&&-1<t&&0==t%1&&t<n}function de(t,n,r){if(!uu(r))return false;var e=typeof n;return!!("number"==e?Qe(r)&&ge(n,r.length):"string"==e&&n in r)&&Ye(r[n],t)}function ye(t,n){if(Fi(t))return false;var r=typeof t;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=t&&!au(t))||(ut.test(t)||!et.test(t)||null!=n&&t in Tu(n))}function be(t){var n=oe(t),r=It[n];return typeof r=="function"&&n in $t.prototype&&(t===r||(n=Yo(r),!!n&&t===n[0]))}function xe(t){var n=t&&t.constructor;
return t===(typeof n=="function"&&n.prototype||Zu)}function je(t,n){return function(r){return null!=r&&(r[t]===n&&(n!==P||t in Tu(r)))}}function we(t,n,r,e,u,o){return uu(t)&&uu(n)&&(o.set(n,t),Xn(t,n,P,we,o),o.delete(n)),t}function me(t,n){return 1==n.length?t:In(t,sr(n,0,-1))}function Ae(t){if(typeof t=="string"||au(t))return t;var n=t+"";return"0"==n&&1/t==-Z?"-0":n}function ke(t){if(null!=t){try{return Ku.call(t)}catch(t){}return t+""}return""}function Ee(t,n){return u(V,function(r){var e="_."+r[0];
n&r[1]&&!c(t,e)&&t.push(e)}),t.sort()}function Oe(t){if(t instanceof $t)return t.clone();var n=new Lt(t.__wrapped__,t.__chain__);return n.__actions__=Wr(t.__actions__),n.__index__=t.__index__,n.__values__=t.__values__,n}function Se(t,n,r){var e=t?t.length:0;return e?(r=null==r?0:hu(r),0>r&&(r=xo(e+r,0)),g(t,fe(n,3),r)):-1}function Ie(t,n,r){var e=t?t.length:0;if(!e)return-1;var u=e-1;return r!==P&&(u=hu(r),u=0>r?xo(e+u,0):jo(u,e-1)),g(t,fe(n,3),u,true)}function Re(t){return t&&t.length?t[0]:P}function We(t){
var n=t?t.length:0;return n?t[n-1]:P}function Be(t,n){return t&&t.length&&n&&n.length?or(t,n):t}function Le(t){return t?Ao.call(t):t}function Ce(t){if(!t||!t.length)return[];var n=0;return t=f(t,function(t){if(Xe(t))return n=xo(t.length,n),true}),E(n,function(n){return l(t,j(n))})}function Ue(t,n){if(!t||!t.length)return[];var e=Ce(t);return null==n?e:l(e,function(t){return r(n,P,t)})}function Me(t){return t=It(t),t.__chain__=true,t}function ze(t,n){return n(t)}function De(){return this}function Te(t,n){
return(Fi(t)?u:Po)(t,fe(n,3))}function $e(t,n){return(Fi(t)?o:Zo)(t,fe(n,3))}function Fe(t,n){return(Fi(t)?l:Yn)(t,fe(n,3))}function Ne(t,n,r){var e=-1,u=lu(t),o=u.length,i=o-1;for(n=(r?de(t,n,r):n===P)?1:vn(hu(n),0,o);++e<n;)t=fr(e,i),r=u[t],u[t]=u[e],u[e]=r;return u.length=n,u}function Pe(t,n,r){return n=r?P:n,n=t&&null==n?t.length:n,re(t,128,P,P,P,P,n)}function Ze(t,n){var r;if(typeof n!="function")throw new Nu("Expected a function");return t=hu(t),function(){return 0<--t&&(r=n.apply(this,arguments)),
1>=t&&(n=P),r}}function qe(t,n,r){return n=r?P:n,t=re(t,8,P,P,P,P,P,n),t.placeholder=qe.placeholder,t}function Ve(t,n,r){return n=r?P:n,t=re(t,16,P,P,P,P,P,n),t.placeholder=Ve.placeholder,t}function Ke(t,n,r){function e(n){var r=c,e=a;return c=a=P,_=n,s=t.apply(e,r)}function u(t){var r=t-p;return t-=_,p===P||r>=n||0>r||g&&t>=l}function o(){var t=Ri();if(u(t))return i(t);var r,e=ni;r=t-_,t=n-(t-p),r=g?jo(t,l-r):t,h=e(o,r)}function i(t){return h=P,d&&c?e(t):(c=a=P,s)}function f(){var t=Ri(),r=u(t);if(c=arguments,
a=this,p=t,r){if(h===P)return _=t=p,h=ni(o,n),v?e(t):s;if(g)return h=ni(o,n),e(p)}return h===P&&(h=ni(o,n)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof t!="function")throw new Nu("Expected a function");return n=_u(n)||0,uu(r)&&(v=!!r.leading,l=(g="maxWait"in r)?xo(_u(r.maxWait)||0,n):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==P&&Go(h),_=0,c=p=a=h=P},f.flush=function(){return h===P?s:i(Ri())},f}function Ge(t,n){function r(){var e=arguments,u=n?n.apply(this,e):e[0],o=r.cache;return o.has(u)?o.get(u):(e=t.apply(this,e),
r.cache=o.set(u,e),e)}if(typeof t!="function"||n&&typeof n!="function")throw new Nu("Expected a function");return r.cache=new(Ge.Cache||qt),r}function Je(t){if(typeof t!="function")throw new Nu("Expected a function");return function(){var n=arguments;switch(n.length){case 0:return!t.call(this);case 1:return!t.call(this,n[0]);case 2:return!t.call(this,n[0],n[1]);case 3:return!t.call(this,n[0],n[1],n[2])}return!t.apply(this,n)}}function Ye(t,n){return t===n||t!==t&&n!==n}function He(t){return Xe(t)&&Gu.call(t,"callee")&&(!io.call(t,"callee")||"[object Arguments]"==Hu.call(t));
}function Qe(t){return null!=t&&eu(t.length)&&!nu(t)}function Xe(t){return ou(t)&&Qe(t)}function tu(t){return!!ou(t)&&("[object Error]"==Hu.call(t)||typeof t.message=="string"&&typeof t.name=="string")}function nu(t){return t=uu(t)?Hu.call(t):"","[object Function]"==t||"[object GeneratorFunction]"==t}function ru(t){return typeof t=="number"&&t==hu(t)}function eu(t){return typeof t=="number"&&-1<t&&0==t%1&&9007199254740991>=t}function uu(t){var n=typeof t;return!!t&&("object"==n||"function"==n)}function ou(t){
return!!t&&typeof t=="object"}function iu(t){return typeof t=="number"||ou(t)&&"[object Number]"==Hu.call(t)}function fu(t){return!(!ou(t)||"[object Object]"!=Hu.call(t)||C(t))&&(t=eo(t),null===t||(t=Gu.call(t,"constructor")&&t.constructor,typeof t=="function"&&t instanceof t&&Ku.call(t)==Yu))}function cu(t){return typeof t=="string"||!Fi(t)&&ou(t)&&"[object String]"==Hu.call(t)}function au(t){return typeof t=="symbol"||ou(t)&&"[object Symbol]"==Hu.call(t)}function lu(t){if(!t)return[];if(Qe(t))return cu(t)?F(t):Wr(t);
if(uo&&t[uo]){t=t[uo]();for(var n,r=[];!(n=t.next()).done;)r.push(n.value);return r}return n=St(t),("[object Map]"==n?U:"[object Set]"==n?D:wu)(t)}function su(t){return t?(t=_u(t),t===Z||t===-Z?1.7976931348623157e308*(0>t?-1:1):t===t?t:0):0===t?t:0}function hu(t){t=su(t);var n=t%1;return t===t?n?t-n:t:0}function pu(t){return t?vn(hu(t),0,4294967295):0}function _u(t){if(typeof t=="number")return t;if(au(t))return q;if(uu(t)&&(t=typeof t.valueOf=="function"?t.valueOf():t,t=uu(t)?t+"":t),typeof t!="string")return 0===t?t:+t;
t=t.replace(at,"");var n=jt.test(t);return n||mt.test(t)?Pt(t.slice(2),n?2:8):xt.test(t)?q:+t}function vu(t){return Br(t,xu(t))}function gu(t){return null==t?"":dr(t)}function du(t,n,r){return t=null==t?P:In(t,n),t===P?r:t}function yu(t,n){return null!=t&&se(t,n,Ln)}function bu(t){return Qe(t)?Yt(t):Kn(t)}function xu(t){return Qe(t)?Yt(t,true):Gn(t)}function ju(t,n){return null==t?{}:er(t,Rn(t,xu,Qo),fe(n))}function wu(t){return t?I(t,bu(t)):[]}function mu(t){return jf(gu(t).toLowerCase())}function Au(t){
return(t=gu(t))&&t.replace(kt,un).replace(Bt,"")}function ku(t,n,r){return t=gu(t),n=r?P:n,n===P?Mt.test(t)?t.match(Ct)||[]:t.match(vt)||[]:t.match(n)||[]}function Eu(t){return function(){return t}}function Ou(t){return t}function Su(t){return Vn(typeof t=="function"?t:gn(t,true))}function Iu(t,n,r){var e=bu(n),o=Sn(n,e);null!=r||uu(n)&&(o.length||!e.length)||(r=n,n=t,t=this,o=Sn(n,bu(n)));var i=!(uu(r)&&"chain"in r&&!r.chain),f=nu(t);return u(o,function(r){var e=n[r];t[r]=e,f&&(t.prototype[r]=function(){
var n=this.__chain__;if(i||n){var r=t(this.__wrapped__);return(r.__actions__=Wr(this.__actions__)).push({func:e,args:arguments,thisArg:t}),r.__chain__=n,r}return e.apply(t,s([this.value()],arguments))})}),t}function Ru(){}function Wu(t){return ye(t)?j(Ae(t)):ur(t)}function Bu(){return[]}function Lu(){return false}w=w?cn.defaults(Vt.Object(),w,cn.pick(Vt,zt)):Vt;var Cu=w.Array,Uu=w.Date,Mu=w.Error,zu=w.Function,Du=w.Math,Tu=w.Object,$u=w.RegExp,Fu=w.String,Nu=w.TypeError,Pu=Cu.prototype,Zu=Tu.prototype,qu=w["__core-js_shared__"],Vu=function(){
var t=/[^.]+$/.exec(qu&&qu.keys&&qu.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}(),Ku=zu.prototype.toString,Gu=Zu.hasOwnProperty,Ju=0,Yu=Ku.call(Tu),Hu=Zu.toString,Qu=Vt._,Xu=$u("^"+Ku.call(Gu).replace(ft,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),to=Jt?w.Buffer:P,no=w.Symbol,ro=w.Uint8Array,eo=M(Tu.getPrototypeOf,Tu),uo=no?no.iterator:P,oo=Tu.create,io=Zu.propertyIsEnumerable,fo=Pu.splice,co=no?no.isConcatSpreadable:P,ao=w.clearTimeout!==Vt.clearTimeout&&w.clearTimeout,lo=Uu&&Uu.now!==Vt.Date.now&&Uu.now,so=w.setTimeout!==Vt.setTimeout&&w.setTimeout,ho=Du.ceil,po=Du.floor,_o=Tu.getOwnPropertySymbols,vo=to?to.isBuffer:P,go=w.isFinite,yo=Pu.join,bo=M(Tu.keys,Tu),xo=Du.max,jo=Du.min,wo=w.parseInt,mo=Du.random,Ao=Pu.reverse,ko=le(w,"DataView"),Eo=le(w,"Map"),Oo=le(w,"Promise"),So=le(w,"Set"),Io=le(w,"WeakMap"),Ro=le(Tu,"create"),Wo=function(){
var t=le(Tu,"defineProperty"),n=le.name;return n&&2<n.length?t:P}(),Bo=Io&&new Io,Lo=!io.call({valueOf:1},"valueOf"),Co={},Uo=ke(ko),Mo=ke(Eo),zo=ke(Oo),Do=ke(So),To=ke(Io),$o=no?no.prototype:P,Fo=$o?$o.valueOf:P,No=$o?$o.toString:P;It.templateSettings={escape:tt,evaluate:nt,interpolate:rt,variable:"",imports:{_:It}},It.prototype=Rt.prototype,It.prototype.constructor=It,Lt.prototype=bn(Rt.prototype),Lt.prototype.constructor=Lt,$t.prototype=bn(Rt.prototype),$t.prototype.constructor=$t,Ft.prototype.clear=function(){
this.__data__=Ro?Ro(null):{}},Ft.prototype.delete=function(t){return this.has(t)&&delete this.__data__[t]},Ft.prototype.get=function(t){var n=this.__data__;return Ro?(t=n[t],"__lodash_hash_undefined__"===t?P:t):Gu.call(n,t)?n[t]:P},Ft.prototype.has=function(t){var n=this.__data__;return Ro?n[t]!==P:Gu.call(n,t)},Ft.prototype.set=function(t,n){return this.__data__[t]=Ro&&n===P?"__lodash_hash_undefined__":n,this},Zt.prototype.clear=function(){this.__data__=[]},Zt.prototype.delete=function(t){var n=this.__data__;
return t=sn(n,t),!(0>t)&&(t==n.length-1?n.pop():fo.call(n,t,1),true)},Zt.prototype.get=function(t){var n=this.__data__;return t=sn(n,t),0>t?P:n[t][1]},Zt.prototype.has=function(t){return-1<sn(this.__data__,t)},Zt.prototype.set=function(t,n){var r=this.__data__,e=sn(r,t);return 0>e?r.push([t,n]):r[e][1]=n,this},qt.prototype.clear=function(){this.__data__={hash:new Ft,map:new(Eo||Zt),string:new Ft}},qt.prototype.delete=function(t){return ce(this,t).delete(t)},qt.prototype.get=function(t){return ce(this,t).get(t);
},qt.prototype.has=function(t){return ce(this,t).has(t)},qt.prototype.set=function(t,n){return ce(this,t).set(t,n),this},Kt.prototype.add=Kt.prototype.push=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this},Kt.prototype.has=function(t){return this.__data__.has(t)},Gt.prototype.clear=function(){this.__data__=new Zt},Gt.prototype.delete=function(t){return this.__data__.delete(t)},Gt.prototype.get=function(t){return this.__data__.get(t)},Gt.prototype.has=function(t){return this.__data__.has(t);
},Gt.prototype.set=function(t,n){var r=this.__data__;if(r instanceof Zt){if(r=r.__data__,!Eo||199>r.length)return r.push([t,n]),this;r=this.__data__=new qt(r)}return r.set(t,n),this};var Po=Mr(En),Zo=Mr(On,true),qo=zr(),Vo=zr(true),Ko=Bo?function(t,n){return Bo.set(t,n),t}:Ou,Go=ao||function(t){return Vt.clearTimeout(t)},Jo=So&&1/D(new So([,-0]))[1]==Z?function(t){return new So(t)}:Ru,Yo=Bo?function(t){return Bo.get(t)}:Ru,Ho=_o?M(_o,Tu):Bu,Qo=_o?function(t){for(var n=[];t;)s(n,Ho(t)),t=eo(t);return n;
}:Bu;(ko&&"[object DataView]"!=St(new ko(new ArrayBuffer(1)))||Eo&&"[object Map]"!=St(new Eo)||Oo&&"[object Promise]"!=St(Oo.resolve())||So&&"[object Set]"!=St(new So)||Io&&"[object WeakMap]"!=St(new Io))&&(St=function(t){var n=Hu.call(t);if(t=(t="[object Object]"==n?t.constructor:P)?ke(t):P)switch(t){case Uo:return"[object DataView]";case Mo:return"[object Map]";case zo:return"[object Promise]";case Do:return"[object Set]";case To:return"[object WeakMap]"}return n});var Xo=qu?nu:Lu,ti=function(){
var t=0,n=0;return function(r,e){var u=Ri(),o=16-(u-n);if(n=u,0<o){if(150<=++t)return r}else t=0;return Ko(r,e)}}(),ni=so||function(t,n){return Vt.setTimeout(t,n)},ri=Wo?function(t,n,r){n+="";var e;e=(e=n.match(pt))?e[1].split(_t):[],r=Ee(e,r),e=r.length;var u=e-1;return r[u]=(1<e?"& ":"")+r[u],r=r.join(2<e?", ":" "),n=n.replace(ht,"{\n/* [wrapped with "+r+"] */\n"),Wo(t,"toString",{configurable:true,enumerable:false,value:Eu(n)})}:Ou,ei=Ge(function(t){t=gu(t);var n=[];return ot.test(t)&&n.push(""),t.replace(it,function(t,r,e,u){
n.push(e?u.replace(gt,"$1"):r||t)}),n}),ui=ar(function(t,n){return Xe(t)?jn(t,kn(n,1,Xe,true)):[]}),oi=ar(function(t,n){var r=We(n);return Xe(r)&&(r=P),Xe(t)?jn(t,kn(n,1,Xe,true),fe(r,2)):[]}),ii=ar(function(t,n){var r=We(n);return Xe(r)&&(r=P),Xe(t)?jn(t,kn(n,1,Xe,true),P,r):[]}),fi=ar(function(t){var n=l(t,mr);return n.length&&n[0]===t[0]?Cn(n):[]}),ci=ar(function(t){var n=We(t),r=l(t,mr);return n===We(r)?n=P:r.pop(),r.length&&r[0]===t[0]?Cn(r,fe(n,2)):[]}),ai=ar(function(t){var n=We(t),r=l(t,mr);return n===We(r)?n=P:r.pop(),
r.length&&r[0]===t[0]?Cn(r,P,n):[]}),li=ar(Be),si=ar(function(t,n){n=kn(n,1);var r=t?t.length:0,e=_n(t,n);return ir(t,l(n,function(t){return ge(t,r)?+t:t}).sort(Sr)),e}),hi=ar(function(t){return yr(kn(t,1,Xe,true))}),pi=ar(function(t){var n=We(t);return Xe(n)&&(n=P),yr(kn(t,1,Xe,true),fe(n,2))}),_i=ar(function(t){var n=We(t);return Xe(n)&&(n=P),yr(kn(t,1,Xe,true),P,n)}),vi=ar(function(t,n){return Xe(t)?jn(t,n):[]}),gi=ar(function(t){return jr(f(t,Xe))}),di=ar(function(t){var n=We(t);return Xe(n)&&(n=P),
jr(f(t,Xe),fe(n,2))}),yi=ar(function(t){var n=We(t);return Xe(n)&&(n=P),jr(f(t,Xe),P,n)}),bi=ar(Ce),xi=ar(function(t){var n=t.length,n=1<n?t[n-1]:P,n=typeof n=="function"?(t.pop(),n):P;return Ue(t,n)}),ji=ar(function(t){function n(n){return _n(n,t)}t=kn(t,1);var r=t.length,e=r?t[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof $t&&ge(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:ze,args:[n],thisArg:P}),new Lt(u,this.__chain__).thru(function(t){return r&&!t.length&&t.push(P),
t})):this.thru(n)}),wi=Cr(function(t,n,r){Gu.call(t,r)?++t[r]:t[r]=1}),mi=Pr(Se),Ai=Pr(Ie),ki=Cr(function(t,n,r){Gu.call(t,r)?t[r].push(n):t[r]=[n]}),Ei=ar(function(t,n,e){var u=-1,o=typeof n=="function",i=ye(n),f=Qe(t)?Cu(t.length):[];return Po(t,function(t){var c=o?n:i&&null!=t?t[n]:P;f[++u]=c?r(c,t,e):Mn(t,n,e)}),f}),Oi=Cr(function(t,n,r){t[r]=n}),Si=Cr(function(t,n,r){t[r?0:1].push(n)},function(){return[[],[]]}),Ii=ar(function(t,n){if(null==t)return[];var r=n.length;return 1<r&&de(t,n[0],n[1])?n=[]:2<r&&de(n[0],n[1],n[2])&&(n=[n[0]]),
nr(t,kn(n,1),[])}),Ri=lo||function(){return Vt.Date.now()},Wi=ar(function(t,n,r){var e=1;if(r.length)var u=z(r,ie(Wi)),e=32|e;return re(t,e,n,r,u)}),Bi=ar(function(t,n,r){var e=3;if(r.length)var u=z(r,ie(Bi)),e=32|e;return re(n,e,t,r,u)}),Li=ar(function(t,n){return xn(t,1,n)}),Ci=ar(function(t,n,r){return xn(t,_u(n)||0,r)});Ge.Cache=qt;var Ui=ar(function(t,n){n=1==n.length&&Fi(n[0])?l(n[0],S(fe())):l(kn(n,1),S(fe()));var e=n.length;return ar(function(u){for(var o=-1,i=jo(u.length,e);++o<i;)u[o]=n[o].call(this,u[o]);
return r(t,this,u)})}),Mi=ar(function(t,n){var r=z(n,ie(Mi));return re(t,32,P,n,r)}),zi=ar(function(t,n){var r=z(n,ie(zi));return re(t,64,P,n,r)}),Di=ar(function(t,n){return re(t,256,P,P,P,kn(n,1))}),Ti=Qr(Wn),$i=Qr(function(t,n){return t>=n}),Fi=Cu.isArray,Ni=Ht?S(Ht):zn,Pi=vo||Lu,Zi=Qt?S(Qt):Dn,qi=Xt?S(Xt):$n,Vi=tn?S(tn):Pn,Ki=nn?S(nn):Zn,Gi=rn?S(rn):qn,Ji=Qr(Jn),Yi=Qr(function(t,n){return t<=n}),Hi=Ur(function(t,n){if(Lo||xe(n)||Qe(n))Br(n,bu(n),t);else for(var r in n)Gu.call(n,r)&&ln(t,r,n[r]);
}),Qi=Ur(function(t,n){Br(n,xu(n),t)}),Xi=Ur(function(t,n,r,e){Br(n,xu(n),t,e)}),tf=Ur(function(t,n,r,e){Br(n,bu(n),t,e)}),nf=ar(function(t,n){return _n(t,kn(n,1))}),rf=ar(function(t){return t.push(P,en),r(Xi,P,t)}),ef=ar(function(t){return t.push(P,we),r(af,P,t)}),uf=Vr(function(t,n,r){t[n]=r},Eu(Ou)),of=Vr(function(t,n,r){Gu.call(t,n)?t[n].push(r):t[n]=[r]},fe),ff=ar(Mn),cf=Ur(function(t,n,r){Xn(t,n,r)}),af=Ur(function(t,n,r,e){Xn(t,n,r,e)}),lf=ar(function(t,n){return null==t?{}:(n=l(kn(n,1),Ae),
rr(t,jn(Rn(t,xu,Qo),n)))}),sf=ar(function(t,n){return null==t?{}:rr(t,l(kn(n,1),Ae))}),hf=ne(bu),pf=ne(xu),_f=$r(function(t,n,r){return n=n.toLowerCase(),t+(r?mu(n):n)}),vf=$r(function(t,n,r){return t+(r?"-":"")+n.toLowerCase()}),gf=$r(function(t,n,r){return t+(r?" ":"")+n.toLowerCase()}),df=Tr("toLowerCase"),yf=$r(function(t,n,r){return t+(r?"_":"")+n.toLowerCase()}),bf=$r(function(t,n,r){return t+(r?" ":"")+jf(n)}),xf=$r(function(t,n,r){return t+(r?" ":"")+n.toUpperCase()}),jf=Tr("toUpperCase"),wf=ar(function(t,n){
try{return r(t,P,n)}catch(t){return tu(t)?t:new Mu(t)}}),mf=ar(function(t,n){return u(kn(n,1),function(n){n=Ae(n),t[n]=Wi(t[n],t)}),t}),Af=Zr(),kf=Zr(true),Ef=ar(function(t,n){return function(r){return Mn(r,t,n)}}),Of=ar(function(t,n){return function(r){return Mn(t,r,n)}}),Sf=Gr(l),If=Gr(i),Rf=Gr(_),Wf=Hr(),Bf=Hr(true),Lf=Kr(function(t,n){return t+n},0),Cf=te("ceil"),Uf=Kr(function(t,n){return t/n},1),Mf=te("floor"),zf=Kr(function(t,n){return t*n},1),Df=te("round"),Tf=Kr(function(t,n){return t-n},0);return It.after=function(t,n){
if(typeof n!="function")throw new Nu("Expected a function");return t=hu(t),function(){if(1>--t)return n.apply(this,arguments)}},It.ary=Pe,It.assign=Hi,It.assignIn=Qi,It.assignInWith=Xi,It.assignWith=tf,It.at=nf,It.before=Ze,It.bind=Wi,It.bindAll=mf,It.bindKey=Bi,It.castArray=function(){if(!arguments.length)return[];var t=arguments[0];return Fi(t)?t:[t]},It.chain=Me,It.chunk=function(t,n,r){if(n=(r?de(t,n,r):n===P)?1:xo(hu(n),0),r=t?t.length:0,!r||1>n)return[];for(var e=0,u=0,o=Cu(ho(r/n));e<r;)o[u++]=sr(t,e,e+=n);
return o},It.compact=function(t){for(var n=-1,r=t?t.length:0,e=0,u=[];++n<r;){var o=t[n];o&&(u[e++]=o)}return u},It.concat=function(){for(var t=arguments.length,n=Cu(t?t-1:0),r=arguments[0],e=t;e--;)n[e-1]=arguments[e];return t?s(Fi(r)?Wr(r):[r],kn(n,1)):[]},It.cond=function(t){var n=t?t.length:0,e=fe();return t=n?l(t,function(t){if("function"!=typeof t[1])throw new Nu("Expected a function");return[e(t[0]),t[1]]}):[],ar(function(e){for(var u=-1;++u<n;){var o=t[u];if(r(o[0],this,e))return r(o[1],this,e);
}})},It.conforms=function(t){return dn(gn(t,true))},It.constant=Eu,It.countBy=wi,It.create=function(t,n){var r=bn(t);return n?pn(r,n):r},It.curry=qe,It.curryRight=Ve,It.debounce=Ke,It.defaults=rf,It.defaultsDeep=ef,It.defer=Li,It.delay=Ci,It.difference=ui,It.differenceBy=oi,It.differenceWith=ii,It.drop=function(t,n,r){var e=t?t.length:0;return e?(n=r||n===P?1:hu(n),sr(t,0>n?0:n,e)):[]},It.dropRight=function(t,n,r){var e=t?t.length:0;return e?(n=r||n===P?1:hu(n),n=e-n,sr(t,0,0>n?0:n)):[]},It.dropRightWhile=function(t,n){
return t&&t.length?br(t,fe(n,3),true,true):[]},It.dropWhile=function(t,n){return t&&t.length?br(t,fe(n,3),true):[]},It.fill=function(t,n,r,e){var u=t?t.length:0;if(!u)return[];for(r&&typeof r!="number"&&de(t,n,r)&&(r=0,e=u),u=t.length,r=hu(r),0>r&&(r=-r>u?0:u+r),e=e===P||e>u?u:hu(e),0>e&&(e+=u),e=r>e?0:pu(e);r<e;)t[r++]=n;return t},It.filter=function(t,n){return(Fi(t)?f:An)(t,fe(n,3))},It.flatMap=function(t,n){return kn(Fe(t,n),1)},It.flatMapDeep=function(t,n){return kn(Fe(t,n),Z)},It.flatMapDepth=function(t,n,r){
return r=r===P?1:hu(r),kn(Fe(t,n),r)},It.flatten=function(t){return t&&t.length?kn(t,1):[]},It.flattenDeep=function(t){return t&&t.length?kn(t,Z):[]},It.flattenDepth=function(t,n){return t&&t.length?(n=n===P?1:hu(n),kn(t,n)):[]},It.flip=function(t){return re(t,512)},It.flow=Af,It.flowRight=kf,It.fromPairs=function(t){for(var n=-1,r=t?t.length:0,e={};++n<r;){var u=t[n];e[u[0]]=u[1]}return e},It.functions=function(t){return null==t?[]:Sn(t,bu(t))},It.functionsIn=function(t){return null==t?[]:Sn(t,xu(t));
},It.groupBy=ki,It.initial=function(t){return t&&t.length?sr(t,0,-1):[]},It.intersection=fi,It.intersectionBy=ci,It.intersectionWith=ai,It.invert=uf,It.invertBy=of,It.invokeMap=Ei,It.iteratee=Su,It.keyBy=Oi,It.keys=bu,It.keysIn=xu,It.map=Fe,It.mapKeys=function(t,n){var r={};return n=fe(n,3),En(t,function(t,e,u){r[n(t,e,u)]=t}),r},It.mapValues=function(t,n){var r={};return n=fe(n,3),En(t,function(t,e,u){r[e]=n(t,e,u)}),r},It.matches=function(t){return Hn(gn(t,true))},It.matchesProperty=function(t,n){
return Qn(t,gn(n,true))},It.memoize=Ge,It.merge=cf,It.mergeWith=af,It.method=Ef,It.methodOf=Of,It.mixin=Iu,It.negate=Je,It.nthArg=function(t){return t=hu(t),ar(function(n){return tr(n,t)})},It.omit=lf,It.omitBy=function(t,n){return ju(t,Je(fe(n)))},It.once=function(t){return Ze(2,t)},It.orderBy=function(t,n,r,e){return null==t?[]:(Fi(n)||(n=null==n?[]:[n]),r=e?P:r,Fi(r)||(r=null==r?[]:[r]),nr(t,n,r))},It.over=Sf,It.overArgs=Ui,It.overEvery=If,It.overSome=Rf,It.partial=Mi,It.partialRight=zi,It.partition=Si,
It.pick=sf,It.pickBy=ju,It.property=Wu,It.propertyOf=function(t){return function(n){return null==t?P:In(t,n)}},It.pull=li,It.pullAll=Be,It.pullAllBy=function(t,n,r){return t&&t.length&&n&&n.length?or(t,n,fe(r,2)):t},It.pullAllWith=function(t,n,r){return t&&t.length&&n&&n.length?or(t,n,P,r):t},It.pullAt=si,It.range=Wf,It.rangeRight=Bf,It.rearg=Di,It.reject=function(t,n){return(Fi(t)?f:An)(t,Je(fe(n,3)))},It.remove=function(t,n){var r=[];if(!t||!t.length)return r;var e=-1,u=[],o=t.length;for(n=fe(n,3);++e<o;){
var i=t[e];n(i,e,t)&&(r.push(i),u.push(e))}return ir(t,u),r},It.rest=function(t,n){if(typeof t!="function")throw new Nu("Expected a function");return n=n===P?n:hu(n),ar(t,n)},It.reverse=Le,It.sampleSize=Ne,It.set=function(t,n,r){return null==t?t:lr(t,n,r)},It.setWith=function(t,n,r,e){return e=typeof e=="function"?e:P,null==t?t:lr(t,n,r,e)},It.shuffle=function(t){return Ne(t,4294967295)},It.slice=function(t,n,r){var e=t?t.length:0;return e?(r&&typeof r!="number"&&de(t,n,r)?(n=0,r=e):(n=null==n?0:hu(n),
r=r===P?e:hu(r)),sr(t,n,r)):[]},It.sortBy=Ii,It.sortedUniq=function(t){return t&&t.length?vr(t):[]},It.sortedUniqBy=function(t,n){return t&&t.length?vr(t,fe(n,2)):[]},It.split=function(t,n,r){return r&&typeof r!="number"&&de(t,n,r)&&(n=r=P),r=r===P?4294967295:r>>>0,r?(t=gu(t))&&(typeof n=="string"||null!=n&&!Vi(n))&&(n=dr(n),!n&&Ut.test(t))?kr(F(t),0,r):t.split(n,r):[]},It.spread=function(t,n){if(typeof t!="function")throw new Nu("Expected a function");return n=n===P?0:xo(hu(n),0),ar(function(e){
var u=e[n];return e=kr(e,0,n),u&&s(e,u),r(t,this,e)})},It.tail=function(t){var n=t?t.length:0;return n?sr(t,1,n):[]},It.take=function(t,n,r){return t&&t.length?(n=r||n===P?1:hu(n),sr(t,0,0>n?0:n)):[]},It.takeRight=function(t,n,r){var e=t?t.length:0;return e?(n=r||n===P?1:hu(n),n=e-n,sr(t,0>n?0:n,e)):[]},It.takeRightWhile=function(t,n){return t&&t.length?br(t,fe(n,3),false,true):[]},It.takeWhile=function(t,n){return t&&t.length?br(t,fe(n,3)):[]},It.tap=function(t,n){return n(t),t},It.throttle=function(t,n,r){
var e=true,u=true;if(typeof t!="function")throw new Nu("Expected a function");return uu(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),Ke(t,n,{leading:e,maxWait:n,trailing:u})},It.thru=ze,It.toArray=lu,It.toPairs=hf,It.toPairsIn=pf,It.toPath=function(t){return Fi(t)?l(t,Ae):au(t)?[t]:Wr(ei(t))},It.toPlainObject=vu,It.transform=function(t,n,r){var e=Fi(t)||Gi(t);if(n=fe(n,4),null==r)if(e||uu(t)){var o=t.constructor;r=e?Fi(t)?new o:[]:nu(o)?bn(eo(t)):{}}else r={};return(e?u:En)(t,function(t,e,u){
return n(r,t,e,u)}),r},It.unary=function(t){return Pe(t,1)},It.union=hi,It.unionBy=pi,It.unionWith=_i,It.uniq=function(t){return t&&t.length?yr(t):[]},It.uniqBy=function(t,n){return t&&t.length?yr(t,fe(n,2)):[]},It.uniqWith=function(t,n){return t&&t.length?yr(t,P,n):[]},It.unset=function(t,n){var r;if(null==t)r=true;else{r=t;var e=n,e=ye(e,r)?[e]:Ar(e);r=me(r,e),e=Ae(We(e)),r=!(null!=r&&Gu.call(r,e))||delete r[e]}return r},It.unzip=Ce,It.unzipWith=Ue,It.update=function(t,n,r){return null==t?t:lr(t,n,(typeof r=="function"?r:Ou)(In(t,n)),void 0);
},It.updateWith=function(t,n,r,e){return e=typeof e=="function"?e:P,null!=t&&(t=lr(t,n,(typeof r=="function"?r:Ou)(In(t,n)),e)),t},It.values=wu,It.valuesIn=function(t){return null==t?[]:I(t,xu(t))},It.without=vi,It.words=ku,It.wrap=function(t,n){return n=null==n?Ou:n,Mi(n,t)},It.xor=gi,It.xorBy=di,It.xorWith=yi,It.zip=bi,It.zipObject=function(t,n){return wr(t||[],n||[],ln)},It.zipObjectDeep=function(t,n){return wr(t||[],n||[],lr)},It.zipWith=xi,It.entries=hf,It.entriesIn=pf,It.extend=Qi,It.extendWith=Xi,
Iu(It,It),It.add=Lf,It.attempt=wf,It.camelCase=_f,It.capitalize=mu,It.ceil=Cf,It.clamp=function(t,n,r){return r===P&&(r=n,n=P),r!==P&&(r=_u(r),r=r===r?r:0),n!==P&&(n=_u(n),n=n===n?n:0),vn(_u(t),n,r)},It.clone=function(t){return gn(t,false,true)},It.cloneDeep=function(t){return gn(t,true,true)},It.cloneDeepWith=function(t,n){return gn(t,true,true,n)},It.cloneWith=function(t,n){return gn(t,false,true,n)},It.conformsTo=function(t,n){return null==n||yn(t,n,bu(n))},It.deburr=Au,It.defaultTo=function(t,n){return null==t||t!==t?n:t;
},It.divide=Uf,It.endsWith=function(t,n,r){t=gu(t),n=dr(n);var e=t.length,e=r=r===P?e:vn(hu(r),0,e);return r-=n.length,0<=r&&t.slice(r,e)==n},It.eq=Ye,It.escape=function(t){return(t=gu(t))&&X.test(t)?t.replace(H,on):t},It.escapeRegExp=function(t){return(t=gu(t))&&ct.test(t)?t.replace(ft,"\\$&"):t},It.every=function(t,n,r){var e=Fi(t)?i:wn;return r&&de(t,n,r)&&(n=P),e(t,fe(n,3))},It.find=mi,It.findIndex=Se,It.findKey=function(t,n){return v(t,fe(n,3),En)},It.findLast=Ai,It.findLastIndex=Ie,It.findLastKey=function(t,n){
return v(t,fe(n,3),On)},It.floor=Mf,It.forEach=Te,It.forEachRight=$e,It.forIn=function(t,n){return null==t?t:qo(t,fe(n,3),xu)},It.forInRight=function(t,n){return null==t?t:Vo(t,fe(n,3),xu)},It.forOwn=function(t,n){return t&&En(t,fe(n,3))},It.forOwnRight=function(t,n){return t&&On(t,fe(n,3))},It.get=du,It.gt=Ti,It.gte=$i,It.has=function(t,n){return null!=t&&se(t,n,Bn)},It.hasIn=yu,It.head=Re,It.identity=Ou,It.includes=function(t,n,r,e){return t=Qe(t)?t:wu(t),r=r&&!e?hu(r):0,e=t.length,0>r&&(r=xo(e+r,0)),
cu(t)?r<=e&&-1<t.indexOf(n,r):!!e&&-1<d(t,n,r)},It.indexOf=function(t,n,r){var e=t?t.length:0;return e?(r=null==r?0:hu(r),0>r&&(r=xo(e+r,0)),d(t,n,r)):-1},It.inRange=function(t,n,r){return n=su(n),r===P?(r=n,n=0):r=su(r),t=_u(t),t>=jo(n,r)&&t<xo(n,r)},It.invoke=ff,It.isArguments=He,It.isArray=Fi,It.isArrayBuffer=Ni,It.isArrayLike=Qe,It.isArrayLikeObject=Xe,It.isBoolean=function(t){return true===t||false===t||ou(t)&&"[object Boolean]"==Hu.call(t)},It.isBuffer=Pi,It.isDate=Zi,It.isElement=function(t){return!!t&&1===t.nodeType&&ou(t)&&!fu(t);
},It.isEmpty=function(t){if(Qe(t)&&(Fi(t)||typeof t=="string"||typeof t.splice=="function"||Pi(t)||He(t)))return!t.length;var n=St(t);if("[object Map]"==n||"[object Set]"==n)return!t.size;if(Lo||xe(t))return!bo(t).length;for(var r in t)if(Gu.call(t,r))return false;return true},It.isEqual=function(t,n){return Tn(t,n)},It.isEqualWith=function(t,n,r){var e=(r=typeof r=="function"?r:P)?r(t,n):P;return e===P?Tn(t,n,r):!!e},It.isError=tu,It.isFinite=function(t){return typeof t=="number"&&go(t)},It.isFunction=nu,
It.isInteger=ru,It.isLength=eu,It.isMap=qi,It.isMatch=function(t,n){return t===n||Fn(t,n,ae(n))},It.isMatchWith=function(t,n,r){return r=typeof r=="function"?r:P,Fn(t,n,ae(n),r)},It.isNaN=function(t){return iu(t)&&t!=+t},It.isNative=function(t){if(Xo(t))throw new Mu("This method is not supported with core-js. Try https://github.com/es-shims.");return Nn(t)},It.isNil=function(t){return null==t},It.isNull=function(t){return null===t},It.isNumber=iu,It.isObject=uu,It.isObjectLike=ou,It.isPlainObject=fu,
It.isRegExp=Vi,It.isSafeInteger=function(t){return ru(t)&&-9007199254740991<=t&&9007199254740991>=t},It.isSet=Ki,It.isString=cu,It.isSymbol=au,It.isTypedArray=Gi,It.isUndefined=function(t){return t===P},It.isWeakMap=function(t){return ou(t)&&"[object WeakMap]"==St(t)},It.isWeakSet=function(t){return ou(t)&&"[object WeakSet]"==Hu.call(t)},It.join=function(t,n){return t?yo.call(t,n):""},It.kebabCase=vf,It.last=We,It.lastIndexOf=function(t,n,r){var e=t?t.length:0;if(!e)return-1;var u=e;if(r!==P&&(u=hu(r),
u=(0>u?xo(e+u,0):jo(u,e-1))+1),n!==n)return g(t,b,u-1,true);for(;u--;)if(t[u]===n)return u;return-1},It.lowerCase=gf,It.lowerFirst=df,It.lt=Ji,It.lte=Yi,It.max=function(t){return t&&t.length?mn(t,Ou,Wn):P},It.maxBy=function(t,n){return t&&t.length?mn(t,fe(n,2),Wn):P},It.mean=function(t){return x(t,Ou)},It.meanBy=function(t,n){return x(t,fe(n,2))},It.min=function(t){return t&&t.length?mn(t,Ou,Jn):P},It.minBy=function(t,n){return t&&t.length?mn(t,fe(n,2),Jn):P},It.stubArray=Bu,It.stubFalse=Lu,It.stubObject=function(){
return{}},It.stubString=function(){return""},It.stubTrue=function(){return true},It.multiply=zf,It.nth=function(t,n){return t&&t.length?tr(t,hu(n)):P},It.noConflict=function(){return Vt._===this&&(Vt._=Qu),this},It.noop=Ru,It.now=Ri,It.pad=function(t,n,r){t=gu(t);var e=(n=hu(n))?$(t):0;return!n||e>=n?t:(n=(n-e)/2,Jr(po(n),r)+t+Jr(ho(n),r))},It.padEnd=function(t,n,r){t=gu(t);var e=(n=hu(n))?$(t):0;return n&&e<n?t+Jr(n-e,r):t},It.padStart=function(t,n,r){t=gu(t);var e=(n=hu(n))?$(t):0;return n&&e<n?Jr(n-e,r)+t:t;
},It.parseInt=function(t,n,r){return r||null==n?n=0:n&&(n=+n),t=gu(t).replace(at,""),wo(t,n||(bt.test(t)?16:10))},It.random=function(t,n,r){if(r&&typeof r!="boolean"&&de(t,n,r)&&(n=r=P),r===P&&(typeof n=="boolean"?(r=n,n=P):typeof t=="boolean"&&(r=t,t=P)),t===P&&n===P?(t=0,n=1):(t=su(t),n===P?(n=t,t=0):n=su(n)),t>n){var e=t;t=n,n=e}return r||t%1||n%1?(r=mo(),jo(t+r*(n-t+Nt("1e-"+((r+"").length-1))),n)):fr(t,n)},It.reduce=function(t,n,r){var e=Fi(t)?h:m,u=3>arguments.length;return e(t,fe(n,4),r,u,Po);
},It.reduceRight=function(t,n,r){var e=Fi(t)?p:m,u=3>arguments.length;return e(t,fe(n,4),r,u,Zo)},It.repeat=function(t,n,r){return n=(r?de(t,n,r):n===P)?1:hu(n),cr(gu(t),n)},It.replace=function(){var t=arguments,n=gu(t[0]);return 3>t.length?n:n.replace(t[1],t[2])},It.result=function(t,n,r){n=ye(n,t)?[n]:Ar(n);var e=-1,u=n.length;for(u||(t=P,u=1);++e<u;){var o=null==t?P:t[Ae(n[e])];o===P&&(e=u,o=r),t=nu(o)?o.call(t):o}return t},It.round=Df,It.runInContext=N,It.sample=function(t){t=Qe(t)?t:wu(t);var n=t.length;
return 0<n?t[fr(0,n-1)]:P},It.size=function(t){if(null==t)return 0;if(Qe(t))return cu(t)?$(t):t.length;var n=St(t);return"[object Map]"==n||"[object Set]"==n?t.size:Kn(t).length},It.snakeCase=yf,It.some=function(t,n,r){var e=Fi(t)?_:hr;return r&&de(t,n,r)&&(n=P),e(t,fe(n,3))},It.sortedIndex=function(t,n){return pr(t,n)},It.sortedIndexBy=function(t,n,r){return _r(t,n,fe(r,2))},It.sortedIndexOf=function(t,n){var r=t?t.length:0;if(r){var e=pr(t,n);if(e<r&&Ye(t[e],n))return e}return-1},It.sortedLastIndex=function(t,n){
return pr(t,n,true)},It.sortedLastIndexBy=function(t,n,r){return _r(t,n,fe(r,2),true)},It.sortedLastIndexOf=function(t,n){if(t&&t.length){var r=pr(t,n,true)-1;if(Ye(t[r],n))return r}return-1},It.startCase=bf,It.startsWith=function(t,n,r){return t=gu(t),r=vn(hu(r),0,t.length),n=dr(n),t.slice(r,r+n.length)==n},It.subtract=Tf,It.sum=function(t){return t&&t.length?k(t,Ou):0},It.sumBy=function(t,n){return t&&t.length?k(t,fe(n,2)):0},It.template=function(t,n,r){var e=It.templateSettings;r&&de(t,n,r)&&(n=P),t=gu(t),
n=Xi({},n,e,en),r=Xi({},n.imports,e.imports,en);var u,o,i=bu(r),f=I(r,i),c=0;r=n.interpolate||Et;var a="__p+='";r=$u((n.escape||Et).source+"|"+r.source+"|"+(r===rt?dt:Et).source+"|"+(n.evaluate||Et).source+"|$","g");var l="sourceURL"in n?"//# sourceURL="+n.sourceURL+"\n":"";if(t.replace(r,function(n,r,e,i,f,l){return e||(e=i),a+=t.slice(c,l).replace(Ot,L),r&&(u=true,a+="'+__e("+r+")+'"),f&&(o=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+n.length,n}),a+="';",(n=n.variable)||(a="with(obj){"+a+"}"),
a=(o?a.replace(K,""):a).replace(G,"$1").replace(J,"$1;"),a="function("+(n||"obj")+"){"+(n?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(o?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",n=wf(function(){return zu(i,l+"return "+a).apply(P,f)}),n.source=a,tu(n))throw n;return n},It.times=function(t,n){if(t=hu(t),1>t||9007199254740991<t)return[];var r=4294967295,e=jo(t,4294967295);for(n=fe(n),t-=4294967295,e=E(e,n);++r<t;)n(r);return e},It.toFinite=su,
It.toInteger=hu,It.toLength=pu,It.toLower=function(t){return gu(t).toLowerCase()},It.toNumber=_u,It.toSafeInteger=function(t){return vn(hu(t),-9007199254740991,9007199254740991)},It.toString=gu,It.toUpper=function(t){return gu(t).toUpperCase()},It.trim=function(t,n,r){return(t=gu(t))&&(r||n===P)?t.replace(at,""):t&&(n=dr(n))?(t=F(t),r=F(n),n=W(t,r),r=B(t,r)+1,kr(t,n,r).join("")):t},It.trimEnd=function(t,n,r){return(t=gu(t))&&(r||n===P)?t.replace(st,""):t&&(n=dr(n))?(t=F(t),n=B(t,F(n))+1,kr(t,0,n).join("")):t;
},It.trimStart=function(t,n,r){return(t=gu(t))&&(r||n===P)?t.replace(lt,""):t&&(n=dr(n))?(t=F(t),n=W(t,F(n)),kr(t,n).join("")):t},It.truncate=function(t,n){var r=30,e="...";if(uu(n))var u="separator"in n?n.separator:u,r="length"in n?hu(n.length):r,e="omission"in n?dr(n.omission):e;t=gu(t);var o=t.length;if(Ut.test(t))var i=F(t),o=i.length;if(r>=o)return t;if(o=r-$(e),1>o)return e;if(r=i?kr(i,0,o).join(""):t.slice(0,o),u===P)return r+e;if(i&&(o+=r.length-o),Vi(u)){if(t.slice(o).search(u)){var f=r;for(u.global||(u=$u(u.source,gu(yt.exec(u))+"g")),
u.lastIndex=0;i=u.exec(f);)var c=i.index;r=r.slice(0,c===P?o:c)}}else t.indexOf(dr(u),o)!=o&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},It.unescape=function(t){return(t=gu(t))&&Q.test(t)?t.replace(Y,fn):t},It.uniqueId=function(t){var n=++Ju;return gu(t)+n},It.upperCase=xf,It.upperFirst=jf,It.each=Te,It.eachRight=$e,It.first=Re,Iu(It,function(){var t={};return En(It,function(n,r){Gu.call(It.prototype,r)||(t[r]=n)}),t}(),{chain:false}),It.VERSION="4.15.0",u("bind bindKey curry curryRight partial partialRight".split(" "),function(t){
It[t].placeholder=It}),u(["drop","take"],function(t,n){$t.prototype[t]=function(r){var e=this.__filtered__;if(e&&!n)return new $t(this);r=r===P?1:xo(hu(r),0);var u=this.clone();return e?u.__takeCount__=jo(r,u.__takeCount__):u.__views__.push({size:jo(r,4294967295),type:t+(0>u.__dir__?"Right":"")}),u},$t.prototype[t+"Right"]=function(n){return this.reverse()[t](n).reverse()}}),u(["filter","map","takeWhile"],function(t,n){var r=n+1,e=1==r||3==r;$t.prototype[t]=function(t){var n=this.clone();return n.__iteratees__.push({
iteratee:fe(t,3),type:r}),n.__filtered__=n.__filtered__||e,n}}),u(["head","last"],function(t,n){var r="take"+(n?"Right":"");$t.prototype[t]=function(){return this[r](1).value()[0]}}),u(["initial","tail"],function(t,n){var r="drop"+(n?"":"Right");$t.prototype[t]=function(){return this.__filtered__?new $t(this):this[r](1)}}),$t.prototype.compact=function(){return this.filter(Ou)},$t.prototype.find=function(t){return this.filter(t).head()},$t.prototype.findLast=function(t){return this.reverse().find(t);
},$t.prototype.invokeMap=ar(function(t,n){return typeof t=="function"?new $t(this):this.map(function(r){return Mn(r,t,n)})}),$t.prototype.reject=function(t){return this.filter(Je(fe(t)))},$t.prototype.slice=function(t,n){t=hu(t);var r=this;return r.__filtered__&&(0<t||0>n)?new $t(r):(0>t?r=r.takeRight(-t):t&&(r=r.drop(t)),n!==P&&(n=hu(n),r=0>n?r.dropRight(-n):r.take(n-t)),r)},$t.prototype.takeRightWhile=function(t){return this.reverse().takeWhile(t).reverse()},$t.prototype.toArray=function(){return this.take(4294967295);
},En($t.prototype,function(t,n){var r=/^(?:filter|find|map|reject)|While$/.test(n),e=/^(?:head|last)$/.test(n),u=It[e?"take"+("last"==n?"Right":""):n],o=e||/^find/.test(n);u&&(It.prototype[n]=function(){function n(t){return t=u.apply(It,s([t],f)),e&&h?t[0]:t}var i=this.__wrapped__,f=e?[1]:arguments,c=i instanceof $t,a=f[0],l=c||Fi(i);l&&r&&typeof a=="function"&&1!=a.length&&(c=l=false);var h=this.__chain__,p=!!this.__actions__.length,a=o&&!h,c=c&&!p;return!o&&l?(i=c?i:new $t(this),i=t.apply(i,f),i.__actions__.push({
func:ze,args:[n],thisArg:P}),new Lt(i,h)):a&&c?t.apply(this,f):(i=this.thru(n),a?e?i.value()[0]:i.value():i)})}),u("pop push shift sort splice unshift".split(" "),function(t){var n=Pu[t],r=/^(?:push|sort|unshift)$/.test(t)?"tap":"thru",e=/^(?:pop|shift)$/.test(t);It.prototype[t]=function(){var t=arguments;if(e&&!this.__chain__){var u=this.value();return n.apply(Fi(u)?u:[],t)}return this[r](function(r){return n.apply(Fi(r)?r:[],t)})}}),En($t.prototype,function(t,n){var r=It[n];if(r){var e=r.name+"";
(Co[e]||(Co[e]=[])).push({name:n,func:r})}}),Co[qr(P,2).name]=[{name:"wrapper",func:P}],$t.prototype.clone=function(){var t=new $t(this.__wrapped__);return t.__actions__=Wr(this.__actions__),t.__dir__=this.__dir__,t.__filtered__=this.__filtered__,t.__iteratees__=Wr(this.__iteratees__),t.__takeCount__=this.__takeCount__,t.__views__=Wr(this.__views__),t},$t.prototype.reverse=function(){if(this.__filtered__){var t=new $t(this);t.__dir__=-1,t.__filtered__=true}else t=this.clone(),t.__dir__*=-1;return t;
},$t.prototype.value=function(){var t,n=this.__wrapped__.value(),r=this.__dir__,e=Fi(n),u=0>r,o=e?n.length:0;t=o;for(var i=this.__views__,f=0,c=-1,a=i.length;++c<a;){var l=i[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":t-=s;break;case"take":t=jo(t,f+s);break;case"takeRight":f=xo(f,t-s)}}if(t={start:f,end:t},i=t.start,f=t.end,t=f-i,u=u?f:i-1,i=this.__iteratees__,f=i.length,c=0,a=jo(t,this.__takeCount__),!e||200>o||o==t&&a==t)return xr(n,this.__actions__);e=[];t:for(;t--&&c<a;){
for(u+=r,o=-1,l=n[u];++o<f;){var h=i[o],s=h.type,h=(0,h.iteratee)(l);if(2==s)l=h;else if(!h){if(1==s)continue t;break t}}e[c++]=l}return e},It.prototype.at=ji,It.prototype.chain=function(){return Me(this)},It.prototype.commit=function(){return new Lt(this.value(),this.__chain__)},It.prototype.next=function(){this.__values__===P&&(this.__values__=lu(this.value()));var t=this.__index__>=this.__values__.length,n=t?P:this.__values__[this.__index__++];return{done:t,value:n}},It.prototype.plant=function(t){
for(var n,r=this;r instanceof Rt;){var e=Oe(r);e.__index__=0,e.__values__=P,n?u.__wrapped__=e:n=e;var u=e,r=r.__wrapped__}return u.__wrapped__=t,n},It.prototype.reverse=function(){var t=this.__wrapped__;return t instanceof $t?(this.__actions__.length&&(t=new $t(this)),t=t.reverse(),t.__actions__.push({func:ze,args:[Le],thisArg:P}),new Lt(t,this.__chain__)):this.thru(Le)},It.prototype.toJSON=It.prototype.valueOf=It.prototype.value=function(){return xr(this.__wrapped__,this.__actions__)},It.prototype.first=It.prototype.head,
uo&&(It.prototype[uo]=De),It}var P,Z=1/0,q=NaN,V=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],K=/\b__p\+='';/g,G=/\b(__p\+=)''\+/g,J=/(__e\(.*?\)|\b__t\))\+'';/g,Y=/&(?:amp|lt|gt|quot|#39|#96);/g,H=/[&<>"'`]/g,Q=RegExp(Y.source),X=RegExp(H.source),tt=/<%-([\s\S]+?)%>/g,nt=/<%([\s\S]+?)%>/g,rt=/<%=([\s\S]+?)%>/g,et=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,ut=/^\w*$/,ot=/^\./,it=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,ft=/[\\^$.*+?()[\]{}|]/g,ct=RegExp(ft.source),at=/^\s+|\s+$/g,lt=/^\s+/,st=/\s+$/,ht=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,pt=/\{\n\/\* \[wrapped with (.+)\] \*/,_t=/,? & /,vt=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,gt=/\\(\\)?/g,dt=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,yt=/\w*$/,bt=/^0x/i,xt=/^[-+]0x[0-9a-f]+$/i,jt=/^0b[01]+$/i,wt=/^\[object .+?Constructor\]$/,mt=/^0o[0-7]+$/i,At=/^(?:0|[1-9]\d*)$/,kt=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Et=/($^)/,Ot=/['\n\r\u2028\u2029\\]/g,St="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|\\ud83c[\\udffb-\\udfff])?)*",It="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+St,Rt="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]?|[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",Wt=RegExp("['\u2019]","g"),Bt=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]","g"),Lt=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Rt+St,"g"),Ct=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d+",It].join("|"),"g"),Ut=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]"),Mt=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,zt="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Dt={};
Dt["[object Float32Array]"]=Dt["[object Float64Array]"]=Dt["[object Int8Array]"]=Dt["[object Int16Array]"]=Dt["[object Int32Array]"]=Dt["[object Uint8Array]"]=Dt["[object Uint8ClampedArray]"]=Dt["[object Uint16Array]"]=Dt["[object Uint32Array]"]=true,Dt["[object Arguments]"]=Dt["[object Array]"]=Dt["[object ArrayBuffer]"]=Dt["[object Boolean]"]=Dt["[object DataView]"]=Dt["[object Date]"]=Dt["[object Error]"]=Dt["[object Function]"]=Dt["[object Map]"]=Dt["[object Number]"]=Dt["[object Object]"]=Dt["[object RegExp]"]=Dt["[object Set]"]=Dt["[object String]"]=Dt["[object WeakMap]"]=false;
var Tt={};Tt["[object Arguments]"]=Tt["[object Array]"]=Tt["[object ArrayBuffer]"]=Tt["[object DataView]"]=Tt["[object Boolean]"]=Tt["[object Date]"]=Tt["[object Float32Array]"]=Tt["[object Float64Array]"]=Tt["[object Int8Array]"]=Tt["[object Int16Array]"]=Tt["[object Int32Array]"]=Tt["[object Map]"]=Tt["[object Number]"]=Tt["[object Object]"]=Tt["[object RegExp]"]=Tt["[object Set]"]=Tt["[object String]"]=Tt["[object Symbol]"]=Tt["[object Uint8Array]"]=Tt["[object Uint8ClampedArray]"]=Tt["[object Uint16Array]"]=Tt["[object Uint32Array]"]=true,
Tt["[object Error]"]=Tt["[object Function]"]=Tt["[object WeakMap]"]=false;var $t,Ft={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Nt=parseFloat,Pt=parseInt,Zt=typeof global=="object"&&global&&global.Object===Object&&global,qt=typeof self=="object"&&self&&self.Object===Object&&self,Vt=Zt||qt||Function("return this")(),Kt=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Gt=Kt&&typeof module=="object"&&module&&!module.nodeType&&module,Jt=Gt&&Gt.exports===Kt,Yt=Jt&&Zt.g;
t:{try{$t=Yt&&Yt.f("util");break t}catch(t){}$t=void 0}var Ht=$t&&$t.isArrayBuffer,Qt=$t&&$t.isDate,Xt=$t&&$t.isMap,tn=$t&&$t.isRegExp,nn=$t&&$t.isSet,rn=$t&&$t.isTypedArray,en=j("length"),un=w({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I",
"\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C",
"\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i",
"\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S",
"\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n",
"\u017f":"ss"}),on=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"}),fn=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'","&#96;":"`"}),cn=N();typeof define=="function"&&typeof define.amd=="object"&&define.amd?(Vt._=cn, define(function(){return cn})):Gt?((Gt.exports=cn)._=cn,Kt._=cn):Vt._=cn}).call(this);
/**
 * gridstack.js 0.2.6
 * http://troolee.github.io/gridstack.js/
 * (c) 2014-2016 Pavel Reznikov
 * gridstack.js may be freely distributed under the MIT license.
 * @preserve
*/
(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery', 'lodash', 'jquery-ui/data', 'jquery-ui/disable-selection', 'jquery-ui/focusable',
            'jquery-ui/form', 'jquery-ui/ie', 'jquery-ui/keycode', 'jquery-ui/labels', 'jquery-ui/jquery-1-7',
            'jquery-ui/plugin', 'jquery-ui/safe-active-element', 'jquery-ui/safe-blur', 'jquery-ui/scroll-parent',
            'jquery-ui/tabbable', 'jquery-ui/unique-id', 'jquery-ui/version', 'jquery-ui/widget',
            'jquery-ui/widgets/mouse', 'jquery-ui/widgets/draggable', 'jquery-ui/widgets/droppable',
            'jquery-ui/widgets/resizable'], factory);
    } else if (typeof exports !== 'undefined') {
        try { jQuery = require('jquery'); } catch (e) {}
        try { _ = require('lodash'); } catch (e) {}
        factory(jQuery, _);
    } else {
        factory(jQuery, _);
    }
})(function($, _) {

    var scope = window;

    var obsolete = function(f, oldName, newName) {
        var wrapper = function() {
            console.warn('gridstack.js: Function `' + oldName + '` is deprecated as of v0.2.5 and has been replaced ' +
            'with `' + newName + '`. It will be **completely** removed in v1.0.');
            return f.apply(this, arguments);
        };
        wrapper.prototype = f.prototype;

        return wrapper;
    };

    var obsoleteOpts = function(oldName, newName) {
        console.warn('gridstack.js: Option `' + oldName + '` is deprecated as of v0.2.5 and has been replaced with `' +
            newName + '`. It will be **completely** removed in v1.0.');
    };

    var Utils = {
        isIntercepted: function(a, b) {
            return !(a.x + a.width <= b.x || b.x + b.width <= a.x || a.y + a.height <= b.y || b.y + b.height <= a.y);
        },

        sort: function(nodes, dir, width) {
            width = width || _.chain(nodes).map(function(node) { return node.x + node.width; }).max().value();
            dir = dir != -1 ? 1 : -1;
            return _.sortBy(nodes, function(n) { return dir * (n.x + n.y * width); });
        },

        createStylesheet: function(id) {
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.setAttribute('data-gs-style-id', id);
            if (style.styleSheet) {
                style.styleSheet.cssText = '';
            } else {
                style.appendChild(document.createTextNode(''));
            }
            document.getElementsByTagName('head')[0].appendChild(style);
            return style.sheet;
        },

        removeStylesheet: function(id) {
            $('STYLE[data-gs-style-id=' + id + ']').remove();
        },

        insertCSSRule: function(sheet, selector, rules, index) {
            if (typeof sheet.insertRule === 'function') {
                sheet.insertRule(selector + '{' + rules + '}', index);
            } else if (typeof sheet.addRule === 'function') {
                sheet.addRule(selector, rules, index);
            }
        },

        toBool: function(v) {
            if (typeof v == 'boolean') {
                return v;
            }
            if (typeof v == 'string') {
                v = v.toLowerCase();
                return !(v === '' || v == 'no' || v == 'false' || v == '0');
            }
            return Boolean(v);
        },

        _collisionNodeCheck: function(n) {
            return n != this.node && Utils.isIntercepted(n, this.nn);
        },

        _didCollide: function(bn) {
            return Utils.isIntercepted({x: this.n.x, y: this.newY, width: this.n.width, height: this.n.height}, bn);
        },

        _isAddNodeIntercepted: function(n) {
            return Utils.isIntercepted({x: this.x, y: this.y, width: this.node.width, height: this.node.height}, n);
        },

        parseHeight: function(val) {
            var height = val;
            var heightUnit = 'px';
            if (height && _.isString(height)) {
                var match = height.match(/^(-[0-9]+\.[0-9]+|[0-9]*\.[0-9]+|-[0-9]+|[0-9]+)(px|em|rem|vh|vw)?$/);
                if (!match) {
                    throw new Error('Invalid height');
                }
                heightUnit = match[2] || 'px';
                height = parseFloat(match[1]);
            }
            return {height: height, unit: heightUnit};
        }
    };

    // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
    Utils.is_intercepted = obsolete(Utils.isIntercepted, 'is_intercepted', 'isIntercepted');

    Utils.create_stylesheet = obsolete(Utils.createStylesheet, 'create_stylesheet', 'createStylesheet');

    Utils.remove_stylesheet = obsolete(Utils.removeStylesheet, 'remove_stylesheet', 'removeStylesheet');

    Utils.insert_css_rule = obsolete(Utils.insertCSSRule, 'insert_css_rule', 'insertCSSRule');
    // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

    var idSeq = 0;

    var GridStackEngine = function(width, onchange, floatMode, height, items) {
        this.width = width;
        this.float = floatMode || false;
        this.height = height || 0;

        this.nodes = items || [];
        this.onchange = onchange || function() {};

        this._updateCounter = 0;
        this._float = this.float;

        this._addedNodes = [];
        this._removedNodes = [];
    };

    GridStackEngine.prototype.batchUpdate = function() {
        this._updateCounter = 1;
        this.float = true;
    };

    GridStackEngine.prototype.commit = function() {
        if (this._updateCounter !== 0) {
            this._updateCounter = 0;
            this.float = this._float;
            this._packNodes();
            this._notify();
        }
    };

    // For Meteor support: https://github.com/troolee/gridstack.js/pull/272
    GridStackEngine.prototype.getNodeDataByDOMEl = function(el) {
        return _.find(this.nodes, function(n) { return el.get(0) === n.el.get(0); });
    };

    GridStackEngine.prototype._fixCollisions = function(node) {
        var self = this;
        this._sortNodes(-1);

        var nn = node;
        var hasLocked = Boolean(_.find(this.nodes, function(n) { return n.locked; }));
        if (!this.float && !hasLocked) {
            nn = {x: 0, y: node.y, width: this.width, height: node.height};
        }
        while (true) {
            var collisionNode = _.find(this.nodes, _.bind(Utils._collisionNodeCheck, {node: node, nn: nn}));
            if (typeof collisionNode == 'undefined') {
                return;
            }
            this.moveNode(collisionNode, collisionNode.x, node.y + node.height,
                collisionNode.width, collisionNode.height, true);
        }
    };

    GridStackEngine.prototype.isAreaEmpty = function(x, y, width, height) {
        var nn = {x: x || 0, y: y || 0, width: width || 1, height: height || 1};
        var collisionNode = _.find(this.nodes, _.bind(function(n) {
            return Utils.isIntercepted(n, nn);
        }, this));
        return collisionNode === null || typeof collisionNode === 'undefined';
    };

    GridStackEngine.prototype._sortNodes = function(dir) {
        this.nodes = Utils.sort(this.nodes, dir, this.width);
    };

    GridStackEngine.prototype._packNodes = function() {
        this._sortNodes();

        if (this.float) {
            _.each(this.nodes, _.bind(function(n, i) {
                if (n._updating || typeof n._origY == 'undefined' || n.y == n._origY) {
                    return;
                }

                var newY = n.y;
                while (newY >= n._origY) {
                    var collisionNode = _.chain(this.nodes)
                        .find(_.bind(Utils._didCollide, {n: n, newY: newY}))
                        .value();

                    if (!collisionNode) {
                        n._dirty = true;
                        n.y = newY;
                    }
                    --newY;
                }
            }, this));
        } else {
            _.each(this.nodes, _.bind(function(n, i) {
                if (n.locked) {
                    return;
                }
                while (n.y > 0) {
                    var newY = n.y - 1;
                    var canBeMoved = i === 0;

                    if (i > 0) {
                        var collisionNode = _.chain(this.nodes)
                            .take(i)
                            .find(_.bind(Utils._didCollide, {n: n, newY: newY}))
                            .value();
                        canBeMoved = typeof collisionNode == 'undefined';
                    }

                    if (!canBeMoved) {
                        break;
                    }
                    n._dirty = n.y != newY;
                    n.y = newY;
                }
            }, this));
        }
    };

    GridStackEngine.prototype._prepareNode = function(node, resizing) {
        node = _.defaults(node || {}, {width: 1, height: 1, x: 0, y: 0});

        node.x = parseInt('' + node.x);
        node.y = parseInt('' + node.y);
        node.width = parseInt('' + node.width);
        node.height = parseInt('' + node.height);
        node.autoPosition = node.autoPosition || false;
        node.noResize = node.noResize || false;
        node.noMove = node.noMove || false;

        if (node.width > this.width) {
            node.width = this.width;
        } else if (node.width < 1) {
            node.width = 1;
        }

        if (node.height < 1) {
            node.height = 1;
        }

        if (node.x < 0) {
            node.x = 0;
        }

        if (node.x + node.width > this.width) {
            if (resizing) {
                node.width = this.width - node.x;
            } else {
                node.x = this.width - node.width;
            }
        }

        if (node.y < 0) {
            node.y = 0;
        }

        return node;
    };

    GridStackEngine.prototype._notify = function() {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = typeof args[0] === 'undefined' ? [] : [args[0]];
        args[1] = typeof args[1] === 'undefined' ? true : args[1];
        if (this._updateCounter) {
            return;
        }
        var deletedNodes = args[0].concat(this.getDirtyNodes());
        this.onchange(deletedNodes, args[1]);
    };

    GridStackEngine.prototype.cleanNodes = function() {
        if (this._updateCounter) {
            return;
        }
        _.each(this.nodes, function(n) {n._dirty = false; });
    };

    GridStackEngine.prototype.getDirtyNodes = function() {
        return _.filter(this.nodes, function(n) { return n._dirty; });
    };

    GridStackEngine.prototype.addNode = function(node, triggerAddEvent) {
        node = this._prepareNode(node);

        if (typeof node.maxWidth != 'undefined') { node.width = Math.min(node.width, node.maxWidth); }
        if (typeof node.maxHeight != 'undefined') { node.height = Math.min(node.height, node.maxHeight); }
        if (typeof node.minWidth != 'undefined') { node.width = Math.max(node.width, node.minWidth); }
        if (typeof node.minHeight != 'undefined') { node.height = Math.max(node.height, node.minHeight); }

        node._id = ++idSeq;
        node._dirty = true;

        if (node.autoPosition) {
            this._sortNodes();

            for (var i = 0;; ++i) {
                var x = i % this.width;
                var y = Math.floor(i / this.width);
                if (x + node.width > this.width) {
                    continue;
                }
                if (!_.find(this.nodes, _.bind(Utils._isAddNodeIntercepted, {x: x, y: y, node: node}))) {
                    node.x = x;
                    node.y = y;
                    break;
                }
            }
        }

        this.nodes.push(node);
        if (typeof triggerAddEvent != 'undefined' && triggerAddEvent) {
            this._addedNodes.push(_.clone(node));
        }

        this._fixCollisions(node);
        this._packNodes();
        this._notify();
        return node;
    };

    GridStackEngine.prototype.removeNode = function(node, detachNode) {
        detachNode = typeof detachNode === 'undefined' ? true : detachNode;
        this._removedNodes.push(_.clone(node));
        node._id = null;
        this.nodes = _.without(this.nodes, node);
        this._packNodes();
        this._notify(node, detachNode);
    };

    GridStackEngine.prototype.canMoveNode = function(node, x, y, width, height) {
        var hasLocked = Boolean(_.find(this.nodes, function(n) { return n.locked; }));

        if (!this.height && !hasLocked) {
            return true;
        }

        var clonedNode;
        var clone = new GridStackEngine(
            this.width,
            null,
            this.float,
            0,
            _.map(this.nodes, function(n) {
                if (n == node) {
                    clonedNode = $.extend({}, n);
                    return clonedNode;
                }
                return $.extend({}, n);
            }));

        if (typeof clonedNode === 'undefined') {
            return true;
        }

        clone.moveNode(clonedNode, x, y, width, height);

        var res = true;

        if (hasLocked) {
            res &= !Boolean(_.find(clone.nodes, function(n) {
                return n != clonedNode && Boolean(n.locked) && Boolean(n._dirty);
            }));
        }
        if (this.height) {
            res &= clone.getGridHeight() <= this.height;
        }

        return res;
    };

    GridStackEngine.prototype.canBePlacedWithRespectToHeight = function(node) {
        if (!this.height) {
            return true;
        }

        var clone = new GridStackEngine(
            this.width,
            null,
            this.float,
            0,
            _.map(this.nodes, function(n) { return $.extend({}, n); }));
        clone.addNode(node);
        return clone.getGridHeight() <= this.height;
    };

    GridStackEngine.prototype.moveNode = function(node, x, y, width, height, noPack) {
        if (typeof x != 'number') { x = node.x; }
        if (typeof y != 'number') { y = node.y; }
        if (typeof width != 'number') { width = node.width; }
        if (typeof height != 'number') { height = node.height; }

        if (typeof node.maxWidth != 'undefined') { width = Math.min(width, node.maxWidth); }
        if (typeof node.maxHeight != 'undefined') { height = Math.min(height, node.maxHeight); }
        if (typeof node.minWidth != 'undefined') { width = Math.max(width, node.minWidth); }
        if (typeof node.minHeight != 'undefined') { height = Math.max(height, node.minHeight); }

        if (node.x == x && node.y == y && node.width == width && node.height == height) {
            return node;
        }

        var resizing = node.width != width;
        node._dirty = true;

        node.x = x;
        node.y = y;
        node.width = width;
        node.height = height;

        node = this._prepareNode(node, resizing);

        this._fixCollisions(node);
        if (!noPack) {
            this._packNodes();
            this._notify();
        }
        return node;
    };

    GridStackEngine.prototype.getGridHeight = function() {
        return _.reduce(this.nodes, function(memo, n) { return Math.max(memo, n.y + n.height); }, 0);
    };

    GridStackEngine.prototype.beginUpdate = function(node) {
        _.each(this.nodes, function(n) {
            n._origY = n.y;
        });
        node._updating = true;
    };

    GridStackEngine.prototype.endUpdate = function() {
        _.each(this.nodes, function(n) {
            n._origY = n.y;
        });
        var n = _.find(this.nodes, function(n) { return n._updating; });
        if (n) {
            n._updating = false;
        }
    };

    var GridStack = function(el, opts) {
        var self = this;
        var oneColumnMode, isAutoCellHeight;

        opts = opts || {};

        this.container = $(el);

        // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
        if (typeof opts.handle_class !== 'undefined') {
            opts.handleClass = opts.handle_class;
            obsoleteOpts('handle_class', 'handleClass');
        }
        if (typeof opts.item_class !== 'undefined') {
            opts.itemClass = opts.item_class;
            obsoleteOpts('item_class', 'itemClass');
        }
        if (typeof opts.placeholder_class !== 'undefined') {
            opts.placeholderClass = opts.placeholder_class;
            obsoleteOpts('placeholder_class', 'placeholderClass');
        }
        if (typeof opts.placeholder_text !== 'undefined') {
            opts.placeholderText = opts.placeholder_text;
            obsoleteOpts('placeholder_text', 'placeholderText');
        }
        if (typeof opts.cell_height !== 'undefined') {
            opts.cellHeight = opts.cell_height;
            obsoleteOpts('cell_height', 'cellHeight');
        }
        if (typeof opts.vertical_margin !== 'undefined') {
            opts.verticalMargin = opts.vertical_margin;
            obsoleteOpts('vertical_margin', 'verticalMargin');
        }
        if (typeof opts.min_width !== 'undefined') {
            opts.minWidth = opts.min_width;
            obsoleteOpts('min_width', 'minWidth');
        }
        if (typeof opts.static_grid !== 'undefined') {
            opts.staticGrid = opts.static_grid;
            obsoleteOpts('static_grid', 'staticGrid');
        }
        if (typeof opts.is_nested !== 'undefined') {
            opts.isNested = opts.is_nested;
            obsoleteOpts('is_nested', 'isNested');
        }
        if (typeof opts.always_show_resize_handle !== 'undefined') {
            opts.alwaysShowResizeHandle = opts.always_show_resize_handle;
            obsoleteOpts('always_show_resize_handle', 'alwaysShowResizeHandle');
        }
        // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

        opts.itemClass = opts.itemClass || 'grid-stack-item';
        var isNested = this.container.closest('.' + opts.itemClass).length > 0;

        this.opts = _.defaults(opts || {}, {
            width: parseInt(this.container.attr('data-gs-width')) || 12,
            height: parseInt(this.container.attr('data-gs-height')) || 0,
            itemClass: 'grid-stack-item',
            placeholderClass: 'grid-stack-placeholder',
            placeholderText: '',
            handle: '.grid-stack-item-content',
            handleClass: null,
            cellHeight: 60,
            verticalMargin: 20,
            auto: true,
            minWidth: 768,
            float: false,
            staticGrid: false,
            _class: 'grid-stack-instance-' + (Math.random() * 10000).toFixed(0),
            animate: Boolean(this.container.attr('data-gs-animate')) || false,
            alwaysShowResizeHandle: opts.alwaysShowResizeHandle || false,
            resizable: _.defaults(opts.resizable || {}, {
                autoHide: !(opts.alwaysShowResizeHandle || false),
                handles: 'se'
            }),
            draggable: _.defaults(opts.draggable || {}, {
                handle: (opts.handleClass ? '.' + opts.handleClass : (opts.handle ? opts.handle : '')) ||
                    '.grid-stack-item-content',
                scroll: false,
                appendTo: 'body'
            }),
            disableDrag: opts.disableDrag || false,
            disableResize: opts.disableResize || false,
            rtl: 'auto',
            removable: false,
            removeTimeout: 2000,
            verticalMarginUnit: 'px',
            cellHeightUnit: 'px'
        });

        if (this.opts.rtl === 'auto') {
            this.opts.rtl = this.container.css('direction') === 'rtl';
        }

        if (this.opts.rtl) {
            this.container.addClass('grid-stack-rtl');
        }

        this.opts.isNested = isNested;

        isAutoCellHeight = this.opts.cellHeight === 'auto';
        if (isAutoCellHeight) {
            self.cellHeight(self.cellWidth(), true);
        } else {
            this.cellHeight(this.opts.cellHeight, true);
        }
        this.verticalMargin(this.opts.verticalMargin, true);

        this.container.addClass(this.opts._class);

        this._setStaticClass();

        if (isNested) {
            this.container.addClass('grid-stack-nested');
        }

        this._initStyles();

        this.grid = new GridStackEngine(this.opts.width, function(nodes, detachNode) {
            detachNode = typeof detachNode === 'undefined' ? true : detachNode;
            var maxHeight = 0;
            _.each(nodes, function(n) {
                if (detachNode && n._id === null) {
                    if (n.el) {
                        n.el.remove();
                    }
                } else {
                    n.el
                        .attr('data-gs-x', n.x)
                        .attr('data-gs-y', n.y)
                        .attr('data-gs-width', n.width)
                        .attr('data-gs-height', n.height);
                    maxHeight = Math.max(maxHeight, n.y + n.height);
                }
            });
            self._updateStyles(maxHeight + 10);
        }, this.opts.float, this.opts.height);

        if (this.opts.auto) {
            var elements = [];
            var _this = this;
            this.container.children('.' + this.opts.itemClass + ':not(.' + this.opts.placeholderClass + ')')
                .each(function(index, el) {
                el = $(el);
                elements.push({
                    el: el,
                    i: parseInt(el.attr('data-gs-x')) + parseInt(el.attr('data-gs-y')) * _this.opts.width
                });
            });
            _.chain(elements).sortBy(function(x) { return x.i; }).each(function(i) {
                self._prepareElement(i.el);
            }).value();
        }

        this.setAnimation(this.opts.animate);

        this.placeholder = $(
            '<div class="' + this.opts.placeholderClass + ' ' + this.opts.itemClass + '">' +
            '<div class="placeholder-content">' + this.opts.placeholderText + '</div></div>').hide();

        this._updateContainerHeight();

        this._updateHeightsOnResize = _.throttle(function() {
            self.cellHeight(self.cellWidth(), false);
        }, 100);

        this.onResizeHandler = function() {
            if (isAutoCellHeight) {
                self._updateHeightsOnResize();
            }

            if (self._isOneColumnMode()) {
                if (oneColumnMode) {
                    return;
                }

                oneColumnMode = true;

                self.grid._sortNodes();
                _.each(self.grid.nodes, function(node) {
                    self.container.append(node.el);

                    if (self.opts.staticGrid) {
                        return;
                    }
                    if (node.noMove || self.opts.disableDrag) {
                        node.el.draggable('disable');
                    }
                    if (node.noResize || self.opts.disableResize) {
                        node.el.resizable('disable');
                    }

                    node.el.trigger('resize');
                });
            } else {
                if (!oneColumnMode) {
                    return;
                }

                oneColumnMode = false;

                if (self.opts.staticGrid) {
                    return;
                }

                _.each(self.grid.nodes, function(node) {
                    if (!node.noMove && !self.opts.disableDrag) {
                        node.el.draggable('enable');
                    }
                    if (!node.noResize && !self.opts.disableResize) {
                        node.el.resizable('enable');
                    }

                    node.el.trigger('resize');
                });
            }
        };

        $(window).resize(this.onResizeHandler);
        this.onResizeHandler();

        if (!self.opts.staticGrid && typeof self.opts.removable === 'string') {
            var trashZone = $(self.opts.removable);
            if (!trashZone.data('droppable')) {
                trashZone.droppable({
                    accept: '.' + self.opts.itemClass
                });
            }
            trashZone
                .on('dropover', function(event, ui) {
                    var el = $(ui.draggable);
                    var node = el.data('_gridstack_node');
                    if (node._grid !== self) {
                        return;
                    }
                    self._setupRemovingTimeout(el);
                })
                .on('dropout', function(event, ui) {
                    var el = $(ui.draggable);
                    var node = el.data('_gridstack_node');
                    if (node._grid !== self) {
                        return;
                    }
                    self._clearRemovingTimeout(el);
                });
        }

        if (!self.opts.staticGrid && self.opts.acceptWidgets) {
            var draggingElement = null;

            var onDrag = function(event, ui) {
                var el = draggingElement;
                var node = el.data('_gridstack_node');
                var pos = self.getCellFromPixel(ui.offset, true);
                var x = Math.max(0, pos.x);
                var y = Math.max(0, pos.y);
                if (!node._added) {
                    node._added = true;

                    node.el = el;
                    node.x = x;
                    node.y = y;
                    self.grid.cleanNodes();
                    self.grid.beginUpdate(node);
                    self.grid.addNode(node);

                    self.container.append(self.placeholder);
                    self.placeholder
                        .attr('data-gs-x', node.x)
                        .attr('data-gs-y', node.y)
                        .attr('data-gs-width', node.width)
                        .attr('data-gs-height', node.height)
                        .show();
                    node.el = self.placeholder;
                    node._beforeDragX = node.x;
                    node._beforeDragY = node.y;

                    self._updateContainerHeight();
                } else {
                    if (!self.grid.canMoveNode(node, x, y)) {
                        return;
                    }
                    self.grid.moveNode(node, x, y);
                    self._updateContainerHeight();
                }
            };

            $(self.container).droppable({
                accept: function(el) {
                    el = $(el);
                    var node = el.data('_gridstack_node');
                    if (node && node._grid === self) {
                        return false;
                    }
                    return el.is(self.opts.acceptWidgets === true ? '.grid-stack-item' : self.opts.acceptWidgets);
                },
                over: function(event, ui) {
                    var offset = self.container.offset();
                    var el = $(ui.draggable);
                    var cellWidth = self.cellWidth();
                    var cellHeight = self.cellHeight();
                    var origNode = el.data('_gridstack_node');

                    var width = origNode ? origNode.width : (Math.ceil(el.outerWidth() / cellWidth));
                    var height = origNode ? origNode.height : (Math.ceil(el.outerHeight() / cellHeight));

                    draggingElement = el;

                    var node = self.grid._prepareNode({width: width, height: height, _added: false, _temporary: true});
                    el.data('_gridstack_node', node);
                    el.data('_gridstack_node_orig', origNode);

                    el.on('drag', onDrag);
                },
                out: function(event, ui) {
                    var el = $(ui.draggable);
                    el.unbind('drag', onDrag);
                    var node = el.data('_gridstack_node');
                    node.el = null;
                    self.grid.removeNode(node);
                    self.placeholder.detach();
                    self._updateContainerHeight();
                    el.data('_gridstack_node', el.data('_gridstack_node_orig'));
                },
                drop: function(event, ui) {
                    self.placeholder.detach();

                    var node = $(ui.draggable).data('_gridstack_node');
                    node._grid = self;
                    var el = $(ui.draggable).clone(false);
                    el.data('_gridstack_node', node);
                    $(ui.draggable).remove();
                    node.el = el;
                    self.placeholder.hide();
                    el
                        .attr('data-gs-x', node.x)
                        .attr('data-gs-y', node.y)
                        .attr('data-gs-width', node.width)
                        .attr('data-gs-height', node.height)
                        .addClass(self.opts.itemClass)
                        .removeAttr('style')
                        .enableSelection()
                        .removeData('draggable')
                        .removeClass('ui-draggable ui-draggable-dragging ui-draggable-disabled')
                        .unbind('drag', onDrag);
                    self.container.append(el);
                    self._prepareElementsByNode(el, node);
                    self._updateContainerHeight();
                    self._triggerChangeEvent();

                    self.grid.endUpdate();
                }
            });
        }
    };

    GridStack.prototype._triggerChangeEvent = function(forceTrigger) {
        var elements = this.grid.getDirtyNodes();
        var hasChanges = false;

        var eventParams = [];
        if (elements && elements.length) {
            eventParams.push(elements);
            hasChanges = true;
        }

        if (hasChanges || forceTrigger === true) {
            this.container.trigger('change', eventParams);
        }
    };

    GridStack.prototype._triggerAddEvent = function() {
        if (this.grid._addedNodes && this.grid._addedNodes.length > 0) {
            this.container.trigger('added', [_.map(this.grid._addedNodes, _.clone)]);
            this.grid._addedNodes = [];
        }
    };

    GridStack.prototype._triggerRemoveEvent = function() {
        if (this.grid._removedNodes && this.grid._removedNodes.length > 0) {
            this.container.trigger('removed', [_.map(this.grid._removedNodes, _.clone)]);
            this.grid._removedNodes = [];
        }
    };

    GridStack.prototype._initStyles = function() {
        if (this._stylesId) {
            Utils.removeStylesheet(this._stylesId);
        }
        this._stylesId = 'gridstack-style-' + (Math.random() * 100000).toFixed();
        this._styles = Utils.createStylesheet(this._stylesId);
        if (this._styles !== null) {
            this._styles._max = 0;
        }
    };

    GridStack.prototype._updateStyles = function(maxHeight) {
        if (this._styles === null || typeof this._styles === 'undefined') {
            return;
        }

        var prefix = '.' + this.opts._class + ' .' + this.opts.itemClass;
        var self = this;
        var getHeight;

        if (typeof maxHeight == 'undefined') {
            maxHeight = this._styles._max;
            this._initStyles();
            this._updateContainerHeight();
        }
        if (!this.opts.cellHeight) { // The rest will be handled by CSS
            return ;
        }
        if (this._styles._max !== 0 && maxHeight <= this._styles._max) {
            return ;
        }

        if (!this.opts.verticalMargin || this.opts.cellHeightUnit === this.opts.verticalMarginUnit) {
            getHeight = function(nbRows, nbMargins) {
                return (self.opts.cellHeight * nbRows + self.opts.verticalMargin * nbMargins) +
                    self.opts.cellHeightUnit;
            };
        } else {
            getHeight = function(nbRows, nbMargins) {
                if (!nbRows || !nbMargins) {
                    return (self.opts.cellHeight * nbRows + self.opts.verticalMargin * nbMargins) +
                        self.opts.cellHeightUnit;
                }
                return 'calc(' + ((self.opts.cellHeight * nbRows) + self.opts.cellHeightUnit) + ' + ' +
                    ((self.opts.verticalMargin * nbMargins) + self.opts.verticalMarginUnit) + ')';
            };
        }

        if (this._styles._max === 0) {
            Utils.insertCSSRule(this._styles, prefix, 'min-height: ' + getHeight(1, 0) + ';', 0);
        }

        if (maxHeight > this._styles._max) {
            for (var i = this._styles._max; i < maxHeight; ++i) {
                Utils.insertCSSRule(this._styles,
                    prefix + '[data-gs-height="' + (i + 1) + '"]',
                    'height: ' + getHeight(i + 1, i) + ';',
                    i
                );
                Utils.insertCSSRule(this._styles,
                    prefix + '[data-gs-min-height="' + (i + 1) + '"]',
                    'min-height: ' + getHeight(i + 1, i) + ';',
                    i
                );
                Utils.insertCSSRule(this._styles,
                    prefix + '[data-gs-max-height="' + (i + 1) + '"]',
                    'max-height: ' + getHeight(i + 1, i) + ';',
                    i
                );
                Utils.insertCSSRule(this._styles,
                    prefix + '[data-gs-y="' + i + '"]',
                    'top: ' + getHeight(i, i) + ';',
                    i
                );
            }
            this._styles._max = maxHeight;
        }
    };

    GridStack.prototype._updateContainerHeight = function() {
        if (this.grid._updateCounter) {
            return;
        }
        var height = this.grid.getGridHeight();
        this.container.attr('data-gs-current-height', height);
        if (!this.opts.cellHeight) {
            return ;
        }
        if (!this.opts.verticalMargin) {
            this.container.css('height', (height * (this.opts.cellHeight)) + this.opts.cellHeightUnit);
        } else if (this.opts.cellHeightUnit === this.opts.verticalMarginUnit) {
            this.container.css('height', (height * (this.opts.cellHeight + this.opts.verticalMargin) -
                this.opts.verticalMargin) + this.opts.cellHeightUnit);
        } else {
            this.container.css('height', 'calc(' + ((height * (this.opts.cellHeight)) + this.opts.cellHeightUnit) +
                ' + ' + ((height * (this.opts.verticalMargin - 1)) + this.opts.verticalMarginUnit) + ')');
        }
    };

    GridStack.prototype._isOneColumnMode = function() {
        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <=
            this.opts.minWidth;
    };

    GridStack.prototype._setupRemovingTimeout = function(el) {
        var self = this;
        var node = $(el).data('_gridstack_node');

        if (node._removeTimeout || !self.opts.removable) {
            return;
        }
        node._removeTimeout = setTimeout(function() {
            el.addClass('grid-stack-item-removing');
            node._isAboutToRemove = true;
        }, self.opts.removeTimeout);
    };

    GridStack.prototype._clearRemovingTimeout = function(el) {
        var node = $(el).data('_gridstack_node');

        if (!node._removeTimeout) {
            return;
        }
        clearTimeout(node._removeTimeout);
        node._removeTimeout = null;
        el.removeClass('grid-stack-item-removing');
        node._isAboutToRemove = false;
    };

    GridStack.prototype._prepareElementsByNode = function(el, node) {
        if (typeof $.ui === 'undefined') {
            return;
        }
        var self = this;

        var cellWidth;
        var cellHeight;

        var dragOrResize = function(event, ui) {
            var x = Math.round(ui.position.left / cellWidth);
            var y = Math.floor((ui.position.top + cellHeight / 2) / cellHeight);
            var width;
            var height;

            if (event.type != 'drag') {
                width = Math.round(ui.size.width / cellWidth);
                height = Math.round(ui.size.height / cellHeight);
            }

            if (event.type == 'drag') {
                if (x < 0 || x >= self.grid.width || y < 0) {
                    if (self.opts.removable === true) {
                        self._setupRemovingTimeout(el);
                    }

                    x = node._beforeDragX;
                    y = node._beforeDragY;

                    self.placeholder.detach();
                    self.placeholder.hide();
                    self.grid.removeNode(node);
                    self._updateContainerHeight();

                    node._temporaryRemoved = true;
                } else {
                    self._clearRemovingTimeout(el);

                    if (node._temporaryRemoved) {
                        self.grid.addNode(node);
                        self.placeholder
                            .attr('data-gs-x', x)
                            .attr('data-gs-y', y)
                            .attr('data-gs-width', width)
                            .attr('data-gs-height', height)
                            .show();
                        self.container.append(self.placeholder);
                        node.el = self.placeholder;
                        node._temporaryRemoved = false;
                    }
                }
            } else if (event.type == 'resize')  {
                if (x < 0) {
                    return;
                }
            }

            if (!self.grid.canMoveNode(node, x, y, width, height)) {
                return;
            }
            self.grid.moveNode(node, x, y, width, height);
            self._updateContainerHeight();
        };

        var onStartMoving = function(event, ui) {
            self.container.append(self.placeholder);
            var o = $(this);
            self.grid.cleanNodes();
            self.grid.beginUpdate(node);
            cellWidth = self.cellWidth();
            var strictCellHeight = Math.ceil(o.outerHeight() / o.attr('data-gs-height'));
            cellHeight = self.container.height() / parseInt(self.container.attr('data-gs-current-height'));
            self.placeholder
                .attr('data-gs-x', o.attr('data-gs-x'))
                .attr('data-gs-y', o.attr('data-gs-y'))
                .attr('data-gs-width', o.attr('data-gs-width'))
                .attr('data-gs-height', o.attr('data-gs-height'))
                .show();
            node.el = self.placeholder;
            node._beforeDragX = node.x;
            node._beforeDragY = node.y;

            el.resizable('option', 'minWidth', cellWidth * (node.minWidth || 1));
            el.resizable('option', 'minHeight', strictCellHeight * (node.minHeight || 1));

            if (event.type == 'resizestart') {
                o.find('.grid-stack-item').trigger('resizestart');
            }
        };

        var onEndMoving = function(event, ui) {
            var o = $(this);
            if (!o.data('_gridstack_node')) {
                return;
            }

            var forceNotify = false;
            self.placeholder.detach();
            node.el = o;
            self.placeholder.hide();

            if (node._isAboutToRemove) {
                forceNotify = true;
                el.removeData('_gridstack_node');
                el.remove();
            } else {
                self._clearRemovingTimeout(el);
                if (!node._temporaryRemoved) {
                    o
                        .attr('data-gs-x', node.x)
                        .attr('data-gs-y', node.y)
                        .attr('data-gs-width', node.width)
                        .attr('data-gs-height', node.height)
                        .removeAttr('style');
                } else {
                    o
                        .attr('data-gs-x', node._beforeDragX)
                        .attr('data-gs-y', node._beforeDragY)
                        .attr('data-gs-width', node.width)
                        .attr('data-gs-height', node.height)
                        .removeAttr('style');
                    node.x = node._beforeDragX;
                    node.y = node._beforeDragY;
                    self.grid.addNode(node);
                }
            }
            self._updateContainerHeight();
            self._triggerChangeEvent(forceNotify);

            self.grid.endUpdate();

            var nestedGrids = o.find('.grid-stack');
            if (nestedGrids.length && event.type == 'resizestop') {
                nestedGrids.each(function(index, el) {
                    $(el).data('gridstack').onResizeHandler();
                });
                o.find('.grid-stack-item').trigger('resizestop');
            }
        };

        el
            .draggable(_.extend({}, this.opts.draggable, {
                containment: this.opts.isNested ? this.container.parent() : null,
                start: onStartMoving,
                stop: onEndMoving,
                drag: dragOrResize
            }))
            .resizable(_.extend({}, this.opts.resizable, {
                start: onStartMoving,
                stop: onEndMoving,
                resize: dragOrResize
            }));

        if (node.noMove || this._isOneColumnMode() || this.opts.disableDrag) {
            el.draggable('disable');
        }

        if (node.noResize || this._isOneColumnMode() || this.opts.disableResize) {
            el.resizable('disable');
        }

        el.attr('data-gs-locked', node.locked ? 'yes' : null);
    };

    GridStack.prototype._prepareElement = function(el, triggerAddEvent) {
        triggerAddEvent = typeof triggerAddEvent != 'undefined' ? triggerAddEvent : false;
        var self = this;
        el = $(el);

        el.addClass(this.opts.itemClass);
        var node = self.grid.addNode({
            x: el.attr('data-gs-x'),
            y: el.attr('data-gs-y'),
            width: el.attr('data-gs-width'),
            height: el.attr('data-gs-height'),
            maxWidth: el.attr('data-gs-max-width'),
            minWidth: el.attr('data-gs-min-width'),
            maxHeight: el.attr('data-gs-max-height'),
            minHeight: el.attr('data-gs-min-height'),
            autoPosition: Utils.toBool(el.attr('data-gs-auto-position')),
            noResize: Utils.toBool(el.attr('data-gs-no-resize')),
            noMove: Utils.toBool(el.attr('data-gs-no-move')),
            locked: Utils.toBool(el.attr('data-gs-locked')),
            el: el,
            id: el.attr('data-gs-id'),
            _grid: self
        }, triggerAddEvent);
        el.data('_gridstack_node', node);

        this._prepareElementsByNode(el, node);
    };

    GridStack.prototype.setAnimation = function(enable) {
        if (enable) {
            this.container.addClass('grid-stack-animate');
        } else {
            this.container.removeClass('grid-stack-animate');
        }
    };

    GridStack.prototype.addWidget = function(el, x, y, width, height, autoPosition, minWidth, maxWidth,
        minHeight, maxHeight, id) {
        el = $(el);
        if (typeof x != 'undefined') { el.attr('data-gs-x', x); }
        if (typeof y != 'undefined') { el.attr('data-gs-y', y); }
        if (typeof width != 'undefined') { el.attr('data-gs-width', width); }
        if (typeof height != 'undefined') { el.attr('data-gs-height', height); }
        if (typeof autoPosition != 'undefined') { el.attr('data-gs-auto-position', autoPosition ? 'yes' : null); }
        if (typeof minWidth != 'undefined') { el.attr('data-gs-min-width', minWidth); }
        if (typeof maxWidth != 'undefined') { el.attr('data-gs-max-width', maxWidth); }
        if (typeof minHeight != 'undefined') { el.attr('data-gs-min-height', minHeight); }
        if (typeof maxHeight != 'undefined') { el.attr('data-gs-max-height', maxHeight); }
        if (typeof id != 'undefined') { el.attr('data-gs-id', id); }
        this.container.append(el);
        this._prepareElement(el, true);
        this._triggerAddEvent();
        this._updateContainerHeight();
        this._triggerChangeEvent(true);

        return el;
    };

    GridStack.prototype.makeWidget = function(el) {
        el = $(el);
        this._prepareElement(el, true);
        this._triggerAddEvent();
        this._updateContainerHeight();
        this._triggerChangeEvent(true);

        return el;
    };

    GridStack.prototype.willItFit = function(x, y, width, height, autoPosition) {
        var node = {x: x, y: y, width: width, height: height, autoPosition: autoPosition};
        return this.grid.canBePlacedWithRespectToHeight(node);
    };

    GridStack.prototype.removeWidget = function(el, detachNode) {
        detachNode = typeof detachNode === 'undefined' ? true : detachNode;
        el = $(el);
        var node = el.data('_gridstack_node');

        // For Meteor support: https://github.com/troolee/gridstack.js/pull/272
        if (!node) {
            node = this.grid.getNodeDataByDOMEl(el);
        }

        this.grid.removeNode(node, detachNode);
        el.removeData('_gridstack_node');
        this._updateContainerHeight();
        if (detachNode) {
            el.remove();
        }
        this._triggerChangeEvent(true);
        this._triggerRemoveEvent();
    };

    GridStack.prototype.removeAll = function(detachNode) {
        _.each(this.grid.nodes, _.bind(function(node) {
            this.removeWidget(node.el, detachNode);
        }, this));
        this.grid.nodes = [];
        this._updateContainerHeight();
    };

    GridStack.prototype.destroy = function(detachGrid) {
        $(window).off('resize', this.onResizeHandler);
        this.disable();
        if (typeof detachGrid != 'undefined' && !detachGrid) {
            this.removeAll(false);
            this.container.removeData('gridstack');
        } else {
            this.container.remove();
        }
        Utils.removeStylesheet(this._stylesId);
        if (this.grid) {
            this.grid = null;
        }
    };

    GridStack.prototype.resizable = function(el, val) {
        var self = this;
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node == 'undefined' || node === null || typeof $.ui === 'undefined') {
                return;
            }

            node.noResize = !(val || false);
            if (node.noResize || self._isOneColumnMode()) {
                el.resizable('disable');
            } else {
                el.resizable('enable');
            }
        });
        return this;
    };

    GridStack.prototype.movable = function(el, val) {
        var self = this;
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node == 'undefined' || node === null || typeof $.ui === 'undefined') {
                return;
            }

            node.noMove = !(val || false);
            if (node.noMove || self._isOneColumnMode()) {
                el.draggable('disable');
                el.removeClass('ui-draggable-handle');
            } else {
                el.draggable('enable');
                el.addClass('ui-draggable-handle');
            }
        });
        return this;
    };

    GridStack.prototype.enableMove = function(doEnable, includeNewWidgets) {
        this.movable(this.container.children('.' + this.opts.itemClass), doEnable);
        if (includeNewWidgets) {
            this.opts.disableDrag = !doEnable;
        }
    };

    GridStack.prototype.enableResize = function(doEnable, includeNewWidgets) {
        this.resizable(this.container.children('.' + this.opts.itemClass), doEnable);
        if (includeNewWidgets) {
            this.opts.disableResize = !doEnable;
        }
    };

    GridStack.prototype.disable = function() {
        this.movable(this.container.children('.' + this.opts.itemClass), false);
        this.resizable(this.container.children('.' + this.opts.itemClass), false);
        this.container.trigger('disable');
    };

    GridStack.prototype.enable = function() {
        this.movable(this.container.children('.' + this.opts.itemClass), true);
        this.resizable(this.container.children('.' + this.opts.itemClass), true);
        this.container.trigger('enable');
    };

    GridStack.prototype.locked = function(el, val) {
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node == 'undefined' || node === null) {
                return;
            }

            node.locked = (val || false);
            el.attr('data-gs-locked', node.locked ? 'yes' : null);
        });
        return this;
    };

    GridStack.prototype.maxHeight = function(el, val) {
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node === 'undefined' || node === null) {
                return;
            }

            if (!isNaN(val)) {
                node.maxHeight = (val || false);
                el.attr('data-gs-max-height', val);
            }
        });
        return this;
    };

    GridStack.prototype.minHeight = function(el, val) {
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node === 'undefined' || node === null) {
                return;
            }

            if (!isNaN(val)) {
                node.minHeight = (val || false);
                el.attr('data-gs-min-height', val);
            }
        });
        return this;
    };

    GridStack.prototype.maxWidth = function(el, val) {
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node === 'undefined' || node === null) {
                return;
            }

            if (!isNaN(val)) {
                node.maxWidth = (val || false);
                el.attr('data-gs-max-width', val);
            }
        });
        return this;
    };

    GridStack.prototype.minWidth = function(el, val) {
        el = $(el);
        el.each(function(index, el) {
            el = $(el);
            var node = el.data('_gridstack_node');
            if (typeof node === 'undefined' || node === null) {
                return;
            }

            if (!isNaN(val)) {
                node.minWidth = (val || false);
                el.attr('data-gs-min-width', val);
            }
        });
        return this;
    };

    GridStack.prototype._updateElement = function(el, callback) {
        el = $(el).first();
        var node = el.data('_gridstack_node');
        if (typeof node == 'undefined' || node === null) {
            return;
        }

        var self = this;

        self.grid.cleanNodes();
        self.grid.beginUpdate(node);

        callback.call(this, el, node);

        self._updateContainerHeight();
        self._triggerChangeEvent();

        self.grid.endUpdate();
    };

    GridStack.prototype.resize = function(el, width, height) {
        this._updateElement(el, function(el, node) {
            width = (width !== null && typeof width != 'undefined') ? width : node.width;
            height = (height !== null && typeof height != 'undefined') ? height : node.height;

            this.grid.moveNode(node, node.x, node.y, width, height);
        });
    };

    GridStack.prototype.move = function(el, x, y) {
        this._updateElement(el, function(el, node) {
            x = (x !== null && typeof x != 'undefined') ? x : node.x;
            y = (y !== null && typeof y != 'undefined') ? y : node.y;

            this.grid.moveNode(node, x, y, node.width, node.height);
        });
    };

    GridStack.prototype.update = function(el, x, y, width, height) {
        this._updateElement(el, function(el, node) {
            x = (x !== null && typeof x != 'undefined') ? x : node.x;
            y = (y !== null && typeof y != 'undefined') ? y : node.y;
            width = (width !== null && typeof width != 'undefined') ? width : node.width;
            height = (height !== null && typeof height != 'undefined') ? height : node.height;

            this.grid.moveNode(node, x, y, width, height);
        });
    };

    GridStack.prototype.verticalMargin = function(val, noUpdate) {
        if (typeof val == 'undefined') {
            return this.opts.verticalMargin;
        }

        var heightData = Utils.parseHeight(val);

        if (this.opts.verticalMarginUnit === heightData.unit && this.opts.height === heightData.height) {
            return ;
        }
        this.opts.verticalMarginUnit = heightData.unit;
        this.opts.verticalMargin = heightData.height;

        if (!noUpdate) {
            this._updateStyles();
        }
    };

    GridStack.prototype.cellHeight = function(val, noUpdate) {
        if (typeof val == 'undefined') {
            if (this.opts.cellHeight) {
                return this.opts.cellHeight;
            }
            var o = this.container.children('.' + this.opts.itemClass).first();
            return Math.ceil(o.outerHeight() / o.attr('data-gs-height'));
        }
        var heightData = Utils.parseHeight(val);

        if (this.opts.cellHeightUnit === heightData.heightUnit && this.opts.height === heightData.height) {
            return ;
        }
        this.opts.cellHeightUnit = heightData.unit;
        this.opts.cellHeight = heightData.height;

        if (!noUpdate) {
            this._updateStyles();
        }

    };

    GridStack.prototype.cellWidth = function() {
        return Math.round(this.container.outerWidth() / this.opts.width);
    };

    GridStack.prototype.getCellFromPixel = function(position, useOffset) {
        var containerPos = (typeof useOffset != 'undefined' && useOffset) ?
            this.container.offset() : this.container.position();
        var relativeLeft = position.left - containerPos.left;
        var relativeTop = position.top - containerPos.top;

        var columnWidth = Math.floor(this.container.width() / this.opts.width);
        var rowHeight = Math.floor(this.container.height() / parseInt(this.container.attr('data-gs-current-height')));

        return {x: Math.floor(relativeLeft / columnWidth), y: Math.floor(relativeTop / rowHeight)};
    };

    GridStack.prototype.batchUpdate = function() {
        this.grid.batchUpdate();
    };

    GridStack.prototype.commit = function() {
        this.grid.commit();
        this._updateContainerHeight();
    };

    GridStack.prototype.isAreaEmpty = function(x, y, width, height) {
        return this.grid.isAreaEmpty(x, y, width, height);
    };

    GridStack.prototype.setStatic = function(staticValue) {
        this.opts.staticGrid = (staticValue === true);
        this.enableMove(!staticValue);
        this.enableResize(!staticValue);
        this._setStaticClass();
    };

    GridStack.prototype._setStaticClass = function() {
        var staticClassName = 'grid-stack-static';

        if (this.opts.staticGrid === true) {
            this.container.addClass(staticClassName);
        } else {
            this.container.removeClass(staticClassName);
        }
    };

    GridStack.prototype._updateNodeWidths = function(oldWidth, newWidth) {
        this.grid._sortNodes();
        this.grid.batchUpdate();
        var node = {};
        for (var i = 0; i < this.grid.nodes.length; i++) {
            node = this.grid.nodes[i];
            this.update(node.el, Math.round(node.x * newWidth / oldWidth), undefined,
                Math.round(node.width * newWidth / oldWidth), undefined);
        }
        this.grid.commit();
    };

    GridStack.prototype.setGridWidth = function(gridWidth,doNotPropagate) {
        this.container.removeClass('grid-stack-' + this.opts.width);
        if (doNotPropagate !== true) {
            this._updateNodeWidths(this.opts.width, gridWidth);
        }
        this.opts.width = gridWidth;
        this.grid.width = gridWidth;
        this.container.addClass('grid-stack-' + gridWidth);
    };

    // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
    GridStackEngine.prototype.batch_update = obsolete(GridStackEngine.prototype.batchUpdate);
    GridStackEngine.prototype._fix_collisions = obsolete(GridStackEngine.prototype._fixCollisions,
        '_fix_collisions', '_fixCollisions');
    GridStackEngine.prototype.is_area_empty = obsolete(GridStackEngine.prototype.isAreaEmpty,
        'is_area_empty', 'isAreaEmpty');
    GridStackEngine.prototype._sort_nodes = obsolete(GridStackEngine.prototype._sortNodes,
        '_sort_nodes', '_sortNodes');
    GridStackEngine.prototype._pack_nodes = obsolete(GridStackEngine.prototype._packNodes,
        '_pack_nodes', '_packNodes');
    GridStackEngine.prototype._prepare_node = obsolete(GridStackEngine.prototype._prepareNode,
        '_prepare_node', '_prepareNode');
    GridStackEngine.prototype.clean_nodes = obsolete(GridStackEngine.prototype.cleanNodes,
        'clean_nodes', 'cleanNodes');
    GridStackEngine.prototype.get_dirty_nodes = obsolete(GridStackEngine.prototype.getDirtyNodes,
        'get_dirty_nodes', 'getDirtyNodes');
    GridStackEngine.prototype.add_node = obsolete(GridStackEngine.prototype.addNode,
        'add_node', 'addNode, ');
    GridStackEngine.prototype.remove_node = obsolete(GridStackEngine.prototype.removeNode,
        'remove_node', 'removeNode');
    GridStackEngine.prototype.can_move_node = obsolete(GridStackEngine.prototype.canMoveNode,
        'can_move_node', 'canMoveNode');
    GridStackEngine.prototype.move_node = obsolete(GridStackEngine.prototype.moveNode,
        'move_node', 'moveNode');
    GridStackEngine.prototype.get_grid_height = obsolete(GridStackEngine.prototype.getGridHeight,
        'get_grid_height', 'getGridHeight');
    GridStackEngine.prototype.begin_update = obsolete(GridStackEngine.prototype.beginUpdate,
        'begin_update', 'beginUpdate');
    GridStackEngine.prototype.end_update = obsolete(GridStackEngine.prototype.endUpdate,
        'end_update', 'endUpdate');
    GridStackEngine.prototype.can_be_placed_with_respect_to_height =
        obsolete(GridStackEngine.prototype.canBePlacedWithRespectToHeight,
        'can_be_placed_with_respect_to_height', 'canBePlacedWithRespectToHeight');
    GridStack.prototype._trigger_change_event = obsolete(GridStack.prototype._triggerChangeEvent,
        '_trigger_change_event', '_triggerChangeEvent');
    GridStack.prototype._init_styles = obsolete(GridStack.prototype._initStyles,
        '_init_styles', '_initStyles');
    GridStack.prototype._update_styles = obsolete(GridStack.prototype._updateStyles,
        '_update_styles', '_updateStyles');
    GridStack.prototype._update_container_height = obsolete(GridStack.prototype._updateContainerHeight,
        '_update_container_height', '_updateContainerHeight');
    GridStack.prototype._is_one_column_mode = obsolete(GridStack.prototype._isOneColumnMode,
        '_is_one_column_mode','_isOneColumnMode');
    GridStack.prototype._prepare_element = obsolete(GridStack.prototype._prepareElement,
        '_prepare_element', '_prepareElement');
    GridStack.prototype.set_animation = obsolete(GridStack.prototype.setAnimation,
        'set_animation', 'setAnimation');
    GridStack.prototype.add_widget = obsolete(GridStack.prototype.addWidget,
        'add_widget', 'addWidget');
    GridStack.prototype.make_widget = obsolete(GridStack.prototype.makeWidget,
        'make_widget', 'makeWidget');
    GridStack.prototype.will_it_fit = obsolete(GridStack.prototype.willItFit,
        'will_it_fit', 'willItFit');
    GridStack.prototype.remove_widget = obsolete(GridStack.prototype.removeWidget,
        'remove_widget', 'removeWidget');
    GridStack.prototype.remove_all = obsolete(GridStack.prototype.removeAll,
        'remove_all', 'removeAll');
    GridStack.prototype.min_height = obsolete(GridStack.prototype.minHeight,
        'min_height', 'minHeight');
    GridStack.prototype.min_width = obsolete(GridStack.prototype.minWidth,
        'min_width', 'minWidth');
    GridStack.prototype._update_element = obsolete(GridStack.prototype._updateElement,
        '_update_element', '_updateElement');
    GridStack.prototype.cell_height = obsolete(GridStack.prototype.cellHeight,
        'cell_height', 'cellHeight');
    GridStack.prototype.cell_width = obsolete(GridStack.prototype.cellWidth,
        'cell_width', 'cellWidth');
    GridStack.prototype.get_cell_from_pixel = obsolete(GridStack.prototype.getCellFromPixel,
        'get_cell_from_pixel', 'getCellFromPixel');
    GridStack.prototype.batch_update = obsolete(GridStack.prototype.batchUpdate,
        'batch_update', 'batchUpdate');
    GridStack.prototype.is_area_empty = obsolete(GridStack.prototype.isAreaEmpty,
        'is_area_empty', 'isAreaEmpty');
    GridStack.prototype.set_static = obsolete(GridStack.prototype.setStatic,
        'set_static', 'setStatic');
    GridStack.prototype._set_static_class = obsolete(GridStack.prototype._setStaticClass,
        '_set_static_class', '_setStaticClass');
    // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

    scope.GridStackUI = GridStack;

    scope.GridStackUI.Utils = Utils;
    scope.GridStackUI.Engine = GridStackEngine;

    $.fn.gridstack = function(opts) {
        return this.each(function() {
            var o = $(this);
            if (!o.data('gridstack')) {
                o
                    .data('gridstack', new GridStack(this, opts));
            }
        });
    };

    return scope.GridStackUI;
});
/**
 * gridstack-angular - Angular Gridstack.js directive
 * @version v0.6.0-dev
 * @author Kevin Dietrich
 * @link https://github.com/kdietrich/gridstack-angular#readme
 * @license MIT
 */
(function(){
  'use strict';

  angular.module('gridstack-angular', []);
  var app = angular.module('gridstack-angular');
  app.controller('GridstackController', ['$scope', function($scope){
    this.gridstack = null;
    this.init = function(element, options){
      this.gridstack = element.gridstack(options).data('gridstack');
      return this.gridstack;
    };
  
    this.removeItem = function(element){
      if(this.gridstack){
        return this.gridstack.removeWidget(element, false);
      }
      return null;
    };
  
    this.addItem = function(element){
      if(this.gridstack){
        this.gridstack.makeWidget(element);
        return element;
      }
      return null;
    };

    this.dGridSetFx = function(caller){
      if(this.gridstack){
        if(caller == "e"){
          this.gridstack.enableMove(true);
          this.gridstack.enableResize(true);
        } else{
          this.gridstack.enableMove(false);
          this.gridstack.enableResize(false);
        }
        // return element;
      }
      return null;
    };
  
  }]);
})();

(function(){
  'use strict';
  
  var app = angular.module('gridstack-angular');
  app.directive('gridstack', ['$timeout', function($timeout){
    return{
      restrict: 'A',
      controller: 'GridstackController',
      scope:{
        onChange: '&',
        onDragStart: '&',
        onDragStop: '&',
        onResizeStart: '&',
        onResizeStop: '&',
        gridstackHandler: '=?',
        options: '='
      },
      link: function(scope, element, attrs, controller, ngModel){
  
        var gridstack = controller.init(element, scope.options);
        scope.gridstackHandler = gridstack;
  
        element.on('change', function(e, items){
          $timeout(function(){
            scope.$apply();
            scope.onChange({event: e, items: items});
          });
        });
  
        element.on('dragstart', function(e, ui){
          scope.onDragStart({event: e, ui: ui});
        });
  
        element.on('dragstop', function(e, ui){
          $timeout(function(){
            scope.$apply();
            scope.onDragStop({event: e, ui: ui});
          });
        });
  
        element.on('resizestart', function(e, ui){
          scope.onResizeStart({event: e, ui: ui});
        });
  
        element.on('resizestop', function(e, ui){
          $timeout(function(){
            scope.$apply();
            scope.onResizeStop({event: e, ui: ui});
          });
        });
  
        scope.$on("dGridSet", function(event, args){
          controller.dGridSetFx(args);
        });
      }
    };
  
  }]);
})();

(function(){
  'use strict';

  var app = angular.module('gridstack-angular');
  app.directive('gridstackItem', ['$timeout', function($timeout){
    return{
      restrict: 'A',
      controller: 'GridstackController',
      require: '^gridstack',
      scope:{
        gridstackItem: '=',
        onItemAdded: '&',
        onItemRemoved: '&',
        gsItemId: '=?',
        gsItemX: '=',
        gsItemY: '=',
        gsItemWidth: '=',
        gsItemHeight: '=',
        gsItemAutopos: '=',
        gsItemMinHeight: '=?',
        gsItemMaxHeight: '=?',
        gsItemMinWidth: '=?',
        gsItemMaxWidth: '=?'
      },
      link: function(scope, element, attrs, controller){
        if(scope.gsItemId){
          $(element).attr('data-gs-id', scope.gsItemId);
        }
        $(element).attr('data-gs-x', scope.gsItemX);
        $(element).attr('data-gs-y', scope.gsItemY);
        $(element).attr('data-gs-width', scope.gsItemWidth);
        $(element).attr('data-gs-height', scope.gsItemHeight);
        $(element).attr('data-gs-min-width', scope.gsItemMinWidth);
        $(element).attr('data-gs-min-height', scope.gsItemMinHeight);
        $(element).attr('data-gs-max-width', scope.gsItemMaxWidth);
        $(element).attr('data-gs-max-height', scope.gsItemMaxHeight);
        $(element).attr('data-gs-auto-position', scope.gsItemAutopos);

        var widget = controller.addItem(element);
        var item = element.data('_gridstack_node');
        $timeout(function(){
          scope.onItemAdded({item: item});
        });
  
        var propertyChanged = function(newVal, oldVal){
          if(newVal != oldVal){
            controller.gridstack.update($(element), scope.gsItemX, scope.gsItemY, scope.gsItemWidth, scope.gsItemHeight);
          }
        };
  
        scope.$watch(function(){ return $(element).attr('data-gs-id'); }, function(val){
          scope.gsItemId = val;
        });
  
        scope.$watch(function(){ return $(element).attr('data-gs-x'); }, function(val){
          scope.gsItemX = Number(val);
        });
  
        scope.$watch(function(){ return $(element).attr('data-gs-y'); }, function(val){
          scope.gsItemY = Number(val);
        });
  
        scope.$watch(function(){ return $(element).attr('data-gs-width'); }, function(val){
          scope.gsItemWidth = Number(val);
        });
  
        scope.$watch(function(){ return $(element).attr('data-gs-height'); }, function(val){
          scope.gsItemHeight = Number(val);
        });
  
        scope.$watch('gsItemX', propertyChanged);
        scope.$watch('gsItemY', propertyChanged);
        scope.$watch('gsItemWidth', propertyChanged);
        scope.$watch('gsItemHeight', propertyChanged);
  
        element.bind('$destroy', function(){
          var item = element.data('_gridstack_node');
          scope.onItemRemoved({item: item});
          controller.removeItem(element);
        });
      }
    };
  
  }]);
})();
/*
azure-maps-html-marker-layer Version: 0.0.1

MIT License - Copyright (c) Microsoft Corporation.
*/


!function(e,y){"use strict";var o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};function t(e,t){function r(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var n=function(){return(n=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var a in t=arguments[r])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e}).apply(this,arguments)};function a(e,n,s,l){return new(s=s||Promise)(function(r,t){function o(e){try{i(l.next(e))}catch(e){t(e)}}function a(e){try{i(l.throw(e))}catch(e){t(e)}}function i(e){var t;e.done?r(e.value):((t=e.value)instanceof s?t:new s(function(e){e(t)})).then(o,a)}i((l=l.apply(e,n||[])).next())})}function g(r,o){var a,i,n,e,s={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return e={next:t(0),throw:t(1),return:t(2)},"function"==typeof Symbol&&(e[Symbol.iterator]=function(){return this}),e;function t(t){return function(e){return function(t){if(a)throw new TypeError("Generator is already executing.");for(;s;)try{if(a=1,i&&(n=2&t[0]?i.return:t[0]?i.throw||((n=i.return)&&n.call(i),0):i.next)&&!(n=n.call(i,t[1])).done)return n;switch(i=0,n&&(t=[2&t[0],n.value]),t[0]){case 0:case 1:n=t;break;case 4:return s.label++,{value:t[1],done:!1};case 5:s.label++,i=t[1],t=[0];continue;case 7:t=s.ops.pop(),s.trys.pop();continue;default:if(!(n=0<(n=s.trys).length&&n[n.length-1])&&(6===t[0]||2===t[0])){s=0;continue}if(3===t[0]&&(!n||t[1]>n[0]&&t[1]<n[3])){s.label=t[1];break}if(6===t[0]&&s.label<n[1]){s.label=n[1],n=t;break}if(n&&s.label<n[2]){s.label=n[2],s.ops.push(t);break}n[2]&&s.ops.pop(),s.trys.pop();continue}t=o.call(r,s)}catch(e){t=[6,e],i=0}finally{a=n=0}if(5&t[0])throw t[1];return{value:t[0]?t[1]:void 0,done:!0}}([t,e])}}}var r=(i.merge=function(e,t){for(var r=window||global,o=0,a=e.split(".");o<a.length;o++){var i=a[o];if(!r[i])return t;r=r[i]}return n(n({},r),t)},i);function i(){}var s,l=(t(u,s=y.layer.BubbleLayer),u.prototype.getOptions=function(){return Object.assign({},this._options)},u.prototype.setOptions=function(e){var t=this._options,r={},o=!1;e.source&&t.source!==e.source&&(t.source=e.source,r.source=e.source,o=!0),e.sourceLayer&&t.sourceLayer!==e.sourceLayer&&(t.sourceLayer=e.sourceLayer,r.sourceLayer=e.sourceLayer,o=!0),e.filter&&t.filter!==e.filter&&(t.filter=e.filter,r.filter=e.filter,o=!0),"number"==typeof e.minZoom&&t.minZoom!==e.minZoom&&(t.minZoom=e.minZoom,r.minZoom=e.minZoom),"number"==typeof e.maxZoom&&t.maxZoom!==e.maxZoom&&(t.maxZoom=e.maxZoom,r.maxZoom=e.maxZoom),void 0!==e.visible&&t.visible!==e.visible&&(t.visible=e.visible,r.visible=e.visible),e.markerCallback&&t.markerCallback!=e.markerCallback&&(t.markerCallback=e.markerCallback,o=!0),"boolean"==typeof e.updateWhileMoving&&t.updateWhileMoving!==e.updateWhileMoving&&(t.updateWhileMoving=e.updateWhileMoving),o?this._clearCache(!0):this._updateMarkers(),s.prototype.setOptions.call(this,r)},u.prototype.update=function(){this._clearCache(!0),this._updateMarkers()},u.prototype.onAdd=function(e){var t=this,r=e.events;e&&(r.remove("moveend",t._updateMarkers),r.remove("move",t._mapMoved),r.remove("sourcedata",t._sourceUpdated)),(r=(t._map=e).events).add("moveend",t._updateMarkers),r.add("move",t._mapMoved),r.add("sourcedata",t._sourceUpdated),s.prototype.onAdd.call(this,e)},u.prototype.onRemove=function(){var e=this,t=e._map;if(t){var r=t.events;r.remove("moveend",e._updateMarkers),r.remove("move",e._mapMoved),r.remove("sourcedata",e._sourceUpdated)}e._clearCache(!1),e._map=null,s.prototype.onRemove.call(this)},u.prototype._getSourceClass=function(){var e=this.getSource();return"string"==typeof e&&null!==this._map?this._map.sources.getById(e):e instanceof y.source.Source?e:null},u.prototype._clearCache=function(e){var t=this;if(t._markerCache={},t._map)for(var r=0,o=t._markers.length;r<o;r++){var a=t._markers[r];t._removeEvents(a),a._eventsAttached=!1,t._map.markers.remove(a)}t._markers=[],t._markerIds=[],e&&t._updateMarkers()},u.prototype._getMarker=function(o,a,i){var n=this,s=n._markerCache,e=n._options;if(o=o||a.join(",")+JSON.stringify(i||{}),s[o])return s[o];var t=e.markerCallback(o,a,i);if(!(t instanceof y.HtmlMarker))return new Promise(function(r){t.then(function(e){var t=n._getExtendedMarker(e,o,a,i);t&&(s[o]=t,r(t))})});var r=n._getExtendedMarker(t,o,a,i);return r?(s[o]=r,Promise.resolve(r)):null},u.prototype._getExtendedMarker=function(e,t,r,o){var a=e;return a?(a.properties=o,a.id=t,a.setOptions({position:r}),a):null},u.prototype._addEvents=function(t){var r=this;r._supportedEvents.forEach(function(e){r.map.events.add(e,t,r._wrappedEvent)})},u.prototype._removeEvents=function(t){var r=this;r._supportedEvents.forEach(function(e){r.map.events.remove(e,t,r._wrappedEvent)})},u);function u(e,t,r){var o=s.call(this,e,t)||this;return o._options={minZoom:0,maxZoom:24,visible:!0,updateWhileMoving:!1,filter:["==",["geometry-type"],"Point"],markerCallback:function(e,t,r){return r.cluster?new y.HtmlMarker({position:t,text:r.point_count_abbreviated}):new y.HtmlMarker({position:t})}},o._markers=[],o._markerIds=[],o._markerCache={},o._supportedEvents=["click","contextmenu","dblclick","drag","dragstart","dragend","keydown","keypress","keyup","mousedown","mouseenter","mouseleave","mousemove","mouseout","mouseover","mouseup"],o._mapMoved=function(){o._options.updateWhileMoving&&o._updateMarkers()},o._sourceUpdated=function(e){var t=o._getSourceClass();t&&t.getId()===e.source.id&&(o._timer&&clearTimeout(o._timer),o._timer=setTimeout(o._sourceUpdater,33))},o._sourceUpdater=function(){o._timer=null,o._clearCache(!0)},o._updateMarkers=function(){return a(o,void 0,void 0,function(){var t,r,o,a,i,n,s,l,u,c,p,d,m,h,f,v,_,k;return g(this,function(e){switch(e.label){case 0:if(r=(t=this)._map,o=t._markers,a=t._options,i=r?r.getCamera().zoom:void 0,!(a.visible&&void 0!==i&&i>=a.minZoom&&i<=a.maxZoom))return[3,5];n=t.getSource(),s="string"==typeof n?n:n.getId(),l=r.map.querySourceFeatures(s,{sourceLayer:t.getOptions().sourceLayer,filter:a.filter}),u=[],c=[],v=f=h=m=d=p=void 0,k=0,_=l.length,e.label=1;case 1:return k<_?(p=v=null,l[k]instanceof y.Shape?"Point"===(h=l[k]).getType()&&(m=h.getCoordinates(),d=h.getProperties(),p=h.getId()):"Point"===(f=l[k]).geometry.type&&(m=f.geometry.coordinates,(d=f.properties)&&d.cluster?p="cluster_"+f.properties.cluster_id:f.id&&(p=f.id)),m?[4,t._getMarker(p,m,d)]:[3,3]):[3,4];case 2:(v=e.sent())._eventsAttached||(t._addEvents(v),v._eventsAttached=!0),v&&(v.id&&c.push(v.id),v.id&&-1!==t._markerIds.indexOf(v.id)||(u.push(v),r.markers.add(v))),e.label=3;case 3:return k++,[3,1];case 4:for(k=o.length-1;0<=k;k--)o[k].id&&-1!==c.indexOf(o[k].id)||(r.markers.remove(o[k]),o.splice(k,1));return t._markers=o.concat(u),t._markerIds=c,[3,6];case 5:0<t._markers.length&&(r.markers.remove(t._markers),t._markers=[]),e.label=6;case 6:return[2]}})})},o._wrappedEvent=function(e){o.map.events.invoke(e.type,o,e)},s.prototype.setOptions.call(o,{color:"transparent",radius:0,strokeWidth:0}),o.setOptions(r||{}),o}var b,c=Object.freeze({__proto__:null,HtmlMarkerLayer:l}),p=(t(C,b=y.HtmlMarker),C.prototype.getTotalValue=function(){return this._total},C.prototype.getSliceValue=function(e){var t=this._options.values;return 0<=e&&e<t.length?t[e]:0},C.prototype.getSlicePercentage=function(e){return 0<this._total?Math.round(this.getSliceValue(e)/this._total*1e4)/100:0},C.prototype.getOptions=function(){return Object.assign({},b.prototype.getOptions.call(this),this._options)},C.prototype.setOptions=function(e){var t=this._options,r=JSON.stringify,o=!1;e.radius&&0<e.radius&&e.radius!=t.radius&&(t.radius=e.radius,o=!0),0<=e.innerRadius&&e.innerRadius!=t.innerRadius&&(t.innerRadius=e.innerRadius,o=!0),e.colors&&r(e.colors)!==r(t.colors)&&(t.colors=e.colors,o=!0),e.fillColor&&r(e.fillColor)!==r(t.fillColor)&&(t.fillColor=e.fillColor,o=!0),e.strokeColor&&e.strokeColor!==t.strokeColor&&(t.strokeColor=e.strokeColor,o=!0),0<=e.strokeWidth&&e.strokeWidth!=t.strokeWidth&&(t.strokeWidth=e.strokeWidth,o=!0),void 0!==e.tooltipCallback&&t.tooltipCallback!=e.tooltipCallback&&(t.tooltipCallback=e.tooltipCallback,o=!0),e.values&&r(e.values)!==r(t.values)&&(t.values=e.values,o=!0),void 0!==e.text&&e.text!==t.text&&(b.prototype.setOptions.call(this,{text:e.text}),o=!0),void 0!==e.textClassName&&e.textClassName!==t.textClassName&&(t.textClassName=e.textClassName,o=!0),o&&this._render(),b.prototype.setOptions.call(this,e)},C.prototype._render=function(){var e=this,t=e._options,r=t.values,o=t.radius,a=0,i=0;if(r){e._total=r.reduce(function(e,t){return e+t},0);for(var n=C._moreColors,s=Math.random,l=Math.round,u=0;r.length>t.colors.length;)n.length<r.length&&n.push("hsl("+l(360*s())+","+(l(20*s())+70)+"%,"+(l(40*s())+30)+"%)"),t.colors.push(n[u]),u++;var c=o+t.strokeWidth,p=['<svg xmlns="http://www.w3.org/2000/svg" width="'+2*c+'px" height="'+2*c+'px">'],d="",m=void 0;if(0<t.innerRadius&&t.innerRadius<=t.radius&&(m="piechart-innercircle-"+l(1e7*s()),p.push('<defs><mask id="'+m+'"><rect width="100%" height="100%" fill="white"/><circle r="'+t.innerRadius+'" cx="'+c+'" cy="'+c+'" fill="black"/></mask></defs>\n                    <circle r="'+t.innerRadius+'" cx="'+c+'" cy="'+c+'" style="fill:'+t.fillColor+";stroke:"+t.strokeColor+";stroke-width:"+2*t.strokeWidth+'px;"/>')),0<e._total)for(var h=t.tooltipCallback,f=2*Math.PI/e._total,v=0;v<r.length;v++){i=f*r[v],h&&(d=h(e,v));var _=v<t.colors.length?t.colors[v]:n[v];p.push(e._createSlice(c,c,o,a,i,_,d,m)),a+=i}var k=e.getOptions().text;k&&p.push('<text x="'+c+'" y="'+(c+7)+'" style="font-size:16px;font-family:arial;fill:#000;font-weight:bold;" class="'+(t.textClassName||"")+'" text-anchor="middle">'+k+"</text>"),p.push("</svg>"),b.prototype.getOptions.call(this).htmlContent.innerHTML=p.join("")}},C.prototype._createSlice=function(e,t,r,o,a,i,n,s){var l=this._options,u=Math.PI,c="";if(s&&(c=' mask="url(#'+s+'"'),2*u*.99<a)return'<circle r="'+r+'" cx="'+e+'" cy="'+t+'" style="fill:'+i+";stroke:"+l.strokeColor+";stroke-width:"+l.strokeWidth+'px;"'+c+"><title>"+n+"</title></circle>";var p=Math.sin,d=Math.cos,m=e+r*p(o),h=t-r*d(o),f=e+r*p(o+a),v=t-r*d(o+a),_=(l.innerRadius,p(o),l.innerRadius,d(o),l.innerRadius,p(o+a),l.innerRadius,d(o+a),0);return u<a&&(_=1),'<path d="M'+e+" "+t+" L "+m+" "+h+" A "+r+","+r+" 0 "+_+" 1 "+f+" "+v+'z" style="fill:'+i+";stroke:"+l.strokeColor+";stroke-width:"+l.strokeWidth+'px;"'+c+"><title>"+n+"</title></path>"},C._moreColors=[],C);function C(e){var t=b.call(this,e)||this;return t._options={values:[],radius:40,colors:["#d7191c","#fdae61","#ffffbf","#abdda4","#2b83ba"],fillColor:"transparent",strokeWidth:0,strokeColor:"#666666",innerRadius:0},t._total=0,t.properties={},b.prototype.setOptions.call(t,{htmlContent:document.createElement("div"),pixelOffset:[0,0],anchor:"center"}),t.setOptions(e),t}var d=r.merge("atlas.layer",c);e.PieChartMarker=p,e.layer=d}(this.atlas=this.atlas||{},atlas);

/**
 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
 * @author Alex_Crack
 * @version v0.1.0
 * @link https://github.com/alexcrack/angular-ui-notification
 * @license MIT
 */
angular.module("ui-notification",[]),angular.module("ui-notification").provider("Notification",function(){this.options={delay:5e3,startTop:8,startRight:10,verticalSpacing:10,horizontalSpacing:10,positionX:"right",positionY:"top",replaceMessage:!1,templateUrl:"angular-ui-notification.html"},this.setOptions=function(t){if(!angular.isObject(t))throw new Error("Options should be an object!");this.options=angular.extend({},this.options,t)},this.$get=["$timeout","$http","$compile","$templateCache","$rootScope","$injector","$sce","$q","$window",function(t,e,i,n,o,s,a,r,l){var p=this.options,c=p.startTop,u=p.startRight,d=p.verticalSpacing,m=p.horizontalSpacing,g=p.delay,f=[],h=!1,y=function(s,y){var v=r.defer();return"object"!=typeof s&&(s={message:s}),s.scope=s.scope?s.scope:o,s.template=s.templateUrl?s.templateUrl:p.templateUrl,s.delay=angular.isUndefined(s.delay)?g:s.delay,s.type=y||p.type||"",s.positionY=s.positionY?s.positionY:p.positionY,s.positionX=s.positionX?s.positionX:p.positionX,s.replaceMessage=s.replaceMessage?s.replaceMessage:p.replaceMessage,e.get(s.template,{cache:n}).success(function(e){var n=s.scope.$new();n.message=a.trustAsHtml(s.message),n.title=a.trustAsHtml(s.title),n.t=s.type.substr(0,1),n.delay=s.delay;var o=function(){for(var t=0,e=0,i=c,n=u,o=[],a=f.length-1;a>=0;a--){var r=f[a];if(s.replaceMessage&&a<f.length-1)r.addClass("killed");else{var l=parseInt(r[0].offsetHeight),p=parseInt(r[0].offsetWidth),g=o[r._positionY+r._positionX];h+l>window.innerHeight&&(g=c,e++,t=0);var h=i=g?0===t?g:g+d:c,y=n+e*(m+p);r.css(r._positionY,h+"px"),"center"==r._positionX?r.css("left",parseInt(window.innerWidth/2-p/2)+"px"):r.css(r._positionX,y+"px"),o[r._positionY+r._positionX]=h+l,t++}}},r=i(e)(n);r._positionY=s.positionY,r._positionX=s.positionX,r.addClass(s.type),r.bind("webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd click",function(t){t=t.originalEvent||t,("click"===t.type||"opacity"===t.propertyName&&t.elapsedTime>=1)&&(r.remove(),f.splice(f.indexOf(r),1),o())}),angular.isNumber(s.delay)&&t(function(){r.addClass("killed")},s.delay),angular.element(document.getElementsByTagName("body")).append(r);var p=-(parseInt(r[0].offsetHeight)+50);r.css(r._positionY,p+"px"),f.push(r),n._templateElement=r,n.kill=function(e){e?(f.splice(f.indexOf(n._templateElement),1),n._templateElement.remove(),t(o)):n._templateElement.addClass("killed")},t(o),h||(angular.element(l).bind("resize",function(){t(o)}),h=!0),v.resolve(n)}).error(function(t){throw new Error("Template ("+s.template+") could not be loaded. "+t)}),v.promise};return y.primary=function(t){return this(t,"primary")},y.error=function(t){return this(t,"error")},y.success=function(t){return this(t,"success")},y.info=function(t){return this(t,"info")},y.warning=function(t){return this(t,"warning")},y.clearAll=function(){angular.forEach(f,function(t){t.addClass("killed")})},y}]}),angular.module("ui-notification").run(["$templateCache",function(t){t.put("angular-ui-notification.html",'<div class="ui-notification"><h3 ng-show="title" ng-bind-html="title"></h3><div class="message" ng-bind-html="message"></div></div>')}]);

/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e()}):"object"==typeof module&&module.exports?module.exports=e():e()}(0,function(){function t(e){"use strict";var n=e.storageKey(),a=e.storage(),t=function(){var t=e.preferredLanguage();angular.isString(t)?e.use(t):a.put(n,e.use())};t.displayName="fallbackFromIncorrectStorageValue",a?a.get(n)?e.use(a.get(n)).catch(t):t():angular.isString(e.preferredLanguage())&&e.use(e.preferredLanguage())}function e(t,r,e,i){"use strict";var T,c,z,x,F,I,_,n,V,R,D,K,U,M,H,G,q={},Y=[],B=t,J=[],Q="translate-cloak",W=!1,X=!1,Z=!0,tt=".",et=!1,nt=!1,at=0,rt=!0,a="default",s={default:function(t){return(t||"").split("-").join("_")},java:function(t){var e=(t||"").split("-").join("_"),n=e.split("_");return 1<n.length?n[0].toLowerCase()+"_"+n[1].toUpperCase():e},bcp47:function(t){var e=(t||"").split("_").join("-"),n=e.split("-");switch(n.length){case 1:n[0]=n[0].toLowerCase();break;case 2:n[0]=n[0].toLowerCase(),4===n[1].length?n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase():n[1]=n[1].toUpperCase();break;case 3:n[0]=n[0].toLowerCase(),n[1]=n[1].charAt(0).toUpperCase()+n[1].slice(1).toLowerCase(),n[2]=n[2].toUpperCase();break;default:return e}return n.join("-")},"iso639-1":function(t){return(t||"").split("_").join("-").split("-")[0].toLowerCase()}},o=function(){if(angular.isFunction(i.getLocale))return i.getLocale();var t,e,n=r.$get().navigator,a=["language","browserLanguage","systemLanguage","userLanguage"];if(angular.isArray(n.languages))for(t=0;t<n.languages.length;t++)if((e=n.languages[t])&&e.length)return e;for(t=0;t<a.length;t++)if((e=n[a[t]])&&e.length)return e;return null};o.displayName="angular-translate/service: getFirstBrowserLanguage";var it=function(){var t=o()||"";return s[a]&&(t=s[a](t)),t};it.displayName="angular-translate/service: getLocale";var st=function(t,e){for(var n=0,a=t.length;n<a;n++)if(t[n]===e)return n;return-1},ot=function(){return this.toString().replace(/^\s+|\s+$/g,"")},f=function(t){return angular.isString(t)?t.toLowerCase():t},lt=function(t){if(t){for(var e,n=[],a=f(t),r=0,i=Y.length;r<i;r++)n.push(f(Y[r]));if(-1<(r=st(n,a)))return Y[r];if(c)for(var s in c)if(c.hasOwnProperty(s)){var o=!1,l=Object.prototype.hasOwnProperty.call(c,s)&&f(s)===f(t);if("*"===s.slice(-1)&&(o=f(s.slice(0,-1))===f(t.slice(0,s.length-1))),(l||o)&&(e=c[s],-1<st(n,f(e))))return e}var u=t.split("_");return 1<u.length&&-1<st(n,f(u[0]))?u[0]:void 0}},ut=function(t,e){if(!t&&!e)return q;if(t&&!e){if(angular.isString(t))return q[t]}else angular.isObject(q[t])||(q[t]={}),angular.extend(q[t],ct(e));return this};this.translations=ut,this.cloakClassName=function(t){return t?(Q=t,this):Q},this.allowNamespaces=function(t){return void 0===t?Z:(Z=t,this)},this.nestedObjectDelimeter=function(t){return t?(tt=t,this):tt};var ct=function(t,e,n,a){var r,i,s;if(e||(e=[]),n||(n={}),!Z)return t;for(r in t)Object.prototype.hasOwnProperty.call(t,r)&&(s=t[r],angular.isObject(s)?ct(s,e.concat(r),n,r):(i=e.length?""+e.join(tt)+tt+r:r,e.length&&r===a&&(n[""+e.join(tt)]="@:"+i),n[i]=s));return n};ct.displayName="flatObject",this.addInterpolation=function(t){return J.push(t),this},this.useMessageFormatInterpolation=function(){return this.useInterpolation("$translateMessageFormatInterpolation")},this.useInterpolation=function(t){return R=t,this},this.useSanitizeValueStrategy=function(t){return e.useStrategy(t),this},this.preferredLanguage=function(t){return t?(ft(t),this):T};var ft=function(t){return t&&(T=t),T};this.translationNotFoundIndicator=function(t){return this.translationNotFoundIndicatorLeft(t),this.translationNotFoundIndicatorRight(t),this},this.translationNotFoundIndicatorLeft=function(t){return t?(U=t,this):U},this.translationNotFoundIndicatorRight=function(t){return t?(M=t,this):M},this.fallbackLanguage=function(t){return gt(t),this};var gt=function(t){return t?(angular.isString(t)?(x=!0,z=[t]):angular.isArray(t)&&(x=!1,z=t),angular.isString(T)&&st(z,T)<0&&z.push(T),this):x?z[0]:z};this.use=function(t){if(t){if(!q[t]&&!D)throw new Error("$translateProvider couldn't find translationTable for langKey: '"+t+"'");return F=t,this}return F},this.resolveClientLocale=function(){return it()};var pt=function(t){return t?(B=t,this):n?n+B:B};this.storageKey=pt,this.useUrlLoader=function(t,e){return this.useLoader("$translateUrlLoader",angular.extend({url:t},e))},this.useStaticFilesLoader=function(t){return this.useLoader("$translateStaticFilesLoader",t)},this.useLoader=function(t,e){return D=t,K=e||{},this},this.useLocalStorage=function(){return this.useStorage("$translateLocalStorage")},this.useCookieStorage=function(){return this.useStorage("$translateCookieStorage")},this.useStorage=function(t){return _=t,this},this.storagePrefix=function(t){return t?(n=t,this):t},this.useMissingTranslationHandlerLog=function(){return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog")},this.useMissingTranslationHandler=function(t){return V=t,this},this.usePostCompiling=function(t){return W=!!t,this},this.forceAsyncReload=function(t){return X=!!t,this},this.uniformLanguageTag=function(t){return t?angular.isString(t)&&(t={standard:t}):t={},a=t.standard,this},this.determinePreferredLanguage=function(t){var e=t&&angular.isFunction(t)?t():it();return T=Y.length&&lt(e)||e,this},this.registerAvailableLanguageKeys=function(t,e){return t?(Y=t,e&&(c=e),this):Y},this.useLoaderCache=function(t){return!1===t?H=void 0:!0===t?H=!0:void 0===t?H="$translationCache":t&&(H=t),this},this.directivePriority=function(t){return void 0===t?at:(at=t,this)},this.statefulFilter=function(t){return void 0===t?rt:(rt=t,this)},this.postProcess=function(t){return G=t||void 0,this},this.keepContent=function(t){return nt=!!t,this},this.$get=["$log","$injector","$rootScope","$q",function(t,o,s,m){var i,$,y,b=o.get(R||"$translateDefaultInterpolation"),S=!1,L={},f={},w=function(t,s,o,l,u,c){!F&&T&&(F=T);var a=u&&u!==F?lt(u)||u:F;if(u&&v(u),angular.isArray(t)){return function(t){for(var a={},e=[],n=function(e){var n=m.defer(),t=function(t){a[e]=t,n.resolve([e,t])};return w(e,s,o,l,u,c).then(t,t),n.promise},r=0,i=t.length;r<i;r++)e.push(n(t[r]));return m.all(e).then(function(){return a})}(t)}var e=m.defer();if(!t)throw new TypeError("translationId must be a not empty string");t=ot.apply(t);var n=function(){var t=f[a]||f[T];if($=0,_&&!t){var e=i.get(B);if(t=f[e],z&&z.length){var n=st(z,e);$=0===n?1:0,st(z,T)<0&&z.push(T)}}return t}();if(n){var r=function(){u||(a=F),h(t,s,o,l,a,c).then(e.resolve,e.reject)};r.displayName="promiseResolved",n.finally(r).catch(angular.noop)}else h(t,s,o,l,a,c).then(e.resolve,e.reject);return e.promise},j=function(t){return U&&(t=[U,t].join(" ")),M&&(t=[t,M].join(" ")),t},l=function(t){F=t,_&&i.put(w.storageKey(),F),s.$emit("$translateChangeSuccess",{language:t}),b.setLocale(F);var e=function(t,e){L[e].setLocale(F)};e.displayName="eachInterpolatorLocaleSetter",angular.forEach(L,e),s.$emit("$translateChangeEnd",{language:t})},u=function(n){if(!n)throw"No language key specified for loading.";var a=m.defer();s.$emit("$translateLoadingStart",{language:n}),S=!0;var t=H;"string"==typeof t&&(t=o.get(t));var e=angular.extend({},K,{key:n,$http:angular.extend({},{cache:t},K.$http)}),r=function(t){var e={};s.$emit("$translateLoadingSuccess",{language:n}),angular.isArray(t)?angular.forEach(t,function(t){angular.extend(e,ct(t))}):angular.extend(e,ct(t)),S=!1,a.resolve({key:n,table:e}),s.$emit("$translateLoadingEnd",{language:n})};r.displayName="onLoaderSuccess";var i=function(t){s.$emit("$translateLoadingError",{language:t}),a.reject(t),s.$emit("$translateLoadingEnd",{language:t})};return i.displayName="onLoaderError",o.get(D)(e).then(r,i),a.promise};if(_&&(!(i=o.get(_)).get||!i.put))throw new Error("Couldn't use storage '"+_+"', missing get() or put() method!");if(J.length){var e=function(t){var e=o.get(t);e.setLocale(T||F),L[e.getInterpolationIdentifier()]=e};e.displayName="interpolationFactoryAdder",angular.forEach(J,e)}var c=function(a,r,i,s,o){var l=m.defer(),t=function(t){if(Object.prototype.hasOwnProperty.call(t,r)&&null!==t[r]){s.setLocale(a);var e=t[r];if("@:"===e.substr(0,2))c(a,e.substr(2),i,s,o).then(l.resolve,l.reject);else{var n=s.interpolate(t[r],i,"service",o,r);n=O(r,t[r],n,i,a),l.resolve(n)}s.setLocale(F)}else l.reject()};return t.displayName="fallbackTranslationResolver",function(t){var e=m.defer();if(Object.prototype.hasOwnProperty.call(q,t))e.resolve(q[t]);else if(f[t]){var n=function(t){ut(t.key,t.table),e.resolve(t.table)};n.displayName="translationTableResolver",f[t].then(n,e.reject)}else e.reject();return e.promise}(a).then(t,l.reject),l.promise},g=function(t,e,n,a,r){var i,s=q[t];if(s&&Object.prototype.hasOwnProperty.call(s,e)&&null!==s[e]){if(a.setLocale(t),i=a.interpolate(s[e],n,"filter",r,e),i=O(e,s[e],i,n,t,r),!angular.isString(i)&&angular.isFunction(i.$$unwrapTrustedValue)){var o=i.$$unwrapTrustedValue();if("@:"===o.substr(0,2))return g(t,o.substr(2),n,a,r)}else if("@:"===i.substr(0,2))return g(t,i.substr(2),n,a,r);a.setLocale(F)}return i},C=function(t,e,n,a){return V?o.get(V)(t,F,e,n,a):t},N=function(t,e,n,a,r,i){var s=m.defer();if(t<z.length){var o=z[t];c(o,e,n,a,i).then(function(t){s.resolve(t)},function(){return N(t+1,e,n,a,r,i).then(s.resolve,s.reject)})}else if(r)s.resolve(r);else{var l=C(e,n,r);V&&l?s.resolve(l):s.reject(j(e))}return s.promise},p=function(t,e,n,a,r){var i;if(t<z.length){var s=z[t];(i=g(s,e,n,a,r))||""===i||(i=p(t+1,e,n,a))}return i},h=function(t,e,n,a,r,i){var s,o,l,u,c,f=m.defer(),g=r?q[r]:q,p=n?L[n]:b;if(g&&Object.prototype.hasOwnProperty.call(g,t)&&null!==g[t]){var h=g[t];if("@:"===h.substr(0,2))w(h.substr(2),e,n,a,r,i).then(f.resolve,f.reject);else{var d=p.interpolate(h,e,"service",i,t);d=O(t,h,d,e,r),f.resolve(d)}}else{var v;V&&!S&&(v=C(t,e,a)),r&&z&&z.length?(s=t,o=e,l=p,u=a,c=i,N(0<y?y:$,s,o,l,u,c)).then(function(t){f.resolve(t)},function(t){f.reject(j(t))}):V&&!S&&v?a?f.resolve(a):f.resolve(v):a?f.resolve(a):f.reject(j(t))}return f.promise},d=function(t,e,n,a,r){var i,s=a?q[a]:q,o=b;if(L&&Object.prototype.hasOwnProperty.call(L,n)&&(o=L[n]),s&&Object.prototype.hasOwnProperty.call(s,t)&&null!==s[t]){var l=s[t];i="@:"===l.substr(0,2)?d(l.substr(2),e,n,a,r):(i=o.interpolate(l,e,"filter",r,t),O(t,l,i,e,a,r))}else{var u;V&&!S&&(u=C(t,e,r)),i=a&&z&&z.length?p(($=0)<y?y:$,t,e,o,r):V&&!S&&u?u:j(t)}return i},O=function(t,e,n,a,r,i){var s=G;return s&&("string"==typeof s&&(s=o.get(s)),s)?s(t,e,n,a,r,i):n},v=function(t){q[t]||!D||f[t]||(f[t]=u(t).then(function(t){return ut(t.key,t.table),t}))};w.preferredLanguage=function(t){return t&&ft(t),T},w.cloakClassName=function(){return Q},w.allowNamespaces=function(){return Z},w.nestedObjectDelimeter=function(){return tt},w.fallbackLanguage=function(t){if(null!=t){if(gt(t),D&&z&&z.length)for(var e=0,n=z.length;e<n;e++)f[z[e]]||(f[z[e]]=u(z[e]));w.use(w.use())}return x?z[0]:z},w.useFallbackLanguage=function(t){if(null!=t)if(t){var e=st(z,t);-1<e&&(y=e)}else y=0},w.proposedLanguage=function(){return I},w.storage=function(){return i},w.negotiateLocale=lt,w.use=function(e){if(!e)return F;var n=m.defer();n.promise.then(null,angular.noop),s.$emit("$translateChangeStart",{language:e});var t=lt(e);return 0<Y.length&&!t?m.reject(e):(t&&(e=t),I=e,!X&&q[e]||!D||f[e]?f[e]?f[e].then(function(t){return I===t.key&&l(t.key),n.resolve(t.key),t},function(t){return!F&&z&&0<z.length&&z[0]!==t?w.use(z[0]).then(n.resolve,n.reject):n.reject(t)}):(n.resolve(e),l(e)):(f[e]=u(e).then(function(t){return ut(t.key,t.table),n.resolve(t.key),I===e&&l(t.key),t},function(t){return s.$emit("$translateChangeError",{language:t}),n.reject(t),s.$emit("$translateChangeEnd",{language:t}),m.reject(t)}),f[e].finally(function(){var t;I===(t=e)&&(I=void 0),f[t]=void 0}).catch(angular.noop)),n.promise)},w.resolveClientLocale=function(){return it()},w.storageKey=function(){return pt()},w.isPostCompilingEnabled=function(){return W},w.isForceAsyncReloadEnabled=function(){return X},w.isKeepContent=function(){return nt},w.refresh=function(t){if(!D)throw new Error("Couldn't refresh translation table, no loader registered!");s.$emit("$translateRefreshStart",{language:t});var e=m.defer(),n={};function a(e){var t=u(e);return(f[e]=t).then(function(t){q[e]={},ut(e,t.table),n[e]=!0},angular.noop),t}if(e.promise.then(function(){for(var t in q)q.hasOwnProperty(t)&&(t in n||delete q[t]);F&&l(F)},angular.noop).finally(function(){s.$emit("$translateRefreshEnd",{language:t})}),t)q[t]?a(t).then(e.resolve,e.reject):e.reject();else{var r=z&&z.slice()||[];F&&-1===r.indexOf(F)&&r.push(F),m.all(r.map(a)).then(e.resolve,e.reject)}return e.promise},w.instant=function(t,e,n,a,r){var i=a&&a!==F?lt(a)||a:F;if(null===t||angular.isUndefined(t))return t;if(a&&v(a),angular.isArray(t)){for(var s={},o=0,l=t.length;o<l;o++)s[t[o]]=w.instant(t[o],e,n,a,r);return s}if(angular.isString(t)&&t.length<1)return t;t&&(t=ot.apply(t));var u,c,f=[];T&&f.push(T),i&&f.push(i),z&&z.length&&(f=f.concat(z));for(var g=0,p=f.length;g<p;g++){var h=f[g];if(q[h]&&void 0!==q[h][t]&&(u=d(t,e,n,i,r)),void 0!==u)break}u||""===u||(U||M?u=j(t):(u=b.interpolate(t,e,"filter",r),V&&!S&&(c=C(t,e,r)),V&&!S&&c&&(u=c)));return u},w.versionInfo=function(){return"2.19.1"},w.loaderCache=function(){return H},w.directivePriority=function(){return at},w.statefulFilter=function(){return rt},w.isReady=function(){return et};var n=m.defer();n.promise.then(function(){et=!0}),w.onReady=function(t){var e=m.defer();return angular.isFunction(t)&&e.promise.then(t),et?e.resolve():n.promise.then(e.resolve),e.promise},w.getAvailableLanguageKeys=function(){return 0<Y.length?Y:null},w.getTranslationTable=function(t){return(t=t||w.use())&&q[t]?angular.copy(q[t]):null};var a=s.$on("$translateReady",function(){n.resolve(),a(),a=null}),r=s.$on("$translateChangeEnd",function(){n.resolve(),r(),r=null});if(D){if(angular.equals(q,{})&&w.use()&&w.use(w.use()),z&&z.length)for(var E=function(t){return ut(t.key,t.table),s.$emit("$translateChangeEnd",{language:t.key}),t},k=0,P=z.length;k<P;k++){var A=z[k];!X&&q[A]||(f[A]=u(A).then(E))}}else s.$emit("$translateReady",{language:w.use()});return w}]}function n(s,o){"use strict";var t={};return t.setLocale=function(t){t},t.getInterpolationIdentifier=function(){return"default"},t.useSanitizeValueStrategy=function(t){return o.useStrategy(t),this},t.interpolate=function(t,e,n,a,r){var i;return e=e||{},e=o.sanitize(e,"params",a,n),i=angular.isNumber(t)?""+t:angular.isString(t)?(i=s(t)(e),o.sanitize(i,"text",a,n)):""},t}function a(S,L,w,j,C){"use strict";var N=function(t){return angular.isString(t)?t.toLowerCase():t};return{restrict:"AE",scope:!0,priority:S.directivePriority(),compile:function(t,h){var d=h.translateValues?h.translateValues:void 0,v=h.translateInterpolation?h.translateInterpolation:void 0,m=h.translateSanitizeStrategy?h.translateSanitizeStrategy:void 0,$=t[0].outerHTML.match(/translate-value-+/i),y="^(.*)("+L.startSymbol()+".*"+L.endSymbol()+")(.*)",b="^(.*)"+L.startSymbol()+"(.*)"+L.endSymbol()+"(.*)";return function(r,l,u){r.interpolateParams={},r.preText="",r.postText="",r.translateNamespace=function t(e){if(e.translateNamespace)return e.translateNamespace;if(e.$parent)return t(e.$parent)}(r);var i={},s=function(t){if(angular.isFunction(s._unwatchOld)&&(s._unwatchOld(),s._unwatchOld=void 0),angular.equals(t,"")||!angular.isDefined(t)){var e=function(){return this.toString().replace(/^\s+|\s+$/g,"")}.apply(l.text()).replace(/\n/g," "),n=e.match(y);if(angular.isArray(n)){r.preText=n[1],r.postText=n[3],i.translate=L(n[2])(r.$parent);var a=e.match(b);angular.isArray(a)&&a[2]&&a[2].length&&(s._unwatchOld=r.$watch(a[2],function(t){i.translate=t,c()}))}else i.translate=e||void 0}else i.translate=t;c()},t=function(e){u.$observe(e,function(t){i[e]=t,c()})};!function(t,e,n){if(e.translateValues&&angular.extend(t,j(e.translateValues)(r.$parent)),$)for(var a in n)Object.prototype.hasOwnProperty.call(e,a)&&"translateValue"===a.substr(0,14)&&"translateValues"!==a&&(t[N(a.substr(14,1))+a.substr(15)]=n[a])}(r.interpolateParams,u,h);var e=!0;for(var n in u.$observe("translate",function(t){void 0===t?s(""):""===t&&e||(i.translate=t,c()),e=!1}),u)u.hasOwnProperty(n)&&"translateAttr"===n.substr(0,13)&&13<n.length&&t(n);if(u.$observe("translateDefault",function(t){r.defaultText=t,c()}),m&&u.$observe("translateSanitizeStrategy",function(t){r.sanitizeStrategy=j(t)(r.$parent),c()}),d&&u.$observe("translateValues",function(t){t&&r.$parent.$watch(function(){angular.extend(r.interpolateParams,j(t)(r.$parent))})}),$){var a=function(n){u.$observe(n,function(t){var e=N(n.substr(14,1))+n.substr(15);r.interpolateParams[e]=t})};for(var o in u)Object.prototype.hasOwnProperty.call(u,o)&&"translateValue"===o.substr(0,14)&&"translateValues"!==o&&a(o)}var c=function(){for(var t in i)i.hasOwnProperty(t)&&void 0!==i[t]&&f(t,i[t],r,r.interpolateParams,r.defaultText,r.translateNamespace)},f=function(e,t,n,a,r,i){t?(i&&"."===t.charAt(0)&&(t=i+t),S(t,a,v,r,n.translateLanguage,n.sanitizeStrategy).then(function(t){g(t,n,!0,e)},function(t){g(t,n,!1,e)})):g(t,n,!1,e)},g=function(t,e,n,a){if(n||void 0!==e.defaultText&&(t=e.defaultText),"translate"===a){(n||!n&&!S.isKeepContent()&&void 0===u.translateKeepContent)&&l.empty().append(e.preText+t+e.postText);var r=S.isPostCompilingEnabled(),i=void 0!==h.translateCompile,s=i&&"false"!==h.translateCompile;(r&&!i||s)&&w(l.contents())(e)}else{var o=u.$attr[a];"data-"===o.substr(0,5)&&(o=o.substr(5)),o=o.substr(15),l.attr(o,t)}};(d||$||u.translateDefault)&&r.$watch("interpolateParams",c,!0),r.$on("translateLanguageChanged",c);var p=C.$on("$translateChangeSuccess",c);l.text().length?u.translate?s(u.translate):s(""):u.translate&&s(u.translate),c(),r.$on("$destroy",p)}}}}function r(u,c){"use strict";return{restrict:"A",priority:u.directivePriority(),link:function(n,a,r){var i,s,o,l={},t=function(){angular.forEach(i,function(t,e){t&&(l[e]=!0,n.translateNamespace&&"."===t.charAt(0)&&(t=n.translateNamespace+t),u(t,s,r.translateInterpolation,void 0,n.translateLanguage,o).then(function(t){a.attr(e,t)},function(t){a.attr(e,t)}))}),angular.forEach(l,function(t,e){i[e]||(a.removeAttr(e),delete l[e])})};f(n,r.translateAttr,function(t){i=t},t),f(n,r.translateValues,function(t){s=t},t),f(n,r.translateSanitizeStrategy,function(t){o=t},t),r.translateValues&&n.$watch(r.translateValues,t,!0),n.$on("translateLanguageChanged",t);var e=c.$on("$translateChangeSuccess",t);t(),n.$on("$destroy",e)}}}function f(t,e,n,a){"use strict";e&&("::"===e.substr(0,2)?e=e.substr(2):t.$watch(e,function(t){n(t),a()},!0),n(t.$eval(e)))}function i(s,o){"use strict";return{compile:function(t){var i=function(t){t.addClass(s.cloakClassName())};return i(t),function(t,e,n){var a=function(t){t.removeClass(s.cloakClassName())}.bind(this,e),r=i.bind(this,e);n.translateCloak&&n.translateCloak.length?(n.$observe("translateCloak",function(t){s(t).then(a,r)}),o.$on("$translateChangeSuccess",function(){s(n.translateCloak).then(a,r)})):s.onReady(a)}}}}function s(){"use strict";return{restrict:"A",scope:!0,compile:function(){return{pre:function(t,e,n){t.translateNamespace=function t(e){if(e.translateNamespace)return e.translateNamespace;if(e.$parent)return t(e.$parent)}(t),t.translateNamespace&&"."===n.translateNamespace.charAt(0)?t.translateNamespace+=n.translateNamespace:t.translateNamespace=n.translateNamespace}}}}}function o(){"use strict";return{restrict:"A",scope:!0,compile:function(){return function(e,t,n){n.$observe("translateLanguage",function(t){e.translateLanguage=t}),e.$watch("translateLanguage",function(){e.$broadcast("translateLanguageChanged")})}}}}function l(i,s){"use strict";var t=function(t,e,n,a){if(!angular.isObject(e)){var r=this||{__SCOPE_IS_NOT_AVAILABLE:"More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"};e=i(e)(r)}return s.instant(t,e,n,a)};return s.statefulFilter()&&(t.$stateful=!0),t}function u(t){"use strict";return t("translations")}return t.$inject=["$translate"],e.$inject=["$STORAGE_KEY","$windowProvider","$translateSanitizationProvider","pascalprechtTranslateOverrider"],n.$inject=["$interpolate","$translateSanitization"],a.$inject=["$translate","$interpolate","$compile","$parse","$rootScope"],r.$inject=["$translate","$rootScope"],i.$inject=["$translate","$rootScope"],l.$inject=["$parse","$translate"],u.$inject=["$cacheFactory"],angular.module("pascalprecht.translate",["ng"]).run(t),t.displayName="runTranslate",angular.module("pascalprecht.translate").provider("$translateSanitization",function(){"use strict";var n,a,g,p=null,h=!1,d=!1;(g={sanitize:function(t,e){return"text"===e&&(t=i(t)),t},escape:function(t,e){return"text"===e&&(t=r(t)),t},sanitizeParameters:function(t,e){return"params"===e&&(t=o(t,i)),t},escapeParameters:function(t,e){return"params"===e&&(t=o(t,r)),t},sce:function(t,e,n){return"text"===e?t=s(t):"params"===e&&"filter"!==n&&(t=o(t,r)),t},sceParameters:function(t,e){return"params"===e&&(t=o(t,s)),t}}).escaped=g.escapeParameters,this.addStrategy=function(t,e){return g[t]=e,this},this.removeStrategy=function(t){return delete g[t],this},this.useStrategy=function(t){return h=!0,p=t,this},this.$get=["$injector","$log",function(u,c){var e,f={};return u.has("$sanitize")&&(n=u.get("$sanitize")),u.has("$sce")&&(a=u.get("$sce")),{useStrategy:(e=this,function(t){e.useStrategy(t)}),sanitize:function(t,e,n,a){if(p||h||d||(c.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."),d=!0),n||null===n||(n=p),!n)return t;a||(a="service");var r,i,s,o,l=angular.isArray(n)?n:[n];return r=t,i=e,s=a,o=l,angular.forEach(o,function(e){if(angular.isFunction(e))r=e(r,i,s);else if(angular.isFunction(g[e]))r=g[e](r,i,s);else{if(!angular.isString(g[e]))throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'");if(!f[g[e]])try{f[g[e]]=u.get(g[e])}catch(t){throw f[g[e]]=function(){},new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '"+e+"'")}r=f[g[e]](r,i,s)}}),r}}}];var r=function(t){var e=angular.element("<div></div>");return e.text(t),e.html()},i=function(t){if(!n)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");return n(t)},s=function(t){if(!a)throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");return a.trustAsHtml(t)},o=function(t,n,a){if(angular.isDate(t))return t;if(angular.isObject(t)){var r=angular.isArray(t)?[]:{};if(a){if(-1<a.indexOf(t))throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object")}else a=[];return a.push(t),angular.forEach(t,function(t,e){angular.isFunction(t)||(r[e]=o(t,n,a))}),a.splice(-1,1),r}return angular.isNumber(t)?t:!0===t||!1===t?t:angular.isUndefined(t)||null===t?t:n(t)}}),angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider",{}).provider("$translate",e),e.displayName="displayName",angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation",n),n.displayName="$translateDefaultInterpolation",angular.module("pascalprecht.translate").constant("$STORAGE_KEY","NG_TRANSLATE_LANG_KEY"),angular.module("pascalprecht.translate").directive("translate",a),a.displayName="translateDirective",angular.module("pascalprecht.translate").directive("translateAttr",r),r.displayName="translateAttrDirective",angular.module("pascalprecht.translate").directive("translateCloak",i),i.displayName="translateCloakDirective",angular.module("pascalprecht.translate").directive("translateNamespace",s),s.displayName="translateNamespaceDirective",angular.module("pascalprecht.translate").directive("translateLanguage",o),o.displayName="translateLanguageDirective",angular.module("pascalprecht.translate").filter("translate",l),l.displayName="translateFilterFactory",angular.module("pascalprecht.translate").factory("$translationCache",u),u.displayName="$translationCache","pascalprecht.translate"});
/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateLocalStorageFactory.$inject = ['$window', '$translateCookieStorage'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateLocalStorage
 * @requires $window
 * @requires $translateCookieStorage
 *
 * @description
 * Abstraction layer for localStorage. This service is used when telling angular-translate
 * to use localStorage as storage.
 *
 */
.factory('$translateLocalStorage', $translateLocalStorageFactory);

function $translateLocalStorageFactory($window, $translateCookieStorage) {

  'use strict';

  // Setup adapter
  var localStorageAdapter = (function(){
    var langKey;
    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#get
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Returns an item from localStorage by given name.
       *
       * @param {string} name Item name
       * @return {string} Value of item name
       */
      get: function (name) {
        if(!langKey) {
          langKey = $window.localStorage.getItem(name);
        }

        return langKey;
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#set
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @deprecated use #put
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      set: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      },
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateLocalStorage#put
       * @methodOf pascalprecht.translate.$translateLocalStorage
       *
       * @description
       * Sets an item in localStorage by given name.
       *
       * @param {string} name Item name
       * @param {string} value Item value
       */
      put: function (name, value) {
        langKey=value;
        $window.localStorage.setItem(name, value);
      }
    };
  }());

  var hasLocalStorageSupport = 'localStorage' in $window;
  if (hasLocalStorageSupport) {
    var testKey = 'pascalprecht.translate.storageTest';
    try {
      // this check have to be wrapped within a try/catch because on
      // a SecurityError: Dom Exception 18 on iOS
      if ($window.localStorage !== null) {
        $window.localStorage.setItem(testKey, 'foo');
        $window.localStorage.removeItem(testKey);
        hasLocalStorageSupport = true;
      } else {
        hasLocalStorageSupport = false;
      }
    } catch (e){
      hasLocalStorageSupport = false;
    }
  }
  var $translateLocalStorage = hasLocalStorageSupport ? localStorageAdapter : $translateCookieStorage;
  return $translateLocalStorage;
}

$translateLocalStorageFactory.displayName = '$translateLocalStorageFactory';
return 'pascalprecht.translate';

}));

/*!
 * angular-translate - v2.19.0 - 2021-09-02
 * 
 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateCookieStorageFactory.$inject = ['$injector'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateCookieStorage
 * @requires $cookieStore
 *
 * @description
 * Abstraction layer for cookieStore. This service is used when telling angular-translate
 * to use cookieStore as storage.
 *
 */
  .factory('$translateCookieStorage', $translateCookieStorageFactory);

function $translateCookieStorageFactory($injector) {

  'use strict';

  // Since AngularJS 1.4, $cookieStore is deprecated
  var delegate;
  if (angular.version.major === 1 && angular.version.minor >= 4) {
    var $cookies = $injector.get('$cookies');
    delegate = {
      get : function (key) {
        return $cookies.get(key);
      },
      put : function (key, value) {
        $cookies.put(key, value, { samesite: 'lax' });
      }
    };
  } else {
    var $cookieStore = $injector.get('$cookieStore');
    delegate = {
      get : function (key) {
        return $cookieStore.get(key);
      },
      put : function (key, value) {
        $cookieStore.put(key, value);
      }
    };
  }

  var $translateCookieStorage = {

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#get
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Returns an item from cookieStorage by given name.
     *
     * @param {string} name Item name
     * @return {string} Value of item name
     */
    get : function (name) {
      return delegate.get(name);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#set
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @deprecated use #put
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    set : function (name, value) {
      delegate.put(name, value);
    },

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translateCookieStorage#put
     * @methodOf pascalprecht.translate.$translateCookieStorage
     *
     * @description
     * Sets an item in cookieStorage by given name.
     *
     * @param {string} name Item name
     * @param {string} value Item value
     */
    put : function (name, value) {
      delegate.put(name, value);
    }
  };

  return $translateCookieStorage;
}

$translateCookieStorageFactory.displayName = '$translateCookieStorage';
return 'pascalprecht.translate';

}));

/*!
 * angular-translate - v2.18.2 - 2020-01-04
 * 
 * Copyright (c) 2020 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));

angular.module('hub').service('EmergencyMsgSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSendMsg = function(){
    httpReq = $http.get($rootScope.apiHost + "emergencyMsg/messages");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSentMsg = function(){
    httpReq = $http.get($rootScope.apiHost + "emergencyMsg/messages/sent");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSettings = function(){
    httpReq = $http.get($rootScope.apiHost + "emergencyMsg/settings");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAcknowledge = function(id, type){
    if(type=="download"){
      httpReq = $http.get($rootScope.apiHost + "emergencyMsg/messages/acknowledgements/" + id + "?isExport=1");
    } else {
      httpReq = $http.get($rootScope.apiHost + "emergencyMsg/messages/acknowledgements/" + id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSendMessage = function(sendObj){
    httpReq = $http.post($rootScope.apiHost + "emergencyMsg/messages", sendObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateSentMsg = function(sentObj){
    httpReq = $http.put($rootScope.apiHost + "emergencyMsg/messages/sent", sentObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateSettings = function(settingObj){
    httpReq = $http.put($rootScope.apiHost + "emergencyMsg/settings", settingObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savePredefinedMsg = function(msgObj){
    httpReq = $http.post($rootScope.apiHost + "emergencyMsg/settings/predefined", msgObj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Delete*/
  this.deleteSentMsg = function(sentId, type){
    if(type == "msgCancel"){
      httpReq = $http.delete($rootScope.apiHost + "emergencyMsg/messages/sent/" + sentId + "?emMsgIsNotActive=true");
    } else {
      httpReq = $http.delete($rootScope.apiHost + "emergencyMsg/messages/sent/" + sentId);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deletePredefinedMsg = function(settingId){
    httpReq = $http.delete($rootScope.apiHost + "emergencyMsg/settings/predefined/" + settingId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    } else{
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('EmergencyMsgController', EmergencyMsgController);

  /** @ngInject */
  function EmergencyMsgController($log, $rootScope, $scope, $state, ngDialog, DevicesSrv, FileModelUploadSrv, EmergencyMsgSrv, CommonSrv){
    $rootScope.selectedMenu = 7;
    // $scope.uiVersionFx();

    $scope.colorPicker = {hb:false, ht:false, bb:false, mb:false, mt:false};
    $scope.selectedTab = $state.current.name;
    $scope.predefinedMsg = {message:""};
    $scope.isAcknoledgementOpen = false;
    $scope.emergencyMsgLoading = true;
    $scope.saveProcessingMsg = false;
    $scope.isDeviceAvailable = false;
    $scope.fileModelLoading = false;
    $scope.saveProcessing = false;
    $scope.deletableMsg = [];
    $scope.emergencyMsg = {};
    $scope.acknowledge = [];
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.gAList = [];
    $rootScope.gSList = [];
    $rootScope.tAList = [];
    $rootScope.tSList = [];
    $scope.encId = "";
    $scope.decId = "";

    $scope.updateDefineVariable = function(){
      $scope.haveMoreData = false;
      $scope.haveMoreSearchData = false;
      $scope.visibleData = [];
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.searchScroll = false;
    }

    $scope.loadSelectedTab = function(){
      $scope.updateDefineVariable();
      $scope.curDevices = {availableDevices:"", assignedDevices:""};
      $scope.curGroups = {availableGroups:"", assignedGroups:""};
      $scope.curTags = {availableTags:"", assignedTags:""};
      if($scope.auth.upreferences.sdtf){
        $scope.flag = {d:false,g:true,t:true};
      } else{
        $scope.flag = {d:true,g:true,t:true};
      }
      $scope.emergencyMsgLoading = true;
      $scope.deletableMsg = [];
      $scope.flagDGT = true;
      if($scope.selectedTab === "hub.emergencyMsg.em"){
        $scope.isDeviceAvailable = false;
        EmergencyMsgSrv.getSendMsg().then(
          function(data){
            $scope.emergencyMsg = {info:{predefinedMsg:"", audioType:"n", durationType:"p", durationP:"120", durationC:"", whenDisplay:"i", display:{date:"", time:""}, deviceType:"a", devices:{assignedDevices:[], assignedGroups:[], assignedTags:[]}}};
            $scope.emergencyMsg.predefinedMsg = data.msg;
            if(data.devices > 0){
              $scope.isDeviceAvailable = true;
            }
            $scope.emergencyMsgLoading = false;
            $scope.curEmergencyMsg = angular.copy($scope.emergencyMsg);
          },
          function(err){
            $log.error(err);
            $scope.emergencyMsgLoading = false;
          }
        );
      } else if($scope.selectedTab === "hub.emergencyMsg.sm"){
        $scope.loadingMain = true;
        EmergencyMsgSrv.getSentMsg().then(
          function(data){
            $scope.emergencyMsg = data;
            angular.forEach($scope.emergencyMsg, function(msg){
              if(msg.duration == 86400 || msg.duration == 172800 || msg.duration == 259200){
                msg.time = $scope.secondsToHMS(msg.duration);
              } else {
                msg.time = moment.utc(msg.duration*1000).format('HH:mm:ss');
              }
              msg.isChecked = false;
            });
            $scope.emergencyMsgLoading = false;
            $scope.loadingMain = false;
          },
          function(err){
            $log.error(err);
            $scope.loadingMain = false;
            $scope.emergencyMsgLoading = false;
          }
        );
      } else if($scope.selectedTab === "hub.emergencyMsg.es"){
        EmergencyMsgSrv.getSettings().then(
          function(data){
            $scope.emergencyMsg = data;
            $scope.emergencyMsgLoading = false;
            $scope.tim = $scope.emergencyMsg.info.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.emergencyMsg.info.bucket;
            if($scope.emergencyMsg.info.mbucket && $scope.emergencyMsg.info.mbucket != ""){
              $scope.detailBucket = $scope.emergencyMsg.info.mbucket;
            }
          },
          function(err){
            $log.error(err);
            $scope.emergencyMsgLoading = false;
          }
        );
      }
      $scope.isAcknoledgementOpen = false;
      $scope.acknowledge.list = [];
    }
    $scope.loadSelectedTab();

    // Function to convert seconds to HH:mm:ss format
    $scope.secondsToHMS = function(seconds){
      // Calculate hours, minutes, and remaining seconds
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var remainingSeconds = seconds % 60;

      // Format the result
      var formattedTime = $scope.pad(hours) + ":" + $scope.pad(minutes) + ":" + $scope.pad(remainingSeconds);
      return formattedTime;
    }

    // Function to add leading zeros to numbers less than 10
    $scope.pad = function(num){
      return (num < 10 ? "0" : "") + num;
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.saveProcessing = false;
      $scope.hasErrMsg = false;
      $scope.hasErr = false;
      $scope.emergencyMsg = {};
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
      $scope.acknowledgeCloseFx();
      $scope.resetSelDGTList();
    });

    $scope.msgCheckAll = function(event){
      $scope.deletableMsg = [];
      angular.forEach($scope.emergencyMsg, function(msg){
        msg.isChecked = event.target.checked;
        if(event.target.checked){
          $scope.deletableMsg.push(msg.id);
        }
      });
    }

    $scope.msgCheckFx = function(){
      $scope.deletableMsg = [];
      angular.forEach($scope.emergencyMsg, function(msg){
        if(msg.isChecked){
          $scope.deletableMsg.push(msg.id);
        }
      });
    }

    if($scope.auth.upreferences.sdtf){
      $scope.flag = {d:false,g:true,t:true};
    } else{
      $scope.flag = {d:true,g:true,t:true};
    }
    $scope.deviceAndGroupsFx = function(type, caller){
      // $scope.haveMoreData = false;
      $scope.callListAPI = false;
      if($scope.flag.d && type == 'd'){
        $scope.callListAPI = true;
        $scope.scrollObjDyn = {caller: caller, offset: 0, id: 0, sortType: "l", sortVal: "asc"}
        DevicesSrv.getScrollListData($scope.scrollObjDyn).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn = true;
            } else{
              $scope.haveMoreDataDyn = false;
            }
            $scope.totalDeviceCount = data.tc;
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            $scope.scrollDataListDyn = data.d;
            $scope.allScrollDataListDyn = [];
            $scope.allScrollDataListDyn =  angular.copy($scope.scrollDataListDyn);
            $scope.flag.d = false;
          },
          function(err){
            $scope.flag.d = false;
            $log.error(err);
          }
        );
        // CommonSrv.getAvailDGT('d', "em").then(
        //   function(data){
        //     $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
        //     $scope.addTypeKey(data);
        //     $scope.emergencyMsg.devices = data.devices;
        //     $scope.flag.d = false;
        //   },
        //   function(err){
        //     $scope.flag.d = true;
        //     $log.error(err);
        //   }
        // );
      } else if($scope.flag.g && type == 'g'){
        CommonSrv.getAvailDGT('g', "em").then(
          function(data){
            $scope.emergencyMsg.groups = data.groups;
            $scope.flag.g = false;
          },
          function(err){
            $scope.flag.g = true;
            $log.error(err);
          }
        );
      } else if($scope.flag.t && type == 't'){
        CommonSrv.getAvailDGT('t', "em").then(
          function(data){
            $scope.emergencyMsg.tags = data.deviceTags;
            $scope.flag.t = false;
          },
          function(err){
            $scope.flag.t = true;
            $log.error(err);
          }
        );
      }
    }

    $scope.resetMessageFx = function(caller){
      if(caller == "sendMsg"){
        if($scope.auth.upreferences.sdtf){
          $scope.flag = {d:false,g:true,t:true};
        } else{
          $scope.flag = {d:true,g:true,t:true};
        }
        $scope.emergencyMsg = angular.copy($scope.curEmergencyMsg);
        $scope.flagDGT = true;
        $scope.deviceAndGroupsFx();
      }
    }

    $scope.sendMessageFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curMsg = {};
      $scope.curMsg.info = $scope.emergencyMsg.info;
      if(($scope.curMsg.info.customMsg == undefined || $scope.curMsg.info.customMsg == "") && ($scope.curMsg.info.predefinedMsg == null || $scope.curMsg.info.predefinedMsg == "") ){
        $scope.hasErr = true;
        $scope.errType = "msg";
        // console.warn("$scope.emergencyMsg.predefinedMsg.length ", $scope.emergencyMsg.predefinedMsg.length);
        if($scope.emergencyMsg.predefinedMsg.length){
          $("#predefinedMsg").focus();
        } else{
          $("#customMsg").focus();
        }
      } else if($scope.curMsg.info.durationType == 'c' && ($scope.curMsg.info.durationC == "" || $scope.curMsg.info.durationC == null)){
        $scope.hasErr = true;
        $scope.errType = "duration";
        $("#durationC").focus();
      } else if($scope.curMsg.info.whenDisplay == 'c' && $scope.curMsg.info.display.date == ""){
        $scope.hasErr = true;
        $scope.errType = "display";
        $("#durationC").focus();
      } else if($scope.curMsg.info.whenDisplay == 'c' && $scope.curMsg.info.display.time == ""){
        $scope.hasErr = true;
        $scope.errType = "display";
      } else if($scope.curMsg.info.deviceType == 'c' && !($scope.curMsg.info.devices.assignedDevices.length > 0 || $scope.curMsg.info.devices.assignedGroups.length > 0 || $scope.curMsg.info.devices.assignedTags.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        $scope.saveProcessing = true;
        $scope.copyCurMsg = angular.copy($scope.curMsg);
        if($scope.copyCurMsg.info.whenDisplay == 'c'){
          $scope.copyCurMsg.info.display.date.startDate = moment($scope.copyCurMsg.info.display.date.startDate).format("L");
          $scope.copyCurMsg.info.display.date.endDate = moment($scope.copyCurMsg.info.display.date.endDate).format("L");
          $scope.copyCurMsg.info.display.time = moment($scope.copyCurMsg.info.display.time).format("HH:mm Z");
        }
        EmergencyMsgSrv.saveSendMessage($scope.copyCurMsg).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 14011){
              $scope.hasErr = true;
              $scope.errType = "gDevice";
            } else if(data.code != 14011){
              $scope.copyCurMsg = data
              $scope.emergencyMsgLoading = true;
              $scope.loadSelectedTab();
            }
          },
          function(err){
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.defaultSettingFx = function(){
      $scope.hasErr = false;
      $scope.emergencyMsg.info = {timthumb:$scope.emergencyMsg.info.timthumb, titleImg:$scope.emergencyMsg.info.titleImg};
      $scope.emergencyMsg.settings = {hText:"EMERGENCY BROADCAST", hFont:$scope.fontFamilySelected, hBgColor:"#ffffff", hTextColor:"#cc0000", bBgColor:"#cc0000", mBgColor:"#ffff00", mTextColor:"#000000", mFont:$scope.fontFamilySelected};
      $scope.emergencyMsg.ctype = {hBgColor:"monochrome", hTextColor:"default", bBgColor:"default", mBgColor:"basic", mTextColor:"monochrome"};
    }

    $scope.saveSettingsFx = function(){
      $scope.hasErr = false;
      $scope.curMsg = {};
      $scope.curMsg.settings = $scope.emergencyMsg.settings;
      $scope.curMsg.ctype = $scope.emergencyMsg.ctype;
      if($scope.emergencyMsg.settings.hText == ""){
        $scope.hasErr = true;
        $("#hText").focus();
      } else{
        $scope.saveProcessing = true;
        EmergencyMsgSrv.updateSettings($scope.curMsg).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.acknowledgeFx = function(id){
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.scrollDataList = [];
      $scope.haveMoreSearchData = false;
      $scope.searchScroll = false;
      $scope.scrollObj = {caller: 'emAck', offset: 0, id: id}
      $scope.isAcknoledgementOpen = true;
      $scope.acknowledgeLoading = true;
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          $scope.acknowledge.id = id;
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.acknowledgeLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );

      // $scope.isAcknoledgementOpen = true;
      // $scope.acknowledgeLoading = true;
      // $scope.acknowledge.list = [];
      // EmergencyMsgSrv.getAcknowledge(id).then(
      //   function(data){
      //     $scope.addStatusKey(data, $scope.auth.upreferences.dot);
      //     $scope.acknowledge.id = id;
      //     $scope.acknowledge.list = data;
      //     $scope.acknowledgeLoading = false;
      //   },
      //   function(err){
      //     $log.error(err);
      //     $scope.saveProcessing = false;
      //   }
      // );
    }
    $scope.acknowledgeCloseFx = function(){
      $scope.isAcknoledgementOpen = false;
      $scope.acknowledge.list = [];
    }

    $scope.savePredefinedMsgFx = function(){
      $scope.hasErrMsg = false;
      if($scope.predefinedMsg.message == ""){
        $scope.hasErrMsg = true;
        $("#message").focus();
      } else{
        $scope.saveProcessingMsg = true;
        EmergencyMsgSrv.savePredefinedMsg($scope.predefinedMsg).then(
          function(data){
            $scope.predefinedMsg.message = "";
            $scope.saveProcessingMsg = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.saveProcessingMsg = false;
          }
        );
      }
    }
    $scope.resetMsgFx = function(){
      $scope.hasErrMsg = false;
      $scope.predefinedMsg.message = "";
    }
    $rootScope.fileModelUploadFx = function(data, caller){
      $scope.fileModelLoading = true;
      FileModelUploadSrv.uploadFile("emergencyMsg/settings/images", data).then(
        function(data){
          $scope.fileModelLoading = false;
          if(caller == "delete"){
            ngDialog.close();
            $scope.emergencyMsg.info.titleImg = "";
          } else{
            $scope.loadSelectedTab();
          }
          $rootScope.toastNotificationFx("info", data);
        },
        function(err){
          $rootScope.toastNotificationFx("danger", {"code":5000});
          $log.error(err);
        }
      );
    }

    /*ngDialog*/
    $scope.sentMsgOpen = function(id, msg){
      $scope.smProcessing = false;
      $scope.sentErr = false;
      $scope.sentObj = {
        message:msg,
        id:id
      };
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"em.body.11" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"em.label.2" | translate}} <span class="text-muted text-sm">({{"em.label.2.1" | translate}})</span></label>\
                <textarea class="form-control" ng-model="sentObj.message" maxlength="500" rows="8"></textarea>\
                <span class="text-muted text-sm">[ {{500 - sentObj.message.length}} ]</span>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="sentMsgFx(deleteObj.id);" ng-disabled="smProcessing"><span class="fa" ng-class="smProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="sentErr" aria-live="polite" role="status">{{"em.msg.10" | translate}}</div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.sentMsgFx = function(){
      if($scope.sentObj.message == ""){
        $scope.sentErr = true;
      } else{
        EmergencyMsgSrv.updateSentMsg($scope.sentObj).then(
          function(data){
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.esProcessing = false;
          }
        );
      }
    }
    $scope.deleteOpen = function(tabName, id){
      if(tabName == "message"){
        $scope.acknowledgeCloseFx();
      }
      $scope.esProcessing = false;
      $scope.deleteObj = {
        tabName:tabName,
        id:id
      };
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="deleteObj.tabName != \'titleImg\'">{{deleteObj.tabName == "message"?"em.msg.13":deleteObj.tabName == "msgCancel"?"em.msg.15":"em.msg.12" | translate}}</span>\
              <span ng-if="deleteObj.tabName == \'titleImg\'">{{"em.msg.11" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx(deleteObj.id);" ng-disabled="esProcessing"><span class="fa fa-repeat fa-spin" ng-if="esProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
      });
    }
    $scope.deleteFx = function(id){
      $scope.esProcessing = true;
      if($scope.deleteObj.tabName == "predefinedMsg"){
        EmergencyMsgSrv.deletePredefinedMsg(id).then(
          function(data){
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $log.error(err);
            $scope.esProcessing = false;
          }
        );
      } else if($scope.deleteObj.tabName === "message" || $scope.deleteObj.tabName === "msgCancel"){
        EmergencyMsgSrv.deleteSentMsg(id, $scope.deleteObj.tabName).then(
          function(data){
            ngDialog.close();
            $scope.loadSelectedTab();
            if($scope.acknowledge.id == id){
              $scope.acknowledgeCloseFx();
            }
          },
          function(err){
            $log.error(err);
            $scope.esProcessing = false;
          }
        );
      } else if($scope.deleteObj.tabName === "titleImg"){
        $scope.fileModelUploadFx("delete", "delete");
      }
    }

    $scope.videoFx = function(){
      ngDialog.open({
        template:'app/emergencyMsg/popup/video.html',
        width:580
      });
    }
    $scope.readMeFx = function(){
      ngDialog.open({
        template:'app/emergencyMsg/popup/info.html',
        width:580
      });
    }

    //select all assign & available devices
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //select all assign & available groups
    $rootScope.selAllGroupFx = function(caller, groupList){
      groupList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curGroups.assignedGroups.length){
          $scope.curGroups = {availableGroups:angular.copy(groupList), assignedGroups:$scope.curGroups.assignedGroups};
          $rootScope.gSList = $scope.curGroups.assignedGroups;
        } else{
          $rootScope.gSList = [];
          $scope.curGroups = {availableGroups:angular.copy(groupList), assignedGroups:[]};
        }
        $rootScope.gAList = $scope.curGroups.availableGroups;
      } else{
        if($scope.curGroups.availableGroups.length){
          $scope.curGroups = {availableGroups:$scope.curGroups.availableGroups, assignedGroups:angular.copy(groupList)};
          $rootScope.gAList = $scope.curGroups.availableGroups;
        } else{
          $rootScope.gAList = [];
          $scope.curGroups = {availableGroups:[], assignedGroups:angular.copy(groupList)};
        }
        $rootScope.gSList = $scope.curGroups.assignedGroups;
      }
    }
    //select/deselect single assign & available groups
    $scope.selGroupFx = function(caller, selectedItems, groupList){
      angular.forEach(groupList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.gAList.push(item);
            } else{
              angular.forEach($rootScope.gAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.gAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.gSList.push(item);
            } else{
              angular.forEach($rootScope.gSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.gSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curGroups = {availableGroups:$rootScope.gAList, assignedGroups:$rootScope.gSList};
        }
      });
    }
    //deselect all assign & available Groups
    $scope.deSelAllGroupFx = function(caller, groupList){
      angular.forEach(groupList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.gAList = [];
        $scope.curGroups.availableGroups = [];
      } else{
        $rootScope.gSList = [];
        $scope.curGroups.assignedGroups = [];
      }
    }

    //select all assign & available tags
    $rootScope.selAllTagFx = function(caller, tagList){
      tagList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curTags.assignedTags.length){
          $scope.curTags = {availableTags:angular.copy(tagList), assignedTags:$scope.curTags.assignedTags};
          $rootScope.tSList = $scope.curTags.assignedTags;
        } else{
          $rootScope.tSList = [];
          $scope.curTags = {availableTags:angular.copy(tagList), assignedTags:[]};
        }
        $rootScope.tAList = $scope.curTags.availableTags;
      } else{
        if($scope.curTags.availableTags.length){
          $scope.curTags = {availableTags:$scope.curTags.availableTags, assignedTags:angular.copy(tagList)};
          $rootScope.tAList = $scope.curTags.availableTags;
        } else{
          $rootScope.tAList = [];
          $scope.curTags = {availableTags:[], assignedTags:angular.copy(tagList)};
        }
        $rootScope.tSList = $scope.curTags.assignedTags;
      }
    }
    //select/deselect single assign & available tags
    $scope.selTagFx = function(caller, selectedItems, tagList){
      angular.forEach(tagList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.tAList.push(item);
            } else{
              angular.forEach($rootScope.tAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.tSList.push(item);
            } else{
              angular.forEach($rootScope.tSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curTags = {availableTags:$rootScope.tAList, assignedTags:$rootScope.tSList};
        }
      });
    }
    //deselect all assign & available tags
    $scope.deSelAllTagFx = function(caller, tagList){
      angular.forEach(tagList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curTags.availableTags = [];
      } else{
        $rootScope.dSList = [];
        $scope.curTags.assignedTags = [];
      }
    }

    $scope.downloadStatusFx = function(){
      EmergencyMsgSrv.getAcknowledge($scope.acknowledge.id, 'download').then(
        function(data){
          $scope.linkOpenFx('m',data.url);
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    //Reset selected devices, groups and tag list
    $scope.resetSelDGTList = function(){
      $rootScope.resetD();
      $rootScope.resetG();
      $rootScope.resetT();
      $rootScope.resetSortingFx();
    }
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }
    $rootScope.resetG = function(caller){
      $rootScope.gAList = [];
      $rootScope.gSList = [];
      if(caller == "add" && $scope.curGroups.assignedGroups.length){
        $scope.curGroups = {availableGroups:[], assignedGroups:$scope.curGroups.assignedGroups};
      } else if(caller == "remove" && $scope.curGroups.availableGroups.length){
        $scope.curGroups = {availableGroups:$scope.curGroups.availableGroups, assignedGroups:[]};
      } else{
        $scope.curGroups = {availableGroups:[], assignedGroups:[]};
      }
    }
    $rootScope.resetT = function(caller){
      $rootScope.tAList = [];
      $rootScope.tSList = [];
      if(caller == "add" && $scope.curTags.assignedTags.length){
        $scope.curTags = {availableTags:[], assignedTags:$scope.curTags.assignedTags};
      } else if(caller == "remove" && $scope.curTags.availableTags.length){
        $scope.curTags = {availableTags:$scope.curTags.availableTags, assignedTags:[]};
      } else{
        $scope.curTags = {availableTags:[], assignedTags:[]};
      }
    }

    // * scroll list data code START 2nd phase pagination
    $scope.updateDefineVariable();

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder" || $scope.copyScrollObj.caller == "ss"){
        $scope.loading = false;
        $scope.refreshObj = {l:true, b:false};
        $scope.marginLoad = true;
        $scope.marRemove = false;
      } else if($scope.copyScrollObj.caller == "ug"){
        $scope.ugDevicePopupLoading = true;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder"|| $scope.copyScrollObj.caller == "ss"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            } else if($scope.copyScrollObj.caller == "ug"){
              $scope.ugDevicePopupLoading = false;
            } else if($scope.copyScrollObj.caller == "dFolder"){
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder" || $scope.copyScrollObj.caller == "ss"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            } else if($scope.copyScrollObj.caller == "ug"){
              $scope.ugDevicePopupLoading = false;
            } else if($scope.copyScrollObj.caller == "dFolder"){
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      });
    });

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: encodeURIComponent(text) });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: encodeURIComponent(text) });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.stIndex = 0;
            $scope.etIndex = 300;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "em"){
        $scope.emergencyMsg.info.devices.assignedDevices = obj.selDevice;
      }
    });
    // * scroll list data code END 2nd phase pagination 
  }
})();
angular.module('hub').service('DashboardSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  var requests = [];

  // Helper to add request to the list
  function addRequest(deferred) {
    requests.push(deferred);
  }

  // Helper to cancel all ongoing requests
  function cancelAllRequests() {
    requests.forEach(function(req){req.resolve()});
    requests = []; // Clear the list after aborting
  }

  // Watch for tab/module change to abort
  $rootScope.$on('abortRequests', function () {
    cancelAllRequests();
  });

  this.getDashboard = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceContent = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/d", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceTypSumm = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/dts", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceListOnMap = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/dlom", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSsodt = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ssodt", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSsdt = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ssdt", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSsdpt = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ssdpt", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDevicePropSumm = function(caller, id){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    if(caller == 'dpts'){
      httpReq = $http.get($rootScope.apiHost + "dashboard/dpts?dpid="+id, destroy);
    }else{
      httpReq = $http.get($rootScope.apiHost + "dashboard/dpts", destroy);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceOtherInfoSumm = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/dps", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceList = function(ot){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/d?lt=100&ot=" + ot, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRecentAddedDevice = function(ot){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/rad?ot=" + ot, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getContentConfirmation = function(ot){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/cc?ot=" + ot, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getContentConfirmationSearch = function(ot, text){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/cc?ot=" + ot +'&searchQ='+encodeURIComponent(text), destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCclDetail = function(id){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/devicelist/" + id, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.getContentConfirmationSumm = function(){
  //   var deferred = $q.defer();
  //   addRequest(deferred);
  //   var destroy = {
  //     timeout: deferred.promise
  //   };

  //   httpReq = $http.get($rootScope.apiHost + "dashboard/ccs");
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }
  this.getContentConfirmationSumm = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ccd", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loadMoreDevices = function(startIndex){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/moreDevices/" + startIndex, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLogsList = function(startIndex){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ral/" + startIndex, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLogsSearchList = function(startIndex, text){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/ral/" + startIndex +'?searchQ='+encodeURIComponent(text), destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loadMoreLogs = function(startIndex){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/moreLogs/" + startIndex, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getKeyType = function(obj,keyType){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/" + keyType , obj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTempterature = function(ot){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/tmpr?ot=" + ot, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTempteratureSumm = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/dtps", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLogs = function(dateObj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/logs", dateObj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRegisterOnMap = function(dateObj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    // httpReq = $http.get($rootScope.apiHost + "dashboard/registerDeviceOnMap");
    httpReq = $http.get($rootScope.apiHost + "devices/listnew?caller=dom", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveRegisterOnMap = function(dateObj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/registerDeviceOnMap", dateObj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMapCoordinates = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/coordinates", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceListReport = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/deviceList", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDetailedLog = function(id){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/detailedLog/" + id, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getRefresh = function(type){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/reload/" + type, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGrid = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/dGrid", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDGrid = function(dateObj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.put($rootScope.apiHost + "dashboard/dGrid", dateObj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.postDowanloadExcel = function(obj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/excel/quad", obj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.dowanloadExcelCCL = function(obj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/ccl/excel/popup", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deviceDetail = function(obj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/quad/devices", obj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deviceDetailNew = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if (canceler) {
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {
      timeout: canceler.promise
    };
    if((obj.caller == 'ssdt' || obj.caller == 'ssdpt' || obj.caller == 'ssodt') && obj.status){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 's':obj.status},config);
    }else if(obj.caller == 'ccs' || obj.caller == 'dccl' || obj.caller == 'dts' || obj.caller == 'dtps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'t':obj.caller},config);
    }else if(obj.caller == 'dpts' || obj.caller == 'dps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller},config);
    }else if(obj.caller == 'ds'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'val':obj.value, 't':obj.caller},config);
    }else{
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller},config);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // ! Popup scroll data list API start
  this.getScrollDBListData = function(obj){
    if((obj.caller == 'ssdt' || obj.caller == 'ssdpt' || obj.caller == 'ssodt') && obj.status){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 's':obj.status, 'offset':obj.offset});
    }else if(obj.caller == 'ccs' || obj.caller == 'dccl' || obj.caller == 'dts' || obj.caller == 'dtps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'t':obj.caller, 'offset':obj.offset});
    }else if(obj.caller == 'dpts' || obj.caller == 'dps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset});
    }else if(obj.caller == 'ds'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'val':obj.value, 't':obj.caller, 'offset':obj.offset});
    }else if((obj.caller == 'c' || obj.caller == 'nc') && obj.type == 'ccl'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'t':obj.type, 'id':obj.id, 'caller': obj.caller , 'offset': obj.offset});
    }else if(obj.caller == 'd' || obj.caller == 'dtpl' || obj.caller == 'rad' || obj.caller == 'dom'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'t': obj.caller , 'offset': obj.offset});
    }else if(obj.caller == 'wgws' || obj.caller == 'wgw'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset, 'tz':obj.tz});
    }else{
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset});
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSearchScrollDBData = function(obj){
    if((obj.caller == 'ssdt' || obj.caller == 'ssdpt' || obj.caller == 'ssodt') && obj.status){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 's':obj.status, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }else if(obj.caller == 'ccs' || obj.caller == 'dccl' || obj.caller == 'dts' || obj.caller == 'dtps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'t':obj.caller, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }else if(obj.caller == 'dpts' || obj.caller == 'dps'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }else if(obj.caller == 'ds'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'val':obj.value, 't':obj.caller, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }else if((obj.caller == 'c' || obj.caller == 'nc') && obj.type == 'ccl'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'t':obj.type, 'id':obj.id, 'caller': obj.caller , 'offset': obj.offset, 'searchQ': encodeURIComponent(obj.searchQ)});
    }else if(obj.caller == 'd' || obj.caller == 'dtpl' || obj.caller == 'rad' || obj.caller == 'dom'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'t': obj.caller , 'offset': obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }else if(obj.caller == 'wgws' || obj.caller == 'wgw'){
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ), 'tz':obj.tz});
    }else{
      httpReq = $http.post($rootScope.apiHost + "dashboard/deviceslist", {'q':obj.name,'val':obj.value, 't':obj.caller, 'offset':obj.offset, 'searchQ':encodeURIComponent(obj.searchQ)});
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
    // ! Popup scroll data list API End
  this.getTicketCounts = function(url, sId, envId){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    // httpReq = $http.get(url + "auth/devices/tickets/" + sId + "/" + envId + "/count");
    httpReq = $http.get($rootScope.apiHost + "hubspot/count/" + envId + "/" + sId, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTicket = function(url, sId, envId, type){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    // httpReq = $http.get(url +"auth/devices/tickets/"+ sId +"/"+ envId +"/"+ type);
    httpReq = $http.get($rootScope.apiHost +"hubspot/"+ envId +"/"+ sId +"/"+ type, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.restrictDevices = function(obj){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.post($rootScope.apiHost + "dashboard/feedRestriction", obj, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPinnedItems = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "dashboard/pinnedItems?dpi=1", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceAddress = function(id){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "devices/map/new/" + id, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // get Device status
  this.getDStatus = function(obj){
    httpReq = $http.post($rootScope.apiHost + "dashboard/devicestatus", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  
  this.getWgwSumm = function(){    
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };
    // httpReq = $http.get($rootScope.apiHost + "dashboard/wgws", destroy);
    httpReq = $http.get($rootScope.apiHost + "dashboard/wgws?tz="+ $rootScope.offsetFormatted, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWgwDeviceSheet = function(t, q, subt){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };
    if(q){
      httpReq = $http.get($rootScope.apiHost + "dashboard/devices/wgw?t=" + t + "&q=" + q + "&subType=" + subt + "&tz=" + $rootScope.offsetFormatted , destroy);
    } else{
      httpReq = $http.get($rootScope.apiHost + "dashboard/devices/wgw?t=" + t + "&tz=" + $rootScope.offsetFormatted , destroy);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  //Send adClick Status
  this.getAdCampaign = function(){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "adcampaign", destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  //Stop showing Ad
  this.stopAdCampaign = function(adId){
    var deferred = $q.defer();
    addRequest(deferred);
    var destroy = {
      timeout: deferred.promise
    };

    httpReq = $http.get($rootScope.apiHost + "adcampaign/ignore/"+adId, destroy);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  
  // Clean up requests if service is re-initialized
  this.cleanup = function () {
    cancelAllRequests();
  };

  this.handleError = function(response){
    if(response.status === -1){
      return ($q.reject('Request aborted'));
    } else{
      $rootScope.toastNotificationFx("danger", {
        "code": 5000
      });
      return ($q.reject(response.data.message));
    }
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
}]);
(function(){
  'use strict';
  angular.module('hub')
  .directive('imageLoad', function(){
    return{
      restrict:'A',
      link:function(scope, element, attrs) {
        element.bind("load", function() {
          scope.$apply(attrs.imageLoad);
        });
      }
    }
  });
})();
(function(){
  'use strict';
  angular.module('hub')
  .directive('dbThumb', function(){
    return{
      restrict:'A',
      link:function($scope, element, attrs){
        $scope.$watch(function(){
          var parent = element.parent();
          $scope.dbThumbParamZc3 = "&h="+(parent.closest(".dbScrollQuad").height()-50)+"&w="+(parent.closest(".dbScrollQuad").width()-30)+"&q=80&zc=3";
           return $scope.dbThumbParamZc3;
        });
      }
    }
  });
})();
(function(){
  'use strict';
  angular.module('hub')
  .directive('dbGetSetHeight', function(){
    return{
      restrict:'A',
      link:function($scope, element, attrs){
        $scope.$watch(function(){
          var parent = element.parent();
          var offSets = 0;
          if(Number(attrs.offset)){
            offSets = Number(attrs.offset);
          };
          var curHeight = parent.prop('offsetHeight') - offSets - element.find('.panel-heading').outerHeight() - element.find('.bg-light').outerHeight() - element.find('.panel-footer').outerHeight();
          element.find(".dbScrollQuad").height(curHeight);
        });
      }
    }
  });
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($log, $rootScope, $scope, $state, $window, $filter, $interval, $location, $timeout, Restangular, NgMap, ngDialog, DevicesSrv, ReportsSrv, DashboardSrv, ContentLibrarySrv){
    $rootScope.selectedMenu = 0;
    $scope.uiVersionFx();

    $scope.timestamp = moment().format('x');
    $scope.searchText = {log:"", device:""};
    $scope.searchPin = {text:""};
    $scope.isMapScriptLoaded = false;
    $scope.allDevicesLoaded = false;
    $scope.dashboardLoading = true;
    $scope.saveProcessing = false;
    $scope.allLogsLoaded = false;
    $scope.contentTooltip = "";
    $scope.logLoading = false;
    $scope.refreshing = false;
    $scope.mapLoading = true;
    var dashboardCtrl = this;
    $scope.controlInfo = {};
    $scope.markerList = [];
    $scope.dashboard = {};
    $scope.place = null;
    $scope.bucket = "";
    $scope.tim = "";

    // $scope.contentLibrary = [];

    // $scope.contentLibrary = {"contentLibrary":{"folder":[{"id":7386,"createdOn":1691061880,"label":"6","wp":0,"type":"Folder","pid":7386,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7385,"createdOn":1691061875,"label":"5","wp":0,"type":"Folder","pid":7385,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7384,"createdOn":1691061871,"label":"4","wp":0,"type":"Folder","pid":7384,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7383,"createdOn":1691061867,"label":"3","wp":0,"type":"Folder","pid":7383,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7382,"createdOn":1691061864,"label":"2","wp":0,"type":"Folder","pid":7382,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7381,"createdOn":1691061860,"label":"1","wp":0,"type":"Folder","pid":7381,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":7380,"createdOn":1691061854,"label":"A","wp":0,"type":"Folder","pid":7380,"editedOn":null,"createdby":42,"ufirstname":"l squared","ulastname":"support","cBy":"L Squared Support"},{"id":5670,"createdOn":1539663876,"label":"audio","wp":0,"type":"Folder","pid":5670,"editedOn":null,"createdby":1274,"ufirstname":"m1","ulastname":"1","cBy":"M1 1"}],"content":[]},"info":{"sortType":"createdon","sortVal":"desc","writable":true,"wp":false,"timthumb":"/api/v1/vendor/timthumb/timthumb.php?src=","bucket":"http://20.43.14.129:9000/dev-lsquared-hub/cl/","thumbSize":"n","groupType":"none","publisherV":"2.1.11.56","breadCrumbs":[],"path":"/","mbucket":"https://dev2.lsquared.com/dev-lsquared-hub/cl/"},"rightKey":[]};



    // if($scope.contentLibrary.info.breadCrumbs) {
		// 	$scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
		// }
		// if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.folder) {
		// 	$scope.folderList = $scope.contentLibrary.contentLibrary.folder;
		// }
		// if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.content) {
		// 	$scope.contentList = $scope.contentLibrary.contentLibrary.content;
		// }
		// if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.groups) {
		// 	$scope.contentGroup = $scope.contentLibrary.contentLibrary.groups;
		// }

    // $scope.devices = {"devices":[{"id":30156,"label":"test2212","mac":"test11112","timezone":"America/Toronto","thumbV":0,"lastPing":null,"status":"offline","createdOn":"2023-07-25 06:55:31","space":null,"dType":"mp","ss":0,"type":"device","os":1,"client":0,"mem":{"tot":null,"use":null},"disk":{"tot":null,"use":null}},{"id":29980,"label":"same123457","mac":"same123457","timezone":"America/Toronto","thumbV":0,"lastPing":null,"status":"offline","createdOn":"2023-05-11 12:09:28","space":null,"dType":"mp","ss":0,"type":"device","os":1,"client":0,"mem":{"tot":null,"use":null},"disk":{"tot":null,"use":null}},{"id":29979,"label":"same123456","mac":"same1234561","timezone":"America/Toronto","thumbV":0,"lastPing":null,"status":"offline","createdOn":"2023-05-11 12:07:18","space":null,"dType":"mp","ss":0,"type":"device","os":0,"client":0,"mem":{"tot":null,"use":null},"disk":{"tot":null,"use":null}},{"id":29978,"label":"same12345","mac":"same12345","timezone":"America/Toronto","thumbV":0,"lastPing":null,"status":"offline","createdOn":"2023-05-11 12:06:58","space":null,"dType":"mp","ss":0,"type":"device","os":1,"client":0,"mem":{"tot":null,"use":null},"disk":{"tot":null,"use":null}},{"id":29977,"label":"same1234","mac":"same1234","timezone":"America/Toronto","thumbV":0,"lastPing":null,"status":"offline","createdOn":"2023-05-11 12:06:18","space":null,"dType":"mp","ss":0,"type":"device","os":1,"client":0,"mem":{"tot":null,"use":null},"disk":{"tot":null,"use":null}}],"folders":[],"info":{"l":97,"al":5,"vl":5,"slide":"2.1.0.1120","watcher":"2.1.0.110","webos":"2.1.15","webOSisActive":true,"eSW":"2.1.12","eSM":"2.1.0","eSL":"2.1.0","eWW":"2.1.1","eWM":"2.1.0","eWL":"2.1.0","tzn":"2.1.0","chrm":"2.1.0","adrd":"1.0.0","de":true,"bucket":"http://20.43.14.129:9000/dev-lsquared-hub/d/","timthumb":"/api/v1/vendor/timthumb/timthumb.php?src=","sortType":"label","sortVal":"desc","breadCrumbs":[],"path":"","tc":5,"rdc":false,"mbucket":"https://dev2.lsquared.com/dev-lsquared-hub/d/","sd":{"url":"https://dev.lsquared.com/supportDev/","ep":"api/v1/"}}};

    // $scope.schedules = {"schedules":[{"id":25090,"startDate":"Aug 18, 2023","endDate":"Aug 18, 2024","isActive":1,"label":"bbb","gid":944,"isCustom":0,"isPartial":0,"createdOn":1692362612,"approvedOn":1692362624,"pr":1,"ls":0,"thumb":"dateTime","type":"Widget","extn":"Date Time","contentCount":1,"deviceCount":1},{"id":25089,"startDate":"Aug 18, 2023","endDate":"Aug 18, 2024","isActive":1,"label":"aaaa","gid":0,"isCustom":0,"isPartial":0,"createdOn":1692362583,"approvedOn":1692362596,"pr":1,"ls":0,"thumb":"dateTime","type":"Widget","extn":"Date Time","contentCount":1,"deviceCount":1}],"groups":[{"id":944,"gid":944,"label":"Test","createdOn":944,"isEditable":true,"permission":{"type":"p"}}],"info":{"sortType":"label","sortVal":"desc","tBucket":"http://20.43.14.129:9000/dev-lsquared-hub/","cBucket":"http://20.43.14.129:9000/dev-lsquared-hub/cl/","timthumb":"/api/v1/vendor/timthumb/timthumb.php?src=","tMbucket":"https://dev2.lsquared.com/dev-lsquared-hub/","cMbucket":"https://dev2.lsquared.com/dev-lsquared-hub/cl/","sp":"h"}};

    $scope.folderContentFx = function(fId, splId, type){
      $scope.odSp = {auth:false, breadCrumbs:[]};
      $scope.contentLibraryLoading = true;
      $rootScope.showTimeoutMsg = false;
      $rootScope.selectedItems = [];
      $rootScope.sessionTimoutFx();

      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curFId");

      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curFolderId = 0;
      $scope.curSPlObj = {};

      //for OD & SP breadcrumb
      if(fId == 0){
        $scope.odSp.breadCrumbs = [];
      }
      if(fId){
        localStorage.setItem("curFId", fId);
        $scope.curFolderId = fId;
      }
      if(splId){
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:type}));
        $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      }

      if($scope.curFolderId == 0){
        localStorage.setItem("inFolder", 0);
        localStorage.removeItem("curPathFId");
      }

      if(splId && fId != splId){
        ContentLibrarySrv.getAllSPL($scope.curFolderId, $scope.curSPlObj.id, $scope.curSPlObj.type).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else if(data.fType=="gd"){
                $scope.odSp.curType = "Googledrive";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.selectedTreeItem($scope.curFolderId);
        ContentLibrarySrv.getAll($scope.curFolderId).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.folderBriefFx = function(obj){ /*Get folder briefs*/
      $scope.contentBtn = [];
      $scope.contentBrief = [];
      $scope.contextMenuOpt = [];
      $timeout.cancel($scope.promise);
      localStorage.removeItem("curPathId");

      angular.element('.ui-selectable li').removeClass('ui-highlight');
      ContentLibrarySrv.getFolderBrief(obj[0].id, obj[0].splId, obj[0].type).then(
        function(data){
          $scope.contentBrief = data;
          if($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type != "folder"){/*Button api*/
            $scope.getBtnFx("c");
          }
        },
        function(err){
          $log.error(err);
        }
      );
      /*Button api*/
      if($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type == "folder"){
        $scope.getBtnFx("c");
      } else if($scope.selectedTab === "hub.contentLibrary.ac"){
        $scope.getBtnFx("ac");
      } else if($scope.selectedTab === "hub.contentLibrary.dc"){
        $scope.getBtnFx("dc");
      }
    }

    $scope.thumbSize = 'n'; //sm, n, md, lg, xl

    $scope.dgOptions = {cellHeight:50, verticalMargin:20, float:false, animate:true, staticGrid:false};
    $scope.dbLoading = {d:false, ccl:false, dtpl:false, rad:false, dp:false};
    $scope.dgActions = {isEditable:false, loading:false};
    $scope.dGrid = [];

    $scope.dbGotoFx = function(caller){
      if(!$scope.dgActions.isEditable){
        if($scope.auth.uservices.d && caller == "d"){
          $state.go("hub.devices.d");
        } else if($scope.auth.uservices.c && caller == "c"){
          $state.go("hub.contentLibrary.c");
        } else if($scope.auth.uservices.s && caller == "s"){
          $state.go("hub.schedules.s");
        } else if($scope.auth.uservices.u && caller == "u"){
          $state.go("hub.users.au");
        }
      } else{
      }
    }

    $scope.bingMapFx = function(){
      var locs = [];
      var navigationBarMode = Microsoft.Maps.NavigationBarMode;
      var map = new Microsoft.Maps.Map(document.getElementById('bingMap'), {
        navigationBarMode:navigationBarMode.compact,
     });

      var center = map.getCenter();
      for(var i = 0; i < $scope.markerList.length; i++){
        var loc = new Microsoft.Maps.Location($scope.markerList[i].latitude, $scope.markerList[i].longitude);
        var pushpin = new Microsoft.Maps.Pushpin(loc, {label:$scope.markerList[i].label, color:$scope.markerList[i].status == 'online'?'green':'gray'});

        var pushpins = Microsoft.Maps.TestDataGenerator.getPushpins($scope.markerList.length, map.getBounds());
        var infobox = new Microsoft.Maps.Infobox(center, {visible:false});
        infobox.setMap(map);

        pushpin.metadata = {
          label:$scope.markerList[i].label,
          description:'Discription for pushpin' + i
        };
        Microsoft.Maps.Events.addHandler(pushpin, 'click', function(args){
          infobox.setOptions({
            location:args.target.getLocation(),
            title:args.target.metadata.label,
            visible:true
         });
       });

        map.entities.push(pushpin);
        locs.push(loc);
      }

      if(locs.length > 0){
        var bestview = Microsoft.Maps.LocationRect.fromLocations(locs);
        map.setView({
          bounds:bestview,
          zoom:13
       });
      }
    }

    var map, datasource, popup, spiderManager, pos;
    $scope.azureMapFx = function(){
      setTimeout(function(){
        $scope.cordinates = [];
        $scope.markArr = [];
        $("#azMap").empty();

        //Define a popup template.
        // var keyArr = atob($scope.auth.uservices.mk).split("|");
        // var subKey = $scope.reverse(keyArr[0]);

        map = new atlas.Map('azMap', {
          view:'Auto',
          showFeedbackLink:false,
          enableAccessibilityLocationFallback:false,
          // Add your Azure Maps subscription client ID to the map SDK.
          authOptions:{
            //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
            authType:'subscriptionKey',
            // subscriptionKey:subKey
            subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
          },
          language: "en"
       });

        //center map
        if($scope.markerList.length){
          angular.forEach($scope.markerList, function(item){
            $scope.cordinates.push({"type":"Feature", "geometry":{"type":"Point", "coordinates":[item.longitude, item.latitude]}, "properties":{"Name":item.label, "Status":item.status, "Mac":item.mac}});
         });

          var positions = {"type":"FeatureCollection", "features":$scope.cordinates};
          $scope.latLongArr = [];
          //get only unique lat long length
          angular.forEach($scope.markerList, function(value, key){
            var newKey = value.latitude + '-' + value.longitude;
            if($scope.latLongArr.includes(newKey)){
            } else{
              $scope.latLongArr.push(newKey);
            }
         });

          if($scope.latLongArr.length == 1){
            map.setCamera({
              center:atlas.data.BoundingBox.fromData(positions),
              zoom:8
           });
          } else{
            map.setCamera({
              bounds:atlas.data.BoundingBox.fromData(positions),
              padding:50
           });
          }
        } else{
          map.setCamera({
            center:[-97, 39],
            zoom:3,
         });
        }

        map.events.add('ready', function(){
          //Create a popup.
          popup = new atlas.Popup();

          //marker icons
          var iconPromises = [
            map.imageSprite.createFromTemplate('onlineIcon', 'marker', '#4cae4c', '#fff'),
            map.imageSprite.createFromTemplate('offlineIcon', 'marker', '#808080', '#fff')
          ];

          //Wait for icons to load into the map sprite.
          Promise.all(iconPromises).then(function(){
            //Hide popup when user clicks or moves the map.
            // map.events.add('click', $scope.hidePopup);
            map.events.add('movestart', function(){
              $scope.hidePopup();
              isPopupOpen = true;
           });

            //Create a data source to add your data to.
            datasource = new atlas.source.DataSource(null, {
              //Tell the data source to cluster point data.
              cluster:true,
              //The radius in pixels to cluster points together.
              clusterRadius:0.1,
              clusterProperties:{//Calculate counts for each entity type in a cluster
                'online':['+', ['case', ['==', ['get', 'Status'], 'online'], 1, 0]],
                'offline':['+', ['case', ['==', ['get', 'Status'], 'offline'], 1, 0]]
              },
              //The maximium zoom level in which clustering occurs.
              //If you zoom in more than this, all points are rendered as symbols.
              clusterMaxZoom:24,
              maxZoom:24
           });

            //set data to datasource
            datasource.setShapes(positions);
            map.sources.add(datasource);

            //Create a layer for rendering clustered data in the data source.
            var clusterBubbleLayer = new atlas.layer.BubbleLayer(datasource, null, {
              //Scale the size of the clustered bubble based on the number of points inthe cluster.
              radius:[
                'step',
                ['get', 'point_count'],
                20,         //Default of 20 pixel radius.
                100, 30,    //If point_count >= 100, radius is 30 pixels.
                750, 40     //If point_count >= 750, radius is 40 pixels.
              ],

              //Change the color of the cluster based on the value on the point_cluster property of the cluster.
              color:[
                'case', //Use a conditional case expression.
                // all offline
                ['>', ['get', 'offline'], 0] && ['==', ['get', 'online'], 0],
                // '#a5a5a5',
                'rgba(165, 165, 165,0.7)',

                // all online
                ['>', ['get', 'online'], 0] && ['==', ['get', 'offline'], 0],
                // '#6aa84f',
                'rgba(106, 168, 79,0.7)',

                // online and offline both
                // '#ff9900'
                'rgba(255, 153, 0,0.7)',
              ],

              // text:'point_count_abbreviated',
              filter:['has', 'point_count'] //Only rendered data points which have a point_count property, which clusters do.
           });

            //Create a layer to render the individual locations.
            var shapeLayer = new atlas.layer.SymbolLayer(datasource, null, {
              iconOptions:{
                allowOverlap:true,
                ignorePlacement:true,
                opacity:1,
                //Use a case expression to select the image icon based on the Status property of the data point.
                image:[
                  'case',
                  //Check if status is online
                  ['==', ['get', 'Status'], 'online'],
                  'onlineIcon',
                  //Offline/default icon.
                  'offlineIcon'
                ]
              },
              textOptions:{
                textField:['get', 'point_count_abbreviated'],
                offset:[0, 0.4]
              },
              filter:['!', ['has', 'point_count']] //Filter out clustered points from this layer.
           });

            //Add the clusterBubbleLayer and two additional layers to the map.
            map.layers.add([
              clusterBubbleLayer,
              //Create a symbol layer to render the count of locations in a cluster.
              new atlas.layer.SymbolLayer(datasource, null, {
                iconOptions:{
                  image:'none', //Hide the icon image.
                },
                textOptions:{
                  textField:['get', 'point_count_abbreviated'],
                  offset:[0, 0.4],
                  color:'white',
                  // font:["SegoeFrutigerHelveticaMYingHei-Regular"],
                  font:["StandardFont-Bold"],
                  size:18
                },
                // filter:['!', ['has', 'point_count']]
             }),
              shapeLayer
            ]);

            //Create an instance of the spider manager.
            spiderManager = new atlas.SpiderClusterManager(map, clusterBubbleLayer, shapeLayer);
            spiderManager.setOptions({
              stickLayerOptions:{
                strokeColor:[
                  'case',
                  ['boolean', ['feature-state', 'hover'], false],
                  '#808080',
                  '#808080'
                ]
              }
           });

            var isMarkerClick = false;
            var isPopupOpen = false;
            var isCluster = false;
            var properties = "";

            //Add event handler for when a feature is selected.
            map.events.add('featureSelected', spiderManager, function(e){
              isPopupOpen = true;
              if(e.cluster){
                isCluster = true;
                isMarkerClick = true;
                properties = e.shape.getProperties();
              } else{
                isCluster = false;
                isMarkerClick = false;
                $scope.showPopup(e.shape.getCoordinates(), e.shape.getProperties(), [0, -20]);
              }
           });

            //Add event handler for when a feature is unselected.
            map.events.add('featureUnselected', spiderManager, function(){
              isMarkerClick = false;
              $scope.hidePopup();
           });

            map.events.add('close', popup, function(e){
              isMarkerClick = false;
              isPopupOpen = false;
           });

            map.events.add('click', function(e){
              if(isMarkerClick){
                $scope.hidePopup();
                $scope.showPopup(e.position, properties, [0, 0]);
              } else{
                if(isCluster){
                  $scope.hidePopup();
                }
              }
              if(isPopupOpen || popup.isOpen()){
              } else{
                spiderManager.setOptions({
                  closeWebOnPointClick:false
               });
              }
           });

         });
       });
      }, 800);
    }

    var popupTemplate = '<div class="customInfobox"><div class="name"><span class="pull-left marT4 deviceStatus {status}"></span><div class="padL20">{name}</div><div class="mac">{mac}</div></div></div>';
    $scope.showPopup = function(position, properties, pixelOffset){
      var content = popupTemplate.replace(/{name}/g, properties.Name).replace(/{status}/g, properties.Status).replace(/{mac}/g, properties.Mac);
      popup.setOptions({
        //Update the content of the popup.
        content:content,
        //Update the position of the popup with the symbols coordinate.
        position:position,
        //Offset the popups position for better alignment with the layer.
        pixelOffset:pixelOffset
        // pixelOffset:[0,0]
     });

      //Open the popup.
      popup.open(map);
    }

    $scope.hidePopup = function(){
      popup.close();
    }

    $scope.dgOptionsFx = function(caller){
      $scope.dgActions.loading = false;
      $rootScope.isDBEdit = caller;
      if(caller == "e"){
        $rootScope.$broadcast("dGridSet", caller);
        $scope.dGridCanCopy = angular.copy($scope.dGridArr);
        $scope.dgActions.isEditable = true;
      } else if(caller == "s"){
        $rootScope.$broadcast("dGridSet", caller);
        $scope.dgActions.loading = true;
        DashboardSrv.saveDGrid($scope.dGridArr).then(
          function(data){
            $scope.dGridCopy = angular.copy($scope.dGridArr);
            $scope.dgActions.isEditable = false;
            $scope.dgActions.loading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "c"){
        $scope.dgActions.isEditable = false;
        $window.location.reload();
      }
    }

    $scope.setDefaultGridFx = function(){
      $scope.dgActions.loading = true;
      $scope.dGArr = [];
      if($scope.dashboard.dbd.ds){/*Device Online*/
        $scope.dGArr.push({x:0, y:0, width:3, height:2, minH:2, type:'ds'});
      }
      if($scope.dashboard.dbd.c){/*Content*/
        $scope.dGArr.push({x:3, y:0, width:3, height:2, minH:2, type:'c'});
      }
      if($scope.dashboard.dbd.sc){/*Scheduls*/
        $scope.dGArr.push({x:6, y:0, width:3, height:2, minH:2, type:'sc'});
      }
      if($scope.dashboard.dbd.us){/*Users*/
        $scope.dGArr.push({x:9, y:0, width:3, height:2, minH:2, type:'us'});
      }
      if($scope.dashboard.dbd.ral){/*Recent Activity Log*/
        $scope.dGArr.push({x:0, y:2, width:3, height:6, minH:4, type:'ral'});
      }
      if($scope.dashboard.dbd.d){/*Devices*/
        $scope.dGArr.push({x:3, y:2, width:3, height:6, minH:4, type:'d'});
      }
      if($scope.dashboard.dbd.dom){/*Devices on Map*/
        $scope.dGArr.push({x:6, y:2, width:6, height:6, minH:4, type:'dom'});
      }
      if($scope.dashboard.dbd.dts){/*Devices Type Summary*/
        $scope.dGArr.push({x:0, y:8, width:3, height:3, minH:2, type:'dts'});
      }
      if($scope.dashboard.dbd.dtps){/*Device Temperature Summary*/
        $scope.dGArr.push({x:3, y:8, width:3, height:2, minH:2, type:'dtps'});
      }
      if($scope.dashboard.dbd.dtpl){/*Device Temperature List*/
        $scope.dGArr.push({x:6, y:8, width:3, height:6, minH:4, type:'dtpl'});
      }
      if($scope.dashboard.dbd.ccl){/*Content Confirmation List*/
        $scope.dGArr.push({x:9, y:8, width:3, height:6, minH:4, type:'ccl'});
      }
      if($scope.dashboard.dbd.rad){/*Recently Added Devices*/
        $scope.dGArr.push({x:0, y:10, width:3, height:6, minH:4, type:'rad'});
      }
      if($scope.dashboard.dbd.ccs){/*Content Confirmation Summary*/
        $scope.dGArr.push({x:3, y:10, width:3, height:2, minH:2, type:'ccs'});
      }
      if($scope.dashboard.dbd.ot){/*Open Tickets*/
        $scope.dGArr.push({x:0, y:12, width:3, height:2, minH:2, type:'ot'});
      }
      if($scope.dashboard.dbd.dccl){/*dccl*/
        $scope.dGArr.push({x:0, y:14, width:4, height:4, minH:3, type:'dccl'});
      }
      if($scope.dashboard.dbd.dpi){/*Content Pin*/
        $scope.dGArr.push({x:3, y:14, width:6, height:6, minH:3, type:'dpi'});
      }


      /****** Check *******/

      if($scope.dashboard.dbd.dps && $scope.dashboard.dps.length > 0){/*Devices Other Info Summary*/
        var dspLoopX = 0, dspLoopY = 14;
        angular.forEach($scope.dashboard.dps.data, function(dps, index){
          if(3 * index > 9){
            dspLoopX = 0;
            dspLoopY = dspLoopY + 2;
          } else{
            dspLoopX = index;
          }
          $scope.dGArr.push({x:3 * dspLoopX, y:dspLoopY, width:3, height:2, type:'dps', subType:index, label:dps.label});
       });
      }

      if($scope.dashboard.dbd.dpts && $scope.dashboard.dpts.length > 0){/*Devices Properties Summary*/
        var dptsLoopX = 0, dptsLoopY = 14;
        angular.forEach($scope.dashboard.dpts.data, function(dpts, index){
          if(3 * index > 9){
            dptsLoopX = 0;
            dptsLoopY = dptsLoopY + 2;
          } else{
            dptsLoopX = index;
          }
          $scope.dGArr.push({x:3 * dptsLoopX, y:dptsLoopY, width:3, height:2, type:'dpts', subType:index, label:dpts.label});
       });
      }

      if($scope.dashboard.dbd.ssdt && $scope.dashboard.ssdt){/*Status of Specific Device Type*/
        var ssdtLoopX = 0, ssdtLoopY = 16;
        angular.forEach($scope.dashboard.ssdt.data, function(ssdt, index){
          if(3 * index > 9){
            ssdtLoopX = 0;
            ssdtLoopY = ssdtLoopY + 2;
          } else{
            ssdtLoopX = index;
          }
          $scope.dGArr.push({x:3 * ssdtLoopX, y:ssdtLoopY, width:3, height:2, minH:2, type:'ssdt', subType:index, label:ssdt.label});
       });
      }
      if($scope.dashboard.dbd.ssodt && $scope.dashboard.ssodt){/*Status Summary of Device Type*/
        var ssodtLoopX = 0, ssodtLoopY = 16;
        angular.forEach($scope.dashboard.ssodt, function(ssodt, index){
          if(3 * index > 9){
            ssodtLoopX = 0;
            ssodtLoopY = ssodtLoopY + 2;
          } else{
            ssodtLoopX = index;
          }
          $scope.dGArr.push({x:3 * ssodtLoopX, y:ssodtLoopY, width:3, height:2, minH:2, type:'ssodt', subType:index, label:ssodt.label});
       });
      }

      /****** Check *******/
      $scope.dGridArr = $scope.dGArr;
      setTimeout(function(){
        $scope.dgOptionsFx('e');
      }, 10);
    }

    $scope.getDashboard = function(){
      $scope.markerList = [];
      DashboardSrv.getDashboard().then(
        function(data){
          if(angular.isArray(data)){
            return;
          }
          $scope.dashboard = data;

          if($scope.dashboard.d){
            $scope.webOSisActive = $scope.auth.upermissions.webos;
          }
          if($scope.dashboard.dp){
            $scope.tim = $scope.dashboard.dp.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.dashboard.dp.bucket;
            if($scope.dashboard.dp.mbucket && $scope.dashboard.dp.mbucket != ""){
              $scope.detailBucket = $scope.dashboard.dp.mbucket;
            }
          }

          if($scope.auth.uservices.m == "b"){
            var s = document.createElement('script');
            s.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-spider-clusters.min.js?ts=' + $scope.timestamp);
            document.body.appendChild(s);

            var s1 = document.createElement('script');
            s1.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-html-marker-layer.min.js?ts=' + $scope.timestamp);
            document.body.appendChild(s1);
            $scope.isMapScriptLoaded = true;
          }

          //call API for grid
          $scope.getGrid();

          /*Recent Activity Log*/
          // if($scope.dashboard.dbd.ral){
          //   $scope.logList = $scope.dashboard.ral.logs;
          //   $scope.tim = $scope.dashboard.ral.timthumb;
          //   $scope.uBucket = $scope.dashboard.ral.bucket;
          // }
          if($scope.dashboard.dbd.c){
            // console.warn("AAAAAAAAA");

            $scope.usedSpace = $scope.dashboard.c.uss;
            $scope.usedSpacePercent = ($scope.usedSpace * 100) / $scope.dashboard.c.ts;
            $scope.contentTooltip = '"' + $filter("translate")('cl.tool.10') + ":" + $scope.dashboard.c.ac + "<br>" + $filter("translate")('cl.tool.11') + ":" + $scope.dashboard.c.uac + "<br>" + $filter("translate")('db.body.8') + ":" + $scope.dashboard.c.ec + "<br>" + $filter("translate")('db.body.6') + ":" + $scope.dashboard.c.arc + "<br>" + $filter("translate")('db.body.7') + ":" + $scope.dashboard.c.dc + '"';
          }

          /*Devices Other Info Summary*/
          $scope.dpsSettings = $scope.dashboard.dps;
          if($scope.dashboard.dbd.dps && $scope.dashboard.dps && $scope.dashboard.dps.data){
            DashboardSrv.getKeyType($scope.dpsSettings, "dps").then(
              function(data){
                $scope.dashboardLoading = false;
                $scope.dps = data;
                $scope.dps.total = [];
                $scope.dpsArr = [];
                var dspOpts = {
                  chart:{
                    width:120,
                    height:120,
                    type:'pie',
                    plotShadow:false,
                    plotBorderWidth:0,
                    margin:[0, 0, 0, 0],
                    backgroundColor:'rgba(0,0,0,0)'
                  },
                  navigation:{
                    buttonOptions:{
                      enabled:false
                    }
                  },
                  tooltip:{
                    headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                    pointFormat:'{point.name}:<b>{point.y}</b>'
                  },
                  plotOptions:{
                    pie:{
                      cursor:'pointer',
                      dataLabels:{
                        size:'100%',
                        distance:-11,
                        enabled:true,
                        style:{
                          color:'white',
                          fontSize:'10px',
                          textShadow:'0 1px 1px #333333'
                        },
                        formatter:function(){
                          return this.y;
                        }
                      },
                      showInLegend:false,
                      center:['50%', '50%']
                    }
                  }
                };

                angular.forEach($scope.dps, function(dps, index){
                  var curFilertdDG = $filter("filter")($scope.dashboard.dGrid, {label:dps.label}, true);
                  if(curFilertdDG.length){
                    if($filter('lowercase')(dps.label) == $filter('lowercase')(curFilertdDG[0].label)){
                      curFilertdDG[0].subType = index;
                      $scope.dGridArr.push(curFilertdDG[0]);
                    }
                  } else{
                    $scope.dGridArr.push({x:0, y:14, width:3, height:2, minH:2, type:'dps', subType:index, label:dps.label});
                  }
               });

                angular.forEach($scope.dps, function(dps, index){
                  var curDpsArr = [];
                  var curDpsValArr = [];
                  var dpsTotal = [];
                  angular.forEach(dps.d, function(val){
                    curDpsArr.push({name:val.value, y:val.dId.length, yl:val.dId, total:"sd", title:dps.label});
                    angular.forEach(val.dId, function(dId){
                      dpsTotal.push(dId);
                      curDpsValArr.push(dId);
                  });
                });

                dps.total = [];
                angular.forEach(curDpsValArr, function(dId){
                  dps.total.push(dId);
                });

                  $scope.dpsArr.push(
                    {
                      options:dspOpts,
                      series:[{
                        size:'100%',
                        data:curDpsArr,
                        d:dpsTotal,
                        name:dps.label,
                        innerSize:'50%',
                        cursor:'pointer',
                        colorByPoint:true,
                        showInLegend:false,
                        point:{
                          events:{
                            click:function(event){
                              $scope.detailsOpen('dps', this.title, this.yl, '', this.name);
                            }
                          }
                        }
                      }],
                      title:' ',
                      xAxis:{categories:[] },
                      yAxis:{title:' ' },
                    }
                  );
               });
              },
              function(err){
                $log.error(err);
              }
            );
          }

          /*Devices Properties Summary*/
          $scope.dptsSettings = $scope.dashboard.dpts;
          if($scope.dashboard.dbd.dpts && $scope.dashboard.dpts && $scope.dashboard.dpts.data){
            DashboardSrv.getKeyType($scope.dptsSettings, "dpts").then(
              function(data){
              $scope.dashboardLoading = false;
              $scope.dpts = data;
              $scope.dptsArr = [];
              var dptsOpts = {
                chart:{
                  width:120,
                  height:120,
                  type:'pie',
                  plotShadow:false,
                  plotBorderWidth:0,
                  margin:[0, 0, 0, 0],
                  backgroundColor:'rgba(0,0,0,0)'
                },
                navigation:{
                  buttonOptions:{
                    enabled:false
                  }
                },
                tooltip:{
                  headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                  pointFormat:'{point.name}:<b>{point.y}</b>'
                },
                plotOptions:{
                  pie:{
                    cursor:'pointer',
                    dataLabels:{
                      size:'100%',
                      distance:-11,
                      enabled:true,
                      style:{
                        color:'white',
                        fontSize:'10px',
                        textShadow:'0 1px 1px #333333'
                      },
                      formatter:function(){
                        return this.y;
                      }
                    },
                    showInLegend:false,
                    center:['50%', '50%']
                  }
                }
              };

              angular.forEach($scope.dpts, function(dpts, index){
                var curFilertdDG = $filter("filter")($scope.dashboard.dGrid, {label:dpts.label }, true);
                if(curFilertdDG.length){
                  if($filter('lowercase')(dpts.label) == $filter('lowercase')(curFilertdDG[0].label)){
                    curFilertdDG[0].subType = index;
                    $scope.dGridArr.push(curFilertdDG[0]);
                  } else{
                  }
                } else{
                  $scope.dGridArr.push({x:0, y:14, width:3, height:2, minH:2, type:'dpts', subType:index, label:dpts.label});
                }
             });

              $scope.dpts.total = [];
              angular.forEach($scope.dpts, function(dpts, index){

                var curDptsArr = [];
                var curDptsValArr = [];
                var dptsTotal = [];
                angular.forEach(dpts.d, function(val){
                  curDptsArr.push({name:val.value, y:val.dId.length, yl:val.dId, total:"sd", title:dpts.label});
                  angular.forEach(val.dId, function(dId){
                    dptsTotal.push(dId);
                    curDptsValArr.push(dId);
                 });
               });
                dpts.total = [];
                angular.forEach(curDptsValArr, function(val){
                  dpts.total.push(val);
               });

                $scope.dptsArr.push(
                  {
                    options:dptsOpts,
                    series:[{
                      size:'100%',
                      data:curDptsArr,
                      name:dpts.label,
                      d:dptsTotal,
                      innerSize:'50%',
                      cursor:'pointer',
                      colorByPoint:true,
                      showInLegend:false,
                      point:{
                        events:{
                          click:function(event){
                            $scope.detailsOpen('dpts', this.title, this.yl, '', this.name);
                          }
                        }
                      }
                    }],
                    title:' ',
                    xAxis:{categories:[] },
                    yAxis:{title:' ' },
                  }
                );
             });
              },
              function(err){
                $log.error(err);
              }
            );
          }

          /*Open Tickets*/
          if($scope.dashboard.dbd.ot){
            DashboardSrv.getTicketCounts($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId).then(
              function(data){
                $scope.dashboard.ot = data;
                if($scope.dashboard.ot.total > 0){
                  $scope.otArr = [];
                  var otOpts = {
                    chart:{
                      width:120,
                      height:120,
                      type:'pie',
                      plotShadow:false,
                      plotBorderWidth:0,
                      margin:[0, 0, 0, 0],
                      backgroundColor:'rgba(0,0,0,0)'
                    },
                    navigation:{
                      buttonOptions:{
                        enabled:false
                      }
                    },
                    tooltip:{
                      pointFormat:'{series.name}:<b>{point.y}</b>'
                    },
                    plotOptions:{
                      pie:{
                        // allowPointSelect:true,
                        cursor:'pointer',
                        dataLabels:{
                          size:'100%',
                          distance:-11,
                          enabled:true,
                          style:{
                            color:'white',
                            fontSize:'10px',
                            textShadow:'0 1px 1px #333333'
                          },
                          formatter:function(){
                            return this.y;
                          }
                        },
                        showInLegend:false,
                        center:['50%', '50%']
                      }
                    }
                  };

                  var curOtArr = [
                    {name:$filter("translate")('ms.label.35.15.3'), y:$scope.dashboard.ot.o, type:'o', color:$scope.dashboard.dsg.pieColors.ot.ot },
                    {name:$filter("translate")('ms.label.35.15.4'), y:$scope.dashboard.ot.r, type:'r', color:$scope.dashboard.dsg.pieColors.ot.t }
                  ];

                  $scope.otArr = {
                    options:otOpts,
                    series:[{
                      size:'100%',
                      data:curOtArr,
                      name:$filter("translate")("cl.widget.count.1"),
                      innerSize:'50%',
                      cursor:'pointer',
                      colorByPoint:true,
                      showInLegend:false,
                      point:{
                        events:{
                          click:function(event){
                            $scope.deviceTicketOpen('ot', this.type);
                          }
                        }
                      }
                    }],
                    credits:{enabled:false },
                    title:' ',
                    xAxis:{categories:[] },
                    yAxis:{title:' ' }
                  }
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }


          $rootScope.showTimeoutMsg = false;
          $scope.searchText.device = "";
          $scope.refreshing = true;
          $scope.mapLoading = false;
          $scope.refreshing = false;

          if($scope.auth.uservices.m == "b"){
            $scope.tryLoadBingMap();
          } else{
            NgMap.getMap().then(function(map){
              dashboardCtrl.map = map;
              if($scope.markerList.length == 1 && map.getZoom() > 4){
                setTimeout(function(){
                  map.setZoom(7);
                }, 200);
              }
           });
          }

          setTimeout(function(){
            // $scope.loadDeviceList();
            if($rootScope.isDBEdit == "e"){
              $scope.dgOptionsFx('e');
            }
          }, 500);

        if($scope.dashboard.ssdpt || $scope.dashboard.ssdt || $scope.dashboard.dps || $scope.dashboard.dpts){
          $scope.dashboardLoading = true;
        } else{
          $scope.dashboardLoading = false;
        }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getDashboard();

    $scope.getGrid = function(){
      DashboardSrv.getGrid().then(
        function(data){
          // console.log("data",data);
          $scope.dashboard.dGrid = data
          if(!$scope.dashboard.dGrid.length){
            $scope.dashboard.dGrid = [];
          }
          /*Grid start*/
          $scope.dGridArr = [];
          if($scope.dashboard && !$scope.dashboard.dGrid){
            $scope.dGridArr = [];
          } else{
            $scope.dGridCopy = angular.copy($scope.dashboard.dGrid);
          }
          if($scope.dashboard.dbd.ds){/*Device Online*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'ds'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'ds'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:0, width:3, height:2, minH:2, type:'ds'});
            }
          }
          if($scope.dashboard.dbd.c){/*Content*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'c'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'c'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:3, y:0, width:3, height:2, minH:2, type:'c'});
            }
          }
          if($scope.dashboard.dbd.sc){/*Scheduls*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'sc'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'sc'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:6, y:0, width:3, height:2, minH:2, type:'sc'});
            }
          }
          if($scope.dashboard.dbd.us){/*Users*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'us'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'us'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:9, y:0, width:3, height:2, minH:2, type:'us'});
            }
          }
          if($scope.dashboard.dbd.ral){/*Recent Activity Log*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'ral'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'ral'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:2, width:3, height:6, minH:4, type:'ral'});
            }
          }
          if($scope.dashboard.dbd.d){/*Devices*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'d'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'d'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:3, y:2, width:3, height:6, minH:4, type:'d'});
            }
          }
          if($scope.dashboard.dbd.dom){/*Devices on Map*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dom'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dom'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:6, y:2, width:6, height:6, minH:4, type:'dom'});
            }
          }
          if($scope.dashboard.dbd.dts){/*Devices Type Summary*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dts'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dts'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:8, width:3, height:3, minH:2, type:'dts'});
            }
          }
          if($scope.dashboard.dbd.dtps){/*Device Temperature Summary*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dtps'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dtps'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:3, y:8, width:3, height:2, minH:2, type:'dtps'});
            }
          }
          if($scope.dashboard.dbd.dtpl){/*Device Temperature List*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dtpl'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dtpl'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:6, y:8, width:3, height:6, minH:4, type:'dtpl'});
            }
          }
          if($scope.dashboard.dbd.ccl){/*Content Confirmation List*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'ccl'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'ccl'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:9, y:8, width:3, height:6, minH:4, type:'ccl'});
            }
          }
          if($scope.dashboard.dbd.rad){/*Recently Added Devices*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'rad'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'rad'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:10, width:3, height:2, minH:4, type:'rad'});
            }
          }
          if($scope.dashboard.dbd.ccs){/*Content Confirmation Summary*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'ccs'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'ccs'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:3, y:10, width:3, height:2, minH:2, type:'ccs'});
            }
          }
          if($scope.dashboard.dbd.ot){/*Open Tickets*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'ot'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'ot'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:12, width:3, height:2, minH:2, type:'ot'});
            }
          }
          if($scope.dashboard.dbd.dp){/*Device Preview*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dp'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dp'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:12, width:3, height:4, minH:4, type:'dp'});
            }
          }
          if($scope.dashboard.dbd.dccl){/*dccl*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dccl'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dccl'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:0, y:12, width:3, height:3, minH:3, type:'dccl'});
            }
          }
          if($scope.dashboard.dbd.dpi){/*Pin items*/
            if($filter("filter")($scope.dashboard.dGrid, {type:'dpi'}, true).length){
              $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {type:'dpi'}, true)[0]);
            } else{
              $scope.dGridArr.push({x:3, y:14, width:6, height:6, minH:3, type:'dpi'});
            }
          }

          if(!$scope.dashboard.dGrid.length){
            $scope.dashboard.dGrid = angular.copy($scope.dGridArr);
          }
          /*Grid end*/
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.secondaryLoading = true;
    $scope.getNewApiFx = function(caller){
      if(caller && caller!="refresh"){
        if(caller == "d"){
          $scope.searchText.device = "";
          $scope.dbLoading.d = true;
        } else if(caller == "ccl"){
          $scope.searchText.ccl = "";
          $scope.dbLoading.ccl = true;
        } else if(caller == "dtpl"){
          $scope.searchText.dtpl = "";
          $scope.dbLoading.dtpl = true;
        } else if(caller == "rad"){
          $scope.searchText.rad = "";
          $scope.dbLoading.rad = true;
        } else if(caller == "dp"){
          $scope.dbLoading.dp = true;
        }
      } else{
        $scope.loading = true;
        $scope.refreshing = true;
      }
      DashboardSrv.getDeviceContent().then(
        function(data){
          $scope.secondaryLoading = false;
          $scope.curDCData = data;
          if(caller && caller!="refresh"){
            $scope.dbLoading = {d:false, ccl:false, dtpl:false, rad:false, dp:false };
          } else{
            $rootScope.sessionTimoutFx();
            $rootScope.showTimeoutMsg = false;
            $scope.searchText.device = "";
            $scope.refreshing = true;

            /*For Coordinators*/
              $scope.deviceList = $scope.curDCData.d;
              angular.forEach($scope.curDCData.d, function(dList){
                if(dList.ll.length){
                  $scope.markerList.push({latitude:dList.ll[0], longitude:dList.ll[1], status:(dList.s==1)? "online":"offline", label:dList.l, mac:dList.h});
                }
             });

              $scope.mapLoading = false;
              $scope.refreshing = false;

              if($scope.auth.uservices.m == "b"){
                if(caller=="refresh"){
                  $scope.tryLoadBingMap();
                }
              } else{
                NgMap.getMap().then(function(map){
                  dashboardCtrl.map = map;
                  if($scope.markerList.length == 1 && map.getZoom() > 4){
                    setTimeout(function(){
                      map.setZoom(7);
                    }, 200);
                  }
               });
              }
              $scope.loading = false;
              $scope.refreshing = false;
              $scope.dbLoading = {d:false, ccl:false, dtpl:false, rad:false, dp:false };
          }

          $scope.markerList = [];
          $scope.ssodtPref = [{label:"mp",categorry:"Device Type"},{label:"desktop",categorry:"Device Type"}];
          $scope.curDCData.ssodt = [];
          $scope.curDCData.dp = {};
          // $scope.curDCData.ds = {online:[], offline:[], nc:[], total:[]};
          $scope.curDCData.ccs = {down:[], no:[], rem:[], total:[]};
          $scope.curDCData.dts = {mp:[], webos:[], tizen:[], mc:[], desktop:[], epd:[], gf:[], v:[]};
          $scope.curDCData.dccl = {ofcc:[], offline:[], ofncc:[], ofnsd:[], oncc:[], online:[], onncc:[], onnsd:[], nosd:[], totalCount:[]};
          $scope.allDeviceList = [];
          $scope.allDeviceListTemp = [];

          // console.log("$scope.curDCData",$scope.curDCData);
          /*For Content Confirmation List*/
          if($scope.curDCData.c.length){
            angular.forEach($scope.curDCData.c, function(cList){
              cList.label = cList.l;
              cList.devices = [];
              angular.forEach($scope.curDCData.d, function(dList){

                if(dList.c.length){
                  angular.forEach(dList.c, function(dcList){
                    if(dcList === cList.i){
                      cList.devices.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:(dList.s==1)? "online":"offline"});
                    }
                 });
                }
                if(dList.u.length){
                  angular.forEach(dList.u, function(duList){
                    if(duList === cList.i){
                      cList.devices.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:false, ct:dList.ct, status:(dList.s==1)? "online":"offline"});
                    }
                 });
                }
             });
           });
          }

          if($scope.curDCData.d.length){
            angular.forEach($scope.curDCData.d, function(dList, index){
              dList.label = dList.l;
              dList.status = dList.s;
              $scope.allDeviceList.push({id:dList.i, label:dList.l, mac:dList.h, status:dList.s});
              $scope.curDCData.ccs.total.push(dList.i);

              /*For Content Confirmation Summary*/
              if(dList.c.length && !dList.u.length){
                $scope.curDCData.ccs.down.push(dList.i);   //Devices downloaded all content (Confirmed)
              } else if(!dList.c.length && !dList.u.length){
                $scope.curDCData.ccs.no.push(dList.i);   //Devices downloaded all content (not schedule)
              } else if(dList.u.length){
                $scope.curDCData.ccs.rem.push(dList.i);   //Devices downloaded all content (Unconfirmed)
              }

              /*Devices Type Summary*/
              if(dList.t == 1 || dList.t == 5 || dList.t == 6){
                $scope.curDCData.dts.mp.push(dList.i);
              } else if(dList.t == 2){
                $scope.curDCData.dts.webos.push(dList.i);
              } else if(dList.t == 7){
                $scope.curDCData.dts.mc.push(dList.i);
              } else if(dList.t == 3){
                $scope.curDCData.dts.tizen.push(dList.i);
              } else if(dList.t == 8){
                $scope.curDCData.dts.desktop.push(dList.i);
              } else if(dList.t == 9){
                $scope.curDCData.dts.epd.push(dList.i);
              } else if(dList.t == 10){
                $scope.curDCData.dts.gf.push(dList.i);
              } else if(dList.t == 11){
                $scope.curDCData.dts.v.push(dList.i);
              }
              $scope.curDCData.dts.total = $scope.curDCData.dts.mp.concat($scope.curDCData.dts.webos, $scope.curDCData.dts.tizen, $scope.curDCData.dts.mc, $scope.curDCData.dts.desktop, $scope.curDCData.dts.epd, $scope.curDCData.dts.gf, $scope.curDCData.dts.v);

              if(dList.s == 1){
                $scope.curDCData.ds.online.push(dList.i);
                if(dList.c.length && !dList.u.length){
                    $scope.curDCData.dccl.oncc.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                if(dList.u.length ){
                  $scope.curDCData.dccl.onncc.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                if(!dList.c.length && !dList.u.length){
                  $scope.curDCData.dccl.onnsd.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                $scope.curDCData.dccl.online.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
              } else if(dList.s == 2){
                $scope.curDCData.ds.nc.push(dList.i);
              } else{
                $scope.curDCData.ds.offline.push(dList.i);
                if(dList.c.length && !dList.u.length){
                  $scope.curDCData.dccl.ofcc.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                if(dList.u.length){
                  $scope.curDCData.dccl.ofncc.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                if(!dList.c.length && !dList.u.length){
                  $scope.curDCData.dccl.ofnsd.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
                }
                $scope.curDCData.dccl.offline.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
              }
              if(!dList.c.length && !dList.u.length){
                $scope.curDCData.dccl.nosd.push({id:dList.i, label:dList.l, mac:dList.h, isConfirmed:true, ct:dList.ct, status:dList.s});
              }
              $scope.curDCData.dccl.totalCount = $scope.curDCData.d.length;

              if(dList.ll.length){
                $scope.markerList.push({latitude:dList.ll[0], longitude:dList.ll[1], status:(dList.s==1)? "online":"offline", label:dList.l, mac:dList.h});
              }

                /*For Device Preview*/
                if($scope.dashboard.dp){
                  if(dList.i == $scope.dashboard.dp.Id){
                    $scope.curDCData.dp ={id:dList.i, label:dList.l, mac:dList.h, dType:dList.t == 1? "mp":dList.t == 2? "webos":dList.t == 3? "tizen":dList.t == 4? "chrome":dList.t == 5? "mp":dList.t == 6? "mp":dList.t == 7? "mp":dList.t == 8? "desktop":dList.t == 9? "epd":"gf", status:(dList.s==1)? "online":"offline"};
                  }
                }
           });
          }

          angular.forEach($scope.dashboard.dsg.ssodt, function(data, key){
            $scope.mpSsodt = {online:[], offline:[],total:[]};
            $scope.tizenSsodt = {online:[], offline:[],total:[]};
            $scope.webosSsodt = {online:[], offline:[],total:[]};
            $scope.chromeSsodt = {online:[], offline:[],total:[]};
            $scope.mcSsodt = {online:[], offline:[],total:[]};
            $scope.desktopSsodt = {online:[], offline:[],total:[]};
            $scope.epdSsodt = {online:[], offline:[],total:[]};
            $scope.gfSsodt = {online:[], offline:[],total:[]};
            $scope.vSsodt = {online:[], offline:[],total:[]};
            if(data){
              if(key == "mp"){
                $scope.mpData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 1 || obj.t == 5 || obj.t == 6){
                    return obj;
                  }
               });
                $scope.online = $scope.mpData.map(function(obj){
                  if(obj.s == 1){
                    $scope.mpSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.mpData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.mpSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.mpData.map(function(obj){
                    $scope.mpSsodt.total.push(obj.i);
                    return obj.i;
                });
                $scope.mpSsodt.label = "mp";
                $scope.mpSsodt.category = "Device Type";
                if($scope.mpData.length > 0){
                  $scope.curDCData.ssodt.push($scope.mpSsodt);
                }
              } else if(key == "tizen"){
                $scope.tizenData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 3){
                    return obj;
                  }
               });
                $scope.online = $scope.tizenData.map(function(obj){
                  if(obj.s == 1){
                    $scope.tizenSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.tizenData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.tizenSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.tizenData.map(function(obj){
                    $scope.tizenSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.tizenSsodt.label = "tizen";
                $scope.tizenSsodt.category = "Device Type";
                if($scope.tizenData.length > 0){
                  $scope.curDCData.ssodt.push($scope.tizenSsodt);
                }
              } else if(key == "webos"){
                $scope.webosData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 2){
                    return obj;
                  }
               });
                $scope.online = $scope.webosData.map(function(obj){
                  if(obj.s == 1){
                    $scope.webosSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.webosData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.webosSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.webosData.map(function(obj){
                    $scope.webosSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.webosSsodt.label = "webos";
                $scope.webosSsodt.category = "Device Type";
                if($scope.webosData.length > 0){
                  $scope.curDCData.ssodt.push($scope.webosSsodt);
                }
              } else if(key == "chrome"){
                $scope.chromeData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 4){
                    return obj;
                  }
               });
                $scope.online = $scope.chromeData.map(function(obj){
                  if(obj.s == 1){
                    $scope.chromeSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.chromeData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.chromeSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.chromeData.map(function(obj){
                    $scope.chromeSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.chromeSsodt.label = "chrome";
                $scope.chromeSsodt.category = "Device Type";
                if($scope.chromeData.length > 0){
                  $scope.curDCData.ssodt.push($scope.chromeSsodt);
                }
              } else if(key == "mc"){
                $scope.mcData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 7){
                    return obj;
                  }
               });
                $scope.online = $scope.mcData.map(function(obj){
                  if(obj.s == 1){
                    $scope.mcSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.mcData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.mcSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.mcData.map(function(obj){
                    $scope.mcSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.mcSsodt.label = "mc";
                $scope.mcSsodt.category = "Device Type";
                if($scope.mcData.length > 0){
                  $scope.curDCData.ssodt.push($scope.mcSsodt);
                }
              } else if(key == "desktop"){
                $scope.desktopData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 8){
                    return obj;
                  }
               });
                $scope.online = $scope.desktopData.map(function(obj){
                  if(obj.s == 1){
                    $scope.desktopSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.desktopData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.desktopSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.desktopData.map(function(obj){
                    $scope.desktopSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.desktopSsodt.label = "desktop";
                $scope.desktopSsodt.category = "Device Type";
                if($scope.desktopData.length > 0){
                  $scope.curDCData.ssodt.push($scope.desktopSsodt);
                }
              } else if(key == "epd"){
                $scope.epdData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 9){
                    return obj;
                  }
               });
                $scope.online = $scope.epdData.map(function(obj){
                  if(obj.s == 1){
                    $scope.epdSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.epdData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.epdSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.epdData.map(function(obj){
                    $scope.epdSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.epdSsodt.label = "epd";
                $scope.epdSsodt.category = "Device Type";
                if($scope.epdData.length > 0){
                  $scope.curDCData.ssodt.push($scope.epdSsodt);
                }
              } else if(key == "gf"){
                $scope.gfData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 10){
                    return obj;
                  }
               });
                $scope.online = $scope.gfData.map(function(obj){
                  if(obj.s == 1){
                    $scope.gfSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.gfData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.gfSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.gfData.map(function(obj){
                    $scope.gfSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.gfSsodt.label = "gf";
                $scope.gfSsodt.category = "Device Type";
                if($scope.gfData.length > 0){
                  $scope.curDCData.ssodt.push($scope.gfSsodt);
                }
              } else if(key == "v"){
                $scope.vData = $scope.curDCData.d.filter(function(obj){
                  if(obj.t == 11){
                    return obj;
                  }
               });
                $scope.online = $scope.vData.map(function(obj){
                  if(obj.s == 1){
                    $scope.vSsodt.online.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.offline = $scope.vData.map(function(obj){
                  if(obj.s == 0 || obj.s == 2){
                    $scope.vSsodt.offline.push(obj.i);
                    return obj.i;
                  }
               });
                $scope.total = $scope.vData.map(function(obj){
                    $scope.vSsodt.total.push(obj.i);
                    return obj.i;
               });

                $scope.vSsodt.label = "v";
                $scope.vSsodt.category = "Device Type";
                if($scope.vData.length > 0){
                  $scope.curDCData.ssodt.push($scope.vSsodt);
                }
              }
            }
         })


          /*For Online/Ofline Device Type Summary*/
          if($scope.dashboard.dbd.ssodt && $scope.curDCData.ssodt){
            $scope.ssodtArr = [];
            var ssodtOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                pointFormat:'{point.status}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };
            angular.forEach($scope.curDCData.ssodt, function(ssodt, index){
              var curFilertdSSODT = $filter("filter")($scope.dashboard.dGrid, {type:'ssodt',category:ssodt.category, label:ssodt.label }, true);
              if(curFilertdSSODT.length){
                if($filter('lowercase')(ssodt.category) == $filter('lowercase')(curFilertdSSODT[0].category) && $filter('lowercase')(ssodt.label) == $filter('lowercase')(curFilertdSSODT[0].label)){
                  curFilertdSSODT[0].subType = index;
                  $scope.dGridArr.push(curFilertdSSODT[0]);
                } else{
                }
              } else{
                $scope.dGridArr.push({x:0, y:16, width:3, height:2, minH:2, type:'ssodt', subType:index, label:ssodt.label, category:ssodt.category});
              }
           });

            angular.forEach($scope.curDCData.ssodt, function(ssodt, index){
              var curSsodtLabel = "";
              var ssodtOnline = "";
              var ssodtOffline = "";
              if(ssodt.label == 'mp'){
                curSsodtLabel = $filter("translate")('d.label.1.1');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.mp.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.mp.off;
              } else if(ssodt.label == 'webos'){
                curSsodtLabel = $filter("translate")('d.label.1.5');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.webos.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.webos.off;
              } else if(ssodt.label == 'tizen'){
                curSsodtLabel = $filter("translate")('d.label.1.6');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.tz.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.tz.off;
              } else if(ssodt.label == 'mc'){
                curSsodtLabel = $filter("translate")('d.label.1.4');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.mc.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.mc.off;
              } else if(ssodt.label == 'gf'){
                curSsodtLabel = $filter("translate")('d.label.1.2');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.geo.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.geo.off;
              } else if(ssodt.label == 'v'){
                curSsodtLabel = $filter("translate")('d.label.1.3');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.vd.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.vd.off;
              } else if(ssodt.label == 'desktop'){
                curSsodtLabel = $filter("translate")('d.label.1.7');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.de.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.de.off;
              } else if(ssodt.label == 'epd'){
                curSsodtLabel = $filter("translate")('d.label.1.8');
                ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.epd.on;
                ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.epd.off;
              }
              var curSsodtArr = [
                {name:curSsodtLabel, status:$filter("translate")('d.tool.1'), category:ssodt.category, y:ssodt.online.length, yl:ssodt.online, total:ssodt.total, color:ssodtOnline },
                {name:curSsodtLabel, status:$filter("translate")('d.tool.2'), category:ssodt.category, y:ssodt.offline.length, yl:ssodt.offline, total:ssodt.total, color:ssodtOffline }
              ];
              $scope.ssodtArr.push(
                {
                  options:ssodtOpts,
                  series:[{
                    size:'100%',
                    data:curSsodtArr,
                    name:curSsodtLabel,
                    innerSize:'50%',
                    cursor:'pointer',
                    colorByPoint:true,
                    showInLegend:false,
                    point:{
                      events:{
                        click:function(event){
                          $scope.detailsOpen('ssodt', this.category, this.yl, this.status, this.name);
                        }
                      }
                    }
                  }],
                  title:' ',
                  xAxis:{categories:[] },
                  yAxis:{title:' ' },
                }
              );
           });
          }


          /*Status of Specific Device Type*/
          $scope.ssdtSettings = $scope.dashboard.ssdt;
          if($scope.dashboard.dbd.ssdt && $scope.dashboard.ssdt && $scope.dashboard.ssdt.data){
            DashboardSrv.getKeyType($scope.ssdtSettings, "ssdt").then(
              function(data){
                $scope.dashboardLoading = false;
                $scope.ssdt = data;
                $scope.curDCData.ssdt = [];

                angular.forEach($scope.ssdt, function(ssdt, key){
                  for (var i = 0; i < ssdt.d.length; i++){
                    var ssdtOnline = []
                    var ssdtOffline = []
                      for (var j = 0; j < ssdt.d[i].dId.length; j++){
                        $scope.ssdtData = $scope.curDCData.d.filter(function(obj){
                          if(obj.i == ssdt.d[i].dId[j]){
                            return obj;
                          }
                       });
                        $scope.online = $scope.ssdtData.map(function(obj){
                          if(obj.s == 1){
                            ssdtOnline.push(obj.i);
                            return obj.i;
                          }
                       });
                        $scope.offline = $scope.ssdtData.map(function(obj){
                          if(obj.s == 0 || obj.s == 2){
                            ssdtOffline.push(obj.i);
                            return obj.i;
                          }
                       });
                      }
                    $scope.curDCData.ssdt.push({online:ssdtOnline.filter(Number) , offline:ssdtOffline.filter(Number),total:ssdt.d[i].dId, label:ssdt.d[i].value, category:ssdt.label});
                  }
               })
                $scope.ssdtArr = [];
                var ssdtOpts = {
                  chart:{
                    width:120,
                    height:120,
                    type:'pie',
                    plotShadow:false,
                    plotBorderWidth:0,
                    margin:[0, 0, 0, 0],
                    backgroundColor:'rgba(0,0,0,0)'
                  },
                  navigation:{
                    buttonOptions:{
                      enabled:false
                    }
                  },
                  tooltip:{
                    headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                    pointFormat:'{point.status}:<b>{point.y}</b>'
                  },
                  plotOptions:{
                    pie:{
                      cursor:'pointer',
                      dataLabels:{
                        size:'100%',
                        distance:-11,
                        enabled:true,
                        style:{
                          color:'white',
                          fontSize:'10px',
                          textShadow:'0 1px 1px #333333'
                        },
                        formatter:function(){
                          return this.y;
                        }
                      },
                      showInLegend:false,
                      center:['50%', '50%']
                    }
                  }
                };

                angular.forEach($scope.curDCData.ssdt, function(ssdt, index){
                  var curFilertdSSDT = $filter("filter")($scope.dashboard.dGrid, {type:"ssdt", category:ssdt.category, label:ssdt.label }, true);
                  if(curFilertdSSDT.length){
                    if($filter('lowercase')(ssdt.category) == $filter('lowercase')(curFilertdSSDT[0].category) && $filter('lowercase')(ssdt.label) == $filter('lowercase')(curFilertdSSDT[0].label)){
                      curFilertdSSDT[0].subType = index;
                      $scope.dGridArr.push(curFilertdSSDT[0]);
                    }
                  } else{
                    $scope.dGridArr.push({x:0, y:16, width:3, height:2, minH:2, type:'ssdt', subType:index, label:ssdt.label, category:ssdt.category});
                  }
               });

                angular.forEach($scope.curDCData.ssdt, function(ssdt, index){
                  var curSsdtArr = [
                    {name:ssdt.label, status:$filter("translate")('d.tool.1'), category:ssdt.category, y:ssdt.online.length, yl:ssdt.online, total:ssdt.total, color:$scope.dashboard.dsg.pieColors.ssdt.on },
                    {name:ssdt.label, status:$filter("translate")('d.tool.2'), category:ssdt.category, y:ssdt.offline.length, yl:ssdt.offline, total:ssdt.total, color:$scope.dashboard.dsg.pieColors.ssdt.off }
                  ];
                  $scope.ssdtArr.push(
                    {
                      options:ssdtOpts,
                      series:[{
                        size:'100%',
                        data:curSsdtArr,
                        name:ssdt.category,
                        innerSize:'50%',
                        cursor:'pointer',
                        colorByPoint:true,
                        showInLegend:false,
                        point:{
                          events:{
                            click:function(event){
                              $scope.detailsOpen('ssdt', this.category, this.yl, this.status, this.name);
                            }
                          }
                        }
                      }],
                      title:' ',
                      xAxis:{categories:[] },
                      yAxis:{title:' ' },
                    }
                  );
               });
              },
              function(err){
                $log.error(err);
              }
            );
          }


            /*Online/Offline Status of Specific Device Properties*/
          $scope.ssdptSettings = $scope.dashboard.ssdpt;
          if($scope.dashboard.dbd.ssdpt && $scope.dashboard.ssdpt && $scope.dashboard.ssdpt.data){
            DashboardSrv.getKeyType($scope.ssdptSettings, "ssdpt").then(
              function(data){
                $scope.dashboardLoading = false;
                $scope.ssdpt = data;
                $scope.curDCData.ssdpt = []

                angular.forEach($scope.ssdpt, function(ssdpt, key){
                  $scope.tempSsdpt = {online:[], offline:[],total:[]};
                  for (var i = 0; i < ssdpt.d.length; i++){
                    $scope.online = [];
                    $scope.offline = [];
                    for (var j = 0; j < ssdpt.d[i].dId.length; j++){
                      $scope.onOff = $scope.curDCData.d.filter(function(obj){
                        if(obj.i == ssdpt.d[i].dId[j]){
                          if(obj.s == 1){
                            $scope.online.push(obj.i);
                          } else if(obj.s == 0 || obj.s == 2){
                            $scope.offline.push(obj.i);
                          }
                        }
                     });
                    }
                    $scope.curDCData.ssdpt.push({online:$scope.online.filter(Number) , offline:$scope.offline.filter(Number) ,total:ssdpt.d[i].dId, label:ssdpt.d[i].value, category:ssdpt.label,id:ssdpt.id});
                  }
               })
                $scope.ssdptArr = [];
                var ssdptOpts = {
                  chart:{
                    width:120,
                    height:120,
                    type:'pie',
                    plotShadow:false,
                    plotBorderWidth:0,
                    margin:[0, 0, 0, 0],
                    backgroundColor:'rgba(0,0,0,0)'
                  },
                  navigation:{
                    buttonOptions:{
                      enabled:false
                    }
                  },
                  tooltip:{
                    headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                    pointFormat:'{point.status}:<b>{point.y}</b>'
                  },
                  plotOptions:{
                    pie:{
                      cursor:'pointer',
                      dataLabels:{
                        size:'100%',
                        distance:-11,
                        enabled:true,
                        style:{
                          color:'white',
                          fontSize:'10px',
                          textShadow:'0 1px 1px #333333'
                        },
                        formatter:function(){
                          return this.y;
                        }
                      },
                      showInLegend:false,
                      center:['50%', '50%']
                    }
                  }
                };

                angular.forEach($scope.curDCData.ssdpt, function(ssdpt, index){
                  var curFilertdSSDPT = $filter("filter")($scope.dashboard.dGrid, {type:"ssdpt", category:ssdpt.category, label:ssdpt.label }, true);

                  if(curFilertdSSDPT.length){
                    if($filter('lowercase')(ssdpt.category) == $filter('lowercase')(curFilertdSSDPT[0].category) && $filter('lowercase')(ssdpt.label) == $filter('lowercase')(curFilertdSSDPT[0].label)){
                      curFilertdSSDPT[0].subType = index;
                      $scope.dGridArr.push(curFilertdSSDPT[0]);
                    }
                  } else{
                    $scope.dGridArr.push({x:0, y:16, width:3, height:2, minH:2, type:'ssdpt', subType:index, label:ssdpt.label, category:ssdpt.category});
                  }
               });

                angular.forEach($scope.curDCData.ssdpt, function(ssdpt, index){
                  var curSsdptArr = [
                    {name:ssdpt.label, status:$filter("translate")('d.tool.1'), category:ssdpt.category, y:ssdpt.online.length, yl:ssdpt.online, total:ssdpt.online.concat(ssdpt.offline), color:$scope.dashboard.dsg.pieColors.ssdpt.on },
                    {name:ssdpt.label, status:$filter("translate")('d.tool.2'), category:ssdpt.category, y:ssdpt.offline.length, yl:ssdpt.offline, total:ssdpt.online.concat(ssdpt.offline), color:$scope.dashboard.dsg.pieColors.ssdpt.off }
                  ];
                  $scope.ssdptArr.push(
                    {
                      options:ssdptOpts,
                      series:[{
                        size:'100%',
                        data:curSsdptArr,
                        name:ssdpt.category,
                        innerSize:'50%',
                        cursor:'pointer',
                        colorByPoint:true,
                        showInLegend:false,
                        point:{
                          events:{
                            click:function(event){
                              $scope.detailsOpen('ssdpt', this.category, this.yl, this.status, this.name);
                            }
                          }
                        }
                      }],
                      title:' ',
                      xAxis:{categories:[] },
                      yAxis:{title:' ' },
                    }
                  );
               });
              },
              function(err){
                $log.error(err);
              }
            );
          }


          /*Content Confirmation Summary new start*/
          if($scope.dashboard.dbd.ccs && ($scope.curDCData.ccs.down.length || $scope.curDCData.ccs.no.length || $scope.curDCData.ccs.rem.length)){
            $scope.downArr = [];
            var downOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };

            var curDownArr = [
              {name:$filter("translate")('db.body.13.1'), y:$scope.curDCData.ccs.down.length, yl:$scope.curDCData.ccs.down, color:$scope.dashboard.dsg.pieColors.ccs.d },
              {name:$filter("translate")('db.body.13.2'), y:$scope.curDCData.ccs.rem.length, yl:$scope.curDCData.ccs.rem, color:$scope.dashboard.dsg.pieColors.ccs.r },
              {name:$filter("translate")('db.body.13.3'), y:$scope.curDCData.ccs.no.length, yl:$scope.curDCData.ccs.no, color:$scope.dashboard.dsg.pieColors.ccs.ns }
            ];

            $scope.downArr = {
              options:downOpts,
              series:[{
                size:'100%',
                data:curDownArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.detailsOpen('ccs', this.name, this.yl);
                    }
                  }
                }
              }],
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' },
            };
          }

          /*Device Temperature Summary new start*/
          if($scope.dashboard.dbd.dtps || $scope.dashboard.dbd.dtpl){
            DashboardSrv.getTempterature().then(
              function(data){
                /*For Devices Temperature*/
                $scope.temperature = data;
                $scope.dtplc = $scope.dashboard.dsg.dtpl.dtpsc;
                $scope.dtpld = $scope.dashboard.dsg.dtpl.dtpsd;
                $scope.curDCData.dtps = {c:[], d:[], n:[], totalCount:[]};
                var tmKeys = Object.keys($scope.temperature);
                var matchMac = []
                angular.forEach(tmKeys, function(val){
                  matchMac.push({t:$scope.temperature[val], h:val});
               });
                angular.forEach($scope.curDCData.d, function(d){
                  d.tms = 0;
                  d.tmp = 0;
                  angular.forEach(matchMac, function(t){
                    if(d.h == t.h){
                      d.tmp = t.t;
                      if(t.t >= $scope.dtplc && t.t < $scope.dtpld){
                        d.tms = 1;
                      } else if(t.t >= $scope.dtpld){
                        d.tms = 2;
                      } else{
                        d.tms = 0;
                      }
                    }
                 });

                  if(d.tms == 1){
                    $scope.curDCData.dtps.c.push(d.i);
                  } else if(d.tms == 2){
                    $scope.curDCData.dtps.d.push(d.i);
                  } else{
                    $scope.curDCData.dtps.n.push(d.i);
                  }
                  $scope.allDeviceListTemp.push({id:d.i,dtplTemp:d.tmp})
               });
                $scope.curDCData.dtps.totalCount = $scope.curDCData.dtps.n.length + $scope.curDCData.dtps.c.length + $scope.curDCData.dtps.d.length;
                if($scope.dashboard.dbd.dtps){
                  $scope.tempArr = [];
                  var tempOpts = {
                    chart:{
                      width:120,
                      height:120,
                      type:'pie',
                      plotShadow:false,
                      plotBorderWidth:0,
                      margin:[0, 0, 0, 0],
                      backgroundColor:'rgba(0,0,0,0)'
                    },
                    navigation:{
                      buttonOptions:{
                        enabled:false
                      }
                    },
                    tooltip:{
                      pointFormat:'{series.name}:<b>{point.y}</b>'
                    },
                    plotOptions:{
                      pie:{
                        cursor:'pointer',
                        dataLabels:{
                          size:'100%',
                          distance:-11,
                          enabled:true,
                          style:{
                            color:'white',
                            fontSize:'10px',
                            textShadow:'0 1px 1px #333333'
                          },
                          formatter:function(){
                            return this.y;
                          }
                        },
                        showInLegend:false,
                        center:['50%', '50%']
                      }
                    }
                  };

                  var curTempArr = [
                    {name:$filter("translate")('db.body.14.1'), y:$scope.curDCData.dtps.n.length, yl:$scope.curDCData.dtps.n, t:"n", color:$scope.dashboard.dsg.pieColors.dtps.no },
                    {name:$filter("translate")('db.body.14.2'), y:$scope.curDCData.dtps.c.length, yl:$scope.curDCData.dtps.c, t:"c", color:$scope.dashboard.dsg.pieColors.dtps.c },
                    {name:$filter("translate")('db.body.14.3'), y:$scope.curDCData.dtps.d.length, yl:$scope.curDCData.dtps.d, t:"d", color:$scope.dashboard.dsg.pieColors.dtps.d }
                  ];

                  $scope.tempArr = {
                    options:tempOpts,
                    series:[{
                      size:'100%',
                      data:curTempArr,
                      name:$filter("translate")("cl.widget.count.1"),
                      innerSize:'50%',
                      cursor:'pointer',
                      colorByPoint:true,
                      showInLegend:false,
                      point:{
                        events:{
                          click:function(event){
                            $scope.detailsOpen('dtps', this.t, this.yl);
                          }
                        }
                      }
                    }],
                    title:' ',
                    xAxis:{categories:[] },
                    yAxis:{title:' ' },
                  };
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }

          /*Devices Type Summary*/
          if($scope.dashboard.dbd.dts && $scope.curDCData.dts){
            $scope.dtsArr = [];
            var dtsOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };

            var curDTSArr = [{name:$filter("translate")('d.label.1.1'), y:$scope.curDCData.dts.mp.length, yl:$scope.curDCData.dts.mp, t:"mp", color:$scope.dashboard.dsg.pieColors.dts.mp}];
            if($scope.auth.upermissions.webos){
              curDTSArr.push({name:$filter("translate")('d.label.1.5'), y:$scope.curDCData.dts.webos.length, yl:$scope.curDCData.dts.webos, t:"webos", color:$scope.dashboard.dsg.pieColors.dts.webos});
            }
            if($scope.auth.upermissions.mc){
              curDTSArr.push({name:$filter("translate")('d.label.1.4'), y:$scope.curDCData.dts.mc.length, yl:$scope.curDCData.dts.mc, t:"mc", color:$scope.dashboard.dsg.pieColors.dts.mc});
            }
            if($scope.auth.upermissions.tizen){
              curDTSArr.push({name:$filter("translate")('d.label.1.6'), y:$scope.curDCData.dts.tizen.length, yl:$scope.curDCData.dts.tizen, t:"tizen", color:$scope.dashboard.dsg.pieColors.dts.tz});
            }
            if($scope.auth.upermissions.gf){
              curDTSArr.push({name:$filter("translate")('d.label.1.2'), y:$scope.curDCData.dts.gf.length, yl:$scope.curDCData.dts.gf, t:"gf", color:$scope.dashboard.dsg.pieColors.dts.geo});
            }
            if($scope.auth.upermissions.vd){
              curDTSArr.push({name:$filter("translate")('d.label.1.3'), y:$scope.curDCData.dts.v.length, yl:$scope.curDCData.dts.v, t:"v", color:$scope.dashboard.dsg.pieColors.dts.vd});
            }
            if($scope.auth.upermissions.desktop){
              curDTSArr.push({name:$filter("translate")('d.label.1.7'), y:$scope.curDCData.dts.desktop.length, yl:$scope.curDCData.dts.desktop, t:"desktop", color:$scope.dashboard.dsg.pieColors.dts.de});
            }
            if($scope.auth.upermissions.epd){
              curDTSArr.push({name:$filter("translate")('d.label.1.8'), y:$scope.curDCData.dts.epd.length, yl:$scope.curDCData.dts.epd, t:"epd", color:$scope.dashboard.dsg.pieColors.dts.epd});
            }

            $scope.dtsArr = {
              options:dtsOpts,
              series:[{
                size:'100%',
                data:curDTSArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.detailsOpen('dts', this.t, this.yl);
                    }
                  }
                }
              }],
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' },
            };
          }

          /*Content Confirmation dccl*/
          if($scope.dashboard.dbd.dccl && $scope.curDCData.dccl.totalCount > 0){
            $scope.dcclArr = [];
            var dcclOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>',
                outside:true
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  borderWidth:2,
                  dataLabels:{
                    overflow:"allow",
                    size:'100%',
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };

            var curDcclArr = [
              {
                label:"cc", //confirm content
                name:$filter("translate")("db.body.13.1"),
                y:$scope.curDCData.dccl.oncc.length + $scope.curDCData.dccl.ofcc.length,
                yl:$scope.curDCData.dccl.oncc.concat($scope.curDCData.dccl.ofcc),
                color:$scope.dashboard.dsg.pieColors.dccl.cc,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"poncc", y:$scope.curDCData.dccl.oncc.length, yl:$scope.curDCData.dccl.oncc, color:$scope.dashboard.dsg.pieColors.dccl.oncc },
                    {name:$filter("translate")("d.tool.2"), label:"pofcc", y:$scope.curDCData.dccl.ofcc.length, yl:$scope.curDCData.dccl.ofcc, color:$scope.dashboard.dsg.pieColors.dccl.ofcc }
                  ]
                }
              },
              {
                label:"ncc",  //unconfirm content
                name:$filter("translate")("db.body.21.7"),
                y:$scope.curDCData.dccl.onncc.length + $scope.curDCData.dccl.ofncc.length,
                yl:$scope.curDCData.dccl.onncc.concat($scope.curDCData.dccl.ofncc),
                color:$scope.dashboard.dsg.pieColors.dccl.ncc,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"ponncc", y:$scope.curDCData.dccl.onncc.length, yl:$scope.curDCData.dccl.onncc, color:$scope.dashboard.dsg.pieColors.dccl.onncc },
                    {name:$filter("translate")("d.tool.2"), label:"pofncc", y:$scope.curDCData.dccl.ofncc.length, yl:$scope.curDCData.dccl.ofncc, color:$scope.dashboard.dsg.pieColors.dccl.ofncc }
                  ]
                }
              },
              {
                label:"nsd",   //without schedule
                name:$filter("translate")("db.body.21.6"),
                y:$scope.curDCData.dccl.nosd.length,
                yl:$scope.curDCData.dccl.nosd,
                color:$scope.dashboard.dsg.pieColors.dccl.nsd,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"onnsd", y:$scope.curDCData.dccl.onnsd.length, yl:$scope.curDCData.dccl.onnsd, color:$scope.dashboard.dsg.pieColors.dccl.onnsd },
                    {name:$filter("translate")("d.tool.2"), label:"ofnsd", y:$scope.curDCData.dccl.ofnsd.length, yl:$scope.curDCData.dccl.ofnsd, color:$scope.dashboard.dsg.pieColors.dccl.ofnsd },
                  ]
                }
              }
            ];
            var
              innerData = [],
              outerData = [],
              drillDataLen,
              brightness;

            // Build the data arrays
            for (var i = 0; i < curDcclArr.length; i += 1){
              // add inner data
              innerData.push({
                name:curDcclArr[i].name,
                label:curDcclArr[i].label,
                y:curDcclArr[i].y,
                yl:curDcclArr[i].yl,
                color:curDcclArr[i].color
             });

              // add outer data
              drillDataLen = curDcclArr[i].drilldown.data.length;
              for (var j = 0; j < drillDataLen; j += 1){
                brightness = 0.2 - (j / drillDataLen) / 5;
                outerData.push({
                  name:curDcclArr[i].drilldown.data[j].name,
                  label:curDcclArr[i].drilldown.data[j].label,
                  y:curDcclArr[i].drilldown.data[j].y,
                  yl:curDcclArr[i].drilldown.data[j].yl,
                  color:curDcclArr[i].drilldown.data[j].color
               });
              }
            }
            $scope.dcclArr = {
              options:dcclOpts,
              series:[
                {//inner
                  name:$filter("translate")("cl.widget.count.1"),
                  data:innerData,
                  size:'55%',
                  dataLabels:{
                    formatter:function(){
                      return this.y
                    },
                    distance:-16,
                  },
                  point:{
                    events:{
                      click:function(event){
                        $scope.detailsOpen('dccl', this.label, this.yl);
                      }
                    }
                  }
                },
                {//outer
                  name:$filter("translate")("cl.widget.count.1"),
                  data:outerData,
                  size:'100%',
                  innerSize:'55%',
                  dataLabels:{
                    formatter:function(){
                      return this.y
                    },
                    distance:-11,
                  },
                  id:'versions',
                  point:{
                    events:{
                      click:function(event){
                        $scope.detailsOpen('dccl', this.label, this.yl);
                      }
                    }
                  }
                }
              ],
              title:' ',
              xAxis:{},
              yAxis:{title:' ' },
            }
          }

          /*Device Online*/
          if($scope.dashboard.dbd.ds && ($scope.curDCData.ds.online.length || $scope.curDCData.ds.offline.length || $scope.curDCData.ds.nc.length)){
            $scope.curDCData.ds.total = $scope.curDCData.ds.online.concat($scope.curDCData.ds.offline, $scope.curDCData.ds.nc);
            $scope.dsArr = [];
            var dsOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };
            var curDSArr = [
              {name:$filter("translate")('d.tool.1'), y:$scope.curDCData.ds.online.length, yl:$scope.curDCData.ds.online, color:$scope.dashboard.dsg.pieColors.ds.on, fType:"online" },
              {name:$filter("translate")('d.tool.2'), y:$scope.curDCData.ds.offline.length, yl:$scope.curDCData.ds.offline, color:$scope.dashboard.dsg.pieColors.ds.off, fType:"offline" },
              {name:$filter("translate")('d.tool.21'), y:$scope.curDCData.ds.nc.length, yl:$scope.curDCData.ds.nc, color:$scope.dashboard.dsg.pieColors.ds.nc, fType:"nc" }
            ];

            $scope.dsArr = {
              options:dsOpts,
              series:[{
                size:'100%',
                data:curDSArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.detailsOpen('ds', this.name, this.yl, '', this.name, '', this.fType);
                    }
                  }
                }
              }],
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' },
            };
          }

          $scope.mapLoading = false;
          $scope.refreshing = false;

          if($scope.auth.uservices.m == "b"){
            $scope.tryLoadBingMap();
          } else{
            NgMap.getMap().then(function(map){
              dashboardCtrl.map = map;
              if($scope.markerList.length == 1 && map.getZoom() > 4){
                setTimeout(function(){
                  map.setZoom(7);
                }, 200);
              }
           });
          }
          setTimeout(function(){
            if($rootScope.isDBEdit == "e"){
              $scope.dgOptionsFx('e');
            }
          }, 500);
        },
        function(err){
          $log.error(err);
        }
      );

    }

    $scope.detailsOpen = function(caller, label, arr, status, name, tId, fType, isDeviceId){
      // console.warn(caller, label, arr, status, name, tId, fType);
      $scope.detailsObj = {caller:caller, label:label, dCount:arr.length, deviceDetails:[], status:status, name:name, tId:tId, fType:fType, isDeviceId:isDeviceId};
      $scope.tDetailsObj = {caller:caller, label:label, arr:arr, status:status, name:name, tId:tId, fType:fType};

      if(caller == "dccl" && label != "offline"){
        if(label == "onncc"){
          $scope.stringIds = arr = $scope.arraytoStringFx(arr);
        } else{
          $scope.stringIds = arr = $scope.arraytoStringFx(arr);
        }
      }

      if(arr.length){
        $scope.detailLoading = true;
        if($scope.detailsObj.caller == "ot"){
          $scope.detailsObj.tId = tId;
          if(isDeviceId){
            $scope.stringIds = arr = $scope.arraytoStringFx(arr); /*Array to String common with ID*/
            $scope.payloadObj = {devices:arr};
          }else {
            $scope.stringIds = arr = $scope.arraytoStringMacFx(arr); /*Array to String common with MAC*/
            $scope.payloadObj = {macs:arr};
          }
        } else{
          $scope.payloadObj = {devices:arr};
        }
        DashboardSrv.deviceDetail($scope.payloadObj).then(
          function(data){
            var source = document.getElementById("source");
            $scope.textValue = source.innerText;
            $scope.detailsObj.deviceDetails = data;

            /** Below code is commented because we are now sending device ids acc to status */
              // if($scope.detailsObj.caller == "ds" && angular.lowercase(label) == "total"){
              //   $scope.detailsObj.deviceDetails = data;
              // }
              // if($scope.detailsObj.caller != "ds"){
              //   $scope.detailsObj.deviceDetails = data;
              // }
              // angular.forEach(data, function(device){
              //   if($scope.detailsObj.caller == "ds" && (angular.lowercase(label) == "online" || fType == "online")){
              //     if(device.status == "online"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase(label) == "offline" || fType == "offline")){
              //     if(device.status == "offline"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   }
              // });
            $scope.detailLoading = false;
          },
          function(err){
            $scope.detailLoading = false;
            $log.error(err);
          }
        );
        $rootScope.isDInterval = $interval(function(){
          DashboardSrv.deviceDetail($scope.payloadObj).then(
            function(data){
              $scope.detailsObj.deviceDetails = [];
              $scope.detailsObj.deviceDetails = data;

              /** Below code is commented because we are now sending device ids acc to status */
                // if($scope.detailsObj.caller == "ds" && angular.lowercase($scope.tDetailsObj.label) == "total"){
                // }
                // if($scope.detailsObj.caller != "ds"){
                //   $scope.detailsObj.deviceDetails = data;
                // }
                // angular.forEach(data, function(device){
                //   if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "online" || $scope.tDetailsObj.fType == "online")){
                //     if(device.status == "online"){
                //       $scope.detailsObj.deviceDetails.push(device);
                //     }
                //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "offline" || $scope.tDetailsObj.fType == "offline")){
                //     if(device.status == "offline"){
                //       $scope.detailsObj.deviceDetails.push(device);
                //     }
                //   }
                // });

              if(caller == "dccl"){
                if(label == "ofncc" || label == "ofcc"){
                  $scope.offDArr = [];
                  angular.forEach(data, function(device){
                    if(device.status == "offline"){
                      $scope.offDArr.push(device);
                    }
                 });
                  $scope.detailsObj.deviceDetails = $scope.offDArr;
                } else if(label == "onncc" || label == "oncc"){
                  $scope.onDArr = [];
                  angular.forEach(data, function(device){
                    if(device.status == "online"){
                      $scope.onDArr.push(device);
                    }
                 });
                  $scope.detailsObj.deviceDetails = $scope.onDArr;
                }
              }
              $scope.detailLoading = false;
              $scope.loadingDetail = false;
            },
            function(err){
              $scope.detailloadingDetail = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }, 10000);
      }
      ngDialog.open({
        template:'app/dashboard/popup/detailList.html',
        width:700,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          $interval.cancel($rootScope.isDInterval);
          $scope.uiVersionFx();
          $scope.getDashboard();
          if($rootScope.isDBEdit == "e"){
            $scope.dgOptionsFx("e");
          }
        }
     });
    }

    $scope.tryLoadBingMap = function(){
      if($scope.isMapScriptLoaded){
        $scope.azureMapFx();
      } else{
        setTimeout(function(){$scope.tryLoadBingMap() }, 1000);
      }
    }

    $scope.deviceTicketOpen = function(count, type){
      $scope.dataTkObj = {count:count, type:type, ticket:[] };
      if(type == 'o'){
        $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.3');
      } else{
        $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.4');
      }
      $scope.popupLoading = true;
      DashboardSrv.getTicket($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId, $scope.dataTkObj.type).then(
        function(data){
          $scope.popupLoading = false;
          $scope.dataTkObj.ticket = data;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/dashboard/popup/tickets.html',
        width:900,
        scope:$scope,
        data:$scope.dataTkObj,
        closeByDocument:false
     });
    }

    $scope.ticketDetailsOpen = function(thid, tid, devices){
      $scope.dataTkDetails = {thid:thid, tid:tid, iFrameUrl:"", dIds:[] };
      $scope.popupInLoading = false;
      if($scope.auth.uType == 4 && devices.length){
        $scope.popupInLoading = true;
        $scope.arraytoStringFx(devices);
        var deviceIds = $scope.stringIds;
        DashboardSrv.deviceDetail({devices:deviceIds}).then(
          function(data){
            $scope.popupInLoading = false;
            if(data.length && data.length == devices.length){
              $scope.dataTkDetails.dIds = null;
            } else if(data.length && data.length != devices.length){
              $scope.arraytoStringFx(data);
              $scope.dataTkDetails.dIds = $scope.stringIds;
            } else{
              $scope.dataTkDetails.dIds = 0;
            }
            $scope.ticketDetailsFx();
          },
          function(err){
            $scope.popupInLoading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.dataTkDetails.dIds = null;
        $scope.ticketDetailsFx();
      }
    }
    $scope.ticketDetailsFx = function(){
      $scope.hostURL = $location.protocol() + "://" + $location.host();
      $scope.timestamp = moment().format('x');
      $scope.dataTkDetails.iFrameUrl = $scope.auth.sd.url + "ticketDetail/?tId=" + $scope.dataTkDetails.thid + "&ids=" + $scope.dataTkDetails.dIds + "&uName=" + $scope.auth.uname + "&email=" + $scope.auth.email + "&uId=" + $scope.auth.uid + "&hostURL=" + $scope.hostURL + "&" + $scope.timestamp;
      ngDialog.open({
        template:'app/dashboard/popup/ticketDetails.html',
        width:"98%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-preview",
     });
    }

    $scope.loadDeviceList = function(caller){
      $scope.getNewApiFx(caller);
    }

    $scope.loadMoreDevices = function(){
      if($scope.deviceList.length == $scope.dashboard.d.totalCount){
        $scope.allDevicesLoaded = true;
      }

      if(!$scope.allDevicesLoaded){
        DashboardSrv.loadMoreDevices($scope.deviceList.length).then(
          function(data){
            $scope.deviceList = $scope.deviceList.concat(data.device);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.loadMoreLogs = function(count){
      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;
      if(count == 0){
        $scope.searchText.log = "";
        $scope.allLogsLoaded = false;
        $scope.logList = [];
      }
      if(!$scope.allLogsLoaded && !$scope.logLoading){
        $scope.logLoading = true;
        DashboardSrv.loadMoreLogs($scope.logList.length).then(
          function(data){
            $scope.logLoading = false;
            if(data.logs && data.logs.length > 0){
              $scope.logList = $scope.logList.concat(data.logs);
            } else{
              $scope.allLogsLoaded = true;
            }
          },
          function(err){
            $scope.logLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.logsOpen = function(){
      $scope.hasErr = false;
      $scope.logs = {module:"a", date:{startDate:moment().subtract(1, "day")._d, endDate:moment()._d } };
      if($scope.logList.length > 0){
        ngDialog.open({
          template:'app/common/popup/downloadLog.html',
          width:500,
          scope:$scope,
          trapFocus:false,
          data:$scope.logs,
          closeByDocument:false
       });
      }
    }

    $scope.detailedLogFx = function(data){
      $scope.detailLoading = true;
      $scope.detailedLog = {obj:data, list:[] };
      DashboardSrv.getDetailedLog(data.id).then(
        function(data){
          $scope.detailedLog.list = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );

      ngDialog.open({
        template:'app/dashboard/popup/detailedLog.html',
        width:600,
        scope:$scope,
        data:$scope.detailedLog,
        closeByDocument:false
     });
    }

    $scope.downloadListFx = function(caller, val){
      var downloadObj = {type:caller, devices:[] };
      var isPost = false;
      if(caller == "ds" || caller == "dts"){
        isPost = true;
        downloadObj.devices = val;
      } else if(caller == "rad"){
        isPost = true;
        $scope.arraytoStringFx(val); /*Array to String common*/
        downloadObj.devices = $scope.stringIds;
      } else if(caller == "dps" || caller == "ssdt" || caller == "ssodt" || caller == "dpts" || caller == "ssdpt"){
        isPost = true;
        if(caller == "dpts" || caller == "ssdpt"){
          downloadObj.id = val.id;
        }
        downloadObj.devices = {category:val.c, name:val.n, device:val.d };
      } else if(caller == "dtps"){
        isPost = true;
        downloadObj.devices = {n:val.n, c:val.c, d:val.d };
      } else if(caller == "dtpl"){
        isPost = true;
        downloadObj.devices = $scope.allDeviceListTemp;
      } else if(caller == "dccl"){
        var curOfDevices = val.offline.concat(val.online);
        angular.forEach(curOfDevices, function(device){
          downloadObj.devices.push(device);
       });
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsCC({devices:downloadObj.devices}).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:"" };
            }
          },
          function(err){
            $log.error(err);
          }
        );
        return;
      }

      if(isPost){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel(downloadObj).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:"" };
            }
          },
          function(err){
            $log.error(err);
          }
        );
        return;
      }

      if(caller == "ccs" || caller == "ccl" || caller == "dccl"){
        var curDevicesArr = [], confirmedArr = [],unconfirmedArr = [],curDevicesArr1 = [];
        angular.forEach($scope.curDCData.c, function(val){
          angular.forEach($scope.curDCData.d, function(d){
            angular.forEach(d.c, function(c){
              if(val.i == c){
                confirmedArr.push({id:d.i, label:d.l, mac:d.h, status:d.s, isConfirmed:true});
              }
           })
            angular.forEach(d.u, function(u){
              if(val.i == u){
                unconfirmedArr.push({id:d.i, label:d.l, mac:d.h, status:d.s, isConfirmed:false});
              }
           })
         })
       })
        curDevicesArr = confirmedArr.concat(unconfirmedArr)

        angular.forEach(curDevicesArr, function(item){
          $scope.isDuplicate = false;
          angular.forEach(curDevicesArr1, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
         });

          if(!$scope.isDuplicate){
            curDevicesArr1.push(item);
          }
       });
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsCC({devices:curDevicesArr1}).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:"" };
              // $scope.linkOpenFx(data.url);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }else if(caller == "cclp"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        DashboardSrv.dowanloadExcelCCL($scope.curCcl).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:"" };
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.downloadDbListFx = function(caller, subType, val, label){
      if(angular.isUndefined(subType)){
        $scope.downloadObj = {type:"", subType:$scope.detailsObj.label, devices:[] };
      } else{
        $scope.downloadObj = {type:"", subType:subType, devices:[] };
      }
      var isPost = false;
      if(caller == "ccs"){
        isPost = true;
        $scope.downloadObj.type = "ccsDevices";
      } else if(caller == "dps"){
        isPost = true;
        $scope.downloadObj.type = "dpsDevices";
      } else if(caller == "dpts"){
        isPost = true;
        $scope.downloadObj.type = "dptsDevices";
      } else if(caller == "ds"){
        isPost = true;
        $scope.downloadObj.type = "dsDevices";
      } else if(caller == "dts"){
        isPost = true;
        if($scope.downloadObj.subType == "mp"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.1');
        } else if($scope.downloadObj.subType == "webos"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.5');
        } else if($scope.downloadObj.subType == "tizen"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.6');
        } else if($scope.downloadObj.subType == "mc"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.4');
        } else if($scope.downloadObj.subType == "gf"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.2');
        } else if($scope.downloadObj.subType == "v"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.3');
        } else if($scope.downloadObj.subType == "desktop"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.7');
        } else if($scope.downloadObj.subType == "epd"){
          $scope.downloadObj.subType = $filter("translate")('d.label.1.8');
        }
        $scope.downloadObj.type = "dtsDevices";
      } else if(caller == "ssdt"){
        isPost = true;
        $scope.downloadObj.type = "ssdtDevices";
      } else if(caller == "ssdpt"){
        isPost = true;
        $scope.downloadObj.type = "ssdptDevices";
      } else if(caller == "ssodt"){
        isPost = true;
        $scope.downloadObj.type = "ssodtDevices";
      } else if(caller == "dtps"){
        isPost = true;
        if($scope.downloadObj.subType == "n"){
          $scope.downloadObj.subType = "No issues";
        } else if($scope.downloadObj.subType == "c"){
          $scope.downloadObj.subType = "Caution";
        } else if($scope.downloadObj.subType == "d"){
          $scope.downloadObj.subType = "Danger";
        }
        $scope.downloadObj.type = "dtpsDevices";
      } else if(caller == "dccl"){
        isPost = true;
        if($scope.downloadObj.subType == "cc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8');
        } else if($scope.downloadObj.subType == "poncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.1');
        } else if($scope.downloadObj.subType == "pofcc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.2');
        } else if($scope.downloadObj.subType == "oncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.1');
        } else if($scope.downloadObj.subType == "ofcc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.3');
        } else if($scope.downloadObj.subType == "ncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.1');
        } else if($scope.downloadObj.subType == "ponncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.2');
        } else if($scope.downloadObj.subType == "pofncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.3');
        } else if($scope.downloadObj.subType == "onncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.2');
        } else if($scope.downloadObj.subType == "ofncc"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.4');
        } else if($scope.downloadObj.subType == "nsd"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6');
        } else if($scope.downloadObj.subType == "onnsd"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.1');
        } else if($scope.downloadObj.subType == "ofnsd"){
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.2');
        }
        $scope.downloadObj.type = "dcclDevices";
      }
      $scope.stringIds = $scope.arraytoStringFx(val); /*Array to String common*/
      $scope.downloadObj.devices = $scope.stringIds;
      if(isPost){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel($scope.downloadObj).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:"" };
            }
          },
          function(err){
            $log.error(err);
          }
        );
        return;
      }
    }

    $scope.logsFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.logsCopy = angular.copy({date:{startDate:moment($scope.logs.date.startDate).format("L"), endDate:moment($scope.logs.date.endDate).format("L") }});
      DashboardSrv.saveLogs($scope.logsCopy).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 6027){
            $scope.hasErr = true;
          } else{
            $scope.logs.url = data.download;
            $scope.saveProcessing = false;
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    //confirmed device hide/show in cc popup
    $scope.cDToggleFx = function(event){
      $scope.cOpen = !$scope.cOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".confirm-device").toggleClass('hide');
    }
    //Unconfirmed device hide/show in cc popup
    $scope.ncDToggleFx = function(event){
      $scope.ncOpen = !$scope.ncOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".not-confirm-device").toggleClass('hide');
    }

    /*Device control*/
    $scope.cclOpen = function(devices, label){
      $scope.curCcl = {devices:devices, label:label };
      $scope.cOpen = true;
      $scope.ncOpen = true;
      $scope.cCount = $filter("filter")($scope.curCcl.devices, {isConfirmed:true }, true);
      $scope.ncCount = $filter("filter")($scope.curCcl.devices, {isConfirmed:false }, true);

      var arr = $scope.arraytoStringFx(devices);
      $rootScope.isDInterval = $interval(function(){
        DashboardSrv.deviceDetail({devices:arr}).then(
          function(data){
            if($scope.cCount.length){
              angular.forEach($scope.cCount, function(list){
                if(data.length){
                  angular.forEach(data, function(device){
                    if(device.id === list.id){
                      list.status = device.status;
                    }
                 });
                }
             });
            }
            if($scope.ncCount.length){
              angular.forEach($scope.ncCount, function(list){
                if(data.length){
                  angular.forEach(data, function(device){
                    if(device.id === list.id){
                      list.status = device.status;
                    }
                 });
                }
             });
            }

            $scope.detailLoading = false;
            $scope.loadingDetail = false;
          },
          function(err){
            $scope.detailloadingDetail = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }, 10000);
      ngDialog.open({
        template:'app/dashboard/popup/ccDevice.html',
        width:650,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          if($rootScope.isDBEdit == "e"){
            $scope.dgOptionsFx("e");
          }
          $interval.cancel($rootScope.isDInterval);
        }
     });
    }

    /*Device control*/
    $scope.deviceControlOpen = function(id, label, dType){
      $scope.curDeviceControl = {id:id, label:label, dType:dType };
      ngDialog.open({
        template:'app/devices/popup/deviceControl.html',
        width:850,
        data:$scope.curDeviceControl,
        scope:$scope,
        controller:'DeviceControlController',
        closeByDocument:false
     });
    }

    $scope.$on("$stateChangeStart", function(event, toState){
      if($scope.markerList.length > 0){
        if(dashboardCtrl.map && dashboardCtrl.map.hideInfoWindow){
          dashboardCtrl.map.hideInfoWindow('info');
        }
      }
   });
    angular.element(document).bind('keyup', function(e){
      if(e.keyCode == 27 && $scope.markerList.length > 0){//key:- escape
        dashboardCtrl.map.hideInfoWindow('info');
      }
   });

    $scope.showDetail = function(e, marker){
      $scope.markerDetail = marker;
      dashboardCtrl.map.showInfoWindow('info', this);
    };

    $scope.registerOnMapOpen = function(){
      $scope.onMap = {info:{type:"c" } };
      $scope.detailLoading = true;
      DashboardSrv.getRegisterOnMap().then(
        function(data){
          angular.forEach(data.devices, function(item){
            if(item.isRegistered == null){
              item.isRegistered = 0;
            }
         });
          $scope.rCount = $filter("filter")(data.devices, {isRegistered:1 }, true);
          $scope.urCount = $filter("filter")(data.devices, {isRegistered:0 }, true);
          if(data.devices){
            $scope.onMap.devices = data.devices;
          }
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
      ngDialog.open({
        template:'app/dashboard/popup/registerOnMap.html',
        width:"500px",
        scope:$scope,
        controller:"OnMapController",
        controllerAs:"vm",
        closeByDocument:false
     });
    }

    $scope.previewObj = {};
    $scope.previewOpen = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!caller){
        $scope.previewObj = {
          isControls:false,
          time:moment().format(),
          id:$scope.curDCData.dp.id,
          eip:$scope.curDCData.dp.eip,
          mac:$scope.curDCData.dp.mac,
          label:$scope.curDCData.dp.label,
          date:{startDate:moment().format('L'), endDate:moment().format('L')}
        };
      }
      ngDialog.close();
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"d.btn.11" | translate}}</h1> <span class="text-sm text-muted">[ {{previewObj.label}} ]</span></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cm.label.7" | translate}}</label>\
                <div class="input-group">\
                  <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                  <input type="daterange" class="form-control picker" ng-model="previewObj.date" format="MM/DD/YYYY" singleDatePicker="true" readonly="" aria-label="{{\'cm.label.7\' | translate}}" aria-labelledby="{{\'cm.label.7\' | translate}}">\
                </div>\
              </div>\
              <div class="form-group timepicker">\
                <label>{{"cm.label.8" | translate}}</label>\
                <span uib-dropdown auto-close="outsideClick" dropdown-append-to-body>\
                  <div class="input-group">\
                    <span class="input-group-addon"><span class="fa fa-clock-o" aria-hidden="true"></span></span>\
                    <input type="text" class="form-control picker" uib-dropdown-toggle ng-value="previewObj.time | date:\'shortTime\'" readonly="" aria-label="{{\'cm.label.8\' | translate}}" aria-labelledby="{{\'cm.label.8\' | translate}}">\
                  </div>\
                  <div class="dropdown-menu dropdown-to-body" uib-dropdown-menu>\
                    <div uib-timepicker ng-model="previewObj.time" hour-step="1" minute-step="5"></div>\
                  </div>\
                </span>\
              </div>\
              <div><label class="noMar"><input type="checkbox" ng-model="previewObj.isControls"><label></label> {{"d.label.28" | translate}}</label></div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="previewFx();"><span class="fa fa-film" aria-hidden="true"></span> {{"d.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">\
                <span ng-if="errType==\'date\'" aria-live="polite" role="status">{{"cm.msg.21" | translate}}</span>\
                <span ng-if="errType==\'time\'" aria-live="polite" role="status">{{"cm.msg.22" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:400,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
     });
    }
    $scope.previewFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.previewObj.date == "" || $scope.previewObj.date == null){
        $scope.hasErr = true;
        $scope.errType = "date";
        return false;
      }
      if($scope.previewObj.time == "" || $scope.previewObj.time == null){
        $scope.hasErr = true;
        $scope.errType = "time";
        return false;
      }

      $scope.curPreviewObj = angular.copy($scope.previewObj);
      $scope.curPreviewObj.timestamp = moment($scope.previewObj.date.startDate).format('MM-DD-YYYY');
      $scope.curPreviewObj.time = moment(angular.copy($scope.previewObj).time).format("HH:mm");
      $scope.curPreviewObj.offset = new Date($scope.previewObj.date.startDate).getTimezoneOffset();

      $scope.curPreviewObj.iFrameUrl = $rootScope.dPreviewPath + $scope.previewObj.mac +"&cc="+ $scope.previewObj.isControls +"&ts="+ $scope.curPreviewObj.timestamp +"&t=" + $scope.curPreviewObj.time +"&"+ new Date().getTime();

      $scope.devices = {info:{bucket:$scope.dashboard.dp.bucket, timthumb:$scope.dashboard.dp.timthumb } };
      ngDialog.close();
      ngDialog.open({
        template:'app/devices/preview/preview.html',
        width:"98%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        controller:"PreviewController",
        className:"ngdialog-theme-default ngdialog-preview",
        preCloseCallback:function(){
          $interval.cancel($rootScope.emTimer);
        }
     });
    }

    // for refresh list
    $scope.refreshPopupListFx = function(caller, stringIds, fType, isDeviceId){
      if(caller == "ticket"){
        $scope.loading = true;
        if($scope.dataTkObj.type == 'o'){
          $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.3');
        } else{
          $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.4');
        }
        $scope.popupLoading = true;
        DashboardSrv.getTicket($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId, $scope.dataTkObj.type).then(
          function(data){
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.dataTkObj.ticket = data;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.loadingDetail = true;
        if(caller == "dccl" && $scope.tDetailsObj.label != "offline"){
          $scope.arraytoStringFx($scope.tDetailsObj.arr);
          $scope.tDetailsObj.arr = stringIds;
          $scope.stringIds = stringIds;
        }
        if($scope.tDetailsObj.arr.length){
          $scope.detailLoading = true;
          if(caller == "ot"){
            $scope.detailsObj.tId = $scope.tDetailsObj.tId;
            // $scope.arraytoStringFx($scope.tDetailsObj.arr); /*Array to String common*/
            if(isDeviceId){
              $scope.arraytoStringFx($scope.tDetailsObj.arr); /*Array to String common with ID*/
              $scope.tDetailsObj.arr = stringIds;
              $scope.payloadObj = {devices:$scope.tDetailsObj.arr};
            }else {
              $scope.arraytoStringMacFx($scope.tDetailsObj.arr); /*Array to String common with MAC*/
              $scope.tDetailsObj.arr = stringIds;
              $scope.payloadObj = {macs:$scope.tDetailsObj.arr};
            }
            $scope.stringIds = stringIds;
          } else{
            $scope.payloadObj = {devices:$scope.tDetailsObj.arr};
          }


          DashboardSrv.deviceDetail($scope.payloadObj).then(
            function(data){
              $scope.detailsObj.deviceDetails = [];
              $scope.detailsObj.deviceDetails = data;

              /** Below code is commented because we are now sending device ids acc to status */
                // if($scope.detailsObj.caller == "ds" && angular.lowercase($scope.tDetailsObj.label) == "total"){
                //   $scope.detailsObj.deviceDetails = data;
                // }
                // if($scope.detailsObj.caller != "ds"){
                //   $scope.detailsObj.deviceDetails = data;
                // }
                // angular.forEach(data, function(device){
                //   if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "online" || $scope.tDetailsObj.fType == "online")){
                //     if(device.status == "online"){
                //       $scope.detailsObj.deviceDetails.push(device);
                //     }
                //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "offline" || $scope.tDetailsObj.fType == "offline")){
                //     if(device.status == "offline"){
                //       $scope.detailsObj.deviceDetails.push(device);
                //     }
                //   }
                // });

              if(caller == "dccl"){
                if($scope.tDetailsObj.label == "ofncc" || $scope.tDetailsObj.label == "ofcc"){
                  $scope.offDArr = [];
                  angular.forEach(data, function(device){
                    if(device.status == "offline"){
                      $scope.offDArr.push(device);
                    }
                 });
                  $scope.detailsObj.deviceDetails = $scope.offDArr;
                } else if($scope.tDetailsObj.label == "onncc" || $scope.tDetailsObj.label == "oncc"){
                  $scope.onDArr = [];
                  angular.forEach(data, function(device){
                    if(device.status == "online"){
                      $scope.onDArr.push(device);
                    }
                 });
                  $scope.detailsObj.deviceDetails = $scope.onDArr;
                }
              }
              $scope.detailLoading = false;
              $scope.loadingDetail = false;
            },
            function(err){
              $scope.detailloadingDetail = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.devicePCOpen = function(id, label){
      $scope.dataCHObj = {id:id, label:label, history:[] };
      $scope.popupLoading = true;
      DevicesSrv.getDeviceCH($scope.dataCHObj.id).then(
        function(data){
          $scope.popupLoading = false;
          $scope.dataCHObj.history = data.history;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/devices/popup/previousChanges.html',
        width:900,
        scope:$scope,
        data:$scope.dataCHObj,
        closeByDocument:false
     });
    }

    $scope.dRestrictFx = function(caller, obj){
      $scope.dObj = [];
      if(caller == 'cc'){
        $scope.dObj = obj;
      } else{
        $scope.dObj = obj.deviceDetails;
      }
      $scope.popupProcessing = true;
      if($scope.dObj.length){
        $scope.devicesArr = [];
        angular.forEach($scope.dObj, function(device){
          if(!device.dType){
            $scope.devicesArr.push({id:device.id, mac:device.mac, dType:""});
          } else{
            $scope.devicesArr.push({id:device.id, mac:device.mac, dType:device.dType});
          }
       });
      }
      DashboardSrv.restrictDevices({devices:$scope.devicesArr}).then(
        function(data){
          $scope.popupProcessing = false;
        },
        function(err){
          $scope.popupProcessing = false;
          $log.error(err);
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hub')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($log, $rootScope, $scope, $state, $window, $filter, $interval, $location, $timeout, Restangular, NgMap, ngDialog, $q, DevicesSrv, ReportsSrv, DashboardSrv, ContentLibrarySrv){
    $rootScope.selectedMenu = 0;
    $scope.uiVersionFx();

    $scope.timestamp = moment().format('x');
    $scope.searchText = { log: "", device: "" };
    $scope.searchPin = { text: "" };
    $scope.isMapScriptLoaded = false;
    $scope.allDevicesLoaded = false;
    $scope.dashboardLoading = true;
    $scope.saveProcessing = false;
    $scope.allLogsLoaded = false;
    $scope.allRadLoaded = false;
    $scope.allDtplLoaded = false;
    $scope.allCclLoaded = false;
    $scope.contentTooltip = "";
    $scope.logLoading = false;
    $scope.refreshing = false;
    $scope.mapLoading = true;
    var dashboardCtrl = this;
    $scope.controlInfo = {};
    $scope.markerList = [];
    $scope.dashboard = {};
    $scope.place = null;
    $scope.bucket = "";
    $scope.tim = "";
    $scope.curDCData = [];
    $scope.dbListLoading = {d:false, rad:false, ral:false, dtpl:false, dtps:false, ccl:false, ccs:false, ot:false, ssodt:false, dlom:false, wgw:false, wgws:false};

    //AdCampaign
    $scope.currentAdIndex = 0;
    $scope.dontShowAdAgain = false;

    //Todo to check have data or not in the quad
    $scope.haveDataList = {ral: false, ccl:false}

    // For img map
    $scope.isImgMap = true;

    // Get Offset
    $rootScope.offsetFormatted = Intl.DateTimeFormat().resolvedOptions().timeZone;

    $scope.viewMapFx = function(){
      $scope.isImgMap = false;

      if($scope.auth.uservices.m == "b"){
        var s = document.createElement('script');
        s.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-spider-clusters.min.js?ts=' + $scope.timestamp);
        document.body.appendChild(s);

        var s1 = document.createElement('script');
        s1.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-html-marker-layer.min.js?ts=' + $scope.timestamp);
        document.body.appendChild(s1);
        $scope.isMapScriptLoaded = true;
      }
    }

    // For img map
    $scope.isImgMap = true;

    $scope.viewMapFx = function(){
      $scope.isImgMap = false;
      $scope.deviceListOnMap();
      if($scope.auth.uservices.m == "b"){
        var s = document.createElement('script');
        s.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-spider-clusters.min.js?ts=' + $scope.timestamp);
        document.body.appendChild(s);

        var s1 = document.createElement('script');
        s1.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-html-marker-layer.min.js?ts=' + $scope.timestamp);
        document.body.appendChild(s1);
        $scope.isMapScriptLoaded = true;
      }
    }

    $scope.folderContentFx = function (fId, splId, type) {
      $scope.odSp = { auth: false, breadCrumbs: [] };
      $scope.contentLibraryLoading = true;
      $rootScope.showTimeoutMsg = false;
      $rootScope.selectedItems = [];
      $rootScope.sessionTimoutFx();

      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curFId");

      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curFolderId = 0;
      $scope.curSPlObj = {};

      //for OD & SP breadcrumb
      if (fId == 0) {
        $scope.odSp.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curFId", fId);
        $scope.curFolderId = fId;
      }
      if (splId) {
        localStorage.setItem('curSPlObj', JSON.stringify({ id: splId, type: type }));
        $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.removeItem("curPathFId");
      }

      if (splId && fId != splId) {
        ContentLibrarySrv.getAllSPL($scope.curFolderId, $scope.curSPlObj.id, $scope.curSPlObj.type).then(
          function (data) {
            if (data.code == 8197) {
              $scope.odSp.auth = true;
              if (data.fType == "od") {
                $scope.odSp.curType = "OneDrive";
              } else if (data.fType == "sp") {
                $scope.odSp.curType = "SharePoint";
              } else if (data.fType == "sf") {
                $scope.odSp.curType = "SharedFolder";
              } else if (data.fType == "gd") {
                $scope.odSp.curType = "Googledrive";
              } else {
                $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function (err) {
            $log.error(err);
          }
        );
      } else {
        $scope.selectedTreeItem($scope.curFolderId);
        ContentLibrarySrv.getAll($scope.curFolderId).then(
          function (data) {
            if (data.code == 8197) {
              $scope.odSp.auth = true;
              if (data.fType == "od") {
                $scope.odSp.curType = "OneDrive";
              } else if (data.fType == "sp") {
                $scope.odSp.curType = "SharePoint";
              } else if (data.fType == "sf") {
                $scope.odSp.curType = "SharedFolder";
              } else if (data.fType == "gd") {
                $scope.odSp.curType = "Googledrive";
              } else {
                $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function (err) {
            $log.error(err);
          }
        );
      }
    }

    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/
      $scope.contentBtn = [];
      $scope.contentBrief = [];
      $scope.contextMenuOpt = [];
      $timeout.cancel($scope.promise);
      localStorage.removeItem("curPathId");

      angular.element('.ui-selectable li').removeClass('ui-highlight');
      ContentLibrarySrv.getFolderBrief(obj[0].id, obj[0].splId, obj[0].type).then(
        function (data) {
          $scope.contentBrief = data;
          if ($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type != "folder") {/*Button api*/
            $scope.getBtnFx("c");
          }
        },
        function (err) {
          $log.error(err);
        }
      );
      /*Button api*/
      if ($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type == "folder") {
        $scope.getBtnFx("c");
      } else if ($scope.selectedTab === "hub.contentLibrary.ac") {
        $scope.getBtnFx("ac");
      } else if ($scope.selectedTab === "hub.contentLibrary.dc") {
        $scope.getBtnFx("dc");
      }
    }

    $scope.thumbSize = 'n'; //sm, n, md, lg, xl

    $scope.dgOptions = { cellHeight: 50, verticalMargin: 20, float: false, animate: true, staticGrid: false };
    $scope.dbLoading = { d: false, ccl: false, dtpl: false, rad: false, dp: false };
    $scope.dgActions = { isEditable: false, loading: false };
    $scope.dGrid = [];

    $scope.dbGotoFx = function (caller) {
      if (!$scope.dgActions.isEditable) {
        if ($scope.auth.uservices.d && caller == "d") {
          $state.go("hub.devices.d");
        } else if ($scope.auth.uservices.c && caller == "c") {
          $state.go("hub.contentLibrary.c");
        } else if ($scope.auth.uservices.s && caller == "s") {
          $state.go("hub.schedules.s");
        } else if ($scope.auth.uservices.u && caller == "u") {
          $state.go("hub.users.au");
        }
      } else {
      }
    }

    $scope.bingMapFx = function () {
      var locs = [];
      var navigationBarMode = Microsoft.Maps.NavigationBarMode;
      var map = new Microsoft.Maps.Map(document.getElementById('bingMap'), {
        navigationBarMode:navigationBarMode.compact,
      });

      var center = map.getCenter();
      for (var i = 0; i < $scope.markerList.length; i++) {
        var loc = new Microsoft.Maps.Location($scope.markerList[i].latitude, $scope.markerList[i].longitude);
        var pushpin = new Microsoft.Maps.Pushpin(loc, { label: $scope.markerList[i].label, color: $scope.markerList[i].status == 'online' ? 'green' : 'gray' });

        var pushpins = Microsoft.Maps.TestDataGenerator.getPushpins($scope.markerList.length, map.getBounds());
        var infobox = new Microsoft.Maps.Infobox(center, { visible: false });
        infobox.setMap(map);

        pushpin.metadata = {
          label: $scope.markerList[i].label,
          description: 'Discription for pushpin' + i
        };
        Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) {
          infobox.setOptions({
            location:args.target.getLocation(),
            title:args.target.metadata.label,
            visible:true
          });
        });

        map.entities.push(pushpin);
        locs.push(loc);
      }

      if (locs.length > 0) {
        var bestview = Microsoft.Maps.LocationRect.fromLocations(locs);
        map.setView({
          bounds:bestview,
          zoom:13
        });
      }
    }

    var map, datasource, markerLayer, popup, spiderManager;


    var entityTypes = ['online', 'offline'];
    var entityTypesColors = ['#6aa84f', '#cccccc'];

    $scope.azureMapFx = function () {
      // Function to initialize the map
      function initializeMap(style) {
        $scope.cordinates = [];
        $scope.markArr = [];
        $("#azMap").empty();

        //Define a popup template.
        // var keyArr = atob($scope.auth.uservices.mk).split("|");
        // var subKey = $scope.reverse(keyArr[0]);
        map = new atlas.Map('azMap', {
          center: [-97, 39],
          zoom: 3,
          style: style,
          // style: $scope.themeSwitch.btn?'night':'road',
          view: 'Auto',
          showFeedbackLink: false,
          enableAccessibilityLocationFallback: false,

          //Add authentication details for connecting to Azure Maps.
          authOptions: {
            //Use Microsoft Entra ID authentication.
            authType: 'subscriptionKey',
            // subscriptionKey: subKey
            subscriptionKey: $scope.decryptFx($scope.auth.uservices.mk)
          },
          language: "en"
        });

        //Wait until the map resources are ready.
        map.events.add('ready', function () {
          // //Create a reusable popup.
          popup = new atlas.Popup({
            pixelOffset: [0, -20]
          });

          // //Add a style control to the map.
          // map.controls.add(new atlas.control.StyleControl({
          //     mapStyles: 'all'
          // }), {
          //     position: 'top-left'
          // });

          //Create a data source and add it to the map.
          datasource = new atlas.source.DataSource(null, {
            cluster: true,
            clusterRadius: 150,
            clusterProperties: { //Calculate counts for each entity type in a cluster
              'online': ['+', ['case', ['==', ['get', 'Status'], 'online'], 1, 0]],
              'offline': ['+', ['case', ['==', ['get', 'Status'], 'offline'], 1, 0]]
            }
          });
          map.sources.add(datasource);

          //Create a HTML marker layer for rendering data points.
          markerLayer = new atlas.layer.HtmlMarkerLayer(datasource, null, {
            markerCallback: function (id, position, properties) {
              //Check to see if marker represents a cluster.
              if (properties.cluster) {
                var radius = 20;

                if (properties.point_count > 1000) {
                  radius = 50;
                } else if (properties.point_count > 100) {
                  radius = 40;
                } else if (properties.point_count > 10) {
                  radius = 30;
                }

                //Get the counts for each entity type in the cluster.
                var values = [0, 0, 0, 0];
                for (var i = 0; i < entityTypes.length; i++) {
                  if (properties[entityTypes[i]]) {
                    values[i] = properties[entityTypes[i]];
                  }
                }

                return new atlas.PieChartMarker({
                  position: position,
                  values: values,
                  colors: entityTypesColors,
                  radius: radius,
                  fillColor: 'white',
                  strokeWidth: 1,
                  strokeColor: 'white',
                  innerRadius: radius * 0.5,
                  text: properties.point_count_abbreviated,
                  // tooltipCallback: tooltipCallback
                });
              }

              //Individual points are rendered with colors based on their status.
              var color = properties.Status === 'online' ? '#6aa84f' : '#cccccc';
              return new atlas.HtmlMarker({
                position: position,
                color: color,
              });
            }
          });

          //Add a click event to the marker layer.
          map.events.add('click', markerLayer, markerClicked);

          //Add marker layer to the map.
          map.layers.add(markerLayer);

          //Set data into the data source.
          datasource.setShapes($scope.getMapNewData);

          // Adjust the map view to fit all markers after data is loaded.
          fitMapToBounds();

          // Add event listeners for map move and zoom to close the popup
          map.events.add('move', closePopup);
          map.events.add('zoom', closePopup);

        });
      }
      setTimeout(function () {
        initializeMap($scope.themeSwitch.btn ? 'night' : 'road');
      }, 800);
    }

    function closePopup() {
      if (popup) {
        popup.close();
      }
    }

    function fitMapToBounds(shapes) {
      // Get all shapes from the datasource
      var shapes = datasource.getShapes();

      // Check if there are any shapes
      if (shapes && shapes.length === 1) {
        // If there is only one marker, zoom out to a predefined level
        map.setCamera({
          center: shapes[0].getCoordinates(),
          zoom: 13 // Adjust zoom level as needed
        });
      }else if (shapes && shapes.length > 0) {
        // Check if all markers have the same coordinates
        var sameCoordinates = shapes.every(function(shape) {
          return shape.getCoordinates()[0] === shapes[0].getCoordinates()[0] &&
                shape.getCoordinates()[1] === shapes[0].getCoordinates()[1];
        });
        if (sameCoordinates) {
          // If all markers have the same coordinates, zoom out to show the area
          map.setCamera({
            center: shapes[0].getCoordinates(),
            zoom: 13 // Adjust zoom level as needed
          });
        } else {
          // Fit map to bounds of all markers
          var coordinates = shapes.map(function(shape) {
            return shape.getCoordinates();
          });
          var bounds = atlas.data.BoundingBox.fromPositions(coordinates);
          map.setCamera({
            bounds: bounds,
            padding: 50 // Adjust padding as needed
          });
        }
        // var coordinates = shapes.map(function (shape) {
        //   return shape.getCoordinates();
        // });

        // // Calculate the bounding box of the coordinates
        // var bounds = atlas.data.BoundingBox.fromPositions(coordinates);
        // map.setCamera({
        //   bounds: bounds,
        //   padding: 20, // Optional: Add some padding to the bounds
        // });
      }
    }

    function findObjectsWithSameCoordinates(dataArray, clickedObject) {
      var resultArray = [];
      var targetCoordinates = null;

      // First loop: find the coordinates of the object with the matching MAC address
      for (var i = 0; i < dataArray.length; i++) {
        if (dataArray[i].data.properties.Mac === clickedObject.Mac) {
          targetCoordinates = dataArray[i].data.geometry.coordinates;
          break;
        }
      }

      // If the coordinates are found, find all objects with the same coordinates
      if (targetCoordinates) {
        for (var j = 0; j < dataArray.length; j++) {
          if (JSON.stringify(dataArray[j].data.geometry.coordinates) === JSON.stringify(targetCoordinates)) {
            resultArray.push(dataArray[j].data.properties);
          }
        }
      }

      return resultArray;
    }

    function markerClicked(e) {
      var marker = e.target;

      if (!marker) {
        popup.close();
      }
      if (marker.properties.cluster) {
        // Close the popup when clicking on a cluster
        popup.close();
        //Get the cluster expansion zoom level. This is the zoom level at which the cluster starts to break apart.
        datasource.getClusterExpansionZoom(marker.properties.cluster_id).then(function (zoom) {

          //Update the map camera to be centered over the cluster.
          map.setCamera({
            center: marker.getOptions().position,
            zoom: zoom,
            type: 'ease',
            duration: 200
          });
        });
      } else {
        // // Get the clicked marker coordinates
        var allShapes = datasource.getShapes();
        // var sameLocationMarkers = []
        var sameLocationMarkers = findObjectsWithSameCoordinates(allShapes, marker.properties);

        if (sameLocationMarkers.length > 1) {
          // Construct the popup content with a scrollable list
          var desc = '<div class="customInfobox" style="max-height: 200px; overflow-y: auto;">';
          sameLocationMarkers.forEach(function (prop) {
            desc += '<div class="name">\
                        <span class="pull-left marT4 deviceStatus ' + prop.Status + '"></span>\
                        <div class="padL20">' + prop.Name + '</div>\
                        <div class="mac">' + prop.Mac + '</div>\
                    </div>';
          });
          desc += '</div>';

          popup.setOptions({
            content: desc,
            position: marker.getOptions().position
          });

          popup.open(map);
        } else {
          // Open popup for individual marker
          openPopup(marker.properties, marker);
        }
      }
    }

    function openPopup(properties, marker) {
      // Open a popup for individual marker
      var desc = '<div class="customInfobox"><div class="name"><span class="pull-left marT4 deviceStatus ' + properties.Status + '"></span><div class="padL20">' + properties.Name + '</div><div class="mac">' + properties.Mac + '</div></div></div>';
      popup.setOptions({
        content: desc,
        position: marker.getOptions().position
      });

      popup.open(map);
    }

    $rootScope.changeMapStyle = function (style) {
      $scope.azureMapFx();
    }
    function tooltipCallback(marker, sliceIdx) {
      return '<div class="popup">\
        <div ng-if="marker.properties.online == 0 || marker.properties.online > 0">Online device count: '+ marker.properties.online + '</div>\
        <div ng-if="marker.properties.offline == 0 || marker.properties.offline > 0">Offlinez device count: '+ marker.properties.offline + '</div>\
        </div>';
    }

    // function updateData() {
    // //Create mock data as an update.
    // var data = [];
    // for (var i = 0; i < 16000; i++) {
    //     data.push(new atlas.data.Feature(new atlas.data.Point([
    //         Math.random() * 50 - 120,
    //         Math.random() * 30 + 25
    //     ]), {
    //         EntityType: entityTypes[i % 4],
    //         Name: 'A place',
    //         Address: '1234 main st',
    //         City: 'My City',
    //         State: 'My State',
    //         ZipCode: '90210',
    //         Country: 'USA'
    //     }));
    // }

    // datasource.setShapes(data);
    // }

    var popupTemplate = '<div class="customInfobox"><div class="name"><span class="pull-left marT4 deviceStatus {status}"></span><div class="padL20">{name}</div><div class="mac">{mac}</div></div></div>';
    $scope.showPopup = function (position, properties, pixelOffset) {
      var content = popupTemplate.replace(/{name}/g, properties.Name).replace(/{status}/g, properties.Status).replace(/{mac}/g, properties.Mac);
      popup.setOptions({
        //Update the content of the popup.
        content: content,
        //Update the position of the popup with the symbols coordinate.
        position: position,
        //Offset the popups position for better alignment with the layer.
        pixelOffset: pixelOffset
        // pixelOffset:[0,0]
      });

      //Open the popup.
      popup.open(map);
    }

    $scope.hidePopup = function () {
      popup.close();
    }

    $scope.dgOptionsFx = function (caller) {
      $scope.dgActions.loading = false;
      $rootScope.isDBEdit = caller;
      if (caller == "e") {
        $rootScope.$broadcast("dGridSet", caller);
        $scope.dGridCanCopy = angular.copy($scope.dGridArr);
        $scope.dgActions.isEditable = true;
      } else if (caller == "s") {
        $rootScope.$broadcast("dGridSet", caller);
        $scope.dgActions.loading = true;
        DashboardSrv.saveDGrid($scope.dGridArr).then(
          function (data) {
            $scope.dGridCopy = angular.copy($scope.dGridArr);
            $scope.dgActions.isEditable = false;
            $scope.dgActions.loading = false;
          },
          function (err) {
            $log.error(err);
          }
        );
      } else if (caller == "c") {
        $scope.dgActions.isEditable = false;
        $window.location.reload();
      }
    }

    $scope.setDefaultGridFx = function () {
      $scope.dgActions.loading = true;
      $scope.dGArr = [];
      if($scope.dashboard.dbd.ds){/*Device Online*/
        $scope.dGArr.push({x:0, y:0, wd:3, hg:2, mh:2, ty:'ds'});
      }
      if($scope.dashboard.dbd.c){/*Content*/
        $scope.dGArr.push({x:3, y:0, wd:3, hg:2, mh:2, ty:'c'});
      }
      if($scope.dashboard.dbd.sc){/*Scheduls*/
        $scope.dGArr.push({x:6, y:0, wd:3, hg:2, mh:2, ty:'sc'});
      }
      if($scope.dashboard.dbd.us){/*Users*/
        $scope.dGArr.push({x:9, y:0, wd:3, hg:2, mh:2, ty:'us'});
      }
      if($scope.dashboard.dbd.ral){/*Recent Activity Log*/
        $scope.dGArr.push({x:0, y:2, wd:3, hg:6, mh:4, ty:'ral'});
      }
      if($scope.dashboard.dbd.d){/*Devices*/
        $scope.dGArr.push({x:3, y:2, wd:3, hg:6, mh:4, ty:'d'});
      }
      if($scope.dashboard.dbd.dom){/*Devices on Map*/
        $scope.dGArr.push({x:6, y:2, wd:6, hg:6, mh:4, ty:'dom'});
      }
      if($scope.dashboard.dbd.dts){/*Devices Type Summary*/
        $scope.dGArr.push({x:0, y:8, wd:3, hg:3, mh:2, ty:'dts'});
      }
      if($scope.dashboard.dbd.dtps){/*Device Temperature Summary*/
        $scope.dGArr.push({x:3, y:8, wd:3, hg:2, mh:2, ty:'dtps'});
      }
      if($scope.dashboard.dbd.dtpl){/*Device Temperature List*/
        $scope.dGArr.push({x:6, y:8, wd:3, hg:6, mh:4, ty:'dtpl'});
      }
      if($scope.dashboard.dbd.ccl){/*Content Confirmation List*/
        $scope.dGArr.push({x:9, y:8, wd:3, hg:6, mh:4, ty:'ccl'});
      }
      if($scope.dashboard.dbd.rad){/*Recently Added Devices*/
        $scope.dGArr.push({x:0, y:10, wd:3, hg:6, mh:4, ty:'rad'});
      }
      if($scope.dashboard.dbd.ccs){/*Content Confirmation Summary*/
        $scope.dGArr.push({x:3, y:10, wd:3, hg:2, mh:2, ty:'ccs'});
      }
      if($scope.dashboard.dbd.ot){/*Open Tickets*/
        $scope.dGArr.push({x:0, y:12, wd:3, hg:2, mh:2, ty:'ot'});
      }
      if($scope.dashboard.dbd.dccl){/*dccl*/
        $scope.dGArr.push({x:0, y:14, wd:4, hg:4, mh:3, ty:'dccl'});
      }
      if($scope.dashboard.dbd.dpi){/*Content Pin*/
        $scope.dGArr.push({x:3, y:14, wd:6, hg:6, mh:3, ty:'dpi'});
      }
      if($scope.dashboard.dbd.wgw){/*White Glove Warranty List*/
        $scope.dGArr.push({x:6, y:28, wd:3, hg:6, mh:4, ty:'wgw'});
      }
      if($scope.dashboard.dbd.wgws){/*White Glove Warranty Summary*/
        $scope.dGArr.push({x:9, y:28, wd:3, hg:2, mh:2, ty:'wgws'});
      }
      /****** Check *******/

      if($scope.dashboard.dbd.dps && $scope.dashboard.dps.length > 0){/*Devices Other Info Summary*/
        var dspLoopX = 0, dspLoopY = 14;
        angular.forEach($scope.dashboard.dps.data, function (dps, index) {
          if (3 * index > 9) {
            dspLoopX = 0;
            dspLoopY = dspLoopY + 2;
          } else {
            dspLoopX = index;
          }
          $scope.dGArr.push({x:3 * dspLoopX, y:dspLoopY, wd:3, hg:2, ty:'dps', sty:index, l:dps.label});
        });
      }

      if($scope.dashboard.dbd.dpts && $scope.dashboard.dpts.length > 0){/*Devices Properties Summary*/
        var dptsLoopX = 0, dptsLoopY = 14;
        angular.forEach($scope.dashboard.dpts.data, function (dpts, index) {
          if (3 * index > 9) {
            dptsLoopX = 0;
            dptsLoopY = dptsLoopY + 2;
          } else {
            dptsLoopX = index;
          }
          $scope.dGArr.push({x:3 * dptsLoopX, y:dptsLoopY, wd:3, hg:2, ty:'dpts', sty:index, l:dpts.label});
        });
      }

      if($scope.dashboard.dbd.ssdt && $scope.dashboard.ssdt){/*Status of Specific Device Type*/
        var ssdtLoopX = 0, ssdtLoopY = 16;
        angular.forEach($scope.dashboard.ssdt.data, function (ssdt, index) {
          if (3 * index > 9) {
            ssdtLoopX = 0;
            ssdtLoopY = ssdtLoopY + 2;
          } else {
            ssdtLoopX = index;
          }
          $scope.dGArr.push({x:3 * ssdtLoopX, y:ssdtLoopY, wd:3, hg:2, mh:2, ty:'ssdt', sty:index, l:ssdt.label});
        });
      }
      if($scope.dashboard.dbd.ssodt && $scope.dashboard.ssodt){/*Status Summary of Device Type*/
        var ssodtLoopX = 0, ssodtLoopY = 16;
        angular.forEach($scope.dashboard.ssodt, function (ssodt, index) {
          if (3 * index > 9) {
            ssodtLoopX = 0;
            ssodtLoopY = ssodtLoopY + 2;
          } else {
            ssodtLoopX = index;
          }
          $scope.dGArr.push({x:3 * ssodtLoopX, y:ssodtLoopY, wd:3, hg:2, mh:2, ty:'ssodt', sty:index, l:ssodt.label});
        });
      }

      /****** Check *******/
      $scope.dGridArr = $scope.dGArr;
      setTimeout(function () {
        $scope.dgOptionsFx('e');
      }, 10);
    }

    $scope.getGrid = function(){
      DashboardSrv.getGrid().then(
        function(data){
          $scope.dashboard.dGrid = data
          if(!$scope.dashboard.dGrid.length){
            $scope.dashboard.dGrid = [];
          }
          if($scope.dashboard.dp){
            $scope.tim = $scope.dashboard.dp.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.dashboard.dp.bucket;
            if($scope.dashboard.dp.mbucket && $scope.dashboard.dp.mbucket != ""){
              $scope.detailBucket = $scope.dashboard.dp.mbucket;
            }
          }

          // TODO For img map
          // if($scope.auth.uservices.m == "b"){
          //   var s = document.createElement('script');
          //   s.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-spider-clusters.min.js?ts=' + $scope.timestamp);
          //   document.body.appendChild(s);

          //   var s1 = document.createElement('script');
          //   s1.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-html-marker-layer.min.js?ts=' + $scope.timestamp);
          //   document.body.appendChild(s1);
          //   $scope.isMapScriptLoaded = true;
          // }

          /*Grid start*/
          $scope.dGridArr = [];
          if($scope.dashboard && !$scope.dashboard.dGrid){
            $scope.dGridArr = [];
          } else{
            $scope.dGridCopy = angular.copy($scope.dashboard.dGrid);
          }

          if(!$scope.dashboard.dGrid.length){
            $scope.dashboard.dGrid = angular.copy($scope.dGridArr);
          }
          /*Grid end*/


          $scope.getDashboard();
          setTimeout(function(){
            $scope.loadDeviceList();
            if($rootScope.isDBEdit == "e"){
              $scope.dgOptionsFx('e');
            }
          }, 500);

          // if($scope.dashboard.ssdpt || $scope.dashboard.ssdt || $scope.dashboard.dps || $scope.dashboard.dpts){
          //   $scope.dashboardLoading = true;
          // } else{
          //   $scope.dashboardLoading = false;
          // }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getGrid();

    $scope.getDashboard = function(caller){
      $scope.markerList = [];
      $scope.isImgMap = true;
     
      /*AdCampaign*/
      if(!localStorage.getItem('adC')){
        DashboardSrv.getAdCampaign().then(
          function(data){
            $scope.adCampaign = data;
            if($scope.adCampaign && $scope.adCampaign.length && $scope.adCampaign[0].data && $scope.adCampaign[0].data.length){
              $scope.loadAdPopup();
            }
          }
        );  
      }

      DashboardSrv.getDashboard().then(
        function(data){
          $scope.dbListLoading = {d:true, rad:true, ral:true, dtpl:true, dtps:true, ccl:true, ccs:true, ot:true, ssodt:true, wgw:true, wgws:true};
          if(angular.isArray(data)){
            return;
          }
          data.dGrid = $scope.dashboard.dGrid
          $scope.dashboard = data;

          // if($scope.auth.uservices.m == "b"){
          //   var s = document.createElement('script');
          //   s.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-spider-clusters.min.js?ts=' + $scope.timestamp);
          //   document.body.appendChild(s);

          //   var s1 = document.createElement('script');
          //   s1.setAttribute('src', $rootScope.apiHost + 'storage/azure-maps/azure-maps-html-marker-layer.min.js?ts=' + $scope.timestamp);
          //   document.body.appendChild(s1);
          //   $scope.isMapScriptLoaded = true;
          // }

          $rootScope.showTimeoutMsg = false;
          $scope.searchText.device = "";
          $scope.refreshing = true;
          $scope.mapLoading = false;
          $scope.refreshing = false;

          /*Device Status Quard*/
          if($scope.dashboard.dbd.ds){
            $scope.dsCopyObj = angular.copy($scope.dashboard.ds);
            $scope.dsTotal = $scope.dashboard.ds.ondc + $scope.dashboard.ds.offdc + $scope.dashboard.ds.ncdc;
            $scope.dsArr = [];
            var dsOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };
            var curDSArr = [
              {name:$filter("translate")('d.tool.1'), y:$scope.dashboard.ds.ondc, yl:$scope.dashboard.ds.ondc, color:$scope.dashboard.dsg.pieColors.ds.on, fType:"online" },
              {name:$filter("translate")('d.tool.2'), y:$scope.dashboard.ds.offdc, yl:$scope.dashboard.ds.offdc, color:$scope.dashboard.dsg.pieColors.ds.off, fType:"offline" },
              {name:$filter("translate")('d.tool.21'), y:$scope.dashboard.ds.ncdc, yl:$scope.dashboard.ds.ncdc, color:$scope.dashboard.dsg.pieColors.ds.nc, fType:"nc" }
            ];

            $scope.dsArr = {
              options:dsOpts,
              series:[{
                size:'100%',
                data:curDSArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.deviceDetailListFx('ds', '', '', this.fType == 'online'? 'ondc': this.fType == 'offline'? 'offdc': 'ncdc');
                    }
                  }
                }
              }],
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' },
            };
          }

          /*Content Count Quard*/
          setTimeout(function() {
            if($scope.dashboard.dbd.c){
              // console.warn("BBBBB", $scope.dashboard.c);
                $scope.usedSpace = $scope.dashboard.c.uss;
                var spaceStatus = ($scope.usedSpace * 100) / $scope.dashboard.c.ts;
                if(spaceStatus < 100){
                  $scope.usedSpacePercent = ($scope.usedSpace * 100) / $scope.dashboard.c.ts;
                } else{
                  $scope.usedSpacePercent = 100;
                }
                $scope.contentTooltip = '"' + $filter("translate")('cl.tool.10') + ":" + $scope.dashboard.c.ac + "<br>" + $filter("translate")('cl.tool.11') + ":" + $scope.dashboard.c.uac + "<br>" + $filter("translate")('db.body.8') + ":" + $scope.dashboard.c.ec + "<br>" + $filter("translate")('db.body.6') + ":" + $scope.dashboard.c.arc + "<br>" + $filter("translate")('db.body.7') + ":" + $scope.dashboard.c.dc + '"';
            }
          }, 500);

          /*For Device Preview*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dp){
              if($scope.dashboard.dp){
                $scope.curDCData.dp ={id:$scope.dashboard.dp.Id, l:$scope.dashboard.dp.l, h:$scope.dashboard.dp.h, dt:$scope.dashboard.dp.dt, s:($scope.dashboard.dp.s==1)? "online":"offline"};
              }
            }

            /*Pinned Items*/
            if($scope.dashboard.dbd.dpi){
              $rootScope.$broadcast('pinitemClear', true);
            }
          }, 500);

          /*Device List*/
          setTimeout(function() {
            if($scope.dashboard.dbd.d){
              $scope.dbListLoading.d = true;
              $scope.deviceListFx();
            }
          }, 500);

          /*Recent Log List*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ral){
              $scope.dbListLoading.ral = true;
              $scope.logListFx();
            }
          }, 500);

          /*Device Type Summary*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dts){
              $scope.dbListLoading.dts = true;
              $scope.deviceTypSummFx();
            }
          }, 500);

          /*Recent Added Device*/
          setTimeout(function() {
            if($scope.dashboard.dbd.rad){
              $scope.dbListLoading.rad = true;
              $scope.recentAddedDeviceFx();
            }
          }, 500);

          /*Temperature List*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dtpl){
              $scope.dbListLoading.dtpl = true;
              $scope.deviceTempratureFx();
            }
          }, 500);

          /*Temperature Summary*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dtps){
              $scope.dbListLoading.dtps = true;
              $scope.deviceTempratureSummFx();
            }
          }, 500);

          /*Devices Properties Summary*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dpts){
              $scope.devicePropSummFx(caller);
            }
          }, 500);

          /*Devices Other Info Summary*/
          setTimeout(function() {
            if($scope.dashboard.dbd.dps){
              $scope.deviceOtherInfoSummFx(caller);
            }
          }, 500);

          /*Online/Offline Status of Specific Device Info*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ssdt){
              $scope.ssdtFx(caller);
            }
          }, 500);

          /*Online/Offline Status of Specific Device Properties*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ssdpt){
              $scope.ssdptFx(caller);
            }
          }, 500);

          /*Online/Offline Status Summary of Device Type*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ssodt){
              $scope.dbListLoading.ssodt = true;
              $scope.ssodtFx(caller);
            }
          }, 500);

          /*Content Confirmation List*/
          // if($scope.dashboard.dbd.ccl){
            // $scope.dbListLoading.ccl = true;
            // $scope.contentConfirmationFx();
          // }
          /*Content Confirmation Summary and Download*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ccs || $scope.dashboard.dbd.ccl){
              $scope.dbListLoading.ccs = true;
              $scope.dbListLoading.ccl = true;
              $scope.contentConfirmationSummFx();
            }
          }, 500);

          /*Open Tickets*/
          setTimeout(function() {
            if($scope.dashboard.dbd.ot){
              $scope.dbListLoading.ot = true;
              $scope.hubspotTicketFx();
            }
          }, 500);

          /*White Glove Warranty List*/
          setTimeout(function() {
            if($scope.dashboard.dbd.wgw){
              $scope.dbListLoading.wgw = true;
              $scope.wgwListFx();
            }
          }, 500);

          /*White Glove Warranty Summary*/
          setTimeout(function() {
            if($scope.dashboard.dbd.wgws){
              $scope.dbListLoading.wgws = true;
              $scope.wgwSummFx();
            }
          }, 500);

          // Device List On Map
          // setTimeout(function() {
          //   if($scope.dashboard.dbd.dom){
          //     $scope.deviceListOnMap();
          //   }
          // }, 500);

          if($rootScope.isDBEdit == "e"){
            $scope.dgOptionsFx('e');
          }




        // if($scope.dashboard.ssdpt || $scope.dashboard.ssdt || $scope.dashboard.dps || $scope.dashboard.dpts){
        //   $scope.dashboardLoading = true;
        // } else{

          //Make grid
          if(caller != 'update'){
            $scope.createGrid();
          }
        // }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    // $scope.getDashboard();

    $scope.createGrid = function(){
      /*Grid start*/
      if($scope.dashboard.dbd.ds){/*Device Online*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'ds'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'ds'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:0, wd:3, hg:2, mh:2, ty:'ds'});
        }
      }
      if($scope.dashboard.dbd.c){/*Content*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'c'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'c'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:3, y:0, wd:3, hg:2, mh:2, ty:'c'});
        }
      }
      if($scope.dashboard.dbd.sc){/*Scheduls*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'sc'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'sc'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:6, y:0, wd:3, hg:2, mh:2, ty:'sc'});
        }
      }
      if($scope.dashboard.dbd.us){/*Users*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'us'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'us'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:9, y:0, wd:3, hg:2, mh:2, ty:'us'});
        }
      }
      if($scope.dashboard.dbd.ral){/*Recent Activity Log*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'ral'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'ral'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:2, wd:3, hg:6, mh:4, ty:'ral'});
        }
      }
      if($scope.dashboard.dbd.d){/*Devices*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'d'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'d'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:3, y:2, wd:3, hg:6, mh:4, ty:'d'});
        }
      }
      if($scope.dashboard.dbd.dom){/*Devices on Map*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dom'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dom'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:6, y:2, wd:6, hg:6, mh:4, ty:'dom'});
        }
      }
      if($scope.dashboard.dbd.dts){/*Devices Type Summary*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dts'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dts'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:8, wd:3, hg:3, mh:2, ty:'dts'});
        }
      }
      if($scope.dashboard.dbd.dtps){/*Device Temperature Summary*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dtps'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dtps'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:3, y:8, wd:3, hg:2, mh:2, ty:'dtps'});
        }
      }
      if($scope.dashboard.dbd.dtpl){/*Device Temperature List*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dtpl'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dtpl'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:6, y:8, wd:3, hg:6, mh:4, ty:'dtpl'});
        }
      }
      if($scope.dashboard.dbd.ccl){/*Content Confirmation List*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'ccl'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'ccl'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:9, y:8, wd:3, hg:6, mh:4, ty:'ccl'});
        }
      }
      if($scope.dashboard.dbd.rad){/*Recently Added Devices*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'rad'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'rad'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:10, wd:3, hg:2, mh:4, ty:'rad'});
        }
      }
      if($scope.dashboard.dbd.ccs){/*Content Confirmation Summary*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'ccs'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'ccs'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:3, y:10, wd:3, hg:2, mh:2, ty:'ccs'});
        }
      }
      if($scope.dashboard.dbd.ot){/*Open Tickets*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'ot'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'ot'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:12, wd:3, hg:2, mh:2, ty:'ot'});
        }
      }
      if($scope.dashboard.dbd.dp){/*Device Preview*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dp'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dp'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:12, wd:3, hg:4, mh:4, ty:'dp'});
        }
      }
      if($scope.dashboard.dbd.dccl){/*dccl*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dccl'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dccl'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:0, y:12, wd:3, hg:3, mh:3, ty:'dccl'});
        }
      }
      if($scope.dashboard.dbd.dpi){/*Pin items*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'dpi'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'dpi'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:3, y:14, wd:6, hg:6, mh:3, ty:'dpi'});
        }
      }
      if($scope.dashboard.dbd.wgw){/*White Glove Warranty List*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'wgw'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'wgw'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:6, y:28, wd:3, hg:6, mh:4, ty:'wgw'});
        }
      }
      if($scope.dashboard.dbd.wgws){/*White Glove Warranty Summary*/
        if($filter("filter")($scope.dashboard.dGrid, {ty:'wgws'}, true).length){
          $scope.dGridArr.push($filter("filter")($scope.dashboard.dGrid, {ty:'wgws'}, true)[0]);
        } else{
          $scope.dGridArr.push({x:9, y:28, wd:3, hg:2, mh:2, ty:'wgws'});
        }
      }
      /*Grid end*/
      $scope.dashboardLoading = false;
    }

    $scope.isDeviceListLoad = false;
    $scope.isFirst = {d: false, rad: false, dtpl: false, wgw: false};
    $scope.deviceListFx = function(caller){
      $scope.isFirst.d = true;
      $scope.dbListLoading.d = true;
      $scope.searchText.device = "";
      $scope.detailListObj.d = {};
      $scope.scrollDataList.d = [];
      $scope.allScrollDataList.d = [];
      $scope.copyScrollObj.d = {};
      $scope.visibleObjects.d = [];
      $scope.haveMoreData.d = false;
      $scope.haveMoreSearchData.d = false;
      $scope.visibleData.d = [];
      $scope.stIndex.d = 0;
      $scope.etIndex.d = 300;
      $scope.searchScroll.d = false;

      $scope.detailListObj.d = {caller:'d', offset:0};
      DashboardSrv.getScrollDBListData($scope.detailListObj.d).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.d = true;
          } else{
            $scope.haveMoreData.d = false;
          }
          $scope.scrollDataList.d = data;
          $scope.addStatusKey($scope.scrollDataList.d, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.d =  angular.copy($scope.scrollDataList.d);


          $rootScope.sessionTimoutFx();
          $rootScope.showTimeoutMsg = false;
          $scope.searchText.device = "";
          $scope.loading = false;
          $scope.refreshing = false;

          setTimeout(function(){
              if($rootScope.isDBEdit == "e"){
              $scope.dgOptionsFx('e');
              }
          }, 500);

          $scope.dbListLoading.d = false;
        },
        function(err){
          $scope.dbListLoading.d = false;
          $log.error(err);
        }
      );
    }

    $scope.loadMoreDeviceListFx = function(obj){
      $scope.isFirst.d = true;
      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;
      $scope.searchText.device = "";
      $scope.detailListObj.d = {};
      $scope.scrollDataList.d = [];
      $scope.allScrollDataList.d = [];
      $scope.copyScrollObj.d = {};
      $scope.visibleObjects.d = [];
      $scope.haveMoreData.d = false;
      $scope.haveMoreSearchData.d = false;
      $scope.visibleData.d = [];
      $scope.stIndex.d = 0;
      $scope.etIndex.d = 300;
      $scope.searchScroll.d = false;

      $scope.detailListObj.d = {caller:'d', offset:0};
      $scope.dbListLoading.d = true;
      DashboardSrv.getScrollDBListData($scope.detailListObj.d).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.d = true;
          } else{
            $scope.haveMoreData.d = false;
          }
          $scope.scrollDataList.d = data;
          $scope.addStatusKey($scope.scrollDataList.d, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.d =  angular.copy($scope.scrollDataList.d);
          $scope.dbListLoading.d = false;
        },
        function(err){
          $scope.dbListLoading.d = false;
          $log.error(err);
        }
      );
    }

    // $scope.deviceListFx = function(caller){
    //   $scope.dbListLoading.d = true;
    //   DashboardSrv.getDeviceList(caller).then(
    //     function(data){
    //       $scope.dbListLoading.d = false;
    //       $scope.curDCData.d = data;
    //       $rootScope.sessionTimoutFx();
    //       $rootScope.showTimeoutMsg = false;
    //       $scope.searchText.device = "";
    //       $scope.loading = false;
    //       $scope.refreshing = false;

    //       setTimeout(function(){
    //           if($rootScope.isDBEdit == "e"){
    //           $scope.dgOptionsFx('e');
    //           }
    //       }, 500);
    //     },
    //     function(err){
    //       $scope.dbListLoading.d = false;
    //       $log.error(err);
    //     }
    //   );
    // }

    // $scope.loadMoreDeviceListFx = function(offSet){
    //   $rootScope.sessionTimoutFx();
    //   $rootScope.showTimeoutMsg = false;
    //   if(offSet == 0){
    //     $scope.searchText.device = "";
    //     $scope.isDeviceListLoad = false;
    //     $scope.curDCData.d = [];
    //   }
    //   if(!$scope.isDeviceListLoad && !$scope.dbListLoading.d && !$scope.deviceLoading){
    //     $scope.deviceLoading = true;
    //     if(offSet == 0){
    //       $scope.dbListLoading.d = true;
    //     }
    //     DashboardSrv.getDeviceList($scope.curDCData.d.length).then(
    //         function(data){
    //           $scope.curDCData.d = $scope.curDCData.d.concat(data);
    //           $scope.dbListLoading.d = false;
    //           $scope.deviceLoading = false;
    //           if($scope.curDCData.d.length == $scope.dashboard.dc){
    //             $scope.isDeviceListLoad = true;
    //           }
    //         },
    //         function(err){
    //           $scope.dbListLoading.d = false;
    //           $scope.deviceLoading = false;
    //           $log.error(err);
    //         }
    //     );
    //   }
    // }

    $scope.deviceTypSummFx = function(){
      $scope.secondaryLoading = true;
      DashboardSrv.getDeviceTypSumm().then(
          function(data){
            $scope.secondaryLoading = false;
            $scope.curDCData.dts = {mp:0,webos:0,mc:0,tizen:0,gf:0,v:0,desktop:0,epd:0};
            angular.forEach(data, function(val, key){
              $scope.curDCData.dts[key] = val;
              // $scope.curDCData.dts[key] = JSON.parse(val.split('|')[1]);
            });
            $scope.curDCData.dts.total = $scope.curDCData.dts.mp + $scope.curDCData.dts.webos + $scope.curDCData.dts.tizen + $scope.curDCData.dts.mc + $scope.curDCData.dts.desktop + $scope.curDCData.dts.epd + $scope.curDCData.dts.gf + $scope.curDCData.dts.v;
            $scope.loading = false;
            $scope.refreshing = false;
            $scope.dtsArr = [];
            var dtsOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              tooltip:{
                pointFormat:'{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter:function(){
                      return this.y;
                    }
                  },
                  showInLegend:false,
                  center:['50%', '50%']
                }
              }
            };

            var curDTSArr = [{name:$filter("translate")('d.label.1.1'), y:$scope.curDCData.dts.mp, yl:$scope.curDCData.dts.mp, t:"mp", color:$scope.dashboard.dsg.pieColors.dts.mp}];
            if($scope.auth.upermissions.webos){
              curDTSArr.push({name:$filter("translate")('d.label.1.5'), y:$scope.curDCData.dts.webos, yl:$scope.curDCData.dts.webos, t:"webos", color:$scope.dashboard.dsg.pieColors.dts.webos});
            }
            if($scope.auth.upermissions.mc){
              curDTSArr.push({name:$filter("translate")('d.label.1.4'), y:$scope.curDCData.dts.mc, yl:$scope.curDCData.dts.mc, t:"mc", color:$scope.dashboard.dsg.pieColors.dts.mc});
            }
            if($scope.auth.upermissions.tizen){
              curDTSArr.push({name:$filter("translate")('d.label.1.6'), y:$scope.curDCData.dts.tizen, yl:$scope.curDCData.dts.tizen, t:"tizen", color:$scope.dashboard.dsg.pieColors.dts.tz});
            }
            if($scope.auth.upermissions.gf){
              curDTSArr.push({name:$filter("translate")('d.label.1.2'), y:$scope.curDCData.dts.gf, yl:$scope.curDCData.dts.gf, t:"gf", color:$scope.dashboard.dsg.pieColors.dts.geo});
            }
            if($scope.auth.upermissions.vd){
              curDTSArr.push({name:$filter("translate")('d.label.1.3'), y:$scope.curDCData.dts.v, yl:$scope.curDCData.dts.v, t:"v", color:$scope.dashboard.dsg.pieColors.dts.vd});
            }
            if($scope.auth.upermissions.desktop){
              curDTSArr.push({name:$filter("translate")('d.label.1.7'), y:$scope.curDCData.dts.desktop, yl:$scope.curDCData.dts.desktop, t:"desktop", color:$scope.dashboard.dsg.pieColors.dts.de});
            }
            if($scope.auth.upermissions.epd){
              curDTSArr.push({name:$filter("translate")('d.label.1.8'), y:$scope.curDCData.dts.epd, yl:$scope.curDCData.dts.epd, t:"epd", color:$scope.dashboard.dsg.pieColors.dts.epd});
            }

            $scope.dtsArr = {
              options:dtsOpts,
              series:[{
                size:'100%',
                data:curDTSArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.deviceDetailListFx('dts', '', this.t);
                    }
                  }
                }
              }],
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' },
            };
          },
          function(err){
            $log.error(err);
          }
      );
    }

    $scope.getRecentAddedDeviceFX =  function(data){
      $scope.rad = data;
      angular.forEach($scope.rad, function(rad, index){
        var curDT = moment(parseInt(rad.ct + '000')).format("MMM, DD YYYY");
        if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")){
          curDT = "Today";
        } else if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().subtract(1, 'days').format("YYYY-MM-DD")){
          curDT = "Yesterday";
        }
        $scope.scrollDataList.rad.push({id:rad.id, l:rad.l, h:rad.h, isConfirmed:true, ct:rad.ct, ftm:rad.ftm ,lp:rad.lp, date:curDT});
      })
    }

    $scope.recentAddedDeviceFx = function(caller){
      $scope.isFirst.rad = true;
      $scope.dbListLoading.rad = true;
      $scope.searchText.rad = ""
      $scope.detailListObj.rad = {};
      $scope.scrollDataList.rad = [];
      $scope.allScrollDataList.rad = [];
      $scope.copyScrollObj.rad = {};
      $scope.visibleObjects.rad = [];
      $scope.haveMoreData.rad = false;
      $scope.haveMoreSearchData.rad = false;
      $scope.visibleData.rad = [];
      $scope.stIndex.rad = 0;
      $scope.etIndex.rad = 300;
      $scope.searchScroll.rad = false;

      $scope.detailListObj.rad = {caller:'rad', offset:0};
      DashboardSrv.getScrollDBListData($scope.detailListObj.rad).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.rad = true;
          } else{
            $scope.haveMoreData.rad = false;
          }
          $scope.getRecentAddedDeviceFX(data);
          $scope.addStatusKey($scope.scrollDataList.rad, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.rad =  angular.copy($scope.scrollDataList.rad);
          $scope.dbListLoading.rad = false;
        },
        function(err){
          $scope.dbListLoading.rad = false;
          $log.error(err);
        }
      );
    }
    // $scope.loadMoreRecentAddedDeviceFx = function(offSet){
    //   $rootScope.sessionTimoutFx();
    //   $rootScope.showTimeoutMsg = false;
    //   if(offSet == 0){
    //     $scope.searchText.rad = "";
    //     $scope.allRadLoaded = false;
    //     $scope.curDCData.rad = [];
    //   }
    //   if(!$scope.allRadLoaded && !$scope.dbListLoading.rad && !$scope.recentAddedDeviceLoading){
    //     $scope.recentAddedDeviceLoading = true;
    //     if(offSet == 0){
    //       $scope.dbListLoading.rad = true;
    //     }
    //     DashboardSrv.getRecentAddedDevice($scope.curDCData.rad.length).then(
    //       function(data){
    //         $scope.dbListLoading.rad = false;
    //         $scope.tempRadList = [];
    //         var count = 0;
    //         $scope.recentAddedDeviceLoading = false
    //         if(data && data.length > 0){
    //           angular.forEach(data, function(rad, index){
    //             count++;
    //             var curDT = moment(parseInt(rad.ct + '000')).format("MMM, DD YYYY");
    //             if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")){
    //               curDT = "Today";
    //             } else if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().subtract(1, 'days').format("YYYY-MM-DD")){
    //               curDT = "Yesterday";
    //             }
    //             $scope.tempRadList.push({id:rad.id, label:rad.l, mac:rad.h, isConfirmed:true, ct:rad.ct, icon:rad.ftm ,status:rad.s, date:curDT});
    //           })
    //           if(data.length === count){
    //             $scope.curDCData.rad = $scope.curDCData.rad.concat($scope.tempRadList);
    //           }
    //         } else{
    //           $scope.allRadLoaded = true;
    //         }

    //       },
    //       function(err){$scope.recentAddedDeviceLoading =  false
    //         $scope.dbListLoading.rad = false;
    //         $log.error(err);
    //       }
    //     );
    //   }
    // }
    // $scope.recentAddedDeviceFx = function(){
    //   $scope.dbListLoading.rad = true;
    //   $scope.searchText.rad = ""
    //   DashboardSrv.getRecentAddedDevice(0).then(
    //     function(data){
    //       $scope.dbListLoading.rad = false;
    //       $scope.rad = data;
    //       $scope.curDCData.rad = [];
    //       angular.forEach($scope.rad, function(rad, index){
    //         var curDT = moment(parseInt(rad.ct + '000')).format("MMM, DD YYYY");
    //         if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")){
    //           curDT = "Today";
    //         } else if(moment(parseInt(rad.ct + '000')).format("YYYY-MM-DD") == moment().subtract(1, 'days').format("YYYY-MM-DD")){
    //           curDT = "Yesterday";
    //         }
    //         $scope.curDCData.rad.push({id:rad.id, label:rad.l, mac:rad.h, isConfirmed:true, ct:rad.ct, icon:rad.ftm ,status:rad.s, date:curDT});
    //       })
    //     },
    //     function(err){
    //       $scope.dbListLoading.rad = false;
    //       $log.error(err);
    //     }
    //   );
    // }
    $scope.deviceTempratureFx = function(caller){
      $scope.isFirst.dtpl = true;
      $scope.dbListLoading.dtpl = true;
      $scope.searchText.dtpl = ""
      $scope.detailListObj.dtpl = {};
      $scope.scrollDataList.dtpl = [];
      $scope.allScrollDataList.dtpl = [];
      $scope.copyScrollObj.dtpl = {};
      $scope.visibleObjects.dtpl = [];
      $scope.haveMoreData.dtpl = false;
      $scope.haveMoreSearchData.dtpl = false;
      $scope.visibleData.dtpl = [];
      $scope.stIndex.dtpl = 0;
      $scope.etIndex.dtpl = 300;
      $scope.searchScroll.dtpl = false;

      $scope.detailListObj.dtpl = {caller:'dtpl', offset:0};
      DashboardSrv.getScrollDBListData($scope.detailListObj.dtpl).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.dtpl = true;
          } else{
            $scope.haveMoreData.dtpl = false;
          }
          $scope.scrollDataList.dtpl = data;
          $scope.addStatusKey($scope.scrollDataList.dtpl, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.dtpl =  angular.copy($scope.scrollDataList.dtpl);
          $scope.dbListLoading.dtpl = false;
        },
        function(err){
          $scope.dbListLoading.dtpl = false;
          $log.error(err);
        }
      );
    }
    // $scope.loadMoreDeviceTempListFx = function(offSet){
    //   $rootScope.sessionTimoutFx();
    //   $rootScope.showTimeoutMsg = false;
    //   if(offSet == 0){
    //     $scope.searchText.dtpl = "";
    //     $scope.allDtplLoaded = false;
    //     $scope.curDCData.dtpl = [];
    //   }
    //   if(!$scope.allDtplLoaded && !$scope.dbListLoading.dtpl && !$scope.deviceTempLoading){
    //     $scope.deviceTempLoading = true;
    //     if(offSet == 0){
    //       $scope.dbListLoading.dtpl = true;
    //     }
    //     DashboardSrv.getTempterature($scope.curDCData.dtpl.length).then(
    //       function(data){
    //         $scope.dbListLoading.dtpl = false;
    //         $scope.deviceTempLoading = false;
    //         if(data && data.length > 0){
    //           $scope.curDCData.dtpl = $scope.curDCData.dtpl.concat(data);
    //         } else{
    //           $scope.allDtplLoaded = true;
    //         }
    //       },
    //       function(err){
    //         $scope.deviceTempLoading = false;
    //         $scope.dbListLoading.dtpl = false;
    //         $log.error(err);
    //       }
    //     );
    //   }
    // }
    // $scope.deviceTempratureFx = function(){
    //   $scope.dbListLoading.dtpl = true;
    //   $scope.searchText.dtpl = ""
    //   DashboardSrv.getTempterature(0).then(
    //     function(data){
    //       $scope.curDCData.dtpl = data;
    //       $scope.dbListLoading.dtpl = false;
    //     },
    //     function(err){
    //       $scope.dbListLoading.dtpl = false;
    //       $log.error(err);
    //     }
    //   );
    // }
    $scope.deviceTempratureSummFx = function(){
      $scope.dbListLoading.dtps = true;
      DashboardSrv.getTempteratureSumm().then(
        function(data){
          $scope.curDCData.dtps = {c:0, d:0, n:0, totalCount:[]};
          $scope.curDCData.dtps.c = data.c;
          $scope.curDCData.dtps.d = data.d;
          $scope.curDCData.dtps.n = data.n;
          $scope.curDCData.dtps.totalCount = $scope.curDCData.dtps.n + $scope.curDCData.dtps.c + $scope.curDCData.dtps.d;
          $scope.tempArr = [];
          var tempOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              pointFormat:'{series.name}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          var curTempArr = [
            {name:$filter("translate")('db.body.14.1'), y:$scope.curDCData.dtps.n, yl:$scope.curDCData.dtps.n, t:"n", color:$scope.dashboard.dsg.pieColors.dtps.no},
            {name:$filter("translate")('db.body.14.2'), y:$scope.curDCData.dtps.c, yl:$scope.curDCData.dtps.c, t:"c", color:$scope.dashboard.dsg.pieColors.dtps.c},
            {name:$filter("translate")('db.body.14.3'), y:$scope.curDCData.dtps.d, yl:$scope.curDCData.dtps.d, t:"d", color:$scope.dashboard.dsg.pieColors.dtps.d}
          ];

          $scope.tempArr = {
            options:tempOpts,
            series:[{
              size:'100%',
              data:curTempArr,
              name:$filter("translate")("cl.widget.count.1"),
              innerSize:'50%',
              cursor:'pointer',
              colorByPoint:true,
              showInLegend:false,
              point:{
                events:{
                  click:function(event){
                    $scope.deviceDetailListFx('dtps', '', this.t);
                  }
                }
              }
            }],
            title:' ',
            xAxis:{categories:[] },
            yAxis:{title:' ' },
          };
          $scope.dbListLoading.dtps = false;
        },
        function(err){
          $scope.dbListLoading.dtps = false;
          $log.error(err);
        }
      );
    }
    $scope.getDptsIds = function(){
      $scope.promises = [];
      angular.forEach($scope.dpts, function(val) {
          var promise = DashboardSrv.getDevicePropSumm('dpts', val.id).then(
              function(data) {
                  val.d = data;
                  $scope.dptsCount++;
              },
              function(err) {
                  $log.error(err);
              }
          );
          $scope.promises.push(promise);
      });

      return Promise.all($scope.promises).then(function() {
          console.log("All getDevicePropSumm calls are done.");
      });
    }
    $scope.devicePropSummFx = function(caller){
      DashboardSrv.getDevicePropSumm().then(
        function(data){
          $scope.dashboardLoading = false;
          $scope.dpts = data;
          // $scope.getDptsIds().then(function() {
          //   $scope.$apply(function(){
              $scope.dptsArr = [];
              var dptsOpts = {
                chart:{
                  width:120,
                  height:120,
                  type:'pie',
                  plotShadow:false,
                  plotBorderWidth:0,
                  margin:[0, 0, 0, 0],
                  backgroundColor:'rgba(0,0,0,0)'
                },
                navigation:{
                  buttonOptions:{
                    enabled:false
                  }
                },
                tooltip:{
                  headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
                  pointFormat:'{point.name}:<b>{point.y}</b>'
                },
                plotOptions:{
                  pie:{
                    cursor:'pointer',
                    dataLabels:{
                      size:'100%',
                      distance:-11,
                      enabled:true,
                      style:{
                        color:'white',
                        fontSize:'10px',
                        textShadow:'0 1px 1px #333333'
                      },
                      showInLegend: false,
                      center: ['50%', '50%']
                    }
                  }
                }
              };

              if(caller != 'update'){
                angular.forEach($scope.dpts, function(dpts, index){
                  var curFilertdDG = $filter("filter")($scope.dashboard.dGrid, {l:dpts.l }, true);
                  if(curFilertdDG.length){
                    if($filter('lowercase')(dpts.l) == $filter('lowercase')(curFilertdDG[0].l)){
                      curFilertdDG[0].sty = index;
                      $scope.dGridArr.push(curFilertdDG[0]);
                    } else{
                    }
                  } else{
                    $scope.dGridArr.push({x:0, y:14, wd:3, hg:2, mh:2, ty:'dpts', sty:index, l:dpts.l});
                  }
                });
              }

              $scope.dpts.total = [];
              angular.forEach($scope.dpts, function(dpts, index){
                var curDptsArr = [];
                var curDptsValArr = [];
                var dptsTotal = [];
                angular.forEach(dpts.d, function(val){
                  curDptsArr.push({name:val.v, y:val.dc, yl:val.dc, total:"sd", title:dpts.l});
                  angular.forEach(val.dc, function(dc){
                    dptsTotal.push(dc);
                    curDptsValArr.push(dc);
                  });
                });
                dpts.total = [];
                angular.forEach(curDptsValArr, function(val){
                  dpts.total.push(val);
                });

                $scope.dptsArr.push(
                  {
                    options:dptsOpts,
                    series:[{
                      size:'100%',
                      data:curDptsArr,
                      name:dpts.l,
                      d:dptsTotal,
                      innerSize:'50%',
                      cursor:'pointer',
                      colorByPoint:true,
                      showInLegend:false,
                      point:{
                        events:{
                          click:function(event){
                            $scope.deviceDetailListFx('dpts', '', this.title, this.name);
                          }
                        }
                      }
                    }],
                    title:' ',
                    xAxis:{categories:[] },
                    yAxis:{title:' ' },
                  }
                );
              });
          //   });
          // }, function(err) {
          //   $log.error("An error occurred while fetching device properties summaries", err);
          // });


        },
        function (err) {
          $log.error(err);
        }
      );
    }
    $scope.deviceOtherInfoSummFx = function(caller){
      DashboardSrv.getDeviceOtherInfoSumm().then(
        function(data){
          $scope.dashboardLoading = false;
          $scope.dps = data;
          $scope.dps.total = [];
          $scope.dpsArr = [];
          var dspOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
              pointFormat:'{point.name}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          if(caller != 'update'){
            angular.forEach($scope.dps, function(dps, index){
              var curFilertdDG = $filter("filter")($scope.dashboard.dGrid, {l:dps.l}, true);
              if(curFilertdDG.length){
                if($filter('lowercase')(dps.l) == $filter('lowercase')(curFilertdDG[0].l)){
                  curFilertdDG[0].sty = index;
                  $scope.dGridArr.push(curFilertdDG[0]);
                }
              } else{
                $scope.dGridArr.push({x:0, y:14, wd:3, hg:2, mh:2, ty:'dps', sty:index, l:dps.l});
              }
            });
          }

          angular.forEach($scope.dps, function(dps, index){
            var curDpsArr = [];
            var curDpsValArr = [];
            var dpsTotal = 0;
            angular.forEach(dps.d, function(val){
              curDpsArr.push({name:val.v, y:val.dc, yl:val.dc, total:"sd", title:dps.l});
              dpsTotal = val.dc
              // angular.forEach(val.dc, function(dc){
              //   dpsTotal(dc);
              //   curDpsValArr.push(dc);
              // });
            });

            dps.total = [];
            angular.forEach(curDpsValArr, function(val){
              dps.total.push(val);
            });

            $scope.dpsArr.push(
              {
                options:dspOpts,
                series:[{
                  size:'100%',
                  data:curDpsArr,
                  d:dpsTotal,
                  name:dps.l,
                  innerSize:'50%',
                  cursor:'pointer',
                  colorByPoint:true,
                  showInLegend:false,
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('dps', '', this.title, this.name);
                      }
                    }
                  }
                }],
                title:' ',
                xAxis:{categories:[] },
                yAxis:{title:' ' },
              }
            );
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.ssdtFx = function(caller){
      DashboardSrv.getSsdt().then(
        function(data){
          $scope.dashboardLoading = false;
          $scope.ssdt = data;
          $scope.curDCData.ssdt = [];

          angular.forEach($scope.ssdt, function(ssdt, key){
            for (var i = 0; i < ssdt.d.length; i++){
              $scope.curDCData.ssdt.push({online:ssdt.d[i].onc , offline:ssdt.d[i].ofc,total:ssdt.d[i].dc, label:ssdt.d[i].v, category:ssdt.l});
            }
          })
          $scope.ssdtCopyObj = angular.copy($scope.curDCData.ssdt);
          $scope.ssdtArr = [];
          var ssdtOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
              pointFormat:'{point.status}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          if(caller != 'update'){
            angular.forEach($scope.curDCData.ssdt, function(ssdt, index){
              var curFilertdSSDT = $filter("filter")($scope.dashboard.dGrid, {ty:"ssdt", ctg:ssdt.category, l:ssdt.label }, true);
              if(curFilertdSSDT.length){
                if($filter('lowercase')(ssdt.category) == $filter('lowercase')(curFilertdSSDT[0].ctg) && $filter('lowercase')(ssdt.label) == $filter('lowercase')(curFilertdSSDT[0].l)){
                  curFilertdSSDT[0].sty = index;
                  $scope.dGridArr.push(curFilertdSSDT[0]);
                }
              } else{
                $scope.dGridArr.push({x:0, y:16, wd:3, hg:2, mh:2, ty:'ssdt', sty:index, l:ssdt.label, ctg:ssdt.category});
              }
            });
          }

          angular.forEach($scope.curDCData.ssdt, function(ssdt, index){
            var curSsdtArr = [
              {name:ssdt.label, status:$filter("translate")('d.tool.1'), category:ssdt.category, y:ssdt.online, yl:ssdt.online, total:ssdt.total, color:$scope.dashboard.dsg.pieColors.ssdt.on },
              {name:ssdt.label, status:$filter("translate")('d.tool.2'), category:ssdt.category, y:ssdt.offline, yl:ssdt.offline, total:ssdt.total, color:$scope.dashboard.dsg.pieColors.ssdt.off }
            ];
            $scope.ssdtArr.push(
              {
                options:ssdtOpts,
                series:[{
                  size:'100%',
                  data:curSsdtArr,
                  name:ssdt.category,
                  innerSize:'50%',
                  cursor:'pointer',
                  colorByPoint:true,
                  showInLegend:false,
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('ssdt', this.status=='Online'?'onc':'ofc', this.category, this.name);
                      }
                    }
                  }
                }],
                title:' ',
                xAxis:{categories:[] },
                yAxis:{title:' ' },
              }
            );
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.ssdptFx = function(caller){
      DashboardSrv.getSsdpt().then(
        function(data){
          $scope.dashboardLoading = false;
          $scope.ssdpt = data;
          $scope.curDCData.ssdpt = []

          angular.forEach($scope.ssdpt, function(ssdpt, key){
            for (var i = 0; i < ssdpt.d.length; i++){
              $scope.curDCData.ssdpt.push({online:ssdpt.d[i].onc , offline:ssdpt.d[i].ofc ,total:ssdpt.d[i].dc, label:ssdpt.d[i].v, category:ssdpt.l,id:ssdpt.id});
            }
          })
          $scope.ssdptCopyObj = angular.copy($scope.curDCData.ssdpt);
          $scope.ssdptArr = [];
          var ssdptOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
              pointFormat:'{point.status}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          if(caller != 'update'){
            angular.forEach($scope.curDCData.ssdpt, function(ssdpt, index){
              var curFilertdSSDPT = $filter("filter")($scope.dashboard.dGrid, {ty:"ssdpt", ctg:ssdpt.category, l:ssdpt.label }, true);

              if(curFilertdSSDPT.length){
                if($filter('lowercase')(ssdpt.category) == $filter('lowercase')(curFilertdSSDPT[0].ctg) && $filter('lowercase')(ssdpt.label) == $filter('lowercase')(curFilertdSSDPT[0].l)){
                  curFilertdSSDPT[0].sty = index;
                  $scope.dGridArr.push(curFilertdSSDPT[0]);
                }
              } else{
                $scope.dGridArr.push({x:0, y:16, wd:3, hg:2, mh:2, ty:'ssdpt', sty:index, l:ssdpt.label, ctg:ssdpt.category});
              }
            });
          }

          angular.forEach($scope.curDCData.ssdpt, function(ssdpt, index){
            var curSsdptArr = [
              {name:ssdpt.label, status:$filter("translate")('d.tool.1'), category:ssdpt.category, y:ssdpt.online, yl:ssdpt.online, total:ssdpt.total, color:$scope.dashboard.dsg.pieColors.ssdpt.on },
              {name:ssdpt.label, status:$filter("translate")('d.tool.2'), category:ssdpt.category, y:ssdpt.offline, yl:ssdpt.offline, total:ssdpt.total, color:$scope.dashboard.dsg.pieColors.ssdpt.off }
            ];
            $scope.ssdptArr.push(
              {
                options:ssdptOpts,
                series:[{
                  size:'100%',
                  data:curSsdptArr,
                  name:ssdpt.category,
                  innerSize:'50%',
                  cursor:'pointer',
                  colorByPoint:true,
                  showInLegend:false,
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('ssdpt', this.status=='Online'?'onc':'ofc', this.category, this.name);
                      }
                    }
                  }
                }],
                title:' ',
                xAxis:{categories:[] },
                yAxis:{title:' ' },
              }
            );
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.ssodtFx = function(caller){
      $scope.dbListLoading.ssodt = true;
      DashboardSrv.getSsodt().then(
        function(data){
          $scope.curDCData.ssodt = data
          $scope.ssodtCopyObj = angular.copy($scope.curDCData.ssodt);
          $scope.ssodtArr = [];
          var ssodtOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              headerFormat:'<span style="font-size:10px">{series.name}</span><br/>',
              pointFormat:'{point.status}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          if(caller != 'update'){
            angular.forEach($scope.curDCData.ssodt, function(ssodt, index){
              var curFilertdSSODT = $filter("filter")($scope.dashboard.dGrid, {ty:'ssodt',ctg:ssodt.category, l:ssodt.l }, true);
              if(curFilertdSSODT.length){
                if($filter('lowercase')(ssodt.category) == $filter('lowercase')(curFilertdSSODT[0].ctg) && $filter('lowercase')(ssodt.l) == $filter('lowercase')(curFilertdSSODT[0].l)){
                  curFilertdSSODT[0].sty = index;
                  $scope.dGridArr.push(curFilertdSSODT[0]);
                } else{
                }
              } else{
                $scope.dGridArr.push({x:0, y:16, wd:3, hg:2, mh:2, ty:'ssodt', sty:index, l:ssodt.l, ctg:ssodt.category});
              }
            });
          }

          angular.forEach($scope.curDCData.ssodt, function(ssodt, index){
            var curSsodtLabel = "";
            var ssodtOnline = "";
            var ssodtOffline = "";
            if(ssodt.l == 'mp'){
              curSsodtLabel = $filter("translate")('d.label.1.1');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.mp.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.mp.off;
            } else if(ssodt.l == 'webos'){
              curSsodtLabel = $filter("translate")('d.label.1.5');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.webos.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.webos.off;
            } else if(ssodt.l == 'tizen'){
              curSsodtLabel = $filter("translate")('d.label.1.6');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.tz.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.tz.off;
            } else if(ssodt.l == 'mc'){
              curSsodtLabel = $filter("translate")('d.label.1.4');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.mc.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.mc.off;
            } else if(ssodt.l == 'gf'){
              curSsodtLabel = $filter("translate")('d.label.1.2');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.geo.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.geo.off;
            } else if(ssodt.l == 'v'){
              curSsodtLabel = $filter("translate")('d.label.1.3');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.vd.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.vd.off;
            } else if(ssodt.l == 'desktop'){
              curSsodtLabel = $filter("translate")('d.label.1.7');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.de.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.de.off;
            } else if(ssodt.l == 'epd'){
              curSsodtLabel = $filter("translate")('d.label.1.8');
              ssodtOnline = $scope.dashboard.dsg.pieColors.ssodt.epd.on;
              ssodtOffline = $scope.dashboard.dsg.pieColors.ssodt.epd.off;
            }
            var curSsodtArr = [
              {name:curSsodtLabel, status:$filter("translate")('d.tool.1'), category:ssodt.category, y:ssodt.online, yl:ssodt.online, total:ssodt.total, color:ssodtOnline },
              {name:curSsodtLabel, status:$filter("translate")('d.tool.2'), category:ssodt.category, y:ssodt.offline, yl:ssodt.offline, total:ssodt.total, color:ssodtOffline }
            ];
            $scope.ssodtArr.push(
              {
                options:ssodtOpts,
                series:[{
                  size:'100%',
                  data:curSsodtArr,
                  name:curSsodtLabel,
                  innerSize:'50%',
                  cursor:'pointer',
                  colorByPoint:true,
                  showInLegend:false,
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('ssodt', this.status == 'Online' ? 'onc': 'ofc', ssodt.l, 'rem');
                      }
                    }
                  }
                }],
                title:' ',
                xAxis:{categories:[] },
                yAxis:{title:' ' },
              }
            );
          });
        },
        function(err){
          $scope.dbListLoading.ssodt = false;
          $log.error(err);
        }
      );
    }
    $scope.loadMoreContentConfirmationFx = function(offSet){
      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;
      if(offSet == 0){
        $scope.searchText.ccl = "";
        $scope.allCclLoaded = false;
        $scope.curDCData.ccl = [];
      }
      if(!$scope.allCclLoaded && !$scope.dbListLoading.ccl && !$scope.ccloading){
        $scope.ccloading = true;
        if(offSet == 0){
          $scope.dbListLoading.ccl = true;
        }
        if($scope.searchText.ccl.length){
          DashboardSrv.getContentConfirmationSearch($scope.curDCData.ccl.length, $scope.searchText.ccl).then(
            function(data){
              $scope.dbListLoading.ccl = false;
              $scope.ccloading = false;
              if(data && data.cc.length > 0){
                $scope.curDCData.ccl = $scope.curDCData.ccl.concat(data.cc);
              } else{
                $scope.allCclLoaded = true;
              }
            },
            function(err){
              $scope.ccloading = false;
              $scope.dbListLoading.ccl = false;
              $log.error(err);
            }
          );
        } else{
          DashboardSrv.getContentConfirmation($scope.curDCData.ccl.length).then(
            function(data){
              $scope.dbListLoading.ccl = false;
              $scope.ccloading = false;
              if(data && data.cc.length > 0){
                $scope.curDCData.ccl = $scope.curDCData.ccl.concat(data.cc);
              } else{
                $scope.allCclLoaded = true;
              }
            },
            function(err){
              $scope.ccloading = false;
              $scope.dbListLoading.ccl = false;
              $log.error(err);
            }
          );
        }
      }
    }
    $scope.changeTabFx = function(tab){
      $scope.isPopupOpen = true;
      if(tab == 1){
        $scope.quadId = "c"
      } else{
        $scope.quadId = "nc"
      }
      $scope.detailListObj[$scope.quadId] = {};
      $scope.scrollDataList[$scope.quadId] = [];
      $scope.allScrollDataList[$scope.quadId] = [];
      $scope.copyScrollObj[$scope.quadId] = {};
      $scope.visibleObjects[$scope.quadId] = [];
      $scope.haveMoreData[$scope.quadId] = false;
      $scope.haveMoreSearchData[$scope.quadId] = false;
      $scope.visibleData[$scope.quadId] = [];
      $scope.stIndex[$scope.quadId] = 0;
      $scope.etIndex[$scope.quadId] = 300;
      $scope.searchScroll[$scope.quadId] = false;

      $scope.detailListObj[$scope.quadId] = {caller:$scope.cclObjList.caller, offset:$scope.cclObjList.offset, id: $scope.cclObjList.id, label: $scope.cclObjList.label, type:$scope.cclObjList.type};
      $scope.detailLoading = true;
      if(tab == 1){
        $scope.selectedT = 1;
        $scope.detailListObj[$scope.quadId].caller = "c";
      } else{
        $scope.selectedT = 2;
        $scope.detailListObj[$scope.quadId].caller = "nc";
      }
      DashboardSrv.getScrollDBListData($scope.detailListObj[$scope.quadId]).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData[$scope.quadId] = true;
          } else{
            $scope.haveMoreData[$scope.quadId] = false;
          }
          $scope.scrollDataList[$scope.quadId] = data;
          $scope.addStatusKey($scope.scrollDataList[$scope.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[$scope.quadId] =  angular.copy($scope.scrollDataList[$scope.quadId]);
          $scope.curCcl = {id:$scope.detailListObj[$scope.quadId].id};
          $scope.detailLoading = false;
        },
        function(err){
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.cclOpenList = function(id, label){
      $scope.cclObjList = {caller:'c', offset:0, id: id, label: label, type:'ccl'};
      $scope.changeTabFx(1);
      ngDialog.open({
        template:'app/dashboard/popup/ccDevice.html',
        width:650,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          $scope.getDashboard("update");
          if($rootScope.isDBEdit == "e"){
            $scope.dgOptionsFx("e");
          }
          $scope.isPopupOpen = false;
          $scope.allCclLoaded = false;
          $interval.cancel($rootScope.isStatusInterval);
        }
      });
    }
    // $scope.cclOpenList = function(id, label){
    //   $scope.detailLoading = true;
    //   DashboardSrv.getCclDetail(id).then(
    //     function(data){
    //       angular.forEach(data.cd, function(obj1){
    //         obj1.isConfirmed = true;
    //       })
    //       angular.forEach(data.ud, function(obj2){
    //         obj2.isConfirmed = false;
    //       })
    //       $scope.cCount = data.cd
    //       $scope.ncCount = data.ud
    //       $scope.curCcl = {devices:[], l:label};
    //       $scope.curCcl.devices = $scope.cCount.concat($scope.ncCount);
    //       $scope.detailLoading = false;
    //       $scope.cOpen = true;
    //       $scope.ncOpen = true;
    //     },
    //     function(err){
    //       $scope.detailLoading = false;
    //       $log.error(err);
    //     }
    //   );

    //   $rootScope.isDInterval = $interval(function(){
    //     DashboardSrv.getCclDetail(id).then(
    //       function(data){
    //         $scope.cCount = data.cd
    //         $scope.ncCount = data.ud
    //         $scope.detailLoading = false;
    //         $scope.cOpen = true;
    //         $scope.ncOpen = true;
    //       },
    //       function(err){
    //         $scope.detailLoading = false;
    //         $log.error(err);
    //       }
    //     );
    //   }, 10000);
    //   ngDialog.open({
    //     template:'app/dashboard/popup/ccDevice.html',
    //     width:650,
    //     scope:$scope,
    //     closeByDocument:false,
    //     preCloseCallback:function(){
    //       if($rootScope.isDBEdit == "e"){
    //         $scope.dgOptionsFx("e");
    //       }
    //       $interval.cancel($rootScope.isDInterval);
    //     }
    //   });
    // }

    $scope.contentConfirmationSummFx = function(){
      $scope.dbListLoading.ccs = true;
      $scope.dbListLoading.ccl = true;
      $scope.searchText.ccl = ""
      DashboardSrv.getContentConfirmationSumm().then(
        function(data){
          $scope.curDCData.ccl = [];
          $scope.curDCData.ccs = {down:0, no:0, rem:0, total:0};
          $scope.curDCData.dccl = {
            ofcc:0,/*Offline & confirmed content*/
            offline:0,/*not*/
            ofncc:0,/*Offline & not confirmed content*/
            ofnsd:0,/*not*/
            oncc:0,/*Online & confirmed content*/
            online:0,/*not*/
            onncc:0,/*Online & not confirmed content*/
            onnsd:0,/*not*/
            nosd:0,/*Devices without downloadable content*/
            totalCount:0
          };
          if(data.ccs){
            $scope.curDCData.ccs = {down:data.ccs.ccs.down, no:data.ccs.ccs.no, rem:data.ccs.ccs.rem, total:data.ccs.ccs.tc};
            $scope.curDCData.dccl = {ofcc:data.ccs.dccl.ofcc, offline:data.ccs.dccl.offline, ofncc:data.ccs.dccl.ofncc, ofnsd:data.ccs.dccl.ofnsd, oncc:data.ccs.dccl.oncc, online:data.ccs.dccl.online, onncc:data.ccs.dccl.onncc, onnsd:data.ccs.dccl.onnsd, nosd:data.ccs.dccl.nosd, totalCount:data.ccs.dccl.tc};
            $scope.dcclCopyObj = angular.copy($scope.curDCData.dccl);
          }
          if(data.cids && data.cids.length){
            $scope.curDCData.cids = data.cids;
          }
          if($scope.dashboard.dbd.ccs && ($scope.curDCData.ccs.down || $scope.curDCData.ccs.no || $scope.curDCData.ccs.rem)){
            $scope.downArr = [];
            var downOpts = {
              chart: {
                width: 120,
                height: 120,
                type: 'pie',
                plotShadow: false,
                plotBorderWidth: 0,
                margin: [0, 0, 0, 0],
                backgroundColor: 'rgba(0,0,0,0)'
              },
              navigation: {
                buttonOptions: {
                  enabled: false
                }
              },
              tooltip: {
                pointFormat: '{series.name}:<b>{point.y}</b>'
              },
              plotOptions: {
                pie: {
                  cursor: 'pointer',
                  dataLabels: {
                    size: '100%',
                    distance: -11,
                    enabled: true,
                    style: {
                      color: 'white',
                      fontSize: '10px',
                      textShadow: '0 1px 1px #333333'
                    },
                    formatter: function () {
                      return this.y;
                    }
                  },
                  showInLegend: false,
                  center: ['50%', '50%']
                }
              }
            };

            var curDownArr = [
              {name:$filter("translate")('db.body.13.1'), y:$scope.curDCData.ccs.down, yl:$scope.curDCData.ccs.down, color:$scope.dashboard.dsg.pieColors.ccs.d },
              {name:$filter("translate")('db.body.13.2'), y:$scope.curDCData.ccs.rem, yl:$scope.curDCData.ccs.rem, color:$scope.dashboard.dsg.pieColors.ccs.r },
              {name:$filter("translate")('db.body.13.3'), y:$scope.curDCData.ccs.no, yl:$scope.curDCData.ccs.no, color:$scope.dashboard.dsg.pieColors.ccs.ns }
            ];

            $scope.downArr = {
              options:downOpts,
              series:[{
                size:'100%',
                data:curDownArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.deviceDetailListFx('ccs', '', this.name == 'Confirmed'? 'down': this.name == 'Unconfirmed'? 'rem' : 'no');
                    }
                  }
                }
              }],
              title: ' ',
              xAxis: { categories: [] },
              yAxis: { title: ' ' },
            };
          }
          if($scope.dashboard.dbd.dccl && $scope.curDCData.dccl.totalCount > 0){
            $scope.dcclArr = [];
            var dcclOpts = {
              chart: {
                width: 120,
                height: 120,
                type: 'pie',
                plotShadow: false,
                plotBorderWidth: 0,
                margin: [0, 0, 0, 0],
                backgroundColor: 'rgba(0,0,0,0)'
              },
              navigation: {
                buttonOptions: {
                  enabled: false
                }
              },
              tooltip: {
                pointFormat: '{series.name}:<b>{point.y}</b>',
                outside: true
              },
              plotOptions: {
                pie: {
                  cursor: 'pointer',
                  borderWidth: 2,
                  dataLabels: {
                    overflow: "allow",
                    size: '100%',
                    enabled: true,
                    style: {
                      color: 'white',
                      fontSize: '10px',
                      textShadow: '0 1px 1px #333333'
                    },
                    formatter: function () {
                      return this.y;
                    }
                  },
                  showInLegend: false,
                  center: ['50%', '50%']
                }
              }
            };

            var curDcclArr = [
              {
                label:"cc", //confirm content
                name:$filter("translate")("db.body.13.1"),
                y:$scope.curDCData.dccl.oncc + $scope.curDCData.dccl.ofcc,
                yl:$scope.curDCData.dccl.oncc + $scope.curDCData.dccl.ofcc,
                color:$scope.dashboard.dsg.pieColors.dccl.cc,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"poncc", y:$scope.curDCData.dccl.oncc, yl:$scope.curDCData.dccl.oncc, color:$scope.dashboard.dsg.pieColors.dccl.oncc },
                    {name:$filter("translate")("d.tool.2"), label:"pofcc", y:$scope.curDCData.dccl.ofcc, yl:$scope.curDCData.dccl.ofcc, color:$scope.dashboard.dsg.pieColors.dccl.ofcc }
                  ]
                }
              },
              {
                label:"ncc",  //unconfirm content
                name:$filter("translate")("db.body.21.7"),
                y:$scope.curDCData.dccl.onncc + $scope.curDCData.dccl.ofncc,
                yl:$scope.curDCData.dccl.onncc + $scope.curDCData.dccl.ofncc,
                color:$scope.dashboard.dsg.pieColors.dccl.ncc,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"ponncc", y:$scope.curDCData.dccl.onncc, yl:$scope.curDCData.dccl.onncc, color:$scope.dashboard.dsg.pieColors.dccl.onncc },
                    {name:$filter("translate")("d.tool.2"), label:"pofncc", y:$scope.curDCData.dccl.ofncc, yl:$scope.curDCData.dccl.ofncc, color:$scope.dashboard.dsg.pieColors.dccl.ofncc }
                  ]
                }
              },
              {
                label:"nsd",   //without schedule
                name:$filter("translate")("db.body.21.6"),
                y:$scope.curDCData.dccl.nosd,
                yl:$scope.curDCData.dccl.nosd,
                color:$scope.dashboard.dsg.pieColors.dccl.nsd,
                drilldown:{
                  data:[
                    {name:$filter("translate")("d.tool.1"), label:"onnsd", y:$scope.curDCData.dccl.onnsd, yl:$scope.curDCData.dccl.onnsd, color:$scope.dashboard.dsg.pieColors.dccl.onnsd },
                    {name:$filter("translate")("d.tool.2"), label:"ofnsd", y:$scope.curDCData.dccl.ofnsd, yl:$scope.curDCData.dccl.ofnsd, color:$scope.dashboard.dsg.pieColors.dccl.ofnsd },
                  ]
                }
              }
            ];
            var
              innerData = [],
              outerData = [],
              drillDataLen,
              brightness;

            // Build the data arrays
            for (var i = 0; i < curDcclArr.length; i += 1) {
              // add inner data
              innerData.push({
                name:curDcclArr[i].name,
                label:curDcclArr[i].label,
                y:curDcclArr[i].y,
                yl:curDcclArr[i].yl,
                color:curDcclArr[i].color
              });

              // add outer data
              drillDataLen = curDcclArr[i].drilldown.data.length;
              for (var j = 0; j < drillDataLen; j += 1) {
                brightness = 0.2 - (j / drillDataLen) / 5;
                outerData.push({
                  name:curDcclArr[i].drilldown.data[j].name,
                  label:curDcclArr[i].drilldown.data[j].label,
                  y:curDcclArr[i].drilldown.data[j].y,
                  yl:curDcclArr[i].drilldown.data[j].yl,
                  color:curDcclArr[i].drilldown.data[j].color
                });
              }
            }
            $scope.dcclArr = {
              options: dcclOpts,
              series: [
                {//inner
                  name: $filter("translate")("cl.widget.count.1"),
                  data: innerData,
                  size: '55%',
                  dataLabels: {
                    formatter: function () {
                      return this.y
                    },
                    distance: -16,
                  },
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('dccl', '', this.label);
                      }
                    }
                  }
                },
                {//outer
                  name: $filter("translate")("cl.widget.count.1"),
                  data: outerData,
                  size: '100%',
                  innerSize: '55%',
                  dataLabels: {
                    formatter: function () {
                      return this.y
                    },
                    distance: -11,
                  },
                  id:'versions',
                  point:{
                    events:{
                      click:function(event){
                        $scope.deviceDetailListFx('dccl', '', this.label);
                      }
                    }
                  }
                }
              ],
              title: ' ',
              xAxis: {},
              yAxis: { title: ' ' },
            }
          }
          if(data.cc.length){
            $scope.curDCData.ccl = data.cc;
            $scope.haveDataList.ccl = true;
          }
          $scope.dbListLoading.ccl = false;
          $scope.dbListLoading.ccs = false;
        },
        function(err){
          $scope.dbListLoading.ccs = false;
          $scope.dbListLoading.ccl = false;
          $log.error(err);
        }
      );
    }
    $scope.hubspotTicketFx = function(){
      DashboardSrv.getTicketCounts($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId).then(
        function(data){
          $scope.dashboard.ot = data;
          if($scope.dashboard.ot.total > 0){
            $scope.otArr = [];
            var otOpts = {
              chart:{
                width:120,
                height:120,
                type:'pie',
                plotShadow:false,
                plotBorderWidth:0,
                margin:[0, 0, 0, 0],
                backgroundColor:'rgba(0,0,0,0)'
              },
              navigation: {
                buttonOptions: {
                  enabled: false
                }
              },
              tooltip: {
                pointFormat: '{series.name}:<b>{point.y}</b>'
              },
              plotOptions:{
                pie:{
                  // allowPointSelect:true,
                  cursor:'pointer',
                  dataLabels:{
                    size:'100%',
                    distance:-11,
                    enabled:true,
                    style:{
                      color:'white',
                      fontSize:'10px',
                      textShadow:'0 1px 1px #333333'
                    },
                    formatter: function () {
                      return this.y;
                    }
                  },
                  showInLegend: false,
                  center: ['50%', '50%']
                }
              }
            };

            var curOtArr = [
              {name:$filter("translate")('ms.label.35.15.3'), y:$scope.dashboard.ot.o, type:'o', color:$scope.dashboard.dsg.pieColors.ot.ot },
              {name:$filter("translate")('ms.label.35.15.4'), y:$scope.dashboard.ot.r, type:'r', color:$scope.dashboard.dsg.pieColors.ot.t }
            ];

            $scope.otArr = {
              options:otOpts,
              series:[{
                size:'100%',
                data:curOtArr,
                name:$filter("translate")("cl.widget.count.1"),
                innerSize:'50%',
                cursor:'pointer',
                colorByPoint:true,
                showInLegend:false,
                point:{
                  events:{
                    click:function(event){
                      $scope.deviceTicketOpen('ot', this.type);
                    }
                  }
                }
              }],
              credits:{enabled:false },
              title:' ',
              xAxis:{categories:[] },
              yAxis:{title:' ' }
            }
          }
        },
        function (err) {
          $log.error(err);
        }
      );
    }
    $scope.deviceListOnMap = function(caller){
      $scope.dbListLoading.dlom = true;
      $scope.markerList = [];
      $scope.getMapNewData ={type: "FeatureCollection",features: []}
      DashboardSrv.getDeviceListOnMap().then(
        function(data){
          $scope.dbListLoading.dlom = false;
          var splitObj = []
          angular.forEach(data, function(obj){
            splitObj = obj.split('|')
            $scope.markerList.push({latitude:Number(splitObj[4]), longitude:Number(splitObj[5]), status:(splitObj[1]==1)? "online":"offline", label:splitObj[2], mac:splitObj[3]});
          })

          if ($scope.auth.uservices.m == "b") {
            // if (caller == "refresh") {
              $scope.tryLoadBingMap();
            // }
          } else {
            NgMap.getMap().then(function (map) {
              dashboardCtrl.map = map;
              if ($scope.markerList.length == 1 && map.getZoom() > 4) {
                setTimeout(function () {
                  map.setZoom(7);
                }, 200);
              }
            });
          }
        },
        function(err){
          $scope.dbListLoading.dlom = false;
          $log.error(err);
        }
      );
    }


    $scope.isPopupOpen = false;
    $scope.deviceDetailListFx = function(caller, status, name, value){
      $scope.isPopupOpen = true;

      $scope.quadId = caller;

      $scope.detailListObj[$scope.quadId] = {};
      $scope.scrollDataList[$scope.quadId] = [];
      $scope.allScrollDataList[$scope.quadId] = [];
      $scope.copyScrollObj[$scope.quadId] = {};
      $scope.visibleObjects[$scope.quadId] = [];
      $scope.haveMoreData[$scope.quadId] = false;
      $scope.haveMoreSearchData[$scope.quadId] = false;
      $scope.visibleData[$scope.quadId] = [];
      $scope.stIndex[$scope.quadId] = 0;
      $scope.etIndex[$scope.quadId] = 300;
      $scope.searchScroll[$scope.quadId] = false;
      if($scope.quadId == 'wgws'){
        $scope.detailListObj[$scope.quadId] = {caller:caller, status:status, name:name, value:value, offset:0, tz:$rootScope.offsetFormatted};
      } else{
        $scope.detailListObj[$scope.quadId] = {caller:caller, status:status, name:name, value:value, offset:0};
      }
      // $scope.deviceDetailsList = [];
      $scope.detailLoading = true;
      DashboardSrv.getScrollDBListData($scope.detailListObj[$scope.quadId]).then(
        function(data){
          var source = document.getElementById("source");
          if(source != null){
            $scope.textValue = source.innerText;
          }
          if(data.length >= 1000){
            $scope.haveMoreData[$scope.quadId] = true;
          } else{
            $scope.haveMoreData[$scope.quadId] = false;
          }
          if($scope.quadId == 'wgws' && data.length){
            $scope.getExpirySoonDevice(data, 'wgws');
          } else{
            $scope.scrollDataList[$scope.quadId] = data;
          }
          $scope.addStatusKey($scope.scrollDataList[$scope.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[$scope.quadId] =  angular.copy($scope.scrollDataList[$scope.quadId]);
          $scope.detailLoading = false;
        },
        function(err){
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
      // DashboardSrv.deviceDetailNew($scope.detailListObj).then(
      //   function(data){
      //     var source = document.getElementById("source");
      //     $scope.textValue = source.innerText;
      //     $scope.deviceDetailsList = data;
      //     $scope.detailLoading = false;
      //   },
      //   function(err){
      //     $scope.detailLoading = false;
      //     $log.error(err);
      //   }
      // );
      // $rootScope.isDInterval = $interval(function(){
      //   DashboardSrv.deviceDetailNew($scope.detailListObj).then(
      //     function(data){
      //       $scope.deviceDetailsList = [];
      //       $scope.deviceDetailsList = data;
      //       $scope.detailLoading = false;
      //       $scope.loadingDetail = false;
      //     },
      //     function(err){
      //       $scope.detailloadingDetail = false;
      //       $scope.loading = false;
      //       $log.error(err);
      //     }
      //   );
      // }, 20000);
      // $scope.getDashboard("update");
      ngDialog.open({
        template:'app/dashboard/popup/detailListClick.html',
        width:700,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          // $interval.cancel($rootScope.isDInterval);
          $scope.uiVersionFx();
          // $scope.dashboardLoading = true;
          // $scope.getGrid();
          $scope.getDashboard("update");
          if($rootScope.isDBEdit == "e"){
            $scope.dgOptionsFx("e");
          }
          $scope.isPopupOpen = false;
          $interval.cancel($rootScope.isStatusInterval);
        }
      });
    }

    $scope.detailsOpen = function (caller, label, arr, status, name, tId, fType, isDeviceId) {
      $scope.detailsObj = { caller: caller, label: label, dCount: arr.length, deviceDetails: [], status: status, name: name, tId: tId, fType: fType, isDeviceId: isDeviceId };
      $scope.tDetailsObj = { caller: caller, label: label, arr: arr, status: status, name: name, tId: tId, fType: fType };

      if(arr.length){
        $scope.detailLoading = true;
        if ($scope.detailsObj.caller == "ot") {
          $scope.detailsObj.tId = tId;
          if (isDeviceId) {
            $scope.stringIds = arr = $scope.arraytoStringFx(arr); /*Array to String common with ID*/
            $scope.payloadObj = { devices: arr };
          } else {
            $scope.stringIds = arr = $scope.arraytoStringMacFx(arr); /*Array to String common with MAC*/
            $scope.payloadObj = { macs: arr };
          }
        } else {
          $scope.payloadObj = { devices: arr };
        }
        DashboardSrv.deviceDetail($scope.payloadObj).then(
          function (data) {
            var source = document.getElementById("source");
            $scope.textValue = source.innerText;
            $scope.detailsObj.deviceDetails = data;

            /** Below code is commented because we are now sending device ids acc to status */
            // if($scope.detailsObj.caller == "ds" && angular.lowercase(label) == "total"){
            //   $scope.detailsObj.deviceDetails = data;
            // }
            // if($scope.detailsObj.caller != "ds"){
            //   $scope.detailsObj.deviceDetails = data;
            // }
            // angular.forEach(data, function(device){
            //   if($scope.detailsObj.caller == "ds" && (angular.lowercase(label) == "online" || fType == "online")){
            //     if(device.status == "online"){
            //       $scope.detailsObj.deviceDetails.push(device);
            //     }
            //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase(label) == "offline" || fType == "offline")){
            //     if(device.status == "offline"){
            //       $scope.detailsObj.deviceDetails.push(device);
            //     }
            //   }
            // });
            $scope.detailLoading = false;
          },
          function (err) {
            $scope.detailLoading = false;
            $log.error(err);
          }
        );
        $rootScope.isDInterval = $interval(function () {
          DashboardSrv.deviceDetail($scope.payloadObj).then(
            function (data) {
              $scope.detailsObj.deviceDetails = [];
              $scope.detailsObj.deviceDetails = data;

              /** Below code is commented because we are now sending device ids acc to status */
              // if($scope.detailsObj.caller == "ds" && angular.lowercase($scope.tDetailsObj.label) == "total"){
              // }
              // if($scope.detailsObj.caller != "ds"){
              //   $scope.detailsObj.deviceDetails = data;
              // }
              // angular.forEach(data, function(device){
              //   if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "online" || $scope.tDetailsObj.fType == "online")){
              //     if(device.status == "online"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "offline" || $scope.tDetailsObj.fType == "offline")){
              //     if(device.status == "offline"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   }
              // });

              if (caller == "dccl") {
                if (label == "ofncc" || label == "ofcc") {
                  $scope.offDArr = [];
                  angular.forEach(data, function (device) {
                    if (device.status == "offline") {
                      $scope.offDArr.push(device);
                    }
                  });
                  $scope.detailsObj.deviceDetails = $scope.offDArr;
                } else if (label == "onncc" || label == "oncc") {
                  $scope.onDArr = [];
                  angular.forEach(data, function (device) {
                    if (device.status == "online") {
                      $scope.onDArr.push(device);
                    }
                  });
                  $scope.detailsObj.deviceDetails = $scope.onDArr;
                }
              }
              $scope.detailLoading = false;
              $scope.loadingDetail = false;
            },
            function (err) {
              $scope.detailloadingDetail = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }, 10000);
      }
      ngDialog.open({
        template: 'app/dashboard/popup/detailList.html',
        width: 700,
        scope: $scope,
        closeByDocument: false,
        preCloseCallback: function () {
          $interval.cancel($rootScope.isDInterval);
          $scope.uiVersionFx();
          $scope.getDashboard();
          if ($rootScope.isDBEdit == "e") {
            $scope.dgOptionsFx("e");
          }
        }
      });
    }

    $scope.tryLoadBingMap = function () {
      if ($scope.isMapScriptLoaded) {
        $scope.getMapNewData = { type: "FeatureCollection", features: [] }
        // Integrate the new code here
        if ($scope.markerList.length) {
          angular.forEach($scope.markerList, function (item) {
            $scope.getMapNewData.features.push({ "type": "Feature", "geometry": { "type": "Point", "coordinates": [item.longitude, item.latitude] }, "properties": { "Name": item.label, "Status": item.status, "Mac": item.mac, "EntityType": item.status } });
          });
        }
        $scope.azureMapFx();
      } else {
        setTimeout(function () { $scope.tryLoadBingMap() }, 1000);
      }
    }

    $scope.deviceTicketOpen = function (count, type) {
      $scope.dataTkObj = { count: count, type: type, ticket: [] };
      if (type == 'o') {
        $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.3');
      } else {
        $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.4');
      }
      $scope.popupLoading = true;
      DashboardSrv.getTicket($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId, $scope.dataTkObj.type).then(
        function (data) {
          $scope.popupLoading = false;
          $scope.dataTkObj.ticket = data;
        },
        function (err) {
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/dashboard/popup/tickets.html',
        width:900,
        scope:$scope,
        data:$scope.dataTkObj,
        closeByDocument:false
      });
    }

    $scope.ticketDetailsOpen = function (thid, tid, devices) {
      $scope.dataTkDetails = { thid: thid, tid: tid, iFrameUrl: "", dIds: [] };
      $scope.popupInLoading = false;
      if ($scope.auth.uType == 4 && devices.length) {
        $scope.popupInLoading = true;
        $scope.arraytoStringFx(devices);
        var deviceIds = $scope.stringIds;
        DashboardSrv.deviceDetail({ devices: deviceIds }).then(
          function (data) {
            $scope.popupInLoading = false;
            if (data.length && data.length == devices.length) {
              $scope.dataTkDetails.dIds = null;
            } else if (data.length && data.length != devices.length) {
              $scope.arraytoStringFx(data);
              $scope.dataTkDetails.dIds = $scope.stringIds;
            } else {
              $scope.dataTkDetails.dIds = 0;
            }
            $scope.ticketDetailsFx();
          },
          function (err) {
            $scope.popupInLoading = false;
            $log.error(err);
          }
        );
      } else {
        $scope.dataTkDetails.dIds = null;
        $scope.ticketDetailsFx();
      }
    }
    $scope.ticketDetailsFx = function () {
      $scope.hostURL = $location.protocol() + "://" + $location.host();
      $scope.timestamp = moment().format('x');
      $scope.dataTkDetails.iFrameUrl = $scope.auth.sd.url + "ticketDetail/?tId=" + $scope.dataTkDetails.thid + "&ids=" + $scope.dataTkDetails.dIds + "&uName=" + $scope.auth.uname + "&email=" + $scope.auth.email + "&uId=" + $scope.auth.uid + "&hostURL=" + $scope.hostURL + "&" + $scope.timestamp;
      ngDialog.open({
        template:'app/dashboard/popup/ticketDetails.html',
        width:"98%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-preview"
     });
    }

    $scope.loadDeviceList = function (caller) {
      $scope.getNewApiFx(caller);
    }
    // $scope.loadMoreDevices = function(){
    //   if($scope.deviceList.length == $scope.dashboard.d.totalCount){
    //     $scope.allDevicesLoaded = true;
    //   }

    //   if(!$scope.allDevicesLoaded){
    //     DashboardSrv.loadMoreDevices($scope.deviceList.length).then(
    //       function(data){
    //         $scope.deviceList = $scope.deviceList.concatevice);
    //       },
    //       function(err){
    //         $log.error(err);
    //       }
    //     );
    //   }
    // }

    $scope.logListFx = function(){
      $scope.logList = []
      $scope.logLoading = true;
      $scope.dbListLoading.ral = true;
      
      $scope.searchText.log = "";

      DashboardSrv.getLogsList(0).then(
        function(data){
          $scope.logLoading = false;
          $scope.dbListLoading.ral = false;
          if(data.logs && data.logs.length > 0){
            $scope.haveDataList.ral = true;
            $scope.logList = data.logs;
            $scope.tim = data.timthumb;
            $scope.uBucket = data.bucket;
          } else{
            $scope.allLogsLoaded = true;
          }
        },
        function(err){
          $scope.logLoading = false;
          $scope.dbListLoading.ral = false;
          $log.error(err);
        }
      );
    }

    $scope.loadMoreLogs = function (count) {
      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;
      if (count == 0) {
        $scope.searchText.log = "";
        $scope.allLogsLoaded = false;
        $scope.logList = [];
      }
      if(!$scope.allLogsLoaded && !$scope.dbListLoading.ral && !$scope.logLoading){
        $scope.logLoading = true;
        if(count == 0){
          $scope.dbListLoading.ral = true;
        }
        if($scope.searchText.log.length){
          console.log("call from here");
          DashboardSrv.getLogsSearchList($scope.logList.length, $scope.searchText.log).then(
            function(data){
              $scope.logLoading = false;
              $scope.dbListLoading.ral = false;
              if(data.logs && data.logs.length > 0){
                $scope.logList = $scope.logList.concat(data.logs);
              } else {
                $scope.allLogsLoaded = true;
              }
            },
            function (err) {
              $scope.logLoading = false;
              $scope.dbListLoading.ral = false;
              $log.error(err);
            }
          );
        } else{
          DashboardSrv.getLogsList($scope.logList.length).then(
            function(data){
              $scope.logLoading = false;
              $scope.dbListLoading.ral = false;
              if(data.logs && data.logs.length > 0){
                $scope.logList = $scope.logList.concat(data.logs);
              } else {
                $scope.allLogsLoaded = true;
              }
            },
            function (err) {
              $scope.logLoading = false;
              $scope.dbListLoading.ral = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.logsOpen = function(){
      $scope.hasErr = false;
      $scope.logs = {module:"a", note:true, noteC:"db.msg.14", date:{startDate:moment().subtract(1, "day")._d, endDate:moment()._d}};
      if($scope.logList.length > 0){
        ngDialog.open({
          template:'app/common/popup/downloadLog.html',
          width:500,
          scope:$scope,
          trapFocus:false,
          data:$scope.logs,
          closeByDocument:false
        });
      }
    }

    $scope.detailedLogFx = function (data) {
      $scope.detailLoading = true;
      $scope.detailedLog = { obj: data, list: [] };
      DashboardSrv.getDetailedLog(data.id).then(
        function (data) {
          $scope.detailedLog.list = data;
          $scope.detailLoading = false;
        },
        function (err) {
          $log.error(err);
          $scope.detailLoading = false;
        }
      );

      ngDialog.open({
        template:'app/dashboard/popup/detailedLog.html',
        width:600,
        scope:$scope,
        data:$scope.detailedLog,
        closeByDocument:false
      });
    }

    $scope.downloadListFx = function (caller, val, ids) {
      var downloadObj = { type: caller, devices: [] };
      var isPost = false;
      if (caller == "ds" || caller == "dts") {
        isPost = true;
        downloadObj.devices = val;
      } else if (caller == "rad") {
        isPost = true;
        $scope.arraytoStringFx(val); /*Array to String common*/
        downloadObj.devices = $scope.stringIds;
      } else if (caller == "dps" || caller == "ssdt" || caller == "ssodt" || caller == "dpts" || caller == "ssdpt") {
        isPost = true;
        if (caller == "dpts" || caller == "ssdpt") {
          downloadObj.id = val.id;
        }
        downloadObj.devices = { category: val.c, name: val.n, device: val.d };
      } else if (caller == "dtps") {
        isPost = true;
        downloadObj.devices = { n: val.n, c: val.c, d: val.d };
      } else if (caller == "dtpl") {
        isPost = true;
        downloadObj.devices = $scope.allDeviceListTemp;
      } else if (caller == "dccl") {
        // var curOfDevices = val.offline.concat(val.online);
        // angular.forEach(curOfDevices, function (device) {
        //   downloadObj.devices.push(device);
        // });
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsCC({cids:ids, caller:"dashboard"}).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
            }
          },
          function (err) {
            $log.error(err);
          }
        );
        return;
      }

      if (isPost) {
        $rootScope.linkOpenObj = { loading: true, url: "", surl: "" };
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel(downloadObj).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
            }
          },
          function (err) {
            $log.error(err);
          }
        );
        return;
      }

      if(caller == "ccl"){
      // if(caller == "ccs" || caller == "ccl" || caller == "dccl"){
        var curDevicesArr = [], confirmedArr = [],unconfirmedArr = [],curDevicesArr1 = [];
        // angular.forEach($scope.curDCData.c, function(val){
        //   angular.forEach($scope.curDCData.d, function(d){
        //     angular.forEach(d.c, function(c){
        //       if(val.i == c){
        //         confirmedArr.push({id:d.i, label:d.l, mac:d.h, status:d.s, isConfirmed:true});
        //       }
        //     })
        //     angular.forEach(d.u, function(u){
        //       if(val.i == u){
        //         unconfirmedArr.push({id:d.i, label:d.l, mac:d.h, status:d.s, isConfirmed:false});
        //       }
        //     })
        //   })
        // })
        // curDevicesArr = confirmedArr.concat(unconfirmedArr)

        // angular.forEach(curDevicesArr, function(item){
        //   $scope.isDuplicate = false;
        //   angular.forEach(curDevicesArr1, function(listItem){
        //     if(listItem.id == item.id){
        //       $scope.isDuplicate = true;
        //       return false;
        //     }
        //   });

        //   if(!$scope.isDuplicate){
        //     curDevicesArr1.push(item);
        //   }
        // });
        if(caller == 'ccl'){
          // curDevicesArr1 = $scope.arraytoStringFx($scope.curDCData.ccl)
          curDevicesArr1 = $scope.curDCData.cids;
        }
        $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
        $scope.linkOpenFx('d');
        ReportsSrv.getReportsCC({cids:curDevicesArr1, caller:"dashboard"}).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
              // $scope.linkOpenFx(data.url);
            }
          },
          function (err) {
            $log.error(err);
          }
        );
      } else if (caller == "cclp") {
        $rootScope.linkOpenObj = { loading: true, url: "", surl: "" };
        $scope.linkOpenFx('d');
        DashboardSrv.dowanloadExcelCCL($scope.curCcl).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
            }
          },
          function (err) {
            $log.error(err);
          }
        );
      }
    }

    $scope.downloadDbListFx = function (caller, subType, val, label) {
      if (angular.isUndefined(subType)) {
        $scope.downloadObj = { type: "", subType: $scope.detailsObj.label, devices: [] };
      } else {
        $scope.downloadObj = { type: "", subType: subType, devices: [] };
      }
      var isPost = false;
      if (caller == "ccs") {
        isPost = true;
        $scope.downloadObj.type = "ccsDevices";
      } else if (caller == "dps") {
        isPost = true;
        $scope.downloadObj.type = "dpsDevices";
      } else if (caller == "dpts") {
        isPost = true;
        $scope.downloadObj.type = "dptsDevices";
      } else if (caller == "ds") {
        isPost = true;
        $scope.downloadObj.type = "dsDevices";
      } else if (caller == "dts") {
        isPost = true;
        if ($scope.downloadObj.subType == "mp") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.1');
        } else if ($scope.downloadObj.subType == "webos") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.5');
        } else if ($scope.downloadObj.subType == "tizen") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.6');
        } else if ($scope.downloadObj.subType == "mc") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.4');
        } else if ($scope.downloadObj.subType == "gf") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.2');
        } else if ($scope.downloadObj.subType == "v") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.3');
        } else if ($scope.downloadObj.subType == "desktop") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.7');
        } else if ($scope.downloadObj.subType == "epd") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.8');
        }
        $scope.downloadObj.type = "dtsDevices";
      } else if (caller == "ssdt") {
        isPost = true;
        $scope.downloadObj.type = "ssdtDevices";
      } else if (caller == "ssdpt") {
        isPost = true;
        $scope.downloadObj.type = "ssdptDevices";
      } else if (caller == "ssodt") {
        isPost = true;
        $scope.downloadObj.type = "ssodtDevices";
      } else if (caller == "dtps") {
        isPost = true;
        if ($scope.downloadObj.subType == "n") {
          $scope.downloadObj.subType = "No issues";
        } else if ($scope.downloadObj.subType == "c") {
          $scope.downloadObj.subType = "Caution";
        } else if ($scope.downloadObj.subType == "d") {
          $scope.downloadObj.subType = "Danger";
        }
        $scope.downloadObj.type = "dtpsDevices";
      } else if (caller == "dccl") {
        isPost = true;
        if ($scope.downloadObj.subType == "cc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8');
        } else if ($scope.downloadObj.subType == "poncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.1');
        } else if ($scope.downloadObj.subType == "pofcc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.2');
        } else if ($scope.downloadObj.subType == "oncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.1');
        } else if ($scope.downloadObj.subType == "ofcc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.3');
        } else if ($scope.downloadObj.subType == "ncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.1');
        } else if ($scope.downloadObj.subType == "ponncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.2');
        } else if ($scope.downloadObj.subType == "pofncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.3');
        } else if ($scope.downloadObj.subType == "onncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.2');
        } else if ($scope.downloadObj.subType == "ofncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.4');
        } else if ($scope.downloadObj.subType == "nsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6');
        } else if ($scope.downloadObj.subType == "onnsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.1');
        } else if ($scope.downloadObj.subType == "ofnsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.2');
        }
        $scope.downloadObj.type = "dcclDevices";
      }
      $scope.stringIds = $scope.arraytoStringFx(val); /*Array to String common*/
      $scope.downloadObj.devices = $scope.stringIds;
      if (isPost) {
        $rootScope.linkOpenObj = { loading: true, url: "", surl: "" };
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel($scope.downloadObj).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
            }
          },
          function (err) {
            $log.error(err);
          }
        );
        return;
      }
    }

    $scope.logsFx = function () {
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.logsCopy = angular.copy({ date: { startDate: moment($scope.logs.date.startDate).format("L"), endDate: moment($scope.logs.date.endDate).format("L") } });
      DashboardSrv.saveLogs($scope.logsCopy).then(
        function (data) {
          $scope.saveProcessing = false;
          if (data.code == 6027) {
            $scope.hasErr = true;
          } else {
            $scope.logs.url = data.download;
            $scope.saveProcessing = false;
          }
        },
        function (err) {
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    //confirmed device hide/show in cc popup
    $scope.cDToggleFx = function (event) {
      $scope.cOpen = !$scope.cOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".confirm-device").toggleClass('hide');
    }
    //Unconfirmed device hide/show in cc popup
    $scope.ncDToggleFx = function (event) {
      $scope.ncOpen = !$scope.ncOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".not-confirm-device").toggleClass('hide');
    }

    /*Device control*/
    $scope.cclOpen = function (devices, label) {
      $scope.curCcl = { devices: devices, label: label };
      $scope.cOpen = true;
      $scope.ncOpen = true;
      $scope.cCount = $filter("filter")($scope.curCcl.devices, { isConfirmed: true }, true);
      $scope.ncCount = $filter("filter")($scope.curCcl.devices, { isConfirmed: false }, true);

      var arr = $scope.arraytoStringFx(devices);
      $rootScope.isDInterval = $interval(function () {
        DashboardSrv.deviceDetail({ devices: arr }).then(
          function (data) {
            if ($scope.cCount.length) {
              angular.forEach($scope.cCount, function (list) {
                if (data.length) {
                  angular.forEach(data, function (device) {
                    if (device.id === list.id) {
                      list.status = device.status;
                    }
                  });
                }
              });
            }
            if ($scope.ncCount.length) {
              angular.forEach($scope.ncCount, function (list) {
                if (data.length) {
                  angular.forEach(data, function (device) {
                    if (device.id === list.id) {
                      list.status = device.status;
                    }
                  });
                }
              });
            }

            $scope.detailLoading = false;
            $scope.loadingDetail = false;
          },
          function (err) {
            $scope.detailloadingDetail = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }, 10000);
      ngDialog.open({
        template: 'app/dashboard/popup/ccDevice.html',
        width: 650,
        scope: $scope,
        closeByDocument: false,
        preCloseCallback: function () {
          if ($rootScope.isDBEdit == "e") {
            $scope.dgOptionsFx("e");
          }
          $interval.cancel($rootScope.isDInterval);
        }
      });
    }

    /*Device control*/
    $scope.deviceControlOpen = function (id, label, dType) {
      $scope.curDeviceControl = { id: id, label: label, dType: dType };
      ngDialog.open({
        template:'app/devices/popup/deviceControl.html',
        width:850,
        data:$scope.curDeviceControl,
        scope:$scope,
        controller:'DeviceControlController',
        closeByDocument:false
      });
    }

    $scope.$on("$stateChangeStart", function (event, toState) {
      if ($scope.markerList.length > 0) {
        if (dashboardCtrl.map && dashboardCtrl.map.hideInfoWindow) {
          dashboardCtrl.map.hideInfoWindow('info');
        }
      }
      $interval.cancel($rootScope.isStatusInterval);
    });
    angular.element(document).bind('keyup', function(e){
      if(e.keyCode == 27 && $scope.markerList.length > 0){//key:- escape
        dashboardCtrl.map.hideInfoWindow('info');
      }
    });

    $scope.showDetail = function (e, marker) {
      $scope.markerDetail = marker;
      dashboardCtrl.map.showInfoWindow('info', this);
    };

    $scope.registerOnMapOpen = function () {
      $scope.isPopupOpen = true;
      $scope.onMap = { info: { type: "c" } };
      // $scope.quadId = "dom";
      $scope.detailListObj.dom = {};
      $scope.scrollDataList.dom = [];
      $scope.allScrollDataList.dom = [];
      $scope.copyScrollObj.dom = {};
      $scope.visibleObjects.dom = [];
      $scope.haveMoreData.dom = false;
      $scope.haveMoreSearchData.dom = false;
      $scope.visibleData.dom = [];
      $scope.stIndex.dom = 0;
      $scope.etIndex.dom = 300;
      $scope.searchScroll.dom = false;

      $scope.detailListObj.dom = {caller:'dom', offset:0};
      $scope.detailLoading = true;
      DashboardSrv.getScrollDBListData($scope.detailListObj.dom).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.dom = true;
          } else{
            $scope.haveMoreData.dom = false;
          }
          $scope.scrollDataList.dom = data;
          $scope.addStatusKey($scope.scrollDataList.dom, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.dom =  angular.copy($scope.scrollDataList.dom);
          $scope.detailLoading = false;
        },
        function(err){
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template: 'app/dashboard/popup/registerOnMap.html',
        width: "500px",
        scope: $scope,
        controller: "OnMapController",
        controllerAs: "vm",
        closeByDocument: false,
        preCloseCallback:function(){
          $scope.isPopupOpen = false;
          $interval.cancel($rootScope.isStatusInterval);
        }
      });
    }
    // $scope.registerOnMapOpen = function () {
    //   $scope.onMap = { info: { type: "c" } };
    //   $scope.detailLoading = true;
    //   DashboardSrv.getRegisterOnMap().then(
    //     function(data){
    //       angular.forEach(data.devices, function(item){
    //         if(item.reg == null){
    //           item.reg = 0;
    //         }
    //      });
    //       $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
    //       $scope.rCount = $filter("filter")(data.devices, {reg:1 }, true);
    //       $scope.urCount = $filter("filter")(data.devices, {reg:0 }, true);
    //       if(data.devices){
    //         $scope.onMap.devices = data.devices;
    //       }
    //       $scope.detailLoading = false;
    //     },
    //     function (err) {
    //       $log.error(err);
    //       $scope.detailLoading = false;
    //     }
    //   );
    //   ngDialog.open({
    //     template: 'app/dashboard/popup/registerOnMap.html',
    //     width: "500px",
    //     scope: $scope,
    //     controller: "OnMapController",
    //     controllerAs: "vm",
    //     closeByDocument: false
    //   });
    // }

    $scope.previewObj = {};
    $scope.previewOpen = function (caller) {
      $scope.hasErr = false;
      $scope.errType = "";
      if (!caller) {
        $scope.previewObj = {
          isControls:false,
          time:moment().format(),
          id:$scope.curDCData.dp.id,
          eip:$scope.curDCData.dp.eip,
          mac:$scope.curDCData.dp.h,
          label:$scope.curDCData.dp.l,
          date:{startDate:moment().format('L'), endDate:moment().format('L')}
        };
      }
      ngDialog.close();
      ngDialog.open({
        template: '\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"d.btn.11" | translate}}</h1> <span class="text-sm text-muted">[ {{previewObj.label}} ]</span></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cm.label.7" | translate}}</label>\
                <div class="input-group">\
                  <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                  <input type="daterange" class="form-control picker" ng-model="previewObj.date" format="MM/DD/YYYY" singleDatePicker="true" readonly="" aria-label="{{\'cm.label.7\' | translate}}" aria-labelledby="{{\'cm.label.7\' | translate}}">\
                </div>\
              </div>\
              <div class="form-group timepicker">\
                <label>{{"cm.label.8" | translate}}</label>\
                <span uib-dropdown auto-close="outsideClick" dropdown-append-to-body>\
                  <div class="input-group">\
                    <span class="input-group-addon"><span class="fa fa-clock-o" aria-hidden="true"></span></span>\
                    <input type="text" class="form-control picker" uib-dropdown-toggle ng-value="previewObj.time | date:\'shortTime\'" readonly="" aria-label="{{\'cm.label.8\' | translate}}" aria-labelledby="{{\'cm.label.8\' | translate}}">\
                  </div>\
                  <div class="dropdown-menu dropdown-to-body" uib-dropdown-menu>\
                    <div uib-timepicker ng-model="previewObj.time" hour-step="1" minute-step="5"></div>\
                  </div>\
                </span>\
              </div>\
              <div><label class="noMar"><input type="checkbox" ng-model="previewObj.isControls"><label></label> {{"d.label.28" | translate}}</label></div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="previewFx();"><span class="fa fa-film" aria-hidden="true"></span> {{"d.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">\
                <span ng-if="errType==\'date\'" aria-live="polite" role="status">{{"cm.msg.21" | translate}}</span>\
                <span ng-if="errType==\'time\'" aria-live="polite" role="status">{{"cm.msg.22" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:400,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
      });
    }
    $scope.previewFx = function () {
      $scope.hasErr = false;
      $scope.errType = "";
      if ($scope.previewObj.date == "" || $scope.previewObj.date == null) {
        $scope.hasErr = true;
        $scope.errType = "date";
        return false;
      }
      if ($scope.previewObj.time == "" || $scope.previewObj.time == null) {
        $scope.hasErr = true;
        $scope.errType = "time";
        return false;
      }

      $scope.curPreviewObj = angular.copy($scope.previewObj);
      $scope.curPreviewObj.timestamp = moment($scope.previewObj.date.startDate).format('MM-DD-YYYY');
      $scope.curPreviewObj.time = moment(angular.copy($scope.previewObj).time).format("HH:mm");
      $scope.curPreviewObj.offset = new Date($scope.previewObj.date.startDate).getTimezoneOffset();

      $scope.curPreviewObj.iFrameUrl = $rootScope.dPreviewPath + $scope.previewObj.mac + "&cc=" + $scope.previewObj.isControls + "&ts=" + $scope.curPreviewObj.timestamp + "&t=" + $scope.curPreviewObj.time + "&" + new Date().getTime();

      $scope.devices = {info:{bucket:$scope.dashboard.dp.buc, timthumb:$scope.dashboard.dp.tmb } };
      ngDialog.close();
      ngDialog.open({
        template: 'app/devices/preview/preview.html',
        width: "98%",
        scope: $scope,
        trapFocus: false,
        closeByDocument: false,
        controller: "PreviewController",
        className: "ngdialog-theme-default ngdialog-preview",
        preCloseCallback: function () {
          $interval.cancel($rootScope.emTimer);
        }
      });
    }

    // for refresh list
    $scope.refreshPopupListClickFx = function(obj){
      obj.offset = 0;
      $scope.quadId = obj.caller;

      $scope.detailListObj[$scope.quadId] = {};
      $scope.scrollDataList[$scope.quadId] = [];
      $scope.allScrollDataList[$scope.quadId] = [];
      $scope.copyScrollObj[$scope.quadId] = {};
      $scope.visibleObjects[$scope.quadId] = [];
      $scope.haveMoreData[$scope.quadId] = false;
      $scope.haveMoreSearchData[$scope.quadId] = false;
      $scope.visibleData[$scope.quadId] = [];
      $scope.stIndex[$scope.quadId] = 0;
      $scope.etIndex[$scope.quadId] = 300;
      $scope.searchScroll[$scope.quadId] = false;

      $scope.detailLoading = true;
      $scope.loadingDetail = true;
      $scope.detailListObj[$scope.quadId] = obj;
      DashboardSrv.getScrollDBListData(obj).then(
        function(data){
          var source = document.getElementById("source");
          if(source != null){
            $scope.textValue = source.innerText;
          }
          if(data.length >= 1000){
            $scope.haveMoreData[$scope.quadId] = true;
          } else{
            $scope.haveMoreData[$scope.quadId] = false;
          }
          if($scope.quadId == 'wgws' && data.length){
            $scope.getExpirySoonDevice(data, $scope.quadId);
          } else{
            $scope.scrollDataList[$scope.quadId] = data;
          }
          $scope.addStatusKey($scope.scrollDataList[$scope.quadId], $scope.auth.upreferences.dot);
          $scope.allScrollDataList[$scope.quadId] =  angular.copy($scope.scrollDataList[$scope.quadId]);
          $scope.detailLoading = false;
          $scope.loadingDetail = false;
        },
        function(err){
          $scope.detailLoading = false;
          $scope.loadingDetail = false;
          $log.error(err);
        }
      );

      // $scope.loadingDetail = true;
      // $scope.detailLoading = true;

      // DashboardSrv.deviceDetailNew(obj).then(
      //   function(data){
      //     $scope.deviceDetailsList = [];
      //     $scope.deviceDetailsList = data;

      //     $scope.detailLoading = false;
      //     $scope.loadingDetail = false;
      //   },
      //   function(err){
      //     $scope.detailloadingDetail = false;
      //     $scope.loading = false;
      //     $log.error(err);
      //   }
      // );
    }
    $scope.refreshPopupListFx = function(caller, stringIds, fType, isDeviceId){
      if(caller == "ticket"){
        $scope.loading = true;
        if ($scope.dataTkObj.type == 'o') {
          $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.3');
        } else {
          $scope.dataTkObj.label = $filter("translate")('ms.label.35.15.4');
        }
        $scope.popupLoading = true;
        DashboardSrv.getTicket($scope.auth.sd.url + $scope.auth.sd.ep, $scope.auth.servers[0].id, $scope.auth.sd.envId, $scope.dataTkObj.type).then(
          function (data) {
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.dataTkObj.ticket = data;
          },
          function (err) {
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else {
        $scope.loadingDetail = true;
        if (caller == "dccl" && $scope.tDetailsObj.label != "offline") {
          $scope.arraytoStringFx($scope.tDetailsObj.arr);
          $scope.tDetailsObj.arr = stringIds;
          $scope.stringIds = stringIds;
        }
        if ($scope.tDetailsObj.arr.length) {
          $scope.detailLoading = true;
          if (caller == "ot") {
            $scope.detailsObj.tId = $scope.tDetailsObj.tId;
            // $scope.arraytoStringFx($scope.tDetailsObj.arr); /*Array to String common*/
            if (isDeviceId) {
              $scope.arraytoStringFx($scope.tDetailsObj.arr); /*Array to String common with ID*/
              $scope.tDetailsObj.arr = stringIds;
              $scope.payloadObj = { devices: $scope.tDetailsObj.arr };
            } else {
              $scope.arraytoStringMacFx($scope.tDetailsObj.arr); /*Array to String common with MAC*/
              $scope.tDetailsObj.arr = stringIds;
              $scope.payloadObj = { macs: $scope.tDetailsObj.arr };
            }
            $scope.stringIds = stringIds;
          } else {
            $scope.payloadObj = { devices: $scope.tDetailsObj.arr };
          }


          DashboardSrv.deviceDetail($scope.payloadObj).then(
            function (data) {
              $scope.detailsObj.deviceDetails = [];
              $scope.detailsObj.deviceDetails = data;

              /** Below code is commented because we are now sending device ids acc to status */
              // if($scope.detailsObj.caller == "ds" && angular.lowercase($scope.tDetailsObj.label) == "total"){
              //   $scope.detailsObj.deviceDetails = data;
              // }
              // if($scope.detailsObj.caller != "ds"){
              //   $scope.detailsObj.deviceDetails = data;
              // }
              // angular.forEach(data, function(device){
              //   if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "online" || $scope.tDetailsObj.fType == "online")){
              //     if(device.status == "online"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   } else if($scope.detailsObj.caller == "ds" && (angular.lowercase($scope.tDetailsObj.label) == "offline" || $scope.tDetailsObj.fType == "offline")){
              //     if(device.status == "offline"){
              //       $scope.detailsObj.deviceDetails.push(device);
              //     }
              //   }
              // });

              if (caller == "dccl") {
                if ($scope.tDetailsObj.label == "ofncc" || $scope.tDetailsObj.label == "ofcc") {
                  $scope.offDArr = [];
                  angular.forEach(data, function (device) {
                    if (device.status == "offline") {
                      $scope.offDArr.push(device);
                    }
                  });
                  $scope.detailsObj.deviceDetails = $scope.offDArr;
                } else if ($scope.tDetailsObj.label == "onncc" || $scope.tDetailsObj.label == "oncc") {
                  $scope.onDArr = [];
                  angular.forEach(data, function (device) {
                    if (device.status == "online") {
                      $scope.onDArr.push(device);
                    }
                  });
                  $scope.detailsObj.deviceDetails = $scope.onDArr;
                }
              }
              $scope.detailLoading = false;
              $scope.loadingDetail = false;
            },
            function (err) {
              $scope.detailloadingDetail = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.devicePCOpen = function (id, label) {
      $scope.dataCHObj = { id: id, label: label, history: [] };
      $scope.popupLoading = true;
      DevicesSrv.getDeviceCH($scope.dataCHObj.id).then(
        function (data) {
          $scope.popupLoading = false;
          $scope.dataCHObj.history = data.history;
        },
        function (err) {
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/devices/popup/previousChanges.html',
        width:900,
        scope:$scope,
        data:$scope.dataCHObj,
        closeByDocument:false
      });
    }

    $scope.dRestrictFx = function (caller, obj) {
      $scope.dObj = [];
      if (caller == 'cc') {
        $scope.dObj = obj;
      } else {
        $scope.dObj = obj.deviceDetails;
      }
      $scope.popupProcessing = true;
      if ($scope.dObj.length) {
        $scope.devicesArr = [];
        angular.forEach($scope.dObj, function (device) {
          if (!device.dType) {
            $scope.devicesArr.push({ id: device.id, mac: device.mac, dType: "" });
          } else {
            $scope.devicesArr.push({ id: device.id, mac: device.mac, dType: device.dType });
          }
        });
      }
      DashboardSrv.restrictDevices({ devices: $scope.devicesArr }).then(
        function (data) {
          $scope.popupProcessing = false;
        },
        function (err) {
          $scope.popupProcessing = false;
          $log.error(err);
        }
      );
    }

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';

    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
      if($scope.copyScrollObj[obj.quadId].type && $scope.copyScrollObj[obj.quadId].type == "ccl"){
        $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:$scope.scrollDataList[obj.quadId].length, id: $scope.copyScrollObj[obj.quadId].id, label: $scope.copyScrollObj[obj.quadId].label, type:$scope.copyScrollObj[obj.quadId].type};
      } else if(obj.quadId == 'wgw' || obj.quadId == 'wgws') {
        $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:$scope.scrollDataList[obj.quadId].length, tz:$rootScope.offsetFormatted};
      } else {
        $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:$scope.scrollDataList[obj.quadId].length};
      }
      if($scope.searchScroll[obj.quadId]){
        $scope.detailListObj[obj.quadId].searchQ = obj.text;
        DashboardSrv.getSearchScrollDBData($scope.detailListObj[obj.quadId]).then(
          function(data){
            $scope.addStatusKey(data, $scope.auth.upreferences.dot);
            if(data.length >= 1000){
              $scope.haveMoreSearchData[obj.quadId] = true;
            } else{
              $scope.haveMoreSearchData[obj.quadId] = false;
            }
            if(obj.quadId == 'rad' && data.length){
              $scope.getRecentAddedDeviceFX(data);
            } else if((obj.quadId == 'wgw' || obj.quadId == 'wgws') && data.length){
              $scope.getExpirySoonDevice(data, obj.quadId);
            } else{
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data);
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DashboardSrv.getScrollDBListData($scope.detailListObj[obj.quadId]).then(
          function(data){
            $scope.addStatusKey(data, $scope.auth.upreferences.dot);
            if(data.length >= 1000){
              $scope.haveMoreData[obj.quadId] = true;
            } else if(data.length && data.length < 1000){
              $scope.haveMoreData[obj.quadId] = false;
            }
            $scope.allScrollDataList[obj.quadId] = [];
            if(obj.quadId == 'rad' && data.length){
              $scope.getRecentAddedDeviceFX(data);
            } else if((obj.quadId == 'wgw' || obj.quadId == 'wgws') && data.length){
              $scope.getExpirySoonDevice(data, obj.quadId);
            } else{
              $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data);
            }
            $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
      $scope.scrollDataList[obj.quadId] = [];
      if(obj.quadId != 'dom'){
        $scope.detailLoading = true;
      }
      // $scope.loadingDetail = true;
      if(obj.quadId == "d" || obj.quadId == "rad" || obj.quadId == "dtpl" || obj.quadId == "wgw"){
        $scope.dbListLoading[obj.quadId] == true;
      }

      if($scope.copyScrollObj[obj.quadId].type && $scope.copyScrollObj[obj.quadId].type == "ccl"){
        if(obj.text){
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:0, id: $scope.copyScrollObj[obj.quadId].id, label: $scope.copyScrollObj[obj.quadId].label, type:$scope.copyScrollObj[obj.quadId].type, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:0, id: $scope.copyScrollObj[obj.quadId].id, label: $scope.copyScrollObj[obj.quadId].label, type:$scope.copyScrollObj[obj.quadId].type};
        }
      } else if(obj.quadId == 'wgw' || obj.quadId == 'wgws'){
        if(obj.text){
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:0, searchQ: obj.text, tz:$rootScope.offsetFormatted};
        } else{
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:0, tz:$rootScope.offsetFormatted};
        }
      } else{
        if(obj.text){
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:0, searchQ: obj.text};
        } else{
          $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, status:$scope.copyScrollObj[obj.quadId].status, name:$scope.copyScrollObj[obj.quadId].name, value:$scope.copyScrollObj[obj.quadId].value, offset:0};
        }
      }
      if(obj.text){
        $scope.searchScroll[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        DashboardSrv.getSearchScrollDBData($scope.detailListObj[obj.quadId]).then(
          function(data){
            if(data.length && data.length >= 1000){
              $scope.haveMoreSearchData[obj.quadId] = true;
            } else{
              $scope.haveMoreSearchData[obj.quadId] = false;
            }
            if(obj.quadId == 'rad' && data.length){
              $scope.getRecentAddedDeviceFX(data);
            } else if((obj.quadId == 'wgw' || obj.quadId == 'wgws') && data.length){
              $scope.getExpirySoonDevice(data, obj.quadId);
            } else{
              $scope.scrollDataList[obj.quadId] = data;
            }
            $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
            $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
            $scope.detailLoading = false;
            $scope.loadingDetail = false;
            setTimeout(function() {
              $scope.$apply();
            });
            if(obj.quadId == "d" || obj.quadId == "rad" || obj.quadId == "dtpl" || obj.quadId == "wgw"){
              $scope.dbListLoading[obj.quadId] == false;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData[obj.quadId] = false;
        $scope.searchScroll[obj.quadId] = false;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        DashboardSrv.getScrollDBListData($scope.detailListObj[obj.quadId]).then(
          function(data){
            if(data.length >= 1000){
              $scope.haveMoreData[obj.quadId] = true;
            } else{
              $scope.haveMoreData[obj.quadId] = false;
            }

            if(obj.quadId == 'rad' && data.length){
              $scope.getRecentAddedDeviceFX(data);
            } else if((obj.quadId == 'wgw' || obj.quadId == 'wgws') && data.length){
              $scope.getExpirySoonDevice(data, obj.quadId);
            } else{
              $scope.scrollDataList[obj.quadId] = data;
            }
            $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
            $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
            $scope.allScrollDataList[obj.quadId] = [];
            $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

            $scope.detailLoading = false;
            $scope.loadingDetail = false;
            setTimeout(function() {
              $scope.$apply();
            });
            if(obj.quadId == "d" || obj.quadId == "rad" || obj.quadId == "dtpl" || obj.quadId == "wgw"){
              $scope.dbListLoading[obj.quadId] == false;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      $interval.cancel($rootScope.isStatusInterval);
      $scope.stIndex[obj.quadId] = obj.st;
      $scope.etIndex[obj.quadId] = obj.et;
      $scope.visibleData[obj.quadId] = obj.vObj;
      setTimeout(function() {
        $scope.$apply();
      }, 0);
      if($scope.isPopupOpen){
        $rootScope.isStatusInterval = $interval(function(){
          var tempArr = $scope.arraytoStringFx($scope.visibleData[obj.quadId]);
          DashboardSrv.getDStatus({tIds: tempArr}).then(
            function (data) {
              angular.forEach($scope.visibleData[obj.quadId], function(object){
                object.lp = data.dLP[object.id];
                if(object.lp){
                  object.status = $filter('isDeviceOnline')(data.dLP[object.id], {minDeduct: $scope.auth.upreferences.dot});
                } else {
                  object.status = "offline";
                }
                setTimeout(function() {
                  $scope.$apply();
                });
              })
            },
            function (err) {
              $log.error(err);
            }
          );
        }, 10000);
      }
    });

    $scope.searchChangeDataDyn = function(val, quadId){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container-"+quadId);
      if (!text && $scope.searchScroll[quadId]) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex[quadId] = 0;
        $scope.etIndex[quadId] = 300;
        $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData[quadId]) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData[quadId] = true;
          } else{
            $scope.haveMoreSearchData[quadId] = false;
          }
          $scope.scrollDataList[quadId] = filteredObj;
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          if ($scope.scrollDataList[quadId].length <= 300) {
            $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
          } else {
            $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          }
          $scope.searchScroll[quadId] = true;
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else {
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        }
      }
    }

    /* Ad Campaign */

    $scope.loadAdPopup = function(){
      ngDialog.open({
        showClose:false,
        template:'app/dashboard/popup/adpopup.html',
        width:850,
        scope:$scope,
        closeByDocument:false,
        closeByEscape: false,
        preCloseCallback:function(){
         console.log("Close");
        }
      });
    }

    $scope.dontShowAd = function(){
      $scope.dontShowAdAgain=!$scope.dontShowAdAgain
    }

    $scope.isAdLoading = true;

    $scope.adImageLoaded = function () {
      $scope.isAdLoading = false;
    };

    $scope.changeSlide = function (newIndex) {
      if(!$scope.isAdLoading) {
        $scope.currentAdIndex = newIndex; 
        // $scope.isAdLoading = true; 
        // var tempImg = new Image();
        // tempImg.src = $scope.adCampaign[0].data[newIndex].img; 
        // tempImg.onload = function () {
        //   $scope.$apply(function () {
        //     $scope.currentAdIndex = newIndex; 
        //     $scope.isAdLoading = false;
        //   });
        // };
      }
    };
    
    $scope.prevAdSlider = function () {
      var newIndex = $scope.currentAdIndex == 0 ? ($scope.adCampaign[0].data.length - 1) : $scope.currentAdIndex - 1;
      $scope.changeSlide(newIndex);
    };
    
    $scope.nextAdSlider = function () {
      var newIndex = $scope.currentAdIndex == ($scope.adCampaign[0].data.length - 1) ? 0 : $scope.currentAdIndex + 1;
      $scope.changeSlide(newIndex);
    };

    $scope.closeAdPopup = function(){
      /* Temporary close */ 
      ngDialog.close();
      localStorage.setItem("adC", true);
      /* Permanent close */ 
      if($scope.dontShowAdAgain){
        console.error("permaClosed");
        DashboardSrv.stopAdCampaign($scope.adCampaign[0].id);
      }
    }

    // * scroll list data code END 2nd phase pagination
    // Clean up service on scope destroy (optional but safer)
    $scope.$on('$destroy', function () {
      DashboardSrv.cleanup();
    });

    $scope.searchFrmAllData = function(val, caller){
      console.log("val", val);
      console.log("caller", caller);
      if ($scope.searchTimeout) {
        $timeout.cancel($scope.searchTimeout);
      }
      $scope.searchTimeout = $timeout(function () {
        var text = val.toLowerCase();
        if(!text){
          if(caller == 'ral'){
            $scope.loadMoreLogs(0)
          }
          if(caller == 'ccl'){
            $scope.loadMoreContentConfirmationFx(0);
          }
        } else if(text && text.length >= 3){
          if(caller == 'ral'){
            $scope.dbListLoading.ral = true;
            $scope.allLogsLoaded = false;
            $scope.logList = [];
            console.warn("call ho gaya he");
            DashboardSrv.getLogsSearchList(0, text).then(
              function(data){
                $scope.dbListLoading.ral = false;
                if(data.logs && data.logs.length > 0){
                  $scope.logList = data.logs;
                } else {
                  $scope.allLogsLoaded = true;
                }
                setTimeout(function() {
                  $scope.$apply();
                });
              },
              function (err) {
                $scope.dbListLoading.ral = false;
                $log.error(err);
              }
            );
          }
          if(caller == 'ccl'){
            $scope.dbListLoading.ccl = true;
            $scope.allCclLoaded = false;
            $scope.curDCData.ccl = [];
            DashboardSrv.getContentConfirmationSearch(0, text).then(
              function(data){
                $scope.dbListLoading.ccl = false;
                if(data && data.cc.length > 0){
                  $scope.curDCData.ccl = data.cc;
                } else{
                  $scope.allCclLoaded = true;
                }
                setTimeout(function() {
                  $scope.$apply();
                });
              },
              function(err){
                $scope.dbListLoading.ccl = false;
                $log.error(err);
              }
            );
          }
        }
      }, 300);
    }

    $scope.getExpirySoonDevice = function(data, quad){
      console.log("quad", quad);
      var wgwData = data;
      angular.forEach(wgwData, function(wgw){
        if(wgw.exp){
          var expiryDate = moment(wgw.exp);
          var currentDate = moment(); // Get current date
          var threeMonthsBeforeExpiry = expiryDate.clone().subtract(3, 'months')
          if (currentDate.isAfter(threeMonthsBeforeExpiry) && currentDate.isBefore(expiryDate)) {
            $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: 3});
          } else if (currentDate.isAfter(expiryDate)) {
            $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: 0});
          } else {
            $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: 1});
          }
        } else if(wgw.reg && !wgw.exp){
          $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: 1});
        } else{
          $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: 2});
        }
      });
      // var wgwData = data;
      // angular.forEach(wgwData, function(wgw){
      //   var expiryDate = moment(parseInt(wgw.exp + '000')); // Convert timestamp to date
      //   var currentDate = moment(); // Get current date
      //   var threeMonthsBeforeExpiry = expiryDate.clone().subtract(3, 'months')
      //   if (currentDate.isAfter(threeMonthsBeforeExpiry) && currentDate.isBefore(expiryDate)) {
      //     wgw.expSoon = true;
      //   } else{
      //     wgw.expSoon = false;
      //   }
      //   $scope.scrollDataList[quad].push({exp: wgw.exp, h:wgw.h, id: wgw.id, l: wgw.l, lp: wgw.lp, reg: wgw.reg, wgs: wgw.wgs, expSoon: wgw.expSoon});
      // });
    }

    $scope.wgwListFx = function(){
      $scope.isFirst.wgw = true;
      $scope.dbListLoading.wgw = true;
      $scope.searchText.device = "";
      $scope.detailListObj.wgw = {};
      $scope.scrollDataList.wgw = [];
      $scope.allScrollDataList.wgw = [];
      $scope.copyScrollObj.wgw = {};
      $scope.visibleObjects.wgw = [];
      $scope.haveMoreData.wgw = false;
      $scope.haveMoreSearchData.wgw = false;
      $scope.visibleData.wgw = [];
      $scope.stIndex.wgw = 0;
      $scope.etIndex.wgw = 300;
      $scope.searchScroll.wgw = false;

      $scope.detailListObj.wgw = {caller:'wgw', offset:0, tz:$rootScope.offsetFormatted};
      DashboardSrv.getScrollDBListData($scope.detailListObj.wgw).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.wgw = true;
          } else{
            $scope.haveMoreData.wgw = false;
          }
          // $scope.scrollDataList.wgw = data;
          $scope.getExpirySoonDevice(data, 'wgw');
          $scope.addStatusKey($scope.scrollDataList.wgw, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.wgw =  angular.copy($scope.scrollDataList.wgw);


          $rootScope.sessionTimoutFx();
          $rootScope.showTimeoutMsg = false;
          $scope.searchText.wgw = "";
          $scope.loading = false;
          $scope.refreshing = false;

          setTimeout(function(){
              if($rootScope.isDBEdit == "e"){
              $scope.dgOptionsFx('e');
              }
          }, 500);

          $scope.dbListLoading.wgw = false;
        },
        function(err){
          $scope.dbListLoading.wgw = false;
          $log.error(err);
        }
      );
    }

    $scope.loadMoreWgwListFx = function(){
      $scope.isFirst.wgw = true;
      $rootScope.sessionTimoutFx();
      $rootScope.showTimeoutMsg = false;
      $scope.searchText.wgw = "";
      $scope.detailListObj.wgw = {};
      $scope.scrollDataList.wgw = [];
      $scope.allScrollDataList.wgw = [];
      $scope.copyScrollObj.wgw = {};
      $scope.visibleObjects.wgw = [];
      $scope.haveMoreData.wgw = false;
      $scope.haveMoreSearchData.wgw = false;
      $scope.visibleData.wgw = [];
      $scope.stIndex.wgw = 0;
      $scope.etIndex.wgw = 300;
      $scope.searchScroll.wgw = false;

      $scope.detailListObj.wgw = {caller:'wgw', offset:0, tz:$rootScope.offsetFormatted};
      $scope.dbListLoading.wgw = true;
      DashboardSrv.getScrollDBListData($scope.detailListObj.wgw).then(
        function(data){
          if(data.length >= 1000){
            $scope.haveMoreData.wgw = true;
          } else{
            $scope.haveMoreData.wgw = false;
          }
          // $scope.scrollDataList.wgw = data;          
          $scope.getExpirySoonDevice(data, 'wgw');
          $scope.addStatusKey($scope.scrollDataList.wgw, $scope.auth.upreferences.dot);
          $scope.allScrollDataList.wgw =  angular.copy($scope.scrollDataList.wgw);
          $scope.dbListLoading.wgw = false;
        },
        function(err){
          $scope.dbListLoading.wgw = false;
          $log.error(err);
        }
      );
    }

    $scope.wgwSummFx = function(){
      $scope.dbListLoading.wgws = true;
      DashboardSrv.getWgwSumm().then(
        function(data){
          $scope.curDCData.wgws = {act:0, exp:0, nw:0, totalCount:[]};
          $scope.curDCData.wgws.act = data.act;
          $scope.curDCData.wgws.exp = data.exp;
          $scope.curDCData.wgws.nw = data.nw;
          $scope.curDCData.wgws.totalCount = $scope.curDCData.wgws.nw + $scope.curDCData.wgws.act + $scope.curDCData.wgws.exp;
          $scope.wgwsArr = [];
          var wgwsOpts = {
            chart:{
              width:120,
              height:120,
              type:'pie',
              plotShadow:false,
              plotBorderWidth:0,
              margin:[0, 0, 0, 0],
              backgroundColor:'rgba(0,0,0,0)'
            },
            navigation:{
              buttonOptions:{
                enabled:false
              }
            },
            tooltip:{
              pointFormat:'{series.name}:<b>{point.y}</b>'
            },
            plotOptions:{
              pie:{
                cursor:'pointer',
                dataLabels:{
                  size:'100%',
                  distance:-11,
                  enabled:true,
                  style:{
                    color:'white',
                    fontSize:'10px',
                    textShadow:'0 1px 1px #333333'
                  },
                  formatter:function(){
                    return this.y;
                  }
                },
                showInLegend:false,
                center:['50%', '50%']
              }
            }
          };

          var curWgwsArr = [
            {name:$filter("translate")('db.wgw.8'), y:$scope.curDCData.wgws.nw, yl:$scope.curDCData.wgws.nw, t:"nw", color:$scope.dashboard.dsg.pieColors.wgws.nw},
            {name:$filter("translate")('db.wgw.6'), y:$scope.curDCData.wgws.act, yl:$scope.curDCData.wgws.act, t:"act", color:$scope.dashboard.dsg.pieColors.wgws.act},
            {name:$filter("translate")('db.wgw.7'), y:$scope.curDCData.wgws.exp, yl:$scope.curDCData.wgws.exp, t:"exp", color:$scope.dashboard.dsg.pieColors.wgws.exp}
          ];

          $scope.wgwsArr = {
            options:wgwsOpts,
            series:[{
              size:'100%',
              data:curWgwsArr,
              name:$filter("translate")("cl.widget.count.1"),
              innerSize:'50%',
              cursor:'pointer',
              colorByPoint:true,
              showInLegend:false,
              point:{
                events:{
                  click:function(event){
                    $scope.deviceDetailListFx('wgws', '', this.t);
                  }
                }
              }
            }],
            title:' ',
            xAxis:{categories:[] },
            yAxis:{title:' ' },
          };
          $scope.dbListLoading.wgws = false;
        },
        function(err){
          $scope.dbListLoading.wgws = false;
          $log.error(err);
        }
      );
    }

    $scope.exportWgwDeviceSheet = function(type, value){
      $rootScope.linkOpenObj = { loading:true, url:"", surl:"" };
      $scope.linkOpenFx("d")
      if(value){
        var subType = "";
        if(value == "act"){
          subType = $filter("translate")('db.wgw.6');
        }
        if(value == "exp"){
          subType = $filter("translate")('db.wgw.7');
        }
        if(value == "nw"){
          subType = $filter("translate")('db.wgw.8');
        }
      }
      DashboardSrv.getWgwDeviceSheet(type, value, subType).then(
        function(data){          
          if(data.url){
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

  }
  })();

angular.module('hub').service('FrameLayoutsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getApproved = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAssignments = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/assignments?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUnapproved = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/unapproved?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIncompleted = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/incomplete?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibrary = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/library?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibraryContent = function(libraryId){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/library/" + libraryId + "?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveSort = function(obj){
    httpReq = $http.put($rootScope.apiHost + "frameLayouts/sort", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Get Brief*/
  this.getApprovedBrief = function(frameId){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/briefs/" + frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAssignmentsBrief = function(assingnId){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/assignments/briefs/" + assingnId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibraryBrief = function(libraryId){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/library/briefs/" + libraryId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFrameDeviceList = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/deviceList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAssignDeviceList = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/assignments/devices/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAssignmentList = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/assignmentList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Button*/
  this.saveApprovedBtn = function(frameId){
    httpReq = $http.post($rootScope.apiHost + "action/frameLayouts", frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAssignmentsBtn = function(assingnId){
    httpReq = $http.post($rootScope.apiHost + "action/frameLayoutAssignments", assingnId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.saveFrameAssignmentsList = function(frameId){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/deviceFrameLayoutAssignments", frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Button Actions*/
  this.duplicateFrameLayouts = function(frameId){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/copyMove", frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getServersList = function(){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/serversList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Frame*/
  this.updateApprove = function(frameId){
    httpReq = $http.put($rootScope.apiHost + "frameLayouts/approve", frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateUnapprove = function(frameId){
    httpReq = $http.put($rootScope.apiHost + "frameLayouts/unapprove", frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteFrameLayout = function(frameId){
    httpReq = $http.delete($rootScope.apiHost + "frameLayouts/" + frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteLibrary = function(frameId){
    httpReq = $http.delete($rootScope.apiHost + "frameLayouts/library/" + frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFrameLayout = function(frameId){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/" + frameId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Assignment*/
  this.updateApproveAssign = function(assingnId){
    httpReq = $http.put($rootScope.apiHost + "frameLayouts/assignments/approve", assingnId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateUnapproveAssign = function(assingnId){
    httpReq = $http.put($rootScope.apiHost + "frameLayouts/assignments/unapprove", assingnId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteAssignment = function(assingnId){
    httpReq = $http.delete($rootScope.apiHost + "frameLayouts/assignments/" + assingnId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Library*/
  this.saveUseFrameLayout = function(libraryId){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/use", libraryId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteCategory = function(id){
    httpReq = $http.delete($rootScope.apiHost + "frameLayouts/category/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FrameLayoutCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFrameLayoutDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLibraryDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/library/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFrameLayout = function(obj){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLibrary = function(obj){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/library", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('AssignmentCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getFrameLayoutAssignmentDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "frameLayouts/assignments/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFrameLayoutAssignment = function(obj){
    httpReq = $http.post($rootScope.apiHost + "frameLayouts/assignments", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular
  .module('hub').directive('ngFramelayoutList', function(){
    return {
      restrict:'E',
      templateUrl:'app/frameLayouts/dir/frameLayoutList.html'
    }
  });
angular
  .module('hub').directive('ngFramelayoutBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/frameLayouts/dir/frameLayoutBrief.html'
    }
  });
angular.module('hub').directive('ngAssignableDevices', function(){
  return {
    restrict:'E',
    templateUrl:'app/frameLayouts/dir/assignableDevices.html'
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FrameLayoutsController', FrameLayoutsController);

  /** @ngInject */
  function FrameLayoutsController($log, $rootScope, $scope, $state, $sce, $filter, $cookies, ngDialog, CommonSrv, FrameLayoutsSrv, DashboardSrv, ContentLibrarySrv, SupportSrv, DevicesSrv){
    $rootScope.selectedMenu = 4;
    $scope.selectedTab = $state.current.name;
    $scope.frameLayoutsLoading = true;
    $scope.isConfirmOpen = false;
    $scope.flProcessing = false;
    $scope.frameLayoutList = [];
    $scope.frameLayouts = {};
    $scope.encType = "";
    $scope.encId = "";
    $scope.serverList = [];

    $scope.openFolderFx = function(id){
      $scope.frameLayoutsLoading = true;
      $rootScope.selectedItems = [];
      $scope.contextMenuOpt = [];
      $scope.frameLayouts = {};
      $scope.searchText = "";
      localStorage.setItem("curFllId", id);

      FrameLayoutsSrv.getLibraryContent(id).then(
        function(data){
          $scope.frameLayouts = data;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.loadSelectedTab = function(caller){
      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        localStorage.removeItem("curLayoutId");
        localStorage.removeItem("curAssignmentId");
        angular.element('.ui-selectable li').removeClass('ui-highlight');
      }
      $scope.frameLayoutsLoading = true;
      $rootScope.selectedItems = [];
      $scope.frameLayouts = {};
      $scope.searchText = "";
      if($scope.selectedTab === "hub.frameLayouts.fl"){
        $scope.encType = $scope.hubEnc("fl");
        FrameLayoutsSrv.getApproved().then(
          function(data){
            if($scope.selectedTab === "hub.frameLayouts.fl"){
            $scope.frameLayouts = data;
            $scope.updateList();
            $scope.loadingMain = false;
            $scope.curLayoutId = angular.fromJson(localStorage.getItem("curLayoutId"));
              if($scope.curLayoutId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curLayoutId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.frameLayouts.fla"){
        $scope.encType = $scope.hubEnc("fla");
        FrameLayoutsSrv.getAssignments().then(
          function(data){
            if($scope.selectedTab === "hub.frameLayouts.fla"){
            $scope.frameLayouts = data;
            $scope.updateList();
            $scope.loadingMain = false;
            $scope.curAssignmentId = angular.fromJson(localStorage.getItem("curAssignmentId"));
              if($scope.curAssignmentId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curAssignmentId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.frameLayouts.ufl"){
        $scope.encType = $scope.hubEnc("ufl");
        FrameLayoutsSrv.getUnapproved().then(
          function(data){
            if($scope.selectedTab === "hub.frameLayouts.ufl"){
            $scope.frameLayouts = data;
            $scope.updateList();
            $scope.loadingMain = false;
            $scope.curLayoutId = angular.fromJson(localStorage.getItem("curLayoutId"));
              if($scope.curLayoutId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curLayoutId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.frameLayouts.ifl"){
        $scope.encType = $scope.hubEnc("ifl");
        FrameLayoutsSrv.getIncompleted().then(
          function(data){
            if($scope.selectedTab === "hub.frameLayouts.ifl"){
            $scope.frameLayouts = data;
            $scope.updateList();
            $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.frameLayouts.fll"){
        $scope.encType = $scope.hubEnc("fll");
        if(caller == "home"){
          localStorage.removeItem("curFllId");
        }
        if(!localStorage.getItem("curFllId")){
          FrameLayoutsSrv.getLibrary().then(
            function(data){
              if($scope.selectedTab === "hub.frameLayouts.fll"){
              $scope.frameLayouts = data;
              $scope.updateList();
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.openFolderFx(localStorage.getItem("curFllId"));
        }
      }
    }
    $scope.loadSelectedTab();

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      localStorage.removeItem("curLayoutId");
      localStorage.removeItem("curAssignmentId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.updateList = function(){
      $scope.frameLayoutsLoading = false;
      if($scope.frameLayouts.info){
        $scope.tim = $scope.frameLayouts.info.timthumb;
        $scope.bucket = $scope.detailBucket = $scope.frameLayouts.info.bucket;
        if($scope.frameLayouts.info.mbucket && $scope.frameLayouts.info.mbucket != ""){
          $scope.detailBucket = $scope.frameLayouts.info.mbucket;
        }
      }
      // $scope.tabIndexFx("fl");
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchText = "";
      $scope.frameLayouts = {};
      $scope.contextMenuOpt = [];
      $scope.frameLayoutsLoading = true;
      $state.current = toState;
      localStorage.removeItem("curLayoutId");
      localStorage.removeItem("curAssignmentId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.selectedTab = $state.current.name;
      if($scope.selectedTab != "hub.frameLayouts.fll" && $scope.selectedTab != "hub.flContainer.flName" && $scope.selectedTab != "hub.flContainer.flDesign"){
        localStorage.removeItem("curFllId");
      }
      $scope.loadSelectedTab();
    });

    $scope.selectFolderFx = function(e, selectedItems){
      localStorage.setItem("curFllId", selectedItems.id);
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      $(e.currentTarget).addClass("ui-selected");
      $rootScope.selectedItems = [selectedItems];
      $scope.frameBtn = {buttons:[{key:"fllOpen"}]};
      $scope.updateContextMenu($scope.frameBtn);
    }

    $scope.selectableFx = function(e){
      // console.error("selectableFx ", e.target.tagName);
      if(e.target.tagName == "UL"){
        $rootScope.closeAllFx();
      }
    }

    $scope.briefFx = function(selectedItems){ /*Get frameLayouts brief*/
      // console.error("briefFx @#@#");
      $scope.encId = $scope.hubEncrypt(selectedItems[0].id);
      $scope.contextMenuOpt = [];
      $scope.btnLoading = true;
      $scope.frameBrief = [];
      $scope.frameBtn = [];
      localStorage.removeItem("curLayoutId");
      localStorage.removeItem("curAssignmentId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.curSelectedItem = $filter("filter")($scope.frameLayouts.frameLayouts, {id:$scope.selectedItems[0].id}, true);
      if($scope.selectedTab === "hub.frameLayouts.fla"){
        if(selectedItems.length == 1){
          FrameLayoutsSrv.getAssignmentsBrief(selectedItems[0].id).then(
            function(data){
              $scope.frameBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        FrameLayoutsSrv.saveAssignmentsBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.frameBtn = data;
            $scope.btnLoading = false;
            $scope.updateContextMenu($scope.frameBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.frameLayouts.fll"){
        if(selectedItems.length == 1){
          FrameLayoutsSrv.getLibraryBrief(selectedItems[0].id).then(
            function(data){
              $scope.frameBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        if($scope.auth.upermissions.f){
          $scope.filterIncompleted = $filter("filter")($scope.frameLayouts.frameLayouts, {id:$scope.selectedItems[0].id, thumbV:0}, true).length;
          if($scope.auth.uType == 0){
            $scope.frameBtn = {buttons:[{key:"flDelete"}]};
            if($scope.filterIncompleted == 0 && $scope.curSelectedItem[0].hfr && !$scope.curSelectedItem[0].sffl){
              $scope.frameBtn.buttons.unshift({key:"fllUse"});
            }
            if($scope.filterIncompleted == 0 && !$scope.curSelectedItem[0].hfr && $scope.curSelectedItem[0].sffl){
              $scope.frameBtn.info = [{key:"fllUse", code:2004109.1}, {key:"fllUse", code:2004109.2}];
            }
            if($scope.filterIncompleted == 0 && !$scope.curSelectedItem[0].hfr){
              $scope.frameBtn.info = [{key:"fllUse", code:2004109.1}];
            }
            if($scope.filterIncompleted == 0 && $scope.curSelectedItem[0].sffl){
              $scope.frameBtn.info = [{key:"fllUse", code:2004109.2}];
            }
            if($scope.selectedItems.length == 1){
              $scope.frameBtn.buttons.unshift({key:"flEdit", steps:[{key:"flStep1"},{key:"flStep2"}]});
            }
          } else if($scope.curSelectedItem[0].hfr && !$scope.curSelectedItem[0].sffl){
            $scope.frameBtn = {buttons:[{key:"fllUse"}]};
          } else if($scope.auth.upermissions.fll && !$scope.curSelectedItem[0].hfr && $scope.curSelectedItem[0].sffl){
            $scope.frameBtn.info = [{key:"fllUse", code:2004109.1}, {key:"fllUse", code:2004109.2}];
          } else if($scope.auth.upermissions.fll && $scope.curSelectedItem[0].hfr && $scope.curSelectedItem[0].sffl){
            $scope.frameBtn.info = [{key:"fllUse", code:2004109.2}];
          } else if($scope.auth.upermissions.fll && !$scope.curSelectedItem[0].hfr){
            $scope.frameBtn = {buttons:[], info:[{key:"fllUse", code:2004109.1}]};
          } else if(!$scope.auth.upermissions.fll && !$scope.curSelectedItem[0].hfr){
            $scope.frameBtn = {buttons:[], info:[{key:"fllUse", code:2004109.1}]};
          } else{
            $scope.frameBtn = {buttons:[], info:[{key:"fllUse", code:2004109}]};
          }
          $scope.btnLoading = false;
        } else if($scope.curSelectedItem[0].hfr && !$scope.auth.upermissions.fll){
          $scope.frameBtn = {buttons:[], info:[{key:"fllUse", code:2004109}]};
          $scope.btnLoading = false;
        } else{
          $scope.frameBtn = {buttons:[], info:[{key:"fllUse", code:2004101}]};
          $scope.btnLoading = false;
        }
        $scope.updateContextMenu($scope.frameBtn);
      } else{
        if(selectedItems.length == 1){
          FrameLayoutsSrv.getApprovedBrief(selectedItems[0].id).then(
            function(data){
              $scope.frameBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        FrameLayoutsSrv.saveApprovedBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.frameBtn = data;
            if(!$scope.curSelectedItem[0].hfr){
              if($scope.auth.upermissions.f && $scope.auth.upermissions.fla){
                angular.forEach($scope.frameBtn.info, function(info){
                  if(info.code == 2004105){
                    info.code = 2004105.1;
                  } else if(info.code == 2004101){
                    info.code = 2004101.1;
                  }
                });
              } else if(!$scope.auth.upermissions.f && $scope.auth.upermissions.fla){
                angular.forEach($scope.frameBtn.info, function(info){
                  if(info.code == 2004105){
                    info.code = 2004105.1;
                  }
                });
              } else if($scope.auth.upermissions.f && !$scope.auth.upermissions.fla){
                angular.forEach($scope.frameBtn.info, function(info){
                  if(info.code == 2004101){
                    info.code = 2004101.1;
                  }
                });
              }
            }
            $scope.updateContextMenu($scope.frameBtn);
            $scope.btnLoading = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/frameLayouts/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }

    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function(menuItem){
        if(menuItem.key == "flEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
        } else if(menuItem.key=="flDuplicate"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.50'); //('cm.btn.30')
        } else if(menuItem.key == "flAssign"){
          $scope.menuItemLabel = $filter("translate")('fl.btn.5');
        } else if(menuItem.key == "flApprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.24');
        } else if(menuItem.key == "flUnapprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.25');
        } else if(menuItem.key == "flDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key == "flaEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key == "flaApprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.24');
        } else if(menuItem.key == "flaUnapprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.25');
        } else if(menuItem.key == "flaDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key == "fllUse"){
          $scope.menuItemLabel = $filter("translate")('fl.btn.12');
        } else if(menuItem.key == "fllOpen"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.8');
        }

        $scope.curIndex = $scope.contextMenuOpt.length;
        $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
        if(menuItem.key == "flEdit" || menuItem.key == "flaEdit"){
          $scope.tempSubMenu = [];
          angular.forEach(menuItem.steps, function(subMenuItem){
            if(subMenuItem.key == "flStep1"){
              $scope.subMenu = $filter("translate")('fl.btn.3');
            } else if(subMenuItem.key == "flStep2"){
              $scope.subMenu = $filter("translate")('fl.btn.4');
            } else if(subMenuItem.key == "flaStep1"){
              $scope.subMenu = $filter("translate")('cm.label.72');
            } else if(subMenuItem.key == "flaStep2"){
              $scope.subMenu = $filter("translate")('cm.btn.27');
            } else if(subMenuItem.key == "flaStep3"){
              $scope.subMenu = $filter("translate")('cm.label.31');
            } else if(subMenuItem.key == "flaStep4"){
              $scope.subMenu = $filter("translate")('fl.btn.13');
            } else if(subMenuItem.key == "flaStep4.1"){
              $scope.subMenu = $filter("translate")('fl.btn.14');
            } else if(subMenuItem.key == "flaStep4.2"){
              $scope.subMenu = $filter("translate")('fl.btn.15');
            }
            $scope.tempSubMenu.push([$scope.subMenu, function($itemScope){$scope.contextMenuFx(subMenuItem);}]);
          });
          $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
        }
      });
    }
    $scope.contextMenuFx = function(menuItem){
      if(menuItem.key == "flEdit" || menuItem.key == "flStep1"){
        $state.go("hub.flContainer.flName", {type:$scope.encType, id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key == "flStep2"){
        $state.go("hub.flContainer.flDesign", {type:$scope.encType, id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key=="flDuplicate"){
        $scope.duplicateFx();
      } else if(menuItem.key == "flAssign"){
        $scope.addAssignFx();
      } else if(menuItem.key == "flApprove"){
        $scope.approveFrameFx();
      } else if(menuItem.key == "flUnapprove"){
        $scope.confirmFrameOpen('unapprove');
      } else if(menuItem.key == "flDelete"){
        $scope.confirmFrameOpen('delete');
      } else if(menuItem.key == "flaEdit" || menuItem.key == "flaStep1"){
        $state.go("hub.flContainer.flaName", {id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key == "flaStep2"){
        $state.go("hub.flContainer.flaSchedule", {id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key == "flaStep3"){
        $state.go("hub.flContainer.flaDevice", {id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key == "flaStep4" || menuItem.key == "flaStep4.1" || menuItem.key == "flaStep4.2"){
        $state.go("hub.flContainer.flaThreshold", {id:$scope.hubEncrypt($scope.frameBrief.id)});
      } else if(menuItem.key == "flaApprove"){
        $scope.approveAssignFx();
      } else if(menuItem.key == "flaUnapprove"){
        $scope.confirmAssignOpen('unapprove');
      } else if(menuItem.key == "flaDelete"){
        $scope.confirmAssignOpen('delete');
      } else if(menuItem.key == "fllUse"){
        $scope.useFrameLayoutFx();
      } else if(menuItem.key == "fllOpen"){
        $scope.openFolderFx(localStorage.getItem("curFllId"));
      }
    }
    $scope.contextMenuBase = [];
    if($scope.auth.upermissions.f){
      $scope.contextMenuBase.push([$filter("translate")("fl.btn.1"), function($itemScope){$state.go("hub.flContainer.flName", {type:$scope.encType});}]);
    }

    $scope.allFalse = function(){
      $scope.fcError = false;
      $scope.hasErr = false;
    }

    $scope.duplicateFx = function(){
      $scope.allFalse();
      $scope.isConfirmOpen = true;
      $scope.flProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.serverList = [];
      $rootScope.selectedT = 1;
      $scope.copyObj = {type:"w", sType:"copy", server:null};
      ngDialog.open({
        template:"app/frameLayouts/popup/move.html",
        width:500,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.confirmDuplicateFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($rootScope.selectedT == '2' && $scope.copyObj.server == null){
        $scope.hasErr = true;
        $scope.errType = "server";
      } else{
        $scope.flProcessing = true;
        if($rootScope.selectedT == '2'){
          $scope.copyItems = {type:"o", action:$scope.copyObj.sType, target:$scope.copyObj.server, selectedItems:$scope.selectedItems};
        } else{
          $scope.copyItems = {type:"w", selectedItems:$scope.selectedItems};
        }

        if($scope.copyObj.sType == "move"){
          FrameLayoutsSrv.saveFrameAssignmentsList($rootScope.selectedItems).then(
            function(data){
              $scope.assignmentList = data;
              $scope.flProcessing = false;
              if($scope.assignmentList.frameLayouts.length){
                $scope.dataObj = {action:"move", list:$scope.assignmentList};
                ngDialog.open({
                  template: "app/frameLayouts/popup/confirmFl.html",
                  width: 500,
                  data: $scope.dataObj,
                  scope: $scope,
                  closeByDocument: false,
                  className: "ngdialog-theme-default ngdialog-confirm",
                  preCloseCallback: function(){
                    $scope.isConfirmOpen = false;
                  }
                });
              }
              else{
                $scope.duplicateFrameFx($scope.copyItems);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.duplicateFrameFx($scope.copyItems);
        }
      }
    }

    $scope.duplicateFrameFx = function(copyItem){
      // $scope.flProcessing = true;
      if(!copyItem.action){
        copyItem.action = "copy";
      }
      FrameLayoutsSrv.duplicateFrameLayouts(copyItem).then(
        function(data){
          $scope.flProcessing = false;
          // console.warn("data",data);
          if(data.status == "success"){
            ngDialog.close();
            $scope.loadSelectedTab();
          } else if(data.code == 11022 || data.code == 11023){
            $scope.dataObj = {code:data.code};
            ngDialog.open({
              template: '\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div ng-if="dataObj.code == 11022">{{"fl.p_cfl.msg.10" | translate}}</div>\
                    <div ng-if="dataObj.code == 11023">{{"fl.p_cfl.msg.11" | translate}}</div>\
                    <div class="marT10"><span class="fa fa-envelope"></span> <span class="marL5">support@LSquared.com</span></div>\
                    <div class="marT5"><span class="fa fa-phone"></span> <span class="marL5">+1 877 525 1995</span></div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" class="btn btn-default" ng-click="closeThisDialog();">{{\'cm.btn.1\' | translate}}</button>\
                  </footer>\
                </section>',
              plain: true,
              width: 550,
              scope: $scope,
              closeByDocument: false,
              className: "ngdialog-theme-default ngdialog-confirm"
            });
          }
        },
        function(err){
          $scope.flProcessing = false;
          ngDialog.close();
          $log.error(err);
        }
      );
    }

    $scope.changeServerFx = function(){
      $scope.allFalse();
      if($scope.copyObj.server != null && !$scope.copyObj.server.fc){
        $scope.fcError = true;
      }
    }

    $rootScope.selectedTabFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.allFalse();
      if($rootScope.selectedT == 1){
        $scope.copyObj = {type:"w", sType:"copy", server:null};
      } else if($rootScope.selectedT == 2){
        if($scope.serverList.length == 0){
          $scope.listLoading = true;
          FrameLayoutsSrv.getServersList().then(
            function(data){
              $scope.listLoading = false;
              $scope.serverList = data.servers;
            },
            function(err){
              $scope.listLoading = false;
              $log.error(err);
            }
          );
        }
      }
    }
    $rootScope.selectedTabFx();

    $scope.changeTypeFx = function(){
      if($scope.selectedT == 1){
        $rootScope.selectedTabFx();
      }
    }

    $scope.deviceListFx = function(id, label){
      $scope.popupLabel = label;
      $scope.deviceRefObj = {id:id, label:label};
      $scope.deviceList = [];
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.haveMoreSearchData = false;
      $scope.searchScroll = false;
      $scope.refreshObj = {l:true, b:false};
      if($scope.selectedTab === "hub.frameLayouts.fla"){
        $scope.scrollObj = {caller:'fla', offset:0, id:id};
        // FrameLayoutsSrv.getAssignDeviceList(id).then(
        //   function(data){
        //     $scope.deviceList = data;
        //     $scope.refreshObj = {l:false, b:true};
        //   },
        //   function(err){
        //     $log.error(err);
        //   }
        // );
      } else{
        $scope.scrollObj = {caller:'fl', offset:0, id:id};
        // FrameLayoutsSrv.getFrameDeviceList(id).then(
        //   function(data){
        //     $scope.deviceList = data;
        //     $scope.refreshObj = {l:false, b:true};
        //   },
        //   function(err){
        //     $log.error(err);
        //   }
        // );
      }
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.marginLoad = false;
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList = angular.copy($scope.scrollDataList);
          $scope.refreshObj = {l:false, b:true};
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/frameLayouts/popup/deviceList.html",
        width:600,
        scope:$scope
      });
    }

    $scope.refreshPopupListFx = function(caller){
      $scope.loading = true;
      if(caller === 'device'){
        $scope.deviceList = [];
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.refreshObj = {l:true, b:true};
        if($scope.selectedTab === "hub.frameLayouts.fla"){
          $scope.scrollObj = {caller:'fla', offset:0, id:$scope.deviceRefObj.id};
        } else{
          $scope.scrollObj = {caller:'fl', offset:0, id:$scope.deviceRefObj.id};
        }
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.marginLoad = false;
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList = angular.copy($scope.scrollDataList);
            $scope.refreshObj.l = false;
            if(!$scope.scrollDataList.length){
              $scope.refreshObj.b = false;
            }
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'assignment'){
        $scope.assignmentList = [];
        if($scope.selectedTab === "hub.frameLayouts.fl"){
          FrameLayoutsSrv.getAssignmentList($scope.assignmentRefObj.id).then(
            function(data){
              $scope.assignmentList = data;
              $scope.loading = false;
            },
            function(err){
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
      }
    }


    $scope.downloadDeviceListFx = function(val){
      var downloadObj = {type:"", subType:"", devices:[]};
      var isPost = false;
      if($scope.selectedTab == "hub.frameLayouts.fl"){
        isPost = true;
        downloadObj.type = "flDevices";
      } else if($scope.selectedTab == "hub.frameLayouts.fla"){
        isPost = true;
        downloadObj.type = "flaDevices";
      }
      $scope.arraytoStringFx(val); /*Array to String common*/
      downloadObj.devices = $scope.stringIds;
      if(isPost){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel(downloadObj).then(
          function(data){
            if(data.code == 18009){
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
          }
        );
        return;
      }
    }

    $scope.assignmentListFx = function(id, label){
      $scope.popupLabel = label;
      $scope.assignmentRefObj = {id:id, label:label};
      $scope.assignmentList = [];
      if($scope.selectedTab === "hub.frameLayouts.fl"){
        FrameLayoutsSrv.getAssignmentList(id).then(
          function(data){
            $scope.assignmentList = data;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      ngDialog.open({
        template:"app/frameLayouts/popup/assignmentList.html",
        width:700,
        scope:$scope
      });
    }

    /*FrameLayouts Action Button*/
    $scope.addAssignFx = function(){
      $state.go("hub.flContainer.flaName", {fl:$scope.hubEncrypt($rootScope.selectedItems[0].id)});
    }

    $scope.editAssignment = function(id){
      ngDialog.close();
      $state.go("hub.flContainer.flaName", {id:$scope.hubEncrypt(id)});
    }

    $scope.confirmFrameOpen = function(action){
      $scope.isConfirmOpen = true;
      if($scope.selectedTab === "hub.frameLayouts.fl"){
        FrameLayoutsSrv.saveFrameAssignmentsList($rootScope.selectedItems).then(
          function(data){
            $scope.assignmentList = data;
            $scope.dataObj = {action:action, list:$scope.assignmentList};
            ngDialog.open({
              template:"app/frameLayouts/popup/confirmFl.html",
              width:500,
              data:$scope.dataObj,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm",
              preCloseCallback:function(){
                $scope.isConfirmOpen = false;
              }
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.dataObj = {action:action, list:""};
        ngDialog.open({
          template:"app/frameLayouts/popup/confirmFl.html",
          width:500,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm",
          preCloseCallback:function(){
            $scope.isConfirmOpen = false;
          }
        });
      }
    }
    $scope.confirmFrameFx = function(){ /* Delete and Unapproved */
      $scope.flProcessing = true;
      if($scope.dataObj.action == "delete"){
        $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
        if($scope.selectedTab === "hub.frameLayouts.fll"){
          FrameLayoutsSrv.deleteLibrary($scope.stringIds).then(
            function(data){
              $scope.flProcessing = false;
              ngDialog.close();
              $scope.loadSelectedTab();
            },
            function(err){
              $scope.flProcessing = false;
              $log.error(err);
            }
          );
        } else{
          FrameLayoutsSrv.deleteFrameLayout($scope.stringIds).then(
            function(data){
              $scope.flProcessing = false;
              ngDialog.close();
              $scope.loadSelectedTab();
            },
            function(err){
              $scope.flProcessing = false;
              $log.error(err);
            }
          );
        }
      } else if($scope.dataObj.action == "category"){
        $scope.deleteFLCategory($scope.frameLayouts.info.id);
      } else{
        FrameLayoutsSrv.updateUnapprove($rootScope.selectedItems).then(
          function(data){
            $scope.flProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.flProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.deleteFLCategory = function(id){
      FrameLayoutsSrv.deleteCategory(id).then(
        function(data){
          ngDialog.close();
          $scope.flProcessing = false;
          $scope.loadSelectedTab('home');
        },
        function(err){
          $scope.flProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.approveFrameFx = function(){
      FrameLayoutsSrv.updateApprove($rootScope.selectedItems).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    /*Assignment Action Button*/
    $scope.confirmAssignOpen = function(action){
      $scope.isConfirmOpen = true;
      $scope.dataObj = {action:action};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dataObj.action == \'delete\'">{{selectedItems.length > 1?"fl.msg.14s":"fl.msg.14" | translate}}</span>\
              <span ng-if="dataObj.action == \'unapprove\'">{{selectedItems.length > 1?"fl.msg.15s":"fl.msg.15" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-warning btn-sm" ng-class="{\'btn-danger\':dataObj.action==\'delete\'}" ng-click="confirmAssignFx();" ng-disabled="flProcessing"><span class="fa fa-repeat fa-spin" ng-if="flProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.confirmAssignFx = function(){ /* Delete and Unapproved */
      $scope.flProcessing = true;
      if($scope.dataObj.action == "delete"){
        $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
        FrameLayoutsSrv.deleteAssignment($scope.stringIds).then(
          function(data){
            $scope.flProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.flProcessing = false;
            $log.error(err);
          }
        );
      } else{
        FrameLayoutsSrv.updateUnapproveAssign($rootScope.selectedItems).then(
          function(data){
            $scope.flProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.flProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.approveAssignFx = function(){
      FrameLayoutsSrv.updateApproveAssign($rootScope.selectedItems).then(
        function(data){
          if(data.code && data.code == 11020){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"fl.msg.13" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.useFrameLayoutFx = function(){
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body" translate="{{selectedItems.length > 1?\'fl.msg.12s\':\'fl.msg.12\'}}" translate-values="{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}"></div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-click="confirmUseFx();" ng-disabled="flProcessing"><span class="fa fa-repeat fa-spin" ng-if="flProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.confirmUseFx = function(){
      $scope.flProcessing = true;
      FrameLayoutsSrv.saveUseFrameLayout($rootScope.selectedItems).then(
        function(data){
          $scope.flProcessing = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.flProcessing = false;
          $log.error(err);
        }
      );
    }

    /*Knowledge base*/
    $scope.videoFx = function(tabName){
      $scope.videoObj = {tabName:tabName};
      $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "bwIrRLjkyUI" + $scope.videoParam);
      ngDialog.open({
        template:'app/frameLayouts/popup/video.html',
        width:580,
        data:$scope.videoObj,
        scope:$scope
      });
    }
    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {tabName:tabName};
      ngDialog.open({
        template:'app/frameLayouts/popup/info.html',
        width:580,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen){
        angular.forEach($scope.frameBtn.buttons, function(btn){
          if(btn.key == "flDelete" || btn.key == "flaDelete"){
            $scope.isDeletable = true;
          }
        });
        if($scope.isDeletable){
          if($scope.selectedTab === "hub.frameLayouts.fla"){
            $scope.confirmAssignOpen('delete');
          } else if($scope.selectedTab === "hub.frameLayouts.fll"){
            // Do nothing
            if($scope.auth.uType == 0){
              $scope.confirmFrameOpen('delete');
            }
          } else{
            $scope.confirmFrameOpen('delete');
          }
        }
      }
    }

    /*For Mail to Support*/
    $scope.mailSupportOpen = function(){
      $scope.savePopProcessing = false;
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
      ngDialog.open({
        template: "app/support/popup/mailToSupport.html",
        scope: $scope,
        closeByDocument: false,
        width: 500
      });
    }
    $scope.saveMailSupportFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";

      if(!$scope.mail.subject || $scope.mail.subject == ""){
        $scope.errPopType = "subject";
        $scope.hasPopErr = true;
      }
      else if(!$scope.mail.message || $scope.mail.message == ""){
        $scope.errPopType = "message";
        $scope.hasPopErr = true;
      }
      else{
        $scope.savePopProcessing = true;
        SupportSrv.saveMailSupport($scope.mail).then(
          function(data){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.unselectTypeFx = function(){
      setTimeout(function(){
        angular.forEach(angular.element('.ui-selectable li'), function(item){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        });
      }, 100);
    }

    $scope.closeAllFx = function(){
      $scope.unselectTypeFx();
      $rootScope.closeAllFx();
    }

    // * scroll list data code START 2nd phase pagination
    $scope.haveMoreData = false;
    $scope.haveMoreSearchData = false;
    $scope.visibleData = [];
    $scope.stIndex = 0
    $scope.etIndex = 300;
    $scope.searchScroll = false;

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj){
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj){
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
        $scope.loading = false;
        $scope.refreshObj = {l:true, b:false};
        $scope.marginLoad = true;
        $scope.marRemove = false;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj){
      // console.warn("visibleData",obj);
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function(){
        $scope.$apply();
      }, 0);
    });

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);

          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    // * scroll list data code END 2nd phase pagination
  };
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('FrameLayoutCUController', FrameLayoutCUController);

  /** @ngInject */
  function FrameLayoutCUController($log, $rootScope, $scope, $state, $timeout, $filter, ngDialog, CommonSrv, SupportSrv, FrameLayoutsSrv, FrameLayoutCUSrv){
    $rootScope.isPermissionOpen = false;
    $rootScope.selectedMenu = 4;
    $scope.resolutionsL = ["1920x1080", "1280x720", "1366x768", "1600x900"];
    $scope.resolutionsP = ["1080x1920", "720x1280", "768x1366", "900x1600"];
    $scope.temp = "app/common/dir/tmpl/hubColorPicker.html";
    $scope.colorPicker = {isOpen:false, b:false};
    $scope.curStage = $state.current.name;
    $scope.frameBg = {isChecked:false};
    $scope.saveCloseProcessing = false;
    $scope.detailLoading = false;
    $scope.flProcessing = false;
    $scope.availableGroups = [];
    $scope.idForPermission = 0;
    $scope.tempPermission = "";
    $scope.filteredGroups = {};
    $scope.userPermission = {};
    $scope.snap = {grid:true};
    $scope.frameInfoCopy = {};
    $scope.frameLayout = {};
    $scope.resolutions = [];
    $scope.zoomLevels = [];
    $scope.hasErr = false;
    $scope.fitToFrame = 0;
    $scope.errType = "";
    $scope.encType = "";
    $scope.decType = "";
    $scope.flHeight = 0;
    $scope.flWidth = 0;
    $scope.frameId = 0;
    $scope.imgUrl = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.curZ = 1;
    $scope.curFrame;
    $scope.canvas = {};
    $scope.canvas.zoom = '0.5';


    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.curStage = $state.current.name;
    });

    if($scope.curStage == 'hub.flContainer.flDesign'){
      CommonSrv.getPermissions().then(
        function(data){
          $scope.userPermission = data;
          $scope.availableGroups = data.availableGroups;
          $scope.tempPermission = angular.copy($scope.userPermission);
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.loadDataFx = function(){
      if($scope.decType == "fll"){
        FrameLayoutCUSrv.getLibraryDetails($scope.decId).then(
          function(data){
            $scope.frameLayout = data;
            $scope.getflCommonObjFx();
          },
          function(err){
            $scope.detailLoading = false;
            $log.error(err);
          }
        );
      } else{
        FrameLayoutCUSrv.getFrameLayoutDetails($scope.decId).then(
          function(data){
            $scope.frameLayout = data;
            $scope.frameInfoCopy = angular.copy($scope.frameLayout.info);
            $scope.getflCommonObjFx();
          },
          function(err){
            $log.error(err);
            $scope.detailLoading = false;
          }
        );
      }
    }

    if($state.params.id){
      $scope.decType = $scope.hubDec($state.params.type);
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encType = $state.params.type;
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;
      $scope.loadDataFx();
    } else{
      $scope.resolutions = $scope.resolutionsL;
      $scope.frameLayout = {
        info:{label:"", isCompleted:false, orientation:"l", dimension:"1920x1080", resolutionCustW:"", resolutionCustH:"", layoutBGType:"monochrome", layoutBG:"#000000", step:"info", halign:"c", valign:"m"},
        frames:[]
      };
    }

    $scope.frameAlignFx = function(val){
      $scope.curFrame.align = val;
    }

    $scope.getflCommonObjFx = function(){
      $scope.detailLoading = false;
      if($scope.frameLayout.frames){
        $scope.curZ = $scope.frameId = $scope.frameLayout.frames.length + 1;
      }
      if($scope.frameLayout.info.orientation == "c"){
        $scope.flHeight = $scope.frameLayout.info.resolutionCustH;
        $scope.flWidth = $scope.frameLayout.info.resolutionCustW;
      } else{
        if($scope.frameLayout.info.orientation == "l"){
          $scope.resolutions = $scope.resolutionsL;
        } else if($scope.frameLayout.info.orientation == "p"){
          $scope.resolutions = $scope.resolutionsP;
        }
        $scope.flHeight = $scope.frameLayout.info.dimension.split("x")[1];
        $scope.flWidth = $scope.frameLayout.info.dimension.split("x")[0];
      }
      $timeout(function(){
        $scope.scaleHeight = $("#canvas").height() / $scope.flHeight;
        $scope.scaleWidth = $("#canvas").width() / $scope.flWidth;
  			if($scope.scaleWidth < $scope.scaleHeight){
  				$scope.canvas.zoom = Math.round($scope.scaleWidth * 100) / 100;
  			} else{
  				$scope.canvas.zoom = Math.round($scope.scaleHeight * 100) / 100;
  			}
        $scope.fitToFrame = $scope.canvas.zoom;
        $scope.zoomLevels = [{val:$scope.canvas.zoom, label:$filter("translate")('fl.p_cfl.label.23')},{val:1, label:"100%"},{val:0.75, label:"75%"},{val:0.5, label:"50%"},{val:0.25, label:"25%"},{val:0.1, label:"10%"}];
       $scope.canvas.zoom = $scope.zoomLevels[0].val;
      }, 100);
    }

    $scope.addFrame = function(){
      $scope.frameLayout.frames.push({
        id:"fl" + $scope.frameId,
        label:"Frame " + parseInt($scope.frameLayout.frames.length + 1),
        width:100,
        height:100,
        bg:"",
        bga:1,
        rgba:"",
        fill:"fit",
        align:"m-c",
        rotation:0,
        isEditable:1,
        settings:{br:{tl:0, tr:0, bl:0, br:0, isBorder:false}, ish:{hl:0, vl:0, br:10, sr:5, sc:"#000000", sca:0.75, rgba:'rgba(0,0,0,1)',scType:"monochrome", isShadow:false}},
        // br:{tl:0, tr:0, bl:0, br:0},
        // ish:{hl:1, vl:0, br:0, sr:0, sc:"#000000", sca:0.75, rgba:'rgba(0,0,0,1)', scType:"monochrome"},
        x:Math.round($("#canvas").scrollLeft()) * (1 / $scope.canvas.zoom),
        y:Math.round($("#canvas").scrollTop()) * (1 / $scope.canvas.zoom),
        z:$scope.curZ,
        permission:angular.copy($scope.tempPermission),
        isNew:1
      });
      $scope.frameId++;
      $scope.curZ++;

      $(".sortable-containment").sortable({
        cancel:".span"
      });
      $timeout(function(){$scope.selectFrame(null, $scope.frameLayout.frames[$scope.frameLayout.frames.length - 1], ($scope.frameLayout.frames.length - 1));}, 100);
    }

    $scope.duplicateFrame = function(){
      // console.warn($scope.curFrame);
      $scope.frameLayout.frames.push({
        id:"fl" + $scope.frameId,
        label:$scope.curFrame.label + " - Copy",
        width:$scope.curFrame.width,
        height:$scope.curFrame.height,
        bg:$scope.curFrame.bg,
        bga:$scope.curFrame.bga,
        br:$scope.curFrame.br,
        settings:angular.copy($scope.curFrame.settings),
        rgba:$scope.curFrame.rgba,
        bgType:$scope.curFrame.bgType,
        rotation:$scope.curFrame.rotation,
        fill:$scope.curFrame.fill,
        align:$scope.curFrame.align,
        x:$scope.curFrame.x,
        y:$scope.curFrame.y,
        z:$scope.curZ,
        isEditable:$scope.curFrame.isEditable,
        permission:angular.copy($scope.curFrame.permission),
        isNew:1
      });

      $scope.frameId++;
      $scope.curZ++;

      $(".sortable-containment").sortable({
        cancel:".span"
      });
      $timeout(function(){$scope.selectFrame(null, $scope.frameLayout.frames[$scope.frameLayout.frames.length - 1], ($scope.frameLayout.frames.length - 1));}, 100);
    }

    $scope.selectFrame = function(e, frame, index){
      if(e){
        e.stopPropagation();
      }
      if(frame.isEditable){
        $scope.idForPermission = frame.id;
        $rootScope.isPermissionOpen = false;
        $scope.colorPicker.isOpen = false;
        $scope.colorPicker.isSc = false;
        $scope.curFrame = frame;
        try{
          $scope.updatePermission();
        } catch(e){}

        $(".layer-container .layer").removeClass("selected");
        $(".frame").removeClass("selected");

        $(".layer[data-id=" + frame.id + "]").addClass("selected");
        $(".frame[data-id=" + frame.id + "]").addClass("selected");

        if($scope.curFrame.bg != ''){
          $scope.frameBg.isChecked = true;
        } else{
          $scope.frameBg.isChecked = false;
        }
      }
    }

    $scope.deselectAllFrames = function(){
      $(".layer").removeClass("selected");
      $(".frame").removeClass("selected");
      $scope.colorPicker.isOpen = false;
      $scope.colorPicker.isSc = false;
      $scope.frameBg.isChecked = false;
      $scope.curFrame = null;
      try{
        $scope.permissionFx('cancel');
      } catch(e){}
    }

    $scope.orientationChangeFx = function(orientation){
      if(orientation == "l"){
        $scope.resolutions = $scope.resolutionsL;
      } else if(orientation == "p"){
        $scope.resolutions = $scope.resolutionsP;
      } else{
        $scope.resolutions = [];
      }
      $scope.frameLayout.info.dimension = $scope.resolutions[0];
    }

    $scope.frameResize = function(e, index, ui){
      $scope.frameLayout.frames[index].width = Math.round((1 / $scope.canvas.zoom) * ui.size.width);
      $scope.frameLayout.frames[index].height = Math.round((1 / $scope.canvas.zoom) * ui.size.height);
    }

    $scope.frameDrag = function(e, ui, index){
      $scope.frameLayout.frames[index].x = Math.round((1 / $scope.canvas.zoom) * ui.position.left);
      $scope.frameLayout.frames[index].y = Math.round((1 / $scope.canvas.zoom) * ui.position.top);
    }

    $scope.frameDragStart = function(e, ui, index){}

    $scope.sortCallback = function(e, ui, index){
      $scope.curLayer = $(".layer").length + 1;
      $(".layer").each(function(){
        for(var i = 0; i < $scope.frameLayout.frames.length; i++){
          if($scope.frameLayout.frames[i].id == $(this).data("id")){
            $scope.frameLayout.frames[i].z = $scope.curLayer - 1;
            break;
          }
        }
        $scope.curLayer--;
      });
      $("#canvas").click();
    }

    $scope.snapGridFx = function(e){
        $(".frame:not(.notSelectable)").draggable({
          grid:[1, 1]
        });
        $(".frame:not(.notSelectable)").resizable({
          grid:[1, 1]
        });
    }
    $scope.frameBgFx = function(e){
      if(!$(e.currentTarget).children("input")[0].checked && $scope.curFrame){
        $scope.curFrame.bgType = '';
        $scope.curFrame.rgba = '';
        $scope.curFrame.bg = '';
        $scope.curFrame.bga = 1;
      } else{
        $scope.colorPickerOpen(e);
      }
    }
    $scope.colorPickerOpen = function($event, caller){
      $event.stopPropagation();
      if(caller=="sc"){
        $scope.colorPicker.isSc = true;
        if(!$scope.curFrame.ish){
          $scope.curFrame.ish.sca = 1;
          $scope.curFrame.ish.sc = '#000000';
          $scope.curFrame.ish.scType = 'monochrome';
          $scope.curFrame.ish.rgba = 'rgba(0,0,0,1)';
        }
      } else {
        $scope.colorPicker.isOpen = true;
        if(!$scope.curFrame.bg){
          $scope.curFrame.bga = 1;
          $scope.curFrame.bg = '#000000';
          $scope.curFrame.bgType = 'monochrome';
          $scope.curFrame.rgba = 'rgba(0,0,0,1)';
        }
      }
    }

    $scope.resetAdSettingFx = function(isShadow, caller){
      if(!isShadow){
        if(caller=='b'){
          $scope.curFrame.settings.br = {tl:0, tr:0, bl:0, br:0, isBorder:false};
        } else {
          $scope.curFrame.settings.ish = {hl:0, vl:0, br:10, sr:5, sc:"#000000", sca:0.75, rgba:'rgba(0,0,0,1)', scType:"monochrome", isShadow:false};
        }
      }
    }

    $scope.saveAnywayProcessing = false;
    $scope.saveFrameLayout = function(caller, action){
      if(action == undefined){
        $scope.frameLayout.info.toast = false;
      } else{
        $scope.frameLayout.info.toast = true;
      }
      $scope.frameLayout.info.type = $scope.hubDec($state.params.type);
      if(action == "saveAnyway"){
        $scope.saveAnywayProcessing = true;
      } else{
        $scope.saveAnywayProcessing = false;
      }
      if(caller == "design"){
        $scope.hasErr = false;
        $scope.errType = "";
        $scope.isDefaultFram = false;
        $scope.frameLayout.frames = $filter('orderBy')($scope.frameLayout.frames, "id");

        if($scope.frameLayout.frames.length){
          $scope.dNameEmpty = false;
          angular.forEach($scope.frameLayout.frames, function(frame){
            if(frame.label == ""){
              $scope.dNameEmpty = true;
            }
          })
        }
        if($scope.dNameEmpty){
          $scope.errType = "dName";
          $scope.hasErr = true;
        } else {
          if($scope.frameLayout.info.dFId){
            angular.forEach($scope.frameLayout.frames, function(frame){
              if(frame.id == $scope.frameLayout.info.dFId){
                $scope.isDefaultFram = true;
              }
            });
          } else if($scope.frameLayout.frames.length > 0){
            $scope.frameLayout.info.dFId = $scope.frameLayout.frames[0].id;
          }
          if(!$scope.isDefaultFram && $scope.frameLayout.frames.length > 0){
            $scope.frameLayout.info.dFId = $scope.frameLayout.frames[0].id;
          } else if($scope.frameLayout.frames.length == 0){
            $scope.frameLayout.info.dFId = "";
          }

          if($scope.isPermissionOpen){
            $scope.hasErr = true;
            $scope.errType = "per";
            return;
          }

          if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameLayout.info.orientation == "c" && !$scope.frameLayout.info.isCompleted && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920)){
            $scope.errType = "hfr";
            $scope.hasErr = true;
            return;
          } else if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameInfoCopy.orientation !== "c" && $scope.frameLayout.info.orientation == "c" && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920)){
            $scope.errType = "hfr";
            $scope.hasErr = true;
            return;
          } else if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameLayout.info.orientation == "c" && ($scope.frameInfoCopy.resolutionCustW !== "" && $scope.frameInfoCopy.resolutionCustH !== "") && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920) && ($scope.frameLayout.info.resolutionCustW > $scope.frameInfoCopy.resolutionCustW || $scope.frameLayout.info.resolutionCustH > $scope.frameInfoCopy.resolutionCustH)){
            $scope.errType = "hfr";
            $scope.hasErr = true;
            return;
          } else if($scope.auth.upermissions.sffl && $scope.frameLayout.frames.length > 1){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"fl.p_cfl.msg.11" | translate}}</div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{\'cm.btn.1\' | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:550,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          }

          $scope.frameLayout.info.step = "frame";
          if(action == "s"){
            $scope.saveProcessing = true;
          } else{
            $scope.saveCloseProcessing = true;
          }

          if(action != "saveAnyway" && $scope.frameLayout.frames.length == 0){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"fl.p_cfl.msg.9" | translate}}</div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-success" ng-click="closeThisDialog();" data-dismiss="modal">{{\'fl.p_cfl.label.17\' | translate}}</button>\
                    <button type="button" role="button" class="btn btn-danger" ng-click="saveFrameLayout(\'design\', \'saveAnyway\');">{{\'fl.p_cfl.label.18\' | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:600,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            $scope.saveProcessing = false;
            $scope.saveCloseProcessing = false;
            return true;
          } else{
            ngDialog.close();
          }

          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body text-center">\
                  <div>{{"cm.msg.10" | translate}}</div>\
                </div>\
              </section>',
            plain:true,
            width:300,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
          $(".frame").removeClass("selected");
          if(action == "sc"){
            $scope.canvas.zoom = $scope.fitToFrame;
            $("#canvas").css("overflow-x", "visible")
            $("#canvas").css("height", "auto")
            $(".frame").css("border", "1px solid #003E66");
            $(".frame .frameSize").removeClass("hide");
            $(".frame .ui-resizable-handle").remove();
            $(".frame").removeClass("nonSelectable");
            $(".frame").css("box-shadow", "none");
            $(".frame .remove").remove();
          }
          html2canvas($(".flGrid"),{
            onrendered:function(canvas){
              $scope.imgUrl = canvas.toDataURL("image/png");
              $scope.frameLayout.base64 = $scope.imgUrl;
              $timeout(function(){$("#canvas").click();}, 250);
              if($scope.auth.uType == 0 && $scope.frameLayout.info.libraryOpt){
                FrameLayoutCUSrv.saveLibrary($scope.frameLayout).then(
                  function(data){
                    $scope.saveCloseProcessing = false;
                    $scope.saveProcessing = false;
                    ngDialog.close();
                    if(action == "s"){
                      $state.go("hub.flContainer.flDesign", {type:$scope.encType, id:$scope.encId});
                    } else{
                      $state.go("hub.frameLayouts.fll");
                    }
                  },
                  function(err){
                    $scope.saveCloseProcessing = false;
                    ngDialog.close();
                    $log.error(err);
                  }
                );
              } else{
                FrameLayoutCUSrv.saveFrameLayout($scope.frameLayout).then(
                  function(data){
                    $scope.saveCloseProcessing = false;
                    $scope.saveProcessing = false;
                    ngDialog.close();
                    if(action == "s"){
                      $scope.loadDataFx();
                      if($state.current.name == "hub.flContainer.flDesign"){
                      $state.go("hub.flContainer.flDesign", {type:$scope.encType, id:$scope.encId});
                      }
                    } else{
                      if($state.current.name == "hub.flContainer.flDesign"){
                        $state.go("hub.frameLayouts.fl");
                      }
                    }
                  },
                  function(err){
                    $scope.saveCloseProcessing = false;
                    ngDialog.close();
                    $log.error(err);
                  }
                );
              }
            }
          });
        }
      } else if(caller == "name"){
        $scope.frameLayout.info.step = "info";
        $scope.newCategory = false;
        $scope.hasErr = false;
        $scope.errType = "";

        if($scope.auth.uType == 0 && $scope.frameLayout.info.libraryOpt && $scope.frameLayout.info.newCategory){
          angular.forEach($scope.librarys, function(item){
            if(angular.lowercase(item.label) == angular.lowercase($scope.frameLayout.info.newCategory)){
              $scope.newCategory = true;
            }
          });
        }
        if($scope.frameLayout.info.label == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#label").focus();
        } else if($scope.frameLayout.info.orientation == 'c' && (!$scope.frameLayout.info.resolutionCustW || $scope.frameLayout.info.resolutionCustW === "" || !$scope.frameLayout.info.resolutionCustH || $scope.frameLayout.info.resolutionCustH === "")){
          $scope.errType = "dimension";
          $scope.hasErr = true;
          if(!$scope.frameLayout.info.resolutionCustW || $scope.frameLayout.info.resolutionCustW === ""){
            $("#resolutionCustW").focus();
          } else if(!$scope.frameLayout.info.resolutionCustH || $scope.frameLayout.info.resolutionCustH === ""){
            $("#resolutionCustH").focus();
          }
        } else if($scope.auth.uType == 0 && $scope.frameLayout.info.libraryOpt && !$scope.frameLayout.info.category && (!$scope.frameLayout.info.newCategory || $scope.frameLayout.info.newCategory == "")){
          $scope.errType = "library";
          $scope.hasErr = true;
          $("#newCategory").focus();
        } else if($scope.auth.uType == 0 && $scope.frameLayout.info.libraryOpt && !$scope.frameLayout.info.category && $scope.newCategory){
          $scope.errType = "categoryExists";
          $scope.hasErr = true;
          $("#newCategory").focus();
        } else if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameLayout.info.orientation == "c" && !$scope.frameLayout.info.isCompleted && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920)){
          $scope.errType = "hfr";
          $scope.hasErr = true;
        } else if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameInfoCopy.orientation !== "c" && $scope.frameLayout.info.orientation == "c" && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920)){
          $scope.errType = "hfr";
          $scope.hasErr = true;
        } else if(!$scope.auth.upermissions.hfr && !$scope.frameLayout.info.libraryOpt && $scope.frameLayout.info.orientation == "c" && ($scope.frameInfoCopy.resolutionCustW !== "" && $scope.frameInfoCopy.resolutionCustH !== "") && ($scope.frameLayout.info.resolutionCustW > 1920 || $scope.frameLayout.info.resolutionCustH > 1920) && ($scope.frameLayout.info.resolutionCustW > $scope.frameInfoCopy.resolutionCustW || $scope.frameLayout.info.resolutionCustH > $scope.frameInfoCopy.resolutionCustH)){
          $scope.errType = "hfr";
          $scope.hasErr = true;
        } else{
          if(action == undefined){
            $scope.flProcessing = true;
          } else{
            $scope.saveCloseProcessing = true;
          }
          if($scope.auth.uType == 0 && $scope.frameLayout.info.libraryOpt){
            FrameLayoutCUSrv.saveLibrary($scope.frameLayout).then(
              function(data){
                $scope.encId = $scope.hubEncrypt(data.layoutId);
                $scope.encType = $scope.hubEnc("fll");
                $scope.saveCloseProcessing = false;
                $scope.flProcessing = false;
                if(action == undefined){
                  if($state.current.name == "hub.flContainer.flName"){
                    $state.go("hub.flContainer.flDesign", {type:$scope.encType, id:$scope.encId});
                  }
                } else{
                  $state.go("hub.frameLayouts.fll");
                }
              },
              function(err){
                $scope.saveCloseProcessing = false;
                $scope.saveProcessing = false;
                $log.error(err);
              }
            );
          } else{
            FrameLayoutCUSrv.saveFrameLayout($scope.frameLayout).then(
              function(data){
                $scope.encId = $scope.hubEncrypt(data.layoutId);
                $scope.encType = $scope.hubEnc("fl");
                $scope.saveCloseProcessing = false;
                $scope.flProcessing = false;
                if(action == undefined){
                  if($state.current.name == "hub.flContainer.flName"){
                    $state.go("hub.flContainer.flDesign", {type:$scope.encType, id:$scope.encId});
                  }
                } else{
                  if($state.current.name == "hub.flContainer.flName"){
                    $state.go("hub.frameLayouts.fl");
                  }
                }
              },
              function(err){
                $scope.saveCloseProcessing = false;
                $scope.flProcessing = false;
                $log.error(err);
              }
            );
          }
        }
      }
    // }
    }

    $scope.cancelFx = function(){
      if($scope.decType == "fll"){
        $state.go("hub.frameLayouts.fll");
      } else{
        $state.go("hub.frameLayouts.fl");
      }
    }

    $rootScope.deleteCallback = function(){
      if($scope.curFrame){
        $scope.removePlaceholder();
      }
    }

    $scope.removePlaceholder = function(id, type){
      if(!$scope.isConfirmOpen){
        if(type){
          $scope.removeObj = {id:id, type:type};
        } else{
          $scope.removeObj = null;
        }
        $scope.confirmDeleteFrame();
      }
    }

    $scope.confirmDeleteFrame = function(){
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"fl.p_cfl.msg.5" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFrame();" ng-disabled="templateProcessing">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deleteFrame = function(){
      if($scope.removeObj){
        if($scope.removeObj.type == "f"){
          $scope.frameLayout.frames.splice($scope.removeObj.id, 1);
        } else if($scope.removeObj.type == "l"){
          $scope.frameLayout.frames.splice($scope.frameLayout.frames.indexOf($scope.frameLayout.frames.filter(function(obj){
            return obj.id == $scope.removeObj.id;
          })[0]), 1);
        }
      } else{
        for(var i=0; i<$scope.frameLayout.frames.length; i++){
          if($scope.frameLayout.frames[i].id == $scope.curFrame.id){
            $scope.frameLayout.frames.splice(i, 1);
            break;
          }
        }
      }
      $timeout(function(){$("#canvas").click();}, 250);
      ngDialog.close();
    }

    $scope.permissionFx = function(caller){
      if(caller == "edit"){
        $scope.curPermisson = {};
        $scope.curPermisson = $scope.curFrame.permission;
        $scope.tempPermission = angular.copy($scope.curFrame.permission);
        $scope.permissionLoading = false;
        $rootScope.isPermissionOpen = true;
      } else if(caller == 'save'){
        $scope.curFrame.permission.groups = $scope.curPermisson.groups;
        $scope.curFrame.permission.type = $scope.curPermisson.type;
        $rootScope.isPermissionOpen = false;
      } else if(caller == 'cancel'){
        $rootScope.isPermissionOpen = false;
        $scope.curFrame.permission = angular.copy($scope.tempPermission);
      }
    }

    if($scope.auth.uType == 0 && $scope.curStage == "hub.flContainer.flName" && $scope.decType != "fl"){
      FrameLayoutsSrv.getLibrary().then(
        function(data){
          $scope.librarys = data.frameLayouts;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*For Mail to Support*/
    $scope.mailSupportOpen = function(){
      $scope.savePopProcessing = false;
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
      ngDialog.open({
        template:"app/support/popup/mailToSupport.html",
        scope:$scope,
        closeByDocument:false,
        width:500
      });
    }

    $scope.saveMailSupportFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";

      if(!$scope.mail.subject || $scope.mail.subject == ""){
        $scope.errPopType = "subject";
        $scope.hasPopErr = true;
      } else if(!$scope.mail.message || $scope.mail.message == ""){
        $scope.errPopType = "message";
        $scope.hasPopErr = true;
      } else{
        $scope.savePopProcessing = true;
        SupportSrv.saveMailSupport($scope.mail).then(
          function(data){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.ngDialogOpenedCount = 0;
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('AssignmentCUController', AssignmentCUController);

  /** @ngInject */
  function AssignmentCUController($log, $rootScope, $scope, $state, $filter, $timeout, ngDialog, DevicesSrv, SupportSrv, AssignmentCUSrv, FileModelUploadSrv, CommonSrv){
    $rootScope.selectedMenu = 4;
    $scope.selectedTab = $state.current.name;
    $scope.devices = {devices:"", info:{}};
    $scope.selectedFilteredList = {};
    $scope.searchTextFla = {text:""};
    $scope.deviceListLoading = true;
    $scope.detailLoading = false;
    $scope.hiddenDevices = false;
    $scope.deviceGrpList = [];
    $scope.flDeviceList = [];
    $scope.frameLayout = [];
    $scope.filter = "all";
    $scope.bucket = "";
    $scope.decId = "";
    $scope.flId = "";
    $scope.tim = "";
    $scope.flaProcessing = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.selectedFolder;
    $scope.tempGroups = {};
    $scope.folderList = [];
    $scope.thumbSize = 'n';
    $scope.masterDeviceId;
    $scope.mDAccessible = {isAccissable:false};
    $scope.ipAddressPattern = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    $scope.dOffset = 0;
    $scope.isAPISearch = {enable:false};

    $rootScope.importXls = {file:""};
    $rootScope.clearSearch = false;
    $scope.advSearchInfo = {};

    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.getAllData = {search:false,advSearch:false,filter:false,list:false};
    $scope.selPaginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.copyDevices = {devices:[],folders:[]};
    $scope.stored = {devices:[], folders:[]};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.statusObj = {d:false,s:false,as:false,f:false};

    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.isAdvSearchMsg = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.advSApply = false;
    $scope.filterIsAppliedAlready = false;
    $scope.rdc = 0;
    $rootScope.addStatusKeyVal = {value: true};
    $scope.isPageApiLoad = false;
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $scope.selectedSearch = {text:""};
    $rootScope.search = {text:""};
    $rootScope.commonSearchVar = "";

    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getTotalDeviceCountFx();
    if($scope.auth.upreferences.isSplitV){
      $scope.tabHeight = $scope.getAvailableHeight(315);
      $scope.selectedHeight = $scope.getAvailableHeight(315);
    } else{
      $scope.tabHeight = $scope.getAvailableHeight(365) * 0.6;
      $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      $scope.detailLoading = true;

      AssignmentCUSrv.getFrameLayoutAssignmentDetails($scope.decId).then(
        function(data){
          $scope.detailLoading = false;
          $scope.frameLayout = data;
          $scope.fLCopy = angular.copy(data);

          if($scope.selectedTab === "hub.flContainer.flaThreshold" && !$scope.auth.upermissions.flat && !$scope.auth.upermissions.flar){
            $state.go("hub.frameLayouts.fla");
          }
          if($scope.selectedTab === "hub.flContainer.flaDevice" && (!$scope.frameLayout.info.hfr && $scope.frameLayout.info.sffl)){
            if($scope.auth.upreferences.isSplitV){
              $scope.selectedHeight = $scope.selectedHeight-75;
              $scope.tabHeight = $scope.tabHeight-75;
            } else{
              $scope.selectedHeight = $scope.selectedHeight-60;
              $scope.tabHeight = $scope.tabHeight-60;
            }
          } else if($scope.selectedTab === "hub.flContainer.flaDevice" && (!$scope.frameLayout.info.hfr || $scope.frameLayout.info.sffl)){
            if($scope.auth.upreferences.isSplitV){
              $scope.selectedHeight = $scope.selectedHeight-75;
              $scope.tabHeight = $scope.tabHeight-75;
            } else{
              $scope.selectedHeight = $scope.selectedHeight-35;
              $scope.tabHeight = $scope.tabHeight-35;
            }
          }

          if(!$scope.frameLayout.info.dateRange.startDate || !$scope.frameLayout.info.dateRange.endDate){
            $scope.frameLayout.info.dateRange = {startDate:moment()._d, endDate:moment().add(5, "year")._d}
          } else{
            $scope.frameLayout.info.dateRange = {
              startDate:$filter("momentDate")($scope.frameLayout.info.dateRange.startDate),
              endDate:$filter("momentDate")($scope.frameLayout.info.dateRange.endDate)
            }
          }
          $scope.dateRangeCopy = angular.copy($scope.frameLayout.info.dateRange);
          $scope.setDate();

          if($scope.frameLayout.devices.hiddenDeviceGroup == ""){
            $scope.hiddenDevices = false;
          } else{
            $scope.hiddenDevices = true;
          }

          $scope.tim = $scope.frameLayout.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = $scope.frameLayout.info.bucket;
          if($scope.frameLayout.info.mbucket && $scope.frameLayout.info.mbucket != ""){
            $scope.dDetailBucket = $scope.frameLayout.info.mbucket;
          }
          //?new
          if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
            if ($scope.frameLayout.folders) {
              $scope.folderList = $scope.frameLayout.folders;
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    } else{
      $scope.flId = $scope.hubDecrypt($state.params.fl);
      $scope.frameLayout = {info:{label:"", flId:$scope.flId, step:"info"}};
    }

    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceStatus = function(caller){
      setTimeout(function(){
        if($scope.pageDeviceArr.length){
          var currentTime = new Date().getTime();
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          angular.forEach($scope.pageDeviceArr, function(obj){
            if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
              obj.tz = currentTime;
              DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                function(data){
                  angular.forEach($scope.devices.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  });
                  if($scope.frameLayout.devices.device.length){
                    angular.forEach($scope.frameLayout.devices.device, function(sData){
                      angular.forEach(Object.keys(data),function(key){
                        var value = data[key];
                        if(key == sData.id){
                          sData.status = $filter('isDeviceOnline')(value, {minDeduct: $scope.auth.upreferences.dot});
                        }
                      })
                    })
                  }
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          })
        }
      },100)
      $scope.updateSelectedDevice();
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($scope.frameLayout.devices.device, function(data){
          if(data.id == obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.thumbV = obj.tv;
            }
            data.status = $filter('isDeviceOnline')(obj.lp, {minDeduct: $scope.auth.upreferences.dot});;
          }
        })
        outerLoopCounter++;
        if (outerLoopCounter === totalOuterLoops) {
            $scope.temSelectedArr = angular.copy($scope.frameLayout.devices.device);
            $scope.frameLayout.devices.device = [];
            $scope.frameLayout.devices.device = $scope.temSelectedArr;
        }
      })
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter || $scope.filter == ""){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:($scope.curFolderId>0)?$scope.curFolderId:0,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};

        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextFla.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = true;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    };

    $scope.selPageChangeHandler = function(){
      $('#pagingCtrlClone li').removeClass('active');
    };

    $scope.resetSelPagination = function(){
      var searchData = angular.copy($filter("customSearch")($scope.frameLayout.devices.device, {key:$scope.selectedSearch.text, module:'dSel'}));
      if(searchData.length>$scope.auth.upreferences.dpc){
        resetSelPageFx(1);
      }
    }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }
      DevicesSrv.getAssignableDevices(dReqObj).then(
        function(data){
          if(!$rootScope.addStatusKeyVal.value){
            $scope.deviceListLoading = false;
          }
          $scope.isPageApiLoad = false;
          $scope.moreDeviceLoading = false;
          $scope.devicesLoading = false;
          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);

          $scope.tim = data.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.dDetailBucket = data.info.mbucket;
          }
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }

          // get device of types
          if(caller=='openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller=='dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else {
              $scope.dData = angular.copy(data);
            }

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.filter = "all";
            } else{
              $scope.filter = $scope.filterType;
            }

            $scope.devices = angular.copy($scope.dData);
            $scope.folderList = $scope.devices.folders;
            $scope.loadingMain = false;
          }

          $scope.updateList();
          $scope.setCountFx();
          // if($scope.selectedTab === "hub.flContainer.flaDevice" && ($scope.frameLayout.info && (!$scope.frameLayout.info.hfr || $scope.frameLayout.info.sffl))){
          //   angular.forEach($scope.devices.devices, function(item){
          //     item.isSelected = 1;
          //   });
          //   angular.forEach($scope.devices.devices, function(item){
          //     angular.forEach($scope.frameLayout.devices.device, function(device){
          //       if(item.id == device.id){
          //         item.isSelected = 0;
          //       }
          //     });
          //   });
          // }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.deviceListLoading = true;
      $scope.searchTextFla.text = "";
      $scope.search.text = "";
      $scope.searchText = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      //Adv search implemented
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextFla.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else {
        $scope.advSApply = false;
        $scope.devicesLoading = true;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.deviceListLoading = true;
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
        // $scope.firstApply.filter = true;
      } else{
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.deviceListLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextFla.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.searchTextFla.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      // $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    // $scope.setCountFx = function(caller){
    //   // $scope.deviceListLoading = false;
    //   $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
    //   if(caller=='last'){
    //     $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
    //   } else{
    //     $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
    //   }


    //   // if($scope.filter && $scope.filter != "all" && !$scope.devices.devices.length && $scope.dData.devices.length){
    //   if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isFilterMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     // if($scope.filter && $scope.filter != "all" && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //     if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isFilterMsg = true;
    //     }else{
    //       $scope.isFilterMsg = false;
    //     }
    //   }
    //   if($scope.searchTextFla.text && $scope.searchTextFla.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isSearchMsg = true;
    //     $scope.isFilterMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     if($scope.searchTextFla.text && $scope.searchTextFla.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isSearchMsg = true;
    //     } else {
    //       $scope.isSearchMsg = false;
    //     }
    //   }

    //   if(!$scope.searchTextFla.text && $scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
    //     $scope.isAdvSearchMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isFilterMsg = false;
    //   } else {
    //     if($scope.searchTextFla.text && $scope.searchTextFla.text.length && $scope.dData.advObj && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //       $scope.isSearchMsg = true;
    //       $scope.isAdvSearchMsg = false;
    //       $scope.isFilterMsg = false;
    //     } else {
    //       $scope.isAdvSearchMsg = false;
    //     }
    //   }
    // }
    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller=='last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
      } else{
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
      }

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
      // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        // console.log($rootScope.isObjectEmpty($scope.dData), ($rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length), !$scope.devices.devices.length, !$scope.advSApply);
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchTextFla.text && $scope.searchTextFla.text.length && !$scope.devices.devices.length){
      // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
      // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.searchTextFla.text && $scope.searchTextFla.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchTextFla.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }

    $scope.loadDevicesFx = function(caller){
      if($scope.selectedTab === "hub.flContainer.flaDevice"){
        $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
        if($scope.filterType && ($scope.filterType === "online" || $scope.filterType === "offline")){
          $scope.filter = $scope.filterType;
        } else{
          $scope.filter = "all";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.filter));

        $scope.deviceConflictMsg = $filter("translate")('fl.p_assign.msg.4');
        $scope.deviceListLoading = true;
        $rootScope.addStatusKeyVal.value = true;
        $scope.folderList = [];

        $scope.curFolderId = 0;

        $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false, caller);
      }
    }
    $scope.loadDevicesFx();

    $rootScope.selectedTabFx = function(){
      $scope.searchChangeFx();
      $scope.advSearchInfo = {};
      if($rootScope.selectedT == 1){
        $scope.devices.devices = $scope.flDeviceList.devices;
        $scope.deviceConflictMsg = $filter("translate")('fl.p_assign.msg.4');
      } else if($rootScope.selectedT == 2){
        $scope.devices.devices = $scope.flDeviceList.groups;
        $scope.deviceConflictMsg = $filter("translate")('fl.p_assign.msg.6');
        $scope.deviceConflictMsg1 = $filter("translate")('s.p_s.msg.33');
      } else if($rootScope.selectedT == 3){
        $scope.devices.devices = $scope.flDeviceList.tags;
        $scope.deviceConflictMsg = $filter("translate")('s.p_s.msg.25');
      }
    }

    $scope.setDate = function() {
      $scope.curSD = moment($scope.frameLayout.info.dateRange.startDate).format('MM/DD/YYYY');
      $scope.curED = moment($scope.frameLayout.info.dateRange.endDate).format('MM/DD/YYYY');

      // Set the start and end dates to the scope variables
      $scope.startDate = $scope.curSD;
      $scope.endDate = $scope.curED;

      // Use $timeout to delay the initialization of daterangepicker
      $timeout(function() {
        // Initialize the Date Range Picker with current start and end dates
        $("input[name='datetimes']").daterangepicker({
          startDate: $scope.curSD,
          endDate: $scope.curED,
        }, function(start, end, label) {
          // Update the scope variables with selected dates
          $scope.$apply(function() {
            // $scope.startDate = start.format("MM/DD/YYYY");
            // $scope.endDate = end.format("MM/DD/YYYY");

            // Update the date range in the schedule object
            $scope.frameLayout.info.dateRange = {
                startDate: start,
                endDate: end
            };
          });
        });
      });
    }

    $scope.briefFx = function(deviceId){
      $scope.selectedSearch.text = "";
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "device"){
          $scope.isDuplicate = false;
          angular.forEach($scope.frameLayout.devices.device, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          angular.forEach($scope.devices.devices, function(listItem){
            if(listItem.id == item.id && ((listItem.isConflict == 1 || listItem.isConflict == 2) || (!$scope.frameLayout.info.hfr && listItem.isSelected) || ($scope.frameLayout.info.sffl && listItem.isSelected))){
              $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.devices.devices.filter(function(obj){
              return obj.id == item.id;
            })[0];
            if($scope.auth.upreferences.deviceView == 'l'){
              $scope.curItem.tv = $scope.curItem.id;
            }
            $scope.frameLayout.devices.device.push({id:item.id, label:$scope.curItem.l, thumbV:$scope.curItem.tv, mac:$scope.curItem.h, dType:$scope.curItem.t, status:$filter('isDeviceOnline')($scope.curItem.lp, {minDeduct: $scope.auth.upreferences.dot})});
          }
        } else if(item.type == "tag"){
          $scope.isDuplicate = false;
          angular.forEach($scope.frameLayout.devices.tag, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          angular.forEach($scope.devices.devices, function(listItem){
            if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
              $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.devices.devices.filter(function(obj){return obj.id == item.id;})[0];
            $scope.frameLayout.devices.tag.push({id:item.id, label:$scope.curItem.label});
          }
        }
      });
      $rootScope.selectedItems = [];
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on('advSearchfilteredData', function(event, args){
      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchTextFla.text = "";
        $scope.search.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchTextFla.text = "";
        $scope.search.text = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }

      $scope.advSearchInfo = args.info;
      $scope.isAdvSearchActive = false;
      $scope.folderList = [];
      $scope.breadCrumbs = [];
      //manage height with advance search
      if($scope.advSearchInfo.os != null || ($scope.advSearchInfo.hasOwnProperty("client") && $scope.advSearchInfo.client != null) || ($scope.advSearchInfo.hasOwnProperty("dName") && $scope.advSearchInfo.dName != null) || ($scope.advSearchInfo.hasOwnProperty("createdBy") && $scope.advSearchInfo.createdBy != null) || ($scope.advSearchInfo.hasOwnProperty("sName") && $scope.advSearchInfo.sName != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || $scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length || $scope.advSearchInfo.userGroup.include.length || $scope.advSearchInfo.userGroup.exclude.length || ($scope.advSearchInfo.hasOwnProperty("fil") && $scope.advSearchInfo.fil != "" && $scope.advSearchInfo.fil != "all") || $scope.advSearchInfo.prop != null){
        if($scope.auth.upreferences.isSplitV){
          $scope.tabHeight = $scope.getAvailableHeight(382);
          $scope.selectedHeight = $scope.getAvailableHeight(382);
        } else {
          $scope.tabHeight = $scope.getAvailableHeight(433) * 0.5;
          $scope.selectedHeight = $scope.getAvailableHeight(433) * 0.5;
        }
      } else if($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length && !$scope.advSearchInfo.userGroup.include.length && !$scope.advSearchInfo.userGroup.exclude.length && ($scope.advSearchInfo.fil == "all" || !$scope.advSearchInfo.fil) && $scope.advSearchInfo.prop == null){
        if($scope.auth.upreferences.isSplitV){
          $scope.tabHeight = $scope.getAvailableHeight(315);
          $scope.selectedHeight = $scope.getAvailableHeight(315);
        } else {
          $scope.tabHeight = $scope.getAvailableHeight(365) * 0.6;
          $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
        }
      }
      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.searchTextFla.text && $scope.searchTextFla.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            localStorage.setItem("sData", JSON.stringify($scope.sData));
            $scope.devices = angular.copy($scope.sData);
            $scope.setCountFx();
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            localStorage.setItem("asData", JSON.stringify($scope.asData));
            $scope.devices = angular.copy($scope.asData);
            $scope.statusObj.as = true;
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};

          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          if(args.dInfo && args.dInfo.allIds){
            $scope.devices.info.allIds = args.dInfo.allIds;
          }
        }

        $scope.isAdvSearch = true;
      }
      $scope.devices.folders = args.folders;

      if(!$scope.frameLayout.info.hfr || $scope.frameLayout.info.sffl){
        angular.forEach($scope.devices.devices, function(item){
          item.isSelected = 1;
        });
        angular.forEach($scope.devices.devices, function(item){
          angular.forEach($scope.fLCopy.devices.device, function(device){
            if(item.id == device.id){
              item.isSelected = 0;
            }
          });
        });
      }
      $scope.setCountFx();
      $scope.filterType = $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
      }
      // console.warn(args);
      if(args.code == 8118){
        $scope.searchTextFla.text = "";
        $scope.search.text = "";
        $scope.curFolderId = 0;
        localStorage.removeItem("curDFId");
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.advSApply = false;
        $scope.deviceConflictMsg = $filter("translate")('fl.p_assign.msg.4');
        $scope.deviceListLoading = true;
        $scope.advSearchInfo = {};
        $scope.folderList = [];
        $rootScope.commonSearchVar = "";

        $scope.filter = JSON.parse(localStorage.getItem("filterType"));

        $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    });

    // var searchTimeout;
    $scope.searchChangeFx = function(text){
      $rootScope.commonSearchVar = text;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if(!text){
        $scope.clearSearchFx();
        return;
      }else{
        $scope.search.text = text;
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        if(text){
          $scope.deviceListLoading = true;
          $rootScope.clearSearch = false;
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          //Adv search implemented
          $scope.paginationControls.currPage = 1;
          $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
          if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
            $scope.curAdvSearchObj = $scope.advSearchInfo;
            if($scope.filter != "all"){
              $scope.curAdvSearchObj.fil = $scope.filter;
            }
            $scope.curAdvSearchObj.offset = 0;
            CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextFla.text).then(
              function(data){
                $scope.deviceListLoading = false;
                $scope.filteredData = data;
                $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                $scope.curAdvSearchObj.isLoadMore = false;
                if(data.info.rdc || data.info.rdc == 0){
                  $scope.curAdvSearchObj.rdc = data.info.rdc;
                }
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else{
            $rootScope.offset = 0;
            $scope.deviceListLoading = true;
            $scope.filter = JSON.parse(localStorage.getItem("filterType"));
            $scope.dReqObj = {caller:'d',id:$scope.hubDecrypt($state.params.id),type:"f",offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
            $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
          }
        }
      }
    }

    $scope.saveAssignmentFx = function(caller, action){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.frameLayoutCopy = angular.copy($scope.frameLayout);

      if(caller == "name"){
        if($scope.frameLayoutCopy.info.label == ""){
          $scope.hasErr = true;
          $("#label").focus();
          return;
        }
        $scope.frameLayoutCopy.info.step = "info";
      } else if(caller == "schedule"){
        if($scope.frameLayoutCopy.info.dateRange == ""){
          $scope.hasErr = true;
          $("#dateRange").focus();
          return;
        }
        $scope.frameLayoutCopy.info.step = "date";
        $scope.curDate = angular.element(document).find(".picker").val();
        $scope.curDate = $scope.curDate.split(" - ");
        $scope.frameLayoutCopy.info.dateRange = {startDate:$scope.curDate[0], endDate:$scope.curDate[1]};
      } else if(caller == "device"){
        if($scope.frameLayoutCopy.devices.device.length == 0 && !$scope.hiddenDevices){
          // Only devices
          $scope.hasErr = true;
          $scope.errType = "dEmpty";
          return;
        } else{
          if($scope.frameLayout.info.syncFrame){
            $scope.hasNoMasterIp = false;
            $scope.hasMaster = $scope.frameLayoutCopy.devices.device.filter(function(obj){return obj.id == $scope.frameLayout.info.masterDeviceId}).length > 0;
            if($scope.hasMaster){
              angular.forEach($scope.frameLayoutCopy.devices.device, function(item, $index){
                if(item.id == $scope.frameLayout.info.masterDeviceId){
                  if($scope.frameLayout.info.masterDeviceIP == undefined || $scope.frameLayout.info.masterDeviceIP == ''){
                    $("#IP-"+$index).focus();
                    $scope.hasNoMasterIp = true;
                  }
                }
              });
            }
          }
          if($scope.frameLayout.info.syncFrame && !$scope.hasMaster){
            $scope.errType = "deviceMaster";
            $scope.hasErr = true;
            return;
          }else if($scope.hasNoMasterIp){
            $scope.errType = "deviceIPEmpty";
            $scope.hasErr = true;
            return;
          }
        }
        $scope.frameLayoutCopy.info.step = "device";
      } else if(caller == "threshold"){
        $scope.frameLayoutCopy.info.step = "restriction";
      }

      if(action == undefined){
        $scope.flaProcessing = true;
        $scope.frameLayoutCopy.info.toast = false;
      } else{
        $scope.saveCloseProcessing = true;
        $scope.frameLayoutCopy.info.toast = true;
      }
      AssignmentCUSrv.saveFrameLayoutAssignment($scope.frameLayoutCopy).then(
        function(data){
          $scope.flaProcessing = false;
          $scope.saveCloseProcessing = false;
          if(data.code == 11030){
            $scope.hasErr = true;
            $scope.errType = "slot";
            return;
          }
          if(action == undefined){
            if(caller == "name"){
              if($state.current.name == "hub.flContainer.flaName"){
              $state.go("hub.flContainer.flaSchedule", {id:$scope.hubEncrypt(data.assignmentId)});
              }
            } else if(caller == "schedule"){
              if($state.current.name == "hub.flContainer.flaSchedule"){
              $state.go("hub.flContainer.flaDevice", {id:$scope.hubEncrypt(data.assignmentId)});
              }
            } else if(caller == "device"){
              if($state.current.name == "hub.flContainer.flaDevice"){
              $state.go("hub.flContainer.flaThreshold", {id:$scope.hubEncrypt(data.assignmentId)});
              }
            } else if(caller == "threshold"){
              $state.go("hub.frameLayouts.fla", {id:$scope.hubEncrypt(data.assignmentId)});
            }
          } else{
            if($state.current.name == "hub.flContainer.flaDevice" || $state.current.name == "hub.flContainer.flaThreshold" || $state.current.name == "hub.flContainer.flaSchedule" || $state.current.name == "hub.flContainer.flaName"){
              $state.go("hub.frameLayouts.fla");
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.flaProcessing = false;
          $scope.saveCloseProcessing = false;
        }
      );
    }

    // $scope.foreverFx = function(){
    //   $scope.curDate = angular.element(document).find(".picker").val();
    //   $scope.curDate = $scope.curDate.split(" - ");
    //   $scope.curDateS = $scope.curDate[0].split("/");
    //   if($scope.frameLayout.info.forever){
    //     $scope.curDateE = angular.copy($scope.curDate[1].split("/"));
    //     $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0], $scope.curDateS[1]]).add(100, "year")._d};
    //   } else{
    //     $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]])};
    //   }
    // }
    $scope.foreverFx = function(){
      $scope.curDate = angular.element(document).find(".picker").val();
      $scope.curDate = $scope.curDate.split(" - ");
      $scope.curDateCheck = new Date(moment().format('MM/DD/YYYY'));
      $scope.currentDate = moment().format('MM/DD/YYYY').split("/");
      $scope.curDateS = $scope.curDate[0].split("/");

      if($scope.frameLayout.info.forever){
        $scope.curDateE = angular.copy($scope.curDate[1].split("/"));
        // below code comment bcz we need to show forever from selected date
        $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0], $scope.curDateS[1]]).add(100, "year")._d};
      } else{
        $scope.frameLayout.info.dateRange = {startDate:$scope.dateRangeCopy.startDate, endDate:moment([$scope.curDateS[2], $scope.curDateS[1], $scope.curDateS[0]]).add(1, "year")._d};

        $scope.selStartDate = new Date(moment($scope.curDateS.join('-'), 'MM-DD-YYYY').format('MM/DD/YYYY'));
        if($scope.curDateE){
          $scope.selEndDate = new Date(moment($scope.curDateE.join('-'), 'MM-DD-YYYY').format('MM/DD/YYYY'));
        }
        $scope.curDate = new Date(moment().format('MM/DD/YYYY'));
        $scope.curDateC = moment().format('MM/DD/YYYY').split("/");

        if($scope.selEndDate){
          if ($scope.selEndDate.getTime() === $scope.curDate.getTime()) {
          } else if ($scope.selEndDate > $scope.curDate) {
            if($scope.auth.upreferences.sddr == "m"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "month")._d};
            } else if($scope.auth.upreferences.sddr == "w"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "week")._d};
            } else{
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateE[2], $scope.curDateE[0] - 1, $scope.curDateE[1]]).add(1, "year")._d};
            }
          } else {
            if($scope.auth.upreferences.sddr == "m"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "month")._d};
            } else if($scope.auth.upreferences.sddr == "w"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "week")._d};
            } else{
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "year")._d};
            }
          }
        } else {
          if ($scope.selStartDate > $scope.curDate) {
            if($scope.auth.upreferences.sddr == "m"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "month")._d};
            } else if($scope.auth.upreferences.sddr == "w"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "week")._d};
            } else{
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]).add(1, "year")._d};
            }
          } else {
            if($scope.auth.upreferences.sddr == "m"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "month")._d};
            } else if($scope.auth.upreferences.sddr == "w"){
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "week")._d};
            } else{
              $scope.frameLayout.info.dateRange = {startDate:moment([$scope.curDateS[2], $scope.curDateS[0] - 1, $scope.curDateS[1]]), endDate:moment([$scope.curDateC[2], $scope.curDateC[0] - 1, $scope.curDateC[1]]).add(1, "year")._d};
            }
          }
        }
        $scope.setDate();
      }
    }
    $scope.removeFilteredFx = function(id, type){
      if(id == "all"){
        $scope.frameLayout.devices.device = [];
        $scope.frameLayout.devices.group = [];
        $scope.frameLayout.devices.tag = [];
      } else{
        if(type == "d"){
          angular.forEach($scope.frameLayout.devices.device, function(item){
            if(id == item.id){
              $scope.frameLayout.devices.device.splice($scope.frameLayout.devices.device.indexOf(item), 1);
              return false;
            }
          });
          angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
            if($(item).attr('data-id') == id){
              $(item).removeClass('ui-selected');
              $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
            }
          });
        } else if(type == "t"){
          angular.forEach($scope.frameLayout.devices.tag, function(item){
            if(id == item.id){
              $scope.frameLayout.devices.tag.splice($scope.frameLayout.devices.tag.indexOf(item), 1);
              return false;
            }
          });
          angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
            if($(item).attr('data-id') == id){
              $(item).removeClass('ui-selected');
              $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
            }
          });
        }
        $rootScope.selectedItems = [];
      }
    }

    $rootScope.selectRestrictedFolder = function(frameIndex){
      $scope.selectedFolder = $("input[name='treeOpt']:checked");
      $scope.frameLayout.restriction.frame[frameIndex].folder = parseInt($scope.selectedFolder.val());
      $scope.frameLayout.restriction.frame[frameIndex].folderLabel = $scope.selectedFolder.attr("data-label");
      ngDialog.close();
    }

    $rootScope.selectRestrictedGroups = function(frameIndex, groups){
      $scope.frameLayout.restriction.frame[frameIndex].groups = groups;
      ngDialog.close();
    }

    $rootScope.closeGroupPopup = function(frameIndex){
      $scope.frameLayout.restriction.frame[frameIndex].groups = $scope.tempGroups;
      ngDialog.close();
    }

    $scope.openPopupFx = function(type, frameId, folderId){
      if(type == "f"){
        $scope.dataObj = {frame:frameId, folder:folderId};
        ngDialog.open({
          template:'app/frameLayouts/popup/selectFolder.html',
          width:500,
          data:$scope.dataObj,
          controller:'SelectFolderController',
          closeByDocument:false,
          appendClassName:"ng-dialog-padT50"
        });
      } else if(type == "g"){
        $scope.tempGroups = angular.copy($scope.frameLayout.restriction.frame[frameId].groups);
        $scope.dataObj = {
          frame:frameId,
          groups:$scope.frameLayout.restriction.frame[frameId].groups,
          isSplitV:$scope.auth.upreferences.isSplitV,
          thumbParam:$scope.thumbParam,
          thumbBigParam:$scope.thumbBigParam,
          tabHeight:$scope.tabHeight,
          selectedHeight:$scope.selectedHeight
        };
        ngDialog.open({
          template:'app/frameLayouts/popup/selectGroups.html',
          width:1150,
          data:$scope.dataObj,
          scope:$scope,
          controller:'SelectGroupsController',
          closeByDocument:false,
          appendClassName:"ng-dialog-padT50"
        });
      }
    }

    /*For Mail to Support*/
    $scope.mailSupportOpen = function(){
      $scope.savePopProcessing = false;
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
      ngDialog.open({
        template:"app/support/popup/mailToSupport.html",
        scope:$scope,
        closeByDocument:false,
        width:500
      });
    }

    $scope.saveMailSupportFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";

      if(!$scope.mail.subject || $scope.mail.subject == ""){
        $scope.errPopType = "subject";
        $scope.hasPopErr = true;
      } else if(!$scope.mail.message || $scope.mail.message == ""){
        $scope.errPopType = "message";
        $scope.hasPopErr = true;
      } else{
        $scope.savePopProcessing = true;
        SupportSrv.saveMailSupport($scope.mail).then(
          function(data){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $rootScope.deleteCallback = function(){}

    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.folderContentFx = function (fId, splId, splType, caller) {
      $scope.apiCalledArr = [];
      // ?New: this "if" code is for device folder
      $scope.paginationControls.currPage = 1;

      $scope.deviceListLoading = true;
      if(!caller || caller != "changeView"){
        $scope.searchTextFla.text = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.search = { text: "" };
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curDFId");
      $scope.advSearch = false;
      $scope.curFolderId = 0;

      if (fId == 0) {
        $scope.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curDFId", fId);
        $scope.curFolderId = localStorage.getItem("curDFId");
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.setItem("curDFId", 0);
        localStorage.removeItem("curPathFId");
      }

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType != "all"){
        $scope.filterIsAppliedAlready = true;
      }
      $scope.flObj = {id:$scope.hubDecrypt($state.params.id), type:'f'};
      $scope.folObj = {fId:fId, offset:0, obj:$scope.flObj, caller:null,filType:$scope.filterType,text:$scope.searchTextFla.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};
      // DevicesSrv.getFolderData(fId, null, $scope.flObj, null, $scope.filterType, $scope.searchTextFla.text).then(
      DevicesSrv.getFolderData($scope.folObj).then(
        function (data) {
          $scope.flId = fId;
          $scope.deviceListLoading = false;
          $scope.flDeviceList = angular.copy(data);
          $scope.devices = angular.copy(data);
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.dData = angular.copy($scope.devices)
          $scope.brief = data;
          $scope.setCountFx();
          $scope.updateList();

          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function (err) {
          $scope.deviceListLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.updateList = function(){
      $scope.breadCrumbs = [];
      if(!$rootScope.addStatusKeyVal.value){
        $scope.deviceListLoading = false;
      }

      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df'){
        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchTextFla.text){
          $scope.folderList = $scope.dData.folders;
        }
        if ($scope.devices.info && $scope.devices.info.breadCrumbs) {
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
      }
      if($scope.searchTextFla.text && $scope.searchTextFla.text.length){
        $scope.folderList = [];
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.devices.types){
        if(!$scope.filterType || $scope.filterType=="all"){
          $scope.filterType = "";
          $scope.filter = "all";
        }
      }
    }
    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/}

    $scope.$on('$destroy', function() {
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
      $scope.advSearchInfo = {};
    });

    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.deviceListLoading = true;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      $rootScope.offset = 0;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if($scope.selectedTab == "hub.flContainer.flaDevice"){
        var fId = localStorage.getItem("curDFId");
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj.offset = 0;
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextFla.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = false;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.sortType = data.info.sortType;
              $scope.curAdvSearchObj.sortVal = data.info.sortVal;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          if(fId > 0){
            $scope.folderContentFx(fId,null,null,"changeView");
          } else {
            $scope.loadDevicesFx("changeView");
          }
        }
      }
      // deregister();
    });

    $scope.apiCalledArr = [];

    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData) {
      // Deep compare the new data with the current data
      if (!angular.equals($scope.currentPageDevice, newData.curData)) {
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if (!angular.equals($scope.allPageDevice, newData.allData.length)) {
        $scope.allPageDevice = angular.copy(newData.allData.length);
      }
    }

    // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data) {
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function() {
      return $scope.currentPageDevice.map(function(obj) {
          return obj.id;
      }).join(',');
    };

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.currentPageDevice = newVal
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for (var i = 1; i <= allPagesCount; i++) {
              $scope.pageDeviceArr.push({pNo:i, tz:new Date().getTime()})
            }
          }else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for (var i = 1; i <= allPagesCount - start; i++) {
              $scope.pageDeviceArr.push({pNo:start +i, tz:new Date().getTime()})
            }
          }
        }
      }
    }, true); // 'true' for deep watch
  }
})();
angular.module('hub').service('CreativeServicesSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getCurrent = function(){
    httpReq = $http.get($rootScope.apiHost + "creative/current");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCompleted = function(){
    httpReq = $http.get($rootScope.apiHost + "creative/completed");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInvoiceList = function(){
    httpReq = $http.get($rootScope.apiHost + "creative/invoices");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPaymentUrl = function(id, encId){
    httpReq = $http.get($rootScope.apiHost + "creative/paymentUrl/" + id + "/" + encId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.paymentFx = function(obj){
    httpReq = $http.post($rootScope.apiHost + "creative/payment", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.paymentCanel = function(encId, dataId){///paymentCancel/:encId/:dataId
    httpReq = $http.get($rootScope.apiHost + "creative/paymentCancel/"+ encId + "/" + dataId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "creative/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCSTimeline = function(id){
    httpReq = $http.get($rootScope.apiHost + "creative/timeline/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAttachments = function(id){
    httpReq = $http.get($rootScope.apiHost + "creative/attachments/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getOrderInvoice = function(id){
    httpReq = $http.get($rootScope.apiHost + "creative/invoicedetail/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateCSEstimate = function(obj){
    httpReq = $http.post($rootScope.apiHost + "creative/status", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.approveCreative = function(id){
    httpReq = $http.post($rootScope.apiHost + "creative/approve", {"id": id});
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteCreative = function(id){
    httpReq = $http.delete($rootScope.apiHost + "creative/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    } else{
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CSPaymentController', CSPaymentController);

  /** @ngInject */
  function CSPaymentController($log, $rootScope, $scope, $state, $location, $timeout, $window, CreativeServicesSrv){
    $rootScope.selectedMenu = 9;

    $scope.selectedTab = $state.current.name;
    $scope.paymentProcessing = true;
    $scope.hasErr = false;
    $scope.decId = "";
    $scope.encId = "";
    $scope.paypalData;

    if($state.params.id){
      $scope.encId = $state.params.id;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.paypalData = $location.search();

      if($scope.paypalData.paymentId && $scope.paypalData.PayerID){
        CreativeServicesSrv.paymentFx($scope.paypalData).then(
          function(data){
            $scope.paymentProcessing = false;
            if(data.code == 15016){
              $scope.hasErr = false;
              $timeout(function(){
                $state.go("hub.cContainer.cs.iTab", {
                  id:$scope.encId
                });
                $state.reload();
              }, 4000);
            } else{
              $scope.hasErr = true;
              $timeout(function(){
                $state.go("hub.cContainer.cs.iTab", {
                  id:$scope.encId
                });
                $state.reload();
              }, 4000);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.paymentProcessing = false;
        $scope.hasErr = true;
        CreativeServicesSrv.paymentCanel($scope.encId, $scope.paypalData.dataId).then(
          function(data){
            $timeout(function(){
              $state.go("hub.cContainer.cs.iTab", {
                id:$scope.encId
              });
              $window.location.reload();
            }, 4000);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CSDetailsController', CSDetailsController);

  /** @ngInject */
  function CSDetailsController($log, $rootScope, $scope, $state, ngDialog, $timeout, $ocLazyLoad, CreativeServicesSrv, FileModelUploadSrv){
    $ocLazyLoad.load('//www.paypalobjects.com/api/checkout.min.js');
    $rootScope.csPromise;
    $rootScope.selectedMenu = 9;
    $scope.contactRegExp = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;

    $scope.selectedTab = $state.current.name;
    $scope.cancelStatus = [1, 2, 4, 10];
    $scope.csComment = {comment:""};
    $scope.commentProcessing = false;
    $scope.paypalBtnLoading = false;
    $scope.saveProcessing = false;
    $scope.detailsLoading = true;
    $scope.showDetails = false;
    $scope.csAttachments = [];
    $scope.isEditable = false;
    $scope.timelineLoading;
    $scope.csDetails = [];
    $scope.csInvoice = [];
    $scope.timeline = [];
    $scope.decId = "";
    $scope.encId = "";

    $scope.loadSelectedTab = function(){
      if($state.params.id){
        $scope.decId = $scope.hubDecrypt($state.params.id);
        $scope.encId = $state.params.id;
        if($scope.selectedTab == "hub.cContainer.cs.odTab"){
          $scope.detailsLoading = true;
          $scope.timelineLoading = null;
          CreativeServicesSrv.getCSDetails($scope.decId).then(
            function(data){
              if(data.code == 4004){
                $state.go("hub.creativeServices.cur");
                return;
              }
              $scope.csDetails = data;
              $scope.detailsLoading = false;
              $scope.timelineLoading = true;
              $scope.curTitle = angular.copy($scope.csDetails.title);
              $scope.curDescr = angular.copy($scope.csDetails.description);
              $scope.curContact = angular.copy($scope.csDetails.contact);

              $scope.csBucket = $scope.detailBucket = $scope.csDetails.info.csBucket;
              if($scope.csDetails.info.mbucket && $scope.csDetails.info.mbucket != ""){
                $scope.detailBucket = $scope.csDetails.info.mbucket;
              }

              if($rootScope.csPromise){
                $timeout.cancel($rootScope.csPromise);
              }
              CreativeServicesSrv.getCSTimeline($scope.decId).then(
                function(data){
                  $scope.timelineLoading = false;
                  $scope.timeline = data;
                  $rootScope.csPromise = $timeout(loadTimeline, 20000);
                },
                function(err){
                  $log.error(err);
                }
              );
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.selectedTab == "hub.cContainer.cs.aTab"){
          $scope.detailsLoading = true;
          CreativeServicesSrv.getAttachments($scope.decId).then(
            function(data){
              if(data.code == 4004){
                $state.go("hub.creativeServices.cur");
                return;
              }
              $scope.csAttachments = data;
              $scope.bucket = $scope.detailBucket = $scope.csAttachments.info.bucket;
              if($scope.csAttachments.info.mbucket && $scope.csAttachments.info.mbucket != ""){
                $scope.detailBucket = $scope.csAttachments.info.mbucket;
              }
              $scope.detailsLoading = false;
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.selectedTab == "hub.cContainer.cs.iTab"){
          $scope.detailsLoading = true;
          $scope.csInvoice = [];
          CreativeServicesSrv.getOrderInvoice($scope.decId).then(
            function(data){
              if(data.code == 4004){
                $state.go("hub.creativeServices.cur");
                return;
              }
              $scope.csInvoice = data;
              $scope.detailsLoading = false;
              if(!$scope.csInvoice.status){
                $scope.paypalBtnLoading = true;
                CreativeServicesSrv.getPaymentUrl($scope.decId, $scope.encId).then(
                  function(data){
                    $timeout(function(){
                      paypal.checkout.setup('6Z7FYTNUVALP4',{
                      	container:'paymentBtn', //{String|HTMLElement|Array} where you want the PayPal button to reside
                      	environment:'sandbox', //or 'production' depending on your environment
                      	click:function(){
                          paypal.checkout.startFlow(data.url);
                      	}
                      });
                      $scope.paypalBtnLoading = false;
                    }, 500);
                  },
                  function(err){
                    $log.error(err);
                  }
                );
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }
    $scope.loadSelectedTab();
    var loadTimeline = function(){
      CreativeServicesSrv.getCSTimeline($scope.decId).then(
        function(data){
          $scope.timeline = [];
          $scope.timeline = data;
          $scope.csDetails.approvedBy = $scope.timeline.info.approvedBy;
          $scope.csDetails.approvedOn = $scope.timeline.info.approvedOn;
          $scope.csDetails.fileCount = $scope.timeline.info.fileCount;
          $scope.csDetails.status = $scope.timeline.info.status;
          $scope.csDetails.hours = $scope.timeline.info.hours;
          $scope.csDetails.cost = $scope.timeline.info.cost;
          $scope.csDetails.rate = $scope.timeline.info.rate;
          $rootScope.csPromise = $timeout(loadTimeline, 20000);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
    });

    $scope.saveCreativeFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.csDetails.title == ""){
        $scope.errType = "title";
        $scope.hasErr = true;
        $("title").focus();
      } else if($scope.csDetails.description == ""){
        $scope.errType = "desc";
        $scope.hasErr = true;
        $("desc").focus();
      } else if($scope.csDetails.contact == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("contact").focus();
      } else if(!$scope.contactRegExp.test($scope.csDetails.contact) || $scope.csDetails.contact.length < 10){
        $scope.errType = "contactValid";
        $scope.hasErr = true;
        $("contactValid").focus();
      } else{
        $scope.saveProcessing = true;
        FileModelUploadSrv.uploadFileAndData("creative", $scope.csDetails, $scope.curFile).then(
          function(data){
            if(data.code == 4004){
              $state.go("hub.creativeServices.cur");
              return;
            }
            $rootScope.toastNotificationFx("info", data);
            $scope.saveProcessing = false;
            $scope.loadSelectedTab();
          },
          function(err){
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.resetFx = function(){
      $scope.isEditable = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.csDetails.title = angular.copy($scope.curTitle);
      $scope.csDetails.description = angular.copy($scope.curDescr);
      $scope.csDetails.contact = angular.copy($scope.curContact);
    }
    $scope.editFx = function(){
      $scope.isEditable = true;
    }

    $scope.csStatusOpen = function(status){
      $scope.curStatus = {id:$scope.decId, status:status};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="curStatus.status == 3" class="estimateText" translate="{{\'cs.msg.9\'}}" translate-values="{rate:\'<b>${{csDetails.cost}}</b>\'}"></span>\
              <span ng-if="curStatus.status == 4">{{"cs.msg.10" | translate}}</span>\
              <span ng-if="curStatus.status == 5">{{"cs.msg.12" | translate}}</span>\
              <span ng-if="curStatus.status == 6">{{"cs.msg.11" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm" ng-class="(curStatus.status == 3 || curStatus.status == 5)?\'btn-success\':\'btn-danger\'" ng-click="csStatusFx();" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
      });
    }
    $scope.csStatusFx = function(){
      CreativeServicesSrv.updateCSEstimate($scope.curStatus).then(
        function(data){
          $scope.csDetails = data;
          $scope.detailsLoading = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.csCommentFx = function(){
      $scope.commentErr = false;
      $scope.csComment.id = $scope.decId;
      if($scope.csComment.comment == ""){
        $scope.commentErr = true;
      } else{
        $scope.commentProcessing = true;
        FileModelUploadSrv.uploadFileAndData("creative/comments", $scope.csComment, $scope.csComment.curFile).then(
          function(data){
            if(data.code == 4004){
              $state.go("hub.creativeServices.cur");
              return;
            }
            $rootScope.toastNotificationFx("info", data);
            $scope.timeline.comments.unshift(data.comment);
            if(data.comment && data.comment.attachment){
              $scope.csDetails.fileCount = $scope.csDetails.fileCount + 1;
            }
            $scope.commentProcessing = false;
            $scope.csComment = {comment:"", curFile:null};
            $scope.csAttachments = [];
          },
          function(err){
            $log.error(err);
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.commentProcessing = false;
          }
        );
      }
    }

    $rootScope.fileModelUploadFx = function(data){
      $scope.attachProcessing = true;
      $scope.csId = {id:$scope.decId};
      FileModelUploadSrv.uploadFileAndData("creative/attachments", $scope.csId, data).then(
        function(data){
          if(data.code == 4004){
            $state.go("hub.creativeServices.cur");
            return;
          }
          $rootScope.toastNotificationFx("info", data);
          $scope.attachProcessing = false;
          $scope.loadSelectedTab();
        },
        function(err){
          $rootScope.toastNotificationFx("danger", {"code":5000});
          $scope.attachProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.printFx = function(){
      window.print();
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CSAddController', CSAddController);

  /** @ngInject */
  function CSAddController($log, $rootScope, $scope, $state, CreativeServicesSrv, FileModelUploadSrv){
    $rootScope.selectedMenu = 9;
    $scope.contactRegExp = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    $scope.selectedTab = $state.current.name;
    $scope.saveProcessing = false;
    $scope.csAdd = {type:"c", title:"", description:"", contact:$scope.auth.cn};
    $scope.saveCreativeFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.csAdd.title == ""){
        $scope.errType = "title";
        $scope.hasErr = true;
        $("#title").focus();
      } else if($scope.csAdd.description == ""){
        $scope.errType = "desc";
        $scope.hasErr = true;
        $("#desc").focus();
      } else if($scope.csAdd.contact == ""){
        $scope.errType = "contact";
        $scope.hasErr = true;
        $("#contact").focus();
      } else if(!$scope.contactRegExp.test($scope.csAdd.contact) || $scope.csAdd.contact.length < 10){
        $scope.errType = "contactValid";
        $scope.hasErr = true;
        $("#contactValid").focus();
      } else{
        $scope.saveProcessing = true;
        FileModelUploadSrv.uploadFileAndData("creative", $scope.csAdd, $scope.curFile).then(
          function(data){
            $rootScope.toastNotificationFx("info", data);
            $scope.saveProcessing = false;
            $state.go("hub.creativeServices.cur");
          },
          function(err){
            $rootScope.toastNotificationFx("danger", {"code":5000});
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CreativeSrvController', CreativeSrvController);

  /** @ngInject */
  function CreativeSrvController($log, $rootScope, $scope, $state, $filter, $sce, $ocLazyLoad, ngDialog, CreativeServicesSrv){
    $ocLazyLoad.load('//www.paypalobjects.com/api/checkout.min.js');
    $rootScope.selectedMenu = 9;

    $scope.selectedTab = $state.current.name;
    $scope.deleteStatus = [1, 2, 6, 9, 10];
    $scope.creativeSrvLoading = true;
    $scope.creativeSrv = {};
    $scope.filterCount = "";
    $scope.filter = "all";
    $scope.invoices = {};

    $scope.loadSelectedTab = function(){
      $scope.creativeSrvLoading = true;
      $rootScope.selectedItems = [];
      $scope.creativeSrv = {};
      $scope.searchText = "";
      $scope.filter = "all";
      if($scope.selectedTab === "hub.creativeServices.cur"){
        CreativeServicesSrv.getCurrent().then(
          function(data){
            if($scope.selectedTab === "hub.creativeServices.cur"){
            $scope.creativeSrvLoading = false;
            $scope.filterCount = data.length;
            $scope.creativeSrv = data;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.creativeServices.cmp"){
        CreativeServicesSrv.getCompleted().then(
          function(data){
            if($scope.selectedTab === "hub.creativeServices.cmp"){
            $scope.creativeSrvLoading = false;
            $scope.filterCount = data.length;
            $scope.creativeSrv = data;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.creativeServices.inv"){
        CreativeServicesSrv.getInvoiceList().then(
          function(data){
            if($scope.selectedTab === "hub.creativeServices.inv"){
            $scope.invoices = data;
            $scope.filterCount = data.length;
            $scope.creativeSrvLoading = false;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
    });

    $scope.openInvoiceFx = function(id){
      $state.go("hub.cContainer.cs.iTab", {
        id:$scope.hubEncrypt(id)
      });
    }

    $scope.editFx = function(id){
      $state.go("hub.cContainer.cs.odTab", {
        id:$scope.hubEncrypt(id)
      });
    }

    $scope.approveFx = function(id){
      CreativeServicesSrv.approveCreative(id).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.flProcessing = false;
          $log.error(err);
        }
      );
    }
    $scope.confirmOpen = function(id){
      $scope.deleteId = id;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cs.msg.13" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="confirmFx();" ng-disabled="saveProcessing"><span class="fa fa-repeat fa-spin" ng-if="saveProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
      });
    }

    $scope.confirmFx = function(){
      $scope.saveProcessing = true;
      CreativeServicesSrv.deleteCreative($scope.deleteId).then(
        function(data){
          $scope.saveProcessing = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.flProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.filterFx = function(type){
      $rootScope.closeAllFx();
      $scope.filter = type;
      if(type == 'all'){
        $scope.filterCount = $scope.creativeSrv.length;
      } else if(type == 'c' || type == 't'){
        $scope.filterCount = $filter("filter")($scope.creativeSrv, {type:type}).length;
      } else{
        $scope.filterCount = $filter("filter")($scope.creativeSrv, {status:type}).length;
      }
    }

    $scope.readMeFx = function(){
      ngDialog.open({
        template:'app/creativeServices/popup/info.html',
        width:580,
        scope:$scope
      });
    }

    $scope.videoFx = function(){
      $scope.videoObj = {};
      $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "CRJUIjgmBYo" + $scope.videoParam);
      ngDialog.open({
        template:'app/creativeServices/popup/video.html',
        width:580,
        data:$scope.videoObj,
        scope:$scope
      });
    }
  }
})();
angular.module('hub').service('DvwCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getVideoWallDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/videowall/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*With tag*/
  this.getDeviceTag = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceTag");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDvw = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/videowall/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DevicesSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  this.getDeviceAndGroups = function(){ /*Get All devices and devices groups for selected options only {id, label}*/
    httpReq = $http.get($rootScope.apiHost + "devices/deviceAndGroups?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceTagsAndGroups = function(id, type){ /*Get All devices and devices groups for selected options only {id, label}*/
    httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new/" + id + "?type=" + type + "&" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.getAssignableDevices = function(id, type, auth, offset, text, filter){ /*Get All devices, groups and tags*/
  this.getAssignableDevices = function(obj){ /*Get All devices, groups and tags*/
    // If there's a previous canceler, resolve it to cancel the previous request
    if (canceler) {
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {
      timeout: canceler.promise
    };
    // console.log("obj.offset",obj.offset);
    // console.log("getAssignableDevices service", obj);
    if(obj.auth && obj.auth.upreferences.deviceView == 'l'){
      if(obj.type){
        httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+obj.fId+"&caller="+obj.caller+"&type=" + obj.type + "&isLV=1&offset=" + obj.offset + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + "&" + new Date().getTime(), config);
      } else{
        httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+obj.fId+"&caller="+obj.caller+ "&isLV=1&offset=" + offset+((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+"&" + new Date().getTime(), config);
      }
    } else {
      if(obj.type){
        httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+obj.fId+"&caller="+obj.caller+"&type=" + obj.type + "&offset=" + obj.offset +((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+ "&" + new Date().getTime(), config);
      } else{
        httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+obj.fId+"&caller="+obj.caller+"&offset=" + obj.offset +((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+ "&" + new Date().getTime(), config);
      }
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDownupDGT = function(sid){
    if(!angular.isUndefined(sid)){
      httpReq = $http.get($rootScope.apiHost + "devices/downup/devices?sid=" + sid);
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/downup/devices?" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDevice = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if (canceler) {
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {
      timeout: canceler.promise
    };
    var auth = angular.fromJson(localStorage.getItem("auth"));
    if(obj.caller == "gbdt" && obj.isDP){
      if(obj.type){
        var urlPart = "devices/new1?gtype="+ obj.type + "&offset=" + obj.offset + (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"");
      } else {
        var urlPart = "devices/new1?" + "&offset=" + obj.offset + (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"");
      }
    } else if(obj.caller == "gbdt" && !obj.isDP){
      var urlPart = "devices/new1?gtype="+ obj.type +"&"+ new Date().getTime();
    } else if(obj.caller == "dp"){
      var urlPart = "devices/new1?dp=1&"+ new Date().getTime();
    } else if(obj.caller == "r"){
      var urlPart = "devices/new1?"+ new Date().getTime() +"&r=1&offset="+obj.offset+ (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"");//changed &rpt to &r
    } else if(obj.caller == "vdw"){
      var urlPart = "devices/new1?"+ new Date().getTime() +"&vdw=1&offset="+obj.offset+ (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"")+(obj.vdwId?"&vdwId=" + obj.vdwId:"");//changed &rpt to &r
    } else if(obj.caller == "hdsr"){
      var urlPart = "devices/new1?"+ new Date().getTime() +"&hdsr=1&offset="+obj.offset+ (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"");//changed &rpt to &r
    } else{
      var urlPart = "devices/new1?" + "offset=" + obj.offset + (obj.fId?"&fid=" + obj.fId:"") + ((obj.filter=='online' || obj.filter=='offline') ? "&fil=" + obj.filter : "")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+(obj.isLV?"&isLV=1":"");
    }
    httpReq = $http.get($rootScope.apiHost + urlPart +'&'+ new Date().getTime(), config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTotalDeviceCount = function(){
    httpReq = $http.get($rootScope.apiHost +"devices/listnew?caller=tdc&"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDType = function(sType, caller){
    if(caller == "s"){
      if(sType){
        httpReq = $http.get($rootScope.apiHost +"devices/gbdt?t="+ sType +"&"+ new Date().getTime());
      } else{
        httpReq = $http.get($rootScope.apiHost +"devices/gbdt?t=0&"+ new Date().getTime());
      }
    } else{
      httpReq = $http.get($rootScope.apiHost +"devices/gbdt?"+ new Date().getTime());
    }
    // httpReq = $http.get($rootScope.apiHost +"devices/gbdt?"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setPL = function(obj){
    httpReq = $http.put($rootScope.apiHost + "common/pg", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceGroups = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/groups?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceTag = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/tags?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.similarDevices = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/similar", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loadMoreDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/moreDevices/25");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getConfig = function(mac){
    httpReq = $http.get($rootScope.apiHost + "devices/mcConfig/" + mac);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteConfig = function(configId){
    httpReq = $http.delete($rootScope.apiHost + "devices/mcConfig/" + configId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSearch = function(caller){
    httpReq = $http.get($rootScope.apiHost + "devices/searches/" + caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSearchBrief = function(caller){
    httpReq = $http.get($rootScope.apiHost + "devices/searches/briefs/" + caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.savedSearched = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/searches", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPlayListDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/playlist/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getPlayListDetailsLSN = function(id){
    httpReq = $http.get($rootScope.apiHost + "lsn/playList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getRefreshList = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/refreshList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.expTagDevices = function(tId, type, dsg){
    if(type == "group"){
      httpReq = $http.get($rootScope.apiHost + "devices/export/groups?groupId=" + tId +"&dsg=" + dsg);
    } else if(type == "search"){
      httpReq = $http.get($rootScope.apiHost + "devices/export/searches?searchId=" + tId+"&dsg=" + dsg);
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/export/tags?tagId=" + tId+"&dsg=" + dsg);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Brief*/
  this.getDeviceBrief = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/briefs/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceRes = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/desktopDisplayModes/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceGroupBrief = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/groups/briefs/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*ngSwitch*/
  this.changeAutoUpdate = function(id){
    httpReq = $http.patch($rootScope.apiHost + "devices/autoUpdate/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.changeOfflineReboot = function(id){
    httpReq = $http.patch($rootScope.apiHost + "devices/offlineReboot/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.changeLanAccessible = function(id){
    httpReq = $http.patch($rootScope.apiHost + "devices/groups/lan/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Count list*/
  this.getContentList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/contentList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveContent = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/contentList/" + id +"/a");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInactiveContent = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/contentList/" + id +"/i");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAllSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/scheduleList/" + id +"/all");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/scheduleList/" + id +"/a");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInactiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/scheduleList/" + id +"/i");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFrameLayoutList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/frameLayoutList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getScheduleList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/scheduleList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTagList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tagList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGroupDeviceList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/groups/deviceList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTagDeviceList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUserGroupList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/deviceUserGroupList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUserGroupDeviceList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/userGroup/deviceList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAccessUserList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/search/deviceUserGroupList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.downloadUserGroups = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/deviceUserGroupList/" + id +"?isExport=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loadMoreLogs = function(dateObj){
    httpReq = $http.get($rootScope.apiHost + "devices/logs/" + dateObj.id + "/" + dateObj.offset);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.downloadLogs = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/logs", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // ! Popup scroll data list API start
  this.getScrollListData = function(obj){
    if(obj.caller == 'dt' || obj.caller == 'dg' || obj.caller == 'ug' || obj.caller == 'ss' || obj.caller == 's' || obj.caller == 'u' || obj.caller == 'fl' || obj.caller == 'fla' || obj.caller == 'irAck' || obj.caller == 'dp' || obj.caller == "emAck" || obj.caller == "qr"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset);
    } else if(obj.caller == 'dFolder'){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset +"&fil="+ obj.fil);
    } else if(obj.caller == 'ir' || obj.caller == "tv" || obj.caller == "oi" || obj.caller == "tag" || obj.caller == "prop" || obj.caller == "onOffSch" || obj.caller == "du" || obj.caller == "wm" || obj.caller == "ed"  || obj.caller == "em"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset +"&sortType="+ obj.sortType +"&sortVal="+ obj.sortVal);
    } else if(obj.subCaller == "dmbU"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&subCaller="+ obj.subCaller +"&offset="+ obj.offset +"&sortType="+ obj.sortType +"&sortVal="+ obj.sortVal);
    } else if(obj.caller == "availD" || obj.caller == "selD"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset + (obj.subCaller ? "&subCaller=" + obj.subCaller : "") + (obj.subCallerId ? "&subCallerId=" + obj.subCallerId : "") + (obj.sortType ? "&sortType=" + obj.sortType : "") + (obj.sortVal ? "&sortVal=" + obj.sortVal : ""));
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSearchScrollData = function(obj){
    if(obj.caller == 'dt' || obj.caller == 'dg' || obj.caller == 'ug' || obj.caller == 'ss' || obj.caller == 's' || obj.caller == 'u' || obj.caller == 'fl' || obj.caller == 'fla' || obj.caller == 'irAck' || obj.caller == 'dp' || obj.caller == "emAck" || obj.caller == "qr"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset +"&searchQ="+ encodeURIComponent(obj.searchQ));
    } else if(obj.caller == 'dFolder'){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset +"&searchQ="+ encodeURIComponent(obj.searchQ) +"&fil="+ obj.fil);
    } else if(obj.caller == 'ir' || obj.caller == "tv" || obj.caller == "oi" || obj.caller == "tag" || obj.caller == "prop" || obj.caller == "onOffSch" || obj.caller == "du" || obj.caller == "wm" || obj.caller == "ed"  || obj.caller == "em"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset +"&searchQ="+ encodeURIComponent(obj.searchQ) +"&sortType="+ obj.sortType +"&sortVal="+ obj.sortVal);
    } else if(obj.subCaller == "dmbU"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&subCaller="+ obj.subCaller +"&offset="+ obj.offset +"&searchQ="+ encodeURIComponent(obj.searchQ) +"&sortType="+ obj.sortType +"&sortVal="+ obj.sortVal);
    } else if(obj.caller == "availD" || obj.caller == "selD"){
      httpReq = $http.get($rootScope.apiHost + "devices/listpagingnew?callerId="+ obj.id +"&caller="+ obj.caller +"&offset="+ obj.offset + (obj.subCaller ? "&subCaller=" + obj.subCaller : "") + (obj.subCallerId ? "&subCallerId=" + obj.subCallerId : "") + (obj.sortType ? "&sortType=" + obj.sortType : "") + (obj.sortVal ? "&sortVal=" + obj.sortVal : "") + (obj.searchQ ? "&searchQ="+ encodeURIComponent(obj.searchQ) : ""));
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // ! Popup scroll data list API End
  /*Button*/
  this.getDeviceBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/devices", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceTagsBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/tags", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceGroupBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/deviceGroups", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDeviceRes = function(obj){
    httpReq = $http.put($rootScope.apiHost + "devices/desktopDisplayModes", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Delete*/
  this.deleteDevices = function(deviceId, fIds){
    if(deviceId.length == 0 && fIds.length > 0){
      httpReq = $http.post($rootScope.apiHost + "devices/deviceDelete", {fids:fIds});
    } else if(deviceId.length > 0 && fIds.length > 0){
      httpReq = $http.post($rootScope.apiHost + "devices/deviceDelete", {did:deviceId,fids:fIds});
    } else if(deviceId.length > 0 && fIds.length == 0){
      httpReq = $http.post($rootScope.apiHost + "devices/deviceDelete", {did:deviceId});
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.verifyDeletedDevice = function(deviceId){
    httpReq = $http.get($rootScope.apiHost + "devices/dvcVerifyBeforeDelete/" + deviceId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteGroups = function(obj){
    httpReq = $http.delete($rootScope.apiHost + "devices/groups", {
      "params":obj
    });
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteTags = function(tagId){
    httpReq = $http.delete($rootScope.apiHost + "devices/tags/" + tagId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteTagsConfirm = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/tags/delete/confirm", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getOnDemandSS = function(ids){
    httpReq = $http.get($rootScope.apiHost + "devices/onDemandSS/" + ids);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.onDemandSS = function(ids){
    httpReq = $http.post($rootScope.apiHost + "devices/onDemandSS", ids);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveOrder = function(obj){
    httpReq = $http.patch($rootScope.apiHost + "devices/scheduleList/" + obj.id, obj.list);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Identify tab*/
  this.getHistory = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/history");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.sendIdentify = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/identify", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.dsInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/tvinfo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAcknowledge = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/acknowledgements/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteHistory = function(id){
    httpReq = $http.delete($rootScope.apiHost + "devices/history/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.duoInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/deviceinfo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.dueInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/ed", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.dutInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/devicetags", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.duInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/du", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.dupInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/dp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTargetDevice = function(type){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceControl/action/"+ type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.importSettings = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/deviceControl/action/import", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLockScreen = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/lockscreen", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Auto Registration*/
  this.saveRegistration = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/autoReg/import", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSampleFile = function(){
    httpReq = $http.get($rootScope.apiHost + "common/devices/export/sampleAutoReg?dsg=0");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Devcice Timer On/Off*/
  this.dtInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/downup/tvinfo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceCH = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/migrationhistory/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getTicket = function(url, id, server, count, envId){
    httpReq = $http.get(url + "auth/devices/tickets/"+ id +"/"+ server +"/"+ count);
    // httpReq = $http.get($rootScope.apiHost + "hubspot/"+ count + "/" + envId + "/" + server +"/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTicketCount = function(url, id, server, envId){
    // httpReq = $http.get(url +"auth/devices/tickets/"+ id +"/"+ server +"/"+ count +"/count");
    httpReq = $http.get($rootScope.apiHost + "hubspot/ticketCount/" + envId + "/" + server +"/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTicketDetails = function(url, thId){
    httpReq = $http.get(url + "auth/devices/tickets/"+ thId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.loadMorePH = function(dateObj){
    httpReq = $http.get($rootScope.apiHost +"devices/powerhistory/"+ dateObj.mac +"/"+ dateObj.offset);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.phDownload = function(obj){
    httpReq = $http.post($rootScope.apiHost +"reports/poh/xlsx", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  //watermark
  this.dwInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/watermark/downup", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWatermark = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/watermark");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getWMDevices = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/downup/devices?type=watermark");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWatermark = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/watermark", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteWatermark = function (id) {
    httpReq = $http.delete($rootScope.apiHost + "devices/watermark/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*****Folder*****/
  this.folderCU = function (obj) {
    httpReq = $http.post($rootScope.apiHost + "devices/folders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.getFolderData = function (fId, offset, obj, caller, filType, text) {
  this.getFolderData = function (obj){
    // this.getFolderData = function (fId, offset, obj, caller, filType, text) {
    if(obj.offset==null || obj.offset==0){
      if(obj.obj){
        if(obj.obj.caller=="vdw"){
          // httpReq = $http.get($rootScope.apiHost + "devices/new?"+ new Date().getTime() + "&fid=" + obj.fId +"&vdw=1&vdwId="+obj.id);
          httpReq = $http.get($rootScope.apiHost + "devices/new1?fid="+obj.fId+"&vdw=1&offset=0" + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&vdwId="+(obj.id?obj.id:"") +"&"+ new Date().getTime());
        } else {
          // httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new/" + obj.id + "?fid=" + fId + "&type=" + obj.type + "&sType=" + obj.schType+ "&" + new Date().getTime());
          httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.obj.id + "?fid="+obj.fId+"&caller=d&type=" + obj.obj.type +"&offset=0" + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&" + new Date().getTime());
        }
        // httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new/" + obj.id + "?fid="+fId+"&type=" + obj.type + "&" + new Date().getTime());
      } else {
        if(obj.caller=="r"){
          httpReq = $http.get($rootScope.apiHost + "devices/new1?fid=" + obj.fId+"&offset="+obj.offset + "&r=1"+ ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&" + new Date().getTime());
        } else if(obj.caller=="hdsr"){
          httpReq = $http.get($rootScope.apiHost + "devices/new1?fid=" + obj.fId+"&offset="+obj.offset + "&hdsr=1" + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + "&" + (obj.isLV?"&isLV=1":"") + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + "&" + new Date().getTime());
        } else if(obj.caller=="tag" || obj.caller=="group"){
          httpReq = $http.get($rootScope.apiHost + "devices/new1?fid=" + obj.fId+"&offset="+obj.offset + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + "&isCalledFromTag=1" + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&" + new Date().getTime());
        } else {
          httpReq = $http.get($rootScope.apiHost + "devices/new1?fid=" + obj.fId+"&offset="+obj.offset + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&" + new Date().getTime());
        }
      }
    } else {
      httpReq = $http.get($rootScope.apiHost + "devices/new1?fid=" + obj.fId+"&offset=" + obj.offset + ((obj.filType=='online' || obj.filType=='offline') ? "&fil=" + obj.filType : "") + (obj.text?"&searchQ="+encodeURIComponent(obj.text):"") + (obj.isLV?"&isLV=1":"") + "&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.getFolderData = function (obj){
  //   // console.log("obj",obj);
  //   // console.log("filType",filType);
  //   var auth = angular.fromJson(localStorage.getItem("auth"));
  //   if(auth.upreferences.deviceView == 't'){
  //     if(offset==null){
  //       if(obj){
  //         httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+fId+"&caller=d&type=" + obj.type +"&offset=0" + ((filType=='online' || filType=='offline') ? "&fil=" + filType : "") + (text?"&searchQ="+text:"") + "&" + new Date().getTime());
  //         // httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new/" + obj.id + "?fid="+fId+"&type=" + obj.type + "&" + new Date().getTime());
  //       } else {
  //         if(caller=="r"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + "&r=1"+ ((filType=='online' || filType=='offline') ? "&fil=" + filType : "") + (text?"&searchQ="+text:""));
  //         } else if(caller=="hdsr"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + "&hdsr=1" + (text?"&searchQ="+text:""));
  //         } else if(caller=="tag" || caller=="group"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + ((filType=='online' || filType=='offline') ? "&fil=" + filType : "") + "&isCalledFromTag=1" + (text?"&searchQ="+text:""));
  //         } else {
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + (text?"&searchQ="+text:""));
  //         }
  //       }
  //     } else {
  //       httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset=" + offset + (filType ? "&fil="+filType : '')+ (text?"&searchQ="+text:""));
  //     }
  //   } else {
  //     if(offset==null){
  //       if(obj){
  //         httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new1/" + obj.id + "?fid="+fId+"&caller=d&type=" + obj.type +"&offset=0" + ((filType=='online' || filType=='offline') ? "&fil=" + filType : "") + (text?"&searchQ="+text:"") +"&isLV=1" + new Date().getTime());
  //         // httpReq = $http.get($rootScope.apiHost + "devices/assignableDevices/new/" + obj.id + "?fid="+fId+"&type=" + obj.type +"&isLV=1" + new Date().getTime());
  //       } else {
  //         if(caller=="r"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + "&r=1&isLV=1"+ ((filType=='online' || filType=='offline') ? "&fil=" + filType : "")+ (text?"&searchQ="+text:""));
  //         } else if(caller=="hdsr"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + "&r=hdsr&isLV=1"+ (text?"&searchQ="+text:""));
  //         } else if(caller=="tag" || caller=="group"){
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset + "&r=1"+ ((filType=='online' || filType=='offline') ? "&fil=" + filType : "") + "&isCalledFromTag=1&isLV=1"+ (text?"&searchQ="+text:""));
  //         } else {
  //           httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset="+offset+"&isLV=1"+ (text?"&searchQ="+text:""));
  //         }
  //       }
  //     } else {
  //       httpReq = $http.get($rootScope.apiHost + "devices/new1?"+ new Date().getTime() + "&fid=" + fId+"&offset=" + offset + (filType ? "&fil="+filType : '')+"&isLV=1"+ (text?"&searchQ="+text:""));
  //     }
  //   }
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }
  this.getFolderDetails = function (fId) {
    httpReq = $http.get($rootScope.apiHost + "devices/folders/details/" + fId);
    // httpReq = $http.get($rootScope.apiHost + "devices/?"+ new Date().getTime() + "&fid=" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTemplatesFolder = function (id) {
    httpReq = $http.get($rootScope.apiHost + "templates/scheduleList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.move = function (obj) {
    httpReq = $http.post($rootScope.apiHost + "devices/folders/move", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // this.copy = function (obj) {
  //   httpReq = $http.post($rootScope.apiHost + "devices/folders/copy", obj);
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }
  this.getTree = function(id, path){
    if(path){
      httpReq = $http.get($rootScope.apiHost + "devices/folders/tree/" + id +"?path=1&"+ new Date().getTime());
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/folders/tree/" + id +"?"+ new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMoveTree = function (fId) {
    if (fId === undefined) {
      fId = 0;
    }
    httpReq = $http.get($rootScope.apiHost + "devices/folders/moveTree" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Brief*/
  this.getFolderBrief = function(fId, splId, splType, filType){
    if(splType == "folder"){
      httpReq = $http.get($rootScope.apiHost + "devices/folders/briefs/" + fId + "?fil="+filType);
    } else{
      httpReq = $http.get($rootScope.apiHost + "devices/folders/briefs/" + fId + "&splType=" + splType + "&fil="+filType);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Button*/
  this.saveTemplateBtn = function(tId){
    httpReq = $http.post($rootScope.apiHost + "action/devices", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getDeviceList = function(id, filType){
    httpReq = $http.get($rootScope.apiHost + "devices/folders/deviceList/"+ id + "?fil="+filType);
    return httpReq.then(this.handleSuccess, this.handleError);
  }


  this.getCBTime = function(){
    httpReq = $http.get($rootScope.apiHost + "feed/circuitBench/feed");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.forceUpdateCBTime = function(sid){
    httpReq = $http.get($rootScope.apiHost + "feed/circuitBench/paragraphs?serverid="+sid+"&generatefeed=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDUserGroupList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/uGroups/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTask = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/downup/devicetags");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTaskDetails = function(tId){
    httpReq = $http.get($rootScope.apiHost + "devices/downup/devicetags/"+tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateDeviceInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/updateDeviceInfo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceSS = function(){ /*Get All devices and devices groups for selected options only {id, label}*/
    httpReq = $http.get($rootScope.apiHost + "devices/listnew?caller=dss&"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  // video wall
  this.getVideoWalls = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/videowall/?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVideoWallBrief = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/videowall/briefs/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVideoWallBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/videowall", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteVideoWall = function(obj){
    httpReq = $http.delete($rootScope.apiHost + "devices/videowall/", {
      "params":obj
    });
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVideoWallList = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/videowall/deviceList/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.updateDeviceStatus = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/lp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);

angular.module('hub').service('DeviceTagCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  this.getDeviceTagsDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/tags/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*With tag*/
  // this.getDeviceTag = function(auth, offset, text){
  this.getDeviceTag = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if (canceler) {
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {
      timeout: canceler.promise
    };
    // console.log("getDeviceTag", obj);
    if(obj.auth && obj.auth.upreferences.deviceView == 'l'){
      httpReq = $http.get($rootScope.apiHost + "devices/deviceTag/new1?isLV=1&offset="+obj.offset+(obj.text?"&searchQ="+encodeURIComponent(obj.text):'')+((obj.filter=='online' || obj.filter=='offline')?"&fil="+obj.filter:"")+ "&caller=d&fid="+(obj.fId>0?obj.fId:0), config);
    } else {
      httpReq = $http.get($rootScope.apiHost + "devices/deviceTag/new1?offset="+obj.offset+(obj.text?"&searchQ="+encodeURIComponent(obj.text):'')+((obj.filter=='online' || obj.filter=='offline')?"&fil="+obj.filter:"")+ "&caller=d&fid="+(obj.fId>0?obj.fId:0), config);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDeviceTag = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/tags", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DeviceGroupCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  this.getDeviceGroupDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/groups/details/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*With tag*/
  // this.getDeviceTag = function(auth, offset, text){
  this.getDeviceTag = function(obj){
    // If there's a previous canceler, resolve it to cancel the previous request
    if (canceler) {
      canceler.resolve();
    }

    // Create a new canceler promise
    canceler = $q.defer();

    // Make the HTTP GET request with the new canceler promise
    var config = {
      timeout: canceler.promise
    };
    if(obj.auth && obj.auth.upreferences.deviceView == 'l'){
      httpReq = $http.get($rootScope.apiHost + "devices/deviceTag/new1?isLV=1&offset="+obj.offset+((obj.filter=='online' || obj.filter=='offline')?"&fil="+obj.filter:"")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+ "&caller="+obj.caller+"&fid="+(obj.fId>0?obj.fId:0), config);
    } else {
      httpReq = $http.get($rootScope.apiHost + "devices/deviceTag/new1?offset="+obj.offset+((obj.filter=='online' || obj.filter=='offline')?"&fil="+obj.filter:"")+(obj.text?"&searchQ="+encodeURIComponent(obj.text):"")+ "&caller="+obj.caller+"&fid="+(obj.fId>0?obj.fId:0), config);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDeviceGroup = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices/groups", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('DevicesCUSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getDevicesDetails = function(id, caller){
    if(caller == "oi"){
      httpReq = $http.get($rootScope.apiHost + "devices/details/" + id + "?info=1");
    } else {
      httpReq = $http.get($rootScope.apiHost + "devices/details/" + id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getProperties = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/dp");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceTags = function(id){
    httpReq = $http.get($rootScope.apiHost + "devices/deviceTags/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDevice = function(obj){
    httpReq = $http.post($rootScope.apiHost + "devices", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getESLStores = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/esl/stores");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getModels = function(){
    httpReq = $http.get($rootScope.apiHost + "devices/esl/models");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLicenseTypes = function(sId){
    // httpReq = $http.get($rootScope.apiHost + "supportDesk/renewal/licenses/list/"+sId+"/detail");
    httpReq = $http.get($rootScope.apiHost + "devices/availableLicenses");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('ngMouseWheelZoom', ngMouseWheelZoom);

  /** @ngInject */
  /*This directive work instent of ng-bind-html*/
  function ngMouseWheelZoom(){
    return {
      restrict:"A",
      scope: {
       ngMouseWheelZoom:"=",
       option:"="
      },

      link:function(scope, element, attrs){
        element.bind("DOMMouseScroll mousewheel onmousewheel", function(event){
          // cross-browser wheel delta
          var event = window.event || event; // old IE support
          var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

          if(!scope.ngMouseWheelZoom){
            scope.ngMouseWheelZoom = 100;
          }
          if(!scope.option.zoom){
            scope.option.zoom = 20;
          }
          if(delta > 0){ //ngMouseWheelUp
            if(scope.option.max){
              if(scope.option.max > scope.ngMouseWheelZoom){
                scope.ngMouseWheelZoom = scope.ngMouseWheelZoom + scope.option.zoom;
                scope.$apply(scope.ngMouseWheelZoom);
              }
            } else{
              scope.ngMouseWheelZoom = scope.ngMouseWheelZoom + scope.option.zoom;
              scope.$apply(scope.ngMouseWheelZoom);
            }

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if(event.preventDefault) event.preventDefault();
          }
          if(delta < 0){ //ngMouseWheelDown
            if(scope.option.min){
              if(scope.option.min < scope.ngMouseWheelZoom){
                scope.ngMouseWheelZoom = scope.ngMouseWheelZoom - scope.option.zoom;
                scope.$apply(scope.ngMouseWheelZoom);
              }
            } else{
              scope.ngMouseWheelZoom = scope.ngMouseWheelZoom - scope.option.zoom;
              scope.$apply(scope.ngMouseWheelZoom);
            }

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if(event.preventDefault) event.preventDefault();
          }
        });
      }
    };
  }
})();
angular
  .module('hub').directive('focusSelected', function($timeout){
    return {
        restrict: 'A',
        link: function(scope, element) {
            scope.$on('selectedItemChanged', function(event, selectedItemId) {
              if (selectedItemId) {
                $timeout(function () {
                  var listItem = angular.element(document).find('#' + selectedItemId);
                  if (listItem.length > 0) {
                    listItem[0].scrollIntoView();
                  }
                });
              }
            });
        }
      };
  });

angular
  .module('hub').directive('ngDeviceThumb', function(){
    return {
      restrict:'E',
      templateUrl:'app/devices/dir/deviceThumb.html'
    }
  });

(function(){
  'use strict';
  angular.module('hub')
  .directive('deviceScrollQuad', function(){
    return{
      restrict:'A',
      link:function($scope, element, attrs){
        $scope.$watch(function(){
          var parent = element.parent();
          var offSets = 0;
          if(Number(attrs.offset)){
            offSets = Number(attrs.offset);
          };
          var curHeight = parent.prop('offsetHeight') - offSets - element.find('.bdrGray').outerHeight() - element.find('.panel-body').outerHeight() - element.find('.panel-footer').outerHeight();
          element.find(".dScrollQuad").height(curHeight + 80);
        });
      }
    }
  });
})();
angular
  .module('hub').directive('ngDeviceList', function(){
    return {
      restrict:'E',
      templateUrl:'app/devices/dir/deviceList.html'
    }
  });

angular
  .module('hub').directive('ngDeviceGroupThumb', function(){
    return {
      restrict:'E',
      templateUrl:'app/devices/dir/deviceGroupThumb.html'
    }
  });

angular
  .module('hub').directive('ngDeviceBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/devices/dir/deviceBrief.html'
    }
  });

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PlayListLSNController', PlayListLSNController);

  /** @ngInject */
  function PlayListLSNController($log, $rootScope, $scope, $state, ngDialog, FrameLayoutsSrv, DevicesSrv){
    $rootScope.selectedMenu = 5;

    $scope.previewHeight = $scope.getAvailableHeight(164) * 0.40;
    $scope.listHeight = $scope.getAvailableHeight(164) * 0.60;
    $scope.canvas = {zoom:"0.25"};
    $scope.detailsLoading = true;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      DevicesSrv.getPlayListDetailsLSN($scope.decId).then(
        function(data){
          $scope.playList = data;
          $scope.frameLayout = $scope.playList.layout[0];
          $scope.detailsLoading = false;
        },
        function(err){
          $log.error(err);
        }
      )
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('PlayListController', PlayListController);

  /** @ngInject */
  function PlayListController($log, $rootScope, $scope, $state, ngDialog, FrameLayoutsSrv, DevicesSrv){
    $rootScope.selectedMenu = 5;

    $scope.previewHeight = $scope.getAvailableHeight(164) * 0.40;
    $scope.listHeight = $scope.getAvailableHeight(164) * 0.60;
    $scope.canvas = {zoom:"0.25"};
    $scope.detailsLoading = true;
    $scope.encId = "";
    $scope.decId = "";

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      DevicesSrv.getPlayListDetails($scope.decId).then(
        function(data){
          $scope.playList = data;
          $scope.frameLayout = $scope.playList.layout[0];
          $scope.detailsLoading = false;
        },
        function(err){
          $log.error(err);
        }
      )
    }
  }
})();
(function(){
  'use strict';

  angular
  .module('hub')
  .controller('DevicesController', DevicesController);

  /** @ngInject */
  function DevicesController($log, $rootScope, $scope, $state, $sce, $filter, $interval, ngDialog, $cookies, $timeout, $location, $window, $q, CommonSrv, FileModelUploadSrv, ContentLibrarySrv,TemplatesSrv, DeviceControlSrv, DevicesSrv, FrameLayoutsSrv, ReportsSrv, DashboardSrv, SchedulesSrv, UsersSrv, DevicesCUSrv){
    $rootScope.selectedMenu = 5;
    $rootScope.totalDeviceOnServer = 0;
    $rootScope.importXls = {file:""};
    $rootScope.tmpBriefDevices = [];
    $rootScope.multiSelDevices = [];
    $rootScope.deviceFilter = "all";
    $rootScope.clearSearch = false;
    $rootScope.ssDStatus = [];
    $scope.visibleDevices = 0;
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $rootScope.gAList = [];
    $rootScope.gSList = [];
    $rootScope.tAList = [];
    $rootScope.tSList = [];
    $rootScope.offset = 0;

    $scope.similarFilter = {id:0,os:false,ip:false,aDate:false,res:false,dRestriction:false,tags:false,fl:false,dGroup:false,cGroup:false};
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.devices = {info:{totalDevices:0},list:{},devices:[]};
    $scope.curGroups = {availableGroups:[], assignedGroups:[]};
    $scope.curTags = {availableTags:[], assignedTags:[]};
    $scope.selectedTab = $state.current.name;

    $scope.deviceProcessing = false;
    $scope.status = {isopen:false};
    $scope.devicesLoading = true;
    $scope.isConfirmOpen = false;
    $scope.deviceLastPing = true;
    $scope.deletableHistory = [];
    $scope.curDevicesLength = "";
    $scope.highlightedFrame = 0;
    $scope.showDownload = false;
    $scope.innerLoading = false;
    $scope.deletableTags = [];
    $scope.acknowledge = {};

    $scope.expType = "";
    $scope.tempArr = [];
    $scope.fidArr = [];
    $scope.tempId = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.brief = {};
    $scope.curWMObj = {isEdit:false};
    $scope.resetCopy = {list:{}};
    $rootScope.search = {text:""};
    $scope.isInfoSteth = false;
    $scope.validationOn = false;
    $scope.tempId = "";
    $scope.folderList = [];
    $scope.thumbSize = 'n'
    $scope.treeList = [];
    $scope.validationOn = false;
    $scope.searchTotal = 0;
    $scope.treeLoading = true;
    $scope.legend = false;
    $scope.tagList = [];
    $scope.valueType = "t";
    $scope.dpOpen = true;
    $scope.searchDInfo = {text:''};
    $scope.dialog = {info:""};
    $scope.isInfoDialog = {open:false};
    $scope.isDBInfo = false;
    $scope.curTimestamp = moment().format('x');
    $scope.pagination = [];
    $scope.dOffset = 0;
    $rootScope.commonSearchVar = "";
    // $scope.isAPISearch = {enable:false};
    $scope.dReqObj = {caller:"",type:"",offset:0,isDP:false,filter:"all",fId:"",text:"",isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};

    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.copyDevices = {devices:[],folders:[]};
    $scope.stored = {devices:[], folders:[]};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.statusObj = {d:false,s:false,as:false,f:false};

    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.isAdvSearchMsg = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.filterIsAppliedAlready = false;
    $scope.rdc = 0;

    $scope.isPageApiLoad = false;
    $scope.advSearchInfoCopy = undefined
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $scope.advSApply = false;
    $rootScope.searchInfo = {text:""};


    $scope.updateDefineVariable = function(){
      $scope.haveMoreData = false;
      $scope.haveMoreSearchData = false;
      $scope.visibleData = [];
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.searchScroll = false;
    }

    function generateRandomName(length){
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      var result = "";
      for(var i = 0; i < length; i++){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }

    window.onscroll = function(){
      $scope.$apply(function(){
        $rootScope.showRemainingList = false;
      })
    }
    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceStatus = function(caller){
      setTimeout(function(){
        if($scope.pageDeviceArr.length){
          var currentTime = new Date().getTime();
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          angular.forEach($scope.pageDeviceArr, function(obj){
            if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
              obj.tz = currentTime;
              DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                function(data){
                  angular.forEach($scope.devices.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  })
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          })
        }
      },100)
    }

    $scope.pageChangeHandler = function(num){
      // $scope.moreDeviceLoading = true;
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      if($scope.selectedTab === "hub.devices.d"){
        $scope.curNum = angular.copy(num);

        $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

        var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
        $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

        var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

        $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
        if(!$scope.filter){
          $scope.filter = "all";
        }
        // $scope.closeAllFx();
        $scope.unselectTypeFx();
        // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
        if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
          $scope.isPageApiLoad = true;
          $scope.apiCalledArr.push(num);
          $scope.dReqObj = {caller:null,type:null,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text};

          if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
            $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
            $scope.curAdvSearchObj.offset = $rootScope.offset;
            if($scope.filter != "all"){
              $scope.curAdvSearchObj.fil = $scope.filter;
            }
            CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.search.text).then(
              function(data){
                $scope.devicesLoading = false;
                $scope.isPageApiLoad = false;
                $scope.filteredData = data;
                $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                $scope.curAdvSearchObj.isLoadMore = true;
                $scope.curAdvSearchObj.isRemove = false;
                if(!angular.isUndefined($scope.rdc)){
                  $scope.curAdvSearchObj.rdc = $scope.rdc;
                } else {
                  $scope.curAdvSearchObj.rdc = data.info.rdc;
                }
                $scope.curAdvSearchObj.sortType = data.info.sortType;
                $scope.curAdvSearchObj.sortVal = data.info.sortVal;
                $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
                $scope.curAdvSearchObj.vl = data.info.tc;
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true, dInfo:data.info, deviceInfo:data.info};
                if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                  $scope.advSearchfilteredData.dInfo = data.info;
                } else{
                  $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
                }
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else{
            $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
          }
        }
        else{
          if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
            $scope.setCountFx("last");
          } else{
            $scope.setCountFx();
          }
        }
      }
    };

    $scope.cList = [{bg:"#351C75", label:"tag 1"}, {bg:"#FFD966", label:"tag 2"}, {bg:"#6FA8DC", label:"tag 3"}, {bg:"#45818E", label:"tag 4"}, {bg:"#A64D79", label:"tag 5"}, {bg:"#CC0000", label:"tag 6"}, {bg:"#FF00FF", label:"tag 7"}]
    $scope.curFolderId = localStorage.getItem("curDFId");
    if(angular.isUndefined($scope.curFolderId)){
      $scope.curFolderId = 0;
    }

    // $scope.getSSStatus = function(){
    //   DevicesSrv.getDeviceSS().then(
    //     function(data){
    //       $rootScope.ssDStatus = data.devices;
    //     },
    //     function(err){
    //       $log.error(err);
    //     }
    //   );
    // }
    // $scope.getSSStatus();

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }

      DevicesSrv.getDevice(dReqObj).then(
        function(data){
          if($scope.selectedTab === "hub.devices.d"){
            $scope.loadingMain = false;
            $scope.isPageApiLoad = false;
            $scope.devicesLoading = false;
            $scope.moreDeviceLoading = false;
            $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey(data);
            if(!$rootScope.selectedItems.length){
              $scope.brief = data;
            }
            if(data.info.rdc || data.info.rdc == 0){
              $scope.rdc = data.info.rdc;
            }

            // get device of types
            if(caller=='openType'){
              $scope.loadingMain = false;
              if(data.code == 12064){
                $scope.auth.upermissions.gbdt = false;
                localStorage.setItem('auth', JSON.stringify($scope.auth));
                $scope.loadSelectedTab();
              } else{
                $scope.isGbdt = false;
              }
            }
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
              return;
            }

            if(caller=='dList'){// get device list
              if(isLoadMore && $scope.dData.devices.length){
                $scope.dData.devices = $scope.dData.devices.concat(data.devices);
              } else{
                $scope.dData = angular.copy(data);
              }

              $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));
              if($scope.addedDeviceId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.addedDeviceId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }

              // $scope.checkOnDemandSS(); // Make it page wise

              $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
              // $scope.filterType = localStorage.getItem("filterType");
              if(!$scope.filterType || $scope.filterType=="all"){
                $scope.filterType = "";
                $scope.filter = "all";
                $scope.fCount = $scope.devices.devices;
              } else{
                $scope.filter = $scope.filterType;
              }
              $scope.devices = angular.copy($scope.dData);
              // $scope.devices.info = angular.copy($scope.dData.info);
              $scope.loadingMain = false;
            }
            // console.warn($scope.curFolderId);
            // $scope.devices.info.sortVal = data.info.sortVal;
            // $scope.devices.info.sortType = data.info.sortType;
            $scope.selectedTreeItem($scope.curFolderId); //?New
            if($scope.totalDPages > 1 && $scope.curNum > 1 && $scope.totalDPages == $scope.curNum){
              $scope.setCountFx("last");
            } else{
              $scope.setCountFx();
            }
            $scope.updateList(isLoadMore);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $scope.closeAllFx();
      $rootScope.commonSearchVar = "";
      $scope.isAdvSearchMsg = false;
      $scope.isSearchMsg = false;
      $scope.isFilterMsg = false;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.firstApply.search = false;
      if($scope.selectedTab=="hub.devices.d"){
        if($scope.rdc > 0){
          $scope.devicesLoading = true;
        }
        // setTimeout(function(){
          // $scope.devicesLoading = true;
          $scope.search.text = "";
          // $scope.sData = {};
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          //Adv search implemented
          $scope.paginationControls.currPage = 1;
          if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
            $scope.curAdvSearchObj.offset = 0;
            if($scope.filter != "all"){
              $scope.curAdvSearchObj.fil = $scope.filter;
            }
            CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.search.text).then(
              function(data){
                $scope.devicesLoading = false;
                $scope.filteredData = data;
                $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                $scope.curAdvSearchObj.rdc = data.info.rdc;
                $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
                $scope.curAdvSearchObj.vl = data.info.tc;
                $scope.curAdvSearchObj.sortType = data.info.sortType;
                $scope.curAdvSearchObj.sortVal = data.info.sortVal;
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true, t:data.t, dInfo:data.info, deviceInfo:data.info};
                if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                  $scope.advSearchfilteredData.dInfo = data.info;
                } else{
                  $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
                }
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else {
            $scope.devicesLoading = true;
            $scope.dReqObj = {caller:null,type:null,offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text};

            // if($scope.firstApply.search && !$scope.firstApply.filter){
            //   $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
            // } else if(!$scope.firstApply.search && $scope.firstApply.filter){
            //   $scope.getDeviceAndProcessFx($scope.dReqObj, "filter", false);
            // } else{
              $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
            // }
          }
        // }, 100);
      } else if($scope.selectedTab=="hub.devices.dg"){
        $scope.search.text = "";
        $scope.devices.devices = angular.copy($scope.dgDataCopy.devices);
        $scope.setCountFx();
      }
    }

    // var searchTimeout;
    $scope.dSearchFx = function(text){
      $scope.closeAllFx();
      $rootScope.commonSearchVar = text;
      $scope.apiCalledArr = [];
      if(!text){
        $scope.clearSearchFx();
        return;
      } else{
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else{
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        if($scope.selectedTab=="hub.devices.d"){
          if(text){
            $scope.devicesLoading = true;
            $rootScope.clearSearch = false;

            if(!$rootScope.isObjectEmpty($scope.advSearchInfo) && (!angular.isUndefined($scope.advSearchInfo)) && $scope.advSearchInfo.module == 'd'){
              localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));
            }
            $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
            //Adv search implemented
            $scope.paginationControls.currPage = 1;
            $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
            if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
              $scope.curAdvSearchObj.offset = 0;
              if($scope.filter != "all"){
                $scope.filterType = $scope.filter
                $scope.curAdvSearchObj.fil = $scope.filter;
              } else{
                $scope.filterType = "";
              }
              $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
              CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, text).then(
                function(data){
                  $scope.devicesLoading = false;
                  $scope.filteredData = data;
                  $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                  $scope.curAdvSearchObj.rdc = data.info.rdc;
                  $scope.curAdvSearchObj.sortType = data.info.sortType;
                  $scope.curAdvSearchObj.sortVal = data.info.sortVal;
                  $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
                  $scope.curAdvSearchObj.vl = data.info.tc;
                  $scope.curAdvSearchObj.isLoadMore = false;
                  $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true, t:data.t, dInfo:data.info, deviceInfo:data.info};
                  if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                    $scope.advSearchfilteredData.dInfo = data.info;
                  } else{
                    $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
                  }
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            } else{
              $rootScope.offset = 0;
              $scope.devicesLoading = true;
              $scope.dReqObj = {caller:null,type:null,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,text:text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};

              // if($scope.firstApply.search && !$scope.firstApply.filter){
              //   $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
              // } else if(!$scope.firstApply.search && $scope.firstApply.filter){
              //   $scope.getDeviceAndProcessFx($scope.dReqObj, "filter", false);
              // } else{
                $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
              // }
              // $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
            }
          }
        } else if($scope.selectedTab=="hub.devices.dg"){
          $scope.devices.devices = $filter("customSearch")($scope.dgDataCopy.devices, {key:$scope.search.text, module:'d'});
        }
      }
    }

    $scope.filterFx = function(type){
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.paginationControls.currPage = 1;

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.apiCalledArr = [];
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
        // $scope.firstApply.filter = true;
      } else{
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }
      localStorage.setItem("filterType", JSON.stringify($scope.filter));

      $scope.devicesLoading = true;
      if(!angular.isUndefined($scope.advSearchInfo) && !angular.isUndefined($scope.advSearchInfo.step)){
        $scope.getAdvSearchFx($rootScope.offset);
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        $scope.dReqObj = {caller:null,type:null,offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text};

        // if($scope.filter && $scope.filter != "all" && $scope.search.text.length == 0){
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "filter", false);
        // } else if($scope.search.text && $scope.search.text.length){
        //   $scope.getDeviceAndProcessFx($scope.dReqObj, "search", false);
        // } else {
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
        // }
      }

      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
        // localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      // $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if($scope.selectedTab != "hub.devices.di"){
        if(caller=='last'){
          $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
          $scope.visibleDevices = ($scope.visibleDevices == 0?$scope.auth.upreferences.dpc:$scope.visibleDevices)
        } else{
          $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
        }
      }

      // console.error($scope.devices, $scope.dData, $scope.curFolderId, $scope.fData, $scope.advSApply, $scope.dData.advObj);

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) && !$scope.advSApply)){
      // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.filter && $scope.filter != "all" && ((!$scope.dData.devices.length && !$scope.devices.devices.length) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.search.text && $scope.search.text.length && !$scope.devices.devices.length){
      // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
      // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.search.text && $scope.search.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.search.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }

    $scope.devicePreviewFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      $rootScope.closeAllFx("all");
    }
    $scope.removeSelectedFx = function(){
      $('.ui-selectable li').each(function(){
        $(this).removeClass('ui-selected');
        $(this).removeClass('ui-highlight');
      });
    }

    $scope.historyFx = function(){
      $scope.deletableHistory = [];
      $scope.innerLoading = true;
      DevicesSrv.getHistory().then(
        function(data){
          $scope.innerLoading = false;
          $scope.history = data;
          angular.forEach($scope.history, function(h){
            h.time = moment.utc(h.duration*1000).format('HH:mm:ss');
            h.isChecked = false;
            $scope.loadingMain = false;
          });
        },
        function(err){
          $scope.loadingMain = false;
          $log.error(err);
        }
      );
    }
    $scope.dASAllCheck = {box:false};
    $scope.dASAllFx = function(){
      $scope.dASAllBtnLoading = false;
      $scope.deviceBtn = [];
      $scope.dASAll = [];
      if($scope.dASAllCheck.box){
        $rootScope.closeAllFx("all");
        angular.forEach($scope.devices.info.allIds, function(item){
          $scope.dASAll.push({id:item, type:"device", subType:"device"});
        });
        $scope.dASAllBtnLoading = true;
        DevicesSrv.getDeviceBtn($scope.dASAll).then( /*Button api*/
          function(data){
            $scope.deviceBtn = data;
            $scope.dASAllBtnLoading = false;
            $scope.updateContextMenu($scope.deviceBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $scope.getAdvSearchFx = function(offset){
      // $scope.getSSStatus();
      $scope.advSearchInfo.offset = offset;
      if($scope.filter != "all" ){
        $scope.advSearchInfo.fil = angular.copy($scope.filter);
      } else{
        // $scope.advSearchInfo.fil = "all";
      }

      if($scope.advSearchInfo.fil == "all"){
        delete $scope.advSearchInfo.fil;
      }
      $scope.devicesLoading = true;
      CommonSrv.updateAdvSearch($scope.advSearchInfo, $scope.auth).then(
        function(data){
          $scope.devicesLoading = false;

          $scope.isGbdt = false;
          $scope.devices = data;
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          if($scope.auth.upermissions.dp || $scope.rdc > $scope.auth.upreferences.dpc){
            $scope.deviceSelectable();
          } else{
            $scope.brief = data;
          }
          if(!$scope.devices.info.pl){
            $scope.devices.info.pl = 0;
          }

          $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
          }
          $scope.updateList();
          $scope.setCountFx();
        },
        function(err){
          $log.error(err);
          $scope.searchProcessing = false;
        }
      );
    }

    $scope.openTypeFx = function(type, page, caller){w
      if(!caller){
        localStorage.setItem("filterType", JSON.stringify("all"));
      }
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      localStorage.setItem('curDType', JSON.stringify(type));
      $rootScope.advSearchArgObj = {};
      $scope.devicesLoading = true;
      $rootScope.selectedItems = [];
      $scope.breadCrumbs = [type];
      $scope.contextMenuOpt = [];
      $scope.advSearchInfo = {};
      $scope.search = {text:""};
      $scope.curDType = type;
      $scope.devices = {};
      $scope.brief = {};

      $rootScope.offset = 0;
      $scope.dReqObj = {caller:"gbdt",type:type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
      // DevicesSrv.getDevice("gbdt", type.type, $rootScope.offset, $scope.auth.upermissions.dp, $scope.filter).then(

      $scope.getDeviceAndProcessFx($scope.dReqObj, "openType", false);
    }

    $scope.deviceSelectable = function(){
      //push devices if selected with ctrl key
      if($rootScope.selectedItems.length > 0){
        angular.forEach($rootScope.selectedItems, function(item){
          $scope.isDuplicate = false;
          angular.forEach($rootScope.multiSelDevices, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $rootScope.multiSelDevices.push(item);
          }
        });
        $rootScope.tmpBriefDevices = $rootScope.multiSelDevices;
      }

      //add 'ui-selected' class to selected thumb
      setTimeout(function(){
        for(var i = 0; i < $rootScope.tmpBriefDevices.length; i++){
          angular.forEach(angular.element('.ui-selectable li'), function(item, count){
            if(count < $scope.devices.devices.length){
              if($rootScope.tmpBriefDevices[i].id == $(item).data("id")){
                $(item).addClass('ui-selected');
                $(item).find('input[type="checkbox"]').prop("checked", true);
              }
            }
          });
        }
      }, 100);
    }

    $rootScope.resetCheckedListFx = function(){
      $scope.unselectTypeFx();
    }

    $scope.unselectTypeFx = function(){
      $rootScope.tmpBriefDevices = [];
      $rootScope.multiSelDevices = [];
      $rootScope.selectedItems = [];
      $rootScope.curItems = [];
      $scope.contextMenuOpt = [];
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      setTimeout(function(){
        angular.forEach(angular.element('.ui-selectable li'), function(item){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        });
      }, 100);
    }

    $scope.avLic = 0;
    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
          $scope.avLic = data.l;
          if($scope.devices.info){
            $scope.devices.info.l = data.l;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.loadSelectedTab = function(caller, isOSet){
      $scope.updateDefineVariable();
      $rootScope.commonSearchVar = "";
      $scope.curNum = 1;
      $scope.isPageApiLoad = false;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if(caller=="changeView"){
        $rootScope.offset = 0;
      }

      // $scope.pagingObj = {count:6,/*count should be equal to or greater than 6 */ curPage:1, itemPerPage: 300, rightDots:false, showFirst:false, pageRange:[]};
      $scope.curTimestamp = moment().format('x');
      if($scope.auth.upreferences.sdtf){
        $scope.flag = {d:false,g:true,t:true};
      } else{
        $scope.flag = {d:true,g:true,t:true};
      }
      $scope.dASAllCheck.box = false;
      $scope.sendProcessing = false;
      $scope.deletableHistory = [];
      $scope.showDownload = false;
      $scope.isSsChecking = false;
      $scope.hasErr = false;
      $scope.curDType = "";
      $scope.dASAll = [];
      $scope.ssIds = [];

      $rootScope.offset = isOSet?$rootScope.offset:0;
      // $scope.getSSStatus();

      //reset selection
      // if($scope.auth.upermissions.dp){
        $scope.unselectTypeFx();
      // }

      //get current filter
      if($scope.selectedTab === "hub.devices.d"){
        $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
        // $scope.filterType = localStorage.getItem("filterType");

        if($scope.filterType && ($scope.filterType === "online" || $scope.filterType === "offline")){
          $scope.filter = $scope.filterType;
        } else{
          $scope.filter = "all";
        }
        localStorage.setItem("filterType", JSON.stringify($scope.filter));

        //if page refresh from browser and adv search was open
        if(angular.fromJson(localStorage.getItem("advSearchOpen"))){
          localStorage.removeItem("advSearchOpen");
        }
      } else{
        $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
        if($scope.filterType && $scope.filterType != "all"){}
        $rootScope.curItems = [];
        $rootScope.tmpBriefDevices = [];
        $rootScope.multiSelDevices = [];
      }

      $timeout.cancel($scope.ssTimer);
      $timeout.cancel($scope.refreshTimer);
      if(caller == "refresh"){
        $scope.totalDPages = 0;
        $scope.curNum = 0;
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        // $rootScope.deviceFilter = "all";
        $rootScope.advSearchArgObj = {};
        // $scope.filter = "all";
        if($scope.advSApply){
          $scope.curFolderId = 0;
          localStorage.removeItem("curDFId");
        }
        $scope.advSApply = false;
        $scope.advSearchInfo = {};
        $scope.advSearchInfo = undefined;

        $scope.loadingMain = true;
        localStorage.removeItem("addedDeviceGroupId");
        localStorage.removeItem("addedDeviceId");
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("fc");
        // localStorage.removeItem("filterType");
        $scope.firstApply.search = false;

        angular.element('.ui-selectable li').removeClass('ui-highlight');
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
      }


      if(caller !== "sort"){
        if($scope.selectedTab !== "hub.devices.d"){
          if(((!angular.isUndefined($scope.advSearchInfo) || (!angular.isUndefined($scope.advSearchInfo) && Object.keys($scope.advSearchInfo).length)))){
            if(!$rootScope.isObjectEmpty($scope.advSearchInfoCopy) && (!angular.isUndefined($scope.advSearchInfoCopy)) && $scope.advSearchInfoCopy.module == 'd'){
              localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfoCopy));
            }
            $scope.advSearchInfoCopy = angular.copy($scope.advSearchInfo);
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.isAdvSearch = false;
          } else{
            $scope.advSearchInfo = undefined;
            $scope.advSearch = false;
            $scope.isAdvSearch = false;
            $scope.advSearchInfoCopy = undefined;
          }
        } else{
          if(((!angular.isUndefined($scope.advSearchInfo) || (!angular.isUndefined($scope.advSearchInfo) && Object.keys($scope.advSearchInfo).length)))){
            if(!$rootScope.isObjectEmpty($scope.advSearchInfoCopy) && (!angular.isUndefined($scope.advSearchInfoCopy)) && $scope.advSearchInfoCopy.module == 'd'){
              localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfoCopy));
            } else if($scope.advSearchInfo.module=='d'){
              localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));
            }
            $scope.advSearchInfoCopy = angular.copy($scope.advSearchInfo);
            $scope.advSearch = true;
            $scope.isAdvSearch = true;
          } else{
            $scope.advSearchInfo = undefined;
            $scope.advSearch = false;
            $scope.isAdvSearch = false;
            $scope.advSearchInfoCopy = undefined;
            // localStorage.removeItem("isActionOnDevice");
          }
        }
        // $scope.advSearchInfo = {};
        // $scope.advSearch = false;
        // $scope.isAdvSearch = false;

      }
      if(caller == "home"){
        localStorage.removeItem("curDType");
        localStorage.removeItem("fc");
        $scope.breadCrumbs = [];
      }

      if($scope.curFolderId == 0){
        localStorage.setItem("inFolder", 0);
      }
      if(!$scope.isDBInfo){
        $scope.devicesLoading = true;
      }
      $rootScope.selectedItems = [];
      $scope.deletableTags = [];
      // Below code is commented because after apply advance search and normal search if user tries to applied sort below code clear the normal search
      // $scope.search.text = "";
      $scope.isGbdt = false;
      $scope.devices = {devices:[]};
      $scope.brief = {};

      if($scope.selectedTab === "hub.devices.d"){
        $scope.getTotalDeviceCountFx();

        if(angular.isUndefined($scope.curFolderId)){
          $scope.curFolderId = 0;
        }

        //get stored adv search data after search
        $scope.curFilterDlObj = angular.fromJson(localStorage.getItem("curFilterDlObj"));
        $scope.curAdvSearchCopy = angular.fromJson(localStorage.getItem("curAdvSearchCopy"));
        $scope.isDlAdvSearch = localStorage.getItem("isDlAdvSearch");
        $scope.isActionOnDevice = localStorage.getItem("isActionOnDevice");
        if(caller == "sort" && $scope.isDlAdvSearch){
          $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
          $scope.filter = $scope.filterType;

          if($scope.advObj.fil == "all"){
            delete $scope.advObj.fil;
          }
          $scope.advObj.offset = $rootScope.offset;
          //get stored adv search data after search
          CommonSrv.updateAdvSearch($scope.advObj, $scope.auth, $scope.search.text).then( //getDevice / loadMoreDevices
            function(data){
              // console.warn("update adva saer");
              $scope.folderList = [];
              $scope.asData = angular.copy(data);
              $scope.devices = angular.copy(data);
              if(data.info.rdc || data.info.rdc == 0){
                $scope.rdc = data.info.rdc;
                $scope.devices.info.rdc = data.info.rdc;
              }
              $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey($scope.devices);
              $scope.brief = data;
              if($scope.devices.info.pl == undefined){
                $scope.devices.info.pl = 0;
              }
              $scope.updateList();
              // $scope.checkOnDemandSS();
              $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));
              $scope.selectedTreeItem($scope.advSApply?0:$scope.curFolderId);
              // $scope.selectedTreeItem($scope.curFolderId);
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          // $rootScope.deviceFilter = "all";
          $scope.curDType = angular.fromJson(localStorage.getItem("curDType"));
          // get device types
          if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt' && !$scope.curDType){
            $scope.isGbdt = true;
            DevicesSrv.getDType().then( //getDevice / loadMoreDevices
              function(data){
                if(data.code == 12064){
                  $scope.auth.upermissions.gbdt = false;
                  localStorage.setItem('auth', JSON.stringify($scope.auth));
                  $scope.loadSelectedTab();
                } else{
                  $scope.devices = data;
                  $scope.brief = data;
                  $scope.updateList();
                  $scope.selectedTreeItem($scope.curFolderId);
                }
                $scope.loadingMain = false;
              },
              function(err){
                $scope.loadingMain = false;
                $log.error(err);
              }
            );
          }
          // get device of types
          else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt' && $scope.curDType){
            $scope.openTypeFx($scope.curDType, 0, "call");
          }
          // get devices
          else{
            // if(localStorage.getItem("isActionOnDevice")){
            //   localStorage.removeItem("isActionOnDevice");
            // }
            //store search state if edit
            // if($scope.isActionOnDevice){
            // if($scope.isActionOnDevice || !angular.isUndefined($scope.advSearchInfo)){

            if($scope.curAdvSearchCopy && $scope.curAdvSearchCopy.module == "cl"){
              $scope.advSearchInfoCopy = undefined;
              localStorage.removeItem("isActionOnDevice")
            }
            if($scope.isActionOnDevice || (!angular.isUndefined($scope.advSearchInfoCopy))){
            // if(!angular.isUndefined($scope.advSearchInfo)){
              if($scope.curAdvSearchCopy.dName || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.scheduleRange || $scope.curAdvSearchCopy.createdBy || $scope.curAdvSearchCopy.sName || $scope.curAdvSearchCopy.os || $scope.curAdvSearchCopy.tag.include.length > 0 || $scope.curAdvSearchCopy.tag.exclude.length > 0 || ($scope.curAdvSearchCopy.prop && $scope.curAdvSearchCopy.prop.value) || $scope.curAdvSearchCopy.userGroup.include.length > 0 || $scope.curAdvSearchCopy.userGroup.exclude.length > 0 || ($scope.curAdvSearchCopy.fil && $scope.curAdvSearchCopy.fil != 'all')){
                $scope.searchProcessing = true;
                $scope.curFilterDlObj = {name:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, type:$scope.curAdvSearchCopy.type, step:$scope.curAdvSearchCopy.step};

                if($scope.curAdvSearchCopy.fil == "all" || $scope.filter == "all"){
                  delete $scope.curAdvSearchCopy.fil;
                }
                $scope.curAdvSearchCopy.offset = 0;
                CommonSrv.updateAdvSearch($scope.curAdvSearchCopy, $scope.auth, $scope.search.text).then(
                  function(data){
                    $scope.searchProcessing = false;
                    $scope.filteredData = data;
                    $scope.devices = data;
                    $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
                    $scope.addTypeKey($scope.devices);
                    $scope.brief = data;
                    if($scope.devices.info.pl == undefined){
                      $scope.devices.info.pl = 0;
                    }
                    $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
                    $scope.curAdvSearchCopy.rdc = data.info.rdc;
                    $scope.curAdvSearchCopy.sortType = data.info.sortType;
                    $scope.curAdvSearchCopy.sortVal = data.info.sortVal;
                    $scope.curAdvSearchCopy.isLoadMore = false;
                    $scope.advSearchfilteredData = { info: $scope.curAdvSearchCopy, devices:$scope.filteredData.devices, content: $scope.filteredData.content, folder: $scope.filteredData.folder, code: data.code, advObj: $scope.curAdvSearchCopy, t:data.t, dInfo:data.info, deviceInfo:data.info};
                    $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                    $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));

                    if($scope.addedDeviceId){
                      setTimeout(function(){
                        angular.forEach(angular.element('.ui-selectable li'), function(item){
                          if($(item).attr('data-id') == $scope.addedDeviceId){
                            $(item).addClass('ui-highlight');
                          }
                        });
                      }, 100);
                    }
                  },
                  function(err){
                    $log.error(err);
                    $scope.searchProcessing = false;
                  }
                );
              }
            } else{
              localStorage.removeItem("isDlAdvSearch");
              localStorage.removeItem("curFilterDlObj");
              $scope.isGbdt = false;
              $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
              $scope.filter = $scope.filterType;
              $scope.dReqObj = {caller:null,type:null,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text};
              if($scope.selectedTab === "hub.devices.d"){
                $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
              }
            }
          }
        }
      } else if($scope.selectedTab === "hub.devices.dg"){
        DevicesSrv.getDeviceGroups().then(
          function(data){
            if($scope.selectedTab === "hub.devices.dg"){
              $scope.devices = {info:data.info, groups:data.groups, devices:data.groups, searches:data.searches};
              $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey(data);
              $scope.brief = $scope.devices;
              $scope.dgDataCopy = angular.copy($scope.devices);
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.addedDeviceGroupId = angular.fromJson(localStorage.getItem("addedDeviceGroupId"));
              if($scope.addedDeviceGroupId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.addedDeviceGroupId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.dt"){
        DevicesSrv.getDeviceTag().then(
          function(data){
            if($scope.selectedTab === "hub.devices.dt"){
              $scope.devices = {info:data.info, devices:data.deviceTags};
              $scope.brief = $scope.devices;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));
              if($scope.addedDeviceId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.addedDeviceId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.di"){
        $scope.devicesLoading = false;
        $scope.flagDGT = true;
        $scope.devices = {info:{durationType:"p", durationP:"60", deviceType:"a", devices:{assignedDevices:[], assignedGroups:[], assignedTags:[]}}, list:{}};
        $scope.resetCopy.info = angular.copy($scope.devices.info);
        $scope.brief = $scope.devices;
        if(caller != "refresh"){
          $rootScope.selectedT = $scope.auth.upreferences.sdtf ? 5 : $rootScope.selectedT;
        }

        $timeout(function(){
          if($scope.auth.upreferences.sdtf && $scope.auth.upermissions.da.ti && caller != "refresh"){
            $scope.tabFx(5, 'tabFx');
          } else{
            if($scope.auth.upermissions.da.sir){
              $scope.tabFx(1, 'tabFx');
            } else if($scope.auth.upermissions.da.is){
              $scope.tabFx(2, 'tabFx');
            } else if($scope.auth.upermissions.da.oi){
              $scope.tabFx(3, 'tabFx');
            } else if($scope.auth.upermissions.da.ti){
              $scope.tabFx(5, 'tabFx');
            } else if($scope.auth.upermissions.da.ar){
              $scope.tabFx(6, 'tabFx');
            } else if($scope.auth.upermissions.da.dp){
              $scope.tabFx(8, 'tabFx');
            } else if($scope.auth.upermissions.da.dt){
              $scope.tabFx(9, 'tabFx');
            } else if($scope.auth.upermissions.da.du){
              $scope.tabFx(10, 'tabFx');
            } else if($scope.auth.upermissions.da.dw){
              $scope.tabFx(11, 'tabFx');
            } else if($scope.auth.upermissions.emType=="cb"){
              $scope.tabFx(13, 'tabFx');
            } else{
              $scope.tabFx(12, 'tabFx');
            }
          }
        }, 50);
        if($rootScope.selectedT == 1){
          $scope.historyFx();
        }
      } else if($scope.selectedTab === "hub.devices.dvw"){
        $scope.devicesLoading = true;
        DevicesSrv.getVideoWalls().then(
          function(data){
            $scope.devices = {info:data.info, walls:data.videowalls};
            $scope.brief = $scope.devices;
            // $scope.updateList();
            $scope.devicesLoading = false;
            $scope.loadingMain = false;
            $scope.addedDeviceGroupId = angular.fromJson(localStorage.getItem("addedDeviceGroupId"));
            if($scope.addedDeviceGroupId){
              setTimeout(function(){
                angular.forEach(angular.element('.ui-selectable li'), function(item){
                  if($(item).attr('data-id') == $scope.addedDeviceGroupId){
                    $(item).addClass('ui-highlight');
                  }
                });
              }, 100);
            }
          },
          function(err){
            $scope.devicesLoading = false;
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      }
      // if(!$scope.filterType || $scope.filterType=="all"){
      //   $scope.filterType = "";
      // }
    }
    $scope.loadSelectedTab();

    $scope.resetArr = function(arr){
      var indexOfOne = arr.indexOf(1);
      var itemsToAdd = indexOfOne < 0 ? Math.abs(arr[0]) : 0;
      var addedItems = Array.from({ length: itemsToAdd }, function(_, index) { return index + 1; }).slice(-arr.length);
      return addedItems.concat(arr.map(function(value) { return value + itemsToAdd; }));
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2, targetList3){
      $scope.closeAllFx();
      // $scope.sortFx = function(obj){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      //reset pagination only
      $rootScope.offset = 0;
      CommonSrv.setSort({type:sortType,val:sortVal,module:moduleName}).then(
        function(data){
          $scope.loadSelectedTab("sort");
          $scope.reloadTree();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.contentListDBInfo = [];
    $scope.updateList = function(caller){
      if($scope.isDBInfo){
        $scope.contentLoading = false;
        $scope.openingLoading = false;
        $scope.breadCrumbsDBInfo = [];
        $scope.folderListDBInfo = [];
        $scope.tim = $scope.contentLibrary.info.timthumb;
        $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
        $scope.breadCrumbsDBInfo = $scope.contentLibrary.info.breadCrumbs;
        $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
        if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
          $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
        }
        $scope.folderListDBInfo = $scope.contentLibrary.contentLibrary.folder;
        $scope.curImages = [];
        $scope.curFiles = [];
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if((item.type == "Image" || (item.splType && item.splType == "Image") && (item.extn == "JPG" || item.extn == "PNG" || item.extn == "JPEG"))){
            $scope.curImages.push(item);
          }
          if(item.type == "WORD" || item.type == "Vector"){
            $scope.curFiles.push(item);
          }
        });
        $scope.contentListDBInfo = $scope.curImages.concat($scope.curFiles);
      } else{
        $scope.dASAll = [];
        if($rootScope.clearSearch){
          // $scope.search.text = "";
          // $scope.paginationControls.currPage = 1;
        }
        $scope.dASAllCheck.box = false;
        $scope.devicesLoading = false;
        $scope.folderList = [];
        $scope.treeList = [];
        $scope.contextMenuBaseFx();
        if($scope.devices.info){
          $scope.devices.info.l = $scope.avLic;
          $scope.tim = $scope.devices.info.timthumb;
          $scope.bucket = $scope.detailBucket = $scope.devices.info.bucket;
          if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
            $scope.detailBucket = $scope.devices.info.mbucket;
          }
        }

        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        }

        $scope.auth.upreferences.isDFTreeOpen = JSON.parse(localStorage.getItem("auth")).upreferences.isDFTreeOpen;
        // if($scope.selectedTab == "hub.devices.d" && $scope.auth.upreferences.isDFTreeOpen){
        if($scope.selectedTab == "hub.devices.d"){
          $scope.reloadTree();
        }
        if($scope.devices.info && $scope.devices.info.breadCrumbs){
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
        // if($scope.search.text && $scope.search.text.length){
        //   $scope.folderList = [];
        // }
        $scope.filterType = angular.fromJson(localStorage.getItem("filterType"));
        if(!$scope.devices.types){
          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
          }
        }
        // $scope.tabIndexFx("d");
      }
      $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));
      if($scope.addedDeviceId){
        setTimeout(function(){
          angular.forEach(angular.element('.ui-selectable li'), function(item){
            if($(item).attr('data-id') == $scope.addedDeviceId){
              $(item).addClass('ui-highlight');
            }
          });
        }, 100);
      }
    }

    // $scope.closeAllFx = function(){
    //   ngDialog.closeAll();
    //   $scope.unselectTypeFx();
    // }

    //open group device status popup before download
    $scope.openExpTagDevices = function(devices){
      $scope.confirmObj = {devices:devices, dsg:$scope.auth.upermissions.dsg};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
            <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
            <footer class="panel-footer padB10">\
              <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="expTagDevices();" ng-disabled="sendProcessing">{{"cm.btn.17" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.expTagDevices = function(){
      ngDialog.close();
      $scope.dsg = $scope.confirmObj.dsg?1:0;
      if($scope.selectedTab == "hub.devices.dg"){
        if($scope.expType != "search" || $scope.expType == ""){
          $scope.expType = "group";
        }
      } else if($scope.selectedTab == "hub.devices.dt"){
        $scope.expType = "tag";
      }
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      DevicesSrv.expTagDevices($scope.dataObj.id, $scope.expType, $scope.dsg).then(
        function(data){
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.selectTypeFx = function(e, selectedItems){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      $(".dType-list li.ui-selected").removeClass('ui-selected');
      $(e.currentTarget).addClass("ui-selected");
      $rootScope.selectedItems = [{type:selectedItems.type, label:selectedItems.label, subType:"folder"}];
      $scope.deviceBtn = {buttons:[{key:"dTypeOpen"}]};
      $scope.updateContextMenu($scope.deviceBtn);
    }

    // todo ==== Make this function common
    $scope.$on("$stateChangeStart", function(event, toState){
      // console.warn(event,toState);
      $rootScope.offset = 0;
      $scope.search.text = "";
      $rootScope.commonSearchVar = "";
      $scope.dASAll = [];
      $scope.breadCrumbs = [];
      $scope.contextMenuOpt = [];
      $scope.dASAllCheck.box = false;
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.curFolderId = localStorage.getItem("curDFId");
      $scope.loadSelectedTab();
      localStorage.removeItem("curDType");
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      localStorage.removeItem("fc");
      //reset adv search data if state change without edit widget
      if(toState.name != "hub.contentLibrary.c" && !localStorage.getItem("isDlAdvSearch")){
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      if($scope.selectedT == 'hub.devices.d'){
        $scope.selectPLFx(0);
      }
      $scope.acknowledgeCloseFx();
      if($scope.selectedTab !== "hub.devices.d" && $scope.selectedTab !== "hub.devices.dt" && $scope.selectedTab !== "hub.devices.dg" && $scope.selectedTab !== "hub.devices.di" && $scope.selectedTab !== "hub.devices.ds" && $scope.selectedTab !== "hub.devices.dvw"){
        $scope.advSearchInfo = undefined;
        $scope.advSearchInfo = {};
        localStorage.removeItem("isActionOnDevice")
      }
    });

    $scope.loadDevices = function(){
      if($scope.devices.devices.length == $scope.devices.info.totalCount){
        $scope.allDevicesLoaded = true;
      }
      if(!$scope.allDevicesLoaded){
        DevicesSrv.loadMoreDevices($scope.devices.devices.length).then(
          function(data){
            $scope.devices.devices = $scope.devices.devices.push(data.devices);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.briefUpdate = function(){
      if($scope.auth.upermissions.dp || $scope.totalDeviceOnServer > $scope.auth.upreferences.dpc){
        if($scope.briefSelectedItems.length == 1 && (angular.isUndefined($scope.curSelectedItem) || $scope.curSelectedItem.length == 0)){
          $scope.curSelectedItem = $filter("filter")($scope.brief.devices, {id:$rootScope.selectedItems[0].id}, true);
        }

        //check if thumb selected with ctrl key
        if($scope.ctrlKey && $rootScope.multiSelDevices.length > 0){
          //remove selected device with ctrl key
          angular.forEach($rootScope.multiSelDevices, function(item, i){
            angular.forEach($rootScope.unSelItems, function(id){
              if(item.id == id){
                $rootScope.multiSelDevices.splice(i, 1);
              }
            });
          });
          //add remaining devices in selected items
          angular.forEach($rootScope.multiSelDevices, function(item){
            $scope.isDuplicate = false;
            angular.forEach($rootScope.selectedItems, function(listItem){
              if(listItem.id == item.id){
                $scope.isDuplicate = true;
                return false;
              }
            });
            if(!$scope.isDuplicate){
              $rootScope.selectedItems.push(item);
            }
          });
        } else{
          $rootScope.multiSelDevices = [];
        }
        if($scope.briefSelectedItems.length == 1){
          DevicesSrv.getDeviceBrief($scope.briefSelectedItems[0].id).then(
            function(data){
              $scope.deviceBrief = angular.copy(data);
              $scope.deviceBrief.status = $scope.briefSelectedItems[0].status;
              $rootScope.curItems = $scope.briefSelectedItems;
              $scope.brief = {devices:[]};
              $scope.multiSelDevices = [];
              $rootScope.tmpBriefDevices = $scope.curSelectedItem;
              if($scope.auth.upreferences.deviceView == 'l'){
                $scope.curSelectedItem[0].dsk = $scope.deviceBrief.dsk;
                $scope.curSelectedItem[0].mem = $scope.deviceBrief.mem;
              }
              $scope.curSelectedItem[0].tv = $scope.deviceBrief.tv;
              $scope.brief.devices.push($scope.curSelectedItem[0]);
              $scope.curSelectedItem[0].eip = $scope.deviceBrief.eip;
              //get device property
              if($scope.deviceBrief.properties.length){
                $scope.executeArr = [];
                angular.forEach($scope.deviceBrief.properties, function(item){
                  if(item.label.toLowerCase().indexOf('RS232'.toLowerCase()) !== -1){
                    $scope.executeArr.push(item);
                  }
                });
              }

              //get appType for hd steth
              if($scope.deviceBrief.os==7){
                $scope.infoData = JSON.parse($scope.deviceBrief.info);
                angular.forEach($scope.infoData, function(info){
                  if(info.label == "AppType" && info.isEditable == false && info.value == "HD Steth"){
                    $scope.isInfoSteth = true;
                  }
                });
              }

              angular.forEach($scope.devices.devices, function(obj){
                if($scope.deviceBrief.id === obj.id){
                  obj.tv = $scope.deviceBrief.tv;
                }
              })
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.briefSelectedItems.length > 1){
          $scope.dReqObj = {caller:null,type:null,offset:0,isDP:false,filter:"all",isLV:($scope.auth.upreferences.deviceView=='l'?true:false)};
          // DevicesSrv.getDevice(null, null, 0, false, "all").then(
          // DevicesSrv.getDevice($scope.dReqObj).then(
          //   function(data){
          //     console.warn("AAAAAAAAAAAAAAAAAAAAADDDD", data);
          //     $scope.brief = {devices:data.devices};
          //     console.warn("SSSS", $scope.brief);
          //   },
          //   function(err){
          //     $log.error(err);
          //   }
          // );

          //add selected item in temp brief device array
          if($rootScope.selectedItems.length > 1){
            $rootScope.tmpBriefDevices = [];
            angular.forEach($rootScope.selectedItems, function(item){
              angular.forEach($scope.brief.devices, function(listItem){
                if(listItem.id == item.id){
                  $rootScope.tmpBriefDevices.push(listItem);
                }
              });
            });
          }
          $rootScope.curItems = angular.copy($scope.briefSelectedItems);
        }
      } else{
        if($scope.briefSelectedItems.length == 1){
          DevicesSrv.getDeviceBrief($scope.briefSelectedItems[0].id).then(
            function(data){
              $scope.deviceBrief = angular.copy(data);
              $scope.deviceBrief.status = $scope.briefSelectedItems[0].status;
              $scope.curSelectedItem[0].eip = $scope.deviceBrief.eip;
              $scope.curSelectedItem[0].tv = $scope.deviceBrief.tv;

              $scope.brief = {devices:[]};
              $scope.multiSelDevices = [];
              $rootScope.tmpBriefDevices = $scope.curSelectedItem;
              if($scope.auth.upreferences.deviceView == 'l'){
                $scope.curSelectedItem[0].dsk = $scope.deviceBrief.dsk;
                $scope.curSelectedItem[0].mem = $scope.deviceBrief.mem;
              }
              $scope.curSelectedItem[0].tv = $scope.deviceBrief.tv;
              $scope.brief.devices.push($scope.curSelectedItem[0]);
              $scope.curSelectedItem[0].eip = $scope.deviceBrief.eip;

              //get device property
              if($scope.deviceBrief.properties.length){
                $scope.executeArr = [];
                angular.forEach($scope.deviceBrief.properties, function(item){
                  if(item.label.toLowerCase().indexOf('RS232'.toLowerCase()) !== -1){
                    $scope.executeArr.push(item);
                  }
                });
              }

              //get appType for hd steth
              if($scope.deviceBrief.os==7){
                $scope.infoData = JSON.parse($scope.deviceBrief.info);
                angular.forEach($scope.infoData, function(info){
                  if(info.label == "AppType" && info.isEditable == false && info.value == "HD Steth"){
                    $scope.isInfoSteth = true;
                  }
                });
              }

              angular.forEach($scope.devices.devices, function(obj){
                if($scope.deviceBrief.id === obj.id){
                  obj.tv = $scope.deviceBrief.tv;
                }
              })
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }

      $scope.deviceBriefTicket = [];
      DevicesSrv.getTicketCount($scope.auth.sd.url + $scope.auth.sd.ep, $scope.briefSelectedItems[0].id, $scope.auth.server, $scope.auth.sd.envId).then(
        function(data){
          $scope.deviceBriefTicket = data;
        },
        function(err){
          $log.error(err);
        }
      );

      DevicesSrv.getDeviceBtn($rootScope.selectedItems).then( /*Button api*/
        function(data){
          $scope.deviceBtn = data;
          $scope.updateContextMenu($scope.deviceBtn);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $rootScope.curItems = [];
    $scope.briefFx = function(selectedItems){ /*Get devices Brief*/
      $scope.curTimestamp = moment().format('x');
      $scope.isInfoSteth = false;
      $scope.encId = $scope.hubEncrypt(selectedItems[0].id);
      $scope.decId = selectedItems[0].id;
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      $scope.dASAllCheck.box = false;
      $scope.contextMenuOpt = [];
      $scope.deviceBrief = [];
      $scope.deviceBtn = [];
      $scope.dASAll = [];
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if($scope.selectedTab === "hub.devices.d"){
        $scope.ctrlKey = $window.event.ctrlKey;
        $scope.briefSelectedItems = angular.copy(selectedItems);
        // if($scope.otherInfoDB.dAll){
        //   console.warn("AKKKKKKKK_1111 If ");
        //   $scope.getItemDB("dData", $rootScope.selectedItems[0].id, "brief");
        // } else {
        //   console.warn("AKKKKKKKK_1111 Else ");
          $scope.curSelectedItem = $filter("filter")($scope.devices.devices, {id:$rootScope.selectedItems[0].id}, true);
          $scope.briefUpdate();
        // }

      } else if($scope.selectedTab === "hub.devices.dt"){
        DevicesSrv.getDeviceTagsBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.deviceBtn = data;
            $scope.updateContextMenu($scope.deviceBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.dg"){
        if(selectedItems.length == 1){
          $scope.deviceBrief = {};
          if($rootScope.selectedItems[0].type == "search"){
            $scope.refreshObj = {l:true, b:false};
            DevicesSrv.getSearchBrief(selectedItems[0].id).then(
              function(data){
                $scope.deviceBrief = data;
                $scope.refreshObj = {l:false, b:true};
              },
              function(err){
                $log.error(err);
              }
            );
          } else{
            DevicesSrv.getDeviceGroupBrief(selectedItems[0].id).then(
              function(data){
                $scope.deviceBrief = data;
                // console.log($scope.deviceBrief);
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
        DevicesSrv.getDeviceGroupBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.deviceBtn = data;
            $scope.updateContextMenu($scope.deviceBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.dvw"){
        if(selectedItems.length == 1){
          DevicesSrv.getVideoWallBrief(selectedItems[0].id).then(
            function(data){
              $scope.deviceBrief = data;
            },
            function(err){
              $log.error(err);
            }
          );
        }
        // $scope.deviceBtn = {"info":[],"buttons":[{"key":"dvwEdit","label":"Edit"},{"key":"dvwDelete","label":"Delete"}]};
        // return
        DevicesSrv.getVideoWallBtn($rootScope.selectedItems).then( /*Button api*/
          function(data){
            $scope.deviceBtn = data;
            $scope.updateContextMenu($scope.deviceBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.checkAll = function(caller, event){
      if(caller == 'tag'){ //Not in used
        $scope.deletableTags = [];
        angular.forEach($scope.devices.deviceTags, function(tag){
          tag.isChecked = event.target.checked;
          if(event.target.checked){
            $scope.deletableTags.push(tag.id);
          }
        });
      } else if(caller == 'history'){
        $scope.deletableHistory = [];
        angular.forEach($scope.history, function(h){
          h.isChecked = event.target.checked;
          if(event.target.checked){
            $scope.deletableHistory.push(h.id);
          }
        });
      }
    }

    $scope.checkFx = function(caller){
      if(caller == 'history'){
        $scope.deletableHistory = [];
        angular.forEach($scope.history, function(h){
          if(h.isChecked){
            $scope.deletableHistory.push(h.id);
          }
        });
      }
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/devices/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }

    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function (menuItem) {
        if (menuItem.key == "dOpenFolder") {
          $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
        } else if (menuItem.key == "dEdit" || menuItem.key == "seEdit" || menuItem.key == "dEditFolder" || menuItem.key == "dvwEdit") {
          $scope.menuItemLabel = $filter("translate")('cm.btn.22'); //menuItem.label;
        } else if(menuItem.key == "tEdit"){
          $scope.menuItemLabel = $filter("translate")('d.tab.3');
        } else if(menuItem.key=="dPreview"){
          $scope.menuItemLabel = $filter("translate")('d.btn.7');
        } else if(menuItem.key=="dAddToGroup"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.29');
        } else if(menuItem.key=="dSimilar"){
          $scope.menuItemLabel = $filter("translate")('d.btn.10');
        } else if (menuItem.key == "dDelete" || menuItem.key == "dDeleteFolder") {
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key=="dtEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key=="dtDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key=="dgEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key=="dgDelete" || menuItem.key=="dvwDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key=="dTypeOpen"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.8');
        } else if (menuItem.key == "dMove") {
          $scope.menuItemLabel = $filter("translate")('cl.btn.6');
        } else if (menuItem.key == "dPin") {
          $scope.menuItemLabel = $filter("translate")('cm.label.98');
        }

        $scope.curIndex = $scope.contextMenuOpt.length;
        $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
        if(menuItem.key == "dEdit" || menuItem.key == "dgEdit" || menuItem.key == "dtEdit"){
          $scope.tempSubMenu = [];
          angular.forEach(menuItem.steps, function(subMenuItem){
            if(subMenuItem.key == "dStep1"){
              $scope.subMenu = $filter("translate")('d.btn.4');
            } else if(subMenuItem.key == "dStep2"){
              $scope.subMenu = $filter("translate")('d.btn.5');
            } else if(subMenuItem.key == "dStep3"){
              $scope.subMenu = $filter("translate")('d.btn.6');
            } else if(subMenuItem.key == "dtStep1"){
              $scope.subMenu = $filter("translate")('cm.brief.1');
            } else if(subMenuItem.key == "dtStep2"){
              $scope.subMenu = $filter("translate")('cm.label.31');
            } else if(subMenuItem.key == "dgStep1"){
              $scope.subMenu = $filter("translate")('cm.brief.1');
            } else if(subMenuItem.key == "dgStep2"){
              /*With tag*/
              $scope.subMenu = $filter("camelCase")($filter("translate")('d.btn.13'));
              /*Without tag*/
              // $scope.subMenu = $filter("camelCase")($filter("translate")('cm.label.31'));
            } else if(subMenuItem.key == "tStep1"){
              $scope.subMenu = $filter("translate")('fl.btn.5');
            } else if(subMenuItem.key == "tStep2"){
              $scope.subMenu = $filter("translate")('cm.btn.20');
            }
            $scope.tempSubMenu.push([$scope.subMenu, function($itemScope){$scope.contextMenuFx(subMenuItem);}]);
          });
          $scope.contextMenuOpt[$scope.curIndex].push($scope.tempSubMenu);
        }
      });
    }
    $scope.contextMenuFx = function (menuItem) {
      if (menuItem.key == "dOpenFolder") {
        $scope.folderContentFx($rootScope.selectedItems[0].id);
      } else if (menuItem.key == "dEdit" || menuItem.key == "dStep1" || menuItem.key == "dtEdit") {
        $state.go("hub.dContainer.dName", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      } else if (menuItem.key == "dStep2") {
        $state.go("hub.dContainer.dFrameLayout", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      } else if (menuItem.key == "dStep3") {
        $state.go("hub.dContainer.dTag", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      } else if(menuItem.key=="tEdit"){
        $scope.assignTagOpen();
      } else if (menuItem.key == "dPreview") {
        $scope.previewOpen();
      } else if(menuItem.key=="dAddToGroup"){
        $scope.addToGrpOpen();
      } else if(menuItem.key=="tStep1"){
        $scope.addRemoveTagOpen('a');
      } else if(menuItem.key=="tStep2"){
        $scope.addRemoveTagOpen('r');
      } else if(menuItem.key=="dtStep1"){
        $state.go("hub.dContainer.dtName", {id:$scope.hubEncrypt($rootScope.selectedItems[0].id)});
      } else if(menuItem.key=="dtStep2"){
        $state.go("hub.dContainer.dtDevice", {id:$scope.hubEncrypt($rootScope.selectedItems[0].id)});
      } else if(menuItem.key=="dSimilar"){
        $scope.similarOpen();
      } else if (menuItem.key == "dDelete" || menuItem.key == "dDeleteFolder") {
        if($rootScope.selectedItems.length==1 && $rootScope.selectedItems[0].type=='device'){
          $scope.deleteOpen("device");
        } else {
          $scope.deleteOpen("device", $rootScope.selectedItems[0].id, $rootScope.selectedItems);
        }
      } else if (menuItem.key == "dgEdit" || menuItem.key == "dgStep1") {
        $state.go("hub.dContainer.dgName", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      } else if (menuItem.key == "dgStep2") {
        $state.go("hub.dContainer.dgDevice", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      } else if (menuItem.key == "seEdit") {
        $scope.seEditFx();
      } else if(menuItem.key=="dtDelete"){
        $scope.deleteOpen('tag');
      } else if(menuItem.key=="dgDelete"){
        $scope.deleteOpen('group');
      } else if(menuItem.key=="dsDelete"){
        $scope.deleteOpen('search');
      } else if(menuItem.key=="dTypeOpen"){
        $scope.openTypeFx($scope.selectedItems[0], 0);
      }
      else if (menuItem.key == "dEditFolder") {
        $scope.folderCUOpen('n', "edit");
      }
      else if (menuItem.key == "dMove") {
        $scope.moveOpen($scope.selectedItems[0].id);
      }
      else if (menuItem.key == "dPin") {
        $scope.pinToDBFx($rootScope.selectedItems, 'd');
      }
      else if (menuItem.key == "dvwEdit") {
        $state.go("hub.dContainer.dvwName", { id: $scope.hubEncrypt($scope.deviceBrief.id) });
      }
      else if (menuItem.key == "dvwDelete") {
        $scope.deleteOpen('videowall');
      }
    }
    $scope.contextMenuBaseFx = function(){
      $scope.contextMenuBase = [];
      if($scope.auth.upermissions.d && $scope.selectedTab == "hub.devices.d" && $scope.devices.info.l > 0){
        $scope.contextMenuBase.push([$filter("translate")('d.btn.1'), function($itemScope){$state.go("hub.dContainer.dName");}]);
      } else if($scope.auth.upermissions.dg && $scope.selectedTab == "hub.devices.dg"){
        $scope.contextMenuBase.push([$filter("translate")('d.btn.2'), function($itemScope){$state.go("hub.dContainer.dgName");}]);
      } else if($scope.auth.upermissions.dt && $scope.selectedTab == "hub.devices.dt"){
        $scope.contextMenuBase.push([$filter("translate")('d.btn.3'), function($itemScope){$state.go("hub.dContainer.dtName")}]);
      }
      if($scope.selectedTab == "hub.devices.d" && $scope.auth.upermissions.df && $scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type=='df'){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.3"), function($itemScope){$scope.folderCUOpen('n');}]);
      }
    }

    $scope.editFx = function(id, fId, type, extn,label, splId, splType){
      $rootScope.tabView = false;
      $scope.tempId = $scope.hubEncrypt(id);
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
      }
      if(type == "Widget"){
        if(extn == "AGC"){
          $state.go("hub.contentAdd.widgetAddTab.agc", {
            id:$scope.tempId
          });
        } else if(extn == "Crop Comm: Alert Message"){
          $state.go("hub.contentAdd.widgetAddTab.alertMsg", {
            id:$scope.tempId
          });
        } else if(extn == "Achievers"){
          $state.go("hub.contentAdd.widgetAddTab.achievers", {
            id:$scope.tempId
          });
        } else if(extn == "Air Quality Index"){
          $state.go("hub.contentAdd.widgetAddTab.aqi", {
            id:$scope.tempId
          });
        } else if(extn == "Amazon QuickSight"){
          $state.go("hub.contentAdd.widgetAddTab.amazonQuickSight", {
            id:$scope.tempId
          });
        } else if(extn == "Auto Login (Basic Auth)"){
          $state.go("hub.contentAdd.widgetAddTab.autoLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id:$scope.tempId
          });
        } else if(extn == "Calendar of Events View"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coev", {
            id:$scope.tempId
          });
        } else if(extn == "Cisco Meraki"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            id:$scope.tempId
          });
        } else if(extn == "Content on Demand"){
          $state.go("hub.contentAdd.widgetAddTab.contentOnDemand", {
            id:$scope.tempId
          });
        } else if(extn == "Button"){
          $state.go("hub.contentAdd.widgetAddTab.codButton", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Events"){
          $state.go("hub.contentAdd.widgetAddTab.comEvent", {
            id:$scope.tempId
          });
        } else if(extn == "Pandora CloudCover"){
          $state.go("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            id:$scope.tempId
          });
        } else if(extn == "Content Group"){
          $state.go("hub.contentAdd.widgetAddTab.contentGroup", {
            id:$scope.tempId
          });
        } else if(extn == "Count"){
          $state.go("hub.contentAdd.widgetAddTab.count", {
            id:$scope.tempId
          });
        } else if(extn == "CoM Pylon Text"){
          $state.go("hub.contentAdd.widgetAddTab.comPylonText", {
            id:$scope.tempId
          });
        } else if(extn == "Cloud Farm"){
          $state.go("hub.contentAdd.widgetAddTab.cloudFarm", {
            id:$scope.tempId
          });
        } else if(extn == "Date Time"){
          $state.go("hub.contentAdd.widgetAddTab.dateTime", {
            id:$scope.tempId
          });
        } else if(extn == "Delimited Text"){
          $state.go("hub.contentAdd.widgetAddTab.delimitedText", {
            id:$scope.tempId
          });
        } else if(extn == "External Input"){
          $state.go("hub.contentAdd.widgetAddTab.externalInput", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Excel Sheet"){
          $state.go("hub.contentAdd.widgetAddTab.excelSheet", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook"){
          $state.go("hub.contentAdd.widgetAddTab.facebook", {
            id:$scope.tempId
          });
        } else if(extn == "Facebook Workplace"){
          $state.go("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            id:$scope.tempId
          });
        } else if(extn == "Fifa"){
          $state.go("hub.contentAdd.widgetAddTab.fifa", {
            id:$scope.tempId
          });
        } else if(extn == "Filler Content"){
          $state.go("hub.contentAdd.widgetAddTab.fillerContent", {
            id:$scope.tempId
          });
        } else if(extn == "Flight Schedule"){
          $state.go("hub.contentAdd.widgetAddTab.flightSchedule", {
            id:$scope.tempId
          });
        } else if(extn == "Free Form"){
          $state.go("hub.contentAdd.widgetAddTab.freeForm", {
            id:$scope.tempId
          });
        } else if(extn == "FTP"){
          $state.go("hub.contentAdd.widgetAddTab.ftp", {
            id:$scope.tempId
          });
        } else if(extn == "Fullscreen Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.fsChrome", {
            id:$scope.tempId
          });
        } else if(extn == "F45"){
          $state.go("hub.contentAdd.widgetAddTab.f45", {
            id:$scope.tempId
          });
        } else if(extn == "Blank"){
          $state.go("hub.contentAdd.widgetAddTab.blank", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Scroller"){
          $state.go("hub.contentAdd.widgetAddTab.contentScroller", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Content Tile"){
          $state.go("hub.contentAdd.widgetAddTab.contentTile", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Countdown Circle"){
          $state.go("hub.contentAdd.widgetAddTab.countdownCircle", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Hydrate"){
          $state.go("hub.contentAdd.widgetAddTab.hydrate", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Move Station"){
          $state.go("hub.contentAdd.widgetAddTab.moveStation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.f45progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Animation"){
          $state.go("hub.contentAdd.widgetAddTab.animation", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Progress Bar With Break"){
          $state.go("hub.contentAdd.widgetAddTab.f45progressBarWithBreak", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Stay"){
          $state.go("hub.contentAdd.widgetAddTab.stay", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Work"){
          $state.go("hub.contentAdd.widgetAddTab.work", {
            id:$scope.tempId
          });
        } else if(extn == "F45 Workout"){
          $state.go("hub.contentAdd.widgetAddTab.story", {
            id:$scope.tempId
          });
        } else if(extn == "Google Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.gCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Google Slide"){
          $state.go("hub.contentAdd.widgetAddTab.gSlide", {
            id:$scope.tempId
          });
        } else if(extn == "Grafana Cloud"){
          $state.go("hub.contentAdd.widgetAddTab.grafana", {
            id:$scope.tempId
          });
        } else if(extn == "HD Steth"){
          $state.go("hub.contentAdd.widgetAddTab.hdSteth", {
            id:$scope.tempId
          });
        } else if(extn == "IFrame"){
          $state.go("hub.contentAdd.widgetAddTab.iFrame", {
            id:$scope.tempId
          });
        } else if(extn == "Instagram"){
          $state.go("hub.contentAdd.widgetAddTab.instagram", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Circuit Bench"){
          $state.go("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            id:$scope.tempId
          });
        } else if(extn == "LinkedIn"){
          $state.go("hub.contentAdd.widgetAddTab.linkedIn", {
            id:$scope.tempId
          });
        } else if(extn == "Interactive Menu"){
          $state.go("hub.contentAdd.widgetAddTab.iMenu", {
            id:$scope.tempId
          });
        } else if(extn == "IoT Button"){
          $state.go("hub.contentAdd.widgetAddTab.iotButton", {
            id:$scope.tempId
          });
        } else if(extn == "Intel JCI Map"){
          $state.go("hub.contentAdd.widgetAddTab.jciMap", {
            id:$scope.tempId
          });
        } else if(extn == "Intel Smart Building"){
          $state.go("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            id:$scope.tempId
          });
        } else if(extn == "Live Streaming"){
          $state.go("hub.contentAdd.widgetAddTab.liveStreaming", {
            id:$scope.tempId
          });
        } else if(extn == "Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.meeting", {
            id:$scope.tempId
          });
        } else if(extn == "Message"){
          $state.go("hub.contentAdd.widgetAddTab.message", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams"){
          $state.go("hub.contentAdd.widgetAddTab.msTeams", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Rooms"){
          $state.go("hub.contentAdd.widgetAddTab.teamsRoom", {
            id:$scope.tempId
          });
        } else if(extn == "Music Choice"){
          $state.go("hub.contentAdd.widgetAddTab.musicChoice", {
            id:$scope.tempId
          });
        } else if(extn == "News"){
          $state.go("hub.contentAdd.widgetAddTab.news", {
            id:$scope.tempId
          });
        } else if(extn == "NextBus"){
          $state.go("hub.contentAdd.widgetAddTab.nextBus", {
            id:$scope.tempId
          });
        } else if(extn == "Next Vehicle"){
          $state.go("hub.contentAdd.widgetAddTab.nextVehicle", {
            id:$scope.tempId
          });
        } else if(extn == "Online Radio"){
          $state.go("hub.contentAdd.widgetAddTab.onlineRadio", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Outlook Calendar"){
           $state.go("hub.contentAdd.widgetAddTab.outlookCalendar", {
             id:$scope.tempId
           });
        } else if(extn == "LifeLabs Patient Wait"){
          $state.go("hub.contentAdd.widgetAddTab.patientWait", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Power BI"){
          $state.go("hub.contentAdd.widgetAddTab.powerBI", {
            id:$scope.tempId
          });
        } else if(extn == "Prayer"){
          $state.go("hub.contentAdd.widgetAddTab.prayer", {
            id:$scope.tempId
          });
        } else if(extn == "Open Hours"){
          $state.go("hub.contentAdd.widgetAddTab.openHours", {
            id:$scope.tempId
          });
        } else if(extn == "Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.progressBar", {
            id:$scope.tempId
          });
        } else if(extn == "Qlik"){
          $state.go("hub.contentAdd.widgetAddTab.qlik", {
            id:$scope.tempId
          });
        } else if(extn == "Queue"){
          $state.go("hub.contentAdd.widgetAddTab.queue", {
            id:$scope.tempId
          });
        } else if(extn == "Quotes"){
          $state.go("hub.contentAdd.widgetAddTab.quotes", {
            id:$scope.tempId
          });
        } else if(extn == "QR Code"){
          $state.go("hub.contentAdd.widgetAddTab.qrCode", {
            id:$scope.tempId
          });
        } else if(extn == "Readerboard"){
          $state.go("hub.contentAdd.widgetAddTab.readerboard", {
            id:$scope.tempId
          });
        } else if(extn == "RSS Feed"){
          $state.go("hub.contentAdd.widgetAddTab.rssFeed", {
            id:$scope.tempId
          });
        } else if(extn == "Schedule Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            id:$scope.tempId
          });
        } else if(extn == "Slack"){
          $state.go("hub.contentAdd.widgetAddTab.slack", {
            id:$scope.tempId
          });
        } else if(extn == "Firstup"){
          $state.go("hub.contentAdd.widgetAddTab.socialChorus", {
            id:$scope.tempId
          });
        } else if(extn == "Social Media"){
          $state.go("hub.contentAdd.widgetAddTab.socialMedia", {
            id:$scope.tempId
          });
        } else if(extn == "Stock Price"){
          $state.go("hub.contentAdd.widgetAddTab.stockPrice", {
            id:$scope.tempId
          });
        } else if(extn == "Storm"){
          $state.go("hub.contentAdd.widgetAddTab.storm", {
            id:$scope.tempId
          });
        } else if(extn == "Sun Smart"){
          $state.go("hub.contentAdd.widgetAddTab.sunSmart", {
            id:$scope.tempId
          });
        } else if(extn == "Survey"){
          $state.go("hub.contentAdd.widgetAddTab.survey", {
            id:$scope.tempId
          });
        } else if(extn == "Tableau"){
          $state.go("hub.contentAdd.widgetAddTab.tableau", {
            id:$scope.tempId
          });
        } else if(extn == "Telax"){
          $state.go("hub.contentAdd.widgetAddTab.telax", {
            id:$scope.tempId
          });
        } else if(extn == "Crawling Text" || extn == "Static Text"){
          $state.go("hub.contentAdd.widgetAddTab.text", {
            id:$scope.tempId
          });
        } else if(extn == "Traffic"){
          $state.go("hub.contentAdd.widgetAddTab.traffic", {
            id:$scope.tempId
          });
        } else if(extn == "TouchLink Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.touchLink", {
            id:$scope.tempId
          });
        } else if(extn == "Training Mode"){
          $state.go("hub.contentAdd.widgetAddTab.trainingMode", {
            id:$scope.tempId
          });
        } else if(extn == "TSC Country Mile"){
          $state.go("hub.contentAdd.widgetAddTab.tsccm", {
            // id:$scope.hubEncrypt($scope.tempId)
            id:$scope.tempId
          });
        } else if(extn == "X"){
          $state.go("hub.contentAdd.widgetAddTab.twitter", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Teams Channels"){
          $state.go("hub.contentAdd.widgetAddTab.teamsChannel", {
            id:$scope.tempId
          });
        } else if(extn == "Ungerboeck"){
          $state.go("hub.contentAdd.widgetAddTab.ungerboeck", {
            id:$scope.tempId
          });
        } else if(extn == "Unisys"){
          $state.go("hub.contentAdd.widgetAddTab.unisys", {
            id:$scope.tempId
          });
        } else if(extn == "Vimeo"){
          $state.go("hub.contentAdd.widgetAddTab.vimeo", {
            id:$scope.tempId
          });
        } else if(extn == "Weather"){
          $state.go("hub.contentAdd.widgetAddTab.weather", {
            id:$scope.tempId
          });
        } else if(extn == "Web Cam"){
          $state.go("hub.contentAdd.widgetAddTab.webCam", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login"){
          $state.go("hub.contentAdd.widgetAddTab.webLogin", {
            id:$scope.tempId
          });
        } else if(extn == "Web Login Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.webLoginChrome", {
            id:$scope.tempId
          });
        } else if(extn == "Web Page"){
          $state.go("hub.contentAdd.widgetAddTab.webPage", {
            id:$scope.tempId
          });
        } else if(extn == "Wait Queue Metro"){
          $state.go("hub.contentAdd.widgetAddTab.wqMetro", {
            id:$scope.tempId
          });
        } else if(extn == "webex by CISCO"){
          $state.go("hub.contentAdd.widgetAddTab.webex", {
            id:$scope.tempId
          });
        } else if(extn == "Xovis"){
          $state.go("hub.contentAdd.widgetAddTab.xovis", {
            id:$scope.tempId
          });
        } else if(extn == "Microsoft Viva Engage"){
          $state.go("hub.contentAdd.widgetAddTab.yammer", {
            id:$scope.tempId
          });
        } else if(extn == "YouTube"){
          $state.go("hub.contentAdd.widgetAddTab.youTube", {
            id:$scope.tempId
          });
        }else if(extn == "Verkada"){
          $state.go("hub.contentAdd.widgetAddTab.verkada", {
            id:$scope.tempId
          });
        }
      } else{
        $state.go("hub.tContainer.tName", {type:$scope.hubEnc("t"), id:$scope.tempId});
      }
    }
    $scope.contentEditOpen = function(id,label){
      $scope.editObj = {info:{id:id, label:label}};
      $scope.editBtnProcess = true;
      ContentLibrarySrv.getContentDetails(id).then(
        function(data){
          $scope.editBtnProcess = false;
          $scope.editObj.activePeriod = data.activePeriod;
          $scope.editObj.permission = data.permission;
          ngDialog.open({
            template:"app/contentLibrary/popup/contentEdit.html",
            width:680,
            scope:$scope,
            data:$scope.editObj,
            closeByDocument:false,
            controller:"ContentEditController",
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.setContentTimeFx = function(template){
      angular.forEach(template.frames, function(frame){
        if(frame.content.length){
          var startTime = 0;
          var tmpStartTime = 0;
          var tmpEndTime = 0;
          var endTime = 0;
          for (var i = 0; i < frame.content.length; i++){
            if(i == 0){
              tmpStartTime = startTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            } else{
              tmpStartTime = endTime;
              frame.content[i].startTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpStartTime), 'HH:mm:ss');
              tmpEndTime = endTime = endTime + frame.content[i].duration;
              frame.content[i].endTime = $filter('date')(new Date(1970, 0, 1).setSeconds(tmpEndTime), 'HH:mm:ss')
            }
          }
        }
      });
    }
    /*Search Edit*/
    $scope.seEditFx = function(){
      $scope.dSearchObj = $scope.decId;
      ngDialog.open({
        template:"app/devices/popup/dSearchEdit.html",
        width:650,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        controller:"DSearchCUController",
        preCloseCallback:function(caller){
          if(angular.isUndefined(caller)){
            $scope.loadSelectedTab();
          }
        }
      });
    }

    $scope.showDownloadFx = function(){
      $scope.showDownload = !$scope.showDownload;
      if($scope.showDownload){
        $scope.refreshListFx();
      } else{
        $timeout.cancel($scope.refreshTimer);
      }
    }

    $scope.refreshListFx = function(){
      $scope.refreshTimer = $timeout(function(){
        DevicesSrv.getRefreshList().then(
          function(data){
            if($scope.selectedTab === "hub.devices.d"){
              for(var i=0; i < $scope.devices.devices.length; ++i){
                for(var j=0; j < data.devices.length; ++j){
                  if(data.devices[j].id === $scope.devices.devices[i].id){
                    $scope.devices.devices[i].ss = data.devices[j].ss;
                    $scope.devices.devices[i].status = data.devices[j].status;
                    if(!data.devices[j].ss){
                      $scope.devices.devices[i].tv = data.devices[j].tv;
                    }
                    $scope.devices.devices[i].dp = data.devices[j].d;
                  }
                }
              }
              $scope.refreshListFx();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }, 15000);
    }

    $scope.checkOnDemandSS = function(){
      // $scope.ssIds = [];
      // angular.forEach($scope.devices.devices, function(item){
      //   // if(item.ss && $filter('isDeviceOnline')(item.lp, {minDeduct: $scope.auth.upreferences.dot})){ //old
      //   // if(item.ss && $filter('isDeviceOnline')(item.lp, {minDeduct: $scope.auth.upreferences.dot}) == 'online'){
      //   if(item.ss && item.status == 'online'){
      //     $scope.ssIds.push(item.id);
      //   }
      // });
      if($scope.ssIds.length > 0){
        $scope.getOnDemandSSFx();
      } else{
        $scope.deviceBrief.ssProcessing = false;
        $scope.isSsChecking = false;
      }
    }

    $scope.getOnDemandSSFx = function(){
      if(!$scope.isSsChecking){
        $scope.isSsChecking = true;
        $scope.ssTimer = $timeout(function(){
          if($scope.ssIds.length){
            DevicesSrv.getOnDemandSS($scope.ssIds).then(
              function(data){
                if($scope.selectedTab === "hub.devices.d"){
                  // for(var i=0; i < $scope.devices.devices.length; ++i){
                  //   for(var j=0; j < data.devices.length; ++j){
                  //     if(data.devices[j].id === $scope.devices.devices[i].id){
                  //       // $scope.devices.devices[i].ss = data.devices[j].ss;
                  //       // if(!data.devices[j].ss){
                  //         $scope.devices.devices[i].tv = data.devices[j].tv;
                  //         $scope.deviceBrief.tv = data.devices[j].tv;
                  //       // }
                  //     }
                  //   }
                  // }

                  angular.forEach($scope.devices.devices, function(obj){
                    angular.forEach(data.devices, function(val){
                      if(val.id === obj.id){
                        obj.tv = val.tv;
                        $scope.brief.devices[0].tv = val.tv;
                        $scope.brief.devices[0].ss = val.ss;
                        $scope.deviceBrief.tv = val.tv;
                        // $scope.deviceBrief.ss = val.ss;
                      }
                    })
                  })
                  if(!data.devices[0].ss){
                    $scope.deviceBrief.ssProcessing = false;
                    $scope.ssIds = [];
                  }
                  $scope.isSsChecking = false;
                  $scope.checkOnDemandSS();
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }, 10000);
      }
    }

    $scope.screenshotFx = function(id){
      DevicesSrv.onDemandSS({id:id}).then(
        function(data){
          if(data.status == "success"){
            $scope.ssIds.push(data.id);
            $scope.deviceBrief.ssProcessing = true;
            // angular.forEach($scope.devices.devices, function(device){
            //   if(device.id == data.id){
            //     device.ss = 1;
            //   }
            // });
            $scope.checkOnDemandSS();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Identify tab*/
    // $scope.flagDGT = true;
    if($scope.auth.upreferences.sdtf){
      $scope.flag = {d:false,g:true,t:true};
    } else{
      $scope.flag = {d:true,g:true,t:true};
    }
    $scope.sendProcessing = false;
    $scope.assignableDGTFx = function(type, caller){
      $scope.callListAPI = false;
      if($scope.flag.d && type == 'd'){
        $scope.callListAPI = true;
        $scope.scrollObjDyn = {caller: caller, offset: 0, id: 0, sortType: "l", sortVal: "asc"}
        DevicesSrv.getScrollListData($scope.scrollObjDyn).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreDataDyn = true;
            } else{
              $scope.haveMoreDataDyn = false;
            }
            $scope.totalDeviceCount = data.tc;
            angular.forEach(data.d, function(obj){
              obj.disabled = false;
            })
            $scope.scrollDataListDyn = data.d;
            $scope.allScrollDataListDyn = [];
            $scope.allScrollDataListDyn =  angular.copy($scope.scrollDataListDyn);
            $scope.flag.d = false;
          },
          function(err){
            $scope.flag.d = false;
            $log.error(err);
          }
        );
        // CommonSrv.getAvailDGT(type, caller).then(
        //   function(data){
        //     $scope.devices.list.devices = data.devices;
        //     if(data.devices.length){
        //       angular.forEach($scope.devices.list.devices, function(d){
        //         d.status = $filter('isDeviceOnline')(d.lp, {minDeduct: $scope.auth.upreferences.dot});
        //       });
        //     }
        //     $scope.resetCopy.list.devices = angular.copy($scope.devices.list.devices);
        //     $scope.flag.d = false;
        //   },
        //   function(err){
        //     $scope.flag.d = true;
        //     $log.error(err);
        //   }
        // );
      } else if($scope.flag.g && type == 'g'){
        CommonSrv.getAvailDGT(type, caller).then(
          function(data){
            $scope.devices.list.groups = data.groups;
            $scope.resetCopy.list.groups = angular.copy($scope.devices.list.groups);
            $scope.flag.g = false;
          },
          function(err){
            $scope.flag.g = true;
            $log.error(err);
          }
        );
      } else if($scope.flag.t && type == 't'){
        CommonSrv.getAvailDGT(type, caller).then(
          function(data){
            $scope.devices.list.tags = data.deviceTags;
            $scope.resetCopy.list.tags = angular.copy($scope.devices.list.tags);
            $scope.flag.t = false;
          },
          function(err){
            $scope.flag.t = true;
            $log.error(err);
          }
        );
      }
    }

    $scope.targetDevice = [];
    $rootScope.selectedTabFx = function(){
      $scope.curFolderId = 0;
      localStorage.removeItem("curDFId");
      if($scope.auth.upreferences.sdtf){
        $scope.flag = {d:false,g:true,t:true};
      } else{
        $scope.flag = {d:true,g:true,t:true};
      }
      $scope.resetSelDGTList();
      $scope.status.isopen = false;
      $scope.search.text = "";
      $rootScope.commonSearchVar = "";
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.acknowledgeCloseFx();
      $scope.deletableHistory = [];
      $scope.flagDGT = true;

      if($rootScope.selectedT == 1){/* Identify Request */
        if($rootScope.selectedT == 1 && $state.current.name === "hub.devices.di"){
        $scope.historyFx();
        $scope.resetFx();
        }
      } else if($rootScope.selectedT == 2){/* Device Settings */
        $scope.importLoading = false;
        $scope.innerLoading = true;

        $scope.dsInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.import = {s:"", t:[]};
        // CommonSrv.getAvailDGT(type, caller).then(
        //   function(data){
        //     $scope.devices.list.devices = data.devices;
        //     $scope.resetCopy.list.devices = angular.copy($scope.devices.list.devices);
        //     $scope.flag.d = false;
        //   },
        //   function(err){
        //     $scope.flag.d = true;
        //     $log.error(err);
        //   }
        // );
        // TODO As per the discursion we comment out the bellow code.
        // CommonSrv.getAvailDGT('d', "impTVS").then(
        //   function(data){
        //     if($rootScope.selectedT == 2 && $state.current.name === "hub.devices.di"){
        //       $scope.devicesList = [];
        //       $scope.importLoading = false;
        //       angular.forEach(data.devices, function (item){
        //         if(item.dt !== 7){
        //           $scope.devicesList.push(item);
        //           if($scope.targetDevice.length){
        //             angular.forEach($scope.targetDevice, function(item){
        //               if(item.selected){
        //                 item.selected = false;
        //               }
        //             });
        //           }
        //         }
        //       });
        //     }
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.importLoading = false;
        //   }
        // );
      } else if($rootScope.selectedT == 3){/* Other Info */
        $scope.duoInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 5){/* Tags Info */
        $scope.dutInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 8){
        $scope.dupInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 6){
        $scope.register = {exceldata:"", layoutId:""};
        $scope.fLayout = {data:""};
        $scope.innerLoading = true;
        $scope.layoutLoading = true;
        FrameLayoutsSrv.getApproved().then(
          function(data){
            if($rootScope.selectedT == 6 && $state.current.name === "hub.devices.di"){
            $scope.frameLayouts = data;
            $scope.layoutLoading = false;
            }
          },
          function(err){
            $log.error(err);
            $scope.layoutLoading = false;
          }
        );
      } else if($rootScope.selectedT == 9){
        $scope.dtInfo = {type:"d", dType:"a", onoff:true, devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 10){/* Data Usage */
        $scope.duInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 11){
        // $scope.dWMObj = ;
        $scope.minDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.dwInfo = {type:"d", dType:"a", s:{img:"", alignOpt:"a", align:"m-c", x:0,y:0,dateRange:{startDate:moment().subtract(0, "days").format("L"),endDate:moment().subtract(0, "days").format("L")}, bg:"#ffffff", bga:1, ctype:{bg:"monochrome"}}, devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 12){/* Other Info */
        $scope.dueInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[]}, exceldata:""};
        $scope.innerLoading = true;
      } else if($rootScope.selectedT == 13){/* Circuit Bench */
        $scope.innerLoading = true;
        $scope.getCBTime();
      }
    }
    $rootScope.copySelectedTabFx = $rootScope.selectedTabFx;
    $scope.frameAlignFx = function(val){
      $scope.dwInfo.s.align = val;
    }

    /*Device Settings*/
    $scope.dsUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dsInfo.exceldata){
        if($scope.dsInfo.type == "d" && $scope.dsInfo.dType == 'c' && !($scope.dsInfo.devices.device.length > 0 || $scope.dsInfo.devices.group.length > 0 || $scope.dsInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.46" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dsDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDSDownload = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dsInfo.dType == 'c' && !($scope.dsInfo.devices.device.length > 0 || $scope.dsInfo.devices.group.length > 0 || $scope.dsInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dsDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm ng-binding" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dsDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dsInfo.type!='u'){
        $scope.dsInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dsInfo.type=="d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      DevicesSrv.dsInfo($scope.dsInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.dsInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dsResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.dsResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dsInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    $scope.dwUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dwInfo.exceldata){
        if($scope.dwInfo.dType == 'c' && !($scope.dwInfo.devices.device.length > 0 || $scope.dwInfo.devices.group.length > 0 || $scope.dwInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else if($scope.dwInfo.exceldata == null || $scope.dwInfo.exceldata == ""){
          $scope.hasErr = true;
          $scope.errType = "upEmpty";
        } else{
          if($scope.validationOn){
            if($scope.dwInfo.s.img == null || $scope.dwInfo.s.img == ""){
              $scope.hasErr = true;
              $scope.errType = "wmImg";
            } else if(angular.isUndefined($scope.dwInfo.s.x) || angular.isUndefined($scope.dwInfo.s.y) || $scope.dwInfo.s.x < 0 || $scope.dwInfo.s.y < 0){
              $scope.hasErr = true;
              $scope.errType = "position";
            } else{
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"d.msg.59" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dwDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                      <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            }
          } else{
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"d.msg.59" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dwDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          }
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDwDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dwInfo.dType == 'c' && !($scope.dwInfo.devices.device.length > 0 || $scope.dwInfo.devices.group.length > 0 || $scope.dwInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dwDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dwDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dwInfo.type!='u'){
        $scope.dwInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dwInfo.type == "d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      $scope.dwInfo.s.dateRange = {
        startDate:moment($scope.dwInfo.s.dateRange.startDate).format("L"),
        endDate:moment($scope.dwInfo.s.dateRange.endDate).format("L")
      }

      DevicesSrv.dwInfo($scope.dwInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12072){
            $scope.hasErr = true;
            $scope.errType = "hdEmpty";
          } else if(data.code == 12073){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.dwInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dwResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }
    $scope.dwResetFx = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dwInfo = {type:"d", dType:"a", s:{img:"",alignOpt:"a", align:"m-c", x:0,y:0,dateRange:{startDate:moment().subtract(0, "days").format("L"),endDate:moment().subtract(0, "days").format("L")}, bg:"#ffffff", bga:1, ctype:{bg:"monochrome"}}, devices:{device:[], tag:[], group:[]}, exceldata:""};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }
    $scope.resetDwFileFx = function(){
      $('#excelFile').val('');
    }
    $scope.downloadDeviceListFx = function(val){
      var downloadObj = {type:"", subType:"", devices:[]};
      $scope.arraytoStringFx(val); /*Array to String common*/
      downloadObj.devices = $scope.stringIds;
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      DashboardSrv.postDowanloadExcel(downloadObj).then(
        function(data){
          if(data.code == 18009){
            $scope.hasErr = true;
            $scope.errType = "noData"
          } else{
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $log.error(err);
        }
      );
      return;
    }

    /*Download/Upload Other Info*/
    $scope.duoUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.duoInfo.exceldata){
        if($scope.duoInfo.dType == 'c' && !($scope.duoInfo.devices.device.length > 0 || $scope.duoInfo.devices.group.length > 0 || $scope.duoInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.29" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="duoDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDuoDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.duoInfo.dType == 'c' && !($scope.duoInfo.devices.device.length > 0 || $scope.duoInfo.devices.group.length > 0 || $scope.duoInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="duoDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm ng-binding" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.duoDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.duoInfo.type!='u'){
        $scope.duoInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.duoInfo.type == "d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      DevicesSrv.duoInfo($scope.duoInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
            ngDialog.close();
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12078){
            $scope.hasErr = true;
            $scope.errType = "heEmpty";
          } else if(data.code == 12095){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m14" | translate}}</span></div>\
                    <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\': \'{{getAvailableHeight(360)}}px\'}">\
                      <div class="row alt-row-bg padLR10">\
                        <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                          <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.duoInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.duoResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.duoResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.duoInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /*Download/Upload Edit device*/
    $scope.dueUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dueInfo.exceldata){
        if($scope.dueInfo.dType == 'c' && !($scope.dueInfo.devices.device.length > 0 || $scope.dueInfo.devices.group.length > 0 || $scope.dueInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.29" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dueDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDueDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dueInfo.dType == 'c' && !($scope.dueInfo.devices.device.length > 0 || $scope.dueInfo.devices.group.length > 0 || $scope.dueInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading">{{"cm.btn.17" | translate}}</header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dueDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dueDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dueInfo.type!='u'){
        $scope.dueInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dueInfo.type == "d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      DevicesSrv.dueInfo($scope.dueInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
            ngDialog.close();
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12078){
            $scope.hasErr = true;
            $scope.errType = "heEmpty";
          } else if(data.code == 12095){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m14" | translate}}</span></div>\
                    <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                      <div class="row alt-row-bg padLR10">\
                        <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                          <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else if(data.code == 12072){
            $scope.hasErr = true;
            $scope.errType = "hdEmpty";
          } else if(data.code == 12073){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.dueInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dueResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.dueResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dueInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /*Download/Upload Tags Info*/
    $scope.dutUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dutInfo.exceldata){
        if($scope.dutInfo.dType == 'c' && !($scope.dutInfo.devices.device.length > 0 || $scope.dutInfo.devices.group.length > 0 || $scope.dutInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.37" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dutDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDutDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dutInfo.dType == 'c' && !($scope.dutInfo.devices.device.length > 0 || $scope.dutInfo.devices.group.length > 0 || $scope.dutInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dutDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm ng-binding" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dutDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dutInfo.type!='u'){
        $scope.dutInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dutInfo.type == "d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }

      DevicesSrv.dutInfo($scope.dutInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12039){
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.p_dg.m11" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.error.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-6">{{"d.tab.1" | translate | camelCase}}</div>\
                        <div class="col-xs-6">{{"d.tab.3" | translate | camelCase}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="err in resData.error">\
                          <div class="col-xs-6 word-break">{{err.device.name}}</div>\
                          <div class="col-xs-6 word-break"><span ng-repeat="tag in err.tags">{{tag.name}}{{$last ? \'\' : \', \'}}</span></div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.resData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else if(data.code == 12042 || data.code == 12054 || data.code == 12069 || data.code == 12070){
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div ng-if="resData.code==\'12042\'">{{"d.p_dg.m4" | translate}}</div>\
                    <div ng-if="resData.code==\'12054\'">{{"d.msg.36" | translate}}</div>\
                    <div ng-if="resData.code==\'12069\'">{{"d.msg.35" | translate}}</div>\
                    <div ng-if="resData.code==\'12070\'">{{"d.msg.34" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.error.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="err in resData.error">\
                          <div class="col-xs-12 word-break" >{{err.device.name}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:580,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else if(data.code == 12079){
            $scope.resData = data;
            ngDialog.open({
              template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">\
                  <div>{{"d.msg.43" | translate}}</div>\
                  <div class="table marT15" ng-if="resData.data.length > 0">\
                    <div class="row th">\
                      <div class="col-xs-3">{{"d.body.15" | translate}}</div>\
                      <div class="col-xs-9">{{"cm.label.85" | translate}}</div>\
                    </div>\
                    <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                      <div class="row" ng-repeat="list in resData.data">\
                        <div class="col-xs-3 word-break">{{list.cell}}</div>\
                        <div class="col-xs-9 word-break">{{list.desc}}</div>\
                      </div>\
                    </div>\
                  </div>\
                </div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                </footer>\
              </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.resData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.dutInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dutResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.dutResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dutInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /*Download/Upload Properties*/
    $scope.dupUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dupInfo.exceldata){
        if($scope.dupInfo.dType == 'c' && !($scope.dupInfo.devices.device.length > 0 || $scope.dupInfo.devices.group.length > 0 || $scope.dupInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.48" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dupDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDupDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dupInfo.dType == 'c' && !($scope.dupInfo.devices.device.length > 0 || $scope.dupInfo.devices.group.length > 0 || $scope.dupInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dupDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm ng-binding" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dupDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dupInfo.type!='u'){
        $scope.dupInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dupInfo.type=="d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      DevicesSrv.dupInfo($scope.dupInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else if(data.code == 12095){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m16" | translate}}</span></div>\
                    <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                      <div class="row alt-row-bg padLR10">\
                        <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                          <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            if($scope.dupInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dupResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.dupResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dupInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /*Auto Registration*/
    $scope.fLayout = {data:""};
    $scope.autoRegFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.register.exceldata){
        if($scope.fLayout.data == ''){
          $scope.hasErr = true;
          $scope.errType = "fEmpty";
        } else{
          $scope.register.layoutId = $scope.fLayout.data.id;
          $scope.saveProcessing = true;
          DevicesSrv.saveRegistration($scope.register).then(
            function(data){
              $scope.saveProcessing = false;
              if(data.code == 12071){
                $scope.hasErr = true;
                $scope.errType = "fExist";
              } else if(data.code == 12072){
                $scope.hasErr = true;
                $scope.errType = "hdEmpty";
              } else if(data.code == 12073){
                $scope.hasErr = true;
                $scope.errType = "dEmpty";
              } else if(data.code == 12074){
                $scope.hasErr = true;
                $scope.errType = "exOrder";
              } else if(data.code == 12076){
                $scope.hasErr = true;
                $scope.errType = "noLic";
              } else if(data.code == 12090){
                $scope.hasErr = true;
                $scope.errType = "dupInfo";
              } else if(data.code == 12075){
                $scope.saveProcessing = false;
                $scope.resData = data;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <div>{{"d.msg.43" | translate}}</div>\
                        <div class="table marT15" ng-if="resData.data.length > 0">\
                          <div class="row th">\
                            <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                          </div>\
                          <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                            <div class="row" ng-repeat="list in resData.data">\
                              <div class="col-xs-12 word-break">{{list}}</div>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                      </div>\
                    </section>',
                  plain:true,
                  width:700,
                  scope:$scope,
                  closeByDocument:false,
                  className:"ngdialog-theme-default ngdialog-confirm"
                });
                return;
              } else if(data.code == 12095){
                $scope.curData = data;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m17" | translate}}</span></div>\
                        <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                          <div class="row alt-row-bg padLR10">\
                            <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                              <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                      </div>\
                    </section>',
                  plain:true,
                  width:500,
                  scope:$scope,
                  data:$scope.curData,
                  closeByDocument:false,
                  className:"ngdialog-theme-default ngdialog-confirm"
                });
              } else{
                $scope.autoRegResetFx();
              }
              if($scope.hasErr){
                $scope.excelResetFx();
              }
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.autoRegResetFx = function(){
      $('#excelFile').val('');
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.fLayout = {data:""};
      $scope.register = {exceldata:"", layoutId:""};
      $rootScope.resetSelDGTList();
    }

    $scope.isFDevice = {exist:false};
    $scope.folderContentFx = function (fId, splId, splType, caller) {
      if($scope.isDBInfo){
        // folderListDBInfo
        $scope.contentLoading = true;
        $scope.search = { text:"" };
        ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
          function(data){
            $scope.contentLibrary = data;
            $scope.flId = fId;
            $scope.advSearchDI = false;
            $scope.advSearchDInfo = {};
            $scope.updateList();
          },
          function(err){
            $scope.contentLoading = false;
            $log.error(err);
          }
        );
      } else{
        $rootScope.commonSearchVar = "";
        $scope.apiCalledArr = [];
        $scope.advSApply = false;
        $scope.curNum = 0;
        if(!caller || caller != "changeView"){
          $scope.search = { text: "" };
        }
        if(caller=="changeView"){
          $rootScope.offset = 0;
        }

        $scope.paginationControls.currPage = 1;
        //if Device brief info popup opened

        $scope.statusObj.d = false;
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("fc");
        $scope.isAdvSearch = false;
        $scope.advSearchInfo = undefined;
        // $scope.advSearchInfo = {};
        $rootScope.advSearchArgObj = {};
        // ?New: this "if" code is for device folder
        if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df' && $scope.selectedTab !== "hub.devices.di") {
          // $scope.breadCrumbs = [];
          // $scope.filter = "all";
          // $cookies.remove("filterType");
          // localStorage.removeItem("filterType");
          $scope.paginationControls.currPage = 1;
          $rootScope.offset = 0;

          $scope.devicesLoading = true;
          $rootScope.selectedItems = [];
          // $cookies.remove("curPathId");
          // $cookies.remove('curSPlObj');
          // $cookies.remove("curDFId");
          localStorage.removeItem("curPathId");
          localStorage.removeItem("curSPlObj");
          localStorage.removeItem("curDFId");
          $scope.advSearch = false;
          $scope.curFolderId = 0;

          if($scope.auth.upermissions.dp || $scope.rdc > $scope.auth.upreferences.dpc){
            $scope.unselectTypeFx();
          }

          if (fId == 0) {
            $scope.breadCrumbs = [];
          }
          if (fId) {
            // $cookies.put("curDFId", fId);
            localStorage.setItem("curDFId", fId);
            // $scope.curFolderId = $cookies.get("curDFId");
            $scope.curFolderId = localStorage.getItem("curDFId");
          }

          if ($scope.curFolderId == 0) {
            // $cookies.put("inFolder", 0);
            localStorage.setItem("inFolder", 0);
            localStorage.setItem("curDFId", 0);
            localStorage.removeItem("curPathFId");
          }

          if(!$scope.auth.upermissions.dp){
            $rootScope.offset = 0;
          }

          $scope.selectedTreeItem($scope.curFolderId);
          // DevicesSrv.getFolderData(fId, $rootScope.offset, "", "", $scope.filterType).then(
          $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
          if($scope.filterType != "all"){
            // $scope.otherInfoDB.dAll = false;
            $scope.filterIsAppliedAlready = true;
          }


          $scope.folObj = {fId:fId, offset:0, obj:null, caller:null,filType:$scope.filterType,text:$scope.search.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};
          // DevicesSrv.getFolderData(fId, $scope.dOffset, "", "", $scope.filterType, $scope.search.text).then(
          DevicesSrv.getFolderData($scope.folObj).then(
            function (data) {
              $scope.flId = fId;
              $scope.devicesLoading = false;
              $scope.devices = angular.copy(data);

              if(fId == 0){
                $scope.isFDevice.exist = false;
              } else {
                if(data.devices.length > 0){
                  $scope.isFDevice.exist = true;
                }
              }
              $scope.copyFolderList = data.folders;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.rdc = data.info.rdc;
              }
              $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey($scope.devices);
              // if($scope.search.text && $scope.search.text.length){
              //   $scope.sData = angular.copy($scope.devices)
              // } else {
              //   $scope.dData = angular.copy($scope.devices)
              //   if($scope.filter && $scope.filter != 'all'){
              //     $scope.fData = angular.copy($scope.devices);
              //   }
              // }
              $scope.dData = angular.copy($scope.devices)

              $scope.searchTotal = angular.copy($scope.devices.info.count?$scope.devices.info.count:$scope.devices.devices.length);
              $scope.brief = data;
              $scope.setCountFx();

              // commented it to fix dot issue
              // if(data.info.rdc){
              //   $scope.rdc = data.info.rdc;
              // }

              // $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
              if(!$scope.filterType || $scope.filterType=="all"){
                $scope.filterType = "";
                $scope.fCount = $scope.devices.devices;
              } else {
                $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
              }
              // if($scope.rdc > 0 && ($scope.rdc == $scope.dData.devices.length)){
              if($scope.dData.info){
                $scope.dData.info.id = 0;
              }
              $scope.addedDeviceId = angular.fromJson(localStorage.getItem("addedDeviceId"));
              if($scope.addedDeviceId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.addedDeviceId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }

              $scope.updateList();

            },
            function (err) {
              $scope.devicesLoading = false;
              $log.error(err);
            }
          );
        } else {
          // ?this was old code no change
          $scope.contentLoading = true;
          $scope.search = { text: "" };
          ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
            function (data) {
              $scope.flId = fId;
              $scope.contentLibrary = data;
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
              $scope.updateListContentFx();
            },
            function (err) {
              $scope.contentLoading = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.excelResetFx = function(){
      $('#excelFile').val('');
      $scope.curData = {};
      if($scope.selectedT == 2){
        $scope.dsInfo.exceldata="";
      } else if($scope.selectedT == 3){
        $scope.duoInfo.exceldata = "";
      } else if($scope.selectedT == 5){
        $scope.dutInfo.exceldata = "";
      } else if($scope.selectedT == 8){
        $scope.dupInfo.exceldata = "";
      } else if($scope.selectedT == 6){
        $scope.register.exceldata = "";
      } else if($scope.selectedT == 9){
        $scope.dtInfo.exceldata = "";
      } else if($scope.selectedT == 10){
        $scope.duInfo.exceldata = "";
      } else if($scope.selectedT == 12){
        $scope.dueInfo.exceldata = "";
      } else if($scope.selectedT == 11){
        $scope.dwInfo.exceldata = "";
      }
    }

    $scope.getSampleFileFx = function(){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx('d');
      DevicesSrv.getSampleFile().then(
        function(data){
          if(data.url){
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }


    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      if($scope.selectedT == 2 || $scope.selectedT == 5 || $scope.selectedT == 6 || $scope.selectedT == 8 || $scope.selectedT == 9 || $scope.selectedT == 10){
        $scope.emptyRow = "?getEmptyRow=1";
        if($scope.selectedT == 6){
          $scope.emptyRow = "?getEmptyRow=1&isCalledFrom=ar";
        } else if($scope.selectedT == 8){
          $scope.emptyRow = "?getEmptyRow=1&isCalledFrom=prop";
        } else if($scope.selectedT == 10){
          $scope.emptyRow = "?getEmptyRow=1&isCalledFrom=du";
        } else if($scope.selectedT == 2 || $scope.selectedT == 9){
          $scope.emptyRow = "?getEmptyRow=1&isCalledFrom=tvinfo";
        } else if($scope.selectedT == 5){
          $scope.emptyRow = "?getEmptyRow=1&return=raw";
        }
      }
      if($scope.selectedT == 3){
        $scope.emptyRow = "?isCalledFrom=oi";
      }
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }else{
            if($scope.selectedT == 11){
              $scope.isWMExist = false;
              angular.forEach(data.head.columns, function(col, i){
                if(col.label.replace(/\s/g, '').toLowerCase()=="watermarkstatus"){
                  $scope.colIndex = i;
                  $scope.isWMExist = true;
                }
              });
              if($scope.isWMExist){
                angular.forEach(data.row, function(rowItem, i){
                  if(rowItem.columns[$scope.colIndex].label){
                    $scope.rowLabel = rowItem.columns[$scope.colIndex].label;
                    if($scope.rowLabel.toLowerCase()=="yes"){
                      $scope.validationOn = true;
                      return false;
                    }
                  }
                });
              }
            }
            $scope.fileModelLoading = false;
            ngDialog.close();
            if(data.code == 17070){
              $scope.hasErr = true;
              $scope.errType = "exIssue";
              $scope.excelResetFx();
            } else if($scope.selectedT == 11 && !$scope.isWMExist){
              $scope.hasErr = true;
              $scope.errType = "exOrder";
              $scope.excelResetFx();
            } else{
              $scope.convertData = data;
              if(data && ((data.head && data.head.length > 0) || (data.row && data.row.length > 0))){
                if($scope.selectedT == 2){
                  $scope.dsInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT == 5){
                  $scope.dutInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT==6){
                  $scope.register.exceldata = $scope.convertData;
                } else if($scope.selectedT==8){
                  $scope.dupInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT==9){
                  $scope.dtInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT==10){
                  $scope.duInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT==12){
                  $scope.dueInfo.exceldata = $scope.convertData;
                } else if($scope.selectedT==11){
                  $scope.dwInfo.exceldata = $scope.convertData;
                } else{
                  $scope.duoInfo.exceldata = $scope.convertData;
                }
              }
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    /*Lock Screen*/
    $scope.updateListContentFx = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      // $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }

      if($scope.isInfoDialog.open || $scope.isDBInfo){
        $scope.folderListDBInfo = $scope.contentLibrary.contentLibrary.folder;
        $scope.breadCrumbsDBInfo = $scope.contentLibrary.info.breadCrumbs;
        $scope.contentListDBInfo = [];
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Image" || (item.splType && item.splType == "Image")){
            $scope.contentListDBInfo.push(item);
          }
        });
      } else {
        $scope.breadCrumbs = [];
        $scope.folderList = [];
        if($scope.contentLibrary.info.breadCrumbs){
          $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
        }
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
        $scope.contentList = [];
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(item.type == "Image" || (item.splType && item.splType == "Image")){
            $scope.contentList.push(item);
          }
        });
        // $scope.getAllDevices();
      }
    }

    $scope.curDInfoIndex =  null;
    $scope.selectContentOpen = function(index){
      // console.warn("index", index, $scope.isDBInfo);
      $scope.isDBInfo = false;
      $scope.curDInfoIndex =  null;
      $scope.useContentErr = {empty:false};
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      if(!angular.isUndefined(index)){
        $scope.curDInfoIndex =  index;
        $scope.isDBInfo = true;
        $scope.isInfoDialog.open = true;
        $scope.advSearchDInfo = {};
        $scope.advSearchDI = false;
      } else {
        $scope.advSearchInfo = {};
        $scope.advSearch = false;
        $scope.searchInfo = {text:""};
      }
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateListContentFx();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      if($scope.isDBInfo){
        $scope.loading = false;
        $scope.dialog.info = ngDialog.open({
          template:'app/contentLibrary/widgets/popup/selectSingleContentDInfo.html',
          width:845,
          scope:$scope,
          closeByDocument:false,
          preCloseCallback:function(){
            if (!$scope.$$phase) {
              $scope.$apply(function(){
                $scope.isInfoDialog.open = false;
                if(!$scope.advSearch){
                  $scope.advSearchInfo = {}
                }
              });
            } else {
              // $apply is already running
              $scope.isInfoDialog.open = false;
              if(!$scope.advSearch){
                $scope.advSearchInfo = {}
              }
            }
            if($scope.advSearchInfo && $scope.advSearchInfo.module == 'd'){
              $scope.advSApply = true;
            } else {
              $scope.advSApply = false;
            }
            // $scope.advSApply = false;
            // $scope.advSearchInfo = undefined;
            // localStorage.removeItem("isActionOnDevice")
          }
        });
      } else {
        ngDialog.open({
          template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
          width:845,
          scope:$scope,
          closeByDocument:false,
          preCloseCallback:function(){
            if(!$scope.advSApply && $scope.advSearchInfo && $scope.advSearchInfo.module == 'cl'){
              $scope.advSearchInfo = {};
              $scope.advSearchInfo = undefined;
            }
          }
        });
      }

    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        $scope.contentList = $scope.isDBInfo ? $scope.contentListDBInfo : $scope.contentList
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              btnExtn:listItem.btnExtn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible,
              url:listItem.url
            };
            if($scope.curDInfoIndex != null && !angular.isUndefined($scope.curDInfoIndex)){
              $scope.curBg.isAccessible = true;
              $scope.curBg.duration = listItem.duration;
            }
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.curDevicesLS = {};
    $scope.useContentFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        if($rootScope.selectedT == 11){
          $scope.dwInfo.s.img = $scope.curBg;
        } else{
          $scope.curLSBg = $scope.curBg;
          $scope.curDevicesLS.cid = $scope.curLSBg.id;
        }
        // ngDialog.close($scope.diaId.id);
        if($scope.curDInfoIndex != null && !angular.isUndefined($scope.curDInfoIndex)){
          $scope.device.info.info[$scope.curDInfoIndex].vFile = $scope.curBg;
          ngDialog.close($scope.dialog.info.id);
        }else{
          ngDialog.close();
        }
      }
    }
    $scope.removeBgFx = function(){
      $scope.curDevicesLS.cid = "";
      $scope.curLSBg = {};
      $scope.dwInfo.s.img = "";
    }

    $scope.lsSaveFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!$scope.devicesLS.assignedDevices.length){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else if(angular.isUndefined($scope.curDevicesLS.cid)){
        $scope.hasErr = true;
        $scope.errType = "ls";
      } else{
        $scope.curDevicesLS.devices = $scope.devicesLS.assignedDevices;
        $scope.saveProcessing = true;
        DevicesSrv.saveLockScreen($scope.curDevicesLS).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 12062){
              $scope.curLSDevices = {availableDevices:[], assignedDevices:[]};
              $scope.devicesLS = {availableDevices:[], assignedDevices:[]};
              $scope.devicesLS.availableDevices = $scope.devicesLSCopy;
              $scope.curDevicesLS = {};
              $scope.curLSBg = {};
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    /**Device Timer On/Off*/
    $scope.openDTDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dtInfo.dType == 'c' && !($scope.dtInfo.devices.device.length > 0 || $scope.dtInfo.devices.group.length > 0 || $scope.dtInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dtDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm ng-binding" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.dtDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.dtInfo.type!='u'){
        $scope.dtInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.dtInfo.type=="d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }
      DevicesSrv.dtInfo($scope.dtInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12046){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12045){
            $scope.hasErr = true;
            $scope.errType = "gtEmpty";
          } else if(data.code == 12066){
            $scope.hasErr = true;
            $scope.errType = "exIssue";
          } else if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.dtInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.dtResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    // On/Off Schedule
    $scope.dtUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.dtInfo.exceldata){
        if($scope.dtInfo.type == "d" && $scope.dtInfo.dType == 'c' && !($scope.dtInfo.devices.device.length > 0 || $scope.dtInfo.devices.group.length > 0 || $scope.dtInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.52" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="dtDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }

    }

    $scope.dtResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.dtInfo = {type:"d", dType:"a", onoff:true, devices:{device:[], tag:[], group:[]}, exceldata:""};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /*Download/Upload Data Usage*/
    $scope.duUploadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.duInfo.exceldata){
        if($scope.duInfo.dType == 'c' && !($scope.duInfo.devices.device.length > 0 || $scope.duInfo.devices.group.length > 0 || $scope.duInfo.devices.tag.length > 0)){
          $scope.hasErr = true;
          $scope.errType = "device";
        } else{
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body">{{"d.msg.53" | translate}}</div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="duDownloadFx();" ng-disabled="sendProcessing"><span class="fa fa-repeat fa-spin" ng-if="sendProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        }
      } else{
        $scope.hasErr = true;
        $scope.errType = "upEmpty";
      }
    }

    $scope.openDuDownload = function(){
      $scope.getDsgValueInAction();
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.duInfo.dType == 'c' && !($scope.duInfo.devices.device.length > 0 || $scope.duInfo.devices.group.length > 0 || $scope.duInfo.devices.tag.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        // $scope.confirmObj = {dsg:$scope.auth.upermissions.dsg};
        $scope.getDsgValueInAction();
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.btn.17" | translate}}</h1></header>\
              <div class="panel-body"><div><label class="text-unbold"><input type="checkbox" ng-model="confirmObj.dsg" role="checkbox"><label></label>{{\'d.msg.33\' | translate}}</label></div></div>\
              <footer class="panel-footer padB10">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="duDownloadFx();" ng-disabled="sendProcessing">{{"d.btn.24" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false
        });
      }
    }

    $scope.duDownloadFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.sendProcessing = true;
      if($scope.duInfo.type!='u'){
        $scope.duInfo.dsg = $scope.confirmObj.dsg?1:0;
        ngDialog.close();
      }
      if($scope.duInfo.type == "d"){
        $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
        $scope.linkOpenFx('d');
      }

      DevicesSrv.duInfo($scope.duInfo).then(
        function(data){
          $scope.sendProcessing = false;
          if(data.code){
            ngDialog.close();
          }
          if(data.code == 12067){
            $scope.hasErr = true;
            $scope.errType = "noDevice";
          } else if(data.code == 12072){
            $scope.hasErr = true;
            $scope.errType = "hdEmpty";
          } else if(data.code == 12073){
            $scope.hasErr = true;
            $scope.errType = "dEmpty";
          } else if(data.code == 12074){
            $scope.hasErr = true;
            $scope.errType = "exOrder";
          } else if(data.code == 12075){
            $scope.saveProcessing = false;
            $scope.resData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.msg.43" | translate}}</div>\
                    <div class="table marT15" ng-if="resData.data.length > 0">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.ar.1" | translate | capitalize}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="list in resData.data">\
                          <div class="col-xs-12 word-break">{{list}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
            return;
          } else{
            if($scope.duInfo.type == "d"){
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            } else{
              ngDialog.close();
            }
            $scope.duResetFx();
          }
          if($scope.hasErr){
            $scope.excelResetFx();
          }
        },
        function(err){
          $log.error(err);
          $scope.sendProcessing = false;
        }
      );
    }

    $scope.duResetFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curData = {};
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.brief = $scope.devices;
      $scope.duInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
    }

    /**Import Setting*/
    $scope.selectedTPop = 1;
    $scope.tabPopFx = function(caller){
      $scope.selectedTPop = caller;
      $scope.viewSettingsFx();
    }
    $scope.viewSettingsFx = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.import.s.id){
        $scope.tabLoading = true;
        if(caller || $scope.selectedTPop == 1){
          DeviceControlSrv.getDeviceControl($scope.import.s.id).then(
            function(data){
              $scope.tabLoading = false;
              $scope.viewData = {label:$scope.import.s.l, info:data};
              $scope.viewData.info.pass = $scope.decryptFx($scope.viewData.info.pass);
              if(caller){
                $scope.webOS = "";
                $scope.selectedTPop = 1;
                ngDialog.open({
                  template:'app/devices/popup/viewSettings.html',
                  width:650,
                  data:$scope.viewData,
                  scope:$scope,
                  closeByDocument:false
                });
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          DeviceControlSrv.getWebOS($scope.import.s.id).then(
            function(data){
              $scope.tabLoading = false;
              if(data){
                $scope.webOS = data;
                if($scope.webOS.gs.as.tvt){
                  angular.forEach($scope.webOS.gs.as.days, function(day){
                    day.st = $filter("momentTime")(day.st);
                    day.et = $filter("momentTime")(day.et);
                  });
                }
              }
            }, function(err){
              $log.error(err);
              $scope.tabLoading = false;
            }
          );
        }
      } else{
        $scope.errType = "sDevice";
        $scope.hasErr = true;
      }
    }

    $scope.getTargetDeviceFx = function(){
      $scope.status.isopen = false;
      $scope.targetDLoading = true;
      // DevicesSrv.getTargetDevice($scope.import.s.os).then(
      CommonSrv.getAvailDGT('d','impTVT&os='+$scope.import.s.os).then(
        function(data){
          $scope.targetDLoading = false;
          $scope.targetDevice = data;
        },
        function(err){
          $scope.targetDLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.importFx = function(){
      angular.forEach($scope.targetDevice.devices, function(item){
        if(item.selected){
          $scope.import.t.push(item.id);
        }
      });
      if($scope.import.t.length){
        $scope.importProcessing = true;
        DevicesSrv.importSettings({sourceId:$scope.import.s.id, target:$scope.import.t}).then(
          function(data){
            $scope.importProcessing = false;
            if(data.code == 12046){
              $scope.hasErr = true;
              $scope.errType = "dEmpty";
            } else if(data.code == 12045){
              $scope.hasErr = true;
              $scope.errType = "gtEmpty";
            } else{
              $scope.impotResetFx();
            }
          },
          function(err){
            $log.error(err);
            $scope.importProcessing = false;
          }
        );
      }
    }
    $scope.impotResetFx = function(){
      $scope.dsInfo = {type:"d", dType:"a", devices:{device:[], tag:[], group:[], exceldata:""}};
      $scope.import = {s:"", t:[]};
      $scope.hasErr = false;
      $scope.errType = ""
      angular.forEach($scope.targetDevice.devices, function(item){
        if(item.selected){
          item.selected = false;
        }
      });
    }

    $scope.sendIdentifyFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.devices.info.durationType == 'c' && ($scope.devices.info.durationC == "" || $scope.devices.info.durationC == null)){
        $scope.hasErr = true;
        $scope.errType = "duration";
        $("#durationSelect1").focus();
      } else if($scope.devices.info.deviceType == 'c' && !($scope.devices.info.devices.assignedDevices.length > 0 || $scope.devices.info.devices.assignedGroups.length > 0 || $scope.devices.info.devices.assignedTags.length > 0)){
        $scope.hasErr = true;
        $scope.errType = "device";
      } else{
        $scope.sendProcessing = true;
        DevicesSrv.sendIdentify($scope.devices.info).then(
          function(data){
            $scope.sendProcessing = false;
            if(data.code == 12046){
              $scope.hasErr = true;
              $scope.errType = "dEmpty";
            } else if(data.code == 12045){
              $scope.hasErr = true;
              $scope.errType = "gtEmpty";
            } else{
              $scope.resetFx();
              $scope.historyFx();
            }
          },
          function(err){
            $log.error(err);
            $scope.sendProcessing = false;
          }
        );
      }
    }
    $scope.resetFx = function(){
      $scope.hasErr = false;
      $scope.devices = angular.copy($scope.resetCopy);
      $scope.flag.d = true;
      $rootScope.resetSelDGTList();
      $scope.brief = $scope.devices;
    }

    $scope.acknowledgeFx = function(id){
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.scrollDataList = [];
      $scope.haveMoreSearchData = false;
      $scope.searchScroll = false;
      $scope.scrollObj = {caller: 'irAck', offset: 0, id: id}
      $scope.isAcknoledgeOpen = true;
      $scope.acknowledgeLoading = true;
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          $scope.acknowledge.id = id;
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.acknowledgeLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
      // $scope.isAcknoledgeOpen = true;
      // $scope.acknowledgeLoading = true;
      // $scope.acknowledge.list = [];
      // DevicesSrv.getAcknowledge(id).then(
      //   function(data){
      //     $scope.acknowledge.id = id;
      //     $scope.acknowledge.list = data;
      //     $scope.acknowledgeLoading = false;
      //   },
      //   function(err){
      //     $log.error(err);
      //     $scope.saveProcessing = false;
      //   }
      // );
    }
    $scope.acknowledgeCloseFx = function(){
      $scope.isAcknoledgeOpen = false;
      $scope.acknowledge.list = [];
    }

    /*ngSwitch*/
    $scope.autoUpdateFx = function(id){
      DevicesSrv.changeAutoUpdate(id).then(
        function(data){
          $scope.deviceBrief.autoUpdate = data.autoUpdate;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.offlineRebootFx = function(id){
      DevicesSrv.changeOfflineReboot(id).then(
        function(data){
          $scope.deviceBrief.offlineReboot = data.offlineReboot;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.lanAccessibleFx = function(id){
      DevicesSrv.changeLanAccessible(id).then(
        function(data){
          $scope.deviceBrief.lan = data.lan;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*ngDialog*/
    $scope.deviceIdOpen = function(id, label, mac, caller){
      $scope.dataObj = {id:id, label:label, mac:mac, caller:caller};
      ngDialog.open({
        template:'app/devices/popup/deviceId.html',
        width:450,
        scope:$scope,
        data:$scope.dataObj,
        closeByDocument:false,
        controller:'DeviceIdController',
      });
    }
    $scope.devicePCOpen = function(id, label){
      $scope.dataCHObj = {id:id, label:label, history:[]};
      $scope.popupLoading = true;
      DevicesSrv.getDeviceCH($scope.dataCHObj.id).then(
        function(data){
          $scope.popupLoading = false;
          $scope.dataCHObj.history = data.history;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/devices/popup/previousChanges.html',
        width:900,
        scope:$scope,
        data:$scope.dataCHObj,
        closeByDocument:false
      });
    }

    $scope.deviceTicketOpen = function(data,id, label){
      $scope.dataTkObj = {id:id, label:label, ticket:data};
      $scope.popupLoading = true;
      DevicesSrv.getTicketCount($scope.auth.sd.url + $scope.auth.sd.ep, $scope.dataTkObj.id, $scope.auth.server, $scope.auth.sd.envId).then(
        function(data){
          $scope.popupLoading = false;
          $scope.dataTkObj.ticket = data.ticket;
          $scope.deviceBriefTicket.count = data.count;
          $scope.loading = false;
        },
        function(err){
          $scope.popupLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/devices/popup/tickets.html',
        width:800,
        scope:$scope,
        data:$scope.dataTkObj,
        closeByDocument:false
      });
    }
    $scope.ticketDetailsOpen = function(thid, tid){
      $scope.dataTkDetails = {thid:thid, tid:tid, iFrameUrl:""};
      $scope.hostURL = $location.protocol() + "://" + $location.host();
      $scope.timestamp = moment().format('x');
      $scope.dataTkDetails.iFrameUrl = $scope.auth.sd.url + "ticketDetail/?tId="+$scope.dataTkDetails.thid+"&uName="+$scope.auth.uname+"&email="+$scope.auth.email+"&uId="+$scope.auth.uid+"&hostURL="+$scope.hostURL+"&"+$scope.timestamp;
      ngDialog.open({
        template:'app/devices/popup/ticketDetails.html',
        width:"80%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-preview",
      });
    }

    $scope.changeResOpen = function(id, label, resolution){
      $scope.deviceResObj = {id:id, label:label, resolution:resolution};
      $scope.popupLoading = true;
      ngDialog.open({
        template:'app/devices/popup/changeRes.html',
        width:550,
        scope:$scope,
        data:$scope.deviceResObj,
        closeByDocument:false
      });
      DevicesSrv.getDeviceRes(id).then(
        function(data){
          $scope.popupLoading = false;
          $scope.deviceRes = data;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.changeResFx = function(){
      DevicesSrv.updateDeviceRes({id:$scope.deviceResObj.id, resolution:$scope.deviceResObj.resolution}).then(
        function(data){
          ngDialog.close();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.contentCountFx = function(id, label, mac, content,type){
      $scope.deviceType = type;
      $scope.loading = false;
      $scope.popupLoading = true;
      $scope.popupLabel = label;
      $scope.filtered = {a:[], i:[]};
      $scope.contentList = {content:{a:[], i:[]}};
      $scope.contentObj = {id:id, label:label, mac:mac, content:content};
      $scope.marginLoad = false;
      if(content.a){
        $scope.refreshObj = {b:false};
        $scope.marginLoad = true;
        $scope.activeContentPromise = DevicesSrv.getActiveContent(id);

        // DevicesSrv.getActiveContent(id).then(
        //   function(data){
        //     if(!content.i){
        //       $scope.marginLoad = false;
        //       $scope.popupLoading = false;
        //       $scope.refreshObj = {b:true};
        //     }
        //     $scope.contentList.framelayout = data.framelayout;
        //     $scope.contentList.content.a =  data.content;
        //     $scope.contentList.info = data.info;
        //     $scope.filtered.a = $scope.contentList.content.a;

        //     $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
        //     if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
        //       $scope.cDetailBucket = $scope.contentList.info.cMbucket;
        //     }
        //     $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
        //     if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
        //       $scope.tDetailBucket = $scope.contentList.info.tMbucket;
        //     }
        //   },
        //   function(err){
        //     $scope.popupLoading = false;
        //     $log.error(err);
        //   }
        // );
      }
      if(content.i){
        $scope.refreshObj = {b:false};
        $scope.marginLoad = true;
        $scope.inactiveContentPromise = DevicesSrv.getInactiveContent(id);
        // DevicesSrv.getInactiveContent(id).then(
        //   function(data){
        //     $scope.marginLoad = false;
        //     $scope.refreshObj = {b:true};
        //     $scope.popupLoading = false;
        //     $scope.contentList.framelayout = data.framelayout;
        //     $scope.contentList.content.i =  data.content;
        //     $scope.contentList.info = data.info;
        //     $scope.filtered.i = $scope.contentList.content.i;

        //     $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
        //     if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
        //       $scope.cDetailBucket = $scope.contentList.info.cMbucket;
        //     }
        //     $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
        //     if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
        //       $scope.tDetailBucket = $scope.contentList.info.tMbucket;
        //     }
        //   },
        //   function(err){
        //     $scope.popupLoading = false;
        //     $log.error(err);
        //   }
        // );
      }
      $q.all([$scope.activeContentPromise, $scope.inactiveContentPromise])
        .then(function(results) {
          var activeData = results[0];
          var inactiveData = results[1];

          $scope.aExpired = [];
          $scope.iExpired = [];
          $scope.eExpired = [];

          if(content.a){
            if(!content.i){
              $scope.marginLoad = false;
              $scope.popupLoading = false;
              $scope.refreshObj = {b:true};
            }
            $scope.contentList.framelayout = activeData.framelayout;

            if(activeData.content && activeData.content.length){
              $scope.aExpired = activeData.content.filter(function(a){
                return !a.isActive;
              });
              $scope.aExpired.forEach(function(ae){
                var index = activeData.content.indexOf(ae);
                activeData.content.splice(index, 1);
              })
            }

            $scope.contentList.content.a =  activeData.content;
            $scope.contentList.info = activeData.info;
            $scope.filtered.a = $scope.contentList.content.a;

            $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
            if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
              $scope.cDetailBucket = $scope.contentList.info.cMbucket;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
            if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
              $scope.tDetailBucket = $scope.contentList.info.tMbucket;
            }
          }
          if(content.i){
            $scope.marginLoad = false;
            $scope.refreshObj = {b:true};
            $scope.popupLoading = false;
            $scope.contentList.framelayout = inactiveData.framelayout;


            if(inactiveData.content.length){
              $scope.eExpired = inactiveData.content.filter(function(a){
                return !a.isActive;
              });
              $scope.eExpired.forEach(function(ae){
                var index = inactiveData.content.indexOf(ae);
                inactiveData.content.splice(index, 1);
              })
            }

            $scope.contentList.content.i =  inactiveData.content;
            $scope.contentList.info = inactiveData.info;
            $scope.filtered.i = $scope.contentList.content.i;

            $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
            if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
              $scope.cDetailBucket = $scope.contentList.info.cMbucket;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
            if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
              $scope.tDetailBucket = $scope.contentList.info.tMbucket;
            }
          }

          $scope.eExpired = $scope.aExpired.concat($scope.eExpired);

          $scope.contentList.content.e = [];
          for (var i = 0; i < $scope.eExpired.length; i++) {
            var obj = $scope.eExpired[i];
            var isDuplicate = false;

            for (var j = 0; j < $scope.contentList.content.e.length; j++) {
              if ($scope.contentList.content.e[j].id === obj.id) {
                isDuplicate = true;
                break;
              }
            }

            if (!isDuplicate) {
              $scope.contentList.content.e.push(obj);
            }
          }

        })
        .catch(function(err) {
          $scope.popupLoading = false;
          $log.error(err);
        });


      // return

      $scope.schConDialog = ngDialog.open({
        template:'app/devices/popup/contentList.html',
        width:950,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
      });
    }
    $scope.contentInfoOpen = function(clObj){
      $scope.searchInfo = {text:""};
      $scope.infoBC = [];
      $scope.contentBtn=[];
      if(clObj.path == "Templates"){
        clObj.path = $filter("translate")('cm.menu.2');
      }
      $scope.contentInfoCopy = angular.copy(clObj);
      $scope.contentInfo = angular.copy(clObj);
      if($scope.contentInfo.type == "widget"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:$scope.contentInfo.type}]
      } else if($scope.contentInfo.type != "widget" && $scope.contentInfo.type != "template"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:"content", subType:$scope.contentInfo.type}]
      } else if($scope.contentInfo.type != "widget" && $scope.contentInfo.type == "template"){
        $scope.contentInfoData = [{id:$scope.contentInfo.id, type:$scope.contentInfo.type, subType:"content"}]
      }

      if($scope.contentInfo.content && $scope.contentInfo.content.length){
        $scope.isLabel = $scope.contentInfo.content[0].label?"label":"l";
      } else{
        $scope.isLabel = "label";
      }

      $scope.customFilter = function(item){
        var itemValue = (item[$scope.isLabel] || '').toLowerCase();
        var searchText = ($scope.searchInfo.text || '').toLowerCase();
        return itemValue.indexOf(searchText) !== -1;
        // return item[$scope.isLabel].indexOf($scope.searchInfo.text) !== -1;
      };

      if($scope.contentInfo.type != "template"){
        ContentLibrarySrv.getApproveBtn($scope.contentInfoData).then(
          function(data){
            $scope.contentBtn = data;
          },
          function(err){
            $log.error(err);
          }
        );
      } else if($scope.contentInfo.type ===  "template"){
        TemplatesSrv.saveTemplateBtn($scope.contentInfoData).then(
          function(data){
            $scope.contentBtn = data;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      ngDialog.open({
        template:'app/common/popup/contentInfo.html',
        width:760,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false
      });
    }
    $scope.openContentFolderFx = function(id, fId, type, splId, splType, gid, gType){
      if(type == 'template'){
        localStorage.setItem("curTemplateId", id);
        localStorage.setItem('curPathTFId', true);
        localStorage.setItem('curTFId', fId);
        $state.go("hub.templates.t");
      } else{
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curDFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
        if(gType){
          localStorage.setItem("curGroupId", gid);
          localStorage.setItem("curGroupType", gType);
        }
        $state.go("hub.contentLibrary.c");
      }
    }
    $scope.downloadOpen = function(contentInfo){
      $scope.downloadSurl = "";
      var cBucket = $scope.contentList.info.cBucket;
      if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
        cBucket = $scope.contentList.info.cMbucket;
      }

      if(contentInfo.type == "Image"){
        $scope.downloadUrl = cBucket + contentInfo.thumb;
      } else if(contentInfo.type == "Video" || contentInfo.type == "Audio" || contentInfo.type == "POWERPOINT" || contentInfo.type == "WORD" || contentInfo.type == "Vector" || contentInfo.type == "Flash"){
        $scope.downloadUrl = cBucket +  contentInfo.url;
      }
      if(contentInfo.sUrl){
        $scope.downloadSurl = cBucket + contentInfo.sUrl;
      }
      $scope.linkOpenFx('m', $scope.downloadUrl, $scope.downloadSurl, contentInfo.thumb, contentInfo.type, contentInfo.size, contentInfo.pSize);
    }

    $scope.userListSearchFocus = function(){
      $scope.searchUserList = {UEmail:""};
      if($scope.userList.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $scope.singleUserListFx = function(u){
      $scope.userDetail = u;
    }
    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.scaleFrameLayout();
    });

    $scope.scaleFrameLayout = function(){
      if($scope.schConDialog){
        $scope.interval = setInterval(function(){
          if(!$scope.popupLoading){
            clearInterval($scope.interval);
            var scaleX = $('.fcont').width() / $('.flGrid').innerWidth();
            var scaleY = $('.fcont').height() / $('.flGrid').innerHeight();

            if(scaleX < scaleY){
              $(".framesContainer").css({"transform-origin":"0 0","transform":"scale(" + scaleX  + "," + scaleX + ")"});
            } else{
              $(".framesContainer").css({"transform-origin":"0 0","transform":"scale(" + scaleY  + "," + scaleY + ")"});
            }
            $('.scrollQuad-y').css('visibility', 'visible');
          }
        }, 1000);
      }
    }

    $scope.removeImgFx = function(index){
      $scope.device.info.info[index].vFile = null;
    }

    $scope.addCustomInfo = function(vType){
      $scope.device.info.info.push({ id:$scope.device.info.info.length+1, label:"", value:"", vType:vType, isEditable:true, time:moment().format() });
    }

    $scope.removeCustomInfo = function(id){
      var index = $scope.device.info.info.findIndex(function(item) {
        return item.id === id;
      });
      $scope.searchDInfo.text = "";
      $scope.device.info.info.splice(index, 1);
    }

    $scope.formatTime = function(value){
      // Convert the date string to a JavaScript Date object
      var dateObject = new Date(value);

      // Use the $filter service to format the date object
      var $filter = angular.injector(['ng']).get('$filter');
      var formattedDate = $filter('date')(dateObject, "yyyy-MM-ddTHH:mm:ss.sssZ");

      return formattedDate;
    }
    $scope.countListFx = function(id, name, label, schedule){
      // console.log("name",name);
      $scope.loading = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.isDBInfo = false;
      $scope.legend = false;
      $rootScope.selectedT = 1;
      $scope.marginLoad = false;
      $scope.popupLabel = label;
      $scope.expType = name;
      $scope.countList = [];
      $scope.uGroupList = [];
      $scope.activeDataS = [];
      $scope.inActiveDataS = [];
      $scope.dataObj = {id:id, name:name, label:label};
      $scope.deviceDataObj = {id:id, name:name, label:label, schedule:schedule};
      $scope.filtered = {a:[], i:[]};

      // ** 2nd phase pagination variable
      $scope.scrollDataList = [];

      if(name == 'frame'){
        DevicesSrv.getFrameLayoutList(id).then(
          function(data){
            $scope.countList = data;
            $scope.flBucket = $scope.countList.info.bucket;
            if($scope.countList.info.mbucket && $scope.countList.info.mbucket != ""){
              $scope.flBucket = $scope.countList.info.mbucket;
            }
          },
          function(err){
            $log.error(err);
          }
        );
        ngDialog.open({
          template:'app/devices/popup/frameCount.html',
          width:750,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
          closeByEscape:false
        });
      } else if(name == 'schedule'){
        $scope.isSorted = false;
        $scope.popupLoading = true;
        $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
        $scope.currentSelectFrame = 0
        DevicesSrv.getAllSchedule(id).then(
          function(data){
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.countList.info = data.info;
            if(data.schedules.length){
              angular.forEach(data.schedules , function(item, key){
                if(item.isActive == 1){
                  $scope.activeDataS.push(item);
                }
                if(item.isActive == 0){
                  $scope.inActiveDataS.push(item);
                }
              })
            }
            $scope.countList.schedules.a = $scope.activeDataS;
            $scope.countList.schedules.i = $scope.inActiveDataS;
            $scope.filtered.a = $scope.countList.schedules.a;
            $scope.filtered.i = $scope.countList.schedules.i;
            $scope.countList.framelayout = data.framelayout;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );

        $scope.schConDialog = ngDialog.open({
          template:'app/devices/popup/scheduleList.html',
          width:1280,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
        });

      } else if(name == 'device' || name == 'tag' || name == 'search' || name == 'videowall'){
        if(name == 'device'){
          if($scope.selectedTab === "hub.devices.dg"){
            $scope.refreshObj = {l:true, b:false};
            $scope.marginLoad = true;
            $scope.stIndex = 0
            $scope.etIndex = 300;
            $scope.haveMoreSearchData = false;
            $scope.searchScroll = false;
            $scope.scrollObj = {caller: 'dg', offset: 0, id: id}
            DevicesSrv.getScrollListData($scope.scrollObj).then(
              function(data){
                if(data.d.length >= 1000){
                  $scope.haveMoreData = true;
                } else{
                  $scope.haveMoreData = false;
                }
                $scope.marginLoad = false;
                $scope.scrollDataList = data.d;
                $scope.allScrollDataList = [];
                $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
                $scope.refreshObj = {l:false, b:true};
              },
              function(err){
                $log.error(err);
              }
            );
            // DevicesSrv.getGroupDeviceList(id).then(
            //   function(data){
            //     $scope.countList = data;
            //     $scope.marginLoad = false;
            //     $scope.refreshObj = {l:false, b:true};
            //   },
            //   function(err){
            //     $log.error(err);
            //   }
            // );
          } else{
            $scope.refreshObj = {l:true, b:false};
            $scope.marginLoad = true;
            $scope.stIndex = 0
            $scope.etIndex = 300;
            $scope.haveMoreSearchData = false;
            $scope.searchScroll = false;
            $scope.scrollObj = {caller: 'dt', offset: 0, id: id}
            DevicesSrv.getScrollListData($scope.scrollObj).then(
              function(data){
                if(data.d.length >= 1000){
                  $scope.haveMoreData = true;
                } else{
                  $scope.haveMoreData = false;
                }
                $scope.marginLoad = false;
                $scope.scrollDataList = data.d;
                $scope.allScrollDataList = [];
                $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
                $scope.refreshObj = {l:false, b:true};
              },
              function(err){
                $log.error(err);
              }
            );
            // DevicesSrv.getTagDeviceList(id).then(
            //   function(data){
            //     $scope.marginLoad = false;
            //     $scope.countList = data.devices;
            //     $scope.refreshObj = {l:false, b:true};
            //   },
            //   function(err){
            //     $log.error(err);
            //   }
            // );
          }
        }
        if(name == 'tag'){
          $scope.marginLoad = true;
          $scope.refreshObj = {l:true, b:false};
          DevicesSrv.getTagList(id).then(
            function(data){
              $scope.countList = data;
              $scope.refreshObj = {l:false, b:true};
            },
            function(err){
              $log.error(err);
            }
          );
        }
        if(name == 'search'){
          // $scope.countList = id.devices;
          $scope.dataObj.id = id.id;

          $scope.refreshObj = {l:true, b:false};
          $scope.marginLoad = true;
          $scope.stIndex = 0
          $scope.etIndex = 300;
          $scope.haveMoreSearchData = false;
          $scope.searchScroll = false;
          $scope.scrollObj = {caller: 'ss', offset: 0, id: id.id}
          DevicesSrv.getScrollListData($scope.scrollObj).then(
            function(data){
              if(data.d.length >= 1000){
                $scope.haveMoreData = true;
              } else{
                $scope.haveMoreData = false;
              }
              $scope.marginLoad = false;
              $scope.scrollDataList = data.d;
              $scope.allScrollDataList = [];
              $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
              $scope.refreshObj = {l:false, b:true};
            },
            function(err){
              $log.error(err);
            }
          );
        }
        if(name == 'videowall'){
          if($scope.selectedTab === "hub.devices.dvw"){
            $scope.refreshObj = {l:true, b:false};
            $scope.marginLoad = true;
            DevicesSrv.getVideoWallList(id).then(
              function(data){
                $scope.countList = data;
                $scope.marginLoad = false;
                $scope.refreshObj = {l:false, b:true};
              },
              function(err){
                $log.error(err);
              }
            );
          }
        }
        ngDialog.open({
          template:'app/devices/popup/deviceTagCount.html',
          width:800,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
        });
      } else if(name == 'userGroup'){
        $scope.userDetail = ""
        $scope.refreshObj = {l:true, b:true};
        $scope.marginLoad = true;
        $scope.loading = true;

        UsersSrv.getActive().then(
          function(data){
            $scope.userList = data.users;
          },
          function(err){
            // $scope.loading = false;
            $log.error(err);
          }
        );

        DevicesSrv.getUserGroupList(id).then(
          function(data){
            $scope.marginLoad = false;
            $scope.countList = data.usersGroup;
            $scope.refreshObj.l = false;
            if(!$scope.countList.length){
              $scope.refreshObj.b = false;
              $scope.marginLoad = true;
            }
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );

        ngDialog.open({
          template:'app/devices/popup/deviceUserGroup.html',
          width:700,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
        });
      } else if(name == 'uGroup'){
        $scope.refreshObj = {u:true};
        DevicesSrv.getDUserGroupList(id).then(
          function(data){
            $scope.uGroupList = data.groupList;
            $scope.refreshObj.u = false;
          },
          function(err){
            $log.error(err);
          }
        );
        ngDialog.open({
          template:'app/devices/popup/groupCount.html',
          width:700,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
        });
      } else if(name == 'dbInfo'){
        $scope.isDBInfo = true;
        $scope.detailsLoading = true;
        DevicesCUSrv.getDevicesDetails(id).then(
          function(data){
            $scope.searchDInfo.text = "";
            $scope.detailsLoading = false;
            $scope.device = data;
            $scope.device.info.properties.forEach(function(item){
              if(item.value == ""){
                item.isblank = true;
              } else{
                item.isblank = false;
              }
            });

            $scope.tim = $scope.device.info.otherinfo.timthumb;
            $scope.cBucket = $scope.cDetailBucket = $scope.device.info.otherinfo.bucket;
            if(!$scope.device.info.info || $scope.device.info.info == null || $scope.device.info.info.length == 0){
              $scope.device.info.info = [{ label:"", value:"", vType:"t", isEditable:true }];
            }
            if($scope.device.info.otherinfo.mbucket && $scope.device.info.otherinfo.mbucket != ""){
              $scope.cDetailBucket = $scope.device.info.otherinfo.mbucket;
            }

            if($scope.device.info.info.length){
              $scope.device.info.info.forEach(function(item, i){
                item.id = i+1;
                if(item.vType == "dt"){
                  item.time = $scope.formatTime(item.value);
                }
              });
            }
          },
          function(err){
            $log.error(err);
          }
        );
        ngDialog.open({
          template:'app/devices/popup/deviceInfo.html',
          width:850,
          data:$scope.dataObj,
          scope:$scope,
          trapFocus:false,
          closeByDocument:false,
          preCloseCallback:function(){
            $scope.isDBInfo = false;
          }
        });
      }
    }

    $scope.loadingInfo = false;
    // $scope.refreshOInfoFx = function(){
    //   $scope.loadingInfo = true;
    //   DevicesCUSrv.getDevicesDetails($scope.decId, 'oi').then(
    //     function(data){
    //       $scope.searchDInfo.text = "";
    //       $scope.loadingInfo = false;
    //       $scope.device.info.info = data.info.info;
    //       $scope.device.info.otherinfo = data.info.otherinfo;

    //       $scope.tim = $scope.device.info.otherinfo.timthumb;
    //       $scope.cBucket = $scope.cDetailBucket = $scope.device.info.otherinfo.bucket;
    //       if(!$scope.device.info.info || $scope.device.info.info == null || $scope.device.info.info.length == 0){
    //         $scope.device.info.info = [{ label:"", value:"", vType:"t", isEditable:true }];
    //       }
    //       if($scope.device.info.otherinfo.mbucket && $scope.device.info.otherinfo.mbucket != ""){
    //         $scope.cDetailBucket = $scope.device.info.otherinfo.mbucket;
    //       }

    //       if($scope.device.info.info.length){
    //         $scope.device.info.info.forEach(function(item){
    //           if(item.vType == "dt"){
    //             item.time = $scope.formatTime(item.value);
    //           }
    //         });
    //       }
    //     },
    //     function(err){
    //       $log.error(err);
    //     }
    //   );
    // }

    $scope.refreshPopupListFx = function(caller){
      // console.warn(caller);
      $scope.loadingInfo = false;
      $scope.loading = false;
      // $scope.paginationControls.currPage = 1;
      $scope.legend = false;
      if(caller != "ugDevice"){
        $scope.popupLoading = true;
        $scope.loading = true;
      }else{
        $scope.ugDevicePopupLoading = true;
        $scope.ugDeviceloading = true;
      }
      // $scope.advSearchInfo = {};
      if(caller === 'content'){
        $rootScope.selectedT = 1;
        $scope.currentSelectFrame = 0;
        $scope.refreshObj.b = true;
        $scope.popupLabel = $scope.contentObj.label;
        $scope.filtered = {a:[], i:[]};
        $scope.contentList = {content:{a:[], i:[]}};

        if($scope.contentObj.content.a){
          $scope.activeContentPromise = DevicesSrv.getActiveContent($scope.contentObj.id);
          // DevicesSrv.getActiveContent($scope.contentObj.id).then(
          //   function(data){
          //     if(!$scope.contentObj.content.i){
          //       $scope.popupLoading = false;
          //       $scope.loading = false;
          //       if(!$scope.contentList.content.a.length){
          //         $scope.refreshObj.b = true;
          //       }
          //     }
          //     $scope.contentList.framelayout = data.framelayout;
          //     $scope.contentList.content.a =  data.content;
          //     $scope.contentList.info = data.info;
          //     $scope.filtered.a = $scope.contentList.content.a;

          //     $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
          //     if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
          //       $scope.cDetailBucket = $scope.contentList.info.cMbucket;
          //     }
          //     $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
          //     if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
          //       $scope.tDetailBucket = $scope.contentList.info.tMbucket;
          //     }
          //     $scope.scaleFrameLayout();
          //   },
          //   function(err){
          //     $scope.popupLoading = false;
          //     $scope.loading = false;
          //     $log.error(err);
          //   }
          // );
        }
        if($scope.contentObj.content.i){
          $scope.inactiveContentPromise = DevicesSrv.getInactiveContent($scope.contentObj.id);
          // DevicesSrv.getInactiveContent($scope.contentObj.id).then(
          //   function(data){
          //     $scope.popupLoading = false;
          //     $scope.loading = false;
          //     $scope.refreshObj.b = true;
          //     $scope.contentList.framelayout = data.framelayout;
          //     $scope.contentList.content.i =  data.content;
          //     $scope.contentList.info = data.info;
          //     $scope.filtered.i = $scope.contentList.content.i;

          //     $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
          //     if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
          //       $scope.cDetailBucket = $scope.contentList.info.cMbucket;
          //     }
          //     $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
          //     if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
          //       $scope.tDetailBucket = $scope.contentList.info.tMbucket;
          //     }
          //   },
          //   function(err){
          //     $scope.popupLoading = false;
          //     $scope.loading = false;
          //     $log.error(err);
          //   }
          // );
        }

        $q.all([$scope.activeContentPromise, $scope.inactiveContentPromise])
        .then(function(results) {
          var activeData = results[0];
          var inactiveData = results[1];

          $scope.aExpired = [];
          $scope.iExpired = [];
          $scope.eExpired = [];

          if($scope.contentObj.content.a){
            if(!$scope.contentObj.content.i){
              $scope.popupLoading = false;
              $scope.loading = false;
              if(!$scope.contentList.content.a.length){
                $scope.refreshObj.b = true;
              }
            }
            $scope.contentList.framelayout = activeData.framelayout;

            if(activeData.content.length){
              $scope.aExpired = activeData.content.filter(function(a){
                return !a.isActive;
              });
              $scope.aExpired.forEach(function(ae){
                var index = activeData.content.indexOf(ae);
                activeData.content.splice(index, 1);
              })
            }

            $scope.contentList.content.a =  activeData.content;
            $scope.contentList.info = activeData.info;
            $scope.filtered.a = $scope.contentList.content.a;

            $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
            if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
              $scope.cDetailBucket = $scope.contentList.info.cMbucket;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
            if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
              $scope.tDetailBucket = $scope.contentList.info.tMbucket;
            }
            $scope.scaleFrameLayout();
          }
          if($scope.contentObj.content.i){
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.refreshObj.b = true;
            $scope.contentList.framelayout = inactiveData.framelayout;

            if(inactiveData.content.length){
              $scope.eExpired = inactiveData.content.filter(function(a){
                return !a.isActive;
              });
              $scope.eExpired.forEach(function(ae){
                var index = inactiveData.content.indexOf(ae);
                inactiveData.content.splice(index, 1);
              })
            }

            $scope.contentList.content.i =  inactiveData.content;
            $scope.contentList.info = inactiveData.info;
            $scope.filtered.i = $scope.contentList.content.i;

            $scope.cBucket = $scope.cDetailBucket = $scope.contentList.info.cBucket;
            if($scope.contentList.info.cMbucket && $scope.contentList.info.cMbucket != ""){
              $scope.cDetailBucket = $scope.contentList.info.cMbucket;
            }
            $scope.tBucket = $scope.tDetailBucket = $scope.contentList.info.tBucket;
            if($scope.contentList.info.tMbucket && $scope.contentList.info.tMbucket != ""){
              $scope.tDetailBucket = $scope.contentList.info.tMbucket;
            }
          }

          $scope.eExpired = $scope.aExpired.concat($scope.eExpired);

          $scope.contentList.content.e = [];
          for (var i = 0; i < $scope.eExpired.length; i++) {
            var obj = $scope.eExpired[i];
            var isDuplicate = false;

            for (var j = 0; j < $scope.contentList.content.e.length; j++) {
              if ($scope.contentList.content.e[j].id === obj.id) {
                isDuplicate = true;
                break;
              }
            }

            if (!isDuplicate) {
              $scope.contentList.content.e.push(obj);
            }
          }

        })
        .catch(function(err) {
          $scope.popupLoading = false;
          $log.error(err);
        });


      } else if(caller === 'schedule'){
        $rootScope.selectedT = 1;
        $scope.currentSelectFrame = 0;
        $scope.popupLabel = $scope.deviceDataObj.label;
        $scope.expType = $scope.deviceDataObj.name;
        $scope.countList = [];
        $scope.activeDataS = [];
        $scope.inActiveDataS = [];
        $scope.filtered = {a:[], i:[]};

        $scope.isSorted = false;
        $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
        DevicesSrv.getAllSchedule($scope.deviceDataObj.id).then(
          function(data){
            $scope.popupLoading = false;
            $scope.loading = false;
            $scope.countList.info = data.info;
            if(data.schedules.length){
              angular.forEach(data.schedules , function(item, key){
                if(item.isActive == 1){
                  $scope.activeDataS.push(item);
                }
                if(item.isActive == 0){
                  $scope.inActiveDataS.push(item);
                }
              })
            }
            $scope.countList.schedules.a = $scope.activeDataS;
            $scope.countList.schedules.i = $scope.inActiveDataS;
            $scope.filtered.a = $scope.countList.schedules.a;
            $scope.filtered.i = $scope.countList.schedules.i;
            $scope.countList.framelayout = data.framelayout;
            $scope.scaleFrameLayout();
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'frame'){
        $scope.popupLabel = $scope.deviceDataObj.label;
        $scope.expType = $scope.deviceDataObj.name;
        $scope.countList = [];
        $scope.filtered = {a:[], i:[]};
        DevicesSrv.getFrameLayoutList($scope.deviceDataObj.id).then(
          function(data){
            $scope.countList = data;
              $scope.loading = false;
            $scope.flBucket = $scope.countList.info.bucket;
            if($scope.countList.info.mbucket && $scope.countList.info.mbucket != ""){
              $scope.flBucket = $scope.countList.info.mbucket;
            }
          },
          function(err){
              $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'ticket'){
        DevicesSrv.getTicketCount($scope.auth.sd.url + $scope.auth.sd.ep, $scope.dataTkObj.id, $scope.auth.server, $scope.auth.sd.envId).then(
          function(data){
            $scope.popupLoading = false;
            $scope.dataTkObj.ticket = data.ticket;
            $scope.deviceBriefTicket.count = data.count;
            $scope.loading = false;
          },
          function(err){
            $scope.popupLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'device'){
        $scope.popupLabel = $scope.deviceDataObj.l?$scope.deviceDataObj.l:$scope.deviceDataObj.label;
        $scope.expType = $scope.deviceDataObj.name;
        $scope.countList = [];

        $scope.scrollDataList = [];

        $scope.filtered = {a:[], i:[]};
        if($scope.expType == 'device'){
          if($scope.selectedTab === "hub.devices.dg"){
            $scope.refreshObj = {l:true, b:true};
            $scope.stIndex = 0
            $scope.etIndex = 300;
            $scope.haveMoreSearchData = false;
            $scope.searchScroll = false;
            $scope.scrollObj = {caller: 'dg', offset: 0, id: $scope.deviceDataObj.id}
            DevicesSrv.getScrollListData($scope.scrollObj).then(
              function(data){
                if(data.d.length >= 1000){
                  $scope.haveMoreData = true;
                } else{
                  $scope.haveMoreData = false;
                }
                $scope.scrollDataList = data.d;
                $scope.allScrollDataList = [];
                $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
                $scope.refreshObj.l = false;
                if(!$scope.scrollDataList.length){
                  $scope.refreshObj.b = false;
                }
                $scope.loading = false;
              },
              function(err){
                $log.error(err);
              }
            );
            // DevicesSrv.getGroupDeviceList($scope.deviceDataObj.id).then(
            //   function(data){
            //     $scope.countList = data;
            //     $scope.refreshObj.l = false;
            //     if(!$scope.countList.length){
            //       $scope.refreshObj.b = false;
            //     }
            //     $scope.loading = false;
            //   },
            //   function(err){
            //     $scope.loading = false;
            //     $log.error(err);
            //   }
            // );
          } else{
            $scope.refreshObj = {l:true, b:true};
            $scope.stIndex = 0
            $scope.etIndex = 300;
            $scope.haveMoreSearchData = false;
            $scope.searchScroll = false;
            $scope.scrollObj = {caller: 'dt', offset: 0, id: $scope.deviceDataObj.id}
            DevicesSrv.getScrollListData($scope.scrollObj).then(
              function(data){
                if(data.d.length >= 1000){
                  $scope.haveMoreData = true;
                } else{
                  $scope.haveMoreData = false;
                }
                $scope.scrollDataList = data.d;
                $scope.allScrollDataList = [];
                $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
                $scope.refreshObj.l = false;
                if(!$scope.scrollDataList.length){
                  $scope.refreshObj.b = false;
                }
                $scope.loading = false;
              },
              function(err){
                $log.error(err);
              }
            );
            // DevicesSrv.getTagDeviceList($scope.deviceDataObj.id).then(
            //   function(data){
            //     $scope.countList = data.devices;
            //     $scope.refreshObj.l = false;
            //     if(!$scope.countList.length){
            //       $scope.refreshObj.b = false;
            //     }
            //     $scope.loading = false;
            //   },
            //   function(err){
            //     $scope.loading = false;
            //     $log.error(err);
            //   }
            // );
          }
        }
        if($scope.expType == 'userGroup'){
          $scope.userDetail = ""
          $scope.marginLoad = true;
          $scope.refreshObj = {l:true, b:true};

          UsersSrv.getActive().then(
            function(data){
              $scope.userList = data.users;
            },
            function(err){
              $log.error(err);
            }
          );

          DevicesSrv.getUserGroupList($scope.deviceDataObj.id).then(
            function(data){
              $scope.marginLoad = false;
              $scope.countList = data.usersGroup;
              $scope.refreshObj.l = false;
              if(!$scope.countList.length){
                $scope.refreshObj.b = false;
                $scope.marginLoad = true;
              }
              $scope.loading = false;
            },
            function(err){
              $scope.loading = false;
              $log.error(err);
            }
          );

        }
        if($scope.expType == 'tag'){
          $scope.refreshObj = {l:true, b:true};
          DevicesSrv.getTagList($scope.deviceDataObj.id).then(
            function(data){
              $scope.countList = data;
              $scope.refreshObj.l = false;
              if(!$scope.countList.length){
                $scope.refreshObj.b = false;
              }
              $scope.loading = false;
            },
            function(err){
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
        if($scope.selectedTab === "hub.devices.dg"){
          if($rootScope.selectedItems[0].type == "search"){
            $scope.refreshObj = {l:true, b:true};
            $scope.stIndex = 0
            $scope.etIndex = 300;
            $scope.haveMoreSearchData = false;
            $scope.searchScroll = false;
            $scope.scrollObj = {caller: 'ss', offset: 0, id: $rootScope.selectedItems[0].id}
            DevicesSrv.getScrollListData($scope.scrollObj).then(
              function(data){
                if(data.d.length >= 1000){
                  $scope.haveMoreData = true;
                } else{
                  $scope.haveMoreData = false;
                }
                $scope.scrollDataList = data.d;
                $scope.allScrollDataList = [];
                $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
                $scope.refreshObj.l = false;
                if(!$scope.scrollDataList.length){
                  $scope.refreshObj.b = false;
                }
                $scope.loading = false;
              },
              function(err){
                $log.error(err);
              }
            );

            // $scope.refreshObj = {l:true, b:true};
            // $scope.countList = [];
            // DevicesSrv.getSearchBrief($rootScope.selectedItems[0].id).then(
            //   function(data){
            //     $scope.deviceBrief = data;
            //     $scope.countList = $scope.deviceBrief.devices;
            //     $scope.refreshObj.l = false;
            //     if(!$scope.countList.length){
            //       $scope.refreshObj.b = false;
            //     }
            //     $scope.loading = false;
            //   },
            //   function(err){
            //     $scope.loading = false;
            //     $log.error(err);
            //   }
            // );
          }
        }
        if($scope.selectedTab === "hub.devices.dvw"){
          $scope.refreshObj = {l:true, b:false};
          $scope.marginLoad = true;
          DevicesSrv.getVideoWallList($scope.deviceDataObj.id).then(
            function(data){
              $scope.countList = data;
              $scope.marginLoad = false;
              $scope.refreshObj = {l:false, b:true};
              $scope.loading = false;
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if(caller === "wmDevices"){
        $scope.refreshObj = {l:true, b:false};
        $scope.deviceIds = $scope.arraytoStringFx($scope.deviceList);
        DashboardSrv.deviceDetail({devices:$scope.deviceIds}).then(
          function(data){
            $scope.deviceList = data;
            $scope.loading = false;
            $scope.detailLoading = false;
            $scope.refreshObj = {l:false, b:true};
          },
          function(err){
            $scope.detailLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === "task"){
        $scope.taskDetails = {};
        DevicesSrv.getTaskDetails($scope.taskObj.task.id).then(
          function(data){
            $scope.completeTask = data.queued_task.filter(function(obj){
              if(obj.iscompleted == 1 && obj.resp.status == "success"){
                return obj;
              }
            });
            $scope.pendingTask = data.queued_task.filter(function(obj){
              if(obj.iscompleted == 0){
                return obj;
              }
            });
            $scope.failedTask = data.queued_task.filter(function(obj){
              if(obj.resp.status != "success"){
                return obj;
              }
            });
            $scope.taskDetails = data;
            $scope.taskQueueList = data.queued_task;
            $scope.popupLoading = false;
            $scope.loading = false;
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
            $scope.loading = false;
          }
        );
      } else if(caller === 'fDevices'){
        $scope.deviceList = [];
        $scope.scrollDataList = [];
        $scope.refreshObj = { l: true, b: true };
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: 'dFolder', offset: 0, id: $scope.deviceView.id, fil: $scope.filType}
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.refreshObj.l = false;
            if(!$scope.scrollDataList.length){
              $scope.refreshObj.b = false;
            }
            $scope.loading = false;
          },
          function(err){
            $log.error(err);
          }
        );
        // DevicesSrv.getDeviceList($scope.deviceView.id, $scope.filType).then(
        //   function (data) {
        //     $scope.deviceList = data;
        //     $scope.refreshObj.l = false;
        //     if (!$scope.deviceList.length) {
        //       $scope.refreshObj.b = false;
        //     }
        //     $scope.loading = false;
        //   },
        //   function (err) {
        //     $scope.loading = false;
        //     $log.error(err);
        //   }
        // );
      } else if(caller === 'ugDevice'){
        $scope.ugType = $scope.deviceListUserGroupObj.name;
        $scope.ugid = $scope.deviceListUserGroupObj.ugid;
        $scope.deviceList = [];
        $scope.scrollDataList = [];

        $scope.ugDevicePopupLoading = true;

        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: 'ug', offset: 0, id: $scope.ugid}
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.ugDevicePopupLoading = false;
            $scope.ugDeviceloading = false;
          },
          function(err){
            $scope.ugDevicePopupLoading = false;
            $scope.ugDeviceloading = false;
            $log.error(err);
          }
        );
        // DevicesSrv.getUserGroupDeviceList($scope.ugid).then(
        //   function(data){
        //     $scope.deviceList = data.devices;
        //     $scope.ugDevicePopupLoading = false;
        //     $scope.ugDeviceloading = false;
        //   },
        //   function(err){
        //     $scope.ugDevicePopupLoading = false;
        //     $scope.ugDeviceloading = false;
        //     $log.error(err);
        //   }
        // );
      } else if(caller === 'tag'){
        $scope.refreshObj = {t:true};
        DevicesSrv.getTagList($scope.dId).then(
          function(data){
            $scope.tagList = data.devices;
            $scope.refreshObj.t = false;
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'uGroup'){
        $scope.uGroupList = [];
        $scope.refreshObj = {u:true};
        DevicesSrv.getDUserGroupList($scope.deviceDataObj.id).then(
          function(data){
            $scope.uGroupList = data.groupList;
            $scope.refreshObj.u = false;
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else if(caller === 'dbInfo'){
        $scope.detailsLoading = true;
        $scope.loadingInfo = true;
        DevicesCUSrv.getDevicesDetails($scope.deviceDataObj.id).then(
          function(data){
            $scope.searchDInfo.text = "";
            $scope.loadingInfo = false;
            $scope.detailsLoading = false;
            $scope.device = data;
            $scope.device.info.properties.forEach(function(item){
              if(item.value == ""){
                item.isblank = true;
              } else{
                item.isblank = false;
              }
            });

            $scope.tim = $scope.device.info.otherinfo.timthumb;
            $scope.cBucket = $scope.cDetailBucket = $scope.device.info.otherinfo.bucket;
            if(!$scope.device.info.info || $scope.device.info.info == null || $scope.device.info.info.length == 0){
              $scope.device.info.info = [{ label:"", value:"", vType:"t", isEditable:true }];
            }
            if($scope.device.info.otherinfo.mbucket && $scope.device.info.otherinfo.mbucket != ""){
              $scope.cDetailBucket = $scope.device.info.otherinfo.mbucket;
            }

            if($scope.device.info.info.length){
              $scope.device.info.info.forEach(function(item,i){
                item.id = i+1;
                if(item.vType == "dt"){
                  item.time = $scope.formatTime(item.value);
                }
              });
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.contentLoading = true;
        $scope.openingLoading = true;
        $scope.useContentErr = {empty:false};
        $scope.curBg = "";
        // console.log("HELLO");
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLoading = false;
            $scope.contentLibrary = data;
            $scope.loading = false;
            if($scope.isDBInfo){
              $scope.advSearchDInfo = {};
              $scope.advSearchDI = false;
            } else {
              $scope.advSearchInfo = {};
              $scope.advSearch = false;
            }
            $scope.updateListContentFx();
          },
          function(err){
            $scope.loading = false;
            $scope.contentLoading = false;
            $scope.openingLoading = false;
            $log.error(err);
          }
        );
      }
      $scope.scaleFrameLayout();
    }

    $scope.getUserAccess = function(detail){
      $(".table .scrollQuad .ugList").removeClass("access");
      $(".table .scrollQuad .ugList").removeClass("noAccess");
      DevicesSrv.getAccessUserList(detail.id).then(
        function(data){
          $scope.legend = true;
          $scope.AccessUserGroups = data.userGroups;
            angular.forEach($scope.countList, function(item,value){
              $scope.isDuplicate = false;
              angular.forEach($scope.AccessUserGroups, function(user,index){
                if(user.id == item.id){
                  item.noAccess = false;
                  $scope.isDuplicate = true;
                  return false;
                }
              })
              if(!$scope.isDuplicate){
                item.noAccess = true;
                $(".ugList[data-id=" + item.id + "]").addClass("noAccess");
              }else{
                item.noAccess = false;
                $(".ugList[data-id=" + item.id + "]").addClass("access");
              }
            });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.downloadUserGroup = function(){
      $rootScope.linkOpenObj = {loading:true, url:"", surl:"" };
      $scope.linkOpenFx('d');
      DevicesSrv.downloadUserGroups($scope.deviceDataObj.id).then(
        function(data){
            $rootScope.linkOpenObj = {loading:false, url:data.download, surl:"" };
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.deviceListOpen = function(ugid, label){
      $scope.selectedUserGroupId = ugid;
      $scope.popupLabel = label;
      $scope.deviceListUserGroupObj = {ugid:ugid, name:'ugDeviceList'};
        $scope.scrollDataList = [];
        ngDialog.open({
          template:'app/devices/popup/userGroupDeviceList.html',
          width:650,
          scope:$scope,
          closeByDocument:false
        });
        $scope.ugDevicePopupLoading = true;
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: 'ug', offset: 0, id: ugid}
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            // console.log("data",data);
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            $scope.ugDevicePopupLoading = false;
          },
          function(err){
            $scope.ugDevicePopupLoading = false;
            $log.error(err);
          }
        );
        // DevicesSrv.getUserGroupDeviceList(ugid).then(
        //   function(data){
        //     $scope.deviceList = data.devices;
        //     $scope.ugDevicePopupLoading = false;
        //   },
        //   function(err){
        //     $scope.ugDevicePopupLoading = false;
        //     $log.error(err);
        //   }
        // );
    }

    $scope.selectFrame = function(id){
      $scope.currentSelectFrame = id
      $(".layer-container .layer .flList").removeClass("selectedFlList");
      $(".flList[data-id=" + id + "]").addClass("selectedFlList");
    }
    // switch for schedule
    $scope.statusFx = function(id){
      $scope.scaleFrameLayout();
      $scope.popupLoading = true;
      $scope.loading = true;
      $scope.advSearchInfo = {};
      $(".switch-sm").each(function(){
        if(id == $(this).attr("data-id")){
          $(this).addClass("disabled");
        }
      });
      SchedulesSrv.changeStatus(id).then(
        function(data){
          $(".switch-sm").each(function(){
            if(id == $(this).attr("data-id")){
              $(this).removeClass("disabled");
            }
          });
          $scope.briefFx($scope.curSelectedItem);
            // $scope.refreshPopupListFx('schedule');
          $scope.popupLabel = $scope.deviceDataObj.label;
          $scope.expType = $scope.deviceDataObj.name;
          $scope.countList = [];
          $scope.activeDataS = [];
          $scope.inActiveDataS = [];
          $scope.filtered = {a:[], i:[]};

          $scope.isSorted = false;
          $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
          DevicesSrv.getAllSchedule($scope.deviceDataObj.id).then(
            function(data){
              $scope.popupLoading = false;
              $scope.loading = false;
              $scope.countList.info = data.info;
              if(data.schedules.length){
                angular.forEach(data.schedules , function(item, key){
                  if(item.isActive == 1){
                    $scope.activeDataS.push(item);
                  }
                  if(item.isActive == 0){
                    $scope.inActiveDataS.push(item);
                  }
                })
              }
              $scope.countList.schedules.a = $scope.activeDataS;
              $scope.countList.schedules.i = $scope.inActiveDataS;
              $scope.filtered.a = $scope.countList.schedules.a;
              $scope.filtered.i = $scope.countList.schedules.i;
              $scope.countList.framelayout = data.framelayout;
            },
            function(err){
              $scope.popupLoading = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        },
        function(err){
          $log.error(err);
        }
      );
    }
    /*Content Confirmation*/
    $scope.loadDownload = false;
    $scope.downloadCCFx = function(){
      $scope.loadDownload = true;
      $scope.deviceObj = {devices:[$scope.contentObj], caller:"device"};
      ReportsSrv.getReportsCC($scope.deviceObj).then(
        function(data){
          $scope.loadDownload = false;
          $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          $scope.linkOpenFx(data.url);
        },
        function(err){
          $log.error(err);
          $scope.loadDownload = false;
        }
      );
    }

    $scope.infoBC = [];
    $scope.contentOpenFx = function(cl){
      $scope.searchInfo = {text:""};
      $scope.infoBC.push({id:cl.id, label:cl.label, type:cl.type, extn:cl.extn});
      if(cl.type == "Widget" && cl.extn == "Content Group"){
        $scope.innerLoading = true;
        $scope.contentInfo.content = [];
        CommonSrv.getCGList(cl.id).then(
          function(data){
            $scope.innerLoading = false;
            $scope.contentInfo.content = data.content;
          },
          function(err){
            $log.error(err);
            $scope.innerLoading = false;
          }
        );
      } else{
        $scope.contentInfo.content = cl.content;
      }
    }

    $scope.infoBCFx = function(cl){
      $scope.searchInfo = {text:""};
      $scope.infoBC = [];
      if(cl){
        $scope.contentOpenFx(cl);
      } else{
        $scope.contentInfo = angular.copy($scope.contentInfoCopy);
      }
    }

    $scope.sortCallback = function(){
      $scope.saveOrderProcessing = false;
      $scope.isSameCount = 0;
      $(".sortable-item").each(function(index){
        if($(this).data("index") != index + 1){
          for(var i = 0; i < $scope.countList.schedules.length; i++){
            if($scope.countList.schedules[i].id == $(this).data("ids")){
              $scope.countList.schedules[i].sortOrder = index + 1;
              $scope.isSorted = true;
              break;
            }
          }
        } else{
          $scope.isSameCount++;
          if($scope.countList.schedules.length == $scope.isSameCount){
            $scope.isSorted = false;
          }
        }
      });
    }

    $scope.saveOrderFx = function(){
      $scope.saveOrderProcessing = true;
      DevicesSrv.saveOrder({id:$scope.dataObj.id, list:$scope.countList}).then(
        function(data){
          $scope.saveOrderProcessing = false;
          ngDialog.close();
        },
        function(err){
          $scope.saveOrderProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.adaptersList = function(obj){
      $scope.dataObj = obj;
      ngDialog.open({
        template:'app/devices/popup/adaptersList.html',
        width:650,
        scope:$scope,
        data:$scope.dataObj,
        closeByDocument:false
      });
    }

    $scope.editScheduleFx = function(id, step){
      // console.warn("EditSchedule", id);
      ngDialog.close();
      if(!step){
        if($scope.auth.upermissions.se.np){
          $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.s){
          $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.c){
          $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.f){
          $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        }
      } else if(step == "np"){
        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "s"){
        $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "c"){
        $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "d"){
        $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "f"){
        $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      }
    }

    $scope.dataUsageOpen = function(id, label){
      $scope.dataObj = {id:id, label:label, key:'dataUsage', tzOffset:$scope.curTimezone};
      ngDialog.open({
        template:'app/devices/popup/dataUsage.html',
        width:650,
        data:$scope.dataObj,
        controller:'DataUsageController',
        closeByDocument:false
      });
    }
    $scope.dataUsageSettingOpen = function(id, label){
      $scope.dataObj = {id:id, label:label, key:'dataUsageSetting'};
      ngDialog.open({
        template:'app/devices/popup/dataUsageSetting.html',
        width:650,
        data:$scope.dataObj,
        scope:$scope,
        controller:'DataUsageController',
        closeByDocument:false
      });
    }

    $scope.loadMoreLogs = function(caller){
      $scope.dateObj = {id:$rootScope.selectedItems[0].id, offset:$scope.logObj.logList.length};
      if(caller == "refresh"){
        $scope.logLoading = true;
        $scope.loading = true;
        $scope.allLogsLoaded = false;
        $scope.dateObj.offset = 0;
      }
      if(!$scope.allLogsLoaded){
        DevicesSrv.loadMoreLogs($scope.dateObj).then(
          function(data){
            $scope.logLoading = false;
            $scope.loading = false;
            if(data.code == 7002){
              $scope.allLogsLoaded = true;
            } else if(data.logs && data.logs.length > 0){
              if(caller == "refresh"){
                $scope.logObj.logList = [];
              }
              $scope.logObj.logList = $scope.logObj.logList.concat(data.logs);
            }
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.deviceLogOpen = function(label){
      $scope.logObj = {info:{module:"Device", label:label, id:$rootScope.selectedItems[0].id}, logList:[]};
      $scope.allLogsLoaded = false;
      $scope.logLoading = true;
      $scope.loading = false;
      $scope.loadMoreLogs();
      ngDialog.open({
        template:"app/common/popup/logList.html",
        width:750,
        scope:$scope,
        data:$scope.logObj,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-logList",
      });
    }

    $scope.loadMorePHFx = function(caller){
      $scope.datePHObj = {mac:$scope.phObj.info.mac, offset:$scope.phObj.list.length};
      if(caller == "refresh"){
        $scope.refreshLoading = true;
        $scope.phLoading = true;
        $scope.allPHLoaded = false;
        $scope.datePHObj.offset = 0;
      }
      if(!$scope.allPHLoaded){
        DevicesSrv.loadMorePH($scope.datePHObj).then(
          function(data){
            $scope.phLoading = false;
            if(data.code == 7002){
              $scope.allPHLoaded = true;
            } else if(data.history && data.history.length > 0){
              if(caller == "refresh"){
                $scope.phObj.list = [];
              }
              $scope.phObj.list = $scope.phObj.list.concat(data.history);
            }
            $scope.refreshLoading = false;
          },
          function(err){
            $scope.phLoading = false;
            $scope.refreshLoading = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.powerHistoryOpen = function(label, mac){
      $scope.phObj = {info:{label:label, mac:mac}, list:[]};
      $scope.allPHLoaded = false;
      $scope.phLoading = true;
      $scope.loadMorePHFx();
      ngDialog.open({
        template:"app/devices/popup/phList.html",
        width:750,
        scope:$scope,
        data:$scope.phObj,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-logList",
      });
    }

    $scope.downloadPHOpen = function(){
      $scope.saveProcessing = false;
      $scope.hasErr = false;
      $scope.phDownload = {info:{dateRange:{startDate:moment().subtract(15, "day")._d, endDate:moment()._d}}, url:"", devices:$filter("filter")($scope.devices.devices, {id:$rootScope.selectedItems[0].id})};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"d.brief.25" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div ng-if="!phDownload.url">\
                <div class="form-group noMarB">\
                  <label>{{"cm.label.9" | translate}}</label>\
                  <div class="input-group">\
                    <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                    <input type="daterange" class="form-control picker" ng-model="phDownload.info.dateRange" max-date="{{maxDate}}" format="MM/DD/YYYY" readonly="" aria-label="{{\'cm.label.9\' | translate}}" aria-labelledby="{{\'cm.label.9\' | translate}}">\
                  </div>\
                </div>\
              </div>\
              <div class="text-center" ng-if="phDownload.url">\
                <p translate="{{\'cm.body.11\'}}" translate-values="{htmlTagO:\'<b>&quot;\', htmlTagC:\'&quot;</b>\'}"></p>\
                <a href="{{phDownload.url}}" role="link" target="_blank" download class="btn btn-link text-lg"><span class="fa fa-download" aria-hidden="true"></span> {{"cm.btn.17" | translate}}</a>\
              </div>\
            </div>\
            <div class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-primary" ng-click="downloadPHFx();" ng-if="!phDownload.url" ng-disabled="saveProcessing"><span class="fa" ng-class="saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{"cm.btn.42" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" ng-if="!phDownload.url" ng-disabled="saveProcessing" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" ng-if="phDownload.url" ng-disabled="saveProcessing" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
              </span>\
              <div class="errMsg" ng-if="hasErr" aria-live="polite" role="status">\
                <span ng-if="errType==\'date\'" aria-live="polite" role="status">{{"r.msg.7" | translate}}</span>\
                <span ng-if="errType==\'noData\'" aria-live="polite" role="status">{{"r.msg.1" | translate}}</span>\
                <span ng-if="errType==\'dateRange\'" aria-live="polite" role="status">{{"r.msg.12" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </div>\
          </section>',
        plain:true,
        className:'ngdialog-theme-default',
        width:500,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
      });
    }
    $scope.downloadPHFx = function(){
      $scope.hasErr = false;
      $scope.phDownload.info.dateRange = {startDate:moment($scope.phDownload.info.dateRange.startDate).format("L"), endDate:moment($scope.phDownload.info.dateRange.endDate).format("L")};
      $scope.phDownload.info.sTime = moment().format("HH:mm Z");
      $scope.phDownload.info.eTime = moment().format("HH:mm Z");
      if($filter("dateDifference")($scope.phDownload.info.dateRange.startDate, $scope.phDownload.info.dateRange.endDate) > 15){
        $scope.hasErr = true;
        $scope.errType = "date";
        return;
      }
      $scope.saveProcessing = true;
      DevicesSrv.phDownload($scope.phDownload).then(
        function(data){
          if(data.code == 12033){
            $scope.saveProcessing = false;
            $scope.hasErr = true;
          } else{
            $scope.phDownload.url = data.url;
            $scope.saveProcessing = false;
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.getConfigFx = function(caller){
      DevicesSrv.getConfig($scope.configObj.mac).then(
        function(data){
          if(!data.code){
            $scope.configObj.configList = data;
          }
          $scope.configLoading = false;
          if(caller == "d"){
            $scope.configProcessing = false;
            ngDialog.close($scope.confirmDialog);
          }
        },
        function(err){
          $log.error(err);
          $scope.configLoading = false;
        }
      );
    }
    $scope.configOpen = function(label, mac){
      $scope.configObj = {label:label, mac:mac, id:$rootScope.selectedItems[0].id, configList:[]};
      $scope.configLoading = true;
      $scope.getConfigFx();
      ngDialog.open({
        template:"app/devices/popup/config.html",
        width:800,
        scope:$scope,
        closeByEscape:false,
        data:$scope.configObj,
        closeByDocument:false
      });
    }

    $scope.scheduleListOpen = function(list){
      $scope.scheduleList = list;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cm.body.2" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="table no-th">\
                <div class="row" ng-repeat="list in scheduleList">\
                  <div class="col-xs-12 word-break">{{list.name}}</div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
              </span>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.deleteConfigOpen = function(configId){
      $scope.configId = configId;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body" lang="{{auth.lang}}">{{"d.p_config.m2" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteConfigFx();" focus-me="true" ng-disabled="configProcessing"><span class="fa fa-repeat fa-spin" ng-if="configProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.deleteConfigFx = function(){
      $scope.configProcessing = true;
      DevicesSrv.deleteConfig($scope.configId).then(
        function(data){
          $scope.getConfigFx("d");
        },
        function(err){
          $scope.configProcessing = false;
          $log.error(err);
        }
      );
    }
    $scope.highlightFx = function(fid, type){
      if(fid){
        $scope.fidArr = fid.split(",");
        for(var i=0; i<$scope.fidArr.length; i++){
          $(".frame[data-id = '"+ $scope.fidArr[i] + "']").addClass("highlight");
          $(".flList[data-id = '"+ $scope.fidArr[i] + "']").addClass("selectFlList")
          if(type == "frame"){
            $(".frameRow").each(function(){
              $scope.tempArr = $(this).attr("data-id").split(",");
              for(var j=0; j<$scope.tempArr.length; j++){
                if($scope.fidArr[i] == $scope.tempArr[j]){
                  $(this).addClass("highlight");
                  break;
                }
              }
            });
            $(".contentItem").each(function(){
              $scope.tempArr = $(this).attr("data-id").split(",");
              for(var j=0; j<$scope.tempArr.length; j++){
                if($scope.fidArr[i] == $scope.tempArr[j]){
                  $(this).addClass("highlight");
                  break;
                }
              }
            });
          }
        }
      }
    }
    $scope.unhilightFx = function(){
      $(".frame").removeClass("highlight");
      $(".contentItem").removeClass("highlight");
      $(".frameRow").removeClass("highlight");
      $(".flList").removeClass("selectFlList");
    }

    $scope.highlightSelectFx = function(fid, caller){
      // Select the radio button
      var radio = document.querySelector('input[name="layer"][value="'+fid+'"]');
      if($scope.highlightedFrame == fid){
        $scope.unhighlightSelectFx();
        $scope.currentSelectFrame = 0;
        $scope.highlightedFrame = 0;
        if(caller != 'content'){
          radio.checked = false;
        }
      } else{
        $scope.unhighlightSelectFx();
        $scope.highlightedFrame = fid;
        $scope.currentSelectFrame = fid;
        if(caller != 'content'){
          radio.checked = true;
        }
        for(var i=0; i<$scope.fidArr.length; i++){
          $(".frame[data-id = '"+ $scope.fidArr[i] + "']").addClass("highlightSelect");
          $(".flList[data-id = '"+ $scope.fidArr[i] + "']").addClass("selectedFlList");
          $(".frameRow").each(function(){
            $scope.tempArr = $(this).attr("data-id").split(",");
            for(var j=0; j<$scope.tempArr.length; j++){
              if($scope.fidArr[i] == $scope.tempArr[j]){
                $(this).addClass("highlightSelect");
                break;
              }
            }
          });
          $(".contentItem").each(function(){
            $scope.tempArr = $(this).attr("data-id").split(",");
            for(var j=0; j<$scope.tempArr.length; j++){
              if($scope.fidArr[i] == $scope.tempArr[j]){
                $(this).addClass("highlightSelect");
                break;
              }
            }
          });
        }
      }
    }

    $scope.unhighlightSelectFx = function(){
      $(".frame").removeClass("highlightSelect");
      $(".contentItem").removeClass("highlightSelect");
      $(".frameRow").removeClass("highlightSelect");
      $(".flList").removeClass("selectedFlList");
    }

    $scope.daChangeFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.taskLoading = true;
      DevicesSrv.getTask().then(
        function(data){
          $scope.taskObj = data;
          $scope.taskLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.taskLoading = false;
        }
      );
      if($scope.selectedT == 9){
        $scope.dtInfo.dType = "a";
        $scope.dtInfo.devices.device = [];
      }
    }

    /*Second ngDialog close*/
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });
    $scope.downloadLogOpen = function(){
      $scope.saveProcessing = false;
      $scope.hasErr = false;
      $scope.logs = {module:"d", date:{startDate:moment().subtract(1, "day")._d, endDate:moment()._d}};
      ngDialog.open({
        template:"app/common/popup/downloadLog.html",
        width:500,
        data:$scope.logs,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
      });
    }
    $scope.logsFx = function(){
      $scope.hasErr = false;
      $scope.saveProcessing = true;
      $scope.logsCopy = angular.copy({id:$rootScope.selectedItems[0].id, date:{startDate:moment($scope.logs.date.startDate).format("L"), endDate:moment($scope.logs.date.endDate).format("L")}});
      DevicesSrv.downloadLogs($scope.logsCopy).then(
        function(data){
          if(data.code == 12033){
            $scope.saveProcessing = false;
            $scope.hasErr = true;
          } else{
            $scope.logs.url = data.download;
            $scope.saveProcessing = false;
          }
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
        }
      );
    }

    /*Device control*/
    $scope.deviceControlOpen = function(id, label, dType, os){
      $scope.curDeviceControl = {id:id, label:label, dType:dType, os:os};
      ngDialog.open({
        template:'app/devices/popup/deviceControl.html',
        width:850,
        data:$scope.curDeviceControl,
        scope:$scope,
        controller:'DeviceControlController',
        closeByDocument:false,
        preCloseCallback:function(){
          $rootScope.checkReboot = false;
        }
      });
    }

    /*Tags Tab*/
    $scope.tagCUOpen = function(id, label, permis){
      $scope.dtag = {id:id, label:label, permission:permis};
      ngDialog.open({
        template:'app/devices/popup/tagCU.html',
        width:620,
        scope:$scope,
        data:$scope.dtag,
        closeByDocument:false,
        controller:'DevicesTagController',
      });
    }

    $scope.getTaskDetailsFx = function(tId){
      $scope.cOpen = false;
      $scope.pOpen = true;
      $scope.fOpen = true;
      $scope.taskDetails = {};
      DevicesSrv.getTaskDetails(tId).then(
        function(data){
          $scope.completeTask = data.queued_task.filter(function(obj){
            if(obj.iscompleted == 1){
              return obj;
            }
          });
          $scope.pendingTask = data.queued_task.filter(function(obj){
            if(obj.iscompleted == 0){
              return obj;
            }
          });
          $scope.failedTask = data.queued_task.filter(function(obj){
            if(obj.iscompleted == -1){
              return obj;
            }
          });
          $scope.taskDetails = data;
          $scope.taskQueueList = data.queued_task;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/devices/popup/taskList.html',
        width:750,
        data:$scope.taskDetails,
        scope:$scope,
        closeByDocument:false,
        closeByEscape:false
      });
    }

    $scope.cDToggleFx = function(event){
      $scope.cOpen = !$scope.cOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".completed-device").toggleClass('hide');
    }
    $scope.pDToggleFx = function(event){
      $scope.pOpen = !$scope.pOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".pending-device").toggleClass('hide');
    }
    $scope.fDToggleFx = function(event){
      $scope.fOpen = !$scope.fOpen;
      $(event.currentTarget).closest(".scrollQuad").children(".failed-device").toggleClass('hide');
    }

    $scope.taskFailInfoFx = function(data){
      $scope.resData = data;
      // $scope.dtArr = [];
      // $scope.itArr = [];
      // if(data.dt.length){
      //   data.dt.map(function(id){
      //     $scope.taskDetails.tags.find(function(item){
      //       if(item.id == id){
      //         $scope.dtArr.push(item.label);
      //       }
      //     })
      //   });
      // }
      // if(data.it.length){
      //   data.it.map(function(id){
      //     $scope.taskDetails.tags.find(function(item){
      //       if(item.id == id){
      //         $scope.itArr.push(item.label);
      //       }
      //     })
      //   });
      // }
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">\
              <div ng-if="resData.resp.code==12039">{{\'d.p_dg.m11\' | translate}}</div>\
              <div ng-if="resData.resp.code==12042">{{\'d.p_dg.m4\' | translate}}</div>\
              <div ng-if="resData.resp.code==12054">{{\'d.msg.36\' | translate}}</div>\
              <div ng-if="resData.resp.code==12069">{{\'d.msg.35\' | translate}}</div>\
              <div ng-if="resData.resp.code==12070">{{\'d.msg.34\' | translate}}</div>\
            </div>\
            <div class="panel-footer">\
              <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
            </div>\
          </section>',
        // template:'\
        //   <section class="panel">\
        //     <div class="panel-body">\
        //       <div ng-if="resData.resp.code==12039">{{\'d.p_dg.m11\' | translate}}</div>\
        //       <div ng-if="resData.resp.code==12079">{{\'d.msg.43\' | translate}}</div>\
        //       <div ng-if="resData.resp.code==12042">{{\'d.p_dg.m4\' | translate}}</div>\
        //       <div class="marT5">{{\'cm.label.71\' | translate}}: <span class="text-bold">{{resData.label}}</span></div>\
        //       <div class="table marT15" ng-if="dtArr.length > 0 || itArr.length > 0">\
        //         <div class="row th">\
        //           <div class="col-xs-6">{{\'d.label.42\' | translate | camelCase}}</div>\
        //           <div class="col-xs-6">{{\'d.label.43\' | translate | camelCase}}</div>\
        //         </div>\
        //         <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
        //           <div class="row">\
        //             <div class="col-xs-6 word-break"><span ng-repeat="tag in dtArr">\
        //               <span ng-if="dtArr.length">{{tag}}{{$last ? \'\' : \', \'}}</span></span>\
        //               <span ng-if="!dtArr.length" class="text-sm text-muted">N/A</span>\
        //             </div>\
        //             <div class="col-xs-6 word-break"><span ng-repeat="tag in itArr">\
        //               <span ng-if="itArr.length">{{tag}}{{$last ? \'\' : \', \'}}</span></span>\
        //               <span ng-if="!itArr.length" class="text-sm text-muted">N/A</span>\
        //             </div>\
        //           </div>\
        //         </div>\
        //       </div>\
        //     </div>\
        //     <div class="panel-footer">\
        //       <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
        //     </div>\
        //   </section>',
        plain:true,
        width:700,
        scope:$scope,
        data:$scope.resData,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    /*Action Botton*/
    $scope.addToGrpOpen = function(caller, folder){
      if (caller == "lvFolder") {
        $scope.closeAllFx();
        $rootScope.selectedItems = [{ id: folder.id, type: folder.type.toLowerCase(), subType: 'f', splId: folder.splId, spid: folder.spid, pid: folder.pid }];
      }
      $scope.curGroupIds = {};
      $scope.curGroupIds = $rootScope.selectedItems;
      if($scope.dASAllCheck.box && $scope.dASAll.length){
        $scope.curGroupIds = $scope.dASAll;
      }
      ngDialog.open({
        template:'app/devices/popup/addToGroup.html',
        width:710,
        scope:$scope,
        closeByDocument:false,
        controller:'AddToDeviceGrpController',
        preCloseCallback: function(){
          // if($scope.auth.upreferences.deviceView == "l"){
          //   $rootScope.selectedItems = [];
          // }
          $scope.isLVPopupOpen = false;
          $rootScope.selectedItems.type = "device";
        }
      });
    }
    $scope.addRemoveTagOpen = function(caller){
      $scope.curTagObj = {type:caller, ids:$rootScope.selectedItems};
      if($scope.dASAllCheck.box && $scope.dASAll.length){
        $scope.curTagObj = {type:caller, ids:$scope.dASAll};
      }
      ngDialog.open({
        template:'app/devices/popup/addRemoveTag.html',
        width:710,
        scope:$scope,
        closeByDocument:false,
        controller:'AddRemoveTagController'
      });
    }

    $scope.assignTagOpen = function(){
      $scope.curTagObj = {ids:$rootScope.selectedItems};
      if($scope.dASAllCheck.box && $scope.dASAll.length){
        $scope.curTagObj = {ids:$scope.dASAll};
      }
      ngDialog.open({
        template:'app/devices/popup/addRemoveTag.html',
        width:710,
        scope:$scope,
        closeByDocument:false,
        controller:'AddRemoveTagController'
      });
    }

    $scope.similarOpen = function(){
      $scope.similarFilter = {id:0,os:false,ip:false,aDate:false,res:false,dRestriction:false,tags:false,fl:false,dGroup:false,cGroup:false}
      ngDialog.open({
        template:'app/devices/popup/similar.html',
        width:580,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.filterSimilarDevices = function(){
      $scope.deviceProcessing = true;
      $scope.similarFilter.id = $scope.curSelectedItem[0].id;
      DevicesSrv.similarDevices($scope.similarFilter).then(
        function(data){
          $scope.deviceProcessing = false;
          $rootScope.selectedItems = data;
          ngDialog.close();
          for(var i = 0; i < data.length; i++){
            $('.ui-selectable li').each(function(){
              if(data[i].id == $(this).data("id")){
                $(this).addClass('ui-selected');
                $(this).find('input[type="checkbox"]').prop("checked", true);
                return false;
              }
            });
          }
          if($rootScope.selectedItems.length > 1){
            $scope.briefFx($rootScope.selectedItems);
          } else{
            $scope.briefFx($rootScope.selectedItems[0].id);
          }
        },
        function(err){
          $scope.deviceProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.searchChangeFx = function(){
      $scope.searchInfo.text = "";
      setTimeout(function(){
        if($(".table .row:not(.th)").length == 0){
          $scope.$apply(function(){
            $scope.deletableTags = [];
            $scope.deletableHistory = [];
          });
          angular.forEach($scope.devices.deviceTags, function(tag){
            tag.isChecked = false;
          });
          angular.forEach($scope.history, function(h){
            h.isChecked = false;
          });
        }
      }, 10);
    }

    $scope.curData = {};
    $scope.deleteOpen = function(tabName, id, selFolder){
      if(tabName == "history"){
        $scope.acknowledgeCloseFx();
      }
      if($scope.isConfirmOpen && !$scope.isDeletable){
        ngDialog.close();
      }else{
        $scope.isLVPopup = {open:true};
        $scope.isFExist = false;
        $scope.isDExist = false;
        $scope.isConfirmOpen = true;
        $scope.isDeletable = true;
        $scope.popupLoading = true;
        $scope.tempArr = [];
        if(tabName == "tags"){
          $(".table .row:not(.th)").each(function(){
            for(var i=0; i<id.length; i++){
              if($(this).attr("data-id") == id[i]){
                $scope.tempArr.push(id[i]);
                break;
              }
            }
          });
          $scope.deleteObj = {tabName:"tag", id:$scope.tempArr.toString()};
        } else if (tabName == "lvFolder") {
          $scope.closeAllFx();
          if(id==0 && selFolder.type=='Folder'){
            $scope.deleteObj = { tabName: "device", id: selFolder.id, selItem: selFolder };
          } else {
            $scope.deleteObj = { tabName: "device", id: id, selItem: selFolder };
          }
        } else{
          $scope.deleteObj = {tabName:tabName, id:id};
        }

        if(selFolder && selFolder.length){
          selFolder.forEach(function(item){
            if(item.type == "folder"){
              $scope.isFExist = true;
            }
            if(item.type == "device"){
              $scope.isDExist = true;
              return;
            }
          });
        }
        if($scope.auth.upermissions.dvw && ((tabName == 'device' && !selFolder && !$scope.isDExist) || (tabName == 'device' && selFolder && selFolder.length && $scope.isDExist))){
          $scope.dId = $rootScope.selectedItems.filter(function (item) {
            if (item.type == "device") {
              return item;
            }
          }).map(function (device) {
            return device.id.toString();
          });
          DevicesSrv.verifyDeletedDevice($scope.dId).then(
            function(data){
              $scope.popupLoading = false;
              if(data.code && data.code == 13016){
                $scope.vwName = data.vw;
                $scope.isVWAccess = data.vdwAccessible;
                $scope.isDeletable = false;
              } else{
                $scope.isDeletable = true;
              }
            },
            function(err){
              $scope.deviceProcessing = false;
              $log.error(err);
            }
          );
        } else{
          $scope.popupLoading = false;
          $scope.isDeletable = true;
        }
        // <span ng-if="isVWAccess">\
        //   {{"d.p_delete.8" | translate: {vwName: vwName} }}\
        // </span>\
        // <span ng-if="!isVWAccess">\
        //   {{"d.p_delete.9" | translate: {vwName: vwName} }}\
        // </span>\
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading text-bold" ng-if="deleteObj.tabName == \'device\' && isDeletable && !popupLoading"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
              <div class="panel-body">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
                <div ng-if="deleteObj.tabName == \'device\' && !popupLoading">\
                  <div ng-if="(!isFExist || !isDExist) && isDeletable" lang="{{auth.lang}}">\
                    <div ng-if="deleteObj.id">{{selectedItems.length > 1?"d.p_delete.6s":"d.p_delete.6" | translate}}</div>\
                    <div ng-if="!deleteObj.id">{{selectedItems.length > 1?"d.p_delete.1s":"d.p_delete.1" | translate}}</div>\
                  </div>\
                  <div ng-if="isFExist && isDExist && isDeletable" lang="{{auth.lang}}">\
                    {{"d.p_delete.7" | translate}}\
                  </div>\
                  <div ng-if="!isDeletable" lang="{{auth.lang}}">\
                    {{"d.p_delete.10" | translate}}\
                  </div>\
                </div>\
                <div ng-if="deleteObj.tabName != \'device\' && !popupLoading">\
                  <span ng-if="deleteObj.tabName == \'group\' || deleteObj.tabName == \'videowall\'" lang="{{auth.lang}}">{{selectedItems.length > 1?"cm.msg.35s":"cm.msg.35" | translate}}</span>\
                  <span ng-if="deleteObj.tabName == \'tag\'" lang="{{auth.lang}}">{{"d.p_delete.3" | translate}}</span>\
                  <span ng-if="deleteObj.tabName == \'search\'" lang="{{auth.lang}}">{{"cm.msg.35" | translate}}</span>\
                </div>\
                <div ng-if="deleteObj.tabName == \'history\' && !popupLoading" lang="{{auth.lang}}">{{"d.p_delete.5" | translate}}</div>\
              </div>\
              <footer class="panel-footer">\
                <img alt="Loading" src="assets/images/loading-xs.gif" ng-if="popupLoading">\
                <span  ng-if="!popupLoading">\
                  <button type="button" role="button" class="btn btn-danger btn-sm" ng-if="deleteObj.tabName == \'device\'  && isDeletable" ng-click="deleteFx();" focus-me="true" ng-disabled="deviceProcessing"><span class="fa fa-repeat fa-spin" ng-if="deviceProcessing" aria-hidden="true"></span>{{selectedItems.length > 1?"d.p_delete.12s":"d.p_delete.12" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-danger btn-sm" ng-if="deleteObj.tabName != \'device\'  && isDeletable" ng-click="deleteFx(deleteObj.id);" focus-me="true" ng-disabled="deviceProcessing"><span class="fa fa-repeat fa-spin" ng-if="deviceProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                  <button type="button" focus-me="true" role="button" class="btn btn-sm" ng-class="isDeletable?\'btn-link\':\'btn-default\'" ng-click="closeThisDialog();" data-dismiss="modal" >{{isDeletable? "cm.btn.9" : "cm.btn.10" | translate}}</button>\
                </span>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
          preCloseCallback:function(){
            $scope.isConfirmOpen = false;
          }
        });
      }
    }
    // todo we change the msg d.p_delete.4/d.p_delete.4s to d.p_delete.12

    $scope.deleteFx = function(id){
      $scope.deviceProcessing = true;
      $scope.stringIds = $scope.arraytoStringFx($rootScope.selectedItems); /*Array to String common*/
      if($scope.selectedTab === "hub.devices.d"){
        if(localStorage.getItem("isDlAdvSearch")){
          localStorage.setItem("isActionOnDevice", true);
        } else{
          localStorage.removeItem("isActionOnDevice");
          localStorage.removeItem("isDlAdvSearch");
          localStorage.removeItem("curFilterDlObj");
        }

        $scope.stringIds = $rootScope.selectedItems.filter(function(item){
          if(item.type == "device"){
            return item;
          }
        }).map(function(device){
          return device.id.toString();
        });

        // ?New: get folder ids
        $scope.fIdsArr = [];
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "folder"){
            $scope.fIdsArr.push(item.id);
          }
        });
        if($scope.deleteObj.selItem){
          $scope.fIdsArr.push($scope.deleteObj.selItem.id).toString();
        }

        var stringIds = $scope.stringIds;
        if($scope.stringIds.length){
          stringIds = $scope.stringIds[0];
          // stringIds = $scope.encryptFx($scope.stringIds[0]);
        }        

        DevicesSrv.deleteDevices(stringIds, $scope.fIdsArr.toString()).then(
          function(data){
            $scope.deviceProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );

      } else if($scope.selectedTab === "hub.devices.dt"){
        DevicesSrv.deleteTags($scope.stringIds).then(
          function(data){
            $scope.deviceProcessing = false;
            if(data.code == 12050){
              $scope.curData.conflict = data.conflict;
              $scope.confirmOpen();
            } else{
              //we are clearing Adv search state bcz if any one edit or delete tag/group
              $scope.advSearchInfo = undefined;
              $scope.advSApply = false;
              ngDialog.close();
              $scope.loadSelectedTab("refresh");
            }
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.dg"){
        $scope.deleteGSObj = {groupIds:"", searchIds:""};
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "group"){
            if($scope.deleteGSObj.groupIds.length > 0){
              $scope.deleteGSObj.groupIds += "," + item.id.toString();
            } else{
              $scope.deleteGSObj.groupIds = item.id.toString();
            }
          }
          else if(item.type == "search"){
            if($scope.deleteGSObj.searchIds.length > 0){
              $scope.deleteGSObj.searchIds += "," + item.id.toString();
            } else{
              $scope.deleteGSObj.searchIds = item.id.toString();
            }
          }
        });

        DevicesSrv.deleteGroups($scope.deleteGSObj).then(
          function(data){
            $scope.deviceProcessing = false;
            //we are clearing Adv search state bcz if any one edit or delete tag/group we need to handle loop for multiple delete
            $scope.advSearchInfo = undefined;
            $scope.advSApply = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.ds"){
        DevicesSrv.deleteGroups($scope.stringIds).then(
          function(data){
            $scope.deviceProcessing = false;
            //we are clearing Adv search state bcz if any one edit or delete tag/group we need to handle loop for multiple delete
            $scope.advSearchInfo = undefined;
            $scope.advSApply = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.di"){
        if(id.length > 1){
          angular.forEach(id, function(ids){
            if($scope.acknowledge.id === ids){
              $scope.acknowledgeCloseFx();
            }
          });
        } else if($scope.acknowledge.id === id){
          $scope.acknowledgeCloseFx();
        }
        DevicesSrv.deleteHistory(id).then(
          function(data){
            $scope.deviceProcessing = false;
            ngDialog.close();
            $scope.historyFx();
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.devices.dvw"){
        $scope.deleteVWObj = {vwIds:""};
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "videowall"){
            if($scope.deleteVWObj.vwIds.length > 0){
              $scope.deleteVWObj.vwIds += "," + item.id.toString();
            } else{
              $scope.deleteVWObj.vwIds = item.id.toString();
            }
          }
        });
        DevicesSrv.deleteVideoWall($scope.deleteVWObj).then(
          function(data){
            $scope.deviceProcessing = false;
            ngDialog.close();
            $scope.loadSelectedTab();
          },
          function(err){
            $scope.deviceProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.remDeviceFx = function(id, arr){
      // Find the index of the object with the specified ID
      var indexToRemove = arr.findIndex(function(obj) {
        return obj.id === parseInt(id);
      });

      // If the index is found (not -1), remove the object at that index
      if(indexToRemove !== -1){
        arr.splice(indexToRemove, 1);
      }
      $scope.devices.devices = angular.copy(arr);
      $scope.getTotalDeviceCountFx();
      if($scope.totalDPages == $scope.curNum){
        $scope.setCountFx("last");
      } else{
        $scope.setCountFx();
      }
    }

    $scope.remItemsFx = function(obj){
      if(obj.caller == "d"){
        if(obj.target=="dData"){
          angular.forEach(obj.items, function(item){
            angular.forEach($scope.dData.devices, function(d, i){
              if(item.id == d.id){
                $scope.dData.devices.splice(i, 1);
              }
            });
          })
        }
        // Find the index of the object with the specified ID
      }
      $scope.devices.devices = angular.copy($scope.dData.devices);
      $scope.getTotalDeviceCountFx();
      if($scope.totalDPages == $scope.curNum){
        $scope.setCountFx("last");
      } else{
        $scope.setCountFx();
      }
    }

    $scope.remFoldersFx = function(ids, arr){
      // Convert ids to an array of integers
      var idsToRemove = ids.map(function(id){
        return parseInt(id);
      });

      // Filter the array to exclude objects with IDs in the idsToRemove array
      var updatedArr = arr.filter(function(obj){
        return !idsToRemove.includes(obj.id);
      });

      // Update the scope variables
      $scope.folderList = angular.copy(updatedArr);
      $scope.getTotalDeviceCountFx();

      // Update the page count if necessary
      if($scope.totalDPages === $scope.curNum){
        $scope.setCountFx("last");
      } else{
        $scope.setCountFx();
      }
    }

    $scope.confirmOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div class="marB15">{{"d.msg.23" | translate}}</div>\
              <div class="table">\
                <div class="row th">\
                  <div class="col-xs-4">{{"d.tab.3" | translate}}</div>\
                  <div class="col-xs-4">{{"d.tab.2" | translate}}</div>\
                  <div class="col-xs-4">{{"s.tab.1" | translate}}</div>\
                </div>\
                <div class="scrollQuad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                  <div class="row" ng-repeat="con in curData.conflict">\
                    <div class="col-xs-4">{{con.tags.label}}</div>\
                    <div class="col-xs-4">\
                      <span ng-repeat="search in con.searches" class="word-break">{{search.label}} <span ng-if="!$last">,</span></span>\
                    </div>\
                    <div class="col-xs-4">\
                      <span ng-repeat="schedule in con.schedules" class="word-break">{{schedule.label}} <span ng-if="!$last">,</span></span>\
                    </div>\
                  </div>\
                </div>\
              </div>\
            </div>\
            <div class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger" ng-click="confirmTagFx(curData.caller);"><span class="fa fa-remove" aria-hidden="true"></span>{{"cm.btn.13" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeAll();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </div>\
          </section>',
        plain:true,
        width:700,
        scope:$scope,
        data:$scope.curData,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.closeAll = function(){
      ngDialog.closeAll();
    };

    $scope.closeAllFx = function(caller){
      $scope.ssIds = [];
      $scope.isSsChecking = false;
      ngDialog.closeAll();
      if(!caller){
        $scope.unselectTypeFx();
      }
    }

    $scope.confirmTagFx = function(){
      DevicesSrv.deleteTagsConfirm($scope.curData.conflict).then(
        function(data){
          $scope.deviceProcessing = false;
          ngDialog.close();
          $scope.loadSelectedTab();
        },
        function(err){
          $scope.deviceProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.previewObj = {};
    $scope.previewOpen = function(caller){
      $scope.hasErr = false;
      $scope.errType = "";
      if(!caller){
        $scope.previewObj = {isControls:false, id:$scope.curSelectedItem[0].id, label:$scope.curSelectedItem[0].l, eip:$scope.curSelectedItem[0].eip, mac:$scope.curSelectedItem[0].h, time:moment().format(), date:{startDate:moment().format('L'), endDate:moment().format('L')}};
      }
      ngDialog.close();
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"d.btn.11" | translate}}</h1> <span class="text-sm text-muted">[ {{previewObj.label}} ]</span></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cm.label.7" | translate}}</label>\
                <div class="input-group">\
                  <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                  <input type="daterange" class="form-control picker" ng-model="previewObj.date" format="MM/DD/YYYY" singleDatePicker="true" readonly="" aria-label="{{\'cm.label.7\' | translate}}" aria-labelledby="{{\'cm.label.7\' | translate}}">\
                </div>\
              </div>\
              <div class="form-group timepicker">\
                <label>{{"cm.label.8" | translate}}</label>\
                <span uib-dropdown auto-close="outsideClick" dropdown-append-to-body>\
                  <div class="input-group">\
                    <span class="input-group-addon"><span class="fa fa-clock-o" aria-hidden="true"></span></span>\
                    <input type="text" class="form-control picker" uib-dropdown-toggle ng-value="previewObj.time | date:\'shortTime\'" readonly="" aria-label="{{\'cm.label.8\' | translate}}" aria-labelledby="{{\'cm.label.8\' | translate}}">\
                  </div>\
                  <div class="dropdown-menu dropdown-to-body" uib-dropdown-menu>\
                    <div uib-timepicker ng-model="previewObj.time" hour-step="1" minute-step="5"></div>\
                  </div>\
                </span>\
              </div>\
              <div><label class="noMar"><input type="checkbox" ng-model="previewObj.isControls"><label></label> {{"d.label.28" | translate}}</label></div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="previewFx();"><span class="fa fa-film" aria-hidden="true"></span> {{"d.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">\
                <span ng-if="errType==\'date\'" aria-live="polite" role="status">{{"cm.msg.21" | translate}}</span>\
                <span ng-if="errType==\'time\'" aria-live="polite" role="status">{{"cm.msg.22" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:400,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false
      });
    }
    $scope.previewFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.previewObj.date == "" || $scope.previewObj.date == null){
        $scope.hasErr = true;
        $scope.errType = "date";
        return false;
      }
      if($scope.previewObj.time == "" || $scope.previewObj.time == null){
        $scope.hasErr = true;
        $scope.errType = "time";
        return false;
      }
      $scope.curPreviewObj = angular.copy($scope.previewObj);
      $scope.curPreviewObj.timestamp = moment($scope.previewObj.date.startDate).format('MM-DD-YYYY');
      $scope.curPreviewObj.time = moment(angular.copy($scope.previewObj).time).format("HH:mm");
      $scope.curPreviewObj.offset = new Date($scope.previewObj.date.startDate).getTimezoneOffset();
      $scope.curPreviewObj.iFrameUrl = $rootScope.dPreviewPath + $scope.previewObj.mac +"&cc="+ $scope.previewObj.isControls +"&ts="+ $scope.curPreviewObj.timestamp +"&t="+ $scope.curPreviewObj.time +"&"+ new Date().getTime();

      // $scope.curPreviewObj.date = {
      //   startDate:moment(angular.copy($scope.previewObj).date.startDate).format("L"),
      //   endDate:moment(angular.copy($scope.previewObj).date.endDate).format("L")
      // }

      ngDialog.close();
      ngDialog.open({
        template:'app/devices/preview/preview.html',
        width:"98%",
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        controller:"PreviewController",
        className:"ngdialog-theme-default ngdialog-preview",
        preCloseCallback:function(){
          $interval.cancel($rootScope.emTimer);
        }
      });
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.removeSelectedFx();
      // $scope.clearAllStoresDB();
      $scope.apiCalledArr = [];
      $rootScope.selectedItems = [];
      $scope.searchMsg = false;
      $scope.devicesLoading = false;

      if($rootScope.clearSearch && !args.info.isLoadMore && ((args.module && args.module=='d') || (args.info && args.info.module=='d'))){
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove && ((args.module && args.module=='d') || (args.info && args.info.module=='d'))){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }

      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }

      if($scope.isDBInfo){
        $scope.folderListDBInfo = [];
        $scope.contentListDBInfo = [];
      } else{
        $scope.isGbdt = false;
        // if(!args.isLV){
        //   $scope.filter = "all";
        // }
        $scope.contentList = [];
        $scope.folderList = [];
        // $scope.search = {text:""};
      }


      if(args.dInfo && args.dInfo.timthumb){
        $scope.tim = args.dInfo.timthumb;
        $scope.bucket = $scope.detailBucket = args.dInfo.bucket;
        if(args.dInfo.mbucket && args.dInfo.mbucket != ""){
          $scope.detailBucket = args.dInfo.mbucket;
        }
      }
      if(args.dInfo && args.dInfo.de){
        $scope.devices.info = args.dInfo;
      }
      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.search.text && $scope.search.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            $scope.devices = angular.copy($scope.sData);
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            $scope.devices = angular.copy($scope.asData);
            $scope.statusObj.as = true;
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};
          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }
        $scope.devices.info.sortVal = args.info.sortVal;
        $scope.devices.info.sortType = args.info.sortType;

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          if(args.dInfo && args.dInfo.allIds){
            $scope.devices.info.allIds = args.dInfo.allIds;
          }
        }

        $scope.isAdvSearch = true;
      }
      if(!$rootScope.isObjectEmpty(args.advObj) && (!angular.isUndefined(args.advObj)) && args.advObj.module == 'd'){
        $scope.advObj = args.advObj;
      }
      if(angular.isUndefined($scope.advObj)){
        localStorage.removeItem("advSearchOpen");
      } else{
        localStorage.setItem('advSearchOpen', true);
      }

      $rootScope.offset = (args.info.isOSet ? $rootScope.offset : 0);
      $rootScope.curItems = [];
      $rootScope.selectedItems = [];
      $rootScope.tmpBriefDevices = [];
      $rootScope.multiSelDevices = [];

      if($scope.isDBInfo){
        $scope.advSearchDInfo = args.info;
      } else {
        $scope.advSearchInfo = args.info;
      }
      if(args.folder){
        if($scope.isDBInfo){
          $scope.folderListDBInfo = args.folder;
        } else {
          $scope.folderList = args.folder;
        }
        $scope.contentLibrary.contentLibrary.folder = [];
        $scope.contentLibrary.contentLibrary.folder = args.folder;
      }
      // $scope.contentList = args.content;
      if(args.content){
        $scope.contentLibrary.contentLibrary.content = args.content;
        $scope.curArgsContent = [];
        if($scope.isDBInfo){
          angular.forEach(args.content, function(item){
            if(item.type == "Image" || item.type == "WORD" || item.type == "Vector"){
              $scope.curArgsContent.push(item);
            }
          });
        } else {
          angular.forEach(args.content, function(item){
            if(item.type == "Image"){
              $scope.curArgsContent.push(item);
            }
          });
        }
        if($scope.isDBInfo){
          $scope.contentListDBInfo = $scope.curArgsContent;
        } else {
          $scope.contentList = $scope.curArgsContent;
        }
      }

      if(($scope.contentList && !$scope.contentList.length) && ($scope.folderList && !$scope.folderList.length)){
        $scope.advSearchInfo.isEmpty = true;
      }
      if($scope.contentList && $scope.contentList.length){
        $scope.contentLibrary.contentLibrary.content = $scope.contentList;
      }

      if($scope.isDBInfo){
        $scope.advSearchDI = true;
      } else {
        $scope.advSearch = true;
      }
      // if(($scope.auth.upermissions.dp || $scope.rdc > $scope.auth.upreferences.dpc) && !$scope.devices.types){
      //   if($scope.isAdvSearch){
      //     $scope.setCountFx();
      //   } else {
      //     $scope.setCountFx();
      //   }
      // }
      if(((args.info && args.info.module!='cl') || (args.module && args.module!='cl')) || ($scope.advSearchInfo && $scope.advSearchInfo.module=='d')){
        $scope.advSApply = true;
      } else {
        $scope.advSApply = false;
      }
      $scope.setCountFx();

      $scope.filterType = $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
        $scope.filter = "all";
      }
      if($scope.treeList && $scope.treeList !=0 && $scope.treeList.length){
        $scope.treeList.forEach(function(item){
          item.collapsed = true;
        });
      }
      $scope.reloadTree();
      $scope.unselectTypeFx();
      if($scope.advSApply){
        $scope.contextMenuBase = [];
      }
      if(args.deviceInfo){
        $scope.devices.info = args.deviceInfo;
      }

      if(args.code == 8118){
        $scope.firstApply = {filter:false,search:false}
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
        $scope.isSearchMsg = false;
        $scope.curFolderId = 0;
        localStorage.removeItem("fc");
        // localStorage.removeItem("filterType");
        localStorage.removeItem("curDFId");
        if($scope.isDBInfo){
          $scope.advSearchDInfo = {};
        } else {
          $scope.advSApply = false;
          $scope.advSearchInfo = {};
          $scope.advSearchInfo = undefined;
          $scope.curAdvSearchCopy = {};
        }

        // $scope.filter = "all";
        if(($scope.advSearchInfo && $scope.advSearchInfo.type == null && $scope.selectedTab != 'hub.devices.d') || ($scope.isDBInfo && $scope.advSearchDInfo && !$scope.advSearchDInfo.type) || ($scope.selectedTab == 'hub.devices.di' && !$scope.advSearchInfo)){
          $scope.contentLoading = true;
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              if($scope.isDBInfo){
                $scope.advSearchDI = false;
              } else {
                $scope.advSearch = false;
              }
              $scope.updateListContentFx();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
        if(!$scope.isDBInfo){
          $scope.statusObj.as = false;
          $scope.advSearchInfo = undefined;
          $scope.loadSelectedTab();
        }

        // var filterType = localStorage.getItem("filterType");

        // if(angular.isUndefined(filterType) || filterType == "all"){
        //   $scope.filterType = "";
        //   $scope.filter = "all";
        // } else {
        //   $scope.filterType = filterType;
        //   $scope.filter = filterType;
        // }

      }
      $scope.getTotalDeviceCountFx();
    });

    /*Advanced Search*/
    $scope.advancedSearchDOpen = function(caller, step, id, opt){
      $scope.advSearchObj = {caller:caller, step:step, id:id, opt:opt};
      $scope.dialogW = 1024;
      if(caller == "s"){
        $scope.dialogW = 650;
      }
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type=='df'){
        $scope.redirectFolderId = localStorage.getItem("curDFId");
        if($scope.redirectFolderId != 0){
          // $cookies.put("curFId", 0, {secure:true});
          localStorage.setItem("curDFId", 0);
          $scope.curFolderId = 0;
          $scope.loadSelectedTab();
        }
      }
      ngDialog.open({
        template: "app/common/popup/advancedSearch.html",
        width: $scope.dialogW,
        scope: $scope,
        data: $scope.advSearchObj,
        closeByEscape: false,
        closeByDocument: false,
        controller: "AdvancedSearchController",
        preCloseCallback: function(caller){
          if(caller == "close" && $scope.redirectFolderId != 0){
            // $cookies.put("curFId", $scope.redirectFolderId, {secure:true});
            localStorage.setItem("curDFId", $scope.redirectFolderId);
            // $scope.curFolderId = $cookies.get("curFId");
            $scope.curFolderId = localStorage.getItem("curDFId");
            $scope.loadSelectedTab();
          }
        }
      });
    }

    /*Knowledge base*/
    $scope.videoFx = function(tabName){
      $scope.videoObj = {tabName:tabName};
      $scope.videoObj.url = $sce.trustAsResourceUrl($scope.videoEmbed + "CRJUIjgmBYo" + $scope.videoParam);
      ngDialog.open({
        template:'app/devices/popup/video.html',
        width:580,
        data:$scope.videoObj,
        scope:$scope
      });
    }
    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {tabName:tabName};
      ngDialog.open({
        template:'app/devices/popup/info.html',
        width:580,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    $scope.editAssignment = function(id){
      ngDialog.close();
      $state.go("hub.flContainer.flaName", {id:$scope.hubEncrypt(id)});
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if ($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen) {
        angular.forEach($scope.deviceBtn.buttons, function (btn) {
          if (btn.key == "dDelete" || btn.key == "dtDelete" || btn.key == "dgDelete" || btn.key == "dsDelete" || btn.key == "dDeleteFolder" || btn.key == "dvwDelete") {
            $scope.isDeletable = true;
            if(btn.kdy == "dDeleteFolder"){
              $scope.isDelFolder = true;
            }
          }
        });
        if ($scope.isDeletable) {
          if ($scope.selectedTab === "hub.devices.d") {
            if($rootScope.selectedItems.length==1 && $rootScope.selectedItems[0].type=='device'){
              $scope.deleteOpen("device");
            } else {
              $scope.deleteOpen("device", $rootScope.selectedItems[0].id, $rootScope.selectedItems);
            }
          } else if ($scope.selectedTab === "hub.devices.dt") {
            $scope.deleteOpen('tag');
          } else if($scope.selectedTab === "hub.devices.dg"){
            $scope.deleteOpen('group');
          } else if($scope.selectedTab === "hub.devices.ds"){
            $scope.deleteOpen('search');
          } else if($scope.selectedTab === "hub.devices.dvw"){
            $scope.deleteOpen('videowall');
          }
        }
      }
    }

    $scope.propertyFilter = function(item){
      return item.value == 'true' || item.value == 1;
    }

    //select all assign & available devices
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      $scope.nonSelDevices = [];
      deviceList.forEach(function(item){
        if(!item.isWM){
          item.selected = true;
          $scope.nonSelDevices.push(item);
        }
      });
      if($scope.nonSelDevices.length){
        deviceList = $scope.nonSelDevices;
      }
      if(caller=="a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      if(!selectedItems.isWM){
        angular.forEach(deviceList, function(item){
          if(item.id==selectedItems.id){
            item.selected = !item.selected;
            if(caller == "a"){
              if(item.selected){
                $rootScope.dAList.push(item);
              } else{
                angular.forEach($rootScope.dAList, function(listItem, i){
                  if(!listItem.selected || listItem.id==selectedItems.id){
                    $rootScope.dAList.splice(i, 1);
                  }
                });
              }
            } else if(caller == "s"){
              if(item.selected){
                $rootScope.dSList.push(item);
              } else{
                angular.forEach($rootScope.dSList, function(listItem, i){
                  if(!listItem.selected || listItem.id==selectedItems.id){
                    $rootScope.dSList.splice(i, 1);
                  }
                });
              }
            }
            $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
          }
        });
      }
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      });
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }

    //select all assign & available groups
    $rootScope.selAllGroupFx = function(caller, groupList){
      groupList.forEach(function(item){
        item.selected = true;
      });
      if(caller=="a"){
        if($scope.curGroups.assignedGroups.length){
          $scope.curGroups = {availableGroups:angular.copy(groupList), assignedGroups:$scope.curGroups.assignedGroups};
          $rootScope.gSList = $scope.curGroups.assignedGroups;
        } else{
          $rootScope.gSList = [];
          $scope.curGroups = {availableGroups:angular.copy(groupList), assignedGroups:[]};
        }
        $rootScope.gAList = $scope.curGroups.availableGroups;
      } else{
        if($scope.curGroups.availableGroups.length){
          $scope.curGroups = {availableGroups:$scope.curGroups.availableGroups, assignedGroups:angular.copy(groupList)};
          $rootScope.gAList = $scope.curGroups.availableGroups;
        } else{
          $rootScope.gAList = [];
          $scope.curGroups = {availableGroups:[], assignedGroups:angular.copy(groupList)};
        }
        $rootScope.gSList = $scope.curGroups.assignedGroups;
      }
    }
    //select/deselect single assign & available groups
    $scope.selGroupFx = function(caller, selectedItems, groupList){
      angular.forEach(groupList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.gAList.push(item);
            } else{
              angular.forEach($rootScope.gAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.gAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.gSList.push(item);
            } else{
              angular.forEach($rootScope.gSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.gSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curGroups = {availableGroups:$rootScope.gAList, assignedGroups:$rootScope.gSList};
        }
      });
    }
    //deselect all assign & available Groups
    $scope.deSelAllGroupFx = function(caller, groupList){
      angular.forEach(groupList, function(item){
        item.selected = false;
      });
      if(caller=="a"){
        $rootScope.gAList = [];
        $scope.curGroups.availableGroups = [];
      } else{
        $rootScope.gSList = [];
        $scope.curGroups.assignedGroups = [];
      }
    }

    //select all assign & available tags
    $rootScope.selAllTagFx = function(caller, tagList){
      tagList.forEach(function(item){
        item.selected = true;
      });
      if(caller=="a"){
        if($scope.curTags.assignedTags.length){
          $scope.curTags = {availableTags:angular.copy(tagList), assignedTags:$scope.curTags.assignedTags};
          $rootScope.tSList = $scope.curTags.assignedTags;
        } else{
          $rootScope.tSList = [];
          $scope.curTags = {availableTags:angular.copy(tagList), assignedTags:[]};
        }
        $rootScope.tAList = $scope.curTags.availableTags;
      } else{
        if($scope.curTags.availableTags.length){
          $scope.curTags = {availableTags:$scope.curTags.availableTags, assignedTags:angular.copy(tagList)};
          $rootScope.tAList = $scope.curTags.availableTags;
        } else{
          $rootScope.tAList = [];
          $scope.curTags = {availableTags:[], assignedTags:angular.copy(tagList)};
        }
        $rootScope.tSList = $scope.curTags.assignedTags;
      }
    }
    //select/deselect single assign & available tags
    $scope.selTagFx = function(caller, selectedItems, tagList){
      angular.forEach(tagList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.tAList.push(item);
            } else{
              angular.forEach($rootScope.tAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.tSList.push(item);
            } else{
              angular.forEach($rootScope.tSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curTags = {availableTags:$rootScope.tAList, assignedTags:$rootScope.tSList};
        }
      });
    }
    //deselect all assign & available tags
    $scope.deSelAllTagFx = function(caller, tagList){
      angular.forEach(tagList, function(item){
        item.selected = false;
      });
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curTags.availableTags = [];
      } else{
        $rootScope.dSList = [];
        $scope.curTags.assignedTags = [];
      }
    }

    //Reset selected devices, groups and tag list
    $rootScope.resetSelDGTList = function(){
      $rootScope.resetD();
      $rootScope.resetG();
      $rootScope.resetT();
      $rootScope.resetSortingFx();
    }
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }
    $rootScope.resetG = function(caller){
      $rootScope.gAList = [];
      $rootScope.gSList = [];
      if(caller == "add" && $scope.curGroups.assignedGroups.length){
        $scope.curGroups = {availableGroups:[], assignedGroups:$scope.curGroups.assignedGroups};
      } else if(caller == "remove" && $scope.curGroups.availableGroups.length){
        $scope.curGroups = {availableGroups:$scope.curGroups.availableGroups, assignedGroups:[]};
      } else{
        $scope.curGroups = {availableGroups:[], assignedGroups:[]};
      }
    }
    $rootScope.resetT = function(caller){
      $rootScope.tAList = [];
      $rootScope.tSList = [];
      if(caller == "add" && $scope.curTags.assignedTags.length){
        $scope.curTags = {availableTags:[], assignedTags:$scope.curTags.assignedTags};
      } else if(caller == "remove" && $scope.curTags.availableTags.length){
        $scope.curTags = {availableTags:$scope.curTags.availableTags, assignedTags:[]};
      } else{
        $scope.curTags = {availableTags:[], assignedTags:[]};
      }
    }

    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.templateBtn = [];
      $scope.dFolderBrief = [];
      $scope.contextMenuOpt = [];
      $timeout.cancel($scope.promise);
      $scope.filType = "all";
      if($scope.filterType=="online"){
        $scope.filType = "on";
      } else if($scope.filterType=="offline"){
        $scope.filType = "off";
      }
      DevicesSrv.getFolderBrief(obj[0].id, obj[0].splId, obj[0].type, $scope.filType).then(
        function (data) {
          $scope.dFolderBrief = data;
          if ($scope.selectedTab === "hub.devices.d" && obj[0].type != "folder") {/*Button api*/
            $scope.getBtnFx("d");
          }
        },
        function (err) {
          $log.error(err);
        }
      );
      /*Button api*/
      if ($scope.selectedTab === "hub.devices.d" && obj[0].type == "folder") {
        $scope.getBtnFx("d");
      }
    }

    $scope.getBtnFx = function (caller) {/*Button api*/
      if (caller == "d") {
        $scope.dASAllBtnLoading = true;
        $scope.deviceBtn = [];
        DevicesSrv.saveTemplateBtn($rootScope.selectedItems).then(
          function (data) {
            $scope.dASAllBtnLoading = false;
            $scope.deviceBtn = data;
            $scope.updateContextMenu($scope.deviceBtn);
          },
          function (err) {
            $log.error(err);
          }
        );
      }
    }

    $scope.folderCUOpen = function (type, caller) {
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.folderObj = { fType: type };
      if (caller == "edit") {
        $scope.folderObj.label = $scope.dFolderBrief.label;
        $scope.folderObj.id = $scope.dFolderBrief.id;
      } else {
        $scope.folderObj.fid = $scope.curFolderId;
      }

      ngDialog.open({
        template: "app/devices/popup/folderCU.html",
        width: 620,
        scope: $scope,
        data: $scope.folderObj,
        closeByDocument: false,
        controller: "DFolderCUController",
      });
    }

    $scope.lvFolderCUOpen = function (type, id) {
      $scope.closeAllFx();
      $scope.folderObj = {id:id, fType: type };
      $scope.lvPopLoading = true;
      DevicesSrv.getFolderDetails(id).then(
        function (data) {
          $scope.lvPopLoading = false;
          $scope.folder = data;
          $scope.folderObj.label = $scope.folder.info.label;
          $scope.folderObj.id = $scope.folder.info.id;
        },
        function (err) {
          $log.error(err);
        }
      );
      ngDialog.open({
        template: "app/devices/popup/folderCU.html",
        width: 620,
        scope: $scope,
        data: $scope.folderObj,
        closeByDocument: false,
        controller: "DFolderCUController",
        preCloseCallback: function(){
          $scope.isLVPopupOpen = false;
        }
      });

    }

    $rootScope.reloadTree = function () {
      // // $scope.curFolderId = $cookies.get("curDFId");
      $scope.curFolderId = localStorage.getItem("curDFId");
      // console.warn("reload tree", $scope.curFolderId);
      if (!$scope.curFolderId) {
        $scope.curFolderId = 0;
      }

      $scope.treeLoading = true;
      $scope.treeList = [];
      setTimeout(function(){
        DevicesSrv.getTree($scope.curFolderId).then(
          function (data) {
            $scope.treeLoading = false;
            $scope.treeList = data.tree;
            setTimeout(function(){
              $scope.selectedTreeItem($scope.advSApply?0:$scope.curFolderId);
            });
            if($scope.advSApply && $scope.treeList != "0" && $scope.treeList.length){
              $scope.treeList.forEach(function(item){
                item.collapsed = true;
              });
            }
            // $scope.selectedTreeItem($scope.curFolderId);
          }
        );
      }, 1000);
    }

    //! above and below commented code now woking properly that's why its commented not when user open the tree always called API to get updated data

    $rootScope.checkDFTree = function () {
      // if ($scope.treeList == 0) {
        $scope.treeLoading = true;
        $scope.reloadTree();
      // } else {
      //   setTimeout(function(){
      //     $scope.selectedTreeItem($scope.advSApply?0:$scope.curFolderId);
      //   });
      // }
    }

    $scope.selectedTreeItem = function(id){
      // console.log(id);
      $(".tree-view a.home").removeClass("selected");
      $("div[data-tree-model] li span.selected").removeClass("selected");
      $("div[data-tree-model]").find("#" + id).children("span").addClass("selected");
      if(id == 0){
        $(".tree-view a.home").addClass("selected");
      }
    }

    /*For click on tree folder view*/
    $scope.$on('treeId', function (event, treeFolderId, splId, type, treeId) {
      if (treeFolderId.toString().split("|").length > 1) {
        $rootScope.selectedSPfId = treeFolderId;
      } else {
        // $scope.ftype = "cp";
        $scope.folderContentFx(treeFolderId);
      }
    });

    $scope.moveOpen = function (folder, caller) {
      $rootScope.curFType = "move";
      $scope.lvPopLoading = true;
      $scope.isLVPopup = {open:true};
      $scope.folderListStr = "";
      if (caller == "lvFolder") {
        $scope.closeAllFx();
        $scope.folderListStr = "/" + folder.id;
        $rootScope.selectedItems = [{ id: folder.id, type: folder.type.toLowerCase(), subType: 'f', splId: folder.splId, spid: folder.spid, pid: folder.pid }];
      } else {
        angular.forEach($scope.selectedItems, function(item){
          if(item.type == "folder" || item.type == "shortcut"){
            if($scope.folderListStr == ""){
              $scope.folderListStr = "/" + item.id;
            } else{
              $scope.folderListStr += "," + item.id;
            }
          }
        });
      }
      $scope.curMoveObj = [];
      $scope.moveObj = { type: "move", server: null, curServerTree:""};
      DevicesSrv.getMoveTree($scope.folderListStr).then(
        function(data){
          $scope.lvPopLoading = false;
          $scope.moveObj = {type:"move", server:null, curServerTree:data.tree};
        }
      );
      ngDialog.open({
        template: "app/devices/popup/move.html",
        width: 580,
        scope: $scope,
        data: $scope.moveObj,
        closeByDocument: false,
        controller: "MoveDController",
        preCloseCallback: function(){
          $scope.isLVPopupOpen = false;
        }
      });
    }

    //For get device list on view button from folder brief
    $scope.folderDeviceListFx = function (id, label) {
      $scope.load = false;
      $scope.loading = false;
      $scope.deviceView = { id: id, label: label };
      $scope.popupLabel = label;
      $scope.scrollDataList = [];
      $scope.deviceListObj = { id: id };
      $scope.marRemove = true;
      $scope.refreshObj = { l: true, b: false };
      // localStorage.setItem("curDFId", id);
      $scope.filType = "all";
      if($scope.filterType=="online"){
        $scope.filType = "on";
      } else if($scope.filterType=="offline"){
        $scope.filType = "off";
      }
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.haveMoreSearchData = false;
      $scope.searchScroll = false;
      $scope.scrollObj = {caller: 'dFolder', offset: 0, id: id, fil: $scope.filType}
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          // console.log("data",data);
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
          $scope.marRemove = false;
          $scope.refreshObj = { l: false, b: true };
        },
        function(err){
          $log.error(err);
        }
      );
      // DevicesSrv.getDeviceList(id, $scope.filType).then(
      //   function (data) {
      //     $scope.deviceList = data;
      //     $scope.marRemove = false;
      //     $scope.refreshObj = { l: false, b: true };
      //   },
      //   function (err) {
      //     $log.error(err);
      //   }
      // );
      ngDialog.open({
        template: 'app/devices/popup/deviceList.html',
        width: 755,
        scope: $scope,
        closeByEscape: false,
        closeByDocument: false,
      });
    }

    $scope.downloadDbListFx = function (caller, subType, val, label) {
      if (angular.isUndefined(subType)) {
        $scope.downloadObj = { type: "", subType: $scope.detailsObj.label, devices: [] };
      } else {
        $scope.downloadObj = { type: "", subType: subType, devices: [] };
      }
      var isPost = false;
      if (caller == "ccs") {
        isPost = true;
        $scope.downloadObj.type = "ccsDevices";
      } else if (caller == "dps") {
        isPost = true;
        $scope.downloadObj.type = "dpsDevices";
      } else if (caller == "dpts") {
        isPost = true;
        $scope.downloadObj.type = "dptsDevices";
      } else if (caller == "ds") {
        isPost = true;
        $scope.downloadObj.type = "dsDevices";
      } else if (caller == "dts") {
        isPost = true;
        if ($scope.downloadObj.subType == "mp") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.1');
        } else if ($scope.downloadObj.subType == "webos") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.5');
        } else if ($scope.downloadObj.subType == "tizen") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.6');
        } else if ($scope.downloadObj.subType == "mc") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.4');
        } else if ($scope.downloadObj.subType == "gf") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.2');
        } else if ($scope.downloadObj.subType == "v") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.3');
        } else if ($scope.downloadObj.subType == "desktop") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.7');
        } else if ($scope.downloadObj.subType == "epd") {
          $scope.downloadObj.subType = $filter("translate")('d.label.1.8');
        }
        $scope.downloadObj.type = "dtsDevices";
      } else if (caller == "ssdt") {
        isPost = true;
        $scope.downloadObj.type = "ssdtDevices";
      } else if (caller == "ssdpt") {
        isPost = true;
        $scope.downloadObj.type = "ssdptDevices";
      } else if (caller == "ssodt") {
        isPost = true;
        $scope.downloadObj.type = "ssodtDevices";
      } else if (caller == "dtps") {
        isPost = true;
        if ($scope.downloadObj.subType == "n") {
          $scope.downloadObj.subType = "No issues";
        } else if ($scope.downloadObj.subType == "c") {
          $scope.downloadObj.subType = "Caution";
        } else if ($scope.downloadObj.subType == "d") {
          $scope.downloadObj.subType = "Danger";
        }
        $scope.downloadObj.type = "dtpsDevices";
      } else if (caller == "dccl") {
        isPost = true;

        if ($scope.downloadObj.subType == "cc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8');
        } else if ($scope.downloadObj.subType == "poncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.1');
        } else if ($scope.downloadObj.subType == "pofcc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.8.2');
        } else if ($scope.downloadObj.subType == "oncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.1');
        } else if ($scope.downloadObj.subType == "ofcc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.3');
        }

        else if ($scope.downloadObj.subType == "ncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.1');
        } else if ($scope.downloadObj.subType == "ponncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.2');
        } else if ($scope.downloadObj.subType == "pofncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.7.3');
        } else if ($scope.downloadObj.subType == "onncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.2');
        } else if ($scope.downloadObj.subType == "ofncc") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.4');
        }

        else if ($scope.downloadObj.subType == "nsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6');
        } else if ($scope.downloadObj.subType == "onnsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.1');
        } else if ($scope.downloadObj.subType == "ofnsd") {
          $scope.downloadObj.subType = $filter("translate")('db.body.21.6.2');
        }
        $scope.downloadObj.type = "dcclDevices";
      }
      $scope.stringIds = $scope.arraytoStringFx(val); /*Array to String common*/
      $scope.downloadObj.devices = $scope.stringIds;
      if (isPost) {
        $rootScope.linkOpenObj = { loading: true, url: "", surl: "" };
        $scope.linkOpenFx('d');
        DashboardSrv.postDowanloadExcel($scope.downloadObj).then(
          function (data) {
            if (data.code == 18009) {
              $scope.hasErr = true;
              $scope.errType = "noData"
            } else {
              $rootScope.linkOpenObj = { loading: false, url: data.url, surl: "" };
              // $scope.linkOpenFx(data.url);
            }
          },
          function (err) {
            $log.error(err);
          }
        );
        return;
      }
    }

    // Circuit Bench
    $scope.getCBTime = function(){
      $scope.innerLoading = true;
      DevicesSrv.getCBTime().then(
        function(data){
          $scope.cbObj = data;
          $scope.innerLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.innerLoading = false;
        }
      );
    }

    $scope.forceUpdateOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.46" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" class="btn btn-danger btn-sm" ng-click="forceUpdateFx();" focus-me="true" ng-disabled="forceUpdating"><span class="fa fa-repeat fa-spin" ng-if="forceUpdating"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-sm btn-link" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.forceUpdateFx = function(){
      $scope.forceUpdating = true;
      DevicesSrv.forceUpdateCBTime($scope.auth.server).then(
        function(data){
          $scope.cbObj = data;
          $scope.forceUpdating = false;
          $scope.getCBTime();
          ngDialog.close();
        },
        function(err){
          $log.error(err);
          $scope.forceUpdating = false;
        }
      );
    }

    $scope.getDsgValueInAction = function(){
      CommonSrv.getGroupDeviceSettings('device').then(
        function(data){
          $scope.confirmObj = {dsg:data.dsg};
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearDateFx = function(obj){
      obj.isblank = true;
    }

    $scope.selectDateFx =  function(obj){
      obj.isblank = false;
    }

    $scope.saveDeviceInfoFx = function(){
      $scope.hasErr = false;
      for(var i = $scope.device.info.info.length - 1; i >= 0; i--){
        if($scope.device.info.info[i].label == "" && ($scope.device.info.info[i].value == "" && !$scope.device.info.info[i].vFile)){
          $scope.device.info.info.splice(i, 1);
        } else if($scope.device.info.info[i].label == "" && ($scope.device.info.info[i].value != "" || $scope.device.info.info[i].vFile)){
          $scope.errType = "label";
          $scope.hasErr = true;
          return;
        }
      }
      $scope.saveDeviceInfo();
    }

    $scope.dSaveInfo = {id : '', mac : '', dType : '', otherInfo : [], properties : [], switches : []};
    $scope.saveDeviceInfo = function(){
      $scope.isHaveOneDT = false;
      if($scope.device.info.info.length){
        angular.forEach($scope.device.info.info, function(item){
          if(item.vType == 'dt'){
            item.dateRange = {startDate:moment(item.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(item.dateRange.endDate).format('MM/DD/YYYY')}
            item.value = item.dateRange.startDate + " " + moment(item.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
          }
        })
      }
      if($scope.device.info.properties.length){
        angular.forEach($scope.device.info.properties, function(item){
          if(item.vType == 'd' || item.vType == 'dt'){
            if(item.dateRange){
              item.dateRange = {startDate:moment(item.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(item.dateRange.endDate).format('MM/DD/YYYY')}
            }
            if(item.vType == 'd'){
              if(!item.isblank){
                item.value = item.dateRange ? item.dateRange.startDate : "";
              } else{
                item.value = null;
              }
            } else {
              if(!item.isblank && item.time){
                item.value = item.dateRange.startDate + " " + moment(item.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
              } else{
                item.value = null;
              }
            }
          }
          if(item.vType == 'ti'){
            if(item.time){
              item.value = moment(item.time).format("HH:mm:ss");
            } else{
              item.value = null;
            }
          }
        })
      }
      if($scope.device.info.properties.length){
        angular.forEach($scope.device.info.properties, function(obj){
          if(obj.vType == 'dt'){
            if((obj.isblank && obj.time && obj.value == null) || (!obj.isblank && !obj.time && obj.value == null)){
              $scope.isHaveOneDT = true;
            }
          }
        })
      }
      if($scope.isHaveOneDT){
        $scope.saveDInfoProcessing = false;
        $scope.errType = "haveOne";
        $scope.hasErr = true;
      } else{
        $scope.dSaveInfo.id = $scope.device.info.id;
        $scope.dSaveInfo.mac = $scope.device.info.mac;
        $scope.dSaveInfo.dType = $scope.device.info.dType;
        $scope.dSaveInfo.otherInfo = $scope.device.info.info;
        $scope.dSaveInfo.properties = $scope.device.info.properties;
        $scope.dSaveInfo.switches = $scope.device.info.switches;
        $scope.saveDInfoProcessing = true;
        DevicesSrv.updateDeviceInfo($scope.dSaveInfo).then(
          function(data){
            $scope.saveDInfoProcessing = false;
            localStorage.setItem("addedDeviceId", $scope.device.info.id);
            ngDialog.close();
          },
          function(err){
            $scope.saveDInfoProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.licInfoOpen = function(info, label){
      // console.warn(info);
      $scope.licObj = {info:info, label:label, emails:info.ie.split(",")};
      $scope.infoLoading = true;
      ngDialog.open({
        template:"app/devices/popup/licInfo.html",
        width:750,
        scope:$scope,
        data:$scope.licObj,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-logList",
      });
    }

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.devicesLoading = true;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      if($scope.selectedTab == "hub.devices.d"){
        if(!$rootScope.isObjectEmpty($scope.advSearchInfo) && (!angular.isUndefined($scope.advSearchInfo)) && $scope.advSearchInfo.module == 'd'){
          localStorage.setItem("curAdvSearchCopy", JSON.stringify($scope.advSearchInfo));
        }
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
        var fId = localStorage.getItem("curDFId");
        // console.warn($scope.advSearchInfo);
        if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.search.text).then(
            function(data){
              $scope.devicesLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.sortType = data.info.sortType;
              $scope.curAdvSearchObj.sortVal = data.info.sortVal;
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true, t:data.t, dInfo:data.info, deviceInfo:data.info};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          if(fId > 0){
            $scope.folderContentFx(fId,null,null,"changeView");
          } else {
            $scope.loadSelectedTab("changeView", $rootScope.offset > 0 ? true : false);
          }
        }
      }
      // deregister();
      // $scope.loadSelectedTab();
    });
    $scope.$on('$destroy', function() {
      $scope.advSearchInfo = {};
    });

    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData) {
      // Deep compare the new data with the current data
      if (!angular.equals($scope.currentPageDevice, newData.curData)) {
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if (!angular.equals($scope.allPageDevice, newData.allData.length)) {
        $scope.allPageDevice = angular.copy(newData.allData.length);
      }
    }

    // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data) {
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function() {
      return $scope.currentPageDevice.map(function(obj) {
          return obj.id;
      }).join(',');
    };

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.currentPageDevice = newVal
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for (var i = 1; i <= allPagesCount; i++) {
              $scope.pageDeviceArr.push({pNo:i, tz:new Date().getTime()})
            }
          }else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for (var i = 1; i <= allPagesCount - start; i++) {
              $scope.pageDeviceArr.push({pNo:start +i, tz:new Date().getTime()})
            }
          }
        }
      }
    }, true); // 'true' for deep watch


    // * scroll list data code START 2nd phase pagination
    $scope.updateDefineVariable();

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj) {
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj) {
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder" || $scope.copyScrollObj.caller == "ss"){
        $scope.loading = false;
        $scope.refreshObj = {l:true, b:false};
        $scope.marginLoad = true;
        $scope.marRemove = false;
      } else if($scope.copyScrollObj.caller == "ug"){
        $scope.ugDevicePopupLoading = true;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder"|| $scope.copyScrollObj.caller == "ss"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            } else if($scope.copyScrollObj.caller == "ug"){
              $scope.ugDevicePopupLoading = false;
            } else if($scope.copyScrollObj.caller == "dFolder"){
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }

            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "dt" || $scope.copyScrollObj.caller == "dg" || $scope.copyScrollObj.caller == "dFolder" || $scope.copyScrollObj.caller == "ss"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            } else if($scope.copyScrollObj.caller == "ug"){
              $scope.ugDevicePopupLoading = false;
            } else if($scope.copyScrollObj.caller == "dFolder"){
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj) {
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      });
    }, 0);

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: encodeURIComponent(text) });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: encodeURIComponent(text) });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    $scope.storeDataList = {};
    $scope.$on('curSelDevice', function (e, obj){
      $scope.storeDataList = obj.obj;
      if(obj.caller == "ir"){
        $scope.devices.info.devices.assignedDevices = obj.selDevice;
      } else if(obj.caller == "tv"){
        $scope.dsInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "oi"){
        $scope.duoInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "tag"){
        $scope.dutInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "prop"){
        $scope.dupInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "onOffSch"){
        $scope.dtInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "du"){
        $scope.duInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "wm"){
        $scope.dwInfo.devices.device = obj.selDevice;
      } else if(obj.caller == "ed"){
        $scope.dueInfo.devices.device = obj.selDevice;
      }

    });
    // * scroll list data code END 2nd phase pagination
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceVideoWallCUController', DeviceVideoWallCUController);

  /** @ngInject */
  function DeviceVideoWallCUController($log, $rootScope, $scope, $state, $filter, ngDialog, DevicesSrv, CommonSrv, DvwCUSrv){
    $rootScope.selectedMenu = 5;
    $scope.selectedTab = $state.current.name;
    $rootScope.wallSelectedItems = {info:{}, devices:[]};
    $scope.deviceDvw = {info:{label:"",row:"",col:""}, wallList:[]};
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.searchDevice = {text:""}

    $scope.deviceVWLoading = true;
    $scope.saveProcessing = false;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.thumbSize = 'n';

    $scope.paginationLoading = false;
    $scope.pagination = [];
    $scope.preMatrix = false;
    $scope.cells = [];
    $scope.curWallId = 0;
    $scope.ss = {isOpen:false};
    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.advSApply = false;
    $scope.filterIsAppliedAlready = false;
    $scope.rdc = 0;
    $rootScope.addStatusKeyVal = {value: true};
    $scope.isPageApiLoad = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $rootScope.commonSearchVar = "";

    $scope.ipAddressPattern = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(316);
      $scope.selectedHeight = $scope.getAvailableHeight(316);
    } else{
      $scope.selectedHeight = $scope.getAvailableHeight(425) * 0.4;
      $scope.quadHeight = $scope.getAvailableHeight(425) * 0.6;
    }

    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceList = function(action){
      $scope.deviceListLoading = true;
      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      $scope.dReqObj = {caller:"vdw",type:null,offset:0,filter:$scope.filter,fId:($scope.curFolderId>0)?$scope.curFolderId:0,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),vdwId:""};
      if($scope.encId){
        $scope.dReqObj.vdwId = $scope.decId;
      }
      $scope.getDeviceAndProcessFx($scope.dReqObj, 'dList', false, action);
    }

    if($state.params.id){
      $scope.encId = $state.params.id;
      $scope.devicesLoading = false;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      DvwCUSrv.getVideoWallDetails($scope.decId).then(
        function(data){
          $scope.deviceDvw.info = data.info;
          $scope.deviceDvw.wallList = data.walllist;
          $scope.tim = $scope.deviceDvw.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = $scope.deviceDvw.info.bucket;
          if($scope.deviceDvw.info.mbucket && $scope.deviceDvw.info.mbucket != ""){
            $scope.dDetailBucket = $scope.deviceDvw.info.mbucket;
          }
          if($scope.selectedTab === "hub.dContainer.dvwName"){
            $scope.deviceVWLoading = false;
          }
          $scope.createMatrixFx();
        },
        function(err){
          $log.error(err);
          $scope.deviceVWLoading = false;
        }
      );
    } else{
      $scope.deviceVWLoading = false;
      $scope.deviceDvw = {info:{label:"",row:"",col:""}, wallList:[]};
    }

    $scope.createMatrixOpen = function(){
      if($scope.preMatrix && $scope.deviceDvw.wallList.length){
        ngDialog.open({
          template:'\
            <section class="panel">\
              <div class="panel-body">{{"d.msg.70" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="createMatrixFx(\'reset\');closeThisDialog();">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      } else {
        $scope.createMatrixFx();
      }
    }
    $scope.createMatrixFx = function(caller) {
      var rows = $scope.deviceDvw.info.row;
      var cols = $scope.deviceDvw.info.col;
      if(caller == "reset"){
        $scope.deviceDvw.wallList = [];
      }
      if(!rows){
        $scope.hasErr = true;
        $scope.errType = "row";
        $("#row").focus();
      } else if(!cols){
        $scope.hasErr = true;
        $scope.errType = "col";
        $("#col").focus();
      } else {
        $scope.hasErr = false;
        $scope.errType = "";
        $scope.cells = [];
        $scope.cellList = [];
        for (var i = 0; i < rows; i++) {
          var row = [];
          for (var j = 0; j < cols; j++) {
            row.push({ label: String.fromCharCode(65 + j) + (i + 1) , device:""}); // Generating label for each cell
          }
          $scope.cells.push(row);
        }

        if($scope.cells.length){
          angular.forEach($scope.cells, function(mat){
            for (var i = 0; i < mat.length; i++) {
              $scope.cellList.push({label: mat[i].label, isSel:false});
            }
          });
        }
        if($scope.deviceDvw.wallList.length){
          angular.forEach($scope.cellList, function(c){
            c.isSel = false;
            angular.forEach($scope.deviceDvw.wallList, function(wlc){
              if(wlc.cell.label == c.label){
                c.isSel = true;
              }
            })
          });

          $scope.updateCellsFx($scope.deviceDvw.wallList);
        }

        $scope.preMatrix = true;
      }
    };

    // $scope.deviceSearchFocus = function () {
    //   $scope.searchDevice = {text:""};
    //   if ($scope.deviceList.devices.length > 5) {
    //     angular.element(document).find(".findSearch").children()[0].focus();
    //   }
    // }

    // $rootScope.selDeviceFx = function (device) {
    //   $scope.ss.isOpen = !$scope.ss.isOpen;
    //   $scope.deviceLabel = device;
    //   $scope.addWall.device = device;
    //   angular.element(document).find('.customSelectChannel').removeClass('open')
    // }

    // $scope.toggleCallback= function(){
    //   $scope.searchDevice.text = "";
    // }

    $scope.addWall = {id:"", device:"", cell:"", isMaster:false, edit:false};
    $scope.addWallFx = function(){
      $scope.hasErrPop = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.addWall.device = $rootScope.wallSelectedItems.devices;
      // if($scope.addWall.cell == ''){
      //   $scope.hasErr = true;
      //   $scope.errType = "cell";
      //}
      if($scope.addWall.device == '' || !$scope.addWall.device){
        $scope.hasErrPop = true;
        $scope.errType = "device";
      } else{
        $scope.addWall.id = "w" + $scope.curWallId;
        $scope.deviceDvw.wallList.push($scope.addWall);
        $scope.curWallId++;
        $scope.deviceLabel = "";

        $scope.updateCellsFx($scope.addWall, "add");
        $scope.addRemListItemFx($scope.addWall, "add");
        ngDialog.close();
      }
    }

    $scope.addRemListItemFx = function(curAddItem, caller){
      //add remove device from dropdown
      // $scope.deviceList.devices = $scope.deviceList.devices.filter(function(d){
      //   return d.id != curAddItem.device.id;
      // });
      // //add remove matrix from dropdown
      // $scope.cellList = $scope.cellList.filter(function(m){
      //   return m.label != curAddItem.cell.label;
      // });
      //make first one master by default
      if($scope.deviceDvw.wallList.length){
        angular.forEach($scope.deviceDvw.wallList, function(wl){
          if(wl.id == curAddItem.id){
            wl.isMaster = curAddItem.isMaster;
          }
        })
      }
      if(caller == "add"){
        angular.forEach($scope.deviceDvw.wallList, function(wl){
          wl.isMaster = false;
        });
        $scope.deviceDvw.wallList[0].isMaster = true;
      }
      $scope.addWall = {id:"", device:"", cell:"", isMaster:false};
    }

    // $scope.cancelWallItemFx = function(curRemItem){
    //   curRemItem = $scope.copyWall.item;
    //   $scope.deviceLabel = "";
    //   $scope.wallEdit.edit = !$scope.wallEdit.edit;
    //   $scope.addRemListItemFx(curRemItem);
    // }

    $scope.deleteWallOpen = function(id){
      $scope.hasErr = false;
      $scope.hasErrPop = false;
      $scope.errType = "";
      if($scope.wallEdit && $scope.wallEdit.edit){
        $scope.cancelWallItemFx($scope.addWall);
      }
      $scope.deleteId = id;
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">{{"cm.msg.34" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteWallFx();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteWallFx = function(){
      //remove item from wall listing
      angular.forEach($scope.deviceDvw.wallList, function(list){
        if($scope.deleteId == list.id){
          $scope.curDelItem = $scope.deviceDvw.wallList.splice($scope.deviceDvw.wallList.indexOf(list), 1);
        }
      });

      //add removed device and matrix in dropdown
      // $scope.deviceList.devices.push($scope.curDelItem[0].device);
      // $scope.cellList.push({label:$scope.curDelItem[0].cell.label});

      // if($scope.deviceDvw.wallList.length){
      //   $scope.deviceDvw.wallList[0].isMaster = true;
      // }
      //make first one master by default
      if($scope.deviceDvw.wallList.length){
        if(!$scope.curDelItem[0].isMaster){
          angular.forEach($scope.deviceDvw.wallList, function(wl){
            if(wl.id == $scope.curDelItem[0].id){
              wl.isMaster = $scope.curDelItem[0].isMaster;
            }
          })
        } else {
          angular.forEach($scope.deviceDvw.wallList, function(wl){
            wl.isMaster = false;
          });
          $scope.deviceDvw.wallList[0].isMaster = true;
        }
      }

      $scope.updateCellsFx($scope.curDelItem, 'delete');
      ngDialog.close();
    }

    $scope.updateCellsFx = function(wallList, caller){
      $scope.cells.forEach(function(cell){
        cell.forEach(function(c){
          if(caller == "add" || caller == "update"){
            if(wallList.cell.label == c.label){
              c.dType = wallList.device.dType;
              c.status = wallList.device.status;
              c.mac = wallList.device.mac;
              c.dLabel = wallList.device.label;
              c.wId = wallList.id;
              c.thumbV = wallList.device.thumbV;
            }
          } else if(caller == "remove"){
            if(wallList.cell.label == c.label){
              c.dType = "";
              c.status = "";
              c.mac = "";
              c.dLabel = "";
              c.wId = "";
              c.thumbV = "";
            }
          } else {
            angular.forEach(wallList, function(wlc){
              if(wlc.cell.label == c.label){
                if(caller=='delete'){
                  c.dType = "";
                  c.status = "";
                  c.mac = "";
                  c.dLabel = "";
                  c.wId = "";
                  c.thumbV = "";
                } else {
                  c.dType = wlc.device.dType;
                  c.status = wlc.device.status;
                  c.mac = wlc.device.mac;
                  c.dLabel = wlc.device.label;
                  c.wId = wlc.id;
                  c.thumbV = wlc.device.thumbV;
                }
              }
            });
          }
        })
      });
    }

    $scope.checkIfArrayIsUnique = function(myArray){
      for(var i = 0;i < myArray.length;i++){
        for(var j = 0;j < myArray.length;j++){
          if(i != j){
            if(myArray[i].device.localIp == myArray[j].device.localIp){
              return true;
            }
          }
        }
      }
      return false; // means there are no duplicate values.
    }

    $scope.saveVideoWallFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.allHaveLocalIp = $scope.deviceDvw.wallList.every(function(item) {
        return item.device && $scope.ipAddressPattern.test(item.device.localIp);
        // return item.device && item.device.localIp;
      });
      // $scope.haveSameIp = $scope.checkIfArrayIsUnique($scope.deviceDvw.wallList);
      if($scope.deviceDvw.info.label == ""){
        $scope.errType = "name";
        $scope.hasErr = true;
        $("#label").focus();
      } else if($scope.deviceDvw.wallList.length == 0){
        $scope.hasErr = true;
        $scope.errType = "list";
      } else if(!$scope.allHaveLocalIp){
        $scope.hasErr = true;
        $scope.errType = "ipAddress";
      } else {
        $scope.modifiedList = [];
        $scope.finalObj = angular.copy($scope.deviceDvw);

        $scope.deviceDvw.wallList.forEach(function(list){
          $scope.modifiedList.push({id:list.id, device:{id:list.device.id, label:list.device.label, status:list.device.status, mac:list.device.mac, dType:list.device.dType, thumbV:list.device.thumbV, localIp:list.device.localIp}, cell:list.cell, isMaster:list.isMaster});
        });
        $scope.finalObj.wallList = $scope.modifiedList;
        if($scope.finalObj.info.col * $scope.finalObj.info.row != $scope.finalObj.wallList.length){
          $scope.hasErr = true;
          $scope.errType = "matrix";
        } else {
          $scope.saveProcessing = true;
          DvwCUSrv.saveDvw($scope.finalObj).then(
            function(data){
              $scope.saveProcessing = false;
              if(data.code == 12022){
                $scope.errType = "exists";
                $scope.hasErr = true;
                $("#label").focus();
              } else if(data.code == 15029){
                $scope.hasErr = true;
                $scope.errType = "schedule";
              } else if(data.code == 12060){
                $scope.errType = "dupDevice";
                $scope.hasErr = true;
              } else {
                $state.go("hub.devices.dvw");
              }
            },
            function(err){
              $scope.saveCloseProcessing = false;
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.search = {text:""};
    $scope.selectDevice = function(cell){
      $scope.isAdvSearchActive = false;
      $scope.hasErr = false;
      $scope.hasErrPop = false;
      $scope.errType = "";
      $rootScope.wallSelectedItems = {info:{}, devices:[]};
      // $scope.searchChangeFx("empty");
      $scope.addWall.cell = cell;
      $scope.search.text = "";
      $rootScope.reportSelectedItems.devices = []
      $scope.deviceListLoading = true;
      $scope.isAdvSearch = false;

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      $scope.dReqObj = {caller:"vdw",type:null,offset:0,filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),vdwId:$scope.decId};

      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
        $scope.dfilter = "all";
      } else {
        $scope.dfilter = $scope.filterType;
      }

      $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);

      // DevicesSrv.getDevice($scope.dObj).then(
      //   function(data){
      //     $scope.deviceList = data;
      //     $scope.deviceListLoading = false;
      //     $scope.devices = data;
      //     $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
      //     $scope.addTypeKey($scope.devices);
      //     if ($scope.devices.folders) {
      //       $scope.folderList = $scope.devices.folders;
      //     }
      //     if ($scope.devices.info.breadCrumbs) {
      //       $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
      //     }
      //     $scope.tim = $scope.devices.info.timthumb;
      //     $scope.bucket = $scope.dBucket = $scope.dDetailBucket = $scope.devices.info.bucket;
      //     if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
      //       $scope.detailBucket = $scope.dDetailBucket = $scope.devices.info.mbucket;
      //     }
      //     $scope.devicesCopy = angular.copy(data);
      //     $scope.devicesLength = data.devices.length;

      //     $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      //     if(!$scope.filterType || $scope.filterType=="all"){
      //       $scope.filterType = "";
      //       $scope.dfilter = "all";
      //       $scope.fCount = ($scope.devices.devices.length > 0 ? $scope.devices.devices : null);
      //     } else {
      //       $scope.dfilter = $scope.filterType;
      //       $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
      //     }



      //     // $scope.devices = data;
      //     // if ($scope.devices.folders) {
      //     //   $scope.folderList = $scope.devices.folders;
      //     // }
      //     // if ($scope.devices.info.breadCrumbs) {
      //     //   $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
      //     // }
      //     // $scope.tim = $scope.devices.info.timthumb;
      //     // $scope.bucket = $scope.dBucket = $scope.dDetailBucket = $scope.devices.info.bucket;
      //     // if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
      //     //   $scope.detailBucket = $scope.dDetailBucket = $scope.devices.info.mbucket;
      //     // }
      //     // $scope.devicesCopy = angular.copy(data);
      //     // $scope.devicesLength = data.devices.length;

      //     // $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      //     // if(!$scope.filterType || $scope.filterType=="all"){
      //     //   $scope.filterType = "";
      //     //   $scope.dfilter = "all";
      //     //   $scope.fCount = ($scope.devices.devices.length > 0 ? $scope.devices.devices : null);
      //     // } else {
      //     //   $scope.dfilter = $scope.filterType;
      //     //   $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
      //     // }
      //     // $scope.updateList();
      //   },
      //   function(err){
      //     $scope.deviceListLoading = false;
      //     $log.error(err);
      //   }
      // );
      $scope.deviceObj = {
        isSplitV:$scope.auth.upreferences.isSplitV,
        deviceView:$scope.auth.upreferences.deviceView,
        thumbBigParam:$scope.thumbBigParam,
        quadHeight:$scope.quadHeight,
        selectedHeight:$scope.selectedHeight,
        dvwId:$scope.decId
      };

      // $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      // if(!$scope.filterType || $scope.filterType=="all"){
      //   $scope.filterType = "";
      //   $scope.dfilter = "all";
      //   $scope.fCount = ($scope.devices.devices.length > 0 ? $scope.devices.devices : null);
      // } else {
      //   $scope.dfilter = $scope.filterType;
      //   $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
      // }

      ngDialog.open({
        template:'app/devices/popup/selectSingleDevice.html',
        width:1100,
        scope:$scope,
        data:$scope.deviceObj,
        closeByEscape:false,
        closeByDocument:false,
        appendClassName:"ng-dialog-padT50",
        controller:'SelectDeviceController',
        preCloseCallback:function(){
          $rootScope.selectedItems = [];
          $scope.advSearchInfo = {};
          localStorage.removeItem("curDType");
        }
      });
    }

    // $scope.selectedTreeItem = function(id){
    //   $(".tree-view a.home").removeClass("selected");
    //   $("div[data-tree-model] li span.selected").removeClass("selected");
    //   $("div[data-tree-model]").find("#" + id).children("span").addClass("selected");
    //   if(id == 0){
    //     $(".tree-view a.home").addClass("selected");
    //   }
    // }

    // $scope.setDeviceRange = function(devices, curPage){
    //   if(curPage){
    //     $scope.pageFilter = angular.copy($scope.devices.info.pl > 0 ? $scope.devices.info.pl : $scope.devices.info.count);
    //     if(curPage==1){
    //       $scope.drFrom = 1;
    //       $scope.drTo = $scope.pageFilter;
    //     } else if(curPage==2){
    //       $scope.drFrom = $scope.pageFilter + 1;
    //       $scope.drTo = $scope.pageFilter += $scope.pageFilter;
    //     } else if(curPage > 2){
    //       $scope.drTo = curPage * $scope.pageFilter;
    //       $scope.drFrom = $scope.drTo - $scope.pageFilter + 1;
    //     }
    //     if($scope.devices.info.count < $scope.drTo){
    //       $scope.drTo = $scope.devices.info.count;
    //     }
    //     $scope.deviceRange = $scope.drFrom + " - " + $scope.drTo;
    //   } else {
    //     $scope.drFrom = 1;
    //     if(devices.info.count < devices.info.pl){
    //       $scope.drTo = devices.info.count;
    //       $scope.deviceRange = $scope.drFrom + " - " + $scope.drTo;
    //     } else {
    //       $scope.deviceRange = $scope.drFrom + " - " + (devices.info.pl ? devices.info.pl: devices.devices.length);
    //     }
    //   }
    // }

    $scope.unselectTypeFx = function(){
      $rootScope.tmpBriefDevices = [];
      $rootScope.multiSelDevices = [];
      $rootScope.selectedItems = [];
      $rootScope.curItems = [];
      $scope.contextMenuOpt = [];
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      setTimeout(function(){
        angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        });
      }, 100);
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.deviceListLoading = true;
      $scope.curTimestamp = moment().format('x');
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      // $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.deviceListLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchDevice.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.searchDevice.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:"vdw",type:null,offset:0,filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),vdwId:""};
        if($scope.encId){
          $scope.dReqObj.vdwId = $scope.decId;
        }
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      $scope.setCountFx();
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $rootScope.offset = 0;

      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchDevice.text = "";
        $scope.searchText = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchDevice.text = "";
        $scope.search.text = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }

      $scope.advSearchInfo = args.info;
      $scope.searchMsg = false;
      $scope.deviceTypes = "";
      $scope.folderList = [];
      $scope.breadCrumbs = [];
      $scope.isAdvSearchActive = false;
      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.searchDevice.text && $scope.searchDevice.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            $scope.devices = angular.copy($scope.sData);
            $scope.setCountFx();
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            $scope.devices = angular.copy($scope.asData);
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};
          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          $scope.devices.info = args.dInfo;
          if($scope.devices.info){
            $scope.tim = $scope.devices.info.timthumb;
            $scope.bucket = $scope.dBucket = $scope.detailBucket = $scope.devices.info.bucket;
            if($scope.devices.info.mbucket && $scope.devices.info.mbucket != ""){
              $scope.detailBucket = $scope.dDetailBucket = $scope.devices.info.mbucket;
            }
          }
        }
        $scope.isAdvSearch = true;
      }
      $scope.devices.folders = args.folders;
      $scope.advSearchInfo = args.info;

      if($scope.advSearchInfo.os != null || $scope.advSearchInfo.client != null || $scope.advSearchInfo.dName != null || $scope.advSearchInfo.createdBy != null || $scope.advSearchInfo.sName != null || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || ($scope.advSearchInfo.tag && ($scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length))){
        $scope.deviceObj.quadHeight = $scope.getAvailableHeight(400);
        $scope.deviceObj.selectedHeight = $scope.getAvailableHeight(400);
      } else if($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length){
        $scope.deviceObj.quadHeight = $scope.getAvailableHeight(320);
        $scope.deviceObj.selectedHeight = $scope.getAvailableHeight(320);
      }
      $scope.advSearch = true;
      //clear folder list if adv search active
      if($scope.isAdvSearchActive && $scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df'){
        $scope.folderList = [];
        $scope.breadCrumbs = [];
      }
      if(args.code == 8118 && !$scope.isAdvSearchActive){
        $scope.isAdvSearch = false;
        $scope.advSearchInfo.isEmpty = false;
        $scope.advSearchInfo.step = undefined;
        $scope.searchDevice.text = "";
        $scope.search.text = "";
        $scope.searchText = "";
        $scope.curFolderId = 0;
        localStorage.removeItem("curDFId");
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.advSApply = false;
        $scope.advSearchInfo = {};
        $scope.folderList = [];
        $scope.curFolderId = 0;
        $rootScope.commonSearchVar = "";

        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {caller:"vdw",auth:$scope.auth,offset:0,text:$scope.searchDevice.text,filter:$scope.filter, fId:$scope.curFolderId,vdwId:""};
        if($scope.encId){
          $scope.dReqObj.vdwId = $scope.decId
        }
        $scope.getDeviceAndProcessFx($scope.dReqObj,"dList", false);
      }
    });

    $scope.devicePreviewFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($rootScope.reportSelectedItems.devices, function(data){
          if(data.id == obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.tv = obj.tv;
            }
            data.lp = obj.lp;
          }
        })
        outerLoopCounter++;
        if (outerLoopCounter === totalOuterLoops) {
          $scope.temSelectedArr = angular.copy($rootScope.reportSelectedItems.devices);
          $rootScope.reportSelectedItems.devices = [];
          $rootScope.reportSelectedItems.devices = $scope.temSelectedArr;
        }
      })
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){        
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        $scope.dReqObj = {caller:"vdw",type:null,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:($scope.curFolderId>0)?$scope.curFolderId:0,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),vdwId:$scope.decId};

        // if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
        if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          if($scope.encId){
            $scope.curAdvSearchObj.vdwId = $scope.encId;
            $scope.curAdvSearchObj.vdw = true;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchDevice.text).then(
            function(data){
              $scope.deviceListLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = true;
              $scope.curAdvSearchObj.isRemove = false;
              if(!angular.isUndefined($scope.rdc)){
                $scope.curAdvSearchObj.rdc = $scope.rdc;
              } else{
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true,dInfo:data.info, deviceInfo:data.info};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    };

    // By AP
    // $scope.selPageChangeHandler = function(){
    //   $('#pagingCtrlClone li').removeClass('active');
    //   // console.warn("Count", $scope.bothDeviceAndTags.list.length);
    //   var pages = Math.ceil($scope.bothDeviceAndTags.list.length / $scope.paginationControls.pageSize);
    //   $scope.totalDPages = Math.ceil($scope.bothDeviceAndTags.list.length / $scope.paginationControls.pageSize);
    // };

    // By AP
    // $scope.resetSelPagination = function(caller){
    //   if(caller=="all"){
    //     $scope.resetSelFx();
    //   }
    //   var searchData = angular.copy($filter("customSearch")($scope.bothDeviceAndTags.list, {key:$scope.selectedSearch.text, module:'dSel'}));
    //   if(searchData.length>$scope.auth.upreferences.dpc && !caller){
    //     resetSelPageFx(1);
    //   }
    // }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore, action){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }
      DevicesSrv.getDevice(dReqObj).then(
        function(data){
          $scope.deviceListLoading = false;
          $scope.firstDeviceLoading = false;
          $scope.isPageApiLoad = false;
          // $scope.moreDeviceLoading = false;
          $scope.devicesLoading = false;
          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);

          $scope.tim = data.info.timthumb;
          $scope.bucket = $scope.dBucket = $scope.dDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.detailBucket = $scope.dDetailBucket = data.info.mbucket;
          }
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }

          // get device of types
          if(caller=='openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller=='dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else {
              $scope.dData = angular.copy(data);
            }
            $scope.devices = angular.copy($scope.dData);

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.filter = "all";
              $scope.fCount = $scope.devices.devices;
            } else{
              $scope.filter = $scope.filterType;
            }

            $scope.folderList = $scope.devices.folders;
            $scope.loadingMain = false;
          }

          if($scope.totalDPages > 1 && $scope.curNum > 1 && $scope.totalDPages == $scope.curNum){
            $scope.setCountFx("last");
          } else{
            $scope.setCountFx();
          }
          $scope.updateList(isLoadMore);

          //for fix #9
          if(action && action != "changeView"){
            $scope.updateSelectedDevice();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.deviceListLoading = true;
      $scope.searchDevice.text = "";
      $scope.searchText = "";
      $scope.search.text = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      //Adv search implemented
      // if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
      if(!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        $scope.curAdvSearchObj.offset = 0;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchDevice.text).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
            $scope.curAdvSearchObj.vl = data.info.tc;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            // $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true, t:data.t, dInfo:data.info, deviceInfo:data.info};
            if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
              $scope.advSearchfilteredData.dInfo = data.info;
            } else{
              $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
            }
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else {
        $scope.advSApply = false;
        $scope.deviceListLoading = true;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        // $scope.dReqObj = {caller:"vdw",type:null,offset:0,filter:$scope.filter,fId:$scope.curFolderId,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),vdwId:""};
        $scope.dReqObj = {caller:"vdw",type:null,offset:0,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,fId:$scope.curFolderId,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.search.text,vdwId:""};
        if($scope.encId){
          $scope.dReqObj.vdwId = $scope.decId;
        }
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller=='last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
        $scope.visibleDevices = ($scope.visibleDevices == 0?$scope.auth.upreferences.dpc:$scope.visibleDevices);
      } else{
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
      }

      // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
      if($scope.filter && $scope.filter != "all" && ((!$scope.dData.devices.length && !$scope.devices.devices.length) && !$scope.advSApply)){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchDevice.text && $scope.searchDevice.text.length && !$scope.devices.devices.length){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.searchDevice.text && $scope.searchDevice.text.length && !$scope.devices.devices.length){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchDevice.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }

    // var searchTimeout;
    $scope.searchChangeFx = function(text){
      $rootScope.commonSearchVar = text;
      if(!text){
        $scope.clearSearchFx();
        return;
      } else {
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        if(text){
          $scope.deviceListLoading = true;
          $rootScope.clearSearch = false;
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          //Adv search implemented
          $scope.paginationControls.currPage = 1;
          $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
          if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
            $scope.curAdvSearchObj = $scope.advSearchInfo;
            if($scope.filter != "all"){
              $scope.filterType = $scope.filter
              $scope.curAdvSearchObj.fil = $scope.filter;
            } else{
              $scope.filterType = "";
            }
            $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
            $scope.curAdvSearchObj.offset = 0;
            CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchDevice.text).then(
              function(data){
                $scope.deviceListLoading = false;
                $scope.filteredData = data;
                $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                $scope.curAdvSearchObj.isLoadMore = false;
                if(data.info.rdc || data.info.rdc == 0){
                  $scope.curAdvSearchObj.rdc = data.info.rdc;
                }
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else{
            $rootScope.offset = 0;
            $scope.deviceListLoading = true;
            $scope.filter = JSON.parse(localStorage.getItem("filterType"));
            $scope.dReqObj = {caller:"vdw",type:null,offset:0,auth:$scope.auth,text:$scope.searchDevice.text,filter:$scope.filter,fId:$scope.curFolderId, vdwId:""};
            if($scope.encId){
              $scope.dReqObj.vdwId = $scope.decId;
            }
            $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
          }
        }
      }
    }

    $scope.updateList = function(){
      // $scope.searchChangeFx('empty');
      $scope.dASAll = [];
      // $scope.dASAllCheck.box = false;
      $scope.devicesLoading = false;
      if($scope.searchDevice.text && $scope.searchDevice.text.length){
        $scope.folderList = [];
      }
      //?New: start
      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchDevice.text){
          $scope.folderList = $scope.dData.folders;
        }
        if ($scope.devices.info && $scope.devices.info.breadCrumbs) {
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
      }
      if($scope.searchDevice.text && $scope.searchDevice.text.length){
        $scope.folderList = [];
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.devices.types){
        if(!$scope.filterType || $scope.filterType=="all"){
          $scope.filterType = "";
          $scope.filter = "all";
        }
      }
      //?New: end
      // $scope.dASAll = [];
      // $scope.devicesLoading = false;
      // $scope.folderList = [];
      // console.warn($scope.devices);

      // if($scope.devices.info.allIds){
      //   $scope.filterCount = $scope.devices.info.allIds.length;
      // } else{
      //   $scope.filterCount = $scope.devices.devices.length;
      // }
      // if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
      //   if ($scope.devices.folders) {
      //     $scope.folderList = $scope.devices.folders;
      //   }
      //   if ($scope.devices.info.breadCrumbs) {
      //     $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
      //   }
      // }
    }

    $scope.selectFx = function(e, id){
      $("li.ui-selected").removeClass('ui-selected');
      $(e.currentTarget).addClass("ui-selected");
      $rootScope.wallSelectedItems.devices = {}
      angular.forEach($scope.devices.devices, function(listItem){
        if(listItem.id == id){
          $rootScope.wallSelectedItems.devices = {
            id:listItem.id,
            timezone:listItem.timezone,
            mac:listItem.h,
            label:listItem.l,
            dType:listItem.t,
            status:listItem.status,
            thumbV:listItem.tv,
            localIp:listItem.localIp
          };
        }
      });
    }

    $scope.folderContentFx = function (fId, splId, splType, caller) {
      $scope.curNum = 0;
      $scope.apiCalledArr = [];
      // ?New: this "if" code is for device folder
      if(caller=="changeView"){
        $rootScope.offset = 0;
      }
      $scope.paginationControls.currPage = 1;

      $scope.deviceListLoading = true;
      if(!caller || caller != "changeView"){
        $scope.searchDevice.text = "";
        $scope.searchText = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.search = { text: "" };
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curDFId");
      $scope.advSearch = false;
      $scope.curFolderId = 0;

      if (fId == 0) {
        $scope.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curDFId", fId);
        $scope.curFolderId = localStorage.getItem("curDFId");
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.setItem("curDFId", 0);
        localStorage.removeItem("curPathFId");
      }

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType != "all"){
        $scope.filterIsAppliedAlready = true;
      }
      $scope.flObj = {caller:"vdw"};
      $scope.folObj = {fId:fId, offset:0, obj:$scope.flObj,filType:$scope.filterType,text:$scope.searchDevice.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false),vdwId:""};
      if($scope.encId){
        $scope.folObj.vdwId = $scope.decId;
      }
      // DevicesSrv.getFolderData(fId, null, null, "r", $scope.filterType, $scope.searchDevice.text).then(
      DevicesSrv.getFolderData($scope.folObj).then(
        function (data) {
          $scope.flId = fId;
          $scope.deviceListLoading = false;
          $scope.devices = angular.copy(data);
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.dData = angular.copy($scope.devices)
          $scope.brief = data;
          $scope.setCountFx();
          $scope.updateList();

          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function (err) {
          $scope.deviceListLoading = false;
          $log.error(err);
        }
      );

    }
    $scope.folderBriefFx = function (obj) {
      /*Get folder briefs*/
      $rootScope.wallSelectedItems.devices = [];
    }

    $scope.$on('$destroy', function() {
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
    });

    $scope.refreshPopupListFx = function(){
      $scope.getDeviceList();
    }

    // $scope.copyWall = {item:""};
    // $scope.editFx = function(data){
    //   $scope.copyWall.item = angular.copy(data);
    //   $scope.hasErr = false;
    //   $scope.errType = "";
    //   $scope.wallEdit = {edit:true};
    //   $scope.isExist = false;

    //   //copy data to remove previous edit row
    //   if($scope.addWall.id == ""){
    //     $scope.copyData = angular.copy(data);
    //     $scope.deviceLabel = $scope.copyData.device;
    //   } else {
    //     if($scope.copyData.id != data.id){
    //       $scope.deviceLabel = data.device;
    //       $scope.addRemListItemFx($scope.addWall);
    //       $scope.copyData = "";
    //     }
    //   }

    //   //check if already exist or not
    //   $scope.deviceList.devices.forEach(function(d){
    //     if(d.id == data.device.id){
    //       $scope.isExist = true;
    //     }
    //   })

    //   //add edited device and cell in the dropdown
    //   if(!$scope.isExist){
    //     $scope.deviceList.devices.push(data.device);
    //     $scope.cellList.push(data.cell);
    //     $scope.addWall = angular.copy(data);
    //   }
    //   $("#addWall").focus();
    // }

    // $scope.updateWallFx = function(element){
    //   $scope.deviceDvw.wallList.find(function(item){
    //     if(item.id === element.id){
    //       item.device = element.device;
    //       item.cell = element.cell;
    //     }
    //   });

    //   if($scope.copyData){
    //     $scope.copyData.device.dLabel = "";
    //   }
    //   $scope.deviceLabel = "";
    //   $scope.wallEdit.edit = false;
    //   $scope.addRemListItemFx(element, "update");
    //   $scope.updateCellsFx(element, "update");
    // }

    $scope.sortCallback = function(){
      $scope.deviceDvw.wallList = [];
      angular.forEach(angular.element(".sortable-item"), function(item, i){
        $scope.deviceDvw.wallList.push({id:$(item).attr("data-wid"), device:JSON.parse($(item).attr("data-device")), cell:JSON.parse($(item).attr("data-cell")), localIp:JSON.parse($(item).attr("data-device")).localIp, isMaster:(i == 0 ? true : false)});
      });
      // Manually trigger the digest cycle
      $scope.$apply();
    }
    $rootScope.$on('reloadDevices', function(event, data){
      $scope.deviceListLoading = true;
      // $scope.isAdvSearch = false;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $rootScope.offset = 0;
      var fId = localStorage.getItem("curDFId");
      // $scope.curAdvSearchCopy = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
      $scope.curAdvSearchCopy = $scope.advSearchInfo;
      if(!angular.isUndefined($scope.advSearchInfo) && $scope.isAdvSearch){
        console.warn(" $scope.curAdvSearchCopy *&*&8 ", $scope.curAdvSearchCopy);
        $scope.curAdvSearchCopy.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchCopy).then(
          function(data){
            $scope.deviceListLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchCopy};
            if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
              $scope.advSearchfilteredData.dInfo = $scope.filteredData.info;
            } else{
              $scope.advSearchfilteredData.dInfo = {allIds:$scope.filteredData.info.allIds};
            }
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.deviceListLoading = false;
          }
        );
      } else {
        if(fId > 0){
          $scope.folderContentFx(fId,null,null,"changeView");
        } else {
          $scope.getDeviceList("changeView");
        }
      }
    });
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceTagCUController', DeviceTagCUController);

  /** @ngInject */
  function DeviceTagCUController($log, $rootScope, $cookies, $scope, $state, $filter, $timeout, ngDialog, DevicesSrv, DeviceTagCUSrv, CommonSrv, FileModelUploadSrv){
    $rootScope.selectedMenu = 5;
    $scope.deviceTag = {info:{lan:false, label:"", isBg:false,tagColor:"#000000", tagColorType:"monochrome"}, devices:[]};
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    // console.log("==============================");
    $scope.selectedTab = $state.current.name;
    $scope.colorPicker = {b:false};
    $scope.deviceTagLoading = false;
    $scope.saveProcessing = false;
    $scope.searchTextS = {text:""};
    $scope.searchFromRoot = true;
    $scope.advSearchInfo = {};
    $scope.searchText = "";
    $scope.hasErr = false;
    $scope.filter = "all";
    $scope.devices = {};
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.folderList = [];
    $scope.thumbSize = 'n';
    $rootScope.clearSearch = false;

    $scope.dOffset = 0;
    $scope.isAPISearch = {enable:false};

    $rootScope.importXls = {file:""};
    $scope.advSearchInfo = {};
    var selPages = 4;

    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.selPaginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.getAllData = {search:false,advSearch:false,filter:false,list:false};
    $scope.copyDevices = {devices:[],folders:[]};
    $scope.stored = {devices:[], folders:[]};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.statusObj = {d:false,s:false,as:false,f:false};

    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.isAdvSearchMsg = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.advSApply = false;
    $scope.filterIsAppliedAlready = false;
    $scope.rdc = 0;
    $rootScope.addStatusKeyVal = {value: true};
    $scope.isPageApiLoad = false;
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $rootScope.search = {text:""};
    $scope.selectedSearch = {text:""};
    $rootScope.commonSearchVar = "";

    $rootScope.importXls = {file:""};
    $scope.curFolderId = localStorage.getItem("curDFId");
    if(angular.isUndefined($scope.curFolderId)){
      $scope.curFolderId = 0;
    }

    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getTotalDeviceCountFx();

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(315);
      $scope.selectedHeight = $scope.getAvailableHeight(315);
    } else{
      $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
      $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
    }

    if($state.params.id){
      $scope.deviceTagLoading = true;
      $scope.encId = $state.params.id;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      DeviceTagCUSrv.getDeviceTagsDetails($scope.decId).then(
        function(data){
          $scope.deviceTag = data;
          $scope.tim = $scope.deviceTag.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = $scope.deviceTag.info.bucket;
          if($scope.deviceTag.info.mbucket && $scope.deviceTag.info.mbucket != ""){
            $scope.dDetailBucket = $scope.deviceTag.info.mbucket;
          }
          if($scope.selectedTab === "hub.dContainer.dtName"){
            $scope.deviceTagLoading = false;
          }
          if(!$scope.deviceTag.info.tagColor){
            $scope.deviceTag.info.tagColor = "#000000";
          }
        },
        function(err){
          $log.error(err);
          $scope.deviceTagLoading = false;
        }
      );
    } else{
      $scope.deviceTagLoading = false;
    }

    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceStatus = function(caller){
      setTimeout(function(){
        if($scope.pageDeviceArr.length){
          var currentTime = new Date().getTime();
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          angular.forEach($scope.pageDeviceArr, function(obj){
            if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
              obj.tz = currentTime;
              DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                function(data){
                  angular.forEach($scope.devices.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  });
                  if($scope.deviceTag.devices.length){
                    angular.forEach($scope.deviceTag.devices, function(sData){
                      angular.forEach(Object.keys(data),function(key){
                        var value = data[key];
                        if(key == sData.id){
                          sData.status = $filter('isDeviceOnline')(value, {minDeduct: $scope.auth.upreferences.dot});
                        }
                      })
                    })
                  }
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          })
        }
      },100)
      $scope.updateSelectedDevice();
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($scope.deviceTag.devices, function(data){
          if(data.id == obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.thumbV = obj.tv;
            }
            data.status = $filter('isDeviceOnline')(obj.lp, {minDeduct: $scope.auth.upreferences.dot});;
          }
        })
        outerLoopCounter++;
        if (outerLoopCounter === totalOuterLoops) {
            $scope.temSelectedArr = angular.copy($scope.deviceTag.devices);
            $scope.deviceTag.devices = [];
            $scope.deviceTag.devices = $scope.temSelectedArr;
        }
      })
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        $scope.dReqObj = {auth:$scope.auth,offset:$rootScope.offset,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};

        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.devicesLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = true;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    };

    $scope.selPageChangeHandler = function(num){
      $('#pagingCtrlClone li').removeClass('active');
    };

    $scope.resetSelPagination = function(){
      var searchData = angular.copy($filter("customSearch")($scope.deviceTag.devices, {key:$scope.selectedSearch.text, module:'dSel'}));
      if(searchData.length>$scope.auth.upreferences.dpc){
        resetSelPageFx(1);
      }
    }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore, action){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }
      DeviceTagCUSrv.getDeviceTag(dReqObj).then(
        function(data){
          if(!$rootScope.addStatusKeyVal.value){
            $scope.deviceTagLoading = false;
            $scope.devicesLoading = false;
          }
          $scope.isPageApiLoad = false;
          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);

          $scope.tim = data.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = data.info.bucket;
          if(data.info.mbucket && data.info.mbucket != ""){
            $scope.dDetailBucket = data.info.mbucket;
          }
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }

          // get device of types
          if(caller=='openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller=='dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else {
              $scope.dData = angular.copy(data);
            }

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.filter = "all";
            } else{
              $scope.filter = $scope.filterType;
            }

            $scope.devices = angular.copy($scope.dData);
            $scope.folderList = $scope.devices.folders;
            $scope.loadingMain = false;
          }

          $scope.updateList();
          $scope.setCountFx();
          if(action && action != "changeView"){
            $scope.updateSelectedDevice();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.devicesLoading = true;
      $scope.searchTextS.text = "";
      $scope.search.text = "";
      $scope.searchText = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      //Adv search implemented
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.devicesLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else {
        $scope.advSApply = false;
        $scope.devicesLoading = true;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.devicesLoading = true;
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.devicesLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.devicesLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.searchTextS.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      // $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    $scope.getDeviceTagFx = function(obj, caller){
      // console.log("DEVICE -> TAGS");
      DeviceTagCUSrv.getDeviceTag(obj).then( //loadMoreDevices
        function(data){
          $scope.deviceTagLoading = false;
          $scope.devicesLoading = false;
          $scope.deviceGrpLoading = false;
          $scope.devicesCopy = data;
          $scope.addStatusKey($scope.devicesCopy.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devicesCopy);
          $scope.devices = angular.copy($scope.devicesCopy);
          $scope.devicesLength = data.devices.length;
          //$scope.deviceList = data;

          $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.filter = $scope.filterType;
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
          if(caller=='advSearch'){
            $scope.filterCount = $scope.fCount.length;
            $scope.updateList();
          } else {
            $scope.folderList = $scope.devices.folders;
            $scope.folderList = data.folders;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getDevicesGroupFx = function(caller){
      $scope.deviceTagLoading = true;
      $scope.breadCrumbs = [];
      $scope.isGbdt = true;
      $scope.devices = {};
      if(caller == "home"){
        $scope.searchFromRoot = true;
        $scope.breadCrumbs = [];
        $rootScope.selectedItems = [];
        $scope.advSearchInfo = {};
      }
      DevicesSrv.getDType().then(
        function(data){
          $scope.devices = data;
          $scope.deviceTagLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // $scope.setCountFx = function(caller){
    //   // $scope.devicesLoading = false;
    //   $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
    //   if(caller=='last'){
    //     $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
    //   } else{
    //     $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
    //   }

    //   // if($scope.filter && $scope.filter != "all" && !$scope.devices.devices.length && $scope.dData.devices.length){
    //   if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isFilterMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     // if($scope.filter && $scope.filter != "all" && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //     if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isFilterMsg = true;
    //     }else{
    //       $scope.isFilterMsg = false;
    //     }
    //   }
    //   if($scope.searchTextS.text && $scope.searchTextS.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (($scope.advSApply || $scope.dData.advObj) && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isSearchMsg = true;
    //     $scope.isFilterMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     $scope.isSearchMsg = false;
    //   }

    //   if(!$scope.searchTextS.text && $scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
    //     $scope.isAdvSearchMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isFilterMsg = false;
    //   } else {
    //     if($scope.searchTextS.text && $scope.searchTextS.text.length && $scope.dData.advObj && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //       $scope.isSearchMsg = true;
    //       $scope.isAdvSearchMsg = false;
    //       $scope.isFilterMsg = false;
    //     } else {
    //       $scope.isAdvSearchMsg = false;
    //     }
    //   }
    // }
    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller=='last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
      } else{
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
      }

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
      // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        // console.log($rootScope.isObjectEmpty($scope.dData), ($rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length), !$scope.devices.devices.length, !$scope.advSApply);
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
      // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
      // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchTextS.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }

    $scope.updateList = function(){
      $scope.dASAll = [];
      if($scope.searchTextS.text && $scope.searchTextS.text.length){
        $scope.folderList = [];
      }
      $scope.breadCrumbs = [];
      if(!$rootScope.addStatusKeyVal.value){
        $scope.deviceTagLoading = false;
        $scope.devicesLoading = false;
      }
      if($scope.devices && $scope.devices.devices){
        $scope.filterCount = $scope.devices.devices.length;
      }

      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df') {
        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchTextS.text){
          $scope.folderList = $scope.dData.folders;
        }
        if ($scope.devices.info && $scope.devices.info.breadCrumbs) {
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
      }
      if($scope.searchTextS.text && $scope.searchTextS.text.length){
        $scope.folderList = [];
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.devices.types){
        if(!$scope.filterType || $scope.filterType=="all"){
          $scope.filterType = "";
          $scope.filter = "all";
        }
      }
    }

    $scope.openTypeFx = function(type, page){
      $scope.deviceTagLoading = true;
      $rootScope.selectedItems = [];
      $scope.searchText = "";
      $rootScope.commonSearchVar = "";
      localStorage.setItem('curType', JSON.stringify(type.type));
      $scope.curType = angular.fromJson(localStorage.getItem("curType"));
      $scope.devices = {};
      $scope.breadCrumbs = [type];
      $scope.dReqObj = {caller:"gbdt",type:$scope.curType,offset:0};
      DevicesSrv.getDevice($scope.dReqObj).then(
        function(data){
          $scope.deviceTagLoading = false;
          $scope.isGbdt = false;
          $scope.devices = data;
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.devicesLength = $scope.devices.info.count;
          $scope.updateList();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    if($scope.selectedTab === "hub.dContainer.dtDevice"){
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        $scope.getDevicesGroupFx();
      } else{
        $scope.folderList = [];
        $scope.advSearchInfo = {};
        /*With tag*/
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:$scope.dOffset,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
    }

    $scope.curItem;
    $scope.isDuplicate = false;
    $scope.isTagDuplicate = false;

    $scope.briefFx = function(){
      $scope.selectedSearch.text = "";
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "device"){
          $scope.isDuplicate = false;
          angular.forEach($scope.deviceTag.devices, function(listItem){
            if(listItem.id == item.id){
              $scope.isDuplicate = true;
              return false;
            }
          });
          angular.forEach($scope.devices.devices, function(listItem){
            if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
              $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
              $scope.isDuplicate = true;
              return false;
            }
          });
          if(!$scope.isDuplicate){
            $scope.curItem = $scope.devices.devices.filter(function(obj){ return obj.id == item.id; })[0];
            if($scope.auth.upreferences.deviceView == 'l'){
              $scope.curItem.tv = $scope.curItem.id;
            }
            $scope.deviceTag.devices.push({ id:item.id, label:$scope.curItem.l, thumbV:$scope.curItem.tv, mac:$scope.curItem.h, dType:$rootScope.dTypeObj[$scope.curItem.t], t:$scope.curItem.t, status:$filter('isDeviceOnline')($scope.curItem.lp, {minDeduct: $scope.auth.upreferences.dot})});
          }
        }
      });
      $rootScope.selectedItems = [];
    }

    $scope.selectAllSDFx = function(){
      if($scope.auth.upermissions.gbdt && ($scope.devices.info.count/$scope.devices.info.pl > 1)){
        if($scope.devices.info.allIds){
          CommonSrv.selectAllSD($scope.devices.info.allIds.join()).then(
            function(data){
              $rootScope.reportSelectedItems.devices = data.devices;
              $scope.deviceTag.devices = data.devices;
            },
            function(err){
              $log.error(err);
            }
          );
        } else{
          $scope.dReqObj = {caller:"gbdt",type:$scope.curType};
          DevicesSrv.getDevice($scope.dReqObj).then(
            function(data){
              $rootScope.reportSelectedItems.devices = data.devices;
              $scope.deviceTag.devices = data.devices;
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.closeFilteredFx = function(id, caller){
      if(caller == "d"){
        $scope.closeFiltered(id, $scope.deviceTag.devices);
      } else if(caller = "all"){
        $scope.deviceTag.devices = [];
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.advSearchEmpty = false;
    $scope.$on('advSearchfilteredData', function(event, args){
      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }
      $scope.advSearchInfo = args.info;
      $scope.isAdvSearchActive = false;
      $scope.folderList = [];
      $scope.breadCrumbs = [];
      if($scope.advSearchInfo.os != null || ($scope.advSearchInfo.hasOwnProperty("client") && $scope.advSearchInfo.client != null) || ($scope.advSearchInfo.hasOwnProperty("dName") && $scope.advSearchInfo.dName != null) || ($scope.advSearchInfo.hasOwnProperty("createdBy") && $scope.advSearchInfo.createdBy != null) || ($scope.advSearchInfo.hasOwnProperty("sName") && $scope.advSearchInfo.sName != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || $scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length || $scope.advSearchInfo.userGroup.include.length || $scope.advSearchInfo.userGroup.exclude.length || ($scope.advSearchInfo.hasOwnProperty("fil") && $scope.advSearchInfo.fil != "" && $scope.advSearchInfo.fil != "all") || $scope.advSearchInfo.prop != null){
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(382);
          $scope.selectedHeight = $scope.getAvailableHeight(382);
        } else {
          $scope.quadHeight = $scope.getAvailableHeight(433) * 0.5;
          $scope.selectedHeight = $scope.getAvailableHeight(433) * 0.5;
        }
      } else if($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length && !$scope.advSearchInfo.userGroup.include.length && !$scope.advSearchInfo.userGroup.exclude.length && ($scope.advSearchInfo.fil == "all" || !$scope.advSearchInfo.fil) && $scope.advSearchInfo.prop == null){
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(315);
          $scope.selectedHeight = $scope.getAvailableHeight(315);
        } else {
          $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
          $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
        }
      }

      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.searchTextS.text && $scope.searchTextS.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            $scope.devices = angular.copy($scope.sData);
            $scope.setCountFx();
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            $scope.devices = angular.copy($scope.asData);
            $scope.statusObj.as = true;
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};
          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          if(args.dInfo && args.dInfo.allIds){
            $scope.devices.info.allIds = args.dInfo.allIds;
          }
        }

        $scope.isAdvSearch = true;
      }
      $scope.devices.folders = args.folders;
      $scope.isExcelData = false;

      $scope.setCountFx();
      $scope.filterType = $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
      }

      $scope.advSearchInfo = args.info;
      if(args.code == 8118){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.advSApply = false;
        $scope.curFolderId = 0;
        localStorage.removeItem("curDFId");
        $scope.deviceTagLoading = true;
        $scope.advSearchInfo = {};
        $rootScope.commonSearchVar = "";
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:$scope.dOffset,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj,"dList", false);
      }
    });

    // var searchTimeout;
    $scope.searchChangeFx = function(text){
      $rootScope.commonSearchVar = text;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if(!text){
        $scope.clearSearchFx();
        return;
      }else{
        $scope.search.text = text;
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        if(text){
          $scope.devicesLoading = true;
          $rootScope.clearSearch = false;
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          //Adv search implemented
          $scope.paginationControls.currPage = 1;
          $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
          if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
            $scope.curAdvSearchObj = $scope.advSearchInfo;
            if($scope.filter != "all"){
              $scope.filterType = $scope.filter
              $scope.curAdvSearchObj.fil = $scope.filter;
            } else{
              $scope.filterType = "";
            }
            $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
            $scope.curAdvSearchObj.offset = 0;
            CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
              function(data){
                $scope.devicesLoading = false;
                $scope.filteredData = data;
                $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                $scope.curAdvSearchObj.isLoadMore = false;
                if(data.info.rdc || data.info.rdc == 0){
                  $scope.curAdvSearchObj.rdc = data.info.rdc;
                }
                $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
                $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else{
            $rootScope.offset = 0;
            $scope.devicesLoading = true;
            $scope.filter = JSON.parse(localStorage.getItem("filterType"));
            $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
            $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
          }
        }
      }
    }

    $scope.saveDeviceTagFx = function(caller, action){
      $scope.hasErr = false;
      $scope.curData = {};
      if(caller == "name"){
        if($scope.deviceTag.info.label == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#label").focus();
          return;
        }
        $scope.deviceTag.info.step = "n";
      } else{
        $scope.deviceTag.info.step = "d";
      }

      if(action == undefined){
        $scope.saveProcessing = true;
        $scope.deviceTag.info.toast = false;
      } else{
        $scope.saveCloseProcessing = true;
        $scope.deviceTag.info.toast = true;
      }
      if(!$scope.deviceTag.info.isBg){
        $scope.deviceTag.info.tagColor = "";
      }
      DeviceTagCUSrv.saveDeviceTag($scope.deviceTag).then(
        function(data){
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          if(data.code == 12021){
            $scope.errType = "exists";
            $scope.hasErr = true;
            $("#label").focus();
          } else if(data.code == 12059){
            $scope.errType = "mcDeviceTag";
            $scope.hasErr = true;
          } else if(data.code == 12091){
            $scope.errType = "eslError";
            $scope.hasErr = true;
          } else if(data.code == 12042){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                      <div>{{"d.p_dg.m4" | translate}}</div>\
                      <div class="table marT15">\
                        <div class="row th">\
                          <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                        </div>\
                        <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                          <div class="row" ng-repeat="err in curData.devices">\
                          <div class="col-xs-12 word-break">{{err}}</div>\
                          </div>\
                        </div>\
                      </div>\
                    </div>\
                    <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else if(data.code == 10046){
            $scope.errDataObj = data.data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <header class="panel-heading"><h1 role="heading" aria-level="1">{{"s.p_s.body.6" | translate}}</h1></header>\
                  <div class="panel-body">\
                    <div class="msg-warning" lang="{{auth.lang}}">{{"s.p_s.msg.55" | translate}}</div>\
                    <div class="table marT10">\
                      <div class="row th">\
                        <div class="col-xs-4">{{"cm.label.3" | translate}}</div>\
                        <div class="col-xs-4">{{"cm.label.4" | translate}}</div>\
                        <div class="col-xs-4">{{"as.btn.1" | translate}}</div>\
                      </div>\
                      <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(420)}}px">\
                        <div class="row" ng-repeat="list in errDataObj">\
                          <div class="col-xs-4">{{list.schedule.label}}</div>\
                          <div class="col-xs-4">{{list.device.label}}</div>\
                          <div class="col-xs-4">{{list.search.label}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <span class="btnQuad">\
                      <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                    </span>\
                    <div class="clearfix"></div>\
                  </footer>\
                </section>',
              plain:true,
              width:710,
              scope:$scope,
              closeByDocument:false
            });
          } else{
            if(action == undefined){
              if(caller == "name"){
                $scope.encId = $scope.hubEncrypt(data.id);
                if($state.current.name == "hub.dContainer.dtName"){
                  $state.go("hub.dContainer.dtDevice", {id:$scope.encId});
                }
              } else if(caller == "device"){
                $state.go("hub.devices.dt");
              }
            } else{
              if($state.current.name == "hub.dContainer.dtName" || $state.current.name == "hub.dContainer.dtDevice"){
                $state.go("hub.devices.dt");
              }
            }
          }
        },
        function(err){
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.devicePreviewFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    }

    $scope.clearFx = function(){
      $scope.devices = angular.copy($scope.devicesCopy);
    }
    $rootScope.deleteCallback = function(){}

    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.folderContentFx = function (fId, splId, splType, caller) {
      $scope.apiCalledArr = [];
      $scope.paginationControls.currPage = 1;

      $scope.devicesLoading = true;
      if(!caller || caller != "changeView"){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.search = { text: "" };
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curDFId");
      $scope.advSearch = false;
      $scope.curFolderId = 0;

      if (fId == 0) {
        $scope.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curDFId", fId);
        $scope.curFolderId = localStorage.getItem("curDFId");
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.setItem("curDFId", 0);
        localStorage.removeItem("curPathFId");
      }

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType != "all"){
        $scope.filterIsAppliedAlready = true;
      }
      $scope.folObj = {fId:fId, offset:0, obj:null, caller:"tag",filType:$scope.filterType,text:$scope.searchTextS.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};
      // DevicesSrv.getFolderData(fId, null, null, "tag", $scope.filterType, $scope.searchTextS.text).then(
      DevicesSrv.getFolderData($scope.folObj).then(
        function (data) {
          $scope.flId = fId;
          $scope.devicesLoading = false;
          $scope.devices = angular.copy(data);
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.dData = angular.copy($scope.devices)
          $scope.brief = data;
          $scope.setCountFx();
          $scope.updateList();

          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function (err) {
          $scope.devicesLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/}

    $scope.$on('$destroy', function() {
      // say goodbye to your controller here
      // release resources, cancel request...
      localStorage.setItem("curDFId", 0);
      $scope.advSearchInfo = {};
    });

    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.devicesLoading = true;
    });
    var deregister = $scope.$on('changeView', function(event, data){
      $rootScope.offset = 0;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if($scope.selectedTab == "hub.dContainer.dtDevice"){
        var fId = localStorage.getItem("curDFId");
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj.offset = 0;
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.deviceTagLoading = false;
              $scope.devicesLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = false;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.sortType = data.info.sortType;
              $scope.curAdvSearchObj.sortVal = data.info.sortVal;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          if(fId > 0){
            $scope.folderContentFx(fId, null, null, "changeView");
          } else {
            $scope.filter = JSON.parse(localStorage.getItem("filterType"));
            $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,fId:$scope.curFolderId};
            $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false, "changeView");
          }
        }
      }
      // deregister();
    });

    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData) {
      // Deep compare the new data with the current data
      if (!angular.equals($scope.currentPageDevice, newData.curData)) {
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if (!angular.equals($scope.allPageDevice, newData.allData.length)) {
        $scope.allPageDevice = angular.copy(newData.allData.length);
      }
    }

    // // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data) {
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function() {
      return $scope.currentPageDevice.map(function(obj) {
          return obj.id;
      }).join(',');
    };

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.currentPageDevice = newVal
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for (var i = 1; i <= allPagesCount; i++) {
              $scope.pageDeviceArr.push({pNo:i, tz:new Date().getTime()})
            }
          }else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for (var i = 1; i <= allPagesCount - start; i++) {
              $scope.pageDeviceArr.push({pNo:start +i, tz:new Date().getTime()})
            }
          }
        }
      }
    }, true); // 'true' for deep watch
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceGroupCUController', DeviceGroupCUController);

  /** @ngInject */
  function DeviceGroupCUController($log, $rootScope, $scope, $state, $filter, $cookies, $timeout, ngDialog, FileModelUploadSrv, DeviceGroupCUSrv, DevicesSrv, CommonSrv){
    $rootScope.selectedMenu = 5;

    $scope.deviceGroup = {info:{lan:false, label:""}, devices:[], tags:[]};
    $scope.selectedTab = $state.current.name;
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $scope.deviceGrpLoading = true;
    $scope.saveProcessing = false;
    $scope.searchTextS = {text:""};
    $scope.isExcelData = false;
    $scope.searchText = "";
    $scope.hasErr = false;
    $scope.filter = "all";
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.folderList = [];
    $scope.thumbSize = 'n';
    $scope.advSearchInfo = {};
    $rootScope.selectedT = $scope.auth.upreferences.sdtf ? 2 : 1;
    $scope.paginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.selPaginationControls = {boundaryLinks:false, maxSize:7, currPage:1, pageSize:$scope.auth.upreferences.dpc, dataCount:$scope.auth.upreferences.dpcc?$scope.auth.upreferences.dpcc:1000};
    $scope.getAllData = {search:false,advSearch:false,filter:false,list:false};
    $scope.copyDevices = {devices:[],folders:[]};
    $scope.stored = {devices:[], folders:[]};
    $scope.apiCalledArr = [];
    $scope.isFilterApplied = false;
    $scope.statusObj = {d:false,s:false,as:false,f:false};

    $scope.isFilterMsg = false;
    $scope.isSearchMsg = false;
    $scope.isAdvSearchMsg = false;
    $scope.dData = {};
    $scope.sData = {};
    $scope.asData = {};
    $scope.totalDPages = 0;
    $scope.curNum = 0;
    $scope.advSApply = false;
    $scope.filterIsAppliedAlready = false;
    $scope.dOffset = 0;
    $scope.rdc = 0;
    $rootScope.addStatusKeyVal = {value: true};
    // $scope.dTags = [];
    $scope.isPageApiLoad = false;
    $rootScope.showRemainingList = false;
    $scope.currentPageDevice = [];
    $scope.allPageDevice = 0;
    $scope.pageDeviceArr = [];
    $scope.firstApply = {filter:false, search:false};
    $rootScope.search = {text:""};
    $scope.selectedSearch = {text:""};
    $rootScope.commonSearchVar = "";
    $scope.copySelData = [];

    // if($scope.auth.upreferences.deviceView=="t"){
    //   $scope.thumbView = true;
    //   $scope.listView = false;
    // } else {
    //   $scope.listView = true;
    //   $scope.thumbView = false;
    // }

    $scope.curFolderId = localStorage.getItem("curDFId");
    if(angular.isUndefined($scope.curFolderId)){
      $scope.curFolderId = 0;
    }

    $scope.getTotalDeviceCountFx = function(){
      DevicesSrv.getTotalDeviceCount().then(
        function(data){
          $rootScope.totalDeviceOnServer = data.devices;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getTotalDeviceCountFx();

    if($scope.auth.upreferences.isSplitV){
      $scope.quadHeight = $scope.getAvailableHeight(315);
      $scope.selectedHeight = $scope.getAvailableHeight(315);
    } else{
      $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
      $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
    }

    $rootScope.bothDeviceAndTags = {list:[]};
    if($state.params.id){
      $scope.encId = $state.params.id;
      $scope.decId = $scope.hubDecrypt($state.params.id);
      DeviceGroupCUSrv.getDeviceGroupDetails($scope.decId).then(
        function(data){
          // console.warn(data);
          $scope.deviceGroup = data;
          var mergeData = angular.copy([].concat($scope.deviceGroup.devices, $scope.deviceGroup.tags));
          $scope.bothDeviceAndTags = {list:angular.copy(mergeData)};
          $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
          // console.warn($scope.deviceGroup, $scope.bothDeviceAndTags);
          $scope.tim = $scope.deviceGroup.info.timthumb;
          $scope.bucket = $scope.dDetailBucket = $scope.deviceGroup.info.bucket;
          if($scope.deviceGroup.info.mbucket && $scope.deviceGroup.info.mbucket != ""){
            $scope.dDetailBucket = $scope.deviceGroup.info.mbucket;
          }
          if($scope.selectedTab === "hub.dContainer.dgName"){
            $scope.deviceGrpLoading = false;
          }
        },
        function(err){
          $log.error(err);
          $scope.deviceGrpLoading = false;
        }
      );
    } else{
      $scope.deviceGrpLoading = false;
    }

    $scope.timerFx = function(){
      $scope.remPageTimer = setTimeout(function(){
        $scope.$apply(function(){
          $rootScope.timerFxToLoadData();
          clearTimeout($scope.remPageTimer);
        })
      },2000);
    }

    $scope.getDeviceStatus = function(caller){
      setTimeout(function(){
        if($scope.pageDeviceArr.length){
          var currentTime = new Date().getTime();
          $scope.commaSeparatedIds = $scope.getCommaSeparatedIds();
          angular.forEach($scope.pageDeviceArr, function(obj){
            if(obj.pNo == $scope.curNum && (currentTime - obj.tz) >= 120000){
              obj.tz = currentTime;
              DevicesSrv.updateDeviceStatus({'ids':$scope.commaSeparatedIds}).then(
                function(data){
                  angular.forEach($scope.devices.devices, function(dData){
                    angular.forEach(Object.keys(data),function(key){
                      var value = data[key];
                      if(key == dData.id){
                        dData.lp = value;
                      }
                    })
                  });
                  if($scope.deviceGroup.devices.length){
                    angular.forEach($scope.deviceGroup.devices, function(sData){
                      angular.forEach(Object.keys(data),function(key){
                        var value = data[key];
                        if(key == sData.id){
                          sData.status = $filter('isDeviceOnline')(value, {minDeduct: $scope.auth.upreferences.dot});
                        }
                      })
                    })
                  }
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          })
        }
      },100)
      $scope.updateSelectedDevice();
    }

    $scope.updateSelectedDevice = function(){
      $scope.temSelectedArr = [];
      var totalOuterLoops = $scope.currentPageDevice.length;
      var outerLoopCounter = 0;
      angular.forEach($scope.currentPageDevice, function(obj){
        angular.forEach($scope.deviceGroup.devices, function(data){
          if(data.id === obj.id){
            if($scope.auth.upreferences.deviceView == 't'){
              data.thumbV = obj.tv;
            }
            data.status = $filter('isDeviceOnline')(obj.lp, {minDeduct: $scope.auth.upreferences.dot});;
          }
        })
        outerLoopCounter++;
        if (outerLoopCounter === totalOuterLoops) {
            $scope.temSelectedArr = angular.copy($scope.deviceGroup.devices);
            $scope.deviceGroup.devices = [];
            $scope.deviceGroup.devices = $scope.temSelectedArr;
        }
      })
    }

    $scope.pageChangeHandler = function(num){
      if($scope.remPageTimer){
        clearTimeout($scope.remPageTimer);
      }
      $scope.timerFx();
      $('#pagingCtrl li').removeClass('active');
      $('.remDeviceList').remove();
      $rootScope.showRemainingList = true;
      $scope.isPageApiLoad = false;
      $scope.curNum = angular.copy(num);

      $rootScope.offset = $scope.devices.devices.length?$scope.devices.devices.length:0;

      var pages = Math.ceil($scope.devices.devices.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);

      var isAPICall = $scope.apiCalledArr.every(function(item){return item !== num});

      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filter){
        $scope.filter = "all";
      }
      // if(isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages){
      if((isAPICall && (pages == num || (num == (pages-1))) && $scope.totalDPages != pages) || ($scope.totalDPages == pages && $scope.rdc > $scope.devices.devices.length)){
        $scope.isPageApiLoad = true;
        $scope.apiCalledArr.push(num);

        $scope.dReqObj = {auth:$scope.auth,offset:$rootScope.offset,text:$scope.searchTextS.text,filter:$scope.filter,caller:$rootScope.selectedT == 1 ? 'd' : "dt",fId:$scope.curFolderId};

        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.isEmpty)){
          $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
          $scope.curAdvSearchObj.offset = $rootScope.offset;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.devicesLoading = false;
              $scope.isPageApiLoad = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = true;
              $scope.curAdvSearchObj.rdc = data.info.rdc;
              $scope.curAdvSearchObj.isOSet = ($rootScope.offset > 0 ? true : false);
              $scope.curAdvSearchObj.vl = data.info.tc;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj,isLV:true};
              if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
                $scope.advSearchfilteredData.dInfo = data.info;
              } else{
                $scope.advSearchfilteredData.dInfo = {allIds:data.info.allIds};
              }
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else{
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", true);
        }
      } else{
        if($scope.totalDPages > 0 && $scope.curNum > 0 && $scope.totalDPages == $scope.curNum){
          $scope.setCountFx("last");
        } else{
          $scope.setCountFx();
        }
      }
    }

    $scope.selPageChangeHandler = function(){
      $('#pagingCtrlClone li').removeClass('active');
      // console.warn("Count", $scope.bothDeviceAndTags.list.length);
      var pages = Math.ceil($scope.bothDeviceAndTags.list.length / $scope.paginationControls.pageSize);
      $scope.totalDPages = Math.ceil($scope.bothDeviceAndTags.list.length / $scope.paginationControls.pageSize);
    };

    $scope.resetSelPagination = function(caller){
      if(caller=="all"){
        $scope.resetSelFx();
      }
      var searchData = angular.copy($filter("customSearch")($scope.bothDeviceAndTags.list, {key:$scope.selectedSearch.text, module:'dSel'}));
      if(searchData.length>$scope.auth.upreferences.dpc && !caller){
        resetSelPageFx(1);
      }
    }

    /**Common function for geting devices and processing*/
    $scope.getDeviceAndProcessFx = function(dReqObj, caller, isLoadMore, action){
      if(!isLoadMore){
        $scope.pageDeviceArr = [];
        $scope.rdc = 0;
        $scope.curNum = 1;
      }
      // console.warn("getDeviceAndProcessFx", caller);
      DeviceGroupCUSrv.getDeviceTag(dReqObj).then(
        function(data){
          // $scope.dTags = data.tags;
          if(data.info.bucket){
            $scope.tim = data.info.timthumb;
            $scope.bucket = $scope.dDetailBucket = data.info.bucket;
            if(data.info.mbucket && data.info.mbucket != ""){
              $scope.dDetailBucket = data.info.mbucket;
            }
          }
          $scope.brief = data;
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          // get device of types
          if(!$rootScope.addStatusKeyVal.value){
            $scope.devicesLoading = false;
          }
          $scope.isPageApiLoad = false;
          $scope.deviceGrpLoading = false;
          $scope.devicesLoading = false;

          $scope.addStatusKey(data.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey(data);
          if(caller=='openType'){
            $scope.loadingMain = false;
            if(data.code == 12064){
              $scope.auth.upermissions.gbdt = false;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              $scope.loadSelectedTab();
            } else{
              $scope.isGbdt = false;
            }
          }

          if(caller=='dList'){// get device list
            if(isLoadMore && $scope.dData.devices.length){
              $scope.dData.devices = $scope.dData.devices.concat(data.devices);
            } else {
              $scope.dData = angular.copy(data);
            }

            $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
            if(!$scope.filterType || $scope.filterType=="all"){
              $scope.filterType = "";
              $scope.filter = "all";
            } else{
              $scope.filter = $scope.filterType;
            }
            $scope.devices = angular.copy($scope.dData);

            if($scope.dData && $scope.dData.tags && $scope.selectedT == 2){
              $scope.dData.devices = $scope.dData.tags;
            } else{
              $scope.folderList = $scope.devices.folders;
            }
            $scope.loadingMain = false;
          }
          $scope.updateList();
          if($scope.selectedT==1){
            $scope.setCountFx();
          }
          if(action && action != "changeView"){
            $scope.updateSelectedDevice();
          }
        },
        function(err){
          $log.error(err);
        }
      );

    }

    $scope.clearSearchFx = function(){
      $rootScope.offset = 0;
      $rootScope.commonSearchVar = "";
      $scope.devicesLoading = true;
      $scope.searchTextS.text = "";
      $scope.search.text = "";
      $scope.searchText = "";
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.sData = {};
      $scope.firstApply.search = false;
      //Adv search implemented
      if($scope.selectedT==1){
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj = $scope.advSearchInfo;
          if($scope.filter != "all"){
            $scope.curAdvSearchObj.fil = $scope.filter;
          }
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.devicesLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = false;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else {
          $scope.advSApply = false;
          $scope.devicesLoading = true;
          $scope.filter = JSON.parse(localStorage.getItem("filterType"));
          $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,caller:$rootScope.selectedT == 1 ? 'd' : "dt",fId:$scope.curFolderId};
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
        }
      } else{
        $scope.devicesLoading = false;
      }
    }

    $scope.filterUpdateFx = function(type){
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      $scope.devicesLoading = true;
      $scope.curTimestamp = moment().format('x');
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');

      $scope.filter = type;
      $rootScope.offset = 0;
      $scope.closeAllFx();

      $scope.isFilterApplied = true;

      if($scope.filter == 'all'){
        localStorage.removeItem("filterType");
        $scope.statusObj.f = false;
        $scope.isAdvSearchMsg = false;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
        // $scope.firstApply.filter = true;
      } else{
        $scope.statusObj.f = true;
      }

      if(!$scope.firstApply.search && $scope.filter != "all"){
        $scope.firstApply.filter = true;
      } else {
        $scope.firstApply.filter = false;
      }

      localStorage.setItem("filterType", JSON.stringify($scope.filter));
      $scope.devicesLoading = true;
      if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }
        $scope.curAdvSearchObj.offset = 0;
        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.devicesLoading = false;
            $scope.filteredData = data;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.curAdvSearchObj.isLoadMore = false;
            if(data.info.rdc  || data.info.rdc == 0){
              $scope.curAdvSearchObj.rdc = data.info.rdc;
            }
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(!$scope.curDType){
          $scope.curDType = "";
        }
        $scope.dReqObj = {caller:"gbdt",type:$scope.curDType.type,offset:$rootScope.offset,isDP:($scope.devices.devices.length > $scope.paginationControls.pageSize ? true : false),filter:$scope.filter,isLV:($scope.auth.upreferences.deviceView=='l'?true:false),text:$scope.searchTextS.text};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "filGbdt", false);
      } else{
        $rootScope.offset = 0;
        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,caller:$rootScope.selectedT == 1 ? 'd' : "dt",fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
      }
      $scope.filterType = type;
      if(type=="offline"){
        $rootScope.deviceFilter = "off";
      } else if(type=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all";
      }

      if(!$scope.filterType || $scope.filterType == 'all'){
        localStorage.removeItem("filterType");
        $scope.filterType = "";
      } else{
        localStorage.setItem("filterType", JSON.stringify($scope.filterType));
      }
      // $scope.setCountFx();
    }

    $scope.limitDataFx = function(obj){
      var tempList = [];
      if(obj.list && obj.list.length){
        // tempList = obj.list;
        obj.offset = obj.list.length + 1000;
      } else{
        obj.offset = 1000;
      }
      for(var i = tempList.length; i<obj.dList.length; i++){
        if(!obj.type || obj.type == "all"){
          tempList.push(obj.dList[i]);
          if(tempList.length == obj.offset){
            break;
          }
        } else{
          if(obj.dList[i].status == obj.type){
            tempList.push(obj.dList[i]);
            if(tempList.length == obj.offset){
              break;
            }
          }
        }
      }
      return tempList;
    }

    // $scope.setCountFx = function(caller){
    //   $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
    //   if(caller=='last'){
    //     $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
    //   } else{
    //     $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc ? $scope.devices.devices.length : $scope.auth.upreferences.dpc;
    //   }

    //   // if($scope.filter && $scope.filter != "all" && ($scope.devices && !$scope.devices.devices.length) && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)){
    //   if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isFilterMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     // if($scope.filter && $scope.filter != "all" && (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length) && ($scope.devices && !$scope.devices.devices.length)){
    //     // if($scope.filter && $scope.filter != "all" && $scope.devices && !$scope.devices.devices.length){
    //     if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //       $scope.isFilterMsg = true;
    //     }else{
    //       $scope.isFilterMsg = false;
    //     }
    //   }
    //   if($scope.searchTextS.text && $scope.searchTextS.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (($scope.advSApply || $scope.dData.advObj) && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
    //     $scope.isSearchMsg = true;
    //     $scope.isFilterMsg = false;
    //     $scope.isAdvSearchMsg = false;
    //   } else {
    //     $scope.isSearchMsg = false;
    //   }

    //   if(!$scope.searchTextS.text && $scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
    //     $scope.isAdvSearchMsg = true;
    //     $scope.isSearchMsg = false;
    //     $scope.isFilterMsg = false;
    //   } else {
    //     if($scope.searchTextS.text && $scope.searchTextS.text.length && $scope.dData.advObj && !$scope.dData.devices.length && !$scope.devices.devices.length){
    //       $scope.isSearchMsg = true;
    //       $scope.isAdvSearchMsg = false;
    //       $scope.isFilterMsg = false;
    //     } else {
    //       $scope.isAdvSearchMsg = false;
    //     }
    //   }
    // }
    $scope.setCountFx = function(caller){
      $scope.totalPages = Math.ceil($scope.rdc / $scope.paginationControls.pageSize);
      if(caller=='last'){
        $scope.visibleDevices = $scope.devices.devices.length % $scope.auth.upreferences.dpc;
      } else{
        $scope.visibleDevices = $scope.devices.devices.length < $scope.auth.upreferences.dpc?$scope.devices.devices.length:$scope.auth.upreferences.dpc;
      }

      if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && (!$rootScope.isObjectEmpty($scope.dData) && $scope.dData.devices.length)) && !$scope.advSApply)){
      // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
        $scope.isFilterMsg = true;
        $scope.isSearchMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        // console.log($rootScope.isObjectEmpty($scope.dData), ($rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length), !$scope.devices.devices.length, !$scope.advSApply);
        if($scope.filter && $scope.filter != "all" && ((($rootScope.isObjectEmpty($scope.dData) || (!$rootScope.isObjectEmpty($scope.dData) && !$scope.dData.devices.length)) && !$scope.devices.devices.length) && !$scope.advSApply)){
        // if($scope.filter && $scope.filter != "all" && ((!$scope.devices.devices.length && $scope.dData.devices.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
        // if($scope.filter && $scope.filter != "all" && ($scope.devices.info.rdc != 0 || ($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj) && !$scope.devices.devices.length){
          $scope.isFilterMsg = true;
        } else{
          $scope.isFilterMsg = false;
        }
      }
      if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
      // if($scope.search.text && $scope.search.text.length && ((!$scope.devices.devices.length && $scope.dData.devices.length) || (!$scope.devices.folders.length && $scope.dData.folders.length) || ($scope.dData.advObj && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)))){
      // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
        $scope.isSearchMsg = true;
        $scope.isFilterMsg = false;
        $scope.isAdvSearchMsg = false;
      } else{
        if($scope.searchTextS.text && $scope.searchTextS.text.length && !$scope.devices.devices.length){
        // if($scope.search.text && $scope.search.text.length && (($scope.devices.folders && $scope.devices.folders.length) || $scope.dData.devices.length || $scope.dData.advObj || !$scope.devices.devices.length)){
          $scope.isSearchMsg = true;
        } else{
          $scope.isSearchMsg = false;
        }
      }

      if(!$scope.searchTextS.text && $scope.advSApply && ($scope.devices.devices.length == 0 && $scope.dData.devices.length == 0)){
        $scope.isAdvSearchMsg = true;
        $scope.isSearchMsg = false;
        $scope.isFilterMsg = false;
      } else{
        $scope.isAdvSearchMsg = false;
      }
    }
    $scope.changeDataTab = function(caller){
      $scope.curFolderId = 0;
      // console.log(caller);
      if(!caller || caller != "changeView"){
        $scope.searchTextS.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.firstApply = {filter:false,search:false};
      localStorage.removeItem("curDFId");
      $scope.isExcelData = false;
      $scope.devicesLoading = true;
      /*With tag*/
      $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      $scope.dReqObj = {auth:$scope.auth,offset:$scope.dOffset,text:$scope.searchTextS.text,filter:$scope.filter,fId:0,caller:$rootScope.selectedT == 1 ? 'd' : "dt"};
      if($scope.advSApply && $rootScope.selectedT == 1){
        $scope.apiCalledArr = [];
        $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
        $scope.curAdvSearchObj.offset = 0;
        if($scope.filter != "all"){
          $scope.curAdvSearchObj.fil = $scope.filter;
        }

        //show properly
        $scope.quadHeight = $scope.getAvailableHeight(400);
        $scope.selectedHeight = $scope.getAvailableHeight(400);

        CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
          function(data){
            $scope.devicesLoading = false;
            $scope.filteredData = data;
            $scope.rdc = data.info.rdc;
            $scope.curAdvSearchObj.isEmpty = data.isEmpty;
            $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
            $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      } else {
        if($scope.selectedT == 1){
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false, caller);
        } else {
          $scope.firstApply.search = false;
          $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false, caller);
        }
      }
    }

    $scope.loadDevicesFx = function(caller){
      if($scope.selectedTab === "hub.dContainer.dgDevice"){
        $scope.changeDataTab(caller)
        $rootScope.selectedTabFx = function(){
          $scope.devicesLoading = true;
          $rootScope.addStatusKeyVal.value = true;
          if(!caller || caller != "changeView"){
            $scope.searchTextS.text = "";
            $scope.search.text = "";
          }
          $scope.isExcelData = false;
          $scope.changeDataTab();
          if(!$scope.advSApply){
            $scope.advSearchInfo = {};
          }
          $scope.breadCrumbs = [];
          /*With tag*/
          if($rootScope.selectedT == 2){
            $scope.conflictMsg = $filter("translate")('s.p_s.msg.25');
            $rootScope.addStatusKeyVal.value = false;
            // if(!$scope.advSApply){
              // setTimeout(function(){
                $scope.advSearchInfo = {};
                // $scope.$apply()
              // }, 0);
            // }
            if($scope.advSApply){
              $scope.quadHeight = $scope.getAvailableHeight(320);
              $scope.selectedHeight = $scope.getAvailableHeight(320);
            }
          } else if($rootScope.selectedT == 1){
            $scope.dReqObj.offset = 0;
            $scope.paginationControls.currPage = 1;
            $scope.apiCalledArr = [];
            // $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
            $scope.updateList();
          }
          // else if($rootScope.selectedT == 1){
          //   $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
          // }
        }

        $scope.curItem;
        $scope.isDuplicate = false;
        $scope.isTagDuplicate = false;
        $scope.briefFx = function(){
          $scope.selectedSearch.text = "";
          $scope.bothDeviceAndTags = {list:[]};
          angular.forEach($rootScope.selectedItems, function(item){
            if(item.type == "device"){
              $scope.isDuplicate = false;
              angular.forEach($scope.deviceGroup.devices, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              angular.forEach($scope.devices.devices, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected').find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.devices.devices.filter(function(obj){return obj.id == item.id;})[0];
                if($scope.auth.upreferences.deviceView == 'l'){
                  $scope.curItem.tv = $scope.curItem.id;
                }
                $scope.deviceGroup.devices.push({id:item.id, label:$scope.curItem.l, thumbV:$scope.curItem.tv, mac:$scope.curItem.h, dType:$scope.curItem.t, status:$filter('isDeviceOnline')($scope.curItem.lp, {minDeduct: $scope.auth.upreferences.dot})});
              }
            } else if(item.type == "tag"){
              $scope.isDuplicate = false;
              angular.forEach($scope.deviceGroup.tags, function(listItem){
                if(listItem.id == item.id){
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              angular.forEach($scope.devices.tags, function(listItem){
                if(listItem.id == item.id && (listItem.isConflict == 1 || listItem.isConflict == 2)){
                  $(".ui-selectable li.ui-selected[data-id='" + listItem.id + "']").removeClass('ui-selected');
                  $scope.isDuplicate = true;
                  return false;
                }
              });
              if(!$scope.isDuplicate){
                $scope.curItem = $scope.devices.tags.filter(function(obj){return obj.id == item.id;})[0];
                $scope.deviceGroup.tags.push({id:item.id, label:$scope.curItem.label, tagColor:$scope.curItem.tagColor});
              }
            }
          });

          var mergeData = angular.copy([].concat($scope.deviceGroup.devices, $scope.deviceGroup.tags));
          if($scope.selectedSearch.text.length){
            $scope.bothDeviceAndTags.list = angular.copy($filter("customSearch")(mergeData, {key:$scope.selectedSearch.text, module:'dSel'}));
          } else {
            $scope.bothDeviceAndTags.list = angular.copy(mergeData);
          }
          $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
          $rootScope.selectedItems = [];
        }
      }
    }
    $scope.loadDevicesFx();

    $scope.searchSelFx = function(text){
      $scope.searchData = angular.copy($scope.copySelData.list);
      if(text != ''){
        $scope.bothDeviceAndTags.list = angular.copy($filter("customSearch")($scope.searchData, {key:text, module:'dSel'}));
      } else {
        $scope.resetSelFx();
      }
    }

    $scope.resetSelFx = function(){
      var mergeData = angular.copy([].concat($scope.deviceGroup.devices, $scope.deviceGroup.tags));
      $scope.bothDeviceAndTags = {list:angular.copy(mergeData)};
      // $scope.bothDeviceAndTags.list = angular.copy(mergeData);
      $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
    }

    $scope.closeFilteredFx = function(id, caller){
      if(caller == "d"){
        $scope.closeFiltered(id, $scope.bothDeviceAndTags.list);
        $scope.closeFiltered(id, $scope.deviceGroup.devices);
        // $scope.copySelData = angular.copy($scope.remainList);
        $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
      } else if(caller == "t"){
        $scope.closeFiltered(id, $scope.bothDeviceAndTags.list);
        $scope.closeFiltered(id, $scope.deviceGroup.tags);
        $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
        // $scope.copySelData = angular.copy($scope.remainList);
      } else if(caller = "all"){
        $scope.deviceGroup.devices = [];
        $scope.deviceGroup.tags = [];
        $scope.bothDeviceAndTags.list = [];
        // $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
      }
      // $scope.copySelData = angular.copy($scope.bothDeviceAndTags);
    }

    /*advSearchfilteredData by advanced search*/
    $scope.advSearchEmpty = false;
    $scope.$on('advSearchfilteredData', function(event, args){
      angular.forEach(angular.element('.ui-selectable li'), function(item){
        if(!$(item).hasClass("nonSelectable")){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false);
        }
      });
      if(!$scope.advSApply){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.searchText = "";
        $rootScope.commonSearchVar = "";
      }
      $scope.advSApply = true;
      $scope.apiCalledArr = [];

      if($rootScope.clearSearch && !args.info.isLoadMore){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.paginationControls.currPage = 1;
      }
      if(args.info.isRemove){
        $scope.paginationControls.currPage = 1;
        $scope.apiCalledArr = [];
        $rootScope.offset = 0;
        args.info.isLoadMore = false;
      }
      if(args.info.rdc || args.info.rdc == 0){
        $scope.rdc = args.info.rdc;
      }
      $scope.advSearchInfo = args.info;
      $scope.isAdvSearchActive = false;
      $scope.folderList = [];
      $scope.breadCrumbs = [];
      if($scope.advSearchInfo.os != null || ($scope.advSearchInfo.hasOwnProperty("client") && $scope.advSearchInfo.client != null) || ($scope.advSearchInfo.hasOwnProperty("dName") && $scope.advSearchInfo.dName != null) || ($scope.advSearchInfo.hasOwnProperty("createdBy") && $scope.advSearchInfo.createdBy != null) || ($scope.advSearchInfo.hasOwnProperty("sName") && $scope.advSearchInfo.sName != null) || $scope.advSearchInfo.creationRange == true || $scope.advSearchInfo.scheduleRange == true || $scope.advSearchInfo.tag.include.length || $scope.advSearchInfo.tag.exclude.length || $scope.advSearchInfo.userGroup.include.length || $scope.advSearchInfo.userGroup.exclude.length || ($scope.advSearchInfo.hasOwnProperty("fil") && $scope.advSearchInfo.fil != "" && $scope.advSearchInfo.fil != "all") || $scope.advSearchInfo.prop != null){
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(382);
          $scope.selectedHeight = $scope.getAvailableHeight(382);
        } else {
          $scope.quadHeight = $scope.getAvailableHeight(433) * 0.5;
          $scope.selectedHeight = $scope.getAvailableHeight(433) * 0.5;
        }
      } else if($scope.advSearchInfo.os == null && $scope.advSearchInfo.client == null && $scope.advSearchInfo.createdBy == null && $scope.advSearchInfo.sName == null && $scope.advSearchInfo.dName == null && $scope.advSearchInfo.creationRange == false && $scope.advSearchInfo.scheduleRange == false && !$scope.advSearchInfo.tag.include.length && !$scope.advSearchInfo.tag.exclude.length && !$scope.advSearchInfo.userGroup.include.length && !$scope.advSearchInfo.userGroup.exclude.length && ($scope.advSearchInfo.fil == "all" || !$scope.advSearchInfo.fil) && $scope.advSearchInfo.prop == null){
        if($scope.auth.upreferences.isSplitV){
          $scope.quadHeight = $scope.getAvailableHeight(315);
          $scope.selectedHeight = $scope.getAvailableHeight(315);
        } else {
          $scope.quadHeight = $scope.getAvailableHeight(365) * 0.6;
          $scope.selectedHeight = $scope.getAvailableHeight(365) * 0.4;
        }
      }

      if(args.devices){
        $scope.dData = angular.copy(args);
        if($scope.dData.devices.length){
          if($scope.searchTextS.text && $scope.searchTextS.text.length){
            if(args.info.isLoadMore){
              $scope.sData.devices = $scope.sData.devices.concat($scope.dData.devices);
            } else{
              $scope.sData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.sData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.sData);
            $scope.devices = angular.copy($scope.sData);
            $scope.setCountFx();
          } else{
            if(args.info.isLoadMore){
              $scope.asData.devices = $scope.asData.devices.concat($scope.dData.devices);
            } else{
              $scope.asData = angular.copy($scope.dData);
            }
            $scope.addStatusKey($scope.asData.devices, $scope.auth.upreferences.dot);
            $scope.addTypeKey($scope.asData);
            $scope.devices = angular.copy($scope.asData);
            $scope.statusObj.as = true;
          }
          $scope.setCountFx();
        } else{
          $scope.asData = {devices: args.devices ? args.devices : [], info:args.info};
          $scope.devices.devices = angular.copy($scope.asData.devices);
          $scope.devices.info = angular.copy($scope.asData.info);
          $scope.setCountFx();
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
          if(args.dInfo && args.dInfo.allIds){
            $scope.devices.info.allIds = args.dInfo.allIds;
          }
        }

        $scope.isAdvSearch = true;
      }
      $scope.devices.folders = args.folders;
      $scope.isExcelData = false;

      //clear folder list if adv search active
      if($scope.isAdvSearchActive && $scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df'){
        $scope.folderList = [];
        $scope.breadCrumbs = [];
      }

      $scope.setCountFx();
      $scope.filterType = $scope.filter = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.filterType || $scope.filterType=="all"){
        $scope.filterType = "";
      }

      $scope.advSearchInfo = args.info;
      if(args.code == 8118 && !$scope.isAdvSearchActive){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $scope.curFolderId = 0;
        localStorage.removeItem("curDFId");
        $scope.apiCalledArr = [];
        $scope.paginationControls.currPage = 1;
        $scope.advSApply = false;
        $scope.devicesLoading = true;
        $scope.isGbdt = false;
        $scope.advSearchInfo = {};
        $rootScope.commonSearchVar = "";

        $scope.filter = JSON.parse(localStorage.getItem("filterType"));
        $scope.dReqObj = {auth:$scope.auth,offset:$scope.dOffset,text:$scope.searchTextS.text,filter:$scope.filter, caller:"d",fId:$scope.curFolderId};
        $scope.getDeviceAndProcessFx($scope.dReqObj,"dList", false);
      }
    });
    // $scope.devicesLoading = false;

    // var searchTimeout;
    $scope.searchChangeFx = function(caller, text){
      $rootScope.commonSearchVar = text;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if(!text){
        $scope.clearSearchFx();
        return;
      }else{
        if(!$scope.firstApply.filter){
          $scope.firstApply.search = true;
        } else {
          $scope.firstApply.search = false;
        }
        $scope.paginationControls.currPage = 1;
        if($rootScope.selectedT == 1 && text){
          $scope.search.text = text;
          if(text){
            $scope.devicesLoading = true;
            $rootScope.clearSearch = false;
            $scope.curAdvSearchObj = JSON.parse(localStorage.getItem("curAdvSearchCopy"));
            //Adv search implemented
            $scope.paginationControls.currPage = 1;
            $scope.filter = angular.fromJson(localStorage.getItem("filterType"));
            if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
              $scope.curAdvSearchObj = $scope.advSearchInfo;
              if($scope.filter != "all"){
                $scope.filterType = $scope.filter
                $scope.curAdvSearchObj.fil = $scope.filter;
              } else {
                $scope.filterType = "";
              }
              $scope.advSearchInfo.fil = $scope.curAdvSearchObj.fil;
              $scope.curAdvSearchObj.offset = 0;
              CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
                function(data){
                  $scope.devicesLoading = false;
                  $scope.filteredData = data;
                  $scope.curAdvSearchObj.isEmpty = data.isEmpty;
                  $scope.curAdvSearchObj.isLoadMore = false;
                  if(data.info.rdc || data.info.rdc == 0){
                    $scope.curAdvSearchObj.rdc = data.info.rdc;
                  }
                  $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
                  $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                },
                function(err){
                  $log.error(err);
                  $scope.searchProcessing = false;
                }
              );
            } else{
              $rootScope.offset = 0;
              $scope.devicesLoading = true;
              $scope.filter = JSON.parse(localStorage.getItem("filterType"));
              $scope.dReqObj = {auth:$scope.auth,offset:0,text:$scope.searchTextS.text,filter:$scope.filter,caller:$rootScope.selectedT == 1 ? 'd' : "dt",fId:$scope.curFolderId};
              $scope.getDeviceAndProcessFx($scope.dReqObj, "dList", false);
            }
          } else{
            $scope.devicesLoading = false;
          }
        } else {
          $scope.devicesLoading = false;
          if(caller){
            $scope.searchTextS.text = "";
            $scope.search.text = "";
            $scope.searchText = "";
            $rootScope.clearSearch = true;
            $rootScope.commonSearchVar = "";
          } else{
            $scope.searchText = $scope.searchTextS.text;
            $scope.search.text = $scope.searchTextS.text;
          }
        }
      }
    }

    $scope.saveDeviceGroupFx = function(caller, action){
      $scope.hasErr = false;
      $scope.curData = {};
      if(caller == "name"){
        if($scope.deviceGroup.info.label == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#label").focus();
          return;
        }
      }
      if(action == undefined){
        $scope.saveProcessing = true;
        $scope.deviceGroup.info.toast = false;
      } else{
        $scope.saveCloseProcessing = true;
        $scope.deviceGroup.info.toast = true;
      }
      DeviceGroupCUSrv.saveDeviceGroup($scope.deviceGroup).then(
        function(data){
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          if(data.code == 12022){
            $scope.errType = "exists";
            $scope.hasErr = true;
            $("#label").focus();
          } else if(data.code == 12039){
            $scope.errType = "mcDevice";
            $scope.hasErr = true;
          } else if(data.code == 12090){
            $scope.errType = "eslError";
            $scope.hasErr = true;
          } else if(data.code == 12042){
            $scope.curData = data;
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <div>{{"d.p_dg.m4" | translate}}</div>\
                    <div class="table marT15">\
                      <div class="row th">\
                        <div class="col-xs-12">{{"d.tab.1" | translate | camelCase}}</div>\
                      </div>\
                      <div class="overflow-auto" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row" ng-repeat="err in curData.devices">\
                          <div class="col-xs-12 word-break">{{err}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <div class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                  </div>\
                </section>',
              plain:true,
              width:700,
              scope:$scope,
              data:$scope.curData,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            if(action == undefined){
              if(caller == "name"){
                $scope.encId = $scope.hubEncrypt(data.deviceGroupId);
                if($state.current.name == "hub.dContainer.dgName"){
                  $state.go("hub.dContainer.dgDevice", {
                    id:$scope.encId
                  });
                }
              } else if(caller == "device"){
                $state.go("hub.devices.dg");
              }
            } else{
              if($state.current.name == "hub.dContainer.dgName" || $state.current.name == "hub.dContainer.dgDevice"){
                $state.go("hub.devices.dg");
              }
            }
          }
        },
        function(err){
          $scope.saveCloseProcessing = false;
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.importOpen = function(){
      // $scope.devices = angular.copy($scope.devicesCopy);
      // $scope.searchChangeFx("empty");
      $scope.isExcelData = false;
      $scope.advSearchInfo = {};

      $scope.importing = false;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.importObj = {};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"d.p_dg.4" | translate}}</h1></header>\
            <div class="panel-body scrollQuad" style="max-height:{{getAvailableHeight(304)}}px">\
              <div class="form-group">\
                <label>{{"d.p_dg.4" | translate | capitalize}}</label> <span class="text-sm marL5">(<a href="https://s3-us-west-2.amazonaws.com/lsquared-hub/support/downloads/doc/device-group.xlsx" target="_blank">{{"cl.btn.21" | translate}}</a>)</span>\
                <div class="btn-file">\
                  <button type="button" role="button" class="btn btn-primary btn-sm">{{"cm.btn.36" | translate}}</button>\
                  <input type="file" file-model="importObj.file" options="{format:[\'excel\']}">\
                  <input type="text" class="form-control" ng-model="importObj.file.name" readonly="" aria-label="{{\'d.p_dg.4\' | translate}}" aria-labelledby="{{\'d.p_dg.4\' | translate}}">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-primary" ng-click="importFx();" ng-disabled="importing"><span ng-class="importing?\'fa fa-repeat fa-spin\':\'fa fa-check\'" aria-hidden="true"></span> {{"cm.btn.42" | translate}}</button>\
                <button type="button" role="button" class="btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div ng-if="hasErrPop" class="errMsg pull-right" aria-live="polite" role="status">{{errTypePop == "empty"?"d.p_dg.m8":"d.p_dg.m7" | translate}}</div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.importFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.importObj.file){
        $scope.hasErrPop = true;
        $scope.errTypePop = "empty";
      } else{
        $scope.importing = true;
        FileModelUploadSrv.uploadFileAndData("devices/groups/file" + ($scope.auth.upreferences.deviceView == 'l' ? "?isLV=1":""), {id:$scope.decId}, $scope.importObj.file).then(
          function(data){
            $scope.importing = false;
            if(data.length){
              $scope.devices.devices = data;
              $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
              $scope.addTypeKey($scope.devices);
              $scope.folderList = [];
              $scope.isExcelData = true;

              $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
              if(!$scope.filterType || $scope.filterType=="all"){
                $scope.filterType = "";
                $scope.filter = "all";
                $scope.fCount = $scope.devices.devices;
              } else {
                $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
              }
              $scope.updateList();
              ngDialog.close();
            } else{
              $scope.hasErrPop = true;
              $scope.errTypePop = "no";
            }
          },
          function(err){
            $log.error(err);
            $scope.importing = false;
            $rootScope.toastNotificationFx("danger", {"code":5000});
          }
        );
      }
    }

    $scope.devicePreviewFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    }

    $scope.clearFx = function(){
      $scope.isExcelData = false;
      // $scope.devices = angular.copy($scope.devicesCopy);
	    $scope.folderContentFx(0);
    }

    $rootScope.deleteCallback = function(){}


    // ?===========================================================
    // ? Below code used for Device Folders
    // ?===========================================================
    $scope.updateList = function(){
      // console.warn("updateList");
      if($scope.searchTextS.text && $scope.searchTextS.text.length){
        $scope.folderList = [];
      }
      $scope.breadCrumbs = [];
      if(!$rootScope.addStatusKeyVal.value){
        $scope.devicesLoading = false;
      }
      $scope.deviceGrpLoading = false;
      if($scope.devices && $scope.devices.devices){
        $scope.filterCount = $scope.devices.devices.length;
      }
      if ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'df' && !$scope.isExcelData) {
        // console.warn(!$scope.searchTextS.text);
        if ($scope.devices.folders) {
          $scope.folderList = $scope.devices.folders;
        } else if($scope.dData.folders && $scope.dData.folders.length && !$scope.searchTextS.text){
          $scope.folderList = $scope.dData.folders;
        }
        if ($scope.devices.info && $scope.devices.info.breadCrumbs) {
          $scope.breadCrumbs = $scope.devices.info.breadCrumbs;
        }
      }
      if($scope.searchTextS.text && $scope.searchTextS.text.length){
        $scope.folderList = [];
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if(!$scope.devices.types){
        if(!$scope.filterType || $scope.filterType=="all"){
          $scope.filterType = "";
          $scope.filter = "all";
        }
      }
    }

    $scope.folderContentFx = function (fId, splId, splType, caller) {
      // console.warn("folderContentFx", caller);
      $scope.curNum = 0;
      $scope.isExcelData = false;
      $scope.apiCalledArr = [];
      if(!caller || caller != "changeView"){
        $scope.searchTextS.text = "";
        $scope.search.text = "";
        $rootScope.commonSearchVar = "";
        // $rootScope.search = {text:""};
      }
      if(caller=="changeView"){
        $rootScope.offset = 0;
      }
      $scope.paginationControls.currPage = 1;

      $scope.devicesLoading = true;
      $scope.search = { text: "" };
      $rootScope.selectedItems = [];
      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curDFId");
      $scope.advSearch = false;
      $scope.curFolderId = 0;

      if (fId == 0) {
        $scope.breadCrumbs = [];
      }
      if (fId) {
        localStorage.setItem("curDFId", fId);
        $scope.curFolderId = localStorage.getItem("curDFId");
      }

      if ($scope.curFolderId == 0) {
        localStorage.setItem("inFolder", 0);
        localStorage.setItem("curDFId", 0);
        localStorage.removeItem("curPathFId");
      }

      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType != "all"){
        $scope.filterIsAppliedAlready = true;
      }
      $scope.folObj = {fId:fId, offset:0, obj:null, caller:"group",filType:$scope.filterType,text:$scope.searchTextS.text,isLV:($scope.auth.upreferences.deviceView=="l"?true:false)};
      // DevicesSrv.getFolderData(fId, null, null, "group", $scope.filterType, $scope.searchTextS.text).then(
      DevicesSrv.getFolderData($scope.folObj).then(
        function (data) {
          $scope.flId = fId;
          $scope.devicesLoading = false;
          $scope.deviceGrpLoading = false;
          $scope.devices = angular.copy(data);
          if(data.info.rdc || data.info.rdc == 0){
            $scope.rdc = data.info.rdc;
          }
          $scope.addStatusKey($scope.devices.devices, $scope.auth.upreferences.dot);
          $scope.addTypeKey($scope.devices);
          $scope.dData = angular.copy($scope.devices)
          $scope.brief = data;
          $scope.setCountFx();
          $scope.updateList();

          if(!$scope.filterType || $scope.filterType=="all"){
            $scope.filterType = "";
            $scope.filter = "all";
            $scope.fCount = $scope.devices.devices;
          } else {
            $scope.fCount = $filter("filter")($scope.devices.devices, {status:$scope.filterType}, true);
          }
        },
        function (err) {
          $scope.devicesLoading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderBriefFx = function (obj) { /*Get folder briefs*/}

    $scope.$on('$destroy', function() {
      localStorage.setItem("curDFId", 0);
      $scope.advSearchInfo = {};
    });

    $rootScope.$on('reloadDevices', function(event, data){
      $scope.devicesLoading = true;
    });

    var deregister = $scope.$on('changeView', function(event, data){
      // if($scope.auth.upreferences.deviceView=="t"){
      //   $scope.thumbView = true;
      //   $scope.listView = false;
      // } else {
      //   $scope.listView = true;
      //   $scope.thumbView = false;
      // }
      $rootScope.offset = 0;
      $scope.paginationControls.currPage = 1;
      $scope.apiCalledArr = [];
      if($scope.selectedTab == "hub.dContainer.dgDevice"){
        var fId = localStorage.getItem("curDFId");
        $scope.curAdvSearchObj = $scope.advSearchInfo;
        if($scope.advSApply || (!angular.isUndefined($scope.advSearchInfo) && $scope.advSearchInfo && $scope.advSearchInfo.id > 0)){
          $scope.curAdvSearchObj.offset = 0;
          CommonSrv.updateAdvSearch($scope.curAdvSearchObj, $scope.auth, $scope.searchTextS.text).then(
            function(data){
              $scope.devicesLoading = false;
              $scope.filteredData = data;
              $scope.curAdvSearchObj.isEmpty = data.isEmpty;
              $scope.curAdvSearchObj.isLoadMore = false;
              if(data.info.rdc || data.info.rdc == 0){
                $scope.curAdvSearchObj.rdc = data.info.rdc;
              }
              $scope.curAdvSearchObj.sortType = data.info.sortType;
              $scope.curAdvSearchObj.sortVal = data.info.sortVal;
              $scope.advSearchfilteredData = {info:$scope.curAdvSearchObj, devices:$scope.filteredData.devices, advObj:$scope.curAdvSearchObj};
              $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
            },
            function(err){
              $log.error(err);
              $scope.searchProcessing = false;
            }
          );
        } else if($scope.isExcelData){
          $scope.importFx();
        } else {
          if(fId > 0){
            $scope.folderContentFx(fId, null, null, "changeView");
          } else {
            $scope.loadDevicesFx("changeView");
          }
        }
      }
      // deregister();
    });

    $rootScope.fileModelUploadFx = function(data, fmType){
      $scope.curData = data;
      $scope.hasErr = false;
      $scope.emptyRow = "";
      $scope.errType = "";
      $scope.fileModelLoading = true;
      $scope.validationOn = false;
      FileModelUploadSrv.uploadFileAndData("common/convertTojson" + $scope.emptyRow,{}, $scope.curData).then(
        function(data){
          if(fmType == "d-advSearch"){
            $scope.fileModelLoading = false;
            $scope.convertData = data;
            $rootScope.importXls = $scope.convertData;
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }
    // Function to update currentPageDevice only if there are changes
    function updateCurrentPageDevice(newData) {
      // console.warn($scope.currentPageDevice, newData);
      // Deep compare the new data with the current data
      if (!angular.equals($scope.currentPageDevice, newData.curData)) {
        $scope.currentPageDevice = angular.copy(newData.curData);
      }
      if (!angular.equals($scope.allPageDevice, newData.allData.length)) {
        $scope.allPageDevice = angular.copy(newData.allData.length);
        // console.warn($scope.allPageDevice);
      }
    }

    // Listen for the 'itemsPerPage' event
    $rootScope.$on('itemsPerPage', function(event, data) {
      updateCurrentPageDevice(data);
    });

    // Function to get comma-separated IDs
    $scope.getCommaSeparatedIds = function() {
      // console.log("getCommaSeparatedIds", $scope.currentPageDevice);
      return $scope.currentPageDevice.map(function(obj) {
          return obj.id;
      }).join(',');
    };

    // Use $watch to monitor currentPageDevice for changes
    $scope.$watch('currentPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.currentPageDevice = newVal
        $scope.getDeviceStatus();
      }
    }, true); // 'true' for deep watch

    $scope.$watch('allPageDevice', function(newVal, oldVal) {
      if (!angular.equals(newVal, oldVal)) {
        $scope.allPageDevice = newVal;
        var allPagesCount = Math.ceil($scope.allPageDevice / $scope.paginationControls.pageSize);
        if(allPagesCount){
          if(!$scope.pageDeviceArr.length){
            for (var i = 1; i <= allPagesCount; i++) {
              $scope.pageDeviceArr.push({pNo:i, tz:new Date().getTime()})
            }
          }else{
            var start = angular.copy($scope.pageDeviceArr.length);
            for (var i = 1; i <= allPagesCount - start; i++) {
              $scope.pageDeviceArr.push({pNo:start +i, tz:new Date().getTime()})
            }
          }
        }
      }
    }, true); // 'true' for deep watch
  };
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('DeviceCUController', DeviceCUController);

  /** @ngInject */
  function DeviceCUController($log, $rootScope, $scope, $state, $timeout, $cookies, $filter, ngDialog, FrameLayoutsSrv, DevicesSrv, DevicesTagSrv, DevicesCUSrv, ContentLibrarySrv, DashboardSrv, $stateParams){
    $rootScope.selectedMenu = 5;
    $scope.tags = {availableTags:[], assigned:[]};
    $scope.tag = {info:{label:"", step:"n"}};
    $scope.selectedTab = $state.current.name;
    $scope.saveCloseProcessing = false;
    $scope.searchTextFl = {val:""};
    $scope.saveProcessing = false;
    $scope.isConfirmOpen = false;
    $scope.detailsLoading = true;
    $scope.search = {text:""};
    $scope.eslNotAuth = false;
    $scope.isPEOpen = false;
    $scope.moveInLib = true;
    $scope.valueType = "t";
    $scope.hasErr = false;
    $scope.deviceId = {};
    $scope.curTags = {};
    $scope.errType = "";
    $scope.encId = "";
    $scope.decId = "";
    $scope.mapOverlay;
    $scope.timestamp;
    $scope.curPoly;
    $scope.valueType = "t";
    $scope.searchTextFl = { val:"" };
    $scope.search = { text:"" };
    $scope.searchDOInfo = {text:""};
    $scope.searchDP = {'text':''};
    $scope.fId = localStorage.getItem("curDFId");
    $scope.searchAS = {text:''};
    $scope.DeviceTagList = false;
    $scope.advSearchInfo = undefined;

    if($state.params.id){
      if(localStorage.getItem("isDlAdvSearch")){
        localStorage.setItem("isActionOnDevice", true);
      } else{
        localStorage.removeItem("isActionOnDevice");
        localStorage.removeItem("isDlAdvSearch");
        localStorage.removeItem("curFilterDlObj");
      }
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      DevicesCUSrv.getDevicesDetails($scope.decId).then(
        function(data){
          $scope.detailsLoading = false;
          $scope.device = data;

          $scope.device.info.info.forEach(function(item){
            if(item.value == ""){
              item.isblank = true;
            } else{
              item.isblank = false;
            }
          });

          $scope.device.info.properties.forEach(function(item){
            if(item.value == ""){
              item.isblank = true;
            } else{
              item.isblank = false;
            }
          });

          $scope.tim = $scope.device.info.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.device.info.otherinfo.bucket;
          if(!$scope.device.info.info || $scope.device.info.info == null || $scope.device.info.info.length == 0){
            $scope.device.info.info = [{ label:"", value:"", vType:"t", isEditable:true }];
          }
          if($scope.device.info.otherinfo.mbucket && $scope.device.info.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.device.info.otherinfo.mbucket;
          }

          if($scope.device.permission){
            $scope.permission = $scope.device.permission;
          }
          if($scope.selectedTab === "hub.dContainer.dFrameLayout"){
            if($scope.device.info.fla && $scope.auth.upermissions.flae){
              $rootScope.selectedT = 2;
              $rootScope.selectedTabFx();
            } else{
              $rootScope.selectedTabFx();
            }
          }
          if(!$scope.device.info.frameLayout){
            $rootScope.singleSelected = null;
          } else{
            $rootScope.singleSelected = $scope.device.info.frameLayout;
          }
          if($scope.selectedTab === "hub.dContainer.dName" && $scope.device.info.dType == "gf"){
            $scope.loadMap('edit');
          }

          if($scope.selectedTab === "hub.dContainer.dName" && $scope.device.info.dType == "epd"){
            $scope.changeDeviceType();
          }

          if($scope.device.info.info.length){
            $scope.device.info.info.forEach(function(item, i){
              item.id = i + 1;
              if(item.vType == "dt"){
                item.time = item.time ? $scope.formatTime(item.value) : "";
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    } else{
      DevicesCUSrv.getLicenseTypes($scope.auth.server).then(
        function(data){
          $scope.licenseList = data;
          $scope.allLicenseList = [];

          angular.forEach($scope.licenseList, function(obj){
            $scope.allLicenseList.push(obj.data);
            // angular.forEach(obj.data, function(val){
            //   return val.t = obj.lbl;
            // });
          });

          $scope.device = {
            info:{ label:"", mac:"", dType:"mp", licId:{id:"",lt:""}, regType:"d", timezone:$scope.auth.defaultTimezone, frameLayout:null, polyArr:[], info:[{ label:"", vType:"t", value:"", isEditable:true }] },
            permission:{ type:$scope.auth.upreferences.defaultP },
            tags:{}
          };
          DevicesCUSrv.getProperties().then(
            function(data){
              $scope.device.info.properties = data.properties;
              $scope.device.info.switches = data.switches;
              $scope.device.info.properties.forEach(function(item){
                if(item.value == ""){
                  item.isblank = true;
                } else{
                  item.isblank = false;
                }
              });
              $scope.detailsLoading = false;
            },
            function(err){
              $scope.detailsLoading = false;
              $log.error(err);
            }
          );
          $rootScope.singleSelected = null;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.licSearchFocus = function(){
      // $scope.searchLic = "";
      $scope.searchLic = {l:""};
      if($scope.licenseList.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $scope.lic = {isOpen:false};
    $scope.selectLic = function(id, lbl){
      $scope.device.info.licId = {id:id, lt:lbl};
      $scope.lic.isOpen = !$scope.lic.isOpen;
    }

    $scope.toggleDropDown = function(call){
      if(call && $scope.device.info.licId.id){
        $rootScope.$broadcast('selectedItemChanged', $scope.device.info.licId.id);
      }
    }


    // EPD Type
    $scope.epdSearchFocus = function(){
      $scope.searchEpd = {l:""};
      if($scope.epdGrouped.length > 1){
        angular.element(document).find(".findSearch").children()[0].focus();
      }
    }

    $scope.epd = {isOpen:false};
    $scope.selectEpdFx = function(epd){
      $scope.device.info.eslInfo = epd;
      $scope.epd.isOpen = !$scope.epd.isOpen;
    }

    // $scope.toggleDropDown = function(call){
    //   if(call && $scope.device.info.licId.id){
    //     $rootScope.$broadcast('selectedItemChanged', $scope.device.info.licId.id);
    //   }
    // }


    $scope.formatTime = function(value){
      // Convert the date string to a JavaScript Date object
      var dateObject = new Date(value);

      // Use the $filter service to format the date object
      var $filter = angular.injector(['ng']).get('$filter');
      var formattedDate = $filter('date')(dateObject, "yyyy-MM-ddTHH:mm:ss.sssZ");

      return formattedDate;
    }

    /*Select Frame layouts*/
    if($scope.selectedTab === "hub.dContainer.dFrameLayout"){
      $scope.selection = false; /*ngSetected set false*/
      $scope.frameLayouts = {};
      $rootScope.selectedTabFx = function(){
        if(!$scope.auth.upermissions.fla && !$scope.auth.upermissions.flae){
          $state.go("hub.devices.d");
        } else{
          $scope.frameLayoutsLoading = true;
          if($scope.auth.uType == 4 && !$scope.auth.upermissions.fla && $scope.auth.upermissions.flae){
            $rootScope.selectedT = 2;
          }
          if($rootScope.selectedT == 1){
            $scope.searchTextFl = { val:"" };
            FrameLayoutsSrv.getApproved().then(
              function(data){
                if($state.current.name == "hub.dContainer.dFrameLayout" && $rootScope.selectedT == 1){
                  $scope.frameLayouts = data;
                  $scope.frameLayoutsLoading = false;
                  $scope.tim = $scope.frameLayouts.info.timthumb;
                  $scope.bucket = $scope.frameLayouts.info.bucket;
                  if($scope.moveInLib && !$scope.frameLayouts.frameLayouts.length){
                    $rootScope.selectedT = 3;
                    $rootScope.selectedTabFx();
                  }
                }
              },
              function(err){
                $log.error(err);
              }
            );
          } else if($rootScope.selectedT == 2){
            $scope.searchText = { val:"" };
            FrameLayoutsSrv.getAssignments().then(
              function(data){
                if($state.current.name == "hub.dContainer.dFrameLayout" && $rootScope.selectedT == 2){
                  $scope.frameLayouts = data;
                  $scope.frameLayoutsLoading = false;
                  $scope.tim = $scope.frameLayouts.info.timthumb;
                  $scope.bucket = $scope.detailBucket = $scope.frameLayouts.info.bucket;
                  if($scope.frameLayouts.info.mbucket && $scope.frameLayouts.info.mbucket != ""){
                    $scope.detailBucket = $scope.frameLayouts.info.mbucket;
                  }
                  if($scope.moveInLib && !$scope.frameLayouts.frameLayouts.length){
                    $rootScope.selectedT = 3;
                    $rootScope.selectedTabFx();
                  }
                }
              },
              function(err){
                $log.error(err);
              }
            );
          }else if($rootScope.selectedT == 3){
            $scope.searchTextFl = { val:"" };
            FrameLayoutsSrv.getLibrary().then(
              function(data){
                if($state.current.name == "hub.dContainer.dFrameLayout" && $rootScope.selectedT == 3){
                  $scope.moveInLib = false;
                  $scope.frameLayouts = data;
                  $scope.frameLayoutsLoading = false;
                }
              },
              function(err){
                $log.error(err);
              }
            );
            $scope.openFolderFx = function(id){ //For dblClick
              $scope.frameLayoutsLoading = true;
              $scope.searchTextFl = { val:"" };
              FrameLayoutsSrv.getLibraryContent(id).then(
                function(data){
                  $scope.frameLayouts = data;
                  $scope.frameLayoutsLoading = false;
                  $scope.tim = $scope.frameLayouts.info.timthumb;
                  $scope.bucket = $scope.frameLayouts.info.bucket;
                },
                function(err){
                  $log.error(err);
                }
              );
            }
          }
        }
      }
    }

    $scope.addCustomInfo = function(vType){
      $scope.device.info.info.push({ id:$scope.device.info.info.length+1, label:"", value:"", vType:vType, isEditable:true, time:moment().format() });
    }

    $scope.removeCustomInfo = function(id){
      var index = $scope.device.info.info.findIndex(function(item) {
        return item.id === id;
      });
      $scope.searchDOInfo.text = "";
      $scope.device.info.info.splice(index, 1);
    }

    /*Info Image*/
    $scope.logoPopover = { templateUrl:"logo.html" };

    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.curImages = [];
      $scope.curFiles = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if((item.type == "Image" || (item.splType && item.splType == "Image") && (item.extn == "JPG" || item.extn == "PNG" || item.extn == "JPEG"))){
          $scope.curImages.push(item);
        }
        if(item.type == "WORD" || item.type == "Vector"){
          $scope.curFiles.push(item);
        }
      });
      $scope.contentList = $scope.curImages.concat($scope.curFiles);
    }
    $scope.selectContentOpen = function(index){
      $scope.useContentErr = { empty:false };
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.curContent = "";
      $scope.curIndex = index;
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.search = { text:"" };
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:845,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      $scope.search = { text:"" };
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curContent = {
              id:listItem.id,
              fid:listItem.fid,
              url:listItem.url,
              isAccessible:true,
              extn:listItem.extn,
              btnExtn:listItem.btnExtn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              duration:listItem.duration,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl
            };
          }
        });
      }else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      $scope.device.info.info[$scope.curIndex].vFile = $scope.curContent;
      ngDialog.close();
    }
    $scope.removeImgFx = function(index){
      $scope.device.info.info[index].vFile = null;
    }

    /*ngDialog*/
    $scope.deviceListFx = function(id, label){
      $scope.popupLabel = label;
      $scope.deviceList = [];
      $scope.refreshObj = {l:true, b:false};
      // $scope.deviceFrameObj = {id:id, label:label};
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.haveMoreSearchData = false;
      $scope.searchScroll = false;
      $scope.deviceRefObj = {id:id, label:label};
      $scope.scrollObj = {caller:'fla', offset:0, id:id};
      DevicesSrv.getScrollListData($scope.scrollObj).then(
        function(data){
          if(data.d.length >= 1000){
            $scope.haveMoreData = true;
          } else{
            $scope.haveMoreData = false;
          }
          $scope.marginLoad = false;
          $scope.scrollDataList = data.d;
          $scope.allScrollDataList = [];
          $scope.allScrollDataList = angular.copy($scope.scrollDataList);
          $scope.refreshObj = {l:false, b:true};
        },
        function(err){
          $log.error(err);
        }
      );

      ngDialog.open({
        template:"app/frameLayouts/popup/deviceList.html",
        width:620,
        scope:$scope
      });
    }

    $scope.refreshPopupListFx = function(caller){
      $scope.loading = true;
      if(caller === 'device'){
        $scope.deviceList = [];
        $scope.refreshObj = {l:true, b:true};
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller:'fla', offset:0, id:$scope.deviceRefObj.id};
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.marginLoad = false;
            $scope.scrollDataList = data.d;
            $scope.allScrollDataList = [];
            $scope.allScrollDataList = angular.copy($scope.scrollDataList);
            $scope.refreshObj.l = false;
            if(!$scope.scrollDataList.length){
              $scope.refreshObj.b = false;
            }
            $scope.loading = false;
          },
          function(err){
            $scope.loading = false;
            $log.error(err);
          }
        );
      } else{
        $scope.useContentErr = {empty:false};
        $scope.contentLoading = true;
        $scope.openingLoading = true;
        $scope.curContent = "";
        ContentLibrarySrv.getApproved().then(
          function(data){
            $scope.contentLibrary = data;
            $scope.loading = false;
            $scope.advSearchInfo = {};
            $scope.advSearch = false;
            $scope.updateList();
          },
          function(err){
            $scope.contentLoading = false;
            $scope.openingLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.downloadDeviceListFx = function(val){
      var downloadObj = { type:"", subType:"", devices:[] };
      downloadObj.type = "flDevices";
      $scope.arraytoStringFx(val); /*Array to String common*/
      downloadObj.devices = $scope.stringIds;
      $rootScope.linkOpenObj = { loading:true, url:"", surl:"" };
      $scope.linkOpenFx('d');
      DashboardSrv.postDowanloadExcel(downloadObj).then(
        function(data){
          if(data.code == 18009){
            $scope.hasErr = true;
            $scope.errType = "noData"
          }else{
            $rootScope.linkOpenObj = { loading:false, url:data.url, surl:"" };
          }
        },
        function(err){
          $log.error(err);
        }
      );
      return;
    }

    $scope.deviceIdOpen = function(id, label, mac, caller){
      $scope.dataObj = { id:id, label:label, mac:mac, caller:caller };
      ngDialog.open({
        template:'app/devices/popup/deviceId.html',
        width:450,
        scope:$scope,
        data:$scope.dataObj,
        closeByDocument:false,
        controller:'DeviceIdController'
      });
    }

    $scope.polyClickFx = function(event, arg1){
      if($scope.curPoly){
        $scope.curPoly.setOptions({ fillOpacity:0.5, editable:false });
        $scope.curPoly = null;
      }
      $scope.curPoly = this;
      $scope.curPoly.customId = arg1;
      $scope.curPoly.setOptions({ fillOpacity:0.8, editable:true });
    }

    $scope.drawPolygonComplete = function(e){
      $scope.mapOverlay = e.overlay;
      $scope.timestamp = moment().format('x');
      $scope.mapOverlay.customId = $scope.timestamp;

      if($scope.curPoly){
        $scope.curPoly.setOptions({ fillOpacity:0.5, editable:false });
        $scope.curPoly = null;
      }
      $scope.mapOverlay.addListener("click", function(){
        $scope.curPoly = e.overlay;
      });
      $scope.mapOverlay.map.mapDrawingManager[0].setOptions({ drawingMode:null });
      $scope.device.info.polyArr.push({ id:$scope.mapOverlay.customId, arr:$scope.getPolyLatLng() });
      $scope.mapOverlay.setMap(null);
    }

    $scope.getPolyLatLng = function(){
      $scope.tempArr = [];
      $scope.tempLatLng = "";
      angular.forEach($scope.mapOverlay.getPath(), function(item, index){
        $scope.tempLatLng = $scope.mapOverlay.getPath().getAt(index).toUrlValue(12);
        $scope.tempArr.push($scope.tempLatLng.split(","))
      });
      return $scope.tempArr;
    }

    $scope.mapClickFx = function(){
      if($scope.curPoly){
        $scope.curPoly.setOptions({ fillOpacity:0.5, editable:false });
        $scope.curPoly = null;
      }
    }

    /*Azure Map*/
    var azmap, drawingManager, polyArr;
    $scope.loadMap = function(caller){

      $timeout(function(){
        if($scope.device.info.dType == 'gf'){
          // var keyArr = atob($scope.auth.uservices.mk).split("|");
          // var subKey = $scope.reverse(keyArr[0]);

          azmap = new atlas.Map('azMap', {
            view:'Auto',
            showFeedbackLink:false,
            enableAccessibilityLocationFallback:false,
            // Add your Azure Maps subscription client ID to the map SDK.
            authOptions:{
              //Alternatively, use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE:The primary key should be used as the key.
              authType:'subscriptionKey',
              // subscriptionKey:$scope.decryptFx($scope.auth.uservices.mk)
              subscriptionKey:'KID57hqwgPX1MyuBvAcyizt5t_WBJU4KmafpfF-oiOM'
            },
            language: "en"
          });

          //Wait until the map resources are ready.
          azmap.events.add("ready", function(){

            //Create an instance of the drawing manager and display the drawing toolbar.
            drawingManager = new atlas.drawing.DrawingManager(azmap, {
              interactionType:'click',
              toolbar:new atlas.control.DrawingToolbar({
                position:'top-right',
                buttons:["draw-polygon", "edit-geometry"]
              })
            });

            //When the drawing started, check to see if the interaction type is set to click, and if it is, re-enable panning of the map.
            azmap.events.add('drawingstarted', drawingManager, function(){
              if(drawingManager.getOptions().interactionType === 'click'){
                azmap.setUserInteraction({ dragPanInteraction:true });
              }
            });

            if(caller == "edit"){
              var featureArr = [];
              var source = drawingManager.getSource()
              angular.forEach($scope.device.info.polyArr, function(item){
                featureArr.push({ "type":"Feature", "geometry":{ "type":"Polygon", "coordinates":[item.arr] } });
              });

              //Pass the shape into the edit function of the drawing manager.
              var positions = { "type":"FeatureCollection", "features":featureArr };
              source.setShapes(positions);

              azmap.setCamera({
                //center map
                bounds:atlas.data.BoundingBox.fromData(positions),
                padding:50
              });
            } else{
              azmap.setCamera({
                //center map
                center:[75.8577, 22.7196],
                zoom:8
              });
            }

          });
        }

      }, 1000);
    }

    $rootScope.deleteCallback = function(){
      if(!$scope.isConfirmOpen && $scope.curPoly){
        $scope.confirmDeletePoly();
      }
    }

    $scope.confirmDeletePoly = function(){
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"d.msg.8" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePoly();">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm",
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deletePoly = function(){
      $scope.curPoly.setMap(null);
      angular.forEach($scope.device.info.polyArr, function(item, index){
        if($scope.device.info.polyArr[index].id == $scope.curPoly.customId){
          $scope.device.info.polyArr.splice(index, 1);
        }
      });
      $scope.curPoly = null;
      ngDialog.close();
    }

    /*Select Tags*/
    if($scope.selectedTab === "hub.dContainer.dTag"){
      $scope.DeviceTagList = true;
      DevicesCUSrv.getDeviceTags($scope.decId).then(
        function(data){
          if($state.current.name == "hub.dContainer.dTag"){
            $scope.DeviceTagList = false;
            $scope.curTags = data;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.createTagFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.tag.info.dId = $scope.decId;
      $scope.tag.info.tagColor = "";
      $scope.tag.info.tagColorType = "monochrome";
      $scope.tag.info.isBg = false;
      if($scope.tag.info.label == ""){
        $scope.errType = "form";
        $scope.hasErr = true;
        $("#label").focus();
        return;
      } else{
        DevicesTagSrv.saveTagCU($scope.tag).then(
          function(data){
            if(data.code == 12007){
              $scope.tag.info = {label:"", step:"n"};
              $scope.curTags.availableTags.push(data);
            } else{
              $scope.errType = "tag";
              $scope.hasErr = true;
              $("#label").focus();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.saveDeviceFx = function(step, action, caller){
      $scope.device.info.frameLayout = $rootScope.singleSelected;
      $scope.hasErr = false;
      if(parseInt($stateParams.fid) > 0){
        $scope.fId = parseInt($stateParams.fid);
        localStorage.setItem("curDFId", $scope.fId);
        $scope.device.info.fId = $scope.fId;
      } else{
        $scope.device.info.fId = $scope.fId;
      }
      var polyArr = [];
      if($scope.device.info.dType == 'gf' && step == 1){
        var source = drawingManager.getSource().toJson();
        if(source.features.length){
          angular.forEach(source.features, function(item){
            polyArr.push({ id:item.id, arr:item.geometry.coordinates[0] })
          });
        }
        $scope.device.info.polyArr = polyArr;
      }
      if(step == 1){
        $scope.device.info.step = caller;
        if($scope.device.info.licId.id == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#lic").focus();
          return;
        } else if($scope.device.info.mac == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#mac").focus();
          return;
        } else if($scope.device.info.label == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          $("#label").focus();
          return;
        }
        if($scope.device.info.info.length && $filter("findDuplicates")($scope.device.info.info, "label")){
          $scope.errType = "outher";
          $scope.hasErr = true;
          return;
        }
        if($scope.device.info.dType == "gf" && $scope.device.info.polyArr.length == 0){
          $scope.errType = "fence";
          $scope.hasErr = true;
          return;
        }
      } else if(step == 2){
        $scope.device.info.step = caller;
        if($scope.device.info.mac == "" || $scope.device.info.label == ""){
          $scope.errType = "form";
          $scope.hasErr = true;
          return;
        }
        if($scope.device.info.dType == "epd"){
          if(!$scope.device.info.eslInfo || $scope.device.info.eslInfo == ""){//|| !$scope.device.info.eslInfo.selectedDpi
            $scope.errType = "form";
            $scope.hasErr = true;
            return;
          }
        }
      } else if(step == 3){
        $scope.device.info.step = caller;
        $scope.curData = {};
      }
      if($scope.curTags.assignedTags || $scope.curTags.hiddenTags){
        $scope.device.tags = {assignedTags:$scope.curTags.assignedTags, hiddenTags:$scope.curTags.hiddenTags};
      }
      if($rootScope.isPermissionOpen){
        $scope.isPEOpen = true;
        $rootScope.$broadcast('savePermission',{});
      }
      for(var i = $scope.device.info.info.length - 1; i >= 0; i--){
        if($scope.device.info.info[i].label == "" && ($scope.device.info.info[i].value == "" && !$scope.device.info.info[i].vFile)){
          $scope.device.info.info.splice(i, 1);
        } else if($scope.device.info.info[i].label == "" && ($scope.device.info.info[i].value != "" || $scope.device.info.info[i].vFile)){
          $scope.errType = "label";
          $scope.hasErr = true;
          return;
        }
      }
      if($scope.device.info.properties.length && $scope.isPEOpen){
        $timeout(function(){
          $scope.saveDevice(step, action, caller);
        }, 250);
      } else{
        $scope.saveDevice(step, action, caller);
      }
    }

    $scope.saveDevice = function(step, action, caller){
      $scope.isHaveOneDT = false;
      if(action == 'sc'){
        $scope.saveCloseProcessing = true;
        $scope.device.info.toast = true;
      } else{
        $scope.device.info.toast = false;
        $scope.saveProcessing = true;
      }
      if($scope.device.info.info.length){
        angular.forEach($scope.device.info.info, function(item){
          if(item.vType == 'dt'){
            item.dateRange = {startDate:moment(item.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(item.dateRange.endDate).format('MM/DD/YYYY')}
            item.value = item.dateRange.startDate + " " + moment(item.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
          }
        })
      }
      if($scope.device.info.properties.length){
        angular.forEach($scope.device.info.properties, function(item){
          // if(item.vType == 'd' || item.vType == 'dt'){
          //   item.dateRange = {startDate:moment(item.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(item.dateRange.endDate).format('MM/DD/YYYY')}
          //   item.value = item.dateRange.startDate + " " + moment(item.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
          // } else if(item.vType == 'ti' && item.time){
          //   item.value = moment(item.time).format("HH:mm:ss").split(" ")[1];
          // } else {
          //   item.value = "";
          // }
          if(item.vType == 'd' || item.vType == 'dt'){
            if(item.dateRange){
              item.dateRange = {startDate:moment(item.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment(item.dateRange.endDate).format('MM/DD/YYYY')}
            }
            if(item.vType == 'd'){
              if(!item.isblank){
                item.value = item.dateRange ? item.dateRange.startDate : "";
              } else{
                item.value = null;
              }
            } else {
              if(!item.isblank && item.time){
                item.value = item.dateRange.startDate + " " + moment(item.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
              } else{
                item.value = null;
              }
            }
          }
          if(item.vType == 'ti'){
            if(item.time){
              item.value = moment(item.time).format("HH:mm:ss");
            } else{
              item.value = null;
            }
          }
        })
      }
      if($scope.device.info.properties.length){
        angular.forEach($scope.device.info.properties, function(obj){
          if(obj.vType == 'dt'){
            if((obj.isblank && obj.time && obj.value == null) || (!obj.isblank && !obj.time && obj.value == null)){
              $scope.isHaveOneDT = true;
            }

          }
        })
      }
      if($scope.isHaveOneDT){
        $scope.saveProcessing = false;
        $scope.saveCloseProcessing = false;
        $scope.errType = "haveOne";
        $scope.hasErr = true;
      } else{
        DevicesCUSrv.saveDevice($scope.device).then(
          function(data){
            $scope.saveProcessing = false;
            $scope.saveCloseProcessing = false;
            if(data.code == 12036){
              $scope.hasErr = true;
              $scope.errType = "lic";
              return;
            }
            if(step == 1){
              if(data.status == "success"){
                if(action == 'sc'){
                  if($state.current.name == "hub.dContainer.dName"){
                    localStorage.setItem("addedDeviceId", $scope.device.info.id);
                    $state.go("hub.devices.d");
                  }
                } else{
                  if((!$scope.device.info.frameLayout || $scope.device.info.frameLayout == null) && ($scope.auth.upermissions.fla || $scope.auth.upermissions.flae)){
                    if($state.current.name == "hub.dContainer.dName"){
                      $state.go("hub.dContainer.dFrameLayout", {
                        id:$scope.hubEncrypt(data.id)
                      });
                    }
                  } else if($scope.device.info.frameLayout || (!$scope.auth.upermissions.fla && !$scope.auth.upermissions.flae)){
                    if($state.current.name == "hub.dContainer.dName"){
                      $state.go("hub.dContainer.dTag", {
                        id:$scope.hubEncrypt(data.id)
                      });
                    }
                  }
                }
              } else{
                if(data.code == 12034){
                  $scope.hasErr = true;
                  $scope.errType = "idInvalid";
                } else if(data.code == 12020){
                  $scope.hasErr = true;
                  $scope.errType = $scope.device.info.regType == 's'?"siExists":"idExists";
                } else if(data.code == 12025){
                  $scope.hasErr = true;
                  $scope.errType = "name";
                } else if(data.code == 12095){
                  $scope.curData = data;
                  ngDialog.open({
                    template:'\
                      <section class="panel">\
                        <div class="panel-body">\
                          <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m14" | translate}}</span></div>\
                          <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                            <div class="row alt-row-bg padLR10">\
                              <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                                <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                              </div>\
                            </div>\
                          </div>\
                        </div>\
                        <div class="panel-footer">\
                          <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                        </div>\
                      </section>',
                    plain:true,
                    width:500,
                    scope:$scope,
                    data:$scope.curData,
                    closeByDocument:false,
                    className:"ngdialog-theme-default ngdialog-confirm"
                  });
                }
              }
            } else if(step == 2){
              if(data.status == "success"){
                if(action == 'sc'){
                  if($state.current.name == "hub.dContainer.dFrameLayout"){
                    $state.go("hub.devices.d");
                  }
                  localStorage.setItem("addedDeviceId", $scope.device.info.id);
                } else{
                  if($state.current.name == "hub.dContainer.dFrameLayout" || $state.current.name == "hub.dContainer.dName"){
                    $state.go("hub.dContainer.dTag", {id:$scope.hubEncrypt(data.id)});
                  } else{
                    $state.go("hub.dContainer.dTag", {id:$scope.hubEncrypt(data.id)});
                  }
                }
              } else if(data.code == 12020){
                $scope.hasErr = true;
                $scope.errType = "idExists";
              } else if(data.code == 12025){
                $scope.hasErr = true;
                $scope.errType = "name";
              }
            } else if(step == 3){
              if(data.code == 12040){
                $scope.errType = "deviceType";
                $scope.hasErr = true;
              } else if(data.code == 12020){
                $scope.errType = "idExists";
                $scope.hasErr = true;
              } else if(data.code == 12042){
                $scope.curData = data;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">{{"d.p_dg.m4" | translate}}</div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                      </div>\
                    </section>',
                  plain:true,
                  width:700,
                  scope:$scope,
                  data:$scope.curData,
                  closeByDocument:false,
                  className:"ngdialog-theme-default ngdialog-confirm"
                });
              } else if(data.code == 10046){
                $scope.errDataObj = data.data;
                ngDialog.open({
                  template:'\
                    <section class="panel">\
                      <header class="panel-heading"><h1>{{"s.p_s.body.6" | translate}}</h1></header>\
                      <div class="panel-body">\
                        <div class="msg-warning">{{"s.p_s.msg.55" | translate}}</div>\
                        <div class="table marT10">\
                          <div class="row th">\
                            <div class="col-xs-4">{{"cm.label.3" | translate}}</div>\
                            <div class="col-xs-4">{{"cm.label.4" | translate}}</div>\
                            <div class="col-xs-4">{{"as.btn.1" | translate}}</div>\
                          </div>\
                          <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(420)}}px">\
                            <div class="row" ng-repeat="list in errDataObj">\
                              <div class="col-xs-4">{{list.schedule.label}}</div>\
                              <div class="col-xs-4">{{list.device.label}}</div>\
                              <div class="col-xs-4">{{list.search.label}}</div>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <footer class="panel-footer">\
                        <span class="btnQuad">\
                          <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                        </span>\
                        <div class="clearfix"></div>\
                      </footer>\
                    </section>',
                  plain:true,
                  width:710,
                  scope:$scope,
                  closeByDocument:false
                });
              } else{
                if($state.current.name == "hub.dContainer.dTag"){
                  $state.go("hub.devices.d");
                  localStorage.setItem("addedDeviceId", $scope.device.info.id);
                }
              }
            }
          },
          function(err){
            $scope.saveProcessing = false;
            $scope.saveCloseProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.changeDeviceType = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.saveProcessing = false;
      $scope.eslNotAuth = false;
      $scope.saveCloseProcessing = false;
      if($scope.device.info.dType == "gf" || $scope.device.info.dType == "v"){
        $scope.device.info.mac = $scope.generateUUID();
        $scope.loadMap();
      } else{
        // $scope.device.info.mac = "";
        // $scope.device.info.eslInfo = "";
        if($scope.device.info.dType == "epd"){
          $scope.storeErr = false;
          $scope.modelsLoading = true;
          DevicesCUSrv.getModels().then(
            function(data){
              if(data.code == 12089){
                $scope.hasErr = true;
                $scope.eslNotAuth = true;
                $scope.errType = "eslAuth";
              }
              $scope.epdModels = data.models;
              $scope.modelsLoading = false;

              // Group by model
              $scope.epdGrouped = $scope.epdModels.reduce(function(result, epd){
                if(!result[epd.model]){
                  result[epd.model] = [];
                }
                result[epd.model].push(epd);
                return result;
              }, {});
            },
            function(err){
              $scope.modelsLoading = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.generateUUID = function(){
      var d = new Date().getTime();
      if(window.performance && typeof window.performance.now === "function"){
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c){
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r :(r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    }

    //select all assign & available tags
    $rootScope.tAList = [];
    $rootScope.tSList = [];
    $scope.tags.available = [];
    $scope.tags.assigned = [];
    $rootScope.selAllTagFx = function(caller, tagList){
      tagList.forEach(function(item){
        item.selected = true;
      });
      if(caller == "a"){
        if($scope.tags.assigned.length){
          $scope.tags = { available:angular.copy(tagList), assigned:$scope.tags.assigned };
          $rootScope.tSList = $scope.tags.assigned;
        } else{
          $rootScope.tSList = [];
          $scope.tags = { available:angular.copy(tagList), assigned:[] };
        }
        $rootScope.tAList = $scope.tags.available;
      } else{
        if($scope.tags.available.length){
          $scope.tags = { available:$scope.tags.available, assigned:angular.copy(tagList) };
          $rootScope.tAList = $scope.tags.available;
        } else{
          $rootScope.tAList = [];
          $scope.tags = { available:[], assigned:angular.copy(tagList) };
        }
        $rootScope.tSList = $scope.tags.assigned;
      }
    }
    //select/deselect single assign & available tags
    $scope.selTagFx = function(caller, selectedItems, tagList){
      angular.forEach(tagList, function(item){
        if(item.id == selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.tAList.push(item);
            } else{
              angular.forEach($rootScope.tAList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.tAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.tSList.push(item);
            } else{
              angular.forEach($rootScope.tSList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.tSList.splice(i, 1);
                }
              });
            }
          }
          $scope.tags = { available:$rootScope.tAList, assigned:$rootScope.tSList };
        }
      });
    }
    //deselect all assign & available tags
    $scope.deSelAllTagFx = function(caller, tagList){
      angular.forEach(tagList, function(item){
        item.selected = false;
      })
      if(caller == "a"){
        $rootScope.dAList = [];
        $scope.tags.available = [];
      } else{
        $rootScope.dSList = [];
        $scope.tags.assigned = [];
      }
    }

    //Reset selected devices, groups and tag list
    $rootScope.resetT = function(caller){
      $rootScope.tAList = [];
      $rootScope.tSList = [];
      if(caller == "add" && $scope.tags.assigned.length){
        $scope.tags = {available:[], assigned:$scope.tags.assigned};
      } else if(caller == "remove" && $scope.tags.available.length){
        $scope.tags = {available:$scope.tags.available, assigned:[]};
      } else{
        $scope.tags = {available:[], assigned:[]};
      }
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      // console.warn("edit adv");
      $rootScope.selectedItems = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchTextFl = {val:""};
      $scope.searchText = "";
      $scope.search = {text:""};
      $scope.advSearchInfo = args.info;
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.folder = [];
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      if(args.content){
        $scope.curArgsContent = [];
        angular.forEach(args.content, function(item){
          if(item.type == "Image" || item.type == "WORD" || item.type == "Vector"){
            $scope.curArgsContent.push(item);
          }
        });
        $scope.contentList = $scope.curArgsContent;
      }
      if(!$scope.contentList.length && !$scope.folderList.length){
        $scope.advSearchInfo.isEmpty = true;
      }
      $scope.contentLibrary.contentLibrary.content = $scope.contentList;

      $scope.advSearch = true;
      if(args.code == 8118){
        $scope.contentLibraryLoading = true;
        $scope.contentLoading = true;
        if($scope.flId){
          ContentLibrarySrv.getFolderApprovedContent($scope.flId).then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        } else{
          ContentLibrarySrv.getApproved().then(
            function(data){
              $scope.contentLibrary = data;
              $scope.advSearch = false;
              $scope.updateList();
            },
            function(err){
              $scope.contentLibraryLoading = false;
              $log.error(err);
            }
          );
        }
      }
    });

    $scope.clearDateFx = function(obj){
      obj.isblank = true;
    }
    $scope.selectDateFx =  function(obj){
      obj.isblank = false;
    }
    // $scope.selectTimeFx =  function(obj){
    //   obj.time = moment().format();
    // }

    $scope.loadingInfo = false;
    $scope.refreshOInfoFx = function(){
      $scope.loadingInfo = true;
      $scope.searchDOInfo.text = "";
      DevicesCUSrv.getDevicesDetails($scope.decId, 'oi').then(
        function(data){
          $scope.loadingInfo = false;
          $scope.device.info.info = data.info.info;
          $scope.device.info.otherinfo = data.info.otherinfo;

          $scope.tim = $scope.device.info.otherinfo.timthumb;
          $scope.cBucket = $scope.cDetailBucket = $scope.device.info.otherinfo.bucket;
          if(!$scope.device.info.info || $scope.device.info.info == null || $scope.device.info.info.length == 0){
            $scope.device.info.info = [{ label:"", value:"", vType:"t", isEditable:true }];
          }
          if($scope.device.info.otherinfo.mbucket && $scope.device.info.otherinfo.mbucket != ""){
            $scope.cDetailBucket = $scope.device.info.otherinfo.mbucket;
          }

          if($scope.device.info.info.length){
            $scope.device.info.info.forEach(function(item,i){
              item.id = i+1;
              if(item.vType == "dt"){
                item.time = $scope.formatTime(item.value);
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    /*Device control*/
    $scope.deviceControlOpen = function(id, label, dType, os, wosis){
      $scope.webOSisActive = wosis;
      $scope.curDeviceControl = {id:id, label:label, dType:dType, os:os};
      ngDialog.open({
        template:'app/devices/popup/deviceControl.html',
        width:850,
        data:$scope.curDeviceControl,
        scope:$scope,
        controller:'DeviceControlController',
        closeByDocument:false,
        preCloseCallback:function(){
          $rootScope.checkReboot = false;
        }
      });
    }

    // * scroll list data code START 2nd phase pagination
    $scope.haveMoreData = false;
    $scope.haveMoreSearchData = false;
    $scope.visibleData = [];
    $scope.stIndex = 0
    $scope.etIndex = 300;
    $scope.searchScroll = false;

    // TODO load next data
    $scope.$on('loadNextData', function(e, obj){
      $scope.copyScrollObj = angular.copy($scope.scrollObj);

      $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: $scope.scrollDataList.length, id: $scope.copyScrollObj.id}
      if($scope.searchScroll){
        $scope.scrollObj.searchQ = obj.text;
        FrameLayoutsSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData = false;
            }
            $scope.allScrollDataList = [];
            $scope.scrollDataList = $scope.scrollDataList.concat(data.d);
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollData', function(e, obj){
      $scope.stIndex = 0
      $scope.etIndex = 300;
      $scope.copyScrollObj = angular.copy($scope.scrollObj);
      $scope.scrollDataList = [];
      if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
        $scope.loading = false;
        $scope.refreshObj = {l:true, b:false};
        $scope.marginLoad = true;
        $scope.marRemove = false;
      }
      if(obj.text){
        $scope.searchScroll = true;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id, searchQ: obj.text}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getSearchScrollData($scope.scrollObj).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData = true;
            } else{
              $scope.haveMoreSearchData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });

            if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData = false;
        $scope.searchScroll = false;
        $scope.scrollObj = {caller: $scope.copyScrollObj.caller, offset: 0, id: $scope.copyScrollObj.id}
        if($scope.copyScrollObj.fil){
          $scope.scrollObj.fil = $scope.copyScrollObj.fil;
        }
        $scope.copyScrollObj = angular.copy($scope.scrollObj);
        DevicesSrv.getScrollListData($scope.scrollObj).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData = true;
            } else{
              $scope.haveMoreData = false;
            }
            $scope.scrollDataList = data.d;
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
            $scope.allScrollDataList = [];
            $scope.allScrollDataList =  angular.copy($scope.scrollDataList);

            if($scope.copyScrollObj.caller == "fl" || $scope.copyScrollObj.caller == "fla"){
              $scope.marginLoad = false;
              $scope.marRemove = false;
              $scope.refreshObj = {l:false, b:true};
            }
            setTimeout(function(){
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleData', function(e, obj){
      // console.warn("visibleData",obj);
      $scope.stIndex = obj.st;
      $scope.etIndex = obj.et;
      $scope.visibleData = obj.vObj;
      $scope.addStatusKey($scope.visibleData, $scope.auth.upreferences.dot);
      setTimeout(function(){
        $scope.$apply();
      }, 0);
    });

    $scope.searchChangeData = function(val){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container");
      if (!text && $scope.searchScroll) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex = 0
        $scope.etIndex = 300;
        $scope.visibleObjects = $scope.allScrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        $rootScope.$broadcast('searchScrollData', { text: '', st: $scope.stIndex, et: $scope.etIndex });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList, function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);

          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData = true;
          } else{
            $scope.haveMoreSearchData = false;
          }
          $scope.scrollDataList = filteredObj;
          $scope.stIndex = 0;
          $scope.etIndex = 300;
          if ($scope.scrollDataList.length <= 300) {
            $scope.visibleObjects = $scope.scrollDataList;
          } else {
            $scope.visibleObjects = $scope.scrollDataList.slice($scope.stIndex, $scope.stIndex + $scope.etIndex);
          }
          $scope.searchScroll = true;
          $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.stIndex, et: $scope.etIndex });
        } else {
          $scope.stIndex = 0;
          $scope.etIndex = $scope.itemsPerPage;
          $rootScope.$broadcast('searchScrollData', { text: text, st: $scope.stIndex, et: $scope.etIndex });
        }
      }
    }

    // * scroll list data code END 2nd phase pagination

  };
})();

angular.module('hub').service('CPLoginSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.authenticate = function(credentials){
    httpReq = $http.post($rootScope.apiHost + "auth/login", credentials);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
angular.module('hub').service('CPDashboardSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getPath = function(path){
    httpReq = $http.get($rootScope.apiHost + path);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.postPath = function(path, data){
    httpReq = $http.post("http://54.187.247.85/hub/api/v0/" + path, data);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CPLoginController', CPLoginController);

  /** @ngInject */
  function CPLoginController($log, $scope, $http, $state, $cookies, CPLoginSrv){
    $scope.authProcessing = false;
    $scope.credentials = {};
    $scope.authServer = [];
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.auth = [];

    $scope.authenticate = function(){
      $scope.authProcessing = true;
      $scope.hasErr = false;
      if(!$scope.credentials.email || $scope.credentials.email == "" || !$scope.credentials.pass || $scope.credentials.pass == ""){
        $scope.authProcessing = false;
        $scope.errType = "form";
        $scope.hasErr = true;
      } else{
        LoginSrv.authenticate($scope.credentials).then(
          function(data){
            $scope.authProcessing = false;
            if(data.code && data.code == 11800){
              $scope.errType = "auth";
              $scope.hasErr = true;
            } else{
              $http.defaults.headers.common.Authorization = data.info.token;
              $scope.authServer = data.servers;
              $scope.auth = data.info;
              localStorage.setItem('authServer', JSON.stringify($scope.authServer));
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              
              if($scope.authServer.length > 1){
                $state.go('selectServer');
              } else{
                $state.go('hub.dashboard');
              }
            }
          },
          function(err){
            $scope.authProcessing = false;
            $scope.errType = "api";
            $scope.hasErr = true;
          }
        );
      }
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CPDashboardController', CPDashboardController);

  /** @ngInject */
  function CPDashboardController($log, $scope, $http, $cookies, CPDashboardSrv){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
    $http.defaults.headers.common['via']= 'via';
    $http.defaults.headers.common.Authorization = $scope.auth.token;
    $http.defaults.headers.common.via = "cp";
    $scope.apiPath="";

    $scope.apiFx = function(){
      $scope.authProcessing = true;
      // Simple GET request example:
      $http({
        method:'GET',
        url:'http://54.187.247.85/hub/api/v0/'+$scope.apiPath
      })
      .then(function successCallback(response){
        $scope.apiResponse = response;
        // this callback will be called asynchronously
        // when the response is available
      }, function errorCallback(response){
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });

    }
    $scope.apiPostFx = function(){
      CPDashboardSrv.postPath($scope.apiPostPath, $scope.apiPostData).then(
        function(data){
          $scope.apiPostResponse = data;
        },
        function(err){
          $scope.errType = "api";
        }
      );
    }
  }
})();
angular.module('hub').service('CLTPSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  /*Get list*/
  this.getTupList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Auth*/
  this.getDBAuth = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/dropbox/auth");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFBAuth = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/fb/auth");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.postFtpAuth = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/access/ftp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGDAuth = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/gdrive/auth");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIGAuth = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/instagram/auth");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get*/
  this.getDB = function(fId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/dropbox?q="+ fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFB = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/fb");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGD = function(fId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/gdrive?q="+ fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getIG = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/instagram");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTW = function(obj){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/twitter/"+ obj.twitter +"?type="+ obj.dType);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getVerify = function(caller){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/verify/" + caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getLogout = function(caller){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/thirdparty/logout/" + caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Post*/
  this.saveDB = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/dropbox", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFB = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/fb", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveFtp = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/ftp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveGD = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/gdrive", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveIG = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/instagram", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveTW = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/twitter", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveUrl = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/thirdparty/url", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentLibraryWidgetsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getAll = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    return (response.data);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('ContentLibrarySrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  //type is added for get shortcut folder details
  this.getAll = function(fId, caller, type){
    if(!JSON.parse(fId)){
      fId = 0;
    }
    if(!caller){
      if(type=="shortcut"){
        httpReq = $http.get($rootScope.apiHost + "contentLibrary/" + fId + "?splType=" + type + "&" + new Date().getTime());
      } else {
        httpReq = $http.get($rootScope.apiHost + "contentLibrary/" + fId + "?" + new Date().getTime());
      }
    } else{
      if(type=="shortcut"){
        httpReq = $http.get($rootScope.apiHost + "contentLibrary/" + fId + "?" +caller+"="+1+"&splType=" + type + "&" + new Date().getTime());
      } else {
        httpReq = $http.get($rootScope.apiHost + "contentLibrary/" + fId + "?" +caller+"="+1+"&"+ new Date().getTime());
      }
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAllSPL = function(fId, splId, splType){
    if(!fId){
      fId = 0;
    }
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/" + fId + "?splId=" + splId + "&splType=" + splType);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getApproved = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderApprovedContent = function(fId, splId, splType){
    if(splId === undefined || splId === ""){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?" + new Date().getTime());
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/approved/" + fId + "?splId=" + splId + "&splType=" + splType + "&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUnapproved = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/unapproved?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getArchived = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/archived?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExpired = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/expired?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeleted = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/deleted?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTree = function(id, path){
    if(path){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folderTree/" + id +"?path=1&"+ new Date().getTime());
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folderTree/" + id +"?"+ new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatefavoritefolders = function(obj){
      httpReq = $http.post($rootScope.apiHost + "contentLibrary/favoritefolders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMoveTree = function(fId){
    if(fId === undefined){
      fId = 0;
    }
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/moveTree" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getServersList = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/serversList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInfo = function(id, langId){
    if(langId){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/editor/" + id + "?langId=" + langId);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/editor/" + id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getContentList = function(fId, splId, splType){
    if(splId === undefined || splId === ""){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/contentList/" + fId + "?" + new Date().getTime());
    }
    else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/contentList/" + fId + "?splId=" + splId + "&splType=" + splType + "&" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.briefContentList = function(wId,wName){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/briefContentList/" + wName + "/" + wId + "?" + new Date().getTime());
    // httpReq = $http.get($rootScope.apiHost + "contentLibrary/codContentList/" + wId + "?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getScheduleList = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/scheduleList/" + id + "?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getMetaTag = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/metatags/" + id + "?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateMT = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/metatags", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteMT = function(obj){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/metatags?id=" + obj.id + "&tag=" + encodeURIComponent(obj.tag));
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVersions = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/versions/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateVersions = function(obj){
    httpReq = $http.put($rootScope.apiHost + "contentLibrary/versions", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVideoLoad = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/content/state/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.reprocessVideo = function(id, optimize){
    if(optimize){
      httpReq = $http.patch($rootScope.apiHost + "contentLibrary/optimizeVideo/" + id + "/" + optimize);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/content/reprocess/" + id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateCaptions = function(obj){
    httpReq = $http.patch($rootScope.apiHost + "contentLibrary/captions", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getProcessStatus = function(ids){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/content/processStatus/"+ ids);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateProcessStatus = function(ids){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/content/processStatus", ids);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.sendUnapproveNotification = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/content/notifications", obj.id, obj.isApproved);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteContent = function(obj){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/", {
      "params":obj
    });
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.restoreContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/restore", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.approveContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/approve", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.unapproveContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/unapprove", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.removeExpiry= function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/removeExpiry", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.folderCU = function(obj){ //Folder create and update
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/folders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.sharedFolder = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/folderTree/0?serverid="+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*SP*/
  this.getSpUrl = function(id, caller){
    if(caller == "ssp"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/ssp?ssp=true");
    } else if(id){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/" + id);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSpSites = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/sites");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSpLibraries = function(id, caller){
    if(caller && caller == "ssp"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/libraries/"+ id +"?ssp=true");
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/libraries/"+ id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getSpFolder = function(sId, lId, caller){
    if(caller && caller == "ssp"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/folders/"+ sId +"/"+ lId +"?ssp=true");
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/folders/"+ sId +"/"+ lId);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.spFolder = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/folders/sharepoint/folders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*OD*/
  this.getOdUrl = function(id){
    if(id){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive/"+ id);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  //OD and SP re auth url
  this.getOdSpUrl = function(caller, fId){
    if(caller == "od"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive?isReAuth=1&fid="+ fId);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint?isReAuth=1&fid="+ fId);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  //OD folders child
  this.getOdFolderChild = function(dId, fId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive/folders/"+dId+"/"+fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  //SP folders child
  this.getSpFolderChild = function(siteId, libId, fId, caller){
    if(caller && caller == "ssp"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/folders/"+siteId+"/"+libId+"/"+fId+"?ssp=true");
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/folders/"+siteId+"/"+libId+"/"+fId);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Google Drive*/
  this.getGdUrl = function(caller){
    httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/login");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGdFolder = function(caller, dId){
    httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders?callFrom=onlyfolders&drive_id="+ dId);
    // if(caller == "oauth"){
    //   httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders?callFrom=onlyfolders&drive_id="+ dId);
    // } else{
    //   httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders?callFrom=onlyfolders");
    // }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGdSubfolder = function(caller, fId, dId){
    httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders/"+ fId +"?callFrom=onlyfolders&drive_id="+ dId);
    // if(caller == "oauth"){
    //   httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders/"+ fId +"?callFrom=onlyfolders&drive_id="+ dId);
    // } else{
    //   httpReq = $http.get($rootScope.apiHost +"googledrive/"+ caller +"/folders/"+ fId +"?callFrom=onlyfolders");
    // }
    return httpReq.then(this.handleSuccess, this.handleError);
  }


  this.clearSession = function(caller){
    if(caller == "sp"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/sharepoint/clearsession");
    } else if(caller == "gd"){ /*Google Drive*/
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/googledrive/clearsession");
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive/clearsession");
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerify = function(){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/oneDrive/folders");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVerifyTemp = function(tId){
    httpReq = $http.get($rootScope.apiHost + "templates/oneDrive/folders/"+tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateShortcut= function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/folders/shortcut", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.move = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/move", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.copy = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/copy", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*ToolBar*/
  this.setDisplaySize = function(size){
    httpReq = $http.put($rootScope.apiHost + "contentlibrary/displaySize", size);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Get Brief*/
  this.getFolderBrief = function(fId, splId, splType){
    if(splType == "folder"){
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/briefs/" + fId);
    } else{
      httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/briefs/" + fId + "?splId=" + splId + "&splType=" + splType);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getContentBrief = function(contentId, isIncompleteVideo){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/content/briefs/" + contentId + "/" + isIncompleteVideo);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAcknowledgment = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/alertmsg/"+ id +"?report=true");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFolderDetails = function(fId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/folders/details/" + fId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getContentDetails = function(contentId){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/content/details/" + contentId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateContentEdit = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/content", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*ngSwitch*/
  this.writeProtected = function(id){
    httpReq = $http.patch($rootScope.apiHost + "contentLibrary/writeProtected/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Button*/
  this.getContentBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getApproveBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/approve", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUnapproveBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/unapprove", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getExprieBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/expire", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getArchiveBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/archive", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeleteBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/delete", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Image Editer*/
  this.updateImage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/editor", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Video Editer*/
  this.updateVideo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/editor", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCaptionsLang = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/captions/lang/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.importCaptions = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/captions/import", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.generateCaptions = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/captions", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveLanguage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/captions/lang", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.delLanguage = function(id){
    httpReq = $http.delete($rootScope.apiHost + "contentLibrary/captions/lang/"+id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addCue = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/cues", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Instagram Prev*/
  this.getInstaPrev = function(id){
    httpReq = $http.get($rootScope.apiHost + "feed/instagram/basicdisplay/"+id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getActiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/scheduleList/" + id +"/a");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInactiveSchedule = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/scheduleList/" + id +"/i");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.f45JsonView = function(id){
    httpReq = $http.get($rootScope.apiHost + "contentLibrary/widgets/f45/playbook/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.streamMetrics = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentlibrary/widgets/liveStreaming/hlslogs", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.showToAdmin = function(id){
    httpReq = $http.patch($rootScope.apiHost + "contentLibrary/folders/shortcut/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.pinContent = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/pin", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getCLActionBtn = function(status, id){
    httpReq = $http.post($rootScope.apiHost + "action/contentLibrary/"+status+"?pin=1", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.aiPreview = function(obj){
    // httpReq = $http.post($rootScope.apiHost + "contentLibrary/move", obj);
    httpReq = $http.post($rootScope.apiHost + "generateImage", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAIImage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "publishimage", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.checkUserPass = function(pass){
    httpReq = $http.get($rootScope.apiHost + "checkuser?pass="+ pass);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getFilePages = function(obj){
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/content/pages", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getVIndexer = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/upload", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStatusVIndexer = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/process/status", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getStatusStripImg = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/download/strip", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVideoInsight = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/view", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getVindexerLang = function(vid){
    httpReq = $http.get($rootScope.apiHost + "videoIndexer/view/languages/"+vid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.addLanguage = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/view/addlang", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateCaptions = function(obj){
    httpReq = $http.post($rootScope.apiHost + "videoIndexer/view/cc", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);

angular
.module('hub').directive('ngTemplateListing', function(){
  return {
    restrict:'E',
    templateUrl:'app/contentLibrary/dir/templateListing.html'
  }
});
angular
  .module('hub').directive('ngContentListView', function(){
    return {
      restrict:'EA',
      // scope:{
      //   isSorting:'='
      // },
      templateUrl:'app/contentLibrary/dir/contentListView.html'
    }
  });
angular
  .module('hub').directive('ngContentList', function(){
    return {
      restrict:'E',
      templateUrl:'app/contentLibrary/dir/contentList.html'
    }
  });
angular
  .module('hub').directive('ngContentBrief', function(){
    return {
      restrict:'E',
      templateUrl:'app/contentLibrary/dir/contentBrief.html'
    }
  });
(function(){
  'use strict';
  
  angular
    .module('hub')
    .controller('VideoAIIndexerController', VideoAIIndexerController);

  /** @ngInject */
  function VideoAIIndexerController($log, $rootScope, $scope, $state, $cookies, $timeout, $window, $filter, ngDialog, FileModelUploadSrv, ContentLibrarySrv){
    $rootScope.selectedMenu = 1; //For LeftPanel Menu selected
    $scope.selectedT = '1';
    $scope.detailLoading = true;
    $scope.loadInsights = false;
    $scope.loadSupportLang = true;
    localStorage.setItem("curFId", localStorage.getItem("inFolder"));
    $scope.insightsData = [];
    $scope.langSupport = [];
    $scope.curData = {};
    $scope.searchText = {txt:""};
    $scope.selectedLang = {}
    $scope.readyToReIndex = true;
    $scope.ccEdit = false;
    $scope.editMore = false;
    $scope.editMoreId = 0;    
    $scope.previousCC = {};
    $scope.ccAddObj = {start:"00:00:00.00", end:"00:00:00.00", text:""};
    $scope.lang = {isOpen:false};
    $scope.timestamp = moment().format('x');
    $scope.previousState = localStorage.getItem("preState");
    $scope.loadingCaption = false;


    $scope.timeToSeconds = function(time) {
      var timeParts = time.split(":");
      var hours = timeParts[0];
      var minutes = timeParts[1];
      var secondsAndMilliseconds = timeParts[2] || ""; // Handle cases where seconds might not exist
      var secondsParts = secondsAndMilliseconds.split(".");
      var wholeSeconds = secondsParts[0];
      var milliseconds = secondsParts[1] || 0; // Default to 0 if milliseconds are not provided

      return (
        parseInt(hours) * 3600 +
        parseInt(minutes) * 60 +
        parseInt(wholeSeconds) +
        parseFloat(0 + '.' + milliseconds)
      );
    }    

    $scope.getInstancesFx = function(caller, obj, change){
      if(typeof obj === 'object'){
        if(change && (caller == 'namedLocations' || caller == 'namedPeople' || caller == 'brands')){
          caller = 'nEntities';
        }
        if(caller == 'detectedObjects'){
          if(change){            
            $scope.curData.selDetectedObjects = obj            
            var time = $scope.timeToSeconds(obj.instances[0].start);
            $scope.video.currentTime = time;
          }else{
            $scope.curData.selDetectedObjects = obj.thumbArr[0];
            $scope.curData[caller] = obj;
            // Process instances to calculate width and offset
            angular.forEach($scope.curData[caller].thumbArr, function(data){
              if(change){
                var time = $scope.timeToSeconds(data.instances[0].start);
                $scope.video.currentTime = time;
              }
              data.instances.forEach(function(instance){
                var total = $scope.timeToSeconds($scope.insightsData.insight.duration);
                var startInSeconds = $scope.timeToSeconds(instance.start);
                var endInSeconds = $scope.timeToSeconds(instance.end);
        
                var durationInSeconds = endInSeconds - startInSeconds;
                instance.left = (startInSeconds / total) * 100;
                var widthValue = (durationInSeconds / total) * 100;
                instance.width = widthValue + 0.5;
              });
            })
          }
        } else{
          $scope.curData[caller] = obj;
          // Process instances to calculate width and offset
          if(change){
            var time = $scope.timeToSeconds($scope.curData[caller].instances[0].start);
            $scope.video.currentTime = time;
          }
          $scope.curData[caller].instances.forEach(function(instance){
            var total = $scope.timeToSeconds($scope.insightsData.insight.duration);
            var startInSeconds = $scope.timeToSeconds(instance.start);
            var endInSeconds = $scope.timeToSeconds(instance.end);
    
            var durationInSeconds = endInSeconds - startInSeconds;
            instance.left = (startInSeconds / total) * 100;
            var widthValue = (durationInSeconds / total) * 100;
            instance.width = widthValue + 0.5;
          });
        }
      }
    }

    $scope.highlight = function(stime){
      if($scope.selectedT == '2'){
        $(".closedCaptionList").each(function(index){
          if($(this).attr("data-sTime") == stime){            
            $(".closedCaptionList").removeClass("highlightCaption");
            $(this).addClass("highlightCaption");          

            // Scroll the container to the highlighted element
            var container = $("#captionContainer");
            var highlighted = $(this);

            if (container.length && highlighted.length) {
              container.animate({
                scrollTop: highlighted.offset().top - container.offset().top + container.scrollTop()
              }, 300); // Smooth scrolling animation
            }
          }
        });
      }
    }  

    $scope.findNearestIndex = function(array, key, targetValue) {
      var nearestIndex = 0;
      var smallestDifference = Infinity;
    
      array.forEach(function (obj, index) {
        var difference = Math.abs($scope.timeToSeconds(obj[key]) - targetValue);
        if (difference < smallestDifference) {
          smallestDifference = difference;
          nearestIndex = index;
        }
      });
    
      return nearestIndex;
    }
    
    $scope.updateVideoTrack = function(text){
      setTimeout(function(){
        var videoElement = document.getElementById('videoElement');
        var trackElement = videoElement.querySelector('track');
        if (trackElement) {
          trackElement.remove(); // Remove old track
        }
        var newTrack = document.createElement('track');
        newTrack.kind = 'subtitles';
        newTrack.label = 'On'
        newTrack.srclang = 'en';
        newTrack.src = $scope.insightsData.bucket + $scope.insightsData.vtt; // Update track source
        // TODO remove timestamp from vtt file
        // newTrack.src = $scope.insightsData.bucket + $scope.insightsData.vtt + '?' + moment().format('x'); // Update track source
        newTrack.default = true;
        videoElement.appendChild(newTrack);
        videoElement.load(); // Reload video to apply new track
      }, 100)
    }

    $scope.updateElmVid = function(){
      $scope.video = document.getElementById("videoElement");
      $scope.progressBar = document.querySelectorAll(".progressBar");
      $scope.timeline = document.querySelector(".video-timeline");
      $scope.tooltip = document.querySelectorAll(".viTooltip");
      $scope.tracks = $scope.video.textTracks[0];
      $scope.tracks.mode = "showing";
      // Update progress bar as video plays
      $scope.video.addEventListener("canplay", function() {
        console.log("video is ready");
        // $scope.totalDuration = $scope.video.duration;
      });
      $scope.video.addEventListener("timeupdate", function() {
        angular.forEach($scope.curData, function(data, key){
          if(key == "selDetectedObjects" || key == "observedPeople" || key == "topics" || key == "keywords" || key == "labels" || key == "nEntities" || key == "emotions" || key == "sentiments"){
            var instancesLength = data.instances.length - 1;
            var indexObj = $scope.findNearestIndex(data.instances, 'start', $scope.video.currentTime);
            var timeStObj = $scope.timeToSeconds(data.instances[indexObj].start);
            if(data.instances.length == 1){
              if($scope.video.currentTime < timeStObj){
                data.prv = 0;
                data.nxt = 1;
              } else if($scope.video.currentTime == timeStObj){
                data.prv = 0;
                data.nxt = 0;
              } else if($scope.video.currentTime > timeStObj){
                data.prv = 1;
                data.nxt = 0;
              }
            } else{
              if(indexObj == 0){
               if($scope.video.currentTime < timeStObj){
                data.prv = 0;
                data.nxt = 1;
               } else if($scope.video.currentTime == timeStObj){
                data.prv = 0;
                data.nxt = 1;
               } else if($scope.video.currentTime > timeStObj){
                data.prv = 1;
                data.nxt = 1;
               } 
              }
              if(indexObj == instancesLength){
               if($scope.video.currentTime < timeStObj){
                data.prv = 1;
                data.nxt = 1;
               } else if($scope.video.currentTime == timeStObj){
                data.prv = 1;
                data.nxt = 0;
               } else if($scope.video.currentTime > timeStObj){
                data.prv = 1;
                data.nxt = 0;
               } 
              }
              if(indexObj != 0 && indexObj != instancesLength){
                data.prv = 1;
                data.nxt = 1;
              }
            }
            $scope.$apply();
          }
        })
        var progress = ($scope.video.currentTime / $scope.video.duration) * 100;
        $scope.progressBar.forEach(function(element) {
          element.style.width = progress + "%";
        })
      });
      if($scope.tracks.mode == "showing"){
        $scope.tracks.addEventListener("cuechange", function (obj) {
          var activeCues = $scope.tracks.activeCues; // Get active captions
          if (activeCues.length > 0) {
            $scope.highlight(activeCues[0].startTime)
          }
        });      
      }
    }

    $scope.getUniqueArray = function (arr, caller) {
      var uniqueArray = [];
      var seenType = {}; // Use an object to track unique Type
    
      angular.forEach(arr, function (obj) {
        if (!seenType[obj.type]) {
          seenType[obj.type] = true; // Mark the type as seen
          var thumbArr = [];
          thumbArr.push({thumbnailId: obj.thumbnailId,instances: obj.instances, pc: obj.pc})
          uniqueArray.push({
            type: obj.type,
            displayName: obj.type,
            thumbArr: thumbArr
          });
        } else{
          angular.forEach(uniqueArray, function(value){
            if(value.type === obj.type){
              value.thumbArr.push({ thumbnailId: obj.thumbnailId, instances: obj.instances });
            }
          })
        }
      });
    
      return uniqueArray;
    };

    $scope.timeDifference = function(timestamp) {
      var givenTime = new Date(timestamp).getTime(); // Convert timestamp to milliseconds
      var currentTime = new Date().getTime(); // Get current time in milliseconds
      var difference = (currentTime - givenTime) / (1000 * 60); // Convert difference to minutes
      // if(difference > 30){
      //   $scope.readyToReIndex = true;
      // }
      // if($scope.readyToReIndex){
      //   clearInterval($scope.getTimeDiffer)
      // }
      // return difference > 30;
      // $scope.getTimeDiffer = null;
      // clearInterval($scope.getTimeDiffer)
      // $scope.getTimeDiffer = setInterval(function(){
      //   var givenTime = new Date(timestamp).getTime(); // Convert timestamp to milliseconds
      //   var currentTime = new Date().getTime(); // Get current time in milliseconds
      //   var difference = (currentTime - givenTime) / (1000 * 60); // Convert difference to minutes
      //   if(difference > 30){
      //     $scope.readyToReIndex = true;
      //   }
      //   if($scope.readyToReIndex){
      //     clearInterval($scope.getTimeDiffer)
      //   }
      //   return difference > 30;
      // }, 300000)
    }

    $scope.langJsonUpdate = function(arr, type){
      $scope.addedLang = arr.filter(function(obj){
        if(obj.isAdded == true){
          return obj;
        }
      });
      $scope.notAddedLang = arr.filter(function(obj){
        if(obj.isAdded == false){
          return obj;
        }
      });
      if(type && $scope.insightsData.hasTranscript && $scope.insightsData.insight.transcript.length){
        angular.forEach(arr, function(obj){
          if(obj.languageCode == type){
            $scope.selectedLang = obj;
            return;
          }
        })
      } else{
        $scope.selectedLang = {};
      }
    }

    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id)
      $scope.contentId = $scope.decId.split('||')[0];
      $scope.videoId = $scope.decId.split('||')[1];
      ContentLibrarySrv.getVideoInsight({id:$scope.contentId,vId:$scope.videoId}).then(
        function(data){
          var timestamp = data.cOn * 1000;
          $scope.timeDifference(timestamp)
          if(data.insight.detectedObjects && data.insight.detectedObjects.length){
            var detectedObjects = angular.copy(data.insight.detectedObjects);
            data.insight.detectedObjects = [];
            data.insight.detectedObjects = $scope.getUniqueArray(detectedObjects);
          }
          $scope.insightsData = data;
          $scope.insightsData.id = $scope.contentId;
          if((data.insight.namedLocations && data.insight.namedLocations.length) || (data.insight.namedPeople && data.insight.namedPeople.length) || (data.insight.brands && data.insight.brands.length)){
            if(data.insight.namedLocations && data.insight.namedLocations.length){
              $scope.curData.nEntities = data.insight.namedLocations[0];
            } else if(data.insight.namedPeople && data.insight.namedPeople.length){
              $scope.curData.nEntities = data.insight.namedPeople[0];
            } else if(data.insight.brands && data.insight.brands.length){
              $scope.curData.nEntities = data.insight.brands[0];
            }
          }
          angular.forEach(data.insight, function(value, index){
            if(typeof value === 'object' && value.length && index != 'textualContentModeration' && index != 'transcript'){
              if(index == 'emotions' || index == 'sentiments' && index != 'scenes' && index != 'detectedObjects'){
                var totalLength = angular.copy(value.length);
                var count = 0;
                var tempData = {type:[], instances:[]}
                angular.forEach(value, function(obj){
                  count++;
                  if(index == 'emotions'){
                    tempData.type.push({id: obj.id, name:obj.type, pc: obj.pc});
                  }
                  if(index == 'sentiments'){
                    tempData.type.push({id: obj.id, name:obj.sentimentType, pc: obj.pc});
                  }
                  angular.forEach(obj.instances,function(instance){
                    instance.type = (index == 'emotions') ? obj.type : obj.sentimentType;
                    tempData.instances.push(instance);
                  });
                  if(totalLength === count){
                    $scope.insightsData.insight[index] = [];
                    $scope.insightsData.insight[index] = tempData;
                  }
                });
                $scope.getInstancesFx(index, tempData, false)
              } else{
                if(index == 'scenes'){
                  $scope.curData.scenes = value[0];
                  if(value[0].shots.length){
                    $scope.curData.shots = value[0].shots;
                    if(value[0].shots[0].keyFrames.length){
                      $scope.curData.keyFrames = value[0].shots[0].keyFrames
                    }
                  }
                // }else if(index == 'detectedObjects'){
                //   $scope.getInstancesFx(index, value[0], false);
                }else{
                  $scope.getInstancesFx(index, value[0], false);
                }
              }
            }
          });
          $scope.detailLoading = false;
          setTimeout(function(){
            $scope.updateElmVid();
          }, 100)
        },
        function(err){
          $scope.detailLoading = false;
          $log.error(err);
        }
      );
      ContentLibrarySrv.getVindexerLang($scope.videoId).then(
        function(data){
          $scope.loadSupportLang = false;
          $scope.langSupport = data;
          $scope.langJsonUpdate($scope.langSupport, "en-US");
        },
        function(err){
          $scope.loadSupportLang = false;
          $log.error(err);
        }
      );
    }

    $scope.tabChangeFx = function(tab){
      if(tab == '1'){
        $scope.video = null;
        $scope.progressBar = null;
        $scope.timeline = null;
        $scope.tooltip = null;
        setTimeout(function(){
          $scope.updateElmVid();
        }, 100)
      }
      $scope.selectedT = tab;
      $scope.ccEdit = false;
      $scope.ccAdd = false;
    }

    $scope.seekVideo = function(event){
      var timelineWidth = $scope.timeline.offsetWidth;
      var rect = $scope.timeline.getBoundingClientRect(); // Get the bounding rectangle of the videoBar
      var clickX = event.clientX - rect.left; // Calculate the offset relative to the videoBar
      var newTime = (clickX / timelineWidth) * $scope.video.duration;
      $scope.video.currentTime = newTime;
    }

    // Show time tooltip on hover
    $scope.showTimeTooltip = function(event) {
      var timelineWidth = $scope.timeline.offsetWidth;
      var rect = $scope.timeline.getBoundingClientRect(); // Get the bounding rectangle of the videoBar
      var hoverX = event.clientX - rect.left; // Calculate the offset relative to the videoBar
      var hoverTime = (hoverX / timelineWidth) * $scope.video.duration;

      var minutes = Math.max(0,Math.floor(hoverTime / 60));
      var seconds = Math.max(0,Math.floor(hoverTime % 60));
      // var formattedTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;
      var formattedTime = minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);;

      // Make sure the tooltip is temporarily visible to calculate its width
      $scope.tooltip.forEach(function(element){
        element.style.display = "block";
        var tooltipWidth = element.offsetWidth;
        // Calculate tooltip position
        var tooltipLeft = hoverX - (tooltipWidth / 2);
        // Boundary checks
        if (tooltipLeft < 0) {
          tooltipLeft = 0; // Ensure it doesn't go outside the left boundary
        }
        if (tooltipLeft + tooltipWidth > timelineWidth) {
          tooltipLeft = timelineWidth - tooltipWidth; // Ensure it doesn't go outside the right boundary
        }
        // Apply tooltip styles
        element.style.left = tooltipLeft + 'px';
        element.textContent = formattedTime; // Always show the formatted time
      })
    }

    // Hide tooltip when the mouse leaves the timeline
    $scope.hideTimeTooltip =  function() {
      $scope.tooltip.forEach(function(element){
        element.style.display = "none";
      });
    }

    $scope.playFx = function(data, caller, enable){
      if(enable){
        var nearestIndex = $scope.findNearestIndex(data.instances, 'start', $scope.video.currentTime);
        $scope.video.currentTime = $scope.timeToSeconds(data.instances[nearestIndex].start);
        var index = 0;
        if(caller == 'p'){
        index = nearestIndex - 1;
        }
        if(caller == 'n'){
        index = nearestIndex + 1;
        }
        if(caller == 'p' && data.instances.length > index && index >= 0){
          $scope.video.currentTime = $scope.timeToSeconds(data.instances[index].start);
        }
        if(caller == 'n' && data.instances.length > index && index >= 0){
          $scope.video.currentTime = $scope.timeToSeconds(data.instances[index].start);
        }
      }
    }

    $scope.getShotsFx = function(data){
      $scope.video.currentTime = $scope.timeToSeconds(data.instances[0].start);
      $scope.curData.scenes = data;
      $scope.curData.shots = data.shots;
      if($scope.curData.shots.length){
        $scope.getKeyFrameFx($scope.curData.shots[0])
      }
    }

    $scope.getKeyFrameFx = function(data){
      $scope.curData.keyFrames = data.keyFrames;
    }
    
    $scope.confirmFx = function(){
      var obj = {'vid':$scope.contentId};
      ContentLibrarySrv.getVIndexer(obj).then(
        function(data){
          $state.go("hub.contentLibrary.c");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.getVIndexer = function(){
      ngDialog.open({
        // <span ng-if="!readyToReIndex">{{\'cl.vi.m1\' | translate}}</span>\
        template:'\
          <section class="panel">\
            <div class="panel-body">\
            <span ng-if="readyToReIndex">{{ \'cl.vi.m5\' | translate}}</span>\
            <span ng-if="!readyToReIndex">{{\'cl.vi.m2\' | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-primary" ng-click="confirmFx();" focus-me="true" ng-disabled="confirmProcessing" ng-if="readyToReIndex">\
                <span class="fa fa-repeat fa-spin fa-fw" ng-if="confirmProcessing" aria-hidden="true"></span>{{\'cl.vi.3\' | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal" ng-if="readyToReIndex">{{"cm.btn.9" | translate}}</button>\
              <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal" ng-if="!readyToReIndex">{{"cm.btn.10" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.addLangFx = function(lang){
      $scope.loadInsights = true;
      $scope.searchText.txt = "";
      var addLangObj = angular.copy(lang);
      addLangObj.jobid = $scope.videoId;
      addLangObj.cid = $scope.contentId;
      addLangObj.isAdded = true;
      ContentLibrarySrv.addLanguage(addLangObj).then(
        function(data){
          if(data.st){
            $scope.selectedLang = addLangObj;
            $scope.insightsData.insight.transcript = [];
            $scope.insightsData.insight.transcript = data.transcript;
            $scope.insightsData.vtt = data.vtt;
            // TODO remove timestamp from vtt file
            // $scope.insightsData.vtt = data.vtt + '?' + moment().format('x');
  
            
            // if(data.transcript.length){
            //   $scope.getInstancesFx('transcript', data.transcript[0], false)
            // }
            $scope.loadInsights = false;
            setTimeout(function(){
              $scope.updateElmVid();
            }, 100)
            angular.forEach($scope.langSupport, function(obj){
              if(obj.languageCode == addLangObj.languageCode){
                obj.isAdded = true;
              }
            })
            $scope.langJsonUpdate($scope.langSupport, addLangObj.languageCode)
          } else{
            $scope.loadInsights = false;
            $scope.getVIndexer();
          }
        },
        function(err){
          $scope.loadInsights = false;
          $log.error(err);
        }
      );
    }

    $scope.timelineFx = function(data){
      $scope.video.currentTime = $scope.timeToSeconds(data.st);
    }

    $scope.openContentFolderFx = function(id, fId, splId, splType, gid, gType){
      if(id){        
        localStorage.setItem("curPathId", id);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', fId);
        localStorage.setItem('curDFId', fId);
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:splType}));
        if(gType){
          localStorage.setItem("curGroupId", gid);
          localStorage.setItem("curGroupType", gType);
        }
        $state.go($scope.previousState);
      } else{
        var curPathId = $scope.contentId;
        var curFId = localStorage.getItem("curFId");
        var curSPlObj = localStorage.getItem("curSPlObj");        
        localStorage.setItem("curPathId", curPathId);
        localStorage.setItem('curPathFId', true);
        localStorage.setItem('curFId', curFId);
        localStorage.setItem('curDFId', curFId);
        localStorage.setItem('curSPlObj', curSPlObj);
        $state.go($scope.previousState);
      }
      // $state.go("hub.contentLibrary.c");
    }

    $scope.ccEditFx = function(value){
      $scope.hasErr = false;
      $scope.errType = "";
      if(value){
        $scope.ccEdit = false;
      } else{
        $scope.ccEdit = true;
      }
    }

    $scope.editDetails = function(obj){
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.previousCC && $scope.previousCC.id){
        angular.forEach($scope.insightsData.insight.transcript, function(data){
          if(data.id == $scope.previousCC.id){
            data.txt = $scope.previousCC.txt;
            data.st = $scope.previousCC.st;
            data.et = $scope.previousCC.et;
          }
        });
      }
      $scope.previousCC = angular.copy(obj);
      $scope.ccEdit = true;
      $scope.editMore = true;
      $scope.ccAdd = false;
      $scope.editMoreId = obj.id;
    }

    $scope.generateVTT = function(captions) {
      var vttContent = "WEBVTT\n\n"; // WebVTT header
      vttContent += "NOTE\n";
      vttContent += "language:" + $scope.selectedLang.languageCode + "\n\n";
      captions.forEach(function(caption, index) {
        vttContent += (index + 1) + "\n"; // Caption index (optional)
        vttContent += caption.st + " --> " + caption.et + "\n"; // Use end time
        vttContent += caption.txt + "\n\n";
      });
      
      return vttContent;
    }

    $scope.formatTimeOnSave = function(time) {
      var value = time.replace(/\D/g, ''); // Remove non-numeric characters
  
      var hours = value.slice(0, 2);
      var minutes = value.slice(2, 4);
      var seconds = value.slice(4, 6);
      var milliseconds = value.slice(6, 9); // Only two digits after the dot
  
      // Ensure valid ranges
      // if (parseInt(hours, 10) > 99) hours = "99";
      // if (parseInt(minutes, 10) > 59) minutes = "59";
      // if (parseInt(seconds, 10) > 59) seconds = "59";
      // var hours = value.slice(0, 2) || "00";
      // var minutes = value.slice(2, 4) || "00";
      // var seconds = value.slice(4, 6) || "00";
      // var milliseconds = value.slice(6, 8) || "00"; // Only two digits after the dot
  
      // // Ensure valid ranges
      // if (parseInt(hours, 10) > 99) hours = "99";
      // if (parseInt(minutes, 10) > 59) minutes = "59";
      // if (parseInt(seconds, 10) > 59) seconds = "59";
  
      // Format output as HH:MM:SS.XX
      time = hours + ":" + minutes + ":" + seconds + "." + milliseconds;
      return time;
    };

    $scope.insertTranscriptEntry = function(newEntry){
      var newStartTime = $scope.timeToSeconds(newEntry.st);

      var insertIndex = -1;
      var lastSameTimeIndex = -1;

      // Find the correct position to insert
      angular.forEach($scope.insightsData.insight.transcript, function (entry, i) {
        var entryStartTime = $scope.timeToSeconds(entry.st);

        if (newStartTime < entryStartTime && insertIndex === -1) {
          insertIndex = i; // First position where newStartTime is smaller
        }

        if (newStartTime === entryStartTime) {
          lastSameTimeIndex = i; // Track the last occurrence of this time
        }
      });

      if (lastSameTimeIndex !== -1) {
        insertIndex = lastSameTimeIndex + 1;
      } else if (insertIndex === -1) {
        insertIndex = $scope.insightsData.insight.transcript.length;
      }

      // Convert new entry format to match the $scope.insightsData.insight.transcript structure
      var formattedEntry = {
        id: null, // Will be updated later
        txt: newEntry.txt,
        st: newEntry.st,
        et: newEntry.et
      };

      // Insert the new entry at the correct position
      $scope.insightsData.insight.transcript.splice(insertIndex, 0, formattedEntry);

      // Update the sequence IDs after inserting
      angular.forEach($scope.insightsData.insight.transcript, function (item, index) {
        item.id = index + 1;
      });
    };
  

    $scope.updateCaptionsDetail = function(caller, obj, $event){
      $scope.hasErr = false;
      $scope.errType = "";
      if(caller == 'a' || caller == 'u'){
        $event.stopPropagation();
      }
      if(caller == 'r'){
        angular.forEach($scope.insightsData.insight.transcript, function(value, index){
          if($scope.removeObj.id == value.id){
            $scope.insightsData.insight.transcript.splice(index, 1);
          }
        })
      }
      if(caller == 'a' || caller == 'u'){
        var start = '';
        var end = '';
        if(caller == 'a'){
          start = $scope.formatTimeOnSave(obj.st);
          end = $scope.formatTimeOnSave(obj.et);
          $scope.ccAddObj.st = start;
          $scope.ccAddObj.et = end;
        }
        if(caller == 'u'){
          start = $scope.formatTimeOnSave(obj.st);
          end = $scope.formatTimeOnSave(obj.et);
          angular.forEach($scope.insightsData.insight.transcript, function(value){
            if(value.id == obj.id){
              value.st = start;
              value.et = end;
              value.txt = obj.txt;
            }
          })
        }
        // function isOverlapping(existingCaptions, newCaption) {
        //   return existingCaptions.some(function (caption) {
        //     return !(newCaption.endTime <= caption.startTime || newCaption.startTime >= caption.endTime);
        //   });
        // }
        var total = $scope.timeToSeconds($scope.insightsData.insight.duration);
        var startInSeconds = $scope.timeToSeconds(start);
        var endInSeconds = $scope.timeToSeconds(end);
        var durationInSeconds = endInSeconds - startInSeconds;
        if(!startInSeconds){
          $scope.hasErr = true;
          $scope.errType = "sTime";
        } else if(!endInSeconds){
          $scope.hasErr = true;
          $scope.errType = "eTime";
        } else if(startInSeconds >= endInSeconds){
          $scope.hasErr = true;
          $scope.errType = "validTime";
        } else if(endInSeconds > total || durationInSeconds > total){
          $scope.hasErr = true;
          $scope.errType = "validDuration";
        } else if(!obj.txt){
          $scope.hasErr = true;
          $scope.errType = "text";
        } else{          
          $scope.hasErr = false;
          $scope.errType = "";
        }
      }
      if(!$scope.hasErr){
        if(caller == 'a'){
          $scope.insertTranscriptEntry($scope.ccAddObj)
        }
        var vttData = "";
        vttData = $scope.generateVTT($scope.insightsData.insight.transcript);
        if(!$scope.insightsData.insight.transcript.length){
          vttData = "";
        }
        $scope.loadingCaption = true;
        var captionObj = {jobid:$scope.videoId, vtt:vttData, langId:$scope.selectedLang.id}
        if(!$scope.insightsData.insight.transcript.length){
          angular.forEach($scope.langSupport, function(obj){
            if(obj.languageCode == $scope.selectedLang.languageCode){
              obj.isAdded = false;
            }
          })
          $scope.langJsonUpdate($scope.langSupport)
          captionObj.lang = $scope.addedLang.concat($scope.notAddedLang);
        }
        ContentLibrarySrv.updateCaptions(captionObj).then(
          function(data){
            if(data.st){
              $scope.previousCC = {};
              $scope.ccEdit = false;
              $scope.ccAdd = false;
              $scope.editMore = false;
              $scope.editMoreId = 0;
              $scope.insightsData.vtt = "";
              $scope.insightsData.vtt = data.vtt;
              // TODO remove timestamp from vtt file
              // $scope.insightsData.vtt = data.vtt + '?' + moment().format('x');
              // $scope.updateVideoTrack('');
              if(caller == 'a'){
                $rootScope.toastNotificationFx("info", {code:1710102346});
              } else if(caller == 'u'){
                $rootScope.toastNotificationFx("info", {code:1710102347});
              } else if(caller == 'r'){
                ngDialog.close();
                $rootScope.toastNotificationFx("info", {code:1710102348});
              }
              $scope.loadingCaption = false;
            }
          },
          function(err){
            $log.error(err);
            $scope.loadingCaption = false;
          }
        );
      }
    }

    $scope.addCCFx = function(obj, e){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.updateCaptionsDetail('a', obj, e);
    }

    $scope.updateCCFx = function(obj, e){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.updateCaptionsDetail('u', obj, e);
    }

    $scope.removeCCFx = function(obj, e){      
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.removeObj = obj;     
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">\
            <span ng-if="readyToReIndex">{{ "cm.msg.34" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="updateCaptionsDetail(\'r\');" focus-me="true" ng-disabled="loadingCaption" ng-if="readyToReIndex">\
                <span class="fa fa-repeat fa-spin fa-fw" ng-if="loadingCaption" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal" ng-if="readyToReIndex">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.cancelCCFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      angular.forEach($scope.insightsData.insight.transcript, function(data){
        if(data.id == $scope.previousCC.id){
          data.txt = $scope.previousCC.txt;
          data.st = $scope.previousCC.st;
          data.et = $scope.previousCC.et;
        }
      });
      $scope.ccEdit = false;
      $scope.ccAdd = false;
      $scope.editMore = false;
      $scope.editMoreId = 0;
      $scope.previousCC = {};
    }

    $scope.resetAddDetails = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.ccAddObj = {st:"00:00:00.000", et:"00:00:00.000", txt:""};
    }

    $scope.addDetails = function(){
      $scope.resetAddDetails();
      $scope.cancelCCFx();
      $scope.ccAdd = true;
    }

    // $scope.$watch('selectedLang.name', function (newVal, oldVal) {
    //   if (newVal && newVal !== oldVal) {
    //     $scope.updateVideoTrack(newVal)
    //   }
    // });
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ThirdPartyCtrl', ThirdPartyCtrl);

  /** @ngInject */
  function ThirdPartyCtrl($log, $rootScope, $scope, $state, $interval, $timeout, $cookies, $filter, ngDialog, CLTPSrv){
    $scope.fid = localStorage.getItem("curFId");
    if(angular.isUndefined($scope.fid)){
      $scope.fid = 0;
    }
    $rootScope.selectedMenu = 1; //For LeftPanel Menu selected
    $rootScope.selectedCW = 3; //For upload content & widget tab selection
    $rootScope.tabView = true;

    $scope.curState = $state.current.name;
    $scope.isUploadBtn = false;
    $scope.dataLoading = true;
    $scope.isListOpen = true;
    $scope.isPEOpen = false;
    $scope.breadCrumbs = [];

    $scope.tpuPermissionExpiry = {permission:{type:$scope.auth.upreferences.defaultP}, activePeriod:{type:"a"}};

    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.errType = "";
      $scope.hasErr = false;
      $scope.curSelected = [];
      $state.current = toState;
      $scope.selectProcessing = false;
      $scope.curState = $state.current.name;
      $scope.getStateFx();
      $scope.tpuPermissionExpiry = {permission:{type:$scope.auth.upreferences.defaultP}, activePeriod:{type:"a"}};
    });

    $scope.isAuthShow = false;
    $scope.isVerified = false;
    $scope.isAuthLoading = false;
    $scope.verifyFx = function(calback){
      $scope.isAuthLoading = false;
      $scope.btnLoading = true;
      $scope.isAuthShow = true;
      CLTPSrv.getVerify($scope.curCaller).then(
        function(data){
          $scope.btnLoading = false;
          $scope.hasErr = false;
          $scope.errType = "";
          if(data.code == 8155){
            if(calback){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
            }
            $scope.isVerified = false;
            $interval.cancel($scope.childWindowInt);
          } else{
            $scope.cList = data.calendarList;
            $scope.cListShow = true;
            if(data.isClosed){
              $scope.isVerified = true;
            } else{
              $scope.hasErr = true;
              $scope.errType = "authFailed";
              $scope.isVerified = false;
            }
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    //$scope.verifyFx();

    $scope.getStateFx = function(){
      $scope.isSelectShow = true;
      $scope.isAuthShow = false;
      if($scope.curState == "hub.contentAdd.thirdParty.tpuDbox"){
        $scope.curCaller = "dbox";
        $scope.verifyFx();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuFb"){
        $scope.curCaller = "fb";
        $scope.verifyFx();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuFtp"){
        $scope.curCaller = "ftp";
        $scope.isAuthShow = false;
        $scope.isVerified = false;
        // $scope.ftp = {host:"dev2.lsquarednetworks.com", user:"ftptest", pass:"ftptest@123"};
        $scope.ftp = {host:"", user:"", pass:"", dir:[]};
        $("#tpuBtn .ftp").click();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuDrive"){
        $scope.curCaller = "gd";
        $scope.verifyFx();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuInsta"){
        $scope.curCaller = "ig";
        $scope.verifyFx();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuTw"){
        $scope.curCaller = "tw";
        $scope.tw = {twitter:"", dType:"h"};
        $scope.isAuthShow = false;
        $scope.isVerified = false;
        $("#tpuBtn .twitter").click();
      } else if($scope.curState == "hub.contentAdd.thirdParty.tpuUrl"){
        $scope.url = {url:""};
        $scope.curCaller = "url";

        $scope.isSelectShow = false;
        $scope.isAuthShow = false;
        $scope.isVerified = false;
        $scope.isUploading = false;
        $scope.curSelected = [{}];
      }
    }
    setTimeout(function(){
      $scope.getStateFx();
    }, 100);

    $scope.listOpenFx = function(){
      if($scope.isListOpen){
        $scope.isListOpen = false;
      } else{
        $scope.isListOpen = true;
      }
    }

    $scope.openSelectFx = function(){
      ngDialog.open({
        template:"app/contentLibrary/popup/openSelectContent.html",
        width:"98%",
        scope:$scope,
        className:'ngdialog-theme-default ngdialog-preview',
        closeByDocument:false
      });
      $scope.selectProcessing = false;
    }

    $scope.authorizeFx = function(){
      if(!$scope.isVerified){
        $scope.isAuthLoading = true;
        $scope.hasErr = false;
        $scope.errType = "";
        if($scope.curCaller == "dbox"){
          CLTPSrv.getDBAuth().then(
            function(data){
              if(data.isLoggedin){
              } else{
                $scope.openUrlFx(data.rUrl, 626, 450);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.curCaller == "fb"){
          CLTPSrv.getFBAuth().then(
            function(data){
              if(data.isLoggedin){
              } else{
                $scope.openUrlFx(data.rUrl, 626, 450);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.curCaller == "gd"){
          CLTPSrv.getGDAuth().then(
            function(data){
              if(data.isLoggedin){
              } else{
                $scope.openUrlFx(data.rUrl, 626, 450);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.curCaller == "ig"){
          CLTPSrv.getIGAuth().then(
            function(data){
              if(data.isLoggedin){
              } else{
                $scope.openUrlFx(data.rUrl, 626, 450);
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else{
        CLTPSrv.getLogout($scope.curCaller).then(
          function(data){
            $scope.isAuthLoading = false;
            $scope.isVerified = false;
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $scope.selectProcessing = false;
    $scope.selectFileFx = function(caller){
      $scope.hasPopupErr = false;
      $scope.errPopupType = "";
      $scope.breadCrumbs = [];
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.selectProcessing = true;
      if($scope.curCaller == "dbox"){
        CLTPSrv.getDB(0).then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
              $scope.openSelectFx();
            }
          },
          function(err){
            $scope.selectProcessing = false;
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "fb"){
        CLTPSrv.getFB().then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
              $scope.openSelectFx();
            }
          },
          function(err){
            $scope.selectProcessing = false;
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "ftp"){
        $scope.authOpen("ftp");
      } else if($scope.curCaller == "gd"){
        CLTPSrv.getGD(0).then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
              $scope.openSelectFx();
            }
          },
          function(err){
            $scope.selectProcessing = false;
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "ig"){
        CLTPSrv.getIG().then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
              $scope.openSelectFx();
            }
          },
          function(err){
            $scope.selectProcessing = false;
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "tw"){
        $scope.tw = {twitter:"", dType:"h"};
        $scope.authOpen("tw");
      }
    }

    $scope.authOpen = function(caller){
      $scope.selectProcessing = false;
      $scope.popupProcessing = false;
      $scope.authObj = {caller:caller};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div ng-if="authObj.caller==\'ftp\'">\
                <div class="form-group">\
                  <label for="host">{{"cl.t_p.ftp.1" | translate}}</label>\
                  <input type="text" class="form-control" ng-model="ftp.host" focus-me="true" id="host" aria-label="host" aria-labelledby="host">\
                </div>\
                <div class="form-group">\
                  <label for="user">{{"cl.t_p.ftp.2" | translate}}</label>\
                  <input type="text" class="form-control" ng-model="ftp.user" id="user" aria-label="user" aria-labelledby="user">\
                </div>\
                <div class="form-group noMarB">\
                  <label for="pass">{{"cl.t_p.ftp.3" | translate}}</label>\
                  <input type="password" class="form-control" ng-model="ftp.pass" id="pass" aria-label="pass" aria-labelledby="pass">\
                </div>\
              </div>\
              <div ng-if="authObj.caller == \'tw\'">\
                <div class="form-group">\
                  <label>{{"cm.label.69" | translate}}</label>\
                  <div role="radiogroup" aria-labelledby="radiogroup">\
                    <label class="noMarB marR10" for="dTypeH">\
                      <input type="radio" role="radio" name="dTypeOpt" ng-model="tw.dType" value="h" id="dTypeH" aria-label="dTypeH" aria-labelledby="dTypeH"><label></label> {{"cl.widget.twitter.4" | translate}}\
                    </label>\
                    <label class="noMarB" for="dTypeT">\
                      <input type="radio" role="radio" name="dTypeOpt" ng-model="tw.dType" value="t" id="dTypeT" aria-label="dTypeT" aria-labelledby="dTypeT"><label></label> {{"cl.widget.cm.21" | translate}}\
                    </label>\
                  </div>\
                </div>\
                <div class="form-group noMarB">\
                  <label for="twitter">{{tw.dType == "t"?"cl.widget.twitter.5":"cl.widget.twitter.5.1" | translate}}</label>\
                  <input type="text" id="twitter" class="form-control" ng-model="tw.twitter" aria-label="{{tw.dType == "t"?"cl.widget.twitter.5":"cl.widget.twitter.5.1" | translate}}" aria-labelledby="{{tw.dType == "t"?"cl.widget.twitter.5":"cl.widget.twitter.5.1" | translate}}">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-primary" ng-click="authFx(authObj.caller);" ng-disabled="popupProcessing"><span class="fa fa-repeat fa-spin" ng-if="popupProcessing" aria-hidden="true"></span> {{"cm.btn.42" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right" ng-if="hasPopupErr" aria-live="polite" role="status">\
                <div ng-if="errPopupType==\'empty\'" aria-live="polite" role="status">{{"cm.msg.5" | translate}}</div>\
                <div ng-if="errPopupType==\'authFailed\'" aria-live="polite" role="status">{{"cl.widget.msg.11" | translate}}</div>\
                <div ng-if="errPopupType==\'twEmpty\'" aria-live="polite" role="status">{{tw.dType == "t"?"cl.widget.twitter.m1":"cl.widget.twitter.m2" | translate}}</div>\
                <div ng-if="errPopupType==\'dataEmpty\'" aria-live="polite" role="status">{{"cl.widget.msg.11" | translate}}</div>\
                <div ng-if="errPopupType==\'twNot\'" aria-live="polite" role="status">{{"cl.widget.twitter.m3" | translate}}</div>\
                <div ng-if="errPopupType==\'nHandle\'" aria-live="polite" role="status">{{"cl.t_p.tw.m1" | translate}}</div>\
                <div ng-if="errPopupType==\'cHandle\'" aria-live="polite" role="status">{{"cl.t_p.tw.m2" | translate}}</div>\
                <div ng-if="errPopupType==\'cTag\'" aria-live="polite" role="status">{{"cl.t_p.tw.m3" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:520,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
      });
    }

    $scope.authFx = function(caller){
      $scope.hasPopupErr = false;
      $scope.errPopupType = "";
      if(caller == "ftp"){
        if($scope.ftp.host == ""){
          $scope.hasPopupErr = true;
          $scope.errPopupType = "empty";
          $("#host").focus();
        } else if($scope.ftp.user == ""){
          $scope.hasPopupErr = true;
          $scope.errPopupType = "empty";
          $("#user").focus();
        } else if($scope.ftp.pass == ""){
          $scope.hasPopupErr = true;
          $scope.errPopupType = "empty";
          $("#pass").focus();
        } else{
          $scope.ftp.dir = [];
          $scope.popupProcessing = true;
          CLTPSrv.postFtpAuth($scope.ftp).then(
            function(data){
              $scope.popupProcessing = false;
              if(data.code == 8173){
                $scope.hasPopupErr = true;
                $scope.errPopupType = "authFailed";
              }
              if(data.isLoggedin){
                ngDialog.close();
                $scope.dataLoading = false;
                $scope.openSelect = data;
                $scope.openSelectFx();
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if(caller == "tw"){
        $scope.replaceObj = $scope.tw.twitter.replace( /#/g, "" );
        // $scope.replaceObj = $scope.tw.twitter.replace( /@/g, "" );
        $scope.tw.twitter = $scope.replaceObj;
        if($scope.tw.twitter == ""){
          $scope.hasPopupErr = true;
          $scope.errPopupType = "twEmpty";
          $("#twitter").focus();
        } else{
          $scope.popupProcessing = true;
          CLTPSrv.getTW($scope.tw).then(
            function(data){
              $scope.popupProcessing = false;
              if(data.code == 8180){
                $scope.hasPopupErr = true;
                $scope.errPopupType = "nHandle";
              } else if(data.code == 8206){
                $scope.hasPopupErr = true;
                $scope.errPopupType = "cHandle";
              } else if(data.code == 8181){
                $scope.hasPopupErr = true;
                $scope.errPopupType = "cTag";
              } else if(!data.contentLibrary.content.length){
                $scope.hasPopupErr = true;
                $scope.errPopupType = "twNot";
              } else{
                ngDialog.close();
                $scope.dataLoading = false;
                $scope.openSelect = data;
                $scope.openSelectFx();
              }
            },
            function(err){
              $scope.dataLoading = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.openUrlFx = function(rUrl, w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      $scope.childWindow = window.open(rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
      $scope.childWindowInt = $interval($scope.checkChild, 500);
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        $scope.verifyFx(true);
      }
    }

    $scope.curItem;
    $scope.curSelected = [];
    $scope.isDuplicate = false;
    $scope.briefFx = function(){
      angular.forEach($rootScope.selectedItems, function(item){
        $scope.isDuplicate = false;
        angular.forEach($scope.curSelected, function(listItem){
          if(listItem.id == item.id){
            $scope.isDuplicate = true;
            return false;
          }
        });
        if(!$scope.isDuplicate){
          if(item.type != "folder"){
            $scope.curItem = $scope.openSelect.contentLibrary.content.filter(function(obj){
              return obj.id == item.id;
            })[0];
            if($scope.curCaller == "ftp"){
              var curDir = [];
              if($scope.ftp && $scope.ftp.dir.length){
                curDir = $scope.ftp.dir;
              }
              $scope.curSelected.push({id:$scope.curItem.id, label:$scope.curItem.label, type:$scope.curItem.type, thumb:$scope.curItem.thumb, extn:$scope.curItem.extn, url:$scope.curItem.url, dir:curDir, size:$scope.curItem.size});
            } else{
              $scope.curSelected.push({id:$scope.curItem.id, label:$scope.curItem.label, type:$scope.curItem.type, thumb:$scope.curItem.thumb, extn:$scope.curItem.extn, url:$scope.curItem.url, size:$scope.curItem.size});
            }
          }
        }
      });
      $rootScope.selectedItems = [];

      $timeout(function(){
        angular.forEach($scope.curSelected, function(file, index){
          $scope.fileLabelStr = "";
          if($rootScope.itemInArray($scope.supportedFiles, (file.extn).toLowerCase())){
            if(!file.optimize){
              file.optimize = 1;
            }
            if(!file.isEdit){
              file.isEdit = false;
            }
            if(!file.label){
              $scope.fileLabelArr = file.name.split(".");
              for(var i=0; i<$scope.fileLabelArr.length - 1; i++){
                if($scope.fileLabelStr == ""){
                  $scope.fileLabelStr = $scope.fileLabelArr[i];
                } else{
                  $scope.fileLabelStr += "." + $scope.fileLabelArr[i];
                }
              }
              file.label = $scope.fileLabelStr;
              file.tempLabel = $scope.fileLabelStr;
            }
            if(!file.isNameValid){
              file.isNameValid = true;
            }
            file.unsupported = false;
          } else{
            file.unsupported = true;
          }
        });
      }, 200);
    }

    $scope.folderBriefFx = function(){}

    $scope.folderContentFx = function(selectedFolder, index){
      if(!selectedFolder){
        $scope.breadCrumbs = [];
      } else{
        if(index){
          var curIndex = $scope.breadCrumbs.length - index;
          $scope.breadCrumbs.splice(index, curIndex);
        }
        angular.forEach($scope.openSelect.contentLibrary.folder, function(folder){
          if(folder.id == selectedFolder){
            $scope.breadCrumbs.push(folder);
          }
        });
      }
      $scope.dataLoading = true;
      if($scope.curCaller == "dbox"){
        CLTPSrv.getDB(selectedFolder).then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
            }
          },
          function(err){
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "ftp"){
        $scope.arraytoStringFx($scope.breadCrumbs);;
        $scope.ftp.dir = $scope.stringIds;
        CLTPSrv.postFtpAuth($scope.ftp).then(
          function(data){
            $scope.dataLoading = false;
            if(data.code == 8173){
              $scope.hasErr = true;
              $scope.errType = "authFailed";
            } else{
              $scope.openSelect = data;
            }
          },
          function(err){
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "gd"){
        CLTPSrv.getGD(selectedFolder).then(
          function(data){
            if(data){
              $scope.dataLoading = false;
              $scope.openSelect = data;
            }
          },
          function(err){
            $scope.dataLoading = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.cancelFileFx = function(index){
      $scope.curSelected.splice(index, 1);
    }

    $scope.openEditName = function(index){
      $scope.curSelected[index].isEdit = true;
    }
    $scope.cancelEditName = function(index){
      $scope.curSelected[index].tempLabel = angular.copy($scope.curSelected[index].label);
      $scope.curSelected[index].isNameValid = true;
      $scope.curSelected[index].isEdit = false;
    }
    $scope.saveEditName = function(index){
      if($scope.splCharValidateRegExp.test($scope.curSelected[index].tempLabel)){
        $scope.curSelected[index].label = angular.copy($scope.curSelected[index].tempLabel);
        $scope.curSelected[index].isNameValid = true;
        $scope.curSelected[index].isEdit = false;
      } else{
        $scope.curSelected[index].isNameValid = false;
      }
    }

    $scope.tpuUploadFx = function(){
      $scope.filteredContent = [];
      $scope.curSaveObj = {};
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.curCaller != "url"){
        angular.forEach($scope.curSelected, function(item){
          if(!item.unsupported && item.size <= 512000){
            $scope.filteredContent.push(item);
          }
        });
        $scope.curSaveObj = {fid:JSON.parse($scope.fid), content:$scope.filteredContent};
        if(!$scope.curSaveObj.content.length){
          $scope.hasErr = true;
          $scope.errType = "fileFormat";
          return;
        }
        $scope.isUploading = true;
      }

      if($rootScope.activePeriodOpen){
        $scope.isPEOpen = true;
        $rootScope.$broadcast('saveActivePeriod',{});
      }
      if($rootScope.isPermissionOpen){
        $scope.isPEOpen = true;
        $rootScope.$broadcast('savePermission',{});
      }
      if($scope.isPEOpen){
        $timeout(function(){
          $scope.saveFx();
        }, 250);
      } else{
        $scope.saveFx();
      }
    }

    $scope.saveFx = function(){
      $scope.curSaveObj.permission = $scope.tpuPermissionExpiry.permission;
      $scope.curSaveObj.activePeriod = $scope.tpuPermissionExpiry.activePeriod;

      if($scope.curCaller == "dbox"){
        CLTPSrv.saveDB($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "fb"){
        CLTPSrv.saveFB($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "ftp"){
        $scope.curSaveObj.ftp_token = $scope.openSelect.ftp_token;
        CLTPSrv.saveFtp($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "gd"){
        CLTPSrv.saveGD($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "ig"){
        CLTPSrv.saveIG($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "tw"){
        CLTPSrv.saveTW($scope.curSaveObj).then(
          function(data){
            $scope.isUploading = false;
            if(data.code == 8092){
              $scope.hasErr = true;
              $scope.errType = "fileFormat";
            } else{
              $state.go("hub.contentLibrary.c");
            }
          },
          function(err){
            $scope.isUploading = false;
            $log.error(err);
          }
        );
      } else if($scope.curCaller == "url"){
        $scope.curSaveObj = {fid:JSON.parse($scope.fid), url:$scope.url.url, permission:$scope.tpuPermissionExpiry.permission, activePeriod:$scope.tpuPermissionExpiry.activePeriod};
        if($scope.url.url == ""){
          $scope.hasErr = true;
          $scope.errType = "urlEmpty";
          $("#tpUrl").focus();
        } else{
          if($rootScope.itemInArray($scope.supportedFiles, $scope.url.url.split(".")[$scope.url.url.split(".").length - 1].toLowerCase())){
            $scope.isUploading = true;
            CLTPSrv.saveUrl($scope.curSaveObj).then(
              function(data){
                $scope.isUploading = false;
                if(data.code == 8182){
                  $scope.hasErr = true;
                  $scope.errType = "invalidUrl";
                } else if(data.code == 8092){
                  $scope.hasErr = true;
                  $scope.errType = "fileFormat";
                } else if(data.code == 8205){
                  $scope.hasErr = true;
                  $scope.errType = "fileSize";
                } else{
                  $state.go("hub.contentLibrary.c");
                }
              },
              function(err){
                $scope.isUploading = false;
                $log.error(err);
              }
            );
          } else{
            $scope.hasErr = true;
            $scope.errType = "fileFormat";
          }
        }
      }
    }

    $scope.logOffFx = function(){
      CLTPSrv.getLogout().then(
        function(data){
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $rootScope.selectedTabFx = function(){}
    $scope.cancelPromise = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ImageVideoEditorController', ImageVideoEditorController);

  /** @ngInject */
  function ImageVideoEditorController($log, $rootScope, $scope, $state, $cookies, $timeout, $window, $filter, ngDialog, FileModelUploadSrv, ContentLibrarySrv){
    $rootScope.selectedMenu = 1; //For LeftPanel Menu selected

    $scope.replaceProcessing = false;
    $scope.isNewPermission = false;
    $scope.saveProcessing = false;
    $scope.newProcessing = false;
    $scope.contentLoading = true;
    $scope.contentInfo = {};
    $scope.isEmpty = true;
    $scope.curObj = {};
    $scope.selectedObj;
    $scope.addCaption = {begin:"", end:"", text:""};
    $scope.tooltipMsg = "";

    if($scope.auth.upermissions.c){
      if(!$scope.auth.upermissions.ar && (localStorage.getItem("inFolder") == 0)){
        $scope.isNewPermission = true;
        $scope.tooltipMsg = $filter("translate")('cl.p_cEdit.m10');
      }
    } else{
      $scope.isNewPermission = true;
      $scope.tooltipMsg = $filter("translate")('cl.p_cEdit.m11');
    }

    if($state.params.id){
      ContentLibrarySrv.getInfo($scope.hubDecrypt($state.params.id)).then(
        function(data){
          $scope.bucket = $scope.detailBucket = data.bucket;
          if(data.mbucket && data.mbucket != ""){
            $scope.detailBucket = data.mbucket;
          }

          /*Image Editor*/
          $scope.contentInfo = data;

          $("#canvas").attr("height", $scope.contentInfo.h);
          $("#canvas").attr("width", $scope.contentInfo.w);

          $scope.canvas = new fabric.Canvas('canvas', {
            preserveObjectStacking:true
          });

          $scope.canvas.on('mouse:down', function(e){
            if(e.target != null){
              $scope.isEmpty = false;
              if(e.target.isType("i-text")){
                $scope.curObj = {
                  type:"text",
                  tColor:e.target.fill,
                  size:e.target.fontSize,
                  textAlign:e.target.textAlign,
                  fontStyle:e.target.fontStyle,
                  fontWeight:e.target.fontWeight,
                  textDecoration:e.target.textDecoration,
                  font:$scope.valInArr(e.target.fontFamily, $scope.fontFamily),
                }
                if(e.target.shadow){//For color type
                  $scope.curObj.cType = e.target.shadow.color;
                }
              } else if(e.target.isType("image")){
                $scope.curObj = {
                  type:"image",
                  filters:e.target.filters
                }
              } else{
                $scope.curObj = {
                  type:"obj",
                  bgColor:e.target.fill,
                }
                if(e.target.shadow){//For color type
                  $scope.curObj.bgType = e.target.shadow.color;
                }
                if(e.target.radius){
                  $scope.curObj.subType = "circle";
                }
              }
              if(e.target.fill == "#000000"){
                $scope.curObj.tColor = "#000000";
                $scope.curObj.bgColor = "#000000";
                $scope.curObj.cType = "monochrome";
                $scope.curObj.bgType = "monochrome";
              }
              $scope.curObj.top = e.target.top;
              $scope.curObj.left = e.target.left;
              $scope.curObj.width = $scope.contentInfo.w;
              $scope.curObj.height = $scope.contentInfo.h;
              $scope.curObj.scaleX = e.target.scaleX;
              $scope.curObj.scaleY = e.target.scaleY;
              $scope.curObj.opacity = e.target.opacity;
            } else{
              $scope.isEmpty = true;
            }
            $timeout(function(){
              $scope.$apply()
            }, 50);
          });

          $scope.imgObj = new Image();
          if($scope.contentInfo.mbucket && $scope.contentInfo.mbucket != ""){
            $scope.imgObj.src = $scope.detailBucket + $scope.contentInfo.src + "?" + new Date().getTime();
          } else{
            $scope.imgObj.src = $scope.contentInfo.timthumb + $scope.contentInfo.bucket + $scope.contentInfo.src + "&h=" + $scope.contentInfo.h + "&w=" + $scope.contentInfo.w + "&q=100";
          }
          $scope.imgObj.setAttribute('crossOrigin', '');
          $scope.imgObj.onload = function(){
            $scope.img = new fabric.Image($scope.imgObj);
            $scope.canvas.centerObject($scope.img);
            $scope.f = fabric.Image.filters;
            $scope.canvas.add($scope.img);
            $scope.contentLoading = false;
            $scope.canvas.renderAll();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Create text, rect, circle, triangle*/
  	$scope.drawFx = function(caller){
      $scope.drawObj;
      if(caller == "text"){
        $scope.drawObj = new fabric.IText('Tap and Type', {top:0, left:0, fill:"#000000", fontFamily:$scope.fontFamilySelected.value});
        $scope.canvas.setActiveObject($scope.drawObj);
      } else if(caller == "circle"){
        $scope.drawObj = new fabric.Circle({top:0, left:0, radius:30, fill:"#000000"});
      } else if(caller == "rect"){
        $scope.drawObj = new fabric.Rect({top:0, left:0, width:100, height:100, fill:"#000000"});//,selection:false
      } else if(caller == "triangle"){
        $scope.drawObj = new fabric.Triangle({top:0, left:0, width:100, height:100, fill:"#000000"});
      }
      $scope.canvas.add($scope.drawObj);
    }

    /*Header Tool's*/
    $scope.positionFx = function(type){
      $scope.selectedObj = $scope.canvas.getActiveObject();
      if(type == 'sendBack'){
        $scope.canvas.sendBackwards($scope.selectedObj);
      } else if(type == 'sendToBack'){
        $scope.canvas.sendToBack($scope.selectedObj);
      } else if(type == 'bringForward'){
        $scope.canvas.bringForward($scope.selectedObj);
      } else if(type == 'bringToFront'){
        $scope.canvas.bringToFront($scope.selectedObj);
      }
      $scope.canvas.renderAll();
    }
    /*Selected send forward & backward with keybord*/
    angular.element(document).bind('keyup', function (e){
      if(!$scope.isEmpty){
        if(e.keyCode == 36){//key:- Home
          $scope.positionFx("bringToFront");
        } else if(e.keyCode == 35){//key:- End
          $scope.positionFx("sendToBack");
        } else if(e.keyCode == 33){//key:- pUp
          $scope.positionFx("bringForward");
        } else if(e.keyCode == 34){//key:- pDown
          $scope.positionFx("sendBack");
        }
      }
    });

    /*Delete selected object*/
    $scope.deleteFx = function(){
      if($scope.canvas.getActiveGroup()){
        $scope.canvas.getActiveGroup().forEachObject(function(o){
          $scope.canvas.remove(o)
        });
        $scope.canvas.discardActiveGroup().renderAll();
      } else{
        $scope.canvas.remove($scope.canvas.getActiveObject());
      }
    }
    $rootScope.deleteCallback = function(){
      $scope.deleteFx();
    }

    /*Object, text, images*/
    $scope.setPropertiesFx = function(caller, prop){
      $scope.selectedObj = $scope.canvas.getActiveObject();
      if(caller == "text"){
        if(prop == "font"){
          $scope.selectedObj.fontFamily = $scope.curObj.font.value;
        } else if(prop == "size"){
          $scope.selectedObj.set("fontSize", $scope.curObj.size);
        } else if(prop == "color"){
          $scope.selectedObj.setColor($scope.curObj.tColor);
          $scope.selectedObj.setShadow($scope.curObj.cType);
        } else if(prop == "bold"){
          if($scope.curObj.fontWeight == "600"){
            $scope.curObj.fontWeight = "400";
          } else{
            $scope.curObj.fontWeight = "600";
          }
          $scope.selectedObj.setFontWeight($scope.curObj.fontWeight);
        } else if(prop == "italic"){
          if($scope.curObj.fontStyle == "italic"){
            $scope.curObj.fontStyle = "normal";
          } else{
            $scope.curObj.fontStyle = "italic";
          }
          $scope.selectedObj.setFontStyle($scope.curObj.fontStyle);
        } else if(prop == "underline"){
          if($scope.curObj.textDecoration == "underline"){
            $scope.curObj.textDecoration = "none";
          } else{
            $scope.curObj.textDecoration = "underline";
          }
          $scope.selectedObj.setTextDecoration($scope.curObj.textDecoration);
        } else if(prop == "left"){
          $scope.curObj.textAlign = "left";
          $scope.selectedObj.setTextAlign($scope.curObj.textAlign);
        } else if(prop == "center"){
          $scope.curObj.textAlign = "center";
          $scope.selectedObj.setTextAlign($scope.curObj.textAlign);
        } else if(prop == "right"){
          $scope.curObj.textAlign = "right";
          $scope.selectedObj.setTextAlign($scope.curObj.textAlign);
        } else if(prop == "justify"){
          $scope.curObj.textAlign = "justify";
          $scope.selectedObj.setTextAlign($scope.curObj.textAlign);
        }
      } else if(caller == "obj"){
        if(prop == "color"){
          $scope.selectedObj.setColor($scope.curObj.bgColor);
          $scope.selectedObj.setShadow($scope.curObj.bgType);
        }
      } else if(caller == "all"){
        if(prop == "x"){
          $scope.selectedObj.setLeft(parseInt($scope.curObj.left, 10)).setCoords();
        } else if(prop == "y"){
          $scope.selectedObj.setTop(parseInt($scope.curObj.top, 10)).setCoords();
        } else if(prop == "w"){
          $scope.selectedObj.setWidth(parseInt($scope.curObj.width, 10)).setCoords();
        } else if(prop == "h"){
          $scope.selectedObj.setHeight(parseInt($scope.curObj.height, 10)).setCoords();
        } else if(prop == "scaleX"){
          $scope.selectedObj.scaleX = $scope.curObj.scaleX;
        } else if(prop == "scaleY"){
          $scope.selectedObj.scaleY = $scope.curObj.scaleY;
        } else if(prop == "opacity"){
          $scope.selectedObj.opacity = $scope.curObj.opacity;
        } else if(prop == "angle"){
          $scope.selectedObj.setAngle(parseInt($scope.curObj.angle, 10)).setCoords();
        }
      }
      $scope.canvas.renderAll();
    }
    $scope.$on('hubColorPicker', function (event, args){
      if($scope.curObj.type == "text"){
        $scope.curObj.cType = args.type;
        $scope.curObj.tColor = args.color;
      } else if($scope.curObj.type == "obj"){
        $scope.curObj.bgType = args.type;
        $scope.curObj.bgColor = args.color;
      }
      $scope.setPropertiesFx($scope.curObj.type, "color");
    });

    /*Image Filters*/
    $scope.curImg = {};
    $scope.filterFx = function(type){
      $scope.selectedObj = $scope.canvas.getActiveObject();
      if($scope.selectedObj){
        if(type == "grayscale"){
          $scope.curImg.grayscale != $scope.curImg.grayscale;
          $scope.selectedObj.filters[0] = $scope.curImg.grayscale && new $scope.f.Grayscale();
        } else if(type == "invert"){
          $scope.curImg.invert != $scope.curImg.invert;
          $scope.selectedObj.filters[1] = $scope.curImg.invert && new $scope.f.Invert();
        } else if(type == "sepia1"){
          $scope.curImg.sepia1 != $scope.curImg.sepia1;
          $scope.selectedObj.filters[2] = $scope.curImg.sepia1 && new $scope.f.Sepia();
        } else if(type == "sepia2"){
          $scope.curImg.sepia2 != $scope.curImg.sepia2;
          $scope.selectedObj.filters[3] = $scope.curImg.sepia2 && new $scope.f.Sepia2();
        } else if(type == "emboss"){
          $scope.curImg.emboss != $scope.curImg.emboss;
          $scope.selectedObj.filters[4] = $scope.curImg.emboss && new $scope.f.Convolute({
            matrix:[1, 1, 1, 1, 0.7, -1, -1, -1, -1]
          });
        } else if(type == "blur"){
          $scope.curImg.blur != $scope.curImg.blur;
          $scope.selectedObj.filters[5] = $scope.curImg.blur && new $scope.f.Convolute({
             matrix:[1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9]
           });
        } else if(type == "sharpen"){
          $scope.curImg.sharpen != $scope.curImg.sharpen;
          $scope.selectedObj.filters[6] = $scope.curImg.sharpen && new $scope.f.Convolute({
            matrix:[0, -1, 0, -1, 5, -1, 0, -1, 0]
          });
        } else if(type == "brightness"){
          $scope.selectedObj.filters[7] = new $scope.f.Brightness({
            brightness:parseInt($scope.curImg.brightness, 10)
          });
        } else if(type == "contrast"){
          $scope.selectedObj.filters[8] = new $scope.f.Contrast({
            contrast:parseInt($scope.curImg.contrast, 10)
          });
        } else if(type == "saturation"){
          $scope.selectedObj.filters[9] = new $scope.f.Saturate({
            saturate:parseInt($scope.curImg.saturation, 10)
          });
        }
        $scope.selectedObj.applyFilters($scope.canvas.renderAll.bind($scope.canvas));
      }
    }

    $scope.resetFilterFx = function(){
      $scope.resetAry = [];
      if($scope.curImg.grayscale){
        $scope.curImg.grayscale = false;
        $scope.resetAry.push("grayscale");
      }
      if($scope.curImg.invert){
        $scope.curImg.invert = false;
        $scope.resetAry.push("invert");
      }
      if($scope.curImg.sepia1){
        $scope.curImg.sepia1 = false;
        $scope.resetAry.push("sepia1");
      }
      if($scope.curImg.sepia2){
        $scope.curImg.sepia2 = false;
        $scope.resetAry.push("sepia2");
      }
      if($scope.curImg.emboss){
        $scope.curImg.emboss = false;
        $scope.resetAry.push("emboss");
      }
      if($scope.curImg.blur){
        $scope.curImg.blur = false;
        $scope.resetAry.push("blur");
      }
      if($scope.curImg.sharpen){
        $scope.curImg.sharpen = false;
        $scope.resetAry.push("sharpen");
      }
      if($scope.curImg.brightness != undefined && $scope.curImg.brightness != 0){
        $scope.curImg.brightness = 0;
        $scope.resetAry.push("brightness");
      }
      if($scope.curImg.contrast != undefined && $scope.curImg.contrast != 0){
        $scope.curImg.contrast = 0;
        $scope.resetAry.push("contrast");
      }
      if($scope.curImg.saturation != undefined && $scope.curImg.saturation != 0){
        $scope.curImg.saturation = 0;
        $scope.resetAry.push("saturation");
      }

      angular.forEach($scope.resetAry, function(type){
        $scope.filterFx(type);
      });
    }

    $scope.valInArr = function(val, arr){
      for(var i = 0; i < arr.length; i++){
        if(arr[i].value == val) return arr[i];
      }
    }
    $scope.patient = function(){this.start}
    $scope.patient = new $scope.patient();

    /*Image Editor*/
    $scope.saveImageFx = function(caller){
      $scope.hasErr = false;
      $scope.canvas.deactivateAll().renderAll();
      if(caller == "new"){
        $scope.contentInfo.w = $scope.curObj.width
        $scope.contentInfo.h = $scope.curObj.height
        $scope.contentInfoCopy = angular.copy($scope.contentInfo);
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.p_cEdit.2" | translate | camelCase}}</h1></header>\
              <div class="panel-body">\
                <div class="form-group">\
                  <label for="label">{{"cl.p_cEdit.2" | translate}}</label>\
                  <input type="text" ng-model="contentInfoCopy.label" class="form-control" focus-me="true" id="label" aria-label="label" aria-labelledby="label">\
                </div>\
              </div>\
              <div class="panel-footer">\
                <span class="btnQuad">\
                  <button type="button" role="button" class="btn btn-success" ng-click="replaceImgFx(\'new\');"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                </span>\
                <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">{{"cl.msg.16" | translate}}</div>\
                <div class="clearfix"></div>\
              </div>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
        });
      } else{
        $scope.replaceImgFx('replace');
      }
    }
    $scope.replaceImgFx = function(caller){
      $scope.contentInfo.w = $scope.curObj.width
      $scope.contentInfo.h = $scope.curObj.height
      if(caller == "replace"){
        $scope.replaceProcessing = true;
        $scope.contentInfo.method = "replace";
      } else if(caller == "new"){
        if($scope.contentInfoCopy.label == ""){
          $scope.hasErr = true;
          return false;
        }
        $scope.contentInfo = $scope.contentInfoCopy;
        $scope.newProcessing = true;
        $scope.contentInfo.method = "new";
      }
      $scope.contentInfo.type = "image";
      $scope.confirmProcessing = true;
      $scope.saveProcessing = true;
      ngDialog.close();
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body text-center">\
              <div>{{"cm.msg.10" | translate}}</div>\
            </div>\
          </section>',
        plain:true,
        width:300,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
      html2canvas($("#canvas"), {
        onrendered:function(canvas){
          $scope.imgUrl = canvas.toDataURL("image/png");
          $scope.contentInfo.base64 = $scope.imgUrl;
          ContentLibrarySrv.updateImage($scope.contentInfo).then(
            function(data){
              ngDialog.close();
              $state.go("hub.contentLibrary.c");
            },
            function(err){
              $scope.confirmProcessing = false;
              $scope.replaceProcessing = false;
              $scope.saveProcessing = false;
              $scope.newProcessing = false;
              ngDialog.close();
              $log.error(err);
            }
          );
        }
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentLibraryWidgetController', ContentLibraryWidgetController);

  /** @ngInject */
  function ContentLibraryWidgetController($log, $rootScope, $scope, $state, $filter, ngDialog, SupportSrv, ContentLibraryWidgetsSrv){
    $rootScope.contentPermissionExpiryTemp.activePeriod = {type:"a"};
    $rootScope.selectedMenu = 1; //For LeftPanel Menu selected
    $rootScope.selectedCW = 2; //For upload content & widget tab selection
    $scope.listLoading = true;
    $scope.isListOpen = true;
    $scope.widgetList = {};
    $scope.widgetListArr = [];

    $scope.getWidgetListFx = function(){
      $scope.widgetListArr = [];
      angular.forEach($scope.widgetList, function(value, key){
        // if(value == "1" && key == "hdSteth"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.aNetPre.1"), state:".aNetPre", class:"hdSteth", tags:"active net preview, active"});
        // } else
        // TODO below code removed start
        // if(value == "1" && key == "agc"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.agc.1"), state:".agc", class:"agc"});
        // } else 
        // TODO below code removed end
        if(value == "1" && key == "achievers"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.achievers.1"), state:".achievers", class:"achievers", tags:"achievers"});
        } else if(value == "1" && key == "alertMsg"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.alert.1"), state:".alertMsg", class:"alertMsg"});
        } else if(value == "1" && key == "aqi"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.aqi.1"), state:".aqi", class:"aqi"});
        } else if(value == "1" && key == "amazonQuickSight"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.aqs.1"), state:".amazonQuickSight", class:"amazonQuickSight", tags:"Amazon QuickSight, amazon, QuickSight, quick sight"});
        } else if(value == "1" && key == "autoLogin"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.al.1"), state:".autoLogin", class:"autoLogin", tags:"Auto Login, Auto Login (Basic Auth), al"});
        } else if(value == "1" && key == "blank"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.bk.1"), state:".blank", class:"blank"});
        } else if(value == "1" && key == "ciscoMeraki"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.cisco.1"), state:".ciscoMeraki", class:"ciscoMeraki", tags:"cisco, cisco meraki"});
        } else if(value == "1" && key == "coe"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.coe.1"), state:".coe", class:"coe", tags:"calendar, events"});
        } else if(value == "1" && key == "cloudCoverMusic"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.ccm.1"), state:".cloudCoverMusic", class:"cloudCoverMusic", tags:"music, third party, 3rd party,Pandora CloudCover"});
        } else if(value == "1" && key == "comEvent"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.aNet.1"), state:".comEvent", class:"comEvent", tags:"active net, active, com events"});
        } else if(value == "1" && key == "contentGroup"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.cg.1"), state:".contentGroup", class:"contentGroup"});
        } else if(value == "1" && key == "contentOnDemand"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.cod.1"), state:".contentOnDemand", class:"contentOnDemand", tags:"content on demand, cod"});
        } else if(value == "1" && key == "button"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.codBtn.1"), state:".codButton", class:"contentOnDemandBtn", tags:"content on demand button, cod button, cod"});
        } else if(value == "1" && key == "count"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.count.1"), state:".count", class:"count"});
        } else if(value == "1" && key == "comPylonText"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.pylonText.1"), state:".comPylonText", class:"text", tags:"CoM Pylon Text"});
        } else if(value == "1" && key == "cloudFarm"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.clFarm.1"), state:".cloudFarm", class:"cloudFarm"});
        } else if(value == "1" && key == "dateTime"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.dt.1"), state:".dateTime", class:"dateTime"});
        } else if(value == "1" && key == "delimitedText"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.dText.1"), state:".delimitedText", class:"delimitedText", tags:"csv, excel, xls, xlsx"});
        } else if(value == "1" && key == "dynamicMenuBoard"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.dmb.1"), state:".dynamicMenuBoard", class:"dynamicMenuBoard", tags:"menu, menuboard, mb"});
        } else if(value == "1" && key == "excelSheet"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.es.1"), state:".excelSheet", class:"excelSheet", tags:"csv, excel, xls, xlsx"});
        } else if(value == "1" && key == "externalInput"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.ei.1"), state:".externalInput", class:"externalInput"});
        } else if(value == "1" && key == "facebook"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.fb.1"), state:".facebook", class:"facebook", tags:"social media meta"});
        } else if(value == "1" && key == "facebookWorkplace"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.fwp.1"), state:".facebookWorkplace", class:"facebookWorkplace", tags:"meta"});
          // TODO below code removed start
        // } else if(value == "1" && key == "fifa"){
        //   $scope.widgetListArr.push({label:$filter("translate")("FIFA World Cup"), state:".fifa", class:"fifa", tags:"sports, football"});
          // TODO below code removed end
        } else if(value == "1" && key == "fillerContent"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.fc.1"), state:".fillerContent", class:"fillerContent"});
        } else if(value == "1" && key == "flightSchedule"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.fs.1"), state:".flightSchedule", class:"flightSchedule", tags:"airport, airline"});
        } else if(value == "1" && key == "fsChrome"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.fsc.1"), state:".fsChrome", class:"fsChrome"});
        } else if(value == "1" && key == "f45"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.16"), state:".f45", class:"f45"});
        } else if(value == "1" && key == "f45CountdownCircle"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.2"), state:".countdownCircle", class:"countdownCircle", tags:"f45"});
        } else if(value == "1" && key == "f45ContentScroller"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.1"), state:".contentScroller", class:"contentScroller", tags:"f45"});
        } else if(value == "1" && key == "f45ContentTile"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.11"), state:".contentTile", class:"contentTile", tags:"f45"});
        } else if(value == "1" && key == "f45Hydrate"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.3"), state:".hydrate", class:"hydrate", tags:"f45"});
        } else if(value == "1" && key == "f45MoveStation"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.4"), state:".moveStation", class:"moveStation", tags:"f45"});
        } else if(value == "1" && key == "f45ProgressBar"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.5"), state:".f45progressBar", class:"progressBar", tags:"f45"});
        } else if(value == "1" && key == "f45Animation"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.18"), state:".animation", class:"animation", tags:"f45"});
        } else if(value == "1" && key == "f45ProgressBarWithBreak"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.6"), state:".progressBarWithBreak", class:"progressBarWithBreak", tags:"f45"});
        } else if(value == "1" && key == "f45Stay"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.13"), state:".stay", class:"stay", tags:"f45"});
        } else if(value == "1" && key == "f45Workout"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.14"), state:".story", class:"story", tags:"f45"});
        } else if(value == "1" && key == "f45Work"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wf45.12"), state:".work", class:"work", tags:"f45"});
        } else if(value == "1" && key == "freeForm"){
          $scope.widgetListArr.push({label:"Free Form", state:".freeForm", class:"freeForm"});
        } else if(value == "1" && key == "ftp"){
          $scope.widgetListArr.push({label:"FTP", state:".ftp", class:"ftp"});
        } else if(value == "1" && key == "gCalendar"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.gc.1"), state:".gCalendar", class:"gCalendar", tags:"google, calendar, events"});
        } else if(value == "1" && key == "gSlide"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.gs.1"), state:".gSlide", class:"gSlide", tags:"google, slide, presentation"});
        } else if(value == "1" && key == "grafana"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.grafana.1"), state:".grafana", class:"grafana", tags:"grafana"});
        } else if(value == "1" && key == "hdSteth"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.steth.1"), state:".hdSteth", class:"hdSteth", tags:"hd, steth"});
        } else if(value == "1" && key == "iFrame"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.iFrame.1"), state:".iFrame", class:"iframe", tags:"web"});
        } else if(value == "1" && key == "instagram"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.instagram.1"), state:".instagram", class:"instagram", tags:"social media, facebook, meta"});
        } else if(value == "1" && key == "intelCircuitBench"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.inC.1"), state:".intelCircuitRss", class:"intelCircuitRss", tags:"intel circuit bench, rss, circuit, intel, bench"});
          // TODO below code removed start
        // } else if(value == "1" && key == "iMenu"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.iMenu.1"), state:".iMenu", class:"iMenu"});
          // TODO below code removed end
        } else if(value == "1" && key == "iotButton"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.iot.1"), state:".iotButton", class:"iotButton", tags:"aws"});
        } else if(value == "1" && key == "intelJciMap"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.jci.1"), state:".jciMap", class:"jciMap", tags:"floor plan"});
        } else if(value == "1" && key == "intelSmartBuilding"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.isb.1"), state:".intelSmartBuilding", class:"intelSmartBuilding"});
        } else if(value == "1" && key == "linkedIn"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.in.1"), state:".linkedIn", class:"linkedIn", tags:"social media"});
        } else if(value == "1" && key == "liveStreaming"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.ls.1"), state:".liveStreaming", class:"liveStreaming", tags:"hls, youtube, live, rtmp, rtsp"});
        } else if(value == "1" && key == "meeting"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.meeting.1"), state:".meeting", class:"meeting", tags:"calendar, events"});
        } else if(value == "1" && key == "message"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.message.1"), state:".message", class:"message", tags:""});
        } else if(value == "1" && key == "msTeams"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.msTeams.1"), state:".msTeams", class:"msTeams", tags:"microsoft, office"});
        } else if(value == "1" && key == "musicChoice"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.mc.1"), state:".musicChoice", class:"musicchoice", tags:"music, third party, 3rd party"});
        } else if(value == "1" && key == "news"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.news.1"), state:".news", class:"news", tags:"bbc, cnn, cbc, espn, bing, fox news, us nuclear, crawling"});
        } else if(value == "1" && key == "nextBus"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.nb.1"), state:".nextBus", class:"nextBus", tags:""});
        } else if(value == "1" && key == "nextVehicle"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.nv.1"), state:".nextVehicle", class:"nextBus", tags:""});
        } else if(value == "1" && key == "onlineRadio"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.or.1"), state:".onlineRadio", class:"onlineRadio", tags:"onair"});
        } else if(value == "1" && key == "openHours"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.oh.1"), state:".openHours", class:"openHours", tags:"work hours"});
        } else if(value == "1" && key == "outlook"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.outlook.1"), state:".outlook", class:"outlook", tags:"microsoft, calendar, events, office"});
        } else if(value == "1" && key == "outlookCalendar"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.oc.1"), state:".outlookCalendar", class:"outlook", tags:"microsoft, calendar, events, office"});
        } else if(value == "1" && key == "progressBar"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.pb.1"), state:".progressBar", class:"progressBar", tags:"progress bar"});
        }else if(value == "1" && key == "patientWait"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.pw.1"), state:".patientWait", class:"patientWait", tags:"lifelabs"});
        } else if(value == "1" && key == "powerBI"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.pBI.1"), state:".powerBI", class:"powerBi", tags:"microsoft, analytics"});
        } else if(value == "1" && key == "prayer"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.prayer.1"), state:".prayer", class:"prayer", tags:"prayer"});
        } else if(value == "1" && key == "qlik"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.qlik.1"), state:".qlik", class:"qlik", tags:"qlik"});
        } else if(value == "1" && key == "queue"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.queue.1"), state:".queue", class:"queue", tags:""});
        } else if(value == "1" && key == "quotes"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.quotes.1s"), state:".quotes", class:"quotes", tags:""});
        } else if(value == "1" && key == "qrCode"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.qr.1"), state:".qrCode", class:"qrCode", tags:""});
        } else if(value == "1" && key == "readerboard"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget..1"), state:".readerboard", class:"readerBoard", tags:"hotel, meetings, events"});
        } else if(value == "1" && key == "rssFeed"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.rss.1"), state:".rssFeed", class:"rssFeed", tags:"crawling"});
        } else if(value == "1" && key == "scheduleCalendar"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.sc.1"), state:".scheduleCalendar", class:"scheduleCalendar"});
        } else if(value == "1" && key == "slack"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.slack.1"), state:".slack", class:"slack"});
        } else if(value == "1" && key == "firstup"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.sch.1"), state:".socialChorus", class:"socialChorus", tags:"social chorus, social, firstup, chorus"});
        } else if(value == "1" && key == "socialMedia"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.ssm.1"), state:".socialMedia", class:"socialMedia"});
        } else if(value == "1" && key == "stockPrice"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.sp.1"), state:".stockPrice", class:"stock", tags:"market, trading, share"});
        } else if(value == "1" && key == "storm"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.storm.1"), state:".storm", class:"storm", tags:"storm"});
        } else if(value == "1" && key == "survey"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.survey.1"), state:".survey", class:"survey"});
        } else if(value == "1" && key == "tableau"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tb.1"), state:".tableau", class:"tableau", tags:"analytics"});
        } else if(value == "1" && key == "telax"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.telax.1"), state:".telax", class:"telax"});
        } else if(value == "1" && key == "text"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.text.1"), state:".text", class:"text", tags:"crawling"});
        } else if(value == "1" && key == "teamsRoom"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tRoom.1"), state:".teamsRoom", class:"teamsRoom", tags:"microsoft, office, rooms"});
        } else if(value == "1" && key == "teamsChannel"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tChannel.1"), state:".teamsChannel", class:"teamsChannel", tags:"microsoft, office, channel, teams channel"});
          // TODO below code removed start
        // } else if(value == "1" && key == "touchlinkMeetings"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tl.1"), state:".touchlinkMeetings", class:"touchLink"});
          // TODO below code removed end
        } else if(value == "1" && key == "traffic"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.traffic.1"), state:".traffic", class:"traffic", tags:"road, map"});
          // TODO below code removed start
        // } else if(value == "1" && key == "trainingMode"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tm.1"), state:".trainingMode", class:"trainingMode"});
          // TODO below code removed end
        } else if(value == "1" && key == "tscCountryMile"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.tsccm.1"), state:".tsccm", class:"tsccm", tags:"tsc, cm, tsccm, country mile"});
        } else if(value == "1" && key == "twitter"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.twitter.1"), state:".twitter", class:"twitter", tags:"social media"});
          // TODO below code removed start
        // } else if(value == "1" && key == "unisys"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.unisys.1"), state:".unisys", class:"unisysIcon", tags:"disney, cruise"});
          // TODO below code removed end
        } else if(value == "1" && key == "vimeo"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.vimeo.1"), state:".vimeo", class:"vimeoIcon", tags:"social medi, video"});
          // TODO below code removed start
        // } else if(value == "1" && key == "wqMetro"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wqMetro.1"), state:".wqMetro", class:"wqMetro"});
          // TODO below code removed end
        }else if(value == "1" && key == "verkada"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.verkada.1"), state:".verkada", class:"verkada", tags:"verkada"});
        } else if(value == "1" && key == "weather"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.weather.1"), state:".weather", class:"weadher", tags:"forecast"});
        } else if(value == "1" && key == "webCam"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wc.1"), state:".webCam", class:"webCam"});
        } else if(value == "1" && key == "webLogin"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wl.1"), state:".webLogin", class:"webLogin"});
          // TODO below code removed start
        // } else if(value == "1" && key == "webLoginChrome"){
        //   $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wl.1.1"), state:".webLoginChrome", class:"webLogin", tags:"chrome"});
          // TODO below code removed end
        } else if(value == "1" && key == "webPage"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.wp.1"), state:".webPage", class:"webURL"});
        } else if(value == "1" && key == "webexByCisco"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.webex.1"), state:".webex", class:"webex"});
        } else if(value == "1" && key == "xovis"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.xovis.1"), state:".xovis", class:"xovis", tags:"3d camera, cctv, smart camera"});
        } else if(value == "1" && key == "yammer"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.yammer.1"), state:".yammer", class:"yammer", tags:"social media"});
        } else if(value == "1" && key == "youTube"){
          $scope.widgetListArr.push({label:$filter("translate")("cl.widget.youTube.1"), state:".youTube", class:"youTube", tags:"social media, video"});
        }
      })
    }
    ContentLibraryWidgetsSrv.getAll().then(
      function(data){
        $scope.listLoading = false;
        $scope.widgetList = data;
        $scope.getWidgetListFx();
      },
      function(err){
        $log.error(err);
      }
    );

    $scope.listOpenFx = function(){
      if($scope.isListOpen){
        $scope.isListOpen = false;
      } else{
        $scope.isListOpen = true;
      }
    }

    /*For Mail to Support*/
    $scope.mailSupportOpen = function(){
      $scope.savePopProcessing = false;
      $scope.hasPopErr = false;
      $scope.errPopType = "";
      $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
      ngDialog.open({
        template:"app/support/popup/mailToSupport.html",
        scope:$scope,
        closeByDocument:false,
        width:500
      });
    }
    $scope.saveMailSupportFx = function(){
      $scope.hasPopErr = false;
      $scope.errPopType = "";

      if(!$scope.mail.subject || $scope.mail.subject == ""){
        $scope.errPopType = "subject";
        $scope.hasPopErr = true;
      } else if(!$scope.mail.message || $scope.mail.message == ""){
        $scope.errPopType = "message";
        $scope.hasPopErr = true;
      } else{
        $scope.savePopProcessing = true;
        SupportSrv.saveMailSupport($scope.mail).then(
          function(data){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            ngDialog.close();
          },
          function(err){
            $scope.mail = {uid:$scope.auth.uid, subject:"", message:""};
            $scope.savePopProcessing = false;
            $log.error(err);
          }
        );
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentLibraryUploadController', ContentLibraryUploadController);

  /** @ngInject */
  function ContentLibraryUploadController($log, $rootScope, $scope, $state, $filter, ngDialog, $timeout, $cookies, ContentLibrarySrv){
    $rootScope.selectedMenu = 1;
    $rootScope.selectedCW = 1; //For upload content & widget selection
    $rootScope.tabView = true;

    $scope.splCharValidateRegExp = new RegExp(/^[^\\/:\*\?"<>\|]+$/);
    $scope.vidFormatRegExp = new RegExp("video");
    $scope.fileLabelArr = [];
    $scope.fileLabelStr = "";
    $scope.displayType = "";
    $scope.decId = "";
    $rootScope.uploadActive = false;
    $rootScope.uniqueGrp = {id: Math.random().toString(36).substring(2, 10) + new Date().getTime()};

    $scope.$on('flow::fileAdded', function(event, $flow){
      $rootScope.flowFiles = $flow.files;
      $timeout(function(){
        angular.forEach($flow.files, function(file, index){
          $scope.fileLabelStr = "";
          if(!file.extension){
            file.extension = file.name.split(".")[file.name.split(".").length - 1].toLowerCase();
          }
          if($rootScope.itemInArray($scope.supportedFiles, file.extension)){
            var isSP = false; //Storage plan
            if($scope.auth.strg.s && (file.size > $scope.auth.strg.s)){
              isSP = true;
              file.isSizeExceed = true;
            }
            if(!isSP){
              if($scope.auth.upermissions.vi && file.vi && (file.extension == "wmv" || file.extension == "webm" || file.extension == "vob" || file.extension == "mxf" || file.extension == "mpg" || file.extension == "mpeg" || file.extension == "mp4" || file.extension == "mov" || file.extension == "mkv" || file.extension == "m4v" || file.extension == "m2v" || file.extension == "flv" || file.extension == "f4v" || file.extension == "avi" || file.extension == "asf" || file.extension == "3gp")){
                file.vi = 1;
              }
              if($scope.auth.upermissions.vi && !file.vi && (file.extension == "wmv" || file.extension == "webm" || file.extension == "vob" || file.extension == "mxf" || file.extension == "mpg" || file.extension == "mpeg" || file.extension == "mp4" || file.extension == "mov" || file.extension == "mkv" || file.extension == "m4v" || file.extension == "m2v" || file.extension == "flv" || file.extension == "f4v" || file.extension == "avi" || file.extension == "asf" || file.extension == "3gp")){
                file.vi = 0;
              }
              if(!file.optimize){
                file.optimize = 1;
              }
              if(!file.isEdit){
                file.isEdit = false;
              }
              if(!file.label){
                $scope.fileLabelArr = file.name.split(".");
                for(var i=0; i<$scope.fileLabelArr.length - 1; i++){
                  if($scope.fileLabelStr == ""){
                    $scope.fileLabelStr = $scope.fileLabelArr[i];
                  } else{
                    $scope.fileLabelStr += "." + $scope.fileLabelArr[i];
                  }
                }
                file.label = $scope.fileLabelStr;
                file.tempLabel = $scope.fileLabelStr;
              }
              if(!file.isNameValid){
                file.isNameValid = true;
              }
            }
            file.unsupported = false;
          } else{
            file.unsupported = true;
          }
          if(file.exai){
            file.exai = false;
          }
        });
        $("#testLink").click();
      }, 200);
	  });

    $scope.fileCancel = function(cancelFile){
      if($rootScope.flowFiles.length == 0){
        $scope.isFileUploading = false;
      } else{
        $scope.isFileUploading = true;
      }
    }

    $scope.openEditName = function(index){
      $rootScope.flowFiles[index].isEdit = true;
    }

    $scope.cancelEditName = function(index){
      $rootScope.flowFiles[index].tempLabel = angular.copy($rootScope.flowFiles[index].label);
      $rootScope.flowFiles[index].isNameValid = true;
      $rootScope.flowFiles[index].isEdit = false;
    }

    $scope.saveEditName = function(index){
      if($scope.splCharValidateRegExp.test($rootScope.flowFiles[index].tempLabel)){
        $rootScope.flowFiles[index].label = angular.copy($rootScope.flowFiles[index].tempLabel);
        $rootScope.flowFiles[index].isNameValid = true;
        $rootScope.flowFiles[index].isEdit = false;
      } else{
        $rootScope.flowFiles[index].isNameValid = false;
      }
    }

    $rootScope.sendUnapproveNotification = function(idArr){
      ContentLibrarySrv.sendUnapproveNotification({id:idArr}).then(
        function(data){},
        function(err){}
      );
    }
  }
})();

angular.module('hub').config(function(flowFactoryProvider){
  flowFactoryProvider.defaults = {
    target:"/api/v1/contentlibrary/content",
    permanentErrors:[404, 500, 501],
    maxChunkRetries:1,
    chunkRetryInterval:5000,
    simultaneousUploads:4,
    chunkSize:1024 * 1024 * 10
    /* headers:{
        Accept:"application/json, text/plain, *",
        Authorization :"f7c34fc9f2c68df4bbab242d78d0060c",
        ContentType:"text/plain",
        Referer:"http://localhost:8080/flowjs2/samples/basic/"
    } */
    //headers:{Authorization :"60866cedcf9a2c93cd9de89f822e5064"}
  };
});

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('ContentLibraryController', ContentLibraryController);

  /** @ngInject */
  function ContentLibraryController($log, $rootScope, $scope, $state, $cookies,fancyboxService, vcRecaptchaService, $timeout, $filter, $sce, $document, $interval, $window, $location, ngDialog, CommonSrv, SchedulesSrv, ContentLibrarySrv, JciMapSrv){
    $rootScope.widgetsEdit = true;
    $rootScope.selectedMenu = 1;
    $scope.editForm = {isShow:false, isAdd:false, isEdit:false};
    $scope.downloadableObj = {type:"", label:"", thumb:"", url:"", surl:""};
    $scope.curExtn = {id:"", type:"", extn:""};
    $scope.curSort = {sortType:"", sortVal:""};
    $scope.odSp ={auth:false, breadCrumbs:[]};
    $scope.selectedTab = $state.current.name;
    $scope.timestamp = moment().format('x');
    $scope.contentLibraryLoading = true;
    $scope.reprocessRequested = false;
    $scope.confirmProcessing = false;
    $scope.previewLoading = false;
    $scope.saveProcessing = false;
    $scope.isConfirmOpen = false;
    $scope.isPSChecking = false;
    $scope.isSPContent = false;
    $scope.treeLoading = true;
    $scope.isPreview = false;
    $scope.groupType = "none";
    $scope.downloadUrl = "";
    $scope.filterCount = "";
    $scope.contentList = [];
    $scope.folderList = [];
    $scope.aiPreview = "";
    $scope.thumbSize = 'n'; //sm, n, md, lg, xl
    $scope.editorImg = "";
    $scope.filter = "all";
    $scope.treeList = [];
    $scope.sendObj = {};
    $scope.ftype = "cp";
    $rootScope.excelObj = "";
    $scope.delAIArr = [];

    // todo create a function which call first time and than call in the interval
    $scope.getVIStatusFx = function(arr){
      ContentLibrarySrv.getStatusVIndexer(arr).then(
        function(data){
          angular.forEach(data, function(object){
            angular.forEach($scope.contentList, function(obj){
              if(obj.type == 'Video' && obj.id == object.id){
                obj.viD.st = object.st;
                obj.viD.pc = object.pc;
                obj.viD.stpImg = object.stpImg;
                obj.viD.stpSt = object.stpSt;
              }
            })
            angular.forEach($scope.viProArr, function(value, i){
              if(value.id == object.id && object.st == 's'){
                $rootScope.toastNotificationFx("info", {code:1710102345});
                $scope.viProArr.splice(i, 1);
              }
            })
          })
          if(!$scope.viProArr.length){
            clearInterval($scope.viStatusProIntervalId);
            $scope.viStatusProIntervalId = null;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }


    // todo this variable for to get array which have process data
    $scope.viProArr = [];
    // $scope.viStripStatusArr = [];
    $scope.viStatusProIntervalId = null;
    // $scope.viStripStatusIntervalId = null;
    $scope.getStatusVIndexer = function(arr){
      if($scope.auth.upermissions.vi){
        $scope.getVIStatusFx(arr);
        $scope.viStatusProIntervalId = setInterval(function(){
          $scope.getVIStatusFx(arr);
        }, 25000)
      }
    }
    // $scope.getStatusStripImg = function(arr){
    //   if($scope.auth.upermissions.vi && $scope.selectedTab === "hub.contentLibrary.c"){        
    //     $scope.viStripStatusIntervalId = setInterval(function(){
    //       var arrString = arr.map(function(number) {
    //         return number.toString();
    //       });
    //       ContentLibrarySrv.getStatusStripImg(arrString).then(
    //         function(data){
    //           angular.forEach(data, function(object){
    //             angular.forEach($scope.contentList, function(obj){
    //               if(obj.type == 'Video' && obj.id == object.id && object.st){
    //                 obj.viD.stpSt = 1;
    //                 if($scope.contentBrief.id && $scope.contentBrief.id == object.id){
    //                   $scope.partyPoperTimeOut = null;
    //                   var briefImgElm = document.querySelector('.partyPoper');
    //                   briefImgElm.style.visibility = 'visible';
    //                   $scope.partyPoperTimeOut = setTimeout(function(){
    //                     briefImgElm.style.visibility = 'hidden';                        
    //                     clearInterval($scope.partyPoperTimeOut);
    //                     $scope.partyPoperTimeOut = null;
    //                   }, 2000)
    //                 }
    //               }
    //             })
    //             angular.forEach($scope.viStripStatusArr, function(id, i){
    //               if(id == object.id && object.st){
    //                 $scope.viStripStatusArr.splice(i, 1);
    //               }
    //             })
    //           })
    //           if(!$scope.viStripStatusArr.length){
    //             clearInterval($scope.viStripStatusIntervalId);
    //             $scope.viStripStatusIntervalId = null;
    //           }
    //         },
    //         function(err){
    //           $log.error(err);
    //         }
    //       );
    //     }, 5000)
    //   }
    // }
    $scope.getViProArr = function(arr){
      if($scope.auth.upermissions.vi){
        $scope.viProArr = [];
        $scope.viStripStatusArr = [];
        var tempViProArr = arr.filter(function(obj){
          if(obj.type == 'Video' && obj.vi && obj.viD.st == 'p'){
            return obj;
          }
        });
        // var tempStpStArr = arr.filter(function(obj){
        //   if(obj.type == 'Video' && obj.vi && obj.viD.st == 's' && !obj.viD.stpSt){
        //     return obj;
        //   }
        // });
        angular.forEach(tempViProArr, function(data){
          // $scope.viProArr.push(data.id);
          $scope.viProArr.push({id:data.id, vId:data.viD.id})
        })
        // angular.forEach(tempStpStArr, function(data){
        //   $scope.viStripStatusArr.push(data.id);
        // })
        setTimeout(function(){
          if($scope.viProArr.length){
            clearInterval($scope.viStatusProIntervalId);
            $scope.viStatusProIntervalId = null;
            $scope.getStatusVIndexer($scope.viProArr)
          }
          // if($scope.viStripStatusArr.length){
          //   clearInterval($scope.viStripStatusIntervalId);
          //   $scope.viStripStatusIntervalId = null;
          //   $scope.getStatusStripImg($scope.viStripStatusArr)
          // }
        }, 1000)
      }
    }

    // Remove from local storage
    localStorage.removeItem("clSchedule");
    localStorage.removeItem("clfSchedule");
    localStorage.removeItem("tSchedule");
    localStorage.removeItem("tfSchedule");
    localStorage.removeItem("tiSchedule");

    $scope.curHeight = {getHeight:0};
    $scope.setDisplayFx = function(size){
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.thumbSize = size;
      if(size == 'sm'){
        $scope.thumbParam = "&h=30&w=45&q=80&zc=3";
      } else if(size == 'n'){
        $scope.thumbParam = "&h=60&w=90&q=80&zc=3";
      } else if(size == 'md'){
        $scope.thumbParam = "&h=120&w=180&q=80&zc=3";
      } else if(size == 'lg'){
        $scope.thumbParam = "&h=135&w=215&q=80&zc=3";
      } else if(size == 'xl'){
        $scope.thumbParam = "&h=180&w=270&q=80&zc=3";
      }
      ContentLibrarySrv.setDisplaySize(size);
    }

    $scope.removeSelectedFx = function(){
      $('.ui-selectable li').each(function(){
        $(this).removeClass('ui-selected');
      });
    }

    $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
    $scope.curFolderId = localStorage.getItem("curFId");

    if(angular.isUndefined($scope.curFolderId)){
      $scope.curFolderId = 0;
    }
    if(angular.isUndefined($scope.curSPlObj)){
      $scope.curSPlObj = {id:0};
    }
    $scope.loadSelectedTab = function(caller){
      $scope.contentLibraryLoading = true;
      $scope.isPSChecking = false;
      $scope.odSp = {auth:false, breadCrumbs:[]};
      $timeout.cancel($scope.psTimer);
      $timeout.cancel($scope.promise);
      $rootScope.selectedItems = [];

      if(caller !== "sort"){
        $scope.advSearchInfo = {};
        $scope.advSearch = false;
      }
      $scope.searchText = "";
      $scope.filter = "all";
      $scope.psIds = [];

      if(caller == "refresh"){
        $rootScope.sessionTimoutFx();
        $rootScope.showTimeoutMsg = false;
        $scope.loadingMain = true;
        localStorage.removeItem("curPathId");

        angular.element('.ui-selectable li').removeClass('ui-highlight');
      }
      if($scope.curFolderId == 0){
        localStorage.setItem("inFolder", 0);
      }

      if($scope.selectedTab === "hub.contentLibrary.c"){
        $scope.tabName = "c";
        $rootScope.contentPermissionExpiryTemp.permission = {type:$scope.auth.upreferences.defaultP};

        //get stored adv search data after search
        $scope.curFilterObj = angular.fromJson(localStorage.getItem("curFilterObj"));
        $scope.curAdvSearchCopy = angular.fromJson(localStorage.getItem("curAdvSearchCopy"));
        $scope.isAdvSearch = localStorage.getItem("isAdvSearch");
        $scope.isWidgetEdited = localStorage.getItem("isWidgetEdited");
        //action like del, add to sch, replace, archive, and approve/unapprove
        $scope.isActionOnContent = localStorage.getItem("isActionOnContent");

        if(!$scope.curSPlObj || !$scope.curSPlObj.id){
          if(caller == "sort" && $scope.advSearch){
            CommonSrv.updateAdvSearchCL($scope.advObj).then(
              function(data){
                $rootScope.selectedItems = [];
                $scope.folderList = [];
                $scope.searchText = "";
                $scope.filterFx('all', true);
                $scope.contentList = data.content;
                // todo this  function to get process data of the video indexer
                $scope.getViProArr($scope.contentList);
                $scope.folderList = data.folder;
                $scope.contentLibrary.contentLibrary.content = data.content;
                $scope.contentLibrary.contentLibrary.folder = data.folder;
                $scope.contentLibrary.contentLibrary.groups = data.groups;
                $scope.filterCount = $scope.contentLibrary.contentLibrary.content.length;
                $scope.advSearchInfo = $scope.advSearchInfo;

                $scope.contentLibrary = {contentLibrary:{folder:data.folder, content:data.content, groups:data.groups}, info:data.info};
                $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
                if($scope.curPathId){
                  setTimeout(function(){
                    angular.forEach(angular.element('.ui-selectable li'), function(item){
                      if($(item).attr('data-id') == $scope.curPathId){
                        $(item).addClass('ui-highlight');
                      }
                    });
                  }, 100);
                }
                $scope.updateList();
                $scope.checkProcessStatus();
                $scope.selectedTreeItem($scope.curFolderId);
                /*ContextMenu*/
                $scope.contextMenuBaseFx();
              },
              function(err){
                $log.error(err);
                $scope.searchProcessing = false;
              }
            );
          } else{
            if(localStorage.getItem("isWidgetEdited")){
              localStorage.removeItem("isWidgetEdited");
            }
            if(localStorage.getItem("isActionOnContent")){
              localStorage.removeItem("isActionOnContent");
            }
            //store search state if edit
            if($scope.isWidgetEdited || $scope.isActionOnContent){
              if($scope.curAdvSearchCopy.type || $scope.curAdvSearchCopy.name || $scope.curAdvSearchCopy.creationRange || $scope.curAdvSearchCopy.createdBy){
                $scope.searchProcessing = true;
                $scope.curFilterObj = {name:$scope.curAdvSearchCopy.name, creationRange:$scope.curAdvSearchCopy.creationRange, creationDateRange:$scope.curAdvSearchCopy.creationDateRange, createdBy:$scope.curAdvSearchCopy.createdBy, type:$scope.curAdvSearchCopy.type, step:$scope.curAdvSearchCopy.step};
                //filter adv search with schedule type
                if(!angular.isUndefined($scope.curAdvSearchCopy.opt)){
                  $scope.curFilterObj.ls = $scope.curAdvSearchCopy.opt;
                }

                CommonSrv.updateAdvSearchCL($scope.curFilterObj).then(
                  function(data){
                    $scope.searchProcessing = false;
                    $scope.filteredData = data;

                    $scope.contentLibrary = {contentLibrary:{content:data.content, folder:data.folder}, info:data.info, rightKey:[]};
                    $scope.curAdvSearchCopy.isEmpty = data.isEmpty;
                    $scope.advSearchfilteredData = {info:$scope.curAdvSearchCopy, content:$scope.filteredData.content, folder:$scope.filteredData.folder, groups:$scope.filteredData.groups, code:data.code, advObj:$scope.curFilterObj};
                    $rootScope.$broadcast("advSearchfilteredData", $scope.advSearchfilteredData);
                    $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
                    if($scope.curPathId){
                      setTimeout(function(){
                        angular.forEach(angular.element('.ui-selectable li'), function(item){
                          if($(item).attr('data-id') == $scope.curPathId){
                            $(item).addClass('ui-highlight');
                          }
                        });
                      }, 100);
                    }
                    $scope.checkProcessStatus();
                  },
                  function(err){
                    $log.error(err);
                    $scope.searchProcessing = false;
                  }
                );
              }
            } else{
              localStorage.removeItem("isAdvSearch");
              localStorage.removeItem("curFilterObj");
              ContentLibrarySrv.getAll($scope.curFolderId).then(
                function(data){
                  if($scope.selectedTab === "hub.contentLibrary.c"){
                    if(data.code == 8197){
                      $scope.odSp.auth = true;
                      if(data.fType=="od"){
                        $scope.odSp.curType = "OneDrive";
                      } else if(data.fType=="sp"){
                        $scope.odSp.curType = "SharePoint";
                      } else if(data.fType=="sf"){
                        $scope.odSp.curType = "SharedFolder";
                      } else if(data.fType=="gd"){
                        $scope.odSp.curType = "Googledrive";
                      } else{
                        $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
                      }
                      $scope.odSp.breadCrumbs = data.info.breadCrumbs;
                    }
                    $scope.contentLibrary = data;

                    $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
                    if($scope.curPathId){
                      setTimeout(function(){
                        angular.forEach(angular.element('.ui-selectable li'), function(item){
                          if($(item).attr('data-id') == $scope.curPathId){
                            $(item).addClass('ui-highlight');
                          }
                        });
                      }, 100);
                    }
                    $scope.updateList();
                    $scope.checkProcessStatus();

                    $scope.selectedTreeItem($scope.curFolderId);
                    /*ContextMenu*/
                    $scope.contextMenuBaseFx();
                    $scope.loadingMain = false;
                  }
                },
                function(err){
                  $scope.loadingMain = false;
                  $log.error(err);
                }
              );
            }
          }
        } else{
          if($scope.curFolderId == 0){
            localStorage.removeItem('curSPlObj');
            $scope.curSPlObj = {};
          }
          ContentLibrarySrv.getAllSPL($scope.curFolderId, $scope.curSPlObj.id, $scope.curSPlObj.type).then(
            function(data){
              if(data.code == 8197){
                $scope.odSp.auth = true;
                if(data.fType=="od"){
                  $scope.odSp.curType = "OneDrive";
                } else if(data.fType=="sp"){
                  $scope.odSp.curType = "SharePoint";
                } else if(data.fType=="sf"){
                  $scope.odSp.curType = "SharedFolder";
                } else if(data.fType=="gd"){
                  $scope.odSp.curType = "Googledrive";
                } else{
                  $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
                }
                $scope.odSp.breadCrumbs = data.info.breadCrumbs;
              }
              $scope.contentLibrary = data;
              $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
              if($scope.curPathId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
              $scope.updateList();
              $scope.checkProcessStatus();

              $scope.selectedTreeItem($scope.curFolderId);
              /*ContextMenu*/
              $scope.contextMenuBaseFx();
            },
            function(err){
              $log.error(err);
            }
          );
        }
      } else if($scope.selectedTab === "hub.contentLibrary.uc"){
        $scope.tabName = "uc";
        ContentLibrarySrv.getUnapproved().then(
          function(data){
            if($scope.selectedTab === "hub.contentLibrary.uc"){
              $scope.contentLibrary = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
              if($scope.curPathId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.contentLibrary.ac"){
        $scope.tabName = "ac";
        ContentLibrarySrv.getArchived().then(
          function(data){
            if($scope.selectedTab === "hub.contentLibrary.ac"){
              $scope.contentLibrary = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
              if($scope.curPathId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.contentLibrary.ec"){
        $scope.tabName = "ec";
        ContentLibrarySrv.getExpired().then(
          function(data){
            if($scope.selectedTab === "hub.contentLibrary.ec"){
              $scope.contentLibrary = data;
              $scope.updateList();
              $scope.loadingMain = false;
              $scope.curPathId = angular.fromJson(localStorage.getItem("curPathId"));
              if($scope.curPathId){
                setTimeout(function(){
                  angular.forEach(angular.element('.ui-selectable li'), function(item){
                    if($(item).attr('data-id') == $scope.curPathId){
                      $(item).addClass('ui-highlight');
                    }
                  });
                }, 100);
              }
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      } else if($scope.selectedTab === "hub.contentLibrary.dc"){
        $scope.tabName = "dc";
        ContentLibrarySrv.getDeleted().then(
          function(data){
            if($scope.selectedTab === "hub.contentLibrary.dc"){
              $scope.contentLibrary = data;
              $scope.updateList();
              $scope.loadingMain = false;
            }
          },
          function(err){
            $scope.loadingMain = false;
            $log.error(err);
          }
        );
      }
    }
    $scope.loadSelectedTab();

    $scope.isSorting = true;

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2, fromContentLibrary){
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if(fromContentLibrary == "cList"){
        if($scope.curSort.sortType == sortType && $scope.curSort.sortVal == "asc"){
          sortVal = "desc";
        } else if($scope.curSort.sortType == sortType && $scope.curSort.sortVal == "desc"){
          sortVal = "asc";
        }
      }
      $scope.curSort = {sortType:sortType, sortVal:sortVal};
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $scope.loadSelectedTab("sort");
          $scope.reloadTree();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    // contentLibrary.info.groupType
    $scope.groupingFx = function(group){
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.groupType = group;
      CommonSrv.getCLGroups({val:$scope.groupType, module:"contentgroupby"}).then(
        function(data){
          $scope.loadSelectedTab("group");
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.groupFx = function(e, id, isExpand){
      isExpand = !isExpand;
      angular.forEach($scope.contentGroup, function(group){
        if(group.id == id){
          group.isExpand = isExpand;
        }
      });
      CommonSrv.setExpand({gid:id, groupType:$scope.groupType, isExpand:isExpand}).then(
        function(data){
          console.warn(data);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $rootScope.sendUnapproveNotification = function(idArr){
      ContentLibrarySrv.sendUnapproveNotification({id:idArr}).then(
        function(data){},
        function(err){}
      );
    }

    $scope.getTooltip = function(isApproved, expiring){
      if(!isApproved && !expiring && $scope.selectedTab !== "hub.contentLibrary.uc"){
        $scope.curTooltip = $filter("translate")('cl.tool.16');
      } else if(!isApproved && expiring && $scope.selectedTab !== "hub.contentLibrary.uc"){
        $scope.curTooltip = $filter("translate")('cl.tool.17');
      } else if((isApproved && expiring) || (!isApproved && expiring && $scope.selectedTab === "hub.contentLibrary.uc")){
        $scope.curTooltip = $filter("translate")('cl.tool.18');
      } else{
        $scope.curTooltip="";
      }
      return $scope.curTooltip;
    }

    $scope.updateList = function(){
      $scope.contentLibraryLoading = false;
      $scope.loadingMain = false;
      $rootScope.selectedItems = [];
      $scope.contentGroup = [];
      $scope.breadCrumbs = [];
      $scope.contentList = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.ftype = "cp";
      if($scope.contentLibrary.contentLibrary){
        $scope.filterCount = $scope.contentLibrary.contentLibrary.folder.length + $scope.contentLibrary.contentLibrary.content.length;
      }
      $scope.filterFx('all', false);

      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }

      $scope.thumbSize = $scope.contentLibrary.info.thumbSize;
      if($scope.thumbSize == 'sm'){
        $scope.thumbParam = "&h=30&w=45&q=80&zc=3";
      } else if($scope.thumbSize == 'n'){
        $scope.thumbParam = "&h=60&w=90&q=80&zc=3";
      } else if($scope.thumbSize == 'md'){
        $scope.thumbParam = "&h=120&w=180&q=80&zc=3";
      } else if($scope.thumbSize == 'lg'){
        $scope.thumbParam = "&h=135&w=215&q=80&zc=3";
      } else if($scope.thumbSize == 'xl'){
        $scope.thumbParam = "&h=180&w=270&q=80&zc=3";
      }

      $scope.groupType = $scope.contentLibrary.info.groupType;

      if($scope.contentLibrary.info.breadCrumbs){
        $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      }
      if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.folder){
        $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      }
      if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.content){
        $scope.contentList = $scope.contentLibrary.contentLibrary.content;
        // todo this  function to get process data of the video indexer
        $scope.getViProArr($scope.contentList);
      }

      if($scope.contentLibrary.contentLibrary && $scope.contentLibrary.contentLibrary.groups){
        $scope.contentGroup = $scope.contentLibrary.contentLibrary.groups;
      }
      if($scope.selectedTab == "hub.contentLibrary.c" && $scope.auth.upreferences.isTreeOpen){
        $scope.reloadTree();
      }

      $scope.curToken = $scope.contentLibrary.info.token?"&token="+$scope.contentLibrary.info.token:"";
      $scope.curSort = {sortType:$scope.contentLibrary.info.sortType, sortVal:$scope.contentLibrary.info.sortVal};

      $scope.curGroupId = angular.fromJson(localStorage.getItem("curGroupId"));
      if($scope.curGroupId){
        $scope.groupType = localStorage.getItem("curGroupType");
        $scope.groupFx("", $scope.curGroupId, false);
      }
    }

    $scope.$on("$stateChangeStart", function(event, toState){
      $scope.searchText = "";
      $state.current = toState;
      $scope.contentLibrary = {};
      $scope.contextMenuOpt = [];
      $scope.selectedTab = $state.current.name;
      $scope.curFolderId = localStorage.getItem("curFId");
      $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      $rootScope.contentPermissionExpiryTemp.activePeriod = {type:"a"};
      localStorage.removeItem("curPathId");
      localStorage.removeItem("curGroupId");
      localStorage.removeItem("curGroupType");

      //reset adv search data if state change without edit widget
      if(toState.name != "hub.contentLibrary.c" && !localStorage.getItem("isAdvSearch")){
        localStorage.removeItem("isAdvSearch");
        localStorage.removeItem("curFilterObj");
      }      
      clearInterval($scope.viStatusProIntervalId);
      $scope.viStatusProIntervalId = null;
      
      clearInterval($scope.viStripStatusIntervalId);
      $scope.viStripStatusIntervalId = null;
      $scope.loadSelectedTab();
    });

    $scope.checkProcessStatus = function(){
      $scope.psIds = [];
      if($scope.contentLibrary.contentLibrary){
        angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
          if(!item.isCompleted){
            $scope.psIds.push(item.id);
          }
        });
      }
      if($scope.psIds.length > 0){
        $scope.getProcessStatusFx();
      } else{
        $scope.isPSChecking = false;
      }
    }

    $scope.getProcessStatusFx = function(){
      if(!$scope.isPSChecking){
        $scope.isPSChecking = true;
        $scope.psTimer = $timeout(function(){
          ContentLibrarySrv.getProcessStatus($scope.psIds).then(
            function(data){
              if($scope.selectedTab === "hub.contentLibrary.c"){
                if($scope.contentLibrary.contentLibrary){
                  for(var i=0; i < $scope.contentLibrary.contentLibrary.content.length; ++i){
                    for(var j=0; j < data.content.length; ++j){
                      if(data.content[j].id === $scope.contentLibrary.contentLibrary.content[i].id){
                        $scope.contentLibrary.contentLibrary.content[i].isCompleted = data.content[j].isCompleted;
                        $scope.contentLibrary.contentLibrary.content[i].isblur = data.content[j].isblur;
                        $scope.contentLibrary.contentLibrary.content[i].isApproved = data.content[j].isApproved;
                        $scope.contentLibrary.contentLibrary.content[i].severityLevel = data.content[j].severityLevel;
                        if(data.content[j].duration){
                          $scope.contentLibrary.contentLibrary.content[i].duration = data.content[j].duration;
                        }
                        if(data.content[j].isCompleted){
                          $scope.contentLibrary.contentLibrary.content[i].thumb = data.content[j].thumb;
                          $scope.contentLibrary.contentLibrary.content[i].sUrl = data.content[j].sUrl;
                          $scope.contentLibrary.contentLibrary.content[i].url = data.content[j].url;
                          if($scope.contentLibrary.contentLibrary.content[i].vi){
                            if(data.content[j].vId == '' || !data.content[j].vId){
                              $scope.contentLibrary.contentLibrary.content[i].vi = 0;
                            } else{
                              $scope.contentLibrary.contentLibrary.content[i].viD = {id: data.content[j].vId, pc:0, st:"p", stpSt:0}
                              $scope.getViProArr($scope.contentLibrary.contentLibrary.content)
                            }
                          }
                        }
                      }
                    }
                  }
                }
                $scope.isPSChecking = false;
                $scope.checkProcessStatus();
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }, 10000);
      }
    }

    $rootScope.reloadTree = function(){
      $scope.curFolderId = localStorage.getItem("curFId");
      if(!$scope.curFolderId){
        $scope.curFolderId = 0;
      }
      $scope.treeLoading = true;
      setTimeout(function(){
        ContentLibrarySrv.getTree($scope.curFolderId).then(
          function(data){
            $scope.treeLoading = false;
            $scope.treeList = data.tree;
            $scope.favoritesList = data.favorites;
          });
      }, 800);
    }

    $rootScope.checkTree = function(){
      // if($scope.treeList == 1){
        $scope.treeLoading = true;
        $rootScope.reloadTree();
      // }
    }

    $rootScope.favoriteFx = function(id, type){
      var favObj = {type:type?"remove":"add",id:id}
      ContentLibrarySrv.updatefavoritefolders(favObj).then(
        function(data){
          $rootScope.reloadTree();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.selectedTreeItem = function(id){
      $(".tree-view a.home").removeClass("selected");
      $("div[data-tree-model] li span.selected").removeClass("selected");
      $("div[data-tree-model]").find("#" + id).children("span").addClass("selected");
      if(id == 0){
        $(".tree-view a.home").addClass("selected");
      }
    }

    $scope.folderContentFx = function(fId, splId, type){
      $scope.odSp = {auth:false, breadCrumbs:[]};
      $scope.contentLibraryLoading = true;
      $rootScope.showTimeoutMsg = false;
      $rootScope.selectedItems = [];
      $rootScope.sessionTimoutFx();

      localStorage.removeItem("curPathId");
      localStorage.removeItem('curSPlObj');
      localStorage.removeItem("curFId");

      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      $scope.curFolderId = 0;
      $scope.curSPlObj = {};

      //for OD & SP breadcrumb
      if(fId == 0){
        $scope.odSp.breadCrumbs = [];
      }
      if(fId){
        localStorage.setItem("curFId", fId);
        $scope.curFolderId = fId;
      }
      if(splId){
        localStorage.setItem('curSPlObj', JSON.stringify({id:splId, type:type}));
        $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      }

      if($scope.curFolderId == 0){
        localStorage.setItem("inFolder", 0);
        localStorage.removeItem("curPathFId");
      }

      if(splId && fId != splId){
        ContentLibrarySrv.getAllSPL($scope.curFolderId, $scope.curSPlObj.id, $scope.curSPlObj.type).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else if(data.fType=="gd"){
                $scope.odSp.curType = "Googledrive";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.selectedTreeItem($scope.curFolderId);
        ContentLibrarySrv.getAll($scope.curFolderId).then(
          function(data){
            if(data.code == 8197){
              $scope.odSp.auth = true;
              if(data.fType=="od"){
                $scope.odSp.curType = "OneDrive";
              } else if(data.fType=="sp"){
                $scope.odSp.curType = "SharePoint";
              } else if(data.fType=="sf"){
                $scope.odSp.curType = "SharedFolder";
              } else if(data.fType=="gd"){
                $scope.odSp.curType = "Googledrive";
              } else{
                $scope.odSp.curType = data.fType=="od"?"OneDrive":data.fType=="gd"?"Googledrive":"SharePoint";
              }
              $scope.odSp.breadCrumbs = data.info.breadCrumbs;
            }
            $scope.contentLibrary = data;
            $scope.updateList();
            $scope.contextMenuBaseFx();
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    /*For click on tree folder view*/
    $scope.$on('treeId', function(event, treeFolderId, splId, type, treeId){
      if(treeId != "sharedFolderList"){
        if(treeFolderId.toString().split("|").length > 1){
          $rootScope.selectedSPfId = treeFolderId;
        } else if(type == "SharedFolder"){
          $scope.folderContentFx(treeFolderId, splId, "sharedfolder");
        } else{
          $scope.ftype = "cp";
          $scope.folderContentFx(treeFolderId);
        }
      }
    });

    $scope.folderBriefFx = function(obj){ /*Get folder briefs*/
      $scope.contentBtn = [];
      $scope.contentBrief = [];
      $scope.contextMenuOpt = [];
      $timeout.cancel($scope.promise);
      localStorage.removeItem("curPathId");

      angular.element('.ui-selectable li').removeClass('ui-highlight');
      ContentLibrarySrv.getFolderBrief(obj[0].id, obj[0].splId, obj[0].type).then(
        function(data){
          $scope.contentBrief = data;
          if($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type != "folder"){/*Button api*/
            $scope.getBtnFx("c");
          }
        },
        function(err){
          $log.error(err);
        }
      );
      /*Button api*/
      if($scope.selectedTab === "hub.contentLibrary.c" && obj[0].type == "folder"){
        $scope.getBtnFx("c");
      } else if($scope.selectedTab === "hub.contentLibrary.ac"){
        $scope.getBtnFx("ac");
      } else if($scope.selectedTab === "hub.contentLibrary.dc"){
        $scope.getBtnFx("dc");
      }
    }

    $scope.briefFx = function(selectedItems){ /*Get content briefs*/
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.timestamp = moment().format('x');
      localStorage.removeItem("curPathId");
      $timeout.cancel($scope.promise);
      $scope.isContentDeleted = 0;
      $scope.isSPContent = false;
      $scope.contextMenuOpt=[];
      $scope.contentBrief=[];
      $scope.contentBtn=[];
      $rootScope.excelObj=[];

      if(selectedItems.length == 1){
        $scope.isIncompleteVideo = false;
        for(var i=0; i < $scope.contentList.length; i++){
          if($scope.contentList[i].id == selectedItems[0].id){
            if(($scope.contentList[i].thumb == "" && $scope.contentList[i].type == "Video") || ($scope.contentList[i].isCompleted == "" && $scope.contentList[i].type == "Widget" && ($scope.contentList[i].extn == "Crawling Text" || $scope.contentList[i].extn == "Static Text")) || ($scope.contentList[i].isCompleted == "" && $scope.contentList[i].type == "Image" && $scope.contentList[i].extn == "WEBP") || ($scope.contentList[i].isCompleted == "" && $scope.contentList[i].type == "WORD") || ($scope.contentList[i].isCompleted == "" && $scope.contentList[i].type == "POWERPOINT") || ($scope.contentList[i].isCompleted == "" && $scope.contentList[i].type == "Vector")){
              $scope.isIncompleteVideo = true;
            }
            break;
          }
        }
        console.warn(selectedItems[0].type);
        
        if(selectedItems[0].type == "SharePointC" || selectedItems[0].type == "OneDriveC" || selectedItems[0].type == "SharedFolderC" || selectedItems[0].type == "GoogleDriveC"){
          $scope.contentBrief = {id:selectedItems[0].id, mt:0};
          $scope.contentBtn = {info:[],buttons:[]};
          $scope.isSPContent = true;
          if($scope.auth.upermissions.s){
            $scope.contentBtn.buttons.push({key:"clSchedule",label:"Schedule"});
          }
          if($scope.auth.upermissions.se.c){
            $scope.contentBtn.buttons.push({key:"clAddToSchedule",label:"Add to Schedule"});
          }
        } else{
          $scope.qrThumbLoading = true;
          ContentLibrarySrv.getContentBrief(selectedItems[0].id, $scope.isIncompleteVideo).then(
            function(data){
              $scope.qrThumbLoading = false;
              $scope.contentBrief = data;
              if($scope.contentBrief.percent != undefined){
                $scope.promise = $timeout(checkVidLoad, 5000);
              }
              if($scope.contentBrief.isContentDeleted){
                $scope.isContentDeleted = 1;
              }
              $scope.wVer = $scope.contentBrief.wVer;
            },
            function(err){
              $scope.qrThumbLoading = false;
              $log.error(err);
            }
          );
        }
      }
      /*Button api*/
      if(!$scope.isSPContent){
        if($scope.selectedTab === "hub.contentLibrary.c"){
          $scope.getBtnFx("c", selectedItems);
        } else if($scope.selectedTab === "hub.contentLibrary.uc"){
          $scope.getBtnFx("uc");
        } else if($scope.selectedTab === "hub.contentLibrary.ec"){
          $scope.getBtnFx("ec");
        } else if($scope.selectedTab === "hub.contentLibrary.ac"){
          $scope.getBtnFx("ac");
        } else if($scope.selectedTab === "hub.contentLibrary.dc"){
          $scope.getBtnFx("dc");
        }
      }
    }

    $scope.getBtnFx = function(caller, selItem){/*Button api*/
      if($rootScope.selectedItems.length){
        angular.forEach($rootScope.selectedItems, function(item){
          if(!item.isBlur){
            delete item.isBlur;
          }
        })
      }
      if(caller == "c"){
        angular.forEach($scope.contentLibrary.contentLibrary.folder, function(folder){
          angular.forEach($rootScope.selectedItems, function(item){
            if(folder.id == item.id){
              item.pid = folder.pid;
            }
          });
        });

        if($scope.contentLibrary.contentLibrary.content.length){
          $scope.contentLibrary.contentLibrary.content.forEach(function(content){
            if(selItem && content.id == selItem[0].id && content.isblur){
              $rootScope.selectedItems[0].isBlur = 1;
            }
          });
        }
        ContentLibrarySrv.getApproveBtn($rootScope.selectedItems).then(
          function(data){
            $scope.contentBtn = data;
            $scope.updateContextMenu($scope.contentBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "uc"){
        ContentLibrarySrv.getUnapproveBtn($rootScope.selectedItems).then(
          function(data){
            $scope.contentBtn = data;
            $scope.updateContextMenu($scope.contentBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "ec"){
        ContentLibrarySrv.getExprieBtn($rootScope.selectedItems).then(
          function(data){
            $scope.contentBtn = data;
            $scope.updateContextMenu($scope.contentBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "ac"){
        ContentLibrarySrv.getArchiveBtn($rootScope.selectedItems).then(
          function(data){
            $scope.contentBtn = data;
            $scope.updateContextMenu($scope.contentBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      } else if(caller == "dc"){
        ContentLibrarySrv.getDeleteBtn($rootScope.selectedItems).then(
          function(data){
            $scope.contentBtn = data;
            $scope.updateContextMenu($scope.contentBtn);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.btnInfoOpen = function(btnInfo){
      $scope.btnInfo = btnInfo;
      ngDialog.open({
        template:"app/contentLibrary/popup/btnInfo.html",
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }

    /*ContextMenu*/
    $scope.updateContextMenu = function(menuList){
      $scope.contextMenuOpt = [];
      angular.forEach(menuList.buttons, function(menuItem){
        if(menuItem.key=="clOpenFolder"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.8'); //menuItem.label;
        } else if(menuItem.key == "clEdit"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.22');
        } else if(menuItem.key=="clReplace"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.26');
        } else if(menuItem.key=="clMove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.50');
        } else if(menuItem.key=="clDownload"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.17');
        } else if(menuItem.key=="clArchive"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.7');
        } else if(menuItem.key=="clApprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.24');
        } else if(menuItem.key=="clUnapprove"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.25');
        } else if(menuItem.key=="clSchedule"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.27');
        } else if(menuItem.key=="clAddToSchedule"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.28');
        } else if(menuItem.key=="clShortcut"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.17');
        }  else if(menuItem.key=="clOpenImgEditor"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.9');
        } else if(menuItem.key=="clOpenVidEditor"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.10');
        } else if(menuItem.key=="clRemoveExpiry"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.11');
        } else if(menuItem.key=="clDelete"){
          $scope.menuItemLabel = $filter("translate")('cm.btn.13');
        } else if(menuItem.key=="clRestore"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.12');
        } else if(menuItem.key=="clPermanentlyDelete"){
          $scope.menuItemLabel = $filter("translate")('cl.btn.13');
        } else if(menuItem.key=="clPinItems"){
          $scope.menuItemLabel = $filter("translate")('cm.label.98');
        } else if(menuItem.key=="clUnpin"){
          $scope.menuItemLabel = $filter("translate")('cm.label.99');
        }

        $scope.curIndex = $scope.contextMenuOpt.length;
        $scope.contextMenuOpt.push([$scope.menuItemLabel, function($itemScope){$scope.contextMenuFx(menuItem);}]);
      });

    }

    $scope.contextMenuFx = function(menuItem){
      if(menuItem.key == "clOpenFolder"){
        $scope.folderContentFx($scope.contentBrief.id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type);
      } else if(menuItem.key=="clEdit"){
        $scope.editFx();
      } else if(menuItem.key=="clReplace"){
        $scope.replaceOpen();
      } else if(menuItem.key=="clMove"){
        $scope.moveOpen($scope.contentBrief.id);
      } else if(menuItem.key=="clDownload"){
        $scope.downloadOpen();
      } else if(menuItem.key=="clSDownload"){
        $scope.downloadOpen("source");
      } else if(menuItem.key=="clArchive"){
        $scope.confirmOpen('archive');
      } else if(menuItem.key=="clApprove"){
        $scope.approveFx();
      } else if(menuItem.key=="clUnapprove"){
        $scope.confirmOpen('unapprove');
      } else if(menuItem.key=="clShortcut"){
        $scope.shortcutFx();
      } else if(menuItem.key=="clSchedule"){
        $scope.scheduleFx();
      } else if(menuItem.key=="clAddToSchedule"){
        $scope.addToScheduleOpen($scope.contentBrief.id);
      } else if(menuItem.key=="clOpenImgEditor"){
        $scope.openImgEditor($scope.contentBrief.id);
      } else if(menuItem.key=="clOpenVidEditor"){
        $scope.openCapVidEditor($scope.contentBrief.id);
      } else if(menuItem.key=="clRemoveExpiry"){
        $scope.removeExpiryFx();
      } else if(menuItem.key=="clDelete"){
        $scope.confirmOpen('delete');
      } else if(menuItem.key=="clRestore"){
        $scope.restoreFx();
      } else if(menuItem.key=="clPermanentlyDelete"){
        $scope.confirmOpen('pDelete');
      } else if(menuItem.key=="clPinItems"){
        $scope.pinToDBFx($rootScope.selectedItems, "c");
      }
    }

    /*ContextMenu*/
    $scope.contextMenuBaseFx = function(){
      $scope.contextMenuBase=[];
      if(($scope.contentLibrary.info.writable && $scope.auth.upermissions.c && $scope.auth.upermissions.w) || ($scope.contentLibrary.info.writable && $scope.auth.upermissions.c)){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.1"), function($itemScope){$state.go("hub.contentAdd.contentAddTab");}]);
      } else if($scope.contentLibrary.info.writable && $scope.auth.upermissions.w && !$scope.auth.upermissions.c){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.2"), function($itemScope){$state.go("hub.contentAdd.widgetAddTab.dateTime");}]);
      }
      if($scope.contentLibrary.info.writable && $scope.auth.upermissions.c && $scope.auth.upermissions.ai && $scope.auth.upermissions.ai_img){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.24"), function($itemScope){$scope.aiPopupOpen();}]);
      }
      if($scope.contentLibrary.info.writable && $scope.auth.upermissions.cf){
        $scope.contextMenuBase.push([$filter("translate")("cl.btn.3"), function($itemScope){$scope.folderCUOpen('n');}]);
      }
    }

    $scope.filterFx = function(type, close){
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      if(close && !$scope.isWidgetEdited && !$scope.isActionOnContent){
        $rootScope.closeAllFx();
      }
      $scope.filter = type;
      if($scope.contentLibrary.contentLibrary){
        if(type == 'all'){
          $scope.filterCount = $scope.contentLibrary.contentLibrary.folder.length + $scope.contentLibrary.contentLibrary.content.length;
        } else if(type == 'myContent'){
          $scope.filterCount = $filter("filter")($scope.contentLibrary.contentLibrary.content, {owner:1}).length;
        } else if(type == 'approved'){
          $scope.filterCount = $filter("filter")($scope.contentLibrary.contentLibrary.content, {isApproved:1}).length;
        } else if(type == 'unapproved'){
          $scope.filterCount = $filter("filter")($scope.contentLibrary.contentLibrary.content, {isApproved:0}).length;
        } else{
          $scope.filterCount = $filter("filter")($scope.contentLibrary.contentLibrary.content, {type:type}).length;
        }
      }
    }

    /*ngSwitch*/
    $scope.writeProtectedFx = function(id){
      $scope.treeLoading = true;
      ContentLibrarySrv.writeProtected(id).then(
        function(data){
          $scope.reloadTree();
          if($scope.treeLoading == false){
            $scope.contentBrief.wp = data.wp;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    var checkVidLoad = function(){
      if($rootScope.selectedMenu != 1){
        $timeout.cancel($scope.promise);
      }
      ContentLibrarySrv.getVideoLoad($scope.contentBrief.id).then(
        function(data){
          $scope.contentBrief.percent = data.percent;
          if($scope.contentBrief.percent != undefined && $scope.contentBrief.percent != 100){
            $scope.promise = $timeout(checkVidLoad, 5000);
          } else if($scope.contentBrief.percent == 100){
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.reprocessVideoFx = function(id, optimize){
      $scope.reprocessRequested = true;
      ContentLibrarySrv.reprocessVideo(id, optimize).then(
        function(data){
          $scope.reprocessRequested = false;
          if(optimize){
            ngDialog.close();
            $scope.loadSelectedTab();
          }
        },
        function(err){
          $scope.reprocessRequested = false;
          $log.error(err);
        }
      );
    }

    /*ngDialog*/
    $scope.folderCUOpen = function(type, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $rootScope.curFType = type;
      $scope.folderObj = {fType:type};
      if(caller == "edit"){
        $scope.folderObj.label = $scope.contentBrief.label;
        $scope.folderObj.id = $scope.contentBrief.id;
      } else{
        $scope.folderObj.fid = $scope.curFolderId;
      }

      if(type == "sf"){
        $scope.folderLoading = true;
        $scope.serverList = [];
        ContentLibrarySrv.getServersList().then(
          function(data){
            $scope.serverList = data.servers;
            $scope.folderLoading = false;
          },
          function(err){
            $log.error(err);
            $scope.folderLoading = false;
          }
        );
      }

      if($scope.curSPlObj && $scope.curSPlObj.id){
        $scope.folderObj.fid = $scope.curSPlObj.id;
      }

      ngDialog.open({
        template:"app/contentLibrary/popup/folderCU.html",
        width:620,
        scope:$scope,
        data:$scope.folderObj,
        closeByDocument:false,
        controller:"FolderCUController",
      });
    }
    $scope.moveOpen = function(caller){
      $rootScope.curFType = "move";
      $scope.folderListStr = "";
      $scope.scFolderListStr = "";
      $scope.isShortcut = false;
      angular.forEach($scope.selectedItems, function(item){
        if(item.type == "folder" || item.type == "shortcut" || item.type == "sharedfolder"){
          if($scope.folderListStr == "" && item.type != "shortcut"){
            $scope.folderListStr = "/" + item.id;
          } else if($scope.scFolderListStr == "" && item.type == "shortcut"){
            $scope.scFolderListStr = "?scutIds=" + item.id;
          } else{
            if(item.type == "shortcut"){
              $scope.scFolderListStr += "," + item.id;
            } else {
              $scope.folderListStr += "," + item.id;
            }
          }
        }
        if(item.type == "shortcut"){
          $scope.isShortcut = true;
        }
      });

      $scope.curMoveObj = [];
      ContentLibrarySrv.getMoveTree($scope.folderListStr + $scope.scFolderListStr).then(
        function(data){
          $scope.moveObj = {type:"move", server:null, curServerTree:data.tree, isShortcut:$scope.isShortcut};
          ngDialog.open({
            template:"app/contentLibrary/popup/move.html",
            width:580,
            scope:$scope,
            data:$scope.moveObj,
            closeByDocument:false,
            controller:"MoveController"
          });
        }
      );
    }

    $scope.aiOptions = {"style":["Natural","Vivid"],"quality":["HD","Standard"],"res":["1024 x 1024","1024 x 1792","1792 x 1024"],"price":{"standard":{"1024 x 1024":"$0.040 / image","1024 x 1792":"$0.080 / image","1792 x 1024":"$0.080 / image"},"hd":{"1024 x 1024":"$0.080 / image","1024 x 1792":"$0.120 / image","1792 x 1024":"$0.120 / image"}}};
    $scope.aiPopupOpen = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.delAIArr = [];
      $scope.aiObj = {prompt:"", style:"Natural", quality:"Standard", res:"1024 x 1024", price:"", activePeriod : {type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
      $scope.aiPreview = "";
      $scope.isPreview = false;

      $scope.selPriceFx();
      ngDialog.open({
        template:"app/contentLibrary/popup/generateAI.html",
        width:1160,
        scope:$scope,
        data:$scope.folderObj,
        closeByDocument:false,
        closeByEscape:false,
      });
    }
    $scope.selPriceFx = function(){
      if($scope.aiObj.quality=="Standard"){
        $scope.aiObj.price = $scope.aiOptions.price.standard[$scope.aiObj.res];
      } else {
        $scope.aiObj.price = $scope.aiOptions.price.hd[$scope.aiObj.res];
      }
    }
    $scope.genImgFx = function(obj, caller){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.isPreview = false;
      if($scope.aiObj.prompt == ""){
        $scope.errType = "prompt";
        $scope.hasErr = true;
        $("#prompt").focus();
      } else {
        // $scope.permissionFx('save');
        $scope.previewLoading = true;
        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.genImage();
          }, 250);
        } else{
          $scope.genImage();
        }

      }
    }
    $scope.genImage = function(caller){
      $scope.aiObj.domainType = $scope.getDomain();
      ContentLibrarySrv.aiPreview($scope.aiObj).then(
        function(data){
          $scope.previewLoading = false;
          $scope.generateProcessing = false;
          $scope.isPreview = (caller=='save') ? false : true;
          if(data.code == 99003){
            $scope.hasErr = true;
            $scope.errType = "genErr";
            $scope.isPreview = false;
            $scope.aiPreview = "";
            $("#prompt").focus();
          } else {
            $scope.aiPreview = data;
            $scope.cBucket = $scope.cDetailBucket = $scope.aiPreview.bucket;
            if($scope.aiPreview.mbucket && $scope.aiPreview.mbucket != ""){
              $scope.cDetailBucket = $scope.aiPreview.mbucket;
            }
            $scope.tim = $scope.aiPreview.timthumb;
          }
          if(caller != 'save'){
            $scope.fileName = $scope.getImageName($scope.aiPreview.url, 'save');
            $scope.delAIArr.push($scope.fileName);
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      )
    }
    $scope.saveAIFx = function(){
      $scope.tmpObj = {};
      $scope.fileName = "";
      if($scope.aiObj.prompt == ""){
        $scope.errType = "prompt";
        $scope.hasErr = true;
        $("#prompt").focus();
      } else {

        if($rootScope.activePeriodOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('saveActivePeriod',{});
        }
        if($rootScope.isPermissionOpen){
          $scope.isPEOpen = true;
          $rootScope.$broadcast('savePermission',{});
        }
        if($scope.isPEOpen){
          $timeout(function(){
            $scope.saveImg($scope.aiObj);
          }, 250);
        } else{
          $scope.saveImg($scope.aiObj);
        }
      }
    }
    $scope.saveImg = function(aiObj){
      $scope.tmpObj.permissionType = aiObj.permission.type;
      $scope.tmpObj.activeType = aiObj.activePeriod.type;
      $scope.tmpObj.fid = localStorage.getItem("curFId");
      $scope.tmpObj.startDate = "";
      $scope.tmpObj.endDate = "";
      $scope.tmpObj.groups = "";
      $scope.tmpObj.time = "";

      if(aiObj.activePeriod.type == "c"){
        $scope.tmpObj.time = aiObj.activePeriod.time;
        $scope.tmpObj.startDate = aiObj.activePeriod.date.startDate;
        $scope.tmpObj.endDate = aiObj.activePeriod.date.endDate;
      }

      if(aiObj.permission.type == "c"){
        angular.forEach(aiObj.permission.groups, function(group){
          if($scope.tmpObj.groups.length == 0){
            $scope.tmpObj.groups = group.id;
          } else{
            $scope.tmpObj.groups += "," + group.id;
          }
        });
      }

      $scope.fileName = $scope.getImageName($scope.aiPreview.url, 'save');
      $scope.finalObj = {info:$scope.tmpObj, filename:$scope.fileName};
      $scope.finalObj.domainType = $scope.getDomain();
      $scope.saveProcessing = true;
      $scope.previewLoading = false;
      $scope.finalObj.delArr = $scope.delAIArr.slice(0, -1);

      ContentLibrarySrv.saveAIImage($scope.finalObj).then(
        function(data){
          if(!data.isApproved){
            $rootScope.sendUnapproveNotification({id:[data.id], isApproved:false});
          } else {
            $rootScope.sendUnapproveNotification({id:[], isApproved:true});
          }
          $scope.loadSelectedTab();
          ngDialog.close();
          $scope.saveProcessing = false;
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      )
    }
    $scope.getDomain = function(){
      var fullUrl = $location.absUrl();
      // Use the URL constructor to parse the URL
      var parsedUrl = new URL(fullUrl);
      // Access the hostname property to get the domain
      var domain = parsedUrl.hostname;
      // Extract text between "//" and the first dot
      var startIndex = domain.indexOf("//") + 1; // Find the index after "//"
      var endIndex = domain.indexOf("."); // Find the index of the first dot
      return domain.substring(startIndex, endIndex);
    }
    $scope.resetAIFx = function(){
      $scope.aiObj = {prompt:"", style:"Natural", quality:"Standard", res:"1024 x 1024", price:"", activePeriod : {type:"a"}, permission:{type:$scope.auth.upreferences.defaultP}};
      $scope.aiPreview = "";
      $scope.isPreview = false;
      $scope.selPriceFx();
    }
    $scope.getImageName = function(url, caller){
      $scope.splitArray = url.split("/");
      $scope.fileName = $scope.splitArray[$scope.splitArray.length - 1];
      return $scope.fileName;
    }
    $scope.genPopupOpen = function(){
      $scope.hasErrPopDP = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.imgGenObj = {processing:false, pass:"", isSession:false};
      if($scope.aiObj.prompt == ""){
        $scope.errType = "prompt";
        $scope.hasErr = true;
        $("#prompt").focus();
      } else {
        if(localStorage.getItem('askSession')){
          $scope.imgGenObj.isSession = true;
          $scope.genImgFx();
        } else {
          if($scope.aiPreview == ''){
            $scope.dialogId = ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <header class="panel-heading text-bold"><h1 role="heading" aria-level="1">{{"cl.ai.5" | translate}}</h1></header>\
                  <div class="panel-body">\
                    <div>{{"cl.ai.m2" | translate}}</div>\
                    <div class="form-group marT15">\
                      <div><label for="agreeeToPay"><input type="checkbox" role="checkbox" aria-labelledby="agreeeToPay" id="agreeeToPay" ng-model="imgGenObj.agreeToPay"><label></label>{{"cl.ai.8"  | translate}} <span class="text-danger">*</span></label></div>\
                      <label class="marT10" for="pass" ng-if="!sso && !msal">{{\'cl.widget.telax.9.3\' | translate}}</label>\
                      <input type="password" id="pass" autocomplete="new-password" class="form-control" ng-model="imgGenObj.pass" ng-if="!sso && !msal" aria-label="{{\'cl.widget.telax.9.3\' | translate}}" aria-labelledby="{{\'cl.widget.telax.9.3\' | translate}}">\
                      <div class="marT10"><label for="askSession"><input type="checkbox" role="checkbox" aria-labelledby="askSession" id="askSession" ng-model="imgGenObj.isSession"><label></label>{{\'cl.ai.6\' | translate}}</label></div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-success btn-sm" ng-click="validatePassFx();" focus-me="true" ng-disabled="imgGenObj.processing || !imgGenObj.agreeToPay"><span class="fa fa-repeat fa-spin" ng-if="imgGenObj.processing" aria-hidden="true"></span>{{"cl.btn.26" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                    <div class="errMsg pull-right" ng-if="hasErrPopDP" aria-live="polite" role="status">\
                      <span ng-if="errType==\'emptyPass\'" aria-live="polite" role="status">{{\'lock.m1\' | translate}}</span>\
                      <span ng-if="errType==\'invPass\'" aria-live="polite" role="status">{{\'cl.widget.oc.m10\' | translate}}</span>\
                    </div>\
                  </footer>\
                </section>',
              plain:true,
              width:600,
              scope:$scope,
              closeByDocument:false,
              preCloseCallback:function(){
                $scope.generateProcessing = false;
              },
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else {
            $scope.genImgFx();
          }
        }
      }
    }
    $scope.validatePassFx = function(){
      $scope.hasErrPopDP = false;
      $scope.errType = "";
      if(!$rootScope.sso && !$scope.msal){
        if($scope.imgGenObj.pass == ""){
          $scope.hasErrPopDP = true;
          $scope.errType = "emptyPass";
          $("#pass").focus();
        } else{
          $scope.generateProcessing = true;
          if($scope.imgGenObj.isSession){
            localStorage.setItem('askSession', $scope.imgGenObj.isSession);
          }
          $scope.imgGenObj.processing = true;
          // $scope.passEnc = $scope.passEncrypt($scope.auth.email, $scope.imgGenObj.pass);
          // ContentLibrarySrv.checkUserPass($scope.passEnc).then(
          ContentLibrarySrv.checkUserPass($scope.encryptFx($scope.imgGenObj.pass)).then(
            function(data){
              $scope.imgGenObj.processing = false;
              if(data.code == 99000){
                $scope.generateProcessing = false;
                $scope.hasErrPopDP = true;
                $scope.errType = "invPass";
                $("#pass").focus();
              } else if(data.code == 99002){
                ngDialog.close($scope.dialogId);
                $scope.genImgFx();
              }
            },
            function(err){
              $scope.dpDObj.processing = false;
              $log.error(err);
            }
          );
        }
      } else{        
        $scope.generateProcessing = false;
        if($scope.imgGenObj.isSession){
          localStorage.setItem('askSession', $scope.imgGenObj.isSession);
        }
        $scope.imgGenObj.processing = false;
        ngDialog.close($scope.dialogId);
        $scope.genImgFx();
      }
    }
    $scope.passEncrypt = function(email, pass){
      $scope.emailPass = email + "|" + pass;
      return btoa($scope.reverse($scope.emailPass));
    }
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.dialogId = $dialog.attr('id');
    });

    $scope.replaceOpen = function(){
      $rootScope.uploadError = false;
      $scope.curReplaceObj = $filter("filter")($scope.contentList, {id:$scope.selectedItems[0].id}, true);
      $scope.replaceObj = {fid:$scope.curReplaceObj[0].folderid, id:$scope.contentBrief.id, label:$scope.contentBrief.label, type:$scope.curReplaceObj[0].type, extn:$scope.curReplaceObj[0].extn, optimize:1};

      if($scope.auth.upermissions.vi){
        $scope.replaceObj.vi = 0;
      }

      ngDialog.open({
        template:"app/contentLibrary/popup/replace.html",
        width:580,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        data:$scope.replaceObj,
        controller:"ReplaceController"
      });
    }

    $scope.reprocessOpen = function(){
      $scope.curReproObj = angular.copy($scope.contentBrief);
      ngDialog.open({
        template:"app/contentLibrary/popup/reprocess.html",
        width:580,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        data:$scope.curReproObj
      });
    }

    $scope.confirmReplFx = function(){
      ngDialog.open({
        template:'\
        <section class="panel" role="dialog">\
          <div class="panel-body">{{"cl.msg.18" | translate}}</div>\
          <footer class="panel-footer">\
            <button type="button" role="button" class="btn btn-sm btn-warning" ng-click="closeAll();" focus-me="true">{{"cm.btn.2" | translate}}</button>\
            <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
          </footer>\
        </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
      });
    }
    $scope.closeAll = function(){
      $rootScope.uploading = false;
      ngDialog.closeAll();
    };

    $scope.scheduleFx = function(){
      $scope.curSelectedItems = [];
      $scope.curSelectedFolders = [];
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type.toLowerCase() == "folder" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){
          item.fid = item.id;
          if(item.type == "excelfolder"){
            item.type = "folder";
          }
          $scope.curSelectedFolders.push(item);
        }
      });
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(content){
        angular.forEach($rootScope.selectedItems, function(item){
          if(content.isApproved){
            if(item.type == "SharePointC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted,
                caption:content.caption,
                captionLang:content.captionLang,
                activePeriod:content.activePeriod
              });
            }
            if(item.type == "OneDriveC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted,
                caption:content.caption,
                captionLang:content.captionLang,
                activePeriod:content.activePeriod
              });

            }
            if(item.type == "SharedFolderC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                height:content.height,
                splFid:content.splFid,
                fid:JSON.parse($scope.curFolderId),

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                url:content.url,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                caption:content.caption,
                duration:content.duration,
                isCompleted:content.isCompleted,
                captionLang:content.captionLang,
                activePeriod:content.activePeriod
              });
            }
            if(item.type == "GoogleDriveC" && content.id == item.id){
              $scope.curSelectedItems.push({
                size:content.size,
                splId:content.splId,
                width:content.width,
                spfid:content.spfid,
                splFid:content.splFid,
                height:content.height,
                Length:content.Length,
                MajorVersion:content.MajorVersion,
                fid:JSON.parse($scope.curFolderId),
                ServerRelativeUrl:content.ServerRelativeUrl,

                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                url:content.url,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                userid:$scope.auth.uid,
                duration:content.duration,
                isCompleted:content.isCompleted,
                caption:content.caption,
                captionLang:content.captionLang
              });

            }
            if((item.type != "SharePointC" && item.type != "OneDriveC" && item.type != "SharedFolderC" && item.type != "GoogleDriveC") && content.id == item.id){
              $scope.curSelectedItems.push({
                hidden:0,
                mute:true,
                scale:"fit",
                id:content.id,
                fid:JSON.parse($scope.curFolderId),
                ss:content.ss,
                url:content.url,
                fullscreen:false,
                extn:content.extn,
                type:content.type,
                label:content.label,
                dimension:content.d,
                thumb:content.thumb,
                ssImg:content.ssImg,
                userid:$scope.auth.uid,
                caption:content.caption,
                duration:content.duration,
                isCompleted:content.isCompleted,
                captionLang:content.captionLang,
                activePeriod:content.activePeriod
              });
              /*
                captionLang: []
                captionSel: []
                path: "/"
                sortOrder: 0
              */
            }
          }
        });
      });

      // angular.forEach($scope.contentLibrary.contentLibrary.folder, function(folder){
      //   angular.forEach($rootScope.selectedItems, function(item){
      //     if(folder.id == item.id){
      //       $scope.curSelectedItems.push({
      //         id:folder.id,
      //         wp:folder.wp,
      //         pid:folder.pid,
      //         type:folder.type,
      //         label:folder.label,
      //         userid:$scope.auth.uid
      //       });
      //     }
      //   });
      // });
      // localStorage.setItem("clSchedule", JSON.stringify($rootScope.selectedItems));

      if($scope.curSelectedItems.length){
        localStorage.setItem("clSchedule", JSON.stringify($scope.curSelectedItems));
      }
      if($scope.curSelectedFolders.length){
        localStorage.setItem("clfSchedule", JSON.stringify($scope.curSelectedFolders));
      }

      $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:""});
    };

    $scope.openImgEditor = function(id){
      localStorage.setItem("inFolder", $scope.curFolderId);
      $state.go("hub.contentLibraryEditImg", {
        id:$scope.hubEncrypt(id)
      });
    }

    $scope.openCapVidEditor = function(id){
      localStorage.setItem("inFolder", $scope.curFolderId);
      localStorage.setItem("vId", $scope.hubEncrypt(id));
      $state.go("hub.contentLibraryEditCapVid.vc");
    }

    $scope.shortcutFx = function(){
      $rootScope.curFType = "move";
      $scope.moveLoading = true;
      $scope.confirmObj = {admin:true};
      ContentLibrarySrv.getMoveTree("/"+$scope.selectedItems[0].id).then(
        function(data){
          $scope.treeObj = {type:"move", curServerTree:data.tree};
          $scope.moveLoading = false;
        }
      );
      ngDialog.open({
        template:"app/contentLibrary/popup/shortcut.html",
        width:580,
        scope:$scope,
        data:$scope.confirmObj,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
      return;
    }
    $scope.shortcutCreateFx = function(pId){
      $scope.saveProcessing = true;
      $scope.selectedItems[0].pid = parseInt($("input[name='treeOpt']:checked").val());
      $scope.selectedItems[0].admin = $scope.confirmObj.admin;
      ContentLibrarySrv.updateShortcut($scope.selectedItems[0]).then(
        function(data){
          $scope.loadSelectedTab();
          ngDialog.close();
          $scope.saveProcessing = false;
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      )
    }
    $scope.selFolderFx = function(){
      // console.warn("Hello");
    }

    /*Asana Integration Start*/
    $scope.asanaPopOpen = function(f){
      $scope.fList = f;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <div>\
                <span ng-if="dataObj.caller==\'archive\'">{{\'cm.asn.m6\' | translate}}</span>\
                <span ng-if="dataObj.caller==\'unapprove\'">{{\'cm.asn.m7\' | translate}}</span>\
                <span ng-if="dataObj.caller==\'delete\'">{{\'cm.asn.m8\' | translate}}</span>\
                <h5 class="panel-inner-tab marT25 marB10">{{\'cm.asn.7\' | translate}}</h5>\
                <div ng-if="!fList.length" class="msg-warning">{{\'cm.asn.m10\' | translate}}</div>\
                <div class="table table-sm" ng-if="fList.length">\
                  <div class="row th">\
                    <div class="col-xs-6">{{\'cm.brief.1\' | translate}}</div>\
                    <div class="col-xs-6">{{\'cl.brief.8\' | translate}}</div>\
                  </div>\
                  <div class="scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(450)}}px">\
                    <div class="row" ng-repeat="f in fList">\
                      <div class="col-xs-6">{{f.label}}</div>\
                      <div class="col-xs-6 word-break"><span class="fa fa-home marR5" aria-hidden="true"></span>{{f.path}}</div>\
                    </div>\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeAll();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:580,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    /*Asana Integration End*/

    $scope.confirmOpen = function(caller, id){
      $scope.confirmProcessing = false;
      $scope.dataObj = {caller:caller};
      $scope.isConfirmOpen = true;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dataObj.caller==\'archive\'">{{\'cl.msg.7\' | translate}}</span>\
              <span ng-if="dataObj.caller==\'unapprove\'">{{\'cl.msg.8\' | translate}}</span>\
              <span ng-if="dataObj.caller==\'delete\'">{{\'cl.msg.9\' | translate}}</span>\
              <span ng-if="dataObj.caller==\'pDelete\'" translate="{{\'cl.msg.10\'}}" translate-values="{htmlTag:\'<br>\', htmlTagO:\'<b>\', htmlTagC:\'</b>\'}"></span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm" ng-class="{\'btn-success\':dataObj.caller==\'archive\',\'btn-warning\':dataObj.caller==\'unapprove\', \'btn-danger\':(dataObj.caller==\'delete\'||dataObj.caller==\'pDelete\')}" ng-click="confirmFx(dataObj.caller);" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin fa-fw" ng-if="confirmProcessing" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }
    $scope.cancelPromise = function(){
      $timeout.cancel($scope.promise);
    }
    $scope.confirmFx = function(caller){
      $scope.confirmProcessing = true;
      //set isWidget true if adv search applied
      if(localStorage.getItem("isAdvSearch")){
        if($scope.selectedTab == "hub.contentLibrary.c"){
          localStorage.setItem("isActionOnContent", true);
        } else {
          localStorage.removeItem("isActionOnContent");
        }
      } else{
        localStorage.removeItem("isActionOnContent");
        localStorage.removeItem("curFilterObj");
        localStorage.removeItem("isAdvSearch");
      }
      if(caller == "unapprove"){
        $scope.sendObj = {contentIds:[], folderIds:[]};
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "content" || item.type == "widget"){
            $scope.sendObj.contentIds.push(item.id);
          } else if(item.type == "folder" || item.type == "shortcut" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){

            if(item.type == "sharedfolder" && !item.pid){
              $scope.sendObj.folderIds.push(item.splId);
            } else{
              $scope.sendObj.folderIds.push(item.id);
            }

          }
        });
        ContentLibrarySrv.unapproveContent($scope.sendObj).then(
          function(data){
            if(data.code == 8333){
              $scope.asanaPopOpen(data.f);
            } else{
              ngDialog.close();
              $scope.loadSelectedTab();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        if(caller == 'archive'){
          $scope.sendObj = {contentIds:"", folderIds:"", status:1}
        } else if(caller == 'delete'){
          $scope.sendObj = {contentIds:"", folderIds:"", shortcutIds:"", status:2}
        } else if(caller == 'pDelete'){
          $scope.sendObj = {contentIds:"", folderIds:"", status:3}
        }
        angular.forEach($rootScope.selectedItems, function(item){
          if(item.type == "content" || item.type == "widget"){
            if($scope.sendObj.contentIds.length > 0){
              $scope.sendObj.contentIds += "," + item.id.toString();
            } else{
              $scope.sendObj.contentIds = item.id.toString();
            }
          }
          else if(item.type == "folder" || item.type == "shortcut" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){
            if(caller == 'delete'){
              if(item.type == "folder" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){
                if(item.type == "sharedfolder" && !item.pid){
                  if($scope.sendObj.folderIds.length > 0){
                    $scope.sendObj.folderIds += "," + item.splId.toString();
                  } else{
                    $scope.sendObj.folderIds = item.splId.toString();
                  }
                } else{
                  if($scope.sendObj.folderIds.length > 0){
                    $scope.sendObj.folderIds += "," + item.id.toString();
                  } else{
                    $scope.sendObj.folderIds = item.id.toString();
                  }
                }
              }
              else if(item.type == "shortcut"){
                if($scope.sendObj.shortcutIds.length > 0){
                  $scope.sendObj.shortcutIds += "," + item.id.toString();
                } else{
                  $scope.sendObj.shortcutIds = item.id.toString();
                }
              }
            } else{
              if(item.type == "sharedfolder" && !item.pid){
                if($scope.sendObj.folderIds.length > 0){
                  $scope.sendObj.folderIds += "," + item.splId.toString();
                } else{
                  $scope.sendObj.folderIds = item.splId.toString();
                }
              } else{
                if($scope.sendObj.folderIds.length > 0){
                  $scope.sendObj.folderIds += "," + item.id.toString();
                } else{
                  $scope.sendObj.folderIds = item.id.toString();
                }
              }
            }
          }
        });

        if(caller == "delLink"){
          $scope.sendObj.isDelete = true;
        }
        ContentLibrarySrv.deleteContent($scope.sendObj).then(
          function(data){
            ngDialog.close();
            if(data.code == 8333){
              $scope.asanaPopOpen(data.f);
            } else if(data.code == 8188){
              $scope.coeDataObj = data;
              ngDialog.open({
                template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">\
                    <p>{{\'cl.msg.54\' | translate}}</p>\
                    <div class="table table-scroll marB10">\
                      <div class="scrollQuad" style="max-height:{{getAvailableHeight(371)}}px">\
                        <div class="row" ng-repeat="child in coeDataObj.child">\
                          <div class="col-xs-12">{{child.label}}</div>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                  </footer>\
                </section>',
                plain:true,
                width:600,
                scope:$scope,
                closeByDocument:false,
                className:'ngdialog-theme-default ngdialog-confirm',
                preCloseCallback:function(){
                  $scope.isConfirmOpen = false;
                }
              });
            } else if(data.code == 8294){
              $scope.coeDataObj = data;
              ngDialog.open({
                template:'\
                <section class="panel">\
                  <div class="panel-body">\
                    <p class="noPad noMar">{{\'cl.msg.55\' | translate}}</p>\
                    <div class="marT20" translate="{{\'cl.msg.56\'}}" translate-values="{sName:\'<b>{{coeDataObj.server[0].servername}}</b>\'}"></div>\
                  </div>\
                  <footer class="panel-footer">\
                    <button type="button" class="btn btn-sm btn-danger" ng-click="confirmFx(\'delLink\');" focus-me="true" ng-disabled="deleteProcessing">\
                      <span class="fa fa-repeat fa-spin fa-fw" ng-if="deleteProcessing"></span>{{\'cm.btn.2\' | translate}}\
                    </button>\
                    <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
                  </footer>\
                </section>',
                plain:true,
                width:600,
                scope:$scope,
                closeByDocument:false,
                className:'ngdialog-theme-default ngdialog-confirm',
                preCloseCallback:function(){
                  $scope.isConfirmOpen = false;
                }
              });
            } else{
              $scope.loadSelectedTab();
              $scope.reloadTree();
            }
          },
          function(err){
            $scope.confirmProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.downloadOpen = function(caller){
      $scope.downloadSurl = "";
      if($scope.downloadableObj.type == "Image"){
        $scope.downloadUrl = $scope.downloadableObj.thumb;
      } else if($scope.downloadableObj.type == "Video" || $scope.downloadableObj.type == "Audio" || $scope.downloadableObj.type == "POWERPOINT" || $scope.downloadableObj.type == "WORD" || $scope.downloadableObj.type == "Vector" || $scope.downloadableObj.type == "Flash"){
        $scope.downloadUrl = $scope.downloadableObj.url;
      }
      if($scope.downloadableObj.surl){
        $scope.downloadSurl = $scope.cDetailBucket + $scope.downloadableObj.surl;
      }
      $scope.linkOpenFx('m', $scope.downloadUrl, $scope.downloadSurl, $scope.downloadableObj.label, $scope.downloadableObj.type, $scope.downloadableObj.size, $scope.downloadableObj.pSize);
    }
    $scope.versionContentOpen = function(contentInfo){
      $scope.downloadSurl = "";
      if(contentInfo.type == "Image"){
        $scope.downloadUrl = $scope.cDetailBucket + contentInfo.thumb;
      } else if(contentInfo.type == "Video"){
        $scope.downloadUrl = $scope.cDetailBucket +  contentInfo.pUrl;
      } else if(contentInfo.type == "Audio" || contentInfo.type == "POWERPOINT" || contentInfo.type == "WORD" || contentInfo.type == "Vector" || contentInfo.type == "Flash"){
        $scope.downloadUrl = $scope.cDetailBucket +  contentInfo.url;
      }
      if(contentInfo.sUrl){
        $scope.downloadSurl = $scope.cDetailBucket + contentInfo.sUrl;
      }
      $scope.linkOpenFx('m', $scope.downloadUrl, $scope.downloadSurl, contentInfo.thumb, contentInfo.type, contentInfo.size, contentInfo.pSize);
    }

    $scope.restoreFx = function(){
      $scope.sendObj = {contentIds:[], folderIds:[]}
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "content" || item.type == "widget"){
          $scope.sendObj.contentIds.push(item.id);
        } else if(item.type == "folder" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){
          $scope.sendObj.folderIds.push(item.id);
        }
      });
      ContentLibrarySrv.restoreContent($scope.sendObj).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.approveFx = function(){
      //set isWidget true if adv search applied
      if(localStorage.getItem("isAdvSearch")){
        localStorage.setItem("isActionOnContent", true);
      } else{
        localStorage.removeItem("isActionOnContent");
        localStorage.removeItem("curFilterObj");
        localStorage.removeItem("isAdvSearch");
      }
      $scope.sendObj = {contentIds:[], folderIds:[]}
      angular.forEach($rootScope.selectedItems, function(item){
        if(item.type == "content" || item.type == "widget"){
          $scope.sendObj.contentIds.push(item.id);
        } else if(item.type == "folder" || item.type == "sharepoint" || item.type == "onedrive" || item.type == "sharedfolder" || item.type == "excelfolder" || item.type.toLowerCase() == "googledrive"){
          if(item.type == "sharedfolder" && !item.pid){
            $scope.sendObj.folderIds.push(item.splId);
          } else{
            $scope.sendObj.folderIds.push(item.id);
          }
        }
      });
      ContentLibrarySrv.approveContent($scope.sendObj).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.removeExpiryFx = function(){
      ContentLibrarySrv.removeExpiry($rootScope.selectedItems).then(
        function(data){
          $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.addToScheduleOpen = function(){
      $scope.scheduleList = {};
      SchedulesSrv.getAddToSchedules($rootScope.selectedItems).then(
        function(data){
          $scope.scheduleList = data;
          $scope.selectedSch = data.filter(function(item){
            return item.isChecked == true;
          }).map(function(item){
            return item.id;
          });
          ngDialog.open({
            template:"app/common/popup/addToSchedule.html",
            width:800,
            scope:$scope,
            closeByDocument:false,
            controller:"AddtoScheduleController",
            preCloseCallback:function(){
              $scope.saveProcessing = false;
              $scope.hasErr = false;
              $scope.errType = "";
            }
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.contentEditOpen = function(){
      $scope.editObj = {info:{id:$rootScope.selectedItems[0].id, label:$scope.contentBrief.label}};
      ContentLibrarySrv.getContentDetails($rootScope.selectedItems[0].id).then(
        function(data){
          $scope.editObj.activePeriod = data.activePeriod;
          $scope.editObj.permission = data.permission;

          ngDialog.open({
            template:"app/contentLibrary/popup/contentEdit.html",
            width:680,
            scope:$scope,
            data:$scope.editObj,
            closeByDocument:false,
            controller:"ContentEditController",
          });
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.contentCountFx = function(id, label, caller){
      $scope.loading = false;
      $scope.contentCountList = [];
      $scope.popupLabel = label;
      $scope.contentObj = {id:id, label:label};
      if(caller == "contentOnDemand"){
        caller = "cod";
      }
      if(caller == "cod" || caller == "filler"){
        ContentLibrarySrv.briefContentList(id, caller).then(
          function(data){
            $scope.contentCountList = data;
            $scope.cBucket = $scope.cDetailBucket = $scope.contentCountList.info.bucket;
            if($scope.contentCountList.info.mbucket && $scope.contentCountList.info.mbucket != ""){
              $scope.cDetailBucket = $scope.contentCountList.info.mbucket;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }else{
        ContentLibrarySrv.getContentList(id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type).then(
          function(data){
            $scope.contentCountList = data;
            $scope.cBucket = $scope.cDetailBucket = $scope.contentCountList.info.bucket;
            if($scope.contentCountList.info.mbucket && $scope.contentCountList.info.mbucket != ""){
              $scope.cDetailBucket = $scope.contentCountList.info.mbucket;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
      ngDialog.open({
        template:'app/contentLibrary/popup/contentList.html',
        width:755,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
      });
    }

    $scope.scheduleCountFx = function(id, label){
      $scope.scheduleCountList = [];
      $scope.popupLabel = label;
      $scope.scheduleObj = {id:id, label:label};
      ContentLibrarySrv.getScheduleList(id).then(
        function(data){
          $scope.scheduleCountList = data;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/popup/scheduleCountList.html',
        width:600,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.versionsOpen = function(label){
      $scope.popupLabel = label;
      $scope.versions = [];
      ContentLibrarySrv.getVersions($rootScope.selectedItems[0].id).then(
        function(data){
          $scope.versions = data;
          $scope.versions.info.label = label;
          $scope.vTim = $scope.versions.info.timthumb;
          $scope.vBucket = $scope.vDetailBucket = $scope.versions.info.bucket;
          if($scope.versions.info.mbucket && $scope.versions.info.mbucket != ""){
            $scope.vDetailBucket = $scope.versions.info.mbucket;
          }
          $scope.versions.cid = $rootScope.selectedItems[0].id;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/contentLibrary/popup/versions.html",
        width:800,
        scope:$scope,
        closeByDocument:false,
        controller:"VersionsController",
      });
    }

    $scope.metaTagOpen = function(label){
      $scope.mtObj = {loading:true, label:label, tags:[]};
      ContentLibrarySrv.getMetaTag($rootScope.selectedItems[0].id).then(
        function(data){
          $scope.mtObj.tags = data;
          $scope.mtObj.loading = false;
        },
        function(err){
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/contentLibrary/popup/metaTags.html",
        width:650,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        controller:"MetaTagsController",
        preCloseCallback:function(){
          $scope.contentBrief.mt = $scope.mtObj.tags.length;
          setTimeout(function(){
            $scope.$apply();
          }, 0);
        }
      });
    }

    $scope.editScheduleFx = function(id, step){
      ngDialog.close();
      if(!step){
        if($scope.auth.upermissions.se.np){
          $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.s){
          $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.c){
          $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.d || $scope.auth.upermissions.se.dt || $scope.auth.upermissions.se.dg){
          $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        } else if($scope.auth.upermissions.se.f){
          $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
        }
      } else if(step == "np"){
        $state.go("hub.sContainer.sName", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "s"){
        $state.go("hub.sContainer.sSchedule", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "c"){
        $state.go("hub.sContainer.sContent", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "d"){
        $state.go("hub.sContainer.sDevice", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      } else if(step == "f"){
        $state.go("hub.sContainer.sFrame", {type:$scope.hubEnc("s"), id:$scope.hubEncrypt(id)});
      }
    }

    /*Widget's edit button*/
    $scope.editFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $rootScope.tabView = false;
      //set isWidget true if adv search applied
      if(localStorage.getItem("isAdvSearch")){
        localStorage.setItem("isWidgetEdited", true);
      } else{
        localStorage.removeItem("isWidgetEdited");
        localStorage.removeItem("curFilterObj");
        localStorage.removeItem("isAdvSearch");
      }
      if($scope.curExtn.type == "Folder" || $scope.curExtn.type == "Sharepoint" || $scope.curExtn.type == "Onedrive" || $scope.curExtn.type == "SharedFolder" || $scope.curExtn.type.toLowerCase() == "googledrive"){
        var fType = "n";
        if($scope.curExtn.type == "Sharepoint"){
          fType = "sp";
        } else if($scope.curExtn.type == "Onedrive"){
          fType = "od";
        } else if($scope.curExtn.type == "SharedFolder"){
          fType = "sf";
        } else if($scope.curExtn.type.toLowerCase() == "googledrive"){
          fType = "gd";
        }
        $scope.folderCUOpen(fType, "edit");
      } else if($rootScope.excelObj.type == "excelfolder"){
        $scope.folderCUOpen("ef", "edit");
      } else if($scope.curExtn.type != "Folder" && $scope.curExtn.type != "Widget" && $scope.curExtn.type != "Sharepoint" && $scope.curExtn.type != "Onedrive" && $scope.curExtn.type != "SharedFolder" && $scope.curExtn.type.toLowerCase() != "googledrive"){
        $scope.contentEditOpen();
      } else if($scope.curExtn.type == "Widget"){
        if($scope.curExtn.extn == "Audio"){
          $scope.contentEditOpen();
        } else if($scope.curExtn.extn == "CoM Events"){
          $state.go("hub.contentAdd.widgetAddTab.comEvent", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "AGC"){
          $state.go("hub.contentAdd.widgetAddTab.agc", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Crop Comm: Alert Message"){
          $state.go("hub.contentAdd.widgetAddTab.alertMsg", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Achievers"){
          $state.go("hub.contentAdd.widgetAddTab.achievers", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Air Quality Index"){
          $state.go("hub.contentAdd.widgetAddTab.aqi", {
            id: $scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Amazon QuickSight"){
          $state.go("hub.contentAdd.widgetAddTab.amazonQuickSight", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Auto Login (Basic Auth)"){
          $state.go("hub.contentAdd.widgetAddTab.autoLogin", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Calendar of Events"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coe", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Calendar of Events View"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.coev", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Cisco Meraki"){
          localStorage.removeItem("celEventBack");
          $state.go("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Content on Demand"){
          $state.go("hub.contentAdd.widgetAddTab.contentOnDemand", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Button"){
          $state.go("hub.contentAdd.widgetAddTab.codButton", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Pandora CloudCover"){
          $state.go("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Content Group"){
          $state.go("hub.contentAdd.widgetAddTab.contentGroup", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Count"){
          $state.go("hub.contentAdd.widgetAddTab.count", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "CoM Pylon Text"){
          $state.go("hub.contentAdd.widgetAddTab.comPylonText", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Cloud Farm"){
          $state.go("hub.contentAdd.widgetAddTab.cloudFarm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Date Time"){
          $state.go("hub.contentAdd.widgetAddTab.dateTime", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Delimited Text"){
          $state.go("hub.contentAdd.widgetAddTab.delimitedText", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "External Input"){
          $state.go("hub.contentAdd.widgetAddTab.externalInput", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Excel Sheet"){
          $state.go("hub.contentAdd.widgetAddTab.excelSheet", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Facebook"){
          $state.go("hub.contentAdd.widgetAddTab.facebook", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Facebook Workplace"){
          $state.go("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Fifa"){
          $state.go("hub.contentAdd.widgetAddTab.fifa", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Filler Content"){
          $state.go("hub.contentAdd.widgetAddTab.fillerContent", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Flight Schedule"){
          $state.go("hub.contentAdd.widgetAddTab.flightSchedule", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Free Form"){
          $state.go("hub.contentAdd.widgetAddTab.freeForm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "FTP"){
          $state.go("hub.contentAdd.widgetAddTab.ftp", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Fullscreen Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.fsChrome", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45"){
          $state.go("hub.contentAdd.widgetAddTab.f45", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Blank"){
          $state.go("hub.contentAdd.widgetAddTab.blank", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Content Scroller"){
          $state.go("hub.contentAdd.widgetAddTab.contentScroller", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Content Tile"){
          $state.go("hub.contentAdd.widgetAddTab.contentTile", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Countdown Circle"){
          $state.go("hub.contentAdd.widgetAddTab.countdownCircle", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Hydrate"){
          $state.go("hub.contentAdd.widgetAddTab.hydrate", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Move Station"){
          $state.go("hub.contentAdd.widgetAddTab.moveStation", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.f45progressBar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Animation"){
          $state.go("hub.contentAdd.widgetAddTab.animation", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Progress Bar With Break"){
          $state.go("hub.contentAdd.widgetAddTab.progressBarWithBreak", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Stay"){
          $state.go("hub.contentAdd.widgetAddTab.stay", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Work"){
          $state.go("hub.contentAdd.widgetAddTab.work", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "F45 Workout"){
          $state.go("hub.contentAdd.widgetAddTab.story", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Google Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.gCalendar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Google Slide"){
          $state.go("hub.contentAdd.widgetAddTab.gSlide", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Grafana Cloud"){
          $state.go("hub.contentAdd.widgetAddTab.grafana", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "HD Steth"){
          $state.go("hub.contentAdd.widgetAddTab.hdSteth", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "IFrame"){
          $state.go("hub.contentAdd.widgetAddTab.iFrame", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Instagram"){
          $state.go("hub.contentAdd.widgetAddTab.instagram", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel Circuit Bench"){
          $state.go("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "LinkedIn"){
          $state.go("hub.contentAdd.widgetAddTab.linkedIn", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Interactive Menu"){
          $state.go("hub.contentAdd.widgetAddTab.iMenu", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "IoT Button"){
          $state.go("hub.contentAdd.widgetAddTab.iotButton", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel JCI Map"){
          $state.go("hub.contentAdd.widgetAddTab.jciMap", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Intel Smart Building"){
          $state.go("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Live Streaming"){
          $state.go("hub.contentAdd.widgetAddTab.liveStreaming", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.meeting", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Message"){
          $state.go("hub.contentAdd.widgetAddTab.message", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams"){
          $state.go("hub.contentAdd.widgetAddTab.msTeams", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams Rooms"){
          $state.go("hub.contentAdd.widgetAddTab.teamsRoom", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Music Choice"){
          $state.go("hub.contentAdd.widgetAddTab.musicChoice", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "News"){
          $state.go("hub.contentAdd.widgetAddTab.news", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "NextBus"){
          $state.go("hub.contentAdd.widgetAddTab.nextBus", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Next Vehicle"){
          $state.go("hub.contentAdd.widgetAddTab.nextVehicle", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Online Radio"){
          $state.go("hub.contentAdd.widgetAddTab.onlineRadio", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Outlook Calendar"){
           $state.go("hub.contentAdd.widgetAddTab.outlookCalendar", {
             id:$scope.hubEncrypt($scope.curExtn.id)
           });
        } else if($scope.curExtn.extn == "LifeLabs Patient Wait"){
          $state.go("hub.contentAdd.widgetAddTab.patientWait", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Power BI"){
          $state.go("hub.contentAdd.widgetAddTab.powerBI", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Progress Bar"){
          $state.go("hub.contentAdd.widgetAddTab.progressBar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Prayer"){
          $state.go("hub.contentAdd.widgetAddTab.prayer", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Open Hours"){
          $state.go("hub.contentAdd.widgetAddTab.openHours", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Queue"){
          $state.go("hub.contentAdd.widgetAddTab.queue", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Quotes"){
          $state.go("hub.contentAdd.widgetAddTab.quotes", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "QR Code"){
          $state.go("hub.contentAdd.widgetAddTab.qrCode", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Qlik"){
          $state.go("hub.contentAdd.widgetAddTab.qlik", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Readerboard"){
          $state.go("hub.contentAdd.widgetAddTab.readerboard", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "RSS Feed"){
          $state.go("hub.contentAdd.widgetAddTab.rssFeed", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Schedule Calendar"){
          $state.go("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Slack"){
          $state.go("hub.contentAdd.widgetAddTab.slack", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Firstup"){
          $state.go("hub.contentAdd.widgetAddTab.socialChorus", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Social Media"){
          $state.go("hub.contentAdd.widgetAddTab.socialMedia", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Stock Price"){
          $state.go("hub.contentAdd.widgetAddTab.stockPrice", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Storm"){
          $state.go("hub.contentAdd.widgetAddTab.storm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Sun Smart"){
          $state.go("hub.contentAdd.widgetAddTab.sunSmart", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Survey"){
          $state.go("hub.contentAdd.widgetAddTab.survey", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Tableau"){
          $state.go("hub.contentAdd.widgetAddTab.tableau", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Telax"){
          $state.go("hub.contentAdd.widgetAddTab.telax", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Crawling Text" || $scope.curExtn.extn == "Static Text"){
          $state.go("hub.contentAdd.widgetAddTab.text", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Traffic"){
          $state.go("hub.contentAdd.widgetAddTab.traffic", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "TouchLink Meetings"){
          $state.go("hub.contentAdd.widgetAddTab.touchLink", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Training Mode"){
          $state.go("hub.contentAdd.widgetAddTab.trainingMode", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "TSC Country Mile"){
          $state.go("hub.contentAdd.widgetAddTab.tsccm", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "X"){
          $state.go("hub.contentAdd.widgetAddTab.twitter", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Teams Channels"){
          $state.go("hub.contentAdd.widgetAddTab.teamsChannel", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Ungerboeck"){
          $state.go("hub.contentAdd.widgetAddTab.ungerboeck", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Unisys"){
          $state.go("hub.contentAdd.widgetAddTab.unisys", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Vimeo"){
          $state.go("hub.contentAdd.widgetAddTab.vimeo", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        }else if($scope.curExtn.extn == "Verkada"){
          $state.go("hub.contentAdd.widgetAddTab.verkada",{
            id:$scope.hubEncrypt($scope.curExtn.id)
          })
        }else if($scope.curExtn.extn == "Weather"){
          $state.go("hub.contentAdd.widgetAddTab.weather", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Cam"){
          $state.go("hub.contentAdd.widgetAddTab.webCam", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Login"){
          $state.go("hub.contentAdd.widgetAddTab.webLogin", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Login Chrome"){
          $state.go("hub.contentAdd.widgetAddTab.webLoginChrome", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Web Page"){
          $state.go("hub.contentAdd.widgetAddTab.webPage", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Wait Queue Metro"){
          $state.go("hub.contentAdd.widgetAddTab.wqMetro", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "webex by CISCO"){
          $state.go("hub.contentAdd.widgetAddTab.webex", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Xovis"){
          $state.go("hub.contentAdd.widgetAddTab.xovis", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "Microsoft Viva Engage"){
          $state.go("hub.contentAdd.widgetAddTab.yammer", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        } else if($scope.curExtn.extn == "YouTube"){
          $state.go("hub.contentAdd.widgetAddTab.youTube", {
            id:$scope.hubEncrypt($scope.curExtn.id)
          });
        }
      }
    }

    $rootScope.deleteCallback = function(){
      $scope.isDeletable = false;
      if($rootScope.selectedItems.length > 0 && !$scope.isConfirmOpen){
        angular.forEach($scope.contentBtn.buttons, function(btn){
          if(btn.key == "clDelete" || btn.key == "clPermanentlyDelete"){
            $scope.isDeletable = true;
          }
        });
        if($scope.isDeletable){
          if($scope.selectedTab === "hub.contentLibrary.c" || $scope.selectedTab === "hub.contentLibrary.uc" || $scope.selectedTab === "hub.contentLibrary.ac" || $scope.selectedTab === "hub.contentLibrary.ec"){
            $scope.confirmOpen('delete');
          } else{
            $scope.confirmOpen('pDelete');
          }
        }
      }
    }

    $scope.alertMsgAcknProcessing = false;
    $scope.alertMsgAcknFx = function(id){
      $scope.alertMsgAcknProcessing = true;
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.linkOpenFx("d");
      ContentLibrarySrv.getAcknowledgment(id).then(
        function(data){
          $scope.alertMsgAcknProcessing = false;
          if(data.url){
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $scope.alertMsgAcknProcessing = false;
          $log.error(err);
        }
      );
    }

    /*Instagram*/
    $scope.instaPrevProcessing = false;
    $scope.instaPrevFx = function(id, label){
      $scope.popupLabel = label;
      $scope.instaPrevProcessing = true;
      $scope.instaObj = {};
      ContentLibrarySrv.getInstaPrev(id).then(
        function(data){
          $scope.instaObj.data = data;
          $scope.instaObj.url = $sce.trustAsResourceUrl($rootScope.apiHost + "feed/instagram/basicdisplay/"+id);
          $scope.instaPrevProcessing = false;
          ngDialog.open({
            template:'app/contentLibrary/popup/instaPreview.html',
            width:920,
            data:$scope.instaObj,
            scope:$scope,
            className:"ngdialog-theme-default ngdialog-preview"
          });
        },
        function(err){
          $scope.instaPrevProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.streamMetricsOpen = function(){
      $scope.lssmObj = {info:{id:$scope.contentBrief.id, dateRange:{startDate:moment().format('MM-DD-YYYY'), endDate:moment().format('MM-DD-YYYY')}}};
      $scope.popProcessing = false;
      $scope.hasErrPop = false;
      $scope.errType = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.48" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="dateRange">{{"cm.label.36" | translate}}</label>\
                <div class="input-group">\
                  <span class="input-group-addon"><span class="fa fa-calendar" aria-hidden="true"></span></span>\
                  <input type="daterange" id="dateRange" class="form-control picker" ng-model="lssmObj.info.dateRange" format="MM/DD/YYYY" readonly="" aria-label="dateRange" aria-labelledby="dateRange">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-click="streamMetricsFx();" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing" aria-hidden="true"></span> {{"cl.widget.queue.1b" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errType==\'noRecord\'" aria-live="polite" role="status">{{\'r.msg.1\' | translate}}</span>\
                <span ng-if="errType==\'start\'" aria-live="polite" role="status">{{\'cm.msg.8\' | translate}}</span>\
                <span ng-if="errType==\'end\'" aria-live="polite" role="status">{{\'cm.msg.9\' | translate}}</span>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        trapFocus:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.streamMetricsFx = function(){
      $scope.popProcessing = true;
      $scope.lssmObjCopy = {
        startDate:moment($scope.lssmObj.info.dateRange.startDate).format("L"),
        endDate:moment($scope.lssmObj.info.dateRange.endDate).format("L")
      };
      ContentLibrarySrv.streamMetrics({info:{id:$scope.lssmObj.info.id, dateRange:$scope.lssmObjCopy}}).then(
        function(data){
          $scope.popProcessing = false;
          $scope.hasErrPop = false;
          $scope.errType = "";
          if(data.code == 18005 || data.code == 18009){//Invalid widget id || Record not found
            $scope.hasErrPop = true;
            $scope.errType = "noRecord";
          } else if(data.code == 18007){//Start Date is missing
            $scope.errType = "start";
          } else if(data.code == 18008){//End Date is missing
            $scope.errType = "end";
          } else{
            $scope.linkOpenFx('m', data.url);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    /*Knowledge base*/
    $scope.videoFx = function(){
      ngDialog.open({
        template:'app/contentLibrary/popup/video.html',
        width:580
      });
    }
    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/contentLibrary/popup/info.html',
        width:580,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    //File upload
    $scope.$on('flow::complete', function(event, $flow){
      if($flow.files.length == 0){
        if($state.includes('hub.contentLibrary.c')){
          $scope.selectedTab = "hub.contentLibrary.c";
          $scope.loadSelectedTab();
        } else{
          $timeout(function(){
            $state.go('hub.contentLibrary.c');
          }, 1000);
        }
      }
    });
    $scope.$on('flow::fileSuccess', function(file,message){
      if($state.includes('hub.contentLibrary.c')){
        localStorage.setItem("inFolder", message.opts.query.fid);
        $scope.inFolder = localStorage.getItem("inFolder");
        if($scope.curFolderId === $scope.inFolder){
          $scope.loadSelectedTab();
        } else{
          localStorage.setItem("inFolder", 0);
        }
      }
    });

    /*Advanced Search*/
    $scope.advancedSearchClOpen = function(caller, step, id){
      $scope.hasErr = false;
      $scope.errType = "";
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
      $scope.advSearchObj = {caller:caller, step:step, id:id};
      $scope.redirectFolderId = localStorage.getItem("curFId");
      if($scope.redirectFolderId != 0){
        localStorage.setItem("curFId", 0);
        $scope.curFolderId = 0;
        $scope.loadSelectedTab();
      }
      ngDialog.open({
        template:"app/common/popup/advancedSearch.html",
        width:1250,
        scope:$scope,
        data:$scope.advSearchObj,
        closeByEscape:false,
        closeByDocument:false,
        controller:"AdvancedSearchController",
        preCloseCallback:function(caller){
          if(caller == "close" && $scope.redirectFolderId != 0){
            localStorage.setItem("curFId", $scope.redirectFolderId);
            $scope.curFolderId = localStorage.getItem("curFId");
            $scope.loadSelectedTab();
          }
        }
      });
    }

    $scope.openUrlFx = function(w, h, caller){
      $scope.fCaller = caller;
      if(caller == "spRe" || caller == "spReOu"){
        $scope.popProcessing = true;
        $scope.fCaller = "sp";
      }
      if(caller == "odRe" || caller == "odReOu"){
        $scope.popProcessing = true;
        $scope.fCaller = "od";
      }
      ContentLibrarySrv.getOdSpUrl($scope.fCaller, $scope.curFolderId).then(
        function(data){
          $scope.odDisabled = false;
          $scope.odSpUrl = data.url;
          // $scope.odrdUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri="+data.url;
          $scope.odrdUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";

          ContentLibrarySrv.clearSession($scope.fCaller).then(
            function(data){
              $scope.left = (screen.width/2)-(w/2);
              $scope.top = (screen.height/2)-(h/2);
              $scope.odProcessing = true;
              $scope.odDisabled = true;
              $scope.hasErr = false;
              $scope.errType = "";

              if(caller == "spReOu" || caller == "odReOu"){
                var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ $scope.top +', left='+ $scope.left);
              }
              setTimeout(function(){
                if(caller != "sp" && caller != "od"){
                  $scope.popProcessing = false;
                  ngDialog.close();
                  if(caller == "spReOu" || caller == "odReOu"){
                    newWindow.close();
                  }
                }
                $scope.childWindow = window.open($scope.odSpUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
                $scope.childWindowInt = $interval($scope.checkChild, 500);
              }, 2000);
              return false;
            },
            function(err){
              $log.error(err);
            }
          );
        },
        function(err){
          $scope.odDisabled = false;
          $log.error(err);
        }
      );
    }
    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $state.reload();
        $interval.cancel($scope.childWindowInt);
      }
    }

    $scope.reAuthOpen = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="reAuthObj == \'spRe\' || reAuthObj == \'odRe\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObj == \'spReOu\' || reAuthObj == \'odReOu\'">{{"cl.widget.msg.10.2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="openUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    /*advSearchfilteredData by advanced search*/
    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.selectedItems = [];
      $scope.folderList = [];
      $scope.searchText = "";
      $scope.filterFx('all', true);
      $scope.contentList = args.content;
      // todo this  function to get process data of the video indexer
      $scope.getViProArr($scope.contentList);
      $scope.folderList = args.folder;
      $scope.contentLibrary.contentLibrary.content = args.content;
      $scope.contentLibrary.contentLibrary.folder = args.folder;
      $scope.contentLibrary.contentLibrary.groups = args.groups;
      $scope.filterCount = $scope.contentLibrary.contentLibrary.content.length;
      $scope.advSearchInfo = args.info;
      $scope.advObj = args.advObj;
      $scope.advSearch = true;
      if($scope.isWidgetEdited || $scope.isActionOnContent || $scope.groupType=="type"){
        $scope.updateList();
      }
      if(args.code == 8118){
        $scope.loadSelectedTab();
      } else if(angular.isUndefined(args.code) && !args.info.step) {
        $scope.advSearch = false;
      }
    });

    $scope.countListFx = function(id, name, label, schedule){
      $scope.popupLabel = label;
      $scope.expType = name;
      $scope.countList = [];
      $scope.dataObj = {id:id, name:name, label:label};
      $scope.schCountObj = {id:id, name:name, label:label, schedule:schedule};
      $scope.filtered = {a:[], i:[]};
      if(name == 'schedule'){
        $scope.isSorted = false;
        $scope.popupLoading = true;
        $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
        if(schedule.a){
          ContentLibrarySrv.getActiveSchedule(id).then(
            function(data){
              if(!schedule.i){
                $scope.popupLoading = false;
              }
              $scope.countList.info = data.info;
              $scope.countList.schedules.a = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.a = $scope.countList.schedules.a;
            },
            function(err){
              $scope.popupLoading = false;
              $log.error(err);
            }
          );
        }
        if(schedule.i){
          ContentLibrarySrv.getInactiveSchedule(id).then(
            function(data){
              $scope.popupLoading = false;
              $scope.countList.info = data.info;
              $scope.countList.schedules.i = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.i = $scope.countList.schedules.i;
            },
            function(err){
              $scope.popupLoading = false;
              $log.error(err);
            }
          );
        }

        ngDialog.open({
          template:'app/contentLibrary/popup/scheduleList.html',
          width:700,
          data:$scope.dataObj,
          scope:$scope,
          closeByDocument:false,
        });
      }
    }

    // for refresh content and schedule popup list
    $scope.refreshPopupListFx = function(caller,brief){
      $scope.loading = true;
      if(caller == "content"){
        $scope.contentCountList = [];
        $scope.popupLabel = $scope.contentObj.label;
        if(brief == "contentOnDemand"){
          brief = "cod";
        }
        if(brief == "cod" || brief == "filler"){
          ContentLibrarySrv.briefContentList($scope.contentObj.id, brief).then(
            function(data){
              $scope.contentCountList = data;
              $scope.cBucket = $scope.cDetailBucket = $scope.contentCountList.info.bucket;
              if($scope.contentCountList.info.mbucket && $scope.contentCountList.info.mbucket != ""){
                $scope.cDetailBucket = $scope.contentCountList.info.mbucket;
              }
              $scope.loading = false;
            },
            function(err){
              $scope.loading = false;
              $log.error(err);
            }
          );
        }else{
          ContentLibrarySrv.getContentList($scope.contentObj.id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type).then(
            function(data){
              $scope.contentCountList = data;
              $scope.cBucket = $scope.cDetailBucket = $scope.contentCountList.info.bucket;
              if($scope.contentCountList.info.mbucket && $scope.contentCountList.info.mbucket != ""){
                $scope.cDetailBucket = $scope.contentCountList.info.mbucket;
              }
              $scope.loading = false;
            },
            function(err){
              $scope.loading = false;
              $log.error(err);
            }
          );
        }

      } else if(caller == "schedule"){
        $scope.popupLabel = $scope.schCountObj.label;
        $scope.expType = $scope.schCountObj.name;
        $scope.countList = [];
        $scope.filtered = {a:[], i:[]};

        $scope.isSorted = false;
        $scope.popupLoading = true;
        $scope.loading = true;
        $scope.countList = {schedules:{a:[], i:[]}, framelayout:"", info:""};
        if($scope.schCountObj.schedule.a){
          ContentLibrarySrv.getActiveSchedule($scope.schCountObj.id).then(
            function(data){
              if(!$scope.schCountObj.schedule.i){
                $scope.popupLoading = false;
                $scope.loading = false;
              }
              $scope.countList.info = data.info;
              $scope.countList.schedules.a = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.a = $scope.countList.schedules.a;
            },
            function(err){
              $scope.popupLoading = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
        if($scope.schCountObj.schedule.i){
          ContentLibrarySrv.getInactiveSchedule($scope.schCountObj.id).then(
            function(data){
              $scope.popupLoading = false;
              $scope.loading = false;
              $scope.countList.info = data.info;
              $scope.countList.schedules.i = data.schedules;
              $scope.countList.framelayout = data.framelayout;
              $scope.filtered.i = $scope.countList.schedules.i;
            },
            function(err){
              $scope.popupLoading = false;
              $scope.loading = false;
              $log.error(err);
            }
          );
        }
      } else if(caller == "kiosk"){
        $scope.kListLoading = true;
        JciMapSrv.getKioskList().then(
          function(data){
            $scope.kListLoading = false;
            $scope.loading = false;
            $scope.kioskList = data;
          }, function(err){
            $scope.kListLoading = false;
            $scope.loading = false;
            $log.error(err);
          }
        );
      }
    }
    $rootScope.selectedTabFx = function(){
      if($rootScope.selectedT == 1){
        $scope.jsonObj.tab = $scope.jsonObj.data.playbook;
      } else if($rootScope.selectedT == 2){
        $scope.jsonObj.tab = $scope.jsonObj.data.stories;
      } else if($rootScope.selectedT == 3){
        $scope.jsonObj.tab = $scope.jsonObj.data.scenes;
      } else if($rootScope.selectedT == 4){
        $scope.jsonObj.tab = {stories:$scope.jsonObj.data.stories, scenes:$scope.jsonObj.data.scenes};
      } else{
        $scope.jsonObj.tab = [];
      }
      $("#jsonQuad").empty();
      $("#jsonQuad").append(
        renderjson.set_show_by_default(true).set_show_to_level(2).set_icons('►', '▼')($scope.jsonObj.tab)
      );
    };
    $scope.jsonViewOpen = function(id, label){
      $scope.jsonObj = {id:id, label:label, data:"", tab:""};
      $scope.popupLoading = true;
      $rootScope.selectedT = 1;
      ContentLibrarySrv.f45JsonView($scope.jsonObj.id).then(
        function(data){
          $scope.popupLoading = false;
          $scope.jsonObj.data = data;
          setTimeout(function(){
            $rootScope.selectedTabFx();
          }, 500);
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/popup/f45JsonViewer.html',
        width:600,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.fbGalleryFxx = function(pages,thumb,label,extn,url){
      $scope.fbGallery = {};
      $scope.curfbObj1 = [];
      $scope.tempBucket = "";
      $scope.tempBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.tempBucket = $scope.contentLibrary.info.mbucket;
      }

      if(pages > 1 && url){
        ContentLibrarySrv.getFilePages({u:url.split("?")[0], pn:pages}).then(
          function(data){
            angular.forEach(data, function(item){
              $scope.curfbObj1.push({href:$scope.tempBucket + item.url, title:label, extn:extn});
            });
            $scope.fbGallery = $scope.curfbObj1;
            fancyboxService.fancyboxPlus()($scope.fbGallery, $scope.fbGroup);
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.secureThumb = $filter("secureThumb")(thumb);
        $scope.splitthumb = $scope.secureThumb.split('_');
        $scope.mainthumb = $scope.splitthumb[1].split('.');
        for(var i = 0; i < pages; i++){
          if(i <= 9){
            $scope.curfbObj1.push({href:$scope.tempBucket + $scope.splitthumb[0]+ "_" +"00"+ i + "." +$scope.mainthumb[1], title:label, extn:extn});
          } else if(9 < i <= 99){
            $scope.curfbObj1.push({href:$scope.tempBucket + $scope.splitthumb[0]+ "_" +"0"+ i + "." +$scope.mainthumb[1], title:label, extn:extn});
          } else if(99 < i <= 999){
            $scope.curfbObj1.push({href:$scope.tempBucket + $scope.splitthumb[0]+ "_" + i + "." +$scope.mainthumb[1], title:label, extn:extn});
          }
        }
        $scope.fbGallery = $scope.curfbObj1;
        fancyboxService.fancyboxPlus()($scope.fbGallery, $scope.fbGroup);
      }
    }

    $scope.fbStreamingFx = function(data){
      var urlObj = "";
      if(data.dType == "hls"){
        urlObj = '<iframe src="'+ $scope.apiHost + 'feed/hls?cid=' + data.id + '&cl=0&mute=1" style="width:635px;height:300px;border:0"></iframe>';
      } else if(data.dType == "https"){
        urlObj = '<iframe src="' + data.url + '" style="width:635px;height:300px;border:0"></iframe>';
      } else if(data.dType == "rtsp"){
        urlObj = '<div id="lsplayer-' + "," + '-' + data.id + '" style="height:300px"><div id="lsplayer-' + "," + '-' + data.id + '-vid" style="height:' + this.prop.h + 'px;"></div></div>';
      } else if(data.dType == "yt"){
        var listSrc = "";
        var vidSrc = "";
        if(data.url.indexOf("?list=") >= 0){
          listSrc = data.url.split("?list=")[1].split("&")[0];
        }
        if(data.url.indexOf("?v=") >= 0){
          vidSrc = data.url.split("?v=")[1].split("&")[0];
        }
        if(listSrc != ""){
          urlObj = '<iframe src="https://www.youtube.com/embed/'+ vidSrc +'?autoplay=1&loop=1&controls=0&enablejsapi=1&playlist='+ listSrc + '&mute=1" referrerpolicy="strict-origin-when-cross-origin" style="width:635px;height:300px;border:0"></iframe>';
        } else{
          urlObj = '<iframe src="https://www.youtube.com/embed/'+ vidSrc +'?autoplay=1&loop=1&controls=0&enablejsapi=1&mute=1" referrerpolicy="strict-origin-when-cross-origin" style="width:635px;height:300pxpx;border:0"></iframe>';
        }
      }
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        content:urlObj,
        beforeShow:function(){},
        afterLoad:function(){
          this.title = data.label;
        },
      });
    }

    $scope.$on('folderBriefFx',function(event, data){
      $scope.folderBriefFx(data);
    });
    $scope.$on('briefFx',function(event, data){
      $scope.briefFx(data);
    });

    $scope.showToAdminFx = function(id){
      ContentLibrarySrv.showToAdmin(id).then(
        function(data){
          $scope.contentBrief.wp = data.wp;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.showAllKioskIdsFx = function(){
      $scope.searchTextPopup = "";
      $scope.kioskList = [];
      $scope.kListLoading = true;
      JciMapSrv.getKioskList().then(
        function(data){
          $scope.kListLoading = false;
          $scope.kioskList = data;
        }, function(err){
          $scope.kListLoading = false;
          $log.error(err);
        }
      );

      ngDialog.open({
        template:'app/contentLibrary/popup/kioskIdsList.html',
        width:700,
        data:$scope.dataObj,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.restrictionInfo = function(tabName, sl){
      $scope.readMeObj = {
        tabName:tabName,
        severity:sl
      };
      ngDialog.open({
        template:'app/common/popup/levelInfo.html',
        width:820,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    // $scope.pinToDBFx = function(){
    //   $scope.reqObj = $rootScope.selectedItems.map(function(item){
    //     return {id:item.id,type:'content',subType:item.type};
    //   });
    //   CommonSrv.pinUnpinItems({"selectedItems":$scope.reqObj}, "pin").then(
    //     function(data){
    //       $scope.loadSelectedTab();
    //     },
    //     function(err){
    //       $log.error(err);
    //     }
    //   );
    // }

    
    // TODO OD/SP ReAuth
    $rootScope.$on('ngDialog.opened', function (e, $dialog){
      $scope.confirmDialog = $dialog.attr('id');
    });

    $scope.openReAuthUrlFx = function(w, h, caller){
      $scope.fCallerReAuth = caller;
      if(caller == "spRe" || caller == "spReOu"){
        $scope.popProcessing = true;
        $scope.fCallerReAuth = "sp";
      }
      if(caller == "odRe" || caller == "odReOu"){
        $scope.popProcessing = true;
        $scope.fCallerReAuth = "od";
      }
      ContentLibrarySrv.clearSession($scope.fCallerReAuth).then(
        function(data){
          $scope.left = (screen.width/2)-(w/2);
          $scope.top = (screen.height/2)-(h/2);

          $scope.authProcessing = true;

          $scope.hasErr = false;
          $scope.errType = "";
          if(caller == "spReOu" || caller == "odReOu"){
            var newWindow = window.open("https://login.microsoftonline.com/common/oauth2/logout", 'logout','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ $scope.top +', left='+ $scope.left);
          }
          $scope.timer = setTimeout(
            function(){
              if($scope.timer){
                clearTimeout($scope.timer);
              }
              if(caller != "sp" && caller != "od"){
                $scope.popProcessing = false;
                ngDialog.close($scope.confirmDialog);
                if(caller == "spReOu" || caller == "odReOu"){
                  newWindow.close();
                }
              }
              if($scope.fCallerReAuth == "sp"){
                $scope.childWindow = window.open($scope.spReAuthUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
              } else if($scope.fCallerReAuth == "od"){
                $scope.childWindow = window.open($scope.odReAuthUrl, 'Authorize access to your account', 'toolbar=no,directories=no,status=no,width='+ w +', height='+ h +', top='+ $scope.top +', left='+ $scope.left);
              }
              $scope.childWindowInt = $interval($scope.reAuthCheckChild, 500);
            }, 2000);
          return false;
        },
        function(err){
          $log.error(err);
        }
      );
    }



    // Function to create the vertical strip
    function createVerticalStrip(urls, callback) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var imgWidth = $scope.preWidth; // Width of each image
      var imgHeight = $scope.preHeight; // Height of each image
      // Total height of the canvas will be the sum of all image heights
      var totalHeight = imgHeight * urls.length;
      canvas.width = $scope.preWidth;
      // canvas.width = 90;
      canvas.height = totalHeight;

      var loadedCount = 0;

      // Loop through the URLs to load images
      for (var i = 0; i < urls.length; i++) {
        var img = new Image();
        img.crossOrigin = 'Anonymous';
        
        img.src = urls[i];

        img.onload = function(index) {
          return function() {
            // var xPos = (canvas.width - imgWidth) / 2;
            ctx.drawImage(this, 0, index * imgHeight, imgWidth, imgHeight);
            loadedCount++;

            // Once all images are loaded, generate the final data URL
            if (loadedCount === urls.length) {
              var finalImageUrl = canvas.toDataURL('image/png');
              callback(finalImageUrl); // Call the callback with the final URL
            }
          };
        }(i);

        img.onerror = function() {
          console.error("Failed to load image at " + this.src);
        };
      }
    }

    $scope.isHovering = {};
    $scope.vIndexerIntervalId = null;
    $scope.finalStripUrl = "";
    $scope.preWidth = "";
    $scope.preHeight = "";
    $scope.startCycle = function(content, event){
      if($scope.auth.upermissions.vi && content.type == 'Video' && content.vi && content.viD.st == 's' && content.viD.stpSt){
        // $scope.stopCycle(content, event);
        $scope.finalStripUrl = ""
        // $scope.imageUrls = [];
        $scope.haveImage = true;

        var element = event.target;
        var totalFrames = content.viD.stpImg; // Total number of thumbnails in the strip
        $scope.currentFrame = 0;
        $scope.preWidth = element.offsetWidth;
        $scope.preHeight = element.offsetHeight;
        if($scope.haveImage){
          // createVerticalStrip($scope.imageUrls, function(finalImageUrl) {
          if(!content.viD.stpUrl || content.viD.stpUrl == {}){
            $scope.finalStripUrl = $scope.contentLibrary.info.bucket + 'videos/thumbs/vi/' + $scope.thumbSize + '/' +content.viD.id +'.jpg'; // Store the final strip URL for further use
          }
          if(content.viD.stpUrl && content.viD.stpUrl[$scope.thumbSize]){
            $scope.finalStripUrl = $scope.contentLibrary.info.bucket + content.viD.stpUrl[$scope.thumbSize]; // Store the final strip URL for further use
          }
          // });
          // var imgLoader = null;
          // imgLoader = new Image();
          // imgLoader.src = $scope.finalStripUrl;
        
          // imgLoader.removeEventListener("load", function(){console.log("Sucess");});
          // imgLoader.addEventListener("load", function(){ 
          // })

          // imgLoader.onload = function () {
            element.style.width = $scope.preWidth+'px';
            element.style.height = $scope.preHeight+'px';
            element.style.backgroundPosition = '0 0';
            // Start cycling through frames
            
            element.style.backgroundImage = 'url('+$scope.finalStripUrl+')';
            $scope.vIndexerIntervalId = setInterval(function() {
              // Calculate the next frame's position
              $scope.currentFrame = ($scope.currentFrame + 1) % totalFrames;
              var newPosition = -($scope.currentFrame * $scope.preHeight); // Negative value to shift to next image
          
              // Update the background position
              $scope.$apply(function(){
                $scope.isHovering[content.id] = true;
                if($scope.currentFrame == 0){
                  element.style.backgroundPosition = '0 0';
                } else{
                  element.style.backgroundPosition = '0'+ newPosition +'px';
                }
              });
            }, 1000); // Change frame every 1 second     
          // };

        
        }
      }
    }
    $scope.stopCycle = function stopCycle(content, event) {
      if($scope.auth.upermissions.vi && content.type == 'Video' && content.vi && content.viD.st == 's'){
        var element = event.target;
        $scope.isHovering[content.id] = false;
        // Stop the interval
        clearInterval($scope.vIndexerIntervalId);
        $scope.vIndexerIntervalId = null;
        $scope.finalStripUrl = "";
      
        // Reset to the first frame
        element.style.width = "";
        element.style.height = "";
        element.style.backgroundImage = '';
        element.style.backgroundPosition = '0 0';
      }
    }
    
    $scope.viewVIndexer = function(id, vid){
      localStorage.setItem("inFolder", $scope.curFolderId);
      localStorage.setItem("preState", $scope.selectedTab);
      $state.go("hub.contentLibraryVidIndexer", {
        id:$scope.hubEncrypt(id + '||' + vid)
      });
    }

    $scope.reIndexLoad = false;
    $scope.getVIndexer = function(content, caller, info){
      $scope.reIndexLoad = true;
      var obj = {'vid':content.id};
      ContentLibrarySrv.getVIndexer(obj).then(
        function(data){
          if(data.st == 'p' && data.id && data.id != ""){
            content.vi = 1;
            content.viD.id = data.id;
            content.viD.st = 'p';
            content.viD.pc = 0;
            $scope.viProArr.push({id:content.id, vId:data.id});
            // $scope.viProArr.push(content.id);
            clearInterval($scope.viStatusProIntervalId);
            $scope.viStatusProIntervalId = null;
            $scope.getStatusVIndexer($scope.viProArr);
            $scope.reIndexLoad = false;
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.reAuthCheckChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        if($scope.fCallerReAuth == "sp"){
          ContentLibrarySrv.getSpSites().then(
            function(data){
              $scope.authProcessing = false;
              if(data.isClosed){
                $rootScope.toastNotificationFx("info", {code:8196});
                $scope.loadSelectedTab("refresh");
              } else{
                $rootScope.toastNotificationFx("danger", {code:8195});
              }
            },
            function(err){
              $log.error(err);
            }
          );
        } else if($scope.fCallerReAuth == "od"){
          ContentLibrarySrv.getVerify().then(
            function(data){
              $scope.authProcessing = false;
              if(data.code == 8195){
                $rootScope.toastNotificationFx("danger", {code:8195});
                return;
              } else{
                if(data.isClosed){
                  $rootScope.toastNotificationFx("info", {code:8196});
                  $scope.loadSelectedTab("refresh");
                } else{
                  $rootScope.toastNotificationFx("danger", {code:8195});
                }
              }
            },
            function(err){
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.reAuthCUOpen = function(type){
      $scope.hasErr = false;
      $scope.errType = "";
      localStorage.removeItem("curPathId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');      
      $scope.popProcessing = false;
      
      if(type == "spRe" || type == "spReOu"){
        ContentLibrarySrv.getSpUrl($scope.curFolderId).then(
          function(data){
            $scope.spReAuthUrl = data.url;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      if(type == "odRe" || type == "odReOu"){
        ContentLibrarySrv.getOdUrl($scope.curFolderId).then(
          function(data){
            $scope.odReAuthUrl = data.url;
          },
          function(err){
            $log.error(err);
          }
        );
      }
      $scope.reAuthObjType = type;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="reAuthObjType == \'spRe\' || reAuthObjType == \'odRe\'">{{"ms.msg.38" | translate}}</span>\
              <span ng-if="reAuthObjType == \'spReOu\' || reAuthObjType == \'odReOu\'">{{"cl.widget.msg.10.2" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="openReAuthUrlFx(626, 450, reAuthObjType);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing" aria-hidden="true"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('VideoCaptionEditorController', VideoCaptionEditorController);

  /** @ngInject */
  function VideoCaptionEditorController($log, $rootScope, $scope, $state, $cookies, $timeout, $window, $filter, ngDialog, FileModelUploadSrv, ContentLibrarySrv){
    $rootScope.selectedMenu = 1; //For LeftPanel Menu selected

    $scope.replaceProcessing = false;
    $scope.isNewPermission = false;
    $scope.saveProcessing = false;
    $scope.newProcessing = false;
    $scope.contentLoading = true;
    $scope.importProcessing = false;
    $scope.contentInfo = {};
    $scope.isEmpty = true;
    $scope.curObj = {};
    $scope.selectedObj;
    $scope.addCaption = {begin:"", end:"", text:""};
    $scope.addCue = {time:""};
    $scope.curLangObj = {id:"", label:""};
    $scope.tooltipMsg = "";
    $scope.captionSrc = "";
    $scope.selectedTab = $state.current.name;
    $scope.selectedT = 0;
    $scope.encVId = localStorage.getItem("vId");
    $scope.removeLength = 0;
    $scope.cueRemoveLength = 0;
    $scope.isChecked = {all:false};
    $scope.langId = "";
    $scope.isImport = false;

    if($scope.auth.upermissions.c){
      if(!$scope.auth.upermissions.ar && (localStorage.getItem("inFolder") == 0)){
        $scope.isNewPermission = true;
        $scope.tooltipMsg = $filter("translate")('cl.p_cEdit.m10');
      }
    } else{
      $scope.isNewPermission = true;
      $scope.tooltipMsg = $filter("translate")('cl.p_cEdit.m11');
    }

    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadLanguagesTab();
    });

    //uncheck all selected captions
    $scope.uncheckAllCapFx = function(){
      $scope.isChecked.all = false;
      $scope.removeLength = 0;
      angular.forEach($scope.contentInfo.caption, function(item){
        if(item.caption.length > 0){
          angular.forEach(item.caption, function(caption){
            caption.isChecked = false;
          });
        }
      });
    }

    //change language tabs
    $scope.tabFx = function(index, curLang){
      $scope.contentInfo = angular.copy($scope.copyInfo);
      $scope.getEndTime($scope.contentInfo.duration);
      $scope.uncheckAllCapFx();
      $scope.resetImportFx();
      $scope.selectedT = index;
      $scope.isEdit = false;

      angular.forEach($scope.contentInfo.caption[$scope.selectedT].caption, function(cap){
        cap.show = false;
      });

      $scope.curLang = {id:curLang.id, name:curLang.label, isSel:true};
      angular.forEach($scope.contentInfo.caption, function(item){
        if(item.id == curLang.id){
          item.isSel = true;
          $scope.contentInfo.curType = item.type;
        } else{
          item.isSel = false;
        }
      })
    }

    $scope.loadLanguagesTab = function(){
      $scope.curState = $state.current.name;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.isEdit = false;
      $scope.dataLoading = true;
      $scope.cueRemoveLength = 0;
      $scope.uncheckAllCapFx();
      if(!angular.isUndefined($scope.curLang)){
        $scope.langId = $scope.curLang.id;
      }
      //langId is passing for get language selected isSel:true for tab
      ContentLibrarySrv.getInfo($scope.hubDecrypt($scope.encVId), $scope.langId).then(
        function(data){
          $scope.bucket = $scope.detailBucket = data.bucket;
          if(data.mbucket && data.mbucket != ""){
            $scope.detailBucket = data.mbucket;
          }

          if(data.duration){/*Video Editor*/
            $scope.contentLoading = false;
            //it is previouse object
            $scope.contentInfo = {w:data.w, h:data.h, s:data.s, id:data.id, type:data.type, hasAudio:data.hasAudio, start:"000000", label:data.label, src:$scope.detailBucket + data.src, caption:data.caption, cue:data.cue, isCaptionProcessing:data.isCaptionProcessing, ev:{res:"", ar:"", cq:"23", vc:"h264", pre:"medium", tu:"", pro:"", level:"", fps:"", ac:"aac", ab:"", vol:""}};

            if(data.cue.length > 0){
              angular.forEach(data.cue, function(item, i){
                item.isChecked = false;
              });
            }

            angular.forEach(data.caption, function(item){
              if(item.isSel){
                $scope.contentInfo.curType = item.type;
                $scope.contentInfo.subtype = item.subtype;
              }
            })

            angular.forEach(data.caption, function(item, i){
              angular.forEach(item.caption, function(cItem){
                cItem.isChecked = false;
              });
            });

            $scope.getEndTime = function(_seconds){
              var hours = Math.floor(_seconds / 3600) + '',
                minutes = Math.floor((_seconds % 3600) / 60) + '',
                seconds = Math.floor(_seconds % 60) + '';
              if(hours <= 9){
                hours = 0 + hours;
              }
              if(minutes <= 9){
                minutes = 0 + minutes;
              }
              if(seconds <= 9){
                seconds = 0 + seconds;
              }
              $scope.contentInfo.end = hours.concat(minutes).concat(seconds);
            }
            $scope.getEndTime(data.duration);

            if($scope.contentInfo.start != ""){
              $scope.curSHours = angular.copy($scope.contentInfo.start.split("")[0] + $scope.contentInfo.start.split("")[1]);
              $scope.curSMinutes = angular.copy($scope.contentInfo.start.split("")[2] + $scope.contentInfo.start.split("")[3]);
              $scope.curSSeconds = angular.copy($scope.contentInfo.start.split("")[4] + $scope.contentInfo.start.split("")[5]);
            }
            if($scope.contentInfo.end != ""){
              $scope.curEHours = angular.copy($scope.contentInfo.end.split("")[0] + $scope.contentInfo.end.split("")[1]);
              $scope.curEMinutes = angular.copy($scope.contentInfo.end.split("")[2] + $scope.contentInfo.end.split("")[3]);
              $scope.curESeconds = angular.copy($scope.contentInfo.end.split("")[4] + $scope.contentInfo.end.split("")[5]);
            }

            $scope.copyInfo = angular.copy($scope.contentInfo);
          }
          $scope.dataLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
      localStorage.setItem("curFId", localStorage.getItem("inFolder"));
    }
    $scope.loadLanguagesTab();

    $scope.updateCaptionFx = function(){
      ContentLibrarySrv.getInfo($scope.hubDecrypt($scope.encVId)).then(
        function(data){
          $scope.contentInfo.caption[$scope.selectedT].caption = data.caption[$scope.selectedT].caption;
          $scope.contentInfo.caption[$scope.selectedT].captionSrc = data.caption[$scope.selectedT].captionSrc;
          $scope.contentInfo.caption[$scope.selectedT].type = data.caption[$scope.selectedT].type;
          $scope.contentInfo.caption[$scope.selectedT].subtype = data.caption[$scope.selectedT].subtype;
        },
        function(err){
          $log.error(err);
        }
      );
      $scope.resetImportFx();
    }

    $scope.addCaptionFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.end = $scope.contentInfo.end;
      $scope.start = $scope.contentInfo.start;

      if($scope.end != ""){
        $scope.eHours = $scope.end.split("")[0] + $scope.end.split("")[1];
        $scope.eMinutes = $scope.end.split("")[2] + $scope.end.split("")[3];
        $scope.eSeconds = $scope.end.split("")[4] + $scope.end.split("")[5];
      }

      if($scope.addCaption.text == ""){
        $scope.hasErr = true;
        $scope.errType = "caption";
      } else if($scope.addCaption.begin == "" || $scope.addCaption.end == ""){
        $scope.hasErr = true;
        $scope.errType = "captionTime";
      } else{
        $scope.sHours = $scope.addCaption.begin.split("")[0] + $scope.addCaption.begin.split("")[1];
        $scope.sMinutes = $scope.addCaption.begin.split("")[2] + $scope.addCaption.begin.split("")[3];
        $scope.sSeconds = $scope.addCaption.begin.split("")[4] + $scope.addCaption.begin.split("")[5];

        $scope.eHours = $scope.addCaption.end.split("")[0] + $scope.addCaption.end.split("")[1];
        $scope.eMinutes = $scope.addCaption.end.split("")[2] + $scope.addCaption.end.split("")[3];
        $scope.eSeconds = $scope.addCaption.end.split("")[4] + $scope.addCaption.end.split("")[5];

        if($scope.sHours + $scope.sMinutes + $scope.sSeconds > $scope.curEHours + $scope.curEMinutes + $scope.curESeconds){
          $scope.hasErr = true;
          $scope.errType = "sNotValid";
        } else if($scope.eHours + $scope.eMinutes + $scope.eSeconds > $scope.curEHours + $scope.curEMinutes + $scope.curESeconds){
          $scope.hasErr = true;
          $scope.errType = "eNotValid";
        } else if($scope.eHours + $scope.eMinutes + $scope.eSeconds < $scope.sHours + $scope.sMinutes + $scope.sSeconds){
          $scope.hasErr = true;
          $scope.errType = "eNotValid";
        } else{
          if($scope.contentInfo.caption[$scope.selectedT].isCaptionProcessing){
            $scope.contentInfo.caption[$scope.selectedT].caption.push({isChecked:false, begin:$scope.timeSeparator($scope.addCaption.begin, 2).join(":"), end:$scope.timeSeparator($scope.addCaption.end, 2).join(":"), text:$scope.addCaption.text});

            $scope.captionInfo = {id:$scope.contentInfo.id, captions:$scope.contentInfo.caption[$scope.selectedT].caption,
            lang:{id:$scope.contentInfo.caption[$scope.selectedT].id,label:$scope.contentInfo.caption[$scope.selectedT].label, type:$scope.contentInfo.caption[$scope.selectedT].type, subtype:$scope.contentInfo.caption[$scope.selectedT].subtype}};

            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.p_cEdit.m19" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileImportFx(captionInfo, \'add\');" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(); updateCaptionFx();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else{
            $scope.contentInfo.caption[$scope.selectedT].caption.push({isChecked:false, begin:$scope.timeSeparator($scope.addCaption.begin, 2).join(":"), end:$scope.timeSeparator($scope.addCaption.end, 2).join(":"), text:$scope.addCaption.text});

            $scope.captionInfo = {id:$scope.contentInfo.id, captions:$scope.contentInfo.caption[$scope.selectedT].caption,
            lang:{id:$scope.contentInfo.caption[$scope.selectedT].id,label:$scope.contentInfo.caption[$scope.selectedT].label, type:$scope.contentInfo.caption[$scope.selectedT].type, subtype:$scope.contentInfo.caption[$scope.selectedT].subtype}};

            $scope.fileImportFx($scope.captionInfo, "add");
          }
        }
      }
    }
    $scope.timeSeparator = function(str, n){
      var ret = [];
      var i;
      var len;
      for(i = 0, len = str.length; i < len; i += n){
        ret.push(str.substr(i, n))
      }
      return ret
    };

    /*Video Editor*/
    /*Import File*/
    $rootScope.fileModelUploadFx = function(data){
      $scope.curData = data;
      $scope.fileModelLoading = true;
      FileModelUploadSrv.uploadFile("common/srtTojson", $scope.curData).then(
        function(data){
          $scope.convertData = data;
          if($scope.convertData.code == 8129){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.p_cEdit.m15" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog(); resetImportFx();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else if($scope.convertData.length){
            $scope.removeLength = 0;

            $scope.captionInfo = {id:$scope.contentInfo.id, captions:$scope.convertData,
            lang:{id:$scope.contentInfo.caption[$scope.selectedT].id,label:$scope.contentInfo.caption[$scope.selectedT].label, type:"import", subtype:""}};

            $scope.captionExists = false;
            angular.forEach($scope.contentInfo.caption, function(item){
              if(item.id == $scope.captionInfo.lang.id){
                if(item.caption.length > 0){
                  $scope.captionExists = true;
                }
              }
            })

            if($scope.contentInfo.caption[$scope.selectedT].isCaptionProcessing){
              $scope.fileModelLoading = false;
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"cl.p_cEdit.m19" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileImportFx(captionInfo, \'import\');" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                      <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(); updateCaptionFx();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:480,
                scope:$scope,
                closeByDocument:false,
                className:'ngdialog-theme-default ngdialog-confirm'
              });
            } else{
              if($scope.captionExists){
                $scope.fileModelLoading = false;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">{{"cl.p_cEdit.m16" | translate}}</div>\
                      <footer class="panel-footer">\
                        <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="fileImportFx(captionInfo, \'import\');" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                        <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(); resetImportFx();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                      </footer>\
                    </section>',
                  plain:true,
                  width:480,
                  scope:$scope,
                  closeByDocument:false,
                  className:'ngdialog-theme-default ngdialog-confirm'
                });
              } else{
                $scope.fileImportFx($scope.captionInfo, "import");
              }
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.fileModelLoading = false;
          ngDialog.close();
          $rootScope.toastNotificationFx("danger", {"code":5000});
        }
      );
    }

    $scope.fileImportFx = function(captionInfo, caller){
      $scope.fileModelLoading = true;
      $scope.importProcessing = true;
      $scope.hasErr = "";
      $scope.hasPopErr = "";
      $scope.errTypePop = "";
      $scope.errType = "";
      $scope.isEdit = false;
      $scope.addCaption = {begin:"", end:"", text:""};
      $scope.addCue = {time:""};

      $scope.curLang = {id:captionInfo.lang.id, name:captionInfo.lang.label, isSel:true};
      angular.forEach($scope.contentInfo.caption, function(item){
        if(item.id == captionInfo.lang.id){
          item.isSel = true;
          $scope.contentInfo.curType = item.type;
        } else{
          item.isSel = false;
        }
      })
      if(caller == "add"){
        captionInfo.capType = "add";
      }
      ContentLibrarySrv.importCaptions(captionInfo).then(
        function(data){
          if(data.code == 8254){
            $scope.hasPopErr = true;
            $scope.errType = "lExist";
            $scope.fileModelLoading = false;
            $scope.importProcessing = false;
          } else{
            $scope.fileModelLoading = false;
            $scope.saveCProcessing = false;
            ngDialog.close();
            ContentLibrarySrv.getInfo($scope.contentInfo.id).then(
              function(data){
                $scope.importProcessing = false;
                $scope.contentInfo.caption[$scope.selectedT].caption = data.caption[$scope.selectedT].caption;
                $scope.contentInfo.caption[$scope.selectedT].captionSrc = data.caption[$scope.selectedT].captionSrc;//Added when rise the issue on export time
                $scope.contentInfo.caption[$scope.selectedT].type = data.caption[$scope.selectedT].type;
                $scope.contentInfo.caption[$scope.selectedT].subtype = data.caption[$scope.selectedT].subtype;
                $scope.copyInfo = data;
                $scope.uncheckAllCapFx();
              }
            );
          }
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
    }

    $scope.importOpenFx = function(){
      $("#myImport").trigger("click");
    }

    $scope.resetImportFx = function(){
      angular.element("input[type='file']").val(null);
      $scope.addCaption = {begin:"", end:"", text:""};
      $scope.hasPopErr = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.convertData = "";
      $scope.curData = "";
    }

    $scope.setSubTypeFx = function(subType){
      //reset edit caption inputs
      angular.forEach($scope.contentInfo.caption[$scope.selectedT].caption, function(cap){
        cap.show = false;
      });
      $scope.isEdit = false;

      $scope.contentInfo.caption[$scope.selectedT].type = "generate";
      $scope.contentInfo.caption[$scope.selectedT].subtype = subType;
      $scope.replaceVidFx('generate');
      $scope.uncheckAllCapFx();
    }

    $scope.checkedFx = function(caller){
      if(caller == "all"){
        for(var i=0; i<$scope.contentInfo.caption[$scope.selectedT].caption.length; i++){
          $scope.contentInfo.caption[$scope.selectedT].caption[i].isChecked = $scope.isChecked.all;
        }
        $scope.removeLength = $filter("filter")($scope.contentInfo.caption[$scope.selectedT].caption, {isChecked:true}).length;
      } else{
        $scope.removeLength = $filter("filter")($scope.contentInfo.caption[$scope.selectedT].caption, {isChecked:true}).length;

        if($scope.removeLength == $scope.contentInfo.caption[$scope.selectedT].caption.length){
          $scope.isChecked.all = true;
        } else{
          $scope.isChecked.all = false;
        }
      }
      $scope.removeLength = $filter("filter")($scope.contentInfo.caption[$scope.selectedT].caption, {isChecked:true}).length;
    }
    $scope.removeConfirm = function(){
      if($scope.removeLength > 0){
        ngDialog.open({
          template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{removeLength==1?"cm.msg.34":"cm.msg.34s" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeFx();" focus-me="true">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      }
    }
    $scope.removeFx = function(){
      if($scope.isChecked.all){
        for (var i = 0; i < $scope.contentInfo.caption.length; i++){
          if($scope.contentInfo.caption[i].id == $scope.contentInfo.caption[$scope.selectedT].id){
            $scope.captionInfo = {id:$scope.contentInfo.id, captions:[], lang:{id:$scope.contentInfo.caption[i].id,label:$scope.contentInfo.caption[i].label,type:$scope.contentInfo.caption[i].type, subtype:""}};
            break;
          }
        }
      } else{
        $scope.contentInfo.caption[$scope.selectedT].caption = $filter("filter")($scope.contentInfo.caption[$scope.selectedT].caption, {isChecked:false});

        $scope.captionInfo = {id:$scope.contentInfo.id, captions:$scope.contentInfo.caption[$scope.selectedT].caption,
        lang:{id:$scope.contentInfo.caption[$scope.selectedT].id,label:$scope.contentInfo.caption[$scope.selectedT].label, type:$scope.contentInfo.caption[$scope.selectedT].type, subtype:$scope.contentInfo.caption[$scope.selectedT].subtype}};
      }

      $scope.fileImportFx($scope.captionInfo, "remove");
      $scope.isChecked.all = false;
      $scope.removeLength = 0;
      ngDialog.close();
    }

    $scope.resetVidFx = function(){
      $scope.contentInfo = angular.copy($scope.copyInfo);
      $scope.isChecked.all = false;
      $scope.hasErr = false;
      $scope.hasPopErr = false;
      $scope.errType = "";
      $scope.removeLength = 0;
    }

    $scope.generateCaptionsFx = function(contentInfo){
      $scope.fileModelLoading = true;
      $scope.saveProcessing = true;

      ContentLibrarySrv.generateCaptions(contentInfo).then(
        function(data){
          $scope.saveProcessing = false;
          $scope.fileModelLoading = false;
          ngDialog.close();
          $scope.updateCaptionFx();
          $scope.loadLanguagesTab();
        },
        function(err){
          $log.error(err);
          $scope.saveProcessing = false;
          $scope.fileModelLoading = false;
        }
      );
    }

    $scope.saveVideoFx = function(caller){
      $scope.errType = "";
      $scope.hasErr = false;
      $scope.end = $scope.contentInfo.end;
      $scope.start = $scope.contentInfo.start;

      if($scope.start != ""){
        $scope.sHours = $scope.start.split("")[0] + $scope.start.split("")[1];
        $scope.sMinutes = $scope.start.split("")[2] + $scope.start.split("")[3];
        $scope.sSeconds = $scope.start.split("")[4] + $scope.start.split("")[5];
      }
      if($scope.end != ""){
        $scope.eHours = $scope.end.split("")[0] + $scope.end.split("")[1];
        $scope.eMinutes = $scope.end.split("")[2] + $scope.end.split("")[3];
        $scope.eSeconds = $scope.end.split("")[4] + $scope.end.split("")[5];
      }

      if($scope.sHours + $scope.sMinutes + $scope.sSeconds > $scope.curEHours + $scope.curEMinutes + $scope.curESeconds){
        $scope.hasErr = true;
        $scope.errType = "sNotValid";
      } else if($scope.eHours + $scope.eMinutes + $scope.eSeconds > $scope.curEHours + $scope.curEMinutes + $scope.curESeconds){
        $scope.hasErr = true;
        $scope.errType = "eNotValid";
      } else if($scope.contentInfo.label == ""){
        $scope.hasErr = true;
        $scope.errType = "label";
      } else if($scope.contentInfo.start == ""){
        $scope.hasErr = true;
        $scope.errType = "start";
      } else if($scope.contentInfo.end == ""){
        $scope.hasErr = true;
        $scope.errType = "end";
      } else if($scope.sMinutes > 59 || $scope.sSeconds > 59){
        $scope.hasErr = true;
        $scope.errType = "sNotValid";
      } else if($scope.eMinutes > 59 || $scope.eSeconds > 59){
        $scope.hasErr = true;
        $scope.errType = "eNotValid";
      } else if($scope.contentInfo.start >= $scope.copyInfo.end){
        $scope.hasErr = true;
        $scope.errType = "slNotValid";
      } else if($scope.contentInfo.end <= $scope.contentInfo.start){
        $scope.hasErr = true;
        $scope.errType = "eslNotValid";
      } else if($scope.contentInfo.end > $scope.copyInfo.end){
        $scope.hasErr = true;
        $scope.errType = "elNotValid";
      } else if(angular.isUndefined($scope.contentInfo.w) || $scope.contentInfo.w == null){
        $scope.hasErr = true;
        $scope.errType = "width";
      } else if(angular.isUndefined($scope.contentInfo.h) || $scope.contentInfo.h == null){
        $scope.hasErr = true;
        $scope.errType = "height";
      } else if($scope.contentInfo.w % 2 != 0 || $scope.contentInfo.h % 2 != 0){
        $scope.hasErr = true;
        $scope.errType = "oddWH";
      } else if($scope.curState == 'hub.contentLibraryEditCapVid.ev' && $scope.contentInfo.ev.ab != "" && $scope.contentInfo.ev.ab == 0){
        $scope.hasErr = true;
        $scope.errType = "aBitrate";
      } else if($scope.contentInfo.s && caller == "replace" && ($scope.contentInfo.start != $scope.copyInfo.start || $scope.contentInfo.end != $scope.copyInfo.end)){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.p_cEdit.m12" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-warning" ng-click="replaceVidFx(\'replace\');" ng-disabled="confirmProcessing"><span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</span></button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        $scope.replaceVidFx(caller);
      }
    }
    $scope.replaceVidFx = function(caller){
      if($scope.contentInfo.editorOpt == "imp" && $scope.contentInfo.caption.length == 0){
        $scope.hasErr = true;
        $scope.errType = "file";
      } else{
        $scope.confirmProcessing = true;
        $scope.contentInfo.type = "video";

        if(caller == "replace"){
          $scope.replaceProcessing = true;
          $scope.contentInfo.method = "replace";
        } else if(caller == "new"){
          $scope.newProcessing = true;
          $scope.contentInfo.method = "new";
        } else if(caller == "generate"){
          $scope.contentInfo.lang = {id:$scope.contentInfo.caption[$scope.selectedT].id, label:$scope.contentInfo.caption[$scope.selectedT].label, type:$scope.contentInfo.caption[$scope.selectedT].type, subtype:$scope.contentInfo.caption[$scope.selectedT].subtype}
        }

        if(caller != "generate"){
          $scope.saveProcessing = true;
          ContentLibrarySrv.updateVideo($scope.contentInfo).then(
            function(data){
              ngDialog.close();
              $state.go("hub.contentLibrary.c");
            },
            function(err){
              $log.error(err);
              $scope.newProcessing = false;
              $scope.saveProcessing = false;
              $scope.replaceProcessing = false;
              $scope.confirmProcessing = false;
            }
          );
        } else{
          if($scope.contentInfo.caption[$scope.selectedT].caption.length > 0){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.p_cEdit.m18" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="generateCaptionsFx(contentInfo);" ng-disabled="fileModelLoading"><span class="fa fa-repeat fa-spin" ng-if="fileModelLoading" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                    <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(); updateCaptionFx();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:480,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          } else{
            $scope.generateCaptionsFx($scope.contentInfo);
          }
        }
      }
    }

    $scope.isEdit = false;
    $scope.captionFx = function(caller){
      $scope.isChecked.all = false;
      $scope.removeLength = 0;
      $scope.hasErr = false;
      $scope.errType = "";

      if(caller == "e"){
        $scope.isEdit = true;
        angular.forEach($scope.contentInfo.caption[$scope.selectedT].caption, function(cap){
          cap.show = true;
        });
      } else if(caller == "c"){
        $scope.isEdit = false;
        $scope.contentInfo.caption[$scope.selectedT].caption = [];
        angular.forEach(angular.element(".captionQuad"), function(cap){
          $scope.contentInfo.caption[$scope.selectedT].caption.push({begin:$(cap).attr("data-begin"), end:$(cap).attr("data-end"), text:$(cap).find(".codeText").text(), show:false});
        });
        $scope.uncheckAllCapFx();
      } else if(caller == "s"){
        $scope.isEmptyCaption = false;
        angular.forEach(angular.element(".captionQuad"), function(cap){
          if($scope.trim($(cap).find("input[type='text']").val()) == ""){
            $scope.isEmptyCaption = true;
            $scope.hasErr = true;
            $scope.errType = "caption";
          }
        });

        if(!$scope.isEmptyCaption){
          $scope.contentInfo.caption[$scope.selectedT].caption = [];
          angular.forEach(angular.element(".captionQuad"), function(cap){
            $scope.contentInfo.caption[$scope.selectedT].caption.push({begin:$(cap).attr("data-begin"), end:$(cap).attr("data-end"), text:$scope.trim($(cap).find("input[type='text']").val())});
          });
          $scope.saveCProcessing = true;
          $scope.isEdit = false;

          $scope.captionInfo = {id:$scope.contentInfo.id, captions:$scope.contentInfo.caption[$scope.selectedT].caption,
          lang:{id:$scope.contentInfo.caption[$scope.selectedT].id,label:$scope.contentInfo.caption[$scope.selectedT].label, type:$scope.contentInfo.caption[$scope.selectedT].type, subtype:$scope.contentInfo.caption[$scope.selectedT].subtype}};
          $scope.fileImportFx($scope.captionInfo, "edit");
        }
      }
    }

    $scope.langObj = {languages:[]}
    $scope.openLanguageFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.popupLoading = true;
      ContentLibrarySrv.getCaptionsLang($scope.contentInfo.id).then(
        function(data){
          $scope.popupLoading = false;
          $scope.langObj.languages = data;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );

      ngDialog.open({
        template:"app/contentLibrary/popup/captionLanguages.html",
        width:680,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default'
      });
    }

    $scope.langAddFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if(!$scope.curLangObj.label){
        $scope.hasErrPop = true;
        $scope.errTypePop = "label";
      } else{
        $scope.langProcessing = true;
        $scope.langDataLoading = true;
        ContentLibrarySrv.saveLanguage($scope.curLangObj).then(
          function(data){
            if (data.code == 8254){
              $scope.hasErrPop = true;
              $scope.errTypePop = "same";
              $scope.langProcessing = false;
              $scope.langDataLoading = false;
            } else if(data.code == 8258 || data.code == 8259){
              ContentLibrarySrv.getCaptionsLang($scope.contentInfo.id).then(
                function(data){
                  $scope.langDataLoading = false;
                  $scope.langProcessing = false;
                  $scope.langObj.languages = data;
                  $scope.langResetFx();
                  $scope.loadLanguagesTab();
                },
                function(err){
                  $scope.langDataLoading = false;
                  $scope.langProcessing = false;
                  $log.error(err);
                }
              );
            }
          },
          function(err){
            $scope.langProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.langEditFx = function(obj){
      $scope.curLangObj = angular.copy(obj);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.langResetFx = function(){
      $scope.curLangObj = {id:"", label:""};
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.langDeleteOpen = function(id){
      $scope.defaultLang = $scope.langObj.languages.filter(function(obj){
        if(obj.label == "English"){
          return obj;
        }
      })
      if(!angular.isUndefined($scope.curLang)){
        if(id == $scope.curLang.id){
          $scope.curLang = {id:$scope.defaultLang[0].id,name:$scope.defaultLang[0].label,isSel:$scope.defaultLang[0].isSel}
        }else{
          $scope.langId = $scope.curLang.id;
        }
      }
      $scope.langDObj = {id:id, processing:false};
      $scope.dialogId = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cl.msg.44" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="langDeleteFx();" focus-me="true" ng-disabled="langDObj.processing"><span class="fa fa-repeat fa-spin" ng-if="langDObj.processing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }
    $scope.langDeleteFx = function(){
      $scope.langDObj.processing = true;
      ContentLibrarySrv.delLanguage($scope.langDObj.id).then(
        function(data){
          $scope.langDObj.processing = false;
          if(data.code == 8260){
            for(var i=0; i<$scope.langObj.languages.length; i++){
              if($scope.langObj.languages[i].id == $scope.langDObj.id){
                $scope.langObj.languages.splice(i, 1);
              }
            }
            $scope.dialogId.close();
            $scope.loadLanguagesTab();
          } else if(data.code == 8261){
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.msg.45" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:420,
              scope:$scope,
              closeByDocument:false,
              className:'ngdialog-theme-default ngdialog-confirm'
            });
          }
        },
        function(err){
          $scope.langDObj.processing = false;
          $log.error(err);
        }
      );
    }

    //Cue Point
    $scope.saveCueFx = function(cueInfo, caller){
      $scope.cueLoading = true;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.addCue = {time:""};
      cueInfo.type = caller;

      ContentLibrarySrv.addCue(cueInfo).then(
        function(data){
          ngDialog.close();
          ContentLibrarySrv.getInfo($scope.contentInfo.id).then(
            function(data){
              $scope.cueLoading = false;
              $scope.contentInfo.cue = data.cue;
              if($scope.contentInfo.cue.length > 0){
                angular.forEach($scope.contentInfo.cue, function(item, i){
                  item.isChecked = false;
                });
              }
              $scope.copyInfo = data;
              $scope.uncheckAllCapFx();
            }
          );
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
    }
    $scope.cueCheckedFx = function(caller){
      if(caller == "all"){
        for(var i=0; i<$scope.contentInfo.cue.length; i++){
          $scope.contentInfo.cue[i].isChecked = $scope.isChecked.all;
        }
        $scope.cueRemoveLength = $filter("filter")($scope.contentInfo.cue, {isChecked:true}).length;
      } else{
        $scope.cueRemoveLength = $filter("filter")($scope.contentInfo.cue, {isChecked:true}).length;

        if($scope.cueRemoveLength == $scope.contentInfo.cue.length){
          $scope.isChecked.all = true;
        } else{
          $scope.isChecked.all = false;
        }
      }
      $scope.cueRemoveLength = $filter("filter")($scope.contentInfo.cue, {isChecked:true}).length;
    }
    $scope.cueRemoveConfirm = function(){
      if($scope.cueRemoveLength > 0){
        ngDialog.open({
          template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{removeLength==1?"cm.msg.34":"cm.msg.34s" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="cueRemoveFx();" focus-me="true">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm'
        });
      }
    }
    $scope.cueRemoveFx = function(){
      if($scope.isChecked.all){
        $scope.cueInfo = {id:$scope.contentInfo.id, cue:[]};
      } else{
        $scope.contentInfo.cue = $filter("filter")($scope.contentInfo.cue, {isChecked:false});
        $scope.cueInfo = {id:$scope.contentInfo.id, cue:$scope.contentInfo.cue};
      }
      $scope.saveCueFx($scope.cueInfo, "remove");
      $scope.isChecked.all = false;
      $scope.cueRemoveLength = 0;
      ngDialog.close();
    }
    $scope.addCueTimeFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";

      $scope.end = $scope.contentInfo.end;
      if($scope.end != ""){
        $scope.eHours = $scope.end.split("")[0] + $scope.end.split("")[1];
        $scope.eMinutes = $scope.end.split("")[2] + $scope.end.split("")[3];
        $scope.eSeconds = $scope.end.split("")[4] + $scope.end.split("")[5];
      }
      if($scope.addCue.time != ""){
        $scope.curCTHours = angular.copy($scope.addCue.time.split("")[0] + $scope.addCue.time.split("")[1]);
        $scope.curCTMinutes = angular.copy($scope.addCue.time.split("")[2] + $scope.addCue.time.split("")[3]);
        $scope.curCTSeconds = angular.copy($scope.addCue.time.split("")[4] + $scope.addCue.time.split("")[5]);
      }

      if($scope.addCue.time == ""){
        $scope.hasErr = true;
        $scope.errType = "cueTime";
      } else if($scope.eHours + $scope.eMinutes + $scope.eSeconds < $scope.curCTHours + $scope.curCTMinutes + $scope.curCTSeconds){
        $scope.hasErr = true;
        $scope.errType = "ctNotValid";
      } else{
        $scope.cueExist = false;
        if($scope.contentInfo.cue.length > 0){
          angular.forEach($scope.contentInfo.cue, function(cue){
            if($scope.timeSeparator($scope.addCue.time, 2).join(":") == cue.time){
              $scope.cueExist = true;
            }
          });
        }
        if($scope.cueExist){
          $scope.hasErr = true;
          $scope.errType = "cueExist";
        } else{
          $scope.contentInfo.cue.push({time:$scope.timeSeparator($scope.addCue.time, 2).join(":")});
          $scope.cueInfo = {id:$scope.contentInfo.id, cue:$scope.contentInfo.cue};
          $scope.saveCueFx($scope.cueInfo, "add");
        }
      }
    }

    $scope.setHeightWidth = function(){
      if($scope.contentInfo.ev.res != "" && $scope.contentInfo.ev.res != "custom"){
        $scope.stringArr = $scope.contentInfo.ev.res.split(/[x(]/);
        $scope.contentInfo.w = parseInt($scope.stringArr[0].trim());
        $scope.contentInfo.h = parseInt($scope.stringArr[1].trim());
      }
    }
  }
})();
angular.module('hub').service('RestartSessionSrv', ['$http', '$q', '$rootScope', '$state', '$window', function($http, $q, $rootScope, $state, $window){
  var httpReq;
  this.restartSession = function(){
    httpReq = $http.get($rootScope.apiHost + "auth/restartSession");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.ssoVerify = function(){
    httpReq = $http.get($rootScope.apiHost + "callback/sso/verify");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    return (response.data);
  }
  this.handleError = function(response){
    if(response.status == 401){
      $rootScope.curLang = localStorage.getItem("loginLang");
      if($rootScope.curLang != "" && ($rootScope.curLang == "en" || $rootScope.curLang == "es" || $rootScope.curLang == "fr" || $rootScope.curLang == "hi")){
        $state.go("login", {id: $rootScope.curLang});
      } else {
        $state.go("login");
      }
      setTimeout(function(){
        $window.location.reload();
      }, 50);
    }
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('MySettingsSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSettings = function(id){
    httpReq = $http.get($rootScope.apiHost + "mySettings/"+id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateEmail = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/email", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updatePass = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/password", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateSettings = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCoordinators = function(){
    httpReq = $http.get($rootScope.apiHost + "mySettings/coordinator");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getUser = function(email){
    httpReq = $http.post($rootScope.apiHost + "mySettings/coordinator/search", email);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.makeUserCoordinator = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/coordinator", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.editUserCoordinator = function(obj){
    httpReq = $http.put($rootScope.apiHost + "mySettings/coordinator", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteCoordinator = function(id, role){
    httpReq = $http.delete($rootScope.apiHost + "mySettings/coordinator/"+ role +"/"+ id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTwoFA = function(obj){
    httpReq = $http.get($rootScope.apiHost + "mySettings/twoFA");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateTwoFA = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/twoFA", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getServersList = function(){
    httpReq = $http.get($rootScope.apiHost + "mySettings/serversList");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getOtherInfo = function(caller){
    httpReq = $http.get($rootScope.apiHost + "mySettings/otherinfo/"+ caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveOtherInfo = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/otherinfo", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getDPS = function(caller){
    httpReq = $http.get($rootScope.apiHost + "mySettings/quads/dp/"+ caller);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveDPS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/quads/dp", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.savePieColors = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mysettings/quads/settings", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceWatermark = function(sId){
    httpReq = $http.get($rootScope.apiHost + "mysettings/deviceWatermark/"+sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveWatermark = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mysettings/deviceWatermark", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Content Storage*/
  this.saveStorageplan = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mysettings/storageplan", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*App Switch*/
  this.getAS = function(){
    httpReq = $http.get($rootScope.apiHost + "mySettings/switches/getswitches");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveAS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/switches/add", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.deleteAS = function(obj){
    httpReq = $http.post($rootScope.apiHost + "mySettings/switches/delete", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Asana Integration*/
  this.getAsnConn = function(){
    httpReq = $http.get($rootScope.apiHost + "asanacp/connections");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.asnAuth = function(){
    httpReq = $http.get($rootScope.apiHost + "asanacp/auth/url");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getAsnWS = function(){
    httpReq = $http.get($rootScope.apiHost + "asanacp/connections/workspaces");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setAsnWS = function(obj){
    httpReq = $http.put($rootScope.apiHost + "asanacp/connections/workspaces", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setAsnCLF = function(obj){
    httpReq = $http.put($rootScope.apiHost + "asanacp/connections/folders", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return(response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return($q.reject("An unknown error occurred."));
    }
    return($q.reject(response.data.message));
  }
}]);

angular.module('hub').service('LocalizationSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getLocalization = function(lang){
    httpReq = $http.get($rootScope.languageHost + lang + ".json?"+new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.handleSuccess = function(response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    }
    return (response.data);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('FileModelUploadSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.uploadFile = function(uploadUrl, file){
    var fd = new FormData();
    fd.append('file', file);
    httpReq = $http.post($rootScope.apiHost + uploadUrl, fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    })
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.uploadFileAndData = function(uploadUrl, obj, file){
    var fd = new FormData();
    fd.append('data', angular.toJson(obj));
    if(file && file.length){
      angular.forEach(file, function(f){
        fd.append('file[]', f);
      });
    } else{
      fd.append('file', file);
    }
    httpReq = $http.post($rootScope.apiHost + uploadUrl, fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type':undefined}
    })
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    if(response.data.code == 4004){
      $rootScope.toastNotificationFx("danger", response.data, response.data.deletedBy);
    }
    return (response.data);
  }
  this.handleError = function(response){
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').service('CommonSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  var canceler;
  this.getAvailableDevice = function(){
    httpReq = $http.get($rootScope.apiHost + "common/availableDevices?"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTimezone = function(){
    httpReq = $http.get($rootScope.apiHost + "common/timezone?"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getNotifications = function(){
    httpReq = $http.get($rootScope.apiHost + "common/notifications?"+ new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.exportDevicesList = function(gbdt, gType, dsg, type, id, s, df, tDevices, dfData, dType, subType, caller, obj){
    if(caller && (caller == 'dashboard' || caller == 'dashboardPopup')){
      if(angular.isUndefined(subType) || subType == ""){
        httpReq = $http.post($rootScope.apiHost + "dashboard/devices?dsg="+dsg+"&s="+s+"&type="+dType, obj);
      } else {
        httpReq = $http.post($rootScope.apiHost + "dashboard/devices?dsg="+dsg+"&s="+s+"&type="+dType+"&subType="+subType, obj);
      }
    } else{
      if(gbdt && gType!=""){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/folder?gType="+ gType+"&dsg="+dsg+"&s="+s+"&f="+df);
      } else if(type == "dashboard"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/dashboard?dsg="+dsg+"&s="+s);
      } else if(type == "tags"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/tags?tagId=" + id + "&dsg="+dsg+"&s="+s);
      } else if(type == "groups"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/groups?groupId=" + id + "&dsg="+dsg+"&s="+s);
      } else if(type == "searches"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/searches?searchId=" + id + "&dsg="+dsg+"&s="+s);
      } else if(type == "ir"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/ir?dsg="+dsg+"&s="+s);
      } else if(type == "schedule"){
        // httpReq = $http.get($rootScope.apiHost + "common/devices/export/advancedSearch?targetDIds="+tDevices + "&dsg="+dsg+"&s="+s);
        // making above api in post
        httpReq = $http.post($rootScope.apiHost + "common/devices/export/schedule?dsg="+dsg+"&s="+s, {"targetDIds":"", id:id});
      } else if(type == "ds" || type == "dtps" || type == "ccs" || type == "dts" || type == "dtpl" || type == "rad" || type == "ssodt" || type == "ssdt" || type == "ssdpt" || type == "dpts" || type == "dps" || type == "flDevices" || type == "flaDevices"|| type == "uDevices"){
        if(angular.isUndefined(subType) || subType == ""){
          // httpReq = $http.get($rootScope.apiHost + "common/devices/export/"+type+"?targetDIds="+tDevices + "&dsg="+dsg+"&s="+s+"&type="+dType);
          // making above api in post
          httpReq = $http.post($rootScope.apiHost + "common/devices/export/"+type+"?dsg="+dsg+"&s="+s+"&type="+dType, {"targetDIds":"", id:id});
        } else {
          // httpReq = $http.get($rootScope.apiHost + "common/devices/export/"+type+"?targetDIds="+tDevices + "&dsg="+dsg+"&s="+s+"&type="+dType+"&subType="+subType);
          // making above api in post
          httpReq = $http.post($rootScope.apiHost + "common/devices/export/"+type+"?dsg="+dsg+"&s="+s+"&type="+dType+"&subType="+subType, {"targetDIds":"", id:id});
        }
      } else if(type == "videowall"){
        httpReq = $http.get($rootScope.apiHost + "common/devices/export/videowall?wId=" + id + "&dsg="+dsg+"&s="+s);
      } else {
        if(dfData){
          httpReq = $http.get($rootScope.apiHost + "common/devices/export?dsg="+dsg+"&s="+s+"&f="+df+"&fid="+dfData.fId+"&df="+dfData.type);
        } else{
          httpReq = $http.get($rootScope.apiHost + "common/devices/export?dsg="+dsg+"&s="+s+"&f="+df);
        }
      }
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getGroupDeviceSettings = function(type){
    httpReq = $http.get($rootScope.apiHost + "common/devices/export/settings/"+ type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setDeviceViewStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/deviceView/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setTemplateViewStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/templateView/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setContentViewStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/contentView/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setLPOpenStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isLPOpen/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setPinStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isPin/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setPopupStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isPopup/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setSplitVStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isSplitV/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setTreeOpenStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isTreeOpen/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setDFTreeOpenStatus = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/isDFTreeOpen/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setScale = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/scale/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setSddr = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/sddr/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setTheme = function(status){
    httpReq = $http.get($rootScope.apiHost + "common/uPreferences/theme/" + status);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setUPreferences = function(obj){
    httpReq = $http.put($rootScope.apiHost + "common/uPreferences", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setSort = function(obj){
    httpReq = $http.put($rootScope.apiHost + "common/sort", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setDeviceView = function(obj){
    httpReq = $http.put($rootScope.apiHost + "common/sort", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.restartSession = function(){
    httpReq = $http.get($rootScope.apiHost + "auth/restartSession");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.supportedFiles = function(sid){
    httpReq = $http.get($rootScope.apiHost + "common/supportedFiles/" + sid);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.logOut = function(obj){
    httpReq = $http.put($rootScope.apiHost + "auth/logout", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Get user group list for permission*/
  this.getPermissions = function(obj){
    httpReq = $http.post($rootScope.apiHost + "common/permissions", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getAdvSearch = function(obj, type){
    if(type == "cod"){
      httpReq = $http.get($rootScope.apiHost + "common/advancedSearch/"+ obj +"?cod=1");
    } else if(type){
      httpReq = $http.get($rootScope.apiHost + "common/advancedSearch/"+ obj +"?m="+ type);
    } else{
      httpReq = $http.get($rootScope.apiHost + "common/advancedSearch/"+ obj);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.selectAllSD = function(ids){
    httpReq = $http.get($rootScope.apiHost + "common/info/devices/"+ ids +"?isconflict=1");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.updateAdvSearch = function(obj, auth, text){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };

    if(obj.fil == "all"){
      delete obj.fil;
    }
    if(auth && auth.upreferences.deviceView == "l"){
      if(text){
        // httpReq = $http.post($rootScope.apiHost + "common/advancedSearch/new?isLV=1&searchQ="+text, obj);
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?isLV=1&searchQ="+ encodeURIComponent(text), obj, config);
      } else{
        // httpReq = $http.post($rootScope.apiHost + "common/advancedSearch/new?isLV=1", obj);
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?isLV=1", obj, config);
      }
    } else{
      if(text){
        // httpReq = $http.post($rootScope.apiHost + "common/advancedSearch/new?searchQ="+text, obj);
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?searchQ="+ encodeURIComponent(text), obj, config);
      } else{
        // httpReq = $http.post($rootScope.apiHost + "common/advancedSearch/new", obj);
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1", obj, config);
      }
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.advSearchExportList = function(obj){
    // httpReq = $http.post($rootScope.apiHost + "common/advancedSearch?isExport=1", obj);
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };

    httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?isExport=1", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  // TODO
  this.updateAdvSearchD = function(obj, auth, text){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };
    if(obj.fil == "all"){
      delete obj.fil;
    }
    if(auth && auth.upreferences.deviceView == 'l'){
      if(text){
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?isLV=1&searchQ="+ encodeURIComponent(text), obj, config);
      } else {
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?isLV=1", obj, config);
      }
    } else{
      if(text){
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1?searchQ="+ encodeURIComponent(text), obj, config);
      } else{
        httpReq = $http.post($rootScope.apiHost + "devices/advancedSearch/new1", obj, config);
      }
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  // TODO
  this.updateAdvSearchS = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };
    httpReq = $http.post($rootScope.apiHost + "schedules/advancedSearch/new1", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.updateAdvSearchCL = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };
    httpReq = $http.post($rootScope.apiHost + "contentLibrary/advancedSearch", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateAdvSearchTM = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };
    httpReq = $http.post($rootScope.apiHost + "templates/advancedSearch", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.updateAdvSearchInv = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();
    var config = {
      timeout:canceler.promise
    };
    if(obj.invType == "d"){
      httpReq = $http.post($rootScope.apiHost + "inventory/getInventoryData", obj, config);
    } else if(obj.invType == "h"){
      httpReq = $http.post($rootScope.apiHost + "inventory/getInventoryData", obj, config);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveCustomColors = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();

    var config = {
      timeout:canceler.promise
    };

    httpReq = $http.post($rootScope.apiHost + "common/customColors", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getEditHistory = function(obj){
    if(canceler){
      canceler.resolve();
    }
    canceler = $q.defer();

    var config = {
      timeout:canceler.promise
    };

    httpReq = $http.post($rootScope.apiHost + "common/history", obj, config);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Notifications*/
  // this.getToastNotification = function(){
  //   httpReq = $http.get("app/libraries/json/notification_dictionary.json");
  //   return httpReq.then(this.handleSuccess, this.handleError);
  // }
  /*UI Version*/
  this.getUIVersion = function(){
    httpReq = $http.get($rootScope.apiHost + "auth/uiversion");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Content Library*/
  this.getCLGroups = function(type){
    httpReq = $http.put($rootScope.apiHost + "common/group", type);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.setExpand = function(obj){
    httpReq = $http.put($rootScope.apiHost + "common/group/expand", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getCGList = function(id, extn){
    // if(extn=="Content Group"){
    //   httpReq = $http.get($rootScope.apiHost + "common/contentlist/cg/"+ id);
    //   } else {
    //     httpReq = $http.get($rootScope.apiHost + "common/contentlist/fc/"+ id);
    //     }
    if(extn == "template"){
      httpReq = $http.get($rootScope.apiHost + "common/template/contentlist/"+ id);
    } else{
      httpReq = $http.get($rootScope.apiHost + "common/cg/contentlist/"+ id);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Pin Items */
  this.pinUnpinItems = function(obj, caller){
    if(caller=="pin"){
      httpReq = $http.post($rootScope.apiHost + "common/pinitems", obj);
    } else {
      httpReq = $http.post($rootScope.apiHost + "common/unpinitems", obj);
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getDeviceBtn = function(id){
    httpReq = $http.post($rootScope.apiHost + "action/devices?pin=1", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getScheduleBtn = function(sId){
    httpReq = $http.post($rootScope.apiHost + "action/schedules?pin=1", sId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTemplateBtn = function(tId){
    httpReq = $http.post($rootScope.apiHost + "action/templates?pin=1", tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  this.getAvailDGT = function(type, caller){
    if(type=='d'){
      httpReq = $http.get($rootScope.apiHost + "devices/listnew?caller="+ caller);
    } else if(type=='g'){
      httpReq = $http.get($rootScope.apiHost + "devices/groups?" + new Date().getTime());
    } else if(type=='t'){
      httpReq = $http.get($rootScope.apiHost + "devices/tags?" + new Date().getTime());
    }
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  // TODO get timezone list from server
  this.getTimezoneList = function(){
    httpReq = $http.get($rootScope.libraries + "/timezone/timezone.json");
    return httpReq.then(this.handleSuccess, this.handleError);
  }

  /*Localization Start*/
  this.getLangList = function(){
    httpReq = $http.get($rootScope.libraries + "/localization/lang_list.json?" + new Date().getTime());
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  /*Localization End*/

  this.handleSuccess = function(response){
    if(response.data.code==8301 || response.data.code==8302 || response.data.code==8303 || response.data.code==8304 || response.data.code==8305){
      $rootScope.toastNotificationFx("info", response.data);
    }
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", response.data);
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
angular.module('hub').filter('unique', function(){
  return function(collection, keyname, returnKey){
    var output = [],
      keys = [];
    angular.forEach(collection, function(item){
      var key = item[keyname];
      if(keys.indexOf(key) === -1){
        keys.push(key);
        if(returnKey){
          output.push(item[returnKey]);
        } else{
          output.push(item);
        }
      }
    });
    return output;
  };
});
angular.module('hub').filter("trustUrl", ['$sce', function($sce){
  return function(recordingUrl){
    return $sce.trustAsResourceUrl(recordingUrl);
  };
}]);
angular.module('hub').filter('trustHtml', ['$sce', function($sce){
  return function(value, type){
    return $sce.trustAs(type || 'html', value);
  }
}]);
angular.module('hub').filter('toFixed', function($filter){
  return function(input, places){
    if(isNaN(input)) return input;
    
    if(input.toString().split(".").length > 1){
      return parseFloat(input.toFixed(places));
    } else{
      return input;
    }
    // var factor = "1" + Array(+(places > 0 && places + 1)).join("0");
    // return Math.round(input * factor) / factor;
  };
});
angular.module('hub').filter('toDate', function(){
  return function(data){
    return new Date(data);
  };
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('timezoneLabel', timezoneLabel);

  /** @ngInject */
  function timezoneLabel(){
    return function(label, timezoneList){
      angular.forEach(timezoneList, function(list){
        if(list.label === label.label){
          label = label.label +' - '+ list.zone;
        }
      });
      return label;
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .filter('startFrom', startFrom);

  /** @ngInject */
  function startFrom(){
    return function(input, start){
      start = +start; //parse to int
      return input.slice(start);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('split', split);

  /** @ngInject */
  function split(){
    return function(input, splitChar, splitIndex){
      // do some bounds checking here to ensure it has that index
      if(splitIndex){
        return input.split(splitChar)[splitIndex];
      }
      return input.split(splitChar);
    }
  }
})();
angular.module('hub').filter('setDecimal', function($filter){
  return function(input, places){
    if(isNaN(input)) return input;
    // If we want 1 decimal place, we want to mult/div by 10
    // If we want 2 decimal places, we want to mult/div by 100, etc
    // So use the following to create that factor
    var factor = "1" + Array(+(places > 0 && places + 1)).join("0");
    return Math.round(input * factor) / factor;
  };
});

(function(){
  'use strict';
  angular
    .module('hub')
    .filter('secureThumb', secureThumb);
    
  /** @ngInject */
  function secureThumb(){
    return function(thumb, version){
      if(thumb){
        var splitThumb = thumb.split("___|___");
        if(splitThumb.length <= 1){
          return thumb;
        }
        var base64 = decode_base64(splitThumb[1]);

        function decode_base64(sData) {
          var base64 = sData.replace(/-/g, '+').replace(/_/g, '/');
          return atob(base64);
        };
        var tempThumb = version ? splitThumb[0] +'?'+ base64 +'&v='+ version : splitThumb[0] +'?'+ base64;
        return tempThumb; 
      }
      // return thumb;
    }
  }
})();


// (function(){
//   'use strict';

//   angular
//     .module('hub')
//     .filter('colorWithOpacity', colorWithOpacity);

//   /** @ngInject */
//   function colorWithOpacity(){
//     return function(colorString, opacity){
//       opacity = opacity || 1;
//       colorString = colorString.replace('#', '');
//       var splitColor = colorString.match(/.{1,2}/g);
//       splitColor = splitColor.map(function(hex) { return parseInt(hex, 16); });
//       return 'rgba(' + splitColor[0] + ', ' + splitColor[1] + ', ' + splitColor[2] + ', ' + opacity + ')';
//     }
//   }
// })();



(function(){
  'use strict';

  angular
    .module('hub')
    .filter('sameValue', sameValue);

  /** @ngInject */
  function sameValue(){
    return function(arry, value){
      var sameValue = [];
      if(value[1] == "sg"){
        angular.forEach(arry, function(item){
          if(item.gid === value[0]){
            sameValue.push(item);
          }
        });
      }
      if(value[1] == "grp"){
        angular.forEach(arry, function(item){
          if(item.gid === value[0]){
            sameValue.push(item);
          }
        });
      }
      return sameValue;
    }
  }
})();
angular.module('hub').filter("reverseAndSplice", function(){
  return function(items, max){
    items = items.slice().reverse(); // Create a copy of the array and reverse the order of the items
    if(items.length > max){
      items.splice(max, (items.length - max))
    }
    return items;
  };
});
angular.module('hub').filter("reverse", function(){
  return function(items){
    if(items){
      return items.slice().reverse(); // Create a copy of the array and reverse the order of the items
    }
  };
});
angular.module('hub').filter('removeColon', function(){
  return function(str){
    return str.replace(/:\s*/g, "");
  }
});
angular.module('hub').filter('positive', function(){
  return function(input){
    if(!input){return 0}
    return Math.abs(input);
  }
});
angular.module('hub').filter('percentage', function($filter){
  return function(val1, val2, decimals){
    return $filter('number')((val1/val2)*100, decimals) + '%';
  }
});
angular.module('hub').filter('momentTimeZone', function(){
  return function(date){
    return moment(date).format('LL');
  }
});
angular.module('hub').filter('momentTime', function(){
  return function(time){
    if(time != null){
      return new Date(moment(moment().format("YYYY-MM-DD") + "T" + time.split(" ")[0])).getTime();
    }
  }
});
angular.module('hub').filter('momentDate', function(){
  return function(date){
    return new moment(date, 'MM/DD/YYYY', true).format();
  }
});
angular.module('hub').filter('minmaxDate', function(){
  return function(dates){
    return dates.reduce(function(acc, date){
      var startDate = new Date(date.startDate);
      var endDate = new Date(date.endDate);
      if(!acc.minStartDate || startDate < acc.minStartDate){
        acc.minStartDate = startDate;
      }
      if(!acc.maxEndDate || endDate > acc.maxEndDate){
        acc.maxEndDate = endDate;
      }
      return acc;
    }, { minStartDate:null, maxEndDate:null });
  }
});
angular.module('hub').filter('minmax', function(){
  return function(input, min, max){
    min = parseInt(min); //Make string input int
    max = parseInt(max);
    for(var i=min; i<max; i++)
      input.push({id:i, label:i});
    return input;
  }
});
angular.module('hub').filter('minToHour', function($filter){
  return function(min){
    if(min != null){
      if(min > 59){
        var hours = Math.floor(min / 60);
        var minutes = min % 60;
        if(minutes > 0){
          return hours + " " + (hours > 1 ? $filter("translate")('cm.label.29s') : $filter("translate")('cm.label.29')) + " " + minutes + " " + (minutes > 1 ? $filter("translate")('cm.label.28s') : $filter("translate")('cm.label.28'));
        } else{
          return hours + " " + (hours > 1 ? $filter("translate")('cm.label.29s') : $filter("translate")('cm.label.29'));
        }
      } else{
        return min + " " + (min > 1 ? $filter("translate")('cm.label.28s') : $filter("translate")('cm.label.28'));
      }
    }
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('key', key);

  /** @ngInject */
  function key($filter){
    return function(list, m, key1, key2, key3){
      if(list !== undefined){
        var k = list[m][key1];
        if(key2 && key3 === undefined){
          k = list[m][key1][key2];
        }
        if(key3){
          k = list[m][key1][key2][key3];
        }
        return k;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('kioskFilter', kioskFilter);

  /** @ngInject */
  function kioskFilter(){
    return function(items, selected, type){
      if(items.length){
        var arr = [];
        if((type=='widget' && $(".customSelect").hasClass('open')) || angular.isUndefined(type))
        for(var i=0; i<items.length; i++){
          // console.warn(items[i].kioskName);
          if(items[i].kioskName.toLowerCase().includes(selected.toLowerCase()) || items[i].kioskId.toString().toLowerCase().includes(selected.toLowerCase())){
            arr.push(items[i]);
          }
        }
        return arr;
      }
    }
  }
})();
angular.module('hub').filter('isEmpty', function(){
  return function(object){
    return angular.equals({}, object);
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('isDeviceOnline', isDeviceOnline);

  /** @ngInject */
  function isDeviceOnline(){
    return function(lastPing, params) {
      var curTS = moment().format('x');
      var minDeduct = parseInt(params.minDeduct.trim().split(" minutes")[0]);
      // console.warn("");
      if (lastPing) {
        var modTS = parseInt(curTS) - (-minDeduct * 60 * 1000);
        if((lastPing * 1000) > modTS){
          return "online";
        } else {
          return "offline";
        }
      }
      else {
        return "offline"; // Return false if value is not negative
      }
    };
  }
})();



(function(){
  'use strict';

  angular
    .module('hub')
    .filter('folderBrief', folderBrief);

  /** @ngInject */
  function folderBrief($filter){
    return function(items, selected){
      if(items && items.length){
        for(var i=0; i<items.length; i++){
          if(items[i].id == selected.id && $filter("capitalize")(items[i].type) == $filter("capitalize")(selected.type)){
            return [items[i]];
          } else if(!items[i].splId && items[i].id == selected.id && $filter("capitalize")(items[i].type) == $filter("capitalize")(selected.type)){
            return [items[i]];
          }
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('findDuplicates', findDuplicates);

  /** @ngInject */
  function findDuplicates($filter){
    return function(arry, key){
      if(key == "label"){
        for(var i = 0; i < arry.length; i++){
          for(var x = i + 1; x < arry.length; x++){
            if(arry[i].label !== "" && $filter('lowercase')(arry[i].label) == $filter('lowercase')(arry[x].label)){
              return true;
            }
          }
        }
        return false;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('findAndReplace', findAndReplace);

  /** @ngInject */
  function findAndReplace(){
    return function(string, target, replacement){
      var i = 0, length = string.length;
      for(i; i < length; i++){
        string = string.replace(target, replacement);
      }
      return string;
    }
  }
})();
angular.module('hub').filter('filesize', function(){
  return function(filesize, decimals){
    if(filesize != null){
      filesize = filesize / 1024;
      if(filesize == 0) return '0 KB';
      if(filesize > 0 && filesize < 1) return (filesize).toFixed(2) +' KB';
      var k = 1024; // or 1000 for binary
      var dm = decimals + 1 || 2;
      var sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(filesize) / Math.log(k));
      return parseFloat((filesize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('fileExt', fileExt);

  /** @ngInject */
  function fileExt(){
  	return function(type, name){
      if(type){
        var curType = type.split("/");
        var curExt = name.split(".")[name.split(".").length - 1];
        var ext = "";
        if(curType[0]=="image"){
          return ext = "image";
        } else if(curType[0]=="video"){
          return ext = "video";
        } else if(curType[0]=="audio"){
          return ext = "audio";
        } else if(curExt=="csv"){
          return ext = "csv";
        } else if(curType[1]=="pdf"){
          return ext = "pdf";
        } else if(curExt=="zip" || curExt=="rar"){
          return ext = "zip";
        } else if(curExt=="doc" || curExt=="docx"){
          return ext = "doc";
        } else if(curExt=="xls" || curExt=="xlsx"){
          return ext = "xls";
        } else if(curExt=="ppt" || curExt=="pptx" || curExt=="ppsx"){
          return ext = "ppt";
        } else if(curType[1]=="plain" || curType[1]=="json" || curType[1]=="css"){
          return ext = "text";
        } else if(curType[1]=="html" || curExt=="xml" || curType[1]=="octet-stream" && (curExt=="md" || curExt=="php")){
          return ext = "code";
        } else if(curExt=="bak" || curExt=="woff" || curExt=="ttf" || curExt=="eot" || curExt=="asar" || curExt=="ini"){ //curExt=="swf"
          return ext = "file";
        } else if(curType[0]=="application"){/*Note: No code add after this*/
          return ext = "file";
        }
      }
  	}
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .filter('eslSearchOpt', eslSearchOpt);

  /** @ngInject */
  function eslSearchOpt(){
    return function(arry){
      var eslSearchOpt = [];
      angular.forEach(arry, function(item){
        if(item.id == 'image' || item.id == 'powerpoint'){
          eslSearchOpt.push(item);
        }
      });
      return eslSearchOpt;
    }
  }
})();
angular.module('hub').filter('emptyFilter', function(){
  return function(array){
    var filteredArray = [];
      angular.forEach(array, function(item){
        if (item.length > 0){filteredArray.push(item);}
      });
    return filteredArray;
  };
});
angular.module('hub').filter('durations', function($filter){
  return function(seconds){
    var curDuration = $filter('date')(new Date(1970, 0, 1).setSeconds(seconds), 'HH:mm:ss');
    var splitedDuration = curDuration.split(":");
    if(splitedDuration[0] == "00"){
      curDuration = splitedDuration[1] + ":" + splitedDuration[2];
    }
    return curDuration;
    // return new Date(1970, 0, 1).setSeconds(seconds);
  }
});
angular.module('hub').filter('duration', function($filter){
  function padTime(t){
    return t < 10 ? "0" + t : t;
  }
  var durationStr = "";
  return function(_seconds){
    durationStr = "";
    if(typeof _seconds !== "number" || _seconds < 0)
      return "00:00:00";
    var hours = Math.floor(_seconds / 3600),
      minutes = Math.floor((_seconds % 3600) / 60),
      seconds = Math.floor(_seconds % 60);
    if(hours > 0){
      durationStr = hours;
      if(hours == 1){
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.29')) + " "; //" hour@ ";
      } else{
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.29s')) + " "; //" hours@ ";
      }
    }
    if(minutes > 0){
      durationStr += minutes;
      if(minutes == 1){
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.28')) + " "; //" minute@ ";
      } else{
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.28s')) + " "; //" minutes@ ";
      }
    }
    if(seconds > 0){
      durationStr += seconds;
      if(seconds == 1){
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.27')); //" second@";
      } else{
        durationStr += " " + $filter("lowercase")($filter("translate")('cm.label.27s')); //" seconds@";
      }
    }
    return durationStr;
  }
});
angular.module('hub').filter('distinct', function(){
  return function(arr1, arr2){
    return arr1.filter(function(n){
      return arr2.indexOf(n) == -1
    });
  };
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('dateFormat', dateFormat);

  /** @ngInject */
  function dateFormat(){
    var dateFormatFilter = function (input) {
      if (input) {
        // Parse the input date using Moment.js
        var parsedDate = moment(input, 'MM/DD/YYYY');

        // Format the parsed date as 'MMM D, YYYY'
        return parsedDate.format('MMM D, YYYY');
      }
    };
    return dateFormatFilter;
  }
})();
angular.module('hub').filter('dateDifference', function(){
  return function(sDate, eDate){
    function parseDate(str){
      var mdy = str.split('/');
      return new Date(mdy[2], mdy[0]-1, mdy[1]);
    }
    function daydiff(first, second){
      return Math.round((second-first)/(1000*60*60*24));
    }
    return daydiff(parseDate(sDate), parseDate(eDate));
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('customTimezoon', customTimezoon);

  /** @ngInject */
  function customTimezoon(){
    return function(time, val){
      function getTimeZone(){
        var offset = new Date().getTimezoneOffset();
        var o = Math.abs(offset);
        return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
      }
      var curTime = time.substring(0, 19);
      if(val){
        time = curTime + "+00:00";
      } else{
        time = curTime + getTimeZone();
      }
      return time;
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('customSearch', customSearch);

  /** @ngInject */
  function customSearch($filter, $rootScope, $state){
    return function(array, obj){
      var dStatus = JSON.parse(localStorage.getItem("filterType"))
      var curState = $state.current.name;
      $rootScope.filterSearch = true;
      var obj1 = [], obj2 = [], obj3 = [], obj4 = [], obj5 = [], obj6 = [], obj7 =[], obj8 =[], filterObj = [];
      if(!angular.isUndefined(obj.key) && obj.key != ""){
        if(obj.module == "cl"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {extn:obj.key});

          var concatFilterObj = obj1.concat(obj2);
          if(obj.filterType == "myContent"){
            filterObj = $filter("filter")(concatFilterObj, {owner:1});
          } else if(obj.filterType == "approved"){
            filterObj = $filter("filter")(concatFilterObj, {isApproved:1});
          } else if(obj.filterType == "unapproved"){
            filterObj = $filter("filter")(concatFilterObj, {isApproved:0});
          } else{
            filterObj = $filter("filter")(concatFilterObj, {type:obj.filterType});
          }
          if(filterObj.length > 0 || obj.filterType == "all"){
            $rootScope.filterSearch = true;
          } else{
            $rootScope.filterSearch = false;
          }
        } else if(obj.module == "clf"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {type:obj.key});
        } else if(obj.module == "t"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {type:obj.key});
        } else if(obj.module == "s"){
          obj1 = $filter("filter")(array, {label:obj.key});
        } else if(obj.module == "fl"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {type:obj.key});
        } else if(obj.module == "fla"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {flName:obj.key});
        } else if(obj.module == "d" || obj.module == "dl" || obj.module == "dSel" || obj.module == "dSelOp"){
          if(dStatus != "all"){
            dStatus = "";
          }
          if($rootScope.selectedT == 1 && (dStatus == "online" || dStatus == "offline") && obj.module != "dSel" && obj.module != "dSelOp"){
          // if($rootScope.selectedT == 1 && (dStatus == "online" || dStatus == "offline") && (curState == "hub.devices.d" || curState == "hub.sContainer.sDevice" || curState == "hub.flContainer.flaDevice" || curState == "hub.flContainer.flaDevice" || curState == "hub.dContainer.dgDevice" || curState.includes("hub.reports"))){
            obj1 = $filter("filter")(array, {label:obj.key,status:dStatus});
            // obj1 = $filter("filter")(array, {l:obj.key,status:dStatus});
            obj2 = $filter("filter")(array, {mac:obj.key,status:dStatus});
            // obj2 = $filter("filter")(array, {h:obj.key,status:dStatus});
            obj3 = $filter("filter")(array, {room:obj.key,status:dStatus});
            obj4 = $filter("filter")(array, {lp:obj.key,status:dStatus});
            obj5 = $filter("filter")(array, {label:obj.key,status:dStatus});
            // obj6 = $filter("filter")(array, {h:obj.key,status:dStatus});
          } else {
            if(obj.module=='dSel' || obj.module=='dl' || obj.module=='d'){
              obj1 = $filter("filter")(array, {label:obj.key});
              obj2 = $filter("filter")(array, {mac:obj.key});
            } else if(obj.module=='dSelOp'){
              obj1 = $filter("filter")(array, {l:obj.key});
              obj2 = $filter("filter")(array, {h:obj.key});
            } else {
              obj1 = $filter("filter")(array, {label:obj.key});
              obj2 = $filter("filter")(array, {mac:obj.key});
            }
            obj3 = $filter("filter")(array, {room:obj.key});
            obj4 = $filter("filter")(array, {lp:obj.key});

            // obj1 = $filter("filter")(array, {label:obj.key});
            // obj1 = $filter("filter")(array, {l:obj.key});
            // if($rootScope.arrObjContainKey(array,'mac')){
            //   obj2 = $filter("filter")(array, {mac:obj.key});
            // } else {
            //   obj2 = $filter("filter")(array, {h:obj.key});
            // }
            // obj3 = $filter("filter")(array, {room:obj.key});
            // obj4 = $filter("filter")(array, {lp:obj.key});
            // obj5 = $filter("filter")(array, {label:obj.key});
            // obj6 = $filter("filter")(array, {h:obj.key});
          }
        } else if(obj.module == "df"){
          obj1 = $filter("filter")(array, {label:obj.key});
        } else if(obj.module == "u"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {email:obj.key});
        } else if(obj.module == "dText"){
          obj1 = $filter("filter")(array, {name:obj.key});
          obj2 = $filter("filter")(array, {frametext:obj.key});
        } else if(obj.module == "dls"){
          obj1 = $filter("filter")(array, {d:obj.key});
          obj2 = $filter("filter")(array, {h:obj.key});
          obj3 = $filter("filter")(array, {l:obj.key});
        } else if(obj.module == "flals"){
          obj1 = $filter("filter")(array, {fla:obj.key});
        } else if(obj.module == "sls"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {startDate:obj.key});
          obj3 = $filter("filter")(array, {endDate:obj.key});
        } else if(obj.module == "dh"){
          obj1 = $filter("filter")(array, {createdBy:obj.key});
        } else if(obj.module == "stock"){
          obj1 = $filter("filter")(array, {symbol:obj.key});
          obj2 = $filter("filter")(array, {name:obj.key});
        } else if(obj.module == "mRoom"){
          obj1 = $filter("filter")(array, {l:obj.key});
          obj2 = $filter("filter")(array, {fl:obj.key});
          obj3 = $filter("filter")(array, {id:obj.key});
          obj4 = $filter("filter")(array, {dt:obj.key});
        } else if(obj.module == "mMeeting"){
          obj1 = $filter("filter")(array, {title:obj.key});
          obj2 = $filter("filter")(array, {room:obj.key});
          obj3 = $filter("filter")(array, {mac:obj.key});
        } else if(obj.module == "mSS"){
          obj1 = $filter("filter")(array, {room:obj.key});
          obj2 = $filter("filter")(array, {floor:obj.key});
        } else if(obj.module == "odc"){
          obj1 = $filter("filter")(array, {name:obj.key});
        } else if(obj.module == "role"){
          obj1 = $filter("filter")(array, {label:obj.key});
        } else if(obj.module == "ch"){
          obj1 = $filter("filter")(array, {name:obj.key});
        } else if(obj.module == "comm"){
          obj1 = $filter("filter")(array, {full_name:obj.key});
        } else if(obj.module == "net"){
          obj1 = $filter("filter")(array, {network_name:obj.key});
        } else if(obj.module == "k"){
          // obj1 = $filter("filter")(array, {kioskName:obj.key, kioskId:obj.key});
          // obj2 = $filter("filter")(array, {kioskId:obj.key});
          // console.warn(obj1);
          // console.warn(obj2);
          obj1 = $filter("filter")(array, {kioskName:obj.key});
          obj2 = $filter("filter")(array, {kioskId:obj.key});
        } else if(obj.module == "custServerS"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {state:obj.key});
          obj3 = $filter("filter")(array, {catagary:obj.key});
          obj4 = $filter("filter")(array, {tags:obj.key});
        } else if(obj.module == "ticket"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {sub:obj.key});
          obj3 = $filter("filter")(array, {tid:obj.key});
        } else if(obj.module == "cdtg" || obj.module == "avd" || obj.module == "cdtgSort"){
          if(obj.module == "avd" || obj.module == "cdtgSort"){
            obj1 = $filter("filter")(array, {l:obj.key});
            obj2 = $filter("filter")(array, {h:obj.key});
          } else {
            obj1 = $filter("filter")(array, {label:obj.key});
            obj2 = $filter("filter")(array, {room:obj.key});
            obj3 = $filter("filter")(array, {mac:obj.key});
            // obj3 = $filter("filter")(array, {mac:obj.key});
            // obj4 = $filter("filter")(array, {h:obj.key});
          }
        } else if(obj.module == "dbPopup"){
          obj1 = $filter("filter")(array, {l:obj.key});
          obj2 = $filter("filter")(array, {room:obj.key});
          obj3 = $filter("filter")(array, {h:obj.key});
        } else if(obj.module == "comEvent"){
          obj1 = $filter("filter")(array, {activityName:obj.key});
          // obj2 = $filter("filter")(array, {room:obj.key});
          // obj3 = $filter("filter")(array, {mac:obj.key});
        } else if(obj.module == "pinItem"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {mac:obj.key});
        } else if(obj.module == "dp"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {value:obj.key});
        } else if(obj.module == "qlik"){
          obj1 = $filter("filter")(array, {name:obj.key});
          obj2 = $filter("filter")(array, {id:obj.key});
        } else if(obj.module == "sdList" && obj.key.length >=3){
          obj1 = $filter("filter")(array, {l:obj.key});
          obj2 = $filter("filter")(array, {h:obj.key});
        } else if(obj.module == "dLic"){
          obj1 = $filter("filter")(array, {l:obj.key});
          obj2 = $filter("filter")(array, {c:obj.key});
        } else if(obj.module == "dEpd"){
          obj1 = $filter("filter")(array, {model:obj.key});
          obj2 = $filter("filter")(array, {resolution:obj.key});
          obj3 = $filter("filter")(array, {size:obj.key});
          obj4 = $filter("filter")(array, {dpi:obj.key});
        } else if(obj.module == "CODs"){
          obj1 = $filter("filter")(array, {label:obj.key});
          obj2 = $filter("filter")(array, {catLabel:obj.key});
        }


        if(((obj1 && obj1.length > 0) && (obj2 && obj2.length > 0)) || ((obj1 && obj1.length > 0) && (obj3 && obj3.length > 0)) || ((obj2 && obj2.length > 0) && (obj3 && obj3.length > 0)) || ((obj1 && obj1.length > 0) && (obj4 && obj4.length > 0)) || ((obj2 && obj2.length > 0) && (obj4 && obj4.length > 0))){
          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
            angular.forEach(concatObj, function(item){
              if(obj.module == "dl"){ // || obj.module == "dls"
                if(keys.indexOf(item.mac) === -1){
                  keys.push(item.mac);
                  filteredObj.push(item);
                }
              } else if(obj.module == "sdList"){
                if(keys.indexOf(item.h) === -1){
                  keys.push(item.h);
                  filteredObj.push(item);
                }
              } else{
                if(keys.indexOf(item.id) === -1){
                  keys.push(item.id);
                  filteredObj.push(item);
                }
              }
            });
          return filteredObj;
        } else if(obj1 && obj1.length > 0){
          return obj1;
        } else if(obj2 && obj2.length > 0){
          return obj2;
        } else if(obj3 && obj3.length > 0){
          return obj3;
        } else if(obj4 && obj4.length > 0){
          return obj4;
        } else if(obj5 && obj5.length > 0){
          return obj5;
        } else if(obj6 && obj6.length > 0){
          return obj6;
        } else{
          return [];
        }
      } else{
        return array;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('colorWithOpacity', colorWithOpacity);

  /** @ngInject */
  function colorWithOpacity(){
    return function(colorString, opacity){
      opacity = opacity || 1;
      colorString = colorString.replace('#', '');
      var splitColor = colorString.match(/.{1,2}/g);
      splitColor = splitColor.map(function(hex) { return parseInt(hex, 16); });
      return 'rgba(' + splitColor[0] + ', ' + splitColor[1] + ', ' + splitColor[2] + ', ' + opacity + ')';
    }
  }
})();



angular.module('hub').filter('changeTimeFormat', function(){
  return function(time){
    if(time != null){
      return moment(time.split(" ")[0], ["HH:mm"]).format("hh:mm A");
    }
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('capitalize', capitalize);

  /** @ngInject */
  function capitalize(){
    return function(input){
      //return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
      return (angular.isString(input) && input.length > 0) ? input[0].toUpperCase() + input.substr(1).toLowerCase() : input;
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .filter('camelCase', camelCase);

  /** @ngInject */
  function camelCase(){
    var camelCaseFilter = function(input){
      if(angular.isString(input)){
        var words = input.split(' ');
        for(var i = 0, len = words.length; i < len; i++)
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        return words.join(' ');
      } else{
        return input;
      }
    };
    return camelCaseFilter;
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('whenScrolled', whenScrolled);

  /** @ngInject */
  function whenScrolled(){
    return{
      link:function(scope, element, attrs){
        var raw = element[0];
        element.bind('scroll', function(){
            if(raw.scrollTop + raw.offsetHeight + 1 >= raw.scrollHeight){
              scope.$apply(attrs.whenScrolled);
            }
        });
      }
    }
  }
})();
angular.module('hub').directive('treenode', function($compile, ContentLibrarySrv){
  return{
    restrict:"E",
    replace:true,
    scope:{
      node:'=',
      ischecked:'=',
      checkDisable:'=',
      authType:'='
    },
    template:'<li class="branch text-ellipsis-wrap" ng-class="{\'disabledRow\': checkDisable && (!node.movable || !node.writable)}"><a ng-if="!node.isRoot && ($root.curFType==\'od\' || $root.curFType==\'sp\' || $root.curFType==\'gdSP\' || $root.curFType==\'oauth\' || $root.curFType==\'move\' && node.collapsed)" href="" role="link" ng-click="loadChildrenFx($event, node);" class="marR10"><span class="fa fa-chevron-right" aria-hidden="true"></span><img alt="Loading" class="marL-2 marT-4 loadingChild hide" src="assets/images/loading-xs.gif"></a><label uib-tooltip="{{!node.movable?\'cl.p_m.m9\':\'cl.msg.11\' | translate}}" tooltip-enable="checkDisable && (!node.movable || !node.writable)"><input type="radio" role="radio" aria-label="treeOpt" aria-labelledby="treeOpt" name="treeOpt" value="{{node.id}}" data-label="{{node.name}}" data-path="{{node.path}}" ng-disabled="checkDisable && (!node.movable || !node.writable)" ng-checked="ischecked"><label></label>{{node.name}}</label></li>',
    link:function(scope, element, attrs){
      if(angular.isArray(scope.node.children)){
        element.append("<tree ng-class={'hide':$root.curFType==\'move\'} list='node.children' check-disable='checkDisable' role='tree' aria-orientation='vertical' auth-type='authType'></tree>");
        $compile(element.contents())(scope)
      }

			//below function is for get OD and SD folders child
			scope.loadChildrenFx = function(event, node){
				$(event.currentTarget).find(".fa-chevron-right").addClass('hide');
				$(event.currentTarget).find(".loadingChild").removeClass('hide');

				if(!$(event.currentTarget).hasClass('selected')){
					if(scope.$root.curFType=="od"){
						ContentLibrarySrv.getOdFolderChild(scope.$root.driveId, node.id).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(data.length == 0){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
								}
								node.children = data;
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="sp"){
						ContentLibrarySrv.getSpFolderChild(scope.$root.siteId, scope.$root.libId, node.id, scope.authType).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(data.sp.dir.length == 0){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
								}
								node.children = data.sp.dir;
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="gdSP"){
						ContentLibrarySrv.getGdSubfolder("sp", node.id, scope.$root.driveId).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(!data.data.length){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
									node.children = data.data;
								}
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="oauth"){
						ContentLibrarySrv.getGdSubfolder("oauth", node.id, scope.$root.driveId).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(!data.data.length){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
									node.children = data.data;
								}
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="move"){
						$(event.currentTarget).find(".loadingChild").css('display', 'none');
						$(event.currentTarget).addClass('selected');
						if($(event.currentTarget).parent().find("> div").hasClass("hide")){
							$(event.currentTarget).parent().find("> div").removeClass("hide");
							$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						} else {
							$(event.currentTarget).parent().find("> div").addClass("hide");
							$(event.currentTarget).find(".fa-chevron-down").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-down").removeClass("fa-chevron-down hide").addClass("fa-chevron-right");
						}
					}
				} else{
					if($(event.currentTarget).parent().find("> div").hasClass("hide")){
						//for open
						$(event.currentTarget).find("span.fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						$(event.currentTarget).parent().find("> div").removeClass("hide");
					} else{
						//for close
						$(event.currentTarget).find("span.fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-right");
						$(event.currentTarget).parent().find("> div").addClass("hide");
					}
					$(event.currentTarget).find(".loadingChild").addClass('hide');
				}
			};
		}
	}
});
angular.module('hub').directive('treenodeTf', function($compile, ContentLibrarySrv){
  return{
    restrict:"E",
    replace:true,
    scope:{
      node:'=',
      ischecked:'=',
      checkDisable:'='
    },
    template:'<li class="branch text-ellipsis-wrap" ng-class="{\'disabledRow\': checkDisable && (!node.movable || !node.writable)}"><a ng-if="!node.isRoot && ($root.curFType==\'od\' || $root.curFType==\'sp\' || $root.curFType==\'gd\' || $root.curFType==\'move\' && node.collapsed)" href="" role="link" ng-click="loadChildrenFx($event, node);" class="marR10"><span class="fa fa-chevron-right" aria-hidden="true"></span><img alt="Loading" class="marL-2 marT-4 loadingChild hide" src="assets/images/loading-xs.gif"></a><label uib-tooltip="{{!node.movable?\'cl.p_m.m9\':\'cl.msg.11\' | translate}}" tooltip-enable="checkDisable && (!node.movable || !node.writable)"><input type="radio" role="radio" aria-label="treeOptTF" aria-labelledby="treeOptTF" name="treeOptTF" value="{{node.id}}" data-label="{{node.name}}" data-path="{{node.path}}" ng-disabled="checkDisable && (!node.movable || !node.writable)" ng-checked="ischecked"><label></label>{{node.name}}</label></li>',
    link:function(scope, element, attrs){
      if(angular.isArray(scope.node.children)){
        element.append("<tree-tf ng-class={'hide':$root.curFType==\'move\'} list='node.children' check-disable='checkDisable' role='tree' aria-orientation='vertical'></tree-tf>");
        $compile(element.contents())(scope)
      }

			//below function is for get OD and SD folders child
			scope.loadChildrenFx = function(event, node){
				$(event.currentTarget).find(".fa-chevron-right").addClass('hide');
				$(event.currentTarget).find(".loadingChild").removeClass('hide');

				if(!$(event.currentTarget).hasClass('selected')){
					if(scope.$root.curFType=="od"){
						ContentLibrarySrv.getOdFolderChild(scope.$root.driveId, node.id).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(data.length == 0){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
								}
								node.children = data;
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="sp"){
						ContentLibrarySrv.getSpFolderChild(scope.$root.siteId, scope.$root.libId, node.id).then(
							function(data){
								$(event.currentTarget).addClass('selected');
								if(data.sp.dir.length == 0){
									$(event.currentTarget).css('visibility', 'hidden');
								} else{
									$(event.currentTarget).find(".loadingChild").addClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
									$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
								}
								node.children = data.sp.dir;
							},
							function(err){
								console.log(err);
							}
						);
					} else if(scope.$root.curFType=="move"){
						$(event.currentTarget).find(".loadingChild").css('display', 'none');
						$(event.currentTarget).addClass('selected');
						if($(event.currentTarget).parent().find("> div").hasClass("hide")){
							$(event.currentTarget).parent().find("> div").removeClass("hide");
							$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						} else {
							$(event.currentTarget).parent().find("> div").addClass("hide");
							$(event.currentTarget).find(".fa-chevron-down").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-down").removeClass("fa-chevron-down hide").addClass("fa-chevron-right");
						}
					}
				} else{
					if($(event.currentTarget).parent().find("> div").hasClass("hide")){
						//for open
						$(event.currentTarget).find("span.fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						$(event.currentTarget).parent().find("> div").removeClass("hide");
					} else{
						//for close
						$(event.currentTarget).find("span.fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-right");
						$(event.currentTarget).parent().find("> div").addClass("hide");
					}
					$(event.currentTarget).find(".loadingChild").addClass('hide');
				}
			};
		}
	}
});
angular.module('hub').directive('treenodeSf', function($compile, ContentLibrarySrv){
  return {
		restrict:"E",
		replace:true,
		scope:{
			node:'=',
      ischecked:'=',
      checkDisable:'='
		},
		template:'<li class="branch text-ellipsis-wrap" ng-class="{\'disabledRow\': checkDisable && !node.sf}"><a ng-if="!node.isRoot && ($root.curFType==\'move\' && node.collapsed)" href="" role="link" ng-click="loadChildrenFx($event, node);" class="marR10"><span class="fa fa-chevron-right" aria-hidden="true"></span></a><label uib-tooltip="{{node.type==\'Googledrive\'||node.type==\'Sharepoint\'||node.type==\'Onedrive\'?\'cl.p_f.18-1\':\'cl.p_f.18\' | translate}}" tooltip-enable="checkDisable && !node.sf"><input type="radio" role="radio" aria-label="treeOpt" aria-labelledby="treeOpt" name="treeOpt" value="{{node.id}}" data-label="{{node.name}}" data-path="{{node.path}}" ng-disabled="checkDisable && !node.sf" ng-checked="ischecked"><label></label>{{node.name}}</label></li>',
		link:function(scope, element, attrs){
			if(angular.isArray(scope.node.children)){
				element.append("<tree ng-class={'hide':$root.curFType==\'move\'} list='node.children' check-disable='checkDisable' role='tree' aria-orientation='vertical'></tree>");
				$compile(element.contents())(scope)
		  	}

			//below function is for get OD and SD folders child
			scope.loadChildrenFx = function(event, node){
				$(event.currentTarget).find(".fa-chevron-right").addClass('hide');
				$(event.currentTarget).find(".loadingChild").removeClass('hide');
				if(!$(event.currentTarget).hasClass('selected')){
					if(scope.$root.curFType=="move"){
						$(event.currentTarget).find(".loadingChild").css('display', 'none');
						$(event.currentTarget).addClass('selected');
						if($(event.currentTarget).parent().find("> div").hasClass("hide")){
							$(event.currentTarget).parent().find("> div").removeClass("hide");
							$(event.currentTarget).find(".fa-chevron-right").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						} else {
							$(event.currentTarget).parent().find("> div").addClass("hide");
							$(event.currentTarget).find(".fa-chevron-down").removeClass('hide');
							$(event.currentTarget).find(".fa-chevron-down").removeClass("fa-chevron-down hide").addClass("fa-chevron-right");
						}
					}
				} else{
					if($(event.currentTarget).parent().find("> div").hasClass("hide")){
						//for open
						$(event.currentTarget).find("span.fa-chevron-right").removeClass("fa-chevron-right hide").addClass("fa-chevron-down");
						$(event.currentTarget).parent().find("> div").removeClass("hide");
					} else{
						//for close
						$(event.currentTarget).find("span.fa-chevron-down").removeClass("fa-chevron-down").addClass("fa-chevron-right");
						$(event.currentTarget).parent().find("> div").addClass("hide");
					}
					$(event.currentTarget).find(".loadingChild").addClass('hide');
				}
			};
		}
	}
});
angular.module('hub').directive('tree', function(){
	return {
		restrict:"E",
		replace:true,
		scope:{
			list:'=',
			selectednode:'=',
			checkDisable:'=',
			searchText:'=',
			authType:'='
		},
		// template:'<div>{{folderType}}<treenode ng-repeat="item in filteredList = (list | filter:searchText)" node="item" ischecked="selectednode == item.id" check-disable="checkDisable" role="tree" aria-orientation="vertical"></treenode><div class="msg-warning" lang="{{auth.lang}}" ng-if="filteredList.length == 0 && searchText.length > 0" translate="{{\'cm.msg.14\'}}" translate-values="{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}"></div></div>'
		template:'<div>{{folderType}}<treenode ng-repeat="item in filteredList = (list | filter:searchText)" node="item" ischecked="selectednode == item.id" check-disable="checkDisable" role="tree" aria-orientation="vertical" auth-type="authType"></treenode><div class="msg-warning" lang="{{auth.lang}}" ng-if="filteredList.length == 0 && searchText.length > 0" translate="{{\'cm.msg.14\'}}" translate-values="{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}"></div></div>',
		link:function(scope, element, attrs){
			// Function to properly escape special characters
			scope.escapeSearchText = function(text){
				if(!text){
					return "";
				} else{
					return text
						.replace(/\\/g, "&#92;") // Escape backslashes (\)
						.replace(/"/g, "&quot;") // Escape double quotes
						.replace(/'/g, "&apos;") // Escape single quotes
						.replace(/</g, "&lt;") // Escape HTML tags
						.replace(/>/g, "&gt;"); // Escape HTML tags
				}
			}
		}
	}
});
angular.module('hub').directive('treeTf', function(){
	return {
		restrict:"E",
		replace:true,
		scope:{
			list:'=',
			selectednode:'=',
			checkDisable:'=',
			searchText:'='
		},
		// template:'<div>{{folderType}}<treenode ng-repeat="item in filteredList = (list | filter:searchText)" node="item" ischecked="selectednode == item.id" check-disable="checkDisable" role="tree" aria-orientation="vertical"></treenode><div class="msg-warning" lang="{{auth.lang}}" ng-if="filteredList.length == 0 && searchText.length > 0" translate="{{\'cm.msg.14\'}}" translate-values="{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}"></div></div>'
		template:'<div>{{folderType}}<treenode-tf ng-repeat="item in filteredList = (list | filter:searchText)" node="item" ischecked="selectednode == item.id" check-disable="checkDisable" role="tree" aria-orientation="vertical"></treenode-tf><div class="msg-warning" lang="{{auth.lang}}" ng-if="filteredList.length == 0 && searchText.length > 0" translate="{{\'cm.msg.14\'}}" translate-values="{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}"></div></div>',
		link:function(scope, element, attrs){
			// Function to properly escape special characters
			scope.escapeSearchText = function(text){
				if(!text){
					return "";
				} else{
					return text
						.replace(/\\/g, "&#92;") // Escape backslashes (\)
						.replace(/"/g, "&quot;") // Escape double quotes
						.replace(/'/g, "&apos;") // Escape single quotes
						.replace(/</g, "&lt;") // Escape HTML tags
						.replace(/>/g, "&gt;"); // Escape HTML tags
				}
			}
		}
	}
});
angular.module('hub').directive('treeSf', function(){
	return {
		restrict:"E",
		replace:true,
		scope:{
			list:'=',
			selectednode:'=',
			checkDisable:'='
		},
		template:'<div><treenode-sf ng-repeat="item in list" node="item" ischecked="selectednode == item.id" check-disable="checkDisable"></treenode-sf></div>'
	}
});
angular.module('hub').directive('ngTimezone', function(){
  return {
    restrict:'E',
    scope:{
      label:'=',
      timezone:'=',
      timezoneList:'='
    },
    controller:"TimezoneController",
    templateUrl:'app/common/dir/tmpl/timeZone.html'
  }
});
angular.module('hub').directive('timeFormat', function(){
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.on('input', function() {
        var cursorPos = element[0].selectionStart; // Save cursor position
        var value = element.val().replace(/\D/g, ''); // Remove non-numeric characters

        // var hours = value.slice(0, 2) || "00";
        // var minutes = value.slice(2, 4) || "00";
        // var seconds = value.slice(4, 6) || "00";
        // var milliseconds = value.slice(6, 8) || "00"; // Only allow two digits after comma
        var hours = value.slice(0, 2);
        var minutes = value.slice(2, 4);
        var seconds = value.slice(4, 6);
        var milliseconds = value.slice(6, 8); // Only allow two digits after comma

        // Ensure hours, minutes, seconds stay in valid ranges
        // if (parseInt(hours, 10) > 99) hours = "99";
        // if (parseInt(minutes, 10) > 59) minutes = "59";
        // if (parseInt(seconds, 10) > 59) seconds = "59";
        if (hours > 99) hours = "99";
        if (minutes > 59) minutes = "59";
        if (seconds > 59) seconds = "59";

        // Format input with colons and a comma
        var formattedValue = hours;
        if (value.length > 2) formattedValue += ':' + minutes;
        if (value.length > 4) formattedValue += ':' + seconds;
        if (value.length > 6) formattedValue += '.' + milliseconds;

        element.val(formattedValue); // Update input field

        // Adjust cursor position to prevent jump
        var newCursorPos = cursorPos;
        if ([1,2,3,4,5,6,7,8,9].includes(cursorPos)) {
            newCursorPos++; // Skip over colon or comma
        }

        element[0].setSelectionRange(newCursorPos, newCursorPos);
      });
    }
  };
});
angular.module('hub').directive('ngTagIcon', function(){
  return {
      restrict: 'E',
      scope: {
          type: '@',
          color: '@',        // General color for type 'o'
          tagColor: '@'      // Specific tagColor for type 'f'
      },
      templateUrl:'app/common/dir/tmpl/tagIcon.html',
      // template: '<svg ng-if="type == \'o\'" fill="{{color}}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="valign-sub" viewBox="0 0 16 16">\
      //       <path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"/>\
      //       <path d="M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1m0 5.586 7 7L13.586 9l-7-7H2z"/>\
      //     </svg>\
      //     <svg ng-if="type == \'f\'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="{{tagColor}}" class="valign-sub" viewBox="0 0 16 16">\
      //       <path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>\
      //     </svg>',
      link: function(scope, element, attrs) {
          // If further logic is needed for SVG handling, you can place it here
      }
  };
});

angular.module('hub').directive('srcError', function($rootScope){
  return {
    link:function(scope, element, attrs){
      element.bind('load', function(){
        scope.$apply($rootScope.imageLoaded= true);
      });
      element.bind('error', function(){        
        if(attrs.src != attrs.srcError){
          if(attrs.srcError == ''){
            $(this).closest('a').addClass('hide');
            scope.$apply($rootScope.srcErrorShow = true);
          } else{
            if(attrs.srcError == 'userError'){
              scope.userImg.uImg = '';
              scope.$apply($rootScope.srcErrorShow = true);
            } else{
              attrs.$set('src', attrs.srcError);
            }
          }
        }
      });
    }
  }
});
angular.module('hub').directive('sortable', function(){
  return{
    // A = attribute, E = Element, C = Class and M = HTML Comment
    restrict:'A',
    scope:{
      axis:'=',
      callback:'&',
      containment:'='
    },
    link:function($scope, element, attrs){
      if($scope.containment){
        element.sortable({
          containment:$scope.containment,
          axis:$scope.axis,
          items:".sortable-item",
          revert:false,
          stop:function(e, ui){
            $scope.callback(e, ui, element.data("index"));
          }
        });
      } else{
        element.sortable({
          containment:".sortable-containment",
          axis:$scope.axis,
          items:".sortable-item",
          revert:false,
          stop:function(e, ui){
            $scope.callback(e, ui, element.data("index"));
          }
        });
      }
    }
  };
});
angular.module("hub").directive("singleSelection", function($rootScope, $document){
  return {
    restrict:"A",
    link:function($scope, element, attr){
      if($scope.selection == false){
        $document.find("[selectable]").addClass("ui-selectable");
        $document.find('.table li input[type="checkbox"]').replaceWith('<input type="radio" role="radio" name="radioOpt" aria-label="radioOpt" aria-labelledby="radioOpt">');
        setTimeout(function(){
          $document.find('.table li.nonSelectable input[type="radio"]').remove();
        }, 10);
        element.bind("click", function($event){
          if(!element.hasClass("nonSelectable") && $event.target.nodeName != "BUTTON"){
            $document.find(".ui-selected").removeClass("ui-selected");
            element.addClass("ui-selected");
            element.find('input[type="radio"]').prop("checked", true);
            $rootScope.singleSelected = {
              id:element.attr("data-id"),
              type:element.attr("data-type")
            }
          }
        });
      }
    }
  }
});
angular.module('hub').directive('searchTbx', function(){
  return {
    restrict:'C',
    link:function(scope, element, attrs){
      element.children(".text-danger").bind('click', function($event){
        element.children("input[type=text]").focus();
      });
    }
  }
});
(function(){
    'use strict';
  
    angular
      .module('hub')
      .directive('scrollTree', scrollTree);
  
    /** @ngInject */
    function scrollTree(){
      return{
        link:function(scope, element, attrs){
            var prevScrollLeft = 0;
            var button = document.getElementsByClassName('favIconTree');
            element.on('scroll', function(){
                var currentScrollLeft = element.scrollLeft();

                if (currentScrollLeft > prevScrollLeft) {
                    // Scrolling to the right
                    for (var i = 0; i < button.length; i++) {
                        button[i].style.right = '-' + currentScrollLeft + 'px';
                    }
                } else if (currentScrollLeft < prevScrollLeft) {
                    // Scrolling to the left
                    for (var i = 0; i < button.length; i++) {
                        button[i].style.right = '-' + currentScrollLeft + 'px';
                    }
                } else {
                    console.log('Not scrolling horizontally');
                }

                prevScrollLeft = currentScrollLeft;
            });
        }
      }
    }
  })();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('sanitizeInput', sanitizeInput);

  /** @ngInject */
  function sanitizeInput(){
    return{
      restrict:'A',
      require:'ngModel',
      link:function(scope, element, attrs, ngModel){
        element.on('input', function(){
          var sanitizedValue = element.val()
          // .replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
          .replace(/^\s+/, "") // Remove leading spaces
          .replace(/!/g, "")
          ngModel.$setViewValue(sanitizedValue);
          ngModel.$render();
        });
      }
    }
  }
})();
angular.module('hub').directive('rotatable', function(){
  return {
    // A = attribute, E = Element, C = Class and M = HTML Comment
    restrict:'A',
    link:function(scope, element, attrs){
      element.rotatable({
        start:function(event, ui){},
        // Callback fired during rotation.
        rotate:function(event, ui){},
        // Callback fired on rotation end.
        stop:function(event, ui){
          $scope.frameRotateStop(e, ui, element.data("index"));
        }
      });
    }
  };
});
angular.module('hub').directive('resizer', function($document){
	return function($scope, $element, $attrs){
		$element.on('mousedown', function(event){
			event.preventDefault();
			$document.on('mousemove', mousemove);
			$document.on('mouseup', mouseup);
		});
		function mousemove(event){
			var outerPos = $document.find('.flex-wrap').position();
			if($attrs.resizer == 'vertical'){
				// Handle vertical resizer
				var	x = parseInt(event.pageX) - parseInt(outerPos.left);
				if($attrs.resizerMax && x > $attrs.resizerMax){//MaxLength
					x = parseInt($attrs.resizerMax);
				}
        if($attrs.resizerMin && x < $attrs.resizerMin){//MinLength
					x = parseInt($attrs.resizerMin);
				}
				$element.css({
					left:x + 'px'
				});
				$($attrs.resizerLeft).css({
					width:x + 'px'
				});
				$($attrs.resizerRight).css({
					left:(x + parseInt($attrs.resizerWidth)) + 'px'
				});
			} else{
				// Handle horizontal resizer
				var y = window.innerHeight - event.pageY - 55;
				if($attrs.resizerMax && y > $attrs.resizerMax){//MaxLength
					y = parseInt($attrs.resizerMax);
				}
				if($attrs.resizerMin && y < $attrs.resizerMin){//MinLength
					y = parseInt($attrs.resizerMin);
				}
				$element.css({
					bottom:y + 'px'
				});

				$($attrs.resizerTop).css({
					bottom:(y + parseInt($attrs.resizerHeight) * 0.5) + 'px'
				});
				$($attrs.resizerBottom).css({
					height:y + 'px'
				});
			}
		}
		function mouseup(){
			$document.unbind('mousemove', mousemove);
			$document.unbind('mouseup', mouseup);
		}
	};
});
angular.module('hub').directive('resizableHeight', function($document){
    return {
        link: function(scope, element) {
            var startY = 0,
                startHeight = 0;
            var resizableDiv, parentDiv;

            element.on('mousedown', function(event) {
                event.preventDefault();
                resizableDiv = angular.element(element).prev(); // Get the previous sibling as the resizable div
                parentDiv = angular.element(element).parent();

                startY = event.clientY;
                startHeight = resizableDiv[0].offsetHeight;

                $document.on('mousemove', mousemove);
                $document.on('mouseup', mouseup);
            });

            function mousemove(event) {
                var newHeight = startHeight + (event.clientY - startY);
                if (newHeight > 137) { // Adjust the minimum height as needed
                    resizableDiv.css('height', newHeight + 'px');
                }
            }

            function mouseup() {
                $document.off('mousemove', mousemove);
                $document.off('mouseup', mouseup);
            }
        }
    };
  });
angular.module('hub').directive('resizable', function(){
  return{
    restrict:'A',
    scope:{
      callback:'&onResize'
    },
    link:function postLink(scope, elem, attrs){
      elem.resizable({
        grid:1,
        containment:".flGrid"
      });
      elem.on('resize', function(evt, ui){
        scope.$apply(function(){
          if(scope.callback){
            scope.callback({$evt:evt, $ui:ui });
          }
        });
      });
    }
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('regex', regex);

  /** @ngInject */
  function regex($compile){
    return {
      restrict:'A',
      require:'ngModel',
      link:function($scope, $elem, attrs, ctrl){
        var regReplace,
          preset = {
            'only-numbers':'0-9',
            'numbers':'0-9\\s',
            'only-letters':'A-Za-z',
            'letters':'A-Za-z\\s',
            'email':'\\wÑñ@._\\-',
            'alpha-numeric':'\\w\\s',
            'latin-alpha-numeric':'\\w\\sÑñáéíóúüÁÉÍÓÚÜ'
          },
          filter = preset[attrs.regex] || attrs.regex;

        $elem.on('input', function(){
          regReplace = new RegExp('[^' + filter + ']', 'ig');
          ctrl.$setViewValue($elem.val().replace(regReplace, ''));
          ctrl.$render();
        });
      }
    }
  }
})();
angular.module('hub').directive('processBtn', function(){
  return {
    restrict:"A",
    scope:{
      target:"@processBtn",
      processLabel:"@processLabel"
    },
    link:function(scope, element, attr){
      element.bind('click', function(){
        if(scope.target){
          element.html('<span class="fa fa-repeat fa-spin fa-fw" aria-hidden="true"></span>' + scope.processLabel);
        }
      });
    }
  }
});
angular.module('hub').directive('ngPinItems', function(){
  return {
    restrict:'EA',
    scope:{
      pinItemsList:'='
    },
    controller:"PinItemsController",
    templateUrl:'app/common/dir/tmpl/pinItems.html'
  }
});
angular.module('hub').directive('ngPermissionBrief', function(){
  return {
    restrict:'E',
    scope:{
      permission:'=',
      pid:'=',
      cfo:'=',
      module:'=',
      isDisabled:"=",
      other:"=",
      assignable:"="
    },
    controller:"PermissionsController",
    templateUrl:'app/common/dir/tmpl/permissionsBrief.html'
  }
});
angular.module('hub').directive('ngPermissionDetails', function(){
  return {
    restrict:'E',
    templateUrl:'app/common/dir/tmpl/permissionsDetails.html',
    link:function(scope, element, attrs){
       scope.$on('savePermission',function(event, data){
         scope.permissionFx('save');
      });
     },
  }
});
(function () {
  'use strict';

  angular
    .module('hub')
    .directive('ngScrollList', ngScrollList);

  /** @ngInject */
  function ngScrollList($timeout, $rootScope, $filter) {
    return {
      restrict: 'A',
      scope: {
        listData: '=',
        visibleData: '=',
        st: '=',
        et: '=',
        searchData: '=',
        haveMoreData: '=',
        searchScroll: '=',
        cloneData: '=',
        haveMoreSearchData: '=',
        ddOpen: '='
      },
      link: function ($scope, element, attrs) {
        // TODO Display window size is 300 items at a time
        $scope.itemsPerPage = 300;
        $scope.sData = false;
        // TODO Number of objects to add/remove on scroll is 100
        $scope.scrollStep = 100;

        // TODO Initial visible range
        $scope.startIndex = $scope.st;
        $scope.endIndex = $scope.et;

        $scope.lastVisibleObjectIndex = 0;

        // TODO Initialize the visible objects
        $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.endIndex);
        $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex });
        $scope.loadingData = false;

        var lastScrollTop = 0;

        var havescroll = true;
        // TODO Check if the container has a scroll
        function hasVerticalScroll() {
          return element[0].scrollHeight > element[0].clientHeight;
        }
        
        $scope.$watch('searchData', function (newVal, oldVal) {
          console.warn("$scope.ddOpen",$scope.ddOpen);
          if($scope.ddOpen == true){
            setTimeout(function(){
              havescroll = hasVerticalScroll();
            })
          }
        });

        element.bind('scroll', function () {
          setTimeout(function(){
            $scope.startIndex = $scope.st;
            $scope.endIndex = $scope.et;

            if($scope.searchScroll && !$scope.haveMoreSearchData){
              $scope.sData = true;
            } else{
              $scope.sData = false;
            }
            var rowObjList = $("#scroll-container .rowObj");
            if (rowObjList.length > 0) {
              // TODO Log the ID of the first element
              var firstElement = $(rowObjList[0]);
              var firstElementId = firstElement.attr("id");
  
              // TODO Log the ID of the last element
              var lastElement = $(rowObjList[rowObjList.length - 1]);
              var lastElementId = lastElement.attr("id");
            }
  
            var scrollTop = element[0].scrollTop;
            var offsetHeight = element[0].offsetHeight;
            var scrollHeight = element[0].scrollHeight;
  
            // TODO Scrolling down
            if (scrollTop + offsetHeight >= scrollHeight - 10 && havescroll) {
              handleScrollDown(lastElementId);
            }
  
            // TODO  Scrolling up
            if (scrollTop === 0 && lastScrollTop > scrollTop && havescroll) {
              handleScrollUp(firstElementId);
            }
  
            lastScrollTop = scrollTop;
          })
        });

        function handleScrollDown(lastElementId){
          if (($scope.endIndex + $scope.scrollStep <= $scope.listData.length) && !$scope.loadingData) {
            $scope.loadingData = true;

            // TODO Calculate the last visible object before loading new data
            // TODO Last item currently visible
            $scope.lastVisibleObjectIndex = $scope.endIndex;
            
            var lastVisibleObjId = $("#scroll-container .rowObj" + '#' +lastElementId).get(0);
            if(lastVisibleObjId != null){
              var lastElementOffset = lastVisibleObjId.getBoundingClientRect().bottom;
            }

            if ((Math.abs(Math.abs($scope.listData.length - $scope.lastVisibleObjectIndex) - $scope.scrollStep) < $scope.scrollStep) && $scope.haveMoreData && !$scope.sData) {
              $rootScope.$broadcast('loadNextData', {text: $scope.searchData});
            }

            setTimeout(function(){
              // var lastVisibleObjId = document.getElementById(lastElementId);
              // if(lastVisibleObjId){
              //   lastVisibleObjId.scrollIntoView({
              //     behavior: 'smooth',  // * Optional: 'smooth' for animated scrolling
              //     block: 'center'      // * Optional: Scrolls to the center of the container
              //   });
              // }
              
              // Adjust scroll position so that the previous top element remains at the same position
              var newLastVisibleObjId = $("#scroll-container .rowObj" + '#' +lastElementId).get(0);
              if(newLastVisibleObjId != null){                
                var newLastElementOffset = newLastVisibleObjId.getBoundingClientRect().bottom;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newLastElementOffset - lastElementOffset;
                element[0].scrollTop -= scrollAdjustment;
              }

              // TODO Remove the top 100 and load the next 100
              $scope.startIndex += $scope.scrollStep;
              $scope.endIndex += $scope.scrollStep;
              $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
              $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex });
              $scope.loadingData = false;
            }, 0);
          } else if (($scope.endIndex + $scope.scrollStep > $scope.listData.length) && !$scope.loadingData && $scope.listData.length != $scope.endIndex && $scope.listData.length > 300) {
            $scope.loadingData = true;
            // TODO Calculate the last visible object before loading new data
            $scope.lastVisibleObjectIndex = $scope.endIndex; // Last item currently visible
            
            var lastVisibleObjId = $("#scroll-container .rowObj" + '#' +lastElementId).get(0);
            if(lastVisibleObjId != null){
              var lastElementOffset = lastVisibleObjId.getBoundingClientRect().bottom;
            }

            var newScrollStep = $scope.listData.length - $scope.lastVisibleObjectIndex

            setTimeout(function(){
              // var lastVisibleObjId = document.getElementById(lastElementId);
              // lastVisibleObjId.scrollIntoView({
              //   behavior: 'smooth',  // * Optional: 'smooth' for animated scrolling
              //   block: 'center'      // * Optional: Scrolls to the center of the container
              // });
              
              // Adjust scroll position so that the previous top element remains at the same position
              var newLastVisibleObjId = $("#scroll-container .rowObj" + '#' +lastElementId).get(0);
              if(newLastVisibleObjId != null){
                var newLastElementOffset = newLastVisibleObjId.getBoundingClientRect().bottom;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newLastElementOffset - lastElementOffset;
                element[0].scrollTop -= scrollAdjustment;
              }

              // TODO Remove the top 100 and load the next 100
              $scope.startIndex += newScrollStep;
              $scope.endIndex += newScrollStep;
              $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
              $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex });
              $scope.loadingData = false;
            }, 0);
          }
        }

        function handleScrollUp(firstElementId) {
          if (($scope.startIndex - $scope.scrollStep >= 0) && !$scope.loadingData) {
            $scope.loadingData = true;

            // TODO Last item currently visible
            $scope.topVisibleObjectIndex = $scope.startIndex;

            var firstVisibleObjId = $("#scroll-container .rowObj" + '#' +firstElementId).get(0);
            if(firstVisibleObjId != null){
              var firstElementOffset = firstVisibleObjId.getBoundingClientRect().top;
            }

            // TODO Remove the bottom 100 and load the previous 100
            $scope.startIndex -= $scope.scrollStep;
            $scope.endIndex -= $scope.scrollStep;
            $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex });
            setTimeout(function () {              
              // Adjust scroll position so that the previous top element remains at the same position
              var newFirstVisibleObjId = $("#scroll-container .rowObj" + '#' +firstElementId).get(0);
              if(newFirstVisibleObjId != null){
                var newFirstElementOffset = newFirstVisibleObjId.getBoundingClientRect().top;
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newFirstElementOffset - firstElementOffset;
                element[0].scrollTop += scrollAdjustment;
              }
              $scope.loadingData = false;
            }, 200);

          } else if (($scope.startIndex - $scope.scrollStep < 0) && !$scope.loadingData && $scope.startIndex != 0) {
            // TODO Availabele top data
            $scope.loadingData = true;

            // TODO Last item currently visible
            $scope.topVisibleObjectIndex = $scope.startIndex;

            var firstVisibleObjId = $("#scroll-container .rowObj" + '#' +firstElementId).get(0);
            if(firstVisibleObjId != null){
              var firstElementOffset = firstVisibleObjId.getBoundingClientRect().top;
            }

            // TODO Remove the bottom 100 and load the previous 100
            $scope.startIndex -= $scope.topVisibleObjectIndex;
            $scope.endIndex -= $scope.topVisibleObjectIndex;
            $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
            $rootScope.$broadcast('visibleData', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex });

            setTimeout(function () {
              // Adjust scroll position so that the previous top element remains at the same position
              var newFirstVisibleObjId = $("#scroll-container .rowObj" + '#' +firstElementId).get(0);
              if(newFirstVisibleObjId != null){
                var newFirstElementOffset = newFirstVisibleObjId.getBoundingClientRect().top;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newFirstElementOffset - firstElementOffset;
                element[0].scrollTop += scrollAdjustment;
              }
              $scope.loadingData = false;
            }, 200);
          }
        }
      }
    }
  }
})();
(function(){
    'use strict';
  
    angular
      .module('hub')
      .directive('ngScroll', ngScroll);
  
    /** @ngInject */
    function ngScroll(){
      return{
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('scroll', function() {
                scope.$apply(attrs.ngScroll);
            });
        }
      }
    }
})();
angular.module('hub').directive('ngHubColorPicker', function(){
  return {
    restrict:'E',
    scope:{
      selectedColor:'=',
      selectedAlpha:'=',
      selectedType:'=',
      selectedRgba:'=',
      isAlpha:"=",
      selectedElm:"="
    },
    controller:"HubColorPickerController",
    templateUrl:'app/common/dir/tmpl/hubColorPicker.html'
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('input', input);

  /** @ngInject */
  function input($compile){
    return {
      restrict:'E',
      link:function($scope, $element, $attributes){
        //Set MaxLength
        var t;
        if($attributes.type == "text" && !$attributes.maxlength){
          $element.attr("maxlength", "250");
        }
        /*read maxLength length for all maxlength input with number field*/
        $scope.enforceMaxlength = function(event){
          t = event.target;
          if(t.hasAttribute('maxlength')){
            if(t.value.length > t.getAttribute("maxlength")){
              t.value = t.value.slice(0, t.getAttribute('maxlength'));
            }
          }
        }
        document.body.addEventListener('input', $scope.enforceMaxlength);
      }
    }
  }
})();
angular.module('hub').directive('ngFramePermission', function(){
  return {
    restrict:'E',
    templateUrl:'app/common/dir/tmpl/permissionsDetails.html',
    controller:'FramePermissionsController'
  }
});
angular.module('hub').directive('fileModel', function(ngDialog, $rootScope, $filter){
  return{
    restrict:'EA',
    transclude:'true',
    scope:{
      fileModel:'=' //Two-way data binding
    },
    link: function($scope, element, attrs){
      $scope.attachmentFormat = ["jpg","jpeg","png","gif","txt","doc","docx","xls","xlsx","ppt","pptx","csv","pdf"];
      element.bind('change', function(){
        $scope.$apply(function(){
          /* Storage plan */
          $rootScope.isSPSize = false;
          $scope.options = $scope.$eval(attrs.options);
          $scope.fmType = attrs.fmtype;
          $rootScope.uploadError = false;
          $rootScope.hasErr = false;
          $scope.errorMsg = "";
          $scope.sFile = [];
          $scope.auth = angular.fromJson(localStorage.getItem("auth"));

          $scope.sizeOptFx = function(){
            if($scope.options.callback && $scope.options.multiple && !$scope.options.value){
              $rootScope.createFilelUploadFx($scope.sFile);
            } else if($scope.options.callback && !$scope.options.value && !$scope.options.multiple){
              $rootScope.fileModelUploadFx(element[0].files[0], $scope.fmType);
            } else if($scope.options.callback && $scope.options.value){
              $rootScope.fileModelUploadFx(element[0].files[0], $scope.options.value);
            } else{
              $scope.fileModel = element[0].files[0];
            }
          }
          $scope.sizeFx = function(){
            /* Storage plan */
            $rootScope.isSPSize = false;
            if($scope.auth.strg.s && (element[0].files[0].size > $scope.auth.strg.s)){
              $rootScope.isSPSize = true;
              $scope.fileModel = "";
              return;
            }
            if($scope.options.size){
              if(element[0].files[0].size == 0){
                $scope.errorMsg = "sizeZero";
              } else if(element[0].files[0].size < $scope.options.size){
                $scope.sizeOptFx();
              } else{
                $scope.errorMsg = "size";
              }
            } else{
              $scope.sizeOptFx();
            }
          }

          $scope.cursFiles = [];
          $scope.curuFiles = [];
          $scope.isSupported = false;
          if($scope.options.format[0] == "inventory"){
            $scope.curSize = 0;
            angular.forEach(element[0].files, function(file){
              $scope.curExt = angular.lowercase(file.name.substring(file.name.lastIndexOf(".") + 1));
              if($rootScope.itemInArray($scope.attachmentFormat, $scope.curExt)){
                $scope.cursFiles.push(file);
              } else{
                $scope.curuFiles.push(file);
              }
              $scope.isSupported = $rootScope.itemInArray($scope.attachmentFormat, $scope.curExt);
              if($scope.isSupported || $scope.cursFiles.length){
                $scope.curSize = $scope.curSize + file.size;
              }
            });

            if($scope.isSupported || $scope.cursFiles.length){
              if($scope.options.size){
                if($scope.curSize == 0){
                  $scope.errorMsg = "sizeZero";
                } else if($scope.curSize < $scope.options.size){
                  angular.forEach($scope.curuFiles, function(item){
                    $scope.uFiles.push(item);
                  });
                  if($scope.sFile.length){
                    $scope.sFileSize = 0;
                    angular.forEach($scope.sFile, function(item){
                      $scope.sFileSize = $scope.sFileSize + item.size;
                    });

                    $scope.curFileSize = $scope.sFileSize + $scope.curSize;

                    if($scope.curFileSize < $scope.options.size){
                      angular.forEach($scope.cursFiles, function(item){
                        $scope.sFile.push(item);
                        $scope.sizeOptFx("if");
                      });
                    } else{
                      $scope.errorMsg = "size";
                    }

                  } else{
                    angular.forEach($scope.cursFiles, function(item){
                      $scope.sFile.push(item);
                      $scope.sizeOptFx("else");
                    });
                  }
                } else{
                  $scope.errorMsg = "size";
                }
              } else{
                // $scope.sFile = $scope.cursFiles;
                // $scope.uFiles = $scope.curuFiles;
              }
              //$scope.sizeFx();
            }
            else{
              $scope.errorMsg = "format";
            }

            //Error
            if($scope.errorMsg != ""){
              $scope.fileModel = "";
              $('input[type="file"]').val(null);
              if(angular.isUndefined($scope.options.errorPop)){
                $scope.fileSize = $filter("filesize")($scope.options.size);
                ngDialog.open({
                  template: '\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <span ng-if="errorMsg == \'format\'">\
                          <p>{{"cm.msg.23" | translate}}</p>\
                          <div class="text-left">\
                            <div class="text-ucase">\
                              <span ng-repeat="ext in attachmentFormat">{{ext}}<span ng-if="!$last">, </span></span>\
                            </div>\
                          </div>\
                        </span>\
                        <span ng-if="errorMsg == \'size\'">{{"cm.msg.24" | translate:{fileSize:fileSize} }}</span>\
                        <span ng-if="errorMsg == \'sizeZero\'">{{"cl.p_c.m4" | translate}}</span>\
                      </div>\
                      <footer class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();">{{"cm.btn.1" | translate}}</button>\
                      </footer>\
                    </section>',
                  plain: true,
                  width: 450,
                  scope: $scope,
                  closeByDocument: false,
                  className: 'ngdialog-theme-default ngdialog-confirm',
                });
              } else{
                $rootScope.uploadError = true;
                $rootScope.uploadErrorType = $scope.errorMsg;
              }
            }
          }

          if($scope.options.format[0] !== "inventory" && element[0].files[0]){
            $scope.curName = element[0].files[0].name;
            $scope.curType = element[0].files[0].type.split("/");
            $scope.curEleFormat = angular.lowercase($scope.curName.substring($scope.curName.lastIndexOf(".") + 1));
            //$scope.otherFormat = ["swf", "pdf", "ppt", "pptx", "pps", "ppsx", "doc", "docx"];
            if($scope.options.sFiles){
              if($scope.options.format[0] == "image" && $rootScope.itemInArray($rootScope.sFiles.img, $scope.curEleFormat)){
                $scope.sizeFx();
              } else if($scope.options.format[0] == "video" && $rootScope.itemInArray($rootScope.sFiles.vid, $scope.curEleFormat)){
                $scope.sizeFx();
              } else if($scope.options.format[0] == "audio" && $rootScope.itemInArray($rootScope.sFiles.aud, $scope.curEleFormat)){
                $scope.sizeFx();
              }
              else if($scope.options.format[1] === "doc" || $scope.options.format[1] === "docx" || $scope.options.format[1] === "odt"){
                if($scope.curEleFormat === "doc" || $scope.curEleFormat === "docx" || $scope.curEleFormat === "odt"){
                  if($rootScope.itemInArray($rootScope.sFiles.ot, $scope.curEleFormat)){
                    $scope.sizeFx();
                  } else{
                    $scope.errorMsg = "format";
                  }
                } else{
                  $scope.errorMsg = "format";
                }
              }
              else if($scope.options.format[1] === "odp" || $scope.options.format[1] === "pps" || $scope.options.format[1] === "ppt" || $scope.options.format[1] === "pptx" || $scope.options.format[1] === "ppsx"){
                if($scope.curEleFormat === "odp" || $scope.curEleFormat === "pps" || $scope.curEleFormat === "ppt" || $scope.curEleFormat === "pptx" || $scope.curEleFormat === "ppsx"){
                  if($rootScope.itemInArray($rootScope.sFiles.ot, $scope.curEleFormat)){
                    $scope.sizeFx();
                  } else{
                    $scope.errorMsg = "format";
                  }
                } else{
                  $scope.errorMsg = "format";
                }
              }
              else if($scope.options.format[1] == $scope.curEleFormat && $rootScope.itemInArray($rootScope.sFiles.ot, $scope.curEleFormat)){
                $scope.sizeFx();
              }
              else{
                $scope.errorMsg = "format";
              }
            }
            else if($filter("filter")($scope.options.format, "image")[0] == $scope.curType[0] && element[0].files[0].type != "image/x-icon"){
              $scope.sizeFx();
            } else if($filter("filter")($scope.options.format, "video")[0] == $scope.curType[0]){
              $scope.sizeFx();
            } else if($filter("filter")($scope.options.format, "audio")[0] == $scope.curType[0]){
              $scope.sizeFx();
            } else if($scope.options.format[0] == "image" && $rootScope.itemInArray($rootScope.sFiles.img, $scope.curEleFormat)){
              $scope.sizeFx();
            } else if($scope.options.format[0] == "video" && $rootScope.itemInArray($rootScope.sFiles.vid, $scope.curEleFormat)){
              $scope.sizeFx();
            } else if($scope.options.format[0] == "audio" && $rootScope.itemInArray($rootScope.sFiles.aud, $scope.curEleFormat)){
              $scope.sizeFx();
            } else if($filter("filter")($scope.options.format, "csOther")[0] == "csOther"){
              if($scope.curEleFormat == "ai" ||
                $scope.curEleFormat == "eps" ||
                $scope.curEleFormat == "psd" ||
                $scope.curEleFormat == "pdf" ||
                $scope.curEleFormat == "ppt" ||
                $scope.curEleFormat == "pptx"||
                $scope.curEleFormat == "doc" ||
                $scope.curEleFormat == "docx"||
                $scope.curEleFormat == "zip" ||
                $scope.curEleFormat == "rar"){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($rootScope.itemInArray($rootScope.sFiles.ot, $scope.curEleFormat)){
              // if($scope.curEleFormat == "swf" && $scope.options.format[1] == "swf"){
              //   $scope.sizeFx();
              // }
              if($scope.curEleFormat == "pdf" && $scope.options.format[1] == "pdf"){
                $scope.sizeFx();
              } else if(($scope.curEleFormat == "doc" || $scope.curEleFormat == "docx" || $scope.curEleFormat == "odt") && ($scope.options.format[1] == "doc" || $scope.options.format[1] == "docx" || $scope.options.format[1] == "odt")){
                $scope.sizeFx();
              } else if(($scope.curEleFormat == "xls" || $scope.curEleFormat == "xlsx") && ($scope.options.format[0] == "excel")){
                $scope.sizeFx();
              } else if(($scope.curEleFormat == "ppt" || $scope.curEleFormat == "pptx" || $scope.curEleFormat == "pps" || $scope.curEleFormat == "odp") && ($scope.options.format[1] == "ppt" || $scope.options.format[1] == "pptx" || $scope.options.format[1] == "pps" || $scope.options.format[1] == "odp")){
                $scope.sizeFx();
              } else if(($scope.curEleFormat == "pps" || $scope.curEleFormat == "ppsx") && ($scope.options.format[1] == "pps" || $scope.options.format[1] == "ppsx")){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($scope.options.format[0] == "imgOnly"){
              if($rootScope.itemInArray(['jpg', 'jpeg', 'png', 'gif'], $scope.curEleFormat)){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($scope.options.format[0] == "xml"){
              if($rootScope.itemInArray(['xml'], $scope.curEleFormat)){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($scope.options.format[0] == "excel"){
              if($rootScope.itemInArray(['xls', 'xlsx'], $scope.curEleFormat)){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($scope.options.format[0] == "csv"){
              if($rootScope.itemInArray(['csv'], $scope.curEleFormat)){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else if($scope.options.format[0] == "srt"){
              if($rootScope.itemInArray(['srt'], $scope.curEleFormat)){
                $scope.sizeFx();
              } else{
                $scope.errorMsg = "format";
              }
            } else{
              $scope.errorMsg = "format";
            }

            //Error
            if($scope.errorMsg != ""){
              $scope.fileModel = "";
              $('input[type="file"]').val(null);
              if(angular.isUndefined($scope.options.errorPop)){
                $scope.fileSize = $filter("filesize")($scope.options.size);
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <span ng-if="errorMsg==\'format\'">{{"cm.msg.23" | translate}}</span>\
                        <span ng-if="errorMsg==\'size\'">{{"cm.msg.24" | translate:{fileSize:fileSize} }}</span>\
                        <span ng-if="errorMsg==\'sizeZero\'">{{"cl.p_c.m4" | translate}}</span>\
                      </div>\
                      <footer class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();">{{"cm.btn.1" | translate}}</button>\
                      </footer>\
                    </section>',
                  plain:true,
                  width:450,
                  scope:$scope,
                  closeByDocument:false,
                  className:'ngdialog-theme-default ngdialog-confirm',
                });
              } else{
                $rootScope.uploadError = true;
                $rootScope.uploadErrorType = $scope.errorMsg;
              }
            }
          }
        });
      });
    }
  };
});
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('elementHeight', elementHeight);

  /** @ngInject */
  function elementHeight($filter){
    return {
      restrict:'EA',
      scope:{
        elementHeight:'=',
        delay:'@'
      },
      link:function($scope, element, attrs, ctrl){
        element.bind('scroll', function(){
          element[0].classList.remove("h100");
          element[0].children[0].classList.remove("h100");
        });
        $scope.$watch(function(){
          if($scope.delay){
            $scope.elementHeightFx();
          } else{
            setTimeout(function(){
              $scope.elementHeightFx();
            }, 100);
          }
        });
        $scope.elementHeightFx = function(){
          if(element[0].offsetHeight > 0 ){
            if(element[0].children.length == 0){
              if(element.hasClass("overflow-auto")){
                element[0].style.height = 0;
              }
              element[0].classList.remove("h100");
            } else if(element[0].offsetHeight <= $scope.elementHeight){
              element[0].classList.add("h100");
              element[0].children[0].classList.add("h100");
            } else{
              element[0].classList.remove("h100");
              element[0].children[0].classList.remove("h100");
            }
          }
        }
      }
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('hub')
    .directive('dynamicScrollList', dynamicScrollList);

  /** @ngInject */
  function dynamicScrollList($timeout, $rootScope, $filter) {
    return {
      restrict: 'A',
      scope: {
        listData: '=',
        visibleData: '=',
        st: '=',
        et: '=',
        searchData: '=',
        haveMoreData: '=',
        searchScroll: '=',
        cloneData: '=',
        haveMoreSearchData: '=',
        quadId: '=',
        ddOpen: '='
      },
      link: function ($scope, element, attrs) {
        // TODO Display window size is 300 items at a time
        $scope.itemsPerPage = 300;
        $scope.sData = false;
        // TODO Number of objects to add/remove on scroll is 100
        $scope.scrollStep = 100;

        // TODO Initial visible range
        $scope.startIndex = $scope.st;
        $scope.endIndex = $scope.et;

        $scope.lastVisibleObjectIndex = 0;

        // TODO Initialize the visible objects
        $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.endIndex);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex, quadId:$scope.quadId});
        $scope.loadingData = false;

        var lastScrollTop = 0;

        var havescroll = true;
        // TODO Check if the container has a scroll
        function hasVerticalScroll() {
          return element[0].scrollHeight > element[0].clientHeight;
        }

        $scope.$watch('searchData', function (newVal, oldVal) {
          if($scope.ddOpen == true){
            setTimeout(function () {
              havescroll = hasVerticalScroll();
            })
          }
        });

        element.bind('scroll', function () {
          setTimeout(function () {
            $scope.startIndex = $scope.st;
            $scope.endIndex = $scope.et;

            if ($scope.searchScroll && !$scope.haveMoreSearchData) {
              $scope.sData = true;
            } else {
              $scope.sData = false;
            }
            var rowObjList = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId);
            if (rowObjList.length > 0) {
              // TODO Log the ID of the first element
              var firstElement = $(rowObjList[0]);
              var firstElementId = firstElement.attr("id");

              // TODO Log the ID of the last element
              var lastElement = $(rowObjList[rowObjList.length - 1]);
              var lastElementId = lastElement.attr("id");
            }

            var scrollTop = element[0].scrollTop;
            var offsetHeight = element[0].offsetHeight;
            var scrollHeight = element[0].scrollHeight;

            // TODO Scrolling down
            if (scrollTop + offsetHeight >= scrollHeight - 10 && havescroll) {
              handleScrollDown(lastElementId);
            }

            // TODO  Scrolling up
            if (scrollTop === 0 && lastScrollTop > scrollTop && havescroll) {
              handleScrollUp(firstElementId);
            }

            lastScrollTop = scrollTop;
          })
        });

        function handleScrollDown(lastElementId) {
          if (($scope.endIndex + $scope.scrollStep <= $scope.listData.length) && !$scope.loadingData) {
            $scope.loadingData = true;

            // TODO Calculate the last visible object before loading new data
            // TODO Last item currently visible
            $scope.lastVisibleObjectIndex = $scope.endIndex;
            
            var lastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);
            if(lastVisibleObjId != null){
              var lastElementOffset = lastVisibleObjId.getBoundingClientRect().bottom;
            }

            if ((Math.abs(Math.abs($scope.listData.length - $scope.lastVisibleObjectIndex) - $scope.scrollStep) < $scope.scrollStep) && $scope.haveMoreData && !$scope.sData) {
              $rootScope.$broadcast('loadNextDataDyn', { text: $scope.searchData, quadId:$scope.quadId });
            }

            setTimeout(function () {
              // var lastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);
              // if (lastVisibleObjId) {
              //   lastVisibleObjId.scrollIntoView({
              //     behavior: 'smooth',  // * Optional: 'smooth' for animated scrolling
              //     block: 'center'      // * Optional: Scrolls to the center of the container
              //   });
              // }
              // Get the scroll container
              
              // Adjust scroll position so that the previous top element remains at the same position
              var newLastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);              
              if(newLastVisibleObjId != null){
                var newLastElementOffset = newLastVisibleObjId.getBoundingClientRect().bottom;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newLastElementOffset - lastElementOffset;
                element[0].scrollTop -= scrollAdjustment;
              }

              // TODO Remove the top 100 and load the next 100
              $scope.startIndex += $scope.scrollStep;
              $scope.endIndex += $scope.scrollStep;
              $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex, quadId:$scope.quadId });
              $scope.loadingData = false;
            }, 0);
          } else if (($scope.endIndex + $scope.scrollStep > $scope.listData.length) && !$scope.loadingData && $scope.listData.length != $scope.endIndex && $scope.listData.length > 300) {
            $scope.loadingData = true;
            // TODO Calculate the last visible object before loading new data
            $scope.lastVisibleObjectIndex = $scope.endIndex; // Last item currently visible

            var lastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);
            if(lastVisibleObjId != null){
              var lastElementOffset = lastVisibleObjId.getBoundingClientRect().bottom;
            }

            var newScrollStep = $scope.listData.length - $scope.lastVisibleObjectIndex

            setTimeout(function () {
              // var lastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);
              // lastVisibleObjId.scrollIntoView({
              //   behavior: 'smooth',  // * Optional: 'smooth' for animated scrolling
              //   block: 'center'      // * Optional: Scrolls to the center of the container
              // });
              // Get the scroll container
              
              // Adjust scroll position so that the previous top element remains at the same position
              var newLastVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +lastElementId).get(0);
              if(newLastVisibleObjId != null){
                var newLastElementOffset = newLastVisibleObjId.getBoundingClientRect().bottom;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newLastElementOffset - lastElementOffset;
                element[0].scrollTop -= scrollAdjustment;
              }

              // TODO Remove the top 100 and load the next 100
              $scope.startIndex += newScrollStep;
              $scope.endIndex += newScrollStep;
              $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
              $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex, quadId:$scope.quadId });
              $scope.loadingData = false;
            }, 0);
          }
        }

        function handleScrollUp(firstElementId) {
          if (($scope.startIndex - $scope.scrollStep >= 0) && !$scope.loadingData) {
            $scope.loadingData = true;

            // TODO Last item currently visible
            $scope.topVisibleObjectIndex = $scope.startIndex;

            var firstVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +firstElementId).get(0);
            if(firstVisibleObjId != null){
              var firstElementOffset = firstVisibleObjId.getBoundingClientRect().top;
            }

            // TODO Remove the bottom 100 and load the previous 100
            $scope.startIndex -= $scope.scrollStep;
            $scope.endIndex -= $scope.scrollStep;
            $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex, quadId:$scope.quadId });
            setTimeout(function () {
              // Adjust scroll position so that the previous top element remains at the same position
              var newFirstVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +firstElementId).get(0);
              if(newFirstVisibleObjId != null){
                var newFirstElementOffset = newFirstVisibleObjId.getBoundingClientRect().top;
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newFirstElementOffset - firstElementOffset;
                element[0].scrollTop += scrollAdjustment;
              }
              $scope.loadingData = false;
            }, 200);

          } else if (($scope.startIndex - $scope.scrollStep < 0) && !$scope.loadingData && $scope.startIndex != 0) {
            // TODO Availabele top data
            $scope.loadingData = true;

            // TODO Last item currently visible
            $scope.topVisibleObjectIndex = $scope.startIndex;

            var firstVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +firstElementId).get(0);
            if(firstVisibleObjId != null){
              var firstElementOffset = firstVisibleObjId.getBoundingClientRect().top;
            }

            // TODO Remove the bottom 100 and load the previous 100
            $scope.startIndex -= $scope.topVisibleObjectIndex;
            $scope.endIndex -= $scope.topVisibleObjectIndex;
            $scope.visibleObjects = $scope.listData.slice($scope.startIndex, $scope.startIndex + $scope.itemsPerPage);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects, st: $scope.startIndex, et: $scope.endIndex, quadId:$scope.quadId });

            setTimeout(function () {
              // Adjust scroll position so that the previous top element remains at the same position
              var newFirstVisibleObjId = $("#scroll-container-" + $scope.quadId + " .rowObj-" + $scope.quadId + '#' +firstElementId).get(0);
              if(newFirstVisibleObjId != null){
                var newFirstElementOffset = newFirstVisibleObjId.getBoundingClientRect().top;
  
                // Calculate the difference in position and adjust the scroll
                var scrollAdjustment = newFirstElementOffset - firstElementOffset;
                element[0].scrollTop += scrollAdjustment;
              }
              $scope.loadingData = false;
            }, 200);
          }
        }
      }
    }
  }
})();
angular.module('hub').directive('draggable', function(){
  return{
    // A = attribute, E = Element, C = Class and M = HTML Comment
    restrict:'A',
    link:function(scope, element, attrs){
      element.draggable({
        grid:[1,1],
        containment:".flGrid",
        revert:false,
        start:function(e, ui){
          if(!element.hasClass("layer")){
            scope.frameDragStart(e, ui, element.attr('data-index'));
          }
        },
        stop:function(e, ui){
          if(!element.hasClass("layer")){
            scope.frameDrag(e, ui, element.attr('data-index'));
          }
        }
      });
    }
  }
});
(function () {
  'use strict';

  angular
    .module('hub')
    .directive('ngDeviceStoreAssignable', ngDeviceStoreAssignable);

  /** @ngInject */
  function ngDeviceStoreAssignable($timeout, $rootScope, $filter) {
    return {
      restrict: 'E',
      scope: {
        assignableListData: '=',
        haveMoreAssignableData: '=',
        cloneAssignableData: '=',
        assignableScrollObj: '=',
        minDeduct: '=',
        pageTab: '=',
        totalCount: '=',
        storeDataList: '='
      },
      link: function ($scope, element, attrs) {
      },
      controller: "DeviceStoreAssignableController",
      templateUrl: 'app/common/dir/tmpl/deviceStoreAssignable.html'
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('hub')
    .directive('ngDeviceAssignable', ngDeviceAssignable);

  /** @ngInject */
  function ngDeviceAssignable($timeout, $rootScope, $filter) {
    return {
      restrict: 'E',
      scope: {
        assignableListData: '=',
        haveMoreAssignableData: '=',
        cloneAssignableData: '=',
        assignableScrollObj: '=',
        minDeduct: '=',
        pageTab: '=',
        totalCount: '=',
        callApi: '=',
        storeDataList: '=',
      },
      link: function ($scope, element, attrs) {
      },
      controller: "DeviceAssignableController",
      templateUrl: 'app/common/dir/tmpl/deviceAssignable.html'
    }
  }
})();
angular.module('hub').directive("contenteditable", function(){
  return {
    require: "ngModel",
    link: function(scope, element, attrs, ngModel) {

      function read() {
        ngModel.$setViewValue(element.html());
      }

      ngModel.$render = function() {
        element.html(ngModel.$viewValue || "");
      };
      
      element.bind("blur mousedown keyup change", function() {
        scope.$apply(read);
      });

    }
  };
});
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('bindHtmlCompile', bindHtmlCompile);

  /** @ngInject */
  /*This directive work instent of ng-bind-html*/
  function bindHtmlCompile($compile){
    return {
      restrict:'A',
      link:function(scope, element, attrs){
        scope.$watch(function(){
          return scope.$eval(attrs.bindHtmlCompile);
        }, function(value){
          element.html(value);
          $compile(element.contents())(scope);
        });
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .directive('alphaNum', alphaNum);

  /** @ngInject */
  /*This directive work instent of ng-bind-html*/
  function alphaNum($compile){
    return {
      require:'ngModel',
      link:function(scope, element, attr, ngModelCtrl){
        function fromUser(text){
          var transformedInput = text.replace(/[^A-Za-z0-9:-]/g, '');
          if(transformedInput !== text){
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
          }
          return transformedInput;  // or return Number(transformedInput)
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    }
  }
})();
angular.module('hub').directive('advancedSearch', function(){
  return {
    restrict:'E',
    scope:{
      advSearchInfo:'='
    },
    controller:"AdvSearchDirController",
    templateUrl:'app/common/dir/tmpl/advancedSearch.html'
  }
});
angular.module('hub').directive('ngActivePeriod', function(){
  return {
    restrict:'E',
    scope:{
      activePeriod:'=', //Two-way data binding
      isDisabled:'='
    },
    link:function(scope, element, attrs){
      scope.$on('saveActivePeriod',function(event, data){
        scope.activePeriodFx('save');
      });
    },
    controller:"ActivePeriodController",
    templateUrl:'app/common/dir/tmpl/activePeriod.html'
  }
});
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SettingsServersController', SettingsServersController);

  /** @ngInject */
  function SettingsServersController($log, $scope, $rootScope, $state, $cookies, $filter, $window, $timeout, ngDialog, $interval, SettingsSrv, ReportsSrv, CommonSrv, DevicesSrv, DeviceControlSrv, FileModelUploadSrv, MySettingsSrv, ContentLibrarySrv, SchedulesSrv){
    $rootScope.saveProcessingServer = false;
    $rootScope.hasDurErr = false;
    $rootScope.durErrType = "";
    $scope.serverSettingsLoading = true;
    $scope.selectedTab = $state.current.name;

    $scope.dmbNewUser = {label:"", email:"", pwd:"", sid:$scope.sid, brand:"", devices:[]};
    $scope.curUrl = $window.location.origin;
    $scope.dmbStoreObj = {store:""};
    $scope.serverListArr = [];
    $scope.serverListDashArr = [];
    $scope.curDSelected = [];
    $scope.theme = {data:""};
    $scope.searchPopup = {text:""};
    $scope.searchDP = {text:""};

    $scope.curDevices = {availableDevices:[], assignedDevices:[]};
    $scope.devices = {info:{totalDevices:0}};
    $rootScope.dAList = [];
    $rootScope.dSList = [];
    $scope.resetCopy = {};
    $scope.cbSettings = {};
    $scope.tempSchIDs = [];
    $scope.selectedIDs = [];
    $scope.scheduleList = [];
    $scope.schCount = 0;
    $scope.searchAS = {text:''};
    
    // TODO server permission error
    $rootScope.hasServerPerErr = false;
    $rootScope.errServerPerType = "";

    MySettingsSrv.getSettings($scope.auth.uid).then(
      function(data){
        $scope.settings = data;
        if($scope.selectedTab == "hub.mySettings.ss"){
          $scope.serverSettingData = $scope.settings.roles;

          angular.forEach($scope.serverSettingData, function(value, key){
            if(value.id == $scope.auth.server){
              $scope.scType = $scope.settings.info.scType;
              $scope.sName = value.label;
              $scope.uType = value.uType;
              $scope.isDmb = value.isDmb;
              $scope.sid = value.id;
            }
          })
          if($scope.uType == 0 || $scope.uType == 1 || $scope.uType == 2){
            $scope.selectTabFx(1);
          } else{
            $scope.selectTabFx(2);
          }
          $rootScope.selectedServerSetting = $scope.sName;
        }
      },
      function(err){
        $log.error(err);
      }
    );

    $rootScope.changeServerCommon = function(sid, sName, uType, scType, isDmb, isDW){
      $scope.scType = scType;
      $scope.sName = sName;
      $scope.uType = uType;
      $scope.isDmb = isDmb;
      $scope.isDW = isDW;
      $scope.sid = sid;
      if($scope.uType == 0 || $scope.uType == 1 || $scope.uType == 2){
        $scope.selectTabFx(1);
      } else{
        $scope.selectTabFx(2);
      }
    }

    $scope.getServerListFx = function(caller){
      /*Widgets List*/
      angular.forEach($scope.server.widgets, function(value, key){
        if(key === "aqi"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.aqi.1"), state:"Widgets", model:"server.widgets.aqi", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "autoLogin"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.al.1"), state:"Widgets", model:"server.widgets.autoLogin", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "count"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.count.1"), state:"Widgets", model:"server.widgets.count", keyName:key, catagary:"Public", checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dateTime"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.dt.1"), state:"Widgets", model:"server.widgets.dateTime", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "excelSheet"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.es.1"), state:"Widgets", model:"server.widgets.excelSheet", keyName:key, catagary:"Public", checkBox:value, tags:"csv, excel, xls, xlsx"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "facebook"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.fb.1"), state:"Widgets", model:"server.widgets.facebook", keyName:key, catagary:"Public", checkBox:value, tags:"social media, meta"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "facebookworkplace"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.fwp.1"), state:"Widgets", model:"server.widgets.facebookworkplace", keyName:key, catagary:"Public", checkBox:value, tags:"meta"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "fsChrome"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.fsc.1"), state:"Widgets", model:"server.widgets.fsChrome", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "gSlide"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.gs.1"), state:"Widgets", model:"server.widgets.gSlide", keyName:key, catagary:"Public", checkBox:value, tags:"google, slide, presentation"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "iFrame"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.iFrame.1"), state:"Widgets", model:"server.widgets.iFrame", keyName:key, catagary:"Public", checkBox:value, tags:"web"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "instagram"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.instagram.1"), state:"Widgets", model:"server.widgets.instagram", keyName:key, catagary:"Public", checkBox:value, tags:"social media, facebook, meta"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "linkedIn"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.in.1"), state:"Widgets", model:"server.widgets.linkedIn", keyName:key, catagary:"Public", checkBox:value, tags:"social media"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "meeting"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.meeting.1"), state:"Widgets", model:"server.widgets.meeting", keyName:key, catagary:"Public", checkBox:value, tags:"calendar,Group by title, events"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "message"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.message.1"), state:"Widgets", model:"server.widgets.message", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "news"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.news.1"), state:"Widgets", model:"server.widgets.news", keyName:key, catagary:"Public", checkBox:value, tags:"bbc, cnn, cbc, espn, bing, fox news, us nuclear, crawling"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "nextVehicle"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.nv.1"), state:"Widgets", model:"server.widgets.nextVehicle", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "onlineRadio"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.or.1"), state:"Widgets", model:"server.widgets.onlineRadio", keyName:key, catagary:"Public", checkBox:value, tags:"onair"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "openHours"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.oh.1"), state:"Widgets", model:"server.widgets.openHours", keyName:key, catagary:"Public", checkBox:value, tags:"work hours"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "progressBar"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.pb.1"), state:"Widgets", model:"server.widgets.progressBar", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "queue"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.queue.1"), state:"Widgets", model:"server.widgets.queue", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "quotes"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.quotes.1s"), state:"Widgets", model:"server.widgets.quotes", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "qrCode"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.qr.1"), state:"Widgets", model:"server.widgets.qrCode", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "rssFeed"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.rss.1"), state:"Widgets", model:"server.widgets.rssFeed", keyName:key, catagary:"Public", checkBox:value, tags:"crawling"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "stockPrice"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.sp.1"), state:"Widgets", model:"server.widgets.stockPrice", keyName:key, catagary:"Public", checkBox:value, tags:"market, trading, share"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "text"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.text.1"), state:"Widgets", model:"server.widgets.text", keyName:key, catagary:"Public", checkBox:value, tags:"crawling"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "traffic"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.traffic.1"), state:"Widgets", model:"server.widgets.traffic", keyName:key, catagary:"Public", checkBox:value, tags:"road, map"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tscCountryMile"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.tsccm.1"), state:"Widgets", model:"server.widgets.tsccm", keyName:key, catagary:"Private", checkBox:value, tags:"tsc, cm, country, mile"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "twitter"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.twitter.1"), state:"Widgets", model:"server.widgets.twitter", keyName:key, catagary:"Public", checkBox:value, tags:"social media"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "vimeo"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.vimeo.1"), state:"Widgets", model:"server.widgets.vimeo", keyName:key, catagary:"Public", checkBox:value, tags:"social medi, video"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "weather"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.weather.1"), state:"Widgets", model:"server.widgets.weather", keyName:key, catagary:"Public", checkBox:value, tags:"forecast"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "webCam"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.wc.1"), state:"Widgets", model:"server.widgets.webCam", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "webPage"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.wp.1"), state:"Widgets", model:"server.widgets.webPage", keyName:key, catagary:"Public", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "youtube"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.youTube.1"), state:"Widgets", model:"server.widgets.youtube", keyName:key, catagary:"Public", checkBox:value, tags:"social media, video"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "prayer"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.prayer.1"), state:"Widgets", model:"server.widgets.prayer", keyName:key, catagary:"Public", checkBox:value, tags:"prayer"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        }
        // Premium
        else if(key === "alertMsg"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.alert.1"), state:"Widgets", model:"server.widgets.alertMsg", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "achievers"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.achievers.1"), state:"Widgets", model:"server.widgets.achievers", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "calendarOfEvents"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.coe.1"), state:"Widgets", model:"server.widgets.calendarOfEvents", keyName:key, catagary:"Premium", checkBox:value, tags:"calendar, events"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ciscoMeraki"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.cisco.1"), state:"Widgets", model:"server.widgets.ciscoMeraki", keyName:key, catagary:"Premium", setting:"server.widgets.ciscoMeraki", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cloudCoverMusic"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.ccm.1"), state:"Widgets", model:"server.widgets.cloudCoverMusic", keyName:key, catagary:"Premium", checkBox:value, tags:"music, third party, 3rd party, Pandora CloudCover"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "contentGroup"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.cg.1"), state:"Widgets", model:"server.widgets.contentGroup", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "contentOnDemand"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.cod.1"), state:"Widgets", model:"server.widgets.contentOnDemand", keyName:key, catagary:"Premium", checkBox:value, tags:"content on demand button, cod button, cod"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "delimitedText"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.dText.1"), state:"Widgets", model:"server.widgets.delimitedText", keyName:key, catagary:"Premium", checkBox:value, tags:"csv, excel, xls, xlsx"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "externalInput"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.ei.1"), state:"Widgets", model:"server.widgets.externalInput", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
          // TODO below code removed start
        // } else if(key === "fifa"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("FIFA World Cup"), state:"Widgets", model:"server.widgets.fifa", keyName:key, catagary:"Premium", checkBox:value, tags:"sports, football"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // TODO below code removed end
        } else if(key === "fillerContent"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.fc.1"), state:"Widgets", model:"server.widgets.fillerContent", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "flightSchedule"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.fs.1"), state:"Widgets", model:"server.widgets.flightSchedule", keyName:key, catagary:"Premium", checkBox:value, tags:"airport, airline"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "gCalendar"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.gc.1"), state:"Widgets", model:"server.widgets.gCalendar", keyName:key, catagary:"Premium", checkBox:value, tags:"google, calendar, events"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "hdSteth"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.steth.1"), state:"Widgets", model:"server.widgets.hdSteth", keyName:key, catagary:"Premium", checkBox:value, tags:"steth, hd"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "liveStreaming"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.ls.1"), state:"Widgets", model:"server.widgets.liveStreaming", keyName:key, catagary:"Premium", checkBox:value, tags:"hls, youtube, live, rtmp, rtsp"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "msTeams"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.msTeams.1"), state:"Widgets", model:"server.widgets.msTeams", keyName:key, catagary:"Premium", checkBox:value, tags:"microsoft, office"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "jukebox"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.mc.1"), state:"Widgets", model:"server.widgets.jukebox", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.jukebox"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
          // TODO below code removed start
        // } else if(key === "iMenu"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.iMenu.1"), state:"Widgets", model:"server.widgets.iMenu", keyName:key, catagary:"Premium", checkBox:value});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // TODO below code removed end
        } else if(key === "iotButton"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.iot.1"), state:"Widgets", model:"server.widgets.iotButton", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.iotButton", tags:"aws"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "outlookCalendar"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.oc.1"), state:"Widgets", model:"server.widgets.outlookCalendar", keyName:key, catagary:"Premium", checkBox:value, tags:"microsoft, calendar, events, office"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "powerBI"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.pBI.1"), state:"Widgets", model:"server.widgets.powerBI", keyName:key, catagary:"Premium", checkBox:value, tags:"microsoft, analytics, Using L Squared's App, Using Customer's App"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "quickSight"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.aqs.1"), state:"Widgets", model:"server.widgets.quickSight", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "scheduleCalendar"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.sc.1"), state:"Widgets", model:"server.widgets.scheduleCalendar", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "slack"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.slack.1"), state:"Widgets", model:"server.widgets.slack", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "survey"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.survey.1"), state:"Widgets", model:"server.widgets.survey", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "storm"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.storm.1"), state:"Widgets", model:"server.widgets.storm", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "firstup"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.sch.1"), state:"Widgets", model:"server.widgets.firstup", keyName:key, catagary:"Premium", checkBox:value, tags:"social chorus, social, firstup, chorus"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "teamsRoom"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.tRoom.1"), state:"Widgets", model:"server.widgets.teamsRoom", keyName:key, catagary:"Premium", checkBox:value, tags:"microsoft, office, rooms"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
          // TODO below code removed start
        // } else if(key === "touchlinkMeetings"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.tl.1"), state:"Widgets", model:"server.widgets.touchlinkMeetings", keyName:key, catagary:"Premium", checkBox:value});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // } else if(key === "trainingMode"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.tm.1"), state:"Widgets", model:"server.widgets.trainingMode", keyName:key, catagary:"Premium", checkBox:value});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // TODO below code removed end
        } else if(key === "webLogin"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.wl.1"), state:"Widgets", model:"server.widgets.webLogin", keyName:key, catagary:"Premium", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "xovis"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.xovis.1"), state:"Widgets", model:"server.widgets.xovis", keyName:key, catagary:"Premium", checkBox:value, tags:"3d camera, cctv, smart camera"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "yammer"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.yammer.1"), state:"Widgets", model:"server.widgets.yammer", keyName:key, catagary:"Premium", checkBox:value, tags:"social media"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "teamsChannel"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.tChannel.1"), state:"Widgets", model:"server.widgets.teamsChannel", keyName:key, catagary:"Premium", checkBox:value, tags:"microsoft, office, channel, Teams channel"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tableau"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.tb.1"), state:"Widgets", model:"server.widgets.tableau", keyName:key, catagary:"Premium", checkBox:value, tags:"Tableau, tableau"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "webex"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.webex.1"), state:"Widgets", model:"server.widgets.webex", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.webex"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "qlik"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.qlik.1"), state:"Widgets", model:"server.widgets.qlik", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.qlik", tags:"qlik"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "grafana"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.grafana.1"), state:"Widgets", model:"server.widgets.grafana", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.grafana", tags:"grafana, cloud"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "verkada"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.verkada.1"), state:"Widgets", model:"server.widgets.verkada", keyName:key, catagary:"Premium", checkBox:value, setting:"server.widgets.verkada", tags:"verkada"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        }
        // Private
        // TODO below code removed start
        // else if(key === "agc"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.agc.1"), state:"Widgets", model:"server.widgets.agc", keyName:key, catagary:"Private", checkBox:value});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // }
        // TODO below code removed end
        else if(key === "f45"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.f45.1"), state:"Widgets", model:"server.widgets.f45", keyName:key, catagary:"Private", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "patientWait"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.pw.1"), state:"Widgets", model:"server.widgets.patientWait", keyName:key, catagary:"Private", checkBox:value, tags:"lifelabs"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "telax"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.telax.1"), state:"Widgets", model:"server.widgets.telax", keyName:key, catagary:"Private", checkBox:value, setting:"server.widgets.telax"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "intelSmartBuilding"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.isb.1"), state:"Widgets", model:"server.widgets.intelSmartBuilding", keyName:key, catagary:"Private", checkBox:value, tags:"intel smart building, floor map, intel" });
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
          // TODO below code removed start
        // } else if(key === "unisys"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.unisys.1"), state:"Widgets", model:"server.widgets.unisys", keyName:key, catagary:"Private", checkBox:value, tags:"disney, cruise"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // } else if(key === "waitQueueMetro"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.wqMetro.1"), state:"Widgets", model:"server.widgets.waitQueueMetro", keyName:key, catagary:"Private", checkBox:value});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        // } else if(key === "webLoginChrome"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.wl.1.1"), state:"Widgets", model:"server.widgets.webLoginChrome", keyName:key, catagary:"Private", checkBox:value, tags:"chrome"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
          // TODO below code removed end
        } else if(key === "intelJciMap"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.jci.1"), state:"Widgets", model:"server.widgets.intelJciMap", keyName:key, catagary:"Private", checkBox:value, setting:"server.widgets.intelJciMap", tags:"floor plan"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "intelCircuitBench"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.inC.1"), state:"Widgets", model:"server.widgets.intelCircuitBench", keyName:key, catagary:"Private", setting:"server.widgets.intelCircuitBench", checkBox:value, tags:"intel circuit bench, intel, circuit, rss, bench"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "comEvent"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.aNet.1"), state:"Widgets", model:"server.widgets.comEvent", keyName:key, catagary:"Private", checkBox:value, tags:"active net, com events, com, events", setting:"server.widgets.comEvents"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "comPylonText"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.pylonText.1"), state:"Widgets", model:"server.widgets.pylonText", keyName:key, catagary:"Private", checkBox:value, tags:"CoM, Pylon, Text"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cloudFarm"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.clFarm.1"), state:"Widgets", model:"server.widgets.cloudFarm", keyName:key, catagary:"Private", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Other List*/
      angular.forEach($scope.server, function(value, key){
        // if(key === "si"){
        //    if(caller == "get"){
        //      $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.27"), state:"Modules", keyName:key , model:"server.si", catagary:"setting", checkBox: value});
        //     } else{
        //       $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //       $scope.server[key]  = $scope.tempObj[0].checkBox;
        //    }
        // } else
        if(key === "emType"){//old key "em"
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("cm.menu.7"), state:"Modules", keyName:key , model:"server.em", catagary:"Emergency", checkBox: value, tags:"IoT Hub,AWS Iot,Circuit Bench,L Squared", setting:"server.cb"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        }
        // else if(key === "iothub"){
        //    if(caller == "get"){
        //      $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.22"), state:"Modules", keyName:key , model:"server.iothub", catagary:"Emergency", checkBox: value});
        //     } else{
        //       $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //       $scope.server[key]  = $scope.tempObj[0].checkBox;
        //    }
        // }
        else if(key === "inven"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("cm.menu.11"), state:"Modules", keyName:key , model:"server.inven", catagary:"inven", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "t"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("cm.menu.2"), state:"Modules", keyName:key , model:"server.t", checkBox: value, tags: "olo"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        // } else if(key === "tolo"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("t.label.30"), state:"Modules", model:"server.tolo", keyName:key, checkBox:value, setting:"server.tolos"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server.widgets[key] = $scope.tempObj[0].checkBox;
        //   }
        } else if(key === "bp"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.21"), state:"Modules", keyName:key , model:"server.bp", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "gbdt"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.23"), state:"Device", keyName:key , model:"server.gbdt", catagary: "Settings", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "dsoi"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.29"), state:"Device", keyName:key , model:"server.dsoi", catagary: "Settings", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        // } else if(key === "dp"){
        //    if(caller == "get"){
        //      $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.37"), state:"Device", keyName:key , model:"server.dp", catagary: "Settings", checkBox: value});
        //     } else{
        //       $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //       $scope.server[key]  = $scope.tempObj[0].checkBox;
        //    }
        } else if(key === "gf"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.2"), state:"Device", keyName:key , model:"server.gf", catagary: "Device", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "mc"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.4"), state:"Device", keyName:key , model:"server.mc", catagary: "Device", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "webos"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.5"), state:"Device", keyName:key , model:"server.webos", catagary: "Device", checkBox: value , setting: "server.webos"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "tizen"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.6"), state:"Device", keyName:key , model:"server.tizen", catagary: "Device", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "vd"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.3"), state:"Device", keyName:key , model:"server.vd", catagary: "Device", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "desktop"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.7"), state:"Device", keyName:key , model:"server.desktop", catagary: "Device", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "epd"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.label.1.8"), state:"Device", keyName:key , model:"server.epd", catagary: "Device", checkBox: value, setting: "server.epd"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "asana"){/*Asana Integration*/
           if(caller == "get"){
              $scope.serverListArr.push({label:$filter("translate")("cm.asn.1"), state:"Other Features", keyName:key , model:"server.asana", catagary:"asana", checkBox: value,  tags:"Asana Publisher, Asana, Publisher"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
            }
        } else if(key === "dmb"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cm.dmb.1"), state:"Other Features", keyName:key , model:"server.dmb", catagary: "Menu Board", checkBox: value, setting: "server.dmb",  tags:"MB, Menu Board, Templates, Channel Selector"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        }
        else if(key === "isCS"){
           if(caller == "get"){
              $scope.serverListArr.push({label:$filter("translate")("cm.dmb.15"), state:"Other Features", keyName:key , model:"server.isCS", checkBox: value, setting: "server.isCS"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "gd"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.p_f.19"), state:"Other Features", keyName:key , model:"server.gd", checkBox: value,  setting: "server.gd"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        } else if(key === "mssp"){
            if(caller == "get"){
              $scope.serverListArr.push({label:$filter("translate")("cl.p_f.14"), state:"Other Features", keyName:key , model:"server.mssp", catagary: "SharePoint Folder", checkBox: value, tags:"sharePoint Folder, Using L Squared's App, Using Customer's App"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
            }
        } else if(key === "msod"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("cl.p_f.15"), state:"Other Features", keyName:key , model:"server.msod", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "csn"){
          if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.41"), state:"Other Features", keyName:key , model:"server.csn", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "ss"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("d.tab.5"), state:"Other Features", keyName:key , model:"server.ss", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "sovr"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("s.p_s.label.21"), state:"Other Features", keyName:key , model:"server.sovr", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "mic"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.19"), state:"Other Features", keyName:key , model:"server.mic", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "hfr"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.18"), state:"Other Features", keyName:key , model:"server.hfr", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "sffl"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.20"), state:"Other Features", keyName:key , model:"server.sffl", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "sf"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.44"), state:"Other Features", keyName:key , model:"server.sf", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "iotcentral"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.25"), state:"Other Features", keyName:key , model:"server.iotcentral", checkBox: value, setting: "server.iotcentral"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "fl"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.3"), state:"Other Features", keyName:key , model:"server.fl", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "odn"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.30"), state:"Other Features", keyName:key , model:"server.odn", checkBox: value, setting: "server.odn"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "log"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.2"), state:"Other Features", keyName:key , model:"server.log", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "m"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.8.2"), state:"Other Features", keyName:key , model:"server.m", catagary:"Maps", checkBox: value, tags: "bing,google"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        }
        else if(key === "strg"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.65"), state:"Other Features", keyName:key , model:"server.strg", catagary:"Content Storage", checkBox: value, tags: "L Squared, Storage, Third Party, Hybrid"});
           } else{
             $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
             $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        }
        else if(key === "mcs"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.24.2"), state:"Other Features", keyName:key , model:"server.mcs", catagary:"Media Conversion", checkBox: value, tags: "Third Party, In house"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        } else if(key === "sp"){
           if(caller == "get"){
             $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.36.1"), state:"Other Features", keyName:key , model:"server.sp", catagary:"Schedule Priority", checkBox: value, tags: "Higher number higher priority, lower number higher priority"});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        } else if(key === "cst"){
           if(caller == "get"){
             $scope.serverListArr.push({label:'Session Timeout', state:"Other Features", keyName:key , model:"server.cst", catagary:"Session Timeout", checkBox: value});
            } else{
              $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
              $scope.server[key]  = $scope.tempObj[0].checkBox;
           }
        // } else if(key === "dsg"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.28"), state:"Other Features", keyName:key, model:"server.dsg", catagary:"Sheet Export Settings", checkBox:value, tags:"By default, group devices by status"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server[key] = $scope.tempObj[0].checkBox;
        //   }
        // } else if(key === "iTime"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.28"), state:"Other Features", keyName:key, model:"server.dsg", catagary:"Sheet Export Settings", checkBox:value, tags:"By default, group devices by status"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server[key] = $scope.tempObj[0].checkBox;
        //   }
        } else if(key === "dtc"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.55"), state:"Other Features", keyName:key, model:"server.dtc", catagary:"Show tags in device list", checkBox:value, tags:"Show tags in device list, device tag color, color, tag, device tag, fill, outline"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "defConDur"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.56"), state:"Other Features", keyName:key , model:"server.defConDur", catagary:"Default Content Duration", checkBox:value});
           } else{
             $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
             $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        }
        else if(key === "cda"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.59"), state:"Other Features", keyName:key, model:"server.cda", checkBox:value, tags:"alert, content, dimension"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "proMonitor"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.61"), state:"Other Features", keyName:key, model:"server.proMonitor", checkBox:value, tags:"pro, active, monitor, pro active monitor", setting: "server.proMonitor"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ai_img"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.60"), state:"Other Features", keyName:key, model:"server.ai_img", checkBox:value, tags:"open, AI, image, generation", setting: "server.ai_img"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key == 'drg'){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.label.24"), state:"Other Features", keyName:key , model:"server.drg", catagary:"Device report generation", checkBox: value, tags: "Old Version, New Version, v1, v2"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        }
        // else if(key === "strg"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.62"), state:"Other Features", keyName:key , model:"server.strg", catagary:"Storage Type", strgVal: value, tags:"storage type",});
        //    } else{
        //      $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //      $scope.server[key]  = $scope.tempObj[0].checkBox;
        //   }
        // }
        else if(key === "acs"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cm.acs.1"), state:"Other Features", keyName:key, model:"server.acs", setting:"server.acs", checkBox:value, tags:"content, safety, Sensitivity"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dvw"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.label.62"), state:"Device", keyName:key , model:"server.dvw", catagary: "Device", checkBox: value});
           } else{
             $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
             $scope.server[key]  = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cau"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.brief.3"), state:"Other Features", keyName:key, model:"server.cau", setting:"server.cau", checkBox:value, tags:"Client auto update"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "vi"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.vi.1"), state:"Other Features", keyName:key, model:"server.vi", catagary: "video indexer", setting:"server.vi", checkBox:value, tags:"Video AI Indexer"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server[key] = $scope.tempObj[0].checkBox;
          }
        } 
        // else if(key === "texl"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("t.label.22"), state:"Other Features", keyName:key, model:"server.dtc", checkBox:value, tags:"excel, template, excel template"});
        //   } else{
        //     $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //     $scope.server[key] = $scope.tempObj[0].checkBox;
        //   }
        // }
        // else if(key === "pbf"){
        //   if(caller == "get"){
        //     $scope.serverListArr.push({label:$filter("translate")("cl.widget.pBI.26"), state:"Other Features", keyName:key , model:"server.pbf", checkBox: value});
        //    } else{
        //      $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
        //      $scope.server[key]  = $scope.tempObj[0].checkBox;
        //   }
        // }
      });

      /*Reports List*/
      angular.forEach($scope.server.reports, function(value, key){
        if(key === "r"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.1"), state:"Modules", keyName:key, model:"server.reports.r", catagary:"Report", checkBox:value, tags:"Proof of play,Offline device, Device health,Status timeline,Device status,Online percentage,Content confirmation,Inventory report,Power on/off history,Settings,report SettingsContent saturation,rs,cs, pp, ds, hg, ir, od,op, dst,poh, hotkey, hot key, hk Hot Key"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cc"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.1.1"), state:"Modules", keyName:key, model:"server.reports.cc", catagary:"Report", checkBox:value, tags:"cc"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cs"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.1.2"), state:"Modules", keyName:key, model:"server.reports.cs", catagary:"Report", checkBox:value, tags:"cs"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "pp"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.1.3"), state:"Modules", keyName:key, model:"server.reports.pp", catagary:"Report", checkBox:value, tags:"pp"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ds"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.1"), state:"Modules", keyName:key, model:"server.reports.ds", catagary:"Report", checkBox:value, tags:"ds"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "hg"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.2"), state:"Modules", keyName:key, model:"server.reports.hg", catagary:"Report", checkBox:value, tags:"hg"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ir"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.5"), state:"Modules", keyName:key, model:"server.reports.ir", catagary:"Report", checkBox:value, tags:"ir"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "od"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.3"), state:"Modules", keyName:key, model:"server.reports.od", catagary:"Report", checkBox:value, tags:"od"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "op"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.4"), state:"Modules", keyName:key, model:"server.reports.op", catagary:"Report", checkBox:value, tags:"op"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dst"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.6"), state:"Modules", keyName:key, model:"server.reports.dst", catagary:"Report", checkBox:value, tags:"dst"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "poh"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.7"), state:"Modules", keyName:key, model:"server.reports.poh", catagary:"Report", checkBox:value, tags:"poh"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "hk"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.2.8"), state:"Modules", keyName:key, model:"server.reports.hk", catagary:"Report", checkBox:value, tags:"hotkey, hot key, hk Hot Key"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ci"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("r.tab.7"), state:"Modules", keyName:key, model:"server.reports.ci", catagary:"Report", checkBox:value, tags:"configuration item, item, configuration"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.reports[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Dashbord List*/
      angular.forEach($scope.server.dashboard, function(value, key){
        if(key === "ccl"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.11"), state:"Dashboard", keyName:key, model:"server.dashboard.ccl", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ccs"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.10"), state:"Dashboard", keyName:key, model:"server.dashboard.ccs", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "c"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.2"), state:"Dashboard", keyName:key, model:"server.dashboard.c", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dp"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("d.btn.11"), state:"Dashboard", keyName:key, model:"server.dashboard.dp", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "d"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.6"), state:"Dashboard", keyName:key, model:"server.dashboard.d", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dom"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.7"), state:"Dashboard", keyName:key, model:"server.dashboard.dom", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dps"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.9"), state:"Dashboard", keyName:key, model:"server.dashboard.dps", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ds"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.1"), state:"Dashboard", keyName:key, model:"server.dashboard.ds", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dts"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.8"), state:"Dashboard", keyName:key, model:"server.dashboard.dts", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dpts"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.18"), state:"Dashboard", keyName:key, model:"server.dashboard.dpts", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dtpl"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.16"), state:"Dashboard", keyName:key, model:"server.dashboard.dtpl", checkBox:value, setting:"server.dashboard.dtpl"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dtps"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.12"), state:"Dashboard", keyName:key, model:"server.dashboard.dtps", checkBox:value, setting:"server.dashboard.dtps"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ot"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.15"), state:"Dashboard", keyName:key, model:"server.dashboard.ot", checkBox:value, setting:"server.dashboard.ot"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ral"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.5"), state:"Dashboard", keyName:key, model:"server.dashboard.ral", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "rad"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.14"), state:"Dashboard", keyName:key, model:"server.dashboard.rad", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "sc"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.3"), state:"Dashboard", keyName:key, model:"server.dashboard.sc", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ssdt"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.13"), state:"Dashboard", keyName:key, model:"server.dashboard.ssdt", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ssodt"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.17"), state:"Dashboard", keyName:key, model:"server.dashboard.ssodt", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ssdpt"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.19"), state:"Dashboard", keyName:key, model:"server.dashboard.ssdpt", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "us"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("ms.label.35.4"), state:"Dashboard", keyName:key, model:"server.dashboard.us", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "wgw"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("db.wgw.2"), state:"Dashboard", keyName:key, model:"server.dashboard.wgw", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "wgws"){
          if(caller == "get"){
            $scope.serverListDashArr.push({label:$filter("translate")("db.wgw.3"), state:"Dashboard", keyName:key, model:"server.dashboard.wgws", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListDashArr, {keyName:key}, true);
            $scope.server.dashboard[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Da List*/
      angular.forEach($scope.server.da, function(value, key){
        if(key === "sir"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.1"), state:"Device", keyName:key, model:"server.da.sir", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "is"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.2"), state:"Device", keyName:key, model:"server.da.is", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "oi"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.3"), state:"Device", keyName:key, model:"server.da.oi", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ti"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.5"), state:"Device", keyName:key, model:"server.da.ti", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dp"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.8"), state:"Device", keyName:key, model:"server.da.dp", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ar"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.6.6"), state:"Device", keyName:key, model:"server.da.ar", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dt"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.9"), state:"Device", keyName:key, model:"server.da.dt", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "du"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.10"), state:"Device", keyName:key, model:"server.da.du", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dw"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.11"), state:"Device", keyName:key, model:"server.da.dw", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ed"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("d.tab.12"), state:"Device", keyName:key, model:"server.da.ed", catagary:"Device Actions", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.da[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*TPU List*/
      angular.forEach($scope.server.tpu, function(value, key){
        if(key === "db"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.p_c.10"), state:"Other Features", keyName:key, model:"server.tpu.db", catagary:"Third-Party", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ftp"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.p_c.12"), state:"Other Features", keyName:key, model:"server.tpu.ftp", catagary:"Third-Party", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "gd"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.p_c.11"), state:"Other Features", keyName:key, model:"server.tpu.gd", catagary:"Third-Party", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {catagary:"Third-Party", keyName:key}, true);
            // $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ig"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.instagram.1"), state:"Other Features", keyName:key, model:"server.tpu.ig", catagary:"Third-Party", checkBox:value});
          } else{ 
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tw"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.twitter.1"), state:"Other Features", keyName:key, model:"server.tpu.tw", catagary:"Third-Party", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "url"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cl.widget.cm.10"), state:"Other Features", keyName:key, model:"server.tpu.url", catagary:"Third-Party", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.tpu[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Device Grouping*/
      angular.forEach($scope.server.dgrp, function(value, key){
        if(key === "dgrp"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("cm.tool.11"), state:"Device", keyName:key , model:"server.dgrp.dgrp", catagary:"Settings", checkBox:value, tags:"device group, device folder, folder"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.dgrp[key]  = $scope.tempObj[0].checkBox;
         }
        }
      });
      /*SSO List*/
      angular.forEach($scope.server.sso, function(value, key){
        if(key === "sso"){
          if(caller == "get"){
            $scope.serverListArr.push({label:"SSO", state:"Other Features", keyName:key, model:"server.sso.sso", catagary:"SSO", checkBox:value, tags:"microsoft Azure, okta,idaptive,saml"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.sso[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Subdomain List*/
      angular.forEach($scope.server.subdomain, function(value, key){
        if(key === "isActive"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.35"), state:"Other Features", keyName:key, model:"server.subdomain.isActive", catagary:"domain", checkBox:value, setting:"server.subdomain.isActive"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.subdomain[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*Log List*/
      angular.forEach($scope.server.logSE, function(value, key){
        if(key === "checked"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.7"), state:"Other Features", keyName:key, model:"server.logSE.checked", catagary:"logSE", checkBox:value});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.logSE[key] = $scope.tempObj[0].checkBox;
          }
        }
      });
      /*BPA List*/
      angular.forEach($scope.server.bpa, function(value, key){
        if(key === "isActive"){
          if(caller == "get"){
            $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.33"), state:"Other Features", keyName:key, model:"server.bpa.isActive", catagary:"bigPanda", checkBox:value, setting:"server.bpa.isActive"});
          } else{
            $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
            $scope.server.bpa[key] = $scope.tempObj[1].checkBox;
          }
        }
      });
      /*Hub-spot Ticket*/
      // angular.forEach($scope.server.hs, function(value, key){
      //   if(key === "isActive"){
      //     if(caller == "get"){
      //       $scope.serverListArr.push({label:$filter("translate")("ms.p_s.serverPer.50"), state:"Other Features", keyName:key, model:"server.hs.isActive", catagary:"hubSpot", checkBox:value, setting:"server.hs.isActive"});
      //     } else{
      //       $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
      //       $scope.server.hs[key] = $scope.tempObj[2].checkBox;
      //     }
      //   }
      // });
      
      /*Video Indexer*/
      // angular.forEach($scope.server.viIndexer, function(value, key){
      //   if(key === "vi"){
      //     if(caller == "get"){
      //       $scope.serverListArr.push({label:$filter("translate")("cl.vi.1"), state:"Other Features", keyName:key, model:"server.viIndexer.vi", catagary:"video indexer", checkBox:value, setting:"server.viIndexer.vi", tags:"Video AI Indexer"});
      //     } else{
      //       $scope.tempObj = $filter("filter")($scope.serverListArr, {keyName:key}, true);
      //       $scope.server.subdomain[key] = $scope.tempObj[0].checkBox;
      //     }
      //   }
      // });
    }

    /*encrypt & decrypt start*/
    $scope.keysToProcess = [
      'asanaS.pci',
      'asanaS.pcs',
      'asanaS.uci',
      'asanaS.ucs',
      'bpa.token',
      'bpa.key',
      'hs.token',
      'toloS.oloKey',
      'epdS.c',
      'epdS.p',
      'epdS.s',
      'epdS.u',
      'gdS.gdOtApp.client_id',
      'gdS.gdOtApp.client_secret',
      'gdS.gdspApp.jobj.client_id',
      'gdS.gdspApp.jobj.client_secret',
      'gdS.gdspApp.jobj.client_email',
      'gdS.gdspApp.jobj.private_key_id',
      'gdS.gdspApp.jobj.project_id',
      'msspS.c',
      'msspS.s',
      'msspS.t',
      'dashboard.otc',
      'widgets.achieversS.clientId',
      'widgets.achieversS.clientSecret',
      'widgets.ciscoMerakiS.accKey',
      'widgets.ciscoMerakiS.orgId',
      'widgets.comEventS.apiKey',
      'widgets.firstupS.clientId',
      'widgets.firstupS.clientSecret',
      'widgets.firstupS.token',
      'widgets.grafanaS.token',
      'widgets.intelCircuitBenchS.clientId',
      'widgets.intelCircuitBenchS.clientSecret',
      'widgets.intelJciMapS.pass',
      'widgets.intelJciMapS.rtoken',
      'widgets.intelJciMapS.user',
      'widgets.iotButtonS.IoT1ClickAccKey',
      'widgets.iotButtonS.IoT1ClickSecKey',
      'widgets.iotButtonS.dvcCert',
      'widgets.iotButtonS.rootCACert',
      'widgets.powerBIS.c',
      'widgets.powerBIS.s',
      'widgets.powerBIS.t',
      'widgets.qlikS.c',
      'widgets.qlikS.i',
      'widgets.qlikS.k',
      'widgets.qlikS.s',
      'widgets.qlikS.t',
      'widgets.qlikS.w',
      'widgets.quickSightS.aid',
      'widgets.quickSightS.ak',
      'widgets.quickSightS.reg',
      'widgets.quickSightS.sk',
      'widgets.quickSightS.unm',
      'widgets.tableauS.clientId',
      'widgets.tableauS.secretId',
      'widgets.tableauS.secretValue',
      'widgets.webexS.clientId',
      'widgets.webexS.clientSecret',
      'widgets.verkadaS.org_id',
      'widgets.verkadaS.api_key'
    ];
    /*encrypt & decrypt end*/

    $scope.selectTabFx = function(caller){
      $rootScope.settingLoadingServer = true;
      $rootScope.hasDurErr = false;
      $rootScope.durErrType = "";
      $rootScope.settingLoadingServer = true;
      $scope.serverSettingsLoading = false;
      $rootScope.selectTab = caller;
      $scope.hasErr = false;
      $scope.hasErrPop = false;
      $scope.searchServer.text = "";
      $scope.searchDP.text = '';
      if(!angular.isUndefined($scope.isDW)){
        $scope.auth.upermissions.dw = $scope.isDW;
      }
      if(caller == 1){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.primeObj = {};
        SettingsSrv.primeAdmin($scope.sid).then(
          function(data){
            $scope.primeObj = data;
            if($scope.primeObj.info){
              $scope.tim = $scope.primeObj.info.timthumb;
              $scope.bucket = $scope.detailBucket = $scope.primeObj.info.bucket;
              if($scope.primeObj.info.mbucket && $scope.primeObj.info.mbucket != ""){
                $scope.detailBucket = $scope.primeObj.info.mbucket;
              }
            }
            $rootScope.settingLoadingServer = false;
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 2){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.isPEOpen = false;
        $rootScope.hasErrPop = false;
        $rootScope.errTypePop = "";
        $scope.schExpNotifyIds = "";
        SettingsSrv.getNotifications($scope.sid).then(
          function(data){
            $scope.notifications = data;
            $scope.schExpNotifyIds = data.schexpnotifyids;
            if($scope.schExpNotifyIds == null || $scope.schExpNotifyIds == 0 || $scope.schExpNotifyIds.length == 0){
              $scope.spSchedule = {type:"a"};
              $scope.schExpNotifyIds = [];
              $scope.selectedIDs = [];
            } else {
              $scope.spSchedule = {type:"s"};
              $scope.selectedIDs = $scope.schExpNotifyIds == 0 ? [] : angular.copy($scope.schExpNotifyIds);
            }
            $rootScope.settingLoadingServer = false;
            if($scope.notifications.offline.startTime && $scope.notifications.offline.endTime){
              $scope.offline = {startTime:$filter("momentTime")($scope.notifications.offline.startTime), endTime:$filter("momentTime")($scope.notifications.offline.endTime), timeout:$scope.notifications.offline.timeout, isExcluded:$scope.notifications.offline.isExcluded, threshold:$scope.notifications.offline.threshold};
            } else{
              $scope.offline = {startTime:moment().format(), endTime:moment().add(5, "m").format(), timeout:$scope.notifications.offline.timeout, isExcluded:$scope.notifications.offline.isExcluded, threshold:$scope.notifications.offline.threshold};
            }

            for(var i = 0;i < $scope.notifications.email.length;i++){}

            $scope.emailArr = [];
            angular.forEach($scope.notifications.email, function(item, index){
              if(item.id == 16){
                $scope.emailArr.push({id:16.1, value:false});
              }
              if(item.id == 19){
                $scope.emailArr.push({id:19.1, value:false});
              }
              if(item.id == 24){
                $scope.emailArr.push({id:24.1, value:false});
              }
              $scope.emailArr.push(item);
            });
            $scope.notifications.email = $scope.emailArr;
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 3){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        SettingsSrv.getPollingFrequency($scope.sid).then(
          function(data){
            $rootScope.settingLoadingServer = false;
            $scope.polling = data;
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 4){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        ReportsSrv.getAdapters($scope.sid).then(
          function(data){
            $rootScope.settingLoadingServer = false;
            if(data.code == 18003){
              $scope.adapters = "";
            } else{
              $scope.adapters = data;
            }
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 5){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        SettingsSrv.getDefaultClientImage($scope.sid).then(
          function(data){
            $scope.defaultImg = data;
            $scope.bucket = $scope.detailBucket = $scope.defaultImg.info.bucket;
            if($scope.defaultImg.info.mbucket && $scope.defaultImg.info.mbucket != ""){
              $scope.detailBucket = $scope.defaultImg.info.mbucket;
            }
            $rootScope.settingLoadingServer = false;
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 6){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        SettingsSrv.getAvailableExtension($scope.sid).then(
          function(data){
            $rootScope.settingLoadingServer = false;
            $scope.allowedFiles = data;
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 7){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.searchText = "";
        SettingsSrv.getPermissions($scope.sid).then(
          function(data){
            $rootScope.settingLoadingServer = false;
            // $scope.server = data;

            /*encrypt & decrypt start*/
            $scope.server = $scope.endeDataFx("d", angular.copy(data), $scope.keysToProcess);
            if($scope.server.gdS && $scope.server.gdS.gdspApp && $scope.server.gdS.gdspApp.jobj && $scope.server.gdS.gdspApp.jobj.private_key){
              $scope.server.gdS.gdspApp.jobj.private_key = $scope.decryptChunksFx($scope.server.gdS.gdspApp.jobj.private_key);
            }

            if($scope.server.emType == ""){
              $scope.em = {isCheck: false, type:"ls"};
            } else {
              $scope.em = {isCheck: true, type:$scope.server.emType};
            }
            if($scope.server.vi){
              $scope.getAuthUrlIndexer($scope.server.vi);
            }
            $scope.serverCopy = angular.copy($scope.server);
            $scope.getServerListFx("get");
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
          }
        );
      } else if(caller == 8){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.popupLoading = true;
        $scope.curDSelected = [];
        $scope.hasErrPop = false;
        $scope.errTypePop = "";

        SettingsSrv.getDMBSettings($scope.sid).then(
          function(data){
            $scope.dmbNewUser = {sid:$scope.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
            $scope.dmbSettings = data;
            SettingsSrv.DMBDevice($scope.sid).then(
              function(data){
                $scope.popupLoading = false;
                $rootScope.settingLoadingServer = false;
                $scope.devices = data;
              },
              function(err){
                $log.error(err);
              }
            );
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      } else if(caller == 9){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.hasErrPop = false;
        $scope.errTypePop = "";

        $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", creationRange:false, time:moment().format(), creationTime:false};
        SettingsSrv.getDP($scope.sid).then(
          function(data){
            $rootScope.settingLoadingServer = false;
            $scope.dpObj = data;
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      } else if(caller == 10){
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.hasErrPop = false;
        $scope.errTypePop = "";
      } else if(caller == 11){
        $scope.minDate = moment().subtract(0, "day").format('YYYY-MM-DD');
        $scope.dupInfo = {type:"d", devices:{device:[]}};
        $scope.colorPicker = {b:false};
        $scope.serverListArr.length = 0;
        $scope.serverListDashArr.length = 0;
        $scope.serverSettingsLoading = true;
        MySettingsSrv.getDeviceWatermark($scope.sid).then(
          function(data){
            $scope.dWMObj = data.s;
            $scope.dWMObj.d = data.d;
            DevicesSrv.getDownupDGT($scope.sid).then(
              function(data){
                $scope.serverSettingsLoading = false;
                $rootScope.settingLoadingServer = false;
                $scope.devices.list = data;
                if($scope.dWMObj.d.length){

                  $scope.availDevices = $scope.devices.list.devices.filter(function(device){
                    return !$scope.dWMObj.d.some(function(id){
                      return device.id === id;
                    });
                  });

                  $scope.selDevices = $scope.devices.list.devices.filter(function(device){
                    return $scope.dWMObj.d.some(function(id){
                      return device.id === id;
                    });
                  });
                  $scope.devices.list.devices = $scope.availDevices;
                  $scope.dupInfo.devices.device = $scope.selDevices;
                }
              },
              function(err){
                $scope.serverSettingsLoading = false;
                $rootScope.settingLoadingServer = false;
                $log.error(err);
              }
            );
          },
          function(err){
            $log.error(err);
            $rootScope.settingLoadingServer = false;
            $scope.serverSettingsLoading = false;
          }
        );
      } else if(caller == 13){/*R&G Reports*/
        $scope.rgSDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.rgEDate = moment().subtract(1, "day").format('YYYY-MM-DD');
        $scope.rgProcessing = false;
        $scope.rgSelectedTab = 1;
        $scope.rgHasErr = false;
        $scope.rgErrType = "";
        $scope.rgObj = {rType:"l",
          dateRange:{startDate:$scope.rgSDate, endDate:$scope.rgEDate}
        };
      }
    }

    $scope.sortCallback = function(caller){
      if(caller == "dp"){
        $scope.dpObj.properties = [];
        angular.forEach(angular.element(".sortable-item"), function(item){
          $scope.dpObj.properties.push({id:$(item).attr("data-id"), label:$(item).find(".dpLabel").text(), value:$(item).find(".dpValue").text(), desc:$(item).find(".dpDesc").text(), vType:$(item).attr("data-type")});
        });
      } else if(caller == "as"){
        $scope.asObj.switches = [];
        angular.forEach(angular.element(".sortable-item"), function(item){
          $scope.asObj.switches.push({id:$(item).attr("data-id"), label:$(item).find(".asLabel").text(), value:$(item).find(".asValue").text(), desc:$(item).find(".asDesc").text()});
        });
      }
    }

    // $scope.assignFx = function(){
    //   if($scope.curDPObj.creationRange){
    //     console.warn($scope.curDPObj);
    //   }
    // }
    $scope.dpSaveFx = function(caller){
      $scope.searchDP.text = '';
      $scope.dpObj.sid = $scope.sid;
      if(caller){
        $scope.dpSProcessing = true;
      } else{
        $scope.dpCProcessing = true;
      }
      SettingsSrv.saveSortDP($scope.dpObj).then(
        function(data){
          $scope.dpSProcessing = false;
          $scope.dpCProcessing = false;
          $scope.dpObj.properties = [];
          $scope.dpObj.properties = data.properties;
          $rootScope.toastNotificationFx("danger", {"code":5000});
        },
        function(err){
          $scope.dpSProcessing = false;
          $log.error(err);
        }
      );
    }

    // $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", time:moment().format()};
    $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", creationRange:false, time:moment().format(), creationTime:false};
    $scope.dpAddFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      var haveOneDT = false;

      if(!$scope.curDPObj.label){
        $scope.errTypePop = "label";
        $scope.hasErrPop = true;
        $("#curDPObjL").focus();
      } else{
        $scope.dpProcessing = true;
        $scope.curDPObj.sid = $scope.sid;

        if($scope.curDPObj.vType == 'd' || $scope.curDPObj.vType == 'dt'){
          $scope.curDPObj.dateRange = {startDate:moment($scope.curDPObj.dateRange.startDate).format('MM/DD/YYYY'), endDate:moment($scope.curDPObj.dateRange.endDate).format('MM/DD/YYYY')}
          if($scope.curDPObj.vType == 'd'){
            if($scope.curDPObj.creationRange){
              $scope.curDPObj.value = $scope.curDPObj.dateRange.startDate;
            } else{
              $scope.curDPObj.value = null;
            }
          } else {
            if($scope.curDPObj.creationRange && $scope.curDPObj.creationTime && $scope.curDPObj.time){
              $scope.curDPObj.value = $scope.curDPObj.dateRange.startDate + " " + moment($scope.curDPObj.time).format("MM/DD/YYYY HH:mm:ss").split(" ")[1];
            } else if(!$scope.curDPObj.creationRange && (!$scope.curDPObj.creationTime ||  !$scope.curDPObj.time)){
              $scope.curDPObj.value = null;
            } else{
              haveOneDT = true;
            }
          }
        }
        if($scope.curDPObj.vType == 'ti'){
          if($scope.curDPObj.creationTime && $scope.curDPObj.time){
            $scope.curDPObj.value = moment($scope.curDPObj.time).format("HH:mm:ss");
          } else{
            $scope.curDPObj.value = null;
          }
          // $scope.curDPObj.value = $scope.curDPObj.time;
        }

        if($scope.curDPObj.vType == 'dt' && haveOneDT){
          $scope.dpProcessing = false;
          $scope.errTypePop = "haveOne";
          $scope.hasErrPop = true;
        } else{
          SettingsSrv.saveDP($scope.curDPObj).then(
            function(data){
              $scope.searchDP.text = '';
              $scope.dpProcessing = false;
              if(data.code == 17076){
                $scope.errTypePop = "same";
                $scope.hasErrPop = true;
                $("#curDPObjL").focus();
              } else if(data.code == 17073){
                $scope.dpObj.properties.push({id:data.id, label:$scope.curDPObj.label, value:$scope.curDPObj.value});
                // $scope.curDPObj = {label:"", value:""};
                // $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", time:moment().format()};
                $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", creationRange:false, time:moment().format(), creationTime:false};
              } else if(data.code == 17074){
                for(var i = 0;i < $scope.dpObj.properties.length;i++){
                  if($scope.dpObj.properties[i].id == $scope.curDPObj.id){
                    $scope.dpObj.properties[i] = $scope.curDPObj;
                  }
                }
                // $scope.curDPObj = {label:"", value:""};
                // $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", time:moment().format()};
                $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", creationRange:false, time:moment().format(), creationTime:false};
              } else if(data.code == 12095){
                $scope.curData = data;
                ngDialog.open({
                  template:'\
                    <section class="panel" role="dialog">\
                      <div class="panel-body">\
                        <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m15" | translate}}</span></div>\
                        <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                          <div class="row alt-row-bg padLR10">\
                            <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                              <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                            </div>\
                          </div>\
                        </div>\
                      </div>\
                      <div class="panel-footer">\
                        <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                      </div>\
                    </section>',
                  plain:true,
                  width:500,
                  scope:$scope,
                  data:$scope.curData,
                  closeByDocument:false,
                  className:"ngdialog-theme-default ngdialog-confirm"
                });
              }
              if(data.code != 17076){
                $scope.dpDataLoading = true;
                SettingsSrv.getDP($scope.sid).then(
                  function(data){
                    $scope.dpDataLoading = false;
                    $scope.dpObj = data;
                  },
                  function(err){
                    $scope.dpDataLoading = false;
                    $log.error(err);
                  }
                );
              }
            },
            function(err){
              $scope.dpProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }

    $scope.dpEditFx = function(obj){
      // if(!obj.vType){
      //   obj.vType = "t";
      //   obj.time = moment().format();
      // }

      $scope.curDPObj = angular.copy(obj);

      $scope.curDPObj.creationRange = false;
      $scope.curDPObj.creationTime = false;
      if(obj.vType == "t"){
        $scope.curDPObj.creationRange = false;
        $scope.curDPObj.creationTime = false;
      } else if(obj.vType == "d" && obj.value){
        $scope.curDPObj.creationRange = true;
        $scope.curDPObj.creationTime = false;
      } else if(obj.vType == "dt" && obj.value){
        $scope.curDPObj.creationRange = true;
        $scope.curDPObj.creationTime = true;
      } else if(obj.vType == "ti" && obj.value){
        $scope.curDPObj.creationRange = false;
        $scope.curDPObj.creationTime = true;
      }

      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.dpDeleteOpen = function(id){
      $scope.hasErrPopDP = false;
      $scope.errType = "";
      $scope.dpDObj = {id:id, processing:false, pass:""};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
            <div class="panel-body">\
              <div>{{"ms.p_s.dp.m4" | translate}}</div>\
              <div class="form-group marT15">\
                <label for="dpDObjPass">{{\'cl.widget.telax.9.3\' | translate}}</label>\
                <input type="password" id="dpDObjPass" autocomplete="new-password" class="form-control" ng-model="dpDObj.pass" aria-label="{{\'cl.widget.telax.9.3\' | translate}}" aria-labelledby="{{\'cl.widget.telax.9.3\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="dpDeleteFx();" focus-me="true" ng-disabled="dpDObj.processing"><span class="fa fa-repeat fa-spin" ng-if="dpDObj.processing" aria-hidden="true"></span>{{"ms.p_s.dp.4" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right" ng-if="hasErrPopDP" aria-live="polite" role="status">\
                <span ng-if="errType==\'emptyPass\'" aria-live="polite" role="status">{{\'lock.m1\' | translate}}</span>\
                <span ng-if="errType==\'invPass\'" aria-live="polite" role="status">{{\'cl.widget.oc.m10\' | translate}}</span>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.dpDeleteFx = function(){
      $scope.hasErrPopDP = false;
      $scope.errType = "";
      if($scope.dpDObj.pass == ""){
        $scope.hasErrPopDP = true;
        $scope.errType = "emptyPass";
        $("#dpDObjPass").focus();
      } else{
        $scope.dpDObj.processing = true;
        // $scope.passEnc = $scope.hubEnc($scope.auth.email, $scope.dpDObj.pass);
        // SettingsSrv.deleteDP($scope.sid, $scope.dpDObj.id, $scope.passEnc).then(

        SettingsSrv.deleteDP({sid:$scope.sid, id:$scope.dpDObj.id, pass:$scope.encryptFx($scope.dpDObj.pass)}).then(
          function(data){
            $scope.dpDObj.processing = false;
            if(data.code == 17097){
              $scope.hasErrPopDP = true;
              $scope.errType = "invPass";
              $("#dpDObjPass").focus();
            } else if(data.code == 17075){
              for(var i = 0;i < $scope.dpObj.properties.length;i++){
                if($scope.dpObj.properties[i].id == $scope.dpDObj.id){
                  $scope.dpObj.properties.splice(i, 1);
                }
              }
              $scope.searchDP.text = "";
              $scope.dpResetFx();
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $scope.dpDObj.processing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.dpResetFx = function(){
      // $scope.curDPObj = {label:"", value:""};
      // $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", time:moment().format()};
      $scope.curDPObj = {label:"", value:"", desc:"", vType:"t", creationRange:false, time:moment().format(), creationTime:false};
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.hubEnc = function(email, pass){
      $scope.emailPass = email + "|" + pass;
      return btoa($scope.reverse($scope.emailPass));
    }

    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.dialogId = $dialog.attr('id');
    });


    $scope.deviceProFx = function(caller, val){
      $scope.callerCopyReport = {caller:caller, val:val}
    }
    $scope.reportsFx = function(caller, val){
      if(caller == "rs" && !$scope.server.reports.rs && $scope.serverCopy.reports.rs){
        $scope.subscriptionConfirm(caller);
      }

      if(caller == "r"){
        if($scope.server.reports.rs && !val && $scope.serverCopy.reports.rs){
          $scope.subscriptionConfirm(caller);
        } else{
          angular.forEach($scope.serverListArr, function(item){
            if(item.catagary == "Report"){
              if(item.keyName == "r"){
                item.checkBox = val;
                $scope.server.reports.r = val;
              } else if(item.keyName == "pp"){
                item.checkBox = val;
                $scope.server.reports.pp = val;
              } else if(item.keyName == "ds"){
                item.checkBox = val;
                $scope.server.reports.ds = val;
              } else if(item.keyName == "cs"){
                item.checkBox = val;
                $scope.server.reports.cs = val;
              } else if(item.keyName == "op"){
                item.checkBox = val;
                $scope.server.reports.op = val;
              } else if(item.keyName == "od"){
                item.checkBox = val;
                $scope.server.reports.od = val;
              } else if(item.keyName == "cc"){
                item.checkBox = val;
                $scope.server.reports.cc = val;
              } else if(item.keyName == "ir"){
                item.checkBox = val;
                $scope.server.reports.ir = val;
              } else if(item.keyName == "hg"){
                item.checkBox = val;
                $scope.server.reports.hg = val;
              } else if(item.keyName == "dst"){
                item.checkBox = val;
                $scope.server.reports.dst = val;
              } else if(item.keyName == "poh"){
                item.checkBox = val;
                $scope.server.reports.poh = val;
              } else if(item.keyName == "hk"){
                item.checkBox = val;
                $scope.server.reports.hk = val;
              } else if(item.keyName == "ci"){
                item.checkBox = val;
                $scope.server.reports.ci = val;
              }
            }
          });
        }
      }
      if(caller != "r"){
        angular.forEach($scope.serverListArr, function(item){
          if(item.catagary == "Report"){
            if(item.keyName == "r"){
              $scope.server.reports.r = item.checkBox;
            } else if(item.keyName == "pp"){
              $scope.server.reports.pp = item.checkBox;
            } else if(item.keyName == "ds"){
              $scope.server.reports.ds = item.checkBox;
            } else if(item.keyName == "cs"){
              $scope.server.reports.cs = item.checkBox;
            } else if(item.keyName == "op"){
              $scope.server.reports.op = item.checkBox;
            } else if(item.keyName == "od"){
              $scope.server.reports.od = item.checkBox;
            } else if(item.keyName == "cc"){
              $scope.server.reports.cc = item.checkBox;
            } else if(item.keyName == "ir"){
              $scope.server.reports.ir = item.checkBox;
            } else if(item.keyName == "hg"){
              $scope.server.reports.hg = item.checkBox;
            } else if(item.keyName == "dst"){
              $scope.server.reports.dst = item.checkBox;
            } else if(item.keyName == "poh"){
              $scope.server.reports.poh = item.checkBox;
            } else if(item.keyName == "hk"){
              $scope.server.reports.hk = item.checkBox;
            } else if(item.keyName == "ci"){
              $scope.server.reports.ci = item.checkBox;
            }
          }
        });
        if(!$scope.server.reports.pp && !$scope.server.reports.ds && !$scope.server.reports.cs && !$scope.server.reports.op && !$scope.server.reports.od && !$scope.server.reports.cc && !$scope.server.reports.ir && !$scope.server.reports.dst && !$scope.server.reports.poh && !$scope.server.reports.hg && !$scope.server.reports.hk && !$scope.server.reports.ci){
          if($scope.serverCopy.reports.rs){
            $scope.subscriptionConfirm(caller);
          } else{
            $scope.server.reports.r = false;
            angular.forEach($scope.serverListArr, function(item){
              if(item.catagary == "Report"){
                if(item.keyName == "r"){
                  item.checkBox = false;
                }
              }
            });
          }
        }
      }
    }

    $scope.subCallbackFx = function(){
      if($scope.subCaller == "rs"){
        $scope.server.reports.rs = false;
      } else{
        angular.forEach($scope.serverListArr, function(item){
          if(item.catagary == "Report"){
            if($scope.subCaller !== "rs" && item.keyName == "r"){
              item.checkBox = false;
            } else{
              item.checkBox = false;
            }
          }
        });
        $scope.server.reports.r = false;
        $scope.server.reports.pp = false;
        $scope.server.reports.ds = false;
        $scope.server.reports.cs = false;
        $scope.server.reports.op = false;
        $scope.server.reports.od = false;
        $scope.server.reports.cc = false;
        $scope.server.reports.ir = false;
        $scope.server.reports.hg = false;
        $scope.server.reports.dst = false;
        $scope.server.reports.poh = false;
        $scope.server.reports.rs = false;
        $scope.server.reports.hk = false;
        $scope.server.reports.ci = false;
      }
      ngDialog.close($scope.dialogId);
    }

    $scope.subUncheckFx = function(){
      angular.forEach($scope.serverListArr, function(item){
        if(item.catagary == "Report"){
          if($scope.subCaller == "r" && item.keyName == "r"){
            item.checkBox = true;
            $scope.server.reports.r = true;
          } else if($scope.subCaller == "pp" && item.keyName == "pp"){
            item.checkBox = true;
            $scope.server.reports.pp = true;
          } else if($scope.subCaller == "ds" && item.keyName == "ds"){
            item.checkBox = true;
            $scope.server.reports.ds = true;
          } else if($scope.subCaller == "cs" && item.keyName == "cs"){
            item.checkBox = true;
            $scope.server.reports.cs = true;
          } else if($scope.subCaller == "op" && item.keyName == "op"){
            item.checkBox = true;
            $scope.server.reports.op = true;
          } else if($scope.subCaller == "od" && item.keyName == "od"){
            item.checkBox = true;
            $scope.server.reports.od = true;
          } else if($scope.subCaller == "cc" && item.keyName == "cc"){
            item.checkBox = true;
            $scope.server.reports.cc = true;
          } else if($scope.subCaller == "ir" && item.keyName == "ir"){
            item.checkBox = true;
            $scope.server.reports.ir = true;
          } else if($scope.subCaller == "hg" && item.keyName == "hg"){
            item.checkBox = true;
            $scope.server.reports.hg = true;
          } else if($scope.subCaller == "dst" && item.keyName == "dst"){
            item.checkBox = true;
            $scope.server.reports.dst = true;
          } else if($scope.subCaller == "poh" && item.keyName == "poh"){
            item.checkBox = true;
            $scope.server.reports.poh = true;
          } else if($scope.subCaller == "rs"){
            $scope.server.reports.rs = true;
          } else if($scope.subCaller == "hk" && item.keyName == "hk"){
            item.checkBox = true;
            $scope.server.reports.hk = true;
          } else if($scope.subCaller == "ci"){
            item.checkBox = true;
            $scope.server.reports.ci = true;
          }
        }
      });
      ngDialog.close($scope.dialogId);
    }

    $scope.subscriptionConfirm = function(caller){
      $scope.subCaller = caller;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{subCaller=="rs"?"cm.msg.41.1":"cm.msg.41" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="subCallbackFx();" focus-me="true">{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="subUncheckFx();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.uploadFileCount = 0;
    $rootScope.fileModelUploadFx = function(file, res){
      var reader = new FileReader();
      reader.onload = function(e){
        $("#" + res).parents(".diThumbQuad").addClass("show");
        $("#" + res).siblings(".diUploadedThumb").addClass("hide");
        document.getElementById(res).src = e.target.result;
        if(res == "default"){
          $scope.defaultImg.default.uploading = true;
        } else{
          angular.forEach($scope.defaultImg.resolutions, function(item){
            if(item.res == res){
              item.uploading = true;
            }
          });
        }
      }
      reader.readAsDataURL(file);

      if(res == "default"){
        $scope.defaultImg.default = {label:file.name, curImg:true, uploading:true}
      } else{
        angular.forEach($scope.defaultImg.resolutions, function(item){
          if(item.res == res){
            item.label = file.name;
            item.curImg = true;
            item.uploading = true;
          }
        });
      }

      $scope.uploadFileCount++;
      FileModelUploadSrv.uploadFileAndData("mySettings/defaultClientImage", {sid:$scope.sid, res:res}, file).then(
        function(data){
          $scope.uploadFileCount--;
          if(res == "default"){
            $scope.defaultImg.default.uploading = false;
          } else{
            angular.forEach($scope.defaultImg.resolutions, function(item){
              if(item.res == res){
                item.uploading = false;
              }
            });
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.deleteConfirmFx = function(res){
      $scope.resObj = res;
      $scope.deleteProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"ms.p_s.defaultImg.m2" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="deleteThumbFx(resObj);"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deleteThumbFx = function(res){
      $scope.deleteProcessing = true;
      FileModelUploadSrv.uploadFileAndData("mySettings/defaultClientImage", {sid:$scope.sid, res:res}).then(
        function(data){
          $("#" + res).parents(".diThumbQuad").removeClass("show").addClass("hide");
          if(res == "default"){
            $scope.defaultImg.default = {label:null, thumb:null, curImg:false, uploading:false};
            $("#fileDefault").val('');
          } else{
            angular.forEach($scope.defaultImg.resolutions, function(item){
              if(item.res == res){
                document.getElementById("file" + res).value = "";
                item.uploading = false;
                item.curImg = false;
                item.label = null;
                item.thumb = null;
              }
            });
          }
          ngDialog.close($scope.dialogId);
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.selectEntity = function(caller, index){
      $scope.isChecked = false;
      $scope.cbxStatus;
      if(caller == "all"){
        $scope.isChecked = $scope.allowedFiles[index].selected;
        $scope.curCbx = $scope.allowedFiles[index];
        angular.forEach($scope.curCbx.ext, function(type){
          type.selected = $scope.isChecked;
        });
      } else{
        angular.forEach($scope.allowedFiles, function(type){
          $scope.cbxStatus = type.ext[0].selected;
          if($scope.cbxStatus == false){
            type.selected = false;
          } else{
            $scope.isChecked = true;
            angular.forEach(type.ext, function(exts){
              if(!exts.selected){
                $scope.isChecked = false;
                return false;
              }
            });
            if(!$scope.isChecked){
              type.selected = false;
            } else{
              type.selected = true;
            }
          }
        });
      }
    };

    $rootScope.serverSettingFx = function(caller, subCaller){
      $rootScope.hasDurErr = false;
      $rootScope.durErrType = "";
      $scope.hasErr = false;
      $scope.errType = "";
      $rootScope.hasWMErr = false;
      $rootScope.errWMType = "";
      $rootScope.hasErrPop = false;
      $rootScope.errTypePop = "";
      
      // TODO server permission error
      $rootScope.hasServerPerErr = false;
      $rootScope.errServerPerType = "";

      if(caller == 1){
        $rootScope.saveProcessingServer = true;
        SettingsSrv.updatePrimeAdmin({sid:$scope.sid, uid:$scope.primeObj.info.prime, isNotify:$scope.primeObj.info.isNotify}).then(
          function(data){
            $rootScope.saveProcessingServer = false;
            if(data.code == 17020){
              setTimeout(function(){
                $state.reload();
              }, 100);
            } else if(data.code == 17034){
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">{{"ms.msg.27" | translate}}</div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:480,
                scope:$scope,
                closeByDocument:false,
                className:'ngdialog-theme-default ngdialog-confirm',
              });
            } else{
              ngDialog.close();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
      else if(caller == 2){
        $scope.notifications.sid = $scope.sid;
        if($scope.offline){
          $scope.curSTime = $filter("date")($scope.offline.startTime, "HH:mm:00");
          $scope.curETime = $filter("date")($scope.offline.endTime, "HH:mm:00");
          $scope.notifications.offline = {startTime:($scope.offline.isExcluded ? $scope.curSTime :null), endTime:($scope.offline.isExcluded ? $scope.curETime :null), timeout:$scope.offline.timeout, isExcluded:$scope.offline.isExcluded, threshold:$scope.offline.threshold};
        }
        angular.forEach($scope.notifications.email, function(item){
          if(item.id == 15){
            $scope.isDeviceOffline = item.value;
          }
        });
        if((!$scope.offline.timeout || $scope.offline.timeout == "") && $scope.isDeviceOffline){
         $rootScope.hasErrPop = true;
          $rootScope.errTypePop = "offline";
        } else if(!$scope.offline.threshold && $scope.isDeviceOffline){
         $rootScope.hasErrPop = true;
          $rootScope.errTypePop = "threshold";
        } else if($scope.spSchedule.type == 's' && $scope.scheduleList && ($scope.scheduleList.length == 0 && $scope.notifications.schCount == 0)){
          $rootScope.hasErrPop = true;
          $rootScope.errTypePop = "noSch";
        } else{
          $rootScope.saveProcessingServer = true;
          $scope.isSchExpireSel = false;
          if($scope.spSchedule.type == 's'){
            $scope.scheduleIds = [];
            if($scope.scheduleList && $scope.scheduleList.length){
              $scope.scheduleList.filter(function(ele){
                if(ele.selected){
                  $scope.scheduleIds.push(ele.id);
                }
              });
              if($scope.spSchedule.type=="s"){
                $scope.notifications.schexpnotifyids = $scope.scheduleIds;
              }
            }
            if(!$scope.notifications.schexpnotifyids || $scope.notifications.schexpnotifyids.length == 0){
              $rootScope.hasErrPop = true;
              $rootScope.errTypePop = "noSelSch";
              $rootScope.saveProcessingServer = false;
              return;
            }
          } else {
            $scope.notifications.schexpnotifyids = null;
          }

          $scope.notifications.email.forEach(function(item){
            if((item.id == 16 || item.id == 17 || item.id == 18) && item.value == true){
              $scope.isSchExpireSel = true;
            }
          });

          if(!$scope.isSchExpireSel && $scope.spSchedule.type == 's'){
            $rootScope.hasErrPop = true;
            $rootScope.errTypePop = "noSelExSch";
            $rootScope.saveProcessingServer = false;
            return;
          }


          SettingsSrv.updateNotifications($scope.notifications).then(
            function(data){
              $rootScope.saveProcessingServer = false;
              if($scope.spSchedule.type == 'a'){
                $scope.schExpNotifyIds = data.schexpnotifyids;
                if($scope.schExpNotifyIds == null || $scope.schExpNotifyIds == 0 || $scope.schExpNotifyIds.length == 0){
                  $scope.spSchedule = {type:"a"};
                  $scope.schExpNotifyIds = [];
                  $scope.selectedIDs = [];
                } else {
                  $scope.spSchedule = {type:"s"};
                  $scope.selectedIDs = $scope.schExpNotifyIds == 0 ? [] : angular.copy($scope.schExpNotifyIds);
                }
                $scope.scheduleCheked();
                $scope.resetSchFx();
              }
              ngDialog.close();
            },
            function(err){
              $rootScope.saveProcessingServer = false;
              $log.error(err);
            }
          );
        }
      }
      else if(caller == 3){
        if($scope.polling.pollingDuration == null){
          $scope.hasErr = true;
        } else{
          if(subCaller == 1){
            $rootScope.savePProcessingServer = true;
          } else{
            $rootScope.saveProcessingServer = true;
          }
          $scope.polling.type = subCaller;
          $scope.polling.sid = $scope.sid;
          SettingsSrv.updatePollingFrequency($scope.polling).then(
            function(data){
              ngDialog.close();
              $rootScope.saveProcessingServer = false;
              $rootScope.savePProcessingServer = false;
            },
            function(err){
              $log.error(err);
              $rootScope.saveProcessingServer = false;
              $rootScope.savePProcessingServer = false;
            }
          );
        }
      }
      else if(caller == 4){}
      else if(caller == 5){}
      else if(caller == 6){
        $rootScope.saveProcessingServer = true;
        SettingsSrv.updateAvailableExtension({sid:$scope.sid, supportedFiles:$scope.allowedFiles}).then(
          function(data){
            $rootScope.saveProcessingServer = false;
            $scope.supportedFilesFx();
          },
          function(err){
            $log.error(err);
            $rootScope.saveProcessingServer = false;
          }
        );
      }
      else if(caller == 7){        
        $scope.getServerListFx();
        angular.forEach($scope.serverListArr, function(item){
          if(item.catagary == "Device Actions"){
            if(item.keyName == "dp"){
              $scope.server.da.dp = item.checkBox;
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              $scope.auth.upermissions.da.dp = item.checkBox;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
            }
            if(item.catagary == "Private"){
              if(item.keyName == "f45"){
                $scope.server.widgets.f45 = item.checkBox;
                $scope.auth = angular.fromJson(localStorage.getItem("auth"));
                $scope.auth.upermissions.f45Workout = item.checkBox;
                localStorage.setItem('auth', JSON.stringify($scope.auth));
              }
            }
          }
        });
        if($scope.server.cst == null && !angular.isUndefined($scope.server.cst)){
          $rootScope.hasServerPerErr = true;
          $rootScope.errServerPerType = "cst";
          return false;
        } else if($scope.server.cst < 20 || angular.isUndefined($scope.server.cst)){
          $rootScope.hasServerPerErr = true;
          $rootScope.errServerPerType = "cstMore";
          return false;
        } else if($scope.server.iTime == "" || Number($scope.server.iTime) < 1){
          $rootScope.hasServerPerErr = true;
          $rootScope.errServerPerType = "iTime";
          return false;
        } else if($scope.server.pass == ""){
          $rootScope.hasServerPerErr = true;
          $rootScope.errServerPerType = "pass";
          return false;
        } else if($scope.server.defConDur == null || $scope.server.defConDur <= 0 || angular.isUndefined($scope.server.defConDur)){
          $rootScope.hasDurErr = true;
          $rootScope.durErrType = "invDur";
          return false;
        } else if($scope.server.mssp && $scope.server.msspApp == "ca" && (!$scope.server.msspS.c || !$scope.server.msspS.s || !$scope.server.msspS.t)){
          $rootScope.hasServerPerErr = true;
          $rootScope.errServerPerType = "noCredentialSP";
          return false;
        } else if($scope.server.gd){
          if($scope.server.gdS && $scope.server.gdS.gdOtApp.active){
            if(!$scope.server.gdS.gdOtApp.client_id){
              $rootScope.hasErrPop = true;
              $rootScope.errTypePop = "gdOS";
              return;
            } else if(!$scope.server.gdS.gdOtApp.client_secret){
              $rootScope.hasErrPop = true;
              $rootScope.errTypePop = "gdOS";
              return false;
            }
          }
          if($scope.server.gdS && $scope.server.gdS.gdspApp.active && !$scope.server.gdS.gdspApp.jobj){
            $rootScope.hasErrPop = true;
            $rootScope.errTypePop = "gdSP";
            return false;
          }
        }
        
        // Menu Board
        if($scope.server.dmb && (!$scope.server.dmb_t && !$scope.server.dmb_c)){
          $rootScope.hasDurErr = true;
          $rootScope.durErrType = "dmbSubEmpt";
          return false;
        }
        if(!$scope.server.dmb){
          $scope.server.dmb_t = false;
          $scope.server.dmb_c = false;
        }
        
        // TODO video indexer status key
        if($scope.server.vi && !$scope.authorizedInder){
          $scope.server.vi = false;
        }
        // return;
        $scope.server.sid = $scope.sid;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">\
                <div class="marB15" translate="{{\'ms.p_s.serverPer.m2\'}}" translate-values="{serverName:\'<b>{{sName}}</b>\'}"></div>\
                <label class="noMarB"><input type="checkbox" role="checkbox" ng-model="server.isNotify" aria-label="isNotify" aria-labelledby="isNotify"><label></label> {{"ms.p_s.prime.5" | translate}}</label>\
              </div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="confirmFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-repeat fa-spin" ng-if="saveProcessingServer" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                <div class="errMsg pull-right" ng-if="hasErr" aria-live="polite" role="status">\
                  <span ng-if="errType==\'urlS\'" aria-live="polite" role="status" translate="{{\'ms.p_s.serverPer.m9.1\'}}" translate-values="{serverName:existsServer}"></span>\
                </div>\
              </footer>\
            </section>',
          plain:true,
          width:480,
          scope:$scope,
          closeByDocument:false,
          className:'ngdialog-theme-default ngdialog-confirm',
        });
      }
      else if(caller == 11){
        if($scope.dWMObj.wmImg == null || $scope.dWMObj.wmImg == ""){
          $rootScope.hasWMErr = true;
          $rootScope.errWMType = "wmImg";
        } else if(angular.isUndefined($scope.dWMObj.curFrame.x) || angular.isUndefined($scope.dWMObj.curFrame.y) || $scope.dWMObj.curFrame.x < 0 || $scope.dWMObj.curFrame.y < 0){
          $rootScope.hasWMErr = true;
          $rootScope.errWMType = "position";
        } else{
          $scope.server = {s:$scope.dWMObj, serverid:$scope.sid};
          if($scope.dupInfo.devices.device.length){
            $scope.stringIds = $scope.arraytoStringFx($scope.dupInfo.devices.device);
            $scope.server.d = $scope.stringIds;
          }

          $scope.saveProcessingServer = true;
          $scope.server.s.dateRange.startDate = moment($scope.server.s.dateRange.startDate).format('MM-DD-YYYY');
          $scope.server.s.dateRange.endDate = moment($scope.server.s.dateRange.endDate).format('MM-DD-YYYY');
          MySettingsSrv.saveWatermark($scope.server).then(
            function(data){
              $scope.saveProcessingServer = false;
            },
            function(err){
              $log.error(err);
              $scope.saveProcessingServer = false;
            }
          );
        }
      }
    }
    $scope.confirmFx = function(){
      $rootScope.saveProcessingServer = true;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.server.emType = $scope.em.isCheck ? $scope.em.type : "";
      /*encrypt & decrypt start*/
      var enData = $scope.endeDataFx("e", angular.copy($scope.server), $scope.keysToProcess);
      if(enData.gdS && enData.gdS.gdspApp && enData.gdS.gdspApp.jobj && enData.gdS.gdspApp.jobj.private_key){
        enData.gdS.gdspApp.jobj.private_key = $scope.encryptedChunksFx(enData.gdS.gdspApp.jobj.private_key);
      }

      // SettingsSrv.updatePermissions($scope.server).then(
      SettingsSrv.updatePermissions(enData).then(
        function(data){
          $rootScope.saveProcessingServer = false;
          if(data.code == 17044){
            $scope.existsServer = data.name;
            $scope.errType = "urlS";
            $scope.hasErr = true;
          }
          if(data.status == "Success"){
            if($scope.server.sid == $scope.auth.server){
              // console.log("INNN",$scope.server);
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              $scope.auth.upermissions.gf = $scope.server.gf;
              $scope.auth.upermissions.mc = $scope.server.mc;
              $scope.auth.upermissions.vd = $scope.server.vd;
              $scope.auth.upermissions.dgrp = $scope.server.dgrp;
              $scope.auth.upermissions.gbdt = $scope.server.gbdt;
              $scope.auth.upermissions.webos = $scope.server.webos;
              $scope.auth.upermissions.tizen = $scope.server.tizen;
              $scope.auth.upermissions.desktop = $scope.server.desktop;
              $scope.auth.upermissions.drg = $scope.server.drg;
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              // console.log("$scope.auth.upermissions.drg",$scope.auth.upermissions.drg);
            }
            ngDialog.close();
            $scope.selectTabFx(7);
          }
        },
        function(err){
          $log.error(err);
          $rootScope.saveProcessingServer = false;
        }
      );
    }

    /*Second ngDialog close*/
    $scope.listPopOpen = function(caller){
      $scope.popupLoading = true;
      $scope.openList = {caller:caller, list:[], selectAll:false};
      if($scope.openList.caller == "mc"){
        SettingsSrv.getMusicChoice($scope.sid).then(
          function(data){
            $scope.popupLoading = false;
            $scope.openList.list = data;
          },
          function(err){
            $log.error(err);
            $scope.popupLoading = false;
          }
        );
      }
      ngDialog.open({
        template:'app/common/popup/openList.html',
        width:850,
        scope:$scope,
        data:$scope.openList,
        closeByDocument:false
      });
    }
    $scope.listPopFx = function(){
      $scope.popupProcessing = true;
      if($scope.openList.caller == "mc"){
        SettingsSrv.updateMusicChoice($scope.sid, $scope.openList.list).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17036){
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    $scope.offlineOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.30" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div>\
                <label for="odne">{{"cm.label.47" | translate}}</label>\
                <input type="email" id="odne" class="form-control" ng-model="server.odne" aria-label="{{\'cm.label.47\' | translate}}" aria-labelledby="{{\'cm.label.47\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="offlineFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'email\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m3" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.offlineFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.odne){
        $scope.hasErrPop = true;
        $scope.errTypePop = "email";
        $("#odne").focus();
      } else{
        ngDialog.close($scope.dialogId);
      }
    }

    $scope.proActiveOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.proMonitorCopy = angular.copy($scope.server.proMonitorS);
      $scope.curMonitor = $scope.server.proMonitorS;
      if(!$scope.server.proMonitorS.time){
        $scope.curMonitor.time = "";
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.61.1" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="time">{{\'ms.p_s.serverPer.61.2\' | translate}}</label>\
                <div class="input-group">\
                  <input id="time" type="text" class="form-control" ng-model="curMonitor.time" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="{{inputLimit}}" aria-label="time" aria-labelledby="time">\
                  <span class="input-group-addon">{{\'r.label.17\' | translate}}</span>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="proActiveFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="resetProActiveFx(); closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'time\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m27" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
      });
    }
    $scope.proActiveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curMonitor.time){
        $scope.hasErrPop = true;
        $scope.errTypePop = "time";
        $("#time").focus();
      } else{
        $scope.server.proMonitorS = $scope.curMonitor;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.resetProActiveFx = function(){
      $scope.server.proMonitorS.time = $scope.proMonitorCopy.time;
    }

    /** BigPanda */
    $scope.bigPandaOpen = function(){
      $scope.tmpBpObj = angular.copy($scope.server.bpa);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.33" | translate | camelCase}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="token">{{"ms.label.37" | translate}}</label>\
                <input type="text" id="token" class="form-control" ng-model="server.bpa.token" aria-label="{{\'ms.label.37\' | translate}}" aria-labelledby="{{\'ms.label.37\' | translate}}">\
              </div>\
              <div class="form-group noMarB">\
                <label for="key">{{"ms.label.38" | translate}}</label>\
                <input type="text" id="key" class="form-control" ng-model="server.bpa.key" aria-label="{{\'ms.label.38\' | translate}}" aria-labelledby="{{\'ms.label.38\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="bigPandaFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="resetBigPDataFx(); closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'token\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m6" | translate}}</div>\
                <div ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m7" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.bigPandaFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.bpa.token){
        $scope.hasErrPop = true;
        $scope.errTypePop = "token";
        $("#token").focus();
      } else if(!$scope.server.bpa.key){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
        $("#key").focus();
      } else{
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.resetBigPDataFx = function(){
      $scope.server.bpa.token = $scope.tmpBpObj.token;
      $scope.server.bpa.key = $scope.tmpBpObj.key;
    }

    /** HubSpot ticket */
    $scope.hubSpotOpen = function(){
      $scope.tmpBpObj = angular.copy($scope.server.hs);
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading" role="heading" aria-level="1">{{"ms.p_s.serverPer.50" | translate | camelCase}}</header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"ms.label.37" | translate}}</label>\
                <input type="text" class="form-control" ng-model="server.hs.token">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="hubSpotFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="resethubSpotDataFx(); closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'token\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m6" | translate}}</div>\
                <div ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"ms.p_s.notifyS.m7" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.hubSpotFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.server.hs.token){
        $scope.hasErrPop = true;
        $scope.errTypePop = "token";
      } else{
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.resethubSpotDataFx = function(){
      $scope.server.hs.token = $scope.tmpBpObj.token;
      $scope.server.hs.key = $scope.tmpBpObj.key;
    }

    /** SSO */
    $scope.ssoPopOpen = function(){
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      SettingsSrv.getSSO($scope.sid, $scope.server.sso.type).then(
        function(data){
          $scope.popupLoading = false;
          $scope.curSSO = angular.copy(data.sso);

          var keysToProcess = ['clientId', 'clientSecret', 'tenantId', 'appDomain', 'entityId', 'slo'];
          $scope.curSSO = $scope.endeDataFx("d", data.sso, keysToProcess);
          $scope.curSSO.id = $scope.sid;
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/ssoSettings.html',
        width:500,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.ssoSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if(!$scope.curSSO.text || $scope.curSSO.text == ""){
        $scope.errTypePop = "text";
        $scope.hasErrPop = true;
        $("#curSSOtext").focus();
      } else if(!$scope.curSSO.url || $scope.curSSO.url == ""){
        $scope.errTypePop = "url";
        $scope.hasErrPop = true;
        $("#curSSOurl").focus();
      } else if($scope.server.sso.type != "idaptive" && $scope.server.sso.type != "saml" && !$scope.curSSO.clientId || $scope.curSSO.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
        $("#curSSOclientId").focus();
      } else if($scope.server.sso.type != "idaptive" && $scope.server.sso.type != "saml" && !$scope.curSSO.clientSecret || $scope.curSSO.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
        $("#curSSOclientSecret").focus();
      } else if($scope.server.sso.type == "azure" && (!$scope.curSSO.tenantId || $scope.curSSO.tenantId == "")){
        $scope.errTypePop = "tId";
        $scope.hasErrPop = true;
        $("#curSSOtenantId").focus();
      } else if($scope.server.sso.type == "okta" && (!$scope.curSSO.appDomain || $scope.curSSO.appDomain == "")){
        $scope.errTypePop = "appD";
        $scope.hasErrPop = true;
        $("#curSSOappDomain").focus();
      } else if(($scope.server.sso.type == "idaptive" || $scope.server.sso.type == "saml") && (!$scope.curSSO.entityId || $scope.curSSO.entityId == "")){
        $scope.errTypePop = "eId";
        $scope.hasErrPop = true;
        $("#curSSOentityId").focus();
      } else if(($scope.server.sso.type == "idaptive" || $scope.server.sso.type == "saml") && (!$scope.curSSO.sso || $scope.curSSO.sso == "")){
        $scope.errTypePop = "sso";
        $scope.hasErrPop = true;
        $("#curSSOsso").focus();
      } else if(($scope.server.sso.type == "idaptive" || $scope.server.sso.type == "saml") && (!$scope.curSSO.slo || $scope.curSSO.slo == "")){
        $scope.errTypePop = "slo";
        $scope.hasErrPop = true;
        $("#curSSOslo").focus();
      } else if(($scope.server.sso.type == "idaptive" || $scope.server.sso.type == "saml") && (!$scope.curSSO.cert || $scope.curSSO.cert == "")){
        $scope.errTypePop = "cert";
        $scope.hasErrPop = true;
        $("#curSSOcert").focus();
      } else{
        $scope.popupProcessing = true;

        var curSSO = angular.copy($scope.curSSO);
        var keysToProcess = ['clientId', 'clientSecret', 'tenantId', 'appDomain', 'entityId', 'slo'];

        curSSO = $scope.endeDataFx("e", $scope.curSSO, keysToProcess);

        SettingsSrv.updateSSO(curSSO).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17044){
              $scope.existsServer = data.name;
              $scope.errTypePop = "urlS";
              $scope.hasErrPop = true;
            } else if(data.code == 17045){
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }
    /** Jci Map */
    $scope.jciMapPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curJciMapCopy = angular.copy($scope.server.widgets.intelJciMapS);
      $scope.curJciMap = $scope.server.widgets.intelJciMapS;
      if($scope.server.widgets.intelJciMapS.length == 0){
        $scope.curJciMap = {user:"", pass:""};
      }
      ngDialog.open({
        template:'<section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"cl.widget.jci.4" | translate | camelCase}}</h1>\
            </header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label>{{"cl.widget.jci.4.1" | translate}}</label>\
                    <input type="text" id="jciUser" class="form-control" ng-model="curJciMap.user">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"cl.widget.jci.4.2" | translate}}</label>\
                    <input type="text" id="jciPass" class="form-control" ng-model="curJciMap.pass">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="jciMapSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'user\'" aria-live="polite" role="status">{{"cl.widget.jci.m2" | translate}}</div>\
                <div ng-if="errTypePop==\'pass\'" aria-live="polite" role="status">{{"cl.widget.jci.m3" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.jciMapCloseFx();
          }
        }
      });
    }
    $scope.jciMapSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curJciMap.user || $scope.curJciMap.user == ""){
        $scope.errTypePop = "user";
        $scope.hasErrPop = true;
        $("#jciUser").focus();
      } else if(!$scope.curJciMap.pass || $scope.curJciMap.pass == ""){
        $scope.errTypePop = "pass";
        $scope.hasErrPop = true;
        $("#jciPass").focus();
      } else{
        $scope.server.widgets.intelJciMapS = $scope.curJciMap;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.jciMapCloseFx = function(){
      $scope.server.widgets.intelJciMapS = angular.copy($scope.curJciMapCopy);
    }

    /** Social Chorus */
    $scope.sChorusPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curSocialChorusCopy = angular.copy($scope.server.widgets.firstupS);
      $scope.curSocialChorus = $scope.server.widgets.firstupS;
      if($scope.server.widgets.firstupS.length == 0){
        $scope.curSocialChorus = {clientId:"", clientSecret:""};
      }
      ngDialog.open({
        template: '<section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.46" | translate | camelCase}}</h1></header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label for="clientId">{{"ms.p_s.serverPer.13" | translate}}</label>\
                    <input type="text" id="clientId" class="form-control" ng-model="curSocialChorus.clientId" aria-label="clientId" aria-labelledby="clientId">\
                  </div>\
                  <div class="form-group">\
                    <label for="clientSecret">{{"ms.p_s.serverPer.14" | translate}}</label>\
                    <input type="text" id="clientSecret" class="form-control" ng-model="curSocialChorus.clientSecret" aria-label="clientSecret" aria-labelledby="clientSecret">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="sChorusSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'cId\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m4" | translate}}</div>\
                <div ng-if="errTypePop==\'cs\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m5" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.sChorusCloseFx();
          }
        }
      });
    }

    $scope.sChorusSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curSocialChorus.clientId || $scope.curSocialChorus.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
        $("#clientId").focus();
      } else if(!$scope.curSocialChorus.clientSecret || $scope.curSocialChorus.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
        $("#clientSecret").focus();
      } else{
        $scope.server.widgets.firstupS = $scope.curSocialChorus;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.sChorusCloseFx = function(){
      $scope.server.widgets.firstupS = angular.copy($scope.curSocialChorusCopy);
    }

    /** Achiever */
    $scope.achieversPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curAchieverCopy = angular.copy($scope.server.widgets.achieversS);
      $scope.curAchiever = $scope.server.widgets.achieversS;
      if($scope.server.widgets.achieversS.length == 0){
        $scope.curAchiever = {endpoint:'', clientId:"", clientSecret:""};
      }
      ngDialog.open({
        template: '<section class="panel">\
            <header class="panel-heading"><h1>{{"cl.widget.achievers.3" | translate | camelCase}}</h1></header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label for="ep">{{"cl.widget.pw.27" | translate}}</label>\
                    <input type="text" id="ep" class="form-control" ng-model="curAchiever.endpoint" aria-label="{{\'cl.widget.pw.27\' | translate}}" aria-labelledby="{{\'cl.widget.pw.27\' | translate}}">\
                  </div>\
                  <div class="form-group">\
                    <label for="clientId">{{"ms.p_s.serverPer.13" | translate}}</label>\
                    <input type="text" id="clientId" class="form-control" ng-model="curAchiever.clientId" aria-label="clientId" aria-labelledby="clientId">\
                  </div>\
                  <div class="form-group">\
                    <label for="clientSecret">{{"ms.p_s.serverPer.14" | translate}}</label>\
                    <input type="text" id="clientSecret" class="form-control" ng-model="curAchiever.clientSecret" aria-label="clientSecret" aria-labelledby="clientSecret">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="achieversSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop">\
                <div ng-if="errTypePop == \'cId\'">{{"ms.p_s.serverPer.m4" | translate}}</div>\
                <div ng-if="errTypePop == \'cs\'">{{"ms.p_s.serverPer.m5" | translate}}</div>\
                <div ng-if="errTypePop == \'ep\'">{{"ms.p_s.serverPer.39.m1" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:540,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.achieversCloseFx();
          }
        }
      });
    }
    $scope.achieversSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curAchiever.endpoint || $scope.curAchiever.endpoint == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
        $("#ep").focus();
      } else if(!$scope.curAchiever.clientId || $scope.curAchiever.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
        $("#clientId").focus();
      } else if(!$scope.curAchiever.clientSecret || $scope.curAchiever.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
        $("#clientSecret").focus();
      } else{
        $scope.server.widgets.achieversS = $scope.curAchiever;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.achieversCloseFx = function(){
      $scope.server.widgets.achieversS = angular.copy($scope.curAchieverCopy);
    }

    /** Intel Circuit RSS */
    $scope.inCircuitPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curInCircuitCopy = angular.copy($scope.server.widgets.intelCircuitBenchS);
      $scope.curInCircuit = $scope.server.widgets.intelCircuitBenchS;
      if($scope.server.widgets.intelCircuitBenchS.length == 0){
        $scope.curInCircuit = {clientId:"", clientSecret:"", ep:""};
      }
      ngDialog.open({
        template:'<section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"cl.widget.inC.3" | translate | camelCase}}</h1>\
            </header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label>{{"ms.p_s.serverPer.13" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="curInCircuit.clientId">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"ms.p_s.serverPer.14" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="curInCircuit.clientSecret">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"cl.widget.pw.27" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="curInCircuit.ep">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="inCircuitSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'cId\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m4" | translate}}</div>\
                <div ng-if="errTypePop==\'cs\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m5" | translate}}</div>\
                <span ng-if="errTypePop==\'ep\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m1" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.inCircuitCloseFx();
          }
        }
      });
    }

    $scope.inCircuitSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curInCircuit.clientId || $scope.curInCircuit.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
      } else if(!$scope.curInCircuit.clientSecret || $scope.curInCircuit.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
      } else if($scope.curInCircuit.ep == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
      } else{
        $scope.server.widgets.intelCircuitBenchS = $scope.curInCircuit;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.inCircuitCloseFx = function(){
      $scope.server.widgets.intelCircuitBenchS = angular.copy($scope.curInCircuitCopy);
    }

    /** Webex */
    $scope.webexPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.webexCopy = angular.copy($scope.server.widgets.webexS);
      $scope.webex = $scope.server.widgets.webexS;
      if($scope.server.widgets.webexS.length == 0){
        $scope.webex = {clientId:"", clientSecret:"", ep:""};
      }
      ngDialog.open({
        template:'<section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"cl.widget.webex.6" | translate}}</h1>\
            </header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label>{{"ms.p_s.serverPer.13" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="webex.clientId">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"ms.p_s.serverPer.14" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="webex.clientSecret">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="webexSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'cId\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m4" | translate}}</div>\
                <div ng-if="errTypePop==\'cs\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m5" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.webexCloseFx();
          }
        }
      });
    }

    $scope.webexSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.webex.clientId || $scope.webex.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
      } else if(!$scope.webex.clientSecret || $scope.webex.clientSecret == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
      } else{
        $scope.server.widgets.webexS = $scope.webex;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.webexCloseFx = function(){
      $scope.server.widgets.webexS = angular.copy($scope.webexCopy);
    }

    /* Asana Integration */
    $scope.asanaOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.asanaSCopy = angular.copy($scope.server.asanaS);
      $scope.asanaS = $scope.server.asanaS;
      if($scope.server.asanaS.length == 0){
        $scope.asanaS = {pci:"", pcs:"", uci:"", ucs:""};
      }
      ngDialog.open({
        template:'<section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"cm.asn.8" | translate}}</h1>\
            </header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label>{{"cm.asn.9" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="asanaS.pci">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"cm.asn.10" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="asanaS.pcs">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"cm.asn.11" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="asanaS.uci">\
                  </div>\
                  <div class="form-group">\
                    <label>{{"cm.asn.12" | translate}}</label>\
                    <input type="text" class="form-control" ng-model="asanaS.ucs">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="asanaSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'pci\'" aria-live="polite" role="status">{{"cm.asn.m11" | translate}}</div>\
                <div ng-if="errTypePop==\'pcs\'" aria-live="polite" role="status">{{"cm.asn.m12" | translate}}</div>\
                <div ng-if="errTypePop==\'uci\'" aria-live="polite" role="status">{{"cm.asn.m13" | translate}}</div>\
                <div ng-if="errTypePop==\'ucs\'" aria-live="polite" role="status">{{"cm.asn.m14" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.asanaCloseFx();
          }
        }
      });
    }

    $scope.asanaSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.asanaS.pci || $scope.asanaS.pci == ""){
        $scope.errTypePop = "pci";
        $scope.hasErrPop = true;
      }
      else if(!$scope.asanaS.pcs || $scope.asanaS.pcs == ""){
        $scope.errTypePop = "pcs";
        $scope.hasErrPop = true;
      }
      else if(!$scope.asanaS.uci || $scope.asanaS.uci == ""){
        $scope.errTypePop = "uci";
        $scope.hasErrPop = true;
      }
      else if(!$scope.asanaS.ucs || $scope.asanaS.ucs == ""){
        $scope.errTypePop = "ucs";
        $scope.hasErrPop = true;
      }
      else{
        $scope.server.asanaS = $scope.asanaS;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.asanaCloseFx = function(){
      $scope.server.asanaS = angular.copy($scope.asanaSCopy);
    }

    /** WebOS */
    $scope.pmModeList = [{label:"Power Off (Default)", value:"powerOff"}, {label:"Sustain Aspect Ratio", value:"sustainAspectRatio"}, {label:"Screen Off", value:"screenOff"}, {label:"Screen Off Always", value:"screenOffAlways"}, {label:"Screen Off & Backlight On", value:"screenOffBacklight"}];
    $scope.irLockList = [{label:"Off (Normal)", value:"normal"}, {label:"On (Power Key Only)", value:"usePwrOnly"}, {label:"On (Block All)", value:"blockAll"}];
    $scope.pStatusList = [{label:"PWR (Power On)", value:"PWR"}, {label:"STD (Standby)", value:"STD"}, {label:"LST (Last Status)", value:"LST"}];
    $scope.continentList = ["Africa", "Asia", "CIS", "Europe", "Middle East", "North America", "Oceania", "Pacific", "South America"];
    $scope.dpmWakeList = [{label:"Clock", value:"clock"}, {label:"Clock+Data", value:"clockAndData"}];
    $scope.dpmList = [{label:"Off", value:"off"}, {label:"1 Min", value:"1min"}, {label:"3 Min", value:"3min"}, {label:"5 Min", value:"5min"}, {label:"10 Min", value:"10min"}];
    $scope.countryList = [];
    $scope.cityList = [];

    $scope.webOSPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      DeviceControlSrv.getWebOSTimezone().then(
        function(data){
          $scope.webOSTimezone = data.timeZone;
        },
        function(err){
          $log.error(err);
        }
      );
      DeviceControlSrv.getWebOSLang().then(
        function(data){
          $scope.localeList = data.localeList;
        },
        function(err){
          $log.error(err);
        }
      );

      $scope.popupLoading = true;
      SettingsSrv.getWebOS($scope.sid).then(
        function(data){
          $scope.popupLoading = false;
          if(data != ""){
            $scope.webOS = data;
            if($scope.webOS.gs.as.tvt){
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")(day.st);
                day.et = $filter("momentTime")(day.et);
              });
            } else{
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")("09:00:00");
                day.et = $filter("momentTime")("17:00:00");
              });
            }
          } else{
            $scope.webOS = {
              gs:{
                l:{
                  menu:{language:"English", languageCode:"en", countries:[{name:"", specifier:"en-US"}]},
                  key:{language:"English", languageCode:"en", countries:[{name:"", specifier:"en-US"}]}
                },
                si:{s:false},
                dt:{set:true, t:"", d:"", tz:{c:"North America", ct:"Canada", ci:"Toronto"}, ntp:{s:false, ip:""}},
                p:{signal:false, ir:false, dpm:{label:"Off", value:"off"}, wakeUp:{label:"Clock", value:"clock"}, pm:{label:"Power Off (Default)", value:"powerOff"}, delay:0, status:{label:"PWR (Power On)", value:"PWR"}, wired:false, wireless:false},
                n:{
                  lan:{wired:true},
                  cpc:{ip:"", mask:"", gateway:"", dns:""}
                },
                as:{
                  b:false, w:true, tvt:false,
                  days:[
                    {label:1, name:"Mon", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:2, name:"Tue", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:3, name:"Wed", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:4, name:"Thu", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:5, name:"Fri", val:true, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:6, name:"Sat", val:false, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")},
                    {label:0, name:"Sun", val:false, st:$filter("momentTime")("09:00:00"), et:$filter("momentTime")("17:00:00")}
                  ]
                }
              },
              as:{h:false, usb:false, osd:false, ir:{label:"Off (Normal)", value:"normal"}, local:{label:"Off (Normal)", value:"normal"}, wifi:true, ss:true},
              ns:{port:[], tcp:""}
            }
          }
          $scope.blockObj = {id:0, p:null, d:"in", pr:"TCP", show:false};
          $scope.blockAdd = false;
          $scope.bCount = 0;
          $scope.timeZoneFx("c", true);
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      $scope.webOSPop = ngDialog.open({
        template:'app/common/popup/webOSSettings.html',
        width:900,
        scope:$scope,
        closeByDocument:false,
        closeByEscape:false,
        className:'ngdialog-theme-default ngdialog-preview'
      });
    }

    $scope.webosDefaultOpen = function(){
      $scope.confirmProcessing = false;
      $scope.webosDefault = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"d.p_dc.wos.m12" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="webosDefaultFx();" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.webosDefaultFx = function(){
      $scope.confirmProcessing = true;
      SettingsSrv.webosDefault().then(
        function(data){
          $scope.confirmProcessing = false;
          if(data.settings){
            $scope.webOS = data.settings;
            if($scope.webOS.gs.as.tvt){
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")(day.st);
                day.et = $filter("momentTime")(day.et);
              });
            } else{
              angular.forEach($scope.webOS.gs.as.days, function(day){
                day.st = $filter("momentTime")("09:00:00");
                day.et = $filter("momentTime")("17:00:00");
              });
            }
            ngDialog.close($scope.webosDefault.id);
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.setTvTimerFx = function(caller, curTime){
      $scope.webOS.gs.as.days.forEach(function(item){
        if(caller==='Mon'){
          if(item.name != 'Sat' && item.name != 'Sun'){
            item.val = true;
            item.st = curTime.st;
            item.et = curTime.et;
          }
        } else if(caller=='Sat'){
          if(item.name == 'Sat' || item.name == 'Sun'){
            item.val = true;
            item.st = curTime.st;
            item.et = curTime.et;
          }
        } else if(caller == 'all'){
          item.val = true;
          item.st = curTime.st;
          item.et = curTime.et;
        }
      });
    }

    $scope.getDTFx = function(){
      if(!$scope.webOS.gs.dt.set){
        $scope.webOS.gs.dt.t = $scope.custTime = moment().set('minute', '00').utc().format();
        $scope.webOS.gs.dt.d = {startDate:moment()._d, endDate:moment()._d};
      } else{
        $scope.timeZoneFx("c", true);
      }
    }
    $scope.timeZoneFx = function(caller, auto){
      if(caller == "c"){
        $scope.countryList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCExists = false;
          angular.forEach($scope.countryList, function(item1){
            if(angular.equals(item.country, item1)){
              $scope.isCExists = true;
            }
          });
          if(!$scope.isCExists && item.continent == $scope.webOS.gs.dt.tz.c){
            $scope.countryList.push(item.country);
          }
        });
        if(auto){
          $scope.timeZoneFx("ct");
        }
      } else if(caller == "ct"){
        $scope.cityList = [];
        angular.forEach($scope.webOSTimezone, function(item){
          $scope.isCtExists = false;
          angular.forEach($scope.cityList, function(item1){
            if(angular.equals(item.country, item1)){
              $scope.isExists = true;
            }
          });
          if(!$scope.isCtExists && item.country == $scope.webOS.gs.dt.tz.ct){
            $scope.cityList.push(item.city);
          }
        });
      }
    }

    $scope.blockAddFx = function(){
      $scope.blockAdd = !$scope.blockAdd;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }

    $scope.editArr = [];
    $scope.savePortFx = function(caller, port){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.webOS.ns.port){
        $scope.webOS.ns.port = [];
      }
      if(caller == "a"){
        if($scope.blockObj.p == ""){
          $scope.errTypePop = "pEmpty";
          $scope.hasErrPop = true;
        } else{
          if(!$scope.webOS.ns.port.length){
            $scope.blockObj.id = $scope.bCount;
            $scope.webOS.ns.port.push($scope.blockObj);
            $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
            $scope.blockAdd = false;
            $scope.bCount++;
          } else{
            for(var i = 0;i < $scope.webOS.ns.port.length;i++){
              if($scope.webOS.ns.port[i].p == $scope.blockObj.p && $scope.webOS.ns.port[i].d == $scope.blockObj.d && $scope.webOS.ns.port[i].pr == $scope.blockObj.pr){
                $scope.errTypePop = "pSame";
                $scope.hasErrPop = true;
                return;
              }
            }
            if($scope.bCount <= 30){
              $scope.webOS.ns.port.push({id:$scope.bCount, p:$scope.blockObj.p, d:$scope.blockObj.d, pr:$scope.blockObj.pr});
              $scope.blockObj = {p:null, d:"in", pr:"TCP", show:false};
              $scope.blockAdd = false;
              $scope.bCount++;
            }
          }
        }
      } else if(caller == "e"){
        $scope.editArr.push(angular.copy(port));
      } else if(caller == "s"){
        $scope.isSame = false;
        $scope.indexToUpdate;
        for(var i = 0;i < $scope.webOS.ns.port.length;i++){
          if($scope.webOS.ns.port[i].id != port.id && ($scope.webOS.ns.port[i].p == port.p && $scope.webOS.ns.port[i].d == port.d && $scope.webOS.ns.port[i].pr == port.pr)){
            $scope.isSame = true;
            $scope.errTypePop = "pSame";
            $scope.hasErrPop = true;
            break;
          }
          else if($scope.webOS.ns.port[i].id == port.id){
            $scope.indexToUpdate = i;
          }
        }
        if(!$scope.isSame){
          port.show = !port.show;
          $scope.webOS.ns.port[$scope.indexToUpdate] = port;
          for(var j = 0;j < $scope.editArr.length;j++){
            if($scope.editArr[j].id == port.id){
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    $scope.cancelEditFx = function(id){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      for(var i = 0;i < $scope.webOS.ns.port.length;i++){
        if($scope.webOS.ns.port[i].id == id){
          for(var j = 0;j < $scope.editArr.length;j++){
            if($scope.editArr[j].id == id){
              $scope.webOS.ns.port[i] = $scope.editArr[j];
              $scope.editArr.splice(j, 1);
            }
          }
        }
      }
    }

    $scope.deletePortOpen = function(index){
      $scope.portIndex = index;
      $scope.deletePort = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.msg.35" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deletePortFx(portIndex);" focus-me="true" ng-disabled="confirmProcessing">\
                <span class="fa fa-repeat fa-spin" ng-if="confirmProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}\
              </button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }
    $scope.deletePortFx = function(index){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dialogId = "";
      $scope.webOS.ns.port.splice(index, 1);
      ngDialog.close($scope.deletePort.id);
    }

    $scope.webOSPopFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.eOpened = $filter("filter")($scope.webOS.ns.port, {show:true});
      if($scope.webOS.gs.as.tvt){
        var isSTErr = false, isETErr = false;
        angular.forEach($scope.webOS.gs.as.days, function(day){
          if(day.val && !day.st){
            isSTErr = true;
          }
          if(day.val && !day.et){
            isETErr = true;
          }
        });
      }
      if($scope.eOpened && $scope.eOpened.length){
        $scope.hasErrPop = true;
        $scope.errTypePop = "eOpened";
      } else if($scope.webOS.gs.as.tvt && isSTErr){
        $scope.hasErrPop = true;
        $scope.errTypePop = "onTime";
      } else if($scope.webOS.gs.as.tvt && isETErr){
        $scope.hasErrPop = true;
        $scope.errTypePop = "offTime";
      } else{
        $scope.copyWebOS = angular.copy($scope.webOS);
        if($scope.copyWebOS.gs.as.tvt){
          angular.forEach($scope.copyWebOS.gs.as.days, function(day){
            if(day.st){
              day.st = moment(day.st).format();
              day.st = day.st.split("T")[1].split("+")[0].split("-")[0];
            }
            if(day.et){
              day.et = moment(day.et).format();
              day.et = day.et.split("T")[1].split("+")[0].split("-")[0];
            }
          });
        }

        $scope.popupProcessing = true;
        SettingsSrv.updateWebOS({id:$scope.sid, settings:$scope.copyWebOS}).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17043){
              ngDialog.close($scope.webOSPop.id);
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    $scope.telexPopOpen = function(){
      $scope.popupLoading = true;
      SettingsSrv.getTelexSettings($scope.sid).then(
        function(data){
          $scope.popupLoading = false;
          $scope.telexSettings = data;
          $scope.decodePass = {ac:$scope.reverse(atob($scope.telexSettings.settings.telaxpassword).split("|")[0]), ftp:$scope.reverse(atob($scope.telexSettings.settings.telaxftppassword).split("|")[0])};
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/telexSettings.html',
        width:850,
        scope:$scope,
        data:$scope.openList,
        closeByDocument:false
      });
    }
    $scope.telexPopFx = function(){
      $scope.popupProcessing = true;
      $scope.encodePass = {ac:btoa($scope.reverse($scope.settings.info.email + "|" + $scope.decodePass.ac)), ftp:btoa($scope.reverse($scope.settings.info.email + "|" + $scope.decodePass.ftp))};
      $scope.telexSettings.settings.telaxpassword = $scope.encodePass.ac;
      $scope.telexSettings.settings.telaxftppassword = $scope.encodePass.ftp;
      SettingsSrv.updateTelexSettings($scope.sid, $scope.telexSettings).then(
        function(data){
          $scope.popupProcessing = false;
          if(data.code == 17037){
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.popupProcessing = false;
        }
      );
    }

    $scope.gdPopOpen = function(caller){
      if(caller == "o" && angular.isArray($scope.server.gdS.gdOtApp)){
        $scope.server.gdS.gdOtApp = {active:true};
      }
      if(caller == "sp" && angular.isArray($scope.server.gdS.gdspApp)){
        $scope.server.gdS.gdspApp = {active:true};
      }
      $scope.gdObj = {caller:caller, data:angular.copy($scope.server.gdS)};
      if(caller == "sp" && $scope.gdObj.data.gdspApp.jobj){
        $scope.gdObj.data.gdspApp.jobj = JSON.stringify($scope.gdObj.data.gdspApp.jobj, null, 2);
      }
      
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      ngDialog.open({
        template:'app/common/popup/gdSettings.html',
        width:650,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.gdFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      
      if($scope.gdObj.caller == "o"){
        if(!$scope.gdObj.data.gdOtApp.client_id){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cid";
          $("#cid").focus();
          return;
        } else if($scope.gdObj.data.gdOtApp && $scope.gdObj.data.gdOtApp.client_id == ""){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cid";
          $("#cid").focus();
          return;
        } else if(!$scope.gdObj.data.gdOtApp.client_secret){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cs";
          $("#cs").focus();
          return;
        } else if(($scope.gdObj.data.gdOtApp && $scope.gdObj.data.gdOtApp.client_secret == "")){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cs";
          $("#cs").focus();
          return;
        }
      } else if($scope.gdObj.caller == "sp"){
        if(!$scope.gdObj.data.gdspApp.jobj){
          $scope.hasErrPop = true;
          $scope.errTypePop = "md";
          $("#md").focus();
          return;
        } else if($scope.gdObj.data.gdspApp && $scope.gdObj.data.gdspApp.jobj == ""){
          $scope.hasErrPop = true;
          $scope.errTypePop = "md";
          $("#md").focus();
          return;
        }
      }
      if(!$scope.hasErrPop){
        // Oauth
        if($scope.gdObj.caller == "o"){
          $scope.server.gdS = angular.copy($scope.gdObj.data);
        }

        // Service Principle
        if($scope.gdObj.caller == "sp"){
          try{
            var jobj = $scope.gdObj.data.gdspApp.jobj;
            var parsedJobj = null;

            if(typeof jobj === 'string'){
              parsedJobj = JSON.parse(jobj);
            } else if(typeof jobj === 'object' && jobj !== null){
              parsedJobj = JSON.stringify(jobj, null, 2);
            } else if(jobj === null || jobj === undefined){
              parsedJobj = {};
            } else{
              throw new Error("Invalid type for jobj");
            }
            $scope.server.gdS.gdspApp.jobj = angular.copy(parsedJobj);
          } catch(e){
            console.error("Invalid JSON format: " + e.message);
          }
        }
        ngDialog.close($scope.dialogId);
      }
    }

    $scope.dmbPopOpen = function(){
      $scope.dmbBrand = {sid:$scope.sid, brand:"", url:""};
      $scope.dmbBrandProcessing = false;
      $scope.dmbUserProcessing = false;
      $scope.popupLoading = true;
      $scope.curDSelected = [];
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbTab = 1;

      SettingsSrv.getDMBSettings($scope.sid).then(
        function(data){
          $scope.dmbNewUser = {sid:$scope.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
          $scope.curDMBLabels = {};
          $scope.dmbSettings = data;
          SettingsSrv.DMBDevice($scope.sid).then(
            function(data){
              $scope.popupLoading = false;
              $scope.devices = data;
            },
            function(err){
              $log.error(err);
            }
          );

          SettingsSrv.getDMBLabels($scope.sid).then(
            function(data){
              $scope.popupLoading = false;
              $scope.dmbLabels = data.settings.labels;
              $scope.curDMBLabels = data.settings.labels.et;
            },
            function(err){
              $log.error(err);
            }
          );
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/dmbSettings.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.editThemeOpen = function(url, label){
      $scope.brandLabel = label;
      $scope.hasErrPop1 = false;
      $scope.brandUrl = url;
      $scope.popupLoad = true;

      SettingsSrv.getTheme($scope.brandUrl).then(
        function(data){
          $rootScope.settingLoadingServer = false;
          $scope.theme.data = data.scss;
          $scope.popupLoad = false;
        },
        function(err){
          $log.error(err);
          $rootScope.settingLoadingServer = false;
          $scope.popupLoad = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/editTheme.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.saveTheme = function(dialog){
      $scope.saveThemeProcess = true;
      $scope.themeObj = {url:$scope.brandUrl, scss:$scope.theme.data}
      SettingsSrv.updateTheme($scope.themeObj).then(
        function(data){
          $scope.saveThemeProcess = false;
          if(data.code == 17055){
            dialog.closeThisDialog();
          }
          if(data.code == 17057){
            $scope.hasErrPop1 = true;
            $scope.errTypePop = 'tInvalid';
          }
        },
        function(err){
          $log.error(err);
          $scope.saveThemeProcess = false;
        }
      );
    }

    $scope.resetTheme = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"cm.dmb.m8" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="resetThemeFx();" focus-me="true" ng-disabled="resetThemeProcess"><span class="fa fa-repeat fa-spin" ng-if="resetThemeProcess" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.resetThemeFx = function(){
      $scope.isConfirmOpen = false;
      $scope.resetThemeProcess = true;
      SettingsSrv.resetTheme($scope.brandUrl).then(
        function(data){
          if(data.status == 'success'){
            SettingsSrv.getTheme($scope.brandUrl).then(
              function(data){
                ngDialog.close($scope.dialogId);
                $scope.resetThemeProcess = false;
                $rootScope.settingLoadingServer = false;
                $scope.theme.data = data.scss;
              },
              function(err){
                $log.error(err);
                ngDialog.close($scope.dialogId);
                $rootScope.settingLoadingServer = false;
                $scope.resetThemeProcess = false;
              }
            );
          }
        },
        function(err){
          $log.error(err);
          $rootScope.settingLoadingServer = false;
          $scope.resetThemeProcess = false;
        }
      );
    }

    $scope.dmbTab = 1;
    $scope.dmbTabFx = function(tab){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbTab = tab;
    }

    $scope.dmbBrand = {sid:$scope.sid, brand:"", url:""};
    $scope.addBrandFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dmbBrand.brand == ""){
        $scope.errTypePop = "eBrand";
        $scope.hasErrPop = true;
        $("#brand").focus();
      } else{
        $scope.dmbBrandProcessing = true;
        SettingsSrv.addBrand($scope.dmbBrand).then(
          function(data){
            $scope.dmbBrandProcessing = false;
            if(data.code == 17052){
              $scope.errTypePop = "aBrand";
              $scope.hasErrPop = true;
              $("#brand").focus();
            } else if(data.code == 17054){
              $scope.errTypePop = "aURL";
              $scope.hasErrPop = true;
              $("#url").focus();
            } else if(data.code == 17051){
              $scope.dmbSettings.brands.unshift({id:data.id, label:$scope.dmbBrand.brand, url:$scope.dmbBrand.url});
              $scope.dmbBrand = {sid:$scope.sid, brand:"", url:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbBrandProcessing = false;
          }
        );
      }
    }

    $scope.addDMBUserFx = function(){
      $scope.dmbNewUser.devices = $filter("filter")($scope.devices.devices, {selected:true});
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if($scope.dmbNewUser.label != "" && $scope.dmbNewUser.email != "" && $scope.dmbNewUser.email && $scope.dmbNewUser.pwd != "" && $scope.dmbNewUser.brand != "" && $scope.dmbNewUser.devices.length){
        $scope.dmbUserProcessing = true;
        SettingsSrv.addDMBUser($scope.dmbNewUser).then(
          function(data){
            $scope.dmbUserProcessing = false;
            if(data.code == 17049){
              $scope.hasErrPop = true;
              $scope.errTypePop = "uExist";
            } else if(data.code == 17047){
              $scope.dmbNewUser.userId = data.userId;
              $scope.dmbSettings.users.unshift($scope.dmbNewUser);
              $scope.dmbNewUser = {sid:$scope.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
            } else if(data.code == 17048){
              $scope.dmbNewUser.userId = data.userId;
              for(var i = 0;i < $scope.dmbSettings.users.length;i++){
                if($scope.dmbSettings.users[i].id === $scope.dmbNewUser.id){
                  $scope.dmbSettings.users[i] = $scope.dmbNewUser;
                }
              }
              angular.forEach($scope.devices.devices, function(device){
                if(device.selected){
                  device.selected = false;
                }
              });
              $scope.dmbNewUser = {sid:$scope.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
            }
          },
          function(err){
            $log.error(err);
            $scope.dmbUserProcessing = false;
          }
        );
      } else{
        $scope.hasErrPop = true;
        $scope.errTypePop = "eField";
      }
    }

    $scope.updateDMBLablesFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curDMBLabels.dv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t1Empty";
        $("#curDMBLabelsdv").focus();
      } else if($scope.curDMBLabels.lv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t2Empty";
        $("#curDMBLabelslv").focus();
      } else if($scope.curDMBLabels.pv == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t3Empty";
        $("#curDMBLabelspv").focus();
      } else{
        $scope.dmbLabels.et = $scope.curDMBLabels;
        $scope.dataObj = {sid:$scope.sid, labels:$scope.dmbLabels};

        $scope.updateProcessing = true;
        SettingsSrv.updateDMBLabels($scope.dataObj).then(
          function(data){
            $scope.updateProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.updateProcessing = false;
          }
        );
      }
    }

    $scope.dmbLabelsResetFx = function(){
      SettingsSrv.resetDMBLabels($scope.sid).then(
        function(data){
          $scope.updateProcessing = false;
          if(data.code == 17125){
            $scope.curDMBLabels = data.settings.et;
          }
        },
        function(err){
          $log.error(err);
          $scope.updateProcessing = false;
        }
      );
    }

    $scope.editOpen = function(obj, index){
      obj.sid = $scope.sid;
      $scope.dmbNewUser = angular.copy(obj);
      $scope.dList = angular.copy(obj.devices);
      angular.forEach($scope.devices.devices, function(d){
        d.selected = false;
      });
      angular.forEach($scope.dList, function(item){
        angular.forEach($scope.devices.devices, function(d){
          if(item.id === d.id){
            d.selected = true;
          }
        });
      });
    }

    $scope.cancelDMBUserFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dmbNewUser = {sid:$scope.sid, label:"", email:"", pwd:"", brand:"", devices:[]};
      angular.forEach($scope.devices.devices, function(d){
        d.selected = false;
      });
    }

    $scope.deleteOpen = function(caller, id, index){
      $scope.isConfirmOpen = true;
      $scope.deleteErr = false;
      $scope.dmbDeleteObj = {caller:caller, id:id, index:index};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span ng-if="dmbDeleteObj.caller==\'b\'">{{deleteErr?"cm.dmb.m5":"cm.dmb.m10" | translate}}</span>\
              <span ng-if="dmbDeleteObj.caller==\'u\'">{{"cm.dmb.m11" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="deleteFx();" focus-me="true" ng-if="!deleteErr" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm" ng-class="deleteErr?\'btn-default\':\'btn-link\'" ng-click="closeThisDialog();" data-dismiss="modal">{{deleteErr?"cm.btn.1":"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.deleteFx = function(){
      $scope.deleteProcessing = true;
      SettingsSrv.deleteDMBbu($scope.dmbDeleteObj.id, $scope.sid, $scope.dmbDeleteObj.caller).then(
        function(data){
          $scope.deleteProcessing = false;
          if($scope.dmbDeleteObj.caller == "b"){
            if(data.code == 17052){
              $scope.deleteErr = true;
            } else if(data.code == 17053){
              $scope.dmbSettings.brands.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          } else{
            if(data.code == 17050){
              $scope.dmbSettings.users.splice($scope.dmbDeleteObj.index, 1);
              ngDialog.close($scope.dialogId);
            }
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.sendPwdProcessing = false;
    $scope.sendPwdFx = function(id){
      $scope.sendPwdProcessing = true;
      SettingsSrv.sendPwd({id:id, sid:$scope.sid}).then(
        function(data){
          $scope.sendPwdProcessing = false;
          if(data.code == 17049){}
        },
        function(err){
          $scope.sendPwdProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.dmbPopFx = function(){
      $scope.popupProcessing = true;
      $scope.encodePass = {ac:btoa($scope.reverse($scope.settings.info.email + "|" + $scope.decodePass.ac)), ftp:btoa($scope.reverse($scope.settings.info.email + "|" + $scope.decodePass.ftp))};
      $scope.telexSettings.settings.telaxpassword = $scope.encodePass.ac;
      $scope.telexSettings.settings.telaxftppassword = $scope.encodePass.ftp;
      SettingsSrv.updateTelexSettings($scope.sid, $scope.telexSettings).then(
        function(data){
          $scope.popupProcessing = false;
          if(data.code == 17037){
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.popupProcessing = false;
        }
      );
    }

    $scope.meetingPopOpen = function(){
      $scope.curRoom = {label:"", floor:""};
      $scope.popupProcessing = false;
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.isAddMode = true;
      $scope.errTypePop = "";
      $scope.roomList = [];
      SettingsSrv.getCustomRoom($scope.sid).then(
        function(data){
          $scope.popupLoading = false;
          $scope.roomList = data;
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/customRoom.html',
        width:850,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.addEditRoomFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(angular.isUndefined($scope.curRoom.label) || $scope.curRoom.label == ""){
        $scope.errTypePop = "empty";
        $scope.hasErrPop = true;
      } else{
        $scope.curRoom.sId = $scope.sid;
        $scope.popupProcessing = true;
        SettingsSrv.updateCustomRoom($scope.curRoom).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17041){
              $scope.errTypePop = "exist";
              $scope.hasErrPop = true;
            } else if(data.code == 17038){
              $scope.roomList.push({label:$scope.curRoom.label, floor:$scope.curRoom.floor, id:data.id});
              $scope.curRoom = {label:"", floor:""};
            } else if(data.code == 17039){
              angular.forEach($scope.roomList, function(list){
                if($scope.curRoom.id === list.id){
                  list.id = $scope.curRoom.id;
                  list.label = $scope.curRoom.label;
                  list.floor = $scope.curRoom.floor;
                  $scope.curRoom = {label:"", floor:""};
                  $scope.isAddMode = true;
                }
              });
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }
    $scope.meetingActionFx = function(caller, obj){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dataObj = obj;
      if(caller == "e"){
        $scope.isAddMode = false;
        $scope.curRoom = angular.copy($scope.dataObj);
      } else{
        $scope.deleteProcessing = false;
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"cl.widget.meeting.m7" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="deleteRoomFx();" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }
    $scope.deleteRoomFx = function(){
      $scope.deleteProcessing = true;
      SettingsSrv.deleteCustomRoom($scope.dataObj.id).then(
        function(data){
          $scope.deleteProcessing = false;
          if(data.code == 17042){
            ngDialog.close($scope.dialogId);
            ngDialog.open({
              template:'\
                <section class="panel" role="dialog">\
                  <div class="panel-body">{{"cl.widget.meeting.m8" | translate}}</div>\
                  <footer class="panel-footer">\
                    <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                  </footer>\
                </section>',
              plain:true,
              width:500,
              scope:$scope,
              closeByDocument:false,
              className:"ngdialog-theme-default ngdialog-confirm"
            });
          } else{
            $scope.roomList.splice($scope.roomList.indexOf($scope.dataObj), 1);
            if($scope.curRoom.id){
              $scope.curRoom = {label:"", floor:""};
              $scope.isAddMode = true;
            }
            ngDialog.close($scope.dialogId);
          }
        },
        function(err){
          $log.error(err);
          $scope.deleteProcessing = false;
        }
      );
    }

    $scope.iotCPopOpen = function(){
      $scope.popupLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      SettingsSrv.getIoTCSettings($scope.sid).then(
        function(data){
          $scope.popupLoading = false;
          // $scope.iotCSettings = data;
          var keysToProcess = ['settings.admin_token_id', 'settings.application_id', 'settings.template_id'];
          $scope.iotCSettings = $scope.endeDataFx("d", data, keysToProcess);
        },
        function(err){
          $log.error(err);
          $scope.popupLoading = false;
        }
      );
      $scope.iotCPop = ngDialog.open({
        template:'app/common/popup/iotCSettings.html',
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }
    
    $scope.iotCPopFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.iotCSettings.settings.admin_token_id == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aToken";
        $("#admin_token_id").focus();
      } else if($scope.iotCSettings.settings.subdomain == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "sDomain";
        $("#subdomain").focus();
      } else if($scope.iotCSettings.settings.dns == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "dns";
        $("#dns").focus();
      } else if($scope.iotCSettings.settings.application_id == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aId";
        $("#application_id").focus();
      } else{
        $scope.popupProcessing = true;
        
        var keysToProcess = ['settings.admin_token_id', 'settings.application_id', 'settings.template_id'];

        var iotCSettings = angular.copy($scope.iotCSettings);
        iotCSettings = $scope.endeDataFx("e", $scope.iotCSettings, keysToProcess);
        SettingsSrv.updateIoTCSettings(iotCSettings).then(
          function(data){
            $scope.popupProcessing = false;
            if(data.code == 17061){
              ngDialog.close($scope.dialogId);
            }
            if(data.code == 17060){
              $scope.hasErrPop = true;
              $scope.errTypePop = "invalid";
              $("#admin_token_id").focus();
            }
          },
          function(err){
            $log.error(err);
            $scope.popupProcessing = false;
          }
        );
      }
    }

    $scope.dsOpen = function(caller){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.dsObj = {caller:caller};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 ng-if="dsObj.caller==\'dtps\'" role="heading" aria-level="1">{{"ms.label.35.12.1" | translate}}</h1>\
              <h1 ng-if="dsObj.caller==\'ot\'" role="heading" aria-level="1">{{"ms.label.35.15.1" | translate}}</h1>\
              <h1 ng-if="dsObj.caller==\'dps\'" role="heading" aria-level="1">{{"ms.label.35.9.1" | translate}}</h1>\
            </header>\
            <div class="panel-body">\
              <div ng-if="dsObj.caller == \'dtps\'">\
                <div class="form-group">\
                  <label for="dtpsc">{{"ms.label.35.12.2" | translate}} <span class="text-muted text-sm">(&deg;C)</span></label>\
                  <input type="number" id="dtpsc" class="form-control" ng-model="server.dashboard.dtpsc" min="1" aria-label="{{\'ms.label.35.12.2\' | translate}}" aria-labelledby="{{\'ms.label.35.12.2\' | translate}}" focus-me="true">\
                </div>\
                <div class="form-group noMarB">\
                  <label for="dtpsd">{{"ms.label.35.12.3" | translate}} <span class="text-muted text-sm">(&deg;C)</span></label>\
                  <input type="number" id="dtpsd" class="form-control" ng-model="server.dashboard.dtpsd" min="1" aria-label="{{\'ms.label.35.12.3\' | translate}}" aria-labelledby="{{\'ms.label.35.12.3\' | translate}}">\
                </div>\
              </div>\
              <div ng-if="dsObj.caller == \'ot\'">\
                <div class="form-group noMarB">\
                  <label for="otc">{{"ms.label.35.15.2" | translate}}</label>\
                  <input type="text" id="otc" class="form-control" ng-model="server.dashboard.otc" focus-me="true" aria-label="{{\'ms.label.35.15.2\' | translate}}" aria-labelledby="{{\'ms.label.35.15.2\' | translate}}">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success" ng-click="dsFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'caution\'" aria-live="polite" role="status">{{"ms.msg.33" | translate}}</div>\
                <div ng-if="errTypePop==\'danger\'" aria-live="polite" role="status">{{"ms.msg.34" | translate}}</div>\
                <div ng-if="errTypePop==\'cId\'" aria-live="polite" role="status">{{"ms.msg.35" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.dsFx = function(caller){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.dsObj.caller == "dtps"){
        if(!$scope.server.dashboard.dtpsc){
          $scope.hasErrPop = true;
          $scope.errTypePop = "caution";
          $("#dtpsc").focus();
        } else if(!$scope.server.dashboard.dtpsd){
          $scope.hasErrPop = true;
          $scope.errTypePop = "danger";
          $("#dtpsd").focus();
        } else{
          ngDialog.close($scope.dialogId);
        }
      } else if($scope.dsObj.caller == "ot"){
        if(!$scope.server.dashboard.otc){
          $scope.hasErrPop = true;
          $scope.errTypePop = "cId";
          $("#otc").focus();
        } else{
          ngDialog.close($scope.dialogId);
        }
      }
    }


    /*Content Storage*/
    $scope.csOpen = function(caller){
      $scope.csCopy = angular.copy($scope.server.strg);
      $scope.csObj = $scope.csCopy;

      if(!$scope.csObj.d){
        if($scope.csObj.t == "azure"){
          $scope.csObj.d = {b:"", an:"", st:""};
        }
        if($scope.csObj.t == "s3"){
          $scope.csObj.d = {b:"", ak:"", sk:"", r:""};
        }
      }
      // $scope.csObj.caller = caller;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.65.4" | translate}}</h1>\
            </header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="cst">{{"cm.label.69" | translate}}</label>\
                <select id="cst" class="form-control" ng-model="csObj.t" ng-change="csChangeFx()" aria-label="{{\'cm.label.69\' | translate}}" aria-labelledby="{{\'cm.label.69\' | translate}}" focus-me="true">\
                  <option value="azure">Azure Blob</option>\
                  <option value="s3">AWS S3</option>\
                </select>\
              </div>\
              <div ng-if="csObj.t == \'azure\'">\
                <div class="form-group">\
                  <label for="csb">{{"ms.p_s.serverPer.34.3" | translate}}</label>\
                  <input type="text" id="csb" class="form-control" ng-model="csObj.d.b" aria-label="{{\'ms.p_s.serverPer.34.3\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.3\' | translate}}">\
                </div>\
                <div class="form-group">\
                  <label for="csan">{{"ms.p_s.serverPer.66" | translate}}</label>\
                  <input type="text" id="csan" class="form-control" ng-model="csObj.d.an" aria-label="{{\'ms.p_s.serverPer.34.4\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.4\' | translate}}">\
                </div>\
                <div class="form-group noMarB">\
                  <label for="csst">{{"ms.p_s.serverPer.67" | translate}}<span class="glyphicon glyphicon-info-sign text-primary marL5" uib-tooltip="?sv=2023-01-03&si=lsquared-hub-191*********&sr=c&sig=ksq*******************************************" tooltip-append-to-body="true" tooltip-placement="right" aria-hidden="true"></span></label>\
                  <textarea id="csst" class="form-control" ng-model="csObj.d.st" ng-keydown="onKeydownFx($event)" aria-label="{{\'ms.p_s.serverPer.34.5\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.5\' | translate}}"></textarea>\
                  <!--<input type="text" id="csst" class="form-control" ng-model="csObj.d.st" aria-label="{{\'ms.p_s.serverPer.34.5\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.5\' | translate}}">-->\
                </div>\
              </div>\
              <div ng-if="csObj.t == \'s3\'">\
                <div class="form-group">\
                  <label for="csb1">{{"ms.p_s.serverPer.34.3" | translate}}</label>\
                  <input type="text" id="csb1" class="form-control" ng-model="csObj.d.b" aria-label="{{\'ms.p_s.serverPer.34.3\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.3\' | translate}}">\
                </div>\
                <div class="form-group">\
                  <label for="csak">{{"ms.p_s.serverPer.34.4" | translate}}</label>\
                  <input type="text" id="csak" class="form-control" ng-model="csObj.d.ak" aria-label="{{\'ms.p_s.serverPer.34.4\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.4\' | translate}}">\
                </div>\
                <div class="form-group">\
                  <label for="cssk">{{"ms.p_s.serverPer.34.5" | translate}}</label>\
                  <input type="text" id="cssk" class="form-control" ng-model="csObj.d.sk" aria-label="{{\'ms.p_s.serverPer.34.5\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.34.5\' | translate}}">\
                </div>\
                <div class="form-group noMarB">\
                  <label for="csr">{{"ms.p_s.serverPer.39.6" | translate}}</label>\
                  <input type="text" id="csr" class="form-control" ng-model="csObj.d.r" aria-label="{{\'ms.p_s.serverPer.39.6\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.6\' | translate}}">\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer noPadB">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="csFx();" ng-disabled="csProcessing"><span class="fa" ng-class="csProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{"ms.btn.4" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'t\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m14" | translate}}</div>\
                <div ng-if="errTypePop==\'b\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m16" | translate}}</div>\
                <div ng-if="errTypePop==\'an\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.66.m1" | translate}}</div>\
                <div ng-if="errTypePop==\'ani\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.66.m2" | translate}}</div>\
                <div ng-if="errTypePop==\'st\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.67.m1" | translate}}</div>\
                <div ng-if="errTypePop==\'sti\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.67.m2" | translate}}</div>\
                <div ng-if="errTypePop==\'ak\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m17" | translate}}</div>\
                <div ng-if="errTypePop==\'aki\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m17.1" | translate}}</div>\
                <div ng-if="errTypePop==\'sk\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m18" | translate}}</div>\
                <div ng-if="errTypePop==\'ski\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m18.1" | translate}}</div>\
                <div ng-if="errTypePop==\'r\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m7" | translate}}</div>\
                <div ng-if="errTypePop==\'invalid\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m28" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.onKeydownFx = function(event){
      if(event.key === "Enter"){
        event.preventDefault(); // Prevents the newline
      }
    }

    $scope.csChangeFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
    }
    $scope.csFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      $scope.tempCSObj = {};

      if(!$scope.csObj.t){
        $scope.hasErrPop = true;
        $scope.errTypePop = "t";
        $("#dtpsc").focus();
      }
      else if($scope.csObj.t == "azure"){
        if(!$scope.csObj.d.b){
          $scope.hasErrPop = true;
          $scope.errTypePop = "b";
          $("#csb").focus();
        } else if(!$scope.csObj.d.an){
          $scope.hasErrPop = true;
          $scope.errTypePop = "an";
          $("#csan").focus();
        } else if(!$scope.csObj.d.st){
          $scope.hasErrPop = true;
          $scope.errTypePop = "st";
          $("#csst").focus();
        } else if($scope.csObj.d.an.indexOf('*') !== -1){
          $scope.hasErrPop = true;
          $scope.errTypePop = "ani";
          $("#csan").focus();
        } else if($scope.csObj.d.st.indexOf('*') !== -1){
          $scope.hasErrPop = true;
          $scope.errTypePop = "sti";
          $("#csst").focus();
        }
        $scope.tempCSObj = {t:$scope.csObj.t, p:$scope.csObj.p, d:{b:$scope.csObj.d.b, an:$scope.csObj.d.an, st:$scope.encryptFx($scope.csObj.d.st)}};
      } else if($scope.csObj.t == "s3"){
        if(!$scope.csObj.d.b){
          $scope.hasErrPop = true;
          $scope.errTypePop = "b";
          $("#csb1").focus();
        } else if(!$scope.csObj.d.ak){
          $scope.hasErrPop = true;
          $scope.errTypePop = "ak";
          $("#csak").focus();
        } else if(!$scope.csObj.d.sk){
          $scope.hasErrPop = true;
          $scope.errTypePop = "sk";
          $("#cssk").focus();
        } else if(!$scope.csObj.d.r){
          $scope.hasErrPop = true;
          $scope.errTypePop = "r";
          $("#csr").focus();
        } else if($scope.csObj.d.ak.indexOf('*') !== -1){
          $scope.hasErrPop = true;
          $scope.errTypePop = "aki";
          $("#csak").focus();
        } else if($scope.csObj.d.sk.indexOf('*') !== -1){
          $scope.hasErrPop = true;
          $scope.errTypePop = "ski";
          $("#cssk").focus();
        }
        $scope.tempCSObj = {t:$scope.csObj.t, p:$scope.csObj.p, d:{b:$scope.csObj.d.b, ak:$scope.encryptFx($scope.csObj.d.ak), sk:$scope.encryptFx($scope.csObj.d.sk), r:$scope.csObj.d.r}};
      }

      if(!$scope.hasErrPop){
        $scope.csProcessing = true;
        MySettingsSrv.saveStorageplan({strg:$scope.tempCSObj, sid:$scope.sid}).then(
          function(data){
            $scope.csProcessing = false;
            if(data.code == 17104){
              $scope.server.strg = angular.copy($scope.csObj);
              ngDialog.close($scope.dialogId);
            } else{
            // if(data.code == 17019){
              $scope.hasErrPop = true;
              $scope.errTypePop = "invalid";
            }
          },
          function(err){
            $scope.csProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    /*EDP*/
    $scope.epdOpenFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.epdObj = angular.copy($scope.server.epdS);
      ngDialog.open({
        template:'app/common/popup/epdSettings.html',
        width:700,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.epdFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.epdObj.ep || $scope.epdObj.ep == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
        $("#ep").focus();
      } else if(!$scope.epdObj.u || $scope.epdObj.u == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "user";
        $("#user").focus();
      } else if(!$scope.epdObj.p || $scope.epdObj.p == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "pass";
        $("#pass").focus();
      } else if(!$scope.epdObj.c || $scope.epdObj.c == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "client";
        $("#client").focus();
      } else if(!$scope.epdObj.s || $scope.epdObj.s == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "clientS";
        $("#clientS").focus();
      } else{
        $scope.server.epdS = angular.copy($scope.epdObj);
        ngDialog.close($scope.dialogId);
      }
    }
    
    $scope.appMenuFx = function(){
      $scope.appMenuProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";
      if($scope.server.iTime == "" || Number($scope.server.iTime) < 1){
        $scope.hasErr = true;
        $scope.errType = "iTime";
        $("#iTime").focus();
        return false;
      } else if($scope.server.pass == ""){
        $scope.hasErr = true;
        $scope.errType = "pass";
        $("#pass").focus();
        return false;
      } else{
        $scope.appMenuProcessing = true;
        SettingsSrv.appMenu({sid:$scope.sid, iTime:$scope.server.iTime, pass:$scope.server.pass}).then(
          function(data){
            $scope.appMenuProcessing = false;
          },
          function(err){
            $scope.appMenuProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.iotBtnPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curIoTBtnCopy = angular.copy($scope.server.widgets.iotButtonS);
      $scope.curIoTBtn = $scope.server.widgets.iotButtonS;
      if(!$scope.server.widgets.iotButtonS.IoT1ClickAccKey){
        $scope.curIoTBtn.IoT1ClickAccKey = "";
      }
      if(!$scope.server.widgets.iotButtonS.IoT1ClickSecKey){
        $scope.curIoTBtn.IoT1ClickSecKey = "";
      }
      if(!$scope.server.widgets.iotButtonS.region){
        $scope.curIoTBtn.region = "";
      }
      if(!$scope.server.widgets.iotButtonS.project){
        $scope.curIoTBtn.project = "";
      }
      if($scope.server.widgets.iotButtonS.length == 0){
        $scope.curIoTBtn = {ep:'', dvcCert:'', privateKey:'', rootCACert:'', IoT1ClickAccKey:"", IoT1ClickSecKey:"", region:"", project:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.39" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="ep">{{"cl.widget.pw.27" | translate}}</label>\
                <input type="text" id="ep" class="form-control" ng-model="curIoTBtn.ep" aria-label="{{\'cl.widget.pw.27\' | translate}}" aria-labelledby="{{\'cl.widget.pw.27\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="dvcCert">{{"ms.p_s.serverPer.39.1" | translate}}<span class="text-muted text-sm">&nbsp;(*.crt)</span></label>\
                <input type="text" id="dvcCert" class="form-control" ng-model="curIoTBtn.dvcCert" aria-label="{{\'ms.p_s.serverPer.39.1\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.1\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="privateKey">{{"ms.p_s.serverPer.39.2" | translate}}<span class="text-muted text-sm">&nbsp;(*.key)</span></label>\
                <input type="text" id="privateKey" class="form-control" ng-model="curIoTBtn.privateKey" aria-label="{{\'ms.p_s.serverPer.39.2\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.2\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="rootCACert">{{"ms.p_s.serverPer.39.3" | translate}}<span class="text-muted text-sm">&nbsp;(*.pem)</span></label>\
                <input type="text" id="rootCACert" class="form-control" ng-model="curIoTBtn.rootCACert" aria-label="{{\'ms.p_s.serverPer.39.3\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.3\' | translate}}">\
              </div>\
              <h5 class="panel-inner-tab marTB10">{{"ms.p_s.serverPer.39.8" | translate}}</h5>\
              <div class="form-group">\
                <label for="iot1ClickAccKey">{{"ms.p_s.serverPer.39.4" | translate}}</label>\
                <input type="text" id="iot1ClickAccKey" class="form-control" ng-model="curIoTBtn.IoT1ClickAccKey" aria-label="{{\'ms.p_s.serverPer.39.4\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.4\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="iot1ClickSecKey">{{"ms.p_s.serverPer.39.5" | translate}}</label>\
                <input type="text" id="iot1ClickSecKey" class="form-control" ng-model="curIoTBtn.IoT1ClickSecKey" aria-label="{{\'ms.p_s.serverPer.39.5\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.5\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="region">{{"ms.p_s.serverPer.39.6" | translate}}</label>\
                <input type="text" id="region" class="form-control" ng-model="curIoTBtn.region" aria-label="{{\'ms.p_s.serverPer.39.6\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.6\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="project">{{"ms.p_s.serverPer.39.7" | translate}}</label>\
                <input type="text" id="project" class="form-control" ng-model="curIoTBtn.project" aria-label="{{\'ms.p_s.serverPer.39.7\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.7\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="iotBtnFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'ep\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'dc\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m2" | translate}}</span>\
                <span ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m3" | translate}}</span>\
                <span ng-if="errTypePop==\'rc\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m4" | translate}}</span>\
                <span ng-if="errTypePop==\'aKey\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m5" | translate}}</span>\
                <span ng-if="errTypePop==\'sKey\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m6" | translate}}</span>\
                <span ng-if="errTypePop==\'region\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m7" | translate}}</span>\
                <span ng-if="errTypePop==\'project\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m8" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.iotBtnCloseFx();
          }
        }
      });
    }
    $scope.iotBtnFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curIoTBtn.ep == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ep";
        $("#ep").focus();
      } else if($scope.curIoTBtn.dvcCert == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "dc";
        $("#dvcCert").focus();
      } else if($scope.curIoTBtn.privateKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
        $("#privateKey").focus();
      } else if($scope.curIoTBtn.rootCACert == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "rc";
        $("#rootCACert").focus();
      } else if($scope.curIoTBtn.IoT1ClickAccKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aKey";
        $("#iot1ClickAccKey").focus();
      } else if($scope.curIoTBtn.IoT1ClickSecKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "sKey";
        $("#iot1ClickSecKey").focus();
      } else if($scope.curIoTBtn.region == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "region";
        $("#region").focus();
      } else if($scope.curIoTBtn.project == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "project";
        $("#project").focus();
      } else{
        $scope.server.widgets.iotButtonS = $scope.curIoTBtn;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.iotBtnCloseFx = function(){
      $scope.server.widgets.iotButtonS = angular.copy($scope.curIoTBtnCopy);
    }

    $scope.aqsPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curQSCopy = angular.copy($scope.server.widgets.quickSightS);
      $scope.curQS = $scope.server.widgets.quickSightS;
      if(!$scope.server.widgets.quickSightS.ak){
        $scope.curQS.ak = "";
      }
      if(!$scope.server.widgets.quickSightS.sk){
        $scope.curQS.sk = "";
      }
      if(!$scope.server.widgets.quickSightS.reg){
        $scope.curQS.reg = "";
      }
      if(!$scope.server.widgets.quickSightS.aid){
        $scope.curQS.aid = "";
      }
      if(!$scope.server.widgets.quickSightS.unm){
        $scope.curQS.unm = "";
      }
      if($scope.server.widgets.quickSightS.length == 0){
        $scope.curQS = {ak:'', sk:'', reg:'', aid:'', unm:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
          <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.aqs.1" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="aqsAccKey">{{"ms.p_s.serverPer.39.4" | translate}}</label>\
                <input type="text" id="aqsAccKey" class="form-control" ng-model="curQS.ak" aria-label="{{\'ms.p_s.serverPer.39.4\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.4\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="aqsSecKey">{{"ms.p_s.serverPer.39.5" | translate}}</label>\
                <input type="text" id="aqsSecKey" class="form-control" ng-model="curQS.sk" aria-label="{{\'ms.p_s.serverPer.39.5\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.5\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="aqsRegion">{{"ms.p_s.serverPer.39.6" | translate}}</label>\
                <input type="text" id="aqsRegion" class="form-control" ng-model="curQS.reg" aria-label="{{\'ms.p_s.serverPer.39.6\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.39.6\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="accountId">{{"ms.p_s.serverPer.63" | translate}}</label>\
                <input type="text" id="accountId" class="form-control" ng-model="curQS.aid" aria-label="{{\'ms.p_s.serverPer.63\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.63\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="qsUser">{{"ms.p_s.serverPer.64" | translate}}</label>\
                <input type="text" id="qsUser" class="form-control" ng-model="curQS.unm" aria-label="{{\'ms.p_s.serverPer.64\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.64\' | translate}}">\
              </div>\
          </div>\
          <footer class="panel-footer">\
            <span class="btnQuad">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-click="aqsFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                </span>\
                <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                  <span ng-if="errTypePop==\'aKey\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m5" | translate}}</span>\
                  <span ng-if="errTypePop==\'sKey\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m6" | translate}}</span>\
                  <span ng-if="errTypePop==\'region\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m7" | translate}}</span>\
                  <span ng-if="errTypePop==\'accountId\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.63.m1" | translate}}</span>\
                  <span ng-if="errTypePop==\'qsUser\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.64.m1" | translate}}</span>\
                  </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.aqsCloseFx();
          }
        }
      });
    }
    $scope.aqsFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curQS.ak == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aKey";
        $("#aqsAccKey").focus();
      } else if($scope.curQS.sk == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "sKey";
        $("#aqsSecKey").focus();
      } else if($scope.curQS.reg == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "region";
        $("#aqsRegion").focus();
      } else if($scope.curQS.aid == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "accountId";
        $("#accountId").focus();
      } else if($scope.curQS.unm == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "qsUser";
        $("#qsUser").focus();
      }
      else{
        $scope.server.widgets.quickSightS = $scope.curQS;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.aqsCloseFx = function(){
      $scope.server.widgets.quickSightS = angular.copy($scope.curQSCopy);
    }

    $scope.qlikPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curQlikCopy = angular.copy($scope.server.widgets.qlikS);
      $scope.curQlik = $scope.server.widgets.qlikS;
      if(!$scope.server.widgets.qlikS.t){
        $scope.curQlik.t = "";
      }
      if(!$scope.server.widgets.qlikS.c){
        $scope.curQlik.c = "";
      }
      if(!$scope.server.widgets.qlikS.s){
        $scope.curQlik.s = "";
      }
      if(!$scope.server.widgets.qlikS.w){
        $scope.curQlik.w = "";
      }
      if(!$scope.server.widgets.qlikS.k){
        $scope.curQlik.k = "";
      }
      if(!$scope.server.widgets.qlikS.i){
        $scope.curQlik.i = "";
      }
      if($scope.server.widgets.qlikS.length == 0){
        $scope.curQlik = {t:"", c:"", s:"", w:"", k:"", i:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.qlik.12" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="tenant">{{\'cl.widget.qlik.10\' | translate}}</label>\
                <input type="text" id="tenant" class="form-control" ng-model="curQlik.t" aria-label="{{\'cl.widget.qlik.10\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.10\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="clientId">{{"ms.p_s.serverPer.13" | translate}}</label>\
                <input type="text" id="clientId" class="form-control" ng-model="curQlik.c" aria-label="{{\'ms.p_s.serverPer.13\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.13\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="secret">{{"ms.p_s.serverPer.14" | translate}}</label>\
                <input type="text" id="secret" class="form-control" ng-model="curQlik.s" aria-label="{{\'ms.p_s.serverPer.14\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.14\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="webID">{{"cl.widget.qlik.5" | translate}}</label>\
                <input type="text" id="webID" class="form-control" ng-model="curQlik.w" aria-label="{{\'cl.widget.qlik.5\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.5\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="keyID">{{"cl.widget.qlik.6" | translate}}</label>\
                <input type="text" id="keyID" class="form-control" ng-model="curQlik.k" aria-label="{{\'cl.widget.qlik.6\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.6\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="issuer">{{"cl.widget.qlik.7" | translate}}</label>\
                <input type="text" id="issuer" class="form-control" ng-model="curQlik.i" aria-label="{{\'cl.widget.qlik.7\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.7\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="qlikFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'tenant\'" aria-live="polite" role="status">{{"cl.widget.qlik.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'client\'" aria-live="polite" role="status">{{"cl.widget.qlik.m2" | translate}}</span>\
                <span ng-if="errTypePop==\'secret\'" aria-live="polite" role="status">{{"cl.widget.qlik.m3" | translate}}</span>\
                <span ng-if="errTypePop==\'webInt\'" aria-live="polite" role="status">{{"cl.widget.qlik.m4" | translate}}</span>\
                <span ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"cl.widget.qlik.m5" | translate}}</span>\
                <span ng-if="errTypePop==\'issuer\'" aria-live="polite" role="status">{{"cl.widget.qlik.m6" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.iotBtnCloseFx();
          }
        }
      });
    }

    $scope.qlikFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      // console.warn($scope.curQlik);
      if($scope.curQlik.t == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "tenant";
        $("#tenant").focus();
      } else if($scope.curQlik.c == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "client";
        $("#clientId").focus();
      } else if($scope.curQlik.s == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "secret";
        $("#secret").focus();
      } else if($scope.curQlik.w == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "webInt";
        $("#webID").focus();
      } else if($scope.curQlik.k == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
        $("#keyID").focus();
      } else if($scope.curQlik.i == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "issuer";
        $("#issuer").focus();
      } else{
        $scope.server.widgets.qlikS = $scope.curQlik;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.qlikCloseFx = function(){
      $scope.server.widgets.qlikS = angular.copy($scope.curQlikCopy);
    }

    // PowerBI
    $scope.pBIPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curPBICopy = angular.copy($scope.server.widgets.powerBIS);
      $scope.curPBI = $scope.server.widgets.powerBIS;
      if(!$scope.server.widgets.powerBIS.t){
        $scope.curPBI.t = "";
      }
      if(!$scope.server.widgets.powerBIS.c){
        $scope.curPBI.c = "";
      }
      if(!$scope.server.widgets.powerBIS.s){
        $scope.curPBI.s = "";
      }
      if($scope.server.widgets.powerBIS.length == 0){
        $scope.curPBI = {t:"", c:"", s:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.pBI.25" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="tenant">{{\'cl.widget.pBI.9\' | translate}}</label>\
                <input type="text" id="tenant" class="form-control" ng-model="curPBI.t" aria-label="{{\'cl.widget.pBI.9\' | translate}}" aria-labelledby="{{\'cl.widget.pBI.9\' | translate}}" autocomplete="off">\
              </div>\
              <div class="form-group">\
                <label for="clientId">{{"cl.widget.pBI.10" | translate}}</label>\
                <input type="text" id="clientId" class="form-control" ng-model="curPBI.c" aria-label="{{\'cl.widget.pBI.10\' | translate}}" aria-labelledby="{{\'cl.widget.pBI.10\' | translate}}" autocomplete="off">\
              </div>\
              <div class="form-group">\
                <label for="secret">{{"cl.widget.pBI.11" | translate}}</label>\
                <input type="text" id="secret" class="form-control" ng-model="curPBI.s" aria-label="{{\'cl.widget.pBI.11\' | translate}}" aria-labelledby="{{\'cl.widget.pBI.11\' | translate}}" autocomplete="off">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="pBIFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'tenant\'" aria-live="polite" role="status">{{"cl.widget.qlik.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'client\'" aria-live="polite" role="status">{{"cl.widget.qlik.m2" | translate}}</span>\
                <span ng-if="errTypePop==\'secret\'" aria-live="polite" role="status">{{"cl.widget.qlik.m3" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.pBICloseFx();
          }
        }
      });
    }

    $scope.pBIFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      // console.warn($scope.curPBI);
      // if($scope.curPBI.t == ""){
      //   $scope.hasErrPop = true;
      //   $scope.errTypePop = "tenant";
      //   $("#tenant").focus();
      // } else if($scope.curPBI.c == ""){
      //   $scope.hasErrPop = true;
      //   $scope.errTypePop = "client";
      //   $("#clientId").focus();
      // } else if($scope.curPBI.s == ""){
      //   $scope.hasErrPop = true;
      //   $scope.errTypePop = "secret";
      //   $("#secret").focus();
      // } else{
        $scope.server.widgets.powerBIS = $scope.curPBI;
        ngDialog.close($scope.dialogId);
      // }
    }
    $scope.pBICloseFx = function(){
      $scope.server.widgets.powerBIS = angular.copy($scope.curPBICopy);
    }

    // Grafana
    $scope.grafanaPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curGrafanaCopy = angular.copy($scope.server.widgets.grafanaS);
      $scope.curGrafana = $scope.server.widgets.grafanaS;
      if($scope.server.widgets.grafanaS.length == 0){
        $scope.curGrafana = {domain:"", token:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.grafana.5" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="domain">{{\'cl.widget.grafana.5.1\' | translate}}</label>\
                <input type="text" id="domain" class="form-control" ng-model="curGrafana.domain" placeholder="lsquared.grafana.net" aria-label="{{\'cl.widget.qlik.10\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.10\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="token">{{"cl.widget.grafana.5.2" | translate}}</label>\
                <input type="text" id="token" class="form-control" ng-model="curGrafana.token" aria-label="{{\'ms.p_s.serverPer.13\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.13\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="grafanaFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'domain\'" aria-live="polite" role="status">{{"cl.widget.grafana.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'token\'" aria-live="polite" role="status">{{"cl.widget.grafana.m2" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.grafanaCloseFx();
          }
        }
      });
    }

    $scope.grafanaFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      // console.warn($scope.curGrafana);
      if($scope.curGrafana.domain == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "domain";
        $("#domain").focus();
      } else if($scope.curGrafana.token == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "token";
        $("#token").focus();
      } else{
        $scope.server.widgets.grafanaS = $scope.curGrafana;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.grafanaCloseFx = function(){
      $scope.server.widgets.grafanaS = angular.copy($scope.curGrafanaCopy);
    }


    // verkada
    $scope.verkadaPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curVerkadaCopy = angular.copy($scope.server.widgets.verkadaS);
      $scope.curVerkada = $scope.server.widgets.verkadaS;
      if(Object.keys(($scope.server.widgets.verkadaS)).length == 0){
        $scope.curVerkada = {org_id:"", api_key:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.widget.verkada.8" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="domain">{{\'cl.widget.verkada.8.1\' | translate}}</label>\
                <input type="text" id="vorgid" class="form-control" ng-model="curVerkada.org_id" placeholder="Organization Id" aria-label="{{\'cl.widget.qlik.10\' | translate}}" aria-labelledby="{{\'cl.widget.qlik.10\' | translate}}">\
              </div>\
              <div class="form-group">\
                <label for="token">{{"cl.widget.verkada.8.2" | translate}}</label>\
                <input type="text" id="vapikey" class="form-control" ng-model="curVerkada.api_key" aria-label="{{\'ms.p_s.serverPer.13\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.13\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="verkadaFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'orgid\'" aria-live="polite" role="status">{{"cl.widget.verkada.m6" | translate}}</span>\
                <span ng-if="errTypePop==\'apikey\'" aria-live="polite" role="status">{{"cl.widget.verkada.m7" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.verkadaCloseFx();
          }
        }
      });
    }

    $scope.verkadaFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curVerkada.org_id == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "orgid";
        $("#vorgid").focus();
      } else if($scope.curVerkada.api_key == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "apikey";
        $("#vapikey").focus();
      } else{
        $scope.server.widgets.verkadaS = $scope.curVerkada;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.verkadaCloseFx = function(){
      $scope.server.widgets.verkadaS = angular.copy($scope.curVerkadaCopy);
    }

    /* watermark image */
    $scope.updateList = function(){
      $scope.contentLoading = false;
      $scope.openingLoading = false;
      $scope.breadCrumbs = [];
      $scope.folderList = [];
      $scope.tim = $scope.contentLibrary.info.timthumb;
      $scope.thumbSize = $scope.contentLibrary.info.thumbSize; //sm, n, md, lg, xl
      $scope.breadCrumbs = $scope.contentLibrary.info.breadCrumbs;
      $scope.cBucket = $scope.cDetailBucket = $scope.contentLibrary.info.bucket;
      if($scope.contentLibrary.info.mbucket && $scope.contentLibrary.info.mbucket != ""){
        $scope.cDetailBucket = $scope.contentLibrary.info.mbucket;
      }
      $scope.folderList = $scope.contentLibrary.contentLibrary.folder;
      $scope.contentList = [];
      angular.forEach($scope.contentLibrary.contentLibrary.content, function(item){
        if(item.type == "Image" || (item.splType && item.splType == "Image")){
          $scope.contentList.push(item);
        }
      });
    }
    $scope.selectContentOpen = function(){
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      $scope.advSearchInfo = {};
      $scope.advSearch = false;
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/contentLibrary/widgets/popup/selectSingleContent.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.refreshPopupListFx = function(){
      $scope.loading = true;
      $scope.contentLoading = true;
      $scope.openingLoading = true;
      $scope.useContentErr = {empty:false};
      $scope.curBg = "";
      ContentLibrarySrv.getApproved().then(
        function(data){
          $scope.contentLibrary = data;
          $scope.loading = false;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $scope.openingLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }
    $scope.folderContentFx = function(fId, splId, splType){
      $scope.contentLoading = true;
      ContentLibrarySrv.getFolderApprovedContent(fId, splId, splType).then(
        function(data){
          $scope.contentLibrary = data;
          $scope.flId = fId;
          $scope.advSearchInfo = {};
          $scope.advSearch = false;
          $scope.updateList();
        },
        function(err){
          $scope.contentLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.selectFx = function(e, caller, id, type, splId){
      $(".cl-list li.ui-selected").removeClass('ui-selected');
      if(caller == "content"){
        $(e.currentTarget).addClass("ui-selected");
        angular.forEach($scope.contentList, function(listItem){
          if(listItem.id == id){
            $scope.curBg = {
              id:listItem.id,
              fid:listItem.fid,
              extn:listItem.extn,
              type:listItem.type,
              label:listItem.label,
              thumb:listItem.thumb,
              width:listItem.width,
              height:listItem.height,
              hidden:listItem.hidden,
              splFid:listItem.splFid,
              Length:listItem.Length,
              splType:listItem.splType,
              MajorVersion:listItem.MajorVersion,
              path:$scope.contentLibrary.info.path,
              ServerRelativeUrl:listItem.ServerRelativeUrl,
              isAccessible:$scope.contentLibrary.info.isAccessible
            };
          }
        });
      } else{
        $scope.folderContentFx(id, splId, type);
      }
    }
    $scope.useContentFx = function(){
      if($scope.curBg == ""){
        $scope.useContentErr.empty = true;
      } else{
        $scope.dWMObj.wmImg = $scope.curBg;
        ngDialog.close();
      }
    }
    $scope.removeBgFx = function(){
      $scope.dWMObj.wmImg = {};
    }

    //select all assign & available devices
    $rootScope.selAllDeviceFx = function(caller, deviceList){
      deviceList.forEach(function(item){
        item.selected = true;
      })
      if(caller == "a"){
        if($scope.curDevices.assignedDevices.length){
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:$scope.curDevices.assignedDevices};
          $rootScope.dSList = $scope.curDevices.assignedDevices;
        } else{
          $rootScope.dSList = [];
          $scope.curDevices = {availableDevices:angular.copy(deviceList), assignedDevices:[]};
        }
        $rootScope.dAList = $scope.curDevices.availableDevices;
      } else{
        if($scope.curDevices.availableDevices.length){
          $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:angular.copy(deviceList)};
          $rootScope.dAList = $scope.curDevices.availableDevices;
        } else{
          $rootScope.dAList = [];
          $scope.curDevices = {availableDevices:[], assignedDevices:angular.copy(deviceList)};
        }
        $rootScope.dSList = $scope.curDevices.assignedDevices;
      }
    }
    //select/deselect single assign & available devices
    $scope.selDeviceFx = function(caller, selectedItems, deviceList){
      angular.forEach(deviceList, function(item){
        if(item.id == selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.dAList.push(item);
            } else{
              angular.forEach($rootScope.dAList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.dAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.dSList.push(item);
            } else{
              angular.forEach($rootScope.dSList, function(listItem, i){
                if(!listItem.selected || listItem.id == selectedItems.id){
                  $rootScope.dSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curDevices = {availableDevices:$rootScope.dAList, assignedDevices:$rootScope.dSList};
        }
      });
    }
    //deselect all assign & available devices
    $scope.deSelAllDeviceFx = function(caller, deviceList){
      angular.forEach(deviceList, function(item){
        item.selected = false;
      })
      if(caller == "a"){
        $rootScope.dAList = [];
        $scope.curDevices.availableDevices = [];
      } else{
        $rootScope.dSList = [];
        $scope.curDevices.assignedDevices = [];
      }
    }
    //Reset selected devices, groups and tag list
    $rootScope.resetSelDGTList = function(){
      $rootScope.resetD();
      $rootScope.resetSortingFx();
    }
    $rootScope.resetD = function(caller){
      $rootScope.dAList = [];
      $rootScope.dSList = [];
      if(caller == "add" && $scope.curDevices.assignedDevices.length){
        $scope.curDevices = {availableDevices:[], assignedDevices:$scope.curDevices.assignedDevices};
      } else if(caller == "remove" && $scope.curDevices.availableDevices.length){
        $scope.curDevices = {availableDevices:$scope.curDevices.availableDevices, assignedDevices:[]};
      } else{
        $scope.curDevices = {availableDevices:[], assignedDevices:[]};
      }
    }

    /* Cisco */
    $scope.ciscoPopOpen = function(){
      // $scope.hasErrPop = false;
      // $scope.errTypePop = "";
      // $scope.curSCopy = angular.copy($scope.server.widgets.ciscoMerakiS);
      // $scope.curCiSetting = []; //$scope.server.widgets.ciscoMerakiS

      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curCiscoCopy = angular.copy($scope.server.widgets.ciscoMerakiS);
      $scope.curCisco = $scope.server.widgets.ciscoMerakiS;
      if(!$scope.server.widgets.ciscoMerakiS.orgId){
        $scope.curCisco.orgId = "";
      }
      if(!$scope.server.widgets.ciscoMerakiS.accKey){
        $scope.curCisco.accKey = "";
      }
      if($scope.server.widgets.ciscoMerakiS.length == 0){
        $scope.curCisco = {orgId:'', accKey:''};
      }

      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-heading" role="heading" aria-level="1">{{"ms.p_s.serverPer.49" | translate}}</div>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"ms.p_s.serverPer.49.1" | translate}}</label>\
                <input type="text" class="form-control" ng-model="curCisco.orgId">\
              </div>\
              <div class="form-group">\
                <label>{{"ms.p_s.serverPer.39.4" | translate}}</label>\
                <input type="text" class="form-control" ng-model="curCisco.accKey">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="ciscoFx();"><span class="fa fa-check"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'oId\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.49.m1" | translate}}</span>\
                <span ng-if="errTypePop==\'aKey\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.39.m5" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.ciscoCloseFx();
          }
        }
      });
    }
    $scope.ciscoFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curCisco.orgId == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "oId";
      } else if($scope.curCisco.accKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "aKey";
      } else{
        $scope.server.widgets.ciscoMerakiS = $scope.curCisco;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.ciscoCloseFx = function(){
      $scope.server.widgets.ciscoMerakiS = angular.copy($scope.curCiscoCopy);
    }

    /** OLO template type */
    $scope.oloOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.oloCopy = angular.copy($scope.server.toloS);
      $scope.curOlo = $scope.server.toloS;
      if(!$scope.server.toloS.oloKey){
        $scope.curOlo.oloKey = "";
      }
      if($scope.server.toloS.length == 0){
        $scope.curOlo = {oloKey:''};
      }
      ngDialog.open({
        template:'\
          <section class="panel">\
            <header class="panel-heading">{{"t.label.31" | translate | camelCase}}</header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"t.label.31.1" | translate}}</label>\
                <input type="text" class="form-control" ng-model="curOlo.oloKey">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" class="btn btn-success btn-sm" ng-click="oloFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" class="btn btn-link btn-sm" ng-click="resetOloFx(); closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop">\
                <div ng-if="errTypePop == \'key\'">{{"t.msg.37" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.resetOloFx();
          }
        }
      });
    }
    $scope.oloFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curOlo.oloKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
      } else{
        $scope.server.toloS = $scope.curOlo;
        ngDialog.close();
      }
    }
    $scope.resetOloFx = function(){
      $scope.server.toloS = angular.copy($scope.oloCopy);
    }

    /** CoMEvents */
    $scope.comEventsOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.comEventCopy = angular.copy($scope.server.widgets.comEventS);
      $scope.curComEvent = $scope.server.widgets.comEventS;
      if(!$scope.server.widgets.comEventS.apiKey){
        $scope.curComEvent.apiKey = "";
      }
      if($scope.server.widgets.comEventS.length == 0){
        $scope.curComEvent = {apiKey:''};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading" role="heading" aria-level="1">{{"cl.widget.aNet.21" | translate | camelCase}}</header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label>{{"cl.widget.aNet.21.1" | translate}}</label>\
                <input type="text" class="form-control" ng-model="curComEvent.apiKey">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="comEventsFx();" focus-me="true" ng-disabled="saveProcessingServer"><span class="fa fa-check"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="resetComEventsFx(); closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right noMar" ng-if="hasErrPop" aria-live="polite" role="status">\
                <div ng-if="errTypePop==\'key\'" aria-live="polite" role="status">{{"cl.widget.aNet.m7" | translate}}</div>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.resetComEventsFx();
          }
        }
      });
    }
    $scope.comEventsFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curComEvent.apiKey == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "key";
      } else{
        $scope.server.widgets.comEventS = $scope.curComEvent;
        ngDialog.close();
      }
    }
    $scope.resetComEventsFx = function(){
      $scope.server.widgets.comEventS = angular.copy($scope.comEventCopy);
    }

    /** Tableau */
    $scope.tableauPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curTableauCopy = angular.copy($scope.server.widgets.tableau);
      $scope.curTableau = $scope.server.widgets.tableauS;
      if($scope.server.widgets.tableauS.length == 0){
        $scope.curTableau = {clientId:"", secretId:"",secretValue:"",contentUrl:"",serverUrl:"",userName:""};
      }
      ngDialog.open({
        template: '<section class="panel">\
            <header class="panel-heading"><h1>{{"cl.widget.tbS.4" | translate | camelCase}}</h1></header>\
            <div class="panel-body scrollQuad" ng-attr-style="max-height:{{getAvailableHeight(310)}}px">\
              <img alt="Loading" src="assets/images/loading.gif" ng-if="popupLoading">\
              <div class="row" ng-if="!popupLoading">\
                <div class="col-xs-12">\
                  <div class="form-group">\
                    <label for="clientId">{{"ms.p_s.serverPer.13" | translate}}</label>\
                    <input type="text" id="clientId" class="form-control" ng-model="curTableau.clientId" aria-label="clientId" aria-labelledby="clientId">\
                  </div>\
                  <div class="form-group">\
                    <label for="secretId">{{"cl.widget.tbS.5" | translate}}</label>\
                    <input type="text" id="secretId" class="form-control" ng-model="curTableau.secretId" aria-label="secretId" aria-labelledby="secretId">\
                  </div>\
                  <div class="form-group">\
                    <label for="secretValue">{{"cl.widget.tbS.1" | translate}}</label>\
                    <input type="text" id="secretValue" class="form-control" ng-model="curTableau.secretValue" aria-label="secretValue" aria-labelledby="secretValue">\
                  </div>\
                  <div class="form-group">\
                    <label for="contentUrl">{{"cl.widget.tbS.2" | translate}}</label>\
                    <input type="text" id="contentUrl" class="form-control" ng-model="curTableau.contentUrl" aria-label="contentUrl" aria-labelledby="contentUrl">\
                  </div>\
                  <div class="form-group">\
                    <label for="serverUrl">{{"cl.widget.tbS.3" | translate}}</label>\
                    <input type="text" id="serverUrl" class="form-control" ng-model="curTableau.serverUrl" aria-label="serverUrl" aria-labelledby="serverUrl">\
                  </div>\
                  <div class="form-group">\
                    <label for="userName">{{"cl.widget.telax.9.2" | translate}}</label>\
                    <input type="text" id="userName" class="form-control" ng-model="curTableau.userName" aria-label="userName" aria-labelledby="userName">\
                  </div>\
                </div>\
              </div>\
            </div>\
            <footer class="panel-footer" ng-if="!popupLoading">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success" ng-click="tableauSaveFx();" ng-disabled="popupProcessing"><span class="fa" ng-class="popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{popupProcessing?"cm.btn.7i":"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop">\
                <div ng-if="errTypePop == \'cId\'">{{"ms.p_s.serverPer.m4" | translate}}</div>\
                <div ng-if="errTypePop == \'cs\'">{{"cl.widget.tbS.m4" | translate}}</div>\
                <div ng-if="errTypePop == \'sv\'">{{"cl.widget.tbS.m1" | translate}}</div>\
                <div ng-if="errTypePop == \'cu\'">{{"cl.widget.tbS.m2" | translate}}</div>\
                <div ng-if="errTypePop == \'su\'">{{"cl.widget.tbS.m3" | translate}}</div>\
                <div ng-if="errTypePop == \'un\'">{{"cl.widget.jci.m2" | translate}}</div>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.sChorusCloseFx();
          }
        }
      });
    }

    $scope.tableauSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(!$scope.curTableau.clientId || $scope.curTableau.clientId == ""){
        $scope.errTypePop = "cId";
        $scope.hasErrPop = true;
        $("#clientId").focus();
      } else if(!$scope.curTableau.secretId || $scope.curTableau.secretId == ""){
        $scope.errTypePop = "cs";
        $scope.hasErrPop = true;
        $("#secretId").focus();
      } else if(!$scope.curTableau.secretValue || $scope.curTableau.secretValue == ""){
        $scope.errTypePop = "sv";
        $scope.hasErrPop = true;
        $("#secretValue").focus();
      } else if(!$scope.curTableau.contentUrl || $scope.curTableau.contentUrl == ""){
        $scope.errTypePop = "cu";
        $scope.hasErrPop = true;
        $("#contentUrl").focus();
      } else if(!$scope.curTableau.serverUrl || $scope.curTableau.serverUrl == ""){
        $scope.errTypePop = "su";
        $scope.hasErrPop = true;
        $("#serverUrl").focus();
      } else if(!$scope.curTableau.userName || $scope.curTableau.userName == ""){
        $scope.errTypePop = "un";
        $scope.hasErrPop = true;
        $("#userName").focus();
      } else{
        $scope.server.widgets.tableauS = $scope.curTableau;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.tableauCloseFx = function(){
      $scope.server.widgets.tableauS = angular.copy($scope.curTableauCopy);
    }


    $scope.setEmTypeFx = function(em){
      if(em && $scope.server.emType == ""){
        $scope.server.emType = "ls";
      }
    }

    $scope.cbPopOpen = function(){
      $scope.colorPicker = {b:false, hb:false, ht:false, mb:false, mt:false};
      $scope.cbSettingsLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      SettingsSrv.getCBSettings($scope.sid).then(
        function(data){
          $scope.cb = data;
          $scope.cbSettingsLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.cbSettingsLoading = false;
        }
      );
      ngDialog.open({
        template:'app/common/popup/cbSettings.html',
        width:1000,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.updateCBSettingsFx = function(caller){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.cb.settings.hSize == "" || $scope.cb.settings.hSize == null){
        $scope.hasErrPop = true;
        $scope.errTypePop = "hSize";
      } else if($scope.cb.settings.mSize == "" || $scope.cb.settings.mSize == null){
        $scope.hasErrPop = true;
        $scope.errTypePop = "mSize";
      } else{
        if(caller == "reset"){
          $scope.resetProcessing = true;
          $scope.cb = {
            settings:{bg:"#cc0000", bga:1,hBg:"#ffffff", hBga:1, hText:"#cc0000", hFont:{label:"Century Gothic", value:"century gothic"}, hSize:110, mBg:"#ffff00", mBga:1, mText:"#000000", mFont:{label:"Century Gothic", value:"century gothic"}, mSize:90},
            ctype:{bg:"default", hb:"monochrome", ht:"default", mb:"basic", mt:"monochrome"}
          };
          $scope.dataObj = {sid:$scope.sid, reset:true, settings:$scope.cb.settings, ctype:$scope.cb.ctype};
        } else {
          $scope.updateProcessing = true;
          $scope.dataObj = {sid:$scope.sid, settings:$scope.cb.settings, ctype:$scope.cb.ctype};
        }
        SettingsSrv.updateCBSettings($scope.dataObj).then(
          function(data){
            $scope.resetProcessing = false;
            $scope.updateProcessing = false;
            $scope.cb = {settings:data.settings, ctype:data.ctype};
            if(data.code == 17125){
              ngDialog.close($scope.cbPopup.id);
            } else {
              ngDialog.close();
            }
          },
          function(err){
            $log.error(err);
            $scope.resetProcessing = false;
            $scope.updateProcessing = false;
          }
        );
      }
    }
    $scope.resetCBSettings = function(){
      $scope.cbPopup = ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"ms.p_s.serverPer.51.m1" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="updateCBSettingsFx(\'reset\');" focus-me="true" ng-disabled="resetProcessing"><span class="fa fa-repeat fa-spin" ng-if="resetProcessing"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-link" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.filterBySchStatus = function(sch) {
      return sch.schStatus === 'a';
    };

    $scope.isPopupOpen = false;
    $scope.scheduleListOpen = function(){
      $scope.searchText = "";
      $scope.curSearch = "";
      $scope.isSorted = false;
      $scope.currentSelectFrame = 0;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.popupLoading = true;

      $scope.tempSchIDs = angular.copy($scope.selectedIDs);
      $scope.getSchedulesList(null, $scope.sid);

      $scope.schConDialog = ngDialog.open({
        template:'app/common/popup/specScheduleList.html',
        width:1200,
        data:$scope,
        scope:$scope,
        closeByDocument:false,
        preCloseCallback:function(){
          $scope.resetSchFx();
        }
      });

      $scope.isPopupOpen = true;
    }

    $scope.scheduleCheked = function(){
      $scope.selSchList = [];
      if($scope.scheduleList.length){
        $scope.scheduleList.forEach(function(sch){
          sch.selected = false;
        });
      }

      $scope.idsArr = $scope.selectedIDs.length ? $scope.selectedIDs : $scope.schExpNotifyIds;
      if($scope.idsArr.length){
        $scope.scheduleList.forEach(function(sch){
          if($scope.idsArr.includes(sch.id)){
            sch.selected = true;
          }
        });
        $scope.selSchList = $scope.scheduleList.filter(function(sch){
          if(sch.selected){
            return sch;
          }
        });
        if($scope.selSchList && $scope.selSchList.length){
          $scope.groupIds = $scope.selSchList.map(function(sch){
            if(sch.gid > 0){
              return sch.gid;
            }
            return 0;
          });
        }
        if($scope.groupList && $scope.groupList.length){
          $scope.selGroupList = $scope.groupList.filter(function(grp){
            if($scope.groupIds.includes(grp.id)){
              return grp;
            }
          });
        }
      }
    }

    $scope.getSchedulesList = function(caller, sId){
      $scope.schLoading = true;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if(caller=="refresh"){
        $scope.popupLoading = true;
        $scope.searchPopup.text = "";
        $scope.searchMsgSel = false;
        $scope.searchMsg = false;
        $scope.curSearch = "";
        $scope.tempSchIDs = $scope.selectedIDs.length ? angular.copy($scope.selectedIDs) : [];
      } else {
        // $rootScope.settingLoadingServer = true;
        // $scope.dataLoading = true;
        // $scope.loading = true;
      }
      SchedulesSrv.getAllTypeSchedules(sId).then(
        function(data){
          $scope.scheduleList = data.schedules;
          if(data.schedules.length){
            $scope.scheduleCheked();
          } else {
            $scope.selectedIDs = [];
          }

          $scope.scheduleList = data.schedules.filter(function(list){
            if(list.schStatus=='a' || list.selected){
              return list;
            }
          });

          $scope.selSchList = angular.copy($scope.scheduleList.filter(function(sch){
            if(sch.selected){
              return sch;
            }
          }));

          $scope.groupList = data.groups;
          $scope.groupList.forEach(function(grp){
            $scope.scheduleList.forEach(function(sch){
              if(grp.id == sch.gid && sch.schStatus == 'a'){
                grp.schStatus = 'a';
              }
            })
          });

          $scope.groupIds = $scope.selSchList.map(function(sch){
            if(sch.gid > 0){
              return sch.gid;
            }
            return 0;
          });

          $scope.selGroupList = angular.copy($scope.groupList.filter(function(grp){
            if($scope.groupIds.includes(grp.id)){
              return grp;
            }
          }));

          $scope.loading = false;
          $scope.popupLoading = false;
          $scope.dataLoading = false;
          $rootScope.settingLoadingServer = false;
          $scope.schLoading = false;

        },
        function(err){
          $rootScope.settingLoadingServer = false;
          $scope.popupLoading = false;
          $scope.dataLoading = false;
          $scope.loading = false;
          $log.error(err);
        }
      );
    }

    $scope.resetSchFx = function(){
      $scope.searchPopup.text = "";
      $scope.searchMsg = false;
      $scope.searchMsgSel = false;
      $scope.curSearch = "";
      if($scope.selSchList.length === 0){
        $scope.selGroupList = [];
      }
      $scope.tempSchIDs = $scope.selectedIDs.length ? angular.copy($scope.selectedIDs) : [];
      $scope.scheduleCheked();
    }

    $scope.folderFx = function(event){
      $(event.currentTarget).find('.fa-folder').toggleClass('fa-folder-open text-primary');
      $(event.currentTarget).closest(".folderQuad").children(".folder-content").toggleClass('show');
    }

    $scope.scheduleSearchFx = function(key){
      $scope.folderCount = $scope.contentCount = 0;
      $scope.selfolderCount = $scope.selContentCount = 0;
      $scope.searchMsg = false;
      $scope.searchMsgSel = false;
      $scope.searchRegExp = new RegExp(key, "gi");
      $scope.curSearch = $scope.escapeSearchText($scope.searchPopup.text);
      // $scope.curSearch = $filter('findAndReplace')($scope.searchPopup.text,"'", $scope.searchReplaceChar);

      if($("#schedule-list").length > 0){
        $scope.allFolderCount = $("#schedule-list .folderQuad").length;
        $scope.allContentCount = $("#schedule-list li").length;

        $("#schedule-list li").each(function(e){
          $scope.searchRegExp.lastIndex = 0;
          if($scope.searchRegExp.test($(this).find("div:nth-child(1)").text())){
            $(this).removeClass("sch-hide");
            $(this).show();
          } else{
            $(this).addClass("sch-hide");
            $(this).hide();
            if($(this).length){
              $scope.contentCount++;
            }
          }
        });
        $("#schedule-list .folderQuad").each(function(e){
          $scope.searchRegExp.lastIndex = 0;
          if($scope.searchRegExp.test($(this).find("a").text())){
            $(this).show();
            $(this).find("li").each(function(e){
              $(this).removeClass("sch-hide");
              $(this).show();
            })
          } else{
            $scope.allChildHidden = true;
            $(this).find("li").each(function(e){
              if(!$(this).hasClass("sch-hide")){
                $scope.allChildHidden = false;
                return false;
              }
            });
            if($scope.allChildHidden){
              $(this).hide();
            } else{
              $(this).show();
            }
            if($(this).length){
              $scope.folderCount++;
            }
          }
        });

        if(($scope.folderCount == $scope.allFolderCount) && ($scope.contentCount == $scope.allContentCount)){
          $scope.searchMsg = true;
        }
      }

      if($("#sel-schedule-list").length > 0){
        $scope.allSelFCount = $("#sel-schedule-list .folderQuad").length;
        $scope.allSelCCount = $("#sel-schedule-list li").length;

        // console.warn("length", $scope.allSelCCount);
        $("#sel-schedule-list li").each(function(e){
          $scope.searchRegExp.lastIndex = 0;
          if($scope.searchRegExp.test($(this).find("div:nth-child(1)").text())){
            $(this).removeClass("sch-hide");
            $(this).show();
          } else{
            $(this).addClass("sch-hide");
            $(this).hide();
            if($(this).length){
              $scope.selContentCount++;
            }
          }
        });
        $("#sel-schedule-list .folderQuad").each(function(e){
          $scope.searchRegExp.lastIndex = 0;
          if($scope.searchRegExp.test($(this).find("a").text())){
            $(this).show();
            $(this).find("li").each(function(e){
              $(this).removeClass("sch-hide");
              $(this).show();
            })
          } else{
            $scope.allSelChildHidden = true;
            $(this).find("li").each(function(e){
              if(!$(this).hasClass("sch-hide")){
                $scope.allSelChildHidden = false;
                return false;
              }
            });
            if($scope.allSelChildHidden){
              $(this).hide();
            } else{
              $(this).show();
            }
            if($(this).length){
              $scope.selfolderCount++;
            }
          }
        });

        if(($scope.selfolderCount == $scope.allSelFCount) && ($scope.selContentCount == $scope.allSelCCount)){
          $scope.searchMsgSel = true;
        }
      }
    }

    $scope.saveSelSchduleFx = function(){
      if($scope.tempSchIDs.length == 0){
        $scope.hasErrPop = true;
        $scope.errTypePop = "selSch";
        return;
      }
      $scope.selectedIDs = angular.copy($scope.tempSchIDs);
      if($scope.selectedIDs.length){
        $scope.selectedIDs.map(function(sel){
          $scope.scheduleList.forEach(function(sch){
            if(sch.id == sel){
              sch.selected = true;
            }
          });
        })
      }
      ngDialog.close();
    }

    $scope.selctedSchFx = function(obj, caller, event){
      $scope.selGrpIds = [];
      if($scope.selGroupList.length){
        $scope.selGrpIds = $scope.selGroupList.map(function(sg){
          return sg.gid;
        })
      }
      if(caller == "a"){
        // For group
        if(obj.gid > 0){
          $scope.groupList.forEach(function(group){
            if(group.id == obj.gid){
              // console.log($scope.selGroupList, group);
              // console.warn(!$scope.selGrpIds.includes(group.id));
              if(!$scope.selGrpIds.includes(group.id)){
                group.isSel = true;
                $scope.selGroupList.push(group);
              }
            }
          });
          if(!obj.selected){
            $scope.itemInGrp = 0;
            $scope.selSchList.filter(function(sg){
              if(sg.gid == obj.gid){
                $scope.itemInGrp++;
              }
            })
            if($scope.itemInGrp == 1){
              // var grpIndex = $scope.selGroupList.indexOf(obj);
              // $scope.selGroupList.splice(grpIndex, 1);
              $scope.selGroupList = $scope.selGroupList.filter(function(item){
                return item.gid !== obj.gid;
              })
            }
          }
        }

        // for schedules
        if(obj.selected){
          $scope.selSchList.push(obj);
        } else {
          $scope.selSchList = $scope.selSchList.filter(function(item){
            return item.id !== obj.id;
          });
        }
      } else {
        if(obj.gid > 0){
          $scope.itemInGrp = 0;
          $scope.selSchList.filter(function(sg){
            if(sg.gid == obj.gid){
              $scope.itemInGrp++;
            }
          })
          if($scope.itemInGrp == 1){
            $scope.selGroupList = $scope.selGroupList.filter(function(item){
              return item.gid !== obj.gid;
            })
          }
        }
        $scope.selSchList = $scope.selSchList.filter(function(item){
          return item.id !== obj.id;
        })

        if(!obj.selected){
          $scope.scheduleList.forEach(function(item){
            if(item.id == obj.id){
              item.selected = obj.selected;
            }
          });
        }
      }

      if(obj.selected){
        $scope.tempSchIDs.push(obj.id);
      } else {
        $scope.tempSchIDs = $scope.tempSchIDs.filter(function(item){
          return item != obj.id;
        });
      }
      setTimeout(function(){
        $scope.scheduleSearchFx($scope.searchPopup.text);
      }, 80);
      if($scope.searchPopup.text != ''){
      }
    }
    $scope.selectDateFx =  function(){
      $scope.curDPObj.creationRange = true;
      // if($scope.curDPObj.vType == "dt"){
      //   $scope.selectTimeFx();
      // }
    }
    $scope.selectTimeFx =  function(){
      // $scope.curDPObj.time = moment().format();
      $scope.curDPObj.creationTime = true;
      // if($scope.curDPObj.vType == "dt"){
      //   $scope.selectDateFx();
      // }
    }
    $scope.clearDateFx = function(){
      $scope.curDPObj.creationRange = false;
    }
    $scope.dpTypeChangeFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curDPObj.creationRange = false;
      $scope.curDPObj.creationTime = false;
    }

    $scope.acsPopOpen = function(){
      $scope.curAcsCopy = angular.copy($scope.server.acsS);
      $scope.curAcs = $scope.server.acsS;
      if(!$scope.server.acsS.vl){
        $scope.curAcs.vl = 0;
      }
      if(!$scope.server.acsS.sh){
        $scope.curAcs.sh = 0;
      }
      if(!$scope.server.acsS.sx){
        $scope.curAcs.sx = 0;
      }
      if(!$scope.server.acsS.ht){
        $scope.curAcs.ht = 0;
      }
      if(!$scope.server.acsS.strc){
        $scope.curAcs.strc = false;
      }
      if($scope.server.acsS.length == 0){
        $scope.curAcs = {vl:0, sh:0, sx:0, ht:0, strc:false};
      }
      $scope.dialogId = ngDialog.open({
        template:'app/common/popup/contentSensitivity.html',
        width:580,
        scope:$scope,
        closeByDocument:false
      });
    }
    $scope.acsFx = function(){
      $scope.server.acsS = $scope.curAcs;
      ngDialog.close($scope.dialogId);
    }

    $scope.readMeFx = function(tabName){
      $scope.readMeObj = {
        tabName:tabName
      };
      ngDialog.open({
        template:'app/common/popup/levelInfo.html',
        width:820,
        data:$scope.readMeObj,
        scope:$scope
      });
    }

    $scope.dtcPopOpen = function(){
      $scope.dtcTCopy = angular.copy($scope.server.dtcS.type);
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading">\
              <h1 role="heading" aria-level="1">{{"ms.p_s.serverPer.55.1" | translate}}</h1>\
            </header>\
            <div class="panel-body">\
              <label for="fTag" class="marL10 marT5">\
                <input type="radio" role="radio" id="fTag" aria-label="{{\'cl.widget.weather.9.1.3\' | translate}}" aria-labelledby="{{\'cl.widget.weather.9.1.3\' | translate}}" name="dtcOpt" value="f" ng-model="server.dtcS.type"><label></label>\
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="valign-sub" viewBox="0 0 16 16"><path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/></svg>\
                <span>{{\'cl.widget.weather.9.1.3\' | translate}}</span>\
              </label>\
              <label for="olTag" class="marL10 marT5">\
                <input type="radio" role="radio" id="olTag" aria-label="{{\'cl.widget.weather.9.2.1\' | translate}}" aria-labelledby="{{\'cl.widget.weather.9.2.1\' | translate}}" name="dtcOpt" value="o" ng-model="server.dtcS.type"><label></label>\
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="valign-sub" viewBox="0 0 16 16"><path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0"/><path d="M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1m0 5.586 7 7L13.586 9l-7-7H2z"/></svg>\
                <span>{{\'cl.widget.weather.9.2.1\' | translate}}</span>\
              </label>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-success btn-sm" ng-click="closeThisDialog();" focus-me="true"><span class="fa fa-check"></span>{{"cm.btn.7" | translate}}</button>\
              <button type="button" role="button" class="btn btn-sm btn-link" ng-click="dtcResetFx();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback:function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.dtcResetFx = function(){
      $scope.server.dtcS.type = $scope.dtcTCopy;
      ngDialog.close($scope.dialogId);
    }

    $scope.authIndexUrl = "";
    $scope.authorizedInder = true;
    $scope.getAuthUrlIndexer = function(isCheck){
      if(isCheck){
        SettingsSrv.getAuthUrl().then(
          function(data){
            $scope.authIndexUrl = data.url;
            $scope.authorizedInder = data.auth;
          },
          function(err){
            $log.error(err);
          }
        )
      } else{
        $scope.authIndexUrl = "";
      }
    }

    $scope.openIndexerUrlFx = function(w, h, caller){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);

      if(caller == "re"){
        $scope.popProcessing = true;
      }
      $scope.authProcessing = true;
      setTimeout(function(){
        if(caller == "re"){
          ngDialog.close($scope.confirmDialog);
        }
        $scope.popProcessing = false;
        $scope.childWindow = window.open($scope.authIndexUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
        $scope.childWindowInt = $interval($scope.checkChild, 500);
      }, 2000);
      return false;
    }

    $scope.reAuthOpenIndexer = function(caller){
      $scope.reAuthObj = caller;
      $scope.popProcessing = false;
      ngDialog.open({
        template:'\
          <section class="panel">\
            <div class="panel-body">\
              <span>{{"ms.msg.38" | translate}}</span>\
            </div>\
            <footer class="panel-footer">\
            <button type="button" class="btn btn-danger btn-sm" ng-click="openIndexerUrlFx(626, 450, reAuthObj);" focus-me="true" ng-disabled="popProcessing"><span class="fa fa-repeat fa-spin" ng-if="popProcessing"></span> {{"cm.btn.2" | translate}}</button>\
              <button type="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.checkChild = function(){
      if($scope.childWindow.closed){
        $interval.cancel($scope.childWindowInt);
        SettingsSrv.getAuthUrlCallback().then(
          function(data){
            $scope.authProcessing = false;
            if(data.code == 99007){
              $scope.authorizedInder = false;
              angular.forEach($scope.serverListArr, function(obj){
                if(obj.state == "Other Features" && obj.catagary == 'video indexer' && obj.model == 'server.vi'){
                  obj.checkBox = false;
                }
              })
              $scope.server.vi = false;
            } else{
              if(data.isClosed){
                $scope.authorizedInder = true;
              } else{
                $scope.authorizedInder = false;
                angular.forEach($scope.serverListArr, function(obj){
                  if(obj.state == "Other Features" && obj.catagary == 'video indexer' && obj.model == 'server.vi'){
                    obj.checkBox = false;
                  }
                })
                $scope.server.vi = false;
              }
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    // SharePoint Folder
    $scope.msspPopOpen = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.curMsspCopy = angular.copy($scope.server.msspS);
      $scope.curMssp = $scope.server.msspS;
      if(!$scope.server.msspS.t){
        $scope.curMssp.t = "";
      }
      if(!$scope.server.msspS.c){
        $scope.curMssp.c = "";
      }
      if(!$scope.server.msspS.s){
        $scope.curMssp.s = "";
      }
      if($scope.server.msspS.length == 0){
        $scope.curMssp = {t:"", c:"", s:""};
      }
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"cl.p_f.14.1" | translate}}</h1></header>\
            <div class="panel-body">\
              <div class="form-group">\
                <label for="tenant">{{\'ms.p_s.serverPer.15\' | translate}}</label>\
                <input type="text" id="tenant" class="form-control" ng-model="curMssp.t" aria-label="{{\'ms.p_s.serverPer.15\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.15\' | translate}}" autocomplete="off">\
              </div>\
              <div class="form-group">\
                <label for="clientId">{{"ms.p_s.serverPer.13" | translate}}</label>\
                <input type="text" id="clientId" class="form-control" ng-model="curMssp.c" aria-label="{{\'ms.p_s.serverPer.13\' | translate}}" aria-labelledby="{{\'ms.p_s.serverPer.13\' | translate}}" autocomplete="off">\
              </div>\
              <div class="form-group">\
                <label for="secret">{{"cl.widget.pBI.11" | translate}}</label>\
                <input type="text" id="secret" class="form-control" ng-model="curMssp.s" aria-label="{{\'cl.widget.pBI.11\' | translate}}" aria-labelledby="{{\'cl.widget.pBI.11\' | translate}}" autocomplete="off">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-success btn-sm" ng-click="msspFx();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.7" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(\'close\');" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </span>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errTypePop==\'tenant\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m6" | translate}}</span>\
                <span ng-if="errTypePop==\'client\'" aria-live="polite" role="status">{{"cl.widget.qlik.m2" | translate}}</span>\
                <span ng-if="errTypePop==\'secret\'" aria-live="polite" role="status">{{"ms.p_s.serverPer.m18" | translate}}</span>\
              </div>\
              <div class="clearfix"></div>\
            </footer>\
          </section>',
        plain:true,
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.msspCloseFx();
          }
        }
      });
    }

    $scope.msspFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      if($scope.curMssp.t == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "tenant";
        $("#tenant").focus();
      } else if($scope.curMssp.c == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "client";
        $("#clientId").focus();
      } else if($scope.curMssp.s == ""){
        $scope.hasErrPop = true;
        $scope.errTypePop = "secret";
        $("#secret").focus();
      } else{
        $scope.server.msspS = $scope.curMssp;
        ngDialog.close($scope.dialogId);
      }
    }
    $scope.msspCloseFx = function(){
      $scope.server.msspS = angular.copy($scope.curMsspCopy);
    }
    
    /*R&G Reports*/
    $scope.rgTabFx = function(tab){
      $scope.rgProcessing = false;
      $scope.rgHasErr = false;
      $scope.rgErrType = "";
      $scope.rgSelectedTab = tab;
      $scope.rgObj = {rType:$scope.rgSelectedTab==1?"l":$scope.rgSelectedTab==2?"cc":$scope.rgSelectedTab==3?"st":null,
        dateRange:{startDate:$scope.rgSDate, endDate:$scope.rgEDate}
      }
    }

    $scope.rgReportFx = function(){
      var caller = $scope.rgSelectedTab==1?"rgl":$scope.rgSelectedTab==2?"rgc":"rgs";
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      $scope.rgProcessing = true;
      $scope.rgHasErr = false;
      $scope.rgErrType = "";
      
      $scope.rgTempObj = {rType:$scope.rgObj.rType, sId:$scope.sid, startDate:moment($scope.rgObj.dateRange.startDate).format('YYYY-MM-DD'), endDate:moment($scope.rgObj.dateRange.endDate).format('YYYY-MM-DD')};

      SettingsSrv.rgReports(caller, $scope.rgTempObj).then(
        function(data){
          $scope.rgProcessing = false;
          if(data.code == 19016 || data.code == 18009){
            ngDialog.close();
            $scope.rgHasErr = true;
            $scope.rgErrType = "noData";
          } else if(data.code == 19017){
            ngDialog.close();
            $scope.rgHasErr = true;
            $scope.rgErrType = "dateRange";
          } else if(data.code == 19018){ //Invalid Server ID
            ngDialog.close();
            $scope.rgHasErr = true;
            $scope.rgErrType = "noData";
          } else{
            $scope.linkOpenFx('d');
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
          }
        },
        function(err){
          $log.error(err);
          $scope.rgProcessing = false;
        }
      );
      
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MySettingsController', MySettingsController);

  /** @ngInject */
  function MySettingsController($log, $rootScope, $scope, $state, $window, $cookies, $filter, $translate, $interval, ngDialog, LocalizationSrv, FileModelUploadSrv, UsersSrv, ReportsSrv, DevicesSrv, SettingsSrv, ContentLibrarySrv, MySettingsSrv, CommonSrv){
    $rootScope.selectedMenu = 22;
    $scope.selectedTab = $state.current.name;
    $scope.contactRegExp = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    $scope.splCharRegExp = new RegExp("(?=.*[!@#$%&])", "gi");
    $scope.charRegExp = /(?=.*[a-z])(?=.*[A-Z])/; // new RegExp("(?=.*[a-z])", "gi");
    $scope.numRegExp = new RegExp("(?=.*[0-9])", "gi");
    $scope.profileProcessing = false;
    $scope.fileModelLoading = false;
    $scope.pwdSplCharValid = false;
    $scope.pwdLengthValid = false;
    $scope.saveProcessing = false;
    $scope.twoFALoading = false;
    $scope.pwdCharValid = false;
    $scope.pwdNumValid = false;
    $scope.selectedServer = {};
    $scope.hasPwdErr = false;
    $scope.pwdValid = false;
    $scope.curSettings = {};
    $scope.curUsers = {availableTags:[], assignedTags:[], assignedUser:[]};
    $rootScope.tAList = [];
    $rootScope.tSList = [];
    $scope.hasErr = false;
    $scope.settings = {};
    $scope.curTwoFA = {};
    $scope.errType = "";
    $rootScope.settingsObjArr = [];
    $scope.searchServer = {text:""}
    $scope.searchAS = {text:""};

    /*Asana Integration Start*/
    $scope.getAsnConnFx = function(){
      MySettingsSrv.getAsnConn().then(
        function(data){
          $scope.settingsLoading = false;
          $scope.asnObj = data;
        },
        function(err){
          $log.error(err);
          $scope.settingsLoading = false;
        }
      );
    }
    /*Asana Integration End*/

    $scope.getSettingsFx = function(){
      $rootScope.settingsLoading = true;
      $scope.searchAS.text = "";

      /*App Switches*/
      if($scope.selectedTab == "hub.mySettings.as"){
        $scope.curASObj = {label:"", value:"", desc:""};
        $scope.settingsLoading = true;
        $scope.hasErrPop = false;
        $scope.errTypePop = "";
        MySettingsSrv.getAS().then(
          function(data){
            $scope.settingsLoading = false;
            $scope.asObj = data;
          },
          function(err){
            $log.error(err);
            $scope.settingsLoading = false;
          }
        );
      } else if($scope.selectedTab == "hub.mySettings.asana"){/*Asana Integration*/
        $scope.settingsLoading = true;
        $scope.getAsnConnFx();
      } else{
        MySettingsSrv.getSettings($scope.auth.uid).then(
          function(data){
            $scope.settingsLoading = false;
            $scope.settings = data;
            $scope.twoFAObj = $scope.settings.info.twoFA;
            $scope.twoFAObjCopy = angular.copy($scope.settings.info.twoFA);
            $scope.tim = $scope.settings.info.timthumb;
            $scope.bucket = $scope.detailBucket = $scope.settings.info.bucket;
            if($scope.settings.info.mbucket && $scope.settings.info.mbucket != ""){
              $scope.detailBucket = $scope.settings.info.mbucket;
            }
            if($scope.selectedTab == "hub.mySettings.ss"){
              $scope.settingLoading = true;
              $scope.serverSettingData = $scope.settings.roles;
              angular.forEach($scope.serverSettingData , function(value, key){
                if(value.id == $scope.auth.server){
                  $scope.sid = value.id
                  $scope.sName = value.label
                  $scope.uType = value.uType
                  $scope.scType = $scope.settings.info.scType
                  $scope.isDmb = value.isDmb
                }
              })
              $rootScope.selectedServerSetting = $scope.sName;
              $scope.settingsOpen($scope.sid,$scope.sName,$scope.uType,$scope.scType,$scope.isDmb);
              $scope.serverSearchFocus = function(){
                $scope.searchServer = {text:""}
                if($scope.serverSettingData.length > 1 && $scope.settings.roles.length > 5){
                  angular.element(document).find(".findSearch").children()[0].focus();
                }
              }
            } else if($scope.selectedTab == "hub.mySettings.pro"){
              $scope.settingsObjArr.length = 0;
            } else if($scope.selectedTab == "hub.mySettings.pre"){
              if($scope.auth.upreferences.sfdl == 0){
                $scope.uPreferences.sfdl = $scope.auth.upreferences.sfdl;
              } else{
                $scope.uPreferences.sfdl = $scope.auth.upreferences.sfdl;
              }
              if($scope.auth.upreferences.sdtf == 0){
                $scope.uPreferences.sdtf = $scope.auth.upreferences.sdtf;
              } else{
                $scope.uPreferences.sdtf = $scope.auth.upreferences.sdtf;
              }
              if($scope.auth.upreferences.sfop == 0){
                $scope.uPreferences.sfop = $scope.auth.upreferences.sfop;
              } else{
                $scope.uPreferences.sfop = $scope.auth.upreferences.sfop;
              }
              $scope.settingsObjArr.length = 0;
            } else if($scope.selectedTab == "hub.mySettings.cp"){
              $scope.settingsObjArr.length = 0;
            } else if($scope.selectedTab == "hub.mySettings.co"){
              $scope.settingsObjArr.length = 0;
              $scope.getCoordinatorsFx();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    $scope.getSettingsFx();

    /*Asana Integration Start*/
    $scope.asnAuthFx = function(){
      $scope.ansAuthProcessing = true;
      MySettingsSrv.asnAuth().then(
        function(data){
          $scope.ansAuthProcessing = false;
          if(data && data.url){
            $scope.rUrl = data.url;
            $scope.asnOpenUrlFx(600, 700);
          }
        },
        function(err){
          $log.error(err);
          $scope.ansAuthProcessing = false;
        }
      );
    }

    $scope.asnOpenUrlFx = function(w, h){
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      $scope.ansAuthProcessing = true;
      setTimeout(function(){
        $scope.asnChildWindow = window.open($scope.rUrl,'Authorize access to your account','toolbar=0,directories=no,status=0,width='+ w +',height='+ h +',top='+ top +', left='+ left);
        $scope.asnChildWindowInt = $interval($scope.asnCheckChild, 500);
      }, 2000);
      return false;
    }
    
    $scope.asnCheckChild = function(){
      if($scope.asnChildWindow.closed){
        $interval.cancel($scope.asnChildWindowInt);
        $scope.ansAuthProcessing = false;
        $scope.getAsnConnFx();
      }
    }

    $scope.asnActionOpen = function(caller, obj){
      $scope.asnCurObj = {caller:caller, id:obj.id, selected:{}, list:[]};
      $scope.asnPopLoading = true;
      $scope.hasErrAsn = false;
      $scope.errTypeAsn = "";
      $scope.hasErrAsn1 = false;
      $scope.errTypeAsn1 = "";
      if(caller == "ws"){
        MySettingsSrv.getAsnWS().then(
          function(data){
            $scope.asnPopLoading = false;
            if(data.ws.length){
              for(var i = 0; i < obj.ws.length; i++){
                for(var j = 0; j < data.ws.length; j++){
                  if(obj.ws[i].id == data.ws[j].id){
                    data.ws[j].selected = true;
                    break;
                  }
                }
              }
              $scope.asnCurObj.list = data.ws;
            }
          },
          function(err){
            $scope.asnPopLoading = false;
            $log.error(err);
          }
        );
      } else if(caller == "clf"){
        // ContentLibrarySrv.getMoveTree("/0?c=asana").then(
        ContentLibrarySrv.getMoveTree("/0").then(
          function(data){
            $scope.asnPopLoading = false;
            if(data.tree && data.tree.length){
              $scope.asnCurObj.list = data.tree;
            } else if(!data.tree || (data.tree && !data.tree.length)){
              $scope.hasErrAsn1 = true;
              $scope.errTypeAsn1 = "treeEmpty";
            }
          },
          function(err){
            $scope.asnPopLoading = false;
            $log.error(err);
          }
        );
      }
      ngDialog.open({
        template:'app/common/popup/asnActionOpen.html',
        width:500,
        scope:$scope,
        closeByDocument:false
      });
    }

    $scope.asnActionFx = function(){
      $scope.ansProProcessing = false;
      $scope.hasErrAsn = false;
      $scope.errTypeAsn = "";
      if($scope.asnCurObj.caller == "ws"){
        var selectData = $filter("filter")($scope.asnCurObj.list, {selected:true});
        // if(!selectData.length){
        //   $scope.hasErrAsn = true;
        //   $scope.errTypeAsn = "asnAction";
        //   $("#asnAction").focus();
        // } else{
          $scope.ansProProcessing = true;
          var asnCurObj = {id:$scope.asnCurObj.id, ws:selectData};
          MySettingsSrv.setAsnWS(asnCurObj).then(
            function(data){
              $scope.ansProProcessing = false;
              if(data.code == 10018){
                $scope.asnObj.auth.ws = angular.copy(asnCurObj.ws);
                ngDialog.close($scope.dialogId);
              }
            },
            function(err){
              $scope.ansProProcessing = false;
              $log.error(err);
            }
          );
        // }
      } else if($scope.asnCurObj.caller == "clf"){
        var selectData = $("input[name='treeOpt']:checked").val();
        if(!selectData){
          $scope.hasErrAsn = true;
          $scope.errTypeAsn = "asnAction";
          $("#asnAction").focus();
        } else{
          $scope.ansProProcessing = true;
          var asnCurObj = {id:$scope.asnCurObj.id, f:Number(selectData)};
          MySettingsSrv.setAsnCLF(asnCurObj).then(
            function(data){
              $scope.ansProProcessing = false;
              if(data.code == 10018){
                $scope.asnObj.auth.f = data.f;
                ngDialog.close($scope.dialogId);
              }
            },
            function(err){
              $scope.ansProProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }
    /*Asana Integration End*/


    $scope.addUser = function(caller){
      $scope.curUserObj = {type:caller};
      ngDialog.open({
        template:'app/common/popup/addToDashboard.html',
        width:710,
        scope:$scope,
        closeByDocument:false,
        controller:'AddToDashboardController',
      });
    }
      //select all assign & available tags
    $rootScope.selAllUserFx = function(caller, userList){
      userList.forEach(function(item){
        item.selected = true;
      })
      if(caller=="a"){
        if($scope.curUsers.assignedUser.length){
          $scope.curUsers = {availableUser:angular.copy(userList), assignedUser:$scope.curUsers.assignedUser};
          $rootScope.tSList = $scope.curUsers.assignedUser;
        } else{
          $rootScope.tSList = [];
          $scope.curUsers = {availableUser:angular.copy(userList), assignedUser:[]};
        }
        $rootScope.tAList = $scope.curUsers.availableUser;
      } else{
        if($scope.curUsers.availableUser.length){
          $scope.curUsers = {availableUser:$scope.curUsers.availableUser, assignedUser:angular.copy(userList)};
          $rootScope.tAList = $scope.curUsers.availableUser;
        } else{
          $rootScope.tAList = [];
          $scope.curUsers = {availableUser:[], assignedUser:angular.copy(userList)};
        }
        $rootScope.tSList = $scope.curUsers.assignedUser;
      }
    }
    //select/deselect single assign & available tags
    $scope.selUserFx = function(caller, selectedItems, userList){
      angular.forEach(userList, function(item){
        if(item.id==selectedItems.id){
          item.selected = !item.selected;
          if(caller == "a"){
            if(item.selected){
              $rootScope.tAList.push(item);
            } else{
              angular.forEach($rootScope.tAList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tAList.splice(i, 1);
                }
              });
            }
          } else if(caller == "s"){
            if(item.selected){
              $rootScope.tSList.push(item);
            } else{
              angular.forEach($rootScope.tSList, function(listItem, i){
                if(!listItem.selected || listItem.id==selectedItems.id){
                  $rootScope.tSList.splice(i, 1);
                }
              });
            }
          }
          $scope.curUsers = {availableUser:$rootScope.tAList, assignedUser:$rootScope.tSList};
        }
      });
    }
    //deselect all assign & available tags
    $scope.deSelAllUserFx = function(caller, userList){
      angular.forEach(userList, function(item){
        item.selected = false;
      })
      if(caller=="a"){
        $rootScope.dAList = [];
        $scope.curUsers.availableUser = [];
      } else{
        $rootScope.dSList = [];
        $scope.curUsers.assignedUser = [];
      }
    }

    //Reset selected devices, groups and tag list
    $scope.resetSelDGTList = function(){
      $rootScope.resetU();
      $rootScope.resetSortingFx();
    }
    $rootScope.resetU = function(caller){
      $rootScope.tAList = [];
      $rootScope.tSList = [];
      if(caller == "add" && $scope.curUsers.assignedUser.length){
        $scope.curUsers = {availableUser:[], assignedUser:$scope.curUsers.assignedUser};
      } else if(caller == "remove" && $scope.curUsers.availableUser.length){
        $scope.curUsers = {availableUser:$scope.curUsers.availableUser, assignedUser:[]};
      } else{
        $scope.curUsers = {availableUser:[], assignedUser:[]};
      }
    }


    $scope.primaryGrpOpen = function(serverId, pGrp, grp){
      $scope.primaryGrp = {};
      $scope.primaryGrp.serverId = serverId;
      $scope.primaryGrp.userGroups = grp;

      if(pGrp){
        $scope.primaryGrp.permission = "c";
        $scope.primaryGrp.userPrimGrp = pGrp;
      } else{
        $scope.primaryGrp.permission = "p";
        $scope.primaryGrp.userPrimGrp = grp[0];
      }
      ngDialog.open({
        template:'app/users/popup/primaryGrp.html',
        width:500,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.pwdValidate = function(){
      if($scope.curSettings.pass.nPass.length >= 8){
        $scope.pwdLengthValid = true;
      } else{
        $scope.pwdLengthValid = false;
      }
      if($scope.charRegExp.test($scope.curSettings.pass.nPass)){
        $scope.pwdCharValid = true;
      } else{
        $scope.pwdCharValid = false;
      }
      if($scope.numRegExp.test($scope.curSettings.pass.nPass)){
        $scope.pwdNumValid = true;
      } else{
        $scope.pwdNumValid = false;
      }
      if($scope.splCharRegExp.test($scope.curSettings.pass.nPass)){
        $scope.pwdSplCharValid = true;
      } else{
        $scope.pwdSplCharValid = false;
      }
      if($scope.pwdLengthValid && $scope.pwdCharValid && $scope.pwdNumValid && $scope.pwdSplCharValid){
        $scope.pwdValid = true;
      } else{
        $scope.pwdValid = false;
      }
    }

    $scope.defaultImgOpen = function(){
      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"ms.msg.3" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-sm btn-warning" ng-click="defaultImgFx();">{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.3" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }
    $scope.defaultImgFx = function(){
      $rootScope.fileModelUploadFx("delete");
    }
    $scope.profilePicFx = function(){
      $rootScope.fileModelUploadFx = function(data){
        if($rootScope.isFileUploading){
          $scope.preventAction();
        } else{
          $scope.fileModelLoading = true;
          FileModelUploadSrv.uploadFile("mySettings/images", data).then(
            function(data){
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              if(data.profileImg){
                $scope.auth.uimg = $scope.userImg.uImg = data.profileImg + "&a=t&h=24&w=24&q=80&zc=3";
              } else{
                $scope.settings.info.profileImg = "";
                $scope.auth.uimg = "";
              }
              $rootScope.toastNotificationFx("info", data);
              localStorage.setItem('auth', JSON.stringify($scope.auth));
              ngDialog.close();
              $state.reload();
            },
            function(err){
              $log.error(err);
              $rootScope.toastNotificationFx("danger", {"code":5000});
            }
          );
        }
      }
    }
    $scope.profilePicFx();

    $scope.settingsOpen = function(sid, sName, uType, scType, isDmb, iotButton){
      $scope.settingLoading = true;
      $scope.settingsObj = {sid:sid, label:sName, uType:uType, scType:scType, isDmb:isDmb, iotButton:iotButton};
      $scope.notify = {offlineTimeout:5};
    }


    $scope.savePrimaryGrpFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErr = false;
      $scope.curPrimaryGrp = {
        userId:$scope.auth.uid,
        serverId:$scope.primaryGrp.serverId,
        primaryGroup:null
      };
      if($scope.primaryGrp.permission == "c"){
        $scope.curPrimaryGrp.primaryGroup = $scope.primaryGrp.userPrimGrp;
      }
      UsersSrv.updatePrimaryGroup($scope.curPrimaryGrp).then(
        function(data){
          $scope.settings.roles.primaryGroup = data.primaryGroup;
          ngDialog.close();
          $state.reload();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.dColorsDefault = {
      ccs:{r:"#ff9900", ns:"#6fa8dc", d:"#6aa84f", rt:"basic", nst:"default", dt:"default"},
      ds:{on:"#6aa84f", off:"#cccccc", nc:"#adadad", ont:"default", offt:"monochrome", nct:"monochrome"},
      dts:{mp:"#6fa8dc", de:"#f1c232", webos:"#444444", tz:"#ff9900", mc:"#00ff00", geo:"#3d85c6", vd:"#e06666", epd:"#6aa84f", mpt:"default", det:"default", webost:"monochrome", tzt:"basic", mct:"basic", geot:"default", vdt:"default", epdt:"default"},
      dtps:{no:"#6aa84f", c:"#f1c232", d:"#cc0000", not:"default", ct:"default", dt:"default"},
      ot:{ot:"#6fa8dc", t:"#444444", ott:"default", tt:"monochrome"},
      ssdt:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
      ssodt:{
        mp:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        de:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        webos:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        tz:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        mc:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        geo:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        vd:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
        epd:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"}
      },
      ssdpt:{on:"#6aa84f", off:"#cccccc", ont:"default", offt:"monochrome"},
      wgws:{act:"#6aa84f", exp:"#cc0000", nw:"#adadad", actt:"default", expt:"default", nwt:"monochrome"},
    };

    $scope.colorDefaultFx = function(caller){
      if(caller == "ccs"){
        $scope.dColors.ccs = angular.copy($scope.dColorsDefault.ccs);
      }
      if(caller == "ds"){
        $scope.dColors.ds = angular.copy($scope.dColorsDefault.ds);
      }
      if(caller == "dts"){
        $scope.dColors.dts = angular.copy($scope.dColorsDefault.dts);
      }
      if(caller == "dtps"){
        $scope.dColors.dtps = angular.copy($scope.dColorsDefault.dtps);
      }
      if(caller == "ot"){
        $scope.dColors.ot = angular.copy($scope.dColorsDefault.ot);
      }
      if(caller == "ssdt"){
        $scope.dColors.ssdt = angular.copy($scope.dColorsDefault.ssdt);
      }
      if(caller == "ssodt"){
        $scope.dColors.ssodt = angular.copy($scope.dColorsDefault.ssodt);
      }
      if(caller == "ssdpt"){
        $scope.dColors.ssdpt = angular.copy($scope.dColorsDefault.ssdpt);
      }
      if(caller == "wgws"){
        $scope.dColors.wgws = angular.copy($scope.dColorsDefault.wgws);
      }
    }
    $scope.clearSettingsFx = function(caller){
      $scope.curDSetting = angular.fromJson(localStorage.getItem("curDSetting"));
      if(caller == "ccs"){
        $scope.dColors.ccs = angular.copy($scope.curDSetting.pieColors.css);
      }
      if(caller == "ds"){
        $scope.dColors.ds = angular.copy($scope.settings.dSettings.pieColors.ds);
      }
      if(caller == "dts"){
        $scope.dColors.dts = angular.copy($scope.settings.dSettings.pieColors.dts);
      }
      if(caller == "dtps"){
        $scope.dColors.dtps = angular.copy($scope.settings.dSettings.pieColors.dtps);
      }
      if(caller == "ot"){
        $scope.dColors.ot = angular.copy($scope.settings.dSettings.pieColors.ot);
      }
      if(caller == "ssdt"){
        $scope.dColors.ssdt = angular.copy($scope.settings.dSettings.pieColors.ssdt);
      }
      if(caller == "ssodt"){
        $scope.dColors.ssodt = angular.copy($scope.settings.dSettings.pieColors.ssodt);
      }
      if(caller == "wgws"){
        $scope.dColors.wgws = angular.copy($scope.dColorsDefault.wgws);
      }
      $scope.settings.dSettings = $scope.curDSetting;
    }

    $scope.dsOpen = function(type, val){
      $scope.colorPicker = {r:false, ns:false, d:false, on:false, off:false, nc:false, mp:false, de:false, webos:false, tz:false, mc:false, geo:false, vd:false, epd:false, no:false, co:false, dn:false, ot:false, to:false,
        mpOn:false, mpOff:false, deOn:false, deOff:false, webosOn:false, webosOff:false, tzOn:false, tzOff:false, mcOn:false, mcOff:false, geoOn:false, geoOff:false, vdOn:false, vdOff:false, epdOn:false, epdOff:false
      };

      $scope.dSettingsCopy = angular.copy($scope.settings.dSettings);
      localStorage.setItem('curDSetting', JSON.stringify($scope.dSettingsCopy));


      $scope.dsObj = {type:type, val:val, dps:[], ssdt:[], dpts:[], dList:[]};
      $scope.dColors = angular.copy($scope.dColorsDefault);
      $scope.dSettings = $scope.dSettingsCopy;
      $scope.dsProcessing = false;
      $scope.hasErrPop = false;
      $scope.errTypePop = "";

      if($scope.dSettings.pieColors.ccs){
        $scope.dColors.ccs = $scope.dSettings.pieColors.ccs;
      }
      if($scope.dSettings.pieColors.ds){
        $scope.dColors.ds = $scope.dSettings.pieColors.ds;
      }
      if($scope.dSettings.pieColors.dts){
        $scope.dColors.dts = $scope.dSettings.pieColors.dts;
      }
      if($scope.dSettings.pieColors.dtps){
        $scope.dColors.dtps = $scope.dSettings.pieColors.dtps;
      }
      if($scope.dSettings.pieColors.ot){
        $scope.dColors.ot = $scope.dSettings.pieColors.ot;
      }
      if($scope.dSettings.pieColors.ssdt){
        $scope.dColors.ssdt = $scope.dSettings.pieColors.ssdt;
      }
      if($scope.dSettings.pieColors.ssodt){
        $scope.dColors.ssodt = $scope.dSettings.pieColors.ssodt;
      }
      if($scope.dSettings.pieColors.ssdpt){
        $scope.dColors.ssdpt = $scope.dSettings.pieColors.ssdpt;
      }      
      if($scope.dSettings.pieColors.wgws){
        $scope.dColors.wgws = $scope.dSettings.pieColors.wgws;
      }

      if($scope.dsObj.type == "dps" || $scope.dsObj.type == "ssdt"){
        $scope.dsLoading = true;
        MySettingsSrv.getOtherInfo(type).then(
          function(data){
            $scope.dsLoading = false;
            if($scope.dsObj.type == "dps"){
              $scope.dsObj.dps = data.dps;
            } else if($scope.dsObj.type == "ssdt"){
              $scope.dsObj.ssdt = data.ssdt;
            }
          },
          function(err){
            $log.error(err);
            $scope.dsLoading = false;
          }
        );
      } else if($scope.dsObj.type == "dp"){
        $scope.dsLoading = true;
        // $scope.quadId = "dp"
        $scope.detailListObj.dp = {};
        $scope.scrollDataList.dp = [];
        $scope.allScrollDataList.dp = [];
        $scope.copyScrollObj.dp = {};
        $scope.visibleObjects.dp = [];
        $scope.haveMoreData.dp = false;
        $scope.haveMoreSearchData.dp = false;
        $scope.visibleData.dp = [];
        $scope.stIndex.dp = 0;
        $scope.etIndex.dp = 300;
        $scope.searchScroll.dp = false;
        // $scope.searchList = "";

        $scope.detailListObj.dp = {caller:'dp', offset:0, id: 0};

        DevicesSrv.getScrollListData($scope.detailListObj.dp).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData.dp = true;
            } else{
              $scope.haveMoreData.dp = false;
            }
            $scope.scrollDataList.dp = data.d;
            $scope.addStatusKey($scope.scrollDataList.dp, $scope.auth.upreferences.dot);
            $scope.allScrollDataList.dp =  angular.copy($scope.scrollDataList.dp);
            $scope.dsLoading = false;
          },
          function(err){
            $scope.dsLoading = false;
            $log.error(err);
          }
        );
        // CommonSrv.getAvailDGT("d", $scope.dsObj.type).then(
        //   function(data){
        //     $scope.dsLoading = false;
        //     $scope.dsObj.dList = data.devices;
        //     $scope.addStatusKey($scope.dsObj.dList, $scope.auth.upreferences.dot);
        //     $scope.addTypeKey($scope.dsObj);
        //   },
        //   function(err){
        //     $log.error(err);
        //     $scope.dsLoading = false;
        //   }
        // );
      } else if($scope.dsObj.type == "dpts" || $scope.dsObj.type == "ssdpt"){
        $scope.dsLoading = true;
        MySettingsSrv.getDPS($scope.dsObj.type).then(
          function(data){
            $scope.dsLoading = false;
            if($scope.dsObj.type == "dpts"){
              $scope.dsObj.dpts = data.dpts;
            } else{
              $scope.dsObj.ssdpt = data.ssdpt;
            }
          },
          function(err){
            $log.error(err);
            $scope.dsLoading = false;
          }
        );
      }

      ngDialog.open({
        template:"app/common/popup/dashbordSettings.html",
        width:480,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        preCloseCallback:function(caller){
          if(caller){
            $scope.dsCloseFx();
            $scope.clearSettingsFx($scope.dsObj.type);
          }
        }
      });
    }

    $scope.savePieColors = function(){
      $scope.dsProcessing = true;
      MySettingsSrv.savePieColors($scope.pieColorObj).then(
        function(data){
          $scope.dsProcessing = false;
          if($scope.dsObj.type == "ccs"){
            $scope.settings.dSettings.pieColors.ccs = $scope.dColors.ccs;
          }
          if($scope.dsObj.type == "ds"){
            $scope.settings.dSettings.pieColors.ds = $scope.dColors.ds;
          }
          if($scope.dsObj.type == "dts"){
            $scope.settings.dSettings.pieColors.dts = $scope.dColors.dts;
          }
          if($scope.dsObj.type == "dtps"){
            $scope.settings.dSettings.pieColors.dtps = $scope.dColors.dtps;
          }
          if($scope.dsObj.type == "ot"){
            $scope.settings.dSettings.pieColors.ot = $scope.dColors.ot;
          }
          if($scope.dsObj.type == "ssdt"){
            $scope.settings.dSettings.pieColors.ssdt = $scope.dColors.ssdt;
          }
          if($scope.dsObj.type == "ssodt"){
            $scope.settings.dSettings.pieColors.ssodt = $scope.dColors.ssodt;
          }
          if($scope.dsObj.type == "ssdpt"){
            $scope.settings.dSettings.pieColors.ssdpt = $scope.dColors.ssdpt;
          }
          if($scope.dsObj.type == "wgws"){
            $scope.settings.dSettings.pieColors.wgws = $scope.dColors.wgws;
          }
          ngDialog.close();
          localStorage.removeItem("curDSetting");
        },
        function(err){
          $scope.dsProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.dsSaveFx = function(){
      $scope.hasErrPop = false;
      $scope.errTypePop = "";
      $scope.pieColorObj = "";
      if($scope.dsObj.type == "ccs"){
        $scope.pieColorObj = {type:"ccs", data:$scope.dColors.ccs};
      }
      if($scope.dsObj.type == "ds"){
        $scope.pieColorObj = {type:"ds", data:$scope.dColors.ds};
      }
      if($scope.dsObj.type == "dts"){
        $scope.pieColorObj = {type:"dts", data:$scope.dColors.dts};
      }
      if($scope.dsObj.type == "dtps"){
        $scope.pieColorObj = {type:"dtps", data:$scope.dColors.dtps};
      }
      if($scope.dsObj.type == "ot"){
        $scope.pieColorObj = {type:"ot", data:$scope.dColors.ot};
      }
      if($scope.dsObj.type == "ssdt"){
        $scope.pieColorObj = {type:"ssdt", data:$scope.dColors.ssdt};
      }
      if($scope.dsObj.type == "ssodt"){
        $scope.pieColorObj = {type:"ssodt", data:$scope.dColors.ssodt};
      }
      if($scope.dsObj.type == "ssdpt"){
        $scope.pieColorObj = {type:"ssdpt", data:$scope.dColors.ssdpt};
      }
      if($scope.dsObj.type == "dp"){
        $scope.pieColorObj = {type:"dp", data:$scope.settings.dSettings.dp};
      }
      if($scope.dsObj.type == "rad"){
        $scope.pieColorObj = {type:"rad", data:$scope.settings.dSettings.rad};
      }
      if($scope.dsObj.type == "wgws"){
        $scope.pieColorObj = {type:"wgws", data:$scope.dColors.wgws};
      }

      if($scope.dsObj.type == "ssdt"){
        angular.forEach($scope.dsObj.ssdt, function(item){
          item.selected = false;
          if($filter("filter")(item.values, {selected:true}).length){
            item.selected = true;
          }
        });
      }

      if($scope.dsObj.type == "dps" && !$filter("filter")($scope.dsObj.dps, {selected:true}, true).length){
        $scope.hasErrPop = true;
        $scope.errTypePop = "empty";
        $("#otherInfo").focus();
      } else if($scope.dsObj.type == "dpts" && !$filter("filter")($scope.dsObj.dpts, {selected:true}, true).length){
        $scope.hasErrPop = true;
        $scope.errTypePop = "empty";
        $("#properties").focus();
      } else if($scope.dsObj.type == "dps" || $scope.dsObj.type == "ssdt"){
        $scope.dsProcessing = true;
        MySettingsSrv.saveOtherInfo($scope.dsObj).then(
          function(data){
            $scope.dsProcessing = false;
            ngDialog.close();
            $scope.savePieColors();
            if(data.code == 17071 || data.code == 17072){
            }
          },
          function(err){
            $log.error(err);
            $scope.dsProcessing = false;
          }
        );
      } else if($scope.dsObj.type == "dp" && !$scope.settings.dSettings.dp){
        $scope.hasErrPop = true;
        $scope.errTypePop = "dpEmpty";
      } else if($scope.dsObj.type == "ssodt" && !$scope.settings.dSettings.ssodt.mp && !$scope.settings.dSettings.ssodt.desktop && !$scope.settings.dSettings.ssodt.webos && !$scope.settings.dSettings.ssodt.tizen && !$scope.settings.dSettings.ssodt.mc && !$scope.settings.dSettings.ssodt.gf && !$scope.settings.dSettings.ssodt.v){
        $scope.hasErrPop = true;
        $scope.errTypePop = "ssodtEmpty";
        $("#statusSummary").focus();
      } else if($scope.dsObj.type == "dpts" || $scope.dsObj.type == "ssdpt"){
        $scope.dsProcessing = true;
        MySettingsSrv.saveDPS($scope.dsObj).then(
          function(data){
            $scope.dsProcessing = false;
            ngDialog.close();
            $scope.savePieColors();
          },
          function(err){
            $log.error(err);
            $scope.dsProcessing = false;
          }
        );
      } else{
        $scope.savePieColors();
      }
    }

    $scope.singleSelectFx = function(){
      $scope.settings.dSettings.dp = angular.fromJson($scope.settings.dSettings.dp);
      $scope.settings.dSettings.dp.label = $scope.settings.dSettings.dp.l;
    }

    $scope.dsCloseFx = function(){
      $scope.settings.dSettings = angular.copy($scope.dSettingsCopy);
    }

    $scope.settingFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        if($scope.settings.info.fName == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#fName").focus();
        } else if($scope.settings.info.lName == ""){
          $scope.errType = "name";
          $scope.hasErr = true;
          $("#lName").focus();
        } else if($scope.settings.info.contact && (!$scope.contactRegExp.test($scope.settings.info.contact) || $scope.settings.info.contact.length < 10)){
          $scope.errType = "contact";
          $scope.hasErr = true;
          $("#tel").focus();
        } else{
          $scope.profileProcessing = true;
          MySettingsSrv.updateSettings($scope.settings.info).then(
            function(data){
              $scope.auth = angular.fromJson(localStorage.getItem("auth"));
              $scope.auth.uname = $scope.settings.info.fName + " " + $scope.settings.info.lName;
              $scope.auth.defaultTimezone = $scope.settings.info.timezone;
              $scope.auth.cn = $scope.settings.info.contact;
              $scope.auth.lang = $scope.settings.info.lang;
              localStorage.setItem('auth', JSON.stringify($scope.auth));

              /*Localization*/
              if($scope.auth.lang != angular.fromJson(localStorage.getItem("authLang"))){
                LocalizationSrv.getLocalization($scope.auth.lang).then(
                  function(data){
                    localStorage.setItem("authLang", JSON.stringify($scope.auth.lang));
                    localStorage.setItem("lang", JSON.stringify(data));
                    $window.location.reload();
                  },
                  function(err){
                    $log.error(err);
                  }
                );
              } else{
                $state.reload();
              }
              $scope.profileProcessing = false;
            },
            function(err){
              $log.error(err);
              $scope.profileProcessing = false;
            }
          );
        }
      }
    }
    $scope.getTwoFAFx = function(){
      $scope.twoFALoading = true;
      MySettingsSrv.getTwoFA().then(
        function(data){
          $scope.twoFALoading = false;
          $scope.twoFAObj = data.twoFA;
          $scope.timestamp = moment().format('x');
        },
        function(err){
          $scope.twoFALoading = false;
          $log.error(err);
        }
      );
    }

    $scope.twoFAFx = function(caller){
      $scope.saveProcessing = false;
      $scope.hasErr = false;
      $scope.errType = "";

      if($scope.twoFAObjCopy.is2fa && caller == "d"){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">{{"ms.msg.28" | translate}}</div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="twoFAFx(\'s\');" ng-disabled="saveProcessing"><span class="fa" ng-class="saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog(); resetFx();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        $scope.curTwoFA.is2fa = $scope.twoFAObj.is2fa;
        $scope.curTwoFA.secret = $scope.twoFAObj.secret;

        if($scope.curTwoFA.is2fa && $scope.curTwoFA.otp == ""){
          $scope.hasErr = true;
          $scope.errType = "optEmpty";
        } else if(($scope.twoFAObjCopy.is2fa && caller == "d") || caller == "s"){
          $scope.saveProcessing = true;

          // $scope.hubEnc = function(){
          //   $scope.otpEnc = $scope.auth.email+"|"+$scope.curTwoFA.otp;
          //   return btoa($scope.reverse($scope.otpEnc));
          // }

          $scope.encTwoFA = angular.copy($scope.curTwoFA);
          var secret = $scope.decryptFx($scope.encTwoFA.secret);
          $scope.encTwoFA.secret = $scope.encryptFx(secret);
          $scope.encTwoFA.otp = $scope.encryptFx($scope.encTwoFA.otp);

          MySettingsSrv.updateTwoFA($scope.encTwoFA).then(
            function(data){
              $scope.saveProcessing = false;
              if(data.code == 13041 || data.code == 1000){
                $scope.hasErr = true;
                $scope.errType = "opt";
              } else{
                ngDialog.close();
                $scope.twoFAObjCopy = angular.copy($scope.curTwoFA);
                $scope.curTwoFA.otp = "";
              }
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
        }
      }
    }

    $scope.resetFx = function(){
      $scope.twoFAObj.is2fa = angular.copy($scope.twoFAObjCopy.is2fa);
      $scope.curTwoFA.otp = "";
    }

    $scope.setUpOpen = function(){
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading"><h1 role="heading" aria-level="1">{{"ms.p_setup.1" | translate}}</h1></header>\
            <div class="panel-body">\
              <h5>{{"ms.p_setup.2" | translate}}</h5>\
              <ol>\
                <li>{{"ms.p_setup.2.1" | translate}}</li>\
                <li>{{"ms.p_setup.2.2" | translate}}</li>\
                <li>{{"ms.p_setup.2.3" | translate}}</li>\
              </ol>\
              <h5>{{"ms.p_setup.3" | translate}}</h5>\
              <ol>\
                <li>{{"ms.p_setup.3.1" | translate}}</li>\
                <li>{{"ms.p_setup.3.2" | translate}}</li>\
                <li>{{"ms.p_setup.3.3" | translate}}</li>\
              </ol>\
              <p>{{"ms.p_setup.4" | translate}}</p>\
            </div>\
            <div class="panel-footer">\
              <span class="btnQuad">\
                <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
              </span>\
              <div class="clearfix"></div>\
            </div>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default"
      });
    }

    $scope.changeConfirmOpen = function(caller){
      $scope.dataObj = caller;
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">\
              <span class="text-bold text-success">{{dataObj == "email"?"ms.msg.10":"ms.msg.11" | translate}}</span>\
              <br>\
              {{dataObj == "email"?"ms.msg.10.1":"ms.msg.11.1" | translate}}\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="logOutFx();">{{"cm.btn.1" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.curSettings.email = {};
    $scope.emailOpen = function(caller){
      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        if(caller == "confirm"){
          ngDialog.open({
            template:'\
              <section class="panel" role="dialog">\
                <div class="panel-body" translate="{{\'ms.msg.4\'}}" translate-values="{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}"></div>\
                <footer class="panel-footer">\
                  <button type="button" role="button" class="btn btn-primary btn-sm" ng-click="emailOpen();"><span class="fa fa-check" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
                </footer>\
              </section>',
            plain:true,
            width:500,
            scope:$scope,
            closeByDocument:false,
            className:"ngdialog-theme-default ngdialog-confirm"
          });
        } else{
          $scope.hasErrPop = false;
          $scope.errType = "";
          ngDialog.close();
          $scope.curSettings.email = $scope.settings.info.email;
          MySettingsSrv.updateEmail({}).then(
            function(data){
              $scope.saveProcessing = false;
              $scope.curSettings.email = {};
            },
            function(err){
              $log.error(err);
              $scope.saveProcessing = false;
            }
          );
          ngDialog.open({
            template:'app/common/popup/email.html',
            width:500,
            scope:$scope,
            closeByDocument:false,
          });
        }
      }
    }

    $scope.emailFx = function(){
      $scope.saveProcessing = true;
      $scope.hasErrPop = false;
      $scope.errType = "";
      if(!$scope.curSettings.email.newEmail || $scope.curSettings.email.newEmail == "" || $scope.curSettings.email.newEmail === undefined){
        $scope.saveProcessing = false;
        $scope.hasErrPop = true;
        $scope.errType = "email";
        $("#newEmail").focus();
      } else if(!$scope.curSettings.email.vCode || $scope.curSettings.email.vCode == ""){
        $scope.saveProcessing = false;
        $scope.hasErrPop = true;
        $scope.errType = "vCodeEmpty";
        $("#vCode").focus();
      } else{
        MySettingsSrv.updateEmail($scope.curSettings.email).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 13023){
              $scope.hasErrPop = true;
              $scope.errType = "email";
              $("#newEmail").focus();
            } else if(data.code == 17009){
              $scope.hasErrPop = true;
              $scope.errType = "vCode";
              $("#vCode").focus();
            } else if(data.code == 17013){
              $scope.hasErrPop = true;
              $scope.errType = "userExist";
              $("#newEmail").focus();
            } else if(data.code == 17014){
              $scope.hasErrPop = true;
              $scope.errType = "same";
              $("#newEmail").focus();
            } else if(data.code == 17004){
              ngDialog.close();
              $scope.curSettings.email = {};
              $scope.changeConfirmOpen("email");
            }
          },
          function(err){
            $log.error(err);
            $scope.saveProcessing = false;
          }
        );
      }
    }

    $scope.tabLoading = false;
    $scope.makeLoading = false;
    $scope.makeProcessing = false;
    $scope.searchProcessing = false;
    $scope.makeConfirmProcessing = false;
    $scope.getCoordinatorsFx = function(caller){
      if(caller == "tab"){
        $scope.tabLoading = true;
      } else{
        $scope.makeLoading = true;
      }
      MySettingsSrv.getCoordinators().then(
        function(data){
          $scope.makeLoading = false;
          $scope.tabLoading = false;
          $rootScope.coordinators = data;
        },
        function(err){
          $scope.makeLoading = false;
          $scope.tabLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.loadSelectedTab = function(caller){
      $scope.settingsLoading = true;
      $scope.userText = {search:""};
      $scope.hasPwdErr = false;
      $scope.searchedUser = "";
      $scope.searchTxt = "";
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.timestamp = moment().format('x');
      if($scope.selectedTab == "hub.mySettings.pro"){
        $scope.settingsLoading = false;
        $scope.settingsObjArr.length = 0;
        $scope.profilePicFx();
      } else if($scope.selectedTab == "hub.mySettings.pre"){
        $scope.settingsObjArr.length = 0;
        $scope.getSettingsFx();
      } else if($scope.selectedTab == "hub.mySettings.ss"){
        $scope.serverSettingData = $scope.settings.roles;
        angular.forEach($scope.serverSettingData, function(value, key){
          if(value.id == $scope.auth.server){
            $scope.sid = value.id
            $scope.sName =value.label
            $scope.uType = value.uType
            $scope.scType = $scope.settings.info.scType
            $scope.isDmb = value.isDmb
          }
        })
        $scope.settingsLoading = false;
        $rootScope.selectedServerSetting = $scope.sName
        $scope.settingsOpen($scope.sid,$scope.sName,$scope.uType,$scope.scType,$scope.isDmb)
      } else if($scope.selectedTab == "hub.mySettings.co"){
        $scope.settingsObjArr.length = 0;
        $scope.getCoordinatorsFx("tab");
      } else if($scope.selectedTab == "hub.mySettings.cp"){
        $scope.settingsLoading = false;
        $scope.settingsObjArr.length = 0;
        $scope.curSettings = {pass:{curPass:"", nPass:"", cPass:""}};
      } else if($scope.selectedTab == "hub.mySettings.as"){
        $scope.settingsLoading = false;
        $scope.getSettingsFx();
      } else if($scope.selectedTab == "hub.mySettings.asana"){
        $scope.settingsLoading = false;
        $scope.getSettingsFx();
      }
    }
    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
    });

    $scope.getUserFx = function(){
      $scope.curCoordin = {selected:null};
      $scope.searchedUser = "";
      $scope.errType = "";
      if($scope.userText.search == "" || $scope.userText.search == undefined){
        $scope.errType = "empty";
      } else{
        $scope.searchProcessing = true;
        MySettingsSrv.getUser($scope.userText).then(
          function(data){
            $scope.searchProcessing = false;
            if(data.code == 17030){
              $scope.errType = "notFound";
            } else if(data.code == 17031){
              $scope.errType = "already";
            } else{
              $scope.searchedUser = data.user;
            }
          },
          function(err){
            $log.error(err);
            $scope.searchProcessing = false;
          }
        );
      }
    }

    $scope.curCoordin = {selected:null};
    $scope.makeCoordinatorOpen = function(caller, obj){
      if(caller == "a"){
        $scope.curServer = {available:[], assigned:[], scType:obj, caller:caller};
      } else{
        $scope.curServer = {available:[], assigned:[], scType:obj.role, id:obj.id, caller:caller};
      }
      $scope.makePopObj = {isEmail:false};
      $scope.curServerModel = {};
      $scope.popupLoading = true;
      MySettingsSrv.getServersList().then(
        function(data){
          $scope.serversList = data;
          $scope.curServer.available = angular.copy($scope.serversList);
          if(caller == "e"){
            $scope.listManipulateFx("add", $scope.curServer.available, $scope.curServer.assigned, obj.servers);
          }
          $scope.popupLoading = false;
        },
        function(err){
          $scope.popupLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:'app/common/popup/ssList.html',
        width:710,
        scope:$scope,
        closeByDocument:false,
      });
    }

    $scope.makeUserCoordinatorFx = function(confirm){
      if(confirm){
        $scope.makeConfirmProcessing = true;
      } else{
        $scope.makeProcessing = true;
      }
      if($scope.curServer.caller == "a"){
        MySettingsSrv.makeUserCoordinator({id:$scope.curCoordin.selected.id, isConfirmed:confirm, scType:$scope.curServer.scType, servers:$scope.curServer.assigned}).then(
          function(data){
            $scope.makeConfirmProcessing = false;
            $scope.makeProcessing = false;
            $scope.makeObj = data;
            ngDialog.close();
            if(data.code == 17028 || data.code == 17033){
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">\
                      {{makeObj.code == "17028"?"ms.msg.23":"ms.msg.26" | translate}}\
                      <div class="table no-th marT20 scrollQuad" style="max-height:{{getAvailableHeight(400)}}px">\
                        <div class="row" ng-repeat="server in makeObj.server">\
                          <div class="col-xs-12 word-break">{{server.label}}</div>\
                        </div>\
                      </div>\
                      <div class="marT15" ng-if="makeObj.code == \'17033\'">{{"ms.msg.26.1" | translate}}</div>\
                    </div>\
                    <footer class="panel-footer">\
                      <button type="button" role="button" class="btn btn-success btn-sm" ng-if="makeObj.code == \'17028\'" ng-click="makeUserCoordinatorFx(true);" ng-disabled="makeConfirmProcessing"><span ng-class="makeConfirmProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'" aria-hidden="true"></span>{{"u.btn.9" | translate}}</button>\
                      <button type="button" role="button" ng-class="makeObj.code == \'17033\'?\'btn btn-default\':\'btn-link\'" ng-click="closeThisDialog();" data-dismiss="modal">{{makeObj.code == \'17033\'?"cm.btn.10":"cm.btn.9" | translate}}</button>\
                    </footer>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                closeByEscape:false,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            } else if(data.code == 17029){
              $scope.userText = {search:""};
              $scope.getCoordinatorsFx();
              $scope.searchedUser = "";
            }
          },
          function(err){
            $scope.makeConfirmProcessing = false;
            $scope.makeProcessing = false;
            $log.error(err);
          }
        );
      } else{
        MySettingsSrv.editUserCoordinator({id:$scope.curServer.id, isConfirmed:confirm, scType:$scope.curServer.scType, servers:$scope.curServer.assigned}).then(
          function(data){
            $scope.makeConfirmProcessing = false;
            $scope.makeProcessing = false;
            if(data.code == 17046){
              $scope.userText = {search:""};
              $scope.getCoordinatorsFx();
              $scope.searchedUser = "";
              ngDialog.close();
            }
          },
          function(err){
            $scope.makeConfirmProcessing = false;
            $scope.makeProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.userTextChange = function(){
      $scope.errType = "";
    }
    $scope.clearSearchFx = function(){
      $scope.userText = {search:""};
      $scope.searchedUser = "";
      $scope.errType = "";
    }

    $scope.removeCoordinatorOpen = function(id, role){
      $scope.deleteObj = {id:id, role:role};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <div class="panel-body">{{"ms.msg.24" | translate}}</div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="removeCoordinatorFx();" ng-disabled="deleteProcessing"><span class="fa fa-repeat fa-spin" ng-if="deleteProcessing" aria-hidden="true"></span>{{"cm.btn.2" | translate}}</button>\
              <button type="button" role="button" class="btn-link" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
            </footer>\
          </section>',
        plain:true,
        width:500,
        scope:$scope,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-confirm"
      });
    }

    $scope.removeCoordinatorFx = function(){
      $scope.deleteProcessing = true;
      MySettingsSrv.deleteCoordinator($scope.deleteObj.id, $scope.deleteObj.role).then(
        function(data){
          $scope.deleteProcessing = false;
          $scope.getCoordinatorsFx();
          ngDialog.close();
        },
        function(err){
          $scope.deleteProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.updatePassFx = function(){
      $scope.saveProcessing = false;
      $scope.hasPwdErr = false;
      $scope.errType = "";

      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        if($scope.curSettings.pass.curPass == ""){
          $scope.hasPwdErr = true;
          $scope.errType = "form";
          $("#curPass").focus();
        } else if($scope.curSettings.pass.nPass == ""){
          $scope.hasPwdErr = true;
          $scope.errType = "form";
          $("#nPass").focus();
        } else if($scope.curSettings.pass.cPass == ""){
          $scope.hasPwdErr = true;
          $scope.errType = "form";
          $("#cPass").focus();
        } else if($scope.curSettings.pass.nPass != $scope.curSettings.pass.cPass){
          $scope.hasPwdErr = true;
          $scope.errType = "match";
          $("#cPass").focus();
        } else if($scope.curSettings.pass.curPass == $scope.curSettings.pass.nPass){
          $scope.hasPwdErr = true;
          $scope.errType = "oldNew";
          $("#nPass").focus();
        } else if(!$scope.pwdValid){
          $scope.hasPwdErr = true;
          $scope.errType = "invalid";
          $("#nPass").focus();
        } else{
          $scope.saveProcessing = true;

          // $scope.encodePass = {c:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.curSettings.pass.curPass)), n:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.curSettings.pass.nPass)), nc:btoa($scope.reverse($scope.settings.info.email+"|"+$scope.curSettings.pass.cPass))};
          // MySettingsSrv.updatePass({curPass:$scope.encodePass.c, nPass:$scope.encodePass.n, cPass:$scope.encodePass.nc}).then(

          MySettingsSrv.updatePass({curPass:$scope.encryptFx($scope.curSettings.pass.curPass), nPass:$scope.encryptFx($scope.curSettings.pass.nPass), cPass:$scope.encryptFx($scope.curSettings.pass.cPass)}).then(
            function(data){
              $scope.saveProcessing = false;
              $scope.curSettings = {pass:{curPass:"", nPass:"", cPass:""}};
              if(data.code == 17010){
                $scope.errType = "curPwd";
                $scope.hasPwdErr = true;
              } else if(data.code == 17005){
                $scope.changeConfirmOpen("pass");
              }
            },
            function(err){
              $scope.saveProcessing = false;
              $log.error(err);
            }
          );
        }
      }
    }


    /*App Switches*/
    $scope.curASObj = {label:"", value:"", desc:""};
    $scope.asAddFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";

      if(!$scope.curASObj.label){
        $scope.errType = "label";
        $scope.hasErr = true;
        $("#curASObjL").focus();
      } else{
        $scope.asProcessing = true;
        $scope.curASObj.sid = $scope.sid;
        MySettingsSrv.saveAS($scope.curASObj).then(
          function(data){
            $scope.searchAS.text = '';
            $scope.asProcessing = false;
            if(data.code == 17076){
              $scope.errType = "same";
              $scope.hasErr = true;
              $("#curASObjL").focus();
            } else if(data.code == 17073){
              $scope.asObj.switches.push({id:data.id, label:$scope.curASObj.label, value:$scope.curASObj.value});
              $scope.curASObj = {label:"", value:"", desc:""};
            } else if(data.code == 17074){
              for(var i = 0;i < $scope.asObj.switches.length;i++){
                if($scope.asObj.switches[i].id == $scope.curASObj.id){
                  $scope.asObj.switches[i] = $scope.curASObj;
                }
              }
              $scope.curASObj = {label:"", value:"", desc:""};
            } else if(data.code == 12095){
              $scope.curData = data;
              ngDialog.open({
                template:'\
                  <section class="panel" role="dialog">\
                    <div class="panel-body">\
                      <div class="bg-warning text-warning pad5"><span class="fa fa-exclamation-triangle marR5" aria-hidden="true"></span><span>{{"d.p_dg.m15" | translate}}</span></div>\
                      <div class="overflow-y marT15 bdr-top-dashed noPad" ng-style="{\'max-height\':\'{{getAvailableHeight(360)}}px\'}">\
                        <div class="row alt-row-bg padLR10">\
                          <div class="col-xs-6 word-break padT5" ng-class="{{$index % 2 == 0}}?\'marR-5\':\'spaceB noPadL\'" ng-repeat="data in curData.labels">\
                            <label ng-class="{\'text-danger\':data.isConflict}">{{data.key}}</label>\
                          </div>\
                        </div>\
                      </div>\
                    </div>\
                    <div class="panel-footer">\
                      <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog(); excelResetFx();" data-dismiss="modal">{{"cm.btn.10" | translate}}</button>\
                    </div>\
                  </section>',
                plain:true,
                width:500,
                scope:$scope,
                data:$scope.curData,
                closeByDocument:false,
                className:"ngdialog-theme-default ngdialog-confirm"
              });
            }
            if(data.code != 17076){
              $scope.asDataLoading = true;
              MySettingsSrv.getAS().then(
                function(data){
                  $scope.asDataLoading = false;
                  $scope.asObj = data;
                  $scope.curASObj = {label:"", value:"", desc:""};
                },
                function(err){
                  $scope.asDataLoading = false;
                  $log.error(err);
                }
              );
            }
          },
          function(err){
            $scope.asProcessing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.asEditFx = function(obj){
      $scope.curASObj = angular.copy(obj);
      $scope.hasErr = false;
      $scope.errType = "";
    }

    $scope.asDeleteOpen = function(id){
      $scope.hasErrPop = false;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.asDObj = {id:id, processing:false, pass:""};
      ngDialog.open({
        template:'\
          <section class="panel" role="dialog">\
            <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.body.16" | translate}}</h1></header>\
            <div class="panel-body">\
              <div>{{"ms.p_s.as.m2" | translate}}</div>\
              <div class="form-group marT15">\
                <label for="asDObjPass">{{\'cl.widget.telax.9.3\' | translate}}</label>\
                <input type="password" id="asDObjPass" autocomplete="new-password" class="form-control" ng-model="asDObj.pass" aria-label="{{\'cl.widget.telax.9.3\' | translate}}" aria-labelledby="{{\'cl.widget.telax.9.3\' | translate}}">\
              </div>\
            </div>\
            <footer class="panel-footer">\
              <button type="button" role="button" class="btn btn-danger btn-sm" ng-click="asDeleteFx();" focus-me="true" ng-disabled="asDObj.processing"><span class="fa fa-repeat fa-spin" ng-if="asDObj.processing" aria-hidden="true"></span>{{"ms.p_s.as.3" | translate}}</button>\
              <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
              <div class="errMsg pull-right" ng-if="hasErrPop" aria-live="polite" role="status">\
                <span ng-if="errType==\'emptyPass\'" aria-live="polite" role="status">{{\'lock.m1\' | translate}}</span>\
                <span ng-if="errType==\'invPass\'" aria-live="polite" role="status">{{\'cl.widget.oc.m10\' | translate}}</span>\
              </div>\
            </footer>\
          </section>',
        plain:true,
        width:600,
        scope:$scope,
        closeByDocument:false,
        className:'ngdialog-theme-default ngdialog-confirm'
      });
    }

    $scope.asDeleteFx = function(){
      $scope.hasErrPop = false;
      $scope.errType = "";
      if($scope.asDObj.pass == ""){
        $scope.hasErrPop = true;
        $scope.errType = "emptyPass";
        $("#asDObjPass").focus();
      } else{
        $scope.asDObj.processing = true;
        MySettingsSrv.deleteAS({sid:$scope.sid, id:$scope.asDObj.id, pass:$scope.encryptFx($scope.asDObj.pass)}).then(
          function(data){
            $scope.asDObj.processing = false;
            if(data.code == 17097){
              $scope.hasErrPop = true;
              $scope.errType = "invPass";
              $("#asDObjPass").focus();
            } else if(data.code == 18014){
              for(var i = 0;i < $scope.asObj.switches.length;i++){
                if($scope.asObj.switches[i].id == $scope.asDObj.id){
                  $scope.asObj.switches.splice(i, 1);
                }
              }
              $scope.searchAS.text = '';
              $scope.asResetFx();
              ngDialog.close($scope.dialogId);
            }
          },
          function(err){
            $scope.asDObj.processing = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.asResetFx = function(){
      $scope.curASObj = {label:"", value:"", desc:""};
      $scope.hasErr = false;
      $scope.errType = "";
    }
    /*End App Switches*/

    // * scroll list data code START 2nd phase pagination
    $scope.detailListObj = {};
    $scope.scrollDataList = {};
    $scope.allScrollDataList = {};
    $scope.copyScrollObj = {};
    $scope.visibleObjects = {};
    $scope.haveMoreData = {};
    $scope.haveMoreSearchData = {};
    $scope.visibleData = {};
    $scope.stIndex = {};
    $scope.etIndex = {};
    $scope.searchScroll = {};
    $scope.quadId = '';

    // TODO load next data
    $scope.$on('loadNextDataDyn', function(e, obj) {
      $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
      $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:$scope.scrollDataList[obj.quadId].length, id:0};
      if($scope.searchScroll[obj.quadId]){
        $scope.detailListObj[obj.quadId].searchQ = obj.text;
        DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
          function(data){
            $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
            if(data.d.length >= 1000){
              $scope.haveMoreSearchData[obj.quadId] = true;
            } else{
              $scope.haveMoreSearchData[obj.quadId] = false;
            }
            $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
          function(data){
            $scope.addStatusKey(data.d, $scope.auth.upreferences.dot);
            if(data.d.length >= 1000){
              $scope.haveMoreData[obj.quadId] = true;
            } else if(data.d.length && data.d.length < 1000){
              $scope.haveMoreData[obj.quadId] = false;
            }
            $scope.allScrollDataList[obj.quadId] = [];
            $scope.scrollDataList[obj.quadId] = $scope.scrollDataList[obj.quadId].concat(data.d);
            $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO get search data API call
    $scope.$on('searchScrollDataDyn', function(e, obj) {
      $scope.stIndex[obj.quadId] = 0;
      $scope.etIndex[obj.quadId] = 300;
      $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
      $scope.scrollDataList[obj.quadId] = [];
      // $scope.dpLoading = true;
      if(obj.text){
        $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:0, searchQ: obj.text, id:0};
      } else{
        $scope.detailListObj[obj.quadId] = {caller:$scope.copyScrollObj[obj.quadId].caller, offset:0, id:0};
      }

      if(obj.text){
        $scope.searchScroll[obj.quadId] = true;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        DevicesSrv.getSearchScrollData($scope.detailListObj[obj.quadId]).then(
          function(data){
            if(data.d.length && data.d.length >= 1000){
              $scope.haveMoreSearchData[obj.quadId] = true;
            } else{
              $scope.haveMoreSearchData[obj.quadId] = false;
            }
            $scope.scrollDataList[obj.quadId] = data.d;

            $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
            $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });

            // $scope.dpLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      } else{
        $scope.haveMoreSearchData[obj.quadId] = false;
        $scope.searchScroll[obj.quadId] = false;
        $scope.copyScrollObj[obj.quadId] = angular.copy($scope.detailListObj[obj.quadId]);
        DevicesSrv.getScrollListData($scope.detailListObj[obj.quadId]).then(
          function(data){
            if(data.d.length >= 1000){
              $scope.haveMoreData[obj.quadId] = true;
            } else{
              $scope.haveMoreData[obj.quadId] = false;
            }

            $scope.scrollDataList[obj.quadId] = data.d;

            $scope.addStatusKey($scope.scrollDataList[obj.quadId], $scope.auth.upreferences.dot);
            $scope.visibleObjects[obj.quadId] = $scope.scrollDataList[obj.quadId].slice($scope.stIndex[obj.quadId], $scope.stIndex[obj.quadId] + $scope.etIndex[obj.quadId]);
            $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[obj.quadId], st: $scope.stIndex[obj.quadId], et: $scope.etIndex[obj.quadId], quadId: obj.quadId });
            $scope.allScrollDataList[obj.quadId] = [];
            $scope.allScrollDataList[obj.quadId] =  angular.copy($scope.scrollDataList[obj.quadId]);

            // $scope.dpLoading = false;
            setTimeout(function() {
              $scope.$apply();
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    });

    // TODO visibleData come from the directive
    $scope.$on('visibleDataDyn', function(e, obj) {
      $scope.stIndex[obj.quadId] = obj.st;
      $scope.etIndex[obj.quadId] = obj.et;
      $scope.visibleData[obj.quadId] = obj.vObj;
      $scope.addStatusKey($scope.visibleData[obj.quadId], $scope.auth.upreferences.dot);
      setTimeout(function() {
        $scope.$apply();
      });
    });

    $scope.searchChangeData = function(val, quadId){
      var text = val.toLowerCase();
      var scrollElement = document.querySelector("#scroll-container-"+quadId);
      if (!text && $scope.searchScroll[quadId]) {
        // TODO Enter when have newVal is empty and user perform search operation already
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        $scope.stIndex[quadId] = 0;
        $scope.etIndex[quadId] = 300;
        $scope.visibleObjects[quadId] = $scope.allScrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
        $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        $rootScope.$broadcast('searchScrollDataDyn', { text: '', st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
      } else if (text && text.length >= 3) {
        // TODO Enter when have newVal has 3 or grater than 3 character
        if(scrollElement != null){
          scrollElement.scrollTo(0, 0);
        }
        if (!$scope.haveMoreData[quadId]) {
          // var obj1 = $filter("filter")($scope.allScrollDataList, { l: text });
          // var obj2 = $filter("filter")($scope.allScrollDataList, { h: text });
          var obj1 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
            return item.l && item.l.toLowerCase().includes(text);
          });
          var obj2 = $filter('filter')($scope.allScrollDataList[quadId], function(item) {
            return item.h && item.h.toLowerCase().includes(text);
          });

          var concatObj = obj1.concat(obj2);
          var filteredObj = [], keys = [];
          angular.forEach(concatObj , function (item) {
            if(keys.indexOf(item.h) === -1){
              keys.push(item.h);
              filteredObj.push(item);
            }
          })
          if(filteredObj.length && filteredObj.length >= 1000){
            $scope.haveMoreSearchData[quadId] = true;
          } else{
            $scope.haveMoreSearchData[quadId] = false;
          }
          $scope.scrollDataList[quadId] = filteredObj;
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          if ($scope.scrollDataList[quadId].length <= 300) {
            $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId];
          } else {
            $scope.visibleObjects[quadId] = $scope.scrollDataList[quadId].slice($scope.stIndex[quadId], $scope.stIndex[quadId] + $scope.etIndex[quadId]);
          }
          $scope.searchScroll[quadId] = true;
          $rootScope.$broadcast('visibleDataDyn', { vObj: $scope.visibleObjects[quadId], st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        } else {
          $scope.stIndex[quadId] = 0;
          $scope.etIndex[quadId] = 300;
          $rootScope.$broadcast('searchScrollDataDyn', { text: text, st: $scope.stIndex[quadId], et: $scope.etIndex[quadId], quadId: quadId });
        }
      }
    }

    // * scroll list data code END 2nd phase pagination
  }
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .controller('CommonController', CommonController);

  /** @ngInject */
  function CommonController($log, $rootScope, $scope, $state, $cookies, $filter, $http, $window, $timeout, $location, $translate, $sce, $q, ngDialog, Notification, LocalizationSrv, SelectServerSrv, CLTPSrv, ContentLibraryWidgetsSrv, DevicesSrv, SupportSrv, CommonSrv, IndexedDB, DexieSrv){ //fancyboxService
    $rootScope.reportSelectedItems = {devices:[],content:[]};
    $rootScope.sFiles = {img:[], vid:[], aud:[], ot:[]};
    $scope.timestamp = moment().format('x');
    $rootScope.isFileUploading = false;
    $rootScope.colorPickerOpen = true;
    $rootScope.selectedSPfId = 0;
    $rootScope.selectedODfId = 0;
    $rootScope.selectedItems = [];
    $rootScope.selectedMenu = 0;
    $rootScope.selectedT = 1;
    $rootScope.flowFiles;
    $rootScope.emTimer;

    $scope.advDownloadSetting = [];
    $scope.dColumnOneList = [];
    $scope.dColumnTwoList = [];
    $scope.dColumnThreeList = [];

    $scope.searchRegExp = new RegExp("'", "gi");
    $scope.searchReplaceChar = "&apos;"//&apos; &#39;

    $scope.videoParam = "?autoplay=1&amp;rel=0&amp;showinfo=0";
    $scope.videoEmbed = "https://www.youtube.com/embed/";
    $scope.inputImgThumbParam = "&h=32&w=32&q=80&zc=2";
    $scope.profileSmParam = "&h=36&w=36&q=80&zc=3";
    $scope.thumbBigParam = "&h=135&w=215&q=80&zc=2";
    $scope.thumbBigParamZc3 = "&h=135&w=215&q=80&zc=3";
    $scope.dThumbParam = "&h=34&w=60&q=80&zc=3";
    $scope.thumbParam = "&h=60&w=90&q=80&zc=3";
    $scope.miniUploadMinimized = false;
    $scope.totalNotifications = 0;
    $scope.descriptionLimit = 500;
    $scope.devicePropInfoLimit = 500;
    $scope.deviceViewText = "";
    $scope.contextMenuOpt = [];
    $scope.notifications = {};
    $scope.commentLimit = 250;
    $scope.reloadTarget = "";
    $scope.selectedData = {};
    $scope.inputLimit = 100;
    $scope.authServer = {};
    $scope.auth = {};
    $rootScope.dTypeObj = {1:'mp',2:'webos',3:'tizen',4:'chrome',5:'mp',6:'mp',7:'mc',8:'desktop',9:'epd',10:'gf',11:'v'};

    $scope.authServer = angular.fromJson(localStorage.getItem("authServer"));
    $scope.auth = angular.fromJson(localStorage.getItem("auth"));

    $scope.uPreferences = angular.copy($scope.auth.upreferences);
    $scope.uPreferences.dpc = $scope.uPreferences.dpc>0?$scope.uPreferences.dpc:300;
    $scope.msal = angular.fromJson(localStorage.getItem('msal'));


    var absUrl = $location.absUrl();
    $rootScope.domainName = absUrl.replace(/.+\/\/|https.|\..+/g, '');
    // $rootScope.domainName = "intel";

    if($rootScope.domainName != "dev2" && $rootScope.domainName != "rc" && $rootScope.domainName != "nav" && $rootScope.domainName != "us" && $rootScope.domainName != "hub" && $rootScope.domainName != "sharedservices" && $rootScope.domainName != "ttc" && $rootScope.domainName != "lifelabs" && $rootScope.domainName != "cpost" && $rootScope.domainName != "cpostrc" && $rootScope.domainName != "usnew" && $rootScope.domainName != "localhost:3000"){
      $http.get('../theme/'+$rootScope.domainName+'/json.json').then(function(response){
        $rootScope.dmainPageTitle = response.data.themeData.title;
        $rootScope.myTheme.clientTheme = $rootScope.domainName;
        $rootScope.pageTitle = $rootScope.dmainPageTitle + " Digital Signage - " + $translate.instant('cm.menu.' + $state.current.data.id);
        $rootScope.copyRight = moment.utc().format("YYYY") + " &copy; " + $rootScope.dmainPageTitle +" Digital Signage"; //Footer copyright text
      });
    } else{
      $rootScope.myTheme.clientTheme = "";
    }

    $scope.themeSwitch = {btn:0};
    if($scope.uPreferences.theme == "dk"){
      $scope.themeSwitch.btn = 1;
    }

    /*Localization Start*/
    $scope.translateFixed = function(key, lang){
      var selectedLang = angular.fromJson(localStorage.getItem("authLang"));
      var curLang = key;
      if(!lang){
        lang = "en_US_LSN";
        curLang = selectedLang+"."+key;
      }
      var table = $translate.getTranslationTable(lang);
      return table && table[curLang] ? table[curLang] : curLang;
    };
    
    $scope.initLangFx = function(lang){
      document.body.classList.add('no-clickable');
      document.getElementById('awesome-loader').classList.remove('hidden');
      document.getElementById('awesome-loader').classList.remove('awesome-loaded');
      document.getElementById('awesome-loader').classList.add('awesome-loading');

      LocalizationSrv.getLocalization($scope.auth.lang).then(
        function(data){
          setTimeout(function(){
            $translate.use(lang).then(function(){
              document.getElementById('awesome-loader').classList.remove('awesome-loading');
              document.getElementById('awesome-loader').classList.add('awesome-loaded');
              document.body.classList.remove('no-clickable');
            });
          }, 100);
          localStorage.setItem("authLang", JSON.stringify($scope.auth.lang));
          localStorage.setItem("lang", JSON.stringify(data));
          $scope.getLang = data;
          $scope.toastNotification = $scope.getLang.notification;
        },
        function(err){
          $log.error(err);
        }
      );
    }

    if($scope.auth.lang != "en_US"){
      $scope.initLangFx($scope.auth.lang);
    } else{
      $translate.use("en_US");
      
      var en_us_lang = angular.fromJson(localStorage.getItem("lang"));
      if(en_us_lang && en_us_lang.notification){
        $scope.toastNotification = en_us_lang.notification;
      }
    }
    /*Localization End*/

    $http.defaults.headers.common.Authorization = $scope.auth.token;
    $scope.selectedData.token = $scope.auth.token;
    $scope.selectedData.uid = $scope.auth.uid;
    $scope.userName = $scope.auth.uname;
    // $scope.userImg = $scope.auth.uimg;
    $scope.userImg = {uImg:$scope.auth.uimg};

    $scope.isPageaccessible = true;

    $rootScope.myTheme.theme = $scope.auth.upreferences.theme;
    // console.log($rootScope.myTheme.theme);

    $scope.curTime = new Date(); //moment().format();
    $scope.curTimezone = $scope.curTime.getTimezoneOffset();

    $rootScope.contentPermissionExpiryTemp = {fid:localStorage.getItem("curFId"), activePeriod:{type:"a"}};//, tzOffset:$scope.curTimezone
    $rootScope.contentPermissionExpiryTemp.permission = {type:$scope.auth.upreferences.defaultP};
    $rootScope.contentPermissionExpiry = {};
    $rootScope.contentPermissionExpiry.type = $scope.auth.upreferences.defaultP;
    $rootScope.contentExpiry = {};

    if($state.current.name != "hub.teamsApp"){
      localStorage.setItem("teamsApp", $state.current.name);
    }

    /* IDB Start */
    /* Registered useful functions */
    $scope.clearStoreDB = function(store){
      // console.warn("clearStoreDB Commone___! ");
      // Remove all saved data from IndexedDB.
      DexieSrv.clearData().then(function(){
        // console.log('Database cleared');
      });


      //   var dbArr = ["scu"];
      //   var dbCount = 0;

      //   function deleteAllDB(){
      //     if(dbCount < dbArr.length){
      //       deleteDatabase(dbArr[dbCount]);
      //     } else{
      //       console.log("All databases deleted successfully!");
      //     }
      //   }

      //   function deleteDatabase(dbName){
      //     var request = window.indexedDB.deleteDatabase(dbName);
      //     request.onsuccess = function(event){
      //       console.log("Database ", dbName, " deleted successfully");
      //       dbCount++;
      //       deleteAllDB();
      //     };
      //     request.onerror = function(event){
      //       console.error("Failed to delete database ", dbName, ", ", event);
      //     };
      //     request.onblocked = function(event){
      //       console.warn("Delete operation is blocked for database ", dbName ,", ", event);
      //     };
      //   }
      //   deleteAllDB();


      // IndexedDB.clearStore(store).then(function(message){
      //   // console.log(message);
      // }).catch(function(error){
      //   console.error(error);
      // });
    };

    $rootScope.askToChange = false;
    $scope.$on("$stateChangeStart", function(event, toState, toParams, from){
      $rootScope.isDBEdit = "c";
      $state.toParams = toParams;
      $state.current = toState;
      $scope.previousState = from.name;
      if(!$rootScope.askToChange && $scope.previousState.includes('hub.sContainer') && !$state.current.name.includes('hub.sContainer')){
        var scuData = false;
        scuData = JSON.parse(localStorage.getItem("scuData"));
        if(scuData){
          event.preventDefault();
          ngDialog.open({
            template: '\
              <section class="panel" role="dialog">\
                <div class="panel-body">\
                  {{"s.msg.18" | translate}}\
                </div>\
                <div class="panel-footer">\
                  <button type="button" role="button" class="btn btn-success" ng-click="confirm();" data-dismiss="modal">{{"cm.btn.2" | translate}}</button>\
                  <button type="button" role="button" class="btn btn-link" ng-click="closeThisDialog();">{{"cm.btn.9" | translate}}</button>\
                </div>\
              </section>',
            plain: true,
            width: 500,
            scope: $scope,
            closeByDocument: false,
            className: "ngdialog-theme-default ngdialog-confirm",
            preCloseCallback:function(value){
              if(value){
                // console.warn("AA", value);
                $state.go(toState, toParams);
                $scope.tabFx(1);
              }
              // console.warn("BB", value);
              $scope.isConfirmOpen = false;
            }
          });
        }
        /* IDB End */

        // Add confirm function to scope
        $scope.confirm = function(){
          localStorage.setItem("scuData", false);
          $scope.clearStoreDB("scuData");
          ngDialog.close(); // Close the dialog
          $rootScope.askToChange = true;
          $state.go($state.current.name, $state.toParams);
          ngDialog.ngDialogData = true; // Pass data to preCloseCallback
        };
      } else{
        $rootScope.askToChange = false;
        $scope.tabFx(1);
      }

      //rest of code
      if($scope.previousState=="hub.templates.t"){
        localStorage.setItem("isSchTemp", true);
      }
      if($scope.previousState!="hub.templates.t" && $state.current.name != "hub.schedules.s"){
        localStorage.removeItem("isSchTemp");
      }
      if($state.current.name != "hub.teamsApp"){
        localStorage.setItem("teamsApp", $state.current.name);
      }
      /* IDB Start */
      if($state.current.name != "hub.devices.d" && $state.current.name != "hub.devices.dt" && $state.current.name != "hub.devices.dg" && $state.current.name != "hub.devices.di"){
        localStorage.setItem("isCDdb", 1);
      }
      /* IDB End */
    });
    $scope.uiVersionFx = function(){
      CommonSrv.getUIVersion().then(
        function(data){
          if(!$rootScope.isFileUploading && (!$rootScope.uiVersion || $rootScope.uiVersion !== data.version)){
            $translate.refresh();
            $window.location.reload();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.contentViewReloadFx = function(){
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      $rootScope.closeAllFx("all");
    }

    $rootScope.supportedFiles = [];
    $scope.supportedFilesFx = function(){
      CommonSrv.supportedFiles($scope.auth.server).then(
        function(data){
          localStorage.removeItem('sFiles');
          localStorage.setItem('sFiles', JSON.stringify(data));
          $rootScope.sFiles = data;
          $rootScope.supportedFiles = $rootScope.supportedFiles.concat($rootScope.sFiles.img, $rootScope.sFiles.vid, $rootScope.sFiles.aud, $rootScope.sFiles.ot);
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.supportedFilesFx();
    var myEvent = window.attachEvent || window.addEventListener;
    var chkevent = window.attachEvent?'onbeforeunload':'beforeunload'; /// make IE7, IE8 compitable

    myEvent(chkevent, function(e){ // For >=IE7, Chrome, Firefox
      if($rootScope.isFileUploading){
        var confirmationMessage = $filter("translate")('cm.msg.25'); //'Are you sure to leave the page?';  // a space
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });

    $scope.uploadedItems = {id:[], isApproved:true};
    $scope.uploadResponse = {};

    $scope.uploadStart = function(){
      $rootScope.isFileUploading = true;
      $scope.uploadedItems = {id:[], isApproved:true};
      $scope.uploadResponse = {};

      //Session Timeout
      $timeout.cancel($rootScope.sessionTimeoutTimer);
      $timeout.cancel($rootScope.sessionMsgHideTimer);
      $timeout.cancel($rootScope.restartSessionTimer);
      $rootScope.showTimeoutMsg = false;
    }
    $scope.fileSuccess = function(msg, file){
      $scope.uploadResponse = angular.fromJson(msg);
      if(!$scope.uploadResponse.isApproved){
        if(angular.isArray($scope.uploadedItems)){
          angular.forEach($scope.uploadedItems, function(item){
            if(item.t != "f"){
              $scope.uploadedItems.id.push($scope.uploadResponse.id);
            }
          });
        }
        $scope.uploadedItems.isApproved = false; 
      }
      file.cancel();
    }
    $scope.uploadComplete = function(){
      $rootScope.isFileUploading = false;
      if($scope.uploadedItems.id.length > 0){
      }
      if($state.current.name == "hub.contentAdd.contentAddTab"){
        $timeout(function(){
          $state.go('hub.contentLibrary.c');
        }, 1000);
      }
      $rootScope.sendUnapproveNotification($scope.uploadedItems);
      if($rootScope.isPopupOpen){
        $rootScope.resetSession();
        $rootScope.keepSessionAlive();
      } else{
        $timeout.cancel($rootScope.sessionTimeoutTimer);
        $timeout.cancel($rootScope.sessionMsgHideTimer);
        $timeout.cancel($rootScope.restartSessionTimer);
        $rootScope.sessionTimoutFx();
      }
    }
    $scope.isPEOpen = false;

    $rootScope.contentUploadFX = function(flowObj){
      if($rootScope.activePeriodOpen){
        $scope.isPEOpen = true;
        $rootScope.$broadcast('saveActivePeriod',{});
      }
      if($rootScope.isPermissionOpen){
        $scope.isPEOpen = true;
        $rootScope.$broadcast('savePermission',{});
      }
      if($scope.isPEOpen){
        $timeout(function(){
          $scope.contentUpload(flowObj);
        }, 250);
      } else{
        $scope.contentUpload(flowObj);
      }
    }

    $scope.contentUpload = function(flowObj){
      $rootScope.contentPermissionExpiry.permissionType = $rootScope.contentPermissionExpiryTemp.permission.type;
      $rootScope.contentPermissionExpiry.activeType = $rootScope.contentPermissionExpiryTemp.activePeriod.type;
      $rootScope.contentPermissionExpiry.fid = localStorage.getItem("curFId");
      $rootScope.contentPermissionExpiry.fileProp = [];
      $rootScope.contentPermissionExpiry.startDate = "";
      $rootScope.contentPermissionExpiry.endDate = "";
      $rootScope.contentPermissionExpiry.groups = "";
      $rootScope.contentPermissionExpiry.time = "";
      $rootScope.contentPermissionExpiry.uploadgroupid = $rootScope.uniqueGrp.id;
      $rootScope.contentPermissionExpiry.totaluploadcount = $rootScope.flowFiles.length;


      $scope.curSPlObj = angular.fromJson(localStorage.getItem("curSPlObj"));
      if($scope.curSPlObj != null || ($scope.curSPlObj != null && !angular.isUndefined($scope.curSPlObj))){
        if($scope.curSPlObj.type == "sharedfolder"){
          $rootScope.contentPermissionExpiry.splId = $scope.curSPlObj.id;
          $rootScope.contentPermissionExpiry.type = $scope.curSPlObj.type;
        }
      }

      flowObj.pause();
      $scope.removeUnsupportedFiles();
      angular.forEach($rootScope.flowFiles, function(curFile){
        $rootScope.contentPermissionExpiry.fileProp.push({id:curFile.uniqueIdentifier, optimize:curFile.optimize, vi:curFile.vi, label:curFile.label + "." + curFile.extension, gType:(curFile.exai ? "img": null)});
      });
      $rootScope.contentPermissionExpiry.fileProp = JSON.stringify($rootScope.contentPermissionExpiry.fileProp);

      if($rootScope.contentPermissionExpiryTemp.activePeriod.type == "c"){
        $rootScope.contentPermissionExpiry.time = $rootScope.contentPermissionExpiryTemp.activePeriod.time;
        $rootScope.contentPermissionExpiry.startDate = $rootScope.contentPermissionExpiryTemp.activePeriod.date.startDate;
        $rootScope.contentPermissionExpiry.endDate = $rootScope.contentPermissionExpiryTemp.activePeriod.date.endDate;
      }

      if($rootScope.contentPermissionExpiryTemp.permission.type == "c"){
        angular.forEach($rootScope.contentPermissionExpiryTemp.permission.groups, function(group){
          if($rootScope.contentPermissionExpiry.groups.length == 0){
            $rootScope.contentPermissionExpiry.groups = group.id;
          } else{
            $rootScope.contentPermissionExpiry.groups += "," + group.id;
          }
        });
      }
      flowObj.resume();
    }

    $scope.removeUnsupportedFiles = function(){
      $scope.recheck = false;
      angular.forEach($rootScope.flowFiles, function(curFile, index){
        if((curFile.unsupported || curFile.isSizeExceed) && !$scope.recheck){
          $rootScope.flowFiles.splice(index, 1);
          $scope.recheck = true;
        }
      });
      if($scope.recheck){
        $scope.removeUnsupportedFiles();
      }
    }

    $scope.ngDialogOpenedCount = 0;
    $rootScope.$on('ngDialog.opened', function(e, $dialog){
      $scope.timestamp = moment().format('x');
      $scope.ngDialogOpenedCount++;
      $rootScope.isPopupOpen = true;
      $rootScope.ngDialogId = $dialog.attr('id');
      if(!$rootScope.isFileUploading){
        $rootScope.resetSession();
        $rootScope.keepSessionAlive();
      }
      $(".ngdialog-content").removeClass("ngdialog-blink");
      $(".ngdialog-overlay").click(function(){
        $(".ngdialog-content").addClass("ngdialog-blink");
      });
    });
    $rootScope.$on('ngDialog.closed', function(e, $dialog){
      $scope.ngDialogOpenedCount--;
      if($scope.ngDialogOpenedCount <= 0){
        $rootScope.isPopupOpen = false;
        if(!$rootScope.isFileUploading){
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.sessionTimoutFx();
        }
      }
    });

    angular.element(document).unbind('keyup');
    angular.element(document).bind('keyup', function(e){
      if(e.keyCode == 46 && $("#tTextEditor:focus").length != 0){
       return;
      }else if(e.keyCode == 46 && $("#tTextEditor:focus").length == 0){
        if(!$(document.activeElement).is('input[type="text"], input[type="number"], textarea') && !$rootScope.isPopupOpen){
          $rootScope.deleteCallback();
        }
      }
    });

    angular.element(document).bind('dragenter', function(e){
      if(e.target.id == "content-list" && $scope.auth.upermissions.c && !$scope.isFileUploading){
        if(localStorage.getItem("curFId") == 0){
          if($scope.auth.upermissions.ar){
            $state.go("hub.contentAdd.contentAddTab");
          }
        }
        else{
          $state.go("hub.contentAdd.contentAddTab");
        }
      }
    });

    $scope.preventAction = function(caller){
      $scope.callerObj = caller;
      if($rootScope.isFileUploading){
        ngDialog.open({
          template:'\
            <section class="panel" role="dialog">\
              <div class="panel-body">\
                {{"cm.msg.13" | translate}}\
                <span ng-if="callerObj == \'logOut\'">{{"cm.msg.26" | translate}}</span>\
              </div>\
              <footer class="panel-footer">\
                <button type="button" role="button" class="btn btn-default btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.1" | translate}}</button>\
                <button type="button" role="button" class="btn-link" ng-if="callerObj == \'logOut\'" ng-click="logOutFx(\'logOut\');">{{"cm.btn.43" | translate}}</button>\
              </footer>\
            </section>',
          plain:true,
          width:500,
          scope:$scope,
          closeByEscape:false,
          closeByDocument:false,
          className:"ngdialog-theme-default ngdialog-confirm"
        });
      }
    }

    if($scope.authServer.length > 0){
      angular.forEach($scope.authServer, function(server){
        if($scope.auth.server == server.id){
          $scope.selectedServer = server;
        }
      });
    }
    $scope.serverSearchFocus = function(){
      if($scope.authServer.length > 1){
        angular.element(document).find(".searchTbx.input-xs").children()[0].focus();
      }
    }
    $scope.selectServerFx = function(){
      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        $state.go("selectServer");
      }
    }
    $scope.changeServer = function(server){
      if($rootScope.isFileUploading){
        $scope.preventAction();
      } else{
        $scope.selectedData.sid = server.id;
        $scope.reloadTarget = "";
        SelectServerSrv.saveSelectServer($scope.selectedData).then(
          function(data){
            $scope.isPageaccessible = true;
            localStorage.removeItem("folderIdArrTemp");
            localStorage.removeItem("folderId");
            localStorage.removeItem("curDFId");
            //Check if ad is seen
            $scope.isAdSeen = localStorage.getItem("adC") || false;
            // Remove all saved data from localStorage
            localStorage.clear();

            /* IDB Start */
            // Remove all saved data from IndexedDB.
            DexieSrv.clearData().then(function(){
              // console.log('Database cleared');
            });
            /* IDB End */

            // $cookies.putObject('auth', data.info,{secure:true});
            localStorage.setItem('auth', JSON.stringify(data.info));

            localStorage.setItem("authServer", JSON.stringify(data.servers));
            $scope.auth = angular.fromJson(localStorage.getItem("auth"));

            //Reset ad seen status
            if($scope.isAdSeen) {
              localStorage.setItem("adC", true)
            }

            if($rootScope.selectedMenu == 1){
              if(!data.info.uservices.c){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.contentLibrary.c" || $state.current.name == "hub.contentLibrary.uc" || $state.current.name == "hub.contentLibrary.ac" || $state.current.name == "hub.contentLibrary.dc"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.contentLibrary.c";
                }
              }
            } else if($rootScope.selectedMenu == 2){
              if(!data.info.uservices.t){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.templates.t" || $state.current.name == "hub.templates.ut" || $state.current.name == "hub.templates.it" || $state.current.name == "hub.templates.tl"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.templates.t";
                }
              }
            } else if($rootScope.selectedMenu == 3){
              if(!data.info.uservices.s){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.schedules.s" || $state.current.name == "hub.schedules.us" || $state.current.name == "hub.schedules.is" || $state.current.name == "hub.schedules.es"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.schedules.s";
                }
              }
            } else if($rootScope.selectedMenu == 4){
              if(!data.info.uservices.fl){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.frameLayouts.fl" || $state.current.name == "hub.frameLayouts.fla" || $state.current.name == "hub.frameLayouts.ufl" || $state.current.name == "hub.frameLayouts.ifl" || $state.current.name == "hub.frameLayouts.fll"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.frameLayouts.fl";
                }
              }
            } else if($rootScope.selectedMenu == 5){
              if(!data.info.uservices.d){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.devices.d" || $state.current.name == "hub.devices.d" || $state.current.name == "hub.devices.dt"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.devices.d";
                }
              }
            } else if($rootScope.selectedMenu == 6){
              if(!data.info.uservices.u){
                $scope.isPageaccessible = false;
              }
              else{
                if($state.current.name == "hub.users.au" || $state.current.name == "hub.users.ug" || $state.current.name == "hub.users.uu" || $state.current.name == "hub.users.bu"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.users.au";
                }
              }
            } else if($rootScope.selectedMenu == 7){
              if(!data.info.uservices.em){
                $scope.isPageaccessible = false;
              } else{
                $scope.reloadTarget = $state.current.name;
              }
            } else if($rootScope.selectedMenu == 8){
              if(!data.info.uservices.r){
                $scope.isPageaccessible = false;
              } else{
                if($scope.auth.upermissions.rpp && $state.current.name == "hub.reports.pp"){
                  $scope.reloadTarget = "hub.reports.pp";
                } else if($scope.auth.upermissions.rds && $state.current.name == "hub.reports.ds"){
                  $scope.reloadTarget = "hub.reports.ds";
                } else if($scope.auth.upermissions.rcs && $state.current.name == "hub.reports.cs"){
                  $scope.reloadTarget = "hub.reports.cs";
                } else if($scope.auth.upermissions.rop && $state.current.name == "hub.reports.op"){
                  $scope.reloadTarget = "hub.reports.op";
                } else if($scope.auth.upermissions.rcc && $state.current.name == "hub.reports.cc"){
                  $scope.reloadTarget = "hub.reports.cc";
                } else if($scope.auth.upermissions.rofd && $state.current.name == "hub.reports.pod"){
                  $scope.reloadTarget = "hub.reports.pod";
                } else if($scope.auth.upermissions.rhk && $state.current.name == "hub.reports.hk"){
                  $scope.reloadTarget = "hub.reports.hk";
                } else if($scope.auth.upermissions.rpp){
                  $scope.reloadTarget = "hub.reports.c.pp";
                } else if($scope.auth.upermissions.rds){
                  $scope.reloadTarget = "hub.reports.d.ds";
                } else if($scope.auth.upermissions.rcs){
                  $scope.reloadTarget = "hub.reports.c.cs";
                } else if($scope.auth.upermissions.rop){
                  $scope.reloadTarget = "hub.reports.d.op";
                } else if($scope.auth.upermissions.rcc){
                  $scope.reloadTarget = "hub.reports.c.cc";
                } else if($scope.auth.upermissions.rofd){
                  $scope.reloadTarget = "hub.reports.pod";
                } else if($scope.auth.upermissions.rhk){
                  $scope.reloadTarget = "hub.reports.d.hk";
                } else{
                  $scope.isPageaccessible = false;
                }
              }
            } else if($rootScope.selectedMenu == 9){
              if(!data.info.uservices.cs){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.creativeServices.cur" || $state.current.name == "hub.creativeServices.cmp" || $state.current.name == "hub.creativeServices.inv"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.creativeServices.cur";
                }
              }
            } else if($rootScope.selectedMenu == 10){
              if(!data.info.uservices.b){
                $scope.isPageaccessible = false;
              } else{
                if($state.current.name == "hub.billing.s" || $state.current.name == "hub.billing.o"){
                  $scope.reloadTarget = $state.current.name;
                } else{
                  $scope.reloadTarget = "hub.billing.s";
                }
              }
            }

            if($scope.isPageaccessible){
              if($scope.reloadTarget != ""){
                $state.go($scope.reloadTarget);
              } else{
                $state.go("hub.dashboard");
              }
            } else{
              $state.go("hub.dashboard");
            }
            $timeout(function(){
              $window.location.reload();
            }, 500);
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.reportURLFx = function(){
      if($scope.auth.upermissions.rcc){
        $state.go("hub.reports.c.cc");
      } else if($scope.auth.upermissions.rcs){
        $rootScope.refURL = ".reports.c.cs";
        $state.go("hub.reports.c.cs");
      } else if($scope.auth.upermissions.rpp){
        $rootScope.refURL = ".reports.c.pp";
        $state.go("hub.reports.c.pp");
      } else if($scope.auth.upermissions.rds){
        $rootScope.refURL = ".reports.d.ds";
        $state.go("hub.reports.d.ds");
      } else if($scope.auth.upermissions.rhg){
        $rootScope.refURL = ".reports.d.hg";
        $state.go("hub.reports.d.hg");
      } else if($scope.auth.upermissions.ir){
        $rootScope.refURL = ".reports.d.ir";
        $state.go("hub.reports.d.ir");
      } else if($scope.auth.upermissions.rod){
        $rootScope.refURL = ".reports.d.od";
        $state.go("hub.reports.d.od");
      } else if($scope.auth.upermissions.rop){
        $rootScope.refURL = ".reports.d.op";
        $state.go("hub.reports.d.op");
      } else if($scope.auth.upermissions.rdst){
        $rootScope.refURL = ".reports.d.dst";
        $state.go("hub.reports.d.dst");
      } else if($scope.auth.upermissions.rpoh){
        $rootScope.refURL = ".reports.d.poh";
        $state.go("hub.reports.d.poh");
      } else if($scope.auth.upermissions.rhk){
        $rootScope.refURL = ".reports.d.hk";
        $state.go("hub.reports.d.hk");
      } else if($scope.auth.upermissions.ci){
        $rootScope.refURL = ".reports.d.ci";
        $state.go("hub.reports.d.ci");
      } else if($scope.auth.upermissions.hds){
        $rootScope.refURL = ".reports.hds.ac";
        $state.go("hub.reports.hds.ac");
      }
    }

    $scope.popupCloseFx= function(){
      angular.element(document).find('.popup-panel').addClass('popupClose');
      angular.element(document).find('.popup-overlay').addClass('popup-overlay-out');
      $timeout(function(){
        angular.element(document).find('.popup-panel').removeClass('popupClose');
        angular.element(document).find('.popup-overlay').removeClass('popup-overlay-out');
      }, 500);
    }

    $scope.miniUploadMinimizeFx = function(){
      if($scope.miniUploadMinimized){
        $scope.miniUploadMinimized = false;
      } else{
        $scope.miniUploadMinimized = true;
      }
    }

    if($scope.auth.upreferences.isPin == 0){
      $scope.pinStatus = $scope.auth.upreferences.isPin;
    } else{
      $scope.pinStatus = $scope.auth.upreferences.isPin;
    }
    if($scope.auth.upreferences.deviceView == 't'){
      $scope.deviceViewText = $filter("translate")('cm.tool.6');
    } else{
      $scope.deviceViewText = $filter("translate")('cm.tool.5');
    }
    if($scope.auth.upreferences.templateView == 't'){
      $scope.templateViewText = $filter("translate")('cm.tool.6');
    } else{
      $scope.templateViewText = $filter("translate")('cm.tool.5');
    }
    if($scope.auth.upreferences.dbPin == 0){
      $scope.dbPinStatus = $scope.auth.upreferences.dbPin;
    } else{
      $scope.dbPinStatus = $scope.auth.upreferences.dbPin;
    }

    $scope.chartResizer = function(){}

    $scope.preferencesAllFx = function(dObj, sObj){
      $scope.uPSaveProcessing = true;
      $scope.uPreferences.dashboard = dObj;
      $scope.uPreferences.dSettings = sObj;
      // $scope.uPreferences.sfdl = ($scope.uPreferences.sfdl ? true : false);
      // $scope.uPreferences.sfop = ($scope.uPreferences.sfop ? true : false);
      CommonSrv.setUPreferences($scope.uPreferences).then(
        function(data){
          $scope.uPSaveProcessing = false;
          if(data.status == "success"){
            $rootScope.toastNotificationFx("info", {code:data.code});
            $rootScope.myTheme.theme = data.msg.theme;
            $scope.uPreferences = data.msg;
            $scope.auth.upreferences.isTreeOpen = data.msg.isTreeOpen;
            $scope.auth.upreferences.isDFTreeOpen = data.msg.isDFTreeOpen;
            $scope.auth.upreferences.dpc = parseInt(data.msg.dpc)>0?parseInt(data.msg.dpc):300;
            $scope.auth.upreferences.sfdl = data.msg.sfdl;
            $scope.auth.upreferences.sfop = data.msg.sfop;
            $scope.auth.upreferences.sdtf = data.msg.sdtf;
            $scope.auth.upreferences.deviceView = data.msg.deviceView;
            $scope.auth.upreferences.contentView = data.msg.contentView;
            $scope.auth.upreferences.templateView = data.msg.templateView;
            $scope.auth.upreferences.isLPOpen = data.msg.isLPOpen;
            $scope.auth.upreferences.isSplitV = data.msg.isSplitV;
            $scope.auth.upreferences.isPopup = data.msg.isPopup;
            $scope.auth.upreferences.isPin = data.msg.isPin;
            $scope.auth.upreferences.scale = data.msg.scale;
            $scope.auth.upreferences.theme = data.msg.theme;
            $scope.auth.upreferences.dbPin = data.msg.dashboard.dpi ? 1 : 0;
            if($scope.auth.upreferences.theme == "dk"){
              $scope.themeSwitch.btn = 1;
            } else{
              $scope.themeSwitch.btn = 0;
            }
            $scope.auth.upreferences.dmbsort = data.msg.dmbsort;
            $scope.auth.upreferences.sddr = data.msg.sddr;

            $scope.auth.upreferences.dashboard = {ds:data.msg.dashboard.ds, c:data.msg.dashboard.c, sc:data.msg.dashboard.sc, us:data.msg.dashboard.us, ral:data.msg.dashboard.ral, d:data.msg.dashboard.d, dom:data.msg.dashboard.dom, dts:data.msg.dashboard.dts, dps:data.msg.dashboard.dps, ccs:data.msg.dashboard.ccs, ccl:data.msg.dashboard.ccl, dtps:data.msg.dashboard.dtps, ssdt:data.msg.dashboard.ssdt, rad:data.msg.dashboard.rad, ot:data.msg.dashboard.ot};

            $scope.pinStatus = data.msg.isPin;
            $scope.dbPinStatus = $scope.auth.upreferences.dbPin;

            if($scope.auth.upreferences.deviceView == "t"){
              $scope.deviceViewText = $filter("translate")('cm.tool.6');
            } else{
              $scope.deviceViewText = $filter("translate")('cm.tool.5');
            }

            localStorage.setItem('auth', JSON.stringify($scope.auth));
            $scope.auth = angular.fromJson(localStorage.getItem("auth"));

            $scope.uPreferences = angular.copy($scope.auth.upreferences);
          }
        },
        function(err){
          $log.error(err);
          $scope.uPSaveProcessing = false;
        }
      );
    }
    $scope.preferencesFx = function(caller,prop){
      // console.warn("APRPRPRP", caller);
      if(caller !== "scale" && caller !== "sddr"){
        $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      }
      if(caller == "deviceView"){
        if($scope.auth.upermissions.dp && $rootScope.thumbSelType == "dPaging"){
          $rootScope.resetCheckedListFx();
        }
        if($scope.auth.upreferences.deviceView == "t"){
          $scope.auth.upreferences.deviceView = "l";
          $scope.deviceViewText = $filter("translate")('cm.tool.5');
        } else{
          $scope.auth.upreferences.deviceView = "t";
          $scope.deviceViewText = $filter("translate")('cm.tool.6');
        }
        $rootScope.$broadcast('reloadDevices');
        CommonSrv.setDeviceViewStatus($scope.auth.upreferences.deviceView).then(
          function(data){
            $scope.$broadcast('changeView');
          }
        );
      // } else if(caller == "templateView"){
      //   if($scope.auth.upreferences.templateView == "t"){
      //     $scope.auth.upreferences.templateView = "l";
      //     $scope.templateViewText = $filter("translate")('cm.tool.5');
      //   } else{
      //     $scope.auth.upreferences.templateView = "t";
      //     $scope.templateViewText = $filter("translate")('cm.tool.6');
      //   }
      //   CommonSrv.setTemplateViewStatus($scope.auth.upreferences.templateView);
      // } else if(caller == "contentView"){
      //   if(prop == "t"){
      //     $scope.auth.upreferences.contentView = "t";
      //   } else{
      //     $scope.auth.upreferences.contentView = "l";
      //   }
      //   CommonSrv.setContentViewStatus($scope.auth.upreferences.contentView);
      } else if(caller == "contentView" || caller == "templateView"){
        if(prop == "t"){
          $scope.auth.upreferences.contentView = "t";
          $scope.auth.upreferences.templateView = "t";
          $scope.templateViewText = $filter("translate")('cm.tool.6');
        } else{
          $scope.auth.upreferences.contentView = "l";
          $scope.auth.upreferences.templateView = "l";
          $scope.templateViewText = $filter("translate")('cm.tool.5');
        }
        CommonSrv.setContentViewStatus($scope.auth.upreferences.contentView);
        CommonSrv.setTemplateViewStatus($scope.auth.upreferences.templateView);
      } else if(caller == "isLPOpen"){
        if($scope.auth.upreferences.isLPOpen == 0){
          $scope.auth.upreferences.isLPOpen = 1;
        } else{
          $scope.auth.upreferences.isLPOpen = 0;
        }
        CommonSrv.setLPOpenStatus($scope.auth.upreferences.isLPOpen);
        if($state.current.name == "hub.reports.pp" || $state.current.name == "hub.reports.ds" || $state.current.name == "hub.reports.cs"){
          setTimeout(function(){
            $scope.chartResizer.chartReflow();
          }, 1);
        }
      } else if(caller == "isPin"){
        if($scope.auth.upreferences.isPin == 0){
          $scope.auth.upreferences.isPin = 1;
        } else{
          $scope.auth.upreferences.isPin = 0;
        }
        $scope.pinStatus = $scope.auth.upreferences.isPin;
        CommonSrv.setPinStatus($scope.auth.upreferences.isPin);
      } else if(caller == "isPopup"){
        if($scope.auth.upreferences.isPopup == 0){
          $scope.auth.upreferences.isPopup = 1;
        } else{
          $scope.auth.upreferences.isPopup = 0;
        }
        CommonSrv.setPopupStatus($scope.auth.upreferences.isPopup);
      } else if(caller == "isSplitV"){
        if($scope.auth.upreferences.isSplitV == 0){
          $scope.auth.upreferences.isSplitV = 1;
        } else{
          $scope.auth.upreferences.isSplitV = 0;
        }
        CommonSrv.setSplitVStatus($scope.auth.upreferences.isSplitV);
      } else if(caller == "isTreeOpen"){
        if($scope.auth.upreferences.isTreeOpen == 0){
          $scope.auth.upreferences.isTreeOpen = 1;
        } else{
          $scope.auth.upreferences.isTreeOpen = 0;
        }
        CommonSrv.setTreeOpenStatus($scope.auth.upreferences.isTreeOpen).then(
          function(data){
            if($scope.auth.upreferences.isTreeOpen == 1){
              if($state.current.name != "hub.mySettings"){
                $scope.checkTree();
              }
            }
          }
        );
      } else if(caller == "scale"){
        $scope.curScale = angular.copy($scope.auth.upreferences.scale);
        $scope.auth = angular.fromJson(localStorage.getItem("auth"));
        $scope.auth.upreferences.scale = $scope.curScale;
        CommonSrv.setScale($scope.auth.upreferences.scale).then(
          function(data){}
        );
      } else if(caller == "sddr"){
        $scope.curSddr = angular.copy($scope.auth.upreferences.sddr);
        $scope.auth = angular.fromJson(localStorage.getItem("auth"));
        $scope.auth.upreferences.sddr = $scope.curSddr;
        CommonSrv.setSddr($scope.auth.upreferences.sddr).then(
          function(data){}
        );
      } else if(caller == "theme"){
        if($scope.themeSwitch.btn){
          $scope.auth.upreferences.theme = "dk";
          $scope.themeSwitch.btn = 1;
        } else{
          $scope.auth.upreferences.theme = "df";
          $scope.themeSwitch.btn = 0;
        }

        $rootScope.myTheme.theme = $scope.auth.upreferences.theme;
        CommonSrv.setTheme($scope.auth.upreferences.theme).then(
          function(data){
            $rootScope.myTheme.theme = $scope.auth.upreferences.theme;
          }
        );
        $rootScope.changeMapStyle($scope.themeSwitch.btn?'night':'road');

      } else if(caller == "isDFTreeOpen"){
        if($scope.auth.upreferences.isDFTreeOpen == 0){
          $scope.auth.upreferences.isDFTreeOpen = 1;
        } else{
          $scope.auth.upreferences.isDFTreeOpen = 0;
        }
        CommonSrv.setDFTreeOpenStatus($scope.auth.upreferences.isDFTreeOpen).then(
          function(data){
            if($scope.auth.upreferences.isDFTreeOpen == 1){
              if($state.current.name != "hub.mySettings"){
                $scope.checkDFTree();
              }
            }
            // else if($scope.auth.upreferences.isDFTreeOpen == 0){
            //   $state.reload();
            // }
          }
        );
      }
      localStorage.setItem('auth', JSON.stringify($scope.auth));
	    $scope.uPreferences = angular.copy($scope.auth.upreferences);
    }

    $scope.removeHighlightFx = function(){
      localStorage.removeItem("curScheduleId");
      localStorage.removeItem("curScheduleGroupId");
      localStorage.removeItem("addedDeviceId");
      localStorage.removeItem("addedDeviceGroupId");
      angular.element('.ui-selectable li').removeClass('ui-highlight');
    }

    $scope.$on("advSearchfilteredData", function(event, args){
      $rootScope.advSearchArgObj = args.advObj;
    });

    $scope.getDeviceList = function(caller){
      angular.forEach($scope.advDownloadListSetting, function(value, key){
        if(key === "added"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("cm.brief.6"), model:"confirmObj.settings.added", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "cv"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.19"), model:"confirmObj.settings.cv", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "du"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.tab.10"), model:"confirmObj.settings.du", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "dtype"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.1"), model:"confirmObj.settings.dtype", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "grp"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("cm.label.96"), model:"confirmObj.settings.grp", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "lp"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.body.10"), model:"confirmObj.settings.lp", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "lic"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.58"), model:"confirmObj.settings.lic", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "lip"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.brief.11.1"), model:"confirmObj.settings.lip", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "oi"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.9"), model:"confirmObj.settings.oi", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "prop" && $scope.auth.upermissions.da.dp){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.tab.6.8"), model:"confirmObj.settings.prop", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "pip"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.brief.11.2"), model:"confirmObj.settings.pip", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "res"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.18"), model:"confirmObj.settings.res", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tag"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.tab.3"), model:"confirmObj.settings.tag", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tz"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("cm.label.88"), model:"confirmObj.settings.tz", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "tznm"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.17"), model:"confirmObj.settings.tznm", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ws"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.p_dc.13"), model:"confirmObj.settings.ws", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "ugrp"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("u.tab.2"), model:"confirmObj.settings.ugrp", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "wm" && $scope.auth.upermissions.da.dw){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.tab.11"), model:"confirmObj.settings.wm", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "fc"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.53"), model:"confirmObj.settings.fc", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "lit"){
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.label.68"), model:"confirmObj.settings.lit", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        } else if(key === "hnm"){ //for hostname
          if(caller == "get"){
            $scope.advDownloadSetting.push({label:$filter("translate")("d.brief.16.1"), model:"confirmObj.settings.hnm", keyName:key , checkBox:value, key:key});
          } else{
            $scope.tempObj = $filter("filter")($scope.advDownloadSetting, {keyName:key}, true);
            $scope.advDownloadListSetting[key] = $scope.tempObj[0].checkBox;
          }
        }
      })
    }
    // $scope.getDeviceList();
    //open group device status popup before download
    $scope.openGroupDevices = function(type, devices, id, detailsObj, action, label, isAdvSrch, caller){
      if(type=="ir" && !$scope.auth.upermissions.edl){
        ngDialog.open({
          template: '\
            <section class="panel" role="dialog">\
              <header class="panel-heading text-bold"><h1 class="text-danger" role="heading" aria-level="1">{{"cm.msg.56" | translate}}</h1></header>\
              <div class="panel-body">{{"r.msg.17" | translate}}</div>\
              <div class="panel-footer">\
                <button type="button" role="button" class="btn btn-default" ng-click="closeThisDialog();">{{"cm.btn.1" | translate}}</button>\
              </div>\
            </section>',
          plain: true,
          width: 480,
          closeByDocument: false,
          className: "ngdialog-theme-default ngdialog-confirm"
        });
      } else{
        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type=="df"){
          $scope.dfTypeObj = {df:'cr'};
        }
        $scope.isAdvSrch = (isAdvSrch && Object.keys(isAdvSrch).length === 0) ? false : true;
        $scope.advDownloadSetting = [];
        $scope.dColumnOneList = [];
        $scope.dColumnTwoList = [];
        $scope.dColumnThreeList = [];
        $scope.loadProcessing = true;
        $scope.type = type;
        if($scope.type == "hub.devices.dg"){
          $scope.type = "groups";
        } else if($scope.type == "hub.devices.dt"){
          $scope.type = "tags";
        } else if($scope.type == "hub.devices.dvw"){
          $scope.type = "videowall";
        } else if($scope.type == ""){
          $scope.type = "devices";
        }
  
        if($state.current.name == "hub.frameLayouts.fl"){
          $scope.type = "flDevices";
        } else if($state.current.name == "hub.frameLayouts.fla"){
          $scope.type = "flaDevices";
        }
        ngDialog.open({
          template:'app/common/popup/groupDevice.html',
          width:760,
          data:$scope.viewData,
          scope:$scope,
          closeByDocument:false
        });
        CommonSrv.getGroupDeviceSettings($scope.type).then(
          function(data){
            //isDsg is used to show checkbox if true
            // $scope.confirmObj = {type:type, devices:devices, id:id, dsg:$scope.auth.upermissions.dsg, settings:data.settings, from:action};
            $scope.confirmObj = {type:type, devices:devices, id:id, dsg:data.dsg, settings:data.settings, from:action, caller:caller, tempData:detailsObj};
  
            if(angular.isUndefined(label) && $state.current.name == "hub.dashboard"){
              $scope.confirmObj.label = detailsObj.label;
              $scope.confirmObj.subType = detailsObj.label;
            } else{
              $scope.confirmObj.label = label;
              $scope.confirmObj.subType = label;
            }
            if($scope.confirmObj.type == "ds"){
              if($scope.arrIsObject(devices)){
                // $scope.confirmObj.isDsg = detailsObj.fType?false:true;
                $scope.confirmObj.isDsg = (detailsObj.value == 'ondc' || detailsObj.value == 'offdc' || detailsObj.value == 'ncdc')?false:true;
              } else {
                $scope.confirmObj.isDsg = true;
              }
            } else if($scope.confirmObj.type == "ssodt" || $scope.confirmObj.type == "ssdt" || $scope.confirmObj.type == "ssdpt"){
              if($scope.arrIsObject(devices)){
                $scope.confirmObj.isDsg = (detailsObj.status.toLowerCase() == "onc" || detailsObj.status.toLowerCase() == "ofc")?false:true;
              } else {
                $scope.confirmObj.isDsg = true;
              }
            } else if($scope.confirmObj.type == "ssdpt") {
              if($scope.confirmObj.from == "db"){
                $scope.confirmObj.isDsg = detailsObj.fType?false:true;
              } else {
                $scope.confirmObj.isDsg = (detailsObj.status.toLowerCase() == "online" || detailsObj.status.toLowerCase() == "offline")?false:true;
              }
            } else {
              $scope.confirmObj.isDsg = true;
            }
            // console.warn($scope.confirmObj.isDsg);
  
            $scope.advDownloadListSetting = data.settings
            $scope.getDeviceList("get")
            $scope.advDownloadSetting = $scope.advDownloadSetting.sort(function(a, b){
              return a.label.localeCompare(b.label);
            });
            $scope.listLength = $scope.advDownloadSetting.length;
            $scope.listCount = parseInt($scope.advDownloadSetting.length/3);
            $scope.listReminder = $scope.advDownloadSetting.length%3;
            if($scope.listReminder == 0){
              for(var i = 0; i <= $scope.listLength; i++){
                $scope.dColumnOneList[i] = $scope.advDownloadSetting[i];
                var j = i;
                if(i === $scope.listCount - 1){break;}
              }
              $scope.listCount = $scope.listCount + j
              j = j+1
              var m = 0;
              for(j; j < $scope.listLength; j++){
                $scope.dColumnTwoList[m] = $scope.advDownloadSetting[j];
                m++
                var k = j;
                if(j === $scope.listCount){ break;}
              }
              k = k+1
              var l = 0
              for(k+1; k < $scope.listLength; k++){
                $scope.dColumnThreeList[l] = $scope.advDownloadSetting[k];
                l++
              }
            } else if($scope.listReminder == 1 || $scope.listReminder == 2){
              for(var i = 0; i <= $scope.listLength; i++){
                $scope.dColumnOneList[i] = $scope.advDownloadSetting[i];
                var j = i;
                if(i === $scope.listCount){break;}
              }
              $scope.listCount = $scope.listCount + j
              j = j+1
              var m = 0;
              for(j; j < $scope.listLength; j++){
                $scope.dColumnTwoList[m] = $scope.advDownloadSetting[j];
                m++
                var k = j;
                if(j === $scope.listCount + 1){break;}
              }
              k = k+1
              var l = 0;
              for(k+1; k < $scope.listLength; k++){
                $scope.dColumnThreeList[l] = $scope.advDownloadSetting[k];
                l++
              }
            }
  
            $scope.loadProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.loadProcessing = false;
          }
        );
      }
    }

    $scope.exDevicesProcessing = false;
    $scope.exportDevices = function(devices){
      $scope.getDeviceList();
      $rootScope.hasErrEx = false;
      $rootScope.errTypeEx = "";
      // $scope.auth = $cookies.getObject("auth");
      $scope.auth = angular.fromJson(localStorage.getItem("auth"));
      // !:changed: Now this $scope.auth.upermissions.gbdt condition is change into $scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'
      // $scope.isGbdt = $scope.auth.upermissions.gbdt;
      // $scope.isDsoi = $scope.auth.upermissions.gbdt;
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        $scope.isGbdt = true;
        $scope.isDsoi = true;
      } else {
        $scope.isGbdt = false;
        $scope.isDsoi = false;
      }
      $scope.exDevicesProcessing = true;
      $scope.dt = "";
      $scope.settings = [];
      if($scope.confirmObj.isDsg){
        $scope.dsg = $scope.confirmObj.dsg?1:0;
      } else {
        $scope.dsg = 0;
      }
      $scope.type = $scope.confirmObj.type;
      // !:changed: $scope.isGbdt to $scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'
      if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type == 'dt'){
        if(devices.devices){
          $scope.dt = devices.devices[0].dType;
        }
      }

      if($scope.type == "hub.devices.dg"){
        $scope.type = "groups";
      } else if($scope.type == "hub.devices.dt"){
        $scope.type = "tags";
      } else if($scope.type == "hub.devices.dvw"){
        $scope.type = "videowall";
      } else if(($scope.type == "schedule" || ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type=="df") && $scope.type != "ds" && $scope.type != "dtps") ){
        if(devices && devices.length > 0){
          $scope.dIds = Array.prototype.map.call(devices, function(item){
            return item.id;
          }).join(",");
        }
      }
      // else if($scope.type == "dtps"){
      //   if($scope.confirmObj.from == "db"){
      //     devices = devices.n.concat(devices.c, devices.d);
      //   }
      // }
      // else if($scope.type == "dpts"){
      //   $scope.confirmObj.subType = "All Devices";
      // }
      if($scope.type == "ds" || $scope.type == "dtps" || $scope.type == "ccs" || $scope.type == "dts" || $scope.type == "dtpl" || $scope.type == "rad" || $scope.type == "ssodt" || $scope.type == "ssdt" || $scope.type == "ssdpt" || $scope.type == "dpts" || $scope.type == "dps" || $scope.type == "flDevices" || $scope.type == "uDevices" || $scope.type == "dccl"){
        if(devices && devices.length > 0){
          $scope.isObj = $scope.arrIsObject(devices);
          if($scope.isObj){
            if($scope.type=="dtpl"){
              $scope.dIds = Array.prototype.map.call(devices, function(item){
                return item.i;
              }).join(",");
            } else {
              $scope.dIds = $scope.arraytoStringFx(devices);
            }
          } else {
            $scope.dIds = devices;
          }
        }
      }
      $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
      if($scope.filterType=="offline"){
        $rootScope.deviceFilter = "off";
      } else if($scope.filterType=="online"){
        $rootScope.deviceFilter = "on";
      } else{
        $rootScope.deviceFilter = "all"
      }

      angular.forEach($scope.confirmObj.settings, function(value, key){
        if(value){
          $scope.settings.push(key);
        }
      });
      $scope.finalSettings = $scope.settings.join();
      $rootScope.linkOpenObj = {loading:true, url:"", surl:""};
      // console.warn(angular.equals({}, $rootScope.advSearchArgObj) || $rootScope.advSearchArgObj == undefined || $scope.type=='schedule', $rootScope.advSearchArgObj, $rootScope.advSApply, $scope.type);
      if(angular.equals({}, $rootScope.advSearchArgObj) || $rootScope.advSearchArgObj == undefined || $scope.type=='schedule'){
        $scope.linkOpenFx("d");
        if(!$scope.auth.upermissions.da.dp){
          $scope.finalSettings = $scope.finalSettings.replace(",prop", "");
        }
        if(!$scope.auth.upermissions.da.dw){
          $scope.finalSettings = $scope.finalSettings.replace(",wm", "");
        }
        // console.warn($scope.isGbdt, $scope.dt, $scope.dsg, $scope.type, $scope.confirmObj.id, $scope.finalSettings, $rootScope.deviceFilter, $scope.dIds);

        // console.warn($scope.confirmObj.type);
        if($scope.type == "ccs"){
          $scope.confirmObj.dType = "ccsDevices";
          if($scope.confirmObj.label == "Unconfirmed" || $scope.confirmObj.label == "No schedule"){
            $scope.confirmObj.subType = $scope.confirmObj.label;
          }
        } else if($scope.type == "dps"){
          $scope.confirmObj.dType = "dpsDevices";
        } else if($scope.type == "dpts"){
          $scope.confirmObj.dType = "dptsDevices";
        } else if($scope.type == "ds"){
          $scope.confirmObj.dType = "dsDevices";
          if($scope.confirmObj.label == "Never Connected" || $scope.confirmObj.label == "Online" || $scope.confirmObj.label == "Offline"){
            $scope.confirmObj.subType = $scope.confirmObj.label;
          }
        } else if($scope.type == "dts"){
          if($scope.confirmObj.label == "mp"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.1');
          } else if($scope.confirmObj.label == "webos"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.5');
          } else if($scope.confirmObj.label == "tizen"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.6');
          } else if($scope.confirmObj.label == "mc"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.4');
          } else if($scope.confirmObj.label == "gf"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.2');
          } else if($scope.confirmObj.label == "v"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.3');
          } else if($scope.confirmObj.label == "desktop"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.7');
          } else if($scope.confirmObj.label == "epd"){
            $scope.confirmObj.subType = $filter("translate")('d.label.1.8');
          }
          $scope.confirmObj.dType = "dtsDevices";
        } else if($scope.type == "ssdt"){
          $scope.confirmObj.dType = "ssdtDevices";
        } else if($scope.type == "ssdpt"){
          $scope.confirmObj.dType = "ssdptDevices";
        } else if($scope.type == "ssodt"){
          $scope.confirmObj.dType = "ssodtDevices";
        } else if($scope.type == "dtps"){
          if($scope.confirmObj.label == "n"){
            $scope.confirmObj.subType = "No issues";
          } else if($scope.confirmObj.label == "c"){
            $scope.confirmObj.subType = "Caution";
          } else if($scope.confirmObj.label == "d"){
            $scope.confirmObj.subType = "Danger";
          }
          $scope.confirmObj.dType = "dtpsDevices";
        } else if($scope.type == "dccl"){
          if($scope.confirmObj.label == "cc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.8');
          } else if($scope.confirmObj.label == "poncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.8.1');
          } else if($scope.confirmObj.label == "pofcc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.8.2');
          } else if($scope.confirmObj.label == "oncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.1');
          } else if($scope.confirmObj.label == "ofcc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.3');
          } else if($scope.confirmObj.label == "ncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.7.1');
          } else if($scope.confirmObj.label == "ponncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.7.2');
          } else if($scope.confirmObj.label == "pofncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.7.3');
          } else if($scope.confirmObj.label == "onncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.2');
          } else if($scope.confirmObj.label == "ofncc"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.4');
          } else if($scope.confirmObj.label == "nsd"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.6');
          } else if($scope.confirmObj.label == "onnsd"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.6.1');
          } else if($scope.confirmObj.label == "ofnsd"){
            $scope.confirmObj.subType = $filter("translate")('db.body.21.6.2');
          }
          // $scope.confirmObj.type = "dcclDevices";

          if(angular.isUndefined($scope.confirmObj.subType)){
            $scope.confirmObj.subType = "";
          }
        } else if($state.current.name == "hub.frameLayouts.fl"){
          $scope.confirmObj.dType = "flDevices";
          $scope.type = "flDevices";
        } else if($state.current.name == "hub.frameLayouts.fla"){
          $scope.confirmObj.dType = "flaDevices";
          $scope.type = "flaDevices";
        } else if($state.current.name == "hub.users.au"){
          $scope.confirmObj.dType = "uDevices";
        }

        if($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type=='df'){
          $scope.curFolderId = $scope.confirmObj.id;
          if(!$scope.curFolderId){
            $scope.curFolderId = 0;
          }

          $scope.dfType = $scope.dfTypeObj.df ? $scope.dfTypeObj.df : 'cr';

          $scope.dfData = {type:$scope.dfType, fId:$scope.curFolderId};
          $scope.finalSettings = $scope.finalSettings.replace(/,df/g, '');
        }

        $scope.filterType = JSON.parse(localStorage.getItem("filterType"));
        if($scope.filterType=="online"){
          $rootScope.deviceFilter = "on";
        } else if($scope.filterType=="offline"){
          $rootScope.deviceFilter = "off";
        }
        var exportPaylodDevice = {t:''};
        if($scope.confirmObj.caller && $scope.confirmObj.caller == 'dashboard'){
          // exportPaylodDevice = {t: $scope.type};
          if($scope.confirmObj.dType == "ssdtDevices"){
            exportPaylodDevice = {t: $scope.type, q:$scope.confirmObj.tempData.name?$scope.confirmObj.tempData.name:$scope.confirmObj.tempData.ctg, val:$scope.confirmObj.tempData.value?$scope.confirmObj.tempData.value:($scope.confirmObj.tempData.l?$scope.confirmObj.tempData.l:"")};
          } else if($scope.type == 'ssdpt'){
            exportPaylodDevice = {t: $scope.type, q:$scope.confirmObj.tempData.category, val:$scope.confirmObj.tempData.name};
          } else {
            exportPaylodDevice = {t: $scope.type, q:$scope.confirmObj.tempData.name?$scope.confirmObj.tempData.name:$scope.confirmObj.tempData.l, val:$scope.confirmObj.tempData.value?$scope.confirmObj.tempData.value:""};
          }

        }
        if($scope.confirmObj.caller && $scope.confirmObj.caller == 'dashboardPopup'){
          exportPaylodDevice = {t: $scope.type, isPopup:true};
          // exportPaylodDevice = {t: $scope.type, targetDIds:$scope.dIds};
          if($scope.confirmObj.tempData.caller == 'ssdt' || $scope.confirmObj.tempData.caller == 'ssdpt' || $scope.confirmObj.tempData.caller == 'ssodt'){
            exportPaylodDevice.q = $scope.confirmObj.tempData.name;
            exportPaylodDevice.val = $scope.confirmObj.tempData.value;
            exportPaylodDevice.s = $scope.confirmObj.tempData.status;
          } else if($scope.confirmObj.tempData.caller == 'ccs' || $scope.confirmObj.tempData.caller == 'dccl' || $scope.confirmObj.tempData.caller == 'dts' || $scope.confirmObj.tempData.caller == 'dtps'){
            exportPaylodDevice.q = $scope.confirmObj.tempData.name;
            if($scope.confirmObj.tempData.caller == 'dts'){
              if($scope.confirmObj.tempData.name == "mp"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.1');
              } else if($scope.confirmObj.tempData.name == "webos"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.5');
              } else if($scope.confirmObj.tempData.name == "tizen"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.6');
              } else if($scope.confirmObj.tempData.name == "mc"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.4');
              } else if($scope.confirmObj.tempData.name == "gf"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.2');
              } else if($scope.confirmObj.tempData.name == "v"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.3');
              } else if($scope.confirmObj.tempData.name == "desktop"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.7');
              } else if($scope.confirmObj.tempData.name == "epd"){
                $scope.confirmObj.subType = $filter("translate")('d.label.1.8');
              }
            } else if($scope.confirmObj.tempData.caller == 'ccs'){
              $scope.confirmObj.subType = $scope.confirmObj.tempData.name == 'rem'? "Unconfirmed" : "No schedule";
            } else if($scope.confirmObj.tempData.caller == 'dtps'){
              if($scope.confirmObj.tempData.name == "n"){
                $scope.confirmObj.subType = "No issues";
              } else if($scope.confirmObj.tempData.name == "c"){
                $scope.confirmObj.subType = "Caution";
              } else if($scope.confirmObj.tempData.name == "d"){
                $scope.confirmObj.subType = "Danger";
              }
            } else if($scope.confirmObj.tempData.caller == 'dccl'){
              if($scope.confirmObj.tempData.name == "cc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.8');
              } else if($scope.confirmObj.tempData.name == "poncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.8.1');
              } else if($scope.confirmObj.tempData.name == "pofcc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.8.2');
              } else if($scope.confirmObj.tempData.name == "oncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.1');
              } else if($scope.confirmObj.tempData.name == "ofcc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.3');
              } else if($scope.confirmObj.tempData.name == "ncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.7.1');
              } else if($scope.confirmObj.tempData.name == "ponncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.7.2');
              } else if($scope.confirmObj.tempData.name == "pofncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.7.3');
              } else if($scope.confirmObj.tempData.name == "onncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.2');
              } else if($scope.confirmObj.tempData.name == "ofncc"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.4');
              } else if($scope.confirmObj.tempData.name == "nsd"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.6');
              } else if($scope.confirmObj.tempData.name == "onnsd"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.6.1');
              } else if($scope.confirmObj.tempData.name == "ofnsd"){
                $scope.confirmObj.subType = $filter("translate")('db.body.21.6.2');
              }
            }
          } else if($scope.confirmObj.tempData.caller == 'dpts' || $scope.confirmObj.tempData.caller == 'dps' || $scope.confirmObj.tempData.caller == 'wgw' || $scope.confirmObj.tempData.caller == 'wgws'){
            exportPaylodDevice.q = $scope.confirmObj.tempData.name;
            exportPaylodDevice.val = $scope.confirmObj.tempData.value;
          } else if($scope.confirmObj.tempData.caller == 'ds'){
            exportPaylodDevice.val = $scope.confirmObj.tempData.value;
            $scope.confirmObj.subType = $scope.confirmObj.tempData.value == 'ncdc'? "Never Connected" : $scope.confirmObj.tempData.value == 'ondc'? "Online" : "Offline";
          }
        }
        CommonSrv.exportDevicesList($scope.isGbdt, $scope.dt, $scope.dsg, $scope.type, $scope.confirmObj.id, $scope.finalSettings, $rootScope.deviceFilter, $scope.dIds, $scope.dfData, $scope.confirmObj.dType, $scope.confirmObj.subType, $scope.confirmObj.caller? $scope.confirmObj.caller:'',exportPaylodDevice).then(
          function(data){
            $scope.exDevicesProcessing = false;
            if(data.code == 6027){
              ngDialog.close();
              $rootScope.hasErrEx = true;
              $rootScope.errTypeEx = "noData";
            } else{
              $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            }
          },
          function(err){
            $log.error(err);
            $scope.exDevicesProcessing = false;
          }
        );
      } else{
        //  advanced search lists
        $rootScope.advSearchArgObj.f = $rootScope.deviceFilter;
        $rootScope.advSearchArgObj.dsg = $scope.confirmObj.dsg?1:0;
        if(!$scope.auth.upermissions.da.dp){
          $scope.finalSettings = $scope.finalSettings.replace(",prop", "");
          $rootScope.advSearchArgObj.s = $scope.finalSettings;
        } else{
          $rootScope.advSearchArgObj.s = $scope.finalSettings;
        }
        if($rootScope.advSearchArgObj.offset){
          $rootScope.advSearchArgObj.offset = 0;
        }
        $scope.linkOpenFx("d");
        CommonSrv.advSearchExportList($rootScope.advSearchArgObj).then(
          function(data){
            $rootScope.linkOpenObj = {loading:false, url:data.url, surl:""};
            $scope.exDevicesProcessing = false;
          },
          function(err){
            $log.error(err);
            $scope.exDevicesProcessing = false;
          }
        );
      }
    }

    $rootScope.changeServerSetting = function(sid, sName, uType, scType, isDmb, isDW){
      $scope.sid = sid
      $scope.sName = sName
      $scope.uType = uType
      $scope.scType = scType
      $scope.isDmb = isDmb
      $scope.isDW = isDW
      $rootScope.changeServerCommon($scope.sid, $scope.sName, $scope.uType, $scope.scType, $scope.isDmb, $scope.isDW);
      angular.element(document).find('.customSelectServer').removeClass('open')
      $rootScope.selectedServerSetting = $scope.sName
    }

    $scope.tabFx = function(tab, tabFx){
      $rootScope.selectedT = tab;
      if(tabFx == 'tabFx'){
        $scope.selectedTabFx();
      }
    }

    $scope.backBtnFx = function(){
      $rootScope.selectedT = $rootScope.selectedT - 1;
    }

    $scope.hax2rgba = function(color, alpha){
      var curHax = color_convert.to_rgba(color);
      return curHax.split(",")[0]+","+curHax.split(",")[1]+","+curHax.split(",")[2]+","+alpha+")";
    }

    $scope.getAvailableHeight = function(deductableHeight){
      if(document.body && document.body.offsetWidth){
        $scope.winH = document.body.offsetHeight;
      }
      if(document.compatMode == 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth){
        $scope.winH = document.documentElement.offsetHeight;
      }
      if(window.innerWidth && window.innerHeight){
        $scope.winH = window.innerHeight;
      }
      $scope.winH = $scope.winH - deductableHeight;
      return $scope.winH;
    }

    $scope.mainContainerWidth = function(deductableWidth){
      if(!deductableWidth){
        deductableWidth = 0;
      }
      return angular.element(document).find(".mainContainer")[0].clientWidth - deductableWidth;
    }

    $scope.getAvailableWidth = function(deductableWidth){
      $scope.htmlWidth = angular.element(document)[0].children[0].clientWidth;
      $scope.winW = angular.element(document).find(".mainContainer")[0].clientWidth - deductableWidth;

      if($scope.htmlWidth < 1200){
        $scope.tempW = 1200 - $scope.htmlWidth;
        return $scope.winW - $scope.tempW +"px";
      } else{
        return $scope.winW +"px";
      }
    }

    angular.element($window).bind('resize', function(){
      $scope.$apply();
    });
    $rootScope.logOutFx = function(caller){
      if(caller == "logOut"){
        $rootScope.isFileUploading = false;
      }
      if($rootScope.isFileUploading){
        $scope.preventAction("logOut");
      } else{
        CommonSrv.logOut({"token":$scope.auth.token}).then(
          function(data){
            localStorage.removeItem("authServer");
            localStorage.removeItem("authLang");
            localStorage.removeItem("teamsApp");
            //reset content library adv search state
            localStorage.removeItem("isAdvSearch");
            localStorage.removeItem("curFilterObj");
            localStorage.removeItem("isWidgetEdited");
            //action like del, add to sch, replace, archive, and approve/unapprove
            localStorage.removeItem("isActionOnContent");
            localStorage.removeItem("folderIdArrTemp");
            if($rootScope.sso){
              $scope.ssoLogoutURL = $sce.trustAsResourceUrl($rootScope.sso.logout_url);
              $timeout(function(){

                // Remove all saved data from localStorage
                localStorage.clear();

                ngDialog.close();
                $window.location.reload();
              }, 1000);
            } else{

              // Remove all saved data from localStorage
              localStorage.clear();

              ngDialog.close();
              $window.location.reload();
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }

    $scope.arraytoStringFx = function(object){
      $scope.stringIds = [];
      angular.forEach(object, function(obj){
        $scope.stringIds.push(obj.id);
      });
      return $scope.stringIds;
    }

    $scope.arraytoStringMacFx = function(object){
      $scope.stringIds = [];
      angular.forEach(object, function(obj){
        $scope.stringIds.push(obj.mac);
      });
      return $scope.stringIds;
    }

    $scope.reverse = function(s){
      $scope.reverseStr = "";
      for(var i = s.length - 1; i >= 0; i--)
        $scope.reverseStr += s[i];
      return $scope.reverseStr;
    }

    $scope.hubEnc = function(id){
      return btoa($scope.reverse($scope.auth.token) + id + $scope.auth.uid);
    }
    $scope.hubDec = function(id){
      return atob(id).split($scope.reverse($scope.auth.token))[1].split($scope.auth.uid)[0];
    }

    $scope.hubEncrypt = function(id){
      return btoa($scope.auth.token + id + $scope.auth.uname);
    }
    $scope.hubDecrypt = function(id){
      return atob(id).split($scope.auth.token)[1].split($scope.auth.uname)[0];
    }

    $scope.trim = function(str){
			return str.replace(/^\s+|\s+$/g, '');
		}

    $scope.removeInArray = function(array, id){
      angular.forEach(array, function(item){
        if(item.id == id){
          array.splice(array.indexOf(item), 1);
        }
      });
    }

    $rootScope.encryptFx = function(val){
      var curVal = "";
      if(angular.isNumber(val)){
        curVal = val.toString();
      } else{
        curVal = val;
      }

      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      return encrypt.encrypt(curVal);
    };

    $rootScope.decryptFx = function(val){
      var curVal = "";
      if(angular.isNumber(val)){
        curVal = val.toString();
      } else{
        curVal = val;
      }

      var decrypt = new JSEncrypt();
      decrypt.setPrivateKey($scope.priKey);
      return decrypt.decrypt(curVal);
    };


    /*encrypt & decrypt start*/
    $rootScope.endeDataFx = function(c, data, keysToProcess){
      var endeData = angular.copy(data);
      var isDecrypt = c === 'd';

      var process = function (path){
        var keys = path.split('.');
        var source = data;
        var target = endeData;  
        for(var i = 0; i < keys.length - 1; i++){
          var key = keys[i];
          
          if(!source[key]) return; // skip if not present
          source = source[key];

          // Ensure target path exists
          if(!target[key]) target[key] = {};
          target = target[key];
        }

        var lastKey = keys[keys.length - 1];
        if(source[lastKey]){
          target[lastKey] = isDecrypt ? $scope.decryptFx(source[lastKey]) : $scope.encryptFx(source[lastKey]);
        }
      };
      
      for(var j = 0; j < keysToProcess.length; j++){
        process(keysToProcess[j]);
      }
      return endeData;
    };
    /*encrypt & decrypt end*/


    /*chunks encrypt & decrypt*/
    // Helper to split strings into chunks
    function splitIntoChunks(str, size){
      var chunks = [];
      for(var i = 0; i < str.length; i += size){
        chunks.push(str.slice(i, i + size));
      }
      return chunks;
    }

    // Encrypt using public key
    $scope.encryptedChunksFx = function(token){
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey($scope.pubKey);
      var maxChunkSize = 245;
      var chunks = splitIntoChunks(token, maxChunkSize);
      var encryptedChunks = [];
      for(var i = 0; i < chunks.length; i++){
        var chunk = chunks[i];
        var encrypted = encrypt.encrypt(chunk);
        if(!encrypted){
          console.error("Encryption failed for chunk:", chunk);
          return null;
        }
        encryptedChunks.push(encrypted);
      }
      return encryptedChunks;
    };

    // Decrypt using private key
    $scope.decryptChunksFx = function(encryptedChunks){
      var decrypt = new JSEncrypt();
      decrypt.setPrivateKey($scope.priKey);
      var decrypted = "";
      for(var i = 0; i < encryptedChunks.length; i++){
        var encryptedChunk = encryptedChunks[i];
        var decryptedChunk = decrypt.decrypt(encryptedChunk);
        if(decryptedChunk === false){
          console.error("Decryption failed for chunk:", encryptedChunk);
          return null;
        }
        decrypted += decryptedChunk;
      }
      return decrypted;
    };

    // Ex.
    // Encrypt
    // var encryptedChunks = encryptedChunksFx(originalToken);
    // console.log("Encrypted:", encryptedChunks);
    // // Decrypt
    // var decryptedToken = decryptChunksFx(<encrypted array>);
    // console.log("Decrypted:", decryptedToken);


    /*Notifications*/
    $scope.loadNotification = function(caller){
      if(!caller){
        return;
      }
      $scope.notificationLoading = true;
      CommonSrv.getNotifications().then(
        function(data){
          $scope.notificationLoading = false;
          $scope.notifications = data;
          $scope.auth = angular.fromJson(localStorage.getItem("auth"));
          $scope.totalNotifications = 0;
          if($scope.notifications.uc > 0){//unapproved content
            $scope.totalNotifications++;
          }
          if($scope.notifications.ec > 0){//expired content
            $scope.totalNotifications++;
          }
          if($scope.notifications.dc > 0){//deleted content
            $scope.totalNotifications++;
          }
          if($scope.notifications.ut > 0){//unapproved template
            $scope.totalNotifications++;
          }
          if($scope.notifications.it > 0){//incomplete template
            $scope.totalNotifications++;
          }
          if($scope.notifications.us > 0){//unapproved schedule
            $scope.totalNotifications++;
          }
          if($scope.notifications.is > 0){//incomplete schedule
            $scope.totalNotifications++;
          }
          if($scope.notifications.es > 0){//expired schedule
            $scope.totalNotifications++;
          }
          if($scope.notifications.ufl > 0){//unapproved frame layout
            $scope.totalNotifications++;
          }
          if($scope.notifications.if > 0){//incomplete frame layout
            $scope.totalNotifications++;
          }
          if($scope.notifications.efla > 0){//expired frame layout assignment
            $scope.totalNotifications++;
          }
          if($scope.notifications.inv > 0){//Invoice generated
            $scope.totalNotifications++;
          }
          if($scope.notifications.ucs > 0){//unapproved creative services
            $scope.totalNotifications++;
          }
        },
        function(err){
          $scope.notificationLoading = false;
          $log.error(err);
        }
      );
    }

    $scope.closeFiltered = function(id, selectedObj, selectedDevices, selectedGroups){
      angular.forEach(selectedObj, function(item){
        if(id == item.id){
          if(selectedDevices && selectedObj[selectedObj.indexOf(item)].type == "device"){
            $scope.curItem = selectedDevices.filter(function(obj){return obj.id == item.id;})[0];
            selectedDevices.splice(selectedDevices.indexOf($scope.curItem), 1);
          } else if(selectedGroups && selectedObj[selectedObj.indexOf(item)].type == "group"){
            $scope.curItem = selectedGroups.filter(function(obj){return obj.id == item.id;})[0];
            selectedGroups.splice(selectedGroups.indexOf($scope.curItem), 1);
          }
          selectedObj.splice(selectedObj.indexOf(item), 1);
        }
      });
      angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
        if($(item).attr('data-id') == id){
          $(item).removeClass('ui-selected');
          $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
        }
      });
      $rootScope.selectedItems = [];
    }

    $(document).on("click",".input-group-addon", function(e){
      e.preventDefault();
      e.stopPropagation();
      if(!$(this).siblings(".picker").is(':disabled')){
        $(this).siblings(".picker").click();
      }
    });

    /**This is a common function for add/remove Setected item in multiple setected list
        *Ex.1 Note:code view:- $scope.listManipulateFx(add/remove, available item list, assigned item list, add model/remove model name);
        *Ex.2 Note:html view:- ng-click="listManipulateFx("add"/"remove", available item list, assigned item list, add model/remove model name)";
        **Using in permission, addToGroup and emergencyMsg > Devices
    **/
    $scope.listManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type){
      if(caller == "add"){
        if(type == "d"){
          $rootScope.resetD(caller);
        } else if(type == "g"){
          $rootScope.resetG(caller);
        } else if(type == "t"){
          $rootScope.resetT(caller);
        } else if(type == "u"){
          $rootScope.resetU(caller);
        } else if(type == "incTag" || type == "excTag"){
          $rootScope.resetTagFx(caller, type);
        } else if(type == "incGrp" || type == "excGrp"){
          $rootScope.resetGrpFx(type);
        }
        angular.forEach(curModel, function(avlItem){
          angular.forEach(availableList, function(item){
            if(avlItem.id == item.id){
              avlItem.selected = false;
              assignedList.push(avlItem);
              availableList.splice(availableList.indexOf(item), 1);
            }
          });
        });
      } else if(caller == "remove"){
        if(type == "d"){
          $rootScope.resetD(caller);
        } else if(type == "g"){
          $rootScope.resetG(caller);
        } else if(type == "t"){
          $rootScope.resetT(caller);
        } else if(type == "u"){
          $rootScope.resetU(caller);
        } else if(type == "remTag"){
          $rootScope.resetTagFx(caller, type);
        } else if(type == "remGrp"){
          $rootScope.resetGrpFx(type);
        }
        angular.forEach(curModel, function(assigItem){
          angular.forEach(assignedList, function(item){
            if(assigItem.id == item.id){
              assigItem.selected = false;
              availableList.push(assigItem);
              assignedList.splice(assignedList.indexOf(item), 1);
            }
          });
        });
        if(secondAssignedList && curSecondModel){
          angular.forEach(curSecondModel, function(assigItem){
            angular.forEach(secondAssignedList, function(item){
              if(assigItem.id == item.id){
                assigItem.selected = false;
                availableList.push(assigItem);
                secondAssignedList.splice(secondAssignedList.indexOf(item), 1);
              }
            });
          });
        }
      }
    }
    /*Permission*/
    $rootScope.rootManipulateFx = function(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type){
      $scope.listManipulateFx(caller, availableList, assignedList, curModel, secondAssignedList, curSecondModel, type);
    }

    $scope.sortFx = function(sortType, sortVal, targetList, infoObj, moduleName, targetList2){
      if(sortType === "label"){
        if(sortVal === "asc"){
          targetList = targetList.sort(function(a, b){
            return a.label.localeCompare(b.label);
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return a.label.localeCompare(b.label);
            });
          }
        } else if(sortVal === "desc"){
          targetList = targetList.sort(function(a, b){
            return b.label.localeCompare(a.label);
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return b.label.localeCompare(a.label);
            });
          }
        }
      } else if(sortType === "approvedon"){
        if(sortVal === "asc"){
          targetList = targetList.sort(function(a, b){
            return a.approvedOn - b.approvedOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              if(a.approvedOn - b.approvedOn){
                return a.approvedOn - b.approvedOn;
              } else{
                return a.label.localeCompare(b.label);
              }
            });
          }
        } else if(sortVal === "desc"){
          targetList = targetList.sort(function(a, b){
            return b.approvedOn - a.approvedOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              if(a.approvedOn - b.approvedOn){
                return b.approvedOn - a.approvedOn;
              } else{
                return a.label.localeCompare(b.label);
              }
            });
          }
        }
      } else if(sortType === "createdon"){
        if(sortVal === "asc"){
          targetList = targetList.sort(function(a, b){
            return a.createdOn - b.createdOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return a.createdOn - b.createdOn;
            });
          }
        } else if(sortVal === "desc"){
          targetList = targetList.sort(function(a, b){
            return b.createdOn - a.createdOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return b.createdOn - a.createdOn;
            });
          }
        }
      } else if(sortType === "expireon"){
        if(sortVal === "asc"){
          targetList = targetList.sort(function(a, b){
            return a.expireOn - b.expireOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return a.expireOn - b.expireOn;
            });
          }
        } else if(sortVal === "desc"){
          targetList = targetList.sort(function(a, b){
            return b.expireOn - a.expireOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return b.expireOn - a.expireOn;
            });
          }
        }
      } else if(sortType === "editedon"){
        if(sortVal === "asc"){
          targetList = targetList.sort(function(a, b){
            return a.createdOn - b.createdOn;
          });
          targetList = targetList.sort(function(a, b){
            return a.editedOn - b.editedOn;
          });
          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return a.createdOn - b.createdOn;
            });
            targetList2 = targetList2.sort(function(a, b){
              return a.editedOn - b.editedOn;
            });
          }
        } else if(sortVal === "desc"){
          targetList = targetList.sort(function(a, b){
            return b.createdOn - a.createdOn;
          });
          targetList = targetList.sort(function(a, b){
            return b.editedOn - a.editedOn;
          });

          if(targetList2){
            targetList2 = targetList2.sort(function(a, b){
              return b.createdOn - a.createdOn;
            });
            targetList2 = targetList2.sort(function(a, b){
              return b.editedOn - a.editedOn;
            });
          }
        }
      }
      infoObj.sortVal = sortVal;
      infoObj.sortType = sortType;
      CommonSrv.setSort({"type":sortType,"val":sortVal,"module":moduleName}).then(
        function(data){
          $state.reload();
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.fontFamily = [
      {label:"Arial", value:"arial"},
      {label:"Arial Black", value:"arial black"},
      {label:"Berlingske Sans Bold", value:"BerlingskeSansBold"},
      {label:"Breakers Slab", value:"Breakers Slab"},
      {label:"Breakers Slab Black", value:"Breakers Slab Black"},
      {label:"Breakers Slab Light", value:"Breakers Slab Light"},
      {label:"Breakers Slab Thin", value:"Breakers Slab Thin"},
      {label:"Breakers Slab Ultra", value:"Breakers Slab Ultra"},
      {label:"Calibri", value:"Calibri"},
      {label:"Calibri Light", value:"Calibri Light"},
      {label:"Calisto MT", value:"calisto MT"},
      {label:"Cambria", value:"cambria"},
      {label:"Candara", value:"candara"},
      {label:"Century Gothic", value:"century gothic"},
      {label:"Chalet-Pinkberry", value:"Chalet-Pinkberry"},
      {label:"Comic Sans MS", value:"comic sans MS"},
      {label:"Constantia", value:"constantia"},
      {label:"Copernicus", value:"copernicus"},
      {label:"Corbel", value:"corbel"},
      {label:"Dogica-Pixel", value:"dogica-pixel"},
      {label:"Franklin Gothic", value:"franklin gothic"},

      /* Futura Cyrillic Bold */
      {label:'Futura Cyrillic Bold', value:'futura-cyrillic-bold'},
      {label:'Futura Cyrillic Extra Bold', value:'futura-cyrillic-extra-bold'},
      {label:'Futura Cyrillic Heavy', value:'futura-cyrillic-heavy'},
      {label:'Futura Cyrillic Book', value:'futura-cyrillic-book'},
      {label:'Futura Cyrillic Demi', value:'futura-cyrillic-demi'},
      {label:'Futura Cyrillic Light', value:'futura-cyrillic-light'},
      {label:'Futura Cyrillic Medium', value:'futura-cyrillic-medium'},

      {label:"Futura LT", value:"Futura LT"},
      {label:"Futura LT Book", value:"Futura LT Book"},
      {label:"Futura LT Book Condensed", value:"Futura LT Book Condensed"},
      {label:"Futura LT Condensed Light", value:"Futura LT Condensed Light"},
      {label:"Futura LT Condensed Extra Bold", value:"Futura LT Condensed Extra Bold"},
      {label:"Futura LT Extra Bold", value:"Futura LT Extra Bold"},
      {label:"Futura LT Heavy", value:"Futura LT Heavy"},
      {label:"Futura LT Light", value:"Futura LT Light"},

      {label:"Georgia", value:"georgia"},
      {label:"Gotham", value:"gotham"},
      {label:"Helvetica LT 45 Light", value:"Helvetica LT 45 Light"},
      {label:"Impact", value:"impact"},
      {label:"IntelClear_Bds", value:"IntelClear_Bd"},
      {label:"IntelClear_BdIt", value:"IntelClear_BdIt"},
      {label:"IntelClear_It", value:"IntelClear_It"},
      {label:"IntelClear_Lt", value:"IntelClear_Lt"},
      {label:"IntelClear_LtIt", value:"IntelClear_LtIt"},
      {label:"IntelClear_Rg", value:"IntelClear_Rg"},
      {label:"IntelClearPro_Bd", value:"IntelClearPro_Bd"},
      {label:"intelone-display-bold", value:"intelone-display-bold"},
      {label:"intelone-display-light", value:"intelone-display-light"},
      {label:"intelone-display-medium", value:"intelone-display-medium"},
      {label:"intelone-display-regular", value:"intelone-display-regular"},
      {label:"Intro", value:"Intro"},
      {label:"Intro Black Alt", value:"Intro Black Alt"},
      {label:"Intro Black Caps", value:"Intro Black Caps"},
      {label:"Intro Black Inline", value:"Intro Black Inline"},
      {label:"Intro Black Inline Caps", value:"Intro Black Inline Caps"},
      {label:"Intro Bold Alt", value:"Intro Bold Alt"},
      {label:"Intro Bold Caps", value:"Intro Bold Caps"},
      {label:"Intro Book Alt", value:"Intro Book Alt"},
      {label:"Intro Book Caps", value:"Intro Book Caps"},
      {label:"Intro Light", value:"Intro Light"},
      {label:"Intro Light Alt", value:"Intro Light Alt"},
      {label:"Intro Light Caps", value:"Intro Light Caps"},
      {label:"Intro Regular Caps", value:"Intro Regular Caps"},
      {label:"Intro Thin", value:"Intro Thin"},
      {label:"Intro Thin Caps", value:"Intro Thin Caps"},
      {label:"Lucida Console", value:"lucida console"},
      {label:"Lucida Handwriting", value:"lucida handwriting"},
      {label:"Market Pro Bold", value:"MarketProBold"},
      {label:"Martel Light", value:"martellight"},
      {label:"Martel Regular", value:"martelregular"},
      {label:"Menlo Bold", value:"Menlo Bold"},
      {label:"Menlo Bold Italic", value:"Menlo Bold Italic"},
      {label:"Menlo Italic", value:"Menlo Italic"},
      {label:"Menlo Regular", value:"Menlo Regular"},
      {label:"Mission Script", value:"Mission Script"},
      {label:"Menlo Regular", value:"Menlo Regular"},
      
      /*Montserrat*/
      {label:"Montserrat Medium", value:"Montserrat-Medium"},
      {label:"Montserrat Medium Italic", value:"Montserrat-MediumItalic"},
      {label:"Montserrat Regular", value:"Montserrat-Regular"},
      {label:"Montserrat SemiBold", value:"Montserrat-SemiBold"},
      {label:"Montserrat SemiBold Italic", value:"Montserrat-SemiBoldItalic"},
      {label:"Montserrat Thin", value:"Montserrat-Thin"},
      {label:"Montserrat Thin Italic", value:"Montserrat-ThinItalic"},
      {label:"Montserrat Black Italic", value:"Montserrat-BlackItalic"},
      {label:"Montserrat Bold", value:"Montserrat-Bold"},
      {label:"Montserrat Bold Italic", value:"Montserrat-BoldItalic"},
      {label:"Montserrat Extra Bold", value:"Montserrat-ExtraBold"},
      {label:"Montserrat Extra Bold Italic", value:"Montserrat-ExtraBoldItalic"},
      {label:"Montserrat Extra Light", value:"Montserrat-ExtraLight"},
      {label:"Montserrat Extra Light Italic", value:"Montserrat-ExtraLightItalic"},
      {label:"Montserrat Italic", value:"Montserrat-Italic"},
      {label:"Montserrat Light", value:"Montserrat-Light"},
      {label:"Montserrat Light Italic", value:"Montserrat-LightItalic"},
      {label:"Montserrat Black", value:"Montserrat-Black"},

      {label:"Myriad Pro", value:"Myriad Pro"},
      {label:"Myriad Pro Condensed", value:"Myriad Pro Condensed"},
      {label:"Neutra Text", value:"Neutra Text"},
      {label:"Neutra Text Alt", value:"Neutra Text Alt"},
      {label:"Neutraface Text", value:"Neutraface Text"},
      {label:"Neutraface Text Alt", value:"Neutraface Text Alt"},
      {label:"New Kansas Semi Bold", value:"NewKansasSemiBold"},

      {label:"OneDot", value:'One Dot'},
      {label:"OneDotCd", value:'OneDotCd'},
      {label:"OneDotExt", value:'OneDotExt'},
      // {label:"OneDotExt-Bold", value:'OneDotExt-Bold'},
      // {label:"OneDotExt-BoldItalic", value:'OneDotExt-BoldItalic'},
      // {label:"OneDotExt-Italic", value:'OneDotExt-Italic'},
      // {label:"OneDotExt-Lt", value:'OneDotExt-Lt'},
      // {label:"OneDotExt-LtItalic", value:'OneDotExt-LtItalic'},
      
      
      /* Open Sans */
      {label:"Open Sans Bold", value:"opensans-bold"},
      {label:"Open Sans Bold Italic", value:"opensans-bold-italic"},
      {label:"Open Sans Extra Bold", value:"opensans-extra-bold"},
      {label:"Open Sans Extra Bold Italic", value:"opensans-extra-bold-italic"},
      {label:"Open Sans Italic", value:"opensans-italic"},
      {label:"Open Sans Light", value:"opensans-light"},
      {label:"Open Sans Light Italic", value:"opensans-light-italic"},
      {label:"Open Sans Medium", value:"opensans-medium"},
      {label:"Open Sans Medium Italic", value:"opensans-medium-italic"},
      {label:"Open Sans Regular", value:"opensans-regular"},
      {label:"Open Sans Semi Bold", value:"opensans-semi-bold"},
      {label:"Open Sans Semi Bold Italic", value:"opensans-semi-bold-italic"},

      {label:"Open Sans Condensed Bold", value:"opensans-condensed-bold"},
      {label:"Open Sans Condensed Bold Italic", value:"opensans-condensed-bold-italic"},
      {label:"Open Sans Condensed Extra Bold", value:"opensans-condensed-extra-bold"},
      {label:"Open Sans Condensed Extra Bold Italic", value:"opensans-condensed-extra-bold-italic"},
      {label:"Open Sans Condensed Italic", value:"opensans-condensed-italic"},
      {label:"Open Sans Condensed Light", value:"opensans-condensed-light"},
      {label:"Open Sans Condensed Light Italic", value:"opensans-condensed-light-italic"},
      {label:"Open Sans Condensed Medium", value:"opensans-condensed-medium"},
      {label:"Open Sans Condensed Medium Italic", value:"opensans-condensed-medium-italic"},
      {label:"Open Sans Condensed Regular", value:"opensans-condensed-regular"},
      {label:"Open Sans Condensed Semi Bold", value:"opensans-condensed-semi-bold"},
      {label:"Open Sans Condensed Semi Bold Italic", value:"opensans-condensed-semi-bold-italic"},

      {label:"Open Sans Semi Condensed Bold", value:"opensans-semi-condensed-bold"},
      {label:"Open Sans Semi Condensed Bold Italic", value:"opensans-semi-condensed-bold-italic"},
      {label:"Open Sans Semi Condensed Extra Bold", value:"opensans-semi-condensed-extra-bold"},
      {label:"Open Sans Semi Condensed Extra Bold Italic", value:"opensans-semi-condensed-extra-bold-italic"},
      {label:"Open Sans Semi Condensed Italic", value:"opensans-semi-condensed-italic"},
      {label:"Open Sans Semi Condensed Light", value:"opensans-semi-condensed-light"},
      {label:"Open Sans Semi Condensed Light Italic", value:"opensans-semi-condensed-light-italic"},
      {label:"Open Sans Semi Condensed Medium", value:"opensans-semi-condensed-medium"},
      {label:"Open Sans Semi Condensed Medium Italic", value:"opensans-semi-condensed-medium-italic"},
      {label:"Open Sans Semi Condensed Regular", value:"opensans-semi-condensed-regular"},
      {label:"Open Sans Semi Condensed Semi Bold", value:"opensans-semi-condensed-semi-bold"},
      {label:"Open Sans Semi Condensed Semi Bold Italic", value:"opensans-semi-condensed-semi-bold-italic"},
      
      {label:'Palatino Linotype', value:'palatino linotype'},

      /* Permanent Markerr */
      {label:'Permanent marker regular', value:'permanent-marker-regular'},

      /* Placard Condensed */
      {label:'Placard condensed', value:'placard-condensed'},

      {label:"PizzaPress-Antique", value:'PizzaPress-Antique'},
      {label:"PizzaPressExt-Fill", value:'PizzaPressExt-Fill'},
      {label:"PizzaPressExt-Inline", value:'PizzaPressExt-Inline'},
      {label:"PizzaPressExt-ReverseShadow", value:'PizzaPressExt-ReverseShadow'},
      {label:"PizzaPress-Fill", value:'PizzaPress-Fill'},
      {label:"PizzaPress-Inline", value:'PizzaPress-Inline'},
      {label:"PizzaPress-OrnamentsNeue", value:'PizzaPress-OrnamentsNeue'},
      {label:"PizzaPress-Outline", value:'PizzaPress-Outline'},
      {label:"PizzaPress-Regular", value:'PizzaPress-Regular'},
      {label:"PizzaPress-ReverseShadow", value:'PizzaPress-ReverseShadow'},
      {label:"PizzaPress-Shadow", value:'PizzaPress-Shadow'},
      
      {label:"Roboto Bold", value:"robotobold"},
      {label:"Roboto Condensed", value:"Roboto Condensed"},
      {label:"Roboto Light", value:"robotolight"},
      {label:"Roboto Regular", value:"robotoregular"},
      {label:"Segoe Print", value:"segoe Print"},
      {label:"Segoe UI", value:"segoe UI"},
      /* Sofia Sans */
      {label:'Sofia Sans Regular', value:'sofiasans-regular'},
      {label:'Sofia Sans Black', value:'sofiasans-black'},
      {label:'Sofia Sans Black Italic', value:'sofiasans-black-italic'},
      {label:'Sofia Sans Bold', value:'sofiasans-bold'},
      {label:'Sofia Sans Bold Italic', value:'sofiasans-bold-italic'},
      {label:'Sofia Sans Italic', value:'sofiasans-italic'},
      {label:'Sofia Sans Light', value:'sofiasans-light'},
      {label:'Sofia Sans Medium', value:'sofiasans-medium'},
      {label:'Sofia Sans Thin', value:'sofiasans-thin'},
      /* Sofia Sans Condensed */
      {label:'Sofia Sans Condensed Regular', value:'sofiasans-condensed-regular'},
      {label:'Sofia Sans Condensed Black', value:'sofiasans-condensed-black'},
      {label:'Sofia Sans Condensed Black Italic', value:'sofiasans-condensed-black-italic'},
      {label:'Sofia Sans Condensed Bold', value:'sofiasans-condensed-bold'},
      {label:'Sofia Sans Condensed Bold Italic', value:'sofiasans-condensed-bold-italic'},
      {label:'Sofia Sans Condensed Extra Bold', value:'sofiasans-condensed-extra-bold'},
      {label:'Sofia Sans Condensed Extra Light', value:'sofiasans-condensed-extra-light'},
      {label:'Sofia Sans Condensed Hair Line', value:'sofiasans-condensed-hair-line'},
      {label:'Sofia Sans Condensed Italic', value:'sofiasans-condensed-italic'},
      {label:'Sofia Sans Condensed Light', value:'sofiasans-condensed-light'},
      {label:'Sofia Sans Condensed Medium', value:'sofiasans-condensed-medium'},
      {label:'Sofia Sans Condensed Semi Bold', value:'sofiasans-condensed-semi-bold'},
      {label:'Sofia Sans Condensed Thin', value:'sofiasans-condensed-thin'},
      
      {label:"Source Sans Pro Bold", value:"Source Sans Pro Bold"},
      {label:"Source Sans Pro Bold Italic", value:"Source Sans Pro Bold Italic"},
      {label:"Source Sans Pro Regular", value:"Source Sans Pro Regular"},
      {label:"Source Sans Pro Regular Italic", value:"Source Sans Pro Regular Italic"},
      {label:"SUNN Serif Bold", value:"SUNN Serif Bold"},
      {label:"SUNN Serif Regular", value:"SUNN Serif Regular"},
      {label:"Tahoma", value:"tahoma"},
      {label:"Terminus", value:'terminus'},
      {label:"Tewi", value:'tewi'},
      {label:"Times New Roman", value:"Times New Roman"},
      {label:"Trebuchet MS", value:"trebuchet MS"},
      {label:"TwoDots", value:'TwoDots'},
      {label:"Verdana", value:"verdana"},
      {label:"Work Sans Regular", value:"WorkSansRegular"}



      // {label:"TwoDots-Black", value:'TwoDots-Black'},
      // {label:"TwoDots-BlackItalic", value:'TwoDots-BlackItalic'},
      // {label:"TwoDots-Bold", value:'TwoDots-Bold'},
      // {label:"TwoDots-BoldItalic", value:'TwoDots-BoldItalic'},
      // {label:"TwoDots-Italic", value:'TwoDots-Italic'},

    ];
    $scope.fontFamilySelected = $scope.fontFamily[12];

    $scope.connection = navigator.onLine;
    $window.addEventListener("offline", function(){
      $rootScope.$apply(function(){
        $scope.connection = false;
        $scope.isConnection = false;
        $scope.connectionFx();
      });
    }, false);
    $window.addEventListener("online", function(){
      $rootScope.$apply(function(){
        $scope.connection = true;
        if(!$scope.isConnection){
          Notification.clearAll();
        }
      });
    }, false);
    $scope.connectionFx = function(){
      Notification.error({message:$filter("translate")('cm.msg.27'), positionX:'center', delay:null, replaceMessage:true});
    }
    if(!$scope.connection){
      $scope.connectionFx();
    }
    $rootScope.toastNotificationFx = function(type, data, suffix){
      if(data && data.code == 5000){
        $rootScope.resetSession(true);
      }
      if(!suffix){
        suffix = "";
      }
      if($scope.connection){
        $scope.isConnection = true;
        angular.forEach($scope.toastNotification, function(toast){
          if(data && (toast.id == data.code)){
            if(data.code == 5000){
              Notification.error({message:toast.en, positionX:'center', replaceMessage:true});
            } else if(data.code == 15012){
              Notification.error({message:toast.en, positionX:'center', replaceMessage:true});
            } else if(data.code == 4004){
              Notification.error({message:toast.en + " " + suffix, positionX:'center', replaceMessage:true});
            } else{
              if(type == "success"){
                Notification.success({message:toast.en + suffix, positionX:'center', replaceMessage:true});
              } else if(type == "info"){
                if(data.id){
                  localStorage.setItem("curPathId", data.id);
                  localStorage.setItem("addedDeviceId", data.id);
                  localStorage.setItem("curScheduleGroupId", data.id);
                  localStorage.setItem("curTemplateId", data.id);
                  localStorage.setItem("curRoleId", data.id);
                }
                if(data.userGroupId){
                  localStorage.setItem("userGroupId", data.userGroupId);
                }
                if(data.aId){
                  localStorage.setItem("aId", data.aId);
                }
                if(data.templateId){
                  localStorage.setItem("curTemplateId", data.templateId);
                }
                if(data.scheduleId){
                  localStorage.setItem("curScheduleId", data.scheduleId);
                }
                if(data.assignmentId){
                  localStorage.setItem("curAssignmentId", data.assignmentId);
                }
                if(data.layoutId){
                  localStorage.setItem("curLayoutId", data.layoutId);
                }
                if(data.deviceGroupId){
                  localStorage.setItem("addedDeviceGroupId", data.deviceGroupId);
                }
                Notification.warning({message:toast.en + suffix, positionX:'center', replaceMessage:true});
              } else if(type == "danger"){
                Notification.error({message:toast.en + suffix, positionX:'center', replaceMessage:true});
              }
            }
          } else if(data && data.code == 99999){
            $scope.curLang = localStorage.getItem("loginLang");
            if($scope.curLang != ""){
              $state.go("login", {id:$scope.curLang});
            } else{
              $state.go("login");
            }
         }
        });
      }
    }
    $rootScope.itemInArray = function(arr, obj){
			for(var i=0; i<arr.length; i++){
				if(arr[i] == obj) return true;
			}
		}

    $scope.loadMoreHistory = function(count){
      if(count == 0){
        $scope.allHistoryLoaded = false;
        $scope.editHistory = {logs:[]};
      } else if($scope.editHistory.logs.length == $scope.editHistory.info.totalCount){
        $scope.allHistoryLoaded = true;
      }
      if(!$scope.allHistoryLoaded){
        $scope.editHistoryObj.offset = $scope.editHistory.logs.length;
        CommonSrv.getEditHistory($scope.editHistoryObj).then(
          function(data){
            $scope.historyLoading = false;
            if(data.info){
              $scope.editHistory.info = data.info;
            }
            if(data.logs.length > 0){
              $scope.editHistory.logs = $scope.editHistory.logs.concat(data.logs);
            } else{
              $scope.allHistoryLoaded = true;
            }
          },
          function(err){
            $scope.historyLoading = false;
            $log.error(err);
          }
        );
      }
    }

    $scope.editHistoryFx = function(id, caller, label){
      $scope.editHistoryObj = {id:id, type:caller, label:label};
      $scope.historyLoading = true;
      $scope.editHistory = {};

      $scope.loadMoreHistory(0);
      ngDialog.open({
        template:"app/common/popup/editHistory.html",
        width:750,
        scope:$scope,
        data:$scope.editHistoryObj,
        closeByDocument:false
      });
    }

    $scope.noDuplicates = function(arr){
    	var curArr = [];
    	angular.forEach(arr, function(item){
    		var exists = false;
    		angular.forEach(curArr, function(item1){
    			if(angular.equals(item.Id, item1.Id)){
    			  exists = true;
    			}
    		});
    		if(exists === false && item.Id !== ""){
    		  curArr.push(item);
    		}
    	});
      return curArr;
    };

    // $scope.linkOpenFx = function(url, surl, label, type, size, pSize){
    $scope.linkOpenFx = function(caller, url, surl, label, type, size, pSize){
      if(caller == "m"){
        $rootScope.linkOpenObj = {url:url, surl:surl, label:label, type:type, size:size, pSize:pSize, loading:false};
      }
      ngDialog.open({
        template:"app/common/popup/saveLinkAs.html",
        width:500,
        scope:$scope,
        data:$scope.linkOpenObj, //{url:url, surl:surl, label:label, type:type, size:size, pSize:pSize},
        closeByDocument:false
      });
    }

    /*Advanced Search*/
    $scope.advancedSearchOpen = function(caller, step, id, opt){
      $scope.advSearchObj = {caller:caller, step:step, id:id, opt:opt};
      $scope.dialogW = 1280;
      if(caller == "s" || caller == "d" || caller == "r"){
        // $scope.dialogW = 650;
        $scope.dialogW = 1280;
      }
      ngDialog.open({
        template:"app/common/popup/advancedSearch.html",
        width:$scope.dialogW,
        scope:$scope,
        data:$scope.advSearchObj,
        closeByEscape:false,
        closeByDocument:false,
        className:"ngdialog-theme-default ngdialog-preview",
        controller:"AdvancedSearchController"
      });
    }

    $scope.tpuGoFx = function(){
      $scope.listLoading = true;
      CLTPSrv.getTupList().then(
        function(data){
          $scope.tpuList = data;
          if($state.$current.parent.self.name == "hub.contentAdd.thirdParty"){
            if($state.current.name == "hub.contentAdd.thirdParty.tpuDbox" && $scope.tpuList.db){
              $state.go("hub.contentAdd.thirdParty.tpuDbox");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuFb" && $scope.tpuList.fb){
              $state.go("hub.contentAdd.thirdParty.tpuFb");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuFtp" && $scope.tpuList.ftp){
              $state.go("hub.contentAdd.thirdParty.tpuFtp");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuDrive" && $scope.tpuList.gd){
              $state.go("hub.contentAdd.thirdParty.tpuDrive");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuInsta" && $scope.tpuList.in){
              $state.go("hub.contentAdd.thirdParty.tpuInsta");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuTw" && $scope.tpuList.tw){
              $state.go("hub.contentAdd.thirdParty.tpuTw");
            } else if($state.current.name == "hub.contentAdd.thirdParty.tpuUrl" && $scope.tpuList.url){
              $state.go("hub.contentAdd.thirdParty.tpuUrl");
            }
          } else{
            if($scope.tpuList.db){
              $state.go("hub.contentAdd.thirdParty.tpuDbox");
            } else if($scope.tpuList.fb){
              $state.go("hub.contentAdd.thirdParty.tpuFb");
            } else if($scope.tpuList.ftp){
              $state.go("hub.contentAdd.thirdParty.tpuFtp");
            } else if($scope.tpuList.gd){
              $state.go("hub.contentAdd.thirdParty.tpuDrive");
            } else if($scope.tpuList.ig){
              $state.go("hub.contentAdd.thirdParty.tpuInsta");
            } else if($scope.tpuList.tw){
              $state.go("hub.contentAdd.thirdParty.tpuTw");
            } else if($scope.tpuList.url){
              $state.go("hub.contentAdd.thirdParty.tpuUrl");
            }
          }
          $scope.listLoading = false;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    if($state.$current.parent.self.name == "hub.contentAdd.thirdParty"){
      $scope.tpuGoFx();
    }

    $rootScope.showWidgetFx = function(){
      $scope.isWidgetEmpty = true;
      $scope.listLoading = true;
      $scope.isListOpen = true;
      $scope.widgetList = {};
      if(!$state.params.id){
        ContentLibraryWidgetsSrv.getAll().then(
          function(data){
            $scope.widgetList = data;
            $scope.listLoading = false;
            $.each($scope.widgetList, function(key, val){
              if(val){
                $scope.isWidgetEmpty = false;
                if(key != "f45S" && key != "servername"){
                  $state.go("hub.contentAdd.widgetAddTab." + key);
                }
                return false;
              } else{
                $scope.isWidgetEmpty = true;
                $rootScope.tabView = true;
                $state.go("hub.contentAdd.widgetAddTab.empty");
              }
            });
          },
          function(err){
            $log.error(err);
          }
        );
      }
    }
    if($state.current.name == "hub.contentAdd.widgetAddTab.empty"){
      $rootScope.showWidgetFx();
    }

    /*Release Notes Popup*/
    $scope.appName = "app.lsquared.slide";
    function getBaseUrl(){
      var url = new URL(window.location.href);
      
      if(url.port === "1150"){
        url.port = "1154";
      }
      //Change full origin "http://localhost:3000" → "https://us.lsquared.com"
      if(url.hostname === "localhost" && url.port === "3000"){
        url.protocol = "https:";
        url.hostname = "us.lsquared.com";
        url.port = "";
      } else if(url.hostname === "hub.lsquared.com"){
        $scope.appName = "app.lsquared.hub";
      } else if(url.hostname === "ttc.lsquared.com"){
        $scope.appName = "app.lsquared.ttc";
      } else if(url.hostname === "nav.lsquaredcanada.com"){
        $scope.appName = "app.lsquared.nav";
      } else if(url.hostname === "lifelabs.lsquared.com"){
        $scope.appName = "app.lsquared.ll";
      } else if(url.hostname === "sharedservices.lsquared.com"){
        $scope.appName = "app.lsquared.ss";
      }
      return url.origin;
    }
    $scope.appHost = getBaseUrl();

    $scope.appsOpen = function(obj, key){
      $scope.reNotesLoading = true;
      var cauId = 0;
      var curLabel = obj.label;
      if(obj.hubAppType){
        cauId = obj.hubAppType.id;
        curLabel = obj.hubAppType.label;
      }
      
      $scope.reNotes = {l:curLabel, id:cauId, list:[], cv:obj.version, isDown:true, isLink:false, isStoreLink:false, key:key};

      $scope.curData = {id:0, data:""};
      $scope.curData.id = angular.copy($scope.reNotes.curId);
      if(cauId == 2){ //L Squared ESlide
        $scope.curData.id = 1;
      } else if(cauId == 4){ //L Squared WSlide
        $scope.curData.id = 2;
        $scope.reNotes.isLink = true;
      } else if(cauId == 5){ //L Squared TSlide
        $scope.curData.id = 3;
        $scope.reNotes.isLink = true;
        $scope.reNotes.isDown = false;
      } else if(cauId == 11){ //L Squared ASlide
        $scope.curData.id = 4;
      } else if(cauId == 12){ //L Squared ASlide (Play Store)
        $scope.curData.id = 4;
        $scope.reNotes.url = obj.url;
        $scope.reNotes.isDown = false;
        $scope.reNotes.isStoreLink = true;
      } else if(cauId == 7){ //L Squared Publisher
        $scope.curData.id = 5;
      } else if(cauId == 0){//hub
        $scope.curData.id = 7;
        $scope.reNotes.isDown = false;
      } else if(cauId == 13){//L Squared RSlide
        $scope.curData.id = 6;
      } else if(cauId == 14){//L Squared PSlide
        $scope.curData.id = 9;
        $scope.reNotes.url = obj.url;
        $scope.reNotes.isDown = false;
      } else if(cauId == 15){//L Squared BSlide
        $scope.curData.id = 10;
        $scope.reNotes.url = obj.url;
      }
      
      SupportSrv.getRReleaseNotes($scope.curData.id).then(//$scope.reNotes.cv
        function(data){
          $scope.reNotes.list = data[0];
          $scope.reNotesLoading = false;
        },
        function(err){
          $scope.reNotesLoading = false;
          $log.error(err);
        }
      );
      ngDialog.open({
        template:"app/support/popup/releaseNotes.html",
        width:750,
        scope:$scope,
        closeByDocument:false
      });
    }

    /*Feedback Popup*/
    $scope.feedbackOpen = function(){
      ngDialog.open({
        template:"app/support/popup/feedback.html",
        width:500,
        scope:$scope,
        closeByDocument:false,
        controller:"SupportController"
      });
    }
    $scope.bugsOpen = function(id){/*Report Bug Popup*/
      // $scope.bugsLoading = false;
      // DevicesSrv.getDevice().then(
      //   function(data){
      //     $scope.bugsLoading = false;
      //     if(id){
      //       angular.forEach(data.devices, function(device){
      //         if(id == device.id){
      //           device.selected = true;
      //         }
      //       });
      //     }
      //     $scope.bugsDevices = data;
      //     $scope.devicesCopy = angular.copy(data);
      //   },
      //   function(err){
      //     $log.error(err);
      //     $scope.bugsLoading = false;
      //   }
      // );
      ngDialog.open({
        template:"app/support/popup/bugs.html",
        width:900,
        scope:$scope,
        closeByDocument:false,
        controller:"SupportController"
      });
    }

    /*Timepicker*/
    $scope.ismeridian = true;
    $scope.toggleMode = function(){
      $scope.ismeridian = !$scope.ismeridian;
    };

    /*FancyBox Control*/
    $scope.fbTitleInside = {
      helpers:{
        title:{
          type:"inside"
        }
      },
      afterShow:function(){
        if(!$rootScope.isFileUploading){
          $rootScope.resetSession();
          $rootScope.keepSessionAlive();
        }
      },
      afterClose:function(){
        if(!$rootScope.isFileUploading){
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.sessionTimoutFx();
        }
      }
    }
    $scope.fbTitleWithHome = {
      helpers:{
        title:{
          type:"inside"
        }
      },
      afterLoad:function(){
        this.title = '<span class="fa fa-home marR5" aria-hidden="true"></span>'+ this.title.replaceAll("/", " / ");
      },
      afterShow:function(){
        if(!$rootScope.isFileUploading){
          $rootScope.resetSession();
          $rootScope.keepSessionAlive();
        }
      },
      afterClose:function(){
        if(!$rootScope.isFileUploading){
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.sessionTimoutFx();
        }
      }
    }
    $scope.fbGroup = {
      loop:false,
      nextSpeed:250,
      prevMethod:false,
      nextMethod:"resizeIn",
      helpers:{
        title:{
          type:"inside"
        }
      },
      afterShow:function(){
        if(!$rootScope.isFileUploading){
          $rootScope.resetSession();
          $rootScope.keepSessionAlive();
        }
      },
      afterClose:function(){
        if(!$rootScope.isFileUploading){
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.sessionTimoutFx();
        }
      }
    }
    $scope.fbMedia = {
      openEffect:"none",
      closeEffect:"none",
      helpers:{
        media:{},
        title:{
          type:"inside"
        }
      },
      afterShow:function(){
        if(!$rootScope.isFileUploading){
          $rootScope.resetSession();
          $rootScope.keepSessionAlive();
        }
      },
      afterClose:function(){
        if(!$rootScope.isFileUploading){
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.sessionTimoutFx();
        }
      }
    }
    $scope.fbVideoFx = function(url, title){
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        content:'<video width="635" controls preload><source src="' + url + '" type="video/mp4" /></video>',
        beforeShow:function(){
          var video = $('.fancybox-inner').find("video").get(0);
          video.load();
          video.play();
        },
        afterLoad:function(){
          this.title = title;
        },
        afterShow:function(){
          if(!$rootScope.isFileUploading){
            $rootScope.resetSession();
            $rootScope.keepSessionAlive();
          }
        },
        afterClose:function(){
          if(!$rootScope.isFileUploading){
            $timeout.cancel($rootScope.sessionTimeoutTimer);
            $timeout.cancel($rootScope.sessionMsgHideTimer);
            $timeout.cancel($rootScope.restartSessionTimer);
            $rootScope.sessionTimoutFx();
          }
        }
      });
    }
    $scope.fbVideoWithTitleFx = function(url, title){
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        content:'<video width="635" controls preload><source src="' + url + '" type="video/mp4" /></video>',
        beforeShow:function(){
          var video = $('.fancybox-inner').find("video").get(0);
          video.load();
          video.play();
        },
        afterLoad:function(){
          this.title = '<span class="fa fa-home marR5" aria-hidden="true"></span>'+ title
        },
        afterShow:function(){
          if(!$rootScope.isFileUploading){
            $rootScope.resetSession();
            $rootScope.keepSessionAlive();
          }
        },
        afterClose:function(){
          if(!$rootScope.isFileUploading){
            $timeout.cancel($rootScope.sessionTimeoutTimer);
            $timeout.cancel($rootScope.sessionMsgHideTimer);
            $timeout.cancel($rootScope.restartSessionTimer);
            $rootScope.sessionTimoutFx();
          }
        }
      });
    }
    $scope.fbAudioFx = function(url, title){
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        minHeight:"auto",
        content:'<audio controls preload><source src="' + url + '" type="audio/mp3" /></audio>',
        beforeShow:function(){
          var audio = $('.fancybox-inner').find("audio").get(0);
          audio.load();
          audio.play();
        },
        afterLoad:function(){
          this.title = title;
        },
        afterShow:function(){
          if(!$rootScope.isFileUploading){
            $rootScope.resetSession();
            $rootScope.keepSessionAlive();
          }
        },
        afterClose:function(){
          if(!$rootScope.isFileUploading){
            $timeout.cancel($rootScope.sessionTimeoutTimer);
            $timeout.cancel($rootScope.sessionMsgHideTimer);
            $timeout.cancel($rootScope.restartSessionTimer);
            $rootScope.sessionTimoutFx();
          }
        }
      });
    }
    $scope.fbFlashFx = function(url, title, dimension){
      if(dimension){
        $scope.flashWidth = dimension.split(", ")[0].split("W [")[1].split("]")[0];
        $scope.flashHeight = dimension.split(", ")[1].split("H [")[1].split("]")[0];
      } else{
        $scope.flashWidth = "auto";
        $scope.flashHeight = "auto";
      }
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        content:'<object width="'+ $scope.flashWidth +'" height="'+ $scope.flashHeight +'" data="'+ url +'"></object>',
        afterLoad:function(){
          this.title = title;
        },
        afterShow:function(){
          if(!$rootScope.isFileUploading){
            $rootScope.resetSession();
            $rootScope.keepSessionAlive();
          }
        },
        afterClose:function(){
          if(!$rootScope.isFileUploading){
            $timeout.cancel($rootScope.sessionTimeoutTimer);
            $timeout.cancel($rootScope.sessionMsgHideTimer);
            $timeout.cancel($rootScope.restartSessionTimer);
            $rootScope.sessionTimoutFx();
          }
        }
      });
    }
    $scope.fbFrameFx = function(url, title){
      $.fancybox({
        type:"iframe",
        helpers:{
          title:{
            type:"inside"
          }
        },
        minHeight:"auto",
        content:'<iframe id="frameBI" src="' + url + '" width="900" height="500" class="noBdr"></iframe>',
        afterLoad:function(){
          this.title = title;
        },
        afterShow:function(){
          if(!$rootScope.isFileUploading){
            $rootScope.resetSession();
            $rootScope.keepSessionAlive();
          }
        },
        afterClose:function(){
          if(!$rootScope.isFileUploading){
            $timeout.cancel($rootScope.sessionTimeoutTimer);
            $timeout.cancel($rootScope.sessionMsgHideTimer);
            $timeout.cancel($rootScope.restartSessionTimer);
            $rootScope.sessionTimoutFx();
          }
        }
      });
    }

    // $(document).keyup(function(event){
    //   console.warn("event.which ", event.which);
    //   if(event.which === 27){
    //     console.log("tooltip Esc");
    //     $(".tooltip").empty();
    //   }
    // });

    angular.element(document).bind('keyup', function(e){
      if(e.keyCode == 27){
        $(".tooltip").empty();
      }
    });

    //device sorting where we assign devices
    $rootScope.aDeviceSort = {type:"label",val:"asc", reverse:false, lType:'device'};
    $rootScope.sDeviceSort = {type:"label",val:"asc", reverse:false, lType:'device'};
    $rootScope.deviceSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $rootScope.aDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      } else{
        $rootScope.sDeviceSort = {type:sortType, val:sortVal, reverse:reverse, lType:'device'};
      }
    }

    //group sorting where we assign group
    $rootScope.aGroupSort = {type:"label",val:"asc", reverse:false, lType:'group'};
    $rootScope.sGroupSort = {type:"label",val:"asc", reverse:false, lType:'group'};
    $rootScope.groupSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $rootScope.aGroupSort = {type:sortType, val:sortVal, reverse:reverse, lType:'group'};
      } else{
        $rootScope.sGroupSort = {type:sortType, val:sortVal, reverse:reverse, lType:'group'};
      }
    }

    //tag sorting where we assign tags
    $rootScope.aTagSort = {type:"label",val:"asc", reverse:false, lType:'tag'};
    $rootScope.sTagSort = {type:"label",val:"asc", reverse:false, lType:'tag'};
    $rootScope.tagSortFx = function(caller, sortType, sortVal, reverse){
      if(caller == "a"){
        $rootScope.aTagSort = {type:sortType, val:sortVal, reverse:reverse, lType:'tag'};
      } else{
        $rootScope.sTagSort = {type:sortType, val:sortVal, reverse:reverse, lType:'tag'};
      }
    }

    //reset sorting for device, group and tags
    $rootScope.resetSortingFx = function(){
      $rootScope.aDeviceSort = {type:"label",val:"asc", reverse:false, lType:'device'};
      $rootScope.sDeviceSort = {type:"label",val:"asc", reverse:false, lType:'device'};
      $rootScope.aGroupSort = {type:"label",val:"asc", reverse:false, lType:'group'};
      $rootScope.sGroupSort = {type:"label",val:"asc", reverse:false, lType:'group'};
      $rootScope.aTagSort = {type:"label",val:"asc", reverse:false, lType:'tag'};
      $rootScope.sTagSort = {type:"label",val:"asc", reverse:false, lType:'tag'};
    }

    // $scope.openSupport = function(){
    //   $scope.iframeUrl = "https://lsquared-2347217.hs-sites.com/chatbot-landing-page"
    //   $("#chatBtn").addClass("chatBtn-launcher");
    //   $("#supportPage").addClass("transitionSupportPage");
    //   $("#closebtn").addClass("transitionCloseBtn");
    //   $("#iframeId").addClass("iframePage");
    //   $("#closebtn").removeClass("gzfPCr");
    //   $("#openSupport").removeClass("bwsciD");
    //   $("#closebtn").addClass("dsOmqW");
    //   $("#openSupport").addClass("RGfWb");
    //   document.querySelector(".supportBtn").style.display = "none";
    //   document.querySelector(".supportCloseBtn").style.display = "block";
    // }

    // $scope.closwSupportPage = function(){
    //   $scope.iframeUrl = ""
    //   $("#chatBtn").removeClass("chatBtn-launcher");
    //   $("#chatBtn").addClass("chatBtn-launcher");
    //   $("#supportPage").removeClass("transitionSupportPage");
    //   $("#closebtn").removeClass("transitionCloseBtn");
    //   $("#closebtn").removeClass("dsOmqW");
    //   $("#openSupport").removeClass("RGfWb");
    //   $("#closebtn").addClass("gzfPCr");
    //   $("#openSupport").addClass("bwsciD");
    //   document.querySelector(".supportCloseBtn").style.display = "none";
    //   document.querySelector(".supportBtn").style.display = "block";
    // }

    // $scope.tabIndexFx = function(){
    //   setTimeout(function(){
    //     var tabIndex = 17;
    //     $(".tabIndex:not(:hidden)").each(function(i){
    //       $(this).attr('tabindex', tabIndex);
    //       tabIndex++;
    //     });
    //     $window.addEventListener("keypress", function(event){
    //       // console.warn("keypress ", event.key);
    //       if(event.keyCode === 13 && event.shiftKey){
    //         // console.warn("event.shiftKey ", event);
    //       } else if(event.keyCode === 13){
    //         // console.warn("event.keyCode ", event);
    //         $('.ui-selectable li').each(function(){
    //           $(this).removeClass("ui-selected");
    //         });
    //       }
    //       $rootScope.selectedItems = [];
    //       event.target.classList.add("ui-selected");
    //       $('.ui-selectable li').each(function(){
    //         if($(this).hasClass('ui-selected')){
    //           $rootScope.selectedItems.push({
    //             id: $(this).data("id"),
    //             type: $(this).data("type"),
    //             // spid: $(this).data("spid"),
    //             pid: $(this).data("pid"),
    //             splId: $(this).data("splId"),
    //             subType: $(this).data("subType")
    //           });
    //           $(this).find('input[type="checkbox"]').prop('checked', true);
    //         } else{
    //           $(this).find('input[type="checkbox"]').prop('checked', false);
    //         }
    //       });

    //       if((event.keyCode === 13 && event.shiftKey) || event.keyCode === 13){
    //         if($rootScope.selectedItems.length === 1 && ($rootScope.selectedItems[0].type == 'folder' || $rootScope.selectedItems[0].type == 'shortcut' || $rootScope.selectedItems[0].type == 'sharepoint' || $rootScope.selectedItems[0].type == 'onedrive' || $rootScope.selectedItems[0].type == 'sharedfolder')){
    //           // $scope.folderBriefFx($rootScope.selectedItems);
    //           $rootScope.$broadcast('folderBriefFx', $rootScope.selectedItems);
    //         } else{
    //           $rootScope.$broadcast('briefFx', $rootScope.selectedItems);
    //           // $rootScope.briefFx($rootScope.selectedItems);
    //         }
    //       }
    //     });
    //   }, 5000);
    // }

    $scope.arrIsObject = function(arr){
      $scope.isObj = false;
      for (var i = 0; i < arr.length; i++) {
        if(typeof arr[i] === "object"){
          $scope.isObj = true;
        }
        break;
      }
      return $scope.isObj;
    }

    $scope.pinToDBFx = function(selItems, caller){
      $scope.reqObj = $rootScope.selectedItems.map(function(item){
        if(caller=="s"){
          return {id:item.id,type:'schedule',subType:'schedule'};
        } else if(caller=="c"){
          if(selItems[0].splId){
            return {id:item.id,type:'content',subType:item.type, splId:selItems[0].splId};
          }
          return {id:item.id,type:'content',subType:item.type};
        } else if(caller=="d"){
          return {id:item.id,type:'device',subType:item.type};
        } else if(caller=="t"){
          return {id:item.id,type:'template',subType:item.type};
        }
      });

      if(caller=="dl"){
        $scope.reqObj =  [{id:selItems.id,type:'device',subType:'folder'}];
      }

      CommonSrv.pinUnpinItems({"selectedItems":$scope.reqObj}, "pin").then(
        function(data){
          // $scope.loadSelectedTab();
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.isArray = function(value) {
      return Array.isArray(value);
    };


    $rootScope.timerFxToLoadData = function(){
      $rootScope.showRemainingList = false;
    }

    $rootScope.addStatusKeyVal = {value: true}
    $scope.addStatusKey = function(devices, minDeduct){
      $rootScope.addStatusKeyVal.value = true;
      var processedItems = 0;
      if(devices && devices.length){
        angular.forEach(devices, function(device){
          if($rootScope.ssDStatus && $rootScope.ssDStatus.length){
            angular.forEach($rootScope.ssDStatus, function(d){
              if(device.id === d){
                device.ss = 1;
              }
            })
          }
          if(device.lp){
            device.status = $filter('isDeviceOnline')(device.lp, {minDeduct: minDeduct});
          } else {
            device.status = "offline";
          }
          processedItems ++;

          // console.log("processedItems",processedItems);
          // console.log("devices.length",devices.length);
          if(processedItems == devices.length){
            $rootScope.addStatusKeyVal.value = false;
          }
        })
      }else{
          $rootScope.addStatusKeyVal.value = false;
      }

      // console.warn(devices);
      // if(devices.length){
      //   angular.forEach(devices, function(device){
      //     if(device.lp){
      //       device.ss = 0;
      //       device.status = $filter('isDeviceOnline')(device.lp, {minDeduct: minDeduct});
      //     } else {
      //       device.status = "offline";
      //     }
      //   })
      // }
    }

    //add type key for device/folder
    $scope.addTypeKey = function(list){
      // console.warn(list);
      if(list.devices && list.devices.length){
        angular.forEach(list.devices, function(item){
          item.type = "device";
        })
      }
      if(list.dList && list.dList.length){
        angular.forEach(list.dList, function(item){
          item.type = "device";
        })
      }
      if(list.d && list.d.length){
        angular.forEach(list.d, function(item){
          item.type = "device";
        })
      }
      if(list.list && list.list.length){
        angular.forEach(list.list, function(item){
          item.type = "device";
        })
      }
      if(list.folders && list.folders.length){
        angular.forEach(list.folders, function(item){
          item.type = "Folder";
        })
      }
    }

    $rootScope.isObjectEmpty = function(obj) {
      if(angular.isUndefined(obj)){
        return true;
      } else{
        return Object.keys(obj).length === 0;
      }
    };

    $rootScope.arrObjContainKey = function(arr, key) {
      var result = arr.some(function(obj){
        return obj.hasOwnProperty(key);
      });
      return result;
    };

    $rootScope.deepEqualWithoutHashKey = function(obj1, obj2){
      function isObject(obj) {
        return obj !== null && typeof obj === 'object';
      }

      function deepCompare(o1, o2) {
        if (o1 === o2) return true; // Check if same reference or primitive value
        if (!isObject(o1) || !isObject(o2)) return false; // If not objects, return false

        var keys1 = Object.keys(o1).filter(function(key) { return key !== '$$hashKey'; });
        var keys2 = Object.keys(o2).filter(function(key) { return key !== '$$hashKey'; });

        if (keys1.length !== keys2.length) return false; // Check if number of keys are different

        for (var i = 0; i < keys1.length; i++) {
          var key = keys1[i];
          if (!deepCompare(o1[key], o2[key])) return false;
        }
        return true;
      }

      return deepCompare(obj1, obj2);
    }
    $scope.changeModule =  function(tabName){
      // Trigger event to abort all requests
      $rootScope.$broadcast('abortRequests');
    }

    /*Localization Start*/
    $scope.getLangList = function(){
      CommonSrv.getLangList().then(
        function(data){
          $scope.langArr = data;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getLangList();
    /*Localization End*/

    // Function to properly escape special characters
    $scope.escapeSearchText = function(text) {
      if(!text){
        return "";
      } else{
        return text
          .replace(/\\/g, "&#92;") // Escape backslashes (\)
          .replace(/"/g, "&quot;") // Escape double quotes
          .replace(/'/g, "&apos;") // Escape single quotes
          .replace(/</g, "&lt;") // Escape HTML tags
          .replace(/>/g, "&gt;"); // Escape HTML tags
      }
    };

    // todo get timezone list function
    $scope.getTimezoneList = function(){
      CommonSrv.getTimezoneList().then(
        function(data){
          $scope.timezoneList = data;
        },
        function(err){
          $log.error(err);
        }
      );
    }
    $scope.getTimezoneList();
  }
})();

angular.module('hub').service('BillingSrv', ['$http', '$q', '$rootScope', function($http, $q, $rootScope){
  var httpReq;
  this.getSubscription = function(){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/billing/dashboard");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSubDetails = function(id){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/billing/sDetail/" + id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getInvDetails = function(tId){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/billing/iDetail/" + tId);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getOrderDetails = function(){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/billing/oData");
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getTax = function(province){
    httpReq = $http.get($rootScope.apiHost + "njyczdnm/billing/tax/" + province);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.getSubCancel = function(id){
    httpReq = $http.post($rootScope.apiHost + "njyczdnm/billing/cancel", id);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.saveBilling = function(obj){
    httpReq = $http.post($rootScope.apiHost + "njyczdnm/billing/license", obj);
    return httpReq.then(this.handleSuccess, this.handleError);
  }
  this.handleSuccess = function(response){
    $rootScope.toastNotificationFx("info", response.data);
    return (response.data);
  }
  this.handleError = function(response){
    $rootScope.toastNotificationFx("danger", {"code":5000});
    if(!angular.isObject(response.data) || !response.data.message){
      return ($q.reject("An unknown error occurred."));
    }
    return ($q.reject(response.data.message));
  }
}]);
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('SubscriptionsController', SubscriptionsController);

  /** @ngInject */
  function SubscriptionsController($log, $rootScope, $scope, $state, $interval, $timeout, $cookies, $filter, $location, ngDialog, BillingSrv){
    $rootScope.selectedMenu = 10;
    $scope.detailLoading = true;
    if($state.params.id){
      $scope.decId = $scope.hubDecrypt($state.params.id);
      $scope.encId = $state.params.id;
      BillingSrv.getSubDetails($scope.decId).then(
        function(data){
          $scope.sDetails = data;
          $scope.detailLoading = false;
        },
        function(err){
          $log.error(err);
          $scope.detailLoading = false;
        }
      );
    }

    $scope.confirmOpen = function(){
      $scope.confirmProcessing = false;
      ngDialog.open({
        template: '\
        <section class="panel" role="dialog">\
          <div class="panel-body">{{"b.msg.12" | translate}}</div>\
          <footer class="panel-footer">\
            <button type="button" role="button" class="btn btn-sm btn-danger" ng-click="cancelSubFx();" focus-me="true" ng-disabled="confirmProcessing">\
              <span class="fa fa-repeat fa-spin fa-fw" ng-if="confirmProcessing" aria-hidden="true"></span>{{\'cm.btn.2\' | translate}}\
            </button>\
            <button type="button" role="button" class="btn btn-link btn-sm" ng-click="closeThisDialog();" data-dismiss="modal">{{"cm.btn.9" | translate}}</button>\
          </footer>\
        </section>',
        width: 480,
        scope: $scope,
        closeByDocument: false,
        className: 'ngdialog-theme-default ngdialog-confirm',
        preCloseCallback: function(){
          $scope.isConfirmOpen = false;
        }
      });
    }

    $scope.cancelSubFx = function(id){
      $scope.confirmProcessing = true;
      BillingSrv.getSubCancel({id:$scope.sDetails.info.id}).then(
        function(data){
          $scope.confirmProcessing = false;
          if(data.code == 19013){
            $scope.sDetails.info.status = 6;
            ngDialog.close();
          } else{
            ngDialog.close();
          }
        },
        function(err){
          $scope.confirmProcessing = false;
          ngDialog.close();
          $log.error(err);
        }
      );
    }

    $scope.viewOpen = function(viewObj){
      $scope.viewObj = viewObj;
      var iObj = {};
      var width = 900;
      var height = 600;
      var x = window.outerWidth / 2 + window.screenX - (width / 2);
      var y = window.outerHeight / 2 + window.screenY - (height / 2);
      var myWindow = window.open($scope.viewObj, "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top="+y+",left="+x+",width="+width+",height="+height);
    }

    $scope.changeOwnerOpen = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.curOwner = angular.copy($scope.sDetails.info);
      $scope.ownerObj = {b:$scope.curOwner.address, isChangeOwnership:1, sId:$scope.curOwner.id};
      ngDialog.open({
        template: "app/billing/popup/changeOwner.html",
        width: 800,
        scope: $scope,
        closeByDocument: false
      });
      setTimeout(function(){
        $scope.loadAutocomplete();
      }, 50);
    }

    $scope.saveOwnerFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.ownerObj.b = {address1:$('#company_address .autocomplete').val(), address2:$scope.ownerObj.b.address2, city:$('#company_address .locality').val(), province:$('#company_address .administrative_area_level_1').val(), postalcode:$('#company_address .postal_code').val(), country:$('#company_address .country').val(), countrycode:$('#company_address .country_code').val(), server:$scope.auth.servers[0].label};

      if($scope.ownerObj.b.address1 == ""){
        $scope.hasErr = true;
        $scope.errType = "address";
      } else if($scope.ownerObj.b.country == ""){
        $scope.hasErr = true;
        $scope.errType = "country";
      } else{
        $scope.saveProcessing = true;
        BillingSrv.saveBilling($scope.ownerObj).then(
          function(data){
            $scope.saveProcessing = false;
            if(data.code == 19014){
              $scope.hasErr = true;
              $scope.errType = "notFound";
            } else if(data.code == 19015){
              $scope.hasErr = true;
              $scope.errType = "invalidRenew";
            } else if(data.approval){
              window.location.replace(data.approval);
            } else{
              $scope.hasErr = true;
              $scope.errType = "approval";
            }
          },
          function(err){
            $scope.saveProcessing = false;
            $log.error(err);
          }
        );
      }
    }

   /**Google autocomplete*/
   $scope.loadAutocomplete = function(){
     $(document).ready(function(){
       var autocompletesWraps = ['company_address', 'shipping_address'];
       createGeoListeners(autocompletesWraps);
     });
     // Perhaps put these into a javascript library
     function createGeoListeners(autocompletesWraps){
       var options = {};
       var inputs = $('.autocomplete');
       var autocompletes = [];
       for(var i = 0; i < inputs.length; i++){
         var autocomplete = new google.maps.places.Autocomplete(inputs[i], options);
         autocomplete.inputId = inputs[i].id;
         autocomplete.parentDiv = autocompletesWraps[i];
         autocomplete.addListener('place_changed', fillInAddressFields);
         inputs[i].addEventListener("focus", function(){
           geoLocate(autocomplete);
         }, false);
         autocompletes.push(autocomplete);
       }
     }

     function fillInAddressFields(){
       $('.googleerror').removeClass('is-valid is-invalid');
       var place = this.getPlace();
       for(var i = 0; i < place.address_components.length; i++){
         var addressType = place.address_components[i].types[0];
         var val = place.address_components[i].long_name;
         $('#' + this.parentDiv).find("." + addressType).val(val);
         $('#' + this.parentDiv).find("." + addressType).attr('disabled', false);
         if(addressType == "country"){
           $('#' + this.parentDiv).find(".country_code").val(place.address_components[i].short_name);
         }
         if(this.parentDiv == "company_address" && addressType == "administrative_area_level_1"){
           $scope.ownerObj.b.province = $('#company_address .administrative_area_level_1').val();
         }
       }
     }
     function geoLocate(autocomplete){
       if(navigator.geolocation){
         navigator.geolocation.getCurrentPosition(function(position){
           var geolocation = {
             lat: position.coords.latitude,
             lng: position.coords.longitude
           };
           var circle = new google.maps.Circle({
             center: geolocation,
             radius: position.coords.accuracy
           });
           autocomplete.setBounds(circle.getBounds());
         });
       }
     }
     function gm_authFailure(){
       $('.gm-err-autocomplete').addClass('is-invalid');
       swal("Error", "There is a problem with the Google Maps or Places API", "error");
     };
   }
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('BillingController', BillingController);

  /** @ngInject */
  function BillingController($log, $rootScope, $scope, $state, $interval, $timeout, $cookies, $filter, $location, ngDialog, BillingSrv){
    $rootScope.selectedMenu = 10;

    $scope.shipping = {license:1, mp:false, sAddress:true, sType:0, b:{address1:"", address2:"", city:"", province:"", postalcode:"", country:"", countrycode:""}, s:{address1:"", address2:"", city:"", province:"", postalcode:"", country:"", countrycode:""}};
    $scope.selectedTab = $state.current.name;
    $scope.tempObj = {quad:false};
    $scope.billingLoading = true;
    $scope.hasErr = false;
    $scope.errType = "";
    $scope.licenseCost = 0;
    $scope.stype = [];
    $scope.w9Total = 0;
    if($scope.status !== true && $scope.status == 1){
      $rootScope.toastNotificationFx("info", {code:19001});
    } else if($scope.status !== undefined && $scope.status !== true && $scope.status !== ""){
      $scope.hasErr = true;
      $scope.errType = "status"+$scope.status;
    }

    $scope.getTaxFx = function(caller){
      BillingSrv.getTax($scope.shipping.b.province).then(
        function(data){
          $scope.tax = data;
          $scope.stype = [{id:0, type:"y", rate:$scope.tax.ly}, {id:1, type:"m", rate:$scope.tax.lm}, {id:2, type:"w", rate:$scope.tax.lw}, {id:3, type:"d", rate:$scope.tax.ld}];

          if(caller){
            $scope.billingLoading = false;
            $scope.loadAutocomplete();
          }
        },
        function(err){
          $log.error(err);
        }
      );
    }

    $scope.loadSelectedTab = function(){
      $scope.billingLoading = true;
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.bd = {};
      if($scope.selectedTab == "hub.billing.s"){
        BillingSrv.getSubscription().then(
          function(data){
            if($scope.selectedTab == "hub.billing.s"){
            $scope.billingLoading = false;
            $scope.bd = data;
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
      else if($scope.selectedTab == "hub.billing.o"){
        BillingSrv.getOrderDetails().then(
          function(data){
            if($scope.selectedTab == "hub.billing.o"){
            $scope.shipping.b = data.b;
            $scope.shippingInfo = data.info;
            $scope.shipping.mpList = data.mpList;
            $scope.w9Total = $scope.shipping.mpList[1].qty * $scope.shipping.mpList[1].price;
            $scope.getTaxFx(true);
            }
          },
          function(err){
            $log.error(err);
          }
        );
      }
      else if($scope.selectedTab == "hub.billing.orp"){
        $scope.curShipping = angular.fromJson(localStorage.getItem("PO"));
        $scope.shipping = $scope.curShipping.shipping;
        if($scope.shipping.b){
          $scope.isOrpEmpty = false;
          $scope.getTaxFx(true);
        } else{
          $scope.isOrpEmpty = true;
        }
      }
    }
    $scope.loadSelectedTab();

    $scope.$on("$stateChangeStart", function(event, toState){
      $state.current = toState;
      $scope.selectedTab = $state.current.name;
      $scope.loadSelectedTab();
    });

    /*Dashboard tab*/
    $scope.subDetailFx = function(id){
      $state.go("hub.bContainer.sub", {id:$scope.hubEncrypt(id)});
    }

    /*Orders tab*/
    $scope.mpCheckFx = function(caller){
      if(!$scope.shipping.mp && !$scope.shipping.sAddress){
        $scope.shipping.sAddress = true;
        $scope.tempObj.quad = false;
      }
      if($scope.shipping.mp){
      }else{}
    }

    $scope.licenseFx = function(){
      if($scope.shipping.mp){}
    }

    $scope.saveFx = function(){
      $scope.hasErr = false;
      $scope.errType = "";
      $scope.shipping.b = {address1:$('#company_address .autocomplete').val(), address2:$scope.shipping.b.address2, city:$('#company_address .locality').val(), province:$('#company_address .administrative_area_level_1').val(), postalcode:$('#company_address .postal_code').val(), country:$('#company_address .country').val(), countrycode:$('#company_address .country_code').val(), server:$scope.shipping.b.server};
      $scope.shipping.s = {address1:$('#shipping_address .autocomplete').val(), address2:$scope.shipping.s.address2, city:$('#shipping_address .locality').val(), province:$('#shipping_address .administrative_area_level_1').val(), postalcode:$('#shipping_address .postal_code').val(), country:$('#shipping_address .country').val(), countrycode:$('#shipping_address .country_code').val()};

      $scope.isMpEmpty = true;
      if($scope.shipping.mp){
        angular.forEach($scope.shipping.mpList, function(mpList){
          if(mpList.qty){
            $scope.isMpEmpty = false;
          }
        });
      }

      if(!$scope.shipping.license){
        $scope.hasErr = true;
        $scope.errType = "lic";
      } else if(!$scope.shipping.b.address1 || $scope.shipping.b.address1 == ""){
        $scope.hasErr = true;
        $scope.errType = "address";
      } else if(!$scope.shipping.b.city || $scope.shipping.b.city == ""){
        $scope.hasErr = true;
        $scope.errType = "city";
      } else if(!$scope.shipping.b.province || $scope.shipping.b.province == ""){
        $scope.hasErr = true;
        $scope.errType = "state";
      } else if(!$scope.shipping.b.postalcode || $scope.shipping.b.postalcode == ""){
        $scope.hasErr = true;
        $scope.errType = "zip";
      } else if(!$scope.shipping.b.country || $scope.shipping.b.country == ""){
        $scope.hasErr = true;
        $scope.errType = "country";
      } else if($scope.shipping.mp && $scope.isMpEmpty){
        $scope.hasErr = true;
        $scope.errType = "mpqty";
      } else if($scope.shipping.mp && !$scope.shipping.sAddress){
        if($scope.shipping.s.address1 == ""){
          $scope.hasErr = true;
          $scope.errType = "address";
        } else if($scope.shipping.s.country == ""){
          $scope.hasErr = true;
          $scope.errType = "country";
        } else{
          localStorage.setItem("PO", JSON.stringify({shipping:$scope.shipping, info:$scope.shippingInfo}));
          $state.go("hub.billing.orp");
        }
      } else{
        localStorage.setItem("PO", JSON.stringify({shipping:$scope.shipping, info:$scope.shippingInfo}));
        $state.go("hub.billing.orp");
      }
    }

    $scope.save = function(){
      $scope.saveProcessing = true;
      $scope.copyShipping = angular.copy($scope.shipping);

      if($scope.copyShipping.sType == 0){
        $scope.copyShipping.sType = "y";
      }
      else if($scope.copyShipping.sType == 1){
        $scope.copyShipping.sType = "m";
      }
      else if($scope.copyShipping.sType == 2){
        $scope.copyShipping.sType = "w";
      }
      else if($scope.copyShipping.sType == 3){
        $scope.copyShipping.sType = "d";
      }
      BillingSrv.saveBilling($scope.copyShipping).then(
        function(data){
          $scope.saveProcessing = false;
          if(data.code == 19012){
            ngDialog.close();
            $state.go("hub.billing.s");
          }
          else if(data.code == "card_declined"){
            $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.17'));
          }
        },
        function(err){
          $scope.saveProcessing = false;
          $log.error(err);
        }
      );
    }

    $scope.ccOpen = function(){
      $scope.ccLoading = true;
      $scope.errPopupType = "";
      $scope.hasPopupErr = false;
      if($scope.shipping.sType == 'd'){
        $scope.curSType = $filter("lowercase")($filter("translate")("b.o.2.1"));
      } else if($scope.shipping.sType == 'w'){
        $scope.curSType = $filter("lowercase")($filter("translate")("b.o.2.2"));
      } else if($scope.shipping.sType == 'm'){
        $scope.curSType = $filter("lowercase")($filter("translate")("b.o.2.3"));
      } else if($scope.shipping.sType == 'y'){
        $scope.curSType = $filter("lowercase")($filter("translate")("b.o.2.4"));
      }
      ngDialog.open({
        template:"app/billing/popup/ccOpen.html",
        width:800,
        scope:$scope,
        closeByDocument:false
      });

      $timeout(function(){
        $scope.ccLoading = false;
        var stripe = Stripe($scope.curShipping.info.pk);
        // var stripe = Stripe('pk_test_lp1zH8Q9ulFpDXyQCGZt9zPi001cBM1d0v');
        // var stripe = Stripe('pk_live_E4Or95ZdmZod3G4GVRxXoiLE00nLOWXDeJ');

        // Create an instance of Elements.
        var elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
          base:{
            color:'#32325d',
            fontFamily:'"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing:'antialiased',
            fontSize:'16px',
            '::placeholder':{
              color:'#aab7c4'
            }
          },
          invalid:{
            color:'#fa755a',
            iconColor:'#fa755a'
          }
        };

        // Create an instance of the card Element.
        var card = elements.create('card', {hidePostalCode:true, style:style});
        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function(event){
          if(event.error){
            if(event.error.code == "invalid_number"){
              $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.16'));
            } else if(event.error.code == "invalid_expiry_year_past"){
              $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.17'));
            } else if(event.error.code == "card_declined"){
              $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.17'));
            }
          } else{
            $("#card-errors").addClass("hide").text("");
  			  }
        });

        // Handle form submission.
        var form = document.getElementById('payment-form');
        form.addEventListener('submit', function(event){
          event.preventDefault();
          stripe.createSource(card).then(function(result){
            if(result.error){
              // Inform the user if there was an error.
              if(result.error.code == "card_declined"){
                $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.18'));
              } else if(result.error.code == "invalid_number"){
                $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.16'));
              } else if(result.error.code == "invalid_expiry_year_past"){
                $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.17'));
              } else if(result.error.code == "card_declined"){
                $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.17'));
              }
            } else{
              // Send the token to your server.
              stripeSourceHandler(result.source);
            }
          });

        });

        function stripeSourceHandler(source){
          // Insert the source ID into the form so it gets submitted to the server
          var form = document.getElementById('payment-form');
          var hiddenInput = document.createElement('input');
          hiddenInput.setAttribute('type', 'hidden');
          hiddenInput.setAttribute('name', 'stripeSource');
          hiddenInput.setAttribute('value', source.id);
          form.appendChild(hiddenInput);
          if(source.error){
            if(source.error.code == "card_declined"){
              $("#card-errors").removeClass("hide").text($filter("translate")('b.msg.18'));
            }
          } else if(source.id){
            $scope.shipping.source = source.id;
            $scope.save();
          }
        }
      }, 1000);
    }

    /**Google autocomplete*/
    $scope.loadAutocomplete = function(){
      $(document).ready(function(){
        var autocompletesWraps = ['company_address', 'shipping_address'];
        createGeoListeners(autocompletesWraps);
      });
      // Perhaps put these into a javascript library
      function createGeoListeners(autocompletesWraps){
        var options = {};
        var inputs = $('.autocomplete');
        var autocompletes = [];
        for(var i = 0; i < inputs.length; i++){
          var autocomplete = new google.maps.places.Autocomplete(inputs[i], options);
          autocomplete.inputId = inputs[i].id;
          autocomplete.parentDiv = autocompletesWraps[i];
          autocomplete.addListener('place_changed', fillInAddressFields);
          inputs[i].addEventListener("focus", function(){
            geoLocate(autocomplete);
          }, false);
          autocompletes.push(autocomplete);
        }
      }

      function fillInAddressFields(){
        $('.googleerror').removeClass('is-valid is-invalid');
        var place = this.getPlace();
        for(var i = 0; i < place.address_components.length; i++){
          var addressType = place.address_components[i].types[0];
          var val = place.address_components[i].long_name;
          $('#' + this.parentDiv).find("." + addressType).val(val);
          $('#' + this.parentDiv).find("." + addressType).attr('disabled', false);
          $scope.shipping.b.address2 = "";
          if(addressType == "country"){
            $('#' + this.parentDiv).find(".country_code").val(place.address_components[i].short_name);
          }
          if(this.parentDiv == "company_address" && addressType == "administrative_area_level_1"){
            $scope.shipping.b.province = $('#company_address .administrative_area_level_1').val();
            $scope.getTaxFx();
          }
        }
      }
      function geoLocate(autocomplete){
        if(navigator.geolocation){
          navigator.geolocation.getCurrentPosition(function(position){
            var geolocation = {
              lat:position.coords.latitude,
              lng:position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center:geolocation,
              radius:position.coords.accuracy
            });
            autocomplete.setBounds(circle.getBounds());
          });
        }
      }
      function gm_authFailure(){
        $('.gm-err-autocomplete').addClass('is-invalid');
        swal("Error", "There is a problem with the Google Maps or Places API", "error");
      };
    }

    $rootScope.deleteCallback = function(){}
  }
})();
(function(){
  'use strict';

  angular
    .module('hub')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr){
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1465896449403;
    vm.showToastr = showToastr;

    activate();

    function activate(){
      getWebDevTec();
      $timeout(function(){
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr(){
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" role="link" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec(){
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing){
        awesomeThing.rank = Math.random();
      });
    }
  }
})();
(function(a,b){if(typeof define==="function"&&define.amd){define([],b);}else{if(typeof exports==="object"){module.exports=b();}else{a.X2JS=b();}}}(this,function(){return function(z){var t="1.2.0";z=z||{};i();u();function i(){if(z.escapeMode===undefined){z.escapeMode=true;}z.attributePrefix=z.attributePrefix||"_";z.arrayAccessForm=z.arrayAccessForm||"none";z.emptyNodeForm=z.emptyNodeForm||"text";if(z.enableToStringFunc===undefined){z.enableToStringFunc=true;}z.arrayAccessFormPaths=z.arrayAccessFormPaths||[];if(z.skipEmptyTextNodesForObj===undefined){z.skipEmptyTextNodesForObj=true;}if(z.stripWhitespaces===undefined){z.stripWhitespaces=true;}z.datetimeAccessFormPaths=z.datetimeAccessFormPaths||[];if(z.useDoubleQuotes===undefined){z.useDoubleQuotes=false;}z.xmlElementsFilter=z.xmlElementsFilter||[];z.jsonPropertiesFilter=z.jsonPropertiesFilter||[];if(z.keepCData===undefined){z.keepCData=false;}}var h={ELEMENT_NODE:1,TEXT_NODE:3,CDATA_SECTION_NODE:4,COMMENT_NODE:8,DOCUMENT_NODE:9};function u(){}function x(B){var C=B.localName;if(C==null){C=B.baseName;}if(C==null||C==""){C=B.nodeName;}return C;}function r(B){return B.prefix;}function s(B){if(typeof(B)=="string"){return B.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");}else{return B;}}function k(B){return B.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"').replace(/&apos;/g,"'").replace(/&amp;/g,"&");}function w(C,F,D,E){var B=0;for(;B<C.length;B++){var G=C[B];if(typeof G==="string"){if(G==E){break;}}else{if(G instanceof RegExp){if(G.test(E)){break;}}else{if(typeof G==="function"){if(G(F,D,E)){break;}}}}}return B!=C.length;}function n(D,B,C){switch(z.arrayAccessForm){case"property":if(!(D[B] instanceof Array)){D[B+"_asArray"]=[D[B]];}else{D[B+"_asArray"]=D[B];}break;}if(!(D[B] instanceof Array)&&z.arrayAccessFormPaths.length>0){if(w(z.arrayAccessFormPaths,D,B,C)){D[B]=[D[B]];}}}function a(G){var E=G.split(/[-T:+Z]/g);var F=new Date(E[0],E[1]-1,E[2]);var D=E[5].split(".");F.setHours(E[3],E[4],D[0]);if(D.length>1){F.setMilliseconds(D[1]);}if(E[6]&&E[7]){var C=E[6]*60+Number(E[7]);var B=/\d\d-\d\d:\d\d$/.test(G)?"-":"+";C=0+(B=="-"?-1*C:C);F.setMinutes(F.getMinutes()-C-F.getTimezoneOffset());}else{if(G.indexOf("Z",G.length-1)!==-1){F=new Date(Date.UTC(F.getFullYear(),F.getMonth(),F.getDate(),F.getHours(),F.getMinutes(),F.getSeconds(),F.getMilliseconds()));}}return F;}function q(D,B,C){if(z.datetimeAccessFormPaths.length>0){var E=C.split(".#")[0];if(w(z.datetimeAccessFormPaths,D,B,E)){return a(D);}else{return D;}}else{return D;}}function b(E,C,B,D){if(C==h.ELEMENT_NODE&&z.xmlElementsFilter.length>0){return w(z.xmlElementsFilter,E,B,D);}else{return true;}}function A(D,J){if(D.nodeType==h.DOCUMENT_NODE){var K=new Object;var B=D.childNodes;for(var L=0;L<B.length;L++){var C=B.item(L);if(C.nodeType==h.ELEMENT_NODE){var I=x(C);K[I]=A(C,I);}}return K;}else{if(D.nodeType==h.ELEMENT_NODE){var K=new Object;K.__cnt=0;var B=D.childNodes;for(var L=0;L<B.length;L++){var C=B.item(L);var I=x(C);if(C.nodeType!=h.COMMENT_NODE){var H=J+"."+I;if(b(K,C.nodeType,I,H)){K.__cnt++;if(K[I]==null){K[I]=A(C,H);n(K,I,H);}else{if(K[I]!=null){if(!(K[I] instanceof Array)){K[I]=[K[I]];n(K,I,H);}}(K[I])[K[I].length]=A(C,H);}}}}for(var E=0;E<D.attributes.length;E++){var F=D.attributes.item(E);K.__cnt++;K[z.attributePrefix+F.name]=F.value;}var G=r(D);if(G!=null&&G!=""){K.__cnt++;K.__prefix=G;}if(K["#text"]!=null){K.__text=K["#text"];if(K.__text instanceof Array){K.__text=K.__text.join("\n");}if(z.stripWhitespaces){K.__text=K.__text.trim();}delete K["#text"];if(z.arrayAccessForm=="property"){delete K["#text_asArray"];}K.__text=q(K.__text,I,J+"."+I);}if(K["#cdata-section"]!=null){K.__cdata=K["#cdata-section"];delete K["#cdata-section"];if(z.arrayAccessForm=="property"){delete K["#cdata-section_asArray"];}}if(K.__cnt==0&&z.emptyNodeForm=="text"){K="";}else{if(K.__cnt==1&&K.__text!=null){K=K.__text;}else{if(K.__cnt==1&&K.__cdata!=null&&!z.keepCData){K=K.__cdata;}else{if(K.__cnt>1&&K.__text!=null&&z.skipEmptyTextNodesForObj){if((z.stripWhitespaces&&K.__text=="")||(K.__text.trim()=="")){delete K.__text;}}}}}delete K.__cnt;if(z.enableToStringFunc&&(K.__text!=null||K.__cdata!=null)){K.toString=function(){return(this.__text!=null?this.__text:"")+(this.__cdata!=null?this.__cdata:"");};}return K;}else{if(D.nodeType==h.TEXT_NODE||D.nodeType==h.CDATA_SECTION_NODE){return D.nodeValue;}}}}function o(I,F,H,C){var E="<"+((I!=null&&I.__prefix!=null)?(I.__prefix+":"):"")+F;if(H!=null){for(var G=0;G<H.length;G++){var D=H[G];var B=I[D];if(z.escapeMode){B=s(B);}E+=" "+D.substr(z.attributePrefix.length)+"=";if(z.useDoubleQuotes){E+='"'+B+'"';}else{E+="'"+B+"'";}}}if(!C){E+=">";}else{E+="/>";}return E;}function j(C,B){return"</"+(C.__prefix!=null?(C.__prefix+":"):"")+B+">";}function v(C,B){return C.indexOf(B,C.length-B.length)!==-1;}function y(C,B){if((z.arrayAccessForm=="property"&&v(B.toString(),("_asArray")))||B.toString().indexOf(z.attributePrefix)==0||B.toString().indexOf("__")==0||(C[B] instanceof Function)){return true;}else{return false;}}function m(D){var C=0;if(D instanceof Object){for(var B in D){if(y(D,B)){continue;}C++;}}return C;}function l(D,B,C){return z.jsonPropertiesFilter.length==0||C==""||w(z.jsonPropertiesFilter,D,B,C);}function c(D){var C=[];if(D instanceof Object){for(var B in D){if(B.toString().indexOf("__")==-1&&B.toString().indexOf(z.attributePrefix)==0){C.push(B);}}}return C;}function g(C){var B="";if(C.__cdata!=null){B+="<![CDATA["+C.__cdata+"]]>";}if(C.__text!=null){if(z.escapeMode){B+=s(C.__text);}else{B+=C.__text;}}return B;}function d(C){var B="";if(C instanceof Object){B+=g(C);}else{if(C!=null){if(z.escapeMode){B+=s(C);}else{B+=C;}}}return B;}function p(C,B){if(C===""){return B;}else{return C+"."+B;}}function f(D,G,F,E){var B="";if(D.length==0){B+=o(D,G,F,true);}else{for(var C=0;C<D.length;C++){B+=o(D[C],G,c(D[C]),false);B+=e(D[C],p(E,G));B+=j(D[C],G);}}return B;}function e(I,H){var B="";var F=m(I);if(F>0){for(var E in I){if(y(I,E)||(H!=""&&!l(I,E,p(H,E)))){continue;}var D=I[E];var G=c(D);if(D==null||D==undefined){B+=o(D,E,G,true);}else{if(D instanceof Object){if(D instanceof Array){B+=f(D,E,G,H);}else{if(D instanceof Date){B+=o(D,E,G,false);B+=D.toISOString();B+=j(D,E);}else{var C=m(D);if(C>0||D.__text!=null||D.__cdata!=null){B+=o(D,E,G,false);B+=e(D,p(H,E));B+=j(D,E);}else{B+=o(D,E,G,true);}}}}else{B+=o(D,E,G,false);B+=d(D);B+=j(D,E);}}}}B+=d(I);return B;}this.parseXmlString=function(D){var F=window.ActiveXObject||"ActiveXObject" in window;if(D===undefined){return null;}var E;if(window.DOMParser){var G=new window.DOMParser();var B=null;if(!F){try{B=G.parseFromString("INVALID","text/xml").getElementsByTagName("parsererror")[0].namespaceURI;}catch(C){B=null;}}try{E=G.parseFromString(D,"text/xml");if(B!=null&&E.getElementsByTagNameNS(B,"parsererror").length>0){E=null;}}catch(C){E=null;}}else{if(D.indexOf("<?")==0){D=D.substr(D.indexOf("?>")+2);}E=new ActiveXObject("Microsoft.XMLDOM");E.async="false";E.loadXML(D);}return E;};this.asArray=function(B){if(B===undefined||B==null){return[];}else{if(B instanceof Array){return B;}else{return[B];}}};this.toXmlDateTime=function(B){if(B instanceof Date){return B.toISOString();}else{if(typeof(B)==="number"){return new Date(B).toISOString();}else{return null;}}};this.asDateTime=function(B){if(typeof(B)=="string"){return a(B);}else{return B;}};this.xml2json=function(B){return A(B);};this.xml_str2json=function(B){var C=this.parseXmlString(B);if(C!=null){return this.xml2json(C);}else{return null;}};this.json2xml_str=function(B){return e(B,"");};this.json2xml=function(C){var B=this.json2xml_str(C);return this.parseXmlString(B);};this.getVersion=function(){return t;};};}));
// Copyright © 2013-2014 David Caldwell <david@porkrind.org>
//
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
// SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
// OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
// CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

// Usage
// -----
// The module exports one entry point, the `renderjson()` function. It takes in
// the JSON you want to render as a single argument and returns an HTML
// element.
//
// Options
// -------
// renderjson.set_icons("+", "-")
//   This Allows you to override the disclosure icons.
//
// renderjson.set_show_to_level(level)
//   Pass the number of levels to expand when rendering. The default is 0, which
//   starts with everything collapsed. As a special case, if level is the string
//   "all" then it will start with everything expanded.
//
// renderjson.set_max_string_length(length)
//   Strings will be truncated and made expandable if they are longer than
//   `length`. As a special case, if `length` is the string "none" then
//   there will be no truncation. The default is "none".
//
// renderjson.set_sort_objects(sort_bool)
//   Sort objects by key (default: false)
//
// Theming
// -------
// The HTML output uses a number of classes so that you can theme it the way
// you'd like:
//     .disclosure    ("⊕", "⊖")
//     .syntax        (",", ":", "{", "}", "[", "]")
//     .string        (includes quotes)
//     .number
//     .boolean
//     .key           (object key)
//     .keyword       ("null", "undefined")
//     .object.syntax ("{", "}")
//     .array.syntax  ("[", "]")

var module;
(module||{}).exports = renderjson = (function() {
    var themetext = function(/* [class, text]+ */) {
        var spans = [];
        while (arguments.length)
            spans.push(append(span(Array.prototype.shift.call(arguments)),
                              text(Array.prototype.shift.call(arguments))));
        return spans;
    };
    var append = function(/* el, ... */) {
        var el = Array.prototype.shift.call(arguments);
        for (var a=0; a<arguments.length; a++)
            if (arguments[a].constructor == Array)
                append.apply(this, [el].concat(arguments[a]));
            else
                el.appendChild(arguments[a]);
        return el;
    };
    var prepend = function(el, child) {
        el.insertBefore(child, el.firstChild);
        return el;
    }
    var isempty = function(obj) { for (var k in obj) if (obj.hasOwnProperty(k)) return false;
                                  return true; }
    var text = function(txt) { return document.createTextNode(txt) };
    var div = function() { return document.createElement("div") };
    var span = function(classname) { var s = document.createElement("span");
                                     if (classname) s.className = classname;
                                     return s; };
    var A = function A(txt, classname, callback) { var a = document.createElement("a");
                                                   if (classname) a.className = classname;
                                                   a.appendChild(text(txt));
                                                   a.href = '#';
                                                   a.onclick = function() { callback(); return false; };
                                                   return a; };

    function _renderjson(json, indent, dont_indent, show_level, max_string, sort_objects) {
        var my_indent = dont_indent ? "" : indent;

        var disclosure = function(open, placeholder, close, type, builder) {
            var content;
            var empty = span(type);
            var show = function() { if (!content) append(empty.parentNode,
                                                         content = prepend(builder(),
                                                                           A(renderjson.hide, "disclosure",
                                                                             function() { content.style.display="none";
                                                                                          empty.style.display="inline"; } )));
                                    content.style.display="inline";
                                    empty.style.display="none"; };
            append(empty,
                   A(renderjson.show, "disclosure", show),
                   themetext(type+ " syntax", open),
                   A(placeholder, null, show),
                   themetext(type+ " syntax", close));

            var el = append(span(), text(my_indent.slice(0,-1)), empty);
            if (show_level > 0)
                show();
            return el;
        };

        if (json === null) return themetext(null, my_indent, "keyword", "null");
        if (json === void 0) return themetext(null, my_indent, "keyword", "undefined");

        if (typeof(json) == "string" && json.length > max_string)
            return disclosure('"', json.substr(0,max_string)+" ...", '"', "string", function () {
                return append(span("string"), themetext(null, my_indent, "string", JSON.stringify(json)));
            });

        if (typeof(json) != "object") // Strings, numbers and bools
            return themetext(null, my_indent, typeof(json), JSON.stringify(json));

        if (json.constructor == Array) {
            if (json.length == 0) return themetext(null, my_indent, "array syntax", "[]");

            return disclosure("[", " ... ", "]", "array", function () {
                var as = append(span("array"), themetext("array syntax", "[", null, "\n"));
                for (var i=0; i<json.length; i++)
                    append(as,
                           _renderjson(json[i], indent+"    ", false, show_level-1, max_string, sort_objects),
                           i != json.length-1 ? themetext("syntax", ",") : [],
                           text("\n"));
                append(as, themetext(null, indent, "array syntax", "]"));
                return as;
            });
        }

        // object
        if (isempty(json))
            return themetext(null, my_indent, "object syntax", "{}");

        return disclosure("{", "...", "}", "object", function () {
            var os = append(span("object"), themetext("object syntax", "{", null, "\n"));
            for (var k in json) var last = k;
            var keys = Object.keys(json);
            if (sort_objects)
                keys = keys.sort();
            for (var i in keys) {
                var k = keys[i];
                append(os, themetext(null, indent+"    ", "key", '"'+k+'"', "object syntax", ': '),
                       _renderjson(json[k], indent+"    ", true, show_level-1, max_string, sort_objects),
                       k != last ? themetext("syntax", ",") : [],
                       text("\n"));
            }
            append(os, themetext(null, indent, "object syntax", "}"));
            return os;
        });
    }

    var renderjson = function renderjson(json)
    {
        var pre = append(document.createElement("pre"), _renderjson(json, "", false, renderjson.show_to_level, renderjson.max_string_length, renderjson.sort_objects));
        pre.className = "renderjson";
        return pre;
    }
    renderjson.set_icons = function(show, hide) { renderjson.show = show;
                                                  renderjson.hide = hide;
                                                  return renderjson; };
    renderjson.set_show_to_level = function(level) { renderjson.show_to_level = typeof level == "string" &&
                                                                                level.toLowerCase() === "all" ? Number.MAX_VALUE
                                                                                                              : level;
                                                     return renderjson; };
    renderjson.set_max_string_length = function(length) { renderjson.max_string_length = typeof length == "string" &&
                                                                                         length.toLowerCase() === "none" ? Number.MAX_VALUE
                                                                                                                         : length;
                                                          return renderjson; };
    renderjson.set_sort_objects = function(sort_bool) { renderjson.sort_objects = sort_bool;
                                                        return renderjson; };
    // Backwards compatiblity. Use set_show_to_level() for new code.
    renderjson.set_show_by_default = function(show) { renderjson.show_to_level = show ? Number.MAX_VALUE : 0;
                                                      return renderjson; };
    renderjson.set_icons('⊕', '⊖');
    renderjson.set_show_by_default(false);
    renderjson.set_sort_objects(false);
    renderjson.set_max_string_length("none");
    return renderjson;
})();

angular.module('ngSelectable', [])
  .directive('selectable', ['$rootScope', '$window', function($rootScope, $window, $timeout){
    return function($scope, element, attr){
      var options = $scope.$eval(attr.selectableOptions) || {};
      var dblClick = 0;
      $rootScope.thumbSelType = attr.type;
      // var splId = "";
      // var spId = "";
      // var type = "";
      // var fId = "";

      if(attr.selectableList || attr.list){
        element.bind('selectablestart', function(){
          $scope.$apply(function(){
            $rootScope.srcErrorShow = false;
            $rootScope.imageLoaded = false;
          })
        });
        element.bind('selectablestop', function(){
          $scope.$apply(function(){
            $rootScope.selectedItems = [];
            $rootScope.unSelItems = [];
            if($(document.activeElement).is('input[type="text"]')){
              $(document.activeElement).blur();
            }

            if($scope.auth.upermissions.dp && $rootScope.thumbSelType == "dPaging"){
              //this block of code is used for pagination in device with list and thumb
              var total = ($('.ui-selectable li').length);
              if(!$scope.auth.upermissions.dgrp || ($scope.auth.upermissions.dgrp.dgrp && $scope.auth.upermissions.dgrp.type !='df')){
                if($scope.auth.upreferences.deviceView == 't'){
                  total = ($('.ui-selectable li').length / 2);
                }
              }
              $('#pagingCtrl li').each(function(){
                $(this).removeClass('ui-selected');
                return;
              });
              $('.ui-selectable li').each(function(count){
                if(count < total){
                  if($(this).hasClass('ui-selected')){
                    // if($(this).data("type") == "sharepoint"){
                    //   splId = $(this).data("spid");
                    // } else{
                    //   splId = $(this).data("splId");
                    // }
                    $rootScope.selectedItems.push({
                      id: $(this).data("id"),
                      type: $(this).data("type"),
                      // spid: $(this).data("spid"),
                      pid: $(this).data("pid"),
                      splId: $(this).data("splId"),
                      subType: $(this).data("subType"),
                      isBlur: $(this).data("isBlur"),
                      status: $(this).data("status")
                    });
                    $(this).find('input[type="checkbox"]').prop('checked', true);
                  } else{
                    $rootScope.unSelItems.push($(this).data("id"));
                    $(this).find('input[type="checkbox"]').prop('checked', false);
                  }
                }
              });
            } else {
              $('#pagingCtrl li').each(function(){
                $(this).removeClass('ui-selected');
                return;
              });
              $('.ui-selectable li').each(function(){
                if($(this).hasClass('ui-selected')){
                  // if($(this).data("type") == "sharepoint"){
                  //   splId = $(this).data("spid");
                  // } else{
                  //   splId = $(this).data("splId");
                  // }
                  $rootScope.excelObj = [];
                  $rootScope.selectedItems.push({
                    id: $(this).data("id"),
                    type: $(this).data("type"),
                    // spid: $(this).data("spid"),
                    pid: $(this).data("pid"),
                    splId: $(this).data("splId"),
                    subType: $(this).data("subType"),
                    isBlur: $(this).data("isBlur"),
                    status: $(this).data("status")
                  });
                  $(this).find('input[type="checkbox"]').prop('checked', true);
                } else{
                  $(this).find('input[type="checkbox"]').prop('checked', false);
                }
              });
            }

            if($rootScope.selectedItems.length === 1 && ($rootScope.selectedItems[0].type == 'folder' || $rootScope.selectedItems[0].type == 'shortcut' || $rootScope.selectedItems[0].type == 'sharepoint' || $rootScope.selectedItems[0].type == 'onedrive' || $rootScope.selectedItems[0].type == 'sharedfolder' || $rootScope.selectedItems[0].type == 'excelfolder' || $rootScope.selectedItems[0].type == 'googledrive')){
              dblClick++;
              $scope.singleClick = true;
              if(dblClick == 2){
                $scope.singleClick = false;
                if(attr.folderOpen == undefined){
                  // fId = $rootScope.selectedItems[0].id;
                  // spId = $rootScope.selectedItems[0].spid;
                  // type = $rootScope.selectedItems[0].type;
                  // if(type == "sharepoint"){
                  //   splId = $rootScope.selectedItems[0].spid;
                  // } else{
                  //   splId = $rootScope.selectedItems[0].splId;
                  // }
                  $scope.folderContentFx($rootScope.selectedItems[0].id, $rootScope.selectedItems[0].splId, $rootScope.selectedItems[0].type);
                  // if(splId){
                  //   $scope.folderContentFx(fId, splId, type);
                  // } else{
                  //   $scope.folderContentFx(fId, spId, type);
                  // }
                  $rootScope.selectedItems = [];
                  $rootScope.unSelItems = [];
                }
              } else{
                //setTimeout(function(){
                  if($scope.singleClick){
                    $rootScope.sessionTimoutFx();
                    $rootScope.showTimeoutMsg = false;
                    $rootScope.excelObj = [];
                    if($rootScope.selectedItems.length == 1 && $rootScope.selectedItems[0].type == "excelfolder"){
                      $rootScope.excelObj = angular.copy($rootScope.selectedItems[0]);
                    }
                    $scope.folderBriefFx($rootScope.selectedItems);
                  }
                //}, 1000);
              }
              setTimeout(function(){
                dblClick = 0;
              }, 1000);
            } else{
              dblClick = 0;

              // if($scope.auth.upermissions.dp && $rootScope.thumbSelType == "dPaging"){

              //   if($rootScope.selectedItems.length == 0 && $rootScope.curItems == 0){
              //     if($rootScope.selectedMenu == 1){
              //       $scope.cancelPromise();
              //     }
              //   }
              //   else if($rootScope.selectedItems.length == 0 && $rootScope.curItems.length > 0){
              //     //this else if added -  for to maintain selection of other page devices
              //     if($window.event.ctrlKey){
              //       angular.forEach($rootScope.curItems, function(item, i){
              //         angular.forEach($rootScope.unSelItems, function(id){
              //           if(item.id == id){
              //             $rootScope.curItems.splice(i, 1);
              //           }
              //         });
              //       });
              //       $rootScope.selectedItems = $rootScope.curItems;

              //       if($rootScope.selectedItems.length > 0){
              //         $rootScope.tmpBriefDevices = [];
              //         angular.forEach($rootScope.selectedItems, function(item){
              //           angular.forEach($scope.brief.devices, function(listItem){
              //             if(listItem.id == item.id){
              //               $rootScope.tmpBriefDevices.push(listItem);
              //             }
              //           });
              //         });
              //         $rootScope.multiSelDevices = $rootScope.tmpBriefDevices;

              //         if($rootScope.selectedItems.length){
              //           $rootScope.sessionTimoutFx();
              //           $rootScope.showTimeoutMsg = false;
              //           $scope.briefFx($rootScope.selectedItems);
              //         }
              //       } else {
              //         $rootScope.selectedItems = [];
              //       }
              //     } else {
              //       $rootScope.tmpBriefDevices = [];
              //       $rootScope.multiSelDevices = [];
              //       $rootScope.selectedItems = [];
              //       $rootScope.curItems = [];
              //       $rootScope.unSelItems = [];
              //     }
              //   }
              //   else if($rootScope.selectedItems.length > 0){
              //     $rootScope.sessionTimoutFx();
              //     $rootScope.showTimeoutMsg = false;

              //     //code start - below code is used for maintain device selection with pagination
              //     if($window.event.ctrlKey && $rootScope.curItems.length > 0){
              //       angular.forEach($rootScope.curItems, function(item, i){
              //         angular.forEach($rootScope.unSelItems, function(id){
              //           if(item.id == id){
              //             $rootScope.curItems.splice(i, 1);
              //           }
              //         });
              //       });

              //       angular.forEach($rootScope.curItems, function(item){
              //         $scope.isDuplicate = false;
              //         angular.forEach($rootScope.selectedItems, function(listItem){
              //           if(listItem.id == item.id){
              //             $scope.isDuplicate = true;
              //             return false;
              //           }
              //         });
              //         if(!$scope.isDuplicate){
              //           $rootScope.selectedItems.push(item);
              //         }
              //       });
              //     }
              //     $scope.briefFx($rootScope.selectedItems);
              //   }
              // }
              // else {
                if($rootScope.selectedItems.length == 0){
                  if($rootScope.selectedMenu == 1){
                    $scope.cancelPromise();
                  }
                }
                else if($rootScope.selectedItems.length > 0){
                  $rootScope.sessionTimoutFx();
                  $rootScope.showTimeoutMsg = false;
                  $scope.briefFx($rootScope.selectedItems);
                }
              // }
            }
          });
        });
      }
      $scope.$watch(attr.selectable, function(value, old){
        if(value || value === undefined)
          return element.selectable(options);
        if(!value && old){
          element.selectable("destroy");
          element.find('.ui-selected').removeClass('ui-selected');
        }
      });

      /*Actions*/
      $rootScope.checkboxFx = function(event, id){
        // console.warn("Checkbox", event,id);
        if(event == "all"){
          processItems();
          // console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALLLLL", angular.element('.ui-selectable li').length);
          // angular.forEach(angular.element('.ui-selectable li'), function(item){
          //   $rootScope.selectedItems.push({
          //     id: $(item).data("id"),
          //     type: $(item).data("type"),
          //     subType: $(item).data("subType")
          //   });
          //   if($rootScope.selectedItems.length === 1){
          //     $rootScope.sessionTimoutFx();
          //     $rootScope.showTimeoutMsg = false;
          //     $scope.briefFx($rootScope.selectedItems[0].id);
          //   } else if($rootScope.selectedItems.length > 1){
          //     $rootScope.sessionTimoutFx();
          //     $rootScope.showTimeoutMsg = false;
          //     $scope.briefFx($rootScope.selectedItems);
          //   }
          //   if(!$(item).hasClass("nonSelectable")){
          //     $(item).addClass('ui-selected');
          //     $(item).find('input[type="checkbox"]').prop("checked", true);
          //   }
          // });
        } else{
          if(event.target.checked == true){
            angular.forEach(angular.element('.ui-selectable li'), function(item){
                var isExist = false;
                $rootScope.selectedItems.forEach(function(i){
                  if(i.id == $(item).attr('data-id')){
                    isExist = true;
                  }
                });
                if($(item).attr('data-id') == id && !isExist){
                  $rootScope.selectedItems.push({
                    id: $(item).data("id"),
                    type: $(item).data("type"),
                    subType: $(item).data("subType"),
                    isBlur: $(item).data("isBlur"),
                    status: $(item).data("status")
                  });
                  if($rootScope.selectedItems.length > 0){
                    $rootScope.sessionTimoutFx();
                    $rootScope.showTimeoutMsg = false;
                    $scope.briefFx($rootScope.selectedItems);
                  }
                  $(item).addClass('ui-selected');
                  $(item).find('input[type="checkbox"]').prop("checked", true);
                }
            });
          } else{
            $rootScope.closeFx(id);
          }
        }
      }

      function processItems(){
        var items = angular.element('.ui-selectable li');
        var batchSize = 300; // Number of items to process per batch
        var batchIndex = 0;

        function processBatch() {
            var endIndex = Math.min(batchIndex + batchSize, items.length);
            for (var i = batchIndex; i < endIndex; i++) {
                var item = angular.element(items[i]);
                $rootScope.selectedItems.push({
                    id: item.data("id"),
                    type: item.data("type"),
                    subType: item.data("subType")
                });

                if (!item.hasClass("nonSelectable")) {
                    item.addClass('ui-selected');
                    item.find('input[type="checkbox"]').prop("checked", true);
                }
            }

            // Handle session timeout logic after each batch
            if ($rootScope.selectedItems.length === 1) {
              $rootScope.sessionTimoutFx();
              $rootScope.showTimeoutMsg = false;
              $scope.briefFx($rootScope.selectedItems[0].id);
            } else if ($rootScope.selectedItems.length > 1) {
              $rootScope.sessionTimoutFx();
              $rootScope.showTimeoutMsg = false;
              $scope.briefFx($rootScope.selectedItems);
            }

            // Move to the next batch
            batchIndex = endIndex;

            if (batchIndex < items.length) {
                // Schedule the next batch
                setTimeout(processBatch, 0);
            }
        }

        // Start processing the first batch
        processBatch();
      }

      $rootScope.closeAllFx = function(){
        $rootScope.selectedItems = [];
        $rootScope.unSelItems = [];
        element.find('.ui-selected').find('input[type="checkbox"]').prop("checked", false);
        element.find('.ui-selected').removeClass('ui-selected');
      }

      $rootScope.closeFx = function(id, type, caller){
        angular.forEach($rootScope.selectedItems, function(item){
          if(type && id == item.id && type == item.type){
            if(type && type == item.type){
              $rootScope.selectedItems.splice($rootScope.selectedItems.indexOf(item), 1);
            } else{
              $rootScope.selectedItems.splice($rootScope.selectedItems.indexOf(item), 1);
            }
            if($rootScope.selectedItems.length === 1){
              if($rootScope.selectedItems[0].type == "folder" || $rootScope.selectedItems[0].type == "shortcut" || $rootScope.selectedItems[0].type == "sharepoint" || $rootScope.selectedItems[0].type == "onedrive" || $rootScope.selectedItems[0].type == "sharedfolder" || $rootScope.selectedItems[0].type == "excelfolder" || $rootScope.selectedItems[0].type == "googledrive"){
                $rootScope.sessionTimoutFx();
                $rootScope.showTimeoutMsg = false;

                $scope.folderBriefFx($rootScope.selectedItems);
              } else{
                $rootScope.sessionTimoutFx();
                $rootScope.showTimeoutMsg = false;
                $scope.briefFx($rootScope.selectedItems);
              }
            } else if($rootScope.selectedItems.length > 1){
              $rootScope.sessionTimoutFx();
              $rootScope.showTimeoutMsg = false;
              $scope.briefFx($rootScope.selectedItems);
            }
          } else if(!type){
            if(id == item.id){
              if(type && type == item.type){
                $rootScope.selectedItems.splice($rootScope.selectedItems.indexOf(item), 1);
              } else{
                $rootScope.selectedItems.splice($rootScope.selectedItems.indexOf(item), 1);
              }
              if($rootScope.selectedItems.length === 1){
                if($rootScope.selectedItems[0].type == "folder" || $rootScope.selectedItems[0].type == "shortcut" || $rootScope.selectedItems[0].type == "sharepoint" || $rootScope.selectedItems[0].type == "onedrive" || $rootScope.selectedItems[0].type == "sharedfolder" || $rootScope.selectedItems[0].type == "excelfolder" || $rootScope.selectedItems[0].type == "googledrive"){
                  $rootScope.sessionTimoutFx();
                  $rootScope.showTimeoutMsg = false;
                  $scope.folderBriefFx($rootScope.selectedItems);
                } else{
                  $rootScope.sessionTimoutFx();
                  $rootScope.showTimeoutMsg = false;
                  $scope.briefFx($rootScope.selectedItems);
                }
              } else if($rootScope.selectedItems.length > 1){
                $rootScope.sessionTimoutFx();
                $rootScope.showTimeoutMsg = false;
                $scope.briefFx($rootScope.selectedItems);
              }
            }
          }
        });
        angular.forEach(angular.element('.ui-selectable li.ui-selected'), function(item){
          if(type && $(item).attr('data-id') == id && $(item).attr('data-type') == type){
            $(item).removeClass('ui-selected');
            $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
          } else if(!type && $(item).attr('data-id') == id){
            $(item).removeClass('ui-selected');
            $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
          }
        });
        if(caller == 'flaRemove'){
          angular.forEach(angular.element('.ui-selectable li'), function(item){
            if(!type && $(item).attr('data-id') == id){
              $(item).removeClass('ui-selected');
              $(item).find('input[type="checkbox"]').prop("checked", false).removeClass('checked');
            }
          });
        }
      }
    }
  }]);

/*!
 * angular-ui-mask
 * https://github.com/angular-ui/ui-mask
 * Version: 1.8.7 - 2016-07-26T15:59:07.992Z
 * License: MIT
 */
!function(){"use strict";angular.module("ui.mask",[]).value("uiMaskConfig",{maskDefinitions:{9:/\d/,A:/[a-zA-Z]/,"*":/[a-zA-Z0-9]/},clearOnBlur:!0,clearOnBlurPlaceholder:!1,escChar:"\\",eventsToHandle:["input","keyup","click","focus"],addDefaultPlaceholder:!0,allowInvalidValue:!1}).provider("uiMask.Config",function(){var e={};this.maskDefinitions=function(n){return e.maskDefinitions=n},this.clearOnBlur=function(n){return e.clearOnBlur=n},this.clearOnBlurPlaceholder=function(n){return e.clearOnBlurPlaceholder=n},this.eventsToHandle=function(n){return e.eventsToHandle=n},this.addDefaultPlaceholder=function(n){return e.addDefaultPlaceholder=n},this.allowInvalidValue=function(n){return e.allowInvalidValue=n},this.$get=["uiMaskConfig",function(n){var t=n;for(var a in e)angular.isObject(e[a])&&!angular.isArray(e[a])?angular.extend(t[a],e[a]):t[a]=e[a];return t}]}).directive("uiMask",["uiMask.Config",function(e){function n(e){return e===document.activeElement&&(!document.hasFocus||document.hasFocus())&&!!(e.type||e.href||~e.tabIndex)}return{priority:100,require:"ngModel",restrict:"A",compile:function(){var t=angular.copy(e);return function(e,a,i,r){function l(e){return angular.isDefined(e)?(w(e),K?(h(),d(),!0):f()):f()}function u(e){e&&(T=e,!K||0===a.val().length&&angular.isDefined(i.placeholder)||a.val(m(p(a.val()))))}function o(){return l(i.uiMask)}function c(e){return K?(j=p(e||""),R=g(j),r.$setValidity("mask",R),j.length&&(R||Q.allowInvalidValue)?m(j):void 0):e}function s(e){return K?(j=p(e||""),R=g(j),r.$viewValue=j.length?m(j):"",r.$setValidity("mask",R),R||Q.allowInvalidValue?J?r.$viewValue:j:void 0):e}function f(){return K=!1,v(),angular.isDefined(q)?a.attr("placeholder",q):a.removeAttr("placeholder"),angular.isDefined(W)?a.attr("maxlength",W):a.removeAttr("maxlength"),a.val(r.$modelValue),r.$viewValue=r.$modelValue,!1}function h(){j=F=p(r.$modelValue||""),H=_=m(j),R=g(j),i.maxlength&&a.attr("maxlength",2*S[S.length-1]),!q&&Q.addDefaultPlaceholder&&a.attr("placeholder",T);for(var e=r.$modelValue,n=r.$formatters.length;n--;)e=r.$formatters[n](e);r.$viewValue=e||"",r.$render()}function d(){Z||(a.bind("blur",y),a.bind("mousedown mouseup",V),a.bind("keydown",M),a.bind(Q.eventsToHandle.join(" "),O),Z=!0)}function v(){Z&&(a.unbind("blur",y),a.unbind("mousedown",V),a.unbind("mouseup",V),a.unbind("keydown",M),a.unbind("input",O),a.unbind("keyup",O),a.unbind("click",O),a.unbind("focus",O),Z=!1)}function g(e){return e.length?e.length>=I:!0}function p(e){var n,t,i="",r=a[0],l=A.slice(),u=L,o=u+C(r),c="";return e=e.toString(),n=0,t=e.length-T.length,angular.forEach(B,function(a){var i=a.position;i>=u&&o>i||(i>=u&&(i+=t),e.substring(i,i+a.value.length)===a.value&&(c+=e.slice(n,i),n=i+a.value.length))}),e=c+e.slice(n),angular.forEach(e.split(""),function(e){l.length&&l[0].test(e)&&(i+=e,l.shift())}),i}function m(e){var n="",t=S.slice();return angular.forEach(T.split(""),function(a,i){e.length&&i===t[0]?(n+=e.charAt(0)||"_",e=e.substr(1),t.shift()):n+=a}),n}function b(e){var n,t=angular.isDefined(i.uiMaskPlaceholder)?i.uiMaskPlaceholder:i.placeholder;return angular.isDefined(t)&&t[e]?t[e]:(n=angular.isDefined(i.uiMaskPlaceholderChar)&&i.uiMaskPlaceholderChar?i.uiMaskPlaceholderChar:"_","space"===n.toLowerCase()?" ":n[0])}function k(){var e,n,t=T.split("");S&&!isNaN(S[0])&&angular.forEach(S,function(e){t[e]="_"}),e=t.join(""),n=e.replace(/[_]+/g,"_").split("_"),n=n.filter(function(e){return""!==e});var a=0;return n.map(function(n){var t=e.indexOf(n,a);return a=t+1,{value:n,position:t}})}function w(e){var n=0;if(S=[],A=[],T="",angular.isString(e)){I=0;var t=!1,a=0,i=e.split(""),r=!1;angular.forEach(i,function(e,i){r?(r=!1,T+=e,n++):Q.escChar===e?r=!0:Q.maskDefinitions[e]?(S.push(n),T+=b(i-a),A.push(Q.maskDefinitions[e]),n++,t||I++,t=!1):"?"===e?(t=!0,a++):(T+=e,n++)})}S.push(S.slice().pop()+1),B=k(),K=S.length>1?!0:!1}function y(){if((Q.clearOnBlur||Q.clearOnBlurPlaceholder&&0===j.length&&i.placeholder)&&(L=0,N=0,R&&0!==j.length||(H="",a.val(""),e.$apply(function(){r.$pristine||r.$setViewValue("")}))),j!==U){var n=a.val(),t=""===j&&n&&angular.isDefined(i.uiMaskPlaceholderChar)&&"space"===i.uiMaskPlaceholderChar;t&&a.val(""),$(a[0]),t&&a.val(n)}U=j}function $(e){var n;if(angular.isFunction(window.Event)&&!e.fireEvent)try{n=new Event("change",{view:window,bubbles:!0,cancelable:!1})}catch(t){n=document.createEvent("HTMLEvents"),n.initEvent("change",!1,!0)}finally{e.dispatchEvent(n)}else"createEvent"in document?(n=document.createEvent("HTMLEvents"),n.initEvent("change",!1,!0),e.dispatchEvent(n)):e.fireEvent&&e.fireEvent("onchange")}function V(e){"mousedown"===e.type?a.bind("mouseout",E):a.unbind("mouseout",E)}function E(){N=C(this),a.unbind("mouseout",E)}function M(e){var n=8===e.which,t=P(this)-1||0,i=90===e.which&&e.ctrlKey;if(n){for(;t>=0;){if(D(t)){x(this,t+1);break}t--}z=-1===t}i&&(a.val(""),e.preventDefault())}function O(n){n=n||{};var t=n.which,i=n.type;if(16!==t&&91!==t){var l,u=a.val(),o=_,c=!1,s=p(u),f=F,h=P(this)||0,d=L||0,v=h-d,g=S[0],b=S[s.length]||S.slice().shift(),k=N||0,w=C(this)>0,y=k>0,$=u.length>o.length||k&&u.length>o.length-k,V=u.length<o.length||k&&u.length===o.length-k,E=t>=37&&40>=t&&n.shiftKey,M=37===t,O=8===t||"keyup"!==i&&V&&-1===v,A=46===t||"keyup"!==i&&V&&0===v&&!y,B=(M||O||"click"===i)&&h>g;if(N=C(this),!E&&(!w||"click"!==i&&"keyup"!==i&&"focus"!==i)){if(O&&z)return a.val(T),e.$apply(function(){r.$setViewValue("")}),void x(this,d);if("input"===i&&V&&!y&&s===f){for(;O&&h>g&&!D(h);)h--;for(;A&&b>h&&-1===S.indexOf(h);)h++;var I=S.indexOf(h);s=s.substring(0,I)+s.substring(I+1),s!==f&&(c=!0)}for(l=m(s),_=l,F=s,!c&&u.length>l.length&&(c=!0),a.val(l),c&&e.$apply(function(){r.$setViewValue(l)}),$&&g>=h&&(h=g+1),B&&h--,h=h>b?b:g>h?g:h;!D(h)&&h>g&&b>h;)h+=B?-1:1;(B&&b>h||$&&!D(d))&&h++,L=h,x(this,h)}}}function D(e){return S.indexOf(e)>-1}function P(e){if(!e)return 0;if(void 0!==e.selectionStart)return e.selectionStart;if(document.selection&&n(a[0])){e.focus();var t=document.selection.createRange();return t.moveStart("character",e.value?-e.value.length:0),t.text.length}return 0}function x(e,t){if(!e)return 0;if(0!==e.offsetWidth&&0!==e.offsetHeight)if(e.setSelectionRange)n(a[0])&&(e.focus(),e.setSelectionRange(t,t));else if(e.createTextRange){var i=e.createTextRange();i.collapse(!0),i.moveEnd("character",t),i.moveStart("character",t),i.select()}}function C(e){return e?void 0!==e.selectionStart?e.selectionEnd-e.selectionStart:window.getSelection?window.getSelection().toString().length:document.selection?document.selection.createRange().text.length:0:0}var S,A,T,B,I,j,H,R,_,F,L,N,z,K=!1,Z=!1,q=i.placeholder,W=i.maxlength,G=r.$isEmpty;r.$isEmpty=function(e){return G(K?p(e||""):e)};var J=!1;i.$observe("modelViewValue",function(e){"true"===e&&(J=!0)}),i.$observe("allowInvalidValue",function(e){Q.allowInvalidValue=""===e?!0:!!e,c(r.$modelValue)});var Q={};i.uiOptions?(Q=e.$eval("["+i.uiOptions+"]"),Q=angular.isObject(Q[0])?function(e,n){for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(void 0===n[t]?n[t]=angular.copy(e[t]):angular.isObject(n[t])&&!angular.isArray(n[t])&&(n[t]=angular.extend({},e[t],n[t])));return n}(t,Q[0]):t):Q=t,i.$observe("uiMask",l),angular.isDefined(i.uiMaskPlaceholder)?i.$observe("uiMaskPlaceholder",u):i.$observe("placeholder",u),angular.isDefined(i.uiMaskPlaceholderChar)&&i.$observe("uiMaskPlaceholderChar",o),r.$formatters.unshift(c),r.$parsers.unshift(s);var U=a.val();a.bind("mousedown mouseup",V),Array.prototype.indexOf||(Array.prototype.indexOf=function(e){if(null===this)throw new TypeError;var n=Object(this),t=n.length>>>0;if(0===t)return-1;var a=0;if(arguments.length>1&&(a=Number(arguments[1]),a!==a?a=0:0!==a&&a!==1/0&&a!==-(1/0)&&(a=(a>0||-1)*Math.floor(Math.abs(a)))),a>=t)return-1;for(var i=a>=0?a:Math.max(t-Math.abs(a),0);t>i;i++)if(i in n&&n[i]===e)return i;return-1})}}}}])}();

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.JSEncrypt={})}(this,function(t){"use strict";var e="0123456789abcdefghijklmnopqrstuvwxyz";function i(t){return e.charAt(t)}function r(t,e){return t&e}function n(t,e){return t|e}function s(t,e){return t^e}function o(t,e){return t&~e}function h(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function a(t){for(var e=0;0!=t;)t&=t-1,++e;return e}var u="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",c="=";function f(t){var e,i,r="";for(e=0;e+3<=t.length;e+=3)i=parseInt(t.substring(e,e+3),16),r+=u.charAt(i>>6)+u.charAt(63&i);for(e+1==t.length?(i=parseInt(t.substring(e,e+1),16),r+=u.charAt(i<<2)):e+2==t.length&&(i=parseInt(t.substring(e,e+2),16),r+=u.charAt(i>>2)+u.charAt((3&i)<<4));(3&r.length)>0;)r+=c;return r}var l,p=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])};var g,d=function(t){var e;if(void 0===l){var i="0123456789ABCDEF",r=" \f\n\r\t \u2028\u2029";for(l={},e=0;e<16;++e)l[i.charAt(e)]=e;for(i=i.toLowerCase(),e=10;e<16;++e)l[i.charAt(e)]=e;for(e=0;e<r.length;++e)l[r.charAt(e)]=-1}var n=[],s=0,o=0;for(e=0;e<t.length;++e){var h=t.charAt(e);if("="==h)break;if(-1!=(h=l[h])){if(void 0===h)throw new Error("Illegal character at offset "+e);s|=h,++o>=2?(n[n.length]=s,s=0,o=0):s<<=4}}if(o)throw new Error("Hex encoding incomplete: 4 bits missing");return n},v={decode:function(t){var e;if(void 0===g){var i="= \f\n\r\t \u2028\u2029";for(g=Object.create(null),e=0;e<64;++e)g["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e)]=e;for(e=0;e<i.length;++e)g[i.charAt(e)]=-1}var r=[],n=0,s=0;for(e=0;e<t.length;++e){var o=t.charAt(e);if("="==o)break;if(-1!=(o=g[o])){if(void 0===o)throw new Error("Illegal character at offset "+e);n|=o,++s>=4?(r[r.length]=n>>16,r[r.length]=n>>8&255,r[r.length]=255&n,n=0,s=0):n<<=6}}switch(s){case 1:throw new Error("Base64 encoding incomplete: at least 2 bits missing");case 2:r[r.length]=n>>10;break;case 3:r[r.length]=n>>16,r[r.length]=n>>8&255}return r},re:/-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,unarmor:function(t){var e=v.re.exec(t);if(e)if(e[1])t=e[1];else{if(!e[2])throw new Error("RegExp out of sync");t=e[2]}return v.decode(t)}},m=1e13,y=function(){function t(t){this.buf=[+t||0]}return t.prototype.mulAdd=function(t,e){var i,r,n=this.buf,s=n.length;for(i=0;i<s;++i)(r=n[i]*t+e)<m?e=0:r-=(e=0|r/m)*m,n[i]=r;e>0&&(n[i]=e)},t.prototype.sub=function(t){var e,i,r=this.buf,n=r.length;for(e=0;e<n;++e)(i=r[e]-t)<0?(i+=m,t=1):t=0,r[e]=i;for(;0===r[r.length-1];)r.pop()},t.prototype.toString=function(t){if(10!=(t||10))throw new Error("only base 10 is supported");for(var e=this.buf,i=e[e.length-1].toString(),r=e.length-2;r>=0;--r)i+=(m+e[r]).toString().substring(1);return i},t.prototype.valueOf=function(){for(var t=this.buf,e=0,i=t.length-1;i>=0;--i)e=e*m+t[i];return e},t.prototype.simplify=function(){var t=this.buf;return 1==t.length?t[0]:this},t}(),b="…",T=/^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/,S=/^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;function E(t,e){return t.length>e&&(t=t.substring(0,e)+b),t}var w,D=function(){function t(e,i){this.hexDigits="0123456789ABCDEF",e instanceof t?(this.enc=e.enc,this.pos=e.pos):(this.enc=e,this.pos=i)}return t.prototype.get=function(t){if(void 0===t&&(t=this.pos++),t>=this.enc.length)throw new Error("Requesting byte offset "+t+" on a stream of length "+this.enc.length);return"string"==typeof this.enc?this.enc.charCodeAt(t):this.enc[t]},t.prototype.hexByte=function(t){return this.hexDigits.charAt(t>>4&15)+this.hexDigits.charAt(15&t)},t.prototype.hexDump=function(t,e,i){for(var r="",n=t;n<e;++n)if(r+=this.hexByte(this.get(n)),!0!==i)switch(15&n){case 7:r+="  ";break;case 15:r+="\n";break;default:r+=" "}return r},t.prototype.isASCII=function(t,e){for(var i=t;i<e;++i){var r=this.get(i);if(r<32||r>176)return!1}return!0},t.prototype.parseStringISO=function(t,e){for(var i="",r=t;r<e;++r)i+=String.fromCharCode(this.get(r));return i},t.prototype.parseStringUTF=function(t,e){for(var i="",r=t;r<e;){var n=this.get(r++);i+=n<128?String.fromCharCode(n):n>191&&n<224?String.fromCharCode((31&n)<<6|63&this.get(r++)):String.fromCharCode((15&n)<<12|(63&this.get(r++))<<6|63&this.get(r++))}return i},t.prototype.parseStringBMP=function(t,e){for(var i,r,n="",s=t;s<e;)i=this.get(s++),r=this.get(s++),n+=String.fromCharCode(i<<8|r);return n},t.prototype.parseTime=function(t,e,i){var r=this.parseStringISO(t,e),n=(i?T:S).exec(r);return n?(i&&(n[1]=+n[1],n[1]+=+n[1]<70?2e3:1900),r=n[1]+"-"+n[2]+"-"+n[3]+" "+n[4],n[5]&&(r+=":"+n[5],n[6]&&(r+=":"+n[6],n[7]&&(r+="."+n[7]))),n[8]&&(r+=" UTC","Z"!=n[8]&&(r+=n[8],n[9]&&(r+=":"+n[9]))),r):"Unrecognized time: "+r},t.prototype.parseInteger=function(t,e){for(var i,r=this.get(t),n=r>127,s=n?255:0,o="";r==s&&++t<e;)r=this.get(t);if(0===(i=e-t))return n?-1:0;if(i>4){for(o=r,i<<=3;0==(128&(+o^s));)o=+o<<1,--i;o="("+i+" bit)\n"}n&&(r-=256);for(var h=new y(r),a=t+1;a<e;++a)h.mulAdd(256,this.get(a));return o+h.toString()},t.prototype.parseBitString=function(t,e,i){for(var r=this.get(t),n="("+((e-t-1<<3)-r)+" bit)\n",s="",o=t+1;o<e;++o){for(var h=this.get(o),a=o==e-1?r:0,u=7;u>=a;--u)s+=h>>u&1?"1":"0";if(s.length>i)return n+E(s,i)}return n+s},t.prototype.parseOctetString=function(t,e,i){if(this.isASCII(t,e))return E(this.parseStringISO(t,e),i);var r=e-t,n="("+r+" byte)\n";r>(i/=2)&&(e=t+i);for(var s=t;s<e;++s)n+=this.hexByte(this.get(s));return r>i&&(n+=b),n},t.prototype.parseOID=function(t,e,i){for(var r="",n=new y,s=0,o=t;o<e;++o){var h=this.get(o);if(n.mulAdd(128,127&h),s+=7,!(128&h)){if(""===r)if((n=n.simplify())instanceof y)n.sub(80),r="2."+n.toString();else{var a=n<80?n<40?0:1:2;r=a+"."+(n-40*a)}else r+="."+n.toString();if(r.length>i)return E(r,i);n=new y,s=0}}return s>0&&(r+=".incomplete"),r},t}(),x=function(){function t(t,e,i,r,n){if(!(r instanceof R))throw new Error("Invalid tag value.");this.stream=t,this.header=e,this.length=i,this.tag=r,this.sub=n}return t.prototype.typeName=function(){switch(this.tag.tagClass){case 0:switch(this.tag.tagNumber){case 0:return"EOC";case 1:return"BOOLEAN";case 2:return"INTEGER";case 3:return"BIT_STRING";case 4:return"OCTET_STRING";case 5:return"NULL";case 6:return"OBJECT_IDENTIFIER";case 7:return"ObjectDescriptor";case 8:return"EXTERNAL";case 9:return"REAL";case 10:return"ENUMERATED";case 11:return"EMBEDDED_PDV";case 12:return"UTF8String";case 16:return"SEQUENCE";case 17:return"SET";case 18:return"NumericString";case 19:return"PrintableString";case 20:return"TeletexString";case 21:return"VideotexString";case 22:return"IA5String";case 23:return"UTCTime";case 24:return"GeneralizedTime";case 25:return"GraphicString";case 26:return"VisibleString";case 27:return"GeneralString";case 28:return"UniversalString";case 30:return"BMPString"}return"Universal_"+this.tag.tagNumber.toString();case 1:return"Application_"+this.tag.tagNumber.toString();case 2:return"["+this.tag.tagNumber.toString()+"]";case 3:return"Private_"+this.tag.tagNumber.toString()}},t.prototype.content=function(t){if(void 0===this.tag)return null;void 0===t&&(t=1/0);var e=this.posContent(),i=Math.abs(this.length);if(!this.tag.isUniversal())return null!==this.sub?"("+this.sub.length+" elem)":this.stream.parseOctetString(e,e+i,t);switch(this.tag.tagNumber){case 1:return 0===this.stream.get(e)?"false":"true";case 2:return this.stream.parseInteger(e,e+i);case 3:return this.sub?"("+this.sub.length+" elem)":this.stream.parseBitString(e,e+i,t);case 4:return this.sub?"("+this.sub.length+" elem)":this.stream.parseOctetString(e,e+i,t);case 6:return this.stream.parseOID(e,e+i,t);case 16:case 17:return null!==this.sub?"("+this.sub.length+" elem)":"(no elem)";case 12:return E(this.stream.parseStringUTF(e,e+i),t);case 18:case 19:case 20:case 21:case 22:case 26:return E(this.stream.parseStringISO(e,e+i),t);case 30:return E(this.stream.parseStringBMP(e,e+i),t);case 23:case 24:return this.stream.parseTime(e,e+i,23==this.tag.tagNumber)}return null},t.prototype.toString=function(){return this.typeName()+"@"+this.stream.pos+"[header:"+this.header+",length:"+this.length+",sub:"+(null===this.sub?"null":this.sub.length)+"]"},t.prototype.toPrettyString=function(t){void 0===t&&(t="");var e=t+this.typeName()+" @"+this.stream.pos;if(this.length>=0&&(e+="+"),e+=this.length,this.tag.tagConstructed?e+=" (constructed)":!this.tag.isUniversal()||3!=this.tag.tagNumber&&4!=this.tag.tagNumber||null===this.sub||(e+=" (encapsulates)"),e+="\n",null!==this.sub){t+="  ";for(var i=0,r=this.sub.length;i<r;++i)e+=this.sub[i].toPrettyString(t)}return e},t.prototype.posStart=function(){return this.stream.pos},t.prototype.posContent=function(){return this.stream.pos+this.header},t.prototype.posEnd=function(){return this.stream.pos+this.header+Math.abs(this.length)},t.prototype.toHexString=function(){return this.stream.hexDump(this.posStart(),this.posEnd(),!0)},t.decodeLength=function(t){var e=t.get(),i=127&e;if(i==e)return i;if(i>6)throw new Error("Length over 48 bits not supported at position "+(t.pos-1));if(0===i)return null;e=0;for(var r=0;r<i;++r)e=256*e+t.get();return e},t.prototype.getHexStringValue=function(){var t=this.toHexString(),e=2*this.header,i=2*this.length;return t.substr(e,i)},t.decode=function(e){var i;i=e instanceof D?e:new D(e,0);var r=new D(i),n=new R(i),s=t.decodeLength(i),o=i.pos,h=o-r.pos,a=null,u=function(){var e=[];if(null!==s){for(var r=o+s;i.pos<r;)e[e.length]=t.decode(i);if(i.pos!=r)throw new Error("Content size is not correct for container starting at offset "+o)}else try{for(;;){var n=t.decode(i);if(n.tag.isEOC())break;e[e.length]=n}s=o-i.pos}catch(t){throw new Error("Exception while decoding undefined length content: "+t)}return e};if(n.tagConstructed)a=u();else if(n.isUniversal()&&(3==n.tagNumber||4==n.tagNumber))try{if(3==n.tagNumber&&0!=i.get())throw new Error("BIT STRINGs with unused bits cannot encapsulate.");a=u();for(var c=0;c<a.length;++c)if(a[c].tag.isEOC())throw new Error("EOC is not supposed to be actual content.")}catch(t){a=null}if(null===a){if(null===s)throw new Error("We can't skip over an invalid tag with undefined length at offset "+o);i.pos=o+Math.abs(s)}return new t(r,h,s,n,a)},t}(),R=function(){function t(t){var e=t.get();if(this.tagClass=e>>6,this.tagConstructed=0!=(32&e),this.tagNumber=31&e,31==this.tagNumber){for(var i=new y;e=t.get(),i.mulAdd(128,127&e),128&e;);this.tagNumber=i.simplify()}}return t.prototype.isUniversal=function(){return 0===this.tagClass},t.prototype.isEOC=function(){return 0===this.tagClass&&0===this.tagNumber},t}(),B=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],A=(1<<26)/B[B.length-1],O=function(){function t(t,e,i){null!=t&&("number"==typeof t?this.fromNumber(t,e,i):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}return t.prototype.toString=function(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var r,n=(1<<e)-1,s=!1,o="",h=this.t,a=this.DB-h*this.DB%e;if(h-- >0)for(a<this.DB&&(r=this[h]>>a)>0&&(s=!0,o=i(r));h>=0;)a<e?(r=(this[h]&(1<<a)-1)<<e-a,r|=this[--h]>>(a+=this.DB-e)):(r=this[h]>>(a-=e)&n,a<=0&&(a+=this.DB,--h)),r>0&&(s=!0),s&&(o+=i(r));return s?o:"0"},t.prototype.negate=function(){var e=M();return t.ZERO.subTo(this,e),e},t.prototype.abs=function(){return this.s<0?this.negate():this},t.prototype.compareTo=function(t){var e=this.s-t.s;if(0!=e)return e;var i=this.t;if(0!=(e=i-t.t))return this.s<0?-e:e;for(;--i>=0;)if(0!=(e=this[i]-t[i]))return e;return 0},t.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+U(this[this.t-1]^this.s&this.DM)},t.prototype.mod=function(e){var i=M();return this.abs().divRemTo(e,null,i),this.s<0&&i.compareTo(t.ZERO)>0&&e.subTo(i,i),i},t.prototype.modPowInt=function(t,e){var i;return i=t<256||e.isEven()?new I(e):new N(e),this.exp(t,i)},t.prototype.clone=function(){var t=M();return this.copyTo(t),t},t.prototype.intValue=function(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},t.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},t.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},t.prototype.signum=function(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},t.prototype.toByteArray=function(){var t=this.t,e=[];e[0]=this.s;var i,r=this.DB-t*this.DB%8,n=0;if(t-- >0)for(r<this.DB&&(i=this[t]>>r)!=(this.s&this.DM)>>r&&(e[n++]=i|this.s<<this.DB-r);t>=0;)r<8?(i=(this[t]&(1<<r)-1)<<8-r,i|=this[--t]>>(r+=this.DB-8)):(i=this[t]>>(r-=8)&255,r<=0&&(r+=this.DB,--t)),0!=(128&i)&&(i|=-256),0==n&&(128&this.s)!=(128&i)&&++n,(n>0||i!=this.s)&&(e[n++]=i);return e},t.prototype.equals=function(t){return 0==this.compareTo(t)},t.prototype.min=function(t){return this.compareTo(t)<0?this:t},t.prototype.max=function(t){return this.compareTo(t)>0?this:t},t.prototype.and=function(t){var e=M();return this.bitwiseTo(t,r,e),e},t.prototype.or=function(t){var e=M();return this.bitwiseTo(t,n,e),e},t.prototype.xor=function(t){var e=M();return this.bitwiseTo(t,s,e),e},t.prototype.andNot=function(t){var e=M();return this.bitwiseTo(t,o,e),e},t.prototype.not=function(){for(var t=M(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t},t.prototype.shiftLeft=function(t){var e=M();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e},t.prototype.shiftRight=function(t){var e=M();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e},t.prototype.getLowestSetBit=function(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+h(this[t]);return this.s<0?this.t*this.DB:-1},t.prototype.bitCount=function(){for(var t=0,e=this.s&this.DM,i=0;i<this.t;++i)t+=a(this[i]^e);return t},t.prototype.testBit=function(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)},t.prototype.setBit=function(t){return this.changeBit(t,n)},t.prototype.clearBit=function(t){return this.changeBit(t,o)},t.prototype.flipBit=function(t){return this.changeBit(t,s)},t.prototype.add=function(t){var e=M();return this.addTo(t,e),e},t.prototype.subtract=function(t){var e=M();return this.subTo(t,e),e},t.prototype.multiply=function(t){var e=M();return this.multiplyTo(t,e),e},t.prototype.divide=function(t){var e=M();return this.divRemTo(t,e,null),e},t.prototype.remainder=function(t){var e=M();return this.divRemTo(t,null,e),e},t.prototype.divideAndRemainder=function(t){var e=M(),i=M();return this.divRemTo(t,e,i),[e,i]},t.prototype.modPow=function(t,e){var i,r,n=t.bitLength(),s=F(1);if(n<=0)return s;i=n<18?1:n<48?3:n<144?4:n<768?5:6,r=n<8?new I(e):e.isEven()?new P(e):new N(e);var o=[],h=3,a=i-1,u=(1<<i)-1;if(o[1]=r.convert(this),i>1){var c=M();for(r.sqrTo(o[1],c);h<=u;)o[h]=M(),r.mulTo(c,o[h-2],o[h]),h+=2}var f,l,p=t.t-1,g=!0,d=M();for(n=U(t[p])-1;p>=0;){for(n>=a?f=t[p]>>n-a&u:(f=(t[p]&(1<<n+1)-1)<<a-n,p>0&&(f|=t[p-1]>>this.DB+n-a)),h=i;0==(1&f);)f>>=1,--h;if((n-=h)<0&&(n+=this.DB,--p),g)o[f].copyTo(s),g=!1;else{for(;h>1;)r.sqrTo(s,d),r.sqrTo(d,s),h-=2;h>0?r.sqrTo(s,d):(l=s,s=d,d=l),r.mulTo(d,o[f],s)}for(;p>=0&&0==(t[p]&1<<n);)r.sqrTo(s,d),l=s,s=d,d=l,--n<0&&(n=this.DB-1,--p)}return r.revert(s)},t.prototype.modInverse=function(e){var i=e.isEven();if(this.isEven()&&i||0==e.signum())return t.ZERO;for(var r=e.clone(),n=this.clone(),s=F(1),o=F(0),h=F(0),a=F(1);0!=r.signum();){for(;r.isEven();)r.rShiftTo(1,r),i?(s.isEven()&&o.isEven()||(s.addTo(this,s),o.subTo(e,o)),s.rShiftTo(1,s)):o.isEven()||o.subTo(e,o),o.rShiftTo(1,o);for(;n.isEven();)n.rShiftTo(1,n),i?(h.isEven()&&a.isEven()||(h.addTo(this,h),a.subTo(e,a)),h.rShiftTo(1,h)):a.isEven()||a.subTo(e,a),a.rShiftTo(1,a);r.compareTo(n)>=0?(r.subTo(n,r),i&&s.subTo(h,s),o.subTo(a,o)):(n.subTo(r,n),i&&h.subTo(s,h),a.subTo(o,a))}return 0!=n.compareTo(t.ONE)?t.ZERO:a.compareTo(e)>=0?a.subtract(e):a.signum()<0?(a.addTo(e,a),a.signum()<0?a.add(e):a):a},t.prototype.pow=function(t){return this.exp(t,new V)},t.prototype.gcd=function(t){var e=this.s<0?this.negate():this.clone(),i=t.s<0?t.negate():t.clone();if(e.compareTo(i)<0){var r=e;e=i,i=r}var n=e.getLowestSetBit(),s=i.getLowestSetBit();if(s<0)return e;for(n<s&&(s=n),s>0&&(e.rShiftTo(s,e),i.rShiftTo(s,i));e.signum()>0;)(n=e.getLowestSetBit())>0&&e.rShiftTo(n,e),(n=i.getLowestSetBit())>0&&i.rShiftTo(n,i),e.compareTo(i)>=0?(e.subTo(i,e),e.rShiftTo(1,e)):(i.subTo(e,i),i.rShiftTo(1,i));return s>0&&i.lShiftTo(s,i),i},t.prototype.isProbablePrime=function(t){var e,i=this.abs();if(1==i.t&&i[0]<=B[B.length-1]){for(e=0;e<B.length;++e)if(i[0]==B[e])return!0;return!1}if(i.isEven())return!1;for(e=1;e<B.length;){for(var r=B[e],n=e+1;n<B.length&&r<A;)r*=B[n++];for(r=i.modInt(r);e<n;)if(r%B[e++]==0)return!1}return i.millerRabin(t)},t.prototype.copyTo=function(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s},t.prototype.fromInt=function(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},t.prototype.fromString=function(e,i){var r;if(16==i)r=4;else if(8==i)r=3;else if(256==i)r=8;else if(2==i)r=1;else if(32==i)r=5;else{if(4!=i)return void this.fromRadix(e,i);r=2}this.t=0,this.s=0;for(var n=e.length,s=!1,o=0;--n>=0;){var h=8==r?255&+e[n]:C(e,n);h<0?"-"==e.charAt(n)&&(s=!0):(s=!1,0==o?this[this.t++]=h:o+r>this.DB?(this[this.t-1]|=(h&(1<<this.DB-o)-1)<<o,this[this.t++]=h>>this.DB-o):this[this.t-1]|=h<<o,(o+=r)>=this.DB&&(o-=this.DB))}8==r&&0!=(128&+e[0])&&(this.s=-1,o>0&&(this[this.t-1]|=(1<<this.DB-o)-1<<o)),this.clamp(),s&&t.ZERO.subTo(this,this)},t.prototype.clamp=function(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},t.prototype.dlShiftTo=function(t,e){var i;for(i=this.t-1;i>=0;--i)e[i+t]=this[i];for(i=t-1;i>=0;--i)e[i]=0;e.t=this.t+t,e.s=this.s},t.prototype.drShiftTo=function(t,e){for(var i=t;i<this.t;++i)e[i-t]=this[i];e.t=Math.max(this.t-t,0),e.s=this.s},t.prototype.lShiftTo=function(t,e){for(var i=t%this.DB,r=this.DB-i,n=(1<<r)-1,s=Math.floor(t/this.DB),o=this.s<<i&this.DM,h=this.t-1;h>=0;--h)e[h+s+1]=this[h]>>r|o,o=(this[h]&n)<<i;for(h=s-1;h>=0;--h)e[h]=0;e[s]=o,e.t=this.t+s+1,e.s=this.s,e.clamp()},t.prototype.rShiftTo=function(t,e){e.s=this.s;var i=Math.floor(t/this.DB);if(i>=this.t)e.t=0;else{var r=t%this.DB,n=this.DB-r,s=(1<<r)-1;e[0]=this[i]>>r;for(var o=i+1;o<this.t;++o)e[o-i-1]|=(this[o]&s)<<n,e[o-i]=this[o]>>r;r>0&&(e[this.t-i-1]|=(this.s&s)<<n),e.t=this.t-i,e.clamp()}},t.prototype.subTo=function(t,e){for(var i=0,r=0,n=Math.min(t.t,this.t);i<n;)r+=this[i]-t[i],e[i++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r-=t.s;i<this.t;)r+=this[i],e[i++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;i<t.t;)r-=t[i],e[i++]=r&this.DM,r>>=this.DB;r-=t.s}e.s=r<0?-1:0,r<-1?e[i++]=this.DV+r:r>0&&(e[i++]=r),e.t=i,e.clamp()},t.prototype.multiplyTo=function(e,i){var r=this.abs(),n=e.abs(),s=r.t;for(i.t=s+n.t;--s>=0;)i[s]=0;for(s=0;s<n.t;++s)i[s+r.t]=r.am(0,n[s],i,s,0,r.t);i.s=0,i.clamp(),this.s!=e.s&&t.ZERO.subTo(i,i)},t.prototype.squareTo=function(t){for(var e=this.abs(),i=t.t=2*e.t;--i>=0;)t[i]=0;for(i=0;i<e.t-1;++i){var r=e.am(i,e[i],t,2*i,0,1);(t[i+e.t]+=e.am(i+1,2*e[i],t,2*i+1,r,e.t-i-1))>=e.DV&&(t[i+e.t]-=e.DV,t[i+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(i,e[i],t,2*i,0,1)),t.s=0,t.clamp()},t.prototype.divRemTo=function(e,i,r){var n=e.abs();if(!(n.t<=0)){var s=this.abs();if(s.t<n.t)return null!=i&&i.fromInt(0),void(null!=r&&this.copyTo(r));null==r&&(r=M());var o=M(),h=this.s,a=e.s,u=this.DB-U(n[n.t-1]);u>0?(n.lShiftTo(u,o),s.lShiftTo(u,r)):(n.copyTo(o),s.copyTo(r));var c=o.t,f=o[c-1];if(0!=f){var l=f*(1<<this.F1)+(c>1?o[c-2]>>this.F2:0),p=this.FV/l,g=(1<<this.F1)/l,d=1<<this.F2,v=r.t,m=v-c,y=null==i?M():i;for(o.dlShiftTo(m,y),r.compareTo(y)>=0&&(r[r.t++]=1,r.subTo(y,r)),t.ONE.dlShiftTo(c,y),y.subTo(o,o);o.t<c;)o[o.t++]=0;for(;--m>=0;){var b=r[--v]==f?this.DM:Math.floor(r[v]*p+(r[v-1]+d)*g);if((r[v]+=o.am(0,b,r,m,0,c))<b)for(o.dlShiftTo(m,y),r.subTo(y,r);r[v]<--b;)r.subTo(y,r)}null!=i&&(r.drShiftTo(c,i),h!=a&&t.ZERO.subTo(i,i)),r.t=c,r.clamp(),u>0&&r.rShiftTo(u,r),h<0&&t.ZERO.subTo(r,r)}}},t.prototype.invDigit=function(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return(e=(e=(e=(e=e*(2-(15&t)*e)&15)*(2-(255&t)*e)&255)*(2-((65535&t)*e&65535))&65535)*(2-t*e%this.DV)%this.DV)>0?this.DV-e:-e},t.prototype.isEven=function(){return 0==(this.t>0?1&this[0]:this.s)},t.prototype.exp=function(e,i){if(e>4294967295||e<1)return t.ONE;var r=M(),n=M(),s=i.convert(this),o=U(e)-1;for(s.copyTo(r);--o>=0;)if(i.sqrTo(r,n),(e&1<<o)>0)i.mulTo(n,s,r);else{var h=r;r=n,n=h}return i.revert(r)},t.prototype.chunkSize=function(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},t.prototype.toRadix=function(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),i=Math.pow(t,e),r=F(i),n=M(),s=M(),o="";for(this.divRemTo(r,n,s);n.signum()>0;)o=(i+s.intValue()).toString(t).substr(1)+o,n.divRemTo(r,n,s);return s.intValue().toString(t)+o},t.prototype.fromRadix=function(e,i){this.fromInt(0),null==i&&(i=10);for(var r=this.chunkSize(i),n=Math.pow(i,r),s=!1,o=0,h=0,a=0;a<e.length;++a){var u=C(e,a);u<0?"-"==e.charAt(a)&&0==this.signum()&&(s=!0):(h=i*h+u,++o>=r&&(this.dMultiply(n),this.dAddOffset(h,0),o=0,h=0))}o>0&&(this.dMultiply(Math.pow(i,o)),this.dAddOffset(h,0)),s&&t.ZERO.subTo(this,this)},t.prototype.fromNumber=function(e,i,r){if("number"==typeof i)if(e<2)this.fromInt(1);else for(this.fromNumber(e,r),this.testBit(e-1)||this.bitwiseTo(t.ONE.shiftLeft(e-1),n,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(i);)this.dAddOffset(2,0),this.bitLength()>e&&this.subTo(t.ONE.shiftLeft(e-1),this);else{var s=[],o=7&e;s.length=1+(e>>3),i.nextBytes(s),o>0?s[0]&=(1<<o)-1:s[0]=0,this.fromString(s,256)}},t.prototype.bitwiseTo=function(t,e,i){var r,n,s=Math.min(t.t,this.t);for(r=0;r<s;++r)i[r]=e(this[r],t[r]);if(t.t<this.t){for(n=t.s&this.DM,r=s;r<this.t;++r)i[r]=e(this[r],n);i.t=this.t}else{for(n=this.s&this.DM,r=s;r<t.t;++r)i[r]=e(n,t[r]);i.t=t.t}i.s=e(this.s,t.s),i.clamp()},t.prototype.changeBit=function(e,i){var r=t.ONE.shiftLeft(e);return this.bitwiseTo(r,i,r),r},t.prototype.addTo=function(t,e){for(var i=0,r=0,n=Math.min(t.t,this.t);i<n;)r+=this[i]+t[i],e[i++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r+=t.s;i<this.t;)r+=this[i],e[i++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;i<t.t;)r+=t[i],e[i++]=r&this.DM,r>>=this.DB;r+=t.s}e.s=r<0?-1:0,r>0?e[i++]=r:r<-1&&(e[i++]=this.DV+r),e.t=i,e.clamp()},t.prototype.dMultiply=function(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},t.prototype.dAddOffset=function(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}},t.prototype.multiplyLowerTo=function(t,e,i){var r=Math.min(this.t+t.t,e);for(i.s=0,i.t=r;r>0;)i[--r]=0;for(var n=i.t-this.t;r<n;++r)i[r+this.t]=this.am(0,t[r],i,r,0,this.t);for(n=Math.min(t.t,e);r<n;++r)this.am(0,t[r],i,r,0,e-r);i.clamp()},t.prototype.multiplyUpperTo=function(t,e,i){--e;var r=i.t=this.t+t.t-e;for(i.s=0;--r>=0;)i[r]=0;for(r=Math.max(e-this.t,0);r<t.t;++r)i[this.t+r-e]=this.am(e-r,t[r],i,0,0,this.t+r-e);i.clamp(),i.drShiftTo(1,i)},t.prototype.modInt=function(t){if(t<=0)return 0;var e=this.DV%t,i=this.s<0?t-1:0;if(this.t>0)if(0==e)i=this[0]%t;else for(var r=this.t-1;r>=0;--r)i=(e*i+this[r])%t;return i},t.prototype.millerRabin=function(e){var i=this.subtract(t.ONE),r=i.getLowestSetBit();if(r<=0)return!1;var n=i.shiftRight(r);(e=e+1>>1)>B.length&&(e=B.length);for(var s=M(),o=0;o<e;++o){s.fromInt(B[Math.floor(Math.random()*B.length)]);var h=s.modPow(n,this);if(0!=h.compareTo(t.ONE)&&0!=h.compareTo(i)){for(var a=1;a++<r&&0!=h.compareTo(i);)if(0==(h=h.modPowInt(2,this)).compareTo(t.ONE))return!1;if(0!=h.compareTo(i))return!1}}return!0},t.prototype.square=function(){var t=M();return this.squareTo(t),t},t.prototype.gcda=function(t,e){var i=this.s<0?this.negate():this.clone(),r=t.s<0?t.negate():t.clone();if(i.compareTo(r)<0){var n=i;i=r,r=n}var s=i.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)e(i);else{s<o&&(o=s),o>0&&(i.rShiftTo(o,i),r.rShiftTo(o,r));var h=function(){(s=i.getLowestSetBit())>0&&i.rShiftTo(s,i),(s=r.getLowestSetBit())>0&&r.rShiftTo(s,r),i.compareTo(r)>=0?(i.subTo(r,i),i.rShiftTo(1,i)):(r.subTo(i,r),r.rShiftTo(1,r)),i.signum()>0?setTimeout(h,0):(o>0&&r.lShiftTo(o,r),setTimeout(function(){e(r)},0))};setTimeout(h,10)}},t.prototype.fromNumberAsync=function(e,i,r,s){if("number"==typeof i)if(e<2)this.fromInt(1);else{this.fromNumber(e,r),this.testBit(e-1)||this.bitwiseTo(t.ONE.shiftLeft(e-1),n,this),this.isEven()&&this.dAddOffset(1,0);var o=this,h=function(){o.dAddOffset(2,0),o.bitLength()>e&&o.subTo(t.ONE.shiftLeft(e-1),o),o.isProbablePrime(i)?setTimeout(function(){s()},0):setTimeout(h,0)};setTimeout(h,0)}else{var a=[],u=7&e;a.length=1+(e>>3),i.nextBytes(a),u>0?a[0]&=(1<<u)-1:a[0]=0,this.fromString(a,256)}},t}(),V=function(){function t(){}return t.prototype.convert=function(t){return t},t.prototype.revert=function(t){return t},t.prototype.mulTo=function(t,e,i){t.multiplyTo(e,i)},t.prototype.sqrTo=function(t,e){t.squareTo(e)},t}(),I=function(){function t(t){this.m=t}return t.prototype.convert=function(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},t.prototype.revert=function(t){return t},t.prototype.reduce=function(t){t.divRemTo(this.m,null,t)},t.prototype.mulTo=function(t,e,i){t.multiplyTo(e,i),this.reduce(i)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}(),N=function(){function t(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}return t.prototype.convert=function(t){var e=M();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(O.ZERO)>0&&this.m.subTo(e,e),e},t.prototype.revert=function(t){var e=M();return t.copyTo(e),this.reduce(e),e},t.prototype.reduce=function(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var i=32767&t[e],r=i*this.mpl+((i*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[i=e+this.m.t]+=this.m.am(0,r,t,e,0,this.m.t);t[i]>=t.DV;)t[i]-=t.DV,t[++i]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},t.prototype.mulTo=function(t,e,i){t.multiplyTo(e,i),this.reduce(i)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}(),P=function(){function t(t){this.m=t,this.r2=M(),this.q3=M(),O.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t)}return t.prototype.convert=function(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=M();return t.copyTo(e),this.reduce(e),e},t.prototype.revert=function(t){return t},t.prototype.reduce=function(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},t.prototype.mulTo=function(t,e,i){t.multiplyTo(e,i),this.reduce(i)},t.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},t}();function M(){return new O(null)}function q(t,e){return new O(t,e)}"Microsoft Internet Explorer"==navigator.appName?(O.prototype.am=function(t,e,i,r,n,s){for(var o=32767&e,h=e>>15;--s>=0;){var a=32767&this[t],u=this[t++]>>15,c=h*a+u*o;n=((a=o*a+((32767&c)<<15)+i[r]+(1073741823&n))>>>30)+(c>>>15)+h*u+(n>>>30),i[r++]=1073741823&a}return n},w=30):"Netscape"!=navigator.appName?(O.prototype.am=function(t,e,i,r,n,s){for(;--s>=0;){var o=e*this[t++]+i[r]+n;n=Math.floor(o/67108864),i[r++]=67108863&o}return n},w=26):(O.prototype.am=function(t,e,i,r,n,s){for(var o=16383&e,h=e>>14;--s>=0;){var a=16383&this[t],u=this[t++]>>14,c=h*a+u*o;n=((a=o*a+((16383&c)<<14)+i[r]+n)>>28)+(c>>14)+h*u,i[r++]=268435455&a}return n},w=28),O.prototype.DB=w,O.prototype.DM=(1<<w)-1,O.prototype.DV=1<<w;O.prototype.FV=Math.pow(2,52),O.prototype.F1=52-w,O.prototype.F2=2*w-52;var j,L,H=[];for(j="0".charCodeAt(0),L=0;L<=9;++L)H[j++]=L;for(j="a".charCodeAt(0),L=10;L<36;++L)H[j++]=L;for(j="A".charCodeAt(0),L=10;L<36;++L)H[j++]=L;function C(t,e){var i=H[t.charCodeAt(e)];return null==i?-1:i}function F(t){var e=M();return e.fromInt(t),e}function U(t){var e,i=1;return 0!=(e=t>>>16)&&(t=e,i+=16),0!=(e=t>>8)&&(t=e,i+=8),0!=(e=t>>4)&&(t=e,i+=4),0!=(e=t>>2)&&(t=e,i+=2),0!=(e=t>>1)&&(t=e,i+=1),i}O.ZERO=F(0),O.ONE=F(1);var K=function(){function t(){this.i=0,this.j=0,this.S=[]}return t.prototype.init=function(t){var e,i,r;for(e=0;e<256;++e)this.S[e]=e;for(i=0,e=0;e<256;++e)i=i+this.S[e]+t[e%t.length]&255,r=this.S[e],this.S[e]=this.S[i],this.S[i]=r;this.i=0,this.j=0},t.prototype.next=function(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]},t}();var k,_,z=256,Z=null;if(null==Z){Z=[],_=0;var G=void 0;if(window.crypto&&window.crypto.getRandomValues){var $=new Uint32Array(256);for(window.crypto.getRandomValues($),G=0;G<$.length;++G)Z[_++]=255&$[G]}var Y=function(t){if(this.count=this.count||0,this.count>=256||_>=z)window.removeEventListener?window.removeEventListener("mousemove",Y,!1):window.detachEvent&&window.detachEvent("onmousemove",Y);else try{var e=t.x+t.y;Z[_++]=255&e,this.count+=1}catch(t){}};window.addEventListener?window.addEventListener("mousemove",Y,!1):window.attachEvent&&window.attachEvent("onmousemove",Y)}function J(){if(null==k){for(k=new K;_<z;){var t=Math.floor(65536*Math.random());Z[_++]=255&t}for(k.init(Z),_=0;_<Z.length;++_)Z[_]=0;_=0}return k.next()}var X=function(){function t(){}return t.prototype.nextBytes=function(t){for(var e=0;e<t.length;++e)t[e]=J()},t}();var Q=function(){function t(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}return t.prototype.doPublic=function(t){return t.modPowInt(this.e,this.n)},t.prototype.doPrivate=function(t){if(null==this.p||null==this.q)return t.modPow(this.d,this.n);for(var e=t.mod(this.p).modPow(this.dmp1,this.p),i=t.mod(this.q).modPow(this.dmq1,this.q);e.compareTo(i)<0;)e=e.add(this.p);return e.subtract(i).multiply(this.coeff).mod(this.p).multiply(this.q).add(i)},t.prototype.setPublic=function(t,e){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=q(t,16),this.e=parseInt(e,16)):console.error("Invalid RSA public key")},t.prototype.encrypt=function(t){var e=function(t,e){if(e<t.length+11)return console.error("Message too long for RSA"),null;for(var i=[],r=t.length-1;r>=0&&e>0;){var n=t.charCodeAt(r--);n<128?i[--e]=n:n>127&&n<2048?(i[--e]=63&n|128,i[--e]=n>>6|192):(i[--e]=63&n|128,i[--e]=n>>6&63|128,i[--e]=n>>12|224)}i[--e]=0;for(var s=new X,o=[];e>2;){for(o[0]=0;0==o[0];)s.nextBytes(o);i[--e]=o[0]}return i[--e]=2,i[--e]=0,new O(i)}(t,this.n.bitLength()+7>>3);if(null==e)return null;var i=this.doPublic(e);if(null==i)return null;var r=i.toString(16);return 0==(1&r.length)?r:"0"+r},t.prototype.setPrivate=function(t,e,i){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=q(t,16),this.e=parseInt(e,16),this.d=q(i,16)):console.error("Invalid RSA private key")},t.prototype.setPrivateEx=function(t,e,i,r,n,s,o,h){null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=q(t,16),this.e=parseInt(e,16),this.d=q(i,16),this.p=q(r,16),this.q=q(n,16),this.dmp1=q(s,16),this.dmq1=q(o,16),this.coeff=q(h,16)):console.error("Invalid RSA private key")},t.prototype.generate=function(t,e){var i=new X,r=t>>1;this.e=parseInt(e,16);for(var n=new O(e,16);;){for(;this.p=new O(t-r,1,i),0!=this.p.subtract(O.ONE).gcd(n).compareTo(O.ONE)||!this.p.isProbablePrime(10););for(;this.q=new O(r,1,i),0!=this.q.subtract(O.ONE).gcd(n).compareTo(O.ONE)||!this.q.isProbablePrime(10););if(this.p.compareTo(this.q)<=0){var s=this.p;this.p=this.q,this.q=s}var o=this.p.subtract(O.ONE),h=this.q.subtract(O.ONE),a=o.multiply(h);if(0==a.gcd(n).compareTo(O.ONE)){this.n=this.p.multiply(this.q),this.d=n.modInverse(a),this.dmp1=this.d.mod(o),this.dmq1=this.d.mod(h),this.coeff=this.q.modInverse(this.p);break}}},t.prototype.decrypt=function(t){var e=q(t,16),i=this.doPrivate(e);return null==i?null:function(t,e){var i=t.toByteArray(),r=0;for(;r<i.length&&0==i[r];)++r;if(i.length-r!=e-1||2!=i[r])return null;++r;for(;0!=i[r];)if(++r>=i.length)return null;var n="";for(;++r<i.length;){var s=255&i[r];s<128?n+=String.fromCharCode(s):s>191&&s<224?(n+=String.fromCharCode((31&s)<<6|63&i[r+1]),++r):(n+=String.fromCharCode((15&s)<<12|(63&i[r+1])<<6|63&i[r+2]),r+=2)}return n}(i,this.n.bitLength()+7>>3)},t.prototype.generateAsync=function(t,e,i){var r=new X,n=t>>1;this.e=parseInt(e,16);var s=new O(e,16),o=this,h=function(){var e=function(){if(o.p.compareTo(o.q)<=0){var t=o.p;o.p=o.q,o.q=t}var e=o.p.subtract(O.ONE),r=o.q.subtract(O.ONE),n=e.multiply(r);0==n.gcd(s).compareTo(O.ONE)?(o.n=o.p.multiply(o.q),o.d=s.modInverse(n),o.dmp1=o.d.mod(e),o.dmq1=o.d.mod(r),o.coeff=o.q.modInverse(o.p),setTimeout(function(){i()},0)):setTimeout(h,0)},a=function(){o.q=M(),o.q.fromNumberAsync(n,1,r,function(){o.q.subtract(O.ONE).gcda(s,function(t){0==t.compareTo(O.ONE)&&o.q.isProbablePrime(10)?setTimeout(e,0):setTimeout(a,0)})})},u=function(){o.p=M(),o.p.fromNumberAsync(t-n,1,r,function(){o.p.subtract(O.ONE).gcda(s,function(t){0==t.compareTo(O.ONE)&&o.p.isProbablePrime(10)?setTimeout(a,0):setTimeout(u,0)})})};setTimeout(u,0)};setTimeout(h,0)},t}();var W={};W.lang={extend:function(t,e,i){if(!e||!t)throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var r=function(){};if(r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t,t.superclass=e.prototype,e.prototype.constructor==Object.prototype.constructor&&(e.prototype.constructor=e),i){var n;for(n in i)t.prototype[n]=i[n];var s=function(){},o=["toString","valueOf"];try{/MSIE/.test(navigator.userAgent)&&(s=function(t,e){for(n=0;n<o.length;n+=1){var i=o[n],r=e[i];"function"==typeof r&&r!=Object.prototype[i]&&(t[i]=r)}})}catch(t){}s(t.prototype,i)}}};var tt={};void 0!==tt.asn1&&tt.asn1||(tt.asn1={}),tt.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var i=e.substr(1).length;i%2==1?i+=1:e.match(/^[0-7]/)||(i+=2);for(var r="",n=0;n<i;n++)r+="f";e=new O(r,16).xor(t).add(O.ONE).toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){return hextopem(t,e)},this.newObject=function(t){var e=tt.asn1,i=e.DERBoolean,r=e.DERInteger,n=e.DERBitString,s=e.DEROctetString,o=e.DERNull,h=e.DERObjectIdentifier,a=e.DEREnumerated,u=e.DERUTF8String,c=e.DERNumericString,f=e.DERPrintableString,l=e.DERTeletexString,p=e.DERIA5String,g=e.DERUTCTime,d=e.DERGeneralizedTime,v=e.DERSequence,m=e.DERSet,y=e.DERTaggedObject,b=e.ASN1Util.newObject,T=Object.keys(t);if(1!=T.length)throw"key of param shall be only one.";var S=T[0];if(-1==":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+S+":"))throw"undefined key: "+S;if("bool"==S)return new i(t[S]);if("int"==S)return new r(t[S]);if("bitstr"==S)return new n(t[S]);if("octstr"==S)return new s(t[S]);if("null"==S)return new o(t[S]);if("oid"==S)return new h(t[S]);if("enum"==S)return new a(t[S]);if("utf8str"==S)return new u(t[S]);if("numstr"==S)return new c(t[S]);if("prnstr"==S)return new f(t[S]);if("telstr"==S)return new l(t[S]);if("ia5str"==S)return new p(t[S]);if("utctime"==S)return new g(t[S]);if("gentime"==S)return new d(t[S]);if("seq"==S){for(var E=t[S],w=[],D=0;D<E.length;D++){var x=b(E[D]);w.push(x)}return new v({array:w})}if("set"==S){for(E=t[S],w=[],D=0;D<E.length;D++){x=b(E[D]);w.push(x)}return new m({array:w})}if("tag"==S){var R=t[S];if("[object Array]"===Object.prototype.toString.call(R)&&3==R.length){var B=b(R[2]);return new y({tag:R[0],explicit:R[1],obj:B})}var A={};if(void 0!==R.explicit&&(A.explicit=R.explicit),void 0!==R.tag&&(A.tag=R.tag),void 0===R.obj)throw"obj shall be specified for 'tag'.";return A.obj=b(R.obj),new y(A)}},this.jsonToASN1HEX=function(t){return this.newObject(t).getEncodedHex()}},tt.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",i=parseInt(t.substr(0,2),16),r=(e=Math.floor(i/40)+"."+i%40,""),n=2;n<t.length;n+=2){var s=("00000000"+parseInt(t.substr(n,2),16).toString(2)).slice(-8);if(r+=s.substr(1,7),"0"==s.substr(0,1))e=e+"."+new O(r,2).toString(10),r=""}return e},tt.asn1.ASN1Util.oidIntToHex=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},i=function(t){var i="",r=new O(t,10).toString(2),n=7-r.length%7;7==n&&(n=0);for(var s="",o=0;o<n;o++)s+="0";r=s+r;for(o=0;o<r.length-1;o+=7){var h=r.substr(o,7);o!=r.length-7&&(h="1"+h),i+=e(parseInt(h,2))}return i};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",n=t.split("."),s=40*parseInt(n[0])+parseInt(n[1]);r+=e(s),n.splice(0,2);for(var o=0;o<n.length;o++)r+=i(n[o]);return r},tt.asn1.ASN1Object=function(){this.getLengthHexFromValue=function(){if(void 0===this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+"".length+",v="+this.hV;var t=this.hV.length/2,e=t.toString(16);if(e.length%2==1&&(e="0"+e),t<128)return e;var i=e.length/2;if(i>15)throw"ASN.1 length too long to represent by 8x: n = "+t.toString(16);return(128+i).toString(16)+e},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},tt.asn1.DERAbstractString=function(t){tt.asn1.DERAbstractString.superclass.constructor.call(this),this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=stohex(this.s)},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?this.setString(t):void 0!==t.str?this.setString(t.str):void 0!==t.hex&&this.setStringHex(t.hex))},W.lang.extend(tt.asn1.DERAbstractString,tt.asn1.ASN1Object),tt.asn1.DERAbstractTime=function(t){tt.asn1.DERAbstractTime.superclass.constructor.call(this),this.localDateToUTC=function(t){return utc=t.getTime()+6e4*t.getTimezoneOffset(),new Date(utc)},this.formatDate=function(t,e,i){var r=this.zeroPadding,n=this.localDateToUTC(t),s=String(n.getFullYear());"utc"==e&&(s=s.substr(2,2));var o=s+r(String(n.getMonth()+1),2)+r(String(n.getDate()),2)+r(String(n.getHours()),2)+r(String(n.getMinutes()),2)+r(String(n.getSeconds()),2);if(!0===i){var h=n.getMilliseconds();if(0!=h){var a=r(String(h),3);o=o+"."+(a=a.replace(/[0]+$/,""))}}return o+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=stohex(t)},this.setByDateValue=function(t,e,i,r,n,s){var o=new Date(Date.UTC(t,e-1,i,r,n,s,0));this.setByDate(o)},this.getFreshValueHex=function(){return this.hV}},W.lang.extend(tt.asn1.DERAbstractTime,tt.asn1.ASN1Object),tt.asn1.DERAbstractStructured=function(t){tt.asn1.DERAbstractString.superclass.constructor.call(this),this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,void 0!==t&&void 0!==t.array&&(this.asn1Array=t.array)},W.lang.extend(tt.asn1.DERAbstractStructured,tt.asn1.ASN1Object),tt.asn1.DERBoolean=function(){tt.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},W.lang.extend(tt.asn1.DERBoolean,tt.asn1.ASN1Object),tt.asn1.DERInteger=function(t){tt.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=tt.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new O(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.bigint?this.setByBigInteger(t.bigint):void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},W.lang.extend(tt.asn1.DERInteger,tt.asn1.ASN1Object),tt.asn1.DERBitString=function(t){if(void 0!==t&&void 0!==t.obj){var e=tt.asn1.ASN1Util.newObject(t.obj);t.hex="00"+e.getEncodedHex()}tt.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(t<0||7<t)throw"unused bits shall be from 0 to 7: u = "+t;var i="0"+t;this.hTLV=null,this.isModified=!0,this.hV=i+e},this.setByBinaryString=function(t){var e=8-(t=t.replace(/0+$/,"")).length%8;8==e&&(e=0);for(var i=0;i<=e;i++)t+="0";var r="";for(i=0;i<t.length-1;i+=8){var n=t.substr(i,8),s=parseInt(n,2).toString(16);1==s.length&&(s="0"+s),r+=s}this.hTLV=null,this.isModified=!0,this.hV="0"+e+r},this.setByBooleanArray=function(t){for(var e="",i=0;i<t.length;i++)1==t[i]?e+="1":e+="0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),i=0;i<t;i++)e[i]=!1;return e},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):void 0!==t.hex?this.setHexValueIncludingUnusedBits(t.hex):void 0!==t.bin?this.setByBinaryString(t.bin):void 0!==t.array&&this.setByBooleanArray(t.array))},W.lang.extend(tt.asn1.DERBitString,tt.asn1.ASN1Object),tt.asn1.DEROctetString=function(t){if(void 0!==t&&void 0!==t.obj){var e=tt.asn1.ASN1Util.newObject(t.obj);t.hex=e.getEncodedHex()}tt.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},W.lang.extend(tt.asn1.DEROctetString,tt.asn1.DERAbstractString),tt.asn1.DERNull=function(){tt.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},W.lang.extend(tt.asn1.DERNull,tt.asn1.ASN1Object),tt.asn1.DERObjectIdentifier=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},i=function(t){var i="",r=new O(t,10).toString(2),n=7-r.length%7;7==n&&(n=0);for(var s="",o=0;o<n;o++)s+="0";r=s+r;for(o=0;o<r.length-1;o+=7){var h=r.substr(o,7);o!=r.length-7&&(h="1"+h),i+=e(parseInt(h,2))}return i};tt.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",n=t.split("."),s=40*parseInt(n[0])+parseInt(n[1]);r+=e(s),n.splice(0,2);for(var o=0;o<n.length;o++)r+=i(n[o]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=r},this.setValueName=function(t){var e=tt.asn1.x509.OID.name2oid(t);if(""===e)throw"DERObjectIdentifier oidName undefined: "+t;this.setValueOidString(e)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):this.setValueName(t):void 0!==t.oid?this.setValueOidString(t.oid):void 0!==t.hex?this.setValueHex(t.hex):void 0!==t.name&&this.setValueName(t.name))},W.lang.extend(tt.asn1.DERObjectIdentifier,tt.asn1.ASN1Object),tt.asn1.DEREnumerated=function(t){tt.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=tt.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new O(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},W.lang.extend(tt.asn1.DEREnumerated,tt.asn1.ASN1Object),tt.asn1.DERUTF8String=function(t){tt.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},W.lang.extend(tt.asn1.DERUTF8String,tt.asn1.DERAbstractString),tt.asn1.DERNumericString=function(t){tt.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},W.lang.extend(tt.asn1.DERNumericString,tt.asn1.DERAbstractString),tt.asn1.DERPrintableString=function(t){tt.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},W.lang.extend(tt.asn1.DERPrintableString,tt.asn1.DERAbstractString),tt.asn1.DERTeletexString=function(t){tt.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},W.lang.extend(tt.asn1.DERTeletexString,tt.asn1.DERAbstractString),tt.asn1.DERIA5String=function(t){tt.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},W.lang.extend(tt.asn1.DERIA5String,tt.asn1.DERAbstractString),tt.asn1.DERUTCTime=function(t){tt.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},W.lang.extend(tt.asn1.DERUTCTime,tt.asn1.DERAbstractTime),tt.asn1.DERGeneralizedTime=function(t){tt.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),!0===t.millis&&(this.withMillis=!0))},W.lang.extend(tt.asn1.DERGeneralizedTime,tt.asn1.DERAbstractTime),tt.asn1.DERSequence=function(t){tt.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++){t+=this.asn1Array[e].getEncodedHex()}return this.hV=t,this.hV}},W.lang.extend(tt.asn1.DERSequence,tt.asn1.DERAbstractStructured),tt.asn1.DERSet=function(t){tt.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var i=this.asn1Array[e];t.push(i.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},void 0!==t&&void 0!==t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},W.lang.extend(tt.asn1.DERSet,tt.asn1.DERAbstractStructured),tt.asn1.DERTaggedObject=function(t){tt.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,i){this.hT=e,this.isExplicit=t,this.asn1Object=i,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=i.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.tag&&(this.hT=t.tag),void 0!==t.explicit&&(this.isExplicit=t.explicit),void 0!==t.obj&&(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},W.lang.extend(tt.asn1.DERTaggedObject,tt.asn1.ASN1Object);var et=function(t){function e(i){var r=t.call(this)||this;return i&&("string"==typeof i?r.parseKey(i):(e.hasPrivateKeyProperty(i)||e.hasPublicKeyProperty(i))&&r.parsePropertiesFrom(i)),r}return function(t,e){function i(){this.constructor=t}p(t,e),t.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i)}(e,t),e.prototype.parseKey=function(t){try{var e=0,i=0,r=/^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/.test(t)?d(t):v.unarmor(t),n=x.decode(r);if(3===n.sub.length&&(n=n.sub[2].sub[0]),9===n.sub.length){e=n.sub[1].getHexStringValue(),this.n=q(e,16),i=n.sub[2].getHexStringValue(),this.e=parseInt(i,16);var s=n.sub[3].getHexStringValue();this.d=q(s,16);var o=n.sub[4].getHexStringValue();this.p=q(o,16);var h=n.sub[5].getHexStringValue();this.q=q(h,16);var a=n.sub[6].getHexStringValue();this.dmp1=q(a,16);var u=n.sub[7].getHexStringValue();this.dmq1=q(u,16);var c=n.sub[8].getHexStringValue();this.coeff=q(c,16)}else{if(2!==n.sub.length)return!1;var f=n.sub[1].sub[0];e=f.sub[0].getHexStringValue(),this.n=q(e,16),i=f.sub[1].getHexStringValue(),this.e=parseInt(i,16)}return!0}catch(t){return!1}},e.prototype.getPrivateBaseKey=function(){var t={array:[new tt.asn1.DERInteger({int:0}),new tt.asn1.DERInteger({bigint:this.n}),new tt.asn1.DERInteger({int:this.e}),new tt.asn1.DERInteger({bigint:this.d}),new tt.asn1.DERInteger({bigint:this.p}),new tt.asn1.DERInteger({bigint:this.q}),new tt.asn1.DERInteger({bigint:this.dmp1}),new tt.asn1.DERInteger({bigint:this.dmq1}),new tt.asn1.DERInteger({bigint:this.coeff})]};return new tt.asn1.DERSequence(t).getEncodedHex()},e.prototype.getPrivateBaseKeyB64=function(){return f(this.getPrivateBaseKey())},e.prototype.getPublicBaseKey=function(){var t=new tt.asn1.DERSequence({array:[new tt.asn1.DERObjectIdentifier({oid:"1.2.840.113549.1.1.1"}),new tt.asn1.DERNull]}),e=new tt.asn1.DERSequence({array:[new tt.asn1.DERInteger({bigint:this.n}),new tt.asn1.DERInteger({int:this.e})]}),i=new tt.asn1.DERBitString({hex:"00"+e.getEncodedHex()});return new tt.asn1.DERSequence({array:[t,i]}).getEncodedHex()},e.prototype.getPublicBaseKeyB64=function(){return f(this.getPublicBaseKey())},e.wordwrap=function(t,e){if(!t)return t;var i="(.{1,"+(e=e||64)+"})( +|$\n?)|(.{1,"+e+"})";return t.match(RegExp(i,"g")).join("\n")},e.prototype.getPrivateKey=function(){var t="-----BEGIN RSA PRIVATE KEY-----\n";return t+=e.wordwrap(this.getPrivateBaseKeyB64())+"\n",t+="-----END RSA PRIVATE KEY-----"},e.prototype.getPublicKey=function(){var t="-----BEGIN PUBLIC KEY-----\n";return t+=e.wordwrap(this.getPublicBaseKeyB64())+"\n",t+="-----END PUBLIC KEY-----"},e.hasPublicKeyProperty=function(t){return(t=t||{}).hasOwnProperty("n")&&t.hasOwnProperty("e")},e.hasPrivateKeyProperty=function(t){return(t=t||{}).hasOwnProperty("n")&&t.hasOwnProperty("e")&&t.hasOwnProperty("d")&&t.hasOwnProperty("p")&&t.hasOwnProperty("q")&&t.hasOwnProperty("dmp1")&&t.hasOwnProperty("dmq1")&&t.hasOwnProperty("coeff")},e.prototype.parsePropertiesFrom=function(t){this.n=t.n,this.e=t.e,t.hasOwnProperty("d")&&(this.d=t.d,this.p=t.p,this.q=t.q,this.dmp1=t.dmp1,this.dmq1=t.dmq1,this.coeff=t.coeff)},e}(Q),it=function(){function t(t){t=t||{},this.default_key_size=parseInt(t.default_key_size,10)||1024,this.default_public_exponent=t.default_public_exponent||"010001",this.log=t.log||!1,this.key=null}return t.prototype.setKey=function(t){this.log&&this.key&&console.warn("A key was already set, overriding existing."),this.key=new et(t)},t.prototype.setPrivateKey=function(t){this.setKey(t)},t.prototype.setPublicKey=function(t){this.setKey(t)},t.prototype.decrypt=function(t){try{return this.getKey().decrypt(function(t){var e,r="",n=0,s=0;for(e=0;e<t.length&&t.charAt(e)!=c;++e){var o=u.indexOf(t.charAt(e));o<0||(0==n?(r+=i(o>>2),s=3&o,n=1):1==n?(r+=i(s<<2|o>>4),s=15&o,n=2):2==n?(r+=i(s),r+=i(o>>2),s=3&o,n=3):(r+=i(s<<2|o>>4),r+=i(15&o),n=0))}return 1==n&&(r+=i(s<<2)),r}(t))}catch(t){return!1}},t.prototype.encrypt=function(t){try{return f(this.getKey().encrypt(t))}catch(t){return!1}},t.prototype.getKey=function(t){if(!this.key){if(this.key=new et,t&&"[object Function]"==={}.toString.call(t))return void this.key.generateAsync(this.default_key_size,this.default_public_exponent,t);this.key.generate(this.default_key_size,this.default_public_exponent)}return this.key},t.prototype.getPrivateKey=function(){return this.getKey().getPrivateKey()},t.prototype.getPrivateKeyB64=function(){return this.getKey().getPrivateBaseKeyB64()},t.prototype.getPublicKey=function(){return this.getKey().getPublicKey()},t.prototype.getPublicKeyB64=function(){return this.getKey().getPublicBaseKeyB64()},t.version="3.0.0-beta.1",t}();window.JSEncrypt=it,t.JSEncrypt=it,t.default=it,Object.defineProperty(t,"__esModule",{value:!0})});
(function(c,d){c.widget("ui.rotatable",c.ui.mouse,{options:{handle:!1,angle:!1,snap:!1,step:22.5,rotationCenterX:!1,rotationCenterY:!1,start:null,rotate:null,stop:null},rotationCenterX:function(a){if(a===d)return this.options.rotationCenterX;this.options.rotationCenterX=a},rotationCenterY:function(a){if(a===d)return this.options.rotationCenterY;this.options.rotationCenterY=a},handle:function(a){if(a===d)return this.options.handle;this.options.handle=a},angle:function(a){if(a===d)return this.options.angle;
this.elementCurrentAngle=this.options.angle=a;this.performRotation(this.options.angle)},_create:function(){var a;this.options.handle?a=this.options.handle:(a=c(document.createElement("div")),a.addClass("ui-rotatable-handle"));this.listeners={rotateElement:c.proxy(this.rotateElement,this),startRotate:c.proxy(this.startRotate,this),stopRotate:c.proxy(this.stopRotate,this),wheelRotate:c.proxy(this.wheelRotate,this)};this.element.bind("wheel",this.listeners.wheelRotate);a.draggable({helper:"clone",start:this.dragStart,
handle:a});a.bind("mousedown",this.listeners.startRotate);a.appendTo(this.element);0!=this.options.angle?(this.elementCurrentAngle=this.options.angle,this.performRotation(this.elementCurrentAngle)):this.elementCurrentAngle=0},_destroy:function(){this.element.removeClass("ui-rotatable");this.element.find(".ui-rotatable-handle").remove();this.element.unbind("wheel",this.listeners.wheelRotate)},performRotation:function(a){this.element.css("transform-origin",this.options.rotationCenterX+"% "+this.options.rotationCenterY+
"%");this.element.css("-ms-transform-origin",this.options.rotationCenterX+"% "+this.options.rotationCenterY+"%");this.element.css("-webkit-transform-origin",this.options.rotationCenterX+"% "+this.options.rotationCenterY+"%");this.element.css("transform","rotate("+a+"rad)");this.element.css("-moz-transform","rotate("+a+"rad)");this.element.css("-webkit-transform","rotate("+a+"rad)");this.element.css("-o-transform","rotate("+a+"rad)")},getElementOffset:function(){this.performRotation(0);var a=this.element.offset();
this.performRotation(this.elementCurrentAngle);return a},getElementCenter:function(){var a=this.getElementOffset();if(!1===this.options.rotationCenterX)var b=a.left+this.element.width()/2,a=a.top+this.element.height()/2;else b=a.left+this.element.width()/100*this.options.rotationCenterX,a=a.top+this.element.height()/100*this.options.rotationCenterY;return[b,a]},dragStart:function(a){if(this.element)return!1},startRotate:function(a){var b=this.getElementCenter();this.mouseStartAngle=Math.atan2(a.pageY-
b[1],a.pageX-b[0]);this.elementStartAngle=this.elementCurrentAngle;this.hasRotated=!1;this._propagate("start",a);c(document).bind("mousemove",this.listeners.rotateElement);c(document).bind("mouseup",this.listeners.stopRotate);return!1},rotateElement:function(a){if(!this.element||this.element.disabled)return!1;var b=this.getRotateAngle(a);this.performRotation(b);var c=this.elementCurrentAngle;this.elementCurrentAngle=b;this._propagate("rotate",a);c!=b&&(this._trigger("rotate",a,this.ui()),this.hasRotated=
!0);return!1},stopRotate:function(a){if(this.element&&!this.element.disabled)return c(document).unbind("mousemove",this.listeners.rotateElement),c(document).unbind("mouseup",this.listeners.stopRotate),this.elementStopAngle=this.elementCurrentAngle,this.hasRotated&&this._propagate("stop",a),setTimeout(function(){this.element=!1},10),!1},getRotateAngle:function(a){var b=this.getElementCenter();a=Math.atan2(a.pageY-b[1],a.pageX-b[0])-this.mouseStartAngle+this.elementStartAngle;this.options.snap&&(a=
a/Math.PI*180,a=Math.round(a/this.options.step)*this.options.step,a=a*Math.PI/180);return a},wheelRotate:function(a){var b=Math.round(a.originalEvent.deltaY/10)*Math.PI/180,b=this.elementCurrentAngle+b;this.angle(b);this._trigger("rotate",a,this.ui())},_propagate:function(a,b){c.ui.plugin.call(this,a,[b,this.ui()]);"rotate"!==a&&this._trigger(a,b,this.ui())},plugins:{},ui:function(){return{api:this,element:this.element,angle:{start:this.elementStartAngle,current:this.elementCurrentAngle,stop:this.elementStopAngle}}}})})(jQuery);
/*
 * jQuery FlexSlider v2.7.2
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
*/!function($){var e=!0;$.flexslider=function(t,a){var n=$(t);void 0===a.rtl&&"rtl"==$("html").attr("dir")&&(a.rtl=!0),n.vars=$.extend({},$.flexslider.defaults,a);var i=n.vars.namespace,r=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,s=("ontouchstart"in window||r||window.DocumentTouch&&document instanceof DocumentTouch)&&n.vars.touch,o="click touchend MSPointerUp keyup",l="",c,d="vertical"===n.vars.direction,u=n.vars.reverse,v=n.vars.itemWidth>0,p="fade"===n.vars.animation,m=""!==n.vars.asNavFor,f={};$.data(t,"flexslider",n),f={init:function(){n.animating=!1,n.currentSlide=parseInt(n.vars.startAt?n.vars.startAt:0,10),isNaN(n.currentSlide)&&(n.currentSlide=0),n.animatingTo=n.currentSlide,n.atEnd=0===n.currentSlide||n.currentSlide===n.last,n.containerSelector=n.vars.selector.substr(0,n.vars.selector.search(" ")),n.slides=$(n.vars.selector,n),n.container=$(n.containerSelector,n),n.count=n.slides.length,n.syncExists=$(n.vars.sync).length>0,"slide"===n.vars.animation&&(n.vars.animation="swing"),n.prop=d?"top":n.vars.rtl?"marginRight":"marginLeft",n.args={},n.manualPause=!1,n.stopped=!1,n.started=!1,n.startTimeout=null,n.transitions=!n.vars.video&&!p&&n.vars.useCSS&&function(){var e=document.createElement("div"),t=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var a in t)if(void 0!==e.style[t[a]])return n.pfx=t[a].replace("Perspective","").toLowerCase(),n.prop="-"+n.pfx+"-transform",!0;return!1}(),n.isFirefox=navigator.userAgent.toLowerCase().indexOf("firefox")>-1,n.ensureAnimationEnd="",""!==n.vars.controlsContainer&&(n.controlsContainer=$(n.vars.controlsContainer).length>0&&$(n.vars.controlsContainer)),""!==n.vars.manualControls&&(n.manualControls=$(n.vars.manualControls).length>0&&$(n.vars.manualControls)),""!==n.vars.customDirectionNav&&(n.customDirectionNav=2===$(n.vars.customDirectionNav).length&&$(n.vars.customDirectionNav)),n.vars.randomize&&(n.slides.sort(function(){return Math.round(Math.random())-.5}),n.container.empty().append(n.slides)),n.doMath(),n.setup("init"),n.vars.controlNav&&f.controlNav.setup(),n.vars.directionNav&&f.directionNav.setup(),n.vars.keyboard&&(1===$(n.containerSelector).length||n.vars.multipleKeyboard)&&$(document).bind("keyup",function(e){var t=e.keyCode;if(!n.animating&&(39===t||37===t)){var a=n.vars.rtl?37===t?n.getTarget("next"):39===t&&n.getTarget("prev"):39===t?n.getTarget("next"):37===t&&n.getTarget("prev");n.flexAnimate(a,n.vars.pauseOnAction)}}),n.vars.mousewheel&&n.bind("mousewheel",function(e,t,a,i){e.preventDefault();var r=t<0?n.getTarget("next"):n.getTarget("prev");n.flexAnimate(r,n.vars.pauseOnAction)}),n.vars.pausePlay&&f.pausePlay.setup(),n.vars.slideshow&&n.vars.pauseInvisible&&f.pauseInvisible.init(),n.vars.slideshow&&(n.vars.pauseOnHover&&n.hover(function(){n.manualPlay||n.manualPause||n.pause()},function(){n.manualPause||n.manualPlay||n.stopped||n.play()}),n.vars.pauseInvisible&&f.pauseInvisible.isHidden()||(n.vars.initDelay>0?n.startTimeout=setTimeout(n.play,n.vars.initDelay):n.play())),m&&f.asNav.setup(),s&&n.vars.touch&&f.touch(),(!p||p&&n.vars.smoothHeight)&&$(window).bind("resize orientationchange focus",f.resize),n.find("img").attr("draggable","false"),setTimeout(function(){n.vars.start(n)},200)},asNav:{setup:function(){n.asNav=!0,n.animatingTo=Math.floor(n.currentSlide/n.move),n.currentItem=n.currentSlide,n.slides.removeClass(i+"active-slide").eq(n.currentItem).addClass(i+"active-slide"),r?(t._slider=n,n.slides.each(function(){var e=this;e._gesture=new MSGesture,e._gesture.target=e,e.addEventListener("MSPointerDown",function(e){e.preventDefault(),e.currentTarget._gesture&&e.currentTarget._gesture.addPointer(e.pointerId)},!1),e.addEventListener("MSGestureTap",function(e){e.preventDefault();var t=$(this),a=t.index();$(n.vars.asNavFor).data("flexslider").animating||t.hasClass("active")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})})):n.slides.on(o,function(e){e.preventDefault();var t=$(this),a=t.index(),r;r=n.vars.rtl?-1*(t.offset().right-$(n).scrollLeft()):t.offset().left-$(n).scrollLeft(),r<=0&&t.hasClass(i+"active-slide")?n.flexAnimate(n.getTarget("prev"),!0):$(n.vars.asNavFor).data("flexslider").animating||t.hasClass(i+"active-slide")||(n.direction=n.currentItem<a?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){n.manualControls?f.controlNav.setupManual():f.controlNav.setupPaging()},setupPaging:function(){var e="thumbnails"===n.vars.controlNav?"control-thumbs":"control-paging",t=1,a,r;if(n.controlNavScaffold=$('<ol class="'+i+"control-nav "+i+e+'"></ol>'),n.pagingCount>1)for(var s=0;s<n.pagingCount;s++){if(r=n.slides.eq(s),void 0===r.attr("data-thumb-alt")&&r.attr("data-thumb-alt",""),a=$("<a></a>").attr("href","#").text(t),"thumbnails"===n.vars.controlNav&&(a=$("<img alt=''/>").attr("src",r.attr("data-thumb"))),""!==r.attr("data-thumb-alt")&&a.attr("alt",r.attr("data-thumb-alt")),"thumbnails"===n.vars.controlNav&&!0===n.vars.thumbCaptions){var c=r.attr("data-thumbcaption");if(""!==c&&void 0!==c){var d=$("<span></span>").addClass(i+"caption").text(c);a.append(d)}}var u=$("<li>");a.appendTo(u),u.append("</li>"),n.controlNavScaffold.append(u),t++}n.controlsContainer?$(n.controlsContainer).append(n.controlNavScaffold):n.append(n.controlNavScaffold),f.controlNav.set(),f.controlNav.active(),n.controlNavScaffold.delegate("a, img",o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(n.direction=a>n.currentSlide?"next":"prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},setupManual:function(){n.controlNav=n.manualControls,f.controlNav.active(),n.controlNav.bind(o,function(e){if(e.preventDefault(),""===l||l===e.type){var t=$(this),a=n.controlNav.index(t);t.hasClass(i+"active")||(a>n.currentSlide?n.direction="next":n.direction="prev",n.flexAnimate(a,n.vars.pauseOnAction))}""===l&&(l=e.type),f.setToClearWatchedEvent()})},set:function(){var e="thumbnails"===n.vars.controlNav?"img":"a";n.controlNav=$("."+i+"control-nav li "+e,n.controlsContainer?n.controlsContainer:n)},active:function(){n.controlNav.removeClass(i+"active").eq(n.animatingTo).addClass(i+"active")},update:function(e,t){n.pagingCount>1&&"add"===e?n.controlNavScaffold.append($('<li><a href="#">'+n.count+"</a></li>")):1===n.pagingCount?n.controlNavScaffold.find("li").remove():n.controlNav.eq(t).closest("li").remove(),f.controlNav.set(),n.pagingCount>1&&n.pagingCount!==n.controlNav.length?n.update(t,e):f.controlNav.active()}},directionNav:{setup:function(){var e=$('<ul class="'+i+'direction-nav"><li class="'+i+'nav-prev"><a class="'+i+'prev" href="#">'+n.vars.prevText+'</a></li><li class="'+i+'nav-next"><a class="'+i+'next" href="#">'+n.vars.nextText+"</a></li></ul>");n.customDirectionNav?n.directionNav=n.customDirectionNav:n.controlsContainer?($(n.controlsContainer).append(e),n.directionNav=$("."+i+"direction-nav li a",n.controlsContainer)):(n.append(e),n.directionNav=$("."+i+"direction-nav li a",n)),f.directionNav.update(),n.directionNav.bind(o,function(e){e.preventDefault();var t;""!==l&&l!==e.type||(t=$(this).hasClass(i+"next")?n.getTarget("next"):n.getTarget("prev"),n.flexAnimate(t,n.vars.pauseOnAction)),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(){var e=i+"disabled";1===n.pagingCount?n.directionNav.addClass(e).attr("tabindex","-1"):n.vars.animationLoop?n.directionNav.removeClass(e).removeAttr("tabindex"):0===n.animatingTo?n.directionNav.removeClass(e).filter("."+i+"prev").addClass(e).attr("tabindex","-1"):n.animatingTo===n.last?n.directionNav.removeClass(e).filter("."+i+"next").addClass(e).attr("tabindex","-1"):n.directionNav.removeClass(e).removeAttr("tabindex")}},pausePlay:{setup:function(){var e=$('<div class="'+i+'pauseplay"><a href="#"></a></div>');n.controlsContainer?(n.controlsContainer.append(e),n.pausePlay=$("."+i+"pauseplay a",n.controlsContainer)):(n.append(e),n.pausePlay=$("."+i+"pauseplay a",n)),f.pausePlay.update(n.vars.slideshow?i+"pause":i+"play"),n.pausePlay.bind(o,function(e){e.preventDefault(),""!==l&&l!==e.type||($(this).hasClass(i+"pause")?(n.manualPause=!0,n.manualPlay=!1,n.pause()):(n.manualPause=!1,n.manualPlay=!0,n.play())),""===l&&(l=e.type),f.setToClearWatchedEvent()})},update:function(e){"play"===e?n.pausePlay.removeClass(i+"pause").addClass(i+"play").html(n.vars.playText):n.pausePlay.removeClass(i+"play").addClass(i+"pause").html(n.vars.pauseText)}},touch:function(){function e(e){e.stopPropagation(),n.animating?e.preventDefault():(n.pause(),t._gesture.addPointer(e.pointerId),w=0,c=d?n.h:n.w,f=Number(new Date),l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c)}function a(e){e.stopPropagation();var a=e.target._slider;if(a){var n=-e.translationX,i=-e.translationY;if(w+=d?i:n,m=(a.vars.rtl?-1:1)*w,x=d?Math.abs(w)<Math.abs(-n):Math.abs(w)<Math.abs(-i),e.detail===e.MSGESTURE_FLAG_INERTIA)return void setImmediate(function(){t._gesture.stop()});(!x||Number(new Date)-f>500)&&(e.preventDefault(),!p&&a.transitions&&(a.vars.animationLoop||(m=w/(0===a.currentSlide&&w<0||a.currentSlide===a.last&&w>0?Math.abs(w)/c+2:1)),a.setProps(l+m,"setTouch")))}}function i(e){e.stopPropagation();var t=e.target._slider;if(t){if(t.animatingTo===t.currentSlide&&!x&&null!==m){var a=u?-m:m,n=a>0?t.getTarget("next"):t.getTarget("prev");t.canAdvance(n)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?t.flexAnimate(n,t.vars.pauseOnAction):p||t.flexAnimate(t.currentSlide,t.vars.pauseOnAction,!0)}s=null,o=null,m=null,l=null,w=0}}var s,o,l,c,m,f,g,h,S,x=!1,y=0,b=0,w=0;r?(t.style.msTouchAction="none",t._gesture=new MSGesture,t._gesture.target=t,t.addEventListener("MSPointerDown",e,!1),t._slider=n,t.addEventListener("MSGestureChange",a,!1),t.addEventListener("MSGestureEnd",i,!1)):(g=function(e){n.animating?e.preventDefault():(window.navigator.msPointerEnabled||1===e.touches.length)&&(n.pause(),c=d?n.h:n.w,f=Number(new Date),y=e.touches[0].pageX,b=e.touches[0].pageY,l=v&&u&&n.animatingTo===n.last?0:v&&u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:v&&n.currentSlide===n.last?n.limit:v?(n.itemW+n.vars.itemMargin)*n.move*n.currentSlide:u?(n.last-n.currentSlide+n.cloneOffset)*c:(n.currentSlide+n.cloneOffset)*c,s=d?b:y,o=d?y:b,t.addEventListener("touchmove",h,!1),t.addEventListener("touchend",S,!1))},h=function(e){y=e.touches[0].pageX,b=e.touches[0].pageY,m=d?s-b:(n.vars.rtl?-1:1)*(s-y),x=d?Math.abs(m)<Math.abs(y-o):Math.abs(m)<Math.abs(b-o);var t=500;(!x||Number(new Date)-f>500)&&(e.preventDefault(),!p&&n.transitions&&(n.vars.animationLoop||(m/=0===n.currentSlide&&m<0||n.currentSlide===n.last&&m>0?Math.abs(m)/c+2:1),n.setProps(l+m,"setTouch")))},S=function(e){if(t.removeEventListener("touchmove",h,!1),n.animatingTo===n.currentSlide&&!x&&null!==m){var a=u?-m:m,i=a>0?n.getTarget("next"):n.getTarget("prev");n.canAdvance(i)&&(Number(new Date)-f<550&&Math.abs(a)>50||Math.abs(a)>c/2)?n.flexAnimate(i,n.vars.pauseOnAction):p||n.flexAnimate(n.currentSlide,n.vars.pauseOnAction,!0)}t.removeEventListener("touchend",S,!1),s=null,o=null,m=null,l=null},t.addEventListener("touchstart",g,!1))},resize:function(){!n.animating&&n.is(":visible")&&(v||n.doMath(),p?f.smoothHeight():v?(n.slides.width(n.computedW),n.update(n.pagingCount),n.setProps()):d?(n.viewport.height(n.h),n.setProps(n.h,"setTotal")):(n.vars.smoothHeight&&f.smoothHeight(),n.newSlides.width(n.computedW),n.setProps(n.computedW,"setTotal")))},smoothHeight:function(e){if(!d||p){var t=p?n:n.viewport;e?t.animate({height:n.slides.eq(n.animatingTo).innerHeight()},e):t.innerHeight(n.slides.eq(n.animatingTo).innerHeight())}},sync:function(e){var t=$(n.vars.sync).data("flexslider"),a=n.animatingTo;switch(e){case"animate":t.flexAnimate(a,n.vars.pauseOnAction,!1,!0);break;case"play":t.playing||t.asNav||t.play();break;case"pause":t.pause();break}},uniqueID:function(e){return e.filter("[id]").add(e.find("[id]")).each(function(){var e=$(this);e.attr("id",e.attr("id")+"_clone")}),e},pauseInvisible:{visProp:null,init:function(){var e=f.pauseInvisible.getHiddenProp();if(e){var t=e.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(t,function(){f.pauseInvisible.isHidden()?n.startTimeout?clearTimeout(n.startTimeout):n.pause():n.started?n.play():n.vars.initDelay>0?setTimeout(n.play,n.vars.initDelay):n.play()})}},isHidden:function(){var e=f.pauseInvisible.getHiddenProp();return!!e&&document[e]},getHiddenProp:function(){var e=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var t=0;t<e.length;t++)if(e[t]+"Hidden"in document)return e[t]+"Hidden";return null}},setToClearWatchedEvent:function(){clearTimeout(c),c=setTimeout(function(){l=""},3e3)}},n.flexAnimate=function(e,t,a,r,o){if(n.vars.animationLoop||e===n.currentSlide||(n.direction=e>n.currentSlide?"next":"prev"),m&&1===n.pagingCount&&(n.direction=n.currentItem<e?"next":"prev"),!n.animating&&(n.canAdvance(e,o)||a)&&n.is(":visible")){if(m&&r){var l=$(n.vars.asNavFor).data("flexslider");if(n.atEnd=0===e||e===n.count-1,l.flexAnimate(e,!0,!1,!0,o),n.direction=n.currentItem<e?"next":"prev",l.direction=n.direction,Math.ceil((e+1)/n.visible)-1===n.currentSlide||0===e)return n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),!1;n.currentItem=e,n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),e=Math.floor(e/n.visible)}if(n.animating=!0,n.animatingTo=e,t&&n.pause(),n.vars.before(n),n.syncExists&&!o&&f.sync("animate"),n.vars.controlNav&&f.controlNav.active(),v||n.slides.removeClass(i+"active-slide").eq(e).addClass(i+"active-slide"),n.atEnd=0===e||e===n.last,n.vars.directionNav&&f.directionNav.update(),e===n.last&&(n.vars.end(n),n.vars.animationLoop||n.pause()),p)s?(n.slides.eq(n.currentSlide).css({opacity:0,zIndex:1}),n.slides.eq(e).css({opacity:1,zIndex:2}),n.wrapup(c)):(n.slides.eq(n.currentSlide).css({zIndex:1}).animate({opacity:0},n.vars.animationSpeed,n.vars.easing),n.slides.eq(e).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing,n.wrapup));else{var c=d?n.slides.filter(":first").height():n.computedW,g,h,S;v?(g=n.vars.itemMargin,S=(n.itemW+g)*n.move*n.animatingTo,h=S>n.limit&&1!==n.visible?n.limit:S):h=0===n.currentSlide&&e===n.count-1&&n.vars.animationLoop&&"next"!==n.direction?u?(n.count+n.cloneOffset)*c:0:n.currentSlide===n.last&&0===e&&n.vars.animationLoop&&"prev"!==n.direction?u?0:(n.count+1)*c:u?(n.count-1-e+n.cloneOffset)*c:(e+n.cloneOffset)*c,n.setProps(h,"",n.vars.animationSpeed),n.transitions?(n.vars.animationLoop&&n.atEnd||(n.animating=!1,n.currentSlide=n.animatingTo),n.container.unbind("webkitTransitionEnd transitionend"),n.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(n.ensureAnimationEnd),n.wrapup(c)}),clearTimeout(n.ensureAnimationEnd),n.ensureAnimationEnd=setTimeout(function(){n.wrapup(c)},n.vars.animationSpeed+100)):n.container.animate(n.args,n.vars.animationSpeed,n.vars.easing,function(){n.wrapup(c)})}n.vars.smoothHeight&&f.smoothHeight(n.vars.animationSpeed)}},n.wrapup=function(e){p||v||(0===n.currentSlide&&n.animatingTo===n.last&&n.vars.animationLoop?n.setProps(e,"jumpEnd"):n.currentSlide===n.last&&0===n.animatingTo&&n.vars.animationLoop&&n.setProps(e,"jumpStart")),n.animating=!1,n.currentSlide=n.animatingTo,n.vars.after(n)},n.animateSlides=function(){!n.animating&&e&&n.flexAnimate(n.getTarget("next"))},n.pause=function(){clearInterval(n.animatedSlides),n.animatedSlides=null,n.playing=!1,n.vars.pausePlay&&f.pausePlay.update("play"),n.syncExists&&f.sync("pause")},n.play=function(){n.playing&&clearInterval(n.animatedSlides),n.animatedSlides=n.animatedSlides||setInterval(n.animateSlides,n.vars.slideshowSpeed),n.started=n.playing=!0,n.vars.pausePlay&&f.pausePlay.update("pause"),n.syncExists&&f.sync("play")},n.stop=function(){n.pause(),n.stopped=!0},n.canAdvance=function(e,t){var a=m?n.pagingCount-1:n.last;return!!t||(!(!m||n.currentItem!==n.count-1||0!==e||"prev"!==n.direction)||(!m||0!==n.currentItem||e!==n.pagingCount-1||"next"===n.direction)&&(!(e===n.currentSlide&&!m)&&(!!n.vars.animationLoop||(!n.atEnd||0!==n.currentSlide||e!==a||"next"===n.direction)&&(!n.atEnd||n.currentSlide!==a||0!==e||"next"!==n.direction))))},n.getTarget=function(e){return n.direction=e,"next"===e?n.currentSlide===n.last?0:n.currentSlide+1:0===n.currentSlide?n.last:n.currentSlide-1},n.setProps=function(e,t,a){var i=function(){var a=e||(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo;return function(){if(v)return"setTouch"===t?e:u&&n.animatingTo===n.last?0:u?n.limit-(n.itemW+n.vars.itemMargin)*n.move*n.animatingTo:n.animatingTo===n.last?n.limit:a;switch(t){case"setTotal":return u?(n.count-1-n.currentSlide+n.cloneOffset)*e:(n.currentSlide+n.cloneOffset)*e;case"setTouch":return e;case"jumpEnd":return u?e:n.count*e;case"jumpStart":return u?n.count*e:e;default:return e}}()*(n.vars.rtl?1:-1)+"px"}();n.transitions&&(i=n.isFirefox?d?"translate3d(0,"+i+",0)":"translate3d("+parseInt(i)+"px,0,0)":d?"translate3d(0,"+i+",0)":"translate3d("+(n.vars.rtl?-1:1)*parseInt(i)+"px,0,0)",a=void 0!==a?a/1e3+"s":"0s",n.container.css("-"+n.pfx+"-transition-duration",a),n.container.css("transition-duration",a)),n.args[n.prop]=i,(n.transitions||void 0===a)&&n.container.css(n.args),n.container.css("transform",i)},n.setup=function(e){if(p)n.vars.rtl?n.slides.css({width:"100%",float:"right",marginLeft:"-100%",position:"relative"}):n.slides.css({width:"100%",float:"left",marginRight:"-100%",position:"relative"}),"init"===e&&(s?n.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+n.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(n.currentSlide).css({opacity:1,zIndex:2}):0==n.vars.fadeFirstSlide?n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).css({opacity:1}):n.slides.css({opacity:0,display:"block",zIndex:1}).eq(n.currentSlide).css({zIndex:2}).animate({opacity:1},n.vars.animationSpeed,n.vars.easing)),n.vars.smoothHeight&&f.smoothHeight();else{var t,a;"init"===e&&(n.viewport=$('<div class="'+i+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(n).append(n.container),n.cloneCount=0,n.cloneOffset=0,u&&(a=$.makeArray(n.slides).reverse(),n.slides=$(a),n.container.empty().append(n.slides))),n.vars.animationLoop&&!v&&(n.cloneCount=2,n.cloneOffset=1,"init"!==e&&n.container.find(".clone").remove(),n.container.append(f.uniqueID(n.slides.first().clone().addClass("clone")).attr("aria-hidden","true")).prepend(f.uniqueID(n.slides.last().clone().addClass("clone")).attr("aria-hidden","true"))),n.newSlides=$(n.vars.selector,n),t=u?n.count-1-n.currentSlide+n.cloneOffset:n.currentSlide+n.cloneOffset,d&&!v?(n.container.height(200*(n.count+n.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){n.newSlides.css({display:"block"}),n.doMath(),n.viewport.height(n.h),n.setProps(t*n.h,"init")},"init"===e?100:0)):(n.container.width(200*(n.count+n.cloneCount)+"%"),n.setProps(t*n.computedW,"init"),setTimeout(function(){n.doMath(),n.vars.rtl&&n.isFirefox?n.newSlides.css({width:n.computedW,marginRight:n.computedM,float:"right",display:"block"}):n.newSlides.css({width:n.computedW,marginRight:n.computedM,float:"left",display:"block"}),n.vars.smoothHeight&&f.smoothHeight()},"init"===e?100:0))}v||n.slides.removeClass(i+"active-slide").eq(n.currentSlide).addClass(i+"active-slide"),n.vars.init(n)},n.doMath=function(){var e=n.slides.first(),t=n.vars.itemMargin,a=n.vars.minItems,i=n.vars.maxItems;n.w=void 0===n.viewport?n.width():n.viewport.width(),n.isFirefox&&(n.w=n.width()),n.h=e.height(),n.boxPadding=e.outerWidth()-e.width(),v?(n.itemT=n.vars.itemWidth+t,n.itemM=t,n.minW=a?a*n.itemT:n.w,n.maxW=i?i*n.itemT-t:n.w,n.itemW=n.minW>n.w?(n.w-t*(a-1))/a:n.maxW<n.w?(n.w-t*(i-1))/i:n.vars.itemWidth>n.w?n.w:n.vars.itemWidth,n.visible=Math.floor(n.w/n.itemW),n.move=n.vars.move>0&&n.vars.move<n.visible?n.vars.move:n.visible,n.pagingCount=Math.ceil((n.count-n.visible)/n.move+1),n.last=n.pagingCount-1,n.limit=1===n.pagingCount?0:n.vars.itemWidth>n.w?n.itemW*(n.count-1)+t*(n.count-1):(n.itemW+t)*n.count-n.w-t):(n.itemW=n.w,n.itemM=t,n.pagingCount=n.count,n.last=n.count-1),n.computedW=n.itemW-n.boxPadding,n.computedM=n.itemM},n.update=function(e,t){n.doMath(),v||(e<n.currentSlide?n.currentSlide+=1:e<=n.currentSlide&&0!==e&&(n.currentSlide-=1),n.animatingTo=n.currentSlide),n.vars.controlNav&&!n.manualControls&&("add"===t&&!v||n.pagingCount>n.controlNav.length?f.controlNav.update("add"):("remove"===t&&!v||n.pagingCount<n.controlNav.length)&&(v&&n.currentSlide>n.last&&(n.currentSlide-=1,n.animatingTo-=1),f.controlNav.update("remove",n.last))),n.vars.directionNav&&f.directionNav.update()},n.addSlide=function(e,t){var a=$(e);n.count+=1,n.last=n.count-1,d&&u?void 0!==t?n.slides.eq(n.count-t).after(a):n.container.prepend(a):void 0!==t?n.slides.eq(t).before(a):n.container.append(a),n.update(t,"add"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.added(n)},n.removeSlide=function(e){var t=isNaN(e)?n.slides.index($(e)):e;n.count-=1,n.last=n.count-1,isNaN(e)?$(e,n.slides).remove():d&&u?n.slides.eq(n.last).remove():n.slides.eq(e).remove(),n.doMath(),n.update(t,"remove"),n.slides=$(n.vars.selector+":not(.clone)",n),n.setup(),n.vars.removed(n)},f.init()},$(window).blur(function(t){e=!1}).focus(function(t){e=!0}),$.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,fadeFirstSlide:!0,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",customDirectionNav:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,isFirefox:!1,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){},rtl:!1},$.fn.flexslider=function(e){if(void 0===e&&(e={}),"object"==typeof e)return this.each(function(){var t=$(this),a=e.selector?e.selector:".slides > li",n=t.find(a);1===n.length&&!1===e.allowOneSlide||0===n.length?(n.fadeIn(400),e.start&&e.start(t)):void 0===t.data("flexslider")&&new $.flexslider(this,e)});var t=$(this).data("flexslider");switch(e){case"play":t.play();break;case"pause":t.pause();break;case"stop":t.stop();break;case"next":t.flexAnimate(t.getTarget("next"),!0);break;case"prev":case"previous":t.flexAnimate(t.getTarget("prev"),!0);break;default:"number"==typeof e&&t.flexAnimate(e,!0)}}}(jQuery);
/*!
 * fancyBox - jQuery Plugin
 * version: 2.1.5 (Fri, 14 Jun 2013)
 * requires jQuery v1.6 or later
 *
 * Examples at http://fancyapps.com/fancybox/
 * License: www.fancyapps.com/fancybox/#license
 *
 * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
 *
 */

;(function (window, document, $, undefined){
	"use strict";

	var H = $("html"),
		W = $(window),
		D = $(document),
		F = $.fancybox = function (){
			F.open.apply( this, arguments );
		},
		IE =  navigator.userAgent.match(/msie/i),
		didUpdate	= null,
		isTouch		= document.createTouch !== undefined,

		isQuery	= function(obj){
			return obj && obj.hasOwnProperty && obj instanceof $;
		},
		isString = function(str){
			return str && $.type(str) === "string";
		},
		isPercentage = function(str){
			return isString(str) && str.indexOf('%') > 0;
		},
		isScrollable = function(el){
			return (el && !(el.style.overflow && el.style.overflow === 'hidden') && ((el.clientWidth && el.scrollWidth > el.clientWidth) || (el.clientHeight && el.scrollHeight > el.clientHeight)));
		},
		getScalar = function(orig, dim){
			var value = parseInt(orig, 10) || 0;

			if(dim && isPercentage(orig)){
				value = F.getViewport()[ dim ] / 100 * value;
			}

			return Math.ceil(value);
		},
		getValue = function(value, dim){
			return getScalar(value, dim) + 'px';
		};

    var isFBoxOpen = false;
    function isFBoxOpenFx(){
      $('body').on("keydown", function(e){
        if(isFBoxOpen && (e.keyCode == 9 || e.keyCode == 13)){
          e.preventDefault();
        }
      });
    }

	$.extend(F, {
		// The current version of fancyBox
		version: '2.1.5',

		defaults: {
			padding : 15,
			margin  : 20,

			width     : 800,
			height    : 600,
			minWidth  : 100,
			minHeight : 100,
			maxWidth  : 9999,
			maxHeight : 9999,
			pixelRatio: 1, // Set to 2 for retina display support

			autoSize   : true,
			autoHeight : false,
			autoWidth  : false,

			autoResize  : true,
			autoCenter  : !isTouch,
			fitToView   : true,
			aspectRatio : false,
			topRatio    : 0.5,
			leftRatio   : 0.5,

			scrolling : 'auto', // 'auto', 'yes' or 'no'
			wrapCSS   : '',

			arrows     : true,
			closeBtn   : true,
			closeClick : false,
			nextClick  : false,
			mouseWheel : true,
			autoPlay   : false,
			playSpeed  : 3000,
			preload    : 3,
			modal      : false,
			loop       : true,

			ajax  : {
				dataType : 'html',
				headers  : { 'X-fancyBox': true }
			},
			iframe : {
				scrolling : 'auto',
				preload   : true
			},
			swf : {
				wmode: 'transparent',
				allowfullscreen   : 'true',
				allowscriptaccess : 'always'
			},

			keys  : {
				next : {
					13 : 'left', // enter
					34 : 'up',   // page down
					39 : 'left', // right arrow
					40 : 'up'    // down arrow
				},
				prev : {
					8  : 'right',  // backspace
					33 : 'down',   // page up
					37 : 'right',  // left arrow
					38 : 'down'    // up arrow
				},
				close  : [27], // escape key
				play   : [32], // space - start/stop slideshow
				toggle : [70]  // letter "f" - toggle fullscreen
			},

			direction : {
				next : 'left',
				prev : 'right'
			},

			scrollOutside  : true,

			// Override some properties
			index   : 0,
			type    : null,
			href    : null,
			content : null,
			title   : null,

			// HTML templates
			tpl: {
				wrap     : '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
				image    : '<img alt="" class="fancybox-image" src="{href}" />',
				iframe   : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen referrerpolicy="strict-origin-when-cross-origin" ' + (IE ? ' allowtransparency="true"' : '') + '></iframe>',
				error    : '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
				closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
				next     : '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
				prev     : '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
				loading  : '<div id="fancybox-loading"><div></div></div>'
			},

			// Properties for each animation type
			// Opening fancyBox
			openEffect  : 'fade', // 'elastic', 'fade' or 'none'
			openSpeed   : 250,
			openEasing  : 'swing',
			openOpacity : true,
			openMethod  : 'zoomIn',

			// Closing fancyBox
			closeEffect  : 'fade', // 'elastic', 'fade' or 'none'
			closeSpeed   : 250,
			closeEasing  : 'swing',
			closeOpacity : true,
			closeMethod  : 'zoomOut',

			// Changing next gallery item
			nextEffect : 'elastic', // 'elastic', 'fade' or 'none'
			nextSpeed  : 250,
			nextEasing : 'swing',
			nextMethod : 'changeIn',

			// Changing previous gallery item
			prevEffect : 'elastic', // 'elastic', 'fade' or 'none'
			prevSpeed  : 250,
			prevEasing : 'swing',
			prevMethod : 'changeOut',

			// Enable default helpers
			helpers : {
				overlay : true,
				title   : true
			},

			// Callbacks
			onCancel     : $.noop, // If canceling
			beforeLoad   : $.noop, // Before loading
			afterLoad    : $.noop, // After loading
			beforeShow   : $.noop, // Before changing in current item
			afterShow    : $.noop, // After opening
			beforeChange : $.noop, // Before changing gallery item
			beforeClose  : $.noop, // Before closing
			afterClose   : $.noop  // After closing
		},

		//Current state
		group    : {}, // Selected group
		opts     : {}, // Group options
		previous : null,  // Previous element
		coming   : null,  // Element being loaded
		current  : null,  // Currently loaded element
		isActive : false, // Is activated
		isOpen   : false, // Is currently open
		isOpened : false, // Have been fully opened at least once

		wrap  : null,
		skin  : null,
		outer : null,
		inner : null,

		player : {
			timer    : null,
			isActive : false
		},

		// Loaders
		ajaxLoad   : null,
		imgPreload : null,

		// Some collections
		transitions : {},
		helpers     : {},

		/*
		 *	Static methods
		 */

		open: function (group, opts){
      isFBoxOpen = true;
			isFBoxOpenFx();

			if(!group){
				return;
			}

			if(!$.isPlainObject(opts)){
				opts = {};
			}

			// Close if already active
			if(false === F.close(true)){
				return;
			}

			// Normalize group
			if(!$.isArray(group)){
				group = isQuery(group) ? $(group).get() : [group];
			}

			// Recheck if the type of each element is `object` and set content type (image, ajax, etc)
			$.each(group, function(i, element){
				var obj = {},
					href,
					title,
					content,
					type,
					rez,
					hrefParts,
					selector;

				if($.type(element) === "object"){
					// Check if is DOM element
					if(element.nodeType){
						element = $(element);
					}

					if(isQuery(element)){
						obj = {
							href    : element.data('fancybox-href') || element.attr('href'),
							title   : $('<div/>').text( element.data('fancybox-title') || element.attr('title') || element.attr('caption') || '' ).html(),
							isDom   : true,
							element : element
						};

						if($.metadata){
							$.extend(true, obj, element.metadata());
						}

					} else{
						obj = element;
					}
				}

				href  = opts.href  || obj.href || (isString(element) ? element : null);
				title = opts.title !== undefined ? opts.title : obj.title || '';

				content = opts.content || obj.content;
				type    = content ? 'html' : (opts.type  || obj.type);

				if(!type && obj.isDom){
					type = element.data('fancybox-type');

					if(!type){
						rez  = element.prop('class').match(/fancybox\.(\w+)/);
						type = rez ? rez[1] : null;
					}
				}

				if(isString(href)){
					// Try to guess the content type
					if(!type){
						if(F.isImage(href)){
							type = 'image';

						} else if(F.isSWF(href)){
							type = 'swf';

						} else if(href.charAt(0) === '#'){
							type = 'inline';

						} else if(isString(element)){
							type    = 'html';
							content = element;
						}
					}

					// Split url into two pieces with source url and content selector, e.g,
					// "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
					if(type === 'ajax'){
						hrefParts = href.split(/\s+/, 2);
						href      = hrefParts.shift();
						selector  = hrefParts.shift();
					}
				}

				if(!content){
					if(type === 'inline'){
						if(href){
							content = $( isString(href) ? href.replace(/.*(?=#[^\s]+$)/, '') : href ); //strip for ie7

						} else if(obj.isDom){
							content = element;
						}

					} else if(type === 'html'){
						content = href;

					} else if(!type && !href && obj.isDom){
						type    = 'inline';
						content = element;
					}
				}

				$.extend(obj, {
					href     : href,
					type     : type,
					content  : content,
					title    : title,
					selector : selector
				});

				group[ i ] = obj;
			});

			// Extend the defaults
			F.opts = $.extend(true, {}, F.defaults, opts);

			// All options are merged recursive except keys
			if(opts.keys !== undefined){
				F.opts.keys = opts.keys ? $.extend({}, F.defaults.keys, opts.keys) : false;
			}

			F.group = group;

			return F._start(F.opts.index);
		},

		// Cancel image loading or abort ajax request
		cancel: function (){
			var coming = F.coming;

			if(coming && false === F.trigger('onCancel')){
				return;
			}

			F.hideLoading();

			if(!coming){
				return;
			}

			if(F.ajaxLoad){
				F.ajaxLoad.abort();
			}

			F.ajaxLoad = null;

			if(F.imgPreload){
				F.imgPreload.onload = F.imgPreload.onerror = null;
			}

			if(coming.wrap){
				coming.wrap.stop(true, true).trigger('onReset').remove();
			}

			F.coming = null;

			// If the first item has been canceled, then clear everything
			if(!F.current){
				F._afterZoomOut( coming );
			}
      isFBoxOpen = false;
			isFBoxOpenFx();
		},

		// Start closing animation if is open; remove immediately if opening/closing
		close: function (event){
			F.cancel();

			if(false === F.trigger('beforeClose')){
				return;
			}

			F.unbindEvents();

			if(!F.isActive){
				return;
			}

			if(!F.isOpen || event === true){
				$('.fancybox-wrap').stop(true).trigger('onReset').remove();

				F._afterZoomOut();

			} else{
				F.isOpen = F.isOpened = false;
				F.isClosing = true;

				$('.fancybox-item, .fancybox-nav').remove();

				F.wrap.stop(true, true).removeClass('fancybox-opened');

				F.transitions[ F.current.closeMethod ]();
			}
      isFBoxOpen = false;
			isFBoxOpenFx();
		},

		// Manage slideshow:
		//   $.fancybox.play(); - toggle slideshow
		//   $.fancybox.play( true ); - start
		//   $.fancybox.play( false ); - stop
		play: function ( action ){
			var clear = function (){
					clearTimeout(F.player.timer);
				},
				set = function (){
					clear();

					if(F.current && F.player.isActive){
						F.player.timer = setTimeout(F.next, F.current.playSpeed);
					}
				},
				stop = function (){
					clear();

					D.unbind('.player');

					F.player.isActive = false;

					F.trigger('onPlayEnd');
				},
				start = function (){
					if(F.current && (F.current.loop || F.current.index < F.group.length - 1)){
						F.player.isActive = true;

						D.bind({
							'onCancel.player beforeClose.player' : stop,
							'onUpdate.player'   : set,
							'beforeLoad.player' : clear
						});

						set();

						F.trigger('onPlayStart');
					}
				};

			if(action === true || (!F.player.isActive && action !== false)){
				start();
			} else{
				stop();
			}
		},

		// Navigate to next gallery item
		next: function ( direction ){
			var current = F.current;

			if(current){
				if(!isString(direction)){
					direction = current.direction.next;
				}

				F.jumpto(current.index + 1, direction, 'next');
			}
		},

		// Navigate to previous gallery item
		prev: function ( direction ){
			var current = F.current;

			if(current){
				if(!isString(direction)){
					direction = current.direction.prev;
				}

				F.jumpto(current.index - 1, direction, 'prev');
			}
		},

		// Navigate to gallery item by index
		jumpto: function ( index, direction, router ){
			var current = F.current;

			if(!current){
				return;
			}

			index = getScalar(index);

			F.direction = direction || current.direction[ (index >= current.index ? 'next' : 'prev') ];
			F.router    = router || 'jumpto';

			if(current.loop){
				if(index < 0){
					index = current.group.length + (index % current.group.length);
				}

				index = index % current.group.length;
			}

			if(current.group[ index ] !== undefined){
				F.cancel();

				F._start(index);
			}
		},

		// Center inside viewport and toggle position type to fixed or absolute if needed
		reposition: function (e, onlyAbsolute){
			var current = F.current,
				wrap    = current ? current.wrap : null,
				pos;

			if(wrap){
				pos = F._getPosition(onlyAbsolute);

				if(e && e.type === 'scroll'){
					delete pos.position;

					wrap.stop(true, true).animate(pos, 200);

				} else{
					wrap.css(pos);

					current.pos = $.extend({}, current.dim, pos);
				}
			}
		},

		update: function (e){
			var type = (e && e.originalEvent && e.originalEvent.type),
				anyway = !type || type === 'orientationchange';

			if(anyway){
				clearTimeout(didUpdate);

				didUpdate = null;
			}

			if(!F.isOpen || didUpdate){
				return;
			}

			didUpdate = setTimeout(function(){
				var current = F.current;

				if(!current || F.isClosing){
					return;
				}

				F.wrap.removeClass('fancybox-tmp');

				if(anyway || type === 'load' || (type === 'resize' && current.autoResize)){
					F._setDimension();
				}

				if(!(type === 'scroll' && current.canShrink)){
					F.reposition(e);
				}

				F.trigger('onUpdate');

				didUpdate = null;

			}, (anyway && !isTouch ? 0 : 300));
		},

		// Shrink content to fit inside viewport or restore if resized
		toggle: function ( action ){
			if(F.isOpen){
				F.current.fitToView = $.type(action) === "boolean" ? action : !F.current.fitToView;

				// Help browser to restore document dimensions
				if(isTouch){
					F.wrap.removeAttr('style').addClass('fancybox-tmp');

					F.trigger('onUpdate');
				}

				F.update();
			}
		},

		hideLoading: function (){
			D.unbind('.loading');

			$('#fancybox-loading').remove();
		},

		showLoading: function (){
			var el, viewport;

			F.hideLoading();

			el = $(F.opts.tpl.loading).click(F.cancel).appendTo('body');

			// If user will press the escape-button, the request will be canceled
			D.bind('keydown.loading', function(e){
				if((e.which || e.keyCode) === 27){
					e.preventDefault();

					F.cancel();
				}
			});

			if(!F.defaults.fixed){
				viewport = F.getViewport();

				el.css({
					position : 'absolute',
					top  : (viewport.h * 0.5) + viewport.y,
					left : (viewport.w * 0.5) + viewport.x
				});
			}

			F.trigger('onLoading');
		},

		getViewport: function (){
			var locked = (F.current && F.current.locked) || false,
				rez    = {
					x: W.scrollLeft(),
					y: W.scrollTop()
				};

			if(locked && locked.length){
				rez.w = locked[0].clientWidth;
				rez.h = locked[0].clientHeight;

			} else{
				// See http://bugs.jquery.com/ticket/6724
				rez.w = isTouch && window.innerWidth  ? window.innerWidth  : W.width();
				rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height();
			}

			return rez;
		},

		// Unbind the keyboard / clicking actions
		unbindEvents: function (){
			if(F.wrap && isQuery(F.wrap)){
				F.wrap.unbind('.fb');
			}

			D.unbind('.fb');
			W.unbind('.fb');
		},

		bindEvents: function (){
			var current = F.current,
				keys;

			if(!current){
				return;
			}

			// Changing document height on iOS devices triggers a 'resize' event,
			// that can change document height... repeating infinitely
			W.bind('orientationchange.fb' + (isTouch ? '' : ' resize.fb') + (current.autoCenter && !current.locked ? ' scroll.fb' : ''), F.update);

			keys = current.keys;

			if(keys){
				D.bind('keydown.fb', function (e){
					var code   = e.which || e.keyCode,
						target = e.target || e.srcElement;

					// Skip esc key if loading, because showLoading will cancel preloading
					if(code === 27 && F.coming){
						return false;
					}

					// Ignore key combinations and key events within form elements
					if(!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || $(target).is('[contenteditable]')))){
						$.each(keys, function(i, val){
							if(current.group.length > 1 && val[ code ] !== undefined){
								F[ i ]( val[ code ] );

								e.preventDefault();
								return false;
							}

							if($.inArray(code, val) > -1){
								F[ i ] ();

								e.preventDefault();
								return false;
							}
						});
					}
				});
			}

			if($.fn.mousewheel && current.mouseWheel){
				F.wrap.bind('mousewheel.fb', function (e, delta, deltaX, deltaY){
					var target = e.target || null,
						parent = $(target),
						canScroll = false;

					while (parent.length){
						if(canScroll || parent.is('.fancybox-skin') || parent.is('.fancybox-wrap')){
							break;
						}

						canScroll = isScrollable( parent[0] );
						parent    = $(parent).parent();
					}

					if(delta !== 0 && !canScroll){
						if(F.group.length > 1 && !current.canShrink){
							if(deltaY > 0 || deltaX > 0){
								F.prev( deltaY > 0 ? 'down' : 'left' );

							} else if(deltaY < 0 || deltaX < 0){
								F.next( deltaY < 0 ? 'up' : 'right' );
							}

							e.preventDefault();
						}
					}
				});
			}
		},

		trigger: function (event, o){
			var ret, obj = o || F.coming || F.current;

			if(obj){
				if($.isFunction( obj[event] )){
					ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1));
				}

				if(ret === false){
					return false;
				}

				if(obj.helpers){
					$.each(obj.helpers, function (helper, opts){
						if(opts && F.helpers[helper] && $.isFunction(F.helpers[helper][event])){
							F.helpers[helper][event]($.extend(true, {}, F.helpers[helper].defaults, opts), obj);
						}
					});
				}
			}

			D.trigger(event);
		},

		isImage: function (str){
			return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
		},

		isSWF: function (str){
			return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i);
		},

		_start: function (index){
			var coming = {},
				obj,
				href,
				type,
				margin,
				padding;

			index = getScalar( index );
			obj   = F.group[ index ] || null;

			if(!obj){
				return false;
			}

			coming = $.extend(true, {}, F.opts, obj);

			// Convert margin and padding properties to array - top, right, bottom, left
			margin  = coming.margin;
			padding = coming.padding;

			if($.type(margin) === 'number'){
				coming.margin = [margin, margin, margin, margin];
			}

			if($.type(padding) === 'number'){
				coming.padding = [padding, padding, padding, padding];
			}

			// 'modal' propery is just a shortcut
			if(coming.modal){
				$.extend(true, coming, {
					closeBtn   : false,
					closeClick : false,
					nextClick  : false,
					arrows     : false,
					mouseWheel : false,
					keys       : null,
					helpers: {
						overlay : {
							closeClick : false
						}
					}
				});
			}

			// 'autoSize' property is a shortcut, too
			if(coming.autoSize){
				coming.autoWidth = coming.autoHeight = true;
			}

			if(coming.width === 'auto'){
				coming.autoWidth = true;
			}

			if(coming.height === 'auto'){
				coming.autoHeight = true;
			}

			/*
			 * Add reference to the group, so it`s possible to access from callbacks, example:
			 * afterLoad : function(){
			 *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
			 * }
			 */

			coming.group  = F.group;
			coming.index  = index;

			// Give a chance for callback or helpers to update coming item (type, title, etc)
			F.coming = coming;

			if(false === F.trigger('beforeLoad')){
				F.coming = null;

				return;
			}

			type = coming.type;
			href = coming.href;

			if(!type){
				F.coming = null;

				//If we can not determine content type then drop silently or display next/prev item if looping through gallery
				if(F.current && F.router && F.router !== 'jumpto'){
					F.current.index = index;

					return F[ F.router ]( F.direction );
				}

				return false;
			}

			F.isActive = true;

			if(type === 'image' || type === 'swf'){
				coming.autoHeight = coming.autoWidth = false;
				coming.scrolling  = 'visible';
			}

			if(type === 'image'){
				coming.aspectRatio = true;
			}

			if(type === 'iframe' && isTouch){
				coming.scrolling = 'scroll';
			}

			// Build the neccessary markup
			coming.wrap = $(coming.tpl.wrap).addClass('fancybox-' + (isTouch ? 'mobile' : 'desktop') + ' fancybox-type-' + type + ' fancybox-tmp ' + coming.wrapCSS).appendTo( coming.parent || 'body' );

			$.extend(coming, {
				skin  : $('.fancybox-skin',  coming.wrap),
				outer : $('.fancybox-outer', coming.wrap),
				inner : $('.fancybox-inner', coming.wrap)
			});

			$.each(["Top", "Right", "Bottom", "Left"], function(i, v){
				coming.skin.css('padding' + v, getValue(coming.padding[ i ]));
			});

			F.trigger('onReady');

			// Check before try to load; 'inline' and 'html' types need content, others - href
			if(type === 'inline' || type === 'html'){
				if(!coming.content || !coming.content.length){
					return F._error( 'content' );
				}

			} else if(!href){
				return F._error( 'href' );
			}

			if(type === 'image'){
				F._loadImage();

			} else if(type === 'ajax'){
				F._loadAjax();

			} else if(type === 'iframe'){
				F._loadIframe();

			} else{
				F._afterLoad();
			}
		},

		_error: function ( type ){
			$.extend(F.coming, {
				type       : 'html',
				autoWidth  : true,
				autoHeight : true,
				minWidth   : 0,
				minHeight  : 0,
				scrolling  : 'no',
				hasError   : type,
				content    : F.coming.tpl.error
			});

			F._afterLoad();
		},

		_loadImage: function (){
			// Reset preload image so it is later possible to check "complete" property
			var img = F.imgPreload = new Image();

			img.onload = function (){
				this.onload = this.onerror = null;

				F.coming.width  = this.width / F.opts.pixelRatio;
				F.coming.height = this.height / F.opts.pixelRatio;

				F._afterLoad();
			};

			img.onerror = function (){
				this.onload = this.onerror = null;

				F._error( 'image' );
			};

			img.src = F.coming.href;

			if(img.complete !== true){
				F.showLoading();
			}
		},

		_loadAjax: function (){
			var coming = F.coming;

			F.showLoading();

			F.ajaxLoad = $.ajax($.extend({}, coming.ajax, {
				url: coming.href,
				error: function (jqXHR, textStatus){
					if(F.coming && textStatus !== 'abort'){
						F._error( 'ajax', jqXHR );

					} else{
						F.hideLoading();
					}
				},
				success: function (data, textStatus){
					if(textStatus === 'success'){
						coming.content = data;

						F._afterLoad();
					}
				}
			}));
		},

		_loadIframe: function(){
			var coming = F.coming,
				iframe = $(coming.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
					.attr('scrolling', isTouch ? 'auto' : coming.iframe.scrolling)
					.attr('src', coming.href);

			// This helps IE
			$(coming.wrap).bind('onReset', function (){
				try {
					$(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
				} catch (e){}
			});

			if(coming.iframe.preload){
				F.showLoading();

				iframe.one('load', function(){
					$(this).data('ready', 1);

					// iOS will lose scrolling if we resize
					if(!isTouch){
						$(this).bind('load.fb', F.update);
					}

					// Without this trick:
					//   - iframe won't scroll on iOS devices
					//   - IE7 sometimes displays empty iframe
					$(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();

					F._afterLoad();
				});
			}

			coming.content = iframe.appendTo( coming.inner );

			if(!coming.iframe.preload){
				F._afterLoad();
			}
		},

		_preloadImages: function(){
			var group   = F.group,
				current = F.current,
				len     = group.length,
				cnt     = current.preload ? Math.min(current.preload, len - 1) : 0,
				item,
				i;

			for(i = 1; i <= cnt; i += 1){
				item = group[ (current.index + i ) % len ];

				if(item.type === 'image' && item.href){
					new Image().src = item.href;
				}
			}
		},

		_afterLoad: function (){
			var coming   = F.coming,
				previous = F.current,
				placeholder = 'fancybox-placeholder',
				current,
				content,
				type,
				scrolling,
				href,
				embed;

			F.hideLoading();

			if(!coming || F.isActive === false){
				return;
			}

			if(false === F.trigger('afterLoad', coming, previous)){
				coming.wrap.stop(true).trigger('onReset').remove();

				F.coming = null;

				return;
			}

			if(previous){
				F.trigger('beforeChange', previous);

				previous.wrap.stop(true).removeClass('fancybox-opened')
					.find('.fancybox-item, .fancybox-nav')
					.remove();
			}

			F.unbindEvents();

			current   = coming;
			content   = coming.content;
			type      = coming.type;
			scrolling = coming.scrolling;

			$.extend(F, {
				wrap  : current.wrap,
				skin  : current.skin,
				outer : current.outer,
				inner : current.inner,
				current  : current,
				previous : previous
			});

			href = current.href;

			switch (type){
				case 'inline':
				case 'ajax':
				case 'html':
					if(current.selector){
						content = $('<div>').html(content).find(current.selector);

					} else if(isQuery(content)){
						if(!content.data(placeholder)){
							content.data(placeholder, $('<div class="' + placeholder + '"></div>').insertAfter( content ).hide() );
						}

						content = content.show().detach();

						current.wrap.bind('onReset', function (){
							if($(this).find(content).length){
								content.hide().replaceAll( content.data(placeholder) ).data(placeholder, false);
							}
						});
					}
				break;

				case 'image':
					content = current.tpl.image.replace(/\{href\}/g, href);
				break;

				case 'swf':
					content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
					embed   = '';

					$.each(current.swf, function(name, val){
						content += '<param name="' + name + '" value="' + val + '"></param>';
						embed   += ' ' + name + '="' + val + '"';
					});

					content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + '></embed></object>';
				break;
			}

			if(!(isQuery(content) && content.parent().is(current.inner))){
				current.inner.append( content );
			}

			// Give a chance for helpers or callbacks to update elements
			F.trigger('beforeShow');

			// Set scrolling before calculating dimensions
			current.inner.css('overflow', scrolling === 'yes' ? 'scroll' : (scrolling === 'no' ? 'hidden' : scrolling));

			// Set initial dimensions and start position
			F._setDimension();

			F.reposition();

			F.isOpen = false;
			F.coming = null;

			F.bindEvents();

			if(!F.isOpened){
				$('.fancybox-wrap').not( current.wrap ).stop(true).trigger('onReset').remove();

			} else if(previous.prevMethod){
				F.transitions[ previous.prevMethod ]();
			}

			F.transitions[ F.isOpened ? current.nextMethod : current.openMethod ]();

			F._preloadImages();
		},

		_setDimension: function (){
			var viewport   = F.getViewport(),
				steps      = 0,
				canShrink  = false,
				canExpand  = false,
				wrap       = F.wrap,
				skin       = F.skin,
				inner      = F.inner,
				current    = F.current,
				width      = current.width,
				height     = current.height,
				minWidth   = current.minWidth,
				minHeight  = current.minHeight,
				maxWidth   = current.maxWidth,
				maxHeight  = current.maxHeight,
				scrolling  = current.scrolling,
				scrollOut  = current.scrollOutside ? current.scrollbarWidth : 0,
				margin     = current.margin,
				wMargin    = getScalar(margin[1] + margin[3]),
				hMargin    = getScalar(margin[0] + margin[2]),
				wPadding,
				hPadding,
				wSpace,
				hSpace,
				origWidth,
				origHeight,
				origMaxWidth,
				origMaxHeight,
				ratio,
				width_,
				height_,
				maxWidth_,
				maxHeight_,
				iframe,
				body;

			// Reset dimensions so we could re-check actual size
			wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');

			wPadding = getScalar(skin.outerWidth(true)  - skin.width());
			hPadding = getScalar(skin.outerHeight(true) - skin.height());

			// Any space between content and viewport (margin, padding, border, title)
			wSpace = wMargin + wPadding;
			hSpace = hMargin + hPadding;

			origWidth  = isPercentage(width)  ? (viewport.w - wSpace) * getScalar(width)  / 100 : width;
			origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;

			if(current.type === 'iframe'){
				iframe = current.content;

				if(current.autoHeight && iframe && iframe.data('ready') === 1){
					try {
						if(iframe[0].contentWindow.document.location){
							inner.width( origWidth ).height(9999);

							body = iframe.contents().find('body');

							if(scrollOut){
								body.css('overflow-x', 'hidden');
							}

							origHeight = body.outerHeight(true);
						}

					} catch (e){}
				}

			} else if(current.autoWidth || current.autoHeight){
				inner.addClass( 'fancybox-tmp' );

				// Set width or height in case we need to calculate only one dimension
				if(!current.autoWidth){
					inner.width( origWidth );
				}

				if(!current.autoHeight){
					inner.height( origHeight );
				}

				if(current.autoWidth){
					origWidth = inner.width();
				}

				if(current.autoHeight){
					origHeight = inner.height();
				}

				inner.removeClass( 'fancybox-tmp' );
			}

			width  = getScalar( origWidth );
			height = getScalar( origHeight );

			ratio  = origWidth / origHeight;

			// Calculations for the content
			minWidth  = getScalar(isPercentage(minWidth) ? getScalar(minWidth, 'w') - wSpace : minWidth);
			maxWidth  = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, 'w') - wSpace : maxWidth);

			minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, 'h') - hSpace : minHeight);
			maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, 'h') - hSpace : maxHeight);

			// These will be used to determine if wrap can fit in the viewport
			origMaxWidth  = maxWidth;
			origMaxHeight = maxHeight;

			if(current.fitToView){
				maxWidth  = Math.min(viewport.w - wSpace, maxWidth);
				maxHeight = Math.min(viewport.h - hSpace, maxHeight);
			}

			maxWidth_  = viewport.w - wMargin;
			maxHeight_ = viewport.h - hMargin;

			if(current.aspectRatio){
				if(width > maxWidth){
					width  = maxWidth;
					height = getScalar(width / ratio);
				}

				if(height > maxHeight){
					height = maxHeight;
					width  = getScalar(height * ratio);
				}

				if(width < minWidth){
					width  = minWidth;
					height = getScalar(width / ratio);
				}

				if(height < minHeight){
					height = minHeight;
					width  = getScalar(height * ratio);
				}

			} else{
				width = Math.max(minWidth, Math.min(width, maxWidth));

				if(current.autoHeight && current.type !== 'iframe'){
					inner.width( width );

					height = inner.height();
				}

				height = Math.max(minHeight, Math.min(height, maxHeight));
			}

			// Try to fit inside viewport (including the title)
			if(current.fitToView){
				inner.width( width ).height( height );

				wrap.width( width + wPadding );

				// Real wrap dimensions
				width_  = wrap.width();
				height_ = wrap.height();

				if(current.aspectRatio){
					while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight){
						if(steps++ > 19){
							break;
						}

						height = Math.max(minHeight, Math.min(maxHeight, height - 10));
						width  = getScalar(height * ratio);

						if(width < minWidth){
							width  = minWidth;
							height = getScalar(width / ratio);
						}

						if(width > maxWidth){
							width  = maxWidth;
							height = getScalar(width / ratio);
						}

						inner.width( width ).height( height );

						wrap.width( width + wPadding );

						width_  = wrap.width();
						height_ = wrap.height();
					}

				} else{
					width  = Math.max(minWidth,  Math.min(width,  width  - (width_  - maxWidth_)));
					height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)));
				}
			}

			if(scrollOut && scrolling === 'auto' && height < origHeight && (width + wPadding + scrollOut) < maxWidth_){
				width += scrollOut;
			}

			inner.width( width ).height( height );

			wrap.width( width + wPadding );

			width_  = wrap.width();
			height_ = wrap.height();

			canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
			canExpand = current.aspectRatio ? (width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight) : ((width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight));

			$.extend(current, {
				dim : {
					width	: getValue( width_ ),
					height	: getValue( height_ )
				},
				origWidth  : origWidth,
				origHeight : origHeight,
				canShrink  : canShrink,
				canExpand  : canExpand,
				wPadding   : wPadding,
				hPadding   : hPadding,
				wrapSpace  : height_ - skin.outerHeight(true),
				skinSpace  : skin.height() - height
			});

			if(!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand){
				inner.height('auto');
			}
		},

		_getPosition: function (onlyAbsolute){
			var current  = F.current,
				viewport = F.getViewport(),
				margin   = current.margin,
				width    = F.wrap.width()  + margin[1] + margin[3],
				height   = F.wrap.height() + margin[0] + margin[2],
				rez      = {
					position: 'absolute',
					top  : margin[0],
					left : margin[3]
				};

			if(current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w){
				rez.position = 'fixed';

			} else if(!current.locked){
				rez.top  += viewport.y;
				rez.left += viewport.x;
			}

			rez.top  = getValue(Math.max(rez.top,  rez.top  + ((viewport.h - height) * current.topRatio)));
			rez.left = getValue(Math.max(rez.left, rez.left + ((viewport.w - width)  * current.leftRatio)));

			return rez;
		},

		_afterZoomIn: function (){
			var current = F.current;

			if(!current){
				return;
			}

			F.isOpen = F.isOpened = true;

			F.wrap.css('overflow', 'visible').addClass('fancybox-opened').hide().show(0);

			F.update();

			// Assign a click event
			if( current.closeClick || (current.nextClick && F.group.length > 1) ){
				F.inner.css('cursor', 'pointer').bind('click.fb', function(e){
					if(!$(e.target).is('a') && !$(e.target).parent().is('a')){
						e.preventDefault();

						F[ current.closeClick ? 'close' : 'next' ]();
					}
				});
			}

			// Create a close button
			if(current.closeBtn){
				$(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb', function(e){
					e.preventDefault();

					F.close();
				});
			}

			// Create navigation arrows
			if(current.arrows && F.group.length > 1){
				if(current.loop || current.index > 0){
					$(current.tpl.prev).appendTo(F.outer).bind('click.fb', F.prev);
				}

				if(current.loop || current.index < F.group.length - 1){
					$(current.tpl.next).appendTo(F.outer).bind('click.fb', F.next);
				}
			}

			F.trigger('afterShow');

			// Stop the slideshow if this is the last item
			if(!current.loop && current.index === current.group.length - 1){

				F.play( false );

			} else if(F.opts.autoPlay && !F.player.isActive){
				F.opts.autoPlay = false;

				F.play(true);
			}
		},

		_afterZoomOut: function ( obj ){
			obj = obj || F.current;

			$('.fancybox-wrap').trigger('onReset').remove();

			$.extend(F, {
				group  : {},
				opts   : {},
				router : false,
				current   : null,
				isActive  : false,
				isOpened  : false,
				isOpen    : false,
				isClosing : false,
				wrap   : null,
				skin   : null,
				outer  : null,
				inner  : null
			});

			F.trigger('afterClose', obj);
		}
	});

	/*
	 *	Default transitions
	 */

	F.transitions = {
		getOrigPosition: function (){
			var current  = F.current,
				element  = current.element,
				orig     = current.orig,
				pos      = {},
				width    = 50,
				height   = 50,
				hPadding = current.hPadding,
				wPadding = current.wPadding,
				viewport = F.getViewport();

			if(!orig && current.isDom && element.is(':visible')){
				orig = element.find('img:first');

				if(!orig.length){
					orig = element;
				}
			}

			if(isQuery(orig)){
				pos = orig.offset();

				if(orig.is('img')){
					width  = orig.outerWidth();
					height = orig.outerHeight();
				}

			} else{
				pos.top  = viewport.y + (viewport.h - height) * current.topRatio;
				pos.left = viewport.x + (viewport.w - width)  * current.leftRatio;
			}

			if(F.wrap.css('position') === 'fixed' || current.locked){
				pos.top  -= viewport.y;
				pos.left -= viewport.x;
			}

			pos = {
				top     : getValue(pos.top  - hPadding * current.topRatio),
				left    : getValue(pos.left - wPadding * current.leftRatio),
				width   : getValue(width  + wPadding),
				height  : getValue(height + hPadding)
			};

			return pos;
		},

		step: function (now, fx){
			var ratio,
				padding,
				value,
				prop       = fx.prop,
				current    = F.current,
				wrapSpace  = current.wrapSpace,
				skinSpace  = current.skinSpace;

			if(prop === 'width' || prop === 'height'){
				ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);

				if(F.isClosing){
					ratio = 1 - ratio;
				}

				padding = prop === 'width' ? current.wPadding : current.hPadding;
				value   = now - padding;

				F.skin[ prop ](  getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) ) );
				F.inner[ prop ]( getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) - (skinSpace * ratio) ) );
			}
		},

		zoomIn: function (){
			var current  = F.current,
				startPos = current.pos,
				effect   = current.openEffect,
				elastic  = effect === 'elastic',
				endPos   = $.extend({opacity : 1}, startPos);

			// Remove "position" property that breaks older IE
			delete endPos.position;

			if(elastic){
				startPos = this.getOrigPosition();

				if(current.openOpacity){
					startPos.opacity = 0.1;
				}

			} else if(effect === 'fade'){
				startPos.opacity = 0.1;
			}

			F.wrap.css(startPos).animate(endPos, {
				duration : effect === 'none' ? 0 : current.openSpeed,
				easing   : current.openEasing,
				step     : elastic ? this.step : null,
				complete : F._afterZoomIn
			});
		},

		zoomOut: function (){
			var current  = F.current,
				effect   = current.closeEffect,
				elastic  = effect === 'elastic',
				endPos   = {opacity : 0.1};

			if(elastic){
				endPos = this.getOrigPosition();

				if(current.closeOpacity){
					endPos.opacity = 0.1;
				}
			}

			F.wrap.animate(endPos, {
				duration : effect === 'none' ? 0 : current.closeSpeed,
				easing   : current.closeEasing,
				step     : elastic ? this.step : null,
				complete : F._afterZoomOut
			});
		},

		changeIn: function (){
			var current   = F.current,
				effect    = current.nextEffect,
				startPos  = current.pos,
				endPos    = { opacity : 1 },
				direction = F.direction,
				distance  = 200,
				field;

			startPos.opacity = 0.1;

			if(effect === 'elastic'){
				field = direction === 'down' || direction === 'up' ? 'top' : 'left';

				if(direction === 'down' || direction === 'right'){
					startPos[ field ] = getValue(getScalar(startPos[ field ]) - distance);
					endPos[ field ]   = '+=' + distance + 'px';

				} else{
					startPos[ field ] = getValue(getScalar(startPos[ field ]) + distance);
					endPos[ field ]   = '-=' + distance + 'px';
				}
			}

			// Workaround for http://bugs.jquery.com/ticket/12273
			if(effect === 'none'){
				F._afterZoomIn();

			} else{
				F.wrap.css(startPos).animate(endPos, {
					duration : current.nextSpeed,
					easing   : current.nextEasing,
					complete : F._afterZoomIn
				});
			}
		},

		changeOut: function (){
			var previous  = F.previous,
				effect    = previous.prevEffect,
				endPos    = { opacity : 0.1 },
				direction = F.direction,
				distance  = 200;

			if(effect === 'elastic'){
				endPos[ direction === 'down' || direction === 'up' ? 'top' : 'left' ] = ( direction === 'up' || direction === 'left' ? '-' : '+' ) + '=' + distance + 'px';
			}

			previous.wrap.animate(endPos, {
				duration : effect === 'none' ? 0 : previous.prevSpeed,
				easing   : previous.prevEasing,
				complete : function (){
					$(this).trigger('onReset').remove();
				}
			});
		}
	};

	/*
	 *	Overlay helper
	 */

	F.helpers.overlay = {
		defaults : {
			closeClick : true,      // if true, fancyBox will be closed when user clicks on the overlay
			speedOut   : 200,       // duration of fadeOut animation
			showEarly  : true,      // indicates if should be opened immediately or wait until the content is ready
			css        : {},        // custom CSS properties
			locked     : !isTouch,  // if true, the content will be locked into overlay
			fixed      : true       // if false, the overlay CSS position property will not be set to "fixed"
		},

		overlay : null,      // current handle
		fixed   : false,     // indicates if the overlay has position "fixed"
		el      : $('html'), // element that contains "the lock"

		// Public methods
		create : function(opts){
			var parent;

			opts = $.extend({}, this.defaults, opts);

			if(this.overlay){
				this.close();
			}

			parent = F.coming ? F.coming.parent : opts.parent;

			this.overlay = $('<div class="fancybox-overlay"></div>').appendTo( parent && parent.length ? parent : 'body' );
			this.fixed   = false;

			if(opts.fixed && F.defaults.fixed){
				this.overlay.addClass('fancybox-overlay-fixed');

				this.fixed = true;
			}
		},

		open : function(opts){
			var that = this;

			opts = $.extend({}, this.defaults, opts);

			if(this.overlay){
				this.overlay.unbind('.overlay').width('auto').height('auto');

			} else{
				this.create(opts);
			}

			if(!this.fixed){
				W.bind('resize.overlay', $.proxy( this.update, this) );

				this.update();
			}

			if(opts.closeClick){
				this.overlay.bind('click.overlay', function(e){
					if($(e.target).hasClass('fancybox-overlay')){
						if(F.isActive){
							F.close();
						} else{
							that.close();
						}

						return false;
					}
				});
			}

			this.overlay.css( opts.css ).show();
		},

		close : function(){
			W.unbind('resize.overlay');

			if(this.el.hasClass('fancybox-lock')){
				$('.fancybox-margin').removeClass('fancybox-margin');

				this.el.removeClass('fancybox-lock');

				W.scrollTop( this.scrollV ).scrollLeft( this.scrollH );
			}

			$('.fancybox-overlay').remove().hide();

			$.extend(this, {
				overlay : null,
				fixed   : false
			});
		},

		// Private, callbacks

		update : function (){
			var width = '100%', offsetWidth;

			// Reset width/height so it will not mess
			this.overlay.width(width).height('100%');

			// jQuery does not return reliable result for IE
			if(IE){
				offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);

				if(D.width() > offsetWidth){
					width = D.width();
				}

			} else if(D.width() > W.width()){
				width = D.width();
			}

			this.overlay.width(width).height(D.height());
		},

		// This is where we can manipulate DOM, because later it would cause iframes to reload
		onReady : function (opts, obj){
			var overlay = this.overlay;

			$('.fancybox-overlay').stop(true, true);

			if(!overlay){
				this.create(opts);
			}

			if(opts.locked && this.fixed && obj.fixed){
				obj.locked = this.overlay.append( obj.wrap );
				obj.fixed  = false;
			}

			if(opts.showEarly === true){
				this.beforeShow.apply(this, arguments);
			}
		},

		beforeShow : function(opts, obj){
			if(obj.locked && !this.el.hasClass('fancybox-lock')){
				if(this.fixPosition !== false){
					$('*:not(object)').filter(function(){
						return ($(this).css('position') === 'fixed' && !$(this).hasClass("fancybox-overlay") && !$(this).hasClass("fancybox-wrap") );
					}).addClass('fancybox-margin');
				}

				this.el.addClass('fancybox-margin');

				this.scrollV = W.scrollTop();
				this.scrollH = W.scrollLeft();

				this.el.addClass('fancybox-lock');

				W.scrollTop( this.scrollV ).scrollLeft( this.scrollH );
			}

			this.open(opts);
		},

		onUpdate : function(){
			if(!this.fixed){
				this.update();
			}
		},

		afterClose: function (opts){
			// Remove overlay if exists and fancyBox is not opening
			// (e.g., it is not being open using afterClose callback)
			if(this.overlay && !F.coming){
				this.overlay.fadeOut(opts.speedOut, $.proxy( this.close, this ));
			}
		}
	};

	/*
	 *	Title helper
	 */

	F.helpers.title = {
		defaults : {
			type     : 'float', // 'float', 'inside', 'outside' or 'over',
			position : 'bottom' // 'top' or 'bottom'
		},

		beforeShow: function (opts){
			var current = F.current,
				text    = current.title,
				extn    = current.extn,
				totalP    = current.group.length,
				indexP    = current.index + 1,
				type    = opts.type,
				title,
				target;

			if($.isFunction(text)){
				text = text.call(current.element, current);
			}

			if(!isString(text) || $.trim(text) === ''){
				return;
			}
			if(extn == "PDF" || extn == "PPTX" || extn == "DOCX"){
				title = $('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '<span class="fancybox-title-pageCount">'+indexP +'/'+totalP+'</span></div>');
			} else{
				title = $('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '</div>');
			}

			switch (type){
				case 'inside':
					target = F.skin;
				break;

				case 'outside':
					target = F.wrap;
				break;

				case 'over':
					target = F.inner;
				break;

				default: // 'float'
					target = F.skin;

					title.appendTo('body');

					if(IE){
						title.width( title.width() );
					}

					title.wrapInner('<span class="child"></span>');

					//Increase bottom margin so this title will also fit into viewport
					F.current.margin[2] += Math.abs( getScalar(title.css('margin-bottom')) );
				break;
			}

			title[ (opts.position === 'top' ? 'prependTo'  : 'appendTo') ](target);
		}
	};

	// jQuery plugin initialization
	$.fn.fancybox = function (options){
		var index,
			that     = $(this),
			selector = this.selector || '',
			run      = function(e){
				var what = $(this).blur(), idx = index, relType, relVal;

				if(!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is('.fancybox-wrap')){
					relType = options.groupAttr || 'data-fancybox-group';
					relVal  = what.attr(relType);

					if(!relVal){
						relType = 'rel';
						relVal  = what.get(0)[ relType ];
					}

					if(relVal && relVal !== '' && relVal !== 'nofollow'){
						what = selector.length ? $(selector) : that;
						what = what.filter('[' + relType + '="' + relVal + '"]');
						idx  = what.index(this);
					}

					options.index = idx;

					// Stop an event from bubbling if everything is fine
					if(F.open(what, options) !== false){
						e.preventDefault();
					}
				}
			};

		options = options || {};
		index   = options.index || 0;

		if(!selector || options.live === false){
			that.unbind('click.fb-start').bind('click.fb-start', run);

		} else{
			D.undelegate(selector, 'click.fb-start').delegate(selector + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', run);
		}

		this.filter('[data-fancybox-start=1]').trigger('click');

		return this;
	};

	// Tests that need a body at doc ready
	D.ready(function(){
		var w1, w2;

		if( $.scrollbarWidth === undefined ){
			// http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
			$.scrollbarWidth = function(){
				var parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
					child  = parent.children(),
					width  = child.innerWidth() - child.height( 99 ).innerWidth();

				parent.remove();

				return width;
			};
		}

		if( $.support.fixedPosition === undefined ){
			$.support.fixedPosition = (function(){
				var elem  = $('<div style="position:fixed;top:20px;"></div>').appendTo('body'),
					fixed = ( elem[0].offsetTop === 20 || elem[0].offsetTop === 15 );

				elem.remove();

				return fixed;
			}());
		}

		$.extend(F.defaults, {
			scrollbarWidth : $.scrollbarWidth(),
			fixed  : $.support.fixedPosition,
			parent : $('body')
		});

		//Get real width of page scroll-bar
		w1 = $(window).width();

		H.addClass('fancybox-lock-test');

		w2 = $(window).width();

		H.removeClass('fancybox-lock-test');

		$("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
	});

}(window, document, jQuery));

/*!
 * Media helper for fancyBox
 * version: 1.0.6 (Fri, 14 Jun 2013)
 * @requires fancyBox v2.0 or later
 *
 * Usage:
 *     $(".fancybox").fancybox({
 *         helpers : {
 *             media: true
 *         }
 *     });
 *
 * Set custom URL parameters:
 *     $(".fancybox").fancybox({
 *         helpers : {
 *             media: {
 *                 youtube : {
 *                     params : {
 *                         autoplay : 0
 *                     }
 *                 }
 *             }
 *         }
 *     });
 *
 * Or:
 *     $(".fancybox").fancybox({,
 *         helpers : {
 *             media: true
 *         },
 *         youtube : {
 *             autoplay: 0
 *         }
 *     });
 *
 *  Supports:
 *
 *      Youtube
 *          http://www.youtube.com/watch?v=opj24KnzrWo
 *          http://www.youtube.com/embed/opj24KnzrWo
 *          http://youtu.be/opj24KnzrWo
 *			http://www.youtube-nocookie.com/embed/opj24KnzrWo
 *      Vimeo
 *          http://vimeo.com/40648169
 *          http://vimeo.com/channels/staffpicks/38843628
 *          http://vimeo.com/groups/surrealism/videos/36516384
 *          http://player.vimeo.com/video/45074303
 *      Metacafe
 *          http://www.metacafe.com/watch/7635964/dr_seuss_the_lorax_movie_trailer/
 *          http://www.metacafe.com/watch/7635964/
 *      Dailymotion
 *          http://www.dailymotion.com/video/xoytqh_dr-seuss-the-lorax-premiere_people
 *      Twitvid
 *          http://twitvid.com/QY7MD
 *      Twitpic
 *          http://twitpic.com/7p93st
 *      Instagram
 *          http://instagr.am/p/IejkuUGxQn/
 *          http://instagram.com/p/IejkuUGxQn/
 *      Google maps
 *          http://maps.google.com/maps?q=Eiffel+Tower,+Avenue+Gustave+Eiffel,+Paris,+France&t=h&z=17
 *          http://maps.google.com/?ll=48.857995,2.294297&spn=0.007666,0.021136&t=m&z=16
 *          http://maps.google.com/?ll=48.859463,2.292626&spn=0.000965,0.002642&t=m&z=19&layer=c&cbll=48.859524,2.292532&panoid=YJ0lq28OOy3VT2IqIuVY0g&cbp=12,151.58,,0,-15.56
 */
;(function ($){
	"use strict";

	//Shortcut for fancyBox object
	var F = $.fancybox,
		format = function( url, rez, params ){
			params = params || '';

			if( $.type( params ) === "object" ){
				params = $.param(params, true);
			}

			$.each(rez, function(key, value){
				url = url.replace( '$' + key, value || '' );
			});

			if(params.length){
				url += ( url.indexOf('?') > 0 ? '&' : '?' ) + params;
			}

			return url;
		};

	//Add helper object
	F.helpers.media = {
		defaults : {
			youtube : {
				matcher : /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i,
				params  : {
					autoplay    : 1,
					autohide    : 1,
					fs          : 1,
					rel         : 0,
					hd          : 1,
					wmode       : 'opaque',
					enablejsapi : 1
				},
				type : 'iframe',
				url  : '//www.youtube.com/embed/$3'
			},
			vimeo : {
				matcher : /(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/,
				params  : {
					autoplay      : 1,
					hd            : 1,
					show_title    : 1,
					show_byline   : 1,
					show_portrait : 0,
					fullscreen    : 1
				},
				type : 'iframe',
				url  : '//player.vimeo.com/video/$1'
			},
			metacafe : {
				matcher : /metacafe.com\/(?:watch|fplayer)\/([\w\-]{1,10})/,
				params  : {
					autoPlay : 'yes'
				},
				type : 'swf',
				url  : function( rez, params, obj ){
					obj.swf.flashVars = 'playerVars=' + $.param( params, true );

					return '//www.metacafe.com/fplayer/' + rez[1] + '/.swf';
				}
			},
			dailymotion : {
				matcher : /dailymotion.com\/video\/(.*)\/?(.*)/,
				params  : {
					additionalInfos : 0,
					autoStart : 1
				},
				type : 'swf',
				url  : '//www.dailymotion.com/swf/video/$1'
			},
			twitvid : {
				matcher : /twitvid\.com\/([a-zA-Z0-9_\-\?\=]+)/i,
				params  : {
					autoplay : 0
				},
				type : 'iframe',
				url  : '//www.twitvid.com/embed.php?guid=$1'
			},
			twitpic : {
				matcher : /twitpic\.com\/(?!(?:place|photos|events)\/)([a-zA-Z0-9\?\=\-]+)/i,
				type : 'image',
				url  : '//twitpic.com/show/full/$1/'
			},
			instagram : {
				matcher : /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
				type : 'image',
				url  : '//$1/p/$2/media/?size=l'
			},
			google_maps : {
				matcher : /maps\.google\.([a-z]{2,3}(\.[a-z]{2})?)\/(\?ll=|maps\?)(.*)/i,
				type : 'iframe',
				url  : function( rez ){
					return '//maps.google.' + rez[1] + '/' + rez[3] + '' + rez[4] + '&output=' + (rez[4].indexOf('layer=c') > 0 ? 'svembed' : 'embed');
				}
			}
		},

		beforeLoad : function(opts, obj){
			var url   = obj.href || '',
				type  = false,
				what,
				item,
				rez,
				params;

			for(what in opts){
				if(opts.hasOwnProperty(what)){
					item = opts[ what ];
					rez  = url.match( item.matcher );

					if(rez){
						type   = item.type;
						params = $.extend(true, {}, item.params, obj[ what ] || ($.isPlainObject(opts[ what ]) ? opts[ what ].params : null));

						url = $.type( item.url ) === "function" ? item.url.call( this, rez, params, obj ) : format( item.url, rez, params );

						break;
					}
				}
			}

			if(type){
				obj.href = url;
				obj.type = type;

				obj.autoHeight = false;
			}
		}
	};

}(jQuery));
/*
  html2canvas 0.4.1 <http://html2canvas.hertzen.com>
  Copyright (c) 2013 Niklas von Hertzen

  Released under MIT License
*/

(function(window, document, undefined){

"use strict";

var _html2canvas = {},
previousElement,
computedCSS,
html2canvas;

_html2canvas.Util = {};

_html2canvas.Util.log = function(a){
  if(_html2canvas.logging && window.console && window.console.log){
    window.console.log(a);
  }
};

_html2canvas.Util.trimText = (function(isNative){
  return function(input){
    return isNative ? isNative.apply(input) : ((input || '') + '').replace( /^\s+|\s+$/g , '' );
  };
})(String.prototype.trim);

_html2canvas.Util.asFloat = function(v){
  return parseFloat(v);
};

(function(){
  // TODO: support all possible length values
  var TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g;
  var TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g;
  _html2canvas.Util.parseTextShadows = function (value){
    if(!value || value === 'none'){
      return [];
    }

    // find multiple shadow declarations
    var shadows = value.match(TEXT_SHADOW_PROPERTY),
      results = [];
    for(var i = 0; shadows && (i < shadows.length); i++){
      var s = shadows[i].match(TEXT_SHADOW_VALUES);
      results.push({
        color: s[0],
        offsetX: s[1] ? s[1].replace('px', '') : 0,
        offsetY: s[2] ? s[2].replace('px', '') : 0,
        blur: s[3] ? s[3].replace('px', '') : 0
      });
    }
    return results;
  };
})();


_html2canvas.Util.parseBackgroundImage = function (value){
    var whitespace = ' \r\n\t',
        method, definition, prefix, prefix_i, block, results = [],
        c, mode = 0, numParen = 0, quote, args;

    var appendResult = function(){
        if(method){
            if(definition.substr( 0, 1 ) === '"'){
                definition = definition.substr( 1, definition.length - 2 );
            }
            if(definition){
                args.push(definition);
            }
            if(method.substr( 0, 1 ) === '-' &&
                    (prefix_i = method.indexOf( '-', 1 ) + 1) > 0){
                prefix = method.substr( 0, prefix_i);
                method = method.substr( prefix_i );
            }
            results.push({
                prefix: prefix,
                method: method.toLowerCase(),
                value: block,
                args: args
            });
        }
        args = []; //for some odd reason, setting .length = 0 didn't work in safari
        method =
            prefix =
            definition =
            block = '';
    };

    appendResult();
    for(var i = 0, ii = value.length; i<ii; i++){
        c = value[i];
        if(mode === 0 && whitespace.indexOf( c ) > -1){
            continue;
        }
        switch(c){
            case '"':
                if(!quote){
                    quote = c;
                }
                else if(quote === c){
                    quote = null;
                }
                break;

            case '(':
                if(quote){ break; }
                else if(mode === 0){
                    mode = 1;
                    block += c;
                    continue;
                } else{
                    numParen++;
                }
                break;

            case ')':
                if(quote){ break; }
                else if(mode === 1){
                    if(numParen === 0){
                        mode = 0;
                        block += c;
                        appendResult();
                        continue;
                    } else{
                        numParen--;
                    }
                }
                break;

            case ',':
                if(quote){ break; }
                else if(mode === 0){
                    appendResult();
                    continue;
                }
                else if(mode === 1){
                    if(numParen === 0 && !method.match(/^url$/i)){
                        args.push(definition);
                        definition = '';
                        block += c;
                        continue;
                    }
                }
                break;
        }

        block += c;
        if(mode === 0){ method += c; }
        else{ definition += c; }
    }
    appendResult();

    return results;
};

_html2canvas.Util.Bounds = function (element){
  var clientRect, bounds = {};

  if(element.getBoundingClientRect){
    clientRect = element.getBoundingClientRect();

    // TODO add scroll position to bounds, so no scrolling of window necessary
    bounds.top = clientRect.top;
    bounds.bottom = clientRect.bottom || (clientRect.top + clientRect.height);
    bounds.left = clientRect.left;

    bounds.width = element.offsetWidth;
    bounds.height = element.offsetHeight;
  }

  return bounds;
};

// TODO ideally, we'd want everything to go through this function instead of Util.Bounds,
// but would require further work to calculate the correct positions for elements with offsetParents
_html2canvas.Util.OffsetBounds = function (element){
  var parent = element.offsetParent ? _html2canvas.Util.OffsetBounds(element.offsetParent) : {top: 0, left: 0};

  return {
    top: element.offsetTop + parent.top,
    bottom: element.offsetTop + element.offsetHeight + parent.top,
    left: element.offsetLeft + parent.left,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
};

function toPX(element, attribute, value ){
    var rsLeft = element.runtimeStyle && element.runtimeStyle[attribute],
        left,
        style = element.style;

    // Check if we are not dealing with pixels, (Opera has issues with this)
    // Ported from jQuery css.js
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels

    if( !/^-?[0-9]+\.?[0-9]*(?:px)?$/i.test( value ) && /^-?\d/.test(value) ){
        // Remember the original values
        left = style.left;

        // Put in the new values to get a computed value out
        if(rsLeft){
            element.runtimeStyle.left = element.currentStyle.left;
        }
        style.left = attribute === "fontSize" ? "1em" : (value || 0);
        value = style.pixelLeft + "px";

        // Revert the changed values
        style.left = left;
        if(rsLeft){
            element.runtimeStyle.left = rsLeft;
        }
    }

    if(!/^(thin|medium|thick)$/i.test(value)){
        return Math.round(parseFloat(value)) + "px";
    }

    return value;
}

function asInt(val){
    return parseInt(val, 10);
}

function parseBackgroundSizePosition(value, element, attribute, index){
    value = (value || '').split(',');
    value = value[index || 0] || value[0] || 'auto';
    value = _html2canvas.Util.trimText(value).split(' ');

    if(attribute === 'backgroundSize' && (!value[0] || value[0].match(/cover|contain|auto/))){
        //these values will be handled in the parent function
    } else{
        value[0] = (value[0].indexOf( "%" ) === -1) ? toPX(element, attribute + "X", value[0]) : value[0];
        if(value[1] === undefined){
            if(attribute === 'backgroundSize'){
                value[1] = 'auto';
                return value;
            } else{
                // IE 9 doesn't return double digit always
                value[1] = value[0];
            }
        }
        value[1] = (value[1].indexOf("%") === -1) ? toPX(element, attribute + "Y", value[1]) : value[1];
    }
    return value;
}

_html2canvas.Util.getCSS = function (element, attribute, index){
    if(previousElement !== element){
      computedCSS = document.defaultView.getComputedStyle(element, null);
    }

    var value = computedCSS[attribute];

    if(/^background(Size|Position)$/.test(attribute)){
        return parseBackgroundSizePosition(value, element, attribute, index);
    } else if(/border(Top|Bottom)(Left|Right)Radius/.test(attribute)){
      var arr = value.split(" ");
      if(arr.length <= 1){
          arr[1] = arr[0];
      }
      return arr.map(asInt);
    }

  return value;
};

_html2canvas.Util.resizeBounds = function( current_width, current_height, target_width, target_height, stretch_mode ){
  var target_ratio = target_width / target_height,
    current_ratio = current_width / current_height,
    output_width, output_height;

  if(!stretch_mode || stretch_mode === 'auto'){
    output_width = target_width;
    output_height = target_height;
  } else if(target_ratio < current_ratio ^ stretch_mode === 'contain'){
    output_height = target_height;
    output_width = target_height * current_ratio;
  } else{
    output_width = target_width;
    output_height = target_width / current_ratio;
  }

  return {
    width: output_width,
    height: output_height
  };
};

function backgroundBoundsFactory( prop, el, bounds, image, imageIndex, backgroundSize ){
    var bgposition =  _html2canvas.Util.getCSS( el, prop, imageIndex ) ,
    topPos,
    left,
    percentage,
    val;

    if(bgposition.length === 1){
      val = bgposition[0];

      bgposition = [];

      bgposition[0] = val;
      bgposition[1] = val;
    }

    if(bgposition[0].toString().indexOf("%") !== -1){
      percentage = (parseFloat(bgposition[0])/100);
      left = bounds.width * percentage;
      if(prop !== 'backgroundSize'){
        left -= (backgroundSize || image).width*percentage;
      }
    } else{
      if(prop === 'backgroundSize'){
        if(bgposition[0] === 'auto'){
          left = image.width;
        } else{
          if(/contain|cover/.test(bgposition[0])){
            var resized = _html2canvas.Util.resizeBounds(image.width, image.height, bounds.width, bounds.height, bgposition[0]);
            left = resized.width;
            topPos = resized.height;
          } else{
            left = parseInt(bgposition[0], 10);
          }
        }
      } else{
        left = parseInt( bgposition[0], 10);
      }
    }


    if(bgposition[1] === 'auto'){
      topPos = left / image.width * image.height;
    } else if(bgposition[1].toString().indexOf("%") !== -1){
      percentage = (parseFloat(bgposition[1])/100);
      topPos =  bounds.height * percentage;
      if(prop !== 'backgroundSize'){
        topPos -= (backgroundSize || image).height * percentage;
      }

    } else{
      topPos = parseInt(bgposition[1],10);
    }

    return [left, topPos];
}

_html2canvas.Util.BackgroundPosition = function( el, bounds, image, imageIndex, backgroundSize ){
    var result = backgroundBoundsFactory( 'backgroundPosition', el, bounds, image, imageIndex, backgroundSize );
    return { left: result[0], top: result[1] };
};

_html2canvas.Util.BackgroundSize = function( el, bounds, image, imageIndex ){
    var result = backgroundBoundsFactory( 'backgroundSize', el, bounds, image, imageIndex );
    return { width: result[0], height: result[1] };
};

_html2canvas.Util.Extend = function (options, defaults){
  for(var key in options){
    if(options.hasOwnProperty(key)){
      defaults[key] = options[key];
    }
  }
  return defaults;
};


/*
 * Derived from jQuery.contents()
 * Copyright 2010, John Resig
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 */
_html2canvas.Util.Children = function( elem ){
  var children;
  try {
    children = (elem.nodeName && elem.nodeName.toUpperCase() === "IFRAME") ? elem.contentDocument || elem.contentWindow.document : (function(array){
      var ret = [];
      if(array !== null){
        (function(first, second ){
          var i = first.length,
          j = 0;

          if(typeof second.length === "number"){
            for(var l = second.length; j < l; j++){
              first[i++] = second[j];
            }
          } else{
            while (second[j] !== undefined){
              first[i++] = second[j++];
            }
          }

          first.length = i;

          return first;
        })(ret, array);
      }
      return ret;
    })(elem.childNodes);

  } catch (ex){
    _html2canvas.Util.log("html2canvas.Util.Children failed with exception: " + ex.message);
    children = [];
  }
  return children;
};

_html2canvas.Util.isTransparent = function(backgroundColor){
  return (backgroundColor === "transparent" || backgroundColor === "rgba(0, 0, 0, 0)");
};
_html2canvas.Util.Font = (function (){

  var fontData = {};

  return function(font, fontSize, doc){
    if(fontData[font + "-" + fontSize] !== undefined){
      return fontData[font + "-" + fontSize];
    }

    var container = doc.createElement('div'),
    img = doc.createElement('img'),
    span = doc.createElement('span'),
    sampleText = 'Hidden Text',
    baseline,
    middle,
    metricsObj;

    container.style.visibility = "hidden";
    container.style.fontFamily = font;
    container.style.fontSize = fontSize;
    container.style.margin = 0;
    container.style.padding = 0;

    doc.body.appendChild(container);

    // http://probablyprogramming.com/2009/03/15/the-tiniest-gif-ever(handtinywhite.gif)
    img.src = "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACwAAAAAAQABAAACAkQBADs=";
    img.width = 1;
    img.height = 1;

    img.style.margin = 0;
    img.style.padding = 0;
    img.style.verticalAlign = "baseline";

    span.style.fontFamily = font;
    span.style.fontSize = fontSize;
    span.style.margin = 0;
    span.style.padding = 0;

    span.appendChild(doc.createTextNode(sampleText));
    container.appendChild(span);
    container.appendChild(img);
    baseline = (img.offsetTop - span.offsetTop) + 1;

    container.removeChild(span);
    container.appendChild(doc.createTextNode(sampleText));

    container.style.lineHeight = "normal";
    img.style.verticalAlign = "super";

    middle = (img.offsetTop-container.offsetTop) + 1;
    metricsObj = {
      baseline: baseline,
      lineWidth: 1,
      middle: middle
    };

    fontData[font + "-" + fontSize] = metricsObj;

    doc.body.removeChild(container);

    return metricsObj;
  };
})();

(function(){
  var Util = _html2canvas.Util,
    Generate = {};

  _html2canvas.Generate = Generate;

  var reGradients = [
  /^(-webkit-linear-gradient)\(([a-z\s]+)([\w\d\.\s,%\(\)]+)\)$/,
  /^(-o-linear-gradient)\(([a-z\s]+)([\w\d\.\s,%\(\)]+)\)$/,
  /^(-webkit-gradient)\((linear|radial),\s((?:\d{1,3}%?)\s(?:\d{1,3}%?),\s(?:\d{1,3}%?)\s(?:\d{1,3}%?))([\w\d\.\s,%\(\)\-]+)\)$/,
  /^(-moz-linear-gradient)\(((?:\d{1,3}%?)\s(?:\d{1,3}%?))([\w\d\.\s,%\(\)]+)\)$/,
  /^(-webkit-radial-gradient)\(((?:\d{1,3}%?)\s(?:\d{1,3}%?)),\s(\w+)\s([a-z\-]+)([\w\d\.\s,%\(\)]+)\)$/,
  /^(-moz-radial-gradient)\(((?:\d{1,3}%?)\s(?:\d{1,3}%?)),\s(\w+)\s?([a-z\-]*)([\w\d\.\s,%\(\)]+)\)$/,
  /^(-o-radial-gradient)\(((?:\d{1,3}%?)\s(?:\d{1,3}%?)),\s(\w+)\s([a-z\-]+)([\w\d\.\s,%\(\)]+)\)$/
  ];

  /*
 * TODO: Add IE10 vendor prefix (-ms) support
 * TODO: Add W3C gradient (linear-gradient) support
 * TODO: Add old Webkit -webkit-gradient(radial, ...) support
 * TODO: Maybe some RegExp optimizations are possible ;o)
 */
  Generate.parseGradient = function(css, bounds){
    var gradient, i, len = reGradients.length, m1, stop, m2, m2Len, step, m3, tl,tr,br,bl;

    for(i = 0; i < len; i+=1){
      m1 = css.match(reGradients[i]);
      if(m1){
        break;
      }
    }

    if(m1){
      switch(m1[1]){
        case '-webkit-linear-gradient':
        case '-o-linear-gradient':

          gradient = {
            type: 'linear',
            x0: null,
            y0: null,
            x1: null,
            y1: null,
            colorStops: []
          };

          // get coordinates
          m2 = m1[2].match(/\w+/g);
          if(m2){
            m2Len = m2.length;
            for(i = 0; i < m2Len; i+=1){
              switch(m2[i]){
                case 'top':
                  gradient.y0 = 0;
                  gradient.y1 = bounds.height;
                  break;

                case 'right':
                  gradient.x0 = bounds.width;
                  gradient.x1 = 0;
                  break;

                case 'bottom':
                  gradient.y0 = bounds.height;
                  gradient.y1 = 0;
                  break;

                case 'left':
                  gradient.x0 = 0;
                  gradient.x1 = bounds.width;
                  break;
              }
            }
          }
          if(gradient.x0 === null && gradient.x1 === null){ // center
            gradient.x0 = gradient.x1 = bounds.width / 2;
          }
          if(gradient.y0 === null && gradient.y1 === null){ // center
            gradient.y0 = gradient.y1 = bounds.height / 2;
          }

          // get colors and stops
          m2 = m1[3].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\)(?:\s\d{1,3}(?:%|px))?)+/g);
          if(m2){
            m2Len = m2.length;
            step = 1 / Math.max(m2Len - 1, 1);
            for(i = 0; i < m2Len; i+=1){
              m3 = m2[i].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\))\s*(\d{1,3})?(%|px)?/);
              if(m3[2]){
                stop = parseFloat(m3[2]);
                if(m3[3] === '%'){
                  stop /= 100;
                } else{ // px - stupid opera
                  stop /= bounds.width;
                }
              } else{
                stop = i * step;
              }
              gradient.colorStops.push({
                color: m3[1],
                stop: stop
              });
            }
          }
          break;

        case '-webkit-gradient':

          gradient = {
            type: m1[2] === 'radial' ? 'circle' : m1[2], // TODO: Add radial gradient support for older mozilla definitions
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            colorStops: []
          };

          // get coordinates
          m2 = m1[3].match(/(\d{1,3})%?\s(\d{1,3})%?,\s(\d{1,3})%?\s(\d{1,3})%?/);
          if(m2){
            gradient.x0 = (m2[1] * bounds.width) / 100;
            gradient.y0 = (m2[2] * bounds.height) / 100;
            gradient.x1 = (m2[3] * bounds.width) / 100;
            gradient.y1 = (m2[4] * bounds.height) / 100;
          }

          // get colors and stops
          m2 = m1[4].match(/((?:from|to|color-stop)\((?:[0-9\.]+,\s)?(?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\)\))+/g);
          if(m2){
            m2Len = m2.length;
            for(i = 0; i < m2Len; i+=1){
              m3 = m2[i].match(/(from|to|color-stop)\(([0-9\.]+)?(?:,\s)?((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\))\)/);
              stop = parseFloat(m3[2]);
              if(m3[1] === 'from'){
                stop = 0.0;
              }
              if(m3[1] === 'to'){
                stop = 1.0;
              }
              gradient.colorStops.push({
                color: m3[3],
                stop: stop
              });
            }
          }
          break;

        case '-moz-linear-gradient':

          gradient = {
            type: 'linear',
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            colorStops: []
          };

          // get coordinates
          m2 = m1[2].match(/(\d{1,3})%?\s(\d{1,3})%?/);

          // m2[1] == 0%   -> left
          // m2[1] == 50%  -> center
          // m2[1] == 100% -> right

          // m2[2] == 0%   -> top
          // m2[2] == 50%  -> center
          // m2[2] == 100% -> bottom

          if(m2){
            gradient.x0 = (m2[1] * bounds.width) / 100;
            gradient.y0 = (m2[2] * bounds.height) / 100;
            gradient.x1 = bounds.width - gradient.x0;
            gradient.y1 = bounds.height - gradient.y0;
          }

          // get colors and stops
          m2 = m1[3].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\)(?:\s\d{1,3}%)?)+/g);
          if(m2){
            m2Len = m2.length;
            step = 1 / Math.max(m2Len - 1, 1);
            for(i = 0; i < m2Len; i+=1){
              m3 = m2[i].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\))\s*(\d{1,3})?(%)?/);
              if(m3[2]){
                stop = parseFloat(m3[2]);
                if(m3[3]){ // percentage
                  stop /= 100;
                }
              } else{
                stop = i * step;
              }
              gradient.colorStops.push({
                color: m3[1],
                stop: stop
              });
            }
          }
          break;

        case '-webkit-radial-gradient':
        case '-moz-radial-gradient':
        case '-o-radial-gradient':

          gradient = {
            type: 'circle',
            x0: 0,
            y0: 0,
            x1: bounds.width,
            y1: bounds.height,
            cx: 0,
            cy: 0,
            rx: 0,
            ry: 0,
            colorStops: []
          };

          // center
          m2 = m1[2].match(/(\d{1,3})%?\s(\d{1,3})%?/);
          if(m2){
            gradient.cx = (m2[1] * bounds.width) / 100;
            gradient.cy = (m2[2] * bounds.height) / 100;
          }

          // size
          m2 = m1[3].match(/\w+/);
          m3 = m1[4].match(/[a-z\-]*/);
          if(m2 && m3){
            switch(m3[0]){
              case 'farthest-corner':
              case 'cover': // is equivalent to farthest-corner
              case '': // mozilla removes "cover" from definition :(
                tl = Math.sqrt(Math.pow(gradient.cx, 2) + Math.pow(gradient.cy, 2));
                tr = Math.sqrt(Math.pow(gradient.cx, 2) + Math.pow(gradient.y1 - gradient.cy, 2));
                br = Math.sqrt(Math.pow(gradient.x1 - gradient.cx, 2) + Math.pow(gradient.y1 - gradient.cy, 2));
                bl = Math.sqrt(Math.pow(gradient.x1 - gradient.cx, 2) + Math.pow(gradient.cy, 2));
                gradient.rx = gradient.ry = Math.max(tl, tr, br, bl);
                break;
              case 'closest-corner':
                tl = Math.sqrt(Math.pow(gradient.cx, 2) + Math.pow(gradient.cy, 2));
                tr = Math.sqrt(Math.pow(gradient.cx, 2) + Math.pow(gradient.y1 - gradient.cy, 2));
                br = Math.sqrt(Math.pow(gradient.x1 - gradient.cx, 2) + Math.pow(gradient.y1 - gradient.cy, 2));
                bl = Math.sqrt(Math.pow(gradient.x1 - gradient.cx, 2) + Math.pow(gradient.cy, 2));
                gradient.rx = gradient.ry = Math.min(tl, tr, br, bl);
                break;
              case 'farthest-side':
                if(m2[0] === 'circle'){
                  gradient.rx = gradient.ry = Math.max(
                    gradient.cx,
                    gradient.cy,
                    gradient.x1 - gradient.cx,
                    gradient.y1 - gradient.cy
                    );
                } else{ // ellipse

                  gradient.type = m2[0];

                  gradient.rx = Math.max(
                    gradient.cx,
                    gradient.x1 - gradient.cx
                    );
                  gradient.ry = Math.max(
                    gradient.cy,
                    gradient.y1 - gradient.cy
                    );
                }
                break;
              case 'closest-side':
              case 'contain': // is equivalent to closest-side
                if(m2[0] === 'circle'){
                  gradient.rx = gradient.ry = Math.min(
                    gradient.cx,
                    gradient.cy,
                    gradient.x1 - gradient.cx,
                    gradient.y1 - gradient.cy
                    );
                } else{ // ellipse

                  gradient.type = m2[0];

                  gradient.rx = Math.min(
                    gradient.cx,
                    gradient.x1 - gradient.cx
                    );
                  gradient.ry = Math.min(
                    gradient.cy,
                    gradient.y1 - gradient.cy
                    );
                }
                break;

            // TODO: add support for "30px 40px" sizes (webkit only)
            }
          }

          // color stops
          m2 = m1[5].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\)(?:\s\d{1,3}(?:%|px))?)+/g);
          if(m2){
            m2Len = m2.length;
            step = 1 / Math.max(m2Len - 1, 1);
            for(i = 0; i < m2Len; i+=1){
              m3 = m2[i].match(/((?:rgb|rgba)\(\d{1,3},\s\d{1,3},\s\d{1,3}(?:,\s[0-9\.]+)?\))\s*(\d{1,3})?(%|px)?/);
              if(m3[2]){
                stop = parseFloat(m3[2]);
                if(m3[3] === '%'){
                  stop /= 100;
                } else{ // px - stupid opera
                  stop /= bounds.width;
                }
              } else{
                stop = i * step;
              }
              gradient.colorStops.push({
                color: m3[1],
                stop: stop
              });
            }
          }
          break;
      }
    }

    return gradient;
  };

  function addScrollStops(grad){
    return function(colorStop){
      try {
        grad.addColorStop(colorStop.stop, colorStop.color);
      }
      catch(e){
        Util.log(['failed to add color stop: ', e, '; tried to add: ', colorStop]);
      }
    };
  }

  Generate.Gradient = function(src, bounds){
    if(bounds.width === 0 || bounds.height === 0){
      return;
    }

    var canvas = document.createElement('canvas'),
    ctx = canvas.getContext('2d'),
    gradient, grad;

    canvas.width = bounds.width;
    canvas.height = bounds.height;

    // TODO: add support for multi defined background gradients
    gradient = _html2canvas.Generate.parseGradient(src, bounds);

    if(gradient){
      switch(gradient.type){
        case 'linear':
          grad = ctx.createLinearGradient(gradient.x0, gradient.y0, gradient.x1, gradient.y1);
          gradient.colorStops.forEach(addScrollStops(grad));
          ctx.fillStyle = grad;
          ctx.fillRect(0, 0, bounds.width, bounds.height);
          break;

        case 'circle':
          grad = ctx.createRadialGradient(gradient.cx, gradient.cy, 0, gradient.cx, gradient.cy, gradient.rx);
          gradient.colorStops.forEach(addScrollStops(grad));
          ctx.fillStyle = grad;
          ctx.fillRect(0, 0, bounds.width, bounds.height);
          break;

        case 'ellipse':
          var canvasRadial = document.createElement('canvas'),
            ctxRadial = canvasRadial.getContext('2d'),
            ri = Math.max(gradient.rx, gradient.ry),
            di = ri * 2;

          canvasRadial.width = canvasRadial.height = di;

          grad = ctxRadial.createRadialGradient(gradient.rx, gradient.ry, 0, gradient.rx, gradient.ry, ri);
          gradient.colorStops.forEach(addScrollStops(grad));

          ctxRadial.fillStyle = grad;
          ctxRadial.fillRect(0, 0, di, di);

          ctx.fillStyle = gradient.colorStops[gradient.colorStops.length - 1].color;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(canvasRadial, gradient.cx - gradient.rx, gradient.cy - gradient.ry, 2 * gradient.rx, 2 * gradient.ry);
          break;
      }
    }

    return canvas;
  };

  Generate.ListAlpha = function(number){
    var tmp = "",
    modulus;

    do {
      modulus = number % 26;
      tmp = String.fromCharCode((modulus) + 64) + tmp;
      number = number / 26;
    }while((number*26) > 26);

    return tmp;
  };

  Generate.ListRoman = function(number){
    var romanArray = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"],
    decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
    roman = "",
    v,
    len = romanArray.length;

    if(number <= 0 || number >= 4000){
      return number;
    }

    for(v=0; v < len; v+=1){
      while (number >= decimal[v]){
        number -= decimal[v];
        roman += romanArray[v];
      }
    }

    return roman;
  };
})();
function h2cRenderContext(width, height){
  var storage = [];
  return {
    storage: storage,
    width: width,
    height: height,
    clip: function(){
      storage.push({
        type: "function",
        name: "clip",
        'arguments': arguments
      });
    },
    translate: function(){
      storage.push({
        type: "function",
        name: "translate",
        'arguments': arguments
      });
    },
    fill: function(){
      storage.push({
        type: "function",
        name: "fill",
        'arguments': arguments
      });
    },
    save: function(){
      storage.push({
        type: "function",
        name: "save",
        'arguments': arguments
      });
    },
    restore: function(){
      storage.push({
        type: "function",
        name: "restore",
        'arguments': arguments
      });
    },
    fillRect: function (){
      storage.push({
        type: "function",
        name: "fillRect",
        'arguments': arguments
      });
    },
    createPattern: function(){
      storage.push({
        type: "function",
        name: "createPattern",
        'arguments': arguments
      });
    },
    drawShape: function(){

      var shape = [];

      storage.push({
        type: "function",
        name: "drawShape",
        'arguments': shape
      });

      return {
        moveTo: function(){
          shape.push({
            name: "moveTo",
            'arguments': arguments
          });
        },
        lineTo: function(){
          shape.push({
            name: "lineTo",
            'arguments': arguments
          });
        },
        arcTo: function(){
          shape.push({
            name: "arcTo",
            'arguments': arguments
          });
        },
        bezierCurveTo: function(){
          shape.push({
            name: "bezierCurveTo",
            'arguments': arguments
          });
        },
        quadraticCurveTo: function(){
          shape.push({
            name: "quadraticCurveTo",
            'arguments': arguments
          });
        }
      };

    },
    drawImage: function (){
      storage.push({
        type: "function",
        name: "drawImage",
        'arguments': arguments
      });
    },
    fillText: function (){
      storage.push({
        type: "function",
        name: "fillText",
        'arguments': arguments
      });
    },
    setVariable: function (variable, value){
      storage.push({
        type: "variable",
        name: variable,
        'arguments': value
      });
      return value;
    }
  };
}
_html2canvas.Parse = function (images, options){
  window.scroll(0,0);

  var element = (( options.elements === undefined ) ? document.body : options.elements[0]), // select body by default
  numDraws = 0,
  doc = element.ownerDocument,
  Util = _html2canvas.Util,
  support = Util.Support(options, doc),
  ignoreElementsRegExp = new RegExp("(" + options.ignoreElements + ")"),
  body = doc.body,
  getCSS = Util.getCSS,
  pseudoHide = "___html2canvas___pseudoelement",
  hidePseudoElements = doc.createElement('style');

  hidePseudoElements.innerHTML = '.' + pseudoHide + '-before:before { content: "" !important; display: none !important; }' +
  '.' + pseudoHide + '-after:after { content: "" !important; display: none !important; }';

  body.appendChild(hidePseudoElements);

  images = images || {};

  function documentWidth (){
    return Math.max(
      Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth),
      Math.max(doc.body.offsetWidth, doc.documentElement.offsetWidth),
      Math.max(doc.body.clientWidth, doc.documentElement.clientWidth)
      );
  }

  function documentHeight (){
    return Math.max(
      Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
      Math.max(doc.body.offsetHeight, doc.documentElement.offsetHeight),
      Math.max(doc.body.clientHeight, doc.documentElement.clientHeight)
      );
  }

  function getCSSInt(element, attribute){
    var val = parseInt(getCSS(element, attribute), 10);
    return (isNaN(val)) ? 0 : val; // borders in old IE are throwing 'medium' for demo.html
  }

  function renderRect (ctx, x, y, w, h, bgcolor){
    if(bgcolor !== "transparent"){
      ctx.setVariable("fillStyle", bgcolor);
      ctx.fillRect(x, y, w, h);
      numDraws+=1;
    }
  }

  function capitalize(m, p1, p2){
    if(m.length > 0){
      return p1 + p2.toUpperCase();
    }
  }

  function textTransform (text, transform){
    switch(transform){
      case "lowercase":
        return text.toLowerCase();
      case "capitalize":
        return text.replace( /(^|\s|:|-|\(|\))([a-z])/g, capitalize);
      case "uppercase":
        return text.toUpperCase();
      default:
        return text;
    }
  }

  function noLetterSpacing(letter_spacing){
    return (/^(normal|none|0px)$/.test(letter_spacing));
  }

  function drawText(currentText, x, y, ctx){
    if(currentText !== null && Util.trimText(currentText).length > 0){
      ctx.fillText(currentText, x, y);
      numDraws+=1;
    }
  }

  function setTextVariables(ctx, el, text_decoration, color){
    var align = false,
    bold = getCSS(el, "fontWeight"),
    family = getCSS(el, "fontFamily"),
    size = getCSS(el, "fontSize"),
    shadows = Util.parseTextShadows(getCSS(el, "textShadow"));

    switch(parseInt(bold, 10)){
      case 401:
        bold = "bold";
        break;
      case 400:
        bold = "normal";
        break;
    }

    ctx.setVariable("fillStyle", color);
    ctx.setVariable("font", [getCSS(el, "fontStyle"), getCSS(el, "fontVariant"), bold, size, family].join(" "));
    ctx.setVariable("textAlign", (align) ? "right" : "left");

    if(shadows.length){
      // TODO: support multiple text shadows
      // apply the first text shadow
      ctx.setVariable("shadowColor", shadows[0].color);
      ctx.setVariable("shadowOffsetX", shadows[0].offsetX);
      ctx.setVariable("shadowOffsetY", shadows[0].offsetY);
      ctx.setVariable("shadowBlur", shadows[0].blur);
    }

    if(text_decoration !== "none"){
      return Util.Font(family, size, doc);
    }
  }

  function renderTextDecoration(ctx, text_decoration, bounds, metrics, color){
    switch(text_decoration){
      case "underline":
        // Draws a line at the baseline of the font
        // TODO As some browsers display the line as more than 1px if the font-size is big, need to take that into account both in position and size
        renderRect(ctx, bounds.left, Math.round(bounds.top + metrics.baseline + metrics.lineWidth), bounds.width, 1, color);
        break;
      case "overline":
        renderRect(ctx, bounds.left, Math.round(bounds.top), bounds.width, 1, color);
        break;
      case "line-through":
        // TODO try and find exact position for line-through
        renderRect(ctx, bounds.left, Math.ceil(bounds.top + metrics.middle + metrics.lineWidth), bounds.width, 1, color);
        break;
    }
  }

  function getTextBounds(state, text, textDecoration, isLast, transform){
    var bounds;
    if(support.rangeBounds && !transform){
      if(textDecoration !== "none" || Util.trimText(text).length !== 0){
        bounds = textRangeBounds(text, state.node, state.textOffset);
      }
      state.textOffset += text.length;
    } else if(state.node && typeof state.node.nodeValue === "string" ){
      var newTextNode = (isLast) ? state.node.splitText(text.length) : null;
      bounds = textWrapperBounds(state.node, transform);
      state.node = newTextNode;
    }
    return bounds;
  }

  function textRangeBounds(text, textNode, textOffset){
    var range = doc.createRange();
    range.setStart(textNode, textOffset);
    range.setEnd(textNode, textOffset + text.length);
    return range.getBoundingClientRect();
  }

  function textWrapperBounds(oldTextNode, transform){
    var parent = oldTextNode.parentNode,
    wrapElement = doc.createElement('wrapper'),
    backupText = oldTextNode.cloneNode(true);

    wrapElement.appendChild(oldTextNode.cloneNode(true));
    parent.replaceChild(wrapElement, oldTextNode);

    var bounds = transform ? Util.OffsetBounds(wrapElement) : Util.Bounds(wrapElement);
    parent.replaceChild(backupText, wrapElement);
    return bounds;
  }

  function renderText(el, textNode, stack){
    var ctx = stack.ctx,
    color = getCSS(el, "color"),
    textDecoration = getCSS(el, "textDecoration"),
    textAlign = getCSS(el, "textAlign"),
    metrics,
    textList,
    state = {
      node: textNode,
      textOffset: 0
    };

    if(Util.trimText(textNode.nodeValue).length > 0){
      textNode.nodeValue = textTransform(textNode.nodeValue, getCSS(el, "textTransform"));
      textAlign = textAlign.replace(["-webkit-auto"],["auto"]);

      textList = (!options.letterRendering && /^(left|right|justify|auto)$/.test(textAlign) && noLetterSpacing(getCSS(el, "letterSpacing"))) ?
      textNode.nodeValue.split(/(\b| )/)
      : textNode.nodeValue.split("");

      metrics = setTextVariables(ctx, el, textDecoration, color);

      if(options.chinese){
        textList.forEach(function(word, index){
          if(/.*[\u4E00-\u9FA5].*$/.test(word)){
            word = word.split("");
            word.unshift(index, 1);
            textList.splice.apply(textList, word);
          }
        });
      }

      textList.forEach(function(text, index){
        var bounds = getTextBounds(state, text, textDecoration, (index < textList.length - 1), stack.transform.matrix);
        if(bounds){
          drawText(text, bounds.left, bounds.bottom, ctx);
          renderTextDecoration(ctx, textDecoration, bounds, metrics, color);
        }
      });
    }
  }

  function listPosition (element, val){
    var boundElement = doc.createElement( "boundelement" ),
    originalType,
    bounds;

    boundElement.style.display = "inline";

    originalType = element.style.listStyleType;
    element.style.listStyleType = "none";

    boundElement.appendChild(doc.createTextNode(val));

    element.insertBefore(boundElement, element.firstChild);

    bounds = Util.Bounds(boundElement);
    element.removeChild(boundElement);
    element.style.listStyleType = originalType;
    return bounds;
  }

  function elementIndex(el){
    var i = -1,
    count = 1,
    childs = el.parentNode.childNodes;

    if(el.parentNode){
      while(childs[++i] !== el){
        if(childs[i].nodeType === 1){
          count++;
        }
      }
      return count;
    } else{
      return -1;
    }
  }

  function listItemText(element, type){
    var currentIndex = elementIndex(element), text;
    switch(type){
      case "decimal":
        text = currentIndex;
        break;
      case "decimal-leading-zero":
        text = (currentIndex.toString().length === 1) ? currentIndex = "0" + currentIndex.toString() : currentIndex.toString();
        break;
      case "upper-roman":
        text = _html2canvas.Generate.ListRoman( currentIndex );
        break;
      case "lower-roman":
        text = _html2canvas.Generate.ListRoman( currentIndex ).toLowerCase();
        break;
      case "lower-alpha":
        text = _html2canvas.Generate.ListAlpha( currentIndex ).toLowerCase();
        break;
      case "upper-alpha":
        text = _html2canvas.Generate.ListAlpha( currentIndex );
        break;
    }

    return text + ". ";
  }

  function renderListItem(element, stack, elBounds){
    var x,
    text,
    ctx = stack.ctx,
    type = getCSS(element, "listStyleType"),
    listBounds;

    if(/^(decimal|decimal-leading-zero|upper-alpha|upper-latin|upper-roman|lower-alpha|lower-greek|lower-latin|lower-roman)$/i.test(type)){
      text = listItemText(element, type);
      listBounds = listPosition(element, text);
      setTextVariables(ctx, element, "none", getCSS(element, "color"));

      if(getCSS(element, "listStylePosition") === "inside"){
        ctx.setVariable("textAlign", "left");
        x = elBounds.left;
      } else{
        return;
      }

      drawText(text, x, listBounds.bottom, ctx);
    }
  }

  function loadImage (src){
    var img = images[src];
    return (img && img.succeeded === true) ? img.img : false;
  }

  function clipBounds(src, dst){
    var x = Math.max(src.left, dst.left),
    y = Math.max(src.top, dst.top),
    x2 = Math.min((src.left + src.width), (dst.left + dst.width)),
    y2 = Math.min((src.top + src.height), (dst.top + dst.height));

    return {
      left:x,
      top:y,
      width:x2-x,
      height:y2-y
    };
  }

  function setZ(element, stack, parentStack){
    var newContext,
    isPositioned = stack.cssPosition !== 'static',
    zIndex = isPositioned ? getCSS(element, 'zIndex') : 'auto',
    opacity = getCSS(element, 'opacity'),
    isFloated = getCSS(element, 'cssFloat') !== 'none';

    // https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
    // When a new stacking context should be created:
    // the root element (HTML),
    // positioned (absolutely or relatively) with a z-index value other than "auto",
    // elements with an opacity value less than 1. (See the specification for opacity),
    // on mobile WebKit and Chrome 22+, position: fixed always creates a new stacking context, even when z-index is "auto" (See this post)

    stack.zIndex = newContext = h2czContext(zIndex);
    newContext.isPositioned = isPositioned;
    newContext.isFloated = isFloated;
    newContext.opacity = opacity;
    newContext.ownStacking = (zIndex !== 'auto' || opacity < 1);

    if(parentStack){
      parentStack.zIndex.children.push(stack);
    }
  }

  function renderImage(ctx, element, image, bounds, borders){

    var paddingLeft = getCSSInt(element, 'paddingLeft'),
    paddingTop = getCSSInt(element, 'paddingTop'),
    paddingRight = getCSSInt(element, 'paddingRight'),
    paddingBottom = getCSSInt(element, 'paddingBottom');

    drawImage(
      ctx,
      image,
      0, //sx
      0, //sy
      image.width, //sw
      image.height, //sh
      bounds.left + paddingLeft + borders[3].width, //dx
      bounds.top + paddingTop + borders[0].width, // dy
      bounds.width - (borders[1].width + borders[3].width + paddingLeft + paddingRight), //dw
      bounds.height - (borders[0].width + borders[2].width + paddingTop + paddingBottom) //dh
      );
  }

  function getBorderData(element){
    return ["Top", "Right", "Bottom", "Left"].map(function(side){
      return {
        width: getCSSInt(element, 'border' + side + 'Width'),
        color: getCSS(element, 'border' + side + 'Color')
      };
    });
  }

  function getBorderRadiusData(element){
    return ["TopLeft", "TopRight", "BottomRight", "BottomLeft"].map(function(side){
      return getCSS(element, 'border' + side + 'Radius');
    });
  }

  var getCurvePoints = (function(kappa){

    return function(x, y, r1, r2){
      var ox = (r1) * kappa, // control point offset horizontal
      oy = (r2) * kappa, // control point offset vertical
      xm = x + r1, // x-middle
      ym = y + r2; // y-middle
      return {
        topLeft: bezierCurve({
          x:x,
          y:ym
        }, {
          x:x,
          y:ym - oy
        }, {
          x:xm - ox,
          y:y
        }, {
          x:xm,
          y:y
        }),
        topRight: bezierCurve({
          x:x,
          y:y
        }, {
          x:x + ox,
          y:y
        }, {
          x:xm,
          y:ym - oy
        }, {
          x:xm,
          y:ym
        }),
        bottomRight: bezierCurve({
          x:xm,
          y:y
        }, {
          x:xm,
          y:y + oy
        }, {
          x:x + ox,
          y:ym
        }, {
          x:x,
          y:ym
        }),
        bottomLeft: bezierCurve({
          x:xm,
          y:ym
        }, {
          x:xm - ox,
          y:ym
        }, {
          x:x,
          y:y + oy
        }, {
          x:x,
          y:y
        })
      };
    };
  })(4 * ((Math.sqrt(2) - 1) / 3));

  function bezierCurve(start, startControl, endControl, end){

    var lerp = function (a, b, t){
      return {
        x:a.x + (b.x - a.x) * t,
        y:a.y + (b.y - a.y) * t
      };
    };

    return {
      start: start,
      startControl: startControl,
      endControl: endControl,
      end: end,
      subdivide: function(t){
        var ab = lerp(start, startControl, t),
        bc = lerp(startControl, endControl, t),
        cd = lerp(endControl, end, t),
        abbc = lerp(ab, bc, t),
        bccd = lerp(bc, cd, t),
        dest = lerp(abbc, bccd, t);
        return [bezierCurve(start, ab, abbc, dest), bezierCurve(dest, bccd, cd, end)];
      },
      curveTo: function(borderArgs){
        borderArgs.push(["bezierCurve", startControl.x, startControl.y, endControl.x, endControl.y, end.x, end.y]);
      },
      curveToReversed: function(borderArgs){
        borderArgs.push(["bezierCurve", endControl.x, endControl.y, startControl.x, startControl.y, start.x, start.y]);
      }
    };
  }

  function parseCorner(borderArgs, radius1, radius2, corner1, corner2, x, y){
    if(radius1[0] > 0 || radius1[1] > 0){
      borderArgs.push(["line", corner1[0].start.x, corner1[0].start.y]);
      corner1[0].curveTo(borderArgs);
      corner1[1].curveTo(borderArgs);
    } else{
      borderArgs.push(["line", x, y]);
    }

    if(radius2[0] > 0 || radius2[1] > 0){
      borderArgs.push(["line", corner2[0].start.x, corner2[0].start.y]);
    }
  }

  function drawSide(borderData, radius1, radius2, outer1, inner1, outer2, inner2){
    var borderArgs = [];

    if(radius1[0] > 0 || radius1[1] > 0){
      borderArgs.push(["line", outer1[1].start.x, outer1[1].start.y]);
      outer1[1].curveTo(borderArgs);
    } else{
      borderArgs.push([ "line", borderData.c1[0], borderData.c1[1]]);
    }

    if(radius2[0] > 0 || radius2[1] > 0){
      borderArgs.push(["line", outer2[0].start.x, outer2[0].start.y]);
      outer2[0].curveTo(borderArgs);
      borderArgs.push(["line", inner2[0].end.x, inner2[0].end.y]);
      inner2[0].curveToReversed(borderArgs);
    } else{
      borderArgs.push([ "line", borderData.c2[0], borderData.c2[1]]);
      borderArgs.push([ "line", borderData.c3[0], borderData.c3[1]]);
    }

    if(radius1[0] > 0 || radius1[1] > 0){
      borderArgs.push(["line", inner1[1].end.x, inner1[1].end.y]);
      inner1[1].curveToReversed(borderArgs);
    } else{
      borderArgs.push([ "line", borderData.c4[0], borderData.c4[1]]);
    }

    return borderArgs;
  }

  function calculateCurvePoints(bounds, borderRadius, borders){

    var x = bounds.left,
    y = bounds.top,
    width = bounds.width,
    height = bounds.height,

    tlh = borderRadius[0][0],
    tlv = borderRadius[0][1],
    trh = borderRadius[1][0],
    trv = borderRadius[1][1],
    brh = borderRadius[2][0],
    brv = borderRadius[2][1],
    blh = borderRadius[3][0],
    blv = borderRadius[3][1],

    topWidth = width - trh,
    rightHeight = height - brv,
    bottomWidth = width - brh,
    leftHeight = height - blv;

    return {
      topLeftOuter: getCurvePoints(
        x,
        y,
        tlh,
        tlv
        ).topLeft.subdivide(0.5),

      topLeftInner: getCurvePoints(
        x + borders[3].width,
        y + borders[0].width,
        Math.max(0, tlh - borders[3].width),
        Math.max(0, tlv - borders[0].width)
        ).topLeft.subdivide(0.5),

      topRightOuter: getCurvePoints(
        x + topWidth,
        y,
        trh,
        trv
        ).topRight.subdivide(0.5),

      topRightInner: getCurvePoints(
        x + Math.min(topWidth, width + borders[3].width),
        y + borders[0].width,
        (topWidth > width + borders[3].width) ? 0 :trh - borders[3].width,
        trv - borders[0].width
        ).topRight.subdivide(0.5),

      bottomRightOuter: getCurvePoints(
        x + bottomWidth,
        y + rightHeight,
        brh,
        brv
        ).bottomRight.subdivide(0.5),

      bottomRightInner: getCurvePoints(
        x + Math.min(bottomWidth, width + borders[3].width),
        y + Math.min(rightHeight, height + borders[0].width),
        Math.max(0, brh - borders[1].width),
        Math.max(0, brv - borders[2].width)
        ).bottomRight.subdivide(0.5),

      bottomLeftOuter: getCurvePoints(
        x,
        y + leftHeight,
        blh,
        blv
        ).bottomLeft.subdivide(0.5),

      bottomLeftInner: getCurvePoints(
        x + borders[3].width,
        y + leftHeight,
        Math.max(0, blh - borders[3].width),
        Math.max(0, blv - borders[2].width)
        ).bottomLeft.subdivide(0.5)
    };
  }

  function getBorderClip(element, borderPoints, borders, radius, bounds){
    var backgroundClip = getCSS(element, 'backgroundClip'),
    borderArgs = [];

    switch(backgroundClip){
      case "content-box":
      case "padding-box":
        parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftInner, borderPoints.topRightInner, bounds.left + borders[3].width, bounds.top + borders[0].width);
        parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightInner, borderPoints.bottomRightInner, bounds.left + bounds.width - borders[1].width, bounds.top + borders[0].width);
        parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightInner, borderPoints.bottomLeftInner, bounds.left + bounds.width - borders[1].width, bounds.top + bounds.height - borders[2].width);
        parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftInner, borderPoints.topLeftInner, bounds.left + borders[3].width, bounds.top + bounds.height - borders[2].width);
        break;

      default:
        parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftOuter, borderPoints.topRightOuter, bounds.left, bounds.top);
        parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightOuter, borderPoints.bottomRightOuter, bounds.left + bounds.width, bounds.top);
        parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightOuter, borderPoints.bottomLeftOuter, bounds.left + bounds.width, bounds.top + bounds.height);
        parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftOuter, borderPoints.topLeftOuter, bounds.left, bounds.top + bounds.height);
        break;
    }

    return borderArgs;
  }

  function parseBorders(element, bounds, borders){
    var x = bounds.left,
    y = bounds.top,
    width = bounds.width,
    height = bounds.height,
    borderSide,
    bx,
    by,
    bw,
    bh,
    borderArgs,
    // http://www.w3.org/TR/css3-background/#the-border-radius
    borderRadius = getBorderRadiusData(element),
    borderPoints = calculateCurvePoints(bounds, borderRadius, borders),
    borderData = {
      clip: getBorderClip(element, borderPoints, borders, borderRadius, bounds),
      borders: []
    };

    for(borderSide = 0; borderSide < 4; borderSide++){

      if(borders[borderSide].width > 0){
        bx = x;
        by = y;
        bw = width;
        bh = height - (borders[2].width);

        switch(borderSide){
          case 0:
            // top border
            bh = borders[0].width;

            borderArgs = drawSide({
              c1: [bx, by],
              c2: [bx + bw, by],
              c3: [bx + bw - borders[1].width, by + bh],
              c4: [bx + borders[3].width, by + bh]
            }, borderRadius[0], borderRadius[1],
            borderPoints.topLeftOuter, borderPoints.topLeftInner, borderPoints.topRightOuter, borderPoints.topRightInner);
            break;
          case 1:
            // right border
            bx = x + width - (borders[1].width);
            bw = borders[1].width;

            borderArgs = drawSide({
              c1: [bx + bw, by],
              c2: [bx + bw, by + bh + borders[2].width],
              c3: [bx, by + bh],
              c4: [bx, by + borders[0].width]
            }, borderRadius[1], borderRadius[2],
            borderPoints.topRightOuter, borderPoints.topRightInner, borderPoints.bottomRightOuter, borderPoints.bottomRightInner);
            break;
          case 2:
            // bottom border
            by = (by + height) - (borders[2].width);
            bh = borders[2].width;

            borderArgs = drawSide({
              c1: [bx + bw, by + bh],
              c2: [bx, by + bh],
              c3: [bx + borders[3].width, by],
              c4: [bx + bw - borders[3].width, by]
            }, borderRadius[2], borderRadius[3],
            borderPoints.bottomRightOuter, borderPoints.bottomRightInner, borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner);
            break;
          case 3:
            // left border
            bw = borders[3].width;

            borderArgs = drawSide({
              c1: [bx, by + bh + borders[2].width],
              c2: [bx, by],
              c3: [bx + bw, by + borders[0].width],
              c4: [bx + bw, by + bh]
            }, borderRadius[3], borderRadius[0],
            borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner, borderPoints.topLeftOuter, borderPoints.topLeftInner);
            break;
        }

        borderData.borders.push({
          args: borderArgs,
          color: borders[borderSide].color
        });

      }
    }

    return borderData;
  }

  function createShape(ctx, args){
    var shape = ctx.drawShape();
    args.forEach(function(border, index){
      shape[(index === 0) ? "moveTo" : border[0] + "To" ].apply(null, border.slice(1));
    });
    return shape;
  }

  function renderBorders(ctx, borderArgs, color){
    if(color !== "transparent"){
      ctx.setVariable( "fillStyle", color);
      createShape(ctx, borderArgs);
      ctx.fill();
      numDraws+=1;
    }
  }

  function renderFormValue (el, bounds, stack){

    var valueWrap = doc.createElement('valuewrap'),
    cssPropertyArray = ['lineHeight','textAlign','fontFamily','color','fontSize','paddingLeft','paddingTop','width','height','border','borderLeftWidth','borderTopWidth'],
    textValue,
    textNode;

    cssPropertyArray.forEach(function(property){
      try {
        valueWrap.style[property] = getCSS(el, property);
      } catch(e){
        // Older IE has issues with "border"
        Util.log("html2canvas: Parse: Exception caught in renderFormValue: " + e.message);
      }
    });

    valueWrap.style.borderColor = "black";
    valueWrap.style.borderStyle = "solid";
    valueWrap.style.display = "block";
    valueWrap.style.position = "absolute";

    if(/^(submit|reset|button|text|password)$/.test(el.type) || el.nodeName === "SELECT"){
      valueWrap.style.lineHeight = getCSS(el, "height");
    }

    valueWrap.style.top = bounds.top + "px";
    valueWrap.style.left = bounds.left + "px";

    textValue = (el.nodeName === "SELECT") ? (el.options[el.selectedIndex] || 0).text : el.value;
    if(!textValue){
      textValue = el.placeholder;
    }

    textNode = doc.createTextNode(textValue);

    valueWrap.appendChild(textNode);
    body.appendChild(valueWrap);

    renderText(el, textNode, stack);
    body.removeChild(valueWrap);
  }

  function drawImage (ctx){
    ctx.drawImage.apply(ctx, Array.prototype.slice.call(arguments, 1));
    numDraws+=1;
  }

  function getPseudoElement(el, which){
    var elStyle = window.getComputedStyle(el, which);
    if(!elStyle || !elStyle.content || elStyle.content === "none" || elStyle.content === "-moz-alt-content" || elStyle.display === "none"){
      return;
    }
    var content = elStyle.content + '',
    first = content.substr( 0, 1 );
    //strips quotes
    if(first === content.substr( content.length - 1 ) && first.match(/'|"/)){
      content = content.substr( 1, content.length - 2 );
    }

    var isImage = content.substr( 0, 3 ) === 'url',
    elps = document.createElement( isImage ? 'img' : 'span' );

    elps.className = pseudoHide + "-before " + pseudoHide + "-after";

    Object.keys(elStyle).filter(indexedProperty).forEach(function(prop){
      // Prevent assigning of read only CSS Rules, ex. length, parentRule
      try {
        elps.style[prop] = elStyle[prop];
      } catch (e){
        Util.log(['Tried to assign readonly property ', prop, 'Error:', e]);
      }
    });

    if(isImage){
      elps.src = Util.parseBackgroundImage(content)[0].args[0];
    } else{
      elps.innerHTML = content;
    }
    return elps;
  }

  function indexedProperty(property){
    return (isNaN(window.parseInt(property, 10)));
  }

  function injectPseudoElements(el, stack){
    var before = getPseudoElement(el, ':before'),
    after = getPseudoElement(el, ':after');
    if(!before && !after){
      return;
    }

    if(before){
      el.className += " " + pseudoHide + "-before";
      el.parentNode.insertBefore(before, el);
      parseElement(before, stack, true);
      el.parentNode.removeChild(before);
      el.className = el.className.replace(pseudoHide + "-before", "").trim();
    }

    if(after){
      el.className += " " + pseudoHide + "-after";
      el.appendChild(after);
      parseElement(after, stack, true);
      el.removeChild(after);
      el.className = el.className.replace(pseudoHide + "-after", "").trim();
    }

  }

  function renderBackgroundRepeat(ctx, image, backgroundPosition, bounds){
    var offsetX = Math.round(bounds.left + backgroundPosition.left),
    offsetY = Math.round(bounds.top + backgroundPosition.top);

    ctx.createPattern(image);
    ctx.translate(offsetX, offsetY);
    ctx.fill();
    ctx.translate(-offsetX, -offsetY);
  }

  function backgroundRepeatShape(ctx, image, backgroundPosition, bounds, left, top, width, height){
    var args = [];
    args.push(["line", Math.round(left), Math.round(top)]);
    args.push(["line", Math.round(left + width), Math.round(top)]);
    args.push(["line", Math.round(left + width), Math.round(height + top)]);
    args.push(["line", Math.round(left), Math.round(height + top)]);
    createShape(ctx, args);
    ctx.save();
    ctx.clip();
    renderBackgroundRepeat(ctx, image, backgroundPosition, bounds);
    ctx.restore();
  }

  function renderBackgroundColor(ctx, backgroundBounds, bgcolor){
    renderRect(
      ctx,
      backgroundBounds.left,
      backgroundBounds.top,
      backgroundBounds.width,
      backgroundBounds.height,
      bgcolor
      );
  }

  function renderBackgroundRepeating(el, bounds, ctx, image, imageIndex){
    var backgroundSize = Util.BackgroundSize(el, bounds, image, imageIndex),
    backgroundPosition = Util.BackgroundPosition(el, bounds, image, imageIndex, backgroundSize),
    backgroundRepeat = getCSS(el, "backgroundRepeat").split(",").map(Util.trimText);

    image = resizeImage(image, backgroundSize);

    backgroundRepeat = backgroundRepeat[imageIndex] || backgroundRepeat[0];

    switch (backgroundRepeat){
      case "repeat-x":
        backgroundRepeatShape(ctx, image, backgroundPosition, bounds,
          bounds.left, bounds.top + backgroundPosition.top, 99999, image.height);
        break;

      case "repeat-y":
        backgroundRepeatShape(ctx, image, backgroundPosition, bounds,
          bounds.left + backgroundPosition.left, bounds.top, image.width, 99999);
        break;

      case "no-repeat":
        backgroundRepeatShape(ctx, image, backgroundPosition, bounds,
          bounds.left + backgroundPosition.left, bounds.top + backgroundPosition.top, image.width, image.height);
        break;

      default:
        renderBackgroundRepeat(ctx, image, backgroundPosition, {
          top: bounds.top,
          left: bounds.left,
          width: image.width,
          height: image.height
        });
        break;
    }
  }

  function renderBackgroundImage(element, bounds, ctx){
    var backgroundImage = getCSS(element, "backgroundImage"),
    backgroundImages = Util.parseBackgroundImage(backgroundImage),
    image,
    imageIndex = backgroundImages.length;

    while(imageIndex--){
      backgroundImage = backgroundImages[imageIndex];

      if(!backgroundImage.args || backgroundImage.args.length === 0){
        continue;
      }

      var key = backgroundImage.method === 'url' ?
      backgroundImage.args[0] :
      backgroundImage.value;

      image = loadImage(key);

      // TODO add support for background-origin
      if(image){
        renderBackgroundRepeating(element, bounds, ctx, image, imageIndex);
      } else{
        Util.log("html2canvas: Error loading background:", backgroundImage);
      }
    }
  }

  function resizeImage(image, bounds){
    if(image.width === bounds.width && image.height === bounds.height){
      return image;
    }

    var ctx, canvas = doc.createElement('canvas');
    canvas.width = bounds.width;
    canvas.height = bounds.height;
    ctx = canvas.getContext("2d");
    drawImage(ctx, image, 0, 0, image.width, image.height, 0, 0, bounds.width, bounds.height );
    return canvas;
  }

  function setOpacity(ctx, element, parentStack){
    return ctx.setVariable("globalAlpha", getCSS(element, "opacity") * ((parentStack) ? parentStack.opacity : 1));
  }

  function removePx(str){
    return str.replace("px", "");
  }

  var transformRegExp = /(matrix)\((.+)\)/;

  function getTransform(element, parentStack){
    var transform = getCSS(element, "transform") || getCSS(element, "-webkit-transform") || getCSS(element, "-moz-transform") || getCSS(element, "-ms-transform") || getCSS(element, "-o-transform");
    var transformOrigin = getCSS(element, "transform-origin") || getCSS(element, "-webkit-transform-origin") || getCSS(element, "-moz-transform-origin") || getCSS(element, "-ms-transform-origin") || getCSS(element, "-o-transform-origin") || "0px 0px";

    transformOrigin = transformOrigin.split(" ").map(removePx).map(Util.asFloat);

    var matrix;
    if(transform && transform !== "none"){
      var match = transform.match(transformRegExp);
      if(match){
        switch(match[1]){
          case "matrix":
            matrix = match[2].split(",").map(Util.trimText).map(Util.asFloat);
            break;
        }
      }
    }

    return {
      origin: transformOrigin,
      matrix: matrix
    };
  }

  function createStack(element, parentStack, bounds, transform){
    var ctx = h2cRenderContext((!parentStack) ? documentWidth() : bounds.width , (!parentStack) ? documentHeight() : bounds.height),
    stack = {
      ctx: ctx,
      opacity: setOpacity(ctx, element, parentStack),
      cssPosition: getCSS(element, "position"),
      borders: getBorderData(element),
      transform: transform,
      clip: (parentStack && parentStack.clip) ? Util.Extend( {}, parentStack.clip ) : null
    };

    setZ(element, stack, parentStack);

    // TODO correct overflow for absolute content residing under a static position
    if(options.useOverflow === true && /(hidden|scroll|auto)/.test(getCSS(element, "overflow")) === true && /(BODY)/i.test(element.nodeName) === false){
      stack.clip = (stack.clip) ? clipBounds(stack.clip, bounds) : bounds;
    }

    return stack;
  }

  function getBackgroundBounds(borders, bounds, clip){
    var backgroundBounds = {
      left: bounds.left + borders[3].width,
      top: bounds.top + borders[0].width,
      width: bounds.width - (borders[1].width + borders[3].width),
      height: bounds.height - (borders[0].width + borders[2].width)
    };

    if(clip){
      backgroundBounds = clipBounds(backgroundBounds, clip);
    }

    return backgroundBounds;
  }

  function getBounds(element, transform){
    var bounds = (transform.matrix) ? Util.OffsetBounds(element) : Util.Bounds(element);
    transform.origin[0] += bounds.left;
    transform.origin[1] += bounds.top;
    return bounds;
  }

  function renderElement(element, parentStack, pseudoElement, ignoreBackground){
    var transform = getTransform(element, parentStack),
    bounds = getBounds(element, transform),
    image,
    stack = createStack(element, parentStack, bounds, transform),
    borders = stack.borders,
    ctx = stack.ctx,
    backgroundBounds = getBackgroundBounds(borders, bounds, stack.clip),
    borderData = parseBorders(element, bounds, borders),
    backgroundColor = (ignoreElementsRegExp.test(element.nodeName)) ? "#efefef" : getCSS(element, "backgroundColor");


    createShape(ctx, borderData.clip);

    ctx.save();
    ctx.clip();

    if(backgroundBounds.height > 0 && backgroundBounds.width > 0 && !ignoreBackground){
      renderBackgroundColor(ctx, bounds, backgroundColor);
      renderBackgroundImage(element, backgroundBounds, ctx);
    } else if(ignoreBackground){
      stack.backgroundColor =  backgroundColor;
    }

    ctx.restore();

    borderData.borders.forEach(function(border){
      renderBorders(ctx, border.args, border.color);
    });

    if(!pseudoElement){
      injectPseudoElements(element, stack);
    }

    switch(element.nodeName){
      case "IMG":
        if((image = loadImage(element.getAttribute('src')))){
          renderImage(ctx, element, image, bounds, borders);
        } else{
          Util.log("html2canvas: Error loading <img alt=''>:" + element.getAttribute('src'));
        }
        break;
      case "INPUT":
        // TODO add all relevant type's, i.e. HTML5 new stuff
        // todo add support for placeholder attribute for browsers which support it
        if(/^(text|url|email|submit|button|reset)$/.test(element.type) && (element.value || element.placeholder || "").length > 0){
          renderFormValue(element, bounds, stack);
        }
        break;
      case "TEXTAREA":
        if((element.value || element.placeholder || "").length > 0){
          renderFormValue(element, bounds, stack);
        }
        break;
      case "SELECT":
        if((element.options||element.placeholder || "").length > 0){
          renderFormValue(element, bounds, stack);
        }
        break;
      case "LI":
        renderListItem(element, stack, backgroundBounds);
        break;
      case "CANVAS":
        renderImage(ctx, element, element, bounds, borders);
        break;
    }

    return stack;
  }

  function isElementVisible(element){
    return (getCSS(element, 'display') !== "none" && getCSS(element, 'visibility') !== "hidden" && !element.hasAttribute("data-html2canvas-ignore"));
  }

  function parseElement (element, stack, pseudoElement){
    if(isElementVisible(element)){
      stack = renderElement(element, stack, pseudoElement, false) || stack;
      if(!ignoreElementsRegExp.test(element.nodeName)){
        parseChildren(element, stack, pseudoElement);
      }
    }
  }

  function parseChildren(element, stack, pseudoElement){
    Util.Children(element).forEach(function(node){
      if(node.nodeType === node.ELEMENT_NODE){
        parseElement(node, stack, pseudoElement);
      } else if(node.nodeType === node.TEXT_NODE){
        renderText(element, node, stack);
      }
    });
  }

  function init(){
    var background = getCSS(document.documentElement, "backgroundColor"),
      transparentBackground = (Util.isTransparent(background) && element === document.body),
      stack = renderElement(element, null, false, transparentBackground);
    parseChildren(element, stack);

    if(transparentBackground){
      background = stack.backgroundColor;
    }

    body.removeChild(hidePseudoElements);
    return {
      backgroundColor: background,
      stack: stack
    };
  }

  return init();
};

function h2czContext(zindex){
  return {
    zindex: zindex,
    children: []
  };
}

_html2canvas.Preload = function( options ){

  var images = {
    numLoaded: 0,   // also failed are counted here
    numFailed: 0,
    numTotal: 0,
    cleanupDone: false
  },
  pageOrigin,
  Util = _html2canvas.Util,
  methods,
  i,
  count = 0,
  element = options.elements[0] || document.body,
  doc = element.ownerDocument,
  domImages = element.getElementsByTagName('img'), // Fetch images of the present element only
  imgLen = domImages.length,
  link = doc.createElement("a"),
  supportCORS = (function( img ){
    return (img.crossOrigin !== undefined);
  })(new Image()),
  timeoutTimer;

  link.href = window.location.href;
  pageOrigin  = link.protocol + link.host;

  function isSameOrigin(url){
    link.href = url;
    link.href = link.href; // YES, BELIEVE IT OR NOT, that is required for IE9 - http://jsfiddle.net/niklasvh/2e48b/
    var origin = link.protocol + link.host;
    return (origin === pageOrigin);
  }

  function start(){
    Util.log("html2canvas: start: images: " + images.numLoaded + " / " + images.numTotal + " (failed: " + images.numFailed + ")");
    if(!images.firstRun && images.numLoaded >= images.numTotal){
      Util.log("Finished loading images: # " + images.numTotal + " (failed: " + images.numFailed + ")");

      if(typeof options.complete === "function"){
        options.complete(images);
      }

    }
  }

  // TODO modify proxy to serve images with CORS enabled, where available
  function proxyGetImage(url, img, imageObj){
    var callback_name,
    scriptUrl = options.proxy,
    script;

    link.href = url;
    url = link.href; // work around for pages with base href="" set - WARNING: this may change the url

    callback_name = 'html2canvas_' + (count++);
    imageObj.callbackname = callback_name;

    if(scriptUrl.indexOf("?") > -1){
      scriptUrl += "&";
    } else{
      scriptUrl += "?";
    }
    scriptUrl += 'url=' + encodeURIComponent(url) + '&callback=' + callback_name;
    script = doc.createElement("script");

    window[callback_name] = function(a){
      if(a.substring(0,6) === "error:"){
        imageObj.succeeded = false;
        images.numLoaded++;
        images.numFailed++;
        start();
      } else{
        setImageLoadHandlers(img, imageObj);
        img.src = a;
      }
      window[callback_name] = undefined; // to work with IE<9  // NOTE: that the undefined callback property-name still exists on the window object (for IE<9)
      try {
        delete window[callback_name];  // for all browser that support this
      } catch(ex){}
      script.parentNode.removeChild(script);
      script = null;
      delete imageObj.script;
      delete imageObj.callbackname;
    };

    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", scriptUrl);
    imageObj.script = script;
    window.document.body.appendChild(script);

  }

  function loadPseudoElement(element, type){
    var style = window.getComputedStyle(element, type),
    content = style.content;
    if(content.substr(0, 3) === 'url'){
      methods.loadImage(_html2canvas.Util.parseBackgroundImage(content)[0].args[0]);
    }
    loadBackgroundImages(style.backgroundImage, element);
  }

  function loadPseudoElementImages(element){
    loadPseudoElement(element, ":before");
    loadPseudoElement(element, ":after");
  }

  function loadGradientImage(backgroundImage, bounds){
    var img = _html2canvas.Generate.Gradient(backgroundImage, bounds);

    if(img !== undefined){
      images[backgroundImage] = {
        img: img,
        succeeded: true
      };
      images.numTotal++;
      images.numLoaded++;
      start();
    }
  }

  function invalidBackgrounds(background_image){
    return (background_image && background_image.method && background_image.args && background_image.args.length > 0 );
  }

  function loadBackgroundImages(background_image, el){
    var bounds;

    _html2canvas.Util.parseBackgroundImage(background_image).filter(invalidBackgrounds).forEach(function(background_image){
      if(background_image.method === 'url'){
        methods.loadImage(background_image.args[0]);
      } else if(background_image.method.match(/\-?gradient$/)){
        if(bounds === undefined){
          bounds = _html2canvas.Util.Bounds(el);
        }
        loadGradientImage(background_image.value, bounds);
      }
    });
  }

  function getImages (el){
    var elNodeType = false;

    // Firefox fails with permission denied on pages with iframes
    try {
      Util.Children(el).forEach(getImages);
    }
    catch( e ){}

    try {
      elNodeType = el.nodeType;
    } catch (ex){
      elNodeType = false;
      Util.log("html2canvas: failed to access some element's nodeType - Exception: " + ex.message);
    }

    if(elNodeType === 1 || elNodeType === undefined){
      loadPseudoElementImages(el);
      try {
        loadBackgroundImages(Util.getCSS(el, 'backgroundImage'), el);
      } catch(e){
        Util.log("html2canvas: failed to get background-image - Exception: " + e.message);
      }
      loadBackgroundImages(el);
    }
  }

  function setImageLoadHandlers(img, imageObj){
    img.onload = function(){
      if( imageObj.timer !== undefined ){
        // CORS succeeded
        window.clearTimeout( imageObj.timer );
      }

      images.numLoaded++;
      imageObj.succeeded = true;
      img.onerror = img.onload = null;
      start();
    };
    img.onerror = function(){
      if(img.crossOrigin === "anonymous"){
        // CORS failed
        window.clearTimeout( imageObj.timer );

        // let's try with proxy instead
        if( options.proxy ){
          var src = img.src;
          img = new Image();
          imageObj.img = img;
          img.src = src;

          proxyGetImage( img.src, img, imageObj );
          return;
        }
      }

      images.numLoaded++;
      images.numFailed++;
      imageObj.succeeded = false;
      img.onerror = img.onload = null;
      start();
    };
  }

  methods = {
    loadImage: function( src ){
      var img, imageObj;
      if( src && images[src] === undefined ){
        img = new Image();
        if( src.match(/data:image\/.*;base64,/i) ){
          img.src = src.replace(/url\(['"]{0,}|['"]{0,}\)$/ig, '');
          imageObj = images[src] = {
            img: img
          };
          images.numTotal++;
          setImageLoadHandlers(img, imageObj);
        } else if( isSameOrigin( src ) || options.allowTaint ===  true ){
          imageObj = images[src] = {
            img: img
          };
          images.numTotal++;
          setImageLoadHandlers(img, imageObj);
          img.src = src;
        } else if( supportCORS && !options.allowTaint && options.useCORS ){
          // attempt to load with CORS

          img.crossOrigin = "anonymous";
          imageObj = images[src] = {
            img: img
          };
          images.numTotal++;
          setImageLoadHandlers(img, imageObj);
          img.src = src;
        } else if( options.proxy ){
          imageObj = images[src] = {
            img: img
          };
          images.numTotal++;
          proxyGetImage( src, img, imageObj );
        }
      }

    },
    cleanupDOM: function(cause){
      var img, src;
      if(!images.cleanupDone){
        if(cause && typeof cause === "string"){
          Util.log("html2canvas: Cleanup because: " + cause);
        } else{
          Util.log("html2canvas: Cleanup after timeout: " + options.timeout + " ms.");
        }

        for(src in images){
          if(images.hasOwnProperty(src)){
            img = images[src];
            if(typeof img === "object" && img.callbackname && img.succeeded === undefined){
              // cancel proxy image request
              window[img.callbackname] = undefined; // to work with IE<9  // NOTE: that the undefined callback property-name still exists on the window object (for IE<9)
              try {
                delete window[img.callbackname];  // for all browser that support this
              } catch(ex){}
              if(img.script && img.script.parentNode){
                img.script.setAttribute("src", "about:blank");  // try to cancel running request
                img.script.parentNode.removeChild(img.script);
              }
              images.numLoaded++;
              images.numFailed++;
              Util.log("html2canvas: Cleaned up failed img: '" + src + "' Steps: " + images.numLoaded + " / " + images.numTotal);
            }
          }
        }

        // cancel any pending requests
        if(window.stop !== undefined){
          window.stop();
        } else if(document.execCommand !== undefined){
          document.execCommand("Stop", false);
        }
        if(document.close !== undefined){
          document.close();
        }
        images.cleanupDone = true;
        if(!(cause && typeof cause === "string")){
          start();
        }
      }
    },

    renderingDone: function(){
      if(timeoutTimer){
        window.clearTimeout(timeoutTimer);
      }
    }
  };

  if(options.timeout > 0){
    timeoutTimer = window.setTimeout(methods.cleanupDOM, options.timeout);
  }

  Util.log('html2canvas: Preload starts: finding background-images');
  images.firstRun = true;

  getImages(element);

  Util.log('html2canvas: Preload: Finding images');
  // load <img> images
  for(i = 0; i < imgLen; i+=1){
    methods.loadImage( domImages[i].getAttribute( "src" ) );
  }

  images.firstRun = false;
  Util.log('html2canvas: Preload: Done.');
  if(images.numTotal === images.numLoaded){
    start();
  }

  return methods;
};

_html2canvas.Renderer = function(parseQueue, options){

  // http://www.w3.org/TR/CSS21/zindex.html
  function createRenderQueue(parseQueue){
    var queue = [],
    rootContext;

    rootContext = (function buildStackingContext(rootNode){
      var rootContext = {};
      function insert(context, node, specialParent){
        var zi = (node.zIndex.zindex === 'auto') ? 0 : Number(node.zIndex.zindex),
        contextForChildren = context, // the stacking context for children
        isPositioned = node.zIndex.isPositioned,
        isFloated = node.zIndex.isFloated,
        stub = {node: node},
        childrenDest = specialParent; // where children without z-index should be pushed into

        if(node.zIndex.ownStacking){
          // '!' comes before numbers in sorted array
          contextForChildren = stub.context = { '!': [{node:node, children: []}]};
          childrenDest = undefined;
        } else if(isPositioned || isFloated){
          childrenDest = stub.children = [];
        }

        if(zi === 0 && specialParent){
          specialParent.push(stub);
        } else{
          if(!context[zi]){ context[zi] = []; }
          context[zi].push(stub);
        }

        node.zIndex.children.forEach(function(childNode){
          insert(contextForChildren, childNode, childrenDest);
        });
      }
      insert(rootContext, rootNode);
      return rootContext;
    })(parseQueue);

    function sortZ(context){
      Object.keys(context).sort().forEach(function(zi){
        var nonPositioned = [],
        floated = [],
        positioned = [],
        list = [];

        // positioned after static
        context[zi].forEach(function(v){
          if(v.node.zIndex.isPositioned || v.node.zIndex.opacity < 1){
            // http://www.w3.org/TR/css3-color/#transparency
            // non-positioned element with opactiy < 1 should be stacked as if it were a positioned element with ‘z-index: 0’ and ‘opacity: 1’.
            positioned.push(v);
          } else if(v.node.zIndex.isFloated){
            floated.push(v);
          } else{
            nonPositioned.push(v);
          }
        });

        (function walk(arr){
          arr.forEach(function(v){
            list.push(v);
            if(v.children){ walk(v.children); }
          });
        })(nonPositioned.concat(floated, positioned));

        list.forEach(function(v){
          if(v.context){
            sortZ(v.context);
          } else{
            queue.push(v.node);
          }
        });
      });
    }

    sortZ(rootContext);

    return queue;
  }

  function getRenderer(rendererName){
    var renderer;

    if(typeof options.renderer === "string" && _html2canvas.Renderer[rendererName] !== undefined){
      renderer = _html2canvas.Renderer[rendererName](options);
    } else if(typeof rendererName === "function"){
      renderer = rendererName(options);
    } else{
      throw new Error("Unknown renderer");
    }

    if( typeof renderer !== "function" ){
      throw new Error("Invalid renderer defined");
    }
    return renderer;
  }

  return getRenderer(options.renderer)(parseQueue, options, document, createRenderQueue(parseQueue.stack), _html2canvas);
};

_html2canvas.Util.Support = function (options, doc){

  function supportSVGRendering(){
    var img = new Image(),
    canvas = doc.createElement("canvas"),
    ctx = (canvas.getContext === undefined) ? false : canvas.getContext("2d");
    if(ctx === false){
      return false;
    }
    canvas.width = canvas.height = 10;
    img.src = [
    "data:image/svg+xml,",
    "<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'>",
    "<foreignObject width='10' height='10'>",
    "<div xmlns='http://www.w3.org/1999/xhtml' style='width:10;height:10;'>",
    "sup",
    "</div>",
    "</foreignObject>",
    "</svg>"
    ].join("");
    try {
      ctx.drawImage(img, 0, 0);
      canvas.toDataURL();
    } catch(e){
      return false;
    }
    _html2canvas.Util.log('html2canvas: Parse: SVG powered rendering available');
    return true;
  }

  // Test whether we can use ranges to measure bounding boxes
  // Opera doesn't provide valid bounds.height/bottom even though it supports the method.

  function supportRangeBounds(){
    var r, testElement, rangeBounds, rangeHeight, support = false;

    if(doc.createRange){
      r = doc.createRange();
      if(r.getBoundingClientRect){
        testElement = doc.createElement('boundtest');
        testElement.style.height = "123px";
        testElement.style.display = "block";
        doc.body.appendChild(testElement);

        r.selectNode(testElement);
        rangeBounds = r.getBoundingClientRect();
        rangeHeight = rangeBounds.height;

        if(rangeHeight === 123){
          support = true;
        }
        doc.body.removeChild(testElement);
      }
    }

    return support;
  }

  return {
    rangeBounds: supportRangeBounds(),
    svgRendering: options.svgRendering && supportSVGRendering()
  };
};
window.html2canvas = function(elements, opts){
  elements = (elements.length) ? elements : [elements];
  var queue,
  canvas,
  options = {
    // general
    logging: false,
    elements: elements,
    background: "#fff",

    // preload options
    proxy: null,
    timeout: 0,    // no timeout
    useCORS: false, // try to load images as CORS (where available), before falling back to proxy
    allowTaint: false, // whether to allow images to taint the canvas, won't need proxy if set to true

    // parse options
    svgRendering: false, // use svg powered rendering where available (FF11+)
    ignoreElements: "IFRAME|OBJECT|PARAM",
    useOverflow: true,
    letterRendering: false,
    chinese: false,

    // render options

    width: null,
    height: null,
    taintTest: true, // do a taint test with all images before applying to canvas
    renderer: "Canvas"
  };

  options = _html2canvas.Util.Extend(opts, options);

  _html2canvas.logging = options.logging;
  options.complete = function( images ){

    if(typeof options.onpreloaded === "function"){
      if( options.onpreloaded( images ) === false ){
        return;
      }
    }
    queue = _html2canvas.Parse( images, options );

    if(typeof options.onparsed === "function"){
      if( options.onparsed( queue ) === false ){
        return;
      }
    }

    canvas = _html2canvas.Renderer( queue, options );

    if(typeof options.onrendered === "function"){
      options.onrendered( canvas );
    }


  };

  // for pages without images, we still want this to be async, i.e. return methods before executing
  window.setTimeout( function(){
    _html2canvas.Preload( options );
  }, 0 );

  return {
    render: function( queue, opts ){
      return _html2canvas.Renderer( queue, _html2canvas.Util.Extend(opts, options) );
    },
    parse: function( images, opts ){
      return _html2canvas.Parse( images, _html2canvas.Util.Extend(opts, options) );
    },
    preload: function( opts ){
      return _html2canvas.Preload( _html2canvas.Util.Extend(opts, options) );
    },
    log: _html2canvas.Util.log
  };
};

window.html2canvas.log = _html2canvas.Util.log; // for renderers
window.html2canvas.Renderer = {
  Canvas: undefined // We are assuming this will be used
};
_html2canvas.Renderer.Canvas = function(options){
  options = options || {};

  var doc = document,
  safeImages = [],
  testCanvas = document.createElement("canvas"),
  testctx = testCanvas.getContext("2d"),
  Util = _html2canvas.Util,
  canvas = options.canvas || doc.createElement('canvas');

  function createShape(ctx, args){
    ctx.beginPath();
    args.forEach(function(arg){
      ctx[arg.name].apply(ctx, arg['arguments']);
    });
    ctx.closePath();
  }

  function safeImage(item){
    if(safeImages.indexOf(item['arguments'][0].src ) === -1){
      testctx.drawImage(item['arguments'][0], 0, 0);
      try {
        testctx.getImageData(0, 0, 1, 1);
      } catch(e){
        testCanvas = doc.createElement("canvas");
        testctx = testCanvas.getContext("2d");
        return false;
      }
      safeImages.push(item['arguments'][0].src);
    }
    return true;
  }

  function renderItem(ctx, item){
    switch(item.type){
      case "variable":
        ctx[item.name] = item['arguments'];
        break;
      case "function":
        switch(item.name){
          case "createPattern":
            if(item['arguments'][0].width > 0 && item['arguments'][0].height > 0){
              try {
                ctx.fillStyle = ctx.createPattern(item['arguments'][0], "repeat");
              }
              catch(e){
                Util.log("html2canvas: Renderer: Error creating pattern", e.message);
              }
            }
            break;
          case "drawShape":
            createShape(ctx, item['arguments']);
            break;
          case "drawImage":
            if(item['arguments'][8] > 0 && item['arguments'][7] > 0){
              if(!options.taintTest || (options.taintTest && safeImage(item))){
                ctx.drawImage.apply( ctx, item['arguments'] );
              }
            }
            break;
          default:
            ctx[item.name].apply(ctx, item['arguments']);
        }
        break;
    }
  }

  return function(parsedData, options, document, queue, _html2canvas){
    var ctx = canvas.getContext("2d"),
    newCanvas,
    bounds,
    fstyle,
    zStack = parsedData.stack;

    canvas.width = canvas.style.width =  options.width || zStack.ctx.width;
    canvas.height = canvas.style.height = options.height || zStack.ctx.height;

    fstyle = ctx.fillStyle;
    ctx.fillStyle = (Util.isTransparent(zStack.backgroundColor) && options.background !== undefined) ? options.background : parsedData.backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = fstyle;

    queue.forEach(function(storageContext){
      // set common settings for canvas
      ctx.textBaseline = "bottom";
      ctx.save();

      if(storageContext.transform.matrix){
        ctx.translate(storageContext.transform.origin[0], storageContext.transform.origin[1]);
        ctx.transform.apply(ctx, storageContext.transform.matrix);
        ctx.translate(-storageContext.transform.origin[0], -storageContext.transform.origin[1]);
      }

      if(storageContext.clip){
        ctx.beginPath();
        ctx.rect(storageContext.clip.left, storageContext.clip.top, storageContext.clip.width, storageContext.clip.height);
        ctx.clip();
      }

      if(storageContext.ctx.storage){
        storageContext.ctx.storage.forEach(function(item){
          renderItem(ctx, item);
        });
      }

      ctx.restore();
    });

    Util.log("html2canvas: Renderer: Canvas renderer done - returning canvas obj");

    if(options.elements.length === 1){
      if(typeof options.elements[0] === "object" && options.elements[0].nodeName !== "BODY"){
        // crop image to the bounds of selected (single) element
        bounds = _html2canvas.Util.Bounds(options.elements[0]);
        newCanvas = document.createElement('canvas');
        newCanvas.width = Math.ceil(bounds.width);
        newCanvas.height = Math.ceil(bounds.height);
        ctx = newCanvas.getContext("2d");

        ctx.drawImage(canvas, bounds.left, bounds.top, bounds.width, bounds.height, 0, 0, bounds.width, bounds.height);
        canvas = null;
        return newCanvas;
      }
    }

    return canvas;
  };
};
})(window,document);
/* ==============
The MIT License (MIT)

Copyright (c) 2011-2013 Mitya <mitya@mitya.co.uk>
Copyright (c) 2013 Oliver Kopp

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

| @author: Mitya <mitya@mitya.co.uk>
| @Docs & demo: http://www.mitya.co.uk/scripts/XML-Tree---visualise-and-traverse-your-XML-186
|
| github page: http://www.github.com/koppor/xmltree
============== */

// AMD and non-AMD compatibility inspired by http://tkareine.org/blog/2012/08/11/why-javascript-needs-module-definitions/ and https://github.com/blueimp/jQuery-File-Upload/blob/9.5.0/js/jquery.fileupload.js
(function(factory){
	if(typeof define === 'function' && define.amd){
	  // Register as named AMD module. Anonymous registering causes "Mismatched anonymous define() module" in requirejs 2.9.1 when script is loaded explicitly and then loaded with requirejs
	  define("xmltree", ['jquery'], factory);
	} else{
	  // traditional browser loading: build object with directly referencing the global jQuery object and inject it into window object
	  // "XMLTree" is used to provide backwards compatiblity with XMLTree 3.0.0
	  window.XMLTree = factory(window.jQuery);
	}
  }(function($){
	  //log progress?
	  var log = location.href.indexOf('XMLTreeLog=true') != -1;
	  XMLTree = function(jdo, subTreeRequest){
		  /* -------------------
		  | PREP & VALIDATION
		  ------------------- */;
		  if(location.href.indexOf('debug') != -1) this.debug = true;
  
		  //ensure was instantiated, not merely called
		  if(!(this instanceof XMLTree)){
			  debug("XMLTree was called but not instantiated");
			  return;
		  }
  
		  //validate some params
		  var error;
		  if(!jdo.fpath && !jdo.xml) error = "neither XML nor path to XML file passed";
		  else if((!jdo.container || !$(jdo.container).length) && !jdo.justReturn) error = "No container selector passed or does not match element in DOM";
		  if(error){ console.log('XMLTree error - '+error); return; }
  
		  //some vars
		  var	li,
			  appendTo,
			  attrLI,
			  container = $(jdo.container),
			  thiss = this,
			  fpath_req;
  
		  //establish tree container - if making the outer tree, create a new UL. If this is a sub-tree request, i.e. called by self,
		  //merge new tree into existing UL of caller LI
		  this.tree = !subTreeRequest ? $('<ul>') : container.children('ul').hide();
  
		  //log this instance of the tree and update global instances tracker
		  this.instanceID = XMLTree.instancesCounter;
		  this.tree.attr('id', 'tree_'+this.instanceID);
		  XMLTree.instancesCounter++;
  
		  //add a few classes to tree, unless it's a sub-tree (i.e. being inserted later into branch of master tree, in which case it can
		  //just inherit master tree's classes
		  if(!subTreeRequest){
			  this.tree.addClass('xmltree');
			  if(jdo['class']) this.tree.addClass(jdo['class']);
			  if(jdo.startExpanded) this.tree.addClass('startExpanded');
		  }
  
		  //and any data?
		  if(jdo.data) for(var i in jdo.data) this.tree.data(i, jdo.data[i]);
  
		  //if it is a sub-tree request, add .forcePlusMin to tree (i.e. expanded LI) so plus/min icon of sub-tree shows, doesn't inherit
		  //CSS from parent to hide it
		  if(subTreeRequest) this.tree.addClass('forcePlusMin');
  
		  //insert master UL, unless just returning tree, not inserting it
		  if(!jdo.justReturn){
		//this.tree.appendTo(container);
		//container.html(this.tree);
	  }
  
  
		  /* -------------------
		  | ESTABLISH XML - either from file or passed manually. If latter, temporarily rename all tags so any sharing names of self-
		  | closing HTML tags aren't mullered by jQuery during delving
		  ------------------- */
  
		  //get XML from file ('done' handler fires not here but slightly further down)

		//   if(jdo.fpath){
		// 	  debug('XML tree fpath:', jdo.fpath);
		// 	  //get data...
		// 	  var dataType = !jdo.jsonp ? (!jdo.json ? 'xml' : 'json') : 'jsonp';
		// 	  fpath_req = $.ajax({url: jdo.fpath +"?"+ new Date().getTime(), cache: jdo.cache == undefined ? true : jdo.cache, dataType: dataType})
		// 		  //...success. Establish XML. If jdo.json, convert JSON respone to XML text then reinitialise
		// 		  .done(function(data){
		// 			  if(jdo.json){
		// 				  if(jdo.jsonCallback) data = jdo.jsonCallback(data);
		// 				  delete jdo.fpath;
		// 				  jdo.xml = json_to_xml(data);
		// 				  return new XMLTree(jdo, subTreeRequest);
		// 			  } else{
		// 				  data = cleanXML(data);
		// 			  }
		// 			  thiss.xml = data;
		// 			  actOnXML.call(thiss, data);
		// 			  localStorage.setItem("successXMLData", true);
		// 		  })
		// 		  //...error
		// 		  //.error(function(){ alert('XMLTree error - could not load XML from '+jdo.fpath); });
		//   //passed as string
		//   } else{
			  if(typeof jdo.xml == 'string'){
				  this.xml = cleanXML(jdo.xml);
				  //also strip out entities as they break JS XML parsing
				  //this.xml = this.xml.replace(/&amp;|&(?= )/g, 'and').replace(/&\w+;/g, '');
				  actOnXML.call(this);
			  } else{
				  alert('XMLTree error - jdo.xml is not a string');
			  }
		//   }
  
		
		  /**
		   * Does some XML cleaning
		   */
		  function cleanXML(xml){
			  // just strip xml processing instruction
			  //return xml.replace(/<\?xml[^>]+>\s*/, '');
			  return xml;
		  }
  
		  /* -------------------
		  | ACT ON XML - once we have the XML, start outputting from it. If XML is string, first parse.
		  ------------------- */
  
		  function actOnXML(){
			  var thiss = this;
			  //establish XML (parsing as required) as a jQuery object
			  this.xml = $(typeof this.xml == 'string' ? parseXML(this.xml) : this.xml);
  
			  //if is sub-tree request, we don't want the root, just the items
			  if(subTreeRequest) this.xml = this.xml.children(':first');
  
			  //perform any XML manipulation rules stipulated
			  if(jdo.XMLCallback) this.xml = jdo.XMLCallback(this.xml);
  
			  debug('XML fed to XMLTree:', this.xml);
  
			  //open the tree at a specific point once output? Log as attribute on the XML node, so later we can spot this and
			  //open from that point
			  if(jdo.openAtPath){ var currSel = this.xml.find(jdo.openAtPath); if(currSel.length == 1) currSel.attr('currSel', 'true'); }
  
			  //start delving. Since JS seems to add another, outer root element, our(real) root it is child
		this.xml.children().each(function(){
		  delve($(this), thiss.tree);
		});
  
			  //if sub-tree, if we ended up with no data, remove tree and also corresponding plus/min. Else show tree.
			  if(subTreeRequest) this.xml.children().length ? this.tree.show() : this.tree.prev('.plusMin').andSelf().remove();
  
			  //do post-build stuff after delving complete
			  postBuild.call(this);
		  }
  
  
		  /* -------------------
		  | MAIN FUNC for outputting. Called recursively for all levels of tree
		  ------------------- */
	  function delve(node, appendTo, n){
			  var tagName, textContent, li, ul, attrs, i, kids, storedProcedure, LITxtHolder;
			  //what's this node's tag name?
			  if(jdo.isOlo){
				    if(n != undefined){
						if(node[0].id){
							tagName = node[0].tagName + "[" + node[0].id + "]";
						} else{
							tagName = node[0].tagName + "[" + n + "]";
						}
					}
					else{
						tagName = node[0].tagName;
				  	}
			  } else {
				  if(n != undefined){
					  tagName = node[0].tagName + "[" + n + "]";
				  }
				  else{
					  tagName = node[0].tagName;
				  }
			  }
			  textContent = node[0].textContent;
  
			  //build LI and sub-UL for this node (note, tagname is applied as class to LI, for easy post-tree traversal)
			  appendTo.append((li = $('<li>').addClass(tagName).append(LITxtHolder = $('<span>').addClass('LIText')).append(ul = $('<ul>'))));
  
			  //plus/mins indicator
			  li.append($('<span>', {html: jdo.startExpanded ? '-' : '+'}).addClass('plusMin expanded'));
  
			  //attributes...
			  attrs = node[0].attributes;
  
			  //...add node attributes as classes? If true, all, else if array, only attributes specified in that array
			  //For each eligible attribute, two classes are added: attr and attr-value
			  if(jdo.attrsAsClasses){
				  for(i=0; i<attrs.length; i++)
					  if(jdo.attrsAsClasses === true || (typeof jdo.attrsAsClasses == 'string' && jdo.attrsAsClasses == attrs[i].name) || (jdo.attrsAsClasses instanceof Array && $.inArray(attrs[i].name, jdo.attrsAsClasses) != -1))
						  li.addClass(attrs[i].name+'-'+attrs[i].value+' '+attrs[i].name);
			  }
  
			  //...add node attributes as element data? " " " " " " "
			  if(jdo.attrsAsData){
				  for(var i=0; i<attrs.length; i++)
					  if(jdo.attrsAsData === true || (typeof jdo.attrsAsData == 'string' && jdo.attrsAsData == attrs[i].name) || (jdo.attrsAsData instanceof Array && $.inArray(attrs[i].name, jdo.attrsAsData) != -1))
						  li.attr('data-'+attrs[i].name, attrs[i].value);
			  }
  
			  //...output attributes as LIs? (yes, no, or yes but hidden)
			  if(!jdo.attrs || jdo.attrs != 'ignore'){
				if(jdo.isOlo){
					if(attrs){
						for(i=0; i<attrs.length; i++){
							if(attrs[i].value){
								ul.append(attrLI = $('<li>').addClass('attrValue').addClass('attr '+attrs[i].name)
								.append(
									$('<span>')
									.append(
										$('<span>', { text: '@'+attrs[i].name, class: 'findSpanTxt' })
									)
									.append(
										// attrs[i].name === "name" ? $('<span>', { text: '('+attrs[i].value+')', class: 'attrVal' }) : $('<span>', { text: typeof(attrs[i].value) == 'number'? '('+(attrs[i].value.toFixed(2))+')' : '('+attrs[i].value+')', class: 'attrValHide' }) 
										attrs[i].name === "name" ? $('<span>', { text: '('+attrs[i].value+')', class: 'attrVal' }) : attrs[i].name === "cost" ? $('<span>', { text: '($'+Number(attrs[i].value).toFixed(2)+')', class: 'attrValHide' }) : $('<span>', { text: '('+attrs[i].value+')', class: 'attrValHide' }) 
									)
								));
								if(jdo.attrs && jdo.attrs == 'hidden') attrLI.hide();
							}
						}
					}					
				} else{					
					if(attrs){
						for(i=0; i<attrs.length; i++){
							if(attrs[i].value){
								ul.append(attrLI = $('<li>').addClass('attrValue').addClass('attr '+attrs[i].name).append($('<span>', {text: '@'+attrs[i].name})));
								if(jdo.attrs && jdo.attrs == 'hidden') attrLI.hide();
							}
						}
					}
				}
			  } else
				  attrs = false;
  
			  //node has children? (for current purposes, attributes are considered children). If contains only attributes, and jdo.attrs
			  //== 'hidden', count as having no kids
			  kids = node.children();
  
			  if(!kids.length && (!attrs.length || (attrs.length && jdo.attrs && jdo.attrs == 'hidden'))) li.addClass('noKids');
  
		var isSimilar = true;
		var initVal = "";
		if(kids.length > 1){
		  for(var i=0; i<kids.length; i++){
			if(i == 0){
			  initVal = kids[i].tagName;
			}
			else{
			  if(kids[i].tagName != initVal){
				isSimilar = false;
				break;
			  }
			}
		  }
		}
  
		//span to show node name
			  tagName = $('<span>', {text:tagName}).addClass('tree_node');
  
			  //if no children, simply append text (if any)
			  if(!kids.length){
		  LITxtHolder.prepend(tagName);
		  LITxtHolder.append('<span class="text-muted text-sm">'+ textContent +'</span>');
		}
  
			  //if children, set stored procedures that will run and create them only when branch expanded - unless starting expanded
			  //or if tree involves sub-trees
			  else{
				  //LITxtHolder.prepend(node.immediateText()+(!jdo.noDots ? '..' : '')).prepend(tagName);
				  LITxtHolder.prepend(node.immediateText()+(!jdo.noDots ? '' : '')).prepend(tagName);
		  storedProcedure = (function(kids, parent){ return function(){
			if(isSimilar){
			  kids.each(function(index){delve($(this), parent, index); });
			}
			else{
			  kids.each(function(){ delve($(this), parent); });
			}
					  if(jdo.renderCallback) jdo.renderCallback(parent, this, subTreeRequest);
				  }; })(kids, ul);
				  if(!jdo.startExpanded && !jdo.subTreeBranches){
					  li.children('.plusMin').bind('click.sp', function(){
						  storedProcedure();
						  $(this).unbind('click.sp');
					  });
				  } else{
			storedProcedure();
		  }
			  }
		  }
  
		  /* -------------------
		  | POST BUILD stuff, e.g. click events, any user-defined HTML rules, update hash log in URL etc
		  ------------------- */
  
	  function addApplyBtn(){
		$("#feedTreeContainer ul li").each(function(e){
		  refStr = "";
		  traversUntilRoot($(this));
		  if(jdo.isOlo){
			  if($(this).hasClass("attrValue")){
				$(this).append('<button type="button" role="button" class="btn btn-xs btn-primary btnFeed" data-val="'+ $(this).find("span.attrVal").text() + $(this).find("span.attrValHide").text() +'" data-txt="'+ $(this).find("span.findSpanTxt").text() +'" data-ref="'+ refStr +'">Apply</button>');
			  }
			//   else{
			// 	$(this).append('<button type="button" role="button" class="btn btn-xs btn-primary btnFeed" data-txt="'+ $(this).find("> .LIText span.tree_node").text() +'" data-ref="'+ refStr +'">Apply</button>');
			//   }
		  } else {
			  if($(this).hasClass("attrValue")){
				$(this).append('<button type="button" role="button" class="btn btn-xs btn-primary btnFeed" data-txt="'+ $(this).find("span").text() +'" data-ref="'+ refStr +'">Apply</button>');
			  }
			  else{
				$(this).append('<button type="button" role="button" class="btn btn-xs btn-primary btnFeed" data-txt="'+ $(this).find("> .LIText span.tree_node").text() +'" data-ref="'+ refStr +'">Apply</button>');
			  }
		  }
		  if($(this).find("ul li").length == 0){
			$(this).find("ul").remove();
			$(this).find("span.plusMin").remove();
		  }
		});
	  }
	  var refStr = "";
	  var refArr = [];
  
	  function traversUntilRoot($node){
		if(!($node.parent().closest("li").hasClass("feedTreeContainer"))){
		  if(refStr != ""){
			refStr += "|";
		  }
		  refStr += $node.parent().closest("li").attr("class");
		  traversUntilRoot($node.parent().closest("li"));
		}
		else{
		  if(refStr != ""){
			refArr = refStr.split("|");
			refArr.reverse();
			refStr = "";
			for(var i=0; i<refArr.length; i++){
			  if(refStr != ""){
				refStr += ".";
			  }
			  refStr += refArr[i];
			}
		  }
		}
	  }
		  function postBuild(){
		container.html(this.tree);
			  addApplyBtn();
			  //if doing sub-tree requests, ensure relevent branches always have plus-min icons visible
			  if(jdo.subTreeBranches){
				  if(jdo.subTreeBranches === true)
					  this.tree.addClass('subTreeRequestsOnAllNodes');
				  else
					  this.tree.find(jdo.subTreeBranches).addClass('subTreeNode');
			  }
  
			  //listen for clicks to expand/collapse nodes.
  
			  this.tree.on('click', '.plusMin', function(evt){
				  //prep
				  evt.stopPropagation();
				  var
				  uls = $(this).parent().children('ul'),
				  currState = $(this).is('.collapsed') ? 'closed' : 'open',
				  //xPathToNode = returnXPathToNode($(this).parent()),
				  li = $(this).parent();
				  uls[currState == 'closed' ? 'show' : 'hide']();
  
				  //Plus/min click callback? Pass LI, LI's XPath, event obj. and string 'open' or 'close'
				  if(jdo.plusMinCallback) jdo.plusMinCallback(li, xPathToNode, evt, currState);
  
				  //Sub-tree request on expand? This should be a callback that returns a request URI that will load a sub-tree into
				  //the current branch. Callback receives same args as plusMinCallback above. If data previously fetched (denoted
				  //by data element on node), ignore.
  
				  if(jdo.subTreeBranches && (jdo.subTreeBranches === true || $(this).parent().is('.subTreeNode')) && jdo.subTreeRequest && currState == 'closed' && !li.data('subTreeDataFetched')){
					  var subTreeReqURI = jdo.subTreeRequest(li, xPathToNode, evt, currState);
					  if(subTreeReqURI && typeof subTreeReqURI == 'string'){
						  var tree = new XMLTree($.extend(jdo, {fpath: subTreeReqURI, container: li}), true);
						  if(tree) li.data('subTreeDataFetched', true);
					  }
				  }
  
				  //Flip plus/minus indicator and class
				  $(this).html(currState == 'closed' ? '-' : '+').removeClass('expanded collapsed').addClass(currState == 'closed' ? 'expanded' : 'collapsed');
  
				  //Log curr tree pos in URL hash, made up of comma-sep LI indexes of open ULs (LIs with multiple open ULs are sub-sep by -)
				  /*if(!jdo.noURLTracking){
					  var paths = [];
					  thiss.tree.find('ul:visible').filter(function(){ return !$(this).find('ul:visible').length; }).each(function(){
						  var thisPathIndecies = [];
						  $(this).parents('li').each(function(){ thisPathIndecies.unshift($(this).index()); });
						  paths.push(thisPathIndecies.join(','));
					  });
					  var newTreeHash = 'tree'+thiss.instanceID+':'+paths.join('|')+';'
					  // idea by http://stackoverflow.com/a/5257214/873282
					  var replaced = false;
					  var regExp = new RegExp('tree'+thiss.instanceID+':([0-9,\-\|]+);');
					  var newHash = location.hash.replace(regExp, function(token){replaced = true; return newTreeHash;});
					  if(!replaced){
						  // no match, just append
						  if(newHash.indexOf(";", newHash.length - 1) !== -1){
							  // newHash ends with ";" -> just append newTreeHash
							  newHash = newHash + newTreeHash;
						  } else{
							  // ";" needed as separator
							  newHash = newHash + ";" + newTreeHash;
						  }
					  }
					  location.hash = newHash;
				  }*/
			  })
  
			  //do callback on click to actual nodes? Pass LI, LI's xPath and event obj.
			  if(jdo.clickCallback)
				  this.tree.on('click', '.LIText', function(evt){
					  var li = $(this).closest('li'); jdo.clickCallback(li, returnXPathToNode(li), evt);
				  });
  
			  //hide attrs if params say so
			  if(jdo.hideAttrs && !jdo.subTree) this.tree.addClass('hideAttrs');
  
			  //hide node names, if params say so
			  if(jdo.hideNodeNames && !jdo.subTree) this.tree.addClass('hideNodeNames');
  
			  //render callback?
			  if(jdo.renderCallback) jdo.renderCallback(this.tree, this, subTreeRequest);
  
			  //onload - re-entry point(s) stipulated in URL hash or in params (@openAtPath)?
  
			  //...stipulated in hash
			  var paths = new RegExp('tree'+this.instanceID+':([0-9,\-\|]+);').exec(location.hash);
			  if(paths){
				  var paths = paths[1].split('|');
				  for(var y in paths){
					  var parts = paths[y].split(',');
					  var selStr = [];
					  for(var i in parts) selStr.push('li:eq('+parts[i]+') > ul');
					  this.tree.find(selStr.join(' > ')).parents('ul').andSelf().show().each(function(){
						  $(this).parent().children('.plusMin').html('-');
					  });
				  }
  
			  //...stipulated in params
			  } else
				  this.tree.find('.currSel').parentsUntil('.xmltree').show();
		  }
		  //return tree, in case it was assigned
		  return this.tree;
	  }
  
	  //count instances. Used for assigning unique IDs
	  XMLTree.instancesCounter = 0;
  
	  /* -------------------
	  | UTILS
	  ------------------- */
  
	  //parse XML
	  function parseXML(XMLStr){
		  if(window.DOMParser){
			  parser=new DOMParser();
			  xmlDoc=parser.parseFromString(XMLStr,"text/xml");
		  } else{
			  xmlDoc=new ActiveXObject("Microsoft.XMLDOM");
			  xmlDoc.async=false;
			  xmlDoc.loadXML(XMLStr);
		  }
		  return xmlDoc;
	  }
  
	  //get immediate text
	  $.fn.immediateText = function(){ return $(this).clone().children().remove().end().text(); }
  
	  //XPath - return XPath of clicked node
	  function returnXPathToNode(nodeEl){
		  var path = [];
		  nodeEl.parents('li').andSelf().each(function(){
			  var nodeName = $(this).children('.LIText').children('.tree_node').text();
			  var step = nodeName;
			  // The li element has the nodename attached as class.
			  // If nodes have a QName with a namespace prefix, that class cannot be queried
			  // Therefore, we have to check the grandchild of each li element
			  var numberOfSilblings = $(this).siblings().filter(function(){ return $(this).children('.LIText').children('.tree_node').text() == nodeName; }).length;
			  if(numberOfSilblings != 0){
				  // more than one child with the same name -- we have to add an index
				  var index = $(this).prevAll().filter(function(){ return $(this).children('.LIText').children('.tree_node').text() == nodeName; }).length + 1;
				  step += '['+index+']';
			  }
			  path.push(step);
		   });
		  return "/" + path.join('/');
	  }
  
	  //debug (console.log)
	  function debug(){ if(window.console && console.log && log) for(var i in arguments) console.log(arguments[i]); }
  
	  /* ---
	  | JSON > XML convertor(creates XML string)
	  --- */
  
	  function json_to_xml(obj, root_name, depth){
  
		  //prep
		  var xml = '', depth = depth || 0, root_name = root_name || 'root';
		  if(!depth) xml = '<'+root_name+'>';
  
		  //recurse over passed object (for-in) or array (for)
		  if(obj.toString() == '[object Object]') for(var i in obj) xml += build_node(i, obj[i]);
		  else if(obj instanceof Array) for(var i=0, len = obj.length; i<len; i++) xml += build_node('node', obj[i]);
  
		  //util to build individual XML node. Tags named after object key or, if array, 'node'. Coerce tag name to be valid.
		  function build_node(tag_name, val){
			  var
			  tag_name = tag_name.replace(/[^\w\-_]/g, '-').replace(/-{2,}/g, '-').replace(/^[^a-z]/, function($0){ return 'node-'+$0; }),
			  padder = new Array(depth + 2).join('\t'),
			  node = '\n'+padder+'<'+tag_name+'>\n'+padder+'\t';
			  node += typeof val != 'object' ? val : json_to_xml(val, null, depth + 1);
			  return node + '\n'+padder+'</'+tag_name+'>\n';
		  }
  
		  if(!depth) xml += '</'+root_name+'>';
  
		  //return XML string, cleaning it up a bit first
		  return xml
			  .replace(/&(?= )/g, '&amp;')
			  .replace(/^\n(?=<)/, '')
			  .replace(/\n{2,}/g, '\n')
			  .replace(/^\t+\n/mg, '');
	  }
  
	  return XMLTree;
  }));
  
var fabric=fabric||{version:"1.7.3"};"undefined"!=typeof exports&&(exports.fabric=fabric),"undefined"!=typeof document&&"undefined"!=typeof window?(fabric.document=document,fabric.window=window,window.fabric=fabric):(fabric.document=require("jsdom").jsdom(decodeURIComponent("%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E")),fabric.document.createWindow?fabric.window=fabric.document.createWindow():fabric.window=fabric.document.parentWindow),fabric.isTouchSupported="ontouchstart"in fabric.document.documentElement,fabric.isLikelyNode="undefined"!=typeof Buffer&&"undefined"==typeof window,fabric.SHARED_ATTRIBUTES=["display","transform","fill","fill-opacity","fill-rule","opacity","stroke","stroke-dasharray","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","id"],fabric.DPI=96,fabric.reNum="(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:e[-+]?\\d+)?)",fabric.fontPaths={},fabric.charWidthsCache={},fabric.devicePixelRatio=fabric.window.devicePixelRatio||fabric.window.webkitDevicePixelRatio||fabric.window.mozDevicePixelRatio||1,function(){function t(t,e){if(this.__eventListeners[t]){var i=this.__eventListeners[t];e?i[i.indexOf(e)]=!1:fabric.util.array.fill(i,!1)}}function e(t,e){if(this.__eventListeners||(this.__eventListeners={}),1===arguments.length)for(var i in t)this.on(i,t[i]);else this.__eventListeners[t]||(this.__eventListeners[t]=[]),this.__eventListeners[t].push(e);return this}function i(e,i){if(this.__eventListeners){if(0===arguments.length)for(e in this.__eventListeners)t.call(this,e);else if(1===arguments.length&&"object"==typeof arguments[0])for(var r in e)t.call(this,r,e[r]);else t.call(this,e,i);return this}}function r(t,e){if(this.__eventListeners){var i=this.__eventListeners[t];if(i){for(var r=0,n=i.length;r<n;r++)i[r]&&i[r].call(this,e||{});return this.__eventListeners[t]=i.filter(function(t){return t!==!1}),this}}}fabric.Observable={observe:e,stopObserving:i,fire:r,on:e,off:i,trigger:r}}(),fabric.Collection={_objects:[],add:function(){if(this._objects.push.apply(this._objects,arguments),this._onObjectAdded)for(var t=0,e=arguments.length;t<e;t++)this._onObjectAdded(arguments[t]);return this.renderOnAddRemove&&this.renderAll(),this},insertAt:function(t,e,i){var r=this.getObjects();return i?r[e]=t:r.splice(e,0,t),this._onObjectAdded&&this._onObjectAdded(t),this.renderOnAddRemove&&this.renderAll(),this},remove:function(){for(var t,e=this.getObjects(),i=!1,r=0,n=arguments.length;r<n;r++)t=e.indexOf(arguments[r]),t!==-1&&(i=!0,e.splice(t,1),this._onObjectRemoved&&this._onObjectRemoved(arguments[r]));return this.renderOnAddRemove&&i&&this.renderAll(),this},forEachObject:function(t,e){for(var i=this.getObjects(),r=0,n=i.length;r<n;r++)t.call(e,i[r],r,i);return this},getObjects:function(t){return"undefined"==typeof t?this._objects:this._objects.filter(function(e){return e.type===t})},item:function(t){return this.getObjects()[t]},isEmpty:function(){return 0===this.getObjects().length},size:function(){return this.getObjects().length},contains:function(t){return this.getObjects().indexOf(t)>-1},complexity:function(){return this.getObjects().reduce(function(t,e){return t+=e.complexity?e.complexity():0},0)}},fabric.CommonMethods={_setOptions:function(t){for(var e in t)this.set(e,t[e])},_initGradient:function(t,e){!t||!t.colorStops||t instanceof fabric.Gradient||this.set(e,new fabric.Gradient(t))},_initPattern:function(t,e,i){!t||!t.source||t instanceof fabric.Pattern?i&&i():this.set(e,new fabric.Pattern(t,i))},_initClipping:function(t){if(t.clipTo&&"string"==typeof t.clipTo){var e=fabric.util.getFunctionBody(t.clipTo);"undefined"!=typeof e&&(this.clipTo=new Function("ctx",e))}},_setObject:function(t){for(var e in t)this._set(e,t[e])},set:function(t,e){return"object"==typeof t?this._setObject(t):"function"==typeof e&&"clipTo"!==t?this._set(t,e(this.get(t))):this._set(t,e),this},_set:function(t,e){this[t]=e},toggle:function(t){var e=this.get(t);return"boolean"==typeof e&&this.set(t,!e),this},get:function(t){return this[t]}},function(t){var e=Math.sqrt,i=Math.atan2,r=Math.pow,n=Math.abs,s=Math.PI/180;fabric.util={removeFromArray:function(t,e){var i=t.indexOf(e);return i!==-1&&t.splice(i,1),t},getRandomInt:function(t,e){return Math.floor(Math.random()*(e-t+1))+t},degreesToRadians:function(t){return t*s},radiansToDegrees:function(t){return t/s},rotatePoint:function(t,e,i){t.subtractEquals(e);var r=fabric.util.rotateVector(t,i);return new fabric.Point(r.x,r.y).addEquals(e)},rotateVector:function(t,e){var i=Math.sin(e),r=Math.cos(e),n=t.x*r-t.y*i,s=t.x*i+t.y*r;return{x:n,y:s}},transformPoint:function(t,e,i){return i?new fabric.Point(e[0]*t.x+e[2]*t.y,e[1]*t.x+e[3]*t.y):new fabric.Point(e[0]*t.x+e[2]*t.y+e[4],e[1]*t.x+e[3]*t.y+e[5])},makeBoundingBoxFromPoints:function(t){var e=[t[0].x,t[1].x,t[2].x,t[3].x],i=fabric.util.array.min(e),r=fabric.util.array.max(e),n=Math.abs(i-r),s=[t[0].y,t[1].y,t[2].y,t[3].y],o=fabric.util.array.min(s),a=fabric.util.array.max(s),h=Math.abs(o-a);return{left:i,top:o,width:n,height:h}},invertTransform:function(t){var e=1/(t[0]*t[3]-t[1]*t[2]),i=[e*t[3],-e*t[1],-e*t[2],e*t[0]],r=fabric.util.transformPoint({x:t[4],y:t[5]},i,!0);return i[4]=-r.x,i[5]=-r.y,i},toFixed:function(t,e){return parseFloat(Number(t).toFixed(e))},parseUnit:function(t,e){var i=/\D{0,2}$/.exec(t),r=parseFloat(t);switch(e||(e=fabric.Text.DEFAULT_SVG_FONT_SIZE),i[0]){case"mm":return r*fabric.DPI/25.4;case"cm":return r*fabric.DPI/2.54;case"in":return r*fabric.DPI;case"pt":return r*fabric.DPI/72;case"pc":return r*fabric.DPI/72*12;case"em":return r*e;default:return r}},falseFunction:function(){return!1},getKlass:function(t,e){return t=fabric.util.string.camelize(t.charAt(0).toUpperCase()+t.slice(1)),fabric.util.resolveNamespace(e)[t]},resolveNamespace:function(e){if(!e)return fabric;var i,r=e.split("."),n=r.length,s=t||fabric.window;for(i=0;i<n;++i)s=s[r[i]];return s},loadImage:function(t,e,i,r){if(!t)return void(e&&e.call(i,t));var n=fabric.util.createImage();n.onload=function(){e&&e.call(i,n),n=n.onload=n.onerror=null},n.onerror=function(){fabric.log("Error loading "+n.src),e&&e.call(i,null,!0),n=n.onload=n.onerror=null},0!==t.indexOf("data")&&r&&(n.crossOrigin=r),n.src=t},enlivenObjects:function(t,e,i,r){function n(){++o===a&&e&&e(s)}t=t||[];var s=[],o=0,a=t.length,h=!0;return a?void t.forEach(function(t,e){if(!t||!t.type)return void n();var o=fabric.util.getKlass(t.type,i);o.fromObject(t,function(i,o){o||(s[e]=i),r&&r(t,i,o),n()},h)}):void(e&&e(s))},enlivenPatterns:function(t,e){function i(){++n===s&&e&&e(r)}t=t||[];var r=[],n=0,s=t.length;return s?void t.forEach(function(t,e){t&&t.source?new fabric.Pattern(t,function(t){r[e]=t,i()}):(r[e]=t,i())}):void(e&&e(r))},groupSVGElements:function(t,e,i){var r;return r=new fabric.PathGroup(t,e),"undefined"!=typeof i&&r.setSourcePath(i),r},populateWithProperties:function(t,e,i){if(i&&"[object Array]"===Object.prototype.toString.call(i))for(var r=0,n=i.length;r<n;r++)i[r]in t&&(e[i[r]]=t[i[r]])},drawDashedLine:function(t,r,n,s,o,a){var h=s-r,c=o-n,l=e(h*h+c*c),u=i(c,h),f=a.length,d=0,g=!0;for(t.save(),t.translate(r,n),t.moveTo(0,0),t.rotate(u),r=0;l>r;)r+=a[d++%f],r>l&&(r=l),t[g?"lineTo":"moveTo"](r,0),g=!g;t.restore()},createCanvasElement:function(t){return t||(t=fabric.document.createElement("canvas")),t.getContext||"undefined"==typeof G_vmlCanvasManager||G_vmlCanvasManager.initElement(t),t},createImage:function(){return fabric.isLikelyNode?new(require("canvas").Image):fabric.document.createElement("img")},createAccessors:function(t){var e,i,r,n,s,o=t.prototype;for(e=o.stateProperties.length;e--;)i=o.stateProperties[e],r=i.charAt(0).toUpperCase()+i.slice(1),n="set"+r,s="get"+r,o[s]||(o[s]=function(t){return new Function('return this.get("'+t+'")')}(i)),o[n]||(o[n]=function(t){return new Function("value",'return this.set("'+t+'", value)')}(i))},clipContext:function(t,e){e.save(),e.beginPath(),t.clipTo(e),e.clip()},multiplyTransformMatrices:function(t,e,i){return[t[0]*e[0]+t[2]*e[1],t[1]*e[0]+t[3]*e[1],t[0]*e[2]+t[2]*e[3],t[1]*e[2]+t[3]*e[3],i?0:t[0]*e[4]+t[2]*e[5]+t[4],i?0:t[1]*e[4]+t[3]*e[5]+t[5]]},qrDecompose:function(t){var n=i(t[1],t[0]),o=r(t[0],2)+r(t[1],2),a=e(o),h=(t[0]*t[3]-t[2]*t[1])/a,c=i(t[0]*t[2]+t[1]*t[3],o);return{angle:n/s,scaleX:a,scaleY:h,skewX:c/s,skewY:0,translateX:t[4],translateY:t[5]}},customTransformMatrix:function(t,e,i){var r=[1,0,n(Math.tan(i*s)),1],o=[n(t),0,0,n(e)];return fabric.util.multiplyTransformMatrices(o,r,!0)},resetObjectTransform:function(t){t.scaleX=1,t.scaleY=1,t.skewX=0,t.skewY=0,t.flipX=!1,t.flipY=!1,t.setAngle(0)},getFunctionBody:function(t){return(String(t).match(/function[^{]*\{([\s\S]*)\}/)||{})[1]},isTransparent:function(t,e,i,r){r>0&&(e>r?e-=r:e=0,i>r?i-=r:i=0);var n,s,o=!0,a=t.getImageData(e,i,2*r||1,2*r||1),h=a.data.length;for(n=3;n<h&&(s=a.data[n],o=s<=0,o!==!1);n+=4);return a=null,o},parsePreserveAspectRatioAttribute:function(t){var e,i="meet",r="Mid",n="Mid",s=t.split(" ");return s&&s.length&&(i=s.pop(),"meet"!==i&&"slice"!==i?(e=i,i="meet"):s.length&&(e=s.pop())),r="none"!==e?e.slice(1,4):"none",n="none"!==e?e.slice(5,8):"none",{meetOrSlice:i,alignX:r,alignY:n}},clearFabricFontCache:function(t){t?fabric.charWidthsCache[t]&&delete fabric.charWidthsCache[t]:fabric.charWidthsCache={}}}}("undefined"!=typeof exports?exports:this),function(){function t(t,r,s,o,h,c,l){var u=a.call(arguments);if(n[u])return n[u];var f=Math.PI,d=l*f/180,g=Math.sin(d),p=Math.cos(d),v=0,b=0;s=Math.abs(s),o=Math.abs(o);var m=-p*t*.5-g*r*.5,y=-p*r*.5+g*t*.5,_=s*s,x=o*o,C=y*y,S=m*m,w=_*x-_*C-x*S,O=0;if(w<0){var T=Math.sqrt(1-w/(_*x));s*=T,o*=T}else O=(h===c?-1:1)*Math.sqrt(w/(_*C+x*S));var j=O*s*y/o,k=-O*o*m/s,P=p*j-g*k+.5*t,M=g*j+p*k+.5*r,A=i(1,0,(m-j)/s,(y-k)/o),D=i((m-j)/s,(y-k)/o,(-m-j)/s,(-y-k)/o);0===c&&D>0?D-=2*f:1===c&&D<0&&(D+=2*f);for(var I=Math.ceil(Math.abs(D/f*2)),E=[],L=D/I,F=8/3*Math.sin(L/4)*Math.sin(L/4)/Math.sin(L/2),R=A+L,B=0;B<I;B++)E[B]=e(A,R,p,g,s,o,P,M,F,v,b),v=E[B][4],b=E[B][5],A=R,R+=L;return n[u]=E,E}function e(t,e,i,r,n,o,h,c,l,u,f){var d=a.call(arguments);if(s[d])return s[d];var g=Math.cos(t),p=Math.sin(t),v=Math.cos(e),b=Math.sin(e),m=i*n*v-r*o*b+h,y=r*n*v+i*o*b+c,_=u+l*(-i*n*p-r*o*g),x=f+l*(-r*n*p+i*o*g),C=m+l*(i*n*b+r*o*v),S=y+l*(r*n*b-i*o*v);return s[d]=[_,x,C,S,m,y],s[d]}function i(t,e,i,r){var n=Math.atan2(e,t),s=Math.atan2(r,i);return s>=n?s-n:2*Math.PI-(n-s)}function r(t,e,i,r,n,s,h,c){var l=a.call(arguments);if(o[l])return o[l];var u,f,d,g,p,v,b,m,y=Math.sqrt,_=Math.min,x=Math.max,C=Math.abs,S=[],w=[[],[]];f=6*t-12*i+6*n,u=-3*t+9*i-9*n+3*h,d=3*i-3*t;for(var O=0;O<2;++O)if(O>0&&(f=6*e-12*r+6*s,u=-3*e+9*r-9*s+3*c,d=3*r-3*e),C(u)<1e-12){if(C(f)<1e-12)continue;g=-d/f,0<g&&g<1&&S.push(g)}else b=f*f-4*d*u,b<0||(m=y(b),p=(-f+m)/(2*u),0<p&&p<1&&S.push(p),v=(-f-m)/(2*u),0<v&&v<1&&S.push(v));for(var T,j,k,P=S.length,M=P;P--;)g=S[P],k=1-g,T=k*k*k*t+3*k*k*g*i+3*k*g*g*n+g*g*g*h,w[0][P]=T,j=k*k*k*e+3*k*k*g*r+3*k*g*g*s+g*g*g*c,w[1][P]=j;w[0][M]=t,w[1][M]=e,w[0][M+1]=h,w[1][M+1]=c;var A=[{x:_.apply(null,w[0]),y:_.apply(null,w[1])},{x:x.apply(null,w[0]),y:x.apply(null,w[1])}];return o[l]=A,A}var n={},s={},o={},a=Array.prototype.join;fabric.util.drawArc=function(e,i,r,n){for(var s=n[0],o=n[1],a=n[2],h=n[3],c=n[4],l=n[5],u=n[6],f=[[],[],[],[]],d=t(l-i,u-r,s,o,h,c,a),g=0,p=d.length;g<p;g++)f[g][0]=d[g][0]+i,f[g][1]=d[g][1]+r,f[g][2]=d[g][2]+i,f[g][3]=d[g][3]+r,f[g][4]=d[g][4]+i,f[g][5]=d[g][5]+r,e.bezierCurveTo.apply(e,f[g])},fabric.util.getBoundsOfArc=function(e,i,n,s,o,a,h,c,l){for(var u,f=0,d=0,g=[],p=t(c-e,l-i,n,s,a,h,o),v=0,b=p.length;v<b;v++)u=r(f,d,p[v][0],p[v][1],p[v][2],p[v][3],p[v][4],p[v][5]),g.push({x:u[0].x+e,y:u[0].y+i}),g.push({x:u[1].x+e,y:u[1].y+i}),f=p[v][4],d=p[v][5];return g},fabric.util.getBoundsOfCurve=r}(),function(){function t(t,e){for(var i=s.call(arguments,2),r=[],n=0,o=t.length;n<o;n++)r[n]=i.length?t[n][e].apply(t[n],i):t[n][e].call(t[n]);return r}function e(t,e){return n(t,e,function(t,e){return t>=e})}function i(t,e){return n(t,e,function(t,e){return t<e})}function r(t,e){for(var i=t.length;i--;)t[i]=e;return t}function n(t,e,i){if(t&&0!==t.length){var r=t.length-1,n=e?t[r][e]:t[r];if(e)for(;r--;)i(t[r][e],n)&&(n=t[r][e]);else for(;r--;)i(t[r],n)&&(n=t[r]);return n}}var s=Array.prototype.slice;Array.prototype.indexOf||(Array.prototype.indexOf=function(t){if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if(0===i)return-1;var r=0;if(arguments.length>0&&(r=Number(arguments[1]),r!==r?r=0:0!==r&&r!==Number.POSITIVE_INFINITY&&r!==Number.NEGATIVE_INFINITY&&(r=(r>0||-1)*Math.floor(Math.abs(r)))),r>=i)return-1;for(var n=r>=0?r:Math.max(i-Math.abs(r),0);n<i;n++)if(n in e&&e[n]===t)return n;return-1}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){for(var i=0,r=this.length>>>0;i<r;i++)i in this&&t.call(e,this[i],i,this)}),Array.prototype.map||(Array.prototype.map=function(t,e){for(var i=[],r=0,n=this.length>>>0;r<n;r++)r in this&&(i[r]=t.call(e,this[r],r,this));return i}),Array.prototype.every||(Array.prototype.every=function(t,e){for(var i=0,r=this.length>>>0;i<r;i++)if(i in this&&!t.call(e,this[i],i,this))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(t,e){for(var i=0,r=this.length>>>0;i<r;i++)if(i in this&&t.call(e,this[i],i,this))return!0;return!1}),Array.prototype.filter||(Array.prototype.filter=function(t,e){for(var i,r=[],n=0,s=this.length>>>0;n<s;n++)n in this&&(i=this[n],t.call(e,i,n,this)&&r.push(i));return r}),Array.prototype.reduce||(Array.prototype.reduce=function(t){var e,i=this.length>>>0,r=0;if(arguments.length>1)e=arguments[1];else for(;;){if(r in this){e=this[r++];break}if(++r>=i)throw new TypeError}for(;r<i;r++)r in this&&(e=t.call(null,e,this[r],r,this));return e}),fabric.util.array={fill:r,invoke:t,min:i,max:e}}(),function(){function t(e,i,r){if(r)if(!fabric.isLikelyNode&&i instanceof Element)e=i;else if(i instanceof Array){e=[];for(var n=0,s=i.length;n<s;n++)e[n]=t({},i[n],r)}else if(i&&"object"==typeof i)for(var o in i)i.hasOwnProperty(o)&&(e[o]=t({},i[o],r));else e=i;else for(var o in i)e[o]=i[o];return e}function e(e,i){return t({},e,i)}fabric.util.object={extend:t,clone:e}}(),function(){function t(t){return t.replace(/-+(.)?/g,function(t,e){return e?e.toUpperCase():""})}function e(t,e){return t.charAt(0).toUpperCase()+(e?t.slice(1):t.slice(1).toLowerCase())}function i(t){return t.replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&apos;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^[\s\xA0]+/,"").replace(/[\s\xA0]+$/,"")}),fabric.util.string={camelize:t,capitalize:e,escapeXml:i}}(),function(){var t=Array.prototype.slice,e=Function.prototype.apply,i=function(){};Function.prototype.bind||(Function.prototype.bind=function(r){var n,s=this,o=t.call(arguments,1);return n=o.length?function(){return e.call(s,this instanceof i?this:r,o.concat(t.call(arguments)))}:function(){return e.call(s,this instanceof i?this:r,arguments)},i.prototype=this.prototype,n.prototype=new i,n})}(),function(){function t(){}function e(t){var e=this.constructor.superclass.prototype[t];return arguments.length>1?e.apply(this,r.call(arguments,1)):e.call(this)}function i(){function i(){this.initialize.apply(this,arguments)}var s=null,a=r.call(arguments,0);"function"==typeof a[0]&&(s=a.shift()),i.superclass=s,i.subclasses=[],s&&(t.prototype=s.prototype,i.prototype=new t,s.subclasses.push(i));for(var h=0,c=a.length;h<c;h++)o(i,a[h],s);return i.prototype.initialize||(i.prototype.initialize=n),i.prototype.constructor=i,i.prototype.callSuper=e,i}var r=Array.prototype.slice,n=function(){},s=function(){for(var t in{toString:1})if("toString"===t)return!1;return!0}(),o=function(t,e,i){for(var r in e)r in t.prototype&&"function"==typeof t.prototype[r]&&(e[r]+"").indexOf("callSuper")>-1?t.prototype[r]=function(t){return function(){var r=this.constructor.superclass;this.constructor.superclass=i;var n=e[t].apply(this,arguments);if(this.constructor.superclass=r,"initialize"!==t)return n}}(r):t.prototype[r]=e[r],s&&(e.toString!==Object.prototype.toString&&(t.prototype.toString=e.toString),e.valueOf!==Object.prototype.valueOf&&(t.prototype.valueOf=e.valueOf))};fabric.util.createClass=i}(),function(){function t(t){var e,i,r=Array.prototype.slice.call(arguments,1),n=r.length;for(i=0;i<n;i++)if(e=typeof t[r[i]],!/^(?:function|object|unknown)$/.test(e))return!1;return!0}function e(t,e){return{handler:e,wrappedHandler:i(t,e)}}function i(t,e){return function(i){e.call(o(t),i||fabric.window.event)}}function r(t,e){return function(i){if(p[t]&&p[t][e])for(var r=p[t][e],n=0,s=r.length;n<s;n++)r[n].call(this,i||fabric.window.event)}}function n(t){t||(t=fabric.window.event);var e=t.target||(typeof t.srcElement!==h?t.srcElement:null),i=fabric.util.getScrollLeftTop(e);return{x:v(t)+i.left,y:b(t)+i.top}}function s(t,e,i){var r="touchend"===t.type?"changedTouches":"touches";return t[r]&&t[r][0]?t[r][0][e]-(t[r][0][e]-t[r][0][i])||t[i]:t[i]}var o,a,h="unknown",c=function(){var t=0;return function(e){return e.__uniqueID||(e.__uniqueID="uniqueID__"+t++)}}();!function(){var t={};o=function(e){return t[e]},a=function(e,i){t[e]=i}}();var l,u,f=t(fabric.document.documentElement,"addEventListener","removeEventListener")&&t(fabric.window,"addEventListener","removeEventListener"),d=t(fabric.document.documentElement,"attachEvent","detachEvent")&&t(fabric.window,"attachEvent","detachEvent"),g={},p={};f?(l=function(t,e,i){t.addEventListener(e,i,!1)},u=function(t,e,i){t.removeEventListener(e,i,!1)}):d?(l=function(t,i,r){var n=c(t);a(n,t),g[n]||(g[n]={}),g[n][i]||(g[n][i]=[]);var s=e(n,r);g[n][i].push(s),t.attachEvent("on"+i,s.wrappedHandler)},u=function(t,e,i){var r,n=c(t);if(g[n]&&g[n][e])for(var s=0,o=g[n][e].length;s<o;s++)r=g[n][e][s],r&&r.handler===i&&(t.detachEvent("on"+e,r.wrappedHandler),g[n][e][s]=null)}):(l=function(t,e,i){var n=c(t);if(p[n]||(p[n]={}),!p[n][e]){p[n][e]=[];var s=t["on"+e];s&&p[n][e].push(s),t["on"+e]=r(n,e)}p[n][e].push(i)},u=function(t,e,i){var r=c(t);if(p[r]&&p[r][e])for(var n=p[r][e],s=0,o=n.length;s<o;s++)n[s]===i&&n.splice(s,1)}),fabric.util.addListener=l,fabric.util.removeListener=u;var v=function(t){return typeof t.clientX!==h?t.clientX:0},b=function(t){return typeof t.clientY!==h?t.clientY:0};fabric.isTouchSupported&&(v=function(t){return s(t,"pageX","clientX")},b=function(t){return s(t,"pageY","clientY")}),fabric.util.getPointer=n,fabric.util.object.extend(fabric.util,fabric.Observable)}(),function(){function t(t,e){var i=t.style;if(!i)return t;if("string"==typeof e)return t.style.cssText+=";"+e,e.indexOf("opacity")>-1?s(t,e.match(/opacity:\s*(\d?\.?\d*)/)[1]):t;for(var r in e)if("opacity"===r)s(t,e[r]);else{var n="float"===r||"cssFloat"===r?"undefined"==typeof i.styleFloat?"cssFloat":"styleFloat":r;i[n]=e[r]}return t}var e=fabric.document.createElement("div"),i="string"==typeof e.style.opacity,r="string"==typeof e.style.filter,n=/alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,s=function(t){return t};i?s=function(t,e){return t.style.opacity=e,t}:r&&(s=function(t,e){var i=t.style;return t.currentStyle&&!t.currentStyle.hasLayout&&(i.zoom=1),n.test(i.filter)?(e=e>=.9999?"":"alpha(opacity="+100*e+")",i.filter=i.filter.replace(n,e)):i.filter+=" alpha(opacity="+100*e+")",t}),fabric.util.setStyle=t}(),function(){function t(t){return"string"==typeof t?fabric.document.getElementById(t):t}function e(t,e){var i=fabric.document.createElement(t);for(var r in e)"class"===r?i.className=e[r]:"for"===r?i.htmlFor=e[r]:i.setAttribute(r,e[r]);return i}function i(t,e){t&&(" "+t.className+" ").indexOf(" "+e+" ")===-1&&(t.className+=(t.className?" ":"")+e)}function r(t,i,r){return"string"==typeof i&&(i=e(i,r)),t.parentNode&&t.parentNode.replaceChild(i,t),i.appendChild(t),i}function n(t){for(var e=0,i=0,r=fabric.document.documentElement,n=fabric.document.body||{scrollLeft:0,scrollTop:0};t&&(t.parentNode||t.host)&&(t=t.parentNode||t.host,t===fabric.document?(e=n.scrollLeft||r.scrollLeft||0,i=n.scrollTop||r.scrollTop||0):(e+=t.scrollLeft||0,i+=t.scrollTop||0),1!==t.nodeType||"fixed"!==fabric.util.getElementStyle(t,"position")););return{left:e,top:i}}function s(t){var e,i,r=t&&t.ownerDocument,s={left:0,top:0},o={left:0,top:0},a={borderLeftWidth:"left",borderTopWidth:"top",paddingLeft:"left",paddingTop:"top"};if(!r)return o;for(var h in a)o[a[h]]+=parseInt(c(t,h),10)||0;return e=r.documentElement,"undefined"!=typeof t.getBoundingClientRect&&(s=t.getBoundingClientRect()),i=n(t),{left:s.left+i.left-(e.clientLeft||0)+o.left,top:s.top+i.top-(e.clientTop||0)+o.top}}var o,a=Array.prototype.slice,h=function(t){return a.call(t,0)};try{o=h(fabric.document.childNodes)instanceof Array}catch(t){}o||(h=function(t){for(var e=new Array(t.length),i=t.length;i--;)e[i]=t[i];return e});var c;c=fabric.document.defaultView&&fabric.document.defaultView.getComputedStyle?function(t,e){var i=fabric.document.defaultView.getComputedStyle(t,null);return i?i[e]:void 0}:function(t,e){var i=t.style[e];return!i&&t.currentStyle&&(i=t.currentStyle[e]),i},function(){function t(t){return"undefined"!=typeof t.onselectstart&&(t.onselectstart=fabric.util.falseFunction),r?t.style[r]="none":"string"==typeof t.unselectable&&(t.unselectable="on"),t}function e(t){return"undefined"!=typeof t.onselectstart&&(t.onselectstart=null),r?t.style[r]="":"string"==typeof t.unselectable&&(t.unselectable=""),t}var i=fabric.document.documentElement.style,r="userSelect"in i?"userSelect":"MozUserSelect"in i?"MozUserSelect":"WebkitUserSelect"in i?"WebkitUserSelect":"KhtmlUserSelect"in i?"KhtmlUserSelect":"";fabric.util.makeElementUnselectable=t,fabric.util.makeElementSelectable=e}(),function(){function t(t,e){var i=fabric.document.getElementsByTagName("head")[0],r=fabric.document.createElement("script"),n=!0;r.onload=r.onreadystatechange=function(t){if(n){if("string"==typeof this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState)return;n=!1,e(t||fabric.window.event),r=r.onload=r.onreadystatechange=null}},r.src=t,i.appendChild(r)}fabric.util.getScript=t}(),fabric.util.getById=t,fabric.util.toArray=h,fabric.util.makeElement=e,fabric.util.addClass=i,fabric.util.wrapElement=r,fabric.util.getScrollLeftTop=n,fabric.util.getElementOffset=s,fabric.util.getElementStyle=c}(),function(){function t(t,e){return t+(/\?/.test(t)?"&":"?")+e}function e(){}function i(i,n){n||(n={});var s=n.method?n.method.toUpperCase():"GET",o=n.onComplete||function(){},a=r(),h=n.body||n.parameters;return a.onreadystatechange=function(){4===a.readyState&&(o(a),a.onreadystatechange=e)},"GET"===s&&(h=null,"string"==typeof n.parameters&&(i=t(i,n.parameters))),a.open(s,i,!0),"POST"!==s&&"PUT"!==s||a.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),a.send(h),a}var r=function(){for(var t=[function(){return new ActiveXObject("Microsoft.XMLHTTP")},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml2.XMLHTTP.3.0")},function(){return new XMLHttpRequest}],e=t.length;e--;)try{var i=t[e]();if(i)return t[e]}catch(t){}}();fabric.util.request=i}(),fabric.log=function(){},fabric.warn=function(){},"undefined"!=typeof console&&["log","warn"].forEach(function(t){"undefined"!=typeof console[t]&&"function"==typeof console[t].apply&&(fabric[t]=function(){return console[t].apply(console,arguments)})}),function(){function t(t){e(function(i){t||(t={});var r,n=i||+new Date,s=t.duration||500,o=n+s,a=t.onChange||function(){},h=t.abort||function(){return!1},c=t.easing||function(t,e,i,r){return-i*Math.cos(t/r*(Math.PI/2))+i+e},l="startValue"in t?t.startValue:0,u="endValue"in t?t.endValue:100,f=t.byValue||u-l;t.onStart&&t.onStart(),function i(u){r=u||+new Date;var d=r>o?s:r-n;return h()?void(t.onComplete&&t.onComplete()):(a(c(d,l,f,s)),r>o?void(t.onComplete&&t.onComplete()):void e(i))}(n)})}function e(){return i.apply(fabric.window,arguments)}var i=fabric.window.requestAnimationFrame||fabric.window.webkitRequestAnimationFrame||fabric.window.mozRequestAnimationFrame||fabric.window.oRequestAnimationFrame||fabric.window.msRequestAnimationFrame||function(t){fabric.window.setTimeout(t,1e3/60)};fabric.util.animate=t,fabric.util.requestAnimFrame=e}(),function(){function t(t,e,i){var r="rgba("+parseInt(t[0]+i*(e[0]-t[0]),10)+","+parseInt(t[1]+i*(e[1]-t[1]),10)+","+parseInt(t[2]+i*(e[2]-t[2]),10);return r+=","+(t&&e?parseFloat(t[3]+i*(e[3]-t[3])):1),r+=")"}function e(e,i,r,n){var s=new fabric.Color(e).getSource(),o=new fabric.Color(i).getSource();n=n||{},fabric.util.animate(fabric.util.object.extend(n,{duration:r||500,startValue:s,endValue:o,byValue:o,easing:function(e,i,r,s){var o=n.colorEasing?n.colorEasing(e,s):1-Math.cos(e/s*(Math.PI/2));return t(i,r,o)}}))}fabric.util.animateColor=e}(),function(){function t(t,e,i,r){return t<Math.abs(e)?(t=e,r=i/4):r=0===e&&0===t?i/(2*Math.PI)*Math.asin(1):i/(2*Math.PI)*Math.asin(e/t),{a:t,c:e,p:i,s:r}}function e(t,e,i){return t.a*Math.pow(2,10*(e-=1))*Math.sin((e*i-t.s)*(2*Math.PI)/t.p)}function i(t,e,i,r){return i*((t=t/r-1)*t*t+1)+e}function r(t,e,i,r){return t/=r/2,t<1?i/2*t*t*t+e:i/2*((t-=2)*t*t+2)+e}function n(t,e,i,r){return i*(t/=r)*t*t*t+e}function s(t,e,i,r){return-i*((t=t/r-1)*t*t*t-1)+e}function o(t,e,i,r){return t/=r/2,t<1?i/2*t*t*t*t+e:-i/2*((t-=2)*t*t*t-2)+e}function a(t,e,i,r){return i*(t/=r)*t*t*t*t+e}function h(t,e,i,r){return i*((t=t/r-1)*t*t*t*t+1)+e}function c(t,e,i,r){return t/=r/2,t<1?i/2*t*t*t*t*t+e:i/2*((t-=2)*t*t*t*t+2)+e}function l(t,e,i,r){return-i*Math.cos(t/r*(Math.PI/2))+i+e}function u(t,e,i,r){return i*Math.sin(t/r*(Math.PI/2))+e}function f(t,e,i,r){return-i/2*(Math.cos(Math.PI*t/r)-1)+e}function d(t,e,i,r){return 0===t?e:i*Math.pow(2,10*(t/r-1))+e}function g(t,e,i,r){return t===r?e+i:i*(-Math.pow(2,-10*t/r)+1)+e}function p(t,e,i,r){return 0===t?e:t===r?e+i:(t/=r/2,t<1?i/2*Math.pow(2,10*(t-1))+e:i/2*(-Math.pow(2,-10*--t)+2)+e)}function v(t,e,i,r){return-i*(Math.sqrt(1-(t/=r)*t)-1)+e}function b(t,e,i,r){return i*Math.sqrt(1-(t=t/r-1)*t)+e}function m(t,e,i,r){return t/=r/2,t<1?-i/2*(Math.sqrt(1-t*t)-1)+e:i/2*(Math.sqrt(1-(t-=2)*t)+1)+e}function y(i,r,n,s){var o=1.70158,a=0,h=n;if(0===i)return r;if(i/=s,1===i)return r+n;a||(a=.3*s);var c=t(h,n,a,o);return-e(c,i,s)+r}function _(e,i,r,n){var s=1.70158,o=0,a=r;if(0===e)return i;if(e/=n,1===e)return i+r;o||(o=.3*n);var h=t(a,r,o,s);return h.a*Math.pow(2,-10*e)*Math.sin((e*n-h.s)*(2*Math.PI)/h.p)+h.c+i}function x(i,r,n,s){var o=1.70158,a=0,h=n;if(0===i)return r;if(i/=s/2,2===i)return r+n;a||(a=s*(.3*1.5));var c=t(h,n,a,o);return i<1?-.5*e(c,i,s)+r:c.a*Math.pow(2,-10*(i-=1))*Math.sin((i*s-c.s)*(2*Math.PI)/c.p)*.5+c.c+r}function C(t,e,i,r,n){return void 0===n&&(n=1.70158),i*(t/=r)*t*((n+1)*t-n)+e}function S(t,e,i,r,n){return void 0===n&&(n=1.70158),i*((t=t/r-1)*t*((n+1)*t+n)+1)+e}function w(t,e,i,r,n){return void 0===n&&(n=1.70158),t/=r/2,t<1?i/2*(t*t*(((n*=1.525)+1)*t-n))+e:i/2*((t-=2)*t*(((n*=1.525)+1)*t+n)+2)+e}function O(t,e,i,r){return i-T(r-t,0,i,r)+e}function T(t,e,i,r){return(t/=r)<1/2.75?i*(7.5625*t*t)+e:t<2/2.75?i*(7.5625*(t-=1.5/2.75)*t+.75)+e:t<2.5/2.75?i*(7.5625*(t-=2.25/2.75)*t+.9375)+e:i*(7.5625*(t-=2.625/2.75)*t+.984375)+e}function j(t,e,i,r){return t<r/2?.5*O(2*t,0,i,r)+e:.5*T(2*t-r,0,i,r)+.5*i+e}fabric.util.ease={easeInQuad:function(t,e,i,r){return i*(t/=r)*t+e},easeOutQuad:function(t,e,i,r){return-i*(t/=r)*(t-2)+e},easeInOutQuad:function(t,e,i,r){return t/=r/2,t<1?i/2*t*t+e:-i/2*(--t*(t-2)-1)+e},easeInCubic:function(t,e,i,r){return i*(t/=r)*t*t+e},easeOutCubic:i,easeInOutCubic:r,easeInQuart:n,easeOutQuart:s,easeInOutQuart:o,easeInQuint:a,easeOutQuint:h,easeInOutQuint:c,easeInSine:l,easeOutSine:u,easeInOutSine:f,easeInExpo:d,easeOutExpo:g,easeInOutExpo:p,easeInCirc:v,easeOutCirc:b,easeInOutCirc:m,easeInElastic:y,easeOutElastic:_,easeInOutElastic:x,easeInBack:C,easeOutBack:S,easeInOutBack:w,easeInBounce:O,easeOutBounce:T,easeInOutBounce:j}}(),function(t){"use strict";function e(t){return t in O?O[t]:t}function i(t,e,i,r){var n,s="[object Array]"===Object.prototype.toString.call(e);return"fill"!==t&&"stroke"!==t||"none"!==e?"strokeDashArray"===t?e="none"===e?null:e.replace(/,/g," ").split(/\s+/).map(function(t){return parseFloat(t)}):"transformMatrix"===t?e=i&&i.transformMatrix?_(i.transformMatrix,p.parseTransformAttribute(e)):p.parseTransformAttribute(e):"visible"===t?(e="none"!==e&&"hidden"!==e,i&&i.visible===!1&&(e=!1)):"originX"===t?e="start"===e?"left":"end"===e?"right":"center":n=s?e.map(y):y(e,r):e="",!s&&isNaN(n)?e:n}function r(t){for(var e in T)if("undefined"!=typeof t[T[e]]&&""!==t[e]){if("undefined"==typeof t[e]){if(!p.Object.prototype[e])continue;t[e]=p.Object.prototype[e]}if(0!==t[e].indexOf("url(")){var i=new p.Color(t[e]);t[e]=i.setAlpha(m(i.getAlpha()*t[T[e]],2)).toRgba()}}return t}function n(t,e){for(var i,r,n=[],s=0;s<e.length;s++)i=e[s],r=t.getElementsByTagName(i),n=n.concat(Array.prototype.slice.call(r));return n}function s(t,r){var n,s;t.replace(/;\s*$/,"").split(";").forEach(function(t){var o=t.split(":");n=e(o[0].trim().toLowerCase()),s=i(n,o[1].trim()),r[n]=s})}function o(t,r){var n,s;for(var o in t)"undefined"!=typeof t[o]&&(n=e(o.toLowerCase()),s=i(n,t[o]),r[n]=s)}function a(t,e){var i={};for(var r in p.cssRules[e])if(h(t,r.split(" ")))for(var n in p.cssRules[e][r])i[n]=p.cssRules[e][r][n];return i}function h(t,e){var i,r=!0;return i=l(t,e.pop()),i&&e.length&&(r=c(t,e)),i&&r&&0===e.length}function c(t,e){for(var i,r=!0;t.parentNode&&1===t.parentNode.nodeType&&e.length;)r&&(i=e.pop()),t=t.parentNode,r=l(t,i);return 0===e.length}function l(t,e){var i,r=t.nodeName,n=t.getAttribute("class"),s=t.getAttribute("id");if(i=new RegExp("^"+r,"i"),e=e.replace(i,""),s&&e.length&&(i=new RegExp("#"+s+"(?![a-zA-Z\\-]+)","i"),e=e.replace(i,"")),n&&e.length){n=n.split(" ");for(var o=n.length;o--;)i=new RegExp("\\."+n[o]+"(?![a-zA-Z\\-]+)","i"),e=e.replace(i,"")}return 0===e.length}function u(t,e){var i;if(t.getElementById&&(i=t.getElementById(e)),i)return i;var r,n,s=t.getElementsByTagName("*");for(n=0;n<s.length;n++)if(r=s[n],e===r.getAttribute("id"))return r}function f(t){for(var e=n(t,["use","svg:use"]),i=0;e.length&&i<e.length;){var r,s,o,a,h,c=e[i],l=c.getAttribute("xlink:href").substr(1),f=c.getAttribute("x")||0,g=c.getAttribute("y")||0,p=u(t,l).cloneNode(!0),v=(p.getAttribute("transform")||"")+" translate("+f+", "+g+")",b=e.length;if(d(p),/^svg$/i.test(p.nodeName)){var m=p.ownerDocument.createElement("g");for(o=0,a=p.attributes,h=a.length;o<h;o++)s=a.item(o),m.setAttribute(s.nodeName,s.nodeValue);for(;p.firstChild;)m.appendChild(p.firstChild);p=m}for(o=0,a=c.attributes,h=a.length;o<h;o++)s=a.item(o),"x"!==s.nodeName&&"y"!==s.nodeName&&"xlink:href"!==s.nodeName&&("transform"===s.nodeName?v=s.nodeValue+" "+v:p.setAttribute(s.nodeName,s.nodeValue));p.setAttribute("transform",v),p.setAttribute("instantiated_by_use","1"),p.removeAttribute("id"),r=c.parentNode,r.replaceChild(p,c),e.length===b&&i++}}function d(t){var e,i,r,n,s=t.getAttribute("viewBox"),o=1,a=1,h=0,c=0,l=t.getAttribute("width"),u=t.getAttribute("height"),f=t.getAttribute("x")||0,d=t.getAttribute("y")||0,g=t.getAttribute("preserveAspectRatio")||"",v=!s||!C.test(t.nodeName)||!(s=s.match(j)),b=!l||!u||"100%"===l||"100%"===u,m=v&&b,_={},x="";if(_.width=0,_.height=0,_.toBeParsed=m,m)return _;if(v)return _.width=y(l),_.height=y(u),_;if(h=-parseFloat(s[1]),c=-parseFloat(s[2]),e=parseFloat(s[3]),i=parseFloat(s[4]),b?(_.width=e,_.height=i):(_.width=y(l),_.height=y(u),o=_.width/e,a=_.height/i),g=p.util.parsePreserveAspectRatioAttribute(g),"none"!==g.alignX&&(a=o=o>a?a:o),1===o&&1===a&&0===h&&0===c&&0===f&&0===d)return _;if((f||d)&&(x=" translate("+y(f)+" "+y(d)+") "),r=x+" matrix("+o+" 0 0 "+a+" "+h*o+" "+c*a+") ","svg"===t.nodeName){for(n=t.ownerDocument.createElement("g");t.firstChild;)n.appendChild(t.firstChild);t.appendChild(n)}else n=t,r=n.getAttribute("transform")+r;return n.setAttribute("transform",r),_}function g(t,e){for(;t&&(t=t.parentNode);)if(t.nodeName&&e.test(t.nodeName.replace("svg:",""))&&!t.getAttribute("instantiated_by_use"))return!0;
return!1}var p=t.fabric||(t.fabric={}),v=p.util.object.extend,b=p.util.object.clone,m=p.util.toFixed,y=p.util.parseUnit,_=p.util.multiplyTransformMatrices,x=/^(path|circle|polygon|polyline|ellipse|rect|line|image|text)$/i,C=/^(symbol|image|marker|pattern|view|svg)$/i,S=/^(?:pattern|defs|symbol|metadata|clipPath|mask)$/i,w=/^(symbol|g|a|svg)$/i,O={cx:"left",x:"left",r:"radius",cy:"top",y:"top",display:"visible",visibility:"visible",transform:"transformMatrix","fill-opacity":"fillOpacity","fill-rule":"fillRule","font-family":"fontFamily","font-size":"fontSize","font-style":"fontStyle","font-weight":"fontWeight","stroke-dasharray":"strokeDashArray","stroke-linecap":"strokeLineCap","stroke-linejoin":"strokeLineJoin","stroke-miterlimit":"strokeMiterLimit","stroke-opacity":"strokeOpacity","stroke-width":"strokeWidth","text-decoration":"textDecoration","text-anchor":"originX"},T={stroke:"strokeOpacity",fill:"fillOpacity"};p.cssRules={},p.gradientDefs={},p.parseTransformAttribute=function(){function t(t,e){var i=Math.cos(e[0]),r=Math.sin(e[0]),n=0,s=0;3===e.length&&(n=e[1],s=e[2]),t[0]=i,t[1]=r,t[2]=-r,t[3]=i,t[4]=n-(i*n-r*s),t[5]=s-(r*n+i*s)}function e(t,e){var i=e[0],r=2===e.length?e[1]:e[0];t[0]=i,t[3]=r}function i(t,e,i){t[i]=Math.tan(p.util.degreesToRadians(e[0]))}function r(t,e){t[4]=e[0],2===e.length&&(t[5]=e[1])}var n=[1,0,0,1,0,0],s=p.reNum,o="(?:\\s+,?\\s*|,\\s*)",a="(?:(skewX)\\s*\\(\\s*("+s+")\\s*\\))",h="(?:(skewY)\\s*\\(\\s*("+s+")\\s*\\))",c="(?:(rotate)\\s*\\(\\s*("+s+")(?:"+o+"("+s+")"+o+"("+s+"))?\\s*\\))",l="(?:(scale)\\s*\\(\\s*("+s+")(?:"+o+"("+s+"))?\\s*\\))",u="(?:(translate)\\s*\\(\\s*("+s+")(?:"+o+"("+s+"))?\\s*\\))",f="(?:(matrix)\\s*\\(\\s*("+s+")"+o+"("+s+")"+o+"("+s+")"+o+"("+s+")"+o+"("+s+")"+o+"("+s+")\\s*\\))",d="(?:"+f+"|"+u+"|"+l+"|"+c+"|"+a+"|"+h+")",g="(?:"+d+"(?:"+o+"*"+d+")*)",v="^\\s*(?:"+g+"?)\\s*$",b=new RegExp(v),m=new RegExp(d,"g");return function(s){var o=n.concat(),a=[];if(!s||s&&!b.test(s))return o;s.replace(m,function(s){var h=new RegExp(d).exec(s).filter(function(t){return!!t}),c=h[1],l=h.slice(2).map(parseFloat);switch(c){case"translate":r(o,l);break;case"rotate":l[0]=p.util.degreesToRadians(l[0]),t(o,l);break;case"scale":e(o,l);break;case"skewX":i(o,l,2);break;case"skewY":i(o,l,1);break;case"matrix":o=l}a.push(o.concat()),o=n.concat()});for(var h=a[0];a.length>1;)a.shift(),h=p.util.multiplyTransformMatrices(h,a[0]);return h}}();var j=new RegExp("^\\s*("+p.reNum+"+)\\s*,?\\s*("+p.reNum+"+)\\s*,?\\s*("+p.reNum+"+)\\s*,?\\s*("+p.reNum+"+)\\s*$");p.parseSVGDocument=function(t,e,i){if(t){f(t);var r=p.Object.__uid++,n=d(t),s=p.util.toArray(t.getElementsByTagName("*"));if(n.svgUid=r,0===s.length&&p.isLikelyNode){s=t.selectNodes('//*[name(.)!="svg"]');for(var o=[],a=0,h=s.length;a<h;a++)o[a]=s[a];s=o}var c=s.filter(function(t){return d(t),x.test(t.nodeName.replace("svg:",""))&&!g(t,S)});if(!c||c&&!c.length)return void(e&&e([],{}));p.gradientDefs[r]=p.getGradientDefs(t),p.cssRules[r]=p.getCSSRules(t),p.parseElements(c,function(t){e&&e(t,n)},b(n),i)}};var k=new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*("+p.reNum+"(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|"+p.reNum+"))?\\s+(.*)");v(p,{parseFontDeclaration:function(t,e){var i=t.match(k);if(i){var r=i[1],n=i[3],s=i[4],o=i[5],a=i[6];r&&(e.fontStyle=r),n&&(e.fontWeight=isNaN(parseFloat(n))?n:parseFloat(n)),s&&(e.fontSize=y(s)),a&&(e.fontFamily=a),o&&(e.lineHeight="normal"===o?1:o)}},getGradientDefs:function(t){var e,i,r,s=["linearGradient","radialGradient","svg:linearGradient","svg:radialGradient"],o=n(t,s),a=0,h={},c={};for(a=o.length;a--;)e=o[a],r=e.getAttribute("xlink:href"),i=e.getAttribute("id"),r&&(c[i]=r.substr(1)),h[i]=e;for(i in c){var l=h[c[i]].cloneNode(!0);for(e=h[i];l.firstChild;)e.appendChild(l.firstChild)}return h},parseAttributes:function(t,n,s){if(t){var o,h,c={};"undefined"==typeof s&&(s=t.getAttribute("svgUid")),t.parentNode&&w.test(t.parentNode.nodeName)&&(c=p.parseAttributes(t.parentNode,n,s)),h=c&&c.fontSize||t.getAttribute("font-size")||p.Text.DEFAULT_SVG_FONT_SIZE;var l=n.reduce(function(r,n){return o=t.getAttribute(n),o&&(n=e(n),o=i(n,o,c,h),r[n]=o),r},{});return l=v(l,v(a(t,s),p.parseStyleAttribute(t))),l.font&&p.parseFontDeclaration(l.font,l),r(v(c,l))}},parseElements:function(t,e,i,r){new p.ElementsParser(t,e,i,r).parse()},parseStyleAttribute:function(t){var e={},i=t.getAttribute("style");return i?("string"==typeof i?s(i,e):o(i,e),e):e},parsePointsAttribute:function(t){if(!t)return null;t=t.replace(/,/g," ").trim(),t=t.split(/\s+/);var e,i,r=[];for(e=0,i=t.length;e<i;e+=2)r.push({x:parseFloat(t[e]),y:parseFloat(t[e+1])});return r},getCSSRules:function(t){for(var r,n=t.getElementsByTagName("style"),s={},o=0,a=n.length;o<a;o++){var h=n[o].textContent||n[o].text;h=h.replace(/\/\*[\s\S]*?\*\//g,""),""!==h.trim()&&(r=h.match(/[^{]*\{[\s\S]*?\}/g),r=r.map(function(t){return t.trim()}),r.forEach(function(t){for(var r=t.match(/([\s\S]*?)\s*\{([^}]*)\}/),n={},o=r[2].trim(),a=o.replace(/;$/,"").split(/\s*;\s*/),h=0,c=a.length;h<c;h++){var l=a[h].split(/\s*:\s*/),u=e(l[0]),f=i(u,l[1],l[0]);n[u]=f}t=r[1],t.split(",").forEach(function(t){t=t.replace(/^svg/i,"").trim(),""!==t&&(s[t]?p.util.object.extend(s[t],n):s[t]=p.util.object.clone(n))})}))}return s},loadSVGFromURL:function(t,e,i){function r(t){var r=t.responseXML;r&&!r.documentElement&&p.window.ActiveXObject&&t.responseText&&(r=new ActiveXObject("Microsoft.XMLDOM"),r.async="false",r.loadXML(t.responseText.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i,""))),r&&r.documentElement||e&&e(null),p.parseSVGDocument(r.documentElement,function(t,i){e&&e(t,i)},i)}t=t.replace(/^\n\s*/,"").trim(),new p.util.request(t,{method:"get",onComplete:r})},loadSVGFromString:function(t,e,i){t=t.trim();var r;if("undefined"!=typeof DOMParser){var n=new DOMParser;n&&n.parseFromString&&(r=n.parseFromString(t,"text/xml"))}else p.window.ActiveXObject&&(r=new ActiveXObject("Microsoft.XMLDOM"),r.async="false",r.loadXML(t.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i,"")));p.parseSVGDocument(r.documentElement,function(t,i){e(t,i)},i)}})}("undefined"!=typeof exports?exports:this),fabric.ElementsParser=function(t,e,i,r){this.elements=t,this.callback=e,this.options=i,this.reviver=r,this.svgUid=i&&i.svgUid||0},fabric.ElementsParser.prototype.parse=function(){this.instances=new Array(this.elements.length),this.numElements=this.elements.length,this.createObjects()},fabric.ElementsParser.prototype.createObjects=function(){for(var t=0,e=this.elements.length;t<e;t++)this.elements[t].setAttribute("svgUid",this.svgUid),function(t,e){setTimeout(function(){t.createObject(t.elements[e],e)},0)}(this,t)},fabric.ElementsParser.prototype.createObject=function(t,e){var i=fabric[fabric.util.string.capitalize(t.tagName.replace("svg:",""))];if(i&&i.fromElement)try{this._createObject(i,t,e)}catch(t){fabric.log(t)}else this.checkIfDone()},fabric.ElementsParser.prototype._createObject=function(t,e,i){if(t.async)t.fromElement(e,this.createCallback(i,e),this.options);else{var r=t.fromElement(e,this.options);this.resolveGradient(r,"fill"),this.resolveGradient(r,"stroke"),this.reviver&&this.reviver(e,r),this.instances[i]=r,this.checkIfDone()}},fabric.ElementsParser.prototype.createCallback=function(t,e){var i=this;return function(r){i.resolveGradient(r,"fill"),i.resolveGradient(r,"stroke"),i.reviver&&i.reviver(e,r),i.instances[t]=r,i.checkIfDone()}},fabric.ElementsParser.prototype.resolveGradient=function(t,e){var i=t.get(e);if(/^url\(/.test(i)){var r=i.slice(5,i.length-1);fabric.gradientDefs[this.svgUid][r]&&t.set(e,fabric.Gradient.fromElement(fabric.gradientDefs[this.svgUid][r],t))}},fabric.ElementsParser.prototype.checkIfDone=function(){0===--this.numElements&&(this.instances=this.instances.filter(function(t){return null!=t}),this.callback(this.instances))},function(t){"use strict";function e(t,e){this.x=t,this.y=e}var i=t.fabric||(t.fabric={});return i.Point?void i.warn("fabric.Point is already defined"):(i.Point=e,void(e.prototype={type:"point",constructor:e,add:function(t){return new e(this.x+t.x,this.y+t.y)},addEquals:function(t){return this.x+=t.x,this.y+=t.y,this},scalarAdd:function(t){return new e(this.x+t,this.y+t)},scalarAddEquals:function(t){return this.x+=t,this.y+=t,this},subtract:function(t){return new e(this.x-t.x,this.y-t.y)},subtractEquals:function(t){return this.x-=t.x,this.y-=t.y,this},scalarSubtract:function(t){return new e(this.x-t,this.y-t)},scalarSubtractEquals:function(t){return this.x-=t,this.y-=t,this},multiply:function(t){return new e(this.x*t,this.y*t)},multiplyEquals:function(t){return this.x*=t,this.y*=t,this},divide:function(t){return new e(this.x/t,this.y/t)},divideEquals:function(t){return this.x/=t,this.y/=t,this},eq:function(t){return this.x===t.x&&this.y===t.y},lt:function(t){return this.x<t.x&&this.y<t.y},lte:function(t){return this.x<=t.x&&this.y<=t.y},gt:function(t){return this.x>t.x&&this.y>t.y},gte:function(t){return this.x>=t.x&&this.y>=t.y},lerp:function(t,i){return"undefined"==typeof i&&(i=.5),i=Math.max(Math.min(1,i),0),new e(this.x+(t.x-this.x)*i,this.y+(t.y-this.y)*i)},distanceFrom:function(t){var e=this.x-t.x,i=this.y-t.y;return Math.sqrt(e*e+i*i)},midPointFrom:function(t){return this.lerp(t)},min:function(t){return new e(Math.min(this.x,t.x),Math.min(this.y,t.y))},max:function(t){return new e(Math.max(this.x,t.x),Math.max(this.y,t.y))},toString:function(){return this.x+","+this.y},setXY:function(t,e){return this.x=t,this.y=e,this},setX:function(t){return this.x=t,this},setY:function(t){return this.y=t,this},setFromPoint:function(t){return this.x=t.x,this.y=t.y,this},swap:function(t){var e=this.x,i=this.y;this.x=t.x,this.y=t.y,t.x=e,t.y=i},clone:function(){return new e(this.x,this.y)}}))}("undefined"!=typeof exports?exports:this),function(t){"use strict";function e(t){this.status=t,this.points=[]}var i=t.fabric||(t.fabric={});return i.Intersection?void i.warn("fabric.Intersection is already defined"):(i.Intersection=e,i.Intersection.prototype={constructor:e,appendPoint:function(t){return this.points.push(t),this},appendPoints:function(t){return this.points=this.points.concat(t),this}},i.Intersection.intersectLineLine=function(t,r,n,s){var o,a=(s.x-n.x)*(t.y-n.y)-(s.y-n.y)*(t.x-n.x),h=(r.x-t.x)*(t.y-n.y)-(r.y-t.y)*(t.x-n.x),c=(s.y-n.y)*(r.x-t.x)-(s.x-n.x)*(r.y-t.y);if(0!==c){var l=a/c,u=h/c;0<=l&&l<=1&&0<=u&&u<=1?(o=new e("Intersection"),o.appendPoint(new i.Point(t.x+l*(r.x-t.x),t.y+l*(r.y-t.y)))):o=new e}else o=new e(0===a||0===h?"Coincident":"Parallel");return o},i.Intersection.intersectLinePolygon=function(t,i,r){for(var n,s,o,a=new e,h=r.length,c=0;c<h;c++)n=r[c],s=r[(c+1)%h],o=e.intersectLineLine(t,i,n,s),a.appendPoints(o.points);return a.points.length>0&&(a.status="Intersection"),a},i.Intersection.intersectPolygonPolygon=function(t,i){for(var r=new e,n=t.length,s=0;s<n;s++){var o=t[s],a=t[(s+1)%n],h=e.intersectLinePolygon(o,a,i);r.appendPoints(h.points)}return r.points.length>0&&(r.status="Intersection"),r},void(i.Intersection.intersectPolygonRectangle=function(t,r,n){var s=r.min(n),o=r.max(n),a=new i.Point(o.x,s.y),h=new i.Point(s.x,o.y),c=e.intersectLinePolygon(s,a,t),l=e.intersectLinePolygon(a,o,t),u=e.intersectLinePolygon(o,h,t),f=e.intersectLinePolygon(h,s,t),d=new e;return d.appendPoints(c.points),d.appendPoints(l.points),d.appendPoints(u.points),d.appendPoints(f.points),d.points.length>0&&(d.status="Intersection"),d}))}("undefined"!=typeof exports?exports:this),function(t){"use strict";function e(t){t?this._tryParsingColor(t):this.setSource([0,0,0,1])}function i(t,e,i){return i<0&&(i+=1),i>1&&(i-=1),i<1/6?t+6*(e-t)*i:i<.5?e:i<2/3?t+(e-t)*(2/3-i)*6:t}var r=t.fabric||(t.fabric={});return r.Color?void r.warn("fabric.Color is already defined."):(r.Color=e,r.Color.prototype={_tryParsingColor:function(t){var i;t in e.colorNameMap&&(t=e.colorNameMap[t]),"transparent"===t&&(i=[255,255,255,0]),i||(i=e.sourceFromHex(t)),i||(i=e.sourceFromRgb(t)),i||(i=e.sourceFromHsl(t)),i||(i=[0,0,0,1]),i&&this.setSource(i)},_rgbToHsl:function(t,e,i){t/=255,e/=255,i/=255;var n,s,o,a=r.util.array.max([t,e,i]),h=r.util.array.min([t,e,i]);if(o=(a+h)/2,a===h)n=s=0;else{var c=a-h;switch(s=o>.5?c/(2-a-h):c/(a+h),a){case t:n=(e-i)/c+(e<i?6:0);break;case e:n=(i-t)/c+2;break;case i:n=(t-e)/c+4}n/=6}return[Math.round(360*n),Math.round(100*s),Math.round(100*o)]},getSource:function(){return this._source},setSource:function(t){this._source=t},toRgb:function(){var t=this.getSource();return"rgb("+t[0]+","+t[1]+","+t[2]+")"},toRgba:function(){var t=this.getSource();return"rgba("+t[0]+","+t[1]+","+t[2]+","+t[3]+")"},toHsl:function(){var t=this.getSource(),e=this._rgbToHsl(t[0],t[1],t[2]);return"hsl("+e[0]+","+e[1]+"%,"+e[2]+"%)"},toHsla:function(){var t=this.getSource(),e=this._rgbToHsl(t[0],t[1],t[2]);return"hsla("+e[0]+","+e[1]+"%,"+e[2]+"%,"+t[3]+")"},toHex:function(){var t,e,i,r=this.getSource();return t=r[0].toString(16),t=1===t.length?"0"+t:t,e=r[1].toString(16),e=1===e.length?"0"+e:e,i=r[2].toString(16),i=1===i.length?"0"+i:i,t.toUpperCase()+e.toUpperCase()+i.toUpperCase()},getAlpha:function(){return this.getSource()[3]},setAlpha:function(t){var e=this.getSource();return e[3]=t,this.setSource(e),this},toGrayscale:function(){var t=this.getSource(),e=parseInt((.3*t[0]+.59*t[1]+.11*t[2]).toFixed(0),10),i=t[3];return this.setSource([e,e,e,i]),this},toBlackWhite:function(t){var e=this.getSource(),i=(.3*e[0]+.59*e[1]+.11*e[2]).toFixed(0),r=e[3];return t=t||127,i=Number(i)<Number(t)?0:255,this.setSource([i,i,i,r]),this},overlayWith:function(t){t instanceof e||(t=new e(t));for(var i=[],r=this.getAlpha(),n=.5,s=this.getSource(),o=t.getSource(),a=0;a<3;a++)i.push(Math.round(s[a]*(1-n)+o[a]*n));return i[3]=r,this.setSource(i),this}},r.Color.reRGBa=/^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/,r.Color.reHSLa=/^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/,r.Color.reHex=/^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i,r.Color.colorNameMap={aqua:"#00FFFF",black:"#000000",blue:"#0000FF",fuchsia:"#FF00FF",gray:"#808080",grey:"#808080",green:"#008000",lime:"#00FF00",maroon:"#800000",navy:"#000080",olive:"#808000",orange:"#FFA500",purple:"#800080",red:"#FF0000",silver:"#C0C0C0",teal:"#008080",white:"#FFFFFF",yellow:"#FFFF00"},r.Color.fromRgb=function(t){return e.fromSource(e.sourceFromRgb(t))},r.Color.sourceFromRgb=function(t){var i=t.match(e.reRGBa);if(i){var r=parseInt(i[1],10)/(/%$/.test(i[1])?100:1)*(/%$/.test(i[1])?255:1),n=parseInt(i[2],10)/(/%$/.test(i[2])?100:1)*(/%$/.test(i[2])?255:1),s=parseInt(i[3],10)/(/%$/.test(i[3])?100:1)*(/%$/.test(i[3])?255:1);return[parseInt(r,10),parseInt(n,10),parseInt(s,10),i[4]?parseFloat(i[4]):1]}},r.Color.fromRgba=e.fromRgb,r.Color.fromHsl=function(t){return e.fromSource(e.sourceFromHsl(t))},r.Color.sourceFromHsl=function(t){var r=t.match(e.reHSLa);if(r){var n,s,o,a=(parseFloat(r[1])%360+360)%360/360,h=parseFloat(r[2])/(/%$/.test(r[2])?100:1),c=parseFloat(r[3])/(/%$/.test(r[3])?100:1);if(0===h)n=s=o=c;else{var l=c<=.5?c*(h+1):c+h-c*h,u=2*c-l;n=i(u,l,a+1/3),s=i(u,l,a),o=i(u,l,a-1/3)}return[Math.round(255*n),Math.round(255*s),Math.round(255*o),r[4]?parseFloat(r[4]):1]}},r.Color.fromHsla=e.fromHsl,r.Color.fromHex=function(t){return e.fromSource(e.sourceFromHex(t))},r.Color.sourceFromHex=function(t){if(t.match(e.reHex)){var i=t.slice(t.indexOf("#")+1),r=3===i.length||4===i.length,n=8===i.length||4===i.length,s=r?i.charAt(0)+i.charAt(0):i.substring(0,2),o=r?i.charAt(1)+i.charAt(1):i.substring(2,4),a=r?i.charAt(2)+i.charAt(2):i.substring(4,6),h=n?r?i.charAt(3)+i.charAt(3):i.substring(6,8):"FF";return[parseInt(s,16),parseInt(o,16),parseInt(a,16),parseFloat((parseInt(h,16)/255).toFixed(2))]}},void(r.Color.fromSource=function(t){var i=new e;return i.setSource(t),i}))}("undefined"!=typeof exports?exports:this),function(){function t(t){var e,i,r,n=t.getAttribute("style"),s=t.getAttribute("offset")||0;if(s=parseFloat(s)/(/%$/.test(s)?100:1),s=s<0?0:s>1?1:s,n){var o=n.split(/\s*;\s*/);""===o[o.length-1]&&o.pop();for(var a=o.length;a--;){var h=o[a].split(/\s*:\s*/),c=h[0].trim(),l=h[1].trim();"stop-color"===c?e=l:"stop-opacity"===c&&(r=l)}}return e||(e=t.getAttribute("stop-color")||"rgb(0,0,0)"),r||(r=t.getAttribute("stop-opacity")),e=new fabric.Color(e),i=e.getAlpha(),r=isNaN(parseFloat(r))?1:parseFloat(r),r*=i,{offset:s,color:e.toRgb(),opacity:r}}function e(t){return{x1:t.getAttribute("x1")||0,y1:t.getAttribute("y1")||0,x2:t.getAttribute("x2")||"100%",y2:t.getAttribute("y2")||0}}function i(t){return{x1:t.getAttribute("fx")||t.getAttribute("cx")||"50%",y1:t.getAttribute("fy")||t.getAttribute("cy")||"50%",r1:0,x2:t.getAttribute("cx")||"50%",y2:t.getAttribute("cy")||"50%",r2:t.getAttribute("r")||"50%"}}function r(t,e,i){var r,n=0,s=1,o="";for(var a in e)"Infinity"===e[a]?e[a]=1:"-Infinity"===e[a]&&(e[a]=0),r=parseFloat(e[a],10),s="string"==typeof e[a]&&/^\d+%$/.test(e[a])?.01:1,"x1"===a||"x2"===a||"r2"===a?(s*="objectBoundingBox"===i?t.width:1,n="objectBoundingBox"===i?t.left||0:0):"y1"!==a&&"y2"!==a||(s*="objectBoundingBox"===i?t.height:1,n="objectBoundingBox"===i?t.top||0:0),e[a]=r*s+n;if("ellipse"===t.type&&null!==e.r2&&"objectBoundingBox"===i&&t.rx!==t.ry){var h=t.ry/t.rx;o=" scale(1, "+h+")",e.y1&&(e.y1/=h),e.y2&&(e.y2/=h)}return o}fabric.Gradient=fabric.util.createClass({offsetX:0,offsetY:0,initialize:function(t){t||(t={});var e={};this.id=fabric.Object.__uid++,this.type=t.type||"linear",e={x1:t.coords.x1||0,y1:t.coords.y1||0,x2:t.coords.x2||0,y2:t.coords.y2||0},"radial"===this.type&&(e.r1=t.coords.r1||0,e.r2=t.coords.r2||0),this.coords=e,this.colorStops=t.colorStops.slice(),t.gradientTransform&&(this.gradientTransform=t.gradientTransform),this.offsetX=t.offsetX||this.offsetX,this.offsetY=t.offsetY||this.offsetY},addColorStop:function(t){for(var e in t){var i=new fabric.Color(t[e]);this.colorStops.push({offset:e,color:i.toRgb(),opacity:i.getAlpha()})}return this},toObject:function(t){var e={type:this.type,coords:this.coords,colorStops:this.colorStops,offsetX:this.offsetX,offsetY:this.offsetY,gradientTransform:this.gradientTransform?this.gradientTransform.concat():this.gradientTransform};return fabric.util.populateWithProperties(this,e,t),e},toSVG:function(t){var e,i,r=fabric.util.object.clone(this.coords);if(this.colorStops.sort(function(t,e){return t.offset-e.offset}),!t.group||"path-group"!==t.group.type)for(var n in r)"x1"===n||"x2"===n||"r2"===n?r[n]+=this.offsetX-t.width/2:"y1"!==n&&"y2"!==n||(r[n]+=this.offsetY-t.height/2);i='id="SVGID_'+this.id+'" gradientUnits="userSpaceOnUse"',this.gradientTransform&&(i+=' gradientTransform="matrix('+this.gradientTransform.join(" ")+')" '),"linear"===this.type?e=["<linearGradient ",i,' x1="',r.x1,'" y1="',r.y1,'" x2="',r.x2,'" y2="',r.y2,'">\n']:"radial"===this.type&&(e=["<radialGradient ",i,' cx="',r.x2,'" cy="',r.y2,'" r="',r.r2,'" fx="',r.x1,'" fy="',r.y1,'">\n']);for(var s=0;s<this.colorStops.length;s++)e.push("<stop ",'offset="',100*this.colorStops[s].offset+"%",'" style="stop-color:',this.colorStops[s].color,null!==this.colorStops[s].opacity?";stop-opacity: "+this.colorStops[s].opacity:";",'"/>\n');return e.push("linear"===this.type?"</linearGradient>\n":"</radialGradient>\n"),e.join("")},toLive:function(t,e){var i,r,n=fabric.util.object.clone(this.coords);if(this.type){if(e.group&&"path-group"===e.group.type)for(r in n)"x1"===r||"x2"===r?n[r]+=-this.offsetX+e.width/2:"y1"!==r&&"y2"!==r||(n[r]+=-this.offsetY+e.height/2);"linear"===this.type?i=t.createLinearGradient(n.x1,n.y1,n.x2,n.y2):"radial"===this.type&&(i=t.createRadialGradient(n.x1,n.y1,n.r1,n.x2,n.y2,n.r2));for(var s=0,o=this.colorStops.length;s<o;s++){var a=this.colorStops[s].color,h=this.colorStops[s].opacity,c=this.colorStops[s].offset;"undefined"!=typeof h&&(a=new fabric.Color(a).setAlpha(h).toRgba()),i.addColorStop(parseFloat(c),a)}return i}}}),fabric.util.object.extend(fabric.Gradient,{fromElement:function(n,s){var o,a,h,c=n.getElementsByTagName("stop"),l=n.getAttribute("gradientUnits")||"objectBoundingBox",u=n.getAttribute("gradientTransform"),f=[];o="linearGradient"===n.nodeName||"LINEARGRADIENT"===n.nodeName?"linear":"radial","linear"===o?a=e(n):"radial"===o&&(a=i(n));for(var d=c.length;d--;)f.push(t(c[d]));h=r(s,a,l);var g=new fabric.Gradient({type:o,coords:a,colorStops:f,offsetX:-s.left,offsetY:-s.top});return(u||""!==h)&&(g.gradientTransform=fabric.parseTransformAttribute((u||"")+h)),g},forObject:function(t,e){return e||(e={}),r(t,e.coords,"userSpaceOnUse"),new fabric.Gradient(e)}})}(),function(){"use strict";var t=fabric.util.toFixed;fabric.Pattern=fabric.util.createClass({repeat:"repeat",offsetX:0,offsetY:0,initialize:function(t,e){if(t||(t={}),this.id=fabric.Object.__uid++,this.setOptions(t),!t.source||t.source&&"string"!=typeof t.source)return void(e&&e(this));if("undefined"!=typeof fabric.util.getFunctionBody(t.source))this.source=new Function(fabric.util.getFunctionBody(t.source)),e&&e(this);else{var i=this;this.source=fabric.util.createImage(),fabric.util.loadImage(t.source,function(t){i.source=t,e&&e(i)})}},toObject:function(e){var i,r,n=fabric.Object.NUM_FRACTION_DIGITS;return"function"==typeof this.source?i=String(this.source):"string"==typeof this.source.src?i=this.source.src:"object"==typeof this.source&&this.source.toDataURL&&(i=this.source.toDataURL()),r={type:"pattern",source:i,repeat:this.repeat,offsetX:t(this.offsetX,n),offsetY:t(this.offsetY,n)},fabric.util.populateWithProperties(this,r,e),r},toSVG:function(t){var e="function"==typeof this.source?this.source():this.source,i=e.width/t.width,r=e.height/t.height,n=this.offsetX/t.width,s=this.offsetY/t.height,o="";return"repeat-x"!==this.repeat&&"no-repeat"!==this.repeat||(r=1),"repeat-y"!==this.repeat&&"no-repeat"!==this.repeat||(i=1),e.src?o=e.src:e.toDataURL&&(o=e.toDataURL()),'<pattern id="SVGID_'+this.id+'" x="'+n+'" y="'+s+'" width="'+i+'" height="'+r+'">\n<image x="0" y="0" width="'+e.width+'" height="'+e.height+'" xlink:href="'+o+'"></image>\n</pattern>\n'},setOptions:function(t){for(var e in t)this[e]=t[e]},toLive:function(t){var e="function"==typeof this.source?this.source():this.source;if(!e)return"";if("undefined"!=typeof e.src){if(!e.complete)return"";if(0===e.naturalWidth||0===e.naturalHeight)return""}return t.createPattern(e,this.repeat)}})}(),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.toFixed;return e.Shadow?void e.warn("fabric.Shadow is already defined."):(e.Shadow=e.util.createClass({color:"rgb(0,0,0)",blur:0,offsetX:0,offsetY:0,affectStroke:!1,includeDefaultValues:!0,initialize:function(t){"string"==typeof t&&(t=this._parseShadow(t));for(var i in t)this[i]=t[i];this.id=e.Object.__uid++},_parseShadow:function(t){var i=t.trim(),r=e.Shadow.reOffsetsAndBlur.exec(i)||[],n=i.replace(e.Shadow.reOffsetsAndBlur,"")||"rgb(0,0,0)";return{color:n.trim(),offsetX:parseInt(r[1],10)||0,offsetY:parseInt(r[2],10)||0,blur:parseInt(r[3],10)||0}},toString:function(){return[this.offsetX,this.offsetY,this.blur,this.color].join("px ")},toSVG:function(t){var r=40,n=40,s=e.Object.NUM_FRACTION_DIGITS,o=e.util.rotateVector({x:this.offsetX,y:this.offsetY},e.util.degreesToRadians(-t.angle)),a=20;return t.width&&t.height&&(r=100*i((Math.abs(o.x)+this.blur)/t.width,s)+a,n=100*i((Math.abs(o.y)+this.blur)/t.height,s)+a),t.flipX&&(o.x*=-1),t.flipY&&(o.y*=-1),'<filter id="SVGID_'+this.id+'" y="-'+n+'%" height="'+(100+2*n)+'%" x="-'+r+'%" width="'+(100+2*r)+'%" >\n\t<feGaussianBlur in="SourceAlpha" stdDeviation="'+i(this.blur?this.blur/2:0,s)+'"></feGaussianBlur>\n\t<feOffset dx="'+i(o.x,s)+'" dy="'+i(o.y,s)+'" result="oBlur"></feOffset>\n\t<feFlood flood-color="'+this.color+'"/>\n\t<feComposite in2="oBlur" operator="in" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n\t</feMerge>\n</filter>\n'},toObject:function(){if(this.includeDefaultValues)return{color:this.color,blur:this.blur,offsetX:this.offsetX,offsetY:this.offsetY,affectStroke:this.affectStroke};var t={},i=e.Shadow.prototype;return["color","blur","offsetX","offsetY","affectStroke"].forEach(function(e){this[e]!==i[e]&&(t[e]=this[e])},this),t}}),void(e.Shadow.reOffsetsAndBlur=/(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/))}("undefined"!=typeof exports?exports:this),function(){"use strict";if(fabric.StaticCanvas)return void fabric.warn("fabric.StaticCanvas is already defined.");var t=fabric.util.object.extend,e=fabric.util.getElementOffset,i=fabric.util.removeFromArray,r=fabric.util.toFixed,n=new Error("Could not initialize `canvas` element");fabric.StaticCanvas=fabric.util.createClass(fabric.CommonMethods,{initialize:function(t,e){e||(e={}),this._initStatic(t,e)},backgroundColor:"",backgroundImage:null,overlayColor:"",overlayImage:null,includeDefaultValues:!0,stateful:!1,renderOnAddRemove:!0,clipTo:null,controlsAboveOverlay:!1,allowTouchScrolling:!1,imageSmoothingEnabled:!0,viewportTransform:[1,0,0,1,0,0],backgroundVpt:!0,overlayVpt:!0,onBeforeScaleRotate:function(){},enableRetinaScaling:!0,_initStatic:function(t,e){var i=fabric.StaticCanvas.prototype.renderAll.bind(this);this._objects=[],this._createLowerCanvas(t),this._initOptions(e),this._setImageSmoothing(),this.interactive||this._initRetinaScaling(),e.overlayImage&&this.setOverlayImage(e.overlayImage,i),e.backgroundImage&&this.setBackgroundImage(e.backgroundImage,i),e.backgroundColor&&this.setBackgroundColor(e.backgroundColor,i),e.overlayColor&&this.setOverlayColor(e.overlayColor,i),this.calcOffset()},_isRetinaScaling:function(){return 1!==fabric.devicePixelRatio&&this.enableRetinaScaling},getRetinaScaling:function(){return this._isRetinaScaling()?fabric.devicePixelRatio:1},_initRetinaScaling:function(){this._isRetinaScaling()&&(this.lowerCanvasEl.setAttribute("width",this.width*fabric.devicePixelRatio),this.lowerCanvasEl.setAttribute("height",this.height*fabric.devicePixelRatio),this.contextContainer.scale(fabric.devicePixelRatio,fabric.devicePixelRatio))},calcOffset:function(){return this._offset=e(this.lowerCanvasEl),this},setOverlayImage:function(t,e,i){return this.__setBgOverlayImage("overlayImage",t,e,i)},setBackgroundImage:function(t,e,i){return this.__setBgOverlayImage("backgroundImage",t,e,i)},setOverlayColor:function(t,e){return this.__setBgOverlayColor("overlayColor",t,e)},setBackgroundColor:function(t,e){return this.__setBgOverlayColor("backgroundColor",t,e)},_setImageSmoothing:function(){var t=this.getContext();t.imageSmoothingEnabled=t.imageSmoothingEnabled||t.webkitImageSmoothingEnabled||t.mozImageSmoothingEnabled||t.msImageSmoothingEnabled||t.oImageSmoothingEnabled,t.imageSmoothingEnabled=this.imageSmoothingEnabled},__setBgOverlayImage:function(t,e,i,r){return"string"==typeof e?fabric.util.loadImage(e,function(e){e&&(this[t]=new fabric.Image(e,r)),i&&i(e)},this,r&&r.crossOrigin):(r&&e.setOptions(r),this[t]=e,i&&i(e)),this},__setBgOverlayColor:function(t,e,i){return this[t]=e,this._initGradient(e,t),this._initPattern(e,t,i),this},_createCanvasElement:function(t){var e=fabric.util.createCanvasElement(t);if(e.style||(e.style={}),!e)throw n;if("undefined"==typeof e.getContext)throw n;return e},_initOptions:function(t){this._setOptions(t),this.width=this.width||parseInt(this.lowerCanvasEl.width,10)||0,this.height=this.height||parseInt(this.lowerCanvasEl.height,10)||0,this.lowerCanvasEl.style&&(this.lowerCanvasEl.width=this.width,this.lowerCanvasEl.height=this.height,this.lowerCanvasEl.style.width=this.width+"px",this.lowerCanvasEl.style.height=this.height+"px",this.viewportTransform=this.viewportTransform.slice())},_createLowerCanvas:function(t){this.lowerCanvasEl=fabric.util.getById(t)||this._createCanvasElement(t),fabric.util.addClass(this.lowerCanvasEl,"lower-canvas"),this.interactive&&this._applyCanvasStyle(this.lowerCanvasEl),this.contextContainer=this.lowerCanvasEl.getContext("2d")},getWidth:function(){return this.width},getHeight:function(){return this.height},setWidth:function(t,e){return this.setDimensions({width:t},e)},setHeight:function(t,e){return this.setDimensions({height:t},e)},setDimensions:function(t,e){var i;e=e||{};for(var r in t)i=t[r],e.cssOnly||(this._setBackstoreDimension(r,t[r]),i+="px"),e.backstoreOnly||this._setCssDimension(r,i);return this._initRetinaScaling(),this._setImageSmoothing(),this.calcOffset(),e.cssOnly||this.renderAll(),this},_setBackstoreDimension:function(t,e){return this.lowerCanvasEl[t]=e,this.upperCanvasEl&&(this.upperCanvasEl[t]=e),this.cacheCanvasEl&&(this.cacheCanvasEl[t]=e),this[t]=e,this},_setCssDimension:function(t,e){return this.lowerCanvasEl.style[t]=e,this.upperCanvasEl&&(this.upperCanvasEl.style[t]=e),this.wrapperEl&&(this.wrapperEl.style[t]=e),this},getZoom:function(){return this.viewportTransform[0]},setViewportTransform:function(t){var e,i=this._activeGroup,r=!1,n=!0;this.viewportTransform=t;for(var s=0,o=this._objects.length;s<o;s++)e=this._objects[s],e.group||e.setCoords(r,n);return i&&i.setCoords(r,n),this.renderAll(),this},zoomToPoint:function(t,e){var i=t,r=this.viewportTransform.slice(0);t=fabric.util.transformPoint(t,fabric.util.invertTransform(this.viewportTransform)),r[0]=e,r[3]=e;var n=fabric.util.transformPoint(t,r);return r[4]+=i.x-n.x,r[5]+=i.y-n.y,this.setViewportTransform(r)},setZoom:function(t){return this.zoomToPoint(new fabric.Point(0,0),t),this},absolutePan:function(t){var e=this.viewportTransform.slice(0);return e[4]=-t.x,e[5]=-t.y,this.setViewportTransform(e)},relativePan:function(t){return this.absolutePan(new fabric.Point(-t.x-this.viewportTransform[4],-t.y-this.viewportTransform[5]))},getElement:function(){return this.lowerCanvasEl},_onObjectAdded:function(t){this.stateful&&t.setupState(),t._set("canvas",this),t.setCoords(),this.fire("object:added",{target:t}),t.fire("added")},_onObjectRemoved:function(t){this.fire("object:removed",{target:t}),t.fire("removed"),delete t.canvas},clearContext:function(t){return t.clearRect(0,0,this.width,this.height),this},getContext:function(){return this.contextContainer},clear:function(){return this._objects.length=0,this.backgroundImage=null,this.overlayImage=null,this.backgroundColor="",this.overlayColor="",this._hasITextHandlers&&(this.off("selection:cleared",this._canvasITextSelectionClearedHanlder),this.off("object:selected",this._canvasITextSelectionClearedHanlder),this.off("mouse:up",this._mouseUpITextHandler),this._iTextInstances=null,this._hasITextHandlers=!1),this.clearContext(this.contextContainer),this.fire("canvas:cleared"),this.renderAll(),this},renderAll:function(){var t=this.contextContainer;return this.renderCanvas(t,this._objects),this},renderCanvas:function(t,e){this.clearContext(t),this.fire("before:render"),this.clipTo&&fabric.util.clipContext(this,t),this._renderBackground(t),t.save(),t.transform.apply(t,this.viewportTransform),this._renderObjects(t,e),t.restore(),!this.controlsAboveOverlay&&this.interactive&&this.drawControls(t),this.clipTo&&t.restore(),this._renderOverlay(t),this.controlsAboveOverlay&&this.interactive&&this.drawControls(t),this.fire("after:render")},_renderObjects:function(t,e){for(var i=0,r=e.length;i<r;++i)e[i]&&e[i].render(t)},_renderBackgroundOrOverlay:function(t,e){var i=this[e+"Color"];i&&(t.fillStyle=i.toLive?i.toLive(t,this):i,t.fillRect(i.offsetX||0,i.offsetY||0,this.width,this.height)),i=this[e+"Image"],i&&(this[e+"Vpt"]&&(t.save(),t.transform.apply(t,this.viewportTransform)),i.render(t),this[e+"Vpt"]&&t.restore())},_renderBackground:function(t){this._renderBackgroundOrOverlay(t,"background")},_renderOverlay:function(t){this._renderBackgroundOrOverlay(t,"overlay")},getCenter:function(){return{top:this.getHeight()/2,left:this.getWidth()/2}},centerObjectH:function(t){return this._centerObject(t,new fabric.Point(this.getCenter().left,t.getCenterPoint().y))},centerObjectV:function(t){return this._centerObject(t,new fabric.Point(t.getCenterPoint().x,this.getCenter().top))},centerObject:function(t){
var e=this.getCenter();return this._centerObject(t,new fabric.Point(e.left,e.top))},viewportCenterObject:function(t){var e=this.getVpCenter();return this._centerObject(t,e)},viewportCenterObjectH:function(t){var e=this.getVpCenter();return this._centerObject(t,new fabric.Point(e.x,t.getCenterPoint().y)),this},viewportCenterObjectV:function(t){var e=this.getVpCenter();return this._centerObject(t,new fabric.Point(t.getCenterPoint().x,e.y))},getVpCenter:function(){var t=this.getCenter(),e=fabric.util.invertTransform(this.viewportTransform);return fabric.util.transformPoint({x:t.left,y:t.top},e)},_centerObject:function(t,e){return t.setPositionByOrigin(e,"center","center"),this.renderAll(),this},toDatalessJSON:function(t){return this.toDatalessObject(t)},toObject:function(t){return this._toObjectMethod("toObject",t)},toDatalessObject:function(t){return this._toObjectMethod("toDatalessObject",t)},_toObjectMethod:function(e,i){var r={objects:this._toObjects(e,i)};return t(r,this.__serializeBgOverlay(e,i)),fabric.util.populateWithProperties(this,r,i),r},_toObjects:function(t,e){return this.getObjects().filter(function(t){return!t.excludeFromExport}).map(function(i){return this._toObject(i,t,e)},this)},_toObject:function(t,e,i){var r;this.includeDefaultValues||(r=t.includeDefaultValues,t.includeDefaultValues=!1);var n=t[e](i);return this.includeDefaultValues||(t.includeDefaultValues=r),n},__serializeBgOverlay:function(t,e){var i={};return this.backgroundColor&&(i.background=this.backgroundColor.toObject?this.backgroundColor.toObject(e):this.backgroundColor),this.overlayColor&&(i.overlay=this.overlayColor.toObject?this.overlayColor.toObject(e):this.overlayColor),this.backgroundImage&&(i.backgroundImage=this._toObject(this.backgroundImage,t,e)),this.overlayImage&&(i.overlayImage=this._toObject(this.overlayImage,t,e)),i},svgViewportTransformation:!0,toSVG:function(t,e){t||(t={});var i=[];return this._setSVGPreamble(i,t),this._setSVGHeader(i,t),this._setSVGBgOverlayColor(i,"backgroundColor"),this._setSVGBgOverlayImage(i,"backgroundImage",e),this._setSVGObjects(i,e),this._setSVGBgOverlayColor(i,"overlayColor"),this._setSVGBgOverlayImage(i,"overlayImage",e),i.push("</svg>"),i.join("")},_setSVGPreamble:function(t,e){e.suppressPreamble||t.push('<?xml version="1.0" encoding="',e.encoding||"UTF-8",'" standalone="no" ?>\n','<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ','"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n')},_setSVGHeader:function(t,e){var i,n=e.width||this.width,s=e.height||this.height,o='viewBox="0 0 '+this.width+" "+this.height+'" ',a=fabric.Object.NUM_FRACTION_DIGITS;e.viewBox?o='viewBox="'+e.viewBox.x+" "+e.viewBox.y+" "+e.viewBox.width+" "+e.viewBox.height+'" ':this.svgViewportTransformation&&(i=this.viewportTransform,o='viewBox="'+r(-i[4]/i[0],a)+" "+r(-i[5]/i[3],a)+" "+r(this.width/i[0],a)+" "+r(this.height/i[3],a)+'" '),t.push("<svg ",'xmlns="http://www.w3.org/2000/svg" ','xmlns:xlink="http://www.w3.org/1999/xlink" ','version="1.1" ','width="',n,'" ','height="',s,'" ',o,'xml:space="preserve">\n',"<desc>Created with Fabric.js ",fabric.version,"</desc>\n","<defs>\n",this.createSVGFontFacesMarkup(),this.createSVGRefElementsMarkup(),"</defs>\n")},createSVGRefElementsMarkup:function(){var t=this,e=["backgroundColor","overlayColor"].map(function(e){var i=t[e];if(i&&i.toLive)return i.toSVG(t,!1)});return e.join("")},createSVGFontFacesMarkup:function(){for(var t,e,i,r,n,s,o,a="",h={},c=fabric.fontPaths,l=this.getObjects(),u=0,f=l.length;u<f;u++)if(t=l[u],e=t.fontFamily,t.type.indexOf("text")!==-1&&!h[e]&&c[e]&&(h[e]=!0,t.styles)){i=t.styles;for(n in i){r=i[n];for(o in r)s=r[o],e=s.fontFamily,!h[e]&&c[e]&&(h[e]=!0)}}for(var d in h)a+=["\t\t@font-face {\n","\t\t\tfont-family: '",d,"';\n","\t\t\tsrc: url('",c[d],"');\n","\t\t}\n"].join("");return a&&(a=['\t<style type="text/css">',"<![CDATA[\n",a,"]]>","</style>\n"].join("")),a},_setSVGObjects:function(t,e){for(var i,r=0,n=this.getObjects(),s=n.length;r<s;r++)i=n[r],i.excludeFromExport||this._setSVGObject(t,i,e)},_setSVGObject:function(t,e,i){t.push(e.toSVG(i))},_setSVGBgOverlayImage:function(t,e,i){this[e]&&this[e].toSVG&&t.push(this[e].toSVG(i))},_setSVGBgOverlayColor:function(t,e){var i=this[e];if(i)if(i.toLive){var r=i.repeat;t.push('<rect transform="translate(',this.width/2,",",this.height/2,')"',' x="',i.offsetX-this.width/2,'" y="',i.offsetY-this.height/2,'" ','width="',"repeat-y"===r||"no-repeat"===r?i.source.width:this.width,'" height="',"repeat-x"===r||"no-repeat"===r?i.source.height:this.height,'" fill="url(#SVGID_'+i.id+')"',"></rect>\n")}else t.push('<rect x="0" y="0" ','width="',this.width,'" height="',this.height,'" fill="',this[e],'"',"></rect>\n")},sendToBack:function(t){if(!t)return this;var e,r,n,s=this._activeGroup;if(t===s)for(n=s._objects,e=n.length;e--;)r=n[e],i(this._objects,r),this._objects.unshift(r);else i(this._objects,t),this._objects.unshift(t);return this.renderAll&&this.renderAll()},bringToFront:function(t){if(!t)return this;var e,r,n,s=this._activeGroup;if(t===s)for(n=s._objects,e=0;e<n.length;e++)r=n[e],i(this._objects,r),this._objects.push(r);else i(this._objects,t),this._objects.push(t);return this.renderAll&&this.renderAll()},sendBackwards:function(t,e){if(!t)return this;var r,n,s,o,a,h=this._activeGroup;if(t===h)for(a=h._objects,r=0;r<a.length;r++)n=a[r],s=this._objects.indexOf(n),0!==s&&(o=s-1,i(this._objects,n),this._objects.splice(o,0,n));else s=this._objects.indexOf(t),0!==s&&(o=this._findNewLowerIndex(t,s,e),i(this._objects,t),this._objects.splice(o,0,t));return this.renderAll&&this.renderAll(),this},_findNewLowerIndex:function(t,e,i){var r;if(i){r=e;for(var n=e-1;n>=0;--n){var s=t.intersectsWithObject(this._objects[n])||t.isContainedWithinObject(this._objects[n])||this._objects[n].isContainedWithinObject(t);if(s){r=n;break}}}else r=e-1;return r},bringForward:function(t,e){if(!t)return this;var r,n,s,o,a,h=this._activeGroup;if(t===h)for(a=h._objects,r=a.length;r--;)n=a[r],s=this._objects.indexOf(n),s!==this._objects.length-1&&(o=s+1,i(this._objects,n),this._objects.splice(o,0,n));else s=this._objects.indexOf(t),s!==this._objects.length-1&&(o=this._findNewUpperIndex(t,s,e),i(this._objects,t),this._objects.splice(o,0,t));return this.renderAll&&this.renderAll(),this},_findNewUpperIndex:function(t,e,i){var r;if(i){r=e;for(var n=e+1;n<this._objects.length;++n){var s=t.intersectsWithObject(this._objects[n])||t.isContainedWithinObject(this._objects[n])||this._objects[n].isContainedWithinObject(t);if(s){r=n;break}}}else r=e+1;return r},moveTo:function(t,e){return i(this._objects,t),this._objects.splice(e,0,t),this.renderAll&&this.renderAll()},dispose:function(){return this.clear(),this},toString:function(){return"#<fabric.Canvas ("+this.complexity()+"): { objects: "+this.getObjects().length+" }>"}}),t(fabric.StaticCanvas.prototype,fabric.Observable),t(fabric.StaticCanvas.prototype,fabric.Collection),t(fabric.StaticCanvas.prototype,fabric.DataURLExporter),t(fabric.StaticCanvas,{EMPTY_JSON:'{"objects": [], "background": "white"}',supports:function(t){var e=fabric.util.createCanvasElement();if(!e||!e.getContext)return null;var i=e.getContext("2d");if(!i)return null;switch(t){case"getImageData":return"undefined"!=typeof i.getImageData;case"setLineDash":return"undefined"!=typeof i.setLineDash;case"toDataURL":return"undefined"!=typeof e.toDataURL;case"toDataURLWithQuality":try{return e.toDataURL("image/jpeg",0),!0}catch(t){}return!1;default:return null}}}),fabric.StaticCanvas.prototype.toJSON=fabric.StaticCanvas.prototype.toObject}(),fabric.BaseBrush=fabric.util.createClass({color:"rgb(0, 0, 0)",width:1,shadow:null,strokeLineCap:"round",strokeLineJoin:"round",strokeDashArray:null,setShadow:function(t){return this.shadow=new fabric.Shadow(t),this},_setBrushStyles:function(){var t=this.canvas.contextTop;t.strokeStyle=this.color,t.lineWidth=this.width,t.lineCap=this.strokeLineCap,t.lineJoin=this.strokeLineJoin,this.strokeDashArray&&fabric.StaticCanvas.supports("setLineDash")&&t.setLineDash(this.strokeDashArray)},_setShadow:function(){if(this.shadow){var t=this.canvas.contextTop,e=this.canvas.getZoom();t.shadowColor=this.shadow.color,t.shadowBlur=this.shadow.blur*e,t.shadowOffsetX=this.shadow.offsetX*e,t.shadowOffsetY=this.shadow.offsetY*e}},_resetShadow:function(){var t=this.canvas.contextTop;t.shadowColor="",t.shadowBlur=t.shadowOffsetX=t.shadowOffsetY=0}}),function(){fabric.PencilBrush=fabric.util.createClass(fabric.BaseBrush,{initialize:function(t){this.canvas=t,this._points=[]},onMouseDown:function(t){this._prepareForDrawing(t),this._captureDrawingPath(t),this._render()},onMouseMove:function(t){this._captureDrawingPath(t),this.canvas.clearContext(this.canvas.contextTop),this._render()},onMouseUp:function(){this._finalizeAndAddPath()},_prepareForDrawing:function(t){var e=new fabric.Point(t.x,t.y);this._reset(),this._addPoint(e),this.canvas.contextTop.moveTo(e.x,e.y)},_addPoint:function(t){this._points.push(t)},_reset:function(){this._points.length=0,this._setBrushStyles(),this._setShadow()},_captureDrawingPath:function(t){var e=new fabric.Point(t.x,t.y);this._addPoint(e)},_render:function(){var t=this.canvas.contextTop,e=this.canvas.viewportTransform,i=this._points[0],r=this._points[1];t.save(),t.transform(e[0],e[1],e[2],e[3],e[4],e[5]),t.beginPath(),2===this._points.length&&i.x===r.x&&i.y===r.y&&(i.x-=.5,r.x+=.5),t.moveTo(i.x,i.y);for(var n=1,s=this._points.length;n<s;n++){var o=i.midPointFrom(r);t.quadraticCurveTo(i.x,i.y,o.x,o.y),i=this._points[n],r=this._points[n+1]}t.lineTo(i.x,i.y),t.stroke(),t.restore()},convertPointsToSVGPath:function(t){var e=[],i=new fabric.Point(t[0].x,t[0].y),r=new fabric.Point(t[1].x,t[1].y);e.push("M ",t[0].x," ",t[0].y," ");for(var n=1,s=t.length;n<s;n++){var o=i.midPointFrom(r);e.push("Q ",i.x," ",i.y," ",o.x," ",o.y," "),i=new fabric.Point(t[n].x,t[n].y),n+1<t.length&&(r=new fabric.Point(t[n+1].x,t[n+1].y))}return e.push("L ",i.x," ",i.y," "),e},createPath:function(t){var e=new fabric.Path(t,{fill:null,stroke:this.color,strokeWidth:this.width,strokeLineCap:this.strokeLineCap,strokeLineJoin:this.strokeLineJoin,strokeDashArray:this.strokeDashArray,originX:"center",originY:"center"});return this.shadow&&(this.shadow.affectStroke=!0,e.setShadow(this.shadow)),e},_finalizeAndAddPath:function(){var t=this.canvas.contextTop;t.closePath();var e=this.convertPointsToSVGPath(this._points).join("");if("M 0 0 Q 0 0 0 0 L 0 0"===e)return void this.canvas.renderAll();var i=this.createPath(e);this.canvas.add(i),i.setCoords(),this.canvas.clearContext(this.canvas.contextTop),this._resetShadow(),this.canvas.renderAll(),this.canvas.fire("path:created",{path:i})}})}(),fabric.CircleBrush=fabric.util.createClass(fabric.BaseBrush,{width:10,initialize:function(t){this.canvas=t,this.points=[]},drawDot:function(t){var e=this.addPoint(t),i=this.canvas.contextTop,r=this.canvas.viewportTransform;i.save(),i.transform(r[0],r[1],r[2],r[3],r[4],r[5]),i.fillStyle=e.fill,i.beginPath(),i.arc(e.x,e.y,e.radius,0,2*Math.PI,!1),i.closePath(),i.fill(),i.restore()},onMouseDown:function(t){this.points.length=0,this.canvas.clearContext(this.canvas.contextTop),this._setShadow(),this.drawDot(t)},onMouseMove:function(t){this.drawDot(t)},onMouseUp:function(){var t=this.canvas.renderOnAddRemove;this.canvas.renderOnAddRemove=!1;for(var e=[],i=0,r=this.points.length;i<r;i++){var n=this.points[i],s=new fabric.Circle({radius:n.radius,left:n.x,top:n.y,originX:"center",originY:"center",fill:n.fill});this.shadow&&s.setShadow(this.shadow),e.push(s)}var o=new fabric.Group(e,{originX:"center",originY:"center"});o.canvas=this.canvas,this.canvas.add(o),this.canvas.fire("path:created",{path:o}),this.canvas.clearContext(this.canvas.contextTop),this._resetShadow(),this.canvas.renderOnAddRemove=t,this.canvas.renderAll()},addPoint:function(t){var e=new fabric.Point(t.x,t.y),i=fabric.util.getRandomInt(Math.max(0,this.width-20),this.width+20)/2,r=new fabric.Color(this.color).setAlpha(fabric.util.getRandomInt(0,100)/100).toRgba();return e.radius=i,e.fill=r,this.points.push(e),e}}),fabric.SprayBrush=fabric.util.createClass(fabric.BaseBrush,{width:10,density:20,dotWidth:1,dotWidthVariance:1,randomOpacity:!1,optimizeOverlapping:!0,initialize:function(t){this.canvas=t,this.sprayChunks=[]},onMouseDown:function(t){this.sprayChunks.length=0,this.canvas.clearContext(this.canvas.contextTop),this._setShadow(),this.addSprayChunk(t),this.render()},onMouseMove:function(t){this.addSprayChunk(t),this.render()},onMouseUp:function(){var t=this.canvas.renderOnAddRemove;this.canvas.renderOnAddRemove=!1;for(var e=[],i=0,r=this.sprayChunks.length;i<r;i++)for(var n=this.sprayChunks[i],s=0,o=n.length;s<o;s++){var a=new fabric.Rect({width:n[s].width,height:n[s].width,left:n[s].x+1,top:n[s].y+1,originX:"center",originY:"center",fill:this.color});this.shadow&&a.setShadow(this.shadow),e.push(a)}this.optimizeOverlapping&&(e=this._getOptimizedRects(e));var h=new fabric.Group(e,{originX:"center",originY:"center"});h.canvas=this.canvas,this.canvas.add(h),this.canvas.fire("path:created",{path:h}),this.canvas.clearContext(this.canvas.contextTop),this._resetShadow(),this.canvas.renderOnAddRemove=t,this.canvas.renderAll()},_getOptimizedRects:function(t){for(var e,i={},r=0,n=t.length;r<n;r++)e=t[r].left+""+t[r].top,i[e]||(i[e]=t[r]);var s=[];for(e in i)s.push(i[e]);return s},render:function(){var t=this.canvas.contextTop;t.fillStyle=this.color;var e=this.canvas.viewportTransform;t.save(),t.transform(e[0],e[1],e[2],e[3],e[4],e[5]);for(var i=0,r=this.sprayChunkPoints.length;i<r;i++){var n=this.sprayChunkPoints[i];"undefined"!=typeof n.opacity&&(t.globalAlpha=n.opacity),t.fillRect(n.x,n.y,n.width,n.width)}t.restore()},addSprayChunk:function(t){this.sprayChunkPoints=[];for(var e,i,r,n=this.width/2,s=0;s<this.density;s++){e=fabric.util.getRandomInt(t.x-n,t.x+n),i=fabric.util.getRandomInt(t.y-n,t.y+n),r=this.dotWidthVariance?fabric.util.getRandomInt(Math.max(1,this.dotWidth-this.dotWidthVariance),this.dotWidth+this.dotWidthVariance):this.dotWidth;var o=new fabric.Point(e,i);o.width=r,this.randomOpacity&&(o.opacity=fabric.util.getRandomInt(0,100)/100),this.sprayChunkPoints.push(o)}this.sprayChunks.push(this.sprayChunkPoints)}}),fabric.PatternBrush=fabric.util.createClass(fabric.PencilBrush,{getPatternSrc:function(){var t=20,e=5,i=fabric.document.createElement("canvas"),r=i.getContext("2d");return i.width=i.height=t+e,r.fillStyle=this.color,r.beginPath(),r.arc(t/2,t/2,t/2,0,2*Math.PI,!1),r.closePath(),r.fill(),i},getPatternSrcFunction:function(){return String(this.getPatternSrc).replace("this.color",'"'+this.color+'"')},getPattern:function(){return this.canvas.contextTop.createPattern(this.source||this.getPatternSrc(),"repeat")},_setBrushStyles:function(){this.callSuper("_setBrushStyles"),this.canvas.contextTop.strokeStyle=this.getPattern()},createPath:function(t){var e=this.callSuper("createPath",t),i=e._getLeftTopCoords().scalarAdd(e.strokeWidth/2);return e.stroke=new fabric.Pattern({source:this.source||this.getPatternSrcFunction(),offsetX:-i.x,offsetY:-i.y}),e}}),function(){var t=fabric.util.getPointer,e=fabric.util.degreesToRadians,i=fabric.util.radiansToDegrees,r=Math.atan2,n=Math.abs,s=fabric.StaticCanvas.supports("setLineDash"),o=.5;fabric.Canvas=fabric.util.createClass(fabric.StaticCanvas,{initialize:function(t,e){e||(e={}),this._initStatic(t,e),this._initInteractive(),this._createCacheCanvas()},uniScaleTransform:!1,uniScaleKey:"shiftKey",centeredScaling:!1,centeredRotation:!1,centeredKey:"altKey",altActionKey:"shiftKey",interactive:!0,selection:!0,selectionKey:"shiftKey",altSelectionKey:null,selectionColor:"rgba(100, 100, 255, 0.3)",selectionDashArray:[],selectionBorderColor:"rgba(255, 255, 255, 0.3)",selectionLineWidth:1,hoverCursor:"move",moveCursor:"move",defaultCursor:"default",freeDrawingCursor:"crosshair",rotationCursor:"crosshair",containerClass:"canvas-container",perPixelTargetFind:!1,targetFindTolerance:0,skipTargetFind:!1,isDrawingMode:!1,preserveObjectStacking:!1,snapAngle:0,snapThreshold:null,stopContextMenu:!1,fireRightClick:!1,_initInteractive:function(){this._currentTransform=null,this._groupSelector=null,this._initWrapperElement(),this._createUpperCanvas(),this._initEventListeners(),this._initRetinaScaling(),this.freeDrawingBrush=fabric.PencilBrush&&new fabric.PencilBrush(this),this.calcOffset()},_chooseObjectsToRender:function(){var t,e=this.getActiveGroup(),i=this.getActiveObject(),r=[],n=[];if(!e&&!i||this.preserveObjectStacking)r=this._objects;else{for(var s=0,o=this._objects.length;s<o;s++)t=this._objects[s],e&&e.contains(t)||t===i?n.push(t):r.push(t);e&&(e._set("_objects",n),r.push(e)),i&&r.push(i)}return r},renderAll:function(){!this.contextTopDirty||this._groupSelector||this.isDrawingMode||(this.clearContext(this.contextTop),this.contextTopDirty=!1);var t=this.contextContainer;return this.renderCanvas(t,this._chooseObjectsToRender()),this},renderTop:function(){var t=this.contextTop;return this.clearContext(t),this.selection&&this._groupSelector&&this._drawSelection(t),this.fire("after:render"),this.contextTopDirty=!0,this},_resetCurrentTransform:function(){var t=this._currentTransform;t.target.set({scaleX:t.original.scaleX,scaleY:t.original.scaleY,skewX:t.original.skewX,skewY:t.original.skewY,left:t.original.left,top:t.original.top}),this._shouldCenterTransform(t.target)?"rotate"===t.action?this._setOriginToCenter(t.target):("center"!==t.originX&&("right"===t.originX?t.mouseXSign=-1:t.mouseXSign=1),"center"!==t.originY&&("bottom"===t.originY?t.mouseYSign=-1:t.mouseYSign=1),t.originX="center",t.originY="center"):(t.originX=t.original.originX,t.originY=t.original.originY)},containsPoint:function(t,e,i){var r,n=!0,s=i||this.getPointer(t,n);return r=e.group&&e.group===this.getActiveGroup()?this._normalizePointer(e.group,s):{x:s.x,y:s.y},e.containsPoint(r)||e._findTargetCorner(s)},_normalizePointer:function(t,e){var i=t.calcTransformMatrix(),r=fabric.util.invertTransform(i),n=this.restorePointerVpt(e);return fabric.util.transformPoint(n,r)},isTargetTransparent:function(t,e,i){var r=t.hasBorders,n=t.transparentCorners,s=this.contextCache,o=t.selectionBackgroundColor;t.hasBorders=t.transparentCorners=!1,t.selectionBackgroundColor="",s.save(),s.transform.apply(s,this.viewportTransform),t.render(s),s.restore(),t.active&&t._renderControls(s),t.hasBorders=r,t.transparentCorners=n,t.selectionBackgroundColor=o;var a=fabric.util.isTransparent(s,e,i,this.targetFindTolerance);return this.clearContext(s),a},_shouldClearSelection:function(t,e){var i=this.getActiveGroup(),r=this.getActiveObject();return!e||e&&i&&!i.contains(e)&&i!==e&&!t[this.selectionKey]||e&&!e.evented||e&&!e.selectable&&r&&r!==e},_shouldCenterTransform:function(t){if(t){var e,i=this._currentTransform;return"scale"===i.action||"scaleX"===i.action||"scaleY"===i.action?e=this.centeredScaling||t.centeredScaling:"rotate"===i.action&&(e=this.centeredRotation||t.centeredRotation),e?!i.altKey:i.altKey}},_getOriginFromCorner:function(t,e){var i={x:t.originX,y:t.originY};return"ml"===e||"tl"===e||"bl"===e?i.x="right":"mr"!==e&&"tr"!==e&&"br"!==e||(i.x="left"),"tl"===e||"mt"===e||"tr"===e?i.y="bottom":"bl"!==e&&"mb"!==e&&"br"!==e||(i.y="top"),i},_getActionFromCorner:function(t,e,i){if(!e)return"drag";switch(e){case"mtr":return"rotate";case"ml":case"mr":return i[this.altActionKey]?"skewY":"scaleX";case"mt":case"mb":return i[this.altActionKey]?"skewX":"scaleY";default:return"scale"}},_setupCurrentTransform:function(t,i){if(i){var r=this.getPointer(t),n=i._findTargetCorner(this.getPointer(t,!0)),s=this._getActionFromCorner(i,n,t),o=this._getOriginFromCorner(i,n);this._currentTransform={target:i,action:s,corner:n,scaleX:i.scaleX,scaleY:i.scaleY,skewX:i.skewX,skewY:i.skewY,offsetX:r.x-i.left,offsetY:r.y-i.top,originX:o.x,originY:o.y,ex:r.x,ey:r.y,lastX:r.x,lastY:r.y,left:i.left,top:i.top,theta:e(i.angle),width:i.width*i.scaleX,mouseXSign:1,mouseYSign:1,shiftKey:t.shiftKey,altKey:t[this.centeredKey]},this._currentTransform.original={left:i.left,top:i.top,scaleX:i.scaleX,scaleY:i.scaleY,skewX:i.skewX,skewY:i.skewY,originX:o.x,originY:o.y},this._resetCurrentTransform()}},_translateObject:function(t,e){var i=this._currentTransform,r=i.target,n=t-i.offsetX,s=e-i.offsetY,o=!r.get("lockMovementX")&&r.left!==n,a=!r.get("lockMovementY")&&r.top!==s;return o&&r.set("left",n),a&&r.set("top",s),o||a},_changeSkewTransformOrigin:function(t,e,i){var r="originX",n={0:"center"},s=e.target.skewX,o="left",a="right",h="mt"===e.corner||"ml"===e.corner?1:-1,c=1;t=t>0?1:-1,"y"===i&&(s=e.target.skewY,o="top",a="bottom",r="originY"),n[-1]=o,n[1]=a,e.target.flipX&&(c*=-1),e.target.flipY&&(c*=-1),0===s?(e.skewSign=-h*t*c,e[r]=n[-t]):(s=s>0?1:-1,e.skewSign=s,e[r]=n[s*h*c])},_skewObject:function(t,e,i){var r=this._currentTransform,n=r.target,s=!1,o=n.get("lockSkewingX"),a=n.get("lockSkewingY");if(o&&"x"===i||a&&"y"===i)return!1;var h,c,l=n.getCenterPoint(),u=n.toLocalPoint(new fabric.Point(t,e),"center","center")[i],f=n.toLocalPoint(new fabric.Point(r.lastX,r.lastY),"center","center")[i],d=n._getTransformedDimensions();return this._changeSkewTransformOrigin(u-f,r,i),h=n.toLocalPoint(new fabric.Point(t,e),r.originX,r.originY)[i],c=n.translateToOriginPoint(l,r.originX,r.originY),s=this._setObjectSkew(h,r,i,d),r.lastX=t,r.lastY=e,n.setPositionByOrigin(c,r.originX,r.originY),s},_setObjectSkew:function(t,e,i,r){var n,s,o,a,h,c,l,u,f,d=e.target,g=!1,p=e.skewSign;return"x"===i?(a="y",h="Y",c="X",u=0,f=d.skewY):(a="x",h="X",c="Y",u=d.skewX,f=0),o=d._getTransformedDimensions(u,f),l=2*Math.abs(t)-o[i],l<=2?n=0:(n=p*Math.atan(l/d["scale"+c]/(o[a]/d["scale"+h])),n=fabric.util.radiansToDegrees(n)),g=d["skew"+c]!==n,d.set("skew"+c,n),0!==d["skew"+h]&&(s=d._getTransformedDimensions(),n=r[a]/s[a]*d["scale"+h],d.set("scale"+h,n)),g},_scaleObject:function(t,e,i){var r=this._currentTransform,n=r.target,s=n.get("lockScalingX"),o=n.get("lockScalingY"),a=n.get("lockScalingFlip");if(s&&o)return!1;var h=n.translateToOriginPoint(n.getCenterPoint(),r.originX,r.originY),c=n.toLocalPoint(new fabric.Point(t,e),r.originX,r.originY),l=n._getTransformedDimensions(),u=!1;return this._setLocalMouse(c,r),u=this._setObjectScale(c,r,s,o,i,a,l),n.setPositionByOrigin(h,r.originX,r.originY),u},_setObjectScale:function(t,e,i,r,n,s,o){var a,h,c,l,u=e.target,f=!1,d=!1,g=!1;return c=t.x*u.scaleX/o.x,l=t.y*u.scaleY/o.y,a=u.scaleX!==c,h=u.scaleY!==l,s&&c<=0&&c<u.scaleX&&(f=!0),s&&l<=0&&l<u.scaleY&&(d=!0),"equally"!==n||i||r?n?"x"!==n||u.get("lockUniScaling")?"y"!==n||u.get("lockUniScaling")||d||r||u.set("scaleY",l)&&(g=g||h):f||i||u.set("scaleX",c)&&(g=g||a):(f||i||u.set("scaleX",c)&&(g=g||a),d||r||u.set("scaleY",l)&&(g=g||h)):f||d||(g=this._scaleObjectEqually(t,u,e,o)),e.newScaleX=c,e.newScaleY=l,f||d||this._flipObject(e,n),g},_scaleObjectEqually:function(t,e,i,r){var n,s=t.y+t.x,o=r.y*i.original.scaleY/e.scaleY+r.x*i.original.scaleX/e.scaleX;return i.newScaleX=i.original.scaleX*s/o,i.newScaleY=i.original.scaleY*s/o,n=i.newScaleX!==e.scaleX||i.newScaleY!==e.scaleY,e.set("scaleX",i.newScaleX),e.set("scaleY",i.newScaleY),n},_flipObject:function(t,e){t.newScaleX<0&&"y"!==e&&("left"===t.originX?t.originX="right":"right"===t.originX&&(t.originX="left")),t.newScaleY<0&&"x"!==e&&("top"===t.originY?t.originY="bottom":"bottom"===t.originY&&(t.originY="top"))},_setLocalMouse:function(t,e){var i=e.target;"right"===e.originX?t.x*=-1:"center"===e.originX&&(t.x*=2*e.mouseXSign,t.x<0&&(e.mouseXSign=-e.mouseXSign)),"bottom"===e.originY?t.y*=-1:"center"===e.originY&&(t.y*=2*e.mouseYSign,t.y<0&&(e.mouseYSign=-e.mouseYSign)),n(t.x)>i.padding?t.x<0?t.x+=i.padding:t.x-=i.padding:t.x=0,n(t.y)>i.padding?t.y<0?t.y+=i.padding:t.y-=i.padding:t.y=0},_rotateObject:function(t,e){var n=this._currentTransform;if(n.target.get("lockRotation"))return!1;var s=r(n.ey-n.top,n.ex-n.left),o=r(e-n.top,t-n.left),a=i(o-s+n.theta),h=!0;if(a<0&&(a=360+a),a%=360,n.target.snapAngle>0){var c=n.target.snapAngle,l=n.target.snapThreshold||c,u=Math.ceil(a/c)*c,f=Math.floor(a/c)*c;Math.abs(a-f)<l?a=f:Math.abs(a-u)<l&&(a=u),n.target.angle===a&&(h=!1)}return n.target.angle=a,h},setCursor:function(t){this.upperCanvasEl.style.cursor=t},_resetObjectTransform:function(t){t.scaleX=1,t.scaleY=1,t.skewX=0,t.skewY=0,t.setAngle(0)},_drawSelection:function(t){var e=this._groupSelector,i=e.left,r=e.top,a=n(i),h=n(r);if(this.selectionColor&&(t.fillStyle=this.selectionColor,t.fillRect(e.ex-(i>0?0:-i),e.ey-(r>0?0:-r),a,h)),this.selectionLineWidth&&this.selectionBorderColor)if(t.lineWidth=this.selectionLineWidth,t.strokeStyle=this.selectionBorderColor,this.selectionDashArray.length>1&&!s){var c=e.ex+o-(i>0?0:a),l=e.ey+o-(r>0?0:h);t.beginPath(),fabric.util.drawDashedLine(t,c,l,c+a,l,this.selectionDashArray),fabric.util.drawDashedLine(t,c,l+h-1,c+a,l+h-1,this.selectionDashArray),fabric.util.drawDashedLine(t,c,l,c,l+h,this.selectionDashArray),fabric.util.drawDashedLine(t,c+a-1,l,c+a-1,l+h,this.selectionDashArray),t.closePath(),t.stroke()}else fabric.Object.prototype._setLineDash.call(this,t,this.selectionDashArray),t.strokeRect(e.ex+o-(i>0?0:a),e.ey+o-(r>0?0:h),a,h)},findTarget:function(t,e){if(!this.skipTargetFind){var i,r=!0,n=this.getPointer(t,r),s=this.getActiveGroup(),o=this.getActiveObject();if(s&&!e&&this._checkTarget(n,s))return this._fireOverOutEvents(s,t),s;if(o&&o._findTargetCorner(n))return this._fireOverOutEvents(o,t),o;if(o&&this._checkTarget(n,o)){if(!this.preserveObjectStacking)return this._fireOverOutEvents(o,t),o;i=o}this.targets=[];var a=this._searchPossibleTargets(this._objects,n);return t[this.altSelectionKey]&&a&&i&&a!==i&&(a=i),this._fireOverOutEvents(a,t),a}},_fireOverOutEvents:function(t,e){t?this._hoveredTarget!==t&&(this._hoveredTarget&&(this.fire("mouse:out",{target:this._hoveredTarget,e:e}),this._hoveredTarget.fire("mouseout")),this.fire("mouse:over",{target:t,e:e}),t.fire("mouseover"),this._hoveredTarget=t):this._hoveredTarget&&(this.fire("mouse:out",{target:this._hoveredTarget,e:e}),this._hoveredTarget.fire("mouseout"),this._hoveredTarget=null)},_checkTarget:function(t,e){if(e&&e.visible&&e.evented&&this.containsPoint(null,e,t)){if(!this.perPixelTargetFind&&!e.perPixelTargetFind||e.isEditing)return!0;var i=this.isTargetTransparent(e,t.x,t.y);if(!i)return!0}},_searchPossibleTargets:function(t,e){for(var i,r,n,s=t.length;s--;)if(this._checkTarget(e,t[s])){i=t[s],"group"===i.type&&i.subTargetCheck&&(r=this._normalizePointer(i,e),n=this._searchPossibleTargets(i._objects,r),n&&this.targets.push(n));break}return i},restorePointerVpt:function(t){return fabric.util.transformPoint(t,fabric.util.invertTransform(this.viewportTransform))},getPointer:function(e,i,r){r||(r=this.upperCanvasEl);var n,s=t(e),o=r.getBoundingClientRect(),a=o.width||0,h=o.height||0;return a&&h||("top"in o&&"bottom"in o&&(h=Math.abs(o.top-o.bottom)),"right"in o&&"left"in o&&(a=Math.abs(o.right-o.left))),this.calcOffset(),s.x=s.x-this._offset.left,s.y=s.y-this._offset.top,i||(s=this.restorePointerVpt(s)),n=0===a||0===h?{width:1,height:1}:{width:r.width/a,height:r.height/h},{x:s.x*n.width,y:s.y*n.height}},_createUpperCanvas:function(){var t=this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/,"");this.upperCanvasEl=this._createCanvasElement(),fabric.util.addClass(this.upperCanvasEl,"upper-canvas "+t),this.wrapperEl.appendChild(this.upperCanvasEl),this._copyCanvasStyle(this.lowerCanvasEl,this.upperCanvasEl),this._applyCanvasStyle(this.upperCanvasEl),this.contextTop=this.upperCanvasEl.getContext("2d")},_createCacheCanvas:function(){this.cacheCanvasEl=this._createCanvasElement(),this.cacheCanvasEl.setAttribute("width",this.width),this.cacheCanvasEl.setAttribute("height",this.height),this.contextCache=this.cacheCanvasEl.getContext("2d")},_initWrapperElement:function(){this.wrapperEl=fabric.util.wrapElement(this.lowerCanvasEl,"div",{class:this.containerClass}),fabric.util.setStyle(this.wrapperEl,{width:this.getWidth()+"px",height:this.getHeight()+"px",position:"relative"}),fabric.util.makeElementUnselectable(this.wrapperEl)},_applyCanvasStyle:function(t){var e=this.getWidth()||t.width,i=this.getHeight()||t.height;fabric.util.setStyle(t,{position:"absolute",width:e+"px",height:i+"px",left:0,top:0}),t.width=e,t.height=i,fabric.util.makeElementUnselectable(t)},_copyCanvasStyle:function(t,e){e.style.cssText=t.style.cssText},getSelectionContext:function(){return this.contextTop},getSelectionElement:function(){return this.upperCanvasEl},_setActiveObject:function(t){this._activeObject&&this._activeObject.set("active",!1),this._activeObject=t,t.set("active",!0)},setActiveObject:function(t,e){return this._setActiveObject(t),this.renderAll(),this.fire("object:selected",{target:t,e:e}),t.fire("selected",{e:e}),this},getActiveObject:function(){return this._activeObject},_onObjectRemoved:function(t){this.getActiveObject()===t&&(this.fire("before:selection:cleared",{target:t}),this._discardActiveObject(),this.fire("selection:cleared",{target:t}),t.fire("deselected")),this.callSuper("_onObjectRemoved",t)},_discardActiveObject:function(){this._activeObject&&this._activeObject.set("active",!1),this._activeObject=null},discardActiveObject:function(t){var e=this._activeObject;return this.fire("before:selection:cleared",{target:e,e:t}),this._discardActiveObject(),this.fire("selection:cleared",{e:t}),e&&e.fire("deselected",{e:t}),this},_setActiveGroup:function(t){this._activeGroup=t,t&&t.set("active",!0)},setActiveGroup:function(t,e){return this._setActiveGroup(t),t&&(this.fire("object:selected",{target:t,e:e}),t.fire("selected",{e:e})),this},getActiveGroup:function(){return this._activeGroup},_discardActiveGroup:function(){var t=this.getActiveGroup();t&&t.destroy(),this.setActiveGroup(null)},discardActiveGroup:function(t){var e=this.getActiveGroup();return this.fire("before:selection:cleared",{e:t,target:e}),this._discardActiveGroup(),this.fire("selection:cleared",{e:t}),this},deactivateAll:function(){for(var t,e=this.getObjects(),i=0,r=e.length;i<r;i++)t=e[i],t&&t.set("active",!1);return this._discardActiveGroup(),this._discardActiveObject(),this},deactivateAllWithDispatch:function(t){var e=this.getActiveGroup(),i=this.getActiveObject();return(i||e)&&this.fire("before:selection:cleared",{target:i||e,e:t}),this.deactivateAll(),(i||e)&&(this.fire("selection:cleared",{e:t,target:i}),i&&i.fire("deselected")),this},dispose:function(){this.callSuper("dispose");var t=this.wrapperEl;return this.removeListeners(),t.removeChild(this.upperCanvasEl),t.removeChild(this.lowerCanvasEl),delete this.upperCanvasEl,t.parentNode&&t.parentNode.replaceChild(this.lowerCanvasEl,this.wrapperEl),delete this.wrapperEl,this},clear:function(){return this.discardActiveGroup(),this.discardActiveObject(),this.clearContext(this.contextTop),this.callSuper("clear")},drawControls:function(t){var e=this.getActiveGroup();e?e._renderControls(t):this._drawObjectsControls(t)},_drawObjectsControls:function(t){for(var e=0,i=this._objects.length;e<i;++e)this._objects[e]&&this._objects[e].active&&this._objects[e]._renderControls(t)},_toObject:function(t,e,i){var r=this._realizeGroupTransformOnObject(t),n=this.callSuper("_toObject",t,e,i);return this._unwindGroupTransformOnObject(t,r),n},_realizeGroupTransformOnObject:function(t){var e=["angle","flipX","flipY","height","left","scaleX","scaleY","top","width"];if(t.group&&t.group===this.getActiveGroup()){var i={};return e.forEach(function(e){i[e]=t[e]}),this.getActiveGroup().realizeTransform(t),i}return null},_unwindGroupTransformOnObject:function(t,e){e&&t.set(e)},_setSVGObject:function(t,e,i){var r;r=this._realizeGroupTransformOnObject(e),this.callSuper("_setSVGObject",t,e,i),this._unwindGroupTransformOnObject(e,r)}});for(var a in fabric.StaticCanvas)"prototype"!==a&&(fabric.Canvas[a]=fabric.StaticCanvas[a]);fabric.isTouchSupported&&(fabric.Canvas.prototype._setCursorFromEvent=function(){}),fabric.Element=fabric.Canvas}(),function(){var t={mt:0,tr:1,mr:2,br:3,mb:4,bl:5,ml:6,tl:7},e=fabric.util.addListener,i=fabric.util.removeListener;fabric.util.object.extend(fabric.Canvas.prototype,{
cursorMap:["n-resize","ne-resize","e-resize","se-resize","s-resize","sw-resize","w-resize","nw-resize"],_initEventListeners:function(){this._bindEvents(),e(fabric.window,"resize",this._onResize),e(this.upperCanvasEl,"mousedown",this._onMouseDown),e(this.upperCanvasEl,"mousemove",this._onMouseMove),e(this.upperCanvasEl,"mouseout",this._onMouseOut),e(this.upperCanvasEl,"mouseenter",this._onMouseEnter),e(this.upperCanvasEl,"wheel",this._onMouseWheel),e(this.upperCanvasEl,"contextmenu",this._onContextMenu),e(this.upperCanvasEl,"touchstart",this._onMouseDown),e(this.upperCanvasEl,"touchmove",this._onMouseMove),"undefined"!=typeof eventjs&&"add"in eventjs&&(eventjs.add(this.upperCanvasEl,"gesture",this._onGesture),eventjs.add(this.upperCanvasEl,"drag",this._onDrag),eventjs.add(this.upperCanvasEl,"orientation",this._onOrientationChange),eventjs.add(this.upperCanvasEl,"shake",this._onShake),eventjs.add(this.upperCanvasEl,"longpress",this._onLongPress))},_bindEvents:function(){this._onMouseDown=this._onMouseDown.bind(this),this._onMouseMove=this._onMouseMove.bind(this),this._onMouseUp=this._onMouseUp.bind(this),this._onResize=this._onResize.bind(this),this._onGesture=this._onGesture.bind(this),this._onDrag=this._onDrag.bind(this),this._onShake=this._onShake.bind(this),this._onLongPress=this._onLongPress.bind(this),this._onOrientationChange=this._onOrientationChange.bind(this),this._onMouseWheel=this._onMouseWheel.bind(this),this._onMouseOut=this._onMouseOut.bind(this),this._onMouseEnter=this._onMouseEnter.bind(this),this._onContextMenu=this._onContextMenu.bind(this)},removeListeners:function(){i(fabric.window,"resize",this._onResize),i(this.upperCanvasEl,"mousedown",this._onMouseDown),i(this.upperCanvasEl,"mousemove",this._onMouseMove),i(this.upperCanvasEl,"mouseout",this._onMouseOut),i(this.upperCanvasEl,"mouseenter",this._onMouseEnter),i(this.upperCanvasEl,"wheel",this._onMouseWheel),i(this.upperCanvasEl,"contextmenu",this._onContextMenu),i(this.upperCanvasEl,"touchstart",this._onMouseDown),i(this.upperCanvasEl,"touchmove",this._onMouseMove),"undefined"!=typeof eventjs&&"remove"in eventjs&&(eventjs.remove(this.upperCanvasEl,"gesture",this._onGesture),eventjs.remove(this.upperCanvasEl,"drag",this._onDrag),eventjs.remove(this.upperCanvasEl,"orientation",this._onOrientationChange),eventjs.remove(this.upperCanvasEl,"shake",this._onShake),eventjs.remove(this.upperCanvasEl,"longpress",this._onLongPress))},_onGesture:function(t,e){this.__onTransformGesture&&this.__onTransformGesture(t,e)},_onDrag:function(t,e){this.__onDrag&&this.__onDrag(t,e)},_onMouseWheel:function(t){this.__onMouseWheel(t)},_onMouseOut:function(t){var e=this._hoveredTarget;this.fire("mouse:out",{target:e,e:t}),this._hoveredTarget=null,e&&e.fire("mouseout",{e:t})},_onMouseEnter:function(t){this.findTarget(t)||(this.fire("mouse:over",{target:null,e:t}),this._hoveredTarget=null)},_onOrientationChange:function(t,e){this.__onOrientationChange&&this.__onOrientationChange(t,e)},_onShake:function(t,e){this.__onShake&&this.__onShake(t,e)},_onLongPress:function(t,e){this.__onLongPress&&this.__onLongPress(t,e)},_onContextMenu:function(t){return this.stopContextMenu&&(t.stopPropagation(),t.preventDefault()),!1},_onMouseDown:function(t){this.__onMouseDown(t),e(fabric.document,"touchend",this._onMouseUp),e(fabric.document,"touchmove",this._onMouseMove),i(this.upperCanvasEl,"mousemove",this._onMouseMove),i(this.upperCanvasEl,"touchmove",this._onMouseMove),"touchstart"===t.type?i(this.upperCanvasEl,"mousedown",this._onMouseDown):(e(fabric.document,"mouseup",this._onMouseUp),e(fabric.document,"mousemove",this._onMouseMove))},_onMouseUp:function(t){if(this.__onMouseUp(t),i(fabric.document,"mouseup",this._onMouseUp),i(fabric.document,"touchend",this._onMouseUp),i(fabric.document,"mousemove",this._onMouseMove),i(fabric.document,"touchmove",this._onMouseMove),e(this.upperCanvasEl,"mousemove",this._onMouseMove),e(this.upperCanvasEl,"touchmove",this._onMouseMove),"touchend"===t.type){var r=this;setTimeout(function(){e(r.upperCanvasEl,"mousedown",r._onMouseDown)},400)}},_onMouseMove:function(t){!this.allowTouchScrolling&&t.preventDefault&&t.preventDefault(),this.__onMouseMove(t)},_onResize:function(){this.calcOffset()},_shouldRender:function(t,e){var i=this.getActiveGroup()||this.getActiveObject();return(!i||!i.isEditing||t!==i)&&!!(t&&(t.isMoving||t!==i)||!t&&i||!t&&!i&&!this._groupSelector||e&&this._previousPointer&&this.selection&&(e.x!==this._previousPointer.x||e.y!==this._previousPointer.y))},__onMouseUp:function(t){var e,i=!0,r=this._currentTransform,n=this._groupSelector,s=!n||0===n.left&&0===n.top;if(this.isDrawingMode&&this._isCurrentlyDrawing)return void this._onMouseUpInDrawingMode(t);r&&(this._finalizeCurrentTransform(),i=!r.actionPerformed),e=i?this.findTarget(t,!0):r.target;var o=this._shouldRender(e,this.getPointer(t));e||!s?this._maybeGroupObjects(t):(this._groupSelector=null,this._currentTransform=null),e&&(e.isMoving=!1),this._handleCursorAndEvent(t,e,"up"),e&&(e.__corner=0),o&&this.renderAll()},_handleCursorAndEvent:function(t,e,i){this._setCursorFromEvent(t,e),this._handleEvent(t,i,e?e:null)},_handleEvent:function(t,e,i){var r="undefined"==typeof i?this.findTarget(t):i,n=this.targets||[],s={e:t,target:r,subTargets:n};this.fire("mouse:"+e,s),r&&r.fire("mouse"+e,s);for(var o=0;o<n.length;o++)n[o].fire("mouse"+e,s)},_finalizeCurrentTransform:function(){var t=this._currentTransform,e=t.target;e._scaling&&(e._scaling=!1),e.setCoords(),this._restoreOriginXY(e),(t.actionPerformed||this.stateful&&e.hasStateChanged())&&(this.fire("object:modified",{target:e}),e.fire("modified"))},_restoreOriginXY:function(t){if(this._previousOriginX&&this._previousOriginY){var e=t.translateToOriginPoint(t.getCenterPoint(),this._previousOriginX,this._previousOriginY);t.originX=this._previousOriginX,t.originY=this._previousOriginY,t.left=e.x,t.top=e.y,this._previousOriginX=null,this._previousOriginY=null}},_onMouseDownInDrawingMode:function(t){this._isCurrentlyDrawing=!0,this.discardActiveObject(t).renderAll(),this.clipTo&&fabric.util.clipContext(this,this.contextTop);var e=this.getPointer(t);this.freeDrawingBrush.onMouseDown(e),this._handleEvent(t,"down")},_onMouseMoveInDrawingMode:function(t){if(this._isCurrentlyDrawing){var e=this.getPointer(t);this.freeDrawingBrush.onMouseMove(e)}this.setCursor(this.freeDrawingCursor),this._handleEvent(t,"move")},_onMouseUpInDrawingMode:function(t){this._isCurrentlyDrawing=!1,this.clipTo&&this.contextTop.restore(),this.freeDrawingBrush.onMouseUp(),this._handleEvent(t,"up")},__onMouseDown:function(t){var e=this.findTarget(t),i="which"in t?3===t.which:2===t.button;if(i)return void(this.fireRightClick&&this._handleEvent(t,"down",e?e:null));if(this.isDrawingMode)return void this._onMouseDownInDrawingMode(t);if(!this._currentTransform){var r=this.getPointer(t,!0);this._previousPointer=r;var n=this._shouldRender(e,r),s=this._shouldGroup(t,e);this._shouldClearSelection(t,e)?this._clearSelection(t,e,r):s&&(this._handleGrouping(t,e),e=this.getActiveGroup()),e&&(!e.selectable||!e.__corner&&s||(this._beforeTransform(t,e),this._setupCurrentTransform(t,e)),e!==this.getActiveGroup()&&e!==this.getActiveObject()&&(this.deactivateAll(),e.selectable&&this.setActiveObject(e,t))),this._handleEvent(t,"down",e?e:null),n&&this.renderAll()}},_beforeTransform:function(t,e){this.stateful&&e.saveState(),e._findTargetCorner(this.getPointer(t))&&this.onBeforeScaleRotate(e)},_clearSelection:function(t,e,i){this.deactivateAllWithDispatch(t),e&&e.selectable?this.setActiveObject(e,t):this.selection&&(this._groupSelector={ex:i.x,ey:i.y,top:0,left:0})},_setOriginToCenter:function(t){this._previousOriginX=this._currentTransform.target.originX,this._previousOriginY=this._currentTransform.target.originY;var e=t.getCenterPoint();t.originX="center",t.originY="center",t.left=e.x,t.top=e.y,this._currentTransform.left=t.left,this._currentTransform.top=t.top},_setCenterToOrigin:function(t){var e=t.translateToOriginPoint(t.getCenterPoint(),this._previousOriginX,this._previousOriginY);t.originX=this._previousOriginX,t.originY=this._previousOriginY,t.left=e.x,t.top=e.y,this._previousOriginX=null,this._previousOriginY=null},__onMouseMove:function(t){var e,i;if(this.isDrawingMode)return void this._onMouseMoveInDrawingMode(t);if(!("undefined"!=typeof t.touches&&t.touches.length>1)){var r=this._groupSelector;r?(i=this.getPointer(t,!0),r.left=i.x-r.ex,r.top=i.y-r.ey,this.renderTop()):this._currentTransform?this._transformObject(t):(e=this.findTarget(t),this._setCursorFromEvent(t,e)),this._handleEvent(t,"move",e?e:null)}},__onMouseWheel:function(t){this._handleEvent(t,"wheel")},_transformObject:function(t){var e=this.getPointer(t),i=this._currentTransform;i.reset=!1,i.target.isMoving=!0,i.shiftKey=t.shiftKey,i.altKey=t[this.centeredKey],this._beforeScaleTransform(t,i),this._performTransformAction(t,i,e),i.actionPerformed&&this.renderAll()},_performTransformAction:function(t,e,i){var r=i.x,n=i.y,s=e.target,o=e.action,a=!1;"rotate"===o?(a=this._rotateObject(r,n))&&this._fire("rotating",s,t):"scale"===o?(a=this._onScale(t,e,r,n))&&this._fire("scaling",s,t):"scaleX"===o?(a=this._scaleObject(r,n,"x"))&&this._fire("scaling",s,t):"scaleY"===o?(a=this._scaleObject(r,n,"y"))&&this._fire("scaling",s,t):"skewX"===o?(a=this._skewObject(r,n,"x"))&&this._fire("skewing",s,t):"skewY"===o?(a=this._skewObject(r,n,"y"))&&this._fire("skewing",s,t):(a=this._translateObject(r,n),a&&(this._fire("moving",s,t),this.setCursor(s.moveCursor||this.moveCursor))),e.actionPerformed=e.actionPerformed||a},_fire:function(t,e,i){this.fire("object:"+t,{target:e,e:i}),e.fire(t,{e:i})},_beforeScaleTransform:function(t,e){if("scale"===e.action||"scaleX"===e.action||"scaleY"===e.action){var i=this._shouldCenterTransform(e.target);(i&&("center"!==e.originX||"center"!==e.originY)||!i&&"center"===e.originX&&"center"===e.originY)&&(this._resetCurrentTransform(),e.reset=!0)}},_onScale:function(t,e,i,r){return!t[this.uniScaleKey]&&!this.uniScaleTransform||e.target.get("lockUniScaling")?(e.reset||"scale"!==e.currentAction||this._resetCurrentTransform(),e.currentAction="scaleEqually",this._scaleObject(i,r,"equally")):(e.currentAction="scale",this._scaleObject(i,r))},_setCursorFromEvent:function(t,e){if(!e)return this.setCursor(this.defaultCursor),!1;var i=e.hoverCursor||this.hoverCursor;if(e.selectable){var r=this.getActiveGroup(),n=e._findTargetCorner&&(!r||!r.contains(e))&&e._findTargetCorner(this.getPointer(t,!0));n?this._setCornerCursor(n,e,t):this.setCursor(i)}else this.setCursor(i);return!0},_setCornerCursor:function(e,i,r){if(e in t)this.setCursor(this._getRotatedCornerCursor(e,i,r));else{if("mtr"!==e||!i.hasRotatingPoint)return this.setCursor(this.defaultCursor),!1;this.setCursor(this.rotationCursor)}},_getRotatedCornerCursor:function(e,i,r){var n=Math.round(i.getAngle()%360/45);return n<0&&(n+=8),n+=t[e],r[this.altActionKey]&&t[e]%2===0&&(n+=2),n%=8,this.cursorMap[n]}})}(),function(){var t=Math.min,e=Math.max;fabric.util.object.extend(fabric.Canvas.prototype,{_shouldGroup:function(t,e){var i=this.getActiveObject();return t[this.selectionKey]&&e&&e.selectable&&(this.getActiveGroup()||i&&i!==e)&&this.selection},_handleGrouping:function(t,e){var i=this.getActiveGroup();(e!==i||(e=this.findTarget(t,!0)))&&(i?this._updateActiveGroup(e,t):this._createActiveGroup(e,t),this._activeGroup&&this._activeGroup.saveCoords())},_updateActiveGroup:function(t,e){var i=this.getActiveGroup();if(i.contains(t)){if(i.removeWithUpdate(t),t.set("active",!1),1===i.size())return this.discardActiveGroup(e),void this.setActiveObject(i.item(0))}else i.addWithUpdate(t);this.fire("selection:created",{target:i,e:e}),i.set("active",!0)},_createActiveGroup:function(t,e){if(this._activeObject&&t!==this._activeObject){var i=this._createGroup(t);i.addWithUpdate(),this.setActiveGroup(i),this._activeObject=null,this.fire("selection:created",{target:i,e:e})}t.set("active",!0)},_createGroup:function(t){var e=this.getObjects(),i=e.indexOf(this._activeObject)<e.indexOf(t),r=i?[this._activeObject,t]:[t,this._activeObject];return this._activeObject.isEditing&&this._activeObject.exitEditing(),new fabric.Group(r,{canvas:this})},_groupSelectedObjects:function(t){var e=this._collectObjects();1===e.length?this.setActiveObject(e[0],t):e.length>1&&(e=new fabric.Group(e.reverse(),{canvas:this}),e.addWithUpdate(),this.setActiveGroup(e,t),e.saveCoords(),this.fire("selection:created",{target:e}),this.renderAll())},_collectObjects:function(){for(var i,r=[],n=this._groupSelector.ex,s=this._groupSelector.ey,o=n+this._groupSelector.left,a=s+this._groupSelector.top,h=new fabric.Point(t(n,o),t(s,a)),c=new fabric.Point(e(n,o),e(s,a)),l=n===o&&s===a,u=this._objects.length;u--&&(i=this._objects[u],!(i&&i.selectable&&i.visible&&(i.intersectsWithRect(h,c)||i.isContainedWithinRect(h,c)||i.containsPoint(h)||i.containsPoint(c))&&(i.set("active",!0),r.push(i),l))););return r},_maybeGroupObjects:function(t){this.selection&&this._groupSelector&&this._groupSelectedObjects(t);var e=this.getActiveGroup();e&&(e.setObjectsCoords().setCoords(),e.isMoving=!1,this.setCursor(this.defaultCursor)),this._groupSelector=null,this._currentTransform=null}})}(),function(){var t=fabric.StaticCanvas.supports("toDataURLWithQuality");fabric.util.object.extend(fabric.StaticCanvas.prototype,{toDataURL:function(t){t||(t={});var e=t.format||"png",i=t.quality||1,r=t.multiplier||1,n={left:t.left||0,top:t.top||0,width:t.width||0,height:t.height||0};return this.__toDataURLWithMultiplier(e,i,n,r)},__toDataURLWithMultiplier:function(t,e,i,r){var n=this.getWidth(),s=this.getHeight(),o=(i.width||this.getWidth())*r,a=(i.height||this.getHeight())*r,h=this.getZoom(),c=h*r,l=this.viewportTransform,u=(l[4]-i.left)*r,f=(l[5]-i.top)*r,d=[c,0,0,c,u,f],g=this.interactive;this.viewportTransform=d,this.interactive&&(this.interactive=!1),n!==o||s!==a?this.setDimensions({width:o,height:a}):this.renderAll();var p=this.__toDataURL(t,e,i);return g&&(this.interactive=g),this.viewportTransform=l,this.setDimensions({width:n,height:s}),p},__toDataURL:function(e,i){var r=this.contextContainer.canvas;"jpg"===e&&(e="jpeg");var n=t?r.toDataURL("image/"+e,i):r.toDataURL("image/"+e);return n},toDataURLWithMultiplier:function(t,e,i){return this.toDataURL({format:t,multiplier:e,quality:i})}})}(),fabric.util.object.extend(fabric.StaticCanvas.prototype,{loadFromDatalessJSON:function(t,e,i){return this.loadFromJSON(t,e,i)},loadFromJSON:function(t,e,i){if(t){var r="string"==typeof t?JSON.parse(t):fabric.util.object.clone(t);this.clear();var n=this;return this._enlivenObjects(r.objects,function(){n._setBgOverlay(r,function(){delete r.objects,delete r.backgroundImage,delete r.overlayImage,delete r.background,delete r.overlay,n._setOptions(r),e&&e()})},i),this}},_setBgOverlay:function(t,e){var i=this,r={backgroundColor:!1,overlayColor:!1,backgroundImage:!1,overlayImage:!1};if(!(t.backgroundImage||t.overlayImage||t.background||t.overlay))return void(e&&e());var n=function(){r.backgroundImage&&r.overlayImage&&r.backgroundColor&&r.overlayColor&&(i.renderAll(),e&&e())};this.__setBgOverlay("backgroundImage",t.backgroundImage,r,n),this.__setBgOverlay("overlayImage",t.overlayImage,r,n),this.__setBgOverlay("backgroundColor",t.background,r,n),this.__setBgOverlay("overlayColor",t.overlay,r,n)},__setBgOverlay:function(t,e,i,r){var n=this;return e?void("backgroundImage"===t||"overlayImage"===t?fabric.util.enlivenObjects([e],function(e){n[t]=e[0],i[t]=!0,r&&r()}):this["set"+fabric.util.string.capitalize(t,!0)](e,function(){i[t]=!0,r&&r()})):(i[t]=!0,void(r&&r()))},_enlivenObjects:function(t,e,i){var r=this;if(!t||0===t.length)return void(e&&e());var n=this.renderOnAddRemove;this.renderOnAddRemove=!1,fabric.util.enlivenObjects(t,function(t){t.forEach(function(t,e){r.insertAt(t,e)}),r.renderOnAddRemove=n,e&&e()},null,i)},_toDataURL:function(t,e){this.clone(function(i){e(i.toDataURL(t))})},_toDataURLWithMultiplier:function(t,e,i){this.clone(function(r){i(r.toDataURLWithMultiplier(t,e))})},clone:function(t,e){var i=JSON.stringify(this.toJSON(e));this.cloneWithoutData(function(e){e.loadFromJSON(i,function(){t&&t(e)})})},cloneWithoutData:function(t){var e=fabric.document.createElement("canvas");e.width=this.getWidth(),e.height=this.getHeight();var i=new fabric.Canvas(e);i.clipTo=this.clipTo,this.backgroundImage?(i.setBackgroundImage(this.backgroundImage.src,function(){i.renderAll(),t&&t(i)}),i.backgroundImageOpacity=this.backgroundImageOpacity,i.backgroundImageStretch=this.backgroundImageStretch):t&&t(i)}}),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.util.object.clone,n=e.util.toFixed,s=e.util.string.capitalize,o=e.util.degreesToRadians,a=e.StaticCanvas.supports("setLineDash"),h=!e.isLikelyNode;e.Object||(e.Object=e.util.createClass(e.CommonMethods,{type:"object",originX:"left",originY:"top",top:0,left:0,width:0,height:0,scaleX:1,scaleY:1,flipX:!1,flipY:!1,opacity:1,angle:0,skewX:0,skewY:0,cornerSize:13,transparentCorners:!0,hoverCursor:null,moveCursor:null,padding:0,borderColor:"rgba(102,153,255,0.75)",borderDashArray:null,cornerColor:"rgba(102,153,255,0.5)",cornerStrokeColor:null,cornerStyle:"rect",cornerDashArray:null,centeredScaling:!1,centeredRotation:!0,fill:"rgb(0,0,0)",fillRule:"nonzero",globalCompositeOperation:"source-over",backgroundColor:"",selectionBackgroundColor:"",stroke:null,strokeWidth:1,strokeDashArray:null,strokeLineCap:"butt",strokeLineJoin:"miter",strokeMiterLimit:10,shadow:null,borderOpacityWhenMoving:.4,borderScaleFactor:1,transformMatrix:null,minScaleLimit:.01,selectable:!0,evented:!0,visible:!0,hasControls:!0,hasBorders:!0,hasRotatingPoint:!0,rotatingPointOffset:40,perPixelTargetFind:!1,includeDefaultValues:!0,clipTo:null,lockMovementX:!1,lockMovementY:!1,lockRotation:!1,lockScalingX:!1,lockScalingY:!1,lockUniScaling:!1,lockSkewingX:!1,lockSkewingY:!1,lockScalingFlip:!1,excludeFromExport:!1,objectCaching:h,statefullCache:!1,noScaleCache:!0,dirty:!1,stateProperties:"top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeLineJoin strokeMiterLimit angle opacity fill fillRule globalCompositeOperation shadow clipTo visible backgroundColor skewX skewY".split(" "),cacheProperties:"fill stroke strokeWidth strokeDashArray width height stroke strokeWidth strokeDashArray strokeLineCap strokeLineJoin strokeMiterLimit fillRule backgroundColor".split(" "),initialize:function(t){t=t||{},t&&this.setOptions(t),this.objectCaching&&(this._createCacheCanvas(),this.setupState({propertySet:"cacheProperties"}))},_createCacheCanvas:function(){this._cacheCanvas=e.document.createElement("canvas"),this._cacheContext=this._cacheCanvas.getContext("2d"),this._updateCacheCanvas()},_getCacheCanvasDimensions:function(){var t=this.canvas&&this.canvas.getZoom()||1,i=this.getObjectScaling(),r=this._getNonTransformedDimensions(),n=this.canvas&&this.canvas._isRetinaScaling()?e.devicePixelRatio:1,s=i.scaleX*t*n,o=i.scaleY*t*n,a=r.x*s,h=r.y*o;return{width:Math.ceil(a)+2,height:Math.ceil(h)+2,zoomX:s,zoomY:o}},_updateCacheCanvas:function(){if(this.noScaleCache&&this.canvas&&this.canvas._currentTransform){var t=this.canvas._currentTransform.action;if("scale"===t.slice(0,5))return!1}var e=this._getCacheCanvasDimensions(),i=e.width,r=e.height,n=e.zoomX,s=e.zoomY;return(i!==this.cacheWidth||r!==this.cacheHeight)&&(this._cacheCanvas.width=i,this._cacheCanvas.height=r,this._cacheContext.translate(i/2,r/2),this._cacheContext.scale(n,s),this.cacheWidth=i,this.cacheHeight=r,this.zoomX=n,this.zoomY=s,!0)},setOptions:function(t){this._setOptions(t),this._initGradient(t.fill,"fill"),this._initGradient(t.stroke,"stroke"),this._initClipping(t),this._initPattern(t.fill,"fill"),this._initPattern(t.stroke,"stroke")},transform:function(t,e){this.group&&!this.group._transformDone&&this.group===this.canvas._activeGroup&&this.group.transform(t);var i=e?this._getLeftTopCoords():this.getCenterPoint();t.translate(i.x,i.y),t.rotate(o(this.angle)),t.scale(this.scaleX*(this.flipX?-1:1),this.scaleY*(this.flipY?-1:1)),t.transform(1,0,Math.tan(o(this.skewX)),1,0,0),t.transform(1,Math.tan(o(this.skewY)),0,1,0,0)},toObject:function(t){var i=e.Object.NUM_FRACTION_DIGITS,r={type:this.type,originX:this.originX,originY:this.originY,left:n(this.left,i),top:n(this.top,i),width:n(this.width,i),height:n(this.height,i),fill:this.fill&&this.fill.toObject?this.fill.toObject():this.fill,stroke:this.stroke&&this.stroke.toObject?this.stroke.toObject():this.stroke,strokeWidth:n(this.strokeWidth,i),strokeDashArray:this.strokeDashArray?this.strokeDashArray.concat():this.strokeDashArray,strokeLineCap:this.strokeLineCap,strokeLineJoin:this.strokeLineJoin,strokeMiterLimit:n(this.strokeMiterLimit,i),scaleX:n(this.scaleX,i),scaleY:n(this.scaleY,i),angle:n(this.getAngle(),i),flipX:this.flipX,flipY:this.flipY,opacity:n(this.opacity,i),shadow:this.shadow&&this.shadow.toObject?this.shadow.toObject():this.shadow,visible:this.visible,clipTo:this.clipTo&&String(this.clipTo),backgroundColor:this.backgroundColor,fillRule:this.fillRule,globalCompositeOperation:this.globalCompositeOperation,transformMatrix:this.transformMatrix?this.transformMatrix.concat():null,skewX:n(this.skewX,i),skewY:n(this.skewY,i)};return e.util.populateWithProperties(this,r,t),this.includeDefaultValues||(r=this._removeDefaultValues(r)),r},toDatalessObject:function(t){return this.toObject(t)},_removeDefaultValues:function(t){var i=e.util.getKlass(t.type).prototype,r=i.stateProperties;return r.forEach(function(e){t[e]===i[e]&&delete t[e];var r="[object Array]"===Object.prototype.toString.call(t[e])&&"[object Array]"===Object.prototype.toString.call(i[e]);r&&0===t[e].length&&0===i[e].length&&delete t[e]}),t},toString:function(){return"#<fabric."+s(this.type)+">"},getObjectScaling:function(){var t=this.scaleX,e=this.scaleY;if(this.group){var i=this.group.getObjectScaling();t*=i.scaleX,e*=i.scaleY}return{scaleX:t,scaleY:e}},_set:function(t,i){var r="scaleX"===t||"scaleY"===t;return r&&(i=this._constrainScale(i)),"scaleX"===t&&i<0?(this.flipX=!this.flipX,i*=-1):"scaleY"===t&&i<0?(this.flipY=!this.flipY,i*=-1):"shadow"!==t||!i||i instanceof e.Shadow?"dirty"===t&&this.group&&this.group.set("dirty",i):i=new e.Shadow(i),this[t]=i,this.cacheProperties.indexOf(t)>-1&&(this.group&&this.group.set("dirty",!0),this.dirty=!0),"width"!==t&&"height"!==t||(this.minScaleLimit=Math.min(.1,1/Math.max(this.width,this.height))),this},setOnGroup:function(){},setSourcePath:function(t){return this.sourcePath=t,this},getViewportTransform:function(){return this.canvas&&this.canvas.viewportTransform?this.canvas.viewportTransform:[1,0,0,1,0,0]},render:function(t,i){0===this.width&&0===this.height||!this.visible||(t.save(),this._setupCompositeOperation(t),this.drawSelectionBackground(t),i||this.transform(t),this._setOpacity(t),this._setShadow(t),this.transformMatrix&&t.transform.apply(t,this.transformMatrix),this.clipTo&&e.util.clipContext(this,t),this.objectCaching&&!this.group?(this.isCacheDirty(i)&&(this.statefullCache&&this.saveState({propertySet:"cacheProperties"}),this.drawObject(this._cacheContext,i),this.dirty=!1),this.drawCacheOnCanvas(t)):(this.drawObject(t,i),i&&this.objectCaching&&this.statefullCache&&this.saveState({propertySet:"cacheProperties"})),this.clipTo&&t.restore(),t.restore())},drawObject:function(t,e){this._renderBackground(t),this._setStrokeStyles(t),this._setFillStyles(t),this._render(t,e)},drawCacheOnCanvas:function(t){t.scale(1/this.zoomX,1/this.zoomY),t.drawImage(this._cacheCanvas,-this.cacheWidth/2,-this.cacheHeight/2)},isCacheDirty:function(t){if(!t&&this._updateCacheCanvas())return!0;if(this.dirty||this.statefullCache&&this.hasStateChanged("cacheProperties")){if(!t){var e=this._getNonTransformedDimensions();this._cacheContext.clearRect(-e.x/2,-e.y/2,e.x,e.y)}return!0}return!1},_renderBackground:function(t){if(this.backgroundColor){var e=this._getNonTransformedDimensions();t.fillStyle=this.backgroundColor,t.fillRect(-e.x/2,-e.y/2,e.x,e.y),this._removeShadow(t)}},_setOpacity:function(t){t.globalAlpha*=this.opacity},_setStrokeStyles:function(t){this.stroke&&(t.lineWidth=this.strokeWidth,t.lineCap=this.strokeLineCap,t.lineJoin=this.strokeLineJoin,t.miterLimit=this.strokeMiterLimit,t.strokeStyle=this.stroke.toLive?this.stroke.toLive(t,this):this.stroke)},_setFillStyles:function(t){this.fill&&(t.fillStyle=this.fill.toLive?this.fill.toLive(t,this):this.fill)},_setLineDash:function(t,e,i){e&&(1&e.length&&e.push.apply(e,e),a?t.setLineDash(e):i&&i(t))},_renderControls:function(t,i){if(!(!this.active||i||this.group&&this.group!==this.canvas.getActiveGroup())){var r,n=this.getViewportTransform(),s=this.calcTransformMatrix();s=e.util.multiplyTransformMatrices(n,s),r=e.util.qrDecompose(s),t.save(),t.translate(r.translateX,r.translateY),t.lineWidth=1*this.borderScaleFactor,this.group||(t.globalAlpha=this.isMoving?this.borderOpacityWhenMoving:1),this.group&&this.group===this.canvas.getActiveGroup()?(t.rotate(o(r.angle)),this.drawBordersInGroup(t,r)):(t.rotate(o(this.angle)),this.drawBorders(t)),this.drawControls(t),t.restore()}},_setShadow:function(t){if(this.shadow){var i=this.canvas&&this.canvas.viewportTransform[0]||1,r=this.canvas&&this.canvas.viewportTransform[3]||1,n=this.getObjectScaling();this.canvas&&this.canvas._isRetinaScaling()&&(i*=e.devicePixelRatio,r*=e.devicePixelRatio),t.shadowColor=this.shadow.color,t.shadowBlur=this.shadow.blur*(i+r)*(n.scaleX+n.scaleY)/4,t.shadowOffsetX=this.shadow.offsetX*i*n.scaleX,t.shadowOffsetY=this.shadow.offsetY*r*n.scaleY}},_removeShadow:function(t){this.shadow&&(t.shadowColor="",t.shadowBlur=t.shadowOffsetX=t.shadowOffsetY=0)},_applyPatternGradientTransform:function(t,e){if(e.toLive){var i=e.gradientTransform||e.patternTransform;i&&t.transform.apply(t,i);var r=-this.width/2+e.offsetX||0,n=-this.height/2+e.offsetY||0;t.translate(r,n)}},_renderFill:function(t){this.fill&&(t.save(),this._applyPatternGradientTransform(t,this.fill),"evenodd"===this.fillRule?t.fill("evenodd"):t.fill(),t.restore())},_renderStroke:function(t){this.stroke&&0!==this.strokeWidth&&(this.shadow&&!this.shadow.affectStroke&&this._removeShadow(t),t.save(),this._setLineDash(t,this.strokeDashArray,this._renderDashedStroke),this._applyPatternGradientTransform(t,this.stroke),t.stroke(),t.restore())},clone:function(t,i){return this.constructor.fromObject?this.constructor.fromObject(this.toObject(i),t):new e.Object(this.toObject(i))},cloneAsImage:function(t,i){var r=this.toDataURL(i);return e.util.loadImage(r,function(i){t&&t(new e.Image(i))}),this},toDataURL:function(t){t||(t={});var i=e.util.createCanvasElement(),r=this.getBoundingRect();i.width=r.width,i.height=r.height,e.util.wrapElement(i,"div");var n=new e.StaticCanvas(i,{enableRetinaScaling:t.enableRetinaScaling});"jpg"===t.format&&(t.format="jpeg"),"jpeg"===t.format&&(n.backgroundColor="#fff");var s={active:this.get("active"),left:this.getLeft(),top:this.getTop()};this.set("active",!1),this.setPositionByOrigin(new e.Point(n.getWidth()/2,n.getHeight()/2),"center","center");var o=this.canvas;n.add(this);var a=n.toDataURL(t);return this.set(s).setCoords(),this.canvas=o,n.dispose(),n=null,a},isType:function(t){return this.type===t},complexity:function(){return 0},toJSON:function(t){return this.toObject(t)},setGradient:function(t,i){i||(i={});var r={colorStops:[]};return r.type=i.type||(i.r1||i.r2?"radial":"linear"),r.coords={x1:i.x1,y1:i.y1,x2:i.x2,y2:i.y2},(i.r1||i.r2)&&(r.coords.r1=i.r1,r.coords.r2=i.r2),r.gradientTransform=i.gradientTransform,e.Gradient.prototype.addColorStop.call(r,i.colorStops),this.set(t,e.Gradient.forObject(this,r))},setPatternFill:function(t){return this.set("fill",new e.Pattern(t))},setShadow:function(t){return this.set("shadow",t?new e.Shadow(t):null)},setColor:function(t){return this.set("fill",t),this},setAngle:function(t){var e=("center"!==this.originX||"center"!==this.originY)&&this.centeredRotation;return e&&this._setOriginToCenter(),this.set("angle",t),e&&this._resetOrigin(),this},centerH:function(){return this.canvas&&this.canvas.centerObjectH(this),this},viewportCenterH:function(){return this.canvas&&this.canvas.viewportCenterObjectH(this),this},centerV:function(){return this.canvas&&this.canvas.centerObjectV(this),this},viewportCenterV:function(){return this.canvas&&this.canvas.viewportCenterObjectV(this),this},center:function(){return this.canvas&&this.canvas.centerObject(this),this},viewportCenter:function(){return this.canvas&&this.canvas.viewportCenterObject(this),this},remove:function(){return this.canvas&&this.canvas.remove(this),this},getLocalPointer:function(t,i){i=i||this.canvas.getPointer(t);var r=new e.Point(i.x,i.y),n=this._getLeftTopCoords();return this.angle&&(r=e.util.rotatePoint(r,n,o(-this.angle))),{x:r.x-n.x,y:r.y-n.y}},_setupCompositeOperation:function(t){this.globalCompositeOperation&&(t.globalCompositeOperation=this.globalCompositeOperation)}}),e.util.createAccessors(e.Object),e.Object.prototype.rotate=e.Object.prototype.setAngle,i(e.Object.prototype,e.Observable),e.Object.NUM_FRACTION_DIGITS=2,e.Object._fromObject=function(t,i,n,s,o){var a=e[t];if(i=r(i,!0),!s){var h=o?new a(i[o],i):new a(i);return n&&n(h),h}e.util.enlivenPatterns([i.fill,i.stroke],function(t){i.fill=t[0],i.stroke=t[1];var e=o?new a(i[o],i):new a(i);n&&n(e)})},e.Object.__uid=0)}("undefined"!=typeof exports?exports:this),function(){var t=fabric.util.degreesToRadians,e={left:-.5,center:0,right:.5},i={top:-.5,center:0,bottom:.5};fabric.util.object.extend(fabric.Object.prototype,{translateToGivenOrigin:function(t,r,n,s,o){var a,h,c,l=t.x,u=t.y;return"string"==typeof r?r=e[r]:r-=.5,"string"==typeof s?s=e[s]:s-=.5,a=s-r,"string"==typeof n?n=i[n]:n-=.5,"string"==typeof o?o=i[o]:o-=.5,h=o-n,(a||h)&&(c=this._getTransformedDimensions(),l=t.x+a*c.x,u=t.y+h*c.y),new fabric.Point(l,u)},translateToCenterPoint:function(e,i,r){var n=this.translateToGivenOrigin(e,i,r,"center","center");return this.angle?fabric.util.rotatePoint(n,e,t(this.angle)):n},translateToOriginPoint:function(e,i,r){var n=this.translateToGivenOrigin(e,"center","center",i,r);return this.angle?fabric.util.rotatePoint(n,e,t(this.angle)):n},getCenterPoint:function(){var t=new fabric.Point(this.left,this.top);return this.translateToCenterPoint(t,this.originX,this.originY)},getPointByOrigin:function(t,e){var i=this.getCenterPoint();return this.translateToOriginPoint(i,t,e)},toLocalPoint:function(e,i,r){var n,s,o=this.getCenterPoint();return n="undefined"!=typeof i&&"undefined"!=typeof r?this.translateToGivenOrigin(o,"center","center",i,r):new fabric.Point(this.left,this.top),s=new fabric.Point(e.x,e.y),this.angle&&(s=fabric.util.rotatePoint(s,o,-t(this.angle))),s.subtractEquals(n)},setPositionByOrigin:function(t,e,i){var r=this.translateToCenterPoint(t,e,i),n=this.translateToOriginPoint(r,this.originX,this.originY);this.set("left",n.x),this.set("top",n.y)},adjustPosition:function(i){var r,n,s=t(this.angle),o=this.getWidth(),a=Math.cos(s)*o,h=Math.sin(s)*o;r="string"==typeof this.originX?e[this.originX]:this.originX-.5,n="string"==typeof i?e[i]:i-.5,this.left+=a*(n-r),this.top+=h*(n-r),this.setCoords(),this.originX=i},_setOriginToCenter:function(){this._originalOriginX=this.originX,this._originalOriginY=this.originY;var t=this.getCenterPoint();this.originX="center",this.originY="center",this.left=t.x,this.top=t.y},_resetOrigin:function(){var t=this.translateToOriginPoint(this.getCenterPoint(),this._originalOriginX,this._originalOriginY);this.originX=this._originalOriginX,this.originY=this._originalOriginY,this.left=t.x,this.top=t.y,this._originalOriginX=null,this._originalOriginY=null},_getLeftTopCoords:function(){return this.translateToOriginPoint(this.getCenterPoint(),"left","top")}})}(),function(){function t(t){return[new fabric.Point(t.tl.x,t.tl.y),new fabric.Point(t.tr.x,t.tr.y),new fabric.Point(t.br.x,t.br.y),new fabric.Point(t.bl.x,t.bl.y)]}var e=fabric.util.degreesToRadians,i=fabric.util.multiplyTransformMatrices;fabric.util.object.extend(fabric.Object.prototype,{
oCoords:null,intersectsWithRect:function(e,i){var r=t(this.oCoords),n=fabric.Intersection.intersectPolygonRectangle(r,e,i);return"Intersection"===n.status},intersectsWithObject:function(e){var i=fabric.Intersection.intersectPolygonPolygon(t(this.oCoords),t(e.oCoords));return"Intersection"===i.status||e.isContainedWithinObject(this)||this.isContainedWithinObject(e)},isContainedWithinObject:function(e){for(var i=t(this.oCoords),r=0;r<4;r++)if(!e.containsPoint(i[r]))return!1;return!0},isContainedWithinRect:function(t,e){var i=this.getBoundingRect();return i.left>=t.x&&i.left+i.width<=e.x&&i.top>=t.y&&i.top+i.height<=e.y},containsPoint:function(t){this.oCoords||this.setCoords();var e=this._getImageLines(this.oCoords),i=this._findCrossPoints(t,e);return 0!==i&&i%2===1},_getImageLines:function(t){return{topline:{o:t.tl,d:t.tr},rightline:{o:t.tr,d:t.br},bottomline:{o:t.br,d:t.bl},leftline:{o:t.bl,d:t.tl}}},_findCrossPoints:function(t,e){var i,r,n,s,o,a,h=0;for(var c in e)if(a=e[c],!(a.o.y<t.y&&a.d.y<t.y||a.o.y>=t.y&&a.d.y>=t.y||(a.o.x===a.d.x&&a.o.x>=t.x?o=a.o.x:(i=0,r=(a.d.y-a.o.y)/(a.d.x-a.o.x),n=t.y-i*t.x,s=a.o.y-r*a.o.x,o=-(n-s)/(i-r)),o>=t.x&&(h+=1),2!==h)))break;return h},getBoundingRectWidth:function(){return this.getBoundingRect().width},getBoundingRectHeight:function(){return this.getBoundingRect().height},getBoundingRect:function(t){var e=this.calcCoords(t);return fabric.util.makeBoundingBoxFromPoints([e.tl,e.tr,e.br,e.bl])},getWidth:function(){return this._getTransformedDimensions().x},getHeight:function(){return this._getTransformedDimensions().y},_constrainScale:function(t){return Math.abs(t)<this.minScaleLimit?t<0?-this.minScaleLimit:this.minScaleLimit:t},scale:function(t){return t=this._constrainScale(t),t<0&&(this.flipX=!this.flipX,this.flipY=!this.flipY,t*=-1),this.scaleX=t,this.scaleY=t,this.setCoords()},scaleToWidth:function(t){var e=this.getBoundingRect().width/this.getWidth();return this.scale(t/this.width/e)},scaleToHeight:function(t){var e=this.getBoundingRect().height/this.getHeight();return this.scale(t/this.height/e)},calcCoords:function(t){var i=e(this.angle),r=this.getViewportTransform(),n=t?this._getTransformedDimensions():this._calculateCurrentDimensions(),s=n.x,o=n.y,a=Math.sin(i),h=Math.cos(i),c=s>0?Math.atan(o/s):0,l=s/Math.cos(c)/2,u=Math.cos(c+i)*l,f=Math.sin(c+i)*l,d=this.getCenterPoint(),g=t?d:fabric.util.transformPoint(d,r),p=new fabric.Point(g.x-u,g.y-f),v=new fabric.Point(p.x+s*h,p.y+s*a),b=new fabric.Point(p.x-o*a,p.y+o*h),m=new fabric.Point(g.x+u,g.y+f);if(!t)var y=new fabric.Point((p.x+b.x)/2,(p.y+b.y)/2),_=new fabric.Point((v.x+p.x)/2,(v.y+p.y)/2),x=new fabric.Point((m.x+v.x)/2,(m.y+v.y)/2),C=new fabric.Point((m.x+b.x)/2,(m.y+b.y)/2),S=new fabric.Point(_.x+a*this.rotatingPointOffset,_.y-h*this.rotatingPointOffset);var g={tl:p,tr:v,br:m,bl:b};return t||(g.ml=y,g.mt=_,g.mr=x,g.mb=C,g.mtr=S),g},setCoords:function(t,e){return this.oCoords=this.calcCoords(t),e||t||(this.absoluteCoords=this.calcCoords(!0)),t||this._setCornerCoords&&this._setCornerCoords(),this},_calcRotateMatrix:function(){if(this.angle){var t=e(this.angle),i=Math.cos(t),r=Math.sin(t);return[i,r,-r,i,0,0]}return[1,0,0,1,0,0]},calcTransformMatrix:function(){var t=this.getCenterPoint(),e=[1,0,0,1,t.x,t.y],r=this._calcRotateMatrix(),n=this._calcDimensionsTransformMatrix(this.skewX,this.skewY,!0),s=this.group?this.group.calcTransformMatrix():[1,0,0,1,0,0];return s=i(s,e),s=i(s,r),s=i(s,n)},_calcDimensionsTransformMatrix:function(t,r,n){var s=[1,0,Math.tan(e(t)),1],o=[1,Math.tan(e(r)),0,1],a=this.scaleX*(n&&this.flipX?-1:1),h=this.scaleY*(n&&this.flipY?-1:1),c=[a,0,0,h],l=i(c,s,!0);return i(l,o,!0)}})}(),fabric.util.object.extend(fabric.Object.prototype,{sendToBack:function(){return this.group?fabric.StaticCanvas.prototype.sendToBack.call(this.group,this):this.canvas.sendToBack(this),this},bringToFront:function(){return this.group?fabric.StaticCanvas.prototype.bringToFront.call(this.group,this):this.canvas.bringToFront(this),this},sendBackwards:function(t){return this.group?fabric.StaticCanvas.prototype.sendBackwards.call(this.group,this,t):this.canvas.sendBackwards(this,t),this},bringForward:function(t){return this.group?fabric.StaticCanvas.prototype.bringForward.call(this.group,this,t):this.canvas.bringForward(this,t),this},moveTo:function(t){return this.group?fabric.StaticCanvas.prototype.moveTo.call(this.group,this,t):this.canvas.moveTo(this,t),this}}),function(){function t(t,e){if(e){if(e.toLive)return t+": url(#SVGID_"+e.id+"); ";var i=new fabric.Color(e),r=t+": "+i.toRgb()+"; ",n=i.getAlpha();return 1!==n&&(r+=t+"-opacity: "+n.toString()+"; "),r}return t+": none; "}fabric.util.object.extend(fabric.Object.prototype,{getSvgStyles:function(e){var i=this.fillRule,r=this.strokeWidth?this.strokeWidth:"0",n=this.strokeDashArray?this.strokeDashArray.join(" "):"none",s=this.strokeLineCap?this.strokeLineCap:"butt",o=this.strokeLineJoin?this.strokeLineJoin:"miter",a=this.strokeMiterLimit?this.strokeMiterLimit:"4",h="undefined"!=typeof this.opacity?this.opacity:"1",c=this.visible?"":" visibility: hidden;",l=e?"":this.getSvgFilter(),u=t("fill",this.fill),f=t("stroke",this.stroke);return[f,"stroke-width: ",r,"; ","stroke-dasharray: ",n,"; ","stroke-linecap: ",s,"; ","stroke-linejoin: ",o,"; ","stroke-miterlimit: ",a,"; ",u,"fill-rule: ",i,"; ","opacity: ",h,";",l,c].join("")},getSvgFilter:function(){return this.shadow?"filter: url(#SVGID_"+this.shadow.id+");":""},getSvgId:function(){return this.id?'id="'+this.id+'" ':""},getSvgTransform:function(){if(this.group&&"path-group"===this.group.type)return"";var t=fabric.util.toFixed,e=this.getAngle(),i=this.getSkewX()%360,r=this.getSkewY()%360,n=this.getCenterPoint(),s=fabric.Object.NUM_FRACTION_DIGITS,o="path-group"===this.type?"":"translate("+t(n.x,s)+" "+t(n.y,s)+")",a=0!==e?" rotate("+t(e,s)+")":"",h=1===this.scaleX&&1===this.scaleY?"":" scale("+t(this.scaleX,s)+" "+t(this.scaleY,s)+")",c=0!==i?" skewX("+t(i,s)+")":"",l=0!==r?" skewY("+t(r,s)+")":"",u="path-group"===this.type?this.width:0,f=this.flipX?" matrix(-1 0 0 1 "+u+" 0) ":"",d="path-group"===this.type?this.height:0,g=this.flipY?" matrix(1 0 0 -1 0 "+d+")":"";return[o,a,h,f,g,c,l].join("")},getSvgTransformMatrix:function(){return this.transformMatrix?" matrix("+this.transformMatrix.join(" ")+") ":""},_createBaseSVGMarkup:function(){var t=[];return this.fill&&this.fill.toLive&&t.push(this.fill.toSVG(this,!1)),this.stroke&&this.stroke.toLive&&t.push(this.stroke.toSVG(this,!1)),this.shadow&&t.push(this.shadow.toSVG(this)),t}})}(),function(){function t(t,e,r){var n={},s=!0;r.forEach(function(e){n[e]=t[e]}),i(t[e],n,s)}function e(t,i,r){if(!fabric.isLikelyNode&&t instanceof Element)return t===i;if(t instanceof Array){if(t.length!==i.length)return!1;for(var n=0,s=t.length;n<s;n++)if(t[n]!==i[n])return!1;return!0}if(t&&"object"==typeof t){if(!r&&Object.keys(t).length!==Object.keys(i).length)return!1;for(var o in t)if(!e(t[o],i[o]))return!1;return!0}return t===i}var i=fabric.util.object.extend,r="stateProperties";fabric.util.object.extend(fabric.Object.prototype,{hasStateChanged:function(t){return t=t||r,t="_"+t,!e(this[t],this,!0)},saveState:function(e){var i=e&&e.propertySet||r,n="_"+i;return this[n]?(t(this,n,this[i]),e&&e.stateProperties&&t(this,n,e.stateProperties),this):this.setupState(e)},setupState:function(t){t=t||{};var e=t.propertySet||r;return t.propertySet=e,this["_"+e]={},this.saveState(t),this}})}(),function(){var t=fabric.util.degreesToRadians,e=function(){return"undefined"!=typeof G_vmlCanvasManager};fabric.util.object.extend(fabric.Object.prototype,{_controlsVisibility:null,_findTargetCorner:function(t){if(!this.hasControls||!this.active)return!1;var e,i,r=t.x,n=t.y;this.__corner=0;for(var s in this.oCoords)if(this.isControlVisible(s)&&("mtr"!==s||this.hasRotatingPoint)&&(!this.get("lockUniScaling")||"mt"!==s&&"mr"!==s&&"mb"!==s&&"ml"!==s)&&(i=this._getImageLines(this.oCoords[s].corner),e=this._findCrossPoints({x:r,y:n},i),0!==e&&e%2===1))return this.__corner=s,s;return!1},_setCornerCoords:function(){var e,i,r=this.oCoords,n=t(45-this.angle),s=.707106*this.cornerSize,o=s*Math.cos(n),a=s*Math.sin(n);for(var h in r)e=r[h].x,i=r[h].y,r[h].corner={tl:{x:e-a,y:i-o},tr:{x:e+o,y:i-a},bl:{x:e-o,y:i+a},br:{x:e+a,y:i+o}}},_getNonTransformedDimensions:function(){var t=this.strokeWidth,e=this.width+t,i=this.height+t;return{x:e,y:i}},_getTransformedDimensions:function(t,e){"undefined"==typeof t&&(t=this.skewX),"undefined"==typeof e&&(e=this.skewY);var i,r,n=this._getNonTransformedDimensions(),s=n.x/2,o=n.y/2,a=[{x:-s,y:-o},{x:s,y:-o},{x:-s,y:o},{x:s,y:o}],h=this._calcDimensionsTransformMatrix(t,e,!1);for(i=0;i<a.length;i++)a[i]=fabric.util.transformPoint(a[i],h);return r=fabric.util.makeBoundingBoxFromPoints(a),{x:r.width,y:r.height}},_calculateCurrentDimensions:function(){var t=this.getViewportTransform(),e=this._getTransformedDimensions(),i=fabric.util.transformPoint(e,t,!0);return i.scalarAdd(2*this.padding)},drawSelectionBackground:function(e){if(!this.selectionBackgroundColor||this.group||!this.active)return this;e.save();var i=this.getCenterPoint(),r=this._calculateCurrentDimensions(),n=this.canvas.viewportTransform;return e.translate(i.x,i.y),e.scale(1/n[0],1/n[3]),e.rotate(t(this.angle)),e.fillStyle=this.selectionBackgroundColor,e.fillRect(-r.x/2,-r.y/2,r.x,r.y),e.restore(),this},drawBorders:function(t){if(!this.hasBorders)return this;var e=this._calculateCurrentDimensions(),i=1/this.borderScaleFactor,r=e.x+i,n=e.y+i;if(t.save(),t.strokeStyle=this.borderColor,this._setLineDash(t,this.borderDashArray,null),t.strokeRect(-r/2,-n/2,r,n),this.hasRotatingPoint&&this.isControlVisible("mtr")&&!this.get("lockRotation")&&this.hasControls){var s=-n/2;t.beginPath(),t.moveTo(0,s),t.lineTo(0,s-this.rotatingPointOffset),t.closePath(),t.stroke()}return t.restore(),this},drawBordersInGroup:function(t,e){if(!this.hasBorders)return this;var i=this._getNonTransformedDimensions(),r=fabric.util.customTransformMatrix(e.scaleX,e.scaleY,e.skewX),n=fabric.util.transformPoint(i,r),s=1/this.borderScaleFactor,o=n.x+s,a=n.y+s;return t.save(),this._setLineDash(t,this.borderDashArray,null),t.strokeStyle=this.borderColor,t.strokeRect(-o/2,-a/2,o,a),t.restore(),this},drawControls:function(t){if(!this.hasControls)return this;var e=this._calculateCurrentDimensions(),i=e.x,r=e.y,n=this.cornerSize,s=-(i+n)/2,o=-(r+n)/2,a=this.transparentCorners?"stroke":"fill";return t.save(),t.strokeStyle=t.fillStyle=this.cornerColor,this.transparentCorners||(t.strokeStyle=this.cornerStrokeColor),this._setLineDash(t,this.cornerDashArray,null),this._drawControl("tl",t,a,s,o),this._drawControl("tr",t,a,s+i,o),this._drawControl("bl",t,a,s,o+r),this._drawControl("br",t,a,s+i,o+r),this.get("lockUniScaling")||(this._drawControl("mt",t,a,s+i/2,o),this._drawControl("mb",t,a,s+i/2,o+r),this._drawControl("mr",t,a,s+i,o+r/2),this._drawControl("ml",t,a,s,o+r/2)),this.hasRotatingPoint&&this._drawControl("mtr",t,a,s+i/2,o-this.rotatingPointOffset),t.restore(),this},_drawControl:function(t,i,r,n,s){if(this.isControlVisible(t)){var o=this.cornerSize,a=!this.transparentCorners&&this.cornerStrokeColor;switch(this.cornerStyle){case"circle":i.beginPath(),i.arc(n+o/2,s+o/2,o/2,0,2*Math.PI,!1),i[r](),a&&i.stroke();break;default:e()||this.transparentCorners||i.clearRect(n,s,o,o),i[r+"Rect"](n,s,o,o),a&&i.strokeRect(n,s,o,o)}}},isControlVisible:function(t){return this._getControlsVisibility()[t]},setControlVisible:function(t,e){return this._getControlsVisibility()[t]=e,this},setControlsVisibility:function(t){t||(t={});for(var e in t)this.setControlVisible(e,t[e]);return this},_getControlsVisibility:function(){return this._controlsVisibility||(this._controlsVisibility={tl:!0,tr:!0,br:!0,bl:!0,ml:!0,mt:!0,mr:!0,mb:!0,mtr:!0}),this._controlsVisibility}})}(),fabric.util.object.extend(fabric.StaticCanvas.prototype,{FX_DURATION:500,fxCenterObjectH:function(t,e){e=e||{};var i=function(){},r=e.onComplete||i,n=e.onChange||i,s=this;return fabric.util.animate({startValue:t.get("left"),endValue:this.getCenter().left,duration:this.FX_DURATION,onChange:function(e){t.set("left",e),s.renderAll(),n()},onComplete:function(){t.setCoords(),r()}}),this},fxCenterObjectV:function(t,e){e=e||{};var i=function(){},r=e.onComplete||i,n=e.onChange||i,s=this;return fabric.util.animate({startValue:t.get("top"),endValue:this.getCenter().top,duration:this.FX_DURATION,onChange:function(e){t.set("top",e),s.renderAll(),n()},onComplete:function(){t.setCoords(),r()}}),this},fxRemove:function(t,e){e=e||{};var i=function(){},r=e.onComplete||i,n=e.onChange||i,s=this;return fabric.util.animate({startValue:t.get("opacity"),endValue:0,duration:this.FX_DURATION,onStart:function(){t.set("active",!1)},onChange:function(e){t.set("opacity",e),s.renderAll(),n()},onComplete:function(){s.remove(t),r()}}),this}}),fabric.util.object.extend(fabric.Object.prototype,{animate:function(){if(arguments[0]&&"object"==typeof arguments[0]){var t,e,i=[];for(t in arguments[0])i.push(t);for(var r=0,n=i.length;r<n;r++)t=i[r],e=r!==n-1,this._animate(t,arguments[0][t],arguments[1],e)}else this._animate.apply(this,arguments);return this},_animate:function(t,e,i,r){var n,s=this;e=e.toString(),i=i?fabric.util.object.clone(i):{},~t.indexOf(".")&&(n=t.split("."));var o=n?this.get(n[0])[n[1]]:this.get(t);"from"in i||(i.from=o),e=~e.indexOf("=")?o+parseFloat(e.replace("=","")):parseFloat(e),fabric.util.animate({startValue:i.from,endValue:e,byValue:i.by,easing:i.easing,duration:i.duration,abort:i.abort&&function(){return i.abort.call(s)},onChange:function(e){n?s[n[0]][n[1]]=e:s.set(t,e),r||i.onChange&&i.onChange()},onComplete:function(){r||(s.setCoords(),i.onComplete&&i.onComplete())}})}}),function(t){"use strict";function e(t,e){var i=t.origin,r=t.axis1,n=t.axis2,s=t.dimension,o=e.nearest,a=e.center,h=e.farthest;return function(){switch(this.get(i)){case o:return Math.min(this.get(r),this.get(n));case a:return Math.min(this.get(r),this.get(n))+.5*this.get(s);case h:return Math.max(this.get(r),this.get(n))}}}var i=t.fabric||(t.fabric={}),r=i.util.object.extend,n=i.util.object.clone,s={x1:1,x2:1,y1:1,y2:1},o=i.StaticCanvas.supports("setLineDash");if(i.Line)return void i.warn("fabric.Line is already defined");var a=i.Object.prototype.cacheProperties.concat();a.push("x1","x2","y1","y2"),i.Line=i.util.createClass(i.Object,{type:"line",x1:0,y1:0,x2:0,y2:0,cacheProperties:a,initialize:function(t,e){t||(t=[0,0,0,0]),this.callSuper("initialize",e),this.set("x1",t[0]),this.set("y1",t[1]),this.set("x2",t[2]),this.set("y2",t[3]),this._setWidthHeight(e)},_setWidthHeight:function(t){t||(t={}),this.width=Math.abs(this.x2-this.x1),this.height=Math.abs(this.y2-this.y1),this.left="left"in t?t.left:this._getLeftToOriginX(),this.top="top"in t?t.top:this._getTopToOriginY()},_set:function(t,e){return this.callSuper("_set",t,e),"undefined"!=typeof s[t]&&this._setWidthHeight(),this},_getLeftToOriginX:e({origin:"originX",axis1:"x1",axis2:"x2",dimension:"width"},{nearest:"left",center:"center",farthest:"right"}),_getTopToOriginY:e({origin:"originY",axis1:"y1",axis2:"y2",dimension:"height"},{nearest:"top",center:"center",farthest:"bottom"}),_render:function(t,e){if(t.beginPath(),e){var i=this.getCenterPoint();t.translate(i.x-this.strokeWidth/2,i.y-this.strokeWidth/2)}if(!this.strokeDashArray||this.strokeDashArray&&o){var r=this.calcLinePoints();t.moveTo(r.x1,r.y1),t.lineTo(r.x2,r.y2)}t.lineWidth=this.strokeWidth;var n=t.strokeStyle;t.strokeStyle=this.stroke||t.fillStyle,this.stroke&&this._renderStroke(t),t.strokeStyle=n},_renderDashedStroke:function(t){var e=this.calcLinePoints();t.beginPath(),i.util.drawDashedLine(t,e.x1,e.y1,e.x2,e.y2,this.strokeDashArray),t.closePath()},toObject:function(t){return r(this.callSuper("toObject",t),this.calcLinePoints())},_getNonTransformedDimensions:function(){var t=this.callSuper("_getNonTransformedDimensions");return"butt"===this.strokeLineCap&&(0===t.x&&(t.y-=this.strokeWidth),0===t.y&&(t.x-=this.strokeWidth)),t},calcLinePoints:function(){var t=this.x1<=this.x2?-1:1,e=this.y1<=this.y2?-1:1,i=t*this.width*.5,r=e*this.height*.5,n=t*this.width*-.5,s=e*this.height*-.5;return{x1:i,x2:n,y1:r,y2:s}},toSVG:function(t){var e=this._createBaseSVGMarkup(),i={x1:this.x1,x2:this.x2,y1:this.y1,y2:this.y2};return this.group&&"path-group"===this.group.type||(i=this.calcLinePoints()),e.push("<line ",this.getSvgId(),'x1="',i.x1,'" y1="',i.y1,'" x2="',i.x2,'" y2="',i.y2,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'"/>\n'),t?t(e.join("")):e.join("")},complexity:function(){return 1}}),i.Line.ATTRIBUTE_NAMES=i.SHARED_ATTRIBUTES.concat("x1 y1 x2 y2".split(" ")),i.Line.fromElement=function(t,e){e=e||{};var n=i.parseAttributes(t,i.Line.ATTRIBUTE_NAMES),s=[n.x1||0,n.y1||0,n.x2||0,n.y2||0];return e.originX="left",e.originY="top",new i.Line(s,r(n,e))},i.Line.fromObject=function(t,e,r){function s(t){delete t.points,e&&e(t)}var o=n(t,!0);o.points=[t.x1,t.y1,t.x2,t.y2];var a=i.Object._fromObject("Line",o,s,r,"points");return a&&delete a.points,a}}("undefined"!=typeof exports?exports:this),function(t){"use strict";function e(t){return"radius"in t&&t.radius>=0}var i=t.fabric||(t.fabric={}),r=Math.PI,n=i.util.object.extend;if(i.Circle)return void i.warn("fabric.Circle is already defined.");var s=i.Object.prototype.cacheProperties.concat();s.push("radius"),i.Circle=i.util.createClass(i.Object,{type:"circle",radius:0,startAngle:0,endAngle:2*r,cacheProperties:s,initialize:function(t){this.callSuper("initialize",t),this.set("radius",t&&t.radius||0)},_set:function(t,e){return this.callSuper("_set",t,e),"radius"===t&&this.setRadius(e),this},toObject:function(t){return this.callSuper("toObject",["radius","startAngle","endAngle"].concat(t))},toSVG:function(t){var e=this._createBaseSVGMarkup(),i=0,n=0,s=(this.endAngle-this.startAngle)%(2*r);if(0===s)this.group&&"path-group"===this.group.type&&(i=this.left+this.radius,n=this.top+this.radius),e.push("<circle ",this.getSvgId(),'cx="'+i+'" cy="'+n+'" ','r="',this.radius,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform()," ",this.getSvgTransformMatrix(),'"/>\n');else{var o=Math.cos(this.startAngle)*this.radius,a=Math.sin(this.startAngle)*this.radius,h=Math.cos(this.endAngle)*this.radius,c=Math.sin(this.endAngle)*this.radius,l=s>r?"1":"0";e.push('<path d="M '+o+" "+a," A "+this.radius+" "+this.radius," 0 ",+l+" 1"," "+h+" "+c,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform()," ",this.getSvgTransformMatrix(),'"/>\n')}return t?t(e.join("")):e.join("")},_render:function(t,e){t.beginPath(),t.arc(e?this.left+this.radius:0,e?this.top+this.radius:0,this.radius,this.startAngle,this.endAngle,!1),this._renderFill(t),this._renderStroke(t)},getRadiusX:function(){return this.get("radius")*this.get("scaleX")},getRadiusY:function(){return this.get("radius")*this.get("scaleY")},setRadius:function(t){return this.radius=t,this.set("width",2*t).set("height",2*t)},complexity:function(){return 1}}),i.Circle.ATTRIBUTE_NAMES=i.SHARED_ATTRIBUTES.concat("cx cy r".split(" ")),i.Circle.fromElement=function(t,r){r||(r={});var s=i.parseAttributes(t,i.Circle.ATTRIBUTE_NAMES);if(!e(s))throw new Error("value of `r` attribute is required and can not be negative");s.left=s.left||0,s.top=s.top||0;var o=new i.Circle(n(s,r));return o.left-=o.radius,o.top-=o.radius,o},i.Circle.fromObject=function(t,e,r){return i.Object._fromObject("Circle",t,e,r)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={});return e.Triangle?void e.warn("fabric.Triangle is already defined"):(e.Triangle=e.util.createClass(e.Object,{type:"triangle",initialize:function(t){this.callSuper("initialize",t),this.set("width",t&&t.width||100).set("height",t&&t.height||100)},_render:function(t){var e=this.width/2,i=this.height/2;t.beginPath(),t.moveTo(-e,i),t.lineTo(0,-i),t.lineTo(e,i),t.closePath(),this._renderFill(t),this._renderStroke(t)},_renderDashedStroke:function(t){var i=this.width/2,r=this.height/2;t.beginPath(),e.util.drawDashedLine(t,-i,r,0,-r,this.strokeDashArray),e.util.drawDashedLine(t,0,-r,i,r,this.strokeDashArray),e.util.drawDashedLine(t,i,r,-i,r,this.strokeDashArray),t.closePath()},toSVG:function(t){var e=this._createBaseSVGMarkup(),i=this.width/2,r=this.height/2,n=[-i+" "+r,"0 "+-r,i+" "+r].join(",");return e.push("<polygon ",this.getSvgId(),'points="',n,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),'"/>'),t?t(e.join("")):e.join("")},complexity:function(){return 1}}),void(e.Triangle.fromObject=function(t,i,r){return e.Object._fromObject("Triangle",t,i,r)}))}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=2*Math.PI,r=e.util.object.extend;if(e.Ellipse)return void e.warn("fabric.Ellipse is already defined.");var n=e.Object.prototype.cacheProperties.concat();n.push("rx","ry"),e.Ellipse=e.util.createClass(e.Object,{type:"ellipse",rx:0,ry:0,cacheProperties:n,initialize:function(t){this.callSuper("initialize",t),this.set("rx",t&&t.rx||0),this.set("ry",t&&t.ry||0)},_set:function(t,e){switch(this.callSuper("_set",t,e),t){case"rx":this.rx=e,this.set("width",2*e);break;case"ry":this.ry=e,this.set("height",2*e)}return this},getRx:function(){return this.get("rx")*this.get("scaleX")},getRy:function(){return this.get("ry")*this.get("scaleY")},toObject:function(t){return this.callSuper("toObject",["rx","ry"].concat(t))},toSVG:function(t){var e=this._createBaseSVGMarkup(),i=0,r=0;return this.group&&"path-group"===this.group.type&&(i=this.left+this.rx,r=this.top+this.ry),e.push("<ellipse ",this.getSvgId(),'cx="',i,'" cy="',r,'" ','rx="',this.rx,'" ry="',this.ry,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'"/>\n'),t?t(e.join("")):e.join("")},_render:function(t,e){t.beginPath(),t.save(),t.transform(1,0,0,this.ry/this.rx,0,0),t.arc(e?this.left+this.rx:0,e?(this.top+this.ry)*this.rx/this.ry:0,this.rx,0,i,!1),t.restore(),this._renderFill(t),this._renderStroke(t)},complexity:function(){return 1}}),e.Ellipse.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat("cx cy rx ry".split(" ")),e.Ellipse.fromElement=function(t,i){i||(i={});var n=e.parseAttributes(t,e.Ellipse.ATTRIBUTE_NAMES);n.left=n.left||0,n.top=n.top||0;var s=new e.Ellipse(r(n,i));return s.top-=s.ry,s.left-=s.rx,s},e.Ellipse.fromObject=function(t,i,r){return e.Object._fromObject("Ellipse",t,i,r)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend;if(e.Rect)return void e.warn("fabric.Rect is already defined");var r=e.Object.prototype.stateProperties.concat();r.push("rx","ry"),e.Rect=e.util.createClass(e.Object,{stateProperties:r,type:"rect",rx:0,ry:0,strokeDashArray:null,initialize:function(t){this.callSuper("initialize",t),this._initRxRy()},_initRxRy:function(){this.rx&&!this.ry?this.ry=this.rx:this.ry&&!this.rx&&(this.rx=this.ry)},_render:function(t,e){if(1===this.width&&1===this.height)return void t.fillRect(-.5,-.5,1,1);var i=this.rx?Math.min(this.rx,this.width/2):0,r=this.ry?Math.min(this.ry,this.height/2):0,n=this.width,s=this.height,o=e?this.left:-this.width/2,a=e?this.top:-this.height/2,h=0!==i||0!==r,c=.4477152502;t.beginPath(),t.moveTo(o+i,a),t.lineTo(o+n-i,a),h&&t.bezierCurveTo(o+n-c*i,a,o+n,a+c*r,o+n,a+r),t.lineTo(o+n,a+s-r),h&&t.bezierCurveTo(o+n,a+s-c*r,o+n-c*i,a+s,o+n-i,a+s),t.lineTo(o+i,a+s),h&&t.bezierCurveTo(o+c*i,a+s,o,a+s-c*r,o,a+s-r),t.lineTo(o,a+r),h&&t.bezierCurveTo(o,a+c*r,o+c*i,a,o+i,a),t.closePath(),this._renderFill(t),this._renderStroke(t)},_renderDashedStroke:function(t){var i=-this.width/2,r=-this.height/2,n=this.width,s=this.height;t.beginPath(),e.util.drawDashedLine(t,i,r,i+n,r,this.strokeDashArray),e.util.drawDashedLine(t,i+n,r,i+n,r+s,this.strokeDashArray),e.util.drawDashedLine(t,i+n,r+s,i,r+s,this.strokeDashArray),e.util.drawDashedLine(t,i,r+s,i,r,this.strokeDashArray),t.closePath()},toObject:function(t){return this.callSuper("toObject",["rx","ry"].concat(t))},toSVG:function(t){var e=this._createBaseSVGMarkup(),i=this.left,r=this.top;return this.group&&"path-group"===this.group.type||(i=-this.width/2,r=-this.height/2),e.push("<rect ",this.getSvgId(),'x="',i,'" y="',r,'" rx="',this.get("rx"),'" ry="',this.get("ry"),'" width="',this.width,'" height="',this.height,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'"/>\n'),t?t(e.join("")):e.join("")},complexity:function(){return 1}}),e.Rect.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat("x y rx ry width height".split(" ")),e.Rect.fromElement=function(t,r){if(!t)return null;r=r||{};var n=e.parseAttributes(t,e.Rect.ATTRIBUTE_NAMES);n.left=n.left||0,n.top=n.top||0;var s=new e.Rect(i(r?e.util.object.clone(r):{},n));return s.visible=s.visible&&s.width>0&&s.height>0,s},e.Rect.fromObject=function(t,i,r){return e.Object._fromObject("Rect",t,i,r)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={});if(e.Polyline)return void e.warn("fabric.Polyline is already defined");var i=e.Object.prototype.cacheProperties.concat();i.push("points"),e.Polyline=e.util.createClass(e.Object,{type:"polyline",points:null,minX:0,minY:0,cacheProperties:i,initialize:function(t,i){return e.Polygon.prototype.initialize.call(this,t,i)},_calcDimensions:function(){return e.Polygon.prototype._calcDimensions.call(this)},toObject:function(t){return e.Polygon.prototype.toObject.call(this,t)},toSVG:function(t){return e.Polygon.prototype.toSVG.call(this,t)},_render:function(t,i){e.Polygon.prototype.commonRender.call(this,t,i)&&(this._renderFill(t),this._renderStroke(t))},_renderDashedStroke:function(t){var i,r;t.beginPath();for(var n=0,s=this.points.length;n<s;n++)i=this.points[n],r=this.points[n+1]||i,e.util.drawDashedLine(t,i.x,i.y,r.x,r.y,this.strokeDashArray)},complexity:function(){return this.get("points").length}}),e.Polyline.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat(),e.Polyline.fromElement=function(t,i){if(!t)return null;i||(i={});var r=e.parsePointsAttribute(t.getAttribute("points")),n=e.parseAttributes(t,e.Polyline.ATTRIBUTE_NAMES);return new e.Polyline(r,e.util.object.extend(n,i))},e.Polyline.fromObject=function(t,i,r){return e.Object._fromObject("Polyline",t,i,r,"points")}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.util.array.min,n=e.util.array.max,s=e.util.toFixed;if(e.Polygon)return void e.warn("fabric.Polygon is already defined");var o=e.Object.prototype.cacheProperties.concat();o.push("points"),e.Polygon=e.util.createClass(e.Object,{type:"polygon",points:null,minX:0,minY:0,cacheProperties:o,initialize:function(t,e){e=e||{},this.points=t||[],this.callSuper("initialize",e),this._calcDimensions(),"top"in e||(this.top=this.minY),"left"in e||(this.left=this.minX),this.pathOffset={x:this.minX+this.width/2,y:this.minY+this.height/2}},_calcDimensions:function(){var t=this.points,e=r(t,"x"),i=r(t,"y"),s=n(t,"x"),o=n(t,"y");this.width=s-e||0,this.height=o-i||0,this.minX=e||0,this.minY=i||0},toObject:function(t){return i(this.callSuper("toObject",t),{points:this.points.concat()})},toSVG:function(t){for(var e,i=[],r=this._createBaseSVGMarkup(),n=0,o=this.points.length;n<o;n++)i.push(s(this.points[n].x,2),",",s(this.points[n].y,2)," ");return this.group&&"path-group"===this.group.type||(e=" translate("+-this.pathOffset.x+", "+-this.pathOffset.y+") "),r.push("<",this.type," ",this.getSvgId(),'points="',i.join(""),'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),e," ",this.getSvgTransformMatrix(),'"/>\n'),t?t(r.join("")):r.join("")},_render:function(t,e){this.commonRender(t,e)&&(this._renderFill(t),(this.stroke||this.strokeDashArray)&&(t.closePath(),this._renderStroke(t)))},commonRender:function(t,e){var i,r=this.points.length,n=e?0:this.pathOffset.x,s=e?0:this.pathOffset.y;if(!r||isNaN(this.points[r-1].y))return!1;t.beginPath(),t.moveTo(this.points[0].x-n,this.points[0].y-s);for(var o=0;o<r;o++)i=this.points[o],t.lineTo(i.x-n,i.y-s);return!0},_renderDashedStroke:function(t){e.Polyline.prototype._renderDashedStroke.call(this,t),t.closePath()},complexity:function(){return this.points.length}}),e.Polygon.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat(),e.Polygon.fromElement=function(t,r){if(!t)return null;r||(r={});var n=e.parsePointsAttribute(t.getAttribute("points")),s=e.parseAttributes(t,e.Polygon.ATTRIBUTE_NAMES);return new e.Polygon(n,i(s,r))},e.Polygon.fromObject=function(t,i,r){return e.Object._fromObject("Polygon",t,i,r,"points")}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.array.min,r=e.util.array.max,n=e.util.object.extend,s=Object.prototype.toString,o=e.util.drawArc,a={m:2,l:2,h:1,v:1,c:6,s:4,q:4,t:2,a:7},h={m:"l",M:"L"};if(e.Path)return void e.warn("fabric.Path is already defined");var c=e.Object.prototype.cacheProperties.concat();c.push("path"),e.Path=e.util.createClass(e.Object,{type:"path",path:null,minX:0,minY:0,cacheProperties:c,initialize:function(t,e){e=e||{},e&&this.setOptions(e),t||(t=[]);var i="[object Array]"===s.call(t);this.path=i?t:t.match&&t.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi),this.path&&(i||(this.path=this._parsePath()),this._setPositionDimensions(e),e.sourcePath&&this.setSourcePath(e.sourcePath),this.objectCaching&&(this._createCacheCanvas(),this.setupState({propertySet:"cacheProperties"})))},_setPositionDimensions:function(t){var e=this._parseDimensions();this.minX=e.left,this.minY=e.top,this.width=e.width,this.height=e.height,"undefined"==typeof t.left&&(this.left=e.left+("center"===this.originX?this.width/2:"right"===this.originX?this.width:0)),"undefined"==typeof t.top&&(this.top=e.top+("center"===this.originY?this.height/2:"bottom"===this.originY?this.height:0)),this.pathOffset=this.pathOffset||{x:this.minX+this.width/2,y:this.minY+this.height/2}},_renderPathCommands:function(t){var e,i,r,n=null,s=0,a=0,h=0,c=0,l=0,u=0,f=-this.pathOffset.x,d=-this.pathOffset.y;this.group&&"path-group"===this.group.type&&(f=0,d=0),t.beginPath();for(var g=0,p=this.path.length;g<p;++g){switch(e=this.path[g],e[0]){case"l":h+=e[1],c+=e[2],t.lineTo(h+f,c+d);break;case"L":h=e[1],c=e[2],t.lineTo(h+f,c+d);break;case"h":h+=e[1],t.lineTo(h+f,c+d);break;case"H":h=e[1],t.lineTo(h+f,c+d);break;case"v":c+=e[1],t.lineTo(h+f,c+d);break;case"V":c=e[1],t.lineTo(h+f,c+d);break;case"m":h+=e[1],c+=e[2],s=h,a=c,t.moveTo(h+f,c+d);break;case"M":h=e[1],c=e[2],s=h,a=c,t.moveTo(h+f,c+d);break;case"c":i=h+e[5],r=c+e[6],l=h+e[3],u=c+e[4],t.bezierCurveTo(h+e[1]+f,c+e[2]+d,l+f,u+d,i+f,r+d),h=i,c=r;break;case"C":h=e[5],c=e[6],l=e[3],u=e[4],t.bezierCurveTo(e[1]+f,e[2]+d,l+f,u+d,h+f,c+d);break;case"s":i=h+e[3],r=c+e[4],null===n[0].match(/[CcSs]/)?(l=h,u=c):(l=2*h-l,u=2*c-u),t.bezierCurveTo(l+f,u+d,h+e[1]+f,c+e[2]+d,i+f,r+d),l=h+e[1],u=c+e[2],h=i,c=r;break;case"S":i=e[3],r=e[4],null===n[0].match(/[CcSs]/)?(l=h,u=c):(l=2*h-l,u=2*c-u),t.bezierCurveTo(l+f,u+d,e[1]+f,e[2]+d,i+f,r+d),h=i,c=r,l=e[1],u=e[2];break;case"q":i=h+e[3],r=c+e[4],l=h+e[1],u=c+e[2],t.quadraticCurveTo(l+f,u+d,i+f,r+d),h=i,c=r;break;case"Q":i=e[3],r=e[4],t.quadraticCurveTo(e[1]+f,e[2]+d,i+f,r+d),h=i,c=r,l=e[1],u=e[2];break;case"t":i=h+e[1],r=c+e[2],null===n[0].match(/[QqTt]/)?(l=h,u=c):(l=2*h-l,u=2*c-u),t.quadraticCurveTo(l+f,u+d,i+f,r+d),h=i,c=r;break;case"T":i=e[1],r=e[2],null===n[0].match(/[QqTt]/)?(l=h,u=c):(l=2*h-l,u=2*c-u),t.quadraticCurveTo(l+f,u+d,i+f,r+d),h=i,c=r;break;case"a":o(t,h+f,c+d,[e[1],e[2],e[3],e[4],e[5],e[6]+h+f,e[7]+c+d]),h+=e[6],c+=e[7];break;case"A":o(t,h+f,c+d,[e[1],e[2],e[3],e[4],e[5],e[6]+f,e[7]+d]),h=e[6],c=e[7];break;case"z":case"Z":h=s,c=a,t.closePath()}n=e}},_render:function(t){this._renderPathCommands(t),this._renderFill(t),this._renderStroke(t)},toString:function(){return"#<fabric.Path ("+this.complexity()+'): { "top": '+this.top+', "left": '+this.left+" }>"},toObject:function(t){var e=n(this.callSuper("toObject",["sourcePath","pathOffset"].concat(t)),{
path:this.path.map(function(t){return t.slice()})});return e},toDatalessObject:function(t){var e=this.toObject(t);return this.sourcePath&&(e.path=this.sourcePath),delete e.sourcePath,e},toSVG:function(t){for(var e=[],i=this._createBaseSVGMarkup(),r="",n=0,s=this.path.length;n<s;n++)e.push(this.path[n].join(" "));var o=e.join(" ");return this.group&&"path-group"===this.group.type||(r=" translate("+-this.pathOffset.x+", "+-this.pathOffset.y+") "),i.push("<path ",this.getSvgId(),'d="',o,'" style="',this.getSvgStyles(),'" transform="',this.getSvgTransform(),r,this.getSvgTransformMatrix(),'" stroke-linecap="round" ',"/>\n"),t?t(i.join("")):i.join("")},complexity:function(){return this.path.length},_parsePath:function(){for(var t,e,i,r,n,s=[],o=[],c=/([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi,l=0,u=this.path.length;l<u;l++){for(t=this.path[l],r=t.slice(1).trim(),o.length=0;i=c.exec(r);)o.push(i[0]);n=[t.charAt(0)];for(var f=0,d=o.length;f<d;f++)e=parseFloat(o[f]),isNaN(e)||n.push(e);var g=n[0],p=a[g.toLowerCase()],v=h[g]||g;if(n.length-1>p)for(var b=1,m=n.length;b<m;b+=p)s.push([g].concat(n.slice(b,b+p))),g=v;else s.push(n)}return s},_parseDimensions:function(){for(var t,n,s,o,a=[],h=[],c=null,l=0,u=0,f=0,d=0,g=0,p=0,v=0,b=this.path.length;v<b;++v){switch(t=this.path[v],t[0]){case"l":f+=t[1],d+=t[2],o=[];break;case"L":f=t[1],d=t[2],o=[];break;case"h":f+=t[1],o=[];break;case"H":f=t[1],o=[];break;case"v":d+=t[1],o=[];break;case"V":d=t[1],o=[];break;case"m":f+=t[1],d+=t[2],l=f,u=d,o=[];break;case"M":f=t[1],d=t[2],l=f,u=d,o=[];break;case"c":n=f+t[5],s=d+t[6],g=f+t[3],p=d+t[4],o=e.util.getBoundsOfCurve(f,d,f+t[1],d+t[2],g,p,n,s),f=n,d=s;break;case"C":f=t[5],d=t[6],g=t[3],p=t[4],o=e.util.getBoundsOfCurve(f,d,t[1],t[2],g,p,f,d);break;case"s":n=f+t[3],s=d+t[4],null===c[0].match(/[CcSs]/)?(g=f,p=d):(g=2*f-g,p=2*d-p),o=e.util.getBoundsOfCurve(f,d,g,p,f+t[1],d+t[2],n,s),g=f+t[1],p=d+t[2],f=n,d=s;break;case"S":n=t[3],s=t[4],null===c[0].match(/[CcSs]/)?(g=f,p=d):(g=2*f-g,p=2*d-p),o=e.util.getBoundsOfCurve(f,d,g,p,t[1],t[2],n,s),f=n,d=s,g=t[1],p=t[2];break;case"q":n=f+t[3],s=d+t[4],g=f+t[1],p=d+t[2],o=e.util.getBoundsOfCurve(f,d,g,p,g,p,n,s),f=n,d=s;break;case"Q":g=t[1],p=t[2],o=e.util.getBoundsOfCurve(f,d,g,p,g,p,t[3],t[4]),f=t[3],d=t[4];break;case"t":n=f+t[1],s=d+t[2],null===c[0].match(/[QqTt]/)?(g=f,p=d):(g=2*f-g,p=2*d-p),o=e.util.getBoundsOfCurve(f,d,g,p,g,p,n,s),f=n,d=s;break;case"T":n=t[1],s=t[2],null===c[0].match(/[QqTt]/)?(g=f,p=d):(g=2*f-g,p=2*d-p),o=e.util.getBoundsOfCurve(f,d,g,p,g,p,n,s),f=n,d=s;break;case"a":o=e.util.getBoundsOfArc(f,d,t[1],t[2],t[3],t[4],t[5],t[6]+f,t[7]+d),f+=t[6],d+=t[7];break;case"A":o=e.util.getBoundsOfArc(f,d,t[1],t[2],t[3],t[4],t[5],t[6],t[7]),f=t[6],d=t[7];break;case"z":case"Z":f=l,d=u}c=t,o.forEach(function(t){a.push(t.x),h.push(t.y)}),a.push(f),h.push(d)}var m=i(a)||0,y=i(h)||0,_=r(a)||0,x=r(h)||0,C=_-m,S=x-y,w={left:m,top:y,width:C,height:S};return w}}),e.Path.fromObject=function(t,i,r){var n;return"string"!=typeof t.path?e.Object._fromObject("Path",t,i,r,"path"):void e.loadSVGFromURL(t.path,function(r){var s=t.path;n=r[0],delete t.path,e.util.object.extend(n,t),n.setSourcePath(s),i&&i(n)})},e.Path.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat(["d"]),e.Path.fromElement=function(t,i,r){var s=e.parseAttributes(t,e.Path.ATTRIBUTE_NAMES);i&&i(new e.Path(s.d,n(s,r)))},e.Path.async=!0}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend;return e.PathGroup?void e.warn("fabric.PathGroup is already defined"):(e.PathGroup=e.util.createClass(e.Object,{type:"path-group",fill:"",initialize:function(t,e){e=e||{},this.paths=t||[];for(var i=this.paths.length;i--;)this.paths[i].group=this;e.toBeParsed&&(this.parseDimensionsFromPaths(e),delete e.toBeParsed),this.setOptions(e),this.setCoords(),e.sourcePath&&this.setSourcePath(e.sourcePath),this.objectCaching&&(this._createCacheCanvas(),this.setupState({propertySet:"cacheProperties"}))},parseDimensionsFromPaths:function(t){for(var i,r,n,s,o,a,h=[],c=[],l=this.paths.length;l--;){n=this.paths[l],s=n.height+n.strokeWidth,o=n.width+n.strokeWidth,i=[{x:n.left,y:n.top},{x:n.left+o,y:n.top},{x:n.left,y:n.top+s},{x:n.left+o,y:n.top+s}],a=this.paths[l].transformMatrix;for(var u=0;u<i.length;u++)r=i[u],a&&(r=e.util.transformPoint(r,a,!1)),h.push(r.x),c.push(r.y)}t.width=Math.max.apply(null,h),t.height=Math.max.apply(null,c)},drawObject:function(t){t.save(),t.translate(-this.width/2,-this.height/2);for(var e=0,i=this.paths.length;e<i;++e)this.paths[e].render(t,!0);t.restore()},isCacheDirty:function(){if(this.callSuper("isCacheDirty"))return!0;if(!this.statefullCache)return!1;for(var t=0,e=this.paths.length;t<e;t++)if(this.paths[t].isCacheDirty(!0)){var i=this._getNonTransformedDimensions();return this._cacheContext.clearRect(-i.x/2,-i.y/2,i.x,i.y),!0}return!1},_set:function(t,e){if("fill"===t&&e&&this.isSameColor())for(var i=this.paths.length;i--;)this.paths[i]._set(t,e);return this.callSuper("_set",t,e)},toObject:function(t){var e=this.paths.map(function(e){var i=e.includeDefaultValues;e.includeDefaultValues=e.group.includeDefaultValues;var r=e.toObject(t);return e.includeDefaultValues=i,r}),r=i(this.callSuper("toObject",["sourcePath"].concat(t)),{paths:e});return r},toDatalessObject:function(t){var e=this.toObject(t);return this.sourcePath&&(e.paths=this.sourcePath),e},toSVG:function(t){var e=this.getObjects(),i=this.getPointByOrigin("left","top"),r="translate("+i.x+" "+i.y+")",n=this._createBaseSVGMarkup();n.push("<g ",this.getSvgId(),'style="',this.getSvgStyles(),'" ','transform="',this.getSvgTransformMatrix(),r,this.getSvgTransform(),'" ',">\n");for(var s=0,o=e.length;s<o;s++)n.push("\t",e[s].toSVG(t));return n.push("</g>\n"),t?t(n.join("")):n.join("")},toString:function(){return"#<fabric.PathGroup ("+this.complexity()+"): { top: "+this.top+", left: "+this.left+" }>"},isSameColor:function(){var t=this.getObjects()[0].get("fill")||"";return"string"==typeof t&&(t=t.toLowerCase(),this.getObjects().every(function(e){var i=e.get("fill")||"";return"string"==typeof i&&i.toLowerCase()===t}))},complexity:function(){return this.paths.reduce(function(t,e){return t+(e&&e.complexity?e.complexity():0)},0)},getObjects:function(){return this.paths}}),e.PathGroup.fromObject=function(t,i){"string"==typeof t.paths?e.loadSVGFromURL(t.paths,function(r){var n=t.paths;delete t.paths;var s=e.util.groupSVGElements(r,t,n);i(s)}):e.util.enlivenObjects(t.paths,function(r){delete t.paths,i(new e.PathGroup(r,t))})},void(e.PathGroup.async=!0))}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.util.array.min,n=e.util.array.max;if(!e.Group){var s={lockMovementX:!0,lockMovementY:!0,lockRotation:!0,lockScalingX:!0,lockScalingY:!0,lockUniScaling:!0};e.Group=e.util.createClass(e.Object,e.Collection,{type:"group",strokeWidth:0,subTargetCheck:!1,initialize:function(t,e,i){e=e||{},this._objects=[],i&&this.callSuper("initialize",e),this._objects=t||[];for(var r=this._objects.length;r--;)this._objects[r].group=this;this.originalState={},e.originX&&(this.originX=e.originX),e.originY&&(this.originY=e.originY),i?this._updateObjectsCoords(!0):(this._calcBounds(),this._updateObjectsCoords(),this.callSuper("initialize",e)),this.setCoords(),this.saveCoords()},_updateObjectsCoords:function(t){for(var e=this.getCenterPoint(),i=this._objects.length;i--;)this._updateObjectCoords(this._objects[i],e,t)},_updateObjectCoords:function(t,e,i){if(t.__origHasControls=t.hasControls,t.hasControls=!1,!i){var r=t.getLeft(),n=t.getTop(),s=!0;t.set({originalLeft:r,originalTop:n,left:r-e.x,top:n-e.y}),t.setCoords(s)}},toString:function(){return"#<fabric.Group: ("+this.complexity()+")>"},addWithUpdate:function(t){return this._restoreObjectsState(),e.util.resetObjectTransform(this),t&&(this._objects.push(t),t.group=this,t._set("canvas",this.canvas)),this.forEachObject(this._setObjectActive,this),this._calcBounds(),this._updateObjectsCoords(),this.dirty=!0,this},_setObjectActive:function(t){t.set("active",!0),t.group=this},removeWithUpdate:function(t){return this._restoreObjectsState(),e.util.resetObjectTransform(this),this.forEachObject(this._setObjectActive,this),this.remove(t),this._calcBounds(),this._updateObjectsCoords(),this.dirty=!0,this},_onObjectAdded:function(t){this.dirty=!0,t.group=this,t._set("canvas",this.canvas)},_onObjectRemoved:function(t){this.dirty=!0,delete t.group,t.set("active",!1)},delegatedProperties:{fill:!0,stroke:!0,strokeWidth:!0,fontFamily:!0,fontWeight:!0,fontSize:!0,fontStyle:!0,lineHeight:!0,textDecoration:!0,textAlign:!0,backgroundColor:!0},_set:function(t,e){var i=this._objects.length;if(this.delegatedProperties[t]||"canvas"===t)for(;i--;)this._objects[i].set(t,e);else for(;i--;)this._objects[i].setOnGroup(t,e);this.callSuper("_set",t,e)},toObject:function(t){var e=this.getObjects().map(function(e){var i=e.includeDefaultValues;e.includeDefaultValues=e.group.includeDefaultValues;var r=e.toObject(t);return e.includeDefaultValues=i,r});return i(this.callSuper("toObject",t),{objects:e})},render:function(t){this._transformDone=!0,this.callSuper("render",t),this._transformDone=!1},drawObject:function(t){for(var e=0,i=this._objects.length;e<i;e++)this._renderObject(this._objects[e],t)},isCacheDirty:function(){if(this.callSuper("isCacheDirty"))return!0;if(!this.statefullCache)return!1;for(var t=0,e=this._objects.length;t<e;t++)if(this._objects[t].isCacheDirty(!0)){var i=this._getNonTransformedDimensions();return this._cacheContext.clearRect(-i.x/2,-i.y/2,i.x,i.y),!0}return!1},_renderControls:function(t,e){t.save(),t.globalAlpha=this.isMoving?this.borderOpacityWhenMoving:1,this.callSuper("_renderControls",t,e);for(var i=0,r=this._objects.length;i<r;i++)this._objects[i]._renderControls(t);t.restore()},_renderObject:function(t,e){if(t.visible){var i=t.hasRotatingPoint;t.hasRotatingPoint=!1,t.render(e),t.hasRotatingPoint=i}},_restoreObjectsState:function(){return this._objects.forEach(this._restoreObjectState,this),this},realizeTransform:function(t){var i=t.calcTransformMatrix(),r=e.util.qrDecompose(i),n=new e.Point(r.translateX,r.translateY);return t.flipX=!1,t.flipY=!1,t.set("scaleX",r.scaleX),t.set("scaleY",r.scaleY),t.skewX=r.skewX,t.skewY=r.skewY,t.angle=r.angle,t.setPositionByOrigin(n,"center","center"),t},_restoreObjectState:function(t){return this.realizeTransform(t),t.setCoords(),t.hasControls=t.__origHasControls,delete t.__origHasControls,t.set("active",!1),delete t.group,this},destroy:function(){return this._restoreObjectsState()},saveCoords:function(){return this._originalLeft=this.get("left"),this._originalTop=this.get("top"),this},hasMoved:function(){return this._originalLeft!==this.get("left")||this._originalTop!==this.get("top")},setObjectsCoords:function(){var t=!0;return this.forEachObject(function(e){e.setCoords(t)}),this},_calcBounds:function(t){for(var e,i,r,n=[],s=[],o=["tr","br","bl","tl"],a=0,h=this._objects.length,c=o.length,l=!0;a<h;++a)for(e=this._objects[a],e.setCoords(l),r=0;r<c;r++)i=o[r],n.push(e.oCoords[i].x),s.push(e.oCoords[i].y);this.set(this._getBounds(n,s,t))},_getBounds:function(t,i,s){var o=new e.Point(r(t),r(i)),a=new e.Point(n(t),n(i)),h={width:a.x-o.x||0,height:a.y-o.y||0};return s||(h.left=o.x||0,h.top=o.y||0,"center"===this.originX&&(h.left+=h.width/2),"right"===this.originX&&(h.left+=h.width),"center"===this.originY&&(h.top+=h.height/2),"bottom"===this.originY&&(h.top+=h.height)),h},toSVG:function(t){var e=this._createBaseSVGMarkup();e.push("<g ",this.getSvgId(),'transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'" style="',this.getSvgFilter(),'">\n');for(var i=0,r=this._objects.length;i<r;i++)e.push("\t",this._objects[i].toSVG(t));return e.push("</g>\n"),t?t(e.join("")):e.join("")},get:function(t){if(t in s){if(this[t])return this[t];for(var e=0,i=this._objects.length;e<i;e++)if(this._objects[e][t])return!0;return!1}return t in this.delegatedProperties?this._objects[0]&&this._objects[0].get(t):this[t]}}),e.Group.fromObject=function(t,i){e.util.enlivenObjects(t.objects,function(r){delete t.objects,i&&i(new e.Group(r,t,!0))})},e.Group.async=!0}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=fabric.util.object.extend;if(t.fabric||(t.fabric={}),t.fabric.Image)return void fabric.warn("fabric.Image is already defined.");var i=fabric.Object.prototype.stateProperties.concat();i.push("alignX","alignY","meetOrSlice"),fabric.Image=fabric.util.createClass(fabric.Object,{type:"image",crossOrigin:"",alignX:"none",alignY:"none",meetOrSlice:"meet",strokeWidth:0,_lastScaleX:1,_lastScaleY:1,minimumScaleTrigger:.5,stateProperties:i,objectCaching:!1,initialize:function(t,e,i){e||(e={}),this.filters=[],this.resizeFilters=[],this.callSuper("initialize",e),this._initElement(t,e,i)},getElement:function(){return this._element},setElement:function(t,e,i){var r,n;return this._element=t,this._originalElement=t,this._initConfig(i),0===this.resizeFilters.length?r=e:(n=this,r=function(){n.applyFilters(e,n.resizeFilters,n._filteredEl||n._originalElement,!0)}),0!==this.filters.length?this.applyFilters(r):r&&r(this),this},setCrossOrigin:function(t){return this.crossOrigin=t,this._element.crossOrigin=t,this},getOriginalSize:function(){var t=this.getElement();return{width:t.width,height:t.height}},_stroke:function(t){if(this.stroke&&0!==this.strokeWidth){var e=this.width/2,i=this.height/2;t.beginPath(),t.moveTo(-e,-i),t.lineTo(e,-i),t.lineTo(e,i),t.lineTo(-e,i),t.lineTo(-e,-i),t.closePath()}},_renderDashedStroke:function(t){var e=-this.width/2,i=-this.height/2,r=this.width,n=this.height;t.save(),this._setStrokeStyles(t),t.beginPath(),fabric.util.drawDashedLine(t,e,i,e+r,i,this.strokeDashArray),fabric.util.drawDashedLine(t,e+r,i,e+r,i+n,this.strokeDashArray),fabric.util.drawDashedLine(t,e+r,i+n,e,i+n,this.strokeDashArray),fabric.util.drawDashedLine(t,e,i+n,e,i,this.strokeDashArray),t.closePath(),t.restore()},toObject:function(t){var i=[],r=[],n=1,s=1;this.filters.forEach(function(t){t&&("Resize"===t.type&&(n*=t.scaleX,s*=t.scaleY),i.push(t.toObject()))}),this.resizeFilters.forEach(function(t){t&&r.push(t.toObject())});var o=e(this.callSuper("toObject",["crossOrigin","alignX","alignY","meetOrSlice"].concat(t)),{src:this.getSrc(),filters:i,resizeFilters:r});return o.width/=n,o.height/=s,o},toSVG:function(t){var e=this._createBaseSVGMarkup(),i=-this.width/2,r=-this.height/2,n="none",s=!0;if(this.group&&"path-group"===this.group.type&&(i=this.left,r=this.top),"none"!==this.alignX&&"none"!==this.alignY&&(n="x"+this.alignX+"Y"+this.alignY+" "+this.meetOrSlice),e.push('<g transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'">\n',"<image ",this.getSvgId(),'xlink:href="',this.getSvgSrc(s),'" x="',i,'" y="',r,'" style="',this.getSvgStyles(),'" width="',this.width,'" height="',this.height,'" preserveAspectRatio="',n,'"',"></image>\n"),this.stroke||this.strokeDashArray){var o=this.fill;this.fill=null,e.push("<rect ",'x="',i,'" y="',r,'" width="',this.width,'" height="',this.height,'" style="',this.getSvgStyles(),'"/>\n'),this.fill=o}return e.push("</g>\n"),t?t(e.join("")):e.join("")},getSrc:function(t){var e=t?this._element:this._originalElement;return e?fabric.isLikelyNode?e._src:e.src:this.src||""},setSrc:function(t,e,i){fabric.util.loadImage(t,function(t){return this.setElement(t,e,i)},this,i&&i.crossOrigin)},toString:function(){return'#<fabric.Image: { src: "'+this.getSrc()+'" }>'},applyFilters:function(t,e,i,r){if(e=e||this.filters,i=i||this._originalElement){var n,s,o=fabric.util.createImage(),a=this.canvas?this.canvas.getRetinaScaling():fabric.devicePixelRatio,h=this.minimumScaleTrigger/a,c=this;if(0===e.length)return this._element=i,t&&t(this),i;var l=fabric.util.createCanvasElement();return l.width=i.width,l.height=i.height,l.getContext("2d").drawImage(i,0,0,i.width,i.height),e.forEach(function(t){t&&(r?(n=c.scaleX<h?c.scaleX:1,s=c.scaleY<h?c.scaleY:1,n*a<1&&(n*=a),s*a<1&&(s*=a)):(n=t.scaleX,s=t.scaleY),t.applyTo(l,n,s),r||"Resize"!==t.type||(c.width*=t.scaleX,c.height*=t.scaleY))}),o.width=l.width,o.height=l.height,fabric.isLikelyNode?(o.src=l.toBuffer(void 0,fabric.Image.pngCompression),c._element=o,!r&&(c._filteredEl=o),t&&t(c)):(o.onload=function(){c._element=o,!r&&(c._filteredEl=o),t&&t(c),o.onload=l=null},o.src=l.toDataURL("image/png")),l}},_render:function(t,e){var i,r,n,s=this._findMargins();i=e?this.left:-this.width/2,r=e?this.top:-this.height/2,"slice"===this.meetOrSlice&&(t.beginPath(),t.rect(i,r,this.width,this.height),t.clip()),this.isMoving===!1&&this.resizeFilters.length&&this._needsResize()?(this._lastScaleX=this.scaleX,this._lastScaleY=this.scaleY,n=this.applyFilters(null,this.resizeFilters,this._filteredEl||this._originalElement,!0)):n=this._element,n&&t.drawImage(n,i+s.marginX,r+s.marginY,s.width,s.height),this._stroke(t),this._renderStroke(t)},_needsResize:function(){return this.scaleX!==this._lastScaleX||this.scaleY!==this._lastScaleY},_findMargins:function(){var t,e,i=this.width,r=this.height,n=0,s=0;return"none"===this.alignX&&"none"===this.alignY||(t=[this.width/this._element.width,this.height/this._element.height],e="meet"===this.meetOrSlice?Math.min.apply(null,t):Math.max.apply(null,t),i=this._element.width*e,r=this._element.height*e,"Mid"===this.alignX&&(n=(this.width-i)/2),"Max"===this.alignX&&(n=this.width-i),"Mid"===this.alignY&&(s=(this.height-r)/2),"Max"===this.alignY&&(s=this.height-r)),{width:i,height:r,marginX:n,marginY:s}},_resetWidthHeight:function(){var t=this.getElement();this.set("width",t.width),this.set("height",t.height)},_initElement:function(t,e,i){this.setElement(fabric.util.getById(t),i,e),fabric.util.addClass(this.getElement(),fabric.Image.CSS_CANVAS)},_initConfig:function(t){t||(t={}),this.setOptions(t),this._setWidthHeight(t),this._element&&this.crossOrigin&&(this._element.crossOrigin=this.crossOrigin)},_initFilters:function(t,e){t&&t.length?fabric.util.enlivenObjects(t,function(t){e&&e(t)},"fabric.Image.filters"):e&&e()},_setWidthHeight:function(t){this.width="width"in t?t.width:this.getElement()?this.getElement().width||0:0,this.height="height"in t?t.height:this.getElement()?this.getElement().height||0:0},complexity:function(){return 1}}),fabric.Image.CSS_CANVAS="canvas-img",fabric.Image.prototype.getSvgSrc=fabric.Image.prototype.getSrc,fabric.Image.fromObject=function(t,e){fabric.util.loadImage(t.src,function(i,r){return r?void(e&&e(null,r)):void fabric.Image.prototype._initFilters.call(t,t.filters,function(r){t.filters=r||[],fabric.Image.prototype._initFilters.call(t,t.resizeFilters,function(r){return t.resizeFilters=r||[],new fabric.Image(i,t,e)})})},null,t.crossOrigin)},fabric.Image.fromURL=function(t,e,i){fabric.util.loadImage(t,function(t){e&&e(new fabric.Image(t,i))},null,i&&i.crossOrigin)},fabric.Image.ATTRIBUTE_NAMES=fabric.SHARED_ATTRIBUTES.concat("x y width height preserveAspectRatio xlink:href".split(" ")),fabric.Image.fromElement=function(t,i,r){var n,s=fabric.parseAttributes(t,fabric.Image.ATTRIBUTE_NAMES);s.preserveAspectRatio&&(n=fabric.util.parsePreserveAspectRatioAttribute(s.preserveAspectRatio),e(s,n)),fabric.Image.fromURL(s["xlink:href"],i,e(r?fabric.util.object.clone(r):{},s))},fabric.Image.async=!0,fabric.Image.pngCompression=1}("undefined"!=typeof exports?exports:this),fabric.util.object.extend(fabric.Object.prototype,{_getAngleValueForStraighten:function(){var t=this.getAngle()%360;return t>0?90*Math.round((t-1)/90):90*Math.round(t/90)},straighten:function(){return this.setAngle(this._getAngleValueForStraighten()),this},fxStraighten:function(t){t=t||{};var e=function(){},i=t.onComplete||e,r=t.onChange||e,n=this;return fabric.util.animate({startValue:this.get("angle"),endValue:this._getAngleValueForStraighten(),duration:this.FX_DURATION,onChange:function(t){n.setAngle(t),r()},onComplete:function(){n.setCoords(),i()},onStart:function(){n.set("active",!1)}}),this}}),fabric.util.object.extend(fabric.StaticCanvas.prototype,{straightenObject:function(t){return t.straighten(),this.renderAll(),this},fxStraightenObject:function(t){return t.fxStraighten({onChange:this.renderAll.bind(this)}),this}}),fabric.Image.filters=fabric.Image.filters||{},fabric.Image.filters.BaseFilter=fabric.util.createClass({type:"BaseFilter",initialize:function(t){t&&this.setOptions(t)},setOptions:function(t){for(var e in t)this[e]=t[e]},toObject:function(){return{type:this.type}},toJSON:function(){return this.toObject()}}),fabric.Image.filters.BaseFilter.fromObject=function(t,e){var i=new fabric.Image.filters[t.type](t);return e&&e(i),i},function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Brightness=n(r.BaseFilter,{type:"Brightness",initialize:function(t){t=t||{},this.brightness=t.brightness||0},applyTo:function(t){for(var e=t.getContext("2d"),i=e.getImageData(0,0,t.width,t.height),r=i.data,n=this.brightness,s=0,o=r.length;s<o;s+=4)r[s]+=n,r[s+1]+=n,r[s+2]+=n;e.putImageData(i,0,0)},toObject:function(){return i(this.callSuper("toObject"),{brightness:this.brightness})}}),e.Image.filters.Brightness.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Convolute=n(r.BaseFilter,{type:"Convolute",initialize:function(t){t=t||{},this.opaque=t.opaque,this.matrix=t.matrix||[0,0,0,0,1,0,0,0,0]},applyTo:function(t){for(var e,i,r,n,s,o,a,h,c,l=this.matrix,u=t.getContext("2d"),f=u.getImageData(0,0,t.width,t.height),d=Math.round(Math.sqrt(l.length)),g=Math.floor(d/2),p=f.data,v=f.width,b=f.height,m=u.createImageData(v,b),y=m.data,_=this.opaque?1:0,x=0;x<b;x++)for(var C=0;C<v;C++){s=4*(x*v+C),e=0,i=0,r=0,n=0;for(var S=0;S<d;S++)for(var w=0;w<d;w++)a=x+S-g,o=C+w-g,a<0||a>b||o<0||o>v||(h=4*(a*v+o),c=l[S*d+w],e+=p[h]*c,i+=p[h+1]*c,r+=p[h+2]*c,n+=p[h+3]*c);y[s]=e,y[s+1]=i,y[s+2]=r,y[s+3]=n+_*(255-n)}u.putImageData(m,0,0)},toObject:function(){return i(this.callSuper("toObject"),{opaque:this.opaque,matrix:this.matrix})}}),e.Image.filters.Convolute.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.GradientTransparency=n(r.BaseFilter,{type:"GradientTransparency",initialize:function(t){t=t||{},this.threshold=t.threshold||100},applyTo:function(t){for(var e=t.getContext("2d"),i=e.getImageData(0,0,t.width,t.height),r=i.data,n=this.threshold,s=r.length,o=0,a=r.length;o<a;o+=4)r[o+3]=n+255*(s-o)/s;e.putImageData(i,0,0)},toObject:function(){return i(this.callSuper("toObject"),{threshold:this.threshold})}}),e.Image.filters.GradientTransparency.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.Image.filters,r=e.util.createClass;i.Grayscale=r(i.BaseFilter,{type:"Grayscale",applyTo:function(t){for(var e,i=t.getContext("2d"),r=i.getImageData(0,0,t.width,t.height),n=r.data,s=r.width*r.height*4,o=0;o<s;)e=(n[o]+n[o+1]+n[o+2])/3,n[o]=e,n[o+1]=e,n[o+2]=e,o+=4;i.putImageData(r,0,0)}}),e.Image.filters.Grayscale.fromObject=function(t,i){return t=t||{},t.type="Grayscale",e.Image.filters.BaseFilter.fromObject(t,i)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.Image.filters,r=e.util.createClass;i.Invert=r(i.BaseFilter,{type:"Invert",applyTo:function(t){var e,i=t.getContext("2d"),r=i.getImageData(0,0,t.width,t.height),n=r.data,s=n.length;for(e=0;e<s;e+=4)n[e]=255-n[e],n[e+1]=255-n[e+1],n[e+2]=255-n[e+2];i.putImageData(r,0,0)}}),e.Image.filters.Invert.fromObject=function(t,i){return t=t||{},t.type="Invert",e.Image.filters.BaseFilter.fromObject(t,i)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Mask=n(r.BaseFilter,{type:"Mask",initialize:function(t){t=t||{},this.mask=t.mask,this.channel=[0,1,2,3].indexOf(t.channel)>-1?t.channel:0},applyTo:function(t){if(this.mask){var i,r=t.getContext("2d"),n=r.getImageData(0,0,t.width,t.height),s=n.data,o=this.mask.getElement(),a=e.util.createCanvasElement(),h=this.channel,c=n.width*n.height*4;a.width=t.width,a.height=t.height,a.getContext("2d").drawImage(o,0,0,t.width,t.height);var l=a.getContext("2d").getImageData(0,0,t.width,t.height),u=l.data;for(i=0;i<c;i+=4)s[i+3]=u[i+h];r.putImageData(n,0,0)}},toObject:function(){return i(this.callSuper("toObject"),{mask:this.mask.toObject(),channel:this.channel})}}),e.Image.filters.Mask.fromObject=function(t,i){e.util.loadImage(t.mask.src,function(r){return t.mask=new e.Image(r,t.mask),e.Image.filters.BaseFilter.fromObject(t,i)})},e.Image.filters.Mask.async=!0}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Noise=n(r.BaseFilter,{type:"Noise",initialize:function(t){t=t||{},this.noise=t.noise||0},applyTo:function(t){for(var e,i=t.getContext("2d"),r=i.getImageData(0,0,t.width,t.height),n=r.data,s=this.noise,o=0,a=n.length;o<a;o+=4)e=(.5-Math.random())*s,n[o]+=e,n[o+1]+=e,n[o+2]+=e;i.putImageData(r,0,0)},toObject:function(){return i(this.callSuper("toObject"),{noise:this.noise})}}),e.Image.filters.Noise.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Pixelate=n(r.BaseFilter,{type:"Pixelate",initialize:function(t){t=t||{},this.blocksize=t.blocksize||4},applyTo:function(t){var e,i,r,n,s,o,a,h=t.getContext("2d"),c=h.getImageData(0,0,t.width,t.height),l=c.data,u=c.height,f=c.width;for(i=0;i<u;i+=this.blocksize)for(r=0;r<f;r+=this.blocksize){e=4*i*f+4*r,n=l[e],s=l[e+1],o=l[e+2],a=l[e+3];for(var d=i,g=i+this.blocksize;d<g;d++)for(var p=r,v=r+this.blocksize;p<v;p++)e=4*d*f+4*p,l[e]=n,l[e+1]=s,l[e+2]=o,l[e+3]=a}h.putImageData(c,0,0)},toObject:function(){return i(this.callSuper("toObject"),{blocksize:this.blocksize})}}),e.Image.filters.Pixelate.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.RemoveWhite=n(r.BaseFilter,{type:"RemoveWhite",initialize:function(t){t=t||{},this.threshold=t.threshold||30,this.distance=t.distance||20},applyTo:function(t){for(var e,i,r,n=t.getContext("2d"),s=n.getImageData(0,0,t.width,t.height),o=s.data,a=this.threshold,h=this.distance,c=255-a,l=Math.abs,u=0,f=o.length;u<f;u+=4)e=o[u],i=o[u+1],r=o[u+2],e>c&&i>c&&r>c&&l(e-i)<h&&l(e-r)<h&&l(i-r)<h&&(o[u+3]=0);n.putImageData(s,0,0)},toObject:function(){return i(this.callSuper("toObject"),{threshold:this.threshold,distance:this.distance})}}),e.Image.filters.RemoveWhite.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.Image.filters,r=e.util.createClass;i.Sepia=r(i.BaseFilter,{type:"Sepia",applyTo:function(t){var e,i,r=t.getContext("2d"),n=r.getImageData(0,0,t.width,t.height),s=n.data,o=s.length;for(e=0;e<o;e+=4)i=.3*s[e]+.59*s[e+1]+.11*s[e+2],s[e]=i+100,s[e+1]=i+50,s[e+2]=i+255;r.putImageData(n,0,0)}}),e.Image.filters.Sepia.fromObject=function(t,i){return t=t||{},t.type="Sepia",new e.Image.filters.BaseFilter.fromObject(t,i)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.Image.filters,r=e.util.createClass;i.Sepia2=r(i.BaseFilter,{type:"Sepia2",applyTo:function(t){var e,i,r,n,s=t.getContext("2d"),o=s.getImageData(0,0,t.width,t.height),a=o.data,h=a.length;for(e=0;e<h;e+=4)i=a[e],r=a[e+1],n=a[e+2],a[e]=(.393*i+.769*r+.189*n)/1.351,a[e+1]=(.349*i+.686*r+.168*n)/1.203,a[e+2]=(.272*i+.534*r+.131*n)/2.14;s.putImageData(o,0,0)}}),e.Image.filters.Sepia2.fromObject=function(t,i){return t=t||{},t.type="Sepia2",new e.Image.filters.BaseFilter.fromObject(t,i)}}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Tint=n(r.BaseFilter,{type:"Tint",initialize:function(t){t=t||{},this.color=t.color||"#000000",this.opacity="undefined"!=typeof t.opacity?t.opacity:new e.Color(this.color).getAlpha()},applyTo:function(t){var i,r,n,s,o,a,h,c,l,u=t.getContext("2d"),f=u.getImageData(0,0,t.width,t.height),d=f.data,g=d.length;for(l=new e.Color(this.color).getSource(),r=l[0]*this.opacity,n=l[1]*this.opacity,s=l[2]*this.opacity,c=1-this.opacity,i=0;i<g;i+=4)o=d[i],a=d[i+1],h=d[i+2],d[i]=r+o*c,d[i+1]=n+a*c,d[i+2]=s+h*c;u.putImageData(f,0,0)},toObject:function(){return i(this.callSuper("toObject"),{color:this.color,opacity:this.opacity})}}),e.Image.filters.Tint.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Multiply=n(r.BaseFilter,{type:"Multiply",initialize:function(t){t=t||{},this.color=t.color||"#000000"},applyTo:function(t){var i,r,n=t.getContext("2d"),s=n.getImageData(0,0,t.width,t.height),o=s.data,a=o.length;for(r=new e.Color(this.color).getSource(),i=0;i<a;i+=4)o[i]*=r[0]/255,o[i+1]*=r[1]/255,o[i+2]*=r[2]/255;n.putImageData(s,0,0)},toObject:function(){return i(this.callSuper("toObject"),{color:this.color})}}),e.Image.filters.Multiply.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric,i=e.Image.filters,r=e.util.createClass;i.Blend=r(i.BaseFilter,{type:"Blend",initialize:function(t){t=t||{},this.color=t.color||"#000",this.image=t.image||!1,this.mode=t.mode||"multiply",this.alpha=t.alpha||1},applyTo:function(t){var i,r,n,s,o,a,h,c,l,u,f=t.getContext("2d"),d=f.getImageData(0,0,t.width,t.height),g=d.data,p=!1;if(this.image){p=!0;var v=e.util.createCanvasElement();v.width=this.image.width,v.height=this.image.height;var b=new e.StaticCanvas(v);b.add(this.image);var m=b.getContext("2d");u=m.getImageData(0,0,b.width,b.height).data}else u=new e.Color(this.color).getSource(),i=u[0]*this.alpha,r=u[1]*this.alpha,n=u[2]*this.alpha;for(var y=0,_=g.length;y<_;y+=4)switch(s=g[y],o=g[y+1],a=g[y+2],p&&(i=u[y]*this.alpha,r=u[y+1]*this.alpha,n=u[y+2]*this.alpha),this.mode){case"multiply":g[y]=s*i/255,g[y+1]=o*r/255,g[y+2]=a*n/255;break;case"screen":g[y]=1-(1-s)*(1-i),g[y+1]=1-(1-o)*(1-r),g[y+2]=1-(1-a)*(1-n);break;case"add":g[y]=Math.min(255,s+i),g[y+1]=Math.min(255,o+r),g[y+2]=Math.min(255,a+n);break;case"diff":case"difference":g[y]=Math.abs(s-i),g[y+1]=Math.abs(o-r),g[y+2]=Math.abs(a-n);break;case"subtract":h=s-i,c=o-r,l=a-n,g[y]=h<0?0:h,g[y+1]=c<0?0:c,g[y+2]=l<0?0:l;break;case"darken":g[y]=Math.min(s,i),g[y+1]=Math.min(o,r),g[y+2]=Math.min(a,n);break;case"lighten":g[y]=Math.max(s,i),g[y+1]=Math.max(o,r),g[y+2]=Math.max(a,n)}f.putImageData(d,0,0)},toObject:function(){return{color:this.color,image:this.image,mode:this.mode,alpha:this.alpha}}}),e.Image.filters.Blend.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=Math.pow,r=Math.floor,n=Math.sqrt,s=Math.abs,o=Math.max,a=Math.round,h=Math.sin,c=Math.ceil,l=e.Image.filters,u=e.util.createClass;l.Resize=u(l.BaseFilter,{type:"Resize",resizeType:"hermite",scaleX:0,scaleY:0,lanczosLobes:3,applyTo:function(t,e,i){if(1!==e||1!==i){this.rcpScaleX=1/e,this.rcpScaleY=1/i;var r,n=t.width,s=t.height,o=a(n*e),h=a(s*i);"sliceHack"===this.resizeType&&(r=this.sliceByTwo(t,n,s,o,h)),"hermite"===this.resizeType&&(r=this.hermiteFastResize(t,n,s,o,h)),"bilinear"===this.resizeType&&(r=this.bilinearFiltering(t,n,s,o,h)),"lanczos"===this.resizeType&&(r=this.lanczosResize(t,n,s,o,h)),t.width=o,
t.height=h,t.getContext("2d").putImageData(r,0,0)}},sliceByTwo:function(t,i,n,s,a){var h,c=t.getContext("2d"),l=.5,u=.5,f=1,d=1,g=!1,p=!1,v=i,b=n,m=e.util.createCanvasElement(),y=m.getContext("2d");for(s=r(s),a=r(a),m.width=o(s,i),m.height=o(a,n),s>i&&(l=2,f=-1),a>n&&(u=2,d=-1),h=c.getImageData(0,0,i,n),t.width=o(s,i),t.height=o(a,n),c.putImageData(h,0,0);!g||!p;)i=v,n=b,s*f<r(v*l*f)?v=r(v*l):(v=s,g=!0),a*d<r(b*u*d)?b=r(b*u):(b=a,p=!0),h=c.getImageData(0,0,i,n),y.putImageData(h,0,0),c.clearRect(0,0,v,b),c.drawImage(m,0,0,i,n,0,0,v,b);return c.getImageData(0,0,s,a)},lanczosResize:function(t,e,o,a,l){function u(t){return function(e){if(e>t)return 0;if(e*=Math.PI,s(e)<1e-16)return 1;var i=e/t;return h(e)*h(i)/e/i}}function f(t){var h,c,u,d,g,k,P,M,A,D,I;for(T.x=(t+.5)*y,j.x=r(T.x),h=0;h<l;h++){for(T.y=(h+.5)*_,j.y=r(T.y),g=0,k=0,P=0,M=0,A=0,c=j.x-S;c<=j.x+S;c++)if(!(c<0||c>=e)){D=r(1e3*s(c-T.x)),O[D]||(O[D]={});for(var E=j.y-w;E<=j.y+w;E++)E<0||E>=o||(I=r(1e3*s(E-T.y)),O[D][I]||(O[D][I]=m(n(i(D*x,2)+i(I*C,2))/1e3)),u=O[D][I],u>0&&(d=4*(E*e+c),g+=u,k+=u*v[d],P+=u*v[d+1],M+=u*v[d+2],A+=u*v[d+3]))}d=4*(h*a+t),b[d]=k/g,b[d+1]=P/g,b[d+2]=M/g,b[d+3]=A/g}return++t<a?f(t):p}var d=t.getContext("2d"),g=d.getImageData(0,0,e,o),p=d.getImageData(0,0,a,l),v=g.data,b=p.data,m=u(this.lanczosLobes),y=this.rcpScaleX,_=this.rcpScaleY,x=2/this.rcpScaleX,C=2/this.rcpScaleY,S=c(y*this.lanczosLobes/2),w=c(_*this.lanczosLobes/2),O={},T={},j={};return f(0)},bilinearFiltering:function(t,e,i,n,s){var o,a,h,c,l,u,f,d,g,p,v,b,m,y=0,_=this.rcpScaleX,x=this.rcpScaleY,C=t.getContext("2d"),S=4*(e-1),w=C.getImageData(0,0,e,i),O=w.data,T=C.getImageData(0,0,n,s),j=T.data;for(f=0;f<s;f++)for(d=0;d<n;d++)for(l=r(_*d),u=r(x*f),g=_*d-l,p=x*f-u,m=4*(u*e+l),v=0;v<4;v++)o=O[m+v],a=O[m+4+v],h=O[m+S+v],c=O[m+S+4+v],b=o*(1-g)*(1-p)+a*g*(1-p)+h*p*(1-g)+c*g*p,j[y++]=b;return T},hermiteFastResize:function(t,e,i,o,a){for(var h=this.rcpScaleX,l=this.rcpScaleY,u=c(h/2),f=c(l/2),d=t.getContext("2d"),g=d.getImageData(0,0,e,i),p=g.data,v=d.getImageData(0,0,o,a),b=v.data,m=0;m<a;m++)for(var y=0;y<o;y++){for(var _=4*(y+m*o),x=0,C=0,S=0,w=0,O=0,T=0,j=0,k=(m+.5)*l,P=r(m*l);P<(m+1)*l;P++)for(var M=s(k-(P+.5))/f,A=(y+.5)*h,D=M*M,I=r(y*h);I<(y+1)*h;I++){var E=s(A-(I+.5))/u,L=n(D+E*E);L>1&&L<-1||(x=2*L*L*L-3*L*L+1,x>0&&(E=4*(I+P*e),j+=x*p[E+3],S+=x,p[E+3]<255&&(x=x*p[E+3]/250),w+=x*p[E],O+=x*p[E+1],T+=x*p[E+2],C+=x))}b[_]=w/C,b[_+1]=O/C,b[_+2]=T/C,b[_+3]=j/S}return v},toObject:function(){return{type:this.type,scaleX:this.scaleX,scaleY:this.scaleY,resizeType:this.resizeType,lanczosLobes:this.lanczosLobes}}}),e.Image.filters.Resize.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.ColorMatrix=n(r.BaseFilter,{type:"ColorMatrix",initialize:function(t){t||(t={}),this.matrix=t.matrix||[1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0]},applyTo:function(t){var e,i,r,n,s,o=t.getContext("2d"),a=o.getImageData(0,0,t.width,t.height),h=a.data,c=h.length,l=this.matrix;for(e=0;e<c;e+=4)i=h[e],r=h[e+1],n=h[e+2],s=h[e+3],h[e]=i*l[0]+r*l[1]+n*l[2]+s*l[3]+l[4],h[e+1]=i*l[5]+r*l[6]+n*l[7]+s*l[8]+l[9],h[e+2]=i*l[10]+r*l[11]+n*l[12]+s*l[13]+l[14],h[e+3]=i*l[15]+r*l[16]+n*l[17]+s*l[18]+l[19];o.putImageData(a,0,0)},toObject:function(){return i(this.callSuper("toObject"),{type:this.type,matrix:this.matrix})}}),e.Image.filters.ColorMatrix.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Contrast=n(r.BaseFilter,{type:"Contrast",initialize:function(t){t=t||{},this.contrast=t.contrast||0},applyTo:function(t){for(var e=t.getContext("2d"),i=e.getImageData(0,0,t.width,t.height),r=i.data,n=259*(this.contrast+255)/(255*(259-this.contrast)),s=0,o=r.length;s<o;s+=4)r[s]=n*(r[s]-128)+128,r[s+1]=n*(r[s+1]-128)+128,r[s+2]=n*(r[s+2]-128)+128;e.putImageData(i,0,0)},toObject:function(){return i(this.callSuper("toObject"),{contrast:this.contrast})}}),e.Image.filters.Contrast.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.object.extend,r=e.Image.filters,n=e.util.createClass;r.Saturate=n(r.BaseFilter,{type:"Saturate",initialize:function(t){t=t||{},this.saturate=t.saturate||0},applyTo:function(t){for(var e,i=t.getContext("2d"),r=i.getImageData(0,0,t.width,t.height),n=r.data,s=.01*-this.saturate,o=0,a=n.length;o<a;o+=4)e=Math.max(n[o],n[o+1],n[o+2]),n[o]+=e!==n[o]?(e-n[o])*s:0,n[o+1]+=e!==n[o+1]?(e-n[o+1])*s:0,n[o+2]+=e!==n[o+2]?(e-n[o+2])*s:0;i.putImageData(r,0,0)},toObject:function(){return i(this.callSuper("toObject"),{saturate:this.saturate})}}),e.Image.filters.Saturate.fromObject=e.Image.filters.BaseFilter.fromObject}("undefined"!=typeof exports?exports:this),function(t){"use strict";var e=t.fabric||(t.fabric={}),i=e.util.toFixed,r=e.Object.NUM_FRACTION_DIGITS,n=2;if(e.Text)return void e.warn("fabric.Text is already defined");var s=e.Object.prototype.stateProperties.concat();s.push("fontFamily","fontWeight","fontSize","text","textDecoration","textAlign","fontStyle","lineHeight","textBackgroundColor","charSpacing");var o=e.Object.prototype.cacheProperties.concat();o.push("fontFamily","fontWeight","fontSize","text","textDecoration","textAlign","fontStyle","lineHeight","textBackgroundColor","charSpacing","styles"),e.Text=e.util.createClass(e.Object,{_dimensionAffectingProps:["fontSize","fontWeight","fontFamily","fontStyle","lineHeight","text","charSpacing","textAlign"],_reNewline:/\r?\n/,_reSpacesAndTabs:/[ \t\r]+/g,type:"text",fontSize:40,fontWeight:"normal",fontFamily:"Times New Roman",textDecoration:"",textAlign:"left",fontStyle:"",lineHeight:1.16,textBackgroundColor:"",stateProperties:s,cacheProperties:o,stroke:null,shadow:null,_fontSizeFraction:.25,_fontSizeMult:1.13,charSpacing:0,initialize:function(t,e){e=e||{},this.text=t,this.__skipDimension=!0,this.callSuper("initialize",e),this.__skipDimension=!1,this._initDimensions(),this.setupState({propertySet:"_dimensionAffectingProps"})},_initDimensions:function(t){this.__skipDimension||(t||(t=e.util.createCanvasElement().getContext("2d"),this._setTextStyles(t)),this._textLines=this._splitTextIntoLines(),this._clearCache(),this.width=this._getTextWidth(t)||this.cursorWidth||n,this.height=this._getTextHeight(t))},toString:function(){return"#<fabric.Text ("+this.complexity()+'): { "text": "'+this.text+'", "fontFamily": "'+this.fontFamily+'" }>'},_getCacheCanvasDimensions:function(){var t=this.callSuper("_getCacheCanvasDimensions"),e=2*Math.ceil(this.fontSize);return t.width+=e,t.height+=e,t},_render:function(t){this._setTextStyles(t),this.group&&"path-group"===this.group.type&&t.translate(this.left,this.top),this._renderTextLinesBackground(t),this._renderText(t),this._renderTextDecoration(t)},_renderText:function(t){this._renderTextFill(t),this._renderTextStroke(t)},_setTextStyles:function(t){t.textBaseline="alphabetic",t.font=this._getFontDeclaration()},_getTextHeight:function(){return this._getHeightOfSingleLine()+(this._textLines.length-1)*this._getHeightOfLine()},_getTextWidth:function(t){for(var e=this._getLineWidth(t,0),i=1,r=this._textLines.length;i<r;i++){var n=this._getLineWidth(t,i);n>e&&(e=n)}return e},_renderChars:function(t,e,i,r,n){var s,o,a=t.slice(0,-4);if(this[a].toLive){var h=-this.width/2+this[a].offsetX||0,c=-this.height/2+this[a].offsetY||0;e.save(),e.translate(h,c),r-=h,n-=c}if(0!==this.charSpacing){var l=this._getWidthOfCharSpacing();i=i.split("");for(var u=0,f=i.length;u<f;u++)s=i[u],o=e.measureText(s).width+l,e[t](s,r,n),r+=o>0?o:0}else e[t](i,r,n);this[a].toLive&&e.restore()},_renderTextLine:function(t,e,i,r,n,s){n-=this.fontSize*this._fontSizeFraction;var o=this._getLineWidth(e,s);if("justify"!==this.textAlign||this.width<o)return void this._renderChars(t,e,i,r,n,s);for(var a,h=i.split(/\s+/),c=0,l=this._getWidthOfWords(e,h.join(" "),s,0),u=this.width-l,f=h.length-1,d=f>0?u/f:0,g=0,p=0,v=h.length;p<v;p++){for(;" "===i[c]&&c<i.length;)c++;a=h[p],this._renderChars(t,e,a,r+g,n,s,c),g+=this._getWidthOfWords(e,a,s,c)+d,c+=a.length}},_getWidthOfWords:function(t,e){var i,r,n=t.measureText(e).width;return 0!==this.charSpacing&&(i=e.split("").length,r=i*this._getWidthOfCharSpacing(),n+=r),n>0?n:0},_getLeftOffset:function(){return-this.width/2},_getTopOffset:function(){return-this.height/2},isEmptyStyles:function(){return!0},_renderTextCommon:function(t,e){for(var i=0,r=this._getLeftOffset(),n=this._getTopOffset(),s=0,o=this._textLines.length;s<o;s++){var a=this._getHeightOfLine(t,s),h=a/this.lineHeight,c=this._getLineWidth(t,s),l=this._getLineLeftOffset(c);this._renderTextLine(e,t,this._textLines[s],r+l,n+i+h,s),i+=a}},_renderTextFill:function(t){!this.fill&&this.isEmptyStyles()||this._renderTextCommon(t,"fillText")},_renderTextStroke:function(t){(this.stroke&&0!==this.strokeWidth||!this.isEmptyStyles())&&(this.shadow&&!this.shadow.affectStroke&&this._removeShadow(t),t.save(),this._setLineDash(t,this.strokeDashArray),t.beginPath(),this._renderTextCommon(t,"strokeText"),t.closePath(),t.restore())},_getHeightOfLine:function(){return this._getHeightOfSingleLine()*this.lineHeight},_getHeightOfSingleLine:function(){return this.fontSize*this._fontSizeMult},_renderTextLinesBackground:function(t){if(this.textBackgroundColor){var e,i,r,n=0,s=t.fillStyle;t.fillStyle=this.textBackgroundColor;for(var o=0,a=this._textLines.length;o<a;o++)e=this._getHeightOfLine(t,o),i=this._getLineWidth(t,o),i>0&&(r=this._getLineLeftOffset(i),t.fillRect(this._getLeftOffset()+r,this._getTopOffset()+n,i,e/this.lineHeight)),n+=e;t.fillStyle=s,this._removeShadow(t)}},_getLineLeftOffset:function(t){return"center"===this.textAlign?(this.width-t)/2:"right"===this.textAlign?this.width-t:0},_clearCache:function(){this.__lineWidths=[],this.__lineHeights=[]},_shouldClearDimensionCache:function(){var t=this._forceClearCache;return t||(t=this.hasStateChanged("_dimensionAffectingProps")),t&&(this.saveState({propertySet:"_dimensionAffectingProps"}),this.dirty=!0),t},_getLineWidth:function(t,e){if(this.__lineWidths[e])return this.__lineWidths[e]===-1?this.width:this.__lineWidths[e];var i,r,n=this._textLines[e];return i=""===n?0:this._measureLine(t,e),this.__lineWidths[e]=i,i&&"justify"===this.textAlign&&(r=n.split(/\s+/),r.length>1&&(this.__lineWidths[e]=-1)),i},_getWidthOfCharSpacing:function(){return 0!==this.charSpacing?this.fontSize*this.charSpacing/1e3:0},_measureLine:function(t,e){var i,r,n=this._textLines[e],s=t.measureText(n).width,o=0;return 0!==this.charSpacing&&(i=n.split("").length,o=(i-1)*this._getWidthOfCharSpacing()),r=s+o,r>0?r:0},_renderTextDecoration:function(t){function e(e){var n,s,o,a,h,c,l,u=0;for(n=0,s=r._textLines.length;n<s;n++){for(h=r._getLineWidth(t,n),c=r._getLineLeftOffset(h),l=r._getHeightOfLine(t,n),o=0,a=e.length;o<a;o++)t.fillRect(r._getLeftOffset()+c,u+(r._fontSizeMult-1+e[o])*r.fontSize-i,h,r.fontSize/15);u+=l}}if(this.textDecoration){var i=this.height/2,r=this,n=[];this.textDecoration.indexOf("underline")>-1&&n.push(.85),this.textDecoration.indexOf("line-through")>-1&&n.push(.43),this.textDecoration.indexOf("overline")>-1&&n.push(-.12),n.length>0&&e(n)}},_getFontDeclaration:function(){return[e.isLikelyNode?this.fontWeight:this.fontStyle,e.isLikelyNode?this.fontStyle:this.fontWeight,this.fontSize+"px",e.isLikelyNode?'"'+this.fontFamily+'"':this.fontFamily].join(" ")},render:function(t,e){this.visible&&(this._shouldClearDimensionCache()&&(this._setTextStyles(t),this._initDimensions(t)),this.callSuper("render",t,e))},_splitTextIntoLines:function(){return this.text.split(this._reNewline)},toObject:function(t){var e=["text","fontSize","fontWeight","fontFamily","fontStyle","lineHeight","textDecoration","textAlign","textBackgroundColor","charSpacing"].concat(t);return this.callSuper("toObject",e)},toSVG:function(t){this.ctx||(this.ctx=e.util.createCanvasElement().getContext("2d"));var i=this._createBaseSVGMarkup(),r=this._getSVGLeftTopOffsets(this.ctx),n=this._getSVGTextAndBg(r.textTop,r.textLeft);return this._wrapSVGTextAndBg(i,n),t?t(i.join("")):i.join("")},_getSVGLeftTopOffsets:function(t){var e=this._getHeightOfLine(t,0),i=-this.width/2,r=0;return{textLeft:i+(this.group&&"path-group"===this.group.type?this.left:0),textTop:r+(this.group&&"path-group"===this.group.type?-this.top:0),lineTop:e}},_wrapSVGTextAndBg:function(t,e){var i=!0,r=this.getSvgFilter(),n=""===r?"":' style="'+r+'"';t.push("\t<g ",this.getSvgId(),'transform="',this.getSvgTransform(),this.getSvgTransformMatrix(),'"',n,">\n",e.textBgRects.join(""),"\t\t<text ",this.fontFamily?'font-family="'+this.fontFamily.replace(/"/g,"'")+'" ':"",this.fontSize?'font-size="'+this.fontSize+'" ':"",this.fontStyle?'font-style="'+this.fontStyle+'" ':"",this.fontWeight?'font-weight="'+this.fontWeight+'" ':"",this.textDecoration?'text-decoration="'+this.textDecoration+'" ':"",'style="',this.getSvgStyles(i),'" >\n',e.textSpans.join(""),"\t\t</text>\n","\t</g>\n")},_getSVGTextAndBg:function(t,e){var i=[],r=[],n=0;this._setSVGBg(r);for(var s=0,o=this._textLines.length;s<o;s++)this.textBackgroundColor&&this._setSVGTextLineBg(r,s,e,t,n),this._setSVGTextLineText(s,i,n,e,t,r),n+=this._getHeightOfLine(this.ctx,s);return{textSpans:i,textBgRects:r}},_setSVGTextLineText:function(t,n,s,o,a){var h=this.fontSize*(this._fontSizeMult-this._fontSizeFraction)-a+s-this.height/2;return"justify"===this.textAlign?void this._setSVGTextLineJustifed(t,n,h,o):void n.push('\t\t\t<tspan x="',i(o+this._getLineLeftOffset(this._getLineWidth(this.ctx,t)),r),'" ','y="',i(h,r),'" ',this._getFillAttributes(this.fill),">",e.util.string.escapeXml(this._textLines[t]),"</tspan>\n")},_setSVGTextLineJustifed:function(t,n,s,o){var a=e.util.createCanvasElement().getContext("2d");this._setTextStyles(a);var h,c,l=this._textLines[t],u=l.split(/\s+/),f=this._getWidthOfWords(a,u.join("")),d=this.width-f,g=u.length-1,p=g>0?d/g:0,v=this._getFillAttributes(this.fill);for(o+=this._getLineLeftOffset(this._getLineWidth(a,t)),t=0,c=u.length;t<c;t++)h=u[t],n.push('\t\t\t<tspan x="',i(o,r),'" ','y="',i(s,r),'" ',v,">",e.util.string.escapeXml(h),"</tspan>\n"),o+=this._getWidthOfWords(a,h)+p},_setSVGTextLineBg:function(t,e,n,s,o){t.push("\t\t<rect ",this._getFillAttributes(this.textBackgroundColor),' x="',i(n+this._getLineLeftOffset(this._getLineWidth(this.ctx,e)),r),'" y="',i(o-this.height/2,r),'" width="',i(this._getLineWidth(this.ctx,e),r),'" height="',i(this._getHeightOfLine(this.ctx,e)/this.lineHeight,r),'"></rect>\n')},_setSVGBg:function(t){this.backgroundColor&&t.push("\t\t<rect ",this._getFillAttributes(this.backgroundColor),' x="',i(-this.width/2,r),'" y="',i(-this.height/2,r),'" width="',i(this.width,r),'" height="',i(this.height,r),'"></rect>\n')},_getFillAttributes:function(t){var i=t&&"string"==typeof t?new e.Color(t):"";return i&&i.getSource()&&1!==i.getAlpha()?'opacity="'+i.getAlpha()+'" fill="'+i.setAlpha(1).toRgb()+'"':'fill="'+t+'"'},_set:function(t,e){this.callSuper("_set",t,e),this._dimensionAffectingProps.indexOf(t)>-1&&(this._initDimensions(),this.setCoords())},complexity:function(){return 1}}),e.Text.ATTRIBUTE_NAMES=e.SHARED_ATTRIBUTES.concat("x y dx dy font-family font-style font-weight font-size text-decoration text-anchor".split(" ")),e.Text.DEFAULT_SVG_FONT_SIZE=16,e.Text.fromElement=function(t,i){if(!t)return null;var r=e.parseAttributes(t,e.Text.ATTRIBUTE_NAMES);i=e.util.object.extend(i?e.util.object.clone(i):{},r),i.top=i.top||0,i.left=i.left||0,"dx"in r&&(i.left+=r.dx),"dy"in r&&(i.top+=r.dy),"fontSize"in i||(i.fontSize=e.Text.DEFAULT_SVG_FONT_SIZE),i.originX||(i.originX="left");var n="";"textContent"in t?n=t.textContent:"firstChild"in t&&null!==t.firstChild&&"data"in t.firstChild&&null!==t.firstChild.data&&(n=t.firstChild.data),n=n.replace(/^\s+|\s+$|\n+/g,"").replace(/\s+/g," ");var s=new e.Text(n,i),o=s.getHeight()/s.height,a=(s.height+s.strokeWidth)*s.lineHeight-s.height,h=a*o,c=s.getHeight()+h,l=0;return"left"===s.originX&&(l=s.getWidth()/2),"right"===s.originX&&(l=-s.getWidth()/2),s.set({left:s.getLeft()+l,top:s.getTop()-c/2+s.fontSize*(.18+s._fontSizeFraction)/s.lineHeight}),s},e.Text.fromObject=function(t,i,r){return e.Object._fromObject("Text",t,i,r,"text")},e.util.createAccessors(e.Text)}("undefined"!=typeof exports?exports:this),function(){var t=fabric.util.object.clone;fabric.IText=fabric.util.createClass(fabric.Text,fabric.Observable,{type:"i-text",selectionStart:0,selectionEnd:0,selectionColor:"rgba(17,119,255,0.3)",isEditing:!1,editable:!0,editingBorderColor:"rgba(102,153,255,0.25)",cursorWidth:2,cursorColor:"#333",cursorDelay:1e3,cursorDuration:600,styles:null,caching:!0,_reSpace:/\s|\n/,_currentCursorOpacity:0,_selectionDirection:null,_abortCursorAnimation:!1,__widthOfSpace:[],initialize:function(t,e){this.styles=e?e.styles||{}:{},this.callSuper("initialize",t,e),this.initBehavior()},_clearCache:function(){this.callSuper("_clearCache"),this.__widthOfSpace=[]},isEmptyStyles:function(){if(!this.styles)return!0;var t=this.styles;for(var e in t)for(var i in t[e])for(var r in t[e][i])return!1;return!0},setSelectionStart:function(t){t=Math.max(t,0),this._updateAndFire("selectionStart",t)},setSelectionEnd:function(t){t=Math.min(t,this.text.length),this._updateAndFire("selectionEnd",t)},_updateAndFire:function(t,e){this[t]!==e&&(this._fireSelectionChanged(),this[t]=e),this._updateTextarea()},_fireSelectionChanged:function(){this.fire("selection:changed"),this.canvas&&this.canvas.fire("text:selection:changed",{target:this})},getSelectionStyles:function(t,e){if(2===arguments.length){for(var i=[],r=t;r<e;r++)i.push(this.getSelectionStyles(r));return i}var n=this.get2DCursorLocation(t),s=this._getStyleDeclaration(n.lineIndex,n.charIndex);return s||{}},setSelectionStyles:function(t){if(this.selectionStart===this.selectionEnd)this._extendStyles(this.selectionStart,t);else for(var e=this.selectionStart;e<this.selectionEnd;e++)this._extendStyles(e,t);return this._forceClearCache=!0,this},_extendStyles:function(t,e){var i=this.get2DCursorLocation(t);this._getLineStyle(i.lineIndex)||this._setLineStyle(i.lineIndex,{}),this._getStyleDeclaration(i.lineIndex,i.charIndex)||this._setStyleDeclaration(i.lineIndex,i.charIndex,{}),fabric.util.object.extend(this._getStyleDeclaration(i.lineIndex,i.charIndex),e)},_initDimensions:function(t){t||this.clearContextTop(),this.callSuper("_initDimensions",t)},render:function(t,e){this.clearContextTop(),this.callSuper("render",t,e),this.cursorOffsetCache={},this.renderCursorOrSelection()},_render:function(t){this.callSuper("_render",t),this.ctx=t},clearContextTop:function(){if(this.active&&this.isEditing&&this.canvas&&this.canvas.contextTop){var t=this.canvas.contextTop;t.save(),t.transform.apply(t,this.canvas.viewportTransform),this.transform(t),this.transformMatrix&&t.transform.apply(t,this.transformMatrix),this._clearTextArea(t),t.restore()}},renderCursorOrSelection:function(){if(this.active&&this.isEditing){var t,e,i=this.text.split("");this.canvas&&this.canvas.contextTop?(e=this.canvas.contextTop,e.save(),e.transform.apply(e,this.canvas.viewportTransform),this.transform(e),this.transformMatrix&&e.transform.apply(e,this.transformMatrix),this._clearTextArea(e)):(e=this.ctx,e.save()),this.selectionStart===this.selectionEnd?(t=this._getCursorBoundaries(i,"cursor"),this.renderCursor(t,e)):(t=this._getCursorBoundaries(i,"selection"),this.renderSelection(i,t,e)),e.restore()}},_clearTextArea:function(t){var e=this.width+4,i=this.height+4;t.clearRect(-e/2,-i/2,e,i)},get2DCursorLocation:function(t){"undefined"==typeof t&&(t=this.selectionStart);for(var e=this._textLines.length,i=0;i<e;i++){if(t<=this._textLines[i].length)return{lineIndex:i,charIndex:t};t-=this._textLines[i].length+1}return{lineIndex:i-1,charIndex:this._textLines[i-1].length<t?this._textLines[i-1].length:t}},getCurrentCharStyle:function(t,e){var i=this._getStyleDeclaration(t,0===e?0:e-1);return{fontSize:i&&i.fontSize||this.fontSize,fill:i&&i.fill||this.fill,textBackgroundColor:i&&i.textBackgroundColor||this.textBackgroundColor,textDecoration:i&&i.textDecoration||this.textDecoration,fontFamily:i&&i.fontFamily||this.fontFamily,fontWeight:i&&i.fontWeight||this.fontWeight,fontStyle:i&&i.fontStyle||this.fontStyle,stroke:i&&i.stroke||this.stroke,strokeWidth:i&&i.strokeWidth||this.strokeWidth}},getCurrentCharFontSize:function(t,e){var i=this._getStyleDeclaration(t,0===e?0:e-1);return i&&i.fontSize?i.fontSize:this.fontSize},getCurrentCharColor:function(t,e){var i=this._getStyleDeclaration(t,0===e?0:e-1);return i&&i.fill?i.fill:this.cursorColor},_getCursorBoundaries:function(t,e){var i=Math.round(this._getLeftOffset()),r=this._getTopOffset(),n=this._getCursorBoundariesOffsets(t,e);return{left:i,top:r,leftOffset:n.left+n.lineLeft,topOffset:n.top}},_getCursorBoundariesOffsets:function(t,e){if(this.cursorOffsetCache&&"top"in this.cursorOffsetCache)return this.cursorOffsetCache;for(var i,r=0,n=0,s=0,o=0,a=0,h=0;h<this.selectionStart;h++)"\n"===t[h]?(a=0,o+=this._getHeightOfLine(this.ctx,n),n++,s=0):(a+=this._getWidthOfChar(this.ctx,t[h],n,s),s++),r=this._getLineLeftOffset(this._getLineWidth(this.ctx,n));return"cursor"===e&&(o+=(1-this._fontSizeFraction)*this._getHeightOfLine(this.ctx,n)/this.lineHeight-this.getCurrentCharFontSize(n,s)*(1-this._fontSizeFraction)),0!==this.charSpacing&&s===this._textLines[n].length&&(a-=this._getWidthOfCharSpacing()),i={top:o,left:a>0?a:0,lineLeft:r},this.cursorOffsetCache=i,this.cursorOffsetCache},renderCursor:function(t,e){var i=this.get2DCursorLocation(),r=i.lineIndex,n=i.charIndex,s=this.getCurrentCharFontSize(r,n),o=0===r&&0===n?this._getLineLeftOffset(this._getLineWidth(e,r)):t.leftOffset,a=this.scaleX*this.canvas.getZoom(),h=this.cursorWidth/a;e.fillStyle=this.getCurrentCharColor(r,n),e.globalAlpha=this.__isMousedown?1:this._currentCursorOpacity,e.fillRect(t.left+o-h/2,t.top+t.topOffset,h,s)},renderSelection:function(t,e,i){i.fillStyle=this.selectionColor;for(var r=this.get2DCursorLocation(this.selectionStart),n=this.get2DCursorLocation(this.selectionEnd),s=r.lineIndex,o=n.lineIndex,a=s;a<=o;a++){var h=this._getLineLeftOffset(this._getLineWidth(i,a))||0,c=this._getHeightOfLine(this.ctx,a),l=0,u=0,f=this._textLines[a];if(a===s){for(var d=0,g=f.length;d<g;d++)d>=r.charIndex&&(a!==o||d<n.charIndex)&&(u+=this._getWidthOfChar(i,f[d],a,d)),d<r.charIndex&&(h+=this._getWidthOfChar(i,f[d],a,d));d===f.length&&(u-=this._getWidthOfCharSpacing())}else if(a>s&&a<o)u+=this._getLineWidth(i,a)||5;else if(a===o){for(var p=0,v=n.charIndex;p<v;p++)u+=this._getWidthOfChar(i,f[p],a,p);n.charIndex===f.length&&(u-=this._getWidthOfCharSpacing())}l=c,(this.lineHeight<1||a===o&&this.lineHeight>1)&&(c/=this.lineHeight),i.fillRect(e.left+h,e.top+e.topOffset,u>0?u:0,c),e.topOffset+=l}},_renderChars:function(t,e,i,r,n,s,o){if(this.isEmptyStyles())return this._renderCharsFast(t,e,i,r,n);o=o||0;var a,h,c=this._getHeightOfLine(e,s),l="";e.save(),n-=c/this.lineHeight*this._fontSizeFraction;for(var u=o,f=i.length+o;u<=f;u++)a=a||this.getCurrentCharStyle(s,u),h=this.getCurrentCharStyle(s,u+1),(this._hasStyleChanged(a,h)||u===f)&&(this._renderChar(t,e,s,u-1,l,r,n,c),l="",a=h),l+=i[u-o];e.restore()},_renderCharsFast:function(t,e,i,r,n){"fillText"===t&&this.fill&&this.callSuper("_renderChars",t,e,i,r,n),"strokeText"===t&&(this.stroke&&this.strokeWidth>0||this.skipFillStrokeCheck)&&this.callSuper("_renderChars",t,e,i,r,n)},_renderChar:function(t,e,i,r,n,s,o,a){var h,c,l,u,f,d,g,p,v,b=this._getStyleDeclaration(i,r);if(b?(c=this._getHeightOfChar(e,n,i,r),u=b.stroke,l=b.fill,d=b.textDecoration):c=this.fontSize,u=(u||this.stroke)&&"strokeText"===t,l=(l||this.fill)&&"fillText"===t,b&&e.save(),h=this._applyCharStylesGetWidth(e,n,i,r,b||null),d=d||this.textDecoration,b&&b.textBackgroundColor&&this._removeShadow(e),0!==this.charSpacing){p=this._getWidthOfCharSpacing(),g=n.split(""),h=0;for(var m,y=0,_=g.length;y<_;y++)m=g[y],l&&e.fillText(m,s+h,o),u&&e.strokeText(m,s+h,o),v=e.measureText(m).width+p,h+=v>0?v:0}else l&&e.fillText(n,s,o),u&&e.strokeText(n,s,o);(d||""!==d)&&(f=this._fontSizeFraction*a/this.lineHeight,this._renderCharDecoration(e,d,s,o,f,h,c)),b&&e.restore(),e.translate(h,0)},_hasStyleChanged:function(t,e){return t.fill!==e.fill||t.fontSize!==e.fontSize||t.textBackgroundColor!==e.textBackgroundColor||t.textDecoration!==e.textDecoration||t.fontFamily!==e.fontFamily||t.fontWeight!==e.fontWeight||t.fontStyle!==e.fontStyle||t.stroke!==e.stroke||t.strokeWidth!==e.strokeWidth},_renderCharDecoration:function(t,e,i,r,n,s,o){if(e){var a,h,c=o/15,l={underline:r+o/10,"line-through":r-o*(this._fontSizeFraction+this._fontSizeMult-1)+c,overline:r-(this._fontSizeMult-this._fontSizeFraction)*o},u=["underline","line-through","overline"];for(a=0;a<u.length;a++)h=u[a],e.indexOf(h)>-1&&t.fillRect(i,l[h],s,c)}},_renderTextLine:function(t,e,i,r,n,s){this.isEmptyStyles()||(n+=this.fontSize*(this._fontSizeFraction+.03)),this.callSuper("_renderTextLine",t,e,i,r,n,s)},_renderTextDecoration:function(t){if(this.isEmptyStyles())return this.callSuper("_renderTextDecoration",t)},_renderTextLinesBackground:function(t){this.callSuper("_renderTextLinesBackground",t);var e,i,r,n,s,o,a=0,h=this._getLeftOffset(),c=this._getTopOffset();t.save();for(var l=0,u=this._textLines.length;l<u;l++)if(e=this._getHeightOfLine(t,l),n=this._textLines[l],""!==n&&this.styles&&this._getLineStyle(l)){i=this._getLineWidth(t,l),r=this._getLineLeftOffset(i);for(var f=0,d=n.length;f<d;f++)o=this._getStyleDeclaration(l,f),o&&o.textBackgroundColor&&(s=n[f],t.fillStyle=o.textBackgroundColor,t.fillRect(h+r+this._getWidthOfCharsAt(t,l,f),c+a,this._getWidthOfChar(t,s,l,f),e/this.lineHeight));a+=e}else a+=e;t.restore()},_getCacheProp:function(t,e){return t+e.fontSize+e.fontWeight+e.fontStyle},_getFontCache:function(t){return fabric.charWidthsCache[t]||(fabric.charWidthsCache[t]={}),fabric.charWidthsCache[t]},_applyCharStylesGetWidth:function(e,i,r,n,s){var o,a,h,c=s||this._getStyleDeclaration(r,n),l=t(c);if(this._applyFontStyles(l),h=this._getFontCache(l.fontFamily),a=this._getCacheProp(i,l),!c&&h[a]&&this.caching)return h[a];"string"==typeof l.shadow&&(l.shadow=new fabric.Shadow(l.shadow));var u=l.fill||this.fill;return e.fillStyle=u.toLive?u.toLive(e,this):u,l.stroke&&(e.strokeStyle=l.stroke&&l.stroke.toLive?l.stroke.toLive(e,this):l.stroke),e.lineWidth=l.strokeWidth||this.strokeWidth,e.font=this._getFontDeclaration.call(l),l.shadow&&(l.scaleX=this.scaleX,l.scaleY=this.scaleY,l.canvas=this.canvas,l.getObjectScaling=this.getObjectScaling,this._setShadow.call(l,e)),this.caching&&h[a]?h[a]:(o=e.measureText(i).width,this.caching&&(h[a]=o),o)},_applyFontStyles:function(t){t.fontFamily||(t.fontFamily=this.fontFamily),t.fontSize||(t.fontSize=this.fontSize),t.fontWeight||(t.fontWeight=this.fontWeight),t.fontStyle||(t.fontStyle=this.fontStyle)},_getStyleDeclaration:function(e,i,r){return r?this.styles[e]&&this.styles[e][i]?t(this.styles[e][i]):{}:this.styles[e]&&this.styles[e][i]?this.styles[e][i]:null},_setStyleDeclaration:function(t,e,i){this.styles[t][e]=i},_deleteStyleDeclaration:function(t,e){delete this.styles[t][e]},_getLineStyle:function(t){return this.styles[t]},_setLineStyle:function(t,e){this.styles[t]=e},_deleteLineStyle:function(t){delete this.styles[t]},_getWidthOfChar:function(t,e,i,r){if(!this._isMeasuring&&"justify"===this.textAlign&&this._reSpacesAndTabs.test(e))return this._getWidthOfSpace(t,i);t.save();var n=this._applyCharStylesGetWidth(t,e,i,r);return 0!==this.charSpacing&&(n+=this._getWidthOfCharSpacing()),t.restore(),n>0?n:0},_getHeightOfChar:function(t,e,i){var r=this._getStyleDeclaration(e,i);return r&&r.fontSize?r.fontSize:this.fontSize},_getWidthOfCharsAt:function(t,e,i){var r,n,s=0;for(r=0;r<i;r++)n=this._textLines[e][r],s+=this._getWidthOfChar(t,n,e,r);return s},_measureLine:function(t,e){this._isMeasuring=!0;var i=this._getWidthOfCharsAt(t,e,this._textLines[e].length);return 0!==this.charSpacing&&(i-=this._getWidthOfCharSpacing()),this._isMeasuring=!1,i>0?i:0},_getWidthOfSpace:function(t,e){if(this.__widthOfSpace[e])return this.__widthOfSpace[e];var i=this._textLines[e],r=this._getWidthOfWords(t,i,e,0),n=this.width-r,s=i.length-i.replace(this._reSpacesAndTabs,"").length,o=Math.max(n/s,t.measureText(" ").width);return this.__widthOfSpace[e]=o,o},_getWidthOfWords:function(t,e,i,r){for(var n=0,s=0;s<e.length;s++){var o=e[s];o.match(/\s/)||(n+=this._getWidthOfChar(t,o,i,s+r))}return n},_getHeightOfLine:function(t,e){if(this.__lineHeights[e])return this.__lineHeights[e];for(var i=this._textLines[e],r=this._getHeightOfChar(t,e,0),n=1,s=i.length;n<s;n++){var o=this._getHeightOfChar(t,e,n);o>r&&(r=o)}return this.__lineHeights[e]=r*this.lineHeight*this._fontSizeMult,this.__lineHeights[e]},_getTextHeight:function(t){for(var e,i=0,r=0,n=this._textLines.length;r<n;r++)e=this._getHeightOfLine(t,r),i+=r===n-1?e/this.lineHeight:e;return i},toObject:function(e){return fabric.util.object.extend(this.callSuper("toObject",e),{styles:t(this.styles,!0)})}}),fabric.IText.fromObject=function(t,e,i){return fabric.Object._fromObject("IText",t,e,i,"text")}}(),function(){var t=fabric.util.object.clone;fabric.util.object.extend(fabric.IText.prototype,{initBehavior:function(){this.initAddedHandler(),this.initRemovedHandler(),this.initCursorSelectionHandlers(),this.initDoubleClickSimulation(),this.mouseMoveHandler=this.mouseMoveHandler.bind(this)},initSelectedHandler:function(){this.on("selected",function(){var t=this;setTimeout(function(){t.selected=!0},100)})},initAddedHandler:function(){var t=this;this.on("added",function(){var e=t.canvas;e&&(e._hasITextHandlers||(e._hasITextHandlers=!0,t._initCanvasHandlers(e)),e._iTextInstances=e._iTextInstances||[],e._iTextInstances.push(t))})},initRemovedHandler:function(){var t=this;this.on("removed",function(){var e=t.canvas;e&&(e._iTextInstances=e._iTextInstances||[],fabric.util.removeFromArray(e._iTextInstances,t),0===e._iTextInstances.length&&(e._hasITextHandlers=!1,t._removeCanvasHandlers(e)))})},_initCanvasHandlers:function(t){t._canvasITextSelectionClearedHanlder=function(){fabric.IText.prototype.exitEditingOnOthers(t)}.bind(this),t._mouseUpITextHandler=function(){t._iTextInstances&&t._iTextInstances.forEach(function(t){t.__isMousedown=!1})}.bind(this),t.on("selection:cleared",t._canvasITextSelectionClearedHanlder),t.on("object:selected",t._canvasITextSelectionClearedHanlder),t.on("mouse:up",t._mouseUpITextHandler)},_removeCanvasHandlers:function(t){t.off("selection:cleared",t._canvasITextSelectionClearedHanlder),t.off("object:selected",t._canvasITextSelectionClearedHanlder),t.off("mouse:up",t._mouseUpITextHandler)},_tick:function(){this._currentTickState=this._animateCursor(this,1,this.cursorDuration,"_onTickComplete")},_animateCursor:function(t,e,i,r){var n;return n={isAborted:!1,abort:function(){this.isAborted=!0}},t.animate("_currentCursorOpacity",e,{duration:i,onComplete:function(){n.isAborted||t[r]()},onChange:function(){t.canvas&&t.selectionStart===t.selectionEnd&&t.renderCursorOrSelection()},abort:function(){return n.isAborted}}),n},_onTickComplete:function(){var t=this;this._cursorTimeout1&&clearTimeout(this._cursorTimeout1),this._cursorTimeout1=setTimeout(function(){t._currentTickCompleteState=t._animateCursor(t,0,this.cursorDuration/2,"_tick")},100)},initDelayedCursor:function(t){var e=this,i=t?0:this.cursorDelay;this.abortCursorAnimation(),this._currentCursorOpacity=1,this._cursorTimeout2=setTimeout(function(){e._tick()},i)},abortCursorAnimation:function(){var t=this._currentTickState||this._currentTickCompleteState;this._currentTickState&&this._currentTickState.abort(),this._currentTickCompleteState&&this._currentTickCompleteState.abort(),clearTimeout(this._cursorTimeout1),clearTimeout(this._cursorTimeout2),this._currentCursorOpacity=0,t&&this.canvas&&this.canvas.clearContext(this.canvas.contextTop||this.ctx)},selectAll:function(){this.selectionStart=0,
this.selectionEnd=this.text.length,this._fireSelectionChanged(),this._updateTextarea()},getSelectedText:function(){return this.text.slice(this.selectionStart,this.selectionEnd)},findWordBoundaryLeft:function(t){var e=0,i=t-1;if(this._reSpace.test(this.text.charAt(i)))for(;this._reSpace.test(this.text.charAt(i));)e++,i--;for(;/\S/.test(this.text.charAt(i))&&i>-1;)e++,i--;return t-e},findWordBoundaryRight:function(t){var e=0,i=t;if(this._reSpace.test(this.text.charAt(i)))for(;this._reSpace.test(this.text.charAt(i));)e++,i++;for(;/\S/.test(this.text.charAt(i))&&i<this.text.length;)e++,i++;return t+e},findLineBoundaryLeft:function(t){for(var e=0,i=t-1;!/\n/.test(this.text.charAt(i))&&i>-1;)e++,i--;return t-e},findLineBoundaryRight:function(t){for(var e=0,i=t;!/\n/.test(this.text.charAt(i))&&i<this.text.length;)e++,i++;return t+e},getNumNewLinesInSelectedText:function(){for(var t=this.getSelectedText(),e=0,i=0,r=t.length;i<r;i++)"\n"===t[i]&&e++;return e},searchWordBoundary:function(t,e){for(var i=this._reSpace.test(this.text.charAt(t))?t-1:t,r=this.text.charAt(i),n=/[ \n\.,;!\?\-]/;!n.test(r)&&i>0&&i<this.text.length;)i+=e,r=this.text.charAt(i);return n.test(r)&&"\n"!==r&&(i+=1===e?0:1),i},selectWord:function(t){t=t||this.selectionStart;var e=this.searchWordBoundary(t,-1),i=this.searchWordBoundary(t,1);this.selectionStart=e,this.selectionEnd=i,this._fireSelectionChanged(),this._updateTextarea(),this.renderCursorOrSelection()},selectLine:function(t){t=t||this.selectionStart;var e=this.findLineBoundaryLeft(t),i=this.findLineBoundaryRight(t);this.selectionStart=e,this.selectionEnd=i,this._fireSelectionChanged(),this._updateTextarea()},enterEditing:function(t){if(!this.isEditing&&this.editable)return this.canvas&&this.exitEditingOnOthers(this.canvas),this.isEditing=!0,this.initHiddenTextarea(t),this.hiddenTextarea.focus(),this._updateTextarea(),this._saveEditingProps(),this._setEditingProps(),this._textBeforeEdit=this.text,this._tick(),this.fire("editing:entered"),this.canvas?(this.canvas.fire("text:editing:entered",{target:this}),this.initMouseMoveHandler(),this.canvas.renderAll(),this):this},exitEditingOnOthers:function(t){t._iTextInstances&&t._iTextInstances.forEach(function(t){t.selected=!1,t.isEditing&&t.exitEditing()})},initMouseMoveHandler:function(){this.canvas.on("mouse:move",this.mouseMoveHandler)},mouseMoveHandler:function(t){if(this.__isMousedown&&this.isEditing){var e=this.getSelectionStartFromPointer(t.e),i=this.selectionStart,r=this.selectionEnd;e!==this.__selectionStartOnMouseDown&&(e>this.__selectionStartOnMouseDown?(this.selectionStart=this.__selectionStartOnMouseDown,this.selectionEnd=e):(this.selectionStart=e,this.selectionEnd=this.__selectionStartOnMouseDown),this.selectionStart===i&&this.selectionEnd===r||(this._fireSelectionChanged(),this._updateTextarea(),this.renderCursorOrSelection()))}},_setEditingProps:function(){this.hoverCursor="text",this.canvas&&(this.canvas.defaultCursor=this.canvas.moveCursor="text"),this.borderColor=this.editingBorderColor,this.hasControls=this.selectable=!1,this.lockMovementX=this.lockMovementY=!0},_updateTextarea:function(){if(this.hiddenTextarea&&!this.inCompositionMode&&(this.cursorOffsetCache={},this.hiddenTextarea.value=this.text,this.hiddenTextarea.selectionStart=this.selectionStart,this.hiddenTextarea.selectionEnd=this.selectionEnd,this.selectionStart===this.selectionEnd)){var t=this._calcTextareaPosition();this.hiddenTextarea.style.left=t.left,this.hiddenTextarea.style.top=t.top,this.hiddenTextarea.style.fontSize=t.fontSize}},_calcTextareaPosition:function(){if(!this.canvas)return{x:1,y:1};var t=this.text.split(""),e=this._getCursorBoundaries(t,"cursor"),i=this.get2DCursorLocation(),r=i.lineIndex,n=i.charIndex,s=this.getCurrentCharFontSize(r,n),o=0===r&&0===n?this._getLineLeftOffset(this._getLineWidth(this.ctx,r)):e.leftOffset,a=this.calcTransformMatrix(),h={x:e.left+o,y:e.top+e.topOffset+s},c=this.canvas.upperCanvasEl,l=c.width-s,u=c.height-s;return h=fabric.util.transformPoint(h,a),h=fabric.util.transformPoint(h,this.canvas.viewportTransform),h.x<0&&(h.x=0),h.x>l&&(h.x=l),h.y<0&&(h.y=0),h.y>u&&(h.y=u),h.x+=this.canvas._offset.left,h.y+=this.canvas._offset.top,{left:h.x+"px",top:h.y+"px",fontSize:s}},_saveEditingProps:function(){this._savedProps={hasControls:this.hasControls,borderColor:this.borderColor,lockMovementX:this.lockMovementX,lockMovementY:this.lockMovementY,hoverCursor:this.hoverCursor,defaultCursor:this.canvas&&this.canvas.defaultCursor,moveCursor:this.canvas&&this.canvas.moveCursor}},_restoreEditingProps:function(){this._savedProps&&(this.hoverCursor=this._savedProps.overCursor,this.hasControls=this._savedProps.hasControls,this.borderColor=this._savedProps.borderColor,this.lockMovementX=this._savedProps.lockMovementX,this.lockMovementY=this._savedProps.lockMovementY,this.canvas&&(this.canvas.defaultCursor=this._savedProps.defaultCursor,this.canvas.moveCursor=this._savedProps.moveCursor))},exitEditing:function(){var t=this._textBeforeEdit!==this.text;return this.selected=!1,this.isEditing=!1,this.selectable=!0,this.selectionEnd=this.selectionStart,this.hiddenTextarea.blur&&this.hiddenTextarea.blur(),this.hiddenTextarea&&this.canvas&&this.hiddenTextarea.parentNode.removeChild(this.hiddenTextarea),this.hiddenTextarea=null,this.abortCursorAnimation(),this._restoreEditingProps(),this._currentCursorOpacity=0,this.fire("editing:exited"),t&&this.fire("modified"),this.canvas&&(this.canvas.off("mouse:move",this.mouseMoveHandler),this.canvas.fire("text:editing:exited",{target:this}),t&&this.canvas.fire("object:modified",{target:this})),this},_removeExtraneousStyles:function(){for(var t in this.styles)this._textLines[t]||delete this.styles[t]},_removeCharsFromTo:function(t,e){for(;e!==t;)this._removeSingleCharAndStyle(t+1),e--;this.selectionStart=t,this.selectionEnd=t},_removeSingleCharAndStyle:function(t){var e="\n"===this.text[t-1],i=e?t:t-1;this.removeStyleObject(e,i),this.text=this.text.slice(0,t-1)+this.text.slice(t),this._textLines=this._splitTextIntoLines()},insertChars:function(t,e){var i;if(this.selectionEnd-this.selectionStart>1&&this._removeCharsFromTo(this.selectionStart,this.selectionEnd),!e&&this.isEmptyStyles())return void this.insertChar(t,!1);for(var r=0,n=t.length;r<n;r++)e&&(i=fabric.util.object.clone(fabric.copiedTextStyle[r],!0)),this.insertChar(t[r],r<n-1,i)},insertChar:function(t,e,i){var r="\n"===this.text[this.selectionStart];this.text=this.text.slice(0,this.selectionStart)+t+this.text.slice(this.selectionEnd),this._textLines=this._splitTextIntoLines(),this.insertStyleObjects(t,r,i),this.selectionStart+=t.length,this.selectionEnd=this.selectionStart,e||(this._updateTextarea(),this.setCoords(),this._fireSelectionChanged(),this.fire("changed"),this.canvas&&this.canvas.fire("text:changed",{target:this}),this.canvas&&this.canvas.renderAll())},insertNewlineStyleObject:function(e,i,r){this.shiftLineStyles(e,1),this.styles[e+1]||(this.styles[e+1]={});var n={},s={};if(this.styles[e]&&this.styles[e][i-1]&&(n=this.styles[e][i-1]),r)s[0]=t(n),this.styles[e+1]=s;else{for(var o in this.styles[e])parseInt(o,10)>=i&&(s[parseInt(o,10)-i]=this.styles[e][o],delete this.styles[e][o]);this.styles[e+1]=s}this._forceClearCache=!0},insertCharStyleObject:function(e,i,r){var n=this.styles[e],s=t(n);0!==i||r||(i=1);for(var o in s){var a=parseInt(o,10);a>=i&&(n[a+1]=s[a],s[a-1]||delete n[a])}this.styles[e][i]=r||t(n[i-1]),this._forceClearCache=!0},insertStyleObjects:function(t,e,i){var r=this.get2DCursorLocation(),n=r.lineIndex,s=r.charIndex;this._getLineStyle(n)||this._setLineStyle(n,{}),"\n"===t?this.insertNewlineStyleObject(n,s,e):this.insertCharStyleObject(n,s,i)},shiftLineStyles:function(e,i){var r=t(this.styles);for(var n in this.styles){var s=parseInt(n,10);s>e&&(this.styles[s+i]=r[s],r[s-i]||delete this.styles[s])}},removeStyleObject:function(t,e){var i=this.get2DCursorLocation(e),r=i.lineIndex,n=i.charIndex;this._removeStyleObject(t,i,r,n)},_getTextOnPreviousLine:function(t){return this._textLines[t-1]},_removeStyleObject:function(e,i,r,n){if(e){var s=this._getTextOnPreviousLine(i.lineIndex),o=s?s.length:0;this.styles[r-1]||(this.styles[r-1]={});for(n in this.styles[r])this.styles[r-1][parseInt(n,10)+o]=this.styles[r][n];this.shiftLineStyles(i.lineIndex,-1)}else{var a=this.styles[r];a&&delete a[n];var h=t(a);for(var c in h){var l=parseInt(c,10);l>=n&&0!==l&&(a[l-1]=h[l],delete a[l])}}},insertNewline:function(){this.insertChars("\n")},setSelectionStartEndWithShift:function(t,e,i){i<=t?(e===t?this._selectionDirection="left":"right"===this._selectionDirection&&(this._selectionDirection="left",this.selectionEnd=t),this.selectionStart=i):i>t&&i<e?"right"===this._selectionDirection?this.selectionEnd=i:this.selectionStart=i:(e===t?this._selectionDirection="right":"left"===this._selectionDirection&&(this._selectionDirection="right",this.selectionStart=e),this.selectionEnd=i)},setSelectionInBoundaries:function(){var t=this.text.length;this.selectionStart>t?this.selectionStart=t:this.selectionStart<0&&(this.selectionStart=0),this.selectionEnd>t?this.selectionEnd=t:this.selectionEnd<0&&(this.selectionEnd=0)}})}(),fabric.util.object.extend(fabric.IText.prototype,{initDoubleClickSimulation:function(){this.__lastClickTime=+new Date,this.__lastLastClickTime=+new Date,this.__lastPointer={},this.on("mousedown",this.onMouseDown.bind(this))},onMouseDown:function(t){this.__newClickTime=+new Date;var e=this.canvas.getPointer(t.e);this.isTripleClick(e)?(this.fire("tripleclick",t),this._stopEvent(t.e)):this.isDoubleClick(e)&&(this.fire("dblclick",t),this._stopEvent(t.e)),this.__lastLastClickTime=this.__lastClickTime,this.__lastClickTime=this.__newClickTime,this.__lastPointer=e,this.__lastIsEditing=this.isEditing,this.__lastSelected=this.selected},isDoubleClick:function(t){return this.__newClickTime-this.__lastClickTime<500&&this.__lastPointer.x===t.x&&this.__lastPointer.y===t.y&&this.__lastIsEditing},isTripleClick:function(t){return this.__newClickTime-this.__lastClickTime<500&&this.__lastClickTime-this.__lastLastClickTime<500&&this.__lastPointer.x===t.x&&this.__lastPointer.y===t.y},_stopEvent:function(t){t.preventDefault&&t.preventDefault(),t.stopPropagation&&t.stopPropagation()},initCursorSelectionHandlers:function(){this.initSelectedHandler(),this.initMousedownHandler(),this.initMouseupHandler(),this.initClicks()},initClicks:function(){this.on("dblclick",function(t){this.selectWord(this.getSelectionStartFromPointer(t.e))}),this.on("tripleclick",function(t){this.selectLine(this.getSelectionStartFromPointer(t.e))})},initMousedownHandler:function(){this.on("mousedown",function(t){if(this.editable){var e=this.canvas.getPointer(t.e);this.__mousedownX=e.x,this.__mousedownY=e.y,this.__isMousedown=!0,this.selected&&this.setCursorByClick(t.e),this.isEditing&&(this.__selectionStartOnMouseDown=this.selectionStart,this.selectionStart===this.selectionEnd&&this.abortCursorAnimation(),this.renderCursorOrSelection())}})},_isObjectMoved:function(t){var e=this.canvas.getPointer(t);return this.__mousedownX!==e.x||this.__mousedownY!==e.y},initMouseupHandler:function(){this.on("mouseup",function(t){this.__isMousedown=!1,this.editable&&!this._isObjectMoved(t.e)&&(this.__lastSelected&&!this.__corner&&(this.enterEditing(t.e),this.selectionStart===this.selectionEnd?this.initDelayedCursor(!0):this.renderCursorOrSelection()),this.selected=!0)})},setCursorByClick:function(t){var e=this.getSelectionStartFromPointer(t),i=this.selectionStart,r=this.selectionEnd;t.shiftKey?this.setSelectionStartEndWithShift(i,r,e):(this.selectionStart=e,this.selectionEnd=e),this._fireSelectionChanged(),this._updateTextarea()},getSelectionStartFromPointer:function(t){for(var e,i,r=this.getLocalPointer(t),n=0,s=0,o=0,a=0,h=0,c=this._textLines.length;h<c;h++){i=this._textLines[h],o+=this._getHeightOfLine(this.ctx,h)*this.scaleY;var l=this._getLineWidth(this.ctx,h),u=this._getLineLeftOffset(l);s=u*this.scaleX;for(var f=0,d=i.length;f<d;f++){if(n=s,s+=this._getWidthOfChar(this.ctx,i[f],h,this.flipX?d-f:f)*this.scaleX,!(o<=r.y||s<=r.x))return this._getNewSelectionStartFromOffset(r,n,s,a+h,d);a++}if(r.y<o)return this._getNewSelectionStartFromOffset(r,n,s,a+h-1,d)}if("undefined"==typeof e)return this.text.length},_getNewSelectionStartFromOffset:function(t,e,i,r,n){var s=t.x-e,o=i-t.x,a=o>s?0:1,h=r+a;return this.flipX&&(h=n-h),h>this.text.length&&(h=this.text.length),h}}),fabric.util.object.extend(fabric.IText.prototype,{initHiddenTextarea:function(){this.hiddenTextarea=fabric.document.createElement("textarea"),this.hiddenTextarea.setAttribute("autocapitalize","off");var t=this._calcTextareaPosition();this.hiddenTextarea.style.cssText="position: absolute; top: "+t.top+"; left: "+t.left+"; opacity: 0; width: 0px; height: 0px; z-index: -999;",fabric.document.body.appendChild(this.hiddenTextarea),fabric.util.addListener(this.hiddenTextarea,"keydown",this.onKeyDown.bind(this)),fabric.util.addListener(this.hiddenTextarea,"keyup",this.onKeyUp.bind(this)),fabric.util.addListener(this.hiddenTextarea,"input",this.onInput.bind(this)),fabric.util.addListener(this.hiddenTextarea,"copy",this.copy.bind(this)),fabric.util.addListener(this.hiddenTextarea,"cut",this.cut.bind(this)),fabric.util.addListener(this.hiddenTextarea,"paste",this.paste.bind(this)),fabric.util.addListener(this.hiddenTextarea,"compositionstart",this.onCompositionStart.bind(this)),fabric.util.addListener(this.hiddenTextarea,"compositionupdate",this.onCompositionUpdate.bind(this)),fabric.util.addListener(this.hiddenTextarea,"compositionend",this.onCompositionEnd.bind(this)),!this._clickHandlerInitialized&&this.canvas&&(fabric.util.addListener(this.canvas.upperCanvasEl,"click",this.onClick.bind(this)),this._clickHandlerInitialized=!0)},_keysMap:{8:"removeChars",9:"exitEditing",27:"exitEditing",13:"insertNewline",33:"moveCursorUp",34:"moveCursorDown",35:"moveCursorRight",36:"moveCursorLeft",37:"moveCursorLeft",38:"moveCursorUp",39:"moveCursorRight",40:"moveCursorDown",46:"forwardDelete"},_ctrlKeysMapUp:{67:"copy",88:"cut"},_ctrlKeysMapDown:{65:"selectAll"},onClick:function(){this.hiddenTextarea&&this.hiddenTextarea.focus()},onKeyDown:function(t){if(this.isEditing){if(t.keyCode in this._keysMap)this[this._keysMap[t.keyCode]](t);else{if(!(t.keyCode in this._ctrlKeysMapDown&&(t.ctrlKey||t.metaKey)))return;this[this._ctrlKeysMapDown[t.keyCode]](t)}t.stopImmediatePropagation(),t.preventDefault(),t.keyCode>=33&&t.keyCode<=40?(this.clearContextTop(),this.renderCursorOrSelection()):this.canvas&&this.canvas.renderAll()}},onKeyUp:function(t){return!this.isEditing||this._copyDone?void(this._copyDone=!1):void(t.keyCode in this._ctrlKeysMapUp&&(t.ctrlKey||t.metaKey)&&(this[this._ctrlKeysMapUp[t.keyCode]](t),t.stopImmediatePropagation(),t.preventDefault(),this.canvas&&this.canvas.renderAll()))},onInput:function(t){if(this.isEditing&&!this.inCompositionMode){var e,i,r,n=this.selectionStart||0,s=this.selectionEnd||0,o=this.text.length,a=this.hiddenTextarea.value.length;a>o?(r="left"===this._selectionDirection?s:n,e=a-o,i=this.hiddenTextarea.value.slice(r,r+e)):(e=a-o+s-n,i=this.hiddenTextarea.value.slice(n,n+e)),this.insertChars(i),t.stopPropagation()}},onCompositionStart:function(){this.inCompositionMode=!0,this.prevCompositionLength=0,this.compositionStart=this.selectionStart},onCompositionEnd:function(){this.inCompositionMode=!1},onCompositionUpdate:function(t){var e=t.data;this.selectionStart=this.compositionStart,this.selectionEnd=this.selectionEnd===this.selectionStart?this.compositionStart+this.prevCompositionLength:this.selectionEnd,this.insertChars(e,!1),this.prevCompositionLength=e.length},forwardDelete:function(t){if(this.selectionStart===this.selectionEnd){if(this.selectionStart===this.text.length)return;this.moveCursorRight(t)}this.removeChars(t)},copy:function(t){if(this.selectionStart!==this.selectionEnd){var e=this.getSelectedText(),i=this._getClipboardData(t);i&&i.setData("text",e),fabric.copiedText=e,fabric.copiedTextStyle=this.getSelectionStyles(this.selectionStart,this.selectionEnd),t.stopImmediatePropagation(),t.preventDefault(),this._copyDone=!0}},paste:function(t){var e=null,i=this._getClipboardData(t),r=!0;i?(e=i.getData("text").replace(/\r/g,""),fabric.copiedTextStyle&&fabric.copiedText===e||(r=!1)):e=fabric.copiedText,e&&this.insertChars(e,r),t.stopImmediatePropagation(),t.preventDefault()},cut:function(t){this.selectionStart!==this.selectionEnd&&(this.copy(t),this.removeChars(t))},_getClipboardData:function(t){return t&&t.clipboardData||fabric.window.clipboardData},_getWidthBeforeCursor:function(t,e){for(var i,r=this._textLines[t].slice(0,e),n=this._getLineWidth(this.ctx,t),s=this._getLineLeftOffset(n),o=0,a=r.length;o<a;o++)i=r[o],s+=this._getWidthOfChar(this.ctx,i,t,o);return s},getDownCursorOffset:function(t,e){var i=this._getSelectionForOffset(t,e),r=this.get2DCursorLocation(i),n=r.lineIndex;if(n===this._textLines.length-1||t.metaKey||34===t.keyCode)return this.text.length-i;var s=r.charIndex,o=this._getWidthBeforeCursor(n,s),a=this._getIndexOnLine(n+1,o),h=this._textLines[n].slice(s);return h.length+a+2},_getSelectionForOffset:function(t,e){return t.shiftKey&&this.selectionStart!==this.selectionEnd&&e?this.selectionEnd:this.selectionStart},getUpCursorOffset:function(t,e){var i=this._getSelectionForOffset(t,e),r=this.get2DCursorLocation(i),n=r.lineIndex;if(0===n||t.metaKey||33===t.keyCode)return-i;var s=r.charIndex,o=this._getWidthBeforeCursor(n,s),a=this._getIndexOnLine(n-1,o),h=this._textLines[n].slice(0,s);return-this._textLines[n-1].length+a-h.length},_getIndexOnLine:function(t,e){for(var i,r=this._getLineWidth(this.ctx,t),n=this._textLines[t],s=this._getLineLeftOffset(r),o=s,a=0,h=0,c=n.length;h<c;h++){var l=n[h],u=this._getWidthOfChar(this.ctx,l,t,h);if(o+=u,o>e){i=!0;var f=o-u,d=o,g=Math.abs(f-e),p=Math.abs(d-e);a=p<g?h:h-1;break}}return i||(a=n.length-1),a},moveCursorDown:function(t){this.selectionStart>=this.text.length&&this.selectionEnd>=this.text.length||this._moveCursorUpOrDown("Down",t)},moveCursorUp:function(t){0===this.selectionStart&&0===this.selectionEnd||this._moveCursorUpOrDown("Up",t)},_moveCursorUpOrDown:function(t,e){var i="get"+t+"CursorOffset",r=this[i](e,"right"===this._selectionDirection);e.shiftKey?this.moveCursorWithShift(r):this.moveCursorWithoutShift(r),0!==r&&(this.setSelectionInBoundaries(),this.abortCursorAnimation(),this._currentCursorOpacity=1,this.initDelayedCursor(),this._fireSelectionChanged(),this._updateTextarea())},moveCursorWithShift:function(t){var e="left"===this._selectionDirection?this.selectionStart+t:this.selectionEnd+t;return this.setSelectionStartEndWithShift(this.selectionStart,this.selectionEnd,e),0!==t},moveCursorWithoutShift:function(t){return t<0?(this.selectionStart+=t,this.selectionEnd=this.selectionStart):(this.selectionEnd+=t,this.selectionStart=this.selectionEnd),0!==t},moveCursorLeft:function(t){0===this.selectionStart&&0===this.selectionEnd||this._moveCursorLeftOrRight("Left",t)},_move:function(t,e,i){var r;if(t.altKey)r=this["findWordBoundary"+i](this[e]);else{if(!t.metaKey&&35!==t.keyCode&&36!==t.keyCode)return this[e]+="Left"===i?-1:1,!0;r=this["findLineBoundary"+i](this[e])}if(void 0!==typeof r&&this[e]!==r)return this[e]=r,!0},_moveLeft:function(t,e){return this._move(t,e,"Left")},_moveRight:function(t,e){return this._move(t,e,"Right")},moveCursorLeftWithoutShift:function(t){var e=!0;return this._selectionDirection="left",this.selectionEnd===this.selectionStart&&0!==this.selectionStart&&(e=this._moveLeft(t,"selectionStart")),this.selectionEnd=this.selectionStart,e},moveCursorLeftWithShift:function(t){return"right"===this._selectionDirection&&this.selectionStart!==this.selectionEnd?this._moveLeft(t,"selectionEnd"):0!==this.selectionStart?(this._selectionDirection="left",this._moveLeft(t,"selectionStart")):void 0},moveCursorRight:function(t){this.selectionStart>=this.text.length&&this.selectionEnd>=this.text.length||this._moveCursorLeftOrRight("Right",t)},_moveCursorLeftOrRight:function(t,e){var i="moveCursor"+t+"With";this._currentCursorOpacity=1,i+=e.shiftKey?"Shift":"outShift",this[i](e)&&(this.abortCursorAnimation(),this.initDelayedCursor(),this._fireSelectionChanged(),this._updateTextarea())},moveCursorRightWithShift:function(t){return"left"===this._selectionDirection&&this.selectionStart!==this.selectionEnd?this._moveRight(t,"selectionStart"):this.selectionEnd!==this.text.length?(this._selectionDirection="right",this._moveRight(t,"selectionEnd")):void 0},moveCursorRightWithoutShift:function(t){var e=!0;return this._selectionDirection="right",this.selectionStart===this.selectionEnd?(e=this._moveRight(t,"selectionStart"),this.selectionEnd=this.selectionStart):this.selectionStart=this.selectionEnd,e},removeChars:function(t){this.selectionStart===this.selectionEnd?this._removeCharsNearCursor(t):this._removeCharsFromTo(this.selectionStart,this.selectionEnd),this.set("dirty",!0),this.setSelectionEnd(this.selectionStart),this._removeExtraneousStyles(),this.canvas&&this.canvas.renderAll(),this.setCoords(),this.fire("changed"),this.canvas&&this.canvas.fire("text:changed",{target:this})},_removeCharsNearCursor:function(t){if(0!==this.selectionStart)if(t.metaKey){var e=this.findLineBoundaryLeft(this.selectionStart);this._removeCharsFromTo(e,this.selectionStart),this.setSelectionStart(e)}else if(t.altKey){var i=this.findWordBoundaryLeft(this.selectionStart);this._removeCharsFromTo(i,this.selectionStart),this.setSelectionStart(i)}else this._removeSingleCharAndStyle(this.selectionStart),this.setSelectionStart(this.selectionStart-1)}}),function(){var t=fabric.util.toFixed,e=fabric.Object.NUM_FRACTION_DIGITS;fabric.util.object.extend(fabric.IText.prototype,{_setSVGTextLineText:function(t,e,i,r,n,s){this._getLineStyle(t)?this._setSVGTextLineChars(t,e,i,r,s):fabric.Text.prototype._setSVGTextLineText.call(this,t,e,i,r,n)},_setSVGTextLineChars:function(t,e,i,r,n){for(var s=this._textLines[t],o=0,a=this._getLineLeftOffset(this._getLineWidth(this.ctx,t))-this.width/2,h=this._getSVGLineTopOffset(t),c=this._getHeightOfLine(this.ctx,t),l=0,u=s.length;l<u;l++){var f=this._getStyleDeclaration(t,l)||{};e.push(this._createTextCharSpan(s[l],f,a,h.lineTop+h.offset,o));var d=this._getWidthOfChar(this.ctx,s[l],t,l);f.textBackgroundColor&&n.push(this._createTextCharBg(f,a,h.lineTop,c,d,o)),o+=d}},_getSVGLineTopOffset:function(t){for(var e=0,i=0,r=0;r<t;r++)e+=this._getHeightOfLine(this.ctx,r);return i=this._getHeightOfLine(this.ctx,r),{lineTop:e,offset:(this._fontSizeMult-this._fontSizeFraction)*i/(this.lineHeight*this._fontSizeMult)}},_createTextCharBg:function(i,r,n,s,o,a){return['\t\t<rect fill="',i.textBackgroundColor,'" x="',t(r+a,e),'" y="',t(n-this.height/2,e),'" width="',t(o,e),'" height="',t(s/this.lineHeight,e),'"></rect>\n'].join("")},_createTextCharSpan:function(i,r,n,s,o){var a=this.getSvgStyles.call(fabric.util.object.extend({visible:!0,fill:this.fill,stroke:this.stroke,type:"text",getSvgFilter:fabric.Object.prototype.getSvgFilter},r));return['\t\t\t<tspan x="',t(n+o,e),'" y="',t(s-this.height/2,e),'" ',r.fontFamily?'font-family="'+r.fontFamily.replace(/"/g,"'")+'" ':"",r.fontSize?'font-size="'+r.fontSize+'" ':"",r.fontStyle?'font-style="'+r.fontStyle+'" ':"",r.fontWeight?'font-weight="'+r.fontWeight+'" ':"",r.textDecoration?'text-decoration="'+r.textDecoration+'" ':"",'style="',a,'">',fabric.util.string.escapeXml(i),"</tspan>\n"].join("")}})}(),function(t){"use strict";var e=t.fabric||(t.fabric={});e.Textbox=e.util.createClass(e.IText,e.Observable,{type:"textbox",minWidth:20,dynamicMinWidth:2,__cachedLines:null,lockScalingY:!0,lockScalingFlip:!0,noScaleCache:!1,initialize:function(t,i){this.callSuper("initialize",t,i),this.setControlsVisibility(e.Textbox.getTextboxControlVisibility()),this.ctx=this.objectCaching?this._cacheContext:e.util.createCanvasElement().getContext("2d"),this._dimensionAffectingProps.push("width")},_initDimensions:function(t){this.__skipDimension||(t||(t=e.util.createCanvasElement().getContext("2d"),this._setTextStyles(t),this.clearContextTop()),this.dynamicMinWidth=0,this._textLines=this._splitTextIntoLines(t),this.dynamicMinWidth>this.width&&this._set("width",this.dynamicMinWidth),this._clearCache(),this.height=this._getTextHeight(t))},_generateStyleMap:function(){for(var t=0,e=0,i=0,r={},n=0;n<this._textLines.length;n++)"\n"===this.text[i]&&n>0?(e=0,i++,t++):" "===this.text[i]&&n>0&&(e++,i++),r[n]={line:t,offset:e},i+=this._textLines[n].length,e+=this._textLines[n].length;return r},_getStyleDeclaration:function(t,e,i){if(this._styleMap){var r=this._styleMap[t];if(!r)return i?{}:null;t=r.line,e=r.offset+e}return this.callSuper("_getStyleDeclaration",t,e,i)},_setStyleDeclaration:function(t,e,i){var r=this._styleMap[t];t=r.line,e=r.offset+e,this.styles[t][e]=i},_deleteStyleDeclaration:function(t,e){var i=this._styleMap[t];t=i.line,e=i.offset+e,delete this.styles[t][e]},_getLineStyle:function(t){var e=this._styleMap[t];return this.styles[e.line]},_setLineStyle:function(t,e){var i=this._styleMap[t];this.styles[i.line]=e},_deleteLineStyle:function(t){var e=this._styleMap[t];delete this.styles[e.line]},_wrapText:function(t,e){var i,r=e.split(this._reNewline),n=[];for(i=0;i<r.length;i++)n=n.concat(this._wrapLine(t,r[i],i));return n},_measureText:function(t,e,i,r){var n=0;r=r||0;for(var s=0,o=e.length;s<o;s++)n+=this._getWidthOfChar(t,e[s],i,s+r);return n},_wrapLine:function(t,e,i){for(var r=0,n=[],s="",o=e.split(" "),a="",h=0,c=" ",l=0,u=0,f=0,d=!0,g=this._getWidthOfCharSpacing(),p=0;p<o.length;p++)a=o[p],l=this._measureText(t,a,i,h),h+=a.length,r+=u+l-g,r>=this.width&&!d?(n.push(s),s="",r=l,d=!0):r+=g,d||(s+=c),s+=a,u=this._measureText(t,c,i,h),h++,d=!1,l>f&&(f=l);return p&&n.push(s),f>this.dynamicMinWidth&&(this.dynamicMinWidth=f-g),n},_splitTextIntoLines:function(t){t=t||this.ctx;var e=this.textAlign;this._styleMap=null,t.save(),this._setTextStyles(t),this.textAlign="left";var i=this._wrapText(t,this.text);return this.textAlign=e,t.restore(),this._textLines=i,this._styleMap=this._generateStyleMap(),i},setOnGroup:function(t,e){"scaleX"===t&&(this.set("scaleX",Math.abs(1/e)),this.set("width",this.get("width")*e/("undefined"==typeof this.__oldScaleX?1:this.__oldScaleX)),this.__oldScaleX=e)},get2DCursorLocation:function(t){"undefined"==typeof t&&(t=this.selectionStart);for(var e=this._textLines.length,i=0,r=0;r<e;r++){var n=this._textLines[r],s=n.length;if(t<=i+s)return{lineIndex:r,charIndex:t-i};i+=s,"\n"!==this.text[i]&&" "!==this.text[i]||i++}return{lineIndex:e-1,charIndex:this._textLines[e-1].length}},_getCursorBoundariesOffsets:function(t,e){for(var i=0,r=0,n=this.get2DCursorLocation(),s=this._textLines[n.lineIndex].split(""),o=this._getLineLeftOffset(this._getLineWidth(this.ctx,n.lineIndex)),a=0;a<n.charIndex;a++)r+=this._getWidthOfChar(this.ctx,s[a],n.lineIndex,a);for(a=0;a<n.lineIndex;a++)i+=this._getHeightOfLine(this.ctx,a);return"cursor"===e&&(i+=(1-this._fontSizeFraction)*this._getHeightOfLine(this.ctx,n.lineIndex)/this.lineHeight-this.getCurrentCharFontSize(n.lineIndex,n.charIndex)*(1-this._fontSizeFraction)),{top:i,left:r,lineLeft:o}},getMinWidth:function(){return Math.max(this.minWidth,this.dynamicMinWidth)},toObject:function(t){return this.callSuper("toObject",["minWidth"].concat(t))}}),e.Textbox.fromObject=function(t,i,r){return e.Object._fromObject("Textbox",t,i,r,"text")},e.Textbox.getTextboxControlVisibility=function(){return{tl:!1,tr:!1,br:!1,bl:!1,ml:!0,mt:!1,mr:!0,mb:!1,mtr:!0}}}("undefined"!=typeof exports?exports:this),function(){var t=fabric.Canvas.prototype._setObjectScale;fabric.Canvas.prototype._setObjectScale=function(e,i,r,n,s,o,a){var h=i.target;if(!(h instanceof fabric.Textbox))return t.call(fabric.Canvas.prototype,e,i,r,n,s,o,a);var c=h.width*(e.x/i.scaleX/(h.width+h.strokeWidth));return c>=h.getMinWidth()?(h.set("width",c),!0):void 0},fabric.Group.prototype._refreshControlsVisibility=function(){if("undefined"!=typeof fabric.Textbox)for(var t=this._objects.length;t--;)if(this._objects[t]instanceof fabric.Textbox)return void this.setControlsVisibility(fabric.Textbox.getTextboxControlVisibility())};var e=fabric.util.object.clone;fabric.util.object.extend(fabric.Textbox.prototype,{_removeExtraneousStyles:function(){for(var t in this._styleMap)this._textLines[t]||delete this.styles[this._styleMap[t].line]},insertCharStyleObject:function(t,e,i){var r=this._styleMap[t];t=r.line,e=r.offset+e,fabric.IText.prototype.insertCharStyleObject.apply(this,[t,e,i])},insertNewlineStyleObject:function(t,e,i){var r=this._styleMap[t];t=r.line,e=r.offset+e,fabric.IText.prototype.insertNewlineStyleObject.apply(this,[t,e,i])},shiftLineStyles:function(t,i){var r=e(this.styles),n=this._styleMap[t];t=n.line;for(var s in this.styles){var o=parseInt(s,10);o>t&&(this.styles[o+i]=r[o],r[o-i]||delete this.styles[o])}},_getTextOnPreviousLine:function(t){for(var e=this._textLines[t-1];this._styleMap[t-2]&&this._styleMap[t-2].line===this._styleMap[t-1].line;)e=this._textLines[t-2]+e,t--;return e},removeStyleObject:function(t,e){var i=this.get2DCursorLocation(e),r=this._styleMap[i.lineIndex],n=r.line,s=r.offset+i.charIndex;this._removeStyleObject(t,i,n,s)}})}(),function(){var t=fabric.IText.prototype._getNewSelectionStartFromOffset;fabric.IText.prototype._getNewSelectionStartFromOffset=function(e,i,r,n,s){n=t.call(this,e,i,r,n,s);for(var o=0,a=0,h=0;h<this._textLines.length&&(o+=this._textLines[h].length,!(o+a>=n));h++)"\n"!==this.text[o+a]&&" "!==this.text[o+a]||a++;return n-h+a}}(),function(){function request(t,e,i){var r=URL.parse(t);r.port||(r.port=0===r.protocol.indexOf("https:")?443:80);var n=0===r.protocol.indexOf("https:")?HTTPS:HTTP,s=n.request({hostname:r.hostname,port:r.port,path:r.path,method:"GET"},function(t){var r="";e&&t.setEncoding(e),t.on("end",function(){i(r)}),t.on("data",function(e){200===t.statusCode&&(r+=e)})});s.on("error",function(t){t.errno===process.ECONNREFUSED?fabric.log("ECONNREFUSED: connection refused to "+r.hostname+":"+r.port):fabric.log(t.message),i(null)}),s.end()}function requestFs(t,e){var i=require("fs");i.readFile(t,function(t,i){if(t)throw fabric.log(t),t;e(i)})}if("undefined"==typeof document||"undefined"==typeof window){var DOMParser=require("xmldom").DOMParser,URL=require("url"),HTTP=require("http"),HTTPS=require("https"),Canvas=require("canvas"),Image=require("canvas").Image;fabric.util.loadImage=function(t,e,i){function r(r){r?(n.src=new Buffer(r,"binary"),n._src=t,e&&e.call(i,n)):(n=null,e&&e.call(i,null,!0))}var n=new Image;t&&(t instanceof Buffer||0===t.indexOf("data"))?(n.src=n._src=t,e&&e.call(i,n)):t&&0!==t.indexOf("http")?requestFs(t,r):t?request(t,"binary",r):e&&e.call(i,t)},fabric.loadSVGFromURL=function(t,e,i){t=t.replace(/^\n\s*/,"").replace(/\?.*$/,"").trim(),0!==t.indexOf("http")?requestFs(t,function(t){fabric.loadSVGFromString(t.toString(),e,i)}):request(t,"",function(t){fabric.loadSVGFromString(t,e,i)})},fabric.loadSVGFromString=function(t,e,i){var r=(new DOMParser).parseFromString(t);fabric.parseSVGDocument(r.documentElement,function(t,i){e&&e(t,i)},i)},fabric.util.getScript=function(url,callback){request(url,"",function(body){eval(body),callback&&callback()})},fabric.createCanvasForNode=function(t,e,i,r){r=r||i;var n=fabric.document.createElement("canvas"),s=new Canvas(t||600,e||600,r),o=new Canvas(t||600,e||600,r);n.style={},n.width=s.width,n.height=s.height,i=i||{},i.nodeCanvas=s,i.nodeCacheCanvas=o;var a=fabric.Canvas||fabric.StaticCanvas,h=new a(n,i);return h.nodeCanvas=s,h.nodeCacheCanvas=o,h.contextContainer=s.getContext("2d"),h.contextCache=o.getContext("2d"),h.Font=Canvas.Font,h};var originaInitStatic=fabric.StaticCanvas.prototype._initStatic;fabric.StaticCanvas.prototype._initStatic=function(t,e){t=t||fabric.document.createElement("canvas"),this.nodeCanvas=new Canvas(t.width,t.height),this.nodeCacheCanvas=new Canvas(t.width,t.height),originaInitStatic.call(this,t,e),this.contextContainer=this.nodeCanvas.getContext("2d"),this.contextCache=this.nodeCacheCanvas.getContext("2d"),this.Font=Canvas.Font;
},fabric.StaticCanvas.prototype.createPNGStream=function(){return this.nodeCanvas.createPNGStream()},fabric.StaticCanvas.prototype.createJPEGStream=function(t){return this.nodeCanvas.createJPEGStream(t)},fabric.StaticCanvas.prototype._initRetinaScaling=function(){if(this._isRetinaScaling())return this.lowerCanvasEl.setAttribute("width",this.width*fabric.devicePixelRatio),this.lowerCanvasEl.setAttribute("height",this.height*fabric.devicePixelRatio),this.nodeCanvas.width=this.width*fabric.devicePixelRatio,this.nodeCanvas.height=this.height*fabric.devicePixelRatio,this.contextContainer.scale(fabric.devicePixelRatio,fabric.devicePixelRatio),this},fabric.Canvas&&(fabric.Canvas.prototype._initRetinaScaling=fabric.StaticCanvas.prototype._initRetinaScaling);var origSetBackstoreDimension=fabric.StaticCanvas.prototype._setBackstoreDimension;fabric.StaticCanvas.prototype._setBackstoreDimension=function(t,e){return origSetBackstoreDimension.call(this,t,e),this.nodeCanvas[t]=e,this},fabric.Canvas&&(fabric.Canvas.prototype._setBackstoreDimension=fabric.StaticCanvas.prototype._setBackstoreDimension)}}();
(function(){
  var moduleName = 'angularUtils.directives.dirPaginationClone';
  var DEFAULT_ID = '__defaultClone';

  angular.module(moduleName, [])
    .directive('dirPaginateClone', ['$compile', '$parse', 'paginationServiceClone', dirPaginateDirectiveClone])
    .directive('dirPaginateNoCompileClone', noCompileDirectiveClone)
    .directive('dirPaginationControlsClone', ['paginationServiceClone', 'paginationTemplateClone', dirPaginationControlsDirectiveClone])
    .filter('itemsPerPageClone', ['$rootScope', 'paginationServiceClone', itemsPerPageFilterClone])
    .filter('remainItemPerPageClone', ['paginationServiceClone', remainItemPerPageFilterClone])
    .service('paginationServiceClone', paginationServiceClone)
    .provider('paginationTemplateClone', paginationTemplateProviderClone)
    .run(['$templateCache', dirPaginationControlsTemplateInstallerClone]);

  function dirPaginateDirectiveClone($compile, $parse, paginationServiceClone){
    return {
      terminal: true,
      multiElement: true,
      priority: 100,
      compile: dirPaginationCompileFnClone
    };

    function dirPaginationCompileFnClone(tElement, tAttrs){
      // console.warn("PAGI Clone");
      var expression = tAttrs.dirPaginateClone;

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      var filterPattern = /\|\s*itemsPerPageClone\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
      var filterPattern1 = /\|\s*remainItemPerPageClone\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
      if (match[2].match(filterPattern) === null && match[2].match(filterPattern1) === null){
        throw 'pagination directive clone: the \'itemsPerPageClone\' filter must be set.';
      }
      if (match[2].match(filterPattern) !== null){
        var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
      } else if (match[2].match(filterPattern1) !== null){
        var itemsPerPageFilterRemoved = match[2].replace(filterPattern1, '');
      }

      var collectionGetter = $parse(itemsPerPageFilterRemoved);

      addNoCompileAttributesClone(tElement);

      var rawId = tAttrs.paginationId || DEFAULT_ID;
      paginationServiceClone.registerInstance(rawId);

      return function dirPaginationLinkFnClone(scope, element, attrs){
        var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;

        paginationServiceClone.registerInstance(paginationId);

        var repeatExpression = getRepeatExpressionClone(expression, paginationId);
        addNgRepeatToElementClone(element, attrs, repeatExpression);

        removeTemporaryAttributesClone(element);
        var compiled =  $compile(element);

        var currentPageGetter = makeCurrentPageGetterFnClone(scope, attrs, paginationId);
        paginationServiceClone.setCurrentPageParser(paginationId, currentPageGetter, scope);

        if (typeof attrs.totalItems !== 'undefined') {
          paginationServiceClone.setAsyncModeTrue(paginationId);
          scope.$watch(function() {
            return $parse(attrs.totalItems)(scope);
          }, function (result) {
            if (0 <= result) {
              paginationServiceClone.setCollectionLength(paginationId, result);
            }
          });
        } else {
          paginationServiceClone.setAsyncModeFalse(paginationId);
          scope.$watchCollection(function() {
              return collectionGetter(scope);
          }, function(collection) {
            if (collection) {
              var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
              paginationServiceClone.setCollectionLength(paginationId, collectionLength);
            }
          });
        }

        compiled(scope);
      };
    }

    function getRepeatExpressionClone(expression, paginationId) {
      var repeatExpression,
          idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPageClone\s*:[^|]*:[^|]*)/);

      if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
        repeatExpression = expression.replace(/(\|\s*itemsPerPageClone\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
      } else {
        repeatExpression = expression;
      }

      return repeatExpression;
    }

    function addNgRepeatToElementClone(element, attrs, repeatExpression) {
      if (element[0].hasAttribute('dir-paginate-start-clone') || element[0].hasAttribute('data-dir-paginate-start-clone')) {
        // using multiElement mode (dir-paginate-start, dir-paginate-end)
        attrs.$set('ngRepeatStart', repeatExpression);
        element.eq(element.length - 1).attr('ng-repeat-end', true);
      } else {
        attrs.$set('ngRepeat', repeatExpression);
      }
    }

    function addNoCompileAttributesClone(tElement) {
      angular.forEach(tElement, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).attr('dir-paginate-no-compile-clone', true);
        }
      });
    }

    function removeTemporaryAttributesClone(element) {
      angular.forEach(element, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).removeAttr('dir-paginate-no-compile-clone');
        }
      });
      element.eq(0).removeAttr('dir-paginate-start-clone').removeAttr('dir-paginate-clone').removeAttr('data-dir-paginate-start-clone').removeAttr('data-dir-paginate-clone');
      element.eq(element.length - 1).removeAttr('dir-paginate-end-clone').removeAttr('data-dir-paginate-end-clone');
    }

    function makeCurrentPageGetterFnClone(scope, attrs, paginationId) {
      var currentPageGetter;
      if (attrs.currentPage) {
        currentPageGetter = $parse(attrs.currentPage);
      } else {
        var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
        scope[defaultCurrentPage] = 1;
        currentPageGetter = $parse(defaultCurrentPage);
      }
      return currentPageGetter;
    }
  }

  function noCompileDirectiveClone(){
    return {
      priority: 5000,
      terminal: true
    };
  }

  function dirPaginationControlsTemplateInstallerClone($templateCache){
    $templateCache.put('angularUtils.directives.dirPaginationClone.template',
    '<ul id="pagingCtrlClone" class="pagination1 custom-pagination" data-id=pages>\
      <li ng-if="boundaryLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(1)"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>\
      <li ng-if="directionLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)"><i class="fa fa-angle-left" aria-hidden="true"></i></a></li>\
      <li class="l-{{pageNumber}}" ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active:pagination.current == pageNumber, disabled:pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }" class="nonSelectable">\
        <a href="" ng-click="setCurrent(pageNumber)" ng-disabled="loadMore">{{ pageNumber }}</a>\
      </li>\
      <li ng-if="directionLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)"><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>\
      <li ng-if="boundaryLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>\
      </ul>'
    );
  }

  function countEllipsisClone(arr) {
    var count = 0;
    var firstEllipsis = false;
    var secondEllipsis = false;

    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === "...") {
        count++;
        if (!firstEllipsis) {
          firstEllipsis = true;
        } else {
          secondEllipsis = true;
        }
      }
    }

    return { count: count, firstEllipsis: firstEllipsis, secondEllipsis: secondEllipsis };
  }

  function dirPaginationControlsDirectiveClone(paginationServiceClone, paginationTemplateClone){
    var numberRegex = /^\d+$/;

    return {
      restrict: 'AE',
      templateUrl: function(elem, attrs) {
        return attrs.templateUrl || paginationTemplateClone.getPath();
      },
      scope: {
        maxSize: '=?',
        onPageChange: '&?',
        paginationId: '=?',
        autoHide: '=?',
        loadMore: '=?'
      },
      link: dirPaginationControlsLinkFnClone
    };

    function dirPaginationControlsLinkFnClone(scope, element, attrs) {

      // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate-clone directive has
      // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
      // no corresponding dir-paginate-clone directive and wrongly throwing an exception.
      var rawId = attrs.paginationId || DEFAULT_ID;
      var paginationId = scope.paginationId || attrs.paginationId || DEFAULT_ID;

      if (!paginationServiceClone.isRegistered(paginationId) && !paginationServiceClone.isRegistered(rawId)) {
          var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
          if (window.console) {
              console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
          }
      }

      if (!scope.maxSize) { scope.maxSize = 9; } // Default to 9
      scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

      var paginationRange = Math.max(scope.maxSize, 10);
      scope.pages = [];
      scope.pagination = {
          last: 1,
          current: 1
      };
      scope.range = {
          lower: 1,
          upper: 1,
          total: 1
      };

      scope.$watch('maxSize', function(val) {
          if (val) {
              paginationRange = Math.max(scope.maxSize, 10);
              generatePagination();
          }
      });

      scope.$watch(function() {
          if (paginationServiceClone.isRegistered(paginationId)) {
              return (paginationServiceClone.getCollectionLength(paginationId) + 1) * paginationServiceClone.getItemsPerPage(paginationId);
          }
      }, function(length) {
          if (0 < length) {
              generatePagination();
          }
      });

      scope.$watch(function() {
          if (paginationServiceClone.isRegistered(paginationId)) {
              return paginationServiceClone.getItemsPerPage(paginationId);
          }
      }, function(current, previous) {
          if (current !== previous && typeof previous !== 'undefined') {
              goToPage(scope.pagination.current);
          }
      });

      scope.$watch(function() {
          if (paginationServiceClone.isRegistered(paginationId)) {
              return paginationServiceClone.getCurrentPage(paginationId);
          }
      }, function(currentPage, previousPage) {
          if (currentPage !== previousPage) {
              goToPage(currentPage);
          }
      });

      scope.setCurrent = function(num) {
        if(paginationServiceClone.isRegistered(paginationId) && isValidPageNumber(num)){
          num = parseInt(num, 10);
          paginationServiceClone.setCurrentPage(paginationId, num);
        }
      };

      window.resetSelPageFx = function(num){
        scope.setCurrent(1);
        goToPage(1);
        // console.warn($('#pagingCtrlClone li.l-1').addClass("active"));

      }

      /**
       * Custom "track by" function to handle duplicate entries on long lists,
       * ensuring correct highlighting of links.
       * @param id
       * @param index
       * @returns {string}
       */
      scope.tracker = function(id, index) {
          return id + '_' + index;
      };

      function goToPage(num) {
        // console.warn(num);
        if (paginationServiceClone.isRegistered(paginationId) && isValidPageNumber(num) && !scope.loadMore){
          var oldPageNumber = scope.pagination.current;
          scope.pages = generatePagesArrayClone(num, paginationServiceClone.getCollectionLength(paginationId), paginationServiceClone.getItemsPerPage(paginationId), paginationRange);
          scope.pagination.current = num;
          updateRangeValues();
          if(scope.pagination.current == scope.maxPage){
            scope.isAllShow = true;
          }
          if(scope.onPageChange){
            scope.onPageChange({
              newPageNumber: num,
              oldPageNumber: oldPageNumber
            });
          }
        }
      }

      function generatePagination() {
          scope.isAllShow = false;
          if (paginationServiceClone.isRegistered(paginationId)) {
              // console.log(parseInt(paginationServiceClone.getCurrentPage(paginationId)));
              var page = parseInt(paginationServiceClone.getCurrentPage(paginationId)) || 1;
              scope.pages = generatePagesArrayClone(page, paginationServiceClone.getCollectionLength(paginationId), paginationServiceClone.getItemsPerPage(paginationId), paginationRange);
              scope.ec = countEllipsisClone(scope.pages);
              scope.pagination.current = page;
              scope.currentPagination = page;
              scope.pagination.last = scope.pages[scope.pages.length - 1];
              if(scope.pages.length == scope.maxPage){
                  scope.isAllShow = true;
              }
              if (scope.pagination.last < scope.pagination.current) {
                  scope.setCurrent(scope.pagination.last);
              } else {
                  updateRangeValues();
              }
          }
      }

      /**
       * Updates the `scope.range` values to display the current page range, e.g., "showing 21 - 40 of 144 results".
       */
      function updateRangeValues() {
          if (paginationServiceClone.isRegistered(paginationId)) {
              var currentPage = paginationServiceClone.getCurrentPage(paginationId),
                  itemsPerPage = paginationServiceClone.getItemsPerPage(paginationId),
                  totalItems = paginationServiceClone.getCollectionLength(paginationId);

              scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
              scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
              scope.range.total = totalItems;
              scope.ec = countEllipsisClone(scope.pages);
          }
      }

      function isValidPageNumber(num) {
          return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
      }
  }


    function makePageClone(number, isActive, isDisabled) {
      return {
        number: number,
        active: isActive,
        disabled: isDisabled
      };
    }

    function generatePagesArrayClone(currentPage, collectionLength, rowsPerPage, paginationRange){
      // console.log(currentPage, collectionLength, rowsPerPage, paginationRange);
      var pages = [];
      var totalPages = Math.ceil(collectionLength / rowsPerPage);
      var halfWay = Math.ceil(paginationRange / 2);
      var position;

      if (currentPage <= halfWay) {
        position = 'start';
      } else if (totalPages - halfWay < currentPage) {
        position = 'end';
      } else {
        position = 'middle';
      }

      var ellipsesNeeded = paginationRange < totalPages;
      var i = 1;
      // console.warn("Generate", totalPages, paginationRange);
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = calculatePageNumberClone(i, currentPage, paginationRange, totalPages);

        var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
        var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));

        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...');
        } else {
          pages.push(pageNumber);
        }

        i++;
      }

      return pages;
    }

    function calculatePageNumberClone(i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2);
      if (i === paginationRange) {
        return totalPages;
      } else if (i === 1) {
        return i;
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i;
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i;
        } else {
          return i;
        }
      } else {
        return i;
      }
    }
  }

  function itemsPerPageFilterClone($rootScope, paginationServiceClone){
    return function(collection, itemsPerPage, paginationId) {
      // itemsPerPage = 25;
      if (typeof(paginationId) === 'undefined') {
        paginationId = DEFAULT_ID;
      }
      if (!paginationServiceClone.isRegistered(paginationId)) {
        throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
      }

      var end;
      var start;
      var isFirstTime = false;

      if (!paginationServiceClone.isRegistered(paginationId)) {
        if (typeof(itemsPerPage) !== 'undefined') {
          isFirstTime = true;
          paginationServiceClone.registerInstance(paginationId);
        }
      }

      if (paginationServiceClone.isRegistered(paginationId)) {
        if (isFirstTime) {
          paginationServiceClone.setItemsPerPage(paginationId, itemsPerPage);
        }

        var currentPage = paginationServiceClone.getCurrentPage(paginationId);
        if (collection instanceof Array) {
          itemsPerPage = parseInt(itemsPerPage) || 9999999999;
          if (paginationServiceClone.isAsyncMode(paginationId)) {
            start = 0;
          } else {
            if (currentPage > 1 && itemsPerPage !== 0) {
              start = (currentPage - 1) * itemsPerPage;
            } else {
              start = 0;
            }
          }
          end = start + itemsPerPage;
          paginationServiceClone.setItemsPerPage(paginationId, itemsPerPage);

          return collection.slice(start, end);
        } else {
          return collection;
        }
      }
    };
  }

  function remainItemPerPageFilterClone(paginationServiceClone) {
    return function(collection, itemsPerPage, paginationId) {
      if (typeof(paginationId) === 'undefined') {
        paginationId = DEFAULT_ID;
      }

      var end;
      var start;
      var isFirstTime = false;

      if (!paginationServiceClone.isRegistered(paginationId)) {
        if (typeof(itemsPerPage) !== 'undefined') {
          isFirstTime = true;
          paginationServiceClone.registerInstance(paginationId);
        }
      }

      if (paginationServiceClone.isRegistered(paginationId)) {
        if (isFirstTime) {
          paginationServiceClone.setItemsPerPage(paginationId, itemsPerPage);
        }

        var currentPage = paginationServiceClone.getCurrentPage(paginationId);
        if (collection instanceof Array) {
          itemsPerPage = parseInt(itemsPerPage) || 9999999999;
          if (paginationServiceClone.isAsyncMode(paginationId)) {
            start = 0;
          } else {
            start = (currentPage - 1) * itemsPerPage;
          }
          end = collection.length;
          paginationServiceClone.setItemsPerPage(paginationId, itemsPerPage);

          return collection.slice(start, end);
        } else {
          return collection;
        }
      }
    };
  }

  function paginationServiceClone() {
    var instances = {};
    var lastRegisteredId = DEFAULT_ID;

    this.registerInstance = function(instanceId) {
      if (typeof instances[instanceId] === 'undefined') {
        instances[instanceId] = {
          asyncMode: false
        };
        lastRegisteredId = instanceId;
      }
    };

    this.isRegistered = function(instanceId) {
      return typeof instances[instanceId] !== 'undefined';
    };

    this.getLastInstanceId = function() {
      return lastRegisteredId;
    };

    this.setCurrentPageParser = function(instanceId, currentPageParser, scope) {
      instances[instanceId].currentPageParser = currentPageParser;
      instances[instanceId].context = scope;
    };

    this.setCurrentPage = function(instanceId, val) {
      instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
    };

    this.getCurrentPage = function(instanceId) {
      return instances[instanceId].currentPageParser(instances[instanceId].context);
    };

    this.setItemsPerPage = function(instanceId, val) {
      instances[instanceId].itemsPerPage = val;
    };

    this.getItemsPerPage = function(instanceId) {
      return instances[instanceId].itemsPerPage;
    };

    this.setCollectionLength = function(instanceId, val) {
      instances[instanceId].collectionLength = val;
    };

    this.getCollectionLength = function(instanceId) {
      return instances[instanceId].collectionLength;
    };

    this.setAsyncModeTrue = function(instanceId) {
      instances[instanceId].asyncMode = true;
    };

    this.setAsyncModeFalse = function(instanceId) {
      instances[instanceId].asyncMode = false;
    };

    this.isAsyncMode = function(instanceId) {
      return instances[instanceId].asyncMode;
    };
  }

  function paginationTemplateProviderClone() {
    var templatePath = 'angularUtils.directives.dirPaginationClone.template';

    this.setPath = function(path) {
      templatePath = path;
    };

    this.$get = function() {
      return {
        getPath: function() {
          return templatePath;
        }
      };
    };
  }
})();

/**
 * dirPagination - AngularJS module for paginating (almost) anything.
 *
 *
 * Credits
 * =======
 *
 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
 * for the idea on how to dynamically invoke the ng-repeat directive.
 *
 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */

(function(){

  /**
   * Config
   */
  var moduleName = 'angularUtils.directives.dirPagination';
  var DEFAULT_ID = '__default';

  /**
   * Module
   */
  angular.module(moduleName, [])
    .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
    .directive('dirPaginateNoCompile', noCompileDirective)
    .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
    .filter('itemsPerPage', ['$rootScope', 'paginationService', itemsPerPageFilter])
    .filter('remainItemPerPage', ['paginationService', remainItemPerPageFilter])
    .service('paginationService', paginationService)
    .provider('paginationTemplate', paginationTemplateProvider)
    .run(['$templateCache',dirPaginationControlsTemplateInstaller]);
  function dirPaginateDirective($compile, $parse, paginationService){
    return{
      terminal: true,
      multiElement: true,
      priority: 100,
      compile: dirPaginationCompileFn
    };

    function dirPaginationCompileFn(tElement, tAttrs){
      // console.warn("PAGI");
      var expression = tAttrs.dirPaginate;
      // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
      var filterPattern1 = /\|\s*remainItemPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
      if(match[2].match(filterPattern) === null && match[2].match(filterPattern1) === null){
        throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
      }
      if(match[2].match(filterPattern) !== null){
        var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
      }else if(match[2].match(filterPattern1) !== null){
        var itemsPerPageFilterRemoved = match[2].replace(filterPattern1, '');
      }
      // if (match[2].match(filterPattern) === null && match[2].match(filterPattern1) === null) {
      //   throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
      // }
      // var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
      var collectionGetter = $parse(itemsPerPageFilterRemoved);

      addNoCompileAttributes(tElement);

      // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
      // dir-pagination-controls directives that may be looking for this ID.
      var rawId = tAttrs.paginationId || DEFAULT_ID;
      paginationService.registerInstance(rawId);

      return function dirPaginationLinkFn(scope, element, attrs){
        // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
        // potentially register a new ID if it evaluates to a different value than the rawId.
        var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;

        // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
        // Needs more investigation.)
        // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
        // before registering using paginationId
        // paginationService.deregisterInstance(rawId);
        paginationService.registerInstance(paginationId);

        var repeatExpression = getRepeatExpression(expression, paginationId);
        addNgRepeatToElement(element, attrs, repeatExpression);

        removeTemporaryAttributes(element);
        var compiled =  $compile(element);

        var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
        paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

        if (typeof attrs.totalItems !== 'undefined') {
          paginationService.setAsyncModeTrue(paginationId);
          scope.$watch(function() {
            return $parse(attrs.totalItems)(scope);
          }, function (result) {
            if (0 <= result) {
              paginationService.setCollectionLength(paginationId, result);
            }
          });
        } else {
          paginationService.setAsyncModeFalse(paginationId);
          scope.$watchCollection(function() {
              return collectionGetter(scope);
          }, function(collection) {
            if (collection) {
              var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
              paginationService.setCollectionLength(paginationId, collectionLength);
            }
          });
        }

        // Delegate to the link function returned by the new compilation of the ng-repeat
        compiled(scope);

        // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
        // principle is sound)
        // When the scope is destroyed, we make sure to remove the reference to it in paginationService
        // so that it can be properly garbage collected
        // scope.$on('$destroy', function destroyDirPagination() {
        //     paginationService.deregisterInstance(paginationId);
        // });
      };
    }

    /**
     * If a pagination id has been specified, we need to check that it is present as the second argument passed to
     * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
     *
     * @param expression
     * @param paginationId
     * @returns {*}
     */
    function getRepeatExpression(expression, paginationId) {
      var repeatExpression,
          idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

      if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
        repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
      } else {
        repeatExpression = expression;
      }

      return repeatExpression;
    }

    /**
     * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
     * appropriate multi-element ng-repeat to the first and last element in the range.
     * @param element
     * @param attrs
     * @param repeatExpression
     */
    function addNgRepeatToElement(element, attrs, repeatExpression) {
      if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
        // using multiElement mode (dir-paginate-start, dir-paginate-end)
        attrs.$set('ngRepeatStart', repeatExpression);
        element.eq(element.length - 1).attr('ng-repeat-end', true);
      } else {
        attrs.$set('ngRepeat', repeatExpression);
      }
    }

    /**
     * Adds the dir-paginate-no-compile directive to each element in the tElement range.
     * @param tElement
     */
    function addNoCompileAttributes(tElement) {
      angular.forEach(tElement, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).attr('dir-paginate-no-compile', true);
        }
      });
    }

    /**
     * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
     * @param element
     */
    function removeTemporaryAttributes(element) {
      angular.forEach(element, function(el) {
        if (el.nodeType === 1) {
          angular.element(el).removeAttr('dir-paginate-no-compile');
        }
      });
      element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
      element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
    }

    /**
     * Creates a getter function for the current-page attribute, using the expression provided or a default value if
     * no current-page expression was specified.
     *
     * @param scope
     * @param attrs
     * @param paginationId
     * @returns {*}
     */
    function makeCurrentPageGetterFn(scope, attrs, paginationId) {
      var currentPageGetter;
      if (attrs.currentPage) {
        currentPageGetter = $parse(attrs.currentPage);
      } else {
        // If the current-page attribute was not set, we'll make our own.
        // Replace any non-alphanumeric characters which might confuse
        // the $parse service and give unexpected results.
        // See https://github.com/michaelbromley/angularUtils/issues/233
        var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
        scope[defaultCurrentPage] = 1;
        currentPageGetter = $parse(defaultCurrentPage);
      }
      return currentPageGetter;
    }
  }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective(){
      return{
        priority:5000,
        terminal:true
      };
    }

    function dirPaginationControlsTemplateInstaller($templateCache){
      $templateCache.put('angularUtils.directives.dirPagination.template',
      '<ul id="pagingCtrl" class="pagination1 custom-pagination" ng-if="1 < pages.length || !autoHide">\
        <li ng-if="boundaryLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(1)"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>\
        <li ng-if="directionLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)"><i class="fa fa-angle-left" aria-hidden="true"></i></a></li>\
        <li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active:pagination.current == pageNumber, disabled:pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }" class="nonSelectable">\
          <a href="" ng-click="setCurrent(pageNumber)" ng-disabled="loadMore">{{ pageNumber }}</a>\
          <span class="disabled">\
          <a href="">\
            <span ng-if="($last && $index==(pages.length-1) && pagination.current != pagination.last && ec.count<=1 && !ec.secondEll && !isAllShow && !loadMore)">...</span>\
            <span ng-if="($last && loadMore && !isAllShow)">\
            <img src="assets/\images/\loading-xs.gif" class="marB-6">\
            </span>\
          </a>\
          </span>\
        </li>\
        <li ng-if="directionLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)"><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>\
        <li ng-if="boundaryLinks" class="nonSelectable" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>\
        </ul>'
      );
    }

    // function dirPaginationControlsTemplateInstaller($templateCache){
    //   $templateCache.put('angularUtils.directives.dirPagination.template',
    //   '<ul class="pagination1 custom-pagination" ng-if="1 < pages.length || !autoHide">\
    //       <li ng-if="boundaryLinks" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(1)"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a></li>\
    //       <li ng-if="directionLinks" ng-class="{ disabled:pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)"><i class="fa fa-angle-left" aria-hidden="true"></i></a></li>\
    //       <li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active:pagination.current == pageNumber, disabled:pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }">\
    //       <a href="" ng-click="setCurrent(pageNumber)" ng-disabled="loadMore">{{ pageNumber }}</a><span class="disabled"><a href="" ng-class="{\'marL10\':($last && $index==(pages.length-1) && pagination.current != pagination.last && ec.count<=1 &&!ec.secondEll && !isAllShow)}">\
    //       <span ng-if="($last && $index==(pages.length-1) && pagination.current != pagination.last && ec.count<=1 &&!ec.secondEll && !isAllShow && !loadMore)">...</span>\
    //       <span ng-if="($last && loadMore && !isAllShow)" class="padL10">\
    //         <img src="assets/\images/\loading-xs.gif" class="marB-6">\
    //       </span>\
    //       </a></span>\
    //       </li>\
    //       <li ng-if="directionLinks" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)"><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>\
    //       <li ng-if="boundaryLinks" ng-class="{ disabled:pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a></li>\
    //     </ul>'
    //   );
    // }


    // <span ng-if="($last && loadMore && !isAllShow)" class="padL10 valign-middle valign-baseline-middle">\
    function countEllipsis(arr) {
      var count = 0;
      var firstEllipsis = false;
      var secondEllipsis = false;

      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === "...") {
          count++;
          if (!firstEllipsis) {
            firstEllipsis = true;
          }
        } else if (arr[i] === 1 && arr[i + 1] === 2 && arr[i + 2] === 3 && arr[i + 3] === 4 && arr[i + 4] === 5) {
          secondEllipsis = true;
        }
      }

      // If no ellipsis found, set both flags to false
      if (count === 0) {
        firstEllipsis = false;
        secondEllipsis = false;
      }

      return {
        count: count,
        firstEll: firstEllipsis,
        secondEll: secondEllipsis
      };
    }

    // == pageNumber && pageNumber == \'...\') || ( ! autoHide && pages.length === 1 )
    function dirPaginationControlsDirective(paginationService, paginationTemplate){

      var numberRegex = /^\d+$/;

      var DDO = {
        restrict: 'AE',
        scope: {
          maxSize: '=?',
          loadMore: '=?',
          maxPage: '=?',
          onPageChange: '&?',
          paginationId: '=?',
          autoHide: '=?'
        },
        link: dirPaginationControlsLinkFn
      };

      // We need to check the paginationTemplate service to see whether a template path or
      // string has been specified, and add the `template` or `templateUrl` property to
      // the DDO as appropriate. The order of priority to decide which template to use is
      // (highest priority first):
      // 1. paginationTemplate.getString()
      // 2. attrs.templateUrl
      // 3. paginationTemplate.getPath()
      var templateString = paginationTemplate.getString();
      if (templateString !== undefined) {
        DDO.template = templateString;
      } else {
        DDO.templateUrl = function(elem, attrs) {
          return attrs.templateUrl || paginationTemplate.getPath();
        };
      }
      return DDO;

      function dirPaginationControlsLinkFn(scope, element, attrs) {

        // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
        // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
        // no corresponding dir-paginate directive and wrongly throwing an exception.
        var rawId = attrs.paginationId ||  DEFAULT_ID;
        var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;

        if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
          var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
          if (window.console) {
            console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
          }
        }

        if (!scope.maxSize) { scope.maxSize = 9; }//page number generated Defualt 9;
        scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
        scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
        scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

        var paginationRange = Math.max(scope.maxSize, 10);//5 ---- 3
        scope.pages = [];
        scope.pagination = {
          last: 1,
          current: 1
        };
        scope.range = {
          lower: 1,
          upper: 1,
          total: 1
        };

        scope.$watch('maxSize', function(val) {
          // console.log("I am max size @#@#... ");
          if (val) {
            paginationRange = Math.max(scope.maxSize, 10); //5 ---- 3
            generatePagination();
          }
        });

        scope.$watch(function() {
          if (paginationService.isRegistered(paginationId)) {
            return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
          }
        }, function(length) {
          if (0 < length) {
            generatePagination();
          }
        });

        scope.$watch(function() {
          if (paginationService.isRegistered(paginationId)) {
            return (paginationService.getItemsPerPage(paginationId));
          }
        }, function(current, previous) {
          if (current != previous && typeof previous !== 'undefined') {
            goToPage(scope.pagination.current);
          }
        });

        scope.$watch(function() {
          if (paginationService.isRegistered(paginationId)) {
            return paginationService.getCurrentPage(paginationId);
          }
        }, function(currentPage, previousPage) {
          if (currentPage != previousPage) {
            goToPage(currentPage);
          }
        });

        scope.setCurrent = function(num) {
          // console.warn("setCurrent @@@@@@@ ", num);
          // scope.currentPagination = num;
          // console.error("paginationId ", paginationId);
          // console.error("isValidPageNumber(num) ", isValidPageNumber(num));
          if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
            num = parseInt(num, 10);
            // console.error("Hellllo i am in ------ ", num);
            paginationService.setCurrentPage(paginationId, num);
          }
        };

        /**
         * Custom "track by" function which allows for duplicate "..." entries on long lists,
         * yet fixes the problem of wrongly-highlighted links which happens when using
         * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
         * @param id
         * @param index
         * @returns {string}
         */
        scope.tracker = function(id, index) {
          return id + '_' + index;
        };

        function goToPage(num) {
          // console.warn("goToPage ", num);
          if (paginationService.isRegistered(paginationId) && isValidPageNumber(num) && !scope.loadMore) {
            var oldPageNumber = scope.pagination.current;
            scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
            scope.pagination.current = num;
            updateRangeValues();
            if(scope.pagination.current == scope.maxPage){
              scope.isAllShow = true;
            }
            // if a callback has been set, then call it with the page number as the first argument
            // and the previous page number as a second argument
            if (scope.onPageChange) {
              // console.warn("Hello");
              scope.onPageChange({
                newPageNumber : num,
                oldPageNumber : oldPageNumber
              });
            }
          }
        }

        function generatePagination() {
          scope.isAllShow = false;
          if (paginationService.isRegistered(paginationId)) {
            var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
            scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
            scope.ec = countEllipsis(scope.pages);
            scope.pagination.current = page;
            scope.currentPagination = page;
            // console.warn(scope.maxPage);
            scope.pagination.last = scope.pages[scope.pages.length - 1]; // TODO if -1 to -2
            // console.warn("scope.pagination.last ", scope.pagination.last);
            // console.warn("scope.pagination.current ", scope.pagination.current);
            if(scope.pages.length == scope.maxPage){
              scope.isAllShow = true;
            }
            // console.error("ell count",scope.ec, scope.pages, scope.maxPage);
            if (scope.pagination.last < scope.pagination.current) {
              scope.setCurrent(scope.pagination.last);
            } else {
              updateRangeValues();
            }
          }
        }

        /**
         * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
         * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
         */
        function updateRangeValues() {
          if (paginationService.isRegistered(paginationId)) {
            var currentPage = paginationService.getCurrentPage(paginationId),
                itemsPerPage = paginationService.getItemsPerPage(paginationId),
                totalItems = paginationService.getCollectionLength(paginationId);

            scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
            scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
            scope.range.total = totalItems;
            scope.ec = countEllipsis(scope.pages);
          }
        }
        function isValidPageNumber(num) {
          // console.warn(" HI isValidPageNumber ", num, " ____ ", numberRegex.test(num));

          // console.log("(0 < num && num <= scope.pagination.last) ", (0 < num && num <= scope.pagination.last));
          // console.log(numberRegex.test(num) && (0 < num && num <= scope.pagination.last))


          return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
        }
      }

      /**
       * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
       * links used in pagination
       *
       * @param currentPage
       * @param rowsPerPage
       * @param paginationRange
       * @param collectionLength
       * @returns {Array}
       */
      function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
        // console.error(currentPage, collectionLength, rowsPerPage, paginationRange);
        var pages = [];
        var totalPages = Math.ceil(collectionLength / rowsPerPage);
        var halfWay = Math.ceil(paginationRange / 2);
        var position;

        if (currentPage <= halfWay) {
          position = 'start';
        } else if (totalPages - halfWay < currentPage) {
          position = 'end';
        } else {
          position = 'middle';
        }

        // console.error("paginationRange ", paginationRange);
        // console.error("totalPages ", totalPages);
        // console.error("currentPage ", currentPage);
        // console.error("halfWay ", halfWay);
        // console.error("position ", position);

        var ellipsesNeeded = paginationRange < totalPages;
        // console.error("ellipsesNeeded ", ellipsesNeeded);
        var i = 1;
        while(i <= totalPages && i <= paginationRange){
          var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);
          var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
          var closingEllipsesNeeded = (i === paginationRange -1 && (position === 'middle' || position === 'start'));

          // console.error("position ", position);

          // console.warn("ellipsesNeeded ", ellipsesNeeded);
          // console.error("openingEllipsesNeeded ", openingEllipsesNeeded);
          // console.error("closingEllipsesNeeded ", closingEllipsesNeeded);

          // if(ellipsesNeeded && closingEllipsesNeeded){
          //   $(".custom-pagination li:nth-last-child(2)").attr("style","display:none");
          //   setTimeout(function(){
          //     $(".custom-pagination li:nth-last-child(2)").attr("style","display:none");
          //   });
          // }
          // // if(paginationRange > totalPages && currentPage != totalPages){
          // //   pages.push('...');
          // // }
          if(ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)){
            // if(position === 'end'){ //&& closingEllipsesNeeded
            //   $(".custom-pagination li:nth-last-child(2)").attr("style","display:block");
            // }
            pages.push('...');
          } else{
            pages.push(pageNumber);

            // console.warn("pageNumber ", pageNumber);
            // console.warn("currentPage ", currentPage);
            // console.warn("totalPages ", totalPages);

            // if(pageNumber >= totalPages && currentPage != totalPages){
            //   pages.push('...');
            // }
          }
          i++;
        }
        // console.warn("pages ", pages);
        return pages;
      }

      /**
       * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
       *
       * @param i
       * @param currentPage
       * @param paginationRange
       * @param totalPages
       * @returns {*}
       */
      function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
        // console.warn("calculatePageNumber ", " i ", i, " currentPage ", currentPage, " paginationRange ", paginationRange, " totalPages ", totalPages);
        var halfWay = Math.ceil(paginationRange/2);
        if (i === paginationRange) { //TODO 15052024 9:20PM
          return totalPages;
        } else if (i === 1) {
          return i;
        } else if (paginationRange < totalPages) {
          if (totalPages - halfWay < currentPage) {
            return totalPages - paginationRange + i;
          } else if (halfWay < currentPage) {
            return currentPage - halfWay + i;
          } else {
            return i;
          }
        } else {
          return i;
        }
      }
    }

  /**
   * This filter slices the collection into pages based on the current page number and number of items per page.
   * @param paginationService
   * @returns {Function}
   */
  function itemsPerPageFilter($rootScope, paginationService) {

    return function(collection, itemsPerPage, paginationId) {
      if (typeof (paginationId) === 'undefined') {
        paginationId = DEFAULT_ID;
      }
      if (!paginationService.isRegistered(paginationId)) {
        throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
      }
      var end;
      var start;
      if (angular.isObject(collection)) {
        itemsPerPage = parseInt(itemsPerPage) || 9999999999;
        if (paginationService.isAsyncMode(paginationId)) {
          start = 0;
        } else {
          start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
        }
        end = start + itemsPerPage;
        paginationService.setItemsPerPage(paginationId, itemsPerPage);

        if (collection instanceof Array) {
          // the array just needs to be sliced
          // var finalData = collection.slice(start, end)
          // $scope.remainingItems = finalData.slice(50);
          // console.log("finalData",finalData);
          // return finalData;
          $rootScope.$broadcast('itemsPerPage', {'allData':collection,'curData':collection.slice(start, end)});
          return collection.slice(start, end);
        } else {
          // in the case of an object, we need to get an array of keys, slice that, then map back to
          // the original object.
          var slicedObject = {};
          angular.forEach(keys(collection).slice(start, end), function(key) {
            slicedObject[key] = collection[key];
          });
          return slicedObject;
        }
      } else {
        return collection;
      }
    };
  }

  function remainItemPerPageFilter(paginationService) {

    return function(collection, itemsPerPage, paginationId) {
      if (typeof (paginationId) === 'undefined') {
        paginationId = DEFAULT_ID;
      }
      if (!paginationService.isRegistered(paginationId)) {
        throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
      }
      var end;
      var start;
      if (angular.isObject(collection)) {
        itemsPerPage = parseInt(itemsPerPage) || 9999999999;
        if (paginationService.isAsyncMode(paginationId)) {
          start = 0;
        } else {
          start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
        }
        end = start + itemsPerPage;
        paginationService.setItemsPerPage(paginationId, itemsPerPage);

        if (collection instanceof Array) {
          // the array just needs to be sliced
          var finalData = collection.slice(start, end)
          // this return remiaing data after length of 50
          return finalData.slice(50);
        } else {
          // in the case of an object, we need to get an array of keys, slice that, then map back to
          // the original object.
          var slicedObject = {};
          angular.forEach(keys(collection).slice(start, end), function(key) {
            slicedObject[key] = collection[key];
          });
          return slicedObject;
        }
      } else {
        return collection;
      }
    };
  }

  /**
   * Shim for the Object.keys() method which does not exist in IE < 9
   * @param obj
   * @returns {Array}
   */
  function keys(obj) {
    if (!Object.keys) {
      var objKeys = [];
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          objKeys.push(i);
        }
      }
      return objKeys;
    } else {
      return Object.keys(obj);
    }
  }

  /**
   * This service allows the various parts of the module to communicate and stay in sync.
   */
  function paginationService(){

    // console.warn("paginationService ");

    var instances = {};
    var lastRegisteredInstance;

    this.registerInstance = function(instanceId) {
      if (typeof instances[instanceId] === 'undefined') {
        instances[instanceId] = {
          asyncMode: false
        };
        lastRegisteredInstance = instanceId;
      }
    };

    this.deregisterInstance = function(instanceId) {
      delete instances[instanceId];
    };

    this.isRegistered = function(instanceId) {
      return (typeof instances[instanceId] !== 'undefined');
    };

    this.getLastInstanceId = function() {
      return lastRegisteredInstance;
    };

    this.setCurrentPageParser = function(instanceId, val, scope) {
      instances[instanceId].currentPageParser = val;
      instances[instanceId].context = scope;
    };
    this.setCurrentPage = function(instanceId, val) {
      instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
    };
    this.getCurrentPage = function(instanceId) {
      var parser = instances[instanceId].currentPageParser;
      return parser ? parser(instances[instanceId].context) : 1;
    };

    this.setItemsPerPage = function(instanceId, val) {
      instances[instanceId].itemsPerPage = val;
    };
    this.getItemsPerPage = function(instanceId) {
      return instances[instanceId].itemsPerPage;
    };

    this.setCollectionLength = function(instanceId, val) {
      instances[instanceId].collectionLength = val;
    };
    this.getCollectionLength = function(instanceId) {
      return instances[instanceId].collectionLength;
    };

    this.setAsyncModeTrue = function(instanceId) {
      instances[instanceId].asyncMode = true;
    };

    this.setAsyncModeFalse = function(instanceId) {
      instances[instanceId].asyncMode = false;
    };

    this.isAsyncMode = function(instanceId) {
      return instances[instanceId].asyncMode;
    };
  }

  /**
   * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
   */
  function paginationTemplateProvider() {

    var templatePath = 'angularUtils.directives.dirPagination.template';
    var templateString;

    /**
     * Set a templateUrl to be used by all instances of <dir-pagination-controls>
     * @param {String} path
     */
    this.setPath = function(path) {
        templatePath = path;
    };

    /**
     * Set a string of HTML to be used as a template by all instances
     * of <dir-pagination-controls>. If both a path *and* a string have been set,
     * the string takes precedence.
     * @param {String} str
     */
    this.setString = function(str) {
      templateString = str;
    };

    this.$get = function() {
      return {
        getPath: function() {
          return templatePath;
        },
        getString: function() {
          return templateString;
        }
      };
    };
  }
})();

/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.0.8, Wed Jul 10 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */

(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
    ? define(factory)
    : ((global =
        typeof globalThis !== "undefined" ? globalThis : global || self),
      (global.Dexie = factory()));
})(this, function () {
  "use strict";

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  var extendStatics = function (d, b) {
    extendStatics =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (d, b) {
          d.__proto__ = b;
        }) ||
      function (d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      };
    return extendStatics(d, b);
  };
  function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError(
        "Class extends value " + String(b) + " is not a constructor or null"
      );
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype =
      b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
  }
  var __assign = function () {
    __assign =
      Object.assign ||
      function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from));
  }

  var _global =
    typeof globalThis !== "undefined"
      ? globalThis
      : typeof self !== "undefined"
      ? self
      : typeof window !== "undefined"
      ? window
      : global;

  var keys = Object.keys;
  var isArray = Array.isArray;
  if (typeof Promise !== "undefined" && !_global.Promise) {
    _global.Promise = Promise;
  }
  function extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    keys(extension).forEach(function (key) {
      obj[key] = extension[key];
    });
    return obj;
  }
  var getProto = Object.getPrototypeOf;
  var _hasOwn = {}.hasOwnProperty;
  function hasOwn(obj, prop) {
    return _hasOwn.call(obj, prop);
  }
  function props(proto, extension) {
    if (typeof extension === "function") extension = extension(getProto(proto));
    (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(
      extension
    ).forEach(function (key) {
      setProp(proto, key, extension[key]);
    });
  }
  var defineProperty = Object.defineProperty;
  function setProp(obj, prop, functionOrGetSet, options) {
    defineProperty(
      obj,
      prop,
      extend(
        functionOrGetSet &&
          hasOwn(functionOrGetSet, "get") &&
          typeof functionOrGetSet.get === "function"
          ? {
              get: functionOrGetSet.get,
              set: functionOrGetSet.set,
              configurable: true,
            }
          : { value: functionOrGetSet, configurable: true, writable: true },
        options
      )
    );
  }
  function derive(Child) {
    return {
      from: function (Parent) {
        Child.prototype = Object.create(Parent.prototype);
        setProp(Child.prototype, "constructor", Child);
        return {
          extend: props.bind(null, Child.prototype),
        };
      },
    };
  }
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  function getPropertyDescriptor(obj, prop) {
    var pd = getOwnPropertyDescriptor(obj, prop);
    var proto;
    return (
      pd || ((proto = getProto(obj)) && getPropertyDescriptor(proto, prop))
    );
  }
  var _slice = [].slice;
  function slice(args, start, end) {
    return _slice.call(args, start, end);
  }
  function override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
  }
  function assert(b) {
    if (!b) throw new Error("Assertion Failed");
  }
  function asap$1(fn) {
    if (_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
  }
  function arrayToObject(array, extractor) {
    return array.reduce(function (result, item, i) {
      var nameAndValue = extractor(item, i);
      if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
      return result;
    }, {});
  }
  function getByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string" && hasOwn(obj, keyPath))
      return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
      var rv = [];
      for (var i = 0, l = keyPath.length; i < l; ++i) {
        var val = getByKeyPath(obj, keyPath[i]);
        rv.push(val);
      }
      return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
      var innerObj = obj[keyPath.substr(0, period)];
      return innerObj == null
        ? undefined
        : getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
  }
  function setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
      assert(typeof value !== "string" && "length" in value);
      for (var i = 0, l = keyPath.length; i < l; ++i) {
        setByKeyPath(obj, keyPath[i], value[i]);
      }
    } else {
      var period = keyPath.indexOf(".");
      if (period !== -1) {
        var currentKeyPath = keyPath.substr(0, period);
        var remainingKeyPath = keyPath.substr(period + 1);
        if (remainingKeyPath === "")
          if (value === undefined) {
            if (isArray(obj) && !isNaN(parseInt(currentKeyPath)))
              obj.splice(currentKeyPath, 1);
            else delete obj[currentKeyPath];
          } else obj[currentKeyPath] = value;
        else {
          var innerObj = obj[currentKeyPath];
          if (!innerObj || !hasOwn(obj, currentKeyPath))
            innerObj = obj[currentKeyPath] = {};
          setByKeyPath(innerObj, remainingKeyPath, value);
        }
      } else {
        if (value === undefined) {
          if (isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
          else delete obj[keyPath];
        } else obj[keyPath] = value;
      }
    }
  }
  function delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath)
      [].map.call(keyPath, function (kp) {
        setByKeyPath(obj, kp, undefined);
      });
  }
  function shallowClone(obj) {
    var rv = {};
    for (var m in obj) {
      if (hasOwn(obj, m)) rv[m] = obj[m];
    }
    return rv;
  }
  var concat = [].concat;
  function flatten(a) {
    return concat.apply([], a);
  }
  var intrinsicTypeNames =
    "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey"
      .split(",")
      .concat(
        flatten(
          [8, 16, 32, 64].map(function (num) {
            return ["Int", "Uint", "Float"].map(function (t) {
              return t + num + "Array";
            });
          })
        )
      )
      .filter(function (t) {
        return _global[t];
      });
  var intrinsicTypes = new Set(
    intrinsicTypeNames.map(function (t) {
      return _global[t];
    })
  );
  function cloneSimpleObjectTree(o) {
    var rv = {};
    for (var k in o)
      if (hasOwn(o, k)) {
        var v = o[k];
        rv[k] =
          !v || typeof v !== "object" || intrinsicTypes.has(v.constructor)
            ? v
            : cloneSimpleObjectTree(v);
      }
    return rv;
  }
  function objectIsEmpty(o) {
    for (var k in o) if (hasOwn(o, k)) return false;
    return true;
  }
  var circularRefs = null;
  function deepClone(any) {
    circularRefs = new WeakMap();
    var rv = innerDeepClone(any);
    circularRefs = null;
    return rv;
  }
  function innerDeepClone(x) {
    if (!x || typeof x !== "object") return x;
    var rv = circularRefs.get(x);
    if (rv) return rv;
    if (isArray(x)) {
      rv = [];
      circularRefs.set(x, rv);
      for (var i = 0, l = x.length; i < l; ++i) {
        rv.push(innerDeepClone(x[i]));
      }
    } else if (intrinsicTypes.has(x.constructor)) {
      rv = x;
    } else {
      var proto = getProto(x);
      rv = proto === Object.prototype ? {} : Object.create(proto);
      circularRefs.set(x, rv);
      for (var prop in x) {
        if (hasOwn(x, prop)) {
          rv[prop] = innerDeepClone(x[prop]);
        }
      }
    }
    return rv;
  }
  var toString = {}.toString;
  function toStringTag(o) {
    return toString.call(o).slice(8, -1);
  }
  var iteratorSymbol =
    typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
  var getIteratorOf =
    typeof iteratorSymbol === "symbol"
      ? function (x) {
          var i;
          return x != null && (i = x[iteratorSymbol]) && i.apply(x);
        }
      : function () {
          return null;
        };
  function delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
  }
  var NO_CHAR_ARRAY = {};
  function getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
      if (isArray(arrayLike)) return arrayLike.slice();
      if (this === NO_CHAR_ARRAY && typeof arrayLike === "string")
        return [arrayLike];
      if ((it = getIteratorOf(arrayLike))) {
        a = [];
        while (((x = it.next()), !x.done)) a.push(x.value);
        return a;
      }
      if (arrayLike == null) return [arrayLike];
      i = arrayLike.length;
      if (typeof i === "number") {
        a = new Array(i);
        while (i--) a[i] = arrayLike[i];
        return a;
      }
      return [arrayLike];
    }
    i = arguments.length;
    a = new Array(i);
    while (i--) a[i] = arguments[i];
    return a;
  }
  var isAsyncFunction =
    typeof Symbol !== "undefined"
      ? function (fn) {
          return fn[Symbol.toStringTag] === "AsyncFunction";
        }
      : function () {
          return false;
        };

  var dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait",
  ];
  var idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone",
  ];
  var errorList = dexieErrorNames.concat(idbDomErrorNames);
  var defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI:
      "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb",
  };
  function DexieError(name, msg) {
    this.name = name;
    this.message = msg;
  }
  derive(DexieError)
    .from(Error)
    .extend({
      toString: function () {
        return this.name + ": " + this.message;
      },
    });
  function getMultiErrorMessage(msg, failures) {
    return (
      msg +
      ". Errors: " +
      Object.keys(failures)
        .map(function (key) {
          return failures[key].toString();
        })
        .filter(function (v, i, s) {
          return s.indexOf(v) === i;
        })
        .join("\n")
    );
  }
  function ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = getMultiErrorMessage(msg, failures);
  }
  derive(ModifyError).from(DexieError);
  function BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function (pos) {
      return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = getMultiErrorMessage(msg, this.failures);
  }
  derive(BulkError).from(DexieError);
  var errnames = errorList.reduce(function (obj, name) {
    return (obj[name] = name + "Error"), obj;
  }, {});
  var BaseException = DexieError;
  var exceptions = errorList.reduce(function (obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
      this.name = fullName;
      if (!msgOrInner) {
        this.message = defaultTexts[name] || fullName;
        this.inner = null;
      } else if (typeof msgOrInner === "string") {
        this.message = ""
          .concat(msgOrInner)
          .concat(!inner ? "" : "\n " + inner);
        this.inner = inner || null;
      } else if (typeof msgOrInner === "object") {
        this.message = ""
          .concat(msgOrInner.name, " ")
          .concat(msgOrInner.message);
        this.inner = msgOrInner;
      }
    }
    derive(DexieError).from(BaseException);
    obj[name] = DexieError;
    return obj;
  }, {});
  exceptions.Syntax = SyntaxError;
  exceptions.Type = TypeError;
  exceptions.Range = RangeError;
  var exceptionMap = idbDomErrorNames.reduce(function (obj, name) {
    obj[name + "Error"] = exceptions[name];
    return obj;
  }, {});
  function mapError(domError, message) {
    if (
      !domError ||
      domError instanceof DexieError ||
      domError instanceof TypeError ||
      domError instanceof SyntaxError ||
      !domError.name ||
      !exceptionMap[domError.name]
    )
      return domError;
    var rv = new exceptionMap[domError.name](
      message || domError.message,
      domError
    );
    if ("stack" in domError) {
      setProp(rv, "stack", {
        get: function () {
          return this.inner.stack;
        },
      });
    }
    return rv;
  }
  var fullNameExceptions = errorList.reduce(function (obj, name) {
    if (["Syntax", "Type", "Range"].indexOf(name) === -1)
      obj[name + "Error"] = exceptions[name];
    return obj;
  }, {});
  fullNameExceptions.ModifyError = ModifyError;
  fullNameExceptions.DexieError = DexieError;
  fullNameExceptions.BulkError = BulkError;

  function nop() {}
  function mirror(val) {
    return val;
  }
  function pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === mirror) return f2;
    return function (val) {
      return f2(f1(val));
    };
  }
  function callBoth(on1, on2) {
    return function () {
      on1.apply(this, arguments);
      on2.apply(this, arguments);
    };
  }
  function hookCreatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function () {
      var res = f1.apply(this, arguments);
      if (res !== undefined) arguments[0] = res;
      var onsuccess = this.onsuccess,
        onerror = this.onerror;
      this.onsuccess = null;
      this.onerror = null;
      var res2 = f2.apply(this, arguments);
      if (onsuccess)
        this.onsuccess = this.onsuccess
          ? callBoth(onsuccess, this.onsuccess)
          : onsuccess;
      if (onerror)
        this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
      return res2 !== undefined ? res2 : res;
    };
  }
  function hookDeletingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function () {
      f1.apply(this, arguments);
      var onsuccess = this.onsuccess,
        onerror = this.onerror;
      this.onsuccess = this.onerror = null;
      f2.apply(this, arguments);
      if (onsuccess)
        this.onsuccess = this.onsuccess
          ? callBoth(onsuccess, this.onsuccess)
          : onsuccess;
      if (onerror)
        this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    };
  }
  function hookUpdatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function (modifications) {
      var res = f1.apply(this, arguments);
      extend(modifications, res);
      var onsuccess = this.onsuccess,
        onerror = this.onerror;
      this.onsuccess = null;
      this.onerror = null;
      var res2 = f2.apply(this, arguments);
      if (onsuccess)
        this.onsuccess = this.onsuccess
          ? callBoth(onsuccess, this.onsuccess)
          : onsuccess;
      if (onerror)
        this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
      return res === undefined
        ? res2 === undefined
          ? undefined
          : res2
        : extend(res, res2);
    };
  }
  function reverseStoppableEventChain(f1, f2) {
    if (f1 === nop) return f2;
    return function () {
      if (f2.apply(this, arguments) === false) return false;
      return f1.apply(this, arguments);
    };
  }
  function promisableChain(f1, f2) {
    if (f1 === nop) return f2;
    return function () {
      var res = f1.apply(this, arguments);
      if (res && typeof res.then === "function") {
        var thiz = this,
          i = arguments.length,
          args = new Array(i);
        while (i--) args[i] = arguments[i];
        return res.then(function () {
          return f2.apply(thiz, args);
        });
      }
      return f2.apply(this, arguments);
    };
  }

  var debug =
    typeof location !== "undefined" &&
    /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
  function setDebug(value, filter) {
    debug = value;
  }

  var INTERNAL = {};
  var ZONE_ECHO_LIMIT = 100,
    _a$1 =
      typeof Promise === "undefined"
        ? []
        : (function () {
            var globalP = Promise.resolve();
            if (typeof crypto === "undefined" || !crypto.subtle)
              return [globalP, getProto(globalP), globalP];
            var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
            return [nativeP, getProto(nativeP), globalP];
          })(),
    resolvedNativePromise = _a$1[0],
    nativePromiseProto = _a$1[1],
    resolvedGlobalPromise = _a$1[2],
    nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
  var NativePromise =
    resolvedNativePromise && resolvedNativePromise.constructor;
  var patchGlobalPromise = !!resolvedGlobalPromise;
  function schedulePhysicalTick() {
    queueMicrotask(physicalTick);
  }
  var asap = function (callback, args) {
    microtickQueue.push([callback, args]);
    if (needsNewPhysicalTick) {
      schedulePhysicalTick();
      needsNewPhysicalTick = false;
    }
  };
  var isOutsideMicroTick = true,
    needsNewPhysicalTick = true,
    unhandledErrors = [],
    rejectingErrors = [],
    rejectionMapper = mirror;
  var globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: nop,
    pgp: false,
    env: {},
    finalize: nop,
  };
  var PSD = globalPSD;
  var microtickQueue = [];
  var numScheduledCalls = 0;
  var tickFinalizers = [];
  function DexiePromise(fn) {
    if (typeof this !== "object")
      throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this._lib = false;
    var psd = (this._PSD = PSD);
    if (typeof fn !== "function") {
      if (fn !== INTERNAL) throw new TypeError("Not a function");
      this._state = arguments[1];
      this._value = arguments[2];
      if (this._state === false) handleRejection(this, this._value);
      return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    executePromiseTask(this, fn);
  }
  var thenProp = {
    get: function () {
      var psd = PSD,
        microTaskId = totalEchoes;
      function then(onFulfilled, onRejected) {
        var _this = this;
        var possibleAwait =
          !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
        var cleanup = possibleAwait && !decrementExpectedAwaits();
        var rv = new DexiePromise(function (resolve, reject) {
          propagateToListener(
            _this,
            new Listener(
              nativeAwaitCompatibleWrap(
                onFulfilled,
                psd,
                possibleAwait,
                cleanup
              ),
              nativeAwaitCompatibleWrap(
                onRejected,
                psd,
                possibleAwait,
                cleanup
              ),
              resolve,
              reject,
              psd
            )
          );
        });
        if (this._consoleTask) rv._consoleTask = this._consoleTask;
        return rv;
      }
      then.prototype = INTERNAL;
      return then;
    },
    set: function (value) {
      setProp(
        this,
        "then",
        value && value.prototype === INTERNAL
          ? thenProp
          : {
              get: function () {
                return value;
              },
              set: thenProp.set,
            }
      );
    },
  };
  props(DexiePromise.prototype, {
    then: thenProp,
    _then: function (onFulfilled, onRejected) {
      propagateToListener(
        this,
        new Listener(null, null, onFulfilled, onRejected, PSD)
      );
    },
    catch: function (onRejected) {
      if (arguments.length === 1) return this.then(null, onRejected);
      var type = arguments[0],
        handler = arguments[1];
      return typeof type === "function"
        ? this.then(null, function (err) {
            return err instanceof type ? handler(err) : PromiseReject(err);
          })
        : this.then(null, function (err) {
            return err && err.name === type ? handler(err) : PromiseReject(err);
          });
    },
    finally: function (onFinally) {
      return this.then(
        function (value) {
          return DexiePromise.resolve(onFinally()).then(function () {
            return value;
          });
        },
        function (err) {
          return DexiePromise.resolve(onFinally()).then(function () {
            return PromiseReject(err);
          });
        }
      );
    },
    timeout: function (ms, msg) {
      var _this = this;
      return ms < Infinity
        ? new DexiePromise(function (resolve, reject) {
            var handle = setTimeout(function () {
              return reject(new exceptions.Timeout(msg));
            }, ms);
            _this
              .then(resolve, reject)
              .finally(clearTimeout.bind(null, handle));
          })
        : this;
    },
  });
  if (typeof Symbol !== "undefined" && Symbol.toStringTag)
    setProp(DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
  globalPSD.env = snapShot();
  function Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
  }
  props(DexiePromise, {
    all: function () {
      var values = getArrayOf
        .apply(null, arguments)
        .map(onPossibleParallellAsync);
      return new DexiePromise(function (resolve, reject) {
        if (values.length === 0) resolve([]);
        var remaining = values.length;
        values.forEach(function (a, i) {
          return DexiePromise.resolve(a).then(function (x) {
            values[i] = x;
            if (!--remaining) resolve(values);
          }, reject);
        });
      });
    },
    resolve: function (value) {
      if (value instanceof DexiePromise) return value;
      if (value && typeof value.then === "function")
        return new DexiePromise(function (resolve, reject) {
          value.then(resolve, reject);
        });
      var rv = new DexiePromise(INTERNAL, true, value);
      return rv;
    },
    reject: PromiseReject,
    race: function () {
      var values = getArrayOf
        .apply(null, arguments)
        .map(onPossibleParallellAsync);
      return new DexiePromise(function (resolve, reject) {
        values.map(function (value) {
          return DexiePromise.resolve(value).then(resolve, reject);
        });
      });
    },
    PSD: {
      get: function () {
        return PSD;
      },
      set: function (value) {
        return (PSD = value);
      },
    },
    totalEchoes: {
      get: function () {
        return totalEchoes;
      },
    },
    newPSD: newScope,
    usePSD: usePSD,
    scheduler: {
      get: function () {
        return asap;
      },
      set: function (value) {
        asap = value;
      },
    },
    rejectionMapper: {
      get: function () {
        return rejectionMapper;
      },
      set: function (value) {
        rejectionMapper = value;
      },
    },
    follow: function (fn, zoneProps) {
      return new DexiePromise(function (resolve, reject) {
        return newScope(
          function (resolve, reject) {
            var psd = PSD;
            psd.unhandleds = [];
            psd.onunhandled = reject;
            psd.finalize = callBoth(function () {
              var _this = this;
              run_at_end_of_this_or_next_physical_tick(function () {
                _this.unhandleds.length === 0
                  ? resolve()
                  : reject(_this.unhandleds[0]);
              });
            }, psd.finalize);
            fn();
          },
          zoneProps,
          resolve,
          reject
        );
      });
    },
  });
  if (NativePromise) {
    if (NativePromise.allSettled)
      setProp(DexiePromise, "allSettled", function () {
        var possiblePromises = getArrayOf
          .apply(null, arguments)
          .map(onPossibleParallellAsync);
        return new DexiePromise(function (resolve) {
          if (possiblePromises.length === 0) resolve([]);
          var remaining = possiblePromises.length;
          var results = new Array(remaining);
          possiblePromises.forEach(function (p, i) {
            return DexiePromise.resolve(p)
              .then(
                function (value) {
                  return (results[i] = { status: "fulfilled", value: value });
                },
                function (reason) {
                  return (results[i] = { status: "rejected", reason: reason });
                }
              )
              .then(function () {
                return --remaining || resolve(results);
              });
          });
        });
      });
    if (NativePromise.any && typeof AggregateError !== "undefined")
      setProp(DexiePromise, "any", function () {
        var possiblePromises = getArrayOf
          .apply(null, arguments)
          .map(onPossibleParallellAsync);
        return new DexiePromise(function (resolve, reject) {
          if (possiblePromises.length === 0) reject(new AggregateError([]));
          var remaining = possiblePromises.length;
          var failures = new Array(remaining);
          possiblePromises.forEach(function (p, i) {
            return DexiePromise.resolve(p).then(
              function (value) {
                return resolve(value);
              },
              function (failure) {
                failures[i] = failure;
                if (!--remaining) reject(new AggregateError(failures));
              }
            );
          });
        });
      });
  }
  function executePromiseTask(promise, fn) {
    try {
      fn(function (value) {
        if (promise._state !== null) return;
        if (value === promise)
          throw new TypeError("A promise cannot be resolved with itself.");
        var shouldExecuteTick = promise._lib && beginMicroTickScope();
        if (value && typeof value.then === "function") {
          executePromiseTask(promise, function (resolve, reject) {
            value instanceof DexiePromise
              ? value._then(resolve, reject)
              : value.then(resolve, reject);
          });
        } else {
          promise._state = true;
          promise._value = value;
          propagateAllListeners(promise);
        }
        if (shouldExecuteTick) endMicroTickScope();
      }, handleRejection.bind(null, promise));
    } catch (ex) {
      handleRejection(promise, ex);
    }
  }
  function handleRejection(promise, reason) {
    rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && beginMicroTickScope();
    reason = rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    addPossiblyUnhandledError(promise);
    propagateAllListeners(promise);
    if (shouldExecuteTick) endMicroTickScope();
  }
  function propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for (var i = 0, len = listeners.length; i < len; ++i) {
      propagateToListener(promise, listeners[i]);
    }
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if (numScheduledCalls === 0) {
      ++numScheduledCalls;
      asap(function () {
        if (--numScheduledCalls === 0) finalizePhysicalTick();
      }, []);
    }
  }
  function propagateToListener(promise, listener) {
    if (promise._state === null) {
      promise._listeners.push(listener);
      return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) {
      return (promise._state ? listener.resolve : listener.reject)(
        promise._value
      );
    }
    ++listener.psd.ref;
    ++numScheduledCalls;
    asap(callListener, [cb, promise, listener]);
  }
  function callListener(cb, promise, listener) {
    try {
      var ret,
        value = promise._value;
      if (!promise._state && rejectingErrors.length) rejectingErrors = [];
      ret =
        debug && promise._consoleTask
          ? promise._consoleTask.run(function () {
              return cb(value);
            })
          : cb(value);
      if (!promise._state && rejectingErrors.indexOf(value) === -1) {
        markErrorAsHandled(promise);
      }
      listener.resolve(ret);
    } catch (e) {
      listener.reject(e);
    } finally {
      if (--numScheduledCalls === 0) finalizePhysicalTick();
      --listener.psd.ref || listener.psd.finalize();
    }
  }
  function physicalTick() {
    usePSD(globalPSD, function () {
      beginMicroTickScope() && endMicroTickScope();
    });
  }
  function beginMicroTickScope() {
    var wasRootExec = isOutsideMicroTick;
    isOutsideMicroTick = false;
    needsNewPhysicalTick = false;
    return wasRootExec;
  }
  function endMicroTickScope() {
    var callbacks, i, l;
    do {
      while (microtickQueue.length > 0) {
        callbacks = microtickQueue;
        microtickQueue = [];
        l = callbacks.length;
        for (i = 0; i < l; ++i) {
          var item = callbacks[i];
          item[0].apply(null, item[1]);
        }
      }
    } while (microtickQueue.length > 0);
    isOutsideMicroTick = true;
    needsNewPhysicalTick = true;
  }
  function finalizePhysicalTick() {
    var unhandledErrs = unhandledErrors;
    unhandledErrors = [];
    unhandledErrs.forEach(function (p) {
      p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = tickFinalizers.slice(0);
    var i = finalizers.length;
    while (i) finalizers[--i]();
  }
  function run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
      fn();
      tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
    }
    tickFinalizers.push(finalizer);
    ++numScheduledCalls;
    asap(function () {
      if (--numScheduledCalls === 0) finalizePhysicalTick();
    }, []);
  }
  function addPossiblyUnhandledError(promise) {
    if (
      !unhandledErrors.some(function (p) {
        return p._value === promise._value;
      })
    )
      unhandledErrors.push(promise);
  }
  function markErrorAsHandled(promise) {
    var i = unhandledErrors.length;
    while (i)
      if (unhandledErrors[--i]._value === promise._value) {
        unhandledErrors.splice(i, 1);
        return;
      }
  }
  function PromiseReject(reason) {
    return new DexiePromise(INTERNAL, false, reason);
  }
  function wrap(fn, errorCatcher) {
    var psd = PSD;
    return function () {
      var wasRootExec = beginMicroTickScope(),
        outerScope = PSD;
      try {
        switchToZone(psd, true);
        return fn.apply(this, arguments);
      } catch (e) {
        errorCatcher && errorCatcher(e);
      } finally {
        switchToZone(outerScope, false);
        if (wasRootExec) endMicroTickScope();
      }
    };
  }
  var task = { awaits: 0, echoes: 0, id: 0 };
  var taskCounter = 0;
  var zoneStack = [];
  var zoneEchoes = 0;
  var totalEchoes = 0;
  var zone_id_counter = 0;
  function newScope(fn, props, a1, a2) {
    var parent = PSD,
      psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++zone_id_counter;
    globalPSD.env;
    psd.env = patchGlobalPromise
      ? {
          Promise: DexiePromise,
          PromiseProp: {
            value: DexiePromise,
            configurable: true,
            writable: true,
          },
          all: DexiePromise.all,
          race: DexiePromise.race,
          allSettled: DexiePromise.allSettled,
          any: DexiePromise.any,
          resolve: DexiePromise.resolve,
          reject: DexiePromise.reject,
        }
      : {};
    if (props) extend(psd, props);
    ++parent.ref;
    psd.finalize = function () {
      --this.parent.ref || this.parent.finalize();
    };
    var rv = usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
  }
  function incrementExpectedAwaits() {
    if (!task.id) task.id = ++taskCounter;
    ++task.awaits;
    task.echoes += ZONE_ECHO_LIMIT;
    return task.id;
  }
  function decrementExpectedAwaits() {
    if (!task.awaits) return false;
    if (--task.awaits === 0) task.id = 0;
    task.echoes = task.awaits * ZONE_ECHO_LIMIT;
    return true;
  }
  if (("" + nativePromiseThen).indexOf("[native code]") === -1) {
    incrementExpectedAwaits = decrementExpectedAwaits = nop;
  }
  function onPossibleParallellAsync(possiblePromise) {
    if (
      task.echoes &&
      possiblePromise &&
      possiblePromise.constructor === NativePromise
    ) {
      incrementExpectedAwaits();
      return possiblePromise.then(
        function (x) {
          decrementExpectedAwaits();
          return x;
        },
        function (e) {
          decrementExpectedAwaits();
          return rejection(e);
        }
      );
    }
    return possiblePromise;
  }
  function zoneEnterEcho(targetZone) {
    ++totalEchoes;
    if (!task.echoes || --task.echoes === 0) {
      task.echoes = task.awaits = task.id = 0;
    }
    zoneStack.push(PSD);
    switchToZone(targetZone, true);
  }
  function zoneLeaveEcho() {
    var zone = zoneStack[zoneStack.length - 1];
    zoneStack.pop();
    switchToZone(zone, false);
  }
  function switchToZone(targetZone, bEnteringZone) {
    var currentZone = PSD;
    if (
      bEnteringZone
        ? task.echoes && (!zoneEchoes++ || targetZone !== PSD)
        : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)
    ) {
      queueMicrotask(
        bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho
      );
    }
    if (targetZone === PSD) return;
    PSD = targetZone;
    if (currentZone === globalPSD) globalPSD.env = snapShot();
    if (patchGlobalPromise) {
      var GlobalPromise = globalPSD.env.Promise;
      var targetEnv = targetZone.env;
      if (currentZone.global || targetZone.global) {
        Object.defineProperty(_global, "Promise", targetEnv.PromiseProp);
        GlobalPromise.all = targetEnv.all;
        GlobalPromise.race = targetEnv.race;
        GlobalPromise.resolve = targetEnv.resolve;
        GlobalPromise.reject = targetEnv.reject;
        if (targetEnv.allSettled)
          GlobalPromise.allSettled = targetEnv.allSettled;
        if (targetEnv.any) GlobalPromise.any = targetEnv.any;
      }
    }
  }
  function snapShot() {
    var GlobalPromise = _global.Promise;
    return patchGlobalPromise
      ? {
          Promise: GlobalPromise,
          PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
          all: GlobalPromise.all,
          race: GlobalPromise.race,
          allSettled: GlobalPromise.allSettled,
          any: GlobalPromise.any,
          resolve: GlobalPromise.resolve,
          reject: GlobalPromise.reject,
        }
      : {};
  }
  function usePSD(psd, fn, a1, a2, a3) {
    var outerScope = PSD;
    try {
      switchToZone(psd, true);
      return fn(a1, a2, a3);
    } finally {
      switchToZone(outerScope, false);
    }
  }
  function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function"
      ? fn
      : function () {
          var outerZone = PSD;
          if (possibleAwait) incrementExpectedAwaits();
          switchToZone(zone, true);
          try {
            return fn.apply(this, arguments);
          } finally {
            switchToZone(outerZone, false);
            if (cleanup) queueMicrotask(decrementExpectedAwaits);
          }
        };
  }
  function execInGlobalContext(cb) {
    if (Promise === NativePromise && task.echoes === 0) {
      if (zoneEchoes === 0) {
        cb();
      } else {
        enqueueNativeMicroTask(cb);
      }
    } else {
      setTimeout(cb, 0);
    }
  }
  var rejection = DexiePromise.reject;

  function tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || (!db._state.openComplete && !PSD.letThrough && !db._vip)) {
      if (db._state.openComplete) {
        return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
      }
      if (!db._state.isBeingOpened) {
        if (!db._state.autoOpen)
          return rejection(new exceptions.DatabaseClosed());
        db.open().catch(nop);
      }
      return db._state.dbReadyPromise.then(function () {
        return tempTransaction(db, mode, storeNames, fn);
      });
    } else {
      var trans = db._createTransaction(mode, storeNames, db._dbSchema);
      try {
        trans.create();
        db._state.PR1398_maxLoop = 3;
      } catch (ex) {
        if (
          ex.name === errnames.InvalidState &&
          db.isOpen() &&
          --db._state.PR1398_maxLoop > 0
        ) {
          // console.warn("Dexie: Need to reopen db");
          db.close({ disableAutoOpen: false });
          return db.open().then(function () {
            return tempTransaction(db, mode, storeNames, fn);
          });
        }
        return rejection(ex);
      }
      return trans
        ._promise(mode, function (resolve, reject) {
          return newScope(function () {
            PSD.trans = trans;
            return fn(resolve, reject, trans);
          });
        })
        .then(function (result) {
          if (mode === "readwrite")
            try {
              trans.idbtrans.commit();
            } catch (_a) {}
          return mode === "readonly"
            ? result
            : trans._completion.then(function () {
                return result;
              });
        });
    }
  }

  var DEXIE_VERSION = "4.0.8";
  var maxString = String.fromCharCode(65535);
  var minKey = -Infinity;
  var INVALID_KEY_ARGUMENT =
    "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
  var STRING_EXPECTED = "String expected.";
  var connections = [];
  var DBNAMES_DB = "__dbnames";
  var READONLY = "readonly";
  var READWRITE = "readwrite";

  function combine(filter1, filter2) {
    return filter1
      ? filter2
        ? function () {
            return (
              filter1.apply(this, arguments) && filter2.apply(this, arguments)
            );
          }
        : filter1
      : filter2;
  }

  var AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [[]],
    upperOpen: false,
  };

  function workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath)
      ? function (obj) {
          if (obj[keyPath] === undefined && keyPath in obj) {
            obj = deepClone(obj);
            delete obj[keyPath];
          }
          return obj;
        }
      : function (obj) {
          return obj;
        };
  }

  function Entity() {
    throw exceptions.Type();
  }

  function cmp(a, b) {
    try {
      var ta = type(a);
      var tb = type(b);
      if (ta !== tb) {
        if (ta === "Array") return 1;
        if (tb === "Array") return -1;
        if (ta === "binary") return 1;
        if (tb === "binary") return -1;
        if (ta === "string") return 1;
        if (tb === "string") return -1;
        if (ta === "Date") return 1;
        if (tb !== "Date") return NaN;
        return -1;
      }
      switch (ta) {
        case "number":
        case "Date":
        case "string":
          return a > b ? 1 : a < b ? -1 : 0;
        case "binary": {
          return compareUint8Arrays(getUint8Array(a), getUint8Array(b));
        }
        case "Array":
          return compareArrays(a, b);
      }
    } catch (_a) {}
    return NaN;
  }
  function compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for (var i = 0; i < l; ++i) {
      var res = cmp(a[i], b[i]);
      if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
  }
  function compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for (var i = 0; i < l; ++i) {
      if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
  }
  function type(x) {
    var t = typeof x;
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
  }
  function getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a))
      return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
  }

  var Table = (function () {
    function Table() {}
    Table.prototype._trans = function (mode, fn, writeLocked) {
      var trans = this._tx || PSD.trans;
      var tableName = this.name;
      var task =
        debug &&
        typeof console !== "undefined" &&
        console.createTask &&
        console.createTask(
          "Dexie: "
            .concat(mode === "readonly" ? "read" : "write", " ")
            .concat(this.name)
        );
      function checkTableInTransaction(resolve, reject, trans) {
        if (!trans.schema[tableName])
          throw new exceptions.NotFound(
            "Table " + tableName + " not part of transaction"
          );
        return fn(trans.idbtrans, trans);
      }
      var wasRootExec = beginMicroTickScope();
      try {
        var p =
          trans && trans.db._novip === this.db._novip
            ? trans === PSD.trans
              ? trans._promise(mode, checkTableInTransaction, writeLocked)
              : newScope(
                  function () {
                    return trans._promise(
                      mode,
                      checkTableInTransaction,
                      writeLocked
                    );
                  },
                  { trans: trans, transless: PSD.transless || PSD }
                )
            : tempTransaction(
                this.db,
                mode,
                [this.name],
                checkTableInTransaction
              );
        if (task) {
          p._consoleTask = task;
          p = p.catch(function (err) {
            console.trace(err);
            return rejection(err);
          });
        }
        return p;
      } finally {
        if (wasRootExec) endMicroTickScope();
      }
    };
    Table.prototype.get = function (keyOrCrit, cb) {
      var _this = this;
      if (keyOrCrit && keyOrCrit.constructor === Object)
        return this.where(keyOrCrit).first(cb);
      if (keyOrCrit == null)
        return rejection(
          new exceptions.Type("Invalid argument to Table.get()")
        );
      return this._trans("readonly", function (trans) {
        return _this.core
          .get({ trans: trans, key: keyOrCrit })
          .then(function (res) {
            return _this.hook.reading.fire(res);
          });
      }).then(cb);
    };
    Table.prototype.where = function (indexOrCrit) {
      if (typeof indexOrCrit === "string")
        return new this.db.WhereClause(this, indexOrCrit);
      if (isArray(indexOrCrit))
        return new this.db.WhereClause(
          this,
          "[".concat(indexOrCrit.join("+"), "]")
        );
      var keyPaths = keys(indexOrCrit);
      if (keyPaths.length === 1)
        return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
      var compoundIndex = this.schema.indexes
        .concat(this.schema.primKey)
        .filter(function (ix) {
          if (
            ix.compound &&
            keyPaths.every(function (keyPath) {
              return ix.keyPath.indexOf(keyPath) >= 0;
            })
          ) {
            for (var i = 0; i < keyPaths.length; ++i) {
              if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
            }
            return true;
          }
          return false;
        })
        .sort(function (a, b) {
          return a.keyPath.length - b.keyPath.length;
        })[0];
      if (compoundIndex && this.db._maxKey !== maxString) {
        var keyPathsInValidOrder = compoundIndex.keyPath.slice(
          0,
          keyPaths.length
        );
        return this.where(keyPathsInValidOrder).equals(
          keyPathsInValidOrder.map(function (kp) {
            return indexOrCrit[kp];
          })
        );
      }
      if (!compoundIndex && debug)
        console.warn(
          "The query "
            .concat(JSON.stringify(indexOrCrit), " on ")
            .concat(this.name, " would benefit from a ") +
            "compound index [".concat(keyPaths.join("+"), "]")
        );
      var idxByName = this.schema.idxByName;
      var idb = this.db._deps.indexedDB;
      function equals(a, b) {
        return idb.cmp(a, b) === 0;
      }
      var _a = keyPaths.reduce(
          function (_a, keyPath) {
            var prevIndex = _a[0],
              prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
              prevIndex || index,
              prevIndex || !index
                ? combine(
                    prevFilterFn,
                    index && index.multi
                      ? function (x) {
                          var prop = getByKeyPath(x, keyPath);
                          return (
                            isArray(prop) &&
                            prop.some(function (item) {
                              return equals(value, item);
                            })
                          );
                        }
                      : function (x) {
                          return equals(value, getByKeyPath(x, keyPath));
                        }
                  )
                : prevFilterFn,
            ];
          },
          [null, null]
        ),
        idx = _a[0],
        filterFunction = _a[1];
      return idx
        ? this.where(idx.name)
            .equals(indexOrCrit[idx.keyPath])
            .filter(filterFunction)
        : compoundIndex
        ? this.filter(filterFunction)
        : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function (filterFunction) {
      return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function (thenShortcut) {
      return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function (offset) {
      return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function (numRows) {
      return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function (callback) {
      return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function (thenShortcut) {
      return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function () {
      return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function (index) {
      return new this.db.Collection(
        new this.db.WhereClause(
          this,
          isArray(index) ? "[".concat(index.join("+"), "]") : index
        )
      );
    };
    Table.prototype.reverse = function () {
      return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function (constructor) {
      var _a = this,
        db = _a.db,
        tableName = _a.name;
      this.schema.mappedClass = constructor;
      if (constructor.prototype instanceof Entity) {
        constructor = (function (_super) {
          __extends(class_1, _super);
          function class_1() {
            return (_super !== null && _super.apply(this, arguments)) || this;
          }
          Object.defineProperty(class_1.prototype, "db", {
            get: function () {
              return db;
            },
            enumerable: false,
            configurable: true,
          });
          class_1.prototype.table = function () {
            return tableName;
          };
          return class_1;
        })(constructor);
      }
      var inheritedProps = new Set();
      for (var proto = constructor.prototype; proto; proto = getProto(proto)) {
        Object.getOwnPropertyNames(proto).forEach(function (propName) {
          return inheritedProps.add(propName);
        });
      }
      var readHook = function (obj) {
        if (!obj) return obj;
        var res = Object.create(constructor.prototype);
        for (var m in obj)
          if (!inheritedProps.has(m))
            try {
              res[m] = obj[m];
            } catch (_) {}
        return res;
      };
      if (this.schema.readHook) {
        this.hook.reading.unsubscribe(this.schema.readHook);
      }
      this.schema.readHook = readHook;
      this.hook("reading", readHook);
      return constructor;
    };
    Table.prototype.defineClass = function () {
      function Class(content) {
        extend(this, content);
      }
      return this.mapToClass(Class);
    };
    Table.prototype.add = function (obj, key) {
      var _this = this;
      var _a = this.schema.primKey,
        auto = _a.auto,
        keyPath = _a.keyPath;
      var objToAdd = obj;
      if (keyPath && auto) {
        objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
      }
      return this._trans("readwrite", function (trans) {
        return _this.core.mutate({
          trans: trans,
          type: "add",
          keys: key != null ? [key] : null,
          values: [objToAdd],
        });
      })
        .then(function (res) {
          return res.numFailures
            ? DexiePromise.reject(res.failures[0])
            : res.lastResult;
        })
        .then(function (lastResult) {
          if (keyPath) {
            try {
              setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
          }
          return lastResult;
        });
    };
    Table.prototype.update = function (keyOrObject, modifications) {
      if (typeof keyOrObject === "object" && !isArray(keyOrObject)) {
        var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
        if (key === undefined)
          return rejection(
            new exceptions.InvalidArgument(
              "Given object does not contain its primary key"
            )
          );
        return this.where(":id").equals(key).modify(modifications);
      } else {
        return this.where(":id").equals(keyOrObject).modify(modifications);
      }
    };
    Table.prototype.put = function (obj, key) {
      var _this = this;
      var _a = this.schema.primKey,
        auto = _a.auto,
        keyPath = _a.keyPath;
      var objToAdd = obj;
      if (keyPath && auto) {
        objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
      }
      return this._trans("readwrite", function (trans) {
        return _this.core.mutate({
          trans: trans,
          type: "put",
          values: [objToAdd],
          keys: key != null ? [key] : null,
        });
      })
        .then(function (res) {
          return res.numFailures
            ? DexiePromise.reject(res.failures[0])
            : res.lastResult;
        })
        .then(function (lastResult) {
          if (keyPath) {
            try {
              setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
          }
          return lastResult;
        });
    };
    Table.prototype.delete = function (key) {
      var _this = this;
      return this._trans("readwrite", function (trans) {
        return _this.core.mutate({ trans: trans, type: "delete", keys: [key] });
      }).then(function (res) {
        return res.numFailures
          ? DexiePromise.reject(res.failures[0])
          : undefined;
      });
    };
    Table.prototype.clear = function () {
      var _this = this;
      return this._trans("readwrite", function (trans) {
        return _this.core.mutate({
          trans: trans,
          type: "deleteRange",
          range: AnyRange,
        });
      }).then(function (res) {
        return res.numFailures
          ? DexiePromise.reject(res.failures[0])
          : undefined;
      });
    };
    Table.prototype.bulkGet = function (keys) {
      var _this = this;
      return this._trans("readonly", function (trans) {
        return _this.core
          .getMany({
            keys: keys,
            trans: trans,
          })
          .then(function (result) {
            return result.map(function (res) {
              return _this.hook.reading.fire(res);
            });
          });
      });
    };
    Table.prototype.bulkAdd = function (objects, keysOrOptions, options) {
      var _this = this;
      var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
      options = options || (keys ? undefined : keysOrOptions);
      var wantResults = options ? options.allKeys : undefined;
      return this._trans("readwrite", function (trans) {
        var _a = _this.schema.primKey,
          auto = _a.auto,
          keyPath = _a.keyPath;
        if (keyPath && keys)
          throw new exceptions.InvalidArgument(
            "bulkAdd(): keys argument invalid on tables with inbound keys"
          );
        if (keys && keys.length !== objects.length)
          throw new exceptions.InvalidArgument(
            "Arguments objects and keys must have the same length"
          );
        var numObjects = objects.length;
        var objectsToAdd =
          keyPath && auto
            ? objects.map(workaroundForUndefinedPrimKey(keyPath))
            : objects;
        return _this.core
          .mutate({
            trans: trans,
            type: "add",
            keys: keys,
            values: objectsToAdd,
            wantResults: wantResults,
          })
          .then(function (_a) {
            var numFailures = _a.numFailures,
              results = _a.results,
              lastResult = _a.lastResult,
              failures = _a.failures;
            var result = wantResults ? results : lastResult;
            if (numFailures === 0) return result;
            throw new BulkError(
              ""
                .concat(_this.name, ".bulkAdd(): ")
                .concat(numFailures, " of ")
                .concat(numObjects, " operations failed"),
              failures
            );
          });
      });
    };
    Table.prototype.bulkPut = function (objects, keysOrOptions, options) {
      var _this = this;
      var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
      options = options || (keys ? undefined : keysOrOptions);
      var wantResults = options ? options.allKeys : undefined;
      return this._trans("readwrite", function (trans) {
        var _a = _this.schema.primKey,
          auto = _a.auto,
          keyPath = _a.keyPath;
        if (keyPath && keys)
          throw new exceptions.InvalidArgument(
            "bulkPut(): keys argument invalid on tables with inbound keys"
          );
        if (keys && keys.length !== objects.length)
          throw new exceptions.InvalidArgument(
            "Arguments objects and keys must have the same length"
          );
        var numObjects = objects.length;
        var objectsToPut =
          keyPath && auto
            ? objects.map(workaroundForUndefinedPrimKey(keyPath))
            : objects;
        return _this.core
          .mutate({
            trans: trans,
            type: "put",
            keys: keys,
            values: objectsToPut,
            wantResults: wantResults,
          })
          .then(function (_a) {
            var numFailures = _a.numFailures,
              results = _a.results,
              lastResult = _a.lastResult,
              failures = _a.failures;
            var result = wantResults ? results : lastResult;
            if (numFailures === 0) return result;
            throw new BulkError(
              ""
                .concat(_this.name, ".bulkPut(): ")
                .concat(numFailures, " of ")
                .concat(numObjects, " operations failed"),
              failures
            );
          });
      });
    };
    Table.prototype.bulkUpdate = function (keysAndChanges) {
      var _this = this;
      var coreTable = this.core;
      var keys = keysAndChanges.map(function (entry) {
        return entry.key;
      });
      var changeSpecs = keysAndChanges.map(function (entry) {
        return entry.changes;
      });
      var offsetMap = [];
      return this._trans("readwrite", function (trans) {
        return coreTable
          .getMany({ trans: trans, keys: keys, cache: "clone" })
          .then(function (objs) {
            var resultKeys = [];
            var resultObjs = [];
            keysAndChanges.forEach(function (_a, idx) {
              var key = _a.key,
                changes = _a.changes;
              var obj = objs[idx];
              if (obj) {
                for (
                  var _i = 0, _b = Object.keys(changes);
                  _i < _b.length;
                  _i++
                ) {
                  var keyPath = _b[_i];
                  var value = changes[keyPath];
                  if (keyPath === _this.schema.primKey.keyPath) {
                    if (cmp(value, key) !== 0) {
                      throw new exceptions.Constraint(
                        "Cannot update primary key in bulkUpdate()"
                      );
                    }
                  } else {
                    setByKeyPath(obj, keyPath, value);
                  }
                }
                offsetMap.push(idx);
                resultKeys.push(key);
                resultObjs.push(obj);
              }
            });
            var numEntries = resultKeys.length;
            return coreTable
              .mutate({
                trans: trans,
                type: "put",
                keys: resultKeys,
                values: resultObjs,
                updates: {
                  keys: keys,
                  changeSpecs: changeSpecs,
                },
              })
              .then(function (_a) {
                var numFailures = _a.numFailures,
                  failures = _a.failures;
                if (numFailures === 0) return numEntries;
                for (
                  var _i = 0, _b = Object.keys(failures);
                  _i < _b.length;
                  _i++
                ) {
                  var offset = _b[_i];
                  var mappedOffset = offsetMap[Number(offset)];
                  if (mappedOffset != null) {
                    var failure = failures[offset];
                    delete failures[offset];
                    failures[mappedOffset] = failure;
                  }
                }
                throw new BulkError(
                  ""
                    .concat(_this.name, ".bulkUpdate(): ")
                    .concat(numFailures, " of ")
                    .concat(numEntries, " operations failed"),
                  failures
                );
              });
          });
      });
    };
    Table.prototype.bulkDelete = function (keys) {
      var _this = this;
      var numKeys = keys.length;
      return this._trans("readwrite", function (trans) {
        return _this.core.mutate({ trans: trans, type: "delete", keys: keys });
      }).then(function (_a) {
        var numFailures = _a.numFailures,
          lastResult = _a.lastResult,
          failures = _a.failures;
        if (numFailures === 0) return lastResult;
        throw new BulkError(
          ""
            .concat(_this.name, ".bulkDelete(): ")
            .concat(numFailures, " of ")
            .concat(numKeys, " operations failed"),
          failures
        );
      });
    };
    return Table;
  })();

  function Events(ctx) {
    var evs = {};
    var rv = function (eventName, subscriber) {
      if (subscriber) {
        var i = arguments.length,
          args = new Array(i - 1);
        while (--i) args[i - 1] = arguments[i];
        evs[eventName].subscribe.apply(null, args);
        return ctx;
      } else if (typeof eventName === "string") {
        return evs[eventName];
      }
    };
    rv.addEventType = add;
    for (var i = 1, l = arguments.length; i < l; ++i) {
      add(arguments[i]);
    }
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
      if (typeof eventName === "object") return addConfiguredEvents(eventName);
      if (!chainFunction) chainFunction = reverseStoppableEventChain;
      if (!defaultFunction) defaultFunction = nop;
      var context = {
        subscribers: [],
        fire: defaultFunction,
        subscribe: function (cb) {
          if (context.subscribers.indexOf(cb) === -1) {
            context.subscribers.push(cb);
            context.fire = chainFunction(context.fire, cb);
          }
        },
        unsubscribe: function (cb) {
          context.subscribers = context.subscribers.filter(function (fn) {
            return fn !== cb;
          });
          context.fire = context.subscribers.reduce(
            chainFunction,
            defaultFunction
          );
        },
      };
      evs[eventName] = rv[eventName] = context;
      return context;
    }
    function addConfiguredEvents(cfg) {
      keys(cfg).forEach(function (eventName) {
        var args = cfg[eventName];
        if (isArray(args)) {
          add(eventName, cfg[eventName][0], cfg[eventName][1]);
        } else if (args === "asap") {
          var context = add(eventName, mirror, function fire() {
            var i = arguments.length,
              args = new Array(i);
            while (i--) args[i] = arguments[i];
            context.subscribers.forEach(function (fn) {
              asap$1(function fireEvent() {
                fn.apply(null, args);
              });
            });
          });
        } else throw new exceptions.InvalidArgument("Invalid event config");
      });
    }
  }

  function makeClassConstructor(prototype, constructor) {
    derive(constructor).from({ prototype: prototype });
    return constructor;
  }

  function createTableConstructor(db) {
    return makeClassConstructor(
      Table.prototype,
      function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name]
          ? db._allTables[name].hook
          : Events(null, {
              creating: [hookCreatingChain, nop],
              reading: [pureFunctionChain, mirror],
              updating: [hookUpdatingChain, nop],
              deleting: [hookDeletingChain, nop],
            });
      }
    );
  }

  function isPlainKeyRange(ctx, ignoreLimitFilter) {
    return (
      !(ctx.filter || ctx.algorithm || ctx.or) &&
      (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter)
    );
  }
  function addFilter(ctx, fn) {
    ctx.filter = combine(ctx.filter, fn);
  }
  function addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr
      ? function () {
          return combine(curr(), factory());
        }
      : factory;
    ctx.justLimit = isLimitFilter && !curr;
  }
  function addMatchFilter(ctx, fn) {
    ctx.isMatch = combine(ctx.isMatch, fn);
  }
  function getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index)
      throw new exceptions.Schema(
        "KeyPath " +
          ctx.index +
          " on object store " +
          coreSchema.name +
          " is not indexed"
      );
    return index;
  }
  function openCursor(ctx, coreTable, trans) {
    var index = getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
      trans: trans,
      values: !ctx.keysOnly,
      reverse: ctx.dir === "prev",
      unique: !!ctx.unique,
      query: {
        index: index,
        range: ctx.range,
      },
    });
  }
  function iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter
      ? combine(ctx.filter, ctx.replayFilter())
      : ctx.filter;
    if (!ctx.or) {
      return iterate(
        openCursor(ctx, coreTable, coreTrans),
        combine(ctx.algorithm, filter),
        fn,
        !ctx.keysOnly && ctx.valueMapper
      );
    } else {
      var set_1 = {};
      var union = function (item, cursor, advance) {
        if (
          !filter ||
          filter(
            cursor,
            advance,
            function (result) {
              return cursor.stop(result);
            },
            function (err) {
              return cursor.fail(err);
            }
          )
        ) {
          var primaryKey = cursor.primaryKey;
          var key = "" + primaryKey;
          if (key === "[object ArrayBuffer]")
            key = "" + new Uint8Array(primaryKey);
          if (!hasOwn(set_1, key)) {
            set_1[key] = true;
            fn(item, cursor, advance);
          }
        }
      };
      return Promise.all([
        ctx.or._iterate(union, coreTrans),
        iterate(
          openCursor(ctx, coreTable, coreTrans),
          ctx.algorithm,
          union,
          !ctx.keysOnly && ctx.valueMapper
        ),
      ]);
    }
  }
  function iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper
      ? function (x, c, a) {
          return fn(valueMapper(x), c, a);
        }
      : fn;
    var wrappedFn = wrap(mappedFn);
    return cursorPromise.then(function (cursor) {
      if (cursor) {
        return cursor.start(function () {
          var c = function () {
            return cursor.continue();
          };
          if (
            !filter ||
            filter(
              cursor,
              function (advancer) {
                return (c = advancer);
              },
              function (val) {
                cursor.stop(val);
                c = nop;
              },
              function (e) {
                cursor.fail(e);
                c = nop;
              }
            )
          )
            wrappedFn(cursor.value, cursor, function (advancer) {
              return (c = advancer);
            });
          c();
        });
      }
    });
  }

  var PropModSymbol = Symbol();
  var PropModification = (function () {
    function PropModification(spec) {
      Object.assign(this, spec);
    }
    PropModification.prototype.execute = function (value) {
      var _a;
      if (this.add !== undefined) {
        var term = this.add;
        if (isArray(term)) {
          return __spreadArray(
            __spreadArray([], isArray(value) ? value : [], true),
            term,
            true
          ).sort();
        }
        if (typeof term === "number") return (Number(value) || 0) + term;
        if (typeof term === "bigint") {
          try {
            return BigInt(value) + term;
          } catch (_b) {
            return BigInt(0) + term;
          }
        }
        throw new TypeError("Invalid term ".concat(term));
      }
      if (this.remove !== undefined) {
        var subtrahend_1 = this.remove;
        if (isArray(subtrahend_1)) {
          return isArray(value)
            ? value
                .filter(function (item) {
                  return !subtrahend_1.includes(item);
                })
                .sort()
            : [];
        }
        if (typeof subtrahend_1 === "number")
          return Number(value) - subtrahend_1;
        if (typeof subtrahend_1 === "bigint") {
          try {
            return BigInt(value) - subtrahend_1;
          } catch (_c) {
            return BigInt(0) - subtrahend_1;
          }
        }
        throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
      }
      var prefixToReplace =
        (_a = this.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
      if (
        prefixToReplace &&
        typeof value === "string" &&
        value.startsWith(prefixToReplace)
      ) {
        return this.replacePrefix[1] + value.substring(prefixToReplace.length);
      }
      return value;
    };
    return PropModification;
  })();

  var Collection = (function () {
    function Collection() {}
    Collection.prototype._read = function (fn, cb) {
      var ctx = this._ctx;
      return ctx.error
        ? ctx.table._trans(null, rejection.bind(null, ctx.error))
        : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function (fn) {
      var ctx = this._ctx;
      return ctx.error
        ? ctx.table._trans(null, rejection.bind(null, ctx.error))
        : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function (fn) {
      var ctx = this._ctx;
      ctx.algorithm = combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function (fn, coreTrans) {
      return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function (props) {
      var rv = Object.create(this.constructor.prototype),
        ctx = Object.create(this._ctx);
      if (props) extend(ctx, props);
      rv._ctx = ctx;
      return rv;
    };
    Collection.prototype.raw = function () {
      this._ctx.valueMapper = null;
      return this;
    };
    Collection.prototype.each = function (fn) {
      var ctx = this._ctx;
      return this._read(function (trans) {
        return iter(ctx, fn, trans, ctx.table.core);
      });
    };
    Collection.prototype.count = function (cb) {
      var _this = this;
      return this._read(function (trans) {
        var ctx = _this._ctx;
        var coreTable = ctx.table.core;
        if (isPlainKeyRange(ctx, true)) {
          return coreTable
            .count({
              trans: trans,
              query: {
                index: getIndexOrStore(ctx, coreTable.schema),
                range: ctx.range,
              },
            })
            .then(function (count) {
              return Math.min(count, ctx.limit);
            });
        } else {
          var count = 0;
          return iter(
            ctx,
            function () {
              ++count;
              return false;
            },
            trans,
            coreTable
          ).then(function () {
            return count;
          });
        }
      }).then(cb);
    };
    Collection.prototype.sortBy = function (keyPath, cb) {
      var parts = keyPath.split(".").reverse(),
        lastPart = parts[0],
        lastIndex = parts.length - 1;
      function getval(obj, i) {
        if (i) return getval(obj[parts[i]], i - 1);
        return obj[lastPart];
      }
      var order = this._ctx.dir === "next" ? 1 : -1;
      function sorter(a, b) {
        var aVal = getval(a, lastIndex),
          bVal = getval(b, lastIndex);
        return aVal < bVal ? -order : aVal > bVal ? order : 0;
      }
      return this.toArray(function (a) {
        return a.sort(sorter);
      }).then(cb);
    };
    Collection.prototype.toArray = function (cb) {
      var _this = this;
      return this._read(function (trans) {
        var ctx = _this._ctx;
        if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
          var valueMapper_1 = ctx.valueMapper;
          var index = getIndexOrStore(ctx, ctx.table.core.schema);
          return ctx.table.core
            .query({
              trans: trans,
              limit: ctx.limit,
              values: true,
              query: {
                index: index,
                range: ctx.range,
              },
            })
            .then(function (_a) {
              var result = _a.result;
              return valueMapper_1 ? result.map(valueMapper_1) : result;
            });
        } else {
          var a_1 = [];
          return iter(
            ctx,
            function (item) {
              return a_1.push(item);
            },
            trans,
            ctx.table.core
          ).then(function () {
            return a_1;
          });
        }
      }, cb);
    };
    Collection.prototype.offset = function (offset) {
      var ctx = this._ctx;
      if (offset <= 0) return this;
      ctx.offset += offset;
      if (isPlainKeyRange(ctx)) {
        addReplayFilter(ctx, function () {
          var offsetLeft = offset;
          return function (cursor, advance) {
            if (offsetLeft === 0) return true;
            if (offsetLeft === 1) {
              --offsetLeft;
              return false;
            }
            advance(function () {
              cursor.advance(offsetLeft);
              offsetLeft = 0;
            });
            return false;
          };
        });
      } else {
        addReplayFilter(ctx, function () {
          var offsetLeft = offset;
          return function () {
            return --offsetLeft < 0;
          };
        });
      }
      return this;
    };
    Collection.prototype.limit = function (numRows) {
      this._ctx.limit = Math.min(this._ctx.limit, numRows);
      addReplayFilter(
        this._ctx,
        function () {
          var rowsLeft = numRows;
          return function (cursor, advance, resolve) {
            if (--rowsLeft <= 0) advance(resolve);
            return rowsLeft >= 0;
          };
        },
        true
      );
      return this;
    };
    Collection.prototype.until = function (filterFunction, bIncludeStopEntry) {
      addFilter(this._ctx, function (cursor, advance, resolve) {
        if (filterFunction(cursor.value)) {
          advance(resolve);
          return bIncludeStopEntry;
        } else {
          return true;
        }
      });
      return this;
    };
    Collection.prototype.first = function (cb) {
      return this.limit(1)
        .toArray(function (a) {
          return a[0];
        })
        .then(cb);
    };
    Collection.prototype.last = function (cb) {
      return this.reverse().first(cb);
    };
    Collection.prototype.filter = function (filterFunction) {
      addFilter(this._ctx, function (cursor) {
        return filterFunction(cursor.value);
      });
      addMatchFilter(this._ctx, filterFunction);
      return this;
    };
    Collection.prototype.and = function (filter) {
      return this.filter(filter);
    };
    Collection.prototype.or = function (indexName) {
      return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function () {
      this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
      if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
      return this;
    };
    Collection.prototype.desc = function () {
      return this.reverse();
    };
    Collection.prototype.eachKey = function (cb) {
      var ctx = this._ctx;
      ctx.keysOnly = !ctx.isMatch;
      return this.each(function (val, cursor) {
        cb(cursor.key, cursor);
      });
    };
    Collection.prototype.eachUniqueKey = function (cb) {
      this._ctx.unique = "unique";
      return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function (cb) {
      var ctx = this._ctx;
      ctx.keysOnly = !ctx.isMatch;
      return this.each(function (val, cursor) {
        cb(cursor.primaryKey, cursor);
      });
    };
    Collection.prototype.keys = function (cb) {
      var ctx = this._ctx;
      ctx.keysOnly = !ctx.isMatch;
      var a = [];
      return this.each(function (item, cursor) {
        a.push(cursor.key);
      })
        .then(function () {
          return a;
        })
        .then(cb);
    };
    Collection.prototype.primaryKeys = function (cb) {
      var ctx = this._ctx;
      if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
        return this._read(function (trans) {
          var index = getIndexOrStore(ctx, ctx.table.core.schema);
          return ctx.table.core.query({
            trans: trans,
            values: false,
            limit: ctx.limit,
            query: {
              index: index,
              range: ctx.range,
            },
          });
        })
          .then(function (_a) {
            var result = _a.result;
            return result;
          })
          .then(cb);
      }
      ctx.keysOnly = !ctx.isMatch;
      var a = [];
      return this.each(function (item, cursor) {
        a.push(cursor.primaryKey);
      })
        .then(function () {
          return a;
        })
        .then(cb);
    };
    Collection.prototype.uniqueKeys = function (cb) {
      this._ctx.unique = "unique";
      return this.keys(cb);
    };
    Collection.prototype.firstKey = function (cb) {
      return this.limit(1)
        .keys(function (a) {
          return a[0];
        })
        .then(cb);
    };
    Collection.prototype.lastKey = function (cb) {
      return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function () {
      var ctx = this._ctx,
        idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
      if (!idx || !idx.multi) return this;
      var set = {};
      addFilter(this._ctx, function (cursor) {
        var strKey = cursor.primaryKey.toString();
        var found = hasOwn(set, strKey);
        set[strKey] = true;
        return !found;
      });
      return this;
    };
    Collection.prototype.modify = function (changes) {
      var _this = this;
      var ctx = this._ctx;
      return this._write(function (trans) {
        var modifyer;
        if (typeof changes === "function") {
          modifyer = changes;
        } else {
          var keyPaths = keys(changes);
          var numKeys = keyPaths.length;
          modifyer = function (item) {
            var anythingModified = false;
            for (var i = 0; i < numKeys; ++i) {
              var keyPath = keyPaths[i];
              var val = changes[keyPath];
              var origVal = getByKeyPath(item, keyPath);
              if (val instanceof PropModification) {
                setByKeyPath(item, keyPath, val.execute(origVal));
                anythingModified = true;
              } else if (origVal !== val) {
                setByKeyPath(item, keyPath, val);
                anythingModified = true;
              }
            }
            return anythingModified;
          };
        }
        var coreTable = ctx.table.core;
        var _a = coreTable.schema.primaryKey,
          outbound = _a.outbound,
          extractKey = _a.extractKey;
        var limit = _this.db._options.modifyChunkSize || 200;
        var totalFailures = [];
        var successCount = 0;
        var failedKeys = [];
        var applyMutateResult = function (expectedCount, res) {
          var failures = res.failures,
            numFailures = res.numFailures;
          successCount += expectedCount - numFailures;
          for (var _i = 0, _a = keys(failures); _i < _a.length; _i++) {
            var pos = _a[_i];
            totalFailures.push(failures[pos]);
          }
        };
        return _this
          .clone()
          .primaryKeys()
          .then(function (keys) {
            var criteria = isPlainKeyRange(ctx) &&
              ctx.limit === Infinity &&
              (typeof changes !== "function" || changes === deleteCallback) && {
                index: ctx.index,
                range: ctx.range,
              };
            var nextChunk = function (offset) {
              var count = Math.min(limit, keys.length - offset);
              return coreTable
                .getMany({
                  trans: trans,
                  keys: keys.slice(offset, offset + count),
                  cache: "immutable",
                })
                .then(function (values) {
                  var addValues = [];
                  var putValues = [];
                  var putKeys = outbound ? [] : null;
                  var deleteKeys = [];
                  for (var i = 0; i < count; ++i) {
                    var origValue = values[i];
                    var ctx_1 = {
                      value: deepClone(origValue),
                      primKey: keys[offset + i],
                    };
                    if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                      if (ctx_1.value == null) {
                        deleteKeys.push(keys[offset + i]);
                      } else if (
                        !outbound &&
                        cmp(extractKey(origValue), extractKey(ctx_1.value)) !==
                          0
                      ) {
                        deleteKeys.push(keys[offset + i]);
                        addValues.push(ctx_1.value);
                      } else {
                        putValues.push(ctx_1.value);
                        if (outbound) putKeys.push(keys[offset + i]);
                      }
                    }
                  }
                  return Promise.resolve(
                    addValues.length > 0 &&
                      coreTable
                        .mutate({
                          trans: trans,
                          type: "add",
                          values: addValues,
                        })
                        .then(function (res) {
                          for (var pos in res.failures) {
                            deleteKeys.splice(parseInt(pos), 1);
                          }
                          applyMutateResult(addValues.length, res);
                        })
                  )
                    .then(function () {
                      return (
                        (putValues.length > 0 ||
                          (criteria && typeof changes === "object")) &&
                        coreTable
                          .mutate({
                            trans: trans,
                            type: "put",
                            keys: putKeys,
                            values: putValues,
                            criteria: criteria,
                            changeSpec:
                              typeof changes !== "function" && changes,
                            isAdditionalChunk: offset > 0,
                          })
                          .then(function (res) {
                            return applyMutateResult(putValues.length, res);
                          })
                      );
                    })
                    .then(function () {
                      return (
                        (deleteKeys.length > 0 ||
                          (criteria && changes === deleteCallback)) &&
                        coreTable
                          .mutate({
                            trans: trans,
                            type: "delete",
                            keys: deleteKeys,
                            criteria: criteria,
                            isAdditionalChunk: offset > 0,
                          })
                          .then(function (res) {
                            return applyMutateResult(deleteKeys.length, res);
                          })
                      );
                    })
                    .then(function () {
                      return (
                        keys.length > offset + count &&
                        nextChunk(offset + limit)
                      );
                    });
                });
            };
            return nextChunk(0).then(function () {
              if (totalFailures.length > 0)
                throw new ModifyError(
                  "Error modifying one or more objects",
                  totalFailures,
                  successCount,
                  failedKeys
                );
              return keys.length;
            });
          });
      });
    };
    Collection.prototype.delete = function () {
      var ctx = this._ctx,
        range = ctx.range;
      if (isPlainKeyRange(ctx) && (ctx.isPrimKey || range.type === 3)) {
        return this._write(function (trans) {
          var primaryKey = ctx.table.core.schema.primaryKey;
          var coreRange = range;
          return ctx.table.core
            .count({
              trans: trans,
              query: { index: primaryKey, range: coreRange },
            })
            .then(function (count) {
              return ctx.table.core
                .mutate({ trans: trans, type: "deleteRange", range: coreRange })
                .then(function (_a) {
                  var failures = _a.failures;
                  _a.lastResult;
                  _a.results;
                  var numFailures = _a.numFailures;
                  if (numFailures)
                    throw new ModifyError(
                      "Could not delete some values",
                      Object.keys(failures).map(function (pos) {
                        return failures[pos];
                      }),
                      count - numFailures
                    );
                  return count - numFailures;
                });
            });
        });
      }
      return this.modify(deleteCallback);
    };
    return Collection;
  })();
  var deleteCallback = function (value, ctx) {
    return (ctx.value = null);
  };

  function createCollectionConstructor(db) {
    return makeClassConstructor(
      Collection.prototype,
      function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = AnyRange,
          error = null;
        if (keyRangeGenerator)
          try {
            keyRange = keyRangeGenerator();
          } catch (ex) {
            error = ex;
          }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
          table: table,
          index: whereCtx.index,
          isPrimKey:
            !whereCtx.index ||
            (table.schema.primKey.keyPath &&
              whereCtx.index === table.schema.primKey.name),
          range: keyRange,
          keysOnly: false,
          dir: "next",
          unique: "",
          algorithm: null,
          filter: null,
          replayFilter: null,
          justLimit: true,
          isMatch: null,
          offset: 0,
          limit: Infinity,
          error: error,
          or: whereCtx.or,
          valueMapper: readingHook !== mirror ? readingHook : null,
        };
      }
    );
  }

  function simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
  }
  function simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
  }

  function fail(collectionOrWhereClause, err, T) {
    var collection =
      collectionOrWhereClause instanceof WhereClause
        ? new collectionOrWhereClause.Collection(collectionOrWhereClause)
        : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
  }
  function emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function () {
      return rangeEqual("");
    }).limit(0);
  }
  function upperFactory(dir) {
    return dir === "next"
      ? function (s) {
          return s.toUpperCase();
        }
      : function (s) {
          return s.toLowerCase();
        };
  }
  function lowerFactory(dir) {
    return dir === "next"
      ? function (s) {
          return s.toLowerCase();
        }
      : function (s) {
          return s.toUpperCase();
        };
  }
  function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for (var i = 0; i < length; ++i) {
      var lwrKeyChar = lowerKey[i];
      if (lwrKeyChar !== lowerNeedle[i]) {
        if (cmp(key[i], upperNeedle[i]) < 0)
          return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
        if (cmp(key[i], lowerNeedle[i]) < 0)
          return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
        if (llp >= 0)
          return (
            key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1)
          );
        return null;
      }
      if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next")
      return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev")
      return key.substr(0, upperNeedle.length);
    return llp < 0
      ? null
      : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
  }
  function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper,
      lower,
      compare,
      upperNeedles,
      lowerNeedles,
      direction,
      nextKeySuffix,
      needlesLen = needles.length;
    if (
      !needles.every(function (s) {
        return typeof s === "string";
      })
    ) {
      return fail(whereClause, STRING_EXPECTED);
    }
    function initDirection(dir) {
      upper = upperFactory(dir);
      lower = lowerFactory(dir);
      compare = dir === "next" ? simpleCompare : simpleCompareReverse;
      var needleBounds = needles
        .map(function (needle) {
          return { lower: lower(needle), upper: upper(needle) };
        })
        .sort(function (a, b) {
          return compare(a.lower, b.lower);
        });
      upperNeedles = needleBounds.map(function (nb) {
        return nb.upper;
      });
      lowerNeedles = needleBounds.map(function (nb) {
        return nb.lower;
      });
      direction = dir;
      nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function () {
      return createRange(
        upperNeedles[0],
        lowerNeedles[needlesLen - 1] + suffix
      );
    });
    c._ondirectionchange = function (direction) {
      initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function (cursor, advance, resolve) {
      var key = cursor.key;
      if (typeof key !== "string") return false;
      var lowerKey = lower(key);
      if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) {
        return true;
      } else {
        var lowestPossibleCasing = null;
        for (var i = firstPossibleNeedle; i < needlesLen; ++i) {
          var casing = nextCasing(
            key,
            lowerKey,
            upperNeedles[i],
            lowerNeedles[i],
            compare,
            direction
          );
          if (casing === null && lowestPossibleCasing === null)
            firstPossibleNeedle = i + 1;
          else if (
            lowestPossibleCasing === null ||
            compare(lowestPossibleCasing, casing) > 0
          ) {
            lowestPossibleCasing = casing;
          }
        }
        if (lowestPossibleCasing !== null) {
          advance(function () {
            cursor.continue(lowestPossibleCasing + nextKeySuffix);
          });
        } else {
          advance(resolve);
        }
        return false;
      }
    });
    return c;
  }
  function createRange(lower, upper, lowerOpen, upperOpen) {
    return {
      type: 2,
      lower: lower,
      upper: upper,
      lowerOpen: lowerOpen,
      upperOpen: upperOpen,
    };
  }
  function rangeEqual(value) {
    return {
      type: 1,
      lower: value,
      upper: value,
    };
  }

  var WhereClause = (function () {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
      get: function () {
        return this._ctx.table.db.Collection;
      },
      enumerable: false,
      configurable: true,
    });
    WhereClause.prototype.between = function (
      lower,
      upper,
      includeLower,
      includeUpper
    ) {
      includeLower = includeLower !== false;
      includeUpper = includeUpper === true;
      try {
        if (
          this._cmp(lower, upper) > 0 ||
          (this._cmp(lower, upper) === 0 &&
            (includeLower || includeUpper) &&
            !(includeLower && includeUpper))
        )
          return emptyCollection(this);
        return new this.Collection(this, function () {
          return createRange(lower, upper, !includeLower, !includeUpper);
        });
      } catch (e) {
        return fail(this, INVALID_KEY_ARGUMENT);
      }
    };
    WhereClause.prototype.equals = function (value) {
      if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
      return new this.Collection(this, function () {
        return rangeEqual(value);
      });
    };
    WhereClause.prototype.above = function (value) {
      if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
      return new this.Collection(this, function () {
        return createRange(value, undefined, true);
      });
    };
    WhereClause.prototype.aboveOrEqual = function (value) {
      if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
      return new this.Collection(this, function () {
        return createRange(value, undefined, false);
      });
    };
    WhereClause.prototype.below = function (value) {
      if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
      return new this.Collection(this, function () {
        return createRange(undefined, value, false, true);
      });
    };
    WhereClause.prototype.belowOrEqual = function (value) {
      if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
      return new this.Collection(this, function () {
        return createRange(undefined, value);
      });
    };
    WhereClause.prototype.startsWith = function (str) {
      if (typeof str !== "string") return fail(this, STRING_EXPECTED);
      return this.between(str, str + maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function (str) {
      if (str === "") return this.startsWith(str);
      return addIgnoreCaseAlgorithm(
        this,
        function (x, a) {
          return x.indexOf(a[0]) === 0;
        },
        [str],
        maxString
      );
    };
    WhereClause.prototype.equalsIgnoreCase = function (str) {
      return addIgnoreCaseAlgorithm(
        this,
        function (x, a) {
          return x === a[0];
        },
        [str],
        ""
      );
    };
    WhereClause.prototype.anyOfIgnoreCase = function () {
      var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
      if (set.length === 0) return emptyCollection(this);
      return addIgnoreCaseAlgorithm(
        this,
        function (x, a) {
          return a.indexOf(x) !== -1;
        },
        set,
        ""
      );
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function () {
      var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
      if (set.length === 0) return emptyCollection(this);
      return addIgnoreCaseAlgorithm(
        this,
        function (x, a) {
          return a.some(function (n) {
            return x.indexOf(n) === 0;
          });
        },
        set,
        maxString
      );
    };
    WhereClause.prototype.anyOf = function () {
      var _this = this;
      var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
      var compare = this._cmp;
      try {
        set.sort(compare);
      } catch (e) {
        return fail(this, INVALID_KEY_ARGUMENT);
      }
      if (set.length === 0) return emptyCollection(this);
      var c = new this.Collection(this, function () {
        return createRange(set[0], set[set.length - 1]);
      });
      c._ondirectionchange = function (direction) {
        compare = direction === "next" ? _this._ascending : _this._descending;
        set.sort(compare);
      };
      var i = 0;
      c._addAlgorithm(function (cursor, advance, resolve) {
        var key = cursor.key;
        while (compare(key, set[i]) > 0) {
          ++i;
          if (i === set.length) {
            advance(resolve);
            return false;
          }
        }
        if (compare(key, set[i]) === 0) {
          return true;
        } else {
          advance(function () {
            cursor.continue(set[i]);
          });
          return false;
        }
      });
      return c;
    };
    WhereClause.prototype.notEqual = function (value) {
      return this.inAnyRange(
        [
          [minKey, value],
          [value, this.db._maxKey],
        ],
        { includeLowers: false, includeUppers: false }
      );
    };
    WhereClause.prototype.noneOf = function () {
      var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
      if (set.length === 0) return new this.Collection(this);
      try {
        set.sort(this._ascending);
      } catch (e) {
        return fail(this, INVALID_KEY_ARGUMENT);
      }
      var ranges = set.reduce(function (res, val) {
        return res
          ? res.concat([[res[res.length - 1][1], val]])
          : [[minKey, val]];
      }, null);
      ranges.push([set[set.length - 1], this.db._maxKey]);
      return this.inAnyRange(ranges, {
        includeLowers: false,
        includeUppers: false,
      });
    };
    WhereClause.prototype.inAnyRange = function (ranges, options) {
      var _this = this;
      var cmp = this._cmp,
        ascending = this._ascending,
        descending = this._descending,
        min = this._min,
        max = this._max;
      if (ranges.length === 0) return emptyCollection(this);
      if (
        !ranges.every(function (range) {
          return (
            range[0] !== undefined &&
            range[1] !== undefined &&
            ascending(range[0], range[1]) <= 0
          );
        })
      ) {
        return fail(
          this,
          "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower",
          exceptions.InvalidArgument
        );
      }
      var includeLowers = !options || options.includeLowers !== false;
      var includeUppers = options && options.includeUppers === true;
      function addRange(ranges, newRange) {
        var i = 0,
          l = ranges.length;
        for (; i < l; ++i) {
          var range = ranges[i];
          if (
            cmp(newRange[0], range[1]) < 0 &&
            cmp(newRange[1], range[0]) > 0
          ) {
            range[0] = min(range[0], newRange[0]);
            range[1] = max(range[1], newRange[1]);
            break;
          }
        }
        if (i === l) ranges.push(newRange);
        return ranges;
      }
      var sortDirection = ascending;
      function rangeSorter(a, b) {
        return sortDirection(a[0], b[0]);
      }
      var set;
      try {
        set = ranges.reduce(addRange, []);
        set.sort(rangeSorter);
      } catch (ex) {
        return fail(this, INVALID_KEY_ARGUMENT);
      }
      var rangePos = 0;
      var keyIsBeyondCurrentEntry = includeUppers
        ? function (key) {
            return ascending(key, set[rangePos][1]) > 0;
          }
        : function (key) {
            return ascending(key, set[rangePos][1]) >= 0;
          };
      var keyIsBeforeCurrentEntry = includeLowers
        ? function (key) {
            return descending(key, set[rangePos][0]) > 0;
          }
        : function (key) {
            return descending(key, set[rangePos][0]) >= 0;
          };
      function keyWithinCurrentRange(key) {
        return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
      }
      var checkKey = keyIsBeyondCurrentEntry;
      var c = new this.Collection(this, function () {
        return createRange(
          set[0][0],
          set[set.length - 1][1],
          !includeLowers,
          !includeUppers
        );
      });
      c._ondirectionchange = function (direction) {
        if (direction === "next") {
          checkKey = keyIsBeyondCurrentEntry;
          sortDirection = ascending;
        } else {
          checkKey = keyIsBeforeCurrentEntry;
          sortDirection = descending;
        }
        set.sort(rangeSorter);
      };
      c._addAlgorithm(function (cursor, advance, resolve) {
        var key = cursor.key;
        while (checkKey(key)) {
          ++rangePos;
          if (rangePos === set.length) {
            advance(resolve);
            return false;
          }
        }
        if (keyWithinCurrentRange(key)) {
          return true;
        } else if (
          _this._cmp(key, set[rangePos][1]) === 0 ||
          _this._cmp(key, set[rangePos][0]) === 0
        ) {
          return false;
        } else {
          advance(function () {
            if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
            else cursor.continue(set[rangePos][1]);
          });
          return false;
        }
      });
      return c;
    };
    WhereClause.prototype.startsWithAnyOf = function () {
      var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
      if (
        !set.every(function (s) {
          return typeof s === "string";
        })
      ) {
        return fail(this, "startsWithAnyOf() only works with strings");
      }
      if (set.length === 0) return emptyCollection(this);
      return this.inAnyRange(
        set.map(function (str) {
          return [str, str + maxString];
        })
      );
    };
    return WhereClause;
  })();

  function createWhereClauseConstructor(db) {
    return makeClassConstructor(
      WhereClause.prototype,
      function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
          table: table,
          index: index === ":id" ? null : index,
          or: orCollection,
        };
        this._cmp = this._ascending = cmp;
        this._descending = function (a, b) {
          return cmp(b, a);
        };
        this._max = function (a, b) {
          return cmp(a, b) > 0 ? a : b;
        };
        this._min = function (a, b) {
          return cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new exceptions.MissingAPI();
      }
    );
  }

  function eventRejectHandler(reject) {
    return wrap(function (event) {
      preventDefault(event);
      reject(event.target.error);
      return false;
    });
  }
  function preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
  }

  var DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
  var STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
  var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);

  var Transaction = (function () {
    function Transaction() {}
    Transaction.prototype._lock = function () {
      assert(!PSD.global);
      ++this._reculock;
      if (this._reculock === 1 && !PSD.global) PSD.lockOwnerFor = this;
      return this;
    };
    Transaction.prototype._unlock = function () {
      assert(!PSD.global);
      if (--this._reculock === 0) {
        if (!PSD.global) PSD.lockOwnerFor = null;
        while (this._blockedFuncs.length > 0 && !this._locked()) {
          var fnAndPSD = this._blockedFuncs.shift();
          try {
            usePSD(fnAndPSD[1], fnAndPSD[0]);
          } catch (e) {}
        }
      }
      return this;
    };
    Transaction.prototype._locked = function () {
      return this._reculock && PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function (idbtrans) {
      var _this = this;
      if (!this.mode) return this;
      var idbdb = this.db.idbdb;
      var dbOpenError = this.db._state.dbOpenError;
      assert(!this.idbtrans);
      if (!idbtrans && !idbdb) {
        switch (dbOpenError && dbOpenError.name) {
          case "DatabaseClosedError":
            throw new exceptions.DatabaseClosed(dbOpenError);
          case "MissingAPIError":
            throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
          default:
            throw new exceptions.OpenFailed(dbOpenError);
        }
      }
      if (!this.active) throw new exceptions.TransactionInactive();
      assert(this._completion._state === null);
      idbtrans = this.idbtrans =
        idbtrans ||
        (this.db.core
          ? this.db.core.transaction(this.storeNames, this.mode, {
              durability: this.chromeTransactionDurability,
            })
          : idbdb.transaction(this.storeNames, this.mode, {
              durability: this.chromeTransactionDurability,
            }));
      idbtrans.onerror = wrap(function (ev) {
        preventDefault(ev);
        _this._reject(idbtrans.error);
      });
      idbtrans.onabort = wrap(function (ev) {
        preventDefault(ev);
        _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
        _this.active = false;
        _this.on("abort").fire(ev);
      });
      idbtrans.oncomplete = wrap(function () {
        _this.active = false;
        _this._resolve();
        if ("mutatedParts" in idbtrans) {
          globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        }
      });
      return this;
    };
    Transaction.prototype._promise = function (mode, fn, bWriteLock) {
      var _this = this;
      if (mode === "readwrite" && this.mode !== "readwrite")
        return rejection(new exceptions.ReadOnly("Transaction is readonly"));
      if (!this.active) return rejection(new exceptions.TransactionInactive());
      if (this._locked()) {
        return new DexiePromise(function (resolve, reject) {
          _this._blockedFuncs.push([
            function () {
              _this._promise(mode, fn, bWriteLock).then(resolve, reject);
            },
            PSD,
          ]);
        });
      } else if (bWriteLock) {
        return newScope(function () {
          var p = new DexiePromise(function (resolve, reject) {
            _this._lock();
            var rv = fn(resolve, reject, _this);
            if (rv && rv.then) rv.then(resolve, reject);
          });
          p.finally(function () {
            return _this._unlock();
          });
          p._lib = true;
          return p;
        });
      } else {
        var p = new DexiePromise(function (resolve, reject) {
          var rv = fn(resolve, reject, _this);
          if (rv && rv.then) rv.then(resolve, reject);
        });
        p._lib = true;
        return p;
      }
    };
    Transaction.prototype._root = function () {
      return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function (promiseLike) {
      var root = this._root();
      var promise = DexiePromise.resolve(promiseLike);
      if (root._waitingFor) {
        root._waitingFor = root._waitingFor.then(function () {
          return promise;
        });
      } else {
        root._waitingFor = promise;
        root._waitingQueue = [];
        var store = root.idbtrans.objectStore(root.storeNames[0]);
        (function spin() {
          ++root._spinCount;
          while (root._waitingQueue.length) root._waitingQueue.shift()();
          if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
        })();
      }
      var currentWaitPromise = root._waitingFor;
      return new DexiePromise(function (resolve, reject) {
        promise
          .then(
            function (res) {
              return root._waitingQueue.push(wrap(resolve.bind(null, res)));
            },
            function (err) {
              return root._waitingQueue.push(wrap(reject.bind(null, err)));
            }
          )
          .finally(function () {
            if (root._waitingFor === currentWaitPromise) {
              root._waitingFor = null;
            }
          });
      });
    };
    Transaction.prototype.abort = function () {
      if (this.active) {
        this.active = false;
        if (this.idbtrans) this.idbtrans.abort();
        this._reject(new exceptions.Abort());
      }
    };
    Transaction.prototype.table = function (tableName) {
      var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
      if (hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
      var tableSchema = this.schema[tableName];
      if (!tableSchema) {
        throw new exceptions.NotFound(
          "Table " + tableName + " not part of transaction"
        );
      }
      var transactionBoundTable = new this.db.Table(
        tableName,
        tableSchema,
        this
      );
      transactionBoundTable.core = this.db.core.table(tableName);
      memoizedTables[tableName] = transactionBoundTable;
      return transactionBoundTable;
    };
    return Transaction;
  })();

  function createTransactionConstructor(db) {
    return makeClassConstructor(
      Transaction.prototype,
      function Transaction(
        mode,
        storeNames,
        dbschema,
        chromeTransactionDurability,
        parent
      ) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new DexiePromise(function (resolve, reject) {
          _this._resolve = resolve;
          _this._reject = reject;
        });
        this._completion.then(
          function () {
            _this.active = false;
            _this.on.complete.fire();
          },
          function (e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent
              ? _this.parent._reject(e)
              : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return rejection(e);
          }
        );
      }
    );
  }

  function createIndexSpec(
    name,
    keyPath,
    unique,
    multi,
    auto,
    compound,
    isPrimKey
  ) {
    return {
      name: name,
      keyPath: keyPath,
      unique: unique,
      multi: multi,
      auto: auto,
      compound: compound,
      src:
        (unique && !isPrimKey ? "&" : "") +
        (multi ? "*" : "") +
        (auto ? "++" : "") +
        nameFromKeyPath(keyPath),
    };
  }
  function nameFromKeyPath(keyPath) {
    return typeof keyPath === "string"
      ? keyPath
      : keyPath
      ? "[" + [].join.call(keyPath, "+") + "]"
      : "";
  }

  function createTableSchema(name, primKey, indexes) {
    return {
      name: name,
      primKey: primKey,
      indexes: indexes,
      mappedClass: null,
      idxByName: arrayToObject(indexes, function (index) {
        return [index.name, index];
      }),
    };
  }

  function safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
  }
  var getMaxKey = function (IdbKeyRange) {
    try {
      IdbKeyRange.only([[]]);
      getMaxKey = function () {
        return [[]];
      };
      return [[]];
    } catch (e) {
      getMaxKey = function () {
        return maxString;
      };
      return maxString;
    }
  };

  function getKeyExtractor(keyPath) {
    if (keyPath == null) {
      return function () {
        return undefined;
      };
    } else if (typeof keyPath === "string") {
      return getSinglePathKeyExtractor(keyPath);
    } else {
      return function (obj) {
        return getByKeyPath(obj, keyPath);
      };
    }
  }
  function getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) {
      return function (obj) {
        return obj[keyPath];
      };
    } else {
      return function (obj) {
        return getByKeyPath(obj, keyPath);
      };
    }
  }

  function arrayify(arrayLike) {
    return [].slice.call(arrayLike);
  }
  var _id_counter = 0;
  function getKeyPathAlias(keyPath) {
    return keyPath == null
      ? ":id"
      : typeof keyPath === "string"
      ? keyPath
      : "[".concat(keyPath.join("+"), "]");
  }
  function createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
      var tables = arrayify(db.objectStoreNames);
      return {
        schema: {
          name: db.name,
          tables: tables
            .map(function (table) {
              return trans.objectStore(table);
            })
            .map(function (store) {
              var keyPath = store.keyPath,
                autoIncrement = store.autoIncrement;
              var compound = isArray(keyPath);
              var outbound = keyPath == null;
              var indexByKeyPath = {};
              var result = {
                name: store.name,
                primaryKey: {
                  name: null,
                  isPrimaryKey: true,
                  outbound: outbound,
                  compound: compound,
                  keyPath: keyPath,
                  autoIncrement: autoIncrement,
                  unique: true,
                  extractKey: getKeyExtractor(keyPath),
                },
                indexes: arrayify(store.indexNames)
                  .map(function (indexName) {
                    return store.index(indexName);
                  })
                  .map(function (index) {
                    var name = index.name,
                      unique = index.unique,
                      multiEntry = index.multiEntry,
                      keyPath = index.keyPath;
                    var compound = isArray(keyPath);
                    var result = {
                      name: name,
                      compound: compound,
                      keyPath: keyPath,
                      unique: unique,
                      multiEntry: multiEntry,
                      extractKey: getKeyExtractor(keyPath),
                    };
                    indexByKeyPath[getKeyPathAlias(keyPath)] = result;
                    return result;
                  }),
                getIndexByKeyPath: function (keyPath) {
                  return indexByKeyPath[getKeyPathAlias(keyPath)];
                },
              };
              indexByKeyPath[":id"] = result.primaryKey;
              if (keyPath != null) {
                indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
              }
              return result;
            }),
        },
        hasGetAll:
          tables.length > 0 &&
          "getAll" in trans.objectStore(tables[0]) &&
          !(
            typeof navigator !== "undefined" &&
            /Safari/.test(navigator.userAgent) &&
            !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
            [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604
          ),
      };
    }
    function makeIDBKeyRange(range) {
      if (range.type === 3) return null;
      if (range.type === 4)
        throw new Error("Cannot convert never type to IDBKeyRange");
      var lower = range.lower,
        upper = range.upper,
        lowerOpen = range.lowerOpen,
        upperOpen = range.upperOpen;
      var idbRange =
        lower === undefined
          ? upper === undefined
            ? null
            : IdbKeyRange.upperBound(upper, !!upperOpen)
          : upper === undefined
          ? IdbKeyRange.lowerBound(lower, !!lowerOpen)
          : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
      return idbRange;
    }
    function createDbCoreTable(tableSchema) {
      var tableName = tableSchema.name;
      function mutate(_a) {
        var trans = _a.trans,
          type = _a.type,
          keys = _a.keys,
          values = _a.values,
          range = _a.range;
        return new Promise(function (resolve, reject) {
          resolve = wrap(resolve);
          var store = trans.objectStore(tableName);
          var outbound = store.keyPath == null;
          var isAddOrPut = type === "put" || type === "add";
          if (!isAddOrPut && type !== "delete" && type !== "deleteRange")
            throw new Error("Invalid operation type: " + type);
          var length = (keys || values || { length: 1 }).length;
          if (keys && values && keys.length !== values.length) {
            throw new Error(
              "Given keys array must have same length as given values array."
            );
          }
          if (length === 0)
            return resolve({
              numFailures: 0,
              failures: {},
              results: [],
              lastResult: undefined,
            });
          var req;
          var reqs = [];
          var failures = [];
          var numFailures = 0;
          var errorHandler = function (event) {
            ++numFailures;
            preventDefault(event);
          };
          if (type === "deleteRange") {
            if (range.type === 4)
              return resolve({
                numFailures: numFailures,
                failures: failures,
                results: [],
                lastResult: undefined,
              });
            if (range.type === 3) reqs.push((req = store.clear()));
            else reqs.push((req = store.delete(makeIDBKeyRange(range))));
          } else {
            var _a = isAddOrPut
                ? outbound
                  ? [values, keys]
                  : [values, null]
                : [keys, null],
              args1 = _a[0],
              args2 = _a[1];
            if (isAddOrPut) {
              for (var i = 0; i < length; ++i) {
                reqs.push(
                  (req =
                    args2 && args2[i] !== undefined
                      ? store[type](args1[i], args2[i])
                      : store[type](args1[i]))
                );
                req.onerror = errorHandler;
              }
            } else {
              for (var i = 0; i < length; ++i) {
                reqs.push((req = store[type](args1[i])));
                req.onerror = errorHandler;
              }
            }
          }
          var done = function (event) {
            var lastResult = event.target.result;
            reqs.forEach(function (req, i) {
              return req.error != null && (failures[i] = req.error);
            });
            resolve({
              numFailures: numFailures,
              failures: failures,
              results:
                type === "delete"
                  ? keys
                  : reqs.map(function (req) {
                      return req.result;
                    }),
              lastResult: lastResult,
            });
          };
          req.onerror = function (event) {
            errorHandler(event);
            done(event);
          };
          req.onsuccess = done;
        });
      }
      function openCursor(_a) {
        var trans = _a.trans,
          values = _a.values,
          query = _a.query,
          reverse = _a.reverse,
          unique = _a.unique;
        return new Promise(function (resolve, reject) {
          resolve = wrap(resolve);
          var index = query.index,
            range = query.range;
          var store = trans.objectStore(tableName);
          var source = index.isPrimaryKey ? store : store.index(index.name);
          var direction = reverse
            ? unique
              ? "prevunique"
              : "prev"
            : unique
            ? "nextunique"
            : "next";
          var req =
            values || !("openKeyCursor" in source)
              ? source.openCursor(makeIDBKeyRange(range), direction)
              : source.openKeyCursor(makeIDBKeyRange(range), direction);
          req.onerror = eventRejectHandler(reject);
          req.onsuccess = wrap(function (ev) {
            var cursor = req.result;
            if (!cursor) {
              resolve(null);
              return;
            }
            cursor.___id = ++_id_counter;
            cursor.done = false;
            var _cursorContinue = cursor.continue.bind(cursor);
            var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
            if (_cursorContinuePrimaryKey)
              _cursorContinuePrimaryKey =
                _cursorContinuePrimaryKey.bind(cursor);
            var _cursorAdvance = cursor.advance.bind(cursor);
            var doThrowCursorIsNotStarted = function () {
              throw new Error("Cursor not started");
            };
            var doThrowCursorIsStopped = function () {
              throw new Error("Cursor not stopped");
            };
            cursor.trans = trans;
            cursor.stop =
              cursor.continue =
              cursor.continuePrimaryKey =
              cursor.advance =
                doThrowCursorIsNotStarted;
            cursor.fail = wrap(reject);
            cursor.next = function () {
              var _this = this;
              var gotOne = 1;
              return this.start(function () {
                return gotOne-- ? _this.continue() : _this.stop();
              }).then(function () {
                return _this;
              });
            };
            cursor.start = function (callback) {
              var iterationPromise = new Promise(function (
                resolveIteration,
                rejectIteration
              ) {
                resolveIteration = wrap(resolveIteration);
                req.onerror = eventRejectHandler(rejectIteration);
                cursor.fail = rejectIteration;
                cursor.stop = function (value) {
                  cursor.stop =
                    cursor.continue =
                    cursor.continuePrimaryKey =
                    cursor.advance =
                      doThrowCursorIsStopped;
                  resolveIteration(value);
                };
              });
              var guardedCallback = function () {
                if (req.result) {
                  try {
                    callback();
                  } catch (err) {
                    cursor.fail(err);
                  }
                } else {
                  cursor.done = true;
                  cursor.start = function () {
                    throw new Error("Cursor behind last entry");
                  };
                  cursor.stop();
                }
              };
              req.onsuccess = wrap(function (ev) {
                req.onsuccess = guardedCallback;
                guardedCallback();
              });
              cursor.continue = _cursorContinue;
              cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
              cursor.advance = _cursorAdvance;
              guardedCallback();
              return iterationPromise;
            };
            resolve(cursor);
          }, reject);
        });
      }
      function query(hasGetAll) {
        return function (request) {
          return new Promise(function (resolve, reject) {
            resolve = wrap(resolve);
            var trans = request.trans,
              values = request.values,
              limit = request.limit,
              query = request.query;
            var nonInfinitLimit = limit === Infinity ? undefined : limit;
            var index = query.index,
              range = query.range;
            var store = trans.objectStore(tableName);
            var source = index.isPrimaryKey ? store : store.index(index.name);
            var idbKeyRange = makeIDBKeyRange(range);
            if (limit === 0) return resolve({ result: [] });
            if (hasGetAll) {
              var req = values
                ? source.getAll(idbKeyRange, nonInfinitLimit)
                : source.getAllKeys(idbKeyRange, nonInfinitLimit);
              req.onsuccess = function (event) {
                return resolve({ result: event.target.result });
              };
              req.onerror = eventRejectHandler(reject);
            } else {
              var count_1 = 0;
              var req_1 =
                values || !("openKeyCursor" in source)
                  ? source.openCursor(idbKeyRange)
                  : source.openKeyCursor(idbKeyRange);
              var result_1 = [];
              req_1.onsuccess = function (event) {
                var cursor = req_1.result;
                if (!cursor) return resolve({ result: result_1 });
                result_1.push(values ? cursor.value : cursor.primaryKey);
                if (++count_1 === limit) return resolve({ result: result_1 });
                cursor.continue();
              };
              req_1.onerror = eventRejectHandler(reject);
            }
          });
        };
      }
      return {
        name: tableName,
        schema: tableSchema,
        mutate: mutate,
        getMany: function (_a) {
          var trans = _a.trans,
            keys = _a.keys;
          return new Promise(function (resolve, reject) {
            resolve = wrap(resolve);
            var store = trans.objectStore(tableName);
            var length = keys.length;
            var result = new Array(length);
            var keyCount = 0;
            var callbackCount = 0;
            var req;
            var successHandler = function (event) {
              var req = event.target;
              if ((result[req._pos] = req.result) != null);
              if (++callbackCount === keyCount) resolve(result);
            };
            var errorHandler = eventRejectHandler(reject);
            for (var i = 0; i < length; ++i) {
              var key = keys[i];
              if (key != null) {
                req = store.get(keys[i]);
                req._pos = i;
                req.onsuccess = successHandler;
                req.onerror = errorHandler;
                ++keyCount;
              }
            }
            if (keyCount === 0) resolve(result);
          });
        },
        get: function (_a) {
          var trans = _a.trans,
            key = _a.key;
          return new Promise(function (resolve, reject) {
            resolve = wrap(resolve);
            var store = trans.objectStore(tableName);
            var req = store.get(key);
            req.onsuccess = function (event) {
              return resolve(event.target.result);
            };
            req.onerror = eventRejectHandler(reject);
          });
        },
        query: query(hasGetAll),
        openCursor: openCursor,
        count: function (_a) {
          var query = _a.query,
            trans = _a.trans;
          var index = query.index,
            range = query.range;
          return new Promise(function (resolve, reject) {
            var store = trans.objectStore(tableName);
            var source = index.isPrimaryKey ? store : store.index(index.name);
            var idbKeyRange = makeIDBKeyRange(range);
            var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
            req.onsuccess = wrap(function (ev) {
              return resolve(ev.target.result);
            });
            req.onerror = eventRejectHandler(reject);
          });
        },
      };
    }
    var _a = extractSchema(db, tmpTrans),
      schema = _a.schema,
      hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function (tableSchema) {
      return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function (table) {
      return (tableMap[table.name] = table);
    });
    return {
      stack: "dbcore",
      transaction: db.transaction.bind(db),
      table: function (name) {
        var result = tableMap[name];
        if (!result) throw new Error("Table '".concat(name, "' not found"));
        return tableMap[name];
      },
      MIN_KEY: -Infinity,
      MAX_KEY: getMaxKey(IdbKeyRange),
      schema: schema,
    };
  }

  function createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function (down, _a) {
      var create = _a.create;
      return __assign(__assign({}, down), create(down));
    }, stackImpl);
  }
  function createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = createMiddlewareStack(
      createDBCore(idbdb, IDBKeyRange, tmpTrans),
      middlewares.dbcore
    );
    return {
      dbcore: dbcore,
    };
  }
  function generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = createMiddlewareStacks(
      db._middlewares,
      idbdb,
      db._deps,
      tmpTrans
    );
    db.core = stacks.dbcore;
    db.tables.forEach(function (table) {
      var tableName = table.name;
      if (
        db.core.schema.tables.some(function (tbl) {
          return tbl.name === tableName;
        })
      ) {
        table.core = db.core.table(tableName);
        if (db[tableName] instanceof db.Table) {
          db[tableName].core = table.core;
        }
      }
    });
  }

  function setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function (tableName) {
      var schema = dbschema[tableName];
      objs.forEach(function (obj) {
        var propDesc = getPropertyDescriptor(obj, tableName);
        if (
          !propDesc ||
          ("value" in propDesc && propDesc.value === undefined)
        ) {
          if (
            obj === db.Transaction.prototype ||
            obj instanceof db.Transaction
          ) {
            setProp(obj, tableName, {
              get: function () {
                return this.table(tableName);
              },
              set: function (value) {
                defineProperty(this, tableName, {
                  value: value,
                  writable: true,
                  configurable: true,
                  enumerable: true,
                });
              },
            });
          } else {
            obj[tableName] = new db.Table(tableName, schema);
          }
        }
      });
    });
  }
  function removeTablesApi(db, objs) {
    objs.forEach(function (obj) {
      for (var key in obj) {
        if (obj[key] instanceof db.Table) delete obj[key];
      }
    });
  }
  function lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
  }
  function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (
      idbUpgradeTrans.objectStoreNames.contains("$meta") &&
      !globalSchema.$meta
    ) {
      globalSchema.$meta = createTableSchema(
        "$meta",
        parseIndexSyntax("")[0],
        []
      );
      db._storeNames.push("$meta");
    }
    var trans = db._createTransaction(
      "readwrite",
      db._storeNames,
      globalSchema
    );
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = PSD.transless || PSD;
    newScope(function () {
      PSD.trans = trans;
      PSD.transless = transless;
      if (oldVersion === 0) {
        keys(globalSchema).forEach(function (tableName) {
          createTable(
            idbUpgradeTrans,
            tableName,
            globalSchema[tableName].primKey,
            globalSchema[tableName].indexes
          );
        });
        generateMiddlewareStacks(db, idbUpgradeTrans);
        DexiePromise.follow(function () {
          return db.on.populate.fire(trans);
        }).catch(rejectTransaction);
      } else {
        generateMiddlewareStacks(db, idbUpgradeTrans);
        return getExistingVersion(db, trans, oldVersion)
          .then(function (oldVersion) {
            return updateTablesAndIndexes(
              db,
              oldVersion,
              trans,
              idbUpgradeTrans
            );
          })
          .catch(rejectTransaction);
      }
    });
  }
  function patchCurrentVersion(db, idbUpgradeTrans) {
    createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (
      idbUpgradeTrans.db.version % 10 === 0 &&
      !idbUpgradeTrans.objectStoreNames.contains("$meta")
    ) {
      idbUpgradeTrans.db
        .createObjectStore("$meta")
        .add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), "version");
    }
    var globalSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function (tableChange) {
      if (tableChange.change.length || tableChange.recreate) {
        console.warn(
          "Unable to patch indexes of table ".concat(
            tableChange.name,
            " because it has changes on the type of index or primary key."
          )
        );
        return { value: void 0 };
      }
      var store = idbUpgradeTrans.objectStore(tableChange.name);
      tableChange.add.forEach(function (idx) {
        if (debug)
          console.debug(
            "Dexie upgrade patch: Creating missing index "
              .concat(tableChange.name, ".")
              .concat(idx.src)
          );
        addIndex(store, idx);
      });
    };
    for (var _i = 0, _a = diff.change; _i < _a.length; _i++) {
      var tableChange = _a[_i];
      var state_1 = _loop_1(tableChange);
      if (typeof state_1 === "object") return state_1.value;
    }
  }
  function getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes("$meta")) {
      return trans
        .table("$meta")
        .get("version")
        .then(function (metaVersion) {
          return metaVersion != null ? metaVersion : oldVersion;
        });
    } else {
      return DexiePromise.resolve(oldVersion);
    }
  }
  function updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = (db._dbSchema = buildGlobalSchema(
      db,
      db.idbdb,
      idbUpgradeTrans
    ));
    var versToRun = versions.filter(function (v) {
      return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) {
      return DexiePromise.resolve();
    }
    versToRun.forEach(function (version) {
      queue.push(function () {
        var oldSchema = globalSchema;
        var newSchema = version._cfg.dbschema;
        adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
        adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
        globalSchema = db._dbSchema = newSchema;
        var diff = getSchemaDiff(oldSchema, newSchema);
        diff.add.forEach(function (tuple) {
          createTable(
            idbUpgradeTrans,
            tuple[0],
            tuple[1].primKey,
            tuple[1].indexes
          );
        });
        diff.change.forEach(function (change) {
          if (change.recreate) {
            throw new exceptions.Upgrade(
              "Not yet support for changing primary key"
            );
          } else {
            var store_1 = idbUpgradeTrans.objectStore(change.name);
            change.add.forEach(function (idx) {
              return addIndex(store_1, idx);
            });
            change.change.forEach(function (idx) {
              store_1.deleteIndex(idx.name);
              addIndex(store_1, idx);
            });
            change.del.forEach(function (idxName) {
              return store_1.deleteIndex(idxName);
            });
          }
        });
        var contentUpgrade = version._cfg.contentUpgrade;
        if (contentUpgrade && version._cfg.version > oldVersion) {
          generateMiddlewareStacks(db, idbUpgradeTrans);
          trans._memoizedTables = {};
          var upgradeSchema_1 = shallowClone(newSchema);
          diff.del.forEach(function (table) {
            upgradeSchema_1[table] = oldSchema[table];
          });
          removeTablesApi(db, [db.Transaction.prototype]);
          setApiOnPlace(
            db,
            [db.Transaction.prototype],
            keys(upgradeSchema_1),
            upgradeSchema_1
          );
          trans.schema = upgradeSchema_1;
          var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
          if (contentUpgradeIsAsync_1) {
            incrementExpectedAwaits();
          }
          var returnValue_1;
          var promiseFollowed = DexiePromise.follow(function () {
            returnValue_1 = contentUpgrade(trans);
            if (returnValue_1) {
              if (contentUpgradeIsAsync_1) {
                var decrementor = decrementExpectedAwaits.bind(null, null);
                returnValue_1.then(decrementor, decrementor);
              }
            }
          });
          return returnValue_1 && typeof returnValue_1.then === "function"
            ? DexiePromise.resolve(returnValue_1)
            : promiseFollowed.then(function () {
                return returnValue_1;
              });
        }
      });
      queue.push(function (idbtrans) {
        var newSchema = version._cfg.dbschema;
        deleteRemovedTables(newSchema, idbtrans);
        removeTablesApi(db, [db.Transaction.prototype]);
        setApiOnPlace(
          db,
          [db.Transaction.prototype],
          db._storeNames,
          db._dbSchema
        );
        trans.schema = db._dbSchema;
      });
      queue.push(function (idbtrans) {
        if (db.idbdb.objectStoreNames.contains("$meta")) {
          if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
            db.idbdb.deleteObjectStore("$meta");
            delete db._dbSchema.$meta;
            db._storeNames = db._storeNames.filter(function (name) {
              return name !== "$meta";
            });
          } else {
            idbtrans.objectStore("$meta").put(version._cfg.version, "version");
          }
        }
      });
    });
    function runQueue() {
      return queue.length
        ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue)
        : DexiePromise.resolve();
    }
    return runQueue().then(function () {
      createMissingTables(globalSchema, idbUpgradeTrans);
    });
  }
  function getSchemaDiff(oldSchema, newSchema) {
    var diff = {
      del: [],
      add: [],
      change: [],
    };
    var table;
    for (table in oldSchema) {
      if (!newSchema[table]) diff.del.push(table);
    }
    for (table in newSchema) {
      var oldDef = oldSchema[table],
        newDef = newSchema[table];
      if (!oldDef) {
        diff.add.push([table, newDef]);
      } else {
        var change = {
          name: table,
          def: newDef,
          recreate: false,
          del: [],
          add: [],
          change: [],
        };
        if (
          "" + (oldDef.primKey.keyPath || "") !==
            "" + (newDef.primKey.keyPath || "") ||
          oldDef.primKey.auto !== newDef.primKey.auto
        ) {
          change.recreate = true;
          diff.change.push(change);
        } else {
          var oldIndexes = oldDef.idxByName;
          var newIndexes = newDef.idxByName;
          var idxName = void 0;
          for (idxName in oldIndexes) {
            if (!newIndexes[idxName]) change.del.push(idxName);
          }
          for (idxName in newIndexes) {
            var oldIdx = oldIndexes[idxName],
              newIdx = newIndexes[idxName];
            if (!oldIdx) change.add.push(newIdx);
            else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
          }
          if (
            change.del.length > 0 ||
            change.add.length > 0 ||
            change.change.length > 0
          ) {
            diff.change.push(change);
          }
        }
      }
    }
    return diff;
  }
  function createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(
      tableName,
      primKey.keyPath
        ? { keyPath: primKey.keyPath, autoIncrement: primKey.auto }
        : { autoIncrement: primKey.auto }
    );
    indexes.forEach(function (idx) {
      return addIndex(store, idx);
    });
    return store;
  }
  function createMissingTables(newSchema, idbtrans) {
    keys(newSchema).forEach(function (tableName) {
      if (!idbtrans.db.objectStoreNames.contains(tableName)) {
        if (debug) console.debug("Dexie: Creating missing table", tableName);
        createTable(
          idbtrans,
          tableName,
          newSchema[tableName].primKey,
          newSchema[tableName].indexes
        );
      }
    });
  }
  function deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function (storeName) {
      return (
        newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName)
      );
    });
  }
  function addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
      unique: idx.unique,
      multiEntry: idx.multi,
    });
  }
  function buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function (storeName) {
      var store = tmpTrans.objectStore(storeName);
      var keyPath = store.keyPath;
      var primKey = createIndexSpec(
        nameFromKeyPath(keyPath),
        keyPath || "",
        true,
        false,
        !!store.autoIncrement,
        keyPath && typeof keyPath !== "string",
        true
      );
      var indexes = [];
      for (var j = 0; j < store.indexNames.length; ++j) {
        var idbindex = store.index(store.indexNames[j]);
        keyPath = idbindex.keyPath;
        var index = createIndexSpec(
          idbindex.name,
          keyPath,
          !!idbindex.unique,
          !!idbindex.multiEntry,
          false,
          keyPath && typeof keyPath !== "string",
          false
        );
        indexes.push(index);
      }
      globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
  }
  function readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = (db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans));
    db._storeNames = slice(idbdb.objectStoreNames, 0);
    setApiOnPlace(db, [db._allTables], keys(globalSchema), globalSchema);
  }
  function verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = getSchemaDiff(installedSchema, db._dbSchema);
    return !(
      diff.add.length ||
      diff.change.some(function (ch) {
        return ch.add.length || ch.change.length;
      })
    );
  }
  function adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for (var i = 0; i < storeNames.length; ++i) {
      var storeName = storeNames[i];
      var store = idbtrans.objectStore(storeName);
      db._hasGetAll = "getAll" in store;
      for (var j = 0; j < store.indexNames.length; ++j) {
        var indexName = store.indexNames[j];
        var keyPath = store.index(indexName).keyPath;
        var dexieName =
          typeof keyPath === "string"
            ? keyPath
            : "[" + slice(keyPath).join("+") + "]";
        if (schema[storeName]) {
          var indexSpec = schema[storeName].idxByName[dexieName];
          if (indexSpec) {
            indexSpec.name = indexName;
            delete schema[storeName].idxByName[dexieName];
            schema[storeName].idxByName[indexName] = indexSpec;
          }
        }
      }
    }
    if (
      typeof navigator !== "undefined" &&
      /Safari/.test(navigator.userAgent) &&
      !/(Chrome\/|Edge\/)/.test(navigator.userAgent) &&
      _global.WorkerGlobalScope &&
      _global instanceof _global.WorkerGlobalScope &&
      [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604
    ) {
      db._hasGetAll = false;
    }
  }
  function parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function (index, indexNum) {
      index = index.trim();
      var name = index.replace(/([&*]|\+\+)/g, "");
      var keyPath = /^\[/.test(name)
        ? name.match(/^\[(.*)\]$/)[1].split("+")
        : name;
      return createIndexSpec(
        name,
        keyPath || null,
        /\&/.test(index),
        /\*/.test(index),
        /\+\+/.test(index),
        isArray(keyPath),
        indexNum === 0
      );
    });
  }

  var Version = (function () {
    function Version() {}
    Version.prototype._parseStoresSpec = function (stores, outSchema) {
      keys(stores).forEach(function (tableName) {
        if (stores[tableName] !== null) {
          var indexes = parseIndexSyntax(stores[tableName]);
          var primKey = indexes.shift();
          primKey.unique = true;
          if (primKey.multi)
            throw new exceptions.Schema("Primary key cannot be multi-valued");
          indexes.forEach(function (idx) {
            if (idx.auto)
              throw new exceptions.Schema(
                "Only primary key can be marked as autoIncrement (++)"
              );
            if (!idx.keyPath)
              throw new exceptions.Schema(
                "Index must have a name and cannot be an empty string"
              );
          });
          outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
        }
      });
    };
    Version.prototype.stores = function (stores) {
      var db = this.db;
      this._cfg.storesSource = this._cfg.storesSource
        ? extend(this._cfg.storesSource, stores)
        : stores;
      var versions = db._versions;
      var storesSpec = {};
      var dbschema = {};
      versions.forEach(function (version) {
        extend(storesSpec, version._cfg.storesSource);
        dbschema = version._cfg.dbschema = {};
        version._parseStoresSpec(storesSpec, dbschema);
      });
      db._dbSchema = dbschema;
      removeTablesApi(db, [db._allTables, db, db.Transaction.prototype]);
      setApiOnPlace(
        db,
        [db._allTables, db, db.Transaction.prototype, this._cfg.tables],
        keys(dbschema),
        dbschema
      );
      db._storeNames = keys(dbschema);
      return this;
    };
    Version.prototype.upgrade = function (upgradeFunction) {
      this._cfg.contentUpgrade = promisableChain(
        this._cfg.contentUpgrade || nop,
        upgradeFunction
      );
      return this;
    };
    return Version;
  })();

  function createVersionConstructor(db) {
    return makeClassConstructor(
      Version.prototype,
      function Version(versionNumber) {
        this.db = db;
        this._cfg = {
          version: versionNumber,
          storesSource: null,
          dbschema: {},
          tables: {},
          contentUpgrade: null,
        };
      }
    );
  }

  function getDbNamesTable(indexedDB, IDBKeyRange) {
    var dbNamesDB = indexedDB["_dbNamesDB"];
    if (!dbNamesDB) {
      dbNamesDB = indexedDB["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
        addons: [],
        indexedDB: indexedDB,
        IDBKeyRange: IDBKeyRange,
      });
      dbNamesDB.version(1).stores({ dbnames: "name" });
    }
    return dbNamesDB.table("dbnames");
  }
  function hasDatabasesNative(indexedDB) {
    return indexedDB && typeof indexedDB.databases === "function";
  }
  function getDatabaseNames(_a) {
    var indexedDB = _a.indexedDB,
      IDBKeyRange = _a.IDBKeyRange;
    return hasDatabasesNative(indexedDB)
      ? Promise.resolve(indexedDB.databases()).then(function (infos) {
          return infos
            .map(function (info) {
              return info.name;
            })
            .filter(function (name) {
              return name !== DBNAMES_DB;
            });
        })
      : getDbNamesTable(indexedDB, IDBKeyRange).toCollection().primaryKeys();
  }
  function _onDatabaseCreated(_a, name) {
    var indexedDB = _a.indexedDB,
      IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB) &&
      name !== DBNAMES_DB &&
      getDbNamesTable(indexedDB, IDBKeyRange).put({ name: name }).catch(nop);
  }
  function _onDatabaseDeleted(_a, name) {
    var indexedDB = _a.indexedDB,
      IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB) &&
      name !== DBNAMES_DB &&
      getDbNamesTable(indexedDB, IDBKeyRange).delete(name).catch(nop);
  }

  function vip(fn) {
    return newScope(function () {
      PSD.letThrough = true;
      return fn();
    });
  }

  function idbReady() {
    var isSafari =
      !navigator.userAgentData &&
      /Safari\//.test(navigator.userAgent) &&
      !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function (resolve) {
      var tryIdb = function () {
        return indexedDB.databases().finally(resolve);
      };
      intervalId = setInterval(tryIdb, 100);
      tryIdb();
    }).finally(function () {
      return clearInterval(intervalId);
    });
  }

  var _a;
  function isEmptyRange(node) {
    return !("from" in node);
  }
  var RangeSet = function (fromOrTree, to) {
    if (this) {
      extend(
        this,
        arguments.length
          ? {
              d: 1,
              from: fromOrTree,
              to: arguments.length > 1 ? to : fromOrTree,
            }
          : { d: 0 }
      );
    } else {
      var rv = new RangeSet();
      if (fromOrTree && "d" in fromOrTree) {
        extend(rv, fromOrTree);
      }
      return rv;
    }
  };
  props(
    RangeSet.prototype,
    ((_a = {
      add: function (rangeSet) {
        mergeRanges(this, rangeSet);
        return this;
      },
      addKey: function (key) {
        addRange(this, key, key);
        return this;
      },
      addKeys: function (keys) {
        var _this = this;
        keys.forEach(function (key) {
          return addRange(_this, key, key);
        });
        return this;
      },
      hasKey: function (key) {
        var node = getRangeSetIterator(this).next(key).value;
        return node && cmp(node.from, key) <= 0 && cmp(node.to, key) >= 0;
      },
    }),
    (_a[iteratorSymbol] = function () {
      return getRangeSetIterator(this);
    }),
    _a)
  );
  function addRange(target, from, to) {
    var diff = cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if (isEmptyRange(target))
      return extend(target, { from: from, to: to, d: 1 });
    var left = target.l;
    var right = target.r;
    if (cmp(to, target.from) < 0) {
      left
        ? addRange(left, from, to)
        : (target.l = { from: from, to: to, d: 1, l: null, r: null });
      return rebalance(target);
    }
    if (cmp(from, target.to) > 0) {
      right
        ? addRange(right, from, to)
        : (target.r = { from: from, to: to, d: 1, l: null, r: null });
      return rebalance(target);
    }
    if (cmp(from, target.from) < 0) {
      target.from = from;
      target.l = null;
      target.d = right ? right.d + 1 : 1;
    }
    if (cmp(to, target.to) > 0) {
      target.to = to;
      target.r = null;
      target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) {
      mergeRanges(target, left);
    }
    if (right && rightWasCutOff) {
      mergeRanges(target, right);
    }
  }
  function mergeRanges(target, newSet) {
    function _addRangeSet(target, _a) {
      var from = _a.from,
        to = _a.to,
        l = _a.l,
        r = _a.r;
      addRange(target, from, to);
      if (l) _addRangeSet(target, l);
      if (r) _addRangeSet(target, r);
    }
    if (!isEmptyRange(newSet)) _addRangeSet(target, newSet);
  }
  function rangesOverlap(rangeSet1, rangeSet2) {
    var i1 = getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while (!nextResult1.done && !nextResult2.done) {
      if (cmp(b.from, a.to) <= 0 && cmp(b.to, a.from) >= 0) return true;
      cmp(a.from, b.from) < 0
        ? (a = (nextResult1 = i1.next(b.from)).value)
        : (b = (nextResult2 = i2.next(a.from)).value);
    }
    return false;
  }
  function getRangeSetIterator(node) {
    var state = isEmptyRange(node) ? null : { s: 0, n: node };
    return {
      next: function (key) {
        var keyProvided = arguments.length > 0;
        while (state) {
          switch (state.s) {
            case 0:
              state.s = 1;
              if (keyProvided) {
                while (state.n.l && cmp(key, state.n.from) < 0)
                  state = { up: state, n: state.n.l, s: 1 };
              } else {
                while (state.n.l) state = { up: state, n: state.n.l, s: 1 };
              }
            case 1:
              state.s = 2;
              if (!keyProvided || cmp(key, state.n.to) <= 0)
                return { value: state.n, done: false };
            case 2:
              if (state.n.r) {
                state.s = 3;
                state = { up: state, n: state.n.r, s: 0 };
                continue;
              }
            case 3:
              state = state.up;
          }
        }
        return { done: true };
      },
    };
  }
  function rebalance(target) {
    var _a, _b;
    var diff =
      (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) -
      (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
      var l = r === "r" ? "l" : "r";
      var rootClone = __assign({}, target);
      var oldRootRight = target[r];
      target.from = oldRootRight.from;
      target.to = oldRootRight.to;
      target[r] = oldRootRight[r];
      rootClone[r] = oldRootRight[l];
      target[l] = rootClone;
      rootClone.d = computeDepth(rootClone);
    }
    target.d = computeDepth(target);
  }
  function computeDepth(_a) {
    var r = _a.r,
      l = _a.l;
    return (r ? (l ? Math.max(r.d, l.d) : r.d) : l ? l.d : 0) + 1;
  }

  function extendObservabilitySet(target, newSet) {
    keys(newSet).forEach(function (part) {
      if (target[part]) mergeRanges(target[part], newSet[part]);
      else target[part] = cloneSimpleObjectTree(newSet[part]);
    });
    return target;
  }

  function obsSetsOverlap(os1, os2) {
    return (
      os1.all ||
      os2.all ||
      Object.keys(os1).some(function (key) {
        return os2[key] && rangesOverlap(os2[key], os1[key]);
      })
    );
  }

  var cache = {};

  var unsignaledParts = {};
  var isTaskEnqueued = false;
  function signalSubscribersLazily(part, optimistic) {
    extendObservabilitySet(unsignaledParts, part);
    if (!isTaskEnqueued) {
      isTaskEnqueued = true;
      setTimeout(function () {
        isTaskEnqueued = false;
        var parts = unsignaledParts;
        unsignaledParts = {};
        signalSubscribersNow(parts, false);
      }, 0);
    }
  }
  function signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) {
      deleteAffectedCacheEntries = false;
    }
    var queriesToSignal = new Set();
    if (updatedParts.all) {
      for (var _i = 0, _a = Object.values(cache); _i < _a.length; _i++) {
        var tblCache = _a[_i];
        collectTableSubscribers(
          tblCache,
          updatedParts,
          queriesToSignal,
          deleteAffectedCacheEntries
        );
      }
    } else {
      for (var key in updatedParts) {
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
          var dbName = parts[1],
            tableName = parts[2];
          var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
          if (tblCache)
            collectTableSubscribers(
              tblCache,
              updatedParts,
              queriesToSignal,
              deleteAffectedCacheEntries
            );
        }
      }
    }
    queriesToSignal.forEach(function (requery) {
      return requery();
    });
  }
  function collectTableSubscribers(
    tblCache,
    updatedParts,
    outQueriesToSignal,
    deleteAffectedCacheEntries
  ) {
    var updatedEntryLists = [];
    for (
      var _i = 0, _a = Object.entries(tblCache.queries.query);
      _i < _a.length;
      _i++
    ) {
      var _b = _a[_i],
        indexName = _b[0],
        entries = _b[1];
      var filteredEntries = [];
      for (var _c = 0, entries_1 = entries; _c < entries_1.length; _c++) {
        var entry = entries_1[_c];
        if (obsSetsOverlap(updatedParts, entry.obsSet)) {
          entry.subscribers.forEach(function (requery) {
            return outQueriesToSignal.add(requery);
          });
        } else if (deleteAffectedCacheEntries) {
          filteredEntries.push(entry);
        }
      }
      if (deleteAffectedCacheEntries)
        updatedEntryLists.push([indexName, filteredEntries]);
    }
    if (deleteAffectedCacheEntries) {
      for (
        var _d = 0, updatedEntryLists_1 = updatedEntryLists;
        _d < updatedEntryLists_1.length;
        _d++
      ) {
        var _e = updatedEntryLists_1[_d],
          indexName = _e[0],
          filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
      }
    }
  }

  function dexieOpen(db) {
    var state = db._state;
    var indexedDB = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb)
      return state.dbReadyPromise.then(function () {
        return state.dbOpenError ? rejection(state.dbOpenError) : db;
      });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
      if (state.openCanceller !== openCanceller)
        throw new exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve,
      upgradeTransaction = null,
      wasCreated = false;
    var tryOpenDB = function () {
      return new DexiePromise(function (resolve, reject) {
        throwIfCancelled();
        if (!indexedDB) throw new exceptions.MissingAPI();
        var dbName = db.name;
        var req =
          state.autoSchema || !nativeVerToOpen
            ? indexedDB.open(dbName)
            : indexedDB.open(dbName, nativeVerToOpen);
        if (!req) throw new exceptions.MissingAPI();
        req.onerror = eventRejectHandler(reject);
        req.onblocked = wrap(db._fireOnBlocked);
        req.onupgradeneeded = wrap(function (e) {
          upgradeTransaction = req.transaction;
          if (state.autoSchema && !db._options.allowEmptyDB) {
            req.onerror = preventDefault;
            upgradeTransaction.abort();
            req.result.close();
            var delreq = indexedDB.deleteDatabase(dbName);
            delreq.onsuccess = delreq.onerror = wrap(function () {
              reject(
                new exceptions.NoSuchDatabase(
                  "Database ".concat(dbName, " doesnt exist")
                )
              );
            });
          } else {
            upgradeTransaction.onerror = eventRejectHandler(reject);
            var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
            wasCreated = oldVer < 1;
            db.idbdb = req.result;
            if (schemaPatchMode) {
              patchCurrentVersion(db, upgradeTransaction);
            }
            runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
          }
        }, reject);
        req.onsuccess = wrap(function () {
          upgradeTransaction = null;
          var idbdb = (db.idbdb = req.result);
          var objectStoreNames = slice(idbdb.objectStoreNames);
          if (objectStoreNames.length > 0)
            try {
              var tmpTrans = idbdb.transaction(
                safariMultiStoreFix(objectStoreNames),
                "readonly"
              );
              if (state.autoSchema) readGlobalSchema(db, idbdb, tmpTrans);
              else {
                adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                if (!verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                  console.warn(
                    "Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this."
                  );
                  idbdb.close();
                  nativeVerToOpen = idbdb.version + 1;
                  schemaPatchMode = true;
                  return resolve(tryOpenDB());
                }
              }
              generateMiddlewareStacks(db, tmpTrans);
            } catch (e) {}
          connections.push(db);
          idbdb.onversionchange = wrap(function (ev) {
            state.vcFired = true;
            db.on("versionchange").fire(ev);
          });
          idbdb.onclose = wrap(function (ev) {
            db.on("close").fire(ev);
          });
          if (wasCreated) _onDatabaseCreated(db._deps, dbName);
          resolve();
        }, reject);
      }).catch(function (err) {
        switch (err === null || err === void 0 ? void 0 : err.name) {
          case "UnknownError":
            if (state.PR1398_maxLoop > 0) {
              state.PR1398_maxLoop--;
              console.warn(
                "Dexie: Workaround for Chrome UnknownError on open()"
              );
              return tryOpenDB();
            }
            break;
          case "VersionError":
            if (nativeVerToOpen > 0) {
              nativeVerToOpen = 0;
              return tryOpenDB();
            }
            break;
        }
        return DexiePromise.reject(err);
      });
    };
    return DexiePromise.race([
      openCanceller,
      (typeof navigator === "undefined"
        ? DexiePromise.resolve()
        : idbReady()
      ).then(tryOpenDB),
    ])
      .then(function () {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return DexiePromise.resolve(
          vip(function () {
            return db.on.ready.fire(db.vip);
          })
        ).then(function fireRemainders() {
          if (state.onReadyBeingFired.length > 0) {
            var remainders_1 = state.onReadyBeingFired.reduce(
              promisableChain,
              nop
            );
            state.onReadyBeingFired = [];
            return DexiePromise.resolve(
              vip(function () {
                return remainders_1(db.vip);
              })
            ).then(fireRemainders);
          }
        });
      })
      .finally(function () {
        if (state.openCanceller === openCanceller) {
          state.onReadyBeingFired = null;
          state.isBeingOpened = false;
        }
      })
      .catch(function (err) {
        state.dbOpenError = err;
        try {
          upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) {
          db._close();
        }
        return rejection(err);
      })
      .finally(function () {
        state.openComplete = true;
        resolveDbReady();
      })
      .then(function () {
        if (wasCreated) {
          var everything_1 = {};
          db.tables.forEach(function (table) {
            table.schema.indexes.forEach(function (idx) {
              if (idx.name)
                everything_1[
                  "idb://"
                    .concat(db.name, "/")
                    .concat(table.name, "/")
                    .concat(idx.name)
                ] = new RangeSet(-Infinity, [[[]]]);
            });
            everything_1[
              "idb://".concat(db.name, "/").concat(table.name, "/")
            ] = everything_1[
              "idb://".concat(db.name, "/").concat(table.name, "/:dels")
            ] = new RangeSet(-Infinity, [[[]]]);
          });
          globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
          signalSubscribersNow(everything_1, true);
        }
        return db;
      });
  }

  function awaitIterator(iterator) {
    var callNext = function (result) {
        return iterator.next(result);
      },
      doThrow = function (error) {
        return iterator.throw(error);
      },
      onSuccess = step(callNext),
      onError = step(doThrow);
    function step(getNext) {
      return function (val) {
        var next = getNext(val),
          value = next.value;
        return next.done
          ? value
          : !value || typeof value.then !== "function"
          ? isArray(value)
            ? Promise.all(value).then(onSuccess, onError)
            : onSuccess(value)
          : value.then(onSuccess, onError);
      };
    }
    return step(callNext)();
  }

  function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while (--i) args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = flatten(args);
    return [mode, tables, scopeFunc];
  }
  function enterTransactionScope(
    db,
    mode,
    storeNames,
    parentTransaction,
    scopeFunc
  ) {
    return DexiePromise.resolve().then(function () {
      var transless = PSD.transless || PSD;
      var trans = db._createTransaction(
        mode,
        storeNames,
        db._dbSchema,
        parentTransaction
      );
      trans.explicit = true;
      var zoneProps = {
        trans: trans,
        transless: transless,
      };
      if (parentTransaction) {
        trans.idbtrans = parentTransaction.idbtrans;
      } else {
        try {
          trans.create();
          trans.idbtrans._explicit = true;
          db._state.PR1398_maxLoop = 3;
        } catch (ex) {
          if (
            ex.name === errnames.InvalidState &&
            db.isOpen() &&
            --db._state.PR1398_maxLoop > 0
          ) {
            console.warn("Dexie: Need to reopen db");
            db.close({ disableAutoOpen: false });
            return db.open().then(function () {
              return enterTransactionScope(
                db,
                mode,
                storeNames,
                null,
                scopeFunc
              );
            });
          }
          return rejection(ex);
        }
      }
      var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
      if (scopeFuncIsAsync) {
        incrementExpectedAwaits();
      }
      var returnValue;
      var promiseFollowed = DexiePromise.follow(function () {
        returnValue = scopeFunc.call(trans, trans);
        if (returnValue) {
          if (scopeFuncIsAsync) {
            var decrementor = decrementExpectedAwaits.bind(null, null);
            returnValue.then(decrementor, decrementor);
          } else if (
            typeof returnValue.next === "function" &&
            typeof returnValue.throw === "function"
          ) {
            returnValue = awaitIterator(returnValue);
          }
        }
      }, zoneProps);
      return (
        returnValue && typeof returnValue.then === "function"
          ? DexiePromise.resolve(returnValue).then(function (x) {
              return trans.active
                ? x
                : rejection(
                    new exceptions.PrematureCommit(
                      "Transaction committed too early. See http://bit.ly/2kdckMn"
                    )
                  );
            })
          : promiseFollowed.then(function () {
              return returnValue;
            })
      )
        .then(function (x) {
          if (parentTransaction) trans._resolve();
          return trans._completion.then(function () {
            return x;
          });
        })
        .catch(function (e) {
          trans._reject(e);
          return rejection(e);
        });
    });
  }

  function pad(a, value, count) {
    var result = isArray(a) ? a.slice() : [a];
    for (var i = 0; i < count; ++i) result.push(value);
    return result;
  }
  function createVirtualIndexMiddleware(down) {
    return __assign(__assign({}, down), {
      table: function (tableName) {
        var table = down.table(tableName);
        var schema = table.schema;
        var indexLookup = {};
        var allVirtualIndexes = [];
        function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
          var keyPathAlias = getKeyPathAlias(keyPath);
          var indexList = (indexLookup[keyPathAlias] =
            indexLookup[keyPathAlias] || []);
          var keyLength =
            keyPath == null
              ? 0
              : typeof keyPath === "string"
              ? 1
              : keyPath.length;
          var isVirtual = keyTail > 0;
          var virtualIndex = __assign(__assign({}, lowLevelIndex), {
            name: isVirtual
              ? ""
                  .concat(keyPathAlias, "(virtual-from:")
                  .concat(lowLevelIndex.name, ")")
              : lowLevelIndex.name,
            lowLevelIndex: lowLevelIndex,
            isVirtual: isVirtual,
            keyTail: keyTail,
            keyLength: keyLength,
            extractKey: getKeyExtractor(keyPath),
            unique: !isVirtual && lowLevelIndex.unique,
          });
          indexList.push(virtualIndex);
          if (!virtualIndex.isPrimaryKey) {
            allVirtualIndexes.push(virtualIndex);
          }
          if (keyLength > 1) {
            var virtualKeyPath =
              keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
            addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
          }
          indexList.sort(function (a, b) {
            return a.keyTail - b.keyTail;
          });
          return virtualIndex;
        }
        var primaryKey = addVirtualIndexes(
          schema.primaryKey.keyPath,
          0,
          schema.primaryKey
        );
        indexLookup[":id"] = [primaryKey];
        for (var _i = 0, _a = schema.indexes; _i < _a.length; _i++) {
          var index = _a[_i];
          addVirtualIndexes(index.keyPath, 0, index);
        }
        function findBestIndex(keyPath) {
          var result = indexLookup[getKeyPathAlias(keyPath)];
          return result && result[0];
        }
        function translateRange(range, keyTail) {
          return {
            type: range.type === 1 ? 2 : range.type,
            lower: pad(
              range.lower,
              range.lowerOpen ? down.MAX_KEY : down.MIN_KEY,
              keyTail
            ),
            lowerOpen: true,
            upper: pad(
              range.upper,
              range.upperOpen ? down.MIN_KEY : down.MAX_KEY,
              keyTail
            ),
            upperOpen: true,
          };
        }
        function translateRequest(req) {
          var index = req.query.index;
          return index.isVirtual
            ? __assign(__assign({}, req), {
                query: {
                  index: index.lowLevelIndex,
                  range: translateRange(req.query.range, index.keyTail),
                },
              })
            : req;
        }
        var result = __assign(__assign({}, table), {
          schema: __assign(__assign({}, schema), {
            primaryKey: primaryKey,
            indexes: allVirtualIndexes,
            getIndexByKeyPath: findBestIndex,
          }),
          count: function (req) {
            return table.count(translateRequest(req));
          },
          query: function (req) {
            return table.query(translateRequest(req));
          },
          openCursor: function (req) {
            var _a = req.query.index,
              keyTail = _a.keyTail,
              isVirtual = _a.isVirtual,
              keyLength = _a.keyLength;
            if (!isVirtual) return table.openCursor(req);
            function createVirtualCursor(cursor) {
              function _continue(key) {
                key != null
                  ? cursor.continue(
                      pad(
                        key,
                        req.reverse ? down.MAX_KEY : down.MIN_KEY,
                        keyTail
                      )
                    )
                  : req.unique
                  ? cursor.continue(
                      cursor.key
                        .slice(0, keyLength)
                        .concat(
                          req.reverse ? down.MIN_KEY : down.MAX_KEY,
                          keyTail
                        )
                    )
                  : cursor.continue();
              }
              var virtualCursor = Object.create(cursor, {
                continue: { value: _continue },
                continuePrimaryKey: {
                  value: function (key, primaryKey) {
                    cursor.continuePrimaryKey(
                      pad(key, down.MAX_KEY, keyTail),
                      primaryKey
                    );
                  },
                },
                primaryKey: {
                  get: function () {
                    return cursor.primaryKey;
                  },
                },
                key: {
                  get: function () {
                    var key = cursor.key;
                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                  },
                },
                value: {
                  get: function () {
                    return cursor.value;
                  },
                },
              });
              return virtualCursor;
            }
            return table
              .openCursor(translateRequest(req))
              .then(function (cursor) {
                return cursor && createVirtualCursor(cursor);
              });
          },
        });
        return result;
      },
    });
  }
  var virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: createVirtualIndexMiddleware,
  };

  function getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    keys(a).forEach(function (prop) {
      if (!hasOwn(b, prop)) {
        rv[prfx + prop] = undefined;
      } else {
        var ap = a[prop],
          bp = b[prop];
        if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
          var apTypeName = toStringTag(ap);
          var bpTypeName = toStringTag(bp);
          if (apTypeName !== bpTypeName) {
            rv[prfx + prop] = b[prop];
          } else if (apTypeName === "Object") {
            getObjectDiff(ap, bp, rv, prfx + prop + ".");
          } else if (ap !== bp) {
            rv[prfx + prop] = b[prop];
          }
        } else if (ap !== bp) rv[prfx + prop] = b[prop];
      }
    });
    keys(b).forEach(function (prop) {
      if (!hasOwn(a, prop)) {
        rv[prfx + prop] = b[prop];
      }
    });
    return rv;
  }

  function getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
  }

  var hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function (downCore) {
      return __assign(__assign({}, downCore), {
        table: function (tableName) {
          var downTable = downCore.table(tableName);
          var primaryKey = downTable.schema.primaryKey;
          var tableMiddleware = __assign(__assign({}, downTable), {
            mutate: function (req) {
              var dxTrans = PSD.trans;
              var _a = dxTrans.table(tableName).hook,
                deleting = _a.deleting,
                creating = _a.creating,
                updating = _a.updating;
              switch (req.type) {
                case "add":
                  if (creating.fire === nop) break;
                  return dxTrans._promise(
                    "readwrite",
                    function () {
                      return addPutOrDelete(req);
                    },
                    true
                  );
                case "put":
                  if (creating.fire === nop && updating.fire === nop) break;
                  return dxTrans._promise(
                    "readwrite",
                    function () {
                      return addPutOrDelete(req);
                    },
                    true
                  );
                case "delete":
                  if (deleting.fire === nop) break;
                  return dxTrans._promise(
                    "readwrite",
                    function () {
                      return addPutOrDelete(req);
                    },
                    true
                  );
                case "deleteRange":
                  if (deleting.fire === nop) break;
                  return dxTrans._promise(
                    "readwrite",
                    function () {
                      return deleteRange(req);
                    },
                    true
                  );
              }
              return downTable.mutate(req);
              function addPutOrDelete(req) {
                var dxTrans = PSD.trans;
                var keys = req.keys || getEffectiveKeys(primaryKey, req);
                if (!keys) throw new Error("Keys missing");
                req =
                  req.type === "add" || req.type === "put"
                    ? __assign(__assign({}, req), { keys: keys })
                    : __assign({}, req);
                if (req.type !== "delete")
                  req.values = __spreadArray([], req.values, true);
                if (req.keys) req.keys = __spreadArray([], req.keys, true);
                return getExistingValues(downTable, req, keys).then(function (
                  existingValues
                ) {
                  var contexts = keys.map(function (key, i) {
                    var existingValue = existingValues[i];
                    var ctx = { onerror: null, onsuccess: null };
                    if (req.type === "delete") {
                      deleting.fire.call(ctx, key, existingValue, dxTrans);
                    } else if (
                      req.type === "add" ||
                      existingValue === undefined
                    ) {
                      var generatedPrimaryKey = creating.fire.call(
                        ctx,
                        key,
                        req.values[i],
                        dxTrans
                      );
                      if (key == null && generatedPrimaryKey != null) {
                        key = generatedPrimaryKey;
                        req.keys[i] = key;
                        if (!primaryKey.outbound) {
                          setByKeyPath(req.values[i], primaryKey.keyPath, key);
                        }
                      }
                    } else {
                      var objectDiff = getObjectDiff(
                        existingValue,
                        req.values[i]
                      );
                      var additionalChanges_1 = updating.fire.call(
                        ctx,
                        objectDiff,
                        key,
                        existingValue,
                        dxTrans
                      );
                      if (additionalChanges_1) {
                        var requestedValue_1 = req.values[i];
                        Object.keys(additionalChanges_1).forEach(function (
                          keyPath
                        ) {
                          if (hasOwn(requestedValue_1, keyPath)) {
                            requestedValue_1[keyPath] =
                              additionalChanges_1[keyPath];
                          } else {
                            setByKeyPath(
                              requestedValue_1,
                              keyPath,
                              additionalChanges_1[keyPath]
                            );
                          }
                        });
                      }
                    }
                    return ctx;
                  });
                  return downTable
                    .mutate(req)
                    .then(function (_a) {
                      var failures = _a.failures,
                        results = _a.results,
                        numFailures = _a.numFailures,
                        lastResult = _a.lastResult;
                      for (var i = 0; i < keys.length; ++i) {
                        var primKey = results ? results[i] : keys[i];
                        var ctx = contexts[i];
                        if (primKey == null) {
                          ctx.onerror && ctx.onerror(failures[i]);
                        } else {
                          ctx.onsuccess &&
                            ctx.onsuccess(
                              req.type === "put" && existingValues[i]
                                ? req.values[i]
                                : primKey
                            );
                        }
                      }
                      return {
                        failures: failures,
                        results: results,
                        numFailures: numFailures,
                        lastResult: lastResult,
                      };
                    })
                    .catch(function (error) {
                      contexts.forEach(function (ctx) {
                        return ctx.onerror && ctx.onerror(error);
                      });
                      return Promise.reject(error);
                    });
                });
              }
              function deleteRange(req) {
                return deleteNextChunk(req.trans, req.range, 10000);
              }
              function deleteNextChunk(trans, range, limit) {
                return downTable
                  .query({
                    trans: trans,
                    values: false,
                    query: { index: primaryKey, range: range },
                    limit: limit,
                  })
                  .then(function (_a) {
                    var result = _a.result;
                    return addPutOrDelete({
                      type: "delete",
                      keys: result,
                      trans: trans,
                    }).then(function (res) {
                      if (res.numFailures > 0)
                        return Promise.reject(res.failures[0]);
                      if (result.length < limit) {
                        return {
                          failures: [],
                          numFailures: 0,
                          lastResult: undefined,
                        };
                      } else {
                        return deleteNextChunk(
                          trans,
                          __assign(__assign({}, range), {
                            lower: result[result.length - 1],
                            lowerOpen: true,
                          }),
                          limit
                        );
                      }
                    });
                  });
              }
            },
          });
          return tableMiddleware;
        },
      });
    },
  };
  function getExistingValues(table, req, effectiveKeys) {
    return req.type === "add"
      ? Promise.resolve([])
      : table.getMany({
          trans: req.trans,
          keys: effectiveKeys,
          cache: "immutable",
        });
  }

  function getFromTransactionCache(keys, cache, clone) {
    try {
      if (!cache) return null;
      if (cache.keys.length < keys.length) return null;
      var result = [];
      for (var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i) {
        if (cmp(cache.keys[i], keys[j]) !== 0) continue;
        result.push(clone ? deepClone(cache.values[i]) : cache.values[i]);
        ++j;
      }
      return result.length === keys.length ? result : null;
    } catch (_a) {
      return null;
    }
  }
  var cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function (core) {
      return {
        table: function (tableName) {
          var table = core.table(tableName);
          return __assign(__assign({}, table), {
            getMany: function (req) {
              if (!req.cache) {
                return table.getMany(req);
              }
              var cachedResult = getFromTransactionCache(
                req.keys,
                req.trans["_cache"],
                req.cache === "clone"
              );
              if (cachedResult) {
                return DexiePromise.resolve(cachedResult);
              }
              return table.getMany(req).then(function (res) {
                req.trans["_cache"] = {
                  keys: req.keys,
                  values: req.cache === "clone" ? deepClone(res) : res,
                };
                return res;
              });
            },
            mutate: function (req) {
              if (req.type !== "add") req.trans["_cache"] = null;
              return table.mutate(req);
            },
          });
        },
      };
    },
  };

  function isCachableContext(ctx, table) {
    return (
      ctx.trans.mode === "readonly" &&
      !!ctx.subscr &&
      !ctx.trans.explicit &&
      ctx.trans.db._options.cache !== "disabled" &&
      !table.schema.primaryKey.outbound
    );
  }

  function isCachableRequest(type, req) {
    switch (type) {
      case "query":
        return req.values && !req.unique;
      case "get":
        return false;
      case "getMany":
        return false;
      case "count":
        return false;
      case "openCursor":
        return false;
    }
  }

  var observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function (core) {
      var dbName = core.schema.name;
      var FULL_RANGE = new RangeSet(core.MIN_KEY, core.MAX_KEY);
      return __assign(__assign({}, core), {
        transaction: function (stores, mode, options) {
          if (PSD.subscr && mode !== "readonly") {
            throw new exceptions.ReadOnly(
              "Readwrite transaction in liveQuery context. Querier source: ".concat(
                PSD.querier
              )
            );
          }
          return core.transaction(stores, mode, options);
        },
        table: function (tableName) {
          var table = core.table(tableName);
          var schema = table.schema;
          var primaryKey = schema.primaryKey,
            indexes = schema.indexes;
          var extractKey = primaryKey.extractKey,
            outbound = primaryKey.outbound;
          var indexesWithAutoIncPK =
            primaryKey.autoIncrement &&
            indexes.filter(function (index) {
              return (
                index.compound && index.keyPath.includes(primaryKey.keyPath)
              );
            });
          var tableClone = __assign(__assign({}, table), {
            mutate: function (req) {
              var trans = req.trans;
              var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
              var getRangeSet = function (indexName) {
                var part = "idb://"
                  .concat(dbName, "/")
                  .concat(tableName, "/")
                  .concat(indexName);
                return (
                  mutatedParts[part] || (mutatedParts[part] = new RangeSet())
                );
              };
              var pkRangeSet = getRangeSet("");
              var delsRangeSet = getRangeSet(":dels");
              var type = req.type;
              var _a =
                  req.type === "deleteRange"
                    ? [req.range]
                    : req.type === "delete"
                    ? [req.keys]
                    : req.values.length < 50
                    ? [
                        getEffectiveKeys(primaryKey, req).filter(function (id) {
                          return id;
                        }),
                        req.values,
                      ]
                    : [],
                keys = _a[0],
                newObjs = _a[1];
              var oldCache = req.trans["_cache"];
              if (isArray(keys)) {
                pkRangeSet.addKeys(keys);
                var oldObjs =
                  type === "delete" || keys.length === newObjs.length
                    ? getFromTransactionCache(keys, oldCache)
                    : null;
                if (!oldObjs) {
                  delsRangeSet.addKeys(keys);
                }
                if (oldObjs || newObjs) {
                  trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                }
              } else if (keys) {
                var range = { from: keys.lower, to: keys.upper };
                delsRangeSet.add(range);
                pkRangeSet.add(range);
              } else {
                pkRangeSet.add(FULL_RANGE);
                delsRangeSet.add(FULL_RANGE);
                schema.indexes.forEach(function (idx) {
                  return getRangeSet(idx.name).add(FULL_RANGE);
                });
              }
              return table.mutate(req).then(function (res) {
                if (keys && (req.type === "add" || req.type === "put")) {
                  pkRangeSet.addKeys(res.results);
                  if (indexesWithAutoIncPK) {
                    indexesWithAutoIncPK.forEach(function (idx) {
                      var idxVals = req.values.map(function (v) {
                        return idx.extractKey(v);
                      });
                      var pkPos = idx.keyPath.findIndex(function (prop) {
                        return prop === primaryKey.keyPath;
                      });
                      res.results.forEach(function (pk) {
                        return (idxVals[pkPos] = pk);
                      });
                      getRangeSet(idx.name).addKeys(idxVals);
                    });
                  }
                }
                trans.mutatedParts = extendObservabilitySet(
                  trans.mutatedParts || {},
                  mutatedParts
                );
                return res;
              });
            },
          });
          var getRange = function (_a) {
            var _b, _c;
            var _d = _a.query,
              index = _d.index,
              range = _d.range;
            return [
              index,
              new RangeSet(
                (_b = range.lower) !== null && _b !== void 0
                  ? _b
                  : core.MIN_KEY,
                (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY
              ),
            ];
          };
          var readSubscribers = {
            get: function (req) {
              return [primaryKey, new RangeSet(req.key)];
            },
            getMany: function (req) {
              return [primaryKey, new RangeSet().addKeys(req.keys)];
            },
            count: getRange,
            query: getRange,
            openCursor: getRange,
          };
          keys(readSubscribers).forEach(function (method) {
            tableClone[method] = function (req) {
              var subscr = PSD.subscr;
              var isLiveQuery = !!subscr;
              var cachable =
                isCachableContext(PSD, table) && isCachableRequest(method, req);
              var obsSet = cachable ? (req.obsSet = {}) : subscr;
              if (isLiveQuery) {
                var getRangeSet = function (indexName) {
                  var part = "idb://"
                    .concat(dbName, "/")
                    .concat(tableName, "/")
                    .concat(indexName);
                  return obsSet[part] || (obsSet[part] = new RangeSet());
                };
                var pkRangeSet_1 = getRangeSet("");
                var delsRangeSet_1 = getRangeSet(":dels");
                var _a = readSubscribers[method](req),
                  queriedIndex = _a[0],
                  queriedRanges = _a[1];
                if (
                  method === "query" &&
                  queriedIndex.isPrimaryKey &&
                  !req.values
                ) {
                  delsRangeSet_1.add(queriedRanges);
                } else {
                  getRangeSet(queriedIndex.name || "").add(queriedRanges);
                }
                if (!queriedIndex.isPrimaryKey) {
                  if (method === "count") {
                    delsRangeSet_1.add(FULL_RANGE);
                  } else {
                    var keysPromise_1 =
                      method === "query" &&
                      outbound &&
                      req.values &&
                      table.query(
                        __assign(__assign({}, req), { values: false })
                      );
                    return table[method]
                      .apply(this, arguments)
                      .then(function (res) {
                        if (method === "query") {
                          if (outbound && req.values) {
                            return keysPromise_1.then(function (_a) {
                              var resultingKeys = _a.result;
                              pkRangeSet_1.addKeys(resultingKeys);
                              return res;
                            });
                          }
                          var pKeys = req.values
                            ? res.result.map(extractKey)
                            : res.result;
                          if (req.values) {
                            pkRangeSet_1.addKeys(pKeys);
                          } else {
                            delsRangeSet_1.addKeys(pKeys);
                          }
                        } else if (method === "openCursor") {
                          var cursor_1 = res;
                          var wantValues_1 = req.values;
                          return (
                            cursor_1 &&
                            Object.create(cursor_1, {
                              key: {
                                get: function () {
                                  delsRangeSet_1.addKey(cursor_1.primaryKey);
                                  return cursor_1.key;
                                },
                              },
                              primaryKey: {
                                get: function () {
                                  var pkey = cursor_1.primaryKey;
                                  delsRangeSet_1.addKey(pkey);
                                  return pkey;
                                },
                              },
                              value: {
                                get: function () {
                                  wantValues_1 &&
                                    pkRangeSet_1.addKey(cursor_1.primaryKey);
                                  return cursor_1.value;
                                },
                              },
                            })
                          );
                        }
                        return res;
                      });
                  }
                }
              }
              return table[method].apply(this, arguments);
            };
          });
          return tableClone;
        },
      });
    },
  };
  function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
      var rangeSet = getRangeSet(ix.name || "");
      function extractKey(obj) {
        return obj != null ? ix.extractKey(obj) : null;
      }
      var addKeyOrKeys = function (key) {
        return ix.multiEntry && isArray(key)
          ? key.forEach(function (key) {
              return rangeSet.addKey(key);
            })
          : rangeSet.addKey(key);
      };
      (oldObjs || newObjs).forEach(function (_, i) {
        var oldKey = oldObjs && extractKey(oldObjs[i]);
        var newKey = newObjs && extractKey(newObjs[i]);
        if (cmp(oldKey, newKey) !== 0) {
          if (oldKey != null) addKeyOrKeys(oldKey);
          if (newKey != null) addKeyOrKeys(newKey);
        }
      });
    }
    schema.indexes.forEach(addAffectedIndex);
  }

  function adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === "deleteRange") {
      return null;
    }
    var numBulkOps = req.keys
      ? req.keys.length
      : "values" in req && req.values
      ? req.values.length
      : 1;
    if (res.numFailures === numBulkOps) {
      return null;
    }
    var clone = __assign({}, req);
    if (isArray(clone.keys)) {
      clone.keys = clone.keys.filter(function (_, i) {
        return !(i in res.failures);
      });
    }
    if ("values" in clone && isArray(clone.values)) {
      clone.values = clone.values.filter(function (_, i) {
        return !(i in res.failures);
      });
    }
    return clone;
  }

  function isAboveLower(key, range) {
    return range.lower === undefined
      ? true
      : range.lowerOpen
      ? cmp(key, range.lower) > 0
      : cmp(key, range.lower) >= 0;
  }
  function isBelowUpper(key, range) {
    return range.upper === undefined
      ? true
      : range.upperOpen
      ? cmp(key, range.upper) < 0
      : cmp(key, range.upper) <= 0;
  }
  function isWithinRange(key, range) {
    return isAboveLower(key, range) && isBelowUpper(key, range);
  }

  function applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function (result, op) {
      var modifedResult = result;
      var includedValues = [];
      if (op.type === "add" || op.type === "put") {
        var includedPKs = new RangeSet();
        for (var i = op.values.length - 1; i >= 0; --i) {
          var value = op.values[i];
          var pk = extractPrimKey(value);
          if (includedPKs.hasKey(pk)) continue;
          var key = extractIndex(value);
          if (
            multiEntry && isArray(key)
              ? key.some(function (k) {
                  return isWithinRange(k, queryRange);
                })
              : isWithinRange(key, queryRange)
          ) {
            includedPKs.addKey(pk);
            includedValues.push(value);
          }
        }
      }
      switch (op.type) {
        case "add":
          modifedResult = result.concat(
            req.values
              ? includedValues
              : includedValues.map(function (v) {
                  return extractPrimKey(v);
                })
          );
          break;
        case "put":
          var keySet_1 = new RangeSet().addKeys(
            op.values.map(function (v) {
              return extractPrimKey(v);
            })
          );
          modifedResult = result
            .filter(function (item) {
              return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
            })
            .concat(
              req.values
                ? includedValues
                : includedValues.map(function (v) {
                    return extractPrimKey(v);
                  })
            );
          break;
        case "delete":
          var keysToDelete_1 = new RangeSet().addKeys(op.keys);
          modifedResult = result.filter(function (item) {
            return !keysToDelete_1.hasKey(
              req.values ? extractPrimKey(item) : item
            );
          });
          break;
        case "deleteRange":
          var range_1 = op.range;
          modifedResult = result.filter(function (item) {
            return !isWithinRange(extractPrimKey(item), range_1);
          });
          break;
      }
      return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function (a, b) {
      return (
        cmp(extractLowLevelIndex(a), extractLowLevelIndex(b)) ||
        cmp(extractPrimKey(a), extractPrimKey(b))
      );
    });
    if (req.limit && req.limit < Infinity) {
      if (finalResult.length > req.limit) {
        finalResult.length = req.limit;
      } else if (
        result.length === req.limit &&
        finalResult.length < req.limit
      ) {
        cacheEntry.dirty = true;
      }
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
  }

  function areRangesEqual(r1, r2) {
    return (
      cmp(r1.lower, r2.lower) === 0 &&
      cmp(r1.upper, r2.upper) === 0 &&
      !!r1.lowerOpen === !!r2.lowerOpen &&
      !!r1.upperOpen === !!r2.upperOpen
    );
  }

  function compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = cmp(lower1, lower2);
    if (c === 0) {
      if (lowerOpen1 && lowerOpen2) return 0;
      if (lowerOpen1) return 1;
      if (lowerOpen2) return -1;
    }
    return c;
  }
  function compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = cmp(upper1, upper2);
    if (c === 0) {
      if (upperOpen1 && upperOpen2) return 0;
      if (upperOpen1) return -1;
      if (upperOpen2) return 1;
    }
    return c;
  }
  function isSuperRange(r1, r2) {
    return (
      compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 &&
      compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0
    );
  }

  function findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [null, false, tblCache, null];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ""];
    if (!entries) return [null, false, tblCache, null];
    switch (type) {
      case "query":
        var equalEntry = entries.find(function (entry) {
          return (
            entry.req.limit === req.limit &&
            entry.req.values === req.values &&
            areRangesEqual(entry.req.query.range, req.query.range)
          );
        });
        if (equalEntry) return [equalEntry, true, tblCache, entries];
        var superEntry = entries.find(function (entry) {
          var limit = "limit" in entry.req ? entry.req.limit : Infinity;
          return (
            limit >= req.limit &&
            (req.values ? entry.req.values : true) &&
            isSuperRange(entry.req.query.range, req.query.range)
          );
        });
        return [superEntry, false, tblCache, entries];
      case "count":
        var countQuery = entries.find(function (entry) {
          return areRangesEqual(entry.req.query.range, req.query.range);
        });
        return [countQuery, !!countQuery, tblCache, entries];
    }
  }

  function subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function () {
      cacheEntry.subscribers.delete(requery);
      if (cacheEntry.subscribers.size === 0) {
        enqueForDeletion(cacheEntry, container);
      }
    });
  }
  function enqueForDeletion(cacheEntry, container) {
    setTimeout(function () {
      if (cacheEntry.subscribers.size === 0) {
        delArrayItem(container, cacheEntry);
      }
    }, 3000);
  }

  var cacheMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Cache",
    create: function (core) {
      var dbName = core.schema.name;
      var coreMW = __assign(__assign({}, core), {
        transaction: function (stores, mode, options) {
          var idbtrans = core.transaction(stores, mode, options);
          if (mode === "readwrite") {
            var ac_1 = new AbortController();
            var signal = ac_1.signal;
            var endTransaction = function (wasCommitted) {
              return function () {
                ac_1.abort();
                if (mode === "readwrite") {
                  var affectedSubscribers_1 = new Set();
                  for (
                    var _i = 0, stores_1 = stores;
                    _i < stores_1.length;
                    _i++
                  ) {
                    var storeName = stores_1[_i];
                    var tblCache =
                      cache["idb://".concat(dbName, "/").concat(storeName)];
                    if (tblCache) {
                      var table = core.table(storeName);
                      var ops = tblCache.optimisticOps.filter(function (op) {
                        return op.trans === idbtrans;
                      });
                      if (
                        idbtrans._explicit &&
                        wasCommitted &&
                        idbtrans.mutatedParts
                      ) {
                        for (
                          var _a = 0,
                            _b = Object.values(tblCache.queries.query);
                          _a < _b.length;
                          _a++
                        ) {
                          var entries = _b[_a];
                          for (
                            var _c = 0, _d = entries.slice();
                            _c < _d.length;
                            _c++
                          ) {
                            var entry = _d[_c];
                            if (
                              obsSetsOverlap(
                                entry.obsSet,
                                idbtrans.mutatedParts
                              )
                            ) {
                              delArrayItem(entries, entry);
                              entry.subscribers.forEach(function (requery) {
                                return affectedSubscribers_1.add(requery);
                              });
                            }
                          }
                        }
                      } else if (ops.length > 0) {
                        tblCache.optimisticOps = tblCache.optimisticOps.filter(
                          function (op) {
                            return op.trans !== idbtrans;
                          }
                        );
                        for (
                          var _e = 0,
                            _f = Object.values(tblCache.queries.query);
                          _e < _f.length;
                          _e++
                        ) {
                          var entries = _f[_e];
                          for (
                            var _g = 0, _h = entries.slice();
                            _g < _h.length;
                            _g++
                          ) {
                            var entry = _h[_g];
                            if (entry.res != null && idbtrans.mutatedParts) {
                              if (wasCommitted && !entry.dirty) {
                                var freezeResults = Object.isFrozen(entry.res);
                                var modRes = applyOptimisticOps(
                                  entry.res,
                                  entry.req,
                                  ops,
                                  table,
                                  entry,
                                  freezeResults
                                );
                                if (entry.dirty) {
                                  delArrayItem(entries, entry);
                                  entry.subscribers.forEach(function (requery) {
                                    return affectedSubscribers_1.add(requery);
                                  });
                                } else if (modRes !== entry.res) {
                                  entry.res = modRes;
                                  entry.promise = DexiePromise.resolve({
                                    result: modRes,
                                  });
                                }
                              } else {
                                if (entry.dirty) {
                                  delArrayItem(entries, entry);
                                }
                                entry.subscribers.forEach(function (requery) {
                                  return affectedSubscribers_1.add(requery);
                                });
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  affectedSubscribers_1.forEach(function (requery) {
                    return requery();
                  });
                }
              };
            };
            idbtrans.addEventListener("abort", endTransaction(false), {
              signal: signal,
            });
            idbtrans.addEventListener("error", endTransaction(false), {
              signal: signal,
            });
            idbtrans.addEventListener("complete", endTransaction(true), {
              signal: signal,
            });
          }
          return idbtrans;
        },
        table: function (tableName) {
          var downTable = core.table(tableName);
          var primKey = downTable.schema.primaryKey;
          var tableMW = __assign(__assign({}, downTable), {
            mutate: function (req) {
              var trans = PSD.trans;
              if (
                primKey.outbound ||
                trans.db._options.cache === "disabled" ||
                trans.explicit
              ) {
                return downTable.mutate(req);
              }
              var tblCache =
                cache["idb://".concat(dbName, "/").concat(tableName)];
              if (!tblCache) return downTable.mutate(req);
              var promise = downTable.mutate(req);
              if (
                (req.type === "add" || req.type === "put") &&
                (req.values.length >= 50 ||
                  getEffectiveKeys(primKey, req).some(function (key) {
                    return key == null;
                  }))
              ) {
                promise.then(function (res) {
                  var reqWithResolvedKeys = __assign(__assign({}, req), {
                    values: req.values.map(function (value, i) {
                      var _a;
                      var valueWithKey = (
                        (_a = primKey.keyPath) === null || _a === void 0
                          ? void 0
                          : _a.includes(".")
                      )
                        ? deepClone(value)
                        : __assign({}, value);
                      setByKeyPath(
                        valueWithKey,
                        primKey.keyPath,
                        res.results[i]
                      );
                      return valueWithKey;
                    }),
                  });
                  var adjustedReq = adjustOptimisticFromFailures(
                    tblCache,
                    reqWithResolvedKeys,
                    res
                  );
                  tblCache.optimisticOps.push(adjustedReq);
                  queueMicrotask(function () {
                    return (
                      req.mutatedParts &&
                      signalSubscribersLazily(req.mutatedParts)
                    );
                  });
                });
              } else {
                tblCache.optimisticOps.push(req);
                req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                promise.then(function (res) {
                  if (res.numFailures > 0) {
                    delArrayItem(tblCache.optimisticOps, req);
                    var adjustedReq = adjustOptimisticFromFailures(
                      tblCache,
                      req,
                      res
                    );
                    if (adjustedReq) {
                      tblCache.optimisticOps.push(adjustedReq);
                    }
                    req.mutatedParts &&
                      signalSubscribersLazily(req.mutatedParts);
                  }
                });
                promise.catch(function () {
                  delArrayItem(tblCache.optimisticOps, req);
                  req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                });
              }
              return promise;
            },
            query: function (req) {
              var _a;
              if (
                !isCachableContext(PSD, downTable) ||
                !isCachableRequest("query", req)
              )
                return downTable.query(req);
              var freezeResults =
                ((_a = PSD.trans) === null || _a === void 0
                  ? void 0
                  : _a.db._options.cache) === "immutable";
              var _b = PSD,
                requery = _b.requery,
                signal = _b.signal;
              var _c = findCompatibleQuery(dbName, tableName, "query", req),
                cacheEntry = _c[0],
                exactMatch = _c[1],
                tblCache = _c[2],
                container = _c[3];
              if (cacheEntry && exactMatch) {
                cacheEntry.obsSet = req.obsSet;
              } else {
                var promise = downTable
                  .query(req)
                  .then(function (res) {
                    var result = res.result;
                    if (cacheEntry) cacheEntry.res = result;
                    if (freezeResults) {
                      for (var i = 0, l = result.length; i < l; ++i) {
                        Object.freeze(result[i]);
                      }
                      Object.freeze(result);
                    } else {
                      res.result = deepClone(result);
                    }
                    return res;
                  })
                  .catch(function (error) {
                    if (container && cacheEntry)
                      delArrayItem(container, cacheEntry);
                    return Promise.reject(error);
                  });
                cacheEntry = {
                  obsSet: req.obsSet,
                  promise: promise,
                  subscribers: new Set(),
                  type: "query",
                  req: req,
                  dirty: false,
                };
                if (container) {
                  container.push(cacheEntry);
                } else {
                  container = [cacheEntry];
                  if (!tblCache) {
                    tblCache = cache[
                      "idb://".concat(dbName, "/").concat(tableName)
                    ] = {
                      queries: {
                        query: {},
                        count: {},
                      },
                      objs: new Map(),
                      optimisticOps: [],
                      unsignaledParts: {},
                    };
                  }
                  tblCache.queries.query[req.query.index.name || ""] =
                    container;
                }
              }
              subscribeToCacheEntry(cacheEntry, container, requery, signal);
              return cacheEntry.promise.then(function (res) {
                return {
                  result: applyOptimisticOps(
                    res.result,
                    req,
                    tblCache === null || tblCache === void 0
                      ? void 0
                      : tblCache.optimisticOps,
                    downTable,
                    cacheEntry,
                    freezeResults
                  ),
                };
              });
            },
          });
          return tableMW;
        },
      });
      return coreMW;
    },
  };

  function vipify(target, vipDb) {
    return new Proxy(target, {
      get: function (target, prop, receiver) {
        if (prop === "db") return vipDb;
        return Reflect.get(target, prop, receiver);
      },
    });
  }

  var Dexie$1 = (function () {
    function Dexie(name, options) {
      var _this = this;
      this._middlewares = {};
      this.verno = 0;
      var deps = Dexie.dependencies;
      this._options = options = __assign(
        {
          addons: Dexie.addons,
          autoOpen: true,
          indexedDB: deps.indexedDB,
          IDBKeyRange: deps.IDBKeyRange,
          cache: "cloned",
        },
        options
      );
      this._deps = {
        indexedDB: options.indexedDB,
        IDBKeyRange: options.IDBKeyRange,
      };
      var addons = options.addons;
      this._dbSchema = {};
      this._versions = [];
      this._storeNames = [];
      this._allTables = {};
      this.idbdb = null;
      this._novip = this;
      var state = {
        dbOpenError: null,
        isBeingOpened: false,
        onReadyBeingFired: null,
        openComplete: false,
        dbReadyResolve: nop,
        dbReadyPromise: null,
        cancelOpen: nop,
        openCanceller: null,
        autoSchema: true,
        PR1398_maxLoop: 3,
        autoOpen: options.autoOpen,
      };
      state.dbReadyPromise = new DexiePromise(function (resolve) {
        state.dbReadyResolve = resolve;
      });
      state.openCanceller = new DexiePromise(function (_, reject) {
        state.cancelOpen = reject;
      });
      this._state = state;
      this.name = name;
      this.on = Events(this, "populate", "blocked", "versionchange", "close", {
        ready: [promisableChain, nop],
      });
      this.on.ready.subscribe = override(
        this.on.ready.subscribe,
        function (subscribe) {
          return function (subscriber, bSticky) {
            Dexie.vip(function () {
              var state = _this._state;
              if (state.openComplete) {
                if (!state.dbOpenError) DexiePromise.resolve().then(subscriber);
                if (bSticky) subscribe(subscriber);
              } else if (state.onReadyBeingFired) {
                state.onReadyBeingFired.push(subscriber);
                if (bSticky) subscribe(subscriber);
              } else {
                subscribe(subscriber);
                var db_1 = _this;
                if (!bSticky)
                  subscribe(function unsubscribe() {
                    db_1.on.ready.unsubscribe(subscriber);
                    db_1.on.ready.unsubscribe(unsubscribe);
                  });
              }
            });
          };
        }
      );
      this.Collection = createCollectionConstructor(this);
      this.Table = createTableConstructor(this);
      this.Transaction = createTransactionConstructor(this);
      this.Version = createVersionConstructor(this);
      this.WhereClause = createWhereClauseConstructor(this);
      this.on("versionchange", function (ev) {
        if (ev.newVersion > 0)
          console.warn(
            "Another connection wants to upgrade database '".concat(
              _this.name,
              "'. Closing db now to resume the upgrade."
            )
          );
        else
          console.warn(
            "Another connection wants to delete database '".concat(
              _this.name,
              "'. Closing db now to resume the delete request."
            )
          );
        _this.close({ disableAutoOpen: false });
      });
      this.on("blocked", function (ev) {
        if (!ev.newVersion || ev.newVersion < ev.oldVersion)
          console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
        else
          console.warn(
            "Upgrade '"
              .concat(
                _this.name,
                "' blocked by other connection holding version "
              )
              .concat(ev.oldVersion / 10)
          );
      });
      this._maxKey = getMaxKey(options.IDBKeyRange);
      this._createTransaction = function (
        mode,
        storeNames,
        dbschema,
        parentTransaction
      ) {
        return new _this.Transaction(
          mode,
          storeNames,
          dbschema,
          _this._options.chromeTransactionDurability,
          parentTransaction
        );
      };
      this._fireOnBlocked = function (ev) {
        _this.on("blocked").fire(ev);
        connections
          .filter(function (c) {
            return c.name === _this.name && c !== _this && !c._state.vcFired;
          })
          .map(function (c) {
            return c.on("versionchange").fire(ev);
          });
      };
      this.use(cacheExistingValuesMiddleware);
      this.use(cacheMiddleware);
      this.use(observabilityMiddleware);
      this.use(virtualIndexMiddleware);
      this.use(hooksMiddleware);
      var vipDB = new Proxy(this, {
        get: function (_, prop, receiver) {
          if (prop === "_vip") return true;
          if (prop === "table")
            return function (tableName) {
              return vipify(_this.table(tableName), vipDB);
            };
          var rv = Reflect.get(_, prop, receiver);
          if (rv instanceof Table) return vipify(rv, vipDB);
          if (prop === "tables")
            return rv.map(function (t) {
              return vipify(t, vipDB);
            });
          if (prop === "_createTransaction")
            return function () {
              var tx = rv.apply(this, arguments);
              return vipify(tx, vipDB);
            };
          return rv;
        },
      });
      this.vip = vipDB;
      addons.forEach(function (addon) {
        return addon(_this);
      });
    }
    Dexie.prototype.version = function (versionNumber) {
      if (isNaN(versionNumber) || versionNumber < 0.1)
        throw new exceptions.Type("Given version is not a positive number");
      versionNumber = Math.round(versionNumber * 10) / 10;
      if (this.idbdb || this._state.isBeingOpened)
        throw new exceptions.Schema("Cannot add version when database is open");
      this.verno = Math.max(this.verno, versionNumber);
      var versions = this._versions;
      var versionInstance = versions.filter(function (v) {
        return v._cfg.version === versionNumber;
      })[0];
      if (versionInstance) return versionInstance;
      versionInstance = new this.Version(versionNumber);
      versions.push(versionInstance);
      versions.sort(lowerVersionFirst);
      versionInstance.stores({});
      this._state.autoSchema = false;
      return versionInstance;
    };
    Dexie.prototype._whenReady = function (fn) {
      var _this = this;
      return this.idbdb &&
        (this._state.openComplete || PSD.letThrough || this._vip)
        ? fn()
        : new DexiePromise(function (resolve, reject) {
            if (_this._state.openComplete) {
              return reject(
                new exceptions.DatabaseClosed(_this._state.dbOpenError)
              );
            }
            if (!_this._state.isBeingOpened) {
              if (!_this._state.autoOpen) {
                reject(new exceptions.DatabaseClosed());
                return;
              }
              _this.open().catch(nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
          }).then(fn);
    };
    Dexie.prototype.use = function (_a) {
      var stack = _a.stack,
        create = _a.create,
        level = _a.level,
        name = _a.name;
      if (name) this.unuse({ stack: stack, name: name });
      var middlewares =
        this._middlewares[stack] || (this._middlewares[stack] = []);
      middlewares.push({
        stack: stack,
        create: create,
        level: level == null ? 10 : level,
        name: name,
      });
      middlewares.sort(function (a, b) {
        return a.level - b.level;
      });
      return this;
    };
    Dexie.prototype.unuse = function (_a) {
      var stack = _a.stack,
        name = _a.name,
        create = _a.create;
      if (stack && this._middlewares[stack]) {
        this._middlewares[stack] = this._middlewares[stack].filter(function (
          mw
        ) {
          return create
            ? mw.create !== create
            : name
            ? mw.name !== name
            : false;
        });
      }
      return this;
    };
    Dexie.prototype.open = function () {
      var _this = this;
      return usePSD(globalPSD, function () {
        return dexieOpen(_this);
      });
    };
    Dexie.prototype._close = function () {
      var state = this._state;
      var idx = connections.indexOf(this);
      if (idx >= 0) connections.splice(idx, 1);
      if (this.idbdb) {
        try {
          this.idbdb.close();
        } catch (e) {}
        this.idbdb = null;
      }
      if (!state.isBeingOpened) {
        state.dbReadyPromise = new DexiePromise(function (resolve) {
          state.dbReadyResolve = resolve;
        });
        state.openCanceller = new DexiePromise(function (_, reject) {
          state.cancelOpen = reject;
        });
      }
    };
    Dexie.prototype.close = function (_a) {
      var _b = _a === void 0 ? { disableAutoOpen: true } : _a,
        disableAutoOpen = _b.disableAutoOpen;
      var state = this._state;
      if (disableAutoOpen) {
        if (state.isBeingOpened) {
          state.cancelOpen(new exceptions.DatabaseClosed());
        }
        this._close();
        state.autoOpen = false;
        state.dbOpenError = new exceptions.DatabaseClosed();
      } else {
        this._close();
        state.autoOpen = this._options.autoOpen || state.isBeingOpened;
        state.openComplete = false;
        state.dbOpenError = null;
      }
    };
    Dexie.prototype.delete = function (closeOptions) {
      var _this = this;
      if (closeOptions === void 0) {
        closeOptions = { disableAutoOpen: true };
      }
      var hasInvalidArguments =
        arguments.length > 0 && typeof arguments[0] !== "object";
      var state = this._state;
      return new DexiePromise(function (resolve, reject) {
        var doDelete = function () {
          _this.close(closeOptions);
          var req = _this._deps.indexedDB.deleteDatabase(_this.name);
          req.onsuccess = wrap(function () {
            _onDatabaseDeleted(_this._deps, _this.name);
            resolve();
          });
          req.onerror = eventRejectHandler(reject);
          req.onblocked = _this._fireOnBlocked;
        };
        if (hasInvalidArguments)
          throw new exceptions.InvalidArgument(
            "Invalid closeOptions argument to db.delete()"
          );
        if (state.isBeingOpened) {
          state.dbReadyPromise.then(doDelete);
        } else {
          doDelete();
        }
      });
    };
    Dexie.prototype.backendDB = function () {
      return this.idbdb;
    };
    Dexie.prototype.isOpen = function () {
      return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function () {
      var dbOpenError = this._state.dbOpenError;
      return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function () {
      return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function () {
      return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
      get: function () {
        var _this = this;
        return keys(this._allTables).map(function (name) {
          return _this._allTables[name];
        });
      },
      enumerable: false,
      configurable: true,
    });
    Dexie.prototype.transaction = function () {
      var args = extractTransactionArgs.apply(this, arguments);
      return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function (mode, tables, scopeFunc) {
      var _this = this;
      var parentTransaction = PSD.trans;
      if (
        !parentTransaction ||
        parentTransaction.db !== this ||
        mode.indexOf("!") !== -1
      )
        parentTransaction = null;
      var onlyIfCompatible = mode.indexOf("?") !== -1;
      mode = mode.replace("!", "").replace("?", "");
      var idbMode, storeNames;
      try {
        storeNames = tables.map(function (table) {
          var storeName = table instanceof _this.Table ? table.name : table;
          if (typeof storeName !== "string")
            throw new TypeError(
              "Invalid table argument to Dexie.transaction(). Only Table or String are allowed"
            );
          return storeName;
        });
        if (mode == "r" || mode === READONLY) idbMode = READONLY;
        else if (mode == "rw" || mode == READWRITE) idbMode = READWRITE;
        else
          throw new exceptions.InvalidArgument(
            "Invalid transaction mode: " + mode
          );
        if (parentTransaction) {
          if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
            if (onlyIfCompatible) {
              parentTransaction = null;
            } else
              throw new exceptions.SubTransaction(
                "Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY"
              );
          }
          if (parentTransaction) {
            storeNames.forEach(function (storeName) {
              if (
                parentTransaction &&
                parentTransaction.storeNames.indexOf(storeName) === -1
              ) {
                if (onlyIfCompatible) {
                  parentTransaction = null;
                } else
                  throw new exceptions.SubTransaction(
                    "Table " +
                      storeName +
                      " not included in parent transaction."
                  );
              }
            });
          }
          if (
            onlyIfCompatible &&
            parentTransaction &&
            !parentTransaction.active
          ) {
            parentTransaction = null;
          }
        }
      } catch (e) {
        return parentTransaction
          ? parentTransaction._promise(null, function (_, reject) {
              reject(e);
            })
          : rejection(e);
      }
      var enterTransaction = enterTransactionScope.bind(
        null,
        this,
        idbMode,
        storeNames,
        parentTransaction,
        scopeFunc
      );
      return parentTransaction
        ? parentTransaction._promise(idbMode, enterTransaction, "lock")
        : PSD.trans
        ? usePSD(PSD.transless, function () {
            return _this._whenReady(enterTransaction);
          })
        : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function (tableName) {
      if (!hasOwn(this._allTables, tableName)) {
        throw new exceptions.InvalidTable(
          "Table ".concat(tableName, " does not exist")
        );
      }
      return this._allTables[tableName];
    };
    return Dexie;
  })();

  var symbolObservable =
    typeof Symbol !== "undefined" && "observable" in Symbol
      ? Symbol.observable
      : "@@observable";
  var Observable = (function () {
    function Observable(subscribe) {
      this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function (x, error, complete) {
      return this._subscribe(
        !x || typeof x === "function"
          ? { next: x, error: error, complete: complete }
          : x
      );
    };
    Observable.prototype[symbolObservable] = function () {
      return this;
    };
    return Observable;
  })();

  var domDeps;
  try {
    domDeps = {
      indexedDB:
        _global.indexedDB ||
        _global.mozIndexedDB ||
        _global.webkitIndexedDB ||
        _global.msIndexedDB,
      IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange,
    };
  } catch (e) {
    domDeps = { indexedDB: null, IDBKeyRange: null };
  }

  function liveQuery(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new Observable(function (observer) {
      var scopeFuncIsAsync = isAsyncFunction(querier);
      function execute(ctx) {
        var wasRootExec = beginMicroTickScope();
        try {
          if (scopeFuncIsAsync) {
            incrementExpectedAwaits();
          }
          var rv = newScope(querier, ctx);
          if (scopeFuncIsAsync) {
            rv = rv.finally(decrementExpectedAwaits);
          }
          return rv;
        } finally {
          wasRootExec && endMicroTickScope();
        }
      }
      var closed = false;
      var abortController;
      var accumMuts = {};
      var currentObs = {};
      var subscription = {
        get closed() {
          return closed;
        },
        unsubscribe: function () {
          if (closed) return;
          closed = true;
          if (abortController) abortController.abort();
          if (startedListening)
            globalEvents.storagemutated.unsubscribe(mutationListener);
        },
      };
      observer.start && observer.start(subscription);
      var startedListening = false;
      var doQuery = function () {
        return execInGlobalContext(_doQuery);
      };
      function shouldNotify() {
        return obsSetsOverlap(currentObs, accumMuts);
      }
      var mutationListener = function (parts) {
        extendObservabilitySet(accumMuts, parts);
        if (shouldNotify()) {
          doQuery();
        }
      };
      var _doQuery = function () {
        if (closed || !domDeps.indexedDB) {
          return;
        }
        accumMuts = {};
        var subscr = {};
        if (abortController) abortController.abort();
        abortController = new AbortController();
        var ctx = {
          subscr: subscr,
          signal: abortController.signal,
          requery: doQuery,
          querier: querier,
          trans: null,
        };
        var ret = execute(ctx);
        Promise.resolve(ret).then(
          function (result) {
            hasValue = true;
            currentValue = result;
            if (closed || ctx.signal.aborted) {
              return;
            }
            accumMuts = {};
            currentObs = subscr;
            if (!objectIsEmpty(currentObs) && !startedListening) {
              globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
              startedListening = true;
            }
            execInGlobalContext(function () {
              return !closed && observer.next && observer.next(result);
            });
          },
          function (err) {
            hasValue = false;
            if (
              !["DatabaseClosedError", "AbortError"].includes(
                err === null || err === void 0 ? void 0 : err.name
              )
            ) {
              if (!closed)
                execInGlobalContext(function () {
                  if (closed) return;
                  observer.error && observer.error(err);
                });
            }
          }
        );
      };
      setTimeout(doQuery, 0);
      return subscription;
    });
    observable.hasValue = function () {
      return hasValue;
    };
    observable.getValue = function () {
      return currentValue;
    };
    return observable;
  }

  var Dexie = Dexie$1;
  props(
    Dexie,
    __assign(__assign({}, fullNameExceptions), {
      delete: function (databaseName) {
        var db = new Dexie(databaseName, { addons: [] });
        return db.delete();
      },
      exists: function (name) {
        return new Dexie(name, { addons: [] })
          .open()
          .then(function (db) {
            db.close();
            return true;
          })
          .catch("NoSuchDatabaseError", function () {
            return false;
          });
      },
      getDatabaseNames: function (cb) {
        try {
          return getDatabaseNames(Dexie.dependencies).then(cb);
        } catch (_a) {
          return rejection(new exceptions.MissingAPI());
        }
      },
      defineClass: function () {
        function Class(content) {
          extend(this, content);
        }
        return Class;
      },
      ignoreTransaction: function (scopeFunc) {
        return PSD.trans ? usePSD(PSD.transless, scopeFunc) : scopeFunc();
      },
      vip: vip,
      async: function (generatorFn) {
        return function () {
          try {
            var rv = awaitIterator(generatorFn.apply(this, arguments));
            if (!rv || typeof rv.then !== "function")
              return DexiePromise.resolve(rv);
            return rv;
          } catch (e) {
            return rejection(e);
          }
        };
      },
      spawn: function (generatorFn, args, thiz) {
        try {
          var rv = awaitIterator(generatorFn.apply(thiz, args || []));
          if (!rv || typeof rv.then !== "function")
            return DexiePromise.resolve(rv);
          return rv;
        } catch (e) {
          return rejection(e);
        }
      },
      currentTransaction: {
        get: function () {
          return PSD.trans || null;
        },
      },
      waitFor: function (promiseOrFunction, optionalTimeout) {
        var promise = DexiePromise.resolve(
          typeof promiseOrFunction === "function"
            ? Dexie.ignoreTransaction(promiseOrFunction)
            : promiseOrFunction
        ).timeout(optionalTimeout || 60000);
        return PSD.trans ? PSD.trans.waitFor(promise) : promise;
      },
      Promise: DexiePromise,
      debug: {
        get: function () {
          return debug;
        },
        set: function (value) {
          setDebug(value);
        },
      },
      derive: derive,
      extend: extend,
      props: props,
      override: override,
      Events: Events,
      on: globalEvents,
      liveQuery: liveQuery,
      extendObservabilitySet: extendObservabilitySet,
      getByKeyPath: getByKeyPath,
      setByKeyPath: setByKeyPath,
      delByKeyPath: delByKeyPath,
      shallowClone: shallowClone,
      deepClone: deepClone,
      getObjectDiff: getObjectDiff,
      cmp: cmp,
      asap: asap$1,
      minKey: minKey,
      addons: [],
      connections: connections,
      errnames: errnames,
      dependencies: domDeps,
      cache: cache,
      semVer: DEXIE_VERSION,
      version: DEXIE_VERSION.split(".")
        .map(function (n) {
          return parseInt(n);
        })
        .reduce(function (p, c, i) {
          return p + c / Math.pow(10, i * 2);
        }),
    })
  );
  Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);

  if (
    typeof dispatchEvent !== "undefined" &&
    typeof addEventListener !== "undefined"
  ) {
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function (updatedParts) {
      if (!propagatingLocally) {
        var event_1;
        event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
          detail: updatedParts,
        });
        propagatingLocally = true;
        dispatchEvent(event_1);
        propagatingLocally = false;
      }
    });
    addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function (_a) {
      var detail = _a.detail;
      if (!propagatingLocally) {
        propagateLocally(detail);
      }
    });
  }
  function propagateLocally(updateParts) {
    var wasMe = propagatingLocally;
    try {
      propagatingLocally = true;
      globalEvents.storagemutated.fire(updateParts);
      signalSubscribersNow(updateParts, true);
    } finally {
      propagatingLocally = wasMe;
    }
  }
  var propagatingLocally = false;

  var bc;
  var createBC = function () {};
  if (typeof BroadcastChannel !== "undefined") {
    createBC = function () {
      bc = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
      bc.onmessage = function (ev) {
        return ev.data && propagateLocally(ev.data);
      };
    };
    createBC();
    if (typeof bc.unref === "function") {
      bc.unref();
    }
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function (changedParts) {
      if (!propagatingLocally) {
        bc.postMessage(changedParts);
      }
    });
  }

  if (typeof addEventListener !== "undefined") {
    addEventListener("pagehide", function (event) {
      if (!Dexie$1.disableBfCache && event.persisted) {
        if (debug) console.debug("Dexie: handling persisted pagehide");
        bc === null || bc === void 0 ? void 0 : bc.close();
        for (
          var _i = 0, connections_1 = connections;
          _i < connections_1.length;
          _i++
        ) {
          var db = connections_1[_i];
          db.close({ disableAutoOpen: false });
        }
      }
    });
    addEventListener("pageshow", function (event) {
      if (!Dexie$1.disableBfCache && event.persisted) {
        if (debug) console.debug("Dexie: handling persisted pageshow");
        createBC();
        propagateLocally({ all: new RangeSet(-Infinity, [[]]) });
      }
    });
  }

  function add(value) {
    return new PropModification({ add: value });
  }

  function remove(value) {
    return new PropModification({ remove: value });
  }

  function replacePrefix(a, b) {
    return new PropModification({ replacePrefix: [a, b] });
  }

  DexiePromise.rejectionMapper = mapError;
  setDebug(debug);

  var namedExports = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Dexie: Dexie$1,
    liveQuery: liveQuery,
    Entity: Entity,
    cmp: cmp,
    PropModSymbol: PropModSymbol,
    PropModification: PropModification,
    replacePrefix: replacePrefix,
    add: add,
    remove: remove,
    default: Dexie$1,
    RangeSet: RangeSet,
    mergeRanges: mergeRanges,
    rangesOverlap: rangesOverlap,
  });

  __assign(Dexie$1, namedExports, { default: Dexie$1 });

  return Dexie$1;
});
//# sourceMappingURL=dexie.js.map

angular.module('ui.bootstrap.contextMenu', [])
.directive('contextMenu', ["$parse", "$q", "$sce", function ($parse, $q, custom, $sce){
  var contextMenus = [];
  var $currentContextMenu = null;
  var defaultItemText = "New Item";

  var removeContextMenus = function (level){
    /// <summary>Remove context menu.</summary>
    while (contextMenus.length && (!level || contextMenus.length > level)){
      contextMenus.pop().remove();
    }
    if(contextMenus.length == 0 && $currentContextMenu){
      $currentContextMenu.remove();
    }
  };

  var processTextItem = function ($scope, item, text, event, model, $promises, nestedMenu, $){
    "use strict";
    var $a = $('<a>');
    $a.css("padding-right", "8px");
    $a.attr({tabindex:'-1', href:'#'});

    if(typeof item[0] === 'string'){
      text = item[0];
    }
    else if(typeof item[0] === "function"){
      text = item[0].call($scope, $scope, event, model);
    } else if(typeof item.text !== "undefined"){
      text = item.text;
    }

    var $promise = $q.when(text);
    $promises.push($promise);
    $promise.then(function (text){
      if(nestedMenu){
        $a.css("cursor", "default");
        $a.append($('<strong style="font-family:monospace;font-weight:bold;float:right;">&gt;</strong>'));
      }
      $a.append(text);
    });
    return $a;
  };

  var processItem = function ($scope, event, model, item, $ul, $li, $promises, $q, $, level){
    /// <summary>Process individual item</summary>
    "use strict";
    // nestedMenu is either an Array or a Promise that will return that array.
    var nestedMenu = angular.isArray(item[1]) || (item[1] && angular.isFunction(item[1].then))
      ? item[1] : angular.isArray(item[2]) || (item[2] && angular.isFunction(item[2].then))
      ? item[2] : angular.isArray(item[3]) || (item[3] && angular.isFunction(item[3].then))
      ? item[3] : null;

    // if html property is not defined, fallback to text, otherwise use default text
    // if first item in the item array is a function then invoke .call()
    // if first item is a string, then text should be the string.
    var text = defaultItemText;
    if(typeof item[0] === 'function' || typeof item[0] === 'string' || typeof item.text !== "undefined"){
      text = processTextItem($scope, item, text, event, model, $promises, nestedMenu, $);
    }
    else if(typeof item.html === 'function'){
      // leave styling open to dev
      text = item.html($scope);
    }
    else if(typeof item.html !== "undefined"){
      // leave styling open to dev
      text = item.html;
    }

    $li.append(text);

    // if item is object, and has enabled prop invoke the prop
    // els if fallback to item[2]
    var isEnabled = function (){
      if(typeof item.enabled !== "undefined"){
        return item.enabled.call($scope, $scope, event, model, text);
      } else if(typeof item[2] === "function"){
        return item[2].call($scope, $scope, event, model, text);
      } else{
        return true;
      }
    };
    registerEnabledEvents($scope, isEnabled(), item, $ul, $li, nestedMenu, model, text, event, $, level);
  };

  var handlePromises = function ($ul, level, event, $promises){
    /// <summary>
    /// calculate if drop down menu would go out of screen at left or bottom
    /// calculation need to be done after element has been added (and all texts are set; thus thepromises)
    /// to the DOM the get the actual height
    /// </summary>
    "use strict";
    $q.all($promises).then(function (){
      var topCoordinate = event.pageY;
      var menuHeight = angular.element($ul[0]).prop('offsetHeight');
      var winHeight = event.view.innerHeight;
      if(topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight){
        topCoordinate = event.pageY - menuHeight;
      } else if(winHeight <= menuHeight){
        // If it really can't fit, reset the height of the menu to one that will fit
        angular.element($ul[0]).css({"height": winHeight - 5, "overflow-y": "scroll"});
        // ...then set the topCoordinate height to 0 so the menu starts from the top
        topCoordinate = 0;
      } else if(winHeight - topCoordinate < menuHeight){
        var reduceThreshold = 5;
        if(topCoordinate < reduceThreshold){
          reduceThreshold = topCoordinate;
        }
        topCoordinate = winHeight - menuHeight - reduceThreshold;
      }

      var leftCoordinate = event.pageX;
      var menuWidth = angular.element($ul[0]).prop('offsetWidth');
      var winWidth = event.view.innerWidth;
      var rightPadding = 5;
      if(leftCoordinate > menuWidth && winWidth - leftCoordinate - rightPadding < menuWidth){
        leftCoordinate = winWidth - menuWidth - rightPadding;
        leftCoordinate = leftCoordinate - 40; //New Added
      } else if(winWidth - leftCoordinate < menuWidth){
        var reduceThreshold = 5;
        if(leftCoordinate < reduceThreshold + rightPadding){
          reduceThreshold = leftCoordinate + rightPadding;
        }
        leftCoordinate = winWidth - menuWidth - reduceThreshold - rightPadding;
      } else if((leftCoordinate + menuWidth) > (winWidth - 30)){//New Added
        leftCoordinate = leftCoordinate - 40;
      }
      $ul.css({display:'block', position:'absolute', left:leftCoordinate + 'px', top:topCoordinate + 'px'});
    });
  };

  var registerEnabledEvents = function ($scope, enabled, item, $ul, $li, nestedMenu, model, text, event, $, level){
    /// <summary>If item is enabled, register various mouse events.</summary>
    if(enabled){
      var openNestedMenu = function ($event){
        removeContextMenus(level + 1);
        /*
         * The object here needs to be constructed and filled with data
         * on an "as needed" basis. Copying the data from event directly
         * or cloning the event results in unpredictable behavior.
         */
        var ev = {
          pageX: event.pageX + $ul[0].offsetWidth - 1,
          pageY: $ul[0].offsetTop + $li[0].offsetTop - 3,
          view: event.view || window
        };

        /*
         * At this point, nestedMenu can only either be an Array or a promise.
         * Regardless, passing them to when makes the implementation singular.
         */
        $q.when(nestedMenu).then(function(promisedNestedMenu){
          renderContextMenu($scope, ev, promisedNestedMenu, model, level + 1);
        });
      };

      $li.on('click', function ($event){
        $event.preventDefault();
        $scope.$apply(function (){
          if(nestedMenu){
            openNestedMenu($event);
          } else{
            $(event.currentTarget).removeClass('context');
            removeContextMenus();
            if(angular.isFunction(item[1])){
              item[1].call($scope, $scope, event, model, text)
            } else{
              item.click.call($scope, $scope, event, model, text);
            }
          }
        });
      });

      $li.on('mouseover', function ($event){
        $scope.$apply(function (){
          if(nestedMenu){
            openNestedMenu($event);
          }
        });
      });
    } else{
      $li.on('click', function ($event){
        $event.preventDefault();
      });
      $li.addClass('disabled');
    }
  };

  var renderContextMenu = function ($scope, event, options, model, level, customClass){
    /// <summary>Render context menu recursively.</summary>
    if(!level){level=0}
    if(!$){var $ = angular.element}
    $(event.currentTarget).addClass('context');
    var $contextMenu = $('<div>');
    if($currentContextMenu){
      $contextMenu = $currentContextMenu;
    } else{
      $currentContextMenu = $contextMenu;
      $contextMenu.addClass('contextMenu dropdown clearfix');
    }
    if(customClass){
      $contextMenu.addClass(customClass);
    }
    var $ul = $('<ul>');
    $ul.addClass('dropdown-menu');
    $ul.attr({'role': 'menu'});
    $ul.css({display:'block', position:'absolute', left:event.pageX + 'px', top:event.pageY + 'px'/*,"z-index":10000*/});
    var $promises = [];
    angular.forEach(options, function (item){
      var $li = $('<li>');
      if(item === null){
        $li.addClass('divider');
      } else if(typeof item[0] === "object"){
        custom.initialize($li, item);
      } else{
        processItem($scope, event, model, item, $ul, $li, $promises, $q, $, level);
      }
      $ul.append($li);
    });
    $contextMenu.append($ul);
    var height = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );
    $contextMenu.css({width:'100%', height:height + 'px', position:'absolute', top:0, left:0, zIndex:999 /*,"max-height" : window.innerHeight - 3,*/});
    $(document).find('body').append($contextMenu);

    handlePromises($ul, level, event, $promises);

    $contextMenu.on("mousedown", function (e){
      if($(e.target).hasClass('dropdown')){
        $(event.currentTarget).removeClass('context');
        removeContextMenus();
      }
    }).on('contextmenu', function (event){
      $(event.currentTarget).removeClass('context');
      event.preventDefault();
      removeContextMenus(level);
    });

    $scope.$on("$destroy", function (){
      removeContextMenus();
    });
    contextMenus.push($ul);
  };

  function isTouchDevice(){
    return 'ontouchstart' in window        // works on most browsers
      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  };

  return function ($scope, element, attrs){
    var openMenuEvent = "contextmenu";
    if(attrs.contextMenuOn && typeof(attrs.contextMenuOn) === "string"){
      openMenuEvent = attrs.contextMenuOn;
    }
    element.on(openMenuEvent, function (event){
      event.stopPropagation();
      event.preventDefault();

      // Don't show context menu if on touch device and element is draggable
      if(isTouchDevice() && element.attr('draggable') === 'true'){
        return false;
      }

      $scope.$apply(function (){
        var options = $scope.$eval(attrs.contextMenu);
        var customClass = attrs.contextMenuClass;
        var model = $scope.$eval(attrs.model);
        if(options instanceof Array){
          if(options.length === 0){
            return;
          }
          renderContextMenu($scope, event, options, model, undefined, customClass);
        } else{
          throw '"' + attrs.contextMenu + '" not an array';
        }
      });
    });
  };
}]);

color_convert = function(){
  var pub = {}, canvas, context;
  canvas = document.createElement('canvas');
  canvas.height = 1;
  canvas.width = 1;
  context = canvas.getContext('2d');

  function byte_to_hex(byte){
    // Turns a number (0-255) into a 2-character hex number (00-ff)
    return('0'+byte.toString(16)).slice(-2);
  }

  pub.to_rgba_array = function(color){
    /**
     * Turns any valid canvas fillStyle into a 4-element Uint8ClampedArray with bytes
     * for R, G, B, and A. Invalid styles will return [0, 0, 0, 0]. Examples:
     * color_convert.to_rgb_array('red')  # [255, 0, 0, 255]
     * color_convert.to_rgb_array('#ff0000')  # [255, 0, 0, 255]
     * color_convert.to_rgb_array('garbagey')  # [0, 0, 0, 0]
     */
    // Setting an invalid fillStyle leaves this unchanged
    context.fillStyle = 'rgba(0, 0, 0, 0)';
    // We're reusing the canvas, so fill it with something predictable
    context.clearRect(0, 0, 1, 1);
    context.fillStyle = color;
    context.fillRect(0, 0, 1, 1);
    return context.getImageData(0, 0, 1, 1).data;
  }

  pub.to_rgba = function(color){
    /**
     * Turns any valid canvas fill style into an rgba() string. Returns
     * 'rgba(0,0,0,0)' for invalid colors. Examples:
     * color_convert.to_rgba('red')  # 'rgba(255,0,0,1)'
     * color_convert.to_rgba('#f00')  # 'rgba(255,0,0,1)'
     * color_convert.to_rgba('garbagey')  # 'rgba(0,0,0,0)'
     * color_convert.to_rgba(some_pattern)  # Depends on the pattern
     *
     * @param color  A string, pattern, or gradient
     * @return  A valid rgba CSS color string
     */
    var a = pub.to_rgba_array(color);
    return 'rgba('+a[0]+','+a[1]+','+a[2]+','+(a[3]/255)+')';
  }

  pub.to_hex = function(color){
    /**
     * Turns any valid canvas fill style into a hex triple. Returns
     * '#000000' for invalid colors. Examples:
     * color_convert.to_hex('red')  # '#ff0000'
     * color_convert.to_hex('rgba(255,0,0,1)')  # '#ff0000'
     * color_convert.to_hex('garbagey')  # '#000000'
     * color_convert.to_hex(some_pattern)  # Depends on the pattern
     *
     * @param color  A string, pattern, or gradient
     * @return  A valid rgba CSS color string
     */
    var a = pub.to_rgba_array(color);
    // Sigh, you can't map() typed arrays
    var hex = [0,1,2].map(function(i){return byte_to_hex(a[i])}).join('');
    return '#'+hex;
  }

  return pub;
}();

angular.module("uiSwitch",[]).directive("switch",function(){return{restrict:"AE",replace:!0,transclude:!0,template:function(n,e){var s="";return s+="<span",s+=' class="switch'+(e.class?" "+e.class:"")+'"',s+=e.ngModel?' ng-click="'+e.disabled+" ? "+e.ngModel+" : "+e.ngModel+"=!"+e.ngModel+(e.ngChange?"; "+e.ngChange+'()"':'"'):"",s+=' ng-class="{ checked:'+e.ngModel+", disabled:"+e.disabled+' }"',s+=">",s+="<small></small>",s+='<input type="checkbox" aria-label="themeSwitchBtn"',s+=e.id?' id="'+e.id+'"':"",s+=e.name?' name="'+e.name+'"':"",s+=e.ngModel?' ng-model="'+e.ngModel+'"':"",s+=' style="display:none" />',s+='<span class="switch-text">',s+=e.on?'<span class="on" aria-hidden="true">'+e.on+"</span>":"",s+=e.off?'<span class="off" aria-hidden="true">'+e.off+"</span>":" ",s+="</span>"}}});
/*angular.treeview.js*/
(function (f) {
    f.module("angularTreeview", []).directive("treeModel", [
      "$rootScope",
      "$compile",
      function ($rootScope, $compile) {
        return {
          restrict: "A",
          link: function (b, h, c) {
            var a = c.treeId,
              g = c.treeModel,
              e;
            (e = c.nodeLabel || "label"),
              (d = c.nodeChildren || "children"),
              (e =
                '<ul role="list" aria-label="Tree View"><li data-ng-repeat="node in ' +
                g +
                '" id="{{node.id}}" splId="{{node.splId}}" type="{{node.type}}" role="listitem" aria-label="{{node.'+e+'}}"><i class="collapsed" data-ng-show="node.' +
                d +
                '.length && node.collapsed" data-ng-click="' +
                a +
                '.selectNodeHead(node)"></i><i class="expanded" data-ng-show="node.' +
                d +
                '.length && !node.collapsed" data-ng-click="' +
                a +
                '.selectNodeHead(node)"></i><i class="normal" data-ng-hide="node.' +
                d +
                '.length"></i> <span ng-class="{selected:(node.selected || node.id == ' +
                c.nodeId +
                ')}" data-ng-click="' +
                a +
                '.selectNodeLabel(node)" class="folderSpan" role="link" aria-selected="{{node.selected}}" aria-hidden="true"><span class="treeIcon"><span data-ng-show="node.type == \'Shortcut\'" class="shortcut" aria-hidden="true"></span><span data-ng-show="node.type == \'Sharepoint\'" class="sharepoint" aria-hidden="true"></span><span data-ng-show="node.type == \'Onedrive\'" class="oneDrive" aria-hidden="true"></span><span data-ng-show="node.type == \'Googledrive\'" class="googleDrive" aria-hidden="true"></span><span data-ng-show="node.type == \'SharedFolder\'" class="sharedFolder" aria-hidden="true"></span><span data-ng-show="node.type == \'Folder\' && node.subtype == \'SharedFolder\'" class="sharedFolder" aria-hidden="true"></span><span data-ng-show="node.type == \'Folder\' && node.wp" ng-class="auth.uType == 4?\'nonwritable\':\'writable\'" aria-hidden="true"></span></span>{{node.' +
                e +
                // '}}{{myTheme.theme}}<img class="marL5 marT-2" src="assets/images/fav.svg" ng-class="node.isStar?\'starClicked\':\'starNotClicked\'" width="14px" height="14px" alt="favorite"> </span><div data-ng-hide="node.collapsed" data-tree-id="' +
                '}} ' +
                // '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="marB-3 marL5 pull-right" version="1.1" width="16" height="16" viewBox="0 0 640 480" xml:space="preserve"> ' +

                '</span>'+
                '<span class="favIconTree padL5" id="favIcon" data-ng-show="node.state == \'cl\'"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-ng-click="favoriteFx(node.id,node.isStar)" class="marT6 pull-right" version="1.1" width="14" height="14" viewBox="0 0 640 480" xml:space="preserve"> ' +
                    '<defs></defs> ' +
                    '<g transform="matrix(4.83 0 0 4.83 320.09 240.2)"> ' +
                    '<path ng-class="node.isStar?\'starClicked\':\'starNotClicked\'" vector-effect="non-scaling-stroke" transform=" translate(-51.83, -49.26)" d="M 0.000109633125,37.631077 L 39.59224,37.631077 L 51.826661,0 L 64.061086,37.631077 L 103.65333,37.631077 L 71.622377,60.88826 L 83.857301,98.519432 L 51.826349,75.262249 L 19.795395,98.519432 L 31.03032,60.88826 L-1.000634,37.631077 Z" stroke-linecap="round"/> ' +
                    '</g> ' +
                '</svg></span>' +
                '<div data-ng-hide="node.collapsed" data-tree-id="' +
                a +
                '" data-tree-model="node.' +
                d +
                '" data-node-id=' +
                (c.nodeId || "id") +
                " data-node-label=" +
                e +
                " data-node-children=" +
                d +
                "></div></li></ul>");
            a &&
              g &&
              (c.angularTreeview &&
                ((b[a] = b[a] || {}),
                (b[a].selectNodeHead =
                  b[a].selectNodeHead ||
                  function (a) {
                    a.collapsed = !a.collapsed;
                  }),
                (b[a].selectNodeLabel =
                  b[a].selectNodeLabel ||
                  function (c) {
                    b[a].currentNode &&
                      b[a].currentNode.selected &&
                      (b[a].currentNode.selected = void 0);
                    c.selected = "selected";
                    b[a].currentNode = c;
                    $rootScope.$broadcast("treeId", c.id, c.splId, c.type, a);
                  })),
              h.html("").append($compile(e)(b)));
          },
        };
      },
    ]);
  })(angular);
  // selected:('+ c.nodeId +' == node.id || node.selected)
  /*(function(l){l.module("angularTreeview",[]).directive("treeModel",function($compile){return{restrict:"A",link:function(a,g,c){var e=c.treeModel,h=c.nodeLabel||"label",d=c.nodeChildren||"children",k='<ul><li data-ng-repeat="node in '+e+'"><i class="collapsed" data-ng-show="node.'+d+'.length && node.collapsed" data-ng-click="selectNodeHead(node, $event)"></i><i class="expanded" data-ng-show="node.'+d+'.length && !node.collapsed" data-ng-click="selectNodeHead(node, $event)"></i><i class="normal" data-ng-hide="node.'+d+'.length"></i> <span data-ng-class="node.selected" data-ng-click="selectNodeLabel(node, $event)">{{node.'+h+'}}</span><div data-ng-hide="node.collapsed" data-tree-model="node.'+d+'" data-node-id='+(c.nodeId||"id")+" data-node-label="+h+" data-node-children="+d+"></div></li></ul>";e&&e.length&&(c.angularTreeview?(a.$watch(e,function(m,b){g.empty().html($compile(k)(a))},!1),a.selectNodeHead=a.selectNodeHead||function(a,b){b.stopPropagation&&b.stopPropagation();b.preventDefault&&b.preventDefault();b.cancelBubble=!0;b.returnValue=!1;a.collapsed=!a.collapsed},a.selectNodeLabel=a.selectNodeLabel||function(c,b){b.stopPropagation&&b.stopPropagation();b.preventDefault&&b.preventDefault();b.cancelBubble=!0;b.returnValue=!1;a.currentNode&&a.currentNode.selected&&(a.currentNode.selected=void 0);c.selected="selected";a.currentNode=c}):g.html($compile(k)(a)))}}})})(angular);*/
  //
  //data-ng-class="{\'selected\':' + c.nodeId + ' == node.id}"

/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/


!function(a){"use strict";a.module("vcRecaptcha",[])}(angular),function(a){"use strict";function b(){throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create')}a.module("vcRecaptcha").provider("vcRecaptchaService",function(){var c=this,d={};c.onLoadFunctionName="vcRecaptchaApiLoaded",c.setDefaults=function(b){a.copy(b,d)},c.setSiteKey=function(a){d.key=a},c.setTheme=function(a){d.theme=a},c.setStoken=function(a){d.stoken=a},c.setSize=function(a){d.size=a},c.setType=function(a){d.type=a},c.setLang=function(a){d.lang=a},c.setBadge=function(a){d.badge=a},c.setOnLoadFunctionName=function(a){c.onLoadFunctionName=a},c.$get=["$rootScope","$window","$q","$document","$interval",function(e,f,g,h,i){function j(){return m?g.when(m):o}function k(){if(!m)throw new Error("reCaptcha has not been loaded yet.")}function l(){return a.isFunction((f.grecaptcha||{}).render)}var m,n=g.defer(),o=n.promise,p={};f.vcRecaptchaApiLoadedCallback=f.vcRecaptchaApiLoadedCallback||[];var q=function(){m=f.grecaptcha,n.resolve(m)};if(f.vcRecaptchaApiLoadedCallback.push(q),f[c.onLoadFunctionName]=function(){f.vcRecaptchaApiLoadedCallback.forEach(function(a){a()})},l())q();else if(f.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]'))var r=i(function(){l()&&(i.cancel(r),q())},25);else{var s=f.document.createElement("script");s.async=!0,s.defer=!0,s.src="https://www.google.com/recaptcha/api.js?onload="+c.onLoadFunctionName+"&render=explicit",h.find("body")[0].appendChild(s)}return{create:function(a,c){return c.sitekey=c.key||d.key,c.theme=c.theme||d.theme,c.stoken=c.stoken||d.stoken,c.size=c.size||d.size,c.type=c.type||d.type,c.hl=c.lang||d.lang,c.badge=c.badge||d.badge,c.sitekey||b(),j().then(function(b){var d=b.render(a,c);return p[d]=a,d})},reload:function(a){k(),m.reset(a),e.$broadcast("reCaptchaReset",a)},execute:function(a){k(),m.execute(a)},useLang:function(a,b){var c=p[a];if(!c)throw new Error("reCaptcha Widget ID not exists",a);var d=c.querySelector("iframe");if(!b)return d&&d.src&&/[?&]hl=\w+/.test(d.src)?d.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/,"$1"):null;if(d&&d.src){var e=d.src;/[?&]hl=/.test(e)?e=e.replace(/([?&]hl=)\w+/,"$1"+b):e+=(-1===e.indexOf("?")?"?":"&")+"hl="+b,d.src=e}},getResponse:function(a){return k(),m.getResponse(a)},getInstance:function(a){return p[a]},destroy:function(a){delete p[a]}}}]})}(angular),function(a){"use strict";a.module("vcRecaptcha").directive("vcRecaptcha",["$document","$timeout","vcRecaptchaService",function(b,c,d){return{restrict:"A",require:"?^^form",scope:{response:"=?ngModel",key:"=?",stoken:"=?",theme:"=?",size:"=?",type:"=?",lang:"=?",badge:"=?",tabindex:"=?",required:"=?",onCreate:"&",onSuccess:"&",onExpire:"&"},link:function(e,f,g,h){function i(){h&&h.$setValidity("recaptcha",null),l()}function j(){c(function(){e.response="",k(),e.onExpire({widgetId:e.widgetId})})}function k(){h&&h.$setValidity("recaptcha",!1===e.required?null:Boolean(e.response))}function l(){d.destroy(e.widgetId),a.element(b[0].querySelectorAll(".pls-container")).parent().remove()}e.widgetId=null,h&&a.isDefined(g.required)&&e.$watch("required",k);var m=e.$watch("key",function(b){var h=function(a){c(function(){e.response=a,k(),e.onSuccess({response:a,widgetId:e.widgetId})})};d.create(f[0],{callback:h,key:b,stoken:e.stoken||g.stoken||null,theme:e.theme||g.theme||null,type:e.type||g.type||null,lang:e.lang||g.lang||null,tabindex:e.tabindex||g.tabindex||null,size:e.size||g.size||null,badge:e.badge||g.badge||null,"expired-callback":j}).then(function(b){k(),e.widgetId=b,e.onCreate({widgetId:b}),e.$on("$destroy",i),e.$on("reCaptchaReset",function(c,d){(a.isUndefined(d)||b===d)&&(e.response="",k())})}),m()})}}}])}(angular);
// Generated by CoffeeScript 1.8.0
(function() {
  'use strict';
  angular.module('angular-flexslider', []).directive('flexSlider', [
    '$parse', '$timeout', function($parse, $timeout) {
      return {
        restrict: 'AE',
        scope: false,
        replace: true,
        transclude: true,
        template: '<div class="flexslider-container"></div>',
        compile: function(element, attr, linker) {
          return function($scope, $element) {
            var addSlide, collectionString, flexsliderDiv, getTrackFromItem, indexString, match, removeSlide, slidesItems, trackBy;
            match = (attr.slide || attr.flexSlide).match(/^\s*(.+)\s+in\s+(.*?)(?:\s+track\s+by\s+(.+?))?\s*$/);
            indexString = match[1];
            collectionString = match[2];
            trackBy = angular.isDefined(match[3]) ? $parse(match[3]) : $parse("" + indexString);
            flexsliderDiv = null;
            slidesItems = {};
            getTrackFromItem = function(collectionItem, index) {
              var locals;
              locals = {};
              locals[indexString] = collectionItem;
              locals['$index'] = index;
              return trackBy($scope, locals);
            };
            addSlide = function(collectionItem, index, callback) {
              var childScope, track;
              track = getTrackFromItem(collectionItem, index);
              if (slidesItems[track] != null) {
                throw "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys.";
              }
              childScope = $scope.$new();
              childScope[indexString] = collectionItem;
              childScope['$index'] = index;
              return linker(childScope, function(clone) {
                var slideItem;
                slideItem = {
                  collectionItem: collectionItem,
                  childScope: childScope,
                  element: clone
                };
                slidesItems[track] = slideItem;
                return typeof callback === "function" ? callback(slideItem) : void 0;
              });
            };
            removeSlide = function(collectionItem, index) {
              var slideItem, track;
              track = getTrackFromItem(collectionItem, index);
              slideItem = slidesItems[track];
              if (slideItem == null) {
                return;
              }
              delete slidesItems[track];
              slideItem.childScope.$destroy();
              return slideItem;
            };
            return $scope.$watchCollection(collectionString, function(collection, oldCollection) {
              var attrKey, attrVal, c, currentSlidesLength, e, i, idx, n, options, slider, slides, t, toAdd, toRemove, trackCollection, _i, _j, _k, _l, _len, _len1, _len2, _len3;
              if (!(collection != null ? collection.length : void 0) && !(oldCollection != null ? oldCollection.length : void 0)) {
                return;
              }
              if (flexsliderDiv != null) {
                slider = flexsliderDiv.data('flexslider');
                currentSlidesLength = Object.keys(slidesItems).length;
                if (collection == null) {
                  collection = [];
                }
                trackCollection = {};
                for (i = _i = 0, _len = collection.length; _i < _len; i = ++_i) {
                  c = collection[i];
                  trackCollection[getTrackFromItem(c, i)] = c;
                }
                toAdd = (function() {
                  var _j, _len1, _results;
                  _results = [];
                  for (i = _j = 0, _len1 = collection.length; _j < _len1; i = ++_j) {
                    c = collection[i];
                    if (slidesItems[getTrackFromItem(c, i)] == null) {
                      _results.push({
                        value: c,
                        index: i
                      });
                    }
                  }
                  return _results;
                })();
                toRemove = (function() {
                  var _results;
                  _results = [];
                  for (t in slidesItems) {
                    i = slidesItems[t];
                    if (trackCollection[t] == null) {
                      _results.push(i.collectionItem);
                    }
                  }
                  return _results;
                })();
                if ((toAdd.length === 1 && toRemove.length === 0) || toAdd.length === 0) {
                  for (_j = 0, _len1 = toRemove.length; _j < _len1; _j++) {
                    e = toRemove[_j];
                    e = removeSlide(e, collection.indexOf(e));
                    slider.removeSlide(e.element);
                  }
                  for (_k = 0, _len2 = toAdd.length; _k < _len2; _k++) {
                    e = toAdd[_k];
                    idx = e.index;
                    addSlide(e.value, idx, function(item) {
                      if (idx === currentSlidesLength) {
                        idx = void 0;
                      }
                      return $scope.$evalAsync(function() {
                        return slider.addSlide(item.element, idx);
                      });
                    });
                  }
                  return;
                }
              }
              slidesItems = {};
              if (flexsliderDiv != null) {
                flexsliderDiv.remove();
              }
              slides = angular.element('<ul class="slides"></ul>');
              flexsliderDiv = angular.element('<div class="flexslider"></div>');
              flexsliderDiv.append(slides);
              $element.append(flexsliderDiv);
              for (i = _l = 0, _len3 = collection.length; _l < _len3; i = ++_l) {
                c = collection[i];
                addSlide(c, i, function(item) {
                  return slides.append(item.element);
                });
              }
              options = {};
              for (attrKey in attr) {
                attrVal = attr[attrKey];
                if (attrKey.indexOf('$') === 0) {
                  continue;
                }
                if (!isNaN(n = parseInt(attrVal))) {
                  options[attrKey] = n;
                  continue;
                }
                if (attrVal === 'false' || attrVal === 'true') {
                  options[attrKey] = attrVal === 'true';
                  continue;
                }
                if (attrKey === 'start' || attrKey === 'before' || attrKey === 'after' || attrKey === 'end' || attrKey === 'added' || attrKey === 'removed') {
                  options[attrKey] = (function(attrVal) {
                    var f;
                    f = $parse(attrVal);
                    return function(slider) {
                      return $scope.$apply(function() {
                        return f($scope, {
                          '$slider': {
                            element: slider
                          }
                        });
                      });
                    };
                  })(attrVal);
                  continue;
                }
                if (attrKey === 'startAt') {
                  options[attrKey] = $parse(attrVal)($scope);
                  continue;
                }
                options[attrKey] = attrVal;
              }
              if (!options.sliderId && attr.id) {
                options.sliderId = "" + attr.id + "-slider";
              }
              if (options.sliderId) {
                flexsliderDiv.attr('id', options.sliderId);
              }
              return $timeout((function() {
                return flexsliderDiv.flexslider(options);
              }), 0);
            });
          };
        }
      };
    }
  ]);
}).call(this);

(function(){
  'use strict';

  angular.module('fancyboxplus', [])
    .service('fancyboxService', fancyboxService)
    .directive('fancyboxable', fancyboxableDirective)
    .directive('fancybox', fancyboxDirective);

  function fancyboxService(){
    //Fancybox-Plus JavaScript API reference:
    // http://igorlino.github.io/fancybox-plus/api.htm

    var service = {
      fancyboxPlus: fancyboxPlus, //returns the fancyboxplus jquery plugin
      showActivity: showActivity, //Shows loading animation
      hideActivity: hideActivity, //Hides loading animation
      next: next, //Displays the next gallery item
      prev: prev, //Displays the previous gallery item
      pos: pos, //Displays item by index from gallery
      cancel: cancel, //Cancels loading content
      close: close, //Hides FancyBox. Within an iframe use - parent.close();
      resize: resize, //Auto-resizes FancyBox height to match height of content
      center: center //Centers FancyBox in viewport
    };
    return service;

    ////////////

    function fancyboxPlus(){
      return $.fancybox;
    }

    function showActivity(){
      fancyboxPlus().showActivity();
    }

    function hideActivity(){
      fancyboxPlus().hideActivity();
    }

    function pos(){
      fancyboxPlus().pos();
    }

    function cancel(){
      fancyboxPlus().cancel();
    }

    function center(){
      fancyboxPlus().center();
    }

    function next(){
      fancyboxPlus().next();
    }

    function prev(){
      fancyboxPlus().prev();
    }

    function close(){
      fancyboxPlus().close();
    }

    function resize(){
      fancyboxPlus().resize();
    }
  }

  fancyboxableDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];

  function fancyboxableDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService){
    var service = {
      restrict: 'A',
      link: fancyboxableLink,
      priority: 100 // must lower priority than ngSrc (99)
    };
    return service;

    ////////////////////////////


    fancyboxableLink.$inject = ['$scope', '$element', '$attributes'];

    function fancyboxableLink($scope, $element, $attributes, controller){
      var fbp = null;

      $scope.$on('$destroy', function(){
        $element.remove();
      });

      init();

      function init(open){
        var options = {
          href: $attributes.src ? $attributes.src : $attributes.href,
          onComplete: function(){
            onComplete();
          }
        };

        //generic way that sets all (non-function) parameters of fancybox-plus.
        if($attributes.fancyboxable && $attributes.fancyboxable.length > 0){
          var fbpOptionsFunc = $parse($attributes.fancyboxable);
          var fbpOptions = fbpOptionsFunc($scope);
          angular.extend(options, fbpOptions);
        }

        //clean undefined
        for(var key in options){
          if(options.hasOwnProperty(key)){
            if(typeof(options[key]) === 'undefined'){
              delete options[key];
            }
          }
        }

        if(typeof(open) !== 'undefined'){
          options.open = open;
        }

        //wait for the DOM view to be ready
        $timeout(function(){
          if(!$attributes.ngSrc){
            //opens the fancybox using an href.
            fbp = $($element).fancybox(options);
          } else{
            //wait for the DOM view to be ready
            $timeout(function(){
              options.href = $attributes.src ? $attributes.src : $attributes.href;
              fbp = $($element).fancybox(options);
            }, 300);
          }
        }, 0);
      }

      function onComplete(){
        $rootScope.$apply(function(){
          var content = $('#fbplus-content');
          $compile(content)($rootScope);
        });
      }
    }
  }

  fancyboxDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];

  function fancyboxDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService){
    var service = {
      restrict: 'E',
      scope: {
        open: '=',
        options: '=',
        templateUrl: '&',

        onStart: '&', //Will be called right before attempting to load the content
        onCancel: '&', //Will be called after loading is canceled
        onComplete: '&', //Will be called once the content is displayed
        onCleanup: '&', //Will be called just before closing
        onClosed: '&' //Will be called once FancyBox is closed

      },
      require: 'fancybox',
      link: link,
      controller: controller,
      controllerAs: 'vm'
    };
    return service;

    ////////////////////////////

    controller.$inject = ['$scope'];

    function controller($scope){}
    link.$inject = ['$scope', '$element', '$attributes'];

    function link($scope, $element, $attributes, controller){
      var fbp = null;
      $scope.$watch('open', function(newValue, oldValue){
        if(oldValue !== newValue){
          updateOpen(newValue);
        }
      });
      $scope.$on('$destroy', function(){
        $element.remove();
      });
      init();

      function updateOpen(newValue){
        if(newValue){
          init(newValue);
        } else{
          fancyboxService.close();
        }
      }

      function init(open){
        var options = {
          href: $attributes.src,
          boxFor: $attributes.boxFor,
          onOpen: function(){
            if($scope.onOpen && $scope.onOpen()){
              $scope.onOpen()();
            }
          },
          onCancel: function(){
            if($scope.onCancel && $scope.onCancel()){
              $scope.onCancel()();
            }
          },
          onComplete: function(){
            onComplete();
            if($scope.onComplete && $scope.onComplete()){
              $scope.onComplete()();
            }
          },
          onCleanup: function(){
            if($scope.onCleanup && $scope.onCleanup()){
              $scope.onCleanup()();
            }
          },
          onClosed: function(){
            $scope.$apply(function(){
              $scope.open = false;
            });
            if($scope.onClosed && $scope.onClosed()){
              $scope.onClosed()();
            }
          }
        };
        //generic way that sets all (non-function) parameters of fancybox-plus.
        if($scope.options){
          angular.extend(options, $scope.options);
        }
        //clean undefined
        for(var key in options){
          if(options.hasOwnProperty(key)){
            if(typeof(options[key]) === 'undefined'){
              delete options[key];
            }
          }
        }
        if(typeof(open) !== 'undefined'){
          options.open = open;
        }
        //wait for the DOM view to be ready
        $timeout(function(){
          if(options.boxFor){
            //opens the element by id boxFor
            fbp = $(options.boxFor).fancybox(options);
          } else if(options.href){
            //opens the fancybox-plus using an href.
            fbp = $.fancybox(options);
          }
        }, 0);
      }

      function onComplete(){
        $rootScope.$apply(function(){
          var content = $('#fbplus-content');
          $compile(content)($rootScope);
        });
      }
    }
  }
})
();
/*resizeIn*/
(function($, F){
  F.transitions.resizeIn = function(){
    var previous = F.previous,
      current = F.current,
      startPos = previous.wrap.stop(true).position(),
      endPos = $.extend({
        opacity: 1
      }, current.pos);
    startPos.width = previous.wrap.width();
    startPos.height = previous.wrap.height();
    previous.wrap.stop(true).trigger('onReset').remove();
    delete endPos.position;
    current.inner.hide();
    current.wrap.css(startPos).animate(endPos, {
      duration: current.nextSpeed,
      easing: current.nextEasing,
      step: F.transitions.step,
      complete: function(){
        F._afterZoomIn();
        current.inner.fadeIn("fast");
      }
    });
  };
}(jQuery, jQuery.fancybox));

angular.module('hub').service('IndexedDB', function($q){
  // Function to generate a random alphanumeric string
  function generateRandomName(length){
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    var result = "";
    for(var i = 0; i < length; i++){
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // Reverse string value
  function reverse(s){
    var reverseStr = "";
    for(var i = s.length - 1; i >= 0; i--)
      reverseStr += s[i];
    return reverseStr;
  }
  // Encrypt
  function hubEnc(id){
    var hubEncDB = reverse(btoa(generateRandomName(5) +"_"+ id +"_"+ generateRandomName(5)));
    localStorage.setItem("reCAPTCHA_", hubEncDB);
    return hubEncDB;
  }
  // Decrypt
  function hubDec(){
    var lsKey = localStorage.getItem("reCAPTCHA_");
    var hubDecDB;
    if(lsKey){
      hubDecDB = atob(reverse(lsKey)).split("_")[1];
      return hubDecDB;
    }
  }

  var dbName;
  var dbVersion = 1;
  var storeArr = [];

  function setIDBInfo(obj){
    dbName = obj.dbN;
    dbVersion = obj.dbV;
    storeArr = obj.sArr;

    if(dbName !== "scu"){
      var hubDecDB = hubDec();
      if(hubDecDB){
        dbName = hubDecDB;
      } else{
        hubEnc(dbName);
      }
    }
  }

  function openDatabase(){
    var deferred = $q.defer();
    try{
      // Code that might throw an error
      // For example:
      // console.log(undefinedVariable); // This will throw a ReferenceError
    } catch(error){
      // Code to handle the error
      // You can access the error object with the parameter passed to catch
      dbName = localStorage.getItem("reCAPTCHA_");
    }

    if(dbName){
      var request = window.indexedDB.open(dbName, dbVersion + 1); // Increment version number
      request.onupgradeneeded = function(event){
        var db = event.target.result;
        storeArr.forEach(function(s){
          if(!db.objectStoreNames.contains(s.name)){
            var curStore = db.createObjectStore(s.name, { keyPath:"id", autoIncrement:true });
            if(s.sort){
              curStore.createIndex(s.sortBy, s.sortBy=="label"?"l":"", { unique:s.unique?s.unique:false });
              curStore.createIndex("id", "id", { unique:s.unique?s.unique:false });
            }
            if(s.subStore){
              s.subStore.forEach(function(ss){
                var curSubStore = db.createObjectStore(ss.name, { keyPath:"id", autoIncrement:true });
                if(ss.sort){
                  curSubStore.createIndex(ss.sortBy, ss.sortBy, { unique:ss.unique?ss.unique:false });
                  curStore.createIndex("id", "id", { unique:ss.unique?ss.unique:false });
                }
              });
            }
          }
        });
      };

      request.onsuccess = function(event){
        deferred.resolve(event.target.result);
      };

      request.onerror = function(event){
        deferred.reject('Error: ' + event.target.errorCode);
      };

      return deferred.promise;
    }
  }

  // function addItem(storeName, data){
  //   var deferred = $q.defer();

  //   openDatabase().then(function(db){
  //     var transaction = db.transaction([storeName], 'readwrite');
  //     var store = transaction.objectStore(storeName);

  //     // console.warn(data);
  //     data.forEach(function(item, index){
  //       item.order = index;
  //       var addRequest = store.put(item); //store.add
  //       addRequest.onsuccess = function(){
  //         // console.log("Added", item);
  //       };
  //       addRequest.onerror = function(event){
  //         console.error("Error adding", item, ":", event.target.error);
  //       };
  //     });

  //     // var request = store.add(item);
  //     // request.onsuccess = function(){
  //     //   deferred.resolve('Item added successfully');
  //     // };
  //     // request.onerror = function(event){
  //     //   deferred.reject('Error: ' + event.target.errorCode);
  //     // };
  //   });

  //   return deferred.promise;
  // }

  function addItems(obj){
    var deferred = $q.defer();

    if(obj.stores && obj.stores.length){
      obj.stores.map(function(store){
        openDatabase().then(function(db){
          var transaction = db.transaction([store.sName], 'readwrite');
          var curStore = transaction.objectStore(store.sName);
          if(Array.isArray(store.value)){
            var addPromises = store.value.map(function(item, index){
              item.order = index;
              var addRequest = curStore.put(item); //store.add
              addRequest.onsuccess = function(){
                // console.log("Added---- ", item);
              };
              addRequest.onerror = function(event){
              };
            });

            // When all Added promises are resolved or any one of them fails
            $q.all(addPromises).then(function(){
              deferred.resolve('All items Added successfully');
            }).catch(function(error){
              deferred.reject('Error: ' + error);
            });

          } else{
            var addRequest = curStore.put(store.value); //store.add
            addRequest.onsuccess = function(){
              // console.log("Added", item);
            };
            addRequest.onerror = function(event){
            };
          }
        });
      });
    }
    else{
      // console.warn("ELSE...... ");
      openDatabase().then(function(db){
        var transaction = db.transaction([obj.sName], 'readwrite');
        var store = transaction.objectStore(obj.sName);

        var addPromises = obj.value.forEach(function(item, index){
          item.order = index;
          var addRequest = store.put(item); //store.add
          addRequest.onsuccess = function(){
            // console.log("Added", item);
          };
          addRequest.onerror = function(event){
            // console.error("Error adding", item, ":", event.target.error);
          };
        });

        // When all Added promises are resolved or any one of them fails
        $q.all(addPromises).then(function(){
          deferred.resolve('All items Added successfully');
        }).catch(function(error){
          deferred.reject('Error: ' + error);
        });

        // var request = store.add(item);
        // request.onsuccess = function(){
        //   deferred.resolve('Item added successfully');
        // };
        // request.onerror = function(event){
        //   deferred.reject('Error: ' + event.target.errorCode);
        // };
      });
    }
    return deferred.promise;
  }

  function updateItem(storeName, item){
    // console.warn(item);
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction([storeName], 'readwrite');
      var store = transaction.objectStore(storeName);
      var request = store.put(item);

      request.onsuccess = function(){
        deferred.resolve('Item updated successfully');
      };

      request.onerror = function(event){
        deferred.reject('Error: ' + event.target.errorCode);
      };
    });

    return deferred.promise;
  }

  // function updateItem(obj) {
  //   var deferred = $q.defer();

  //   openDatabase().then(function(db) {
  //     var transaction = db.transaction([obj.sName], 'readwrite');
  //     var store = transaction.objectStore(obj.sName);

  //     // Iterate through each item in the items array
  //     obj.items.forEach(function(item) {
  //       var request = store.put(item);

  //       request.onsuccess = function() {
  //         // Optionally, you can log or collect successful updates
  //         console.log('Item updated successfully:', item);
  //       };

  //       request.onerror = function(event) {
  //         // Reject the promise on any error encountered
  //         deferred.reject('Error updating item ' + item.id + ': ' + event.target.errorCode);
  //       };
  //     });

  //     // Resolve the promise once all items have been updated
  //     transaction.oncomplete = function() {
  //       deferred.resolve('All items updated successfully');
  //     };

  //     transaction.onerror = function(event) {
  //       // Handle transaction-level errors, if any
  //       deferred.reject('Transaction error: ' + event.target.errorCode);
  //     };
  //   });

  //   return deferred.promise;
  // }

  function deleteItems(obj){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction([obj.sName], 'readwrite');
      var store = transaction.objectStore(obj.sName);

      var deletePromises = obj.stores.map(function(item){
        var itemDeferred = $q.defer();
        var request = store.delete(Number(item));

        request.onsuccess = function(){
          itemDeferred.resolve('Item deleted successfully');
        };

        request.onerror = function(event){
          itemDeferred.reject('Error: ' + event.target.errorCode);
        };

        return itemDeferred.promise;
      });

      // When all delete promises are resolved or any one of them fails
      $q.all(deletePromises).then(function(){
        deferred.resolve('All items deleted successfully');
      }).catch(function(error){
        deferred.reject('Error: ' + error);
      });
    });

    return deferred.promise;
  }

  function getItem(storeName, key){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction([storeName]);
      var store = transaction.objectStore(storeName);
      var request = store.get(key);

      request.onsuccess = function(event){
        // console.log(event.target.result);
        deferred.resolve(event.target.result);
      };

      request.onerror = function(event){
        // console.log(event.target);
        deferred.reject('Error: ' + event.target.errorCode);
      };
    });

    return deferred.promise;
  }

  function getAllItems(obj){
    // console.log("Cursor", obj);

    var deferred = $q.defer();
    if(obj.stores && obj.stores.length){
      // console.log("IF______! ");
      obj.stores.forEach(function(store){
        openDatabase().then(function(db){
          var transaction = db.transaction([store.sName], 'readwrite');
          var curStore = transaction.objectStore(store.sName);
          var request;
          if((obj.sName == "dData" || obj.sName == "dData_folder") && obj.sortType && obj.sortVal){
            if(obj.sortType == "createdon"){
              obj.sortVal = "id";
            }
            var index = curStore.index(obj.sortType);
            var curSort = (obj.sortVal === 'desc')?'prev':'next';
            request = index.openCursor(null, curSort);

            // request = (obj.sortVal === 'desc')?index.openCursor():index.openCursor(null, 'prev'); //curStore.openCursor();
          } else{
            request = curStore.openCursor();
          }
          var items = [];
          request.onsuccess = function(event){
            var cursor = event.target.result;
            if(cursor){
              items.push(cursor.value);
              cursor.continue();
            } else{
              // console.warn("obj ", obj);
              if(obj.sName != "dData_info" && obj.sName != "dTag_color" && obj.sortType == "label"){
                // console.log(a, b);
                items.sort(function(a, b){
                  var labelA = a.l.toLowerCase();
                  var labelB = b.l.toLowerCase();
                  if(obj.sortVal === 'asc'){
                    return labelA<labelB?-1:(labelA>labelB?1:0);
                  } else{
                    return labelA>labelB?-1:(labelA<labelB?1:0);
                  }
                });
              }
              deferred.resolve(items);
            }
          };
          request.onerror = function(event){
            deferred.reject('Error: ' + event.target.errorCode);
          };
        });
      });
    } else{
      // console.log("ELSE______! ");
      openDatabase().then(function(db){
        var transaction = db.transaction([obj.sName]);
        var store = transaction.objectStore(obj.sName);
        var request;
        if(obj.sortType == "createdon"){
          obj.sortType = "id";
        }
        if(obj.sName == "dData_folders" && obj.sortType && obj.sortVal){
          var index = store.index(obj.sortType);
          var curSort = (obj.sortVal === 'desc')?'prev':'next';
          request = index.openCursor(null, curSort);
          // request = (obj.sortVal === 'asc')?index.openCursor():index.openCursor(null, 'prev');
          // request = curStore.openCursor();
        }
        else if(obj.sName == "dData" && obj.sortType && obj.sortVal){
          var index = store.index(obj.sortType);
          var curSort = (obj.sortVal === 'desc')?'prev':'next';
          request = index.openCursor(null, curSort);
          // request = (obj.sortVal === 'asc')?index.openCursor():index.openCursor(null, 'prev');
          // request = curStore.openCursor();
        } else{
          request = store.openCursor();
        }
        var items = [];
        request.onsuccess = function(event){
          var cursor = event.target.result;
          if(cursor){
            items.push(cursor.value);
            cursor.continue();
          } else{
            // console.warn("obj ", obj);
            if(obj.sName != "dData_info" && obj.sName != "dTag_color" && obj.sortType == "label"){
              // console.warn(items);
              items.sort(function(a, b){
                var labelA = a.l.toLowerCase();
                var labelB = b.l.toLowerCase();
                if(obj.sortVal === 'asc'){
                  return labelA<labelB?-1:(labelA>labelB?1:0);
                } else{
                  return labelA>labelB?-1:(labelA<labelB?1:0);
                }
              });
            }
            deferred.resolve(items);
          }
        };
        request.onerror = function(event){
          deferred.reject('Error: ' + event.target.errorCode);
        };
      });
    }
    return deferred.promise;
  }

  function clearStore(storeName){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction([storeName], 'readwrite');
      var store = transaction.objectStore(storeName);
      var request = store.clear();

      request.onsuccess = function(){
        deferred.resolve('Store cleared successfully');
      };

      request.onerror = function(event){
        deferred.reject('Error: ' + event.target.errorCode);
      };
    });

    return deferred.promise;
  }

  function clearAllStores(){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var storeNames = db.objectStoreNames;
      var promises = [];

      for(var i = 0; i < storeNames.length; i++){
        promises.push(clearStore(storeNames[i]));
      }

      $q.all(promises).then(function(results){
        deferred.resolve('All stores cleared successfully');
      }).catch(function(error){
        deferred.reject('Error: ' + error);
      });
    });

    return deferred.promise;
  }

  function deleteStore(storeName){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction([storeName], 'readwrite');
      var store = transaction.objectStore(storeName);
      var request = store.delete();

      request.onsuccess = function(){
        deferred.resolve('Store deleted successfully');
      };

      request.onerror = function(event){
        deferred.reject('Error: ' + event.target.errorCode);
      };
    });

    return deferred.promise;
  }

  /*Delete all stores and DB even you do't know store and DB name*/
  function deleteAllStores(){
    var deferred = $q.defer();

    IndexedDB.databases().then(function(databases){
      databases.forEach(function(database){
        dbName = database.name;
        dbVersion = database.version;

        var request = IndexedDB.open(dbName, dbVersion + 1); // Increment version number

        request.onupgradeneeded = function(event){
          var db = event.target.result;
          var storeNames = Array.from(db.objectStoreNames);
          storeNames.forEach(function(storeName){
            db.deleteObjectStore(storeName);
            // console.log(`Deleted object store "${storeName}" from database "${dbName}".`);
          });
        };

        request.onsuccess = function(event){
          var db = event.target.result;
          db.close(); // Close the database

          // After deleting all object stores, delete the database itself
          var deleteRequest = window.indexedDB.deleteDatabase(dbName);
          deleteRequest.onsuccess = function(){
            // console.log(`Deleted database "${dbName}".`);
            deleteAllStores();
          };
          deleteRequest.onerror = function(event){
            // console.error(`Error deleting database "${dbName}":`, event.target.errorCode);
          };
        };

        request.onerror = function(event){
          // console.error(`Error opening database "${dbName}":`, event.target.errorCode);
        };
      });
    }).catch(function(error){
      console.error("Error retrieving databases:", error);
    });
    return deferred.promise;
  }


  function upgradeDatabase(){
    var deferred = $q.defer();
    dbVersion++; //Upgrade DB Version
    var request = window.indexedDB.open(dbName, dbVersion);

    request.onupgradeneeded = function(event){
      var db = event.target.result;
      /*Delete*/
      storeArr.forEach(function(s){
        if(db.objectStoreNames.contains(s.name)){
          db.deleteObjectStore(s.name);
        }
      });

      /*Re-create*/
      storeArr.forEach(function(s){
        if(!db.objectStoreNames.contains(s.name)){
          var curStore = db.createObjectStore(s.name, { keyPath:"id", autoIncrement:true });
          if(s.sort){
            curStore.createIndex(s.sortBy, s.sortBy, {unique:s.unique?s.unique:false});
            curStore.createIndex("id", "id", { unique:s.unique?s.unique:false });
          }
        }
      });
    };

    request.onsuccess = function(event){
      deferred.resolve(event.target.result);
    };

    request.onerror = function(event){
      deferred.reject('Error: ' + event.target.errorCode);
    };

    return deferred.promise;
  }

  function getStoreCount(storeName){
    var deferred = $q.defer();

    openDatabase().then(function(db){
      var transaction = db.transaction(storeName, "readonly");
      var store = transaction.objectStore(storeName);
      // console.warn(store);
      // Get the count of items in the object store
      var countRequest = store.count();
      countRequest.onsuccess = function(){
        // console.log(`Object Store: ${storeName}`);
        // console.log(`Number of items: ${countRequest.result}`);
        deferred.resolve(countRequest.result); // Resolve the promise with the count
      };

      countRequest.onerror = function(event){
        // console.error(`Error counting items in object store "${storeName}":`, event.target.error);
        deferred.reject(event.target.error); // Reject the promise with the error
      };
    }).catch(function(error){
      deferred.reject(error); // Reject the promise if there's an error opening the database
    });

    return deferred.promise;
  }

  /*Get all count form stores and DB even you do't know store and DB name*/
  // indexedDB.databases().then(function(databases){
  //   databases.forEach(function(database){
  //     var dbName = database.name;

  //     // Open the database
  //     var request = indexedDB.open(dbName);

  //     request.onsuccess = function(event){
  //       var db = event.target.result;
  //       var objectStoreNames = Array.from(db.objectStoreNames);

  //       // Log the count of object stores
  //       console.log(`Database: ${dbName}`);
  //       console.log(`Number of object stores: ${objectStoreNames.length}`);
  //       console.log(`Number of object items : ${objectStoreNames}`);

  //       // Iterate through each object store
  //       objectStoreNames.forEach(function(storeName){
  //         var transaction = db.transaction(storeName, "readonly");
  //         var objectStore = transaction.objectStore(storeName);

  //         // Get the count of items in the object store
  //         var countRequest = objectStore.count();
  //         countRequest.onsuccess = function(){
  //             console.log(`Object Store: ${storeName}`);
  //             console.log(`Number of items: ${countRequest.result}`);
  //         };
  //       });
  //     };

  //     request.onerror = function(event){
  //       console.error(`Error opening database "${dbName}":`, event.target.errorCode);
  //     };
  //   });

  // }).catch(function(error){
  //   console.error("Error retrieving databases:", error);
  // });

  return{
    setIDBInfo: setIDBInfo,
    addItems: addItems,
    updateItem: updateItem,
    deleteItems: deleteItems,
    getItem: getItem,
    getAllItems: getAllItems,
    clearStore: clearStore,
    clearAllStores: clearAllStores,
    deleteStore: deleteStore,
    deleteAllStores: deleteAllStores,
    upgradeDatabase: upgradeDatabase,
    getStoreCount: getStoreCount
  };
});

/****
 * Example usage:
 * Set IDB Info (use for controler or js file)
  var dbInfo = {
    dbN:'hub_d', //Database Name
    dbV:1, //Database Version
    sArr:[ //Database Stores in array
      {name:'dData', sort:true, sortBy:'order', unique:true},
      {name:'sData'},
      {name:'fData', sort:true, sortBy:'order'},
      {name:'asData'}
    ]
  }
  IndexedDB.setIDBInfo(dbInfo); //calling IndexedDB function

 ****
 //for single item
  $scope.addItemDB({sName:"dData", value:$scope.dData.devices});
  $scope.addItemDB = function(store, item){
    IndexedDB.addItem(store, item).then(function(message){
      console.log(message);
    }).catch(function(error){
      console.error(error);
    });
  };

   //for multiple items
  $scope.addItemsDB({
    stores:[
      {sName:"dData", value:$scope.dData.devices},
      {sName:"dData_folders", value:$scope.dData.folders},
      {sName:"dData_info", value:$scope.dData.info}
    ]
  });
  $scope.addItemsDB = function(obj){
    IndexedDB.addItems(obj).then(function(message){
      // console.log("Added items ", message);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.updateItemDB = function(store, item){
    // var item = { id: 1, name: 'John Doe', age: 31 };
    IndexedDB.updateItem(store, item).then(function(message){
      console.log(message);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.deleteItemDB = function(store, key){
    // var key = 1;
    IndexedDB.deleteItem(store, key).then(function(message){
      console.log(message);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.clearStoreDB = function(store){
    IndexedDB.clearStore(store).then(function(message){
      console.log(message);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.getItemDB = function(store, key){
    // var key = 1;
    IndexedDB.getItem(store, key).then(function(item){
      console.log('Retrieved item:', item);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.getAllItemsDB = function(store){
    IndexedDB.getAllItems(store).then(function(items){
      console.log('All items:', items);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.clearAllStoresDB = function(){
    IndexedDB.clearAllStores().then(function(message){
      console.log(message);
    }).catch(function(error){
      console.error(error);
    });
  };

  $scope.resetAllStoresDB = function(){
    IndexedDB.upgradeDatabase().then(function(message){
      console.log('Database upgraded and all stores reset');
    }).catch(function(error){
      console.error(error);
    });
  };

  IndexedDB.deleteAllStores().then(function(message){
    console.log(message);
  }).catch(function(error){
    console.error(error);
  });

 *****/
(function(){
  'use strict';

  angular
    .module('hub')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, $stateParams){
    $rootScope.$state = $state;
    return $rootScope.$stateParams = $stateParams;
  }
})();
(function(){
  'use strict';
  angular
    .module('hub')
    .run(function($rootScope, $state, $cookies, $timeout, $interval, $http, $filter, $translate, $location, ngDialog, RestartSessionSrv, CommonSrv, DexieSrv, LANGUAGE_HOST){
      $rootScope.publicKey = "6LeRFB0TAAAAAPjjzhQTL0DVmVwbpF5pMfjRoJmQ";
      // $rootScope.apiHost = "https://pr24.lsquared.com/api/v1/";
      $rootScope.apiHost = "/api/v1/";
      // $rootScope.apiHost = "/api/v0/"; //for CPost test
     
      /* For login.js */
      // $rootScope.locationHost = "rc24.lsquared.com"; //dev
      // $rootScope.locationHost = "usnew.lsquared.com"; //rc
      $rootScope.locationHost = "trial.lsquared.com"; //Pro
      // $rootScope.locationHost = "cpost.lsquared.com:1150"; //CPost test

      /* For dashboard.js and devices.js */
      $rootScope.dPreviewPath = "/dPreview/index.html?ip="; //for dev/RC/Pro
      // $rootScope.dPreviewPath = "/dPreviewTest/index.html?ip="; //for CPost test

      /* For ccOpen.html */
      $rootScope.ccOpenUrl = "/hub/api/v1/tesths/stripe/post"; //for dev/RC/Pro
      // $rootScope.ccOpenUrl = "/hub/api/v0/tesths/stripe/post"; //for CPost test

      // $rootScope.thumbHost = "https://verkada.lsquared.com"; //for localhost test
      $rootScope.thumbHost = ""; //for Dist

      /* For libraries */
      // $rootScope.libraries = "https://pr24.lsquared.com/other"; //For local
      $rootScope.libraries = "other"; // For the Dist

      /*Localization Start*/
      // for the dist please update the varibale inside the config
      $rootScope.languageHost = LANGUAGE_HOST;
      /*Localization End*/
 

      /* For Release Notes Host */
      // $rootScope.releaseNotesHost = "https://dev.lsquared.com/supportDev/api/v1/"; // Dev
      $rootScope.releaseNotesHost = "https://support.lsquared.com/api_outlook/v1/"; //Prod
 
      $rootScope.copyRight = moment.utc().format("YYYY") + " &copy; L Squared Digital Signage"; //Footer copyright text

      $rootScope.uiVersion = "2.1.565.8"; //Hub:- 2.1.0.290 //Dev:- 2.1.0.822 //RC:- 2.1.0.547

      $rootScope.myTheme = {theme:"", clientTheme:""};
      $rootScope.pageTitle = "L Squared Hub - ";
      $rootScope.showTimeoutMsg = false;
      $rootScope.isPopupOpen = false;
      $rootScope.checkSSO = true;

      // For encryption
      $rootScope.pubKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApD7B2Z5ooW9trut7Tz1SclKSiZxrnaNQM3uq4lOD2r0tetKndqTtMjSwzhM9oYikpCmZqe8zNCrAXBs9dVjqa1tg9Dhq/DGsb8+qZag77/E0QsbROhHrvuraIfaAPeATtJkz6aLnJV+gqH30ugxTlqIJu0LnWwwiT1npIQeMt8dAXBH1EOROm41txi97Wf+tiReIFUetxEvqkdVkyAuBGo6muCSWOJqa9s079dfbHZQm/diP5vqmewcAAl84QgOWTI+yMFcY+xzXTKBbq3VgqZD5YCfEgG2iGq/pZtwGvZCaDSO9r8/cboLQ5L9mIuLLWnELj+3/KUoSebaf+Jd7DQIDAQAB-----END PUBLIC KEY-----';
      // decryption
      $rootScope.priKey = '-----BEGIN PRIVATE KEY-----MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQC5SDoQwL/KBIAnuciVvSWuXs2s9qcfFHQgrrTeMLQ4sxM5DVeVsIIxT0rcGZynCkjwtukjIRTx6swL2w8OyKvxVqRq0HnUcPm5igscIRLFMVb+OPuOeuUUq4UEjsYTssHoeKoucBKS21CZ0ePHqR/DCkv6YiT+7EEGJXmi/6qv1MRIfrYhFm9Un0wejqyRiAQqbkdzFZDVuOE5b40ptQ+1rDtUolRg5b9Tns7OhltkYffmYiCi5suLe7CfcYGMlPJURfKK7rPd8RSB7WeZSgUdkaQHI87hg4Vgn716sT299y5XCLUT0ODs/QtuEjQMQinlb4cICBvHbsVAHgjE8OYDAgMBAAECggEAEmNAn/kBD6NytH6TkYi7/Job/1ZbL5JwE+5CtOpQeHANMFRKpOhng01DOKSyD0HOC1WbvYjC819B8MtEq0rvBXx7xL372UF9BxTUFW6S1k8XOxOco38+zNZY1SL2NW5AIDoZaZJlxX1OenWCDYaTSF/1OlwTH9mCeoGtmKeW4OwpdA3pkaEBogLC0auhahj+AM64kcTLNzGIaghTL6I5L96eTTM6iOkbHl/hLAn5aQnBbCoOPpBlQ4WV4/XDnfDmXrwIBZK45Fy36slj8K2TvXfdgcNKsYV1+Hnm7/b0aThayyesZBNpMCz2/Y0zGKJlSsIt31VxwgRz9B5n/og0AQKBgQDbCBn7Q1JoyPElT2DMtPROCGRk/hclLYUyo/ny3OVRUFqQLtv4VN3sdMF1t7XXcxGF2V3DDy3DFigXCohmDY4V8HayRWo5OZFsfmouikTXLAr5857UsWHRzgoVsv4bCqsF+iYbQ11tPhk3fYfZJdWbGEK+mg+3Zixd9spWeefVQwKBgQDYjeEzzKkh0lslsLJRn7W3AbwN5EBZjT/6VJB6Lv/jeDg8KIxudlFZB/8O7/XFongGILfBDkQPi+LQ8LZtiOze7F/U1U+jnOkXgHhAiNH+l1PZ39jgLZtEL2bCyVttAYQMg9VkxC2n0AZ/c66KiF9qEnhUfjayLV/EeCbSN4FAQQKBgQCsXoDL2twkuFYGDaTZFGLacgJH9CpUyLD0/FR8itgwmLLcmvPjRy5qoiuJL2z8Q4L7uebu1agmye38y/4xieNSYq2Wd8gzhplqL0XyoD+ysedlcxKAwaOAj8wh7X3J3ChhCM4qUGZazS7dG33oJr0mU/5arzVFGDQ8MjZjvYXzrwKBgHMeYURfHN4M7EVJ/FFl3Hyv4F9mIks4ynTx9WfuijtLEmHwkE68eRwiIxW2vGlWqAVh6S0ov0egbm/yNphd/MW41GzZBKAObt7+fW6ZDUERAxNEaw8pT2vc4vzTe9Wjw6W/g3Ywz7Bw5rNkNLoSKt7BeNQ50CvB8TIJSWHg/cXBAoGALeDhxDeqNyuAiQcMtWUfUrG69zvOVAhoJazCqXMb0yUrvf/A2ki+BtjfB4v6fPYF0xGiqoMDgSLoFgt1n85s05GJBH5QkPVQpxvRAIiWhZHk4Cy9ttRkoc5fT2Tnr+sxwn4Cgg5q15xEJZ35wVG1VMDaRQn93DFaVDXyhHaPKj8=-----END PRIVATE KEY-----';

      /**For SSO*/
      $rootScope.$on("$stateChangeStart", function(event, toState, $scope){
        $rootScope.curState = toState.name;
        localStorage.removeItem("isActionOnDevice")
        var absUrl = $location.absUrl();
        $rootScope.domainName = absUrl.replace(/.+\/\/|https.|\..+/g, '');
        // $rootScope.domainName = "intel";
        if($rootScope.domainName != "dev2" && $rootScope.domainName != "rc" && $rootScope.domainName != "nav" && $rootScope.domainName != "us" && $rootScope.domainName != "hub" && $rootScope.domainName != "sharedservices" && $rootScope.domainName != "ttc" && $rootScope.domainName != "lifelabs" && $rootScope.domainName != "cpost" && $rootScope.domainName != "cpostrc" && $rootScope.domainName != "usnew" && $rootScope.domainName != "localhost:3000"){
          $http.get('../theme/'+$rootScope.domainName+'/json.json').then(function(response){
            $rootScope.dmainPageTitle = response.data.themeData.title;
            $rootScope.myTheme.clientTheme = $rootScope.domainName;
            $rootScope.pageTitle = $rootScope.dmainPageTitle + " Digital Signage - " + $translate.instant('cm.menu.' + $state.current.data.id);
            $rootScope.copyRight = moment.utc().format("YYYY") + " &copy; " + $rootScope.dmainPageTitle +" Digital Signage"; //Footer copyright text
          });
        }else{
          $rootScope.myTheme.clientTheme = "";
        }
        $rootScope.sso = angular.fromJson(localStorage.getItem("sso"));
        // if(($rootScope.curState == "login") && absUrl.indexOf("code") == -1 && absUrl.indexOf("state") == -1){ // if(($rootScope.curState == "login") && absUrl.indexOf("code") == -1 && absUrl.indexOf("state") == -1){ // 22102024 //SSO login error fixes.
        if($rootScope.curState == "login"){
          $("html").removeClass("dk");
          $rootScope.themeDataJson = [];
          RestartSessionSrv.ssoVerify().then(
            function(data){
              if(data.type){
                $rootScope.sso = data;
                localStorage.setItem('sso', JSON.stringify($rootScope.sso));
              } else if(data.code == 6060){
                if($rootScope.sso){
                  localStorage.removeItem("sso");
                  $state.reload();
                }
                $rootScope.curState = '';
              }
              $rootScope.checkSSO = false;
            },
            function(err){
              console.error(err);
            }
          );
        } else{
          $rootScope.checkSSO = false;
        }
      });

      /*Localization*/
      var translateChange = false;
      $rootScope.$on('$translateChangeSuccess', function(){
        $rootScope.pageTitle = "L Squared Hub - " + $translate.instant('cm.menu.' + $state.current.data.id);
        translateChange = true;
      });

      var auth;
      var sessionTime = 0;
      $rootScope.sessionTimoutFx = function(){
        document.title = $rootScope.pageTitle;

        var getAuth = localStorage.getItem("auth");
        try{
          auth = angular.fromJson(getAuth);
          // console.warn("TRY....", auth);
        } catch(e){
          // console.warn("CATCH....");
          // Remove all saved data from localStorage
          localStorage.clear();
          /* IDB Start */
          // Remove all saved data from IndexedDB.
          DexieSrv.clearData().then(function(){
            // console.log('Database cleared');
          });
        }

        if(auth && auth.life){
          sessionTime = auth.life - 30000;
        }
        try{
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $interval.cancel($rootScope.isInterval);
        } catch(e){}
        $rootScope.sessionTimeoutTimer = $timeout(function(){
          $rootScope.lock();
        }, sessionTime);//300,000 -- 23min(1,380,000) -- 60,000,000, 7200000 //// auth.life - 60000
        // }, sessionTime || 0);//300,000 -- 23min(1,380,000) -- 60,000,000, 7200000 //// auth.life - 60000
      }
      $rootScope.sessionTimoutFx();

      $rootScope.lock = function(){
        if($state.current.name != "login" && $state.current.name != "forgotPassword" && $state.current.name !== "loginSecurity" && $state.current.name != "resetPass" && $state.current.name != "setPass" && $state.current.name != "signup" && $state.current.name != "thanks"  && $state.current.name != "showPassword" && $state.current.name != "queue" && $state.current.name != "SaaSSubscribe" && $state.current.name != "iotButton" && $state.current.name != "loginSuccess"){
          $rootScope.showTimeoutMsg = true;
          $rootScope.sessionTimer = 30;
          try{
            $interval.cancel($rootScope.isInterval);
          } catch(e){}
          $rootScope.isInterval = $interval(function(){
            $rootScope.sessionTimer--;
            if($rootScope.sessionTimer%2 == 0){
              document.title = "...";
            } else{
              document.title = "ATTENTION";
            }
            if($rootScope.sessionTimer == 0){
              $interval.cancel($rootScope.isInterval);
              $rootScope.showTimeoutMsg = false;
              if($state.current.name == "selectServer" || $state.current.name == "twoFA"){
                $rootScope.ssLogOutFx();
              } else{
                $rootScope.logOutFx();
              }
            }
          }, 1000); //30 sec. timer
        } else{
          //no lock"
        }
      }

      $rootScope.resetSession = function(action){
        document.title = $rootScope.pageTitle;
        $timeout.cancel($rootScope.sessionTimeoutTimer);
        $timeout.cancel($rootScope.sessionMsgHideTimer);
        $timeout.cancel($rootScope.restartSessionTimer);
        $interval.cancel($rootScope.isInterval);
        $rootScope.showTimeoutMsg = false;
        RestartSessionSrv.restartSession().then(
          function(data){
            if(action){
              $rootScope.sessionTimoutFx();
            }
          },
          function(err){
            console.error(err);
          }
        );
      }

      $rootScope.keepSessionAlive = function(){
        try{
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.showTimeoutMsg = false;
          $rootScope.restartSessionTimer = $timeout(function(){
            RestartSessionSrv.restartSession().then(
              function(data){
                $rootScope.keepSessionAlive();
              },
              function(err){
                console.error(err);
              }
            );
          }, angular.fromJson(localStorage.getItem("auth")).life - 600000);//1,200,000
        }
        catch(e){}
      }

      $rootScope.$on("$stateChangeStart", function(event, toState, $scope){
        if(toState.name != "hub.schedules.s" && $rootScope.stateName != "d" && $rootScope.stateName != "c"){
          $rootScope.selectedT = 1; /*For Tab selection*/
        }
        $rootScope.selectedItems = [];
        $rootScope.curState = toState.name;
        $rootScope.parentState = toState.name.split(".")[0];
        $rootScope.advSearchArgObj = {};
        /*Localization*/
        if(translateChange){
          $rootScope.pageTitle = "L Squared Hub - " + $filter("translate")('cm.menu.'+ toState.data.id);
        }
        ngDialog.closeAll();
        try{
          $timeout.cancel($rootScope.sessionTimeoutTimer);
          $timeout.cancel($rootScope.sessionMsgHideTimer);
          $timeout.cancel($rootScope.restartSessionTimer);
          $rootScope.showTimeoutMsg = false;

          if(!$rootScope.isFileUploading && $rootScope.curState != "login" && $rootScope.curState != "forgotPassword" && $rootScope.curState !== "loginSecurity" && $rootScope.curState != "resetPass" && $rootScope.curState != "setPass" && $rootScope.curState != "signup" && $rootScope.curState != "thanks"  && $rootScope.curState != "showPassword" && $rootScope.curState != "selectServer" && $rootScope.curState != "twoFA" && $rootScope.curState != "queue" && $rootScope.parentState != "s" && $rootScope.parentState != "sd" && $state.current.name != "SaaSSubscribe" && $rootScope.curState != "iotButton" && $rootScope.curState != "loginSuccess"){
            $rootScope.sessionTimoutFx();
          } else if($rootScope.curState == "twoFA"){//$rootScope.curState == "selectServer" ||
            $rootScope.resetSession(true);
          }
        }
        catch(e){}

        if($rootScope.curState != "hub.billing.orp"){
          localStorage.removeItem("PO");
        }

        if($rootScope.csPromise){
          $timeout.cancel($rootScope.csPromise);
        }
        var currentState = toState.name.split(".");
        $scope.curPathFId = angular.fromJson(localStorage.getItem("curPathFId"));

        if(currentState[0] + "." + currentState[1] != "hub.contentAdd" && toState.name != "hub.contentLibrary.c" && toState.name != "hub.contentLibraryEditVid" && toState.name != "hub.contentLibraryEditImg" && toState.name != "hub.contentLibraryEditCapVid.vc" && toState.name != "hub.contentLibraryVidIndexer" && !$scope.curPathFId){
          localStorage.setItem("curFId", 0);
          localStorage.removeItem("curPathFId");
        } else if(currentState[0] + "." + currentState[1] != "hub.contentAdd" && toState.name != "hub.contentLibrary.c" && toState.name != "hub.contentLibraryEditVid" && toState.name != "hub.contentLibraryEditImg" && toState.name != "hub.contentLibraryEditCapVid.vc" && toState.name != "hub.contentLibraryVidIndexer"){
          localStorage.setItem("curFId", 0);
          localStorage.removeItem("curPathFId");
        }
        $scope.curPathTFId = angular.fromJson(localStorage.getItem("curPathTFId"));

        if(currentState[0] + "." + currentState[1] != "hub.tContainer" && toState.name != "hub.templates.t" && !$scope.curPathTFId){
          localStorage.setItem("curTFId", 0);
          localStorage.removeItem("curPathTFId");
        } else if(currentState[0] + "." + currentState[1] != "hub.tContainer" && toState.name != "hub.templates.t"){
          localStorage.setItem("curTFId", 0);
          localStorage.removeItem("curPathTFId");
        }

        if(currentState[0] + "." + currentState[1] != "hub.dContainer" && toState.name != "hub.devices.d" && !$scope.curFolderId){
          localStorage.setItem("curDFId", 0);
        }

        if(toState.name !== "login" && toState.name !== "forgotPassword" && toState.name !== "loginSecurity" && toState.name !== "resetPass" && toState.name !== "setPass" && toState.name !== "signup" && toState.name !== "thanks" && toState.name !== "showPassword" && toState.name !== "queue" && $rootScope.parentState !== "s" && $rootScope.parentState !== "sd" && $state.current.name != "SaaSSubscribe" && toState.name !== "iotButton" && toState.name !== "loginSuccess"){
          $scope.auth = angular.fromJson(localStorage.getItem("auth"));
          if(!$scope.auth){
            $scope.curLang = localStorage.getItem("loginLang");
            if($scope.curLang != ""){
              $state.go("login", {id:$scope.curLang});
            } else{
              $state.go("login");
            }
            event.preventDefault();
          }
        }

        setTimeout(function(){
          if(($scope.auth && $scope.auth.serverType == 1) || ($scope.auth && $scope.auth.serverType == 0 && ($rootScope.curState == "hub.billing.s" || $rootScope.curState == "hub.billing.o" || $rootScope.curState == "hub.billing.orp" || $rootScope.curState == "hub.bContainer.sub"))){
            $("iframe.zEWidget-launcher").removeClass("vHide");
            $("iframe.zEWidget-webWidget").removeClass("vHide");
          } else{
            $("iframe.zEWidget-launcher").addClass("vHide");
            $("iframe.zEWidget-webWidget").addClass("vHide");
          }
        }, 1000);

        if(toState.name != "twoFA" && $scope.auth && $scope.auth.is2fa && !$scope.auth.is2faCode){
          $scope.curLang = localStorage.getItem("loginLang");
          if($scope.curLang != ""){
            $state.go("login", {id:$scope.curLang.toLowerCase()});
          } else{
            $state.go("login");
          }
          event.preventDefault();
        } else if(toState.name === "s.login"){
          $rootScope.pageTitle = "L Squared Hub - " + toState.data.pageTitle;
        } else if(toState.name === "s.survey"){
          $rootScope.pageTitle = "L Squared Hub - " + toState.data.pageTitle;
        } else if(toState.name === "sd.survey"){
          $rootScope.pageTitle = "L Squared Hub - " + toState.data.pageTitle + "Desktop";
        } else if(toState.name === "login"){
          localStorage.removeItem("folderId");
          localStorage.removeItem("authLang");
          localStorage.removeItem("teamsApp");
          localStorage.removeItem("code1");
          localStorage.removeItem("curDFId");

          // Remove all saved data from localStorage
          localStorage.clear();

          /* IDB Start */
          // Remove all saved data from IndexedDB.
          DexieSrv.clearData().then(function(){
            // console.log('Database cleared');
          });

          // // Remove all saved data from IndexedDB.
          // var dbArr = ["scu"];
          // var dbCount = 0;

          // function deleteAllDB(){
          //   if(dbCount < dbArr.length){
          //     deleteDatabase(dbArr[dbCount]);
          //   } else{
          //     console.log("All databases deleted successfully!");
          //   }
          // }

          // function deleteDatabase(dbName){
          //   var request = window.indexedDB.deleteDatabase(dbName);
          //   request.onsuccess = function(event){
          //     console.log("Database ", dbName, " deleted successfully");
          //     dbCount++;
          //     deleteAllDB();
          //   };
          //   request.onerror = function(event){
          //     console.error("Failed to delete database ", dbName, ", ", event);
          //   };
          //   request.onblocked = function(event){
          //     console.warn("Delete operation is blocked for database ", dbName ,", ", event);
          //   };
          // }
          // deleteAllDB();
          /* IDB End */
        }
      });

      $rootScope.openSupport = function(){
        // $rootScope.iframeUrl = "https://lsquared-2347217.hs-sites.com/chatbot-landing-page"
        $("#iframeId").attr("src", "https://lsquared-2347217.hs-sites.com/chatbot-landing-page");
        $("#chatBtn").addClass("chatBtn-launcher");
        $("#supportPage").addClass("transitionSupportPage");
        $("#closebtn").addClass("transitionCloseBtn");
        $("#iframeId").addClass("iframePage");
        $("#closebtn").removeClass("gzfPCr");
        $("#openSupport").removeClass("bwsciD");
        $("#closebtn").addClass("dsOmqW");
        $("#openSupport").addClass("RGfWb");
        document.querySelector(".supportBtn").style.display = "none";
        document.querySelector(".supportCloseBtn").style.display = "block";
      }

      $rootScope.closwSupportPage = function(){
        // $rootScope.iframeUrl = ""
        $("#iframeId").attr("src", "");
        $("#chatBtn").removeClass("chatBtn-launcher");
        $("#chatBtn").addClass("chatBtn-launcher");
        $("#supportPage").removeClass("transitionSupportPage");
        $("#closebtn").removeClass("transitionCloseBtn");
        $("#closebtn").removeClass("dsOmqW");
        $("#openSupport").removeClass("RGfWb");
        $("#closebtn").addClass("gzfPCr");
        $("#openSupport").addClass("bwsciD");
        document.querySelector(".supportCloseBtn").style.display = "none";
        document.querySelector(".supportBtn").style.display = "block";
      }
    })
})();

(function(){
  'use strict';

  angular
    .module('hub')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider){
    $stateProvider
    /*Login*/
    .state('login', {
      url: '/:id',
      templateUrl: 'app/login/login.html',
      controller: 'LoginController',
      controllerAs: 'login',
      data: {
        id: 51,
        pageTitle: 'Login'
      }
    })
    /*Standalone*/
    .state('queue', {
      url: '/queue/:id',
      templateUrl: 'app/sa/queue/queue.html',
      controller: 'QueueController',
      controllerAs: 'queueCtrl',
      data: {
        id: 58,
        pageTitle: 'Queue Widget'
      }
    })
    .state('iotButton', {
      url: '/iotButton/:id',
      templateUrl: 'app/sa/IoT/IoT.html',
      controller: 'IoTController',
      controllerAs: 'iotCtrl'
    })
    .state('s', {
      url: '/survey',
      views: {
        '': {
          templateUrl: 'app/sa/survey/home.html',
          controller: 'SurveyCommonController',
          controllerAs: 'common'
        }
      }
    })
      .state('s.login', {
        url: '/login/:id',
        templateUrl: 'app/sa/survey/login.html',
        controller: 'SurveyLoginController',
        controllerAs: 'surveyLoginCtrl',
        data: {
          id: 59,
          pageTitle: 'Survey Login'
        }
      })
      .state('s.survey', {
        url: '/participate/:id',
        templateUrl: 'app/sa/survey/participate.html',
        data: {
          id: 60,
          pageTitle: 'Survey Participate'
        }
      })
      .state('s.thanks', {
        url: '/thanks/:id',
        templateUrl: 'app/sa/survey/thanks.html',
        data: {
          id: 61,
          pageTitle: 'Survey Thanks'
        }
      })
      .state('s.result', {
        url: '/result/:id',
        templateUrl: 'app/sa/survey/result.html',
        data: {
          id: 62,
          pageTitle: 'Survey Result'
        }
      })

    /* Survey desktop */
    .state('sd', {
      url: '/surveyDesktop',
      views: {
        '': {
          templateUrl: 'app/sa/surveyDesktop/home.html',
          controller: 'SurveyDeskCommonController',
          controllerAs: 'surveyDesk'
        }
      }
    })
      .state('sd.login', {
        url: '/login/:id/:mac',
        templateUrl: 'app/sa/surveyDesktop/login.html',
        controller: 'SurveyDeskLoginController',
        controllerAs: 'surveyDeskLoginCtrl',
        data: {
          id: 59,
          pageTitle: 'Survey Login'
        }
      })
      .state('sd.survey', {
        url: '/participate/:id/:mac',
        templateUrl: 'app/sa/surveyDesktop/participate.html',
        data: {
          id: 60,
          pageTitle: 'Survey Participate'
        }
      })
      .state('sd.thanks', {
        url: '/thanks/:id/:mac',
        templateUrl: 'app/sa/surveyDesktop/thanks.html',
        data: {
          id: 61,
          pageTitle: 'Survey Thanks'
        }
      })
      .state('sd.result', {
        url: '/result/:id/:mac',
        templateUrl: 'app/sa/surveyDesktop/result.html',
        data: {
          id: 62,
          pageTitle: 'Survey Result'
        }
      })

    .state('forgotPassword', {
      url: '/forgotPassword/',
      templateUrl: 'app/login/forgotPassword.html',
      controller: 'FPController',
      controllerAs: 'forgotPassword',
      data: {
        id: 52,
        pageTitle: 'Forgot Password'
      }
    })
    .state('resetPass', {
      url: '/resetPassword/:id',
      templateUrl: 'app/login/resetPass.html',
      controller: 'ResetPassController',
      controllerAs: 'resetPassCtrl',
      data:{
        id:63,
        pageTitle:'Reset Password'
      }
    })
    .state('setPass', {
      url: '/setPassword/:id',
      templateUrl: 'app/login/setPass.html',
      controller: 'SetPassController',
      controllerAs: 'setPassCtrl',
      data:{
        id:65,
        pageTitle:'Set Password'
      }
    })
    .state('signup', {
      url: '/signup/:id/:lang',
      templateUrl: 'app/login/signup.html',
      controller: 'SignupController',
      controllerAs: 'signupCtrl',
      data: {
        id: 53,
        pageTitle: 'Signup'
      }
    })
    .state('SaaSSubscribe', {
      url: '/SaaSSubscribe/',
      templateUrl: 'app/login/saasSubscribe.html',
      controller: 'SaaSSubscribeController',
      controllerAs: 'saaSSubscribeCtrl',
      data: {
        id: 53,
        pageTitle: 'Signup'
      }
    })
    .state('showPassword', {
      url: '/showPassword/:id/:email',
      templateUrl: 'app/login/showPassword.html',
      controller: 'ShowPasswordController',
      controllerAs: 'showPasswordController',
      data: {
        id: 54,
        pageTitle: 'Show Password'
      }
    })
    .state('approveItem', {
      url: '/approveItem/:type/:id/:sentTime/:sid/:uid',
      templateUrl: 'app/login/approveItem.html',
      controller: 'ApproveItemController',
      controllerAs: 'approveItemController',
      data: {
        id: 55,
        pageTitle: 'Approve Item'
      }
    })
    .state('twoFA', {
      url: '/authentication/',
      templateUrl: 'app/login/twoFA.html',
      controller: 'TwoFAController',
      controllerAs: 'twoFA',
      data: {
        id: 64,
        pageTitle: 'Two Factor Authentication'
      }
    })
    .state('selectServer', {
      url: '/selectServer/',
      templateUrl: 'app/login/selectServer.html',
      controller: 'selectServerController',
      controllerAs: 'selectServer',
      data: {
        id: 56,
        pageTitle: 'Select Server'
      }
    })

    /*CP*/
    .state('cpLogin', {
      url: '/cp/login/',
      templateUrl: 'app/cpLogin/cpLogin.html',
      controller: 'CPLoginController',
      controllerAs: 'cpLogin'
    })
    .state('cpDashboard', {
      url: '/cp/dashboard/',
      templateUrl: 'app/cpLogin/dashboard.html',
      controller: 'CPDashboardController',
      controllerAs: 'cpDashboard'
    })

    /*Common*/
    .state('hub', {
      url: '/hub',
      views: {
        '': {
          templateUrl: 'app/common/home.html',
          controller: 'CommonController',
          controllerAs: 'common'
        },
        "header@hub": {
          templateUrl: 'app/common/header.html'
        },
        "leftPanel@hub": {
          templateUrl: 'app/common/leftPanel.html'
        },
        "footer@hub": {
          templateUrl: 'app/common/footer.html'
        }
      }
    })

    /*Dashboard*/
    .state('hub.dashboard', {
      url: '/dashboard/',
      templateUrl: 'app/dashboard/dashboard.html',
      controller: 'DashboardController',
      controllerAs: 'dashboardCtrl',
      data: {
        id: 0,
        pageTitle: 'Dashboard'
      }
    })

    /*Advanced Search*/
    .state('hub.advancedSearch', {
      url: '/advancedSearch/',
      templateUrl: 'app/dashboard/advancedSearch.html',
      data: {
        pageTitle: 'Advanced Search'
      }
    })

    /*Content Library*/
    .state('hub.contentLibrary', {
      url: '/contentLibrary',
      templateUrl: 'app/contentLibrary/contentLibrary.html',
      controller: 'ContentLibraryController',
      controllerAs: 'contentLibrary',
      data: {
        id: 1,
        pageTitle: 'Content Library'
      }
    })
      /*Content Library Tab's*/
      .state('hub.contentLibrary.c', {
        url: '/c/',
        views: {
          "tabView": {
            templateUrl: 'app/contentLibrary/c.html'
          }
        }
      })
      .state('hub.contentLibrary.uc', {
        url: '/uc/',
        views: {
          "tabView": {
            templateUrl: 'app/contentLibrary/uc.html'
          }
        }
      })
      .state('hub.contentLibrary.ac', {
        url: '/ac/',
        views: {
          "tabView": {
            templateUrl: 'app/contentLibrary/ac.html'
          }
        }
      })
      .state('hub.contentLibrary.ec', {
        url: '/ec/',
        views: {
          "tabView": {
            templateUrl: 'app/contentLibrary/ec.html'
          }
        }
      })
      .state('hub.contentLibrary.dc', {
        url: '/dc/',
        views: {
          "tabView": {
            templateUrl: 'app/contentLibrary/dc.html'
          }
        }
      })
      /*Editro*/
      .state("hub.contentLibraryEditImg", {
        url: "/contentLibrary/ei/:id",
        templateUrl: "app/contentLibrary/editImg.html",
        controller: 'ImageVideoEditorController',
        controllerAs: 'ImageVideoEditor',
        data: {
          id: 1,
          pageTitle: "Content Library"
        }
      })
      .state("hub.contentLibraryEditCapVid", {
        url: "/contentLibrary",
        templateUrl: "app/contentLibrary/editVid.html",
        controller: 'VideoCaptionEditorController',
        controllerAs: 'VideoCaptionEditor',
        data: {
          id: 1,
          pageTitle: "Content Library"
        }
      })
      // todo video indexer
      .state("hub.contentLibraryVidIndexer", {
        url: "/contentLibrary/vi/:id",
        templateUrl: "app/contentLibrary/vidAIIndexer.html",
        controller: 'VideoAIIndexerController',
        controllerAs: 'VideoAIIndexer',
        data: {
          id: 1,
          pageTitle: "Content Library"
        }
      })

        /*Vid Editor Tab's*/
        .state('hub.contentLibraryEditCapVid.vc', {
          url: '/vc/',
          views: {
            "tabView": {
              templateUrl: 'app/contentLibrary/vc.html'
            }
          }
        })
        .state('hub.contentLibraryEditCapVid.ev', {
          url: '/ev/',
          views: {
            "tabView": {
              templateUrl: 'app/contentLibrary/ev.html'
            }
          }
        })
        .state('hub.contentLibraryEditCapVid.cp', {
          url: '/cp/',
          views: {
            "tabView": {
              templateUrl: 'app/contentLibrary/cp.html'
            }
          }
        })
        /*Content Library Widget's*/
        .state("hub.contentAdd", {
          url: "/contentLibrary",
          templateUrl: "app/contentLibrary/cAdd.html",
          data: {
            id: 1,
            pageTitle: "Content Library"
          }
        })
        .state("hub.contentAdd.contentAddTab", {
          url: "/add/c/",
          views: {
            "tabView": {
              templateUrl: "app/contentLibrary/cAddC.html",
              controller: 'ContentLibraryUploadController',
              controllerAs: 'contentLibraryUpload'
            }
          }
        })
        .state("hub.contentAdd.thirdParty", {
          url: "/add/t",
          views: {
            "tabView": {
              templateUrl: "app/contentLibrary/cAddT.html",
              controller: 'ThirdPartyCtrl',
              controllerAs: 'thirdParty'
            }
          }
        })
          /*third party Start*/
          .state("hub.contentAdd.thirdParty.tpuDbox", {
            url: "/tpuDbox",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuDbox.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuFb", {
            url: "/tpuFb",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuFb.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuFtp", {
            url: "/tpuFtp",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuFtp.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuDrive", {
            url: "/tpuDrive",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuDrive.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuInsta", {
            url: "/tpuInsta",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuInsta.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuTw", {
            url: "/tpuTw",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuTw.html"
              }
            }
          })
          .state("hub.contentAdd.thirdParty.tpuUrl", {
            url: "/tpuUrl",
            views: {
              "thirdPartyView": {
                templateUrl: "app/contentLibrary/thirdParty/tpuUrl.html"
              }
            }
          })


        .state("hub.contentAdd.widgetAddTab", {
          url: "/add/w",
          views: {
            "tabView": {
              templateUrl: "app/contentLibrary/cAddW.html",
              controller: 'ContentLibraryWidgetController',
              controllerAs: 'contentLibraryWidget'
            }
          }
        })
          /*Widgets Start*/
          .state("hub.contentAdd.widgetAddTab.empty", {
            url: "/empty",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/empty.html"
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.comEvent", {
            url: "/comEvent/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/comEvent.html",
                controller: 'ComEventController',
                controllerAs: 'comEventCtrl'
              }
            }
          })
          // .state("hub.contentAdd.widgetAddTab.aNetPre", {
          //   url: "/aNetPre/:id",
          //   views: {
          //     "widgetView": {
          //       templateUrl: "app/contentLibrary/widgets/aNetPre.html",
          //       controller: 'ActiveNetPreController',
          //       controllerAs: 'activeNetPreCtrl'
          //     }
          //   }
          // })
          .state("hub.contentAdd.widgetAddTab.agc", {
            url: "/agc/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/agc.html",
                controller: 'AgcController',
                controllerAs: 'agcCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.achievers", {
            url: "/achievers/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/achievers.html",
                controller: 'AchieversController',
                controllerAs: 'achieversCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.alertMsg", {
            url: "/alertMessage/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/alert.html",
                controller: 'AlertController',
                controllerAs: 'alertCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.aqi", {
            url: "/aqi/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/aqi.html",
                controller: 'AQIController',
                controllerAs: 'aqiCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.amazonQuickSight", {
            url: "/amazonQuickSight/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/amazonQuickSight.html",
                controller: 'AmazonQuickSightController',
                controllerAs: 'amazonQuickSightCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.autoLogin", {
            url: "/autoLogin/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/autoLogin.html",
                controller: 'AutoLoginController',
                controllerAs: 'autoLoginCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.coe", {
            url: "/coe/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/coe.html",
                controller: 'COEController',
                controllerAs: 'coeCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.coev", {
            url: "/coev/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/coev.html",
                controller: 'COEVController',
                controllerAs: 'coevCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.cloudCoverMusic", {
            url: "/ccm/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/cloudCoverMusic.html",
                controller: 'CloudCoverMusicController',
                controllerAs: 'cloudCoverMusicCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.ciscoMeraki", {
            url: "/ciscoMeraki/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/cisco.html",
                controller: 'CiscoController',
                controllerAs: 'CiscoCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.contentGroup", {
            url: "/contentGroup/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/contentGroup.html",
                controller: 'ContentGroupController',
                controllerAs: 'contentGroupCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.contentOnDemand", {
            url: "/cod/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/contentOnDemand.html",
                controller: 'ContentOnDemandController',
                controllerAs: 'ContentOnDemandCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.codButton", {
            url: "/codButton/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/codButton.html",
                controller: 'CoDButtonController',
                controllerAs: 'CoDButtonController'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.count", {
            url: "/count/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/count.html",
                controller: 'CountController',
                controllerAs: 'countCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.cloudFarm", {
            url: "/cloudFarm/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/cloudFarm.html",
                controller: 'CloudFarmController',
                controllerAs: 'cloudFarmCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.dateTime", {
            url: "/dateTime/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/dateTime.html",
                controller: 'DateTimeController',
                controllerAs: 'dateTimeCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.delimitedText", {
            url: "/delimitedText/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/delimitedText.html",
                controller: 'DelimitedTextController',
                controllerAs: 'delimitedTextCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.externalInput", {
            url: "/externalInput/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/extInput.html",
                controller: 'ExtInputController',
                controllerAs: 'extInputCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.excelSheet", {
            url: "/excelSheet/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/excelSheet.html",
                controller: 'ExcelSheetController',
                controllerAs: 'excelSheetCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.facebook", {
            url: "/facebook/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/facebook.html",
                controller: 'FacebookController',
                controllerAs: 'facebookCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.facebookWorkplace", {
            url: "/facebookWorkplace/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/facebookWorkplace.html",
                controller: 'FacebookWorkplaceController',
                controllerAs: 'facebookWpCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.fifa", {
            url: "/fifa/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/fifa.html",
                controller: 'FifaController',
                controllerAs: 'fifaCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.fillerContent", {
            url: "/fillerContent/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/fillerContent.html",
                controller: 'FillerContentController',
                controllerAs: 'fillerContentCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.flightSchedule", {
            url: "/flightSchedule/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/flightSchedule.html",
                controller: 'FlightScheduleController',
                controllerAs: 'flightScheduleCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.freeForm", {
            url: "/freeForm/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/freeForm.html",
                controller: 'FreeFormController',
                controllerAs: 'freeFormCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.fsChrome", {
            url: "/FSChrome/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/fsChrome.html",
                controller: 'FSChromeController',
                controllerAs: 'FSChromeCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.ftp", {
            url: "/FTP/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/ftp.html",
                controller: 'FTPController',
                controllerAs: 'ftpCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.f45", {
            url: "/f45/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45.html",
                controller: 'F45Controller',
                controllerAs: 'f45Ctrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.contentScroller", {
            url: "/contentScroller/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45ContentScroller.html",
                controller: 'ContentScrollerController',
                controllerAs: 'ContentScrollerCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.contentTile", {
            url: "/contentTile/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45ContentTile.html",
                controller: 'ContentTileController',
                controllerAs: 'ContentTileCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.countdownCircle", {
            url: "/countdownCircle/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45CountdownCircle.html",
                controller: 'CountdownCircleController',
                controllerAs: 'CountdownCircleCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.hydrate", {
            url: "/hydrate/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Hydrate.html",
                controller: 'HydrateController',
                controllerAs: 'HydrateCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.moveStation", {
            url: "/moveStation/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45MoveStation.html",
                controller: 'MoveStationController',
                controllerAs: 'MoveStationCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.progressBar", {
            url: "/progressBar/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/progressBar.html",
                controller: 'ProgressBarController',
                controllerAs: 'ProgressBarCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.f45progressBar", {
            url: "/f45progressBar/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45ProgressBar.html",
                controller: 'F45ProgressBarController',
                controllerAs: 'F45ProgressBarCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.animation", {
            url: "/animation/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Animation.html",
                controller: 'AnimationController',
                controllerAs: 'AnimationCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.progressBarWithBreak", {
            url: "/progressBarWithBreak/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45ProgressBarWithBreak.html",
                controller: 'ProgressBarWithBreakController',
                controllerAs: 'ProgressWithBarBreakCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.gCalendar", {
            url: "/GCalendar/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/gCalendar.html",
                controller: 'GCalendarController',
                controllerAs: 'GCalendarCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.gSlide", {
            url: "/GSlide/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/gSlide.html",
                controller: 'GSlideController',
                controllerAs: 'GSlideCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.grafana", {
            url: "/grafana/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/grafana.html",
                controller: 'GrafanaController',
                controllerAs: 'grafanaCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.hdSteth", {
            url: "/hdSteth/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/hdSteth.html",
                controller: 'HDStethController',
                controllerAs: 'hdStethCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.iFrame", {
            url: "/IFrame/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/iFrame.html",
                controller: 'IFrameController',
                controllerAs: 'IFrameCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.intelCircuitRss", {
            url: "/intelCircuitRss/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/intelCircuitRss.html",
                controller: 'IntelCircuitRssController',
                controllerAs: 'IntelCircuitRssCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.instagram", {
            url: "/instagram/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/instagram.html",
                controller: 'InstagramController',
                controllerAs: 'instagramCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.iMenu", {
            url: "/interactiveMenu/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/interactiveMenu.html",
                controller: 'InteractiveMenuController',
                controllerAs: 'iMenuCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.iotButton", {
            url: "/iotButton/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/iotButton.html",
                controller: 'IoTButtonController',
                controllerAs: 'iotBtnCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.jciMap", {
            url: "/jciMap/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/jciMap.html",
                controller: 'JciMapController',
                controllerAs: 'jciMapCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.linkedIn", {
            url: "/linkedIn/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/linkedIn.html",
                controller: 'LinkedInController',
                controllerAs: 'linkedInCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.liveStreaming", {
            url: "/liveStreaming/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/liveStreaming.html",
                controller: 'LiveStreamingController',
                controllerAs: 'liveStreamingCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.meeting", {
            url: "/meeting/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/meeting.html",
                controller: 'MeetingController',
                controllerAs: 'meetingCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.message", {
            url: "/message/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/message.html",
                controller: 'MessageController',
                controllerAs: 'messageCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.msTeams", {
            url: "/msTeams/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/msTeams.html",
                controller: 'MSTeamsController',
                controllerAs: 'msTeamsCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.teamsRoom", {
            url: "/teamsRoom/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/teamsRoom.html",
                controller: 'TeamsRoomController',
                controllerAs: 'TeamsRoomCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.musicChoice", {
            url: "/musicchoice/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/musicChoice.html",
                controller: 'MusicChoiceController',
                controllerAs: 'musicchoiceCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.news", {
            url: "/news/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/news.html",
                controller: 'NewsController',
                controllerAs: 'newsCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.nextBus", {
            url: "/nb/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/nextBus.html",
                controller: 'NextBusController',
                controllerAs: 'nextBusCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.nextVehicle", {
            url: "/nv/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/nextVehicle.html",
                controller: 'NextVehicleController',
                controllerAs: 'nextVehicleCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.patientWait", {
            url: "/patientWait/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/patientWait.html",
                controller: 'PatientWaitController',
                controllerAs: 'patientWaitCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.powerBI", {
            url: "/powerBI/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/powerBI.html",
                controller: 'PowerBIController',
                controllerAs: 'powerBICtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.qlik", {
            url: "/qlik/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/qlik.html",
                controller: 'QlikController',
                controllerAs: 'qlikCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.onlineRadio", {
            url: "/onlineRadio/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/onlineRadio.html",
                controller: 'OnlineRadioController',
                controllerAs: 'onlineRadioCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.openHours", {
            url: "/openHours/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/openHours.html",
                controller: 'OpenHoursController',
                controllerAs: 'openHoursCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.outlookCalendar", {
            url: "/outlookCalendar/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/outlookCalendar.html",
                controller: 'OutlookCalendarController',
                controllerAs: 'outlookCalendarCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.prayer", {
            url: "/prayer/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/prayer.html",
                controller: 'PrayerController',
                controllerAs: 'prayerCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.queue", {
            url: "/queue/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/queue.html",
                controller: 'QueueWController',
                controllerAs: 'queuewCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.quotes", {
            url: "/quotes/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/quotes.html",
                controller: 'QuotesController',
                controllerAs: 'quotesCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.qrCode", {
            url: "/qrCode/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/qrCode.html",
                controller: 'QRCodeController',
                controllerAs: 'qrCodeCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.readerboard", {
            url: "/readerBoard/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/readerBoard.html",
                controller: 'ReaderBoardController',
                controllerAs: 'ReaderBoardCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.rssFeed", {
            url: "/RSSFeed/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/rssFeed.html",
                controller: 'RSSFeedController',
                controllerAs: 'RSSFeedCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.scheduleCalendar", {
            url: "/scheduleCalendar/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/scheduleCalendar.html",
                controller: 'ScheduleCalendarController',
                controllerAs: 'scheduleCalendarCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.slack", {
            url: "/slack/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/slack.html",
                controller: 'SlackController',
                controllerAs: 'slackCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.intelSmartBuilding", {
            url: "/intelSmartBuilding/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/intelSmartBuilding.html",
                controller: 'SBController',
                controllerAs: 'sbCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.socialChorus", {
            url: "/socialChorus/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/socialChorus.html",
                controller: 'SocialChorusController',
                controllerAs: 'socialChorusCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.socialMedia", {
            url: "/selectSocialMedia/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/selectSocialMedia.html",
                controller: 'SelectSocialMediaController',
                controllerAs: 'sSMCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.stay", {
            url: "/stay/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Stay.html",
                controller: 'StayController',
                controllerAs: 'StayCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.stockPrice", {
            url: "/stockPrice/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/stockPrice.html",
                controller: 'StockPriceController',
                controllerAs: 'stockPriceCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.storm", {
            url: "/storm/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/storm.html",
                controller: 'StormController',
                controllerAs: 'stormCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.survey", {
            url: "/survey/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/survey.html",
                controller: 'SurveyController',
                controllerAs: 'surveyWCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.tableau", {
            url: "/tableau/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/tableau.html",
                controller: 'TableauController',
                controllerAs: 'tableauCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.telax", {
            url: "/telax/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/telax.html",
                controller: 'TelaxController',
                controllerAs: 'telaxCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.text", {
            url: "/text/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/text.html",
                controller: 'TextController',
                controllerAs: 'textCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.comPylonText", {
            url: "/comPylonText/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/comPylonText.html",
                controller: 'CoMPylonTextController',
                controllerAs: 'comPylonTextCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.traffic", {
            url: "/traffic/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/traffic.html",
                controller: 'TrafficController',
                controllerAs: 'trafficCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.touchlinkMeetings", {
            url: "/touchLink/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/touchLink.html",
                controller: 'TouchLinkController',
                controllerAs: 'touchLinkCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.trainingMode", {
            url: "/trainingMode/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/trainingMode.html",
                controller: 'TrainingModeController',
                controllerAs: 'tmCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.tsccm", {
            url: "/tsccm/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/tscCountryMile.html",
                controller: 'TsccmController',
                controllerAs: 'tsccmCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.twitter", {
            url: "/twitter/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/twitter.html",
                controller: 'TwitterController',
                controllerAs: 'twitterCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.unisys", {
            url: "/unisys/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/unisys.html",
                controller: 'UnisysController',
                controllerAs: 'unisysCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.vimeo", {
            url: "/vimeo/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/vimeo.html",
                controller: 'VimeoController',
                controllerAs: 'vimeoCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.weather", {
            url: "/weather/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/weather.html",
                controller: 'WeatherController',
                controllerAs: 'weatherCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.webCam", {
            url: "/webCam/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/webCam.html",
                controller: 'WebCamController',
                controllerAs: 'webCamCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.webLogin", {
            url: "/webLogin/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/webLogin.html",
                controller: 'WebLoginController',
                controllerAs: 'webLoginCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.webLoginChrome", {
            url: "/webLoginChrome/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/webLoginChrome.html",
                controller: 'WebLoginChromeController',
                controllerAs: 'webLoginChromeCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.webPage", {
            url: "/webPage/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/webPage.html",
                controller: 'WebPageController',
                controllerAs: 'webPageCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.work", {
            url: "/work/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Work.html",
                controller: 'WorkController',
                controllerAs: 'WorkCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.workout", {
            url: "/workout/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Workout.html",
                controller: 'WorkoutController',
                controllerAs: 'WorkoutCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.story", {
            url: "/story/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/f45Story.html",
                controller: 'StoryController',
                controllerAs: 'StoryCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.verkada", {
            url: "/verkada/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/verkada.html",
                controller: 'VarkadaController',
                controllerAs: 'VerkadaCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.wqMetro", {
            url: "/wqMetro/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/wqMetro.html",
                controller: 'WQMetroController',
                controllerAs: 'wqMetroCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.xovis", {
            url: "/xovis/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/xovis.html",
                controller: 'XovisController',
                controllerAs: 'xovisCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.yammer", {
            url: "/yammer/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/yammer.html",
                controller: 'YammerController',
                controllerAs: 'yammerCtrl'
              }
            }
          })
          .state("hub.contentAdd.widgetAddTab.youTube", {
            url: "/youTube/:id",
            views: {
              "widgetView": {
                templateUrl: "app/contentLibrary/widgets/youTube.html",
                controller: 'YoutubeController',
                controllerAs: 'youTubeCtrl'
              }
            }
          })
          /*Widgets End*/
    /*Content Library End*/

    /*Templates*/
    .state('hub.templates', {
      url: '/templates',
      templateUrl: 'app/templates/templates.html',
      controller: 'TemplatesController',
      controllerAs: 'templatesCtrl',
      data: {
        id: 2,
        pageTitle: 'Templates'
      }
    })
      /*Templates Tab's*/
      .state('hub.templates.t', {
        url: '/t/',
        views: {
          "tabView": {
            templateUrl: 'app/templates/t.html'
          }
        }
      })
      .state('hub.templates.ut', {
        url: '/ut/',
        views: {
          "tabView": {
            templateUrl: 'app/templates/ut.html'
          }
        }
      })
      .state('hub.templates.it', {
        url: '/it/',
        views: {
          "tabView": {
            templateUrl: 'app/templates/it.html'
          }
        }
      })
      .state('hub.templates.tl', {
        url: '/tl/',
        views: {
          "tabView": {
            templateUrl: 'app/templates/tl.html'
          }
        }
      })
      .state('hub.templates.ts', {
        url: '/ts/',
        views: {
          "tabView": {
            templateUrl: 'app/templates/ts.html'
          }
        }
      })
        /*Templates Step*/
        .state("hub.tContainer", {
          url: "/templates",
          templateUrl: "app/common/wizardContainer.html",
          data: {
            id: 2,
            pageTitle: "Templates"
          }
        })
        .state("hub.tContainer.tName", {
          url: "/name/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/templates/tName.html",
              controller: 'TemplatesCUController',
              controllerAs: 'templatesCUCtrl'
            }
          }
        })
        .state("hub.tContainer.tDesign", {
          url: "/design/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/templates/tDesign.html",
              controller: 'TemplatesCUController',
              controllerAs: 'templatesCUCtrl'
            }
          }
        })

    /*Schedules*/
    .state('hub.schedules', {
      url: '/schedules',
      templateUrl: 'app/schedules/schedules.html',
      controller: 'SchedulesController',
      controllerAs: 'schedulesCtrl',
      data: {
        id: 3,
        pageTitle: 'Schedules'
      }
    })
      /*Schedule Tab's*/
      .state('hub.schedules.s', {
        url: '/s/',
        views: {
          "tabView": {
            templateUrl: 'app/schedules/s.html'
          }
        }
      })
      .state('hub.schedules.us', {
        url: '/us/',
        views: {
          "tabView": {
            templateUrl: 'app/schedules/us.html'
          }
        }
      })
      .state('hub.schedules.is', {
        url: '/is/',
        views: {
          "tabView": {
            templateUrl: 'app/schedules/is.html'
          }
        }
      })
      .state('hub.schedules.es', {
        url: '/es/',
        views: {
          "tabView": {
            templateUrl: 'app/schedules/es.html'
          }
        }
      })
        /*Schedule Steps*/
        .state("hub.sContainer", {
          url: "/schedules",
          templateUrl: "app/common/wizardContainer.html",
          data: {
            id: 3,
            pageTitle: "Schedules"
          }
        })
        .state("hub.sContainer.sName", {
          url: "/name/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/schedules/sName.html",
              controller: 'SchedulesCUController',
              controllerAs: 'schedulesCUCtrl'
            }
          }
        })
        .state("hub.sContainer.sContent", {
          url: "/content/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/schedules/sContent.html",
              controller: 'SchedulesCUController',
              controllerAs: 'schedulesCUCtrl'
            }
          }
        })
        .state("hub.sContainer.sDevice", {
          url: "/device/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/schedules/sDevice.html",
              controller: 'SchedulesCUController',
              controllerAs: 'schedulesCUCtrl'
            }
          }
        })
        .state("hub.sContainer.sSchedule", {
          url: "/schedule/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/schedules/sSchedule.html",
              controller: 'SchedulesCUController',
              controllerAs: 'schedulesCUCtrl'
            }
          }
        })
        .state("hub.sContainer.sFrame", {
          url: "/frame/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/schedules/sFrame.html",
              controller: 'SchedulesCUController',
              controllerAs: 'schedulesCUCtrl'
            }
          }
        })

    /*Frame Layouts*/
    .state('hub.frameLayouts', {
      url: '/frameLayouts',
      templateUrl: 'app/frameLayouts/frameLayouts.html',
      controller: 'FrameLayoutsController',
      controllerAs: 'frameLayoutsCtrl',
      data: {
        id: 4,
        pageTitle: 'Frame Layouts'
      }
    })
      /*Frame Layout Tab's*/
      .state('hub.frameLayouts.fl', {
        url: '/fl/',
        views: {
          "tabView": {
            templateUrl: 'app/frameLayouts/fl.html'
          }
        }
      })
      .state('hub.frameLayouts.fla', {
        url: '/fla/',
        views: {
          "tabView": {
            templateUrl: 'app/frameLayouts/fla.html'
          }
        }
      })
      .state('hub.frameLayouts.ufl', {
        url: '/ufl/',
        views: {
          "tabView": {
            templateUrl: 'app/frameLayouts/ufl.html'
          }
        }
      })
      .state('hub.frameLayouts.ifl', {
        url: '/ifl/',
        views: {
          "tabView": {
            templateUrl: 'app/frameLayouts/ifl.html'
          }
        }
      })
      .state('hub.frameLayouts.fll', {
        url: '/fll/',
        views: {
          "tabView": {
            templateUrl: 'app/frameLayouts/fll.html'
          }
        }
      })
      .state("hub.flContainer", {
        url: "/frameLayouts",
        templateUrl: "app/common/wizardContainer.html",
        data: {
          id: 4,
          pageTitle: "Frame Layouts"
        }
      })
        /*FrameLayout Steps*/
        .state("hub.flContainer.flName", {
          url: "/fl/name/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flName.html",
              controller: 'FrameLayoutCUController',
              controllerAs: 'FrameLayoutCUCtrl'
            }
          }
        })
        .state("hub.flContainer.flDesign", {
          url: "/fl/design/:type/:id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flDesign.html",
              controller: 'FrameLayoutCUController',
              controllerAs: 'FrameLayoutCUCtrl'
            }
          }
        })
        /*Assignment Steps*/
        .state("hub.flContainer.flaName", {
          url: "/fla/name/:fl?id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flaName.html",
              controller: 'AssignmentCUController',
              controllerAs: 'assignmentCUCtrl'
            }
          }
        })
        .state("hub.flContainer.flaSchedule", {
          url: "/fla/schedule/:id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flaSchedule.html",
              controller: 'AssignmentCUController',
              controllerAs: 'assignmentCUCtrl'
            }
          }
        })
        .state("hub.flContainer.flaDevice", {
          url: "/fla/device/:id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flaDevice.html",
              controller: 'AssignmentCUController',
              controllerAs: 'assignmentCUCtrl'
            }
          }
        })
        .state("hub.flContainer.flaThreshold", {
          url: "/fla/threshold/:id",
          views: {
            "tabView": {
              templateUrl: "app/frameLayouts/flaThreshold.html",
              controller: 'AssignmentCUController',
              controllerAs: 'assignmentCUCtrl'
            }
          }
        })

    /*Devices*/
    .state('hub.devices', {
      url: '/devices',
      templateUrl: 'app/devices/devices.html',
      controller: 'DevicesController',
      controllerAs: 'devicesCtrl',
      data: {
        id: 5,
        pageTitle: 'Devices'
      }
    })
      /*Devices Tab's*/
      .state('hub.devices.d', {
        url: '/d/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/d.html'
          }
        }
      })
      .state('hub.devices.dg', {
        url: '/dg/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/dg.html'
          }
        }
      })
      .state('hub.devices.dt', {
        url: '/dt/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/dt.html'
          }
        }
      })
      .state('hub.devices.di', {
        url: '/di/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/di.html'
          }
        }
      })
      .state('hub.devices.ds', {
        url: '/ds/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/ds.html'
          }
        }
      })
      .state('hub.devices.dvw', {
        url: '/dvw/',
        views: {
          "tabView": {
            templateUrl: 'app/devices/dvw.html'
          }
        }
      })
        /*Devices Steps*/
        .state("hub.dContainer", {
          url: "/devices",
          templateUrl: "app/common/wizardContainer.html",
          data: {
            id: 5,
            pageTitle: "Devices"
          }
        })
        .state("hub.dContainer.dName", {
          url: "/d/name/:id/:fid",
          views: {
            "tabView": {
              templateUrl: "app/devices/dName.html",
              controller: 'DeviceCUController',
              controllerAs: 'deviceCUCtrl'
            }
          }
        })
        .state("hub.dContainer.dFrameLayout", {
          url: "/d/frameLayout/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/dFrameLayout.html",
              controller: 'DeviceCUController',
              controllerAs: 'deviceCUCtrl'
            }
          }
        })
        .state("hub.dContainer.dTag", {
          url: "/d/tag/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/dTag.html",
              controller: 'DeviceCUController',
              controllerAs: 'deviceCUCtrl'
            }
          }
        })
        /*Devices Group Steps*/
        .state("hub.dContainer.dgName", {
          url: "/dg/name/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/dgName.html",
              controller: 'DeviceGroupCUController',
              controllerAs: 'deviceGroupCUCtrl'
            }
          }
        })
        .state("hub.dContainer.dgDevice", {
          url: "/dg/device/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/dgDevice.html",
              controller: 'DeviceGroupCUController',
              controllerAs: 'deviceGroupCUCtrl'
            }
          }
        })

        .state("hub.dContainer.pl", {
          url: "/playlist/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/playList.html",
              controller: 'PlayListController',
              controllerAs: 'playListCtrl'
            }
          }
        })
        .state("hub.dContainer.plLsn", {//only for test
          url: "/playlist/:id",
          views: {
            "tabView": {
              templateUrl: "app/devices/playList.html",
              controller: 'PlayListLSNController',
              controllerAs: 'playListlsnCtrl'
            }
          }
        })
     /*Devices Tags Steps*/
     .state("hub.dContainer.dtName", {
      url: "/dt/name/:id",
      views: {
        "tabView": {
          templateUrl: "app/devices/dtName.html",
          controller: 'DeviceTagCUController',
          controllerAs: 'deviceTagCUCtrl'
        }
      }
    })
    .state("hub.dContainer.dtDevice", {
      url: "/dt/device/:id",
      views: {
        "tabView": {
          templateUrl: "app/devices/dtDevice.html",
          controller: 'DeviceTagCUController',
          controllerAs: 'deviceTagCUCtrl'
        }
      }
    })

    /*Devices Video Wall Steps*/
    .state("hub.dContainer.dvwName", {
      url: "/dvw/name/:id",
      views: {
        "tabView": {
          templateUrl: "app/devices/dvwName.html",
          controller: 'DeviceVideoWallCUController',
          controllerAs: 'deviceVideoWallCUCtrl'
        }
      }
    })

    /*User*/
    .state('hub.users', {
      url: '/users',
      templateUrl: 'app/users/users.html',
      controller: 'UsersController',
      controllerAs: 'usersCtrl',
      data: {
        id: 6,
        pageTitle: 'Users'
      }
    })
      /*Users Tab's*/
      .state('hub.users.au', {
        url: '/au/',
        views: {
          "tabView": {
            templateUrl: 'app/users/au.html'
          }
        }
      })
      .state('hub.users.ug', {
        url: '/ug/',
        views: {
          "tabView": {
            templateUrl: 'app/users/ug.html'
          }
        }
      })
      .state('hub.users.uu', {
        url: '/uu/',
        views: {
          "tabView": {
            templateUrl: 'app/users/uu.html'
          }
        }
      })
      .state('hub.users.bu', {
        url: '/bu/',
        views: {
          "tabView": {
            templateUrl: 'app/users/bu.html'
          }
        }
      })
      .state('hub.users.rr', {
        url: '/rr/',
        views: {
          "tabView": {
            templateUrl: 'app/users/rr.html'
          }
        }
      })
      .state('hub.users.mb', {
        url: '/mb/',
        views: {
          "tabView": {
            templateUrl: 'app/users/mb.html'
          }
        }
      })
        /*User Steps*/
        .state("hub.uContainer", {
          url: "/users",
          templateUrl: "app/common/wizardContainer.html",
          data: {
            id: 6,
            pageTitle: "Users"
          }
        })
        .state("hub.uContainer.userCU", {
          url: "/usercu/:id",
          views: {
            "tabView": {
              templateUrl: "app/users/userCU.html",
              controller: 'UserCUController',
              controllerAs: 'userCUCtrl'
            }
          }
        })
        /*User Group*/
        .state("hub.uContainer.ugName", {
          url: "/ug/name/:id",
          views: {
            "tabView": {
              templateUrl: "app/users/ugName.html",
              controller: 'UserGrpCUController',
              controllerAs: 'userGrpCUCtrl'
            }
          }
        })
        .state("hub.uContainer.ugUsers", {
          url: "/ug/users/:id",
          views: {
            "tabView": {
              templateUrl: "app/users/ugUsers.html",
              controller: 'UserGrpCUController',
              controllerAs: 'userGrpCUCtrl'
            }
          }
        })
        /*User roles & rights*/
        .state("hub.uContainer.rr", {
          url: "/rolecu/:id",
          views: {
            "tabView": {
              templateUrl: "app/users/roleCU.html",
              controller: 'RoleCUController',
              controllerAs: 'roleCUCtrl'
            }
          }
        })

    /*Emergency Message*/
    .state('hub.emergencyMsg', {
      url: '/emergencyMsg',
      templateUrl: 'app/emergencyMsg/emergencyMsg.html',
      controller: 'EmergencyMsgController',
      controllerAs: 'emergencyMsgCtrl',
      data: {
        id: 7,
        pageTitle: 'Emergency Message'
      }
    })
      /*Emergency Message Tab's*/
      .state('hub.emergencyMsg.em', {
        url: '/em/',
        views: {
          "tabView": {
            templateUrl: "app/emergencyMsg/em.html"
          }
        }
      })
      .state('hub.emergencyMsg.sm', {
        url: '/sm/',
        views: {
          "tabView": {
            templateUrl: "app/emergencyMsg/sm.html"
          }
        }
      })
      .state('hub.emergencyMsg.es', {
        url: '/es/',
        views: {
          "tabView": {
            templateUrl: "app/emergencyMsg/es.html"
          }
        }
      })

    /*Reports*/
    .state('hub.reports', {
      url: '/reports',
      templateUrl: 'app/reports/reports.html',
      controller: 'ReportsController',
      controllerAs: 'reportsCtrl',
      data: {
        id: 8,
        pageTitle: 'Reports'
      }
    })
    .state('hub.reports.c', {
      url: '/c',
      views: {
        "tabView": {
          templateUrl: "app/reports/content.html"
        }
      }
    })
    .state('hub.reports.c.cc', {
      url: '/cc/',
      views: {
        "tabView": {
          templateUrl: "app/reports/cc.html"
        }
      }
    })
    .state('hub.reports.c.cs', {
      url: '/cs/',
      views: {
        "tabView": {
          templateUrl: "app/reports/cs.html"
        }
      }
    })
    .state('hub.reports.c.pp', {
      url: '/pp/',
      views: {
        "tabView": {
          templateUrl: "app/reports/pp.html"
        }
      }
    })
    .state('hub.reports.d', {
      url: '/d',
      views: {
        "tabView": {
          templateUrl: "app/reports/device.html"
        }
      }
    })
    .state('hub.reports.d.ds', {
      url: '/ds/',
      views: {
        "tabView": {
          templateUrl: "app/reports/ds.html"
        }
      }
    })
    .state('hub.reports.d.hg', {
      url: '/hg/',
      views: {
        "tabView": {
          templateUrl: "app/reports/hg.html"
        }
      }
    })
    .state('hub.reports.d.ir', {
      url: '/ir/',
      views: {
        "tabView": {
          templateUrl: "app/reports/ir.html"
        }
      }
    })
    .state('hub.reports.d.od', {
      url: '/od/',
      views: {
        "tabView": {
          templateUrl: "app/reports/od.html"
        }
      }
    })
    .state('hub.reports.d.op', {
      url: '/op/',
      views: {
        "tabView": {
          templateUrl: "app/reports/op.html"
        }
      }
    })
    .state('hub.reports.d.dst', {
      url: '/dst/',
      views: {
        "tabView": {
          templateUrl: "app/reports/dst.html"
        }
      }
    })
    .state('hub.reports.d.poh', {
      url: '/poh/',
      views: {
        "tabView": {
          templateUrl: "app/reports/poh.html"
        }
      }
    })
    .state('hub.reports.d.hk', {
      url: '/hk/',
      views: {
        "tabView": {
          templateUrl: "app/reports/hk.html"
        }
      }
    })
    .state('hub.reports.s', {
      url: '/s/',
      views: {
        "tabView": {
          templateUrl: "app/reports/s.html"
        }
      }
    })
    .state('hub.reports.hds', {
      url: '/hds',
      views: {
        "tabView": {
          templateUrl: "app/reports/steth.html"
        }
      }
    })
    .state('hub.reports.hds.pp', {
      url: '/pp/',
      views: {
        "tabView": {
          templateUrl: "app/reports/hdpp.html"
        }
      }
    })
    .state('hub.reports.hds.es', {
      url: '/es/',
      views: {
        "tabView": {
          templateUrl: "app/reports/es.html"
        }
      }
    })
    .state('hub.reports.hds.rv', {
      url: '/rv/',
      views: {
        "tabView": {
          templateUrl: "app/reports/rv.html"
        }
      }
    })
    .state('hub.reports.hds.ac', {
      url: '/ac/',
      views: {
        "tabView": {
          templateUrl: "app/reports/ac.html"
        }
      }
    })
    .state('hub.reports.d.ci', {
      url: '/ci/',
      views: {
        "tabView": {
          templateUrl: "app/reports/ci.html"
        }
      }
    })

    /*Inventory*/
    .state('hub.inventory', {
      url: '/inventory',
      templateUrl: 'app/inventory/inventory.html',
      controller: 'InventoryController',
      controllerAs: 'inventoryCtrl',
      data: {
        id: 11,
        pageTitle: 'Inventory'
      }
    })
    .state('hub.inventory.a', {
      url: '/a',
      views: {
        "tabView": {
          templateUrl: "app/inventory/a.html"
        }
      }
    })
    .state('hub.inventory.ae', {
      // url: '/ae',
      url: '/r',
      views: {
        "tabView": {
          templateUrl: "app/inventory/ae.html"
        }
      }
    })
    .state('hub.inventory.al', {
      // url: '/al',
      url: '/d',
      views: {
        "tabView": {
          templateUrl: "app/inventory/al.html"
        }
      }
    })
    .state('hub.inventory.cq', {
      url: '/cq',
      views: {
        "tabView": {
          templateUrl: "app/inventory/cq.html"
        }
      }
    })
    .state('hub.inventory.devices', {
      url: '/device',
      views: {
        "tabView": {
          templateUrl: "app/inventory/devices.html"
        }
      }
    })
    .state('hub.inventory.others', {
      url: '/other',
      views: {
        "tabView": {
          templateUrl: "app/inventory/others.html"
        }
      }
    })

    /*Inventory Steps*/
    .state("hub.iContainer", {
      url: "/inventory",
      templateUrl: "app/common/wizardContainer.html",
      data: {
        id: 11,
        pageTitle: "Inventory"
      }
    })
      .state("hub.iContainer.cu", {
        url: "/cu/:status/:id",
        views: {
          "tabView": {
            templateUrl: "app/inventory/cu.html",
            controller: 'InventoryCUController',
            controllerAs: 'inventoryCUCtrl'
          }
        }
      })

    /*Creative Services*/
    .state('hub.creativeServices', {
      url: '/creativeServices',
      templateUrl: 'app/creativeServices/creativeServices.html',
      controller: 'CreativeSrvController',
      controllerAs: 'creativeServicesCtrl',
      data: {
        id: 9,
        pageTitle: 'Creative Services'
      }
    })
      /*Creative Services Tab's*/
      .state('hub.creativeServices.cur', {
        url: '/cur/',
        views: {
          "tabView": {
            templateUrl: "app/creativeServices/cur.html"
          }
        }
      })
      .state('hub.creativeServices.cmp', {
        url: '/cmp/',
        views: {
          "tabView": {
            templateUrl: "app/creativeServices/cmp.html"
          }
        }
      })
      .state('hub.creativeServices.inv', {
        url: '/inv/',
        views: {
          "tabView": {
            templateUrl: "app/creativeServices/inv.html"
          }
        }
      })
        .state("hub.cContainer", {
          url: "/creativeServices",
          templateUrl: "app/common/wizardContainer.html",
          data: {
            id: 9,
            pageTitle: "Creative Services"
          }
        })
          .state("hub.cContainer.csAdd", {
            url: "/csAdd",
            views: {
              "tabView": {
                templateUrl: 'app/creativeServices/csAdd.html',
                controller: 'CSAddController',
                controllerAs: 'csAddCtrl'
              }
            }
          })
          .state('hub.cContainer.cs', {
            url: '/details',
            views: {
              "tabView": {
                templateUrl: 'app/creativeServices/csDetails.html',
                controller: 'CSDetailsController',
                controllerAs: 'csDetailsCtrl'
              }
            }
          })
            .state('hub.cContainer.cs.odTab', {
              url: '/dc/:id',
              views: {
                "tabView": {
                  templateUrl: 'app/creativeServices/csOrderDetail.html'
                }
              }
            })
            .state('hub.cContainer.cs.aTab', {
              url: '/a/:id',
              views: {
                "tabView": {
                  templateUrl: 'app/creativeServices/csOrderAttachment.html'
                }
              }
            })
            .state('hub.cContainer.cs.iTab', {
              url: '/i/:id',
              views: {
                "tabView": {
                  templateUrl: 'app/creativeServices/csOrderInvoice.html'
                }
              }
            })
            .state('hub.cContainer.cs.cp', {
              url: '/cp/:id?param',
              views: {
                "tabView": {
                  templateUrl: 'app/creativeServices/csPaymentConfirmation.html',
                  controller: 'CSPaymentController',
                  controllerAs: 'csPaymentCtrl'
                }
              }
            })

      /*Billing*/
      .state('hub.billing', {
        url: '/billing',
        templateUrl: 'app/billing/billing.html',
        controller: 'BillingController',
        controllerAs: 'billingCtrl',
        data: {
          id: 10,
          pageTitle: 'Billing'
        }
      })
        /*Billing Tab's*/
        .state('hub.billing.s', {
          url: '/s',
          views: {
            "tabView": {
              templateUrl: 'app/billing/s.html'
            }
          }
        })
        .state('hub.billing.o', {
          url: '/o',
          views: {
            "tabView": {
              templateUrl: 'app/billing/o.html'
            }
          }
        })
        .state("hub.billing.orp", {
          url: '/orp/:id',
          views: {
            "tabView": {
              templateUrl: 'app/billing/orp.html'
            }
          }
        })

        /*Billing Steps*/
        .state("hub.bContainer", {
          url: '/billing',
          templateUrl: 'app/common/wizardContainer.html',
          data: {
            id: 10,
            pageTitle: 'Billing'
          }
        })
          .state("hub.bContainer.sub", {
            url: '/sub/:id',
            views: {
              "tabView": {
                templateUrl: 'app/billing/sDetails.html',
                controller: 'SubscriptionsController',
                controllerAs: 'subCUCtrl'
              }
            }
          })

    /*Support*/
    .state('hub.support', {
      url: '/support',
      templateUrl: 'app/support/support.html',
      data: {
        id: 21,
        pageTitle: 'Support'
      }
    })
      /*Support Tab's*/
      .state('hub.support.ts', {
        url: '/ts/',
        views: {
          "tabView": {
            templateUrl: "app/support/ts.html",
            controller: 'SupportController',
            controllerAs: 'supportCtrl'
          }
        }
      })
      .state('hub.support.kb', {
        url: '/kb/',
        views: {
          "tabView": {
            templateUrl: "app/support/kb.html",
            controller: 'SupportController',
            controllerAs: 'supportCtrl'
          }
        }
      })
      .state('hub.support.fr', {
        url: '/fr',
        views: {
          "tabView": {
            templateUrl: "app/support/featureRequest/featureRequest.html",
            controller: 'FeatureRequestController',
            controllerAs: 'featureRequestCtrl'
          }
        }
      })
        /*Feature Request Tab's*/
        .state('hub.support.fr.rf', {
          url: '/rf/',
          views: {
            "tabView": {
              templateUrl: "app/support/featureRequest/rf.html"
            }
          }
        })
        .state('hub.support.fr.af', {
          url: '/af/',
          views: {
            "tabView": {
              templateUrl: "app/support/featureRequest/af.html"
            }
          }
        })
        .state('hub.support.fr.im', {
          url: '/im/',
          views: {
            "tabView": {
              templateUrl: "app/support/featureRequest/im.html"
            }
          }
        })
        .state('hub.featureDetails', {
          url: '/support/fr/details/:id',
          templateUrl: "app/support/featureRequest/featureDetails.html",
          controller: 'FeatureRequestController',
          controllerAs: 'featureRequestCtrl',
          data: {
            id: 21,
            pageTitle: 'Support'
          }
        })

      .state('hub.support.rb', {
          url: '/rb/',
          views: {
            "tabView": {
              templateUrl: "app/support/reportBug/rb.html"
            }
          }
        })
        .state('hub.support.rb.oi', {
          url: 'oi',
          views: {
            "rbView": {
              templateUrl: "app/support/reportBug/oi.html"
            }
          }
        })
        .state('hub.support.rb.ci', {
          url: 'ci',
          views: {
            "rbView": {
              templateUrl: "app/support/reportBug/ci.html"
            }
          }
        })

    /*My Settings*/
    .state('hub.mySettings', {
      url: '/mySettings',
      templateUrl: 'app/common/mySettings.html',
      controller: 'MySettingsController',
      controllerAs: 'mySettingsCtrl',
      data: {
        id: 22,
        pageTitle: 'My Settings'
      }
    })
    .state('hub.mySettings.pro', {
      url: '/pro/',
      views: {
        "tabView": {
          templateUrl: 'app/common/pro.html',
        }
      }
    })
    .state('hub.mySettings.pre', {
      url: '/pre/',
      views: {
        "tabView": {
          templateUrl: 'app/common/pre.html',
        }
      }
    })
    .state('hub.mySettings.ss', {
      url: '/ss/',
      views: {
        "tabView": {
          templateUrl: 'app/common/serverSetting.html',
          controller: 'SettingsServersController',
          controllerAs: 'SettingsServersCtrl'
        }
      }
    })
    .state('hub.mySettings.cp', {
      url: '/cp/',
      views: {
        "tabView": {
          templateUrl: 'app/common/cp.html',
        }
      }
    })
    .state('hub.mySettings.co', {
      url: '/co/',
      views: {
        "tabView": {
          templateUrl: 'app/common/co.html',
        }
      }
    })
    .state('hub.mySettings.as', {
      url: '/as/',
      views: {
        "tabView": {
          templateUrl: 'app/common/as.html',
        }
      }
    })
    .state('hub.mySettings.asana', {
      url: '/asana/',
      views: {
        "tabView": {
          templateUrl: 'app/common/asana.html',
        }
      }
    })

    /* Teams App */
    .state('hub.teamsApp', {
      url: '/teamsApp',
      templateUrl: 'app/teamsApp/teamsApp.html',
      controller: 'TeamsAppController',
      controllerAs: 'teamsAppCtrl',
      data: {
        id: 23,
        pageTitle: 'Teams app'
      }
    })
    /* Teams Channel App */
    .state("hub.contentAdd.widgetAddTab.teamsChannel", {
      url: "/teamsChannel/:id",
      views: {
        "widgetView": {
          templateUrl: "app/contentLibrary/widgets/teamsChannel.html",
          controller: 'TeamsChannelController',
          controllerAs: 'teamsChannelCtrl'
        }
      }
    })
    /* Webex */
    .state("hub.contentAdd.widgetAddTab.webex", {
      url: "/webex/:id",
      views: {
        "widgetView": {
          templateUrl: "app/contentLibrary/widgets/webex.html",
          controller: 'WebexController',
          controllerAs: 'wabexCtrl'
        }
      }
    })

    .state('home', {
      url: '/home',
      templateUrl: 'app/main/main.html',
      controller: 'MainController',
      controllerAs: 'main'
    })

    .state('loginSuccess', {
      url: '/loginSuccess/',
      templateUrl: 'app/login/loginSuccess.html',
      controller: 'LSController',
      controllerAs: 'loginSuccess',
      data: {
        id: 57,
        pageTitle: 'Login Success'
      }
    })

    $urlRouterProvider.otherwise('/');
  }
})();

/* global malarkey:false, moment:false */
(function(){
  'use strict';

  angular
    .module('hub')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function(){
  'use strict';

  angular
    .module('hub')
    // .constant('LANGUAGE_HOST', 'localization/') // For the dist
    .constant('LANGUAGE_HOST', 'other/localization/') // For the dist
    // .constant('LANGUAGE_HOST', 'https://pr24.lsquared.com/other/localization/') // For the localHost
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, LANGUAGE_HOST){//$stateProvider, $httpProvider, RestangularProvider
    // Enable log
    $logProvider.debugEnabled(true);
    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    /*Localization*/
    var authLang = angular.fromJson(localStorage.getItem("authLang"));
    var lang = angular.fromJson(localStorage.getItem("lang"));

    // $translateProvider.translations('en', {
    //   "lang": "en_US",
    //   "cm": {
    //     "menu": {
    //       "51": "Login",
    //       "52": "Forgot Password",
    //       "53": "Signup",
    //       "54": "Show Password",
    //       "55": "Approve Item",
    //       "56": "Select Server",
    //       "57": "Login Success"
    //     },
    //     "head": {
    //       "menu": {
    //         "5": "Logout"
    //       }
    //     },
    //     "ph": {
    //       "1": "Type to search"
    //     },
    //     "footer": {
    //       "1": "Terms & Conditions",
    //       "2": "Privacy Policy",
    //       "3": ""
    //     },
    //     "btn": {
    //       "18": "Continue"
    //     },
    //     "msg": {
    //       "14": "Your search {{searchText}} did not match any item. Try different keyword.",
    //       "27": "No Internet found. Please check your connection.",
    //       "28": "{{htmlTagO}}Security Logout!{{htmlTagC}} Since there is no user activity for a long time, L Squared Hub will automatically logout in {{sessionTimer}} seconds.",
    //       "29": "Keep me logged in."
    //     }
    //   },
    //   "signup": {
    //     "label": {
    //       "1": "Name",
    //       "1.1": "First",
    //       "1.2": "Last",
    //       "2": "Password",
    //       "3": "Confirm password"
    //     },
    //     "btn": {
    //       "1": "Sign Up",
    //       "2": "Cancel"
    //     },
    //     "msg": {
    //       "1": "Welcome to {{brand}} Digital Signage Platform",
    //       "2": "All fields are mandatory.",
    //       "3": "Passwords did not match.",
    //       "4": "Please validate captcha.",
    //       "5": "User already exist.",
    //       "6": "Oops! Something went wrong. Please try again later.",
    //         "6.1": "Try sign up again",
    //       "7": "Thanks for joining {{brand}}.",
    //       "8": "Your account has been created with {{brand}}.",
    //       "9": "Sign in to {{brand}}",
    //       "10": "Password must be at least 8 characters.",
    //       "11": "Password must contain at least one capital and one small letter.",
    //       "12": "Password must contain at least one digit.",
    //       "13": "Password must contain at least one of the following character:",
    //       "14": "Password is not valid."
    //     }
    //   },
    //   "login": {
    //     "label": {
    //       "1": "Email",
    //       "2": "Password",
    //       "3": "Forgot Password?",
    //       "4": "clicking here",
    //       "5": "Resend email?",
    //       "6": "Terms",
    //       "7": "Conditions",
    //       "8": "Privacy Policy",
    //       "9": "Reset Password"
    //     },
    //     "btn": {
    //       "1": "Sign In",
    //       "2": "Sign In with Azure SSO",
    //       "3": "Cancel"
    //     },
    //     "msg": {
    //       "1": "Welcome to L Squared Digital Signage Platform",
    //       "2": "Your L Squared Hub account will lock as a result of multiple failed login attempts. You have only 1 more attempt remaining. If you forgot your password, please try \"Forgot Password?\" link to recover your password.",
    //       "3": "Oops! Something went wrong. Please try again later. You can report this issue to",
    //       "3.1": "L Squared Support by",
    //       "4": "This user does not have access to any server. Please contact your server's administrator or Support@LSquared.com.",
    //       "5": "Your account has been locked because of multiple failed login attempts. Please click on \"Reset Password\" link in the mail we sent you.",
    //       "6": "Email or Password were not recognized. Please check and try again.",
    //       "7": "This item is not accessible with your user.",
    //       "8": "Please provide both Email and Password.",
    //       "9": "There is not any account created on L Squared Hub with this id.",
    //       "10": "User not available on the current sso server.",
    //       "11": "Please wait",
    //       "12": "Please contact dev team for support password.",
    //       "13": "Sign in to L Squared Hub",
    //       "14": "Didn't receive the email?",
    //       "15": "Check your spam folder for a message from hub@lsquared.com",
    //       "16": "Please provide Email.",
    //       "17": "Please validate captcha.",
    //       "18": "If {{htmlTagO}}{{htmlTagC}} is associated with L Squared Hub account, you should receive an email with password reset link.",
    //       // "19": "Welcome to Lenovo Digital Signage Platform",
    //       "20": "The callback url saved in the SAML app was not matched.",
    //       "21": "Welcome to {{title}} Digital Signage Platform",
    //       // "21": "Welcome to Intel Digital Signage Platform",
    //       // "22": "Welcome to MDM Commercial Digital Signage Platform",
    //       // "23": "Welcome to Royal Caribbean Digital Signage Platform",
    //       // "24": "Welcome to Bluebell Digital Signage Platform",
    //       // "25": "Welcome to Skykit Digital Signage Platform",
    //       // "26": "Welcome to Cisco Digital Signage Platform"
    //     }
    //   },
    //   "ss": {
    //     "1": "Select Server",
    //     "2": "Server",
    //     "m1": "Oops! Something went wrong. Please try again later. You can report this issue to {{by}} ",
    //     "m1.1": "clicking here"
    //   },
    //   "sp": {
    //     "1": "Please wait",
    //     "2": "Sign in to L Squared Hub",
    //     "3": "Sorry! The link has expired now.",
    //     "4": "Invalid request URL.",
    //     "5": "Please contact your server's administrator.",
    //     "6": "Go to L Squared Hub"
    //   },
    //   "sm": {
    //     "m1": "Login successful. You can now close this window."
    //   }
    // });

    var en_us_lang = {
      "lang": "en_US",
      "cm": {
        "menu": {
          "0": "Dashboard",
          "1": "Content Library",
          "2": "Templates",
          "3": "Schedules",
          "4": "Frame Layouts",
          "5": "Devices",
          "6": "Users",
          "7": "Emergency Message",
          "8": "Reports",
          "9": "Creative Services",
          "10": "Billing and Payment",
          "11": "Inventory",
          "12": "CoM Events",
          "21": "Support",
          "22": "My Settings",
          "51": "Login",
          "52": "Forgot Password",
          "53": "Signup",
          "54": "Show Password",
          "55": "Approve Item",
          "56": "Select Server",
          "57": "Other",
          "58": "Queue Widget",
          "59": "Survey Login",
          "60": "Survey Participate",
          "61": "Survey Thanks",
          "62": "Survey Result",
          "63": "Reset Password",
          "64": "Authentication",
          "65": "Set Password",
          "66": "Inventory"
        },
        "head": {
          "menu": {
            "1": "Change Server",
            "2": "My Settings",
            "3": "Support Center",
              "3.1": "Technical Support",
              "3.2": "Request New Feature",
              "3.3": "Feedback",
              "3.4": "Report Bug",
              "3.5": "Video Tutorials",
            "4": "Go to Control Panel",
            "5": "Logout"
          },
          "notify": {
            "1": "No new notification.",
            "2": "Unapproved Content",
            "3": "Unapproved Template",
            "3s": "Unapproved Templates",
            "4": "Unapproved Schedule",
            "4s": "Unapproved Schedules",
            "5": "Unapproved Frame Layout",
            "5s": "Unapproved Frame Layouts",
            "6": "Unpaid Invoice",
            "6s": "Unpaid Invoices",
            "7": "Unapproved Creative Service",
            "7s": "Unapproved Creative Services",
            "8": "Expired Layout Assignment",
            "8s": "Expired Layout Assignments"
          }
        },
        "footer": {
          "1": "Terms & Conditions",
          "2": "Privacy Policy",
          "3": ""
        },
        "tool": {
          "1": "Sorting",
            "1.1": "Alphabetical",
            "1.2": "Approved On",
            "1.3": "Created On",
            "1.4": "Ascending",
            "1.5": "Descending",
            "1.6": "Updated On",
            "1.7": "Expire On",
          "2": "Filter",
            "2.1": "All",
          "3": "Info",
            "3.1": "Watch video tutorial.",
          "4": "Thumb Size",
          "5": "Thumb View",
          "6": "List View",
          "7": "Deselect All",
          "8": "Pin to bottom",
          "9": "Unpin from bottom",
          "10": "Reload",
          "11": "Grouping",
            "11.1": "Group by",
            "11.2": "Date modified"
        },
        "body": {
          "1": "Content List",
          "2": "Schedule List",
          "3": "Device List",
          "4": "Available Content",
          "5": "Selected Content",
          "6": "Available Device",
          "6s": "Available Devices",
          "7": "Selected Device",
          "7s": "Selected Devices",
          "8": "Selected Devices/Groups",
          "9": "Download User Activity Log",
          "10": "Advanced Search",
          "11": "Please right-click the download link below and choose {{htmlTagO}}Save Link As...{{htmlTagC}}",
          "12": "",
          "13": "Uploading {{count}} {{key}}",
          "14": "This item is public.",
          "14.1": "You can not change permission of a public item.",
          "15": "Add to Schedule",
          "16": "Are you ABSOLUTELY sure?",
          "17": "Button Info",
          "18": "Content Info"
        },
        "ph": {
          "1": "Type to search",
          "2": "Type to search",
          "3": "Example",
          "4": "Write your comment here..."
        },
        "brief": {
          "1": "Name",
          "2": "Created on",
          "3": "Created by",
          "4": "Approved on",
          "5": "Approved by",
          "6": "Added on",
          "7": "Added by",
          "8": "Dimension",
          "9": "Content",
          "10": "Schedules",
          "11": "Devices",
          "12": "File size",
          "13": "No action available",
          "14": "Edited on",
          "15": "Edited by",
          "16": "L Squared Publisher"
        },
        "label": {
          "1": "Content",
            "2s": "Templates",
          "2": "Template",
          "3": "Schedule",
            "3s": "Schedules",
          "4": "Device",
            "4s": "Devices",
          "5": "User",
            "5s": "Users",
          "6": "Home",
          "7": "Date",
          "8": "Time",
          "9": "Date range",
          "10": "Start date",
          "11": "End date",
          "12": "Start time",
          "13": "End time",
          "14": "Settings",
          "15": "Permission",
          "16": "Forever",
          "17": "Custom",
          "18": "Never",
          "19": "Public",
          "20": "All Groups I Belong",
          "21": "Available group",
            "21s": "Available groups",
          "22": "Assigned group",
            "22s": "Assigned groups",
          "23": "Title",
          "24": "Font",
            "24.1": "Alternate font",
          "25": "Action",
          "26": "Optional",
          "27": "Second",
            "27s": "Seconds",
          "28": "Minute",
            "28s": "Minutes",
          "29": "Hour",
            "29s": "Hours",
          "30": "Select image",
          "31": "Select device",
            "33.1": "Device's timezone",
            "31s": "Select devices",
          "32": "Select content",
          "33": "Select timezone",
          "34": "Select language",
          "35": "Select schedule",
          "36": "Select date range",
          "37": "Images",
          "38": "Video",
          "39": "Audio",
          "40": "Others",
          "41": "Sample",
          "42": "or",
          "43": "Max",
          "44": "Image",
          "45": "City",
          "46": "Status",
          "47": "Email",
          "48": "Contact number",
          "49": "Duration",
          "50": "Primary group",
          "51": "All groups",
          "52": "Custom group",
          "53": "Logs",
          "54": "Supported file formats",
          "55": "Assign name and permission",
          "56": "Feed URL",
          "57": "Zoom",
          "58": "Rotate",
          "59": "Width",
          "60": "Height",
          "61": "Background color",
          "62": "Default colors",
          "63": "Custom colors",
          "64": "Text",
          "65": "Step {{stepNo}}",
          "66": "Note",
          "67": "Mute",
          "68": "Fullscreen",
          "69": "Type",
          "70": "OS",
          "71": "Device name",
          "72": "Assignment name",
          "73": "Role",
          "74": "item",
            "74s": "items",
          "75": "Sec",
          "76": "Min",
            "76.t": "Min",
          "77": "Max",
          "78": "Group name",
          "79": "Group",
            "79s": "Groups",
          "80": "Id",
          "81": "Add to group(s)",
          "82": "Create a new group",
          "83": "Size",
            "83.1": "Select size",
          "84": "Feed refresh interval",
          "85": "Description",
          "86": "Vector",
          "87": "Background",
          "88": "Timezone",
          "89": "Content alignment",
            "89.1": "Top-Left",
            "89.2": "Middle-Left",
            "89.3": "Bottom-Left",
            "89.4": "Top-Center",
            "89.5": "Middle-Center",
            "89.6": "Bottom-Center",
            "89.7": "Top-Right",
            "89.8": "Middle-Right",
            "89.9": "Bottom-Right",
          "90": "Default",
          "91": "Add more",
          "92": "Scale",
          "93": "Opacity",
          "94": "Tag",
            "94s": "Tags",
          "95": "Multiple date range",
          "96": "Device Groups",
          "97": "User Group",
          "98": "Pin to Dashboard",
          "99": "Unpin from Dashboard",
          "100": "Don't show this again",
          "101": "Coordinator Access"
        },
        "btn": {
          "1": "Ok",
          "2": "Yes",
          "3": "No",
          "4": "on",
          "5": "off",
          "6": "",
          "7": "Save",
            "7i": "Saving",
          "8": "Save & Close",
          "9": "Cancel",
            "9i": "Canceling",
          "10": "Close",
          "11": "Back",
          "12": "Next",
          "13": "Delete",
            "13i": "Deleting",
          "14": "Create",
            "14i": "Creating",
          "15": "Update",
            "15i": "Updating",
          "16": "Upload",
            "16i": "Uploading",
          "17": "Download",
            "17i": "Downloading",
          "18": "Continue",
          "19": "Add",
            "19i": "Adding",
          "20": "Remove",
          "21": "View",
          "22": "Edit",
          "23": "More",
          "24": "Approve",
          "25": "Unapprove",
          "26": "Replace",
          "27": "Schedule",
          "28": "Add to Schedule",
          "29": "Add to Group",
          "30": "Duplicate",
          "31": "Details",
          "32": "Settings",
          "33": "Refresh",
          "34": "Reset",
          "35": "Send",
            "35i": "Sending",
          "36": "Browse...",
          "37": "Change Profile Image",
          "38": "Clear Filter",
          "39": "Select step to edit",
          "40": "Name & Permission",
          "41": "Up to parent",
          "42": "Submit",
          "43": "Force Logout",
          "44": "Select All",
          "45": "Remove All",
          "46": "Open Containing Folder",
          "47": "Print",
          "48": "Search Group",
          "49": "Download Sample Excel",
          "50": "Move / Copy",
          "51": "Force Update",
          "51i": "Force Updating"
        },
        "msg": {
          "1": "No recent activity log available.",
          "2": "There is not any log available for the selected date range.",
          "3": "Please save the Permission first.",
          "4": "Please select an item from the list.",
          "5": "All fields are mandatory.",
          "6": "Please select a {{str}} placeholder to see it's details.",
          "7": "You don't have any content yet.",
          "8": "Please provide Start time.",
          "9": "Please provide End time.",
          "10": "Generating Thumbnail...",
          "11": "Duration should not be less than 1.",
          "12": "Please select at least one Device/Group.",
          "13": "There are some file upload in process. Please wait while it gets completed.",
          "14": "Your search {{searchText}} did not match any item. Try different keyword.",
          "15": "Applied filter does not have any matching item.",
          "16": "Start time should not be equal to or greater than end time.",
          "17": "File size limit is {{size}}.",
          "18": "You don't have any schedule yet.",
          "19": "Already exists.",
          "20": "Invalid color code.",
          "21": "Please provide Date.",
          "22": "Please provide Time.",
          "23": "Unsupported file format.",
          "24": "File size limit is {{fileSize}}. Selected file is beyond this limit.",
          "25": "Are you sure to leave the page?",
          "26": "If you still want to logout, click on \"Force Logout\". In forced logout case, the upload process will be discarded.",
          "27": "No Internet found. Please check your connection.",
          "28": "{{htmlTagO}}Security Logout!{{htmlTagC}} Since there is no user activity for a long time, L Squared Hub will automatically logout in {{sessionTimer}} seconds.",
          "29": "Keep me logged in.",
          "30": "There are more action buttons for the selected item which are not available to you because either you don't have relevant user permissions or some other reason. Below is the list of buttons with the reason of unavailability.",
          "31": "No format allowed.",
          "32": "Width should not be empty or less than {{value}}.",
          "33": "Height should not be empty or less than {{value}}.",
          "34": "Are you sure you want to remove selected item?",
            "34s": "Are you sure you want to remove selected items?",
          "35": "Are you sure you want to delete selected item?",
            "35s": "Are you sure you want to delete selected items?",
          "36": "You don't have selected any item yet. When you select some, they'll appear here.",
          "37": "Please provide Name.",
          "38": "Please select at least one item.",
          "39": "Item is not accessible to you.",
          "40": "Please provide valid data.",
          "41": "The reports you are disabling may have subscriptions. Disabling a report will also remove the associated subscriptions. Are you sure you want to disable the report?",
            "41.1": "Disabling a subscription will remove the associated subscriptions. Are you sure you want to disable the subscriptions?",
          "42": "User name or Password were not recognized. Please check and try again.",
          "43": "Login expired, Please login again.",
          "44": "Tag is not available.",
          "45": "Invalid Credentials.",
          "46": "Are you sure you want to force update Circuit Bench feed?",
          "47": "Nothing pinned here.",
          "48": "You don't have any selected schedule yet. When you select some, they'll appear here.",
          "49": "You don't have any active schedule yet.",
          "52": "You don't have permission to access this widget.",
          "53": "Type {{count}} more characters",
          "54": "End of Records",
          "55": "Already selected",
          "56": "You don't have required permissions!",
          "57": "Sorry, you don't have permission to access this folder or its contents.",
          "58": "You don't have any item yet."
        },
        "p_h": {
          "1": "History",
          "2": "Item's Edit History",
          "m1": "No history available."
        },
        "editor": {
          "1": "Add Text",
          "2": "Add Rectangle",
          "3": "Add Circle",
          "4": "Add Triangle",
          "5": "Add Content",
          "6": "Send Backward",
          "7": "Bring Forward",
          "8": "Send to Back",
          "9": "Bring to Front",
          "10": "Text Properties",
            "10.1": "Bold",
            "10.2": "Italic",
            "10.3": "Underline",
            "10.4": "Left",
            "10.5": "Center",
            "10.6": "Right",
            "10.7": "Justify",        
            "10.8": "Redo",
            "10.9": "Undo",
            "10.10": "Numbering",
            "10.11": "Bullet",
            "10.12": "Clear Background Color",
            "10.13": "Strikethrough",
            "10.14": "Font Color",
            "10.15": "Background Color",
            "10.16": "Font Size",
            "10.17": "Font Family",
          "11": "Filters",
            "11.1": "Grayscale",
            "11.2": "Invert",
            "11.3": "Sepia {{no}}",
            "11.4": "Emboss",
            "11.5": "Blur",
            "11.6": "Sharpen",
            "11.7": "Brightness",
            "11.8": "Contrast",
            "11.9": "Saturation",
          "12": "Object Properties",
          "13": "Container Properties",
            "13.1": "Scale X",
            "13.2": "Scale Y",
            "13.3": "Rotate",
            "13.4": "Opacity",
          "14": "Add Dynamic Text",
          "15": "Add Dynamic Content",
            "15.1": "Associated Folder"
        },
        "dmb": {
          "1": "Menu Board",
            "1.1": "Menu Board user",
            "1.2": "Menu Board Users",
          "2": "Menu Board Settings",
          "3": "Brand/Franchise",
            "3.1": "Select Brand/Franchise",
            "3.2": "Brand/Franchise List",
          "4": "Portal URL",
          "5": "Add New User",
          "6": "User List",
          "7": "Edit Theme",
          "8": "Style Your Theme",
          "9": "Admin",
          "10": "Menu board admin",
          "11": "Other Settings",
          "12": "Tab 1",
          "13": "Tab 2",
          "14": "Tab 3",
          "15": "Channel Selector",
          "m1": "Please provide brand/franchise.",
          "m2": "Brand/Franchise already exists.",
          "m3": "URL already exists.",
          "m4": "There is not any brand/franchise on this portal.",
          "m5": "Brand/Franchise assigned with user.",
          "m6": "There is not any user on this portal.",
          "m7": "If you want a custom theme for the menu-board portal of this store/franchise, then you need to provide a portal URL. The theme will be applied to the URL only.",
          "m8": "Are you sure you want to reset the theme?",
          "m9": "Invalid data supplied.",
          "m10": "Are you sure you want to delete selected brand/franchise?",
          "m11": "Are you sure you want to delete selected user?",
          "m12": "Please provide Tab 1.",
          "m13": "Please provide Tab 2.",
          "m14": "Please provide Tab 3."
        },
        "acs": {
          "1": "Content Sensitivity",
          "2": "Content Sensitivity Settings",
          "3": "Violence",
            "3.1": "Violence sensitivity levels",
            "3.2": "Violence allowed levels",
          "4": "Self-harm",
            "4.1": "Self-harm sensitivity levels",
            "4.2": "Self-harm allowed levels",
          "5": "Sexual",
            "5.1": "Sexual sensitivity levels",
            "5.2": "Sexual allowed levels",
          "6": "Hate",
            "6.1": "Hate sensitivity levels",
            "6.2": "Hate allowed levels",
          "7": "Strongly Restrict",
          "8": "No admin approval",
          "9": "Allowed Level",
          "10": "Level 0 - Safe",
          "11": "Level 2 - Low",
          "12": "Level 4 - Medium",
          "13": "Level 6 - High",
          "14": "Sensitivity Level",
          "15": "Image Example",
          "16": "Sensitivity Info",
          "17": "No Restriction",
          "18": "Sensitive Content Approver",
          "ht": {
            "d1": "Content is safe but may contain hate and fairness related imagery with no sentiment or neutral sentiments in non-discriminatory non-offensive ways in the following contexts or those similar to:",
              "d1.1":"Journalistic",
              "d1.2":"Historical",
              "d1.3":"Medical",
              "d1.4":"Legal",
              "d1.5":"Educational",
              "d1.6":"Geographical",
            "e1.1": "Non confederate flags, e.g. Flags of countries or states that feature crosses",
              "e1.1.1": "An image of the Union Jack flag of Great Britain",
            "e1.2": "Depiction of emancipation of enslaved people in the US in historical photos",
            "d2": "Content that contains either positive sentiments, false positive sentiments, or negative, biased sentiments differentiating identity groups from others. This content is intended to trigger an emotional response. This includes:",
              "d2.1":"Protection",
              "d2.2":"Nazi symbolism, the confederate flag, Ku Klux Klan symbolism",
              "d2.3":"Stereotyping",
              "d2.4":"Employment discrimination",
            "e2.1": "Representations of 'No Hate Speech' movement",
            "e2.2": "Representations of deprioritized job candidates such as candidates with disabilities in interview settings",
            "d3": "Content that contains negative sentiment action towards identity groups and others that leads to the promotion of action against an identity groups and sentiments of superiority. This includes:",
              "d3.1":"Insult, isolation, mocking",
              "d3.2":"Nazi flag, confederate flag, and LGBTQIA+ variations and merchandise",
            "e3.1": "Imagery that promotes social avoidance of [identity groups]",
            "e3.2": "Imagery that depicts the racial improvement theory and eugenics",
            "d4": "Content that contains negative sentiment and hate speech towards identity groups leading to hate speech generation or hate crimes. This includes:",
              "d4.1":"Racism",
              "d4.2":"Attacks on LGBTQIA+",
              "d4.3":"Disablism",
              "d4.4":"Sex-based discrimination",
              "d4.5":"Glorified Nazi symbolism, Confederate flag, Ku Klux Klan symbolism",
              "d4.6":"Violent confederate flag",
            "e4.1": "Antisemitic imagery",
            "e4.2": "Imagery depicting the \"Southern Cross\" that features a blue saltire (diagonal cross) with affiliation of obvious violence (e.g. guns in display/use)"
          },
          "sx": {
            "d1": "Content is safe but contains sexually related imagery used in a general sense. This includes:",
              "d1.1":"Family and romantic relationships",
              "d1.2":"Non-sexual nudity",
              "d1.3":"Clothing",
              "d1.4":"Common objects",
              "d1.5":"Non-sexual pose or activity",
              "d1.6":"Animal mating",
              "d1.7":"Sexual wellness",
            "e1.1": "Representations of hugging or making non-sexual physical contact",
            "e1.2": "Representations depicting physical display of affection such as kissing without tongue and without nudity",
            "d2": "Content that contains sexually suggestive behaviors or acts. This includes:",
              "d2.1":"Personal experiences",
              "d2.2":"Fashion modeling",
              "d2.3":"Nudity in artwork",
              "d2.4":"Body art",
              "d2.5":"Racy display",
            "e2.1": "Depictions of people",
            "d3": "Content that contains commercial and amateur erotic and/or pornographic content without visual photographic penetration and nude or semi-nude participants involved in sexual scenes meant to be sexually arousing. This includes:",
              "d3.1":"Sexual modeling",
              "d3.2":"Soft nudity in artwork",
              "d3.3":"Sex jobs or shops",
              "d3.4":"Obscured sexual activity",
              "d3.5":"Porn production backstage",
              "d3.6":"Pole dancing",
            "e3.1": "Depictions of intercourse that may be partially occluded but still clearly present in the image",
            "d4": "Content that contains explicit detailed depictions of sexual organs and sexual acts, including illegal acts. This includes:",
              "d4.1":"Amateur soft-core and hard-core pornography",
              "d4.2":"Sexual solicitation",
              "d4.3":"Voyeurism",
              "d4.4":"Sex in artwork",
              "d4.5":"BDSM with no consent or Rape",
              "d4.6":"Child Sexual Exploitation and Abuse",
              "d4.7":"Child grooming",
              "d4.8":"Incest",
            "e4.1": "Depictions of engagements in sexual activities with animals or corpses"
          },
          "vl": {
            "d1": "Content is safe but contains violence related imagery used in a general sense. This includes:",
              "d1.1":"Sleeping or laying pose",
              "d1.2":"Common objects",
              "d1.3":"Non-violent activity",
              "d1.4":"Ropes not as a noose",
              "d1.5":"Bladed tools in use in kitchen/sewing",
              "d1.6":"Wounds, scars and surgical treatment",
              "d1.7":"Hunting and shooting sport",
              "d1.8":"Toy and pretend guns",
              "d1.9":"Combat practice",
              "d1.10":"Object damage and vandalism",
              "d1.11":"Non-branded terrorist symbolism",
            "e1.1": "Depictions of non-realistic weapons and bladed tools",
            "d2": "Content that contains violence related imagery and acts in real world or fictional contexts with low gore. This includes:",
              "d2.1":"Guns, weapons, and bladed tools in display and in use",
              "d2.2":"Non-realistic corpse",
              "d2.3":"Non-realistic violence",
              "d2.4":"Animated weapons",
              "d2.5":"Light injury and personal experience",
              "d2.6":"Ropes as a noose",
              "d2.7":"Death in historical, educational, or funerary settings",
              "d2.8":"Non-realistic terrorist symbolism",
              "d2.9":"Bullfighting",
            "e2.1": "Depictions of ISIS/al-Qaeda flags",
            "d3": "Content that contains moderate graphic violence and violent acts aimed at an identified target. This includes:",
              "d3.1":"Autopsy",
              "d3.2":"Crime or death scene",
              "d3.3":"Animal death (natural or hunted), animal sacrifice, animal abuse",
              "d3.4":"Enslavement",
              "d3.5":"Genocide and mass killings in historical, educational settings",
              "d3.6":"Slaughterhouse",
              "d3.7":"Domestic violence and physical abuse",
              "d3.8":"Bullying",
              "d3.9":"Guns and weapons in use against a target",
            "e3.1": "Depictions of the use of force and coercion to aggressively dominate or intimidate an individual",
            "d4": "Content that contains explicit detailed depictions of violence and violent acts in high gore. This includes:",
              "d4.1":"Graphic injuries and death",
              "d4.2":"Dismemberment, decapitation, burning alive",
              "d4.3":"Corpse decomposition",
              "d4.4":"Terrorism, Terrorist groups, and flags",
              "d4.5":"Forced labor and servitude, forced medical procedure",
              "d4.6":"Stalking",
              "d4.7":"Corpse in terrorism and war crime",
              "d4.8":"Shooting event",
              "d4.9":"Other extremism",
            "e4.1": "Depictions of death when performed by terrorist groups identifiable by ISIS flags and symbols"
          },
          "sh": {
            "d1": "Content is safe but contains self-harm related imagery used in a general sense. This includes:",
              "d1.1":"Low body fat",
              "d1.2":"Non-self-harm act",
              "d1.3":"Accidental body injury",
            "e1.1": "Depictions of jumping with a parachute out of a plane",
            "d2": "Content that contains self-harm related imagery and acts in real world or fictional contexts with low gore. This includes:",
              "d2.1":"Scars",
              "d2.2":"Self-harm injury in recovery",
              "d2.3":"Non-realistic self-harm",
              "d2.4":"Emaciated individuals or animals",
            "e2.1": "Representations of self-harm related acts, tools, injury and emotional state",
            "d3": "Content that contains moderate graphic imagery related to self-harm and suicide. This includes:",
              "d3.1":"Autopsy",
              "d3.2":"Crime or death scene",
              "d3.3":"Bullying",
            "e3.1": "Representations of the use of force and coercion to aggressively dominate or intimidate an individual into self-harm",
            "d4": "Content that contains explicit detailed depictions of self-harm and suicide in high gore. This includes:",
              "d4.1":"Imminent self-harm act",
              "d4.2":"Self-harm acts",
              "d4.3":"Suicide",
            "e4.1": "Depictions of intentional suicide, where a person has committed suicide by jumping off a tall building"
          }
        },
        "asn":{
          "1": "Asana Publisher",
          "2": "Authenticate with Asana",
          "3": "Connected to Asana",
          "4": "Authenticated with Asana user {{htmlTagO}}{{user}}{{htmlTagC}}",
          "5": "Asana Workspace",
            "5.1": "Select Workspace",
          "6": "Content Library Folder",
          "7": "Folder Details",
          "8": "Asana Publisher Settings",
          "9": "Publisher app client id",
          "10": "Publisher app client secret",
          "11": "Updater app client id",
          "12": "Updater app client secret",
          "m1": "Please select workspace.",
          "m2": "Please select destination folder.",
          "m3": "The workspace is already selected on some other server.",
          "m4": "Select the destination Content Library folder for saving Asana attachments:",
          "m5": "There is no folder in the Content Library.",
          "m6": "The selected folder(s) or their child folders are linked to Asana and cannot be archived.",
          "m7": "The selected folder(s) or their child folders are linked to Asana and cannot be unapproved.",
          "m8": "The selected folder(s) or their child folders are linked to Asana and cannot be deleted.",
          "m9": "The selected folder(s) or their child folders are linked to Asana and cannot be moved to another server.",
          "m10": "You do not have access to the folder(s) linked with Asana.",
          "m11": "Please provide publisher app client id.",
          "m12": "Please provide publisher app client secret.",
          "m13": "Please provide updater app client id.",
          "m14": "Please provide updater app client secret."
        }
      },
      "lock": {
        "1": "Password",
        "b1": "Unlock",
        "m1": "Please provide Password.",
        "m2": "Please provide User name.",
        "m3": "Please select Zkong stores."
      },
      "ss": {
        "1": "Select Server",
        "2": "Server",
        "m1": "Oops! Something went wrong. Please try again later. You can report this issue to {{by}} ",
          "m1.1": "clicking here"
      },
      "db": {
        "body": {
          "1": "Device Online",
            "1s": "Devices Online",
          "2": "Space Available",
          "3": "Recent Activity Log",
            "3.1": "Download Recent Activity Log",
          "4": "Devices on Map",
          "5": "Showing {{show}} of {{total}} devices",
          "6": "Archived",
          "7": "Deleted",
          "8": "Expired",
          "9": "Active",
          "10": "Incomplete",
          "11": "Blocked",
          "12": "Priority",
          "13": "Devices downloaded all content",
            "13.1": "Confirmed",
            "13.2": "Unconfirmed",
            "13.3": "No schedule",
          "14": "Temperature",
            "14.1": "No issues",
            "14.2": "Caution",
            "14.3": "Danger",
          "15": "Device offline of priority",
          "16d": "Device added since last day",
          "16w": "Device added since last week",
          "16m": "Device added since last month",
          "16y": "Device added since last year",
          "17": "Content Confirmation",
            "17.1": "Content Confirmation Devices",
          "18": "Device Online from",
            "18s": "Devices Online from",
          "19": "Devices Temperature",
          "20": "You can add/remove dashboard items from My Settings > Preferences.",
          "21.1": "Online & confirmed content",
          "21.2": "Online & not confirmed content",
          "21.3": "Offline & confirmed content",
          "21.4": "Offline & not confirmed content",
          "21.5": "Offline devices",
          "21.6": "Devices without downloadable content",
            "21.6.1": "Online Device without schedule",
            "21.6.2": "Offline Device without schedule",
          "21.7": "Not Confirmed",
            "21.7.1": "Not confirmed content",
            "21.7.2": "Online not confirmed content",
            "21.7.3": "Offline not confirmed content",
          "21.8": "Confirmed content",
            "21.8.1": "Online confirmed content",
            "21.8.2": "Offline confirmed content",
          "22": "(Blanks)"
        },
        "p_map": {
          "1": "Coordinate",
          "2": "Address",
          "3": "Latitude",
          "4": "Longitude",
          "5": "Click on the map below to drop the location marker pin.",
          "6": "State / Province",
          "7": "Post / Zip code",
          "8": "Country",
            "8.1": "Select country",
          "9": "Registered Device",
            "9s": "Registered Devices",
          "10": "Unregistered Device",
            "10s": "Unregistered Devices"
        },
        "p_dl": {
          "1": "Log Details"
        },
        "ccl": {
          "1": "Confirmed Device",
            "1s": "Confirmed Devices",
          "2": "Unconfirmed Device",
            "2s": "Unconfirmed Devices",
          "3": "Confirmed",
          "4": "Unconfirmed"
        },
        "btn": {
          "1": "Register Device on Map",
          "2": "Register",
          "3": "Edit Dashboard",
          "4": "Disable Download Restriction",
          "5": "See devices on Map"
        },
        "msg": {
          "1": "No device available.",
          "2": "Please select device.",
          "3": "Please provide Address.",
          "4": "Please provide City.",
          "5": "Please provide State / Province.",
          "6": "Please provide Country.",
          "7": "Please provide Latitude & Longitude.",
          "8": "Please provide valid address.",
          "9": "You don't have any dashboard items yet. You can add them from \"My Settings > Preferences\"",
          "10": "No content available.",
          "11": "No tickets available.",
          "12": "You don't have any confirmed device yet.",
          "13": "You don't have any unconfirmed device yet.",
          "14": "Note: The exported report contains masked Personally Identifiable Information (PII) for privacy protection."
        },
        "pin": {
          "1": "Content Quad",
          "2": "Device Quad",
          "3": "Schedule Quad",
          "4": "Template Quad",
          "5": "Pinned Items"
        },
        "wgw": {
          "1": "White Glove Warranty",
          "2": "White Glove Warranty List",
          "3": "White Glove Warranty Summary",
          "4": "Expiry",
          "5": "Register",
          "6": "Active",
          "7": "Expired",
          "8": "No Warranty",
          "9": "Warranty Id",
          "10": "Expiring Soon"
        }
      },
      "cl": {
        "tab": {
          "1": "Content",
          "2": "Unapproved Content",
          "3": "Expired Content",
          "4": "Archived Content",
          "5": "Deleted Content"
        },
        "tool": {
          "1": "Small",
          "2": "Normal",
          "3": "Medium",
          "4": "Large",
          "5": "Extra Large",
          "6": "Image",
          "7": "Video",
          "8": "Widget",
          "9": "My Content",
          "10": "Approved",
          "11": "Unapproved",
          "12": "Tree View",
          "13": "What is {{htmlTagO}}Unapproved Content{{htmlTagC}}?",
          "14": "What is {{htmlTagO}}Expired Content{{htmlTagC}}?",
          "15": "What is {{htmlTagO}}Archived Content{{htmlTagC}}?",
          "16": "Unapproved",
          "17": "Unapproved and expiring soon",
          "18": "Expiring soon",
          "8s": "Widgets"
        },
        "brief": {
          "1": "Content size",
          "2": "Write protected",
          "3": "Uploaded on",
          "4": "Uploaded by",
          "5": "Active period",
          "6": "File type",
          "7": "Versions",
          "8": "Path",
          "9": "Pages",
          "10": "Downloadable size on device",
          "11": "Optimized",
          "12": "Acknowledgment",
          "13": "Download latest L Squared Publisher",
          "14": "Show to admin"
        },
        "label": {
          "1": "Widget name",
          "2": "Custom name",
          "3": "Crop and Resize Video",
          "4": "Video label",
          "5": "Active schedule",
            "5s": "Active schedules",
          "6": "Inactive schedule",
            "6s": "Inactive schedules",
          "7": "Video Caption",
          "8": "Import SRT",
          "9": "Add new caption",
          "10": "Caption",
          "11": "Transcript within server",
          "12": "Use third party",
          "13": "Optimization",
          "14": "Select caption language",
          "15": "Add new language",
          "16": "Select language for their caption",
          "17": "Video Captions",
          "18": "Edit Video",
          "19": "Generate SRT",
          "20": "Type it manually",
          "21": "Add Caption Language",
          "22": "Edit Caption",
          "23": "CC",
          "24": "Cue Point",
          "25": "Cue time",
          "26": "Edit Cue Point",
          "27": "Favorites",
          "28": "Selected schedule",
            "28s": "Selected schedules"
        },
        "btn": {
          "1": "Add New Content",
          "2": "Create New Widget",
          "3": "Create Folder",
          "4": "Add Content",
          "5": "Select File",
            "5s": "Select Files",
          "6": "Move",
          "7": "Archive",
          "8": "Open",
          "9": "Open in Image Editor",
          "10": "Edit Caption/Video",
          "11": "Remove Expiry",
          "12": "Restore",
          "13": "Delete Forever",
          "14": "Save as New Content",
          "15": "Replace Existing",
          "16": "Download as Image",
          "17": "Create Shortcut",
          "18": "Restart Process",
          "19": "Source File",
          "20": "Processed File",
          "21": "Sample file",
          "22": "Reprocess",
          "23": "Add Language",
          "24": "Generate Image",
          "25": "Re-generate",
            "25-i": "Re-generating",
          "26": "Yes, Generate Please"
        },
        "msg": {
          "1": "You don't have any content yet. When you add some, they'll appear here.",
          "2": "Watch {{htmlTagO}}Content Library{{htmlTagC}} video tutorial.",
          "3": "You don't have any unapproved content.",
          "4": "You don't have any expired content.",
          "5": "You don't have any archived content.",
          "6": "You don't have any deleted content yet. When you delete some, before deleting it forever, they'll appear here.",
          "7": "Are you sure you want to archive selected content?",
          "8": "Are you sure you want to unapprove selected content?",
          "9": "Are you sure you want to delete selected content?",
          "10": "Are you sure you want to delete selected content forever? {{htmlTag}} {{htmlTagO}}This process can not be undone.{{htmlTagC}}",
          "11": "This folder is write protected.",
          "12": "This folder is write protected. You can only view and schedule the files/folder within this folder(if you have \"Schedule Add\" permission).",
          "13": "This content is write protected.",
          "14": "This content is write protected. You can only view and schedule (if you have \"Schedule Add\" permission).",
          "15": "If the process is taking more than usual time, press following button to re-process.",
          "16": "Please provide Content name.",
          "17": "Please select content.",
          "18": "Are you sure you want to cancel uploading content.",
          "19": "Please select at least one schedule.",
          "20": "No caption available for this video.",
          "21": "Please provide a caption.",
          "22": "Please provide caption start and end time.",
          "23": "Selected content can not be assigned to selected schedule because Music Choice widget can not be mixed with other type of content and device.",
          "24": "Selected folder does not contain any approved content to schedule.",
          "25": "Video caption is being generated. It may take some time, depending on the duration of the video.",
          "26": "Note: Reprocessing the video with new optimization will make a new version of video and it will get updated on devices if it's already scheduled.",
          "27": "This folder is mapped with SharePoint and is write protected.",
          "28": "This content is mapped with SharePoint and is write protected.",
          "29": "This folder is mapped with OneDrive and is write protected.",
          "30": "This content is mapped with OneDrive and is write protected.",
          "31": "You don't have permission to assess third party upload.",
          "32": "As per the selected plan, there is not any widget enabled on your server. You can contact",
            "32.1": "to get them enabled.",
          "33": "Only images are allowed to a lock screen type schedule.",
          "34": "Only CorpComm: Alert Message & survey widget are allowed to a corporate communication type schedule.",
          "35": "What is active period?",
            "35.1": "Setting expiry date on content will result in the content being removed from the content library at midnight of the last time zone in the world (UTC +14). This means, if you are not in UTC +14 time zone, then the content will be removed from the content library at some time on the next day depending on your time zone. When the content has expired, it will be indicated by a small clock icon on the content. If the content is scheduled, then it will be removed from display at midnight of the local time zone.",
          "36": "You don't have any excel content yet. When you add some, they'll appear here.",
          "37": "The auth-token of this {{folderType}} folder has expired. It requires your immediate attention as we will not be able to sync the content of this folder. Please reauthorize this {{folderType}} folder to fix the issue by click on the following button.",
          "38": "All caption languages are selected.",
          "39": "Please select caption language.",
          "40": "Please import SRT file.",
          "41": "Please provide language.",
          "42": "Language with same name already exists on current server.",
          "43": "You don't have any caption languages.",
          "44": "Are you sure you want to delete this caption language.",
          "45": "This caption language selected in some of videos.",
          "46": "Please provide Cue time.",
          "47": "Invalid Cue time.",
          "48": "No cue time available for this video.",
          "49": "Cue time already exists.",
          "50": "This is a shared folder, mapped with {{sName}} server's {{fName}} folder.",
          "51": "You don't have any folder on this server. When you add some, they'll appear here.",
          "52": "You don't have access to other servers.",
          "53": "This folder is shared as {{sName}} in {{shName}} server's {{fName}} folder.",
          "54": "You are trying to delete a Calendar of Events repository. Following views created with this repository will also get deleted with this:",
          "55": "The selected items are shared and scheduled on other server. Deleting them may cause the scheduled to go to the Incomplete mode. Are you sure you want to delete?",
          "56": "Shared with: Server {{sName}}.",
          "57": "Shortcut is visible to admin",
          "58": "Are you sure you want to remove the content from the schedule?",
          "59": "Are you sure you want to remove the template from the schedule?",
          "60": "This folder is mapped with Excel and is write protected.",
          "61": "This folder is mapped with Google Drive and is write protected.",
          "62": "This content is mapped with Google Drive and is write protected."
        },
        "e_vid": {
          "1": "Aspect Ratio",
          "2": "Constant",
            "2.1": "lossless compression",
            "2.2": "high quality",
            "2.3": "normal quality",
            "2.4": "low quality",
            "2.5": "worst quality",
          "3": "Quality (CRF)",
          "4": "Video Codec",
          "5": "Preset",
            "5.1": "ultrafast",
            "5.2": "superfast",
            "5.3": "veryfast",
            "5.4": "faster",
            "5.5": "fast",
            "5.6": "medium",
            "5.7": "slow",
            "5.8": "slower",
            "5.9": "veryslow",
          "6": "Tune",
            "6.1": "film",
            "6.2": "animation",
            "6.3": "grain",
            "6.4": "stillimage",
            "6.5": "fastdecode",
            "6.6": "zerolatency",
            "6.7": "psnr",
            "6.8": "ssim",
          "7": "Profile",
            "7.1": "baseline",
            "7.2": "main",
            "7.3": "high",
            "7.4": "high10",
            "7.5": "high422",
            "7.6": "high444",
            "7.7": "main10",
            "7.8": "main12",
            "7.9": "main422-10",
            "7.10": "main422-12",
            "7.11": "main444-8",
            "7.12": "main444-10",
            "7.13": "main444-12",
            "7.14": "professional",
          "8": "Level",
          "9": "Fps",
          "10": "Audio Codec",
          "11": "Audio Bitrate",
          "12": "Trim Start",
          "13": "Trim End",
          "14": "no change",
          "15": "none",
          "16": "Trim",
          "17": "Volume (dB)",
          "m1": "By default we keep the current resolution.",
          "m2": "Change the video aspect ratio, for example to 16:9 or 4:3.",
          "m3": "The CRF value sets the video quality and can be from 0-63. Lower values mean better quality but longer conversion times. Recommended values range from 15-35.",
          "m4": "Codec to encode the video. Use \"copy\" to copy the stream without re-encoding.",
          "m5": "The preset is a collection of options that will provide a certain encoding speed to compression ratio.",
          "m6": "Settings based upon the specifics of your input.",
          "m7": "Set output to a specific H264 compatibility profile.",
          "m8": "Set output to a specific H264 compatibility profile level.",
          "m9": "Change the video frame rate.",
          "m10": "Codec to encode the audio. Use \"copy\" to copy the stream without re-encoding.",
          "m11": "Audio Bitrate.",
          "m13": "Make audio louder or quiter.",
          "m14": "Trim start timestamp (HH:MM:SS)",
          "m15": "Trim end timestamp (HH:MM:SS)",
          "m16": "Change video width (The video will be resized proportionately)",
          "m17": "Change video height (The video will be resized proportionately)",
          "m18": "Change the video label.",
          "m19": "Audio Bitrate should be greater than 0."
        },
        "p_f": {
          "1": "Create New Folder",
            "1.1": "Create New SharePoint Folder",
            "1.2": "Create New OneDrive Folder",
            "1.4": "Create New Shared Folder",
            "1.5": "Create New Google Drive Folder",
            "1.6": "New Folder",
          "2": "Update Folder",
            "2.1": "Update SharePoint Folder",
            "2.2": "Update OneDrive Folder",
            "2.4": "Update Shared Folder",
            "2.5": "Update Google Drive Folder",
          "3": "Folder name",
          "4": "",
          "5": "SharePoint URL",
          "6": "User name",
          "7": "Password",
          "8": "Select library",
          "9": "Select Folder",
            "9.1": "Change Folder",
          "10": "Root",
          "11": "Application (client) Id",
          "12": "Secret Key",
          "13": "Normal Folder",
          "14": "SharePoint Folder",
            "14.1": "SharePoint Folder Settings",
          "15": "OneDrive Folder",
          "16": "Select sites",
          "17": "Shared Folder",
          "18": "This folder is already shared",
            "18-1": "This third-party folder is not allowed to be shared.",
          "19": "Google Drive Folder",
          "20": "Oauth",
          "21": "Service Principle",
          "m1": "Please provide folder name.",
          "m2": "Please select a SharePoint folder.",
          "m3": "Please select library.",
          "m4": "Please select folder.",
          "m5": "You don't have OneDrive activated on your account.",
          "m6": "Please select sites.",
          "m7": "Please select server.",
          "m8": "Please select folder.",
          "m9": "The tenant or client ID provided is invalid. Please check your credentials and try again.",
          "m10": "The client secret provided is invalid. Please verify your client credentials and try again.",
          "m11": "Authentication was successful {{userInfo}}"
        },
        "p_c": {
          "1": "Upload Content",
          "2": "Create Widget",
          "3": "Use Publisher for Word and PowerPoint",
          "4": "Minimize",
          "5": "Pause",
          "6": "Resume",
          "7": "Retry",
          "8": "Please save the permission or active period first.",
          "9": "Third Party",
          "10": "Dropbox",
          "11": "Google Drive",
            "11.1": "Google Drive Settings",
          "12": "FTP",
          "m1": "Drop your files here / Select files to upload",
          "m2": "This file format is not supported. This will not get uploaded.",
          "m3": "Video will be optimized for best performance. Quality may vary.",
          "m4": "This file can not be uploaded because of 0kb file size.",
          "m5": "Format or Size is not supported.",
          "m6": "The file exceeds the maximum allowed size ({{spSize}}) for your current storage plan.",
            "m6.1": "Current plan: Storage P1",
            "m6.2": "Max file size: {{spSize}}",
            "m6.3": "To upload larger files, please contact your L\u00A0Squared representative to upgrade your plan."
        },
        "p_cEdit": {
          "1": "Content Edit",
          "2": "Content name",
          "m1": "The video will be resized proportionately.",
          "m2": "Please provide Video label.",
          "m3": "Start time is not valid.",
          "m4": "End time is not valid.",
          "m5": "End time should not be equal to or less than start time.",
          "m6": "End time should not be greater than video's end time.",
          "m7": "Please provide Width.",
          "m8": "Please provide Height.",
          "m9": "Please select a placeholder to see it's details.",
          "m10": "You don't have permission to add content in home directory.",
          "m11": "You don't have permission to add content.",
          "m12": "Since the new video has a different length, replacing it in an existing schedule will change the loop length of your content.  Are you sure you want to do this?",
          "m13": "Height and Width should be even number.",
          "m14": "Importing file again will wipeout all current data from list. Are you sure to import new file?",
          "m15": "Invalid file format.",
          "m16": "Importing file will wipeout all current data for this language. Are you sure to import new file?",
          "m17": "Add caption manually will wipeout all current data for this language. Are you sure to add caption manually?",
          "m18": "Generate caption will wipeout all current data for this language. Are you sure to generate caption?",
          "m19": "Generate caption is on processing, after completion it will wipeout all current data for this language. Are you sure to proceed?"
        },
        "p_r": {
          "1": "Replace",
          "2": "Replace with",
          "3": "Optimize",
          "m1": "Please provide new file.",
          "m2": "Please provide similar file type.",
          "m3": "The file is being uploaded. Please do not refresh the browser.",
          "m4": "Are you sure you want to replace the file?"
        },
        "p_m": {
          "1": "Move Content",
          "2": "Within Server",
          "3": "Other Server",
          "4": "Move",
          "5": "Copy",
          "6": "Home",
          "7": "Select server",
          "8": "Yes, move this content",
          "m1": "Please select a folder.",
          "m2": "Please select a server.",
          "m3": "Selected items can not be moved to this server because",
          "m4": "Selected items can not be copied to this server because",
          "m5": "You don't have permission to add content in home directory on selected server.",
          "m6": "You don't have permission to create folder on selected server.",
          "m7": "You don't have permission to upload content on selected server.",
          "m8": "You don't have permission to create widget on selected server.",
          "m9": "Folder can not be moved/copied inside itself.",
          "m10": "If you move the selected content to another server, this will get deleted from the current server. The content will automatically unassigned from the schedules and media players. Please confirm if you understand the consequences.",
          "m11": "You don't have permission to add template on selected server.",
          "m12": "You don't have permission to add frame layout on selected server."
        },
        "p_v": {
          "1": "Content Versions",
          "2": "Current version",
          "3": "Use",
          "m1": "Content processing. Please try again later.",
          "m2": "Write protected content can not be updated.",
          "m3": "This action will automatically replace the existing content with selected one on all scheduled devices. Are you sure you want to change the selected version?"
        },
        "p_mt":{
          "1": "Meta tag",
            "1.1": "Meta tags",
          "2": "Assign meta tag",
          "3": "Separate multiple tags with commas",
          "m1": "You don't have any meta tag for this content yet. When you add some, they'll appear here.",
          "m2": "Are you sure you want to delete selected meta tag?"
        },
        "info": {
          "uc1": "Content uploaded by a user, which is not having \"approval\" permission, are categorized as \"Unapproved Content\". These content can not be scheduled until it's approved by admin or a user with approval rights.",
          "ec1": "While uploading content or creating widgets, user can set an active period of the content/widget. The content expires after that period and removed from Device (if scheduled) and moved to \"Expired Content\" tab.",
          "ac1": "Archived content are the content which are not being used since a long time and there are less probability to be used in future. User can mark such content as \"Archived\". The archived content will be moved to deleted content automatically after one month.",
          "v1": "Uploading Content"
        },
        "t_p": {
          "ftp": {
            "1": "Host name",
            "2": "FTP user name",
            "3": "FTP password"
          },
          "tw": {
            "m1": "X handle not found.",
            "m2": "Content not found for this handler.",
            "m3": "Content not found for this hash tag."
          }
        },
        "widget": {
          "cm": {
            "1": "Edit Widget",
            "2": "Name and Permission",
            "3": "Color",
              "3.1": "Alternate color",
            "4": "Text color",
            "5": "Speed",
            "6": "Custom name",
            "7": "Choose template",
            "8": "Template {{count}}",
            "9": "Display type",
              "9.1": "List",
            "10": "URL",
            "11": "Header background",
            "12": "Header text",
              "12.1": "Auto",
              "12.2": "Custom",
              "12.3": "None",
            "13": "Header font",
            "14": "Row background",
            "15": "Alternate row background",
            "16": "Title text",
              "16.1": "Alternate title text",
              "16.2": "Title font",
              "16.3": "Title size",
            "17": "Subtitle text",
              "17.1": "Alternate subtitle text",
            "18": "Crawling speed",
              "18.1": "Greater value = Slower speed",
              "18.2": "Pixels/Second",
            "19": "Background image",
            "20": "Select type",
            "21": "Hash tag",
            "22": "Manipulate Data",
            "23": "Crawling text",
            "24": "Import",
              "24i": "Importing",
            "25": "Authorize",
              "25.1": "Re-Authorize",
              "25.2": "Re-Authorize with Other User",
            "26": "Font size",
            "27": "Authentication",
            "28": "User name",
            "29": "Column {{no}}",
            "30": "Time text",
              "30.1": "Alternate time text",
            "31": "Header size",
            "32": "Row size",
            "33": "Alternate row size",
            "34": "Bullet color",
            "35": "Footer background",
            "36": "Footer text",
            "37": "Footer font",
              "37.1": "Footer size",
            "38": "Row text",
            "39": "Row font",
            "40": "Alternate row text",
            "41": "Alternate row font",
            "42": "Description size",
            "43": "Show",
            "44": "Hide",
            "45": "Call",
            "46": "SMS",
            "47": "WiFi",
            "48": "Participant text",
            "49": "Participant font",
            "50": "Participant size",
            "51": "Creator text",
            "52": "Creator font",
            "53": "Creator size",
            "54": "Created on text",
            "55": "Created on font",
            "56": "Created on size",
            "57": "Select Template",
            "73": "Profile background",
            "74": "Profile text",
            "75": "Profile font",
            "76": "Profile size",
            "77": "Header title text",
            "78": "Header title font",
            "79": "Header title size",
            "80": "Header subtitle text",
            "81": "Header subtitle font",
            "82": "Header subtitle size",
            "83": "Verified by",
            "86": "Get Camera List"
          },
          "msg": {
            "1": "Please provide Widget name.",
            "2": "Please save the Active period first.",
            "3": "Please provide URL.",
              "3.1": "Please provide valid URL.",
            "4": "Please provide Title.",
            "5": "Please provide Crawling speed.",
            "6": "This widget will always appear as the top most frame. If you have overlapping frames, please ensure that the frame you will schedule this widget in is the top most frame.",
            "7": "Please provide Feed URL.",
            "8": "Please provide Latitude and Longitude both.",
            "9": "Please provide Header text.",
            "10": "Authorization successful.",
              "10.1": "You are already authorized for this account on this widget. If you want to change account, please re-authorize.",
              "10.2": "This action will log you out from your logged-in Microsoft sessions on this browser. Are you sure you want to re-authorize with other user?",
              "10.3": "This action will log you out from your logged-in Google sessions on this browser. Are you sure you want to re-authorize with other user?",
            "11": "Authorization failed.",
              "11.1": "Please authorization first.",
            "12": "There are duplicate entries of email id in list.",
            "13": "Please provide Title size.",
            "14": "Please provide Subtitle size.",
            "15": "Please provide Time size.",
            "16": "Please provide Header size.",
            "17": "Please provide Row size.",
            "18": "Please provide Alternate row size.",
            "19": "Please provide Rotation.",
            "20": "Menu structure is not correct.",
            "21": "Please provide Reload interval",
            "22": "Please provide Rotate interval.",
            "23": "Please provide Description size.",
            "24": "Please provide Room size.",
            "25": "Please provide maximum occupance.",
            "26": "Please provide warning title text.",
            "27": "Please provide Title/Description/Image.",
            "28": "Video is not accessible to you.",
            "29": "Please provide Image.",
            "30": "Please provide Date size.",
            "31": "Please provide Participant size.",
            "32": "Please provide Creator size.",
            "33": "Please provide Created on size.",
            "34": "Please select template.",
            "35": "Please provide Profile size.",
            "36": "Please provide Header title size.",
            "37": "Please provide Header subtitle size."
          },
          "achievers": {
            "1": "Achievers",
            "2": "Edit Achievers Widget",
            "3": "Achievers Settings",
            "4": "Achievement",
            "5": "Recognization",
            "6": "Event type",
            "7": "Activation",
            "8": "Award",
            "9": "Campaign",
            "10": "Claim",
            "11": "Event",
            "12": "Redemption"
          },
          "aNet":{
            "1": "CoM Events",
            "2": "Edit CoM Events",
            "3": "Rink Schedule",
            "4": "Day Schedule",
            "5": "Civic Committee",
            "6": "Header column 1",
            "7": "Header column 2",
            "8": "Header column 3",
            "9": "Header column 4",
            "10": "Header column 5",
            "11": "Header column 6",
            "12": "Header",
            "13": "Complex name",
              "13.1": "Select complex name",
            "14": "Facility name",
              "14.1": "Select facility name",
            "15": "Select complex and facility",
            "16": "Activity name / Home team",
            "17": "Home room",
            "18": "Visitor team",
            "19": "Visitor room",
            "20": "Activity name",
            "21": "CoM Events Settings",
              "21.1": "API Key",
            "22": "Sync Complex",
            "23": "Sync Facility",
            "24": "Rink / Floor",
            "m1": "Please provide all Header column.",
            "m2": "Please provide day schedule Header.",
            "m3": "Please provide civic committee schedule Header.",
            "m4": "Please select Complex and Facility name.",
            "m5": "You don't have any expired event yet.",
            "m6": "Are you sure you want to hide this event on screen?",
            "m7": "Please provide API Key.",
            "m8": "You don't have any active meeting yet.",
            "m9": "Please provide Rink / Floor.",
            "m10": "Are you sure you want to duplicate this event?"
          },
          "agc": {
            "1": "AGC",
            "2": "Edit AGC Widget",
            "3": "Work center",
              "3.1": "Select work center",
            "m1": "Please provide Work center."
          },
          "alert": {
            "1": "CorpComm: Alert Message",
            "2": "Edit CorpComm: Alert Messages Widget",
            "3": "When display",
              "3.1": "Force Display Immediately",
              "3.2": "Force Display at Login",
              "3.3": "Notification in system tray only",
            "4": "Delete once read",
            "5": "Message type"
          },
          "aqi": {
            "1": "Air Quality Index",
            "2": "Edit Air Quality Index Widget",
            "3": "Data source: Azure Map",
            "4": "AQI Color",
            "5": "Secondary Background",
            "6": "Scale Range Settings",
            "7": "Scale Range",
            "8": "Other Settings",
            "9": "label text",
            "10": "label font",
            "11": "label size",
            "12": "status text",
            "13": "status font",
            "14": "status size",
            "15": "status alternate text",
            "16": "status alternate font",
            "17": "status alternate size",
            "18": "value text",
            "19": "value font",
            "20": "value size",
            "21": "value alternate text",
            "22": "value alternate font",
            "23": "value alternate size",
            "24": "4 day forecast including today's air quality index details",
            "m1": "No scale available for this widget.",
            "m2": "Scale range value should not be same/equal.",
            "m3": "Scale color should not be same.",
            "m4": "Value of scale range should be greater than of previous value.",
            "m5": "Please provide scale range.",
            "m6": "Please provide valid scale value.",
            "m7": "Please provide label size.",
            "m8": "Please provide status size.",
            "m9": "Please provide status alternate size.",
            "m10": "Please provide value size.",
            "m11": "Please provide value alternate size.",
            "m12": "Are you sure you want to remove selected scale?"
          },
          "aqs":{
            "1": "Amazon QuickSight",
            "2": "Edit Amazon QuickSight Widget",
            "3": "Amazon QuickSight Settings",
            "4": "Sheet",
            "4.1": "Select sheet",
            "5": "Visual",
            "5.1": "Select visual",
            "m1": "Please select dashboard.",
            "m2": "Please select Sheet.",
            "m3": "Please select Visual."
          },
          "al":{
            "1": "Auto Login (Basic Auth)",
            "2": "Edit Auto Login (Basic Auth) Widget",
            "3": "Reload interval",
            "4": "Login credentials",
            "5": "Username",
            "m1": "Reload interval should not be less than 10 seconds.",
            "m2": "Reload interval should not be less than 30 seconds.",
            "m3": "Please select placeholder Image.",
            "m4": "Please provide username.",
            "m5": "Password and Confirm password should match."
          },
          "ccm": {
            "1": "Pandora CloudCover",
            "2": "Edit Pandora CloudCover Widget",
            "3": "Get widget name from timezone",
            "4": "Auto color",
              "4.1": "This will auto select the color of widget, depending on the background color on screen.",
            "5": "Only Time {{count}}",
            "6": "Only Date {{count}}",
            "7": "Date color",
            "8": "Time color",
            "9": "Format",
              "9.1": "{{value}} Hours",
              "9.2": "{{value}} Hours with \"h\" separator",
            "10": "Box color"
          },
          "cisco": {
            "1": "Cisco Meraki",
            "2": "Edit Cisco Meraki Widget",
            "3": "Network",
              "3.1": "Select network",
            "4": "Sensors",
              "4.1": "Select sensor",
            "5": "Unit text",
            "6": "Unit size",
            "7": "Unit font",
            "8": "Current reading title text",
            "9": "Current reading title size",
            "10": "Current reading title font",
            "11": "Reading value text",
            "12": "Reading value size",
            "13": "Reading value font",
            "14": "Readings",
            "15": "Horizontal list",
            "16": "Vertical list",
            "17": "Slideshow",
            "18": "Temperature Unit",
            "19": "Inadequate",
            "20": "Poor",
            "21": "Fair",
            "22": "Good",
            "23": "Excellent",
            "24": "Summary title text",
            "25": "Summary title size",
            "26": "Summary title text",
            "27": "Header text",
            "28": "Header size",
            "29": "Header text",
            "30": "Reading unit text",
            "31": "Reading unit size",
            "32": "Reading unit font",
            "m1": "Please select Network.",
            "m2": "Please select Sensor.",
            "m3": "Please provide Value size.",
            "m4": "Please provide Unit size.",
            "m5": "Please provide Readings.",
            "m6": "Please provide Current reading title size.",
            "m7": "Please provide Reading value size.",
            "m8": "Please provide Summary title size.",
            "m9": "Please provide Reading unit size.",
            "m10": "Please select Reading."
          },
          "cod": {
            "1": "Content on Demand",
            "2": "Edit Content on Demand",
            "3": "Categories",
            "4": "Category List",
            "5": "Add New Category",
            "6": "Category name",
            "8": "List background",
            "9": "Content background",
            "10": "Thumbnail text",
            "11": "Thumbnail font",
            "12": "Thumbnail size",
            "13": "Select Content for Content on Demand",
            "14": "Move Up",
            "15": "Move Down",
            "16": "Greater than {{size}}",
            "m1": "Please provide category name.",
            "m2": "Category name already exists.",
            "m3": "You don't have any active category yet. When you create some, they'll appear here.",
            "m4": "Are you sure you want to delete the item?",
            "m5": "Total content size greater than {{size}} is not allowed.",
            "m6": "Some of the contents are not accessible to you.",
            "m7": "Idle Time should not be empty or less than 1 minute."
          },
          "codBtn":{
            "1":"Button",
            "2":"Edit Button",
            "3":"Button settings",
              "3.1":"Icon",
              "3.2":"Button label",
              "3.3":"Text style",
              "3.4":"Text size",
              "3.5":"Select style",
            "4":"Button preview",
            "5":"Close Button",
            "6":"Idle Timeout",
            "m1":"Please provide Icon / Button label.",
            "m2":"Please provide text size.",
            "m3":"Please provide Icon.",
            "m4":"Please provide Idle Timeout."
          },
          "cg": {
            "1": "Content Group",
            "2": "Edit Content Group Widget",
            "m1": "Can't save widget!",
              "m1.1": "Since this widget is a part of other Content on Demand widgets, the combined total file size is going beyond the allowed {{limit}} limit. Please remove {{remaning}} data to save this widget.",
              "m1.2": "Below is the list of Content of Demand widgets where this Content Group widget is associated:"
          },
          "count": {
            "1": "Count",
            "2": "Edit Count Widget",
            "3": "Count type",
            "4": "Title Placement",
              "4.1": "Top",
              "4.2": "Right",
              "4.3": "Bottom",
              "4.4": "Left",
            "5": "Count text",
            "6": "Count font size",
            "7": "Count font",
            "8": "Title text",
            "9": "Title size",
            "10": "Title font",
            "11": "Up",
            "12": "Down",
            "13":"When widget load",
            "14": "End count",
            "15": "Count down type",
            "16": "Count up type",
            "17": "Number",
            "18": "Start count",
            "19": "Timer type",
            "20": "Only Seconds",
            "21": "Only Minutes",
            "22": "Only Hours",
            "23": "Only Days",
            "24": "Mode",
            "25": "Display format",
            "m1": "Please provide Count font size.",
            "m2": "Please provide End count.",
            "m3": "Please provide start count.",
            "m4": "Please provide Header font size.",
            "m5": "Please provide Label font size.",
            "m6": "Please provide Footer font size.",
            "m7": "Start count should be less than of End count.",
            "m8": "Start count should be greater than of End count."
          },
          "clFarm": {
            "1": "Cloud Farm",
            "2": "Edit Cloud Farm",
            "3": "Farm Id",
            "m1": "Please provide Farm id."
          },
          "anima":{
            "1": "Animation",
            "2": "SVG Code",
            "3": "None",
            "4": "Pulse"
          },
          "dt": {
            "1": "Date Time",
            "2": "Edit Date Time Widget",
            "3": "Get widget name from timezone",
            "4": "Auto color",
              "4.1": "This will auto select the color of widget, depending on the background color on screen.",
            "5": "Only Time {{count}}",
            "6": "Only Date {{count}}",
            "7": "Date color",
            "8": "Time color",
            "9": "Format",
              "9.1": "{{value}} Hours",
              "9.2": "{{value}} Hours with \"h\" separator",
            "10": "Box color",
            "11": "Date on top",
            "12": "French Canadian",
            "13": "Day color",
            "14": "Month color",
            "15": "Day font",
            "16": "Month font",
            "17": "Date font"
          },
          "dText": {
            "1": "Delimited Text",
            "2": "Edit Delimited Text Widget",
            "3": "Edit Format",
            "4": "Data source",
            "5": "Auto refresh interval",
            "6": "Delimiter",
              "6.1": "Comma",
              "6.2": "Semicolon",
              "6.3": "Tab",
            "7": "Chart type",
              "7.1": "Table",
              "7.2": "Free Form",
            "8": "Frame width",
            "9": "Frame height",
            "10": "Sample data"
          },
          "ei": {
            "1":"External Input",
            "2":"Edit External Input",
            "3":"Input source",
              "3.1":"PC (HDMI 1)",
              "3.2":"PC (HDMI 2)",
              "3.3":"PC (DVI)",
              "3.4":"PC (DISPLAY PORT)",
              "3.5":"LG Presenter"
          },
          "es": {
            "1":"Microsoft Excel Sheet",
            "2":"Edit Microsoft Excel Sheet",
            "3":"Export as image",
            "4":"Update Microsoft Excel Folder",
            "m1":"If the first row or the first column of an Microsoft Excel sheet is empty, it will affect the mapping of cells in the template.",
            "m2":"You can't delete the merged cell.",
            "m3":"Please wait, the task to export as the image is already in progress."
          },
          "fb": {
            "1": "Facebook",
            "2": "Edit Facebook Widget",
            "3": "Get widget name from Facebook",
            "4": "Facebook page URL",
            "5": "Text with media",
            "6": "Media",
            "7": "Live Video",
            "8": "Authorize Facebook",
            "9": "Page List",
              "9.1": "Select Page",
            "m1": "Please provide Facebook page URL.",
            "m2": "Please Authorize Facebook.",
            "m3": "No page found for this account."
          },
          "fwp": {
            "1": "Facebook Workplace",
            "2": "Edit Facebook Workplace Widget",
            "3": "Get widget name from Facebook Workplace",
            "4": "Access token",
            "5": "App secret",
            "6": "App ID",
            "7": "Is App secret proof required?",
            "8": "Select Group",
            "m1": "Please provide Access token",
            "m2": "Please provide App secret",
            "m3": "Please provide App id",
            "m4": "Credentials are not valid"
          },
          "fc": {
            "1": "Filler Content",
            "2": "Edit Filler Content Widget",
            "3": "Playback Sequence",
              "3.1": "Random",
              "3.2": "Ordered",
            "m1": "Please select Playback Sequence."
          },
          "fs": {
            "1": "Flight Schedule",
            "2": "Edit Flight Schedule Widget",
            "3": "Get widget name from airport name",
            "4": "Select airport",
            "5": "Arrival",
            "6": "Departure",
            "7": "Row text",
            "8": "Row font",
            "9": "Alternate row text",
            "10": "Alternate row font",
            "11": "On-time / Scheduled",
            "12": "Canceled",
            "13": "Delayed",
            "14": "Arrived / Departed",
            "15":"Flight code",
            "16": "Airline name",
            "17": "City name",
            "18": "Time",
            "19": "Terminal",
            "20": "Status default",
            "m1": "Please select an airport."
          },
          "fsc": {
            "1": "Fullscreen Chrome",
            "2": "Edit Fullscreen Chrome Widget"
          },
          "f45": {
            "1": "F45",
            "2": "Edit F45 Widget",
            "3": "Workout List",
            "4": "Add Workout",
            "5": "Screen {{no}}",
            "6": "Timer",
              "6.1": "Route",
            "7": "Timer background",
            "8": "Timer text",
            "9": "Timer font",
            "10": "Timer size",
            "11": "Exercise duration",
            "12": "Rest duration",
            "13": "Repetition",
            "14": "Advertisements",
            "15": "Add Advertisement",
            "m1": "You don't have any workout yet. When you create some, they'll appear here.",
            "m2": "Please provide a timer size.",
            "m3": "Please provide a exercise duration.",
            "m4": "Please provide a rest duration.",
            "m5": "Please provide a advertisements.",
            "m6": "You don't have any advertisements yet. When you create some, they'll appear here."
          },
          "wf45": {
            "1": "F45 Content Scroller",
              "1.1": "Edit F45 Content Scroller",
            "2": "F45 Countdown Circle",
              "2.1": "Edit F45 Countdown Circle",
            "3": "F45 Hydrate",
              "3.1": "Edit F45 Hydrate",
            "4": "F45 Move Station",
              "4.1": "Edit F45 Move Station",
            "5": "F45 Progress Bar",
              "5.1": "Edit F45 Progress Bar",
            "6": "F45 Progress Bar with Break",
              "6.1": "Edit F45 Progress Bar with Break",
              "6.2": "Bar",
              "6.3": "Break",
              "6.4": "Hydrate",
              "6.5": "Break icon color",
            "7": "Bar background",
            "8": "Fill color",
            "9": "Focus area height",
            "10": "Overlay color",
            "11": "F45 Content Tile",
              "11.1": "Edit F45 Content Tile",
              "11.2": "Tile type",
              "11.3": "1 Column",
              "11.4": "2 Column",
              "11.5": "Label position",
              "11.6": "Label width",
              "11.7": "Label background",
            "12": "F45 Work",
              "12.1": "Edit F45 Work",
            "13": "F45 Stay",
              "13.1": "Edit F45 Stay",
              "13.2": "Hexagonal",
              "13.3": "Hexagonal with hand",
              "13.4": "Hexagonal with text",
              "13.5": "Hexagonal filled",
            "14": "F45 Story",
              "14.1": "Edit F45 Story",
            "15": "Select Scenes",
              "15.1": "Available Scenes",
              "15.2": "Selected Scenes",
            "16": "F45 Playbook",
              "16.1": "Edit F45 Playbook",
              "16.2": "F45 Settings",
              "16.3": "Story List",
              "16.4": "Add Story",
              "16.5": "Screen {{no}}",
              "16.6": "F45 Settings",
              "16.7": "Number of screens",
              "16.8": "Select Story",
            "17":"JSON",
              "17.1":"Playbook",
              "17.2":"Stories",
              "17.3":"Scenes",
              "17.4":"Stories + Scenes",
            "18": "F45 Animation",
            "19": "Stroke size",
            "20": "Rounded corner",
            "21": "Glow",
            "22": "Glow color",
            "23": "Horizontal offset",
            "24": "Vertical offset",
            "25": "Blur",
            "m1": "Please provide Focus area height.",
            "m2": "Please provide Label width.",
            "m3": "You don't have any story yet. When you create some, they'll appear here.",
            "m4": "Please provide a story.",
            "m5": "Please provide a screen.",
            "m6": "Please provide svg code."
          },
          "bk":{
            "1": "Blank",
              "1.1": "Edit Blank"
          },
          "gc": {
            "1": "Google Calendar",
            "2": "Edit Google Calendar Widget",
            "3": "Authorize Google Calendar",
            "4": "Calendar",
              "4.1": "Select calendar",
            "m1": "Please Authorize Calendar.",
            "m2": "Please select calendar."
          },
          "gs": {
            "1": "Google Slide",
            "2": "Edit Google Slide Widget",
            "3": "Slide URL",
            "4": "Show toolbar",
            "m1": "Please provide Slide URL."
          },
          "steth":{
            "1": "HD Steth",
            "2": "Edit HD Steth",
            "3": "Advertisements",
              "3.1": "Add Advertisement",
              "3.2": "Target type",
              "3.3": "Target content",
              "3.4": "Target URL",
            "4": "Mapping",
              "4.1": "Mapping List",
              "4.2": "Doctor name",
            "5": "Target content / URL",
            "6": "Idle time",
            "7": "Record time",
              "7.1": "Select Record time",
            "m1": "You don't have any advertisement yet. When you create some, they'll appear here.",
              "m1.1": "You don't have any expired event yet.",
            "m2": "Please provide Target content.",
            "m3": "Please provide Target URL.",
            "m4": "You don't have any view yet. When you create some, they'll appear here.",
            "m5": "Please provide Idle time.",
            "m6": "Please select Record time."
          },
          "iFrame": {
            "1": "IFrame",
            "2": "Edit IFrame Widget",
            "3": "Widget data",
            "4": "Allowed tags",
            "m1": "Please provide Widget data."
          },
          "instagram": {
            "1": "Instagram",
            "2": "Edit Instagram Widget",
            "3": "Get widget name from instagram",
            "5": "Instagram hash tag",
              "5.1": "Instagram user name",
            "6": "Select number of post",
            "7": "Authorize Instagram",
            "8": "Instagram Preview",
            "m1": "Please provide Instagram hash tag.",
            "m2": "Please provide Instagram user name.",
            "m3": "No content for preview."
          },
          "in": {
            "1": "LinkedIn",
            "2": "Edit LinkedIn Widget",
            "3": "Get widget name from LinkedIn",
            "4": "Authorize LinkedIn",
            "5": "Company",
              "5.1": "Select company",
            "m1": "Please Authorize LinkedIn.",
            "m2": "Company not found.",
            "m3": "Please provide the post count. It should be a number between 1 and 60."
          },
          "inC": {
            "1": "Intel Circuit Bench",
            "2": "Edit Intel Circuit Bench Widget",
            "3": "Intel Circuit Bench Settings",
            "4": "Takeover"
          },
          "isb": {
            "1": "Intel Smart Building",
            "2": "Edit Intel Smart Building Widget",
            "3": "Buttons",
            "4": "Splash Screens",
            "m1": "Please provide button name.",
            "m2": "Please provide button url.",
            "m3": "Start times should not overlap.",
            "m4": "Please provide Splash Screens.",
            "m5": "This item could not be deleted."
          },
          "iMenu": {
            "1": "Interactive Menu",
            "2": "Edit Interactive Menu Widget",
            "3": "Button width",
            "4": "Button height",
            "5": "Button background color",
            "6": "Button font size",
            "7": "Button text color",
            "8": "Button text align",
            "9": "Button border",
            "10": "Button border color",
            "11": "Button border size",
            "12": "Button border radius",
            "13": "Icon {{count}}",
              "13.1": "Image selection on each menu is not mandatory. if you make it \"checked\" here. If no image selected on sub-menu level, it's parent menu's icon will be displayed.",
            "14": "Icon position",
            "15": "Parent",
            "16": "Target",
            "17": "Top menu",
            "18": "Select",
            "19": "Menu structure",
            "b1": "Add New Menu"
          },
          "iot": {
            "1": "IoT Button",
            "2": "Edit IoT Button",
            "3": "Placement Mapping",
            "4": "",
              "4.1": "Number text",
              "4.2": "Number font",
              "4.3": "Number size",
              "4.4": "Title text",
              "4.5": "Title font",
              "4.6": "Title size",
              "4.7": "Alternate background",
              "4.8": "Alternate text",
              "4.9": "Alternate font",
              "4.10": "Alternate size",
              "4.11": "Layout orientation",
              "4.12": "Latest item width",
              "4.13": "Latest item height",
              "4.14": "Queue columns",
              "4.15": "Max queue items",
              "4.16": "Separator",
              "4.17": "Show timeout",
            "5": "Add Placement",
              "5.1": "Placement",
              "5.2": "Screen value",
            "6": "Latest Item",
            "7": "Queue Items",
            "8": "Notification audio",
              "8.1": "Select audio",
            "m1": "Please provide Latest item width.",
            "m2": "Please provide Latest item height.",
            "m3": "Please provide Queue columns.",
            "m4": "Please provide Max queue items.",
            "m5": "Please provide Show timeout.",
            "m6": "Please provide latest item Title size.",
            "m7": "Please provide latest item Number size.",
            "m8": "Please provide queue items Title size.",
            "m9": "Please provide queue items Size.",
            "m10": "Please provide queue items Alternate size.",
            "m11": "Please provide Placement.",
            "m12": "Please provide Screen value.",
            "m13": "You don't have any active placement mapping yet. When you create some, they'll appear here.",
            "m14": "Message sent."
          },
          "mc": {
            "1": "Music Choice",
            "2": "Edit Music Choice Widget",
            "3": "Select Categories",
            "4": "Playlist",
            "5": "Shuffle",
            "6": "Available categories",
            "7": "Selected categories",
            "8": "Songs",
              "8.1": "Available songs",
              "8.2": "Selected songs",
            "9": "Songs List",
            "10": "Do not play",
            "11": "Clear",
            "12": "Import Do Not Play List",
            "13": "Select widget",
            "14": "No item in Do not play",
            "15": "Select type",
            "m1": "Please add a category from the list.",
            "m2": "No song selected yet.",
            "m3": "No data available.",
            "m4": "Please select at least one category.",
            "m5": "Are you sure you want to remove this category from current playlist? All corresponding songs will be removed from playlist.",
            "m6": "Invalid songs count.",
            "m7": "Search result",
            "m8": "No result found.",
            "m9": "Invalid song count in one of selected category.",
            "m10": "Playlist can contain max 900 songs including all categories.",
            "m11": "You don't have any Music choice widget yet.",
            "m12": "",
            "m13": "Importing file again will wipeout all current data from list. Are you sure to import new file?",
            "m14": "Playlist should not be empty.",
            "t1": "This category does not have any song",
            "t2": "This song is in \"Do not play\" list"
          },
          "ls": {
            "1": "Live Streaming",
            "2": "Edit Live Streaming Widget",
            "3": "Streaming URL",
            "4": "Streaming type",
              "4-1": "HLS",
              "4-2": "HTTPS",
              "4-3": "RTSP",
              "4-4": "YouTube Live",
              "4-5": "TS over UDP",
            "5": "Caption text",
            "6": "Caption font",
            "7": "Caption size",
            "8": "Caption language",
            "9": "VTT Caption",
            "m1": "Please provide Streaming URL.",
            "m2": "No caption available for this widget.",
            "m3": "Please provide Caption size.",
            "m4": "This caption language selected in some of videos or Live streaming widget.",
            "m5": "Same language for caption should not be selected multiple times.",
            "m6": "Are you sure you want to remove selected caption?",
            "p":{
              "1":"Live Streaming Support on L\u00A0Squared\u00A0Hub",
              "2":"Our digital signage platform supports multiple types of live streaming to accommodate a wide range of broadcast environments and content delivery needs. Below is a brief overview of the streaming formats we support:",
              "3":"1. HLS (HTTP Live Streaming)",
                "3-1":"HLS is a widely adopted adaptive streaming protocol developed by Apple. It breaks the video stream into small chunks and delivers them over standard HTTP, ensuring smooth playback even under varying network conditions.",
              "4":"2. HTTPS Streaming",
                "4-1":"HTTPS streaming involves delivering live video over a secure, encrypted HTTP connection. This is typically used when the stream is hosted via a media server and accessed through a direct URL. It offers broad compatibility and is ideal for cloud-hosted or CDN-based streams.",
              "5":"3. TS over UDP (Transport Stream over User Datagram Protocol)",
                "5-1":"TS over UDP is commonly used in closed or local network environments, such as enterprise or broadcast infrastructure. It provides low-latency delivery but typically requires network configuration and is better suited for intranet scenarios.",
              "6":"4. YouTube Live",
                "6-1":"Our platform supports embedding YouTube Live streams for seamless integration of public-facing events, webinars, or broadcasts. This is ideal for content already hosted or planned for YouTube."
            }
          },
          "coe":{
            "1": "Calendar of Events",
            "2": "Edit Calendar of Events",
            "3": "Event List",
            "4": "Advertise this event",
            "5": "Add Event",
            "6": "Create View",
            "7": "Set Visibility",
              "7.1": "Roomboard view",
              "7.2": "Wallboard view",
              "7.3": "Calendar view",
            "8": "View name",
            "9": "View List",
            "10": "Repository name",
            "11": "Repository path",
            "m1": "You don't have any active event yet. When you create some, they'll appear here.",
              "m1.1": "You don't have any expired event yet.",
            "m2": "Please provide View name.",
            "m3": "Please select Type.",
            "m4": "You don't have any view yet. When you create some, they'll appear here."
          },
          "coev":{
            "1": "Calendar of Events View",
            "2": "Edit Calendar of Events View",
            "3": "Day name background",
            "4": "Day name text",
            "5": "Cell background",
            "m1": "You don't have any event yet. When you create some, they'll appear here."
          },
          "msTeams":{
            "1": "Microsoft Teams",
            "2": "Edit Microsoft Teams Widget",
            "3": "Meeting",
              "3.1": "Group Message"
          },
          "tRoom":{
            "1": "Microsoft Teams Rooms",
            "2": "Edit Microsoft Teams Rooms Widget",
            "3": "Authorize Microsoft Teams Rooms",
            "4": "Select room",
            "m1": "Please Authorize Microsoft Teams Rooms.",
            "m2": "Please select room."
          },
          "tChannel":{
            "1": "Microsoft Teams Channels",
            "2": "Edit Microsoft Teams Channels",
            "3": "Get widget name from Teams",
            "4": "Teams",
              "4.1": "Select teams",
            "5": "Authorize Microsoft Teams Channels",
            "m1": "Teams not found.",
            "m2": "Please Authorize Microsoft Teams Channels."
          },
          "webex":{
            "1": "webex by CISCO",
            "2": "Edit webex by CISCO Widget",
            "3": "Get widget name from Teams",
            "4": "Teams",
              "4.1": "Select teams",
            "5": "Authorize webex by CISCO",
            "6": "webex by CISCO Settings",
            "7": "Spaces",
              "7.1": "Select space",
            "m1": "Teams not found.",
            "m2": "Please Authorize webex by CISCO.",
            "m3": "Please select space.",
            "m4": "This action will log you out from your logged-in webex by CISCO sessions on this browser. Are you sure you want to re-authorize with other user?",
            "m5": "Note: To disconnect this widget from Webex, you can delete the widget from Content Library."
          },
          "meeting": {
            "1": "Meetings",
            "2": "Edit Meetings Widget",
            "3": "Meeting List",
            "4": "Screensaver",
              "4.1": "Screensaver background",
            "5": "Add Meeting",
            "6": "Add Screensaver",
            "7": "Room List",
            "8": "Floor",
            "9": "Logo",
            "10": "Please select room",
            "11": "Save & Add More",
            "12": "Assign devices",
            "13": "Image / Video",
              "13.1": "Select Image / Video",
            "14": "Day view",
            "15": "Week view",
            "16": "Month view",
            "17": "Custom Room",
              "17.1": "Room name",
              "17.2": "Floor name",
            "18": "Show time on screen",
            "19": "Rooms",
            "20": "Add Room",
            "21": "Edit Room",
            "22": "Show on screen",
              "22.1": "Start",
                "22.1.1": "Start of the day",
                "22.1.2": "Prior",
              "22.2": "End",
                "22.2.1": "End of the day",
                "22.2.2": "After",
            "23": "Show logo",
            "24": "Content",
              "24.1":"Select Content",
            "25": "Group by title",
            "26": "Schedule On",
            "27": "Date range apply on",
              "27.1": "Per day",
              "27.2": "Overlapping",
            "28": "Display start on screen",
            "29": "Display end on screen",
            "30": "Display meetings of",
              "30.1": "Current Date",
              "30.2": "Current Week",
              "30.3": "Current Month",
            "31": "Show floor",
              "31.1": "Floor text",
              "31.2": "Alternate floor text",
              "31.3": "Floor font",
              "31.4": "Floor size",
            "32": "Show room and floor in same column",
            "33": "By choosing this option, only the meetings which are directly assigned to this device will get listed.",
            "34": "Assigned meetings only",
            "35": "Show on wallboard",
            "m1": "Please provide Room.",
            "m2": "You don't have any active meeting yet. When you create some, they'll appear here.",
              "m2.1": "You don't have any expired meeting yet.",
            "m3": "You don't have any screensaver yet. When you create some, they'll appear here.",
            "m4": "Please provide Image / Video.",
            "m5": "Please assign at least one device.",
            "m6": "Room name already exists. Please try some other name.",
            "m7": "Are you sure you want to delete selected room?",
            "m8": "You will not be able to delete selected room, Because this room is being used in meeting.",
            "m9": "You don't have any device yet.",
            "m10": "You don't have any device group yet.",
            "m11": "You don't have any room yet.",
            "m12": "Please provide show on screen Prior.",
            "m13": "Please provide show on screen After.",
            "m14": "You don't have any selected device yet.",
            "m15": "You don't have any selected device group yet.",
            "m16": "You don't have any selected room yet."
          },
          "message": {
            "1": "Message",
            "2": "Edit Message Widget",
            "3": "Image Position",
              "3.1": "Top",
              "3.2": "Right",
              "3.3": "Bottom",
              "3.4": "Left",
              "3.5": "After Title",
              "3.6": "Background"
          },
          "news": {
            "1": "News",
            "2": "Edit News Widget",
            "3": "Get widget name from news",
            "4": "News provider",
              "4.1": "Select news provider",
              "4.2": "BBC",
              "4.3": "CBC",
              "4.4": "CNN",
              "4.5": "ESPN",
              "4.6": "Fox News",
              "4.7": "US Nuclear",
              "4.8": "Bing",
              "4.9": "Google",
            "5": "News category",
            "5.1": "Select news category",
            "6": "Rotation",
            "6.1": "Auto",
            "7": "Bing news",
            "8": "Google news",
            "m1": "Please provide News provider.",
            "m2": "Please provide News category.",
            "m3": "",
            "m4": "Feed provided by the news provider is free for non-commercial use. If you wish to use this service for commercial use, please contact the news provider and obtain a license."
          },
          "nb": {
            "1": "NextBus",
            "2": "Edit NextBus Widget",
            "3": "Get widget name from NextBus",
            "4": "Agency",
            "4.1": "Select agency",
            "5": "Route",
            "5.1": "Select route",
            "6": "Directions",
            "6.1": "Select directions",
            "7": "Bus stop",
            "7.1": "Select bus stop",
            "8": "Route info.",
            "9": "Stop info.",
            "m1": "Please provide agency.",
            "m2": "Please provide route.",
            "m3": "Please provide directions.",
            "m4": "Please provide bus stop."
          },
          "nv": {
            "1": "Next Vehicle",
            "2": "Edit Next Vehicle Widget"
          },
          "pw": {
            "1": "LifeLabs Patient Wait",
            "2": "Edit LifeLabs Patient Wait Widget",
            "3": "Average wait time",
            "4": "Number background",
            "5": "Number text",
            "6": "Number font",
            "7": "Number size",
            "8": "Footer background",
            "9": "Footer text",
            "10": "",
            "11": "",
            "12": "Import site mapping",
            "13": "Un-arrived text",
            "14": "Icon color",
            "15": "Alternate icon color",
            "16": "Site Id",
            "17": "Choose symbol",
              "17.1": "Appointment",
              "17.2": "Walk In",
              "17.3": "Save My Spot",
            "18": "Choose name format template",
            "19": "Site Mapping",
            "20": "Arrived text",
            "21": "Walk In text",
            "22": "Name text format",
              "22.1": "Upper case",
              "22.2": "Lower case",
            "23": "Arrived save my spot",
            "24": "Un-arrived save my spot",
            "25": "Environment",
              "25.1": "Test",
              "25.2": "Production",
              "25.3": "Training",
            "26": "On web service",
              "26.1": "Restart",
              "26.2": "Do nothing",
            "27": "Endpoint",
            "m1": "",
            "m2": "Please provide size.",
            "m3": "Please provide Left size.",
            "m4": "Please provide number size.",
            "m5": "Please provide Footer size.",
            "m6": "Please provide site mapping.",
            "m7": "Please provide Reload interval.",
            "m8": "Uploaded mapping sheet is not valid.",
            "m9.1": "Customer First Full Name and Last Name Initial (e.g. Steve Z.)",
            "m9.2": "Only display Appointment Time for Appointments",
            "m9.3": "Walk-ins appear in call up order but no times appear",
            "m10.1": "First and Last Name Initials (e.g. S. Z.)",
            "m10.2": "Only display Appointment Time for Appointments",
            "m10.3": "Walk-ins appear in call up order but no times appear",
            "m11.1": "First letter of First Name, space, and first three initials of the Last Name Initial (e.g. S. ZAN)",
            "m11.2": "Just display sort order(no times)",
            "m12": "Please add or import site mapping."
          },
          "pBI": {
            "1": "Microsoft Power BI",
            "2": "Edit Microsoft Power BI Widget",
            "3": "Get widget name from Microsoft Power BI",
            "4": "Authenticate with Microsoft Power BI",
            "5": "Dashboard",
            "6": "Report",
            "7": "Workspace",
              "7.1": "Select workspace",
            "8": "Visualization",
              "8.1": "Select visualization",
            "9": "Directory (tenant) Id",
            "10": "Application (client) Id",
            "11": "Secret Key",
            "12": "Using L Squared's App",
            "13": "Using Customer's App",
            "14": "Available Dashboards",
            "15": "Available Reports",
            "16": "Select Dashboard",
            "17": "Select Report",
            "18": "Custom Selection",
            "19": "Item",
            "20": "Name",
            "21": "Authenticate",
              "21.1": "Re-Authenticate",
            "22" : "Select Tab",
            "23" : "Authentication method",
              "23.1" : "User login",
              "23.2" : "Service principal",
            "24" : "Widget type",
              "24.1" : "Authorized content",
              "24.2" : "Embed code",
            "25": "Microsoft Power BI Settings",
            "26": "Microsoft Power BI widget filter",
            "27": "Column",
            "28": "Select Active Tab",
            "29": "Filter List",
            "30": "Sync Filters",
            "31": "Default Page",
            "32": "Rotate All Pages",
            "33": "Page",
            "34": "Rendered as image",
            "35": "Select day",
            "36": "Generate every n{{htmlTagO}}th{{htmlTagC}} day",
            "m1": "Please Authenticate with Microsoft Power BI.",
            "m2": "You don't have any workspace yet. When you create some, they'll appear here.",
            "m3": "Please select workspace.",
            "m4": "You don't have any visualization yet. When you create some, they'll appear here.",
            "m5": "Please select visualization.",
            "m6": "Dashboards are not available.",
            "m7": "Reports are not available.",
            "m8": "Authentication successful.",
              "m8.1": "You are already authenticate for this account on this widget. If you want to change account, please re-authenticate.",
            "m9": "Please select dashboard.",
            "m10": "Please select report.",
            "m11": "Please fill custom value.",
            "m12": "Assign custom fields for devices to target the dashboard.",
              "m12.1": "Assign custom fields for devices to target the report.",
            "m13": "Please make sure you saved the correct tenant ID, client ID and client secret.",
            "m14": "Rotation duration should be greater than 10.",
            "m15": "Please select device property for each filter.",
            "m16": "There are no filter available in the selected report.",
            "m17": "Please provide day interval.",
            "m18": "Please select pages."
          },
          "or": {
            "1": "Online Radio",
            "2": "Edit Online Radio Widget",
            "3": "Get widget name from radio station",
            "4": "Radio station",
              "4.1": "Select station",
            "5": "Volume",
            "m1": "Please provide Radio station.",
            "m2": "Service provided by the radio stations is free for non-commercial use. If you wish to use this service for commercial use, please contact the radio station and obtain a license."
          },
          "oh": {
            "1": "Open Hours",
            "2": "Edit Open Hours Widget",
            "3": "Hours English",
              "3.1": "Hours French",
              "3.2": "Hours Spanish",
            "4": "Pickup English",
              "4.1": "Pickup French",
              "4.2": "Pickup Spanish",
            "5": "Footer image",
            "6": "Pickup Day",
            "7": "Pickup Time",
            "8": "Language",
            "9": "Hours text",
            "10": "Hours font",
            "11": "Pickup text",
            "12": "Pickup font"
          },
          "oc": {
            "1": "Microsoft Outlook Calendar",
            "2": "Edit Microsoft Outlook Calendar",
            "4": "Roomboard",
              "4.1": "Room email",
            "5": "Wallboard",
              "5.1": "Wallboard List",
            "6": "Authorize Microsoft Outlook Calendar",
            "8": "Synchronic Microsoft Outlook Calendar",
            "9": "Sync",
            "10": "Room",
            "11": "Left background",
            "12": "Left text",
            "13": "Left font",
              "13.1": "Left size",
            "14": "Subtitle font",
            "15": "Subtitle size",
            "17": "Time font",
            "18": "Time size",
            "20": "Alternate background",
            "21": "Outlook.com",
            "22": "Exchange Server",
            "23": "Host",
            "24": "Password",
            "25": "Retype password",
            "26": "Exchange server version",
              "26.1": "Select version",
            "27": "Room text",
              "27.1": "Alternate room text",
            "28": "Room font",
              "28.1": "Room size",
            "29": "Calendar name",
            "30": "Time background",
            "31": "Alternate time background",
            "32": "Row border",
            "33": "Event background",
            "34": "Event text",
            "35": "All Events",
            "36": "Show time",
            "37": "Show room",
            "38": "Meetings",
            "39": "Show events of days",
            "40": "Title text align",
            "41": "Header text align",
            "42": "Time text align",
            "43": "Room text align",
            "44": "Floor text align",
            "m1": "Please provide Room id.",
            "m3": "Please Authorize Outlook.",
            "m4": "Sync failed.",
            "m5": "Please provide email id to filter the meeting list.",
            "m6": "Please add at least one wallboard.",
            "m7": "Please provide valid name and email.",
              "m7.1": "Please provide valid email.",
            "m8": "Please provide valid host.",
            "m9": "Please provide valid user name.",
            "m10": "Please provide valid password.",
            "m11": "Please provide valid retype password.",
            "m12": "Password and retype password not match.",
            "m13": "Please select version.",
            "m14": "The email will be used to filter the meetings. If email is provided, only the meetings where the provided email is invited will get listed.",
            "m15": "Please provide valid days of events.",
            "m16": "Days of events should not be more than 365."
          },
          "pylonText": {
            "1": "CoM Pylon Text",
            "2": "Edit CoM Pylon Text Widget",
            "3": "Box width",
            "4": "Number of lines",
            "m1": "Please provide Box width.",
            "m2": "Please provide Number of lines.",
            "m3": "Please provide Font size.",
            "m4": "Font size should not be less than 11.",
            "m5": "You don't have any active text yet.",
            "m6": "You don't have any expired text yet."
          },
          "pb": {
            "1": "Progress Bar",
            "2": "Edit Progress Bar",
            "3": "Corner size",
              "3.1": "pixels",
            "4": "Fill type",
            "5": "Dynamic",
            "6": "Fill value",
            "7": "Orientation",
            "m1": "Please provide Rounded corner.",
            "m2": "Please provide Fill value.",
            "m3": "Fill value should not be greater than 100."
          },
          "queue": {
            "1": "Queue",
            "2": "Edit Queue Widget",
            "3": "Current",
            "4": "Next",
            "5": "Starting number",
            "6": "Ending number",
            "7": "Prefix",
              "7.1": "Prefix color",
              "7.2": "Prefix font",
            "8": "Suffix",
              "8.1": "Suffix color",
              "8.2": "Suffix font",
            "9": "Increment",
            "10": "Decrement",
            "11": "Tabular",
            "12": "Tabular - Third Party",
            "13": "Refresh interval",
            "14": "",
            "15": "Generate grid",
            "16": "Import file",
            "17": "Number of columns",
            "18": "Delimiter",
              "18.1": "Comma",
              "18.2": "Semicolon",
              "18.3": "Tab",
            "19": "Current number color",
              "19.1": "Current number font",
            "1t": "Hide",
            "1b": "Generate",
              "1b-i": "Generating",
            "2b": "Add Row",
            "m1": "Please provide Starting number.",
            "m2": "Please provide Ending number.",
            "m3": "Starting number should not be equal to or greater than ending number.",
            "m4": "Are you sure you want to reset queue number?",
            "m5": "Item not accessible.",
            "m7": "Please provide Page rotate interval.",
            "m8": "Please provide Number of columns.",
              "m8.1": "Please Generate grid.",
              "m8.2": "Please Import file.",
            "m9": "This action will remove current data entries from grid. Are you sure you want to proceed?",
            "m10": "Generating the grid again will wipeout all current data from it. Are you sure to regenerate the grid?",
            "m11": "Importing file again will wipeout all current data from grid. Are you sure to import new file?",
            "m12": "The separator you selected is not there in the uploaded file. Are you sure you want to continue?"
          },
          "quotes": {
            "1": "Quote",
            "2": "Edit Quotes Widget",
            "3": "Select quotes",
            "4": "Rotation duration",
            "5": "Quotes font",
            "6": "Quotes font size",
            "7": "Quotes text",
            "8": "Author font",
            "9": "Author font size",
            "10": "Author text",
            "11": "Add new quote",
            "12": "Choose quote from library",
            "13": "Quote library",
            "14": "Click to select",
            "15": "Author",
            "16": "Selected quotes",
            "17": "Ask ChatGPT",
            "18": "Quotes ChatGPT",
            "1s": "Quotes",
            "13s": "Quotes library",
            "m1": "Please provide Quote.",
            "m2": "No quote added.",
            "m3": "",
            "m4": "Please provide Quotes font size.",
            "m5": "Please provide Author font size.",
            "m6": "Image is not accessible to you.",
            "m7": "For example: \"Motivational quotes\"",
            "m8": "No quote found."
          },
          "qr": {
            "1": "QR Code",
            "2": "Edit QR Code Widget",
            "3": "SSID",
            "4": "Network type",
            "5": "Hidden",
            "6": "WEP",
            "7": "WPA/WPA2",
            "8": "No encryption",
            "9": "Plain Text",
              "9.1": "Text",
            "10": "Geo Location",
            "11": "Calendar Event",
              "11.1": "All day event",
              "11.2": "Event title",
              "11.3": "Location",
            "12": "vCard",
              "12.1": "Personal",
                "12.1.1": "Middle name",
                "12.1.2": "Nick name",
                "12.1.3": "Date of birth",
              "12.2": "Emails",
                "12.2.1": "Personal",
                "12.2.2": "Work",
              "12.3": "Contact Number",
                "12.3.1": "Mobile",
                "12.3.2": "Home",
              "12.4": "Work",
                "12.4.1": "Organization",
                "12.4.2": "Job title",
              "12.5": "Home address",
              "12.6": "Work address",
              "12.7": "Note",
            "m1": "Please provide Type.",
            "m2": "Please provide Text.",
            "m3": "Please provide Phone.",
            "m4": "Please provide Subject.",
            "m5": "Please provide SSID.",
            "m6": "Please provide Event title.",
            "m7": "Please provide First name.",
            "m8": "Please provide Last name.",
            "m9": "Please provide Mobile.",
            "m10": "Please provide all Home address info.",
            "m11": "Please provide all Work address info.",
            "m12": "Please provide valid Contacts.",
            "m13": "Please provide valid Email.",
              "m13s": "Please provide valid Emails.",
            "m14": "Please provide Email."
          },
          "qlik": {
            "1": "Qlik",
            "2": "Edit Qlik Widget",
            "3": "App Details",
            "4": "Get widget name from Qlik",
            "5": "Web integration id",
            "6": "Key id",
            "7": "Issuer",
            "8": "App",
              "8.1": "Select App",
            "9": "Sheet List",
              "9.1": "Select Sheet",
            "10": "Tenant hostname",
            "11": "Sheet id",
            "12": "Qlik Settings",
            "13": "Authenticate with Qlik",
            "m1": "Please provide Tenant hostname.",
            "m2": "Please provide Client id.",
            "m3": "Please provide Client secret.",
            "m4": "Please provide Web integration id.",
            "m5": "Please provide Key id.",
            "m6": "Please provide Issuer.",
            "m7": "Please select App.",
            "m8": "Please provide Sheet id.",
            "m9": "Please Authenticate with Qlik.",
            "m10": "This action will log you out from your logged-in Qlik sessions on this browser. Are you sure you want to re-authorize with other user?"
          },
          "rss": {
            "1": "RSS feed",
            "2": "Edit RSS Feed Widget",
            "m1": "Please provide RSS feed."
          },
          "rb":{
            "1": "Readerboard"
          },
          "sc": {
            "1": "Schedule Calendar",
            "2": "Edit Schedule Calendar",
            "3": "Day",
            "4": "Week",
            "5": "Month",
            "6": "Year",
            "7": "Select Schedules",
            "8": "Text background",
            "9": "Text alignment",
            "10": "Only image/video",
            "11": "Text with image/video",
            "m1": "Please select at least one schedule.",
            "m2": "Please select dates.",
            "m3": "Please select weeks.",
            "m4": "Please select months."
          },
          "sch": {
            "1": "Firstup",
            "2": "Edit Firstup Widget",
            "3": "Channel",
              "3.1": "Select channel",
            "m1": "Please select channel."
          },
          "jci": {
            "1": "Intel JCI Map",
            "2": "Edit Intel JCI Map Widget",
            "3": "Kiosk",
              "3.1": "Select kiosk",
            "4": "Intel JCI Map Settings",
              "4.1": "User name",
              "4.2": "Password",
            "5": "Device's {{htmlTagO}}Intel JCI Kiosk Id{{htmlTagC}} Property",
            "6": "All Kiosk Ids",
            "7": "Kiosk List",
            "8": "Kiosk Name",
            "9": "Kiosk Id",
            "m1": "Please select kiosk.",
            "m2": "Please provide User name.",
            "m3": "Please provide Password.",
            "m4": "Kiosk List not found."
          },
          "ssm": {
            "1": "Social Media Wall",
            "2": "Edit Social Media Wall"
          },
          "slack": {
            "1": "Slack",
            "2": "Edit Slack Widget",
            "3": "Get widget name from slack",
            "5": "Authorize Slack bot",
            "7": "Channel list",
              "7.1": "Select channel",
            "8": "User name color",
            "9": "Message color",
            "m2": "Please Authorize Slack bot.",
            "m3": "Please select channel."
          },
          "sp": {
            "1": "Stock Price",
            "2": "Edit Stock Price Widget",
            "3": "Single",
            "4": "Multiple",
            "5": "Stock symbol",
            "6": "Stock List",
            "7": "Symbol",
            "8": "Type to search stock",
            "9": "Show graph image",
            "10": "Country",
              "10.1": "Select country",
            "11": "Symbol",
              "11.1": "Select symbol",
            "12": "Symbol",
            "13": "Price",
            "14": "Change positive",
            "15": "Change negative",
            "16": "Name",
            "17": "Value",
            "18": "Net Change",
            "19": "% Change",
            "20": "Symbol Size",
            "21": "Symbol Font",
            "22": "Name Size",
            "23": "Name Font",
            "24": "Price Size",
            "25": "Price Font",
            "26": "High price label",
            "27": "High price Size",
            "28": "High price Font",
            "29": "Low price label",
            "30": "Low price Size",
            "31": "Low price Font",
            "32": "High price value",
            "33": "High price value Size",
            "34": "High price value Font",
            "35": "Low price value",
            "36": "Low price value Size",
            "37": "Low price value Font",
            "38": "Country Size",
            "39": "Country Font",
            "40": "Positive/Negative Size",
            "41": "Positive/Negative Font",
            "42": "Template 1",
            "43": "Template 2",
            "44": "High",
            "45": "Low",
            "46": "Select language (High/Low)",
            "m1": "Stock trade price provided by {{htmlTagO}}FCSAPI{{htmlTagC}}, may not be free for commercial use. If you wish to use this service for commercial use, please contact the trade price provider and obtain a license.",
            "m2": "Stock symbol is not correct. Please search again.",
            "m3": "Please provide Country.",
            "m4": "Please provide Symbol.",
            "m5": "Please provide symbol size.",
            "m6": "Please provide name size.",
            "m7": "Please provide price text size.",
            "m8": "Please provide positive/negative size.",
            "m9": "Please provide high price text size.",
            "m10": "Please provide low size text size.",
            "m11": "Please provide high price value size.",
            "m12": "Please provide low price value size."
          },
          "ss": {
            "1": "SunSmart",
            "2": "Edit SunSmart Widget",
            "3": "Get widget name from sun smart",
            "4": "Widget type",
            "5": "State",
            "6": "Default location",
            "7": "Preview",
            "5.1": "Select state",
            "6.1": "Select location",
            "m1": "Please provide Widget type.",
            "m2": "Please provide State.",
            "m3": "Please provide Default location."
          },
          "storm":{
            "1": "Storm",
            "2": "Edit Storm Widget",
            "3": "Reload interval",
            "4": "Login credentials",
            "5": "User ID",
            "6": "Dashboard ID",
            "m1": "Reload interval should not be less than 10 seconds.",
            "m2": "Reload interval should not be less than 30 seconds.",
            "m3": "Please select placeholder Image.",
            "m4": "Please provide the user ID.",
            "m5": "Password and Confirm password should match."
          },
          "survey": {
            "1": "Survey",
            "2": "Edit Survey Widget",
            "3": "Question",
              "3s": "Questions",
            "4": "Option {{no}}",
            "8": "Description font",
            "10": "Description text",
            "11": "Survey link",
            "12": "Result",
            "13": "Finished",
            "14": "Reopen",
            "15": "Info screen",
            "16": "Result screen",
    
            "17": "Question color",
            "18": "Question size",
            "19": "Question font",
            "20": "Answers color",
            "21": "Answers size",
            "22": "Answers font",
    
            "23": "Progressbar background",
            "24": "Progressbar",
            "25": "Progressbar color",
            "26": "Show result summary to end user",
            "27": "Question Type",
            "28": "Single selection",
            "29": "Multi selection",
            "30": "User Input",
    
            "m1": "Please provide Question.",
            "m2": "Please provide at least two options.",
            "m3": "No question added.",
            "m6": "Record for the votes on this question will also get deleted if you delete the question. Are you sure you want to delete this question?",
            "m7": "Are you sure you want to finish the Survey?",
            "m8": "Are you sure you want to reopen the Survey?",
            "m9": "Result not found.",
            "m10": "Please provide Question size.",
            "m11": "Please provide Answers font.",
            "m12": "You can add max 10 options.",
            "m13": "Do you want to remove this option?"
          },
          "tb": {
            "1": "Tableau",
            "2": "Edit Tableau Widget",
            "3": "Project",
              "3.1": "Select project",
            "4": "Workbook",
              "4.1": "Select workbook",
            "5": "View",
              "5.1": "Select view",
            "6": "Show tab",
            "m1": "Please select Project.",
            "m2": "Please select Workbook.",
            "m3": "Please select View.",
            "m4": "Invalid info."
          },
          "tbS": {
            "1": "Secret value",
            "2": "Site name",
            "3": "Server URL",
            "4": "Tableau Settings",
            "5": "Secret id",
            "m1": "Please provide Secret value.",
            "m2": "Please provide Site name.",
            "m3": "Please provide Server URL.",
            "m4": "Please provide Secret id."
          },
          "telax": {
            "1": "Telax",
            "2": "Edit Telax Widget",
            "3": "Report Type",
            "4": "Agent Status ",
            "5": "Queue Statistics",
            "6": "COPS Statistics",
            "7": "Limit",
            "8": "Telax Settings",
            "9": "Telax Account Information",
              "9.1": "Account Id",
              "9.2": "User name",
              "9.3": "Password",
              "9.4": "Confirm Password",
            "10": "Telax FTP Information",
              "10.1": "Host",
            "m1": "Please provide Limit.",
            "m2": "Limit should be unique.",
            "m3": "Limit should be in incremental order."
          },
          "text": {
            "1": "Text",
            "2": "Edit Text Widget",
            "3": "Text List",
            "4": "Direction",
            "5": "Right to Left",
            "6": "Bottom to Top",
            "7": "Crawling text",
            "8": "Static text",
            "9": "Horizontal alignment",
            "10": "Vertical alignment",
            "11": "Alignment",
            "m1": "Please provide text.",
            "m2": "Please provide font size."
          },
          "tl": {
            "1": "TouchLink Meetings",
            "2": "Edit TouchLink Meetings Widget",
            "3": "Roomboard",
            "4": "Wallboard collapsed",
            "5": "Wallboard expanded",
            "6": "Logo directory path",
            "7": "Screensaver directory path",
            "m1": "Please provide logo directory path.",
            "m2": "Please provide screensaver directory path."
          },
          "traffic": {
            "1": "Traffic",
            "2": "Edit Traffic Widget"
          },
          "tsccm": {
            "1": "TSC Country Mile",
            "2": "Edit TSC Country Mile Widget",
            "3": "Default message",
              "3-1": "(No post data)",
            "4": "To label",
            "5": "To label font",
            "6": "To label size",
            "7": "To text",
            "8": "To text font",
            "9": "To text size",
            "10": "From label",
            "11": "From label font",
            "12": "From label size",
            "13": "From text",
            "14": "From text font",
            "15": "From text size",
            "16": "Message",
            "17": "Message font",
            "18": "Message size",
            "19": "Default message",
            "20": "Default message font",
            "21": "Default message size",
            "22": "Joining date",
            "23": "Joining date font",
            "24": "Joining date size",
            "25": "",
              "25-1": "Anniversary",
              "25-2": "Badge",
            "26": "",
              "26-1": "Newest first",
              "26-2": "Oldest first",
            "m1": "Please select at least one display type.",
            "m2": "Please provide To label size",
            "m3": "Please provide To text size",
            "m4": "Please provide From label size",
            "m5": "Please provide From text size",
            "m6": "Please provide Message size",
            "m7": "Please provide Default message size",
            "m8": "Please provide Joining date size"
          },
          "tm": {
            "1": "Training Mode",
            "2": "Edit Training Mode Widget"
          },
          "twitter": {
            "1": "X",
            "2": "Edit X Widget",
            "3": "Get widget name from X",
            "4": "Handle",
            "5": "X hash tag",
            "5.1": "X handle",
            "6": "Description text",
            "6.1": "Alternate description text",
            "7": "Authorize X",
            "m1": "Please provide X hash tag.",
            "m2": "Please provide X handle.",
            "m3": "X not found.",
            "m4": "Invalid hash tag.",
            "m5": "After authorization, please click on the verify button below to verify the authorization:"
          },
          "ub": {
            "1": "Ungerboeck",
            "2": "Edit Ungerboeck Widget",
            "3": "Roomboard",
            "4": "Wallboard collapsed",
            "5": "Wallboard expanded",
            "6": "Logo directory path",
            "7": "Screensaver directory path"
          },
          "unisys":{
            "1": "Unisys",
            "2": "Edit Unisys Widget",
            "3": "Source URL",
            "4": "Number of columns",
            "5": "Paging background",
            "6": "Paging color",
            "7": "Paging font",
            "8": "Paging size",
            "9": "Paging highlight",
            "10": "Token type",
            "11": "Token",
            "12": "Environment",
              "12.1": "Select Environment",
              "12.2": "Test/Revenue development",
              "12.3": "Test/Revenue production",
              "12.4": "Simulation development",
              "12.5": "Simulation production",
            "13": "Lane type",
              "13.1": "Select Lane type",
              "13.2": "Debarkation",
              "13.3": "Embarkation",
            "14": "List type",
              "14.1": "Select List type",
              "14.2": "Crew",
              "14.3": "Guest",
            "15": "Cruise Id",
            "16": "Location",
              "16.1": "Select Location",
            "17": "Column header background",
            "18": "Column header text",
            "19": "Column header font",
            "20": "Column header size",
            "m1": "Please provide Source URL.",
            "m2": "Please provide Number of columns.",
            "m3": "Please provide Paging size.",
            "m4": "Please select Environment.",
            "m5": "Please select Lane type.",
            "m6": "Please select List type.",
            "m7": "Please provide Location."
          },
          "vimeo": {
            "1": "Vimeo",
            "2": "Edit Vimeo Widget",
            "3": "Get widget name from Vimeo video",
            "m1": "Subtitles will get displayed with video only if it's available in Vimeo video."
          },
          "verkada": {
            "1": "Verkada",
            "2": "Edit Verkada Widget",
            "3": "Get widget name from verkada",
            "4": "Rotation",
              "4.1": "Auto",
              "4.2": "Custom",
            "5":"Select streaming resolution",
              "5.1": "Low",
              "5.2": "High", 
            "6": "Select streaming type",
              "6.1": "Live",
              "6.2": "Historical",
            "7": "Camera",
              "7.1": "Select camera",
            "8":"Verkada Settings",
              "8.1":"Organisation Id",
              "8.2":"Api key",
            "9":"Site",
            "m1":"All the available cameras loaded.",
            "m2":"Please select a camera.",
            "m3":"Only one hour of historical stream allowed.",
            "m4":"Start time should not be equal to or greater than end time.",
            "m5":"Start time should not be greater than current time.",
            "m6":"Please provide Organization Id.",
            "m7":"Please provide Api Token.",
            "m8":"High resolution stream not supported on SOC",
            "m9":"Verkada settings are not configured for the server."
          },
          "wqMetro": {
            "1": "Wait Queue Metro",
            "2": "Edit Wait Queue Metro",
            "3": "Store id",
            "4": "Customer name text",
            "5": "Customer name font",
            "6": "Customer name size",
            "7": "Wait Queue",
            "8": "Wait Time",
            "9": "Both",
            "m1": "Please provide Store id.",
            "m2": "Please provide Customer name size."
          },
          "weather": {
            "1": "Weather",
            "2": "Edit Weather Widget",
            "3": "Ideal aspect ratio (w:h)",
              "3.1": "For current date",
              "3.2": "5 day forecast",
              "3.3": "4 day forecast including today's temperature details",
            "4": "Ideal aspect ratio for this widget is {{ratio}}. Though, it will fit into any size of frame.",
            "5": "Sample preview",
            "6": "Get widget name from weather city",
            "7": "Foreground color",
            "8": "Display unit",
              "8.1": "Celsius {{deg}}",
              "8.2": "Fahrenheit {{deg}}",
            "9": "Weather image",
              "9.1": "Static",
                "9.1.1": "Plain",
                "9.1.2": "Color {{count}}",
                "9.1.3": "Fill",
              "9.2": "Animated",
                "9.2.1": "Outline",
                "9.2.2": "Cutout",
            "10": "Select city",
            "11": "Device's city",
            "12": "Wind speed unit",
              "12.1": "meters / second",
              "12.2": "miles / hour",
              "12.3": "kilometers / hour",
            "ph": "Type to search city",
            "m1": "City is not correct. Please search again.",
            "m2": "Hub will detect city from device's IP."
          },
          "wc": {
            "1": "Web Cam",
            "2": "Edit Web Cam Widget",
            "3": "Index",
            "4": "Quality",
            "5": "Scale to fill the frame",
            "m1": "Index 0 is the first webcam attached to the device. If you have multiple webcams attached, provide the index of the camera which you want to show with this widget.",
            "m2": "Quality should not be more than 100."
          },
          "wl": {
            "1": "Web Login",
              "1.1": "Web Login Chrome",
            "2": "Edit Web Login Widget",
              "2.1": "Edit Web Login Chrome Widget",
            "3": "",
            "4": "User name identifier",
            "5": "Password",
            "6": "Password identifier",
            "7": "Submit button identifier",
            "8": "Login delay",
            "9": "Redirect URL after login",
            "10": "Class"
          },
          "wp": {
            "1": "Web Page",
            "2": "Edit Web Page Widget",
            "3": "Reload interval",
            "4": "Show Scroll Bar",
            "5": "Container",
              "5.1": "IFrame",
              "5.2": "WebView",
            "6": "Clickable",
              "6.1": "Placeholder",
              "6.2": "Target",
                "6.2.1": "Full Screen",
                "6.2.2": "Self",
            "7": "Test URL on IFrame",
            "m1": "Reload interval should not be less than 10 seconds.",
            "m2": "Reload interval should not be less than 30 seconds.",
            "m3": "Please select placeholder Image.",
            "m4": "X (Left) should not be less than 0.",
            "m5": "Y (Top) should not be less than 0.",
            "m6": "Supported on media players only."
          },
          "xovis": {
            "1": "Xovis 3d Camera",
            "2": "Edit Xovis 3d Camera",
            "3": "Maximum Occupance",
            "4": "Background color",
            "5": "Current occupancy label color",
            "6": "Current occupancy label font",
            "7": "Current occupancy label size",
            "8": "Current occupancy count color",
            "9": "Current occupancy count font",
            "10": "Current occupancy count size",
            "11": "Max occupancy label color",
            "12": "Max occupancy label font",
            "13": "Max occupancy label size",
            "14": "Max occupancy count color",
            "15": "Max occupancy count font",
            "16": "Max occupancy count size",
            "17": "Warning background color",
            "18": "Warning title color",
            "19": "Warning title font",
            "20": "Warning title size",
            "21": "Warning desc color",
            "22": "Warning desc font",
            "23": "Warning desc size",
            "24": "Warning title label",
            "25": "Warning title label color",
            "26": "Warning title label font",
            "27": "Warning title label size",
            "28": "Warning title text",
            "29": "Warning title color",
            "30": "Warning title font",
            "31": "Warning title size",
            "32": "Warning image",
            "33": "Footer text color",
            "34": "Footer text font",
            "35": "Footer text size",
            "36": "Reset Sensor Data",
            "m1": "Are you sure you want to reset the Xovis occupancy data?"
          },
          "yammer": {
            "1": "Microsoft Viva Engage",
            "2": "Edit Microsoft Viva Engage Widget",
            "3": "Get widget name from Microsoft Viva Engage",
            "4": "Authorize Microsoft Viva Engage",
            "5": "Networks",
              "5.1": "Select network",
            "6": "Communities",
              "6.1": "Select community",
            "7": "View",
              "7.1": "Scroll",
              "7.2": "Slideshow",
            "8": "Post background",
            "9": "Header text",
            "10": "Header font",
            "11": "Header size",
            "12": "User name",
            "13": "User font",
            "14": "User size",
            "15": "Date text",
            "16": "Date font",
            "17": "Date size",
            "18": "Description text",
            "19": "Description font",
            "20": "Description size",
            "21": "Likes text",
            "22": "Likes font",
            "23": "Likes size",
            "24": "Post",
            "25": "User",
            "26": "Comments",
            "27": "Comment background",
            "28": "Comment text",
            "29": "Comment font",
            "30": "Comment size",
            "m1": "Please Authorize Microsoft Viva Engage.",
            "m2": "Network not found.",
            "m3": "Please provide Header size.",
            "m4": "Please provide User size.",
            "m5": "Please provide Date size.",
            "m6": "Please provide Description size.",
            "m7": "Please provide Likes size.",
            "m8": "Please provide Comment User size.",
            "m9": "Please provide Comment Date size.",
            "m10": "Please provide Comment size."
          },
          "youTube": {
            "1": "YouTube",
            "2": "Edit YouTube Widget",
            "3": "Get widget name from YouTube video",
            "4": "Video or Playlist id",
            "5": "Enable Subtitles / Closed captions",
            "m1": "Please provide Video or Playlist Id.",
            "m2": "Video Id is not valid.",
            "m3": "Subtitles will get displayed with video only if it's available in YouTube video.",
            "m4": "YouTube videos may play advertisements depending on its policies."
          },
          "zkong": {
            "1": "Zkong",
            "2": "Edit Zkong Widget"
          },
          "prayer": {
            "1": "Prayer",
            "2": "Edit Prayer Widget",
            "3": "Religion",
              "3.1": "Select Religion",
              "3.2": "Islam",
            "4": "Countdown",
            "5": "Method",
              "5.1": "Select Method",
            "m1": "Please provide Religion.",
            "m2": "Please provide Method."
          },
          "grafana": {
            "1": "Grafana Cloud",
            "2": "Grafana Cloud Widget",
            "3": "Get widget name from Grafana Cloud",
            "4": "Authenticate with Grafana Cloud",
            "5": "Grafana Cloud Settings",
              "5.1": "Domain",
              "5.2": "Service account token",
            "6": "Get widget name from Grafana Cloud",
            "m1": "Please provide Domain.",
            "m2": "Please provide Service account token."
          }
        },
        "ai":{
          "1": "Generate Image",
          "2": "Describe your image",
          "3": "Style",
          "4": "Generating Image",
          "5": "AI Image Generation - Pay-Per-Create",
          "6": "Do not ask for this session",
          "7": "Select quality",
          "8": "I agree to pay for the image generation.",
          "m1": "Please provide a description for generating your image.",
          "m2": "Welcome to our AI Image Generation service! Please be aware that each image generation is associated with a charge. Unleash your creativity, but remember that with great art comes a small cost. Every time you hit 'Generate,' a nominal fee will be applied to ensure the continuous enhancement of our AI capabilities and the delivery of top-notch results. Create, innovate, and let your imagination soar, one paid generation at a time!",
          "m3": "Please provide a valid description for generating your image."
        },
        "vi": {
          "1": "Video Indexing",
          "2": "Indexing",
          "3": "Re-Index",
          "4": "Video Indexer",
          "5": "Insights",
          "6": "Closed Captions",
          "7": "Previous",
          "8": "Next",
          "9": "Detected object",
            "9.1": "Detected objects",
          "10": "People",
          "11": "Observed person (preview)",
            "11.1": "Observed persons (preview)",
          "12": "Topic",
            "12.1": "Topics",
          "13": "Keyword",
            "13.1": "Keywords",
          "14": "Label",
            "14.1": "Labels",
          "15": "Named entities",
          "16": "Location",
            "16.1": "Locations",
          "17": "Brand",
            "17.1": "Brands",
          "18": "Emotion",
            "18.1": "Emotions",
          "19": "Sentiment",
            "19.1": "Sentiments",
          "20": "Scene",
            "20.1": "Scenes",
          "21": "Add Language",
          "22": "Added Language",
          "23": "Add More Language",
          "24": "Languages",
          "25": "You have no closed caption",
          "m1": "Are you sure you want to re-index?",
          "m2": "Please wait for the re-indexing.",
          "m3": "Please Provide a text.",
          "m4": "Closed Caption duration should not be greater than video duration",
          "m5": "You need to re-index to add a new language.",
          "m6": "Price per minute 0.19$"
        }
      },
      "t": {
        "tab": {
          "1": "Templates",
          "2": "Unapproved Templates",
          "3": "Incomplete Templates",
          "4": "Library",
          "5": "Feed",
          "6": "Scenes"
        },
        "tool": {
          "1": "What is {{htmlTagO}}Template{{htmlTagC}}?",
          "2": "Watch {{htmlTagO}}Template{{htmlTagC}} video tutorial.",
          "3": "What is {{htmlTagO}}Unapproved Template{{htmlTagC}}?",
          "4": "What is {{htmlTagO}}Incomplete Template{{htmlTagC}}?",
          "5": "What is {{htmlTagO}}Scenes{{htmlTagC}}?"
        },
        "body": {
          "1": "Selected Template",
            "1s": "Selected Templates",
          "2": "Edit Template",
          "3": "Template List",
          "4": "Move Templates",
          "5": "Selected Scene",
            "5s": "Selected Scenes",
          "6": "Target Folder",
          "7": "Templates with schedules",
          "8": "Copy Templates"
        },
        "label": {
          "1": "Template name",
          "2": "Design template",
          "3": "Placeholder",
          "4": "Content of {{frameName}}",
          "5": "Select parent directory",
            "5.1": "Select template parent directory",
          "6": "Template count",
          "7": "Show after",
          "8": "Hide after",
          "9": "Screenshot time",
          "10": "Read local file",
          "11": "Smaller cent value",
          "12": "EPD Authorization",
          "13": "OneDrive Authorization",
          "14": "Click",
          "15": "Download Excel",
          "16": "OneDrive Re-Authorization",
          "17": "Dynamic Text",
          "18": "Dynamic Content",
          "19": "Rectangle",
          "20": "Circle",
          "21": "Template type",
          "22": "Excel Template",
          "23": "Map text with excel sheet",
          "24": "Select sheet",
            "24-1": "Change sheet",
          "25": "Cell number",
          "26": "Sub type",
          "27": "Data Source",
          "28": "Excel",
          "29": "Select excel",
            "29-1": "Change excel",
          "30": "OLO",
          "31": "OLO Settings",
            "31.1": "OLO Key",
          "32": "Store",
            "32.1": "Select Store",
          "33":"Last Sync",
          "34": "No tag color",
          "35": "Allow Multiple Text"
        },
        "btn": {
          "1": "Create New Template",
          "2": "Use Template",
          "3": "Design Template",
          "4": "Edit Dynamic Text",
          "5": "Design Scene"
        },
        "msg": {
          "1": "You don't have any template yet. When you create, they'll appear here.",
          "2": "You don't have any unapproved template.",
          "3": "You don't have any incomplete template.",
          "4": "No template library available.",
          "5": "No template available in this category.",
          "6": "Are you sure you want to unapprove selected Template?",
            "6s": "Are you sure you want to unapprove selected Templates?",
          "7": "Are you sure you want to delete selected Template?",
            "7s": "Are you sure you want to delete selected Templates?",
          "8": "Please provide Template name.",
          "9": "Please provide width and height for this Template.",
          "10": "Are you sure you want to delete selected Placeholder?",
          "11": "Are you sure you want to make a copy of selected Template?",
            "11s": "Are you sure you want to make a copy of selected Templates?",
          "12": "The template will be moved to your {{htmlTagO}}Templates{{htmlTagC}} tab. Then you can assign this template to your devices.",
          "13": "Please select content.",
          "14": "The template does not have any placeholder added yet. A template without any placeholder will be considered as incomplete and you will not be able to scheduled it.",
          "15": "Content / widgets used in this template will be copied in a new folder to your Content Library. Please assign some name to the folder and select it's location in Content Library below:",
          "16": "There are content/widgets used in this template and you are not allowed either to upload content or create widget or create folder, so the files used in the selected template will not be copied. Though, the template will be created.",
            "16-1": "There are content/widgets used in this template and you are not allowed either to upload content or create widget or create folder, so the selected template will not be copied.",
          "17": "Please select parent directory.",
            "17.1": "Please select template parent directory.",
          "18": "Note : For animated dynamic text, right now only Tahoma and Times New Roman fonts are supported.",
          "19": "If enabled, the price will split by decimal, and half of the text field's font size will be applied to the cent value. Ex:",
          "20": "Please follow the below steps to link the template with the excel sheet in your OneDrive:",
          "21": "Are you sure you want to link it with some other sheet?",
            "21-1": "Are you sure you want to link it with some other excel?",
          "22": "Please inseart frame.",
          "23": "You don't have any scenes.",
          "24": "Are you sure you want to delete selected Scene?",
            "24s": "Are you sure you want to delete selected Scenes?",
          "25": "Selected folder does not contain any template to schedule.",
          "26": "You don't have rights to add template in this server.",
          "27": "You don't have rights to create template folder in this server.",
          "28": "Text time duration is greater than same of video.",
          "29": "Hide after duration should not be less than to Show after duration.",
          "31": "Please select sheet.",
          "32": "Please provide Cell number.",
          "33": "Please select OneDrive content.",
          "34": "Invalid Cell number.",
          "35": "Number of columns must be less than 1000.",
          "36": "Excel sheet is not accessible to you.",
          "37": "Please provide OLO Key.",
          "38": "Please select the Store.",
          "39": "Attention: If you change the store, please be aware that it may affect the currently selected data. Consider updating the data accordingly to match the new store selection.",
          "40": "Rotating a video is not supported on SoC TVs.",
          "41": "This functionality requires a permission you currently don't have. When using a template, the associated content is automatically copied to the Content Library. However, you don't have the required permission to add content to the Content Library.",
          "42": "Your OneDrive authorization has expired. Reauthorize your OneDrive account to resume Excel spreadsheet syncing.",
          "43": "Some text is still in edit mode. Please complete or cancel the edits before saving.",
          "44": "Text should not be empty."
        },
        "info": {
          "t1": "The purpose of template is to allow users to quickly change some small part of content they wish to display on a screen. For example, let’s say that this digital signage system needs to be used at a coffee shop. The coffee shop has daily specials that they wish to update in the morning. The coffee can use templates to create a design for the daily special display and define the area where the price goes as a changeable field. This template can be opened in the morning every day to change just the price, then save the template. This way the price can be changed without recreating the entire design every time.",
          "ut1": "Templates created by a user, which is not having \"approval\" permission, are categorized as \"Unapproved Templates\". These templates can not be scheduled until it's approved by admin or a user with approval rights.",
          "it1": "If there is not any placeholder in the template, it's considered as incomplete and moved to Incomplete Template tab."
        },
        "step": {
          "1": "Upload the downloaded excel sheet to your OneDrive.",
          "2": "Edit the Template and authorize your OneDrive account.",
          "3": "Once authorized, select the excel file from your OneDrive and save the Template.",
          "other":"You can also use the menu board portal for updating the text."
        }
      },
      "s": {
        "tab": {
          "1": "Schedules",
          "2": "Unapproved Schedules",
          "3": "Incomplete Schedules",
          "4": "Expired Schedules"
        },
        "tool": {
          "1": "What is {{htmlTagO}}Schedule{{htmlTagC}}?",
          "2": "Watch {{htmlTagO}}Schedule{{htmlTagC}} video tutorial.",
          "3": "What is {{htmlTagO}}Unapproved Schedule{{htmlTagC}}?",
          "4": "What is {{htmlTagO}}Incomplete Schedule{{htmlTagC}}?",
          "5": "What is {{htmlTagO}}Expired Schedule{{htmlTagC}}?",
          "6": "Music Choice widget is allowed to be scheduled for full day or daily schedule only.",
          "7": "Zkong widget is allowed to be scheduled for full day or daily schedule only.",
          "8": "Warning: Possible Issues Detected",
          "9": "Content Dimensions Mismatched with Frame"
        },
        "body": {
          "1": "Schedule name",
          "2": "Content list in schedule",
          "3": "Assignment Date range",
          "4": "Frame",
          "5": "Update Schedule Group",
          "6": "Priority",
          "7": "Schedule Type",
          "8": "Scheduled"
        },
        "brief": {
          "1": "Selected Schedule",
            "1s": "Selected Schedules",
          "2": "Full day"
        },
        "btn": {
          "1": "Create New Schedule",
          "2": "Create Schedule Group",
          "3": "Assign to Group",
          "4": "Add Exception Dates",
          "5": "click here."
        },
        "msg": {
          "1": "You don't have any schedule yet. When you create some, they'll appear here.",
          "2": "You don't have any unapproved schedule.",
          "3": "You don't have any incomplete schedule.",
          "4": "You don't have any expired schedule.",
          "5": "No schedules under this group.",
          "6": "Are you sure you want to unapprove selected schedule?",
            "6s": "Are you sure you want to unapprove selected schedules?",
          "7": "Are you sure you want to delete selected schedule?",
            "7s": "Are you sure you want to delete selected schedules?",
          "8": "Are you sure you want to delete selected schedule group?",
          "9": "Schedules associated with this group will not be deleted, you will have to delete them separately.",
          "10": "Following schedules can not be approved because schedule does not contain the matching permission with their schedule group.",
          "11": "The selected content doesn't match the frame's dimensions. This may cause the content not to fit perfectly within frame and show blank gaps (either on top/bottom or left/right). For more information,",
          "12": "The warning icon appears due to the following reasons:",
          "13": "The Frame on which the Schedule was assigned is deleted.",
            "13.1": "{{htmlTagO}}Resolution:{{htmlTagC}} Reassign a frame using the last step of the Schedule wizard.",
          "14": "Frame Layout Assignment is expired on at least one of the selected devices.",
            "14.1": "{{htmlTagO}}Resolution:{{htmlTagC}} Verify the end date of the frame layout assignment.",
          "15": "Thank you for your attention. If you need further assistance, please don't hesitate to reach us at {{htmlTagO}}support@LSquared.com{{htmlTagC}}.",
          "16": "What could happen if the selected content doesn't match the frame's dimensions?",
            "16.1": "If the selected content doesn't match the frame's dimensions or aspect ratio, the L\u00A0Squared Slide app resizes the content proportionately to fit it within the selected frame. However, this could result in imperfect fitting and blank gaps on the top/bottom or left/right. Check out the examples below for a better understanding:",
            "16.2": "Thank you for your attention. If you need further assistance, please don't hesitate to reach us at {{htmlTagO}}support@LSquared.com{{htmlTagC}}.",
          "18": "If you cancel the process, the changes that you made will not be saved. Are you sure you want to cancel the changes?"
        },
        "p_sg": {
          "1": "Schedule group name",
          "m1": "Please provide Schedule group name.",
          "m2": "Schedule group name already exists.",
          "m3": "New permission can not be applied on the group because the schedules within this group is not having same permission you selected.",
          "m4": "Please change the permission of following schedules first:"
        },
        "p_s": {
          "body": {
            "1": "Edit Schedule",
            "2": "Selected Content/Templates",
            "3": "Select frame",
            "4": "You do not have permission to schedule content to this frame.",
            "5": "Selected Devices/Groups/Tags",
            "6": "Conflict List"
          },
          "btn": {
            "1": "Let Me Rectify",
            "2": "Ok, I'll do it later",
            "3": "Save it anyway!",
            "4": "Save as Group",
            "5": "Dates Preview",
            "6": "Applied Device List",
            "7": "Confirm"
          },
          "label": {
            "1": "Select schedule group",
              "1.1": "No group",
            "2": "Schedule will inherit the selected group's permissions.",
              "2.1": "Schedule Groups",
            "3": "Run at all available times",
            "4": "Custom time",
              "4.1": "Daily",
              "4.2": "Weekly",
                "4.2.0": "Sunday",
                "4.2.1": "Monday",
                "4.2.2": "Tuesday",
                "4.2.3": "Wednesday",
                "4.2.4": "Thursday",
                "4.2.5": "Friday",
                "4.2.6": "Saturday",
                "4.2.7": "Sunday",
              "4.3": "Monthly",
              "4.4": "Days interval",
                "4.4.1": "Custom Repeat",
              "4.5": "Exclude date range",
            "5": "Custom Timings",
            "6": "Frequency",
            "7": "Day",
            "8": "Repeat every n{{htmlTagO}}th{{htmlTagC}} day",
            "9": "Select layer",
            "10": "Assignment Range",
            "11": "Months",
              "11.0": "January",
              "11.1": "February",
              "11.2": "March",
              "11.3": "April",
              "11.4": "May",
              "11.5": "June",
              "11.6": "July",
              "11.7": "August",
              "11.8": "September",
              "11.9": "October",
              "11.10": "November",
              "11.11": "December",
            "12": "Schedule priority",
            "13": "Normal",
            "14": "Lock screen",
            "15": "Corporate communication",
            "16": "Custom Dates",
            "17": "Selected by",
            "18": "Applied Tag",
            "19": "Reason of conflict",
            "20": "Individual",
            "21": "Override Schedule",
            "22": "Regular",
            "23": "Content dimension",
            "24": "Frame dimension"
          },
          "msg": {
            "1": "Please provide Schedule name.",
            "2": "Please select at least one Content/Template.",
            "3": "Please add a custom time range.",
            "4": "Day/Date must be between 1 and 365.",
            "5": "Please add custom timing for the schedule.",
            "6": "No Frame layout selected.",
            "7": "There is a restricted folder conflict between selected devices. Please create separate schedules for following assignments",
            "8": "The schedule contains more than maximum allowed content duration for this frame.",
              "8.1": "Remaining",
            "9": "The schedule contains more than maximum allowed content count for this frame.",
            "10": "Only the content from following folder can be assigned to this frame.",
              "10.1": "Allowed folder",
            "11": "There are content assigned to this schedule which are not accessible to you. You can proceed without selecting new content.",
            "12": "This device does not have a frame layout assigned in the selected time range.",
            "13": "This group contains at least one device on which there is not any frame layout assigned or not having a frame layout assigned in the schedule's date range.",
            "14": "There are devices/groups assigned to this schedule which are not accessible to you. You can proceed without selecting new device/group.",
            "15": "There is not any accessible frame layout available for you. You will be auto redirected to schedule page in {{counter}} seconds.",
            "16": "Please select Frame for each Frame Layout.",
            "17": "The schedule will go to \"Incomplete Schedules\" tab because there is not any active content selected in this schedule.",
            "18": "The schedule will go to \"Incomplete Schedules\" tab because selected device's frame layout assignment is not in this schedule's date range.",
            "19": "The schedule will go to \"Expired Schedules\" tab because the date range you selected is already expired.",
            "20": "The schedule will go to \"Incomplete Schedules\" tab because all selected device's target frame is not selected.",
            "21": "The schedule will go to \"Incomplete Schedules\" tab, because following device's target frame is not selected.",
            "22": "The schedule has been saved. Though, this schedule is not applied on following devices because their frame layout assignment is not in this schedule's date range.",
            "23": "Current schedule's date range",
            "24": "You don't have permission to create Schedule group.",
            "25": "This tag either does not have any device assigned or one of it's device does not have frame layout in schedule's date range.",
            "26": "Schedule marked as \"Forever\" will be applied on devices for 100 years.",
            "27": "Please create schedule group first.",
            "28": "Please select schedule group.",
            "29": "Please select a group on first step and proceed.",
            "30": "Music Widgets can only be scheduled into a music player therefore you cannot have Music Widget and other content in the same schedule.",
            "31": "Music Widgets can only be scheduled into a music player therefore you cannot have Music Player and other device in the same schedule.",
            "32": "Only \"full day\" or \"daily\" schedules are allowed for music choice device.",
            "33": "This group does not have any device.",
            "34": "This search either does not have any device assigned or one of it's device does not have frame layout in schedule's date range.",
            "35": "This search does not have any device.",
            "36": "The group, to which selected schedules has been assigned, does not contain the matching permission. Selected schedules can not be saved.",
            "37": "Schedule priority should not be more than 99999999.",
              "37.1": "Please provide schedule priority. (It should be more than 0)",
            "38": "No possible date found between the selected Date range and Custom Timings.",
            "39": "Only images are allowed to a lock screen type schedule.",
            "40": "Please select at least one Content.",
            "41": "Only CorpComm: Alert Message & survey widget are allowed to a corporate communication type schedule.",
            "42": "Please add a custom date range.",
            "43": "Please add custom dates for the schedule.",
            "44": "Start and end dates should not be overlapping.",
            "45": "Exclude date range should be in between date range.",
            "46": "Schedule can't save when there are EPD Device with some other device types.",
            "47": "If schedule is of EPD type then schedule's schedule must be NonCustom or Daily (if Custom) only.",
            "48": "EPD Device doesn't exist.",
            "49": "Content already exist.",
            "50": "If schedule is of EPD type then only image, EPD template and one page ppt content is allowed.",
              "50.1": "If schedule is of EPD type then only EPD template is allowed.",
            "51": "Only content on demand widgets are allowed to a content on demand type schedule.",
            "52": "Content on demand widgets are allowed to a content on demand type schedule only.",
            "53": "Content group widget are not allowed to be added to any schedule directly.",
            "54": "Start and end time should not be overlapping.",
            "55": "The following saved search conflicted with the devices.",
            "56": "No assignable device was left because of excluded tags in the saved search.",
            "58": "Only one content can be scheduled for epd type.",
              "58.1": "Only one EPD template can be scheduled for EPD type.",
            "59": "There are some conflicts in the selected device/groups/tags. Because of those conflicts, following devices will get removed from the schedule:",
              "59-1": "The selected device is already part of another EPD type schedule. EPD type devices can only be assigned to one EPD type schedule at a time and cannot be selected in multiple schedules.",
              "59-2": "The Tag contains EPD type devices, which can only be scheduled using EPD type schedules.",
              "59-3": "The Tag contains EPD type devices, which have already been scheduled using the EPD type schedule.",
              "59-4": "This Tag does not include any EPD type devices. Therefore, scheduling is limited to non EPD type schedules only.",
              "59-5": "The Group contains EPD type devices, which can only be scheduled using EPD type schedules.",
              "59-6": "The Group contains EPD type devices, which have already been scheduled using the EPD type schedule.",
              "59-7": "This Group does not include any EPD type devices. Therefore, scheduling is limited to non EPD type schedules only.",
            "69": "Some of the items you have selected are deleted/archived while you were in schedule process. Those content will be excluded from this schedule.",
            "70": "Only content are allowed to a override type schedule.",
            "71": "Scheduling a new content from third party folder needs \"Content Approval\" permissions.",
            "72": "Templates cannot be assigned with override schedules."
          }
        },
        "p_ag": {
          "1": "Assign to",
          "m1": "Schedule can be assigned either to a public group or a group which is having selected schedule's all permissions.",
          "m2": "The schedule group does not exists. Following user has removed it from your server: {{uName}}"
        },
        "p_as": {
          "1": "Schedule name",
          "2": "Restriction on frame",
          "m1": "There are some restrictions with frame on which the selected schedules are assigned. Selected items can not be assigned to those schedules. Below is the list of such schedules with the restriction details:"
        },
        "p_ex": {
          "1": "Exception Date",
          "2": "Exception date range",
          "m1": "Exception date range should be in between date range.",
          "m2": "Exception start and end dates should not be overlapping."
        },
        "info": {
          "s1": "Schedules are basically the rules by which content is displayed on the screen.  A schedule will define which content from the content library to display on which screens, at which time and for how long.",
          "us1": "Schedules created by a user, which is not having \"approval\" permission, are categorized as \"Unapproved Schedules\". These schedules will not be visible on Devices until it's approved by admin or a user with approval rights.",
          "is1": "There are five steps of a schedule. If any of the step is not attended, or, becomes incomplete because of some user action (like deletion of content of device which was associated with the schedule) then the schedule becomes Incomplete and moved to the Incomplete Schedule tab.",
          "es1": "Schedules which date range expires, becomes expired and moved to Expired Schedules tab.",
          "isV1": "Introduction to Scheduling",
          "ps1": "Warning info"
        }
      },
      "fl": {
        "tab": {
          "1": "Frame Layouts",
          "2": "Frame Layout Assignments",
          "3": "Unapproved Frame Layouts",
          "4": "Incomplete Frame Layouts",
          "5": "Library"
        },
        "tool": {
          "1": "What is {{htmlTagO}}Frame Layout{{htmlTagC}}?",
          "2": "Watch {{htmlTagO}}Frame Layout{{htmlTagC}} video tutorial.",
          "3": "What is {{htmlTagO}}Frame Layout Assignment{{htmlTagC}}?",
          "4": "What is {{htmlTagO}}Unapproved Frame Layout{{htmlTagC}}?",
          "5": "What is {{htmlTagO}}Incomplete Frame Layout{{htmlTagC}}?",
          "6": "Expired assignment"
        },
        "btn": {
          "1": "Create New Frame Layout",
          "2": "Add Frame",
          "3": "Name & Resolution",
          "4": "Frame Layout Design",
          "5": "Assign",
          "7": "Schedule",
          "8": "Frame Threshold",
          "11": "Delete Category",
          "12": "Use Frame Layout",
          "13": "Threshold and Restrictions",
          "14": "Frame Threshold",
          "15": "Restrictions"
        },
        "brief": {
          "1": "Selected Frame Layout",
            "1s": "Selected Frame Layouts",
          "2": "Selected Frame Layout Assignment",
            "2s": "Selected Frame Layout Assignments",
          "3": "Assignments",
          "4": "Frame layout name",
          "5": "Frame count",
          "6": "Usage count",
          "7": "Frame layout count"
        },
        "label": {
          "1": "Assignment List",
          "2": "Copy Frame Layouts"
        },
        "body": {
          "1": "This process can not be done.",
          "2": "Frame layouts with assignment",
          "3": "Frame layout",
          "4": "Assignment",
          "5": "Edit Frame Layout"
        },
        "msg": {
          "1": "You don't have any frame layout yet. When you create some, they'll appear here.",
          "2": "You don't have any frame layout assignment yet.",
          "3": "You don't have any unapproved frame layout.",
          "4": "You don't have any incomplete frame layout.",
          "5": "No frame layout library available.",
          "6": "No frame layout available in this category.",
          "7": "Are you sure you want to make a copy of selected Frame Layout?",
            "7s": "Are you sure you want to make a copy of selected Frame Layouts?",
          "8": "Are you sure you want to unapprove selected Frame Layout?",
            "8s": "Are you sure you want to unapprove selected Frame Layouts?",
          "9": "Are you sure you want to delete selected Frame Layout?",
            "9s": "Are you sure you want to delete selected Frame Layouts?",
          "10": "Selected frame layout is assigned to some device. You can not unapprove an assigned frame layout. Please delete the assignment first.",
            "10s": "Selected frame layouts are assigned to some devices. You can not unapprove an assigned frame layout. Please delete the assignments first.",
          "11": "Selected frame layout is assigned to some device. You can not delete an assigned frame layout. Please delete the assignment first.",
            "11s": "Selected frame layouts are assigned to some devices. You can not delete an assigned frame layout. Please delete the assignments first.",
          "12": "The frame layout will be moved to your {{htmlTagO}}Frame Layouts{{htmlTagC}} tab. Then you can assign this frame layout to your devices. Are you sure you want to use this frame layout?",
            "12s": "The frame layouts will be moved to your {{htmlTagO}}Frame Layouts{{htmlTagC}} tab. Then you can assign these frame layouts to your devices. Are you sure you want to use these frame layouts?",
          "13": "Selected frame layout assignment can not be approved because one of it's device has a new assignment on same date range.",
          "14": "Are you sure you want to delete selected Frame Layout Assignment?",
            "14s": "Are you sure you want to delete selected Frame Layout Assignments?",
          "15": "Are you sure you want to unapprove selected Frame Layout Assignment?",
            "15s": "Are you sure you want to unapprove selected Frame Layout Assignments?",
          "16": "Are you sure you want to delete the category?",
          "17": "Selected frame layout is assigned to some device. You can not move an assigned frame layout. Please delete the assignment first.",
            "17s": "Selected frame layouts are assigned to some devices. You can not move an assigned frame layout. Please delete the assignments first."
        },
        "p_cfl": {
          "tab": {
            "1": "Frame Info",
            "2": "Layers"
          },
          "label": {
            "1": "Select orientation",
              "1.1": "Landscape",
              "1.2": "Portrait",
            "2": "Select resolution",
              "2.1": "WxH",
            "3": "Add to library",
            "4": "Select category",
            "5": "New category name",
            "6": "Design frame layout",
            "7": "Snap to Grid",
            "8": "X (Left)",
            "9": "Y (Top)",
            "10": "Fill mode",
            "11": "Fit",
            "12": "Stretch",
            "13": "Crop",
            "14": "Help?",
            "15": "Layout Background",
            "17": "Ok, Don't Save!",
            "18": "Save It Anyway!",
            "19": "Set default",
            "20": "Top",
            "21": "Middle",
            "22": "Bottom",
            "23": "Auto fit",
            "24": "Animated text on video",
            "25": "Tile Layout",
              "25.1": "Select tile type",
            "26": "Dynamic text on video",
            "27": "Border radius",
            "28": "Inner Shadow",
            "29": "Horizontal Length",
            "30": "Vertical Length",
            "31": "Blur Radius",
            "32": "Spread Radius",
            "33": "Shadow Color"
          },
          "msg": {
            "1": "Please provide Frame Layout name.",
            "2": "Please provide valid resolution of the Frame Layout.",
            "3": "Please select category, or provide new category name.",
            "4": "Category name already exists.",
            "5": "Are you sure you want to delete selected Frame?",
            "6": "Please select a frame to see it's details.",
            "7": "This item is public. You can not change permission of a public item.",
            "8": "You don't have permission to change this frame.",
            "9": "The frame layout does not have any frame added yet. A frame layout without any frame will be considered as incomplete and you will not be able to assign it to any device.",
            "10": "You are not allowed to create frame layout larger than 1080p (1920x1080). Please contact your L Squared Customer Support team:",
            "11": "With the current plan, you are not allowed to create multi-frame layout. Please contact your L Squared Customer Support team:",
            "12": "Please select Tile type.",
            "13": "You don't have created any tile layout template yet.",
            "14": "With the current plan, you are not allowed to add frame layout on other server. Please contact your L Squared Customer Support team:"
          }
        },
        "p_assign": {
          "body": {
            "1": "Assign name",
            "2": "Assign threshold and restrictions",
              "2.1": "Assign threshold",
              "2.2": "Assign restrictions",
            "3": "Frame name",
            "4": "Loop Threshold",
              "4.1": "This will be used for \"Content Saturation\" report.",
            "5": "Content Duration",
            "6": "Content Count",
            "7": "Content folder",
            "8": "User groups",
            "9": "All Folders",
            "10": "Select Folder",
            "11": "Select",
            "12": "Assign name and resolution"
          },
          "label": {
            "1": "Assignment period"
          },
          "ph": {
            "1": "Enter layout assignment name"
          },
          "msg": {
            "1": "Please provide Frame Layout Assignment name.",
            "2": "Please provide date range.",
            "3": "Device(s) are not free in this time slot.",
            "4": "This device already has a layout assigned in selected time range.",
            "5": "There are devices/groups assigned to this assignment which are not accessible to you. You can proceed without selecting new device/group.",
            "6": "Either this device group does not have any device in it, Or, it contains a device which already has a layout assigned in selected time range.",
            "7": "You don't have any folder.",
            "8": "Frame layout assignments marked as \"Forever\" will be applied on devices for 100 years.",
            "9": "You can not assign frame layouts bigger than 1080p (1920x1080) to your device. Please contact",
              "9.1": "for the same.",
            "10": "You can not assign frame layouts bigger than 1080p (1920x1080) to your device.",
            "11": "You can not assign multiple frame layout.",
            "12": "You can not assign multi-frame layout to the devices. Please contact"
          }
        },
        "p_group": {
          "1": "Select User Groups",
          "2": "Selected Group",
          "2s": "Selected Groups",
          "m1": "You don't have any user group."
        },
        "info": {
          "fl1": "Frame layouts are just a set of designs that define how to particular screen is divided so that a screen can be used to display unique content in each area. In each layout, the screen is divided into frames.  Each frame can have independent schedules so each frame can display unique content.",
          "fla1": "Assigning the frame layout on a device for a particular date range is Frame Layout Assignment. The screen is divided into associated frame layout's frames for that time period.",
          "ufl1": "Frame Layouts created by a user, which is not having \"approval\" permission, are categorized as \"Unapproved Frame Layouts\". These Frame Layouts can not be assigned on Devices until it's approved by admin or a user with approval rights.",
          "ifl1": "If there is not any frame in the frame layout, its considered as incomplete and moved to Incomplete Frame Layouts tab.",
          "v1": "Introduction to Frames"
        }
      },
      "d": {
        "tab": {
          "1": "Devices",
          "2": "Groups",
          "3": "Tags",
          "4": "Identify",
          "5": "Saved Search",
          "6": "Actions",
            "6.1": "Identify Request",
            "6.2": "TV Settings",
              "6.2.1": "Import TV Settings",
            "6.3": "Other Info",
            "6.5": "Tags Info",
            "6.6": "Auto Registration",
            "6.8": "Properties",
          "8": "Lock Screen",
          "9": "On/Off Schedule",
          "10": "Data Usage",
          "11": "Watermark",
            "11.1": "Watermark image",
            "11.2": "Position of the image on the screen",
            "11.3": "Keep-Alive-Until date",
            "11.4": "Alignment",
            "11.5": "Custom position",
            "11.6": "Watermarks",
            "11.7": "Watermark settings",
          "12": "Edit Devices"
        },
        "tool": {
          "1": "Online",
          "2": "Offline",
          "3": "How to add a {{htmlTagO}}Device{{htmlTagC}}?",
          "4": "Watch {{htmlTagO}}Device{{htmlTagC}} video tutorial.",
          "5": "What is {{htmlTagO}}Device Group{{htmlTagC}}?",
          "6": "What is {{htmlTagO}}Device Tag{{htmlTagC}}?",
          "7": "Delete Tags",
          "8": "Slide",
            "8.1": "Slide version not latest",
          "9": "Watcher",
            "9.1": "Watcher version not latest",
          "10": "Low disk space",
          "11": "Delete History",
          "12": "Show Download",
          "13": "Frame layout larger than 1920x1080.",
          "14": "Download List",
          "15": "New device",
          "16": "Device changed",
          "17": "Copy",
            "17.1": "Copied",
          "18": "Changes History",
          "19": "Active",
          "20": "Inactive",
          "21": "Never Connected",
          "22": "What is {{htmlTagO}}Video Wall{{htmlTagC}}?",
          "23": "Total Devices",
          "24": "Total\u00A0Online\u00A0Devices",
          "25": "Total\u00A0Offline\u00A0Devices",
          "26": "Total\u00A0Filtered\u00A0Devices"
        },
        "body": {
          "1": "{{reman}} Licenses available",
          "2": "Edit Device",
          "3": "Frame Layout Assignments",
          "4": "Frame Layout Library",
          "5": "What are tags?",
          "6": "Content list scheduled on device",
          "7": "Frame Layout List",
          "8": "Tag List",
          "9": "Device Logs",
          "10": "Last Ping",
          "11": "Download Device Log",
          "12": "Selected device / tag",
          "13": "Sent on",
          "14": "Downloaded on device",
            "14.1": "Downloaded on",
          "15": "Cell",
            "15.1": "Select cell",
          "16": "Disk usage",
            "16.1": "Used",
            "16.2": "Total",
          "17": "Disk",
          "18": "Greater than allowed size: {{size}} MB"
        },
        "btn": {
          "1": "Add New Device",
          "2": "Create New Group",
          "3": "Create New Tag",
          "4": "Assign Name",
          "5": "Assign Frame Layout",
          "6": "Assign Tags",
          "7": "Preview",
          "8": "Play List",
          "9": "Select frame layout / assignment",
          "10": "Select Similar Devices",
          "11": "Device Preview",
          "12": "Update Screenshot",
          "13": "Select Devices / Tags",
          "14": "View Settings",
          "15": "Assign Tags",
          "16": "Remove Tags",
          "17": "Select Lock Screen",
          "18": "Download Information",
          "19": "Download Tags",
          "20": "Download TV Settings",
          "23": "Download Properties",
          "24": "Generate Sheet",
          "25": "Download On/Off Schedule",
          "26": "Download Data Usage",
          "27": "Execute",
          "28": "Download Watermark",
          "29": "Show all tags",
          "30": "View Details",
          "31": "Create New Video Wall",
          "33": "More info"
        },
        "brief": {
          "1": "Selected Device Group",
            "1s": "Selected Device Groups",
          "2": "Screen resolution",
          "3": "Client auto update",
          "4": "Offline reboot",
            "4.1": "If this setting is turned on, device will reboot if it's offline for 1 hour.",
          "5": "Logs",
          "6": "Tags",
          "7": "Adapters",
          "8": "Id",
          "9": "Client",
          "10": "Status",
          "11": "IP",
            "11.1": "Local IP",
            "11.2": "Public IP",
          "12": "Data usage",
          "13": "Device control",
          "14": "LAN accessible",
          "15": "Mac",
          "16": "Computer name",
            "16.1": "Hostname",
          "17": "Screen Capture Off",
          "18": "Last updated on",
          "19": "Configuration",
          "20": "Selected Saved Search",
          "21": "Selected Device Tag",
            "21s": "Selected Device Tags",
          "22": "Selected Device Type",
          "23": "System",
          "24": "Ticket",
            "24s": "Tickets",
            "24.1": "Support tickets",
          "25": "Power history",
          "26": "Execute RS232 Command",
          "27": "Selected Folder",
          "28": "Selected Video Wall",
            "28s": "Selected Video Walls",
          "29": "Client release is being controlled by {{htmlTagO}} Support. Please contact your {{htmlTagO}} representative.",
          "30": "If enabled, the client release will be controlled by {{htmlTagO}} Support."
        },
        "label": {
          "1": "Device type",
            "1.1": "Media Player",
            "1.2": "Geo Fence",
            "1.3": "Virtual Device",
            "1.4": "Music Player",
            "1.5": "LG WebOS",
            "1.6": "Samsung Tizen",
            "1.7": "Desktop",
            "1.8": "EPD",
          "2": "Device Id",
            "2.1": "Device Id (key)",
            "2.2": "Alphabets, numbers, dash and colon are accepted",
            "2.3": "Barcode",
          "3": "Add new tag",
          "4": "Tag name",
          "5": "Available tag",
            "5s": "Available tags",
          "6": "Assigned tag",
            "6s": "Assigned tags",
          "7": "Save Search",
          "8": "Searches List",
          "9": "Other Info",
            "9.1": "Select other info",
          "10": "Label",
          "11": "Value",
          "12": "Target device",
          "13": "Select source device",
          "14": "Select target devices",
          "15": "Text Info",
          "16": "File Attachment",
          "17": "Timezone Name",
          "18": "Resolution",
          "19": "Client Version",
          "20": "Backlight On Hours",
          "21": "Display On Hours",
          "22": "Select frame layout",
          "23": "Canada Province Timezone",
          "24": "Site Identifier",
          "25": "Zkong stores",
            "25.1": "Select store",
          "26": "Dpi",
            "26.1": "Select Dpi",
          "27": "Reason for change",
            "27.1": "Select reason",
            "27.2": "TV / Media Player changed",
            "27.3": "NIC changed",
          "28": "Controls",
          "29": "Current Folder Only",
          "30": "Including Child Folders",
          "31": "Folder Path",
          "32": "Folders",
          "33": "Device User Group",
          "34": "Check access for the user",
          "35": "User Group Name",
          "36": "User Group List",
          "37": "Accessible",
          "38": "Not Accessible",
          "39": "Completed on",
          "40": "Failed",
          "41": "Task List",
          "42": "Assignable Tags",
          "43": "Removable Tags",
          "44": "Select property",
          "45": "Property and value",
          "46": "Name / Id",
          "47": "Tag Color",
          "48": "Device views",
            "48.1": "Show folders in device list in Device tab",
            "48.2": "Show folders in device list in other places",
              "48.2.1": "(Schedule wizard, Frame layout assignment, Tags, Device Group, Reports etc)",
            "48.3": "Show \"Tags\" as first tab",
          "49": "Date/Time",
          "50": "Add Text Info",
          "51": "Add File Attachment",
          "52": "Add Date/Time",
          "53": "First Ping",
          "54": "Completed Assignment",
            "54s": "Completed Assignments",
          "55": "Pending Assignment",
            "55s": "Pending Assignments",
          "56": "Failed Assignment",
            "56s": "Failed Assignments",
          "57": "Future Content",
          "58": "License Id",
            "58.1": "Please select license",
            "58.2": "License type",
          "59": "(comma-separated)",
          "60": "or",
          "62": "Video Wall",
          "62.1": "Video wall name",
          "63": "Assign video wall",
          "64": "Rows",
          "65": "Columns",
          "66": "Wall preview",
          "67": "Cell Name",
          "68": "License Type",
          "69": "License Info",
            "69.1": "Allotted on",
            "69.2": "Billing cycle",
            "69.3": "Billing start date",
            "69.4": "Currency",
            "69.5": "Billing email",
            "69.6": "Go-Live date",
          "70": "Updating Tag",
          "71": "Cost Center",
          "72": "EPD Model",
            "72-1": "Please select model",
            "72-2": "Please select the EPD model."
        },
        "ph": {
          "1": "Assign a meaningful name to the device",
          "2": "Assign a meaningful name to the group",
          "3": "Downloaded {{no}}%",
          "4": "Assign a meaningful name to the tag",
          "5": "Assign a meaningful name to the video wall"
        },
        "p_dc": {
          "1": "Reboot device",
          "2": "Last reboot requested on",
          "3": "Reboot acknowledged on",
          "4": "Waiting for reboot.",
          "5": "Reboot",
          "6":"Relaunch",
            "6.1": "Waiting for relaunch.",
          "7":"Waiting for download.",
          "8": "Relaunch app",
            "8.1": "Last relaunch requested on",
            "8.2": "Relaunch acknowledged on",
          "9":"Fresh download",
            "9.1":"Last download requested on",
            "9.2":"Download acknowledged on",
          "10": "Transition between content",
            "10.1": "Fade In/Out",
            "10.2": "None",
          "11": "Client display on top most",
          "12": "Turn off Device/Screen",
          "13": "TV Settings",
          "14": "Playback device",
            "14.1": "Select playback device",
            "14.2":"Last change requested on",
            "14.3":"Change acknowledged on",
            "14.4":"Waiting for change.",
          "15": "Already requested",
          "16": "Already used",
          "17": "TV Settings",
          "18": "EPD Settings",
          "19": "Daily reboot",
    
          "m1": "Are you sure you want to reboot device?",
          "m2": "Are you sure you want to relaunch the app?",
          "m3": "This action will remove all downloaded content from device and will initiate fresh download. Are you sure you want to start fresh download?",
          "m4": "Music Player is a third party device. It can not be controlled from Hub.",
          "m5": "Are you sure you want to change transition between content?",
          "m6": "Are you sure you want to change playback device?",
          "m7": "Are you sure you want to change daily reboot?",
          "m8": "Are you sure you want to change Idle Time and Password?",
          "wos":{
            "1": "Following settings will get applied to WebOS Signage only.",
            "2": "General Settings",
            "3": "Language",
              "3.1": "Menu language",
              "3.2": "Keyboard languages",
            "4": "System Information",
              "4.1": "Smart energy savings",
            "5": "Time & Date",
              "5.1": "Set automatically",
              "5.2.1": "Time",
              "5.2.2": "Date",
              "5.4": "Time Zone",
                "5.4.1": "Continent",
                "5.4.2": "Country/Territory",
                "5.4.3": "City",
            "6": "NTP Server",
              "6.1": "Default NTP server",
              "6.2": "IPv4 or IPv6 or URL",
            "7": "Power",
              "7.1": "No signal power off",
              "7.2": "No IR power off",
              "7.3": "DPM",
              "7.4": "DPM wake up control",
              "7.5": "PM mode",
              "7.6": "Power on delay",
              "7.7": "Power on status",
              "7.8": "Wake on LAN wired",
              "7.9": "Wake on LAN wireless",
            "8": "Network",
              "8.1": "For DSL / LAN Sites",
                "8.1.1": "Wired connection (Ethernet) set automatically",
              "8.2": "For CPC retail cell sites",
                "8.2.1": "IP",
                "8.2.2": "Subnet Mask",
                "8.2.3": "Gateway",
                "8.2.4": "DNS",
            "9": "Advanced Settings",
              "9.1": "Beacon",
              "9.2": "TV On/Off Timer",
              "9.3": "Turn On time",
              "9.4": "Turn Off time",
            "10": "Admin Settings",
              "10.1": "Home dashboard lock",
              "10.2": "USB lock",
              "10.3": "OSD lock",
              "10.4": "IR operation lock",
              "10.5": "Local key operation lock",
              "10.6": "Wi-Fi lock",
              "10.7": "Screen share lock",
            "11": "Network Settings",
              "11.1": "Blocked ports",
              "11.1.1": "Max 30 ports can be blocked.",
              "11.1.2": "Port",
              "11.1.3": "Direction",
                "11.1.3.1": "In",
                "11.1.3.2": "Out",
                "11.1.3.3": "All",
              "11.1.4": "Protocol",
            "12": "Firmware",
              "12.1": "Upgrade / Downgrade to",
              "12.2": "Select firmware",
              "12.3": "Upgrade",
              "12.4": "Firmware update requested on",
              "12.5": "Firmware update acknowledged on",
              "12.6": "Downgrade",
              "12.7": "Model",
              "12.8": "I Understand, Push the Firmware",
            "13": "Apply Mon - Fri",
            "14": "Apply to All",
            "15": "Apply Sat - Sun",
    
            "m1": "Please provide Country/Territory.",
            "m2": "No Blocked ports found.",
            "m3": "Please provide port.",
            "m4": "Blocked port is already exists.",
            "m5": "Please save the port first.",
            "m6": "Please select firmware.",
            "m7": "Selected firmware is already installed on TV. Please select different version.",
            "m8": "Firmware update instructions has been saved. Usually it takes 15-30 minutes, depending on the internet speed on TV, to upgrade the firmware.",
            "m9": "Please provide turn on time.",
            "m10": "Please provide turn off time.",
            "m11": "Please select at least one day.",
            "m12": "Are you sure you want to set default value?",
            "m13": "Please provide new password.",
            "m14": "Please provide confirm password.",
            "m15": "Only numeric value is accepted for password.",
            "m16": "The TV will download ~800MB firmware file and will install it. This may take some time depending on the internet speed on the TV. Are you sure you want to push the firmware to the TV?",
            "l": {
              "1":"Off",
              "2":"1 Min",
              "3":"3 Min",
              "4":"5 Min",
              "5":"10 Min",
              "6":"Clock",
              "7":"Clock+Data",
              "8":"Power of (Default)",
              "9":"Screen Off",
              "10":"Screen Off Always",
              "11":"Screen Off & Backlight On",
              "12":"Sustain Aspect Ratio",
              "13":"Off (Normal)",
              "14":"On (Power Key Only)",
              "15":"On (Block All)",
              "16":"PWR (Power On)",
              "17":"STD (Standby)",
              "18":"LST (Last Status)"
            }
          }
        },
        "p_du": {
          "1": "Total data usage till date",
            "1.1": "Since",
          "2": "This week",
          "3": "This month",
          "4": "Last two weeks",
          "5": "Last two months",
          "6": "Custom filter",
          "7": "Calculate",
          "8": "Total data usage"
        },
        "p_dus": {
          "1": "Data Usage Settings",
          "2": "Screenshots upload",
          "3": "Screenshot upload interval",
            "3.1": "Invalid",
          "4": "Download restriction",
          "5": "Allowed time range for download",
          "6": "Override file size",
          "7": "Files within the given size will be downloaded any time.",
          "8": "Polling frequency",
          "m1": "Screenshot upload interval should not be less than 2 minutes.",
          "m2": "Start time should not be equal or greater than end time.",
          "m3": "Please provide Override file size.",
          "m4": "Polling frequency should not be less than 30 seconds."
        },
        "p_mac": {
          "1": "Edit Device Id",
          "m1": "Please provide new device id."
        },
        "p_res": {
          "1": "Change Screen Resolution",
          "b1": "Apply",
          "m1": "There is not any info about applicable resolutions of the screen. Please turn on the device and make sure it's connected to internet.",
          "m2": "You have changed the resolution on {{dateTime}} which is not applied yet. You can wait or can apply new resolution."
        },
        "p_config": {
          "1": "Config id",
          "2": "Start date time",
          "3": "End date time",
          "4": "Create date",
          "5": "Load date",
          "m1": "You don't have any configuration yet.",
          "m2": "Are you sure you want to delete selected configuration?"
        },
        "p_similar": {
          "1": "Please choose similarity",
          "2": "Same Device Group",
          "3": "Any Common Group",
          "4": "Addition Date",
          "5": "Operating System",
          "6": "Screen Resolution",
          "7": "Download Restriction"
        },
        "p_delete": {
          "1": "This action can not be undone. This will permanently delete the selected device, it's reports, screenshots, logs and content from media player. Please confirm if you understand the consequences.",
            "1s": "This action can not be undone. This will permanently delete the selected devices, their reports, screenshots, logs and content from media player. Please confirm if you understand the consequences.",
          "2": "Are you sure you want to delete selected Device Group?",
            "2s": "Are you sure you want to delete selected Device Groups?",
          "3": "Are you sure you want to delete selected Device Tag?",
          "4": "Yes, delete the device",
            "4s": "Yes, delete the devices",
          "5": "Are you sure you want to delete selected identify request?",
          "6": "This action can not be undone. This will permanently delete the selected device folder. Please confirm if you understand the consequences.",
            "6s": "This action can not be undone. This will permanently delete the selected device folders. Please confirm if you understand the consequences.",
          "7": "This action can not be undone. This will permanently delete the selected device & device folders. Please confirm if you understand the consequences.",
          "8": "The device is part of a video wall named {{vwName}} and can't be deleted. Please understand the consequences.",
          "9": "The device is part of a video wall named {{vwName}} and can't be deleted, also this video wall is not displayed because you have no access to all the devices of the video wall. Please understand the consequences.",
          "10": "The device could not be deleted as this is a part of a video wall.",
          "11": "Yes, delete the device folder",
            "11s": "Yes, delete the device folders",
          "12": "Yes, Delete Selected Item",
            "12s": "Yes, Delete Selected Items"
        },
        "p_dg": {
          "1": "Devices Group",
          "2": "Edit Group",
          "3": "Assign group name",
          "4": "Import Excel",
          "5": "Clear Imported List",
          "6": "Edit Tag",
          "7": "Assign tag name",
          "8": "Keywords",
          "m1": "Please provide Device Group name.",
          "m2": "Device group already exists.",
          "m3": "Device group can not have Music Player device with some other type of device.",
          "m4": "Selected devices can not be assigned to this group/tag because either the devices does not have a frame layout assigned or their frame layout assignment's date range is not within assigned schedule's date range.",
          "m5": "Group name already exists. Please try some other name.",
          "m6": "Following device list is imported from uploaded excel sheet.",
          "m7": "No matching device found.",
          "m8": "Please provide file.",
          "m9": "Please provide Tag name.",
          "m10": "Tag name already exists.",
          "m11": "Device tag can not have Music Player device with some other type of device.",
          "m12": "Device group can not have EPD device with some other type of device.",
          "m13": "Device tag can not have EPD device with some other type of device.",
          "m14": "You can not use a reserved keyword for device info. Below is the list of reserved keywords:",
          "m15": "You can not use a reserved keyword for device properties. Below is the list of reserved keywords:",
          "m16": "You can not use a reserved keyword for properties. Below is the list of reserved keywords:",
          "m17": "You can not use a reserved keyword for auto registration. Below is the list of reserved keywords:",
          "m18": "Folder should have atleast one device."
        },
        "p_adg": {
          "1": "Add Device to Group",
          "m1": "You do not have any accessible device group yet.",
          "m2": "Please create a new device group."
        },
        "p_art": {
          "1": "Assigned tag",
            "1s": "Assigned tags",
          "2": "Selected tag",
            "2s": "Selected tags",
          "3": "Tag to remove",
          "3s": "Tags to remove",
          "m1": "You do not have any accessible device tag yet.",
          "m2": "Please create a new device tag."
        },
        "p_tag": {
          "1": "Update Tag",
          "m1": "Please provide tag name.",
          "m2": "Tag already exists.",
          "m3": "Only similar type of devices can be added to a tag."
        },
        "ar": {
          "1": "Issues with detail",
          "2": "Upload file",
          "3": "Download Auto-Registration Device List",
          "m1": "Frame layout will be assigned only to the newly added devices."
        },
        "p_h":{
          "1": "From",
          "2": "To",
          "3": "Change By",
          "4": "Change On",
          "5": "Reason",
          "6": "TV / Media Player changed",
          "7": "NIC changed",
          "8": "Inactive schedules",
          "9": "Content of inactive schedules",
          "m1": "You don't have any change history yet."
        },
        "p_tk": {
          "1": "Ticket List",
          "2": "Id",
          "3": "Assigned",
          "4": "Open",
          "5": "Resolved",
          "6": "Ticket Details",
          "m1": "You don't have any ticket yet. When you add some, they'll appear here.",
          "m2": "You can find difference in device count as some of the devices are not accessible to you."
        },
        "msg": {
          "1": "You don't have any device yet. When you add some, they'll appear here.",
          "2": "You don't have any device group yet. When you create some, they'll appear here.",
          "3": "You don't have any device tag yet. When you create some, they'll appear here.",
          "4": "Enter the device id that is being displayed on the signage screen.",
          "5": "Device Id already exists.",
          "6": "Device name already exists.",
          "7": "Please create a Geo Fence for the device.",
          "8": "Are you sure you want to delete selected Geo Fence?",
          "9": "Some of the widgets are not supported in preview mode.",
          "10": "No content scheduled on this device.",
          "11": "Please provide valid device id.",
          "12": "The device(s) added to device group {{deviceGroupName}} requires some schedules to be reviewed and correct frame selected. These schedules will be marked with a {{icon}} icon on the schedule list, please ask you server administrator to edit them and follow through all steps.",
          "13": "The device(s) added to device group {{deviceGroupName}} requires the following schedules to be reviewed and correct frame selected:",
          "14": "The device(s) added to device tag {{deviceTagName}} requires some schedules to be reviewed and correct frame selected. These schedules will be marked with a {{icon}} icon on the schedule list, please ask you server administrator to edit them and follow through all steps.",
          "15": "The device(s) added to device tag {{deviceTagName}} requires the following schedules to be reviewed and correct frame selected:",
          "16": "These schedules will be marked with a {{icon}} icon on the schedule list, please edit them and follow through all steps.",
          "17": "Please select device, group or tag.",
          "18": "Sent Identify request history not found.",
          "19": "Not any device has acknowledged the identify request yet.",
          "20": "There is not any device, group and tag available on the server.",
          "21": "Selected groups/tags are not having any device.",
          "22": "You don't have any saved search yet. When you create some, they'll appear here.",
          "23": "Selected items has schedules assigned to it. Deleting these items can make those schedules incomplete. Are you sure you want to delete the selected items?",
          "24": "Please select at least one Device.",
          "25": "Following schedules will become incomplete if you save the changes you made in search group:",
            "25.1": "Are you sure you want to save it?",
            "25.2": "There are some schedules which will become incomplete if you save the changes you made in search group.",
          "26": "You don't have any accessible device yet.",
          "27": "Please select lock screen.",
          "28": "Other Info labels should not be same.",
          "29": "Are you sure you want to update the information to the selected devices?",
          "30": "Please select a file.",
          "31": "The selected file data is not valid.",
          "32": "Other info labels should not be empty.",
          "33": "Group by device status (online / offline / never connected).",
          "34": "No matching tags found on server.",
          "35": "No tags found on server.",
          "36": "Device is not added due to restriction.",
          "37": "Are you sure you want to update the tags?",
          "38": "Please select frame layout.",
          "39": "Selected frame layout does not exists.",
          "40": "The uploaded sheet's column heading data should not be empty.",
          "41": "The uploaded sheet's column data should not be empty.",
          "42": "The uploaded sheet's column order is different or some of the columns are missing.",
          "43": "There are some issues while importing the file.",
          "44": "No license remaining to add new device.",
          "45": "Site Identifier already exists.",
          "46": "Are you sure you want to update the TV Settings?",
          "48": "Are you sure you want to update the properties?",
          "47": "TV settings is not enabled.",
          "49": "You don't have any properties.",
          "50": "No zkong store found on this server.",
          "51": "Please authorized for EPD.",
          "52": "Are you sure you want to update the On/Off Schedule?",
          "53": "Are you sure you want to update the Data Usage Settings?",
          "54": "No device found.",
          "55": "No power history available.",
          "56": "Watermarks not found.",
          "57": "Are you sure you want to delete selected watermark?",
          "58": "This device already has a watermark assigned.",
          "59": "Are you sure you want to update the Watermark Settings?",
          "60": "There are some issues while uploading the file.",
          "61": "All device accessible.",
          "62": "Please wait, a tag update task is already in process.",
          "63": "No license.",
          "64": "Please select cell.",
          "65": "Please provide Video wall name.",
          "66": "Please select device for video wall.",
          "67": "Please provide Row.",
          "68": "Please provide Column.",
          "69": "You don't have any video wall yet. When you create some, they'll appear here.",
          "70": "This action will remove current wall entries. Are you sure you want to proceed?",
          "71": "Devices assign for the video wall already have schedule.",
          "72": "Video wall name already exists.",
          "73": "You don't have any video wall yet. When you create some, they'll appear here.",
          "77": "Please select devices for all matrix.",
          "78": "Devices should not be duplicate for wall preview.",
          "79": "Please provide valid IP for all the device."
        },
        "info": {
          "1": "Adding new device to your server",
            "d1": "There are two ways to register the device (media player) . Through client app (Slide) or through web admin (Hub) on your desktop browser.",
            "d2": "Through Slide",
            "d2.1": "When you turn on the device, it will show you the login prompt. Login there with a valid user name and password. Select the server and assign a meaningful name to device.",
          "d3": "Through Hub",
            "d3.1": "Click on the \"Add New Device\" button on \"Devices\" tab. Provide the device Id which is being displayed on the device screen and assign a meaningful name to device.",
          "dg1": "When scheduling content, you can select which device groups to schedule the content to. You will be able to use these device group quickly.",
          "dt1": "Please assign the tags that identify the location or purpose of this device. These tags are later used in the scheduling process.",
          "dt2": "When scheduling content, you will need to select which devices to schedule the content to. You will be able to use these tags to find the device that match your criteria quickly.",
          "dt3": "For example, let's say you have three devices. For the first device, you assigned the tag 'Ontario', 'Cafe' and 'School'. For the second device, you assign 'Ontario', 'Lobby' and 'Retail'. For the third device, you assign 'Vancouver', 'Cafe' and 'School'. Now let's imagine, there are many devices and you want to schedule content to devices in Ontario Cafes. You will use the tags to include devices with tags 'Ontario' and 'Cafe'. Let's say you want to find all cafes not in Vancouver then you will include tags 'Cafe' and exclude tag 'Vancouver'.",
          "dvw1": "A video wall is a display consisting of multiple screens or monitors tiled together to form a larger display surface."
        }
      },
      "u": {
        "tab": {
          "1": "Active Users",
          "2": "User Groups",
          "3": "Blocked Users",
          "4": "Roles and Rights"
        },
        "tool": {
          "1": "What is {{htmlTagO}}User Group{{htmlTagC}}?",
          "2": "What is {{htmlTagO}}Blocked User{{htmlTagC}}?",
          "3": "Watch {{htmlTagO}}User{{htmlTagC}} video tutorial.",
          "4": "Watch {{htmlTagO}}User Roles{{htmlTagC}} video tutorial.",
          "5": "Watch {{htmlTagO}}User Group{{htmlTagC}} video tutorial."
        },
        "btn": {
          "1": "Invite New User",
          "2": "Create New User Group",
          "3": "Create New Role",
          "4": "Invite",
          "5": "Sending Invitation",
          "6": "Invite Again",
          "7": "Change",
          "8": "Block",
          "9": "Unblock",
          "10": "Select Users"
        },
        "brief": {
          "1": "Selected User",
            "1s": "Selected Users",
          "2": "Selected User Group",
            "2s": "Selected User Groups",
          "3": "Group",
          "4": "Role",
          "5": "Last login",
          "6": "Send password",
          "7": "User count",
          "8": "Invited on",
          "9": "Invited by",
          "10": "Selected User / Group"
        },
        "body": {
          "1": "Users List",
          "2": "Roles",
          "3": "Rights",
          "4": "User Logs",
          "5": "Password will be sent to following email",
          "6": "Blocked User",
          "7": "Administrator can not be added to a group.",
          "8": "You",
          "9": "Manager",
          "10": "Executive"
        },
        "p_invite": {
          "1": "Edit User",
          "2": "Assign role",
          "3": "Administrator",
          "4": "Predefined roles",
          "5": "Custom roles are not available. You can create your own role and assign to user.",
            "5.1": "Create User Role",
          "6": "No group available.",
          "7": "Invite User Again",
          "8": "Select user group",
          "m1": "Invitation mail will be sent in selected language. Also, if user is not registered with {{brand}} yet, selected language will be his/her default language.",
          "m2": "This is an L Squared Support Coordinator user, you can not change it's role."
        },
        "p_pgroup": {
          "1": "Change Primary Group",
          "2": "Select Group"
        },
        "p_group": {
          "1": "Edit User Group",
          "2": "Assign group name",
          "3": "Available Users",
          "ph1": "Assign a meaningful name to the user group",
          "m1": "Please provide User Group name.",
          "m2": "User Group already exists.",
          "m3": "User Group already exist in some other user group."
        },
        "p_delete": {
          "1": "Yes, delete the user group",
          "1s": "Yes, delete the user groups"
        },
        "p_role": {
          "1": "Edit Role",
          "2": "Role name",
          "3": "Assign rights",
          "4": "Content Rights",
            "4.1": "Add content",
            "4.2": "Edit content",
            "4.3": "Delete content",
            "4.4": "Create widget",
            "4.5": "Edit widget",
            "4.6": "Delete widget",
            "4.7": "Create folder",
            "4.8": "Edit folder",
            "4.9": "Delete folder",
            "4.10": "Move",
            "4.11": "Archive",
            "4.12": "Add to home directory",
            "4.13": "Edit in home directory",
            "4.14": "Delete from home directory",
          "5": "Template Rights",
          "6": "Device Rights",
            "6.1": "Add device",
            "6.2": "Edit device",
            "6.3": "Delete device",
            "6.4": "Add Group",
            "6.5": "Edit Group",
            "6.6": "Delete Group",
            "6.7": "Add tag",
            "6.8": "Edit tag",
            "6.9": "Delete tag",
            "6.10": "Device control",
            "6.11": "Register/Edit device on map",
          "7": "Schedule Rights",
            "7.1": "Set content fullscreen",
          "8": "User Rights",
            "8.1": "Invite",
            "8.2": "Edit",
            "8.3": "Block",
            "8.4": "Add role",
            "8.5": "Edit role",
            "8.6": "Delete role",
          "9": "Frame Layout Rights",
            "9.1": "Set Restrictions",
            "9.2": "Edit assignment",
            "9.3": "Delete assignment",
          "10": "Other Rights",
            "10.1": "Emergency message",
            "10.2": "Reports",
            "10.3": "Creative Service",
            "10.4": "Billing and Payment",
          "11": "Approval",
          "m1": "Role with same name already exists. Please try some other name.",
          "m2": "Please provide a name for the Role.",
          "m3": "Please select at least one Right.",
          "m4": "One of device selection right (device/group/tag) is mandatory with \"Add schedule\" permission.",
          "m5": "No item find."
        },
        "msg": {
          "1": "No active users available.",
          "2": "You don't have any user group yet. When you create some, they'll appear here.",
          "3": "You don't have any blocked user.",
          "4": "No roles rights available.",
          "5": "User already exists on this server.",
          "6": "Please provide email id.",
          "7": "Email id is not valid.",
          "8": "Please select a role.",
          "9": "Are you sure you want to block selected User?",
            "9s": "Are you sure you want to block selected Users?",
          "10": "Are you sure you want to delete selected Blocked User?",
            "10s": "Are you sure you want to delete selected Blocked Users?",
          "11": "This action can not be undone. This will permanently delete the selected user group. It's associated device, content, schedule etc will become public. Please confirm if you understand the consequences.",
            "11s": "This action can not be undone. This will permanently delete the selected user groups. Their associated device, content, schedule etc will become public. Please confirm if you understand the consequences.",
          "12": "Are you sure you want to delete selected role?",
          "13": "This role can not be deleted. There are users assigned with this role. Please change their roles first.",
          "14": "You do not have any accessible user group yet. Please create a new user group.",
          "15": "No user group available.",
          "16": "Your account is configured through your SSO provider. Please contact your account administrator to get the password."
        },
        "info": {
          "ug1": "User Groups is a way for users within a server to hide data from each other. This is because a marketing department using part of the system to display marketing content doesn’t necessary have to see corporate messaging content used by the HR department.",
          "bu1": "Server administrator can block a user to access his server. Once blocked, that user can not login to that specific server.",
          "uv1": "Adding Users to Your Server",
          "urv1": "Using Roles to Control Access",
          "ugv1": "Restricting and Sharing Content Using User Groups"
        }
      },
      "em": {
        "tab": {
          "1": "Send Message",
          "2": "Sent Messages",
          "3": "Settings"
        },
        "tool": {
          "1": "What is {{htmlTagO}}Emergency Message{{htmlTagC}}?"
        },
        "body": {
          "1": "Message",
          "2": "Expired",
          "3": "Active",
          "4": "Queued",
          "5": "Acknowledgement Status",
          "6": "Timeout",
          "7": "Acknowledged",
          "8": "Pending",
          "9": "Title Image",
          "10": "Add Predefined Message",
          "11": "Edit Sent Message",
          "12": "Sent by"
        },
        "label": {
          "1": "Predefined message",
          "2": "Custom message",
            "2.1": "If predefined message is also selected, this custom message will be added at the end of predefined message.",
          "4": "Predefined",
          "5": "When to display?",
            "5.1": "Immediately",
          "6": "All Devices",
          "7": "Assigned device",
            "7s": "Assigned devices",
          "8": "Blinking background",
          "9": "Message background",
          "10": "Message text",
          "11": "Message font",
          "12": "Text to speech",
          "13": "Message size"
        },
        "btn": {
          "1": "View Status",
          "2": "Delete Message",
          "3": "Default Settings",
          "4": "Change Image",
          "5": "Delete Image"
        },
        "ph": {
          "1": "Select predefined message"
        },
        "msg": {
          "1": "You don't have any device yet. Emergency message works only when you have devices to receive emergency broadcast.",
          "2": "There is not any emergency message broadcast.",
          "3": "Please provide Message.",
          "4": "Please provide Duration.",
          "5": "Please provide When to display.",
          "6": "Please select device or group.",
          "7": "Not any device has acknowledged the emergency message yet.",
          "8": "Please provide Header text.",
          "9": "This image will appear with the title text {{htmlTag}} on Emergency Message screen. {{htmlTag}} You can upload a JPG, GIF or PNG file.",
          "10": "Please provide Custom message.",
          "11": "Are you sure you want to delete the title image?",
          "12": "Are you sure you want to delete selected message?",
          "13": "Are you sure you want to delete the selected emergency message?",
          "14": "Please provide Message size.",
          "15": "Are you sure you want to cancel the selected emergency message?"
        },
        "info": {
          "1": "At the time of any emergency, a user with \"Emergency message\" permission can broadcast a message to all or selected devices for a specific time duration. The emergency message takes whole display of the screen."
        }
      },
      "r": {
        "tab": {
          "1": "Content Reports",
            "1.1": "Content Confirmation",
            "1.2": "Content Saturation",
            "1.3": "Proof of Play",
          "2": "Device Reports",
            "2.1": "Device Status",
            "2.2": "Device Health",
              "2.2.1": "Health",
              "2.2.2": "Temperature",
              "2.2.3": "Backlight",
              "2.2.4": "Up Time Total",
            "2.3": "Offline Device",
            "2.4": "Online Percentage",
            "2.5": "Inventory Report",
            "2.6": "Status Timeline",
            "2.7": "Power On/Off History",
            "2.8": "Hot Key",
          "3": "Subscriptions",
          "4": "Offline report",
          "5": "Online report",
          "6": "Constant Media Reports",
            "6.1": "Email Sent",
            "6.2": "Email Attachment View",
            "6.3": "Advert Click",
          "7": "Configuration Items"
        },
        "tool": {
          "1.1": "What is {{htmlTagO}}Content Confirmation{{htmlTagC}} report?",
          "1.2": "What is {{htmlTagO}}Content Saturation{{htmlTagC}} report?",
          "1.3": "What is {{htmlTagO}}Proof of Play{{htmlTagC}} report?",
          "2.1": "What is {{htmlTagO}}Device Status{{htmlTagC}} report?",
          "2.2": "What is {{htmlTagO}}Device Health{{htmlTagC}} report?",
          "2.3": "What is {{htmlTagO}}Offline Device{{htmlTagC}} report?",
          "2.4": "What is {{htmlTagO}}Online Percentage{{htmlTagC}} report?",
          "2.5": "What is {{htmlTagO}}Inventory{{htmlTagC}} report?",
          "2.6": "What is {{htmlTagO}}Status Timeline{{htmlTagC}} report?",
          "2.7": "What is {{htmlTagO}}Power On/Off History{{htmlTagC}} report?",
          "2.8": "What is {{htmlTagO}}Hot Key{{htmlTagC}} report?",
          "5": "Clip",
          "6": "Unclip",
          "7": "Send Report to Email",
          "8": "TV turn off by the TV panel power button",
          "9": "TV turn off by the TV on/off timer",
          "10": "TV turn off by the TV remote button",
          "11": "TV turn off by the power switch board"
        },
        "body": {
          "1": "Select Device for Report",
          "2": "Select Content for Report",
          "3": "Proof of Play Report",
          "4": "Device Status Report",
          "5": "Content Saturation Report",
          "6": "Content Name",
          "7": "Duration (sec)",
          "7.1": "Duration (hh:mm:ss)",
          "8": "Slot",
          "9": "Total",
          "10": "Used",
          "11": "Available",
          "12": "Overlimit",
          "13": "No threshold",
          "14": "Device Name",
          "15": "New Update"
        },
        "label": {
          "1": "Select date",
          "2": "Time range",
          "3": "Whole day",
          "4": "To",
          "5": "Loop length",
          "6": "Show all frames",
          "7": "Show frames with threshold only",
          "8": "Online devices only",
          "9": "Offline devices for:",
          "10":"Subscription type",
          "11":"Off",
          "12":"No data",
          "13":"Day wise Device Status Report",
          "14":"Hour wise Proof of Play Report",
          "15":"Day wise Proof of Play Report",
          "16":"Month wise Proof of Play Report",
          "17":"Hours",
          "18":"Days",
          "19":"Months",
          "20":"Generated reports",
          "21":"Report generation status",
          "22":"Genrated on",
          "23":"Fetching",
          "24":"Device Reports Generation",
            "24.1":"V1",
            "24.2":"V2"
        },
        "ph": {
          "1": "Enter Email",
          "2": "Create Subscription"
        },
        "btn": {
          "1": "Generate Report",
          "3": "Select Content",
          "4": "Export {{format}}",
          "5": "Subscribe",
          "6": "Unsubscribe"
        },
        "msg": {
          "1": "No records found.",
          "2": "No data found.",
          "3": "No data available.",
          "4": "Please provide time range",
          "5": "Invalid time range",
          "6": "Please provide loop length",
          "7": "Please provide valid date range. Date range should not be greater than 15 days.",
          "8": "Please provide hours.",
          "9": "Are you sure you want to unsubscribe?",
          "10": "Please provide valid date range. Date range should not be greater than 1 month.",
          "11": "Note: Date range should not be greater than 1 month.",
          "12": "The date range should be less than the current date.",
          "13": "History not found.",
          "14": "You have already generated a report for the selected date range. If you would like to download the same, please download it from the 'Generated Reports' section.",
          "15": "Are you sure you want to delete selected report?",
          "16": "Are you sure you want to cancel from the queue?",
          "17": "This functionality requires a permission you currently don't have. The Inventory report exports the list of devices. However, you don't have the required permission to export the device list."
        },
        "info": {
          "pp1": "Content report basically shows when, where and for how long the content was played for. Imagine you have advertisers in your ad-network and you need to show them how many times that ad was broadcast or for how long was this ad being played, on how many screens and so on. The reports will provide this data.",
          "hpp": "HD Steth report basically shows when, where and for how long the content was played for. Imagine you have advertisers in your ad-network and you need to show them how many times that ad was broadcast or for how long was this ad being played, on how many screens and so on. The reports will provide this data.",
          "ds1": "The Device Status shows the user how long the device has been on for vs how long it should have been on for.",
          "dst1": "The Status Timeline report shows online/offline status of device on a particular date range.",
          "poh1": "The Power On/Off History report shows the list of power events history of the selected TV."
        }
      },
      "an": {
        "tab": {
          "1": "Updatable",
          "2": "Read Only",
          "3": "Master"
        },
        "label": {
          "1": "Complex name",
          "2": "Facility name",
          "3": "Activity name",
          "4": "Rink schedule",
          "5": "Day schedule",
          "6": "Civic committee schedule",
          "7": "Home team",
          "8": "Home team room",
          "9": "Visitor team",
          "10": "Visitor team room",
          "11": "Select complex name",
          "12": "Select facility name",
          "13": "Select complex and facility"
        },
        "btn": {
          "1": "Updatable",
          "2": "Non Updatable",
          "3": "Design Template",
          "4": "Edit Dynamic Text",
          "5": "Design Scene"
        },
        "msg": {
          "1": "Please provide Complex name.",
          "2": "Please provide Facility name.",
          "3": "You don't have any updatable item yet.",
          "4": "You don't have any read only item yet.",
          "5": "You don't have any master item yet.",
          "6": "Are you sure you want to sync selected item?"
        },
        "info": {
          "t1": "The purpose of template is to allow users to quickly change some small part of content they wish to display on a screen. For example, let’s say that this digital signage system needs to be used at a coffee shop. The coffee shop has daily specials that they wish to update in the morning. The coffee can use templates to create a design for the daily special display and define the area where the price goes as a changeable field. This template can be opened in the morning every day to change just the price, then save the template. This way the price can be changed without recreating the entire design every time.",
          "ut1": "Templates created by a user, which is not having \"approval\" permission, are categorized as \"Unapproved Templates\". These templates can not be scheduled until it's approved by admin or a user with approval rights.",
          "it1": "If there is not any placeholder in the template, it's considered as incomplete and moved to Incomplete Template tab."
        },
        "step": {
          "1": "Upload the downloaded excel sheet to your OneDrive.",
          "2": "Edit the Template and authorize your OneDrive account.",
          "3": "Once authorized, select the excel file from your OneDrive and save the Template.",
          "other":"You can also use the menu board portal for updating the text."
        }
      },
      "cs": {
        "tab": {
          "1": "Current Orders",
          "2": "Completed Orders",
          "3": "Invoices",
          "4": "Order Detail",
            "4s": "Order Details",
          "5": "Attachments",
          "6": "Invoice"
        },
        "tool": {
          "1": "What is {{htmlTagO}}Creative Service{{htmlTagC}}?",
          "2": "Watch {{htmlTagO}}Creative Services{{htmlTagC}} video tutorial.",
          "3": "Cancel order",
          "4": "Allowed Formats"
        },
        "body": {
          "1": "Requested by",
          "2": "Requested on",
          "3": "Payment",
          "4": "Amount",
          "5": "Invoice date",
          "6": "Not paid yet",
          "7": "Paid",
          "8": "New order",
          "9": "Estimated",
          "10": "Accepted",
          "11": "Rejected",
          "12": "Completed",
          "13": "Cancelled",
          "14": "Estimate Updated",
          "15": "Invoice Generated",
          "16": "Invoice not generated",
          "17": "Approved",
          "18": "Description",
          "19": "Creative Service"
        },
        "btn": {
          "1": "Request New Creative",
          "2": "Approve",
          "3": "View Invoices",
          "4": "Make Payment",
          "5": "Print"
        },
        "p_c": {
          "body": {
            "1": "Request Creative Service",
            "2": "Please select one of the two options below and describe the project as much as detail as possible. If you have sketches or story boards already, please attach them to this request. In the description, please be sure to describe where and how this content will be displayed, who the target audience is etc. The more detail you provide, the better the result will be. We may also contact you for more information."
          },
          "label": {
            "1": "Request for",
            "2": "Attach files"
          }
        },
        "p_d": {
          "label": {
            "1": "Request Id",
            "2": "Request date",
            "3": "Contact tel",
            "4": "Assigned to",
            "5": "Attachment count",
            "6": "Estimate hours",
            "7": "Estimated cost",
            "8": "Rate",
            "9": "Timeline"
          },
          "btn": {
            "1": "Accept",
            "2": "Reject",
            "3": "Comment",
            "4": "Attach file",
            "5": "Attach New File"
          }
        },
        "p_i": {
          "1": "Phone",
          "2": "Website",
          "3": "Address",
          "4": "Invoice to",
          "5": "Invoice id",
          "6": "Transaction id",
          "7": "Order date",
          "8": "Tax id",
          "9": "Item Description",
          "10": "Unit Rate ($/hour)",
          "11": "Total Hours",
          "12": "Price",
          "13": "Total Cost",
          "m1": "Please wait, payment in process. Do not refresh the browser.",
          "m2": "Your payment has been done. Thank you!",
          "m3": "There is some problem with payment. Please try again later."
        },
        "msg": {
          "1": "You don't have any open creative service request.",
          "2": "You don't have any completed creative service request.",
          "3": "You don't have any invoice for creative service request.",
          "4": "Please provide Title.",
          "5": "Please provide Description.",
          "6": "Please provide Contact number.",
          "7": "Please provide valid Contact number.",
          "8": "No Attachments found.",
          "9": "Are you sure you want to accept the estimate for {{rate}}?",
          "10": "Are you sure you want to reject estimate?",
          "11": "Are you sure you want to cancel order?",
          "12": "Are you sure you want to complete order?",
          "13": "Are you sure you want to delete selected Creative?",
          "14": "Only admin can accept the estimate",
          "15": "Only admin can reject the estimate"
        },
        "info": {
          "1": "{{lsn}} graphic designers will create images, videos and Templates according to your requirements for use on your Digital Signage network. Just post a request here and {{lsn}} representative will contact you."
        }
      },
      "ms": {
        "tab": {
          "1": "Profile",
          "2": "Preferences",
          "3": "Server Roles",
          "4": "Change Password",
          "5": "Server Settings",
          "6": "Coordinators"
        },
        "label": {
          "1": "First name",
          "2": "Last name",
          "3": "Profile picture",
          "4": "Use Default Picture",
          "5": "User preferences",
          "6": "Device view",
            "6.1": "Thumb",
            "6.2": "List",
          "7": "Left panel",
            "7.1": "Expanded",
            "7.2": "Collapsed",
          "8": "Details section position",
          "9": "Redirect popup on page",
          "10": "Split",
            "10.1": "Vertical",
            "10.2": "Horizontal",
          "11": "Content Library tree",
          "12": "Server roles",
            "12.1": "Server Name",
            "12.2": "Groups",
          "13": "Current password",
          "14": "New password",
          "15": "Confirm password",
          "16": "New email",
          "17": "Verification code",
            "17.1": "You should have received a verification code in your email. Provide it here.",
          "18": "You can upload a JPG, GIF or PNG file. {{htmlTag}} Preferably square dimension. {{htmlTag}} (file size limit is {{size}})",
          "19": "Add coordinator",
          "20": "Notify new Support Coordinator",
          "21": "Two Factor Authentication",
            "21.1": "Enable",
            "21.2": "Disable",
          "22": "Verification Code",
          "23": "Scan this QR code with",
          "24": "Microsoft Authenticator",
          "25": "How to setup Microsoft Authenticator?",
          "26": "Send the verification code to your email:",
          "27": "Content scaling",
            "27.1": "Scale to Fit",
            "27.2": "Scale and Crop",
            "27.3": "Skew",
          "28": "Servers",
          "29": "Available server",
            "29s": "Available servers",
          "30": "Assigned server",
            "30s": "Assigned servers",
          "31": "Sales",
          "32": "Default date range for schedule",
            "32.1": "1 Year",
            "32.2": "1 Month",
            "32.3": "1 Week",
          "33": "Theme",
            "33.1": "Light",
            "33.2": "Dark",
          "34": "Menu board list sorting",
            "34.1": "Alphabetically",
    
          "35": "",
            "35.1": "Device Status",
            "35.2": "Content Count",
            "35.3": "Schedules Count",
            "35.4": "Users Count",
            "35.5": "Recent Activity Logs",
            "35.6": "Devices List",
            "35.7": "Devices on Map",
            "35.8": "Devices Type Summary",
            "35.9": "Devices Other Info Summary",
              "35.9.1": "Devices Other Info Summary Settings",
            "35.10": "Content Confirmation Summary",
            "35.11": "Content Confirmation List",
            "35.12": "Device Temperature Summary",
              "35.12.1": "Temperature Settings",
              "35.12.2": "Caution threshold",
              "35.12.3": "Danger threshold",
            "35.13": "Online/Offline Status of Specific Device Info",
            "35.14": "Recently Added Devices",
              "35.14.1": "Recently Added Devices Settings",
              "35.14.2": "Recently added devices since",
              "35.14.3": "Last Day",
              "35.14.4": "Last Week",
              "35.14.5": "Last Month",
              "35.14.6": "Last Year",
            "35.15": "Open Tickets",
              "35.15.1": "Open Tickets Settings",
              "35.15.2": "Customer ID",
              "35.15.3": "Open Tickets",
              "35.15.4": "Resolved Tickets",
            "35.16": "Device Temperature List",
            "35.17": "Online/Offline Status Summary of Device Type",
            "35.18": "Devices Properties Summary",
            "35.19": "Online/Offline Status of Specific Device Properties",
            "36": "Select device for preview",
            "37": "Token",
            "38": "Key",
            "39": "Pie Chart Color",
            "40": "Select properties",
            "41": "Apply dashboard layout to other users",
            "42": "Assign your dashboard to selected users:",
            "43": "Make your dashboard layout this server's default. Making this default will apply your dashboard layout to all existing and future users.",
            "44": "Device tree",
            "45": "Device per page",
            "46": "Content view",
            "48": "Pin Item"
        },
        "btn": {
          "1": "Change Email",
          "2": "Search User",
          "3": "Make Support Coordinator",
          "4": "Verify and Save",
          "5": "Verify",
          "6": "Don't have your phone?",
          "7": "Send Code",
          "8": "Resend Code",
          "9": "Make Sales Coordinator",
          "10": "Apply"
        },
        "tool": {
          "1": "Support Coordinator",
          "2": "Sales Coordinator"
        },
        "msg": {
          "1": "First and Last Name both are mandatory.",
          "2": "Please provide valid Contact number.",
          "3": "Are you sure you want to set default image?",
          "4": "This action will start process for changing your login email Id for Hub. You will receive an email with a verification code, that you need to provide in the next screen. {{htmlTagO}} Do you want to proceed? {{htmlTagC}}",
          "5": "Invalid verification code.",
          "6": "New email id is same as old.",
          "7": "Please provide valid email id.",
          "8": "Please provide Verification code.",
          "9": "User already exists with same email.",
          "10": "Your email id has been changed successfully.",
            "10.1": "Please login again with new email id.",
          "11": "Your password has been changed successfully.",
            "11.1": "Please login again with new password.",
          "12": "New password and Confirm password should match.",
          "13": "Current password did not match.",
          "14": "Current password and new password are same.",
          "15": "Password is not valid.",
          "16": "Password must be at least 8 characters.",
          "17": "Password must contain at least one capital and one small letter.",
          "18": "Password must contain at least one digit.",
          "19": "Password must contain at least one of the following character:",
          "20": "You don't have any support coordinator yet. When you add some, they'll appear here.",
          "21": "User with {{htmlTagO}}{{email}}{{htmlTagC}} email id does not exists in Hub.",
          "22": "Selected user is already a support coordinator.",
          "23": "Selected user is blocked on following servers.",
          "24": "Are you sure you want to remove support coordinator role from selected user?",
          "25": "Are you sure you want to make {{htmlTagO}}{{name}}{{htmlTagC}} ({{email}}) a support coordinator?",
          "26": "Support coordinator role can not be assigned to selected user because it has Prime Admin role on following server(s):",
            "26.1": "Please make someone else the prime admin on above server(s) first.",
          "27": "Selected user is a support coordinator. Prime admin role can not be assigned to this user.",
          "28": "Are you sure you want disabled Two Factor Authentication?",
          "29": "Verification code should not be empty.",
          "30": "Verification code is not valid.",
          "31": "Verification code is sent on email.",
          "32": "Try again.",
          "33": "Please provide caution threshold.",
          "34": "Please provide danger threshold.",
          "35": "Please provide customer ID.",
          "36": "Please provide device for preview.",
          "37": "Please select at least one device type.",
          "38": "Are you sure you want re-authorize this account?",
          "39": "You can either assign your dashboard layout to selected users or you can make your dashboard layout default to all users of this server."
        },
        "p_setup": {
          "1": "Set up Microsoft Authenticator",
          "2": "Install the Microsoft Authenticator.",
            "2.1": "On your phone, go to Microsoft Store / Google Play Store / Apple App Store.",
            "2.2": "Search for \"Microsoft Authenticator\".",
            "2.3": "Download and install the application.",
          "3": "Now open and configure Microsoft Authenticator.",
            "3.1": "Open Microsoft Authenticator and click on \"Add Account\" button.",
            "3.2": "Select \"Other\" account.",
            "3.3": "Scan this barcode.",
          "4": "Once you have scanned the barcode, enter the 6-digit verification code generated by the Authenticator app."
        },
        "p_s": {
          "tab": {
            "1": "Change Prime Admin",
            "2": "Notification",
            "3": "Polling Frequency",
            "4": "Adapters List",
            "5": "Default Client Image",
            "6": "Allowed File Types",
            "7": "Server Permissions",
            "8": "Device Properties",
            "9": "Zkong",
            "10": "AWS IoT 1-click Project",
            "12": "App Switches",
            "13": "R&G Reports"
          },
          "notifyS": {
            "1": "Notification Settings",
            "2": "Email Notifications",
              "2.1": "When schedules expire (Daily once).",
              "2.2": "When content expire (Daily once).",
              "2.3": "When new unapproved content are uploaded.",
              "2.4": "When new unapproved templates are created.",
              "2.5": "When new unapproved schedules are created.",
              "2.6": "When schedules are changed.",
              "2.7": "When schedules are deleted.",
              "2.8": "When content is deleted.",
              "2.9": "When template is deleted.",
              "2.10": "When frame layout is changed.",
              "2.11": "When device is offline for x minutes.",
                "2.11.1": "Excluded time",
                "2.11.2": "Offline time",
                "2.11.3": "Device threshold",
    
              "2.12": "When there is no content on the device for the whole day.",
              "2.13": "When schedule is going to expire:",
                "2.13.1": "Date when schedule expires",
                "2.13.2": "One day earlier",
                "2.13.3": "One week earlier",
              "2.14": "When frame layout assignment is going to expire:",
                "2.14.1": "Date when assignment expires",
              "2.15": "When a device is added or deleted.",
              "2.16": "When a device id or name changed.",
              "2.17": "When device info changed.",
                "2.17.1": "Other info",
                "2.17.2": "Property",
                "2.17.3": "Tag",
                "2.17.4": "Group",
              "2.18": "When the installation date of unregistered devices has expired.",
            "3": "Mobile App Notifications",
            "4": "SMS Notifications",
            "m1": "Offline time should not be less than 5 minutes and more than 1440 minutes (24 hours).",
            "m2": "Please provide valid time range.",
            "m3": "Please provide email.",
            "m4": "You can select 5 minutes to 600 minutes (10 hours) only.",
            "m5": "Please provide device threshold.",
            "m6": "Please provide token.",
            "m7": "Please provide key.",
            "m8": "Please provide specific schedules.",
            "m9": "Please select atleast one type of schedule is going to expire.",
            "m10": "Please select atleast one schedule."
          },
          "polling": {
            "1": "Polling Frequency Settings",
            "2": "Polling frequency",
            "3": "Invalid",
            "4": "Apply on all devices",
            "5": "Apply on future devices",
            "m1": "Please provide valid Polling frequency."
          },
          "prime": {
            "1": "Administrator",
            "2": "Administrator (Prime)",
            "3": "User has not signed up with L Squared Hub yet.",
            "4": "Notify new prime admin",
            "5": "Notify prime admin about this change."
          },
          "defaultImg": {
            "1": "Default image",
            "2": "Available device resolution",
            "3": "You can upload a JPG, JPEG or PNG file.",
            "m1": "Please wait! Do not close or change tabs while file upload is in process.",
            "m2": "Are you sure you want to delete the image?"
          },
          "serverPer": {
            "h1": "Modules",
            "h2": "Other Features",
            "1": "Reporting",
            "2": "Show Support's activity log",
            "3": "Content restriction on Frame",
            "4": "Premium",
            "5": "Private",
            "6": "Crawling",
            "7": "Show support coordinators in user list and their activity logs",
            "8": "Maps",
              "8.1": "Google",
              "8.2": "Azure",
            "9": "SharePoint",
            "10": "OneDrive",
            "11": "Microsoft Azure Settings",
              "11.1": "Microsoft Azure SSO Settings",
            "12": "Okta Settings",
            "13": "Client id",
            "14": "Client secret",
            "15": "Tenant id",
            "16": "App domain",
            "17": "Login button label",
            "18": "Allow creating frame layout bigger than 1080p (1920x1080).",
            "19": "Microphone support",
            "20": "Allow only single-frame layout",
            "21": "Billing and Payment",
            "22":"IoT Hub",
            "23": "Group by device type",
            "24": "Media Conversion",
              "24.1": "Third Party",
              "24.2": "In house",
            "25": "IoT Central",
            "26": "Third-Party Uploaders",
            "27": "Generate column for Site Identifier",
            "28": "By default, group devices by status",
            "29": "Allow users to sort device by other info",
            "30": "Third-party email for offline device notification",
            "31": "Device Actions",
    
            "32": "Idaptive Settings",
              "32.1": "Entity id",
              "32.2": "Single sign on URL",
              "32.3": "Single logout URL",
              "32.4": "Signing certificate",
            "33": "BigPanda notification",
            "34": "Hybrid Hosting",
              "34.1": "Is SSL",
              "34.2": "Host",
              "34.3": "Bucket",
              "34.4": "Access key",
              "34.5": "Secret key",
              "34.6": "Port",
              "34.7": "Storage Server",
              "34.8": "Media Server",
            "35": "Subdomain",
            "36": "Schedule Priority",
              "36.1": "Higher number higher priority",
              "36.2": "Lower number higher priority",
            "37": "Device Pagination",
            "38": "Session Timeout",
            "39": "IoT Button Settings",
              "39.1": "Device certificate URL",
              "39.2": "Private key file URL",
              "39.3": "Root CA certificate URL",
              "39.4": "Access key",
              "39.5": "Secret key",
              "39.6": "Region",
              "39.7": "Project",
              "39.8": "AWS IoT 1-click API Credentials",
              "39.9": "Attribute Name",
              "39.10": "Select placement",
              "39.11": "Add Attribute",
                "39.m1": "Please provide an Endpoint.",
                "39.m2": "Please provide a Device certificate URL.",
                "39.m3": "Please provide a Private key file URL.",
                "39.m4": "Please provide a Root CA certificate URL.",
                "39.m5": "Please provide a Access key.",
                "39.m6": "Please provide a Secret key.",
                "39.m7": "Please provide a Region.",
                "39.m8": "Please provide a Project.",
                "39.m9": "Please provide a attribute name.",
                "39.m10": "Please provide a value.",
                "39.m11": "Please select at least one placement.",
                "39.m12": "You don't have any placement yet. When you add some, they'll appear here.",
                "39.m13": "You don't have any attribute yet. When you add some, they'll appear here.",
            "40": "Sheet Export Settings",
            "41": "Content size notification",
            "42": "SAML Settings",
            "43": "Allow users to login to other accessible servers.",
            "44": "Shared Folder",
            "45": "AWS IoT",
            "46": "Firstup Settings",
            "47": "Device Folder",
            "48": "Stream metrics",
            "49": "Cisco Meraki Settings",
              "49.1": "Organization id",
              "49.m1": "Please provide Organization id.",
            "50": "HubSpot Ticket",
            "51": "Circuit Bench",
              "51.1": "Circuit Bench Settings",
              "51.m1": "Are you sure you want to reset circuit bench settings?",
            "52": "L Squared",
            "53": "Registration Secret Key",
            "54": "Registration Secret Key Setting",
            "55": "Show tags in device list",
              "55.1": "Show Tags in Device List Settings",
            "56": "Default Content Duration",
            "57": "Specific",
            "59": "Content dimension alert",
            "60": "Open AI Image Generation",
            "61": "Proactive Monitoring with HubSpot",
              "61.1": "Proactive Monitoring Settings",
              "61.2": "Offline duration",
            "62": "Storage Type",
            "63": "Account Id",
              "63.m1": "Please provide a Account Id",
            "64": "QuickSight Username",
              "64.m1": "Please provide a QuickSight Username.",
            "65": "Content Storage",
              "65.1": "L Squared Storage",
              "65.2": "Storage Plan 2",
              "65.3": "Hybrid Storage",
              "65.4": "Hybrid Storage Settings",
            "66": "Account Name",
              "66.m1": "Please provide Account Name.",
              "66.m2": "The account name is invalid.",
            "67": "Token",
              "67.m1": "Please provide Token.",
              "67.m2": "The Token is invalid.",

            "69": "Google Settings",
            "70": "Google Drive Settings",
              "70.1": "Oauth Settings",
              "70.2": "Service Principal Settings",
            "71": "Metadata",
            
            "m1": "Please provide content saturation duration.",
            "m2": "Are you sure you want to update {{serverName}} server's settings?",
            "m3": "You can not disable this service because there are active items of this service available on the server.",
            "m4": "Please provide Client id.",
            "m5": "Please provide Client secret.",
            "m6": "Please provide Tenant id.",
            "m7": "Please provide App domain.",
            "m8": "Please provide login button label.",
            "m9": "URL already exists with {{serverName}} server.",
              "m9.1": "SSO URL already exists with {{serverName}} server.",
            "m10": "Please provide entity id.",
            "m11": "Please provide Single sign on URL.",
            "m12": "Please provide Single logout URL.",
            "m13": "Please provide Signing certificate.",
            "m14": "Please provide Type.",
            "m15": "Please provide Host.",
            "m16": "Please provide Bucket.",
            "m17": "Please provide Access key.",
              "m17.1": "The access key is invalid.",
            "m18": "Please provide Secret key.",
              "m18.1": "The secret key is invalid.",
            "m19": "Please provide Session timeout.",
            "m20": "Session timeout should be equal to or greater than 20 minutes.",
            "m21": "Please provide Watermark image.",
            "m22": "Please provide Positions of the image.",
            "m23": "There is not any device.",
            "m26": "Please provide valid Content duration.",
            "m27": "Please provide Monitor time.",
            "m28": "Verification failed. Please try again.",
            "m29": "Please perovide SharePoint customer's app credentials.",
            "m30": "Please provide Google Drive Oauth Settings.",
            "m31": "Please provide Google Drive Service Principal Settings.",
            "m32": "Please provide Metadata.",
            "m33": "You have selected \"Menu Board\". Please proceed by selecting Template or Content Select."
          },
          "dp": {
            "1": "Add Property",
            "2": "Key",
            "3": "Default Value",
            "4": "Yes, delete the property",
            "5": "In device edit page and exported excels, sort these properties by:",
              "5.1": "Save Custom Sorting",
            "m1": "Please provide key.",
            "m2": "Key should not be same.",
            "m3": "You don't have any device properties.",
            "m4": "This action can not be undone. This will delete the selected property from all the devices. Please confirm if you understand the consequences.",
            "m5": "Are you sure you want to leave the current change?",
            "m6": "Please fill out both date and time fields in properties."
          },
          "as": {
            "1": "Add Switch",
            "2": "Switches",
            "3": "Yes, delete the switch",
            "4": "In device edit page and exported excels, sort these switches by:",
            "m1": "You don't have any app switches.",
            "m2": "This action can not be undone. This will delete the selected switch from all the devices. Please confirm if you understand the consequences."
          },
          "rg":{
            "1": "Report type",
              "1-1": "User Logins",
              "1-2": "Content Uploaded",
              "1-3": "Content published by Canva",
              "1-4": "Content published by PowerPoint Publisher",
              "1-5": "Content Deleted",
              "1-6": "Displays with New Content",
              "1-7": "Widget Created",
              "1-8": "Schedule Updated",
              "1-9": "Schedule Expired",
              "1-10": "Schedule Created"
          }
        },
        "p_am": {
          "1": "App Menu",
          "2": "Idle Time",
          "3": "Force Update to All Devices",
          "m1": "Idle Time should not be empty or less than 1 minute.",
          "m2": "Are you sure you want to change Idle Time and Password?"
        },
        "p_dConf": {
          "1": "Available User",
          "2": "Selected User",
          "3": "Make Default",
          "m1": "Please select user."
        }
      },
      "sc": {
        "tab": {
          "1": "Technical Support",
          "2": "Feature Request",
          "3": "Reported Bugs",
          "4": "Video Tutorials"
        },
        "fb": {
          "1": "Submit Your Feedback",
          "2": "Please tell us what you think of this application, good or bad, we want to hear from you.",
          "3": "Feedback",
          "m1": "Please provide feedback."
        },
        "bug": {
          "1": "Report a Bug",
          "2": "{{lsn}} is great! But sometimes there are issues that need to be resolved to make it that much greater. To help us make {{lsn}} better, the team needs your help and you can do this through reporting a bug.",
          "3": "Bug description",
          "4": "Screenshots",
          "5": "Browser",
            "5.1": "Other",
          "6": "Browser version",
          "7": "Create Ticket",
          "m1": "Please provide title.",
          "m2": "Please provide description.",
          "m3": "Please select device."
        },
        "mail": {
          "1": "Mail to Support Team",
          "2": "Need assistance with {{lsn}}? We'll get you the help you need.",
          "3": "Subject",
          "m1": "Subject should not be blank.",
          "m2": "Message should not be blank."
        },
        "ts": {
          "body": {
            "1": "Our technical support service is here to assist you with technical problems with the {{lsnh}} software as well as any hardware and software that was purchased from {{lsn}}. Please note, if your support plan with {{lsn}} does not cover user issues you may incur additional charges.",
            "2": "Documents",
            "3": "Downloads",
            "4": "If you have downloaded a ZIP file, you will need to \"unblock\" it before extracting. Once the download is complete, click on the \"Unblock\" button/checkbox on the ZIP file's properties.",
            "5": "How to unblock zip file",
            "6": "Activation key:",
            "7": "Applications",
            "8": "Applications Info"
          },
          "btn": {
            "1": "Email Technical Support",
            "2": "Report Bug",
            "3": "Feedback",
            "4": "User Guide - English",
            "5": "User Guide - French",
            "6": "Installing Media Player and Setting Up Internet",
            "7": "Firewall Port Settings",
            "8": "L Squared Word Publisher - English",
              "8.1": "L Squared Word Publisher - French",
            "9": "L Squared PowerPoint Publisher - English",
              "9.1": "L Squared PowerPoint Publisher - French",
            "10": "L Squared Slide (Windows - Legacy FSS)",
              "10.1": "L Squared Slide (Windows)",
              "10.2": "L Squared Slide (Linux)",
              "10.3": "L Squared Slide (macOS)",
              "10.4": "L Squared Slide (WebOS)",
              "10.5": "L Squared Slide (Tizen)",
              "10.6": "L Squared Slide (Screensaver)",
              "10.7": "L Squared Publisher (Word and PowerPoint)",
            "11": "L Squared HDMI",
            "12": "See image...",
            "13": "User Guide - Spanish",
            "14": "Deploy WebOS app on LG TV",
              "14.1": "Deploy Tizen app on Samsung TV",
              "14.2": "Deploy eSlide on Media Players",
            "15": "Release Notes",
            "16": "Feature Parity"
          },
          "reNotes":{
            "1": "Stable",
            "2": "Latest",
            "3": "Deprecated",
            "4": "Vulnerable",
            "5": "Prerelease",
            "6": "Nightly",
            "7": "Play Store",
            "8": "Copy App Switch",
            "9": "Copy Path"
          }
        },
        "fr": {
          "body": {
            "1": "What is {{htmlTagO}}Feature Request{{htmlTagC}}?",
            "2": "Requested Features",
            "3": "Accepted Features",
            "4": "Request Details",
            "5": "Vote",
            "6": "Episode",
            "7": "Report abuse",
            "8": "Accepted",
            "9": "Implemented",
            "10": "Implemented Features",
            "5s": "Votes"
          },
          "btn": {
            "1": "Add New Feature Request",
            "2": "Edit Feature Request"
          },
          "p_add": {
            "1": "Please browse through the existing new feature requests first to see if the feature you want has already been requested. If you find one that is similar to what you want, vote for it. There is a higher chance that we will implement the most voted feature in the upcoming release. If you don't find the feature you want in the list, add it here.",
            "2": "Request Title",
            "3": "Description",
            "m1": "Please provide Request title."
          },
          "p_comment": {
            "body": {
              "1": "Total votes",
              "2": "Comment",
              "3": "Edit Comment",
              "4": "Add New Comment",
              "5": "Report this Comment",
              "2s": "Comments"
            },
            "btn": {
              "1": "Vote this feature",
              "2": "Mark as Accepted",
              "3": "Mark as Implemented",
              "4": "Reopen (Move to Accepted)"
            },
            "msg": {
              "1": "You have already voted this feature request.",
              "2": "You can not vote on your own feature request.",
              "3": "Are you sure you want to delete selected Comment?",
              "4": "Comment should not be blank.",
              "5": "No comment yet.",
              "6": "Are you sure you want to mark this feature request as Accepted?",
              "7": "Are you sure you want to mark this feature request as Implement?",
              "8": "Are you sure you want to move this feature request in Accepted list?"
            }
          },
          "msg": {
            "1": "Please provide Description.",
            "2": "Are you sure you want to delete selected Feature Request?",
            "3": "You have already reported this feature request.",
            "4": "There is not any requested feature.",
            "5": "What is Requested Feature?",
            "6": "There is not any accepted feature.",
            "7": "What is Accepted Feature?",
            "8": "There is not any implemented feature.",
            "9": "What is Implemented Feature?"
          },
          "info": {
            "1": "We typically release a major version update to the {{lsnh}} once a year and three to four minor revisions throughout the year. The way we select which new features to work on is influenced heavily by the features our users request. Please take a few minutes to tell us what we can improve in our system to help you do more with the {{lsnh}}.",
            "2": "Features that are requested by {{lsnh}} users of different servers are listed in Requested Features tab. If you require some feature in {{lsnh}} that does not exists in it, you can request it here.",
            "3": "Feature requests that are accepted for development by {{lsn}} Team are listed in Accepted Features tab.",
            "4": "Feature requests that are implemented in Hub are listed in Implemented Features tab."
          }
        },
        "kb": {
          "1": "L Squared Hub Video Tutorial Series.",
          "2": "Episode {{count}}"
        }
      },
      "as": {
        "label": {
          "1": "Creation date range",
          "2": "Schedule date range",
          "3": "Select user",
          "4": "Schedule name",
          "5": "Available Tags",
          "6": "Include",
          "7": "Exclude",
          "8": "Tag",
          "9": "AND",
          "10": "Any",
          "11": "All Content",
          "12": "All Widgets",
          "13": "Select OS",
          "14": "Select client"
        },
        "btn": {
          "1": "Search",
          "2": "Searching"
        },
        "msg": {
          "1": "Please provide at least one filter option.",
          "2": "Your search did not match any item. Try different keywords.",
          "3": "Device search can only be made for one type of device."
        }
      },
      "b": {
        "tab":{
          "1": "Subscriptions",
          "2": "Place Order"
        },
        "d":{
          "1": "Last Payment",
          "2": "On {{date}}",
          "3": "Next payment due on",
          "4": "Next payment amount",
          "5": "Subscription",
          "6": "Item",
          "7": "License count",
          "8": "Next payment due",
          "9": "Status",
            "9.1": "Trial Active",
            "9.2": "Active",
            "9.3": "Incomplete",
            "9.4": "Incomplete expired",
            "9.5": "Past due",
            "9.6": "Canceled",
            "9.7": "Unpaid",
            "9.8": "Trial Expired",
          "10": "Amount"
        },
        "o":{
          "1": "Number of licenses",
            "1.1": "License",
            "1.2": "Licenses",
          "2": "Subscriptions",
            "2.1": "Daily",
            "2.2": "Weekly",
            "2.3": "Monthly",
            "2.4": "Yearly",
          "3": "Billing address",
          "4": "Buy media player",
          "5": "Shipping address is same as company address",
          "6": "Shipping address",
          "7": "Order Summary",
          "8": "One-time fee",
          "9": "Media player",
            "9.1": "${{price}} per unit.",
          "10": "Order Total (USD)",
          "11": "Includes a {{val}}% ({{type}}) tax",
          "12": "Shipping costs excluded",
          "13": "Credit or debit card",
          "14": "Next: Review & Pay",
            "14.1": "Review & Pay",
          "15": "Make Payment",
          "16": "Pay",
            "16i": "Paying",
          "17": "I accept the {{htmlTagO}}Terms and Conditions{{htmlTagC}}",
          "18": "I accept the {{htmlTagO}}Service Level Agreement{{htmlTagC}}",
          "19": "Quantity",
          "20": "View more",
          "21": "Hide more",
          "22.0": "${{price}} per year.",
          "22.1": "${{price}} per month.",
          "22.2": "${{price}} per week.",
          "22.3": "${{price}} per day.",
          "23": "Billing & shipping address",
          "24": "Model",
          "25": "CPU",
          "26": "Memory",
          "27": "Hard Drive",
          "28": "Graphics",
          "29": "Audio",
          "30": "LAN",
          "31": "Wireless LAN",
          "32": "Price",
          "33": "Bluetooth",
          "34": "Display Support",
          "35": "Weight",
          "36": "Dimensions",
          "37": "Power Consumption",
          "38": "OS"
        },
        "label":{
          "14": "Suspended",
          "15": "Buy new license"
        },
        "sd":{
          "1": "Subscription id",
            "1.1": "Subscription Details",
          "2": "License",
          "3": "Purchaser",
          "4": "Transition Id",
          "5": "License cost (USD)",
          "6": "Media player cost (USD)",
          "7": "Change ownership",
          "8": "Cancel subscription",
          "9": "Transition Type",
            "9.1": "One time payment",
            "9.2": "Recurring/Subscription payment"
        },
        "msg":{
          "1": "You don't have any subscription yet.",
          "2": "You don't have any invoice yet.",
          "3": "Please provide licenses.",
          "4": "Please provide Post / Zip code.",
          "5": "Please provide media player quantity.",
          "6": "Oops! Payment cancelled. Please try again.",
          "7": "Required parameters did not find.",
          "8": "Paypal data invalid",
          "9": "Subscription does not exist.",
          "10": "Issue with subscription.",
          "11": "Payment cancelled and required parameters did not find.",
          "12": "Are you sure you want to cancel subscription?",
          "13": "Invalid subscription to renewal or not found.",
          "14": "Invalid status of subscription to renew.",
          "15": "Need Help? Call our customer support team at {{htmlTagO}}+1 (416) 628-5401{{htmlTagC}}",
          "16": "Please provide valid card number.",
          "17": "Your card's expiration year is in the past.",
          "18": "Your card was declined. Your request was in live mode, but used a known test card.",
          "19": "You don't have any order Review & Pay.",
          "20": "Once the payment is successful, a {{type}} subscription will be created. Next subscription amount will be automatically deducted from card."
        }
      },
      "p_iotC":{
        "1": "IoT Central Settings",
        "2": "Admin API Token",
        "3": "Sub Domain",
        "4": "DNS Suffix",
        "5": "Application ID",
        "msg":{
          "1": "Please provide admin token id.",
          "2": "Please provide sub domain.",
          "3": "Please provide dns suffix.",
          "4": "Please provide application id."
        }
      },
      "in": {
        "btn": {
          "1": "Add New Item",
          "2": "Show/Hide Columns"
        },
        "body": {
          "1": "Item types",
          "2": "Deployed This Week",
          "3": "Added This Week",
          "4": "Warranty Expiring"
        },
        "p_i": {
          "1": "Update Item",
          "2": "Type",
          "3": "Model",
          "4": "Manufacturer",
          "5": "Serial",
          "6": "PO#",
          "7": "Location",
          "8": "Purchased on",
          "9": "Installed on",
          "10": "Removed on",
          "11": "Decommissioned on",
          "12": "Warranty",
            "12.1": "Day",
            "12.1s": "Days",
            "12.2": "Month",
            "12.3": "Year",
          "13": "Extended Warranty",
          "14": "Remaining Warranty",
          "15": "Status",
            "15.0":"Available",
            "15.1":"Deployed",
            "15.2":"Retired",
          "16": "Warranty start on",
          "17": "Cost",
          "18": "Purchase from",
          "19": "Deployed On",
          "20": "Retired On",
          "21": "Added On",
          "22": "Create New Type",
          "23": "Others",
          "24": "Device Types",
          "m1": "Please select Type.",
          "m2": "Please provide Model",
          "m3": "Please provide Manufacturer",
          "m4": "Please provide Serial",
          "m5": "Please provide PO",
          "m6": "Please provide Location",
          "m7": "Please provide Status",
          "m8": "Please provide Purchased On",
          "m9": "There is not any file.",
          "m10": "Please provide Description.",
          "m11": "Please provide Cost.",
          "m12": "Please provide Purchase from.",
          "m13": "Please provide Warranty.",
          "m14": "Please provide Extended Warranty.",
          "m15": "Serial number already exists."
        },
        "msg": {
          "1": "You don't have any inventory yet. When you create some, they'll appear here.",
          "2": "You don't have any available yet.",
          "3": "You don't have any deployed yet.",
          "4": "You don't have any retired yet.",
          "5": "You don't have any deployed inventory this week yet.",
          "6": "You don't have any added inventory This Week yet.",
          "7": "You don't have any expiring warranty inventory yet.",
          "8": "You don't have any inventory type yet."
        }
      },
      "notification": [
        {
          "id": 6019,
          "en": "Password sent to "
        },
        {
          "id": 6059,
          "en": "Message sent"
        },
        {
          "id": 7001,
          "en": "Device registered on map."
        },
        {
          "id": 7011,
          "en": "Dashboard updated."
        },
        {
          "id": 7013,
          "en": "Devices feed updated."
        },
        {
          "id": 8001,
          "en": "Content uploaded."
        },
        {
          "id": 8002,
          "en": "Content updated."
        },
        {
          "id": 8003,
          "en": "Content moved to the Deleted Content tab."
        },
        {
          "id": 8004,
          "en": "Web Page widget created."
        },
        {
          "id": 8005,
          "en": "Web Page widget updated."
        },
        {
          "id": 8006,
          "en": "Date Time widget created."
        },
        {
          "id": 8007,
          "en": "Date Time widget updated."
        },
        {
          "id": 8008,
          "en": "News widget created."
        },
        {
          "id": 8009,
          "en": "News widget updated."
        },
        {
          "id": 8010,
          "en": "Weather widget created."
        },
        {
          "id": 8011,
          "en": "Weather widget updated."
        },
        {
          "id": 8012,
          "en": "YouTube widget created."
        },
        {
          "id": 8013,
          "en": "YouTube widget updated."
        },
        {
          "id": 8014,
          "en": "X widget created."
        },
        {
          "id": 8015,
          "en": "X widget updated."
        },
        {
          "id": 8016,
          "en": "RSS widget created."
        },
        {
          "id": 8017,
          "en": "RSS widget updated."
        },
        {
          "id": 8018,
          "en": "Flight Schedule widget created."
        },
        {
          "id": 8019,
          "en": "Flight Schedule widget updated."
        },
        {
          "id": 8020,
          "en": "Meetings widget created."
        },
        {
          "id": 8021,
          "en": "Meetings widget updated."
        },
        {
          "id": 8022,
          "en": "Quotes widget created."
        },
        {
          "id": 8023,
          "en": "Quotes widget updated."
        },
        {
          "id": 8024,
          "en": "Live Streaming widget created."
        },
        {
          "id": 8025,
          "en": "Live Streaming widget updated."
        },
        {
          "id": 8026,
          "en": "Stock Price widget created."
        },
        {
          "id": 8027,
          "en": "Stock Price widget updated."
        },
        {
          "id": 8028,
          "en": "FTP widget created."
        },
        {
          "id": 8029,
          "en": "FTP widget updated."
        },
        {
          "id": 8030,
          "en": "Delimited Text widget created."
        },
        {
          "id": 8031,
          "en": "Delimited Text widget updated."
        },
        {
          "id": 8032,
          "en": "Currency widget created."
        },
        {
          "id": 8033,
          "en": "Currency widget updated."
        },
        {
          "id": 8034,
          "en": "Free Form widget created."
        },
        {
          "id": 8035,
          "en": "Free Form widget updated."
        },
        {
          "id": 8036,
          "en": "Open Hours widget created."
        },
        {
          "id": 8037,
          "en": "Open Hours widget updated."
        },
        {
          "id": 8038,
          "en": "Instagram widget created."
        },
        {
          "id": 8039,
          "en": "Instagram widget updated."
        },
        {
          "id": 8040,
          "en": "Filler Content widget created."
        },
        {
          "id": 8041,
          "en": "Filler Content widget updated."
        },
        {
          "id": 8042,
          "en": "TouchLink widget created."
        },
        {
          "id": 8043,
          "en": "TouchLink widget updated."
        },
        {
          "id": 8044,
          "en": "Windows Task widget created."
        },
        {
          "id": 8045,
          "en": "Windows Task widget updated."
        },
        {
          "id": 8046,
          "en": "SunSmart widget created."
        },
        {
          "id": 8047,
          "en": "SunSmart widget updated."
        },
        {
          "id": 8048,
          "en": "IFrame widget created."
        },
        {
          "id": 8049,
          "en": "IFrame widget updated."
        },
        {
          "id": 8050,
          "en": "TouchLink Meetings widget created."
        },
        {
          "id": 8051,
          "en": "TouchLink Meetings widget updated."
        },
        {
          "id": 8052,
          "en": "Web Cam widget created."
        },
        {
          "id": 8053,
          "en": "Web Cam widget updated."
        },
        {
          "id": 8054,
          "en": "Telax widget created."
        },
        {
          "id": 8055,
          "en": "Telax widget updated."
        },
        {
          "id": 8056,
          "en": "Fullscreen Chrome widget created."
        },
        {
          "id": 8057,
          "en": "Fullscreen Chrome widget updated."
        },
        {
          "id": 8058,
          "en": "Online Radio widget created."
        },
        {
          "id": 8059,
          "en": "Online Radio widget updated."
        },
        {
          "id": 8060,
          "en": "Interactive Menu widget created."
        },
        {
          "id": 8061,
          "en": "Interactive Menu widget updated."
        },
        {
          "id": 8062,
          "en": "Text widget created."
        },
        {
          "id": 8063,
          "en": "Text widget updated."
        },
        {
          "id": 8064,
          "en": "Google Calendar widget created."
        },
        {
          "id": 8065,
          "en": "Google Calendar widget updated."
        },
        {
          "id": 8066,
          "en": "Readerboard widget created."
        },
        {
          "id": 8067,
          "en": "Readerboard widget updated."
        },
        {
          "id": 8068,
          "en": "Web Login widget created."
        },
        {
          "id": 8069,
          "en": "Web Login widget updated."
        },
        {
          "id": 8070,
          "en": "Folder created."
        },
        {
          "id": 8071,
          "en": "Folder updated."
        },
        {
          "id": 8072,
          "en": "Folder deleted."
        },
        {
          "id": 8073,
          "en": "Content archived."
        },
        {
          "id": 8074,
          "en": "Content unapproved."
        },
        {
          "id": 8075,
          "en": "Item(s) moved."
        },
        {
          "id": 8076,
          "en": "A new version of content has been uploaded."
        },
        {
          "id": 8081,
          "en": "Content approved."
        },
        {
          "id": 8082,
          "en": "All content of the folder has been approved."
        },
        {
          "id": 8083,
          "en": "All content of the folder has been unapproved."
        },
        {
          "id": 8084,
          "en": "Content restored."
        },
        {
          "id": 8094,
          "en": "Item(s) moved to other server."
        },
        {
          "id": 8095,
          "en": "Item(s) copied."
        },
        {
          "id": 8096,
          "en": "Item(s) copied to other server."
        },
        {
          "id": 8098,
          "en": "Content deleted forever."
        },
        {
          "id": 8103,
          "en": "Content created."
        },
        {
          "id": 8104,
          "en": "You don't have permission to move selected items on this server."
        },
        {
          "id": 8106,
          "en": "Parent folder does not exists and you do not have permission to add content in home directory."
        },
        {
          "id": 8108,
          "en": "Shortcut created."
        },
        {
          "id": 8100,
          "en": "Remove expiry."
        },
        {
          "id": 8111,
          "en": "Queue widget created"
        },
        {
          "id": 8112,
          "en": "Queue widget updated."
        },
        {
          "id": 8113,
          "en": "Queue updated."
        },
        {
          "id": 8116,
          "en": "Authorization successful."
        },
        {
          "id": 8140,
          "en": "Prayer widget created."
        },
        {
          "id": 8141,
          "en": "Prayer widget updated."
        },
        {
          "id": 8142,
          "en": "Authorization successful."
        },
        {
          "id": 8119,
          "en": "Facebook widget created."
        },
        {
          "id": 8120,
          "en": "Facebook widget updated."
        },
        {
          "id": 8121,
          "en": "Traffic widget created."
        },
        {
          "id": 8122,
          "en": "Traffic widget updated."
        },
        {
          "id": 8618,
          "en": "AQI widget created."
        },
        {
          "id": 8619,
          "en": "AQI widget updated."
        },
        {
          "id": 8644,
          "en": "Microsoft Teams Channel widget created."
        },
        {
          "id": 8645,
          "en": "Microsoft Teams Channel widget updated."
        },
        {
          "id": 8664,
          "en": "Content removed."
        },
        {
          "id": 8691,
          "en": "Achievers widget created."
        },
        {
          "id": 8692,
          "en": "Achievers widget updated."
        },
        {
          "id": 8123,
          "en": "Survey widget created."
        },
        {
          "id": 8124,
          "en": "Survey widget updated."
        },
        {
          "id": 8125,
          "en": "Survey finished."
        },
        {
          "id": 8127,
          "en": "Music Choice widget created."
        },
        {
          "id": 8128,
          "en": "Music Choice widget updated."
        },
        {
          "id": 8130,
          "en": "Survey reopened."
        },
        {
          "id": 8134,
          "en": "webex by CISCO widget created."
        },
        {
          "id": 8135,
          "en": "webex by CISCO widget updated."
        },
        {
          "id": 8137,
          "en": "Microsoft Outlook widget created."
        },
        {
          "id": 8138,
          "en": "Microsoft Outlook widget updated."
        },
        {
          "id": 8143,
          "en": "Microsoft Power BI widget created."
        },
        {
          "id": 8144,
          "en": "Microsoft Power BI widget updated."
        },
        {
          "id": 8147,
          "en": "LifeLabs Patient Wait widget created."
        },
        {
          "id": 8148,
          "en": "LifeLabs Patient Wait widget updated."
        },
        {
          "id": 8149,
          "en": "Schedule calendar widget created."
        },
        {
          "id": 8150,
          "en": "Schedule calendar widget updated."
        },
        {
          "id": 8151,
          "en": "Select social media widget created."
        },
        {
          "id": 8152,
          "en": "Select social media widget updated."
        },
        {
          "id": 8156,
          "en": "NextBus widget created."
        },
        {
          "id": 8157,
          "en": "NextBus widget updated."
        },
        {
          "id": 8158,
          "en": "Meta tag deleted."
        },
        {
          "id": 8160,
          "en": "Meta tag added."
        },
        {
          "id": 8161,
          "en": "Screensaver added."
        },
        {
          "id": 8162,
          "en": "Screensaver updated."
        },
        {
          "id": 8163,
          "en": "Screensaver deleted."
        },
        {
          "id": 8167,
          "en": "Web Login Chrome widget created."
        },
        {
          "id": 8168,
          "en": "Web Login Chrome widget updated."
        },
        {
          "id": 8169,
          "en": "FIFA widget created."
        },
        {
          "id": 8170,
          "en": "FIFA widget updated."
        },
        {
          "id": 8175,
          "en": "Next Vehicle widget created."
        },
        {
          "id": 8176,
          "en": "Next Vehicle widget updated."
        },
        {
          "id": 8177,
          "en": "LinkedIn widget created."
        },
        {
          "id": 8178,
          "en": "LinkedIn widget updated."
        },
        {
          "id": 8185,
          "en": "Calendar of Events updated."
        },
        {
          "id": 8186,
          "en": "Calendar of Events View created."
        },
        {
          "id": 8187,
          "en": "Calendar of Events View updated."
        },
        {
          "id": 8190,
          "en": "Microsoft Excel Sheet widget created."
        },
        {
          "id": 8191,
          "en": "Microsoft Excel Sheet widget updated."
        },
        {
          "id": 8192,
          "en": "Microsoft Viva Engage widget created."
        },
        {
          "id": 8193,
          "en": "Microsoft Viva Engage widget updated."
        },
        {
          "id": 8198,
          "en": "Count widget created."
        },
        {
          "id": 8199,
          "en": "Count widget updated."
        },
        {
          "id": 8200,
          "en": "Vimeo widget created."
        },
        {
          "id": 8201,
          "en": "Vimeo widget updated."
        },
        {
          "id": 8203,
          "en": "AGC widget created."
        },
        {
          "id": 8204,
          "en": "AGC widget updated."
        },
        {
          "id": 8207,
          "en": "Training Mode widget created."
        },
        {
          "id": 8208,
          "en": "Training Mode widget updated."
        },
        {
          "id": 8209,
          "en": "Wait Queue Metro widget created."
        },
        {
          "id": 8210,
          "en": "Wait Queue Metro widget updated."
        },
        {
          "id": 8216,
          "en": "Google Slide widget created."
        },
        {
          "id": 8217,
          "en": "Google Slide widget updated."
        },
        {
          "id": 8220,
          "en": "Video captions updated."
        },
        {
          "id": 8223,
          "en": "CorpComm: Alert Message widget created."
        },
        {
          "id": 8224,
          "en": "CorpComm: Alert Message widget updated."
        },
        {
          "id": 8221,
          "en": "Facebook workplace Added."
        },
        {
          "id": 8222,
          "en": "Facebook workplace Edited."
        },
        {
          "id": 8228,
          "en": "Xovis widget created."
        },
        {
          "id": 8229,
          "en": "Xovis widget updated."
        },
        {
          "id": 8230,
          "en": "Microsoft Teams widget created."
        },
        {
          "id": 8231,
          "en": "Microsoft Teams widget updated."
        },
        {
          "id": 8643,
          "en": "Microsoft Teams Room widget created."
        },
        {
          "id": 8642,
          "en": "Microsoft Teams Room widget updated."
        },
        {
          "id": 8232,
          "en": "Unisys widget created."
        },
        {
          "id": 8233,
          "en": "Unisys widget updated."
        },
        {
          "id": 8235,
          "en": "Content on Demand widget created."
        },
        {
          "id": 8236,
          "en": "Content on Demand widget updated."
        },
        {
          "id": 8237,
          "en": "QR Code widget created."
        },
        {
          "id": 8238,
          "en": "QR Code widget updated."
        },
        {
          "id": 8239,
          "en": "F45 widget created."
        },
        {
          "id": 8240,
          "en": "F45 widget updated."
        },
        {
          "id": 8247,
          "en": "Content Group widget created."
        },
        {
          "id": 8248,
          "en": "Content Group widget updated."
        },
        {
          "id": 8252,
          "en": "External Input widget created."
        },
        {
          "id": 8253,
          "en": "External Input widget updated."
        },
        {
          "id": 8255,
          "en": "Video's caption imported."
        },
        {
          "id": 8256,
          "en": "Video's caption updated."
        },
        {
          "id": 8257,
          "en": "Video's caption deleted."
        },
        {
          "id": 8258,
          "en": "Caption language added."
        },
        {
          "id": 8259,
          "en": "Caption language updated."
        },
        {
          "id": 8260,
          "en": "Caption language deleted."
        },
        {
          "id": 8262,
          "en": "Video's caption added."
        },
        {
          "id": 8263,
          "en": "Video's cue time added."
        },
        {
          "id": 8264,
          "en": "Video's cue time deleted."
        },
        {
          "id": 8265,
          "en": "Message widget created."
        },
        {
          "id": 8266,
          "en": "Message widget updated."
        },
        {
          "id": 8267,
          "en": "Item added to favorites."
        },
        {
          "id": 8268,
          "en": "Item removed from favorites."
        },
        {
          "id": 8292,
          "en": "Iot Button widget created."
        },
        {
          "id": 8293,
          "en": "Iot Button widget updated."
        },
        {
          "id": 8296,
          "en": "Event synced successfully."
        },
        {
          "id": 8297,
          "en": "Event updated."
        },
        {
          "id": 8298,
          "en": "Event duplicated."
        },
        {
          "id": 8299,
          "en": "Event added."
        },
        {
          "id": 8300,
          "en": "Event deleted."
        },
        {
          "id": 8303,
          "en": "Item pinned successfully."
        },
        {
          "id": 8304,
          "en": "Item is already pinned."
        },
        {
          "id": 8305,
          "en": "Item unpinned successfully."
        },
        {
          "id": 8270,
          "en": "F45 Content Scroller widget created."
        },
        {
          "id": 8271,
          "en": "F45 Content Scroller widget updated."
        },
        {
          "id": 8272,
          "en": "F45 Countdown Circle widget created."
        },
        {
          "id": 8273,
          "en": "F45 Countdown Circle widget updated."
        },
        {
          "id": 8274,
          "en": "F45 Hydrate widget created."
        },
        {
          "id": 8275,
          "en": "F45 Hydrate widget updated."
        },
        {
          "id": 8276,
          "en": "F45 Move Station widget created."
        },
        {
          "id": 8277,
          "en": "F45 Move Station widget updated."
        },
        {
          "id": 8278,
          "en": "Progress Bar widget created."
        },
        {
          "id": 8279,
          "en": "Progress Bar widget updated."
        },
        {
          "id": 8280,
          "en": "F45 Progress Bar with Break widget created."
        },
        {
          "id": 8281,
          "en": "F45 Progress Bar with Break widget updated."
        },
        {
          "id": 8282,
          "en": "F45 Work widget created."
        },
        {
          "id": 8283,
          "en": "F45 Work widget updated."
        },
        {
          "id": 8284,
          "en": "F45 Stay widget created."
        },
        {
          "id": 8285,
          "en": "F45 Stay widget updated."
        },
        {
          "id": 8286,
          "en": "F45 Content Tile widget created."
        },
        {
          "id": 8287,
          "en": "F45 Content Tile widget updated."
        },
        {
          "id": 8288,
          "en": "F45 Story widget created."
        },
        {
          "id": 8289,
          "en": "F45 Story widget updated."
        },
        {
          "id": 8290,
          "en": "Blank widget created."
        },
        {
          "id": 8291,
          "en": "Blank widget updated."
        },
        {
          "id": 8648,
          "en": "Tableau widget created."
        },
        {
          "id": 8649,
          "en": "Tableau widget updated."
        },
        {
          "id": 8301,
          "en": "Intel Smart Building widget created."
        },
        {
          "id": 8302,
          "en": "Intel Smart Building widget updated."
        },
        {
          "id": 8323,
          "en": "Amazon QuickSight widget created."
        },
        {
          "id": 8324,
          "en": "Amazon QuickSight widget updated."
        },
        {
          "id": 8325,
          "en": "Grafana Cloud widget created."
        },
        {
          "id": 8326,
          "en": "Grafana Cloud widget updated."
        },
        {
          "id": 8327,
          "en": "Auto Login (Basic Auth) widget created."
        },
        {
          "id": 8328,
          "en": "Auto Login (Basic Auth) widget updated."
        },
        {
          "id": 8329,
          "en": "Storm widget created."
        },
        {
          "id": 8330,
          "en": "Storm widget updated."
        },
        {
          "id": 8331,
          "en": "TSC Country Mile widget created."
        },
        {
          "id": 8332,
          "en": "TSC Country Mile widget updated."
        },
        {
          "id": 8334,
          "en": "Verkada widget created."
        },
        {
          "id": 8335,
          "en": "Verkada widget updated."
        },
        {
          "id": 8616,
          "en": "F45 Animation widget created."
        },
        {
          "id": 8617,
          "en": "F45 Animation widget updated."
        },
        {
          "id": 8620,
          "en": "Intel JCI Map widget created."
        },
        {
          "id": 8621,
          "en": "Intel JCI Map widget updated."
        },
        {
          "id": 8622,
          "en": "Firstup widget created."
        },
        {
          "id": 8623,
          "en": "Firstup widget updated."
        },
        {
          "id": 8624,
          "en": "HD Steth widget created."
        },
        {
          "id": 8625,
          "en": "HD Steth widget updated."
        },
        {
          "id": 8626,
          "en": "Advertisement added."
        },
        {
          "id": 8627,
          "en": "Advertisement updated."
        },
        {
          "id": 8628,
          "en": "Advertisement deleted."
        },
        {
          "id": 8629,
          "en": "Mapping updated."
        },
        {
          "id": 8632,
          "en": "Button widget created."
        },
        {
          "id": 8633,
          "en": "Button widget updated."
        },
        {
          "id": 8630,
          "en": "Cisco Meraki widget created."
        },
        {
          "id": 8631,
          "en": "Cisco Meraki widget updated."
        },
        {
          "id": 8636,
          "en": "Intel Circuit Bench widget created."
        },
        {
          "id": 8637,
          "en": "Intel Circuit Bench widget updated."
        },
        {
          "id": 8634,
          "en": "CoM Events widget added."
        },
        {
          "id": 8635,
          "en": "CoM Events widget updated."
        },
        {
          "id": 8638,
          "en": "Complex synced successfully."
        },
        {
          "id": 8639,
          "en": "Facility synced successfully."
        },
        {
          "id": 8681,
          "en": "Qlik widget added."
        },
        {
          "id": 8682,
          "en": "Qlik widget updated."
        },
        {
          "id": 8646,
          "en": "CoM Pylon Text widget created."
        },
        {
          "id": 8647,
          "en": "CoM Pylon Text widget updated."
        },
        {
          "id": 8671,
          "en": "Cloud Farm widget added."
        },
        {
          "id": 8672,
          "en": "Cloud Farm widget updated."
        },
        {
          "id": 8171,
          "en": "Pandora CloudCover widget added."
        },
        {
          "id": 8172,
          "en": "Pandora CloudCover widget updated."
        },
        {
          "id": 8195,
          "en": "Authorization failed."
        },
        {
          "id": 8196,
          "en": "Authorization successful."
        },
        {
          "id": 9001,
          "en": "Template created."
        },
        {
          "id": 9002,
          "en": "Template updated."
        },
        {
          "id": 9003,
          "en": "Template deleted."
        },
        {
          "id": 9005,
          "en": "Template approved."
        },
        {
          "id": 9006,
          "en": "Template unapproved."
        },
        {
          "id": 9012,
          "en": "Created a copy of selected item(s)."
        },
        {
          "id": 9014,
          "en": "Selected Template has been moved to Templates tab. You can use it now."
        },
        {
          "id": 9016,
          "en": "Template category deleted."
        },
        {
          "id": 9021,
          "en": "Item(s) moved."
        },
        {
          "id": 9023,
          "en": "Item(s) copied."
        },
        {
          "id": 9024,
          "en": "Template deleted."
        },
        {
          "id": 9025,
          "en": "Folder created."
        },
        {
          "id": 9026,
          "en": "Folder updated."
        },
        {
          "id": 9027,
          "en": "Dynamic text updated."
        },
        {
          "id": 10001,
          "en": "Schedule created."
        },
        {
          "id": 10002,
          "en": "Schedule updated."
        },
        {
          "id": 10003,
          "en": "Schedule deleted."
        },
        {
          "id": 10004,
          "en": "Schedule Group created."
        },
        {
          "id": 10005,
          "en": "Schedule Group updated."
        },
        {
          "id": 10006,
          "en": "Schedule Group deleted."
        },
        {
          "id": 10007,
          "en": "Schedule approved."
        },
        {
          "id": 10008,
          "en": "Schedule unapproved."
        },
        {
          "id": 10017,
          "en": "Schedule group updated."
        },
        {
          "id": 10022,
          "en": "Item(s) added to schedule."
        },
        {
          "id": 11001,
          "en": "Frame Layout created."
        },
        {
          "id": 11002,
          "en": "Frame Layout updated."
        },
        {
          "id": 11003,
          "en": "Frame Layout deleted."
        },
        {
          "id": 11005,
          "en": "Frame Layout approved."
        },
        {
          "id": 11006,
          "en": "Frame Layout unapproved."
        },
        {
          "id": 11007,
          "en": "Selected Frame Layout has been moved to Frame Layouts tab. You can use it now."
        },
        {
          "id": 11008,
          "en": "Assignment deleted."
        },
        {
          "id": 11009,
          "en": "Frame Layout assigned."
        },
        {
          "id": 11010,
          "en": "Assignment updated."
        },
        {
          "id": 11015,
          "en": "Assignment approved."
        },
        {
          "id": 11016,
          "en": "Assignment unapproved."
        },
        {
          "id": 11018,
          "en": "Created a copy of selected layout(s)."
        },
        {
          "id": 11020,
          "en": "Selected layout(s) copy to other server."
        },
        {
          "id": 11021,
          "en": "Selected layout(s) move to other server."
        },
        {
          "id": 11028,
          "en": "Frame Layout category deleted."
        },
        {
          "id": 12001,
          "en": "Device added."
        },
        {
          "id": 12002,
          "en": "Device updated."
        },
        {
          "id": 12003,
          "en": "Device deleted."
        },
        {
          "id": 12004,
          "en": "Device Group saved."
        },
        {
          "id": 12006,
          "en": "Device Group deleted."
        },
        {
          "id": 12007,
          "en": "Device Tag saved."
        },
        {
          "id": 12008,
          "en": "Device Tag updated."
        },
        {
          "id": 12009,
          "en": "Device Tag deleted."
        },
        {
          "id": 12012,
          "en": "Device data usage settings updated."
        },
        {
          "id": 12019,
          "en": "Device group updated."
        },
        {
          "id": 12024,
          "en": "Device group updated."
        },
        {
          "id": 12043,
          "en": "Identify request sent."
        },
        {
          "id": 12044,
          "en": "Identify request deleted."
        },
        {
          "id": 12048,
          "en": "Device group created."
        },
        {
          "id": 12051,
          "en": "Search updated."
        },
        {
          "id": 12055,
          "en": "TV settings imported."
        },
        {
          "id": 12056,
          "en": "TV settings updated."
        },
        {
          "id": 12062,
          "en": "Lock screen added."
        },
        {
          "id": 12063,
          "en": "All other inventory upload completed."
        },
        {
          "id": 12065,
          "en": "Device info updated."
        },
        {
          "id": 12068,
          "en": "Tags updated."
        },
        {
          "id": 12077,
          "en": "Device auto registration import completed."
        },
        {
          "id": 12086,
          "en": "TV Settings updated."
        },
        {
          "id": 12088,
          "en": "Properties updated."
        },
        {
          "id": 12092,
          "en": "Data Usage Settings updated."
        },
        {
          "id": 12098,
          "en": "On/Off Schedule updated."
        },
        {
          "id": 12099,
          "en": "Watermark added."
        },
        {
          "id": 12101,
          "en": "Watermark deleted."
        },
        {
          "id": 12100,
          "en": "Watermark updated."
        },
        {
          "id": 12102,
          "en": "Edit device file import."
        },
        {
          "id": 12104,
          "en": "Folder created."
        },
        {
          "id": 12105,
          "en": "Folder updated."
        },
        {
          "id": 12106,
          "en": "Folder deleted."
        },
        {
          "id": 12107,
          "en": "Item(s) moved."
        },
        {
          "id": 12103,
          "en": "Watermark settings updated."
        },
        {
          "id": 13001,
          "en": "User invited."
        },
        {
          "id": 13002,
          "en": "User access updated."
        },
        {
          "id": 13003,
          "en": "User deleted."
        },
        {
          "id": 13004,
          "en": "User Group saved."
        },
        {
          "id": 13005,
          "en": "User Group updated."
        },
        {
          "id": 13006,
          "en": "User Group deleted."
        },
        {
          "id": 13007,
          "en": "User role created."
        },
        {
          "id": 13008,
          "en": "User role updated."
        },
        {
          "id": 13009,
          "en": "User role deleted."
        },
        {
          "id": 13010,
          "en": "User unblocked."
        },
        {
          "id": 13011,
          "en": "User blocked."
        },
        {
          "id": 13019,
          "en": "Primary group updated."
        },
        {
          "id": 13022,
          "en": "Password sent to "
        },
        {
          "id": 13026,
          "en": "User invited again."
        },
        {
          "id": 13039,
          "en": "Two factor authentication enabled."
        },
        {
          "id": 13040,
          "en": "Two factor authentication disabled."
        },
        {
          "id": 14001,
          "en": "Emergency message sent."
        },
        {
          "id": 14002,
          "en": "Settings updated."
        },
        {
          "id": 14003,
          "en": "Sent message deleted."
        },
        {
          "id": 14004,
          "en": "Predefined message deleted."
        },
        {
          "id": 14005,
          "en": "Title image updated."
        },
        {
          "id": 14006,
          "en": "Title image deleted."
        },
        {
          "id": 14007,
          "en": "Predefined message added."
        },
        {
          "id": 14008,
          "en": "Sent message updated."
        },
        {
          "id": 14009,
          "en": "Sent message cancelled."
        },
        {
          "id": 14013,
          "en": "Info updated."
        },
        {
          "id": 15001,
          "en": "Creative service requested."
        },
        {
          "id": 15009,
          "en": "File attached."
        },
        {
          "id": 15012,
          "en": "Support can not create or comment on Creative Services"
        },
        {
          "id": 15027,
          "en": "Video wall created."
        },
        {
          "id": 15028,
          "en": "Video wall updated."
        },
        {
          "id": 16001,
          "en": "New feature request submitted."
        },
        {
          "id": 16002,
          "en": "Feature request updated."
        },
        {
          "id": 16003,
          "en": "Feature request deleted."
        },
        {
          "id": 16004,
          "en": "Feature request accepted."
        },
        {
          "id": 16006,
          "en": "Feature request implemented."
        },
        {
          "id": 16007,
          "en": "Vote submitted."
        },
        {
          "id": 16008,
          "en": "Comment updated."
        },
        {
          "id": 16009,
          "en": "New comment added."
        },
        {
          "id": 16010,
          "en": "Comment deleted."
        },
        {
          "id": 16011,
          "en": "Feature request reported."
        },
        {
          "id": 16017,
          "en": "Feature request reopened."
        },
        {
          "id": 17001,
          "en": "Feedback sent to L Squared team."
        },
        {
          "id": 17002,
          "en": "Bug report submitted."
        },
        {
          "id": 17003,
          "en": "Email sent to L Squared Support."
        },
        {
          "id": 17004,
          "en": "Change email."
        },
        {
          "id": 17005,
          "en": "Change password."
        },
        {
          "id": 17006,
          "en": "Profile image updated."
        },
        {
          "id": 17007,
          "en": "Profile image set to default."
        },
        {
          "id": 17008,
          "en": "Profile updated."
        },
        {
          "id": 17011,
          "en": "New and confirm password not match."
        },
        {
          "id": 17012,
          "en": "Current and new passwords are same."
        },
        {
          "id": 17015,
          "en": "Verification code sent to your current email."
        },
        {
          "id": 17017,
          "en": "Notification settings updated."
        },
        {
          "id": 17018,
          "en": "Polling frequency updated."
        },
        {
          "id": 17020,
          "en": "Prime admin updated."
        },
        {
          "id": 17021,
          "en": "Allowed file types updated."
        },
        {
          "id": 17029,
          "en": "Support coordinator added."
        },
        {
          "id": 17032,
          "en": "Support coordinator removed."
        },
        {
          "id": 17035,
          "en": "Unauthorized user."
        },
        {
          "id": 17038,
          "en": "Custom meeting room added."
        },
        {
          "id": 17039,
          "en": "Custom meeting room updated."
        },
        {
          "id": 17040,
          "en": "Custom meeting room deleted."
        },
        {
          "id": 17043,
          "en": "WebOS setting updated."
        },
        {
          "id": 17047,
          "en": "User added."
        },
        {
          "id": 17048,
          "en": "User updated."
        },
        {
          "id": 17058,
          "en": "Password sent on email."
        },
        {
          "id": 17051,
          "en": "Brand added."
        },
        {
          "id": 17055,
          "en": "Theme updated."
        },
        {
          "id": 17056,
          "en": "Theme reset."
        },
        {
          "id": 17059,
          "en": "Preferences updated."
        },
        {
          "id": 17061,
          "en": "IoT Central setting updated."
        },
        {
          "id": 17071,
          "en": "Priority summary updated."
        },
        {
          "id": 17072,
          "en": "Status of specific device updated."
        },
        {
          "id": 17090,
          "en": "Settings updated."
        },
        {
          "id": 17099,
          "en": "Device properties summary updated."
        },
        {
          "id": 17073,
          "en": "Device properties added."
        },
        {
          "id": 17074,
          "en": "Device properties updated."
        },
        {
          "id": 17075,
          "en": "Device properties deleted."
        },
        {
          "id": 17078,
          "en": "Sorting saved."
        },
        {
          "id": 18012,
          "en": "App switch added."
        },
        {
          "id": 18013,
          "en": "App switch updated."
        },
        {
          "id": 18014,
          "en": "App switch deleted."
        },
        {
          "id": 99001,
          "en": "Image generated successfully."
        },
        {
          "id": 17102,
          "en": "Dashboard updated."
        },
        {
          "id": 17103,
          "en": "Dashboard set as default."
        },
        {
          "id": 17104,
          "en": "Settings updated."
        },
        {
          "id": 17124,
          "en": "Settings updated."
        },
        {
          "id": 17125,
          "en": "Settings reset."
        },
        {
          "id": 1710101,
          "en": "Attribute added."
        },
        {
          "id": 1710102,
          "en": "Attribute deleted."
        },
        {
          "id": 18001,
          "en": "Report sent to "
        },
        {
          "id": 18031,
          "en": "Subscription created."
        },
        {
          "id": 18032,
          "en": "Unsubscribe"
        },
        {
          "id": 19001,
          "en": "License purchased."
        },
        {
          "id": 19012,
          "en": "Subscription created."
        },
        {
          "id": 19013,
          "en": "Subscription cancelled."
        },
        {
          "id": 20001,
          "en": "Item added."
        },
        {
          "id": 20002,
          "en": "Item updated."
        },
        {
          "id": 20003,
          "en": "Item deleted."
        },
        {
          "id": 20006,
          "en": "Attachment added."
        },
        {
          "id": 20007,
          "en": "Attachment deleted."
        },
        {
          "id": 4004,
          "en": "The item you are editing does not exists. Following user has removed it from your server:"
        },
        {
          "id": 9040,
          "en": "Content saved."
        },
        {
          "id": 107,
          "en": "Report generation cancel from the queue."
        },
        {
          "id": 108,
          "en": "Report deleted."
        },
        {
          "id": 1710102345,
          "en": "Video indexing completed."
        },
        {
          "id": 1710102346,
          "en": "Closed Caption added."
        },
        {
          "id": 1710102347,
          "en": "Closed Caption updated."
        },
        {
          "id": 99006,
          "en": "Authorization successful."
        },
        {
          "id": 99007,
          "en": "Authorization failed."
        } 
      ],
      "btnInfo": {
        "2001101": "You do not have permission to add content.",
        "2001102": "You do not have permission to edit content.",
        "2001103": "You do not have permission to delete content.",
        "2001104": "You do not have permission to create folder.",
        "2001105": "You do not have permission to edit folder.",
        "2001106": "You do not have permission to delete folder.",
        "2001107": "You do not have permission to create widget.",
        "2001108": "You do not have permission to edit widget.",
        "2001109": "You do not have permission to delete widget.",
        "2001110": "You do not have permission to move Content.",
        "2001111": "You do not have permission to archive content.",
        "2001112": "You do not have permission for content approval.",
        "2001113": "You do not have permission to add item in home directory.",
        "2001114": "You do not have permission to edit item in home directory.",
        "2001115": "You do not have permission to delete from home directory.",
        "2001116": "You do not have permission to delete folder, delete content and delete widget.",
        "2001117": "You do not have permission to delete content and delete widget.",
        "2001118": "You do not have permission to delete folder and delete content.",
        "2001119": "You do not have permission to delete folder and delete widget.",
        "2001120": "Selected items contains write protected folder, content or widget and you are not administrator of this server.",
        "2001121": "Content is in processing state so you can only delete it if you have delete permission.",
        "2001122": "You cannot have Music Widget and other content in the same schedule.",
        "2001123": "Preview is not available for Music Player device.",
        "2001124": "Preview is not available for EPD device.",
        "2001125": "You do not have permission to approve sensitive contents",
        "2001126": "You do not have permission to approve that sensitive contents which is uploaded by yourself.",
        "2002101": "You do not have the required permission to create a template, {{htmlTag}}(or){{htmlTag}}One of the following permissions are missing for Content Library.{{htmlTagO}}Add content{{htmlTagC}}{{htmlTagO}}Create widget{{htmlTagC}}{{htmlTagO}}Create folder{{htmlTagC}}",
        "2002102": "You do not have permission to edit template.",
        "2002103": "You do not have permission to delete template.",
        "2002104": "You do not have permission for template approval.",
        "2002105": "Multiple templates can not be used at once. Please select and use it one by one.",
        "2002106": "You do not have permission to move template.",
        "2002107": "You do not have permission to edit folder.",
        "2002108": "You do not have permission to delete folder.",
        "2003101": "You do not have permission to create schedule.",
        "2003102": "You do not have permission to edit schedule.",
        "2003103": "You do not have permission to delete schedule.",
        "2003104": "You do not have permission for schedule approval.",
        "2004101": "You do not have permission to create frame layout.",
          "2004101.1": "You do not have permission to create frame layout larger than 1080p (1920x1080).",
        "2004102": "You do not have permission to edit frame layout.",
        "2004103": "You do not have permission to delete frame layout.",
        "2004104": "You do not have permission for frame layout approval.",
        "2004105": "You do not have permission to assign frame layout.",
          "2004105.1": "You do not have permission to assign frame layout larger than 1080p (1920x1080).",
        "2004106": "You do not have permission to edit assignment.",
        "2004107": "You do not have permission to delete assignment.",
        "2004108": "You do not have permission to apply frame layout restriction.",
        "2004109": "You do not have permission to create frame layout.",
          "2004109.1": "You do not have permission to create frame layout and larger than 1080p (1920x1080).",
          "2004109.2": "With the current plan, you are not allowed to create multi-frame layout. Please contact L Squared Support (Support@LSquared.com / +1 (416) 628-5401) to upgrade your plan.",
        "2005101": "You do not have permission to add device.",
        "2005102": "You do not have permission to edit device.",
        "2005103": "You do not have permission to delete device.",
        "2005104": "You do not have permission to add device group.",
        "2005105": "You do not have permission to edit device group.",
        "2005106": "You do not have permission to delete device group.",
        "2005107": "You do not have permission to create device tag.",
        "2005108": "You do not have permission to edit device tag.",
        "2005109": "You do not have permission to delete device tag.",
        "2005110": "You do not have permission to device control.",
        "2005111": "You do not have permission to register/edit device on map.",
        "2005112": "Only similar type of devices can be added to a group.",
        "2005113": "Multiple devices can not be deleted at once.",
        "2005130": "You do not have permission to device preview.",
        "2005131": "An only similar types of devices can be added/remove to a tab.",
        "2005132": "You do not have permission to edit folder.",
        "2005133": "You do not have permission to move.",
        "2005134": "You do not have permission to delete folder.",
        "2006101": "You do not have permission to add or invite user.",
        "2006102": "You do not have permission to edit user.",
        "2006103": "You do not have permission to block user.",
        "2006104": "Selected user is admin and you are not an admin on this server, so you can not perform any operation on it.",
        "2006105": "Selected user is a public user and you are not an admin on this server, so you can not perform any operation on it.",
        "2006106": "This action button is available for server admin only.",
        "2006107": "You do not have permission to edit video wall.",
        "2006108": "You do not have permission to delete video wall."
      },
      "roles": {
        "2": "Content Manager",
        "3": "Content Executive",
        "4": "Administrator",
          "4.1": "Administrator (Prime)",
        "5": "Schedule Manager",
        "6": "Schedule Executive",
        "7": "Device Manager",
        "8": "Device Executive",
        "11": "Frame Manager",
        "12": "Frame Executive",
        "13": "Security Manager",
        "14": "Template Manager",
        "15": "Template Executive",
        "17": "Report",
        "18": "Creative Services",
        "19": "Billing and Payment",
        "21": "Inventory Manager",
        "23": "Menu Board User"
      },
      "rights": {
        "1": "Content Rights",
          "1.1": "Add content",
          "1.2": "Edit content",
          "1.4": "Delete content",
          "1.8": "Create widget",
          "1.16": "Edit widget",
          "1.32": "Delete widget",
          "1.64": "Create folder",
          "1.128": "Edit folder",
          "1.256": "Delete folder",
          "1.512": "Move",
          "1.1024": "Archive",
          "1.2048": "Approval",
          "1.4096": "Add to home directory",
          "1.8192": "Edit in home directory",
          "1.16384": "Delete from home directory",
          "1.32768": "Optimize video",
          "1.65536": "Training Mode",
          "1.131072": "Open AI Image Generation",
          "1.262144": "Sensitive content approver",
        "2": "Template Rights",
          "2.1": "Add",
          "2.2": "Edit",
          "2.4": "Delete",
          "2.8": "Approval",
          "2.16": "Create folder",
          "2.32": "Edit folder",
          "2.64": "Delete folder",
          "2.128": "Move",
          "2.256": "Add to home directory",
          "2.512": "Edit in home directory",
          "2.1024": "Delete from home directory",
        "3": "Schedule Rights",
          "3.1": "Add",
          "3.2": "Schedule to devices",
          "3.4": "Schedule to tags",
          "3.8": "Schedule to groups",
          "3.16": "Edit name & permission",
          "3.32": "Edit schedule",
          "3.64": "Edit content",
          "3.128": "Edit device",
          "3.256": "Edit device tag",
          "3.512": "Edit device group",
          "3.1024": "Edit frame",
          "3.2048": "Delete",
          "3.4096": "Approval",
          "3.8192": "Set content fullscreen",
          "3.16384": "Add to home directory",
        "4": "Frame Layout Rights",
          "4.1": "Add",
          "4.2": "Edit",
          "4.4": "Delete",
          "4.8": "Approval",
          "4.16": "Assignment",
          "4.32": "Set restrictions",
          "4.64": "Edit assignment",
          "4.128": "Delete assignment",
        "5": "Device Rights",
          "5.1": "Add device",
          "5.2": "Edit device",
          "5.4": "Delete device",
          "5.8": "Add group",
          "5.16": "Edit group",
          "5.32": "Delete group",
          "5.64": "Add tag",
          "5.128": "Edit tag",
          "5.256": "Delete tag",
          "5.512": "Device control",
          "5.1024": "Register/Edit device on map",
          "5.2048": "Export device list",
          "5.4096": "Device preview",
          "5.8192": "Create Folder",
          "5.16384": "Edit Folder",
          "5.32768": "Delete Folder",
          "5.65536": "Move",
          "5.131072": "Add video wall",
          "5.262144": "Edit video wall",
          "5.524288": "Delete video wall",
        "6": "User Rights",
          "6.1": "Invite",
          "6.2": "Invite administrator",
          "6.4": "Edit",
          "6.8": "Block",
          "6.16": "Add role",
          "6.32": "Edit role",
          "6.64": "Delete role",
          "6.128": "Add group",
          "6.256": "Edit group",
          "6.512": "Delete group",
        "7": "Other Rights",
          "7.1": "Emergency Message",
          "7.2": "Reports",
          "7.4": "Creative Service",
          "7.8": "Billing and Payment",
        "66": "Inventory Rights",
          "66.1": "Add",
          "66.2": "Edit",
          "66.4": "Delete",
          "66.8":"View Device list",
          "66.16":"Download Device list"
      },
      "login": {
        "label": {
          "1": "Email",
          "2": "Password",
          "3": "Forgot Password?",
          "4": "clicking here",
          "5": "Resend email?",
          "6": "Terms",
          "7": "Conditions",
          "8": "Privacy Policy",
          "9": "Reset Password"
        },
        "btn": {
          "1": "Sign In",
          "2": "Sign In with Azure SSO",
          "3": "Cancel"
        },
        "msg": {
          "1": "Welcome to L Squared Digital Signage Platform",
          "2": "Your L Squared Hub account will lock as a result of multiple failed login attempts. You have only 1 more attempt remaining. If you forgot your password, please try \"Forgot Password?\" link to recover your password.",
          "3": "Oops! Something went wrong. Please try again later. You can report this issue to",
            "3.1": "L Squared Support by",
          "4": "This user does not have access to any server. Please contact your server's administrator or Support@LSquared.com.",
          "5": "Your account has been locked because of multiple failed login attempts. Please click on \"Reset Password\" link in the mail we sent you.",
          "6": "Email or Password were not recognized. Please check and try again.",
          "7": "This item is not accessible with your user.",
          "8": "Please provide both Email and Password.",
          "9": "There is not any account created on L Squared Hub with this id.",
          "10": "User not available on the current sso server.",
          "11": "Please wait",
          "12": "Please contact dev team for support password.",
          "13": "Sign in to L Squared Hub",
          "14": "Didn't receive the email?",
          "15": "Check your spam folder for a message from hub@lsquared.com",
          "16": "Please provide Email.",
          "17": "Please validate captcha.",
          "18": "If {{htmlTagO}}{{htmlTagC}} is associated with L Squared Hub account, you should receive an email with password reset link.",
          "20": "The callback url saved in the SAML app was not matched.",
          "21": "Welcome to {{title}} Digital Signage Platform"
        }
      },
      "sp": {
        "1": "Please wait",
        "2": "Sign in to L Squared Hub",
        "3": "Sorry! The link has expired now.",
        "4": "Invalid request URL.",
        "5": "Please contact your server's administrator.",
        "6": "Go to L Squared Hub"
      },
      "sm": {
        "m1": "Login successful. You can now close this window."
      },
      "signup": {
        "label": {
          "1": "Name",
          "1.1": "First",
          "1.2": "Last",
          "2": "Password",
          "3": "Confirm password"
        },
        "btn": {
          "1": "Sign Up",
          "2": "Cancel"
        },
        "msg": {
          "1": "Welcome to {{brand}} Digital Signage Platform",
          "2": "All fields are mandatory.",
          "3": "Passwords did not match.",
          "4": "Please validate captcha.",
          "5": "User already exist.",
          "6": "Oops! Something went wrong. Please try again later.",
            "6.1": "Try sign up again",
          "7": "Thanks for joining {{brand}}.",
          "8": "Your account has been created with {{brand}}.",
          "9": "Sign in to {{brand}}",
          "10": "Password must be at least 8 characters.",
          "11": "Password must contain at least one capital and one small letter.",
          "12": "Password must contain at least one digit.",
          "13": "Password must contain at least one of the following character:",
          "14": "Password is not valid."
        }
      }
    };
    $translateProvider.translations('en_US', en_us_lang);
    setTimeout(function(){
      localStorage.setItem('lang', JSON.stringify(en_us_lang));
    }, 2000);
    
    $translateProvider.useStaticFilesLoader({
      prefix: LANGUAGE_HOST,
      suffix: '.json?'+new Date().getTime()
    });
    $translateProvider.translations(authLang, lang);

    if(authLang){
      $translateProvider.preferredLanguage(authLang);
    } else{
      $translateProvider.preferredLanguage('en_US');
    }
    $translateProvider.useSanitizeValueStrategy();//'escape'
  }
})();
angular.module('hub').directive('focusMe', function(){
  return{
    scope:{trigger:'=focusMe'},
    link:function(scope, element){
      scope.$watch('trigger', function(value){
        if(value == true){
          setTimeout(function(){
            element[0].focus();
          });
          scope.trigger = false;
        }
      });
    }
  }
});
angular.module("hub").run(["$templateCache", function($templateCache) {$templateCache.put("app/billing/billing.html","<div class=\"msg-warning marB15\" lang={{auth.lang}} translate=\"{{\'b.msg.15\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs t\" role=tablist aria-owns=\"tab-s tab-o tab-orp\" aria-labelledby=navList><li ui-sref-active=active id=tab-s aria-selected=true class=tab-success><a ui-sref=.s role=tab>{{\'b.tab.1\' | translate}}</a></li><li ui-sref-active=active id=tab-o aria-selected=false class=tab-primary ng-if=\"selectedTab != \'hub.billing.orp\'\"><a ui-sref=.o role=tab>{{\'b.tab.2\' | translate}}</a></li><li ui-sref-active=active id=tab-orp aria-selected=false class=tab-primary ng-if=\"selectedTab == \'hub.billing.orp\'\"><a ui-sref=.orp role=tab>{{\'b.tab.2\' | translate}}</a></li></ul></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div><div class=panel-footer ng-if=\"(selectedTab == \'hub.billing.o\' || selectedTab == \'hub.billing.orp\') && !billingLoading\"><span class=btnQuad ng-if=\"selectedTab == \'hub.billing.o\'\"><button type=button role=button class=\"btn btn-primary\" ng-click=saveFx();>{{\'b.o.14\' | translate}} <span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.billing.s>{{\'cm.btn.9\' | translate}}</button> </span><span class=btnQuad ng-if=\"selectedTab == \'hub.billing.orp\'\"><button type=button role=button class=\"btn btn-default\" ui-sref=hub.billing.o><span class=\"fa fa-chevron-left\" aria-hidden=true></span> {{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=ccOpen(); ng-disabled=\"!curShipping.tc || !curShipping.sla\"><span class=\"fa fa-check\" aria-hidden=true></span> {{\'b.o.15\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.billing.s>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</span> <span ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</span> <span ng-if=\"errType==\'state\'\" aria-live=polite role=status>{{\'db.msg.5\' | translate}}</span> <span ng-if=\"errType==\'city\'\" aria-live=polite role=status>{{\'db.msg.4\' | translate}}</span> <span ng-if=\"errType==\'status0\'\" aria-live=polite role=status>{{\'b.msg.6\' | translate}}</span> <span ng-if=\"errType==\'status2\'\" aria-live=polite role=status>{{\'b.msg.7\' | translate}}</span> <span ng-if=\"errType==\'status3\'\" aria-live=polite role=status>{{\'b.msg.8\' | translate}}</span> <span ng-if=\"errType==\'status4\'\" aria-live=polite role=status>{{\'b.msg.9\' | translate}}</span> <span ng-if=\"errType==\'status5\'\" aria-live=polite role=status>{{\'b.msg.10\' | translate}}</span> <span ng-if=\"errType==\'status6\'\" aria-live=polite role=status>{{\'b.msg.11\' | translate}}</span> <span ng-if=\"errType==\'mpqty\'\" aria-live=polite role=status>{{\'b.msg.5\' | translate}}</span> <span ng-if=\"errType==\'zip\'\" aria-live=polite role=status>{{\'b.msg.4\' | translate}}</span> <span ng-if=\"errType==\'lic\'\" aria-live=polite role=status>{{\'b.msg.3\' | translate}}</span></div></div></section><!-- Payment --><script src=https://js.stripe.com/v3/ ></script>");
$templateCache.put("app/billing/o.html","<img alt=Loading src=assets/images/loading.gif ng-if=billingLoading><div class=row ng-show=!billingLoading><div class=col-xs-7><div class=row><div class=col-xs-6><label for=license>{{\'b.o.1\' | translate}}</label><input type=number id=license class=form-control ng-model=shipping.license min=0 ng-change=licenseFx() aria-label=license aria-labelledby=license></div><div class=col-xs-6><label for=sType0>{{\'b.o.2\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"marB2 marR10\" for=sType0><input type=radio role=radio id=sType0 name=subOpt ng-model=shipping.sType value=0 aria-labelledby=sType0><label></label>{{\'b.o.2.4\' | translate}}</label><label class=\"marB2 marR10\" for=sType1><input type=radio role=radio id=sType1 name=subOpt ng-model=shipping.sType value=1 aria-labelledby=sType1><label></label>{{\'b.o.2.3\' | translate}}</label></div><div class=\"text-muted text-sm\"><span>{{\'b.o.22.\'+stype[shipping.sType].id | translate:{price:stype[shipping.sType].rate} }}</span></div></div><div class=col-xs-12><div class=\"panel-inner-tab marT15 marB10\">{{\'b.o.3\' | translate}}</div><div id=company_address><div class=form-group><label for=bAddress1>{{\'db.p_map.2\' | translate}}</label><input type=text class=\"form-control autocomplete\" id=bAddress1 ng-model=shipping.b.address1 placeholder=\"\" autocomplete=off aria-label=Address aria-labelledby=Address></div><div class=form-group><label for=bAddress2>{{\'db.p_map.2\' | translate}} 2 <span class=text-muted>({{\'cm.label.26\' | translate}})</span></label><textarea type=text class=form-control id=bAddress2 ng-model=shipping.b.address2 autocomplete=off aria-label=Address2 aria-labelledby=Address2></textarea></div><div class=\"row marB15\"><div class=col-md-6><label for=bCity>{{\'cm.label.45\' | translate}}</label><input type=text class=\"form-control locality\" id=bCity ng-model=shipping.b.city autocomplete=off aria-label=City aria-labelledby=City></div><div class=col-md-6><label for=bProvince>{{\'db.p_map.6\' | translate}}</label><input type=text class=\"form-control administrative_area_level_1\" id=bProvince ng-model=shipping.b.province autocomplete=off aria-label=\"State / Province\" aria-labelledby=\"State / Province\"></div></div><div class=\"row marB15\"><div class=col-md-6><label for=bPostalcode>{{\'db.p_map.7\' | translate}}</label><input type=text class=\"form-control postal_code\" id=bPostalcode ng-model=shipping.b.postalcode autocomplete=off aria-label=\"Post / Zip code\" aria-labelledby=\"Post / Zip code\"></div><div class=col-md-6><label for=bCountry>{{\'db.p_map.8\' | translate}}</label><input type=text class=\"form-control country\" id=bCountry ng-model=shipping.b.country autocomplete=off aria-label=Country aria-labelledby=Country> <input type=text class=\"hide country_code\" id=bCountrycode ng-model=shipping.b.countrycode autocomplete=off aria-label=bCountrycode aria-labelledby=bCountrycode></div></div></div><div class=marTB10><label for=shippingMP><input type=checkbox role=checkbox id=shippingMP ng-model=shipping.mp ng-change=\"mpCheckFx(\'mp\')\" aria-labelledby=shippingMP><label></label>{{\'b.o.4\' | translate}}</label></div><div class=form-group ng-if=shipping.mp><div ng-repeat=\"mp in shipping.mpList\"><div class=mpList><div class=priceQuad>${{mp.price}}</div><div class=imgQuad><a href=\"\" role=link ng-href=\"{{shippingInfo.imgPath + mp.img}}\" fancyboxable=fbTitleInside data-fancybox-title={{mp.model}}><img alt=\"\" src=\"{{shippingInfo.imgPath + mp.thumb}}\"></a></div><div class=mpTable><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.24\' | translate}}:</label>{{mp.model}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.25\' | translate}}:</label>{{mp.cpu}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.26\' | translate}}:</label>{{mp.memory}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.27\' | translate}}:</label>{{mp.hdd}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.28\' | translate}}:</label>{{mp.graphics}}</div><span ng-if=isViewMore><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.29\' | translate}}:</label>{{mp.audio}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.30\' | translate}}:</label>{{mp.lan}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.31\' | translate}}:</label>{{mp.wlan}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.32\' | translate}}:</label>{{mp.price}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.33\' | translate}}:</label>{{mp.bluetooth}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.34\' | translate}}:</label><ol class=padL20 role=listbox><li ng-repeat=\"ds in mp.display\" role=listitem>{{ds}}</li></ol></div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.35\' | translate}}:</label>{{mp.weight}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.36\' | translate}}:</label>{{mp.dim}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.37\' | translate}}:</label>{{mp.power}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>{{\'b.o.38\' | translate}}:</label>{{mp.os}}</div></span></div><div class=\"marT5 padL5\"><a href=\"\" role=link ng-click=\"isViewMore = !isViewMore\">{{isViewMore?\'b.o.21\':\'b.o.20\' | translate}}</a></div><div class=input-group><span class=input-group-addon>{{\'b.o.19\' | translate}}</span> <input type=number class=\"form-control input-sm\" id=mpQty ng-model=mp.qty min=0 autocomplete=off aria-label=Quantity aria-labelledby=Quantity></div></div></div><div class=clearfix></div></div><div ng-if=shipping.mp><label for=sAddress><input type=checkbox role=checkbox id=sAddress ng-model=shipping.sAddress ng-change=\"tempObj.quad = !tempObj.quad\" aria-labelledby=sAddress><label></label>{{\'b.o.5\' | translate}}</label></div><div ng-show=tempObj.quad><div class=\"panel-inner-tab marT15 marB10\">{{\'b.o.6\' | translate}}</div><div id=shipping_address><div class=form-group><label for=sAddress1>{{\'db.p_map.2\' | translate}}</label><input type=text class=\"form-control autocomplete\" id=sAddress1 ng-model=shipping.s.address1 placeholder=\"\" autocomplete=off aria-label=Address aria-labelledby=Address></div><div class=form-group><label for=sAddress2>{{\'db.p_map.2\' | translate}} 2 <span class=text-muted>({{\'cm.label.26\' | translate}})</span></label><textarea type=text class=form-control id=sAddress2 ng-model=shipping.s.address2 autocomplete=off aria-label=\"Address 2\" aria-labelledby=\"Address 2\"></textarea></div><div class=\"row marB15\"><div class=col-md-6><label for=sCity>{{\'cm.label.45\' | translate}}</label><input type=text class=\"form-control locality\" id=sCity ng-model=shipping.s.city autocomplete=off aria-label=City aria-labelledby=City></div><div class=col-md-6><label for=sProvince>{{\'db.p_map.6\' | translate}}</label><input type=text class=\"form-control administrative_area_level_1\" id=sProvince ng-model=shipping.s.province autocomplete=off aria-label=\"State / Province\" aria-labelledby=\"State / Province\"></div></div><div class=\"row marB15\"><div class=col-md-6><label id=sPostalcode>{{\'db.p_map.7\' | translate}}</label><input type=text class=\"form-control postal_code\" id=sPostalcode ng-model=shipping.s.postalcode autocomplete=off aria-label=\"Post / Zip code\" aria-labelledby=\"Post / Zip code\"></div><div class=col-md-6><label for=sCountry>{{\'db.p_map.8\' | translate}}</label><input type=text class=\"form-control country\" id=sCountry ng-model=shipping.s.country aria-label=Country aria-labelledby=Country> <input type=text class=\"hide country_code\" id=sCountrycode ng-model=shipping.s.countrycode autocomplete=off aria-label=countrycode aria-labelledby=countrycode></div></div></div></div></div></div></div><div class=\"col-sm-4 col-lg-3 col-sm-offset-1 bpOrderSummaty\"><h4 class=text-muted>{{\'b.o.7\' | translate}}</h4><ul class=list-group><li class=list-group-item><div class=\"col-xs-8 noPad\"><div class=text-bold>{{shipping.license}} {{shipping.license>1?\'b.o.1.2\':\'b.o.1.1\' | translate}}</div><div class=\"text-muted text-sm\"><span>{{\'b.o.22.\'+stype[shipping.sType].id | translate:{price:stype[shipping.sType].rate} }}</span></div></div><div class=\"col-xs-4 text-muted text-right\">${{stype[shipping.sType].rate * shipping.license | toFixed:2}}</div><div class=clearfix></div></li><li class=list-group-item ng-repeat=\"mp in shipping.mpList\" ng-if=mp.qty><div class=\"col-xs-8 noPad\"><div class=text-bold>{{mp.qty + \" \" + mp.model}} {{\'b.o.9\' | translate}}</div><div class=\"text-muted text-sm\">{{\'b.o.9.1\' | translate:{price:mp.price} }}</div></div><div class=\"col-xs-4 text-muted text-right\">${{mp.qty*mp.price | toFixed:2}}</div><div class=clearfix></div></li><li class=list-group-item><div class=\"col-xs-8 noPad\"><div class=text-bold>Tax ({{tax.type}})</div><div class=\"text-muted text-sm\">{{tax.percent}}%</div></div><div class=\"col-xs-4 text-muted text-right\">${{(((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price)) * (tax.percent / 100)).toFixed(2)}}</div><div class=clearfix></div></li><li class=\"list-group-item bg-light text-bold\"><div class=\"col-xs-8 noPad\">{{\'b.o.10\' | translate}} {{totalCost}}</div><div class=\"col-xs-4 text-right\">${{((((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price)) * (tax.percent / 100)) + ((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price))).toFixed(2)}}</div><div class=clearfix></div></li></ul></div></div>");
$templateCache.put("app/billing/orp.html","<img alt=Loading src=assets/images/loading.gif ng-if=billingLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!billingLoading && isOrpEmpty\">{{\'b.msg.19\' | translate}}</div><div class=row ng-show=\"!billingLoading && !isOrpEmpty\"><div class=col-xs-7><div class=row><div class=col-xs-6><label>{{\'b.o.1\' | translate}}</label><div>{{shipping.license}}</div></div><div class=col-xs-6><label>{{\'b.o.2\' | translate}}</label><div>{{\'b.o.22.\'+stype[shipping.sType].id | translate:{price:stype[shipping.sType].rate} }}</div></div><div class=col-xs-12><div class=form-group ng-if=shipping.mp><div class=\"panel-inner-tab marT15 marB10\">{{\'b.o.9\' | translate}}</div><div ng-repeat=\"mp in shipping.mpList\" ng-if=mp.qty><div class=mpList><div class=priceQuad>${{mp.price}}</div><div class=imgQuad><a href=\"\" role=link ng-href=\"{{shippingInfo.imgPath + mp.img}}\" fancyboxable=fbTitleInside data-fancybox-title={{mp.model}}><img alt=\"\" src=\"{{shippingInfo.imgPath + mp.thumb}}\"></a></div><div class=mpTable><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Model:</label>{{mp.model}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>CPU:</label>{{mp.cpu}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Memory:</label>{{mp.memory}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Hard Drive:</label>{{mp.hdd}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Graphics:</label>{{mp.graphics}}</div><span ng-if=isViewMore><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Audio:</label>{{mp.audio}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>LAN:</label>{{mp.lan}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Wireless LAN:</label>{{mp.wlan}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Price:</label>{{mp.price}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Bluetooth:</label>{{mp.bluetooth}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Display Support:</label><ol class=padL20><li ng-repeat=\"ds in mp.display\">{{ds}}</li></ol></div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Weight:</label>{{mp.weight}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Dimensions:</label>{{mp.dim}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>Power Consumption:</label>{{mp.power}}</div><div ng-class=\"{\'text-ellipsis\':!isViewMore}\"><label class=marR5>OS:</label>{{mp.os}}</div></span></div><div class=\"marT5 padL5\"><a href=\"\" role=link ng-click=\"isViewMore = !isViewMore\">{{isViewMore?\'b.o.21\':\'b.o.20\' | translate}}</a></div><div class=\"qtyQuad bg-light\">{{\'b.o.19\' | translate}}: {{mp.qty}}</div></div></div><div class=clearfix></div></div><div class=\"panel-inner-tab marT15 marB10\"><span ng-show=!shipping.sAddress>{{\'b.o.3\' | translate}}</span> <span ng-show=shipping.sAddress>{{\'b.o.23\' | translate}}</span></div><div id=company_address><div class=form-group><div>{{shipping.b.address1}}</div><div>{{shipping.b.address2}}</div><div>{{shipping.b.city + \", \" + shipping.b.province +\" \"+ shipping.b.postalcode}}</div><div>{{shipping.b.country}}</div></div></div><div ng-show=!shipping.sAddress><div class=\"panel-inner-tab marT15 marB10\">{{\'b.o.6\' | translate}}</div><div class=form-group><div>{{shipping.s.address1}}</div><div>{{shipping.s.address2}}</div><div>{{shipping.s.city +\", \"+ shipping.s.province +\" \"+ shipping.s.postalcode}}</div><div>{{shipping.s.country}}</div></div></div></div></div></div><div class=\"col-sm-4 col-lg-3 col-sm-offset-1\"><h4 class=text-muted>{{\'b.o.7\' | translate}}</h4><ul class=list-group role=list><li class=list-group-item role=listitem><div class=\"col-xs-8 noPad\"><div class=text-bold>{{shipping.license}} {{shipping.license>1?\'b.o.1.2\':\'b.o.1.1\' | translate}}</div><div class=\"text-muted text-sm\"><span>{{\'b.o.22.\'+stype[shipping.sType].id | translate:{price:stype[shipping.sType].rate} }}</span></div></div><div class=\"col-xs-4 text-muted text-right\">${{stype[shipping.sType].rate * shipping.license | toFixed:2}}</div><div class=clearfix></div></li><li class=list-group-item role=listitem ng-repeat=\"mp in shipping.mpList\" ng-if=mp.qty><div class=\"col-xs-8 noPad\"><div class=text-bold>{{mp.qty + \" \" + mp.model}} {{\'b.o.9\' | translate}}</div><div class=\"text-muted text-sm\">{{\'b.o.9.1\' | translate:{price:mp.price} }}</div></div><div class=\"col-xs-4 text-muted text-right\">${{mp.qty*mp.price | toFixed:2}}</div><div class=clearfix></div></li><li class=list-group-item role=listitem><div class=\"col-xs-8 noPad\"><div class=text-bold>Tax ({{tax.type}})</div><div class=\"text-muted text-sm\">{{tax.percent}}%</div></div><div class=\"col-xs-4 text-muted text-right\">${{((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price)) * (tax.percent / 100) | toFixed:2}}</div><div class=clearfix></div></li><li class=\"list-group-item bg-light text-bold\" role=listitem><div class=\"col-xs-8 noPad\">{{\'b.o.10\' | translate}} {{totalCost}}</div><div class=\"col-xs-4 text-right\">${{(((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price)) * (tax.percent / 100)) + ((stype[shipping.sType].rate * shipping.license) + (shipping.mpList[0].qty * shipping.mpList[0].price) + (shipping.mpList[1].qty * shipping.mpList[1].price)) | toFixed:2}}</div><div class=clearfix></div></li></ul></div><div class=col-xs-12><div><label for=tc><input type=checkbox role=checkbox id=tc ng-model=curShipping.tc aria-labelledby=tc><label></label><span translate=\"{{\'b.o.17\'}}\" translate-values=\"{htmlTagO:\'<a href=\\\'https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf\\\' target=\\\'_blank\\\' role=\'button\'>\', htmlTagC:\'</a>\'}\"></span></label></div><div><label for=sla><input type=checkbox role=checkbox id=sla ng-model=curShipping.sla aria-labelledby=sla><label></label><span translate=\"{{\'b.o.18\'}}\" translate-values=\"{htmlTagO:\'<a href=\\\'https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/sla.pdf\\\' target=\\\'_blank\\\' role=\'button\'>\', htmlTagC:\'</a>\'}\"></span></label></div></div></div>");
$templateCache.put("app/billing/s.html","<img alt=Loading src=assets/images/loading.gif ng-if=billingLoading><div ng-if=!billingLoading><div class=row><div class=col-xs-4><div class=\"billingQuad text-center\"><div class=\"marB5 text-md text-bold\">{{\'b.d.1\' | translate}}</div><div class=\"marB5 text-big\"><span ng-if=bd.info.lastPay>${{bd.info.lastPay | setDecimal:2}}</span> <span ng-if=!bd.info.lastPay class=\"text-muted text-sm\">N/A</span></div><div class=\"marB5 text-success text-sm\" ng-if=bd.info.lastDate>{{\'b.d.2\' | translate: {date:((bd.info.lastDate * 1000) | date:\"MMM d, y\")} }}</div></div></div><div class=col-xs-4><div class=\"billingQuad text-center\"><div class=\"marB5 text-md text-bold\">{{\'b.d.3\' | translate}}</div><div class=\"marB5 text-big\"><span ng-if=bd.info.nextDate>{{(bd.info.nextDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=!bd.info.nextDate class=\"text-muted text-sm\">N/A</span></div></div></div><div class=col-xs-4><div class=\"billingQuad text-center\"><div class=\"marB5 text-md text-bold\">{{\'b.d.4\' | translate}}</div><div class=\"marB5 text-big\"><span ng-if=bd.info.nextPay>${{bd.info.nextPay | toFixed:2}}</span> <span ng-if=!bd.info.nextPay class=\"text-muted text-sm\">N/A</span></div></div></div></div><div class=\"panel-inner-tab marT25\">{{\'b.o.2\' | translate}}</div><div class=\"msg-warning marT5\" lang={{auth.lang}} ng-if=!bd.sub.length>{{\'b.msg.1\' | translate}}</div><div class=\"table table-md dTable\" role=table ng-if=bd.sub.length><div class=\"row th\"><div class=col-xs-4>{{\'b.d.6\' | translate}}</div><div class=col-xs-2>{{\'b.d.7\' | translate}}</div><div class=col-xs-2>{{\'b.d.8\' | translate}}</div><div class=col-xs-2>{{\'b.d.9\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'b.d.10\' | translate}}</div></div><div class=row ng-repeat=\"sub in bd.sub\"><div class=col-xs-4><a href=\"\" role=link ng-click=subDetailFx(sub.id)>LSSUB-{{sub.id}}</a></div><div class=col-xs-2>{{sub.license}}</div><div class=col-xs-2><span ng-if=sub.dDate>{{(sub.dDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=!sub.dDate class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-2><span ng-if=\"sub.status == 1\">{{\'b.d.9.1\' | translate}}</span> <span ng-if=\"sub.status == 2\">{{\'b.d.9.2\' | translate}}</span> <span ng-if=\"sub.status == 3\">{{\'b.d.9.3\' | translate}}</span> <span ng-if=\"sub.status == 4\">{{\'b.d.9.4\' | translate}}</span> <span ng-if=\"sub.status == 5\">{{\'b.d.9.5\' | translate}}</span> <span ng-if=\"sub.status == 6\">{{\'b.d.9.6\' | translate}}</span> <span ng-if=\"sub.status == 7\">{{\'b.d.9.7\' | translate}}</span> <span ng-if=\"sub.status == 8\">{{\'b.d.9.8\' | translate}}</span></div><div class=\"col-xs-2 text-right\">${{sub.amount | setDecimal:2}} / <span ng-if=\"sub.interval==\'d\'\">{{\'cl.widget.sc.3\' | translate}}</span> <span ng-if=\"sub.interval==\'w\'\">{{\'cl.widget.sc.4\' | translate}}</span> <span ng-if=\"sub.interval==\'m\'\">{{\'cl.widget.sc.5\' | translate}}</span> <span ng-if=\"sub.interval==\'y\'\">{{\'cl.widget.sc.6\' | translate}}</span></div></div></div></div>");
$templateCache.put("app/billing/sDetails.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><a href=\"\" role=link ui-sref=hub.billing.s class=marR5>{{\'b.tab.1\' | translate}}</a><span ng-if=sDetails.info.id>/<span class=\"marL5 text-muted\">LSSUB-{{sDetails.info.id}}</span></span></div><section class=panel><img alt=Loading src=assets/images/loading.gif class=pad10 ng-if=detailLoading><header class=\"panel-heading panel-tab\" style=height:43px ng-if=!detailLoading><div class=title>{{\'b.sd.1.1\' | translate}}</div><div class=panel-tools><div class=pull-right><a href=\"\" role=link uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" ui-sref=hub.billing.s><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=pull-right uib-dropdown ng-if=\"!sDetails.info.isTrial && (sDetails.info.status == 2 || sDetails.info.status == 3)\"><a href=\"\" role=link uib-dropdown-toggle uib-tooltip=\"{{\'cm.label.25\' | translate}}\" id=dropdownMenu1 data-toggle=dropdown aria-haspopup=true aria-expanded=true><span class=\"glyphicon glyphicon-option-vertical\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=dropdownMenu1><li class=cancel-icon><a href=\"\" role=link ng-click=confirmOpen();>{{\'b.sd.8\' | translate}}</a></li></ul></div></div></header><div class=panel-body ng-if=!detailLoading><div class=row><div class=col-xs-4><label>{{\'b.sd.1\' | translate}}</label><div>LSSUB-{{sDetails.info.id}}</div></div><div class=col-xs-4><label>{{\'b.sd.2\' | translate}}</label><div><span ng-if=sDetails.info.license>{{sDetails.info.license}}</span><span ng-if=!sDetails.info.license class=\"text-sm text-muted\">N/A</span></div></div><div class=col-xs-4><label>{{\'b.o.9\' | translate}}</label><div><span ng-if=sDetails.info.mp>{{sDetails.info.mp}}</span><span ng-if=!sDetails.info.mp class=\"text-sm text-muted\">N/A</span></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'b.sd.3\' | translate}}</label><div>{{sDetails.info.purchaser}}</div></div><div class=col-xs-4><label>{{\'b.sd.5\' | translate}}</label><div><span ng-if=sDetails.info.lsamount>${{sDetails.info.lsamount | toFixed:2}}</span><span ng-if=!sDetails.info.lsamount class=\"text-sm text-muted\">N/A</span></div></div><div class=col-xs-4><label>{{\'b.sd.6\' | translate}}</label><div><span ng-if=sDetails.info.mpamount>${{sDetails.info.mpamount | toFixed:2}}</span><span ng-if=!sDetails.info.mpamount class=\"text-sm text-muted\">N/A</span></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.69\' | translate}}</label><div><span ng-if=\"sDetails.info.type == \'d\'\">{{\'b.o.2.1\' | translate}}</span> <span ng-if=\"sDetails.info.type == \'w\'\">{{\'b.o.2.2\' | translate}}</span> <span ng-if=\"sDetails.info.type == \'m\'\">{{\'b.o.2.3\' | translate}}</span> <span ng-if=\"sDetails.info.type == \'y\'\">{{\'b.o.2.4\' | translate}}</span></div></div><div class=col-xs-4><label>{{\'b.d.9\' | translate}}</label><div><span ng-if=\"sDetails.info.status == 1\">{{\'b.d.9.1\' | translate}}</span> <span ng-if=\"sDetails.info.status == 2\">{{\'b.d.9.2\' | translate}}</span> <span ng-if=\"sDetails.info.status == 3\">{{\'b.d.9.3\' | translate}}</span> <span ng-if=\"sDetails.info.status == 4\">{{\'b.d.9.4\' | translate}}</span> <span ng-if=\"sDetails.info.status == 5\">{{\'b.d.9.5\' | translate}}</span> <span ng-if=\"sDetails.info.status == 6\">{{\'b.d.9.6\' | translate}}</span> <span ng-if=\"sDetails.info.status == 7\">{{\'b.d.9.7\' | translate}}</span> <span ng-if=\"sDetails.info.status == 8\">{{\'b.d.9.8\' | translate}}</span></div></div></div><div ng-if=sDetails.info.address.address1><div class=\"panel-inner-tab marT25 marB10\">{{\'b.o.3\' | translate}}</div><div class=row><div class=col-xs-8><div>{{sDetails.info.address.address1 +\", \"+ sDetails.info.address.address2}}</div><div>{{sDetails.info.address.city +\", \"+ sDetails.info.address.province +\", \"+ sDetails.info.address.country}}</div><div>{{sDetails.info.address.postalcode}}</div></div></div></div><div class=\"panel-inner-tab marT25 marB10\">{{\'cs.tab.3\' | translate}}</div><div class=\"msg-warning marT5\" lang={{auth.lang}} ng-if=!sDetails.txn.length>{{\'b.msg.2\' | translate}}</div><div class=\"table table-md marT10\" ng-if=sDetails.txn.length><div class=\"row th\"><div class=col-xs-4>{{\'b.sd.4\' | translate}}</div><div class=col-xs-2>{{\'b.sd.9\' | translate}}</div><div class=col-xs-2>{{\'cm.label.7\' | translate}}</div><div class=col-xs-2>{{\'cm.label.46\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cs.body.4\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cs.tab.6\' | translate}}</div></div><div class=row ng-repeat=\"txt in sDetails.txn\"><div class=col-xs-4><a href=\"\" role=link ng-click=viewOpen(txt.url);>{{txt.tId}}</a></div><div class=col-xs-2><span ng-if=\"txt.tType == 0\">{{\'b.sd.9.1\' | translate}}</span> <span ng-if=\"txt.tType == 1\">{{\'b.sd.9.2\' | translate}}</span> <span ng-if=\"txt.tType == 2\">{{\'b.sd.9.1\' | translate}}, {{\'b.sd.9.2\' | translate}}</span></div><div class=col-xs-2>{{(txt.createdOn * 1000) | date:\"MMMM d, y\"}}</div><div class=col-xs-2>{{txt.status}}</div><div class=\"col-xs-1 text-right\">${{txt.amount | toFixed:2}}</div><div class=\"col-xs-1 text-right\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=viewOpen(txt.url);>{{\'cm.btn.21\' | translate}}</button></div></div></div></div></section>");
$templateCache.put("app/common/as.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=tabLoading><!-- App Switches --><div><img alt=Loading src=assets/images/loading.gif ng-if=settingsLoading><div ng-if=!settingsLoading><div class=\"bg-light pad10 marB20\"><div class=row><div class=col-xs-4><label for=curASObjL>{{\'ms.p_s.dp.2\' | translate}}</label><input type=text id=curASObjL class=form-control ng-model=curASObj.label maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.dp.2\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.dp.2\' | translate}}\"></div><div class=col-xs-3><label for=curASObjV>{{\'ms.p_s.dp.3\' | translate}}</label><input type=text id=curASObjV class=form-control ng-model=curASObj.value maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.dp.3\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.dp.3\' | translate}}\"></div><div class=col-xs-3><label for=curASObjD>{{\'cm.label.85\' | translate}}</label><input type=text id=curASObjD class=form-control ng-model=curASObj.desc maxlength=500 aria-label=\"{{\'cm.label.85\' | translate}}\" aria-labelledby=\"{{\'cm.label.85\' | translate}}\"></div><div class=col-xs-2><label for=curASObjD class=text-ellipsis uib-tooltip=\"{{\'cm.label.101\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.label.101\' | translate}}</label><div><switch role=switch class=\"switch-sm nonSelectable\" ng-model=curASObj.isvfc on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{curASObj.id}} ng-change=statusFx(curASObj.id) aria-checked={{curASObj.isvfc?true:false}}></switch></div></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=asAddFx(); ng-disabled=asProcessing><span ng-if=!curASObj.id><span ng-class=\"asProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'ms.p_s.as.1\' | translate}}</span> <span ng-if=curASObj.id><span ng-class=\"asProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=reset role=button class=\"btn btn-link\" ng-click=asResetFx(); ng-disabled=asProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m1\' | translate}}</div><div ng-if=\"errType==\'same\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m2\' | translate}}</div></div></div></div></div></div><div class=\"row d-flex align-items-center marB5\"><div class=col-xs-9></div><div class=col-xs-3><div class=searchTbx style=\"float: right\"><input type=text class=\"form-control input-sm\" ng-model=searchAS.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchAS.text.length ng-click=\"searchAS.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div><div class=\"table bg-white no-th\" ng-if=asObj.switches.length><div class=\"row th bg-white\"><div class=col-xs-3>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-3>{{\'ms.p_s.dp.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.85\' | translate}}</div><div class=\"col-xs-2 noPadR\">{{\'cm.label.101\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=asDataLoading class=pad10><div ng-if=!asDataLoading><div class=scrollQuad style=max-height:{{getAvailableHeight(545)}}px><div class=row ng-repeat=\"as in filteredswitches = (asObj.switches | customSearch:{key:searchAS.text, module:\'dp\'})\"><div class=\"col-xs-3 word-break\">{{as.label}}</div><div class=\"col-xs-3 word-break\"><span ng-if=as.value>{{as.value}}</span><span ng-if=!as.value class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 word-break\">{{as.desc}}<span ng-if=!as.desc class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-2 word-break\">{{as.isvfc?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link aria-label=edit class=\"text-primary marR10\" ng-click=asEditFx(as);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link aria-label=delete class=text-danger ng-click=asDeleteOpen(as.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"searchAS.text.length && (asObj.switches | customSearch:{key:searchAS.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchAS.text)}}&quot;</b>\'}\"></div></div><!-- <div class=\"bdr-top-dashed marT15\" ng-if=\"asObj.switches.length && asObj.info.sort == \'c\'\">\r\n          <a href=\"\" role=\"link\" class=\"btn btn-success btn-xs\" ng-click=\"asSaveFx(\'s\');\" ng-disabled=\"asSProcessing\"><span ng-class=\"asSProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=\"true\"></span>{{\'ms.p_s.dp.5.1\' | translate}}</a>\r\n        </div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!asDataLoading && !asObj.switches.length\">{{\'ms.p_s.as.m1\' | translate}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!tabLoading && !makeLoading && coordinators.users.length == 0\">{{\'ms.msg.20\' | translate}}</div></div>");
$templateCache.put("app/common/asana.html","<!-- Asana Integration --><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=settingsLoading><div ng-if=!settingsLoading><div ng-if=!asnObj.auth.isAuth><label>{{\'cm.asn.2\' | translate}}</label><div><button type=button role=button ng-click=asnAuthFx(); class=\"btn btn-success\" ng-disabled=ansAuthProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=ansAuthProcessing></span>{{\'cl.widget.cm.25\' | translate}}</button></div></div><div ng-if=asnObj.auth.isAuth><div class=marB10><label>✅ {{\'cm.asn.3\' | translate}}</label></div><div class=marB10><span translate=\"{{\'cm.asn.4\'}}\" translate-values=\"{htmlTagO:\'<b>\', user:asnObj.auth.au.l + \' ( \'+ asnObj.auth.au.e +\' )\', htmlTagC:\'</b>\'}\"></span></div><div class=marB10><label>{{\'cm.asn.5\' | translate}}</label><div><span ng-if=asnObj.auth.ws.length>{{asnObj.auth.ws.length}}</span><!-- <span class=\"text-muted text-sm\" ng-if=\"!asnObj.auth.ws.length\">N/A</span> --> <button type=button role=button ng-click=\"asnActionOpen(\'ws\', asnObj.auth);\" class=\"btn btn-primary btn-xs\">{{asnObj.auth.ws.length?\"cm.btn.21\":\"cm.asn.5.1\" | translate}}</button></div></div><div class=marB10><label>{{\'cm.asn.6\' | translate}}</label><div><span class=\"bg-light padLR5\" ng-if=\"asnObj.auth.f!=\'\'\"><span class=\"fa fa-home marR5\"></span>{{asnObj.auth.f.path}}</span> <button type=button role=button ng-click=\"asnActionOpen(\'clf\', asnObj.auth);\" ng-if=\"asnObj.auth.f==\'\'\" class=\"btn btn-primary btn-xs\">{{\"cl.p_f.9\" | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/common/co.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=tabLoading><div class=\"bg-light pad10 marB15\" ng-if=!tabLoading><div class=row><div class=col-xs-4><label for=search>{{\'ms.label.19\' | translate}}</label><div class=input-group><input type=text class=form-control id=search ng-model=userText.search sanitize-input maxlength=250 ng-change=userTextChange() focus-me=true placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <span class=input-group-btn><button type=button role=button class=\"btn btn-primary\" ng-click=getUserFx(); ng-disabled=\"!userText.search || searchProcessing\"><span ng-class=\"searchProcessing?\'fa fa-repeat fa-spin\':\'fa fa-search\'\" aria-hidden=true></span>{{\'ms.btn.2\' | translate}}</button></span></div></div></div><div class=\"msg-warning marT25\" lang={{auth.lang}} ng-if=\"errType == \'notFound\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(userText.search)}}&quot;</b>\'}\"></div><div class=\"msg-warning marT25\" lang={{auth.lang}} ng-if=\"errType == \'already\'\" translate=\"{{\'ms.msg.22\'}}\" translate-values=\"{email: userText.search, htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div><div class=\"table row marT15\" ng-if=searchedUser><div class=col-xs-4 ng-repeat=\"su in searchedUser\"><label for=selected ng-class=\"{\'disabled\':su.isSupCor || su.isSaleCor}\" uib-tooltip=\"{{su.isSupCor?\'ms.tool.1\':\'ms.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-enable=\"su.isSupCor || su.isSaleCor\"><input type=radio role=radio id=selected ng-model=curCoordin.selected ng-value=su ng-disabled=\"su.isSupCor || su.isSaleCor\" name=suOpt style=margin-top:10px aria-labelledby=suOpt><label style=margin-top:10px></label><div class=user-tumb><img alt=\"\" src=\"{{coordinators.info.timthumb + coordinators.info.bucket + su.dp}}&w=36&h=36&q=80&zc=3\" ng-if=su.dp><div class=profileIcon-sm ng-if=!su.dp><span>{{su.label | limitTo:1}}</span></div></div><div class=\"text-ellipsis pull-left\"><div ng-class=\"{\'marT8\':!su.email}\">{{su.label}}</div><div class=text-muted ng-class=\"{\'marT8\':!su.label}\">{{su.email}}</div></div></label></div></div><div class=marT15 ng-if=searchedUser><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=\"makeCoordinatorOpen(\'a\', 1);\" ng-disabled=!curCoordin.selected><span class=\"fa fa-check\" aria-hidden=true></span> {{\'ms.btn.3\' | translate}}</button> <button type=button role=button class=\"btn btn-success btn-sm\" ng-click=\"makeCoordinatorOpen(\'a\', 2);\" ng-disabled=!curCoordin.selected ng-if=\"auth.scType!=2\"><span class=\"fa fa-check\" aria-hidden=true></span> {{\'ms.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=clearSearchFx();>{{\'cl.widget.mc.11\' | translate}}</button></div><div class=clearfix></div></div><img alt=Loading src=assets/images/loading.gif ng-if=\"!tabLoading && makeLoading\"><div class=table ng-if=\"!tabLoading && !makeLoading && coordinators.users.length > 0\"><div class=\"row th\"><div class=col-xs-4>{{\'cl.p_f.6\' | translate | camelCase}}</div><div class=col-xs-4>{{\'cm.label.47\' | translate}}</div><div class=col-xs-2>{{\'cm.label.73\' | translate}}</div><div class=\"col-xs-1 text-right noPadL noPadR\">{{\'ms.label.28\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=\"row word-break\" ng-repeat=\"coordinator in coordinators.users\"><div class=col-xs-4><div class=user-tumb><img alt=\"\" src=\"{{coordinators.info.timthumb + coordinators.info.bucket + coordinator.dp}}&w=36&h=36&q=80&zc=3\" ng-if=coordinator.dp><div class=profileIcon-sm ng-if=!coordinator.dp><span>{{coordinator.label | limitTo:1}}</span></div></div><div class=\"text-ellipsis marT8\">{{coordinator.label}}</div></div><div class=\"col-xs-4 marT8\">{{coordinator.email}}</div><div class=\"col-xs-2 marT8\">{{coordinator.role == 1?\'cm.menu.21\':\'ms.label.31\' | translate}}</div><div class=\"col-xs-1 marT7 text-right noPadL noPadR\">{{coordinator.servers.length}} <button type=button role=button ng-click=\"makeCoordinatorOpen(\'e\', coordinator);\" class=\"btn btn-default btn-xs\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 marT8 text-right\"><a href=\"\" role=link class=text-danger ng-if=\"auth.uType == 0 || (auth.scType == 2 && coordinator.role == 1)\" ng-click=\"removeCoordinatorOpen(coordinator.id, coordinator.role);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!tabLoading && !makeLoading && coordinators.users.length == 0\">{{\'ms.msg.20\' | translate}}</div></div>");
$templateCache.put("app/common/cp.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=settingsLoading><div ng-if=!settingsLoading><div class=row><div class=col-xs-6><div class=form-group><label for=curPass>{{\'ms.label.13\' | translate}}</label><input type=password class=form-control id=curPass ng-model=curSettings.pass.curPass maxlength={{inputLimit}} autocomplete=new-password aria-label=\"{{\'ms.label.13\' | translate}}\" aria-labelledby=\"{{\'ms.label.13\' | translate}}\"></div><div class=form-group><label for=nPass>{{\'ms.label.14\' | translate}}</label><input type=password class=form-control id=nPass ng-model=curSettings.pass.nPass maxlength={{inputLimit}} autocomplete=off ng-change=pwdValidate() aria-label=\"{{\'ms.label.14\' | translate}}\" aria-labelledby=\"{{\'ms.label.14\' | translate}}\"></div><div class=form-group><label for=cPass>{{\'ms.label.15\' | translate}}</label><input type=password class=form-control id=cPass ng-model=curSettings.pass.cPass maxlength={{inputLimit}} autocomplete=off aria-label=\"{{\'ms.label.15\' | translate}}\" aria-labelledby=\"{{\'ms.label.15\' | translate}}\"></div></div><div class=col-xs-6><div class=\"bg-light pad10\" ng-if=curSettings.pass.nPass><li ng-class=\"pwdLengthValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'ms.msg.16\' | translate}} <span class=\"fa fa-check\" ng-if=pwdLengthValid aria-hidden=true></span></li><li ng-class=\"pwdCharValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'ms.msg.17\' | translate}} <span class=\"fa fa-check\" ng-if=pwdCharValid aria-hidden=true></span></li><li ng-class=\"pwdNumValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'ms.msg.18\' | translate}} <span class=\"fa fa-check\" ng-if=pwdNumValid aria-hidden=true></span></li><li ng-class=\"pwdSplCharValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'ms.msg.19\' | translate}}<br><span class=marL20>!@#$%&</span> <span class=\"fa fa-check\" ng-if=pwdSplCharValid aria-hidden=true></span></li></div></div></div></div></div>");
$templateCache.put("app/common/footer.html","<!--For All Pages--><footer class=footer><div class=\"col-xs-8 text-left\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme != \'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=\"\" role=link ng-click=\"appsOpen({id:0, label:\'L Squared Hub\', version:uiVersion});\">V&nbsp;{{uiVersion}}</a></div><div class=\"col-xs-1 text-center\"></div><div class=\"col-xs-3 text-right padR20\"><a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf id=terms role=link target=_blank ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf id=privacy role=link target=_blank ng-cloak>{{\'cm.footer.2\' | translate}}</a></div></footer>");
$templateCache.put("app/common/header.html","<nav class=\"navbar navbar-fixed-top navbarTop\"><div class=container-fluid><!-- Brand and toggle get grouped for better mobile display --> <button type=button role=button class=\"navbar-toggle collapsed hide\" ng-click=\"isCollapsed = !isCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=navbar-header><a href=\"\" ui-sref=hub.dashboard class=navbar-brand><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo.png> <img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo_square.png class=hide><!-- Theme --> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/logo.png class=hLogo> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/v-logo.png class=\"hLogo hide\"></a></div><!-- Collect the nav links, forms, and other content for toggling uib-collapse=\"!isCollapsed\"--><div class=\"collapse navbar-collapse in\"><div class=page-title><a href=\"\" role=link id=leftPanel class=sidebar-toggle ng-click=\"preferencesFx(\'isLPOpen\');\" aria-label=leftPanel aria-labelledby=leftPanel><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a><h1 class=pageTitle ng-cloak role=main>{{\'cm.menu.\'+ selectedMenu | translate}}</h1><div class=select-server><div class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-left\" role=navigation aria-labelledby=nList><li class=dropdown uib-dropdown auto-close=outsideClick><a href=# role=button class=dropdown-toggle uib-dropdown-toggle ng-click=\"serverSearchFocus();searchSList.text=\'\'\"><span class=serverName>{{selectedServer.label}}</span> <span class=caret ng-if=\"authServer.length > 1\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"authServer.length > 1\" aria-labelledby=sList><li class=\"dropdown-header padLR10\" ng-show=\"authServer.length <= 5\">{{\'cm.head.menu.1\' | translate}}</li><li class=\"dropdown-header padLR10\" ng-show=\"authServer.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control id=searchSList ng-model=searchSList.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href role=button aria-label=searchSList.text class=text-danger ng-show=searchSList.text.length ng-click=\"searchSList.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"sList in filteredAuthServerList = (authServer | filter:searchSList.text) | orderBy: \'label\'\" tabindex=$index ng-class=\"{\'selected\': sList.label == selectedServer.label}\"><a href role=link ng-click=changeServer(sList); ng-if=\"sList.id != auth.selectedServer\">{{sList.label}}</a> <span ng-if=\"sList.id == auth.selectedServer\">{{sList.label}}</span></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredAuthServerList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchSList.text)}}&quot;</b>\'}\"></div></div></ul></li></ul></div></div></div><div class=updateMsgQuad ng-if=updateMsg><div class=msg-warning lang={{auth.lang}}>{{updateMsg}}</div></div><ul class=\"nav navbar-nav navbar-right\" role=navigation aria-labelledby=right><li class=dropdown uib-dropdown><a href=\"\" role=link class=nav-user uib-dropdown-toggle><img alt=\"{{userName | limitTo:1}}\" ng-if=\"userImg.uImg !=\'\'\" ng-src={{userImg.uImg}} src-error=userError> <span class=profileIcon-xs ng-if=\"userImg.uImg ==\'\'\">{{userName | limitTo:1}}</span>{{userName | limitTo:25}}<span class=caret></span></a><ul class=\"dropdown-menu nav-user-menu\" uib-dropdown-menu role=menu aria-labelledby=sList><li ui-sref-active=selected role=menuitem ng-if=\"authServer.length > 1\"><a href=\"\" role=link ng-click=selectServerFx();><span class=\"fa fa-cloud\" aria-hidden=true></span>{{\'cm.head.menu.1\' | translate}}</a></li><li ui-sref-active=selected role=menuitem><a ui-sref=.mySettings.pro role=link><span class=\"fa fa-cog\" aria-hidden=true></span>{{\'cm.head.menu.2\' | translate}}</a></li><li ng-if=auth.upermissions.cp role=menuitem><a ui-sref=cpDashboard role=link target=_blank><span class=\"fa fa-link\" aria-hidden=true></span>{{\'cm.head.menu.4\' | translate}}</a></li><li class=inner-link><a href=\"\" role=link ui-sref=.support.ts><span class=\"support-caret fa fa-caret-right\" aria-hidden=true></span><span class=\"fa fa-support\" aria-hidden=true></span>{{\'cm.head.menu.3\' | translate}}</a><ul class=\"dropdown-menu inner-menu\" role=menu aria-labelledby=scList><li ui-sref-active=selected role=menuitem><a ui-sref=.support.ts role=link><span class=\"fa fa-support\" aria-hidden=true></span>{{\'cm.head.menu.3.1\' | translate}}</a></li><li ui-sref-active=selected role=menuitem><a ui-sref=.support.fr.rf role=link><span class=\"fa fa-lightbulb-o\" aria-hidden=true></span>{{\'cm.head.menu.3.2\' | translate}}</a></li><li ui-sref-active=selected role=menuitem><a href=\"\" role=link ng-click=feedbackOpen();><span class=\"fa fa-commenting-o\" aria-hidden=true></span>{{\'cm.head.menu.3.3\' | translate}}</a></li><!-- <li ui-sref-active=\"selected\" role=\"menuitem\"><a href=\"\" role=\"link\" ng-click=\"bugsOpen();\"><span class=\"fa fa-bug\" aria-hidden=\"true\"></span>{{\'cm.head.menu.3.4\' | translate}}</a></li> --><li ui-sref-active=selected role=menuitem><a ui-sref=.support.kb role=link><span class=\"fa fa-video-camera\" aria-hidden=true></span>{{\'cm.head.menu.3.5\' | translate}}</a></li></ul></li><li class=divider role=separator></li><li role=menuitem><a href=\"\" role=link ng-click=logOutFx();><span class=\"fa fa-sign-out\" aria-hidden=true></span>{{\'cm.head.menu.5\' | translate}}</a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right notify\" role=navigation aria-labelledby=notify><!-- notification dropdown start--><li class=dropdown uib-dropdown is-open=isNotify><a href=\"\" role=link id=notification class=dropdown-toggle uib-dropdown-toggle ng-click=loadNotification(isNotify) aria-label=notification aria-labelledby=notification><span class=\"fa fa-bell-o noMarR\" aria-hidden=true></span></a><ul class=\"dropdown-menu notify-menu\" uib-dropdown-menu role=menu aria-labelledby=nList><img alt=Loading src=assets/images/loading-xs.gif ng-if=notificationLoading><div ng-if=!notificationLoading><div ng-if=\"totalNotifications == 0\" class=text-muted>{{\'cm.head.notify.1\' | translate}}</div><li role=menuitem ng-if=\"notifications.uc > 0\"><a ui-sref=.contentLibrary.uc role=button class=\"alert alert-info\"><span class=\"fa fa-folder-open marR10 text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.uc}} {{\'cm.head.notify.2\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.ec > 0\"><a ui-sref=.contentLibrary.ec role=button class=\"alert alert-warning\"><span class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=true></span> <span class=text-warning>{{notifications.ec}} {{\'cl.tab.3\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.dc > 0\"><a ui-sref=.contentLibrary.dc role=button class=\"alert alert-danger\"><span class=\"fa fa-exclamation-triangle text-danger\" aria-hidden=true></span> <span class=text-danger>{{notifications.dc}} {{\'cl.tab.5\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.ut > 0\"><a ui-sref=.templates.ut role=button class=\"alert alert-info\"><span class=\"fa fa-file-o text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.ut}} {{notifications.ut > 1?\'cm.head.notify.3s\':\'cm.head.notify.3\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.it > 0\"><a ui-sref=.templates.it role=button class=\"alert alert-warning\"><span class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=true></span> <span class=text-warning>{{notifications.it}} {{\'t.tab.3\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.us > 0\"><a ui-sref=.schedules.us role=button class=\"alert alert-info\"><span class=\"fa fa-calendar text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.us}} {{notifications.us > 1?\'cm.head.notify.4s\':\'cm.head.notify.4\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.is > 0\"><a ui-sref=.schedules.is role=button class=\"alert alert-warning\"><span class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=true></span> <span class=text-warning>{{notifications.is}} {{\'s.tab.3\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.es > 0\"><a ui-sref=.schedules.es role=button class=\"alert alert-danger\"><span class=\"fa fa-exclamation-triangle text-danger\" aria-hidden=true></span> <span class=text-danger>{{notifications.es}} {{\'s.tab.4\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.ufl > 0\"><a ui-sref=.frameLayouts.ufl role=button class=\"alert alert-info\"><span class=\"fa fa-object-ungroup text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.ufl}} {{notifications.ufl > 1?\'cm.head.notify.5s\':\'cm.head.notify.5\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.efla > 0\"><a ui-sref=.frameLayouts.fla role=button class=\"alert alert-danger\"><span class=\"fa fa-exclamation-triangle text-danger\" aria-hidden=true></span> <span class=text-danger>{{notifications.efla}} {{notifications.efla > 1?\'cm.head.notify.8s\':\'cm.head.notify.8\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.if > 0\"><a ui-sref=.frameLayouts.ifl role=button class=\"alert alert-warning\"><span class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=true></span> <span class=text-warning>{{notifications.if}} {{\'fl.tab.4\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.inv > 0\"><a ui-sref=.creativeServices.inv role=button class=\"alert alert-info\"><span class=\"fa fa-file-text-o text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.inv}} {{notifications.inv > 1?\'cm.head.notify.6s\':\'cm.head.notify.6\' | translate}}</span></a></li><li role=menuitem ng-if=\"notifications.ucs > 0\"><a ui-sref=.creativeServices.cur role=button class=\"alert alert-info\"><span class=\"fa fa-paint-brush text-info\" aria-hidden=true></span> <span class=text-info>{{notifications.ucs}} {{notifications.ucs > 1?\'cm.head.notify.7s\':\'cm.head.notify.7\' | translate}}</span></a></li></div></ul></li><!-- notification dropdown end --></ul><div class=\"nav navbar-nav navbar-right switch-nav\"><div class=marB5>{{\'ms.label.33\' | translate}}:</div><switch role=switch class=switch-sm ng-model=themeSwitch.btn aria-checked={{themeSwitch.btn?true:false}} on=\"{{\'ms.label.33.2\' | translate}}\" off=\"{{\'ms.label.33.1\' | translate}}\" ng-change=\"preferencesFx(\'theme\')\"></switch></div></div></div></nav>");
$templateCache.put("app/common/home.html","<section class=wrapper ng-class=\"{\'leftPanel-hide\': auth.upreferences.isLPOpen == 0}\"><div ui-view=header></div><section class=container-fluid><div ui-view=leftPanel role=menu></div><div role=main class=mainContainer flow-init=\"{headers:{\'authorization\':auth.token},query:contentPermissionExpiry}\" flow-upload-started=uploadStart(); flow-file-success=\"fileSuccess($message, $file);\" flow-complete=uploadComplete();><!-- flow-files-submitted=\"contentUploadFX()\"--><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=showTimeoutMsg><span translate=\"{{\'cm.msg.28\'}}\" translate-values=\"{sessionTimer: \'{{sessionTimer}}\',htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></span> <a href=\"\" role=link class=\"btn-link text-bold\" ng-click=resetSession(true);>{{\'cm.msg.29\' | translate}}</a></div><div ui-view=\"\"></div><div class=uploadMiniQuad ng-if=\"$flow.isUploading() && ($state.includes(\'hub.contentAdd.contentAddTab\') != true)\"><div class=upload-header><a href=\"\" role=link class=pull-right ng-click=miniUploadMinimizeFx()><span class=fa ng-class=\"miniUploadMinimized?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a> <span translate=\"{{\'cm.body.13\'}}\" translate-values=\"{count: {{$flow.files.length}}, key: \'{{$flow.files.length > 1?\'cm.label.74s\':\'cm.label.74\' | translate}}\'}\"></span></div><div class=\"upload-list table no-th\" ng-if=!miniUploadMinimized><div ng-repeat=\"file in $flow.files\" class=row><div class=\"col-xs-8 text-ellipsis\">{{file.name}}</div><div class=col-xs-4><div class=progress><div class=\"progress-bar progress-bar-striped active\" style=\"width:{{ 100 * file.progress() | number:0 }}%\"><span class=pad2>{{ 100 * file.progress() | number:0 }}%</span></div></div></div></div></div></div></div><iframe ng-src={{ssoLogoutURL}} width=0 height=0 class=noBdr title=ssoLogout></iframe></section></section><!-- Footer section --><div ui-view=footer ng-class=\"{\'leftPanel-hide\': auth.upreferences.isLPOpen == 0}\" aria-label=Footer></div>");
$templateCache.put("app/common/leftPanel.html","<div class=sidebar ng-class=\"{\'bdrRl\':(!auth.upreferences.isLPOpen && myTheme.clientTheme==\'rcg\')}\"><ul class=\"nav nav-sidebar\" role=menu aria-labelledby=leftNav aria-orientation=vertical ng-class=\"{\'lenovo-navbar\':(!auth.upreferences.isLPOpen && myTheme.clientTheme !=\'\')}\"><li role=menuitem ng-class=\"{\'active\':selectedMenu===0}\"><a ui-sref=.dashboard role=menuitem uib-tooltip=\"{{\'cm.menu.0\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-dashboard\" aria-hidden=true ng-click=\"changeModule(\'db\')\"></i>{{\'cm.menu.0\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===1}\" ng-if=auth.uservices.c><a ui-sref=.contentLibrary.c role=menuitem uib-tooltip=\"{{\'cm.menu.1\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-folder-open\" aria-hidden=true ng-click=\"changeModule(\'c\')\"></i>{{\'cm.menu.1\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===2}\" ng-if=auth.uservices.t><a ui-sref=.templates.t role=menuitem uib-tooltip=\"{{\'cm.menu.2\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-file-o\" aria-hidden=true ng-click=\"changeModule(\'t\')\"></i>{{\'cm.menu.2\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===3}\" ng-if=auth.uservices.s><a ui-sref=.schedules.s role=menuitem uib-tooltip=\"{{\'cm.menu.3\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-calendar\" aria-hidden=true ng-click=\"changeModule(\'s\')\"></i>{{\'cm.menu.3\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===4}\" ng-if=auth.uservices.fl><a ui-sref=.frameLayouts.fl role=menuitem uib-tooltip=\"{{\'cm.menu.4\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-object-ungroup\" aria-hidden=true ng-click=\"changeModule(\'fl\')\"></i>{{\'cm.menu.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===5}\" ng-if=auth.uservices.d><a ng-if=!auth.upreferences.sdtf ui-sref=.devices.d role=menuitem uib-tooltip=\"{{\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"glyphicon glyphicon-hdd\" aria-hidden=true ng-click=\"changeModule(\'d\')\"></i>{{\'cm.menu.5\' | translate}}</a> <a ng-if=auth.upreferences.sdtf ui-sref=.devices.dt role=menuitem uib-tooltip=\"{{\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"glyphicon glyphicon-hdd\" aria-hidden=true ng-click=\"changeModule(\'dt\')\"></i>{{\'cm.menu.5\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===6}\" ng-if=auth.uservices.u><a ui-sref=.users.au role=menuitem uib-tooltip=\"{{\'cm.menu.6\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-user\" aria-hidden=true ng-click=\"changeModule(\'u\')\"></i>{{\'cm.menu.6\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===7}\" ng-if=auth.uservices.em><a ui-sref=.emergencyMsg.em role=menuitem uib-tooltip=\"{{\'cm.menu.7\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-warning\" aria-hidden=true ng-click=\"changeModule(\'em\')\"></i>{{\'cm.menu.7\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===8}\" ng-if=\"auth.uservices.r || auth.upermissions.hds\"><a href=\"\" role=menuitem ng-click=reportURLFx(); uib-tooltip=\"{{\'cm.menu.8\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-bar-chart\" aria-hidden=true ng-click=\"changeModule(\'r\')\"></i>{{\'cm.menu.8\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===11}\" ng-if=\"auth.uservices.inven && (auth.upermissions.inv.vdl || auth.upermissions.inv.ad || auth.upermissions.inv.dlt || auth.upermissions.inv.ed)\"><a ui-sref=\"{{auth.upermissions.inv.vdl ? \'.inventory.devices\' : \'.inventory.others\'}}\" role=menuitem uib-tooltip=\"{{\'cm.menu.11\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-table\" aria-hidden=true ng-click=\"changeModule(\'inv\')\"></i>{{\'cm.menu.11\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===9}\" ng-if=auth.uservices.cs><a ui-sref=.creativeServices.cur role=menuitem uib-tooltip=\"{{\'cm.menu.9\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-paint-brush\" aria-hidden=true ng-click=\"changeModule(\'cur\')\"></i>{{\'cm.menu.9\' | translate}}</a></li><li role=menuitem ng-class=\"{\'active\':selectedMenu===10}\" ng-if=auth.uservices.bp><a ui-sref=.billing.s role=menuitem uib-tooltip=\"{{\'cm.menu.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right tooltip-enable=!auth.upreferences.isLPOpen ng-cloak><i class=\"fa fa-credit-card\" aria-hidden=true ng-click=\"changeModule(\'bp\')\"></i>{{\'cm.menu.10\' | translate}}</a></li></ul><div class=time-widget><div>{{currentDate | date:\'shortTime\'}}</div><div>{{currentDate | date:\'fullDate\'}}</div></div></div>");
$templateCache.put("app/common/mySettings.html","<section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs\" role=tablist aria-labelledby=navList><li ui-sref-active=active role=tab><a ui-sref=.pro role=button>{{\'ms.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab><a ui-sref=.pre role=button>{{\'ms.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab><a ui-sref=.ss role=button>{{\'ms.tab.5\' | translate}}</a></li><li ui-sref-active=active role=tab ng-if=\"!sso && !msal\"><a ui-sref=.cp role=button>{{\'ms.tab.4\' | translate}}</a></li><li ui-sref-active=active role=tab ng-if=\"auth.uType == 0 || auth.scType == 2\"><a ui-sref=.co role=button>{{\'ms.tab.6\' | translate}}</a></li><li ui-sref-active=active role=tab ng-if=\"auth.uType == 0\"><a ui-sref=.as role=link>{{\'ms.p_s.tab.12\' | translate}}</a></li><!-- Asana Integration --><li ui-sref-active=active role=tab ng-if=\"auth.upermissions.asana && auth.uType != 3 && auth.uType != 4\"><a ui-sref=.asana role=link>{{\'cm.asn.1\' | translate}}</a></li><!-- ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1\" --></ul><div class=\"form-group dropdown-server-setting\" ng-if=\"$state.includes(\'hub.mySettings.ss\')\"><div class=\"dropdown customSelect customSelectServer\" uib-dropdown auto-close=outsideClick><span aria-label=currentServer class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"serverSearchFocus();searchServer.text=\'\'\">{{selectedServerSetting}} <span class=caret ng-if=\"settings.roles.length > 1\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"settings.roles.length > 1\"><li class=dropdown-header ng-if=\"settings.roles.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control id=searchServerText ng-model=searchServer.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchServer.text.length ng-click=\"searchServer.text=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"settings.roles.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"role in serverSettingList = (serverSettingData| filter:searchServer.text) | orderBy: \'label\'\" tabindex=$index><label ng-model=role.selected ng-click=\"changeServerSetting(role.id, role.label, role.uType, settings.info.scType, role.isDmb);\"><label></label>{{role.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"serverSettingList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchServer.text)}}&quot;</b>\'}\"></div></div></ul></div></div></header><!-- above code commited because scroll issue in mySetting cordinator --><div class=panel-body><div ui-view=tabView></div></div><div class=panel-footer ng-if=\"!settingsLoading && $state.includes(\'hub.mySettings.pro\')\"><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'ms.msg.1\' | translate}}</span> <span ng-if=\"errType==\'contact\'\" aria-live=polite role=status>{{\'ms.msg.2\' | translate}}</span></div><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=settingFx(); ng-disabled=profileProcessing><span class=fa ng-class=\"profileProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{profileProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button></span></div><div class=panel-footer ng-if=\"!settingsLoading && $state.includes(\'hub.mySettings.pre\')\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"preferencesAllFx(settings.uDashboard, settings.dSettings);\" ng-disabled=uPSaveProcessing><span class=fa ng-class=\"uPSaveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{uPSaveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button></span></div><div class=\"panel-footer text-left\" ng-if=\"$state.includes(\'hub.mySettings.cp\')\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=updatePassFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasPwdErr aria-live=polite role=status><span ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</span> <span ng-if=\"errType==\'match\'\" aria-live=polite role=status>{{\'ms.msg.12\' | translate}}</span> <span ng-if=\"errType==\'curPwd\'\" aria-live=polite role=status>{{\'ms.msg.13\' | translate}}</span> <span ng-if=\"errType==\'oldNew\'\" aria-live=polite role=status>{{\'ms.msg.14\' | translate}}</span> <span ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>{{\'ms.msg.15\' | translate}}</span></div><div class=clearfix></div></div><footer class=panel-footer ng-if=\"!settingsLoading && $state.includes(\'hub.mySettings.ss\') && selectTab !=\'4\' && selectTab !=\'5\' && selectTab !=\'8\' && selectTab !=\'9\' && selectTab !=\'10\' && selectTab !=\'12\' && selectTab !=\'13\'\"><span class=btnQuad><span ng-if=\"selectTab==1\"><button type=button role=button class=\"btn btn-success\" ng-click=serverSettingFx(1); ng-disabled=\"saveProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{primeProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><span ng-if=\"selectTab==2\"><button type=button role=button class=\"btn btn-success\" ng-click=serverSettingFx(2); ng-disabled=\"saveProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> </span><span ng-if=\"selectTab==3\"><button type=button role=button class=\"btn btn-success\" ng-click=\"serverSettingFx(3, 1);\" ng-disabled=\"saveProcessingServer || savePProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"savePProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.polling.4\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"serverSettingFx(3, 0);\" ng-disabled=\"saveProcessingServer || savePProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.polling.5\' | translate}}</button> </span><span ng-if=\"selectTab==6\"><button type=button role=button class=\"btn btn-success\" ng-click=serverSettingFx(6); ng-disabled=\"saveProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessingServer?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><span ng-if=\"selectTab==7\"><button type=button role=button class=\"btn btn-success\" ng-click=serverSettingFx(7); ng-disabled=\"saveProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessingServer?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><span ng-if=\"selectTab==11\"><button type=button role=button class=\"btn btn-success\" ng-click=serverSettingFx(11); ng-disabled=\"saveProcessingServer || settingLoadingServer\"><span class=fa ng-class=\"saveProcessingServer?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessingServer?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button></span></span><div class=\"errMsg pull-right\" ng-if=\"hasErr || hasErrPop || hasDurErr || hasServerPerErr\" aria-live=polite role=status><span ng-if=\"selectTab==2\" aria-live=polite role=status><span ng-if=\"errType == \'excludeSE\' || errType == \'invalidTime\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m2\' | translate}}</span> <span ng-if=\"errType == \'offlineTime\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m4\' | translate}}</span> <span ng-if=\"errType == \'email\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m3\' | translate}}</span> <span ng-if=\"errTypePop == \'offline\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m1\' | translate}}</span> <span ng-if=\"errTypePop == \'threshold\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m5\' | translate}}</span> <span ng-if=\"errTypePop == \'noSch\'\" aria-live=polite role=status>{{\'s.msg.1\' | translate}}</span> <span ng-if=\"errTypePop == \'noSelSch\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m8\' | translate}}</span> <span ng-if=\"errTypePop == \'noSelExSch\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m9\' | translate}}</span> </span><span ng-if=\"selectTab==3\" aria-live=polite role=status>{{\'ms.p_s.polling.m1\' | translate}}</span> <span ng-if=\"selectTab==7\" aria-live=polite role=status><span ng-if=\"errServerPerType==\'cs\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m1\' | translate}}</span> <span ng-if=\"errServerPerType==\'cst\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m19\' | translate}}</span> <span ng-if=\"errServerPerType==\'cstMore\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m20\' | translate}}</span> <span ng-if=\"errServerPerType==\'iTime\'\" aria-live=polite role=status>{{\'ms.p_am.m1\' | translate}}</span> <span ng-if=\"errServerPerType==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</span> <span ng-if=\"durErrType==\'invDur\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m26\' | translate}}</span> <span ng-if=\"errServerPerType==\'noCredentialSP\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m29\' | translate}}</span> <span ng-if=\"errTypePop==\'gdOS\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m30\' | translate}}</span> <span ng-if=\"errTypePop==\'gdSP\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m31\' | translate}}</span> <span ng-if=\"durErrType==\'dmbSubEmpt\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m33\' | translate}}</span></span></div><div class=\"msg-warning inline marL10\" lang={{auth.lang}} ng-if=\"selectTab==5 && uploadFileCount > 0\">{{\'ms.p_s.defaultImg.m1\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/pre.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=settingsLoading><div ng-if=!settingsLoading><div class=row><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=deviceViewT class=marR10><input type=radio role=radio aria-labelledby=deviceViewT name=dViewOpt id=deviceViewT ng-model=uPreferences.deviceView value=t><label></label>{{\'ms.label.6.1\' | translate}}</label><label for=deviceViewL><input type=radio role=radio aria-labelledby=deviceViewL name=dViewOpt id=deviceViewL ng-model=uPreferences.deviceView value=l><label></label>{{\'ms.label.6.2\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.7\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=isLPOpen1 class=marR10><input type=radio role=radio aria-labelledby=isLPOpen1 name=lpOpenOpt id=isLPOpen1 ng-model=uPreferences.isLPOpen ng-value=1><label></label>{{\'ms.label.7.1\' | translate}}</label><label for=isLPOpen0><input type=radio role=radio aria-labelledby=isLPOpen0 name=lpOpenOpt id=isLPOpen0 ng-model=uPreferences.isLPOpen ng-value=0><label></label>{{\'ms.label.7.2\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.8\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=isPin1 class=marR10><input type=radio role=radio aria-labelledby=isPin1 name=isPinOpt id=isPin1 ng-model=uPreferences.isPin ng-value=1><label></label>{{\'cm.tool.8\' | translate}}</label><label for=isPin0><input type=radio role=radio aria-labelledby=isPin0 name=isPinOpt id=isPin0 ng-model=uPreferences.isPin ng-value=0><label></label>{{\'cm.tool.9\' | translate}}</label></div></div></div><div class=row><div class=\"form-group col-xs-4 hide\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=isPopup1 class=marR10><input type=radio role=radio aria-labelledby=isPopup1 name=isPopupOpt id=isPopup1 ng-model=uPreferences.isPopup ng-value=1><label></label>{{\'cm.btn.4\' | translate | camelCase}}</label><label for=isPopup0><input type=radio role=radio aria-labelledby=isPopup0 name=isPopupOpt id=isPopup0 ng-model=uPreferences.isPopup ng-value=0><label></label>{{\'cm.btn.5\' | translate | camelCase}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.10\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=isSplitV1 class=marR10><input type=radio role=radio aria-labelledby=isSplitV1 name=isSplitVOpt id=isSplitV1 ng-model=uPreferences.isSplitV ng-value=1><label></label>{{\'ms.label.10.1\' | translate}}</label><label for=isSplitV0><input type=radio role=radio aria-labelledby=isSplitV0 name=isSplitVOpt id=isSplitV0 ng-model=uPreferences.isSplitV ng-value=0><label></label>{{\'ms.label.10.2\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=isTreeOpen1 class=marR10><input type=radio role=radio aria-labelledby=isTreeOpen1 name=isTreeOpenOpt id=isTreeOpen1 ng-model=uPreferences.isTreeOpen ng-value=1><label></label>{{\'cm.btn.4\' | translate | camelCase}}</label><label for=isTreeOpen0><input type=radio role=radio aria-labelledby=isTreeOpen0 name=isTreeOpenOpt id=isTreeOpen0 ng-model=uPreferences.isTreeOpen ng-value=0><label></label>{{\'cm.btn.5\' | translate | camelCase}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.27\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=scaleF><input type=radio role=radio aria-labelledby=scaleF name=scaleOpt id=scaleF ng-model=uPreferences.scale value=fit><label></label>{{\'ms.label.27.1\' | translate}}</label><label for=scaleC class=\"marL10 marR10\"><input type=radio role=radio aria-labelledby=scaleC name=scaleOpt id=scaleC ng-model=uPreferences.scale value=crop><label></label>{{\'ms.label.27.2\' | translate}}</label><label for=scaleS><input type=radio role=radio aria-labelledby=scaleS name=scaleOpt id=scaleS ng-model=uPreferences.scale value=skew><label></label>{{\'ms.label.27.3\' | translate}}</label></div></div></div><div class=row><div class=form-group ng-class=\"twoFAObj.is2fa?\'col-xs-6\':\'col-xs-4\'\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.21\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=is2fa1 class=marR10><input type=radio role=radio aria-labelledby=is2fa1 name=twoOpt id=is2fa1 ng-model=twoFAObj.is2fa ng-value=true ng-change=getTwoFAFx();><label></label>{{\'ms.label.21.1\' | translate}}</label><label for=is2fa0><input type=radio role=radio aria-labelledby=is2fa0 name=twoOpt id=is2fa0 ng-model=twoFAObj.is2fa ng-value=false ng-change=\"twoFAFx(\'d\');\"><label></label>{{\'ms.label.21.2\' | translate}}</label></div><div ng-if=twoFAObj.is2fa class=\"pad10 bg-light twoFAQuad\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=twoFALoading><div ng-if=!twoFALoading><div class=marB10>{{\'ms.label.23\' | translate}} <a href=\"\" role=link class=text-bold ng-click=setUpOpen();>{{\'ms.label.24\' | translate}}</a>:</div><img alt=\"\" ng-src=\"{{twoFAObj.qr+\'&v=\'+ timestamp}}\" width=150 height=150 ng-cloak><div class=text-sm><a href=\"\" role=link ng-click=setUpOpen();>{{\'ms.label.25\' | translate}}</a></div><div class=row ng-if=!twoFAObjCopy.is2fa><div class=\"col-xs-6 form-input marT5\"><label for=curTwoFAOTP>{{\'ms.label.22\' | translate}}</label><div class=input-group><input type=text class=form-control id=curTwoFAOTP ng-model=curTwoFA.otp focus-me=true aria-label=curTwoFAOTP aria-labelledby=curTwoFAOTP> <span class=input-group-btn><button type=button role=button class=\"btn btn-success\" ng-click=\"twoFAFx(\'s\');\" ng-disabled=saveProcessing>{{\'ms.btn.4\' | translate}}</button></span></div></div><div class=col-xs-6><label class=w100>&nbsp;</label><div class=\"errMsg marT5 pull-left\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'optEmpty\'\" aria-live=polite role=status>{{\'ms.msg.29\' | translate}}</div><div ng-if=\"errType==\'opt\'\" aria-live=polite role=status>{{\'ms.msg.30\' | translate}}</div></div></div></div></div></div></div><div class=\"form-group col-xs-4\" ng-class=\"twoFAObj.is2fa?\'col-xs-offset-2\':\'\'\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.32\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=sddrY><input type=radio role=radio aria-labelledby=sddrY name=sddrOpt id=sddrY ng-model=uPreferences.sddr value=y><label></label>{{\'ms.label.32.1\' | translate}}</label><label for=sddrM class=\"marL10 marR10\"><input type=radio role=radio aria-labelledby=sddrM name=sddrOpt id=sddrM ng-model=uPreferences.sddr value=m><label></label>{{\'ms.label.32.2\' | translate}}</label><label for=sddrW><input type=radio role=radio aria-labelledby=sddrW name=sddrOpt id=sddrW ng-model=uPreferences.sddr value=w><label></label>{{\'ms.label.32.3\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" ng-class=\"twoFAObj.is2fa?\'col-xs-offset-2\':\'\'\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.33\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=themeDF><input type=radio role=radio aria-labelledby=themeDF name=themeOpt id=themeDF ng-model=uPreferences.theme value=df><label></label>{{\'ms.label.33.1\' | translate}}</label><label for=themeDK class=\"marL10 marR10\"><input type=radio role=radio aria-labelledby=themeDK name=themeOpt id=themeDK ng-model=uPreferences.theme value=dk><label></label>{{\'ms.label.33.2\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" ng-class=\"twoFAObj.is2fa?\'col-xs-offset-2\':\'\'\" role=radiogroup aria-labelledby=radiogroup><label>{{\'ms.label.34\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=dmbsortD><input type=radio role=radio id=dmbsortD name=sortOpt ng-model=uPreferences.dmbsort value=d><label></label>{{\'cm.label.90\' | translate}}</label><label for=dmbsortA class=\"marL10 marR10\"><input type=radio role=radio id=dmbsortA name=sortOpt ng-model=uPreferences.dmbsort value=a><label></label>{{\'ms.label.34.1\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\"><label>{{\'ms.label.44\' | translate}}</label><div><label class=marR10><input type=radio name=isDFTreeOpenOpt ng-model=uPreferences.isDFTreeOpen ng-value=1><label></label>{{\'cm.btn.4\' | translate | camelCase}}</label><label><input type=radio name=isDFTreeOpenOpt ng-model=uPreferences.isDFTreeOpen ng-value=0><label></label>{{\'cm.btn.5\' | translate | camelCase}}</label><!-- <span class=\"treeOpt\" ng-if=\"uPreferences.isDFTreeOpen==1\">\r\n            <label class=\"noMarB marL10\" for=\"isICF\"><input type=\"checkbox\" id=\"isICF\" ng-true-value=\"{{ 1 | json }}\" ng-false-value=\"{{ 0 | json }}\" ng-model=\"uPreferences.isICF\" role=\"checkbox\" aria-label=\"isICF\" aria-labelledby=\"isNotify\"><label></label> {{\'d.label.30\' | translate}}</label>\r\n          </span> --></div></div><div class=\"form-group col-xs-12\"><div class=row><div class=\"form-group col-xs-4\"><label>{{\'ms.label.45\' | translate}}</label><div><label for=page class=lableHidden>Search</label><select id=page class=\"form-control input-sm w50\" ng-model=uPreferences.dpc><!-- <option ng-value=\"0\">{{\'cm.tool.2.1\' | translate}}</option> --><option ng-value=25>25</option><option ng-value=50>50</option><option ng-value=100>100</option><option ng-value=150>150</option><option ng-value=200>200</option><option ng-value=300>300</option></select></div></div><div class=\"form-group col-xs-6\"><label>{{\'d.label.48\' | translate}}</label><div ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\"><label for=sfdl><input type=checkbox role=checkbox parse-int ng-true-value=1 ng-false-value=0 aria-labelledby=sfdl id=sfdl ng-model=uPreferences.sfdl><label></label>{{\'d.label.48.1\' | translate}}</label></div><div ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\"><label for=sfop><input type=checkbox role=checkbox parse-int ng-true-value=1 ng-false-value=0 aria-labelledby=sfop id=sfop ng-model=uPreferences.sfop><label></label>{{\'d.label.48.2\' | translate}}</label><label for=newpwd><span class=\"fa fa-info-circle text-primary marL5\" uib-tooltip=\"{{\'d.label.48.2.1\' | translate}}\" tooltip-placement=top aria-hidden=true></span></label></div><div><label for=sdtf><input type=checkbox role=checkbox parse-int ng-true-value=1 ng-false-value=0 aria-labelledby=sdtf id=sdtf ng-model=uPreferences.sdtf><label></label>{{\'d.label.48.3\' | translate}}</label></div></div></div></div><div class=\"form-group col-xs-4\"><label>{{\'ms.label.46\' | translate}}</label><div><label class=marR10><input type=radio name=cViewOpt ng-model=uPreferences.contentView value=t><label></label>{{\'ms.label.6.1\' | translate}}</label><label><input type=radio name=cViewOpt ng-model=uPreferences.contentView value=l><label></label>{{\'ms.label.6.2\' | translate}}</label></div></div><div class=\"col-xs-12 text-bold marB5\" ng-if=\"settings.dashboard.ds || settings.dashboard.c || settings.dashboard.sc || settings.dashboard.us || settings.dashboard.ral || settings.dashboard.d || settings.dashboard.dom || settings.dashboard.dts || settings.dashboard.dps || settings.dashboard.ccs || settings.dashboard.ccl || settings.dashboard.dtps || settings.dashboard.dtpl || settings.dashboard.ssdt || settings.dashboard.rad || settings.dashboard.ot || settings.dashboard.wgw\">{{\'cm.menu.0\' | translate}}</div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><div ng-if=settings.dashboard.ccl><label for=uDashboardCcl><input type=checkbox role=checkbox aria-labelledby=uDashboardCcl id=uDashboardCcl ng-model=settings.uDashboard.ccl><label></label>{{\'ms.label.35.11\' | translate}}</label></div><div ng-if=settings.dashboard.ccs><label for=uDashboardCcs><input type=checkbox role=checkbox aria-labelledby=uDashboardCcs id=uDashboardCcs ng-model=settings.uDashboard.ccs><label></label>{{\'ms.label.35.10\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ccs\');\" aria-label=css uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ccs><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.c><label for=uDashboardC><input type=checkbox role=checkbox aria-labelledby=uDashboardC id=uDashboardC ng-model=settings.uDashboard.c><label></label>{{\'ms.label.35.2\' | translate}}</label></div><div ng-if=settings.dashboard.dp><label for=uDashboardDP><input type=checkbox role=checkbox aria-labelledby=uDashboardDP id=uDashboardDP ng-model=settings.uDashboard.dp><label></label>{{\'d.btn.11\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dp\');\" aria-label=dp uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.dp><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.ds><label for=uDashboardDs><input type=checkbox role=checkbox aria-labelledby=uDashboardDs id=uDashboardDs ng-model=settings.uDashboard.ds><label></label>{{\'ms.label.35.1\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ds\');\" aria-label=ds uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ds><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.dtpl><label for=uDashboardDtpl><input type=checkbox role=checkbox aria-labelledby=uDashboardDtpl id=uDashboardDtpl ng-model=settings.uDashboard.dtpl><label></label>{{\'ms.label.35.16\' | translate}}</label></div><div ng-if=settings.dashboard.dtps><label for=uDashboardDtps><input type=checkbox role=checkbox aria-labelledby=uDashboardDtps id=uDashboardDtps ng-model=settings.uDashboard.dtps><label></label>{{\'ms.label.35.12\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dtps\');\" aria-label=dtps uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.dtps><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.d><label for=uDashboardD><input type=checkbox role=checkbox aria-labelledby=uDashboardD id=uDashboardD ng-model=settings.uDashboard.d><label></label>{{\'ms.label.35.6\' | translate}}</label></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><div ng-if=settings.dashboard.dom><label for=uDashboardDom><input type=checkbox role=checkbox aria-labelledby=uDashboardDom id=uDashboardDom ng-model=settings.uDashboard.dom><label></label>{{\'ms.label.35.7\' | translate}}</label></div><div ng-if=settings.dashboard.dps><label for=uDashboardDps><input type=checkbox role=checkbox aria-labelledby=uDashboardDps id=uDashboardDps ng-model=settings.uDashboard.dps><label></label>{{\'ms.label.35.9\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dps\');\" aria-label=dps uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.dps><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.dpts><label for=uDashboardDpts><input type=checkbox role=checkbox aria-labelledby=uDashboardDpts id=uDashboardDpts ng-model=settings.uDashboard.dpts><label></label>{{\'ms.label.35.18\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dpts\');\" aria-label=dpts uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.dpts><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.dts><label for=uDashboardDts><input type=checkbox role=checkbox aria-labelledby=uDashboardDts id=uDashboardDts ng-model=settings.uDashboard.dts><label></label>{{\'ms.label.35.8\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dts\');\" aria-label=dts uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.dts><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.ssdt><label for=uDashboardSsdt><input type=checkbox role=checkbox aria-labelledby=uDashboardSsdt id=uDashboardSsdt ng-model=settings.uDashboard.ssdt><label></label>{{\'ms.label.35.13\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ssdt\');\" aria-label=ssdt uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ssdt><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.ssdpt><label for=uDashboardSsdpt><input type=checkbox role=checkbox aria-labelledby=uDashboardSsdpt id=uDashboardSsdpt ng-model=settings.uDashboard.ssdpt><label></label>{{\'ms.label.35.19\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ssdpt\');\" aria-label=ssdpt uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ssdpt><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.ssodt><label for=uDashboardSsodt><input type=checkbox role=checkbox aria-labelledby=uDashboardSsodt id=uDashboardSsodt ng-model=settings.uDashboard.ssodt><label></label>{{\'ms.label.35.17\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ssodt\');\" aria-label=ssodt uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ssodt><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.ot><label for=uDashboardOt><input type=checkbox role=checkbox aria-labelledby=uDashboardOt id=uDashboardOt ng-model=settings.uDashboard.ot><label></label>{{\'ms.label.35.15\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ot\');\" aria-label=ot uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.ot><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div><div class=\"form-group col-xs-4\" role=radiogroup aria-labelledby=radiogroup><div ng-if=settings.dashboard.dpi><label for=uDashboardDpi><input type=checkbox role=checkbox aria-labelledby=uDashboardDpi id=uDashboardDpi ng-model=settings.uDashboard.dpi><label></label>{{\'cm.label.98\' | translate}}</label></div><div ng-if=settings.dashboard.ral><label for=uDashboardRal><input type=checkbox role=checkbox aria-labelledby=uDashboardRal id=uDashboardRal ng-model=settings.uDashboard.ral><label></label>{{\'ms.label.35.5\' | translate}}</label></div><div ng-if=settings.dashboard.rad><label for=uDashboardRad><input type=checkbox role=checkbox aria-labelledby=uDashboardRad id=uDashboardRad ng-model=settings.uDashboard.rad><label></label>{{\'ms.label.35.14\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'rad\');\" aria-label=rad uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.rad><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=settings.dashboard.sc><label for=uDashboardSc><input type=checkbox role=checkbox aria-labelledby=uDashboardSc id=uDashboardSc ng-model=settings.uDashboard.sc><label></label>{{\'ms.label.35.3\' | translate}}</label></div><div ng-if=settings.dashboard.us><label for=uDashboardUs><input type=checkbox role=checkbox aria-labelledby=uDashboardUs id=uDashboardUs ng-model=settings.uDashboard.us><label></label>{{\'ms.label.35.4\' | translate}}</label></div><div ng-if=settings.dashboard.wgw><label for=uDashboardWgw><input type=checkbox role=checkbox aria-labelledby=uDashboardWgw id=uDashboardWgw ng-model=settings.uDashboard.wgw><label></label>{{\'db.wgw.2\' | translate}}</label></div><div ng-if=settings.dashboard.wgws><label for=uDashboardWgws><input type=checkbox role=checkbox aria-labelledby=uDashboardWgws id=uDashboardWgws ng-model=settings.uDashboard.wgws><label></label>{{\'db.wgw.3\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'wgws\');\" aria-label=wgws uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=settings.uDashboard.wgws><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div><div class=\"col-xs-12 text-bold marB5\" ng-if=\"(settings.dashboard.adu || settings.dashboard.ds || settings.dashboard.c || settings.dashboard.sc || settings.dashboard.us || settings.dashboard.ral || settings.dashboard.d || settings.dashboard.dom || settings.dashboard.dts || settings.dashboard.dps || settings.dashboard.ccs || settings.dashboard.ccl || settings.dashboard.dtps || settings.dashboard.dtpl || settings.dashboard.ssdt || settings.dashboard.rad || settings.dashboard.ot || settings.dashboard.wgw) && (auth.uType == 0 || auth.uType == 1 || auth.uType == 2)\">{{\"ms.label.41\" | translate}}<div><button type=button role=button class=\"btn btn-default btn-xs marB10 marT5\" ng-click=\"addUser(\'a\',\'adu\');\"><span class=\"fa fa-cog\" aria-hidden=true></span>&nbsp;{{\"ms.btn.10\" | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/common/pro.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=settingsLoading><div ng-if=!settingsLoading><div class=row><div class=\"col-xs-10 col-sm-9\"><div class=row><div class=col-xs-6><div class=form-group><label for=email>{{\'cm.label.47\' | translate}}</label><div class=input-group><input type=text id=email class=form-control ng-model=settings.info.email readonly maxlength=250 aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"> <span class=input-group-btn><button type=button role=button class=\"btn btn-success\" ng-click=\"emailOpen(\'confirm\');\">{{\'ms.btn.1\' | translate}}</button></span></div></div></div><div class=col-xs-6><label for=tel>{{\'cm.label.48\' | translate}}</label><input type=tel id=tel class=form-control ng-model=settings.info.contact maxlength=20 aria-label=\"{{\'cm.label.48\' | translate}}\" aria-labelledby=\"{{\'cm.label.48\' | translate}}\"></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=fName>{{\'ms.label.1\' | translate}}</label><input type=text id=fName class=form-control ng-model=settings.info.fName maxlength=100 aria-label=\"{{\'ms.label.1\' | translate}}\" aria-labelledby=\"{{\'ms.label.1\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=lName>{{\'ms.label.2\' | translate}}</label><input type=text id=lName class=form-control ng-model=settings.info.lName maxlength=100 aria-label=\"{{\'ms.label.2\' | translate}}\" aria-labelledby=\"{{\'ms.label.2\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><ng-timezone timezone=settings.info.timezone label=true timezone-list=timezoneList></ng-timezone></div><div class=col-xs-6><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><!-- <select id=\"lang\" class=\"form-control\" ng-model=\"settings.info.lang\" aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\">\r\n                <option value=\"en_US\">English / USA</option>\r\n                <option value=\"fr_FR\">French / France</option>\r\n                <option value=\"hi_IN\" class=\"hide\">Hindi / India</option>\r\n                <option value=\"es_ES\">Spanish / Spain</option>\r\n              </select> --><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.isopen aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\" ng-click=\"searchList.lang=\'\';\">{{selectedLang = (langArr | filter:settings.info.lang)[0]; \"\"}} <span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle><span ng-if=!settings.info.lang>{{\"cm.label.34\" | translate}}</span> <span ng-if=settings.info.lang>{{selectedLang.n}}<span class=\"inline-B text-muted marL5\" ng-if=\"selectedLang.l != \'English\'\">({{selectedLang.l}})</span></span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"langArr.length > 5\" role=menuitem><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.lang sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger noMarT\" ng-show=searchList.lang.length ng-click=\"searchList.lang=\'\';\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"langArr.length > 5\"></li><div class=\"list-scroll ng-cloak\" role=radiogroup aria-labelledby=radiogroup><li ng-repeat=\"lang in filteredList = (langArr | filter:searchList.lang)\" tabindex=$index><label><input type=radio role=radio name=lang value={{lang.v}} ng-checked=\"lang.v == settings.info.lang\" ng-model=settings.info.lang ng-change=\"status.isopen=false;\"><label></label>{{lang.n}}<span class=\"inline-B text-muted marL5\" ng-if=\"lang.l != \'English\'\">({{lang.l}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"langArr.length > 0 && filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.lang)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div></div></div><div class=\"col-xs-2 col-sm-3\"><div class=pull-right><div class=panel-subheading>{{\'ms.label.3\' | translate}}</div><div class=panel-innerbody><div class=text-center><!-- title-image --> <img alt=Loading src=assets/images/loading-xs.gif ng-if=fileModelLoading> <span ng-if=\"!settings.info.profileImg && !fileModelLoading\"><div class=userThumb><span ng-if=settings.info.fName>{{settings.info.fName | limitTo:1}}</span> <span ng-if=\"!settings.info.fName || settings.info.fName == \' \'\">{{settings.info.email | limitTo:1}}</span></div></span><a ng-href=\"{{detailBucket + settings.info.profileImg | secureThumb}}\" role=button ng-if=\"settings.info.profileImg && !fileModelLoading\" fancyboxable=fbTitleInside><!-- <img alt=\"profile\" ng-src=\"{{settings.info.timthumb + settings.info.profileImg}}&h=75&w=75&q=80&zc=3\"> --> <img alt=\"{{\'cl.e_vid.7\' | translate}}\" ng-src=\"{{tim + bucket + settings.info.profileImg}}&h=75&w=75&q=80&zc=3\"></a><div class=spaceH></div><p><span class=\"btn btn-primary btn-xs btn-file\" ng-disabled=fileModelLoading ng-click=preventAction();>{{\'cm.btn.37\' | translate}} <input type=file file-model options=\"{size:2100000, format:[\'imgOnly\'], callback:true}\" accept=image/* ng-disabled=fileModelLoading ng-if=!isFileUploading aria-label=changeProImg></span></p><p><a href=\"\" role=link class=btn-link ng-if=\"settings.info.profileImg && !fileModelLoading\" ng-click=defaultImgOpen();>{{\'ms.label.4\' | translate}}</a></p><span class=\"text-sm text-muted\" translate=\"{{\'ms.label.18\'}}\" translate-values=\"{htmlTag: \'<br>\', size:\'2 MB\'}\"></span><div class=spaceH2></div></div></div></div></div></div></div></div>");
$templateCache.put("app/common/serverSetting.html","<div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=serverSettingsLoading><div ng-if=!serverSettingsLoading><ul class=\"nav nav-tabs nav-bar d-flex text-center noPadB\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectTab==\'1\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><a href=\"\" role=link ng-click=selectTabFx(1);>{{\'ms.p_s.tab.1\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'2\'}\" ng-if=\"settingsObj.uType != 0\"><a href=\"\" role=link ng-click=selectTabFx(2);>{{\'ms.p_s.tab.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'5\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2 || settingsObj.uType == 3\"><a href=\"\" role=link ng-click=selectTabFx(5);>{{\'ms.p_s.tab.5\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'6\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><a href=\"\" role=link ng-click=selectTabFx(6);>{{\'ms.p_s.tab.6\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'7\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.scType == \'2\'\"><a href=\"\" role=link ng-click=selectTabFx(7);>{{\'ms.p_s.tab.7\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'8\'}\" ng-if=\"settingsObj.uType == 2 && settingsObj.isDmb\"><a href=\"\" role=link ng-click=selectTabFx(8);>{{\'cm.dmb.1\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'9\'}\" ng-if=\"settingsObj.uType != 4 && auth.upermissions.da.dp\"><a href=\"\" role=link ng-click=selectTabFx(9);>{{\'ms.p_s.tab.8\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectTab==\'4\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><a href=\"\" role=link ng-click=selectTabFx(4);>{{\'ms.p_s.tab.4\' | translate}}</a></li><!-- R&G Reports --><li role=tab ng-class=\"{\'active\':selectTab==\'13\'}\" ng-if=\"settingsObj.uType == 0 || settingsObj.scType == \'2\'\"><a href=\"\" role=link ng-click=selectTabFx(13);>{{\'ms.p_s.tab.13\' | translate}}</a></li></ul><div><!-- Tab one Change Prime Admin --><div ng-if=\"selectTab==\'1\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer><div ng-if=\"primeObj.users.length > 0\"><div class=\"table table-scroll no-th scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(350)}}px><div class=row ng-repeat=\"user in primeObj.users\"><div class=\"col-xs-12 primeUserImg\"><label class=\"btn-block text-unbold\" for=prime{{$index}}><span class=primeRadio><input type=radio role=radio aria-label=user aria-labelledby=user name=userName id=prime{{$index}} ng-model=primeObj.info.prime ng-value=user.id ng-disabled=user.isInvited><label></label></span><img alt=\"\" ng-if=user.thumb ng-src=\"{{tim + bucket + user.thumb + profileSmParam + \'&\' + user.thumbV}}\" class=\"pull-left marR5\"> <span ng-if=\"user.label || user.label == \' \'\"><span class=\"profileIcon-sm pull-left\" ng-if=\"!user.thumb && user.label != \' \'\">{{user.label | limitTo:1}}</span> <span class=\"profileIcon-sm pull-left\" ng-if=\"!user.thumb && user.label == \' \'\">{{user.email | limitTo:1}}</span> <span class=pull-left ng-if=\"user.label != \' \'\">{{user.label}}</span> <span class=pull-left ng-if=\"user.label == \' \'\">{{user.email}}</span><br><span class=\"primeText text-muted text-sm\" ng-if=\"user.type == 1\">{{\'ms.p_s.prime.1\' | translate}}</span> <span class=\"primeText text-muted text-sm\" ng-if=\"user.type == 2\">{{\'ms.p_s.prime.2\' | translate}}</span> </span><span ng-if=\"user.label == null && user.email\"><span class=\"profileIcon-sm pull-left\" ng-if=!user.thumb>{{user.email | limitTo:1}}</span> <span class=pull-left>{{user.email}}</span><br><span class=\"primeText text-muted text-sm\">{{\'ms.p_s.prime.3\' | translate}}</span></span></label></div></div></div><label class=\"marT10 noMarB\" for=isNotify><input type=checkbox id=isNotify ng-model=primeObj.info.isNotify role=checkbox aria-label=isNotify aria-labelledby=isNotify><label></label>{{\'ms.p_s.prime.4\' | translate}}</label></div><div ng-if=\"primeObj.users.length == 0\" class=msg-warning lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div><!-- Tab two Mail Notification --><div ng-if=\"selectTab==\'2\'\"><img alt=Loading src=assets/images/loading.gif ng-if=\"settingLoadingServer || dataLoading\"><div ng-if=\"!settingLoadingServer && !dataLoading\"><uib-accordion close-others=true class=accordNotification><!-- Mail Notification --><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(300)}}px><div uib-accordion-group ng-repeat=\"type in notifications\" is-open=$first><uib-accordion-heading ng-if=\"$index == 0\"><span class=\"fa fa-envelope marR5\" aria-hidden=true></span>{{\'ms.p_s.notifyS.2\' | translate}}</uib-accordion-heading><div class=marB5 ng-repeat=\"nft in type track by $index\" ng-if=\"$parent.$index == 0\" ng-class=\"{\'pull-left marL10\':(nft.id != 16.1 && nft.id != 19.1 && nft.id >= 16 && nft.id <= 21) || (nft.id != 24.1 && nft.id >= 24) && nft.id != 28}\"><div class=clearfix></div><label for=nftValue{{$index}}><input type=checkbox id=nftValue{{$index}} ng-model=nft.value ng-disabled=saveProcessing ng-if=\"nft.id != 16.1 && nft.id != 19.1 && nft.id != 24.1 && nft.id != 27\" role=checkbox aria-label=nftValue{{$index}} aria-labelledby=nftValue{{$index}}><label></label><span ng-if=\"nft.id == 1\">{{\'ms.p_s.notifyS.2.1\' | translate}}</span> <span ng-if=\"nft.id == 2\">{{\'ms.p_s.notifyS.2.2\' | translate}}</span> <span ng-if=\"nft.id == 3\">{{\'ms.p_s.notifyS.2.3\' | translate}}</span> <span ng-if=\"nft.id == 4\">{{\'ms.p_s.notifyS.2.4\' | translate}}</span> <span ng-if=\"nft.id == 5\">{{\'ms.p_s.notifyS.2.5\' | translate}}</span> <span ng-if=\"nft.id == 6\">{{\'ms.p_s.notifyS.2.6\' | translate}}</span> <span ng-if=\"nft.id == 7\">{{\'ms.p_s.notifyS.2.7\' | translate}}</span> <span ng-if=\"nft.id == 8\">{{\'ms.p_s.notifyS.2.8\' | translate}}</span> <span ng-if=\"nft.id == 9\">{{\'ms.p_s.notifyS.2.9\' | translate}}</span> <span ng-if=\"nft.id == 10\">{{\'ms.p_s.notifyS.2.12\' | translate}}</span> <span ng-if=\"nft.id == 14\">{{\'ms.p_s.notifyS.2.10\' | translate}}</span> <span ng-if=\"nft.id == 15\">{{\'ms.p_s.notifyS.2.11\' | translate}}</span> <span ng-if=\"nft.id == 16.1\" class=text-bold>{{\'ms.p_s.notifyS.2.13\' | translate}}</span> <span ng-if=\"nft.id == 16\">{{\'ms.p_s.notifyS.2.13.1\' | translate}}</span> <span ng-if=\"nft.id == 17\">{{\'ms.p_s.notifyS.2.13.2\' | translate}}</span> <span ng-if=\"nft.id == 18\">{{\'ms.p_s.notifyS.2.13.3\' | translate}}</span> <span ng-if=\"nft.id == 19.1\" class=text-bold>{{\'ms.p_s.notifyS.2.14\' | translate}}</span> <span ng-if=\"nft.id == 19\">{{\'ms.p_s.notifyS.2.14.1\' | translate}}</span> <span ng-if=\"nft.id == 20\">{{\'ms.p_s.notifyS.2.13.2\' | translate}}</span> <span ng-if=\"nft.id == 21\">{{\'ms.p_s.notifyS.2.13.3\' | translate}}</span> <span ng-if=\"nft.id == 22\">{{\'ms.p_s.notifyS.2.15\' | translate}}</span> <span ng-if=\"nft.id == 23\">{{\'ms.p_s.notifyS.2.16\' | translate}}</span> <span ng-if=\"nft.id == 24.1\" class=text-bold>{{\'ms.p_s.notifyS.2.17\' | translate}}</span> <span ng-if=\"nft.id == 24\">{{\'ms.p_s.notifyS.2.17.1\' | translate}}</span> <span ng-if=\"nft.id == 25\">{{\'ms.p_s.notifyS.2.17.2\' | translate}}</span> <span ng-if=\"nft.id == 26\">{{\'ms.p_s.notifyS.2.17.3\' | translate}}</span> <span ng-if=\"nft.id == 28\">{{\'ms.p_s.notifyS.2.18\' | translate}}</span> <span class=hide ng-if=\"nft.id == 27\">{{\'ms.p_s.notifyS.2.17.4\' | translate}}</span></label><div class=clearFix></div><label for=any ng-if=\"nft.id == 16.1\" class=\"marL10 marT5\"><input id=any type=radio role=radio aria-label=any aria-labelledby=any name=spSchOpt value=a ng-model=spSchedule.type><label></label><span>{{\'as.label.10\' | translate}}</span></label><label for=specific ng-if=\"nft.id == 16.1\" class=\"marL10 marT5\"><input id=specific type=radio role=radio aria-label=\"{{\'ms.p_s.serverPer.57\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.57\' | translate}}\" name=spSchOpt value=s ng-model=spSchedule.type><label></label><span>{{\'ms.p_s.serverPer.57\' | translate}} <span ng-if=\"spSchedule.type==\'s\'\">:</span></span><!-- <img alt=\"Loading\" class=\"marL5\" src=\"assets/images/loading-xs.gif\" ng-if=\"schLoading\"> --> <span class=marL5 ng-if=\"spSchedule.type==\'s\'\"><span ng-if=\"selectedIDs.length>0\">{{selectedIDs.length}}</span><span ng-if=!selectedIDs.length class=text-muted>N/A</span> <button ng-if=\"notifications.schCount > 0\" type=button role=button class=\"btn btn-default btn-xs\" ng-click=scheduleListOpen();>{{\'cm.btn.21\' | translate}}</button></span></label><div ng-if=\"nft.id == 15 && nft.value\" class=\"bg-light marL20 pad10\"><div class=row><div class=col-xs-6></div><div class=col-xs-6><div class=marB5><label class=noMarB for=isExcluded><input type=checkbox id=isExcluded ng-model=offline.isExcluded role=checkbox aria-label=\"{{\'ms.p_s.notifyS.2.11.1\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.notifyS.2.11.1\' | translate}}\"><label></label>{{\'ms.p_s.notifyS.2.11.1\' | translate}}</label></div></div><div class=clearfix></div><div class=col-xs-3><label for=timeout>{{\'ms.p_s.notifyS.2.11.2\' | translate}} <span class=\"text-muted text-sm\">(Min 5 - Max 1440)</span></label><div class=input-group><input type=number id=timeout class=form-control ng-model=offline.timeout min=5 max=1440 aria-label=\"{{\'ms.p_s.notifyS.2.11.2\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.notifyS.2.11.2\' | translate}}\"><div class=input-group-addon>{{\'cm.label.28\' | translate}}</div></div></div><div class=col-xs-3><label for=threshold>{{\'ms.p_s.notifyS.2.11.3\' | translate}}</label><div class=form-group><input type=number id=threshold class=form-control ng-model=offline.threshold min=1 aria-label=\"{{\'ms.p_s.notifyS.2.11.3\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.notifyS.2.11.3\' | translate}}\"></div></div><div class=\"col-xs-3 timepicker\"><label for=startTime>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=startTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"offline.startTime | date:\'shortTime\'\" readonly ng-disabled=!offline.isExcluded aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=offline.startTime hour-step=1 minute-step=5></div></div></span></div><div class=\"col-xs-3 timepicker\"><label for=endTime>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=endTime uib-dropdown-toggle ng-value=\"offline.endTime | date:\'shortTime\'\" readonly ng-disabled=!offline.isExcluded aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=offline.endTime hour-step=1 minute-step=5></div></div></span></div></div></div></div><div class=marB5 ng-if=\"$index != 0\">This feature will be available soon.</div></div></div></uib-accordion><div class=\"bg-light pad10\" ng-if=\"settingsObj.sid == 101\"><div class=form-group><label for=offlineTimeout>Offline mail setting</label><p>Send email to following ids when device is offline for <input type=number class=\"form-control input-sm\" style=width:100px;display:inline-block id=offlineTimeout ng-model=notify.offlineTimeout min=5 max=600 aria-label=offlineTimeout aria-labelledby=offlineTimeout> minutes.</p><label>Email <span class=\"text-muted text-sm\">(one per line)</span></label><textarea class=form-control ng-model=notify.email></textarea></div><div class=\"form-group noMarB\"><label for=exclude><input type=checkbox id=exclude ng-model=notify.exclude role=checkbox aria-label=exclude aria-labelledby=exclude><label></label>Exclude time range:</label><div><div class=\"timepicker pull-left\" style=width:47%><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=excludeST class=\"form-control picker\" uib-dropdown-toggle ng-value=\"notify.excludeST | date:\'shortTime\'\" placeholder=HH:mm readonly ng-disabled=!notify.exclude aria-label=excludeST aria-labelledby=excludeST></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=notify.excludeST hour-step=1 minute-step=5></div></div></span></div><div class=\"text-center pull-left\" style=width:6%;padding-top:7px>to</div><div class=\"timepicker pull-right\" style=width:47%><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=excludeET uib-dropdown-toggle ng-value=\"notify.excludeET | date:\'shortTime\'\" placeholder=HH:mm readonly ng-disabled=!notify.exclude aria-label=excludeET aria-labelledby=excludeET></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=notify.excludeET hour-step=1 minute-step=5></div></div></span></div></div><div class=clearfix></div></div></div></div></div><!-- Tab five default image --><div ng-if=\"selectTab==\'5\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer><h5 class=\"panel-inner-tab marB10\">{{\'ms.p_s.defaultImg.1\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'ms.p_s.defaultImg.3\' | translate}}\" tooltip-placement=right aria-hidden=true></span></h5><div class=row><div class=col-xs-4><div class=diThumbQuad ng-class=\"{\'hide\':!defaultImg.default.label}\" ng-if=defaultImg.default><img alt=\"\" id=default ng-class=\"{\'diCurImg bdr pad2\':defaultImg.default.curImg}\"> <a ng-href=\"{{detailBucket + defaultImg.default.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{defaultImg.default.label}} ng-show=defaultImg.default.thumb><img alt=\"\" ng-src=\"{{defaultImg.info.timthumb + bucket + defaultImg.default.thumb + thumbParam}}\" class=\"bdr pad2\"> </a><a href=\"\" role=link class=\"diDeleteBtn text-danger marL10\" ng-if=!defaultImg.default.uploading ng-click=\"deleteConfirmFx(\'default\');\">{{\'cm.btn.13\' | translate}}</a> <span class=\"diUploading marL10\" ng-if=defaultImg.default.uploading>{{\'cm.btn.16i\' | translate}}<img alt=Loading src=assets/images/loading-xs.gif class=marL5></span><div class=clearfix></div></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file id=fileDefault file-model=curFileDete options=\"{size:2147482548, format:[\'imgOnly\'], callback:true, value:\'default\'}\" accept=image/* ng-disabled=\"defaultImg.default.uploading || saveProcessing\"> <input type=text class=form-control ng-value=defaultImg.default.label readonly aria-label=defaultLabel aria-labelledby=defaultLabel></div></div></div><h5 class=\"panel-inner-tab marT25 marB10\" ng-if=\"defaultImg.resolutions.length > 0\">{{\'ms.p_s.defaultImg.2\' | translate}}:</h5><div class=\"row scrollQuad\" style=max-height:{{getAvailableHeight(520)}}px><div class=col-xs-4><div class=form-group ng-if=\"defaultImg.resolutions.length > 0\"><ul class=list-unstyled><li class=form-group ng-repeat=\"res in defaultImg.resolutions\"><label for={{res.res}}>{{res.res}}</label><div class=diThumbQuad ng-class=\"{\'hide\':!res.label}\"><img alt=\"\" id={{res.res}} ng-class=\"{\'diCurImg bdr pad2\':res.curImg}\"> <a ng-href=\"{{detailBucket + res.thumb | secureThumb}}\" role=button class=diUploadedThumb fancyboxable=fbTitleInside data-fancybox-title={{res.label}} ng-if=res.thumb><img alt=\"\" ng-src=\"{{defaultImg.info.timthumb + bucket + res.thumb + thumbParam}}\" class=\"bdr pad2\"> </a><a href=\"\" role=link class=\"diDeleteBtn text-danger marL10\" ng-if=!res.uploading ng-click=deleteConfirmFx(res.res);>{{\'cm.btn.13\' | translate}}</a> <span class=\"diUploading marL10\" ng-if=res.uploading>{{\'cm.btn.16i\' | translate}}<img alt=Loading src=assets/images/loading-xs.gif class=marL5></span><div class=clearfix></div></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file id=file{{res.res}} file-model=curFileDete options=\"{size:2147482548, format:[\'imgOnly\'], callback:true, value:\'{{res.res}}\'}\" accept=image/* ng-disabled=\"res.uploading || saveProcessing\"> <input type=text class=form-control ng-value=res.label readonly aria-label=resLabel aria-labelledby=resLabel></div></li></ul></div></div></div></div></div><!-- Tab Six Allowed File Types --><div ng-if=\"selectTab==\'6\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div class=allowedFilesQuad ng-if=!settingLoadingServer><div ng-class=\"{\'marB10\':!$last}\" ng-repeat=\"extGrp in allowedFiles\"><h5 class=\"panel-inner-tab marB10\"><label class=noMarB for=extGrpSelected{{$index}}><input type=checkbox id=extGrpSelected{{$index}} ng-model=extGrp.selected ng-change=\"selectEntity(\'all\', $index);\" role=checkbox aria-label=extGrpSelected{{$index}} aria-labelledby=extGrpSelected{{$index}}><label></label><span ng-if=\"extGrp.label==\'img\'\">{{\'cm.label.37\' | translate}}</span> <span ng-if=\"extGrp.label==\'vid\'\">{{\'cm.label.38\' | translate}}</span> <span ng-if=\"extGrp.label==\'aud\'\">{{\'cm.label.39\' | translate}}</span> <span ng-if=\"extGrp.label==\'ot\'\">{{\'cm.label.40\' | translate}}</span></label></h5><ul class=list-inline><li ng-repeat=\"ext in extGrp.ext\" ng-if=\"ext.type != \'swf\'\"><label class=text-unbold for=extSelected{{ext.type}}><input type=checkbox id=extSelected{{ext.type}} ng-model=ext.selected ng-change=selectEntity(); role=checkbox aria-label=extSelected{{ext.type}} aria-labelledby=extSelected{{ext.type}}><label></label>{{ext.type}}</label></li><div class=spaceH></div></ul></div></div></div><!-- Tab seven server permissions List --><div ng-if=\"selectTab==\'7\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer><div class=marB15><div class=row><div class=col-xs-4><div class=\"input-group searchTbx\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove permissionSearchRemove\" aria-hidden=true></span></a></div></div></div></div><div class=\"accordNotification scrollQuad\" style=max-height:{{getAvailableHeight(350)}}px>{{filteredSearchSList = (filteredServerList | customSearch:{key:searchText, module:\'custServerS\', filterType:filter});\"\"}} {{module = (filteredModulesList | filter:{state:\"Modules\"});\"\"}}<div ng-hide=!module.length><div class=\"bg-muted bdrLeftServerPer pad10\"><label class=\"text-lg noMarB\">{{\'ms.p_s.serverPer.h1\' | translate}}</label></div><div class=\"padL10 marT20\"><div ng-repeat=\"w in filteredModulesList = (serverListArr | filter:searchText)\" ng-if=\"w.state == \'Modules\' && w.catagary == \'Report\'\"><label for=wCheckBox{{$index}} ng-if=\"w.keyName == \'r\'\" class=\"text-15 text-unbold\"><input type=checkbox role=checkbox id=wCheckBox{{$index}} ng-model=w.checkBox ng-change=\"reportsFx(\'r\', w.checkBox);\" aria-label=wCheckBox{{$index}} aria-labelledby=wCheckBox{{$index}}><label></label>{{w.label | capitalize}}</label><span class=\"marL5 marR5\" ng-if=\"w.keyName == \'r\' && w.checkBox\">|</span><label for=reportsRS{{$index}} class=\"text-unbold text-15\" ng-if=\"w.keyName == \'r\' && w.checkBox\" ng-class=\"{\'text-muted\':!server.reports.r && !server.reports.pp && !server.reports.ds && !server.reports.cs && !server.reports.op && !server.reports.od && !server.reports.cc && !server.reports.ir && !server.reports.hg && !server.reports.dst && !server.reports.poh && !server.reports.hk && !server.reports.ci}\"><input type=checkbox role=checkbox id=reportsRS{{$index}} ng-model=server.reports.rs ng-change=\"reportsFx(\'rs\', w.checkBox);\" aria-label=reportsRS{{$index}} aria-labelledby=reportsRS{{$index}} ng-disabled=\"!server.reports.r && !server.reports.pp && !server.reports.ds && !server.reports.cs && !server.reports.op && !server.reports.od && !server.reports.cc && !server.reports.ir && !server.reports.hg && !server.reports.dst && !server.reports.poh && !server.reports.hk && !server.reports.ci\"><label></label>{{\'b.tab.1\' | translate | capitalize}}</label><h5 ng-if=\"w.keyName == \'r\' && w.checkBox\" class=\"panel-inner-tab text-15 padB6 marB10 ng-binding\"><span class=hide>blank</span></h5><div class=\"row padL10 marB15\" ng-if=\"w.keyName == \'r\' && w.checkBox\"><div ng-repeat=\"r in filteredModulesList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"r.catagary == \'Report\'\"><div class=\"col-xs-6 colorText\" ng-if=\"r.keyName != \'r\' && r.keyName != \'rs\'\" class=text-unbold><label for=rCheckBox{{$index}} class=\"text-unbold text-15\"><input type=checkbox id=rCheckBox{{$index}} ng-model=r.checkBox ng-change=reportsFx(r.keyName); role=checkbox aria-label=rCheckBox{{$index}} aria-labelledby=rCheckBox{{$index}}><label></label>{{r.label | capitalize}}</label></div></div></div></div><div><div ng-repeat=\"w in filteredModulesList = (serverListArr | filter:searchText)\" ng-if=\"w.state == \'Modules\'\"><label for=wCheckBoxEM{{$index}} class=\"text-md text-unbold text-15\" ng-if=\"w.model == \'server.em\'\"><input type=checkbox id=wCheckBoxEM{{$index}} ng-click=setEmTypeFx(em.isCheck); ng-model=em.isCheck role=checkbox aria-label=wCheckBoxEM{{$index}} aria-labelledby=wCheckBoxEM{{$index}}><label></label>{{w.label}}</label><span class=\"marL5 marR5\" ng-if=\"w.keyName == \'emType\' && em.isCheck\">|</span> <span ng-if=\"w.model == \'server.em\' && em.isCheck\"><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=lsquared aria-labelledby=lsquared name=emOpt value=ls ng-model=em.type><label></label>{{\'ms.p_s.serverPer.52\' | translate}}</label><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=iotHub aria-labelledby=iotHub name=emOpt value=ih ng-model=em.type><label></label>{{\'ms.p_s.serverPer.22\' | translate}}</label><label class=\"text-unbold text-15 noMar\"><input type=radio role=radio aria-label=cBench aria-labelledby=cBench name=emOpt value=cb name=cBench value=cb ng-model=em.type><label></label>{{\'ms.p_s.serverPer.51\' | translate}}</label><a href=\"\" ng-if=\"w.checkBox && em.type == \'cb\'\" class=marL5 ng-click=cbPopOpen(); uib-tooltip=\"{{\'ms.p_s.serverPer.51.1\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox></span></a></span><label for=wCheckBoxT{{$index}} class=\"text-md text-unbold text-15\" ng-if=\"w.model == \'server.t\'\"><input type=checkbox id=wCheckBoxT{{$index}} ng-model=w.checkBox role=checkbox aria-label=wCheckBoxT{{$index}} aria-labelledby=wCheckBoxT{{$index}} ng-disabled=\"server.templateExist && w.model == \'server.t\'\"><label></label>{{w.label}}</label><span class=\"text-md text-unbold text-muted marL5 word-break\" ng-if=\"server.templateExist && w.model == \'server.t\'\">({{\'ms.p_s.serverPer.m3\' | translate}})</span><label for=wCheckBoxBP{{$index}} class=\"text-md text-unbold text-15\" ng-if=\"w.model == \'server.bp\'\"><input type=checkbox id=wCheckBoxBP{{$index}} ng-model=w.checkBox role=checkbox aria-label=wCheckBoxBP{{$index}} aria-labelledby=wCheckBoxBP{{$index}}><label></label>{{w.label}}</label><label for=wCheckBoxInven{{$index}} class=\"text-md text-unbold text-15\" ng-if=\"w.model == \'server.inven\'\"><input type=checkbox id=wCheckBoxInven{{$index}} ng-model=w.checkBox role=checkbox aria-label=wCheckBoxInven{{$index}} aria-labelledby=wCheckBoxInven{{$index}}><label></label>{{w.label}}</label><div ng-if=\"w.model == \'server.t\' && w.checkBox\" class=\"marL20 d-flex\"><label class=\"text-unbold marR10\"><span>{{\'t.label.27\' | translate}}: </span></label><label class=\"text-unbold text-15 marR10\"><input type=checkbox role=checkbox aria-label=lsquared aria-labelledby=lsquared name=tOpt value=cl ng-model=server.texl_cl><label></label>{{\'cm.menu.1\' | translate}}</label><label class=\"text-unbold text-15 marR10\"><input type=checkbox role=checkbox aria-label=iotHub aria-labelledby=iotHub name=tOpt value=od ng-model=server.texl_od><label></label>{{\'ms.p_s.serverPer.10\' | translate}}</label><label class=\"text-unbold text-15 marR10\"><input type=checkbox role=checkbox aria-label=lsquared aria-labelledby=lsquared name=tOpt value=tolo ng-model=server.tolo><label></label>{{\'t.label.30\' | translate}} <a href=\"\" role=button class=marL5 ng-if=server.tolo ng-click=oloOpen(); uib-tooltip=\"{{\'t.label.31\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a></label></div></div></div></div></div><div ng-hide=\"!public.length && !premium.length && !private.length\"><div class=marT30><div class=\"bg-muted bdrLeftServerPer pad10\"><label class=\"text-lg noMarB\">{{\'cl.tool.8s\' | translate}}</label></div>{{public = (filteredPublicWidgetList | filter:{catagary:\"Public\"});\"\"}}<div ng-hide=!public.length class=\"row padLR20 marT20\"><h5 class=\"panel-inner-tab marB10 text-16\">{{\'cm.label.19\' | translate}}</h5><div ng-repeat=\"w in filteredPublicWidgetList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Public\'\"><div class=col-xs-6><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=wCheckBoxT{{$index}} aria-labelledby=wCheckBoxT{{$index}}><label></label>{{w.label}}</label><span ng-show=\"w.model == \'server.widgets.rssFeed\'\"><span class=\"marL5 marR5 text-unbold\">|</span><label for=swRssFeedCrawl{{$index}} class=\"text-unbold text-15\" ng-class=\"{\'text-muted\':!server.widgets.rssFeed}\"><input type=checkbox id=swRssFeedCrawl{{$index}} ng-model=server.widgets.rssFeedCrawl ng-disabled=!w.checkBox role=checkbox aria-label=swRssFeedCrawl{{$index}} aria-labelledby=swRssFeedCrawl{{$index}}><label></label>{{\'ms.p_s.serverPer.6\' | translate | capitalize}} {{\'cl.widget.rss.1\' | translate | camelCase}}</label></span><span ng-show=\"w.model == \'server.widgets.news\'\"><span class=\"marL5 marR5 text-unbold\">|</span><label for=swNewsCrawl{{$index}} class=\"text-unbold text-15\" ng-class=\"{\'text-muted\':!server.widgets.news}\"><input type=checkbox id=swNewsCrawl{{$index}} ng-model=server.widgets.newsCrawl ng-disabled=!w.checkBox role=checkbox aria-label=swNewsCrawl{{$index}} aria-labelledby=swNewsCrawl{{$index}}><label></label>{{\'ms.p_s.serverPer.6\' | translate | capitalize}} {{\'cl.widget.news.1\' | translate | camelCase}}</label></span><span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.meeting\'\">|</span> <span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.news\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.widgets.meeting\'\"><label for=swMeetingGT{{$index}} class=\"text-unbold text-15\" ng-class=\"{\'text-muted\':!server.widgets.meeting}\"><input type=checkbox id=swMeetingGT{{$index}} ng-model=server.widgets.meetingGT ng-disabled=!server.widgets.meeting role=checkbox aria-label=swMeetingGT{{$index}} aria-labelledby=swMeetingGT{{$index}}><label></label>{{\'cl.widget.meeting.25\' | translate}}</label></span><span ng-if=\"w.checkBox && w.model == \'server.widgets.news\'\"><label for=swNewsB{{$index}} class=\"text-unbold text-15\" ng-class=\"{\'text-muted\':!server.widgets.news}\"><input type=checkbox id=swNewsB{{$index}} ng-model=server.widgets.newsB ng-disabled=!server.widgets.news role=checkbox aria-label=swNewsB{{$index}} aria-labelledby=swNewsB{{$index}}><label></label>{{\'cl.widget.news.7\' | translate}}</label></span></div></div></div>{{premium = (filteredPremWidgetList | filter:{catagary:\"Premium\"});\"\"}}<div ng-hide=!premium.length class=\"row padLR20 marT20\"><h5 class=\"panel-inner-tab marB10 text-16\">{{\'ms.p_s.serverPer.4\' | translate}}</h5><div ng-repeat=\"w in filteredPremWidgetList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Premium\'\"><div class=col-xs-6><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=flightSchedule aria-labelledby=flightSchedule><label></label>{{w.label}} <span ng-if=\"w.model == \'server.widgets.flightSchedule\'\" class=text-muted>(Toronto YYZ and Montréal YUL only)</span></label><a href=\"\" role=link class=marL5 ng-click=sChorusPopOpen(); uib-tooltip=\"{{\'ms.p_s.serverPer.46\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.firstup\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.jukebox\'\" ng-click=\"listPopOpen(\'mc\');\" uib-tooltip=\"{{\'cl.widget.mc.3\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.iotButton\'\" ng-click=iotBtnPopOpen(); uib-tooltip=\"{{\'ms.p_s.serverPer.39\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.liveStreaming\'\" ng-click=iotBtnPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.ciscoMeraki\'\" ng-click=ciscoPopOpen(); uib-tooltip=\"{{\'ms.p_s.serverPer.49\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.powerBI\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.widgets.powerBI\'\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox aria-label=filter aria-labelledby=filter ng-model=server.pbi><label></label>{{\'cm.label.44\' | translate}}</label><span class=\"marL5 marR5\">|</span><label class=\"text-unbold text-15 marR10\"><input type=checkbox role=checkbox aria-label=filter aria-labelledby=filter ng-model=server.pbf><label></label>{{\'cm.editor.11\' | translate}}</label><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=pBIla aria-labelledby=pBIla name=pBIOpt value=la ng-model=server.widgets.powerBIApp><label></label>{{\'cl.widget.pBI.12\' | translate}}</label><label class=\"text-unbold text-15\"><input type=radio role=radio aria-label=pBIca aria-labelledby=pBIca name=pBIOpt value=ca ng-model=server.widgets.powerBIApp><label></label>{{\'cl.widget.pBI.13\' | translate}}</label></span><!-- Amazon quickSight --> <span ng-if=\"w.checkBox && w.model == \'server.widgets.quickSight\'\"><a href=\"\" role=link class=marL5 ng-click=aqsPopOpen(); uib-tooltip=\"{{\'cl.widget.aqs.3\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> </span><span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.liveStreaming\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.widgets.liveStreaming\'\"><label class=\"text-unbold text-15\"><input type=checkbox ng-model=server.widgets.livestreamingHLSlogs><label></label>{{\'ms.p_s.serverPer.48\' | translate}}</label></span><span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.teamsRoom\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.widgets.teamsRoom\'\"><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=trla aria-labelledby=trla name=trOpt value=la ng-model=server.widgets.teamsRoomApp><label></label>{{\'cl.widget.pBI.12\' | translate}}</label><label class=\"text-unbold text-15\"><input type=radio role=radio aria-label=trca aria-labelledby=trca name=trOpt value=ca ng-model=server.widgets.teamsRoomApp><label></label>{{\'cl.widget.pBI.13\' | translate}}</label></span><span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.widgets.teamsChannel\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.widgets.teamsChannel\'\"><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=tcla aria-labelledby=tcla name=tcOpt value=la ng-model=server.widgets.teamsChannelApp><label></label>{{\'cl.widget.pBI.12\' | translate}}</label><label class=\"text-unbold text-15\"><input type=radio role=radio aria-label=tcca aria-labelledby=tcca name=tcOpt value=ca ng-model=server.widgets.teamsChannelApp><label></label>{{\'cl.widget.pBI.13\' | translate}}</label></span><a href=\"\" role=link class=marL5 ng-click=tableauPopOpen(); uib-tooltip=\"{{\'cl.widget.tbS.4\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.tableau\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-click=achieversPopOpen(); uib-tooltip=\"{{\'cl.widget.achievers.3\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.achievers\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.webex\'\" ng-click=webexPopOpen(); uib-tooltip=\"{{\'cl.widget.webex.6\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-click=qlikPopOpen(); uib-tooltip=\"{{\'cl.widget.qlik.12\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.qlik\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><!-- PowerBI settings --> <a href=\"\" role=link class=marL5 ng-click=pBIPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.powerBI\' && server.widgets.powerBIApp == \'ca\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-click=grafanaPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.grafana\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-click=verkadaPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.widgets.verkada\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div></div>{{private = (filteredPrivateWidgetList | filter:{catagary:\"Private\"});\"\"}}<div ng-hide=!private.length class=\"row padLR20 marT20\"><h5 class=\"panel-inner-tab marB10 text-16\">{{\'ms.p_s.serverPer.5\' | translate}}</h5><div ng-repeat=\"w in filteredPrivateWidgetList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Private\'\"><div class=col-xs-6><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=telax{{$index}} aria-labelledby=telax{{$index}}><label></label>{{w.label}}</label><a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.telax\'\" ng-click=telexPopOpen(); uib-tooltip=\"{{\'cl.widget.telax.8\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.intelJciMap\'\" ng-click=jciMapPopOpen(); uib-tooltip=\"{{\'cl.widget.jci.4\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.intelCircuitBench\'\" ng-click=inCircuitPopOpen(); uib-tooltip=\"{{\'cl.widget.inC.3\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=button class=marL5 ng-if=\"w.checkBox && w.setting == \'server.widgets.comEvents\'\" ng-click=comEventsOpen(); uib-tooltip=\"{{\'cl.widget.aNet.21\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a></div></div></div></div></div>{{device = (filteredDeviceList | filter:{state:\"Device\"});\"\"}}<div ng-hide=!device.length class=spaceH2></div><div ng-hide=!device.length><div class=marT30><div class=\"bg-muted bdrLeftServerPer pad10\"><label class=\"text-lg noMarB\">{{\'cm.label.4s\' | translate}}</label></div><div class=\"row padL10 marT20\"><div ng-repeat=\"w in filteredDeviceList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Device\'\"><div class=col-xs-6><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=device{{$index}} aria-labelledby=device{{$index}}><label></label>{{w.label}}</label><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.webos\'\" class=marL5 ng-click=webOSPopOpen(); uib-tooltip=\"{{\'d.p_dc.13\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.epd\'\" class=marL5 ng-click=epdOpenFx(); uib-tooltip=\"{{\'d.p_dc.18\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a></div></div>{{dSettings = (filteredDeviceList | filter:{catagary:\"Settings\"});\"\"}}<div ng-hide=!dSettings.length class=\"col-xs-12 marT10 padR20\"><h5 class=\"panel-inner-tab marB10 ng-binding text-16\">{{\'cm.label.14\' | translate}}</h5><div ng-repeat=\"w in filteredDeviceList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Settings\'\"><div ng-if=\"w.model != \'server.dgrp.dgrp\' && w.model != \'server.drsk\'\"><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=\"Device Settings{{$index}}\" aria-labelledby=\"Device Settings{{$index}}\"><label></label>{{w.label}}</label></div><!-- ?New: for device tree view --><div ng-if=\"w.catagary == \'Settings\' && w.model == \'server.drsk\'\"><label class=\"text-md noMar\"><label class=\"text-unbold text-15\"><label></label>{{w.label}}</label></label><a href=\"\" role=link ng-if=\"w.setting == \'server.drsks\'\" class=marL5 ng-click=registrationOpen(); uib-tooltip=\"{{\'d.p_dc.13\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div ng-if=\"w.catagary == \'Settings\' && w.model == \'server.dgrp.dgrp\'\"><label class=\"text-md noMar\"><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox><label></label>{{w.label}}</label></label><span ng-show=w.checkBox class=ssoSpriter></span><!-- <span class=\"marL5 marR5\" ng-show=\"w.checkBox\">|</span> --> <span ng-if=w.checkBox><label class=\"text-unbold text-15\" ng-class=\"{\'disabled\':!w.checkBox}\"><input type=radio name=grpOpt ng-model=server.dgrp.type value=dt ng-disabled=!w.checkBox><label></label>{{\'ms.p_s.serverPer.23\'|translate}}</label><label class=\"text-unbold marL10 text-15\" ng-class=\"{\'disabled\':!w.checkBox}\"><input type=radio name=grpOpt ng-model=server.dgrp.type value=df ng-disabled=!w.checkBox><label></label>{{\'ms.p_s.serverPer.47\'|translate}}</label></span></div></div></div>{{dActions = (filteredDeviceList | filter:{catagary:\"Device Actions\"});\"\"}}<div ng-hide=!dActions.length class=\"col-xs-12 marT10 padR20\"><h5 class=\"panel-inner-tab marB10 text-16 ng-binding\">{{\'ms.p_s.serverPer.31\' | translate}}</h5><div ng-repeat=\"w in filteredDeviceList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Device Actions\'\"><div><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=\"Device Actions{{$index}}\" aria-labelledby=\"Device Actions{{$index}}\"><label></label>{{w.label}}</label></div></div></div></div></div></div>{{dashboard = (filteredServerList | filter:{state:\"Dashboard\"});\"\"}}<div ng-hide=!dashboard.length class=spaceH2></div><div ng-hide=!dashboard.length><div class=\"bg-muted bdrLeftServerPer pad10 marT30\"><label class=\"text-lg noMarB\">{{\'cm.menu.0\' | translate}}</label></div><div class=\"row padL10 marT20\"><div ng-repeat=\"w in filteredServerList = (serverListDashArr | customSearch:{key:searchText, module:\'custServerS\', filterType:filter}) | orderBy:\'label\'\" ng-if=\"w.state == \'Dashboard\'\"><div class=col-xs-6><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox role=checkbox aria-label=serverListDashArr{{$index}} aria-labelledby=serverListDashArr{{$index}}><label></label>{{w.label}}</label><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.dashboard.dtpl\'\" class=marL5 ng-click=\"dsOpen(\'dtps\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.dashboard.dtps\'\" class=marL5 ng-click=\"dsOpen(\'dtps\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.dashboard.ot\'\" class=marL5 ng-click=\"dsOpen(\'ot\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div></div></div><!-- Other Features --> {{feature = (filteredFeaturesList | filter:{state:\"Other Features\"});\"\"}}<div ng-hide=!feature.length><div class=\"bg-muted bdrLeftServerPer pad10 marT30\"><label class=\"text-lg noMarB\">{{\'ms.p_s.serverPer.h2\' | translate}}</label></div><div class=\"padL10 marT20\"><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.state == \'Other Features\'\"><div ng-if=\"w.catagary != \'SSO\' && w.setting != \'server.gd\' && w.catagary != \'domain\' && w.catagary != \'bigPanda\' && w.catagary != \'hubSpot\' && w.catagary != \'Schedule Priority\' && w.catagary != \'Content Storage\'  && w.catagary != \'Media Conversion\' && w.catagary != \'Sheet Export Settings\' && w.catagary != \'Maps\' && w.catagary != \'logSE\' && w.catagary != \'Third-Party\' && w.catagary != \'App Menu\' && w.catagary != \'Session Timeout\' && w.catagary != \'Default Content Duration\' && w.catagary != \'Storage Type\' && w.catagary != \'Device report generation\' && w.catagary != \'video indexer\' && w.catagary != \'SharePoint Folder\' && w.catagary != \'asana\'\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox ng-model=w.checkBox><label></label>{{w.label}}</label><span ng-if=\"w.catagary == \'Menu Board\'\"><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.dmb\'\" class=marL5 ng-click=dmbPopOpen(); uib-tooltip=\"{{\'cm.dmb.2\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <span ng-show=w.checkBox class=ssoSpriter></span> <span ng-if=w.checkBox><label class=\"text-unbold text-15\" ng-class=\"{\'disabled\':!w.checkBox}\"><input type=checkbox ng-model=server.dmb_t ng-disabled=!w.checkBox><label></label>{{\'cm.menu.2\'|translate}}</label><label class=\"text-unbold marL10 text-15\" ng-class=\"{\'disabled\':!w.checkBox}\"><input type=checkbox ng-model=server.dmb_c ng-disabled=!w.checkBox><label></label>{{\'cm.dmb.15\'|translate}}</label></span></span><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.iotcentral\'\" class=marL5 ng-click=iotCPopOpen(); uib-tooltip=\"{{\'p_iotC.1\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.odn\'\" class=marL5 ng-click=offlineOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=w.checkBox><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold text-15\"><a ng-if=\"w.checkBox && w.setting == \'server.ai_img\'\" href=https://openai.com/pricing role=link class=btn-link target=_blank>($$)</a></label><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.proMonitor\'\" class=marL5 ng-click=proActiveOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=w.checkBox><span class=\"fa fa-cog\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.acs\'\" class=marL5 ng-click=acsPopOpen(); uib-tooltip=\"{{\'cm.acs.2\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"w.checkBox && w.model == \'server.dtc\'\" class=marL5 ng-click=dtcPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=w.checkBox aria-hidden=true></span></a> <span class=\"fa fa-info-circle text-primary\" aria-hidden=true ng-if=\"w.setting == \'server.cau\'\" uib-tooltip=\"{{\'d.brief.30\' | translate: {htmlTagO: \'L&nbsp;Squared\'} }}\" tooltip-append-to-body=true></span></div><div ng-if=\"w.setting == \'server.gd\'\"><label class=\"text-md noMar\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox aria-label=gd aria-labelledby=gd ng-model=w.checkBox><label></label>{{w.label}}</label></label><span ng-show=w.checkBox class=ssoSpriter></span> <span ng-if=w.checkBox role=radiogroup aria-labelledby=radiogroup><label class=\"text-unbold text-15\" ng-class=\"{\'disabled\':!w.checkBox}\" for=gdOauth><input type=checkbox role=checkbox id=gdOauth aria-label=Oauth aria-labelledby=Oauth ng-model=server.gdS.gdOtApp.active ng-disabled=!w.checkBox><label></label>{{\'cl.p_f.20\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"gdPopOpen(\'o\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.70.1\' | translate}}\" tooltip-popup-delay=500 ng-if=server.gdS.gdOtApp.active><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold marL10 text-15\" ng-class=\"{\'disabled\':!w.checkBox}\" for=gdSp><input type=checkbox role=checkbox id=gdSp aria-label=sp aria-labelledby=sp ng-model=server.gdS.gdspApp.active ng-disabled=!w.checkBox><label></label>{{\'cl.p_f.21\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"gdPopOpen(\'sp\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.70.2\' | translate}}\" tooltip-popup-delay=500 ng-if=server.gdS.gdspApp.active><span class=\"fa fa-cog\" aria-hidden=true></span></a></span></div><div class=form-inline ng-if=\"w.catagary == \'video indexer\'\"><label class=\"text-unbold text-15\" for=viIndexer-{{$index}}><input type=checkbox role=checkbox ng-model=w.checkBox ng-change=getAuthUrlIndexer(w.checkBox) id=viIndexer-{{$index}} aria-label=viIndexer-{{$index}} aria-labelledby=viIndexer-{{$index}}><label></label>{{w.label}} <span uib-tooltip=\"{{\'cl.vi.m6\' | translate}}\" tooltip-popup-delay=500>($$)</span></label><button type=button role=button class=\"btn btn-xs btn-success marL5 marT-4\" ng-click=\"openIndexerUrlFx(626, 450, \'at\');\" ng-if=\"w.checkBox && !authorizedInder\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-primary marL10 marT-4 hide\" ng-click=\"reAuthOpenIndexer(\'re\');\" ng-if=\"w.checkBox && server.viIndexer.isAuth\">{{server.viIndexer.isAuth?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button></div><div ng-if=\"w.catagary == \'SSO\'\"><label class=\"text-md noMar\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox aria-label=sso aria-labelledby=sso ng-model=w.checkBox><label></label>{{w.label}}</label></label><span ng-show=w.checkBox class=ssoSpriter></span> <span ng-if=w.checkBox role=radiogroup aria-labelledby=radiogroup><label class=\"text-unbold text-15\" ng-class=\"{\'disabled\':!w.checkBox}\" for=azure><input type=radio role=radio aria-label=azure aria-labelledby=azure name=ssoOpt ng-model=server.sso.type value=azure ng-disabled=!w.checkBox><label></label>Microsoft Azure</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'a\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.11\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && server.sso.type == \'azure\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold marL10 text-15\" ng-class=\"{\'disabled\':!w.checkBox}\" for=okta><input type=radio role=radio aria-label=okta aria-labelledby=okta name=ssoOpt ng-model=server.sso.type value=okta ng-disabled=!w.checkBox><label></label>Okta</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'o\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.12\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && server.sso.type == \'okta\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold marL10 text-15\" for=idaptive><input type=radio role=radio aria-label=idaptive aria-labelledby=idaptive name=ssoOpt ng-model=server.sso.type value=idaptive ng-disabled=!w.checkBox><label></label>Idaptive</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'i\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.32\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && server.sso.type == \'idaptive\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold marL10 text-15\" for=google><input type=radio role=radio aria-label=google aria-labelledby=google name=ssoOpt ng-model=server.sso.type value=google ng-disabled=!w.checkBox><label></label>Google</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'g\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.42\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && server.sso.type == \'google\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><label class=\"text-unbold marL10 text-15\" for=saml><input type=radio role=radio aria-label=saml aria-labelledby=saml name=ssoOpt ng-model=server.sso.type value=saml ng-disabled=!w.checkBox><label></label>SAML</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'s\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.42\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && server.sso.type == \'saml\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a> <span ng-show=w.checkBox class=ssoSpriter style=\"margin:0 7px -2px 5px\"></span><label ng-show=w.checkBox class=text-unbold for=isAllServer><input type=checkbox role=checkbox aria-label=isAllServer aria-labelledby=isAllServer ng-model=server.sso.isAllServer><label></label>{{\'ms.p_s.serverPer.43\' | translate}}</label></span></div><div ng-if=\"w.catagary == \'bigPanda\'\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox ng-model=w.checkBox aria-label=bigPanda-{{$index}} aria-labelledby=bigPanda-{{$index}}><label></label>{{w.label}}</label><a href=\"\" role=link ng-if=\"w.checkBox && w.setting == \'server.bpa.isActive\'\" class=marL5 ng-click=bigPandaOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=w.checkBox><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><!-- Hide \"hub spot tickets\" and using \"Proactive monitoring with hubspot\" --><div ng-if=\"w.catagary == \'hubSpot\'\" class=hide><label class=\"text-unbold text-15\"><input type=checkbox ng-model=w.checkBox><label></label>{{w.label}}</label><a href=\"\" ng-if=\"w.checkBox && w.setting == \'server.hs.isActive\'\" class=marL5 ng-click=hubSpotOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=w.checkBox><span class=\"fa fa-cog\"></span></a></div><div class=form-inline ng-if=\"w.catagary == \'domain\'\"><label class=\"text-unbold text-15\" for=domainCheck-{{$index}}><input type=checkbox role=checkbox ng-model=w.checkBox id=domainCheck-{{$index}} aria-label=domainCheck-{{$index}} aria-labelledby=domainCheck-{{$index}}><label></label>{{w.label}}</label><input type=text class=\"form-control input-sm marL10\" ng-model=server.subdomain.domain ng-if=\"w.checkBox && w.setting == \'server.subdomain.isActive\'\" id=domain-{{$index}} aria-label=domain aria-labelledby=domain></div><div ng-if=\"w.catagary == \'logSE\'\"><label class=\"text-unbold text-15\" for=logSECheck-{{$index}}><input type=checkbox role=checkbox ng-model=w.checkBox id=logSECheck-{{$index}} aria-label=logSECheck-{{$index}} aria-labelledby=logSECheck-{{$index}}><label></label>{{w.label}}</label><div class=\"row padLR20\" ng-if=w.checkBox><div class=msg-warning lang={{auth.lang}} ng-if=\"server.logSE.checked && server.logSE.list.length == 0\">{{\'r.msg.1\' | translate}}</div><div class=col-xs-4 ng-if=!tabLoading ng-repeat=\"coordinator in server.logSE.list\"><label class=\"text-unbold text-15\" for=coordinatorCheck-{{$index}}><input type=checkbox role=checkbox ng-model=coordinator.selected id=coordinatorCheck-{{$index}} aria-label=coordinatorCheck-{{$index}} aria-labelledby=coordinatorCheck-{{$index}}><label></label>{{coordinator.label}}</label></div></div></div><div ng-if=\"w.catagary == \'SharePoint Folder\'\"><label class=\"text-md noMar\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox aria-label=mssp aria-labelledby=mssp ng-model=w.checkBox><label></label>{{w.label}}</label></label><span class=\"marL5 marR5\" ng-show=\"w.checkBox && w.model == \'server.mssp\'\">|</span> <span ng-if=\"w.checkBox && w.model == \'server.mssp\'\"><label class=\"text-unbold text-15 marR10\"><input type=radio role=radio aria-label=msspla aria-labelledby=msspla name=msspOpt value=la ng-model=server.msspApp><label></label>{{\'cl.widget.pBI.23.1\' | translate}}</label><label class=\"text-unbold text-15\"><input type=radio role=radio aria-label=msspca aria-labelledby=msspca name=msspOpt value=ca ng-model=server.msspApp><label></label>{{\'cl.widget.pBI.13\' | translate}}</label></span><!-- sharePoint settings --> <a href=\"\" role=link class=marL5 ng-click=msspPopOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=\"w.checkBox && w.model == \'server.mssp\' && server.msspApp == \'ca\'\"><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><!-- Asana Integration --><div ng-if=\"w.catagary == \'asana\'\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox ng-model=w.checkBox aria-label=asana-{{$index}} aria-labelledby=asana-{{$index}}><label></label>{{w.label}}</label><a href=\"\" role=link ng-if=\"w.checkBox && w.model == \'server.asana\'\" class=marL5 ng-click=asanaOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=w.checkBox><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div>{{thirdParty = (filteredFeaturesList | filter:{catagary:\"Third-Party\"});\"\"}}<div ng-hide=!thirdParty.length><h5 class=\"panel-inner-tab marB10 text-16 marT20 ng-binding\">{{\'ms.p_s.serverPer.26\' | translate}}</h5><div class=row><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText) | orderBy:\'label\'\" ng-if=\"w.catagary == \'Third-Party\'\"><div class=col-xs-6><label class=\"text-unbold text-15\" for=catagaryCheck-{{$index}}><input type=checkbox role=checkbox ng-model=w.checkBox id=catagaryCheck-{{$index}} aria-label=catagaryCheck-{{$index}} aria-labelledby=catagaryCheck-{{$index}}><label></label>{{w.label}}</label></div></div></div></div>{{maps = (filteredFeaturesList | filter:{catagary:\"Maps\"});\"\"}}<div ng-hide=!maps.length><h5 class=\"panel-inner-tab marB10 text-16 marT20 ng-binding\">{{\'ms.p_s.serverPer.8\' | translate}}</h5><div role=radiogroup aria-labelledby=radiogroup><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Maps\'\"><label class=\"text-unbold text-15\"><input type=radio role=radio aria-labelledby=mapB name=mapOpt ng-model=w.checkBox value=b><label></label>{{\'ms.p_s.serverPer.8.2\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=mapG name=mapOpt ng-model=w.checkBox value=g><label></label>{{\'ms.p_s.serverPer.8.1\' | translate}} <a href=https://support.lsquared.com/kb/1640759321-pricing-for-google-map.xlsx role=link class=btn-link target=_blank>($$)</a></label></div></div></div><!-- Content Storage --> {{cs = (filteredFeaturesList | filter:{catagary:\"Content Storage\"});\"\"}}<div ng-hide=!cs.length><h5 class=\"panel-inner-tab marB10 text-16 marT20 ng-binding\">{{\'ms.p_s.serverPer.65\' | translate}}</h5><div role=radiogroup aria-labelledby=radiogroup><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Content Storage\'\"><!-- {{w}} --><label class=\"text-unbold text-15\"><input type=radio role=radio aria-labelledby=\"{{\'ms.p_s.serverPer.65.1\' | translate}}\" name=csOpt ng-model=w.checkBox.p value=p1 ng-disabled=\"w.checkBox.p == \'p2\'\"><label></label>{{\'ms.p_s.serverPer.65.1\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=\"{{\'ms.p_s.serverPer.65.2\' | translate}}\" name=csOpt ng-model=w.checkBox.p value=p2 ng-disabled=\"w.checkBox.p == \'p1\' || w.checkBox.p == \'hs\'\"><label></label>{{\'ms.p_s.serverPer.65.2\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=\"{{\'ms.p_s.serverPer.65.3\' | translate}}\" name=csOpt ng-model=w.checkBox.p value=hs ng-disabled=\"w.checkBox.p == \'p2\'\" ng-change=\"media[0].checkBox = \'zencoder\'\"><label></label>{{\'ms.p_s.serverPer.65.3\' | translate}}</label><a href=\"\" role=link class=marL5 ng-if=\"w.checkBox.p && w.checkBox.p == \'hs\'\" ng-click=\"csOpen(\'hs\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.65.4\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true></span></a></div></div></div>{{media = (filteredFeaturesList | filter:{catagary:\"Media Conversion\"});\"\"}}<div ng-hide=!media.length><h5 class=\"panel-inner-tab marB10 text-16 marT20 ng-binding\">{{\'ms.p_s.serverPer.24\' | translate}}</h5><div role=radiogroup aria-labelledby=radiogroup><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Media Conversion\'\"><label class=\"text-unbold text-15\"><input type=radio role=radio aria-labelledby=zencoder name=mcsOpt ng-model=w.checkBox value=zencoder><label></label>{{\'ms.p_s.serverPer.24.1\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=ec2 name=mcsOpt ng-model=w.checkBox value=ec2 ng-disabled=\"cs[0].checkBox.p == \'hs\'\"><label></label>{{\'ms.p_s.serverPer.24.2\' | translate}}</label></div></div></div><div>{{schedule = (filteredFeaturesList | filter:{catagary:\"Schedule Priority\"});\"\"}}<h5 ng-hide=!schedule.length class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'ms.p_s.serverPer.36\' | translate}}</h5><div role=radiogroup aria-labelledby=radiogroup><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Schedule Priority\'\"><label class=\"text-unbold text-15\"><input type=radio role=radio aria-labelledby=spH name=spOpt ng-model=w.checkBox value=h><label></label>{{\'ms.p_s.serverPer.36.1\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=spL name=spOpt ng-model=w.checkBox value=l><label></label>{{\'ms.p_s.serverPer.36.2\' | translate}}</label></div></div></div><div>{{reportGen = (filteredFeaturesList | filter:{catagary:\"Device report generation\"});\"\"}}<h5 ng-hide=!reportGen.length class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'r.label.24\' | translate}}</h5><div role=radiogroup aria-labelledby=radiogroup><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Device report generation\'\"><label class=\"text-unbold text-15\"><input type=radio role=radio aria-labelledby=drgV1 name=drgOpt ng-model=w.checkBox value=v1><label></label>{{\'r.label.24.1\' | translate}}</label><label class=\"text-unbold marL10 text-15\"><input type=radio role=radio aria-labelledby=drgV2 name=drgOpt ng-model=w.checkBox value=v2><label></label>{{\'r.label.24.2\' | translate}}</label></div></div></div><div>{{sheetSetting = (filteredFeaturesList | filter:{catagary:\"Sheet Export Settings\"});\"\"}}<h5 ng-hide=!sheetSetting.length class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'ms.p_s.serverPer.40\' | translate}}</h5><div><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Sheet Export Settings\'\"><div ng-show=\"w.catagary == \'Sheet Export Settings\'\"><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox ng-model=w.checkBox><label></label>{{w.label}}</label></div></div></div></div><div>{{session = (filteredFeaturesList | filter:{catagary:\"Session Timeout\"});\"\"}}<h5 ng-hide=!session.length class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'ms.p_s.serverPer.38\' | translate}}</h5><span ng-hide=!session.length class=\"text-md text-muted marL5\">({{\'cm.label.28s\' | translate | lowercase}})</span><div class=row><div class=\"col-xs-2 marT2\"><div class=\"form-group noMarB\"><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Session Timeout\'\"><input type=number class=\"form-control input-sm\" aria-label=timeOut min=20 ng-model=w.checkBox></div></div></div></div></div><div>{{duration = (filteredFeaturesList | filter:{catagary:\"Default Content Duration\"});\"\"}}<h5 ng-hide=!duration.length class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'ms.p_s.serverPer.56\' | translate}}</h5><span ng-hide=!duration.length class=\"text-md text-muted marL5\">({{\'cm.label.27s\' | translate | lowercase}})</span><div class=row><div class=\"col-xs-2 marT2\"><div class=\"form-group noMarB\"><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'Default Content Duration\'\"><input type=number class=\"form-control input-sm\" aria-label=duration min=1 ng-model=w.checkBox></div></div></div></div></div><!-- <div>\r\n                  {{storage = (filteredFeaturesList | filter:{catagary:\"Storage Type\"});\"\"}}\r\n                  <h5 ng-hide=\"!storage.length\" class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{\'ms.p_s.serverPer.62\' | translate}}</h5>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-xs-2 marT2\">\r\n                      <div class=\"form-group noMarB\">\r\n                        <div><label class=\"text-unbold text-15\">{{storage[0].strgVal | capitalize}}</label></div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div class=marT5><div ng-repeat=\"w in filteredFeaturesList = (serverListArr | filter:searchText)\" ng-if=\"w.catagary == \'App Menu\'\"><h5 class=\"panel-inner-tab marB10 marT20 text-16 ng-binding\">{{w.label}}</h5><div class=row><div class=\"col-xs-3 form-group\"><label class=\"text-unbold text-15\">{{\'ms.p_am.2\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=server.iTime maxlength={{inputLimit}} onkeypress=\"event.charCode >= 48 && event.charCode <= 57\" aria-label=serverITime aria-labelledby=serverITime> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div><div class=\"col-xs-3 form-group\"><label class=\"text-unbold text-15\">{{\'lock.1\' | translate}}</label><input type=text class=form-control ng-model=server.pass maxlength={{inputLimit}} onkeypress=\"event.charCode >= 48 && event.charCode <= 57\" aria-label=serverPass aria-labelledby=serverPass></div><div class=col-xs-2><button type=button role=button class=\"btn btn-default btn-sm marT26 text-unbold text-15\" ng-click=appMenuFx();><span ng-class=\"appMenuProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'ms.p_am.3\' | translate}}</button></div></div></div></div><div class=hide><label class=\"text-unbold text-15\"><input type=checkbox role=checkbox ng-model=server.cs><label></label>{{\'cm.menu.9\' | translate}} (L&nbsp;Squared Marketplace)</label></div></div></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!filteredSearchSList.length && !filteredFeaturesList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div> --><div class=msg-warning lang={{auth.lang}} ng-if=\"!filteredSearchSList.length && !filteredFeaturesList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div></div><!-- Tab eight server dynamic menu board --><div ng-if=\"selectTab==\'8\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer class=\"accordNotification scrollQuad\" style=max-height:{{getAvailableHeight(250)}}px><section class=marT10><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':dmbTab==\'1\'}\" ng-click=dmbTabFx(1);>{{\'cm.dmb.3\' | translate}}</a></header><div class=\"panel-body marT15\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer><div class=\"row marT10\" ng-if=\"dmbTab == 1\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.3.2\' | translate}}<div class=\"panel-tools marT-5 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.brands.length > 0\"><input type=text class=\"form-control input-sm\" ng-model=searchBrandTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchBrandTxt.length ng-click=\"searchBrandTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.brands.length > 0\"><div class=\"row th\"><div class=col-xs-4>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-8>{{\'cl.widget.cm.10\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=\"row word-break\" ng-repeat=\"brand in dmbSettings.brands | filter:searchBrandTxt\"><div class=col-xs-4>{{brand.label}}</div><div class=col-xs-8><a href={{curUrl}}/mb/#/{{brand.url}} role=link target=_blank>{{curUrl}}/mb/#/{{brand.url}}</a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.brands | filter:searchBrandTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchBrandTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.brands.length == 0\">{{\'cm.dmb.m4\' | translate}}</div></div></div><div ng-if=\"dmbTab == 2\"><div class=\"bg-light pad10\"><div class=row><div class=col-xs-2><div class=\"form-group noMarB\"><label for=name>{{\'cm.brief.1\' | translate}}</label><input type=text id=name class=form-control ng-model=dmbNewUser.name aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=email>{{\'cm.label.47\' | translate}}</label><input type=email id=email class=form-control ng-model=dmbNewUser.email aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=pwd>{{\'cl.p_f.7\' | translate}}</label><input type=password id=pwd class=form-control ng-model=dmbNewUser.pwd aria-label=\"{{\'cl.p_f.7\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.7\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=brand>{{\'cm.dmb.3\' | translate}}</label><select id=brand class=form-control ng-options=\"brand.label for brand in dmbSettings.brands track by brand.id\" ng-model=dmbNewUser.brand aria-label=\"{{\'cm.dmb.3\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.3\' | translate}}\"><option value=\"\" disabled>{{\'cm.dmb.3.1\' | translate}}</option></select></div></div><div ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-3\'\"><div class=\"form-group noMarB\"><label>{{\'cm.label.4s\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>{{curDSelected = (devices.devices | filter:{selected:true}); \"\"}} <span ng-if=!curDSelected.length>{{\'cm.label.31\' | translate}}</span> <span ng-repeat=\"device in curDSelected\">{{device.label}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><div class=text-bold>{{\'d.tab.1\' | translate}}</div><li class=\"dropdown-header noPad noMarR marT5\" ng-show=\"devices.devices.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.d sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"device in filteredDList = (devices.devices | filter:searchList.d) | orderBy: \'label\'\" tabindex=$index uib-tooltip={{device.label}} tooltip-popup-delay=1000 tooltip-append-to-body=true><label><input type=checkbox role=checkbox ng-model=device.selected><label></label>{{device.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"devices.devices.length && filteredDList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!devices.devices.length>{{\'db.msg.1\' | translate}}</div></div></div></div></div></ul></div></div></div><div class=noPad ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-1\'\"><div class=\"form-group noMarB\"><label>&nbsp;</label><div><button type=button role=button class=btn ng-class=\"dmbNewUser.id?\'btn-primary\':\'btn-success\'\" ng-click=addDMBUserFx(); ng-disabled=dmbUserProcessing><span class=fa ng-class=\"dmbUserProcessing?\'fa-repeat fa-spin\':dmbNewUser.id?\'fa-check\':\'fa-plus-circle\'\" aria-hidden=true></span>{{dmbNewUser.id?\'cm.btn.7\':\'cm.btn.19\' | translate}}</button> <a href=\"\" role=link class=\"btn btn-link\" ng-click=cancelDMBUserFx(); ng-if=dmbNewUser.id>{{\'cm.btn.9\' | translate}}</a></div></div></div></div><div class=\"errMsg pull-right marT5\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'eField\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errTypePop==\'uExist\'\" aria-live=polite role=status>{{\'ms.msg.9\' | translate}}</div></div><div class=clearfix></div></div><div class=\"row marT20\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.6\' | translate}}<div class=\"panel-tools marT-5 marB10 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.users.length > 0\"><input type=text class=\"form-control input-sm\" ng-model=searchUserTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchUserTxt.length ng-click=\"searchUserTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.users.length > 0\"><div class=\"row th\"><div class=col-xs-2>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.47\' | translate}}</div><div class=col-xs-3>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-1></div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(540)}}px><div class=\"row word-break\" ng-repeat=\"user in dmbSettings.users | filter:searchUserTxt\"><div class=col-xs-2>{{user.label}}</div><div class=col-xs-3>{{user.email}}</div><div class=col-xs-3>{{user.brand.label}}</div><div class=col-xs-3><ul class=list-inline><li class=\"noPad marR5\" ng-repeat=\"device in user.devices\">{{device.label}}<span ng-if=!$last>,</span></li></ul></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-primary ng-click=\"sendPwdFx(user.userId, $index);\" ng-disabled=sendPwdProcessing uib-tooltip=\"{{\'u.brief.6\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-share-square\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marLR5\" ng-click=\"editOpen(user, $index);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'u\', user.userId, $index);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.users | filter:searchUserTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchUserTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.users.length == 0\">{{\'cm.dmb.m6\' | translate}}</div></div></div></div></div></div></section></div></div><div ng-if=\"selectTab==\'9\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div ng-if=!settingLoadingServer><div class=\"bg-light pad10 marB20\"><div class=row><div class=col-xs-3><label for=curDPObjL>{{\'ms.p_s.dp.2\' | translate}}</label><input type=text id=curDPObjL class=form-control ng-model=curDPObj.label maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.dp.2\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.dp.2\' | translate}}\"></div><div class=col-xs-2><label for=type>{{\'cm.label.69\' | translate}}</label><select id=type class=form-control ng-model=curDPObj.vType ng-change=dpTypeChangeFx()><option value=t>{{\'cm.label.64\' | translate}}</option><option value=d>{{\'cm.label.7\' | translate}}</option><option value=dt>{{\'cl.widget.dt.1\' | translate}}</option><option value=ti>{{\'cm.label.8\' | translate}}</option></select></div><div class=col-xs-3><label for=curDPObjV>{{\'ms.p_s.dp.3\' | translate}}<!-- <span class=\"marL5\" ng-if=\"curDPObj.vType!=\'t\'\">( <label class=\"noMar\"><input type=\"checkbox\" ng-model=\"curDPObj.isblankdatetime\" role=\"checkbox\"><label></label>{{\'ms.p_s.dp.6\' | translate}}</label> )</span> --></label><!-- <span role=\"radiogroup\" aria-labelledby=\"radiogroup\">\r\n                  ( <label for=\"valueText\" class=\"noMarB marR5\"><input type=\"radio\" role=\"radio\" id=\"valueText\" ng-model=\"curDPObj.vType\" name=\"valueType\" value=\"t\"><label></label> {{\'cm.label.64\' | translate}}</label> |\r\n                  <label for=\"valueDate\" class=\"noMarB marL5\"><input type=\"radio\" role=\"radio\" id=\"valueDate\" ng-model=\"curDPObj.vType\" name=\"valueType\" value=\"d\"><label></label> {{\'cl.widget.dt.1\' | translate}}</label> )\r\n                </span> --> <input ng-if=\"curDPObj.vType==\'t\'\" type=text id=curDPObjV class=form-control ng-model=curDPObj.value maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.dp.3\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.dp.3\' | translate}}\"><div class=clearFix></div><!-- Date time format --><div class=row ng-if=\"curDPObj.vType!=\'t\'\"><div ng-if=\"curDPObj.vType!=\'ti\'\" ng-class=\"(curDPObj.vType==\'d\')?\'col-xs-12\':\'col-xs-7\'\"><!-- <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\"><span class=\"fa fa-calendar\" aria-hidden=\"true\"></span></span>\r\n                      <input type=\"daterange\" id=\"dateRange\" class=\"form-control picker\" ng-model=\"curDPObj.dateRange\" format=\"MM/DD/YYYY\" opens=\"left\" singleDatePicker=\"true\" readonly=\"\" aria-label=\"dateRange\" aria-labelledby=\"dateRange\" ng-disabled=\"curDPObj.isblankdatetime\">\r\n                    </div> --><div class=input-group><span class=input-group-addon ng-click=selectDateFx()><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text id=dateRange ng-click=selectDateFx() class=form-control ng-hide=curDPObj.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curDPObj.dateRange ng-show=curDPObj.creationRange format=MM/DD/YYYY opens=left singledatepicker=true readonly> <span class=input-group-btn><button class=\"btn btn-default height34\" ng-show=curDPObj.creationRange ng-click=clearDateFx(); type=button>{{\'cl.widget.mc.11\' | translate}}</button></span></div></div><div ng-if=\"curDPObj.vType==\'dt\' || curDPObj.vType==\'ti\'\" class=timepicker ng-class=\"curDPObj.vType == \'ti\' ? \'col-xs-12\' : \'col-xs-5\'\" uib-dropdown auto-close=outsideClick><!-- <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\" aria-hidden=\"true\"></span></span>\r\n                      <input type=\"text\" id=\"time\" class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curDPObj.time | date:\'shortTime\'\" placeholder=\"HH:mm\" readonly=\"\" aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\">\r\n                    </div> --><div class=input-group ng-click=selectTimeFx()><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=time class=form-control ng-hide=curDPObj.creationTime aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=text id=time class=\"form-control picker\" ng-show=curDPObj.creationTime uib-dropdown-toggle ng-value=\"curDPObj.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=curDPObj.time hour-step=1 minute-step=5></div></div></div></div></div><div class=col-xs-4><label for=curDPObjD>{{\'cm.label.85\' | translate}}</label><input type=text id=curDPObjD class=form-control ng-model=curDPObj.desc maxlength=500 aria-label=\"{{\'cm.label.85\' | translate}}\" aria-labelledby=\"{{\'cm.label.85\' | translate}}\"></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=dpAddFx(); ng-disabled=dpProcessing><span ng-if=!curDPObj.id><span ng-class=\"dpProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'ms.p_s.dp.1\' | translate}}</span> <span ng-if=curDPObj.id><span ng-class=\"dpProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=reset role=button class=\"btn btn-link\" ng-click=dpResetFx(); ng-disabled=dpProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'label\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m1\' | translate}}</div><div ng-if=\"errTypePop==\'same\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m2\' | translate}}</div><div ng-if=\"errTypePop==\'haveOne\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m6\' | translate}}</div></div></div></div></div></div><div class=\"row d-flex align-items-center marB5\"><div class=col-xs-9><div class=\"form-group text-bold noMarB\" ng-if=dpObj.properties.length role=radiogroup aria-labelledby=radiogroup><span class=dpsTxt>{{\'ms.p_s.dp.5\' | translate}}</span><label class=\"marL5 marR5 noMarB\" for=sOptA><input type=radio role=radio name=sOpt id=sOptA ng-model=dpObj.info.sort value=a ng-change=dpSaveFx(); aria-label=sOptA aria-labelledby=sOptA><label></label>{{\'ms.label.34.1\' | translate}}</label><span class=text-muted>|</span><label class=\"marL5 noMarB\" for=sOptC><input type=radio role=radio name=sOpt id=sOptC ng-model=dpObj.info.sort value=c ng-change=dpSaveFx(); aria-label=sOptC aria-labelledby=sOptC><label></label>{{\'cm.label.17\' | translate}}</label></div></div><div class=col-xs-3><div class=searchTbx style=\"float: right\"><input type=text class=\"form-control input-sm\" ng-model=searchDP.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchDP.text.length ng-click=\"searchDP.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div ng-class=\"{\'bg-light pad10\':dpObj.properties.length && dpObj.info.sort == \'c\'}\"><div class=\"table bg-white no-th\" ng-if=dpObj.properties.length><div class=\"row th bg-white\"><div class=col-xs-3>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-2>{{\'cm.label.69\' | translate}}</div><div class=col-xs-3>{{\'ms.p_s.dp.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.85\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=dpDataLoading class=pad10><div ng-if=!dpDataLoading><div class=scrollQuad ng-if=\"dpObj.info.sort == \'a\'\" style=max-height:{{getAvailableHeight(545)}}px><div class=row ng-repeat=\"dp in filteredProperties = (dpObj.properties | customSearch:{key:searchDP.text, module:\'dp\'})\"><div class=\"col-xs-3 word-break\">{{dp.label}}</div><div class=\"col-xs-2 word-break\"><span ng-if=\"dp.vType == \'t\'\">{{\'cm.label.64\' | translate}}</span> <span ng-if=\"dp.vType == \'d\'\">{{\'cm.label.7\' | translate}}</span> <span ng-if=\"dp.vType == \'dt\'\">{{\'cl.widget.dt.1\' | translate}}</span> <span ng-if=\"dp.vType == \'ti\'\">{{\'cm.label.8\' | translate}}</span></div><div class=\"col-xs-3 word-break\"><span ng-if=\"dp.vType != \'d\' && dp.vType != \'ti\' && !dp.creationRange\">{{dp.value}}</span><span ng-if=\"(dp.vType == \'d\' || dp.vType == \'ti\') && !dp.creationRange\">{{dp.value | date:\'shortTime\'}}</span><span ng-if=\"!dp.value || dp.creationRange\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 word-break\">{{dp.desc}}<span ng-if=!dp.desc class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link aria-label=edit class=\"text-primary marR10\" ng-click=dpEditFx(dp);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link aria-label=delete class=text-danger ng-click=dpDeleteOpen(dp.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=scrollQuad ng-class=\"{\'sortable-containment\':!searchDP.text.length}\" ng-if=\"dpObj.info.sort == \'c\'\" style=max-height:{{getAvailableHeight(610)}}px sortable callback=\"sortCallback(\'dp\')\"><div class=row ng-class=\"{\'sortable-item\':!searchDP.text.length}\" ng-repeat=\"dp in filteredProperties = (dpObj.properties | customSearch:{key:searchDP.text, module:\'dp\'})\" data-id={{dp.id}} data-type={{dp.vType}}><div class=\"col-xs-3 word-break dpLabel\"><span class=\"fa fa-arrows-v marR5 cursor-grab text-muted\" aria-hidden=true></span> {{dp.label}}</div><div class=\"col-xs-2 word-break\"><span ng-if=\"dp.vType == \'t\'\">{{\'cm.label.64\' | translate}}</span> <span ng-if=\"dp.vType == \'d\'\">{{\'cm.label.7\' | translate}}</span> <span ng-if=\"dp.vType == \'dt\'\">{{\'cl.widget.dt.1\' | translate}}</span> <span ng-if=\"dp.vType == \'ti\'\">{{\'cm.label.8\' | translate}}</span></div><div class=\"col-xs-3 word-break\"><span class=dpValue>{{dp.value}}</span> <span ng-if=!dp.value class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 word-break\"><span class=dpDesc>{{dp.desc}}</span> <span ng-if=!dp.desc class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link aria-label=edit class=\"text-primary marR10\" ng-click=dpEditFx(dp);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link aria-label=delete class=text-danger ng-click=dpDeleteOpen(dp.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dpObj.properties | customSearch:{key:searchDP.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDP.text)}}&quot;</b>\'}\"></div></div><div class=\"bdr-top-dashed marT15\" ng-if=\"dpObj.properties.length && dpObj.info.sort == \'c\'\"><a href=\"\" role=link class=\"btn btn-success btn-xs\" ng-click=\"dpSaveFx(\'s\');\" ng-disabled=dpSProcessing><span ng-class=\"dpSProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.dp.5.1\' | translate}}</a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!dpDataLoading && !dpObj.properties.length\">{{\'ms.p_s.dp.m3\' | translate}}</div></div></div><!-- Tab four Adapters List --><div ng-if=\"selectTab==\'4\'\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div class=text-center ng-if=\"!settingLoadingServer && adapters\"><p translate=\"{{\'cm.body.11\'}}\" translate-values=\"{htmlTagO: \'<b>&quot;\', htmlTagC: \'&quot;</b>\'}\"></p><a href={{adapters.download}} role=link target=_blank download class=\"btn btn-link text-lg\"><span class=\"fa fa-download\" aria-hidden=true></span> {{\'cm.btn.17\' | translate}}</a></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!settingLoadingServer && !adapters\">{{\'r.msg.1\' | translate}}</div></div><!-- R&G Reports --><div ng-if=\"selectTab==\'13\'\"><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':rgSelectedTab==1}\"><a href=\"\" role=link ng-click=rgTabFx(1);>{{\'cm.label.5\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':rgSelectedTab==2}\"><a href=\"\" role=link ng-click=rgTabFx(2);>{{\'cm.label.1\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':rgSelectedTab==3}\"><a href=\"\" role=link ng-click=rgTabFx(3);>{{\'cm.label.3\' | translate}}</a></li></ul><div class=\"bg-light pad10\"><div class=row><div class=col-xs-3><div class=form-group ng-if=\"rgSelectedTab==1\"><label for=rType>{{\'ms.p_s.rg.1\' | translate}}</label><select id=rType class=form-control ng-model=rgObj.rType aria-label=\"{{\'ms.p_s.rg.1\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.rg.1\' | translate}}\"><option value=l>{{\'ms.p_s.rg.1-1\' | translate}}</option></select></div><div class=form-group ng-if=\"rgSelectedTab==2\"><label for=rType>{{\'ms.p_s.rg.1\' | translate}}</label><select id=rType class=form-control ng-model=rgObj.rType aria-label=\"{{\'ms.p_s.rg.1\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.rg.1\' | translate}}\"><option value=cc>{{\'ms.p_s.rg.1-2\' | translate}}</option><option value=dc>{{\'ms.p_s.rg.1-5\' | translate}}</option><option value=wc>{{\'ms.p_s.rg.1-7\' | translate}}</option><option value=pc>{{\'ms.p_s.rg.1-4\' | translate}}</option><option value=cnc>{{\'ms.p_s.rg.1-3\' | translate}}</option><option value=sc>{{\'ms.p_s.rg.1-6\' | translate}}</option></select></div><div class=form-group ng-if=\"rgSelectedTab==3\"><label for=rType>{{\'ms.p_s.rg.1\' | translate}}</label><select id=rType class=form-control ng-model=rgObj.rType aria-label=\"{{\'ms.p_s.rg.1\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.rg.1\' | translate}}\"><option value=st>{{\'ms.p_s.rg.1-10\' | translate}}</option><option value=es>{{\'ms.p_s.rg.1-8\' | translate}}</option><option value=exs>{{\'ms.p_s.rg.1-9\' | translate}}</option></select></div><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=rgObj.dateRange format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div></div></div><div class=col-xs-12><div class=bdr-top-dashed><button type=button role=button class=\"btn btn-primary marB2\" ng-click=rgReportFx(); ng-disabled=rgProcessing><span ng-if=rgProcessing class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=rgHasErr aria-live=polite role=status><span ng-if=\"rgErrType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"rgErrType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"rgErrType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/common/wizardContainer.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><div ui-view=tabView></div>");
$templateCache.put("app/contentLibrary/ac.html","<img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div class=row ng-if=\"!contentLibraryLoading && (contentList.length > 0 || folderList.length > 0)\"><div class=col-lg-12><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.contentView == \'t\'\"><ng-content-list class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.contentView == \'l\'\"><ng-content-list-view class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\"><p>{{\'cl.msg.5\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ac\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cl.tool.15\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=videoFx();><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/contentLibrary/c.html","<div class=\"flex-wrap flex-nowrap\"><!--flex-wrap flex-nowrap--><!--  tree-menu-quad--><div class=\"flex-1 tree-menu-quad\" ng-if=\"auth.upreferences.isTreeOpen == 1 && (folderList.length > 0 || contentList.length > 0 || breadCrumbs.length > 0)\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=treeLoading><div class=tree-view id=nodeTree ng-if=!treeLoading scroll-tree aria-label=\"Tree View\"><!-- stared folder tree --><div class=padTB3 ng-if=favoritesList.length><a href=\"\" role=link class=favorite ng-class=\"{selected:curFolderId == 0 && curFolderType == \'recent\'}\" ng-click=\"folderContentFx(0, null, \'recent\');\"><!-- <img alt=\"\" src=\"assets/images/favorite.svg\"  width=\"20px\" height=\"20px\" alt=\"favorite\" class=\"valign-baseline marB-4\"> {{\'cl.label.27\' | translate}}</a> --> <img alt=\"\" src=assets/images/recent-folder.png class=valign-baseline> {{\'cl.label.27\' | translate}}</a></div><div ng-if=favoritesList.length id=recentTree class=\"marT3 marB8\" data-angular-treeview=true data-tree-id=tree02 data-tree-model=favoritesList data-node-id={{curFolderId}} data-node-label=name data-node-children=children></div><!-- basic folder tree --><div class=marT2 ng-class=\"{\'bdr-top-dashed\':favoritesList.length}\"><a href=\"\" role=link class=home ng-class=\"{selected:curFolderId == 0 && curFolderType != \'recent\'}\" ng-click=folderContentFx(0);><img alt=\"\" src=assets/images/folder-icon.png class=valign-baseline> {{\'cm.label.6\' | translate}}</a></div><div class=marT3 id=normalTree data-angular-treeview=true data-tree-id=tree01 data-tree-model=treeList data-node-id={{curFolderId}} data-node-label=name data-node-children=children ng-if=\"treeList != 0\"></div></div><span class=hide>Selected Node: <span class=text-bold>{{tree01.currentNode.id}}</span></span><div class=resizer-handle resizer=vertical resizer-width=6 resizer-left=.flex-1 resizer-right=\"\" resizer-min=200 resizer-max=400></div></div><div class=flex-2 context-menu=contextMenuBase id=\"{{contentLibrary.info.writable && (folderList.length == 0 || contentList.length == 0)?\'content-list\':\'\'}}\"><div ng-if=\"breadCrumbs.length > 0\" class=breadcrumb ng-class=\"{\'marB5\':contentLibrary.info.wp}\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4) ?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10 d-flex\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}} <span class=marLAuto ng-if=\"contentLibrary.info.fErr && !contentLibrary.info.fErr.ssp\"><button type=button role=button id=spReBtn class=\"btn btn-xs btn-primary\" ng-click=\"reAuthCUOpen(\'spRe\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button id=spReOuBtn class=\"btn btn-xs btn-default hide\" ng-click=\"reAuthCUOpen(\'spReOu\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.2\' | translate}}</button></span></div><div class=\"pad5 msg-info marB10 d-flex\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}} <span class=marLAuto ng-if=\"contentLibrary.info.fErr && !contentLibrary.info.fErr.ssp\"><button type=button role=button id=odReBtn class=\"btn btn-xs btn-primary\" ng-click=\"reAuthCUOpen(\'odRe\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button id=odReOuBtn class=\"btn btn-xs btn-default hide\" ng-click=\"reAuthCUOpen(\'odReOu\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.2\' | translate}}</button></span></div><!-- Googledrive --><div class=\"pad5 msg-info marB10 d-flex\" ng-if=\"contentLibrary.info.gd || (gdSp.auth && gdSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}} <span class=marLAuto ng-if=contentLibrary.info.fErr><button type=button role=button id=gdReBtn class=\"btn btn-xs btn-primary\" ng-click=\"reAuthCUOpen(\'gdRe\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button id=gdReOuBtn class=\"btn btn-xs btn-default hide\" ng-click=\"reAuthCUOpen(\'gdReOu\');\" ng-disabled=authProcessing>{{\'cl.widget.cm.25.2\' | translate}}</button></span></div><div class=\"pad5 msg-success marB10\" ng-if=\"contentLibrary.info.ef || (odSp.auth && odSp.curType==\'ExcelFolder\')\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</div><div class=\"msg-warning marB10\" ng-if=\"(contentLibrary.info.ef || (odSp.auth && odSp.curType==\'ExcelFolder\')) && contentLibrary.info.isProcessed == 0 && !contentLibraryLoading\"><div>{{\'cl.widget.es.m3\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'t\'\" element-height=getAvailableHeight(345) delay=true><ng-content-list class=show id=\"{{contentLibrary.info.writable && (folderList.length > 0 || contentList.length > 0)?\'content-list\':\'\'}}\" ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'l\'\" element-height=getAvailableHeight(345) delay=true><ng-content-list-view class=show id=\"{{contentLibrary.info.writable && (folderList.length > 0 || contentList.length > 0)?\'content-list\':\'\'}}\" ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div ng-hide=contentLibrary.info.ef lang={{auth.lang}} class=msg-warning ng-if=\"!contentLibraryLoading && folderList.length == 0 && contentList.length == 0 && !advSearchInfo.isEmpty\" id=\"{{contentLibrary.info.writable?\'content-list\':\'\'}}\"><div ng-if=!odSp.auth><div>{{\'cl.msg.1\' | translate}}</div><div ng-if=\"breadCrumbs.length == 0\"><div class=spaceH></div><div class=marB5 ng-if=\"auth.upermissions.c && auth.upermissions.ar\"><a ui-sref=hub.contentAdd.contentAddTab><span class=\"fa fa-plus-circle\"></span> {{\'cl.btn.4\' | translate}}</a></div><a href=\"\" ng-click=videoFx();><span class=\"fa fa-video-camera\"></span> <span translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><div ng-if=odSp.auth><div translate=\"{{\'cl.msg.37\'}}\" translate-values=\"{folderType: \'{{odSp.curType}}\'}\"></div><div class=marT10><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"reAuthOpen(odSp.curType==\'OneDrive\'?\'odRe\':\'spRe\');\">{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"reAuthOpen(odSp.curType==\'OneDrive\'?\'odReOu\':\'spReOu\');\">{{\'cl.widget.cm.25.2\' | translate}}</button></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && folderList.length == 0 && contentList.length == 0 && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div></div>");
$templateCache.put("app/contentLibrary/cAdd.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><div class=pageHeading ng-if=!auth.upreferences.isPopup><a href=\"\" role=link class=marR10 ui-sref=hub.contentLibrary.c>{{\'cm.menu.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'cl.btn.1\' | translate}}</span></div><div class=pageHeading ng-if=auth.upreferences.isPopup><a href=\"\" role=link ui-sref=hub.support.ts class=\"pull-right text-sm\" ng-if=\"$state.includes(\'hub.contentAdd.contentAddTab\') === true\">{{\'cl.p_c.3\' | translate}}</a> <a href=\"\" role=link class=marR10 ui-sref=hub.contentLibrary.c>{{\'cm.menu.1\' | translate}}</a>/ <span class=\"marL10 marR10\" ng-if=\"$state.includes(\'hub.contentAdd.contentAddTab\') === true\">{{\'cl.p_c.1\' | translate}}</span> <span class=\"marL10 marR10\" ng-if=\"$state.includes(\'hub.contentAdd.widgetAddTab\') === true\">{{tabView?\'cl.p_c.2\':\'cl.widget.cm.1\' | translate}}</span> <span class=\"marL10 marR10\" ng-if=\"$state.includes(\'hub.contentAdd.thirdParty\') === true\">{{\'cl.p_c.9\' | translate}}</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=\"panel-heading panel-tab\" ng-if=tabView><div class=panel-tools ng-if=\"$state.includes(\'hub.contentAdd.contentAddTab\') === true || $state.includes(\'hub.contentAdd.thirdParty\') === true\"><div class=pull-right ng-if=\"$state.includes(\'hub.contentAdd.contentAddTab\') === true\"><a ui-sref=hub.contentLibrary.c role=button><span class=\"fa fa-chevron-down\" aria-hidden=true></span> {{\'cl.p_c.4\' | translate}}</a></div><div class=pull-right><a href=\"\" role=link uib-tooltip-template=\"\'supportedFilesTemplate.html\'\" tooltip-placement=bottom><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'cm.label.54\' | translate}}</a></div></div><ul class=\"nav nav-tabs\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedCW===1}\" ng-if=auth.upermissions.c><a ui-sref=.contentAddTab role=button id=testLink>{{\'cl.p_c.1\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedCW===2}\" ng-if=auth.upermissions.w><a href=\"\" role=link ng-click=showWidgetFx();>{{\'cl.p_c.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedCW===3}\" ng-if=auth.upermissions.tpu><a href=\"\" role=link ng-click=tpuGoFx();>{{\'cl.p_c.9\' | translate}}</a></li></ul></header><div class=panel-body><div ui-view=tabView></div></div><div class=panel-footer ng-if=\"$state.includes(\'hub.contentAdd.contentAddTab\') === true\"><span class=btnQuad><span class=\"btn btn-primary\" ng-show=$flow.isUploading() ng-disabled=$flow.isUploading()>{{\'cl.btn.5s\' | translate}}</span> <span class=\"btn btn-primary\" ng-hide=$flow.isUploading() flow-btn>{{\'cl.btn.5s\' | translate}}</span> <span><button type=button role=button class=\"btn btn-success\" id=contentUploadBtn ng-click=contentUploadFX($flow); ng-disabled=$flow.isUploading()><span class=fa ng-class=\"$flow.isUploading()?\'fa-repeat fa-spin\':\'fa-arrow-up\'\" aria-hidden=true></span>{{\'cm.btn.16\' | translate}}</button></span> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=$file.cancel();popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section><script type=text/ng-template id=supportedFilesTemplate.html><div class=\"text-left\">\r\n    <div ng-if=\"sFiles.img.length > 0\">\r\n      <div class=\"text-bold\">{{\'cm.label.37\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.img\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.vid.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.38\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.vid\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.aud.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.39\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.aud\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.ot.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.40\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.ot\" ng-if=\"ext != \'swf\'\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.img.length == 0 && sFiles.vid.length == 0 && sFiles.aud.length == 0 && sFiles.ot.length == 0\">{{\'cm.msg.31\' | translate}}</div>\r\n  </div></script>");
$templateCache.put("app/contentLibrary/cAddC.html","<img alt=Loading src=assets/images/loading.gif ng-show=contentsLoading><div class=row ng-hide=contentsLoading><div class=\"col-lg-12 overflow-auto\" ng-attr-style=height:{{getAvailableHeight(293)}}px; flow-drop>{{getAvailableHeight(363); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" ng-attr-style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"$flow.files.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png><p>{{\'cl.p_c.m1\' | translate}}</p></div></div><div class=\"table no-th\" ng-if=\"$flow.files.length > 0\"><div class=row ng-repeat=\"file in $flow.files\"><div ng-if=\"!file.unsupported && !file.sizeUnsupported && !file.isSizeExceed\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=\"flowThumb marB20\"><span class=helper></span> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'ppt_w\':\'ppt\'}}.png\" ng-if=\"file.extension == \'ppt\' || file.extension == \'pptx\' || file.extension == \'pps\' || file.extension == \'ppsx\' || file.extension == \'odp\'\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'video_w\':\'video\'}}.png\" ng-if=\"itemInArray(sFiles.vid, file.extension.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'word_w\':\'word\'}}.png\" ng-if=\"file.extension == \'doc\' || file.extension == \'docx\' || file.extension == \'odt\'\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'excel_w\':\'excel\'}}.png\" ng-if=\"file.extension == \'xls\' || file.extension == \'xlsx\'\"> <img alt=\"\" src-error=\"assets/images/default/{{themeSwitch.btn?\'img_w\':\'img\'}}.png\" ng-if=\"itemInArray(sFiles.img, file.extension.toLowerCase())\" flow-img=file> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'audio_w\':\'audio\'}}.png\" ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'swf_w\':\'swf\'}}.png\" ng-if=\"file.extension == \'swf\'\" /> --> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'pdf_w\':\'pdf\'}}.png\" ng-if=\"file.extension == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=file.label>{{file.label + \".\" + file.extension}}<button type=button role=button class=\"btn btn-link\" ng-click=openEditName($index); ng-disabled=isFileUploading><span class=\"fa fa-pencil\" aria-hidden=true></span></button> {{file.optimizeVideo}}</span> <span ng-show=file.isEdit class=\"navbar-form noPad\"><div class=\"input-group input-group-sm marB2\" ng-class=\"{\'has-error\':file.isNameValid == false}\"><input type=text class=form-control ng-model=file.tempLabel id=tempLabel aria-label=tempLabel aria-labelledby=tempLabel><span class=input-group-addon>.{{file.extension}}</span></div><button type=button role=button class=\"btn btn-success btn-sm marB2 marL5\" ng-click=saveEditName($index);>{{\'cm.btn.7\' | translate}}</button><button type=button role=button class=\"btn btn-link btn-sm marB2 marL5\" ng-click=cancelEditName($index);>{{\'cm.btn.9\' | translate}}</button></span></div><div class=\"text-sm text-muted\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extension == \'f4v\' || file.extension == \'mxf\' || file.extension == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\') || file.extension == \'xls\' || file.extension == \'xlsx\')\"><span ng-if=\"file.extension != \'xls\' && file.extension != \'xlsx\'\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span ng-show=\"$flow.isUploading() || file.paused\"><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span><span ng-if=\"file.extension == \'xls\' || file.extension == \'xlsx\'\"><label class=marR5><input type=checkbox role=checkbox name=\"{{\'cl.widget.es.3\' | translate}}\" ng-model=file.exai><label></label>{{\'cl.widget.es.3\' | translate}}</label></span></span><span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.vi && (itemInArray(sFiles.vid, file.extension.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.vi.2\' | translate}}:</label><span ng-show=\"$flow.isUploading() || file.paused\"><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.vi == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.vi == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\"><label class=marR5><input type=radio role=radio name=vIndexerOpt_{{$index}} ng-model=file.vi value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label><input type=radio role=radio name=vIndexerOpt_{{$index}} ng-model=file.vi value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=\"progress marB5 marT8\"><div class=\"progress-bar progress-bar-striped active\" ng-attr-style=\"width:{{ 100 * file.progress() | number:0 }}%\"><span class=pad2>{{ 100 * file.progress() | number:0 }}%</span></div></div><div class=text-right><span ng-hide=file.paused uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-warning\" ng-click=file.pause(); ng-disabled=\"isPermissionOpen || !$flow.isUploading()\">{{\'cl.p_c.5\' | translate}}</button> </span><span ng-show=file.paused uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-warning\" ng-click=file.resume(); ng-disabled=isPermissionOpen>{{\'cl.p_c.6\' | translate}}</button> </span><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=\"file.cancel(); fileCancel(file);\">{{\'cm.btn.9\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=file.sizeUnsupported class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=file.cancel();><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'unknown_w\':\'unknown\'}}.png\"></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{\'cl.p_c.m4\' | translate}}</div></div></div><div ng-if=file.unsupported class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=file.cancel();><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'unknown_w\':\'unknown\'}}.png\" ng-if=\"!itemInArray(supportedFiles, file.extension.toLowerCase())\"></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{\'cl.p_c.m2\' | translate}}</div></div></div><!-- Storage plan 1 --><div ng-if=file.isSizeExceed class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=file.cancel();><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=\"flowThumb marB20\"><span class=helper></span> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'ppt_w\':\'ppt\'}}.png\" ng-if=\"file.extension == \'ppt\' || file.extension == \'pptx\' || file.extension == \'pps\' || file.extension == \'ppsx\' || file.extension == \'odp\'\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'video_w\':\'video\'}}.png\" ng-if=\"itemInArray(sFiles.vid, file.extension.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'word_w\':\'word\'}}.png\" ng-if=\"file.extension == \'doc\' || file.extension == \'docx\' || file.extension == \'odt\'\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'excel_w\':\'excel\'}}.png\" ng-if=\"file.extension == \'xls\' || file.extension == \'xlsx\'\"> <img alt=\"\" src-error=\"assets/images/default/{{themeSwitch.btn?\'img_w\':\'img\'}}.png\" ng-if=\"itemInArray(sFiles.img, file.extension.toLowerCase())\" flow-img=file> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'audio_w\':\'audio\'}}.png\" ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"> <img alt=\"\" ng-src=\"assets/images/default/{{themeSwitch.btn?\'pdf_w\':\'pdf\'}}.png\" ng-if=\"file.extension == \'pdf\'\"></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{\'cl.p_c.m6\' | translate:{spSize:(auth.strg.s | filesize) } }} <span class=\"fa fa-info-circle text-primary\" uib-tooltip-template=\"\'spInfo.html\'\" tooltip-append-to-body=true></span></div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=contentPermissionExpiryTemp.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=contentPermissionExpiryTemp.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div><script type=text/ng-template id=spInfo.html><div class=\"text-left\">\r\n    <div>{{\'cl.p_c.m6.1\' | translate}}</div>\r\n    <div class=\"spaceH2\"></div>\r\n    <div>{{\'cl.p_c.m6.2\' | translate:{spSize:(auth.strg.s | filesize)} }}</div>\r\n    <div class=\"spaceH\"></div>\r\n    <div>{{\'cl.p_c.m6.3\' | translate}}</div>\r\n  </div></script>");
$templateCache.put("app/contentLibrary/cAddT.html","<img alt=Loading src=assets/images/loading.gif ng-if=listLoading><div class=row ng-if=!listLoading><div class=col-xs-12 ng-if=\"!tpuList.db && !tpuList.fb && !tpuList.ftp && !tpuList.gd && !tpuList.ig && !tpuList.tw && !tpuList.url\"><div class=msg-warning lang={{auth.lang}}>{{\'cl.msg.31\' | translate}}</div></div><div class=\"col-xs-2 col-lg-2 widgetMenu\" ng-attr-style=height:{{getAvailableHeight(239)}}px; ng-if=isListOpen><ul class=nav id=tpuBtn role=tablist aria-labelledby=navList><li ui-sref-active=active ng-if=tpuList.db role=tab><a ui-sref=.tpuDbox role=button class=dropbox>{{\'cl.p_c.10\' | translate}}</a></li><li ui-sref-active=active ng-if=tpuList.ftp role=tab><a ui-sref=.tpuFtp role=button class=ftp>{{\'cl.p_c.12\' | translate}}</a></li><li ui-sref-active=active ng-if=tpuList.gd role=tab><a ui-sref=.tpuDrive role=button class=gDrive>{{\'cl.p_c.11\' | translate}}</a></li><li ui-sref-active=active ng-if=tpuList.ig role=tab><a ui-sref=.tpuInsta role=button class=instagram>{{\'cl.widget.instagram.1\' | translate}}</a></li><li ui-sref-active=active ng-if=tpuList.tw role=tab><a ui-sref=.tpuTw role=button class=twitter>{{\'cl.widget.twitter.1\' | translate}}</a></li><li ui-sref-active=active ng-if=tpuList.url role=tab><a ui-sref=.tpuUrl role=button class=url>{{\'cl.widget.cm.10\' | translate}}</a></li></ul></div><div ng-class=\"isListOpen?\'col-xs-10\':\'col-xs-12\'\" ng-if=\"tpuList.db || tpuList.fb || tpuList.ftp || tpuList.gd || tpuList.ig || tpuList.tw || tpuList.url\"><div class=widgetForm ng-class=\"{\'withSessionMsg\':loginSessionMsg}\" ng-attr-style=min-height:{{getAvailableHeight(305)}}px; ui-view=thirdPartyView></div><div class=bdr-top-dashed><img alt=Loading src=assets/images/loading-xs.gif ng-if=btnLoading> <span class=\"btnQuad noMarB\" ng-if=!btnLoading><button type=button role=button class=btn ng-class=\"isVerified?\'btn-default\':\'btn-primary\'\" ng-click=authorizeFx(); ng-disabled=isAuthLoading ng-if=isAuthShow>{{isVerified?\'cm.head.menu.5\':\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=selectFileFx(); ng-disabled=\"(!isVerified && isAuthShow) || (isVerified && !isAuthShow) || selectProcessing || isUploading\" ng-if=isSelectShow>{{\'cl.btn.5s\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=tpuUploadFx(); ng-disabled=\"!curSelected.length || isUploading\"><span class=fa ng-class=\"isUploading?\'fa-repeat fa-spin\':\'fa-arrow-up\'\" aria-hidden=true></span>{{\'cm.btn.16\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'fileFormat\'\" aria-live=polite role=status>{{\'cl.p_c.m5\' | translate}}</div><div ng-if=\"errType==\'urlEmpty\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'invalidUrl\'\" aria-live=polite role=status>{{\'cl.widget.msg.3.1\' | translate}}</div><div ng-if=\"errType==\'fileSize\'\" aria-live=polite role=status>{{\'cm.msg.24\' | translate:{fileSize:\'512MB\'} }}</div></div><div class=clearfix></div></div></div></div>");
$templateCache.put("app/contentLibrary/cAddW.html","<img alt=Loading src=assets/images/loading.gif ng-if=listLoading><div class=row ng-if=!listLoading><div class=col-xs-12 ng-if=isWidgetEmpty><div class=msg-warning lang={{auth.lang}}>{{\'cl.msg.32\' | translate}} <a href=\"\" role=link ng-click=mailSupportOpen(); class=text-bold>L&nbsp;Squared&nbsp;Support</a> {{\'cl.msg.32.1\' | translate}}</div></div><div class=\"col-xs-2 col-lg-2 widgetMenu\" ng-attr-style=height:{{getAvailableHeight(239)}}px; ng-if=\"isListOpen && tabView && !isWidgetEmpty\"><div class=\"pad10 bg-light stickySearchBox\" ng-show=\"widgetListArr.length > 5\"><label for=wSBox class=lableHidden>c</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=wSBox ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=wSRBtn class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><ul class=nav role=menu aria-labelledby=menuList><li ui-sref-active=active role=menuitem ng-repeat=\"w in filteredWidgetList = (widgetListArr | filter:searchText | orderBy:\'label\')\"><a ui-sref={{w.state}} role=button class={{w.class}}>{{w.label}}</a></li><div class=msg-warning lang={{auth.lang}} ng-if=!filteredWidgetList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><div ng-class=\"(isListOpen && tabView)?\'col-xs-10\':\'col-xs-12\'\" ng-show=!isWidgetEmpty><div class=widgetForm ng-class=\"{\'withSessionMsg\':loginSessionMsg}\" ng-attr-style=height:{{isWidgetEmpty?0:getAvailableHeight(239)}}px; ui-view=widgetView></div></div></div>");
$templateCache.put("app/contentLibrary/contentLibrary.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"selectedTab == \'hub.contentLibrary.c\' && contentLibraryLoading\"> <span ng-if=\"selectedTab == \'hub.contentLibrary.c\' && (auth.upermissions.ar || curFolderId != 0) && !contentLibraryLoading\"><button type=button role=button class=\"btn btn-primary marR5\" ui-sref=hub.contentAdd.contentAddTab ng-if=\"auth.upermissions.c && !auth.upermissions.w && contentLibrary.info.writable\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.btn.1\' | translate}}</button><button type=button role=button class=\"btn btn-primary marR5\" ui-sref=hub.contentAdd.contentAddTab ng-if=\"auth.upermissions.c && auth.upermissions.w && contentLibrary.info.writable\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default marR5\" ng-click=aiPopupOpen(); ng-if=\"auth.upermissions.c && contentLibrary.info.writable && auth.upermissions.ai && auth.upermissions.ai_img\"><span class=\"d-flex align-items-center noMarR\"><img class=w14 alt=cgi src=\"assets/images/{{themeSwitch.btn?\'chatGPT-logo-dk\':\'chatGPT-logo\'}}.png\"><span class=\"marL5 noMarR\">{{\'cl.btn.24\' | translate}}</span></span></button> <button type=button role=button class=\"btn btn-primary marR5\" ui-sref=hub.contentAdd.widgetAddTab.dateTime ng-if=\"auth.upermissions.w && !auth.upermissions.c && contentLibrary.info.writable\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.btn.2\' | translate}}</button><div class=btn-group uib-dropdown ng-if=\"auth.upermissions.cf && contentLibrary.info.writable\"><button type=button role=button class=\"btn btn-default\" ng-click=\"folderCUOpen(\'n\');\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.3\' | translate}}</button> <button type=button role=button ng-if=\"auth.uservices.mssp || auth.uservices.msod || auth.uservices.sf\" class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"folderCUOpen(\'n\');\"><svg xmlns=http://www.w3.org/2000/svg xml:space=preserve viewBox=\"0 0 512 512\" width=14 height=14 class=\"valign-middle marR5\" ng-style=\"{\'fill\':myTheme.theme==\'dk\'?\'#fff\':\'\'}\" id=plus><path d=\"M448 224H288V64h-64v160H64v64h160v160h64V288h160z\"></path></svg>{{\'cl.p_f.1.6\' | translate}}</a></li><li class=divider></li><li ng-if=\"auth.uservices.gd && auth.uservices.gd.active && (auth.uservices.gd.sp || auth.uservices.gd.oauth)\"><a href=\"\" role=link ng-click=\"folderCUOpen(\'gd\');\"><img alt=\"\" src=assets/images/tp/google-drive.svg width=18px class=\"marR5 marL-2\">{{\'cl.p_f.19\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.uservices.msod ng-click=\"folderCUOpen(\'od\');\"><img alt=\"\" src=assets/images/tp/onedrive.svg width=15px class=marR5>{{\'cl.p_f.15\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.uservices.mssp ng-click=\"folderCUOpen(\'sp\');\"><img alt=\"\" src=assets/images/tp/sharepoint.svg width=15px class=marR5>{{\'cl.p_f.14\' | translate}}</a></li><li class=divider ng-if=\"auth.uservices.sf && authServer.length > 1\"></li><li ng-if=\"auth.uservices.sf && authServer.length > 1\"><a href=\"\" role=link ng-if=\"auth.uservices.sf && curSPlObj.type!==\'sharedfolder\'\" ng-click=\"folderCUOpen(\'sf\');\"><img alt=\"\" src=assets/images/tp/link.svg width=15px class=marR5>{{\'cl.p_f.17\' | translate}}</a></li></ul></div></span></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=searchBox class=lableHidden>device</label><div class=searchTbx ng-class=\"{\'input-group\': selectedTab == \'hub.contentLibrary.c\'}\"><input type=text class=form-control id=searchBox ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"selectedTab == \'hub.contentLibrary.c\'\"><!-- <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle name=\"search\" id=\"sortBtn\"><span class=\"fa fa-sort noMarR\"></span></button>\r\n        <ul class=\"dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r\n          <li><a href=\"\" id=\"advSearch\" ng-click=\"advancedSearchClOpen(\'cl\', \'cl\');\">{{\'cm.body.10\' | translate}}</a></li>\r\n        </ul> --> <button type=button role=button id=advSearch class=\"btn btn-default\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left aria-label=search ng-click=\"advancedSearchClOpen(\'cl\', \'cl\');\"><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></span></div></div><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo></advanced-search></div><div ng-if=!advSearch><div class=spaceH></div><div class=spaceH></div></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs cl\" role=tablist aria-owns=\"tab-c tab-uc tab-ec tab-ac tab-dc\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.contentLibrary.c\')}}\" aria-controls=tab-c id=tab-c class=tab-success><a ui-sref=.c role=link aria-label=\"{{\'cl.tab.1\' | translate}}\">{{\'cl.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.contentLibrary.uc\')}}\" aria-controls=tab-uc id=tab-uc class=tab-disabled><a ui-sref=.uc role=link aria-label=\"{{\'cl.tab.2\' | translate}}\">{{\'cl.tab.2\' | translate}}<span class=\"badge bg-danger\" ng-if=\"unapprovedContents.length>0\">{{(unapprovedContents).length}}</span></a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.contentLibrary.ec\')}}\" aria-controls=tab-ec id=tab-ec class=tab-warning><a ui-sref=.ec role=link aria-label=\"{{\'cl.tab.3\' | translate}}\">{{\'cl.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.contentLibrary.ac\')}}\" aria-controls=tab-ac id=tab-ac class=tab-primary><a ui-sref=.ac role=link aria-label=\"{{\'cl.tab.4\' | translate}}\">{{\'cl.tab.4\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.contentLibrary.dc\')}}\" aria-controls=tab-dc id=tab-dc class=tab-danger><a ui-sref=.dc role=link aria-label=\"{{\'cl.tab.5\' | translate}}\">{{\'cl.tab.5\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right uib-dropdown><a href=\"\" role=button id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=sorting><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'label\' && contentLibrary.info.sortVal === \'asc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'label\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'label\' && contentLibrary.info.sortVal === \'desc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'label\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator ng-if=\"selectedTab != \'hub.contentLibrary.uc\'\"></li><li role=menuitem class=dropdown-header ng-if=\"selectedTab != \'hub.contentLibrary.uc\'\">{{\'cm.tool.1.2\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'approvedon\' && contentLibrary.info.sortVal === \'asc\'}\" ng-if=\"selectedTab != \'hub.contentLibrary.uc\'\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'approvedon\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'approvedon\' && contentLibrary.info.sortVal === \'desc\'}\" ng-if=\"selectedTab != \'hub.contentLibrary.uc\'\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'approvedon\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'createdon\' && contentLibrary.info.sortVal === \'asc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'createdon\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'createdon\' && contentLibrary.info.sortVal === \'desc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'createdon\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator ng-if=\"selectedTab == \'hub.contentLibrary.c\'\"></li><li role=menuitem class=dropdown-header ng-if=\"selectedTab == \'hub.contentLibrary.c\'\">{{\'cm.tool.1.6\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'editedon\' && contentLibrary.info.sortVal === \'asc\'}\" ng-if=\"selectedTab == \'hub.contentLibrary.c\'\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'editedon\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': contentLibrary.info.sortType === \'editedon\' && contentLibrary.info.sortVal === \'desc\'}\" ng-if=\"selectedTab == \'hub.contentLibrary.c\'\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'editedon\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider></li><li class=dropdown-header>{{\'cm.brief.3\' | translate | camelCase}}</li><li ng-class=\"{\'selected\': contentLibrary.info.sortType === \'createdby\' && contentLibrary.info.sortVal === \'asc\'}\"><a href=\"\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': contentLibrary.info.sortType === \'createdby\' && contentLibrary.info.sortVal === \'desc\'}\"><a href=\"\" ng-click=\"sortFx(\'createdby\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider></li><li class=dropdown-header>{{\'cm.label.69\' | translate}}</li><li ng-class=\"{\'selected\': contentLibrary.info.sortType === \'type\' && contentLibrary.info.sortVal === \'asc\'}\"><a href=\"\" ng-click=\"sortFx(\'type\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': contentLibrary.info.sortType === \'type\' && contentLibrary.info.sortVal === \'desc\'}\"><a href=\"\" ng-click=\"sortFx(\'type\', \'desc\', contentList, contentLibrary.info, \'contentsort\', folderList);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button id=view uib-dropdown-toggle uib-tooltip=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-cog\" aria-hidden=true></span></a><ul class=\"dropdown-menu dropdown-sub-menu cl-dropdown\" uib-dropdown-menu role=menu aria-labelledby=view><li class=inner-link><a href=\"\" role=button class=padL20>{{\'cm.tool.11.1\' | translate}} <span class=\"support-caret fa fa-caret-right\" aria-hidden=true></span></a><ul class=\"dropdown-menu inner-menu\" role=menu uib-dropdown-menu dropdown-append-to-body aria-labelledby=vList><li role=menuitem ng-class=\"{\'selected\':groupType==\'name\'}\"><a href=\"\" role=menuitem ng-click=\"groupingFx(\'name\');\">{{\'cm.brief.1\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':groupType==\'type\'}\"><a href=\"\" role=menuitem ng-click=\"groupingFx(\'type\');\">{{\'cm.label.69\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':groupType==\'modified\'}\"><a href=\"\" role=menuitem ng-click=\"groupingFx(\'modified\');\">{{\'cm.tool.11.2\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem ng-class=\"{\'selected\':groupType==\'none\'}\"><a href=\"\" role=menuitem ng-click=\"groupingFx(\'none\');\">{{\'cl.widget.cm.12.3\' | translate}}</a></li></ul></li><li class=inner-link ng-class=\"{\'selected\':auth.upreferences.contentView == \'l\'}\"><a href=\"\" role=button class=padL20 ng-click=\"preferencesFx(\'contentView\',\'l\'); contentViewReloadFx(); removeSelectedFx()\">{{\'cm.tool.6\' | translate}}</a></li><li class=inner-link ng-class=\"{\'selected\':auth.upreferences.contentView == \'t\'}\"><a href=\"\" role=button class=padL20 ng-click=\"preferencesFx(\'contentView\',\'t\'); contentViewReloadFx(); removeSelectedFx()\">{{\'cm.tool.5\' | translate}}</a></li><li class=inner-link ng-if=\"auth.upreferences.contentView == \'t\'\"><a href=\"\" role=button id=caret class=padL20>{{\'cm.tool.4\' | translate}} <span class=\"support-caret fa fa-caret-right\" aria-hidden=true></span></a><ul class=\"dropdown-menu inner-menu\" role=menu uib-dropdown-menu dropdown-append-to-body aria-labelledby=vsList><li role=menuitem ng-class=\"{\'selected\':thumbSize==\'sm\'}\"><a href=\"\" role=menuitem ng-click=\"setDisplayFx(\'sm\');\">{{\'cl.tool.1\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':thumbSize==\'n\'}\"><a href=\"\" role=menuitem ng-click=\"setDisplayFx(\'n\');\">{{\'cl.tool.2\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':thumbSize==\'md\'}\"><a href=\"\" role=menuitem ng-click=\"setDisplayFx(\'md\');\">{{\'cl.tool.3\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':thumbSize==\'lg\'}\"><a href=\"\" role=menuitem ng-click=\"setDisplayFx(\'lg\');\">{{\'cl.tool.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':thumbSize==\'xl\'}\"><a href=\"\" role=menuitem ng-click=\"setDisplayFx(\'xl\');\">{{\'cl.tool.5\' | translate}}</a></li></ul></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button id=filter aria-label=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=filter><li role=menuitem ng-class=\"{\'selected\':filter==\'Image\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'Image\');\">{{\'cl.tool.6\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==\'Video\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'Video\');\">{{\'cl.tool.7\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==\'Widget\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'Widget\');\">{{\'cl.tool.8\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==\'myContent\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'myContent\');\">{{\'cl.tool.9\' | translate}}</a></li><li role=menuitem class=divider ng-if=\"$state.includes(\'hub.contentLibrary.c\')\"></li><li role=menuitem ng-class=\"{\'selected\':filter==\'approved\'}\" ng-if=\"$state.includes(\'hub.contentLibrary.c\')\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'approved\');\">{{\'cl.tool.10\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==\'unapproved\'}\" ng-if=\"$state.includes(\'hub.contentLibrary.c\')\"><a href=\"\" role=button ng-click=\"filterFx(\'unapproved\');\">{{\'cl.tool.11\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem ng-class=\"{\'selected\':filter==\'all\'}\"><a href=\"\" role=button ng-click=\"filterFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=info><li role=menuitem ng-if=\"selectedTab == \'hub.contentLibrary.uc\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'uc\');\" translate=\"{{\'cl.tool.13\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li role=menuitem ng-if=\"selectedTab == \'hub.contentLibrary.ec\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'ec\');\" translate=\"{{\'cl.tool.14\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li role=menuitem ng-if=\"selectedTab == \'hub.contentLibrary.ac\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'ac\');\" translate=\"{{\'cl.tool.15\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li role=menuitem class=vid><a href=\"\" role=menuitem ng-click=videoFx(); translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li></ul></div><div class=pull-right ng-if=\"$state.includes(\'hub.contentLibrary.c\') && (folderList.length > 0 || contentList.length > 0 || breadCrumbs.length > 0)\"><a href=\"\" role=button id=tree ng-click=\"preferencesFx(\'isTreeOpen\'); removeHighlightFx()\" ng-class=\"{\'active\': auth.upreferences.isTreeOpen == 1}\" uib-tooltip=\"{{\'cl.tool.12\' | translate}}\" aria-label=\"{{\'cl.tool.12\' | translate}}\" aria-labelledby=\"{{\'cl.tool.12\' | translate}}\"><span class=\"fa fa-sitemap\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=button id=refresh ng-click=\"loadSelectedTab(\'refresh\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingMain aria-label=\"{{\'cm.btn.33\' | translate}}\" aria-labelledby=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':loadingMain}\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><!--For Selected Item Brief--><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-content-brief ng-if=\"selectedItems.length > 0\"></ng-content-brief>");
$templateCache.put("app/contentLibrary/cp.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><section class=\"panel noMar\" ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><div class=\"panel-body pad15\"><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><div ng-if=!contentLoading><div class=row><div class=col-xs-4><div class=\"marB25 bg-black text-center\"><video controls autoplay data-setup=\"{inactivityTimeout: 0}\" class=img-responsive style=background:#000><source ng-src=\"{{contentInfo.src | trustUrl}}\" type=video/mp4>Your browser does not support the HTML5 video.</video></div></div><div class=col-xs-8><!-- Add new caption --><div class=row><div class=col-xs-4><label for=time>{{\'cl.label.25\' | translate}}</label><input type=text class=form-control ng-model=addCue.time min=1 ui-mask=99:99:99 placeholder=hh:mm:ss id=time aria-label=time aria-labelledby=time></div><div class=col-xs-2><label>&nbsp;</label><div><button type=button role=button class=\"btn btn-success btn-block\" ng-click=addCueTimeFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=\"col-xs-12 text-muted marT10\"><span ng-if=\"contentInfo.cue.length == 0\">{{\'cl.msg.48\' | translate}}</span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'cueTime\'\" aria-live=polite role=status>{{\'cl.msg.46\' | translate}}</div><div ng-if=\"errType==\'ctNotValid\'\" aria-live=polite role=status>{{\'cl.msg.47\' | translate}}</div><div ng-if=\"errType==\'cueExist\'\" aria-live=polite role=status>{{\'cl.msg.49\' | translate}}</div></div><div class=clearfix></div></div></div><div class=row><!-- action buttons --><div class=\"col-xs-12 text-right\" ng-if=!cueLoading><div class=\"bdrBtm marT15 marB10\"></div></div><div class=\"col-xs-12 pull-left marT15\" ng-if=cueLoading><img alt=Loading src=assets/images/loading.gif class=padB10></div><div class=\"col-xs-12 marB15\" ng-if=!cueLoading><!-- cue table --><div class=\"table table-scroll\" ng-if=\"contentInfo.cue.length > 0\"><div class=\"row th\"><div class=col-xs-12><label for=sAll><input type=checkbox ng-model=isChecked.all ng-change=\"cueCheckedFx(\'all\');\" role=checkbox id=sAll aria-label=sAll aria-labelledby=sAll><label></label>{{\'cl.label.25\' | translate}}</label><button type=button role=button ng-if=\"contentInfo.cue.length > 0\" class=\"btn btn-default pad6 marL7 pull-right\" ng-class=\"cueRemoveLength?\'text-danger\':\'text-muted\'\" ng-click=cueRemoveConfirm(); ng-disabled=\"cueRemoveLength==0\"><span class=\"fa fa-times marR5\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button></div></div><div class=overflow-auto style=max-height:{{getAvailableHeight(697)}}px><ul><li class=\"row captionQuad\" ng-repeat=\"cue in contentInfo.cue\" data-begin={{caption.begin}} data-end={{caption.end}}><div class=\"col-xs-12 codeQuad\"><label class=text-unbold tooltip-popup-delay=1000 tooltip-append-to-body=true><input type=checkbox ng-model=cue.isChecked ng-change=cueCheckedFx(); role=checkbox id=contentInfo-{{$index}} aria-label=contentInfo-{{$index}} aria-labelledby=contentInfo-{{$index}}><label></label><span class=codeText>{{cue.time}}</span></label></div></li></ul></div></div></div></div></div></div></div></div></section>");
$templateCache.put("app/contentLibrary/dc.html","<img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div class=row ng-if=\"!contentLibraryLoading && (contentList.length > 0 || folderList.length > 0)\"><div class=col-lg-12><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.contentView == \'t\'\"><ng-content-list class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.contentView == \'l\'\"><ng-content-list-view class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && (contentList.length == 0 && folderList.length == 0)\"><p>{{\'cl.msg.6\' | translate}}</p><a href=\"\" role=link ng-click=videoFx();><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/contentLibrary/ec.html","<img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div class=row ng-if=\"!contentLibraryLoading && contentList.length > 0\"><div class=col-lg-12><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.contentView == \'t\'\"><ng-content-list class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.contentView == \'l\'\"><ng-content-list-view class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=contentList folder-open=false></ng-content-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0\"><p>{{\'cl.msg.4\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ec\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cl.tool.14\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=videoFx();><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/contentLibrary/editImg.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><div class=pull-left><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.1\' | translate}}\" ng-click=\"drawFx(\'text\');\"><span class=\"glyphicon glyphicon-font noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.2\' | translate}}\" ng-click=\"drawFx(\'rect\');\"><span class=\"fa fa-stop noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.3\' | translate}}\" ng-click=\"drawFx(\'circle\');\"><span class=\"fa fa-circle noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.4\' | translate}}\" ng-click=\"drawFx(\'triangle\');\"><span class=\"fa fa-play fa-rotate-270 noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrLd bdrLR8\" ng-if=!isEmpty><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.6\' | translate}}\" ng-click=\"positionFx(\'sendBack\');\"><span class=\"fa fa-level-down noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.7\' | translate}}\" ng-click=\"positionFx(\'bringForward\');\"><span class=\"fa fa-level-up noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.8\' | translate}}\" ng-click=\"positionFx(\'sendToBack\');\"><span class=\"fa fa-angle-double-down noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.9\' | translate}}\" ng-click=\"positionFx(\'bringToFront\');\"><span class=\"fa fa-angle-double-up noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrLd bdrLR8\" ng-if=!isEmpty><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" ng-click=deleteFx();><span class=\"glyphicon glyphicon-trash noMarR\" aria-hidden=true></span></button></div><div class=clearfix></div></header><div class=panel-body><div class=row><div class=col-xs-10><div class=\"canvas-container pad10 overflow-auto editorBg\" style=height:{{getAvailableHeight(265)}}px><img alt=Loading src=assets/images/loading.gif ng-if=imgLoading><canvas id=canvas></canvas></div></div><div class=col-xs-2><!-- Image --><div class=filtersQuad ng-if=\"!isEmpty && curObj.type == \'image\'\"><div class=header><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=resetFilterFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> {{\'cm.editor.11\' | translate}}</div><div class=pad10><div class=\"form-group bdrBdLight padB10 marB10\"><div><label><input type=checkbox ng-model=curImg.grayscale ng-click=\"filterFx(\'grayscale\');\" role=checkbox><label></label>{{\'cm.editor.11.1\' | translate}}</label></div><div><label><input type=checkbox ng-model=curImg.invert ng-click=\"filterFx(\'invert\');\" role=checkbox><label></label>{{\'cm.editor.11.2\' | translate}}</label></div><div><label><input type=checkbox ng-model=curImg.sepia1 ng-click=\"filterFx(\'sepia1\');\" role=checkbox><label></label>{{\'cm.editor.11.3\' | translate:\'{no: 1}\' }}</label></div><div><label><input type=checkbox ng-model=curImg.sepia2 ng-click=\"filterFx(\'sepia2\');\" role=checkbox><label></label>{{\'cm.editor.11.3\' | translate:\'{no: 2}\' }}</label></div><div><label><input type=checkbox ng-model=curImg.emboss ng-click=\"filterFx(\'emboss\');\" role=checkbox><label></label>{{\'cm.editor.11.4\' | translate}}</label></div><div><label><input type=checkbox ng-model=curImg.blur ng-click=\"filterFx(\'blur\');\" role=checkbox><label></label>{{\'cm.editor.11.5\' | translate}}</label></div><div><label><input type=checkbox ng-model=curImg.sharpen ng-click=\"filterFx(\'sharpen\');\" role=checkbox><label></label>{{\'cm.editor.11.6\' | translate}}</label></div></div><div class=form-group><label>{{\'cm.editor.11.7\' | translate}}</label><input type=range min=-255 max=255 class=marB10 ng-model=curImg.brightness ng-mouseup=\"filterFx(\'brightness\');\"><label>{{\'cm.editor.11.8\' | translate}}</label><input type=range min=-255 max=255 class=marB10 ng-model=curImg.contrast ng-mouseup=\"filterFx(\'contrast\');\"><label>{{\'cm.editor.11.9\' | translate}}</label><input type=range min=-100 max=100 class=marB10 ng-model=curImg.saturation ng-mouseup=\"filterFx(\'saturation\');\"></div></div></div><!-- Text --><div class=filtersQuad ng-if=\"!isEmpty && curObj.type == \'text\'\"><div class=header>{{\'cm.editor.10\' | translate}}</div><div class=pad10><div class=\"bdrBdLight marB15\"><div class=\"form-group input-group input-group-sm\"><label for=font>{{\'cm.label.24\' | translate}}</label><select class=form-control ng-model=curObj.font ng-change=\"setPropertiesFx(\'text\', \'font\');\" ng-options=\"font.label for font in fontFamily track by font.value\" id=font aria-label=font aria-labelledby=font></select></div><div class=\"form-group input-group input-group-sm\"><label for=size>{{\'cm.label.83\' | translate}}</label><input type=number class=form-control min=0 ng-model=curObj.size ng-change=\"setPropertiesFx(\'text\', \'size\');\" id=size aria-label=size aria-labelledby=size></div><div class=form-group><label for=tColor>{{\'cl.widget.cm.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick><div class=input-colorPicker><input type=text class=\"form-control input-sm picker\" ng-value=\"curObj.tColor | uppercase\" ng-model=curObj.tColor uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly id=tColor aria-label=tColor aria-labelledby=tColor></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"right bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=curObj.tColor selected-type=curObj.cType ng-if=colorPicker></ng-hub-color-picker></div></div></div></div><div class=marB5><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.1\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'bold\');\" ng-class=\"{\'focus\':curObj.fontWeight == \'600\'}\"><span class=\"glyphicon glyphicon-bold noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.2\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'italic\');\" ng-class=\"{\'focus\':curObj.fontStyle == \'italic\'}\"><span class=\"glyphicon glyphicon-italic noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.3\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'underline\');\" ng-class=\"{\'focus\':curObj.textDecoration == \'underline\'}\"><span class=\"fa fa-underline noMarR\" aria-hidden=true></span></button></div><div class=marB5><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.4\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'left\');\" ng-class=\"{\'focus\':curObj.textAlign == \'left\'}\"><span class=\"glyphicon glyphicon-align-left noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.5\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'center\');\" ng-class=\"{\'focus\':curObj.textAlign == \'center\'}\"><span class=\"glyphicon glyphicon-align-center noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.6\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'right\');\" ng-class=\"{\'focus\':curObj.textAlign == \'right\'}\"><span class=\"glyphicon glyphicon-align-right noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.7\' | translate}}\" ng-click=\"setPropertiesFx(\'text\', \'justify\');\" ng-class=\"{\'focus\':curObj.textAlign == \'justify\'}\"><span class=\"glyphicon glyphicon-align-justify noMarR\" aria-hidden=true></span></button></div></div></div><!-- Object --><div class=filtersQuad ng-if=\"!isEmpty && curObj.type == \'obj\'\"><div class=header>{{\'cm.editor.12\' | translate}}</div><div class=pad10><div class=form-group><label for=bgColor>{{\'cm.label.61\' | translate}}</label><div uib-dropdown auto-close=outsideClick><div class=input-colorPicker><input type=text class=\"form-control input-sm picker\" ng-value=\"curObj.bgColor | uppercase\" ng-model=curObj.bgColor uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly id=bgColor aria-label=bgColor aria-labelledby=bgColor></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"right bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=curObj.bgColor selected-type=curObj.bgType ng-if=colorPicker></ng-hub-color-picker></div></div></div></div></div><div class=\"filtersQuad marT10\" ng-if=!isEmpty><div class=header>{{\'cm.editor.13\' | translate}}</div><div class=pad10><div class=\"form-group row\"><div class=col-xs-6><label for=left>{{\'fl.p_cfl.label.8\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.left ng-change=\"setPropertiesFx(\'all\', \'x\');\" min=0 id=x aria-label=x aria-labelledby=x></div><div class=col-xs-6><label for=top>{{\'fl.p_cfl.label.9\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.top ng-change=\"setPropertiesFx(\'all\', \'y\');\" min=0 id=y aria-label=y aria-labelledby=y></div></div><div class=\"form-group row\" ng-if=\"curObj.subType != \'circle\' && curObj.type != \'text\'\"><div class=col-xs-6><label for=width>{{\'cm.label.59\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.width ng-change=\"setPropertiesFx(\'all\', \'w\');\" min=0 id=w aria-label=w aria-labelledby=w></div><div class=col-xs-6><label for=height>{{\'cm.label.60\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.height ng-change=\"setPropertiesFx(\'all\', \'h\');\" min=0 id=h aria-label=h aria-labelledby=h></div></div><div class=\"form-group row\"><div class=col-xs-6><label for=scaleX>{{\'cm.editor.13.1\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.scaleX ng-change=\"setPropertiesFx(\'all\', \'scaleX\');\" min=0 id=scaleX aria-label=scaleX aria-labelledby=scaleX></div><div class=col-xs-6><label for=scaleY>{{\'cm.editor.13.2\' | translate}}</label><input type=number class=\"form-control input-sm\" ng-model=curObj.scaleY ng-change=\"setPropertiesFx(\'all\', \'scaleY\');\" min=0 id=scaleY aria-label=scaleY aria-labelledby=scaleY></div></div><div class=form-group><label for=angle>{{\'cm.editor.13.3\' | translate}}</label><input type=range ng-model=curObj.angle ng-change=\"setPropertiesFx(\'all\', \'angle\');\" min=-90 max=90 id=angle aria-label=angle aria-labelledby=angle></div><div class=form-group><label for=opacity>{{\'cm.editor.13.4\' | translate}}</label><input type=range ng-model=curObj.opacity ng-change=\"setPropertiesFx(\'all\', \'opacity\');\" min=0 max=1 step=.01 id=opacity aria-label=opacity aria-labelledby=opacity></div></div></div><div class=\"filtersQuad pad10 text-muted text-sm\" ng-if=isEmpty>{{\'cl.p_cEdit.m9\' | translate}}</div></div></div></div><div class=panel-footer><span class=btnQuad><span uib-tooltip={{tooltipMsg}}><button type=button role=button class=\"btn btn-primary\" ng-click=\"saveImageFx(\'new\');\" ng-disabled=\"saveProcessing || isNewPermission\"><span class=fa ng-class=\"newProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.btn.14\' | translate}}</button></span> <button type=button role=button class=\"btn btn-default\" ng-click=\"saveImageFx(\'replace\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"replaceProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.btn.15\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/contentLibrary/editVid.html","<div class=pageHeading><a href=\"\" role=link class=marR10 ui-sref=hub.contentLibrary.c>{{\'cm.menu.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=\"curState == \'hub.contentLibraryEditCapVid.vc\'\">{{\'cl.label.22\' | translate}}</span><span class=\"marL10 marR10\" ng-if=\"curState == \'hub.contentLibraryEditCapVid.ev\'\">{{\'cl.label.18\' | translate}}</span><span class=\"marL10 marR10\" ng-if=\"curState == \'hub.contentLibraryEditCapVid.cp\'\">{{\'cl.label.26\' | translate}}</span>/ <span class=\"marL10 marR10\">{{\'cl.tool.7\' | translate}} <span class=text-muted>[ {{contentInfo.label}} ]</span></span></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs d\" role=tablist aria-labelledby=navList><li ui-sref-active=active role=tab class=tab-success><a ui-sref=.vc role=button>{{\'cl.label.17\' | translate}}</a></li><li ui-sref-active=active role=tab class=tab-info><a ui-sref=.ev role=button>{{\'cl.label.18\' | translate}}</a></li><li ui-sref-active=active role=tab class=tab-primary><a ui-sref=.cp role=button>{{\'cl.label.24\' | translate}}</a></li></ul></header><div class=\"panel-body noPad\" ui-selectable-drag-drop><img alt=loading class=pad10 src=assets/images/loading.gif ng-if=dataLoading><div ng-if=!dataLoading ui-view=tabView></div></div></section>");
$templateCache.put("app/contentLibrary/ev.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><section class=\"panel noMar\" ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><div class=\"panel-body pad15\"><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><div ng-if=!contentLoading><div class=row><div class=col-xs-7><!-- This is previous code which we using currently --><div class=form-group><label for=ciLabel>{{\'cl.label.4\' | translate}}</label><input type=text class=form-control ng-model=contentInfo.label id=ciLabel aria-label=ciLabel aria-labelledby=ciLabel></div><div class=row><div class=col-xs-6><div class=form-group><label for=ciStart>{{\'cm.label.12\' | translate}}</label><input type=text class=form-control ng-model=contentInfo.start min=1 ui-mask=99:99:99 placeholder=HH:mm:ss id=ciStart aria-label=ciStart aria-labelledby=ciStart></div></div><div class=col-xs-6><div class=form-group><label for=ciEnd>{{\'cm.label.13\' | translate}}</label><input type=text class=form-control ng-model=contentInfo.end min=1 ui-mask=99:99:99 placeholder=HH:mm:ss id=ciEnd aria-label=ciEnd aria-labelledby=ciEnd></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=ciW>{{\'cm.label.59\' | translate}}</label><input type=number class=form-control ng-model=contentInfo.w min=16 step=2 id=ciW aria-label=ciW aria-labelledby=ciW></div></div><div class=col-xs-6><div class=form-group><label for=ciH>{{\'cm.label.60\' | translate}}</label><input type=number class=form-control ng-model=contentInfo.h min=16 step=2 id=ciH aria-label=ciH aria-labelledby=ciH></div></div></div><div class=row><div class=\"col-xs-12 text-muted\">{{\'cl.p_cEdit.m1\' | translate}}</div></div></div><div class=\"col-xs-5 bg-black sticky\" style=top:65px><div class=\"col-xs-12 d-flex justify-center\"><video controls autoplay data-setup=\"{inactivityTimeout: 0}\" class=img-responsive style=background:#000><source ng-src=\"{{contentInfo.src | trustUrl}}\" type=video/mp4>Your browser does not support the HTML5 video.</video></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><span uib-tooltip={{tooltipMsg}} ng-if=\"selectedTab == \'hub.contentLibraryEditCapVid.ev\'\"><button type=button role=button class=\"btn btn-primary\" ng-click=\"saveVideoFx(\'new\');\" ng-disabled=\"saveProcessing || isNewPermission\"><span class=fa ng-class=\"newProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.btn.14\' | translate}}</button></span> <button type=button role=button ng-if=\"selectedTab == \'hub.contentLibraryEditCapVid.ev\'\" class=\"btn btn-default\" ng-click=\"saveVideoFx(\'replace\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"replaceProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.btn.15\' | translate}}</button> <button type=button role=button ng-if=\"selectedTab == \'hub.contentLibraryEditCapVid.ev\'\" class=\"btn btn-default\" ng-click=resetVidFx(); ng-disabled=saveProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button ng-if=\"selectedTab == \'hub.contentLibraryEditCapVid.vc\' && contentInfo.caption[selectedT].type == \'generate\'\" class=\"btn btn-success\" ng-click=\"replaceVidFx(\'generate\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cl.widget.queue.1b-i\':\'cl.widget.queue.1b\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m2\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'sNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m3\' | translate}}</div><div ng-if=\"errType==\'eNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m4\' | translate}}</div><div ng-if=\"errType==\'slNotValid\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div><div ng-if=\"errType==\'eslNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m5\' | translate}}</div><div ng-if=\"errType==\'elNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m6\' | translate}}</div><div ng-if=\"errType==\'width\'\" aria-live=polite role=status>{{\'cm.msg.32\' | translate:{value: \'16\'} }}</div><div ng-if=\"errType==\'height\'\" aria-live=polite role=status>{{\'cm.msg.33\' | translate:{value: \'16\'} }}</div><div ng-if=\"errType==\'oddWH\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m13\' | translate}}</div><div ng-if=\"errType==\'caption\'\" aria-live=polite role=status>{{\'cl.msg.21\' | translate}}</div><div ng-if=\"errType==\'captionTime\'\" aria-live=polite role=status>{{\'cl.msg.22\' | translate}}</div><div ng-if=\"errType==\'file\'\" aria-live=polite role=status>{{\'cl.msg.40\' | translate}}</div><div ng-if=\"errType==\'aBitrate\'\" aria-live=polite role=status>{{\'cl.e_vid.m19\' | translate}}</div></div><div class=clearfix></div></div></div></section>");
$templateCache.put("app/contentLibrary/uc.html","<img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div class=row ng-if=\"!contentLibraryLoading && contentList.length > 0\"><div class=col-lg-12><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.contentView == \'t\'\"><ng-content-list class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\" selectable-list=contentList></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.contentView == \'l\'\"><ng-content-list-view class=show selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=contentList></ng-content-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\"><p>{{\'cl.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'uc\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cl.tool.13\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=videoFx();><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'cl.msg.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/contentLibrary/vc.html","<section class=pad15><header class=\"panel-inner-tab noPadB\"><button type=button role=button class=\"btn btn-xs btn-primary pull-right marL10\" ng-click=openLanguageFx();>{{\'cl.btn.23\' | translate}}</button><!-- language tabs --><div id=custScroll class=\"d-flex overflow-x padB11\"><span ng-repeat=\"lang in contentInfo.caption\"><a href=\"\" role=link ng-class=\"{\'selected\':lang.isSel}\" data-id={{lang.id}} ng-model=lang.isSel ng-click=\"tabFx($index, lang);\">{{lang.label}}</a></span></div></header><div class=\"panel-body noPadB\"><div class=\"pad5 msg-warning marB10\" lang={{auth.lang}} ng-if=\"contentInfo.caption[selectedT].isCaptionProcessing && contentInfo.caption[selectedT].type==\'generate\'\">{{\'cl.msg.25\' | translate}}</div><label class=hide>{{\'cl.widget.cm.20\' | translate}}</label><div class=\"form-group hide\" role=radiogroup aria-labelledby=radiogroup><div class=\"pull-left marR5\"><label class=\"noMarB marR5\"><input type=radio role=radio name=capType ng-model=contentInfo.caption[selectedT].type ng-click=\"setSubTypeFx(contentInfo.caption[selectedT].type); getLanguages();\" value=import><label></label>{{\'cl.label.8\' | translate}}</label></div><label class=\"noMarB marR5\" ng-if=\"contentInfo.hasAudio && contentInfo.caption[selectedT].id == 23\"><input type=radio role=radio name=capType ng-model=contentInfo.caption[selectedT].type ng-click=setSubTypeFx(contentInfo.caption[selectedT].type); ng-disabled=\"contentInfo.caption[selectedT].isDef==0\" value=generate><label></label>{{\'cl.label.19\' | translate}}</label><label class=noMarB><input type=radio role=radio name=capType ng-model=contentInfo.caption[selectedT].type ng-click=setSubTypeFx(contentInfo.caption[selectedT].type); value=manual><label></label>{{\'cl.label.20\' | translate}}</label></div><div ng-if=\"contentInfo.caption[selectedT].type == \'import\'\" class=\"form-group hide\"><span class=\"btn btn-primary btn-file btn-xs bdrRd bdrRL8\">{{\"cl.btn.5\" | translate}} <input type=file file-model options=\"{format:[\'srt\'], callback:true}\" accept=.srt ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><span class=marL5><label><a class=text-sm href=https://s3-us-west-2.amazonaws.com/lsquared-hub/support/downloads/doc/CaptionSample.srt role=link target=_blank>{{\'cl.btn.21\' | translate}}</a></label></span></div><div ng-if=\"contentInfo.caption[selectedT].type == \'generate\' && contentInfo.hasAudio\" class=\"form-group padB20 hide\"><!--Hide for cPost & Nav--><div class=pull-left role=radiogroup aria-labelledby=radiogroup><span><label><input type=radio role=radio name=subType ng-model=contentInfo.caption[selectedT].subtype ng-change=resetImportFx() value=in-house><label></label>{{\'cl.label.11\' | translate}}</label></span><span class=\"bdrLd bdrRL8 bdrLR8 bdrRL8\"><label><input type=radio role=radio name=subType ng-model=contentInfo.caption[selectedT].subtype ng-change=resetImportFx() value=third-party><label></label>{{\'cl.label.12\' | translate}}</label></span></div><div class=clearFix></div></div><!-- Add new caption --><div class=row><div class=col-xs-6><label for=acText>{{\'cl.label.9\' | translate}}</label><input type=text class=form-control ng-model=addCaption.text id=acText aria-label=\"{{\'cl.label.9\' | translate}}\" aria-labelledby=\"{{\'cl.label.9\' | translate}}\"></div><div class=col-xs-2><label for=acBegin>{{\'cm.label.12\' | translate}}</label><input type=text class=form-control ng-model=addCaption.begin min=1 ui-mask=99:99:99 placeholder=hh:mm:ss id=acBegin aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=col-xs-2><label for=acEnd>{{\'cm.label.13\' | translate}}</label><input type=text class=form-control ng-model=addCaption.end min=1 ui-mask=99:99:99 placeholder=hh:mm:ss id=acEnd aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=col-xs-2><label>&nbsp;</label><div><button type=button role=button class=\"btn btn-success btn-block\" ng-click=addCaptionFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=\"col-xs-12 text-muted marT10\"><span ng-if=\"contentInfo.caption[selectedT].caption.length == 0\">{{\'cl.msg.20\' | translate}}</span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m2\' | translate}}</div><div ng-if=\"errType==\'caption\'\" aria-live=polite role=status>{{\'cl.msg.21\' | translate}}</div><div ng-if=\"errType==\'captionTime\'\" aria-live=polite role=status>{{\'cl.msg.22\' | translate}}</div><div ng-if=\"errType==\'sNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m3\' | translate}}</div><div ng-if=\"errType==\'eNotValid\'\" aria-live=polite role=status>{{\'cl.p_cEdit.m4\' | translate}}</div><div ng-if=\"errType==\'file\'\" aria-live=polite role=status>{{\'cl.msg.40\' | translate}}</div></div><div class=clearfix></div></div></div><div class=row><!-- action buttons --><div class=\"col-xs-12 text-right marB5\" ng-class=\"{\'marB10\': contentInfo.caption[selectedT].caption.length > 0}\" ng-if=!importProcessing><div class=\"bdrBtm marT15 marB15\"></div><button type=button role=button ng-if=\"contentInfo.caption[selectedT].caption.length > 0\" class=\"btn btn-default pad6 marL7\" ng-class=\"removeLength?\'text-danger\':\'text-muted\'\" ng-click=removeConfirm(); ng-disabled=\"removeLength==0\"><span class=\"fa fa-times marR5\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"contentInfo.caption[selectedT].caption.length > 0 && !isEdit\" class=\"btn btn-default text-primary pad6\" ng-click=\"captionFx(\'e\');\"><span class=\"fa fa-pencil marR5\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button class=\"btn btn-default text-primary pad6\" ng-click=\"captionFx(\'s\');\" ng-if=isEdit ng-disabled=saveCProcessing><span class=\"fa marR5\" ng-class=\"saveCProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default text-danger pad6\" ng-click=\"captionFx(\'c\');\" ng-if=isEdit><span class=\"fa fa-remove marR5\" aria-hidden=true></span>{{\'cm.btn.9\' | translate}}</button> <button type=button role=button ng-if=\"contentInfo.caption[selectedT].caption.length > 0\" ng-click=\"linkOpenFx(\'m\', detailBucket + contentInfo.caption[selectedT].captionSrc);\" class=\"btn btn-default text-primary pad6 marR10\"><span class=\"fa fa fa-download marR5\" aria-hidden=true></span>{{\'r.btn.4\' | translate}}</button><div class=btn-group uib-dropdown><input type=file id=myImport class=hide file-model options=\"{format:[\'srt\'], callback:true}\" accept=.srt ng-disabled=fileModelLoading> <button type=button role=button id=split-button class=\"btn btn-primary\" ng-click=importOpenFx();><span class=\"fa fa fa-upload marR5\" aria-hidden=true></span>{{\'cl.widget.cm.24\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=caret></span> <span class=sr-only>Split button!</span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu role=menu aria-labelledby=split-button><li role=menuitem><a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/support/downloads/doc/CaptionSample.srt role=link target=_blank class=\"text-primary pad5\">{{\'cl.btn.21\' | translate}}</a></li></ul></div><!-- Generate --><div ng-if=\"contentInfo.hasAudio && contentInfo.caption[selectedT].label == \'English\'\" class=\"btn-group generateBtn dropdown marL3\" uib-dropdown is-open=status.isopen><button type=button role=button id=gen-button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=disabled>{{\'cl.widget.queue.1b\' | translate}} <span class=caret></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu role=menu aria-labelledby=gen-button><li ng-class=\"{\'selected\': contentInfo.caption[selectedT].subtype == \'in-house\'}\" role=menuitem><a href=\"\" role=link ng-click=\"setSubTypeFx(\'in-house\');\">{{\'cl.label.11\' | translate}}</a></li><li ng-class=\"{\'selected\': contentInfo.caption[selectedT].subtype == \'third-party\'}\" role=menuitem><a href=\"\" role=link ng-click=\"setSubTypeFx(\'third-party\');\" class=\"text-primary pad5\">{{\'cl.label.12\' | translate}}</a></li></ul></div></div><div class=\"col-xs-12 pull-left marT15\" ng-if=importProcessing><img alt=Loading src=assets/images/loading.gif class=padB10></div><div ng-if=!importProcessing><!-- other selection --><div class=\"table table-scroll col-xs-12\" ng-if=\"contentInfo.caption[selectedT].caption.length > 0\"><div class=\"row th\"><div class=col-xs-8><label><input type=checkbox ng-model=isChecked.all ng-change=\"checkedFx(\'all\');\" role=checkbox><label></label>{{\'cl.label.10\' | translate}}</label></div><div class=col-xs-2>{{\'cm.label.12\' | translate}}</div><div class=col-xs-2>{{\'cm.label.13\' | translate}}</div></div><div class=overflow-auto style=max-height:{{getAvailableHeight(455)}}px><ul role=list><li class=\"row captionQuad\" role=listitem ng-repeat=\"caption in contentInfo.caption[selectedT].caption\" data-begin={{caption.begin}} data-end={{caption.end}}><div class=\"col-xs-8 codeQuad\"><label class=text-unbold ng-show=!caption.show tooltip-popup-delay=1000 tooltip-append-to-body=true><input type=checkbox ng-model=caption.isChecked ng-change=checkedFx(); role=checkbox><label></label><span class=codeText>{{caption.text}}</span></label><input type=text class=\"form-control input-sm\" ng-show=caption.show value={{caption.text}} ng-keyup=inputCallbackFx($event); ng-blur=inputCallbackFx($event); maxlength=500 id=cText-{{$index}} aria-label=cText-{{$index}} aria-labelledby=cText-{{$index}}></div><div class=col-xs-2>{{caption.begin}}</div><div class=col-xs-2>{{caption.end}}</div></li></ul></div></div></div></div></div></section>");
$templateCache.put("app/contentLibrary/vidAIIndexer.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><div class=pageHeading><div ng-if=\"insightsData.breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=openContentFolderFx(insightsData.id,0);>{{\'cm.menu.1\' | translate}}</a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in insightsData.breadCrumbs\"><a href=\"\" role=link ng-click=openContentFolderFx(insightsData.id,breadcrumb.id,insightsData.splId,insightsData.splType,insightsData.gid,insightsData.gType);>{{breadcrumb.label}}</a> <span class=slash-icon ng-if=$last>/ <span class=\"marL10 marR10\">{{\'cl.tool.7\' | translate}} <span class=text-muted>[ {{insightsData.label}} ]</span></span></span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=!insightsData.breadCrumbs.length><a href=\"\" role=link class=marR10 ng-click=openContentFolderFx(insightsData.id,insightsData.folderid);>{{\'cm.menu.1\' | translate}}</a>/<!-- <a href=\"\" role=\"link\" class=\"marR10\" ui-sref=\"hub.contentLibrary.c\">{{\'cm.menu.1\' | translate}}</a>/ --> <span class=\"marL10 marR10\">{{\'cl.tool.7\' | translate}} <span class=text-muted>[ {{insightsData.label}} ]</span></span></div><!-- <a href=\"\" role=\"link\" class=\"marR10\" ui-sref=\"hub.contentLibrary.c\">{{\'cm.menu.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'cl.vi.4\' | translate}}</span>/\r\n  <span class=\"marL10 marR10\">{{\'cl.tool.7\' | translate}} <span class=\"text-muted\">[ {{insightsData.label}} ]</span></span> --></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=\"panel-heading noPad\"><h1 role=heading aria-level=1 class=\"padT15 padB15 padL15\"><span>{{\'cl.vi.4\' | translate}}</span></h1><div class=\"panel-tools noBdr\"><div class=pull-right><a href=\"\" class=crossBtn role=link ng-click=openContentFolderFx(insightsData.id,insightsData.folderid); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a><!-- <a href=\"\" class=\"crossBtn\" role=\"link\" ui-sref=\"hub.contentLibrary.c\" uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=\"true\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span></a> --></div><!-- <div class=\"pull-right\" ng-show=\"selectedT == \'2\' && insightsData.insight.transcript && insightsData.insight.transcript.length\">\r\n        <a href=\"\" class=\"crossBtn\" role=\"link\" ng-click=\"ccEditFx(ccEdit)\"  uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=\"true\">\r\n          <span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>\r\n        </a>\r\n      </div> --></div><div class=clearfix></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=\"bg-black text-center\"><video id=videoElement crossorigin=anonymous controls muted data-setup=\"{inactivityTimeout: 0}\" controlslist=nodownload class=\"img-responsive vidElm\"><source ng-src=\"{{ insightsData.bucket + insightsData.url | trustUrl}}\" type=video/mp4><track ng-src=\"{{ insightsData.bucket + insightsData.vtt | trustUrl}}\" kind=subtitles srclang=en label=On default ng-if=insightsData.hasTranscript><!-- <track src=\"assets/images/caption.vtt\" kind=\"subtitles\" srclang=\"en\" label=\"{{selectedLang.name}}\"> --> Your browser does not support the HTML5 video.</video></div><div class=\"text-bold vidLabel\">{{insightsData.label}}<div class=\"text-sm text-muted d-flex hide\"><span class=marR5>{{\'cl.brief.8\' | translate}}:</span><div ng-if=\"insightsData.breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=openContentFolderFx(insightsData.id,0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in insightsData.breadCrumbs\"><a href=\"\" role=link ng-click=openContentFolderFx(insightsData.id,breadcrumb.id,insightsData.splId,insightsData.splType,insightsData.gid,insightsData.gType);>{{breadcrumb.label}}</a> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><!-- <a href=\"\" role=\"link\" class=\"marR10\" ui-sref=\"hub.contentLibrary.c\"><span class=\"glyphicon glyphicon-home marR5\" aria-hidden=\"true\"></span>{{insightsData.path}}</a> --></div></div></div><div class=col-xs-6><header class=\"panel-inner-tab viHeader noPadB\"><div class=row><div class=col-xs-5 style=\"height: 32px\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabChangeFx(1);searchText.txt=\'\';\">{{\'cl.vi.5\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabChangeFx(2);searchText.txt=\'\';\">{{\'cl.vi.6\' | translate}}</a></div><div class=\"col-xs-7 text-right d-flex justify-end\" ng-show=\"selectedT == \'2\' && insightsData.hasTranscript\"><div class=select-lang><div><ul class=\"ulList noMar\" role=navigation aria-labelledby=nList><li class=dropdown uib-dropdown auto-close=outsideClick is-open=lang.isOpen><!-- <a href=\"#\" role=\"button\" class=\"dropdown-toggle\" uib-dropdown-toggle ng-click=\"serverSearchFocus();searchSList.text=\'\'\"><span class=\"serverName\">{{selectedLang.name}}</span> <span class=\"caret\"></span></a> --> <a href=# role=button class=dropdown-toggle uib-dropdown-toggle ng-click=\"serverSearchFocus();searchSList.text=\'\'\"><span>{{\'cl.vi.24\' | translate}}</span> <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=sList><li class=\"dropdown-header padLR10\" ng-show=\"langSupport.length > 5\"><div class=\"searchTbx input-xs\"><input type=text title=search class=form-control id=searchSList ng-model=searchSList.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href role=button aria-label=searchSList.text class=text-danger ng-show=searchSList.text.length ng-click=\"searchSList.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><div class=addLang ng-if=filteredLangAddedList.length>{{\'cl.vi.22\' | translate}}</div><li ng-repeat=\"addList in filteredLangAddedList = (addedLang | filter:searchSList.text) | orderBy: \'name\'\" tabindex=$index ng-class=\"{\'selected\': addList.name == selectedLang.name}\"><span ng-click=\"lang.isOpen = false;addLangFx(addList);\" ng-if=\"addList.languageCode != selectedLang.languageCode\">{{addList.name}}</span> <span ng-if=\"addList.languageCode == selectedLang.languageCode\">{{addList.name}}</span></li><div class=addedLang ng-if=filteredLangAvailableList.length>{{addedLang.length?\'cl.vi.23\':\'cl.vi.21\' | translate}}</div><li ng-repeat=\"availList in filteredLangAvailableList = (notAddedLang | filter:searchSList.text) | orderBy: \'name\'\" tabindex=$index ng-class=\"{\'selected\': availList.name == selectedLang.name}\"><span ng-click=\"lang.isOpen = false;addLangFx(availList);\" ng-if=\"availList.languageCode != selectedLang.languageCode\">{{availList.name}}</span> <span ng-if=\"availList.languageCode == selectedLang.languageCode\">{{availList.name}}</span></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredLangAddedList.length == 0 && filteredLangAvailableList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchSList.text)}}&quot;</b>\'}\"></div></div></ul></li></ul></div></div><div class=searchTbx><input type=text class=form-control ng-model=searchText.txt sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off maxlength=250> <a href=\"\" role=link class=text-danger ng-show=searchText.txt.length ng-click=\"searchText.txt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></header><div class=\"viRsection padT15\"><!-- <div class=\"viSearch\">\r\n            <span class=\"fa fa-search icon\"></span>\r\n            <input id=\"searchBox\" type=\"text\" placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-model=\"searchText\" autocomplete=\"off\" maxlength=\"250\">\r\n            <a href=\"\" role=\"link\" class=\"text-danger\" ng-show=\"searchText.length\" ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n          </div> --><div class=scrollQuad ng-if=\"selectedT == \'1\'\" ng-attr-style=height:{{getAvailableHeight(340)}}px;><!-- Detected objects --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.detectedObjects.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.detectedObjects.length}} {{ insightsData.insight.detectedObjects.length > 1 ?\'cl.vi.9.1\':\'cl.vi.9\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viDthObj insightsBtn\" ng-repeat=\"do in insightsData.insight.detectedObjects\" ng-class=\"{\'selected\': do.type == curData.detectedObjects.type}\" ng-click=\"getInstancesFx(\'detectedObjects\', do, false)\">{{do.displayName}}</div></div><div class=\"d-flex d-flex-wrap marB20\"><div class=viDthObjImg ng-repeat=\"thm in curData.detectedObjects.thumbArr\" ng-class=\"{\'selectedDth\': thm.thumbnailId == curData.selDetectedObjects.thumbnailId}\" ng-click=\"getInstancesFx(\'detectedObjects\', thm, true)\"><img class=viDo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{thm.thumbnailId}}&h=60&w=90&q=80&zc=3\"><!-- <div class=\"viDo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{thm.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div><div class=\"d-flex align-items-center marB20\"><div class=marR15><img class=viSelDthObjImg alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{curData.selDetectedObjects.thumbnailId}}&h=120&w=180&q=80&zc=3\"><!-- <div class=\"viSelDthObjImg\" style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{curData.selDetectedObjects.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div><div><div style=\"font-weight: 600\">{{curData.detectedObjects.displayName}}</div><!-- <div class=\"text-muted\">Appears in {{curData.selDetectedObjects.pc}}% of video</div> --></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.selDetectedObjects.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.selDetectedObjects.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.selDetectedObjects, \'p\', curData.selDetectedObjects.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.selDetectedObjects.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.selDetectedObjects, \'n\', curData.selDetectedObjects.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- People --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.faces.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.faces.length}} {{\'cl.vi.10\' | translate}}</label><div class=\"d-flex marB20\"><div class=viPeoples ng-repeat=\"p in insightsData.insight.faces\" ng-class=\"{\'selected\': p.id == curData.faces.id}\" ng-click=\"getInstancesFx(\'faces\', p, true)\"><img class=viLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{p.thumbnailId}}&h=60&w=90&q=80&zc=3\"><!-- <div class=\"viLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{p.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div><div class=\"d-flex align-items-center marB20\"><div class=marR15><img class=viSelLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{curData.faces.thumbnailId}}&h=120&w=180&q=80&zc=3\"><!-- <div class=\"viSelLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{curData.faces.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div><div><div style=\"font-weight: 600\">{{curData.faces.name}}</div><div class=text-muted ng-if=curData.faces.pc>Appears in {{curData.faces.pc}}% of video</div></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.faces.instances\" style=\"height: 100%; position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span class=cursorPointer ng-click=\"playFx(curData.faces, \'p\')\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span class=cursorPointer ng-click=\"playFx(curData.faces, \'n\')\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Observed person --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.observedPeople.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.observedPeople.length}} {{ insightsData.insight.observedPeople.length > 1 ?\'cl.vi.11.1\':\'cl.vi.11\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=viObsPeoples ng-repeat=\"obsP in insightsData.insight.observedPeople\" ng-class=\"{\'selectedObsP\': obsP.id == curData.observedPeople.id}\" ng-click=\"getInstancesFx(\'observedPeople\', obsP, true)\"><img class=viObsLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{obsP.thumbnailId}}&h=60&w=90&q=80&zc=3\"><!-- <div class=\"viObsLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{obsP.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div><div class=\"d-flex align-items-center marB20\"><div class=marR15><img class=viObsSelLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{curData.observedPeople.thumbnailId}}&h=120&w=180&q=80&zc=3\"><!-- <div class=\"viObsSelLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{curData.observedPeople.thumbnailId}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div><div><div class=text-muted ng-if=curData.observedPeople.pc>Appears in {{curData.observedPeople.pc}}% of video</div><span ng-repeat=\"cloth in curData.observedPeople.clothing\">{{cloth.properties.length}} {{cloth.type}}<span ng-if=!$last class=ng-scope> -</span></span></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.observedPeople.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.observedPeople.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.observedPeople, \'p\', curData.observedPeople.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.observedPeople.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.observedPeople, \'n\', curData.observedPeople.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Topics --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.topics.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.topics.length}} {{ insightsData.insight.topics.length > 1 ?\'cl.vi.12.1\':\'cl.vi.12\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viKeywords insightsBtn\" ng-repeat=\"top in insightsData.insight.topics\" ng-class=\"{\'selected\': top.id == curData.topics.id}\" ng-click=\"getInstancesFx(\'topics\', top, true)\">{{top.name}}</div></div><div class=\"marB20 hide\"><div class=viTopics ng-repeat=\"top in insightsData.insight.topics\" ng-click=\"getInstancesFx(\'topics\', top, true)\" ng-if=top.referenceId.split(top.name)[0].length>{{top.referenceId.split(top.name)[0]}} <span ng-class=\"{\'selected\': top.id == curData.topics.id}\">{{top.name}}</span></div><div class=\"viTopics d-flex d-flex-wrap\" ng-repeat=\"top in insightsData.insight.topics\" ng-click=\"getInstancesFx(\'topics\', top, true)\" ng-if=!top.referenceId.split(top.name)[0].length><span class=\"marR5 marB5\" ng-class=\"{\'selected\': top.id == curData.topics.id}\">{{top.name}}</span></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.topics.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.topics.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.topics, \'p\', curData.topics.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.topics.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.topics, \'n\', curData.topics.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Keywords --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.keywords.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.keywords.length}} {{ insightsData.insight.keywords.length > 1 ?\'cl.vi.13.1\':\'cl.vi.13\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viKeywords insightsBtn\" ng-repeat=\"kw in insightsData.insight.keywords\" ng-class=\"{\'selected\': kw.id == curData.keywords.id}\" ng-click=\"getInstancesFx(\'keywords\', kw, true)\">{{kw.text}}</div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.keywords.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.keywords.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.keywords, \'p\', curData.keywords.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.keywords.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.keywords, \'n\', curData.keywords.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Label --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.labels.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.labels.length}} {{ insightsData.insight.labels.length > 1 ?\'cl.vi.14.1\':\'cl.vi.14\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viLabels insightsBtn\" ng-repeat=\"lb in insightsData.insight.labels\" ng-class=\"{\'selected\': lb.id == curData.labels.id}\" ng-click=\"getInstancesFx(\'labels\', lb, true)\">{{lb.name}}</div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.labels.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.labels.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.labels, \'p\', curData.labels.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.labels.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.labels, \'n\', curData.labels.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Named entities --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=\"insightsData.insight.namedLocations.length || insightsData.insight.namedPeople.length || insightsData.insight.brands.length\"><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=namedEntity>{{insightsData.insight.namedLocations.length + insightsData.insight.namedPeople.length + insightsData.insight.brands.length}} {{ \'cl.vi.15\' | translate}}</label><div class=marB20 ng-if=insightsData.insight.namedLocations.length><label class=\"marB10 noMarT\" for=location>{{insightsData.insight.namedLocations.length}} {{ insightsData.insight.namedLocations.length > 1 ?\'cl.vi.16.1\':\'cl.vi.16\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viLabels insightsBtn\" ng-repeat=\"nl in insightsData.insight.namedLocations\" ng-class=\"{\'selected\': nl.id == curData.nEntities.id && nl.name == curData.nEntities.name}\" ng-click=\"getInstancesFx(\'namedLocations\', nl, true)\">{{nl.name}}</div></div></div><div class=marB20 ng-if=insightsData.insight.namedPeople.length><label class=\"marB10 noMarT\" for=location>{{insightsData.insight.namedPeople.length}} {{ \'cl.vi.10\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viLabels insightsBtn\" ng-repeat=\"np in insightsData.insight.namedPeople\" ng-class=\"{\'selected\': np.id == curData.nEntities.id && np.name == curData.nEntities.name}\" ng-click=\"getInstancesFx(\'namedPeople\', np, true)\">{{np.name}}</div></div></div><div class=marB20 ng-if=insightsData.insight.brands.length><label class=\"marB10 noMarT\" for=location>{{insightsData.insight.brands.length}} {{ insightsData.insight.brands.length > 1 ?\'cl.vi.17.1\':\'cl.vi.17\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=\"viLabels insightsBtn\" ng-repeat=\"br in insightsData.insight.brands\" ng-class=\"{\'selected\': br.id == curData.nEntities.id && br.name == curData.nEntities.name}\" ng-click=\"getInstancesFx(\'brands\', br, true)\">{{br.name}}</div></div><div class=\"d-flex d-flex-wrap marB20\">Description of the brand</div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span class=instance ng-repeat=\"instance in curData.nEntities.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.nEntities.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.nEntities, \'p\', curData.nEntities.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.nEntities.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(curData.nEntities, \'n\', curData.nEntities.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Emotions --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.emotions.type.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.emotions.type.length}} {{ insightsData.insight.emotions.type.length > 1 ?\'cl.vi.18.1\':\'cl.vi.18\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=viPoints ng-repeat=\"em in insightsData.insight.emotions.type\"><span class=\"d-flex align-items-center\" ng-style=\"{\'color\': em.name ==\'Joy\'? \'#12866e\': em.name ==\'Anger\' ? \'#eb001b\' : \'#213bd1\'}\"><span class=points ng-style=\"{\'background-color\': em.name ==\'Joy\'? \'#12866e\': em.name ==\'Anger\' ? \'#eb001b\' : \'#213bd1\'}\"></span>{{em.name}}<span ng-if=em.pc class=marL5>{{em.pc}}%</span></span></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span ng-repeat=\"instance in insightsData.insight.emotions.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\', \'background-color\': instance.type ==\'Joy\'? \'#12866e\': instance.type ==\'Anger\' ? \'#eb001b\' : \'#213bd1\'}\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.emotions.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(insightsData.insight.emotions, \'p\', curData.emotions.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.emotions.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(insightsData.insight.emotions, \'n\', curData.emotions.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Sentiments --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.sentiments.type.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.sentiments.type.length}} {{ insightsData.insight.sentiments.type.length > 1 ?\'cl.vi.19.1\':\'cl.vi.19\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=viPoints ng-repeat=\"snm in insightsData.insight.sentiments.type\" ng-if=\"snm.name ==\'Positive\' || snm.name ==\'Negative\'\"><span class=\"d-flex align-items-center\" ng-style=\"{\'color\': snm.name ==\'Positive\'? \'#12866e\': snm.name ==\'Negative\' ? \'#eb001b\' : \'\'}\"><span class=points ng-style=\"{\'background-color\': snm.name ==\'Positive\'? \'#12866e\': snm.name ==\'Negative\' ? \'#eb001b\' : \'\'}\"></span>{{snm.name}}<span ng-if=snm.pc class=marL5>{{snm.pc}}%</span></span></div></div><div class=\"videoBar marB20\"><div class=\"video-timeline d-flex\" ng-mousemove=showTimeTooltip($event) ng-mouseleave=hideTimeTooltip() ng-click=seekVideo($event)><span ng-repeat=\"instance in insightsData.insight.sentiments.instances\" style=\"height: 100%;position: absolute\" ng-style=\"{\'width\': instance.width + \'%\',\'left\': instance.left + \'%\', \'background-color\': instance.type ==\'Positive\'? \'#12866e\': instance.type ==\'Negative\' ? \'#eb001b\' : \'\'}\" ng-if=\"instance.type ==\'Positive\' || instance.type ==\'Negative\'\"></span><div class=viTooltip></div></div><div class=\"timeline d-flex align-items-center viTimline\"><div class=progressBar></div><div class=playPointer></div></div></div><div class=\"d-flex marB20\" style=\"justify-content: space-between\"><span ng-class=\"!curData.sentiments.prv? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(insightsData.insight.sentiments, \'p\', curData.sentiments.prv)\"><span class=\"fa fa-angle-double-left marR5\"></span>{{\'cl.vi.7\' | translate}}</span> <span ng-class=\"!curData.sentiments.nxt? \'cursorDisabled\' : \'cursorPointer\'\" ng-click=\"playFx(insightsData.insight.sentiments, \'n\', curData.sentiments.nxt)\">{{\'cl.vi.8\' | translate}}<span class=\"fa fa-angle-double-right marL5\"></span></span></div></div></div><!-- Scenes --><div class=\"form-group row noMarL noMarR marB20 viSection\" ng-if=insightsData.insight.scenes.length><div class=\"col-xs-12 padL15\"><label class=\"text-bold text-16 marB10 noMarT\" for=people>{{insightsData.insight.scenes.length}} {{ insightsData.insight.scenes.length > 1 ?\'cl.vi.20.1\':\'cl.vi.20\' | translate}}</label><div class=\"d-flex d-flex-wrap marB20\"><div class=viScenes ng-repeat=\"sns in insightsData.insight.scenes\" ng-class=\"{\'selectedSns\': sns.id == curData.scenes.id}\" ng-click=getShotsFx(sns) uib-tooltip=\"{{sns.instances[0].start}} - {{sns.instances[0].end}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><img class=viSnsLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{sns.url}}&h=120&w=180&q=80&zc=3\"><!-- <div class=\"viSnsLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{sns.url}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div><div class=marB20 ng-if=curData.shots.length><label for=shots>{{curData.shots.length}} shots in this scene</label><div class=\"d-flex d-flex-wrap\"><div class=viShots ng-repeat=\"sh in curData.shots\" ng-class=\"{\'selectedSh\': sh.id == curData.shots.id}\" ng-click=getKeyFrameFx(sh) uib-tooltip=\"{{sh.instances[0].start}} - {{sh.instances[0].end}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><img class=viShLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{sh.url}}&h=60&w=90&q=80&zc=3\"><!-- <div class=\"viShLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{sh.url}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div></div><div class=marB20 ng-if=curData.keyFrames.length><label for=keyframes>{{curData.keyFrames.length}} keyframes in this shot</label><div class=\"d-flex d-flex-wrap\"><div class=vikeyFrames ng-repeat=\"kf in curData.keyFrames\" uib-tooltip=\"{{kf.instances[0].start}} - {{kf.instances[0].end}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><img class=viKfLogo alt=img ng-src=\"{{insightsData.timthumb}}{{insightsData.bucket}}{{kf.url}}&h=30&w=45&q=80&zc=3\"><!-- <div class=\"viKfLogo\"  style=\"background-image: url({{insightsData.timthumb}}{{insightsData.bucket}}{{kf.url}}&h=60&w=90&q=80&zc=3);background-position:center;\"></div> --></div></div></div></div></div></div><div ng-if=\"selectedT == \'2\'\"><img class=marL10 alt=Loading src=assets/images/loading.gif ng-if=loadInsights><div class=\"form-group row noMarL noMarR marB20\" ng-if=!loadInsights><div ng-if=ccAdd class=\"col-xs-12 padTB10 viTranscript ccAdd marL5\"><div class=\"form-group pull-left marB10 marR20 d-flex align-items-center\"><label for=\"\">{{\'d.p_h.1\' | translate}}:</label><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"ccAddObj.start\" time-format placeholder=\"00:00:00.00\"> --> <input type=text class=\"form-control input-sm marL10\" ng-model=ccAddObj.st min=1 ui-mask=99:99:99.999 placeholder=HH:MM:SS.mmm></div><div class=\"form-group pull-left marB10 d-flex align-items-center\"><label for=\"\">{{\'d.p_h.2\' | translate}}:</label><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"ccAddObj.end\" time-format placeholder=\"00:00:00.00\"> --> <input type=text class=\"form-control input-sm marL10\" ng-model=ccAddObj.et min=1 ui-mask=99:99:99.999 placeholder=HH:MM:SS.mmm></div><div class=form-group><textarea name=ccLabel class=\"form-control input-sm\" ng-model=ccAddObj.txt autocomplete=off style=\"resize: vertical\"></textarea></div><div class=marT10><button type=submit role=button class=\"btn btn-success btn-xs marR2\" ng-click=\"addCCFx(ccAddObj, $event);\" ng-disabled=updateProcessing><span class=\"fa fa-check\" ng-class=\"updateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{updateProcessing?\'cm.btn.19i\':\'cm.btn.19\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-xs marR2\" ng-click=resetAddDetails(); ng-disabled=updateProcessing>{{\'cm.btn.34\' | translate}}</button> <button type=submit role=button class=\"btn btn-link btn-xs\" ng-click=cancelCCFx(); ng-disabled=updateProcessing>{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right text-sm\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType == \'sTime\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType == \'eTime\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType == \'validTime\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div><div ng-if=\"errType == \'validDuration\'\" aria-live=polite role=status>{{\'cl.vi.m4\' | translate}}</div><div ng-if=\"errType == \'text\'\" aria-live=polite role=status>{{\'cl.vi.m3\' | translate}}</div></div></div></div><div class=\"col-xs-12 padL15 scrollQuad\" ng-attr-style=\"height:{{getAvailableHeight(ccAdd ? 500 :360)}}px;\" id=captionContainer><div class=closedCaptionList ng-repeat=\"tl in filterTrans = (insightsData.insight.transcript | filter:searchText.txt)\" ng-click=timelineFx(tl) data-stime={{timeToSeconds(tl.st)}}><div class=\"padTB10 d-flex align-items-center viTranscript\" ng-if=\"editMoreId != tl.id\"><div class=\"text-ellipsis padL5\" style=\"width: 85px\" uib-tooltip={{tl.st}} tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"text-sm ccStartTime padLR2\">{{tl.st}}</span></div><div style=\"width: 80%\"><span class=text>{{tl.txt}}</span></div><div class=\"text-right action noPadL padR10\" style=\"width: 80px\"><span class=\"fa fa-plus-circle text-primary cursorPointer marR10\" ng-click=addDetails(); uib-tooltip=\"{{\'cm.btn.19\' | translate}}\" tooltip-append-to-body=true></span> <span class=\"fa fa-pencil text-primary cursorPointer marR10\" ng-click=editDetails(tl); uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true></span> <span class=\"fa fa-trash text-danger cursorPointer\" ng-click=\"removeCCFx(tl, $event);\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true></span></div></div><div ng-if=\"ccEdit && editMoreId == tl.id && editMore\" class=\"pad10 viTranscript bdrB ccEdit\" ng-click=$event.stopPropagation()><div class=\"form-group pull-left marB10 marR20 d-flex align-items-center\"><label for=\"\">{{\'d.p_h.1\' | translate}}:</label><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"tl.st\"> --><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"tl.st\" time-format placeholder=\"00:00:00.00\"> --> <input type=text class=\"form-control input-sm marL10\" ng-model=tl.st min=1 ui-mask=99:99:99.999 placeholder=HH:MM:SS.mmm></div><div class=\"form-group pull-left marB10 d-flex align-items-center\"><label for=\"\">{{\'d.p_h.2\' | translate}}:</label><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"tl.et\"> --><!-- <input type=\"text\" class=\"form-control input-sm marL10\" ng-model=\"tl.et\" time-format placeholder=\"00:00:00.00\"> --> <input type=text class=\"form-control input-sm marL10\" ng-model=tl.et min=1 ui-mask=99:99:99.999 placeholder=HH:MM:SS.mmm></div><div class=form-group><textarea name=ccLabel id={{tl.id}} class=\"form-control input-sm\" ng-model=tl.txt autocomplete=off style=\"resize: vertical\"></textarea></div><div class=marT10><button type=submit role=button class=\"btn btn-success btn-xs marR2\" ng-click=\"updateCCFx(tl, $event);\" ng-disabled=updateProcessing><span class=\"fa fa-check\" ng-class=\"updateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{updateProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=submit role=button class=\"btn btn-link btn-xs\" ng-click=cancelCCFx(); ng-disabled=updateProcessing>{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right text-sm\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType == \'sTime\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType == \'eTime\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType == \'validTime\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div><div ng-if=\"errType == \'validDuration\'\" aria-live=polite role=status>{{\'cl.vi.m4\' | translate}}</div><div ng-if=\"errType == \'text\'\" aria-live=polite role=status>{{\'cl.vi.m3\' | translate}}</div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!insightsData.insight.transcript || !insightsData.insight.transcript.length\">{{\'cl.vi.25\' | translate}}</div><div class=\"row msg-warning\" lang={{auth.lang}} ng-if=\"filterTrans.length == 0 && insightsData.insight.transcript.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.txt)}}&quot;</b>\'}\"></div></div></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><!-- <button type=\"submit\" role=\"button\" class=\"btn btn-default\" ng-if=\"ccEdit\" ng-click=\"saveccFx(\'cc\', \'s\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=\"fa fa-check\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=\"true\"></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button>\r\n      <button type=\"submit\" role=\"button\" class=\"btn btn-success\" ng-if=\"ccEdit\" ng-click=\"saveccFx(\'cc\', \'sc\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=\"fa fa-check\" ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=\"true\"></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.8\' | translate}}</button> --><!-- <button type=\"button\" role=\"button\" class=\"btn btn-default\" ui-sref=\"hub.contentLibrary.c\">{{\'cm.btn.10\' | translate}}</button> --> <button type=button role=button class=\"btn btn-default\" ng-click=openContentFolderFx(insightsData.id,insightsData.folderid);>{{\'cm.btn.10\' | translate}}</button> <button type=button role=button class=\"btn btn-link hide\" ng-click=getVIndexer(); ng-disabled=detailLoading>{{\'cl.vi.3\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/cpLogin/dashboard.html","CP Dashboard<div class=row><div class=col-lg-4>&nbsp;</div><div class=col-lg-6><div class=input-group><input type=text class=form-control ng-model=apiPath> <span class=input-group-btn><button type=button role=button class=\"btn btn-default\" ng-click=apiFx();>Go!</button></span></div></div><div class=col-lg-12>{{apiResponse | json}}</div></div><hr><div class=row><div class=col-lg-4>&nbsp;</div><div class=col-lg-6><div class=input-group><input type=text class=form-control ng-model=apiPostPath> <span class=input-group-btn><button type=button role=button class=\"btn btn-default\" ng-click=apiPostFx();>Go!</button></span></div></div></div><div class=row><div class=col-lg-4>&nbsp;</div><div class=col-lg-6><div class=form-group><textarea class=form-control ng-model=apiPostData></textarea></div></div><div class=col-lg-12>{{apiPostResponse | json}}</div></div>");
$templateCache.put("app/cpLogin/login.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><form method=post name=loginForm><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'auth\'\" aria-live=polite role=status>Email or Password were not recognized. Please check and try again.</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>Please provide both Email and Password.</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>Oops! Something went wrong. Please try again later. You can report this issue to<br>L Squared Support by <a href=\"\" role=link>clicking here</a>.</div></div><div class=form-group><label>Email</label><input type=email ng-model=credentials.email class=form-control placeholder=Email focus-me=true></div><div class=form-group><label>Password</label><input type=password ng-model=credentials.pass class=form-control placeholder=Password></div><button type=button role=button ng-click=authenticate(); class=\"btn btn-primary marR5\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-sign-in\" ng-if=!authProcessing aria-hidden=true></span>Sign In</button> <a href=\"\" role=link ui-sref=forgotPassword class=\"btn btn-link\">Forgot Password?</a></div></form></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=/doc/terms.pdf role=link target=_blank>Terms &amp; Conditions</a> | <a href=/doc/Privacy_Policy.pdf role=link target=_blank>Privacy Policy</a></footer>");
$templateCache.put("app/creativeServices/cmp.html","<img alt=Loading src=assets/images/loading.gif ng-if=creativeSrvLoading><div class=\"table table-md dTable\" role=table ng-if=!creativeSrvLoading><div ng-if=\"creativeSrv.length > 0 && filterCount > 0\"><div class=\"row th\" ng-if=\"(creativeSrv | filter:searchText).length > 0\"><div class=col-xs-1>{{\'cm.label.80\' | translate}}</div><div class=col-xs-5>{{\'cm.label.23\' | translate}}</div><div class=col-xs-2>{{\'cs.body.1\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cs.body.2\' | translate | camelCase}}</div><div class=\"col-xs-2 text-right\">{{\'cs.body.3\' | translate}}</div></div><ul><li class=row ng-repeat=\"cmp in creativeSrv | filter:searchText\" ng-if=\"filter == \'all\' || (filter == \'c\' && cmp.type == \'c\') || (filter == \'t\' && cmp.type == \'t\')\"><div class=col-xs-1><a href=\"\" role=link ng-click=editFx(cmp.id); class=text-primary>LSCS{{cmp.id + cmp.type}}</a></div><div class=\"col-xs-5 text-ellipsis\"><a href=\"\" role=link ng-click=editFx(cmp.id); class=text-primary>{{cmp.title}}</a></div><div class=\"col-xs-2 text-ellipsis\">{{cmp.createdBy}}</div><div class=col-xs-2>{{(cmp.createdOn * 1000) | date:\"mediumDate\"}}</div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-xs btn-primary\" ng-if=\"cmp.status == 8\" ng-click=openInvoiceFx(cmp.id);>{{\'cs.btn.3\' | translate}}</button> <span class=text-muted ng-if=\"cmp.status == 5\">{{\'cs.body.16\' | translate}}</span> <span class=text-muted ng-if=\"cmp.status == 9\">{{\'cs.body.7\' | translate}}</span></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(creativeSrv | filter:searchText).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"creativeSrv.length > 0 && filterCount == 0\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!creativeSrvLoading && creativeSrv.length == 0\"><p>{{\'cs.msg.2\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=readMeFx();><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cs.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/creativeServices/creativeServices.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><button type=button role=button class=\"btn btn-primary\" ui-sref=hub.cContainer.csAdd ng-if=\"!auth.uType == 0 || !auth.uType == 1\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cs.btn.1\' | translate}}</button></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=cSearch class=lableHidden>device</label><div class=\"input-group1 searchTbx\"><input type=text class=form-control id=cSearch ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=\"input-group-btn hide\" uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-caret-down noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ui-sref=hub.advancedSearch>Advanced search</a></li></ul></span></div></div></div><div>&nbsp;</div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs cs\" role=tablist aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab><a ui-sref=.cur role=button>{{\'cs.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab><a ui-sref=.cmp role=button>{{\'cs.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab><a ui-sref=.inv role=button>{{\'cs.tab.3\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right uib-dropdown ng-if=\"selectedTab == \'hub.creativeServices.cur\'\"><a href=\"\" role=link aria-label=filter1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.label.69\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\':filter==\'c\'}\"><a href=\"\" role=link ng-click=\"filterFx(\'c\');\">{{\'cm.label.1\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==\'t\'}\"><a href=\"\" role=link ng-click=\"filterFx(\'t\');\">{{\'cm.label.2\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem class=dropdown-header>{{\'cm.label.46\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\':filter==1}\"><a href=\"\" role=link ng-click=filterFx(1);>{{\'cs.body.8\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==2}\"><a href=\"\" role=link ng-click=filterFx(2);>{{\'cs.body.9\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==3}\"><a href=\"\" role=link ng-click=filterFx(3);>{{\'cs.body.10\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==4}\"><a href=\"\" role=link ng-click=filterFx(4);>{{\'cs.body.11\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==6}\"><a href=\"\" role=link ng-click=filterFx(6);>{{\'cs.body.13\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\':filter==7}\"><a href=\"\" role=link ng-click=filterFx(7);>{{\'cs.body.14\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem ng-class=\"{\'selected\':filter==\'all\'}\"><a href=\"\" role=link ng-click=\"filterFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-if=\"selectedTab == \'hub.creativeServices.cmp\'\"><a href=\"\" role=button aria-label=filter2 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-class=\"{\'selected\':filter==\'c\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'c\');\">{{\'cm.label.1\' | translate}}</a></li><li ng-class=\"{\'selected\':filter==\'t\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'t\');\">{{\'cm.label.2\' | translate}}</a></li><li class=divider role=separator></li><li ng-class=\"{\'selected\':filter==\'all\'}\"><a href=\"\" role=menuitem ng-click=\"filterFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button aria-label=info id=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=info><a href=\"\" role=menuitem ng-click=readMeFx(); translate=\"{{\'cs.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li></ul></div><div class=pull-right><a href=\"\" role=button aria-label=refresh id=refresh ng-click=loadSelectedTab(); uib-tooltip=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView></div></div></section>");
$templateCache.put("app/creativeServices/csAdd.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><a href=\"\" role=link class=marR10 ui-sref=hub.creativeServices.cur>{{\'cm.menu.9\' | translate}}</a>/<span class=marL10>{{\'cs.btn.1\' | translate}}</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=\"panel-heading panel-tab\"><div class=panel-tools><div class=pull-right><a href=\"\" role=link tooltip-placement=bottom uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div class=\'+\'text-bold\'+\'>{{\'cm.label.37\' | translate}}</div><div class=\'+\'text-ucase\'+\'>bmp, dib, gif, jpf, jpe, jpg, jpeg, jpx, png, rle, tga, tif</div><div class=\'+\'spaceH\'+\'></div><div class=\'+\'text-bold\'+\'>{{\'cm.label.40\' | translate}}</div><div class=\'+\'text-ucase\'+\'>ai, eps, doc, docx, pdf, ppt, pptx, psd, rar, zip</div></div>\'\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'cm.label.54\' | translate}}</a></div></div><div class=pad12>{{\'cs.p_c.body.1\' | translate}}</div></header><div class=panel-body><div><p class=csTimeHeading>{{\'cs.p_c.body.2\' | translate}}</p><div>&nbsp;</div><div class=form-group><label>{{\'cs.p_c.label.1\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=csOpt ng-model=csAdd.type value=c><label></label>{{\'cm.label.1\' | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=csOpt ng-model=csAdd.type value=t><label></label>{{\'cm.label.2\' | translate}}</label></div></div><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=csAdd.title focus-me=true maxlength={{inputLimit}} aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=form-group><label for=description>{{\'cs.body.18\' | translate}}</label><textarea id=description class=\"form-control txtAreaBig\" ng-model=csAdd.description maxlength={{descriptionLimit}} aria-label=\"{{\'cs.body.18\' | translate}}\" aria-labelledby=\"{{\'cs.body.18\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - csAdd.description.length}} ]</span></div><div class=row><div class=col-xs-6><div class=\"form-group noMarB\"><label for=contect>{{\'cm.label.48\' | translate}}</label><input type=tel id=contect class=form-control ng-model=csAdd.contact maxlength=20 aria-label=\"{{\'cm.label.48\' | translate}}\" aria-labelledby=\"{{\'cm.label.48\' | translate}}\"></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><label>{{\'cs.p_c.label.2\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file file-model=curFile options=\"{size:8390000, format:[\'image\',\'csOther\']}\" aria-label=\"{{\'cs.p_c.label.2\' | translate}}\" aria-labelledby=\"{{\'cs.p_c.label.2\' | translate}}\"> <input type=text class=form-control ng-value=curFile.name readonly aria-label=\"{{\'cs.p_c.label.2\' | translate}}\" aria-labelledby=\"{{\'cs.p_c.label.2\' | translate}}\"></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveCreativeFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.creativeServices.cur data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cs.msg.4\' | translate}}</div><div ng-if=\"errType==\'desc\'\" aria-live=polite role=status>{{\'cs.msg.5\' | translate}}</div><div ng-if=\"errType==\'contact\'\" aria-live=polite role=status>{{\'cs.msg.6\' | translate}}</div><div ng-if=\"errType==\'contactValid\'\" aria-live=polite role=status>{{\'cs.msg.7\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/creativeServices/csDetails.html","<div class=pageHeading><a href=\"\" role=link class=marR10 ui-sref=hub.creativeServices.cur ng-if=\"csDetails.status != 5\">{{\'cm.menu.9\' | translate}}</a> <a href=\"\" role=link class=marR10 ui-sref=hub.creativeServices.cmp ng-if=\"csDetails.status == 5\">{{\'cm.menu.9\' | translate}}</a> /<span class=\"marL10 marR10\">{{\'cs.tab.4s\' | translate}}</span><span class=text-muted>[ <span>LSCS{{decId}}</span> ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=\"panel-heading panel-tab\"><!-- Order Details --><ul class=\"nav nav-tabs\" role=tablist aria-labelledby=navList><li ui-sref-active=active role=tab><a ui-sref=\".odTab({id: encId})\" role=button>{{\'cs.tab.4\' | translate}}</a></li><li ui-sref-active=active role=tab><a ui-sref=\".aTab({id: encId})\" role=button>{{\'cs.tab.5\' | translate}}</a></li><li ui-sref-active=active ng-if=\"selectedTab != \'hub.cContainer.cs.cp\' && (csDetails.status == 8 || csDetails.status == 9 || csAttachments.info.status == 8 || csAttachments.info.status == 9 || csInvoice.id != undefined)\" role=tab><a ui-sref=\".iTab({id: encId})\" role=button>{{\'cs.tab.6\' | translate}}</a></li><li ui-sref-active=active ng-if=\"selectedTab == \'hub.cContainer.cs.cp\'\" role=tab><a ui-sref=\".cp({id: encId})\">{{\'cs.tab.6\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right><a href=\"\" role=link uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" ui-sref=hub.creativeServices.cur ng-if=\"csDetails.status != 5\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <a href=\"\" role=link uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" ui-sref=hub.creativeServices.cmp ng-if=\"csDetails.status == 5\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><span ng-if=\"selectedTab == \'hub.cContainer.cs.odTab\'\"><div class=pull-right ng-if=\"!detailsLoading && itemInArray(cancelStatus, csDetails.status)\"><a href=\"\" role=link uib-tooltip=\"{{\'cs.tool.3\' | translate}}\" ng-click=csStatusOpen(6);><span class=\"fa fa-trash\" aria-hidden=true></span></a></div><div class=pull-right ng-if=\"!detailsLoading && itemInArray(cancelStatus, csDetails.status)\"><a href=\"\" role=link uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" ng-click=editFx();><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></span><div class=pull-right ng-if=\"selectedTab == \'hub.cContainer.cs.aTab\'\"><a href=\"\" role=link tooltip-placement=bottom uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div class=\'+\'text-bold\'+\'>{{\'cm.label.37\' | translate}}</div><div class=\'+\'text-ucase\'+\'>bmp, dib, gif, jpf, jpe, jpg, jpeg, jpx, png, rle, tga, tif</div><div class=\'+\'spaceH\'+\'></div><div class=\'+\'text-bold\'+\'>{{\'cm.label.40\' | translate}}</div><div class=\'+\'text-ucase\'+\'>ai, eps, doc, docx, pdf, ppt, pptx, psd, rar, zip</div></div>\'\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'cm.label.54\' | translate}}</a></div></div></header><div class=\"panel-body csPanel-body\"><div ui-view=tabView></div></div></section><div class=\"text-center text-big marB10\" ng-if=\"selectedTab == \'hub.cContainer.cs.odTab\' && timelineLoading != undefined\"><div class=csTimeHeading>{{\'cs.p_d.label.9\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=timelineLoading></div><div class=timeline ng-if=\"selectedTab == \'hub.cContainer.cs.odTab\' && timelineLoading != undefined && !timelineLoading\"><div class=\"container userComment\" ng-if=\"csDetails.status != 6 && csDetails.status != 9\"><div class=dot></div><div class=\"comment marB15\"><div class=text-right><textarea class=form-control ng-model=csComment.comment placeholder=\"{{\'cm.ph.4\' | translate}}\" maxlength={{commentLimit}} aria-label=Comment aria-labelledby=Comment></textarea><span class=\"text-muted text-sm\">[ {{commentLimit - csComment.comment.length}} ]</span></div><div class=row><div class=col-xs-5><button type=button role=button class=\"btn btn-primary\" ng-click=csCommentFx(); ng-disabled=\"csComment.comment==\'\' || commentProcessing\"><span class=fa ng-class=\"commentProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cs.p_d.btn.3\' | translate}}</button></div><div class=\"col-xs-7 noPadL text-right\"><div class=\"marT10 text-ellipsis\"><span class=marR5>{{csComment.curFile.name}}</span> <span class=\"btn-link btn-file pull-right\"><span class=\"fa fa-paperclip\" aria-hidden=true></span> {{\'cs.p_d.btn.4\' | translate}} <input type=file file-model=csComment.curFile options=\"{size:8390000, format:[\'image\',\'csOther\']}\"></span></div></div></div></div></div><div ng-repeat=\"comment in timeline.comments\" class=container ng-class=\"comment.cs?\'csComment\':\'userComment\'\"><div class=dot ng-class=\"{\'statusDot\':comment.type == \'s\'}\"></div><div class=status ng-if=\"comment.type == \'s\'\"><div class=text-bold>{{comment.status}}</div><div class=text-sm>{{(comment.createdOn*1000) | date:\"medium\"}}</div></div><div class=\"comment text-ellipsis-wrap\" ng-if=\"comment.type == \'c\'\"><div class=text-bold><div class=pull-left><img alt=\"\" class=marR5 ng-if=comment.cs src=assets/images/logo_square_md.png> <img alt=\"\" class=marR5 ng-if=\"!comment.cs && comment.profileImg\" ng-src=\"{{csDetails.info.timthumb + csDetails.info.uBucket + comment.profileImg + profileSmParam + \'&\' + comment.thumbV}}\"><div ng-if=\"!comment.cs && !comment.profileImg\" class=profileIcon-sm>{{comment.userName | limitTo:1}}</div></div><div>{{comment.userName}} | <span class=\"text-muted text-sm\">{{(comment.createdOn * 1000) | date:\"medium\"}}</span></div></div><div class=text-ellipsis-wrap ng-bind-html=comment.comment></div><div class=marT10 ng-if=\"comment.attachment != null\"><span class=\"fa fa-paperclip\" aria-hidden=true></span> <a href=\"\" role=link class=btn-link ng-click=\"linkOpenFx(\'m\', detailBucket + comment.attachment);\">{{comment.attachment}}</a></div></div></div></div>");
$templateCache.put("app/creativeServices/csEdit.html","<div class=pageHeading><div class=csStatus><div class=text-muted>Spent Hours</div><div class=text-bold>2.5</div><div class=csProgress><div class=bg-primary style=width:30%>&nbsp;</div></div></div><a href=\"\" role=link class=marR10 ui-sref=h.creative.currentOrdersTab>Creative Services</a>/<span class=marL10>Edit Creative Request</span></div><div>&nbsp;</div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs\" role=tablist aria-labelledby=navList><li ui-sref-active=active role=tab><a ui-sref=.csDetailsTab role=button>Details and Comments</a></li><li ui-sref-active=active role=tab><a ui-sref=.csAttachmentsTab role=button>Attachments <span class=\"badge ng-cloak\">{{leg}}</span></a></li></ul></header><div class=panel-body><div ui-view=tabView></div></div><div class=panel-footer ng-if=\"$state.includes(\'h.creativeServiceEdit.csAttachmentsTab\') === true\"><button type=button role=button class=\"btn btn-primary\" ng-disabled=\"buttonDisable==true\" ng-click=creativefileServiceSubmit(csDetailsId);><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=h.creative.currentOrdersTab>{{\'cm.btn.9\' | translate}}</button></div></section><div>&nbsp;</div><section class=panel><div class=panel-body><div class=bdrBtm ng-repeat=\"csCdShow in csCommetDetail\"><div class=\"text-bold marB5 ng-cloak\">{{csCdShow.userName}}</div><div class=marB5 ng-bind-html=csCdShow.comment></div><div class=\"text-muted marB20 text-small ng-cloak\">{{csCdShow.createdate}}</div></div><div><textarea class=\"form-control txtAreaBig marB5\" ng-model=csCS.comment placeholder=\"{{\'cm.ph.4\' | translate}}\" maxlength={{commentLimit}} aria-label=Comment aria-labelledby=Comment></textarea><span class=\"text-muted text-sm\">[ {{commentLimit - csCS.comment.length}} ]</span> <button type=button role=button class=\"btn btn-primary\" ng-disabled=\"commetbuttonDisable==true\" ng-click=csCommentSubmit(csCS,csDetailsId);><span class=\"fa fa-check\" aria-hidden=true></span>Submit Reply</button></div></div></section>");
$templateCache.put("app/creativeServices/csOrderAttachment.html","<img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div ng-if=!detailsLoading><div class=form-group ng-if=\"csAttachments.info.status != 6 && csAttachments.info.status != 9\"><div class=\"btn btn-primary btn-sm btn-file\" ng-disabled=attachProcessing><span class=fa ng-class=\"attachProcessing?\'fa-repeat fa-spin\':\'fa-paperclip\'\" aria-hidden=true></span> {{\'cs.p_d.btn.5\' | translate}} <input type=file file-model=curFile options=\"{size:8390000, format:[\'image\',\'csOther\'], callback:true}\" ng-disabled=attachProcessing></div></div><div class=\"table table-md dTable\" role=table ng-if=!detailsLoading><div ng-if=\"csAttachments.attachments.length > 0\"><div class=\"row th\"><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.brief.7\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.6\' | translate}}</div></div><ul><li class=row ng-repeat=\"attach in csAttachments.attachments\">{{curExtn = (attach.label.substring(attach.label.lastIndexOf(\".\") + 1));\"\"}}<div class=\"col-xs-6 text-ellipsis\"><span class=\"fa text-md\" aria-hidden=true ng-class=\"{\'fa-file-o\':(curExtn == \'ai\' || curExtn == \'eps\' || curExtn == \'psd\'), \'fa-file-pdf-o\':curExtn == \'pdf\', \'fa-file-word-o\':(curExtn == \'doc\' || curExtn == \'docx\'), \'fa-file-powerpoint-o\':(curExtn == \'ppt\' || curExtn == \'pptx\'), \'fa-file-zip-o\':(curExtn == \'rar\' || curExtn == \'zip\'), \'fa-file-image-o\':attach.extn == \'image\', \'fa-file-video-o\':attach.extn == \'video\'}\"></span> <a href=\"\" role=link class=\"marL5 btn-link\" ng-click=\"linkOpenFx(\'m\', detailBucket + attach.label);\" class=marL5>{{attach.label}}</a></div><div class=\"col-xs-3 text-ellipsis\">{{attach.createdBy}}</div><div class=\"col-xs-3 text-right\">{{(attach.createdOn * 1000) | date:\"medium\"}}</div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"csAttachments.attachments.length == 0\">{{\'cs.msg.8\' | translate}}</div></div></div>");
$templateCache.put("app/creativeServices/csOrderDetail.html","<img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div ng-if=!detailsLoading><div ng-if=!isEditable><p class=\"text-lg text-ellipsis-wrap\">{{csDetails.title}}</p><p class=text-ellipsis-wrap>{{csDetails.description}}</p></div><!-- Edit mode --><div ng-if=isEditable><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=csDetails.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=form-group><label for=description>{{\'cs.body.18\' | translate}}</label><textarea id=description class=\"form-control txtAreaBig\" ng-model=csDetails.description maxlength={{descriptionLimit}} aria-label=\"{{\'cs.body.18\' | translate}}\" aria-labelledby=\"{{\'cs.body.18\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - csDetails.description.length}} ]</span></div><div class=form-group><label for=contact>{{\'cm.label.48\' | translate}} <span class=\"fa fa-info-circle text-primary\" aria-hidden=true uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div class=\'+\'text-bold\'+\'>{{\'cs.tool.4\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>+(123) - 456-78-90</div><div>+(123) - 456-7890</div><div>+(123) 456-7890</div><div>+(123)-456-7890</div><div>(123) 456-7890</div><div>+01234567890</div><div>123.456.7890</div><div>123-456-7890</div><div>123-4567890</div><div>1234567890</div></div>\'\"></span></label><input type=tel id=contact class=form-control ng-model=csDetails.contact maxlength=20 aria-label=\"{{\'cm.label.48\' | translate}}\" aria-labelledby=\"{{\'cm.label.48\' | translate}}\"></div><div class=\"form-group bdr-top-dashed\"><button type=button role=button class=\"btn btn-success\" ng-click=saveCreativeFx(); ng-disabled=\"saveProcessing || editSaveDisable\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=resetFx();>{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cs.msg.4\' | translate}}</div><div ng-if=\"errType==\'desc\'\" aria-live=polite role=status>{{\'cs.msg.5\' | translate}}</div><div ng-if=\"errType==\'contact\'\" aria-live=polite role=status>{{\'cs.msg.6\' | translate}}</div><div ng-if=\"errType==\'contactValid\'\" aria-live=polite role=status>{{\'cs.msg.7\' | translate}}</div></div></div></div><div class=\"bg-light marT20 pad10\" ng-show=!showDetails><div class=row><div class=col-xs-3><label>{{\'cs.p_d.label.6\' | translate}}</label><div><span ng-if=\"csDetails.hours && csDetails.hours != null\">{{csDetails.hours}}</span> <span ng-if=\"!csDetails.hours || csDetails.hours == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=col-xs-3><label>{{\'cs.p_d.label.8\' | translate}}</label><div><span ng-if=\"csDetails.rate && csDetails.rate != null\">${{csDetails.rate}}</span> <span ng-if=\"!csDetails.rate || csDetails.rate == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=col-xs-3><label>{{\'cs.p_d.label.7\' | translate}}</label><div><span ng-if=\"csDetails.cost && csDetails.cost != null\">${{csDetails.cost}}</span> <span ng-if=\"!csDetails.cost || csDetails.cost == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=col-xs-3><div ng-if=\"csDetails.status == 2 || csDetails.status == 4 || csDetails.status == 7\"><div ng-if=\"auth.uType == 2 || auth.uType == 3 || auth.uservices.bp\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=csStatusOpen(3);><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.p_d.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=csStatusOpen(4); ng-if=\"csDetails.status != 4\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cs.p_d.btn.2\' | translate}}</button></div><div ng-if=\"auth.uType != 2 && auth.uType != 3 && !auth.uservices.bp\"><span uib-tooltip=\"{{\'cs.msg.14\' | translate}}\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-disabled=true><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.p_d.btn.1\' | translate}}</button></span> <span uib-tooltip=\"{{\'cs.msg.15\' | translate}}\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-disabled=true ng-if=\"csDetails.status != 4\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cs.p_d.btn.2\' | translate}}</button></span></div></div><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=csStatusOpen(5); ng-if=\"csDetails.status == 3\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.body.12\' | translate}}</button><div class=marT5><a href=\"\" role=link class=btn-link ng-click=\"showDetails = true;\">{{\'cm.btn.31\' | translate}}</a></div></div></div></div><div class=\"bg-light pad10 marT20\" ng-show=showDetails><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cs.p_d.label.1\' | translate}}</label><div ng-cloak>LSCS{{csDetails.id}}</div></div><div class=form-group><label>{{\'cs.p_d.label.2\' | translate}}</label><div>{{(csDetails.createdOn * 1000) | date:\"mediumDate\"}}</div></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div>{{csDetails.type == \'c\'?\'cm.label.1\':\'cm.label.2\' | translate}}</div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cs.body.1\' | translate}}</label><div class=text-ellipsis>{{csDetails.createdBy}}</div></div><div class=form-group><label>{{\'cs.p_d.label.3\' | translate}}#</label><div><span ng-if=\"csDetails.contact != null\">{{csDetails.contact}}</span> <span ng-if=\"csDetails.contact == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=form-group><label>{{\'cm.brief.5\' | translate}}</label><div class=text-ellipsis><span ng-if=\"csDetails.approvedBy != null\">{{csDetails.approvedBy}}</span> <span ng-if=\"csDetails.approvedBy == null\" class=\"text-muted text-sm\">N/A</span></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cs.p_d.label.4\' | translate}}</label><div><span ng-if=\"csDetails.assignedTo != null\"><div>{{csDetails.assignedTo}}</div><div class=\"text-sm text-muted text-bold\">L Squared Creative Support</div></span><span ng-if=\"csDetails.assignedTo == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=form-group><label>{{\'cm.label.46\' | translate}}</label><div><span ng-if=\"csDetails.status == 1\">{{\'cs.body.8\' | translate}}</span> <span ng-if=\"csDetails.status == 2\">{{\'cs.body.9\' | translate}}</span> <span ng-if=\"csDetails.status == 3\">{{\'cs.body.10\' | translate}}</span> <span ng-if=\"csDetails.status == 4\">{{\'cs.body.11\' | translate}}</span> <span ng-if=\"csDetails.status == 5\">{{\'cs.body.12\' | translate}}</span> <span ng-if=\"csDetails.status == 6\">{{\'cs.body.13\' | translate}}</span> <span ng-if=\"csDetails.status == 7\">{{\'cs.body.14\' | translate}}</span> <span ng-if=\"csDetails.status == 8\">{{\'cs.body.15\' | translate}}</span> <span ng-if=\"csDetails.status == 9\">{{\'cs.body.7\' | translate}}</span> <span ng-if=\"csDetails.status == 10\">{{\'cs.body.17\' | translate}}</span></div></div><div class=\"form-group noMarB\"><label>{{\'cs.p_d.label.5\' | translate}}</label><div class=text-ellipsis><span ng-if=\"csDetails.fileCount != 0\">{{csDetails.fileCount}}</span> <span ng-if=\"csDetails.fileCount == 0\" class=\"text-muted text-sm\">N/A</span></div></div></div><div class=\"col-xs-3 pad10 marTB-10 bg-warning\"><a href=\"\" role=link class=\"btn-link pull-right\" ng-click=\"showDetails = false;\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=form-group><label>{{\'cs.p_d.label.6\' | translate}}</label><div><span ng-if=\"csDetails.hours && csDetails.hours != null\">{{csDetails.hours}}</span> <span ng-if=\"!csDetails.hours || csDetails.hours == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=form-group><label>{{\'cs.p_d.label.8\' | translate}}</label><div><span ng-if=\"csDetails.rate && csDetails.rate != null\">${{csDetails.rate}}</span> <span ng-if=\"!csDetails.rate || csDetails.rate == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=form-group><label>{{\'cs.p_d.label.7\' | translate}}</label><div><span ng-if=\"csDetails.cost && csDetails.cost != null\">${{csDetails.cost}}</span> <span ng-if=\"!csDetails.cost || csDetails.cost == null\" class=\"text-muted text-sm\">N/A</span></div></div><div ng-if=\"csDetails.status == 2 || csDetails.status == 4 || csDetails.status == 7\"><div ng-if=\"auth.uType != 4 || auth.uservices.bp\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=csStatusOpen(3);><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.p_d.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=csStatusOpen(4); ng-if=\"csDetails.status != 4\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cs.p_d.btn.2\' | translate}}</button></div><div ng-if=\"auth.uType == 4 && !auth.uservices.bp\"><span uib-tooltip=\"{{\'cs.msg.14\' | translate}}\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-disabled=true><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.p_d.btn.1\' | translate}}</button></span> <span uib-tooltip=\"{{\'cs.msg.15\' | translate}}\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-disabled=true ng-if=\"csDetails.status != 4\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cs.p_d.btn.2\' | translate}}</button></span></div></div><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=csStatusOpen(5); ng-if=\"csDetails.status == 3\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.body.12\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/creativeServices/csOrderInvoice.html","<img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div ng-if=!detailsLoading><div class=invoice><div class=\"row header noMar padTB10\"><div class=col-xs-6><img alt=\"\" src=assets/images/lsquared-logo.png class=marT15></div><div class=\"col-xs-6 text-right\"><div><span class=info>{{\'cs.p_i.1\' | translate}}:</span> <span>+1 877 525 1995</span></div><div><span class=info>{{\'cs.p_i.2\' | translate}}:</span> <span>www.lsquared.com</span></div><div><span class=info>{{\'cm.label.47\' | translate}}:</span> <span>support@LSquared.com</span></div><div><span class=info>{{\'cs.p_i.3\' | translate}}:</span> <span>15 Pullman Court, Toronto, ON M1X 1E4, CANADA</span></div></div></div><div class=spaceH></div><div class=\"row pad10\"><div class=col-xs-6><div>{{\'cs.p_i.4\' | translate}}:</div><div class=\"text-big marB10\">{{csInvoice.servername}}</div><div><span class=text-bold>{{\'cs.p_i.1\' | translate}}:</span> {{csInvoice.phone}}</div><div><span class=text-bold>{{\'cm.label.47\' | translate}}:</span> {{csInvoice.email}}</div><div><span class=text-bold>{{\'cs.p_i.3\' | translate}}:</span> {{csInvoice.address}}</div></div><div class=\"col-xs-6 text-right\"><div>{{\'cs.p_i.5\' | translate}}:</div><div class=\"text-big marB10\">LSCS-INV{{csInvoice.id}}</div><div><span class=text-bold ng-if=csInvoice.tid>{{\'cs.p_i.6\' | translate}}:</span> {{csInvoice.tid}}</div><div><span class=text-bold>{{\'cs.body.5\' | translate}}:</span> {{(csInvoice.iDate * 1000 ) | date:\"longDate\"}}</div><div><span class=text-bold>{{\'cs.p_i.7\' | translate}}:</span> {{(csInvoice.oDate * 1000 ) | date:\"longDate\"}}</div><div><span class=text-bold>{{\'cs.p_i.8\' | translate}}:</span> 84999 1989</div><div class=text-bold><span>{{\'cm.label.46\' | translate}}:</span> <span ng-if=!csInvoice.status class=\"bg-danger text-danger padLR5\">{{\'cs.body.6\' | translate}}</span><span ng-if=csInvoice.status class=\"bg-success text-success padLR5\">{{\'cs.body.7\' | translate}}</span></div></div></div><table class=\"table table-invoice\"><tr><th class=text-center>#</th><th>{{\'cs.p_i.9\' | translate}}</th><th style=width:15% class=text-right>{{\'cs.p_i.10\' | translate}}</th><th class=text-right>{{\'cs.p_i.11\' | translate}}</th><th class=text-right>{{\'cs.p_i.12\' | translate}} ($)</th></tr><tr><td class=text-center>1</td><td><div class=text-big>{{\'cs.body.19\' | translate}}</div><div ng-if=\"csInvoice.type == \'c\'\">{{\'cm.label.1\' | translate}}</div><div ng-if=\"csInvoice.type == \'t\'\">{{\'cm.label.2\' | translate}}</div></td><td class=text-right>{{csInvoice.rate}}</td><td class=text-right>{{csInvoice.totalHour}}</td><td class=text-right>{{csInvoice.totalCost}}</td></tr><tr><td colspan=3></td><td class=\"text-right text-bold\">{{\'cs.p_i.13\' | translate}}</td><td class=\"text-right text-bold\">${{csInvoice.totalCost}}</td></tr></table></div><div class=\"bdr-top-dashed marT10\"><span id=paymentBtn class=\"transparentBtn checkoutBtn\" ng-if=!csInvoice.status></span> <span class=\"btn btn-primary\" ng-if=\"!csInvoice.status && !paypalBtnLoading\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.btn.4\' | translate}}</span> <span class=marR5 ng-if=\"!csInvoice.status && paypalBtnLoading\"><img alt=Loading src=assets/images/loading.gif></span><button type=button role=button class=\"btn btn-default\" ng-click=printFx(); ng-if=!paypalBtnLoading><span class=\"fa fa-print\" aria-hidden=true></span>{{\'cs.btn.5\' | translate}}</button></div></div>");
$templateCache.put("app/creativeServices/csPaymentConfirmation.html","<div class=\"bg-info pad10 text-bold text-info\" ng-if=paymentProcessing><span class=\"fa fa-repeat fa-spin marR5\" aria-hidden=true></span> {{\'cs.p_i.m1\' | translate}}</div><div class=\"bg-success pad10 text-bold text-success\" ng-if=\"!paymentProcessing && !hasErr\"><span class=\"fa fa-check marR5\" aria-hidden=true></span> {{\'cs.p_i.m2\' | translate}}</div><div class=\"bg-danger pad10 text-bold text-danger\" ng-if=\"!paymentProcessing && hasErr\"><span class=\"fa fa-exclamation-triangle marR5\" aria-hidden=true></span> {{\'cs.p_i.m3\' | translate}}</div>");
$templateCache.put("app/creativeServices/cur.html","<img alt=Loading src=assets/images/loading.gif ng-if=creativeSrvLoading><div class=\"table table-md dTable\" role=table ng-if=!creativeSrvLoading><div ng-if=\"creativeSrv.length > 0 && filterCount > 0\"><div class=\"row th\" ng-if=\"(creativeSrv | filter:searchText).length > 0\"><div class=col-xs-1>{{\'cm.label.80\' | translate}}</div><div class=col-xs-3>{{\'cm.label.23\' | translate}}</div><div class=col-xs-2>{{\'cs.body.1\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cs.body.2\' | translate | camelCase}}</div><div class=\"col-xs-2 noPadR\">{{\'cm.label.46\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><ul><li class=row ng-repeat=\"cur in creativeSrv | filter:searchText\" ng-class=\"{\'unapprovedRow\':!cur.isApproved}\" ng-if=\"filter == \'all\' || (filter == \'c\' && cur.type == \'c\') || (filter == \'t\' && cur.type == \'t\') || (filter == 1 && cur.status == 1) || (filter == 2 && cur.status == 2) || (filter == 3 && cur.status == 3) || (filter == 4 && cur.status == 4) || (filter == 6 && cur.status == 6) || (filter == 7 && cur.status == 7)\"><div class=\"col-xs-1 text-ucase\"><a href=\"\" role=link ng-click=editFx(cur.id);>LSCS{{cur.id + cur.type}}</a></div><div class=\"col-xs-3 text-ellipsis\"><a href=\"\" role=link ng-click=editFx(cur.id);>{{cur.title}}</a></div><div class=\"col-xs-2 text-ellipsis\">{{cur.createdBy}}</div><div class=col-xs-2>{{(cur.createdOn * 1000) | date:\"mediumDate\"}}</div><div class=\"col-xs-2 noPadR\"><span ng-if=\"cur.status == 1\">{{\'cs.body.8\' | translate}}</span> <span ng-if=\"cur.status == 2\">{{\'cs.body.9\' | translate}}</span> <span ng-if=\"cur.status == 3\">{{\'cs.body.10\' | translate}}</span> <span ng-if=\"cur.status == 4\">{{\'cs.body.11\' | translate}}</span> <span ng-if=\"cur.status == 6\">{{\'cs.body.13\' | translate}}</span> <span ng-if=\"cur.status == 7\">{{\'cs.body.14\' | translate}}</span> <span ng-if=\"cur.status == 10\">{{\'cs.body.17\' | translate}}</span></div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-if=\"!cur.isApproved && (auth.uType != 4 || auth.uservices.bp)\" ng-click=approveFx(cur.id)><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cs.btn.2\' | translate}}</button> <a href=\"\" role=link aria-label=cross class=text-danger ng-if=\"itemInArray(deleteStatus, cur.status)\" ng-click=confirmOpen(cur.id); class=text-danger><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(creativeSrv | filter:searchText).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"creativeSrv.length > 0 && filterCount == 0\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!creativeSrvLoading && creativeSrv.length == 0\"><p>{{\'cs.msg.1\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=readMeFx();><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cs.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/creativeServices/inv.html","<img alt=Loading src=assets/images/loading.gif ng-if=creativeSrvLoading><div class=\"table table-md dTable\" role=table ng-if=!creativeSrvLoading><div ng-if=\"invoices.length > 0\"><div class=\"row th\" ng-if=\"(invoices | filter:searchText).length > 0\"><div class=col-xs-2>{{\'cm.label.80\' | translate}}</div><div class=col-xs-4>{{\'cm.label.23\' | translate}}</div><div class=col-xs-2>{{\'cs.body.4\' | translate}}</div><div class=col-xs-2>{{\'cs.body.5\' | translate | camelCase}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.46\' | translate}}</div></div><ul><li class=row ng-repeat=\"invoice in invoices | filter:searchText\"><div class=col-xs-2><a href=\"\" role=link ng-click=openInvoiceFx(invoice.id); class=text-primary>LSCS-INV{{invoice.id}}</a></div><div class=\"col-xs-4 text-ellipsis\">{{invoice.title}}</div><div class=col-xs-2>${{invoice.amount}}</div><div class=col-xs-2>{{(invoice.iDate * 1000) | date:\"longDate\"}}</div><div class=\"col-xs-2 text-right text-bold\"><span class=text-danger ng-if=!invoice.status>{{\'cs.body.6\' | translate | camelCase}}</span> <span class=text-success ng-if=invoice.status>{{\'cs.body.7\' | translate}}</span></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(invoices | filter:searchText).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!creativeSrvLoading && invoices.length == 0\"><p>{{\'cs.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=readMeFx();><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'cs.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/emergencyMsg/em.html","<img alt=Loading src=assets/images/loading.gif ng-if=emergencyMsgLoading><div ng-if=\"!emergencyMsgLoading && !isDeviceAvailable\" class=msg-warning lang={{auth.lang}}>{{\'em.msg.1\' | translate}}</div><div ng-if=\"!emergencyMsgLoading && isDeviceAvailable\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(320)}}px><div class=form-group><label for=predefinedMsg>{{\'em.label.1\' | translate}}</label><select id=predefinedMsg class=form-control ng-model=emergencyMsg.info.predefinedMsg ng-options=\"option.label for option in emergencyMsg.predefinedMsg track by option.id\" aria-label=\"{{\'em.label.1\' | translate}}\" aria-labelledby=\"{{\'em.label.1\' | translate}}\"><option value=\"\">{{\'em.ph.1\' | translate}}</option></select></div><div class=form-group><label for=customMsg>{{\'em.label.2\' | translate}} <span class=\"text-muted text-sm\">({{\'em.label.2.1\' | translate}})</span></label><textarea id=customMsg class=form-control ng-model=emergencyMsg.info.customMsg maxlength=250 aria-label=\"{{\'em.label.2\' | translate}}\" aria-labelledby=\"{{\'em.label.2\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{250 - emergencyMsg.info.customMsg.length}} ]</span></div><div class=\"form-group hide\"><label>{{\'em.label.12\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR5><input type=radio role=radio name=audioOpt ng-model=emergencyMsg.info.audioType value=a><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=audioOpt ng-model=emergencyMsg.info.audioType value=n><label></label>{{\'cm.btn.3\' | translate}}</label></div></div><div class=form-group><label>{{\'cm.label.49\' | translate}}</label><div><label class=marR5><input type=radio role=radio name=durationOpt ng-model=emergencyMsg.info.durationType value=p><label></label>{{\'em.label.4\' | translate}}</label><label><input type=radio role=radio name=durationOpt ng-model=emergencyMsg.info.durationType value=c><label></label>{{\'cm.label.17\' | translate}}</label><div class=row><div class=col-xs-3><label for=durationP class=lableHidden>Duration</label><select id=durationP class=form-control ng-model=emergencyMsg.info.durationP ng-if=\"emergencyMsg.info.durationType == \'p\'\" aria-label=Duration aria-labelledby=Duration><!--Removing 1 min from list --><!-- <option value=\"60\">1 {{\'cm.label.28\' | translate | lowercase}}</option> --><option value=120>2 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=300>5 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=600>10 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=1800>30 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=3600>1 {{\'cm.label.29\' | translate | lowercase}}</option><option value=7200>2 {{\'cm.label.29\' | translate | lowercase}}</option><option value=14400>4 {{\'cm.label.29\' | translate | lowercase}}</option><option value=28800>8 {{\'cm.label.29\' | translate | lowercase}}</option><option value=43200>12 {{\'cm.label.29\' | translate | lowercase}}</option><option value=86400>24 {{\'cm.label.29\' | translate | lowercase}}</option><option value=172800>48 {{\'cm.label.29\' | translate | lowercase}}</option><option value=259200>72 {{\'cm.label.29\' | translate | lowercase}}</option></select><div class=input-group ng-if=\"emergencyMsg.info.durationType == \'c\'\"><label for=durationC class=lableHidden>Duration</label><input type=number id=durationC class=form-control ng-model=emergencyMsg.info.durationC min=1 aria-label=Duration aria-labelledby=Duration> <span class=input-group-addon>{{\'cm.label.27s\' | translate}}</span></div></div></div></div></div><div class=\"form-group hide\"><label>{{\'em.label.5\' | translate}}</label><div><label class=marR5><input type=radio role=radio name=displayOpt ng-model=emergencyMsg.info.whenDisplay value=i><label></label>{{\'em.label.5.1\' | translate}}</label><label><input type=radio role=radio name=displayOpt ng-model=emergencyMsg.info.whenDisplay value=c><label></label>{{\'cm.label.17\' | translate}}</label><!-- Date-Time Picker --><div class=row ng-if=\"emergencyMsg.info.whenDisplay == \'c\'\"><div class=col-xs-2><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker\" ng-model=emergencyMsg.info.display.date format=MM/DD/YYYY singledatepicker=true readonly aria-label=Date aria-labelledby=Date></div></div><div class=col-xs-2><div class=timepicker><span uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"emergencyMsg.info.display.time | date:\'shortTime\'\" readonly aria-label=Time aria-labelledby=Time></div><div class=\"dropdown-menu dropdown-to-body\" uib-dropdown-menu><div uib-timepicker ng-model=emergencyMsg.info.display.time hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-8>&nbsp;</div></div></div></div><div><label>{{\'cm.label.4s\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=emergencyMsg.info.deviceType value=a><label></label>{{\'em.label.6\' | translate | capitalize}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=emergencyMsg.info.deviceType value=c ng-change=\"deviceAndGroupsFx(\'d\', \'em\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=emergencyMsg.info.deviceType value=c ng-change=\"deviceAndGroupsFx(\'t\', \'em\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"emergencyMsg.info.deviceType == \'c\'\"><!-- Device --><div class=\"row marT10\" ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'em\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=\"row marT10\" ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;deviceAndGroupsFx(\'t\')\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (emergencyMsg.tags.length || emergencyMsg.info.devices.assignedTags.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting5 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu5 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', emergencyMsg.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.tags.length}} ]</span></label>{{curATEM = (emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!emergencyMsg.tags.length ng-model=avlTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'a\', option, emergencyMsg.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!emergencyMsg.tags.length ng-click=\"listManipulateFx(\'add\', emergencyMsg.tags, emergencyMsg.info.devices.assignedTags, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!emergencyMsg.info.devices.assignedTags.length ng-click=\"listManipulateFx(\'remove\', emergencyMsg.tags, emergencyMsg.info.devices.assignedTags, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting6 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu6 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', emergencyMsg.info.devices.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.info.devices.assignedTags.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.info.devices.assignedTags.length}} ]</span></label>{{curATEM = (emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!emergencyMsg.info.devices.assignedTags.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.info.devices.assignedTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'s\', option, emergencyMsg.info.devices.assignedTags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!emergencyMsg.tags.length && !emergencyMsg.info.devices.assignedTags.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;deviceAndGroupsFx(\'d\', \'em\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'em\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Group --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;deviceAndGroupsFx(\'g\')\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (emergencyMsg.groups.length || emergencyMsg.info.devices.assignedGroups.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting3 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu3 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', emergencyMsg.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', emergencyMsg.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.groups.length}} ]</span></label>{{curAGEM = (emergencyMsg.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!emergencyMsg.groups.length ng-model=avlGList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGroupFx(\'a\', option, emergencyMsg.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!emergencyMsg.groups.length ng-click=\"listManipulateFx(\'add\', emergencyMsg.groups, emergencyMsg.info.devices.assignedGroups, curGroups.availableGroups,\'\',\'\',\'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!emergencyMsg.info.devices.assignedGroups.length ng-click=\"listManipulateFx(\'remove\', emergencyMsg.groups, emergencyMsg.info.devices.assignedGroups, curGroups.assignedGroups,\'\',\'\',\'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting4 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && aDeviceSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && aDeviceSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && aDeviceSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && aDeviceSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu4 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', emergencyMsg.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', emergencyMsg.info.devices.assignedGroups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.info.devices.assignedGroups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.info.devices.assignedGroups.length}} ]</span></label>{{curAGEM = (emergencyMsg.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!emergencyMsg.info.devices.assignedGroups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.info.devices.assignedGroups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGroupFx(\'s\', option, emergencyMsg.info.devices.assignedGroups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!emergencyMsg.groups.length && !emergencyMsg.info.devices.assignedGroups.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;deviceAndGroupsFx(\'t\')\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (emergencyMsg.tags.length || emergencyMsg.info.devices.assignedTags.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting5 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu5 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', emergencyMsg.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.tags.length}} ]</span></label>{{curATEM = (emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!emergencyMsg.tags.length ng-model=avlTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'a\', option, emergencyMsg.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!emergencyMsg.tags.length ng-click=\"listManipulateFx(\'add\', emergencyMsg.tags, emergencyMsg.info.devices.assignedTags, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!emergencyMsg.info.devices.assignedTags.length ng-click=\"listManipulateFx(\'remove\', emergencyMsg.tags, emergencyMsg.info.devices.assignedTags, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting6 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu6 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', emergencyMsg.info.devices.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{emergencyMsg.info.devices.assignedTags.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{emergencyMsg.info.devices.assignedTags.length}} ]</span></label>{{curATEM = (emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!emergencyMsg.info.devices.assignedTags.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"emergencyMsg.info.devices.assignedTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in emergencyMsg.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'s\', option, emergencyMsg.info.devices.assignedTags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!emergencyMsg.tags.length && !emergencyMsg.info.devices.assignedTags.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div></div>");
$templateCache.put("app/emergencyMsg/emergencyMsg.html","<section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs em\" role=tablist aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active class=tab-success role=tab><a ui-sref=.em role=button>{{\'em.tab.1\' | translate}}</a></li><li ui-sref-active=active class=tab-primary role=tab><a ui-sref=.sm role=button>{{\'em.tab.2\' | translate}}</a></li><li ui-sref-active=active class=tab-primary role=tab><a ui-sref=.es role=button>{{\'em.tab.3\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right uib-dropdown><a href=\"\" role=link id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=info><a href=\"\" role=link ng-click=readMeFx(); translate=\"{{\'em.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li></ul></div><div class=pull-right ng-if=\"selectedTab == \'hub.emergencyMsg.sm\' && emergencyMsg.length > 0\" uib-tooltip=\"{{\'em.btn.2\' | translate}}\"><a href=\"\" role=link id=delete aria-label=delete ng-click=\"deleteOpen(\'message\', deletableMsg.toString());\" ng-class=\"{\'text-disabled disabled\':deletableMsg.length == 0}\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=refresh aria-label=refresh ng-click=loadSelectedTab(); uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-if=\"selectedTab == \'hub.emergencyMsg.sm\' && emergencyMsg.length > 0\" ng-disabled=loadingMain><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView></div></div><div class=panel-footer ng-if=\"selectedTab == \'hub.emergencyMsg.em\' && isDeviceAvailable\"><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=sendMessageFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.35i\':\'cm.btn.35\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=\"resetMessageFx(\'sendMsg\');\" ng-disabled=saveProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'msg\'\" aria-live=polite role=status>{{\'em.msg.3\' | translate}}</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'em.msg.4\' | translate}}</span> <span ng-if=\"errType==\'display\'\" aria-live=polite role=status>{{\'em.msg.5\' | translate}}</span> <span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'gDevice\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span></div><div class=clearfix></div></div></section><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && isAcknoledgementOpen\"></div><div class=selectedQuad ng-if=\"selectedTab == \'hub.emergencyMsg.sm\' && isAcknoledgementOpen\"><!--For Selected Item Brief--><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><div class=panel-heading><p>{{\'em.body.5\' | translate}}</p><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=acknowledgeCloseFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=downloadStatusFx(); uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-download\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></div><div class=panel-body ng-style=\"pinStatus == 1 && {\'max-height\':\'275px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=acknowledgeLoading><ul class=list-unstyled ng-if=\"!acknowledgeLoading && allScrollDataList.length > 0\"><div class=table><!-- table-md --><div class=\"row th\"><div class=col-xs-8>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'cm.label.46\' | translate}}</div></div><div class=scrollQuad style=height:205px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=\"\" have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{acNow.id}} ng-repeat=\"acNow in visibleData\"><div class=col-xs-8><div class=\"marR5 deviceStatus {{acNow.status}}\" uib-tooltip=\"{{acNow.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{acNow.l}}</div><div class=col-xs-4><span ng-if=\"acNow.st == 0\" class=\"text-danger text-bold\">{{\'em.body.6\' | translate}}</span> <span ng-if=\"acNow.st == 1\" class=\"text-success text-bold\">{{\'em.body.7\' | translate}}</span> <span ng-if=\"acNow.st == 2\">{{\'cl.widget.queue.1\' | translate}}</span> <span class=\"text-muted text-sm marL10\" ng-if=acNow.aOn>{{(acNow.aOn * 1000) | date:\"medium\"}}</span></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div></div></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!acknowledgeLoading && allScrollDataList.length == 0\">{{\'em.msg.7\' | translate}}</div></div></section></div>");
$templateCache.put("app/emergencyMsg/es.html","<img alt=Loading src=assets/images/loading.gif ng-if=emergencyMsgLoading><div ng-if=!emergencyMsgLoading><div class=row><div class=\"col-xs-10 col-sm-9\"><div class=row><div class=col-xs-8><div class=form-group><label for=hText>{{\'cl.widget.cm.12\' | translate}}</label><input id=hText type=text class=form-control ng-model=emergencyMsg.settings.hText value=\"EMERGENCY BROADCAST\" maxlength={{inputLimit}}></div></div><div class=col-xs-4><div class=form-group><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=emergencyMsg.settings.hFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label for=hBgColor>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':emergencyMsg.settings.hBgColor}\"></span></span> <input id=hBgColor type=text class=\"form-control picker\" ng-value=\"emergencyMsg.settings.hBgColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly name=\"\" aria-expanded=false aria-haspopup=true></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=emergencyMsg.settings.hBgColor selected-type=emergencyMsg.ctype.hBgColor ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div></div><div class=col-xs-4><div class=form-group><label for=hTextColor>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':emergencyMsg.settings.hTextColor}\"></span></span> <input id=hTextColor type=text class=\"form-control picker\" ng-value=\"emergencyMsg.settings.hTextColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly name=\"\" aria-expanded=false aria-haspopup=true></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=emergencyMsg.settings.hTextColor selected-type=emergencyMsg.ctype.hTextColor ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=col-xs-4><div class=form-group><label for=bBgColor>{{\'em.label.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':emergencyMsg.settings.bBgColor}\"></span></span> <input id=bBgColor type=text class=\"form-control picker\" ng-value=\"emergencyMsg.settings.bBgColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bb=true\" readonly aria-expanded=false aria-haspopup=true></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=emergencyMsg.settings.bBgColor selected-type=emergencyMsg.ctype.bBgColor ng-if=colorPicker.bb></ng-hub-color-picker></div></div></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label for=mBgColor>{{\'em.label.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':emergencyMsg.settings.mBgColor}\"></span></span> <input id=mBgColor type=text class=\"form-control picker\" ng-value=\"emergencyMsg.settings.mBgColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mb=true\" readonly aria-expanded=false aria-haspopup=true></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=emergencyMsg.settings.mBgColor selected-type=emergencyMsg.ctype.mBgColor ng-if=colorPicker.mb></ng-hub-color-picker></div></div></div></div><div class=col-xs-4><div class=form-group><label for=mTextColor>{{\'em.label.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':emergencyMsg.settings.mTextColor}\"></span></span> <input id=mTextColor type=text class=\"form-control picker\" ng-value=\"emergencyMsg.settings.mTextColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mt=true\" readonly aria-expanded=false aria-haspopup=true></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=emergencyMsg.settings.mTextColor selected-type=emergencyMsg.ctype.mTextColor ng-if=colorPicker.mt></ng-hub-color-picker></div></div></div></div><div class=col-xs-4><div class=form-group><label for=mFont>{{\'em.label.11\' | translate}}</label><select id=mFont class=form-control ng-model=emergencyMsg.settings.mFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div class=\"form-group bdr-top-dashed\"><button type=button role=button class=\"btn btn-success\" ng-click=saveSettingsFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=defaultSettingFx();>{{\'em.btn.3\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div></div></div><div class=\"col-xs-2 col-sm-3\"><div class=panel-subheading>{{\'em.body.9\' | translate}}</div><div class=panel-innerbody><div class=text-center><div class=title-image><span></span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=fileModelLoading> <img alt=\"\" ng-if=\"!emergencyMsg.info.titleImg && !fileModelLoading\" src=assets/images/default/na.png> <a ng-if=\"emergencyMsg.info.titleImg && !fileModelLoading\" ng-href=\"{{detailBucket + emergencyMsg.info.titleImg | secureThumb}}\" role=link fancyboxable=fbTitleInside><img alt=\"\" ng-src=\"{{tim + bucket + emergencyMsg.info.titleImg}}&h=100&w=100&q=80&zc=3\"></a></div><div class=spaceH></div><p><span class=\"btn btn-primary btn-xs btn-file\" ng-disabled=fileModelLoading>{{emergencyMsg.info.titleImg?\'em.btn.4\':\'cm.label.30\' | translate | camelCase}} <input aria-label=selectImg type=file file-model options=\"{size:2100000, format:[\'imgOnly\'], callback:true}\" accept=image/* ng-disabled=fileModelLoading> </span><button type=button role=button class=\"btn btn-danger btn-xs marL2\" ng-disabled=fileModelLoading ng-if=emergencyMsg.info.titleImg ng-click=\"deleteOpen(\'titleImg\');\">{{\'em.btn.5\' | translate}}</button></p><div class=spaceH></div><span class=\"text-sm text-muted\" translate=\"{{\'em.msg.9\'}}\" translate-values=\"{htmlTag: \'<br />\'}\"></span><div class=spaceH2></div></div></div></div><div class=\"col-xs-12 marT25\"><div class=panel-subheading>{{\'em.body.10\' | translate}}</div><div class=panel-innerbody><div class=form-group><label for=message>{{\'em.body.1\' | translate}}</label><textarea id=message class=form-control ng-model=predefinedMsg.message rows=4 maxlength={{commentLimit}}></textarea><span class=\"text-muted text-sm\">[ {{commentLimit - predefinedMsg.message.length}} ]</span></div><div class=bdr-top-dashed><div class=\"errMsg pull-right\" ng-if=hasErrMsg aria-live=polite role=status>{{\'em.msg.3\' | translate}}</div><button type=button role=button class=\"btn btn-success\" ng-click=savePredefinedMsgFx(); ng-disabled=saveProcessingMsg><span class=fa ng-class=\"saveProcessingMsg?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessingMsg?\'cm.btn.19i\':\'cm.btn.19\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=resetMsgFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></div></div></div></div><div class=\"table table-md marT25 dTable\" role=table ng-if=\"!emergencyMsgLoading && emergencyMsg.predefinedMsg.length > 0\"><div class=\"row th\"><div class=\"col-xs-7 col-lg-8\">{{\'em.label.1\' | translate | camelCase}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.3\' | translate}}</div><div class=\"col-xs-2 col-lg-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"pm in emergencyMsg.predefinedMsg\"><div class=\"col-xs-7 col-lg-8 text-ellipsis-wrap\">{{pm.message}}</div><div class=\"col-xs-3 text-right text-ellipsis\">{{pm.createdBy}}</div><div class=\"col-xs-2 col-lg-1 text-right\"><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=\"deleteOpen(\'predefinedMsg\', pm.id);\">{{\'cm.btn.13\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/emergencyMsg/sm.html","<img alt=Loading src=assets/images/loading.gif ng-if=emergencyMsgLoading><div ng-if=\"!emergencyMsgLoading && emergencyMsg.length > 0\"><div class=\"table table-md dTable\" role=table><div class=\"row th\"><div class=col-xs-3><label class=noMarB><input type=checkbox ng-click=msgCheckAll($event); role=checkbox><label></label>{{\'em.body.1\' | translate}}</label></div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.dt.1\' | translate}}</div><div class=col-xs-2>{{\'em.body.12\' | translate}}</div><div class=col-xs-1>{{\'cm.label.46\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"em in emergencyMsg\"><div class=\"col-xs-3 text-ellipsis-wrap\"><label class=text-unbold><input type=checkbox ng-model=em.isChecked ng-click=msgCheckFx() role=checkbox><label></label>{{em.message}} <a href=\"\" role=link class=marL5 ng-click=\"sentMsgOpen(em.id, em.message);\" ng-if=\"em.status != 0 && em.status != 3\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a></label></div><div class=\"col-xs-2 text-ellipsis-wrap text-sm\">{{em.time}}</div><div class=col-xs-2>{{(em.dateTime * 1000) | date:\"medium\"}}</div><div class=\"col-xs-2 text-ellipsis-wrap\">{{em.createdBy}}</div><div class=col-xs-1><span ng-if=\"em.status == 0\">{{\'em.body.2\' | translate}}</span> <span ng-if=\"em.status == 1\">{{\'em.body.3\' | translate}}</span> <span ng-if=\"em.status == 2\">{{\'em.body.4\' | translate}}</span> <span ng-if=\"em.status == 3\">{{\'cs.body.13\' | translate}}</span></div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=acknowledgeFx(em.id);>{{\'em.btn.1\' | translate}}</button> <button ng-if=\"em.status != 0 && em.status != 3\" type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deleteOpen(\'msgCancel\', em.id);\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=\"deleteOpen(\'message\', em.id);\">{{\'cm.btn.13\' | translate}}</button></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!emergencyMsgLoading && emergencyMsg.length == 0\">{{\'em.msg.2\' | translate}}</div>");
$templateCache.put("app/devices/d.html","<div class=\"flex-wrap padB10\"><!-- Folder Tree start --><!-- auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && uPreferences.isDFTreeOpen == \'1\' && (folderList.length > 0 || devicesLength > 0 || breadCrumbs.length > 0) --><!-- <div class=\"flex-1 tree-menu-quad\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && uPreferences.isDFTreeOpen == \'1\' && (folderList.length > 0 || treeList.length > 0 || dData.devices.length > 0 || breadCrumbs.length > 0)\"> --><!-- <div class=\"flex-1 tree-menu-quad\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && uPreferences.isDFTreeOpen == \'1\' && (folderList.length > 0 || treeList.length > 0 || devices.devices.length > 0 || breadCrumbs.length > 0)\"> --><div class=\"flex-1 tree-menu-quad\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && uPreferences.isDFTreeOpen == \'1\' && (folderList.length > 0 || treeList.length > 0 || devices.devices.length > 0 || devices.devices.length > 0 || breadCrumbs.length > 0 || devicesLoading || treeLoading)\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=treeLoading><div class=tree-view ng-if=!treeLoading><div><a href=\"\" class=home ng-class=\"{selected:curFolderId == 0}\" ng-click=folderContentFx(0);><img alt=\"\" src=assets/images/folder-icon.png class=valign-baseline> {{\'cm.label.6\' | translate}}</a></div><div class=marT3 data-angular-treeview=true data-tree-id=tree01 data-tree-model=treeList data-node-id={{curFolderId}} data-node-label=name data-node-children=children ng-if=\"treeList != 0\"></div></div><span class=hide>Selected Node: <span class=text-bold>{{tree01.currentNode.id}}</span></span><div class=resizer-handle resizer=vertical resizer-width=6 resizer-left=.flex-1 resizer-right=\"\" resizer-min=200 resizer-max=400></div></div><!-- Folder Tree end --><div class=flex-2 context-menu=contextMenuBase id=\"{{((folderList.length == 0 || devices.devices.length == 0) && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\')?\'content-list\':\'\'}}\"><!-- TODO: this code is for group by device type start --><div ng-if=\"!devicesLoading && devices.types.length > 0 && !devices.devices.length && !advSearchInfo.isEmpty && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\'\"><ul class=\"list-inline thumb-list dType-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredDTypes = (devices.types | customSearch:{key:searchText, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=folder src=assets/images/default/folder_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.types.length && !filteredDTypes.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><!-- TODO: this code is for group by device type end --><!-- Bread Crumbs Common --><div ng-if=\"!devicesLoading && breadCrumbs.length && (!advSearchInfo.isEmpty || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\'))\" class=breadcrumb><a href=\"\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\'\" ng-click=\"loadSelectedTab(\'home\');\"><span class=\"glyphicon glyphicon-home\"></span></a> <a href=\"\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\"></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" id=bre{{$index}} ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\'\">{{breadcrumb.label}}</a> <a href=\"\" id=bre{{$index}} ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" id=backBtn class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\"></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><!-- Device thumb view --><!-- ?Old: <div class=\"row\" ng-if=\"!devicesLoading && (devices.devices.length > 0 || filter != \'all\' && devices.devices.length == 0) && auth.upreferences.deviceView == \'t\'\"> --><div class=row ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'t\'\"><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-device-thumb class=show data-type=dPaging selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-thumb></ul></div></div><!-- Device list view --><!-- <div class=\"row\" ng-show=\"!devicesLoading && ((dData.folders.length > 0 || dData.devices.length > 0) || (filter != \'all\' && dData.devices.length ==0 && dData.folders.length ==0)) && auth.upreferences.deviceView == \'l\'\"> --><div class=row ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md\" data-type=dPaging selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div><!-- {{!devicesLoading}} && {{devices.devices.length}} == 0 && {{devices.folders.length == 0}} && {{visibleDevices}} == 0 && {{!advSearchInfo.isEmpty}} && {{!isFilterMsg}} && {{!isSearchMsg}} && {{!isAdvSearchMsg}} --><!-- Warning messages with how to add device --><!-- {{devices.info.count}} --><!-- {{!devicesLoading && devices.devices.length == 0 && devices.folders.length == 0 && visibleDevices == 0 && !advSearchInfo.isEmpty}} --><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.devices.length == 0 && folderList.length == 0 && visibleDevices == 0 && !advSearchInfo.isEmpty && !isFilterMsg && !isSearchMsg && !isAdvSearchMsg\"><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && devices.devices.length == 0 && devices.folders.length == 0 && devices.info.tc == 0 && !advSearchInfo.isEmpty\"> --><p>{{\'d.msg.1\' | translate}}</p><div ng-if=\"breadCrumbs.length == 0 || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'dt\' && breadCrumbs.length == 1) || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'df\' && breadCrumbs.length > 0 && devices.devices.length == 0)\"><div class=marB5><a href=\"\" ng-click=\"readMeFx(\'d\');\"><span class=\"fa fa-info-circle\"></span> <span translate=\"{{\'d.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div><!-- <a href=\"\" ng-click=\"videoFx(\'d\');\"><span class=\"fa fa-video-lcamera\"></span> <span translate=\"{{\'d.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a> --></div><!-- Warning message for no device --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && !devices.devices.length && advSearchInfo.isEmpty && !search.text.length && selectedTab!=\'hub.devices.d\'\">{{\'as.msg.2\' | translate}}</div> --><!-- <div ng-hide=\"selectedTab == \'hub.devices.d\' && !advSearchInfo.isEmpty\" class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && !devices.devices.length && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs hide\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --> <img class=pad10 alt=Loading src=assets/images/loading.gif ng-if=paginationLoading><div ng-if=\"!paginationLoading && !devicesLoading && filteredDeviceList.length && devices.devices.length && fCount.length > 0\" class=\"marT10 marB5 noPad d-flex justify-end\" ng-class=\"{\'bdr-top-dashed\':!paginationLoading && !devicesLoading && filteredDeviceList.length && devices.devices.length}\"><span class=\"pull-right noMarT nonSelectable\"><div class=other-controller><!-- <div class=\"d-flex align-items-center\">\r\n            <dir-pagination-controls boundary-links=\"paginationControls.boundaryLinks\" max-size=\"paginationControls.maxSize\" on-page-change=\"pageChangeHandler(newPageNumber)\"></dir-pagination-controls>\r\n          </div> --><!-- <div class=\"devicePaging marL10\" ng-class=\"{\'disabled\': paginationLoading}\">\r\n            <uib-pagination class=\"pagination-sm\" ng-model=\"currentPage\" ng-change=\"pageChangedFx(currentPage)\"\r\n              total-items=\"devices.info.count\" items-per-page=\"devices.info.pl\" max-size=\"5\" num-pages=\"numPages\"\r\n              boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n            </uib-pagination>\r\n          </div>\r\n          <div class=\"pull-right text-muted\" ng-class=\"(devices.info.count/devices.info.pl > 1) ? \'marT15\':\'marT12\'\">{{deviceRange ? deviceRange : (curCount + \' - \' + devices.info.pl)}} of {{devices.info.count ? devices.info.count : devices.devices.length}}</div> --></div></span></div></div></div>");
$templateCache.put("app/devices/dFrameLayout.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\" ng-if=!detailsLoading><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.d>{{\'d.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.1\':\'d.body.2\' | translate}}</span><span ng-if=device.info.label class=text-muted>[ {{device.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'d.btn.9\' | translate}} <span ng-if=\"!auth.upreferences.isPopup && device.info.label\" class=text-muted>[ {{device.info.label}} ]</span></h1><span class=\"stepComment pull-right\" ng-if=\"!auth.upreferences.isPopup && !detailsLoading\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div ng-if=!detailsLoading><header class=panel-inner-tab ng-if=\"auth.upermissions.fla || auth.upermissions.flae\"><span ng-if=device.info.fla><a ng-class=\"{\'selected\':selectedT==\'2\'}\" href=\"\" role=button ng-click=\"tabFx(2,\'tabFx\'); searchTextFl.val=\'\'\" ng-if=auth.upermissions.flae>{{\'d.body.3\' | translate}}</a> <a ng-class=\"{\'selected\':selectedT==\'1\'}\" href=\"\" role=button ng-click=\"tabFx(1,\'tabFx\'); searchTextFl.val=\'\'\" ng-if=auth.upermissions.fla>{{\'cm.menu.4\' | translate}}</a> </span><span ng-if=!device.info.fla><a ng-class=\"{\'selected\':selectedT==\'1\'}\" href=\"\" role=button ng-click=\"tabFx(1,\'tabFx\'); searchTextFl.val=\'\'\" ng-if=auth.upermissions.fla>{{\'cm.menu.4\' | translate}}</a> <a ng-class=\"{\'selected\':selectedT==\'2\'}\" href=\"\" role=button ng-click=\"tabFx(2,\'tabFx\'); searchTextFl.val=\'\'\" ng-if=auth.upermissions.flae>{{\'d.body.3\' | translate}}</a> </span><a ng-class=\"{\'selected\':selectedT==\'3\'}\" href=\"\" role=button ng-click=\"tabFx(3,\'tabFx\'); searchTextFl.val=\'\'\" ng-if=auth.upermissions.fll>{{\'d.body.4\' | translate}}</a></header><div class=pull-right><div class=\"input-group1 searchTbx marT-36 marR5\"><input type=text class=form-control ng-model=searchTextFl.val sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextFl.val.length ng-click=\"searchTextFl.val=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel noMarB scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(310)}}px><div class=\"overflow-auto pad10\" ng-if=\"selectedT==\'1\'\"><img alt=\"\" src=assets/images/loading.gif ng-if=frameLayoutsLoading><div context-menu=contextMenuBase><ul class=\"list-inline thumb-list\" ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\"><li ng-repeat=\"frame in filteredFramelayoutList = (frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fl\'})\" single-selection data-id={{frame.id}} data-type={{frameLayouts.info.type}} ng-class=\"{\'unapprovedFile\':selectedTab === \'hub.frameLayouts.ufl\', \'nonSelectable\':selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)}\" uib-tooltip=\"{{frame.hfr?\'fl.p_assign.msg.11\':\'d.tool.13\' | translate}}\" tooltip-enable=\"selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)\" context-menu=contextMenuOpt><div class=thumb-img><img alt=\"\" src=assets/images/default/incomplete.png ng-if=\"frame.thumbV == 0\" class=img-incomplete> <img alt=\"\" ng-src=\"{{tim + bucket + frame.id + \'.png\' + thumbParam + \'&\' + frame.thumbV}}\" ng-if=\"frame.thumbV != 0\"></div><div class=thumb-label>{{frame.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFramelayoutList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextFl.val)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div>{{\'fl.msg.1\' | translate}}</div><div class=marT10 ng-if=\"$state.includes(\'hub.frameLayouts.fl\') === true\"><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'fl\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div></div></div><div class=\"overflow-auto pad10\" ng-if=\"selectedT==\'2\'\"><img alt=\"\" src=assets/images/loading.gif ng-if=frameLayoutsLoading><div class=\"table table-md\" ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\" selectable=selection selectable-list=frameLayouts.frameLayouts selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"><div class=\"row th\" ng-if=\"(frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fla\'}).length > 0\"><div class=col-xs-3>{{\'cm.label.72\' | translate | camelCase}}</div><div class=col-xs-4>{{\'fl.body.3\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.10\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.11\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.4s\' | translate}}</div></div><ul><li class=row ng-repeat=\"frame in filteredAssignmentList = (frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fla\'})\" single-selection data-id={{frame.id}} data-type={{frameLayouts.info.type}} ng-class=\"{\'unapprovedRow\':!frame.isApproved, \'bg-danger\':frame.isExpired == 1 || (selectedTab == \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)), \'nonSelectable\':selectedTab === \'hub.dContainer.dFrameLayout\' && (frame.isExpired == 1 || !frame.hfr || frame.sffl)}\" context-menu=contextMenuOpt><div class=\"col-xs-3 text-ellipsis\"><input type=checkbox ng-click=\"checkboxFx($event, frame.id);\" ng-class=\"{\'hide\': selectedTab === \'hub.dContainer.dFrameLayout\' && (frame.isExpired == 1 || !frame.hfr || frame.sffl)}\" role=checkbox><label></label><span class=\"fa fa-exclamation-triangle text-danger marR5\" aria-hidden=true uib-tooltip=\"{{frame.isExpired == 1?\'fl.tool.6\':frame.hfr?\'fl.p_assign.msg.11\':\'fl.p_assign.msg.10\' | translate}}\" tooltip-append-to-body=true ng-if=\"frame.isExpired == 1 || (selectedTab == \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl))\"></span> {{frame.label}}</div><div class=\"col-xs-4 text-ellipsis\"><a uib-tooltip={{frame.flName}} tooltip-append-to-body=true tooltip-popup-delay=1000 class=\"btn-link nonSelectable\" ng-href=\"{{detailBucket + frame.flId + \'.png\' | secureThumb:frame.thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{frame.flName}}>{{frame.flName}}</a></div><div class=col-xs-2><span ng-if=\"frame.startDate != null\">{{frame.startDate}}</span> <span ng-if=\"frame.startDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-2 ng-class=\"{\'text-danger text-bold\' : frame.isExpired == 1}\"><span ng-if=\"frame.endDate != null\">{{frame.endDate}}</span> <span ng-if=\"frame.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\">{{frame.devices}} <button type=button role=button class=\"btn btn-xs btn-info\" ng-if=\"frame.devices > 0\" ng-click=\"deviceListFx(frame.id, frame.label);\">{{\'cm.btn.21\' | translate}}</button></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fla\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextFl.val)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div>{{\'fl.msg.2\' | translate}}</div><div class=marT10 ng-if=\"$state.includes(\'hub.frameLayouts.fla\') === true\"><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'fla\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div></div><div class=\"overflow-auto pad10\" ng-if=\"selectedT==\'3\'\"><img alt=\"\" src=assets/images/loading.gif ng-if=frameLayoutsLoading><div ng-if=!frameLayoutsLoading><div class=breadcrumb ng-if=frameLayouts.info.breadcrumb><a href=\"\" role=link ng-click=\"loadSelectedTab(\'home\'); selectedTabFx();\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span>{{frameLayouts.info.breadcrumb.label}}</span> <a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><ul class=\"list-inline thumb-list\" ng-if=\"frameLayouts.frameLayouts[0].type == \'Folder\'\" ng-click=selectableFx($event)><li ng-repeat=\"folder in filteredLibraryList = (frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fl\'})\" ng-click=\"selectFolderFx($event, folder);\" ng-dblclick=openFolderFx(folder.id); data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder.png></span></div><div class=thumb-label>{{folder.label}}</div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"frameLayouts.frameLayouts[0].type == \'Folder\' && (frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextFl.val)}}&quot;</b>\'}\"></div><ul class=\"list-inline thumb-list\" ng-if=\"frameLayouts.frameLayouts[0].type != \'Folder\' && frameLayouts.frameLayouts.length > 0\"><li ng-repeat=\"frame in filteredFramelayoutList = (frameLayouts.frameLayouts | customSearch:{key:searchTextFl.val, module:\'fl\'})\" single-selection data-id={{frame.id}} data-type={{frameLayouts.info.type}} ng-class=\"{\'unapprovedFile\':selectedTab === \'hub.frameLayouts.ufl\', \'nonSelectable\':selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)}\" uib-tooltip=\"{{frame.hfr?\'fl.p_assign.msg.11\':\'d.tool.13\' | translate}}\" tooltip-enable=\"selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)\" context-menu=contextMenuOpt><div class=thumb-img><img alt=\"\" src=assets/images/default/incomplete.png ng-if=\"frame.thumbV == 0\" class=img-incomplete> <img alt=\"\" ng-src=\"{{tim + bucket + frame.id + \'.png\' + thumbParam + \'&\' + frame.thumbV}}\" ng-if=\"frame.thumbV != 0\"></div><div class=thumb-label>{{frame.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFramelayoutList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextFl.val)}}&quot;</b>\'}\"></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div ng-if=!frameLayouts.info>{{\'fl.msg.5\' | translate}}</div><div ng-if=frameLayouts.info>{{\'fl.msg.6\' | translate}}<div class=marT10 ng-if=\"auth.uType == 0\"><button type=button role=button class=\"btn btn-default btn-sm\" ng-click=\"confirmFrameOpen(\'category\');\" ng-disabled=flProcessing><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'fl.btn.11\' | translate}}</button></div></div></div></div></div></div></div><div class=panel-footer ng-if=!detailsLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.dContainer.dName({id: encId})\" ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceFx(2, \'sc\', \'frame\');\" ng-if=device.info.isCompleted ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceFx(2, \'\', \'frame\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'d.btn.6\' | translate}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.d ng-disabled=\"saveCloseProcessing || saveProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/dName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\" ng-if=!detailsLoading><div ng-if=\"auth.upermissions.fla || auth.upermissions.flae\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray ng-class=\"{\'text-muted\':device.info.dType == \'mc\'}\"><p>2</p></span><div ng-if=\"!device.info.frameLayout || device.info.frameLayout == null\"><i></i><span class=stepGray><p>3</p></span></div></div><div ng-if=\"!auth.upermissions.fla && !auth.upermissions.flae\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></div></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.d>{{\'d.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.1\':\'d.body.2\' | translate}}</span><span ng-if=device.info.label class=text-muted>[ {{device.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'cm.label.55\' | translate}} <span ng-if=\"!auth.upreferences.isPopup && device.info.label\" class=text-muted>[ {{device.info.label}} ]</span></h1><span class=\"stepComment pull-right\" ng-if=\"(!auth.upreferences.isPopup && !detailsLoading) && (auth.upermissions.fla || auth.upermissions.flae)\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span><div ng-if=\"!device.info.frameLayout || device.info.frameLayout == null\"><i></i><span class=stepGray><p>3</p></span></div></span></header><div class=\"panel-body overflow-auto\" style=max-height:{{getAvailableHeight(263)}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div class=row ng-if=!detailsLoading><div class=col-xs-6><div class=form-group><label>{{\'d.label.58\' | translate}}</label><div ng-if=\"encId!=\'\'\"><span class=\"bg-default padLR4\">{{device.info.licId.id}} <span class=text-bold>({{device.info.licId.lt}})</span></span></div><div ng-if=\"encId==\'\'\"><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=lic.isOpen on-toggle=toggleDropDown(open) focus-selected=device.info.licId.id><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=licSearchFocus(); aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=!device.info.licId.id>{{\'d.label.58.1\' | translate}}</span> <span ng-if=device.info.licId.id>{{device.info.licId.id}}</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=\"margin-right:-7px;font-size: 16px;font-weight: 600\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=allLicenseList.length><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchLic.l sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchLic.l.length ng-click=\"searchLic.l=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=allLicenseList.length></li><div class=\"list-scroll ng-cloak\"><div class=msg-warning ng-if=!allLicenseList.length>{{\'d.msg.63\' | translate}}</div>{{takeAllLicLength = (allLicenseList | customSearch:{key:searchLic.l, module:\'dLic\'}); \"\"}}<div class=msg-warning ng-if=\"!takeAllLicLength.length && allLicenseList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchLic.l)}}&quot;</b>\'}\"></div><div ng-repeat=\"lic in licenseList\" tabindex=$index>{{takeLenght = (lic.data | customSearch:{key:searchLic.l, module:\'dLic\'}); \"\"}}<div class=licType ng-click=\"lic[$index]=lic[$index]?false:true\" ng-if=takeLenght.length><label class=noMarB>{{lic.lbl}}</label><span class=\"licGrouping padL5 fa\" ng-class=\"lic[$index]?\'fa-chevron-down\':\'fa-chevron-up\'\" aria-hidden=true></span></div><div ng-show=!lic[$index]><!-- <li class=\"padL20 pad2 listHover\" ng-repeat=\"l in lic.data | customSearch:{key:searchLic.l, module:\'licListing\'} | orderBy: \'l\'\" tabindex=\"$index\" ng-class=\"{\'selected-license\': l.l === device.info.licId.id}\"> --><li class=\"padL20 pad2 listHover\" ng-repeat=\"l in lic.data | customSearch:{key:searchLic.l, module:\'dLic\'} | orderBy: \'l\'\" tabindex=$index ng-class=\"{\'selected-license\': l.l === device.info.licId.id}\"><div class=noMarB ng-model=device.info.licId id={{l.l}} ng-click=\"selectLic(l.l, lic.lbl)\">{{l.l}}<span ng-if=l.c class=\"text-sm licCC\" uib-tooltip=\"{{\'d.label.71\' | translate}}\">{{l.c}}</span></div></li></div></div></div></div></div></div></ul></div><!-- <select id=\"lic\" class=\"form-control\" ng-model=\"device.info.licId\" ng-options=\"lic.l for lic in licenseList track by lic.l\">\r\n              <option value=\"\" disabled>{{\'d.label.49.1\' | translate}}</option>\r\n            </select> --></div></div><div class=form-group><label>{{\'d.label.1\' | translate}}</label><div ng-if=\"encId!=\'\'\"><span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'mp\'\">{{\'d.label.1.1\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'desktop\'\">{{\'d.label.1.7\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'webos\'\">{{\'d.label.1.5\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'tizen\'\">{{\'d.label.1.6\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'mc\'\">{{\'d.label.1.4\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'gf\'\">{{\'d.label.1.2\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'v\'\">{{\'d.label.1.3\' | translate}}</span> <span class=\"bg-default padLR4\" ng-if=\"device.info.dType == \'epd\'\">{{\'d.label.1.8\' | translate}}</span></div><div ng-if=\"encId==\'\'\"><span class=\"bg-default pad2\" ng-if=\"(!auth.upermissions.gf && !auth.upermissions.vd && !auth.upermissions.mc && !auth.upermissions.tizen && !auth.upermissions.epd && !auth.upermissions.webos)\">{{\'d.label.1.1\' | translate}}</span><select class=form-control ng-model=device.info.dType ng-if=\"auth.upermissions.gf || auth.upermissions.vd || auth.upermissions.mc || auth.upermissions.tizen || auth.upermissions.epd || auth.upermissions.webos\" ng-change=changeDeviceType()><option value=mp>{{\'d.label.1.1\' | translate}}</option><option value=webos ng-if=auth.upermissions.webos>{{\'d.label.1.5\' | translate}}</option><option value=tizen ng-if=auth.upermissions.tizen>{{\'d.label.1.6\' | translate}}</option><option value=mc ng-if=auth.upermissions.mc>{{\'d.label.1.4\' | translate}}</option><option value=gf ng-if=auth.upermissions.gf>{{\'d.label.1.2\' | translate}}</option><option value=v ng-if=auth.upermissions.vd>{{\'d.label.1.3\' | translate}}</option><option value=epd ng-if=auth.upermissions.epd>{{\'d.label.1.8\' | translate}}</option></select></div></div><div class=form-group ng-if=\"device.info.dType != \'epd\'\"><label ng-class=\"(auth.upermissions.si && encId==\'\') ? \'marR10\' : \'\'\"><input ng-if=\"auth.upermissions.si && encId==\'\'\" type=radio role=radio name=regType ng-model=device.info.regType value=d><label ng-if=\"auth.upermissions.si && encId==\'\'\"></label>{{\'d.label.2\' | translate}}</label><label class=noMarB ng-if=\"auth.upermissions.si && encId==\'\'\"><input type=radio role=radio name=regType ng-model=device.info.regType value=s><label></label>{{\'d.label.24\' | translate}}</label><input type=text id=mac class=form-control ng-model=device.info.mac ng-if=\"encId==\'\'\" ng-readonly=\"device.info.dType == \'gf\' || device.info.dType == \'v\' || (encId != \'\' && !deviceEdit.reason)\" alpha-num focus-me=true maxlength=50 aria-label=\"{{\'d.label.24\' | translate}}\" aria-labelledby=\"{{\'d.label.24\' | translate}}\"><div ng-if=\"encId!=\'\'\"><span class=\"bg-default padLR4 marR5\">{{device.info.mac}}</span> <a ng-if=\"device.info.dType != \'gf\' && device.info.dType != \'v\' && encId != \'\'\" href=\"\" role=button class=\"fa fa-pencil\" tooltip-placement=top uib-tooltip=\"{{\'d.p_mac.1\' | translate}}\" tooltip-append-to-body=true ng-click=\"deviceIdOpen(device.info.id, device.info.label, device.info.mac, \'dName\');\"></a></div></div><div class=form-group ng-if=\"device.info.dType == \'epd\'\"><label>{{\'d.label.2.3\' | translate}}</label><input type=text id=mac class=form-control ng-model=device.info.mac ng-readonly=\"device.info.dType == \'gf\' || device.info.dType == \'v\'\" alpha-num focus-me=true maxlength=50 aria-label=\"{{\'d.label.2.3\' | translate}}\" aria-labelledby=\"{{\'d.label.2.3\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.71\' | translate}}</label><input type=text id=label class=form-control ng-model=device.info.label placeholder=\"{{\'d.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.label.71\' | translate}}\" aria-labelledby=\"{{\'cm.label.71\' | translate}}\"></div><ng-timezone timezone=device.info.timezone label=true timezone-list=timezoneList></ng-timezone><div ng-if=\"device.info.dType == \'epd\' && decId && device.info.eslInfo && device.info.eslInfo.id\"><label>{{\'d.label.72\' | translate}}</label><div><span class=\"bg-default padLR4\">{{device.info.eslInfo.model}} (Size: {{device.info.eslInfo.size}}, Res: {{device.info.eslInfo.resolution}}, DPI: {{device.info.eslInfo.dpi}})</span></div></div><div class=form-group ng-if=\"device.info.dType == \'epd\' && !decId\"><label>{{\'d.label.72\' | translate}}</label><div ng-if=modelsLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-if=!modelsLoading class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=epd.isOpen on-toggle=toggleDropDown(open) focus-selected=device.info.eslInfo.id><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=epdSearchFocus(); aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=!device.info.eslInfo.id>{{\'d.label.72-1\' | translate}}</span> <span ng-if=device.info.eslInfo.id>{{device.info.eslInfo.model}} (Size: {{device.info.eslInfo.size}}, Res: {{device.info.eslInfo.resolution}}, DPI: {{device.info.eslInfo.dpi}})</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=margin-right:-7px;font-size:16px;font-weight:600></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=epdModels.length><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchEpd.l sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchEpd.l.length ng-click=\"searchEpd.l=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=epdModels.length></li><div class=\"list-scroll ng-cloak\"><div class=msg-warning ng-if=!epdModels.length>{{\'d.msg.63\' | translate}}</div>{{takeAllLicLength = (epdModels | customSearch:{key:searchEpd.l, module:\'dEpd\'}); \"\"}}<div class=msg-warning ng-if=\"!takeAllLicLength.length && epdModels.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchEpd.l)}}&quot;</b>\'}\"></div><div ng-repeat=\"(model, epdList) in epdGrouped\" tabindex=$index>{{takeLenght = (epdList | customSearch:{key:searchEpd.l, module:\'dEpd\'}); \"\"}}<div class=licType ng-click=\"epdList[$index]=epdList[$index]?false:true\" ng-if=takeLenght.length><label class=noMarB>{{model}}</label><span class=\"licGrouping padL5 fa\" ng-class=\"epdList[$index]?\'fa-chevron-down\':\'fa-chevron-up\'\" aria-hidden=true></span></div><div ng-show=!epdList[$index]><li class=\"padL20 pad2 listHover\" ng-repeat=\"epd in epdList | customSearch:{key:searchEpd.l, module:\'dEpd\'} | orderBy: \'model\'\" tabindex=$index ng-class=\"{\'selected-license\': epd.id === device.info.eslInfo.id}\" ng-if=epd.id><div class=noMarB ng-model=device.info.eslInfo id={{epd.id}} ng-click=selectEpdFx(epd)>Size: {{epd.size}}, Res: {{epd.resolution}}, DPI: {{epd.dpi}}</div></li></div></div></div></div></div></div></ul></div></div><!-- <div class=\"form-group\" ng-if=\"device.info.dType == \'epd\'\">\r\n          <label>{{\'cm.label.83\' | translate}}</label>\r\n          <div ng-if=\"encId != \'\'\">{{device.info.eslInfo.size}}</div>\r\n          <div ng-if=\"modelsLoading\"><img alt=\"Loading\" src=\"assets/images/loading-xs.gif\"></div>\r\n          <select class=\"form-control\" ng-if=\"!modelsLoading && encId == \'\'\" ng-model=\"device.info.eslInfo\" ng-options=\"option.size for option in models track by option.size\">\r\n            <option value=\"\" disabled>{{\'cm.label.83.1\' | translate}}</option>\r\n          </select>\r\n        </div> --><!-- <div class=\"form-group\" ng-if=\"device.info.dType == \'epd\' && !modelsLoading\">\r\n          <label>{{\'d.label.26\' | translate}}</label>\r\n          <div ng-if=\"encId != \'\'\">{{device.info.eslInfo.selectedDpi.resolution}}</div>\r\n          <select class=\"form-control\" ng-if=\"encId == \'\'\" ng-model=\"device.info.eslInfo.selectedDpi\" ng-options=\"option.resolution for option in device.info.eslInfo.dpi track by option.resolution\">\r\n            <option value=\"\" disabled>{{\'d.label.26.1\' | translate}}</option>\r\n          </select>\r\n        </div> --><div class=form-group ng-if=auth.upermissions.da.dp><!-- <label class=\"noMarB\"><a href=\"\" role=\"link\" ng-click=\"dpOpen=dpOpen?false:true\">{{\'d.tab.6.8\' | translate}} <span class=\"fa\" ng-class=\"dpOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=\"true\"></span></a></label> --><div class=\"row d-flex align-items-center\"><div class=col-xs-7><label class=\"noMarB marT5\"><a href=\"\" role=link ng-click=\"dpOpen=dpOpen?false:true\">{{\'d.tab.6.8\' | translate}} <span class=fa ng-class=\"dpOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label></div><div class=col-xs-5><div class=searchTbx style=\"float: right\" ng-if=dpOpen><input type=text class=\"form-control input-sm\" ng-model=searchDP.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchDP.text.length ng-click=\"searchDP.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=dpOpen><div ng-if=device.info.properties.length><div class=\"row th\"><div class=col-xs-6>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><!-- (device.info.properties | filter:{\'label\':searchDP.text}) --><li class=row ng-repeat=\"dp in filteredProperties = (device.info.properties | customSearch:{key:searchDP.text, module:\'dp\'})\"><div class=\"col-xs-6 text-ellipsis-wrap\">{{dp.label}} <span ng-if=\"dp.desc != null && dp.desc != \'\'\" class=\"fa fa-info-circle text-primary marL5\" uib-tooltip={{dp.desc}} tooltip-placement=top tooltip-append-to-body=true aria-hidden=true></span></div><div class=col-xs-6><div ng-if=\"dp.vType != \'d\' && dp.vType != \'dt\' && dp.vType != \'ti\'\"><input type=text ng-if=!dp.editable class=\"form-control input-sm\" ng-model=dp.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}> <span ng-if=dp.editable>{{dp.value}}</span></div><!-- Date time format --><div ng-if=\"dp.vType != \'t\'\" ng-class=\"{\'d-flex justify-spaceB\':dp.vType == \'dt\'}\"><div ng-if=\"dp.vType != \'ti\'\" class=input-group ng-class=\"{\'marR10\':dp.vType == \'dt\'}\"><span class=input-group-addon ng-click=selectDateFx(dp)><span class=\"fa fa-calendar\" aria-hidden=true></span></span><!-- {{dp.dateRange = dp.isblank == 1 ? null :dp.dateRange;\"\"}} --> <input ng-show=dp.isblank ng-click=selectDateFx(dp) type=text id=pDateRange class=\"form-control input-sm\" aria-label=pDateRange aria-labelledby=pDateRange> <input ng-show=!dp.isblank type=daterange id=pDateRange class=\"form-control input-sm picker\" ng-model=dp.dateRange format=MM/DD/YYYY opens=left singledatepicker=true readonly aria-label=pDateRange aria-labelledby=pDateRange> <span class=input-group-btn><button class=\"btn btn-sm btn-default height30 noPadT noPadB\" ng-show=!dp.isblank ng-click=clearDateFx(dp); type=button>{{\'cl.widget.mc.11\' | translate}}</button></span></div><span class=timepicker uib-dropdown auto-close=outsideClick ng-if=\"dp.vType == \'dt\' || dp.vType == \'ti\'\"><div class=input-group ng-class=\"{\'marL10\': dp.vType==\'dt\'}\"><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=pTime class=\"form-control input-sm picker\" uib-dropdown-toggle ng-value=\"dp.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=dp.time hour-step=1 minute-step=5></div></div></span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(device.info.properties | customSearch:{key:searchDP.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDP.text)}}&quot;</b>\'}\"></div></ul></div><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=!device.info.properties.length>{{\'ms.p_s.dp.m3\' | translate}}</div></div></div><div class=form-group><!-- <div class=\"col-xs-5\">\r\n            <div class=\"input-group searchTbx\" style=\"float: right;\" ng-if=\"settingsOpen\">\r\n              <input type=\"text\" class=\"form-control input-sm\" ng-model=\"searchDP.text\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength=\"250\">\r\n              <a href=\"\" role=\"link\" class=\"text-danger ng-hide\" ng-show=\"searchDP.text.length\" ng-click=\"searchDP.text=\'\'\"><span class=\"fa fa-remove permissionSearchRemove\" aria-hidden=\"true\"></span></a>\r\n            </div>\r\n          </div> --><div class=\"row d-flex align-items-center marB5\"><div class=col-xs-4><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.label.9\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label></div><div class=col-xs-8><div ng-if=settingsOpen class=\"searchTbx pull-right marT-6 marL5\"><input type=text class=\"form-control input-sm\" ng-model=searchDOInfo.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=!device.info.info.length autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchDOInfo.text.length ng-click=\"searchDOInfo.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div ng-if=settingsOpen ng-class=\"{\'bdrL\':decId}\" class=\"btn-group dropdown marT-6 pull-right padR5 bdrR padL5\" uib-dropdown><button type=button role=button uib-dropdown-toggle class=\"btn btn-default btn-xs padLR10 padT4 padB5\"><span class=\"fa fa-plus noMarR\" aria-hidden=true></span><!-- <span ng-if=\"valueType==\'t\'\">{{\'d.label.50\' | translate}}</span>\r\n                  <span ng-if=\"valueType==\'f\'\">{{\'d.label.51\' | translate}}</span>\r\n                  <span ng-if=\"valueType==\'dt\'\">{{\'d.label.52\' | translate}}</span> --></button><!-- <button type=\"button\" role=\"button\" uib-dropdown-toggle class=\"btn btn-primary noPadT\" style=\"padding-bottom: 3px;\">\r\n                  <span class=\"caret\"></span>\r\n                  <span class=\"fa fa-ellipsis-v marL2 marR3 marT6 marB5\" aria-hidden=\"true\"></span>\r\n                  <span class=\"sr-only\">Toggle Dropdown</span>\r\n                </button> --><ul uib-dropdown-menu role=menu><li><a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'t\';addCustomInfo(valueType);searchDOInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'t\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.15\' | translate}}</a> <a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'f\';addCustomInfo(valueType);searchDOInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'f\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.16\' | translate}}</a> <a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'dt\';addCustomInfo(valueType);searchDOInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'dt\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.49\' | translate}}</a></li></ul></div><div ng-if=\"settingsOpen && decId\" class=\"pad5 marT-5 pull-right marLR5\"><a href=\"\" role=link id=refresh ng-click=refreshOInfoFx(); uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingInfo><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingInfo}\" aria-hidden=true></span></a></div></div><!-- <div class=\"col-xs-6\">\r\n              <label class=\"noMarB\"><a href=\"\" role=\"link\" ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.label.9\' | translate}} <span class=\"fa\" ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=\"true\"></span></a></label>\r\n            </div> --></div><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=settingsOpen><img alt=Loading src=assets/images/loading.gif class=padTB10 ng-if=loadingInfo><div ng-if=!loadingInfo><div class=\"row th\"><div class=col-xs-5>{{\'d.label.10\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"i in filteredDeviceInfo = (device.info.info | customSearch:{key:searchDOInfo.text, module:\'dp\'})\"><div ng-if=i.isEditable><div class=col-xs-5><input type=text class=\"form-control input-sm\" ng-model=i.label aria-label=\"{{\'d.label.10\' | translate}}\" aria-labelledby=\"{{\'d.label.10\' | translate}}\"></div><div ng-if=\"i.vType!=\'f\' && i.vType!=\'dt\'\" class=col-xs-6><input type=text class=\"form-control input-sm\" ng-model=i.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}></div><div ng-if=\"i.vType==\'f\'\" class=col-xs-6><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"i.vFile.thumb && i.vFile.isAccessible\"><a href=\"\" role=link class=thumb-close ng-click=removeImgFx($index);><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=i.vFile.thumb ng-href=\"{{cDetailBucket + i.vFile.thumb | secureThumb}}\" role=button data-access={{i.vFile.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(i.vFile.path + (i.vFile.path.length > 1 ? \' / \' : \' \') + i.vFile.label)}}\" ng-show=i.vFile.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + i.vFile.thumb + inputImgThumbParam}}\"></a></div><div class=\"pull-left relative\" ng-if=\"i.vFile && !i.vFile.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=emptyThumb-md></div><button type=button role=button class=\"btn btn-primary marT5 btn-xs\" ng-click=selectContentOpen($index);>{{\'cl.btn.5\' | translate | camelCase}}</button></div></div><div ng-if=\"i.vType==\'dt\'\" class=col-xs-6 ng-class=\"{\'d-flex justify-spaceB\':i.vType == \'dt\'}\"><div class=input-group ng-class=\"{\'marR10\':i.vType == \'dt\'}\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input ng-show=i.isblank ng-click=selectDateFx(i) type=text id=iDateRange class=\"form-control input-sm\" aria-label=iDateRange aria-labelledby=iDateRange> <input ng-show=!i.isblank type=daterange id=iDateRange class=\"form-control input-sm picker\" ng-model=i.dateRange format=MM/DD/YYYY opens=left singledatepicker=true readonly aria-label=iDateRange aria-labelledby=iDateRange><!-- <input type=\"daterange\" id=\"dateRange\" class=\"form-control input-sm picker\" ng-model=\"i.dateRange\" format=\"MM/DD/YYYY\" opens=\"left\" singleDatePicker=\"true\" readonly=\"\" aria-label=\"dateRange\" aria-labelledby=\"dateRange\"> --> <span class=input-group-btn><button class=\"btn btn-sm btn-default height30 noPadT noPadB\" ng-show=!i.isblank ng-click=clearDateFx(i); type=button>{{\'cl.widget.mc.11\' | translate}}</button></span></div><span class=timepicker uib-dropdown auto-close=outsideClick ng-if=\"i.vType == \'dt\'\"><div class=input-group ng-class=\"{\'marL10\': i.vType==\'dt\'}\"><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=iTime class=\"form-control input-sm picker\" uib-dropdown-toggle ng-value=\"i.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=i.time hour-step=1 minute-step=5></div></div></span></div></div><div ng-if=\"i.isEditable || i.vType==\'dt\'\" class=col-xs-1><a href=\"\" role=link ng-click=removeCustomInfo(i.id)><span class=\"fa fa-remove text-danger marT7\" aria-hidden=true></span></a></div><div ng-if=!i.isEditable><div class=col-xs-5>{{i.label}}</div><div class=\"col-xs-6 text-ellipsis-wrap\">{{i.value}}</div><div class=col-xs-1></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"searchDOInfo.text.length && (device.info.info | customSearch:{key:searchDOInfo.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDOInfo.text)}}&quot;</b>\'}\"></div></ul></div></div></div><!-- App Switches --><div class=form-group ng-if=\"auth.uType==0 || auth.uType==1\"><div class=\"row d-flex align-items-center\"><div class=col-xs-7><label class=noMarB><a href=\"\" role=link ng-click=\"asOpen=asOpen?false:true\">{{\'ms.p_s.tab.12\' | translate}} <span class=fa ng-class=\"asOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label></div><div class=col-xs-5><div class=searchTbx style=\"float: right\" ng-if=asOpen><input type=text class=\"form-control input-sm\" ng-model=searchAS.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchAS.text.length ng-click=\"searchAS.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=asOpen><div ng-if=device.info.switches.length><div class=\"row th\"><div class=col-xs-6>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"as in filteredswitches = (device.info.switches | customSearch:{key:searchAS.text, module:\'dp\'})\"><div class=\"col-xs-6 text-ellipsis-wrap\">{{as.label}} <span ng-if=\"as.desc != null && as.desc != \'\'\" class=\"fa fa-info-circle text-primary marL5\" uib-tooltip={{as.desc}} tooltip-placement=top tooltip-append-to-body=true aria-hidden=true></span></div><div class=col-xs-6><div><input type=text ng-if=!as.editable class=\"form-control input-sm\" ng-model=as.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}> <span ng-if=as.editable>{{as.value}}</span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"searchAS.text.length && (device.info.switches | customSearch:{key:searchAS.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchAS.text)}}&quot;</b>\'}\"></div></ul></div><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=!device.info.switches.length>{{\'ms.p_s.as.m1\' | translate}}</div></div></div><div class=form-group ng-if=\"auth.upermissions.dc && device.info.dType != \'desktop\' && device.info.dType != \'mc\' && decId\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deviceControlOpen(device.info.id, device.info.label, device.info.dType, device.info.os, device.info.webOSisActive);\"><span class=\"glyphicon glyphicon-cog\" aria-hidden=true></span>{{\'d.brief.13\' | translate}}</button></div><div class=form-group><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=device.permission pid=decId module=\"\'device\'\"></ng-permission-brief></div><div class=form-group ng-if=\"device.info.dType == \'gf\'\"><div id=azMap style=height:300px></div></div></div></div></div><div class=panel-footer ng-if=!detailsLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceFx(1, \'sc\', \'info\');\" ng-disabled=\"saveCloseProcessing || saveProcessing\" ng-if=device.info.isCompleted><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceFx(1, \'\', \'info\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\" ng-if=\"device.info.dType != \'mc\' && device.info.dType != \'epd\' && (device.info.frameLayout == null || !device.info.frameLayout) && (auth.upermissions.fla || auth.upermissions.flae)\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'d.btn.9\' | translate | camelCase}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceFx(1, \'\', \'info\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\" ng-if=\"device.info.dType != \'mc\' && device.info.dType != \'epd\' && (device.info.frameLayout || (!auth.upermissions.fla && !auth.upermissions.flae))\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'d.btn.6\' | translate}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceFx(2, \'\', \'info\');\" ng-disabled=\"saveProcessing || eslNotAuth || saveCloseProcessing\" ng-if=\"device.info.dType == \'mc\' || device.info.dType == \'epd\'\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'d.btn.6\' | translate}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.d ng-disabled=\"saveCloseProcessing || saveProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'idInvalid\'\" aria-live=polite role=status>{{\'d.msg.11\' | translate}}</div><div ng-if=\"errType==\'idExists\'\" aria-live=polite role=status>{{\'d.msg.5\' | translate}}</div><div ng-if=\"errType==\'siExists\'\" aria-live=polite role=status>{{\'d.msg.45\' | translate}}</div><div ng-if=\"errType==\'outher\'\" aria-live=polite role=status>{{\'d.msg.28\' | translate}}</div><div ng-if=\"errType==\'fence\'\" aria-live=polite role=status>{{\'d.msg.7\' | translate}}</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'eslAuth\'\" aria-live=polite role=status>{{\'d.msg.51\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'d.msg.6\' | translate}}</div><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'d.msg.32\' | translate}}</div><div ng-if=\"errType==\'lic\'\" aria-live=polite role=status>{{\'d.label.58.1\' | translate}}</div><div ng-if=\"errType==\'haveOne\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m6\' | translate}}</div></div><div class=clearfix></div></div></section><script src=https://atlas.microsoft.com/sdk/javascript/drawing/1/atlas-drawing.min.js></script>");
$templateCache.put("app/devices/dTag.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\" ng-if=\"!detailsLoading && device.info.dType != \'mc\' && device.info.dType != \'epd\'\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span ng-class=\"(device.info.frameLayout == null || !device.info.frameLayout)?\'stepGreen\':\'stepBlue\'\"><p class=\"fa fa-check-circle fa-lg\" ng-if=\"device.info.frameLayout == null || !device.info.frameLayout\" aria-hidden=true></p><p ng-if=device.info.frameLayout>2</p></span><div ng-if=\"device.info.frameLayout == null || !device.info.frameLayout\"><i></i><span class=stepBlue><p>3</p></span></div></span><span class=\"stepComment pull-right\" ng-if=\"!detailsLoading && (device.info.dType == \'mc\' || device.info.dType == \'epd\')\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=\"stepGray text-muted\"><p>2</p></span><div ng-if=\"device.info.frameLayout == null || !device.info.frameLayout\"><i></i><span class=stepBlue><p>3</p></span></div></span><a href=\"\" role=link ui-sref=hub.devices.d class=marR10>{{\'d.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.1\':\'d.body.2\' | translate}}</span><span ng-if=device.info.label class=text-muted>[ {{device.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\':!auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1><span ng-if=\"device.info.frameLayout && !detailsLoading\">{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}</span><span ng-if=\"!device.info.frameLayout && !detailsLoading\">{{\'cm.label.65\' | translate:\'{stepNo: 3}\'}}</span>: {{\'d.btn.6\' | translate | capitalize}} <span ng-if=\"!auth.upreferences.isPopup && device.info.label\" class=text-muted>[ {{device.info.label}} ]</span></h1><span class=\"stepComment pull-right\" ng-if=\"!auth.upreferences.isPopup && !detailsLoading\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span ng-class=\"!device.info.frameLayout?\'stepGreen\':\'stepBlue\'\"><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true ng-if=!device.info.frameLayout></p><p ng-if=device.info.frameLayout>2</p></span><div ng-if=!device.info.frameLayout><i></i><span class=stepBlue><p>3</p></span></div></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><div class=row ng-if=!detailsLoading><div class=\"col-xs-12 col-lg-7\"><div class=row><div class=col-xs-5><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link aria-label=sorting id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link aria-label=vMenu1 id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', curTags.availableTags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', curTags.availableTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curTags.availableTags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{curTags.availableTags.length}} ]</span></label>{{curATEM = (curTags.availableTags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input maxlength={{inputLimit}} placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curTags.availableTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><img alt=Loading src=assets/images/loading.gif ng-if=DeviceTagList><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curTags.availableTags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\" ng-if=!DeviceTagList><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'a\', option, curTags.availableTags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div></div></div><div class=\"col-xs-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-block marT50\" ng-click=\"listManipulateFx(\'add\', curTags.availableTags, curTags.assignedTags, tags.available,\'\',\'\',\'t\');\" ng-class=\"{\'disabled\': !curTags.availableTags.length}\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-block\" ng-click=\"listManipulateFx(\'remove\', curTags.availableTags, curTags.assignedTags, tags.assigned,\'\',\'\',\'t\'); asTList=\'\';\" ng-class=\"{\'disabled\': !curTags.assignedTags.length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-5><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link aria-label=sorting1 id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link aria-label=vMenu2 id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', curTags.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', curTags.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curTags.assignedTags.length > 1?\'d.label.6s\':\'d.label.6\' | translate}} <span class=\"text-sm text-muted\">[ {{curTags.assignedTags.length}} ]</span></label>{{curASTEM = (curTags.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curTags.assignedTags.length ng-model=asTList sanitize-input maxlength={{inputLimit}} placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curTags.assignedTags.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><img alt=Loading src=assets/images/loading.gif ng-if=DeviceTagList><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curTags.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\" ng-if=!DeviceTagList><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'s\', option, curTags.assignedTags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div></div></div></div><div class=row ng-if=auth.upermissions.dt><div class=col-xs-5><div class=form-group><label for=label>{{\'d.label.3\' | translate}}</label><div class=input-group><input type=text id=label class=form-control ng-model=tag.info.label autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'d.label.3\' | translate}}\" aria-labelledby=\"{{\'d.label.3\' | translate}}\"> <span class=input-group-btn><button type=button role=button class=\"btn btn-default\" ng-click=createTagFx();>{{\'cm.btn.19\' | translate}}</button></span></div></div></div></div><div class=row><div class=col-xs-12><label><a href=\"\" role=link ng-click=\"tagsOpen = tagsOpen ? false : true\">{{\'d.body.5\' | translate}}</a></label><div class=tagsQuad ng-if=tagsOpen><p>{{\'d.info.dt1\' | translate}}</p><p>{{\'d.info.dt2\' | translate}}</p><p>{{\'d.info.dt3\' | translate}}</p></div></div></div></div></div></div><div class=panel-footer ng-if=!detailsLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.dContainer.dFrameLayout({id: encId})\" ng-disabled=saveCloseProcessing ng-if=\"device.info.dType != \'mc\' && device.info.dType != \'epd\' && (device.info.frameLayout == null || !device.info.frameLayout) && (auth.upermissions.fla || auth.upermissions.flae)\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.dContainer.dName({id: encId})\" ng-disabled=saveCloseProcessing ng-if=\"(device.info.dType == \'mc\' || device.info.dType == \'epd\') && device.info.frameLayout || (!auth.upermissions.fla && !auth.upermissions.flae)\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceFx(3, \'sc\', \'tag\');\" ng-disabled=saveCloseProcessing><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=resetT(); ui-sref=hub.devices.d ng-disabled=saveCloseProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_tag.m1\' | translate}}</div><div ng-if=\"errType==\'tag\'\" aria-live=polite role=status>{{\'d.p_tag.m2\' | translate}}</div><div ng-if=\"errType==\'deviceType\'\" aria-live=polite role=status>{{\'d.p_tag.m3\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/devices.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading><!-- <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"selectedTab == \'hub.devices.d\' && devicesLoading\"> --> <span ng-if=!devicesLoading><button type=button role=button class=\"btn btn-primary\" ui-sref=hub.dContainer.dName ng-if=\"selectedTab == \'hub.devices.d\' && auth.upermissions.d && devices.info.l > 0 && !advSApply\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'d.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ui-sref=hub.dContainer.dgName ng-if=\"selectedTab == \'hub.devices.dg\' && auth.upermissions.dg\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'d.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ui-sref=hub.dContainer.dtName ng-if=\"selectedTab == \'hub.devices.dt\' && auth.upermissions.dt\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'d.btn.3\' | translate}}</button> <button type=button role=button ng-if=\"selectedTab == \'hub.devices.d\' && auth.upermissions.df && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && !advSApply\" class=\"btn btn-default\" ng-click=\"folderCUOpen(\'n\');\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.3\' | translate}}</button><!-- ng-if=\"auth.upermissions.tf\" --> <span ng-if=\"selectedTab == \'hub.devices.d\'\"><span ng-if=\"selectedTab == \'hub.devices.d\' && (devices.info.l >= 0 || avLic >= 0)\" class=\"marL10 licenseText\">{{\'d.body.1\' | translate: {reman: devices.info.l} }}</span><span class=marRL10 ng-if=\"auth.uservices.bp && (devices.info.l >= 0 || avLic >= 0)\">|</span> <a href=\"\" role=link ui-sref=hub.billing.o ng-if=\"auth.uservices.bp && (devices.info.l >= 0 || avLic >= 0)\">{{\'b.label.15\' | translate}}</a></span> <button type=button role=button class=\"btn btn-primary\" ui-sref=hub.dContainer.dvwName ng-if=\"selectedTab == \'hub.devices.dvw\' && auth.upermissions.dvw && auth.upermissions.cdvw\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'d.btn.31\' | translate}}</button></span></div><div class=\"col-xs-3 col-lg-2 text-right\" ng-show=\"selectedTab != \'hub.devices.di\'\"><label for=searchBox class=lableHidden>Search</label><div class=searchTbx ng-class=\"{\'input-group\': selectedTab == \'hub.devices.d\'}\"><!-- ng-keyup=\"scheduleSearchFx(searchText)\" --> <input type=text class=form-control id=searchBox ng-model=search.text sanitize-input maxlength=250 ng-change=dSearchFx(search.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"search.text=\'\'; dSearchFx();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"selectedTab == \'hub.devices.d\'\"><!-- <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle aria-label=\"advSearch\" aria-labelledby=\"advSearch\"><span class=\"fa fa-sort noMarR\"></span></button>\r\n        <ul class=\"dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r\n          <li><a href=\"\" ng-click=\"advancedSearchOpen(\'d\', \'d\', curDType.type);\">{{\'cm.body.10\' | translate}}</a></li>\r\n        </ul> --> <button id=advSearch type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"advancedSearchOpen(\'d\', \'d\', curDType.type);removeHighlightFx();\" ng-disabled=isPageApiLoad><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></span></div></div><!-- Advanced Search --><div class=clearfix></div><advanced-search ng-if=\"selectedTab!=\'hub.devices.di\'\" adv-search-info=advSearchInfo></advanced-search></div><div class=spaceH></div><div class=spaceH></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs d\" role=tablist aria-owns=\"tab-fl tab-fla tab-ufl tab-ifl tab-fll\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.d\')}}\" aria-controls=tab-d1 id=tab-d1 class=tab-success ng-if=!auth.upreferences.sdtf><a ui-sref=.d role=link>{{\'d.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.dt\')}}\" aria-controls=tab-dt1 id=tab-dt1 class=tab-success ng-if=auth.upreferences.sdtf ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a ui-sref=.dt role=link ng-disabled=\"isPageApiLoad || devicesLoading\">{{\'d.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.dt\')}}\" aria-controls=tab-dt2 id=tab-dt2 class=tab-info ng-if=!auth.upreferences.sdtf ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a ui-sref=.dt role=link ng-disabled=\"isPageApiLoad || devicesLoading\">{{\'d.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.d\')}}\" aria-controls=tab-d2 id=tab-d2 class=tab-info ng-if=auth.upreferences.sdtf ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a ui-sref=.d role=link ng-disabled=\"isPageApiLoad || devicesLoading\">{{\'d.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.dvw\')}}\" aria-controls=tab-dg id=tab-dg class=tab-primary ng-if=auth.upermissions.dvw><a ui-sref=.dvw role=link>{{\'d.label.62\' | translate}}</a></li><!-- <li ui-sref-active=\"active\" role=\"tab\" class=\"tab-success\">\r\n        <a ng-if=\"!auth.upreferences.sdtf\" ui-sref=\".d\" role=\"button\">{{\'d.tab.1\' | translate}}</a>\r\n        <a ng-if=\"auth.upreferences.sdtf\" ui-sref=\".dt\" role=\"button\">{{\'d.tab.3\' | translate}}</a>\r\n      </li>\r\n      <li ui-sref-active=\"active\" role=\"tab\" class=\"tab-info\">\r\n        <a ng-if=\"!auth.upreferences.sdtf\" ui-sref=\".dt\" role=\"button\">{{\'d.tab.3\' | translate}}</a>\r\n        <a ng-if=\"auth.upreferences.sdtf\" ui-sref=\".d\" role=\"button\">{{\'d.tab.1\' | translate}}</a>\r\n      </li> --><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.dg\')}}\" aria-controls=tab-dg id=tab-dg class=tab-primary ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a ui-sref=.dg role=link ng-disabled=\"isPageApiLoad || devicesLoading\">{{\'d.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.devices.di\')}}\" aria-controls=tab-di id=tab-di class=tab-primary ng-if=\"auth.uType != 4 && (auth.upermissions.da.sir || auth.upermissions.da.is || auth.upermissions.da.oi || auth.upermissions.da.ti || auth.upermissions.da.dp || auth.upermissions.da.ar || auth.upermissions.da.dt || auth.upermissions.da.du || auth.upermissions.da.dw || auth.upermissions.da.ed || auth.upermissions.emType==\'cb\')\" ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a ui-sref=.di role=link ng-disabled=\"isPageApiLoad || devicesLoading\">{{\'d.tab.6\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right ng-if=\"selectedTab != \'hub.devices.di\' && !isGbdt\" uib-dropdown ng-class=\"{\'cursorDisabled\':(isPageApiLoad || devicesLoading)}\"><a href=\"\" role=link id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-placement=left ng-disabled=\"isPageApiLoad || devicesLoading\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': devices.info.sortType === \'label\' && devices.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-click=\"sortFx(\'label\', \'asc\', devices.devices, devices.info, \'devicesort\', devices.searches, devices.folders);\">{{\'cm.tool.1.4\' | translate}}</a> <a href=\"\" role=link ng-if=\"selectedTab == \'hub.devices.dt\'\" ng-click=\"sortFx(\'label\', \'asc\', devices.deviceTags, devices.info, \'devicesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': devices.info.sortType === \'label\' && devices.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-click=\"sortFx(\'label\', \'desc\', devices.devices, devices.info, \'devicesort\', devices.searches, devices.folders);\">{{\'cm.tool.1.5\' | translate}}</a> <a href=\"\" role=link ng-if=\"selectedTab == \'hub.devices.dt\'\" ng-click=\"sortFx(\'label\', \'desc\', devices.deviceTags, devices.info, \'devicesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li role=menuitem ng-if=\"selectedTab != \'hub.devices.dt\'\" class=divider></li><li role=menuitem ng-if=\"selectedTab != \'hub.devices.dt\'\" class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li role=menuitem ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-class=\"{\'selected\': devices.info.sortType === \'createdon\' && devices.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-click=\"sortFx(\'createdon\', \'asc\', devices.devices, devices.info, \'devicesort\', devices.searches, devices.folders);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-class=\"{\'selected\': devices.info.sortType === \'createdon\' && devices.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-if=\"selectedTab != \'hub.devices.dt\'\" ng-click=\"sortFx(\'createdon\', \'desc\', devices.devices, devices.info, \'devicesort\', devices.searches, devices.folders);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=pull-right ng-if=\"selectedTab == \'hub.devices.d\' && !isGbdt\" uib-dropdown ng-class=\"{\'cursorDisabled\':(isPageApiLoad || devicesLoading)}\"><a href=\"\" role=link aria-label=filter id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" ng-class=\"{\'active\': (filter==\'online\'||filter==\'offline\')}\" ng-disabled=\"isPageApiLoad || devicesLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filter==\'online\'||filter==\'offline\')}\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li role=menuitem ng-class=\"{\'selected\': filter == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" role=link ng-click=\"filterFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': filter == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" role=link ng-click=\"filterFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem ng-class=\"{\'selected\': filter == \'all\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" role=link ng-click=\"filterFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right ng-if=\"selectedTab != \'hub.devices.di\'\" uib-dropdown><a href=\"\" role=link id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=\"selectedTab == \'hub.devices.d\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'d\');\" translate=\"{{\'d.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.devices.dg\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'dg\');\" translate=\"{{\'d.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.devices.dt\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'dt\');\" translate=\"{{\'d.tool.6\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.devices.dvw\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'dvw\');\" translate=\"{{\'d.tool.22\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li></ul></div><div class=pull-right ng-if=\"selectedTab == \'hub.devices.d\' && !isGbdt\" ng-class=\"{\'cursorDisabled\':isPageApiLoad}\"><a href=\"\" role=link id=listView uib-tooltip={{deviceViewText}} ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx(); removeSelectedFx();\" ng-disabled=isPageApiLoad><span class=\"glyphicon glyphicon-th\" ng-class=\"{\'glyphicon-th-list\':auth.upreferences.deviceView == \'t\'}\" aria-hidden=true></span></a></div><!-- D={{folderList.length}} --><div class=pull-right ng-if=\"selectedTab == \'hub.devices.d\' && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && ((treeList != \'0\' && treeList.length > 0) || (treeList.length==0 && treeLoading) || dData.folders.length > 0 || devices.devices.length > 0 || breadCrumbs.length > 0)\"><!-- <div class=\"pull-right\" ng-if=\"selectedTab == \'hub.devices.d\' && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && ((treeList != \'0\' && treeList.length > 0) || dData.folders.length > 0 || dData.devices.length > 0 || breadCrumbs.length > 0)\"> --><!-- <div class=\"pull-right\" ng-if=\"selectedTab == \'hub.devices.d\' && (dData.folders.length > 0 || dData.devices.length > 0 || breadCrumbs.length > 0)\"> --> <a href=\"\" role=link id=tree ng-click=\"preferencesFx(\'isDFTreeOpen\');\" ng-class=\"{\'active\': uPreferences.isDFTreeOpen == 1}\" uib-tooltip=\"{{\'cl.tool.12\' | translate}}\"><span class=\"fa fa-sitemap\" aria-hidden=true></span></a></div><div class=pull-right ng-if=\"selectedTab != \'hub.devices.di\'\"><a href=\"\" role=link id=refresh ng-click=\"loadSelectedTab(\'refresh\'); search.text=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingMain><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></span></a></div><div class=pull-right ng-if=\"selectedTab == \'hub.devices.dt\' && devices.deviceTags.length && devices.info.uDelete\" uib-tooltip=\"{{\'d.tool.7\' | translate}}\"><a href=\"\" role=link id=delete ng-click=\"deleteOpen(\'tags\', deletableTags);\" ng-class=\"{\'text-disabled disabled\':(deletableTags.length == 0)}\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=true></span></a></div><div class=\"pull-right hide\" ng-if=\"selectedTab == \'hub.devices.d\'\"><a href=\"\" role=link id=download uib-tooltip=\"{{\'d.tool.12\' | translate}}\" ng-click=showDownloadFx(); ng-class=\"{\'active\':showDownload}\"><span class=\"fa fa-download\" aria-hidden=true></span></a></div><div class=\"pull-right disabled\" ng-if=\"selectedTab == \'hub.devices.d\' && auth.upermissions.edl && ((!isGbdt && !isAdvSearchMsg && !isSearchMsg && !isFilterMsg && !devices.types.length > 0)) && (devices.devices.length > 0 || (!devices.devices && devices.types.length > 0))\"><a href=\"\" role=link id=downloadList uib-tooltip=\"{{\'d.tool.14\' | translate}}\" ng-click=\"openGroupDevices(\'\', devices, curFolderId, null, null, null, advSearchInfo);removeHighlightFx();\" ng-disabled=exDevicesProcessing><span class=\"fa fa-download\" aria-hidden=true></span></a></div></div><!-- {{filterCount}} / {{devicesLength}} --><!-- <div class=\"pull-right pad10\" ng-if=\"selectedTab == \'hub.devices.d\'\"><div class=\"pad2\"><span ng-if=\"filterStatus\">{{filterCount}} / </span><span ng-if=\"devicesLength\">{{devicesLength}}</span></div></div> --><!-- <div class=\"pull-right pad10\" ng-if=\"selectedTab == \'hub.devices.d\'\"><div class=\"pad2\"><span ng-if=\"filterStatus\">{{filterCount}} <span ng-if=\"filterCount >= 0 && devicesLength && !advSearchInfo.isEmpty\">/</span> </span><span ng-if=\"devicesLength && !advSearchInfo.isEmpty\">{{devicesLength}}</span></div></div> --><div class=\"pull-right pad10\" ng-if=\"selectedTab == \'hub.devices.d\'\"><div class=pad2><!-- ng-if=\"filterCount || devicesLength\" --> <span><!-- <span ng-if=\"filterCount>=0 && ((!auth.upermissions.dgrp.dgrp || auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'dt\') || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'df\' && (filter == \'online\' || filter == \'offline\')))\">{{filterCount}} /</span> {{devicesLength}}</span> --><!-- <span ng-if=\"auth.upermissions.dp\">{{filterCount}} / {{devicesLength}}</span>\r\n        <span ng-if=\"!auth.upermissions.dp\"><span ng-if=\"filterCount!=null\">{{filterCount}} /</span> {{devicesLength}}</span> --> <img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> <span ng-if=!devicesLoading>{{visibleDevices}} / {{totalDeviceOnServer}}</span> </span><!-- && (!auth.upermissions.dgrp.dgrp || auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'dt\') --></div></div></header><div class=panel-body ui-selectable-drag-drop ng-class=\"{\'noPadB\':(auth.upermissions.dp && selectedTab == \'hub.devices.d\' && devices.devices.length && !devicesLoading)}\"><div ui-view=tabView role=tabpanel></div></div><!--Button Quad--><div class=selectedQuad ng-if=\"selectedTab == \'hub.devices.d\' && dASAll.length\"><div class=panel-footer><div class=text-right><img alt=Loading src=assets/images/loading.gif ng-if=dASAllBtnLoading> <a href=\"\" role=link class=\"pull-left marT6\" ng-click=btnInfoOpen(deviceBtn.info); ng-if=deviceBtn.info.length><img alt=\"\" src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"deviceBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=deviceBtn><li ng-repeat=\"dBtn in deviceBtn.buttons\"><div ng-if=\"dBtn.key==\'tEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=\"fa fa-tags\" aria-hidden=true></span>{{\'d.tab.3\' | translate}} <span class=caret></span></button><ul uib-dropdown-menu role=menu><li ng-repeat=\"step in dBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'tStep1\'\" ng-click=\"addRemoveTagOpen(\'a\');\">{{\'fl.btn.5\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'tStep2\'\" ng-click=\"addRemoveTagOpen(\'r\');\">{{\'cm.btn.20\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"dBtn.key==\'dAddToGroup\'\" ng-click=addToGrpOpen(); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.29\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dSimilar\'\" ng-click=similarOpen(); class=\"btn btn-default\"><span class=\"fa fa-object-group\" aria-hidden=true></span>{{\'d.btn.10\' | translate}}</button></li></ul></div></div></div><!--Button Quad End--></section><!--For Selected Item Brief--><!-- <div ng-class=\"(pinStatus==1 && !isAcknoledgeOpen && auth.upreferences.deviceView != \'l\' && selectedItems[0].type != \'device\')?\'pinGap\':\'\'\" ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div> --><!-- <ng-device-brief ng-if=\"selectedItems.length > 0\"></ng-device-brief> --><div class=pinGap ng-if=\"pinStatus && auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-device-brief ng-if=\"(selectedItems.length > 0 && selectedTab != \'hub.devices.d\') || (selectedItems.length > 0 && auth.upreferences.deviceView == \'l\' && selectedItems[0].type == \'device\' && selectedTab == \'hub.devices.d\') || (selectedItems.length > 0 && auth.upreferences.deviceView == \'t\' && selectedTab == \'hub.devices.d\')\"></ng-device-brief><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && isAcknoledgeOpen\"></div><div class=selectedQuad ng-if=\"selectedTab == \'hub.devices.di\' && isAcknoledgeOpen\"><!--For Selected Item Brief--><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><div class=panel-heading><p>{{\'em.body.5\' | translate}}</p><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=acknowledgeCloseFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></div><div class=panel-body ng-style=\"pinStatus == 1 && {\'max-height\':\'275px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=acknowledgeLoading><ul class=list-unstyled ng-if=\"!acknowledgeLoading && allScrollDataList.length > 0\"><div class=table><!-- table-md --><div class=\"row th\"><div class=col-xs-8>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'cm.label.46\' | translate}}</div></div><!-- ng-class=\"{\'scrollQuad\': auth.upreferences.isPin == 1}\" --><div class=scrollQuad style=height:205px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=\"\" have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{acNow.id}} ng-repeat=\"acNow in visibleData\"><div class=col-xs-8><div class=\"marR5 deviceStatus {{acNow.status}}\" uib-tooltip=\"{{acNow.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{acNow.l}}</div><div class=col-xs-4><span ng-if=\"acNow.st == 0\" class=\"text-danger text-bold\">{{\'em.body.6\' | translate}}</span> <span ng-if=\"acNow.st == 1\" class=\"text-success text-bold\">{{\'em.body.7\' | translate}}</span> <span ng-if=\"acNow.st == 2\">{{\'cl.widget.queue.1\' | translate}}</span> <span class=\"text-muted text-sm marL10\" ng-if=acNow.aOn>{{(acNow.aOn * 1000) | date:\"medium\"}}</span></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div></div></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!acknowledgeLoading && allScrollDataList.length == 0\">{{\'d.msg.19\' | translate}}</div></div></section></div>");
$templateCache.put("app/devices/dg.html","<img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div context-menu=contextMenuBase><div class=row ng-if=!devicesLoading><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-device-group-thumb class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=devices></ng-device-group-thumb></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.groups.length + devices.searches.length == 0\"><p>{{\'d.msg.2\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'dg\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'d.tool.5\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && !devices.devices.length + !devices.searches.length\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div> --></div>");
$templateCache.put("app/devices/dgDevice.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.dg>{{\'cm.label.79s\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.2\':\'d.p_dg.2\' | translate}}</span><span ng-if=deviceGroup.info.label class=text-muted>[ {{deviceGroup.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><!-- With tag --><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'d.btn.13\' | translate | capitalize}}<!-- Without tag --> <span class=\"marL5 text-sm\">({{\'cm.label.26\' | translate}})</span></h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=deviceGrpLoading class=pad10><div class=row ng-if=!deviceGrpLoading><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo class=col-xs-12></advanced-search><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=\"pull-right marRL10 filterIcon\" ng-if=\"selectedTab == \'hub.dContainer.dgDevice\' && selectedT==\'1\'\" uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || moreDeviceLoading || devicesLoading}\"><!-- <a href=\"\" id=\"filter\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\"></span></a> --> <a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\" ng-disabled=\"isPageApiLoad || devicesLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\', \'disabled\':((!isObjectEmpty(advSearchInfo)) || addStatusKeyVal.value)}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':((!isObjectEmpty(advSearchInfo)) || addStatusKeyVal.value)}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':((!isObjectEmpty(advSearchInfo)) || addStatusKeyVal.value)}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=\"pull-right dropdown\" uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || showRemainingList}\"><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle ng-disabled=\"isPageApiLoad || showRemainingList\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=\"selectedT == \'1\'\"><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'dg\', \'dg\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li ng-if=\"selectedT == \'1\'\"><a href=\"\" role=link ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\">{{deviceViewText}}</a></li><li><a href=\"\" role=link ng-click=\"checkboxFx(\'all\'); selectedSearch.text=\'\';resetSelPagination(\'all\')\">{{\'cm.btn.44\' | translate}}</a></li><!-- <li ng-if=\"selectedT == \'1\'\" class=\"divider\" role=\"separator\"></li> --><!-- <li ng-if=\"selectedT == \'1\'\"><a href=\"\" role=\"link\" ng-click=\"importOpen();\">{{\'d.p_dg.4\' | translate}}</a></li> --></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchTextS.text sanitize-input maxlength=250 ng-change=\"searchChangeFx(\'\', searchTextS.text)\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextS.text.length ng-click=\"searchChangeFx(\'empty\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><!-- With tag --><div class=panel-inner-tab><!-- ng-class=\"{\'cursorDisabled\':isPageApiLoad}\" --><!-- Show Tag First --> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad}\"><a ng-if=auth.upreferences.sdtf href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\" ng-disabled=isPageApiLoad>{{\'d.brief.6\' | translate}}</a></span> <a ng-if=auth.upreferences.sdtf href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'cm.label.4s\' | translate}}</a><!-- Show Tag as Usual --> <a ng-if=!auth.upreferences.sdtf href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'cm.label.4s\' | translate}}</a> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad}\"><a ng-if=!auth.upreferences.sdtf href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\" ng-disabled=isPageApiLoad>{{\'d.brief.6\' | translate}}</a></span></div><!-- Without tag --></div><div class=\"overflow-auto pad10 bg-light\" ng-if=\"selectedT==\'1\'\" ng-attr-style=height:{{quadHeight}}px; ng-scroll=timerFxToLoadData();><!-- ?New: start --><div ng-if=\"!devicesLoading && breadCrumbs.length && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" class=breadcrumb><a href=\"\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\"></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\"></span> {{\'cm.btn.41\' | translate}}</a></div><!-- ?New: end --> <img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div ng-if=\"isExcelData && !devicesLoading\" class=msg-warning lang={{auth.lang}}><p>{{\'d.p_dg.m6\' | translate}}</p><a href=\"\" role=link class=\"btn btn-default btn-xs\" ng-click=clearFx();>{{\'d.p_dg.5\' | translate}}</a></div><span ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\"><ng-device-thumb class=show selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && devices.devices.length == 0 && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div> old--><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!--<div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && advSearchInfo.isEmpty && filter==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n\r\n          <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !devicesLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !devicesLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextS.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !devicesLoading\">{{\'as.msg.2\' | translate}}</div></div><div class=\"overflow-auto pad10 bg-light\" ng-if=\"selectedT==\'2\'\" ng-attr-style=height:{{quadHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><ul class=\"list-inline thumb-list h100\" ng-if=\"!devicesLoading && devices.tags.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\" selectable-list=\"devices.tags | filter:searchText\"><li ng-repeat=\"tag in filteredTagList = (devices.tags | customSearch:{key:searchText, module:\'d\'})\" data-id={{tag.id}} data-type=tag uib-tooltip={{conflictMsg}} tooltip-append-to-body=true tooltip-enable=\"tag.isConflict != null && (tag.isConflict == 1 || tag.isConflict == 2)\" ng-class=\"{\'nonSelectable unapprovedFile\': tag.isConflict != null && (tag.isConflict == 1 || tag.isConflict == 2)}\"><div class=thumb-img><span class=thumb-inner><img alt=\"\" ng-if=!auth.upermissions.dtc src=assets/images/default/device_tag_selected_sm.png><!-- <svg ng-if=\"auth.upermissions.dtc\" xmlns=\"http://www.w3.org/2000/svg\" width=\"90\" height=\"50\" viewBox=\"0 0 90 50\">\r\n                    <defs></defs>\r\n                    <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(tag.tagColor && !tag.isConflict)?tag.tagColor:\'#57aee3\'}\" d=\"M0,0H90V50H0V0Z\"/>\r\n                    <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(tag.tagColor && !tag.isConflict)?tag.tagColor:\'#57aee3\'}\" d=\"M59.932,27.277a2.616,2.616,0,0,0-.706-1.816L45.573,11.218a5.887,5.887,0,0,0-1.948-1.287A5.686,5.686,0,0,0,41.391,9.4H33.448a2.3,2.3,0,0,0-1.718.758,2.508,2.508,0,0,0-.726,1.8v8.3a6.391,6.391,0,0,0,.506,2.334A5.986,5.986,0,0,0,32.741,24.6L46.394,38.887a2.29,2.29,0,0,0,1.718.738,2.392,2.392,0,0,0,1.738-.738l9.375-9.815A2.5,2.5,0,0,0,59.932,27.277Zm-21.09-9.685a2.369,2.369,0,0,1-3.456,0,2.634,2.634,0,0,1,0-3.61,2.369,2.369,0,0,1,3.456,0A2.634,2.634,0,0,1,38.842,17.592Z\"/>\r\n                  </svg> --> <svg alt=\"\" ng-if=auth.upermissions.dtc class=\"img-responsive center-block marB-4\" xmlns=http://www.w3.org/2000/svg width=64 height=38 viewBox=\"0 0 64 38\"><rect x=1 y=1 width=62 height=36 ng-style=\"{\'fill\':\'#FFFFFF\',\'stroke\':(tag.tagColor)?tag.tagColor:\'#54A7D8\',\'stroke-width\':\'2\',\'stroke-miterlimit\':\'10\'}\"/><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(tag.tagColor)?tag.tagColor:\'#54A7D8\'}\" d=\"M41.72,20.86c0-0.46-0.16-0.87-0.47-1.22l-9.18-9.58c-0.33-0.34-0.76-0.63-1.31-0.87 c-0.55-0.24-1.05-0.36-1.5-0.36h-5.34c-0.44,0-0.83,0.17-1.16,0.51c-0.33,0.34-0.49,0.74-0.49,1.21v5.58c0,0.47,0.11,1,0.34,1.57 c0.23,0.57,0.5,1.02,0.83,1.35l9.18,9.6c0.32,0.33,0.7,0.5,1.16,0.5c0.45,0,0.83-0.17,1.17-0.5l6.3-6.6 C41.57,21.73,41.72,21.33,41.72,20.86z M27.55,14.35c-0.32,0.34-0.71,0.5-1.16,0.5c-0.45,0-0.84-0.17-1.16-0.5 c-0.32-0.34-0.48-0.74-0.48-1.21c0-0.47,0.16-0.88,0.48-1.21c0.32-0.34,0.71-0.5,1.16-0.5c0.45,0,0.84,0.17,1.16,0.5 c0.32,0.34,0.48,0.74,0.48,1.21C28.03,13.61,27.87,14.01,27.55,14.35z\"/></svg></span></div><div class=thumb-label uib-tooltip={{tag.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{tag.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTagList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.tags.length == 0\">{{\'d.msg.3\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"closeFilteredFx(\'all\'); closeAllFx(); selectedSearch.text=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearch.text sanitize-input ng-change=searchSelFx(selectedSearch.text);resetSelPagination(); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearch.text.length ng-click=\"selectedSearch.text=\'\'; resetSelFx();resetSelPagination();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><!-- With tag --><div class=panel-inner-tab>{{\'d.body.12\' | translate}} <span ng-if=deviceGroup.devices>[ {{deviceGroup.devices.length + deviceGroup.tags.length}} ]</span></div><!-- Without tag --></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;><div ng-if=\"deviceGroup.devices.length > 0 || deviceGroup.tags.length > 0\">{{selectedFilteredDevices = (bothDeviceAndTags.list | customSearch:{key:selectedSearch.text, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"bothDeviceAndTags.list.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':bothDeviceAndTags.list.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><div class=\"thumb-list hoverContainer\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"devTag in selectedFilteredDevices = (bothDeviceAndTags.list | itemsPerPageClone:selPaginationControls.pageSize) track by devTag.id\" data-id={{devTag.id}} class=device><!-- <li ng-repeat=\"device in selectedFilteredDevices = (deviceGroup.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}) track by device.id\" data-id=\"{{device.id}}\" ng-if=\"deviceGroup.devices.length > 0 && auth.upreferences.deviceView == \'t\'\"> --><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"closeFilteredFx(devTag.id, (devTag.mac && !devTag.tagColor?\'d\':\'t\'));\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (devTag.dType != \'mc\' && devTag.dType != 7)}\"><a ng-class=\"{\'thumb-device\': (devTag.dType != \'mc\' && devTag.dType != 7)}\" ng-if=\"devTag.thumbV != undefined && devTag.thumbV != 0\" ng-href=\"{{dDetailBucket + (devTag.mac | removeColon) + \'.jpg?\' + devTag.thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{devTag.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (devTag.mac | removeColon) + \'.jpg\' + dThumbParam + \'&\' + devTag.thumbV}}\" src-error=assets/images/default/device_{{devTag.dType}}.png> </a><img alt=\"\" ng-if=\"devTag.thumbV != undefined && devTag.thumbV == 0\" src=assets/images/default/device_{{devTag.dType}}.png> <span class=\"thumb-icon status\" ng-if=devTag.status uib-tooltip=\"{{devTag.status | capitalize}}\" tooltip-popup-delay=500><span class={{devTag.status}}></span></span><div ng-if=\"!devTag.mac && (devTag.tagColor != \'\' || devTag.tagColor==\'\' || devTag.tagColor == null)\" class=thumb><img alt=\"\" ng-if=!auth.upermissions.dtc src=assets/images/default/device_tag_selected.png?1.0 class=\"img-responsive center-block\"><!-- <svg alt=\"\" ng-if=\"auth.upermissions.dtc\" class=\"img-responsive center-block\" xmlns=\"http://www.w3.org/2000/svg\" width=\"215\" height=\"135\" viewBox=\"0 0 215 135\">\r\n                            <defs></defs>\r\n                            <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(devTag.tagColor)?devTag.tagColor:\'#57aee3\'}\" d=\"M2,2H213V133H2V2Z\"/>\r\n                            <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(devTag.tagColor)?devTag.tagColor:\'#57aee3\'}\" d=\"M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z\"/>\r\n                          </svg> --> <svg alt=\"\" ng-if=auth.upermissions.dtc class=\"img-responsive center-block marB-4\" xmlns=http://www.w3.org/2000/svg width=64 height=38 viewBox=\"0 0 64 38\"><rect x=1 y=1 width=62 height=36 ng-style=\"{\'fill\':\'#FFFFFF\',\'stroke\':(devTag.tagColor)?devTag.tagColor:\'#54A7D8\',\'stroke-width\':\'2\',\'stroke-miterlimit\':\'10\'}\"/><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(devTag.tagColor)?devTag.tagColor:\'#54A7D8\'}\" d=\"M41.72,20.86c0-0.46-0.16-0.87-0.47-1.22l-9.18-9.58c-0.33-0.34-0.76-0.63-1.31-0.87 c-0.55-0.24-1.05-0.36-1.5-0.36h-5.34c-0.44,0-0.83,0.17-1.16,0.51c-0.33,0.34-0.49,0.74-0.49,1.21v5.58c0,0.47,0.11,1,0.34,1.57 c0.23,0.57,0.5,1.02,0.83,1.35l9.18,9.6c0.32,0.33,0.7,0.5,1.16,0.5c0.45,0,0.83-0.17,1.17-0.5l6.3-6.6 C41.57,21.73,41.72,21.33,41.72,20.86z M27.55,14.35c-0.32,0.34-0.71,0.5-1.16,0.5c-0.45,0-0.84-0.17-1.16-0.5 c-0.32-0.34-0.48-0.74-0.48-1.21c0-0.47,0.16-0.88,0.48-1.21c0.32-0.34,0.71-0.5,1.16-0.5c0.45,0,0.84,0.17,1.16,0.5 c0.32,0.34,0.48,0.74,0.48,1.21C28.03,13.61,27.87,14.01,27.55,14.35z\"/></svg></div></span></div><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{devTag.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{devTag.label}}</div></div></li><!-- <li ng-repeat=\"tag in selectedFilteredDevicesTag = (deviceGroup.tags | customSearch:{key:selectedSearch.text, module:\'d\'})\" data-id=\"{{tag.id}}\" ng-if=\"deviceGroup.tags.length > 0 && auth.upreferences.deviceView == \'t\'\">\r\n                  <a href=\"\" role=\"link\" class=\"thumb-close\" ng-click=\"closeFilteredFx(tag.id, \'t\');\"><span class=\"fa fa-times-circle\" aria-hidden=\"true\"></span></a>\r\n                  <div class=\"thumb\">\r\n                    <img alt=\"\" ng-if=\"!auth.upermissions.dtc\" src=\"assets/images/default/device_tag_selected.png?1.0\" class=\"img-responsive center-block\">\r\n                    <svg alt=\"\" ng-if=\"auth.upermissions.dtc\" class=\"img-responsive center-block\" xmlns=\"http://www.w3.org/2000/svg\" width=\"215\" height=\"135\" viewBox=\"0 0 215 135\">\r\n                      <defs></defs>\r\n                      <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(tag.tagColor)?tag.tagColor:\'#57aee3\'}\" d=\"M2,2H213V133H2V2Z\"/>\r\n                      <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(tag.tagColor)?tag.tagColor:\'#57aee3\'}\" d=\"M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z\"/>\r\n                    </svg>\r\n                  </div>\r\n                  <div class=\"text-ellipsis marT5\">{{tag.label}}</div>\r\n                </li> --><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length + selectedFilteredDevicesTag.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div><fancybox box-for=\"[rel=fb_group]\" options=fbGroup></fancybox></div><ul class=\"list-inline multiple-selected\" ng-if=\"auth.upreferences.deviceView == \'l\'\" ng-class=\"{\'marT10\':bothDeviceAndTags.list.length>auth.upreferences.dpc}\"><!-- List view --><div class=\"table table-md whiteRow\" ng-class=\"{\'hide\':selectedFilteredDevices.length == 0}\"><div class=\"row th\"><div class=col-xs-7>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-right noPadL\">{{\'cm.label.25\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"devTag in selectedFilteredDevices = (bothDeviceAndTags.list | itemsPerPageClone:selPaginationControls.pageSize) track by devTag.id\" data-id={{devTag.id}} data-type=device data-sub-type={{devTag.type}}><!-- <li class=\"row\" ng-repeat=\"device in selectedFilteredDevices = (deviceGroup.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'})\" data-id=\"{{device.id}}\" data-type=\"device\" data-sub-type=\"{{device.type}}\"> --><div ng-if=\"devTag.mac && !devTag.tagColor\"><div class=\"col-xs-7 text-ellipsis\"><span class=\"deviceStatus {{devTag.status}}\" uib-tooltip=\"{{devTag.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{devTag.label}}</div><div class=\"col-xs-4 text-ellipsis\">{{devTag.mac}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.4\' | translate}}</div> --><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"closeFilteredFx(devTag.id, \'d\')\"><span class=\"fa fa-remove\"></span></a></div></div><div ng-if=\"!devTag.mac && (devTag.tagColor != \'\' || devTag.tagColor==\'\' || devTag.tagColor == null)\"><div class=\"col-xs-7 text-ellipsis\"><span ng-if=auth.upermissions.dtc aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{devTag.tagColor}}></ng-tag-icon></span><span ng-if=!auth.upermissions.dtc class=\"fa fa-tag marR5\" uib-tooltip=\"{{\'cm.label.94\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{devTag.label}}</div><div class=\"col-xs-4 text-muted text-sm\">N/A</div><!-- <div class=\"col-xs-2\">{{\'cm.label.94\' | translate}}</div> --><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"closeFilteredFx(devTag.id, \'t\')\"><span class=\"fa fa-remove\"></span></a></div></div></li><!-- tag list --><!-- <li class=\"row\" ng-repeat=\"tag in selectedFilteredDevicesTag = (deviceGroup.tags | customSearch:{key:selectedSearch.text, module:\'dSel\'})\" data-id=\"{{tag.id}}\" data-type=\"tag\" ng-if=\"deviceGroup.tags.length > 0\">\r\n\r\n                    <div class=\"col-xs-7 text-ellipsis\">\r\n                      <span ng-if=\"auth.upermissions.dtc\" class=\"marT2\">\r\n                        <ng-tag-icon type=\"{{auth.upermissions.dtcS.type}}\" color=\"{{tag.tagColor}}\"></ng-tag-icon>\r\n                      </span>\r\n                      <span ng-if=\"!auth.upermissions.dtc\" class=\"fa fa-tag marR5\" uib-tooltip=\"{{\'cm.label.94\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span>\r\n                      {{tag.label}}\r\n                    </div>\r\n                    <div class=\"col-xs-4 text-muted text-sm\">N/A</div>\r\n                    <div class=\"col-xs-1 text-right\">\r\n                      <a href=\"\" class=\"text-danger\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=\"true\" ng-click=\"closeFilteredFx(tag.id, \'t\')\"><span class=\"fa fa-remove\"></span></a>\r\n                    </div>\r\n                  </li> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length + selectedFilteredDevicesTag.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div><fancybox box-for=\"[rel=fb_group]\" options=fbGroup></fancybox></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"deviceGroup.devices.length == 0 && deviceGroup.tags.length == 0\">{{\'cm.msg.4\' | translate}}</div></div></section></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.dContainer.dgName({id: encId})\" ng-disabled=saveCloseProcessing><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceGroupFx(\'device\', \'sc\');\" ng-disabled=saveCloseProcessing><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.dg ng-disabled=saveCloseProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'d.p_dg.m3\' | translate}}</div><div ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'d.p_dg.m12\' | translate}}</div></div><div class=clearfix></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/dgName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.dg>{{\'cm.label.79s\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.2\':\'d.p_dg.2\' | translate}}</span><span ng-if=deviceGroup.info.label class=text-muted>[ {{deviceGroup.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'d.p_dg.3\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=deviceGrpLoading><div class=row ng-if=!deviceGrpLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'cm.label.78\' | translate}}</label><input type=text id=label class=form-control ng-keypress=\"$event.keyCode == 13 && saveDeviceGroupFx(\'name\');\" ng-model=deviceGroup.info.label placeholder=\"{{\'d.ph.2\' | translate}}\" focus-me=true maxlength={{inputLimit}} aria-label=\"{{\'cm.label.78\' | translate}}\" aria-labelledby=\"{{\'cm.label.78\' | translate}}\"></div></div></div></div><div class=panel-footer ng-if=!deviceGrpLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceGroupFx(\'name\', \'sc\');\" ng-if=deviceGroup.info.isCompleted ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button><!-- With tag --> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceGroupFx(\'name\');\" ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'d.btn.13\' | translate | camelCase}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button><!-- Without tag --> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.dg ng-disabled=\"saveCloseProcessing || saveProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_dg.m1\' | translate}}</div><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'d.p_dg.m2\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/di.html","<img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><section><header class=\"panel-inner-tab d-flex text-center noPadB\" role=tablist aria-owns=\"tab-1 tab-2 tab-3 tab-4 tab-5 tab-6 tab-9 tab-10 tab-11 tab-12 tab-13 tab-51 tab-31\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><!-- Show Tag First --> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'5\'}}\" aria-controls=tab-5 id=tab-5 aria-label=\"{{\'d.tab.3\' | translate}}\" ng-if=\"auth.upreferences.sdtf && auth.upermissions.da.ti\" ng-class=\"{\'selected\':selectedT==\'5\'}\" ng-click=\"tabFx(5, \'tabFx\');\">{{\'d.tab.3\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'1\'}}\" aria-controls=tab-1 id=tab-1 aria-label=\"{{\'d.tab.6.1\' | translate}}\" ng-if=auth.upermissions.da.sir ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'d.tab.6.1\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'2\'}}\" aria-controls=tab-2 id=tab-2 aria-label=\"{{\'d.tab.6.2\' | translate}}\" ng-if=auth.upermissions.da.is ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\">{{\'d.tab.6.2\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'3\'}}\" aria-controls=tab-3 id=tab-3 aria-label=\"{{\'d.tab.6.3\' | translate}}\" ng-if=auth.upermissions.da.oi ng-class=\"{\'selected\':selectedT==\'3\'}\" ng-click=\"tabFx(3, \'tabFx\');\">{{\'d.tab.6.3\' | translate}}</a><!-- Show Tag as Usual --> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'5\'}}\" aria-controls=tab-51 id=tab-51 aria-label=\"{{\'d.tab.3\' | translate}}\" ng-if=\"!auth.upreferences.sdtf && auth.upermissions.da.ti\" ng-class=\"{\'selected\':selectedT==\'5\'}\" ng-click=\"tabFx(5, \'tabFx\');\">{{\'d.tab.3\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'8\'}}\" aria-controls=tab-8 id=tab-8 aria-label=\"{{\'d.tab.6.8\' | translate}}\" ng-if=auth.upermissions.da.dp ng-class=\"{\'selected\':selectedT==\'8\'}\" ng-click=\"tabFx(8, \'tabFx\');\">{{\'d.tab.6.8\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'6\'}}\" aria-controls=tab-6 id=tab-6 aria-label=\"{{\'d.tab.6.6\' | translate}}\" ng-if=auth.upermissions.da.ar ng-class=\"{\'selected\':selectedT==\'6\'}\" ng-click=\"tabFx(6, \'tabFx\');\">{{\'d.tab.6.6\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'3\'}}\" aria-controls=tab-31 id=tab-31 aria-label=\"{{\'d.tab.8\' | translate}}\" ng-if=auth.upermissions.desktop ng-class=\"{\'selected\':selectedT==\'3\'}\" ng-click=\"tabFx(3, \'tabFx\');\" class=hide>{{\'d.tab.8\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'9\'}}\" aria-controls=tab-9 id=tab-9 aria-label=\"{{\'d.tab.9\' |translate}}\" ng-if=auth.upermissions.da.dt ng-class=\"{\'selected\':selectedT==\'9\'}\" ng-click=\"tabFx(9, \'tabFx\');\">{{\'d.tab.9\' |translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'10\'}}\" aria-controls=tab-10 id=tab-10 aria-label=\"{{\'d.tab.10\' | translate}}\" ng-if=auth.upermissions.da.du ng-class=\"{\'selected\':selectedT==\'10\'}\" ng-click=\"tabFx(10, \'tabFx\');\">{{\'d.tab.10\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'11\'}}\" aria-controls=tab-11 id=tab-11 aria-label=\"{{\'d.tab.11\' | translate}}\" ng-if=auth.upermissions.da.dw ng-class=\"{\'selected\':selectedT==\'11\'}\" ng-click=\"tabFx(11, \'tabFx\');\">{{\'d.tab.11\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'12\'}}\" aria-controls=tab-12 id=tab-12 aria-label=\"{{\'d.tab.12\' | translate}}\" ng-if=\"auth.upermissions.da.ed && auth.uType != 4\" ng-class=\"{\'selected\':selectedT==\'12\'}\" ng-click=\"tabFx(12, \'tabFx\');\">{{\'d.tab.12\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'13\'}}\" aria-controls=tab-13 id=tab-13 aria-label=\"{{\'ms.p_s.serverPer.51\' | translate}}\" ng-if=\"auth.upermissions.emType==\'cb\'\" ng-class=\"{\'selected\':selectedT==\'13\'}\" ng-click=\"tabFx(13, \'tabFx\');\">{{\'ms.p_s.serverPer.51\' | translate}}</a></header><div class=\"panel-body marT10\" role=tabpanel><!-- Identify Request --><div ng-if=\"selectedT==\'1\' && auth.upermissions.da.sir\"><div class=form-group><label for=\"durationSelect{{devices.info.durationType == \'c\'?1:\'\'}}\">{{\'cm.label.49\' | translate}}</label><div><label class=marR5><input type=radio role=radio name=durationOpt ng-model=devices.info.durationType value=p><label></label>{{\'em.label.4\' | translate}}</label><label><input type=radio role=radio name=durationOpt ng-model=devices.info.durationType value=c><label></label>{{\'cm.label.17\' | translate}}</label><div class=row><div class=col-xs-3><select class=form-control id=durationSelect ng-model=devices.info.durationP ng-if=\"devices.info.durationType == \'p\'\" aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"><option value=60>1 {{\'cm.label.28\' | translate | lowercase}}</option><option value=120>2 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=300>5 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=600>10 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=1800>30 {{\'cm.label.28s\' | translate | lowercase}}</option><option value=3600>1 {{\'cm.label.29\' | translate | lowercase}}</option></select><div class=input-group ng-if=\"devices.info.durationType == \'c\'\"><input type=number id=durationSelect1 class=form-control ng-model=devices.info.durationC min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.27s\' | translate}}</span></div></div></div></div></div><div><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=devices.info.deviceType value=a><label></label>{{\'em.label.6\' | translate | capitalize}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=devices.info.deviceType value=c ng-change=\"assignableDGTFx(\'d\',\'ir\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=devices.info.deviceType value=c ng-change=\"assignableDGTFx(\'t\',\'ir\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"devices.info.deviceType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'ir\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'ir\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || devices.info.devices.assignedTags.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting5 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu5 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=taSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=taSearch class=form-control ng-disabled=!devices.list.tags.length ng-model=avlTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, devices.info.devices.assignedTags, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!devices.info.devices.assignedTags.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, devices.info.devices.assignedTags, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting6 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu6 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', devices.info.devices.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.info.devices.assignedTags.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.info.devices.assignedTags.length}} ]</span></label>{{curATEM = (devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=tsSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=tsSearch class=form-control ng-disabled=!devices.info.devices.assignedTags.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.info.devices.assignedTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, devices.info.devices.assignedTags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !devices.info.devices.assignedTags.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'ir\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'ir\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'ir\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || devices.info.devices.assignedGroups.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting3 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu3 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=gsSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=gsSearch class=form-control ng-disabled=!devices.list.groups.length ng-model=avlGList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, devices.info.devices.assignedGroups, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!devices.info.devices.assignedGroups.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, devices.info.devices.assignedGroups, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting4 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu4 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', devices.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', devices.info.devices.assignedGroups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.info.devices.assignedGroups.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{devices.info.devices.assignedGroups.length}} ]</span></label>{{curAGEM = (devices.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=gaSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=gaSearch class=form-control ng-model=asGList sanitize-input ng-disabled=!devices.info.devices.assignedGroups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.info.devices.assignedGroups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.info.devices.assignedGroups | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, devices.info.devices.assignedGroups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !devices.info.devices.assignedGroups.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'ir\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || devices.info.devices.assignedTags.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting5 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu5 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=taSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=taSearch class=form-control ng-disabled=!devices.list.tags.length ng-model=avlTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, devices.info.devices.assignedTags, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!devices.info.devices.assignedTags.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, devices.info.devices.assignedTags, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting6 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu6 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', devices.info.devices.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.info.devices.assignedTags.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.info.devices.assignedTags.length}} ]</span></label>{{curATEM = (devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=tsSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text id=tsSearch class=form-control ng-disabled=!devices.info.devices.assignedTags.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.info.devices.assignedTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.info.devices.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, devices.info.devices.assignedTags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !devices.info.devices.assignedTags.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- <div class=\"marT10 marB15\"><span class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devices.list.devices.length && !devices.info.devices.assignedDevices.length && !devices.list.groups.length && !devices.info.devices.assignedGroups.length && !devices.list.tags.length && !devices.info.devices.assignedTags.length\">{{\'d.msg.20\' | translate}}</span></div> --></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=sendIdentifyFx(); ng-disabled=sendProcessing><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{sendProcessing?\'cm.btn.35i\':\'cm.btn.35\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=resetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'em.msg.4\' | translate}}</span> <span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div><!-- History --><div class=marT20><div class=\"panel-inner-tab marB5\">{{\'cm.p_h.1\' | translate}}<div class=pull-right uib-tooltip=\"{{\'cm.btn.33\' | translate}}\"><button type=button role=button ng-click=\"loadSelectedTab(\'refresh\'); searchText=\'\';\" class=btn-link ng-disabled=\"loadingMain || (!innerLoading && history.length == 0)\" aria-label=refresh aria-labelledby=refresh><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':loadingMain}\" aria-hidden=true></span></button></div><div class=pull-right uib-tooltip=\"{{\'d.tool.11\' | translate}}\"><button type=button role=button ng-click=\"deleteOpen(\'history\', deletableHistory);\" class=btn-link ng-class=\"{\'text-disabled\':(deletableHistory.length == 0)}\" ng-disabled=\"deletableHistory.length == 0\" aria-label=delete aria-labelledby=delete><span class=\"glyphicon glyphicon-trash\" aria-hidden=true></span></button></div><div class=\"pull-right searchTbx selectedQuadSearch\"><label for=hSearch class=lableHidden>Search</label><input type=text class=form-control id=hSearch ng-model=searchText sanitize-input maxlength=250 ng-change=acknowledgeCloseFx(); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><img alt=Loading src=assets/images/loading.gif ng-if=innerLoading><div ng-if=\"!innerLoading && history.length > 0\"><div class=\"table table-md\"><div class=\"row th\" ng-if=\"filteredHistoryList.length > 0\"><div class=col-xs-4><label class=noMarB><input type=checkbox ng-click=\"checkAll(\'history\', $event);\"><label></label>{{\'d.body.13\' | translate}}</label></div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=col-xs-2>{{\'em.body.12\' | translate}}</div><div class=col-xs-2>{{\'cm.label.46\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"dh in filteredHistoryList = (history | customSearch:{key:searchText, module:\'dh\'})\"><div class=\"col-xs-4 text-ellipsis-wrap\"><label class=text-unbold><input type=checkbox ng-model=dh.isChecked ng-click=\"checkFx(\'history\')\"><label></label>{{(dh.dateTime * 1000) | date:\"medium\"}}</label></div><div class=\"col-xs-2 text-ellipsis-wrap text-sm\">{{dh.time}}</div><div class=\"col-xs-2 text-ellipsis-wrap\">{{dh.createdBy}}</div><div class=col-xs-2><span ng-if=\"dh.status == 0\">{{\'em.body.2\' | translate}}</span> <span ng-if=\"dh.status == 1\">{{\'em.body.3\' | translate}}</span> <span ng-if=\"dh.status == 2\">{{\'em.body.4\' | translate}}</span></div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=acknowledgeFx(dh.id);>{{\'em.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=\"deleteOpen(\'history\', dh.id);\">{{\'cm.btn.13\' | translate}}</button></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistoryList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!innerLoading && history.length == 0\">{{\'d.msg.18\' | translate}}</div></div></div><!-- TV Settings --><div ng-if=\"selectedT==\'2\' && auth.upermissions.da.is\"><img alt=Loading src=assets/images/loading.gif ng-if=importLoading><div ng-if=!importLoading><div class=\"form-group marB10\"><label>{{\'cm.label.25\' | translate}}</label><div><label class=marR5><input type=radio role=radio name=dsTypeOpt ng-model=dsInfo.type value=d ng-click=\"dsInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=marR5><input type=radio role=radio name=dsTypeOpt ng-model=dsInfo.type value=u ng-click=\"dsInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label><!-- TODO As per the discursion we comment out the bellow code. --><!-- <label class=\"marR5\"><input type=\"radio\" role=\"radio\" name=\"dsTypeOpt\" ng-model=\"dsInfo.type\" value=\"i\" ng-change=\"daChangeFx()\"><label></label> {{\'d.tab.6.2.1\' | translate}}</label> --></div></div><!-- Download --><div ng-if=\"dsInfo.type == \'d\'\"><div><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dsInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dsInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'tv\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dsInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'tv\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dsInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'tv\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'tv\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dsInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting11 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu11 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dsInfo.devices.tag, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dsInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dsInfo.devices.tag, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting12 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu12 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dsInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dsInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dsInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dsInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dsInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dsInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dsInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'tv\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'tv\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'tv\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dsInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting9 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu9 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dsInfo.devices.group, curGroups.availableGroups,\'\',\'\',\'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dsInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dsInfo.devices.group, curGroups.assignedGroups,\'\',\'\',\'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting10 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu10 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dsInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dsInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dsInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dsInfo.devices.group.length}} ]</span></label>{{curAGEM = (dsInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dsInfo.devices.group.length ng-model=asGList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dsInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dsInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dsInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dsInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'tv\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dsInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting11 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu11 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dsInfo.devices.tag, curTags.availableTags,\'\',\'\',\'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dsInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dsInfo.devices.tag, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting12 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu12 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dsInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dsInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dsInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dsInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dsInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dsInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dsInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dsInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDSDownload(); ng-disabled=sendProcessing><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.20\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dsResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Uplopad --><div ng-if=\"dsInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=dsUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dsResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- TODO As per the discursion we comment out the bellow code. --><!-- Import --><!-- <div ng-if=\"dsInfo.type == \'i\'\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-6\">\r\n              <div class=\"form-group\">\r\n                <label>{{\'d.label.13\' | translate}}</label>\r\n                <div class=\"dropdown customSelect select-group\" uib-dropdown auto-close=\"outsideClick\" is-open=\"status.isopen\">\r\n                  <div class=\"row\">\r\n                    <div class=\"col-xs-9 noPadR\">\r\n                      <span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>\r\n                        <span ng-if=\"!import.s.l\">{{\'cm.label.31\' | translate}}</span>\r\n                        <span ng-if=\"import.s.l\">{{import.s.l}}</span>\r\n                        <span class=\"caret\"></span>\r\n                      </span>\r\n                    </div>\r\n                    <div class=\"col-xs-3 noPadL\">\r\n                      <button type=\"button\" role=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"viewSettingsFx(true);\">{{\'d.btn.14\' | translate}}</button>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-xs-12\">\r\n                        <div class=\"padLR10\">\r\n                          <li class=\"dropdown-header noPad noMar\" ng-show=\"devicesList.length>5\">\r\n                            <div class=\"searchTbx input-xs\">\r\n                              <input type=\"text\" class=\"form-control\" ng-model=\"searchList.text\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=\"off\">\r\n                              <a href=\"\" role=\"link\" class=\"text-danger\" ng-show=\"searchList.text.length\" ng-click=\"searchList.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n                            </div>\r\n                          </li>\r\n                          <li class=\"divider\" role=\"separator\" ng-if=\"devicesList.length>5\"></li>\r\n                          <div class=\"list-scroll ng-cloak\">\r\n                            <li ng-repeat=\"device in filteredSList = (devicesList | filter:searchList.text) | orderBy:\'label\'\" tabindex=\"$index\">\r\n                              <label><input type=\"radio\" role=\"radio\" name=\"deviceOpt\" ng-value=\"device\" ng-checked=\"device.id == devicesList.id\" ng-model=\"import.s\" ng-change=\"getTargetDeviceFx();searchList.text=\'\'\"><label></label>\r\n                                <div class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{device.l}}\r\n                              </label>\r\n                            </li>\r\n                            <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"devicesList.length && filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{searchList.text}}&quot;</b>\'}\"></div>\r\n                            <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesList.length\">{{\'cl.widget.meeting.m9\' | translate}}</div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row\" ng-if=\"import.s\">\r\n            <div class=\"col-xs-6\">\r\n              <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"targetDLoading\">\r\n              <div class=\"form-group\" ng-if=\"!targetDLoading\">\r\n                <label>{{\'d.label.14\' | translate}}</label>\r\n                <div class=\"dropdown customSelect\" uib-dropdown auto-close=\"outsideClick\" ng-click=\"searchList.text=\'\'\">\r\n                  <span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>{{targetSelected = (targetDevice.devices | filter:{selected:true}); \"\"}} <span ng-if=\"!targetSelected.length\">{{\'cm.label.31\' | translate}}</span> <span ng-repeat=\"d in targetSelected\">{{d.l}}<span ng-if=\"!$last\">, </span></span> <span class=\"caret\"></span></span>\r\n                  <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-xs-12\">\r\n                        <div class=\"padLR10\">\r\n                          <li class=\"dropdown-header noPad noMar\">\r\n                            <div class=\"searchTbx input-xs\">\r\n                              <input type=\"text\" class=\"form-control\" ng-model=\"searchList.text\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=\"off\"> <a href=\"\" role=\"link\" class=\"text-danger\" ng-show=\"searchList.text.length\" ng-click=\"searchList.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n                            </div>\r\n                          </li>\r\n                          <li class=\"divider\" role=\"separator\"></li>\r\n                          <div class=\"list-scroll ng-cloak\">\r\n                            <li ng-repeat=\"device in filteredDList = (targetDevice.devices | customSearch:{key:searchList.text, module:\'dSelOp\'}) | orderBy: \'l\'\" tabindex=\"$index\">\r\n                              <label>\r\n                                <input type=\"checkbox\" ng-model=\"device.selected\"><label></label>\r\n                                <div class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{device.l}}\r\n                              </label>\r\n                            </li>\r\n                            <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"filteredDList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{searchList.text}}&quot;</b>\'}\"></div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"bdr-top-dashed marT10\" ng-if=\"!importLoading\">\r\n            <span class=\"btnQuad noMarB\">\r\n              {{targetSelected = (targetDevice.devices | filter:{selected:true});\"\"}}\r\n              <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-click=\"importFx();\" ng-disabled=\"!targetSelected.length || importProcessing\"><span class=\"fa fa-check\" ng-class=\"importProcessing?\'fa-repeat fa-spin\':\'fa-arrow-down\'\" aria-hidden=\"true\"></span>{{sendProcessing?\'cl.widget.cm.24i\':\'cl.widget.cm.24\' | translate}}</button>\r\n              <button type=\"button\" role=\"button\" class=\"btn btn-default\" ng-click=\"impotResetFx();\" ng-disabled=\"importProcessing\"><span class=\"fa fa fa-repeat\"></span>{{\'cm.btn.34\' | translate}}</button>\r\n            </span>\r\n            <div class=\"errMsg pull-right\" ng-if=\"hasErr\" aria-live=\"polite\" role=\"status\">\r\n              <span ng-if=\"errType==\'duration\'\" aria-live=\"polite\" role=\"status\">{{\'em.msg.4\' | translate}}</span>\r\n              <span ng-if=\"errType==\'device\'\" aria-live=\"polite\" role=\"status\">{{\'d.msg.17\' | translate}}</span>\r\n              <span ng-if=\"errType==\'dEmpty\'\" aria-live=\"polite\" role=\"status\">{{\'d.msg.20\' | translate}}</span>\r\n              <span ng-if=\"errType==\'sDevice\'\" aria-live=\"polite\" role=\"status\">{{\'db.msg.2\' | translate}}</span>\r\n              <span ng-if=\"errType==\'gtEmpty\'\" aria-live=\"polite\" role=\"status\">{{\'d.msg.21\' | translate}}</span>\r\n              <span ng-if=\"errType==\'noDevice\'\" aria-live=\"polite\" role=\"status\">{{\'d.msg.54\' | translate}}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n          </div>\r\n        </div> --></div></div><!-- Other Info --><div ng-if=\"selectedT==\'3\' && auth.upermissions.da.oi\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=duoInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=duoInfo.type value=u ng-click=\"duoInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"duoInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading></span></div><div class=marT15 ng-if=\"duoInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=duoInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=duoInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'oi\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=duoInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'oi\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"duoInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'oi\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'oi\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || duoInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting17 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu17 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, duoInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duoInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, duoInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting18 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu18 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', duoInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duoInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{duoInfo.devices.tag.length}} ]</span></label>{{curASTEM = (duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!duoInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duoInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, duoInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !duoInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'oi\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'oi\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'oi\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || duoInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting15 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu15 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, duoInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duoInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, duoInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting16 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu16 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', duoInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', duoInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duoInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{duoInfo.devices.group.length}} ]</span></label>{{curAGEM = (duoInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!duoInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duoInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duoInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, duoInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !duoInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'oi\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || duoInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting17 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu17 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, duoInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duoInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, duoInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting18 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu18 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', duoInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duoInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{duoInfo.devices.tag.length}} ]</span></label>{{curASTEM = (duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!duoInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duoInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duoInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, duoInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !duoInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDuoDownload(); ng-disabled=sendProcessing ng-if=\"duoInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.18\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=duoUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"duoInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=duoResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'heEmpty\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Tags --><div ng-if=\"selectedT==\'5\' && auth.upermissions.da.ti\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=dutInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=dutInfo.type value=u ng-click=\"dutInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"dutInfo.type == \'u\' && taskObj.code == 0 && !taskLoading\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading></div><div class=marT15 ng-if=\"dutInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dutInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dutInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'tag\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dutInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'tag\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dutInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'tag\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'tag\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dutInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting23 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu23 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dutInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dutInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dutInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting24 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu24 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dutInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dutInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dutInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dutInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dutInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dutInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dutInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'tag\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'tag\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'tag\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dutInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting21 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu21 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dutInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dutInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dutInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting22 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu22 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dutInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dutInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dutInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dutInfo.devices.group.length}} ]</span></label>{{curAGEM = (dutInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!dutInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dutInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dutInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dutInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dutInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'tag\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dutInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting23 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu23 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dutInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dutInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dutInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting24 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu24 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dutInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dutInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dutInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dutInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dutInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dutInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dutInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dutInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"dutInfo.type==\'u\' && taskLoading\"><div class=msg-warning ng-if=\"dutInfo.type==\'u\' && taskObj.code == 12108 && !taskLoading\">{{\'d.msg.62\' | translate}} <a href=\"\" role=link class=text-bold ng-click=getTaskDetailsFx(taskObj.task.id);>{{\'d.btn.30\' | translate}}</a>.</div><div class=\"bdr-top-dashed marT10\" ng-if=\"(dutInfo.type==\'u\' && taskObj.code == 0) || dutInfo.type==\'d\'\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDutDownload(); ng-disabled=sendProcessing ng-if=\"dutInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.19\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=dutUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"dutInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span>{{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dutResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Auto Registration --><div ng-if=\"selectedT==\'6\' && auth.upermissions.da.ar\"><img alt=Loading src=assets/images/loading.gif ng-if=layoutLoading><div ng-if=!layoutLoading><div class=form-group><label>{{\'d.ar.2\' | translate}}</label><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading> <span class=\"marL5 marR5\">|</span> <a href=\"\" role=link ng-click=getSampleFileFx(); download class=\"btn-link text-sm\">{{\'d.ar.3\' | translate}}</a> <span class=\"marL5 marR5\">|</span> <a href={{auth.bucket}}storage/device-auto-registration/canada-province-timezone.xlsx target=_blank download class=\"btn-link text-sm\">{{\'d.label.23\' | translate}}</a></div><div class=row><div class=col-xs-4><label for=fLayoutData>{{\'d.label.22\' | translate}}</label><div class=form-group><select class=form-control id=fLayoutData ng-model=fLayout.data ng-options=\"layout.label for layout in frameLayouts.frameLayouts | orderBy:\'label\' track by layout.id\" aria-label=\"{{\'d.label.22\' | translate}}\" aria-labelledby=\"{{\'d.label.22\' | translate}}\"><option value=\"\" disabled>{{\'d.label.22\' | translate}}</option></select></div><div class=msg-warning lang={{auth.lang}}>{{\'d.ar.m1\' | translate}}</div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=autoRegFx(); ng-disabled=\"saveProcessing || fileModelLoading\"><span class=\"fa fa-check\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{saveProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=autoRegResetFx(); ng-disabled=saveProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'fExist\'\" aria-live=polite role=status>{{\'d.msg.39\' | translate}}</span> <span ng-if=\"errType==\'hdEmpty\'\" aria-live=polite role=status>{{\'d.msg.40\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.41\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noLic\'\" aria-live=polite role=status>{{\'d.msg.44\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'fEmpty\'\" aria-live=polite role=status>{{\'d.msg.38\' | translate}}</span> <span ng-if=\"errType==\'dupInfo\'\" aria-live=polite role=status>{{\'d.msg.28\' | translate}}</span></div><div class=clearfix></div></div></div></div><!-- Properties --><div ng-if=\"selectedT==\'8\' && auth.upermissions.da.dp\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=dupInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=dupInfo.type value=u ng-click=\"dupInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"dupInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading></div><div class=marT15 ng-if=\"dupInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dupInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dupInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'prop\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dupInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'prop\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dupInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'prop\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'prop\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dupInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting29 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu29 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dupInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dupInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dupInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting30 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu30 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dupInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dupInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dupInfo.devices.tag.length}} ]</span></label>{{curATEM = (dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dupInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dupInfo.devices.tag.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dupInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dupInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'prop\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'prop\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'prop\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dupInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting27 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu27 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dupInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dupInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dupInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting28 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu28 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dupInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dupInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dupInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dupInfo.devices.group.length}} ]</span></label>{{curAGEM = (dupInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!dupInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dupInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dupInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dupInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dupInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'prop\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dupInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting29 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu29 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dupInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dupInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dupInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting30 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu30 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dupInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dupInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dupInfo.devices.tag.length}} ]</span></label>{{curATEM = (dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dupInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dupInfo.devices.tag.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dupInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dupInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dupInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDupDownload(); ng-disabled=sendProcessing ng-if=\"dupInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.23\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=dupUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"dupInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span>{{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dupResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!innerLoading && devices.history.length == 0\">{{\'d.msg.18\' | translate}}</div></div><!-- Device On/Off Schedule --><div ng-if=\"selectedT==\'9\' && auth.upermissions.da.dt\"><img alt=Loading src=assets/images/loading.gif ng-if=importLoading><div ng-if=!importLoading><div class=\"form-group marB10\"><label>{{\'cm.label.25\' | translate}}</label><div><label class=marR5><input type=radio role=radio name=dsTypeOpt ng-model=dtInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label><input type=radio role=radio name=dsTypeOpt ng-model=dtInfo.type value=u ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><!-- Download --><div ng-if=\"dtInfo.type == \'d\'\"><div><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dtInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dtInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'onOffSch\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dtInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'onOffSch\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dtInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'onOffSch\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'onOffSch\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dtInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting35 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu35 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dtInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dtInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dtInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting36 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu36 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dtInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dtInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dtInfo.devices.tag.length}} ]</span></label>{{curATEM = (dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dtInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dtInfo.devices.tag.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dtInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dtInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'onOffSch\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'onOffSch\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'onOffSch\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dtInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting33 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu33 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dtInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dtInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dtInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting34 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu34 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dtInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dtInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dtInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dtInfo.devices.group.length}} ]</span></label>{{curAGEM = (dtInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!dtInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dtInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dtInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dtInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dtInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'onOffSch\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dtInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting35 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu35 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dtInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dtInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dtInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting36 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu36 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dtInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dtInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dtInfo.devices.tag.length}} ]</span></label>{{curATEM = (dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dtInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dtInfo.devices.tag.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dtInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dtInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dtInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDTDownload(); ng-disabled=sendProcessing><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.25\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dtResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Uplopad --><div ng-if=\"dtInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=dtUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dtResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div></div></div><!-- Data Usage --><div ng-if=\"selectedT==\'10\' && auth.upermissions.da.du\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=duInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=duInfo.type value=u ng-click=\"duInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"duInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading></div><div class=marT15 ng-if=\"duInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=duInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=duInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'du\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=duInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'du\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"duInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'du\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'du\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || duInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting41 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu41 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, duInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\"></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, duInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\"></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting42 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu42 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', duInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{duInfo.devices.tag.length}} ]</span></label>{{curASTEM = (duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!duInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, duInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !duInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'du\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'du\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'du\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || duInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting39 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu39 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, duInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, duInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting40 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu40 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', duInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', duInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{duInfo.devices.group.length}} ]</span></label>{{curAGEM = (duInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!duInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, duInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !duInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'du\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || duInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting41 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu41 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, duInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\"></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!duInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, duInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\"></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting42 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu42 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', duInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{duInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{duInfo.devices.tag.length}} ]</span></label>{{curASTEM = (duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!duInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"duInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in duInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, duInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !duInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDuDownload(); ng-disabled=sendProcessing ng-if=\"duInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.26\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=duUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"duInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=duResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Watermark --><div ng-if=\"selectedT==\'11\' && auth.upermissions.da.dw\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=dwInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=dwInfo.type value=u ng-click=\"dwInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"dwInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading ng-click=resetDwFileFx();> </span><img alt=Loading src=assets/images/loading-xs.gif class=marL5 ng-if=fileModelLoading><div class=marT20><div class=\"panel-inner-tab marB5\">{{\'d.tab.11.7\' | translate}}</div><div class=\"form-group marT10\"><label>{{\'d.tab.11.1\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"(dwInfo.s.img.thumb || dwInfo.s.img.type == \'SharePointC\' || dwInfo.s.img.type == \'OneDriveC\' || dwInfo.s.img.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeBgFx();><span class=\"fa fa-times-circle\"></span></a> <a ng-if=dwInfo.s.img.thumb ng-href=\"{{cDetailBucket + dwInfo.s.img.thumb | secureThumb}}\" data-access={{dwInfo.s.img.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(dwInfo.s.img.path + (dwInfo.s.img.path.length > 1 ? \' / \' : \' \') + dwInfo.s.img.label)}}\" ng-show=dwInfo.s.img.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + dwInfo.s.img.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"dwInfo.s.img.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"dwInfo.s.img.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"dwInfo.s.img.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=dwInfo.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div></div><div class=form-group><div class=marB10><label for=alignOptA class=\"noMarB marR10\"><input type=radio role=radio id=alignOptA ng-model=dwInfo.s.alignOpt name=alignOpt value=a><label></label>{{\'d.tab.11.4\' | translate}}</label><label for=alignOptC class=noMarB><input type=radio role=radio id=alignOptC ng-model=dwInfo.s.alignOpt name=alignOpt value=c><label></label>{{\'d.tab.11.5\' | translate}}</label></div><div class=form-group ng-if=\"dwInfo.s.alignOpt == \'a\'\"><div class=\"form-group row\"><div class=col-xs-12><div class=pull-left><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'t-l\'}\" ng-click=\"frameAlignFx(\'t-l\')\" uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'m-l\'}\" ng-click=\"frameAlignFx(\'m-l\')\" uib-tooltip=\"{{\'cm.label.89.2\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'b-l\'}\" ng-click=\"frameAlignFx(\'b-l\')\" uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'t-c\'}\" ng-click=\"frameAlignFx(\'t-c\')\" uib-tooltip=\"{{\'cm.label.89.4\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'m-c\'}\" ng-click=\"frameAlignFx(\'m-c\')\" uib-tooltip=\"{{\'cm.label.89.5\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'b-c\'}\" ng-click=\"frameAlignFx(\'b-c\')\" uib-tooltip=\"{{\'cm.label.89.6\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'t-r\'}\" ng-click=\"frameAlignFx(\'t-r\')\" uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'m-r\'}\" ng-click=\"frameAlignFx(\'m-r\')\" uib-tooltip=\"{{\'cm.label.89.8\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\': dwInfo.s.align == \'b-r\'}\" ng-click=\"frameAlignFx(\'b-r\')\" uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-append-to-body=true></div></div></div></div></div><div class=form-group ng-if=\"dwInfo.s.alignOpt == \'c\'\"><div class=\"form-group row noMargin\"><div class=col-xs-2><label for=xPos>{{\'fl.p_cfl.label.8\' | translate}}:</label><input type=number id=xPos class=\"form-control input-sm\" ng-model=dwInfo.s.x maxlength=5 tabindex=6></div><div class=col-xs-2><label for=yPos>{{\'fl.p_cfl.label.9\' | translate}}:</label><input type=number id=yPos class=\"form-control input-sm\" ng-model=dwInfo.s.y maxlength=5 tabindex=7></div></div></div></div><div class=form-group><div class=\"form-group row noMargin\"><div class=col-xs-2><label>{{\'d.tab.11.3\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker\" ng-model=dwInfo.s.dateRange format=MM/DD/YYYY opens=left singledatepicker=true readonly aria-label=\"{{\'d.tab.11.3\' | translate}}\" aria-labelledby=\"{{\'d.tab.11.3\' | translate}}\"></div></div><div class=col-xs-2><label>{{\'cm.label.61\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dwInfo.s.bg, opacity:dwInfo.s.bg}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"dwInfo.s.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.61\' | translate}}\" aria-labelledby=\"{{\'cm.label.61\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{dwInfo.s.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dwInfo.s.bg selected-type=dwInfo.s.ctype.bg is-alpha=true selected-alpha=dwInfo.s.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div><div class=marT15 ng-if=\"dwInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dwInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dwInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'wm\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dwInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'wm\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dwInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'wm\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'wm\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dwInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting41 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu41 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dwInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dwInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dwInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting42 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu42 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dwInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dwInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dwInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dwInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dwInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dwInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dwInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'wm\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'wm\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'wm\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dwInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting39 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu39 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dwInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dwInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dwInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting40 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu40 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dwInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dwInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dwInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dwInfo.devices.group.length}} ]</span></label>{{curAGEM = (dwInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!dwInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dwInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dwInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dwInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dwInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'wm\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dwInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting41 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu41 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dwInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dwInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dwInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting42 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu42 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dwInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dwInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dwInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dwInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dwInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dwInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dwInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dwInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><!-- we hide this table because now we upload excel files for watermark like other tabs. --><div class=\"marT15 hide\"><label>{{\'cm.label.4s\' | translate}}</label><div><img alt=Loading src=assets/images/loading-xs.gif ng-if=deviceLoading><div ng-if=!deviceLoading><div class=row ng-if=\"devices.list.devices.length || dwInfo.devices.device.length\"><div class=\"form-group col-xs-8\"><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\"><div class=row><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting43 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aDeviceSort.type === \'label\' && aDeviceSort.val === \'asc\' && aDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aDeviceSort.type === \'label\' && aDeviceSort.val === \'desc\' && aDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aDeviceSort.type === \'id\' && aDeviceSort.val === \'asc\' && aDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'id\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aDeviceSort.type === \'id\' && aDeviceSort.val === \'desc\' && aDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'id\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu43 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'a\', devices.list.devices | customSearch:{key:avlDList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'a\', devices.list.devices);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.devices.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{devices.list.devices.length}} ]</span></label>{{curADEM = (devices.list.devices | customSearch:{key:avlDList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlDList sanitize-input ng-disabled=!devices.list.devices.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlDList.length ng-click=\"avlDList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.devices.length && !curADEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlDList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.devices | customSearch:{key:avlDList, module:\'cdtg\'} | orderBy:aDeviceSort.type:aDeviceSort.reverse track by option.id\"><!-- <div class=\"padLR10 padTB2 cursorDefault\" ng-class=\"{\'dRowDisabled\': option.isWM}\" ng-click=\"selDeviceFx(\'a\', option, devices.list.devices)\" uib-tooltip=\"{{\'d.msg.58\' | translate}}\" tooltip-enable=\"option.isWM\"><span class=\"marR5 deviceStatus {{option.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{option.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span>{{option.label}}</div> --><div class=\"padLR10 padTB2 cursorDefault word-break\" ng-class=\"{\'dRowDisabled\': option.isWM}\" ng-click=\"selDeviceFx(\'a\', option, devices.list.devices)\" uib-tooltip=\"{{\'d.msg.58\' | translate}}\" tooltip-enable=option.isWM><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.label}}</div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.devices.length ng-click=\"avlDList=\'\';listManipulateFx(\'add\', devices.list.devices, dwInfo.devices.device, curDevices.availableDevices, \'\', \'\', \'d\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dwInfo.devices.device.length ng-click=\"listManipulateFx(\'remove\', devices.list.devices, dwInfo.devices.device, curDevices.assignedDevices, \'\', \'\', \'d\'); asDList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting44 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sDeviceSort.type === \'label\' && sDeviceSort.val === \'asc\' && sDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sDeviceSort.type === \'label\' && sDeviceSort.val === \'desc\' && sDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sDeviceSort.type === \'id\' && sDeviceSort.val === \'asc\' && sDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sDeviceSort.type === \'id\' && sDeviceSort.val === \'desc\' && sDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu44 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'s\', dwInfo.devices.device | customSearch:{key:asDList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'s\', dwInfo.devices.device);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dwInfo.devices.device.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dwInfo.devices.device.length}} ]</span></label>{{curASDEM = (dwInfo.devices.device | customSearch:{key:asDList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dwInfo.devices.device.length ng-model=asDList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asDList.length ng-click=\"asDList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dwInfo.devices.device.length && !curASDEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asDList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dwInfo.devices.device | customSearch:{key:asDList, module:\'cdtg\'} | orderBy:sDeviceSort.type:sDeviceSort.reverse track by option.id\"><!-- <div class=\"padLR10 padTB2 cursorDefault word-break\" ng-click=\"selDeviceFx(\'s\', option, dwInfo.devices.device)\"><span class=\"marR5 deviceStatus {{option.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{option.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span>{{option.label}}</div> --><div class=\"padLR10 padTB2 cursorDefault word-break\" ng-click=\"selDeviceFx(\'s\', option, dwInfo.devices.device)\"><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.label}}</div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div></div></div><div class=\"marT10 marB15\" ng-if=\"!devices.list.devices.length && !dwInfo.devices.device.length\"><span class=msg-warning lang={{auth.lang}}>{{\'ms.p_s.serverPer.m23\' | translate}}</span></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDwDownload(); ng-disabled=sendProcessing ng-if=\"dwInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.28\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=dwUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"dwInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dwResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'wmImg\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m21\' | translate}}</span> <span ng-if=\"errType==\'position\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m22\' | translate}}</span> <span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'hdEmpty\'\" aria-live=polite role=status>{{\'d.msg.40\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.41\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span></div><div class=clearfix></div></div><!-- we hide this table because now we upload excel files for watermark like other tabs. --><!-- watermark list --><div class=\"marT20 hide\"><div class=\"panel-inner-tab marB5\">{{\'d.tab.11.6\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=listLoading><div ng-if=!listLoading><div class=\"table table-md\"><div class=\"row th\" ng-if=\"filteredWMList.length > 0\"><div class=col-xs-4>{{\'cm.label.44\' | translate}}</div><div class=col-xs-2>{{\'d.tab.11.3\' | translate}}</div><div class=col-xs-2>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.61\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"wm in filteredWMList = (wmList | customSearch:{key:searchText, module:\'wm\'})\"><div class=\"col-xs-4 text-ellipsis-wrap\"><div ng-if=wm.s.img.thumb><div class=user-tumb><a ng-if=wm.s.img.thumb ng-href=\"{{cDetailBucket + wm.s.img.thumb | secureThumb}}\" data-access={{wm.s.img.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(wm.s.img.path + (wm.s.img.path.length > 1 ? \' / \' : \' \') + wm.s.img.label)}}\" ng-show=wm.s.img.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + wm.s.img.thumb + \'&h=30&w=30&q=80&zc=3\'}}\"> </a><img alt=\"\" ng-if=\"wm.s.img.type == \'SharePointC\'\" ng-src=\"{{tim + \'assets/images/default/thumbs/lg/sp.png\'}}&h=28&w=28&q=80&zc=2\"> <img alt=\"\" ng-if=\"wm.s.img.type == \'OneDriveC\'\" ng-src=\"{{tim + \'assets/images/default/thumbs/lg/od.png\'}}&h=28&w=28&q=80&zc=2\"> <img alt=\"\" ng-if=\"wm.s.img.type == \'GoogleDriveC\'\" ng-src=\"{{tim + \'assets/images/default/thumbs/lg/gd.png\'}}&h=28&w=28&q=80&zc=2\"></div><div class=text-ellipsis uib-tooltip={{wm.s.img.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{wm.s.img.label}}</div></div><span class=text-muted ng-if=!wm.s.img.thumb>N/A</span></div><div class=\"col-xs-2 text-ellipsis-wrap\">{{(wm.s.ts) | date:\"MMM d, y\"}}</div><div class=col-xs-2><span ng-if=wm.s.devices.device.length>{{wm.s.devices.device.length}}</span> <span class=text-muted ng-if=!wm.s.devices.device.length>N/A</span> <button type=button role=button ng-if=wm.s.devices.device.length class=\"btn btn-default btn-xs\" ng-click=\"deviceListFx(wm.s.devices.device, \'d.tab.11\' | translate);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-ellipsis-wrap\">{{wm.s.bg}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" class=\"fa fa-pencil marLR5\" ng-click=editWMFx(wm); ng-disabled=isDisabled ng-class=\"{\'text-muted\':isDisabled}\"></a> <a href=\"\" role=link uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=text-danger ng-click=deleteWMOpen(wm.id);><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!listLoading && wmList.length == 0\">{{\'d.msg.56\' | translate}}</div></div></div><!-- Edit Devices --><div ng-if=\"selectedT==\'12\' && auth.upermissions.da.ed && auth.uType != 4\"><div class=form-group><label>{{\'cm.label.25\' | translate}}</label><div><label class=\"noMarB marR5\"><input type=radio role=radio name=typeOpt ng-model=dueInfo.type value=d ng-change=daChangeFx()><label></label>{{\'cm.btn.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=dueInfo.type value=u ng-click=\"dueInfo.dType=\'a\'\" ng-change=daChangeFx()><label></label>{{\'cm.btn.16\' | translate}}</label></div></div><div ng-if=\"dueInfo.type == \'u\'\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file btn-xs\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> </span><span class=\"marL5 marR5\">|</span> <a href={{auth.bucket}}storage/device-auto-registration/canada-province-timezone.xlsx target=_blank download class=\"btn-link text-sm\">{{\'d.label.23\' | translate}}</a></div><div class=marT15 ng-if=\"dueInfo.type==\'d\'\"><label>{{\'cm.label.4s\' | translate}}</label><div class=marB10><label class=marR5><input type=radio role=radio name=deviceOpt ng-model=dueInfo.dType value=a><label></label>{{\'em.label.6\' | translate}}</label><label ng-if=!auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dueInfo.dType value=c ng-change=\"assignableDGTFx(\'d\',\'ed\');\"><label></label>{{\'cm.label.17\' | translate}}</label><label ng-if=auth.upreferences.sdtf><input type=radio role=radio name=deviceOpt ng-model=dueInfo.dType value=c ng-change=\"assignableDGTFx(\'t\',\'ed\');\"><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-if=\"dueInfo.dType == \'c\'\"><div><!-- Device --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"dOpen=true\" ng-click=\"dOpen=dOpen?false:true;callListAPI = false;\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=flag.d><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'ed\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-init=\"tOpen=true\" ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'ed\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dueInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting17 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu17 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dueInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dueInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dueInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting18 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu18 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dueInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dueInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dueInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dueInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dueInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dueInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dueInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div><!-- Device --><div class=row ng-if=auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"dOpen=dOpen?false:true;flag.d=true;assignableDGTFx(\'d\',\'ed\');\">{{\'cm.label.4s\' | translate}} <span class=fa ng-class=\"dOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.d && dOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"dOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.d && allScrollDataListDyn.length\"><div class=row ng-if=dOpen><ng-device-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'ed\'\" total-count=totalDeviceCount call-api=callListAPI store-data-list=storeDataList></ng-device-assignable></div></div><div ng-if=\"!allScrollDataListDyn.length && dOpen && !flag.d\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div></div><!-- Groups --><div class=row><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"gOpen=gOpen?false:true;assignableDGTFx(\'g\',\'ed\');\">{{\'cm.label.79s\' | translate}} <span class=fa ng-class=\"gOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.g && gOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"gOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.g && (devices.list.groups.length || dueInfo.devices.group.length)\"><div class=row ng-if=gOpen><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting15 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu15 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', devices.list.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.groups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.groups.length}} ]</span></label>{{curAGEM = (devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input ng-disabled=!devices.list.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.groups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'a\', option, devices.list.groups)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.groups.length ng-click=\"listManipulateFx(\'add\', devices.list.groups, dueInfo.devices.group, curGroups.availableGroups, \'\', \'\', \'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dueInfo.devices.group.length ng-click=\"listManipulateFx(\'remove\', devices.list.groups, dueInfo.devices.group, curGroups.assignedGroups, \'\', \'\', \'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting16 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu16 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', dueInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', dueInfo.devices.group);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dueInfo.devices.group.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{dueInfo.devices.group.length}} ]</span></label>{{curAGEM = (dueInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!dueInfo.devices.group.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\"></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dueInfo.devices.group.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dueInfo.devices.group | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selGroupFx(\'s\', option, dueInfo.devices.group)\">{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.groups.length && !dueInfo.devices.group.length && gOpen && !flag.g\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.2\' | translate}}</div></div></div><!-- Tags --><div class=row ng-if=!auth.upreferences.sdtf><div class=\"form-group col-xs-8\"><label class=noMarB><a href=\"\" role=link ng-click=\"tOpen=tOpen?false:true;assignableDGTFx(\'t\',\'ed\');\">{{\'cm.label.94s\' | translate}} <span class=fa ng-class=\"tOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div ng-if=\"flag.t && tOpen\"><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-class=\"tOpen?\'bdr-top-dashed marT5\':\'\'\" ng-if=\"!flag.t && (devices.list.tags.length || dueInfo.devices.tag.length)\"><div class=row ng-if=tOpen><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting17 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu17 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', devices.list.tags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{devices.list.tags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{devices.list.tags.length}} ]</span></label>{{curATEM = (devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlTList sanitize-input ng-disabled=!devices.list.tags.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"devices.list.tags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in devices.list.tags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'a\', option, devices.list.tags)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=!devices.list.tags.length ng-click=\"listManipulateFx(\'add\', devices.list.tags, dueInfo.devices.tag, curTags.availableTags, \'\', \'\', \'t\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!dueInfo.devices.tag.length ng-click=\"listManipulateFx(\'remove\', devices.list.tags, dueInfo.devices.tag, curTags.assignedTags, \'\', \'\', \'t\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting18 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu18 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', dueInfo.devices.tag);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{dueInfo.devices.tag.length > 1?\'d.p_art.2s\':\'d.p_art.2\' | translate}} <span class=\"text-sm text-muted\">[ {{dueInfo.devices.tag.length}} ]</span></label>{{curASTEM = (dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!dueInfo.devices.tag.length ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"dueInfo.devices.tag.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\"><div class=\"row padTB5\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in dueInfo.devices.tag | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break\" ng-click=\"selTagFx(\'s\', option, dueInfo.devices.tag)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div><div class=resize-handle resizable-height></div></div></div></div></div></div></div><div ng-if=\"!devices.list.tags.length && !dueInfo.devices.tag.length && tOpen && !flag.t\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.3\' | translate}}</div></div></div></div></div></div><div class=\"bdr-top-dashed marT10\"><span class=\"btnQuad noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=openDueDownload(); ng-disabled=sendProcessing ng-if=\"dueInfo.type == \'d\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-download\'\" aria-hidden=true></span>{{\'d.btn.18\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=dueUploadFx(); ng-disabled=\"sendProcessing || fileModelLoading\" ng-if=\"dueInfo.type == \'u\'\"><span class=\"fa fa-check\" ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-upload\'\" aria-hidden=true></span> {{sendProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=dueResetFx(); ng-disabled=sendProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'d.msg.17\' | translate}}</span> <span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'upEmpty\'\" aria-live=polite role=status>{{\'d.msg.30\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'hdEmpty\'\" aria-live=polite role=status>{{\'d.msg.40\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></div><!-- Circuit Bench --><div ng-if=\"selectedT==\'13\' && auth.upermissions.emType==\'cb\' && auth.uType != 4\"><img alt=Loading src=assets/images/loading.gif ng-if=innerLoading><div ng-if=!innerLoading><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-primary\" ng-click=forceUpdateOpen(); ng-disabled=forceUpdating><span class=\"fa fa-check\" ng-class=\"forceUpdating?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{forceUpdating?\'cm.btn.51i\':\'cm.btn.51\' | translate}}</button> <span class=marL10><label>{{\'d.brief.18\' | translate}}: <span class=text-unbold>{{cbObj.date}}</span></label></span></div></div></div></div></section>");
$templateCache.put("app/devices/ds.html","<img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div context-menu=contextMenuBase><div class=row ng-if=\"!devicesLoading && devices.devices.length > 0\"><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-device-thumb class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=devices.devices></ng-device-thumb></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.devices.length == 0\">{{\'d.msg.22\' | translate}}</div></div>");
$templateCache.put("app/devices/dt.html","<img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div class=\"noPadT noPadB\" ng-if=!devicesLoading context-menu=contextMenuBase><div class=\"table table-md dTable\" role=table selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"><div class=\"row th\" ng-if=\"filteredTagsList.length > 0\"><div class=col-xs-8>{{\'d.label.4\' | translate | camelCase}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.4s\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'d.label.33\' | translate}}</div></div><ul context-menu=contextMenuOpt><li class=row ng-repeat=\"tag in filteredTagsList = (devices.devices | customSearch:{key:search.text, module:\'d\'})\" data-id={{tag.id}} data-type={{tag.type}}><div class=col-xs-8><label class=\"text-unbold text-ellipsis-wrap noMarB\" ng-class=\"{\'d-flex align-items-center\': auth.upermissions.dtc}\"><input type=checkbox ng-click=\"checkboxFx($event, tag.id);\" role=checkbox><label></label><div ng-if=auth.upermissions.dtc class=\"marR5 marL15 marT2\"><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{tag.tagColor}}></ng-tag-icon></div>{{tag.label}}</label></div><div class=\"col-xs-2 text-right\">{{tag.deviceCount}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(tag.id,\'device\', tag.label);\" ng-if=\"tag.deviceCount != 0\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-right\"><span ng-if=\"tag.deviceCount == 0\" class=\"text-muted text-sm\">N/A</span> <button type=button role=button ng-if=\"tag.deviceCount != 0\" class=\"btn btn-default btn-xs\" ng-click=\"countListFx(tag.id,\'userGroup\', tag.label);\">{{\'cm.btn.21\' | translate}}</button></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"devices.devices.length && filteredTagsList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!devices.devices.length><p class=noMarB>{{\'d.msg.3\' | translate}}</p></div></ul></div></div>");
$templateCache.put("app/devices/dtDevice.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.dt>{{\'cm.label.94s\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.3\':\'d.p_dg.6\' | translate}}</span><span ng-if=deviceTag.info.label class=text-muted>[ {{deviceTag.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><!-- Without tag --><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'cm.label.31\' | translate | capitalize}} <span class=\"marL5 text-sm\">({{\'cm.label.26\' | translate}})</span></h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=deviceTagLoading class=pad10><div class=row ng-if=!deviceTagLoading><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo class=col-xs-12></advanced-search><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=\"pull-right marRL10 filterIcon\" ng-if=\"selectedTab == \'hub.dContainer.dtDevice\'\" uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || devicesLoading}\"><a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\" ng-disabled=\"isPageApiLoad || devicesLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=\"pull-right dropdown\" ng-if=!devices.types.length uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || showRemainingList}\"><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle ng-disabled=\"isPageApiLoad || showRemainingList\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'dt\', \'dt\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\">{{deviceViewText}}</a></li><li><a href=\"\" role=link ng-click=\"checkboxFx(\'all\'); selectAllSDFx(); selectedSearch.text=\'\'\">{{\'cm.btn.44\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchTextS.text sanitize-input maxlength=250 ng-change=searchChangeFx(searchTextS.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextS.text.length ng-click=searchChangeFx();><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{devices.devices.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{quadHeight}}px; ng-scroll=timerFxToLoadData();><img alt=Loading src=assets/images/loading.gif ng-if=deviceTagLoading><div ng-if=\"!deviceTagLoading && devices.types.length > 0\"><ul class=\"list-inline thumb-list dType-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredDTypes = (devices.types | customSearch:{key:searchText, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_selected_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceTagLoading && devices.types.length && !filteredDTypes.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><div ng-if=\"!devicesLoading && breadCrumbs.length\" class=breadcrumb><a href=\"\" role=link ng-if=\"!auth.upermissions.dgrp.dgrp || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\" ng-click=\"getDevicesGroupFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><!-- <a href=\"\" ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last\">{{breadcrumb.label}}</a> --> <a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\">{{breadcrumb.label}}</a> <a href=\"\" role=link ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div><!-- ng-if=\"!paginationLoading\" --> <span ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\" element-height=quadHeight><ng-device-thumb class=show selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!devicesLoading && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!--<div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && advSearchInfo.isEmpty && filter==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n            <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!devicesLoading && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !devicesLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !devicesLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextS.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !devicesLoading\">{{\'as.msg.2\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"closeFilteredFx(\'all\'); closeAllFx(); selectedSearch.text=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text ng-model=selectedSearch.text sanitize-input ng-change=resetSelPagination() class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearch.text.length ng-click=\"selectedSearch.text=\'\';resetSelPagination()\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><!-- Without tag --><div class=panel-inner-tab>{{deviceTag.devices.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate}} <span ng-if=deviceTag.devices>[ {{deviceTag.devices.length}} ]</span></div></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;><div ng-if=\"deviceTag.devices.length > 0\">{{selectedFilteredDevices = (deviceTag.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':deviceTag.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><div class=\"thumb-list hoverContainer\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><!-- Device thumb --><!-- <li ng-repeat=\"device in selectedFilteredDevices = (deviceTag.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}) track by device.id\" data-id=\"{{device.id}}\" ng-if=\"auth.upreferences.deviceView == \'t\'\"> --><li dir-paginate-clone=\"device in selectedFilteredDevices = ((deviceTag.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} class=device><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (device.dType != \'mc\' && device.dType != 7)}\"><a href=\"\" role=link class=thumb-close ng-click=\"closeFilteredFx(device.id, \'d\');\"><span class=\"fa fa-times-circle\"></span></a> <a ng-class=\"{\'thumb-device\': (device.dType != \'mc\' && device.dType != 7)}\" ng-if=\"device.thumbV != undefined && device.thumbV != 0\" role=link ng-href=\"{{dDetailBucket + (device.mac | removeColon) + \'.jpg\' | secureThumb:device.thumbV}}\" fancyboxable=fbTitleInside data-fancybox-title={{device.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (device.mac | removeColon) + \'.jpg\' + dThumbParam + \'&\' + device.thumbV}}\" src-error=assets/images/default/device_{{device.t}}.png> </a><img alt=\"\" ng-if=\"device.thumbV != undefined && device.thumbV == 0\" src=assets/images/default/device_{{device.t}}.png> <span class=\"thumb-icon status\" ng-if=device.status uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{device.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{device.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div><fancybox box-for=\"[rel=fb_group]\" options=fbGroup></fancybox></div><ul class=\"list-inline multiple-selected\" ng-if=\"auth.upreferences.deviceView == \'l\'\" ng-class=\"{\'marT10\':deviceTag.devices.length>auth.upreferences.dpc && selectedFilteredItems.length}\"><div class=\"table table-md whiteRow\" ng-class=\"{\'hide\':selectedFilteredDevices.length == 0}\"><div class=\"row th\"><div class=col-xs-7>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-right noPadL\">{{\'cm.label.25\' | translate}}</div></div><!-- Device list --><!-- <li class=\"row\" ng-repeat=\"device in selectedFilteredDevices = (deviceTag.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'})\" data-id=\"{{device.id}}\" data-type=\"device\" data-sub-type=\"{{device.type}}\"> --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((deviceTag.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}}><div class=\"col-xs-7 text-ellipsis\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.label}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.mac}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.4\' | translate}}</div> --><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"closeFilteredFx(device.id, \'d\')\"><span class=\"fa fa-remove\"></span></a></div></li></div><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div><fancybox box-for=\"[rel=fb_group]\" options=fbGroup></fancybox></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"deviceTag.devices.length == 0\">{{\'cm.msg.4\' | translate}}</div></div></section></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.dContainer.dtName({id: encId})\" ng-disabled=saveCloseProcessing><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceTagFx(\'device\', \'sc\');\" ng-disabled=saveCloseProcessing><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.dt ng-disabled=saveCloseProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'mcDeviceTag\'\" aria-live=polite role=status>{{\'d.p_dg.m11\' | translate}}</div><div ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'d.p_dg.m13\' | translate}}</div></div><div class=clearfix></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/dtName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.devices.dt>{{\'cm.label.94s\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.3\':\'d.p_dg.6\' | translate}}</span><span ng-if=deviceTag.info.label class=text-muted>[ {{deviceTag.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'d.p_dg.7\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=deviceTagLoading><div class=row ng-if=!deviceTagLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'d.label.4\' | translate}}</label><input type=text id=label class=form-control ng-keypress=\"$event.keyCode == 13 && saveDeviceTagFx(\'name\');\" ng-model=deviceTag.info.label placeholder=\"{{\'d.ph.4\' | translate}}\" focus-me=true maxlength={{inputLimit}} aria-label=\"{{\'d.label.4\' | translate}}\" aria-labelledby=\"{{\'d.label.4\' | translate}}\" aria-placeholder=\"{{\'d.label.4\' | translate}}\"></div><div class=row ng-if=auth.upermissions.dtc><div class=\"form-group col-xs-4\"><label><input type=checkbox ng-model=deviceTag.info.isBg role=checkbox><label></label>{{\'cl.widget.cm.3\' | translate}}</label><div ng-if=deviceTag.info.isBg uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':deviceTag.info.tagColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"deviceTag.info.tagColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><ng-hub-color-picker selected-color=deviceTag.info.tagColor selected-type=deviceTag.info.tagColorType ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div></div><div class=panel-footer ng-if=!deviceTagLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveDeviceTagFx(\'name\', \'sc\');\" ng-if=deviceTag.info.isCompleted ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button><!-- Without tag --> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveDeviceTagFx(\'name\');\" ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'cm.label.31\' | translate | camelCase}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.dt ng-disabled=\"saveCloseProcessing || saveProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_dg.m9\' | translate}}</div><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'d.p_dg.m10\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/dvw.html","<img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div context-menu=contextMenuBase><div class=row ng-if=\"!devicesLoading && devices.walls.length > 0\"><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-device-thumb class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=devices></ng-device-thumb></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!devicesLoading && devices.walls.length == 0\"><p>{{\'d.msg.69\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'dvw\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'d.tool.22\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/devices/dvwName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><a href=\"\" role=link class=marR10 ui-sref=hub.devices.dvw>{{\'d.label.62\' | translate}}</a>/<span class=\"marL10 marR10\">{{encId == \'\'?\'d.btn.31\':\'d.p_dg.2\' | translate}}</span><span ng-if=deviceGroup.info.label class=text-muted>[ {{deviceGroup.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.label.63\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=deviceVWLoading><div class=row ng-if=!deviceVWLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'d.label.62.1\' | translate}}</label><input type=text id=label class=form-control ng-keypress=\"$event.keyCode == 13\" ng-model=deviceDvw.info.label placeholder=\"{{\'d.ph.5\' | translate}}\" focus-me=true maxlength={{inputLimit}} aria-label=\"{{\'d.label.62.1\' | translate}}\" aria-labelledby=\"{{\'d.label.62.1\' | translate}}\"></div><div class=form-group><div class=row><div class=col-xs-5><label for=col>{{\'d.label.65\' | translate}}</label><input type=number id=col class=form-control min=1 ng-keypress=\"$event.keyCode == 13\" ng-model=deviceDvw.info.col aria-label=\"{{\'d.label.65\' | translate}}\" aria-labelledby=\"{{\'d.label.65\' | translate}}\"></div><div class=col-xs-5><label for=row>{{\'d.label.64\' | translate}}</label><input type=number id=row class=form-control min=1 ng-keypress=\"$event.keyCode == 13\" ng-model=deviceDvw.info.row aria-label=\"{{\'d.label.64\' | translate}}\" aria-labelledby=\"{{\'d.label.64\' | translate}}\"></div><div class=col-xs-2><label>&nbsp;</label><div><button type=button role=button class=\"btn btn-default w100\" ng-click=createMatrixOpen(); ng-disabled=\"deviceDvw.info.row == \'\' || deviceDvw.info.col == \'\'\"><span class=fa ng-class=\"generateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{generateProcessing?\'cl.widget.queue.1bi\':\'cl.widget.queue.1b\' | translate}}</button></div></div></div></div><div class=form-group ng-if=\"deviceDvw.wallList.length > 0\"><div class=\"table table-md\" role=table><div class=\"row th\"><div class=\"col-xs-3 padL25\">{{\'d.body.15\' | translate}}</div><div class=col-xs-4>{{\'cm.label.4\' | translate}}</div><div class=col-xs-3>{{\'d.brief.11\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=sortable-containment sortable callback=sortCallback()><div class=\"row sortable-item d-flex align-items-center\" ng-repeat=\"w in deviceDvw.wallList | orderBy:[\'-isMaster\', \'id\'] track by w.id\" data-wid={{w.id}} data-device={{w.device}} data-cell={{w.cell}} data-master={{w.isMaster}}><div class=\"col-xs-3 padL25\"><span class=\"master-wall marR3\" ng-if=w.isMaster><span class=\"fa fa-star\" uib-tooltip=\"{{\'an.tab.3\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-hidden=true role=status aria-label=\"{{\'an.tab.3\' | translate}}\"></span></span>{{w.cell.label}}</div><div class=\"col-xs-4 codeQuad\"><div class=\"codeText text-ellipsis-wrap\"><span class=deviceStatus ng-class=\"w.device.status == \'online\'?\'online\':\'offline\'\" uib-tooltip=\"{{w.device.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span>{{w.device.label}}</div></div><div class=col-xs-3><input type=text class=\"form-control input-sm\" ng-model=w.device.localIp aria-label=\"{{\'d.brief.11\' | translate}}\" ng-pattern=ipAddressPattern required aria-labelledby=\"{{\'d.brief.11\' | translate}}\"></div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=text-danger ng-click=deleteWallOpen(w.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div></div><div class=col-xs-5 ng-if=preMatrix><div class=\"form-group marL20\"><label for=wp>{{\'d.label.66\' | translate}}</label><div class=scrollQuad-y ng-attr-style=max-height:{{getAvailableHeight(320)}}px><div id=matrix-container class=matrix-container><!-- {{cells}} --><div ng-repeat=\"row in cells\" class=matrix-row><div id={{cell.label}} ng-repeat=\"cell in row\" class=\"matrix-cell flexDirCol\"><span ng-if=!cell.dLabel class=\"text-center text-bold\">{{cell.label}}</span> <span ng-if=!cell.dLabel class=\"btn btn-link text-primary text-ellipsis hTitle w-100\" uib-tooltip=\"{{\'cm.label.31\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 ng-click=selectDevice(cell)>{{\'cm.label.31\' | translate}}</span><!-- {{cell.device}} --><!-- {{tim + bucket + (cell.device.mac) + \'.jpg\' + \'&\' + cell.device.thumbV + dThumbParam}} --><div ng-if=cell.dLabel class=\"d-flex align-items-center justify-center flexDirCol\"><div class=\"thumb-inner thumb-device\"><img alt={{cell.dType}} ng-if=\"cell.thumbV != 0 && (cell.dType == 1 || cell.dType == 3 || cell.dType == 2 || cell.dType == \'mp\' || cell.dType == \'tizen\' || cell.dType == \'webos\')\" ng-src=\"{{tim + bucket + (cell.mac | removeColon) + \'.jpg\' + \'&\' + cell.thumbV + dThumbParam}}\" src-error=assets/images/default/device_{{cell.dType}}.png> <img alt=d_{{cell.dType}} ng-if=\"cell.thumbV == 0\" ng-src=assets/images/default/device_{{cell.dType}}.png> <span class=\"thumb-icon status\" role=status ng-if=cell.status title=\"{{cell.status | capitalize}}\" aria-label={{cell.status}}><span class={{cell.status}}></span></span> <a href=\"\" role=link aria-label=deleteWall class=\"text-danger remDIcon thumb-close\" ng-click=deleteWallOpen(cell.wId); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-times-circle\" aria-hidden=true></span></a></div><div class=\"dName text-center text-ellipsis w30\" uib-tooltip={{cell.dLabel}} tooltip-append-to-body=true tooltip-popup-delay=500>{{cell.dLabel}}</div></div></div></div></div></div></div></div></div></div><div class=panel-footer ng-if=!deviceVWLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveVideoWallFx(); ng-disabled=\"!preMatrix || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.devices.dvw ng-disabled=saveProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'d.msg.65\' | translate}}</div><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'d.msg.72\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'db.msg.2\' | translate}}</div><div ng-if=\"errType==\'cell\'\" aria-live=polite role=status>{{\'d.msg.64\' | translate}}</div><div ng-if=\"errType==\'list\'\" aria-live=polite role=status>{{\'d.msg.66\' | translate}}</div><div ng-if=\"errType==\'row\'\" aria-live=polite role=status>{{\'d.msg.67\' | translate}}</div><div ng-if=\"errType==\'col\'\" aria-live=polite role=status>{{\'d.msg.68\' | translate}}</div><div ng-if=\"errType==\'schedule\'\" aria-live=polite role=status>{{\'d.msg.71\' | translate}}</div><div ng-if=\"errType==\'matrix\'\" aria-live=polite role=status>{{\'d.msg.77\' | translate}}</div><div ng-if=\"errType==\'dupDevice\'\" aria-live=polite role=status>{{\'d.msg.78\' | translate}}</div><div ng-if=\"errType==\'ipAddress\'\" aria-live=polite role=status>{{\'d.msg.79\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/playList.html","<section class=\"selectedQuad panel\" ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><p>{{\'d.btn.8\' | translate}}</p><div class=panel-tools><div class=pull-right><a href=\"\" role=link ui-sref=hub.devices.d uib-tooltip=\"{{\'cm.btn.10\' | translate}}\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div></div><div class=panel-tools><div class=\"pull-right marT6 marR5\"><div class=\"input-group input-group-sm\" style=width:130px><span class=input-group-addon>{{\'cm.label.57\' | translate}}:</span><select class=form-control ng-model=canvas.zoom aria-label=\"{{\'cm.label.57\' | translate}}\" aria-labelledby=\"{{\'cm.label.57\' | translate}}\"><option value=1>100%</option><option value=0.75>75%</option><option value=0.5>50%</option><option value=0.25>25%</option><option value=0.1>10%</option></select></div></div></div></header><div class=\"panel-body noPad\"><img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading class=pad10><div ng-if=!detailsLoading class=relative style=height:{{getAvailableHeight(165)}}px><div class=playListQuad><div ng-if=playList class=\"bg-black relative\" style=\"height:{{playList.layout[0].height * canvas.zoom}}px;width:{{playList.layout[0].width * canvas.zoom}}px\"><div ng-repeat=\"frame in playList.layout[0].frame\" class=\"absolute overflow-hidden\" style=\"background:{{frame.bgColor}};height:{{frame.height * canvas.zoom}}px;width:{{frame.width * canvas.zoom}}px;left:{{frame.x * canvas.zoom}}px;top:{{frame.y * canvas.zoom}}px;z-index:{{frame.z}}\"><ng-frame items=frame.schedule[0].item width=\"frame.width * canvas.zoom\" height=\"frame.height * canvas.zoom\" tim=tim bucket=bucket></ng-frame></div></div><div class=\"canvasBg overflow-auto top-content\" style=bottom:{{listHeight}}px><div class=\"bg-black relative overflow-hidden\" style=\"width:{{frameLayout.width*canvas.zoom}}px; height:{{frameLayout.height*canvas.zoom}}px\"><div ng-repeat=\"frame in frameLayout.frame\" data-index={{$index}} class=frameDrag style=left:{{frame.x*canvas.zoom}}px;top:{{frame.y*canvas.zoom}}px;z-index:{{frame.z}}><div data-id={{frame.id}} data-index={{$index}} style=width:{{frame.width*canvas.zoom}}px;height:{{frame.height*canvas.zoom}}px;background-color:{{frame.bg}};transform:rotate({{frame.rotation}}deg><!-- Content here --></div></div></div></div><div class=resizer-handleH resizer=horizontal resizer-height=6 resizer-top=.top-content resizer-bottom=.bottom-content style=\"bottom:{{listHeight - 3}}px\" resizer-min=50 resizer-max={{getAvailableHeight(300)}}></div><div class=\"overflow-auto pad10 bottom-content\" style=height:{{listHeight}}px><div ng-repeat=\"fl in playList.layout\"><div ng-repeat=\"f in fl.frame\">{{f.frameName}}<ul class=list-unstyled><li ng-repeat=\"s in f.slot\"><ul class=list-unstyled><li ng-repeat=\"i in s.content\"><img alt=\"\" ng-src={{i.src}}></li></ul></li></ul></div></div></div></div></div></div></section>");
$templateCache.put("app/dashboard/dashboard.html","<img alt=Loading src=assets/images/loading.gif ng-if=dashboardLoading><div ng-show=!dashboardLoading><div ng-class=\"{\'gride-editable\':dgActions.isEditable}\"><div gridstack class=grid-stack options=dgOptions on-change=onChange(event,items) on-drag-start=onDragStart(event,ui) on-drag-stop=onDragStop(event,ui) on-resize-start=onResizeStart(event,ui) on-resize-stop=onResizeStop(event,ui)><div gridstack-item class=grid-stack-item ng-repeat=\"gridItem in dGridArr | orderBy:\'y\'\" data-gs-no-resize=1 data-gs-no-move=1 gs-item-x=gridItem.x gs-item-y=gridItem.y gs-item-width=gridItem.wd gs-item-height=gridItem.hg gs-item-min-height=gridItem.mh gs-item-max-height=gridItem.maxH gs-item-autopos=0 on-item-added=onItemAdded(item) on-item-removed=onItemRemoved(item)><div class=\"cursorDefault grid-stack-item-content\" ng-class=\"dgActions.isEditable?\'\':\'db-\'+gridItem.ty\"><!-- Device Status --><div ng-if=\"gridItem.ty == \'ds\'\" class=\"pad10 chartQuad cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div ng-if=dashboard.dc class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu1_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':dashboard.dc == 0}\"><a href=\"\" role=link id=download1_{{$index}} ng-click=\"openGroupDevices(\'ds\', dashboard.dc, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'ds\', dashboard.dc);--></ul></div><highchart config=dsArr ng-if=dashboard.dc></highchart><div class=\"blank-pie text-muted\" ng-if=!dashboard.dc><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=dsOnline1_{{$index}} ng-click=\"deviceDetailListFx(\'ds\', \'\',\'\',\'ondc\');\" aria-label=\"Device online\">{{dashboard.ds.ondc}}<!-- {{!secondaryLoading?dashboard.ds.ondc:\'\'}} --><!-- <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"secondaryLoading\"> --> </a><span ng-if=dashboard.dc>/ <a href=\"\" role=link id=dsTotal1_{{$index}} ng-click=\"deviceDetailListFx(\'ds\', \'\',\'\',\'total\');\" class=text-muted aria-label=\"Total Devices\">{{dashboard.dc | number}}</a></span></div><div class=text-muted ng-cloak>{{dashboard.ds.ondc > 1?\'db.body.1s\':\'db.body.1\' | translate}}</div></div></div><!-- Content Count --><div ng-if=\"gridItem.ty == \'c\'\" class=\"pad10 padTB20 cursorDefault\" id=content-list ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=pull-left><div class=\"statusCounter ng-cloak\">{{dashboard.c.tc | number}}</div><div class=text-muted>{{\"cm.label.1\" | translate}}</div></div><div class=statusIcon><a href=\"\" role=link id=contentFolder1_{{$index}} aria-label=Content ng-click=\"dbGotoFx(\'c\');\"><span class=\"fa fa-folder-open text-primary\" aria-hidden=true></span></a></div><div class=clearfix></div><div class=progress ng-if=dashboard.c><div class=pull-left style=\"width:{{usedSpacePercent | number:2}}%\" uib-tooltip-html=\"\'{{\'cl.tool.10\' | translate}}:&nbsp;{{dashboard.c.ac}}<br/>{{\'cl.tool.11\' | translate}}:&nbsp;{{dashboard.c.uac}}<br/>{{\'db.body.8\' | translate}}:&nbsp;{{dashboard.c.ec}}<br/>{{\'db.body.6\' | translate}}:&nbsp;{{dashboard.c.arc}}<br/>{{\'db.body.7\' | translate}}:&nbsp;{{dashboard.c.dc}}\'\" tooltip-append-to-body=true><div class=\"progress-bar progress-bar-primary\" style=\"width:{{(dashboard.c.ac * 100)/dashboard.c.tc | number:0}}%\"></div><div class=\"progress-bar progress-bar-gray\" style=\"width:{{(dashboard.c.uac * 100)/dashboard.c.tc | number:0}}%\"></div><div class=\"progress-bar progress-bar-warning\" style=\"width:{{(dashboard.c.ec * 100)/dashboard.c.tc | number:0}}%\"></div><div class=\"progress-bar progress-bar-warning\" style=\"width:{{(dashboard.c.arc * 100)/dashboard.c.tc | number:0}}%\"></div><div class=\"progress-bar progress-bar-danger\" style=\"width:{{(dashboard.c.dc * 100)/dashboard.c.tc | number:0}}%\"></div></div><div class=pull-left style=\"width:{{(100 - usedSpacePercent) | number:2}}%\" uib-tooltip=\"{{(100 - usedSpacePercent) | number:1}}% {{\'db.body.2\' | translate}}\" tooltip-append-to-body=true ng-if=\"usedSpacePercent > 0\">&nbsp;</div><div class=pull-left style=\"width:{{(100 - usedSpacePercent) | number:2}}%\" uib-tooltip=\"{{(100 - usedSpacePercent) | number:0}}% {{\'db.body.2\' | translate}}\" tooltip-append-to-body=true ng-if=\"usedSpacePercent == 0\">&nbsp;</div></div></div><!-- Schedules Count --><div ng-if=\"gridItem.ty == \'sc\'\" class=\"pad10 padT20 cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=pull-left><div class=\"statusCounter ng-cloak\">{{dashboard.sc.tc | number}}</div><div class=text-muted>{{dashboard.sc.tc>1?\'cm.label.3s\':\'cm.label.3\' | translate}}</div></div><div class=statusIcon><a href=\"\" role=link id=schedulesCount1_{{$index}} aria-label=schedule ng-click=\"dbGotoFx(\'s\');\"><span class=\"fa fa-calendar text-primary\" aria-hidden=true></span></a></div><div class=clearfix></div><div class=dCardQuad><span ng-if=dashboard.sc class=\"text-sm text-bold text-ellipsis\" uib-tooltip-html=\"\'{{\'db.body.9\' | translate}}:&nbsp;{{dashboard.sc.as}}<br/>{{\'cl.tool.11\' | translate}}:&nbsp;{{dashboard.sc.us}}<br/>{{\'db.body.10\' | translate}}:&nbsp;{{dashboard.sc.is}}<br/>{{\'db.body.8\' | translate}}:&nbsp;{{dashboard.sc.es}}\'\" tooltip-append-to-body=true><span ng-if=\"dashboard.sc.as>0\" class=text-success>{{dashboard.sc.as}} {{\'db.body.9\' | translate}}</span> <span ng-if=\"dashboard.sc.us>0\" class=text-muted>{{dashboard.sc.us}} {{\'cl.tool.11\' | translate}}</span> <span ng-if=\"dashboard.sc.is>0\" ng-class=\"dashboard.sc.is>50?\'text-danger\':\'text-info\'\">{{dashboard.sc.is}} {{\'db.body.10\' | translate}}</span> <span ng-if=\"dashboard.sc.es>0\" class=text-danger>{{dashboard.sc.es}} {{\'db.body.8\' | translate}}</span></span></div></div><!-- Users Count --><div ng-if=\"gridItem.ty == \'us\'\" class=\"pad10 padT20 cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=pull-left><div class=\"statusCounter ng-cloak\">{{dashboard.us.tc | number}}</div><div class=text-muted>{{dashboard.us.tc > 1?\'cm.label.5s\':\'cm.label.5\' | translate}}</div></div><div class=statusIcon><a href=\"\" role=link id=usersCount1_{{$index}} aria-label=user ng-click=\"dbGotoFx(\'u\');\"><span class=\"fa fa-users text-primary\" aria-hidden=true></span></a></div><div class=clearfix></div><div class=dCardQuad><span ng-if=dashboard.us class=\"text-sm text-bold text-ellipsis\" uib-tooltip-html=\"\'{{\'db.body.9\' | translate}}:&nbsp;{{dashboard.us.au}}<br/>{{\'db.body.11\' | translate}}:&nbsp;{{dashboard.us.bu}}\'\" tooltip-append-to-body=true><span ng-if=\"dashboard.us.au>0\" class=text-success>{{dashboard.us.au}} {{\'db.body.9\' | translate}}</span> <span ng-if=\"dashboard.us.bu>0\" class=text-muted>{{dashboard.us.bu}} {{\'db.body.11\' | translate}}</span></span></div></div><!-- Recent Activity Log --><div ng-if=\"gridItem.ty == \'ral\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu2_{{$index}} aria-label=activityLog uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':logList.length == 0}\"><a href=\"\" role=link id=download2_{{$index}} ng-click=logsOpen(); aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><li><a href=\"\" role=link id=refresh2_{{$index}} ng-click=loadMoreLogs(0); aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'db.body.3\' | translate}}</h1></header><div class=\"activityLog dashActivityBg\"><div class=\"bg-light pad10\"><label for=logSearch2_{{$index}} class=lableHidden>logSearch</label><div class=\"input-group1 searchTbx\"><input type=text id=logSearch2_{{$index}} class=form-control ng-model=searchText.log sanitize-input maxlength=250 ng-change=\"searchFrmAllData(searchText.log, \'ral\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=logSR2_{{$index}} class=text-danger ng-show=searchText.log.length ng-click=\"searchText.log=\'\';searchFrmAllData(searchText.log, \'ral\');\" aria-label=Clear><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th\"><div class=dbScrollQuad when-scrolled=loadMoreLogs() ng-hide=dbListLoading.ral ng-if=\"logList.length > 0 || haveDataList.ral\"><div class=row ng-repeat=\"log in filteredLogList = (logList)\"><!-- <div class=\"row\" ng-repeat=\"log in filteredLogList = (logList | filter:searchText.log)\"> --><div class=\"col-xs-8 col-sm-8 col-lg-9\"><div class=user-tumb><img alt=user src=\"{{tim + uBucket + log.uI}}&w=36&h=36&q=80&zc=3\" ng-if=log.uI><div class=profileIcon-sm ng-if=!log.uI><span>{{log.u | limitTo:1}}</span></div></div><div class=\"text-ellipsis ng-cloak\" uib-tooltip={{log.cmt}} tooltip-append-to-body=true tooltip-popup-delay=1500><span ng-if=\"!log.isDetailed && !log.dFile\">{{log.cmt}}</span> <span ng-if=\"!log.isDetailed && log.dFile\"><a href=\"\" role=link id=dFile2_{{$index}} ng-click=\"linkOpenFx(\'m\', log.dFile);\" aria-label=log>{{log.cmt}}</a></span> <a href=\"\" role=link id=detailedLog2_{{$index}} class=btn-link ng-click=detailedLogFx(log); ng-if=log.isDetailed aria-label=log>{{log.cmt}}</a></div><div class=\"text-ellipsis text-sm text-bold text-muted\">{{log.u}}</div></div><div class=\"col-xs-4 col-sm-4 col-lg-3 text-right\" uib-tooltip-html=\"\'{{log.ld}}<br>{{log.lt}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1500><div class=\"text-ellipsis text-sm\">{{log.ld}}</div><div class=\"text-ellipsis text-sm text-muted ng-cloak\">{{log.lt}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredLogList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.log)}}&quot;</b>\'}\"></div></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ral><div ng-class=\"{\'msg-warning\':!dbListLoading.ral}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"logList.length <= 0 && !haveDataList.ral\"><span ng-if=!dbListLoading.ral>{{\'cm.msg.1\'| translate}}</span></div></div></div></div><!-- Devices List New start --><div ng-if=\"gridItem.ty == \'d\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu3_{{$index}} aria-label=deviceList uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-if=\"auth.upermissions.edl && allScrollDataList.d.length\" ng-class=\"{\'disabled\':deviceList.length == 0}\"><a href=\"\" role=link id=dlD3_{{$index}} ng-click=\"openGroupDevices(\'d\', \'\', \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><li><a href=\"\" role=link id=dlR3_{{$index}} ng-click=loadMoreDeviceListFx(detailListObj.d); aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'cm.label.4s\' | translate}}</h1></header><div class=\"bg-light pad10\" ng-if=\"allScrollDataList.d.length > 5\"><label for=dSearch3_{{$index}} class=lableHidden>Device</label><div class=searchTbx><input type=text id=dSearch3_{{$index}} class=form-control ng-model=searchText.device sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchText.device, \'d\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=deviceSR3_{{$index}} class=text-danger ng-show=searchText.device.length ng-click=\"searchText.device=\'\';searchChangeDataDyn(searchText.device, \'d\');\" aria-label=Clear><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th dashDevice activityLog dashDeviceBg\"><div class=dbScrollQuad ng-hide=dbListLoading.d ng-if=\"allScrollDataList.d.length > 0\" id=scroll-container-d dynamic-scroll-list st=stIndex.d et=etIndex.d list-data=scrollDataList.d search-data=searchText.device have-more-data=haveMoreData.d search-scroll=searchScroll.d clone-data=allScrollDataList.d have-more-search-data=haveMoreSearchData.d quad-id=\"\'d\'\" dd-open=true><div class=\"row rowObj-d\" id={{device.id}} ng-repeat=\"device in filteredDeviceList = (visibleData.d)\"><div class=\"col-xs-10 text-ellipsis\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 role=status aria-label=\"{{device.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\"></span><span uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label={{device.l}} role=status>{{device.l}}</span></div><div class=\"col-xs-2 text-right\"><span ng-if=\"device.space != null && device.space < 51200 && (auth.uType == 0 || auth.uType == 1)\" class=\"fa fa-exclamation-triangle text-danger marR5\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true></span> <a href=\"\" role=link id=deviceSet3_{{$index}} ng-click=\"deviceControlOpen(device.id, device.l, device.t);\" ng-if=\"auth.upermissions.dc && device.t != 8 && device.t != 7\" aria-label=\"Device Control\"><span class=\"fa fa-cog text-muted\" aria-hidden=true></span></a></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.d || !haveMoreSearchData.d) && scrollDataList.d.length >= 300 && scrollDataList.d.length == etIndex.d\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.d.length > 0 && filteredDeviceList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.device)}}&quot;</b>\'}\"></div></div><div ng-class=\"{\'msg-warning\':(!dbListLoading.d)}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"allScrollDataList.d.length <= 0\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.d> <span ng-if=!dbListLoading.d>{{\'db.msg.1\'| translate}}</span></div></div></div><!-- Devices List New end --><!-- Devices on Map new start --><div ng-if=\"gridItem.ty == \'dom\'\" db-get-set-height offset=0 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><a href=\"\" role=link id=mapR_{{$index}} class=\"pull-right text-muted\" ng-click=\"deviceListOnMap(\'refresh\');\" ng-disabled=refreshing aria-label=refresh><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': refreshing}\" aria-hidden=true></span></a><h1 class=dHeading>{{\'db.body.4\' | translate}}</h1></header><div class=dbScrollQuad><div class=\"panel-body h100 noPad map-quad\" ng-if=isImgMap><div class=map-text><a href=\"\" ng-click=viewMapFx();>{{\'db.btn.5\' | translate}}</a></div></div><div class=\"panel-body h100 noPad\" ng-if=\"auth.uservices.m == \'g\' && !isImgMap\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=mapLoading class=pad10><ng-map center=\"[43.6532, -79.3832]\" zoom=5 ng-if=\"!mapLoading && markerList.length == 0\"></ng-map><ng-map zoom=8 zoom-to-include-markers=auto ng-if=\"!mapLoading && markerList.length > 0\"><marker ng-repeat=\"marker in markerList\" ng-if=\"marker.latitude != null && marker.longitude != null\" position={{marker.latitude}},{{marker.longitude}} on-click=\"showDetail(event, marker);\" icon=\"{{marker.status?\'assets/images/green-dot.png\':\'assets/images/gray-dot.png\'}}\"></marker><info-window id=info><div ng-non-bindable=\"\"><div class=text-bold><span class=\"deviceStatus {{markerDetail.status}}\"></span>{{markerDetail.label}}</div></div></info-window></ng-map></div><div class=\"panel-body h100 noPad\" ng-if=\"auth.uservices.m == \'b\' && !isImgMap\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=mapLoading class=pad10><div id=azMap style=width:100%;height:100%></div></div></div><div class=\"panel-footer padB10\"><span class=\"btnQuad pull-right noMarB\">&nbsp;<button type=button role=button ng-click=registerOnMapOpen(); class=\"btn btn-primary btn-sm\" ng-if=auth.upermissions.rdm><span class=\"glyphicon glyphicon-map-marker\" aria-hidden=true></span>{{\'db.btn.1\' | translate}}</button></span><div class=\"text-muted marT5\" ng-if=dashboard.devices>{{\'db.body.5\' | translate: {show: markerList.length, total: dashboard.devices.totalCount} }}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.dlom><div class=clearfix></div></div></div><!-- Devices on Map new end --><!-- Devices Type Summary new start --><div ng-if=\"gridItem.ty == \'dts\'\" class=\"pad10 chartQuad cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div ng-if=curDCData.dts.total class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu4_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=Menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':curDCData.dts.total == 0}\"><a href=\"\" role=link id=download4_{{$index}} ng-click=\"openGroupDevices(\'dts\', curDCData.dts.total, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'dts\', curDCData.dts.total);--></ul></div><highchart config=dtsArr ng-if=curDCData.dts.total></highchart><div class=\"blank-pie text-muted\" ng-if=!curDCData.dts.total><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1>{{\'d.tab.1\' | translate}}</h1></div><div class=text-muted>{{\'d.label.1.1\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=mp4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'mp\');\" aria-label=devices>{{curDCData.dts.mp}}</a></div><div class=text-muted ng-if=auth.upermissions.webos>{{\'d.label.1.5\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=webos4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'webos\');\" aria-label=devices>{{curDCData.dts.webos}}</a></div><div class=text-muted ng-if=auth.upermissions.tizen>{{\'d.label.1.6\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=tizen4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'tizen\');\" aria-label=devices>{{curDCData.dts.tizen}}</a></div><div class=text-muted ng-if=auth.upermissions.mc>{{\'d.label.1.4\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=mc4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'mc\');\" aria-label=devices>{{curDCData.dts.mc}}</a></div><div class=text-muted ng-if=auth.upermissions.gf>{{\'d.label.1.2\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=gf4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'gf\');\" aria-label=devices>{{curDCData.dts.gf}}</a></div><div class=text-muted ng-if=auth.upermissions.vd>{{\'d.label.1.3\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=v4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'v\');\" aria-label=devices>{{curDCData.dts.v}}</a></div><div class=text-muted ng-if=auth.upermissions.desktop>{{\'d.label.1.7\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=desktop4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'desktop\');\" aria-label=devices>{{curDCData.dts.desktop}}</a></div><div class=text-muted ng-if=auth.upermissions.epd>{{\'d.label.1.8\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> <a href=\"\" role=link ng-if=!secondaryLoading id=epd4_{{$index}} ng-click=\"deviceDetailListFx(\'dts\', \'\', \'epd\');\" aria-label=devices>{{curDCData.dts.epd}}</a></div><div class=\"text-muted text-bold marT5\">{{\'r.body.9\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=secondaryLoading> {{!secondaryLoading?curDCData.dts.total:\'\'}}</div></div></div><!-- Device Temperature Summary new start --><div ng-if=\"gridItem.ty == \'dtps\'\" class=\"pad10 chartQuad cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div ng-if=\"curDCData.dtps.totalCount > 0\" class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu5_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=Menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=down5_{{$index}} ng-click=\"openGroupDevices(\'dtps\', {n:curDCData.dtps.n, c:curDCData.dtps.c, d:curDCData.dtps.d}, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'dtps\', {n:curDCData.dtps.n, c:curDCData.dtps.c, d:curDCData.dtps.d});--></ul></div><highchart config=tempArr ng-if=\"curDCData.dtps.totalCount > 0\"></highchart><div class=\"blank-pie text-muted\" ng-if=!curDCData.dtps.totalCount><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1>{{\'db.body.14\' | translate}}</h1></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.14.1\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.dtps> <a href=\"\" role=link ng-if=!dbListLoading.dtps id=dtpsN5_{{$index}} ng-click=\"deviceDetailListFx(\'dtps\', \'\', \'n\');\" aria-label=\"{{\'db.body.14.1\' | translate}}\">{{curDCData.dtps.n}}</a></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.14.2\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.dtps> <a href=\"\" role=link ng-if=!dbListLoading.dtps id=dtpsC5_{{$index}} ng-click=\"deviceDetailListFx(\'dtps\', \'\', \'c\');\" aria-label=\"{{\'db.body.14.2\' | translate}}\">{{curDCData.dtps.c}}</a></div><div class=text-muted ng-cloak>{{\'db.body.14.3\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.dtps> <a href=\"\" role=link ng-if=!dbListLoading.dtps id=dtpsD5_{{$index}} ng-click=\"deviceDetailListFx(\'dtps\', \'\', \'d\');\" aria-label=\"{{\'db.body.14.3\' | translate}}\">{{curDCData.dtps.d}}</a></div></div></div><!-- Device Temperature Summary new end --><!-- Content Confirmation Summary new start --><div ng-if=\"gridItem.ty == \'ccs\'\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div ng-if=curDCData.ccs.total class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu6_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=Menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':curDCData.ccs.down + curDCData.ccs.rem == 0}\"><a href=\"\" role=link id=down6_{{$index}} ng-click=\"openGroupDevices(\'ccs\', curDCData.ccs.total, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'ccs\');--></ul></div><highchart config=downArr ng-if=\"curDCData.ccs.down + curDCData.ccs.no + curDCData.ccs.rem > 0 && curDCData.ccs.total > 0\"></highchart><div class=\"blank-pie text-muted\" ng-if=\"!curDCData.ccs.down && !curDCData.ccs.no && !curDCData.ccs.rem\"><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=ccsDown6_{{$index}} ng-click=\"deviceDetailListFx(\'ccs\', \'\', \'down\');\" aria-label=Confirmed>{{!dbListLoading.ccs?curDCData.ccs.down:\'\'}}<img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></a><span ng-if=curDCData.ccs.total>/ <a href=\"\" role=link id=ccsT6_{{$index}} ng-click=\"deviceDetailListFx(\'ccs\', \'\', \'total\');\" class=text-muted aria-label=Unconfirmed>{{curDCData.ccs.total}}</a></span></div><div class=text-muted ng-cloak>{{\"db.body.13\" | translate}}</div></div></div><!-- Content Confirmation Summary new end --><!-- Devices Other Info Summary --><div ng-if=\"gridItem.ty == \'dps\' && dpsArr[gridItem.sty].series[0].data.length\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu7 uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':dpsArr[gridItem.sty].series[0].d == 0}\"><a href=\"\" role=link id=dpsDown7 ng-click=\"openGroupDevices(\'dps\', dpsArr[gridItem.sty].series[0].d, \'\', dpsArr[gridItem.sty].series[0], \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'dps\', {c:dpsArr[gridItem.sty].series[0].name, n:\'\', d:dpsArr[gridItem.sty].series[0].d});\"--></ul></div><highchart config=dpsArr[gridItem.sty]></highchart><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1 class=word-break>{{dpsArr[gridItem.sty].series[0].name | capitalize}}</h1></div><div class=text-muted ng-cloak ng-repeat=\"val in dpsArr[gridItem.sty].series[0].data\">{{val.name | camelCase}}: <a href=\"\" role=link id=deviceOIS{{$index}} ng-click=\"deviceDetailListFx(\'dps\', \'\', dpsArr[gridItem.sty].series[0].name, val.name);\" aria-label={{val.name}}>{{val.y}}</a></div></div></div><!-- Devices Properties Summary --><div ng-if=\"gridItem.ty == \'dpts\' && dptsArr[gridItem.sty].series[0].data.length\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\" ng-if=auth.upermissions.edl><a href=\"\" role=menu id=vMenu8_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-class=\"{\'disabled\':dashboard.dpts[gridItem.sty].total.length == 0}\"><a href=\"\" role=link id=down8_{{$index}} ng-click=\"openGroupDevices(\'dpts\', dptsArr[gridItem.sty].series[0].d, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li></ul></div><highchart config=dptsArr[gridItem.sty]></highchart><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1>{{dptsArr[gridItem.sty].series[0].name | capitalize}}</h1></div><div class=text-muted ng-cloak ng-repeat=\"val in dptsArr[gridItem.sty].series[0].data\">{{val.name | camelCase}}: <a href=\"\" role=link id=dptsD_{{$parent.$index}}{{$index}} ng-click=\"deviceDetailListFx(\'dpts\', \'\', dptsArr[gridItem.sty].series[0].name, val.name);\" aria-label={{val.name}}>{{val.y}}</a></div></div></div><!-- Online/Offline Status of Specific Device Info --><div ng-if=\"gridItem.ty == \'ssdt\' && ssdtArr[gridItem.sty].series[0].data.length\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu9_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=Menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=down9_{{$index}} ng-click=\"openGroupDevices(\'ssdt\', ssdtArr[gridItem.sty].series[0].data[0].total, \'\', gridItem, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'ssdt\', {c:ssdtArr[gridItem.sty].series[0].data[0].category, n:ssdtArr[gridItem.sty].series[0].data[0].name, d:ssdtArr[gridItem.sty].series[0].data[0].total});--></ul></div><highchart config=ssdtArr[gridItem.sty]></highchart><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=ssdt1_{{$index}} ng-click=\"deviceDetailListFx(\'ssdt\', \'onc\', ssdtArr[gridItem.sty].series[0].data[0].category, ssdtArr[gridItem.sty].series[0].data[0].name);\" aria-label={{ssdtArr[gridItem.sty].series[0].name}}>{{ssdtArr[gridItem.sty].series[0].data[0].y}}</a> <span>/ <a href=\"\" role=link id=ssdt2_{{$index}} ng-click=\"deviceDetailListFx(\'ssdt\', \'\', ssdtArr[gridItem.sty].series[0].data[0].category, ssdtArr[gridItem.sty].series[0].data[0].name);\" class=text-muted aria-label={{ssdtArr[gridItem.sty].series[0].name}}>{{ssdtArr[gridItem.sty].series[0].data[0].total}}</a></span></div><div class=text-muted ng-cloak>{{ssdtArr[gridItem.sty].series[0].data[0].y>1?\'db.body.18s\':\'db.body.18\' | translate}}<br>{{ssdtArr[gridItem.sty].series[0].data[0].category +\': \'+ ssdtArr[gridItem.sty].series[0].data[0].name}}<span ng-if=!ssdtArr[gridItem.sty].series[0].data[0].name class=text-sm>{{\'db.body.22\'| translate}}</span><!-- {{ssdtArr[gridItem.sty].series[0].data[0].category +\': \'+ ssdtArr[gridItem.sty].series[0].data[0].name}} --></div></div></div><!-- Online/Offline Status of Specific Device Properties --><div ng-if=\"gridItem.ty == \'ssdpt\' && ssdptArr[gridItem.sty].series[0].data.length\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu10_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=down10_{{$index}} ng-click=\"openGroupDevices(\'ssdpt\', ssdptArr[gridItem.sty].series[0].data[0].total, \'\', ssdptArr[gridItem.sty].series[0].data[0], \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'ssdpt\', {c:ssdptArr[gridItem.sty].series[0].data[0].category, n:ssdptArr[gridItem.sty].series[0].data[0].name, d:ssdptArr[gridItem.sty].series[0].data[0].total, id:dashboard.dpts[gridItem.sty].id});--></ul></div><highchart config=ssdptArr[gridItem.sty]></highchart><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=ssdpt1_{{$index}} ng-click=\"deviceDetailListFx(\'ssdpt\',\'onc\', ssdptArr[gridItem.sty].series[0].data[0].category, ssdptArr[gridItem.sty].series[0].data[0].name);\" aria-label={{ssdptArr[gridItem.sty].series[0].name}}>{{ssdptArr[gridItem.sty].series[0].data[0].y}}</a> <span>/ <a href=\"\" role=link id=ssdpt2_{{$index}} ng-click=\"deviceDetailListFx(\'ssdpt\',\'\', ssdptArr[gridItem.sty].series[0].data[0].category, ssdptArr[gridItem.sty].series[0].data[0].name);\" class=text-muted aria-label={{ssdptArr[gridItem.sty].series[0].name}}>{{ssdptArr[gridItem.sty].series[0].data[0].total}}</a></span></div><div class=text-muted ng-cloak>{{ssdptArr[gridItem.sty].series[0].data[0].y > 1?\'db.body.18s\':\'db.body.18\' | translate}}<br>{{ssdptArr[gridItem.sty].series[0].data[0].category +\': \'+ ssdptArr[gridItem.sty].series[0].data[0].name}}<span ng-if=!ssdptArr[gridItem.sty].series[0].data[0].name class=text-sm>{{\'db.body.22\'| translate}}</span><!-- {{ssdptArr[gridItem.sty].series[0].data[0].category +\': \'}} {{ssdptArr[gridItem.sty].series[0].data[0].name ? ssdptArr[gridItem.sty].series[0].data[0].name : \'db.body.22\'| translate}} --></div></div></div><!-- Online/Offline Status Summary of Device Type --><div ng-if=\"gridItem.ty == \'ssodt\' && ssodtArr[gridItem.sty].series[0].data.length\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu11_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=down11_{{$index}} ng-click=\"openGroupDevices(\'ssodt\', ssodtArr[gridItem.sty].series[0].data[0].total, \'\', gridItem, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'ssodt\', {c:ssodtArr[gridItem.sty].series[0].data[0].category, n:ssodtArr[gridItem.sty].series[0].data[0].name, d:ssodtArr[gridItem.sty].series[0].data[0].total});--></ul></div><highchart config=ssodtArr[gridItem.sty]></highchart><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=ssodt1_{{$index}} ng-click=\"deviceDetailListFx(\'ssodt\', \'onc\', ssodtArr[gridItem.sty].series[0].data[0].name == \'Media Player\'? \'mp\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Geo Fence\'? \'gf\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Virtual Device\'? \'v\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Music Player\'? \'mc\':ssodtArr[gridItem.sty].series[0].data[0].name == \'LG WebOS\'? \'webos\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Samsung Tizen\'? \'tizen\': ssodtArr[gridItem.sty].series[0].data[0].name == \'Desktop\'? \'desktop\': \'epd\', \'rem\');\" aria-label={{ssodtArr[gridItem.sty].series[0].data[0].category}}>{{ssodtArr[gridItem.sty].series[0].data[0].y}}</a> <span>/ <a href=\"\" role=link id=ssodt2_{{$index}} ng-click=\"deviceDetailListFx(\'ssodt\', \'\', ssodtArr[gridItem.sty].series[0].data[0].name == \'Media Player\'? \'mp\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Geo Fence\'? \'gf\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Virtual Device\'? \'v\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Music Player\'? \'mc\':ssodtArr[gridItem.sty].series[0].data[0].name == \'LG WebOS\'? \'webos\':ssodtArr[gridItem.sty].series[0].data[0].name == \'Samsung Tizen\'? \'tizen\': ssodtArr[gridItem.sty].series[0].data[0].name == \'Desktop\'? \'desktop\': \'epd\', \'ttl\');\" class=text-muted aria-label={{ssodtArr[gridItem.sty].series[0].data[0].category}}>{{ssodtArr[gridItem.sty].series[0].data[0].total}}</a></span></div><div class=text-muted ng-cloak>{{ssodtArr[gridItem.sty].series[0].data[0].y > 1?\'db.body.18s\':\'db.body.18\' | translate}}<br>{{\'d.label.1\' | translate}}: {{ssodtArr[gridItem.sty].series[0].data[0].name}}</div></div></div><!-- Open Tickets Chart --><div ng-if=\"gridItem.ty == \'ot\'\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><highchart config=otArr ng-if=\"dashboard.ot.total > 0\"></highchart><div class=\"blank-pie text-muted\" ng-if=!dashboard.ot.total><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><!-- <span ng-if=\"!dashboard.ot.total\" class=\"text-muted text-big pull-right text-center marR25 marT35\">N/A</span> --><div class=marT10><div class=statusCounter ng-cloak><a href=\"\" role=link id=otDT_{{$index}} ng-if=\"dashboard.ot.total > 0\" ng-click=\"deviceTicketOpen(dashboard.ot.o, \'o\');\" aria-label={{dashboard.ot.o}}>{{dashboard.ot.o}}</a> <span ng-if=\"dashboard.ot.total>0\">/ <a href=\"\" role=link id=ot_{{$index}} class=\"text-muted cursorDefault\" aria-label={{dashboard.ot.total}}>{{dashboard.ot.total}}</a></span> <span ng-if=!dashboard.ot.total class=\"text-muted text-sm\">N/A</span></div><div class=text-muted ng-cloak>{{\'ms.label.35.15\' | translate}}</div></div></div><!-- Content Confirmation List new start --><div ng-if=\"gridItem.ty == \'ccl\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu12_{{$index}} aria-label=contentConfList uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-if=\"curDCData.ccl.length && auth.upermissions.edl\" ng-class=\"{\'disabled\': curDCData.ccl.length == 0}\"><a href=\"\" role=link id=cclD12_{{$index}} ng-click=\"downloadListFx(\'ccl\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><li><a href=\"\" role=link id=cclR12_{{$index}} ng-click=loadMoreContentConfirmationFx(0); aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading></h1>{{\'db.body.17\' | translate}}</header><div class=\"bg-light pad10\" ng-if=\"curDCData.ccl.length > 5 || haveDataList.ccl\"><label for=cclSearch12_{{$index}} class=lableHidden>c</label><div class=\"cclSearch searchTbx\"><input type=text id=cclSearch12_{{$index}} class=form-control ng-model=searchText.ccl sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off ng-change=\"searchFrmAllData(searchText.ccl, \'ccl\');\"> <a href=\"\" role=link class=text-danger ng-show=searchText.ccl.length ng-click=\"searchText.ccl=\'\';searchFrmAllData(searchText.ccl, \'ccl\');\" aria-label=clear><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body dashDevice table no-th activityLog dashCCBg\"><div class=\"dbScrollQuad dccl\" when-scrolled=loadMoreContentConfirmationFx() ng-hide=dbListLoading.ccl ng-if=\"curDCData.ccl.length > 0 || haveDataList.ccl\"><div class=row ng-repeat=\"ccl in filteredContentList = (curDCData.ccl)\"><!-- <div class=\"row\" ng-repeat=\"ccl in filteredContentList = (curDCData.ccl | filter:{l:searchText.ccl})\"> --><!-- <div class=\"row\" ng-repeat=\"ccl in filteredContentList = (curDCData.ccl | customSearch:{key:searchText.ccl, module:\'d\'})\"> --><div class=\"col-xs-8 text-ellipsis\"><span class=fa ng-class=\"(ccl.c==ccl.t)?\'fa-check-circle text-success\':\'fa-exclamation-triangle text-warning\'\" uib-tooltip=\"{{(ccl.c==ccl.t)?\'db.body.13.1\':\'db.body.13.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 role=status aria-label=\"{{(ccl.c==ccl.t)?\'db.body.13.1\':\'db.body.13.2\' | translate}}\" aria-hidden=true></span> <span uib-tooltip={{ccl.l}} tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label={{ccl.l}}>{{ccl.l}}</span></div><div class=\"col-xs-4 noPadL text-right\"><!-- {{curCD = (ccl.devices | filter:{isConfirmed:true});\"\"}}\r\n                    {{curNcD = (ccl.devices | filter:{isConfirmed:false});\"\"}} --> <a href=\"\" role=link id=ccl{{$index}} ng-click=\"cclOpenList(ccl.id, ccl.l);\" aria-label=List>{{ccl.c +\"/\"+ ccl.t}}</a></div></div><div class=msg-warning lang={{auth.lang}} aria-live=polite role=status ng-if=\"(curDCData.ccl.length > 0 || haveDataList.ccl) && filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchText.ccl)}}&quot;</b>\'}\"></div></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccl><div ng-class=\"{\'msg-warning\':(!dbListLoading.ccl)}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"curDCData.ccl.length <= 0 && !haveDataList.ccl\"><span ng-if=!dbListLoading.ccl>{{\'db.msg.10\'| translate}}</span></div></div></div><!-- Content Confirmation List new end --><!-- Device Temperature List new start --><div ng-if=\"gridItem.ty == \'dtpl\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu13_{{$index}} aria-label=deviceTemper uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-if=\"auth.upermissions.edl && allScrollDataList.dtpl.length\" ng-class=\"{\'disabled\':deviceList.length == 0}\"><a href=\"\" role=link id=dtpl13_{{$index}} ng-click=\"openGroupDevices(\'dtpl\', allScrollDataList.dtpl, \'\', true, \'db\', \'\',\'\',\'dashboard\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true role=status></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'dtpl\');--><li><a href=\"\" role=link id=dtplR13_{{$index}} ng-click=deviceTempratureFx(detailListObj.dtpl); aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'db.body.19\' | translate}}</h1></header><div class=\"bg-light pad10\" ng-if=\"allScrollDataList.dtpl.length > 5\"><label for=dtplSearch13_{{$index}} class=lableHidden>dtpl</label><div class=searchTbx><input type=text id=dtplSearch13_{{$index}} class=form-control ng-model=searchText.dtpl sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchText.dtpl, \'dtpl\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=dtplSR13_{{$index}} class=text-danger ng-show=searchText.dtpl.length ng-click=\"searchText.dtpl=\'\';searchChangeDataDyn(searchText.dtpl, \'dtpl\');\" aria-label=Clear><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body dashDevice table no-th activityLog dashTempBg\"><div class=\"dbScrollQuad dccl\" ng-hide=dbListLoading.dtpl ng-if=\"allScrollDataList.dtpl.length > 0\" id=scroll-container-dtpl dynamic-scroll-list st=stIndex.dtpl et=etIndex.dtpl list-data=scrollDataList.dtpl search-data=searchText.dtpl have-more-data=haveMoreData.dtpl search-scroll=searchScroll.dtpl clone-data=allScrollDataList.dtpl have-more-search-data=haveMoreSearchData.dtpl quad-id=\"\'dtpl\'\" dd-open=true><div class=\"row rowObj-dtpl\" id={{dtpl.id}} ng-repeat=\"dtpl in filteredDtplList = (visibleData.dtpl)\" ng-if=\"allScrollDataList.dtpl.length > 0\" ng-class=\"{\'bg-warning\':dtpl.ts == 1,\'bg-danger\':dtpl.ts == 2}\"><div class=\"col-xs-10 text-ellipsis\"><span class=\"fa marR5\" uib-tooltip=\"{{\'db.body.14.\'+ (dtpl.ts+1) | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-class=\"{\'fa-thermometer-empty text-success\':dtpl.ts == 0,\'fa-thermometer-three-quarters text-warning\':dtpl.ts == 1,\'fa-thermometer-full text-danger\':dtpl.ts == 2}\" role=status aria-hidden=true aria-label=\"{{\'db.body.14.\'+ (dtpl.ts+1) | translate}}\"></span> <span class=\"noMarL marR3 deviceStatus {{dtpl.status}}\" uib-tooltip=\"{{dtpl.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label=\"{{dtpl.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\"></span> <span uib-tooltip={{dtpl.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dtpl.l}}</span></div><div class=\"col-xs-2 text-right noPadL\"><span ng-if=!dtpl.t class=\"text-muted text-sm\">N/A</span> <span ng-if=dtpl.t>{{dtpl.t | setDecimal}}&deg;C</span></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.dtpl || !haveMoreSearchData.dtpl) && scrollDataList.dtpl.length >= 300 && scrollDataList.dtpl.length == etIndex.dtpl\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} aria-live=polite role=status ng-if=\"allScrollDataList.dtpl.length > 0 && filteredDtplList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.dtpl)}}&quot;</b>\'}\"></div></div><div ng-class=\"{\'msg-warning\':(!dbListLoading.dtpl)}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"allScrollDataList.dtpl.length <= 0\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.dtpl> <span ng-if=!dbListLoading.dtpl>{{\'db.msg.1\'| translate}}</span></div></div></div><!-- Device Temperature List new end --><!-- Recently Added Devices List new start --><div ng-if=\"gridItem.ty == \'rad\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu14_{{$index}} aria-label=daslm uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-if=\"auth.upermissions.edl && allScrollDataList.rad.length\" ng-class=\"{\'disabled\': deviceList.length == 0}\"><a href=\"\" id=download14_{{$index}} ng-click=\"openGroupDevices(\'rad\', allScrollDataList.rad, \'\', true, \'db\', \'\',\'\',\'dashboard\');\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><!--downloadListFx(\'rad\', allScrollDataList.rad);--><li><a href=\"\" role=link id=refresh14_{{$index}} ng-click=recentAddedDeviceFx(detailListObj.rad); aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=\"dHeading d-flex-i\">{{\'db.body.16\'+dashboard.dsg.rad | translate}}</h1></header><div class=\"bg-light pad10\" ng-if=\"allScrollDataList.rad.length > 5\"><label for=radSearch14_{{$index}} class=lableHidden>rad</label><div class=searchTbx><input type=text id=radSearch14_{{$index}} class=form-control ng-model=searchText.rad sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchText.rad, \'rad\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=radSR14_{{$index}} class=text-danger ng-show=searchText.rad.length ng-click=\"searchText.rad=\'\';searchChangeDataDyn(searchText.rad, \'rad\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body dashDevice table no-th activityLog dashDeviceBg\"><div class=\"dbScrollQuad dccl\" ng-hide=dbListLoading.rad ng-if=\"allScrollDataList.rad.length > 0\" id=scroll-container-rad dynamic-scroll-list st=stIndex.rad et=etIndex.rad list-data=scrollDataList.rad search-data=searchText.rad have-more-data=haveMoreData.rad search-scroll=searchScroll.rad clone-data=allScrollDataList.rad have-more-search-data=haveMoreSearchData.rad quad-id=\"\'rad\'\" dd-open=true><div class=\"row rowObj-rad\" id={{d.id}} ng-repeat=\"d in filteredRadlList = (visibleData.rad)\"><div class=\"col-xs-8 col-sm-8 col-lg-9 text-ellipsis\"><span class=\"fa fa-star text-primary\" ng-if=\"d.ftm == \'s\'\" uib-tooltip=\"{{\'d.tool.15\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-hidden=true role=status aria-label=\"{{\'d.tool.15\' | translate}}\"></span> <a href=\"\" role=status id=radRe14_{{$index}} ng-if=\"d.ftm == \'r\'\" ng-click=\"devicePCOpen(d.id, d.l, d.h);\"><span class=\"fa fa-recycle text-primary\" uib-tooltip=\"{{\'d.tool.16\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-hidden=true></span></a> <span class=\"noMarL marR3 deviceStatus {{d.status}}\" uib-tooltip=\"{{d.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label=\"{{d.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" role=status></span> <a href=\"\" role=link ui-sref=\"hub.dContainer.dName({id: hubEncrypt(d.id)})\" ng-if=\"auth.upermissions.de && !dgActions.isEditable && device.dType != \'desktop\'\" uib-tooltip={{d.l}} tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label={{d.l}}>{{d.l}}</a> <span ng-if=\"!auth.upermissions.de || dgActions.isEditable\" uib-tooltip={{d.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{d.l}}</span></div><div class=\"col-xs-4 col-sm-4 col-lg-3 text-right\" uib-tooltip-html=\"\'{{(d.ct * 1000) | date:\'MMM d, y\'}}<br>{{(d.ct * 1000) | date:\'h:mm a\'}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1500><div ng-if=d.ct><div class=\"text-ellipsis text-sm\">{{d.date}}</div><div class=\"text-ellipsis text-sm text-muted ng-cloak\">{{(d.ct * 1000) | date:\"h:mm a\"}}</div></div><div ng-if=!d.ct><span class=\"text-muted text-sm\">N/A</span></div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.rad || !haveMoreSearchData.rad) && scrollDataList.rad.length >= 300 && scrollDataList.rad.length == etIndex.rad\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} aria-live=polite role=status ng-if=\"allScrollDataList.rad.length > 0 && filteredRadlList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.rad)}}&quot;</b>\'}\"></div></div><div ng-class=\"{\'msg-warning\':(!dbListLoading.rad)}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"allScrollDataList.rad.length <= 0\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.rad> <span ng-if=!dbListLoading.rad>{{\'db.msg.1\'| translate}}</span></div></div></div><!-- Recently Added Devices List new end --><!-- Devices Preview --><div ng-if=\"gridItem.ty == \'dp\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\" ng-if=\"curDCData.dp.h && auth.upermissions.dpv\"><a href=\"\" role=link id=vMenu15_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=po15_{{$index}} ng-click=previewOpen(); aria-label=\"{{\'d.btn.7\' | translate}}\"><span class=\"fa fa-film marR5\" aria-hidden=true></span>{{\'d.btn.7\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'d.btn.11\'| translate}}</h1></header><div class=\"panel-body dashDevice table no-th\"><div><div ng-if=dbLoading.dp><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-if=\"!dbLoading.dp && curDCData.dp.h\" class=\"text-center dbScrollQuad db-thumb\"><div><span class=\"d-ib relative\"><img alt=dp ng-src=\"{{dashboard.dp.tmb + dashboard.dp.buc + (curDCData.dp.h | removeColon) + \'.jpg\' + dbThumbParamZc3}}\" db-thumb src-error=assets/images/default/device_selected_{{curDCData.dp.dt}}.png class=\"img-responsive center-block dbBlackBdr\"> <span class=\"db-thumb-icon status {{curDCData.dp.s}}\" ng-if=curDCData.dp.s uib-tooltip=\"{{curDCData.dp.s | capitalize}}\" tooltip-placement=left tooltip-append-to-body=true tooltip-popup-delay=500 role=status></span></span></div><div class=\"text-ellipsis marT5\" uib-tooltip={{curDCData.dp.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{curDCData.dp.l}}</div></div><div ng-if=\"!dbLoading.dp && !curDCData.dp.h\" class=msg-warning lang={{auth.lang}}>{{\'db.msg.1\' | translate}}</div></div></div></div><!-- Device Online/Offline Summary new start --><div ng-if=\"gridItem.ty == \'dccl\'\" class=\"pad10 chartQuad\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><!-- {{dcclCount = (curDCData.dccl.ofcc + curDCData.dccl.offline + curDCData.dccl.ofncc + curDCData.dccl.ofnsd + curDCData.dccl.oncc + curDCData.dccl.online + curDCData.dccl.onncc + curDCData.dccl.onnsd + curDCData.dccl.nosd); \"\"}} --> {{dcclCount = (curDCData.dccl.ofcc + curDCData.dccl.ofncc + curDCData.dccl.oncc + curDCData.dccl.onncc + curDCData.dccl.nosd); \"\"}}<div ng-if=curDCData.dccl.totalCount class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a ng-if=auth.upermissions.edl href=\"\" role=link id=vMenu16_{{$index}} aria-label=contentConf uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=dccl16_{{$index}} ng-click=\"downloadListFx(\'dccl\', {online:curDCData.dccl.online, offline:curDCData.dccl.offline}, curDCData.cids);\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li></ul></div><highchart config=dcclArr ng-if=\"dcclCount > 0 && curDCData.dccl.totalCount > 0\"></highchart><div class=\"blank-pie text-muted\" ng-if=!dcclCount><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1>{{\'db.body.17\' | translate}}</h1></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.21.1\' | translate}}: <a href=\"\" role=link aria-label=\"{{\'db.body.21.1\' | translate}}\" id=dcclOncc16_{{$index}} ng-click=\"deviceDetailListFx(\'dccl\', \'\', \'oncc\');\" ng-if=\"!dbListLoading.ccs && curDCData.dccl.oncc\">{{curDCData.dccl.oncc}} / {{curDCData.dccl.totalCount}}</a> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.oncc && curDCData.dccl.totalCount > 0\">{{curDCData.dccl.oncc}} / {{curDCData.dccl.totalCount}}</span><!-- <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.oncc &&curDCData.dccl.totalCount\">{{curDCData.dccl.oncc}} / {{curDCData.dccl.totalCount}}</span> --> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.oncc && !curDCData.dccl.totalCount\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.21.2\' | translate}}:<!-- {{onnccCount = (curDCData.dccl.onncc | filter:{status:\'online\'}:true);\"\"}} --> <a href=\"\" role=link aria-label=\"{{\'db.body.21.2\' | translate}}\" id=dcclOnncc16_{{$index}} ng-click=\"deviceDetailListFx(\'dccl\', \'\', \'onncc\');\" ng-if=\"!dbListLoading.ccs && curDCData.dccl.onncc\">{{curDCData.dccl.onncc}} / {{curDCData.dccl.totalCount}}</a> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.onncc && curDCData.dccl.totalCount > 0\">{{curDCData.dccl.onncc}} / {{curDCData.dccl.totalCount}}</span><!-- <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.onncc && curDCData.dccl.totalCount\">{{curDCData.dccl.onncc}} / {{curDCData.dccl.totalCount}}</span> --> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.onncc && !curDCData.dccl.totalCount\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.21.3\' | translate}}: <a href=\"\" role=link aria-label=\"{{\'db.body.21.3\' | translate}}\" id=dcclOfcc16_{{$index}} ng-click=\"deviceDetailListFx(\'dccl\', \'\', \'ofcc\');\" ng-if=\"!dbListLoading.ccs && curDCData.dccl.ofcc\">{{curDCData.dccl.ofcc}} / {{curDCData.dccl.totalCount}}</a> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofcc && curDCData.dccl.totalCount > 0\">{{curDCData.dccl.ofcc}} / {{curDCData.dccl.totalCount}}</span><!-- <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofcc && curDCData.dccl.totalCount\">{{curDCData.dccl.ofcc}} / {{curDCData.dccl.totalCount}}</span> --> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofcc && !curDCData.dccl.totalCount\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.21.4\' | translate}}: <a href=\"\" role=link aria-label=\"{{\'db.body.21.4\' | translate}}\" id=dcclOfNcc16_{{$index}} ng-click=\"deviceDetailListFx(\'dccl\', \'\', \'ofncc\');\" ng-if=\"!dbListLoading.ccs && curDCData.dccl.ofncc\">{{curDCData.dccl.ofncc}} / {{curDCData.dccl.totalCount}}</a> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofncc && curDCData.dccl.totalCount > 0\">{{curDCData.dccl.ofncc}} / {{curDCData.dccl.totalCount}}</span><!-- <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofncc && curDCData.dccl.totalCount\">{{curDCData.dccl.ofncc}} / {{curDCData.dccl.totalCount}}</span> --> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.ofncc && !curDCData.dccl.totalCount\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.body.21.6\' | translate}}: {{curnsd = curDCData.dccl.nosd; \"\"}} <a href=\"\" role=link aria-label=\"{{\'db.body.21.6\' | translate}}\" id=dcclNsd16_{{$index}} ng-click=\"deviceDetailListFx(\'dccl\', \'\', \'nsd\');\" ng-if=\"!dbListLoading.ccs && curDCData.dccl.offline\">{{curnsd}} / {{curDCData.dccl.totalCount}}</a> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.offline && curnsd > 0\">{{curnsd}} / {{curDCData.dccl.totalCount}}</span> <span ng-if=\"!dbListLoading.ccs && !curDCData.dccl.offline && !curnsd\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.ccs></div></div></div><!-- Device Online/Offline Summary new end --><!-- Content Pin --><div ng-if=\"gridItem.ty == \'dpi\'\" db-get-set-height offset=20 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu3_{{$index}} aria-label=deviceList uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=dlR3_{{$index}} ng-click=loadPinnedItems();><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'db.pin.5\' | translate}}</h1></header><!-- pin-items-list=\"dashboard.pinnedItems\" --><ng-pin-items></ng-pin-items></div><!-- White Glove Warranty List New start --><div ng-if=\"gridItem.ty == \'wgw\'\" db-get-set-height offset=55 ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><header class=\"panel-heading text-bold\"><div class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=link id=vMenu3_{{$index}} aria-label=wgwList uib-dropdown-toggle=\"\" class=dropdown-toggle><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li ng-if=\"auth.upermissions.edl && allScrollDataList.wgw.length\"><a href=\"\" role=link id=dlD3_{{$index}} ng-click=\"exportWgwDeviceSheet(\'wgw\',\'\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li><li><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"loadMoreWgwListFx();searchText.wgw=\'\';\" aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh marR5\" aria-hidden=true></span>{{\'cm.btn.33\' | translate}}</a></li></ul></div><h1 class=dHeading>{{\'db.wgw.2\' | translate}}</h1></header><div class=\"bg-light pad10\" ng-if=\"allScrollDataList.wgw.length > 5\"><label for=dSearch3_{{$index}} class=lableHidden>wgw</label><div class=searchTbx><input type=text id=dSearch3_{{$index}} class=form-control ng-model=searchText.wgw sanitize-input ng-change=\"searchChangeDataDyn(searchText.wgw, \'wgw\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=deviceSR3_{{$index}} class=text-danger ng-show=searchText.wgw.length ng-click=\"searchText.wgw=\'\';searchChangeDataDyn(searchText.wgw, \'wgw\');\" aria-label=Clear><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body dashDevice activityLog\"><div class=\"table no-th\"><div class=\"row th bgTrans\" ng-hide=dbListLoading.wgw ng-if=\"allScrollDataList.wgw.length > 0\"><div class=\"col-xs-3 col-sm-3 col-lg-4 text-ellipsis\" uib-tooltip=\"{{\'cm.label.71\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.label.71\' | translate | camelCase}}</div><div class=\"col-xs-3 col-sm-3 col-lg-3 text-ellipsis\" uib-tooltip=\"{{\'db.wgw.9\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'db.wgw.9\' | translate}}</div><div class=\"col-xs-3 col-sm-3 col-lg-3 text-ellipsis\" uib-tooltip=\"{{\'db.wgw.4\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'db.wgw.4\' | translate}}</div><div class=\"col-xs-3 col-sm-3 col-lg-2 text-right text-ellipsis\" uib-tooltip=\"{{\'cm.label.46\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.label.46\' | translate}}</div></div><div class=dbScrollQuad ng-hide=dbListLoading.wgw ng-if=\"allScrollDataList.wgw.length > 0\" id=scroll-container-wgw dynamic-scroll-list st=stIndex.wgw et=etIndex.wgw list-data=scrollDataList.wgw search-data=searchText.wgw have-more-data=haveMoreData.wgw search-scroll=searchScroll.wgw clone-data=allScrollDataList.wgw have-more-search-data=haveMoreSearchData.wgw quad-id=\"\'wgw\'\" dd-open=true><div class=\"row rowObj-wgw\" id={{wgw.id}} ng-repeat=\"wgw in filteredWgwList = (visibleData.wgw)\"><div class=\"col-xs-3 col-sm-3 col-lg-4 text-ellipsis\"><span class=\"deviceStatus {{wgw.status}}\" uib-tooltip=\"{{wgw.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 role=status aria-label=\"{{wgw.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\"></span><span uib-tooltip={{wgw.l}} tooltip-append-to-body=true tooltip-popup-delay=1000 aria-label={{wgw.l}} role=status>{{wgw.l}}</span></div><div class=\"col-xs-3 col-sm-3 col-lg-3\" tooltip-enable=wgw.reg uib-tooltip={{wgw.reg}} tooltip-append-to-body=true tooltip-popup-delay=500><div ng-if=wgw.reg><div class=text-ellipsis>{{wgw.reg}}</div></div><div ng-if=!wgw.reg><span class=\"text-muted text-sm\">N/A</span></div></div><div class=\"col-xs-3 col-sm-3 col-lg-3\" tooltip-enable=wgw.exp uib-tooltip={{wgw.exp}} tooltip-append-to-body=true tooltip-popup-delay=500><div ng-if=wgw.exp><div class=text-ellipsis>{{wgw.exp}}</div><!-- <div class=\"text-ellipsis text-sm text-muted ng-cloak\">{{(wgw.exp * 1000) | date:\"h:mm a\"}}</div> --></div><div ng-if=!wgw.exp><span class=\"text-muted text-sm\">N/A</span></div></div><div class=\"col-xs-3 col-sm-3 col-lg-2 text-right text-ellipsis\" tooltip-enable=\"wgw.wgs == 0 || wgw.wgs == 1 || wgw.wgs == 3\" uib-tooltip=\"{{wgw.wgs == 0?\'db.wgw.7\': wgw.wgs == 1? \'db.wgw.6\' : wgw.wgs == 3? \'db.wgw.10\' :\'db.wgw.8\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"text-sm expiryBadge text-ellipsis\" ng-if=\"wgw.wgs == 0\">{{ \'db.wgw.7\' | translate}}</span> <span class=\"text-sm activeBadge text-ellipsis\" ng-if=\"wgw.wgs == 1\">{{ \'db.wgw.6\' | translate}}</span> <span class=\"text-sm expirySoonBadge text-ellipsis\" ng-if=\"wgw.wgs == 3\">{{ \'db.wgw.10\' | translate}}</span> <span class=\"text-sm text-muted\" ng-if=\"wgw.wgs == 2\">{{ \'N/A\' | translate}}</span><!-- <div class=\"text-ellipsis text-sm text-muted\" ng-if=\"wgw.wgs == 2\">{{ \'db.wgw.8\' | translate}}</div> --></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.wgw || !haveMoreSearchData.wgw) && scrollDataList.wgw.length >= 300 && scrollDataList.wgw.length == etIndex.wgw\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.wgw.length > 0 && filteredWgwList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.wgw)}}&quot;</b>\'}\"></div></div><div ng-class=\"{\'msg-warning\':(!dbListLoading.wgw)}\" lang={{auth.lang}} ng-hide=dashboardLoading ng-if=\"allScrollDataList.wgw.length <= 0\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.wgw> <span ng-if=!dbListLoading.wgw>{{\'db.msg.1\'| translate}}</span></div></div></div></div><!-- White Glove Warranty List New end --><!-- White Glove Warranty Summary New start --><div ng-if=\"gridItem.ty == \'wgws\'\" class=\"pad10 chartQuad cursorDefault\" ng-class=\"dgActions.isEditable?\'no-clickable\':\'\'\"><div ng-if=\"curDCData.wgws.totalCount > 0\" class=\"pull-right dropdown dropdown-sm\" uib-dropdown=\"\"><a href=\"\" role=menu ng-if=auth.upermissions.edl id=vMenu5_{{$index}} uib-dropdown-toggle=\"\" class=dropdown-toggle aria-label=Menu><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu=\"\" role=menu><li><a href=\"\" role=link id=down5_{{$index}} ng-click=\"exportWgwDeviceSheet(\'wgws\',\'\');\" aria-label=\"{{\'cm.btn.17\' | translate}}\"><span class=\"fa fa-arrow-down marR5\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a></li></ul></div><highchart config=wgwsArr ng-if=\"curDCData.wgws.totalCount > 0\"></highchart><div class=\"blank-pie text-muted\" ng-if=!curDCData.wgws.totalCount><img alt=\"Blank Pie\" src=assets/images/blank-pie.png></div><div class=tempQuad><div class=statusCounter ng-cloak><h1 role=heading aria-level=1>{{\'db.wgw.1\' | translate}}</h1></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.wgw.6\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.wgws> <a href=\"\" role=link ng-if=!dbListLoading.wgws id=wgwsN5_{{$index}} ng-click=\"deviceDetailListFx(\'wgws\', \'\', \'act\');\" aria-label=\"{{\'db.wgw.6\' | translate}}\">{{curDCData.wgws.act}}</a></div><div class=\"text-muted marB5\" ng-cloak>{{\'db.wgw.7\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.wgws> <a href=\"\" role=link ng-if=!dbListLoading.wgws id=wgwsC5_{{$index}} ng-click=\"deviceDetailListFx(\'wgws\', \'\', \'exp\');\" aria-label=\"{{\'db.wgw.7\' | translate}}\">{{curDCData.wgws.exp}}</a></div><div class=text-muted ng-cloak>{{\'db.wgw.8\' | translate}}: <img alt=Loading src=assets/images/loading-xs.gif ng-if=dbListLoading.wgws> <a href=\"\" role=link ng-if=!dbListLoading.wgws id=wgwsD5_{{$index}} ng-click=\"deviceDetailListFx(\'wgws\', \'\', \'nw\');\" aria-label=\"{{\'db.wgw.8\' | translate}}\">{{curDCData.wgws.nw}}</a></div></div></div><!-- White Glove Warranty Summary New end --></div></div></div></div><div class=dbFooter ng-class=\"{\'dbFooterEdit\':dgActions.isEditable}\" ng-if=\"dashboard.dGrid.length && dGridArr.length\"><div class=\"pull-right text-muted text-sm\" ng-if=dgActions.isEditable>{{\'db.body.20\' | translate}}</div><div><a href=\"\" role=link aria-label=\"{{\'db.btn.3\' | translate}}\" id=dgOptionE ng-click=\"dgOptionsFx(\'e\');\" ng-if=!dgActions.isEditable class=btn-xs><span class=\"fa fa-pencil\" aria-hidden=true></span> {{\'db.btn.3\' | translate}}</a> <a href=\"\" role=link aria-label=\"{{\'cm.btn.7\' | translate}}\" id=dgOptionS ng-click=\"dgOptionsFx(\'s\');\" ng-if=dgActions.isEditable class=btn-xs ng-disabled=dgActions.loading><span class=\"fa fa-check\" aria-hidden=true></span> {{\'cm.btn.7\' | translate}}</a> <a href=\"\" role=link aria-label=\"{{\'cm.btn.9\' | translate}}\" id=dgOptionC ng-click=\"dgOptionsFx(\'c\');\" ng-if=dgActions.isEditable class=\"btn-xs text-danger\" ng-disabled=dgActions.loading><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.9\' | translate}}</a> <a href=\"\" role=link aria-label=\"{{\'fl.p_cfl.label.19\' | translate | camelCase}}\" id=dgOptionD ng-click=setDefaultGridFx(); ng-if=dgActions.isEditable class=\"btn-xs hide\" ng-disabled=dgActions.loading><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'fl.p_cfl.label.19\' | translate | camelCase}}</a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!dashboard.dGrid.length || !dGridArr.length\">{{\'db.msg.9\' | translate}}</div></div>");
$templateCache.put("app/inventory/devices.html","<section ng-if=auth.upermissions.inv.vdl><header class=panel-inner-tab role=tablist aria-owns=\"subTab-da subTab-dd subTab-dr\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><a href=\"\" ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'1\'}}\" aria-controls=subTab-da id=subTab-da aria-label=\"{{\'in.p_i.15.0\' | translate}}\">{{\'in.p_i.15.0\' | translate}}</a> <a href=\"\" ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'2\'}}\" aria-controls=subTab-dd id=subTab-dd aria-label=\"{{\'in.p_i.15.1\' | translate}}\">{{\'in.p_i.15.1\' | translate}}</a> <a href=\"\" ng-class=\"{\'selected\':selectedT==\'3\'}\" ng-click=\"tabFx(3,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'3\'}}\" aria-controls=subTab-dr id=subTab-dr aria-label=\"{{\'in.p_i.15.2\' | translate}}\">{{\'in.p_i.15.2\' | translate}}</a><div class=\"pull-right marT4\" ng-if=auth.upermissions.inv.ddl><a href=\"\" role=link uib-tooltip=\"{{\'d.tool.14\' | translate}}\" aria-label=\"{{\'d.tool.14\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"downloadOpen(\'d\');\"><span class=\"fa fa-download\" aria-hidden=true></span></a></div><div class=\"pull-right marL5\"><button type=button role=button uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" aria-label=\"{{\'cm.btn.33\' | translate}}\" ng-click=\"loadSelectedTab(\'refresh\'); searchInvText.text=\'\';\" class=btn-link ng-disabled=inventoryLoading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':inventoryLoading}\" aria-hidden=true></span></button></div><!-- <div class=\"pull-right searchTbx selectedQuadSearch\">\r\n      <label for=\"hSearch\" class=\"lableHidden\">Search</label>\r\n      <input type=\"text\" id=\"hSearch\" aria-label=\"hSearch\" aria-labelledby=\"hSearch\"\r\n        class=\"form-control\" placeholder=\"Type to search\"\r\n        ng-model=\"searchInvText.text\" maxlength=\"250\">\r\n      <a href=\"\" role=\"link\" class=\"text-danger ng-hide\" ng-show=\"searchInvText.text.length\" aria-hidden=\"true\" aria-label=\"dSearch\" ng-click=\"searchInvText.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n    </div> --><div class=\"advSearch d-content\"><div class=pull-right><button type=button role=button class=\"btn btn-default btn-sm marL5 marT-6\" aria-label=\"{{\'cm.body.10\' | translate}}\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"advancedSearchOpen(\'inv\', \'d\');searchInvText.text=\'\';\"><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchInvText.text sanitize-input maxlength=250 ng-keyup=searchInv(searchInvText.text); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchInvText.text.length ng-click=\"searchInvText.text=\'\';searchInv(\'\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></header><div class=panel-body role=tabpanel><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=inventoryLoading><div ng-if=\"!inventoryLoading && inventory.length > 0\"><ng-inv-list selectable-list=inventory></ng-inv-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!inventoryLoading && !inventory.length && !isAdvSearch\">{{\'in.msg.1\' | translate}}</div><!-- Warning message for no device --><div class=msg-warning lang={{auth.lang}} ng-if=\"!inventoryLoading && !inventory.length && isAdvSearch\">{{\'as.msg.2\' | translate}}</div></div></section>");
$templateCache.put("app/inventory/inventory.html","<img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div ng-if=!invLoading><div class=row ng-if=auth.upermissions.inv.vdl><!-- Item types --><div class=col-xs-3><section class=panel><div class=\"panel-body scrollQuad\" style=min-height:215px;max-height:215px><div class=chartQuad><img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div ng-if=\"!invData.t.values.length && !invLoading\" class=\"msg-warning ng-binding\" lang={{auth.lang}}>{{\'in.msg.8\' | translate}}</div><div ng-if=\"invData.t.values.length && !invLoading\"><highchart config=itArr[0] ng-if=invData.t></highchart><div class=tempQuad><div class=statusCounter>{{\'in.p_i.24\' | translate}}</div><div class=text-muted><span ng-repeat=\"series in itArr[0].series\"><div class=marB5 ng-repeat=\"data in series.data\">{{data.name}}: {{data.y}}</div></span></div></div></div></div></div></section></div><!-- Deployed this week --><div class=col-xs-3><section class=panel><div class=\"panel-heading text-bold\">{{\'in.body.2\' | translate}}</div><div class=\"panel-body dashDevice table no-th\" style=min-height:165px;max-height:165px><div class=dbScrollQuad style=height:146px><img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div><div ng-if=\"!invData.i.length && !invLoading\" class=\"msg-warning ng-binding\" lang={{auth.lang}}>{{\'in.msg.5\' | translate}}</div><div class=row ng-repeat=\"item in invData.i\"><div class=\"col-xs-5 text-ellipsis\"><span class=\"deviceStatus {{item.isActive?\'online\':\'offline\'}}\" uib-tooltip=\"{{item.isActive?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> <span uib-tooltip={{item.name}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.name}}</span></div><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip={{item.mac}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.mac}}</span></div><div class=\"col-xs-3 text-right noPadL text-sm\"><span ng-if=!item.iOn class=\"text-muted text-sm\">N/A</span> <span uib-tooltip-html=\"\'{{(item.iOn * 1000) | date:\'MMM d, y\'}}<br>{{(item.iOn * 1000) | date:\'h:mm a\'}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><div class=\"text-ellipsis text-sm\">{{(item.iOn * 1000) | date:\"MMM d,y\"}}</div><div class=\"text-ellipsis text-sm text-muted ng-cloak\">{{(item.iOn * 1000) | date:\"h:mm a\"}}</div></span></div></div></div></div></div></section></div><!-- Added this week --><div class=col-xs-3><section class=panel><div class=\"panel-heading text-bold\">{{\'in.body.3\' | translate}}</div><div class=\"panel-body dashDevice table no-th\" style=min-height:165px;max-height:165px><div class=dbScrollQuad style=height:146px><img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div><div ng-if=\"!invData.a.length && !invLoading\" class=\"msg-warning ng-binding\" lang={{auth.lang}}>{{\'in.msg.6\' | translate}}</div><div class=row ng-repeat=\"item in invData.a\"><div class=\"col-xs-5 text-ellipsis\"><span class=\"deviceStatus {{item.isActive?\'online\':\'offline\'}}\" uib-tooltip=\"{{item.isActive?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> <span uib-tooltip={{item.name}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.name}}</span></div><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip={{item.mac}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.mac}}</span></div><div class=\"col-xs-3 text-right noPadL text-sm\"><span ng-if=!item.crOn class=\"text-muted text-sm\">N/A</span> <span uib-tooltip-html=\"\'{{(item.crOn * 1000) | date:\'MMM d, y\'}}<br>{{(item.crOn * 1000) | date:\'h:mm a\'}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><div class=\"text-ellipsis text-sm\">{{(item.crOn * 1000) | date:\"MMM d,y\"}}</div><div class=\"text-ellipsis text-sm text-muted ng-cloak\">{{(item.crOn * 1000) | date:\"h:mm a\"}}</div></span></div></div></div></div></div></section></div><!-- Warranty Expiring --><div class=col-xs-3><section class=panel><div class=\"panel-heading text-bold\">{{\'in.body.4\' | translate}}</div><div class=\"panel-body dashDevice table no-th\" style=min-height:165px;max-height:165px><div class=dbScrollQuad style=height:146px><img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div><div ng-if=\"!invData.we.length && !invLoading\" class=\"msg-warning ng-binding\" lang={{auth.lang}}>{{\'in.msg.7\' | translate}}</div><div class=row ng-repeat=\"item in invData.we\"><div class=\"col-xs-5 text-ellipsis\"><span class=\"deviceStatus {{item.isActive?\'online\':\'offline\'}}\" uib-tooltip=\"{{item.isActive?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> <span uib-tooltip={{item.name}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.name}}</span></div><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip={{item.mac}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.mac}}</span></div><div class=\"col-xs-3 text-right noPadL text-sm\"><span ng-if=!item.eOn class=\"text-muted text-sm\">N/A</span> <span uib-tooltip-html=\"\'{{(item.eOn * 1000) | date:\'MMM d, y\'}}<br>{{(item.eOn * 1000) | date:\'h:mm a\'}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><div class=\"text-ellipsis text-sm\" ng-class=\"item.isExpired?\'text-danger\':\'\'\">{{(item.eOn * 1000) | date:\"MMM d,y\"}}</div><div class=\"text-ellipsis text-sm ng-cloak\" ng-class=\"item.isExpired?\'text-danger\':\'text-muted\'\">{{(item.eOn * 1000) | date:\"h:mm a\"}}</div></span></div></div></div></div></div></section></div></div><div class=\"sliderQuad padTB10 padLR5\" ng-if=\"invData.t.values.length && pieArr.length  && (auth.upermissions.inv.vdl || auth.upermissions.inv.ad || auth.upermissions.inv.ed || auth.upermissions.inv.dlt)\" style=\"overflow: hidden\"><img alt=Loading src=assets/images/loading.gif ng-if=invLoading><div id=sliderInv><button type=button role=button class=control_prev ng-click=prevSlider()><span class=\"fa fa-chevron-left\" aria-hidden=true></span></button> <button type=button role=button class=control_next ng-click=nextSlider()><span class=\"fa fa-chevron-right\" aria-hidden=true></span></button><ul class=list-inline ng-if=!invLoading><li ng-repeat=\"val in pieArr\" class=noPad><!-- <li ng-repeat=\"val in pieArr\" ng-class=\"{\'bdrR\':val.type == \'bdr\'}\"> --><div class=li-type-div ng-if=\"val.type==\'pie\'\" data-ng-attr-style=\"{{ pieArr.length > 4  ? \'width: 318px\' : \'min-width:520px\' }}\"><div class=title>{{val.series[0].name}}</div><highchart config=val ng-if=invData.t class=pull-right></highchart><div ng-repeat=\"series in val.series\" style=\"padding-right:100px;width: 220px\"><div ng-repeat=\"data in series.data\">{{data.name}}: {{data.y}}</div></div></div></li></ul></div></div><div class=spaceH></div><div class=spaceH></div><section class=panel ng-if=\"auth.upermissions.inv.vdl || auth.upermissions.inv.ad || auth.upermissions.inv.ed || auth.upermissions.inv.dlt\"><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs r\" role=tablist aria-owns=\"tab-d tab-o\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active class=tab-primary role=tab aria-selected=\"{{$state.includes(\'hub.inventory.devices\')}}\" aria-controls=tab-d id=tab-d ng-if=auth.upermissions.inv.vdl><a ui-sref=.devices role=link aria-label=\"{{\'cm.menu.5\' | translate}}\">{{\'cm.menu.5\' | translate}}</a></li><li ui-sref-active=active class=tab-success role=tab aria-selected=\"{{$state.includes(\'hub.inventory.others\')}}\" aria-controls=tab-o id=tab-o ng-if=\"auth.upermissions.inv.ad || auth.upermissions.inv.dlt || auth.upermissions.inv.ed\"><a ui-sref=.others role=link aria-label=\"{{\'in.p_i.23\' | translate}}\">{{\'in.p_i.23\' | translate}}</a></li></ul></header><div class=\"panel-body noPadB\"><div ui-view=tabView></div></div></section></div>");
$templateCache.put("app/inventory/others.html","<section ng-if=\"auth.upermissions.inv.ad || auth.upermissions.inv.dlt || auth.upermissions.inv.ed\"><header class=panel-inner-tab role=tablist aria-owns=\"subTab-oa subTab-od subTab-or\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><a href=\"\" ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'1\'}}\" aria-controls=subTab-oa id=subTab-oa aria-label=\"{{\'in.p_i.15.0\' | translate}}\">{{\'in.p_i.15.0\' | translate}}</a> <a href=\"\" ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'2\'}}\" aria-controls=subTab-od id=subTab-od aria-label=\"{{\'in.p_i.15.1\' | translate}}\">{{\'in.p_i.15.1\' | translate}}</a> <a href=\"\" ng-class=\"{\'selected\':selectedT==\'3\'}\" ng-click=\"tabFx(3,\'tabFx\');searchInvText.text=\'\';\" role=tab aria-selected=\"{{selectedT==\'3\'}}\" aria-controls=subTab-or id=subTab-or aria-label=\"{{\'in.p_i.15.2\' | translate}}\">{{\'in.p_i.15.2\' | translate}}</a><div class=\"pull-right marT3\" ng-if=auth.upermissions.inv.ad><a href=\"\" role=button uib-tooltip=\"{{\'cm.btn.16\' | translate}}\" aria-label=\"{{\'cm.btn.16\' | translate}}\" ng-click=uploadOpen();><span class=\"fa fa-upload\" aria-hidden=true></span></a></div><div class=\"pull-right marT4\"><a href=\"\" role=button uib-tooltip=\"{{\'d.tool.14\' | translate}}\" aria-label=\"{{\'d.tool.14\' | translate}}\" ng-click=\"downloadOpen(\'h\');\"><span class=\"fa fa-download\" aria-hidden=true></span></a></div><div class=\"pull-right marT3\" ng-if=auth.upermissions.inv.ad><a href=\"\" role=button uib-tooltip=\"{{\'in.btn.1\' | translate}}\" aria-label=\"{{\'in.btn.1\' | translate}}\" ng-click=inventoryCUOpen();><span class=\"fa fa-plus\" aria-hidden=true></span></a></div><div class=\"pull-right marL5\"><button type=button role=button ng-click=\"loadSelectedTab(\'refresh\');searchInvText.text=\'\';\" class=btn-link ng-disabled=inventoryLoading uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" aria-label=\"{{\'cm.btn.33\' | translate}}\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':inventoryLoading}\" aria-hidden=true></span></button></div><!-- <div class=\"pull-right searchTbx selectedQuadSearch\">\r\n      <label for=\"hSearch\" class=\"lableHidden\">Search</label>\r\n      <input type=\"text\" id=\"hSearch\" aria-label=\"hSearch\" aria-labelledby=\"hSearch\"\r\n        class=\"form-control\" placeholder=\"Type to search\"\r\n        ng-model=\"searchInvText.text\" maxlength=\"250\">\r\n      <a href=\"\" role=\"link\" class=\"text-danger ng-hide\" ng-show=\"searchInvText.text.length\"  aria-hidden=\"true\" aria-label=\"oSearch\" ng-click=\"searchInvText.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n    </div> --><div class=\"advSearch d-content\"><div class=pull-right><button type=button role=button class=\"btn btn-default btn-sm marL5 marT-6\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"advancedSearchOpen(\'inv\', \'h\');searchInvText.text=\'\';\"><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchInvText.text sanitize-input maxlength=250 ng-keyup=searchInv(searchInvText.text); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchInvText.text.length ng-click=\"searchInvText.text=\'\';searchInv(\'\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></header><div class=panel-body><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=inventoryLoading><div ng-if=\"!inventoryLoading && inventory.length > 0\"><ng-inv-list selectable-list=inventory></ng-inv-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!inventoryLoading && !inventory.length && !isAdvSearch\">{{\'in.msg.1\' | translate}}</div><!-- Warning message for no device --><div class=msg-warning lang={{auth.lang}} ng-if=\"!inventoryLoading && !inventory.length && isAdvSearch\">{{\'as.msg.2\' | translate}}</div></div></section>");
$templateCache.put("app/frameLayouts/fl.html","<img alt=Loading src=assets/images/loading.gif ng-if=frameLayoutsLoading><div context-menu=contextMenuBase><ul class=\"list-inline thumb-list\" ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\"><ng-framelayout-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=frameLayouts.frameLayouts></ng-framelayout-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div>{{\'fl.msg.1\' | translate}}</div><div class=marT10 ng-if=\"$state.includes(\'hub.frameLayouts.fl\') === true\"><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'fl\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/frameLayouts/flDesign.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fl>{{\'fl.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{decId == \'\'?\'fl.btn.1\':\'fl.body.5\' | translate}}</span><span ng-if=\"frameLayout.info.label != \'\'\" class=text-muted>[ <span>{{frameLayout.info.label}}</span> ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'fl.p_cfl.label.6\' | translate}}</h1><!-- Design frame layout --> <span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span></header><div class=panel-body ng-attr-style=height:{{getAvailableHeight(280)}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-10><div class=templateToolbar><div class=pull-left><button type=button role=button class=\"btn btn-default\" ng-click=addFrame(); tabindex=1 focus-me=true><span class=\"fa fa-plus\" aria-hidden=true></span> {{\'fl.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=duplicateFrame(); ng-if=curFrame tabindex=2><span class=\"fa fa-object-ungroup\" aria-hidden=true></span> {{\'cm.btn.30\' | translate}}</button></div><div class=\"pull-right marT5\"><div class=input-group style=width:120px><span class=input-group-addon>{{\'cm.label.57\' | translate}}:</span><select class=form-control ng-model=canvas.zoom tabindex=4 aria-label=\"{{\'cm.label.57\' | translate}}\" aria-labelledby=\"{{\'cm.label.57\' | translate}}\"><option ng-repeat=\"zoom in zoomLevels\" ng-value=zoom.val>{{zoom.label}}</option></select></div></div><div class=clearfix></div></div><div id=canvas class=\"overflow-auto canvasBg\" ng-click=deselectAllFrames(); ng-attr-style=height:{{getAvailableHeight(360)}}px;><div class=flGrid ng-click=deselectAllFrames(); ng-attr-style=\"width:{{flWidth*canvas.zoom}}px; height:{{flHeight*canvas.zoom}}px;\"><div draggable ng-repeat=\"frame in frameLayout.frames\" ng-if=frame.isEditable data-index={{$index}} class=frameDrag ng-attr-style=left:{{frame.x*canvas.zoom}}px;top:{{frame.y*canvas.zoom}}px;z-index:{{frame.z}};>{{brTL = (frame.settings.br.tl?(frame.settings.br.tl*canvas.zoom)+\'px\':0);\"\"}} {{brTR = (frame.settings.br.tr?(frame.settings.br.tr*canvas.zoom)+\'px\':0);\"\"}} {{brBL = (frame.settings.br.bl?(frame.settings.br.bl*canvas.zoom)+\'px\':0);\"\"}} {{brBR = (frame.settings.br.br?(frame.settings.br.br*canvas.zoom)+\'px\':0);\"\"}}<div resizable on-resize=\"frameResize($event, $index, $ui)\" data-id={{frame.id}} data-index={{$index}} class=frame ng-click=\"selectFrame($event, frame, $index)\" ng-attr-style=\"width:{{frame.width*canvas.zoom | setDecimal:0}}px;height:{{frame.height*canvas.zoom | setDecimal:0}}px;border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}};background-color:{{frame.rgba}};transform:rotate({{frame.rotation}}deg);box-shadow:{{frame.settings.ish.isShadow? \'inset \' + frame.settings.ish.hl +\'px \'+ frame.settings.ish.vl +\'px \'+ frame.settings.ish.br +\'px \'+ frame.settings.ish.sr +\'px \'+ frame.settings.ish.rgba:\'\'}}\"><a href role=link ng-click=\"removePlaceholder($index, \'f\');\" class=remove></a><div class=name><div>{{frame.label}}</div><div class=\"frameSize hide\"><span class=text-bold>W: {{frame.width}} | H: {{frame.height}}</span></div></div></div></div><div ng-repeat=\"frame in frameLayout.frames\" ng-if=!frame.isEditable data-index={{$index}} class=frameDrag ng-attr-style=left:{{frame.x*canvas.zoom}}px;top:{{frame.y*canvas.zoom}}px;z-index:{{frame.z}};><div data-id={{frame.id}} data-index={{$index}} class=\"frame nonSelectable\" uib-tooltip=\"{{\'fl.p_cfl.msg.8\' | translate}}\" tooltip-append-to-body=true ng-attr-style=width:{{frame.width*canvas.zoom}}px;height:{{frame.height*canvas.zoom}}px;transform:rotate({{frame.rotation}}deg><div class=name><div>{{frame.label}}</div><div class=\"frameSize hide\"><span class=text-bold>W: {{frame.width}} | H: {{frame.height}}</span></div></div></div></div></div></div></div><div class=col-xs-2><div class=\"panel noMarB\"><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist aria-owns=\"tab-1 tab-2\" aria-labelledby=navList><li class=tab-success id=tab-1 role=tab aria-selected=true ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);>{{\'fl.p_cfl.tab.1\' | translate}}</a></li><li class=tab-primary id=tab-2 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=tabFx(2);>{{\'fl.p_cfl.tab.2\' | translate}}</a></li></ul></header><div class=pad10 ng-show=\"selectedT==\'1\'\"><div class=\"tab-body overflow-y\" ng-attr-style=max-height:{{getAvailableHeight(367)}}px;><div ng-if=!curFrame class=\"text-muted text-sm\">{{\'fl.p_cfl.msg.6\' | translate}}</div><div ng-if=curFrame><div class=\"form-group row noMargin\"><div class=col-xs-12><label class=noPadT for=frameName>{{\'cm.brief.1\' | translate}}:</label><input type=text id=frameName class=\"form-control input-sm\" ng-model=curFrame.label maxlength={{inputLimit}} tabindex=5 aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=\"form-group row noMargin\"><div class=col-xs-6><label for=xPos>{{\'fl.p_cfl.label.8\' | translate}}:</label><input type=number id=xPos class=\"form-control input-sm\" ng-model=curFrame.x maxlength=5 tabindex=6 aria-label=\"{{\'fl.p_cfl.label.8\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.8\' | translate}}\"></div><div class=col-xs-6><label for=yPos>{{\'fl.p_cfl.label.9\' | translate}}:</label><input type=number id=yPos class=\"form-control input-sm\" ng-model=curFrame.y maxlength=5 tabindex=7 aria-label=\"{{\'fl.p_cfl.label.9\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.9\' | translate}}\"></div></div><div class=\"form-group row noMargin\"><div class=col-xs-6><label for=frameWidth>{{\'cm.label.59\' | translate}}:</label><input type=number id=frameWidth class=\"form-control input-sm\" ng-model=curFrame.width min=1 maxlength=5 tabindex=8 aria-label=\"{{\'cm.label.59\' | translate}}\" aria-labelledby=\"{{\'cm.label.59\' | translate}}\"></div><div class=col-xs-6><label for=frameHeight>{{\'cm.label.60\' | translate}}:</label><input type=number id=frameHeight class=\"form-control input-sm\" ng-model=curFrame.height min=1 maxlength=5 tabindex=9 aria-label=\"{{\'cm.label.60\' | translate}}\" aria-labelledby=\"{{\'cm.label.60\' | translate}}\"></div></div><div class=form-group><label ng-click=frameBgFx($event);><input type=checkbox ng-model=frameBg.isChecked tabindex=15><label></label>{{\'cm.label.61\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.isOpen ng-show=frameBg.isChecked><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':curFrame.bg, opacity:curFrame.bga}\"></span></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.bg | uppercase\" ng-click=\"colorPickerOpen($event, \'bg\');\" readonly aria-label=\"{{\'cm.label.61\' | translate}}\" aria-labelledby=\"{{\'cm.label.61\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{curFrame.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.bg selected-type=curFrame.bgType is-alpha=true selected-alpha=curFrame.bga selected-rgba=curFrame.rgba></ng-hub-color-picker></div></div></div><div><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\" class=text-bold>{{\'d.p_dc.wos.9\' | translate}} <span class=\"fa fa-chevron-down\" ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></div><div ng-if=settingsOpen class=\"marT5 bdr-top-dashed bg-light pad10\"><div class=\"form-group row\"><div class=col-xs-12><label>{{\'cm.label.89\' | translate}}:</label></div><div class=col-xs-12><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-l\'}\" ng-click=\"frameAlignFx(\'t-l\')\" uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-l\'}\" ng-click=\"frameAlignFx(\'m-l\')\" uib-tooltip=\"{{\'cm.label.89.2\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-l\'}\" ng-click=\"frameAlignFx(\'b-l\')\" uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-c\'}\" ng-click=\"frameAlignFx(\'t-c\')\" uib-tooltip=\"{{\'cm.label.89.4\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-c\'}\" ng-click=\"frameAlignFx(\'m-c\')\" uib-tooltip=\"{{\'cm.label.89.5\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-c\'}\" ng-click=\"frameAlignFx(\'b-c\')\" uib-tooltip=\"{{\'cm.label.89.6\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-r\'}\" ng-click=\"frameAlignFx(\'t-r\')\" uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-r\'}\" ng-click=\"frameAlignFx(\'m-r\')\" uib-tooltip=\"{{\'cm.label.89.8\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-r\'}\" ng-click=\"frameAlignFx(\'b-r\')\" uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-append-to-body=true></div></div></div></div><div class=\"row noMargin\"><div class=\"col-xs-12 marB5\"><label><input type=checkbox ng-model=curFrame.settings.br.isBorder ng-click=\"resetAdSettingFx(curFrame.settings.br.isBorder, \'b\');\"><label></label>{{\'fl.p_cfl.label.27\' | translate}}:</label><!-- <label class=\"noPadT\">{{\'fl.p_cfl.label.27\' | translate}}:</label> --></div></div><div ng-if=curFrame.settings.br.isBorder><div class=\"form-group row noMargin\"><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brTL tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.1\' | translate}}:</label><input type=number id=brTL class=\"form-control input-sm\" ng-model=curFrame.settings.br.tl min=0 tabindex=11 aria-label=\"{{\'cm.label.89.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.1\' | translate}}\"></div><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brTR tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.7\' | translate}}:</label><input type=number id=brTR class=\"form-control input-sm\" ng-model=curFrame.settings.br.tr min=0 tabindex=12 aria-label=\"{{\'cm.label.89.7\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.7\' | translate}}\"></div></div><div class=\"form-group row noMargin\"><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brBL tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.3\' | translate}}:</label><input type=number id=brBL class=\"form-control input-sm\" ng-model=curFrame.settings.br.bl min=0 tabindex=13 aria-label=\"{{\'cm.label.89.3\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.3\' | translate}}\"></div><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brBR tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.9\' | translate}}:</label><input type=number id=brBR class=\"form-control input-sm\" ng-model=curFrame.settings.br.br min=0 tabindex=14 aria-label=\"{{\'cm.label.89.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.9\' | translate}}\"></div></div></div><div class=\"row noMargin\"><div class=\"col-xs-12 marB7\"><label><input type=checkbox ng-model=curFrame.settings.ish.isShadow ng-change=\"resetAdSettingFx(curFrame.settings.ish.isShadow, \'s\');\"><label></label>{{\'fl.p_cfl.label.28\' | translate}}:</label><!-- <label class=\"noPadT\">{{\'fl.p_cfl.label.27\' | translate}}:</label> --></div></div><div ng-if=curFrame.settings.ish.isShadow><div class=\"form-group row noMargin\"><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTL>{{\'fl.p_cfl.label.29\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.hl tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.hl}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.30\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.vl tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.vl}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.31\' | translate}}:</label><input type=range min=0 max=200 ng-model=curFrame.settings.ish.br tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.br}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.32\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.sr tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.sr}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.33\' | translate}}:</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.isSc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':curFrame.settings.ish.sc, opacity:curFrame.settings.ish.sca}\"></span></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.settings.ish.sc | uppercase\" ng-click=\"colorPickerOpen($event, \'sc\');\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{curFrame.settings.ish.sca}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.settings.ish.sc selected-type=curFrame.settings.ish.scType is-alpha=true selected-alpha=curFrame.settings.ish.sca selected-rgba=curFrame.settings.ish.rgba></ng-hub-color-picker></div></div></div></div></div><div class=\"form-group row noMargin hide\"><div class=col-xs-6><label class=noPadT for=rotation>{{\'cm.label.58\' | translate}}:</label><input type=number id=rotation class=\"form-control input-sm\" ng-model=curFrame.rotation min=-360 max=360 tabindex=10 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"></div></div></div><div class=\"form-group noMarB marT10\" ng-if=!frameLayout.info.libraryOpt><label>{{\'cm.label.15\' | translate}}</label><div ng-if=\"curFrame.permission && !$root.isPermissionOpen && (curFrame.permission.type!=\'p\' || uType != 4)\"><span class=\"badge bg-muted marR5\" ng-if=\"curFrame.permission.type==\'p\'\">{{\'cm.label.19\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"curFrame.permission.type==\'i\'\">{{\'cm.label.20\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"curFrame.permission.type==\'c\'\">{{\'cm.label.17\' | translate}}</span> <a class=\"fa fa-pencil\" href=\"\" role=button ng-click=\"permissionFx(\'edit\');\" tabindex=16></a></div><div><div class=\"badge bg-muted\" ng-if=\"permission.type == \'p\' && auth.uType == 4\">{{\'fl.p_cfl.msg.7\' | translate}}</div></div><ng-frame-permission class=framePermission ng-if=isPermissionOpen></ng-frame-permission></div></div></div></div><div class=pad10 ng-show=\"selectedT==\'2\'\"><div class=\"tab-body overflow-y\" ng-attr-style=max-height:{{getAvailableHeight(367)}}px;><ul class=\"layer-container sortable-containment list-unstyled noMar\" sortable axis=\"\'y\'\" callback=sortCallback()><li ng-repeat=\"frame in frameLayout.frames | orderBy: \'z\':true\" class=\"layer sortable-item\" ng-class=\"{\'disabled\': !frame.isEditable}\" data-id={{frame.id}} ng-click=\"selectFrame($event, frame, $index)\"><button type=button role=button class=\"btn btn-link btn-sm pull-right\" ng-click=\"removePlaceholder(frame.id, \'l\')\" ng-if=frame.isEditable><span class=\"fa fa-remove noMarR text-danger\" aria-hidden=true></span></button><div class=text-ellipsis><label class=\"pull-left noMarB\" uib-tooltip=\"{{\'fl.p_cfl.label.19\' | translate}}\"><input type=radio role=radio name=layer ng-model=frameLayout.info.dFId ng-value=frame.id><label></label></label><span class=layerBg><span ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.rgba}\"></span> </span><span class=layerFrameLabel>{{frame.label}}</span></div></li></ul><div uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=\"bgLayer text-ellipsis\"><span class=colorpickerQuad></span> <span class=layerBg ng-attr-style=background:{{frameLayout.info.layoutBG}} uib-dropdown-toggle ng-click=\"colorPicker=true\"></span> <span class=\"pull-right glyphicon glyphicon-lock\" aria-hidden=true></span>{{\'fl.p_cfl.label.15\' | translate}}</div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=frameLayout.info.layoutBG selected-type=frameLayout.info.layoutBGType ng-if=colorPicker></ng-hub-color-picker></div></div></div></div></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=submit role=button class=\"btn btn-default\" ui-sref=\"hub.flContainer.flName({type: $state.params.type, id: encId})\" tabindex=17><span class=\"fa fa-chevron-left\" ng-disabled=\"saveProcessing || saveCloseProcessing\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=submit role=button class=\"btn btn-default\" ng-click=\"saveFrameLayout(\'design\', \'s\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\" tabindex=18><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-success\" ng-click=\"saveFrameLayout(\'design\', \'sc\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\" tabindex=19><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx(); tabindex=20 ng-disabled=\"saveProcessing || saveCloseProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'per\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'sffl\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.11\' | translate}}</div><div ng-if=\"errType==\'hfr\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.10\' | translate}} <a href=\"\" role=link ng-click=mailSupportOpen(); class=text-bold>L Squared Support</a></div><div ng-if=\"errType==\'dName\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/flName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fl>{{\'fl.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{decId == \'\'?\'fl.btn.1\':\'fl.body.5\' | translate}}</span><span ng-if=\"frameLayout.info.label && frameLayout.info.label != \'\'\" class=text-muted>[ <span>{{frameLayout.info.label}}</span> ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'fl.p_assign.body.12\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'fl.brief.4\' | translate}}</label><input type=text id=label class=form-control autocomplete=off maxlength=100 ng-model=frameLayout.info.label focus-me=true maxlength={{inputLimit}} aria-label=\"{{\'fl.brief.4\' | translate}}\" aria-labelledby=\"{{\'fl.brief.4\' | translate}}\"></div><div>&nbsp;</div><div class=form-group><label>{{\'fl.p_cfl.label.1\' | translate}}</label><table><tr><td valign=bottom width=100px><label><img alt=landscape src=assets/images/default/landscape.png><div class=clear></div><input type=radio role=radio name=orientation ng-model=frameLayout.info.orientation ng-change=\"orientationChangeFx(\'l\')\" value=l><label></label>{{\'fl.p_cfl.label.1.1\' | translate}}</label></td><td valign=bottom width=80px><label><img alt=portrait src=assets/images/default/portrait.png><div class=clear></div><input type=radio role=radio name=orientation ng-model=frameLayout.info.orientation ng-change=\"orientationChangeFx(\'p\')\" value=p><label></label>{{\'fl.p_cfl.label.1.2\' | translate}}</label></td><td valign=bottom><label><img alt=custom src=assets/images/default/custom.png><div class=clear></div><input type=radio role=radio name=orientation ng-model=frameLayout.info.orientation ng-change=\"orientationChangeFx(\'c\')\" value=c><label></label>{{\'cm.label.17\' | translate}}</label></td></tr></table></div><div class=row><div class=form-group ng-if=\"frameLayout && frameLayout.info.orientation\" ng-class=\"{\'col-xs-6\':frameLayout.info.orientation == \'l\' || frameLayout.info.orientation == \'p\', \'col-xs-8\':frameLayout.info.orientation == \'c\'}\"><label>{{\'fl.p_cfl.label.2\' | translate}} <span class=\"text-muted text-sm\">[ {{\'fl.p_cfl.label.2.1\' | translate}} ]</span></label><select class=form-control ng-if=\"frameLayout.info.orientation != \'c\'\" ng-model=frameLayout.info.dimension ng-options=\"resolution for resolution in resolutions track by resolution\" aria-label=\"{{\'fl.p_cfl.label.2\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.2\' | translate}}\"></select><div ng-if=\"frameLayout.info.orientation == \'c\'\"><div class=\"row noMarginR\"><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.59\' | translate}}</span> <input type=number id=resolutionCustW class=form-control ng-model=frameLayout.info.resolutionCustW min=1 max=99999 maxlength=5 aria-label=\"{{\'cm.label.59\' | translate}}\" aria-labelledby=\"{{\'cm.label.59\' | translate}}\"></div></div><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.60\' | translate}}</span> <input type=number id=resolutionCustH class=form-control ng-model=frameLayout.info.resolutionCustH min=1 max=99999 maxlength=5 aria-label=\"{{\'cm.label.60\' | translate}}\" aria-labelledby=\"{{\'cm.label.60\' | translate}}\"></div></div></div></div></div></div><div class=form-group ng-if=\"auth.uType == 0 && decType != \'fl\'\"><label ng-class=\"{\'noMarB\': !frameLayout.info.libraryOpt}\"><input type=checkbox ng-model=frameLayout.info.libraryOpt ng-disabled=encId role=checkbox><label></label>{{\'fl.p_cfl.label.3\' | translate}}</label><div ng-if=frameLayout.info.libraryOpt><select class=form-control ng-model=frameLayout.info.category ng-options=\"library as library.label for library in librarys track by library.id\"><option value=\"\">{{\'fl.p_cfl.label.4\' | translate}}</option></select><div class=\"form-group marT15\" ng-if=!frameLayout.info.category><label for=newCategory>{{\'fl.p_cfl.label.5\' | translate}}</label><input type=text id=newCategory class=form-control ng-model=frameLayout.info.newCategory aria-label=\"{{\'fl.p_cfl.label.5\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.5\' | translate}}\"></div></div></div><div class=row><div class=\"form-group col-xs-6\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':frameLayout.info.layoutBG}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"frameLayout.info.layoutBG | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><ng-hub-color-picker selected-color=frameLayout.info.layoutBG selected-type=frameLayout.info.layoutBGType ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveFrameLayout(\'name\', \'sc\');\" ng-if=frameLayout.info.isCompleted ng-disabled=\"saveCloseProcessing || flProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveFrameLayout(\'name\');\" ng-disabled=\"saveCloseProcessing || flProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=flProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'fl.p_cfl.label.6\' | translate | camelCase}} <span class=\"fa fa-chevron-right\" ng-if=!flProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx(); ng-disabled=\"saveCloseProcessing || flProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'hfr\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.10\' | translate}} <a href=\"\" role=link ng-click=mailSupportOpen(); class=text-bold>L Squared Support</a></div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.1\' | translate}}</div><div ng-if=\"errType==\'library\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.3\' | translate}}</div><div ng-if=\"errType==\'dimension\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.2\' | translate}}</div><div ng-if=\"errType==\'categoryExists\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.4\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/fla.html","<img alt=Loading src=assets/images/loading.gif ng-if=frameLayoutsLoading><div class=\"table table-md dTable\" role=table ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\" selectable=selection selectable-list=frameLayouts.frameLayouts selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"><div class=\"row th\" ng-if=\"(frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fla\'}).length > 0\"><div class=col-xs-3>{{\'cm.label.72\' | translate | camelCase}}</div><div class=col-xs-4>{{\'fl.body.3\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.10\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.11\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.4s\' | translate}}</div></div><ul><li class=row ng-repeat=\"frame in filteredAssignmentList = (frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fla\'})\" single-selection data-id={{frame.id}} data-type={{frameLayouts.info.type}} ng-class=\"{\'unapprovedRow\':!frame.isApproved, \'bg-danger\':frame.isExpired == 1 || (selectedTab == \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)), \'nonSelectable\':selectedTab === \'hub.dContainer.dFrameLayout\' && (frame.isExpired == 1 || !frame.hfr || frame.sffl)}\" context-menu=contextMenuOpt><div class=\"col-xs-3 text-ellipsis\"><input type=checkbox ng-click=\"checkboxFx($event, frame.id);\" ng-class=\"{\'hide\': selectedTab === \'hub.dContainer.dFrameLayout\' && (frame.isExpired == 1 || !frame.hfr || frame.sffl)}\" role=checkbox><label></label><span class=\"fa fa-exclamation-triangle text-danger marR5\" uib-tooltip=\"{{frame.isExpired == 1?\'fl.tool.6\':frame.hfr?\'fl.p_assign.msg.11\':\'fl.p_assign.msg.10\' | translate}}\" tooltip-append-to-body=true ng-if=\"frame.isExpired == 1 || (selectedTab == \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl))\" aria-hidden=true></span> {{frame.label}}</div><div class=\"col-xs-4 text-ellipsis\"><a uib-tooltip={{frame.flName}} tooltip-append-to-body=true tooltip-popup-delay=1000 class=\"btn-link nonSelectable\" ng-href=\"{{detailBucket + frame.flId + \'.png\' | secureThumb:frame.thumbV}}\" role=button fancyboxable=fbTitleInside data-fancybox-title={{frame.flName}}>{{frame.flName}}</a></div><div class=col-xs-2><span ng-if=\"frame.startDate != null\">{{frame.startDate}}</span> <span ng-if=\"frame.startDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-2 ng-class=\"{\'text-danger text-bold\' : frame.isExpired == 1}\"><span ng-if=\"frame.endDate != null\">{{frame.endDate}}</span> <span ng-if=\"frame.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\">{{frame.devices}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"frame.devices > 0\" ng-click=\"deviceListFx(frame.id, frame.label);\">{{\'cm.btn.21\' | translate}}</button></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fla\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div>{{\'fl.msg.2\' | translate}}</div><div class=marT10 ng-if=\"$state.includes(\'hub.frameLayouts.fla\') === true\"><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'fla\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div>");
$templateCache.put("app/frameLayouts/flaDevice.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>3</p></span><i ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"></i><span class=stepGray ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"><p>4</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fla>{{\'fl.tab.2\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'cm.label.31s\' | translate | camelCase}}</span><span ng-if=frameLayout.info.label class=text-muted>[ {{frameLayout.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\':!auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 3}\'}}: {{\'cm.label.31\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>3</p></span><i></i><span class=stepGray><p>4</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading class=pad10><div class=row ng-if=!detailLoading><div class=col-xs-12 ng-if=!frameLayout.info.hfr><div class=\"msg-warning mar10\" lang={{auth.lang}}>{{\'fl.p_assign.msg.9\' | translate}} <a href=\"\" role=link ng-click=mailSupportOpen(); class=text-bold>L Squared Support</a> {{\'fl.p_assign.msg.9.1\' | translate}}</div></div><div class=col-xs-12 ng-if=frameLayout.info.sffl><div class=\"msg-warning mar10\" lang={{auth.lang}} ng-class=\"{\'noMarT\':!frameLayout.info.hfr}\">{{\'fl.p_assign.msg.12\' | translate}} <a href=\"\" role=link ng-click=mailSupportOpen(); class=text-bold>L Squared Support</a> {{\'fl.p_assign.msg.9.1\' | translate}}</div></div><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo class=col-xs-12></advanced-search><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=\"pull-right marRL10 filterIcon\" ng-if=!isGbdt uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\" ng-disabled=\"isPageApiLoad || deviceListLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || showRemainingList}\"><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle ng-disabled=\"isPageApiLoad || showRemainingList\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'fla\', \'fla\', decId);\" ng-if=\"selectedT == \'1\'\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'deviceView\');\" ng-if=\"selectedT == \'1\'\">{{deviceViewText}}</a></li><li><a href=\"\" role=link ng-click=\"checkboxFx(\'all\'); selectedSearch.text=\'\'\">{{\'cm.btn.44\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchTextFla.text sanitize-input maxlength=250 ng-change=searchChangeFx(searchTextFla.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextFla.text.length ng-click=\"searchTextFla.text = \'\';searchChangeFx();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{devices.devices.length>1?\'cm.body.6s\':\'cm.body.6\' | translate}}</div></div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{tabHeight}}px; ng-scroll=timerFxToLoadData();><div ng-if=\"!deviceListLoading && breadCrumbs.length\" class=breadcrumb><a href=\"\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\"></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\"></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><ul class=\"list-inline thumb-list\" ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'t\'\"><ng-device-thumb class=show selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul><div class=row ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && devices.devices.length == 0 && devices.folders.length == 0 && !advSearchInfo.isEmpty && filter==\'all\' && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.devices.length && advSearchInfo.isEmpty && filter==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n          <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs hide\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !deviceListLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !deviceListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextFla.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !deviceListLoading\">{{\'as.msg.2\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"removeFilteredFx(\'all\'); closeAllFx(); selectedSearch.text=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearch.text sanitize-input ng-change=resetSelPagination(); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearch.text.length ng-click=\"selectedSearch.text=\'\';resetSelPagination()\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{frameLayout.devices.device.length>1?\'cm.body.7s\':\'cm.body.7\' | translate}} [ {{frameLayout.devices.device.length}} ]</div></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;max-height:{{selectedHeight}}px;><div ng-if=\"frameLayout.devices.device.length > 0\">{{selectedFilteredDevices = (frameLayout.devices.device | customSearch:{key:selectedSearch.text, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':frameLayout.devices.device.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><div class=\"thumb-list hoverContainer\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = ((frameLayout.devices.device | customSearch:{key:selectedSearch.text, module:\'dSel\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} class=device><!-- <li ng-repeat=\"device in selectedFilteredDevices = (frameLayout.devices.device | customSearch:{key:selectedSearch.text, module:\'dSel\'}) track by device.id\" data-id=\"{{device.id}}\" ng-if=\"frameLayout.devices.device.length > 0 && auth.upreferences.deviceView == \'t\'\"> --><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"removeFilteredFx(device.id, \'d\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (device.dType != \'mc\' && device.dType != 7)}\"><a ng-class=\"{\'thumb-device\': (device.dType != \'mc\' && device.dType != 7)}\" ng-if=\"device.thumbV != undefined && device.thumbV != 0\" ng-href=\"{{dDetailBucket + (device.mac | removeColon) + \'.jpg\' | secureThumb:device.thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{device.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (device.mac | removeColon) + \'.jpg&\' + device.thumbV + dThumbParam}}\" src-error=assets/images/default/device_{{device.dType}}.png> </a><img alt=\"\" ng-if=\"device.thumbV != undefined && device.thumbV == 0\" src=assets/images/default/device_{{device.dType}}.png> <span class=\"thumb-icon status\" ng-if=device.status uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.label}}</div> --><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{device.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{device.label}}</div></div><div class=form-inline ng-if=frameLayout.info.syncFrame style=width:150px><div class=\"form-group text-ellipsis text-left w100\"><label class=noMarB><input type=radio ng-model=frameLayout.info.masterDeviceId role=radio ng-value=device.id ng-change=changeMasterDevice(device.id) ng-disabled=mDAccessible.isAccissable uib-tooltip=\"{{\'s.p_s.msg.61\' | translate}}\" tooltip-enable=mDAccessible.isAccissable tooltip-append-to-body=true ng-click=$event.stopPropagation()><label></label><span class=valign-inherit>{{\'an.tab.3\' | translate}}</span></label></div><div class=\"deviceIp text-left\" ng-if=\"frameLayout.info.masterDeviceId == device.id\" style=display:flex;align-items:center><span class=valign-inherit>IP:</span> <input type=text id=IP-{{$index}} class=\"form-control input-sm w100Px\" ng-model=frameLayout.info.masterDeviceIP aria-label=\"{{\'d.brief.11\' | translate}}\" aria-labelledby=\"{{\'d.brief.11\' | translate}}\" maxlength=250 ng-pattern=ipAddressPattern required ng-click=$event.stopPropagation()></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div><!-- <li ng-repeat=\"device in selectedFilteredDeviceGrp = (frameLayout.devices.group | customSearch:{key:selectedSearch.text, module:\'d\'})\" data-id=\"{{device.id}}\" ng-if=\"frameLayout.devices.group.length > 0\">\r\n                  <a href=\"\" class=\"thumb-close\" ng-click=\"removeFilteredFx(device.id, \'g\')\"><span class=\"fa fa-times-circle\"></span></a>\r\n                  <div class=\"thumb\">\r\n                    <img alt=\"\" src=\"assets/images/default/device_group_selected.png\" class=\"img-responsive center-block blackBdr\">\r\n                  </div>\r\n                  <div class=\"text-ellipsis marT5\">{{device.label}}</div>\r\n                </li> --></div><ul class=\"list-inline multiple-selected\" ng-if=\"auth.upreferences.deviceView == \'l\'\" ng-class=\"{\'marT10\':frameLayout.devices.device.length>auth.upreferences.dpc}\"><!-- device list view --><div class=\"table table-md whiteRow\" ng-class=\"{\'hide\':selectedFilteredDevices.length == 0}\"><div class=\"row th\"><div class=col-xs-7>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-right noPadL\">{{\'cm.label.25\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((frameLayout.devices.device | customSearch:{key:selectedSearch.text, module:\'dSel\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-show=\"frameLayout.devices.device.length > 0\"><!-- <li class=\"row\" ng-repeat=\"device in selectedFilteredDevices = (frameLayout.devices.device | customSearch:{key:selectedSearch.text, module:\'dSel\'})\" data-id=\"{{device.id}}\" data-type=\"device\" data-sub-type=\"{{device.type}}\" ng-if=\"frameLayout.devices.device.length > 0\"> --><div class=\"col-xs-7 text-ellipsis\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.label}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.mac}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.4\' | translate}}</div> --><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"removeFilteredFx(device.id, \'d\')\"><span class=\"fa fa-remove\"></span></a></div></li></div><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div></ul></div><!-- TODO FIX API RESPONSE --><div class=msg-warning lang={{auth.lang}} ng-if=\"frameLayout.devices.device.length == 0\">{{\'cm.msg.4\' | translate}} <span ng-if=hiddenDevices>{{\'fl.p_assign.msg.5\' | translate}}</span></div></div></section></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.flContainer.flaSchedule({id: encId})\" ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveAssignmentFx(\'device\', \'sc\');\" ng-if=frameLayout.info.isCompleted ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveAssignmentFx(\'device\', \'sc\');\" ng-if=!frameLayout.info.isCompleted ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveAssignmentFx(\'device\');\" ng-disabled=\"saveCloseProcessing || flaProcessing\" ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"><span class=\"fa fa-repeat fa-spin\" ng-if=flaProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: <span ng-if=\"auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2\' | translate | camelCase}}</span> <span ng-if=\"auth.upermissions.flat && !auth.upermissions.flar\">{{\'fl.p_assign.body.2.1\' | translate | camelCase}}</span> <span ng-if=\"!auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2.2\' | translate | camelCase}}</span> <span class=\"fa fa-chevron-right\" ng-if=!flaProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.frameLayouts.fla ng-disabled=\"saveCloseProcessing || flaProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.24\' | translate}}</span></div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/flaName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"></i><span class=stepGray ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"><p>4</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fla>{{\'fl.tab.2\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'fl.p_assign.body.1\' | translate | camelCase}}</span><span ng-if=frameLayout.info.label class=text-muted>[ {{frameLayout.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'fl.p_assign.body.1\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'cm.label.72\' | translate}}</label><input type=text id=label class=form-control ng-model=frameLayout.info.label ng-keypress=\"$event.keyCode == 13 && saveAssignmentFx(\'name\');\" placeholder=\"{{\'fl.p_assign.ph.1\' | translate}}\" autocomplete=off maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cm.label.72\' | translate}}\" aria-labelledby=\"{{\'cm.label.72\' | translate}}\"></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveAssignmentFx(\'name\', \'sc\');\" ng-if=frameLayout.info.isCompleted ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveAssignmentFx(\'name\');\" ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=flaProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'cm.label.36\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" ng-if=!flaProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.frameLayouts.fla ng-disabled=\"saveCloseProcessing || flaProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status>{{\'fl.p_assign.msg.1\' | translate}}</div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/flaSchedule.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"></i><span class=stepGray ng-if=\"auth.upermissions.flat || auth.upermissions.flar\"><p>4</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fla>{{\'fl.tab.2\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'cm.label.36\' | translate | camelCase}}</span><span ng-if=frameLayout.info.label class=text-muted>[ {{frameLayout.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'cm.label.36\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label>{{\'fl.p_assign.label.1\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span><!-- <input type=\"daterange\" id=\"dateRange\" class=\"form-control picker\" ng-model=\"frameLayout.info.dateRange\" format=\"MM/DD/YYYY\" readonly=\"\" ng-disabled=\"frameLayout.info.forever\"> --> <input type=daterange class=\"form-control picker\" id=dateRange name=datetimes ng-model=frameLayout.info.dateRange format=MM/DD/YYYY ng-focus=setDate(); readonly ng-disabled=frameLayout.info.forever aria-label=dateRange></div></div><div><label><input type=checkbox ng-model=frameLayout.info.forever ng-change=foreverFx(); role=checkbox><label></label>{{\'cm.label.16\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'fl.p_assign.msg.8\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.flContainer.flaName({id: encId})\" ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveAssignmentFx(\'schedule\', \'sc\');\" ng-if=frameLayout.info.isCompleted ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveAssignmentFx(\'schedule\');\" ng-disabled=\"saveCloseProcessing || flaProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=flaProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'cm.label.31\' | translate | camelCase}} <span class=\"fa fa-chevron-right\" ng-if=!flaProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.frameLayouts.fla ng-disabled=\"saveCloseProcessing || flaProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'fl.p_assign.msg.2\' | translate}}</span> <span ng-if=\"errType==\'slot\'\" aria-live=polite role=status>{{\'fl.p_assign.msg.3\' | translate}}</span></div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/flaThreshold.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>4</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.frameLayouts.fla>{{\'fl.tab.2\' | translate}}</a>/ <span class=\"marL10 marR10\"><span ng-if=\"auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2\' | translate | camelCase}}</span> <span ng-if=\"auth.upermissions.flat && !auth.upermissions.flar\">{{\'fl.p_assign.body.2.1\' | translate | camelCase}}</span> <span ng-if=\"!auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2.2\' | translate | camelCase}}</span> </span><span ng-if=frameLayout.info.label class=text-muted>[ {{frameLayout.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 4}\'}}: <span ng-if=\"auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2\' | translate}}</span> <span ng-if=\"auth.upermissions.flat && !auth.upermissions.flar\">{{\'fl.p_assign.body.2.1\' | translate}}</span> <span ng-if=\"!auth.upermissions.flat && auth.upermissions.flar\">{{\'fl.p_assign.body.2.2\' | translate}}</span> <span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>4</p></span></span></h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=table ng-if=!detailLoading><div class=\"row th\"><div class=col-xs-2 ng-class=\"{\'col-xs-8\':!auth.upermissions.flar, \'col-xs-4\':!auth.upermissions.flat}\">{{\'fl.p_assign.body.3\' | translate}}</div><div class=col-xs-2 ng-class=\"{\'col-xs-4\':!auth.upermissions.flar}\" ng-if=auth.upermissions.flat>{{\'fl.p_assign.body.4\' | translate}}&nbsp;<span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'fl.p_assign.body.4.1\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right aria-hidden=true></span></div><div class=col-xs-2 ng-if=auth.upermissions.flar>{{\'fl.p_assign.body.5\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><div class=col-xs-2 ng-if=auth.upermissions.flar>{{\'fl.p_assign.body.6\' | translate}}</div><div class=col-xs-2 ng-if=auth.upermissions.flar>{{\'fl.p_assign.body.7\' | translate}}</div><div class=col-xs-2 ng-if=auth.upermissions.flar>{{\'fl.p_assign.body.8\' | translate}}</div></div><div class=row ng-repeat=\"frame in frameLayout.restriction.frame\"><div class=\"col-xs-2 text-ellipsis\" ng-class=\"{\'col-xs-8\':!auth.upermissions.flar, \'col-xs-4\':!auth.upermissions.flat}\">{{frame.label}}</div><div class=col-xs-2 ng-class=\"{\'col-xs-4\':!auth.upermissions.flar}\" ng-if=auth.upermissions.flat><input type=number class=\"form-control input-sm\" ng-model=frame.threshold min=1 aria-label=threshold aria-labelledby=threshold></div><div class=col-xs-2 ng-if=auth.upermissions.flar><input type=number class=\"form-control input-sm\" ng-model=frame.duration ng-disabled=!auth.upermissions.flare min=1 aria-label=duration aria-labelledby=duration></div><div class=col-xs-2 ng-if=auth.upermissions.flar><input type=number class=\"form-control input-sm\" ng-model=frame.count ng-disabled=!auth.upermissions.flare min=1 aria-label=count aria-labelledby=count></div><div class=\"col-xs-2 text-ellipsis-wrap\" ng-if=auth.upermissions.flar><span class=\"badge bg-muted marR5\" ng-if=\"frame.folder == 0\">{{\'fl.p_assign.body.9\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"frame.folder != 0\">{{frame.folderLabel}}</span> <a class=\"fa fa-pencil\" href=\"\" role=button ng-click=\"openPopupFx(\'f\', $index, frame.folder);\" ng-if=auth.upermissions.flare></a></div><div class=\"col-xs-2 text-ellipsis-wrap\" ng-if=auth.upermissions.flar><span class=\"badge bg-muted marR5\" ng-if=\"frame.groups.length == 0\">{{\'cm.label.51\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"frame.groups.length > 0\" ng-repeat=\"group in frame.groups\">{{group.label}}</span> <a class=\"fa fa-pencil\" href=\"\" role=button ng-click=\"openPopupFx(\'g\', $index);\" ng-if=auth.upermissions.flare></a></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.flContainer.flaDevice({id: encId})\" ng-disabled=flaProcessing><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveAssignmentFx(\'threshold\', \'sc\');\" ng-disabled=flaProcessing ng-if=\"auth.upermissions.flat || auth.upermissions.flare\"><span class=fa ng-class=\"flaProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{flaProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.frameLayouts.fla ng-disabled=flaProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/fll.html","<img alt=Loading src=assets/images/loading.gif ng-if=frameLayoutsLoading><div ng-if=!frameLayoutsLoading><div class=breadcrumb ng-if=frameLayouts.info.breadcrumb><a href=\"\" role=link ng-click=\"loadSelectedTab(\'home\'); selectedTabFx();\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span>{{frameLayouts.info.breadcrumb.label}}</span> <a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><ul class=\"list-inline thumb-list cl-list\" ng-if=\"frameLayouts.frameLayouts[0].type == \'Folder\'\" ng-click=selectableFx($event)><li ng-repeat=\"folder in filteredLibraryList = (frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fl\'})\" ng-click=\"selectFolderFx($event, folder);\" ng-dblclick=openFolderFx(folder.id); data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" context-menu=contextMenuOpt class=tabIndex><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder.png></span></div><div class=thumb-label>{{folder.label}}</div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"frameLayouts.frameLayouts[0].type == \'Folder\' && (frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><ul class=\"list-inline thumb-list\" ng-if=\"frameLayouts.frameLayouts[0].type != \'Folder\' && frameLayouts.frameLayouts.length > 0\"><ng-framelayout-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=frameLayouts.frameLayouts></ng-framelayout-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><div ng-if=!frameLayouts.info>{{\'fl.msg.5\' | translate}}</div><div ng-if=frameLayouts.info>{{\'fl.msg.6\' | translate}}<div class=marT10 ng-if=\"auth.uType == 0\"><button type=button role=button class=\"btn btn-default btn-sm\" ng-click=\"confirmFrameOpen(\'category\');\" ng-disabled=flProcessing><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'fl.btn.11\' | translate}}</button></div></div></div>");
$templateCache.put("app/frameLayouts/frameLayouts.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><button type=button role=button class=\"btn btn-primary\" ui-sref=\"hub.flContainer.flName({type: encType})\" ng-if=\"selectedTab == \'hub.frameLayouts.fl\' && auth.upermissions.f\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'fl.btn.1\' | translate}}</button></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=searchBox class=lableHidden>Search</label><div class=\"input-group1 searchTbx\"><input type=text id=searchBox ng-model=searchText sanitize-input maxlength=250 class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=\"input-group-btn hide\" uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-caret-down noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ui-sref=hub.advancedSearch>Advanced search</a></li></ul></span></div></div></div><div class=spaceH></div><div class=spaceH></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs fl\" role=tablist aria-owns=\"tab-fl tab-fla tab-ufl tab-ifl tab-fll\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.frameLayouts.fl\')}}\" aria-controls=tab-fl id=tab-fl class=tab-success><a ui-sref=.fl role=link aria-label=\"{{\'fl.tab.1\' | translate}}\">{{\'fl.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.frameLayouts.fla\')}}\" aria-controls=tab-fla id=tab-fla class=tab-success><a ui-sref=.fla role=link aria-label=\"{{\'fl.tab.2\' | translate}}\">{{\'fl.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.frameLayouts.ufl\')}}\" aria-controls=tab-ufl id=tab-ufl class=tab-disabled><a ui-sref=.ufl role=link aria-label=\"{{\'fl.tab.3\' | translate}}\">{{\'fl.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.frameLayouts.ifl\')}}\" aria-controls=tab-ifl id=tab-ifl class=tab-disabled><a ui-sref=.ifl role=link aria-label=\"{{\'fl.tab.4\' | translate}}\">{{\'fl.tab.4\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.frameLayouts.fll\')}}\" aria-controls=tab-fll id=tab-fll class=tab-primary><a ui-sref=.fll role=link aria-label=\"{{\'fl.tab.5\' | translate}}\">{{\'fl.tab.5\' | translate}}</a></li></ul><div class=panel-tools ng-if=\"selectedTab != \'hub.frameLayouts.fll\'\"><div class=pull-right uib-dropdown><a href=\"\" role=link id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-placement=left><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': frameLayouts.info.sortType === \'label\' && frameLayouts.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'asc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': frameLayouts.info.sortType === \'label\' && frameLayouts.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'desc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\"></li><li class=dropdown-header ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\">{{\'cm.tool.1.2\' | translate}}</li><li ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\" ng-class=\"{\'selected\': frameLayouts.info.sortType === \'approvedon\' && frameLayouts.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'approvedon\', \'asc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\" ng-class=\"{\'selected\': frameLayouts.info.sortType === \'approvedon\' && frameLayouts.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'approvedon\', \'desc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': frameLayouts.info.sortType === \'createdon\' && frameLayouts.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'asc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': frameLayouts.info.sortType === \'createdon\' && frameLayouts.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'desc\', frameLayouts.frameLayouts, frameLayouts.info, \'framelayoutsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=link id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'fl\');\" translate=\"{{\'fl.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'fla\');\" translate=\"{{\'fl.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.frameLayouts.ufl\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'ufl\');\" translate=\"{{\'fl.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.frameLayouts.ifl\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'ifl\');\" translate=\"{{\'fl.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li class=vid><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\" translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li></ul></div><div class=pull-right><a href=\"\" role=link id=refresh aria-label=refresh ng-click=\"loadSelectedTab(\'refresh\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingMain><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><!--For Selected Item Brief--><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-framelayout-brief ng-if=\"selectedItems.length > 0\"></ng-framelayout-brief>");
$templateCache.put("app/frameLayouts/ifl.html","<img alt=Loading src=assets/images/loading.gif ng-if=frameLayoutsLoading><ul class=\"list-inline thumb-list\" ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\"><ng-framelayout-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=frameLayouts.frameLayouts></ng-framelayout-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><p>{{\'fl.msg.4\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ifl\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/frameLayouts/ufl.html","<img alt=Loading src=assets/images/loading.gif ng-if=frameLayoutsLoading><ul class=\"list-inline thumb-list\" ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length > 0\"><ng-framelayout-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=frameLayouts.frameLayouts></ng-framelayout-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!frameLayoutsLoading && frameLayouts.frameLayouts.length == 0\"><p>{{\'fl.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ufl\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'fl\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'fl.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/login/approveItem.html","<section class=wrapper><div class=\"loginContainer approveItem\"><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png></div><div class=\"text-center marT25\"><div ng-if=infoLoading>Please wait <img alt=Loading src=assets\\images\\loading-xs.gif class=marL5></div><div ng-if=!infoLoading><div ng-if=\"info.code == 6024\"><div class=text-bold><div class=text-danger>Items are already approved by you or other Administrator of this server.</div><div class=marT10>Approved by: {{info.approvedBy}}</div></div></div><div ng-if=\"info.code == 6025 || info.code == 6029 || info.code == 6031 || info.code == 6033\" class=\"text-success text-bold\">Items has been approved.</div><div ng-if=\"info.code == 6028\" class=\"text-bold text-danger\">Items does not exists on server any more.</div><div ng-if=\"info.code == 6030\" class=\"text-bold text-danger\">Approval link has been expired.</div><div ng-if=\"info.code == 6032\" class=\"text-bold text-danger\">Items are in Archived/Deleted state. Archived/Deleted item can not be approved.</div><div class=marT10><a id=login class=\"btn btn-primary btn-sm\" ui-sref=login role=button>Go to L Squared Hub</a></div></div></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>Terms &amp; Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>Privacy Policy</a></footer>");
$templateCache.put("app/login/forgotPassword.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">{{\"login.msg.1\" | translate}}</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\" translate=\"{{\'login.msg.21\'}}\" translate-values=\"{title: \'{{dmainPageTitle}}\' }\"></div></div><div class=\"forgotPass bg-white marT25\"><header class=panel-heading><h1 role=heading aria-level=1>{{\"login.label.9\" | translate}}</h1></header><div class=padLR10 ng-if=isSupport><div class=\"marT25 text-success text-center text-bold\">{{\"login.msg.12\" | translate}}</div><div class=\"marT25 marB25 text-center\"><a class=\"btn btn-primary btn-sm\" role=button ng-click=goLoginFx(); id=goLogin1>{{\"login.msg.13\" | translate}}</a></div></div><div class=padLR10 ng-if=isPwdSuccess><div class=\"marT25 text-success text-md\" translate=\"{{\'login.msg.18\'}}\" translate-values=\"{htmlTagO:\'<span class=\\\'text-bold\\\'>{{pwd.email}}\', htmlTagC:\'</span>\'}\"></div><div class=\"marT25 text-muted\"><div class=text-bold>{{\"login.msg.14\" | translate}}</div><div>{{\"login.msg.15\" | translate}}</div></div><div class=\"marT25 marB25 text-center\"><a class=\"btn btn-primary btn-sm\" role=button ng-click=goLoginFx(); id=goLogin2>{{\"login.msg.13\" | translate}}</a></div></div><form method=post name=retrievePassForm ng-show=\"!isPwdSuccess && !isSupport\"><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'email\'\" aria-live=polite role=status>{{\"login.msg.16\" | translate}}</div><div ng-if=\"errType==\'reCaptcha\'\" aria-live=polite role=status>{{\"login.msg.17\" | translate}}</div></div><div class=form-group><label for=email>{{\"login.label.1\" | translate}}</label><input type=email id=email ng-model=email class=form-control placeholder=\"{{\'login.label.1\' | translate}}\" focus-me=true aria-label=\"{{\'login.label.1\' | translate}}\" aria-labelledby=\"{{\'login.label.1\' | translate}}\" aria-placeholder=\"{{\'login.label.1\' | translate}}\" required></div><div class=form-group><div vc-recaptcha key=publicKey></div></div><button type=button role=button ng-click=forgotPassFx(); class=\"btn btn-primary\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-undo\" ng-if=!authProcessing aria-hidden=true></span>{{\"login.label.9\" | translate}}</button> <a href=\"\" role=link id=cancel ng-click=cancelForgetPassFx(); class=\"btn btn-link\">{{\"login.btn.3\" | translate}}</a></div></form></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>{{\"login.label.6\" | translate}} &amp; {{\"login.label.7\" | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>{{\"login.label.8\" | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/lock.html","<section class=wrapper><div class=\"loginContainer1 lock\"><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><hr><form method=post name=loginForm><div class=\"panel-body text-center\"><div class=lockIcon><span class=\"fa fa-lock\" aria-hidden=true></span></div><div class=\"form-group text-center text-big\">{{auth.uname}}</div><div class=\"form-group text-left\"><input type=password id=pass name=pass ng-model=credentials.pass class=form-control placeholder=\"{{\'lock.1\' | translate}}\" aria-label=\"{{\'lock.1\' | translate}}\" aria-labelledby=\"{{\'lock.1\' | translate}}\" aria-placeholder=\"{{\'lock.1\' | translate}}\"></div><div class=\"form-group text-left\"><button type=button role=button ng-click=unlockFx(); class=\"btn btn-primary marR5\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-unlock\" ng-if=!authProcessing aria-hidden=true></span>{{\'lock.b1\' | translate}}</button> <a href=\"\" role=link id=logOut ng-click=logOutFx(); class=\"btn btn-link\">{{\'cm.head.menu.5\' | translate}}</a></div><div class=\"errMsg marB10 text-left\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'auth\'\" aria-live=polite role=status>Password were not recognized. Please check and try again.</div><div ng-if=\"errType==\'block\'\" aria-live=polite role=status>This user does not have access to any server. Please contact your server\'s administrator.</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status translate=\"{{\'ss.m1\'}}\" translate-values=\"{by:\'<br>L Squared Support by <a href=\\\'\\\' role=\\\'button\\\' id=\\\'lsn\\\'>{{\'ss.m1.1\' | translate}}</a>\'}\"></div></div></div></form></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank ng-cloak>{{\'cm.footer.2\' | translate}}</a></footer>");
$templateCache.put("app/login/login.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">{{\"login.msg.1\" | translate}}</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\" translate=\"{{\'login.msg.21\'}}\" translate-values=\"{title: \'{{dmainPageTitle}}\' }\"></div></div><div class=\"panel-body text-center marT25\" ng-if=checkSSO>{{\"login.msg.11\" | translate}} <img alt=Loading src=assets\\images\\loading-xs.gif class=marL5></div><div class=\"panel-body text-center marT25\" ng-if=\"isSsoAuth && freeTrailLogin\">{{\"login.msg.11\" | translate}} <img alt=Loading src=assets\\images\\loading-xs.gif class=marL5></div><div class=\"panel-body text-center marT25\" ng-if=\"checkSaaS && !saasErr\">{{\"login.msg.11\" | translate}} <img alt=Loading src=assets\\images\\loading-xs.gif class=marL5></div><form method=post name=loginForm ng-if=\"(!checkSSO && !sso && !freeTrailLogin && !checkSaaS && !saasErr) || (!isSsoAuth && freeTrailLogin)\"><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'lastAttem\'\" aria-live=polite role=status>{{\"login.msg.2\" | translate}}</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>{{\"login.msg.3\" | translate}}<br>{{\"login.msg.3.1\" | translate}} <a href=\"\" role=link id=api>{{\"login.label.4\" | translate}}</a>.</div><div ng-if=\"errType==\'noServer\'\" aria-live=polite role=status>{{\"login.msg.4\" | translate}}</div><div ng-if=\"errType==\'block\'\" aria-live=polite role=status><div>{{\"login.msg.5\" | translate}}</div><a href=\"\" role=link id=resentFx ng-click=resendFx();>{{\"login.label.5\" | translate}}</a></div><div ng-if=\"errType==\'auth\'\" aria-live=polite role=status>{{\"login.msg.6\" | translate}}</div><div ng-if=\"errType==\'itemNotAcce\'\" aria-live=polite role=status>{{\"login.msg.7\" | translate}}</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\"login.msg.8\" | translate}}</div><div ng-if=\"errType==\'uNotFound\'\" aria-live=polite role=status>{{\"login.msg.9\" | translate}}</div></div><div class=form-group><label for=email>{{\'login.label.1\' | translate}}</label><input type=email id=email ng-model=credentials.email class=form-control placeholder=\"{{\'login.label.1\' | translate}}\" focus-me=true name=email aria-label=\"{{\'login.label.1\' | translate}}\" aria-labelledby=\"{{\'login.label.1\' | translate}}\" aria-placeholder=\"{{\'login.label.1\' | translate}}\"></div><div class=form-group><label for=password>{{\'login.label.2\' | translate}}</label><input type=password id=password ng-model=credentials.pass class=form-control placeholder=\"{{\'login.label.2\' | translate}}\" name=password aria-label=\"{{\'login.label.2\' | translate}}\" aria-labelledby=\"{{\'login.label.2\' | translate}}\" aria-placeholder=\"{{\'login.label.2\' | translate}}\"></div><button type=submit role=button ng-click=authenticate(); class=\"btn btn-primary marR5\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-sign-in\" ng-if=!authProcessing aria-hidden=true></span>{{\"login.btn.1\" | translate}}</button><!-- <button type=\"button\" role=\"button\" ng-click=\"authenticate(\'ft\');\" class=\"btn btn-primary marR5\" ng-if=\"freeTrailLogin\" ng-disabled=\"ftProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=\"ftProcessing\" aria-hidden=\"true\"></span><span class=\"fa fa-windows\" style=\"font-size:14px\" ng-if=\"!ftProcessing\" aria-hidden=\"true\"></span> {{\"login.btn.2\" | translate}}</button> --><!-- <div class=\"marB10\" ng-if=\"freeTrailLogin\"></div> --> <a href=\"\" role=link ui-sref=forgotPassword id=forgotPass class=btn-link ng-class=\"{\'btn\':!freeTrailLogin}\">{{\"login.label.3\" | translate}}</a></div></form><div class=\"panel-body text-center marT20\" ng-if=\"checkSaaS && saasErr\"><div class=\"errMsg marB10 text-left\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'lastAttem\'\" aria-live=polite role=status>{{\"login.msg.2\" | translate}}</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>{{\"login.msg.3\" | translate}}<br>{{\"login.msg.3.1\" | translate}} <a href=\"\" role=link id=saasAPI>{{\"login.label.4\" | translate}}</a>.</div><div ng-if=\"errType==\'noServer\'\" aria-live=polite role=status>{{\"login.msg.4\" | translate}}</div><div ng-if=\"errType==\'block\'\" aria-live=polite role=status><div>{{\"login.msg.5\" | translate}}</div><a href=\"\" role=link id=saasResend ng-click=resendFx();>{{\"login.label.5\" | translate}}</a></div><div ng-if=\"errType==\'auth\'\" aria-live=polite role=status>{{\"login.msg.6\" | translate}}</div><div ng-if=\"errType==\'userNotInSer\'\" aria-live=polite role=status>{{\"login.msg.10\" | translate}}</div><div ng-if=\"errType==\'itemNotAcce\'\" aria-live=polite role=status>{{\"login.msg.7\" | translate}}</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\"login.msg.8\" | translate}}</div></div></div><div class=\"panel-body text-center marT20\" ng-if=\"!checkSSO && sso && !checkSaaS\"><div class=\"errMsg marB10 text-left\" ng-if=\"hasErr || saasErr\" aria-live=polite role=status><div ng-if=\"errType==\'lastAttem\'\" aria-live=polite role=status>{{\"login.msg.2\" | translate}}</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>{{\"login.msg.3\" | translate}}<br>{{\"login.msg.3.1\" | translate}} <a href=\"\" role=link id=ssoAPI>{{\"login.label.4\" | translate}}</a>.</div><div ng-if=\"errType==\'noServer\'\" aria-live=polite role=status>{{\"login.msg.4\" | translate}}</div><div ng-if=\"errType==\'block\'\" aria-live=polite role=status><div>{{\"login.msg.5\" | translate}}</div><a href=\"\" role=link id=ssoResend ng-click=resendFx();>{{\"login.label.5\" | translate}}</a></div><div ng-if=\"errType==\'auth\'\" aria-live=polite role=status>{{\"login.msg.6\" | translate}}</div><div ng-if=\"errType==\'userNotInSer\'\" aria-live=polite role=status>{{\"login.msg.10\" | translate}}</div><div ng-if=\"errType==\'itemNotAcce\'\" aria-live=polite role=status>{{\"login.msg.7\" | translate}}</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\"login.msg.8\" | translate}}</div><div ng-if=\"errType==\'samlErr\'\" aria-live=polite role=status>{{\"login.msg.20\" | translate}}</div></div><a href=\"\" role=link id=ssoLogin class=\"btn btn-primary\" ng-click=loginSSOFx(); ng-if=!isSsoAuth ng-disabled=authProcessing><span class=fa ng-class=\"authProcessing?\'fa-repeat fa-spin\':\'fa-sign-in\'\" aria-hidden=true></span>{{sso.text}}</a><!-- Login with Phillips 66 SSO --><div class=\"panel-body text-center marT25\" ng-if=isSsoAuth>{{\"login.msg.11\" | translate}} <img alt=Loading src=assets\\images\\loading-xs.gif class=marL5></div><iframe ng-src={{ssoLogoutURL}} width=0 height=0 class=noBdr ng-if=ssoLogoutURL></iframe></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>{{\"login.label.6\" | translate}} &amp; {{\"login.label.7\" | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>{{\"login.label.8\" | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/loginSuccess.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15 vHide\" ng-if=\"myTheme.clientTheme == \'\'\">{{\"login.msg.1\" | translate}}</div></div><div ng-if=\"!pageLoading && !isLinkValid\" class=\"text-center marT25\"><h5 class=text-bold>{{\"sm.m1\" | translate}}</h5><!-- <a class=\"btn btn-primary btn-sm\" ui-sref=\"login\" id=\"gotoLSN2\">Go to L Squared Hub</a> --></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf target=_blank>Terms &amp; Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf target=_blank>Privacy Policy</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/resetPass.html","<section class=wrapper><div class=loginContainer><div class=text-center ng-if=\"!urlType || urlType != \'mb\'\"><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><div class=text-center ng-if=\"urlType == \'mb\'\"><img alt=\"L Squared Hub\" src=assets/images/logo-index-mb.png><div class=\"text-muted marT15\">Welcome to L Squared Digital Signage Platform</div></div><div class=\"text-center marT20\" ng-if=pageLoading>Please wait <img alt=Loading src=assets/images/loading-xs.gif class=marL5></div><div ng-if=\"!pageLoading && isReset\" class=\"text-center marT25\"><p class=\"text-bold text-success\">Your password has been successfully reset.</p><a ng-if=\"urlType!=\'mb\'\" class=\"btn btn-primary btn-sm\" ui-sref=login role=button id=gotoLSN1>Go to L Squared Hub</a> <a ng-if=\"urlType==\'mb\'\" class=\"btn btn-primary btn-sm\" ng-href={{hostURL}}/{{urlType}} role=button id=gotoLSN1>Go to L Squared Menu Board</a></div><div ng-if=\"!pageLoading && !isLinkValid\" class=\"text-center marT25\"><p class=\"text-bold text-danger\">Sorry! The link has expired now.</p><p class=marB20>Please try \"Forget password\" again.</p><a ng-if=\"urlType!=\'mb\'\" class=\"btn btn-primary btn-sm\" ui-sref=login role=button id=gotoLSN2>Go to L Squared Hub</a> <a ng-if=\"urlType==\'mb\'\" class=\"btn btn-primary btn-sm\" ng-href={{hostURL}}/{{urlType}} role=button id=gotoLSN2>Go to L Squared Menu Board</a></div><div class=\"forgotPass bg-white marT25\" ng-if=\"!pageLoading && !isReset && isLinkValid\"><header class=panel-heading><h1 role=heading aria-level=1>Reset Password</h1></header><div class=panel-body><div class=\"errMsg marL10 marR10\" ng-if=isUserErr aria-live=polite role=status>Oops! Something went wrong. Please try again later. You can report this issue to L&nbsp;Squared&nbsp;Support by <a href=\"\" role=link ui-sref=login id=login>clicking here</a></div><form method=post name=retrievePassForm ng-if=!isUserErr><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'cPass\'\" aria-live=polite role=status>Please provide Confirm password.</div><div ng-if=\"errType==\'reCaptcha\'\" aria-live=polite role=status>Please validate captcha.</div><div ng-if=\"errType==\'nPass\'\" aria-live=polite role=status>Please provide New password.</div><div ng-if=\"errType==\'notMach\'\" aria-live=polite role=status>Confirm password not match.</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>Password is not valid.</div></div><div class=form-group><label>New password</label><input type=password id=password class=form-control ng-model=credentials.nPass placeholder=\"New password\" autocomplete=new-password ng-change=pwdValidate() focus-me=true required name=password aria-label=\"New password\" aria-labelledby=\"New password\" aria-placeholder=\"New password\"></div><div class=\"form-group bg-light pad10\" ng-if=credentials.nPass><li ng-class=\"pwdLengthValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must be at least 8 characters. <span class=\"fa fa-check\" ng-if=pwdLengthValid aria-hidden=true></span></li><li ng-class=\"pwdCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one capital and one small letter. <span class=\"fa fa-check\" ng-if=pwdCharValid aria-hidden=true></span></li><li ng-class=\"pwdNumValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one digit. <span class=\"fa fa-check\" ng-if=pwdNumValid aria-hidden=true></span></li><li ng-class=\"pwdSplCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one of the following character: !@#$%& <span class=\"fa fa-check\" ng-if=pwdSplCharValid aria-hidden=true></span></li></div><div class=form-group><label>Confirm password</label><input type=password id=cPassword class=form-control ng-model=credentials.cPass placeholder=\"Confirm password\" name=cPassword aria-label=\"Confirm password\" aria-labelledby=\"Confirm password\" aria-placeholder=\"Confirm password\" required></div><div class=form-group><div vc-recaptcha key=publicKey></div></div><button type=button role=button ng-click=resetPassFx(); class=\"btn btn-primary\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-check\" ng-if=!authProcessing aria-hidden=true></span>Save</button> <a href=\"\" role=link ui-sref=login class=\"btn btn-link\" id=cancel>Cancel</a></form></div></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>Terms &amp; Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>Privacy Policy</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/saasSubscribe.html","<section class=wrapper ng-if=!loading><div class=loginContainer style=width:500px;top:10%><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L&nbsp;Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><div ng-if=signupFail class=text-center><div class=\"marT25 text-bold text-danger\">Oops! Something went wrong. Please try again later.</div><div class=marT15><a class=\"btn btn-primary btn-sm\" ng-click=showSignup(); role=button id=trySign>Try sign up again.</a></div></div><div ng-if=\"signupComplete && !signupFail\" class=text-center><div class=\"marT25 text-bold text-success\">Thanks for joining L&nbsp;Squared&nbsp;Hub.</div><div class=marT5>Your account has been created with L&nbsp;Squared&nbsp;Hub.</div><div class=marT15><a class=\"btn btn-primary btn-sm\" ui-sref=login role=button id=signtoLSN>Sign in to L&nbsp;Squared&nbsp;Hub</a></div></div><form method=post name=signupForm ng-if=!signupFail><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>All fields are mandatory.</div><div ng-if=\"errType==\'cpass\'\" aria-live=polite role=status>Passwords did not match.</div><div ng-if=\"errType==\'reCaptcha\'\" aria-live=polite role=status>Please validate captcha.</div><div ng-if=\"errType==\'userExist\'\" aria-live=polite role=status>User already exist.</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>Password is not valid.</div></div><div class=form-group><div class=row><div class=col-xs-6><label>First name</label><input type=text id=fn ng-model=saas.fName class=form-control focus-me=true aria-label=\"First name\" aria-labelledby=\"First name\"></div><div class=col-xs-6><label>Last name</label><input type=text id=ln ng-model=saas.lName class=form-control aria-label=\"Last name\" aria-labelledby=\"Last name\"></div></div></div><div class=form-group><div class=row><div class=col-xs-6><label>Email</label><input type=text id=email ng-model=saas.email class=form-control readonly aria-label=Email aria-labelledby=Email></div><div class=col-xs-6><label>Subscription name</label><input type=text id=sName ng-model=saas.subscriptionName class=form-control readonly aria-label=\"Subscription name\" aria-labelledby=\"Subscription name\"></div></div></div><div class=form-group><div class=row><div class=col-xs-6><label>Offer id</label><input type=text id=offerId ng-model=saas.offerId class=form-control readonly aria-label=\"Offer id\" aria-labelledby=\"Offer id\"></div><div class=col-xs-6><label>Plan id</label><input type=text id=planId ng-model=saas.planId class=form-control readonly aria-label=\"Plan id\" aria-labelledby=\"Plan id\"></div></div></div><div class=form-group><label>Password</label><input type=password id=pass ng-model=saas.pass class=form-control ng-change=pwdValidate() aria-label=Password aria-labelledby=Password autocomplete=new-password></div><div class=\"form-group bg-light pad10\" ng-if=saas.pass><li ng-class=\"pwdLengthValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must be at least 8 characters. <span class=\"fa fa-check\" ng-if=pwdLengthValid aria-hidden=true></span></li><li ng-class=\"pwdCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one letter. <span class=\"fa fa-check\" ng-if=pwdCharValid aria-hidden=true></span></li><li ng-class=\"pwdNumValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one digit. <span class=\"fa fa-check\" ng-if=pwdNumValid aria-hidden=true></span></li><li ng-class=\"pwdSplCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one of the following character: !@#$%& <span class=\"fa fa-check\" ng-if=pwdSplCharValid aria-hidden=true></span></li></div><div class=form-group><label>Confirm password</label><input type=password id=cpw ng-model=saas.cPass class=form-control aria-label=\"Confirm password\" aria-labelledby=\"Confirm password\"></div><div class=form-group><div vc-recaptcha key=publicKey></div></div><button type=button role=button class=\"btn btn-primary\" ng-click=\"signupFx(signup, userId);\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"glyphicon glyphicon-log-in\" aria-hidden=true ng-if=!authProcessing></span>Sign Up</button> <button type=button role=button ui-sref=login class=\"btn btn-link\">Cancel</button></div></form></div></section><footer class=\"footer noMarL padL10 text-theme\" ng-if=!loading><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>Terms & Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>Privacy Policy</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/selectServer.html","<section class=wrapper><nav class=\"navbar navbar-fixed-top navbarTop\"><div class=container-fluid><button type=button role=button class=\"navbar-toggle collapsed hide\" ng-click=\"isCollapsed = !isCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=navbar-header><span class=navbar-brand><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo.png> <img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo_square.png class=hide><!-- Theme --> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/logo.png class=hLogo> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/v-logo.png class=\"hLogo hide\"></span></div><div class=\"collapse navbar-collapse in\"><ul class=\"nav navbar-nav navbar-right\"><li uib-dropdown><a href=\"\" role=link id=topNav class=nav-user uib-dropdown-toggle><img alt=\"{{userName | limitTo:1}}\" ng-if=\"userImg.uImg !=\'\'\" ng-src={{userImg.uImg}} src-error=userError> <span class=profileIcon-xs ng-if=\"userImg.uImg ==\'\'\">{{userName | limitTo:1}}</span>{{userName | limitTo:25}}<span class=caret></span></a><ul class=\"dropdown-menu nav-user-menu\" uib-dropdown-menu role=menu><li role=menuitem><a href=\"\" role=link id=ssLogout ng-click=ssLogOutFx(); ng-cloak><span class=\"fa fa-sign-out\" aria-hidden=true></span>{{\'cm.head.menu.5\' | translate}}</a></li></ul></li></ul></div></div></nav><div class=selectServerContainer><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=showTimeoutMsg><span translate=\"{{\'cm.msg.28\'}}\" translate-values=\"{sessionTimer: \'{{sessionTimer}}\',htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></span><br><a href=\"\" role=link id=resetSession class=\"btn-link text-bold\" ng-click=resetSession(true);>{{\'cm.msg.29\' | translate}}</a></div><div class=selectServer><header class=panel-heading ng-cloak><h1 role=heading aria-level=1>{{\'ss.1\' | translate}}</h1></header><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'api\'\" aria-live=polite role=status translate=\"{{\'ss.m1\'}}\" translate-values=\"{by:\'<br>L Squared Support by <a href=\\\'\\\' role=\\\'button\\\' id=\\\'api\\\'>{{\'ss.m1.1\' | translate}}</a>\'}\"></div></div><div class=\"form-group lsn-select\"><label ng-cloak>{{\'ss.2\' | translate}}</label><div class=dropdown uib-dropdown auto-close=outsideClick is-open=ss.isOpen on-toggle=toggleCallback(open)><a href=\"\" role=link id=serverList class=dropdown-toggle uib-dropdown-toggle ng-click=serverSearchFocus(); focus-me=true><span class=pull-left>{{selectedServer.label}}</span> <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=\"dropdown-header padLR10\" ng-show=\"serverList.length > 5\"><label for=ssSearch class=lableHidden>dtpl</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=ssSearch ng-model=searchSList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=searchSList class=text-danger ng-show=searchSList.length ng-click=\"searchSList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-show=\"serverList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li role=menuitem ng-repeat=\"sList in filteredAuthServerList = (serverList | filter:searchSList) | orderBy: \'label\'\" tabindex={{$index}} ng-class=\"{\'selected disabled\': sList.id == selectedServer.id}\"><a href=\"\" role=link id=ss{{$index}} ng-click=\"selectServerFx(sList, $event);\" ng-if=\"sList.id != auth.selectedServer\">{{sList.label}}</a> <span ng-if=\"sList.id == auth.selectedServer\">{{sList.label}}</span></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredAuthServerList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchSList)}}&quot;</b>\'}\"></div></div></ul></div></div><button type=button role=button ng-click=gotoDashboard(); class=\"btn btn-primary\" ng-disabled=authProcessing ng-cloak><span class=fa ng-class=\"authProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.18\' | translate}}</button></div></div></div><iframe ng-src={{ssoLogoutURL}} width=0 height=0 class=noBdr ng-if=ssoLogoutURL></iframe></section><footer class=\"footer noMarL padL10\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank id=terms ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank id=privacy ng-cloak>{{\'cm.footer.2\' | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/setPass.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><div class=\"text-center marT20\" ng-if=pageLoading>Please wait <img alt=Loading src=assets/images/loading-xs.gif class=marL5></div><div class=\"text-center marT25\" ng-if=\"!pageLoading && !isSetPass && !isLinkValid\"><p class=\"text-bold text-danger\">Sorry! Invalid request URL.</p><p class=marT20>Please contact Support@LSquared.com</p></div><div class=\"forgotPass bg-white marT25\" ng-if=\"!pageLoading && isSetPass\"><div class=\"panel-body pad20\"><!-- <p>Thanks for joining L&nbsp;Squared&nbsp;Digital&nbsp;Signage. We are reviewing your details and will get back to you shortly (normally within 15 minutes to 4 hours). Please check your email shortly.</p> --><p>Thanks for joining L&nbsp;Squared&nbsp;Digital&nbsp;Signage.</p><p class=text-bold>Here are some useful links for you:</p><div><label class=marR5>Video:</label><a href=\"https://www.youtube.com/watch?v=Nuye1KMrw2U\" role=link id=video target=_blank>L&nbsp;Squared&nbsp;Hub Overview</a></div><div><label class=marR5>Client installer:</label><a href=https://trial.lsquared.com/lsquared-hub/support/downloads/app/LSquared-TrialSetup.zip role=link id=ci target=_blank>L&nbsp;Squared&nbsp;Slide</a></div><div><label class=marR5>User Guide:</label><a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/support/downloads/doc/LSquaredHub-UserGuide-V2-en.pdf role=link id=ugEN target=_blank>English</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/support/downloads/doc/LSquaredHub-UserGuide-V2-fr.pdf role=link id=ugFR target=_blank>French</a></div><div>&nbsp;</div><p>Please contact L Squared Sales on <a href=mailto:sales@lsquared.com role=mail>Sales@LSquared.com</a> for any questions.</p><div>&nbsp;</div><a role=button ng-href={{hostURL}} id=authenticate class=\"btn btn-primary btn-sm\"><span class=\"fa fa-sign-in\" aria-hidden=true></span> Go to L Squared Hub</a></div></div><div class=\"forgotPass bg-white marT25\" ng-if=\"!pageLoading && !isSetPass && isLinkValid\"><header class=panel-heading><h1 role=heading aria-level=1>Set Your Password</h1></header><div class=panel-body><div class=\"errMsg marL10 marR10\" ng-if=isUserErr aria-live=polite role=status>Oops! Something went wrong. Please try again later. You can report this issue to L&nbsp;Squared&nbsp;Support by <a href=\"\" role=link ui-sref=login>clicking here</a></div><form method=post name=retrievePassForm ng-if=!isUserErr><div class=\"msg-warning marB15\" lang={{auth.lang}}>You need to set your password to start using the L&nbsp;Squared&nbsp;Digital&nbsp;Signage.</div><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'cPass\'\" aria-live=polite role=status>Please provide Confirm password.</div><div ng-if=\"errType==\'pass\'\" aria-live=polite role=status>Please provide Password.</div><div ng-if=\"errType==\'notMach\'\" aria-live=polite role=status>Confirm password not match.</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>Password is not valid.</div></div><div class=form-group><label for=pass>Password</label><input type=password id=pass class=form-control ng-model=credentials.pass placeholder=Password autocomplete=new-password ng-change=pwdValidate() focus-me=true aria-label=Password aria-labelledby=Password aria-placeholder=Password required></div><div class=\"form-group bg-light pad10\" ng-if=credentials.pass><li ng-class=\"pwdLengthValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must be at least 8 characters. <span class=\"fa fa-check\" ng-if=pwdLengthValid aria-hidden=true></span></li><li ng-class=\"pwdCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one capital and one small letter. <span class=\"fa fa-check\" ng-if=pwdCharValid aria-hidden=true></span></li><li ng-class=\"pwdNumValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one digit. <span class=\"fa fa-check\" ng-if=pwdNumValid aria-hidden=true></span></li><li ng-class=\"pwdSplCharValid?\'text-success\':\'text-danger\'\" class=text-bold>Password must contain at least one of the following character: !@#$%& <span class=\"fa fa-check\" ng-if=pwdSplCharValid aria-hidden=true></span></li></div><div class=form-group><label for=cPass>Confirm password</label><input type=password id=cPass class=form-control ng-model=credentials.cPass placeholder=\"Confirm password\" aria-label=\"Confirm password\" aria-labelledby=\"Confirm password\" aria-placeholder=\"Confirm password\" required></div><button type=button role=button ng-click=setPassFx(); class=\"btn btn-primary\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-check\" ng-if=!authProcessing aria-hidden=true></span>Save</button></form></div></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>Terms &amp; Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>Privacy Policy</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/showPassword.html","<section class=wrapper><div class=loginContainer><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div></div><div class=\"text-center marT40\"><div ng-if=pwdLoading>{{\'sp.1\' | translate}} <img alt=loading src=assets\\images\\loading-xs.gif class=marL5></div><div ng-if=!pwdLoading><div ng-if=\"pwd.code == 6021\"><div>Password: <span class=text-bold>{{pwd.password}}</span></div><div class=marT20><a class=\"btn btn-primary btn-sm\" ui-sref=login role=button id=signIn>{{\'sp.2\' | translate}}</a></div></div><div ng-if=\"pwd.code == 6020 || pwd.code == 6023\"><div class=\"text-danger text-bold\"><span ng-if=\"pwd.code == 6023\">{{\'sp.3\' | translate}}</span> <span ng-if=\"pwd.code == 6020\">{{\'sp.4\' | translate}}</span></div><div class=marT5>{{\'sp.5\' | translate}}</div><div class=marT20><a class=\"btn btn-primary btn-sm\" ui-sref=login role=button id=gotoLSN>{{\'sp.6\' | translate}}</a></div></div></div></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme!=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank ng-cloak>{{\'cm.footer.2\' | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/signup.html","<section class=wrapper><div class=loginContainer style=width:450px><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" translate=\"{{\'signup.msg.1\'}}\" translate-values=\"{brand:\'L&nbsp;Squared\'}\"></div></div><div ng-if=signupFail class=text-center><div class=\"marT25 text-bold text-danger\">{{\'signup.msg.6\' | translate}}</div><div class=marT15><a class=\"btn btn-primary btn-sm\" ng-click=showSignup(); role=button>{{\'signup.msg.6.1\' | translate}}</a></div></div><div ng-if=\"signupComplete && !signupFail\" class=text-center><div class=\"marT25 text-bold text-success\" translate=\"{{\'signup.msg.7\'}}\" translate-values=\"{brand:\'L&nbsp;Squared&nbsp;Hub\'}\"></div><div class=marT5 translate=\"{{\'signup.msg.8\'}}\" translate-values=\"{brand:\'L&nbsp;Squared&nbsp;Hub\'}\"></div><div class=marT15><a class=\"btn btn-primary btn-sm\" ui-sref=login role=button ng-if=!isDmbUser translate=\"{{\'signup.msg.9\'}}\" translate-values=\"{brand:\'L&nbsp;Squared&nbsp;Hub\'}\"></a></div><div class=marT15><a class=\"btn btn-primary btn-sm\" href={{domain}} role=button ng-if=isDmbUser translate=\"{{\'signup.msg.9\'}}\" translate-values=\"{brand:\'Menu Board\'}\"></a></div></div><form method=post name=signupForm ng-if=\"!signupComplete && !signupFail\"><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'signup.msg.2\' | translate}}</div><div ng-if=\"errType==\'cpass\'\" aria-live=polite role=status>{{\'signup.msg.3\' | translate}}</div><div ng-if=\"errType==\'reCaptcha\'\" aria-live=polite role=status>{{\'signup.msg.4\' | translate}}</div><div ng-if=\"errType==\'userExist\'\" aria-live=polite role=status>{{\'signup.msg.5\' | translate}}</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>{{\'signup.msg.14\' | translate}}</div></div><div class=form-group><label for=sfn>{{\'signup.label.1\' | translate}}</label><label for=sln class=lableHidden>Name</label><div class=row><div class=col-xs-6><input type=text id=sfn ng-model=signup.fName class=form-control placeholder=\"{{\'signup.label.1.1\' | translate}}\" focus-me=true name=fName aria-label=\"{{\'signup.label.1.1\' | translate}}\" aria-labelledby=\"{{\'signup.label.1.1\' | translate}}\" aria-placeholder=\"{{\'signup.label.1.1\' | translate}}\"></div><div class=col-xs-6><input type=text id=sln ng-model=signup.lName class=form-control placeholder=\"{{\'signup.label.1.2\' | translate}}\" name=lName aria-label=\"{{\'signup.label.1.2\' | translate}}\" aria-labelledby=\"{{\'signup.label.1.2\' | translate}}\" aria-placeholder=\"{{\'signup.label.1.2\' | translate}}\"></div></div></div><div class=form-group><label for=nPassword>{{\'signup.label.2\' | translate}}</label><input type=password id=nPassword autocomplete=off ng-model=signup.pass class=form-control ng-change=pwdValidate() name=nPassword aria-label=\"{{\'signup.label.2\' | translate}}\" aria-labelledby=\"{{\'signup.label.2\' | translate}}\"></div><div class=\"form-group bg-light pad10\" ng-if=signup.pass><ul class=\"padL20 noMarB\"><li ng-class=\"pwdLengthValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'signup.msg.10\' | translate}} <span class=\"fa fa-check\" ng-if=pwdLengthValid aria-hidden=true></span></li><li ng-class=\"pwdCharValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'signup.msg.11\' | translate}} <span class=\"fa fa-check\" ng-if=pwdCharValid aria-hidden=true></span></li><li ng-class=\"pwdNumValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'signup.msg.12\' | translate}} <span class=\"fa fa-check\" ng-if=pwdNumValid aria-hidden=true></span></li><li ng-class=\"pwdSplCharValid?\'text-success\':\'text-danger\'\" class=text-bold>{{\'signup.msg.13\' | translate}} !@#$%& <span class=\"fa fa-check\" ng-if=pwdSplCharValid aria-hidden=true></span></li></ul></div><div class=form-group><label for=scpw>{{\'signup.label.3\' | translate}}</label><input type=password id=scpw ng-model=signup.cPass class=form-control name=password aria-label=\"{{\'signup.label.3\' | translate}}\" aria-labelledby=\"{{\'signup.label.3\' | translate}}\"></div><div class=form-group><div vc-recaptcha key=publicKey></div></div><button type=button role=button class=\"btn btn-primary\" ng-click=signupFx(signup,userId); ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"glyphicon glyphicon-log-in\" aria-hidden=true ng-if=!authProcessing></span>{{\'signup.btn.1\' | translate}}</button> <button type=button role=button ui-sref=login class=\"btn btn-link\">{{\'signup.btn.2\' | translate}}</button></div></form></div></section><footer class=\"footer noMarL padL10\"><span ng-bind-html=copyRight></span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank id=terms>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank id=privacy>{{\'cm.footer.2\' | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/login/twoFA.html","<section class=wrapper><nav class=\"navbar navbar-fixed-top navbarTop\"><div class=container-fluid><button type=button role=button class=\"navbar-toggle collapsed hide\" ng-click=\"isCollapsed = !isCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=navbar-header><span class=navbar-brand><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo.png> <img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo_square.png class=hide><!-- Theme --> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/logo.png class=hLogo> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/v-logo.png class=\"hLogo hide\"></span></div><div class=\"collapse navbar-collapse in\"><!--uib-collapse=\"!isCollapsed\"--><ul class=\"nav navbar-nav navbar-right\" role=menu aria-labelledby=navList><li role=menuitem uib-dropdown><a href=\"\" role=link id=topNav class=nav-user uib-dropdown-toggle><img alt=\"\" ng-if=\"userImg.uImg !=\'\'\" ng-src={{userImg.uImg}}> <span class=profileIcon-xs ng-if=\"userImg.uImg ==\'\'\">{{userName | limitTo:1}}</span>{{userName | limitTo:25}}<span class=caret></span></a><ul class=\"dropdown-menu nav-user-menu\" uib-dropdown-menu role=menu><li role=menuitem><a href=\"\" role=link id=ssLogOut ng-click=ssLogOutFx(); ng-cloak><span class=\"fa fa-sign-out\" aria-hidden=true></span>{{\'cm.head.menu.5\' | translate}}</a></li></ul></li></ul></div></div></nav><div class=selectServerContainer><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=showTimeoutMsg><span translate=\"{{\'cm.msg.28\'}}\" translate-values=\"{sessionTimer: \'{{sessionTimer}}\',htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></span><br><a href=\"\" role=link id=resetSession class=\"btn-link text-bold\" ng-click=resetSession(true);>{{\'cm.msg.29\' | translate}}</a></div><div class=selectServer><header class=panel-heading ng-cloak><h1 role=heading aria-level=1>{{\'cl.widget.cm.27\' | translate}}</h1></header><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'api\'\" aria-live=polite role=status translate=\"{{\'ss.m1\'}}\" translate-values=\"{by: \'<br>L Squared Support by <a href=\\\'\\\' role=\\\'button\\\' id=\\\'api\\\'>{{\'ss.m1.1\' | translate}}</a>\'}\"></div><div ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'ms.msg.29\' | translate}}</div><div ng-if=\"errType==\'otp\'\" aria-live=polite role=status>{{\'ms.msg.30\' | translate}}</div></div><div class=\"form-group lsn-select\"><label ng-cloak>{{\'ms.label.22\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=curTwoFA.otp aria-label=\"{{\'ms.label.22\' | translate}}\" aria-labelledby=\"{{\'ms.label.22\' | translate}}\" focus-me=true><div class=input-group-btn><button type=button role=button ng-click=\"twoFAFx(\'o\');\" class=\"btn btn-primary\" ng-disabled=authProcessing ng-cloak><span class=fa ng-class=\"authProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.btn.5\' | translate}}</button></div></div></div><a href=\"\" role=link id=showEmail ng-click=\"showEmail=!showEmail\" class=btn-link ng-cloak>{{\'ms.btn.6\' | translate}}</a><div ng-if=showEmail class=marT10><div>{{\'ms.label.26\' | translate}}</div><div class=\"text-bold marB5\">{{auth.email}}</div><a href=\"\" role=link id=twoFA ng-click=\"twoFAFx(\'e\');\" class=text-bold ng-disabled=emailProcessing>{{isEmailSent?\'ms.btn.8\':\'ms.btn.7\' | translate}}</a></div></div></div></div></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank ng-cloak>{{\'cm.footer.2\' | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><h1 role=heading aria-level=1>\'Allo, \'Allo!</h1><p class=lead><img alt=\"I\'m Yeoman\" src=assets/images/yeoman.png><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=main.classAnimation><button type=button role=button class=\"btn btn-lg btn-success\" ng-click=main.showToastr()>Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=row><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=thumbnail><img alt=\"{{ awesomeThing.title }}\" class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\"><div class=caption><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href={{awesomeThing.url}} role=button>{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/reports/ac.html","<div class=row><div class=col-xs-3><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div></div></div><div class=col-xs-12><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"generateReportFx(\'advtClick\');\" ng-disabled=opReportLoading><span ng-if=opReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button></div><div class=col-xs-4><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div>");
$templateCache.put("app/reports/cc.html","<div class=row><div class=col-xs-10><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"reportSelectedItems.devices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><!-- <li ng-repeat=\"device in selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) track by device.id\" data-id=\"{{device.id}}\"> --><li dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} class=noHover><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{thumbHost + tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\" loading=lazy><!-- <span class=\"thumb-icon status\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><!-- <li class=\"row\" ng-repeat=\"device in selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'})\" data-id=\"{{device.id}}\" data-type=\"device\" data-sub-type=\"{{device.type}}\"> --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}}><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div class=col-xs-2><div class=panel-inner-tab>{{\'r.btn.1\' | translate}}</div><div class=\"bg-light pad10\" style=height:300px><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'cc\');\" ng-disabled=\"ccReportLoading || reportSelectedItems.devices.length==0\">{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'cc\');\" ng-disabled=\"ccReportLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/reports/ci.html","<div class=row><div class=col-xs-10><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><!-- <li ng-repeat=\"device in selectedFilteredDevices = (reportSelectedItems.devices) track by device.id\" data-id=\"{{device.id}}\"> --><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><!-- <li class=\"row\" ng-repeat=\"device in selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'})\" data-id=\"{{device.id}}\" data-type=\"device\" data-sub-type=\"{{device.type}}\" ng-if=\"reportSelectedItems.devices.length > 0\"> --><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div class=col-xs-2><div class=panel-inner-tab>{{\'r.btn.1\' | translate}}</div><div class=\"bg-light pad10\" style=height:300px><!-- <div class=\"form-group hide\">\r\n        <label for=\"dateRange\">{{\'cm.label.36\' | translate}}</label>\r\n        <div class=\"input-group\" ng-class=\"{\'has-error\':(hasErr && errType==\'dateRange\')}\" uib-tooltip=\"{{dateMsg}}\" tooltip-enable=\"(hasErr && errType==\'dateRange\')\" tooltip-placement=\"bottom\">\r\n          <span class=\"input-group-addon\"><span class=\"fa fa-calendar\" aria-hidden=\"true\"></span></span>\r\n          <input type=\"daterange\" id=\"dateRange\" class=\"form-control picker\" ng-model=\"report.info.dateRange\" format=\"MM/DD/YYYY\" max-date=\"{{maxDate}}\" opens=\"left\" readonly=\"\" aria-label=\"dateRange\" aria-labelledby=\"dateRange\">\r\n        </div>\r\n      </div> --> <button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'ci\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\">{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'ci\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/reports/content.html","<div class=row><div class=col-xs-12><div class=spaceH></div><section><header class=panel-inner-tab><a ui-sref-active=selected ui-sref=.cc role=button ng-if=auth.upermissions.rcc ng-click=subTabChangeFx();>{{\'r.tab.1.1\' | translate}}</a> <a ui-sref-active=selected ui-sref=.cs role=button ng-if=auth.upermissions.rcs ng-click=subTabChangeFx();>{{\'r.tab.1.2\' | translate}}</a> <a ui-sref-active=selected ui-sref=.pp role=button ng-if=auth.upermissions.rpp ng-click=subTabChangeFx();>{{\'r.tab.1.3\' | translate}}</a></header><div class=\"panel-body marT15\"><div ui-view=tabView></div></div></section></div></div>");
$templateCache.put("app/reports/cs.html","<div class=row><div class=col-xs-10><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><div ng-if=\"reportSelectedItems.devices.length > 0\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices |itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}}><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div class=col-xs-2><div class=panel-inner-tab>{{\'cm.label.14\' | translate}}</div><div class=\"bg-light pad10\" style=height:300px><div class=form-group><label for=dateRange>{{\'r.label.1\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY opens=left singledatepicker=true readonly aria-label=dateRange aria-labelledby=dateRange></div></div><div><label><input type=radio role=radio name=csFrameType value=a ng-model=report.info.csFrameType><label></label>{{\'r.label.6\' | translate}}</label></div><div><label><input type=radio role=radio name=csFrameType value=c ng-model=report.info.csFrameType><label></label>{{\'r.label.7\' | translate}}</label></div><div>&nbsp;</div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'cs\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\">{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'cs\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/reports/device.html","<div class=row><div class=col-xs-12><div class=spaceH></div><section><header class=\"panel-inner-tab d-flex text-center noPadB\" aria-orientation=horizontal><a ui-sref-active=selected ui-sref=.ds role=tab ng-if=auth.upermissions.rds ng-click=\"loadSubTab(\'ds\');subTabChangeFx();\">{{\'r.tab.2.1\' | translate}}</a> <a ui-sref-active=selected ui-sref=.hg role=tab ng-if=auth.upermissions.rhg ng-click=\"loadSubTab(\'hg\');subTabChangeFx();\">{{\'r.tab.2.2\' | translate}}</a> <a ui-sref-active=selected ui-sref=.ir role=tab ng-if=auth.upermissions.ir ng-click=\"loadSubTab(\'ir\');subTabChangeFx();\">{{\'r.tab.2.5\' | translate}}</a> <a ui-sref-active=selected ui-sref=.od role=tab ng-if=auth.upermissions.rod ng-click=\"loadSubTab(\'od\');subTabChangeFx();\">{{\'r.tab.2.3\' | translate}}</a> <a ui-sref-active=selected ui-sref=.op role=tab ng-if=auth.upermissions.rop ng-click=\"loadSubTab(\'op\');subTabChangeFx();\">{{\'r.tab.2.4\' | translate}}</a> <a ui-sref-active=selected ui-sref=.dst role=tab ng-if=auth.upermissions.rdst ng-click=\"loadSubTab(\'dst\');subTabChangeFx();\">{{\'r.tab.2.6\' | translate}}</a> <a ui-sref-active=selected ui-sref=.poh role=tab ng-if=auth.upermissions.rpoh ng-click=\"loadSubTab(\'poh\');subTabChangeFx();\">{{\'r.tab.2.7\' | translate}}</a> <a ui-sref-active=selected ui-sref=.hk role=tab ng-if=auth.upermissions.rhk ng-click=\"loadSubTab(\'hk\');subTabChangeFx();\">{{\'r.tab.2.8\' | translate}}</a> <a ui-sref-active=selected ui-sref=.ci role=tab ng-if=auth.upermissions.ci ng-click=\"loadSubTab(\'ci\');subTabChangeFx();\">{{\'r.tab.7\' | translate}}</a></header><div class=pull-right></div><div class=\"panel-body marT15\"><div ui-view=tabView></div></div></section></div></div>");
$templateCache.put("app/reports/ds.html","<div class=row><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-8\': \'col-xs-10\'\"><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-4\': \'col-xs-2\'\"><div class=panel-inner-tab>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"bg-light pad10\" style=height:300px><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group ng-class=\"{\'has-error\':(hasErr && errType==\'dateRange\')}\" uib-tooltip={{dateMsg}} tooltip-enable=\"(hasErr && errType==\'dateRange\')\" tooltip-placement=bottom><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange ng-change=checkHaveReportFx(report.info.dateRange) format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div><div class=\"msg-warning marT10\" ng-if=notMatchDateRange>{{\'r.msg.14\' | translate}}</div></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'ds\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\"><span ng-if=\"dsReportLoading || chartLoading\" class=\"fa fa-repeat fa-spin\" aria-hidden=true></span>{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'ds\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div><div class=\"form-group noMarB marT10\" ng-if=\"auth.upermissions.drg == \'v2\'\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("app/reports/dst.html","<div class=row><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-8\': \'col-xs-10\'\"><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-4\': \'col-xs-2\'\"><div class=panel-inner-tab ng-if=\"reportSelectedItems.devices.length > 1\">{{\'cm.label.7\' | translate | camelCase}}</div><div class=panel-inner-tab ng-if=\"!reportSelectedItems.devices.length || reportSelectedItems.devices.length == 1\">{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"bg-light pad10\" style=height:300px><div class=form-group ng-if=\"reportSelectedItems.devices.length > 1\"><label for=dateRange>{{\'r.label.1\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.curDateRange ng-click=resetSingleDateFx(); singledatepicker=true format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div></div><div class=form-group ng-if=\"!reportSelectedItems.devices.length || reportSelectedItems.devices.length == 1\"><label for=dateRange1>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange1 class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange1 aria-labelledby=dateRange1></div><!-- <div class=\"msg-warning marT10\" ng-if=\"notMatchDateRange\">{{\'r.msg.14\' | translate}}</div> --></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'dst\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\"><span ng-if=\"dstReportLoading || chartLoading\" class=\"fa fa-repeat fa-spin\" aria-hidden=true></span>{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'dst\');\" ng-disabled=\"chartLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div><div class=\"form-group noMarB marT10\" ng-if=\"auth.upermissions.drg == \'v2\'\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("app/reports/es.html","<div class=row><div class=col-xs-3><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div></div></div><div class=col-xs-12><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"generateReportFx(\'mailSent\');\" ng-disabled=opReportLoading><span ng-if=opReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button></div><div class=col-xs-4><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div>");
$templateCache.put("app/reports/hdpp.html","<div class=row><div class=col-xs-5><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'280px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'315px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'350px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div class=col-xs-5><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectContent()>{{\'cm.label.32\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.1\' | translate}}</div><div class=\"bg-light pad10\"><div class=overflow-auto ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'280px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'315px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'350px\'}\"><div ng-if=\"reportSelectedItems.content.length > 0\"><ul class=\"list-inline thumb-list noHover\" ng-if=\"uPreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (reportSelectedItems.content)\" data-id={{device.id}}><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\'\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"><!-- Images title=\"{{content.label}}\"--> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- YouTube title=\"{{content.label}}\"--> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{content.label}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list\" ng-if=\"uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"reportSelectedItems.content.length > 0\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-3\">{{\'cm.brief.2\' | translate}}</div>\r\n              <div class=\"col-xs-3\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-4>{{\'cm.label.69\' | translate}}</div><!-- <div class=\"col-xs-1 text-right noPad\">{{\'cm.brief.12\' | translate}}</div>\r\n              <div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div> --></div><li class=\"row noHover\" ng-repeat=\"content in filteredContentList = (reportSelectedItems.content)\"><div class=\"col-xs-8 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> </span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-3\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n              <div class=\"col-xs-3 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-4 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><!-- <div class=\"col-xs-1 text-right noPad text-sm\">{{(content.pSize) | filesize}}</div>\r\n              <div class=\"col-xs-2 text-right text-sm\">{{content.d}}</div> --></li></ul></div></div></div></div><div class=col-xs-2><div class=panel-inner-tab>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"bg-light pad10\" ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'300px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'335px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'370px\'}\"><div class=form-group ng-class=\"{\'has-error\':(hasErr && errType==\'dateRange\')}\" uib-tooltip={{dateMsg}} tooltip-enable=\"(hasErr && errType==\'dateRange\')\" tooltip-placement=bottom><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'hdpp\');\" ng-disabled=\"chartLoading || (reportSelectedItems.devices.length == 0 || reportSelectedItems.content.length == 0)\">{{\'r.btn.1\' | translate}}</button><div class=\"errMsg pull-right marT10\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div></div>");
$templateCache.put("app/reports/hg.html","<div class=row><div class=col-xs-12><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=hgReportType ng-model=report.info.dType value=d ng-click=\"loadSubTab(\'dh\')\"><label></label>{{\'r.tab.2.2.1\' | translate}}</label><label class=marRL10><input type=radio role=radio name=hgReportType ng-model=report.info.dType value=dh ng-click=\"loadSubTab(\'dt\')\"><label></label>{{\'r.tab.2.2.2\' | translate}}</label><label><input type=radio role=radio name=hgReportType ng-model=report.info.dType value=bl ng-click=\"loadSubTab(\'bl\')\"><label></label>{{\'r.tab.2.2.4\' | translate}}</label></div></div></div><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-8\': \'col-xs-10\'\"><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-4\': \'col-xs-2\'\"><div class=panel-inner-tab>{{report.info.dType == \'bl\'?\'r.btn.1\':\'cm.label.9\' | translate | camelCase}}</div><div class=\"bg-light pad10\" style=height:300px><div class=form-group ng-if=\"report.info.dType != \'bl\'\" ng-class=\"{\'has-error\':(hasErr && errType==\'dateRange\')}\" uib-tooltip={{dateMsg}} tooltip-enable=\"(hasErr && errType==\'dateRange\')\" tooltip-placement=bottom><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group ng-class=\"{\'has-error\':(hasErr && errType==\'maxDay\')}\" uib-tooltip={{dayMsg}} tooltip-enable=\"(hasErr && errType==\'maxDay\')\" tooltip-placement=bottom><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange ng-change=checkHaveReportFx(report.info.dateRange) format=MM/DD/YYYY limit=\"31 days\" max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div><div class=\"msg-warning marT10\" ng-if=notMatchDateRange>{{\'r.msg.14\' | translate}}</div></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'hg\');\" ng-disabled=\"hgReportLoading || reportSelectedItems.devices.length == 0\"><span ng-if=hgReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=\"report.info.dType != \'bl\' && auth.upermissions.drg == \'v1\'\">{{\'r.msg.11\' | translate}}</div><div class=\"form-group noMarB marT10\" ng-if=\"report.info.dType != \'bl\' && auth.upermissions.drg == \'v2\'\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("app/reports/hk.html","<div class=row><div class=col-xs-5><div class=row><div class=col-xs-7><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div></div></div><div class=\"col-xs-12 hide\" ng-if=\"statusLoading || inProcessTaskList.length\"><div class=form-group><label for=dateRange>{{\'r.label.21\' | translate}} [ {{inProcessTaskList.length}} ]</label><div class=\"scrollQuad table no-th reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(440)}}px><img alt=Loading src=assets/images/loading.gif ng-if=statusLoading><div class=\"row marB5\" ng-repeat=\"item in inProcessTaskList\" ng-if=!statusLoading><div class=\"col-xs-6 text-ellipsis\"><span uib-tooltip=\"{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=ng-binding>{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-6 text-right\"><div ng-if=\"item.s == \'pen\'\">{{\'em.body.8\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'fet\'\">{{\'r.label.23\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'pro\'\" class=d-flex><div style=\"width:100%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#cccccc\'}};height:fit-content\"><div style=\"width: {{item.p}}%\" uib-tooltip={{item.p}} tooltip-append-to-body=true tooltip-popup-delay=500><span class=rectangle-pie ng-if=\"item.p != \'0\'\">{{item.p}}%</span> <span class=rectangle-pie ng-if=\"item.p == \'0\'\"></span></div></div><a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><!-- <div ng-if=\"item.s == \'fail\'\" class=\"text-sm\">\r\n                  <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"reportActionOpen(\'retry\', item.id);\">{{\'cl.p_c.7\' | translate}}</button> \r\n                </div> --><!-- <div ng-if=\"item.s == \'noData\'\" class=\"text-sm text-muted\"> --><div ng-if=\"item.s == \'fail\'\" class=\"text-sm text-muted\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"item.s == \'success\'\"><a href={{item.url}} role=link target=_blank download><div class=\"btn btn-primary btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><!-- <a href=\"{{item.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a> --></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"generateReportFx(\'hk\');\" ng-disabled=hkReportLoading><span ng-if=hkReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button></div><div class=\"form-group noMarB marT10\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div></div></div><div class=col-xs-2></div><div class=\"col-xs-5 bg-light hide\" ng-if=reportHistory.length><div class=form-group><h4>{{\'r.label.20\' | translate}} <span class=text-sm>[ {{reportHistory.length}} ]</span></h4><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"reportHistory.length && !historyLoading\"><div class=\"table table-md bg-white\"><div class=\"scrollQuad reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(386)}}px><div class=\"row stickyHeader\"><div class=col-xs-4>{{\'r.label.22\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"hs in filteredHistory = (reportHistory | customSearch:{key:searchTextPopup, module:\'cdtg\'})\"><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip=\"{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}</span></div><div class=\"col-xs-5 text-ellipsis\"><span uib-tooltip=\"{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-3 text-right\"><a href={{hs.url}} role=link target=_blank download><div class=\"btn btn-default btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><button type=button role=button class=\"btn btn-xs btn-danger marL5\" ng-click=\"reportActionOpen(\'d\', hs.id);\">{{\'cm.btn.13\' | translate}}</button><!-- <a href=\"{{hs.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a>  --></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistory.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"msg-warning marT10\" ng-if=\"!reportHistory.length && !historyLoading\" lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div></div>");
$templateCache.put("app/reports/ir.html","<div class=row><div class=col-xs-5><div class=row><div class=\"col-xs-7 marB15\"><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"openGroupDevices(\'ir\',\'\');\" ng-disabled=irReportLoading><span ng-if=irReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button></div><div class=\"col-xs-12 hide\" ng-if=\"statusLoading || inProcessTaskList.length\"><div class=form-group><label for=dateRange>{{\'r.label.21\' | translate}} [ {{inProcessTaskList.length}} ]</label><div class=\"scrollQuad table no-th reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(440)}}px><img alt=Loading src=assets/images/loading.gif ng-if=statusLoading><div class=\"row marB5\" ng-repeat=\"item in inProcessTaskList\" ng-if=!statusLoading><div class=\"col-xs-6 text-ellipsis\"><span uib-tooltip=\"{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=ng-binding>{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-6 text-right\"><div ng-if=\"item.s == \'pen\'\">{{\'em.body.8\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'fet\'\">{{\'r.label.23\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'pro\'\" class=d-flex><div style=\"width:100%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#cccccc\'}};height:fit-content\"><div style=\"width: {{item.p}}%\" uib-tooltip={{item.p}} tooltip-append-to-body=true tooltip-popup-delay=500><span class=rectangle-pie ng-if=\"item.p != \'0\'\">{{item.p}}%</span> <span class=rectangle-pie ng-if=\"item.p == \'0\'\"></span></div></div><a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><!-- <div ng-if=\"item.s == \'fail\'\" class=\"text-sm\">\r\n                  <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"reportActionOpen(\'retry\', item.id);\">{{\'cl.p_c.7\' | translate}}</button> \r\n                </div> --><!-- <div ng-if=\"item.s == \'noData\'\" class=\"text-sm text-muted\"> --><div ng-if=\"item.s == \'fail\'\" class=\"text-sm text-muted\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"item.s == \'success\'\"><a href={{item.url}} role=link target=_blank download><div class=\"btn btn-primary btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><!-- <a href=\"{{item.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a> --></div></div></div></div></div></div><div class=col-xs-7><div class=\"errMsg pull-left marT10\" ng-if=hasErrEx aria-live=polite role=status><span ng-if=\"errTypeEx==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span></div></div></div></div><div class=col-xs-2></div><div class=\"col-xs-5 bg-light hide\" ng-if=reportHistory.length><div class=form-group><h4>{{\'r.label.20\' | translate}} <span class=text-sm>[ {{reportHistory.length}} ]</span></h4><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"reportHistory.length && !historyLoading\"><div class=\"table table-md bg-white\"><div class=\"scrollQuad reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(386)}}px><div class=\"row stickyHeader\"><div class=col-xs-4>{{\'r.label.22\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"hs in filteredHistory = (reportHistory | customSearch:{key:searchTextPopup, module:\'cdtg\'})\"><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip=\"{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}</span></div><div class=\"col-xs-5 text-ellipsis\"><span uib-tooltip=\"{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-3 text-right\"><a href={{hs.url}} role=link target=_blank download><div class=\"btn btn-default btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><button type=button role=button class=\"btn btn-xs btn-danger marL5\" ng-click=\"reportActionOpen(\'d\', hs.id);\">{{\'cm.btn.13\' | translate}}</button><!-- <a href=\"{{hs.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a>  --></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistory.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"msg-warning marT10\" ng-if=\"!reportHistory.length && !historyLoading\" lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div></div>");
$templateCache.put("app/reports/od.html","<div class=row><div class=col-xs-5><div class=row><div class=col-xs-7><div class=form-group><label for=hour>{{\'r.label.9\' | translate}}</label><div class=input-group><input type=number id=hour class=form-control ng-model=report.hour min=1 aria-label=\"{{\'r.label.9\' | translate}}\" aria-labelledby=\"{{\'r.label.9\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.29s\' | translate}}</span></div></div></div><div class=col-xs-12 ng-if=\"statusLoading || inProcessTaskList.length\"><div class=form-group><label for=dateRange>{{\'r.label.21\' | translate}} [ {{inProcessTaskList.length}} ]</label><div class=\"scrollQuad table no-th reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(440)}}px><img alt=Loading src=assets/images/loading.gif ng-if=statusLoading><div class=\"row marB5\" ng-repeat=\"item in inProcessTaskList\" ng-if=!statusLoading><div class=\"col-xs-6 text-ellipsis\"><span uib-tooltip=\"{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=ng-binding>{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-6 text-right\"><div ng-if=\"item.s == \'pen\'\">{{\'em.body.8\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'fet\'\">{{\'r.label.23\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'pro\'\" class=d-flex><div style=\"width:100%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#cccccc\'}};height:fit-content\"><div style=\"width: {{item.p}}%\" uib-tooltip={{item.p}} tooltip-append-to-body=true tooltip-popup-delay=500><span class=rectangle-pie ng-if=\"item.p != \'0\'\">{{item.p}}%</span> <span class=rectangle-pie ng-if=\"item.p == \'0\'\"></span></div></div><a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><!-- <div ng-if=\"item.s == \'fail\'\" class=\"text-sm\">\r\n                  <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"reportActionOpen(\'retry\', item.id);\">{{\'cl.p_c.7\' | translate}}</button> \r\n                </div> --><!-- <div ng-if=\"item.s == \'noData\'\" class=\"text-sm text-muted\"> --><div ng-if=\"item.s == \'fail\'\" class=\"text-sm text-muted\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"item.s == \'success\'\"><a href={{item.url}} role=link target=_blank download><div class=\"btn btn-primary btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><!-- <a href=\"{{item.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a> --></div></div></div></div></div></div><div class=col-xs-7><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-primary marB2\" role=button ng-click=\"generateReportFx(\'od\');\" ng-disabled=odReportLoading><span ng-if=odReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link marB2\" role=button ng-click=\"subscribeOpen(\'od\');\" ng-disabled=\"odReportLoading || !report.hour\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div><div class=\"form-group noMarB\"><div class=\"errMsg marT10\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'hour\'\" aria-live=polite role=status>{{\'r.msg.8\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span></div></div></div></div></div><div class=col-xs-2></div><div class=\"col-xs-5 bg-light\" ng-if=reportHistory.length><div class=form-group><h4>{{\'r.label.20\' | translate}} <span class=text-sm>[ {{reportHistory.length}} ]</span></h4><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"reportHistory.length && !historyLoading\"><div class=\"table table-md bg-white\"><div class=\"scrollQuad reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(386)}}px><div class=\"row stickyHeader\"><div class=col-xs-4>{{\'r.label.22\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"hs in filteredHistory = (reportHistory | customSearch:{key:searchTextPopup, module:\'cdtg\'})\"><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip=\"{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}</span></div><div class=\"col-xs-5 text-ellipsis\"><span uib-tooltip=\"{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-3 text-right\"><a href={{hs.url}} role=link target=_blank download><div class=\"btn btn-default btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><button type=button role=button class=\"btn btn-xs btn-danger marL5\" ng-click=\"reportActionOpen(\'d\', hs.id);\">{{\'cm.btn.13\' | translate}}</button><!-- <a href=\"{{hs.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a>  --></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistory.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"msg-warning marT10\" ng-if=\"!reportHistory.length && !historyLoading\" lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div></div>");
$templateCache.put("app/reports/op.html","<div class=row><div class=col-xs-5><div class=row><div class=col-xs-7><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange ng-change=checkHaveReportFx(report.info.dateRange) format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div><div class=\"msg-warning marT10\" ng-if=notMatchDateRange>{{\'r.msg.14\' | translate}}</div></div><div class=form-group><label><input type=checkbox ng-model=report.info.online role=checkbox><label></label>{{\'r.label.8\' | translate}}</label></div></div><div class=col-xs-12 ng-if=\"statusLoading || inProcessTaskList.length\"><div class=form-group><label for=dateRange>{{\'r.label.21\' | translate}} [ {{inProcessTaskList.length}} ]</label><div class=\"scrollQuad table no-th reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(440)}}px><img alt=Loading src=assets/images/loading.gif ng-if=statusLoading><div class=\"row marB5\" ng-repeat=\"item in inProcessTaskList\" ng-if=!statusLoading><div class=\"col-xs-6 text-ellipsis\"><span uib-tooltip=\"{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=ng-binding>{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-6 text-right\"><div ng-if=\"item.s == \'pen\'\">{{\'em.body.8\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'fet\'\">{{\'r.label.23\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'pro\'\" class=d-flex><div style=\"width:100%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#cccccc\'}};height:fit-content\"><div style=\"width: {{item.p}}%\" uib-tooltip={{item.p}} tooltip-append-to-body=true tooltip-popup-delay=500><span class=rectangle-pie ng-if=\"item.p != \'0\'\">{{item.p}}%</span> <span class=rectangle-pie ng-if=\"item.p == \'0\'\"></span></div></div><a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><!-- <div ng-if=\"item.s == \'fail\'\" class=\"text-sm\">\r\n                  <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"reportActionOpen(\'retry\', item.id);\">{{\'cl.p_c.7\' | translate}}</button> \r\n                </div> --><!-- <div ng-if=\"item.s == \'noData\'\" class=\"text-sm text-muted\"> --><div ng-if=\"item.s == \'fail\'\" class=\"text-sm text-muted\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"item.s == \'success\'\"><a href={{item.url}} role=link target=_blank download><div class=\"btn btn-primary btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><!-- <a href=\"{{item.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a> --></div></div></div></div></div></div><div class=col-xs-7><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"generateReportFx(\'op\');\" ng-disabled=opReportLoading><span ng-if=opReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link marB2\" ng-click=\"subscribeOpen(\'op\');\" ng-disabled=opReportLoading ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div><!-- <div class=\"form-group noMarB marT10\" ng-if=\"auth.upermissions.drg == \'v2\'\"> --><div class=\"form-group noMarB marT10\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div></div></div><div class=col-xs-2></div><div class=\"col-xs-5 bg-light\" ng-if=reportHistory.length><div class=form-group><h4>{{\'r.label.20\' | translate}} <span class=text-sm>[ {{reportHistory.length}} ]</span></h4><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"reportHistory.length && !historyLoading\"><div class=\"table table-md bg-white\"><div class=\"scrollQuad reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(386)}}px><div class=\"row stickyHeader\"><div class=col-xs-4>{{\'r.label.22\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=\"row reportHS\" data-id={{hs.id}} ng-repeat=\"hs in filteredHistory = (reportHistory | customSearch:{key:searchTextPopup, module:\'cdtg\'})\"><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip=\"{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}</span></div><div class=\"col-xs-5 text-ellipsis\"><span uib-tooltip=\"{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-3 text-right\"><a href={{hs.url}} role=link target=_blank download><div class=\"btn btn-default btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><button type=button role=button class=\"btn btn-xs btn-danger marL5 marL5\" ng-click=\"reportActionOpen(\'d\', hs.id);\">{{\'cm.btn.13\' | translate}}</button><!-- <a href=\"{{hs.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a>  --></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistory.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"msg-warning marT10\" ng-if=\"!reportHistory.length && !historyLoading\" lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div></div>");
$templateCache.put("app/reports/poh.html","<div class=row><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-8\': \'col-xs-10\'\"><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto style=height:280px><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div ng-class=\"auth.upermissions.drg == \'v2\'? \'col-xs-4\': \'col-xs-2\'\"><div class=panel-inner-tab>{{\'r.btn.1\' | translate | camelCase}}</div><!-- <div class=\"panel-inner-tab\">{{\'cm.label.9\' | translate | camelCase}}</div> --><div class=\"bg-light pad10\" style=height:300px><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'poh\');\" ng-disabled=\"pohReportLoading || reportSelectedItems.devices.length==0\"><span ng-if=pohReportLoading class=\"fa fa-repeat fa-spin\" aria-hidden=true></span>{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'poh\');\" ng-disabled=\"pohReportLoading || reportSelectedItems.devices.length==0\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div><div class=\"form-group noMarB marT10\"><div class=errMsg ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("app/reports/pp.html","<div class=row><div class=col-xs-5><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectDevice();>{{\'cm.label.31s\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.4s\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'280px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'315px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'350px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=deviceUpdating><div ng-if=\"reportSelectedItems.devices.length > 0 && !deviceUpdating\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'dSel\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"selectedFilteredDevices.length>0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><ul class=\"list-inline thumb-list noHover\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = (reportSelectedItems.devices | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}}><div class=thumb-img><span class=\"thumb-inner thumb-device\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.h | removeColon) + \'.jpg&\'+ device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png class=\"img-responsive center-block blackBdr\"><!-- <span class=\"thumb-icon status\" ng-if=\"device.lp\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=thumb-label uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list marT10\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><!-- device list view --><div class=\"row th\"><div class=col-xs-8>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearchText, module:\'d\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-8 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div></li></ul></div></div></div></div><div class=col-xs-5><button type=button role=button class=\"btn btn-xs btn-primary pull-right\" ng-click=selectContent()>{{\'cm.label.32\' | translate | camelCase}}</button><div class=panel-inner-tab>{{\'cm.label.1\' | translate}} [ {{reportSelectedItems.content.length}} ]</div><div class=\"bg-light pad10\"><div class=overflow-auto ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'280px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'315px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'350px\'}\"><div ng-if=\"reportSelectedItems.content.length > 0\"><ul class=\"list-inline thumb-list noHover\" ng-if=\"uPreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (reportSelectedItems.content)\" data-id={{device.id}}><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':content.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png?v7 class=\"img-responsive center-block\"><!-- Web Page Widget--> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block\"> <a href=\"\" role=link ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss\" ng-href=\"{{cDetailBucket + content.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{content.label}}><img alt={{content.type}} ng-src=\"{{tim + cBucket + content.ssImg +\'?v\'+ timestamp + thumbParam}}\" class=\"img-responsive center-block\"> </a><!-- Images title=\"{{content.label}}\"--> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube title=\"{{content.label}}\"--> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{content.label}}</div></li></ul><ul class=\"table table-md report-selectable list-unstyled cl-list\" ng-if=\"uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"reportSelectedItems.content.length > 0\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-3\">{{\'cm.brief.2\' | translate}}</div>\r\n              <div class=\"col-xs-3\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-4>{{\'cm.label.69\' | translate}}</div><!-- <div class=\"col-xs-1 text-right noPad\">{{\'cm.brief.12\' | translate}}</div>\r\n              <div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div> --></div><li class=\"row noHover\" ng-repeat=\"content in filteredContentList = (reportSelectedItems.content)\"><div class=\"col-xs-8 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> </span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-3\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n              <div class=\"col-xs-3 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-4 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><!-- <div class=\"col-xs-1 text-right noPad text-sm\">{{(content.pSize) | filesize}}</div>\r\n              <div class=\"col-xs-2 text-right text-sm\">{{content.d}}</div> --></li></ul></div></div></div></div><div class=col-xs-2><div class=panel-inner-tab>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"bg-light pad10\" ng-style=\"report.info.timeRangeType==\'a\' && {\'height\':\'300px\'} || (report.info.timeRangeType==\'c\' && !report.info.loopOpt) && {\'height\':\'335px\'} || (report.info.timeRangeType==\'c\' && report.info.loopOpt) && {\'height\':\'370px\'}\"><div class=form-group ng-class=\"{\'has-error\':(hasErr && errType==\'dateRange\')}\" uib-tooltip={{dateMsg}} tooltip-enable=\"(hasErr && errType==\'dateRange\')\" tooltip-placement=bottom><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} opens=left readonly aria-label=dateRange aria-labelledby=dateRange></div></div><div class=form-group ng-class=\"{\'has-error\':(hasErr && errType==\'time\' && report.info.timeRangeType==\'c\')}\" uib-tooltip={{timeMsg}} tooltip-enable=\"(hasErr && errType==\'time\' && report.info.timeRangeType==\'c\')\" tooltip-placement=bottom><label>{{\'r.label.2\' | translate}}</label><div><label class=marR10><input type=radio role=radio name=timeRangeType value=a ng-model=report.info.timeRangeType><label></label>{{\'r.label.3\' | translate}}</label><label ng-class=\"{\'noMarB\': report.info.timeRangeType == \'a\'}\"><input type=radio role=radio name=timeRangeType value=c ng-model=report.info.timeRangeType><label></label>{{\'cm.label.17\' | translate}}</label><div ng-if=\"report.info.timeRangeType==\'c\'\"><span uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=input-group><label for=sTime class=\"lableHidden absolute\">search</label><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=sTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"report.info.sTime | date:\'shortTime\'\" readonly aria-label=\"Start Time\" aria-labelledby=\"Start Time\"></div><div class=\"dropdown-menu dropdown-to-body\" uib-dropdown-menu placement=\"right bottom\"><div uib-timepicker ng-model=report.info.sTime hour-step=1 minute-step=5></div></div></span><div class=\"text-center text-sm pad5\">{{\'r.label.4\' | translate}}</div><span uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=input-group><label for=eTime class=\"lableHidden absolute\">search</label><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=eTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"report.info.eTime | date:\'shortTime\'\" readonly aria-label=\"End Time\" aria-labelledby=\"End Time\"></div><div class=\"dropdown-menu dropdown-to-body\" uib-dropdown-menu placement=\"right bottom\"><div uib-timepicker ng-model=report.info.eTime hour-step=1 minute-step=5></div></div></span></div></div></div><div class=form-group ng-class=\"{\'has-error\':(hasErr && errType==\'loop\' && report.info.loopOpt)}\" uib-tooltip={{loopLength}} tooltip-enable=\"(hasErr && errType==\'loop\' && report.info.loopOpt)\" tooltip-placement=bottom><label ng-class=\"{\'noMarB\': !report.info.loopOpt}\"><input type=checkbox ng-model=report.info.loopOpt role=checkbox><label></label>{{\'r.label.5\' | translate}}</label><div class=input-group ng-if=report.info.loopOpt><input type=number id=loop class=form-control ng-model=report.info.loopLength min=1><div class=input-group-addon>{{\'cm.label.75\' | translate}}</div></div></div><button type=button role=button class=\"btn btn-block btn-primary\" ng-click=\"generateReportFx(\'pp\');\" ng-disabled=\"chartLoading || (reportSelectedItems.devices.length == 0 && reportSelectedItems.content.length == 0)\">{{\'r.btn.1\' | translate}}</button><div class=\"text-center marT5\"><button type=button role=button class=\"btn btn-link\" ng-click=\"subscribeOpen(\'pp\');\" ng-disabled=\"chartLoading || (reportSelectedItems.devices.length == 0 && reportSelectedItems.content.length == 0)\" ng-if=auth.upermissions.rs>{{\'r.ph.2\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/reports/reports.html","<section class=panel><header class=\"panel-heading panel-tab\">{{tabCR = (selectedTab==\'hub.reports.c.cc\' || selectedTab==\'hub.reports.c.cs\' || selectedTab==\'hub.reports.c.pp\'); \'\'}} {{tabDR = (selectedTab==\'hub.reports.d.ds\' || selectedTab==\'hub.reports.d.hg\' || selectedTab==\'hub.reports.d.ir\' || selectedTab==\'hub.reports.d.od\' || selectedTab==\'hub.reports.d.op\' || selectedTab==\'hub.reports.d.dst\' || selectedTab==\'hub.reports.d.poh\' || selectedTab==\'hub.reports.d.hk\' || selectedTab == \'hub.reports.d.ci\'); \'\'}} {{tabHDS = (selectedTab==\'hub.reports.hds.pp\' || selectedTab==\'hub.reports.hds.es\' || selectedTab==\'hub.reports.hds.rv\' || selectedTab==\'hub.reports.hds.ac\'); \'\'}}<ul class=\"nav nav-tabs r\" role=tablist aria-owns=\"tab-cr tab-dr tab-hds tab-subs\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li class=tab-success role=tab aria-selected={{tabCR}} aria-controls=tab-cr id=tab-cr ng-class=\"{\'active\':tabCR}\" ng-if=\"auth.upermissions.rcc || auth.upermissions.rcs || auth.upermissions.rpp\"><a href=\"\" role=link ng-click=\"loadReportSubTab(\'c\')\">{{\'r.tab.1\' | translate}}</a></li><li class=tab-success role=tab aria-selected={{tabDR}} aria-controls=tab-dr id=tab-dr ng-class=\"{\'active\':tabDR}\" ng-if=\"auth.upermissions.rds || auth.upermissions.rhg || auth.upermissions.rod || auth.upermissions.rop || auth.upermissions.ir || auth.upermissions.rdst || auth.upermissions.rpoh || auth.upermissions.rhk || auth.upermissions.ci\"><a href=\"\" role=link ng-click=\"loadReportSubTab(\'d\')\">{{\'r.tab.2\' | translate}}</a></li><li class=tab-success role=tab aria-selected={{tabHDS}} aria-controls=tab-hds id=tab-hds ng-class=\"{\'active\':tabHDS}\" ng-if=auth.upermissions.hds><a href=\"\" role=link ng-click=\"loadReportSubTab(\'hds\')\">{{\'r.tab.6\' | translate}}</a></li><li class=tab-info role=tab aria-selected=\"{{$state.includes(\'hub.reports.s\')}}\" aria-controls=tab-subs id=tab-subs ui-sref-active=active ng-if=auth.upermissions.rs><a ui-sref=.s role=tab>{{\'r.tab.3\' | translate}}</a></li></ul><div class=panel-tools ng-if=\"selectedTab != \'hub.reports.op\' && selectedTab != \'hub.reports.od\' && selectedTab != \'hub.reports.cc\' && selectedTab != \'hub.reports.pod\' && selectedTab != \'hub.reports.s\' && selectedTab != \'hub.reports.hds.ac\' && selectedTab != \'hub.reports.hds.rv\' && selectedTab != \'hub.reports.hds.es\' && selectedTab != \'hub.reports.hk\' && selectedTab != \'hub.reports.d.ci\'\"><div class=pull-right uib-dropdown><a href=\"\" role=button id=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=tablist aria-owns=\"tab-ccc tab-ccs tab-cpp tab-dds tab-dhg tab-dir tab-dod tab-dop tab-ddst tab-dpoh tab-dhk tab-hdspp\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.c.cc\')}}\" aria-controls=tab-ccc id=tab-ccc ng-if=\"selectedTab==\'hub.reports.c.cc\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'cc\');\" translate=\"{{\'r.tool.1.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.c.cs\')}}\" aria-controls=tab-ccs id=tab-ccs ng-if=\"selectedTab==\'hub.reports.c.cs\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'cs\');\" translate=\"{{\'r.tool.1.2\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.c.pp\')}}\" aria-controls=tab-cpp id=tab-cpp ng-if=\"selectedTab==\'hub.reports.c.pp\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'pp\');\" translate=\"{{\'r.tool.1.3\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.ds\')}}\" aria-controls=tab-dds id=tab-dds ng-if=\"selectedTab==\'hub.reports.d.ds\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'ds\');\" translate=\"{{\'r.tool.2.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.hg\')}}\" aria-controls=tab-dhg id=tab-dhg ng-if=\"selectedTab==\'hub.reports.d.hg\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'hg\');\" translate=\"{{\'r.tool.2.2\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.ir\')}}\" aria-controls=tab-dir id=tab-dir ng-if=\"selectedTab==\'hub.reports.d.ir\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'ir\');\" translate=\"{{\'r.tool.2.5\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.od\')}}\" aria-controls=tab-dod id=tab-dod ng-if=\"selectedTab==\'hub.reports.d.od\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'od\');\" translate=\"{{\'r.tool.2.3\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.op\')}}\" aria-controls=tab-dop id=tab-dop ng-if=\"selectedTab==\'hub.reports.d.op\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'op\');\" translate=\"{{\'r.tool.2.4\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.dst\')}}\" aria-controls=tab-ddst id=tab-dds ng-if=\"selectedTab==\'hub.reports.d.dst\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'dst\');\" translate=\"{{\'r.tool.2.6\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.poh\')}}\" aria-controls=tab-dpoh id=tab-dpo ng-if=\"selectedTab==\'hub.reports.d.poh\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'poh\');\" translate=\"{{\'r.tool.2.7\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.d.hk\')}}\" aria-controls=tab-dhk id=tab-dhk ng-if=\"selectedTab==\'hub.reports.d.hk\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'hk\');\" translate=\"{{\'r.tool.2.8\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li class=info role=tab aria-selected=\"{{$state.includes(\'hub.reports.hds.pp\')}}\" aria-controls=tab-hdspp id=tab-hdspp ng-if=\"selectedTab==\'hub.reports.hds.pp\'\"><a href=\"\" role=link ng-click=\"readMeFx(\'hpp\');\" translate=\"{{\'r.tool.1.3\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li></ul></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><img alt=Loading src=assets/images/loading.gif class=pad10 ng-if=chartLoading><div class=selectedQuad ng-repeat=\"report in reportArr\"><section class=panel><div class=panel-heading ng-if=chartShow><p><span class=text-bold ng-if=\"reportArr.length > 1\">{{reportArr.length - $index}}. </span><span ng-if=\"report.type ==\'pp\'\">{{\'r.body.3\' | translate}}</span> <span ng-if=\"report.type ==\'ds\'\">{{\'r.body.4\' | translate}}</span> <span ng-if=\"report.type ==\'cs\'\">{{\'r.body.5\' | translate}}</span> <span ng-if=\"report.type ==\'hg\'\">{{\'r.tab.2.2\' | translate}}</span> <span ng-if=\"report.type ==\'dst\'\">{{\'r.tab.2.6\' | translate}}</span> <span ng-if=\"report.type ==\'poh\'\">{{\'r.tab.2.7\' | translate}}</span></p><div class=panel-tools><div class=pull-right><a href=\"\" role=link ng-click=closeReport($index); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\"><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><!-- Power history --><div class=pull-right ng-if=\"report.type == \'poh\'\"><a href=\"\" role=link class=padLR5 uib-tooltip-template=\"\'phInfo.html\'\" tooltip-placement=bottom tooltip-append-to-body=true><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><div class=\"pull-right hide\" ng-if=\"(report.data.data.length && report.actionShow && report.type != \'hg\') || (report.type == \'dst\')\"><a href=\"\" role=link ng-click=reportPinFx($index); ng-class=\"{\'active\': report.isPinned}\" uib-tooltip=\"{{report.isPinned?\'r.tool.6\':\'r.tool.5\' | translate}}\"><span class=\"glyphicon glyphicon-paperclip\" aria-hidden=true></span></a></div><div class=pull-right uib-dropdown ng-if=\"(report.data.data.length && report.actionShow && report.type != \'hg\') || (report.type == \'dst\' || report.type == \'poh\')\"><a href=\"\" role=link uib-dropdown-toggle uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" ng-click=\"exportFx(\'xlsx\', report.type, $index);\"><span class=\"fa fa-download\" aria-hidden=true></span></a><!-- <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\r\n            <li role=\"menuitem\" class=\"text-file\" ng-if=\"report.type != \'dst\' && report.type != \'poh\' && report.type != \'pp\'\"><a href=\"\" role=\"link\" ng-click=\"exportFx(\'csv\', report.type, $index);\">{{\'r.btn.4\' | translate:{format:\'CSV\'} }}</a></li>\r\n            <li role=\"menuitem\" class=\"excel-file\"><a href=\"\" role=\"link\" ng-click=\"exportFx(\'xlsx\', report.type, $index);\">{{\'r.btn.4\' | translate:{format:\'XLSX\'} }}</a></li>\r\n          </ul> --></div><div class=pull-right uib-dropdown auto-close=outsideClick ng-if=\"report.data.data.length && report.actionShow && report.type != \'hg\'\" is-open=report.isOpen><!-- is-open=\"status.isopen\" --> <a href=\"\" role=link uib-dropdown-toggle uib-tooltip=\"{{\'r.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-envelope\" aria-hidden=true></span></a><div class=dropdown-menu uib-dropdown-menu><div class=\"input-group input-sm\" ng-class=\"{\'has-error\':errEmail}\"><input type=email id=email class=form-control style=width:200px ng-model=curInfo.email placeholder=\"{{\'r.ph.1\' | translate}}\" focus-me=\"\" maxlength=250 aria-label=\"{{\'r.ph.1\' | translate}}\" aria-labelledby=\"{{\'r.ph.1\' | translate}}\"> <span class=input-group-btn><button type=button role=button class=\"btn btn-primary\" ng-click=\"exportFx(\'mail\', report.type, $index);\" ng-disabled=sendProcessing><span class=fa ng-class=\"sendProcessing?\'fa-repeat fa-spin\':\'fa-envelope-o\'\" aria-hidden=true></span>{{\'cm.btn.35\' | translate}}</button></span></div></div></div></div></div><div class=\"panel-body noPad\"><!-- PP --><hc-pp-chart class=col-xs-12 index=$index ng-if=\"report.type == \'pp\' && report.data.data.length > 0\" chart-fx=chartResizer data=report.data info=report.info.info localiz=localiz path=apiPath devices=reportSelectedItems.devices content=reportSelectedItems.content device-empty=reportInfoCopy.deviceEmpty content-empty=reportInfoCopy.contentEmpty devices-count=reportSelectedItems.devices.length content-ids=stringIds>Placeholder for column chart</hc-pp-chart><!-- DS --><hc-ds-chart class=col-xs-12 ng-if=\"report.type == \'ds\' && report.data.data.length > 0\" chart-fx=chartResizer data=report.data localiz=localiz>Placeholder for stacked column chart</hc-ds-chart><!-- CS --><hc-cs-chart class=\"col-xs-12 csChartContainer\" ng-if=\"report.type == \'cs\' && report.data.data.length > 0\" data=report.data localiz=localiz>Placeholder for stacked column chart</hc-cs-chart><!-- HG --><hc-hg-chart class=col-xs-12 ng-if=\"report.type == \'hg\' && report.data.data.length > 0\" data=report.data localiz=localiz>Placeholder for stacked column chart</hc-hg-chart><!-- DST --><div ng-if=\"report.type == \'dst\'\" class=\"scrollQuad rMinHeight\" ng-attr-style=max-height:{{getAvailableHeight(585)}}px><div class=col-xs-12><div class=\"row noMarB\" ng-class=\"{\'bdr-btm-dashed\': !$last}\" ng-repeat=\"device in report.data.devices\"><div class=col-xs-12><h4 class=\"padL5 padB10 text-16\">{{device.label}} <span class=text-muted>[ {{device.mac}} ]</span></h4><div class=\"row padRL15\" ng-repeat=\"info in device.info\"><div class=\"col-xs-1 noPadR text-center\"><div>{{info.date}}</div></div><div class=col-xs-11><div class=progress><div class=\"pull-left w100\"><div ng-if=info.timeline.length><div ng-repeat=\"item in info.timeline\" class=\"progress-bar progress-bar-{{item.status == \'No data\'?\'empty\':item.status}}\" style=\"width:{{((item.time / 1440) * 100)}}%\" uib-tooltip-template=\"\'timeline.html\'\" tooltip-append-to-body=true></div></div><div ng-if=!item.timeline.length class=\"progress-bar progress-bar-empty w100\" uib-tooltip=\"{{\'r.label.12\' | translate}}\" tooltip-append-to-body=true></div></div></div></div></div></div></div></div></div><!-- POH --><div ng-if=\"report.type == \'poh\'\" class=\"scrollQuad pohScroll rMinHeight\" ng-attr-style=max-height:{{getAvailableHeight(565)}}px;><div class=col-xs-12><div class=testimonial-group><div class=row><div class=\"device-sec valign-top\" ng-class=\"report.data.devices.length > 1 ? \'col-xs-6\' : \'col-xs-12\'\" ng-repeat=\"device in report.data.devices\"><div class=\"row text-center\"><div class=\"col-xs-12 padTB15 text-bold\">{{device.label}} <span class=text-muted>[ {{device.mac}} ]</span></div></div><div class=\"table table-md text-left\"><div class=\"row th bdr-top-dashed\"><div class=col-xs-3>{{\'cm.label.7\' | translate}}</div><div class=col-xs-9>{{\'cm.tool.3\' | translate}}</div></div><div class=row ng-if=\"device.actions.length > 0\" ng-repeat=\"data in device.actions\"><div class=col-xs-3>{{data.dt}}</div><div class=\"col-xs-9 word-break\">{{data.act}}</div></div><div class=\"msg-warning marB15\" lang={{auth.lang}} ng-if=\"device.actions.length == 0\">{{\'r.msg.2\' | translate}}</div></div></div></div></div></div></div><div class=pad10 ng-if=\"!chartLoading && (report.data.data.length == 0 && chartShow)\"><div class=msg-warning lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div><div class=panel-footer ng-if=\"report.type == \'dst\' || report.type == \'ds\'\"><div class=marT8><span><span class=\"legend online marR5\"></span>{{\'d.tool.1\' | translate}}</span> <span><span class=\"legend offline marR5 marL10\"></span>{{\'d.tool.2\' | translate}}</span> <span><span class=\"legend empty marR5 marL10\"></span>{{\'r.label.12\' | translate}}</span></div></div></section></div><section class=panel ng-if=\"(inProcessTaskList.length || reportHistory.length) && (selectedTab == \'hub.reports.d.ds\' || selectedTab == \'hub.reports.d.hg\' || selectedTab == \'hub.reports.d.dst\' || selectedTab == \'hub.reports.d.poh\' || selectedTab == \'hub.reports.d.ci\')\"><div class=panel-body><div class=\"row pad10\"><div class=col-xs-6 ng-class=\"reportHistory.length? \'col-xs-6\':\'col-xs-12\'\" ng-if=inProcessTaskList.length><div class=panel-inner-tab>{{\'r.label.21\' | translate}} [ {{inProcessTaskList.length}} ]</div><div class=\"bg-light pad10\" style=height:512px><img alt=Loading src=assets/images/loading.gif ng-if=statusLoading><div class=\"scrollQuad table table-md no-th reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=\"row marB5\" ng-repeat=\"item in inProcessTaskList\"><div class=\"col-xs-6 text-ellipsis\"><span ng-if=item.dr.st uib-tooltip=\"{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 class=ng-binding>{{(item.dr.st * 1000) | date:\'MMM d, y\'}} - {{(item.dr.et * 1000) | date:\'MMM d, y\'}}</span> <span ng-if=!item.dr.st uib-tooltip=\"{{item.dr * 1000 | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{item.dr * 1000 | date:\'MMM d, y\'}}</span></div><div class=\"col-xs-6 text-right\"><div ng-if=\"item.s == \'pen\'\">{{\'em.body.8\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'fet\'\">{{\'r.label.23\' | translate}} <img alt=Loading src=assets/images/loading-xs.gif> <a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><div ng-if=\"item.s == \'pro\'\" class=d-flex><div style=\"width:100%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#cccccc\'}}\"><div style=\"width: {{item.p}}%\" uib-tooltip={{item.p}} tooltip-append-to-body=true tooltip-popup-delay=500><span class=rectangle-pie ng-if=\"item.p != \'0\'\">{{item.p}}%</span> <span class=rectangle-pie ng-if=\"item.p == \'0\'\"></span></div></div><a href=\"\" role=link class=\"btn btn-link btn-xs marL5\" ng-click=\"reportActionOpen(\'c\', item.id);\">{{\'cm.btn.9\' | translate}}</a></div><!-- <div ng-if=\"item.s == \'fail\'\" class=\"text-sm\">\r\n                  <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"reportActionOpen(\'retry\', item.id);\">{{\'cl.p_c.7\' | translate}}</button>\r\n                </div> --><!-- <div ng-if=\"item.s == \'noData\'\" class=\"text-sm text-muted\"> --><div ng-if=\"item.s == \'fail\'\" class=\"text-sm text-muted\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"item.s == \'success\'\"><a href={{item.url}} role=link target=_blank download><div class=\"btn btn-primary btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><!-- <a href=\"{{item.url}}\" role=\"link\" target=\"_blank\" download><span class=\"fa fa-download\"></span></a> --></div></div></div></div></div></div><div class=col-xs-6 ng-class=\"inProcessTaskList.length? \'col-xs-6\':\'col-xs-12\'\" ng-if=reportHistory.length><div class=panel-inner-tab>{{\'r.label.20\' | translate}} [ {{reportHistory.length}} ]</div><div class=\"bg-light pad10\" style=height:512px><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"reportHistory.length && !historyLoading\"><div class=\"table table-md bg-white\"><div class=\"scrollQuad reportQueue\" ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=\"row stickyHeader\"><div class=col-xs-4>{{\'r.label.22\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"hs in filteredHistory = (reportHistory | customSearch:{key:searchTextPopup, module:\'cdtg\'})\"><div class=\"col-xs-4 text-ellipsis\"><span uib-tooltip=\"{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{hs.gOn * 1000 | date:\'MMM d, y h:mm a\'}}</span></div><div class=\"col-xs-5 text-ellipsis\"><span ng-if=hs.dr.st uib-tooltip=\"{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{(hs.dr.st * 1000) | date:\'MMM d, y\'}} - {{(hs.dr.et * 1000) | date:\'MMM d, y\'}}</span> <span ng-if=!hs.dr.st class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 text-right\"><a href={{hs.url}} role=link target=_blank download><div class=\"btn btn-default btn-xs\"><span class=\"fa fa-download marR5\"></span>{{\'cm.btn.17\' | translate}}</div></a><button type=button role=button class=\"btn btn-xs btn-danger marL5\" ng-click=\"reportActionOpen(\'d\', hs.id);\">{{\'cm.btn.13\' | translate}}</button></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredHistory.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"msg-warning marT10\" ng-if=\"!reportHistory.length && !historyLoading\" lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></div></div></div></section><script type=text/ng-template id=timeline.html><div class=\"text-left\">\r\n    <div>\r\n      <div>{{item.status | capitalize}}</div>\r\n      <div>(UTC) {{item.startTime}} - {{item.endTime}}</div>\r\n      <div>{{item.time | minToHour}}</div>\r\n    </div>\r\n  </div></script><style>.tooltip-inner{max-width:100%}</style><script type=text/ng-template id=phInfo.html><div class=\"text-left\">\r\n    <div>\r\n      <div class=\"text-bold\">localKey</div>\r\n      <div>{{\'r.tool.8\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">offTimer</div>\r\n      <div>{{\'r.tool.9\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">remoteKey</div>\r\n      <div>{{\'r.tool.10\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">unknown</div>\r\n      <div>{{\'r.tool.11\' | translate}}</div>\r\n    </div>\r\n  </div></script>");
$templateCache.put("app/reports/rv.html","<div class=row><div class=col-xs-3><div class=form-group><label for=dateRange>{{\'cm.label.36\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=report.info.dateRange format=MM/DD/YYYY max-date={{maxDate}} readonly aria-label=dateRange aria-labelledby=dateRange></div></div></div><div class=col-xs-12><button type=button role=button class=\"btn btn-primary marB2\" ng-click=\"generateReportFx(\'mailLinkClick\');\" ng-disabled=opReportLoading><span class=\"fa fa-repeat fa-spin\" ng-if=opReportLoading aria-hidden=true></span> {{\'r.btn.1\' | translate}}</button></div><div class=col-xs-4><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'r.msg.7\' | translate}}</span> <span ng-if=\"errType==\'noData\'\" aria-live=polite role=status>{{\'r.msg.1\' | translate}}</span> <span ng-if=\"errType==\'dateRange\'\" aria-live=polite role=status>{{\'r.msg.12\' | translate}}</span></div></div></div>");
$templateCache.put("app/reports/s.html","<img alt=Loading src=assets/images/loading.gif ng-if=sReportLoading><div class=\"table table-md\" ng-if=!sReportLoading><div ng-if=report.length><div class=\"row th\" ng-if=\"(report | filter:searchText).length > 0\"><div class=col-xs-2>{{\'b.o.2\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.telax.3\' | translate}}</div><div class=col-xs-3>{{\'cm.brief.3\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.tool.1.3\' | translate | camelCase}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><ul><li class=row ng-repeat=\"sub in report | filter:searchText\"><div class=col-xs-2><span ng-if=\"sub.type == \'d\'\">{{\'b.o.2.1\' | translate}}</span> <span ng-if=\"sub.type == \'w\'\">{{\'b.o.2.2\' | translate}}</span> <span ng-if=\"sub.type == \'m\'\">{{\'b.o.2.3\' | translate}}</span></div><div class=col-xs-3><span ng-if=\"sub.report == \'pp\'\">{{\'r.body.3\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'ds\'\">{{\'r.body.4\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'cs\'\">{{\'r.tab.1.2\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'op\'\">{{\'r.tab.4\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'od\'\">{{\'r.tab.5\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'cc\'\">{{\'r.tab.1.1\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'pod\'\">{{\'r.tab.7\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'dst\'\">{{\'r.tab.2.6\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'poh\'\">{{\'r.tab.2.7\' | translate | capitalize}}</span> <span ng-if=\"sub.report == \'ci\'\">{{\'r.tab.7\' | translate | capitalize}}</span></div><div class=col-xs-3>{{sub.createdBy}}</div><div class=\"col-xs-2 noPadR\">{{(sub.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link ng-click=unsubscribeOpen(sub.id); class=\"btn btn-danger btn-xs\">{{\'r.btn.6\' | translate}}</a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"(report | filter:searchText).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!sReportLoading && report.length == 0\">{{\'b.msg.1\' | translate}}</div></div>");
$templateCache.put("app/reports/steth.html","<div class=row><div class=col-xs-12><div class=spaceH></div><section><header class=panel-inner-tab><a ui-sref-active=selected ui-sref=.ac>{{\'r.tab.6.3\' | translate}}</a> <a ui-sref-active=selected ui-sref=.rv>{{\'r.tab.6.2\' | translate}}</a> <a ui-sref-active=selected ui-sref=.es>{{\'r.tab.6.1\' | translate}}</a> <a ui-sref-active=selected ui-sref=.pp>{{\'r.tab.1.3\' | translate}}</a></header><div class=pull-right></div><div class=\"panel-body marT15\"><div ui-view=tabView></div></div></section></div></div>");
$templateCache.put("app/schedules/es.html","<img alt=Loading src=assets/images/loading.gif ng-if=scheduleLoading><div ng-if=\"!scheduleLoading && schedules.s.length > 0\"><ng-schedule-list class=\"show table table-md\" selectable=selection selectable-list=schedules.s selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-schedule-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!scheduleLoading && schedules.s.length == 0\"><p>{{\'s.msg.4\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'es\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'s.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'es\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'s.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/schedules/is.html","<img alt=Loading src=assets/images/loading.gif ng-if=scheduleLoading><div ng-if=\"!scheduleLoading && schedules.s.length > 0\"><ng-schedule-list class=\"show table table-md\" selectable=selection selectable-list=schedules.s selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-schedule-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!scheduleLoading && schedules.s.length == 0\"><p>{{\'s.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'is\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'s.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'is\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'s.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/schedules/s.html","<img alt=Loading src=assets/images/loading.gif ng-if=scheduleLoading><div context-menu=contextMenuBase><div ng-if=\"!scheduleLoading && (schedules.s.length > 0 || schedules.g.length > 0)\"><ng-schedule-list class=\"show table table-md\" selectable=selection selectable-list=schedules.s selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-schedule-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!scheduleLoading && schedules.s.length == 0 && schedules.g.length == 0 && !advSearchInfo.isEmpty\"><p>{{\'s.msg.1\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'s\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'s.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'s\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'s.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!scheduleLoading && schedules.s.length == 0 && schedules.g.length == 0 && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div>");
$templateCache.put("app/schedules/sContent.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=\"(!schedule.info.ls && !detailLoading)\"></i><span class=stepGray ng-if=\"(!schedule.info.ls && !detailLoading)\"><p>5</p></span></span><!-- <a href class=\"marR10\" ui-sref=\"hub.schedules.s\">{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'s.p_s.body.1\' | translate}}</span><span ng-if=\"schedule.info.label\" class=\"text-muted\">[ {{schedule.info.label}} ]</span> --> <a href class=marR10 role=link ui-sref=hub.schedules.s>{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=!detailLoading>{{schedule.info.onceCompleted == \'\'?\'s.btn.1\':\'s.p_s.body.1\' | translate}}</span><span ng-if=schedule.info.label class=text-muted>[ {{schedule.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 3}\'}}: {{\'cm.label.32\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=\"(!schedule.info.ls && !detailLoading)\"></i><span class=stepGray ng-if=\"(!schedule.info.ls && !detailLoading)\"><p>5</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading class=pad10><div class=row ng-if=!detailLoading><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=\"(selectedT==\'1\' || selectedT == \'2\') && advancedShow\" class=col-xs-12></advanced-search>{{viewType = (uPreferences.contentView == \'t\' && uPreferences.templateView ? \'l\' : \'t\'); \'\'}}<div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=pull-right uib-dropdown ng-if=\"selectedT == \'1\'\"><a href=\"\" id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'scl\', decId);\" ng-if=!schedule.info.ls>{{\'cm.body.10\' | translate}}</a> <a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'scl\', decId, schedule.info.ls);\" ng-if=\"schedule.info.ls==1 || schedule.info.ls==2 || schedule.info.ls==3 || schedule.info.ls==4 || schedule.info.ls==5 || schedule.info.ls==6\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-if=\"selectedT == \'2\'\"><!-- <button type=\"button\" role=\"button\" class=\"btn btn-default btn-sm marL5 marT-6\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-placement=\"left\" ng-click=\"advancedSearchOpen(\'t\', \'stm\', decId);\" ng-if=\"!schedule.info.ls\"><span class=\"fa fa-sort noMarR\" aria-hidden=\"true\"></span></button>\r\n            <button type=\"button\" role=\"button\" class=\"btn btn-default btn-sm marL5 marT-6\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-placement=\"left\" ng-click=\"advancedSearchOpen(\'t\', \'stm\', decId, schedule.info.ls);\" ng-if=\"schedule.info.ls==1 || schedule.info.ls==2 || schedule.info.ls==3 || schedule.info.ls==4 || schedule.info.ls==5\"><span class=\"fa fa-sort noMarR\" aria-hidden=\"true\"></span></button> --> <a href=\"\" id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'t\', \'stm\', decId);\" ng-if=!schedule.info.ls>{{\'cm.body.10\' | translate}}</a> <a href=\"\" role=link ng-click=\"advancedSearchOpen(\'t\', \'stm\', decId, schedule.info.ls);\" ng-if=\"schedule.info.ls==1 || schedule.info.ls==2 || schedule.info.ls==3 || schedule.info.ls==4 || schedule.info.ls==5\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'templateView\', viewType); templateViewReloadFx()\">{{templateViewText}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchTextS.text sanitize-input maxlength=250 ng-change=\"searchChangeFx(\'\', searchTextS.text);\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextS.text.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1,\'tabFx\');\" ng-if=\"schedule.info.ls != 3\">{{\'cm.label.1\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2,\'tabFx\');\" ng-if=\"(auth.uservices.t && !schedule.info.ls) || schedule.info.ls==3\">{{\'cm.label.2s\' | translate}}</a></div></div><div ng-class=\"{\'noMarB\':auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" ng-attr-style=height:{{quadHeight}}px;><span ng-if=\"selectedT==\'1\'\"><div class=breadcrumb ng-if=\"breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div ng-if=\"!contentLibraryLoading && !advSearch && (folderList.length > 0 || contentList.length > 0)\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4)?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.gd || (odSp.auth && odSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><ul class=\"list-inline thumb-list\" ng-if=\"!contentLibraryLoading && (folderList.length > 0 || contentList.length > 0) && uPreferences.contentView == \'t\'\" element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLibraryLoading && (folderList.length > 0 || contentList.length > 0) && uPreferences.contentView == \'l\'\" element-height=quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0 && !advSearch\">{{\'cl.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></span><span ng-if=\"selectedT==\'2\'\"><div class=breadcrumb ng-if=\"breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><!-- <ul class=\"list-inline thumb-list\" ng-if=\"!templatesLoading\" element-height=\"quadHeight\">\r\n                <ng-template-list class=\"show\" ng-if=\"folderList.length || templateList.length\" selectable=\"selection\" selectable-options=\"{filter:\'li\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-list>\r\n              </ul>     --><ul class=\"list-inline thumb-list\" ng-if=\"!templatesLoading && uPreferences.templateView == \'t\'\" element-height=quadHeight><ng-template-list class=show ng-if=\"folderList.length || templateList.length\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!templatesLoading && uPreferences.templateView == \'l\'\" element-height=quadHeight><ng-template-list-view class=show id=template-list ng-if=\"folderList.length || templateList.length\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && !folderList.length && !templateList.length\">{{\'t.msg.1\' | translate}}</div></span></div></div></div></div><div class=noPadL ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=\"selectedQuad panel-body noPadL\">{{scheduleContentCount = (schedule.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{auth.uservices.t?\'s.p_s.body.2\':\'cm.body.5\' | translate}} [ {{scheduleContentCount.length}} ]</div><section><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && schedule.content.length > 0 || (schedule.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback() ng-if=\"uPreferences.contentView == \'t\'\"><li ng-repeat=\"cl in schedule.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=sortable-item ng-if=!cl.hidden><a href=\"\" role=link aria-label=cross_{{$index}} class=thumb-close ng-click=\"closeFilteredFx(cl.id, $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner ng-class=\"{\'blurry-img\':cl.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{cl.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000 tooltip-enable=cl.path><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && !cl.ss\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png?v{{timestamp}}\" class=\"img-responsive center-block img-widget\"> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && cl.ss\" ng-href=\"{{cDetailBucket + cl.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a ng-if=\"cl.type == \'Image\'\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}}><img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\"> </a><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}}><img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\" ng-src=\"{{thumbHost + tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted && cl.type != \'template\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/sp.png ng-if=\"cl.type == \'SharePointC\'\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/od.png ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/gd.png ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\" class=img-responsive><div class=hoverOverlay><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.l, cl.di);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"cl.type == \'Image\' && cl.isCompleted\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a ng-if=\"cl.type == \'template\' && cl.isCompleted\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'Image\' && cl.type != \'Video\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.type != \'template\'}\" ng-click=contentInfoOpen(cl); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><span class=thumb-icon><span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.ss class=webpage aria-hidden=true></span> <span ng-if=\"cl.type !== \'Folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\" uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</div><div class=form-inline ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3 || cl.extn == \'Content on Demand\'\"><div class=\"form-group text-ellipsis text-left w100\"><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number id=content-{{$index}} class=\"form-control input-sm duration\" ng-model=cl.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"> <span class=\"text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</span></div><div class=\"fullScreen text-left\" ng-if=\"(cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\') || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\') || (cl.type == \'Widget\' && cl.extn == \'Social Chorus\') || (auth.upermissions.sfsc && (cl.type != \'Widget\' && cl.type != \'Flash\' && cl.type != \'template\')) || (cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\'))\"><label class=noMarB ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\' || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\') || (cl.type == \'Widget\' && cl.extn == \'Social Chorus\')\"><input type=checkbox ng-model=cl.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label><label class=noMarB ng-if=\"auth.upermissions.sfsc && ((cl.type != \'Widget\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\') || (cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\')))\"><input type=checkbox ng-model=cl.fullscreen role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.68\' | translate}}</span></label></div><div class=\"form-group text-left w100 marT5\" ng-if=\"cl.type != \'Widget\' && cl.type != \'Audio\' && cl.type != \'template\'\"><span class=valign-inherit>{{\'cm.label.92\' | translate}}:</span><select class=\"form-control input-sm duration\" ng-model=cl.scale><option value=fit>{{\'ms.label.27.1\' | translate}}</option><option value=crop>{{\'ms.label.27.2\' | translate}}</option><option value=skew>{{\'ms.label.27.3\' | translate}}</option></select></div><div class=\"form-group text-left w100 marT8\" ng-if=\"cl.type == \'Video\' || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\')\"><span class=valign-inherit>{{\'cl.label.10\' | translate}}:</span><select class=\"form-control input-sm\" ng-init=cl.captionSel ng-model=cl.captionSel ng-options=\"option as option.label for option in cl.captionLang track by option.label\"><option value=\"\">{{\'cl.widget.cm.12.3\' | translate}}</option></select></div></div></li></ul><ul class=\"table table-md list-unstyled sortable-containment\" sortable callback=sortCallback() containment=\"\'parent\'\" ng-if=\"uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-3 uib-tooltip=\"{{\'cm.brief.1\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-1\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-ellipsis\" uib-tooltip=\"{{\'cm.label.49\' | translate}} ({{\'cm.label.27s\' | translate}})\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><!-- <div class=\"col-xs-1 text-right\">{{\'cm.label.67\' | translate}}</div>\r\n                  <div class=\"col-xs-1 text-right\">{{\'cm.label.68\' | translate}}</div> --><div class=\"col-xs-2 text-center text-ellipsis\" uib-tooltip=\"{{\'cm.label.92\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cm.label.92\' | translate}}</div><div class=\"col-xs-2 text-center text-ellipsis\" uib-tooltip=\"{{\'cl.label.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'cl.label.10\' | translate}}</div><div class=\"col-xs-4 text-right text-ellipsis\" uib-tooltip=\"{{\'d.tab.6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500>{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in schedule.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-if=!cl.hidden><div class=\"col-xs-3 text-ellipsis clViwe d-flex align-items-center\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted && cl.type != \'template\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span></span></span><div class=text-ellipsis uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</div></div><!-- <div class=\"col-xs-1 text-ellipsis\">{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div> --><div class=col-xs-1><span ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3 || cl.extn == \'Content on Demand\'\"><input type=number class=\"form-control input-sm duration pad4\" ng-model=cl.duration min=1></span></div><!-- <div class=\"col-xs-1 text-right\">\r\n                    <span class=\"text-left marR10\" ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\">\r\n                      <label class=\"noMarB\" ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\' || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\') || (cl.type == \'Widget\' && cl.extn == \'Social Chorus\')\">\r\n                        <input type=\"checkbox\" ng-model=\"cl.mute\"><label></label>\r\n                        <span class=\"valign-inherit\">{{\'cm.label.67\' | translate}}</span>\r\n                      </label>\r\n                    </span>\r\n                  </div>\r\n                  <div class=\"col-xs-1 text-right\">\r\n                    <label class=\"noMarB\" ng-if=\"schedule.info.fs && (cl.type != \'Widget\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\')\">\r\n                      <input type=\"checkbox\" ng-model=\"cl.fullscreen\"><label></label>\r\n                      <span class=\"valign-inherit\">{{\'cm.label.68\' | translate}}</span>\r\n                    </label>\r\n                  </div> --><div class=\"col-xs-2 text-center\"><span ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\"><div class=\"text-left w100\" ng-if=\"cl.type != \'Widget\' && cl.type != \'Audio\' && cl.type != \'template\'\"><select class=\"form-control input-sm duration\" ng-model=cl.scale><option value=fit>{{\'ms.label.27.1\' | translate}}</option><option value=crop>{{\'ms.label.27.2\' | translate}}</option><option value=skew>{{\'ms.label.27.3\' | translate}}</option></select></div></span></div><div class=\"col-xs-2 text-center\"><span ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\"><div class=\"text-left w100\" ng-if=\"cl.type == \'Video\' || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\')\"><select class=\"form-control input-sm\" ng-init=cl.captionSel ng-model=cl.captionSel ng-options=\"option as option.label for option in cl.captionLang track by option.label\"><option value=\"\">{{\'cl.widget.cm.12.3\' | translate}}</option></select></div></span></div><div class=\"col-xs-4 text-right d-flex justify-content-flex-end\"><span class=text-left ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\"><label class=\"noMarB marR5\" ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\' || (cl.type == \'Widget\' && cl.extn == \'Live Streaming\') || (cl.type == \'Widget\' && cl.extn == \'Social Chorus\')\"><input type=checkbox ng-model=cl.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label><label class=\"noMarB marL5\" ng-if=\"auth.upermissions.sfsc && (cl.type != \'Widget\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\')\"><input type=checkbox ng-model=cl.fullscreen><label></label><span class=valign-inherit>{{\'cm.label.68\' | translate}}</span></label></span><a href=\"\" class=\"text-primary marL5\" ng-click=contentInfoOpen(cl); uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-info-circle\"></span></a> <a href=\"\" class=\"text-danger marL5\" ng-click=\"closeFilteredFx(cl.id, $index, cl.wcgid, cl.tempId)\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && scheduleContentCount.length == 0\">{{\'cm.msg.4\' | translate}}<span ng-if=hiddenContent>{{\'s.p_s.msg.11\' | translate}}</span></div><div class=msg-warning lang={{auth.lang}} ng-if=\"scheduleContentCount.length > 0 && (schedule.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div><footer class=panel-footer ng-if=!detailLoading><ng-btn-list info=\"{onceCompleted:schedule.info.onceCompleted, isCompleted:schedule.info.isCompleted, sp:saveProcessing, sc:saveCloseProcessing}\" permission=se back-btn=\"backBtn(\'c\');\" next-callback=saveSchedule(se.step); save-callback=\"saveSchedule(se.step, \'sc\');\" cancel-fx=\"cancelFx(\'pop\');\"></ng-btn-list><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'conflict\'\" aria-live=polite role=status>{{\'s.p_s.msg.7\' | translate}}:</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingDuration}}</span></span> <span ng-if=\"errType==\'count\'\" aria-live=polite role=status>{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingCount}}</span></span> <span ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{allowedFolder}}</span></span> <span ng-if=\"errType==\'durationEmpty\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</span> <span ng-if=\"errType==\'selectGroup\'\" aria-live=polite role=status>{{\'s.p_s.msg.29\' | translate}}</span> <span ng-if=\"errType==\'eslSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.47\' | translate}}</span> <span ng-if=\"errType==\'cExist\'\" aria-live=polite role=status>{{\'s.p_s.msg.49\' | translate}}</span><!-- Single sort save --> <span ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.31\' | translate}}</span> <span ng-if=\"errType==\'mcContent\'\" aria-live=polite role=status>{{\'s.p_s.msg.30\' | translate}}</span> <span ng-if=\"errType==\'mcSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.32\' | translate}}</span> <span ng-if=\"errType==\'lsError\'\" aria-live=polite role=status>{{\'s.p_s.msg.39\' | translate}}</span> <span ng-if=\"errType==\'ccError\'\" aria-live=polite role=status>{{\'s.p_s.msg.41\' | translate}}</span> <span ng-if=\"errType==\'eslDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.46\' | translate}}</span> <span ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'s.p_s.msg.50.1\' | translate}}</span> <span ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</span> <span ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</span> <span ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</span> <span ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</span> <span ng-if=\"errType==\'thirdPartyCA\'\" aria-live=polite role=status>{{\'s.p_s.msg.71\' | translate}}</span> <span ng-if=\"errType==\'formN\'\" aria-live=polite role=status>{{\'s.p_s.msg.1\' | translate}}</span> <span ng-if=\"errType==\'formS\'\" aria-live=polite role=status>{{\'s.p_s.msg.3\' | translate}}</span> <span ng-if=\"errType==\'formC\'\" aria-live=polite role=status>{{schedule.info.ls?\'s.p_s.msg.40\':\'s.p_s.msg.2\' | translate}}</span> <span ng-if=\"errType==\'formD\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</span> <span ng-if=\"errType==\'formF\'\" aria-live=polite role=status>{{\'s.p_s.msg.16\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/sDevice.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>4</p></span><i ng-if=\"!schedule.info.ls && !detailLoading\"></i><span class=stepGray ng-if=\"!schedule.info.ls && !detailLoading\"><p>5</p></span></span><!-- <a href class=\"marR10\" ui-sref=\"hub.schedules.s\">{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'s.p_s.body.1\' | translate}}</span><span ng-if=\"schedule.info.label\" class=\"text-muted\">[ {{schedule.info.label}} ]</span> --> <a href class=marR10 role=link ui-sref=hub.schedules.s>{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=!detailLoading>{{schedule.info.onceCompleted == \'\'?\'s.btn.1\':\'s.p_s.body.1\' | translate}}</span><span ng-if=schedule.info.label class=text-muted>[ {{schedule.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\':!auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 4}\'}}: {{\'cm.label.31\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>4</p></span><i ng-if=\"!schedule.info.ls && !detailLoading\"></i><span class=stepGray ng-if=\"!schedule.info.ls && !detailLoading\"><p>5</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading class=pad10><div class=\"row relative\" ng-if=!detailLoading><!-- Advanced Search --><advanced-search ng-if=advSApply adv-search-info=advSearchInfo class=col-xs-12></advanced-search><div class=saveSearchBtn ng-if=\"auth.uservices.ss && advSearchInfo.module == \'s\' && (advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0)\"><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=saveSearchOpen(); ng-if=\"(schedule.info.onceCompleted && auth.upermissions.se.dg) || (!schedule.info.onceCompleted && auth.upermissions.sa.dg)\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'s.p_s.btn.4\' | translate}}</button></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><!-- <div class=\"pull-right marRL10 filterIcon\" ng-if=\"selectedTab == \'hub.sContainer.sDevice\' && selectedT==\'1\' && !isGbdt\" uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad}\"> --><div class=\"pull-right marRL10 filterIcon\" ng-if=\"((stateName == \'d\' && selectedT==\'1\') || (selectedT == \'4\' && vwBreadCrumbs.length)) && !isGbdt\" uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><!-- <a href=\"\" id=\"filter\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\"></span></a> --> <a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\" ng-disabled=\"isPageApiLoad || deviceListLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-hide=\"selectedT == \'4\' && !vwBreadCrumbs.length\" ng-class=\"{\'cursorDisabled\':isPageApiLoad || showRemainingList}\"><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle aria-label=\"other option\" ng-disabled=\"isPageApiLoad || showRemainingList\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'s\', \'s\', decId, schedule.info.ls);\" ng-if=\"selectedT == \'1\' || selectedT == \'4\'\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\" ng-if=\"(selectedT == \'1\' || selectedT == \'4\') && !deviceTypes.types.length\">{{deviceViewText}}</a></li><li><a href=\"\" role=link ng-click=\"checkboxFx(\'all\'); selectAllSDFx(); selectedSearch.text=\'\';resetSelPagination(\'all\')\" ng-if=\"!deviceTypes.types.length || (selectedT == \'2\' || selectedT == \'3\')\">{{\'cm.btn.44\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchTextS.text sanitize-input maxlength=250 ng-change=\"searchChangeFx(null, searchTextS.text)\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextS.text.length ng-click=\"searchChangeFx(\'empty\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab><!-- Show Tag First --> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\" ng-if=\"auth.upreferences.sdtf && ((schedule.info.onceCompleted && auth.upermissions.se.dt) || (!schedule.info.onceCompleted && auth.upermissions.sa.dt))\" ng-disabled=\"isPageApiLoad || deviceListLoading\">{{\'d.brief.6\' | translate}}</a></span> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\" ng-if=\"auth.upreferences.sdtf && ((schedule.info.onceCompleted && auth.upermissions.se.d) || (!schedule.info.onceCompleted && auth.upermissions.sa.d))\" ng-disabled=\"isPageApiLoad || deviceListLoading\">{{\'cm.label.4s\' | translate}}</a></span><!-- Show Tag as Usual --> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\" ng-if=\"!auth.upreferences.sdtf && ((schedule.info.onceCompleted && auth.upermissions.se.d) || (!schedule.info.onceCompleted && auth.upermissions.sa.d))\" ng-disabled=\"isPageApiLoad || deviceListLoading\">{{\'cm.label.4s\' | translate}}</a></span> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\" ng-if=\"!auth.upreferences.sdtf && ((schedule.info.onceCompleted && auth.upermissions.se.dt) || (!schedule.info.onceCompleted && auth.upermissions.sa.dt))\" ng-disabled=\"isPageApiLoad || deviceListLoading\">{{\'d.brief.6\' | translate}}</a></span> <span ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT == \'3\'}\" ng-click=\"tabFx(3, \'tabFx\');\" ng-if=\"(schedule.info.onceCompleted && auth.upermissions.se.dg) || (!schedule.info.onceCompleted && auth.upermissions.sa.dg)\" ng-disabled=\"isPageApiLoad || deviceListLoading\">{{\'cm.label.79s\' | translate}}</a></span></div></div><div class=\"overflow-auto bg-light pad10\" ng-if=\"selectedT==\'1\'\" ng-attr-style=height:{{quadHeight}}px; ng-scroll=timerFxToLoadData();><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><div ng-if=\"!deviceListLoading && deviceTypes.types.length > 0\"><ul class=\"list-inline thumb-list t-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredts = (deviceTypes.types | customSearch:{key:searchText, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_selected_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && deviceTypes.types.length && !filteredts.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><div ng-if=\"!deviceListLoading && breadCrumbs.length\" class=breadcrumb><!-- <a href=\"\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\"></span></a> --> <a href=\"\" role=link ng-if=\"!auth.upermissions.dgrp.dgrp || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><!-- <a href=\"\" ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last\">{{breadcrumb.label}}</a> --> <a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\">{{breadcrumb.label}}</a> <a href=\"\" role=link ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div><span ng-if=\"!deviceListLoading && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\" element-height=quadHeight><ng-device-thumb class=show selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!deviceListLoading && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=devices.devices selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !advSearchInfo.isEmpty && filter==\'all\'\">{{\'d.msg.1\' | translate}}</div> --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && advSearchInfo.isEmpty && filter==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n          <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs hide\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !deviceListLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !deviceListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextS.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !deviceListLoading\">{{\'as.msg.2\' | translate}}</div></div><div class=\"overflow-auto pad10 bg-light\" ng-if=\"selectedT==\'2\'\" ng-attr-style=height:{{quadHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><ul class=\"list-inline thumb-list h100\" ng-if=\"!deviceListLoading && sDeviceList.tags.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"><li ng-repeat=\"tag in filteredTagList = (sDeviceList.tags | customSearch:{key:searchText, module:\'d\'})\" data-id={{tag.id}} data-type=tag uib-tooltip=\"{{(schedule.info.ls != 3 && tag.isConflict && tag.isEPD == 1)?dtMsgEpd1:(schedule.info.ls == 3 && tag.isConflict && tag.isEPD == 1)?dtMsgEpd2:(schedule.info.ls == 3 && tag.isConflict && tag.isEPD == 2)?dtMsgEpd3:deviceConflictMsg}}\" tooltip-append-to-body=true tooltip-enable=\"tag.isConflict != null && (tag.isConflict == 1 || tag.isConflict == 2)\" ng-class=\"{\'nonSelectable unapprovedFile\': tag.isConflict != null && (tag.isConflict == 1 || tag.isConflict == 2)}\"><div class=thumb-img><span class=thumb-inner><img alt=\"\" ng-if=!auth.upermissions.dtc src=assets/images/default/device_tag_selected_sm.png><!-- <svg ng-if=\"auth.upermissions.dtc\" xmlns=\"http://www.w3.org/2000/svg\" width=\"90\" height=\"50\" viewBox=\"0 0 90 50\">\r\n                    <defs></defs>\r\n                    <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(tag.tagColor && !tag.isConflict)?tag.tagColor:\'#57aee3\'}\" d=\"M0,0H90V50H0V0Z\"/>\r\n                    <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(tag.tagColor && !tag.isConflict)?tag.tagColor:\'#57aee3\'}\" d=\"M59.932,27.277a2.616,2.616,0,0,0-.706-1.816L45.573,11.218a5.887,5.887,0,0,0-1.948-1.287A5.686,5.686,0,0,0,41.391,9.4H33.448a2.3,2.3,0,0,0-1.718.758,2.508,2.508,0,0,0-.726,1.8v8.3a6.391,6.391,0,0,0,.506,2.334A5.986,5.986,0,0,0,32.741,24.6L46.394,38.887a2.29,2.29,0,0,0,1.718.738,2.392,2.392,0,0,0,1.738-.738l9.375-9.815A2.5,2.5,0,0,0,59.932,27.277Zm-21.09-9.685a2.369,2.369,0,0,1-3.456,0,2.634,2.634,0,0,1,0-3.61,2.369,2.369,0,0,1,3.456,0A2.634,2.634,0,0,1,38.842,17.592Z\"/>\r\n                  </svg> --> <svg alt=\"\" ng-if=auth.upermissions.dtc class=\"img-responsive center-block marB-4\" xmlns=http://www.w3.org/2000/svg width=64 height=38 viewBox=\"0 0 64 38\"><rect x=1 y=1 width=62 height=36 ng-style=\"{\'fill\':\'#FFFFFF\',\'stroke\':(tag.tagColor)?tag.tagColor:\'#53a7da\',\'stroke-width\':\'2\',\'stroke-miterlimit\':\'10\'}\"/><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(tag.tagColor)?tag.tagColor:\'#53a7da\'}\" d=\"M41.72,20.86c0-0.46-0.16-0.87-0.47-1.22l-9.18-9.58c-0.33-0.34-0.76-0.63-1.31-0.87 c-0.55-0.24-1.05-0.36-1.5-0.36h-5.34c-0.44,0-0.83,0.17-1.16,0.51c-0.33,0.34-0.49,0.74-0.49,1.21v5.58c0,0.47,0.11,1,0.34,1.57 c0.23,0.57,0.5,1.02,0.83,1.35l9.18,9.6c0.32,0.33,0.7,0.5,1.16,0.5c0.45,0,0.83-0.17,1.17-0.5l6.3-6.6 C41.57,21.73,41.72,21.33,41.72,20.86z M27.55,14.35c-0.32,0.34-0.71,0.5-1.16,0.5c-0.45,0-0.84-0.17-1.16-0.5 c-0.32-0.34-0.48-0.74-0.48-1.21c0-0.47,0.16-0.88,0.48-1.21c0.32-0.34,0.71-0.5,1.16-0.5c0.45,0,0.84,0.17,1.16,0.5 c0.32,0.34,0.48,0.74,0.48,1.21C28.03,13.61,27.87,14.01,27.55,14.35z\"/></svg></span></div><div class=thumb-label uib-tooltip={{tag.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{tag.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTagList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && sDeviceList.tags.length == 0\">{{\'d.msg.3\' | translate}}</div></div><div class=\"overflow-auto pad10 bg-light\" ng-if=\"selectedT==\'3\'\" ng-attr-style=height:{{quadHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><div class=\"h100 relative\" ng-if=\"!deviceListLoading && sDeviceList.groups.length + sDeviceList.searches.length > 0\"><ul class=\"list-inline thumb-list h100\"><ng-device-group-thumb class=\"show h100\" selectable=selection selectable-list=\"sDeviceList | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-group-thumb></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && sDeviceList.groups.length + sDeviceList.searches.length == 0\">{{\'d.msg.2\' | translate}}</div></div><!-- video wall --><div class=\"overflow-auto pad10 bg-light hide\" ng-if=\"selectedT==\'4\'\" ng-attr-style=height:{{quadHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><div ng-if=\"!deviceListLoading && (devices.walls.length > 0 || devices.device.length > 0)\"><ul class=\"list-inline thumb-list dType-list\"><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"wall in filteredDWalls = (devices.walls | customSearch:{key:searchText, module:\'d\'})\" ng-dblclick=\"openVideoWallFx(wall, 0);\" data-type=\"{{wall.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=\"thumb-inner relative\"><span class=matrix-badge>{{wall.matrix}}</span> <img class=bdrDark alt=videowall src=assets/images/default/device_videowall.png></span></div><div class=thumb-label>{{wall.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && devices.walls.length && !filteredDWalls.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><div ng-if=\"!deviceListLoading && vwBreadCrumbs.length\" class=breadcrumb><!-- <a href=\"\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\"></span></a> --> <a href=\"\" role=link ng-click=\"getVideoWallFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a><!-- <a href=\"\" role=\"link\" ng-click=\"folderContentFx(0);\"><span  class=\"glyphicon glyphicon-home\" aria-hidden=\"true\"></span></a> --> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in vwBreadCrumbs\"><!-- <a href=\"\" ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last\">{{breadcrumb.label}}</a> --> <a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && auth.upermissions.dvw\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"!deviceListLoading && vwBreadCrumbs.length\"><span ng-if=\"!deviceListLoading && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\" element-height=quadHeight><ng-device-thumb ng-if=\"fCount.length || devices.folders.length\" class=show selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!deviceListLoading && auth.upreferences.deviceView == \'l\'\"><ng-device-list ng-if=\"fCount.length || devices.folders.length\" class=\"table table-md whiteRow\" selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.walls.length && !deviceTypes.types.length && devices.folders.length == 0 && !advSearchInfo.isEmpty && filter==\'all\'\">{{\'d.msg.1\' | translate}}</div> --><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.walls.length && !vwBreadCrumbs.length\">{{\'d.msg.73\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && fCount.length == 0 && filter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown ng-if=\"!schedule.info.onceCompleted || (auth.upermissions.se.d && auth.upermissions.se.dt && auth.upermissions.se.dg)\"><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle aria-label=\"{{\'cm.btn.45\' | translate}}\" aria-labelledby=\"{{\'cm.btn.45\' | translate}}\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"removeFilteredFx(\'all\'); closeAllFx(); selectedSearch.text=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearch.text sanitize-input ng-change=searchSelFx(selectedSearch.text);resetSelPagination() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearch.text.length ng-click=\"selectedSearch.text=\'\'; resetSelFx();resetSelPagination()\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><!-- **With tag** --><div class=panel-inner-tab>{{schedule.devices.device.length + schedule.devices.tag.length + schedule.devices.group.length + schedule.devices.search.length>1?\'cm.body.7s\':\'cm.body.7\' | translate}} [ {{schedule.devices.device.length + schedule.devices.tag.length + schedule.devices.group.length + schedule.devices.search.length}} ]</div></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;max-height:{{selectedHeight}}px;><div ng-if=\"schedule.devices.device.length > 0 || schedule.devices.group.length > 0 || schedule.devices.tag.length > 0 || schedule.devices.search.length > 0\">{{selectedFilteredItems = (allSelItems.list | customSearch:{key:selectedSearch.text, module:\'d\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"allSelItems.list.length>0\" ng-class=\"{\'bdr-btm-dashed marT15\':auth.upreferences.deviceView == \'t\', \'hide\':allSelItems.list.length<=auth.upreferences.dpc || selectedFilteredItems.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><!-- <div ng-if=\"allSelItems.list.length>0\" class=\"d-flex justify-end marB15 nonSelectable\" ng-class=\"{\'noMar\':$state.includes(\'hub.sContainer.sDevice\')}\">\r\n                <div class=\"other-controller\">\r\n                  <div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\">\r\n                    <dir-pagination-controls-clone boundary-links=\"selPaginationControls.boundaryLinks\" max-size=\"selPaginationControls.maxSize\" on-page-change=\"selPageChangeHandler(newPageNumber)\" max-page=\"totalDPages\" load-more=\"isPageApiLoad\"></dir-pagination-controls-clone>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=\"thumb-list hoverContainer\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"item in selectedFilteredItems = (allSelItems.list | itemsPerPageClone:selPaginationControls.pageSize) track by item.id\" data-id={{item.id}} data-type=device class=device><!-- device --><div class=relative><a ng-if=\"item.mac && !item.tagColor && (!schedule.info.onceCompleted || auth.upermissions.se.d)\" href=\"\" role=link aria-label=croos_{{$index}} class=\"thumb-close brief-cl\" ng-click=\"removeFilteredFx(item.id, \'d\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=\"!item.mac && item.t==\'t\' && (!schedule.info.onceCompleted || auth.upermissions.se.dt)\" href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"removeFilteredFx(item.id, \'t\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=\"!item.mac && item.t==\'g\' && (!schedule.info.onceCompleted || auth.upermissions.se.dg)\" href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"removeFilteredFx(item.id, \'g\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (item.dType && item.t != 7),\'thumb-group\': item.t == \'g\', \'mcPlayer\': item.t && item.t == 7}\"><a ng-class=\"{\'thumb-device\': (item.dType && item.t != 7)}\" ng-href=\"{{dDetailBucket + (item.mac | removeColon) + \'.jpg?\' + item.thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{item.label}} ng-if=\"item.thumbV != undefined && item.thumbV != 0\"><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (item.mac | removeColon) + \'.jpg&\' + item.thumbV + dThumbParam}}\" src-error=assets/images/default/device_{{item.t}}.png> </a><img alt=\"\" ng-if=\"item.thumbV != undefined && item.thumbV == 0\" src=assets/images/default/device_{{item.t}}.png> <span class=\"thumb-icon status\" ng-if=item.status uib-tooltip=\"{{item.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class={{item.status}}></span></span><div ng-if=\"!item.mac && item.t==\'t\'\"><img alt=\"\" ng-if=!auth.upermissions.dtc src=assets/images/default/device_tag_selected_sm.png?1.0 class=\"img-responsive center-block\"><!-- <svg alt=\"\" ng-if=\"auth.upermissions.dtc\" class=\"img-responsive center-block\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"38\" viewBox=\"0 0 215 135\">\r\n                            <defs></defs>\r\n                            <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(item.tagColor)?item.tagColor:\'#57aee3\'}\" d=\"M2,2H213V133H2V2Z\"/>\r\n                            <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(item.tagColor)?item.tagColor:\'#57aee3\'}\" d=\"M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z\"/>\r\n                          </svg> --> <svg alt=\"\" ng-if=auth.upermissions.dtc class=\"img-responsive center-block marB-4\" xmlns=http://www.w3.org/2000/svg width=64 height=38 viewBox=\"0 0 64 38\"><rect x=1 y=1 width=62 height=36 ng-style=\"{\'fill\':\'#FFFFFF\',\'stroke\':(item.tagColor)?item.tagColor:\'#53a7da\',\'stroke-width\':\'2\',\'stroke-miterlimit\':\'10\'}\"/><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(item.tagColor)?item.tagColor:\'#53a7da\'}\" d=\"M41.72,20.86c0-0.46-0.16-0.87-0.47-1.22l-9.18-9.58c-0.33-0.34-0.76-0.63-1.31-0.87 c-0.55-0.24-1.05-0.36-1.5-0.36h-5.34c-0.44,0-0.83,0.17-1.16,0.51c-0.33,0.34-0.49,0.74-0.49,1.21v5.58c0,0.47,0.11,1,0.34,1.57 c0.23,0.57,0.5,1.02,0.83,1.35l9.18,9.6c0.32,0.33,0.7,0.5,1.16,0.5c0.45,0,0.83-0.17,1.17-0.5l6.3-6.6 C41.57,21.73,41.72,21.33,41.72,20.86z M27.55,14.35c-0.32,0.34-0.71,0.5-1.16,0.5c-0.45,0-0.84-0.17-1.16-0.5 c-0.32-0.34-0.48-0.74-0.48-1.21c0-0.47,0.16-0.88,0.48-1.21c0.32-0.34,0.71-0.5,1.16-0.5c0.45,0,0.84,0.17,1.16,0.5 c0.32,0.34,0.48,0.74,0.48,1.21C28.03,13.61,27.87,14.01,27.55,14.35z\"/></svg></div><div ng-if=\"!item.mac && item.t==\'g\'\"><img alt=\"\" src=assets/images/default/device_group.png class=\"img-responsive center-block blackBdr marB-4\"></div><a ng-if=\"!item.mac && item.t==\'s\' && (!schedule.info.onceCompleted || auth.upermissions.se.dg)\" href=\"\" role=link class=thumb-close ng-click=\"removeFilteredFx(item.id, \'s\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div ng-if=\"!item.mac && item.t==\'s\'\"><img alt=\"\" src=assets/images/default/device_search.png class=\"img-responsive center-block blackBdr marB-4\"></div></span></div></div><!-- <a ng-if=\"item.mac && !item.tagColor\" href=\"\" role=\"link\" aria-label=\"croos_{{$index}}\" class=\"thumb-close\" ng-click=\"removeFilteredFx(item.id, \'d\')\"><span class=\"fa fa-times-circle\" aria-hidden=\"true\"></span></a>\r\n                  <div ng-if=\"item.mac && !item.tagColor\" class=\"device-thumb\">\r\n                    <a ng-href=\"{{dDetailBucket + (item.mac | removeColon) + \'.jpg?\' + item.thumbV}}\" role=\"link\" fancyboxable=\"fbTitleInside\" data-fancybox-title=\"{{item.label}}\" ng-if=\"item.thumbV != undefined && item.thumbV != 0\">\r\n                      <img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (item.mac | removeColon) + \'.jpg&\' + item.thumbV + thumbBigParam}}\" src-error=\"assets/images/default/device_selected_{{item.dType}}.png\">\r\n                    </a>\r\n                    <img alt=\"\" ng-if=\"item.thumbV != undefined && item.thumbV == 0\" src=\"assets/images/default/device_selected_{{item.dType}}.png\">\r\n                    <span class=\"device-thumb-icon status {{item.status}}\" ng-if=\"item.status\" uib-tooltip=\"{{item.statu | capitalize}}\" tooltip-popup-delay=\"500\"></span>\r\n                  </div>--><!-- tag --><!-- <a ng-if=\"!item.mac && item.t==\'t\'\" href=\"\" role=\"link\" class=\"thumb-close\" ng-click=\"removeFilteredFx(item.id, \'t\')\"><span class=\"fa fa-times-circle\" aria-hidden=\"true\"></span></a>\r\n                  <div ng-if=\"!item.mac && item.t==\'t\'\" class=\"thumb\">\r\n                    <img alt=\"\" ng-if=\"!auth.upermissions.dtc\" src=\"assets/images/default/device_tag_selected.png?1.0\" class=\"img-responsive center-block\">\r\n                    <svg alt=\"\" ng-if=\"auth.upermissions.dtc\" class=\"img-responsive center-block\" xmlns=\"http://www.w3.org/2000/svg\" width=\"215\" height=\"135\" viewBox=\"0 0 215 135\">\r\n                      <defs></defs>\r\n                      <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(item.tagColor)?item.tagColor:\'#57aee3\'}\" d=\"M2,2H213V133H2V2Z\"/>\r\n                      <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(item.tagColor)?item.tagColor:\'#57aee3\'}\" d=\"M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z\"/>\r\n                    </svg>\r\n                  </div> --><!-- group --><!-- <a ng-if=\"!item.mac && item.t==\'g\'\" href=\"\" role=\"link\" class=\"thumb-close\" ng-click=\"removeFilteredFx(item.id, \'g\')\"><span class=\"fa fa-times-circle\" aria-hidden=\"true\"></span></a>\r\n                  <div ng-if=\"!item.mac && item.t==\'g\'\" class=\"thumb\">\r\n                    <img alt=\"\" src=\"assets/images/default/device_group_selected.png\" class=\"img-responsive center-block blackBdr\">\r\n                  </div> --><!-- search --><!-- <a ng-if=\"!item.mac && item.t==\'s\'\" href=\"\" role=\"link\" class=\"thumb-close\" ng-click=\"removeFilteredFx(item.id, \'s\')\"><span class=\"fa fa-times-circle\" aria-hidden=\"true\"></span></a>\r\n                  <div ng-if=\"!item.mac && item.t==\'s\'\" class=\"thumb\">\r\n                    <img alt=\"\" src=\"assets/images/default/device_search_selected.png\" class=\"img-responsive center-block blackBdr\">\r\n                  </div> --><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{item.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{item.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(schedule.devices.device.length > 0 || schedule.devices.tag.length > 0 || schedule.devices.group.length > 0 || schedule.devices.search.length > 0) && selectedFilteredItems.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div></div><ul class=\"list-inline multiple-selected\" ng-if=\"auth.upreferences.deviceView == \'l\'\" ng-class=\"{\'marT10\':allSelItems.list.length>auth.upreferences.dpc && selectedFilteredItems.length}\"><!-- device list view --><div class=\"table table-md whiteRow\" ng-class=\"{\'hide\':selectedFilteredItems.length == 0}\"><div class=\"row th\"><div class=col-xs-7>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-right noPadL\">{{\'cm.label.25\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"item in selectedFilteredItems = (allSelItems.list | itemsPerPageClone:selPaginationControls.pageSize) track by item.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}}><div ng-if=\"item.mac && !item.tagColor\"><div class=\"col-xs-7 text-ellipsis\"><span class=\"deviceStatus {{item.status}}\" uib-tooltip=\"{{item.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{item.label}}</div><div class=\"col-xs-4 text-ellipsis\">{{item.mac}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"removeFilteredFx(item.id, \'d\')\" ng-if=\"!schedule.info.onceCompleted || auth.upermissions.se.d\"><span class=\"fa fa-remove\"></span></a></div></div><div ng-if=\"!item.mac && item.t==\'t\'\"><div class=\"col-xs-7 text-ellipsis\"><span ng-if=auth.upermissions.dtc aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{item.tagColor}}></ng-tag-icon></span><span class=\"fa fa-tag marR5\" ng-if=!auth.upermissions.dtc uib-tooltip=\"{{\'cm.label.94\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{item.label}}</div><div class=\"col-xs-4 text-muted text-sm\">N/A</div><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"removeFilteredFx(item.id, \'t\')\" ng-if=\"!schedule.info.onceCompleted || auth.upermissions.se.dt\"><span class=\"fa fa-remove\"></span></a></div></div><!-- group list --><div ng-if=\"!item.mac && item.t==\'g\'\"><div class=\"col-xs-7 text-ellipsis\"><span class=\"fa fa-clone marR5\" uib-tooltip=\"{{\'cm.label.79\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{item.label}}</div><div class=\"col-xs-4 text-muted text-sm\">N/A</div><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"removeFilteredFx(item.id, \'g\')\" ng-if=\"!schedule.info.onceCompleted || auth.upermissions.se.dg\"><span class=\"fa fa-remove\"></span></a></div></div><!-- saved search --><div ng-if=\"!item.mac && item.t==\'s\'\"><div class=\"col-xs-7 text-ellipsis\"><span class=\"fa fa-search marR5\" uib-tooltip=\"{{\'d.tab.5\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{item.label}}</div><div class=\"col-xs-4 text-muted text-sm\">N/A</div><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=\"removeFilteredFx(item.id, \'s\')\" ng-if=\"!schedule.info.onceCompleted || auth.upermissions.se.dg\"><span class=\"fa fa-remove\"></span></a></div></div></li><!-- tag list --><!-- <li class=\"row\" ng-repeat=\"tag in scheduleDeviceTag = (schedule.devices.tag | customSearch:{key:selectedSearch.text, module:\'d\'})\"  data-id=\"{{tag.id}}\" data-type=\"tag\" ng-if=\"schedule.devices.tag.length > 0\">\r\n                  </li> --><!-- group list --><!-- <li class=\"row\" ng-repeat=\"group in scheduleDeviceGrp = (schedule.devices.group | customSearch:{key:selectedSearch.text, module:\'dSel\'})\"  data-id=\"{{group.id}}\" data-type=\"group\" ng-if=\"schedule.devices.group.length > 0\">\r\n                    <div class=\"col-xs-7 text-ellipsis\">\r\n                      <span class=\"fa fa-clone marR5\" uib-tooltip=\"{{\'cm.label.79\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span>\r\n                      {{group.label}}\r\n                    </div>\r\n                    <div class=\"col-xs-4 text-muted text-sm\">N/A</div>\r\n                    <div class=\"col-xs-1 text-right\">\r\n                      <a href=\"\" class=\"text-danger\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=\"true\" ng-click=\"removeFilteredFx(group.id, \'g\')\"><span class=\"fa fa-remove\"></span></a>\r\n                    </div>\r\n                  </li> --><!-- saved search --><!-- <li class=\"row\" ng-repeat=\"search in scheduleDeviceSearch = (schedule.devices.search | customSearch:{key:selectedSearch.text, module:\'dSel\'})\"  data-id=\"{{search.id}}\" data-type=\"search\"  ng-if=\"schedule.devices.search.length > 0\">\r\n                    <div class=\"col-xs-7 text-ellipsis\" >\r\n                      <span class=\"fa fa-search marR5\" uib-tooltip=\"{{\'d.tab.5\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span>\r\n                      {{search.label}}\r\n                    </div>\r\n                    <div class=\"col-xs-4 text-muted text-sm\">N/A</div>\r\n                    <div class=\"col-xs-1 text-right\">\r\n                      <a href=\"\" class=\"text-danger\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=\"true\" ng-click=\"removeFilteredFx(search.id, \'s\')\"><span class=\"fa fa-remove\"></span></a>\r\n                    </div>\r\n                  </li> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(schedule.devices.device.length > 0 || schedule.devices.tag.length > 0 || schedule.devices.group.length > 0 || schedule.devices.search.length > 0) && selectedFilteredItems.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div></ul></div><!-- todo FIX API RESPONSE --><!-- **With tag** --><div class=msg-warning lang={{auth.lang}} ng-if=\"(schedule.devices.device.length == 0 && schedule.devices.tag.length == 0 && schedule.devices.group.length == 0 && schedule.devices.search.length == 0) || selectedFilteredItems.length == 0\">{{\'cm.msg.4\' | translate}} <span ng-if=hiddenDevices>{{\'s.p_s.msg.14\' | translate}}</span></div></div></section></div></div></div><footer class=panel-footer ng-if=!detailLoading><ng-btn-list info=\"{onceCompleted:schedule.info.onceCompleted, isCompleted:schedule.info.isCompleted, sp:saveProcessing, sc:saveCloseProcessing, other:schedule.info.hideFrameSelection,ls:schedule.info.ls}\" permission=se back-btn=\"backBtn(\'d\');\" next-callback=saveSchedule(se.step); save-callback=\"saveSchedule(se.step, \'sc\');\" cancel-fx=\"cancelFx(\'pop\');\" applied-device-list=appliedDeviceListFx();></ng-btn-list><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'conflict\'\" aria-live=polite role=status>{{\'s.p_s.msg.7\' | translate}}:</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingDuration}}</span></span> <span ng-if=\"errType==\'count\'\" aria-live=polite role=status>{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingCount}}</span></span> <span ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{allowedFolder}}</span></span><!-- **With tag** --> <span ng-if=\"errType==\'selectGroup\'\" aria-live=polite role=status>{{\'s.p_s.msg.29\' | translate}}</span> <span ng-if=\"errType==\'zgDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.47\' | translate}}</span> <span ng-if=\"errType==\'bcExist\'\" aria-live=polite role=status>{{\'s.p_s.msg.48\' | translate}}</span> <span ng-if=\"errType==\'cExist\'\" aria-live=polite role=status>{{\'s.p_s.msg.49\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.56\' | translate}}</span><!-- Single sort save --> <span ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.31\' | translate}}</span> <span ng-if=\"errType==\'mcContent\'\" aria-live=polite role=status>{{\'s.p_s.msg.30\' | translate}}</span> <span ng-if=\"errType==\'mcSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.32\' | translate}}</span> <span ng-if=\"errType==\'lsError\'\" aria-live=polite role=status>{{\'s.p_s.msg.39\' | translate}}</span> <span ng-if=\"errType==\'ccError\'\" aria-live=polite role=status>{{\'s.p_s.msg.41\' | translate}}</span> <span ng-if=\"errType==\'eslDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.46\' | translate}}</span> <span ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'s.p_s.msg.50.1\' | translate}}</span> <span ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</span> <span ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</span> <span ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</span> <span ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</span> <span ng-if=\"errType==\'thirdPartyCA\'\" aria-live=polite role=status>{{\'s.p_s.msg.71\' | translate}}</span> <span ng-if=\"errType==\'formN\'\" aria-live=polite role=status>{{\'s.p_s.msg.1\' | translate}}</span> <span ng-if=\"errType==\'formS\'\" aria-live=polite role=status>{{\'s.p_s.msg.3\' | translate}}</span> <span ng-if=\"errType==\'formC\'\" aria-live=polite role=status>{{schedule.info.ls?\'s.p_s.msg.40\':\'s.p_s.msg.2\' | translate}}</span> <span ng-if=\"errType==\'formD\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</span> <span ng-if=\"errType==\'formF\'\" aria-live=polite role=status>{{\'s.p_s.msg.16\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/sFrame.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>5</p></span></span><!-- <a href class=\"marR10\" ui-sref=\"hub.schedules.s\">{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'s.p_s.body.1\' | translate}}</span><span ng-if=\"schedule.info.label\" class=\"text-muted\">[ {{schedule.info.label}} ]</span> --> <a href class=marR10 role=link ui-sref=hub.schedules.s>{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=!detailLoading>{{schedule.info.onceCompleted == \'\'?\'s.btn.1\':\'s.p_s.body.1\' | translate}}</span><span ng-if=schedule.info.label class=text-muted>[ {{schedule.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 5}\'}}: {{\'s.p_s.body.3\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>5</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=\"col-xs-2 overflow-auto\" ng-attr-style=height:{{getAvailableHeight(280)}}px;><ul class=\"list-inline thumb-list text-center\" ng-class=\"{\'padTB10\':curLayout}\"><li ng-repeat=\"layout in frameLayout.frameLayouts\" ng-click=\"layoutFx($event, layout, $index+1);\" class=fl data-id=\"{{$index + 1}}\"><div class=thumb-img><img alt=\"\" ng-src=\"{{frameLayout.info.timthumb + frameLayout.info.bucket + layout.layoutId + \'.png\' + thumbParam + \'&\' + layout.thumbV}}\"></div><div class=thumb-label>{{layout.label}}</div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!curLayout && accessibleFrame\">{{\'s.p_s.msg.15\' | translate:{counter: counter} }}</div></div><div class=\"col-xs-8 bdrL bdrR\"><div id=canvas class=\"overflow-auto canvasBg\" ng-click=deselectAllFrames(); ng-attr-style=height:{{getAvailableHeight(280)}}px;><div class=flGrid ng-if=curLayout ng-attr-style=\"width:{{curLayout.width*canvas.zoom}}px; height:{{curLayout.height*canvas.zoom}}px;\"><div ng-repeat=\"frame in curLayout.frames\" data-index={{$index}} class=frameDrag ng-attr-style=left:{{frame.x*canvas.zoom}}px;top:{{frame.y*canvas.zoom}}px;z-index:{{frame.z}} uib-tooltip=\"{{\'s.p_s.body.4\' | translate}}\" tooltip-append-to-body=true tooltip-enable=!frame.selectable>{{brTL = (frame.settings.br.tl?(frame.settings.br.tl*canvas.zoom)+\'px\':0);\"\"}} {{brTR = (frame.settings.br.tr?(frame.settings.br.tr*canvas.zoom)+\'px\':0);\"\"}} {{brBL = (frame.settings.br.bl?(frame.settings.br.bl*canvas.zoom)+\'px\':0);\"\"}} {{brBR = (frame.settings.br.br?(frame.settings.br.br*canvas.zoom)+\'px\':0);\"\"}}<div data-id={{frame.id}} data-index={{$index}} class=\"frame overflow-hidden\" ng-class=\"{\'selected\':frame.selected,\'nonSelectable\':!frame.selectable}\" ng-click=\"selectFrame($event, frame, curLayout.layoutId, curLayout.assignment, curLayout.dids);\" ng-attr-style=\"width:{{frame.width*canvas.zoom | setDecimal:0}}px;height:{{frame.height*canvas.zoom | setDecimal:0}}px;background-color:{{frame.rgba}};transform:rotate({{frame.rotation}}deg);border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}};box-shadow:{{frame.settings.ish.isShadow? \'inset \' + frame.settings.ish.hl +\'px \'+ frame.settings.ish.vl +\'px \'+ frame.settings.ish.br +\'px \'+ frame.settings.ish.sr +\'px \'+ frame.settings.ish.rgba:\'\'}}\"><div class=name><div>{{frame.label}}</div></div></div></div></div></div></div><div class=col-xs-2><div class=form-group><div class=input-group><span class=input-group-addon>{{\'cm.label.57\' | translate}}:</span><select class=form-control ng-model=canvas.zoom><option value={{fitToFrame}}>{{\'fl.p_cfl.label.23\' | translate}}</option><option value=1>100%</option><option value=0.75>75%</option><option value=0.5>50%</option><option value=0.25>25%</option><option value=0.1>10%</option></select></div></div><div class=\"panel-heading pad10\">{{\'s.p_s.label.9\' | translate}}</div><div class=\"tab-body overflow-auto\" ng-attr-style=height:{{getAvailableHeight(425)}}px;><ul class=\"layer-container list-unstyled noMar\" ng-if=curLayout><li ng-repeat=\"frame in curLayout.frames | orderBy: \'z\':true\" class=\"layer text-ellipsis\" data-id={{frame.id}} ng-click=\"selectFrame($event, frame, curLayout.layoutId, curLayout.assignment, curLayout.dids);\" ng-class=\"{\'selected\':frame.selected}\" uib-tooltip=\"{{\'s.p_s.body.4\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left tooltip-enable=!frame.selectable><span class=layerBg><span ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.rgba}\"></span> </span><span class=layerFrameLabel>{{frame.label}}</span></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!curLayout && accessibleFrame\">{{\'s.p_s.msg.6\' | translate}}</div></div></div></div></div><footer class=panel-footer ng-if=\"!detailLoading && !footerLoading\"><ng-btn-list info=\"{onceCompleted:schedule.info.onceCompleted, isCompleted:schedule.info.isCompleted, sp:saveProcessing, sc:saveCloseProcessing, other:isAllFramesSelected}\" permission=se back-btn=\"backBtn(\'f\');\" save-callback=\"saveSchedule(se.step, \'sc\');\" next-select=nextFrameFx(); cancel-fx=\"cancelFx(\'pop\');\"></ng-btn-list><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'conflict\'\" aria-live=polite role=status>{{\'s.p_s.msg.7\' | translate}}:</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingDuration}}</span></span> <span ng-if=\"errType==\'count\'\" aria-live=polite role=status>{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingCount}}</span></span> <span ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{allowedFolder}}</span></span> <span ng-if=\"errType==\'selectGroup\'\" aria-live=polite role=status>{{\'s.p_s.msg.29\' | translate}}</span><!-- Single sort save --> <span ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.31\' | translate}}</span> <span ng-if=\"errType==\'mcContent\'\" aria-live=polite role=status>{{\'s.p_s.msg.30\' | translate}}</span> <span ng-if=\"errType==\'mcSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.32\' | translate}}</span> <span ng-if=\"errType==\'lsError\'\" aria-live=polite role=status>{{\'s.p_s.msg.39\' | translate}}</span> <span ng-if=\"errType==\'ccError\'\" aria-live=polite role=status>{{\'s.p_s.msg.41\' | translate}}</span> <span ng-if=\"errType==\'eslDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.46\' | translate}}</span> <span ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'s.p_s.msg.50.1\' | translate}}</span> <span ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</span> <span ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</span> <span ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</span> <span ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</span> <span ng-if=\"errType==\'thirdPartyCA\'\" aria-live=polite role=status>{{\'s.p_s.msg.71\' | translate}}</span> <span ng-if=\"errType==\'formN\'\" aria-live=polite role=status>{{\'s.p_s.msg.1\' | translate}}</span> <span ng-if=\"errType==\'formS\'\" aria-live=polite role=status>{{\'s.p_s.msg.3\' | translate}}</span> <span ng-if=\"errType==\'formC\'\" aria-live=polite role=status>{{schedule.info.ls?\'s.p_s.msg.40\':\'s.p_s.msg.2\' | translate}}</span> <span ng-if=\"errType==\'formD\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</span> <span ng-if=\"errType==\'formF\'\" aria-live=polite role=status>{{\'s.p_s.msg.16\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/sName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=!schedule.info.ls></i><span class=stepGray ng-if=!schedule.info.ls><p>5</p></span></span><a href=\"\" role=link ui-sref=hub.schedules.s class=marR10>{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=!detailLoading>{{schedule.info.onceCompleted == \'\'?\'s.btn.1\':\'s.p_s.body.1\' | translate}}</span><span ng-if=schedule.info.label class=text-muted>[ {{schedule.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'cm.label.55\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=!schedule.info.ls></i><span class=stepGray ng-if=!schedule.info.ls><p>5</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'s.body.1\' | translate}}</label><input type=text id=label class=form-control ng-model=schedule.info.label autocomplete=off maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'s.body.1\' | translate}}\" aria-labelledby=\"{{\'s.body.1\' | translate}}\"></div><div class=form-group><label>{{\'s.p_s.label.1\' | translate}} <span class=text-muted ng-if=auth.upermissions.sar>({{\'cm.label.26\' | translate}})</span></label><select class=form-control ng-model=schedule.info.group ng-options=\"sg.label for sg in sGroups track by sg.id\" ng-if=\"!auth.upermissions.sar && sGroups.length == 1\"><option value=\"\" ng-disabled=true ng-if=\"!auth.upermissions.sar && !schedule.info.isCompleted\">{{\'s.p_s.label.1\' | translate}}</option></select><select class=form-control ng-model=schedule.info.group ng-options=\"sg.label for sg in sGroups track by sg.id\" ng-if=\"(!auth.upermissions.sar && sGroups.length > 1) || (auth.upermissions.sar && sGroups.length > 0)\" ng-change=sGroupsFx()><option value=\"\" ng-disabled=true ng-if=\"!auth.upermissions.sar && !schedule.info.isCompleted\">{{\'s.p_s.label.1\' | translate}}</option></select><div class=msg-warning lang={{auth.lang}} ng-if=\"!auth.upermissions.sar && !sGroups.length\"><span ng-if=auth.upermissions.s><div class=marB5>{{\'s.p_s.msg.27\' | translate}}</div><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=groupCUOpen();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'s.btn.2\' | translate}}</button> </span><span ng-if=!auth.upermissions.s>{{\'s.p_s.msg.24\' | translate}}</span></div></div><div class=form-group><label for=sPriority>{{\'s.p_s.label.12\' | translate}} <span class=text-muted>({{(schPriority == \'h\') ? \'ms.p_s.serverPer.36.1\': \'ms.p_s.serverPer.36.2\' | translate}})</span></label><input type=number id=sPriority class=form-control ng-model=schedule.info.priority min=1 aria-label=\"{{\'s.p_s.label.12\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.12\' | translate}}\"></div><div class=form-group ng-if=\"((auth.upermissions.desktop || auth.upermissions.epd || auth.upermissions.cod || auth.upermissions.f45Workout || auth.upermissions.sovr) && schedule.info.onceCompleted==0) || (schedule.info.onceCompleted==1 && (schedule.info.ls==1 || schedule.info.ls==2 || schedule.info.ls==3 || schedule.info.ls==4 || schedule.info.ls==5 || schedule.info.ls==6))\"><label>{{\'cm.label.69\' | translate}}</label><select id=ls ng-if=\"schedule.info.onceCompleted==0 && !schedule.stepOne\" class=form-control ng-model=schedule.info.ls ng-disabled=decId aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=\"\">{{\'s.p_s.label.22\' | translate}}</option><option value=4 ng-if=auth.upermissions.cod>{{\'cl.widget.cod.1\' | translate}}</option><option value=2 ng-if=auth.upermissions.desktop>{{\'s.p_s.label.15\' | translate}}</option><option value=3 ng-if=auth.upermissions.epd>{{\'d.label.1.8\' | translate}}</option><option value=1 ng-if=auth.upermissions.desktop>{{\'s.p_s.label.14\' | translate}}</option><option value=6 ng-if=auth.upermissions.sovr>{{\'s.p_s.label.21\' | translate}}</option></select><div class=schType ng-if=\"!schedule.info.ls && schedule.stepOne\"><span>{{\'s.p_s.label.22\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==1 && schedule.stepOne\"><span>{{\'s.p_s.label.14\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==2 && schedule.stepOne\"><span>{{\'s.p_s.label.15\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==3 && schedule.stepOne\"><span>{{\'d.label.1.8\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==4 && schedule.stepOne\"><span>{{\'cl.widget.cod.1\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==5 && schedule.stepOne\"><span>{{\'cl.widget.wf45.14\' | translate}}</span></div><div class=schType ng-if=\"schedule.info.ls==6 && schedule.stepOne\"><span>{{\'s.p_s.label.21\' | translate}}</span></div></div><div class=form-group ng-if=\"sGroups.length > 0\"><div><label>{{\'cm.label.15\' | translate}}</label></div><div ng-if=\"schedule.info.group && schedule.info.group.id && schedule.info.group.id != 0\"><div class=\"badge bg-muted marB5\">{{\'s.p_s.label.2\' | translate}}</div><ng-permission-brief permission=schedule.info.group.permission pid=schedule.info.group.id module=\"\'schedulegroupschedule\'\" assignable=schedule.permission other=\"{sig:\'sig\', id:schedule.info.id}\"></ng-permission-brief></div><ng-permission-brief permission=schedule.permission pid=decId module=\"\'schedule\'\" assignable=schedule.permission ng-if=\"!schedule.info.group.id || schedule.info.group.id == 0\"></ng-permission-brief></div></div></div></div><footer class=panel-footer ng-if=!detailLoading><ng-btn-list info=\"{onceCompleted:schedule.info.onceCompleted, isCompleted:schedule.info.isCompleted, sp:saveProcessing, sc:saveCloseProcessing}\" permission=se next-callback=saveSchedule(se.step); save-callback=\"saveSchedule(se.step, \'sc\');\" cancel-fx=\"cancelFx(\'pop\');\"></ng-btn-list><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'conflict\'\" aria-live=polite role=status>{{\'s.p_s.msg.7\' | translate}}:</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingDuration}}</span></span> <span ng-if=\"errType==\'count\'\" aria-live=polite role=status>{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingCount}}</span></span> <span ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{allowedFolder}}</span></span> <span ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</span> <span ng-if=\"errType==\'priority\'\" aria-live=polite role=status>{{\'s.p_s.msg.37\' | translate}}</span> <span ng-if=\"errType==\'priorityMin\'\" aria-live=polite role=status>{{\'s.p_s.msg.37.1\' | translate}}</span> <span ng-if=\"errType==\'selectGroup\'\" aria-live=polite role=status>{{sGroups.length > 0?\'s.p_s.msg.28\':\'s.p_s.msg.27\' | translate}}</span><!-- Single sort save --> <span ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.31\' | translate}}</span> <span ng-if=\"errType==\'mcContent\'\" aria-live=polite role=status>{{\'s.p_s.msg.30\' | translate}}</span> <span ng-if=\"errType==\'mcSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.32\' | translate}}</span> <span ng-if=\"errType==\'lsError\'\" aria-live=polite role=status>{{\'s.p_s.msg.39\' | translate}}</span> <span ng-if=\"errType==\'ccError\'\" aria-live=polite role=status>{{\'s.p_s.msg.41\' | translate}}</span> <span ng-if=\"errType==\'eslDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.46\' | translate}}</span> <span ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'s.p_s.msg.50.1\' | translate}}</span> <span ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</span> <span ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</span> <span ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</span> <span ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</span> <span ng-if=\"errType==\'sovrError\'\" aria-live=polite role=status>{{\'s.p_s.msg.70\' | translate}}</span> <span ng-if=\"errType==\'thirdPartyCA\'\" aria-live=polite role=status>{{\'s.p_s.msg.71\' | translate}}</span> <span ng-if=\"errType==\'formN\'\" aria-live=polite role=status>{{\'s.p_s.msg.1\' | translate}}</span> <span ng-if=\"errType==\'formS\'\" aria-live=polite role=status>{{\'s.p_s.msg.3\' | translate}}</span> <span ng-if=\"errType==\'formC\'\" aria-live=polite role=status>{{schedule.info.ls?\'s.p_s.msg.40\':\'s.p_s.msg.2\' | translate}}</span> <span ng-if=\"errType==\'formD\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</span> <span ng-if=\"errType==\'formF\'\" aria-live=polite role=status>{{\'s.p_s.msg.16\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/sSchedule.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=\"!schedule.info.ls && !detailLoading\"></i><span class=stepGray ng-if=\"!schedule.info.ls && !detailLoading\"><p>5</p></span></span><!-- <a href class=\"marR10\" ui-sref=\"hub.schedules.s\">{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'s.p_s.body.1\' | translate}}</span><span ng-if=\"schedule.info.label\" class=\"text-muted\">[ {{schedule.info.label}} ]</span> --> <a href class=marR10 role=link ui-sref=hub.schedules.s>{{\'s.tab.1\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=!detailLoading>{{schedule.info.onceCompleted == \'\'?\'s.btn.1\':\'s.p_s.body.1\' | translate}}</span><span ng-if=schedule.info.label class=text-muted>[ {{schedule.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'cm.label.36\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span><i></i><span class=stepGray><p>3</p></span><i></i><span class=stepGray><p>4</p></span><i ng-if=\"!schedule.info.ls && !detailLoading\"></i><span class=stepGray ng-if=\"!schedule.info.ls && !detailLoading\"><p>5</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=!detailLoading><div class=row><div class=col-xs-4><div class=form-group><label><input type=radio role=radio ng-model=dateRange.type ng-click=\"resetFx(\'c\');\" value=s><label></label>{{\'cm.label.9\' | translate}}</label><label class=marL10 ng-if=\"schedule.info.ls != 4\"><input type=radio role=radio ng-model=dateRange.type ng-click=\"resetFx(\'a\');\" value=m ng-disabled=\"schedule.schedule.forever || schedule.schedule.type==\'c\'\"><label></label>{{\'cm.label.95\' | translate}}</label><div class=row><div ng-class=\"dateRange.type==\'m\'?\'col-xs-10\':\'col-xs-12\'\"><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=sDateRange class=\"form-control picker\" name=datetimes ng-model=schedule.schedule.dateRange format=MM/DD/YYYY readonly ng-disabled=schedule.schedule.forever aria-label=dateRange></div></div><div class=\"col-xs-2 noPadL\"><button type=button role=button ng-if=\"dateRange.type==\'m\'\" class=\"btn btn-success\" id=addMultipleDate ng-click=addMultipleDateFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div></div><div ng-if=\"dateRange.type==\'s\' && ((schedule.schedule.type == \'c\' && schedule.schedule.subType!=\'dce\') || schedule.schedule.type==\'a\')\"><label><input type=checkbox ng-model=schedule.schedule.forever role=checkbox ng-change=foreverFx(); ng-disabled=\"schedule.info.ls==3\"><label></label>{{\'cm.label.16\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'s.p_s.msg.26\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label></div></div><div class=\"col-xs-6 marL20 padL20 bdrLd\"><div class=form-group ng-class=\"{noMarB: schedule.schedule.type==\'c\'}\"><div><label><input type=radio role=radio name=timeOpt ng-model=schedule.schedule.type value=a ng-disabled=\"schedule.info.ls==3\"><label></label>{{\'s.p_s.label.3\' | translate}}</label></div><div ng-if=\"dateRange.type==\'s\' && schedule.info.ls != 4\"><label><input type=radio role=radio name=timeOpt ng-model=schedule.schedule.type value=c ng-click=subTypeFx(); ng-disabled=\"schedule.info.ls==3\"><label></label>{{\'s.p_s.label.4\' | translate}}</label></div><!-- <div class=\"customTime\" > --><div class=customTime ng-if=\"schedule.schedule.type==\'c\' && schedule.info.ls != 4\" role=radiogroup aria-labelledby=radiogroup><label ng-class=\"{\'disabled\':schedule.schedule.timingList.length > 0 && schedule.schedule.subType != \'d\'}\"><input type=radio role=radio name=customTimeOpt ng-model=schedule.schedule.subType value=d ng-change=subTypeFx(); ng-disabled=\"schedule.schedule.timingList.length > 0\"><label></label>{{\'s.p_s.label.4.1\' | translate}}</label><label class=\"marL10 marR10\" ng-class=\"{\'disabled\':schedule.info.hideFrameSelection || (schedule.schedule.timingList.length > 0 && schedule.schedule.subType != \'w\')}\"><input type=radio role=radio name=customTimeOpt ng-model=schedule.schedule.subType value=w ng-change=subTypeFx(); ng-disabled=\"schedule.info.hideFrameSelection || schedule.schedule.timingList.length > 0\"><label></label>{{\'s.p_s.label.4.2\' | translate}}</label><label class=marR10 ng-class=\"{\'disabled\':schedule.info.hideFrameSelection || (schedule.schedule.timingList.length > 0 && schedule.schedule.subType != \'m\')}\"><input type=radio role=radio name=customTimeOpt ng-model=schedule.schedule.subType value=m ng-change=subTypeFx(); ng-disabled=\"schedule.info.hideFrameSelection || schedule.schedule.timingList.length > 0\"><label></label>{{\'s.p_s.label.4.3\' | translate}}</label><label class=marR10 ng-class=\"{\'disabled\':schedule.info.hideFrameSelection || (schedule.schedule.timingList.length > 0 && schedule.schedule.subType != \'r\')}\"><input type=radio role=radio name=customTimeOpt ng-model=schedule.schedule.subType value=r ng-change=subTypeFx(); ng-disabled=\"schedule.info.hideFrameSelection || schedule.schedule.timingList.length > 0\"><label></label>{{\'s.p_s.label.4.4\' | translate}}</label><label ng-class=\"{\'disabled\':schedule.info.hideFrameSelection || (schedule.schedule.timingList.length > 0 && schedule.schedule.subType != \'dce\')}\"><input type=radio role=radio name=customTimeOpt ng-model=schedule.schedule.subType value=dce ng-change=subTypeFx(); ng-disabled=\"schedule.info.hideFrameSelection || schedule.schedule.timingList.length > 0\"><label></label>{{\'s.p_s.label.4.5\' | translate}}</label></div></div></div></div><!-- <div > --><div ng-if=\"schedule.schedule.type==\'c\' && dateRange.type==\'s\' && schedule.schedule.subType != \'dce\'\"><h5 class=\"panel-inner-tab marT15 marB10\">{{\'s.p_s.label.5\' | translate}}</h5><div class=\"bg-light pad10\"><div class=row><div class=col-xs-2><label for=frequency>{{\'s.p_s.label.6\' | translate}}</label><input type=text id=frequency ng-model=customTime.frequency class=form-control disabled aria-label=\"{{\'s.p_s.label.6\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.6\' | translate}}\"></div><div class=col-xs-2><span ng-if=\"schedule.schedule.subType != \'r\'\"><span ng-if=\"schedule.schedule.subType != \'m\'\"><label>{{\'s.p_s.label.7\' | translate}}</label><select class=form-control ng-model=customTime.days ng-options=\"day.id as day.label for day in curDays\" multiple></select></span><span ng-if=\"schedule.schedule.subType == \'m\'\"><label>{{\'cm.label.7\' | translate}}</label><select class=form-control ng-model=customTime.days ng-options=\"day.id as day.label for day in [] | minmax:1:32\" multiple></select></span></span><span ng-if=\"schedule.schedule.subType == \'r\'\"><label translate=\"{{\'s.p_s.label.8\'}}\" translate-values=\"{htmlTagO: \'<sup>\', htmlTagC: \'</sup>\'}\"></label><input type=number class=form-control ng-model=customTime.days min=1 aria-label=\"{{\'s.p_s.label.8\'}}\" aria-labelledby=\"{{\'s.p_s.label.8\'}}\"></span></div><div class=\"col-xs-3 timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"customTime.startTime | date:\'shortTime\'\" readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=customTime.startTime hour-step=1 minute-step=5></div></div></span></div><div class=\"col-xs-3 timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"customTime.endTime | date:\'shortTime\'\" readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=customTime.endTime hour-step=1 minute-step=5></div></div></span></div><div class=col-xs-2><label>&nbsp;</label><div><button type=button role=button class=\"btn btn-success\" id=addTiming ng-click=addTimingFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div></div></div><div class=marT25><div class=\"table table-md\" ng-if=\"schedule.schedule.timingList.length > 0\"><div class=\"row th\"><div class=col-xs-4>{{\'s.p_s.label.6\' | translate}}</div><div class=col-xs-3><span ng-if=\"schedule.schedule.subType == \'d\' || schedule.schedule.subType == \'w\'\">{{\'s.p_s.label.7\' | translate}}</span> <span ng-if=\"schedule.schedule.subType == \'m\'\">{{\'cm.label.7\' | translate}}</span> <span ng-if=\"schedule.schedule.subType == \'r\'\">{{\'s.p_s.label.4.4\' | translate | camelCase}}</span></div><div class=col-xs-2>{{\'cm.label.12\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.13\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><div class=row ng-repeat=\"timing in schedule.schedule.timingList \"><div class=col-xs-4>{{timing.frequency}}</div><div class=col-xs-3><span ng-if=\"timing.day == \'\'\">{{\'s.p_s.label.4.1\' | translate}}</span> <span ng-if=\"schedule.schedule.subType == \'w\'\"><span ng-if=\"timing.day == 1\">{{\'s.p_s.label.4.2.1\' | translate}}</span> <span ng-if=\"timing.day == 2\">{{\'s.p_s.label.4.2.2\' | translate}}</span> <span ng-if=\"timing.day == 3\">{{\'s.p_s.label.4.2.3\' | translate}}</span> <span ng-if=\"timing.day == 4\">{{\'s.p_s.label.4.2.4\' | translate}}</span> <span ng-if=\"timing.day == 5\">{{\'s.p_s.label.4.2.5\' | translate}}</span> <span ng-if=\"timing.day == 6\">{{\'s.p_s.label.4.2.6\' | translate}}</span> <span ng-if=\"timing.day == 7\">{{\'s.p_s.label.4.2.7\' | translate}}</span> </span><span ng-if=\"schedule.schedule.subType == \'m\'\">{{timing.day}}</span> <span ng-if=\"schedule.schedule.subType == \'r\'\">{{timing.day}}</span></div><div class=col-xs-2>{{timing.startTime | changeTimeFormat}}</div><div class=col-xs-2>{{timing.endTime | changeTimeFormat}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=previewDateFx(timing); ng-if=\"schedule.schedule.type == \'c\' && schedule.schedule.subType != \'d\'\" ng-disabled=\"previewProcessing || previewProcessingEye\"><span class=\"fa fa-eye\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=removeTimingOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"schedule.schedule.timingList.length == 0\">{{\'s.p_s.msg.5\' | translate}}</div><div class=\"text-right marT15\" ng-if=\"schedule.schedule.type == \'c\' && schedule.schedule.subType != \'d\' && schedule.schedule.timingList.length >1\"><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=previewDateFx(); ng-disabled=\"previewProcessing || previewProcessingEye\"><span ng-class=\"previewProcessing?\'fa fa-repeat fa-spin\':\'glyphicon glyphicon-list-alt\'\" aria-hidden=true></span>{{\'s.p_s.btn.5\' | translate}}</button></div></div></div><!-- exclude date range --><div ng-if=\"schedule.schedule.type==\'c\' && dateRange.type==\'s\' && schedule.schedule.subType == \'dce\'\"><h5 class=\"panel-inner-tab marT15 marB10\">{{\'s.p_s.label.5\' | translate}}</h5><div class=\"bg-light pad10\"><div class=row><div class=col-xs-3><label>{{\'s.p_s.label.4.5\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker ex-picker\" ng-model=excludeDR format=MM/DD/YYYY readonly aria-label=\"{{\'s.p_s.label.4.5\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.5\' | translate}}\"></div></div><div class=col-xs-2><label>&nbsp;</label><div><button type=button role=button class=\"btn btn-success\" id=addMultipleDate ng-click=addMultipleDateFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div></div></div><div class=marT25><div class=\"table table-md\" ng-if=\"schedule.schedule.timingList.length > 0\"><div class=\"row th\"><div class=col-xs-5>{{\'cm.label.10\' | translate}}</div><div class=col-xs-5>{{\'cm.label.11\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><div class=row ng-repeat=\"timing in schedule.schedule.timingList\"><div class=col-xs-5>{{timing.startDate | date:\'mediumDate\'}}</div><div class=col-xs-5>{{timing.endDate | date:\'mediumDate\'}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=text-danger ng-click=removeTimingOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"schedule.schedule.timingList.length == 0\">{{\'s.p_s.msg.43\' | translate}}</div></div></div><!-- multiple date range --><div ng-if=\"dateRange.type==\'m\'\"><h5 class=\"panel-inner-tab marT15 marB10\">{{\'s.p_s.label.16\' | translate}}</h5><div><div class=\"table table-md\" ng-if=\"schedule.schedule.timingList.length > 0\"><div class=\"row th\"><div class=col-xs-5>{{\'cm.label.10\' | translate}}</div><div class=col-xs-5>{{\'cm.label.11\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><ul class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(270)}}px><div class=folderQuad ng-repeat=\"timing in schedule.schedule.timingList track by $index\"><!--Folder--><div class=row><div class=col-xs-5>{{timing.startDate | date:\'mediumDate\'}}</div><div class=col-xs-5>{{timing.endDate | date:\'mediumDate\'}}</div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-success btn-xs marR5\" ng-click=\"exDateOpenFx(timing, $index);\">{{\'s.btn.4\' | translate}}</button> <a href=\"\" role=link class=text-danger ng-click=removeTimingOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"bg-gray padTB10 padLR20\" ng-if=timing.ex.length><div class=table><li class=row ng-repeat=\"exDate in timing.ex\"><div class=panel-body><div class=col-xs-5>{{exDate.startDate | date:\'mediumDate\'}}</div><div class=col-xs-5>{{exDate.endDate | date:\'mediumDate\'}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=text-danger ng-click=\"removeExDateOpen($index, timing.ex)\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></li></div></div></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"schedule.schedule.timingList.length == 0\">{{\'s.p_s.msg.43\' | translate}}</div><div class=\"text-right marT15\" ng-if=\"schedule.schedule.type == \'c\' && schedule.schedule.subType != \'d\' && schedule.schedule.timingList.length >1\"><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=previewDateFx(); ng-disabled=\"previewProcessing || previewProcessingEye\"><span ng-class=\"previewProcessing?\'fa fa-repeat fa-spin\':\'glyphicon glyphicon-list-alt\'\" aria-hidden=true></span>{{\'s.p_s.btn.5\' | translate}}</button></div></div></div></div></div><footer class=panel-footer ng-if=!detailLoading><ng-btn-list info=\"{onceCompleted:schedule.info.onceCompleted, isCompleted:schedule.info.isCompleted, sp:saveProcessing, sc:saveCloseProcessing}\" permission=se back-btn=\"backBtn(\'s\');\" next-callback=saveSchedule(se.step); save-callback=\"saveSchedule(se.step, \'sc\');\" cancel-fx=\"cancelFx(\'pop\');\"></ng-btn-list><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'conflict\'\" aria-live=polite role=status>{{\'s.p_s.msg.7\' | translate}}:</span> <span ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingDuration}}</span></span> <span ng-if=\"errType==\'count\'\" aria-live=polite role=status>{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{remainingCount}}</span></span> <span ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{allowedFolder}}</span></span> <span ng-if=\"errType==\'time\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</span> <span ng-if=\"errType==\'date\'\" aria-live=polite role=status>{{\'s.p_s.msg.42\' | translate}}</span> <span ng-if=\"errType==\'sameDate\'\" aria-live=polite role=status>{{\'s.p_s.msg.44\' | translate}}</span> <span ng-if=\"errType==\'inExclude\'\" aria-live=polite role=status>{{\'s.p_s.msg.45\' | translate}}</span> <span ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</span> <span ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</span> <span ng-if=\"errType==\'repeat\'\" aria-live=polite role=status>{{\'s.p_s.msg.4\' | translate}}</span> <span ng-if=\"errType==\'timeRange\'\" aria-live=polite role=status>{{\'s.p_s.msg.54\' | translate}}</span> <span ng-if=\"errType==\'selectGroup\'\" aria-live=polite role=status>{{\'s.p_s.msg.29\' | translate}}</span><!-- Single sort save --> <span ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.31\' | translate}}</span> <span ng-if=\"errType==\'mcContent\'\" aria-live=polite role=status>{{\'s.p_s.msg.30\' | translate}}</span> <span ng-if=\"errType==\'mcSchedule\'\" aria-live=polite role=status>{{\'s.p_s.msg.32\' | translate}}</span> <span ng-if=\"errType==\'lsError\'\" aria-live=polite role=status>{{\'s.p_s.msg.39\' | translate}}</span> <span ng-if=\"errType==\'ccError\'\" aria-live=polite role=status>{{\'s.p_s.msg.41\' | translate}}</span> <span ng-if=\"errType==\'eslDevice\'\" aria-live=polite role=status>{{\'s.p_s.msg.46\' | translate}}</span> <span ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'s.p_s.msg.50.1\' | translate}}</span> <span ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</span> <span ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</span> <span ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</span> <span ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</span> <span ng-if=\"errType==\'thirdPartyCA\'\" aria-live=polite role=status>{{\'s.p_s.msg.71\' | translate}}</span> <span ng-if=\"errType==\'formN\'\" aria-live=polite role=status>{{\'s.p_s.msg.1\' | translate}}</span> <span ng-if=\"errType==\'formS\'\" aria-live=polite role=status>{{\'s.p_s.msg.3\' | translate}}</span> <span ng-if=\"errType==\'formC\'\" aria-live=polite role=status>{{schedule.info.ls?\'s.p_s.msg.40\':\'s.p_s.msg.2\' | translate}}</span> <span ng-if=\"errType==\'formD\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</span> <span ng-if=\"errType==\'formF\'\" aria-live=polite role=status>{{\'s.p_s.msg.16\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/schedules.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><span ng-if=\"selectedTab == \'hub.schedules.s\'\"><button type=button role=button class=\"btn btn-primary\" ui-sref=\"hub.sContainer.sName({type: encType})\" ng-if=auth.upermissions.s><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'s.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=groupCUOpen(); ng-if=auth.upermissions.sg><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'s.btn.2\' | translate}}</button></span></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=searchBox class=lableHidden>Search</label><div class=searchTbx ng-class=\"{\'input-group\': selectedTab == \'hub.schedules.s\'}\"><input type=text class=form-control id=searchBox ng-model=searchText sanitize-input maxlength=250 ng-change=scheduleSearchFx(searchText) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=searchRemove class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'; scheduleSearchFx();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"selectedTab == \'hub.schedules.s\'\"><!-- <button type=\"button\" id=\"advBtn\" class=\"btn btn-default\" uib-dropdown-toggle aria-label=\"advBtn\" aria-labelledby=\"advBtn\"><span class=\"fa fa-sort noMarR\"></span></button>\r\n        <ul class=\"dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r\n          <li><a href=\"\" id=\"advSearch\" ng-click=\"advancedSearchOpen(\'sm\', \'s\');\">{{\'cm.body.10\' | translate}}</a></li>\r\n        </ul> --> <button type=button role=button id=advSearch class=\"btn btn-default\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"advancedSearchOpen(\'sm\', \'s\');removeHighlightFx();\"><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></span></div></div><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo></advanced-search></div><div class=spaceH></div><div class=spaceH></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs s\" role=tablist aria-owns=\"tab-s tab-us tab-is tab-es\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.schedules.s\')}}\" aria-controls=tab-s id=tab-s class=tab-success><a ui-sref=.s role=link aria-label=\"{{\'s.tab.1\' | translate}}\">{{\'s.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.schedules.us\')}}\" aria-controls=tab-us id=tab-us class=tab-disabled><a ui-sref=.us role=link aria-label=\"{{\'s.tab.2\' | translate}}\">{{\'s.tab.2\' | translate}} <span class=\"badge bg-danger\" ng-if=\"unapproved.length>0\">{{(unapproved).length}}</span></a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.schedules.is\')}}\" aria-controls=tab-is id=tab-is class=tab-disabled><a ui-sref=.is role=link aria-label=\"{{\'s.tab.3\' | translate}}\">{{\'s.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.schedules.es\')}}\" aria-controls=tab-es id=tab-es class=tab-danger><a ui-sref=.es role=link aria-label=\"{{\'s.tab.4\' | translate}}\">{{\'s.tab.4\' | translate}}</a></li></ul><div class=panel-tools><div class=pull-right uib-dropdown><a href=\"\" role=button id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-placement=left><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': schedules.i.sty === \'label\' && schedules.i.sv === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'asc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': schedules.i.sty === \'label\' && schedules.i.sv === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'desc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.5\' | translate}}</a></li><li role=menuitem class=divider ng-if=\"selectedTab != \'hub.schedules.us\' && selectedTab != \'hub.schedules.is\'\"></li><li role=menuitem class=dropdown-header ng-if=\"selectedTab != \'hub.schedules.us\' && selectedTab != \'hub.schedules.is\'\">{{\'cm.tool.1.2\' | translate}}</li><li role=menuitem ng-if=\"selectedTab != \'hub.schedules.us\' && selectedTab != \'hub.schedules.is\'\" ng-class=\"{\'selected\': schedules.i.sty === \'approvedon\' && schedules.i.sv === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'approvedon\', \'asc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-if=\"selectedTab != \'hub.schedules.us\' && selectedTab != \'hub.schedules.is\'\" ng-class=\"{\'selected\': schedules.i.sty === \'approvedon\' && schedules.i.sv === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'approvedon\', \'desc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': schedules.i.sty === \'createdon\' && schedules.i.sv === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'asc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': schedules.i.sty === \'createdon\' && schedules.i.sv === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'desc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator ng-if=\"selectedTab == \'hub.schedules.es\'\"></li><li role=menuitem class=dropdown-header ng-if=\"selectedTab == \'hub.schedules.es\'\">{{\'cm.tool.1.7\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': schedules.i.sty === \'expireon\' && schedules.i.sv === \'asc\'}\" ng-if=\"selectedTab == \'hub.schedules.es\'\"><a href=\"\" role=link ng-click=\"sortFx(\'expireon\', \'asc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': schedules.i.sty === \'expireon\' && schedules.i.sv === \'desc\'}\" ng-if=\"selectedTab == \'hub.schedules.es\'\"><a href=\"\" role=link ng-click=\"sortFx(\'expireon\', \'desc\', schedules.schedules, schedules.info, \'schedulesort\', schedules.groups);\" target=_self>{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=\"selectedTab == \'hub.schedules.s\'\" class=info role=menuitem><a href=\"\" role=link ng-click=\"readMeFx(\'s\');\" translate=\"{{\'s.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.schedules.us\'\" class=info role=menuitem><a href=\"\" role=link ng-click=\"readMeFx(\'us\');\" translate=\"{{\'s.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.schedules.is\'\" class=info role=menuitem><a href=\"\" role=link ng-click=\"readMeFx(\'is\');\" translate=\"{{\'s.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.schedules.es\'\" class=info role=menuitem><a href=\"\" role=link ng-click=\"readMeFx(\'es\');\" translate=\"{{\'s.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li class=vid role=menuitem><a href=\"\" role=link ng-click=\"videoFx(\'s\');\" translate=\"{{\'s.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li></ul></div><div class=pull-right><a href=\"\" role=button id=refresh aria-label=refresh ng-click=\"loadSelectedTab(\'refresh\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingMain><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></i></a></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><!--For Selected Item Brief--><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-schedule-brief ng-if=\"selectedItems.length > 0\"></ng-schedule-brief>");
$templateCache.put("app/schedules/us.html","<img alt=Loading src=assets/images/loading.gif ng-if=scheduleLoading><div ng-if=\"!scheduleLoading && schedules.s.length > 0\"><ng-schedule-list class=\"show table table-md\" selectable=selection selectable-list=schedules.s selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-schedule-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!scheduleLoading && schedules.s.length == 0\"><p>{{\'s.msg.2\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'us\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'s.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><a href=\"\" role=link ng-click=\"videoFx(\'s\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'s.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div>");
$templateCache.put("app/templates/it.html","<img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><div class=row ng-if=\"!templatesLoading && templates.templates.length > 0\"><div class=col-xs-12><!-- <ul class=\"list-inline thumb-list\">\r\n      <ng-template-list class=\"show\" selectable=\"selection\" selectable-options=\"{filter:\'li\'}\" selectable-list=\"templates.templates\"></ng-template-list>\r\n    </ul> --><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.templateView == \'t\'\"><ng-template-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=templates.templates></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.templateView == \'l\'\"><ng-template-list-view class=show id=template-list selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=templates.templates></ng-template-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templates.templates.length == 0\"><p>{{\'t.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'it\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'t.tool.4\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div>");
$templateCache.put("app/templates/t.html","<div context-menu=contextMenuBase class=hide><div class=row ng-if=\"!templatesLoading && templates.templates.length > 0\"><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-template-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=templates.templates></ng-template-list></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templates.templates.length == 0\"><p>{{\'t.msg.1\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'t\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'t.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div></div><div class=flex-wrap><div class=\"flex-1 tree-menu-quad hide\" ng-if=\"auth.upreferences.isTreeOpen == 1 && (folderList.length > 0 || templateList.length > 0 || breadCrumbs.length > 0)\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=treeLoading><div class=tree-view ng-if=!treeLoading><div><a href=\"\" role=link class=home ng-class=\"{selected:curFolderId == 0}\" ng-click=folderContentFx(0);><img alt=\"\" src=assets/images/folder-icon.png class=valign-baseline> {{\'cm.label.6\' | translate}}</a></div><div class=marT3 data-angular-treeview=true data-tree-id=tree01 data-tree-model=treeList data-node-id={{curFolderId}} data-node-label=name data-node-children=children ng-if=\"treeList != 0\"></div></div><span class=hide>Selected Node: <span class=text-bold>{{tree01.currentNode.id}}</span></span><div class=resizer-handle resizer=vertical resizer-width=6 resizer-left=.flex-1 resizer-right=\"\" resizer-min=200 resizer-max=400></div></div><div class=flex-2 context-menu=contextMenuBase id=\"{{templates.info.writable && (folderList.length == 0 || templateList.length == 0)?\'content-list\':\'\'}}\"><div ng-if=\"!templatesLoading && breadCrumbs.length > 0\" class=breadcrumb ng-class=\"{\'marB5\':templates.info.wp}\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=templates.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4)?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=templates.info.sp><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=templates.info.od><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><ul class=\"list-inline thumb-list\" ng-if=\"!templatesLoading && auth.upreferences.templateView == \'t\'\" element-height=getAvailableHeight(345) delay=true><ng-template-list class=show ng-if=\"folderList.length || templateList.length\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!templatesLoading && auth.upreferences.templateView == \'l\'\" element-height=getAvailableHeight(345) delay=true><ng-template-list-view class=show id=template-list ng-if=\"folderList.length || templateList.length\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && !folderList.length && !templateList.length && !advSearchInfo.isEmpty\"><div>{{\'t.msg.1\' | translate}}</div><div ng-if=!breadCrumbs.length><div class=spaceH></div><div class=marB5 ng-if=auth.upermissions.t><a ui-sref=\"hub.tContainer.tName({type: encType})\" role=button><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'t.btn.1\' | translate}}</a></div><a href=\"\" role=link ng-click=\"readMeFx(\'t\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'t.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && folderList.length == 0 && templateList.length == 0 && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div></div>");
$templateCache.put("app/templates/tContainer.html","<div class=popup-overlay ng-class=\"{\'hide\': auth.upreferences.isPopup}\"></div><div ui-view=tabView></div>");
$templateCache.put("app/templates/tDesign.html","<div id=tDesign class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.templates.t>{{\'t.tab.1\' | translate}}</a>/ <span class=\"marL10 marR10\">{{decId == \'\'?\'t.btn.1\':\'t.body.2\' | translate}}</span> <span ng-if=\"template.info.label != \'\'\" class=text-muted>[ {{template.info.label}} ]</span></div><div class=\"pad5 msg-warning marB10 d-flex\" ng-if=template.info.tErr><span class=\"oneDrive marR5 marT-2\" ng-if=template.info.tErr.is_od></span>{{\'t.msg.42\' | translate}}</div><section id=fs-container class=panel ng-class=\"{\'popup-panel\':!auth.upreferences.isPopup}\"><header class=panel-heading><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><div class=\"pull-right marR10 hide\"><a href=\"\" role=link>{{\'fl.p_cfl.label.12\' | translate}}</a></div><div class=\"pull-right marR10\"><a href=\"\" role=link aria-label=toggleFS id=toggle_fullscreen uib-tooltip=\"{{\'cm.label.68\' | translate}}\" tooltip-placement=left tooltip-popup-delay=1000 ng-click=\"isFSMode = !isFSMode;\"><span class=\"fa fa-arrows-alt noMarR\" aria-hidden=true></span></a></div><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'t.btn.3\' | translate | capitalize}}</h1></header>{{getAvalHeight = (isFSMode?getAvailableHeight(100):getAvailableHeight(280)); \"\"}} {{getHeight = (isTimeline.toggle?getAvalHeight*0.55:getAvailableHeight(isFSMode?180:360)); \"\"}}<div class=panel-body ng-attr-style=height:{{getAvalHeight}}px><img alt=Loading src=assets/images/loading.gif ng-class=\"XMLData ? \'hide\' : \'\'\"><div class=row ng-if=!detailLoading ng-class=\"!XMLData?\'hide\':\'\'\"><div class=col-xs-8 ng-class=\"{\'col-xs-12\':saveProcessing, \'col-xs-8\':!saveProcessing}\"><div class=templateToolbar id=templateToolbarHeight><div class=\"pull-left bdrRd bdrRL8\"><button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.5\' | translate}}\" ng-click=\"addFrame(\'content\');\" aria-label=\"{{\'cm.editor.5\' | translate}}\" aria-labelledby=\"{{\'cm.editor.5\' | translate}}\" ng-disabled=isContentSelected><span class=\"fa fa-image noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.1\' | translate}}\" ng-click=\"addFrame(\'text\');\" aria-label=\"{{\'cm.editor.1\' | translate}}\" aria-labelledby=\"{{\'cm.editor.1\' | translate}}\"><span class=\"fa fa-text-width noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrRd bdrRL8\" ng-hide=\"(((!auth.upermissions.dmb && !auth.upermissions.dmb_t) && !auth.upermissions.epd) || ((!auth.upermissions.dmb && !auth.upermissions.dmb_t) && auth.upermissions.epd && template.info.tType != 1)) && template.info.tType != 3\"><button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.14\' | translate}}\" ng-click=\"addFrame(\'dText\');\" aria-label=\"{{\'cm.editor.14\' | translate}}\" aria-labelledby=\"{{\'cm.editor.14\' | translate}}\"><span class=\"fa fa-asterisk noMarR\" aria-hidden=true></span></button> <button ng-if=\"(template.info.tType != 1 && template.info.tType != 3)\" type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.15\' | translate}}\" ng-click=\"addFrame(\'dContent\');\" aria-label=\"{{\'cm.editor.15\' | translate}}\" aria-labelledby=\"{{\'cm.editor.15\' | translate}}\" ng-if=\"template.info.tType !== 4\"><span class=\"fa fa-file-o noMarR\" aria-hidden=true></span></button></div><!-- <div class=\"pull-left bdrRd bdrRL8\" ng-if=\"(!auth.upermissions.dmb && !auth.upermissions.epd) || (!auth.upermissions.dmb && auth.upermissions.epd && template.info.tType != 1)\">\r\n            <button type=\"button\" role=\"button\" class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.14\' | translate}}\" ng-click=\"addFrame(\'dText\');\" aria-label=\"{{\'cm.editor.14\' | translate}}\" aria-labelledby=\"{{\'cm.editor.14\' | translate}}\"><span class=\"fa fa-asterisk noMarR\" aria-hidden=\"true\"></span></button>\r\n            <button type=\"button\" role=\"button\" class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.15\' | translate}}\" ng-click=\"addFrame(\'dContent\');\" aria-label=\"{{\'cm.editor.15\' | translate}}\" aria-labelledby=\"{{\'cm.editor.15\' | translate}}\" ng-if=\"template.info.tType !== 4\"><span class=\"fa fa-file-o noMarR\" aria-hidden=\"true\"></span></button>\r\n          </div> --><div class=pull-left ng-class=\"(template.info.tType != 2 && !curFrame) ? \'\' : \'bdrRd bdrRL8\'\"><button type=button role=button aria-label=rectangle class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.2\' | translate}}\" ng-click=\"addFrame(\'rectangle\');\"><span class=\"fa fa-square-o noMarR\" aria-hidden=true></span></button> <button type=button role=button aria-label=circle class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.3\' | translate}}\" ng-click=\"addFrame(\'circle\');\"><span class=\"fa fa-circle-o noMarR\" aria-hidden=true></span></button></div><div class=pull-left ng-class=\"((auth.upermissions.dmb && auth.upermissions.dmb_t) && (template.info.tType == 2 || template.info.tType == 4)) ? \'\' : \'btrLR8\'\"><button type=button role=button class=\"btn btn-default\" ng-click=duplicateFrame(); ng-if=\"curFrame && template.info.tType !== 4\" ng-disabled=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) && template.info.tType == 2 && curFrame.type == \'dContent\'\"><span class=\"fa fa-object-ungroup\" aria-hidden=true></span> {{\'cm.btn.30\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=duplicateFrame(); ng-if=\"curFrame && template.info.tType == 4\" ng-disabled=\"curFrame.type == \'content\'\"><span class=\"fa fa-object-ungroup\"></span> {{\'cm.btn.30\' | translate}}</button></div><div class=\"pull-right marT5\"><div class=\"pull-left bdrRd bdrRL8 pad4\" ng-if=\"(template.info.tType == 2 || template.info.tType == 4) && isTLActive\">{{\'cs.p_d.label.9\' | translate}}: &nbsp;<switch role=switch class=switch-sm ng-model=isTimeline.toggle aria-checked={{isTimeline.toggle?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=\"durationCountFx(\'all\', \'toggle\')\"></switch></div><div class=input-group style=width:110px><span class=input-group-addon>{{\'cm.label.57\' | translate}}:</span><select id=zoom class=form-control ng-model=canvas.zoom aria-label=\"{{\'cm.label.57\' | translate}}\" aria-labelledby=\"{{\'cm.label.57\' | translate}}\"><option value=1>100%</option><option value=0.75>75%</option><option value=0.5>50%</option><option value=0.25>25%</option><option value=0.1>10%</option></select></div></div><div class=clearfix></div></div><div id=canvas class=\"overflow-auto canvasBg\" ng-click=deselectAllFrames(); data-height={{getHeight}} style=\"height:{{curFrame && clientHeightHeader == 87 ?(getHeight-33):(getHeight)}}px\"><div class=flGrid ng-attr-style=\"width:{{template.info.width*canvas.zoom}}px; height:{{template.info.height*canvas.zoom}}px;\"><div draggable ng-repeat=\"frame in template.frames\" data-index={{$index}} class=frameDrag ng-attr-style=left:{{frame.x*canvas.zoom}}px;top:{{frame.y*canvas.zoom}}px;z-index:{{frame.z}};>{{brTL = (frame.settings.br.tl?(frame.settings.br.tl*canvas.zoom)+\'px\':0);\"\"}} {{brTR = (frame.settings.br.tr?(frame.settings.br.tr*canvas.zoom)+\'px\':0);\"\"}} {{brBL = (frame.settings.br.bl?(frame.settings.br.bl*canvas.zoom)+\'px\':0);\"\"}} {{brBR = (frame.settings.br.br?(frame.settings.br.br*canvas.zoom)+\'px\':0);\"\"}}<div resizable on-resize=\"frameResize($event, $index, $ui)\" data-id={{frame.id}} data-index={{$index}} class=\"frame {{frame.type}}\" ng-class=\"{\'overflow-hidden\':frame.type === \'text\' || frame.type === \'dText\'}\" ng-click=\"selectFrame($event, frame, $index);\" ng-attr-style=\"width:{{frame.width*canvas.zoom}}px;height:{{frame.height*canvas.zoom}}px;background-color:{{frame.rgba}};transform:rotate({{frame.settings.rotation}}deg);{{(frame.type==\'content\' || frame.type==\'dContent\' || frame.type==\'rectangle\')?\'border-radius:\'+ brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL:\'\'}};box-shadow:{{frame.settings.ish.isShadow? \'inset \' + frame.settings.ish.hl +\'px \'+ frame.settings.ish.vl +\'px \'+ frame.settings.ish.br +\'px \'+ frame.settings.ish.sr +\'px \'+ frame.settings.ish.rgba:\'\'}}\"><!-- <div ng-if=\"frame.type === \'dText\'\" class=\"text-ellipsis-wrap inner-content\" data-start=\"{{frame.showAfter}}\" data-end=\"{{frame.hideAfter}}\" data-type=\"{{frame.type}}\" ng-attr-style=\"font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size * canvas.zoom}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};\">{{frame.text}}</div> --><!-- <div ng-if=\"frame.type === \'text\'\" class=\"text-ellipsis-wrap inner-content\" data-start=\"{{frame.showAfter}}\" data-end=\"{{allDuration*20}}\" data-type=\"{{frame.type}}\" ng-attr-style=\"font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size * canvas.zoom}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};\">{{frame.text}}</div> --><div ng-if=\"frame.type === \'dText\'\" class=\"text-ellipsis-wrap inner-content\" data-start={{frame.showAfter}} data-end={{frame.hideAfter}} data-type={{frame.type}} ng-attr-style=\"font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size * canvas.zoom}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};\" ng-bind-html=\"getScaledHtml(frame.text, canvas.zoom) | trustHtml\">{{frame.text}}</div><!--white-space:pre-wrap;--><div ng-if=\"frame.type === \'text\'\" class=\"text-ellipsis-wrap inner-content\" data-start={{frame.showAfter}} data-end={{allDuration*20}} data-type={{frame.type}} ng-attr-style=\"font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size * canvas.zoom}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};\" ng-bind-html=\"getScaledHtml(frame.text, canvas.zoom) | trustHtml\">{{frame.text}}</div><!--white-space:pre-wrap;--><div ng-if=\"frame.type === \'content\' || frame.type === \'dContent\'\" class=\"contentPh inner-content\" data-start={{frame.showAfter}} data-end={{frame.content[0].duration}}><span ng-if=\"frame.type === \'content\' && !frame.content.length\">{{frame.text}}</span> <span ng-if=\"(frame.content[0].type != \'SharePointC\' && frame.content[0].type != \'OneDriveC\' && frame.content[0].type != \'GoogleDriveC\' && template.info.tType != 2 && template.info.tType != 4) || ((auth.upermissions.dmb && auth.upermissions.dmb_t) && template.info.tType == 2 && frame.content[0].type != \'Video\')\"><img alt=\"\" src=\"{{thumbHost + tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"><!-- Widget --> <img alt=\"\" src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb + \'.png\' + thumbParam}}\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn != \'YouTube\' && frame.content[frame.content.length -1].extn != \'Vimeo\' && frame.content[frame.content.length -1].extn != \'Web Page\' && frame.content[frame.content.length -1].extn != \'Auto Login (Basic Auth)\' && frame.content.length > 0\"><!-- Web Page Widget --> <img alt=\"\" src=\"{{frame.content[frame.content.length-1].ss?tim + cBucket + frame.content[frame.content.length -1 ].ssImg + \'&a=t&h=\'+frame.height * canvas.zoom+\'&w=\'+frame.width * canvas.zoom+\'&q=80&zc=3\':tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb + \'.png\' + thumbParam}}\" ng-if=\"frame.content[frame.content.length - 1].type == \'Widget\' && (frame.content[frame.content.length -1].extn == \'Web Page\' || frame.content[frame.content.length -1].extn == \'Auto Login (Basic Auth)\') && frame.content.length > 0\"> <img alt=\"\" src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb+\'.png\'}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && (frame.content[frame.content.length -1].type == \'Flash\' || frame.content[frame.content.length -1].type == \'Audio\')\"> <img alt=\"\" src=\"{{thumbHost + tim + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && (frame.content[frame.content.length -1].extn == \'YouTube\' || frame.content[frame.content.length -1].extn == \'Vimeo\') && frame.content.length > 0\"> </span><span class=videoBox ng-if=\"frame.content[0].type != \'SharePointC\' && frame.content[0].type != \'OneDriveC\' && frame.content[0].type != \'GoogleDriveC\' && (auth.upermissions.dmb && auth.upermissions.dmb_t) && (template.info.tType == 2 && template.info.tType !== 4) && frame.content[0].type == \'Video\'\"><video id=dynamicVideo video-player ng-if=\"frame.content.length > 0 && frame.type==\'dContent\'\" style=width:{{frame.width*canvas.zoom}}px;height:{{frame.height*canvas.zoom}}px controls preload><source src=\"{{cDetailBucket + frame.content[0].url}}\" type=video/mp4></video><img alt=\"\" ng-if=\"frame.content.length > 0 && frame.type==\'content\'\" src=\"{{tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> <img alt=\"\" id=vidThumb style=display:none src=\"{{thumbHost + tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> </span><span class=videoBox ng-if=\"frame.content[0].type != \'SharePointC\' && frame.content[0].type != \'OneDriveC\' && frame.content[0].type != \'GoogleDriveC\' && template.info.tType == 4 && frame.content[0].type == \'Video\'\"><video id=dynamicVideo video-player ng-if=\"frame.content.length > 0\" style=width:{{frame.width*canvas.zoom}}px;height:{{frame.height*canvas.zoom}}px controls preload><source src=\"{{cDetailBucket + frame.content[0].url}}\" type=video/mp4></video><img alt=\"\" id=vidThumb style=\"display: none\" src=\"{{thumbHost + tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height * canvas.zoom}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> </span><img alt=\"\" ng-src=assets/images/default/thmbs/n/sp.png ng-if=\"frame.content[0].type == \'SharePointC\'\" width=90px> <img alt=\"\" ng-src=assets/images/default/thmbs/n/od.png ng-if=\"frame.content[0].type == \'OneDriveC\'\" width=90px> <img alt=\"\" ng-src=assets/images/default/thmbs/n/gd.png ng-if=\"frame.content[0].type == \'GoogleDriveC\'\" width=90px></div></div></div></div></div></div><div class=col-xs-4 ng-if=!saveProcessing><div class=\"panel noMarB\"><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist aria-owns=\"tab-1 tab-2 tab-3 tab-4 tab-5\" aria-labelledby=navList><li class=tab-success id=tab-1 role=tab aria-selected=true ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1);searchText=\'\';\">{{\'t.label.3\' | translate}}</a></li><li class=tab-success id=tab-2 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=\"tabFx(2);searchText=\'\';\">{{\'fl.p_cfl.tab.2\' | translate}}</a></li><li class=tab-primary id=tab-3 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'3\'}\" ng-if=\"curFrame.type == \'content\' || curFrame.type == \'dContent\'\"><a href=\"\" role=link ng-click=\"tabFx(3);searchText=\'\';\">{{\'cm.label.1\' | translate}}</a></li><li class=tab-primary id=tab-4 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'4\'}\" ng-if=\"curFrame.type == \'text\' || curFrame.type == \'dText\'\"><a href=\"\" role=link ng-click=\"tabFx(4);searchText=\'\';\">{{\'cm.label.64\' | translate}}</a></li><li class=tab-primary id=tab-5 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'5\'}\" ng-if=\"(curFrame.type == \'text\' || curFrame.type == \'content\') && template.info.feedUrl !=\'\' && template.info.tType != 6\"><a href=\"\" role=link ng-click=\"tabFx(5);searchText=\'\';\">{{\'t.tab.5\' | translate}}</a></li><li class=tab-primary id=tab-5 role=tab aria-selected=false ng-class=\"{\'active\':selectedT==\'5\'}\" ng-if=\"curFrame.type == \'dText\' && template.info.feedUrl !=\'\' && template.info.tType == 6\"><a href=\"\" role=link ng-click=\"tabFx(5);searchText=\'\';\">{{\'t.tab.5\' | translate}}</a></li></ul></header><div class=pad10 ng-show=\"selectedT==\'1\'\"><div class=\"tab-body overflow-y\" style=max-height:{{getHeight-8}}px><div ng-if=!curFrame class=\"text-muted text-sm\">{{\'cm.msg.6\' | translate}}</div><div ng-if=curFrame><div class=\"form-group row\"><div class=col-xs-12><label class=noPadT for=frameName>{{\'cm.brief.1\' | translate}}:</label><input type=text id=frameName class=\"form-control input-sm\" ng-model=curFrame.label maxlength={{inputLimit}} aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=\"form-group row\"><div class=col-xs-6><label for=xPos>{{\'fl.p_cfl.label.8\' | translate}}:</label><input type=number id=xPos class=\"form-control input-sm\" ng-model=curFrame.x maxlength=5 aria-label=\"{{\'fl.p_cfl.label.8\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.8\' | translate}}\"></div><div class=col-xs-6><label for=yPos>{{\'fl.p_cfl.label.9\' | translate}}:</label><input type=number id=yPos class=\"form-control input-sm\" ng-model=curFrame.y maxlength=5 aria-label=\"{{\'fl.p_cfl.label.9\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.9\' | translate}}\"></div></div><div class=\"form-group row\"><div class=col-xs-6><label for=frameWidth>{{\'cm.label.59\' | translate}}:</label><input type=number id=frameWidth class=\"form-control input-sm\" ng-model=curFrame.width min=1 maxlength=5 aria-label=\"{{\'cm.label.59\' | translate}}\" aria-labelledby=\"{{\'cm.label.59\' | translate}}\"></div><div class=col-xs-6><label for=frameHeight>{{\'cm.label.60\' | translate}}:</label><input type=number id=frameHeight class=\"form-control input-sm\" ng-model=curFrame.height min=1 maxlength=5 aria-label=\"{{\'cm.label.60\' | translate}}\" aria-labelledby=\"{{\'cm.label.60\' | translate}}\"></div></div><div class=form-group ng-class=\"frameBg.isChecked?\'\':\'marB5\'\"><label ng-click=frameBgFx($event);><input type=checkbox ng-model=frameBg.isChecked role=checkbox><label></label>{{\'cm.label.61\' | translate}}</label><div uib-dropdown dropdown-append-to-body auto-close=outsideClick is-open=colorPicker.isOpen ng-show=frameBg.isChecked><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':curFrame.bg, opacity:curFrame.bga}\"></span></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.bg | uppercase\" ng-click=\"colorPickerOpen($event,\'bg\');\" readonly aria-label=\"{{\'cm.label.61\' | translate}}\" aria-labelledby=\"{{\'cm.label.61\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{curFrame.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.bg selected-type=curFrame.bgType is-alpha=true selected-alpha=curFrame.bga selected-rgba=curFrame.rgba></ng-hub-color-picker></div></div></div><div><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\" class=text-bold>{{\'d.p_dc.wos.9\' | translate}} <span class=\"fa fa-chevron-down\" ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a><!-- <div ng-if=\"settingsOpen\" class=\"marT5\">\r\n                  <div class=\"form-group row noMargin\" ng-if=\"curFrame.type==\'content\' || curFrame.type==\'dContent\' || curFrame.type==\'rectangle\'\">\r\n                    <div class=\"col-xs-12\">\r\n                      <label class=\"noPadT\">{{\'fl.p_cfl.label.27\' | translate}}:</label>\r\n                    </div>\r\n                    <div class=\"col-xs-6\">\r\n                      <label class=\"noPadT\" for=\"brTL\">{{\'cm.label.89.1\' | translate}}:</label>\r\n                      <input type=\"number\" id=\"brTL\" class=\"form-control input-sm\" ng-model=\"curFrame.br.tl\" min=\"0\" tabindex=\"11\" aria-label=\"{{\'cm.label.89.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.1\' | translate}}\">\r\n                    </div>\r\n                    <div class=\"col-xs-6\">\r\n                      <label class=\"noPadT\" for=\"brTR\">{{\'cm.label.89.7\' | translate}}:</label>\r\n                      <input type=\"number\" id=\"brTR\" class=\"form-control input-sm\" ng-model=\"curFrame.br.tr\" min=\"0\" tabindex=\"12\" aria-label=\"{{\'cm.label.89.7\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.7\' | translate}}\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row noMargin\" ng-if=\"curFrame.type==\'content\' || curFrame.type==\'dContent\' || curFrame.type==\'rectangle\'\">\r\n                    <div class=\"col-xs-6\">\r\n                      <label class=\"noPadT\" for=\"brBL\">{{\'cm.label.89.3\' | translate}}:</label>\r\n                      <input type=\"number\" id=\"brBL\" class=\"form-control input-sm\" ng-model=\"curFrame.br.bl\" min=\"0\" tabindex=\"13\" aria-label=\"{{\'cm.label.89.3\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.3\' | translate}}\">\r\n                    </div>\r\n                    <div class=\"col-xs-6\">\r\n                      <label class=\"noPadT\" for=\"brBR\">{{\'cm.label.89.9\' | translate}}:</label>\r\n                      <input type=\"number\" id=\"brBR\" class=\"form-control input-sm\" ng-model=\"curFrame.br.br\" min=\"0\" tabindex=\"14\" aria-label=\"{{\'cm.label.89.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.9\' | translate}}\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row noMargin\">\r\n                    <div class=\"col-xs-6\">\r\n                      <label class=\"noPadT\">{{\'cm.label.58\' | translate}}:</label>\r\n                      <input type=\"number\" id=\"rotation\" class=\"form-control input-sm\" ng-model=\"curFrame.rotation\" min=\"-360\" max=\"360\" aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group row noMarB\" ng-if=\"curFrame.type == \'content\' || curFrame.type == \'dContent\'\">\r\n                    <div class=\"col-xs-12\"><label>{{\'cm.label.89\' | translate}}:</label></div>\r\n                    <div class=\"col-xs-12\">\r\n                      <div class=\"pull-left\">\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'t-l\'}\" ng-click=\"frameAlignFx(\'t-l\');\" uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.1\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'m-l\'}\" ng-click=\"frameAlignFx(\'m-l\');\" uib-tooltip=\"{{\'cm.label.89.2\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.2\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'b-l\'}\" ng-click=\"frameAlignFx(\'b-l\');\" uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.3\':\'\' | translate}}\"></div>\r\n                      </div>\r\n                      <div class=\"pull-left\">\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'t-c\'}\" ng-click=\"frameAlignFx(\'t-c\');\" uib-tooltip=\"{{\'cm.label.89.4\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.4\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'m-c\'}\" ng-click=\"frameAlignFx(\'m-c\');\" uib-tooltip=\"{{\'cm.label.89.5\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.5\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'b-c\'}\" ng-click=\"frameAlignFx(\'b-c\');\" uib-tooltip=\"{{\'cm.label.89.6\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.6\':\'\' | translate}}\"></div>\r\n                      </div>\r\n                      <div class=\"pull-left\">\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'t-r\'}\" ng-click=\"frameAlignFx(\'t-r\');\" uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.7\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'m-r\'}\" ng-click=\"frameAlignFx(\'m-r\');\" uib-tooltip=\"{{\'cm.label.89.8\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.8\':\'\' | translate}}\"></div>\r\n                        <div class=\"alignBox\" ng-class=\"{\'selected\':curFrame.align == \'b-r\'}\" ng-click=\"frameAlignFx(\'b-r\');\" uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-append-to-body=\"true\" title=\"{{isFSMode?\'cm.label.89.9\':\'\' | translate}}\"></div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div> --><div ng-if=settingsOpen class=\"marT5 bdr-top-dashed bg-light pad10\"><div class=\"form-group row\" ng-show=\"curFrame.type != \'circle\'\"><div class=col-xs-6><label for=frameRotate>{{\'cm.label.58\' | translate}}:</label><span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'t.msg.40\' | translate}}\" tooltip-placement=top tooltip-append-to-body=true aria-hidden=true></span> <input type=number id=frameRotate class=\"form-control input-sm\" ng-model=curFrame.settings.rotation aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"></div></div><div class=\"form-group row\" ng-if=\"curFrame.type==\'content\' || curFrame.type==\'dContent\'\"><div class=col-xs-12><label>{{\'cm.label.89\' | translate}}:</label></div><div class=col-xs-12><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-l\'}\" ng-click=\"frameAlignFx(\'t-l\')\" uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-l\'}\" ng-click=\"frameAlignFx(\'m-l\')\" uib-tooltip=\"{{\'cm.label.89.2\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-l\'}\" ng-click=\"frameAlignFx(\'b-l\')\" uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-c\'}\" ng-click=\"frameAlignFx(\'t-c\')\" uib-tooltip=\"{{\'cm.label.89.4\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-c\'}\" ng-click=\"frameAlignFx(\'m-c\')\" uib-tooltip=\"{{\'cm.label.89.5\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-c\'}\" ng-click=\"frameAlignFx(\'b-c\')\" uib-tooltip=\"{{\'cm.label.89.6\' | translate}}\" tooltip-append-to-body=true></div></div><div class=pull-left><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'t-r\'}\" ng-click=\"frameAlignFx(\'t-r\')\" uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'m-r\'}\" ng-click=\"frameAlignFx(\'m-r\')\" uib-tooltip=\"{{\'cm.label.89.8\' | translate}}\" tooltip-append-to-body=true></div><div class=alignBox ng-class=\"{\'selected\':curFrame.align == \'b-r\'}\" ng-click=\"frameAlignFx(\'b-r\')\" uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-append-to-body=true></div></div></div></div><div class=\"row noMargin\" ng-if=\"curFrame.type==\'content\' || curFrame.type==\'dContent\'\"><div class=\"col-xs-12 marB5\"><label><input type=checkbox ng-model=curFrame.settings.br.isBorder ng-click=\"resetAdSettingFx(curFrame.settings.br.isBorder, \'b\');\"><label></label>{{\'fl.p_cfl.label.27\' | translate}}:</label><!-- <label class=\"noPadT\">{{\'fl.p_cfl.label.27\' | translate}}:</label> --></div></div><div ng-if=curFrame.settings.br.isBorder><div class=\"form-group row noMargin\"><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brTL tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.1\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.1\' | translate}}:</label><input type=number id=brTL class=\"form-control input-sm\" ng-model=curFrame.settings.br.tl min=0 tabindex=11 aria-label=\"{{\'cm.label.89.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.1\' | translate}}\"></div><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brTR tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.7\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.7\' | translate}}:</label><input type=number id=brTR class=\"form-control input-sm\" ng-model=curFrame.settings.br.tr min=0 tabindex=12 aria-label=\"{{\'cm.label.89.7\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.7\' | translate}}\"></div></div><div class=\"form-group row noMargin\"><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brBL tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.3\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.3\' | translate}}:</label><input type=number id=brBL class=\"form-control input-sm\" ng-model=curFrame.settings.br.bl min=0 tabindex=13 aria-label=\"{{\'cm.label.89.3\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.3\' | translate}}\"></div><div class=col-xs-6><label class=\"noPadT text-ellipsis\" for=brBR tooltip-append-to-body=true uib-tooltip=\"{{\'cm.label.89.9\' | translate}}\" tooltip-placement=center tooltip-popup-delay=500>{{\'cm.label.89.9\' | translate}}:</label><input type=number id=brBR class=\"form-control input-sm\" ng-model=curFrame.settings.br.br min=0 tabindex=14 aria-label=\"{{\'cm.label.89.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.89.9\' | translate}}\"></div></div></div><div class=\"row noMargin\" ng-if=\"curFrame.type==\'content\' || curFrame.type==\'dContent\'\"><div class=\"col-xs-12 marB7\"><label><input type=checkbox ng-model=curFrame.settings.ish.isShadow ng-change=\"resetAdSettingFx(curFrame.settings.ish.isShadow, \'s\');\"><label></label>{{\'fl.p_cfl.label.28\' | translate}}:</label><!-- <label class=\"noPadT\">{{\'fl.p_cfl.label.27\' | translate}}:</label> --></div></div><div ng-if=curFrame.settings.ish.isShadow><div class=\"form-group row noMargin\"><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTL>{{\'fl.p_cfl.label.29\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.hl tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.hl}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.30\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.vl tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.vl}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.31\' | translate}}:</label><input type=range min=0 max=200 ng-model=curFrame.settings.ish.br tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.br}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.32\' | translate}}:</label><input type=range min=-200 max=200 ng-model=curFrame.settings.ish.sr tooltip-append-to-body=true uib-tooltip={{curFrame.settings.ish.sr}} tooltip-placement=center></div><div class=\"col-xs-12 marB10\"><label class=noPadT for=brTR>{{\'fl.p_cfl.label.33\' | translate}}:</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.isSc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':curFrame.settings.ish.sc, opacity:curFrame.settings.ish.sca}\"></span></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.settings.ish.sc | uppercase\" ng-click=\"colorPickerOpen($event, \'sc\');\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{curFrame.settings.ish.sca}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.settings.ish.sc selected-type=curFrame.settings.ish.scType is-alpha=true selected-alpha=curFrame.settings.ish.sca selected-rgba=curFrame.settings.ish.rgba></ng-hub-color-picker></div></div></div></div></div><div class=\"form-group row noMargin hide\"><div class=col-xs-6><label class=noPadT for=rotation>{{\'cm.label.58\' | translate}}:</label><input type=number id=rotation class=\"form-control input-sm\" ng-model=curFrame.rotation min=-360 max=360 tabindex=10 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"></div></div></div></div><div class=\"clearboth marT5\"></div></div></div></div><div class=pad10 ng-show=\"selectedT==\'2\'\"><div class=\"tab-body overflow-auto\" style=max-height:{{getHeight-8}}px><ul class=\"layer-container sortable-containment list-unstyled noMar\" sortable axis=\"\'y\'\" callback=sortCallback() containment=\"\'parent\'\"><li ng-repeat=\"frame in template.frames | orderBy: \'z\':true\" class=\"layer sortable-item template-layer\" data-id={{frame.id}} ng-click=\"selectFrame($event, frame, (template.frames.length - $index - 1))\"><button type=button role=button class=\"btn btn-link btn-sm pull-right\" ng-hide=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) && (template.info.tType == 2 || template.info.tType == 4) && frame.type==\'dContent\'\" ng-click=\"removePlaceholder(frame.id, \'l\')\"><span class=\"fa fa-remove noMarR text-danger\" aria-hidden=true></span></button><div class=text-ellipsis><a href=\"\" role=link ng-click=\"layerEyeFx($event, frame);\"><span class=\"fa fa-eye marR3\" aria-hidden=true></span></a> <span class=\"badge bg-muted marR5\"><span ng-if=\"frame.type == \'content\'\" class=\"fa fa-image\" uib-tooltip=\"{{\'cm.label.1\' | translate}}\" title=\"{{isFSMode?\'cm.label.1\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> <span ng-if=\"frame.type == \'text\'\" class=\"fa fa-text-width\" uib-tooltip=\"{{\'cm.label.64\' | translate}}\" title=\"{{isFSMode?\'cm.label.64\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> <span ng-if=\"frame.type == \'dText\'\" class=\"fa fa-asterisk\" uib-tooltip=\"{{\'t.label.17\' | translate}}\" title=\"{{isFSMode?\'t.label.17\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> <span ng-if=\"frame.type == \'dContent\'\" class=\"fa fa-file-o\" uib-tooltip=\"{{\'t.label.18\' | translate}}\" title=\"{{isFSMode?\'t.label.18\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> <span ng-if=\"frame.type == \'rectangle\'\" class=\"fa fa-square-o\" uib-tooltip=\"{{\'t.label.19\' | translate}}\" title=\"{{isFSMode?\'t.label.19\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> <span ng-if=\"frame.type == \'circle\'\" class=\"fa fa-circle-o\" uib-tooltip=\"{{\'t.label.20\' | translate}}\" title=\"{{isFSMode?\'t.label.20\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true tooltip-placement=top aria-hidden=true></span> </span><span class=layerBg><span ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.rgba}\"></span> </span><span class=layerFrameLabel>{{frame.label}}</span></div></li><div ng-if=!template.frames.length class=\"text-muted text-sm\">{{\'cm.msg.6\' | translate}}</div></ul></div></div><div class=pad10 ng-show=\"selectedT==\'3\'\"><div ng-if=curFrame.folder.isHidden class=msg-warning>{{\'cm.msg.57\' | translate}}</div><div ng-if=!curFrame.folder.isHidden><div ng-if=\"!curFrame || (curFrame.type != \'content\' && curFrame.type != \'dContent\')\" class=\"text-muted text-sm\" translate=\"{{\'cm.msg.6\'}}\" translate-values=\"{str: \'<b>Content</b>\'}\"></div><div class=\"marT5 marB20\" ng-show=\"curFrame.type == \'dContent\'\"><label>{{\'cm.editor.15.1\' | translate}}</label><div class=marB10><div ng-if=curFrame.folder.id><span class=\"fa fa-home\" aria-hidden=true></span> {{curFrame.folder.path}} <span ng-if=\"curFrame.folder.path != \'/\'\">/</span> {{curFrame.folder.label}}</div><span class=\"text-muted text-sm\" ng-if=!curFrame.folder.id>N/A</span></div><button type=button role=button class=\"btn btn-xs\" ng-class=\"curFrame.folder.id?\'btn-default\':\'btn-primary\'\" ng-click=selectFolderOpen(curFrame.folder.id);>{{curFrame.folder?\'cl.p_f.9.1\':\'cl.p_f.9\' | translate | camelCase}}</button></div><div class=bdrBtm ng-show=\"curFrame.type == \'dContent\'\"></div><div class=\"row marT5 marB10\" ng-show=\"curFrame.type == \'content\' || curFrame.type == \'dContent\'\"><div class=\"col-xs-5 col-lg-6\"><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=\"selectContentOpen(curFrame.folder.id); searchText=\'\'\" ng-disabled=\"curFrame.type == \'dContent\' && !curFrame.folder.id\">{{\'cm.label.32\' | translate | camelCase}}</button></div><div class=\"col-xs-7 col-lg-6\"><div class=searchTbx><input type=text class=\"form-control input-sm\" ng-model=searchText sanitize-input maxlength=250 ng-disabled=\"curFrame.type == \'dContent\' && !curFrame.folder.id\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=cList1 ng-if=\"curFrame.type == \'content\' || curFrame.type == \'dContent\'\"><div class=\"list-container table\"><div class=msg-warning lang={{auth.lang}} ng-if=\"curFrame.content.length == 0\">{{\'t.msg.13\' | translate}}</div><div class=\"row th\" ng-if=\"curFrame.content.length != 0\"><div class=col-xs-8 ng-class=\"{\'col-xs-11\':template.info.tType == 1}\">{{\'cm.label.1\' | translate}}</div><div class=col-xs-4 ng-if=\"template.info.tType != 1\">{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><div class=text-sm>{{count = (curFrame.content | filter:{isAccessible:true});\"\"}}<div class=col-xs-8 ng-class=\"{\'col-xs-11\':template.info.tType == 1}\">{{count.length}}</div><div class=col-xs-4 ng-if=\"template.info.tType != 1\">{{curDuration}}</div></div></div><ul class=overflow-auto style=\"max-height:{{(getHeight) - (curFrame.type == \'content\'?105:105)}}px\">{{hiddenCount = (curFrame.content | filter:{hidden:0});\"\"}}<li class=row ng-repeat=\"content in filteredContent = (curFrame.content | reverse | customSearch:{key:searchText, module:\'cl\', filterType:filter})\" ng-if=!content.hidden><div class=\"col-xs-8 text-ellipsis\" ng-class=\"{\'col-xs-11\':template.info.tType == 1}\"><span ng-if=\"content.type != \'SharePointC\' && content.type != \'OneDriveC\' && content.type != \'GoogleDriveC\' && content.type != \'Image\' && content.type != \'Video\'\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/n/\' + content.thumb}}.png&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type != \'Widget\' && (content.type == \'Audio\' || content.type == \'Flash\')\"> <img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\"> <img alt=\"\" class=marR5 src=\"{{thumbHost + tim + content.thumb}}&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><!-- Web Page Widget --> <img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb + \'.png&a=t&h=24&w=25&q=80&zc=2\'}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss\"> <a ng-href=\"{{cDetailBucket + content.ssImg | secureThumb}}\" role=button data-access={{content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(content.path + (content.path.length > 1 ? \' / \' : \' \') + content.label)}}\" ng-show=content.thumb ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss\"><img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + content.ssImg}}&a=t&h=24&w=25&q=80&zc=2\"> </a></span><span ng-if=\"content.type != \'SharePointC\' && content.type != \'OneDriveC\' && content.type != \'GoogleDriveC\' && content.type == \'Image\'\"><a ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=button data-access={{content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(content.path + (content.path.length > 1 ? \' / \' : \' \') + content.label)}}\" ng-show=content.thumb><img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + content.thumb}}&a=t&h=24&w=25&q=80&zc=2\"> </a></span><span ng-if=\"content.type != \'SharePointC\' && content.type != \'OneDriveC\' && content.type != \'GoogleDriveC\' && content.type == \'Video\'\"><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + content.url, content.path + (content.path.length > 1 ? \' / \' : \' \') + content.label);\" data-access={{content.isAccessible}}><img alt=\"\" class=marR5 src=\"{{thumbHost + tim + cBucket + content.thumb}}&a=t&h=24&w=25&q=80&zc=2\"> </a></span><img alt=\"\" ng-src=assets/images/default/thumbs/n/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" width=25px> <img alt=\"\" ng-src=assets/images/default/thumbs/n/od.png ng-if=\"content.type == \'OneDriveC\'\" width=25px> <img alt=\"\" ng-src=assets/images/default/thumbs/n/gd.png ng-if=\"content.type == \'GoogleDriveC\'\" width=25px> {{content.label}}</div><div class=\"col-xs-3 text-right\" ng-if=\"template.info.tType != 1\"><input type=number class=\"form-control text-right\" ng-model=content.duration ng-change=durationCountFx(); min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link ng-click=\"removeContentFx($index, content);\"><span class=\"fa fa-remove noMarR text-danger\" aria-hidden=true></span></a></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"curFrame.content.length > 0 && filteredContent.length == 0 && hiddenCount.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"curFrame.content.length > 0 && !hiddenCount.length\">{{\'cm.msg.39\' | translate}}</div></ul></div></div><div class=\"row marT20\" ng-if=\"curFrame.type==\'dContent\' && (template.info.tType == 2 || template.info.tType == 4) && (curFrame.content.length>0 && curFrame.content[0].type==\'Video\')\"><div class=col-xs-6><label class=noPadT>{{\'t.label.9\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=ssTime class=\"form-control input-sm\" ng-model=template.info.ssTime min=0 aria-label=\"{{\'t.label.9\' | translate}}\" aria-labelledby=\"{{\'t.label.9\' | translate}}\"></div></div></div></div><div class=pad10 ng-show=\"selectedT==\'4\'\"><div class=\"tab-body scrollQuad\" style=max-height:{{getHeight-8}}px><div ng-if=\"!curFrame || (curFrame.type != \'text\' && curFrame.type != \'dText\')\" class=\"text-muted text-sm\" translate=\"{{\'cm.msg.6\'}}\" translate-values=\"{str: \'<b>Text</b>\'}\"></div><div ng-if=\"curFrame.type == \'text\' || curFrame.type == \'dText\'\"><div class=text-toolbar><div><div class=\"pull-left bdrRd bdrRL8 marB5\"><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.1\' | translate}}\" ng-click=\"textPropFx(\'bold\');\"><span class=\"fa fa-bold noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.2\' | translate}}\" ng-click=\"textPropFx(\'italic\');\"><span class=\"fa fa-italic noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.3\' | translate}}\" ng-click=\"textPropFx(\'underline\');\"><span class=\"fa fa-underline noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrRd bdrRL8 marB5\"><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.4\' | translate}}\" ng-click=\"textPropFx(\'left\');\"><span class=\"fa fa-align-left noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.5\' | translate}}\" ng-click=\"textPropFx(\'center\');\"><span class=\"fa fa-align-center noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.6\' | translate}}\" ng-click=\"textPropFx(\'right\');\"><span class=\"fa fa-align-right noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrRd bdrRL8 marB5 hide\"><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.8\' | translate}}\" ng-click=\"textPropFx(\'redo\');\"><span class=\"fa fa-repeat noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.9\' | translate}}\" ng-click=\"textPropFx(\'undo\');\"><span class=\"fa fa-undo noMarR\" aria-hidden=true></span></button></div><div class=pull-left style=width:120px><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':curFrame.color}\"></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.color | uppercase\" ng-click=\"colorPicker.tc=true\" style=width:85px readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.color selected-type=curFrame.cType ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=clearfix></div></div><div class=spaceH2></div><div class=row><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.24\' | translate}}:</span><select id=font class=\"form-control selectTemplate\" ng-model=curFrame.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.83\' | translate}}:</span> <input type=number id=size class=form-control number-converter ng-model=curFrame.size min=0 aria-label=\"{{\'cm.label.83\' | translate}}\" aria-labelledby=\"{{\'cm.label.83\' | translate}}\"></div></div></div></div><!-- <div class=\"spaceH\"></div> --><!-- <div>\r\n                  <textarea id=\"text\" class=\"form-control txtAreaBig\" ng-model=\"curFrame.text\" ng-readonly=\"curFrame.feedRef == 1\" aria-label=\"Textarea\" aria-labelledby=\"Textarea\"></textarea>\r\n                </div> --><div class=spaceH></div><div><div ng-if=!treeObj.isOlo><div id=tTextEditor class=scroll-hidden contenteditable=true ng-model=curFrame.text ng-change=textChangeFx() ng-readonly=\"curFrame.feedRef == 1\" ng-paste=removeAllFormate($event)></div><!-- <textarea id=\"text\" class=\"form-control txtAreaBig\"  ng-model=\"curFrame.text\" ng-readonly=\"curFrame.feedRef == 1\" aria-label=\"Textarea\" aria-labelledby=\"Textarea\"></textarea> --><!-- <div text-editor></div> --></div><div ng-if=treeObj.isOlo><label for=data ng-if=curFrame.settings.dynText>{{\'cm.label.64\' | translate}}</label><textarea id=text class=\"form-control txtAreaBig\" ng-if=curFrame.settings.dynText ng-model=curFrame.settings.dynText ng-readonly=\"curFrame.feedRef == 1\" aria-label=Textarea aria-labelledby=Textarea></textarea><div class=spaceH ng-if=curFrame.settings.dynText></div><label for=path ng-if=curFrame.settings.dynText>{{\'cl.brief.8\' | translate}}</label><textarea id=text class=\"form-control txtAreaBig\" ng-if=curFrame.settings.dynText ng-model=curFrame.text ng-readonly=\"curFrame.feedRef == 1\" aria-label=Textarea aria-labelledby=Textarea></textarea><textarea id=text class=\"form-control txtAreaBig\" ng-if=!curFrame.settings.dynText ng-model=curFrame.text ng-readonly=\"curFrame.feedRef == 1\" aria-label=Textarea aria-labelledby=Textarea></textarea></div></div><div class=spaceH></div><div class=row ng-if=\"curFrame.type==\'dText\' && (template.info.tType == 2 || template.info.tType == 4)\"><div class=col-xs-6><label class=noPadT>{{\'t.label.7\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=showAfter class=\"form-control input-sm\" ng-keydown=\"$event.key==\'.\'?$event.preventDefault():\'\'\" ng-model=curFrame.showAfter min=0 aria-label=\"{{\'t.label.7\' | translate}}\" aria-labelledby=\"{{\'t.label.7\' | translate}}\"></div><div class=col-xs-6><label class=noPadT>{{\'t.label.8\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=hideAfter class=\"form-control input-sm\" ng-keydown=\"$event.key==\'.\'?$event.preventDefault():\'\'\" ng-model=curFrame.hideAfter min=0 ng-change=checkDurationFx() aria-label=\"{{\'t.label.8\' | translate}}\" aria-labelledby=\"{{\'t.label.8\' | translate}}\"></div></div><div class=spaceH ng-if=\"curFrame.type==\'dText\' && (template.info.tType == 2 || template.info.tType == 4)\"></div><!-- Allow Multiple Text --><div ng-if=\"curFrame.type==\'dText\' && (template.info.tType == 0 || template.info.tType == 4)\"><div><label><input type=checkbox ng-model=curFrame.isMT ng-change=isMTFx()><label></label>{{\'t.label.35\' | translate}}</label><button type=button role=button class=\"btn btn-primary btn-xs pull-right\" ng-click=\"mtActionFx(\'a\');\" ng-if=curFrame.isMT><span class=\"fa fa-plus-circle\"></span>{{\'cm.editor.1\' | translate}}</button></div><div class=\"bdr-top-dashed marT5 bg-light pad10\" ng-if=curFrame.isMT><div ng-repeat=\"mt in curFrame.mt\" class=\"d-flex align-items-center\" ng-class=\"{\'bdr-btm-dashed padB5 marB5\':!$last}\"><input type=text class=\"form-control input-sm\" ng-model=mt.t ng-disabled=mt.dt maxlength=999999999> <a href=\"\" role=link class=\"pad5 marL10\" ng-click=\"mtActionFx(\'dc\', $index);\" ng-disabled=mt.dt><span class=\"fa fa-remove text-danger\" ng-class=\"{\'text-muted\':mt.dt}\"></span></a></div><div ng-if=!curFrame.mt.length class=msg-warning>{{\'cm.msg.58\' | translate}}</div></div></div><!-- excel template --><div class=\"row bdr-top-dashed\" ng-if=\"curFrame.type==\'dText\' && template.info.tType == 3 && (template.info.subType == \'od\' || template.info.subType == \'cl\') && template.info.file && template.info.file.bucket && sheetList.length\"><div class=col-xs-6><label><input type=checkbox ng-model=curFrame.cell.isMap role=checkbox ng-change=\"getExcelJsonFx(template.info.file.bucket, template.info.file.json)\"><label></label>{{\'t.label.23\' | translate}}</label><div ng-if=curFrame.cell.isMap><select id=category class=form-control ng-model=curFrame.sheet ng-options=\"sheet as sheet.l for sheet in sheetList track by sheet.l\" aria-label=\"{{\'t.label.24\' | translate}}\" aria-labelledby=\"{{\'t.label.24\' | translate}}\"><option value=\"\">{{\'t.label.24\' | translate}}</option></select></div></div><div class=col-xs-6 ng-if=curFrame.cell.isMap><label for=cellData>{{\'t.label.25\' | translate}}</label><input type=text id=cellData class=form-control ng-model=curFrame.cell.cellNo aria-label=\"{{\'fl.p_cfl.label.5\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.5\' | translate}}\"></div></div><div ng-if=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) && (template.info.tType == 2 || template.info.tType == 4)\" class=\"msg-warning marT10 hide\" lang={{auth.lang}}>{{\'t.msg.18\' | translate}}</div></div></div></div><div class=\"pad10 dScrollQuad\" ng-show=\"selectedT==\'5\' && template.info.feedUrl !=\'\'\" style=max-height:{{getHeight}}px><li id=feedTreeContainer class=\"feedTreeContainer list-unstyled\"><img alt=Loading src=assets/images/loading-xs.gif></li></div><div class=\"panel-body hide\"><div ui-view=tabView></div></div></div><!-- temporary showing captured image --><div id=img-out></div></div><!-- Scene with timeline start --><div class=col-xs-12 ng-if=\"!saveProcessing && isTimeline.toggle\"><div class=marT10><div class=text-bold>{{\'cs.p_d.label.9\' | translate}}</div><div class=\"bdr-top-dashed overflow-auto noPad\" style=height:{{isFSMode?(getAvalHeight*0.34):(getAvalHeight*0.3)}}px><div class=tl-container ng-if=template.frames.length><ul class=\"sortable-containment list-unstyled noMar\" sortable axis=\"\'y\'\" callback=\"sortCallback(\'tl\')\" containment=\"\'parent\'\"><div class=tl-left><li class=text-center><div class=w100><a href=\"\" class=\"btn btn-default playBtn marB2\" ng-click=playPauseFx();><i id=playPause class=fa ng-class=\"isPlay?\'fa-play\':\'fa-pause\'\" aria-hidden=true></i></a></div></li><li class=\"layer sortable-item tl-layer\" ng-repeat=\"frame in template.frames | orderBy:\'z\':true\" data-id={{frame.id}} ng-click=\"selectFrame($event, frame, (template.frames.length - $index - 1))\"><span class=\"badge bg-muted marR5\"><span ng-if=\"frame.type == \'content\'\" class=\"fa fa-image\" uib-tooltip=\"{{\'cm.label.1\' | translate}}\" title=\"{{isFSMode?\'cm.label.1\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> <span ng-if=\"frame.type == \'text\'\" class=\"fa fa-text-width\" uib-tooltip=\"{{\'cm.label.64\' | translate}}\" title=\"{{isFSMode?\'cm.label.64\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> <span ng-if=\"frame.type == \'dText\'\" class=\"fa fa-asterisk\" uib-tooltip=\"{{\'t.label.17\' | translate}}\" title=\"{{isFSMode?\'t.label.17\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> <span ng-if=\"frame.type == \'dContent\'\" class=\"fa fa-file-o\" uib-tooltip=\"{{\'t.label.18\' | translate}}\" title=\"{{isFSMode?\'t.label.18\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> <span ng-if=\"frame.type == \'rectangle\'\" class=\"fa fa-square-o\" uib-tooltip=\"{{\'t.label.19\' | translate}}\" title=\"{{isFSMode?\'t.label.19\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> <span ng-if=\"frame.type == \'circle\'\" class=\"fa fa-circle-o\" uib-tooltip=\"{{\'t.label.20\' | translate}}\" title=\"{{isFSMode?\'t.label.20\':\'\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true aria-hidden=true></span> </span><a href=\"\" role=link ng-click=\"layerEyeFx($event, frame);\"><span class=\"fa fa-eye marR3\" aria-hidden=true></span></a><div class=text-ellipsis uib-tooltip={{frame.label}} title=\"{{isFSMode?frame.label:\'\'}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true>{{frame.label}}</div></li></div><div class=tl-right><div id=containment-wrapper style=\"position: relative;width: fit-content;margin-left:200px\"><div id=seeker class=slider timeline-slider data-duration={{allDuration*20}}></div><div class=tl-ruler><div style=width:{{(allDuration*20)}}px><div ng-repeat=\"a in rulerCountArr\" style=width:40px><div class=ruler-number>{{a}}</div><div class=ruler-box></div></div></div></div><li class=time ng-repeat=\"frame in template.frames | orderBy:\'z\':true\" data-id={{frame.id}}><span class=cursorDefault ng-if=\"frame.type !== \'content\' && frame.type !== \'dContent\' && frame.type !== \'rectangle\' && frame.type !== \'circle\' && frame.type != \'dText\'\" style=width:{{(allDuration*20)}}px uib-tooltip=\"{{frame.type == \'dText\'?(\'t.label.17\' | translate):frame.type | capitalize}}\" tooltip-append-to-body=true tooltip-placement=top title=\"{{isFSMode?(frame.type == \'dText\'?(\'t.label.17\' | translate):frame.type|capitalize):\'\'}}\"></span> <span class=cursorDefault ng-if=\"(frame.type == \'rectangle\' || frame.type == \'circle\') && frame.type != \'dText\'\" style=width:{{(allDuration*20)}}px uib-tooltip=\"{{frame.type==\'circle\' ? \'Circle\' : \'Rectangle\'}}\" tooltip-append-to-body=true tooltip-placement=top></span> <span ng-if=\"frame.type == \'dText\'\" class=\"text-center d-flex align-items-center justify-center\" tooltip-enable={{!d.blank}} uib-tooltip=\"{{!d.blank?\'Dynamic Text\':\'\'}}\" tooltip-append-to-body=true tooltip-placement=top style=width:{{d.duration*20}}px ng-class=\"{\'blankBg\': d.blank}\" ng-repeat=\"d in frame.duration\"></span> <span class=\"text-center d-flex align-items-center justify-center\" ng-if=\"frame.type == \'content\' || frame.type == \'dContent\'\" ng-repeat=\"item in frame.content\" ng-class=\"{\'blankBg\':(item.extn==\'F45 Blank\'), \'cursorDefault\':(item.type==\'Widget\')}\" style=width:{{(item.duration*20)}}px tooltip-enable=\"{{item.extn!=\'F45 Blank\'}}\" uib-tooltip-template=\"\'contentTemplate.html\'\" title=\"{{isFSMode?(item.label +\' | \'+ item.extn +\' | \'+ item.startTime +\' - \'+ item.endTime):\'\'}}\" tooltip-append-to-body=true tooltip-placement=top><div class=cursorDefault ng-if=\"item.type != \'SharePointC\' && item.type != \'OneDriveC\' && item.type != \'GoogleDriveC\' && item.type != \'Image\' && item.type != \'Video\'\"><img alt=\"\" class=img-responsive src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/n/\' + item.thumb}}.png&a=t&h=20&w={{item.duration}}&q=80&zc=3\" ng-if=\"item.type != \'Widget\' && (item.type == \'Audio\' || item.type == \'Flash\')\"> <img alt=\"\" class=img-responsive src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + item.thumb}}.png&a=t&h=20&w={{item.duration}}&q=80&zc=3\" ng-if=\"item.type == \'Widget\' && item.extn != \'YouTube\' && item.extn != \'Vimeo\' && item.extn != \'F45 Blank\'\"> <img alt=\"\" class=img-responsive src=\"{{thumbHost + tim + item.thumb}}&a=t&h=20&w={{item.duration}}&q=80&zc=3\" ng-if=\"item.type == \'Widget\' && (item.extn == \'YouTube\' || item.extn == \'Vimeo\')\"></div><div ng-if=\"item.type != \'SharePointC\' && item.type != \'OneDriveC\' && item.type != \'GoogleDriveC\' && item.type == \'Image\'\"><a ng-href=\"{{cDetailBucket + item.thumb | secureThumb}}\" role=button data-access={{item.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(item.path + (item.path.length>1?\'/\':\' \') + item.label)}}\" ng-show=item.thumb><img alt=\"\" class=img-responsive src=\"{{thumbHost + tim + cBucket + item.thumb}}&a=t&h=20&w={{item.duration}}&q=80&zc=3\"></a></div><div ng-if=\"item.type != \'SharePointC\' && item.type != \'OneDriveC\' && item.type != \'GoogleDriveC\' && item.type == \'Video\'\"><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + item.url, item.path + (item.path.length>1?\'/\':\' \') + item.label);\" data-access={{item.isAccessible}}><img alt=\"\" class=img-responsive src=\"{{thumbHost + tim + cBucket + item.thumb}}&a=t&h=20&w={{item.duration}}&q=80&zc=3\"></a></div><img alt=\"\" class=img-responsive ng-src=assets/images/default/thumbs/n/sp.png ng-if=\"item.type == \'SharePointC\'\" width={{item.duration}}px> <img alt=\"\" class=img-responsive ng-src=assets/images/default/thumbs/n/od.png ng-if=\"item.type == \'OneDriveC\'\" width={{item.duration}}px> <img alt=\"\" class=img-responsive ng-src=assets/images/default/thumbs/n/gd.png ng-if=\"item.type == \'GoogleDriveC\'\" width={{item.duration}}px></span></li></div></div></ul></div><div ng-if=!template.frames.length class=msg-warning lang={{auth.lang}}>{{\'t.msg.22\' | translate}}</div></div></div></div><!-- Scene with timeline end --></div></div><div class=panel-footer ng-if=!detailLoading ng-class=\"!XMLData?\'hide\':\'\'\"><span class=btnQuad><button type=submit role=button class=\"btn btn-default\" ui-sref=\"hub.tContainer.tName({type: encType, id: encId})\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=submit role=button class=\"btn btn-default\" ng-click=\"saveTemplate(\'design\', \'s\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-success\" ng-click=\"saveTemplate(\'design\', \'sc\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx(); ng-disabled=\"saveProcessing || saveCloseProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'hAduration\'\" aria-live=polite role=status>{{\'t.msg.28\' | translate}}</div><div ng-if=\"errType==\'sAduration\'\" aria-live=polite role=status>{{\'t.msg.29\' | translate}}</div><div ng-if=\"errType==\'dName\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType == \'sheet\'\" aria-live=polite role=status>{{\'t.msg.31\' | translate}}</div><div ng-if=\"errType == \'cell\'\" aria-live=polite role=status>{{\'t.msg.32\' | translate}}</div><div ng-if=\"errType == \'invCell\'\" aria-live=polite role=status>{{\'t.msg.34\' | translate}}</div></div><div class=clearfix></div></div></section><script type=text/ng-template id=contentTemplate.html><div>\r\n    <div style=\"white-space:nowrap\">{{item.label}}</div>\r\n    <div style=\"white-space:nowrap\">{{item.extn}}</div>\r\n    <div style=\"white-space:nowrap\">{{item.startTime}} - {{item.endTime}}</div>\r\n  </div></script>");
$templateCache.put("app/templates/tName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.templates.t>{{\'t.tab.1\' | translate}}</a>/ <span class=\"marL10 marR10\">{{decId == \'\'?\'t.btn.1\':\'t.body.2\' | translate}}</span> <span ng-if=\"template.info.label && template.info.label != \'\'\" class=text-muted>[ <span>{{template.info.label}}</span> ]</span></div><div class=\"pad5 msg-warning marB10 d-flex\" ng-if=template.info.tErr><span class=\"oneDrive marR5 marT-2\" ng-if=template.info.tErr.is_od></span>{{\'t.msg.42\' | translate}}</div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'cm.label.55\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'t.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=template.info.label autocomplete=off maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'t.label.1\' | translate}}\" aria-labelledby=\"{{\'t.label.1\' | translate}}\"></div><!-- Type > Normal | Dynamic text on video | Excel Template --><div class=form-group ng-if=\"template.info.tType != 1\"><label>{{\'cm.brief.8\' | translate}}</label><div class=row><div class=col-xs-4><div class=input-group><span class=input-group-addon>{{\'cm.label.59\' | translate}}</span> <input type=number id=width class=form-control ng-model=template.info.width min=1 max=99999 maxlength=5 aria-label=width aria-labelledby=width></div></div><div class=col-xs-4><div class=input-group><span class=input-group-addon>{{\'cm.label.60\' | translate}}</span> <input type=number id=height class=form-control ng-model=template.info.height min=1 max=99999 maxlength=5 aria-label=height aria-labelledby=height></div></div><div class=col-xs-4></div></div></div><!-- EPD --><div class=form-group ng-if=\"template.info.tType == 1\"><label>{{\'cm.brief.8\' | translate}}</label><div><label><input type=radio role=radio ng-model=template.info.detail.epd.dt value=s name=dimOpt aria-labelledby=radiogroup><label></label>{{\'d.label.72\' | translate}}</label><label class=marL10><input type=radio role=radio ng-model=template.info.detail.epd.dt value=c name=dimOpt aria-labelledby=radiogroup><label></label>{{\'cm.label.17\' | translate}}</label></div><!-- EPD Model --><div class=form-group ng-if=\"template.info.detail.epd.dt == \'s\'\"><div ng-if=modelsLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-if=!modelsLoading class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=epdDType.isOpen on-toggle=toggleDropDown(open) focus-selected=template.info.detail.epd.m.id><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=epdSearchFocus(); aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=!template.info.detail.epd.m.id>{{\'d.label.72-1\' | translate}}</span> <span ng-if=template.info.detail.epd.m.id>{{template.info.detail.epd.m.model}} (Size: {{template.info.detail.epd.m.size}}, Res: {{template.info.detail.epd.m.resolution}}, DPI: {{template.info.detail.epd.m.dpi}})</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=margin-right:-7px;font-size:16px;font-weight:600></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=epdModels.length><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchEpd.l sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchEpd.l.length ng-click=\"searchEpd.l=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=epdModels.length></li><div class=\"list-scroll ng-cloak\"><div class=msg-warning ng-if=!epdModels.length>{{\'d.msg.63\' | translate}}</div>{{takeAllLicLength = (epdModels | customSearch:{key:searchEpd.l, module:\'dEpd\'}); \"\"}}<div class=msg-warning ng-if=\"!takeAllLicLength.length && epdModels.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchEpd.l)}}&quot;</b>\'}\"></div><div ng-repeat=\"(model, epdList) in epdGrouped track by model\" tabindex=$index>{{takeLenght = (epdList | customSearch:{key:searchEpd.l, module:\'dEpd\'}); \"\"}}<div class=licType ng-click=\"epdList[$index]=epdList[$index]?false:true\" ng-if=takeLenght.length><label class=noMarB>{{model}}</label><span class=\"licGrouping padL5 fa\" ng-class=\"epdList[$index]?\'fa-chevron-down\':\'fa-chevron-up\'\" aria-hidden=true></span></div><div ng-show=!epdList[$index]><li class=\"padL20 pad2 listHover\" ng-repeat=\"epd in epdList | customSearch:{key:searchEpd.l, module:\'dEpd\'} | orderBy: \'model\'\" tabindex=$index ng-class=\"{\'selected-license\': epd.id === template.info.detail.epd.m.id}\" ng-if=epd.id><div class=noMarB ng-model=template.info.detail.epd.m id={{epd.id}} ng-click=selectEpdFx(epd)>Size: {{epd.size}}, Res: {{epd.resolution}}, DPI: {{epd.dpi}}</div></li></div></div></div></div></div></div></ul></div></div><!-- Custom --><div class=row ng-if=\"template.info.detail.epd.dt == \'c\'\"><div class=col-xs-4><div class=input-group><span class=input-group-addon>{{\'cm.label.59\' | translate}}</span> <input type=number id=width class=form-control ng-model=template.info.detail.epd.w min=1 max=99999 maxlength=5 aria-label=width aria-labelledby=width></div></div><div class=col-xs-4><div class=input-group><span class=input-group-addon>{{\'cm.label.60\' | translate}}</span> <input type=number id=height class=form-control ng-model=template.info.detail.epd.h min=1 max=99999 maxlength=5 aria-label=height aria-labelledby=height></div></div><div class=col-xs-4></div></div></div></div><div class=col-xs-9><div class=form-group><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.p_dc.wos.9\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group ng-if=\"auth.upermissions.epd || (auth.upermissions.dmb && auth.upermissions.dmb_t) || auth.upermissions.tl || auth.upermissions.texl_od || auth.upermissions.texl_cl || template.info.tType == 3 || auth.upermissions.tolo\" ng-class=\"{\'marB5\':(decId && template.info.tType != 0)}\"><label>{{\'cm.label.69\' | translate}}</label><div ng-if=!decId role=radiogroup aria-labelledby=radiogroup><!-- normal --><label class=noMarB><input type=radio role=radio name=tTypeOpt ng-model=template.info.tType ng-disabled=decId ng-value=0><label></label>{{\'cl.tool.2\' | translate}}</label><!-- epd --><label class=\"noMarB marL10\" ng-if=\"auth.upermissions.epd || template.info.tType==1\"><input type=radio role=radio ng-disabled=decId ng-change=resetSettingsFx(); ng-model=template.info.tType ng-value=1><label></label>{{\'d.label.1.8\' | translate}}</label><!-- animated text --><label class=\"noMarB marL10 hide\" ng-if=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) || template.info.tType==2\"><input type=radio role=radio name=tTypeOpt ng-model=template.info.tType ng-click=\"template.info.scv=\'\'\" ng-disabled=decId ng-value=2><label></label>{{\'fl.p_cfl.label.24\' | translate}}</label><!-- dynamic text --><label class=\"noMarB marL10\" ng-if=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) || template.info.tType==4\"><input type=radio role=radio name=tTypeOpt ng-model=template.info.tType ng-click=\"template.info.scv=\'\'\" ng-disabled=decId ng-value=4><label></label>{{\'fl.p_cfl.label.26\' | translate}}</label><!-- excel template --><label class=\"noMarB marL10\" ng-if=\"auth.upermissions.texl_od || auth.upermissions.texl_cl || template.info.tType==3\"><input type=radio role=radio name=tTypeOpt ng-model=template.info.tType ng-disabled=decId ng-value=3 ng-click=selSubTypeFx();><label></label>{{\'t.label.22\' | translate}}</label><!-- olo template --><label class=\"noMarB marL10\" ng-if=\"auth.upermissions.tolo || template.info.tType==6\"><input type=radio role=radio name=tTypeOpt ng-model=template.info.tType ng-disabled=decId ng-value=6 ng-click=getStoreFx();><label></label>{{\'t.label.30\' | translate}}</label></div><div ng-if=decId><span ng-if=\"template.info.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.info.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span class=hide ng-if=\"template.info.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.info.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"template.info.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.info.tType == 6\">{{\'t.label.30\' | translate}}</span></div></div><div class=\"form-group marB10\" ng-if=\"template.info.tType == 0\"><!-- <label for=\"feedUrl\">{{\'cm.label.56\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span>\r\n                <label class=\"marL10\">\r\n                  <input type=\"checkbox\" ng-model=\"template.info.rlf\" ng-disabled=\"template.info.tType==1\" role=\"checkbox\">\r\n                  <label></label>{{\'t.label.10\' | translate}}\r\n                </label>\r\n              </label> --><label><input type=checkbox ng-model=template.info.feedOpt role=checkbox><label></label>{{\'cm.label.56\' | translate}}<span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=feedUrl class=form-control ng-if=template.info.feedOpt autocomplete=off ng-model=template.info.feedUrl ng-disabled=\"template.info.tType==1\" ng-blur=feedRefreshInterval() aria-label=\"{{\'cm.label.56\' | translate}}\" aria-labelledby=\"{{\'cm.label.56\' | translate}}\"></div><div class=form-group ng-if=template.info.feedOpt><label for=refresh>{{\'cm.label.84\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=template.info.refreshOpt name=refreshOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=template.info.refreshOpt name=refreshOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"template.info.refreshOpt == \'c\'\"><input type=number id=refresh class=form-control ng-model=template.info.refresh min=1 max=1440 maxlength=4 aria-label=\"{{\'cm.label.84\' | translate}}\" aria-labelledby=\"{{\'cm.label.84\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div><div class=marB15 ng-if=\"template.info.tType == 6\"><div class=row><div class=col-xs-8><label>{{\'t.label.32\' | translate}}</label><!-- <div ng-if=\"decId\"><span>{{curStore.store.name}}</span></div> --><div><div class=form-group ng-if=oloStoreLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=dropdownOpen.isOpen ng-if=!oloStoreLoading><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle id=store ng-click=\"searchList.t=\'\'\"><span ng-if=!curStore.store>{{\'t.label.32.1\' | translate}}</span> <span ng-if=curStore.store>{{curStore.store.name}}<span class=\"text-muted text-sm inline\"> - ({{curStore.store.id}})</span></span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10 ng-if=oloStoreList.length><li class=\"dropdown-header noPad noMar\" ng-if=\"oloStoreList.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.t sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.t.length ng-click=\"searchList.t=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"oloStoreList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"store in filteredSList = (oloStoreList | filter:searchList.t) | orderBy: \'name\'\" tabindex=$index ng-click=closeDropdown();><label><input type=radio role=radio name=storeOpt value=\"{{ {id:store.vendor_id, name:store.name} }}\" ng-checked=\"store.vendor_id == curStore.store.id\" ng-model=curStore.store ng-change=singleStoreFx() ng-disabled=\"store.vendor_id == curStore.store.id\"><label></label>{{store.name}}<span class=\"text-muted text-sm inline\"> - ({{store.vendor_id}})</span></label></li><div class=msg-warning ng-if=\"(oloStoreList | filter:searchList.t).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.t)}}&quot;</b>\'}\"></div></div></div><div class=\"padLR10 msg-warning\" ng-if=!oloStoreList.length class=msg-warning>{{\'r.msg.2\' | translate}}</div></div></div></ul></div></div></div></div></div><!-- Excel Template --><div class=\"form-group marT15\" ng-if=\"template.info.tType == 3\"><label>{{\'t.label.27\' | translate | capitalize}}</label><div ng-if=!decId ng-class=\"{\'marB10\':curContent.label != \'\'}\" role=radiogroup aria-labelledby=radiogroup><div ng-if=\"auth.upermissions.texl_cl && auth.upermissions.texl_od\"><!-- Content library --><label class=noMarB><input type=radio role=radio name=sTypeOpt ng-model=template.info.subType ng-change=changeSubTypeFx(); ng-disabled=decId value=cl><label></label>{{\'cm.menu.1\' | translate}}</label><!-- Onedrive --><label class=\"noMarB marL10\"><input type=radio role=radio name=sTypeOpt ng-model=template.info.subType ng-change=changeSubTypeFx(); ng-disabled=decId value=od><label></label>{{\'ms.p_s.serverPer.10\' | translate}}</label></div><div ng-if=\"auth.upermissions.texl_cl && !auth.upermissions.texl_od\"><span>{{\'cm.menu.1\' | translate}}</span></div><div ng-if=\"auth.upermissions.texl_od && !auth.upermissions.texl_cl\"><span>{{\'ms.p_s.serverPer.10\' | translate}}</span></div></div><div ng-if=decId><span ng-if=\"template.info.subType == \'cl\'\">{{\'cm.menu.1\' | translate}}</span> <span ng-if=\"template.info.subType == \'od\'\">{{\'ms.p_s.serverPer.10\' | translate}}</span></div><div ng-if=\"template.info.tType==3 && template.info.subType==\'cl\'\"><div class=\"form-group marT10\"><span class=\"valign-middle marR5\" ng-if=\"!template.info.isHidden && contentName != \'\' && contentName != null\"><span><span class=\"icon {{curContent.thumb}}\" ng-if=\"(curContent.type == \'Widget\' && curContent.isCompleted) && (curContent.extn != \'YouTube\' && curContent.extn != \'Vimeo\')\"></span> </span><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span> {{contentName}}</span><div class=\"pull-left relative marR5\" ng-if=template.info.isHidden><img alt=\"\" uib-tooltip=\"{{\'t.msg.36\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><br ng-if=\"!template.info.isHidden && contentName != \'\' && contentName != null\"><button ng-if=\"template.info.subType == \'cl\'\" type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT5\" ng-click=selectExcelOpen();><span class=excel aria-hidden=true></span>{{(!template.info.isHidden && contentName != \'\' && contentName != null)?\'t.label.29-1\':\'t.label.29\' | translate | camelCase}}</button></div></div></div><!-- OneDrive --><div class=marT15 ng-if=\"template.info.isCompleted && ((template.info.tType==1 && auth.upermissions.epd) || (template.info.tType==3 && template.info.subType==\'od\'))\"><div class=\"form-group marB5\"><label>{{template.info.tType==1?\'t.label.24\':\'t.label.29\' | translate}}</label><div><div class=\"valign-middle marR5\" ng-if=\"!template.info.isHidden && contentName != \'\' && contentName != null\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span> {{contentName}} <img src=assets/images/loading-xs.gif ng-if=odLSLoading alt=loading> <span class=\"text-bold marL5\" ng-if=odLS>[ {{\"t.label.33\" | translate}} {{(odLS * 1000) | date:\"MMM d, y h:mm a\"}} ]</span></div><!-- <br ng-if=\"!template.info.isHidden && contentName != \'\' && contentName != null\"> --><div class=\"pull-left relative marR5\" ng-if=template.info.isHidden><img alt=\"\" uib-tooltip=\"{{\'t.msg.36\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><!-- <button type=\"button\" role=\"button\" ng-if=\"!template.info.isAuthorized && !content.items\" class=\"btn btn-success\" ng-disabled=\"odDisabled\" ng-click=\"openUrlFx(626, 450);\"><span class=\"fa fa-repeat fa-spin\" ng-if=\"odProcessing\" aria-hidden=\"true\"></span> {{\'t.label.13\' | translate}}</button> --> <button type=button role=button class=\"btn btn-default btn-xs marT5\" ng-click=openConfirmFx();><img alt=\"\" src=assets/images/tp/onedrive.svg width=15px class=marR5 ng-if=\"template.info.tType==1\"><span class=excel aria-hidden=true ng-if=\"template.info.tType==3\"></span>{{(!template.info.isHidden && contentName != \'\' && contentName != null)?(template.info.tType==1?\'t.label.24-1\':\'t.label.29-1\'):(template.info.tType==1?\'t.label.24\':\'t.label.29\') | translate | camelCase}}</button><!-- <button type=\"button\" role=\"button\" ng-if=\"template.info.isAuthorized || content.items\" class=\"btn btn-default btn-xs marT6\" ng-click=\"openConfirmFx();\"><span class=\"oneDrive\"></span> {{template.info.isAuthorized?\'Change Excel\':\'t.label.29\' | translate | camelCase}}</button> --></div><!-- <button type=\"button\" role=\"button\" ng-if=\"template.info.isAuthorized\" class=\"btn btn-primary marT20\" ng-disabled=\"odDisabled\" ng-click=\"openConfirmFx()\"><span class=\"fa fa-repeat fa-spin\" ng-if=\"odProcessing\" aria-hidden=\"true\"></span> {{\'t.label.16\' | translate}}</button> --></div></div><!-- <div class=\"row marB15\" ng-if=\"template.info.feedUrl\">\r\n              <div class=\"col-xs-8\">\r\n                <label for=\"refresh\">{{\'cm.label.84\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label>\r\n                <div class=\"input-group\">\r\n                  <input type=\"number\" id=\"refresh\" class=\"form-control\" ng-model=\"template.info.refresh\" min=\"5\" max=\"99999\" maxlength=\"5\" aria-label=\"{{\'cm.label.84\' | translate}}\" aria-labelledby=\"{{\'cm.label.84\' | translate}}\">\r\n                  <span class=\"input-group-addon\">{{\'cm.label.27s\' | translate}}</span>\r\n                </div>\r\n              </div>\r\n            </div>  --><div class=\"form-group hide\" ng-if=\"(auth.upermissions.dmb && auth.upermissions.dmb_t) && template.info.tType == 0\"><label class=noMarB><input type=checkbox ng-model=template.info.scv ng-disabled=decId role=checkbox><label></label>{{\'t.label.11\' | translate}} <span class=\"fa fa-info-circle text-primary\" uib-tooltip-html=htmlTooltip tooltip-placement=right aria-hidden=true></span></label></div><div class=form-group ng-if=\"(auth.uType == 0 || auth.uType == 1) && decType != \'t\' && template.info.tType != 1 && template.info.tType != 3\"><label ng-class=\"{\'noMarB\': !template.info.libraryOpt}\"><input type=checkbox ng-model=template.info.libraryOpt ng-disabled=encId role=checkbox><label></label>{{\'fl.p_cfl.label.3\' | translate}}</label><div ng-if=template.info.libraryOpt><select id=category class=form-control ng-model=template.info.category ng-options=\"library as library.label for library in librarys track by library.id\" aria-label=\"{{\'fl.p_cfl.label.4\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.4\' | translate}}\"><option value=\"\">{{\'fl.p_cfl.label.4\' | translate}}</option></select><div class=\"form-group marT15\" ng-if=!template.info.category><label for=newCategory>{{\'fl.p_cfl.label.5\' | translate}}</label><input type=text id=newCategory class=form-control ng-model=template.info.newCategory aria-label=\"{{\'fl.p_cfl.label.5\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.5\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-6><div class=form-group ng-if=!template.info.libraryOpt><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=template.permission pid=decId module=\"\'template\'\"></ng-permission-brief></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveTemplate(\'name\', \'sc\');\" ng-if=template.info.isCompleted ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveTemplate(\'name\');\" ng-disabled=\"saveProcessing || saveCloseProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'t.btn.3\' | translate}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx(); ng-disabled=\"saveProcessing || saveCloseProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'t.msg.8\' | translate}}</div><div ng-if=\"errType==\'dim\'\" aria-live=polite role=status>{{\'t.msg.9\' | translate}}</div><div ng-if=\"errType==\'epdModel\'\" aria-live=polite role=status>{{\'d.label.72-2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'library\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.3\' | translate}}</div><div ng-if=\"errType==\'categoryExists\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.4\' | translate}}</div><div ng-if=\"errType == \'content\'\" aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div ng-if=\"errType == \'hasStore\'\" aria-live=polite role=status>{{\'t.msg.38\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/templates/templates.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"selectedTab == \'hub.templates.t\' && templatesLoading\"> <span ng-if=\"selectedTab == \'hub.templates.t\' && !templatesLoading\"><!-- <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-if=\"auth.upermissions.t && curFolderId != 0\" ui-sref=\"hub.tContainer.tName({type: encType})\"><span class=\"fa fa-plus-circle\" aria-hidden=\"true\"></span>{{\'t.btn.1\' | translate}}</button> --> <button type=button role=button class=\"btn btn-primary\" ng-if=\"(auth.upermissions.t && auth.upermissions.art) || (auth.upermissions.t && (!auth.upermissions.art && curTFolderId != 0))\" ui-sref=\"hub.tContainer.tName({type: encType})\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'t.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-if=\"(auth.upermissions.tf && auth.upermissions.art) || (auth.upermissions.tf && (!auth.upermissions.art && curTFolderId != 0))\" ng-click=\"folderCUOpen(\'n\');\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.3\' | translate}}</button></span></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=searchBox class=lableHidden>{{\'as.btn.1\' | translate}}</label><div class=\"input-group1 searchTbx\" ng-class=\"{\'input-group\': selectedTab == \'hub.templates.t\'}\"><input type=text class=form-control id=searchBox ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"selectedTab == \'hub.templates.t\'\"><!-- <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle name=\"search\" id=\"sortBtn\"><span class=\"fa fa-sort noMarR\"></span></button>\r\n        <ul class=\"dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r\n          <li><a href=\"\" id=\"advSearch\" ng-click=\"advancedSearchTempOpen(\'t\', \'t\');\">{{\'cm.body.10\' | translate}}</a></li>\r\n        </ul> --> <button id=advSearch type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.body.10\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left ng-click=\"advancedSearchTempOpen(\'t\', \'t\');\"><span class=\"fa fa-sort noMarR\" aria-hidden=true></span></button></span></div></div><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo></advanced-search></div><div ng-if=!advSearch><div class=spaceH></div><div class=spaceH></div></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs t\" role=tablist aria-owns=\"tab-t tab-ts tab-ut tab-it tab-tl\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.templates.t\')}}\" aria-controls=tab-t id=tab-t class=tab-success><a ui-sref=.t role=link aria-label=\"{{\'t.tab.1\' | translate}}\">{{\'t.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.templates.ts\')}}\" aria-controls=tab-ts id=tab-ts class=tab-info ng-if=auth.upermissions.f45Workout><a ui-sref=.ts role=link aria-label=\"{{\'t.tab.6\' | translate}}\">{{\'t.tab.6\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.templates.ut\')}}\" aria-controls=tab-ut id=tab-ut class=tab-disabled><a ui-sref=.ut role=link aria-label=\"{{\'t.tab.2\' | translate}}\">{{\'t.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.templates.it\')}}\" aria-controls=tab-it id=tab-it class=tab-disabled><a ui-sref=.it role=link aria-label=\"{{\'t.tab.3\' | translate}}\">{{\'t.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.templates.tl\')}}\" aria-controls=tab-tl id=tab-tl class=tab-primary><a ui-sref=.tl role=link aria-label=\"{{\'t.tab.4\' | translate}}\">{{\'t.tab.4\' | translate}}</a></li></ul><div class=panel-tools ng-if=\"selectedTab != \'hub.templates.tl\'\"><div class=pull-right uib-dropdown><a href=\"\" role=button id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-placement=left><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': templates.info.sortType === \'label\' && templates.info.sortVal === \'asc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'label\', \'asc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': templates.info.sortType === \'label\' && templates.info.sortVal === \'desc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'label\', \'desc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator ng-if=\"selectedTab == \'hub.templates.t\'\"></li><li class=dropdown-header ng-if=\"selectedTab == \'hub.templates.t\'\">{{\'cm.tool.1.2\' | translate}}</li><li ng-if=\"selectedTab == \'hub.templates.t\'\" ng-class=\"{\'selected\': templates.info.sortType === \'approvedon\' && templates.info.sortVal === \'asc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'approvedon\', \'asc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-if=\"selectedTab == \'hub.templates.t\'\" ng-class=\"{\'selected\': templates.info.sortType === \'approvedon\' && templates.info.sortVal === \'desc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'approvedon\', \'desc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': templates.info.sortType === \'createdon\' && templates.info.sortVal === \'asc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'createdon\', \'asc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': templates.info.sortType === \'createdon\' && templates.info.sortVal === \'desc\'}\"><a href=\"\" role=menuitem ng-click=\"sortFx(\'createdon\', \'desc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><!-- <li class=\"divider\"></li>\r\n          <li class=\"dropdown-header\">{{\'cm.brief.3\' | translate | camelCase}}</li>\r\n          <li ng-class=\"{\'selected\': templates.info.sortType === \'createdby\' && templates.info.sortVal === \'asc\'}\">\r\n            <a href=\"\" role=\"menuitem\" ng-click=\"sortFx(\'createdby\', \'asc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.4\' | translate}}</a>\r\n          </li>\r\n          <li ng-class=\"{\'selected\': templates.info.sortType === \'createdby\' && templates.info.sortVal === \'desc\'}\">\r\n            <a href=\"\" role=\"menuitem\" ng-click=\"sortFx(\'createdby\', \'desc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.5\' | translate}}</a>\r\n          </li>\r\n          <li class=\"divider\"></li>\r\n          <li class=\"dropdown-header\">{{\'cm.label.69\' | translate}}</li>\r\n          <li ng-class=\"{\'selected\': templates.info.sortType === \'type\' && templates.info.sortVal === \'asc\'}\">\r\n            <a href=\"\" role=\"menuitem\" ng-click=\"sortFx(\'type\', \'asc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.4\' | translate}}</a>\r\n          </li>\r\n          <li ng-class=\"{\'selected\': templates.info.sortType === \'type\' && templates.info.sortVal === \'desc\'}\">\r\n            <a href=\"\" role=\"menuitem\" ng-click=\"sortFx(\'type\', \'desc\', templateList, templates.info, \'templatesort\');\">{{\'cm.tool.1.5\' | translate}}</a>\r\n          </li> --></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=button id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-if=\"selectedTab == \'hub.templates.t\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'t\');\" translate=\"{{\'t.tool.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.templates.ut\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'ut\');\" translate=\"{{\'t.tool.3\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li><li ng-if=\"selectedTab == \'hub.templates.it\'\" class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'it\');\" translate=\"{{\'t.tool.4\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li></ul></div><div class=pull-right ng-if=\"auth.upreferences.templateView== \'l\'\"><a href=\"\" role=link id=listView uib-tooltip={{templateViewText}} tooltip-append-to-body=true ng-click=\"preferencesFx(\'templateView\', \'t\'); removeSelectedFx();closeBriefFx();\"><span class=\"glyphicon glyphicon-th\" ng-class=\"{\'glyphicon-th-list\':auth.upreferences.templateView== \'t\'}\" aria-hidden=true></span></a></div><div class=pull-right ng-if=\"auth.upreferences.templateView== \'t\'\"><a href=\"\" role=link id=listView uib-tooltip={{templateViewText}} ng-click=\"preferencesFx(\'templateView\', \'l\'); removeSelectedFx();closeBriefFx();\"><span class=\"glyphicon glyphicon-th\" ng-class=\"{\'glyphicon-th-list\':auth.upreferences.templateView== \'t\'}\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=button id=refresh ng-click=\"loadSelectedTab(\'refresh\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingMain><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></span></a></div></div><div class=panel-tools ng-if=\"selectedTab==\'hub.templates.tl\'\"><div class=pull-right ng-if=\"auth.upreferences.templateView==\'l\'\"><a href=\"\" role=link id=listView uib-tooltip={{templateViewText}} tooltip-append-to-body=true tooltip-placement=left ng-click=\"preferencesFx(\'templateView\', \'t\'); removeSelectedFx();closeBriefFx();\"><span class=\"glyphicon glyphicon-th\" ng-class=\"{\'glyphicon-th-list\':auth.upreferences.templateView== \'t\'}\" aria-hidden=true></span></a></div><div class=pull-right ng-if=\"auth.upreferences.templateView==\'t\'\"><a href=\"\" role=link id=listView uib-tooltip={{templateViewText}} tooltip-placement=left ng-click=\"preferencesFx(\'templateView\', \'l\'); removeSelectedFx();closeBriefFx();\"><span class=\"glyphicon glyphicon-th\" ng-class=\"{\'glyphicon-th-list\':auth.upreferences.templateView== \'t\'}\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><!--For Selected Item Brief--><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-template-brief ng-if=\"selectedItems.length > 0\"></ng-template-brief>");
$templateCache.put("app/templates/tl.html","<img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><div ng-if=!templatesLoading><div class=breadcrumb ng-if=templates.info.breadcrumb><a href=\"\" role=link ng-click=\"loadSelectedTab(\'home\'); selectedTabFx();\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span>{{templates.info.breadcrumb.label}}</span> <a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><ul class=\"list-inline thumb-list cl-list\" ng-if=\"templates.templates[0].type == \'Folder\' && auth.upreferences.templateView == \'t\'\" ng-click=selectableFx($event)><li ng-repeat=\"folder in filteredLibraryList = (templates.templates | customSearch:{key:searchText, module:\'fl\'})\" ng-click=\"selectFolderFx($event, folder);\" ng-dblclick=\"openFolderFx(\'tl\', folder.id);\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder.png></span></div><!-- <div class=\"thumb-label\">{{folder.label}}</div> --><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{folder.label}}</div></li></ul><ul class=\"table table-md ui-selectable list-unstyled cl-list\" ng-if=\"templates.templates[0].type == \'Folder\' && auth.upreferences.templateView == \'l\'\" ng-click=selectableFx($event)><div class=\"row th\" ng-if=\"templates.templates.length > 0\"><div class=col-xs-12><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', templateList, templates.info, \'templatesort\', templates.templates, \'tList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div></div><li class=row ng-repeat=\"folder in filteredLibraryList = (templates.templates | customSearch:{key:searchText, module:\'fl\'})\" ng-click=\"selectFolderFx($event, folder);\" ng-dblclick=\"openFolderFx(\'tl\', folder.id);\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"templates.templates.length > 0\" context-menu=contextMenuOpt><div class=\"col-xs-12 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> </span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span><!-- <div class=\"text-ellipsis w100px marT5\" uib-tooltip=\"{{folder.label}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\">{{folder.label}}</div> --></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"templates.templates.length > 0 && templates.templates[0].type == \'Folder\' && (templates.templates | customSearch:{key:searchText, module:\'t\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><!-- <ul class=\"list-inline thumb-list\" ng-if=\"templates.templates.length > 0 && templates.templates[0].type != \'Folder\'\">\r\n    <ng-template-list class=\"show\" selectable=\"selection\" selectable-options=\"{filter:\'li\'}\" selectable-list=\"templates.templates\"></ng-template-list>\r\n  </ul> --><ul class=\"list-inline thumb-list\" ng-if=\"templates.templates.length > 0 && templates.templates[0].type != \'Folder\' && auth.upreferences.templateView == \'t\'\"><ng-template-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=templates.templates></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"templates.templates.length > 0 && templates.templates[0].type != \'Folder\' && auth.upreferences.templateView == \'l\'\"><ng-template-list-view class=show id=template-list selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=templates.templates></ng-template-list-view></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templates.templates.length == 0\"><div ng-if=!templates.info>{{\'t.msg.4\' | translate}}</div><div ng-if=templates.info>{{\'t.msg.5\' | translate}}<div class=marT10 ng-if=\"auth.uType == 0\"><button type=button role=button class=\"btn btn-default btn-sm\" ng-click=\"confirmTemplateOpen(\'category\');\" ng-disabled=flProcessing><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'fl.btn.11\' | translate}}</button></div></div></div>");
$templateCache.put("app/templates/ts.html","<img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><div context-menu=contextMenuBase><div class=row ng-if=\"!templatesLoading && templates.templates.length > 0\"><div class=col-xs-12><!-- <ul class=\"list-inline thumb-list\">\r\n        <ng-template-list class=\"show\" selectable=\"selection\" selectable-options=\"{filter:\'li\'}\" selectable-list=\"templates.templates\"></ng-template-list>\r\n      </ul> --><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.templateView == \'t\'\"><ng-template-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=templates.templates></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.templateView == \'l\'\"><ng-template-list-view class=show id=template-list selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=templates.templates></ng-template-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templates.templates.length == 0\"><p class=noMar>{{\'t.msg.23\' | translate}}</p></div></div>");
$templateCache.put("app/templates/ut.html","<img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><div class=row ng-if=\"!templatesLoading && templates.templates.length > 0\"><div class=col-xs-12><!-- <ul class=\"list-inline thumb-list\">\r\n      <ng-template-list class=\"show\" selectable=\"selection\" selectable-options=\"{filter:\'li\'}\" selectable-list=\"templates.templates\"></ng-template-list>\r\n    </ul> --><ul class=\"list-inline thumb-list\" ng-if=\"auth.upreferences.templateView == \'t\'\"><ng-template-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=templates.templates></ng-template-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"auth.upreferences.templateView == \'l\'\"><ng-template-list-view class=show id=template-list selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=templates.templates></ng-template-list-view></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templates.templates.length == 0\"><p>{{\'t.msg.2\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ut\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'t.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div>");
$templateCache.put("app/support/kb.html","<img alt=Loading src=assets/images/loading.gif ng-if=supportLoading><div class=\"row pad10\" ng-if=!supportLoading><div class=vidKbQuad ng-repeat=\"vid in vidKb.list\"><a href=\"\" role=link ng-click=\"videoFx(vid.vidId, vid.label)\"><div class=vidKbThumb><span class=overlay></span><span class=duration>{{vid.duration}}</span><img alt=\"\" ng-src=\"{{vidKb.info.bucket +\'kb/vidThumbs/\'+ vid.vidId}}.png?{{timestamp}}\"></div><div class=info><div class=\"title-txt text-ellipsis\" uib-tooltip={{vid.label}} ng-if=vid.label>{{vid.label}}</div><div class=subtitle-txt ng-if=vid.description>{{vid.description}}</div><div class=text-bold ng-if=vid.subTitle>{{vid.subTitle}}</div></div></a></div></div>");
$templateCache.put("app/support/support.html","<section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs\" role=tablist aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active class=tab-success role=tab aria-selected=\"{{$state.includes(\'hub.support.ts\')}}\" aria-controls=tab-1 id=tab-1><a ui-sref=.ts>{{\'sc.tab.1\' | translate}}</a></li><li ng-class=\"{\'active\':curTabFr}\" class=tab-primary role=tab aria-selected={{curTabFr}} aria-controls=tab-2 id=tab-2><a ui-sref=.fr.rf>{{\'sc.tab.2\' | translate}}</a></li><li ui-sref-active=active class=\"tab-danger hide\" role=tab aria-selected=\"{{$state.includes(\'hub.support.rb\')}}\" aria-controls=tab-3 id=tab-3><a ui-sref=.rb>{{\'sc.tab.3\' | translate}}</a></li><li ui-sref-active=active class=tab-primary role=tab aria-selected=\"{{$state.includes(\'hub.support.kb\')}}\" aria-controls=tab-4 id=tab-4><a ui-sref=.kb>{{\'sc.tab.4\' | translate}}</a></li></ul><div class=panel-tools ng-if=\"$state.includes(\'hub.support.fr.rf\') === true || $state.includes(\'hub.support.fr.af\') === true || $state.includes(\'hub.support.fr.im\') === true\"><div class=pull-right uib-dropdown><a href=\"\" role=button id=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=info><a href=\"\" role=menuitem ng-click=\"readMeFx(\'fr\')\" translate=\"{{\'sc.fr.body.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></a></li></ul></div><div class=\"pull-right marT6 marR5\" ng-if=\"$state.includes(\'hub.support.fr.rf\') === true\"><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=requestOpen();><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'sc.fr.btn.1\' | translate}}</button></div></div></header><div class=panel-body ui-view=tabView></div></section>");
$templateCache.put("app/support/ts.html","<div class=tsQuad><p translate=\"{{\'sc.ts.body.1\'}}\" translate-values=\"{lsnh:\'L Squared Hub&trade;\', lsn:\'L Squared\'}\"></p><div class=marT25><a href=\"\" role=link ng-click=bugsOpen();><span class=\"fa fa-envelope\" aria-hidden=true></span> {{\'sc.ts.btn.1\' | translate}} / {{\'sc.ts.btn.2\' | translate}}</a></div><!-- <div class=\"marT10 hide\"><a href=\"\" role=\"link\" ng-click=\"bugsOpen();\"><span class=\"fa fa-bug\" aria-hidden=\"true\"></span> {{\'sc.ts.btn.2\' | translate}}</a></div> --><div class=marT10><a href=\"\" role=link ng-click=feedbackOpen();><span class=\"fa fa-commenting-o\" aria-hidden=true></span> {{\'sc.ts.btn.3\' | translate}}</a></div><div class=marT10><a href=\"\" role=link ng-click=\"appsOpen({id:0, label:\'L Squared Hub\', version:uiVersion});\"><span class=\"fa fa-file-text-o\" aria-hidden=true></span> {{\'sc.ts.btn.15\' | translate}}</a></div><!-- Documents --><!-- <div class=\"bg-muted bdrLeftServerPer pad10 marT25\" ng-if=\"documentList.length\"><label class=\"text-lg noMarB\">{{\'sc.ts.body.2\' | translate}}</label></div> --><div class=\"panel-inner-tab marT25\" ng-if=documentList.length>{{\'sc.ts.body.2\' | translate}}</div><div class=marL10><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"documentList.length && docsLoading\"><div class=\"marT10 text-md\" ng-if=\"documentList.length && !docsLoading\" ng-repeat=\"docs in documentList\"><a href=\"{{docs.kb.url +\'?\'+ timestamp}}\" role=link target=_blank><span class=\"fa fa-file-pdf-o\" aria-hidden=true></span> {{docs.hubDocType.label}}</a></div></div><!-- Downloads --><!-- <div class=\"bg-muted bdrLeftServerPer pad10 marT25\" ng-if=\"downloadList.length\"><label class=\"text-lg noMarB\">{{\'sc.ts.body.3\' | translate}}</label></div> --><div class=\"panel-inner-tab marT25 d-flex align-items-center\" ng-if=downloadList.length><span class=me-auto>{{\'sc.ts.body.7\' | translate}}</span><div class=\"bdr-r-solid padR10 marR5\" ng-if=fps><a ng-href={{fps}} role=link target=_blank class=\"btn btn-default btn-xs\">{{\'sc.ts.btn.16\' | translate}} <span class=\"fa fa-external-link marL5 noMarR\" aria-hidden=true></span></a></div><div class=\"nonSelectable marR5\"><span class=\"fa fa-info-circle text-primary pad5 cursorPointer\" ng-if=\"downloadList.length && !appsLoading && isPublisherExists\" ng-click=unblockOpen(); aria-hidden=true></span></div></div><div class=marL10><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"downloadList.length && appsLoading\"><!-- <div ng-if=\"downloadList.length && !appsLoading && isPublisherExists\" class=\"marT10 bg-info text-info pad5\"><span class=\"text-bold\">{{\'cm.label.66\' | translate}}:</span> {{\'sc.ts.body.4\' | translate}} <a href=\"\" role=\"link\" ng-click=\"unblockOpen();\" class=\"btn-link\">{{\'sc.ts.btn.12\' | translate}}</a></div> --><div class=\"marT10 text-md hide\" ng-if=\"downloadList.length && !appsLoading\" ng-repeat=\"apps in downloadList\"><a ng-if=!apps.isPublisher href=\"{{apps.url +\'?\'+ timestamp}}\" role=link target=_blank download><span class=\"fa fa-file-archive-o\" aria-hidden=true></span> {{apps.hubAppType.label}} <span class=text-muted ng-if=apps.version>| {{apps.version}}</span></a> <a ng-if=apps.isPublisher href=\"\" role=button ng-click=publisherOpen()><span class=\"fa fa-file-archive-o\" aria-hidden=true></span> {{apps.hubAppType.label}}<span class=text-muted ng-if=apps.version> | {{apps.version}}</span></a></div><div class=\"support-container noPadL\" ng-if=\"downloadList.length && !appsLoading\"><!-- <button type=\"button\" role=\"button\" ng-repeat=\"apps in downloadList\" class=\"support-item {{apps.type}}OP\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\" ng-if=\"apps\"> --> <button type=button role=button ng-repeat=\"apps in downloadList\" class=\"support-item {{apps.type}}OP nonSelectable\" ng-click=\"appsOpen(apps, licenseKey);$event.preventDefault();\" ng-if=apps><img class=defaultImg src=assets/images/platform/{{apps.type}}-color.svg alt={{apps.type}} ng-if=\"apps.type != \'playstore\'\"> <img class=hoverImg src=assets/images/platform/{{apps.type}}-white.svg alt={{apps.type}} ng-if=\"apps.type != \'playstore\'\"> <img src=assets/images/platform/{{apps.type}}-color.svg alt={{apps.type}} ng-if=\"apps.type == \'playstore\'\"><div class=marT4>{{apps.hubAppType.label}}<div class=supportV ng-if=apps.version>V {{apps.version}}</div></div></button><!-- <span ng-repeat=\"apps in downloadList\" class=\"support-item {{apps.type}}OP\" ng-if=\"apps\">\r\n        <a href=\"\" role=\"link\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\">\r\n          <img class=\"defaultImg\" src=\"assets/images/platform/{{apps.type}}-color.svg\" alt=\"{{apps.type}}\" ng-if=\"apps.type != \'playstore\'\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\">\r\n          <img class=\"hoverImg\" src=\"assets/images/platform/{{apps.type}}-white.svg\" alt=\"{{apps.type}}\" ng-if=\"apps.type != \'playstore\'\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\">\r\n          <img src=\"assets/images/platform/{{apps.type}}-color.svg\" alt=\"{{apps.type}}\" ng-if=\"apps.type == \'playstore\'\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\">\r\n        </a>\r\n        <div class=\"marT4\"><a href=\"\" role=\"link\" ng-click=\"downloadApk(apps.url, apps.type);$event.preventDefault();\">{{apps.hubAppType.label}}</a></div>\r\n        <div class=\"supportV\" ng-if=\"apps.version\"><a href=\"\" role=\"link\" ng-click=\"appsOpen(apps.hubAppType, apps.version);\">V {{apps.version}}</a></div></div>\r\n      </span> --></div></div></div>");
$templateCache.put("app/teamsApp/teamsApp.html","teamsApp");
$templateCache.put("app/users/au.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div context-menu=contextMenuBase><div ng-if=\"!usersLoading && users.users.length > 0\" aria-label=Primary><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.users.length == 0\">{{\'u.msg.1\' | translate}}</div></div>");
$templateCache.put("app/users/bu.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div ng-if=\"!usersLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.users.length == 0\"><p>{{\'u.msg.3\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'bu\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'u.tool.2\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div><div class=marB5><a href=\"\" role=link ng-click=\"videoFx(\'u\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'u.tool.3\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></span></a></div></div>");
$templateCache.put("app/users/mb.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div ng-if=!usersLoading><header class=\"panel-inner-tab marT10 marB10\" role=tablist aria-owns=\"tab-1 tab-2\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><a href=\"\" role=tab aria-selected=\"{{selectedT==\'1\'}}\" aria-controls=tab-1 id=tab-1 ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'cm.dmb.9\' | translate}}</a> <a href=\"\" role=tab aria-selected=\"{{selectedT==\'2\'}}\" aria-controls=tab-2 id=tab-2 ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\">{{\'cm.label.5s\' | translate}}</a></header><div ng-if=\"selectedT==1\" role=tabpanel><img alt=Loading src=assets/images/loading.gif ng-if=usersMBLoading><div context-menu=contextMenuBase><div ng-if=\"!usersMBLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersMBLoading && users.users.length == 0\">{{\'u.msg.1\' | translate}}</div></div></div><div ng-if=\"selectedT==2\" role=tabpanel><img alt=Loading src=assets/images/loading.gif ng-if=usersMBLoading><div context-menu=contextMenuBase><div ng-if=\"!usersMBLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersMBLoading && users.users.length == 0\">{{\'u.msg.1\' | translate}}</div></div></div><div class=\"row marT20\" ng-if=\"dmbSettings.users.length > 0\"><div class=col-xs-12><div class=\"table table-md\"><div class=\"row th\"><div class=col-xs-2>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.47\' | translate}}</div><div class=col-xs-3>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-1></div></div><div class=scrollQuad><div class=\"row word-break\" ng-repeat=\"user in dmbSettings.users | filter:searchUserTxt\" data-id={{user.id}}><div class=col-xs-2>{{user.label}}</div><div class=col-xs-3>{{user.email}}</div><div class=col-xs-3>{{user.brand.label}}</div><div class=col-xs-3><ul class=list-inline><li class=\"noPad marR5\" ng-repeat=\"device in user.devices\">{{device.label}}<span ng-if=!$last>,</span></li></ul></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-primary ng-click=\"sendPwdFx(user.userId, $index);\" ng-disabled=sendPwdProcessing uib-tooltip=\"{{\'u.brief.6\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-share-square\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marLR5\" ng-click=\"editOpen(user, $index);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'u\', user.userId, $index);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.users | filter:searchUserTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchUserTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.users.length == 0\">{{\'cm.dmb.m6\' | translate}}</div></div></div></div>");
$templateCache.put("app/users/roleCU.html","<div class=\"row pageHeading\" ng-if=auth.upreferences.isPopup><div class=\"col-xs-9 col-lg-10\"><a href=\"\" role=link class=marR10 ui-sref=hub.users.rr>{{\'u.tab.4\' | translate}}</a>/<span class=marL10>{{decId == \'\'?\'u.btn.3\':\'u.p_role.1\' | translate}}</span></div><div class=\"col-xs-3 col-lg-2 text-right\"><div class=\"input-group1 searchTbx\"><input type=text class=form-control ng-model=ur.searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=ur.searchText.length ng-click=\"ur.searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{decId == \'\'?\'u.btn.3\':\'u.p_role.1\' | translate}}</h1></header><div class=\"panel-body overflow-auto\" ng-attr-style=height:{{getAvailableHeight(265)}}px;><img alt=Loading src=assets/images/loading.gif ng-if=!role.rightsGroups><div class=row ng-if=role.rightsGroups><div class=col-xs-7><div class=form-group><label for=label>{{\'u.p_role.2\' | translate}}</label><input type=text id=label class=form-control ng-model=role.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'u.p_role.2\' | translate}}\" aria-labelledby=\"{{\'u.p_role.2\' | translate}}\"></div></div><div class=col-xs-12><div class=form-group><label ng-if=ur.filterdList.length>{{\'u.p_role.3\' | translate}}</label><div class=row>{{ur.searchTex}}<div class=col-xs-3 ng-repeat=\"rightsGrp in role.rightsGroups | filter:ur.searchTex\"><label class=label-big><input type=checkbox ng-change=\"selectEntity(\'all\', $index);\" ng-model=rightsGrp.selected data-id={{rightsGrp.id}} role=checkbox><label></label>{{\'rights.\'+rightsGrp.id | translate}}</label><div ng-repeat=\"right in ur.filterdList = (rightsGrp.rights | customSearch:{key:ur.searchText, module:\'role\'})\"><label class=text-unbold ng-if=\"right.key != \'1.65536\'\"><input type=checkbox ng-model=right.selected ng-change=selectEntity(); class=rightsName role=checkbox><label></label>{{\'rights.\'+right.key | translate}}</label><label class=text-unbold ng-if=\"right.key == \'1.65536\' && auth.upermissions.tm\"><input type=checkbox ng-model=right.selected ng-change=selectEntity(); class=rightsName role=checkbox><label></label>{{\'rights.\'+right.key | translate}}</label></div><div ng-if=!ur.filterdList.length class=msg-warning lang={{auth.lang}}>{{\'u.p_role.m5\' | translate}}</div><div class=spaceH></div></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveRoleFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> <span ng-if=!encId>{{saveProcessing?\'cm.btn.14i\':\'cm.btn.14\' | translate}}</span> <span ng-if=encId>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.users.rr>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'u.p_role.m1\' | translate}}</div><div ng-if=\"errType==\'right\'\" aria-live=polite role=status>{{\'u.p_role.m3\' | translate}}</div><div ng-if=\"errType==\'sAdd\'\" aria-live=polite role=status>{{\'u.p_role.m4\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'u.p_role.m2\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/users/rr.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div context-menu=contextMenuBase><div class=tab-pane ng-if=\"!usersLoading && users.roles.length > 0\"><div class=\"table table-md dTable\" role=table>{{curSearchText = (users.roles | filter:{role:searchText});\"\"}}<div class=\"row th\" ng-if=\"curSearchText.length > 0\"><div class=col-xs-3>{{\'u.body.2\' | translate}}</div><div class=col-xs-7>{{\'u.body.3\' | translate}}</div><div class=col-xs-1>{{\'cm.label.5s\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=\"row roleList\" ng-repeat=\"rr in curSearchText\" data-id={{rr.id}}><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=rr.key>{{\'roles.\'+ rr.key | translate}}</span> <span ng-if=!rr.key>{{rr.role}}</span></div><div class=col-xs-7><p ng-repeat=\"keys in rr.rightsKey\"><span class=text-bold><span class=marR5 ng-class=\"{\'fa fa-folder-open\':keys[0] == \'1\', \'fa fa-file-o\':keys[0] == \'2\', \'fa fa-calendar\':keys[0] == \'3\', \'fa fa-object-ungroup\':keys[0] == \'4\', \'glyphicon glyphicon-hdd\':keys[0] == \'5\', \'fa fa-user\':keys[0] == \'6\', \'fa fa-star\':keys[0] == \'57\', \'fa fa-table\':keys[0] == \'66\'}\" aria-hidden=true></span>{{\'cm.menu.\'+keys[0] | translate}}:</span> <span ng-repeat=\"key in keys\" ng-if=\"$index != 0\">{{\'rights.\'+ key | translate}}<span class=marR3 ng-if=!$last>,</span></span></p></div><div class=col-xs-1>{{rr.users}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"roleUserListFx(rr.id, rr.key?(\'roles.\'+ rr.key | translate):rr.role)\" ng-if=\"rr.users > 0\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" aria-label=editRole ng-click=editRole(rr.id); ng-if=rr.editable><span class=\"fa fa-pencil\" aria-hidden=true></span> </a><a href=\"\" role=link class=text-danger aria-label=delete ng-click=\"confirmOpen(\'role\', rr.id, rr.users);\" ng-if=rr.deletable><span class=\"fa fa-close\" aria-hidden=true></span></a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"curSearchText.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.roles.length == 0\">{{\'u.msg.4\' | translate}}</div></div>");
$templateCache.put("app/users/ug.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div context-menu=contextMenuBase><div ng-if=\"!usersLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.users.length == 0\"><p>{{\'u.msg.2\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'ug\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> <span translate=\"{{\'u.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div><div class=marB5><a href=\"\" role=link ng-click=\"videoFx(\'ug\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'u.tool.5\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span></a></div></div></div>");
$templateCache.put("app/users/ugName.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.users.ug>{{\'u.tab.2\' | translate}}</a>/ <span class=\"marL10 marR10\">{{encId == \'\'?\'u.btn.2\':\'u.p_group.1\' | translate}}</span><span ng-if=userGrp.info.label class=text-muted>[ {{userGrp.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 1}\'}}: {{\'u.p_group.2\' | translate}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepBlue><p>1</p></span><i></i><span class=stepGray><p>2</p></span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=row ng-if=!detailLoading><div class=col-xs-6><div class=form-group><label for=label>{{\'cm.label.78\' | translate}}</label><input type=text class=form-control id=label ng-keypress=\"$event.keyCode == 13 && saveUserGrpFx(\'name\');\" ng-model=userGrp.info.label maxlength={{inputLimit}} focus-me=true placeholder=\"{{\'u.p_group.ph1\' | translate}}\" aria-label=\"{{\'cm.label.78\' | translate}}\" aria-labelledby=\"{{\'cm.label.78\' | translate}}\" aria-placeholder=\"{{\'u.p_group.ph1\' | translate}}\"></div></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveUserGrpFx(\'name\', \'sc\');\" ng-if=userGrp.info.isCompleted ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=fa ng-class=\"!saveCloseProcessing?\'fa-check\':\'fa-repeat fa-spin\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"saveUserGrpFx(\'name\');\" ng-disabled=\"saveCloseProcessing || saveProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=saveProcessing aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: {{\'u.btn.10\' | translate}} <span class=\"fa fa-chevron-right\" ng-if=!saveProcessing aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.users.ug ng-disabled=\"saveCloseProcessing || saveProcessing\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'u.p_group.m1\' | translate}}</div><div ng-if=\"errType==\'duplicate\'\" aria-live=polite role=status>{{\'u.p_group.m2\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/users/ugUsers.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><span class=\"stepComment pull-right\"><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span><a href=\"\" role=link class=marR10 ui-sref=hub.users.ug>{{\'u.tab.2\' | translate}}</a>/ <span class=\"marL10 marR10\">{{encId == \'\'?\'u.btn.2\':\'u.p_group.1\' | translate}}</span><span ng-if=userGrp.info.label class=text-muted>[ {{userGrp.info.label}} ]</span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.65\' | translate:\'{stepNo: 2}\'}}: {{\'u.btn.10\' | translate | capitalize}}</h1><span class=\"stepComment pull-right\" ng-if=!auth.upreferences.isPopup><span class=stepGreen><p class=\"fa fa-check-circle fa-lg\" aria-hidden=true></p></span><i></i><span class=stepBlue><p>2</p></span></span></header><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading class=pad10><div class=row ng-if=!detailLoading><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText.ug sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.ug.length ng-click=\"searchText.ug=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1,\'tabFx\');\">{{\'u.tab.1\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2,\'tabFx\');\">{{\'u.tab.2\' | translate}}</a></header><div ng-class=\"{\'noMarB\':auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" ng-attr-style=height:{{quadHeight}}px;><span ng-if=\"selectedT==\'1\'\"><div ng-if=\"!usersLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\" selectable=selection selectable-list=users.users selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"><li ng-repeat=\"user in filteredUserList = (users.users | customSearch:{key:searchText.ug, module:\'u\'})\" data-id={{user.id}} data-type=u uib-tooltip=\"{{\'u.body.7\' | translate}}\" tooltip-append-to-body=true tooltip-enable=\"selectedTab == \'hub.uContainer.ugUsers\' && user.uType != 4\" ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab == \'hub.uContainer.ugUsers\' && user.uType !== 4}\" context-menu=contextMenuOpt><div class=thumb-img><img alt=\"\" ng-if=user.thumb ng-src=\"{{tim + bucket + user.thumb + thumbParam + \'&\' + user.thumbV}}\"><div ng-if=\"!user.thumb && users.info.type != \'ug\'\" class=userThumb ng-class=\"{\'userPrime\':user.uType==2}\"><span ng-if=\"!user.label || user.label == \' \'\">{{user.email | limitTo:1}}</span> <span ng-if=\"user.label != \' \'\">{{user.label | limitTo:1}}</span></div></div><div class=thumb-label><span ng-if=user.self class=text-bold>{{\'u.body.8\' | translate}}:</span><span ng-if=\"!user.label || user.label == \'\'\" uib-tooltip={{user.email}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{user.email}}</span> <span ng-if=\"user.label != \'\'\" uib-tooltip={{user.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{user.label}}</span></div><!-- <div ng-if=\"user.self\" class=\"d-flex align-items-center marT5 w100px\">\r\n                      <div class=\"text-bold\">{{\'u.body.8\' | translate}}:</div>\r\n                      <div class=\"text-ellipsis w100px\" ng-if=\"!user.label || user.label == \'\'\" uib-tooltip=\"{{user.email}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\" class=\"text-ellipsis w100px marT5\">{{user.email}}</div>\r\n                      <div class=\"text-ellipsis w100px\" ng-if=\"user.label != \'\'\" uib-tooltip=\"{{user.label}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\">{{user.label}}</div>\r\n                    </div>\r\n                    <div ng-if=\"!user.self\" class=\"marT5 w100px\">\r\n                      <div class=\"text-ellipsis\" ng-if=\"!user.label || user.label == \'\'\" uib-tooltip=\"{{user.email}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\" class=\"text-ellipsis w100px marT5\">{{user.email}}</div>\r\n                      <div class=\"text-ellipsis\" ng-if=\"user.label != \'\'\" uib-tooltip=\"{{user.label}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\">{{user.label}}</div>\r\n                    </div> --></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.users.length == 0\">{{\'u.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"users.users.length > 0 && (users.users | customSearch:{key:searchText.ug, module:\'u\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.ug)}}&quot;</b>\'}\"></div></span><span ng-if=\"selectedT==\'2\'\"><div ng-if=\"!usersLoading && userGroup.groups.length > 0\"><ul class=\"list-inline thumb-list\" selectable=selection selectable-list=userGroup.groups selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"><li ng-repeat=\"ug in filteredUserList = (userGroup.groups | customSearch:{key:searchText.ug, module:\'u\'})\" data-id={{ug.id}} data-type=ug context-menu=contextMenuOpt ng-class=\"{\'nonSelectable unapprovedFile\':ug.isConflict}\" uib-tooltip=\"{{\'u.p_group.m3\' | translate}}\" tooltip-append-to-body=true tooltip-enable=\"selectedTab == \'hub.uContainer.ugUsers\' && ug.isConflict\"><div class=thumb-img><img alt=\"\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/default/user_group.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/user_group.png></div><!-- <div class=\"thumb-label\">{{ug.label}}</div> --><div class=thumb-label uib-tooltip={{ug.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{ug.label}}</div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && userGroup.groups.length == 0\">{{\'u.msg.15\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"userGroup.groups.length > 0 && (userGroup.groups | customSearch:{key:searchText.ug, module:\'u\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.ug)}}&quot;</b>\'}\"></div></span></div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'u.brief.10\' | translate}} <span ng-if=userGrp.users>[ {{userGrp.users.concat(userGrp.groups).length}} ]</span></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;><div ng-if=\"userGrp.users.concat(userGrp.groups).length > 0\"><div class=\"list-inline thumb-list hoverContainer\"><li ng-repeat=\"user in userGrp.users | customSearch:{key:selectedSearchText, module:\'u\'}\" data-id={{user.id}} uib-tooltip=\"{{\'u.body.6\' | translate}}\" tooltip-enable=!user.active><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"closeFilteredFx(user.id, \'u\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img ng-class=\"{\'unapprovedFile\':user.active === false}\"><span class=thumb-inner><a ng-if=user.thumb ng-href=\"{{detailBucket + user.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{user.label}}><img alt=\"\" ng-src=\"{{tim + bucket + user.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"></a><div ng-if=!user.thumb class=userThumb><span ng-if=\"!user.label || user.label == \' \'\">{{user.email | limitTo:1}}</span> <span ng-if=\"user.label != \' \'\">{{user.label | limitTo:1}}</span></div></span></div><div class=\"text-ellipsis w100px marT5\" ng-if=\"!user.label || user.label == \'\'\" uib-tooltip={{user.email}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{user.email}}</div><div class=\"text-ellipsis w100px marT5\" ng-if=\"user.label != \'\'\" uib-tooltip={{user.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{user.label}}</div></div></li><li ng-repeat=\"ug in userGrp.groups | customSearch:{key:selectedSearchText, module:\'u\'}\" data-id={{ug.id}}><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"closeFilteredFx(ug.id, \'ug\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner><img alt=\"\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/default/user_group.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/user_group.png></span></div></div><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{ug.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500>{{ug.label}}</div></li></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"userGrp.users.concat(userGrp.groups).length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"userGrp.users.concat(userGrp.groups).length > 0 && (userGrp.users.concat(userGrp.groups) | customSearch:{key:selectedSearchText, module:\'u\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div><div class=panel-footer ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ui-sref=\"hub.uContainer.ugName({id: encId})\" ng-disabled=saveCloseProcessing><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"saveUserGrpFx(\'users\', \'sc\');\" ng-disabled=saveCloseProcessing><span class=fa ng-class=\"saveCloseProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveCloseProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.users.ug ng-disabled=saveCloseProcessing>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/users/userCU.html","<div class=pageHeading ng-if=auth.upreferences.isPopup><a href=\"\" role=link class=marR10 ui-sref=hub.users.au>{{\'cm.label.5s\' | translate}}</a>/<span class=marL10>{{encId == \'\'?\'u.btn.1\':\'u.p_invite.1\' | translate}}<span class=\"marL5 text-muted\" ng-if=\"encId != \'\' && user.info.firstName != null\">[ {{user.info.firstName + \" \" + user.info.lastName}} ]</span><span class=\"marL5 text-muted\" ng-if=\"encId != \'\' && user.info.firstName == null\">[ {{user.info.email}} ]</span></span></div><section class=panel ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{encId == \'\'?\'u.btn.1\':\'u.p_invite.1\' | translate | capitalize}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=userLoading><div class=row ng-if=!userLoading><div class=col-xs-7><div class=form-group ng-class=\"{\'has-error\':hasErr && errType != \'role\'}\"><label for=email>{{\'cm.label.47\' | translate}}</label><input type=email id=email class=form-control ng-model=user.info.email ng-disabled=\"encId != \'\'\" maxlength=250 focus-me=true aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"></div><div class=row><div class=col-xs-6><div class=form-group ng-if=\"encId == \'\'\"><label for=lang>{{\'cm.label.34\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'u.p_invite.m1\' | translate:{brand:\'L&nbsp;Squared&nbsp;Hub\'} }}\" tooltip-placement=right tooltip-append-to-body=true aria-hidden=true></span></label><select id=lang class=form-control ng-model=user.info.lang aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=es_ES>Spanish / Spain</option></select></div></div></div></div></div><div class=row ng-show=user.info><div class=col-xs-7><div class=form-group ng-if=\"encId != \'\'\"><div class=row><div class=col-xs-6><label for=fName>{{\'ms.label.1\' | translate}}</label><input type=text id=fName class=form-control ng-model=user.info.firstName readonly aria-label=\"{{\'ms.label.1\' | translate}}\" aria-labelledby=\"{{\'ms.label.1\' | translate}}\"></div><div class=col-xs-6><label for=lName>{{\'ms.label.2\' | translate}}</label><input type=text id=lName class=form-control ng-model=user.info.lastName readonly aria-label=\"{{\'ms.label.2\' | translate}}\" aria-labelledby=\"{{\'ms.label.2\' | translate}}\"></div></div></div><div class=\"form-group noMarB\"><label>{{\'u.p_invite.2\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"marB15 marR10\" ng-if=user.info.assignAdmin><input type=radio role=radio name=roleOpt ng-model=user.info.roleOpt value=admin><label></label>{{\'u.p_invite.3\' | translate}}</label><label class=\"marB15 marR10\"><input type=radio role=radio name=roleOpt ng-model=user.info.roleOpt value=predefined><label></label>{{\'u.p_invite.4\' | translate}}</label><label class=\"marB15 marR10\" ng-if=user.info.isMbu><input type=radio role=radio name=roleOpt ng-model=user.info.roleOpt value=mbu><label></label>{{\'cm.dmb.1.1\' | translate}}</label><label class=marB15><input type=radio role=radio name=roleOpt ng-model=user.info.roleOpt value=custom><label></label>{{\'cm.label.17\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right marT8\" ng-click=resetRoleFx(); ng-if=\"user.info.roleOpt == \'predefined\'\">{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right marT8\" ng-click=resetCustomRoleFx(); ng-if=\"user.info.roleOpt == \'custom\' && user.roles.customRoles.length > 0\">{{\'cm.btn.34\' | translate}}</button></div></div><!-- Predefined Roles Start --><div class=\"bg-muted pad10 relative usercuRoleBg\" ng-if=\"user.info.roleOpt==\'predefined\'\"><div class=row><div class=col-xs-4 ng-class=\"{\'col-xs-12 marT5\': $last}\" ng-repeat=\"pr in user.roles.predefinedRoles | orderBy: sortorder\"><div class=text-bold ng-if=pr.key><span ng-class=\"{\'fa fa-folder-open\':pr.key == \'1\', \'fa fa-file-o\':pr.key == \'2\', \'fa fa-calendar\':pr.key == \'3\', \'fa fa-object-ungroup\':pr.key == \'4\', \'glyphicon glyphicon-hdd\':pr.key == \'5\', \'fa fa-user\':pr.key == \'6\', \'fa fa-table\':pr.key == \'66\'}\" aria-hidden=true></span> {{\'cm.menu.\'+ pr.key | translate}}</div><span ng-repeat=\"role in pr.role | orderBy: sortorder\" role=radiogroup aria-labelledby=radiogroup><label class=\"text-unbold marR10\" ng-class-even=\"\'marB25\'\" ng-if=pr.key><input type=radio role=radio name={{pr.key}} ng-model=pr.selected ng-value=role.id><label></label>{{\'u.body.\'+ role.key | translate}}</label><label class=marR10 ng-if=\"!pr.key && role.key != 23\"><input type=checkbox ng-model=role.selected role=checkbox><label></label><span class=fa ng-class=\"{\'fa-warning\':role.key == \'13\', \'fa-bar-chart\':role.key == \'17\', \'fa-paint-brush\':role.key == \'18\'}\" aria-hidden=true></span> {{\'roles.\'+ role.key | translate}}</label></span></div></div></div><!-- Custom Roles Start --><div ng-if=\"user.info.roleOpt==\'custom\'\"><div class=\"bg-muted pad10 usercuRoleBg\" ng-if=\"user.roles.customRoles.length > 0\"><div class=row ng-repeat=\"_ in user.roles.customRoles\" ng-if=\"$index % 3 == 0\"><div class=\"col-xs-4 text-ellipsis-wrap\" ng-repeat=\"cr in user.roles.customRoles.slice($index, ($index+3 > user.roles.customRoles.length ? user.roles.customRoles.length:$index+3))\"><label><input type=checkbox id=\"{{cr.label +\'-\'+ $index}}\" name={{cr.label}} ng-model=cr.selected role=checkbox><label></label>{{cr.label}}</label></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"user.roles.customRoles.length == 0\">{{\'u.p_invite.5\' | translate}} <a ui-sref=hub.uContainer.rr role=button class=bdrBd>{{\'u.p_invite.5.1\' | translate}}</a></div></div><div>&nbsp;</div><div ng-show=\"user.info.roleOpt != \'admin\' && user.info.roleOpt != \'mbu\'\"><div class=row><div class=col-xs-12><label>{{\'cm.btn.29\' | translate | capitalize}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div><ng-add-to-group></ng-add-to-group></div></div></div><div class=row><div class=col-xs-5><div ng-if=!isGroupAvailable><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"!isGroupEmpty && !isGroupAvailable\"><div class=\"text-muted text-sm marB20\" ng-if=isGroupEmpty>{{\'u.p_invite.6\' | translate}}</div></div><div ng-if=isGroupAvailable class=marT25><div class=form-group><label>{{\'cm.label.50\' | translate}}</label><div ng-if=\"curGroups.groups.length == 0\" class=\"text-muted text-sm\">N/A</div><div ng-if=\"curGroups.groups.length > 0\" role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=primaryGrp ng-model=curGroups.type value=p><label></label>{{\'cm.label.51\' | translate}}</label><label class=noMarB><input type=radio role=radio name=primaryGrp ng-model=curGroups.type value=c><label></label>{{\'cm.label.52\' | translate}}</label></div></div><div class=form-group ng-if=\"curGroups.type == \'c\' && curGroups.groups.length > 0\"><select class=form-control ng-model=curGroups.primaryGroup ng-options=\"option.label for option in curGroups.groups track by option.id\" aria-label=\"{{\'cm.label.50\' | translate}}\" aria-labelledby=\"{{\'cm.label.50\' | translate}}\"><option value=\"\" disabled>{{\'u.p_invite.8\' | translate}}</option></select></div></div></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=btn ng-class=\"encId == \'\'?\'btn-primary\':\'btn-success\'\" ng-click=saveUserFx(); ng-disabled=saveProcessing><span ng-if=\"encId == \'\'\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-share\'\" aria-hidden=true></span>{{saveProcessing?\'u.btn.5\':\'u.btn.4\' | translate}}</span> <span ng-if=\"encId != \'\'\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.users.au>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'adminRoleOnly\'\" aria-live=polite role=status>{{\'u.p_invite.m2\' | translate}}</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>{{\'u.msg.7\' | translate}}</div><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'u.msg.5\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'u.msg.6\' | translate}}</div><div ng-if=\"errType==\'role\'\" aria-live=polite role=status>{{\'u.msg.8\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/users/users.html","<div class=row><div class=\"col-xs-9 col-lg-10\"><button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedTab == \'hub.users.au\' && auth.upermissions.u\" ui-sref=hub.uContainer.userCU><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'u.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedTab == \'hub.users.ug\' && auth.upermissions.ug\" ui-sref=hub.uContainer.ugName><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'u.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedTab == \'hub.users.rr\' && auth.upermissions.ur\" ui-sref=hub.uContainer.rr><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'u.btn.3\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedTab == \'hub.users.mb\' && auth.upermissions.dmb\" ui-sref=hub.uContainer.userCU><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'u.btn.1\' | translate}}</button></div><div class=\"col-xs-3 col-lg-2 text-right\"><label for=searchBox class=lableHidden>{{\'as.btn.1\' | translate}}</label><div class=\"input-group1 searchTbx\"><input type=text class=form-control id=searchBox ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=\"input-group-btn hide\" uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-caret-down noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ui-sref=hub.advancedSearch>Advanced search</a></li></ul></span></div></div></div><div class=spaceH></div><div class=spaceH></div><section class=panel><header class=\"panel-heading panel-tab\"><ul class=\"nav nav-tabs u\" role=tablist aria-owns=\"tab-au tab-ug tab-mb tab-bu tab-rr\" aria-label=navList aria-labelledby=navList aria-orientation=horizontal><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.users.au\')}}\" aria-controls=tab-au id=tab-au class=tab-success><a ui-sref=.au role=link aria-label=\"{{\'u.tab.1\' | translate}}\">{{\'u.tab.1\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.users.ug\')}}\" aria-controls=tab-ug id=tab-ug class=tab-primary><a ui-sref=.ug role=link aria-label=\"{{\'u.tab.2\' | translate}}\">{{\'u.tab.2\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.users.mb\')}}\" aria-controls=tab-mb id=tab-mb class=tab-info ng-if=\"auth.upermissions.dmb && (auth.uType == 0 || auth.uType == 1 || auth.uType == 2 || auth.uType == 3)\"><a ui-sref=.mb role=link aria-label=\"{{\'cm.dmb.1.2\' | translate}}\">{{\'cm.dmb.1.2\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.users.bu\')}}\" aria-controls=tab-bu id=tab-bu class=tab-danger><a ui-sref=.bu role=link aria-label=\"{{\'u.tab.3\' | translate}}\">{{\'u.tab.3\' | translate}}</a></li><li ui-sref-active=active role=tab aria-selected=\"{{$state.includes(\'hub.users.rr\')}}\" aria-controls=tab-rr id=tab-rr class=tab-primary><a ui-sref=.rr role=link aria-label=\"{{\'u.tab.4\' | translate}}\">{{\'u.tab.4\' | translate}}</a></li><!-- <li ui-sref-active=\"active\" class=\"tab-disabled\">\r\n      <a ui-sref=\".uu\">Unapproved Users<span class=\"badge bg-info\" ng-if=\"unapprovedUsers.length > 0\">{{unapprovedUsers.length}}</span></a>\r\n    </li> --></ul><div class=panel-tools><div class=pull-right uib-dropdown ng-if=\"selectedTab != \'hub.users.rr\' && selectedTab != \'hub.users.mb\'\"><a href=\"\" role=button id=sorting aria-label=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-placement=left><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': users.info.sortType === \'label\' && users.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'asc\', users.users, users.info, \'usersort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': users.info.sortType === \'label\' && users.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'label\', \'desc\', users.users, users.info, \'usersort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li role=menuitem class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': users.info.sortType === \'createdon\' && users.info.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'asc\', users.users, users.info, \'usersort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': users.info.sortType === \'createdon\' && users.info.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'createdon\', \'desc\', users.users, users.info, \'usersort\');\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-if=\"selectedTab == \'hub.users.ug\' || selectedTab == \'hub.users.bu\'\"><a href=\"\" role=button id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem ng-if=\"selectedTab == \'hub.users.ug\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'ug\');\" translate=\"{{\'u.tool.1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li><li role=menuitem ng-if=\"selectedTab == \'hub.users.bu\'\" class=info><a href=\"\" role=link ng-click=\"readMeFx(\'bu\');\" translate=\"{{\'u.tool.2\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></a></li></ul></div><div class=pull-right><a href=\"\" role=button aria-label=refresh id=refresh ng-click=\"loadSelectedTab(\'refresh\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-disabled=loadingMain><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingMain}\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ui-view=tabView role=tabpanel></div></div></section><!--For Selected Item Brief--><div class=pinGap ng-if=\"auth.upreferences.isPin == 1 && selectedItems.length > 0\"></div><ng-user-brief ng-if=\"selectedItems.length > 0\"></ng-user-brief>");
$templateCache.put("app/users/uu.html","<img alt=Loading src=assets/images/loading.gif ng-if=usersLoading><div ng-if=\"!usersLoading && users.users.length > 0\"><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!usersLoading && users.users.length == 0\"><p>You don\'t have any unapproved user.</p><div class=marB5><a href=\"\" role=link ng-click=\"videoFx(\'u\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'u.tool.3\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span> Watch <span class=text-bold>User</span> video tutorial.</a></div><div><a href=\"\" role=link ng-click=\"videoFx(\'ur\');\"><span class=\"fa fa-video-camera\" aria-hidden=true></span> <span translate=\"{{\'u.tool.4\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC: \'</b>\'}\"></span> Watch <span class=text-bold>User Roles</span> video tutorial.</a></div></div>");
$templateCache.put("app/billing/popup/ccOpen.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cs.body.3\' | translate}}</h1></header><img alt=Loading src=assets/images/loading.gif ng-if=ccLoading class=pad15><form action={{ccOpenUrl}} method=post id=payment-form><div class=panel-body ng-show=!ccLoading><div class=\"form-group msg-warning\" lang={{auth.lang}}>{{\'b.msg.20\' | translate:{type:curSType} }}</div><div class=form-group><label>{{\'b.o.13\' | translate}}</label><div id=card-element><!-- A Stripe Element will be inserted here. --></div></div></div><footer class=panel-footer><span class=btnQuad><button type=submit role=button class=\"btn btn-success\" ng-disabled=saveProcessing><span class=\"fa fa-check\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{\'b.o.16\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right hide\" id=card-errors aria-live=polite role=status></div><div class=clearfix></div></footer></form></section>");
$templateCache.put("app/billing/popup/changeOwner.html","<section class=panel><header class=panel-heading><h1>{{\'b.sd.7\' | translate | camelCase}}</h1></header><div class=panel-body><div class=row><div class=col-xs-4><label>{{\'b.o.1\' | translate}}</label><div>{{curOwner.license}}</div></div><div class=col-xs-4><label>{{\'b.o.2\' | translate}}</label><div><span ng-if=\"curOwner.type == \'y\'\">{{\'b.o.2.1\' | translate}}</span> <span ng-if=\"curOwner.type == \'m\'\">{{\'b.o.2.2\' | translate}}</span> <span ng-if=\"curOwner.type == \'d\'\">Daily</span></div></div><div class=col-xs-4><label>{{\'b.o.9\' | translate}}</label><div>{{curOwner.mp}}</div></div><div class=col-xs-12><div class=\"panel-inner-tab marT15 marB10\">{{\'b.o.3\' | translate}}</div><div id=company_address><div class=form-group><label for=bAddress1>{{\'db.p_map.2\' | translate}}</label><input type=text class=\"form-control autocomplete\" id=bAddress1 ng-model=ownerObj.b.address1 placeholder=\"\" aria-label=bAddress1 aria-labelledby=bAddress1></div><div class=form-group><label for=bAddress2>{{\'db.p_map.2\' | translate}} 2 <span class=text-muted>({{\'cm.label.26\' | translate}})</span></label><textarea class=form-control id=bAddress2 ng-model=ownerObj.b.address2 aria-label=bAddress2 aria-labelledby=bAddress2></textarea></div><div class=\"row marB15\"><div class=col-md-6><label for=bCity>{{\'cm.label.45\' | translate}}</label><input type=text class=\"form-control locality\" id=bCity ng-model=ownerObj.b.city aria-label=bCity aria-labelledby=bCity></div><div class=col-md-6><label for=bProvince>{{\'db.p_map.6\' | translate}}</label><input type=text class=\"form-control administrative_area_level_1\" id=bProvince ng-model=ownerObj.b.province aria-label=bProvince aria-labelledby=bProvince></div></div><div class=\"row marB15\"><div class=col-md-6><label for=bPostalcode>{{\'db.p_map.7\' | translate}}</label><input type=text class=\"form-control postal_code\" id=bPostalcode ng-model=ownerObj.b.postalcode aria-label=bPostalcode aria-labelledby=bPostalcode></div><div class=col-md-6><label for=bCountry>{{\'db.p_map.8\' | translate}}</label><input type=text class=\"form-control country\" id=bCountry ng-model=ownerObj.b.country aria-label=bCountry aria-labelledby=bCountry> <input type=text class=\"hide country_code\" id=bCountrycode ng-model=ownerObj.b.countrycode aria-label=bCountrycode aria-labelledby=bCountrycode></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveOwnerFx(); ng-disabled=saveProcessing><span class=\"fa fa-check\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'invalidRenew\'\" aria-live=polite role=status>{{\'b.msg.14\' | translate}}</span> <span ng-if=\"errType==\'notFound\'\" aria-live=polite role=status>{{\'b.msg.13\' | translate}}</span> <span ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</span> <span ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/addToDashboard.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"ms.label.41\" | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !curUser.availableUser.length && !curUser.assignedUser.length\">{{\'cm.msg.44\' | translate}}</div><div class=scrollQuad ng-if=\"!popupLoading && curUser.availableUser.length || curUser.assignedUser.length\" ng-attr-style=max-height:{{getAvailableHeight(334)}}px><div class=row><div class=\"col-xs-12 marB10\">{{\'ms.msg.39\' | translate}}</div><div class=col-xs-12><div class=\"row bg-light padRL5 padTB10 noMar\"><div class=\"col-xs-12 marB10 bdrBtm\"><label>{{\"ms.label.42\" | translate}}</label></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li role=menuitem ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li role=menuitem ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem><a href=\"\" role=link ng-click=\"selAllUserFx(\'a\', curUser.availableUser | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li role=menuitem><a href=\"\" role=link ng-click=\"deSelAllUserFx(\'a\', curUser.availableUser);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label><span ng-if=\"curUserObj.type==\'a\'\">{{\"ms.p_dConf.1\" | translate}} <span class=\"text-sm text-muted\">[ {{curUser.availableUser.length}} ]</span></span></label>{{curATEM = (curUser.availableUser | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text id=avlTList class=form-control ng-model=avlTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curUser.availableUser.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-if=\"option.id != auth.uid\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curUser.availableUser | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selUserFx(\'a\', option, curUser.availableUser)\">{{option.label}}</div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curUser.availableUser.length}\" ng-click=\"listManipulateFx(\'add\', curUser.availableUser, curUser.assignedUser, curUsers.availableUser,\'\',\'\',\'u\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curUser.assignedUser.length}\" ng-click=\"listManipulateFx(\'remove\', curUser.availableUser, curUser.assignedUser, curUsers.assignedUser,\'\',\'\',\'u\'); asTList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllUserFx(\'s\', curUser.assignedUser | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllUserFx(\'s\', curUser.assignedUser);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label><span ng-if=\"curUserObj.type==\'a\'\">{{\"ms.p_dConf.2\" | translate}} <span class=\"text-sm text-muted\">[ {{curUser.assignedUser.length}} ]</span></span></label>{{curATEM = (curUser.assignedUser | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curUser.assignedUser.length id=asTList ng-model=asTList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curUser.assignedUser.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curUser.assignedUser | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selUserFx(\'s\', option, curUser.assignedUser)\">{{option.label}}</div></div></div></div></div></div></div></div><div class=col-xs-12><button type=button role=button class=\"btn btn-success btn-sm\" ng-if=\"curUser.availableUser.length || curUser.assignedUser.length\" ng-click=saveUserFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'fl.btn.5\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_tag.m1\' | translate}}</div><div ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'d.p_dg.m11\' | translate}}</div><div ng-if=\"errType==\'user\'\" aria-live=polite role=status>{{\'ms.p_dConf.m1\' | translate}}</div></div></div></div></div><div class=\"col-xs-12 text-center padTB10 text-bold\">{{\'cm.label.42\' | translate | uppercase}}</div><div class=col-xs-12><div class=\"row bg-light padRL5 padTB10 noMar\"><div class=col-xs-12><div class=marB5><label>{{\"ms.label.43\" | translate}}</label></div><button type=button role=button class=\"btn btn-default btn-sm\" ng-disabled=saveProcessing ng-click=makeDefaultFx();>{{\'ms.p_dConf.3\' | translate}}</button></div></div></div></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); resetU();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/addToSchedule.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.15\' | translate}}</h1></header><div class=panel-body><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px><div ng-if=scheduleList.length><label>{{\'cm.label.35\' | translate}}</label><div class=\"bg-light pad5\"><ul class=\"list-unstyled moveTree\"><label class=\"marL2 marB2\"><span class=\"fa fa-calendar\" aria-hidden=true></span></label><li class=\"branch text-ellipsis-wrap\" ng-repeat=\"gList in scheduleList | unique:\'group\'\" ng-if=gList.group><label>{{gList.group}}</label>{{curGrpSchedules = (scheduleList | filter:{group:gList.group}:true);\"\"}}<ul class=list-unstyled><li class=\"branch text-ellipsis-wrap\" ng-repeat=\"sList in curGrpSchedules\"><label uib-tooltip=\"{{\'cl.label.6\' | translate}}\" tooltip-enable=!sList.isActive ng-class=\"{\'text-disabled\':!sList.isActive}\"><input type=checkbox ng-model=sList.isChecked ng-change=checkedFx(sList.id); role=checkbox aria-label={{sList.label}} aria-labelledby={{sList.label}}><label></label>{{sList.label}}<span class=\"text-muted text-sm marL5\" ng-if=\"sList.sRange == \'f\' || sList.sRange == \'c\'\">( {{sList.sRange == \"f\"?\"cm.label.16\":\"cm.label.17\" | translate}} )</span><span class=\"text-muted text-sm marL5\" ng-if=\"sList.sRange !== \'f\' && sList.sRange !== \'c\'\">( {{sList.sRange.dr.startDate | dateFormat}} - {{sList.sRange.dr.endDate | dateFormat}} )</span><!-- <input ng-if=\"selectedTab!=\'hub.contentLibrary.c\'\" type=\"checkbox\" ng-model=\"isChecked[sList.id]\" ng-change=\"checkedFx(sList.id);\" role=\"checkbox\" aria-label=\"{{sList.label}}\" aria-labelledby=\"{{sList.label}}\"><label></label>{{sList.label}} --></label></li></ul></li><li class=\"branch text-ellipsis-wrap\" ng-repeat=\"sList in scheduleList\" ng-if=!sList.group><label uib-tooltip=\"{{\'cl.label.6\' | translate}}\" tooltip-enable=!sList.isActive ng-class=\"{\'text-disabled\':!sList.isActive}\"><input type=checkbox ng-model=sList.isChecked ng-change=checkedFx(sList.id); role=checkbox aria-label={{sList.label}} aria-labelledby={{sList.label}}><label></label>{{sList.label}}<span class=\"text-muted text-sm marL5\" ng-if=\"sList.sRange == \'f\' || sList.sRange == \'c\'\">( {{sList.sRange == \"f\"?\"cm.label.16\":\"cm.label.17\" | translate}} )</span><span class=\"text-muted text-sm marL5\" ng-if=\"sList.sRange !== \'f\' && sList.sRange !== \'c\'\">( {{sList.sRange.dr.startDate | dateFormat}} - {{sList.sRange.dr.endDate | dateFormat}} )</span><!-- <input ng-if=\"selectedTab!=\'hub.contentLibrary.c\'\" type=\"checkbox\" ng-model=\"isChecked[sList.id]\" ng-change=\"checkedFx(sList.id);\" role=\"checkbox\" aria-label=\"{{sList.label}}\" aria-labelledby=\"{{sList.label}}\"><label></label>{{sList.label}} --></label></li></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!scheduleList.length>{{\'cm.msg.18\' | translate}}</div><div class=marT10 ng-if=errorList.length><div class=errMsg aria-live=polite role=status>{{\'s.p_as.m1\' | translate}}</div><div class=table><div class=\"row th\"><div class=col-xs-5>{{\'s.p_as.1\' | translate}}</div><div class=col-xs-7>{{\'s.p_as.2\' | translate}}</div></div><div class=row ng-repeat=\"code in errorList\"><div class=col-xs-5>{{code.label}}</div><div class=col-xs-7><span ng-if=\"code.code == 10023\">{{\'s.p_s.msg.9\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{code.count}}</span> </span><span ng-if=\"code.code == 10024\">{{\'s.p_s.msg.8\' | translate}} <span class=text-success>{{\'s.p_s.msg.8.1\' | translate}}: {{code.duration}}</span> </span><span ng-if=\"code.code == 10025\">{{\'s.p_s.msg.10\' | translate}} <span class=text-success>{{\'s.p_s.msg.10.1\' | translate}}: <span class=\"glyphicon glyphicon-home text-sm\" aria-hidden=true></span> / {{code.folder}}</span> </span><span ng-if=\"code.code == 10026\">{{\'s.p_s.msg.7\' | translate}}:<ol class=padL20><li ng-repeat=\"conf in code.conflict\">{{conf}}</li></ol></span></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button ng-if=scheduleList.length ng-click=addToScheduleFx(); class=\"btn btn-success\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=btn ng-class=\"scheduleList.length?\'btn-link\':\'btn-default\'\" ng-click=closeThisDialog(); data-dismiss=modal>{{scheduleList.length?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'cl.msg.19\' | translate}}</div><div ng-if=\"errType==\'contentConfig\'\" aria-live=polite role=status>{{\'cl.msg.23\' | translate}}</div><div ng-if=\"errType==\'folderConfig\'\" aria-live=polite role=status>{{\'cl.msg.24\' | translate}}</div><div ng-if=\"errType==\'tFolderConfig\'\" aria-live=polite role=status>{{\'t.msg.25\' | translate}}</div><div ng-if=\"errType==\'imgConfig\'\" aria-live=polite role=status>{{\'cl.msg.33\' | translate}}</div><div ng-if=\"errType==\'widConfig\'\" aria-live=polite role=status>{{\'cl.msg.34\' | translate}}</div><div ng-if=\"errType==\'codError\'\" aria-live=polite role=status>{{\'s.p_s.msg.51\' | translate}}</div><div ng-if=\"errType==\'codWError\'\" aria-live=polite role=status>{{\'s.p_s.msg.52\' | translate}}</div><div ng-if=\"errType==\'cgError\'\" aria-live=polite role=status>{{\'s.p_s.msg.53\' | translate}}</div><div ng-if=\"errType==\'eslCError\'\" aria-live=polite role=status>{{\'s.p_s.msg.58.1\' | translate}}</div><div ng-if=\"errType==\'overrideError\'\" aria-live=polite role=status>{{\'s.p_s.msg.72\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/advancedSearch.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.10\' | translate}}</h1></header><div class=\"panel-body advSearchQuad\"><img alt=Loading src=assets/images/loading.gif ng-if=advSearchLoading><div class=row ng-if=!advSearchLoading><div ng-if=\"curAdvSearch.module == \'cl\'\"><div class=\"col-xs-3 form-group\"><label for=adType>{{\'cm.label.69\' | translate}}</label><!-- <select id=\"adType\" ng-if=\"curAdvSearch.opt != 2 && curAdvSearch.opt != 3 && curAdvSearch.opt != 4 && selectedTab!=\'hub.contentLibrary.c\'\" class=\"form-control\" ng-model=\"curAdvSearch.type\" ng-disabled=\"curAdvSearch.opt == 1 || default\" ng-options=\"option.label group by option.c for option in advSearch.types | orderBy:\'c==1\' track by option.id\" aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\">\r\n            <option value=\"\">{{\'as.label.10\' | translate}}</option>\r\n          </select> --><div class=form-group ng-if=\"curAdvSearch.opt != 2 && curAdvSearch.opt != 3 && curAdvSearch.opt != 4\"><div class=\"dropdown contentSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=ss.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=contentSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.6.1\' | translate}}\" ng-disabled=\"curAdvSearch.opt == 1 || default\">{{curAdvSearch.type.label}} <span ng-if=\"curAdvSearch.type == \'\'\">{{\'as.label.10\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=\"dropdown-header noMar padLR10\" ng-if=\"advSearch.types.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=\"form-control w100\" ng-model=searchWidget.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchWidget.name.length ng-click=\"searchWidget.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"advSearch.types.length > 5\"></li>{{contentCount = (advSearch.types | filter: { label: searchWidget.name, c: \"Content\"}).length; \"\"}} {{widgetCount = (advSearch.types | filter: { label: searchWidget.name, c: \"Widget\"}).length; \"\"}}<div class=\"listC-scroll ng-cloak\"><li ng-if=\"contentCount > 0 || widgetCount > 0\"><label class=\"selLabel padL12 padTB5\" ng-model=curAdvSearch.type ng-click=\"selTypeFx(\'\');\" ng-class=\"{\'selected\': curAdvSearch.type == \'\'}\"><label></label>{{\'as.label.10\' | translate}}</label></li><div class=\"text-bold padLR15\" ng-class=\"{\'padTB5\':contentCount > 0}\"><span ng-if=\"contentCount > 0\">{{\'cl.tab.1\' | translate}}</span></div><li ng-repeat=\"option in options = (advSearch.types | orderBy:\'c==1\' | filter: { label: searchWidget.name }) track by option.id\" tabindex=$index ng-if=\"option.c==\'Content\'\"><label class=\"padLR30 padTB5\" ng-model=curAdvSearch.type ng-click=selTypeFx(option); ng-class=\"{\'selected\': option.id == curAdvSearch.type.id}\" uib-tooltip={{option.label}} tooltip-append-to-body=true tooltip-popup-delay=500><div><span class=sb-cIcon><img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"option.type == \'Image\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"option.type == \'POWERPOINT\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"option.type == \'WORD\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"option.type == \'Vector\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"option.type == \'Flash\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"option.type == \'Audio\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"option.type == \'SharePointC\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"option.type == \'Video\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk.png ng-if=\"option.type == \'\' && myTheme.theme == \'df\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk-white.png ng-if=\"option.type == \'\' && myTheme.theme == \'dk\'\"> <span class=\"icon excelSheet\" ng-if=\"option.type == \'EXCEL\'\"></span> </span><span>{{option.label}}</span></div></label></li><div class=\"text-bold padLR15\" ng-class=\"{\'padTB5\':widgetCount > 0}\"><span ng-if=\"widgetCount > 0\">{{\'cl.tool.8\' | translate}}</span></div><li ng-repeat=\"option in options = (advSearch.types | orderBy:\'c==1\' | filter: { label: searchWidget.name }) track by option.id\" tabindex=$index ng-if=\"option.c==\'Widget\'\"><label class=\"padLR30 padTB5\" ng-model=curAdvSearch.type ng-click=selTypeFx(option); ng-class=\"{\'selected\': option.id == curAdvSearch.type.id}\" uib-tooltip={{option.label}} tooltip-append-to-body=true tooltip-popup-delay=500><div class=\"d-flex align-items-center\"><span class=sb-cIcon><span class=\"icon {{option.thumb}}\" ui-sref-active=active ng-if=\"option.type == \'Widget\' && option.thumb != \'\' && (option.thumb != \'youtube\' && option.thumb != \'vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"option.type == \'Widget\' && option.thumb == \'vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"option.type == \'Widget\' && option.thumb == \'youtube\'\"></span> <img alt={{option.type}} ng-src=assets/images/default/asterisk.png ng-if=\"option.type == \'Widget\' && option.thumb == \'\' && myTheme.theme == \'df\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk-white.png ng-if=\"option.type == \'Widget\' && option.thumb == \'\' && myTheme.theme == \'dk\'\"> </span><span>{{option.label}}</span></div></label></li><div class=msg-warning ng-if=\"options.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchWidget.name)}}&quot;</b>\'}\"></div></div></ul></div></div><select id=adType ng-if=\"curAdvSearch.opt == 2\" class=form-control ng-model=curAdvSearch.type ng-options=\"option.label for option in advSearch.types track by option.id\" aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.mc.13\' | translate}}</option></select><!-- <select id=\"adType\" ng-if=\"curAdvSearch.opt == 3\" class=\"form-control\" ng-model=\"curAdvSearch.type\" ng-options=\"option.label group by option.c for option in advSearch.types | orderBy:\'c==1\' track by option.id\" aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\">\r\n            <option value=\"\" disabled>{{\'cl.widget.mc.15\' | translate}}</option>\r\n          </select> --><div class=form-group ng-if=\"curAdvSearch.opt == 3\"><div class=\"dropdown contentSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=ss.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=contentSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.6.1\' | translate}}\" ng-disabled=\"curAdvSearch.opt == 1 || default\">{{curAdvSearch.type.label}} <span ng-if=\"curAdvSearch.type == \'\'\">{{\'cl.widget.mc.15\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=\"dropdown-header noMar padLR10\" ng-if=\"advSearch.types.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=\"form-control w100\" ng-model=searchWidget.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchWidget.name.length ng-click=\"searchWidget.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"advSearch.types.length > 5\"></li>{{contentCount = (advSearch.types | filter: { label: searchWidget.name, c: \"Content\"}).length; \"\"}} {{widgetCount = (advSearch.types | filter: { label: searchWidget.name, c: \"Widget\"}).length; \"\"}}<div class=\"listC-scroll ng-cloak\"><li ng-if=\"contentCount > 0 || widgetCount > 0\"><label class=\"selLabel padL12 padTB5\" ng-model=curAdvSearch.type ng-click=\"selTypeFx(\'\');\" ng-class=\"{\'selected\': curAdvSearch.type == \'\'}\"><label></label>{{\'cl.widget.mc.15\' | translate}}</label></li><div class=\"text-bold padLR15\" ng-class=\"{\'padTB5\':contentCount > 0}\"><span ng-if=\"contentCount > 0\">{{\'cl.tab.1\' | translate}}</span></div><li ng-repeat=\"option in options = (advSearch.types | orderBy:\'c==1\' | filter: { label: searchWidget.name }) track by option.id\" tabindex=$index ng-if=\"option.c== \'Content\'\"><label class=\"padLR30 padTB5\" ng-model=curAdvSearch.type ng-click=selTypeFx(option); ng-class=\"{\'selected\': option.id == curAdvSearch.type.id}\" uib-tooltip={{option.label}} tooltip-append-to-body=true tooltip-popup-delay=500><div><span class=sb-cIcon><img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"option.type == \'Image\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"option.type == \'POWERPOINT\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"option.type == \'WORD\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"option.type == \'Vector\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"option.type == \'Flash\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"option.type == \'Audio\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"option.type == \'SharePointC\'\"> <img alt={{option.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"option.type == \'Video\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk.png ng-if=\"option.type == \'\' && myTheme.theme == \'df\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk-white.png ng-if=\"option.type == \'\' && myTheme.theme == \'dk\'\"> <span class=\"icon excelSheet\" ng-if=\"option.type == \'EXCEL\'\"></span> </span><span>{{option.label}}</span></div></label></li><div class=\"text-bold padLR15\" ng-class=\"{\'padTB5\':widgetCount > 0}\"><span ng-if=\"widgetCount > 0\">{{\'cl.tool.8\' | translate}}</span></div><li ng-repeat=\"option in options = (advSearch.types | orderBy:\'c==1\' | filter: { label: searchWidget.name }) track by option.id\" tabindex=$index ng-if=\"option.c== \'Widget\'\"><label class=\"padLR30 padTB5\" ng-model=curAdvSearch.type ng-click=selTypeFx(option); ng-class=\"{\'selected\': option.id == curAdvSearch.type.id}\" uib-tooltip={{option.label}} tooltip-append-to-body=true tooltip-popup-delay=500><div class=\"d-flex align-items-center\"><span class=sb-cIcon><span class=\"icon {{option.thumb}}\" ng-if=\"option.type == \'Widget\' && option.thumb != \'\' && (option.thumb != \'youtube\' && option.thumb != \'vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"option.type == \'Widget\' && option.thumb == \'vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"option.type == \'Widget\' && option.thumb == \'youtube\'\"></span> <img alt={{option.type}} ng-src=assets/images/default/asterisk.png ng-if=\"option.type == \'Widget\' && option.thumb == \'\' && myTheme.theme == \'df\'\"> <img alt={{option.type}} ng-src=assets/images/default/asterisk-white.png ng-if=\"option.type == \'Widget\' && option.thumb == \'\' && myTheme.theme == \'dk\'\"> </span><span>{{option.label}}</span></div></label></li><div class=msg-warning ng-if=\"options.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchWidget.name)}}&quot;</b>\'}\"></div></div></ul></div></div><select id=adType ng-if=\"curAdvSearch.opt == 4\" class=form-control ng-model=curAdvSearch.type ng-options=\"option.label for option in advSearch.types track by option.id\" aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.mc.13\' | translate}}</option></select></div><div class=\"col-xs-3 form-group\"><!-- TODO change the name label to keyword --><label for=adName>{{\'cl.vi.13\' | translate}}</label><!-- <label for=\"adName\">{{\'cm.brief.1\' | translate}}</label> --> <input type=text id=adName class=form-control ng-disabled=\"curAdvSearch.opt == 3 && !curAdvSearch.type\" ng-model=curAdvSearch.name focus-me=true aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"col-xs-3 form-group\"><label for=adCreationDateRange>{{\'as.label.1\' | translate}}</label><div class=input-group ng-click=\"(curAdvSearch.opt == 3 && !curAdvSearch.type) ? \'\' : dateRangeFx(\'c\')\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text id=adCreationDateRange ng-disabled=\"curAdvSearch.opt == 3 && !curAdvSearch.type\" class=form-control ng-hide=curAdvSearch.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange ng-disabled=\"curAdvSearch.opt == 3 && !curAdvSearch.type\" class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY opens=center readonly></div></div><div class=\"col-xs-3 form-group\"><label for=adCreatedBy>{{\'cm.brief.3\' | translate}}</label><select id=adCreatedBy class=form-control ng-disabled=\"curAdvSearch.opt == 3 && !curAdvSearch.type\" ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\" aria-label=\"{{\'cm.brief.3\' | translate}}\" aria-labelledby=\"{{\'cm.brief.3\' | translate}}\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><div ng-if=\"curAdvSearch.module == \'sm\'\"><div class=\"col-xs-3 form-group\"><label for=adName>{{\'cm.brief.1\' | translate}}</label><input type=text id=adName class=form-control ng-model=curAdvSearch.name focus-me=true aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"col-xs-3 form-group\"><label for=adCreationDateRange>{{\'as.label.1\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text id=adCreationDateRange class=form-control ng-hide=curAdvSearch.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY readonly></div></div><div class=\"col-xs-3 form-group\"><label for=adScheduleDateRange>{{\'as.label.2\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'sm\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control id=adScheduleDateRange ng-hide=curAdvSearch.scheduleRange aria-label=\"{{\'as.label.2\' | translate}}\" aria-labelledby=\"{{\'as.label.2\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.scheduleDateRange ng-show=curAdvSearch.scheduleRange opens=center format=MM/DD/YYYY readonly></div></div><div class=\"col-xs-3 form-group\"><label for=adCreatedBy>{{\'cm.brief.3\' | translate}}</label><select class=form-control id=adCreatedBy ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\" aria-label=\"{{\'cm.brief.3\' | translate}}\" aria-labelledby=\"{{\'cm.brief.3\' | translate}}\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><div ng-if=\"curAdvSearch.module == \'t\'\"><div class=\"col-xs-3 form-group\"><label for=adType>{{\'cm.label.69\' | translate}}</label><select id=adType class=form-control ng-model=curAdvSearch.type aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=\"\">{{\'as.label.10\' | translate}}</option><!-- normal --><option ng-value=0>{{\'cl.tool.2\' | translate}}</option><!-- epd --><option ng-if=auth.upermissions.epd ng-value=1>{{\'d.label.1.8\' | translate}}</option><!-- Tile layout --><!-- <option ng-if=\"auth.upermissions.f45Workout\" ng-value=\"3\">{{\'fl.p_cfl.label.25\' | translate}}</option> --><!-- Excel template --><option ng-if=\"auth.upermissions.texl_od || auth.upermissions.texl_cl\" ng-value=3>{{\'t.label.22\' | translate}}</option><!-- ODBC --><!-- <option ng-value=\"5\">{{\'fl.p_cfl.label.27\' | translate}}</option> --><!-- animated text --><option class=hide ng-if=\"auth.upermissions.dmb && auth.upermissions.dmb_t\" ng-value=2>{{\'fl.p_cfl.label.24\' | translate}}</option><!-- dynamic text --><option ng-if=\"auth.upermissions.dmb && auth.upermissions.dmb_t\" ng-value=4>{{\'fl.p_cfl.label.26\' | translate}}</option><!-- OLO template --><option ng-if=auth.upermissions.tolo ng-value=6>{{\'t.label.30\' | translate}}</option></select></div><div class=\"col-xs-3 form-group\"><label for=adName>{{\'cm.brief.1\' | translate}}</label><input type=text id=adName class=form-control ng-model=curAdvSearch.name focus-me=true aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"col-xs-3 form-group\"><label for=adCreationDateRange>{{\'as.label.1\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\')\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control id=adCreationDateRange ng-hide=curAdvSearch.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY opens=center readonly aria-label=adCreationDateRange aria-labelledby=adCreationDateRange></div></div><div class=\"col-xs-3 form-group\"><label for=adCreatedBy>{{\'cm.brief.3\' | translate}}</label><select id=adCreatedBy class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\" aria-label=\"{{\'cm.brief.3\' | translate}}\" aria-labelledby=\"{{\'cm.brief.3\' | translate}}\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><div ng-if=\"curAdvSearch.module == \'inv\'\"><span ng-if=\"curAdvSearch.step == \'d\'\"><div class=col-xs-12><div class=form-group><label>{{\'cm.brief.1\' | translate}}</label><input type=text class=form-control ng-model=curAdvSearch.dName focus-me=true></div></div><div class=col-xs-6><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><select class=form-control ng-model=curAdvSearch.dType><option value=\"\">{{\'as.label.10\' | translate}}</option><option value=mp>{{\'d.label.1.1\' | translate}}</option><option value=webos ng-if=auth.upermissions.webos>{{\'d.label.1.5\' | translate}}</option><option value=tiz ng-if=auth.upermissions.tizen>{{\'d.label.1.6\' | translate}}</option><option value=mc ng-if=auth.upermissions.mc>{{\'d.label.1.4\' | translate}}</option><option value=gf ng-if=auth.upermissions.gf>{{\'d.label.1.2\' | translate}}</option><option value=v ng-if=auth.upermissions.vd>{{\'d.label.1.3\' | translate}}</option><option value=epd ng-if=auth.upermissions.epd>{{\'d.label.1.8\' | translate}}</option></select></div></div><div class=col-xs-6><div class=form-group><label>{{\'d.label.2\' | translate}}</label><input class=form-control ng-model=curAdvSearch.searchId></div></div><div class=col-xs-6><div class=form-group><label>{{\'cm.brief.3\' | translate}}</label><select class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearchObj.userList | orderBy:\'label\' track by option.id\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><div class=col-xs-6><div class=form-group><label>{{\'in.p_i.21\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\');\"><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=text class=form-control ng-hide=curAdvSearch.creationRange> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY readonly></div></div></div></span><div ng-if=\"curAdvSearch.step == \'h\'\"><div class=col-xs-3><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><select class=form-control ng-model=curAdvSearch.oType ng-options=\"option.label for option in advSearchObj.type | orderBy:\'label\' track by option.id\"><option value=\"\">{{\'as.label.10\' | translate}}</option></select></div></div><div class=col-xs-3><div class=form-group><label>{{\'in.p_i.5\' | translate}}</label><input class=form-control ng-model=curAdvSearch.serial focus-me=true></div></div><div class=col-xs-3><div class=form-group><label>{{\'in.p_i.21\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\');\"><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=text class=form-control ng-hide=curAdvSearch.creationRange> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY readonly></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cm.brief.3\' | translate}}</label><select class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearchObj.userList | orderBy:\'label\' track by option.id\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div></div></div><div ng-if=\"curAdvSearch.module != \'cl\' && curAdvSearch.module != \'dt\' && curAdvSearch.module != \'dg\' && curAdvSearch.module != \'s\' && curAdvSearch.module != \'fla\' && curAdvSearch.module != \'r\' && curAdvSearch.module != \'sm\' && curAdvSearch.module != \'t\' && curAdvSearch.module != \'inv\' && curAdvSearch.module != \'an\' && curAdvSearch.module != \'d\'\"><div class=\"col-xs-6 bdrRd\" ng-if=\"curAdvSearch.module != \'s\'\"><div class=row><div class=col-xs-12><div class=form-group><label for=adDName>{{\'d.label.46\' | translate}}</label><span class=\"text-sm text-muted marL7\">{{\'d.label.59\' | translate}}</span> <input type=text id=adDName class=form-control ng-model=curAdvSearch.dName aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=adCreatedBy>{{\'cm.brief.3\' | translate}}</label><select id=adCreatedBy class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\" aria-label=\"{{\'cm.brief.3\' | translate}}\" aria-labelledby=\"{{\'cm.brief.3\' | translate}}\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><div class=col-xs-6><div class=form-group><label for=adCreationDateRange>{{\'as.label.1\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control id=adCreationDateRange ng-hide=curAdvSearch.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange class=\"form-control picker\" id=adCreationDateRange ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY readonly></div></div></div><div class=col-xs-6><div class=form-group><label for=adSName>{{\'as.label.4\' | translate}}</label><input type=text id=adSName class=form-control ng-model=curAdvSearch.sName aria-label=\"{{\'as.label.4\' | translate}}\" aria-labelledby=\"{{\'as.label.4\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label>{{\'as.label.2\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'s\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control ng-hide=curAdvSearch.scheduleRange aria-label=\"{{\'as.label.2\' | translate}}\" aria-labelledby=\"{{\'as.label.2\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.scheduleDateRange ng-show=curAdvSearch.scheduleRange opens=center format=MM/DD/YYYY readonly></div></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><label for=adOS>{{\'cm.label.70\' | translate}}</label><select id=adOS class=form-control ng-model=curAdvSearch.os aria-label=\"{{\'cm.label.70\' | translate}}\" aria-labelledby=\"{{\'cm.label.70\' | translate}}\"><option value=\"\">{{\'as.label.13\' | translate}}</option><option ng-value=0 class=hide>No OS</option><option ng-value=1>Windows</option><option ng-value=2>LG WebOS</option><option ng-value=3>Samsung Tizen</option><option ng-value=4>Chrome OS</option><option ng-value=5>Linux</option><option ng-value=6>MacOS</option><option ng-value=7>Android</option><option ng-value=9>Raspberry Pi</option></select></div></div><div class=\"col-xs-6 hide\"><div class=\"form-group noMarB\" ng-if=\"curAdvSearch.os == 1\"><label for=adClient>{{\'d.brief.9\' | translate}}</label><select id=adClient class=form-control ng-model=curAdvSearch.client aria-label=\"{{\'d.brief.9\' | translate}}\" aria-labelledby=\"{{\'d.brief.9\' | translate}}\"><option value=\"\">{{\'as.label.14\' | translate}}</option><option value=0>FSS</option><option value=1>Electron</option></select></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><label for=adStatus>{{\'d.brief.10\' | translate}}</label><select id=adStatus class=form-control ng-model=curAdvSearch.fil aria-label=\"{{\'d.brief.10\' | translate}}\" aria-labelledby=\"{{\'d.brief.10\' | translate}}\"><!-- <option value=\"\">{{\'as.label.14\' | translate}}</option> --><option value=online>{{\'d.tool.1\' | translate}}</option><option value=offline>{{\'d.tool.2\' | translate}}</option><option value=all>{{\'cm.tool.2.1\' | translate}}</option></select></div></div></div></div><div class=col-xs-6 ng-class=\"{\'col-xs-12 noBdr\':curAdvSearch.module == \'s\'}\"><div class=row><div class=col-xs-4><div class=form-group ng-if=\"$state.current.name == \'hub.sContainer.sDevice\'\"><label for=adDName>{{\'cm.brief.1\' | translate}}</label><input type=text id=adDName class=form-control ng-model=curAdvSearch.dName aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div></div><!-- Tags --><div class=\"row word-break\"><div class=col-xs-4><label for=\"\">{{\'d.tab.3\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.availableTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-2></div><div class=col-xs-3><label for=\"\">{{\'as.label.6\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.includeTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-3><label for=\"\">{{\'as.label.7\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.excludeTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div></div><div class=row><div class=col-xs-4><select id=availableTag class=form-control ng-style=\"{\'height\':(advSearch.propList.length ? \'305px\' : \'233px\')}\" ng-model=curAdvSearchModel.availableTag ng-options=\"option.label for option in advSearch.tagList | orderBy:\'label\' track by option.id\" multiple aria-label=\"available tag\" aria-labelledby=\"available tag\"></select></div><div class=\"col-xs-2 actionQuad noPadL noPadR\" ng-style=\"{\'margin-top\':(advSearch.propList.length ? \'103px\' : \'75px\')}\"><button type=button role=button ng-click=\"listManipulateFx(\'add\', advSearch.tagList, curAdvSearch.tag.include, curAdvSearchModel.availableTag);\" class=\"btn btn-success btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableTag.length}\">{{\'as.label.6\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'add\', advSearch.tagList, curAdvSearch.tag.exclude, curAdvSearchModel.availableTag);\" class=\"btn btn-danger btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableTag.length}\">{{\'as.label.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'remove\', advSearch.tagList, curAdvSearch.tag.include, curAdvSearchModel.includeTag, curAdvSearch.tag.exclude, curAdvSearchModel.excludeTag);\" class=\"btn btn-default btn-xs btn-block\" ng-class=\"{\'disabled\': !(curAdvSearchModel.includeTag + curAdvSearchModel.excludeTag).length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-3><select id=includeTag class=form-control ng-style=\"{\'height\':(advSearch.propList.length ? \'305px\' : \'233px\')}\" ng-model=curAdvSearchModel.includeTag ng-options=\"option.label for option in curAdvSearch.tag.include | orderBy:\'label\' track by option.id\" multiple aria-label=\"include tag\" aria-labelledby=\"include tag\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curAdvSearch.tag.iType value=or ng-disabled=\"curAdvSearch.tag.include.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curAdvSearch.tag.iType value=and ng-disabled=\"curAdvSearch.tag.include.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div><div class=col-xs-3><select id=excludeTag class=form-control ng-style=\"{\'height\':(advSearch.propList.length ? \'305px\' : \'233px\')}\" ng-model=curAdvSearchModel.excludeTag ng-options=\"option.label for option in curAdvSearch.tag.exclude | orderBy:\'label\' track by option.id\" multiple aria-label=\"exclude tag\" aria-labelledby=\"exclude tag\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curAdvSearch.tag.eType value=or ng-disabled=\"curAdvSearch.tag.exclude.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curAdvSearch.tag.eType value=and ng-disabled=\"curAdvSearch.tag.exclude.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div></div><!-- Available Groups --><div class=\"row word-break marT15\" ng-if=\"curState == \'hub.devices.d\'\"><div class=col-xs-4><label for=\"\">{{\'u.tab.2\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.availableGroup = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-2></div><div class=col-xs-3><label for=\"\">{{\'as.label.6\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.includeGroup = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-3><label for=\"\">{{\'as.label.7\' | translate}}</label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curAdvSearchModel.excludeGroup = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div></div><div class=row ng-if=\"curState == \'hub.devices.d\'\"><div class=col-xs-4><select id=availableGroup class=form-control style=height:233px ng-model=curAdvSearchModel.availableGroup ng-options=\"option.label for option in advSearch.userGroupList | orderBy:\'label\' track by option.id\" multiple aria-label=\"available group\" aria-labelledby=\"available group\"></select></div><div class=\"col-xs-2 actionQuad noPadL noPadR\" style=margin-top:75px><button type=button role=button ng-click=\"listManipulateFx(\'add\', advSearch.userGroupList, curAdvSearch.userGroup.include, curAdvSearchModel.availableGroup);\" class=\"btn btn-success btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableGroup.length}\">{{\'as.label.6\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'add\', advSearch.userGroupList, curAdvSearch.userGroup.exclude, curAdvSearchModel.availableGroup);\" class=\"btn btn-danger btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableGroup.length}\">{{\'as.label.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'remove\', advSearch.userGroupList, curAdvSearch.userGroup.include, curAdvSearchModel.includeGroup, curAdvSearch.userGroup.exclude, curAdvSearchModel.excludeGroup);\" class=\"btn btn-default btn-xs btn-block\" ng-class=\"{\'disabled\': !(curAdvSearchModel.includeGroup + curAdvSearchModel.excludeGroup).length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-3><select id=includeGroup class=form-control style=height:233px ng-model=curAdvSearchModel.includeGroup ng-options=\"option.label for option in curAdvSearch.userGroup.include | orderBy:\'label\' track by option.id\" multiple aria-label=\"include group\" aria-labelledby=\"include group\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.userGroup.include.length <= 1}\"><input type=radio role=radio name=ugiOpt ng-model=curAdvSearch.userGroup.iType value=or ng-disabled=\"curAdvSearch.userGroup.include.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.userGroup.include.length <= 1}\"><input type=radio role=radio name=ugiOpt ng-model=curAdvSearch.userGroup.iType value=and ng-disabled=\"curAdvSearch.userGroup.include.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div><div class=col-xs-3><select id=excludeGroup class=form-control style=height:233px ng-model=curAdvSearchModel.excludeGroup ng-options=\"option.label for option in curAdvSearch.userGroup.exclude | orderBy:\'label\' track by option.id\" multiple aria-label=\"exclude group\" aria-labelledby=\"exclude group\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.userGroup.exclude.length <= 1}\"><input type=radio role=radio name=ugeOpt ng-model=curAdvSearch.userGroup.eType value=or ng-disabled=\"curAdvSearch.userGroup.exclude.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.userGroup.exclude.length <= 1}\"><input type=radio role=radio name=ugeOpt ng-model=curAdvSearch.userGroup.eType value=and ng-disabled=\"curAdvSearch.userGroup.exclude.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div></div></div></div><div ng-if=\"curAdvSearch.module == \'an\'\"><div class=\"col-xs-4 form-group\"><label>{{\'an.label.1\' | translate}}</label><select class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div><div class=\"col-xs-4 form-group\"><label>{{\'an.label.2\' | translate}}</label><select class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div><div class=\"col-xs-4 form-group\"><label>{{\'cm.label.9\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\')\"><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=text class=form-control ng-hide=curAdvSearch.creationRange> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY opens=center readonly></div></div></div><div ng-if=\"curAdvSearch.module == \'d\' || curAdvSearch.module == \'dt\' || curAdvSearch.module == \'dg\' || curAdvSearch.module == \'s\' || curAdvSearch.module == \'fla\' || curAdvSearch.module == \'r\'\"><div class=col-xs-12><div class=row><div class=col-xs-12><div class=form-group><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=nfKey ng-model=nameOrFile.nfKey value=n ng-change=\"nfKey(\'n\')\"><label></label>{{\'d.label.46\' | translate}}</label><span class=\"text-sm text-muted marL7\">{{\'d.label.59\' | translate}}</span><label class=\"pull-right marR105\"><input type=radio role=radio name=nfKey ng-model=nameOrFile.nfKey value=f ng-change=\"nfKey(\'f\')\"><label></label>{{\'d.p_dg.4\' | translate}}</label><span class=\"pull-right text-sm text-muted marR33\" ng-if=!importXls.file>[ {{!curAdvSearch.dName.length?0:curAdvSearch.dName.length}}/1000 ]</span></div><!-- <label for=\"adDName\">{{\'d.label.46\' | translate}}</label> --><!-- <span class=\"text-sm text-muted marL7\">{{\'d.label.59\' | translate}}</span> --><!-- <span class=\"pull-right text-sm text-muted marR207\" ng-if=\"!importXls.file\">[ {{!curAdvSearch.dName.length?0:curAdvSearch.dName.length}}/1000 ]</span> --><div class=row><div class=\"col-xs-10 noPadR d-flex\" ng-if=!importXls.file><input type=text class=form-control id=adDName ng-model=curAdvSearch.dName focus-me=true aria-label=\"{{\'d.label.46\' | translate}}\" aria-labelledby=\"{{\'d.label.46\' | translate}}\" maxlength=1000 ng-disabled=\"nameOrFile.nfKey == \'f\'\"><div class=\"padLR10 d-flex align-items-center\">{{\'d.label.60\' | translate}}</div></div><div class=\"col-xs-10 noPadR d-flex\" ng-if=importXls.file><input type=text class=form-control id=adDName readonly ng-model=importXls.file focus-me=true aria-label=\"{{\'d.label.46\' | translate}}\" aria-labelledby=\"{{\'d.label.46\' | translate}}\"><div class=\"padLR10 d-flex align-items-center\">{{\'d.label.60\' | translate}}</div></div><div class=\"col-xs-2 noPadL\"><button type=button role=button class=\"btn btn-primary btn-file w100\" ng-disabled=\"fileModelLoading || nameOrFile.nfKey == \'n\'\">{{\'cl.btn.5\' | translate}} <input type=file id=excelFile file-model options=\"{format:[\'excel\'], callback:true}\" fmtype=d-advSearch accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=\"fileModelLoading || nameOrFile.nfKey == \'n\'\"></button></div></div></div></div><!-- Property and value start--><div class=col-xs-6 ng-if=\"advSearch.propList && advSearch.propList.length && auth.upermissions.da.dp\"><div class=\"form-group lsn-select\"><label ng-cloak>{{\'ms.p_s.notifyS.2.17.2\' | translate}}</label><div class=dropdown uib-dropdown auto-close=outsideClick is-open=ss.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle><span ng-if=!selectedProp>{{\'d.label.44\' | translate}}</span> <span ng-if=selectedProp class=pull-left>{{selectedProp.label}}</span> <span class=\"caret pull-right marT8\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem class=\"dropdown-header padLR10\" ng-show=\"advSearch.propList.length > 5\"><label for=ssSearch class=lableHidden>dtpl</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=ssSearch ng-model=searchPList.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=searchPList.text class=text-danger ng-show=searchPList.text.length ng-click=\"searchPList.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-show=\"advSearch.propList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li role=menuitem ng-repeat=\"pList in filteredPropList = (advSearch.propList | filter:searchPList.text) | orderBy: \'label\'\" tabindex={{$index}} ng-class=\"{\'selected disabled\': pList.id == selectedProp.id}\"><a href=\"\" role=link id=ss{{$index}} ng-click=\"selectPropFx(pList, $event);\" ng-if=\"pList.id != selectedProp\">{{pList.label}}</a> <span ng-if=\"pList.id == selectedProp\">{{pList.label}}</span></li><div class=msg-warning ng-if=\"filteredPropList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPList.text)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=col-xs-6 ng-if=\"advSearch.propList && advSearch.propList.length && auth.upermissions.da.dp\"><div class=form-group><label for=propValue>{{\'d.label.11\' | translate}}</label><input type=text id=propValue class=form-control ng-disabled=!curAdvSearch.prop ng-model=curAdvSearch.prop.value aria-label=\"{{\'as.label.4\' | translate}}\" aria-labelledby=\"{{\'as.label.4\' | translate}}\"></div></div><!-- Property and value end--><!-- created By --><div class=col-xs-6><div class=form-group><label for=adCreatedBy>{{\'cm.brief.3\' | translate}}</label><select id=adCreatedBy class=form-control ng-model=curAdvSearch.createdBy ng-options=\"option.label for option in advSearch.userList | orderBy:\'label\' track by option.id\" aria-label=\"{{\'cm.brief.3\' | translate}}\" aria-labelledby=\"{{\'cm.brief.3\' | translate}}\"><option value=\"\">{{\'as.label.3\' | translate}}</option></select></div></div><!-- creation Range --><div class=col-xs-6><div class=form-group><label for=adCreationDateRange>{{\'as.label.1\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'c\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control id=adCreationDateRange ng-hide=curAdvSearch.creationRange aria-label=\"{{\'as.label.1\' | translate}}\" aria-labelledby=\"{{\'as.label.1\' | translate}}\"> <input type=daterange class=\"form-control picker\" id=adCreationDateRange ng-model=curAdvSearch.creationDateRange ng-show=curAdvSearch.creationRange format=MM/DD/YYYY readonly></div></div></div><!-- schedule name --><div class=col-xs-6><div class=form-group><label for=adSName>{{\'as.label.4\' | translate}}</label><input type=text id=adSName class=form-control ng-model=curAdvSearch.sName aria-label=\"{{\'as.label.4\' | translate}}\" aria-labelledby=\"{{\'as.label.4\' | translate}}\"></div></div><!-- schedule Range --><div class=col-xs-6><div class=form-group><label>{{\'as.label.2\' | translate}}</label><div class=input-group ng-click=\"dateRangeFx(\'s\');\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control ng-hide=curAdvSearch.scheduleRange aria-label=\"{{\'as.label.2\' | translate}}\" aria-labelledby=\"{{\'as.label.2\' | translate}}\"> <input type=daterange class=\"form-control picker\" ng-model=curAdvSearch.scheduleDateRange ng-show=curAdvSearch.scheduleRange opens=center format=MM/DD/YYYY readonly></div></div></div><!-- OS --><div class=col-xs-6><div class=\"form-group noMarB\"><label for=adOS>{{\'cm.label.70\' | translate}}</label><select id=adOS class=form-control ng-model=curAdvSearch.os aria-label=\"{{\'cm.label.70\' | translate}}\" aria-labelledby=\"{{\'cm.label.70\' | translate}}\"><option value=\"\">{{\'as.label.13\' | translate}}</option><option ng-value=0 class=hide>No OS</option><option ng-value=1>Windows</option><option ng-value=2>LG WebOS</option><option ng-value=3>Samsung Tizen</option><option ng-value=4>Chrome OS</option><option ng-value=5>Linux</option><option ng-value=6>MacOS</option><option ng-value=7>Android</option><option ng-value=9>Raspberry Pi</option></select></div></div><div class=\"col-xs-6 hide\"><div class=\"form-group noMarB\" ng-if=\"curAdvSearch.os == 1\"><label for=adClient>{{\'d.brief.9\' | translate}}</label><select id=adClient class=form-control ng-model=curAdvSearch.client aria-label=\"{{\'d.brief.9\' | translate}}\" aria-labelledby=\"{{\'d.brief.9\' | translate}}\"><option value=\"\">{{\'as.label.14\' | translate}}</option><option value=0>FSS</option><option value=1>Electron</option></select></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><label for=adStatus>{{\'d.brief.10\' | translate}}</label><select id=adStatus class=form-control ng-model=curAdvSearch.fil aria-label=\"{{\'d.brief.10\' | translate}}\" aria-labelledby=\"{{\'d.brief.10\' | translate}}\"><!-- <option value=\"\">{{\'as.label.14\' | translate}}</option> --><option value=online>{{\'d.tool.1\' | translate}}</option><option value=offline>{{\'d.tool.2\' | translate}}</option><option value=all>{{\'cm.tool.2.1\' | translate}}</option></select></div></div></div></div><!-- Tags --><div class=\"col-xs-6 marT40\"><!-- <div class=\"row\">\r\n            <div class=\"col-xs-4\">\r\n              <div class=\"form-group\" ng-if=\"$state.current.name == \'hub.sContainer.sDevice\'\">\r\n                <label for=\"adDName\">{{\'cm.brief.1\' | translate}}</label>\r\n                <input type=\"text\" id=\"adDName\" class=\"form-control\" ng-model=\"curAdvSearch.dName\" aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\">\r\n              </div>\r\n            </div>\r\n          </div> --><div class=\"row word-break\"><div class=col-xs-4><label for=\"\">{{\'d.tab.3\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{advSearch.tagList.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllTagFx(\'a\', curAdvSearchModel.availableTag);tagSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-2></div><div class=col-xs-3><label for=\"\">{{\'as.label.6\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{curAdvSearch.tag.include.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllTagFx(\'i\', curAdvSearch.tag.include);tagIncSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-3><label for=\"\">{{\'as.label.7\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{curAdvSearch.tag.exclude.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllTagFx(\'e\', curAdvSearch.tag.exclude);tagExcSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div></div><div class=row><div class=col-xs-4><!-- <select id=\"availableTag\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.availableTag\" ng-options=\"option.label for option in advSearch.tagList | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"available tag\" aria-labelledby=\"available tag\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!advSearch.tagList.length ng-model=tagSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=tagSearch.text.length ng-click=\"tagSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"tagSearch.text.length && !filteredTagList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(tagSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredTagList = (advSearch.tagList | filter:tagSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'a\', option, advSearch.tagList)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div><!-- <select id=\"availableTag\" class=\"form-control\" style=\"height: 233px\" ng-model=\"curAdvSearchModel.availableTag\" ng-options=\"option.id as option.label for option in advSearch.tagList | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"available tag\" aria-labelledby=\"available tag\">\r\n                <option ng-repeat=\"option in advSearch.tagList\" ng-style=\"{\'padding-left\': \'25px\'}\">\r\n                  <span ng-style=\"{\'background-color\': \'blue\', \'display\': \'inline-block\', \'width\': \'20px\', \'height\': \'20px\', \'margin-right\': \'5px\'}\"></span>\r\n                  {{option.label}}\r\n                </option>\r\n              </select> --></div><!-- <div class=\"col-xs-2\">\r\n              <select id=\"availableTag\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.availableTag\" ng-options=\"option.label for option in advSearch.tagList | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"available tag\" aria-labelledby=\"available tag\"></select>\r\n            </div> --><div class=\"col-xs-2 actionQuad noPadL noPadR\" style=margin-top:75px><button type=button role=button ng-click=\"!(!curAdvSearchModel.availableTag.length) && listManipulateFx(\'add\', advSearch.tagList, curAdvSearch.tag.include, curAdvSearchModel.availableTag, null, null, \'incTag\');\" class=\"btn btn-success btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableTag.length}\">{{\'as.label.6\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"!(!curAdvSearchModel.availableTag.length) && listManipulateFx(\'add\', advSearch.tagList, curAdvSearch.tag.exclude, curAdvSearchModel.availableTag, null, null, \'excTag\');\" class=\"btn btn-danger btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableTag.length}\">{{\'as.label.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"!(!(curAdvSearchModel.includeTag + curAdvSearchModel.excludeTag).length) && listManipulateFx(\'remove\', advSearch.tagList, curAdvSearch.tag.include, curAdvSearchModel.includeTag, curAdvSearch.tag.exclude, curAdvSearchModel.excludeTag, \'remTag\');\" class=\"btn btn-default btn-xs btn-block\" ng-class=\"{\'disabled\': !(curAdvSearchModel.includeTag + curAdvSearchModel.excludeTag).length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-3><!-- <select id=\"includeTag\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.includeTag\" ng-options=\"option.label for option in curAdvSearch.tag.include | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"include tag\" aria-labelledby=\"include tag\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curAdvSearch.tag.include.length ng-model=tagIncSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=tagIncSearch.text.length ng-click=\"tagIncSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"tagIncSearch.text.length && !filteredTagIncList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(tagIncSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredTagIncList = (curAdvSearch.tag.include | filter:tagIncSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'i\', option, curAdvSearch.tag.include)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curAdvSearch.tag.iType value=or ng-disabled=\"curAdvSearch.tag.include.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curAdvSearch.tag.iType value=and ng-disabled=\"curAdvSearch.tag.include.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div><div class=col-xs-3><!-- <select id=\"excludeTag\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.excludeTag\" ng-options=\"option.label for option in curAdvSearch.tag.exclude | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"exclude tag\" aria-labelledby=\"exclude tag\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curAdvSearch.tag.exclude.length ng-model=tagExcSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=tagExcSearch.text.length ng-click=\"tagExcSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"tagExcSearch.text.length && !filteredTagExcList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(tagExcSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredTagExcList = (curAdvSearch.tag.exclude | filter:tagExcSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'e\', option, curAdvSearch.tag.exclude)\"><span ng-if=auth.upermissions.dtc class=\"marR5 pull-left\" style=vertical-align:bottom aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curAdvSearch.tag.eType value=or ng-disabled=\"curAdvSearch.tag.exclude.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curAdvSearch.tag.eType value=and ng-disabled=\"curAdvSearch.tag.exclude.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div></div></div><!-- Available Groups --><div class=\"col-xs-6 marT40 bdrLd\"><div class=\"row word-break\"><div class=col-xs-4><label for=\"\">{{\'u.tab.2\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{advSearch.userGroupList.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllGrpFx(\'a\', curAdvSearchModel.availableGroup);grpSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-2></div><div class=col-xs-3><label for=\"\">{{\'as.label.6\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{curAdvSearch.userGroup.include.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllGrpFx(\'i\', curAdvSearch.userGroup.include);grpIncSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-3><label for=\"\">{{\'as.label.7\' | translate}} <span class=\"marL5 text-sm text-muted\">[ {{curAdvSearch.userGroup.exclude.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"deSelAllGrpFx(\'e\', curAdvSearch.userGroup.exclude);grpExcSearch.text=\'\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div></div><div class=row><div class=col-xs-4><!-- <select id=\"availableGroup\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.availableGroup\" ng-options=\"option.label for option in advSearch.userGroupList | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"available group\" aria-labelledby=\"available group\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!advSearch.userGroupList.length ng-model=grpSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=grpSearch.text.length ng-click=\"grpSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"grpSearch.text.length && !filteredGrpList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(grpSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredGrpList = (advSearch.userGroupList | filter:grpSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGrpFx(\'a\', option, advSearch.userGroupList)\">{{option.label}}</div></div></div></div></div></div></div><div class=\"col-xs-2 actionQuad noPadL noPadR\" style=margin-top:75px><button type=button role=button ng-click=\"!(!curAdvSearchModel.availableGroup.length) && listManipulateFx(\'add\', advSearch.userGroupList, curAdvSearch.userGroup.include, curAdvSearchModel.availableGroup, null, null, \'incGrp\');\" class=\"btn btn-success btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableGroup.length}\">{{\'as.label.6\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"!(!curAdvSearchModel.availableGroup.length) && listManipulateFx(\'add\', advSearch.userGroupList, curAdvSearch.userGroup.exclude, curAdvSearchModel.availableGroup, null, null, \'excGrp\');\" class=\"btn btn-danger btn-xs btn-block\" ng-class=\"{\'disabled\': !curAdvSearchModel.availableGroup.length}\">{{\'as.label.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"!(!(curAdvSearchModel.includeGroup + curAdvSearchModel.excludeGroup).length) && listManipulateFx(\'remove\', advSearch.userGroupList, curAdvSearch.userGroup.include, curAdvSearchModel.includeGroup, curAdvSearch.userGroup.exclude, curAdvSearchModel.excludeGroup, \'remGrp\');\" class=\"btn btn-default btn-xs btn-block\" ng-class=\"{\'disabled\': !(curAdvSearchModel.includeGroup + curAdvSearchModel.excludeGroup).length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-3><!-- <select id=\"includeGroup\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.includeGroup\" ng-options=\"option.label for option in curAdvSearch.userGroup.include | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"include group\" aria-labelledby=\"include group\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curAdvSearch.userGroup.include.length ng-model=grpIncSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=grpIncSearch.text.length ng-click=\"grpIncSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"grpIncSearch.text.length && !filteredGrpIncList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(grpIncSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredGrpIncList = (curAdvSearch.userGroup.include | filter:grpIncSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGrpFx(\'i\', option, curAdvSearch.userGroup.include)\">{{option.label}}</div></div></div></div></div></div><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.userGroup.include.length <= 1}\"><input type=radio role=radio name=ugiOpt ng-model=curAdvSearch.userGroup.iType value=or ng-disabled=\"curAdvSearch.userGroup.include.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.userGroup.include.length <= 1}\"><input type=radio role=radio name=ugiOpt ng-model=curAdvSearch.userGroup.iType value=and ng-disabled=\"curAdvSearch.userGroup.include.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div><div class=col-xs-3><!-- <select id=\"excludeGroup\" class=\"form-control\" style=\"height:233px\" ng-model=\"curAdvSearchModel.excludeGroup\" ng-options=\"option.label for option in curAdvSearch.userGroup.exclude | orderBy:\'label\' track by option.id\" multiple=\"multiple\" aria-label=\"exclude group\" aria-labelledby=\"exclude group\"></select> --><div class=\"bdrGray overflow-y\" style=height:233px><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curAdvSearch.userGroup.exclude.length ng-model=grpExcSearch.text sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=grpExcSearch.text.length ng-click=\"grpExcSearch.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"grpExcSearch.text.length && !filteredGrpExcList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(grpExcSearch.text)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th noPad\"><div class=\"padT2 resizable\" style=height:184px><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredGrpExcList = (curAdvSearch.userGroup.exclude | filter:grpExcSearch.text | orderBy:\'label\')\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGrpFx(\'e\', option, curAdvSearch.userGroup.exclude)\">{{option.label}}</div></div></div></div></div></div><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR5 noMarB\" ng-class=\"{\'disabled\':curAdvSearch.userGroup.exclude.length <= 1}\"><input type=radio role=radio name=ugeOpt ng-model=curAdvSearch.userGroup.eType value=or ng-disabled=\"curAdvSearch.userGroup.exclude.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label class=noMarB ng-class=\"{\'disabled\':curAdvSearch.userGroup.exclude.length <= 1}\"><input type=radio role=radio name=ugeOpt ng-model=curAdvSearch.userGroup.eType value=and ng-disabled=\"curAdvSearch.userGroup.exclude.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"advSearchFx();search.text=\'\';searchChangeFx(\'empty\');searchInfo.text=\'\'\" ng-disabled=searchProcessing><span class=fa ng-class=\"searchProcessing?\'fa-repeat fa-spin\':\'fa-search\'\" aria-hidden=true></span>{{!searchProcessing?\'as.btn.1\':\'as.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"resetFx();search.text=\'\';searchChangeFx(\'empty\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(\'close\');\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status>{{\'as.msg.1\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/asnActionOpen.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{asnCurObj.caller==\"ws\"?\"cm.asn.5\":asnCurObj.caller==\"clf\"?\"cm.asn.6\":\"\" | translate}}</h1><div class=\"searchTbx bdrR\" ng-show=\"!asnPopLoading && asnCurObj.caller==\'ws\' && asnCurObj.list.length > 5\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=asnPopLoading><div ng-if=!asnPopLoading><!-- Asana Workspace --><div class=customSelect ng-if=\"asnCurObj.caller==\'ws\'\"><ul class=\"list-unstyled noMar list-striped\"><div class=\"list-scroll ng-cloak\" ng-attr-style=max-height:{{getAvailableHeight(380)}}px><li class=noPad ng-repeat=\"list in filteredList = (asnCurObj.list | filter:searchList) | orderBy: \'l\'\" tabindex=$index><label class=pad10 uib-tooltip=\"{{\'cm.asn.m3\' | translate}}\" tooltip-append-to-body=true tooltip-enable=list.disable><input type=checkbox ng-model=list.selected role=checkbox ng-disabled=list.disable><label></label>{{list.l}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></ul></div><!-- Select Folder --><div ng-if=\"asnCurObj.caller==\'clf\'\"><label>{{\'cm.asn.m4\' | translate}}</label><div class=\"msg-warning marT10\" ng-if=\"hasErrAsn1 && errTypeAsn1==\'treeEmpty\'\">{{\'cm.asn.m5\' | translate}}</div><div class=\"form-group bg-light moveTreeContainer noMarB\" ng-if=asnCurObj.list.length ng-attr-style=max-height:{{getAvailableHeight(420)}}px><div><label class=disabledRow for=treeOpt><input type=radio role=radio name=treeOpt value=0 ng-disabled=true id=treeOpt aria-label=treeOpt aria-labelledby=treeOpt><label></label>{{\'cm.label.6\' | translate}}</label><tree list=asnCurObj.list selectednode=selectednode check-disable=true class=\"list-unstyled moveTree\" role=tree aria-orientation=vertical></tree></div></div></div></div></div><footer class=panel-footer ng-if=!asnPopLoading><span class=btnQuad><button type=button role=button ng-click=asnActionFx(); ng-if=\"errTypeAsn1!==\'treeEmpty\'\" class=\"btn btn-sm btn-success\" focus-me=true ng-disabled=ansProProcessing><span class=fa ng-class=\"ansProProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>{{ansProProcessing?\"cm.btn.7i\":\"cm.btn.7\" | translate}}</button> <button type=button role=button class=\"btn btn-sm\" ng-class=\"errTypeAsn1==\'treeEmpty\'?\'btn-default\':\'btn-link\'\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrAsn aria-live=polite role=status><span ng-if=\"errTypeAsn==\'asnAction\'\" aria-live=polite role=status>{{asnCurObj.caller==\"ws\"?\"cm.asn.m1\":\"cm.asn.m2\" | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/cbSettings.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1>{{\'ms.p_s.serverPer.51.1\' | translate}}</header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=cbSettingsLoading><div ng-if=!cbSettingsLoading><section class=pad5><div><div class=\"row bg-light pad5\"><div class=col-xs-12><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':cb.settings.bg, opacity:cb.settings.bga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"cb.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cb.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cb.settings.bg selected-type=cb.ctype.bg is-alpha=true selected-alpha=cb.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':cb.settings.hBg, opacity:cb.settings.hBga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"cb.settings.hBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cb.settings.hBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cb.settings.hBg selected-type=cb.ctype.hb is-alpha=true selected-alpha=cb.settings.hBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':cb.settings.hText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"cb.settings.hText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cb.settings.hText selected-type=cb.ctype.ht ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=cb.settings.hFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=col-xs-3><div class=form-group><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=cb.settings.hSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div><!--  --><div class=row><div class=col-xs-3><div class=form-group><label for=mBgColor>{{\'em.label.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':cb.settings.mBg, opacity:cb.settings.mBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"cb.settings.mBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cb.settings.mBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cb.settings.mBg selected-type=cb.ctype.mb is-alpha=true selected-alpha=cb.settings.mBga ng-if=colorPicker.mb></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=mTextColor>{{\'em.label.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':cb.settings.mText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"cb.settings.mText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cb.settings.mText selected-type=cb.ctype.mt ng-if=colorPicker.mt></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=mFont>{{\'em.label.11\' | translate}}</label><select id=mFont class=form-control ng-model=cb.settings.mFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=col-xs-3><div class=form-group><label for=mSize>{{\'em.label.13\' | translate}}</label><input type=number id=mSize class=form-control ng-model=cb.settings.mSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div></div></div></div></section></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=updateCBSettingsFx(); ng-disabled=updateProcessing><span class=fa ng-class=\"updateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{updateProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-disabled=resetProcessing ng-click=resetCBSettings();><span class=\"fa fa-repeat\" ng-class=\"resetProcessing?\'fa-repeat fa-spin\':\'fa-repeat\'\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errTypePop==\'mSize\'\" aria-live=polite role=status>{{\'em.msg.14\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/codSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.cod.14\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><div class=\"bg-light pad10\"><div class=row><div class=\"col-xs-6 form-group\"><label for=iTime>{{\'cl.widget.cod.14.1\' | translate}}</label><div class=input-group><input type=text id=iTime class=form-control ng-model=codObj.iTime maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'cl.widget.cod.14.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.14.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div><div class=\"col-xs-6 form-group\"><label for=pass>{{\'lock.1\' | translate}}</label><input type=text id=pass class=form-control ng-model=codObj.pass maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'lock.1\' | translate}}\" aria-labelledby=\"{{\'lock.1\' | translate}}\"></div></div></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=codFx(false); ng-disabled=\"codSProcessing || codSAProcessing\"><span ng-class=\"codSProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=codFx(true); ng-disabled=\"codSAProcessing || codSProcessing\"><span ng-class=\"codSAProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cl.widget.cod.14.2\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'iTime\'\" aria-live=polite role=status>{{\'cl.widget.cod.m7\' | translate}}</div><div ng-if=\"errTypePop==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/contentInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.18\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><div class=noPadL><div class=\"table no-th no-border\"><div class=row><div class=col-xs-3>{{\'cm.brief.1\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold word-break\">{{contentInfo.label}}</div></div><div class=row><div ng-if=\"contentInfo.type == \'SharePointC\'\"><!--Content--><div class=col-xs-3>{{\'cl.brief.6\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">SharePoint <span ng-if=contentInfo.extn>[ {{contentInfo.extn}} ]</span></div></div><div ng-if=\"contentInfo.type == \'OneDriveC\'\"><!--Content--><div class=col-xs-3>{{\'cl.brief.6\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">OneDrive <span ng-if=contentInfo.extn>[ {{contentInfo.extn}} ]</span></div></div><div ng-if=\"contentInfo.type == \'GoogleDriveC\'\"><!--Content--><div class=col-xs-3>{{\'cl.brief.6\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">Google Drive <span ng-if=contentInfo.extn>[ {{contentInfo.extn}} ]</span></div></div><div ng-if=\"contentInfo.type != \'Folder\' && contentInfo.type != \'Shortcut\' && contentInfo.type != \'Sharepoint\' && contentInfo.type != \'SharePointC\' && contentInfo.type != \'Onedrive\' && contentInfo.type != \'OneDriveC\' && contentInfo.type != \'Googledrive\' && contentInfo.type != \'GoogleDriveC\' && contentInfo.type != \'template\'\"><!--Content--><div class=col-xs-3>{{\'cl.brief.6\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">{{contentInfo.type}} <span ng-if=contentInfo.extn>[ {{(contentInfo.extn == \'Button\' ? contentInfo.extn + \' - \' + contentInfo.btnExtn : contentInfo.extn == \'Microsoft Power BI\'? (\'cl.widget.pBI.1\' | translate) : (contentInfo.extn == \'x\')? (\'cl.widget.twitter.1\' | translate) :(contentInfo.extn == \'Crop Comm: Alert Message\')? (\'cl.widget.alert.1\' | translate) : contentInfo.extn)}} ]</span></div></div><div ng-if=\"contentInfo.type == \'template\'\"><!--Content--><div class=col-xs-3>{{\'cl.brief.6\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">{{contentInfo.type | capitalize}} <span ng-if=contentInfo.extn>[ {{(contentInfo.extn.toLowerCase() == \'epd\' || contentInfo.extn.toLowerCase() == \'olo\') ? (contentInfo.extn | uppercase) : (contentInfo.extn | capitalize)}} ]</span></div></div></div><div class=row><div class=col-xs-3>{{\'cm.brief.8\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\">{{contentInfo.dimension}} <span class=\"text-muted text-sm\" ng-if=\"contentInfo.dimension == \'\' || contentInfo.dimension == null\">N/A</span></div></div><div class=row><div class=col-xs-3>{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\"><span ng-if=\"contentInfo.size != null\">{{(contentInfo.size*1024) | filesize}}</span> <span ng-if=\"contentInfo.size != null && contentInfo.pSize != null\">| </span><span ng-if=\"contentInfo.pSize != null\">{{(contentInfo.pSize) | filesize}}</span> <span class=\"text-muted text-sm\" ng-if=\"contentInfo != \'\' && contentInfo.size == null && contentInfo.pSize == null\">N/A</span></div></div><div class=row ng-if=\"contentInfo.type != \'template\'\"><div class=col-xs-3>{{\'cl.brief.5\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\" ng-if=contentInfo.activePeriod>{{contentInfo.activePeriod}}</div><div class=\"col-xs-8 text-bold\" ng-if=!contentInfo.activePeriod>{{\'cm.label.16\' | translate}}</div></div><div class=row><div class=col-xs-3>{{\'cl.brief.8\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\"><!-- <span class=\"glyphicon glyphicon-home marR5\" aria-hidden=\"true\" ng-if=\"contentInfo.type != \'template\'\"></span>{{contentInfo.path}} --> <span class=\"glyphicon glyphicon-home marR5\" aria-hidden=true></span>{{contentInfo.path}}</div></div><div class=row ng-if=contentInfo.downloadedOn><div class=col-xs-3>{{\'d.body.14.1\' | translate}}</div><div class=\"col-xs-1 text-right\">:</div><div class=\"col-xs-8 text-bold\"><div class=checkIconQuad><span class=\"fa fa-check-circle marR5\" aria-hidden=true></span>{{contentInfo.downloadedOn}}</div></div></div></div><div ng-if=\"contentInfo.content.length || innerLoading || infoBC.length\"><div class=\"panel-inner-tab marB5 marT20\">{{\'cm.body.1\' | translate}}<div class=\"pull-right marT-5\"><div class=searchTbx><input type=text class=\"form-control input-sm\" ng-model=searchInfo.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchInfo.text.length ng-click=\"searchInfo.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div ng-if=\"infoBC.length > 0\" class=breadcrumb><a href=\"\" role=link ng-click=\"infoBCFx(0);searchInfo.text=\'\';\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in infoBC\"><a href=\"\" role=link ng-click=infoBCFx(breadcrumb); ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div>{{tth = contentList.info.timthumb?contentList.info.timthumb:timthumb; \"\"}}<div class=\"scrollQuad pad2\" ng-attr-style=max-height:{{getAvailableHeight(610)}}px><ul class=\"list-inline thumb-list noHover\"><img alt=Loading src=assets/images/loading.gif ng-if=innerLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchInfo.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!innerLoading && !contentInfo.content.length\">{{\'cm.msg.7\' | translate}}</div><!-- <li class=\"noMar contentItem\" ng-repeat=\"cl in filteredContentList = (contentInfo.content | filter:{isLabel:searchInfo.text}) | orderBy:isLabel\" data-id=\"{{cl.frameid}}\"> --><li class=\"noMar contentItem\" ng-repeat=\"cl in filteredContentList = (contentInfo.content | filter:customFilter) | orderBy:customOrder\" data-id={{cl.frameid}}><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':cl.isblur}\"><!-- Audio, Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"(cl.type == \'Audio\' || cl.type == \'Flash\') && cl.isCompleted\"><!-- Images, Video --> <img alt=\"\" ng-src=\"{{thumbHost + tth + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"(cl.type == \'Image\' || cl.type == \'Video\') && cl.isCompleted\" ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- YouTube --> <img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Widget --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Content Group\' && cl.extn != \'Filler Content\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\' && cl.extn != \'QR Code\' && cl.extn != \'Message\' && cl.extn != \'Meetings\' && cl.extn != \'Open Hours\' && cl.extn != \'Calendar of Events\' && cl.extn != \'Google Calendar\' && cl.extn != \'Quotes\'\"> <a href=\"\" role=link ng-dblclick=contentOpenFx(cl); ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Content Group\' || cl.extn == \'Filler Content\' || cl.extn == \'QR Code\' || cl.extn == \'Message\' || cl.extn == \'Meetings\' || cl.extn == \'Open Hours\' || cl.extn == \'Calendar of Events\' || cl.extn == \'Google Calendar\' || cl.extn == \'Quotes\')\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Web Page Widget--> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && !cl.ss\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && cl.ss\" ng-href=\"{{cDetailBucket + cl.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{cl.label}}><img alt={{cl.type}} ng-src=\"{{thumbHost + tim + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Template  --> <img alt=\"\" ng-src=\"{{thumbHost + tth + tBucket + cl.thumb + thumbParam + \'&\' + cl.thumbV}}\" class=img-responsive ng-if=\"cl.type == \'template\' && cl.isCompleted\"><!-- Other --> <img alt=\"\" ng-src=\"{{thumbHost + tth + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\" ng-class=\"{\'blurry-img\':cl.isblur}\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\"> <span class=duration ng-if=\"contentInfo.isCallFrom != \'scu\'\">{{cl.duration}}</span> <span class=thumb-icon><span ng-if=\"cl.type !== \'folder\' && !cl.confirmed && contentList.info.restrict.isActive && cl.size > contentList.info.restrict.size\" class=warning-icon></span> <span ng-if=\"cl.type !== \'folder\' && cl.confirmed\" class=check-icon></span> <span ng-if=cl.ss class=webpage></span> <span ng-if=\"cl.type !== \'folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=\"thumb-label text-ellipsis\" uib-tooltip={{cl.label?cl.label:cl.l}} tooltip-popup-delay=1500>{{cl.label?cl.label:cl.l}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredContentList.length == 0 && searchInfo.text\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchInfo.text)}}&quot;</b>\'}\"></div></ul></div></div></div></div><footer class=panel-footer><span class=btnQuad><img alt=Loading src=\"assets/images/loading{{contentInfo.isCallFrom == \'scu\'?\'-xs\':\'\'}}.gif\" ng-if=btnProcessing> <button ng-if=!btnProcessing type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button> <span ng-if=contentBtn.buttons.length><span ng-repeat=\"editBtn in contentBtn.buttons\" ng-if=\"contentInfo.type == \'Widget\' || contentInfo.type == \'template\'\"><button type=button role=button class=\"btn btn-default\" ng-if=\"editBtn.key ==\'clEdit\' || editBtn.key ==\'tEdit\'\" ng-disabled=editBtnProcess ng-click=\"editFx(contentInfo.id, contentInfo.fId, contentInfo.type,contentInfo.extn,contentInfo.label, contentInfo.splId, contentInfo.splType);\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> </span><button type=button role=button class=\"btn btn-primary\" ng-click=\"openContentFolderFx(contentInfo.id, contentInfo.fId, contentInfo.type, contentInfo.splId, contentInfo.splType, contentInfo.gid, contentInfo.gType);\" ng-if=\"(auth.uservices.c && contentInfo.type != \'template\') || (auth.uservices.t && contentInfo.type == \'template\')\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cm.btn.46\' | translate}}</button> <button type=button role=button ng-if=\"contentInfo.type!=\'template\' && contentInfo.type!=\'Widget\'\" class=\"btn btn-success\" ng-click=downloadOpen(contentInfo);><span class=\"fa fa-download\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</button></span></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/contentSensitivity.html","<section class=panel role=dialog><div class=panel-heading role=heading aria-level=1>{{\"cm.acs.2\" | translate}}</div><div class=panel-body><div class=\"table table-md dTable\"><div class=row><div class=col-xs-12><label>{{\"cm.acs.3.2\" | translate}} <a href=\"\" role=button id=infoVL class=\"marL5 pull-right\" aria-label=infoVL ng-click=\"readMeFx(\'vl\');\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></label><div role=radiogroup aria-labelledby=radiogroup><label for=vl1 class=marR35><input type=radio role=radio aria-labelledby=vl1 name=vlOpt id=vl1 ng-model=curAcs.vl value=0><label></label>0</label><label for=vl2 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=vl2 name=vlOpt id=vl2 ng-model=curAcs.vl value=2><label></label>2</label><label for=vl3 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=vl3 name=vlOpt id=vl3 ng-model=curAcs.vl value=4><label></label>4</label><label for=vl4><input type=radio role=radio aria-labelledby=vl4 name=vlOpt id=vl4 ng-model=curAcs.vl value=6><label></label>6</label><span class=\"text-muted text-sm marL5\">({{\'cm.acs.17\' | translate}})</span></div></div></div><div class=row><div class=col-xs-12><label>{{\"cm.acs.4.2\" | translate}} <a href=\"\" role=button id=infoSH class=\"marL5 pull-right\" aria-label=infoSH ng-click=\"readMeFx(\'sh\');\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></label><div role=radiogroup aria-labelledby=radiogroup><label for=sh1 class=marR35><input type=radio role=radio aria-labelledby=sh1 name=shOpt id=sh1 ng-model=curAcs.sh value=0><label></label>0</label><label for=sh2 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=sh2 name=shOpt id=sh2 ng-model=curAcs.sh value=2><label></label>2</label><label for=sh3 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=sh3 name=shOpt id=sh3 ng-model=curAcs.sh value=4><label></label>4</label><label for=sh4><input type=radio role=radio aria-labelledby=sh4 name=shOpt id=sh4 ng-model=curAcs.sh value=6><label></label>6</label><span class=\"text-muted text-sm marL5\">({{\'cm.acs.17\' | translate}})</span></div></div></div><div class=row><div class=col-xs-12><label>{{\"cm.acs.5.2\" | translate}} <a href=\"\" role=button id=infoSX class=\"marL5 pull-right\" aria-label=infoSX ng-click=\"readMeFx(\'sx\');\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></label><div role=radiogroup aria-labelledby=radiogroup><label for=sx1 class=marR35><input type=radio role=radio aria-labelledby=sx1 name=sxOpt id=sx1 ng-model=curAcs.sx value=0><label></label>0</label><label for=sx2 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=sx2 name=sxOpt id=sx2 ng-model=curAcs.sx value=2><label></label>2</label><label for=sx3 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=sx3 name=sxOpt id=sx3 ng-model=curAcs.sx value=4><label></label>4</label><label for=sx4><input type=radio role=radio aria-labelledby=sx4 name=sxOpt id=sx4 ng-model=curAcs.sx value=6><label></label>6</label><span class=\"text-muted text-sm marL5\">({{\'cm.acs.17\' | translate}})</span></div></div></div><div class=row><div class=col-xs-12><label>{{\"cm.acs.6.2\" | translate}} <a href=\"\" role=button id=infoHT class=\"marL5 pull-right\" aria-label=infoHT ng-click=\"readMeFx(\'ht\');\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></label><div role=radiogroup aria-labelledby=radiogroup><label for=ht1 class=marR35><input type=radio role=radio aria-labelledby=ht1 name=htOpt id=ht1 ng-model=curAcs.ht value=0><label></label>0</label><label for=ht2 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=ht2 name=htOpt id=ht2 ng-model=curAcs.ht value=2><label></label>2</label><label for=ht3 class=\"marL10 marR35\"><input type=radio role=radio aria-labelledby=ht3 name=htOpt id=ht3 ng-model=curAcs.ht value=4><label></label>4</label><label for=ht4><input type=radio role=radio aria-labelledby=ht4 name=htOpt id=ht4 ng-model=curAcs.ht value=6><label></label>6</label><span class=\"text-muted text-sm marL5\">({{\'cm.acs.17\' | translate}})</span></div></div></div><div class=\"marT20 hide\"><label for=strc><input type=checkbox role=checkbox aria-labelledby=strc id=strc ng-model=curAcs.strc><label></label>{{\'cm.acs.7\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.acs.8\' | translate}})</span></label></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=acsFx();><span class=\"fa fa-check\"></span>{{\"cm.btn.7\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=\"closeThisDialog(\'close\');\">{{\"cm.btn.9\" | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/customRoom.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.meeting.17\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><div class=row><div class=col-xs-5><label for=label>{{\'cl.widget.meeting.17.1\' | translate}}</label><input type=text id=label class=form-control ng-model=curRoom.label aria-label=\"{{\'cl.widget.meeting.17.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.17.1\' | translate}}\"></div><div class=col-xs-5><label for=floor>{{\'cl.widget.meeting.17.2\' | translate}}</label><input type=text id=floor class=form-control ng-model=curRoom.floor aria-label=\"{{\'cl.widget.meeting.17.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.17.2\' | translate}}\"></div><div class=col-xs-2><label class=w100>&nbsp;</label><button type=button role=button class=\"btn btn-block\" ng-class=\"isAddMode?\'btn-primary\':\'btn-success\'\" ng-click=addEditRoomFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"isAddMode?\'fa-plus-circle\':\'fa-check\'\" ng-if=!popupProcessing aria-hidden=true></span><span class=\"fa fa-spin fa-repeat\" ng-if=popupProcessing aria-hidden=true></span> {{isAddMode?\'cm.btn.19\':\'cm.btn.15\' | translate}}</button></div><div class=col-xs-12><div class=\"errMsg marT2 pull-left\" ng-if=hasErrPop aria-live=polite role=status><span ng-if=\"errTypePop==\'empty\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</span> <span ng-if=\"errTypePop==\'exist\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</span></div></div></div><div class=\"table marT10\" ng-if=roomList.length><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.17.1\' | translate}}</div><div class=col-xs-5>{{\'cl.widget.meeting.17.2\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(470)}}px><div class=row ng-repeat=\"list in roomList\"><div class=col-xs-6>{{list.label}}</div><div class=col-xs-5>{{list.floor}}<span class=\"text-muted text-sm\" ng-if=!list.floor>N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"meetingActionFx(\'e\', list);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"meetingActionFx(\'d\', list);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/dashbordSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"dsObj.type==\'ccs\'\" role=heading aria-level=1>{{\'ms.label.35.10\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'dps\'\" role=heading aria-level=1>{{\'ms.label.35.9.1\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'ds\'\" role=heading aria-level=1>{{\'ms.label.35.1\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'dts\'\" role=heading aria-level=1>{{\'ms.label.35.8\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'dtps\'\" role=heading aria-level=1>{{\'ms.label.35.12\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'ssdt\'\" role=heading aria-level=1>{{\'ms.label.35.13\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'ot\'\" role=heading aria-level=1>{{\'ms.label.35.15\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'rad\'\" role=heading aria-level=1>{{\'ms.label.35.14.1\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'dp\'\" role=heading aria-level=1>{{\'d.btn.11\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'ssodt\'\" role=heading aria-level=1>{{\'ms.label.35.17\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'dpts\'\" role=heading aria-level=1>{{\'ms.label.35.18\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'ssdpt\'\" role=heading aria-level=1>{{\'ms.label.35.19\' | translate}}</h1><h1 ng-if=\"dsObj.type==\'wgws\'\" role=heading aria-level=1>{{\'db.wgw.3\' | translate}}</h1></header><div class=pad15 ng-if=dsLoading><img alt=Loading src=assets/images/loading.gif></div><div class=panel-body ng-if=!dsLoading><div ng-if=\"dsObj.type == \'ccs\'\"><h5 class=\"panel-inner-tab marB10\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ccs\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group\"><label for=confirmed>{{\'db.body.13.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.d><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ccs.d}\"></span></span></span> <input type=text class=\"form-control picker\" id=confirmed ng-value=\"dColors.ccs.ns | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.d=true\" readonly aria-label=\"{{\'db.body.13.1\' | translate}}\" aria-labelledby=\"{{\'db.body.13.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ccs.d selected-type=dColors.ccs.dt ng-if=colorPicker.d></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=unconfirmed>{{\'db.body.13.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.r><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ccs.r}\"></span></span></span> <input type=text class=\"form-control picker\" id=unconfirmed ng-value=\"dColors.ccs.r | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.r=true\" readonly aria-label=\"{{\'db.body.13.2\' | translate}}\" aria-labelledby=\"{{\'db.body.13.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ccs.r selected-type=dColors.ccs.rt ng-if=colorPicker.r></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=noSchedule>{{\'db.body.13.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ns><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ccs.ns}\"></span></span></span> <input type=text class=\"form-control picker\" id=noSchedule ng-value=\"dColors.ccs.ns | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ns=true\" readonly aria-label=\"{{\'db.body.13.3\' | translate}}\" aria-labelledby=\"{{\'db.body.13.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ccs.ns selected-type=dColors.ccs.nst ng-if=colorPicker.ns></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'dps\'\"><div class=msg-warning lang={{auth.lang}} ng-if=!dsObj.dps.length>{{\"r.msg.3\" | translate}}</div><div class=\"form-group noMarB\" ng-if=dsObj.dps.length><label>{{\"d.label.9\" | translate | capitalize}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span id=otherInfo class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\">{{infoSelected = (dsObj.dps | filter:{selected:true}); \"\"}} <span ng-if=!infoSelected.length>{{\"d.label.9.1\" | translate}}</span> <span ng-repeat=\"info in infoSelected\">{{info.label}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li role=listitem class=\"dropdown-header noPad noMar\" ng-show=\"dsObj.dps.length > 5\"><label for=sOIBox class=lableHidden>c</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=sOIBox ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=sOIBtn class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"dsObj.dps.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li role=listitem ng-repeat=\"info in filteredSList = (dsObj.dps | filter:searchList)\" tabindex=$index><label><input type=checkbox role=checkbox ng-model=info.selected><label></label>{{info.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0 && dsObj.dps.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div ng-if=\"dsObj.type == \'ds\'\"><h5 class=\"panel-inner-tab marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ds\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group\"><label for=dson>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.on><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ds.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=dson ng-value=\"dColors.ds.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.on=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ds.on selected-type=dColors.ds.ont ng-if=colorPicker.on></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=dsoff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.off><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ds.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=dsoff ng-value=\"dColors.ds.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.off=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ds.off selected-type=dColors.ds.offt ng-if=colorPicker.off></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=dsnc>{{\'d.tool.21\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ds.nc}\"></span></span></span> <input type=text class=\"form-control picker\" id=dsnc ng-value=\"dColors.ds.nc | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nc=true\" readonly aria-label=\"{{\'d.tool.21\' | translate}}\" aria-labelledby=\"{{\'d.tool.21\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ds.nc selected-type=dColors.ds.nct ng-if=colorPicker.nc></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'dts\'\"><h5 class=\"panel-inner-tab marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'dts\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group\"><label for=dtsmp>{{\'d.label.1.1\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.mp}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsmp ng-value=\"dColors.dts.mp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mp=true\" readonly aria-label=\"{{\'d.label.1.1\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.1\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.mp selected-type=dColors.dts.mpt ng-if=colorPicker.mp></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.desktop><label for=dtsde>{{\'d.label.1.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.de><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.de}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsde ng-value=\"dColors.dts.de | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.de=true\" readonly aria-label=\"{{\'d.label.1.7\' | translate}}\" aria-labelledby=\"{{\'d.label.1.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.de selected-type=dColors.dts.det ng-if=colorPicker.de></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.webos><label for=dtswebos>{{\'d.label.1.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.webos><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.webos}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtswebos ng-value=\"dColors.dts.webos | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.webos=true\" readonly aria-label=\"{{\'d.label.1.5\' | translate}}\" aria-labelledby=\"{{\'d.label.1.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.webos selected-type=dColors.dts.webost ng-if=colorPicker.webos></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.tizen><label for=dtstz>{{\'d.label.1.6\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tz><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.tz}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtstz ng-value=\"dColors.dts.tz | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tz=true\" readonly aria-label=\"{{\'d.label.1.6\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.6\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.tz selected-type=dColors.dts.tzt ng-if=colorPicker.tz></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.mc><label for=dtsmc>{{\'d.label.1.4\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.mc}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsmc ng-value=\"dColors.dts.mc | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mc=true\" readonly aria-label=\"{{\'d.label.1.4\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.4\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.mc selected-type=dColors.dts.mct ng-if=colorPicker.mc></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.gf><label for=dtsgeo>{{\'d.label.1.2\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.geo><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.geo}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsgeo ng-value=\"dColors.dts.geo | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.geo=true\" readonly aria-label=\"{{\'d.label.1.2\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.2\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.geo selected-type=dColors.dts.geot ng-if=colorPicker.geo></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.vd><label for=dtsvd>{{\'d.label.1.3\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.vd><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.vd}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsvd ng-value=\"dColors.dts.vd | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.vd=true\" readonly aria-label=\"{{\'d.label.1.3\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.3\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.vd selected-type=dColors.dts.vdt ng-if=colorPicker.vd></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\" ng-if=auth.upermissions.epd><label for=dtsepd>{{\'d.label.1.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.epd><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dts.epd}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtsepd ng-value=\"dColors.dts.epd | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.epd=true\" readonly aria-label=\"{{\'d.label.1.8\' | translate}}\" aria-labelledby=\"{{\'d.label.1.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dts.epd selected-type=dColors.dts.epdt ng-if=colorPicker.epd></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'dtps\'\"><h5 class=\"panel-inner-tab marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'dtps\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group\"><label for=dtpsno>{{\'db.body.14.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.no><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dtps.no}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtpsno ng-value=\"dColors.dtps.no | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.no=true\" readonly aria-label=\"{{\'db.body.14.1\' | translate}}\" aria-labelledby=\"{{\'db.body.14.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dtps.no selected-type=dColors.dtps.not ng-if=colorPicker.no></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=dtpsc>{{\'db.body.14.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.co><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dtps.c}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtpsc ng-value=\"dColors.dtps.c | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.co=true\" readonly aria-label=\"{{\'db.body.14.2\' | translate}}\" aria-labelledby=\"{{\'db.body.14.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dtps.c selected-type=dColors.dtps.ct ng-if=colorPicker.co></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=dtpsd>{{\'db.body.14.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.dtps.d}\"></span></span></span> <input type=text class=\"form-control picker\" id=dtpsd ng-value=\"dColors.dtps.d | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dn=true\" readonly aria-label=\"{{\'db.body.14.3\' | translate}}\" aria-labelledby=\"{{\'db.body.14.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.dtps.d selected-type=dColors.dtps.dt ng-if=colorPicker.dn></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'ot\'\"><h5 class=\"panel-inner-tab marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ot\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group noMarB\"><label for=otot>{{\'ms.label.35.15\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ot><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ot.ot}\"></span></span></span> <input type=text class=\"form-control picker\" id=otot ng-value=\"dColors.ot.ot | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ot=true\" readonly aria-label=\"{{\'ms.label.35.15\' | translate | capitalize}}\" aria-labelledby=\"{{\'ms.label.35.15\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ot.ot selected-type=dColors.ot.ott ng-if=colorPicker.ot></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=ott>{{\'ms.label.35.15.4\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.to><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ot.t}\"></span></span></span> <input type=text class=\"form-control picker\" id=ott ng-value=\"dColors.ot.t | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.to=true\" readonly aria-label=\"{{\'ms.label.35.15.4\' | translate | capitalize}}\" aria-labelledby=\"{{\'ms.label.35.15.4\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ot.t selected-type=dColors.ot.tt ng-if=colorPicker.to></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'ssdt\'\" ng-attr-style=max-height:{{getAvailableHeight(335)}}px><div class=msg-warning lang={{auth.lang}} ng-if=!dsObj.ssdt.length>{{\"r.msg.3\" | translate}}</div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div ng-repeat=\"ssdt in dsObj.ssdt\" class=marB2 ng-if=dsObj.ssdt.length><div class=\"bg-muted pad5 text-bold\" ng-click=\"ssdt.open = !ssdt.open\"><a href=\"\" role=link>{{ssdt.label}} <span class=\"fa pull-right marT2\" ng-class=\"ssdt.open?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></div><div class=\"table no-th pad5 bdr\" ng-if=ssdt.open><div class=row ng-repeat=\"val in ssdt.values\"><div class=col-xs-12><label class=noMarB><input type=checkbox role=checkbox ng-model=val.selected><label></label>{{val.label}}</label></div></div></div></div></div><h5 class=\"panel-inner-tab marT15 marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ssdt\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group noMarB\"><label for=ssdtOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.on><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssdt.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=ssdtOn ng-value=\"dColors.ssdt.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.on=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssdt.on selected-type=dColors.ssdt.ont ng-if=colorPicker.on></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=ssdtOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.off><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssdt.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=ssdtOff ng-value=\"dColors.ssdt.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.off=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssdt.off selected-type=dColors.ssdt.offt ng-if=colorPicker.off></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'rad\'\"><label>{{\"ms.label.35.14.2\" | translate | capitalize}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=radOpt ng-model=settings.dSettings.rad value=d aria-label=radD aria-labelledby=radD><label></label>{{\"ms.label.35.14.3\" | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=radOpt ng-model=settings.dSettings.rad value=w aria-label=radW aria-labelledby=radW><label></label>{{\"ms.label.35.14.4\" | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=radOpt ng-model=settings.dSettings.rad value=m aria-label=radM aria-labelledby=radM><label></label>{{\"ms.label.35.14.5\" | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=radOpt ng-model=settings.dSettings.rad value=y aria-label=radY aria-labelledby=radY><label></label>{{\"ms.label.35.14.6\" | translate}}</label></div></div><div ng-if=\"dsObj.type == \'dp\'\"><div class=msg-warning lang={{auth.lang}} ng-if=!allScrollDataList.dp.length>{{\"db.msg.1\" | translate}}</div><div class=\"form-group noMarB\" ng-if=allScrollDataList.dp.length><label>{{\"ms.label.36\" | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.isopen><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\';searchChangeData(searchList, \'dp\');\"><span ng-if=!settings.dSettings.dp>{{\"cm.label.31\" | translate}}</span> <span ng-if=settings.dSettings.dp>{{settings.dSettings.dp.label}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"allScrollDataList.dp.length > 5\" role=menuitem><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 ng-change=\"searchChangeData(searchList, \'dp\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\';searchChangeData(searchList, \'dp\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"allScrollDataList.dp.length > 5\"></li><div class=\"list-scroll ng-cloak\" role=radiogroup aria-labelledby=radiogroup id=scroll-container-dp dynamic-scroll-list st=stIndex.dp et=etIndex.dp list-data=scrollDataList.dp search-data=searchText.dp have-more-data=haveMoreData.dp search-scroll=searchScroll.dp clone-data=allScrollDataList.dp have-more-search-data=haveMoreSearchData.dp quad-id=\"\'dp\'\" dd-open=false><!-- <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"dpLoading\"> --><li class=rowObj-dp id={{d.id}} ng-repeat=\"d in filteredSList = (visibleData.dp)\" tabindex=$index><label><input type=radio role=radio name=dpObj value={{d}} ng-checked=\"d.id == settings.dSettings.dp.id\" ng-model=settings.dSettings.dp ng-change=\"singleSelectFx(); status.isopen=false\"><label></label><div class=\"marR5 deviceStatus {{d.status}}\" uib-tooltip=\"{{d.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500></div>{{d.l}}</label></li><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.dp || !haveMoreSearchData.dp) && scrollDataList.dp.length >= 300 && scrollDataList.dp.length == etIndex.dp\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.dp.length > 0 && filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div ng-if=\"dsObj.type == \'ssodt\'\" ng-attr-style=max-height:{{getAvailableHeight(335)}}px><div class=\"form-group noMarB\"><label>{{\"cm.label.31\" | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span id=statusSummary class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle><span ng-if=\"!settings.dSettings.ssodt.mp && !settings.dSettings.ssodt.desktop && !settings.dSettings.ssodt.webos && !settings.dSettings.ssodt.tizen && !settings.dSettings.ssodt.mc && !settings.dSettings.ssodt.gf && !settings.dSettings.ssodt.v\">{{\"cm.label.31\" | translate}}</span> <span ng-if=settings.dSettings.ssodt.mp>{{\'d.label.1.1\' | translate}}<span ng-if=\"settings.dSettings.ssodt.desktop || settings.dSettings.ssodt.webos || settings.dSettings.ssodt.tizen || settings.dSettings.ssodt.mc || settings.dSettings.ssodt.gf || settings.dSettings.ssodt.vd\">,</span></span> <span ng-if=settings.dSettings.ssodt.desktop>{{\'d.label.1.7\' | translate}}<span ng-if=\"settings.dSettings.ssodt.webos || settings.dSettings.ssodt.tizen || settings.dSettings.ssodt.mc || settings.dSettings.ssodt.gf || settings.dSettings.ssodt.v\">,</span></span> <span ng-if=settings.dSettings.ssodt.webos>{{\'d.label.1.5\' | translate}}<span ng-if=\"settings.dSettings.ssodt.tizen || settings.dSettings.ssodt.mc || settings.dSettings.ssodt.gf || settings.dSettings.ssodt.v\">,</span></span> <span ng-if=settings.dSettings.ssodt.tizen>{{\'d.label.1.6\' | translate}}<span ng-if=\"settings.dSettings.ssodt.mc || settings.dSettings.ssodt.gf || settings.dSettings.ssodt.v\">,</span></span> <span ng-if=settings.dSettings.ssodt.mc>{{\'d.label.1.4\' | translate}}<span ng-if=\"settings.dSettings.ssodt.gf || settings.dSettings.ssodt.v\">,</span></span> <span ng-if=settings.dSettings.ssodt.gf>{{\'d.label.1.2\' | translate}}<span ng-if=settings.dSettings.ssodt.v>,</span></span> <span ng-if=settings.dSettings.ssodt.v>{{\'d.label.1.3\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><div class=\"list-scroll ng-cloak\"><li role=menuitem><label><input type=checkbox value=mp ng-model=settings.dSettings.ssodt.mp role=checkbox aria-label=\"{{\'d.label.1.1\' | translate}}\" aria-labelledby=\"{{\'d.label.1.1\' | translate}}\"><label></label>{{\'d.label.1.1\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.desktop><label><input type=checkbox value=desktop ng-model=settings.dSettings.ssodt.desktop role=checkbox aria-label=\"{{\'d.label.1.7\' | translate}}\" aria-labelledby=\"{{\'d.label.1.7\' | translate}}\"><label></label>{{\'d.label.1.7\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.webos><label><input type=checkbox value=webos ng-model=settings.dSettings.ssodt.webos role=checkbox aria-label=\"{{\'d.label.1.5\' | translate}}\" aria-labelledby=\"{{\'d.label.1.5\' | translate}}\"><label></label>{{\'d.label.1.5\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.tizen><label><input type=checkbox value=tizen ng-model=settings.dSettings.ssodt.tizen role=checkbox aria-label=\"{{\'d.label.1.6\' | translate}}\" aria-labelledby=\"{{\'d.label.1.6\' | translate}}\"><label></label>{{\'d.label.1.6\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.mc><label><input type=checkbox value=mc ng-model=settings.dSettings.ssodt.mc role=checkbox aria-label=\"{{\'d.label.1.4\' | translate}}\" aria-labelledby=\"{{\'d.label.1.4\' | translate}}\"><label></label>{{\'d.label.1.4\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.gf><label><input type=checkbox value=gf ng-model=settings.dSettings.ssodt.gf role=checkbox aria-label=\" {{\'d.label.1.2\' | translate}}\" aria-labelledby=\" {{\'d.label.1.2\' | translate}}\"><label></label>{{\'d.label.1.2\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.vd><label><input type=checkbox value=v ng-model=settings.dSettings.ssodt.v role=checkbox aria-label=\"{{\'d.label.1.3\' | translate}}\" aria-labelledby=ssodtv><label></label>{{\'d.label.1.3\' | translate}}</label></li><li role=menuitem ng-if=auth.upermissions.epd><label><input type=checkbox value=epd ng-model=settings.dSettings.ssodt.epd role=checkbox aria-label=\"{{\'d.label.1.8\' | translate}}\" aria-labelledby=\"{{\'d.label.1.8\' | translate}}\"><label></label>{{\'d.label.1.8\' | translate}}</label></li></div></div></div></div></ul></div><h5 class=\"panel-inner-tab marT15 marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ssodt\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=\"row scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=col-xs-12><label>{{\'d.label.1.1\' | translate | capitalize}}</label></div><div class=\"col-xs-6 form-group\"><label for=mpOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mpOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.mp.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=mpOn ng-value=\"dColors.ssodt.mp.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mpOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.mp.on selected-type=dColors.ssodt.mp.ont ng-if=colorPicker.mpOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=mpOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mpOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.mp.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=mpOff ng-value=\"dColors.ssodt.mp.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mpOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.mp.off selected-type=dColors.ssodt.mp.offt ng-if=colorPicker.mpOff></ng-hub-color-picker></div></div></div><div ng-if=auth.upermissions.desktop><div class=col-xs-12><label>{{\'d.label.1.7\' | translate}}</label></div><div class=\"col-xs-6 form-group\"><label for=deOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.deOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.de.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=deOn ng-value=\"dColors.ssodt.de.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.deOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.de.on selected-type=dColors.ssodt.de.ont ng-if=colorPicker.deOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=deOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.deOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.de.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=deOff ng-value=\"dColors.ssodt.de.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.deOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.de.off selected-type=dColors.ssodt.de.offt ng-if=colorPicker.deOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.webos><div class=col-xs-12><label>{{\'d.label.1.5\' | translate}}</label></div><div class=\"col-xs-6 form-group\"><label for=webosOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.webosOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.webos.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=webosOn ng-value=\"dColors.ssodt.webos.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.webosOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.webos.on selected-type=dColors.ssodt.webos.ont ng-if=colorPicker.webosOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=webosOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.webosOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.webos.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=webosOff ng-value=\"dColors.ssodt.webos.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.webosOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.webos.off selected-type=dColors.ssodt.webos.offt ng-if=colorPicker.webosOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.tizen><div class=col-xs-12><label>{{\'d.label.1.6\' | translate | capitalize}}</label></div><div class=\"col-xs-6 form-group\"><label for=tzOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tzOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.tz.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=tzOn ng-value=\"dColors.ssodt.tz.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tzOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.tz.on selected-type=dColors.ssodt.tz.ont ng-if=colorPicker.tzOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=tzOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tzOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.tz.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=tzOff ng-value=\"dColors.ssodt.tz.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tzOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.tz.off selected-type=dColors.ssodt.tz.offt ng-if=colorPicker.tzOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.mc><div class=col-xs-12><label>{{\'d.label.1.4\' | translate | capitalize}}</label></div><div class=\"col-xs-6 form-group\"><label for=mcOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mcOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.mc.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=mcOn ng-value=\"dColors.ssodt.mc.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mcOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.mc.on selected-type=dColors.ssodt.mc.ont ng-if=colorPicker.mcOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=mcOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mcOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.mc.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=mcOff ng-value=\"dColors.ssodt.mc.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mcOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.mc.off selected-type=dColors.ssodt.mc.offt ng-if=colorPicker.mcOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.gf><div class=col-xs-12><label>{{\'d.label.1.2\' | translate | capitalize}}</label></div><div class=\"col-xs-6 form-group\"><label for=geoOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.geoOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.geo.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=geoOn ng-value=\"dColors.ssodt.geo.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.geoOn=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.geo.on selected-type=dColors.ssodt.geo.ont ng-if=colorPicker.geoOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=geoOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.geoOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.geo.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=geoOff ng-value=\"dColors.ssodt.geo.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.geoOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.geo.off selected-type=dColors.ssodt.geo.offt ng-if=colorPicker.geoOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.vd><div class=col-xs-12><label>{{\'d.label.1.3\' | translate | capitalize}}</label></div><div class=\"col-xs-6 form-group\"><label for=vdOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.vdOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.vd.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=vdOn ng-value=\"dColors.ssodt.vd.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.vdOn=true\" readonly aria-label=\"{{\'d.label.1.3\' | translate | capitalize}}\" aria-labelledby=\"{{\'d.label.1.3\' | translate | capitalize}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.vd.on selected-type=dColors.ssodt.vd.ont ng-if=colorPicker.vdOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=vdOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.vdOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.vd.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=vdOff ng-value=\"dColors.ssodt.vd.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.vdOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.vd.off selected-type=dColors.ssodt.vd.offt ng-if=colorPicker.vdOff></ng-hub-color-picker></div></div></div></div><div ng-if=auth.upermissions.epd><div class=col-xs-12><label>{{\'d.label.1.8\' | translate}}</label></div><div class=\"col-xs-6 form-group\"><label for=epdOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.epdOn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.epd.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=epdOn ng-value=\"dColors.ssodt.epd.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.epdOn=true\" readonly aria-label=\"{{\'d.label.1.8\' | translate}}\" aria-labelledby=\"{{\'d.label.1.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.epd.on selected-type=dColors.ssodt.epd.ont ng-if=colorPicker.epdOn></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=epdOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.epdOff><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssodt.epd.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=epdOff ng-value=\"dColors.ssodt.epd.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.epdOff=true\" readonly aria-label=\"{{\'d.tool.2\' | translate}}\" aria-labelledby=\"{{\'d.tool.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssodt.epd.off selected-type=dColors.ssodt.epd.offt ng-if=colorPicker.epdOff></ng-hub-color-picker></div></div></div></div></div></div></div><div ng-if=\"dsObj.type == \'dpts\'\"><div class=msg-warning lang={{auth.lang}} ng-if=!dsObj.dpts.length>{{\"r.msg.3\" | translate}}</div><div class=\"form-group noMarB\" ng-if=dsObj.dpts.length><label>{{\"d.tab.6.8\" | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span id=properties class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\">{{infoSelected = (dsObj.dpts | filter:{selected:true}); \"\"}} <span ng-if=!infoSelected.length>{{\"ms.label.40\" | translate}}</span> <span ng-repeat=\"info in infoSelected\">{{info.label}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"dsObj.dpts.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"dsObj.dpts.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"info in filteredSList = (dsObj.dpts | filter:searchList)\" tabindex=$index><label><input type=checkbox ng-model=info.selected role=checkbox aria-label=infoSelected aria-labelledby=infoSelected><label></label>{{info.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0 && dsObj.dpts.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div ng-if=\"dsObj.type == \'ssdpt\'\" ng-attr-style=max-height:{{getAvailableHeight(335)}}px><div class=msg-warning lang={{auth.lang}} ng-if=!dsObj.ssdpt.length>{{\"r.msg.3\" | translate}}</div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div ng-repeat=\"ssdpt in dsObj.ssdpt\" class=marB2 ng-if=dsObj.ssdpt.length><div class=\"bg-muted pad5 text-bold\" ng-click=\"ssdpt.open = !ssdpt.open\"><a href=\"\" role=link>{{ssdpt.label}} <span class=\"fa pull-right marT2\" ng-class=\"ssdpt.open?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></div><div class=\"table no-th pad5 bdr\" ng-if=ssdpt.open><div class=row ng-repeat=\"val in ssdpt.values\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=val.selected role=checkbox><label></label>{{val.label}}</label></div></div></div></div></div><h5 class=\"panel-inner-tab marT15 marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'ssdpt\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group noMarB\"><label for=ssdptOn>{{\'d.tool.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.on><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssdpt.on}\"></span></span></span> <input type=text class=\"form-control picker\" id=ssdptOn ng-value=\"dColors.ssdpt.on | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.on=true\" readonly aria-label=\"{{\'d.tool.1\' | translate}}\" aria-labelledby=\"{{\'d.tool.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssdpt.on selected-type=dColors.ssdpt.ont ng-if=colorPicker.on></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=ssdptOff>{{\'d.tool.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.off><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.ssdpt.off}\"></span></span></span> <input type=text class=\"form-control picker\" id=ssdptOff ng-value=\"dColors.ssdpt.off | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.off=true\" readonly aria-label=ssdptOff aria-labelledby=ssdptOff></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.ssdpt.off selected-type=dColors.ssdpt.offt ng-if=colorPicker.off></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"dsObj.type == \'wgws\'\"><h5 class=\"panel-inner-tab marB15\">{{\'ms.label.39\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"colorDefaultFx(\'wgws\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button></h5><div class=row><div class=\"col-xs-6 form-group\"><label for=wgwsact>{{\'db.wgw.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.act><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.wgws.act}\"></span></span></span> <input type=text class=\"form-control picker\" id=wgwsact ng-value=\"dColors.wgws.act | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.act=true\" readonly aria-label=\"{{\'db.wgw.6\' | translate}}\" aria-labelledby=\"{{\'db.wgw.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.wgws.act selected-type=dColors.wgws.actt ng-if=colorPicker.act></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group\"><label for=wgwsexp>{{\'db.wgw.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.exp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.wgws.exp}\"></span></span></span> <input type=text class=\"form-control picker\" id=wgwsexp ng-value=\"dColors.wgws.exp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.exp=true\" readonly aria-label=\"{{\'db.wgw.7\' | translate}}\" aria-labelledby=\"{{\'db.wgw.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.wgws.exp selected-type=dColors.wgws.expt ng-if=colorPicker.exp></ng-hub-color-picker></div></div></div><div class=\"col-xs-6 form-group noMarB\"><label for=wgwsnw>{{\'db.wgw.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nw><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dColors.wgws.nw}\"></span></span></span> <input type=text class=\"form-control picker\" id=wgwsnw ng-value=\"dColors.wgws.nw | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nw=true\" readonly aria-label=\"{{\'db.wgw.8\' | translate}}\" aria-labelledby=\"{{\'db.wgw.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dColors.wgws.nw selected-type=dColors.wgws.nwt ng-if=colorPicker.nw></ng-hub-color-picker></div></div></div></div></div></div><footer class=panel-footer ng-if=!dsLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=dsSaveFx(); ng-disabled=dsProcessing><span class=fa ng-class=\"dsProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\"cm.btn.7\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=\"closeThisDialog(\'closeButton\'); clearSettingsFx(dsObj.type);\" data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right noMar\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'empty\'\" aria-live=polite role=status>{{\"cm.msg.38\" | translate}}</div><div ng-if=\"errTypePop==\'dpEmpty\'\" aria-live=polite role=status>{{\"ms.msg.36\" | translate}}</div><div ng-if=\"errTypePop==\'ssodtEmpty\'\" aria-live=polite role=status>{{\"ms.msg.37\" | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/defaultClientContent.html","<section class=panel><header class=panel-heading><h1>{{\'ms.p_s.defaultImg.4\' | translate}}</h1></header><div class=\"panel-body popDCI\"><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div class=row ng-if=!contentLibraryLoading><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=advancedShow class=\"col-xs-12 noPad marB10\"></advanced-search>{{viewType = (uPreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'dfCI\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.pText sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.pText.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{contentObj.quadHeight}}px;><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><ul class=\"list-inline thumb-list\" ng-if=\"uPreferences.contentView == \'t\'\" element-height=contentObj.quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"uPreferences.contentView == \'l\'\" element-height=contentObj.quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning ng-if=\"contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div><div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad><div class=pull-right><label for=scSearch class=\"lableHidden absolute\">search</label><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text id=scSearch ng-model=selectedSearchText sanitize-input class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} [ {{setDFCIImg.content.length}} ]</div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{contentObj.selectedHeight}}px;><div ng-if=\"setDFCIImg.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=\"sortCallback(\'popup\')\" containment=\"\'parent\'\" ng-if=\"uPreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (setDFCIImg.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=sortable-item ng-if=!content.hidden><a href=\"\" role=link aria-label=cross_{{$index}} class=thumb-close ng-click=\"removeFx(\'popup\', content.id, setDFCIImg.content);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000 tooltip-enable=content.path><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Images --><!-- <a ng-href=\"https://dev2.lsquared.com/api/v1/vendor/timthumb/timthumb.php?src=/dev-lsquared-hub/cl/{{content.thumb}}\" role=\"link\" fancyboxable=\"fbTitleInside\" data-fancybox-title=\"{{content.label}}\">\r\n                          <img alt=\"\" ng-src=\"https://dev2.lsquared.com/api/v1/vendor/timthumb/timthumb.php?src=/dev-lsquared-hub/cl/{{content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\">\r\n                        </a> --> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + bucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube --> <a ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Vimeo --> <a ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + bucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbBigParam + \'&v=\' + content.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + bucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted && content.type != \'template\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" ng-src=assets/images/default/thmbs/md/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thmbs/md/od.png ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thmbs/md/gd.png ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <span class=thumb-icon><span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{content.label}}</div><div class=form-inline><div class=\"form-group text-ellipsis text-left w100\"><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number id=content-{{$index}} class=\"form-control input-sm duration\" ng-model=content.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"> <span class=\"text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</span></div></div></li></ul><ul class=\"table table-md list-unstyled sortable-containment\" sortable callback=\"sortCallback(\'popup\')\" containment=\"\'parent\'\" ng-if=\"uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=col-xs-3>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in selectedFilteredContent = (setDFCIImg.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-if=!cl.hidden><div class=\"col-xs-4 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --><!-- <a ng-href=\"https://dev2.lsquared.com/api/v1/vendor/timthumb/timthumb.php?src=/dev-lsquared-hub/cl/{{cl.thumb}}\" role=\"link\" fancyboxable=\"fbTitleInside\" data-fancybox-title=\"{{cl.label}}\" ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\">\r\n                          <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\">\r\n                        </a> --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=assets/images/default/photo-xs.png> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=assets/images/default/video-sm.png> </a><img alt={{cl.type}} ng-src=assets/images/default/ppt-xs.png ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=assets/images/default/word-xs.png ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=assets/images/default/pdf-xs.png ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=assets/images/default/audio-xs.png> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=assets/images/default/swf-xs.png> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&v=\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + bucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted && cl.type != \'template\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=assets/images/default/sp-xs.png ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=assets/images/default/od-xs.png ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=assets/images/default/gd-xs.png ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=assets/images/default/photo-xs.png ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=\"col-xs-3 text-ellipsis\">{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{cl.extn}}&nbsp;]</span></div><div class=col-xs-3><span ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\"><input type=number class=\"form-control input-sm duration pad4\" ng-model=cl.duration min=1></span></div><div class=\"col-xs-2 text-right\"><a href=\"\" class=text-danger ng-click=\"removeFx(\'popup\', cl.id, setDFCIImg.content)\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning ng-if=\"setDFCIImg.content.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning ng-if=\"setDFCIImg.content.length > 0 && (setDFCIImg.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); focus-me=true data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/dmbSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.dmb.1\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-attr-style=min-height:{{getAvailableHeight(360)}}px;max-height:{{getAvailableHeight(360)}}px ng-if=!popupLoading><section class=marT10><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':dmbTab==\'1\'}\" ng-click=dmbTabFx(1);>{{\'cm.dmb.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':dmbTab==\'3\'}\" ng-click=dmbTabFx(3);>{{\'cm.dmb.11\' | translate}}</a></header><img alt=Loading src=assets/images/loading.gif ng-if=settingLoadingServer><div class=\"panel-body marT5\" ng-if=!settingLoadingServer><div ng-if=\"dmbTab == 1\"><div class=\"bg-light pad10\"><div class=row><div class=col-xs-5><div class=\"form-group noMarB\"><label for=brand>{{\'cm.dmb.3\' | translate}}</label><input type=text id=brand class=form-control ng-model=dmbBrand.brand autocomplete=off aria-label=\"{{\'cm.dmb.3\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.3\' | translate}}\"></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><div><label for=url>{{\'cm.dmb.4\' | translate}} <span class=text-muted>({{\'cm.label.26\' | translate}}<span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'cm.dmb.m7\' | translate}}\" tooltip-placement=right aria-hidden=true></span>)</span></label></div><div class=\"pull-left noPadR noPadL pad8\">{{curUrl}}/mb/#/</div><input type=text id=url class=\"form-control wAuto\" ng-model=dmbBrand.url autocomplete=off aria-label=\"{{\'cm.dmb.4\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.4\' | translate}}\"></div></div><div class=\"col-xs-1 noPadL\"><div class=marB5>&nbsp;</div><button type=button role=button class=\"btn btn-success\" ng-click=addBrandFx(); ng-disabled=dmbBrandProcessing><span class=fa ng-class=\"dmbBrandProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div><div class=\"errMsg pull-right marR10 marT5\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'eBrand\'\" aria-live=polite role=status>{{\'cm.dmb.m1\' | translate}}</div><div ng-if=\"errTypePop==\'aBrand\'\" aria-live=polite role=status>{{\'cm.dmb.m2\' | translate}}</div><div ng-if=\"errTypePop==\'aURL\'\" aria-live=polite role=status>{{\'cm.dmb.m3\' | translate}}</div></div></div><div class=clearfix></div></div><div class=\"row marT20\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.3.2\' | translate}}<div class=\"panel-tools marT-5 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.brands.length > 0\"><input type=text class=\"form-control input-sm\" id=searchBrandTxt ng-model=searchBrandTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchBrandTxt.length ng-click=\"searchBrandTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.brands.length > 0\"><div class=\"row th\"><div class=col-xs-5>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-6>{{\'cl.widget.cm.10\' | translate}}</div><div class=col-xs-1></div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(575)}}px><div class=\"row word-break\" ng-repeat=\"brand in dmbSettings.brands | filter:searchBrandTxt\"><div class=col-xs-5>{{brand.label}}</div><div class=col-xs-6><a href={{curUrl}}/mb/#/{{brand.url}} role=link target=_blank>{{curUrl}}/mb/#/{{brand.url}}</a> <button type=button role=button ng-if=brand.url class=\"btn btn-xs btn-primary marL10\" ng-click=\"editThemeOpen(brand.url, brand.label);\">{{\'cm.dmb.7\' | translate}}</button></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'b\', brand.id, $index);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.brands | filter:searchBrandTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchBrandTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.brands.length == 0\">{{\'cm.dmb.m4\' | translate}}</div></div></div></div><div ng-if=\"dmbTab == 2\"><div class=\"bg-light pad10\"><div class=row><div class=col-xs-2><div class=\"form-group noMarB\"><label for=label>{{\'cm.brief.1\' | translate}}</label><input type=text id=label class=form-control ng-model=dmbNewUser.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=email>{{\'cm.label.47\' | translate}}</label><input type=email id=email class=form-control ng-model=dmbNewUser.email aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=pwd>{{\'cl.p_f.7\' | translate}}</label><input type=password id=pwd class=form-control ng-model=dmbNewUser.pwd aria-label=\"{{\'cl.p_f.7\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.7\' | translate}}\"></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label for=brands>{{\'cm.dmb.3\' | translate}}</label><select id=brands class=form-control ng-options=\"brand.label for brand in dmbSettings.brands track by brand.id\" ng-model=dmbNewUser.brand aria-label=\"{{\'cm.dmb.3\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.3\' | translate}}\"><option value=\"\" disabled>{{\'cm.dmb.3.1\' | translate}}</option></select></div></div><div ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-3\'\"><div class=\"form-group noMarB\"><label>{{\'cm.label.4s\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>{{curDSelected = (devices.devices | filter:{selected:true}); \"\"}} <span ng-if=!curDSelected.length>{{\'cm.label.31\' | translate}}</span> <span ng-repeat=\"device in curDSelected\">{{device.label}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><div class=text-bold>{{\'d.tab.1\' | translate}}</div><li class=\"dropdown-header noPad noMarR marT5\" ng-show=\"devices.devices.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control id=searchListD ng-model=searchList.d sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"device in filteredDList = (devices.devices | filter:searchList.d) | orderBy: \'label\'\" tabindex=$index uib-tooltip={{device.label}} tooltip-popup-delay=1000 tooltip-append-to-body=true><label><input type=checkbox ng-model=device.selected role=checkbox aria-label=deviceSelected aria-labelledby=deviceSelected><label></label>{{device.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"devices.devices.length && filteredDList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!devices.devices.length>{{\'db.msg.1\' | translate}}</div></div></div></div></div></ul></div></div></div><div class=noPad ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-1\'\"><div class=\"form-group noMarB\"><label>&nbsp;</label><div><button type=button role=button class=btn ng-class=\"dmbNewUser.id?\'btn-primary\':\'btn-success\'\" ng-click=addDMBUserFx(); ng-disabled=dmbUserProcessing><span class=fa ng-class=\"dmbUserProcessing?\'fa-repeat fa-spin\':dmbNewUser.id?\'fa-check\':\'fa-plus-circle\'\" aria-hidden=true></span>{{dmbNewUser.id?\'cm.btn.7\':\'cm.btn.19\' | translate}}</button> <a href=\"\" role=link class=\"btn btn-link\" ng-click=cancelDMBUserFx(); ng-if=dmbNewUser.id>{{\'cm.btn.9\' | translate}}</a></div></div></div></div><div class=\"errMsg pull-right marT5\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'eField\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errTypePop==\'uExist\'\" aria-live=polite role=status>{{\'ms.msg.9\' | translate}}</div></div><div class=clearfix></div></div><div class=\"row marT20\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.6\' | translate}}<div class=\"panel-tools marT-5 marB10 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.users.length > 0\"><input type=text class=\"form-control input-sm\" ng-model=searchUserTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchUserTxt.length ng-click=\"searchUserTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.users.length > 0\"><div class=\"row th\"><div class=col-xs-2>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.47\' | translate}}</div><div class=col-xs-3>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-1></div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(575)}}px><div class=\"row word-break\" ng-repeat=\"user in dmbSettings.users | filter:searchUserTxt\" data-id={{user.id}}><div class=col-xs-2>{{user.label}}</div><div class=col-xs-3>{{user.email}}</div><div class=col-xs-3>{{user.brand.label}}</div><div class=col-xs-3><ul class=list-inline><li class=\"noPad marR5\" ng-repeat=\"device in user.devices\">{{device.label}}<span ng-if=!$last>,</span></li></ul></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-primary ng-click=\"sendPwdFx(user.userId, $index);\" ng-disabled=sendPwdProcessing uib-tooltip=\"{{\'u.brief.6\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-share-square\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marLR5\" ng-click=\"editOpen(user, $index);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'u\', user.userId, $index);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.users | filter:searchUserTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchUserTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.users.length == 0\">{{\'cm.dmb.m6\' | translate}}</div></div></div></div><div ng-if=\"dmbTab == 3\"><div class=\"bg-light pad10\"><div class=row><div class=col-xs-4><div class=\"form-group noMarB\"><label for=curDMBLabelsdv>{{\'cm.dmb.12\' | translate}}</label><input type=text id=curDMBLabelsdv class=form-control ng-model=curDMBLabels.dv aria-label=\"{{\'cm.dmb.12\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.12\' | translate}}\"></div></div><div class=col-xs-4><div class=\"form-group noMarB\"><label for=curDMBLabelslv>{{\'cm.dmb.13\' | translate}}</label><input type=text id=curDMBLabelslv class=form-control ng-model=curDMBLabels.lv aria-label=\"{{\'cm.dmb.13\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.13\' | translate}}\"></div></div><div class=col-xs-4><div class=\"form-group noMarB\"><label for=curDMBLabelspv>{{\'cm.dmb.14\' | translate}}</label><input type=text id=curDMBLabelspv class=form-control ng-model=curDMBLabels.pv aria-label=\"{{\'cm.dmb.14\' | translate}}\" aria-labelledby=\"{{\'cm.dmb.14\' | translate}}\"></div></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=updateDMBLablesFx(); ng-disabled=updateProcessing><span class=fa ng-class=\"updateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{updateProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=reset role=button class=\"btn btn-link\" ng-click=dmbLabelsResetFx(); ng-disabled=dpProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'eField\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errTypePop==\'uExist\'\" aria-live=polite role=status>{{\'ms.msg.9\' | translate}}</div><div ng-if=\"errTypePop==\'t1Empty\'\" aria-live=polite role=status>{{\'cm.dmb.m12\' | translate}}</div><div ng-if=\"errTypePop==\'t2Empty\'\" aria-live=polite role=status>{{\'cm.dmb.m13\' | translate}}</div><div ng-if=\"errTypePop==\'t3Empty\'\" aria-live=polite role=status>{{\'cm.dmb.m14\' | translate}}</div></div></div></div></div></div></div></div></section></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.1\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/downloadLog.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{logs.module == \"a\"?\'db.body.3.1\':\'\' | translate}} {{logs.module == \"d\"?\'d.body.11\':\'\' | translate}} {{logs.module == \"u\"?\'cm.body.9\':\'\' | translate}}</h1></header><div class=panel-body><div ng-if=!logs.url><div class=\"form-group noMarB\"><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=daterange class=\"form-control picker\" ng-model=logs.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div><div class=\"errMsg marT10\" ng-if=hasErr aria-live=polite role=status>{{\'cm.msg.2\' | translate}}</div></div><div class=text-center ng-if=logs.url><p translate=\"{{\'cm.body.11\'}}\" translate-values=\"{htmlTagO: \'<b>&quot;\', htmlTagC: \'&quot;</b>\'}\"></p><a href={{logs.url}} role=link target=_blank download class=\"btn btn-link text-lg\"><span class=\"fa fa-download\" aria-hidden=true></span> {{\'cm.btn.17\' | translate}}</a></div><div ng-if=\"logs.url && logs.note\" class=\"bg-warning text-warning pad10 marT10\">{{logs.noteC | translate}}</div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=logsFx(); ng-if=!logs.url ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.42\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); ng-if=!logs.url data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); ng-if=logs.url data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/editHistory.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.p_h.2\' | translate}}</h1><span class=marL5 ng-if=\"editHistoryObj.label && editHistoryObj.label != \' \'\">[ {{editHistoryObj.label}} ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=historyLoading><div class=\"table scrollQuad no-th\" ng-if=\"!historyLoading && editHistory.logs.length > 0\" when-scrolled=loadMoreHistory() ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"log in editHistory.logs\"><div class=col-xs-9><div class=user-tumb><img alt=\"\" src=\"{{editHistory.info.timthumb + editHistory.info.bucket + log.userImg}}&w=36&h=36&q=80&zc=3\" ng-if=log.userImg><div class=profileIcon-sm ng-if=!log.userImg><span>{{log.user | limitTo:1}}</span></div></div><div class=text-ellipsis-wrap>{{log.dataShort}}<div class=\"text-ellipsis text-sm text-bold text-muted\">{{log.user}}</div></div></div><div class=\"col-xs-3 text-right\"><div class=\"text-ellipsis text-sm\">{{log.logDate}}</div><div class=\"text-ellipsis text-sm text-muted\">{{log.logTime | uppercase}}</div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!historyLoading && editHistory.logs.length <= 0\">{{\'cm.p_h.m1\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/editTheme.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.dmb.1\' | translate}}</h1><span class=\"text-sm marL5\">[ {{brandLabel}} ]</span></header><div class=\"panel-body pad5\"><img alt=Loading src=assets/images/loading.gif ng-if=popupLoad><div ng-attr-style=min-height:{{getAvailableHeight(360)}}px;max-height:{{getAvailableHeight(360)}}px ng-if=!popupLoad><section><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div class=panel-body ng-if=!settingLoading><div class=row><div class=col-xs-12><h5 class=marB5>{{\'cm.dmb.8\' | translate}}</h5></div><div class=col-xs-12><textarea type=text class=form-control ng-model=theme.data style=resize:vertical ng-attr-style=height:{{getAvailableHeight(360)}}px; autocomplete=off></textarea></div></div></div></section></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-disabled=\"saveThemeProcess || popupLoad\" ng-click=saveTheme(this);><span class=\"fa fa-check\" ng-class=\"saveThemeProcess?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"resetThemeProcess || popupLoad\" ng-click=resetTheme();><span class=\"fa fa-repeat\" ng-class=\"resetThemeProcess?\'fa-repeat fa-spin\':\'fa-repeat\'\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop1 aria-live=polite role=status><div ng-if=\"errTypePop==\'tInvalid\'\" aria-live=polite role=status>{{\'cm.dmb.m9\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/email.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'ms.btn.1\' | translate}}</h1></header><div class=panel-body><div class=form-group><!-- ng-class=\"{\'has-error\':hasErrPop && errType == \'email\'}\" --><label for=newEmail>{{\'ms.label.16\' | translate}}</label><input type=email id=newEmail class=form-control ng-model=curSettings.email.newEmail maxlength={{inputLimit}} aria-label=\"{{\'ms.label.16\' | translate}}\" aria-labelledby=\"{{\'ms.label.16\' | translate}}\"></div><div class=form-group><label for=vCode>{{\'ms.label.17\' | translate}} <a href=\"\" role=link uib-tooltip=\"{{\'ms.label.17.1\' | translate}}\"><span class=\"fa fa-question-circle\" aria-hidden=true></span></a></label><input type=text id=vCode class=form-control ng-model=curSettings.email.vCode aria-label=\"{{\'ms.label.17\' | translate}}\" aria-labelledby=\"{{\'ms.label.17\' | translate}}\"></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=emailFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><span ng-if=\"errType==\'vCode\'\" aria-live=polite role=status>{{\'ms.msg.5\' | translate}}</span> <span ng-if=\"errType==\'same\'\" aria-live=polite role=status>{{\'ms.msg.6\' | translate}}</span> <span ng-if=\"errType==\'email\'\" aria-live=polite role=status>{{\'ms.msg.7\' | translate}}</span> <span ng-if=\"errType==\'vCodeEmpty\'\" aria-live=polite role=status>{{\'ms.msg.8\' | translate}}</span> <span ng-if=\"errType==\'userExist\'\" aria-live=polite role=status>{{\'ms.msg.9\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/epdSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_dc.18\' | translate}}</h1></header><div class=panel-body><div><div class=\"bg-light pad10\"><div class=row><div class=\"col-xs-12 form-group\"><label for=ep>{{\'cl.widget.pw.27\' | translate}}</label><input type=text id=ep class=form-control ng-model=epdObj.ep maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.pw.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.27\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label for=user>{{\'cl.p_f.6\' | translate}}</label><input type=text id=user class=form-control ng-model=epdObj.u maxlength={{inputLimit}} aria-label=\"{{\'cl.p_f.6\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.6\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=pass>{{\'cl.p_f.7\' | translate}}</label><input type=password id=pass class=form-control ng-model=epdObj.p maxlength={{inputLimit}} aria-label=\"{{\'cl.p_f.7\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.7\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label for=client>{{\'ms.p_s.serverPer.13\' | translate}}</label><input type=text id=client class=form-control ng-model=epdObj.c maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.serverPer.13\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.13\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=clientS>{{\'ms.p_s.serverPer.14\' | translate}}</label><input type=text id=clientS class=form-control ng-model=epdObj.s maxlength={{inputLimit}} aria-label=\"{{\'ms.p_s.serverPer.14\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.14\' | translate}}\"></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button class=\"btn btn-success\" role=button ng-click=epdFx();><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'ep\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.39.m1\' | translate}}</div><div ng-if=\"errTypePop==\'user\'\" aria-live=polite role=status>{{\'lock.m2\' | translate}}</div><div ng-if=\"errTypePop==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errTypePop==\'client\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m4\' | translate}}</div><div ng-if=\"errTypePop==\'clientS\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m5\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/gdSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{gdObj.caller==\'o\'?\'ms.p_s.serverPer.70.1\':\'ms.p_s.serverPer.70.2\' | translate}}</h1></header><div class=panel-body><div ng-if=\"gdObj.caller==\'o\'\"><div class=form-group><label for=cid>{{\'ms.p_s.serverPer.13\' | translate}}</label><input type=text id=cid class=form-control ng-model=gdObj.data.gdOtApp.client_id aria-label=\"{{\'ms.p_s.serverPer.13\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.13\' | translate}}\"></div><div class=form-group><label for=cs>{{\'ms.p_s.serverPer.14\' | translate}}</label><input type=text id=cs class=form-control ng-model=gdObj.data.gdOtApp.client_secret aria-label=\"{{\'ms.p_s.serverPer.14\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.14\' | translate}}\"></div></div><div ng-if=\"gdObj.caller==\'sp\'\"><div class=form-group><label for=md>{{\'ms.p_s.serverPer.71\' | translate}}</label><textarea id=md class=form-control ng-model=gdObj.data.gdspApp.jobj rows=8 aria-label=\"{{\'ms.p_s.serverPer.71\' | translate}}\" aria-labelledby=\"{{\'ms.p_s.serverPer.71\' | translate}}\"></textarea></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=gdFx(); focus-me=true ng-disabled=saveProcessing><span class=\"fa fa-check\" aria-hidden=true></span>{{\"cm.btn.7\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right noMar\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'cid\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m4\" | translate}}</div><div ng-if=\"errTypePop==\'cs\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m5\" | translate}}</div><div ng-if=\"errTypePop==\'md\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m32\" | translate}}</div></div></footer></section>");
$templateCache.put("app/common/popup/groupDevice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cm.btn.17\" | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=loadProcessing><div ng-if=!loadProcessing><div class=form-group ng-if=\"$state.includes(\'hub.devices.d\') && (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\') && confirmObj.id > 0 && confirmObj.type!=\'dView\' && confirmObj.devices.folders.length && !isAdvSrch\"><label for=export-device>{{\'cm.menu.5\' | translate}}</label><div class=marB10><label class=noMarB><input id=export-device type=radio name=dOpt value=cr ng-model=dfTypeObj.df><label></label>{{\'d.label.30\' | translate}}</label><label class=\"noMarB marL10\"><input id=export-device type=radio name=dOpt value=c ng-model=dfTypeObj.df><label></label>{{\'d.label.29\' | translate}}</label></div></div><div ng-if=confirmObj.isDsg><label class=text-unbold><input type=checkbox ng-model=confirmObj.dsg role=checkbox aria-label=\"{{\'d.msg.33\' | translate}}\" aria-labelledby=\"{{\'d.msg.33\' | translate}}\"><label></label>{{\'d.msg.33\' | translate}}</label></div><label class=\"noMarB marT5\"><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.p_dc.wos.9\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"row dg-list\"><div class=col-xs-4><div ng-repeat=\"col1 in dColumnOneList\"><label class=marB5><input type=checkbox ng-model=col1.checkBox role=checkbox aria-label={{col1.label}} aria-labelledby={{col1.label}}><label></label>{{col1.label}}</label></div></div><div class=col-xs-4><div ng-repeat=\"col2 in dColumnTwoList\"><label class=marB5><input type=checkbox ng-model=col2.checkBox role=checkbox aria-label={{col2.label}} aria-labelledby={{col2.label}}><label></label>{{col2.label}}</label></div></div><div class=col-xs-4><div ng-repeat=\"col3 in dColumnThreeList\"><label class=marB5><input type=checkbox ng-model=col3.checkBox role=checkbox aria-label={{col3.label}} aria-labelledby={{col3.label}}><label></label>{{col3.label}}</label></div></div></div></div></div></div><footer class=\"panel-footer padB10\"><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=exportDevices(confirmObj.devices); ng-disabled=loadProcessing>{{\"d.btn.24\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm ng-binding\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></footer></section>");
$templateCache.put("app/common/popup/hybridHosting.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"ms.p_s.serverPer.34\" | translate | camelCase}}</h1></header><div class=panel-body><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px ng-if=!popupLoading><h5 class=\"panel-inner-tab marTB10\">{{\'ms.p_s.serverPer.34.7\' | translate}}</h5><div class=pad10><div class=row><div class=col-xs-12><div class=form-group><label for=type>{{\"cm.label.69\" | translate}}</label><select class=form-control id=type ng-model=hh.storage.type aria-label=type aria-labelledby=type><option value=\"\" disabled>{{\'cl.widget.cm.20\' | translate}}</option><option value=minio>MinIO</option><option value=aws-s3>AWS S3</option></select></div><div class=form-group><label for=isSSL><input type=checkbox ng-model=hh.storage.isSSL role=checkbox aria-label=isSSL aria-labelledby=isSSL><label></label>{{\"ms.p_s.serverPer.34.1\" | translate}}</label></div><div class=form-group><label for=host>{{\"ms.p_s.serverPer.34.2\" | translate}}</label><div class=input-group><span class=input-group-addon>{{hh.storage.isSSL ? \'https://\' : \'http://\'}}</span> <input type=text class=form-control id=host ng-model=hh.storage.host aria-label=host aria-labelledby=host></div></div><div class=form-group><label for=bucket>{{\"ms.p_s.serverPer.34.3\" | translate}}</label><input type=text class=form-control id=bucket ng-model=hh.storage.bucket aria-label=bucket aria-labelledby=bucket></div><div class=form-group><label for=accessKey>{{\"ms.p_s.serverPer.34.4\" | translate}}</label><input type=text class=form-control id=accessKey ng-model=hh.storage.accessKey aria-label=accessKey aria-labelledby=accessKey></div><div class=form-group><label for=secretKey>{{\"ms.p_s.serverPer.34.5\" | translate}}</label><input type=text class=form-control id=secretKey ng-model=hh.storage.secretKey aria-label=secretKey aria-labelledby=secretKey></div><div class=form-group><label for=port>{{\"ms.p_s.serverPer.34.6\" | translate}}</label><input type=number min=0 class=form-control id=port ng-model=hh.storage.port aria-label=port aria-labelledby=port></div></div></div></div><h5 class=\"panel-inner-tab marTB10\">{{\'ms.p_s.serverPer.34.8\' | translate}}</h5><div class=pad10><div class=row><div class=col-xs-12><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text class=form-control id=url ng-model=hh.media.url aria-label=url aria-labelledby=url></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=hybridHostingFx(); focus-me=true ng-disabled=saveProcessing><span class=\"fa fa-check\" aria-hidden=true></span>{{\"cm.btn.7\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=\"resetHHDataFx(); closeThisDialog();\" data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right noMar\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'type\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m14\" | translate}}</div><div ng-if=\"errTypePop==\'host\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m15\" | translate}}</div><div ng-if=\"errTypePop==\'bucket\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m16\" | translate}}</div><div ng-if=\"errTypePop==\'aKey\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m17\" | translate}}</div><div ng-if=\"errTypePop==\'sKey\'\" aria-live=polite role=status>{{\"ms.p_s.serverPer.m18\" | translate}}</div></div></footer></section>");
$templateCache.put("app/common/popup/iotCSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'p_iotC.1\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px ng-if=!popupLoading><div class=row><div class=col-xs-12><div class=form-group><label for=admin_token_id>{{\'p_iotC.2\' | translate}}</label><input type=text id=admin_token_id class=form-control ng-model=iotCSettings.settings.admin_token_id focus-me=true aria-label=\"{{\'p_iotC.2\' | translate}}\" aria-labelledby=\"{{\'p_iotC.2\' | translate}}\"></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=subdomain>{{\'p_iotC.3\' | translate}}</label><input type=text id=subdomain class=form-control ng-model=iotCSettings.settings.subdomain aria-label=\"{{\'p_iotC.3\' | translate}}\" aria-labelledby=\"{{\'p_iotC.3\' | translate}}\"></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=dns>{{\'p_iotC.4\' | translate}}</label><input type=text id=dns class=form-control ng-model=iotCSettings.settings.dns aria-label=\"{{\'p_iotC.4\' | translate}}\" aria-labelledby=\"{{\'p_iotC.4\' | translate}}\"></div></div></div><div class=row><div class=col-xs-12><label for=application_id>{{\'p_iotC.5\' | translate}}</label><input type=text id=application_id class=form-control ng-model=iotCSettings.settings.application_id aria-label=\"{{\'p_iotC.5\' | translate}}\" aria-labelledby=\"{{\'p_iotC.5\' | translate}}\"></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=iotCPopFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'aToken\'\" aria-live=polite role=status>{{\'p_iotC.msg.1\' | translate}}</div><div ng-if=\"errTypePop==\'sDomain\'\" aria-live=polite role=status>{{\'p_iotC.msg.2\' | translate}}</div><div ng-if=\"errTypePop==\'dns\'\" aria-live=polite role=status>{{\'p_iotC.msg.3\' | translate}}</div><div ng-if=\"errTypePop==\'aId\'\" aria-live=polite role=status>{{\'p_iotC.msg.4\' | translate}}</div><div ng-if=\"errTypePop==\'iCred\'\" aria-live=polite role=status>{{\'p_iotC.msg.5\' | translate}}</div><div ng-if=\"errTypePop==\'invalid\'\" aria-live=polite role=status>{{\'cm.msg.45\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/levelInfo.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'vl\'\" role=heading aria-level=1>{{\'cm.acs.3.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'sh\'\" role=heading aria-level=1>{{\'cm.acs.4.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'sx\'\" role=heading aria-level=1>{{\'cm.acs.5.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ht\'\" role=heading aria-level=1>{{\'cm.acs.6.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'info\'\" role=heading aria-level=1>{{\'cm.acs.16\' | translate}}</h1></header><div class=panel-body><div class=\"table table-md dTable\" role=table><div class=\"row th\"><div ng-if=ngDialogData.severity class=\"col-xs-2 word-break\">{{\'cl.widget.cod.6\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.14\' | translate}}</div><div ng-class=\"ngDialogData.severity ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break>{{\'cs.body.18\' | translate}}</div><div class=col-xs-4>{{\'cm.acs.15\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><ul ng-if=\"ngDialogData.tabName==\'vl\' || ngDialogData.severity\" class=list-unstyled><!-- Violence --><li class=row ng-if=\"ngDialogData.tabName==\'vl\' || (ngDialogData.severity && ngDialogData.severity.vl == 0)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.vl == 0)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.3\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.10\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.vl == 0) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.vl.d1\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.vl.d1.1\' | translate}}</li><li>{{\'cm.acs.vl.d1.2\' | translate}}</li><li>{{\'cm.acs.vl.d1.3\' | translate}}</li><li>{{\'cm.acs.vl.d1.4\' | translate}}</li><li>{{\'cm.acs.vl.d1.5\' | translate}}</li><li>{{\'cm.acs.vl.d1.6\' | translate}}</li><li>{{\'cm.acs.vl.d1.7\' | translate}}</li><li>{{\'cm.acs.vl.d1.8\' | translate}}</li><li>{{\'cm.acs.vl.d1.9\' | translate}}</li><li>{{\'cm.acs.vl.d1.10\' | translate}}</li><li>{{\'cm.acs.vl.d1.11\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.vl.e1.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'vl\' || (ngDialogData.severity && ngDialogData.severity.vl == 2)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.vl == 2)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.3\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.11\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.vl == 2) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.vl.d2\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.vl.d2.1\' | translate}}</li><li>{{\'cm.acs.vl.d2.2\' | translate}}</li><li>{{\'cm.acs.vl.d2.3\' | translate}}</li><li>{{\'cm.acs.vl.d2.4\' | translate}}</li><li>{{\'cm.acs.vl.d2.5\' | translate}}</li><li>{{\'cm.acs.vl.d2.6\' | translate}}</li><li>{{\'cm.acs.vl.d2.7\' | translate}}</li><li>{{\'cm.acs.vl.d2.8\' | translate}}</li><li>{{\'cm.acs.vl.d2.9\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.vl.e2.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'vl\' || (ngDialogData.severity && ngDialogData.severity.vl == 4)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.vl == 4)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.3\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.12\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.vl == 4) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.vl.d3\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.vl.d3.1\' | translate}}</li><li>{{\'cm.acs.vl.d3.2\' | translate}}</li><li>{{\'cm.acs.vl.d3.3\' | translate}}</li><li>{{\'cm.acs.vl.d3.4\' | translate}}</li><li>{{\'cm.acs.vl.d3.5\' | translate}}</li><li>{{\'cm.acs.vl.d3.6\' | translate}}</li><li>{{\'cm.acs.vl.d3.7\' | translate}}</li><li>{{\'cm.acs.vl.d3.8\' | translate}}</li><li>{{\'cm.acs.vl.d3.9\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.vl.e3.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'vl\' || (ngDialogData.severity && ngDialogData.severity.vl == 6)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.vl == 6)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.3\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.13\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.vl == 6) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.vl.d4\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.vl.d4.1\' | translate}}</li><li>{{\'cm.acs.vl.d4.2\' | translate}}</li><li>{{\'cm.acs.vl.d4.3\' | translate}}</li><li>{{\'cm.acs.vl.d4.4\' | translate}}</li><li>{{\'cm.acs.vl.d4.5\' | translate}}</li><li>{{\'cm.acs.vl.d4.6\' | translate}}</li><li>{{\'cm.acs.vl.d4.7\' | translate}}</li><li>{{\'cm.acs.vl.d4.8\' | translate}}</li><li>{{\'cm.acs.vl.d4.9\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.vl.e4.1\' | translate}}</div></li></ul><!-- Self-harm --><ul ng-if=\"ngDialogData.tabName==\'sh\' || ngDialogData.severity\" class=list-unstyled><li class=row ng-if=\"ngDialogData.tabName==\'sh\' || (ngDialogData.severity && ngDialogData.severity.sh == 0)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sh == 0)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.4\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.10\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sh == 0) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sh.d1\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sh.d1.1\' | translate}}</li><li>{{\'cm.acs.sh.d1.2\' | translate}}</li><li>{{\'cm.acs.sh.d1.3\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sh.e1.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'sh\' || (ngDialogData.severity && ngDialogData.severity.sh == 2)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sh == 2)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.4\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.11\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sh == 2) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sh.d2\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sh.d2.1\' | translate}}</li><li>{{\'cm.acs.sh.d2.2\' | translate}}</li><li>{{\'cm.acs.sh.d2.3\' | translate}}</li><li>{{\'cm.acs.sh.d2.4\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sh.e2.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'sh\' || (ngDialogData.severity && ngDialogData.severity.sh == 4)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sh == 4)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.4\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.12\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sh == 4) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sh.d3\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sh.d3.1\' | translate}}</li><li>{{\'cm.acs.sh.d3.2\' | translate}}</li><li>{{\'cm.acs.sh.d3.3\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sh.e3.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'sh\' || (ngDialogData.severity && ngDialogData.severity.sh == 6)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sh == 6)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.4\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.13\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sh == 6) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sh.d4\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sh.d4.1\' | translate}}</li><li>{{\'cm.acs.sh.d4.2\' | translate}}</li><li>{{\'cm.acs.sh.d4.3\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sh.e4.1\' | translate}}</div></li></ul><!-- Sexual --><ul ng-if=\"ngDialogData.tabName==\'sx\' || ngDialogData.severity\" class=list-unstyled><li class=row ng-if=\"ngDialogData.tabName==\'sx\' || (ngDialogData.severity && ngDialogData.severity.sx == 0)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sx == 0)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.5\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.10\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sx == 0) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sx.d1\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sx.d1.1\' | translate}}</li><li>{{\'cm.acs.sx.d1.2\' | translate}}</li><li>{{\'cm.acs.sx.d1.3\' | translate}}</li><li>{{\'cm.acs.sx.d1.4\' | translate}}</li><li>{{\'cm.acs.sx.d1.5\' | translate}}</li><li>{{\'cm.acs.sx.d1.6\' | translate}}</li><li>{{\'cm.acs.sx.d1.7\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\"><div>{{\'cm.acs.sx.e1.1\' | translate}}</div><br><div>{{\'cm.acs.sx.e1.2\' | translate}}</div></div></li><li class=row ng-if=\"ngDialogData.tabName==\'sx\' || (ngDialogData.severity && ngDialogData.severity.sx == 2)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sx == 2)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.5\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.11\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sx == 2) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sx.d2\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sx.d2.1\' | translate}}</li><li>{{\'cm.acs.sx.d2.2\' | translate}}</li><li>{{\'cm.acs.sx.d2.3\' | translate}}</li><li>{{\'cm.acs.sx.d2.4\' | translate}}</li><li>{{\'cm.acs.sx.d2.5\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sx.e2.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'sx\' || (ngDialogData.severity && ngDialogData.severity.sx == 4)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sx == 4)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.5\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.12\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sx == 4) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sx.d3\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sx.d3.1\' | translate}}</li><li>{{\'cm.acs.sx.d3.2\' | translate}}</li><li>{{\'cm.acs.sx.d3.3\' | translate}}</li><li>{{\'cm.acs.sx.d3.4\' | translate}}</li><li>{{\'cm.acs.sx.d3.5\' | translate}}</li><li>{{\'cm.acs.sx.d3.6\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sx.e3.1\' | translate}}</div></li><li class=row ng-if=\"ngDialogData.tabName==\'sx\' || (ngDialogData.severity && ngDialogData.severity.sx == 6)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.sx == 6)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.5\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.13\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.sx == 6) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.sx.d4\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.sx.d4.1\' | translate}}</li><li>{{\'cm.acs.sx.d4.2\' | translate}}</li><li>{{\'cm.acs.sx.d4.3\' | translate}}</li><li>{{\'cm.acs.sx.d4.4\' | translate}}</li><li>{{\'cm.acs.sx.d4.5\' | translate}}</li><li>{{\'cm.acs.sx.d4.6\' | translate}}</li><li>{{\'cm.acs.sx.d4.7\' | translate}}</li><li>{{\'cm.acs.sx.d4.8\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\">{{\'cm.acs.sx.e4.1\' | translate}}</div></li></ul><!-- Hate --><ul ng-if=\"ngDialogData.tabName==\'ht\' || ngDialogData.severity\" class=list-unstyled><li class=row ng-if=\"ngDialogData.tabName==\'ht\' || (ngDialogData.severity && ngDialogData.severity.ht == 0)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.ht == 0)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.6\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.10\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.ht == 0) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.ht.d1\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.ht.d1.1\' | translate}}</li><li>{{\'cm.acs.ht.d1.2\' | translate}}</li><li>{{\'cm.acs.ht.d1.3\' | translate}}</li><li>{{\'cm.acs.ht.d1.4\' | translate}}</li><li>{{\'cm.acs.ht.d1.5\' | translate}}</li><li>{{\'cm.acs.ht.d1.6\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\"><div class=marB10>{{\'cm.acs.ht.e1.1\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.ht.e1.1.1\' | translate}}</li></ul><br><div>{{\'cm.acs.ht.e1.2\' | translate}}</div></div></li><li class=row ng-if=\"ngDialogData.tabName==\'ht\' || (ngDialogData.severity && ngDialogData.severity.ht == 2)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.ht == 2)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.6\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.11\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.ht == 2) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.ht.d2\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.ht.d2.1\' | translate}}</li><li>{{\'cm.acs.ht.d2.2\' | translate}}</li><li>{{\'cm.acs.ht.d2.3\' | translate}}</li><li>{{\'cm.acs.ht.d2.4\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\"><div>{{\'cm.acs.ht.e2.1\' | translate}}</div><br><div>{{\'cm.acs.ht.e2.2\' | translate}}</div></div></li><li class=row ng-if=\"ngDialogData.tabName==\'ht\' || (ngDialogData.severity && ngDialogData.severity.ht == 4)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.ht == 4)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.6\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.12\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.ht == 4) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.ht.d3\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.ht.d3.1\' | translate}}</li><li>{{\'cm.acs.ht.d3.2\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\"><div>{{\'cm.acs.ht.e3.1\' | translate}}</div><br><div>{{\'cm.acs.ht.e3.2\' | translate}}</div></div></li><li class=row ng-if=\"ngDialogData.tabName==\'ht\' || (ngDialogData.severity && ngDialogData.severity.ht == 6)\"><div ng-if=\"(ngDialogData.severity && ngDialogData.severity.ht == 6)\" class=\"col-xs-2 word-break text-bold\">{{\'cm.acs.6\' | translate}}</div><div class=\"col-xs-2 word-break\">{{\'cm.acs.13\' | translate}}</div><div ng-class=\"(ngDialogData.severity && ngDialogData.severity.ht == 6) ? \'col-xs-4\' : \'col-xs-6\'\" class=word-break><div class=marB10>{{\'cm.acs.ht.d4\' | translate}}</div><ul class=list-disc><li>{{\'cm.acs.ht.d4.1\' | translate}}</li><li>{{\'cm.acs.ht.d4.2\' | translate}}</li><li>{{\'cm.acs.ht.d4.3\' | translate}}</li><li>{{\'cm.acs.ht.d4.4\' | translate}}</li><li>{{\'cm.acs.ht.d4.5\' | translate}}</li><li>{{\'cm.acs.ht.d4.6\' | translate}}</li></ul></div><div class=\"col-xs-4 word-break\"><div>{{\'cm.acs.ht.e4.1\' | translate}}</div><br><div>{{\'cm.acs.ht.e4.2\' | translate}}</div></div></li></ul></div></div></div></section>");
$templateCache.put("app/common/popup/logList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{logObj.info.module == \"Device\"?\'d.body.9\':\'\' | translate}} {{logObj.info.module == \"User\"?\'u.body.4\':\'\' | translate}}</h1><span class=\"text-sm marL5\" ng-if=\"logObj.info.label != \' \'\">[ <span class=\"text-ellipsis hTitle w-65\" uib-tooltip={{logObj.info.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{logObj.info.label}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link class=\"padR10 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=downloadLogOpen(); ng-hide=!logObj.logList.length ng-disabled=loading><span class=\"fa fa-download\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"pad5 marR5\" id=refresh uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-click=\"loadMoreLogs(\'refresh\');\" ng-disabled=\"loading || (!logLoading && logObj.logList.length <= 0)\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=logLoading><div class=\"scrollQuad table no-th\" ng-if=\"!logLoading && logObj.logList.length > 0\" when-scrolled=loadMoreLogs() ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"log in logObj.logList\"><div class=\"col-sm-8 col-lg-9 word-break\">{{log.data}}</div><div class=\"col-sm-4 col-lg-3 text-right text-ellipsis text-sm\">{{log.logDate}} {{log.logTime | uppercase}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!logLoading && logObj.logList.length <= 0\">{{\'cm.msg.1\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/openList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{openList.caller == \"mc\"?\'cl.widget.mc.3\':\'\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px ng-if=\"!popupLoading && openList.list.category.length\"><div class=row><div class=\"col-xs-6 word-break\" ng-repeat=\"list in openList.list.category\"><label class=text-unbold><input type=checkbox ng-model=list.isSelected role=checkbox><label></label>{{list.label}}</label></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=listPopFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/saveLinkAs.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.btn.17\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=linkOpenObj.loading><div ng-if=!linkOpenObj.loading class=text-center><div ng-if=\"!linkOpenObj.url && !linkOpenObj.surl\">{{\'r.msg.2\' | translate}}</div><div ng-if=\"linkOpenObj.url || linkOpenObj.surl\"><p translate=\"{{\'cm.body.11\'}}\" translate-values=\"{htmlTagO: \'<b>&quot;\', htmlTagC: \'&quot;</b>\'}\"></p><div class=row ng-if=linkOpenObj.surl><div class=\"col-xs-6 text-center\"><a href={{linkOpenObj.surl}} target=_blank download class=\"btn btn-link text-bold\"><span class=\"fa fa-download\"></span> {{\'cl.btn.19\' | translate}} <span ng-if=linkOpenObj.size>({{(linkOpenObj.size*1024) | filesize}})</span></a></div><div class=\"col-xs-6 text-center\"><a href={{linkOpenObj.url}} target=_blank download class=\"btn btn-link text-bold\"><span class=\"fa fa-download\"></span> {{\'cl.btn.20\' | translate}} <span ng-if=\"linkOpenObj.size || linkOpenObj.pSize\"><span ng-if=linkOpenObj.pSize>({{(linkOpenObj.pSize) | filesize}})</span> <span ng-if=!linkOpenObj.pSize>({{(linkOpenObj.size*1024) | filesize}})</span></span></a></div></div><div ng-if=!linkOpenObj.surl><a href=\"{{linkOpenObj.url | secureThumb}}\" download target=_blank class=\"btn btn-link text-lg\"><span class=\"fa fa-download\"></span> {{\'cm.btn.17\' | translate}} <span ng-if=linkOpenObj.size>({{(linkOpenObj.size*1024) | filesize}})</span></a></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/settings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.14\' | translate}}</h1><span class=\"text-sm marL5\">[ {{ngDialogData.label}} ]</span></header><div class=\"panel-body bg-muted\"><uib-tabset class=popup-tab><!-- Tab one Change Prime Admin --><uib-tab select=selectTabFx(1) ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><uib-tab-heading>{{\'ms.p_s.tab.1\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><div ng-if=\"primeObj.users.length > 0\"><div class=\"table table-scroll no-th scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(settingsObj.iotButton?365:300)}}px><div class=row ng-repeat=\"user in primeObj.users\"><div class=\"col-xs-12 primeUserImg\"><label class=\"btn-block text-unbold\"><span class=primeRadio><input type=radio role=radio name=userName ng-model=primeObj.info.prime ng-value=user.id ng-disabled=user.isInvited><label></label></span><img alt=\"\" ng-if=user.thumb ng-src=\"{{tim + bucket + user.thumb + profileSmParam + \'&\' + user.thumbV}}\" class=\"pull-left marR5\"> <span ng-if=\"user.label || user.label == \' \'\"><span class=\"profileIcon-sm pull-left\" ng-if=\"!user.thumb && user.label != \' \'\">{{user.label | limitTo:1}}</span> <span class=\"profileIcon-sm pull-left\" ng-if=\"!user.thumb && user.label == \' \'\">{{user.email | limitTo:1}}</span> <span class=pull-left ng-if=\"user.label != \' \'\">{{user.label}}</span> <span class=pull-left ng-if=\"user.label == \' \'\">{{user.email}}</span><br><span class=\"primeText text-muted text-sm\" ng-if=\"user.type == 1\">{{\'ms.p_s.prime.1\' | translate}}</span> <span class=\"primeText text-muted text-sm\" ng-if=\"user.type == 2\">{{\'ms.p_s.prime.2\' | translate}}</span> </span><span ng-if=\"user.label == null && user.email\"><span class=\"profileIcon-sm pull-left\" ng-if=!user.thumb>{{user.email | limitTo:1}}</span> <span class=pull-left>{{user.email}}</span><br><span class=\"primeText text-muted text-sm\">{{\'ms.p_s.prime.3\' | translate}}</span></span></label></div></div></div><label class=\"marT10 noMarB\"><input type=checkbox ng-model=primeObj.info.isNotify role=checkbox><label></label>{{\'ms.p_s.prime.4\' | translate}}</label></div><div ng-if=\"primeObj.users.length == 0\" class=msg-warning lang={{auth.lang}}>{{\'r.msg.1\' | translate}}</div></div></uib-tab><!-- Tab two Mail Notification --><uib-tab select=selectTabFx(2) ng-if=\"settingsObj.uType != 0\"><uib-tab-heading>{{\'ms.p_s.tab.2\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><uib-accordion close-others=true class=accordNotification><!-- Mail Notification --><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(settingsObj.iotButton?365:300)}}px><div uib-accordion-group ng-repeat=\"type in notifications\" is-open=$first><uib-accordion-heading ng-if=\"$index == 0\"><span class=\"fa fa-envelope marR5\" aria-hidden=true></span>{{\'ms.p_s.notifyS.2\' | translate}}</uib-accordion-heading><div class=marB5 ng-repeat=\"nft in type track by $index\" ng-if=\"$parent.$index == 0\" ng-class=\"{\'pull-left marL10\':(nft.id != 16.1 && nft.id != 19.1 && nft.id >= 16 && nft.id <= 21) || (nft.id != 24.1 && nft.id >= 24)}\"><div class=clearfix></div><label><input type=checkbox role=checkbox ng-model=nft.value ng-disabled=saveProcessing ng-if=\"nft.id != 16.1 && nft.id != 19.1 && nft.id != 24.1 && nft.id != 27\"><label></label><span ng-if=\"nft.id == 1\">{{\'ms.p_s.notifyS.2.1\' | translate}}</span> <span ng-if=\"nft.id == 2\">{{\'ms.p_s.notifyS.2.2\' | translate}}</span> <span ng-if=\"nft.id == 3\">{{\'ms.p_s.notifyS.2.3\' | translate}}</span> <span ng-if=\"nft.id == 4\">{{\'ms.p_s.notifyS.2.4\' | translate}}</span> <span ng-if=\"nft.id == 5\">{{\'ms.p_s.notifyS.2.5\' | translate}}</span> <span ng-if=\"nft.id == 6\">{{\'ms.p_s.notifyS.2.6\' | translate}}</span> <span ng-if=\"nft.id == 7\">{{\'ms.p_s.notifyS.2.7\' | translate}}</span> <span ng-if=\"nft.id == 8\">{{\'ms.p_s.notifyS.2.8\' | translate}}</span> <span ng-if=\"nft.id == 9\">{{\'ms.p_s.notifyS.2.9\' | translate}}</span> <span ng-if=\"nft.id == 10\">{{\'ms.p_s.notifyS.2.12\' | translate}}</span> <span ng-if=\"nft.id == 14\">{{\'ms.p_s.notifyS.2.10\' | translate}}</span> <span ng-if=\"nft.id == 15\">{{\'ms.p_s.notifyS.2.11\' | translate}}</span> <span ng-if=\"nft.id == 16.1\" class=text-bold>{{\'ms.p_s.notifyS.2.13\' | translate}}</span> <span ng-if=\"nft.id == 16\">{{\'ms.p_s.notifyS.2.13.1\' | translate}}</span> <span ng-if=\"nft.id == 17\">{{\'ms.p_s.notifyS.2.13.2\' | translate}}</span> <span ng-if=\"nft.id == 18\">{{\'ms.p_s.notifyS.2.13.3\' | translate}}</span> <span ng-if=\"nft.id == 19.1\" class=text-bold>{{\'ms.p_s.notifyS.2.14\' | translate}}</span> <span ng-if=\"nft.id == 19\">{{\'ms.p_s.notifyS.2.14.1\' | translate}}</span> <span ng-if=\"nft.id == 20\">{{\'ms.p_s.notifyS.2.13.2\' | translate}}</span> <span ng-if=\"nft.id == 21\">{{\'ms.p_s.notifyS.2.13.3\' | translate}}</span> <span ng-if=\"nft.id == 22\">{{\'ms.p_s.notifyS.2.15\' | translate}}</span> <span ng-if=\"nft.id == 23\">{{\'ms.p_s.notifyS.2.16\' | translate}}</span> <span ng-if=\"nft.id == 24.1\" class=text-bold>{{\'ms.p_s.notifyS.2.17\' | translate}}</span> <span ng-if=\"nft.id == 24\">{{\'ms.p_s.notifyS.2.17.1\' | translate}}</span> <span ng-if=\"nft.id == 25\">{{\'ms.p_s.notifyS.2.17.2\' | translate}}</span> <span ng-if=\"nft.id == 26\">{{\'ms.p_s.notifyS.2.17.3\' | translate}}</span> <span class=hide ng-if=\"nft.id == 27\">{{\'ms.p_s.notifyS.2.17.4\' | translate}}</span></label><div ng-if=\"nft.id == 15 && nft.value\" class=\"bg-light marL20 pad10\"><div class=row><div class=col-xs-6></div><div class=col-xs-6><div class=marB5><label class=noMarB><input type=checkbox ng-model=offline.isExcluded role=checkbox><label></label>{{\'ms.p_s.notifyS.2.11.1\' | translate}}</label></div></div><div class=clearfix></div><div class=col-xs-3><label>{{\'ms.p_s.notifyS.2.11.2\' | translate}} <span class=\"text-muted text-sm\">(Min 5 - Max 1440)</span></label><div class=input-group><input type=number class=form-control ng-model=offline.timeout min=5 max=1440><div class=input-group-addon>{{\'cm.label.28\' | translate}}</div></div></div><div class=col-xs-3><label>{{\'ms.p_s.notifyS.2.11.3\' | translate}}</label><div class=form-group><input type=number class=form-control ng-model=offline.threshold min=1></div></div><div class=\"col-xs-3 timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"offline.startTime | date:\'shortTime\'\" readonly ng-disabled=!offline.isExcluded aria-label=startTime aria-labelledby=startTime></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=offline.startTime hour-step=1 minute-step=5></div></div></span></div><div class=\"col-xs-3 timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"offline.endTime | date:\'shortTime\'\" readonly ng-disabled=!offline.isExcluded aria-label=endTime aria-labelledby=endTime></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=offline.endTime hour-step=1 minute-step=5></div></div></span></div></div></div></div><div class=marB5 ng-if=\"$index != 0\">This feature will be available soon.</div></div></div></uib-accordion><div class=\"bg-light pad10\" ng-if=\"settingsObj.sid == 101\"><div class=form-group><label>Offline mail setting</label><p>Send email to following ids when device is offline for <input type=number class=\"form-control input-sm\" style=width:100px;display:inline-block ng-model=notify.offlineTimeout min=5 max=600> minutes.</p><label>Email <span class=\"text-muted text-sm\">(one per line)</span></label><textarea class=form-control ng-model=notify.email></textarea></div><div class=\"form-group noMarB\"><label><input type=checkbox ng-model=notify.exclude role=checkbox><label></label>Exclude time range:</label><div><div class=\"timepicker pull-left\" style=width:47%><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"notify.excludeST | date:\'shortTime\'\" placeholder=HH:mm readonly ng-disabled=!notify.exclude aria-label=excludeST aria-labelledby=excludeST></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=notify.excludeST hour-step=1 minute-step=5></div></div></span></div><div class=\"text-center pull-left\" style=width:6%;padding-top:7px>to</div><div class=\"timepicker pull-right\" style=width:47%><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"notify.excludeET | date:\'shortTime\'\" placeholder=HH:mm readonly ng-disabled=!notify.exclude aria-label=excludeET aria-labelledby=excludeET></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=notify.excludeET hour-step=1 minute-step=5></div></div></span></div></div><div class=clearfix></div></div></div></div></uib-tab><!-- Tab four Adapters List --><uib-tab select=selectTabFx(4) ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><uib-tab-heading>{{\'ms.p_s.tab.4\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div class=text-center ng-if=\"!settingLoading && adapters\"><p translate=\"{{\'cm.body.11\'}}\" translate-values=\"{htmlTagO: \'<b>&quot;\', htmlTagC: \'&quot;</b>\'}\"></p><a href={{adapters.download}} role=link target=_blank download class=\"btn btn-link text-lg\"><span class=\"fa fa-download\" aria-hidden=true></span> {{\'cm.btn.17\' | translate}}</a></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!settingLoading && !adapters\">{{\'r.msg.1\' | translate}}</div></uib-tab><!-- Tab five default image --><uib-tab select=selectTabFx(5) ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2 || settingsObj.uType == 3\"><uib-tab-heading>{{\'ms.p_s.tab.5\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><h5 class=\"panel-inner-tab marB10\">{{\'ms.p_s.defaultImg.1\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'ms.p_s.defaultImg.3\' | translate}}\" tooltip-placement=right aria-hidden=true></span></h5><div class=row><div class=col-xs-4><div class=diThumbQuad ng-class=\"{\'hide\':!defaultImg.default.label}\" ng-if=defaultImg.default><img alt=\"\" id=default ng-class=\"{\'diCurImg bdr pad2\':defaultImg.default.curImg}\"> <a ng-href=\"{{detailBucket + defaultImg.default.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{defaultImg.default.label}} ng-show=defaultImg.default.thumb><img alt=\"\" ng-src=\"{{defaultImg.info.timthumb + bucket + defaultImg.default.thumb + thumbParam}}\" class=\"bdr pad2\"> </a><a href=\"\" role=link class=\"diDeleteBtn text-danger marL10\" ng-if=!defaultImg.default.uploading ng-click=\"deleteConfirmFx(\'default\');\">{{\'cm.btn.13\' | translate}}</a> <span class=\"diUploading marL10\" ng-if=defaultImg.default.uploading>{{\'cm.btn.16i\' | translate}}<img alt=Loading src=assets/images/loading-xs.gif class=marL5></span><div class=clearfix></div></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file id=fileDefault file-model=curFileDete options=\"{size:2147482548, format:[\'imgOnly\'], callback:true, value:\'default\'}\" accept=image/* ng-disabled=\"defaultImg.default.uploading || saveProcessing\" aria-label=\"\" aria-labelledby=\"\"> <input type=text class=form-control ng-value=defaultImg.default.label readonly aria-label=defaultLabel aria-labelledby=defaultLabel></div></div></div><h5 class=\"panel-inner-tab marT25 marB10\" ng-if=\"defaultImg.resolutions.length > 0\">{{\'ms.p_s.defaultImg.2\' | translate}}:</h5><div class=\"row scrollQuad\" style=max-height:{{getAvailableHeight(settingsObj.iotButton?515:450)}}px><div class=col-xs-4><div class=form-group ng-if=\"defaultImg.resolutions.length > 0\"><ul class=list-unstyled><li class=form-group ng-repeat=\"res in defaultImg.resolutions\"><label>{{res.res}}</label><div class=diThumbQuad ng-class=\"{\'hide\':!res.label}\"><img alt=\"\" id={{res.res}} ng-class=\"{\'diCurImg bdr pad2\':res.curImg}\"> <a class=diUploadedThumb role=button ng-href=\"{{detailBucket + res.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{res.label}} ng-if=res.thumb><img alt=\"\" ng-src=\"{{defaultImg.info.timthumb + bucket + res.thumb + thumbParam}}\" class=\"bdr pad2\"> </a><a href=\"\" role=link class=\"diDeleteBtn text-danger marL10\" ng-if=!res.uploading ng-click=deleteConfirmFx(res.res);>{{\'cm.btn.13\' | translate}}</a> <span class=\"diUploading marL10\" ng-if=res.uploading>{{\'cm.btn.16i\' | translate}}<img alt=Loading src=assets/images/loading-xs.gif class=marL5></span><div class=clearfix></div></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file id=file{{res.res}} file-model=curFileDete options=\"{size:2147482548, format:[\'imgOnly\'], callback:true, value:\'{{res.res}}\'}\" accept=image/* ng-disabled=\"res.uploading || saveProcessing\" aria-label=curFileDete aria-labelledby=curFileDete> <input type=text class=form-control ng-value=res.label readonly aria-label=resLabel aria-labelledby=resLabel></div></li></ul></div></div></div></div></uib-tab><!-- Tab Six Allowed File Types --><uib-tab select=selectTabFx(6) ng-if=\"settingsObj.uType == 0 || settingsObj.uType == 1 || settingsObj.uType == 2\"><uib-tab-heading>{{\'ms.p_s.tab.6\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div class=allowedFilesQuad ng-if=!settingLoading><div ng-class=\"{\'marB10\':!$last}\" ng-repeat=\"extGrp in allowedFiles\"><h5 class=\"panel-inner-tab marB10\"><label class=noMarB><input type=checkbox role=checkbox ng-model=extGrp.selected ng-change=\"selectEntity(\'all\', $index);\"><label></label><span ng-if=\"extGrp.label==\'img\'\">{{\'cm.label.37\' | translate}}</span> <span ng-if=\"extGrp.label==\'vid\'\">{{\'cm.label.38\' | translate}}</span> <span ng-if=\"extGrp.label==\'aud\'\">{{\'cm.label.39\' | translate}}</span> <span ng-if=\"extGrp.label==\'ot\'\">{{\'cm.label.40\' | translate}}</span></label></h5><ul class=list-inline><li ng-repeat=\"ext in extGrp.ext\"><label class=text-unbold><input type=checkbox role=checkbox ng-model=ext.selected ng-change=selectEntity();><label></label>{{ext.type}}</label></li><div class=spaceH></div></ul></div></div></uib-tab><!-- Tab seven server permissions List --><uib-tab select=selectTabFx(7) ng-if=\"settingsObj.uType == 0 || settingsObj.scType == \'2\'\"><uib-tab-heading>{{\'ms.p_s.tab.7\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading class=\"accordNotification scrollQuad\" style=max-height:{{getAvailableHeight(settingsObj.iotButton?315:250)}}px><div class=\"bg-muted pad5\"><label class=\"text-md noMarB\">{{\'ms.p_s.serverPer.h1\' | translate}}</label></div><div class=\"padL10 marT5\"><label class=text-md><input type=checkbox role=checkbox ng-model=server.reports.r ng-change=\"reportsFx(\'r\');\"><label></label>{{\'ms.p_s.serverPer.1\' | translate | capitalize}}</label><span class=\"marL5 marR5\" ng-if=server.reports.r>|</span><label class=text-unbold ng-if=server.reports.r ng-class=\"{\'text-muted\':!server.reports.r && !server.reports.pp && !server.reports.ds && !server.reports.cs && !server.reports.op && !server.reports.od && !server.reports.cc && !server.reports.ir && !server.reports.hg && !server.reports.dst && !server.reports.poh && !server.reports.ci}\"><input type=checkbox ng-model=server.reports.rs ng-change=\"reportsFx(\'rs\');\" ng-disabled=\"!server.reports.r && !server.reports.pp && !server.reports.ds && !server.reports.cs && !server.reports.op && !server.reports.od && !server.reports.cc && !server.reports.ir && !server.reports.hg && !server.reports.dst && !server.reports.poh && !server.reports.ci\"><label></label>{{\'b.tab.1\' | translate | capitalize}}</label><div class=\"row padL10\" ng-if=server.reports.r><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.cc ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.1.1\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.cs ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.1.2\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.pp ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.1.3\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.ds ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.1\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.hg ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.2\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.ir ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.5\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.od ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.3\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.op ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.4\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.dst ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.6\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.poh ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.2.7\' | translate | capitalize}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.reports.ci ng-change=reportsFx(); role=checkbox><label></label>{{\'r.tab.7\' | translate | capitalize}}</label></div><div class=\"col-xs-12 marT5 marB10 padR20\"><h5 class=\"panel-inner-tab marB10 ng-binding\">{{\'cm.label.14\' | translate}}</h5><div><label><input type=checkbox ng-model=server.si role=checkbox><label></label>{{\'ms.p_s.serverPer.27\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.dsg role=checkbox><label></label>{{\'ms.p_s.serverPer.28\' | translate}}</label></div></div></div><div><label><input type=checkbox ng-model=server.em role=checkbox><label></label>{{\'cm.menu.7\' | translate}}</label><div class=padL10 ng-if=server.em ng-class=\"{\'disabled\':!server.em}\"><label class=text-unbold><input type=checkbox ng-model=server.iothub ng-disabled=!server.em role=checkbox><label></label>{{\'ms.p_s.serverPer.22\' | translate}}</label></div></div><div><label><input type=checkbox ng-model=server.t ng-disabled=\"server.templateExist && server.t\" role=checkbox><label></label>{{\'cm.menu.2\' | translate}}</label><span class=\"text-sm text-muted marL5 word-break\" ng-if=\"server.templateExist && server.t\">({{\'ms.p_s.serverPer.m3\' | translate}})</span></div><div><label><input type=checkbox ng-model=server.tl role=checkbox><label></label>{{\'fl.p_cfl.label.25\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.bp role=checkbox><label></label>{{\'ms.p_s.serverPer.21\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.inven role=checkbox><label></label>{{\'cm.menu.11\' | translate}}</label></div></div><div class=\"bg-muted pad5 marT10\"><label class=\"text-md noMarB\">{{\'ms.p_s.serverPer.h2\' | translate}}</label></div><div class=\"padL10 marT5\"><div><label><input type=checkbox ng-model=server.dmb role=checkbox><label></label>{{\'cm.dmb.1\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=dmbPopOpen(); uib-tooltip=\"{{\'cm.dmb.2\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.dmb aria-hidden=true></span></a></div><div><label><input type=checkbox ng-model=server.mssp role=checkbox><label></label>{{\'cl.p_f.14\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.msod role=checkbox><label></label>{{\'cl.p_f.15\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.ss role=checkbox><label></label>{{\'d.tab.5\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.mic role=checkbox><label></label>{{\'ms.p_s.serverPer.19\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.hfr role=checkbox><label></label>{{\'ms.p_s.serverPer.18\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.sffl role=checkbox><label></label>{{\'ms.p_s.serverPer.20\' | translate}}</label></div><div><label class=text-md><input type=checkbox ng-model=server.iotcentral role=checkbox><label></label>{{\'ms.p_s.serverPer.25\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=iotCPopOpen(); uib-tooltip=\"{{\'p_iotC.1\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.iotcentral aria-hidden=true></span></a></div><div><label class=\"text-md noMar\"><label><input type=checkbox ng-model=server.sso.sso role=checkbox><label></label>SSO</label></label><div class=padL20 ng-if=server.sso.sso role=radiogroup aria-labelledby=radiogroup><label class=text-unbold for=azure ng-class=\"{\'disabled\':!server.sso.sso}\"><input type=radio role=radio id=azure name=ssoOpt ng-model=server.sso.type value=azure ng-disabled=!server.sso.sso><label></label>Microsoft Azure</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'a\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.11\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=\"server.sso.sso && server.sso.type == \'azure\'\" aria-hidden=true></span></a><label class=\"text-unbold marL10\" for=okta ng-class=\"{\'disabled\':!server.sso.sso}\"><input type=radio role=radio id=okta name=ssoOpt ng-model=server.sso.type value=okta ng-disabled=!server.sso.sso><label></label>Okta</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'o\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.12\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=\"server.sso.sso && server.sso.type == \'okta\'\" aria-hidden=true></span></a><label class=\"text-unbold marL10\" for=idaptive><input type=radio role=radio id=idaptive name=ssoOpt ng-model=server.sso.type value=idaptive ng-disabled=!server.sso.sso><label></label>Idaptive</label><a href=\"\" role=link class=marL5 ng-click=\"ssoPopOpen(\'i\');\" uib-tooltip=\"{{\'ms.p_s.serverPer.32\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=\"server.sso.sso && server.sso.type == \'idaptive\'\" aria-hidden=true></span></a></div></div><div class=form-inline><label><input type=checkbox ng-model=server.subdomain.isActive role=checkbox><label></label>{{\'ms.p_s.serverPer.35\' | translate}}</label><input type=text class=\"form-control input-sm marL10\" ng-model=server.subdomain.domain ng-if=server.subdomain.isActive aria-label=subdomainDomain aria-labelledby=subdomainDomain></div><div><label><input type=checkbox ng-model=server.fl role=checkbox><label></label>{{\'ms.p_s.serverPer.3\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.odn role=checkbox><label></label>{{\'ms.p_s.serverPer.30\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=offlineOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=server.odn><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div><label><input type=checkbox ng-model=server.bpa.isActive role=checkbox><label></label>{{\'ms.p_s.serverPer.33\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=bigPandaOpen(); uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=server.bpa.isActive><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div><label><input type=checkbox ng-model=server.log role=checkbox><label></label>{{\'ms.p_s.serverPer.2\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.logSE.checked role=checkbox><label></label>{{\'ms.p_s.serverPer.7\' | translate}}</label></div><div class=\"row padLR20\" ng-if=server.logSE.checked><div class=msg-warning lang={{auth.lang}} ng-if=\"server.logSE.checked && server.logSE.list.length == 0\">{{\'r.msg.1\' | translate}}</div><div class=col-xs-4 ng-if=!tabLoading ng-repeat=\"coordinator in server.logSE.list\"><label class=text-unbold><input type=checkbox ng-model=coordinator.selected ng-disabled=!server.logSE.checked role=checkbox><label></label>{{coordinator.label}}</label></div></div><div><label class=text-md>{{\'ms.p_s.serverPer.8\' | translate}}</label><div class=padL20 role=radiogroup aria-labelledby=radiogroup><label class=text-unbold><input type=radio role=radio name=mapOpt ng-model=server.m value=b><label></label>{{\'ms.p_s.serverPer.8.2\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio role=radio name=mapOpt ng-model=server.m value=g><label></label>{{\'ms.p_s.serverPer.8.1\' | translate}} <a href=https://support.lsquared.com/kb/1640759321-pricing-for-google-map.xlsx role=link target=_blank class=btn-link>($$)</a></label></div></div><div><label class=text-md>{{\'ms.p_s.serverPer.24\' | translate}}</label><div class=padL20 role=radiogroup aria-labelledby=radiogroup><label class=text-unbold><input type=radio role=radio name=mcsOpt ng-model=server.mcs value=zencoder><label></label>{{\'ms.p_s.serverPer.24.1\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio role=radio name=mcsOpt ng-model=server.mcs value=ec2><label></label>{{\'ms.p_s.serverPer.24.2\' | translate}}</label></div></div><div><label class=text-md>{{\'ms.p_s.serverPer.26\' | translate}}</label><div class=\"row padL20\"><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.db role=checkbox><label></label>{{\'cl.p_c.10\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.ftp role=checkbox><label></label>{{\'cl.p_c.12\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.gd role=checkbox><label></label>{{\'cl.p_c.11\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.ig role=checkbox><label></label>{{\'cl.widget.instagram.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.tw role=checkbox><label></label>{{\'cl.widget.twitter.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tpu.url role=checkbox><label></label>{{\'cl.widget.cm.10\' | translate}}</label></div></div></div><div><label class=text-md>{{\'ms.p_s.serverPer.36\' | translate}}</label><div class=padL20 role=radiogroup aria-labelledby=radiogroup><label class=text-unbold><input type=radio role=radio name=spOpt ng-model=server.sp value=h><label></label>{{\'ms.p_s.serverPer.36.1\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio role=radio name=spOpt ng-model=server.sp value=l><label></label>{{\'ms.p_s.serverPer.36.2\' | translate}}</label></div><label class=text-md>{{\'ms.p_s.serverPer.38\' | translate}}</label><span class=\"text-sm text-muted marL5\">({{\'cm.label.28s\' | translate | lowercase}})</span><div class=row><div class=\"col-xs-2 marL20 marT2\"><div class=\"form-group noMarB\"><input type=number min=20 ng-model=server.cst class=\"form-control input-sm\"></div></div></div></div><div class=marT5><label class=text-md>{{\'ms.p_am.1\' | translate}}</label><div class=row><div class=\"col-xs-3 marL20 form-group\"><label>{{\'ms.p_am.2\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=server.iTime maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=serveriTime aria-labelledby=serveriTime> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div><div class=\"col-xs-3 form-group\"><label>{{\'lock.1\' | translate}}</label><input type=text class=form-control ng-model=server.pass maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=serverPass aria-labelledby=serverPass></div><div class=col-xs-2><label>&nbsp;</label><button type=button role=button class=\"btn btn-default btn-sm marT2\" ng-click=appMenuFx();><span ng-class=\"appMenuProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'ms.p_am.3\' | translate}}</button></div></div></div><div class=hide><label><input type=checkbox ng-model=server.cs role=checkbox><label></label>{{\'cm.menu.9\' | translate}} (L&nbsp;Squared Marketplace)</label></div></div><!-- Widgets --><div class=marT10><div class=\"bg-muted pad5\"><label class=\"text-md noMarB\">{{\'cl.tool.8s\' | translate}}</label></div><!-- Public widgets --><div class=\"row padLR20 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cm.label.19\' | translate}}</h5><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.blank role=checkbox><label></label>{{\'cl.widget.bk.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.count role=checkbox><label></label>{{\'cl.widget.count.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.dateTime role=checkbox><label></label>{{\'cl.widget.dt.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.excelSheet role=checkbox><label></label>{{\'cl.widget.es.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.facebook role=checkbox><label></label>{{\'cl.widget.fb.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.facebookworkplace role=checkbox><label></label>{{\'cl.widget.fwp.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.fsChrome role=checkbox><label></label>{{\'cl.widget.fsc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.gSlide role=checkbox><label></label>{{\'cl.widget.gs.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.iFrame role=checkbox><label></label>{{\'cl.widget.iFrame.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.instagram role=checkbox><label></label>{{\'cl.widget.instagram.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.linkedIn role=checkbox><label></label>{{\'cl.widget.in.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.meeting role=checkbox><label></label>{{\'cl.widget.meeting.1\' | translate}}</label><a href=\"\" role=link class=\"marL5 hide\" ng-click=meetingPopOpen(); uib-tooltip=\"{{\'cl.widget.meeting.17\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" aria-hidden=true ng-if=server.widgets.meeting></span></a><div class=marL20 ng-if=server.widgets.meeting><label class=text-unbold ng-class=\"{\'text-muted\':!server.widgets.meeting}\"><input type=checkbox ng-model=server.widgets.meetingGT ng-disabled=!server.widgets.meeting role=checkbox><label></label>{{\'cl.widget.meeting.25\' | translate}}</label></div></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.message role=checkbox><label></label>{{\'cl.widget.message.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.news role=checkbox><label></label>{{\'cl.widget.news.1\' | translate}}</label><span class=\"marL5 marR5\">|</span><label class=text-unbold ng-class=\"{\'text-muted\':!server.widgets.news}\"><input type=checkbox ng-model=server.widgets.newsCrawl ng-disabled=!server.widgets.news role=checkbox><label></label>{{\'ms.p_s.serverPer.6\' | translate | capitalize}} {{\'cl.widget.news.1\' | translate | camelCase}}</label><div class=marL20 ng-if=server.widgets.news><label class=text-unbold ng-class=\"{\'text-muted\':!server.widgets.news}\"><input type=checkbox ng-model=server.widgets.newsB ng-disabled=!server.widgets.news role=checkbox><label></label>{{\'cl.widget.news.7\' | translate}}</label></div></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.nextVehicle role=checkbox><label></label>{{\'cl.widget.nv.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.onlineRadio role=checkbox><label></label>{{\'cl.widget.or.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.openHours role=checkbox><label></label>{{\'cl.widget.oh.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.queue role=checkbox><label></label>{{\'cl.widget.queue.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.quotes role=checkbox><label></label>{{\'cl.widget.quotes.1s\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.qrCode role=checkbox><label></label>{{\'cl.widget.qr.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.rssFeed role=checkbox><label></label>{{\'cl.widget.rss.1\' | translate | camelCase}}</label><span class=\"marL5 marR5\">|</span><label class=text-unbold ng-class=\"{\'text-muted\':!server.widgets.rssFeed}\"><input type=checkbox ng-model=server.widgets.rssFeedCrawl ng-disabled=!server.widgets.rssFeed role=checkbox><label></label>{{\'ms.p_s.serverPer.6\' | translate | capitalize}} {{\'cl.widget.rss.1\' | translate | camelCase}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.stockPrice role=checkbox><label></label>{{\'cl.widget.sp.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.text role=checkbox><label></label>{{\'cl.widget.text.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.traffic role=checkbox><label></label>{{\'cl.widget.traffic.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.twitter role=checkbox><label></label>{{\'cl.widget.twitter.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.vimeo role=checkbox><label></label>{{\'cl.widget.vimeo.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.weather role=checkbox><label></label>{{\'cl.widget.weather.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.webCam role=checkbox><label></label>{{\'cl.widget.wc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.webPage role=checkbox><label></label>{{\'cl.widget.wp.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.youtube role=checkbox><label></label>{{\'cl.widget.youTube.1\' | translate}}</label></div></div><!-- Premium widgets --><div class=\"row padLR20\"><h5 class=\"panel-inner-tab marTB10\">{{\'ms.p_s.serverPer.4\' | translate}}</h5><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.alertMsg role=checkbox><label></label>{{\'cl.widget.alert.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.calendarOfEvents role=checkbox><label></label>{{\'cl.widget.coe.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.cloudCoverMusic role=checkbox><label></label>{{\'cl.widget.ccm.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.contentGroup role=checkbox><label></label>{{\'cl.widget.cg.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.contentOnDemand role=checkbox><label></label>{{\'cl.widget.cod.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.delimitedText role=checkbox><label></label>{{\'cl.widget.dText.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.externalInput role=checkbox><label></label>{{\'cl.widget.ei.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.fifa role=checkbox><label></label>FIFA World Cup</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.fillerContent role=checkbox><label></label>{{\'cl.widget.fc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.flightSchedule role=checkbox><label></label>{{\'cl.widget.fs.1\' | translate}} <span class=text-muted>(Toronto YYZ and Montréal YUL only)</span></label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.gCalendar role=checkbox><label></label>{{\'cl.widget.gc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.hdSteth role=checkbox><label></label>{{\'cl.widget.steth.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.liveStreaming role=checkbox><label></label>{{\'cl.widget.ls.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.msTeams role=checkbox><label></label>{{\'cl.widget.msTeams.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.jukebox role=checkbox><label></label>{{\'cl.widget.mc.1\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"listPopOpen(\'mc\');\" uib-tooltip=\"{{\'cl.widget.mc.3\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.widgets.jukebox aria-hidden=true></span></a></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.iMenu role=checkbox><label></label>{{\'cl.widget.iMenu.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.iotButton role=checkbox><label></label>{{\'cl.widget.iot.1\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=iotBtnPopOpen(); uib-tooltip=\"{{\'ms.p_s.serverPer.39\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.widgets.iotButton aria-hidden=true></span></a></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.outlookCalendar role=checkbox><label></label>{{\'cl.widget.oc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.powerBI role=checkbox><label></label>{{\'cl.widget.pBI.1\' | translate}}</label><div class=marL20 ng-if=server.widgets.powerBI role=radiogroup aria-labelledby=radiogroup><label class=\"text-unbold marR10\"><input type=radio role=radio name=pBIOpt value=la ng-model=server.widgets.powerBIApp><label></label>{{\'cl.widget.pBI.12\' | translate}}</label><label class=text-unbold><input type=radio role=radio name=pBIOpt value=ca ng-model=server.widgets.powerBIApp><label></label>{{\'cl.widget.pBI.13\' | translate}}</label></div></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.scheduleCalendar role=checkbox><label></label>{{\'cl.widget.sc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.slack role=checkbox><label></label>{{\'cl.widget.slack.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.survey role=checkbox><label></label>{{\'cl.widget.survey.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.touchlinkMeetings role=checkbox><label></label>{{\'cl.widget.tl.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.trainingMode role=checkbox><label></label>{{\'cl.widget.tm.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.webLogin role=checkbox><label></label>{{\'cl.widget.wl.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.xovis role=checkbox><label></label>{{\'cl.widget.xovis.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.yammer role=checkbox><label></label>{{\'cl.widget.yammer.1\' | translate}}</label></div></div><!-- Private widgets --><div class=\"row padLR20\"><h5 class=\"panel-inner-tab marTB10\">{{\'ms.p_s.serverPer.5\' | translate}}</h5><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.agc role=checkbox><label></label>{{\'cl.widget.agc.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.f45 role=checkbox><label></label>{{\'cl.widget.wf45.16\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=f45Open(); uib-tooltip=\"{{\'cl.widget.wf45.16.6\' | translate}}\" tooltip-popup-delay=500 ng-if=server.widgets.f45><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.patientWait role=checkbox><label></label>{{\'cl.widget.pw.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.telax role=checkbox><label></label>{{\'cl.widget.telax.1\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=telexPopOpen(); uib-tooltip=\"{{\'cl.widget.telax.8\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.widgets.telax aria-hidden=true></span></a></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.tsccm role=checkbox><label></label>{{\'cl.widget.tsccm.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.unisys role=checkbox><label></label>{{\'cl.widget.unisys.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.waitQueueMetro role=checkbox><label></label>{{\'cl.widget.wqMetro.1\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.widgets.webLoginChrome role=checkbox><label></label>{{\'cl.widget.wl.1.1\' | translate}}</label></div></div></div><!-- Device --><div class=spaceH2></div><div class=marTB10><div class=\"bg-muted pad5\"><label class=\"text-md noMarB\">{{\'cm.label.4\' | translate}}</label></div><div class=\"row padL10 marT5\"><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.gf role=checkbox><label></label>{{\'d.label.1.2\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.mc role=checkbox><label></label>{{\'d.label.1.4\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.webos role=checkbox><label></label>{{\'d.label.1.5\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=webOSPopOpen(); uib-tooltip=\"{{\'d.p_dc.13\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.webos aria-hidden=true></span></a></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.tizen role=checkbox><label></label>{{\'d.label.1.6\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.vd role=checkbox><label></label>{{\'d.label.1.3\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold><input type=checkbox ng-model=server.desktop role=checkbox><label></label>{{\'d.label.1.7\' | translate}}</label></div><div class=col-xs-6><label class=text-unbold ng-click=server.epd><input type=checkbox ng-model=server.epd role=checkbox><label></label>{{\'d.label.1.8\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=epdOpenFx(); uib-tooltip=\"{{\'d.p_dc.18\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-cog\" ng-if=server.epd aria-hidden=true></span></a></div><div class=\"col-xs-12 marT10 padR20\"><h5 class=\"panel-inner-tab marB10 ng-binding\">{{\'cm.label.14\' | translate}}</h5><div><label><input type=checkbox ng-model=server.gbdt role=checkbox><label></label>{{\'ms.p_s.serverPer.23\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.dsoi role=checkbox><label></label>{{\'ms.p_s.serverPer.29\' | translate}}</label></div><!-- Device Pagination --><div><label><input type=checkbox ng-model=server.dp role=checkbox><label></label>{{\'ms.p_s.serverPer.37\' | translate}}</label></div></div><div class=\"col-xs-12 marT10 padR20\"><h5 class=\"panel-inner-tab marB10 ng-binding\">{{\'ms.p_s.serverPer.31\' | translate}}</h5><div><label><input type=checkbox ng-model=server.da.sir role=checkbox><label></label>{{\'d.tab.6.1\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.is role=checkbox><label></label>{{\'d.tab.6.2\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.oi role=checkbox><label></label>{{\'d.tab.6.3\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.ti role=checkbox><label></label>{{\'d.tab.6.5\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.dp role=checkbox><label></label>{{\'d.tab.6.8\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.ar role=checkbox><label></label>{{\'d.tab.6.6\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.dt role=checkbox><label></label>{{\'d.tab.9\' | translate}}</label></div><div><label><input type=checkbox ng-model=server.da.du role=checkbox><label></label>{{\'d.tab.10\' | translate}}</label></div></div></div></div><!-- Dashboard --><div class=spaceH2></div><div class=marTB10><div class=\"bg-muted pad5\"><label class=\"text-md noMarB\">{{\'cm.menu.0\' | translate}}</label></div><div class=\"row padL10 marT5\"><div class=col-xs-6><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ccl role=checkbox><label></label>{{\'ms.label.35.11\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ccs role=checkbox><label></label>{{\'ms.label.35.10\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.c role=checkbox><label></label>{{\'ms.label.35.2\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dp role=checkbox><label></label>{{\'d.btn.11\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.d role=checkbox><label></label>{{\'ms.label.35.6\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dom role=checkbox><label></label>{{\'ms.label.35.7\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dps role=checkbox><label></label>{{\'ms.label.35.9\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ds role=checkbox><label></label>{{\'ms.label.35.1\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dts role=checkbox><label></label>{{\'ms.label.35.8\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dpts role=checkbox><label></label>{{\'ms.label.35.18\' | translate}}</label></div></div><div class=col-xs-6><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dtpl role=checkbox><label></label>{{\'ms.label.35.16\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dtps\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=server.dashboard.dtpl><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.dtps role=checkbox><label></label>{{\'ms.label.35.12\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'dtps\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=server.dashboard.dtps><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ot role=checkbox><label></label>{{\'ms.label.35.15\' | translate}}</label><a href=\"\" role=link class=marL5 ng-click=\"dsOpen(\'ot\');\" uib-tooltip=\"{{\'cm.label.14\' | translate}}\" tooltip-popup-delay=500 ng-if=server.dashboard.ot><span class=\"fa fa-cog\" aria-hidden=true></span></a></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ral role=checkbox><label></label>{{\'ms.label.35.5\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.rad role=checkbox><label></label>{{\'ms.label.35.14\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.sc role=checkbox><label></label>{{\'ms.label.35.3\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ssdt role=checkbox><label></label>{{\'ms.label.35.13\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ssodt role=checkbox><label></label>{{\'ms.label.35.17\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.ssdpt role=checkbox><label></label>{{\'ms.label.35.19\' | translate}}</label></div><div><label class=text-unbold><input type=checkbox ng-model=server.dashboard.us role=checkbox><label></label>{{\'ms.label.35.4\' | translate}}</label></div></div></div></div></div></uib-tab><!-- Tab eight server dynamic menu board --><uib-tab select=selectTabFx(8) ng-if=\"settingsObj.uType == 2 && settingsObj.isDmb\"><uib-tab-heading>{{\'cm.dmb.1\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading class=\"accordNotification scrollQuad\" style=max-height:{{getAvailableHeight(250)}}px><section class=marT10><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':dmbTab==\'1\'}\" ng-click=dmbTabFx(1);>{{\'cm.dmb.3\' | translate}}</a></header><div class=\"panel-body marT15\"><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><div class=\"row marT10\" ng-if=\"dmbTab == 1\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.3.2\' | translate}}<div class=\"panel-tools marT-5 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.brands.length > 0\"><input type=text class=\"form-control input-sm\" ng-model=searchBrandTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchBrandTxt.length ng-click=\"searchBrandTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.brands.length > 0\"><div class=\"row th\"><div class=col-xs-4>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-8>{{\'cl.widget.cm.10\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=\"row word-break\" ng-repeat=\"brand in dmbSettings.brands | filter:searchBrandTxt\"><div class=col-xs-4>{{brand.label}}</div><div class=col-xs-8><a href={{curUrl}}/mb/#/{{brand.url}} role=link target=_blank>{{curUrl}}/mb/#/{{brand.url}}</a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.brands | filter:searchBrandTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchBrandTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.brands.length == 0\">{{\'cm.dmb.m4\' | translate}}</div></div></div><div ng-if=\"dmbTab == 2\"><div class=\"bg-light pad10\"><div class=row><div class=col-xs-2><div class=\"form-group noMarB\"><label>{{\'cm.brief.1\' | translate}}</label><input type=text class=form-control ng-model=dmbNewUser.name aria-label=dmbNewUserName aria-labelledby=dmbNewUserName></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label>{{\'cm.label.47\' | translate}}</label><input type=email class=form-control ng-model=dmbNewUser.email aria-label=dmbNewUserEmail aria-labelledby=dmbNewUserEmail></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label>{{\'cl.p_f.7\' | translate}}</label><input type=password class=form-control ng-model=dmbNewUser.pwd aria-label=dmbNewUserPwd aria-labelledby=dmbNewUserPwd></div></div><div class=col-xs-2><div class=\"form-group noMarB\"><label>{{\'cm.dmb.3\' | translate}}</label><select class=form-control ng-options=\"brand.label for brand in dmbSettings.brands track by brand.id\" ng-model=dmbNewUser.brand aria-label=dmbNewUserBrand aria-labelledby=dmbNewUserBrand><option value=\"\" disabled>{{\'cm.dmb.3.1\' | translate}}</option></select></div></div><div ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-3\'\"><div class=\"form-group noMarB\"><label>{{\'cm.label.4s\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>{{curDSelected = (devices.devices | filter:{selected:true}); \"\"}} <span ng-if=!curDSelected.length>{{\'cm.label.31\' | translate}}</span> <span ng-repeat=\"device in curDSelected\">{{device.label}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><div class=text-bold>{{\'d.tab.1\' | translate}}</div><li class=\"dropdown-header noPad noMarR marT5\" ng-show=\"devices.devices.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.d sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"device in filteredDList = (devices.devices | filter:searchList.d) | orderBy: \'label\'\" tabindex=$index uib-tooltip={{device.label}} tooltip-popup-delay=1000 tooltip-append-to-body=true><label><input type=checkbox ng-model=device.selected role=checkbox aria-label=device-{{$index}} aria-labelledby=device-{{$index}}><label></label>{{device.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"devices.devices.length && filteredDList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!devices.devices.length>{{\'db.msg.1\' | translate}}</div></div></div></div></div></ul></div></div></div><div class=noPad ng-class=\"dmbNewUser.id?\'col-xs-2\':\'col-xs-1\'\"><div class=\"form-group noMarB\"><label>&nbsp;</label><div><button type=button role=button class=btn ng-class=\"dmbNewUser.id?\'btn-primary\':\'btn-success\'\" ng-click=addDMBUserFx(); ng-disabled=dmbUserProcessing><span class=fa ng-class=\"dmbUserProcessing?\'fa-repeat fa-spin\':dmbNewUser.id?\'fa-check\':\'fa-plus-circle\'\" aria-hidden=true></span>{{dmbNewUser.id?\'cm.btn.7\':\'cm.btn.19\' | translate}}</button> <a href=\"\" role=link class=\"btn btn-link\" ng-click=cancelDMBUserFx(); ng-if=dmbNewUser.id>{{\'cm.btn.9\' | translate}}</a></div></div></div></div><div class=\"errMsg pull-right marT5\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'eField\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errTypePop==\'uExist\'\" aria-live=polite role=status>{{\'ms.msg.9\' | translate}}</div></div><div class=clearfix></div></div><div class=\"row marT20\"><div class=col-xs-12><h5 class=\"panel-inner-tab marB10 padB15\">{{\'cm.dmb.6\' | translate}}<div class=\"panel-tools marT-5 marB10 noPad text-unbold searchTbx\" ng-show=\"dmbSettings.users.length > 0\"><input type=text class=\"form-control input-sm\" ng-model=searchUserTxt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchUserTxt.length ng-click=\"searchUserTxt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></h5></div><div class=col-xs-12><div class=\"table table-md\" ng-if=\"dmbSettings.users.length > 0\"><div class=\"row th\"><div class=col-xs-2>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.47\' | translate}}</div><div class=col-xs-3>{{\'cm.dmb.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-1></div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(settingsObj.iotButton?585:540)}}px><div class=\"row word-break\" ng-repeat=\"user in dmbSettings.users | filter:searchUserTxt\"><div class=col-xs-2>{{user.label}}</div><div class=col-xs-3>{{user.email}}</div><div class=col-xs-3>{{user.brand.label}}</div><div class=col-xs-3><ul class=list-inline><li class=\"noPad marR5\" ng-repeat=\"device in user.devices\">{{device.label}}<span ng-if=!$last>,</span></li></ul></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-primary ng-click=\"sendPwdFx(user.userId, $index);\" ng-disabled=sendPwdProcessing uib-tooltip=\"{{\'u.brief.6\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-share-square\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marLR5\" ng-click=\"editOpen(user, $index);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'u\', user.userId, $index);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-popup-delay=1000 tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(dmbSettings.users | filter:searchUserTxt).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchUserTxt)}}&quot;</b>\'}\"></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"dmbSettings.users.length == 0\">{{\'cm.dmb.m6\' | translate}}</div></div></div></div></div></div></section></div></uib-tab><uib-tab select=selectTabFx(9) ng-if=\"settingsObj.uType != 4 && auth.upermissions.da.dp\"><uib-tab-heading>{{\'ms.p_s.tab.8\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><div class=\"bg-light pad10 marB20\"><div class=row><div class=col-xs-6><label>{{\'ms.p_s.dp.2\' | translate}}</label><input type=text class=form-control ng-model=curDPObj.label maxlength={{inputLimit}} aria-label=curDPObjLabel aria-labelledby=curDPObjLabel></div><div class=col-xs-6><label>{{\'ms.p_s.dp.3\' | translate}}</label><input type=text class=form-control ng-model=curDPObj.value maxlength={{inputLimit}} aria-label=curDPObjValue aria-labelledby=curDPObjValue></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=dpAddFx(); ng-disabled=dpProcessing><span ng-if=!curDPObj.id><span ng-class=\"dpProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'ms.p_s.dp.1\' | translate}}</span> <span ng-if=curDPObj.id><span ng-class=\"dpProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=reset role=button class=\"btn btn-link\" ng-click=dpResetFx(); ng-disabled=dpProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'label\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m1\' | translate}}</div><div ng-if=\"errTypePop==\'same\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m2\' | translate}}</div></div></div></div></div></div><div class=\"form-group text-bold dpSort marB10\" ng-if=dpObj.properties.length role=radiogroup aria-labelledby=radiogroup><span class=dpsTxt>{{\'ms.p_s.dp.5\' | translate}}</span><label class=\"marL5 marR5 noMarB\"><input type=radio role=radio name=sOpt ng-model=dpObj.info.sort value=a ng-change=dpSaveFx();><label></label>{{\'ms.label.34.1\' | translate}}</label><span class=text-muted>|</span><label class=\"marL5 noMarB\"><input type=radio role=radio name=sOpt ng-model=dpObj.info.sort value=c ng-change=dpSaveFx();><label></label>{{\'cm.label.17\' | translate}}</label></div><div ng-class=\"{\'bg-light pad10\':dpObj.properties.length && dpObj.info.sort == \'c\'}\"><div class=\"table bg-white no-th\" ng-if=dpObj.properties.length><div class=\"row th bg-white\"><div class=col-xs-6>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-5>{{\'ms.p_s.dp.3\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=dpDataLoading class=pad10><div ng-if=!dpDataLoading><div class=scrollQuad ng-if=\"dpObj.info.sort == \'a\'\" style=max-height:{{getAvailableHeight(settingsObj.iotButton?540:477)}}px><div class=row ng-repeat=\"dp in dpObj.properties\"><div class=\"col-xs-6 word-break\">{{dp.label}}</div><div class=\"col-xs-5 word-break\">{{dp.value}}<span ng-if=!dp.value class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR10\" ng-click=dpEditFx(dp);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=dpDeleteOpen(dp.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"scrollQuad sortable-containment\" ng-if=\"dpObj.info.sort == \'c\'\" style=max-height:{{getAvailableHeight(settingsObj.iotButton?590:545)}}px sortable callback=sortCallback()><div class=\"row sortable-item\" ng-repeat=\"dp in dpObj.properties\" data-id={{dp.id}}><div class=\"col-xs-6 word-break dpLabel\"><span class=\"fa fa-arrows-v marR5 cursor-grab text-muted\" aria-hidden=true></span> {{dp.label}}</div><div class=\"col-xs-5 word-break\"><span class=dpValue>{{dp.value}}</span> <span ng-if=!dp.value class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR10\" ng-click=dpEditFx(dp);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=dpDeleteOpen(dp.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div><div class=\"bdr-top-dashed marT15\" ng-if=\"dpObj.properties.length && dpObj.info.sort == \'c\'\"><a href=\"\" role=link class=\"btn btn-success btn-xs\" ng-click=\"dpSaveFx(\'s\');\" ng-disabled=dpSProcessing><span ng-class=\"dpSProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.dp.5.1\' | translate}}</a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!dpDataLoading && !dpObj.properties.length\">{{\'ms.p_s.dp.m3\' | translate}}</div></div></uib-tab><uib-tab select=selectTabFx(11) ng-if=\"settingsObj.uType != 4 && settingsObj.iotButton\"><uib-tab-heading>{{\'cl.widget.iot.1\' | translate}}</uib-tab-heading><img alt=Loading src=assets/images/loading.gif ng-if=settingLoading><div ng-if=!settingLoading><div ng-if=iotObj.placements.length><div class=\"text-right marB10\"><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=\"iotBtnAttrResetFx(); curIoTAttrObj.isShow=true\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'ms.p_s.serverPer.39.11\' | translate}}</button></div><div class=\"bg-light pad10 marB20\" ng-show=curIoTAttrObj.isShow><div class=row><div class=col-xs-4><label>{{\'ms.p_s.serverPer.39.9\' | translate}}</label><input type=text class=form-control ng-model=curIoTAttrObj.label maxlength={{inputLimit}} aria-label=curIoTAttrObjLabel aria-labelledby=curIoTAttrObjLabel></div><div class=col-xs-4><label>{{\'d.label.11\' | translate}}</label><input type=text class=form-control ng-model=curIoTAttrObj.value maxlength={{inputLimit}} aria-label=curIoTAttrObjValue aria-labelledby=curIoTAttrObjValue></div><div class=col-xs-4><label>{{\'cl.widget.iot.5.1\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>{{plSelected = (iotObj.placements | filter:{selected:true}); \"\"}} <span ng-if=!plSelected.length>{{\'ms.p_s.serverPer.39.10\' | translate}}</span> <span ng-repeat=\"pl in plSelected\">{{pl.placementName}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"iotObj.placements.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=\"bg-light padLR8 padTB2 marT5\"><label class=noMar><input type=checkbox ng-model=plSelect.all ng-click=\"plSelectFx(\'all\')\" role=checkbox aria-label=allPlacements aria-labelledby=allPlacements><label></label>{{\'cm.label.4\' | translate}}</label></li><li class=\"divider noMarT\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"pl in filteredSList = (iotObj.placements | filter:searchList) | orderBy:\'placementName\'\" tabindex=$index><label><input type=checkbox ng-model=pl.selected ng-click=plSelectFx() role=checkbox aria-label=placements-{{$index}} aria-labelledby=placements-{{$index}}><label></label>{{pl.placementName}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=iotBtnAttrAddFx(); ng-disabled=attrAddProcessing><span ng-class=\"attrAddProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'ms.p_s.serverPer.39.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default\" ng-click=iotBtnAttrResetFx(); ng-disabled=attrAddProcessing><span class=\"fa fa-repeat\" aria-hidden=true></span> {{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"iotBtnAttrResetFx(); curIoTAttrObj.isShow = !curIoTAttrObj.isShow\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'label\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.39.m9\' | translate}}</div><div ng-if=\"errTypePop==\'value\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.39.m10\' | translate}}</div><div ng-if=\"errTypePop==\'placement\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.39.m11\' | translate}}</div></div></div></div></div></div><div class=scrollQuad style=max-height:{{getAvailableHeight(curIoTAttrObj.isShow?510:353)}}px><div class=row ng-repeat=\"pm in iotObj.placements\"><div role=button class=\"iot-button-list pad10\" ng-click=\"placementsFx($index, pm.placementName);\"><div class=\"col-xs-12 word-break\"><span class=\"fa fa-plus-square marR5\" ng-class=\"{\'fa-minus-square\':pm.isOpen}\" aria-hidden=true></span> {{pm.placementName}}</div><div class=clearfix></div></div><div class=padLR15 ng-if=pm.isOpen><img alt=Loading src=assets/images/loading-xs.gif ng-if=pm.loading><div ng-if=!pm.loading><div class=table ng-if=!pm.isEmpty><div class=\"row th\"><div class=col-xs-6>{{\'ms.p_s.serverPer.39.9\' | translate}}</div><div class=col-xs-5>{{\'d.label.11\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"(key, value) in pro = pm.placement\"><div role=button><div class=\"col-xs-6 word-break\">{{key}}</div><div class=\"col-xs-5 word-break\">{{value}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-danger ng-click=\"iotBtnAttrDeleteOpen($parent.$index, $index, pm.placementName, pro);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=pm.isEmpty>{{\'ms.p_s.serverPer.39.m13\' | translate}}</div></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!iotObj.placements.length>{{\'ms.p_s.serverPer.39.m12\' | translate}}</div></div></uib-tab></uib-tabset></div><footer class=panel-footer><span class=btnQuad><span ng-if=\"selectTab==1\"><button type=button role=button class=\"btn btn-success\" ng-click=updateTabFx(1); ng-disabled=\"saveProcessing || settingLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{primeProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><span ng-if=\"selectTab==2\"><button type=button role=button class=\"btn btn-success\" ng-click=updateTabFx(2); ng-disabled=\"saveProcessing || settingLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> </span><span ng-if=\"selectTab==3\"><button type=button role=button class=\"btn btn-success\" ng-click=\"updateTabFx(3, 1);\" ng-disabled=\"saveProcessing || savePProcessing || settingLoading\"><span class=fa ng-class=\"savePProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.polling.4\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"updateTabFx(3, 0);\" ng-disabled=\"saveProcessing || savePProcessing || settingLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.p_s.polling.5\' | translate}}</button> </span><span ng-if=\"selectTab==6\"><button type=button role=button class=\"btn btn-success\" ng-click=updateTabFx(6); ng-disabled=\"saveProcessing || settingLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><span ng-if=\"selectTab==7\"><button type=button role=button class=\"btn btn-success\" ng-click=updateTabFx(7); ng-disabled=\"saveProcessing || settingLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> </span><button type=button role=button class=btn ng-click=closeThisDialog(); data-dismiss=modal ng-class=\"selectTab!=4 && selectTab!=5 && selectTab!=8 && selectTab!=9 && selectTab!=10 && selectTab!=11?\'btn-link\':\'btn-default\'\">{{selectTab!=4 && selectTab!=5 && selectTab!=8 && selectTab!=9?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"selectTab==2\"><span ng-if=\"errType==\'excludeSE\' || errType==\'invalidTime\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m2\' | translate}}</span> <span ng-if=\"errType==\'offlineTime\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m4\' | translate}}</span> <span ng-if=\"errType==\'email\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m3\' | translate}}</span> <span ng-if=\"errType==\'offline\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m1\' | translate}}</span> <span ng-if=\"errType==\'threshold\'\" aria-live=polite role=status>{{\'ms.p_s.notifyS.m5\' | translate}}</span> </span><span ng-if=\"selectTab==3\">{{\'ms.p_s.polling.m1\' | translate}}</span> <span ng-if=\"selectTab==7\"><span ng-if=\"errType==\'cs\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m1\' | translate}}</span> <span ng-if=\"errType==\'cst\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m19\' | translate}}</span> <span ng-if=\"errType==\'cstMore\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m20\' | translate}}</span> <span ng-if=\"errType==\'iTime\'\" aria-live=polite role=status>{{\'ms.p_am.m1\' | translate}}</span> <span ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</span></span></div><div class=\"msg-warning inline marL10\" lang={{auth.lang}} ng-if=\"selectTab==5 && uploadFileCount > 0\">{{\'ms.p_s.defaultImg.m1\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/specScheduleList.html","<section class=panel><header class=panel-heading><h1>{{\'cm.body.2\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"getSchedulesList(\'refresh\'); searchPopup.text=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control id=searchBox ng-model=searchPopup.text sanitize-input maxlength=250 ng-keyup=scheduleSearchFx(searchPopup.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchPopup.text.length ng-click=\"searchMsg = false; searchMsgSel =false;searchPopup.text=\'\'; scheduleSearchFx();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading class=scrollQuad callback=sortCallback() ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=bdr-btm-dashed>{{(scheduleList.length > 1) ? \'cl.label.5s\' : \'cl.label.5\' | translate}}</div><div class=\"table table-md dTable\" role=table><div class=\"row th\" ng-if=\"groupList.length > 0 || scheduleList.length > 0\"><div class=col-xs-4>{{\'s.body.1\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.7\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=col-xs-2>{{\'cm.label.46\' | translate | camelCase}}</div></div><ul id=schedule-list><div class=folderQuad ng-repeat=\"s in scheduleGroup = (groupList | filter:{schStatus:\'a\'})\" ng-if=groupList.length>{{curGrpSchedule = (scheduleList | filter:{schStatus:\'a\'} | sameValue:([s.gid, \'sg\']));\"\"}}<!--Folder--><div class=nonSelectable ng-if=s.label><span><div class=folder-heading data-id={{s.id}} ng-class=\"{\'text-muted\':!s.isActive}\"><div class=\"col-xs-12 text-bold text-ellipsis folder\" ng-click=folderFx($event); data-id={{s.id}}><a href=\"\" role=link><span class=\"fa fa-folder marR5\" aria-hidden=true></span>{{s.label}} <span class=\"text-muted text-unbold text-sm\">({{curGrpSchedule.length}})</span></a></div></div></span></div><div class=\"folder-content hide\"><li class=row ng-repeat=\"cgs in curGrpSchedule | filter:{schStatus:\'a\'}\" data-id={{cgs.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!cgs.isActive}\"><div class=\"panel-body noPad\"><div class=\"col-xs-4 text-ellipsis\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-model=cgs.selected role=checkbox ng-click=\"selctedSchFx(cgs,\'a\')\"><label></label><span class=\"fa fa-warning text-warning\" ng-if=cgs.isPartial aria-hidden=true></span> {{cgs.label}}</label></div><div class=col-xs-3><span ng-if=\"cgs.startDate != null\">{{cgs.startDate}}<span ng-if=\"cgs.endDate != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{cgs.endDate}}</span></span> <span ng-if=\"cgs.startDate == null && cgs.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=cgs.isCustom>{{\'cm.label.17\' | translate}}</span> <span ng-if=!cgs.isCustom>{{\'s.brief.2\' | translate}}</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=\"cgs.schStatus == \'a\'\">{{\'db.body.9\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'u\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'cl.tool.11\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'i\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.10\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'e\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.8\' | translate}}</span></div></div></li><div class=\"msg-warning mar5\" ng-if=\"curGrpSchedule.length == 0\">{{\'s.msg.5\' | translate}}</div></div></div>{{schList = (scheduleList | filter:{schStatus:\"a\"});\"\"}}<!--Item--><li class=row ng-repeat=\"s in scheduleItem = scheduleList | filter:{schStatus:\'a\'}\" ng-if=!s.gid data-id={{s.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!s.isActive}\"><div class=\"col-xs-4 text-ellipsis\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-model=s.selected role=checkbox ng-click=\"selctedSchFx(s,\'a\')\" name=nameBox-{{$index}} id=nameBox-{{$index}}><label></label><span class=\"fa fa-warning text-warning\" ng-if=s.isPartial></span> {{s.label}}</label></div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{s.startDate}}<span ng-if=\"s.endDate != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{s.endDate}}</span></span> <span ng-if=\"s.startDate == null && s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=s.isCustom>{{\'cm.label.17\' | translate}}</span> <span ng-if=!s.isCustom>{{\'s.brief.2\' | translate}}</span><!-- <span ng-if=\"s.isCustom == null\" class=\"text-muted text-sm\">N/A</span> --></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=\"s.schStatus == \'a\'\">{{\'db.body.9\' | translate}}</span> <span ng-if=\"s.schStatus == \'u\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'cl.tool.11\' | translate}}</span> <span ng-if=\"s.schStatus == \'i\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.10\' | translate}}</span> <span ng-if=\"s.schStatus == \'e\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.8\' | translate}}</span></div></li></ul><div class=msg-warning ng-if=\"((scheduleList | filter:{label:searchPopup.text, schStatus:\'a\'}).length == 0) && schList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPopup.text)}}&quot;</b>\'}\"></div><div class=msg-warning ng-if=\"!popupLoading && schList.length == 0\">{{\'cm.msg.49\' | translate}}</div></div><!-- Selected Schedule List --><div class=\"bdr-btm-dashed marT45\">{{(selSchList.length > 1) ? \'cl.label.28s\' : \'cl.label.28\' | translate}}</div><div class=\"table table-md dTable\" role=table><div class=\"row th\" ng-if=\"selGroupList.length > 0 || selSchList.length > 0\"><div class=col-xs-4>{{\'s.body.1\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.7\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=col-xs-2>{{\'cm.label.46\' | translate | camelCase}}</div></div><ul id=sel-schedule-list><div class=folderQuad ng-repeat=\"s in scheduleGroup = (selGroupList)\" ng-if=\"selGroupList.length > 0\">{{curGrpSchedule = (selSchList | sameValue:([s.gid, \'sg\']));\"\"}}<!--Folder--><div class=nonSelectable ng-if=s.label><span><div class=folder-heading data-id={{s.id}} ng-class=\"{\'text-muted\':!s.isActive}\"><div class=\"col-xs-12 text-bold text-ellipsis folder\" ng-click=folderFx($event); data-id={{s.id}}><a href=\"\" role=link><span class=\"fa fa-folder marR5\" aria-hidden=true></span>{{s.label}} <span class=\"text-muted text-unbold text-sm\">({{curGrpSchedule.length}})</span></a></div></div></span></div><div class=\"folder-content hide\"><li class=row ng-repeat=\"cgs in curGrpSchedule\" data-id={{cgs.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!cgs.isActive || cgs.schStatus != \'a\'}\"><div class=\"panel-body noPad\"><div class=\"col-xs-4 text-ellipsis\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-model=cgs.selected role=checkbox ng-click=\"selctedSchFx(cgs,\'s\')\"><label></label><span class=\"fa fa-warning text-warning\" ng-if=cgs.isPartial aria-hidden=true></span> {{cgs.label}}</label></div><div class=col-xs-3><span ng-if=\"cgs.startDate != null\">{{cgs.startDate}}<span ng-if=\"cgs.endDate != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{cgs.endDate}}</span></span> <span ng-if=\"cgs.startDate == null && cgs.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=cgs.isCustom>{{\'cm.label.17\' | translate}}</span> <span ng-if=!cgs.isCustom>{{\'s.brief.2\' | translate}}</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=\"cgs.schStatus == \'a\'\">{{\'db.body.9\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'u\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'cl.tool.11\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'i\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.10\' | translate}}</span> <span ng-if=\"cgs.schStatus == \'e\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.8\' | translate}}</span></div></div></li><div class=\"msg-warning mar5\" ng-if=\"curGrpSchedule.length == 0\">{{\'s.msg.5\' | translate}}</div></div></div>{{schSearchList = (selSchList | filter:{schStatus:\"a\"});\"\"}}<!--Item--><li class=row ng-repeat=\"s in scheduleItem = selSchList\" ng-if=!s.gid data-id={{s.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!s.isActive || cgs.schStatus != \'a\'}\"><div class=\"col-xs-4 text-ellipsis\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-model=s.selected role=checkbox ng-click=\"selctedSchFx(s,\'s\')\" name=nameBox-{{$index}} id=nameBox-{{$index}}><label></label><span class=\"fa fa-warning text-warning\" ng-if=s.isPartial></span> {{s.label}}</label></div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{s.startDate}}<span ng-if=\"s.endDate != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{s.endDate}}</span></span> <span ng-if=\"s.startDate == null && s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=s.isCustom>{{\'cm.label.17\' | translate}}</span> <span ng-if=!s.isCustom>{{\'s.brief.2\' | translate}}</span><!-- <span ng-if=\"s.isCustom == null\" class=\"text-muted text-sm\">N/A</span> --></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=\"s.schStatus == \'a\'\">{{\'db.body.9\' | translate}}</span> <span ng-if=\"s.schStatus == \'u\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'cl.tool.11\' | translate}}</span> <span ng-if=\"s.schStatus == \'i\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.10\' | translate}}</span> <span ng-if=\"s.schStatus == \'e\'\" class=\"badge bg-muted bdrRad12 text-sm text-muted\">{{\'db.body.8\' | translate}}</span></div></li></ul><!-- ng-if=\"(schSearchList.length == 0 || searchMsgSel) && (selSchList.length || selGroupList.length)\" --><div class=msg-warning ng-if=\"((selSchList | filter:{label:searchPopup.text}).length == 0) && selSchList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPopup.text)}}&quot;</b>\'}\"></div><div class=msg-warning ng-if=\"!popupLoading && selSchList.length == 0 && selGroupList.length == 0\">{{\'cm.msg.48\' | translate}}</div></div></div></div><footer class=panel-footer><span class=btnQuad><!-- Sortable --> <button type=button role=button class=\"btn btn-success\" ng-click=saveSelSchduleFx(); ng-disabled=\"popupProcessing || selSchList.length == 0 && groupList.length == 0 || popupLoading\"><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();resetSchFx() data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop><span ng-if=\"errTypePop == \'selSch\'\">{{\'ms.p_s.notifyS.m10\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/ssList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'ms.label.28\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><div class=row><div class=col-xs-5><div><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curServerModel.available=[]\">{{\'cm.tool.7\' | translate}}</button><label>{{curServer.available.length > 1?\'ms.label.29s\':\'ms.label.29\' | translate}} <span class=\"text-sm text-muted\">[ {{curServer.available.length}} ]</span></label><select class=form-control ng-model=curServerModel.available ng-options=\"s.label for s in curServer.available | orderBy:\'label\' track by s.id\" multiple size=10></select></div></div><div class=\"col-xs-2 addRemoveBtnQuad\"><button type=button role=button class=\"btn btn-success btn-block marT50\" ng-click=\"listManipulateFx(\'add\', curServer.available, curServer.assigned, curServerModel.available);\" ng-class=\"{\'disabled\': !curServer.available.length}\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-block\" ng-click=\"listManipulateFx(\'remove\', curServer.available, curServer.assigned, curServerModel.assigned);\" ng-class=\"{\'disabled\': !curServer.assigned.length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-5><div><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curServerModel.assigned=[]\">{{\'cm.tool.7\' | translate}}</button><label>{{curServer.assigned.length > 1?\'ms.label.30s\':\'ms.label.30\' | translate}} <span class=\"text-sm text-muted\">[ {{curServer.assigned.length}} ]</span></label><select class=form-control ng-model=curServerModel.assigned ng-options=\"s.label for s in curServer.assigned | orderBy:\'label\' track by s.id\" multiple size=10></select></div></div></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=makeUserCoordinatorFx(false); ng-disabled=\"makeProcessing || !curServer.assigned.length\"><span ng-class=\"makeProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\"cm.btn.1\" | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/ssoSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"curSSO.type==\'azure\'\" role=heading aria-level=1>{{\'ms.p_s.serverPer.11\' | translate | camelCase}}</h1><h1 ng-if=\"curSSO.type==\'okta\'\" role=heading aria-level=1>{{\'ms.p_s.serverPer.12\' | translate | camelCase}}</h1><h1 ng-if=\"curSSO.type==\'idaptive\'\" role=heading aria-level=1>{{\'ms.p_s.serverPer.32\' | translate | camelCase}}</h1><h1 ng-if=\"curSSO.type==\'saml\'\" role=heading aria-level=1>{{\'ms.p_s.serverPer.42\' | translate | camelCase}}</h1><h1 ng-if=\"curSSO.type==\'google\'\" role=heading aria-level=1>{{\'ms.p_s.serverPer.69\' | translate | camelCase}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(310)}}px><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=!popupLoading><div class=col-xs-12><div class=form-group><label for=curSSOtext>{{\'ms.p_s.serverPer.17\' | translate}}</label><input type=text class=form-control ng-model=curSSO.text id=curSSOtext aria-label=curSSOtext aria-labelledby=curSSOtext></div><div class=form-group><label for=curSSOurl>{{\'cl.widget.cm.10\' | translate}}</label><input type=url class=form-control ng-model=curSSO.url id=curSSOurl aria-label=curSSOurl aria-labelledby=curSSOurl></div><div class=form-group ng-if=\"curSSO.type != \'idaptive\' && curSSO.type != \'saml\'\"><label for=curSSOclientId>{{\'ms.p_s.serverPer.13\' | translate}}</label><input type=text class=form-control ng-model=curSSO.clientId id=curSSOclientId aria-label=curSSOclientId aria-labelledby=curSSOclientId></div><div class=form-group ng-if=\"curSSO.type != \'idaptive\' && curSSO.type != \'saml\'\"><label for=curSSOclientSecret>{{\'ms.p_s.serverPer.14\' | translate}}</label><input type=text class=form-control ng-model=curSSO.clientSecret id=curSSOclientSecret aria-label=curSSOclientSecret aria-labelledby=curSSOclientSecret></div><div class=form-group ng-if=\"curSSO.type == \'azure\'\"><label for=curSSOtenantId>{{\'ms.p_s.serverPer.15\' | translate}}</label><input type=text class=form-control ng-model=curSSO.tenantId id=curSSOtenantId aria-label=curSSOtenantId aria-labelledby=curSSOtenantId></div><div class=form-group ng-if=\"curSSO.type == \'okta\'\"><label for=curSSOappDomain>{{\'ms.p_s.serverPer.16\' | translate}}</label><input type=text class=form-control ng-model=curSSO.appDomain id=curSSOappDomain aria-label=curSSOappDomain aria-labelledby=curSSOappDomain></div><div class=form-group ng-if=\"curSSO.type == \'idaptive\' || curSSO.type == \'saml\'\"><label for=curSSOentityId>{{\'ms.p_s.serverPer.32.1\' | translate}}</label><input type=text class=form-control ng-model=curSSO.entityId id=curSSOentityId aria-label=curSSOentityId aria-labelledby=curSSOentityId></div><div class=form-group ng-if=\"curSSO.type == \'idaptive\' || curSSO.type == \'saml\'\"><label for=curSSOsso>{{\'ms.p_s.serverPer.32.2\' | translate}}</label><input type=text class=form-control ng-model=curSSO.sso id=curSSOsso aria-label=curSSOsso aria-labelledby=curSSOsso></div><div class=form-group ng-if=\"curSSO.type == \'idaptive\' || curSSO.type == \'saml\'\"><label for=curSSOslo>{{\'ms.p_s.serverPer.32.3\' | translate}}</label><input type=text class=form-control ng-model=curSSO.slo id=curSSOslo aria-label=curSSOslo aria-labelledby=curSSOslo></div><div class=form-group ng-if=\"curSSO.type == \'idaptive\' || curSSO.type == \'saml\'\"><label for=curSSOcert>{{\'ms.p_s.serverPer.32.4\' | translate}}</label><textarea class=form-control ng-model=curSSO.cert id=curSSOcert aria-label=curSSOcert aria-labelledby=curSSOcert></textarea></div></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=ssoSaveFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'text\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m8\' | translate}}</div><div ng-if=\"errTypePop==\'appD\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m7\' | translate}}</div><div ng-if=\"errTypePop==\'cId\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m4\' | translate}}</div><div ng-if=\"errTypePop==\'tId\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m6\' | translate}}</div><div ng-if=\"errTypePop==\'cs\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m5\' | translate}}</div><div ng-if=\"errTypePop==\'eId\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m10\' | translate}}</div><div ng-if=\"errTypePop==\'sso\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m11\' | translate}}</div><div ng-if=\"errTypePop==\'slo\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m12\' | translate}}</div><div ng-if=\"errTypePop==\'cert\'\" aria-live=polite role=status>{{\'ms.p_s.serverPer.m13\' | translate}}</div><div ng-if=\"errTypePop==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errTypePop==\'urlS\'\" aria-live=polite role=status translate=\"{{\'ms.p_s.serverPer.m9\'}}\" translate-values={serverName:existsServer}></div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/common/popup/telexSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.telax.8\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px ng-if=!popupLoading><h5 class=\"panel-inner-tab marTB10\">{{\'cl.widget.telax.9\' | translate}}</h5><div class=pad10><div class=row><div class=col-xs-6><div class=form-group><label for=telaxaccountid>{{\'cl.widget.telax.9.1\' | translate}}</label><input type=text class=form-control ng-model=telexSettings.settings.telaxaccountid id=telaxaccountid aria-label=telaxaccountid aria-labelledby=telaxaccountid></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=telaxusername>{{\'cl.widget.telax.9.2\' | translate}}</label><input type=text class=form-control ng-model=telexSettings.settings.telaxusername id=telaxusername aria-label=telaxusername aria-labelledby=telaxusername></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=ac>{{\'cl.widget.telax.9.3\' | translate}}</label><input type=text class=form-control ng-model=decodePass.ac id=ac aria-label=ac aria-labelledby=ac></div></div></div></div><h5 class=\"panel-inner-tab marTB10\">{{\'cl.widget.telax.10\' | translate}}</h5><div class=pad10><div class=row><div class=col-xs-6><div class=form-group><label for=telaxftphost>{{\'cl.widget.telax.10.1\' | translate}}</label><input type=text class=form-control ng-model=telexSettings.settings.telaxftphost id=telaxftphost aria-label=telaxftphost aria-labelledby=telaxftphost></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=telaxftpusername>{{\'cl.widget.telax.9.2\' | translate}}</label><input type=text class=form-control ng-model=telexSettings.settings.telaxftpusername id=telaxftpusername aria-label=telaxftpusername aria-labelledby=telaxftpusername></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=ftp>{{\'cl.widget.telax.9.3\' | translate}}</label><input type=text class=form-control ng-model=decodePass.ftp id=ftp aria-label=ftp aria-labelledby=ftp></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=telexPopFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/common/popup/webOSSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_dc.13\' | translate | camelCase}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(160)}}px><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=!popupLoading><div class=col-xs-12><div class=\"panel-inner-tab marB5\">{{\'d.p_dc.wos.2\' | translate}}</div><div class=\"bg-light pad10\"><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.3\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label for=menu>{{\'d.p_dc.wos.3.1\' | translate}}</label><select id=menu class=form-control ng-model=webOS.gs.l.menu ng-options=\"opt.language for opt in localeList track by opt.languageCode\" aria-label=\"{{\'d.p_dc.wos.3.1\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.3.1\' | translate}}\"></select></div><div class=\"col-xs-6 form-group\"><label for=key>{{\'d.p_dc.wos.3.2\' | translate}}</label><select id=key class=form-control ng-model=webOS.gs.l.key ng-options=\"opt.language for opt in localeList track by opt.languageCode\" aria-label=\"{{\'d.p_dc.wos.3.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.3.2\' | translate}}\"></select></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.4\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label for=sis>{{\'d.p_dc.wos.4.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.si.s id=sis aria-checked={{webOS.gs.si.s?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.7\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label for=signal>{{\'d.p_dc.wos.7.1\' | translate}} <span class=\"text-muted text-sm\">(15&nbsp;{{\'cm.label.28s\' | translate}})</span></label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.signal id=signal aria-checked={{webOS.gs.p.signal?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=pir>{{\'d.p_dc.wos.7.2\' | translate}} <span class=\"text-muted text-sm\">(4&nbsp;{{\'cm.label.29s\' | translate}})</span></label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.ir id=pir aria-checked={{webOS.gs.p.ir?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=dpm>{{\'d.p_dc.wos.7.3\' | translate}}</label><select id=dpm class=form-control ng-model=webOS.gs.p.dpm ng-options=\"opt.label for opt in dpmList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.3\' | translate}}\"></select></div></div><div class=row><div class=\"col-xs-4 form-group timepicker\"><label for=wakeUp>{{\'d.p_dc.wos.7.4\' | translate}}</label><select id=wakeUp class=form-control ng-model=webOS.gs.p.wakeUp ng-options=\"opt.label for opt in dpmWakeList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.4\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gsp>{{\'d.p_dc.wos.7.5\' | translate}}</label><select id=gsp class=form-control ng-model=webOS.gs.p.pm ng-options=\"opt.label for opt in pmModeList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.5\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.5\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gsdelay>{{\'d.p_dc.wos.7.6\' | translate}} <span class=\"text-muted text-sm\">(0-250)</span></label><input type=number id=gsdelay class=form-control ng-model=webOS.gs.p.delay min=0 max=250 aria-label=\"{{\'d.p_dc.wos.7.6\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.6\' | translate}}\"></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=gsstatus>{{\'d.p_dc.wos.7.7\' | translate}}</label><select id=gsstatus class=form-control ng-model=webOS.gs.p.status ng-options=\"opt.label for opt in pStatusList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.7\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.7\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gswired>{{\'d.p_dc.wos.7.8\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.wired id=gswired aria-checked={{webOS.gs.p.wired?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gswireless>{{\'d.p_dc.wos.7.9\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.wireless id=gswireless aria-checked={{webOS.gs.p.wireless?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.8\' | translate}}</div><div><label class=text-md>{{\'d.p_dc.wos.8.1\' | translate}}</label><div class=row><div class=\"col-xs-12 form-group\"><label for=gswired>{{\'d.p_dc.wos.8.1.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.n.lan.wired id=gswired aria-checked={{webOS.gs.n.lan.wired?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><label class=text-md>{{\'d.p_dc.wos.8.2\' | translate}}</label><div class=row><div class=\"col-xs-6 form-group\"><label for=gsip>{{\'d.p_dc.wos.8.2.1\' | translate}}</label><input type=text id=gsip class=form-control ng-model=webOS.gs.n.cpc.ip aria-label=\"{{\'d.p_dc.wos.8.2.1\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.1\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsmask>{{\'d.p_dc.wos.8.2.2\' | translate}}</label><input type=text id=gsmask class=form-control ng-model=webOS.gs.n.cpc.mask aria-label=\"{{\'d.p_dc.wos.8.2.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.2\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsgateway>{{\'d.p_dc.wos.8.2.3\' | translate}}</label><input type=text id=gsgateway class=form-control ng-model=webOS.gs.n.cpc.gateway aria-label=\"{{\'d.p_dc.wos.8.2.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.3\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsdns>{{\'d.p_dc.wos.8.2.4\' | translate}}</label><input type=text id=gsdns class=form-control ng-model=webOS.gs.n.cpc.dns aria-label=\"{{\'d.p_dc.wos.8.2.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.4\' | translate}}\"></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.9\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label for=gsb>{{\'d.p_dc.wos.9.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.as.b id=gsb aria-checked={{webOS.gs.as.b?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gsw>{{\'d.tool.9\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.as.w id=gsw aria-checked={{webOS.gs.as.w?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=col-xs-12><div><label class=noMar for=gstvt><input type=checkbox ng-model=webOS.gs.as.tvt id=gstvt role=checkbox aria-label=astvt aria-labelledby=astvt><label></label>{{\'d.p_dc.wos.9.2\' | translate}}</label></div><div class=padLR20 ng-if=webOS.gs.as.tvt><div class=\"row flex-wrap\"><div class=\"col-xs-6 marT10\" ng-repeat=\"day in webOS.gs.as.days\"><div class=row><div class=\"col-xs-12 marB10\"><label for=dayval-{{$index}}><input type=checkbox ng-model=day.val id=dayval-{{$index}} role=checkbox aria-label=dayval-{{$index}} aria-labelledby=dayval-{{$index}}><label></label>{{\'s.p_s.label.4.2.\'+day.label | translate}}</label><span class=marL5 ng-if=\"day.name==\'Mon\' || day.name==\'Sat\'\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"setTvTimerFx(day.name, day);\" ng-disabled=defautProcessing>{{(day.name==\'Mon\'?\'d.p_dc.wos.13\':\'d.p_dc.wos.15\') | translate}}</button> <button type=button role=button ng-if=\"day.name==\'Mon\'\" class=\"btn btn-default btn-xs\" ng-click=\"setTvTimerFx(\'all\', day);\" ng-disabled=defautProcessing>{{\'d.p_dc.wos.14\' | translate}}</button></span></div><div class=col-xs-6 ng-if=day.val><div class=\"form-group timepicker noMarB\"><label for=\"\">{{\'d.p_dc.wos.9.3\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"day.st | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'d.p_dc.wos.9.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.9.3\' | translate}}\"></div><div class=\"dropdown-menu noMarL\" uib-dropdown-menu style=left:-81px><div uib-timepicker ng-model=day.st hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-6 ng-if=day.val><div class=\"form-group timepicker noMarB\"><label for=\"\">{{\'d.p_dc.wos.9.4\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"day.et | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'d.p_dc.wos.9.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.9.4\' | translate}}\"></div><div class=\"dropdown-menu noMarL\" uib-dropdown-menu style=left:-82px><div uib-timepicker ng-model=day.et hour-step=1 minute-step=5></div></div></span></div></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.10\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=\"col-xs-4 form-group\"><label for=ash>{{\'d.p_dc.wos.10.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.h id=ash aria-checked={{webOS.as.h?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=asusb>{{\'d.p_dc.wos.10.2\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.usb id=asusb aria-checked={{webOS.as.usb?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=asosd>{{\'d.p_dc.wos.10.3\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.osd id=asosd aria-checked={{webOS.as.osd?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=asir>{{\'d.p_dc.wos.10.4\' | translate}}</label><select id=asir class=form-control ng-model=webOS.as.ir ng-options=\"opt.label for opt in irLockList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.10.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.10.4\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=aslocal>{{\'d.p_dc.wos.10.5\' | translate}}</label><select id=aslocal class=form-control ng-model=webOS.as.local ng-options=\"opt.label for opt in irLockList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.10.5\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.10.5\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=aswifi>{{\'d.p_dc.wos.10.6\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.wifi id=aswifi aria-checked={{webOS.as.wifi?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=curpwd>{{\'ms.label.13\' | translate}}</label><input type=password id=curpwd class=form-control ng-model=webOSPwdObj.curpwd maxlength={{inputLimit}} autocomplete=new-password aria-label=\"{{\'ms.label.13\' | translate}}\" aria-labelledby=\"{{\'ms.label.13\' | translate}}\"></div><div class=\"col-xs-4 form-group\"><label for=newpwd>{{\'ms.label.14\' | translate}}<span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'d.p_dc.wos.m15\' | translate}}\" tooltip-placement=top aria-hidden=true></span></label><input type=password id=newpwd class=form-control ng-model=webOSPwdObj.newpwd ng-disabled=!webOSPwdObj.curpwd.length maxlength={{inputLimit}} autocomplete=off aria-label=\"{{\'ms.label.14\' | translate}}\" aria-labelledby=\"{{\'ms.label.14\' | translate}}\"></div><div class=\"col-xs-4 form-group\"><label for=conpwd>{{\'ms.label.15\' | translate}}</label><input type=password id=conpwd class=form-control ng-model=webOSPwdObj.conpwd ng-disabled=!webOSPwdObj.newpwd.length maxlength={{inputLimit}} autocomplete=off aria-label=\"{{\'ms.label.15\' | translate}}\" aria-labelledby=\"{{\'ms.label.15\' | translate}}\"></div></div><div class=row><div class=col-xs-6><label for=asss>{{\'d.p_dc.wos.10.7\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.ss id=asss aria-checked={{webOS.as.ss?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.11\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=col-xs-12><div class=\"text-bold marB10\">{{\'d.p_dc.wos.11.1\' | translate}} <span class=\"text-muted text-sm\">({{\'d.p_dc.wos.11.1.1\' | translate}})</span><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=blockAddFx(); ng-disabled=\"webOS.ns.port.length > 29\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cm.btn.19\' | translate}}</button></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!blockAdd && !webOS.ns.port.length\">{{\'d.p_dc.wos.m2\' | translate}}</div><div class=row ng-if=blockAdd><div class=col-xs-4><label for=blockObjp>{{\'d.p_dc.wos.11.1.2\' | translate}} <span class=\"text-muted text-sm\">(0-66355)</span></label><input type=number id=blockObjp class=form-control ng-model=blockObj.p min=0 max=66355 aria-label=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\"></div><div class=col-xs-3><label for=blockObjd>{{\'d.p_dc.wos.11.1.3\' | translate}}</label><select id=blockObjd class=form-control ng-model=blockObj.d aria-label=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\"><option value=in>{{\'d.p_dc.wos.11.1.3.1\' | translate}}</option><option value=out>{{\'d.p_dc.wos.11.1.3.2\' | translate}}</option><option value=all>{{\'d.p_dc.wos.11.1.3.3\' | translate}}</option></select></div><div class=col-xs-3><label for=blockObjpr>{{\'d.p_dc.wos.11.1.4\' | translate}}</label><select id=blockObjpr type=text class=form-control ng-model=blockObj.pr aria-label=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\"><option value=TCP>TCP</option><option value=UDP>UDP</option></select></div><div class=col-xs-2><label class=w100>&nbsp;</label><button type=button role=button class=\"btn btn-success btn-block\" ng-click=\"savePortFx(\'a\');\" ng-disabled=!blockObj.p><span class=\"fa fa-check\" aria-hidden=true></span> {{\'cm.btn.7\' | translate}}</button></div></div><div class=\"table table-md marT10\" ng-if=webOS.ns.port.length><div class=\"row th\"><div class=col-xs-4>{{\'d.p_dc.wos.11.1.2\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.3\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.4\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"port in webOS.ns.port\"><div class=col-xs-4><span ng-show=!port.show>{{port.p}}</span> <input type=number id=portp-{{$index}} class=form-control ng-model=port.p ng-show=port.show min=0 max=66355 aria-label=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\"></div><div class=col-xs-3><span ng-if=!port.show><span ng-if=\"port.d == \'in\'\">{{\'d.p_dc.wos.11.1.3.1\' | translate}}</span> <span ng-if=\"port.d == \'out\'\">{{\'d.p_dc.wos.11.1.3.2\' | translate}}</span> <span ng-if=\"port.d == \'all\'\">{{\'d.p_dc.wos.11.1.3.3\' | translate}}</span></span><select id=portd-{{$index}} class=form-control ng-model=port.d ng-if=port.show aria-label=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\"><option value=in>{{\'d.p_dc.wos.11.1.3.1\' | translate}}</option><option value=out>{{\'d.p_dc.wos.11.1.3.2\' | translate}}</option><option value=all>{{\'d.p_dc.wos.11.1.3.3\' | translate}}</option></select></div><div class=col-xs-3><span ng-if=!port.show>{{port.pr}}</span><select id=portpr-{{$index}} class=form-control ng-model=port.pr ng-if=port.show aria-label=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\"><option value=TCP>TCP</option><option value=UDP>UDP</option></select></div><div class=\"col-xs-2 noPadL text-right\"><span ng-if=!port.show><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"savePortFx(\'e\', port); port.show = !port.show\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deletePortOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></span><div class=\"input-group-btn blockListBtn\" ng-if=port.show><button type=button role=button class=\"btn btn-success btn-sm marR5\" ng-click=\"savePortFx(\'s\', port);\" ng-disabled=!port.p>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-sm\" ng-click=\"cancelEditFx(port.id,  port.show = !port.show);\">{{\'cm.btn.9\' | translate}}</button></div></div></div></div></div></div></div></div></div></div><footer class=panel-footer ng-if=!controlLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webOSPopFx(); ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{popupProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=webosDefaultOpen();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errTypePop==\'newPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m13\' | translate}}</div><div ng-if=\"errTypePop==\'conPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m14\' | translate}}</div><div ng-if=\"errTypePop==\'match\'\" aria-live=polite role=status>{{\'ms.msg.12\' | translate}}</div><div ng-if=\"errTypePop==\'curPwd\'\" aria-live=polite role=status>{{\'ms.msg.13\' | translate}}</div><div ng-if=\"errTypePop==\'same\'\" aria-live=polite role=status>{{\'ms.msg.14\' | translate}}</div><div ng-if=\"errTypePop==\'noPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m15\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/dir/contentBrief.html","<div class=selectedQuad><!--For Selected Item Brief--><section class=panel ng-class=\"{\'pinQuad\':pinStatus==1}\" ng-style=\"pinStatus==1 && {\'width\':mainContainerWidth(5)}\"><header class=panel-heading><h2>{{\'cm.body.5\' | translate}} <span class=\"text-sm text-muted\">[ {{selectedItems.length}} ]</span></h2><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=cancelPromise();closeAllFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true focus-me=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\':pinStatus==1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-show=briefLoading><div ng-if=\"selectedItems.length == 1\">{{curFolder = (folderList | folderBrief:selectedItems[0] | orderBy:\'id\');\"\"}} {{curContent = (contentList | filter:{id:selectedItems[0].id, type:selectedItems[0].subType}:true | orderBy:\'id\');\"\"}} <span ng-if=\"curFolder[0].type==\'Folder\' || curFolder[0].type==\'Sharepoint\' || curFolder[0].type==\'Onedrive\' || curFolder[0].type==\'SharedFolder\' || curFolder[0].type==\'Googledrive\'\">{{curExtn.id = curFolder[0].id;curExtn.type = curFolder[0].type;\"\"}} </span><span ng-if=\"curFolder[0].type!=\'Folder\' && curFolder[0].type!=\'Sharepoint\' && curFolder[0].type!=\'Onedrive\' && curFolder[0].type!=\'SharedFolder\' && curFolder[0].type!=\'Googledrive\'\">{{curExtn.id = curContent[0].id;curExtn.type = curContent[0].type;curExtn.extn = curContent[0].extn;\"\"}} </span>{{downloadableObj.type = curContent[0].type; downloadableObj.label = curContent[0].label; downloadableObj.thumb = cDetailBucket + curContent[0].thumb; downloadableObj.url = cDetailBucket + curContent[0].url; downloadableObj.surl = curContent[0].sUrl; downloadableObj.size = contentBrief.size; downloadableObj.pSize = contentBrief.pSize;\"\"}}<ul class=\"list-unstyled single-selected\"><div class=row><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].wp && curFolder[0].type != \'ExcelFolder\'\"><div class=pad5 ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\" aria-hidden=true></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\" aria-hidden=true></span>{{\'cl.msg.12\' | translate}}</span></div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && (contentLibrary.info.writeProtected || curContent[0].wp)\"><div class=pad5 ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.13\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.14\' | translate}}</span></div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'Sharepoint\'\"><div class=\"pad5 msg-info\"><span class=\"sharepoint marR5\" aria-hidden=true></span>{{\'cl.msg.27\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curContent[0].type == \'SharePointC\' && curContent[0].extn != \'WEBP\'\"><div class=\"pad5 msg-info\"><span class=\"sharepoint marR5\" aria-hidden=true></span>{{\'cl.msg.28\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'Onedrive\'\"><div class=\"pad5 msg-info\"><span class=\"oneDrive marR5\" aria-hidden=true></span>{{\'cl.msg.29\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curContent[0].type == \'OneDriveC\' && curContent[0].extn != \'WEBP\'\"><div class=\"pad5 msg-info\"><span class=\"oneDrive marR5\" aria-hidden=true></span>{{\'cl.msg.30\' | translate}}</div></div><!-- Googledrive --><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'Googledrive\'\"><div class=\"pad5 msg-info\"><span class=\"googleDrive marR5\" aria-hidden=true></span>{{\'cl.msg.61\' | translate}}</div></div><!-- Googledrive --><div class=\"col-xs-12 marB10\" ng-if=\"curContent[0].type == \'GoogleDriveC\'\"><div class=\"pad5 msg-info\"><span class=\"googleDrive marR5\" aria-hidden=true></span>{{\'cl.msg.62\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'SharedFolder\'\" aria-hidden=true><div class=\"pad5 msg-info\"><img alt=\"\" src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"> <span ng-if=\"contentBrief != \'\'\"><span class=\"sharedFolder marR5\"></span><span translate=\"{{\'cl.msg.50\'}}\" translate-values=\"{sName:\'<span class=\\\'text-bold\\\'>{{contentBrief.server.servername}}</span>\', fName:\'<span class=\\\'text-bold\\\'><span class=\\\'fa fa-home marR5\\\'></span>{{contentBrief.path_sf}}</span>\'}\"></span></span></div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'Folder\' && curFolder[0].subtype == \'SharedFolder\'\"><div class=\"pad5 msg-info\"><img alt=\"\" src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"> <span ng-if=\"contentBrief != \'\'\"><span class=\"sharedFolder marR5\" aria-hidden=true></span><span translate=\"{{\'cl.msg.53\'}}\" translate-values=\"{sName:\'<span class=\\\'text-bold\\\'>{{contentBrief.folder.name}}</span>\', shName:\'<span class=\\\'text-bold\\\'>{{contentBrief.server.servername}}</span>\', fName:\'<span class=\\\'text-bold\\\'><span class=\\\'fa fa-home marR5\\\'></span>{{contentBrief.path_sf}} </span>\'}\"></span></span></div></div><div class=\"col-xs-12 marB10\" ng-if=\"curContent[0].type == \'SharedFolderC\'\"><div class=\"pad5 msg-info\"><span class=\"sharedFolder marR5\"></span>{{\'cl.msg.30\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curContent[0].type == \'Video\' && contentBrief.isCaptionProcessing\"><div class=\"pad5 msg-warning\" lang={{auth.lang}}>{{\'cl.msg.25\' | translate}}</div></div><div class=\"col-xs-12 marB10\" ng-if=\"curFolder[0].type == \'ExcelFolder\'\"><div class=\"pad5 msg-success\" lang={{auth.lang}}><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</div></div><div class=col-xs-3><div class=thumb-highlight><div class=\"thumb brief-thumb\" ng-class=\"{\'d-flex align-items-center justify-center\': qrThumbLoading, \'overflow-hidden\': curContent[0].isblur}\"><span ng-class=\"{\'thumb-inner\': curContent[0].isblur}\"><div class=vidLoad ng-if=\"contentBrief.percent != undefined\"><div class=bgCircle ng-if=\"contentBrief.percent < 50\" style=\"background-image:linear-gradient({{90 + (contentBrief.percent * 3.6)}}deg,transparent 50%, #ccc 50%),linear-gradient(90deg, #ccc 50%, transparent 50%)\"><div class=percent>{{contentBrief.percent}}%</div></div><div class=bgCircle ng-if=\"contentBrief.percent == 50\" style=\"background-image:linear-gradient(90deg, #d0d0d0 50%, transparent 50%)\"><div class=percent>{{contentBrief.percent}}%</div></div><div class=bgCircle ng-if=\"contentBrief.percent > 50\" style=\"background-image:linear-gradient({{(contentBrief.percent * 3.6) - 90}}deg,transparent 50%, #449d44 50%),linear-gradient(90deg, #ccc 50%, transparent 50%)\"><div class=percent>{{contentBrief.percent}}%</div></div></div><!-- Folder --> <img alt={{curFolder[0].type}} ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\'\" src=assets/images/default/folder_selected.png class=\"noOutline img-responsive center-block img-folder\"> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'SharePointC\' && curContent[0].extn != \'WEBP\'\" src=assets/images/default/thumbs/md/sp.png class=\"noOutline img-responsive center-block\"> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'OneDriveC\' && curContent[0].extn != \'WEBP\'\" src=assets/images/default/thumbs/md/od.png class=\"noOutline img-responsive center-block\"><!-- Googledrive --> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'GoogleDriveC\' && curContent[0].extn != \'WEBP\'\" src=assets/images/default/thumbs/md/gd.png class=\"noOutline img-responsive center-block\"><!-- Audio --> <a href=\"\" role=link id=audio{{$index}} ng-if=\"curContent[0].type == \'Audio\' && curContent[0].isCompleted && contentBrief.percent == undefined\" ng-click=\"fbAudioFx(cDetailBucket + curContent[0].url, curContent[0].label);\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a href=\"\" role=link id=flash{{$index}} ng-if=\"curContent[0].type == \'Flash\'\" ng-click=\"fbFlashFx(cDetailBucket + curContent[0].url, curContent[0].label, contentBrief.dimension);\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --><!-- <img alt=\"{{curContent[0].type}}\" ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Power BI\' && curContent[0].extn != \'Live Streaming\' && curContent[0].extn != \'QR Code\' && curContent[0].extn != \'Vimeo\' && curContent[0].isCompleted\" ng-src=\"{{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png?v2\" class=\"img-responsive center-block img-widget\"> --> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Microsoft Power BI\' && curContent[0].extn != \'Live Streaming\' && curContent[0].extn != \'QR Code\' && curContent[0].extn != \'Vimeo\' && curContent[0].extn != \'Web Page\' && curContent[0].extn != \'Auto Login (Basic Auth)\' && curContent[0].isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png?v7 class=\"img-responsive center-block img-widget\"><!-- Web Page Widget--> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'Web Page\' || curContent[0].extn == \'Auto Login (Basic Auth)\') && !curContent[0].ss && curContent[0].isCompleted\" ng-src=\"{{cDetailBucket +\'widgets/thumbs/md/\'+ curContent[0].thumb +\'.png?v\'+ timestamp}}\" class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'Web Page\' || curContent[0].extn == \'Auto Login (Basic Auth)\') && curContent[0].ss && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].ssImg+\'?v\'+timestamp | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].ssImg+\'&v=\'+timestamp + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- PowerBI widget--> <a href=\"\" role=link ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Microsoft Power BI\' && curContent[0].isCompleted\" class=cursorPointer ng-click=\"fbFrameFx(apiHost+\'feed/powerbiHtml/\'+curContent[0].id, curContent[0].label)\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png?v7 class=\"img-responsive center-block img-widget\"> </a><!-- Live Streaming widget--> <a href=\"\" role=link ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Live Streaming\' && curContent[0].isCompleted\" class=cursorPointer id=video{{$index}} ng-click=fbStreamingFx(contentBrief);><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png?v7 class=\"img-responsive center-block img-widget\"> </a><!-- QR widget live thumb --> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'QR Code\' && curContent[0].isCompleted && !isContentDeleted && wVer==\'\' && !qrThumbLoading\" ng-src=\"{{tim + cBucket}}widgets/qrcode/{{curContent[0].id}}.png{{contentBrief.sign}}{{thumbBigParamZc3}}&v={{timestamp}}\" class=\"img-responsive center-block img-widget\"> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'QR Code\' && curContent[0].isCompleted && !isContentDeleted && wVer!=\'\' && !qrThumbLoading\" ng-src=\"{{tim + cBucket}}widgets/qrcode/{{wVer}}-{{curContent[0].id}}.png{{contentBrief.sign}}{{thumbBigParamZc3}}&v={{timestamp}}\" class=\"img-responsive center-block img-widget\"> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'QR Code\' && curContent[0].isCompleted && isContentDeleted && !qrThumbLoading\" ng-src={{cDetailBucket}}widgets/thumbs/lg/na_thumb.png class=\"img-responsive center-block img-widget\"><!-- Images --> <a id=image{{$index}} ng-if=\"(curContent[0].type == \'Image\' && curContent[0].extn != \'WEBP\') && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{thumbHost + tim + cBucket + curContent[0].thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':curContent[0].isblur}\"> </a><a id=webp{{$index}} ng-if=\"curContent[0].extn == \'WEBP\' && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].thumb + thumbBigParam}}\" src-error={{cDetailBucket}}widgets/thumbs/lg/na_thumb.png class=\"img-responsive center-block\"> </a><!-- YouTube && Vimeo--> <a id={{curContent[0].extn}}{{$index}} ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\')\" ng-href={{curContent[0].url}} role=link fancyboxable=fbMedia caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src={{curContent[0].thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a href=\"\" role=link id=video{{$index}} ng-if=\"curContent[0].type == \'Video\' && curContent[0].isCompleted  && (!auth.upermissions.vi || (auth.upermissions.vi && (!curContent[0].vi || (curContent[0].vi && curContent[0].viD.st && curContent[0].viD.st == \'s\' && curContent[0].viD.stpSt))))\" ng-click=\"fbVideoFx(cDetailBucket + curContent[0].url, curContent[0].label);\"><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].thumb + thumbBigParam}}\" class=\"img-responsive center-block\"><!-- <img alt=\"{{curContent[0].type}}\" ng-src=\"{{ !isHovering[curContent[0].id] ? (\'\' + tim + cBucket + curContent[0].thumb + thumbBigParam) : \'assets/images/trans.svg\'}}\"  class=\"img-responsive center-block\" ng-class=\"{\'image-strip-container\':curContent[0].type == \'Video\'}\" ng-mouseover=\"startCycle(curContent[0].id, curContent[0].type, $event)\" ng-mouseleave=\"stopCycle(curContent[0].id, curContent[0].type, $event)\"> --></a><div style=\"position: relative; display: inline-flex; align-items: center; justify-content: center\" ng-if=\"auth.upermissions.vi && curContent[0].type == \'Video\' && curContent[0].isCompleted && curContent[0].vi && curContent[0].viD.st && curContent[0].viD.st == \'p\'\"><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].thumb + thumbBigParam}}\" class=\"img-responsive center-block\" style=\"filter: brightness(0.7)\"> <span style=\"position: absolute;color: #ffffff;padding: 0 5px;display: block\"><div style=\"float: left;background-color: #000;padding: 0 5px\" class=\"marB5 marL5\">{{curContent[0].viD.pc? curContent[0].viD.pc : \'0\'}}%</div></span><div class=d-flex style=\"width:95%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}};height:6px;position: absolute;margin-top:22px\"><div class=transitionWidth style=\"width: {{curContent[0].viD.pc}}%\"><span class=vidIndexLoad-rectPie></span></div></div></div><!-- Other --> <a href=\"\" role=link id=other{{$index}} ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Image\' && curContent[0].type != \'Widget\' && curContent[0].type != \'Video\' && curContent[0].type != \'Audio\' && curContent[0].type != \'Flash\' && curContent[0].type != \'SharePointC\' && curContent[0].type != \'OneDriveC\' && curContent[0].type != \'GoogleDriveC\' && curContent[0].isCompleted\" ng-click=\"fbGalleryFxx(contentBrief.pages, curContent[0].thumb, curContent[0].label, curContent[0].extn, contentBrief.url);\"><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><img alt={{curContent[0].type}} ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Flash\' && !curContent[0].isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':curContent[0].isblur}\"><div class=hoverOverlay ng-if=\"curContent[0].isblur == 1\"><!-- Flash --> <a ng-if=\"curContent[0].type == \'Flash\' && curContent[0].isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + curContent[0].url, curContent[0].label, curContent[0].dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"curContent[0].type == \'Image\' && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{curContent[0].label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\')\" ng-href={{curContent[0].url}} role=link fancyboxable=fbMedia data-fancybox-title={{curContent[0].label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': curContent[0].type != \'Audio\' && curContent[0].type != \'Flash\' && curContent[0].type != \'Image\' &&curContent[0].type != \'Video\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Vimeo\' && curContent[0].type != \'template\'}\" ng-click=\"restrictionInfo(\'info\', curContent[0].severityLevel);\" title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div></span></div><!-- <div class=\"text-ellipsis marT5\">{{curFolder[0].label}} {{curContent[0].label}}</div> --><div class=\"text-ellipsis marT5\" uib-tooltip={{curFolder[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500 ng-if=\"curFolder[0].label != \'\'\">{{curFolder[0].label}}</div><div class=\"text-ellipsis marT5\" uib-tooltip={{curContent[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=500 ng-if=\"curContent[0].label != \'\'\">{{curContent[0].label}}</div><div ng-if=contentBrief.publisher class=\"alert-warning marT5 pad5\"><div class=text-bold ng-class=\"{\'bdr-btm-dashed marB5\':contentLibrary.info.publisherV != contentBrief.publisherV}\">{{\'cm.brief.16\' | translate}} <span ng-if=\"contentBrief.publisherV != \'\'\">{{contentBrief.publisherV}}</span> <span ng-if=\"contentBrief.publisherV == \'\'\">&#60;&nbsp;2.1.4.39</span></div><div class=marT5 ng-if=\"contentLibrary.info.publisherV != contentBrief.publisherV\"><a href=\"\" role=link ui-sref=hub.support.ts>{{\'cl.brief.13\' | translate}}</a></div></div></div><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=\"contentBrief.percent != undefined\"><div lang={{auth.lang}}>{{\'cl.msg.15\' | translate}}</div><div class=marT10><button type=button role=button class=\"btn btn-sm btn-default\" ng-click=reprocessVideoFx(contentBrief.id) ng-disabled=reprocessRequested><span class=\"fa fa-refresh\" aria-hidden=true></span>{{\'cl.btn.18\' | translate}}</button></div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFolder[0].label}} {{curContent[0].label}}</div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'SharePointC\' && contentLibrary.info.sp\"><!--Content--><div class=\"col-xs-5 text-right\">{{\'cl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">SharePoint <span ng-if=curContent[0].extn>[ {{curContent[0].extn}} ]</span></div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'OneDriveC\' && contentLibrary.info.od\"><!--Content--><div class=\"col-xs-5 text-right\">{{\'cl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">OneDrive <span ng-if=curContent[0].extn>[ {{curContent[0].extn}} ]</span></div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'GoogleDriveC\' && contentLibrary.info.gd\"><!--Content--><div class=\"col-xs-5 text-right\">{{\'cl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">Google Drive <span ng-if=curContent[0].extn>[ {{curContent[0].extn}} ]</span></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\'\"><!--Folder--><div class=\"col-xs-5 text-right\">{{\'cm.brief.9\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{contentBrief.contentCount}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"contentCountFx(contentBrief.id, contentBrief.label);\" ng-if=\"contentBrief.contentCount > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'OneDriveC\' && curContent[0].type != \'GoogleDriveC\'\"><!--Content--><div class=\"col-xs-5 text-right\">{{\'cm.brief.12\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"contentBrief.size != null\" uib-tooltip=\"{{\'cm.brief.12\' | translate}}\" tooltip-append-to-body=true>{{(contentBrief.size*1024) | filesize}}</span> <span ng-if=\"contentBrief.size != null && contentBrief.pSize != null\">| </span><span ng-if=\"contentBrief.pSize != null\" uib-tooltip=\"{{\'cl.brief.10\' | translate}}\" tooltip-append-to-body=true>{{(contentBrief.pSize) | filesize}}</span> <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.size == null && contentBrief.pSize == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\"><span ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\' || curContent[0].type == \'Widget\'\">{{\'cm.brief.2\' | translate}}:</span> <span ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Widget\'\">{{\'cl.brief.3\' | translate}}:</span></div><div class=\"col-xs-7 text-bold\"><span ng-if=curFolder[0].createdOn>{{(curFolder[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=curContent[0].createdOn>{{(curContent[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curFolder[0].createdOn == null && curContent[0].createdOn == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\'\"><!--Folder--><div class=\"col-xs-5 text-right\">{{\'cl.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"contentBrief.contentSize != null\" uib-tooltip=\"{{\'cm.brief.12\' | translate}}\" tooltip-append-to-body=true>{{(contentBrief.contentSize*1024) | filesize}}</span> <span ng-if=\"contentBrief.contentSize != null && contentBrief.pContentSize != null\">| </span><span ng-if=\"contentBrief.pContentSize != null\" uib-tooltip=\"{{\'cl.brief.10\' | translate}}\" tooltip-append-to-body=true>{{(contentBrief.pContentSize) | filesize}}</span> <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.contentSize == null && contentBrief.pContentSize == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\'\"><!--Content--><div class=\"col-xs-5 text-right\">{{\'cl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curContent[0].type}} <span ng-if=curContent[0].extn>[ {{(curContent[0].extn == \'Button\' ? curContent[0].extn +\' - \' + curContent[0].btnExtn : curContent[0].extn)}} ]</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\"><span ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\' || curContent[0].type == \'Widget\'\">{{\'cm.brief.3\' | translate}}:</span> <span ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Widget\'\">{{\'cl.brief.4\' | translate}}:</span></div><div class=\"col-xs-7 brief-col\">{{contentBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.createdBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><!--Folder--><div class=col-xs-6 ng-if=\"curFolder[0].type == \'Folder\'\"><div class=\"col-xs-5 text-right\" ng-if=\"auth.uType != 4\">{{\'cl.brief.2\' | translate}}:</div><div class=col-xs-7 ng-if=\"auth.uType != 4\"><switch role=switch class=switch-sm ng-model=curFolder[0].wp aria-checked={{curFolder[0].wp?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=writeProtectedFx(curFolder[0].id)></switch></div></div><!--Content--><div class=col-xs-6 ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\' && curContent[0].extn != \'PDF\' && curContent[0].type != \'WORD\' && curContent[0].type != \'POWERPOINT\'\"><div class=\"col-xs-5 text-right\">{{\'cm.label.49\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curContent[0].duration && (curContent[0].type == \'Audio\' || curContent[0].type == \'Video\' || curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\')\">{{curContent[0].duration | duration | date:\'HH:mm:ss\'}}</span><!-- <span ng-if=\"curContent[0].duration < 1 && (curContent[0].type == \'Audio\' || curContent[0].type == \'Video\' || curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\')\">0 {{\'cm.label.27\' | translate}}</span> --> <span ng-if=\"contentBrief.dType==\'v\' && contentBrief.duration != null\">{{contentBrief.duration | duration | date:\'HH:mm:ss\'}}</span> <span class=\"text-muted text-sm\" ng-if=\"curContent[0].duration && curContent[0].type != \'Audio\' && curContent[0].type != \'Video\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Vimeo\'\">N/A</span> <span class=\"text-muted text-sm\" ng-if=\"curContent[0].duration == null || curContent[0].duration == 0\">N/A</span></div></div><div class=col-xs-6 ng-if=\"(curContent[0].type != \'SharePointC\' && curContent[0].type != \'OneDriveC\' && curContent[0].type != \'GoogleDriveC\') && (curContent[0].extn == \'PDF\' || curContent[0].type == \'WORD\' || curContent[0].type == \'POWERPOINT\')\"><div class=\"col-xs-5 text-right\">{{\'cl.brief.9\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curContent[0].isCompleted && contentBrief.pages\">{{contentBrief.pages}}</span> <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && (!curContent[0].isCompleted || contentBrief.pages == null || contentBrief.pages == 0)\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><!-- Folder shortcut --><div class=col-xs-6 ng-if=\"curFolder[0].type == \'Shortcut\'\"><div class=\"col-xs-5 text-right\">{{\'cl.brief.14\' | translate}}:</div><div class=col-xs-7><switch role=switch class=switch-sm ng-model=curFolder[0].show_to_admin aria-checked={{contentBrief.admin?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=showToAdminFx(contentBrief.fs_id)></switch></div></div></div><!--Content--><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"contentBrief != \'\' && contentBrief.editedOn\">{{(contentBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\'\" ng-click=\"editHistoryFx(curContent[0].id, \'content\', curContent[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\'\" ng-click=\"editHistoryFx(curFolder[0].id, \'folder\', curFolder[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && !contentBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'SharedFolderC\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\' && curContent[0].extn != \'Content on Demand\' && curContent[0].extn != \'Filler Content\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.8\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{contentBrief.dimension}} <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.dimension == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><!--COD--><div class=col-xs-6 ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'Content on Demand\' || curContent[0].extn == \'Filler Content\')\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.9\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{contentBrief.contentCount}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"contentCountFx(contentBrief.id, contentBrief.label,contentBrief.extn);\" ng-if=\"contentBrief.contentCount > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{contentBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && !contentBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\'\"><div class=\"col-xs-5 text-right\">{{\'cm.label.3s\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"contentBrief != \'\' && contentBrief.scheduleCount.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{contentBrief.scheduleCount.a}}</span> <span ng-if=\"contentBrief != \'\' && contentBrief.scheduleCount.a == 0 && contentBrief.scheduleCount.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"contentBrief != \'\' && contentBrief.scheduleCount.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{contentBrief.scheduleCount.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(contentBrief.id, \'schedule\', contentBrief.label, contentBrief.scheduleCount);\" ng-if=\"contentBrief.scheduleCount.a + contentBrief.scheduleCount.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.scheduleCount.a + contentBrief.scheduleCount.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curContent[0].approvedOn>{{(curContent[0].approvedOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curContent[0].approvedOn == null\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.5\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curContent[0].activePeriod>{{curContent[0].activePeriod}}</span> <span class=\"text-muted text-sm\" ng-if=\"curContent[0].activePeriod == null\">{{\'cm.label.16\' | translate}}</span></div></div></div><!--Content--><div class=row ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{contentBrief.approvedBy}} <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.approvedBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.p_mt.1.1\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{contentBrief.mt}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=metaTagOpen(curContent[0].label); ng-if=\"contentBrief != \'\'\">{{contentBrief.mt==0?\'cm.btn.19\':\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><span class=\"fa fa-home marR5\" ng-if=\"contentBrief != \'\' && contentBrief.path\" aria-hidden=true></span>{{contentBrief.path}} <span class=\"text-muted text-sm\" ng-if=\"contentBrief != \'\' && contentBrief.path == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><!--FILLER CONTENT--><!-- <div class=\"col-xs-6\" ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Filler Content\'\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.9\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 text-bold\">\r\n                      {{contentBrief.contentCount}}\r\n                      <button class=\"btn btn-xs btn-default\" ng-click=\"contentCountFx(contentBrief.id, contentBrief.label,contentBrief.extn);\" ng-if=\"contentBrief.contentCount > 0\">{{\'cm.btn.21\' | translate}}</button>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"contentBrief == \'\'\">\r\n                    </div>\r\n                  </div> --><div class=col-xs-6 ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'F45\'\"><div class=\"col-xs-5 text-right\">JSON:</div><div class=\"col-xs-7 text-bold word-break\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"jsonViewOpen(curContent[0].id, curContent[0].label);\">{{\'cm.btn.21\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Instagram\'\"><div class=\"col-xs-5 text-right\">{{\'cl.widget.ss.7\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"instaPrevFx(curContent[0].id, curContent[0].label);\" ng-disabled=instaPrevProcessing>{{\'cl.widget.ss.7\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Crop Comm: Alert Message\'\"><div class=\"col-xs-5 text-right\">{{\'cl.brief.12\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=alertMsgAcknFx(curContent[0].id); ng-disabled=alertMsgAcknProcessing>{{\'cm.btn.17\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"curContent[0].type != \'Widget\' && curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curContent[0].type != \'SharePointC\' && curFolder[0].type != \'Onedrive\' && curContent[0].type != \'OneDriveC\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'GoogleDriveC\'\"><div class=\"col-xs-5 text-right\">{{\'cl.brief.7\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{contentBrief.versions}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=versionsOpen(contentBrief.label); ng-if=\"contentBrief.versions > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"(curContent[0].extn == \'Web Page\' || curContent[0].extn == \'Auto Login (Basic Auth)\' ||  curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\' || curContent[0].extn == \'Live Streaming\' || curContent[0].extn == \'Google Slide\' || curContent[0].extn == \'Web Login\' || curContent[0].extn == \'RSS Feed\' || curContent[0].extn == \'AGC\' || curContent[0].extn == \'Microsoft Teams\' || curContent[0].extn == \'Facebook\' || curContent[0].extn == \'Fullscreen Chrome\' || curContent[0].extn == \'Web Login Chrome\' || curContent[0].extn == \'QR Code\') && contentBrief.url.length\"><div class=\"col-xs-5 text-right\">{{\'cl.widget.cm.10\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\">{{contentBrief.url}} <a href=\"\" role=link class=\"btn-link btn-xs\" ngclipboard data-clipboard-text={{contentBrief.url}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true ng-if=contentBrief.url><span class=\"fa fa-files-o\" aria-hidden=true></span></a> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Intel JCI Map\'\"><div class=\"col-xs-5 text-right\">{{\'cl.widget.jci.6\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=showAllKioskIdsFx();>{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row ng-if=\"contentBrief.repoName || contentBrief.repoPath\"><div class=col-xs-6 ng-if=contentBrief.repoName><div class=\"col-xs-5 text-right\">{{\'cl.widget.cm.10\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><span ng-if=\"contentBrief.repoName !== \'\'\">{{contentBrief.repoName}}</span> <span ng-if=\"contentBrief.repoName == \'\'\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=contentBrief.repoPath><div class=\"col-xs-5 text-right\">{{\'t.tab.5\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><span ng-if=\"contentBrief.repoPath !== \'\'\">{{contentBrief.repoPath}}</span> <span ng-if=\"contentBrief.repoPath == \'\'\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row ng-if=\"curContent[0].type == \'Video\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.11\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><span ng-if=\"contentBrief != \'\'\"><span ng-if=\"contentBrief.isOptimize == 1\">{{\'cm.btn.2\' | translate}}</span> <span ng-if=\"contentBrief.isOptimize == 0\">{{\'cm.btn.3\' | translate}}</span> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=reprocessOpen(); ng-if=auth.upermissions.o ng-disabled=\"contentBrief.percent != undefined\">{{\'cl.btn.22\' | translate}}</button> </span><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6><span ng-if=\"auth.upermissions.vi && curContent[0].isCompleted\"><div class=\"col-xs-5 text-right\">{{\'cl.vi.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"> <span ng-if=\"contentBrief != \'\'\"><span ng-if=\"curContent[0].vi && curContent[0].viD.st && curContent[0].viD.st == \'p\'\"><img alt=Loading src=assets\\images\\loading-xs.gif class=marR5>{{curContent[0].viD.pc}}%</span> <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=!curContent[0].vi ng-click=\"getVIndexer(curContent[0], \'n\', contentLibrary.info);\" ng-disabled=reIndexLoad>{{\'cl.vi.3\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"curContent[0].vi && curContent[0].viD.st && curContent[0].viD.st == \'s\'\" ng-click=\"viewVIndexer(curContent[0].id, curContent[0].viD.id);\">{{\'cm.btn.21\' | translate}}</button></span></div></span></div></div><div class=row ng-if=\"curContent[0].extn == \'Queue\' || curContent[0].extn == \'Survey\' || curContent[0].extn == \'Google Calendar\' || curContent[0].extn == \'Outlook Calendar\' || curContent[0].extn == \'Xovis\' || curContent[0].extn == \'IoT Button\'\"><div class=col-xs-6 ng-if=contentBrief.url.length><div class=\"col-xs-5 text-right\">{{\'cl.widget.cm.10\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\">{{contentBrief.url}} <a href=\"\" role=link class=\"btn-link btn-xs\" ngclipboard data-clipboard-text={{contentBrief.url}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true ng-if=contentBrief.url><span class=\"fa fa-files-o\" aria-hidden=true></span></a> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=contentBrief.sUrl><div class=\"col-xs-5 text-right\">{{\'cl.widget.cm.10\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\">{{contentBrief.sUrl}} <a href=\"\" role=link class=\"btn-link btn-xs\" ngclipboard data-clipboard-text={{contentBrief.sUrl}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true ng-if=contentBrief.sUrl><span class=\"fa fa-files-o\" aria-hidden=true></span></a> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=contentBrief.fUrl><div class=\"col-xs-5 text-right\">{{\'t.tab.5\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\">{{contentBrief.fUrl}} <a href=\"\" role=link class=\"btn-link btn-xs\" ngclipboard data-clipboard-text={{contentBrief.fUrl}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true ng-if=contentBrief.fUrl><span class=\"fa fa-files-o\" aria-hidden=true></span></a> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div></div><div class=row ng-if=contentBrief.isHLSLogs><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'ms.p_s.serverPer.48\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=streamMetricsOpen();>{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"contentBrief == \'\'\"></div></div><div class=col-xs-6></div></div></div></div></div></ul></div><!--For Multiple selected--><div ng-if=\"selectedItems.length > 1\"><div class=\"thumb-list hoverContainer\"><li ng-repeat=\"content in selectedItems\" data-id={{content.id}} class=\"device valign-top briefBox\">{{curFolder = (folderList | folderBrief:selectedItems[$index] | orderBy:\'id\');\"\"}} {{curContent = (contentList | filter:{id:selectedItems[$index].id}:true | orderBy:\'id\');\"\"}}<div class=relative ng-class=\"{\'thumb-sm\':thumbSize==\'sm\',\'thumb-md\':thumbSize==\'md\',\'thumb-lg\':thumbSize==\'lg\',\'thumb-xl\':thumbSize==\'xl\'}\"><a href=\"\" role=link id=remove{{$index}} class=\"thumb-close brief-cl\" ng-click=\"closeFx(content.id, device.type)\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isBlur}\"><!-- Folder --> <img alt={{curFolder[0].type}} ng-if=\"curFolder[0].type == \'Folder\' || curFolder[0].type == \'Shortcut\' || curFolder[0].type == \'Sharepoint\' || curFolder[0].type == \'Onedrive\' || curFolder[0].type == \'SharedFolder\' || curFolder[0].type == \'ExcelFolder\' || curFolder[0].type == \'Googledrive\'\" src=assets/images/default/folder_{{thumbSize}}.png class=\"noOutline img-responsive center-block img-folder\"><!-- Audio --> <a href=\"\" role=link id=audio{{$index}} ng-if=\"curContent[0].type == \'Audio\' && curContent[0].isCompleted\" ng-click=\"fbAudioFx(cDetailBucket + curContent[0].url, curContent[0].label);\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/{{thumbSize}}/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a href=\"\" role=link id=flash{{$index}} ng-if=\"curContent[0].type == \'Flash\'\" ng-click=\"fbFlashFx(cDetailBucket + curContent[0].url, curContent[0].label, contentBrief.dimension);\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/{{thumbSize}}/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><!-- Widget --><!-- <img alt=\"{{curContent[0].type}}\" ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Vimeo\' && curContent[0].extn != \'Power BI\' && curContent[0].isCompleted\" ng-src=\"{{cDetailBucket}}widgets/thumbs/md/{{curContent[0].thumb}}.png\" class=\"img-responsive center-block img-widget\"> --> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Vimeo\' && curContent[0].extn != \'Microsoft Power BI\' && curContent[0].extn !== \'Web Page\' && curContent[0].extn !== \'Auto Login (Basic Auth)\' && curContent[0].isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/{{thumbSize}}/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget--> <img alt={{curContent[0].type}} ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'Web Page\' || curContent[0].extn == \'Auto Login (Basic Auth)\') && !curContent[0].ss && curContent[0].isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/{{thumbSize}}/{{curContent[0].thumb}}.png class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'Web Page\' || curContent[0].extn == \'Auto Login (Basic Auth)\') && curContent[0].ss && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].ssImg | secureThumb:curTime}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{thumbHost + tim + cBucket + curContent[0].ssImg +\'?v\'+ timestamp + thumbParam}}\" class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><!-- PowerBI widget--> <a href=\"\" role=link ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Microsoft Power BI\' && curContent[0].isCompleted\" class=cursorPointer ng-click=\"fbFrameFx(apiHost+\'feed/powerbiHtml/\'+curContent[0].id, curContent[0].label)\"><img alt={{curContent[0].type}} ng-src={{cDetailBucket}}widgets/thumbs/{{thumbSize}}/{{curContent[0].thumb}}.png?v7 class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a id=image{{$index}} ng-if=\"(curContent[0].type == \'Image\' && curContent[0].extn != \'WEBP\') && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{thumbHost + tim + cBucket + curContent[0].thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><img alt={{curContent[0].type}} ng-src=\"{{thumbHost + tim + cBucket + curContent[0].thumb + thumbParam}}\" src-error={{cDetailBucket}}widgets/thumbs/lg/na_thumb.png ng-if=\"curContent[0].extn == \'WEBP\' && curContent[0].isCompleted\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> <img alt={{curContent[0].type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/sp.png ng-if=\"curContent[0].type == \'SharePointC\' && curContent[0].extn != \'WEBP\'\" class=\"img-responsive center-block\"> <img alt={{curContent[0].type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/od.png ng-if=\"curContent[0].type == \'OneDriveC\' && curContent[0].extn != \'WEBP\'\" class=\"img-responsive center-block\"> <img alt={{curContent[0].type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/gd.png ng-if=\"curContent[0].type == \'GoogleDriveC\' && curContent[0].extn != \'WEBP\'\" class=\"img-responsive center-block\"><!-- YouTube --> <a id=youtube{{$index}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'YouTube\'\" ng-href={{curContent[0].url}} role=link fancyboxable=fbMedia caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src={{curContent[0].thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><!-- Vimeo --> <a id=vimeo{{$index}} ng-if=\"curContent[0].type == \'Widget\' && curContent[0].extn == \'Vimeo\'\" ng-href={{curContent[0].url}} role=link fancyboxable=fbMedia caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src={{curContent[0].thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><!-- Video --> <a href=\"\" role=link id=video{{$index}} ng-if=\"curContent[0].type == \'Video\' && curContent[0].isCompleted\" ng-click=\"fbVideoFx(cDetailBucket + curContent[0].url, curContent[0].label);\"><img alt={{curContent[0].type}} ng-src=\"{{tim + cBucket + curContent[0].thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><!-- Other --> <a id=other{{$index}} ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Image\' && curContent[0].type != \'Widget\' && curContent[0].type != \'Video\' && curContent[0].type != \'Audio\' && curContent[0].type != \'Flash\' && curContent[0].type != \'SharePointC\' && curContent[0].type != \'OneDriveC\' && curContent[0].type != \'GoogleDriveC\' && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curContent[0].label}}><img alt={{curContent[0].type}} ng-src=\"{{thumbHost + tim + cBucket + curContent[0].thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isBlur}\"> </a><img alt={{curContent[0].type}} ng-if=\"curFolder[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\' && curFolder[0].type != \'Sharepoint\' && curFolder[0].type != \'Onedrive\' && curFolder[0].type != \'SharedFolder\' && curFolder[0].type != \'ExcelFolder\' && curFolder[0].type != \'Googledrive\' && curContent[0].type != \'Flash\' && !curContent[0].isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=\"curFolder[0].type != \'Shortcut\' && curFolder[0].wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"curFolder[0].type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"curFolder[0].type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"curFolder[0].type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"curFolder[0].type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"curFolder[0].type == \'ExcelFolder\'\" class=excel></span> <span ng-if=\"curFolder[0].type == \'Googledrive\'\" class=googleDrive></span> <span ng-if=\"curContent[0].type != \'Folder\' && curFolder[0].type != \'Shortcut\'\" class=\"{{curContent[0].type.toLowerCase()}} {{curContent[0].extn.toLowerCase()}}\"></span> </span><!-- <span class=\"thumb-icon cl\">\r\n                    <span ng-if=\"content.type==\'Video\' || content.type==\'Audio\' || (content.type==\'Widget\' && content.extn==\'YouTube\' || content.extn==\'Vimeo\')\" class=\"vDuration\">{{content.duration | durations}}</span>\r\n                    <span ng-if=\"content.expiring\" class=\"expiring\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.wp\" ng-class=\"auth.uType==4?\'nonwritable\':\'writable\'\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.sp\" class=\"sharepoint\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.od\" class=\"oneDrive\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.sf\" class=\"sharedFolder\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.ss\" class=\"webpage\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.isblur\" class=\"sensitiveContent\" aria-hidden=\"true\"></span>\r\n                    <span ng-if=\"content.type!=\'folder\' && content.type!=\'Sharepoint\' && content.type!=\'Onedrive\' && content.type!=\'SharedFolder\' && !content.blur\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span>\r\n                  </span> --><div class=hoverOverlay ng-if=\"curContent[0].isblur == 1\"><!-- Flash --> <a ng-if=\"curContent[0].type == \'Flash\' && curContent[0].isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + curContent[0].url, curContent[0].label, curContent[0].dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"curContent[0].type == \'Image\' && curContent[0].isCompleted\" ng-href=\"{{cDetailBucket + curContent[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{curContent[0].label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"curContent[0].type == \'Widget\' && (curContent[0].extn == \'YouTube\' || curContent[0].extn == \'Vimeo\')\" ng-href={{curContent[0].url}} role=link fancyboxable=fbMedia data-fancybox-title={{curContent[0].label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye-slash\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': curContent[0].type != \'Audio\' && curContent[0].type != \'Flash\' && curContent[0].type != \'Image\' &&curContent[0].type != \'Video\' && curContent[0].extn != \'YouTube\' && curContent[0].extn != \'Vimeo\' && curContent[0].type != \'template\'}\" ng-click=\"restrictionInfo(\'info\', curContent[0].severityLevel);\" title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div></span></div><div class=\"thumb-label noMar\" uib-tooltip={{curFolder[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curFolder[0].label != \'\' && (content.type.toLowerCase() == \'folder\' || content.type.toLowerCase() == \'shortcut\' || content.type.toLowerCase() == \'sharepoint\' || content.type.toLowerCase() == \'onedrive\' || content.type.toLowerCase() == \'sharedfolder\' || content.type.toLowerCase() == \'excelfolder\' || content.type.toLowerCase() == \'googledrive\')\">{{curFolder[0].label}}</div><div class=thumb-label uib-tooltip={{curContent[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curContent[0].label != \'\' && content.type != \'folder\'\">{{curContent[0].label}}</div></div><!-- <div class=\"text-ellipsis marT5\">{{curFolder[0].label}} {{curContent[0].label}}</div> --></li></div></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=\"contentBtn.length==0\"> <a href=\"\" role=link id=infoBtn class=\"pull-left marT6\" ng-click=btnInfoOpen(contentBtn.info); ng-if=contentBtn.info.length><img alt=Info src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"contentBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=contentBtn><span class=\"btn-group dropup\" ng-style=\"selectedItems[0].type == \'folder\' && {\'margin-right\':\'3px\'}\" uib-dropdown ng-if=\"contentBtn.buttons.length > 4\"><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle ng-disabled=disabled>{{\'cm.btn.23\' | translate}} <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"mBtn in contentBtn.buttons\"><a href=\"\" role=link id=clEdit{{$index}} ng-if=\"mBtn.key==\'clEdit\'\" ng-click=editFx();><span class=\"fa fa-pencil marR10\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</a> <a href=\"\" role=link id=clReplace{{$index}} ng-if=\"mBtn.key==\'clReplace\'\" ng-click=replaceOpen();><span class=\"fa fa-copy marR10\" aria-hidden=true></span>{{\'cm.btn.26\' | translate}}</a> <a href=\"\" role=link id=clMove{{$index}} ng-if=\"mBtn.key==\'clMove\'\" ng-click=moveOpen(contentBrief.id);><span class=\"fa fa-copy marR10\" aria-hidden=true></span>{{\'cm.btn.50\' | translate}}</a> <a href=\"\" role=link id=clDownload{{$index}} ng-if=\"mBtn.key==\'clDownload\'\" ng-click=downloadOpen();><span class=\"fa fa-download marR10\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</a> <a href=\"\" role=link id=clArchive{{$index}} ng-if=\"mBtn.key==\'clArchive\'\" ng-click=\"confirmOpen(\'archive\');\"><span class=\"fa fa-briefcase marR10\" aria-hidden=true></span>{{\'cl.btn.7\' | translate}}</a> <a href=\"\" role=link id=clApprove{{$index}} ng-if=\"mBtn.key==\'clApprove\'\" ng-click=approveFx();><span class=\"fa fa-check marR10\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</a> <a href=\"\" role=link id=clUnapprove{{$index}} ng-if=\"mBtn.key==\'clUnapprove\'\" ng-click=\"confirmOpen(\'unapprove\');\"><span class=\"fa fa-ban marR10\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</a> <a href=\"\" role=link id=clShortcut{{$index}} ng-if=\"mBtn.key==\'clShortcut\'\" ng-click=shortcutFx();><span class=\"fa fa-share-square-o marR10\" aria-hidden=true></span>{{\'cl.btn.17\' | translate}}</a> <a href=\"\" role=link id=clShortcut{{$index}} ng-if=\"mBtn.key==\'clPinItems\'\" ng-click=\"pinToDBFx(selectedItems, \'c\');\"><span class=\"fa fa-thumb-tack marR10\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</a></li></ul></span><span ng-repeat=\"cBtn in contentBtn.buttons\">{{briefId = (selectedItems[0].type && selectedItems[0].type == \'shortcut\') ? contentBrief.fs_id : contentBrief.id; \"\"}} <button type=button role=button ng-if=\"cBtn.key==\'clOpenFolder\'\" ng-click=\"folderContentFx(briefId, selectedItems[0].splId, selectedItems[0].type);\" class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clSchedule\'\" ng-click=scheduleFx(); class=\"btn btn-success\"><span class=\"fa fa-calendar\" aria-hidden=true></span>{{\'cm.btn.27\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clAddToSchedule\'\" ng-click=addToScheduleOpen(); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.28\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clShortcut\' && contentBtn.buttons.length <= 4\" ng-click=shortcutFx(); class=\"btn btn-default\"><span class=\"fa fa-share-square-o\" aria-hidden=true></span>{{\'cl.btn.17\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clEdit\' && contentBtn.buttons.length <= 4\" ng-click=editFx(); class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clReplace\' && contentBtn.buttons.length <= 4\" ng-click=replaceOpen(); class=\"btn btn-primary\"><span class=\"fa fa-copy\" aria-hidden=true></span>{{\'cm.btn.26\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clMove\' && contentBtn.buttons.length <= 4\" ng-click=moveOpen(contentBrief.id); class=\"btn btn-primary\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cm.btn.50\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clDownload\' && contentBtn.buttons.length <= 4\" ng-click=downloadOpen(); class=\"btn btn-primary\"><span class=\"fa fa-download\" aria-hidden=true></span>{{\'cm.btn.17\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clArchive\' && contentBtn.buttons.length <= 4\" ng-click=\"confirmOpen(\'archive\');\" class=\"btn btn-primary\"><span class=\"fa fa-briefcase\" aria-hidden=true></span>{{\'cl.btn.7\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clApprove\' && contentBtn.buttons.length <= 4\" ng-click=approveFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clUnapprove\' && contentBtn.buttons.length <= 4\" ng-click=\"confirmOpen(\'unapprove\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clOpenImgEditor\'\" ng-click=openImgEditor(selectedItems[0].id) class=\"btn btn-primary\"><span class=\"fa fa-picture-o\" aria-hidden=true></span>{{\'cl.btn.9\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clOpenVidEditor\'\" ng-click=openCapVidEditor(selectedItems[0].id) class=\"btn btn-primary\"><span class=\"fa fa-film\" aria-hidden=true></span>{{\'cl.btn.10\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clRemoveExpiry\'\" ng-click=removeExpiryFx() class=\"btn btn-success\"><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cl.btn.11\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clRestore\'\" ng-click=restoreFx(); class=\"btn btn-success\"><span class=\"fa fa-reply\" aria-hidden=true></span>{{\'cl.btn.12\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clDelete\'\" ng-click=\"confirmOpen(\'delete\');\" class=\"btn btn-danger\"><span class=\"fa fa-trash-o\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clPermanentlyDelete\'\" ng-click=\"confirmOpen(\'pDelete\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cl.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"cBtn.key==\'clPinItems\' && contentBtn.buttons.length <= 4\" ng-click=\"pinToDBFx(selectedItems, \'c\');\" class=\"btn btn-default\"><span class=\"fa fa-thumb-tack\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</button></span></ul></div></section></div>");
$templateCache.put("app/contentLibrary/dir/contentList.html","<!-- Groupling --> <span ng-repeat=\"group in contentGroup\" ng-show=contentGroup.length>{{groupFolderList = (folderList | sameValue:([group.id, \'grp\']));\"\"}} {{groupContentList = (contentList | sameValue:([group.id, \'grp\']));\"\"}} {{groupFolderCount = (groupFolderList | customSearch:{key:searchText, module:\'clf\', filterType:filter});\"\"}} {{groupContentCount = (groupContentList | customSearch:{key:searchText, module:\'cl\', filterType:filter});\"\"}}<div class=\"clGroup nonSelectable\" ng-show=\"groupFolderCount.length + groupContentCount.length > 0\"><a href=\"\" role=link ng-click=\"groupFx($event, group.id, group.isExpand);\"><span class=\"fa fa-chevron-right marR5\" ng-class=\"{\'fa-chevron-down\':group.isExpand}\" aria-hidden=true></span>{{group.label}} <span class=\"text-muted text-unbold text-sm\">({{groupFolderCount.length + groupContentCount.length}})</span></a></div><span ng-show=group.isExpand><li class=tabIndex ng-repeat=\"folder in filteredFolderList = (groupFolderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div ng-class=\"{\'thumb-sm\':thumbSize==\'sm\',\'thumb-md\':thumbSize==\'md\',\'thumb-lg\':thumbSize==\'lg\',\'thumb-xl\':thumbSize==\'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type==\'Shortcut\'\" class=shortcut aria-hidden=true></span> <span ng-if=\"folder.type==\'Sharepoint\'\" class=sharepoint aria-hidden=true></span> <span ng-if=\"folder.type==\'Onedrive\'\" class=oneDrive aria-hidden=true></span> <span ng-if=\"folder.type==\'Googledrive\'\" class=googleDrive aria-hidden=true></span> <span ng-if=\"folder.type==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type==\'Folder\' && folder.subtype==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=folder.wp ng-class=\"auth.uType==4?\'nonwritable\':\'writable\'\" aria-hidden=true></span></span></span></div><div class=thumb-label uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</div></div></li><li class=tabIndex ng-repeat=\"content in filteredContentList = (groupContentList | customSearch:{key:searchText, module:\'cl\', filterType:filter})\" data-id={{content.id}} data-type=\"{{content.type==\'Widget\'?\'widget\':content.type==\'SharePointC\'?\'SharePointC\':content.type==\'OneDriveC\'?\'OneDriveC\':content.type==\'GoogleDriveC\'?\'GoogleDriveC\':\'content\'}}\" data-sub-type={{content.type}} data-is-blur={{content.isblur}} data-severity-level={{content.severityLevel}} data-extn={{content.extn}} ng-class=\"{\'unapprovedFile\':content.isApproved === 0, \'nonSelectable unapprovedFile\':(content.type==\'Widget\' && (content.extn==\'Music Choice\' || content.extn==\'Zkong\') && isNonSelectable)}\" ng-if=\"filter==\'all\' || (filter==\'myContent\' && content.owner==1) || (filter==\'approved\' && content.isApproved==1) || (filter==\'unapproved\' && content.isApproved==0) || filter==content.type\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div ng-class=\"{\'thumb-sm\':thumbSize==\'sm\',\'thumb-md\':thumbSize==\'md\',\'thumb-lg\':thumbSize==\'lg\',\'thumb-xl\':thumbSize==\'xl\'}\"><div class=thumb-img ng-class=\"{\'overflow-hidden\':content.isblur}\"><span class=thumb-inner><!-- <img alt=\"{{content.type}}\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam + curToken}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || content.type == \'Video\' || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=\"img-responsive\" ng-class=\"{\'blurry-img\':content.isblur}\"> --> <img alt={{content.type}} ng-src=\"{{ !isHovering[content.id] ? (tim + cBucket + content.thumb + thumbParam + curToken) : \'assets/images/trans.svg\'}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || (content.type == \'Video\' && (!auth.upermissions.vi || (auth.upermissions.vi && (!content.vi || (content.vi && content.viD.st && content.viD.st == \'s\' && content.viD.stpSt))))) || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur, \'image-strip-container\':content.type == \'Video\'}\" ng-mouseover=\"startCycle(content, $event)\" ng-mouseleave=\"stopCycle(content, $event)\"><div style=\"position: relative; display: inline-flex; align-items: center; justify-content: center\" ng-if=\"content.type == \'Video\' && auth.upermissions.vi && content.isCompleted && content.vi && content.viD.st && content.viD.st == \'p\'\"><img alt={{content.type}} ng-if=\"auth.upermissions.vi && content.type == \'Video\' && content.isCompleted && content.vi && content.viD.st && content.viD.st == \'p\'\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam + curToken}}\" class=img-responsive style=\"filter: brightness(0.4)\"><div class=marB5 style=\"position: absolute;color: #ffffff;font-size: 11px;background-color: #000;padding: 0 5px\" ng-if=\"content.viD.st == \'p\'\">{{content.viD.pc? content.viD.pc: \'0\'}}%</div><div class=d-flex style=\"width:95%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}};height:4px;position: absolute;margin-top:22px\" ng-if=\"content.viD.st == \'p\'\"><div class=transitionWidth style=\"width: {{content.viD.pc}}%\"><span class=vidIndexLoad-rectPie style=\"height: 4px\"></span></div></div></div><img alt={{content.type}} ng-src=\"{{tim + cBucket + content.thumb + thumbParam + curToken}}\" src-error=\"{{cDetailBucket +\'widgets/thumbs/\'+ thumbSize +\'/na_thumb.png\'}}\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"><!-- <img alt=\"{{content.type}}\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v3\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && (content.extn == \'Web Page\' && !content.ss)\" class=\"img-responsive\"> --><!-- widget --> <img alt={{content.type}} ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v7\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{content.ss?tim + cBucket + content.ssImg +\'&v\'+ timestamp + thumbParam + curToken:cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb+\'.png?v3\'}}\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\'))\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"><!-- Web Page Widget--><!-- <img alt=\"{{content.type}}\" ng-src=\"{{tim + cBucket + content.ssImg +\'&v=\'+ timestamp + thumbParam + curToken}}\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) && (content.extn == \'Web Page\' && content.ss))\" class=\"img-responsive\"> --> <img alt=Processing ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize}}/processing_thumb.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\" class=img-responsive> <img alt={{content.type}} ng-src=\"{{content.thumb | trustUrl}}\" ng-if=\"content.type==\'Widget\' && (content.extn==\'YouTube\' || content.extn==\'Vimeo\')\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=sp ng-src=assets/images/default/thumbs/lg/sp.png ng-if=\"content.type==\'SharePointC\'\" class=img-responsive> <img alt=od ng-src=assets/images/default/thumbs/lg/od.png ng-if=\"content.type==\'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=gd ng-src=assets/images/default/thumbs/lg/gd.png ng-if=\"content.type==\'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=\"content.type==\'Video\' || content.type==\'Audio\' || (content.type==\'Widget\' && content.extn ==\'YouTube\' || content.extn ==\'Vimeo\')\" class=vDuration aria-hidden=true>{{content.duration | durations}}</span> <span ng-if=content.expiring class=expiring aria-hidden=true></span> <span ng-if=content.wp ng-class=\"auth.uType==4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> <span ng-if=content.sp class=sharepoint aria-hidden=true></span> <span ng-if=content.od class=oneDrive aria-hidden=true></span> <span ng-if=content.gd class=googleDrive aria-hidden=true></span> <span ng-if=content.sf class=sharedFolder aria-hidden=true></span> <span ng-if=content.isblur class=sensitiveContent aria-hidden=true></span> <span ng-if=\"content.type != \'folder\' && content.type != \'Sharepoint\' && content.type != \'Onedrive\' && content.type != \'SharedFolder\' && content.type != \'Googledrive\' && !content.blur\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\" aria-hidden=true></span></span></span></div><div class=thumb-label uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</div></div></li></span></span><!-- Folder / Content --> <span ng-show=!contentGroup.length><li class=tabIndex ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div ng-class=\"{\'thumb-sm\':thumbSize==\'sm\',\'thumb-md\':thumbSize==\'md\',\'thumb-lg\':thumbSize==\'lg\', \'thumb-xl\':thumbSize==\'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type==\'Shortcut\'\" class=shortcut aria-hidden=true></span> <span ng-if=\"folder.type==\'Sharepoint\'\" class=sharepoint aria-hidden=true></span> <span ng-if=\"folder.type==\'Onedrive\'\" class=oneDrive aria-hidden=true></span> <span ng-if=\"folder.type==\'Googledrive\'\" class=googleDrive aria-hidden=true></span> <span ng-if=\"folder.type == \'ExcelFolder\'\" class=excel aria-hidden=true></span> <span ng-if=\"folder.type==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type==\'Folder\' && folder.subtype==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.wp && folder.type != \'ExcelFolder\'\" ng-class=\"auth.uType==4?\'nonwritable\':\'writable\'\" aria-hidden=true></span></span></span></div><div class=thumb-label uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</div></div></li><li class=tabIndex ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:searchText, module:\'cl\', filterType:filter})\" data-id={{content.id}} data-type=\"{{content.type==\'Widget\'?\'widget\':content.type==\'SharePointC\'?\'SharePointC\':content.type==\'OneDriveC\'?\'OneDriveC\':content.type==\'GoogleDriveC\'?\'GoogleDriveC\':\'content\'}}\" data-sub-type={{content.type}} data-extn={{content.extn}} data-is-blur={{content.isblur}} data-severity-level={{content.severityLevel}} ng-class=\"{\'unapprovedFile\':content.isApproved === 0, \'nonSelectable unapprovedFile\':(content.type==\'Widget\' && (content.extn==\'Music Choice\' || content.extn==\'Zkong\') && isNonSelectable)}\" ng-if=\"filter==\'all\' || (filter==\'myContent\' && content.owner==1) || (filter==\'approved\' && content.isApproved==1) || (filter==\'unapproved\' && content.isApproved==0) || filter==content.type\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div ng-class=\"{\'thumb-sm\':thumbSize==\'sm\',\'thumb-md\':thumbSize==\'md\',\'thumb-lg\':thumbSize==\'lg\',\'thumb-xl\':thumbSize==\'xl\'}\"><div class=thumb-img ng-class=\"{\'overflow-hidden\':content.isblur}\"><span class=\"thumb-inner minW0\"><img alt={{content.type}} ng-src=\"{{ !isHovering[content.id] ? (thumbHost + tim + cBucket + content.thumb + thumbParam + curToken) : \'assets/images/trans.svg\'}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || (content.type == \'Video\' && (!auth.upermissions.vi || (auth.upermissions.vi && (!content.vi || (content.vi && content.viD.st && content.viD.st == \'s\' && content.viD.stpSt))))) || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur, \'image-strip-container\':content.type == \'Video\'}\" ng-mouseover=\"startCycle(content, $event)\" ng-mouseleave=\"stopCycle(content, $event)\"><div style=\"position: relative; display: inline-flex; align-items: center; justify-content: center\" ng-if=\"content.type == \'Video\' && auth.upermissions.vi && content.isCompleted && content.vi && content.viD.st && content.viD.st == \'p\'\"><img alt={{content.type}} ng-if=\"auth.upermissions.vi && content.type == \'Video\' && content.isCompleted && content.vi && content.viD.st && content.viD.st == \'p\'\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam + curToken}}\" class=img-responsive style=\"filter: brightness(0.4)\"><div class=marB5 style=\"position: absolute;color: #ffffff;font-size: 11px;background-color: #000;padding: 0 5px\" ng-if=\"content.viD.st == \'p\'\">{{content.viD.pc? content.viD.pc: \'0\'}}%</div><div class=d-flex style=\"width:95%;background-color:{{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}};height:4px;position: absolute;margin-top:22px\" ng-if=\"content.viD.st == \'p\'\"><div class=transitionWidth style=\"width: {{content.viD.pc}}%\"><span class=vidIndexLoad-rectPie style=\"height: 4px\"></span></div></div></div><!-- <img alt=\"{{content.type}}\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam + curToken}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || content.type == \'Video\' || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=\"img-responsive\" ng-class=\"{\'blurry-img\':content.isblur}\"> --> <img alt={{content.type}} ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam + curToken}}\" src-error=\"{{cDetailBucket +\'widgets/thumbs/\'+ thumbSize +\'/na_thumb.png\'}}\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"><!-- <img alt=\"{{content.type}}\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v3\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\'\" class=\"img-responsive\"> --> <img alt={{content.type}} ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v7\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{content.ss?tim + cBucket + content.ssImg +\'&v\'+ timestamp + thumbParam + curToken:cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb+\'.png?v7\'}}\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\'))\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize}}/processing_thumb.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\" class=img-responsive> <img alt={{content.type}} ng-src=\"{{content.thumb | trustUrl}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" class=img-responsive> <img alt={{content.type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt={{content.type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/od.png ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt={{content.type}} ng-src=assets/images/default/thumbs/{{thumbSize}}/gd.png ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=content.isSchedule class=\"fa fa-check text-success text-sm isSchedule\" aria-hidden=true uib-tooltip=\"{{\'s.body.8\' | translate}}\" tooltip-popup-delay=500></span> <span ng-if=\"content.type==\'Video\' || content.type==\'Audio\' || (content.type==\'Widget\' && content.extn==\'YouTube\' || content.extn==\'Vimeo\')\" class=vDuration>{{content.duration | durations}}</span> <span ng-if=content.expiring class=expiring aria-hidden=true></span> <span ng-if=content.wp ng-class=\"auth.uType==4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> <span ng-if=content.sp class=sharepoint aria-hidden=true></span> <span ng-if=content.od class=oneDrive aria-hidden=true></span> <span ng-if=content.gd class=googleDrive aria-hidden=true></span> <span ng-if=content.sf class=sharedFolder aria-hidden=true></span> <span ng-if=content.ss class=webpage aria-hidden=true></span> <span ng-if=content.isblur class=sensitiveContent aria-hidden=true></span> <span ng-if=\"content.type!=\'folder\' && content.type!=\'Sharepoint\' && content.type!=\'Onedrive\' && content.type!=\'SharedFolder\' && content.type!=\'Googledrive\' && !content.blur\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</div></div></li></span><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFolderList.length + filteredContentList.length==0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(filteredFolderList.length==0 && filteredContentList.length > 0 && filterCount==0 && ftype !=\'sp\') || (filteredFolderList.length==0 && filteredContentList.length > 0 && !filterSearch && ftype !=\'sp\')\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div>");
$templateCache.put("app/contentLibrary/dir/contentListView.html","<!-- Groupling --><!-- <span class=\"cl-listViewQuad\"> --> {{isPopupContentList = (($state.current.name == \'hub.contentLibrary.c\' || $state.current.name == \'hub.contentLibrary.uc\' || $state.current.name == \'hub.contentLibrary.ec\' || $state.current.name == \'hub.contentLibrary.ac\' || $state.current.name == \'hub.contentLibrary.dc\')?false:true);\"\"}} <span ng-repeat=\"group in contentGroup\" ng-show=contentGroup.length>{{groupFolderList = (folderList | sameValue:([group.id, \'grp\']));\"\"}} {{groupContentList = (contentList | sameValue:([group.id, \'grp\']));\"\"}} {{groupFolderCount = (groupFolderList | customSearch:{key:searchText, module:\'clf\', filterType:filter});\"\"}} {{groupContentCount = (groupContentList | customSearch:{key:searchText, module:\'cl\', filterType:filter});\"\"}}<div class=\"clGroup nonSelectable\" ng-show=\"groupFolderCount.length + groupContentCount.length > 0\"><a role=button ng-click=\"groupFx($event, group.id, group.isExpand);\"><span class=\"fa fa-chevron-right marR5\" ng-class=\"{\'fa-chevron-down\':group.isExpand}\"></span>{{group.label}} <span class=\"text-muted text-unbold text-sm\">({{groupFolderCount.length + groupContentCount.length}})</span></a></div><span ng-show=group.isExpand><div class=\"row th noPadT\" ng-if=\"groupFolderCount.length + groupContentCount.length > 0\"><div class=col-xs-2><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-2><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'createdon\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.2\' | translate}}</span></div><div class=col-xs-2><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'createdby\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.3\' | translate}}</span></div><div class=col-xs-2><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-1 text-right noPad\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList>{{\'s.body.8\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (groupFolderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div class=\"col-xs-2 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut aria-hidden=true></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint aria-hidden=true></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive aria-hidden=true></span> <span ng-if=\"folder.type == \'Googledrive\'\" class=googleDrive aria-hidden=true></span> <span ng-if=\"folder.type == \'ExcelFolder\'\" class=excel aria-hidden=true></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=col-xs-2>{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" uib-tooltip={{folder.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.cBy}}</div><div class=\"col-xs-2 text-sm\">{{folder.type}}</div><div class=\"col-xs-1 text-right noPad text-sm\">{{(folder.ps) | filesize}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList><span class=\"fa fa-check text-success\" aria-hidden=true></span></div><div class=\"col-xs-2 text-right text-sm\">{{folder.d}}</div></li><li class=row ng-repeat=\"content in filteredContentList = (groupContentList | customSearch:{key:searchText, module:\'cl\', filterType:filter})\" data-id={{content.id}} data-type=\"{{content.type == \'Widget\'?\'widget\':content.type==\'SharePointC\'?\'SharePointC\':content.type==\'OneDriveC\'?\'OneDriveC\':content.type==\'GoogleDriveC\'?\'GoogleDriveC\':\'content\'}}\" data-sub-type={{content.type}} data-is-blur={{content.isblur}} data-severity-level={{content.severityLevel}} data-extn={{content.extn}} ng-class=\"{\'unapprovedFile\':content.isApproved === 0, \'nonSelectable unapprovedFile\':(content.type == \'Widget\' && (content.extn == \'Music Choice\' || content.extn == \'Zkong\') && isNonSelectable)}\" ng-if=\"filter == \'all\' || (filter == \'myContent\' && content.owner == 1) || (filter == \'approved\' && content.isApproved == 1) || (filter == \'unapproved\' && content.isApproved == 0) || filter == content.type\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-2 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\" aria-hidden=true></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\" aria-hidden=true></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\" aria-hidden=true></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring aria-hidden=true></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> <span ng-if=content.sp class=sharepoint aria-hidden=true></span> <span ng-if=content.od class=oneDrive aria-hidden=true></span> <span ng-if=content.gd class=googleDrive aria-hidden=true></span> <span ng-if=content.sf class=sharedFolder aria-hidden=true></span> <span ng-if=content.isblur class=sensitiveContent aria-hidden=true></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><div class=col-xs-2>{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" uib-tooltip={{content.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.cBy}}</div><div class=\"col-xs-2 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-1 text-right noPad text-sm\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList><span ng-if=content.isSchedule class=\"fa fa-check text-success\" aria-hidden=true></span></div><div class=\"col-xs-2 text-right text-sm\">{{content.d}}</div></li></span></span><!-- Folder / Content --> <span ng-show=!contentGroup.length><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div ng-class=\"isPopupContentList?\'col-xs-4\':\'col-xs-2\'\"><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-2 ng-hide=isPopupContentList><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'createdon\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.2\' | translate}}</span></div><div class=col-xs-2 ng-hide=isPopupContentList><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'createdby\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.3\' | translate}}</span></div><div class=col-xs-2 ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\"><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList, contentLibrary.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-1 noPad\" ng-class=\"isPopupContentList?\'col-xs-2\':\'col-xs-1 text-right\'\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList>{{\'s.body.8\' | translate}}</div><div class=\"col-xs-2 text-right\" ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div class=text-ellipsis ng-class=\"isPopupContentList?\'col-xs-4\':\'col-xs-2\'\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut aria-hidden=true></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint aria-hidden=true></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive aria-hidden=true></span> <span ng-if=\"folder.type == \'Googledrive\'\" class=googleDrive aria-hidden=true></span> <span ng-if=\"folder.type == \'ExcelFolder\'\" class=excel aria-hidden=true></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=col-xs-2 ng-hide=isPopupContentList>{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" ng-hide=isPopupContentList uib-tooltip={{folder.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.cBy}}</div><div class=\"col-xs-2 text-sm\" ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\">{{folder.type}}</div><div class=\"col-xs-1 noPad text-sm\" ng-class=\"isPopupContentList?\'col-xs-2\':\'col-xs-1 text-right\'\">{{(folder.ps) | filesize}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList><span ng-if=content.isSchedule class=\"fa fa-check text-success\" aria-hidden=true></span></div><div class=\"col-xs-2 text-right text-sm\" ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\">{{folder.d}}</div></li><li class=row ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:searchText, module:\'cl\', filterType:filter})\" data-id={{content.id}} data-type=\"{{content.type == \'Widget\'?\'widget\':content.type==\'SharePointC\'?\'SharePointC\':content.type==\'OneDriveC\'?\'OneDriveC\':content.type==\'GoogleDriveC\'?\'GoogleDriveC\':\'content\'}}\" data-sub-type={{content.type}} data-extn={{content.extn}} data-is-blur={{content.isblur}} data-severity-level={{content.severityLevel}} ng-class=\"{\'unapprovedFile\':content.isApproved === 0, \'nonSelectable unapprovedFile\':(content.type == \'Widget\' && (content.extn == \'Music Choice\' || content.extn == \'Zkong\') && isNonSelectable)}\" ng-if=\"filter == \'all\' || (filter == \'myContent\' && content.owner == 1) || (filter == \'approved\' && content.isApproved == 1) || (filter == \'unapproved\' && content.isApproved == 0) || filter == content.type\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"text-ellipsis clViwe\" ng-class=\"isPopupContentList?\'col-xs-4\':\'col-xs-2\'\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\" aria-hidden=true></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\" aria-hidden=true></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\" aria-hidden=true></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && !content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type !== \'Video\' && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> <span ng-if=content.sp class=sharepoint aria-hidden=true></span> <span ng-if=content.od class=oneDrive aria-hidden=true></span> <span ng-if=content.gd class=googleDrive aria-hidden=true></span> <span ng-if=content.sf class=sharedFolder aria-hidden=true></span> <span ng-if=content.isblur class=sensitiveContent aria-hidden=true></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><div class=col-xs-2 ng-hide=isPopupContentList>{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" ng-hide=isPopupContentList uib-tooltip={{content.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.cBy}}</div><div class=\"col-xs-2 text-sm\" ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-1 noPad text-sm\" ng-class=\"isPopupContentList?\'col-xs-2\':\'col-xs-1 text-right\'\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-1 text-right\" ng-if=!isPopupContentList><span ng-if=content.isSchedule class=\"fa fa-check text-success\" aria-hidden=true></span></div><div class=\"col-xs-2 text-right text-sm\" ng-class=\"isPopupContentList?\'col-xs-3\':\'col-xs-2\'\">{{content.d}}</div></li></span><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFolderList.length + filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(filteredFolderList.length == 0 && filteredContentList.length > 0 && filterCount == 0 && ftype !=\'sp\') || (filteredFolderList.length == 0 && filteredContentList.length > 0 && !filterSearch && ftype !=\'sp\')\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div>");
$templateCache.put("app/contentLibrary/dir/templateListing.html","<li ng-repeat=\"template in filteredTemplateList = (templates.templates | customSearch:{key:searchText, module:\'t\'})\" single-selected data-id={{template.id}} data-type=Template ng-class=\"{\'unapprovedFile\': selectedTab === \'hub.templates.ut\'}\" context-menu=contextMenuOpt><div class=thumb-img><img alt=Incomplete src=assets/images/default/incomplete.png ng-if=!template.thumb> <img alt=Template ng-src=\"{{tim + cBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" ng-if=template.thumb></div><div class=thumb-label>{{template.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div>");
$templateCache.put("app/contentLibrary/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'clOpenFolder\'\">{{\'cl.btn.8\' | translate}}</span> <span ng-if=\"btn.key==\'clEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'clReplace\'\">{{\'cm.btn.26\' | translate}}</span> <span ng-if=\"btn.key==\'clMove\'\">{{\'cm.btn.50\' | translate}}</span> <span ng-if=\"btn.key==\'clDownload\'\">{{\'cm.btn.17\' | translate}}</span> <span ng-if=\"btn.key==\'clArchive\'\">{{\'cl.btn.7\' | translate}}</span> <span ng-if=\"btn.key==\'clApprove\'\">{{\'cm.btn.24\' | translate}}</span> <span ng-if=\"btn.key==\'clUnapprove\'\">{{\'cm.btn.25\' | translate}}</span> <span ng-if=\"btn.key==\'clSchedule\'\">{{\'cm.btn.27\' | translate}}</span> <span ng-if=\"btn.key==\'clAddToSchedule\'\">{{\'cm.btn.28\' | translate}}</span> <span ng-if=\"btn.key==\'clShortcut\'\">{{\'cl.btn.17\' | translate}}</span> <span ng-if=\"btn.key==\'clOpenImgEditor\'\">{{\'cl.btn.9\' | translate}}</span> <span ng-if=\"btn.key==\'clOpenVidEditor\'\">{{\'cl.btn.10\' | translate}}</span> <span ng-if=\"btn.key==\'clRemoveExpiry\'\">{{\'cl.btn.11\' | translate}}</span> <span ng-if=\"btn.key==\'clDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'clRestore\'\">{{\'cl.btn.12\' | translate}}</span> <span ng-if=\"btn.key==\'clPermanentlyDelete\'\">{{\'cl.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'clSensitiveContentUploader\' || btn.key==\'clSensitiveContentApprover\'\">{{\'cm.acs.18\' | translate}}</span></div><div class=text-ellipsis-wrap>{{\'btnInfo.\'+ btn.code | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/captionLanguages.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cl.label.21\" | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><div class=\"bg-light pad10 marB20\"><div class=row><div class=col-xs-12><label for=label>{{\'cl.widget.oh.8\' | translate}}</label><input type=text class=form-control ng-model=curLangObj.label id=label aria-label=label aria-labelledby=label></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=langAddFx(); ng-disabled=langProcessing><span ng-if=!curLangObj.id><span ng-class=\"langProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'cl.btn.23\' | translate}}</span> <span ng-if=curLangObj.id><span ng-class=\"langProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=reset role=button class=\"btn btn-link\" ng-click=langResetFx(); ng-disabled=langProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'label\'\" aria-live=polite role=status>{{\'cl.msg.41\' | translate}}</div><div ng-if=\"errTypePop==\'same\'\" aria-live=polite role=status>{{\'cl.msg.42\' | translate}}</div></div></div></div></div></div><div class=\"table bg-white no-th\"><div class=\"row th bg-white\"><div class=col-xs-7>{{\'cl.widget.oh.8\' | translate}}</div><div class=\"col-xs-5 text-right\">{{\'cm.label.25\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=langDataLoading class=pad10><div ng-if=!langDataLoading><div class=scrollQuad style=max-height:{{getAvailableHeight(440)}}px><div class=row ng-repeat=\"lang in langObj.languages\"><div class=\"col-xs-7 word-break\">{{lang.label}}</div><div class=\"col-xs-5 text-right\"><a href=\"\" role=link ng-if=!lang.isDef class=\"text-primary marR10\" ng-click=langEditFx(lang);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=!lang.isDef class=text-danger ng-click=langDeleteOpen(lang.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!langDataLoading && !langObj.languages.length\">{{\'cl.msg.43\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=resetImportFx();closeThisDialog(); data-dismiss=modal>{{\"cm.btn.10\" | translate}}</button></span></footer></section>");
$templateCache.put("app/contentLibrary/popup/contentEdit.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.p_cEdit.1\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=label>{{\'cl.p_cEdit.2\' | translate}}</label><input type=text class=form-control ng-model=content.info.label autocomplete=off id=label aria-label=label aria-labelledby=label></div><div class=row><div class=col-xs-12><div class=\"form-group pull-left\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=content.permission pid=content.info.id module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left bdrLd padL20 marL20\" ng-class=\"{\'noPadL noMarL noBdr\':isPermissionOpen}\"><label ng-class=\"{\'marT15\':isPermissionOpen}\">{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=content.activePeriod></ng-active-period></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=contentEditFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.msg.16\' | translate}}</span><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/contentLibrary/popup/contentList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-50\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'content\',contentCountList.brief); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR hide\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx input-group bdrR\" style=width:200px><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\"></span></a> <span class=input-group-btn uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><!-- <li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'tcl\');\">{{\'cm.body.10\' | translate}}</a></li> --><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); \">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><img alt=Loading src=assets/images/loading.gif ng-if=!contentCountList.content.length><ul class=\"list-inline thumb-list noHover\" ng-if=\"contentCountList.content && auth.upreferences.contentView == \'t\'\"><li class=noMar ng-repeat=\"content in filteredContentList = (contentCountList.content | filter:{label:searchTextPopup})\"><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a href=\"\" role=link ng-if=\"content.type == \'Audio\' && content.isCompleted\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a href=\"\" role=link ng-if=\"content.type == \'Flash\' && content.isCompleted\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Images --> <a ng-if=\"content.type == \'Image\' && content.isCompleted\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{thumbHost + contentCountList.info.timthumb + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss\" ng-href=\"{{cDetailBucket+content.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{thumbHost + {contentCountList.info.timthumb + cBucket + content.ssImg+\'&v=\'+timestamp + thumbParam}}\" class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.isCompleted\" ng-src=\"{{contentCountList.info.timthumb + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"><!-- YouTube && Vimeo--> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Video --> <a href=\"\" role=link ng-if=\"content.type == \'Video\' && content.isCompleted\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{thumbHost + contentCountList.info.timthumb + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Processing --> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type == \'Video\' || content.type == \'Audio\' || (content.type == \'Widget\' && (content.extn  == \'YouTube\' || content.extn  == \'Vimeo\'))\" class=vDuration>{{content.duration | durations}}</span> <span ng-if=\"content.type !== \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{content.label}}>{{content.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"contentCountList.content && auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"contentCountList.content.length > 0\"><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.2\' | translate}}</div>\r\n        <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 noPad\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"content in filteredContentList = (contentCountList.content | filter:{label:searchTextPopup})\" ng-click=\"selectFx($event, \'content\', content, content.type);\" ng-if=content.isCompleted><div class=\"col-xs-4 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\" aria-hidden=true></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\" aria-hidden=true></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\" aria-hidden=true></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring aria-hidden=true></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\" aria-hidden=true></span> <span ng-if=content.sp class=sharepoint aria-hidden=true></span> <span ng-if=content.od class=oneDrive aria-hidden=true></span> <span ng-if=content.sf class=sharedFolder aria-hidden=true></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]]</span></div><div class=\"col-xs-2 noPad text-sm\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{content.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/f45JsonViewer.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cl.widget.wf45.17\" | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-80\">{{jsonObj.label}}</span> ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\"cl.widget.wf45.17.1\" | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\">{{\"cl.widget.wf45.17.2\" | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'3\'}\" ng-click=\"tabFx(3, \'tabFx\');\">{{\"cl.widget.wf45.17.3\" | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'4\'}\" ng-click=\"tabFx(4, \'tabFx\');\">{{\"cl.widget.wf45.17.4\" | translate}}</a></header><div id=jsonQuad class=\"bg-light pad10 scrollQuad\" style=max-height:{{getAvailableHeight(370)}}px></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default btn-sm\" ngclipboard data-clipboard-text=\"{{jsonObj.data | json}}\" uib-tooltip=\"{{\'d.tool.17.1\' | translate}}\" tooltip-enable=isCopied tooltip-is-open=isCopied ng-click=\"isCopied=true\"><span class=\"fa fa-files-o\" aria-hidden=true></span>{{\"d.tool.17\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.10\" | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/folderCU.html","<section class=panel role=dialog><header class=panel-heading><span ng-if=!ngDialogData.id><h1 ng-if=\"folder.info.fType==\'n\'\" role=heading aria-level=1>{{\'cl.p_f.1\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'sp\'\" role=heading aria-level=1>{{\'cl.p_f.1.1\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'od\'\" role=heading aria-level=1>{{\'cl.p_f.1.2\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'pf\'\" role=heading aria-level=1>{{\'cl.p_f.1.3\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'sf\'\" role=heading aria-level=1>{{\'cl.p_f.1.4\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'gd\'\" role=heading aria-level=1>{{\'cl.p_f.1.5\' | translate}}</h1></span><span ng-if=ngDialogData.id><h1 ng-if=\"folder.info.fType==\'n\'\" role=heading aria-level=1>{{\'cl.p_f.2\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'sp\'\" role=heading aria-level=1>{{\'cl.p_f.2.1\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'od\'\" role=heading aria-level=1>{{\'cl.p_f.2.2\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'pf\'\" role=heading aria-level=1>{{\'cl.p_f.2.3\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'sf\'\" role=heading aria-level=1>{{\'cl.p_f.2.4\' | translate}}</h1><h1 ng-if=\"folderObj.fType==\'ef\'\" role=heading aria-level=1>{{\'cl.widget.es.4\' | translate}}</h1><h1 ng-if=\"folder.info.fType==\'gd\'\" role=heading aria-level=1>{{\'cl.p_f.2.5\' | translate}}</h1></span><div ng-if=\"folderObj.fType == \'ef\'\" class=\"pull-right bdrR\"><a href=\"\" role=link target=_blank ng-if=\"folder.info.excelDUrl && auth.upermissions.edl\" ng-click=downloadSheetFx(folder.info.excelDUrl); class=padLR10 uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-download\" aria-hidden=true></span></a></div></header><div class=panel-body ng-class=\"{\'scrollQuad\':($root.isPermissionOpen || (!$root.isPermissionOpen && !status.ssOpen))}\" ng-attr-style=max-height:{{getAvailableHeight(350)}}px><div class=form-group><label for=label>{{\'cl.p_f.3\' | translate}}</label><input type=text class=form-control ng-keypress=\"$event.keyCode == 13 && folderCUFx();\" ng-model=folder.info.label autocomplete=off maxlength={{inputLimit}} id=label aria-label=label aria-labelledby=label></div><!-- Google Drive --><div ng-if=\"auth.uservices.gd.active && folder.info.fType == \'gd\'\"><div ng-if=\"decId == \'\'\"><div class=form-group ng-if=\"auth.uservices.gd.sp && !auth.uservices.gd.oauth\"><label class=\"noMarB bg-muted pad2 padLR5\">{{\'cl.p_f.21\' | translate | camelCase}}</label></div><div class=form-group ng-if=\"!auth.uservices.gd.sp && auth.uservices.gd.oauth\"><label class=\"noMarB bg-muted pad2 padLR5\">{{\'cl.p_f.20\' | translate}}</label></div><div class=form-group ng-if=\"auth.uservices.gd.sp && auth.uservices.gd.oauth\"><label class=\"noMarB marR5\"><input type=radio role=radio ng-model=folder.info.gdType value=sp name=gdOpt ng-change=\"gdSelectOptFx(\'first\');\" aria-labelledby=\"{{\'cl.p_f.21\' | translate}}\"><label></label>{{\'cl.p_f.21\' | translate | camelCase}}</label><label class=noMarB><input type=radio role=radio ng-model=folder.info.gdType value=oauth name=gdOpt ng-change=gdSelectOptFx(); aria-labelledby=\"{{\'cl.p_f.20\' | translate}}\"><label></label>{{\'cl.p_f.20\' | translate}}</label></div><div class=form-group ng-if=\"!folderLoading && folder.info.gdType == \'oauth\'\"><button type=button role=button id=gdBtn class=\"btn btn-success\" ng-click=\"gdSelectOptFx(\'first\');\" ng-if=!curStatus.isVerified ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button><div ng-if=curStatus.isVerified class=msg-success>{{\'cl.p_f.m11\' | translate: {userInfo:userInfo.owner_name} }}</div><!-- <button type=\"button\" role=\"button\" id=\"gdReBtn\" class=\"btn btn-primary\" ng-click=\"reAuthOpen(\'gdRe\');\" ng-if=\"curStatus.isVerified\" ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.1\' | translate}}</button>\r\n          <button type=\"button\" role=\"button\" id=\"gdReOuBtn\" class=\"btn btn-default\" ng-click=\"reAuthOpen(\'gdReOu\');\" ng-if=\"curStatus.isVerified\" ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.2\' | translate}}</button> --></div><div class=\"msg-warning marB15\" ng-if=\"gdHasErr && gdErrType == \'dataEmpt\'\">{{\'r.msg.2\' | translate}}</div></div><div ng-if=folderLoading class=form-group><img alt=loading src=assets/images/loading-xs.gif></div><div ng-if=gdFolder.length class=form-group><label>{{\'cl.p_f.9\' | translate}}</label><div class=\"moveTreeContainer bg-light pad10\"><tree list=gdFolder check-disable=false selectednode=selectednodeGD class=\"list-unstyled moveTree rootInside\"></tree></div></div></div><!-- SP --><div ng-if=\"auth.uservices.mssp && folder.info.fType == \'sp\'\"><div ng-if=\"decId == \'\'\"><div ng-if=\"auth.uservices.msspApp == \'ca\'\"><div class=form-group><label>{{\'cl.widget.pBI.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=typeOpt ng-model=folder.info.auth value=ssp ng-change=\"authenticationTypeFx(\'ssp\')\"><label></label>{{\'cl.widget.pBI.23.2\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=folder.info.auth value=u ng-change=\"authenticationTypeFx(\'u\')\"><label></label>{{\'cl.widget.pBI.23.1\' | translate}}</label></div></div></div><div class=form-group ng-if=\"auth.uservices.msspApp == \'la\' || folder.info.auth == \'u\'\"><button type=button role=button id=spBtn class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'sp\');\" ng-if=\"!curStatus.isVerified && curStatus.step == \'a\'\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button id=spReBtn class=\"btn btn-primary\" ng-click=\"reAuthOpen(\'spRe\');\" ng-if=curStatus.isVerified ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button id=spReOuBtn class=\"btn btn-default\" ng-click=\"reAuthOpen(\'spReOu\');\" ng-if=curStatus.isVerified ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.2\' | translate}}</button></div><img alt=Loading class=marB15 src=assets/images/loading-xs.gif ng-if=\"sitesLoading && auth.uservices.msspApp == \'ca\' && folder.info.auth == \'ssp\'\"><div class=\"bg-light pad10\" ng-if=\"!hasErrSP && curStatus.step == \'sl\'\"><div class=form-group><label for=sites>{{\'cl.p_f.16\' | translate}}</label><!-- <select class=\"form-control\" ng-model=\"folder.data.sites\" ng-change=\"spSelectFx(\'lib\');\" ng-options=\"site.label for site in sitesList track by site.id\" id=\"sites\" aria-label=\"sites\" aria-labelledby=\"sites\">\r\n              <option value=\"\" ng-disabled=\"true\">{{\'cl.p_f.16\' | translate}}</option>\r\n            </select> --><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=listIsOpen.site dropdown-append-to-body><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle id=sitebol ng-click=\"search.site=\'\'\"><span ng-if=!folder.data.sites>{{\'cl.p_f.16\' | translate}}</span> <span ng-if=folder.data.sites>{{folder.data.sites.label}}</span> <span class=caret></span></span><ul class=\"dropdown-menu customSelect\" uib-dropdown-menu role=menu style=z-index:999999;width:570px;position:fixed><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"sitesList.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=search.site sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.site.length ng-click=\"search.site=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"sitesList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"site in filteredSitesList = (sitesList | filter:search.site)\" tabindex=$index><label><input type=radio role=radio name=siteOpt value={{site}} ng-checked=\"site.id == folder.data.sites.id\" ng-model=folder.data.sites ng-change=\"spSelectFx(\'lib\')\"><label></label>{{site.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSitesList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.site)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div class=form-group><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"folder.data.sites && !isLibrary\"><div ng-if=isLibrary><label for=library>{{\'cl.p_f.8\' | translate}}</label><!-- <select class=\"form-control\" ng-model=\"folder.data.library\" ng-options=\"lib.label for lib in libraryList track by lib.id\" id=\"library\" aria-label=\"library\" aria-labelledby=\"library\">\r\n                <option value=\"\" ng-disabled=\"true\">{{\'cl.p_f.8\' | translate}}</option>\r\n              </select> --><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=listIsOpen.lib dropdown-append-to-body><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle id=library ng-click=\"search.lib=\'\'\"><span ng-if=!folder.data.library>{{\'cl.p_f.8\' | translate}}</span> <span ng-if=folder.data.library>{{folder.data.library.label}}</span> <span class=caret></span></span><ul class=\"dropdown-menu customSelect\" uib-dropdown-menu role=menu style=z-index:999999;width:570px;position:fixed><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"libraryList.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=search.lib sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.lib.length ng-click=\"search.lib=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"libraryList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"lib in filteredLibraryList = (libraryList | filter:search.lib)\" tabindex=$index><label><input type=radio role=radio name=libOpt value={{lib}} ng-checked=\"lib.id == folder.data.library.id\" ng-model=folder.data.library ng-change=librarySelectFx()><label></label>{{lib.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredLibraryList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.lib)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><button type=button role=button class=\"btn btn-primary\" ng-click=\"spSelectFx(\'folder\');\" ng-disabled=spProcessing>{{\'cl.p_f.9\' | translate}} <span class=\"fa marL5 noMarR\" ng-class=\"spProcessing?\'fa-repeat fa-spin\':\'fa-chevron-right\'\" aria-hidden=true></span></button></div><div ng-if=hasErrSP class=\"errMsg marB10\"><div ng-if=\"errTypeSP==\'spAuthTC\'\" aria-live=polite role=status>{{\'cl.p_f.m9\' | translate}}</div><div ng-if=\"errTypeSP==\'spAuthC\'\" aria-live=polite role=status>{{\'cl.p_f.m10\' | translate}}</div></div><div class=\"bg-light pad10\" ng-if=\"curStatus.step == \'f\'\"><div class=\"moveTreeContainer noPad\"><tree list=folderList check-disable=false selectednode=selectednode class=\"list-unstyled moveTree rootInside\" auth-type=folder.info.auth></tree></div><div class=spaceH></div><button type=button role=button class=\"btn btn-default btn-sm\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span> {{\'cm.btn.11\' | translate}}</button></div></div></div><!-- OneDrive --><div ng-if=\"auth.uservices.msod && folder.info.fType == \'od\'\"><div ng-if=\"decId == \'\'\"><div class=form-group><button type=button role=button id=odBtn class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'od\');\" ng-if=!curStatus.isVerified ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button id=odReBtn class=\"btn btn-primary\" ng-click=\"reAuthOpen(\'odRe\');\" ng-if=curStatus.isVerified ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button id=odReOuBtn class=\"btn btn-default\" ng-click=\"reAuthOpen(\'odReOu\');\" ng-if=curStatus.isVerified ng-disabled=\"authProcessing || saveProcessing\">{{\'cl.widget.cm.25.2\' | translate}}</button></div><div ng-if=odFolder.od.folders[0].children><label>{{\'cl.p_f.9\' | translate}}</label><div class=\"moveTreeContainer bg-light pad10\"><tree list=odFolder.od.folders check-disable=false selectednode=selectednodeOD class=\"list-unstyled moveTree rootInside\"></tree></div></div></div></div><!--Shared Folder--><div ng-show=\"auth.uservices.sf && folder.info.fType == \'sf\'\"><div class=form-group ng-if=!ngDialogData.id><label>{{\'cl.p_m.7\' | translate}}</label><div ng-if=folderLoading><img alt=loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.ssOpen ng-if=serverList.length><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\"><span ng-if=!sfObj.s.label>{{\'cl.p_m.7\' | translate}}</span> <span ng-if=sfObj.s.label>{{sfObj.s.label}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"serverList.length>5\" role=menuitem><div class=\"searchTbx input-xs\"><input type=text class=form-control id=searchList ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"serverList.length>5\" role=menuitem></li><div class=\"list-scroll ng-cloak\" role=radiogroup aria-labelledby=radiogroup><li ng-repeat=\"server in filteredSList = (serverList | filter:searchList) | orderBy:\'label\'\" tabindex=$index role=menuitem><label><input type=radio role=radio name=serverOpt ng-value=server ng-checked=\"server.id == sfObj.s.id\" ng-model=sfObj.s ng-change=\"ssChange(); status.ssOpen=false\" id=sList{{$index}} aria-label=sList{{$index}} aria-labelledby=sList{{$index}}><label></label>{{server.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!folderLoading && !serverList.length\">{{\'cl.msg.52\' | translate}}</div></div><div class=form-group ng-if=\"!ngDialogData.id && sfObj.s\"><label>{{\'cl.p_f.9\' | translate | capitalize}}</label><div><img alt=loading src=assets/images/loading-xs.gif ng-if=treeLoading></div><div class=\"bg-light padTB5 padL5\" ng-if=\"!treeLoading && sfList.length\"><div class=list-scroll><label class=\"noMarB marL2 text-muted\"><span class=\"glyphicon glyphicon-home\" uib-tooltip=\"{{\'cl.p_m.6\' | translate}}\" aria-hidden=true tooltip-popup-delay=500></span></label><tree-sf list=sfList check-disable=true class=\"list-unstyled moveTree\"></tree-sf></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!treeLoading && !sfList.length\">{{\'cl.msg.51\' | translate}}</div></div><div class=form-group ng-if=ngDialogData.id><label>{{\'cl.p_m.7\' | translate}}</label><div class=text-muted>{{sfObjEdit.s.servername}}</div></div><div class=form-group ng-if=ngDialogData.id><label>{{\'cl.p_f.9\' | translate | capitalize}}</label><div class=text-muted>{{sfObjEdit.f.name}}</div></div></div><!-- Excel Folder --><div ng-if=\"folderObj.fType == \'ef\'\" class=\"form-group marB5\"><label>{{\'cm.label.69\' | translate}}</label><div>{{\'cl.widget.es.3\' | translate}}</div></div><div ng-if=\"folderObj.fType == \'ef\'\" class=\"form-group marT10\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate | capitalize}} <input type=file id=fileBtn file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading></span></div><div class=row><div class=col-xs-12><div class=\"form-group pull-left\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=folder.permission pid=decId module=\"\'folder\'\"></ng-permission-brief></div><div ng-if=\"folderObj.fType == \'ef\'\" class=\"form-group pull-left bdrLd padL20 marL20\" ng-class=\"{\'noPadL noMarL noBdr\':isPermissionOpen}\"><label ng-class=\"{\'marT15\':isPermissionOpen}\">{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=folder.activePeriod></ng-active-period></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=folderCUFx(); ng-disabled=saveProcessing><span ng-if=!ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span> <span ng-if=ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'sp\'\" aria-live=polite role=status>{{\'cl.p_f.m2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.p_f.m1\' | translate}}</div><div ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'cl.p_f.m4\' | translate}}</div><div ng-if=\"errType==\'odEmpty\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'sites\'\" aria-live=polite role=status>{{\'cl.p_f.m6\' | translate}}</div><div ng-if=\"errType==\'library\'\" aria-live=polite role=status>{{\'cl.p_f.m3\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.p_f.m7\' | translate}}</div><div ng-if=\"errType==\'sf\'\" aria-live=polite role=status>{{\'cl.p_f.m8\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'odNotExist\'\" aria-live=polite role=status>{{\'cl.p_f.m5\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'authFirst\'\" aria-live=polite role=status>{{\'cl.widget.msg.11.1\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/contentLibrary/popup/generateAI.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.ai.1\' | translate}}</h1></header><div class=panel-body ng-class=\"{\'scrollQuad\':($root.isPermissionOpen || (!$root.isPermissionOpen && !status.ssOpen))}\" ng-attr-style=max-height:{{getAvailableHeight(350)}}px><div class=form-group><label for=prompt>{{\'cl.ai.2\' | translate}}</label><div class=\"d-flex relative\"><img class=\"absolute gptInputLogo\" src=assets/images/chatgpt-icon.svg alt=chatgptLogo> <input type=text class=\"form-control gptInput\" id=prompt ng-model=aiObj.prompt autocomplete=off focus-me=true></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=st>{{\'cl.ai.3\' | translate}}</label><select class=form-control id=st ng-model=aiObj.style ng-options=\"s for s in aiOptions.style track by s\" aria-label=\"{{\'cl.ai.3\' | translate}}\" aria-labelledby=\"{{\'cl.ai.3\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.codBtn.3.5\' | translate}}</option></select></div></div><div class=col-xs-3><div class=form-group><label for=qt>{{\'cl.widget.wc.4\' | translate}}</label><select class=form-control id=qt ng-model=aiObj.quality ng-options=\"q for q in aiOptions.quality track by q\" aria-label=\"{{\'cl.widget.wc.4\' | translate}}\" ng-change=selPriceFx() aria-labelledby=\"{{\'cl.widget.wc.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.ai.7\' | translate}}</option></select></div></div><div class=col-xs-3><div class=form-group><label for=res>{{\'d.label.18\' | translate}}</label><select class=form-control id=res ng-model=aiObj.res ng-options=\"r for r in aiOptions.res track by r\" aria-label=\"{{\'d.label.18\' | translate}}\" ng-change=selPriceFx() aria-labelledby=\"{{\'d.label.18\' | translate}}\"><option value=\"\" disabled>{{\'fl.p_cfl.label.2\' | translate}}</option></select></div></div><div class=col-xs-3><div class=form-group><label for=pr>{{\'cs.p_i.12\' | translate}}</label><input id=pr type=text class=form-control ng-model=aiObj.price aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\" readonly></div></div></div><div class=row><div class=col-xs-12><div class=\"form-group pull-left\" ng-class=\"{\'padR20 bdrRd\':isPermissionOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=aiObj.permission pid=content.info.id module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left bdrLd padL20 marL20\" ng-class=\"{\'noBdr noPadL\':isPermissionOpen}\"><label ng-class=\"{\'marT15\':isPermissionOpen}\">{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=aiObj.activePeriod></ng-active-period></div></div></div><div class=form-group ng-if=isPreview><label>{{\'cl.widget.ss.7\' | translate}}</label><div><a ng-href=\"{{cDetailBucket + aiPreview.url | secureThumb}}\" role=link fancyboxable=fbTitleInside caption=\"\" ng-if=!previewLoading><img alt=perThumb ng-src=\"{{aiPreview.timthumb + cBucket + aiPreview.url  + thumbBigParamZc3+\'?\'+ timestamp}}\"></a></div></div><span ng-if=previewLoading>{{\'cl.ai.4\' | translate}}<img class=marL5 alt=Loading src=assets/images/loading-xs.gif></span></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=genPopupOpen(); ng-disabled=\"saveProcessing || previewLoading || generateProcessing\"><span class=\"fa fa-repeat fa-spin\" ng-if=\"generateProcessing || previewLoading\" aria-hidden=true></span><!-- <img class=\"w14\" alt=\"cgi\" src=\"assets/images/chatGPT-logo.png\" ng-if=\"(!generateProcessing && !previewLoading)\"> --> {{(generateProcessing || previewLoading) ? (aiPreview == \'\' ? \'cl.widget.queue.1b-i\' : \'cl.btn.25-i\') : (aiPreview == \'\' ? \'cl.widget.queue.1b\' : \'cl.btn.25\') | translate}}</button> <button ng-if=\"aiPreview != \'\'\" type=button role=button class=\"btn btn-primary\" ng-click=saveAIFx(); ng-disabled=\"saveProcessing || previewLoading\"><span><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</span></button> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"saveProcessing || previewLoading\" ng-click=resetAIFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); resetAIFx();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.p_f.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'prompt\'\" aria-live=polite role=status>{{\'cl.ai.m1\' | translate}}</div><div ng-if=\"errType==\'genErr\'\" aria-live=polite role=status>{{\'cl.ai.m3\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/contentLibrary/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'uc\'\" role=heading aria-level=1>{{\'cl.tool.13\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ec\'\" role=heading aria-level=1>{{\'cl.tool.14\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ac\'\" role=heading aria-level=1>{{\'cl.tool.15\' | translate}}</h1></header><div class=panel-body><div ng-if=\"ngDialogData.tabName==\'uc\'\" role=img><p class=marB25 lang={{auth.lang}} aria-label=\"{{\'cl.info.uc1\' | translate}}\">{{\'cl.info.uc1\' | translate}}</p><img alt=\"\" src=assets/images/info/uc.png></div><div ng-if=\"ngDialogData.tabName==\'ec\'\" role=img><p class=marB25 lang={{auth.lang}} aria-label=\"{{\'cl.info.ec1\' | translate}}\">{{\'cl.info.ec1\' | translate}}</p><img alt=\"\" src=assets/images/info/ec.png></div><div ng-if=\"ngDialogData.tabName==\'ac\'\" role=img><p class=marB25 lang={{auth.lang}} aria-label=\"{{\'cl.info.ac1\' | translate}}\">{{\'cl.info.ac1\' | translate}}</p><img alt=\"\" src=assets/images/info/ac.png></div></div></section>");
$templateCache.put("app/contentLibrary/popup/instaPreview.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.instagram.8\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-75\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span></header><div class=panel-body><div ng-if=\"ngDialogData.data == \'\'\" class=\"msg-warning pad10\" lang={{auth.lang}}><div lang={{auth.lang}}>{{\'cl.widget.instagram.m3\' | translate}}</div></div><iframe ng-if=\"ngDialogData.data != \'\'\" width=890 height=440 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen></iframe></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/kioskIdsList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.jci.7\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'kiosk\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=kListLoading><div class=row ng-if=!kListLoading><div class=col-xs-12><div class=\"table table-scroll dTable\" role=table><div class=\"row th\" ng-if=kiosk.length><div class=col-xs-8>{{\'cl.widget.jci.8\' | translate}}</div><div class=col-xs-4>{{\'cl.widget.jci.9\' | translate | camelCase}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"kioskList.k.length && kiosk.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"kioskList.k.length == 0\">{{\'cl.widget.jci.m4\' | translate}}</div><div class=scrollQuad callback=sortCallback() ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=\"row frameRow\" ng-repeat=\"k in kiosk = (kioskList.k | orderBy: \'kioskName\' | kioskFilter:searchTextPopup)\" tabindex=$index><div class=\"col-xs-8 text-ellipsis-wrap\">{{k.kioskName}}</div><div class=\"col-xs-4 text-ellipsis\"><span>{{k.kioskId}}</span></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><!-- Sortable --> <button type=button role=button class=btn ng-click=closeThisDialog(); ng-class=\"isSorted?\'btn-link\':\'btn-default\'\" data-dismiss=modal>{{isSorted?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/metaTags.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.p_mt.1.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-80\" uib-tooltip={{mtObj.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{mtObj.label}}</span> ]</span></header><div class=\"panel-body pad10\"><img alt=Loading src=assets/images/loading.gif ng-if=mtObj.loading><div ng-if=!mtObj.loading><div class=form-group><label for=tag>{{\'cl.p_mt.2\' | translate}}</label><div class=input-group><input type=text class=form-control ng-model=curMT.tag maxlength=80 focus-me=true id=tag aria-label=tag aria-labelledby=tag> <span class=input-group-btn><button type=button role=button class=\"btn btn-success\" ng-click=addMTFx(); ng-disabled=!curMT.tag><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></span></div><div class=\"text-sm text-muted\">{{\'cl.p_mt.3\' | translate}}</div></div><ul class=\"list-inline scrollQuad\" ng-if=mtObj.tags.length role=menu ng-attr-style=max-height:{{getAvailableHeight(430)}}px><li class=\"badge bg-default mataTag word-break pad5 marR5 marB5\" ng-repeat=\"tag in mtObj.tags\" role=menuitem>{{tag}}<a href=\"\" role=link class=\"text-danger marL5\" ng-click=confirmMTOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=!mtObj.tags.length>{{\'cl.p_mt.m1\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/move.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.p_m.1\' | translate}}</h1><div class=\"searchTbx bdrR\" ng-show=\"selectedT==1\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><div class=\"panel-inner-tab marB10\" ng-if=\"authServer.length > 1\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');searchTextPopup=\'\'\">{{\'cl.p_m.2\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');searchTextPopup=\'\'\" ng-if=!moveObj.isShortcut>{{\'cl.p_m.3\' | translate}}</a></div><div class=form-group><div class=\"bg-light pad5\" role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\" for=move><input type=radio role=radio name=typeOpt ng-model=moveObj.type value=move ng-change=changeTypeFx(); id=move aria-label=move aria-labelledby=move><label></label>{{\'cl.p_m.4\' | translate}}</label><label class=noMarB for=copy><input type=radio role=radio name=typeOpt ng-model=moveObj.type value=copy ng-change=changeTypeFx(); id=copy aria-label=copy aria-labelledby=copy><label></label>{{\'cl.p_m.5\' | translate}}</label></div></div><img alt=Loading src=assets/images/loading.gif ng-if=moveLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"bg-light moveTreeContainer\" ng-attr-style=max-height:{{getAvailableHeight(420)}}px><div><label ng-class=\"{\'disabledRow\':!auth.upermissions.ar}\" for=treeOpt><input type=radio role=radio name=treeOpt value=0 ng-checked=auth.upermissions.ar ng-disabled=!auth.upermissions.ar id=treeOpt aria-label=treeOpt aria-labelledby=treeOpt><label></label>{{\'cl.p_m.6\' | translate}}</label><tree list=moveObj.curServerTree search-text=searchTextPopup check-disable=true class=\"list-unstyled moveTree\" role=tree aria-orientation=vertical></tree></div></div></div><div ng-if=\"!moveLoading && selectedT==\'2\'\"><div class=\"form-group noMarB\"><label>{{\'cl.p_m.7\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.isopen><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\"><span ng-if=!moveObj.server.label>{{\'cl.p_m.7\' | translate}}</span> <span ng-if=moveObj.server.label>{{moveObj.server.label}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"serverList.length>5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control id=searchList ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"serverList.length>5\"></li><div class=\"list-scroll ng-cloak\" role=radiogroup aria-labelledby=radiogroup><li ng-repeat=\"server in filteredSList = (serverList | filter:searchList) | orderBy:\'label\'\" tabindex=$index><label for=server-{{$index}}><input type=radio role=radio name=serverOpt ng-value=server ng-checked=\"server.id == moveObj.server.id\" ng-model=moveObj.server ng-change=\"changeServerFx();status.isopen=false\" id=server-{{$index}} aria-label=server-{{$index}} aria-labelledby=server-{{$index}}><label></label>{{server.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div class=\"marT15 errMsg\" ng-if=\"arError || fError || cError || wError\"><p><span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.m3\' | translate}}:</span> <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.m4\' | translate}}:</span></p><div ng-if=arError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m5\' | translate}}</div><div ng-if=fError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m6\' | translate}}</div><div ng-if=cError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m7\' | translate}}</div><div ng-if=wError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m8\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button ng-click=moveFx(moveObj.type); class=\"btn btn-success\" ng-disabled=\"arError || fError || cError || wError || moveProcessing\"><span class=\"fa fa-check\" ng-if=!moveProcessing aria-hidden=true></span> <span class=\"fa fa-repeat fa-spin\" ng-if=moveProcessing aria-hidden=true></span> <span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.4\' | translate}}</span> <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.5\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'cl.p_m.m1\' | translate}}</div><div ng-if=\"errType==\'server\'\" aria-live=polite role=status>{{\'cl.p_m.m2\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/openSelectContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(200)}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, $index+1);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=dataLoading><ul class=\"list-inline thumb-list\" element-height=getAvailableHeight(345) delay=true ng-if=!dataLoading><div class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\" ng-if=\"openSelect.contentLibrary.folder.length > 0 || openSelect.contentLibrary.content.length > 0\"><li ng-repeat=\"folder in filteredFolderList = (openSelect.contentLibrary.folder | customSearch:{key:searchTextPopup, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=folder data-index=$index ng-if=\"openSelect.contentLibrary.folder.length > 0\"><div><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_n.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type != \'Shortcut\' && folder.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.label}}</div></div></li><li ng-repeat=\"content in filteredContentList = (openSelect.contentLibrary.content | customSearch:{key:searchTextPopup, module:\'cl\', filterType:filter})\" data-id={{content.id}} data-type=content ng-if=\"openSelect.contentLibrary.content.length > 0\"><div><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isblur}\"><img alt=\"\" ng-src={{content.thumb}} ng-if=content.thumb ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=\"\" ng-src=assets/images/file_icon.png ng-if=!content.thumb></span></div><div class=thumb-label>{{content.label}}</div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFolderList.length + filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!dataLoading && !openSelect.contentLibrary.folder.length && !openSelect.contentLibrary.content.length\">{{\'cl.msg.1\' | translate}}</div></div><div class=\"table table-scroll\" ng-if=openSelect.contentLibrary.length><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/replace.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.btn.26\' | translate}}</h1><span class=\"marL5 text-sm\">[ {{ngDialogData.label}} ]</span></header><div class=panel-body><div class=form-group><label>{{\'cl.p_r.2\' | translate}}</label><div class=pull-right><a href=\"\" role=link uib-tooltip-template=\"\'supportedFilesTemplate.html\'\" tooltip-placement=bottom><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'cm.label.54\' | translate}}</a></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\" ng-disabled=saveProcessing>{{\'cm.btn.36\' | translate}}</button> <input type=file file-model=curImg options=\"{size:2147482548, format:[\'{{replaceObj.type | lowercase}}\', \'{{replaceObj.extn | lowercase}}\'], sFiles:true, errorPop:false}\" ng-disabled=saveProcessing> <input type=text class=form-control ng-value=curImg.name readonly aria-label=\"{{\'cl.p_r.2\' | translate}}\" aria-labelledby=\"{{\'cl.p_r.2\' | translate}}\"></div></div><div class=row ng-if=\"replaceObj.type == \'Video\' && (auth.upermissions.o || auth.upermissions.vi)\"><div class=col-xs-12><div class=\"form-group pull-left\" ng-if=auth.upermissions.o><label>{{\'cl.p_r.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\" for=optimize1><input type=radio role=radio ng-model=replaceObj.optimize value=1 ng-disabled=saveProcessing id=optimize1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=noMarB for=optimize0><input type=radio role=radio ng-model=replaceObj.optimize value=0 ng-disabled=saveProcessing id=optimize0><label></label>{{\'cm.btn.3\' | translate}}</label></div></div><div class=\"form-group pull-left\" ng-if=auth.upermissions.vi ng-class=\"{\'bdrLd padL20 marL20\': auth.upermissions.o}\"><label>{{\'cl.vi.2\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\" for=indexer1><input type=radio role=radio ng-model=replaceObj.vi value=1 ng-disabled=saveProcessing id=indexer1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=noMarB for=indexer0><input type=radio role=radio ng-model=replaceObj.vi value=0 ng-disabled=saveProcessing id=indexer0><label></label>{{\'cm.btn.3\' | translate}}</label></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=msgRefresh>{{\'cl.p_r.m3\' | translate}}</div><div class=errMsg lang={{auth.lang}} ng-if=isSPSize>{{\'cl.p_c.m6\' | translate:{spSize:(auth.strg.s | filesize)} }} <span class=\"fa fa-info-circle text-primary\" uib-tooltip-template=\"\'spInfo.html\'\" tooltip-append-to-body=true></span></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=replaceFx(); ng-disabled=\"saveProcessing || uploadError || isSPSize\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-arrow-up\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=\"(hasErr || uploadError) && !isSPSize\" aria-live=polite role=status><div ng-if=\"errMsg==\'empty\'\" aria-live=polite role=status>{{\'cl.p_r.m1\' | translate}}</div><div ng-if=\"uploadErrorType==\'format\'\" aria-live=polite role=status>{{\'cl.p_r.m2\' | translate}}</div><div ng-if=\"uploadErrorType==\'size\'\" aria-live=polite role=status>{{\'cm.msg.17\' | translate: {size:\'2GB\'} }}</div><div ng-if=\"uploadErrorType==\'sizeZero\'\" aria-live=polite role=status>{{\'cl.p_c.m4\' | translate}}</div></div><div class=clearfix></div></div></section><script type=text/ng-template id=supportedFilesTemplate.html><div class=\"text-left\">\r\n    <div ng-if=\"sFiles.img.length > 0\">\r\n      <div class=\"text-bold\">{{\'cm.label.37\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.img\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.vid.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.38\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.vid\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.aud.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.39\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.aud\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.ot.length > 0\">\r\n      <div class=\"spaceH\"></div>\r\n      <div class=\"text-bold\">{{\'cm.label.40\' | translate}}</div>\r\n      <div class=\"text-ucase\">\r\n        <span ng-repeat=\"ext in sFiles.ot\" ng-if=\"ext != \'swf\'\">{{ext}}<span ng-if=\"!$last\">, </span></span>\r\n      </div>\r\n    </div>\r\n    <div ng-if=\"sFiles.img.length == 0 && sFiles.vid.length == 0 && sFiles.aud.length == 0 && sFiles.ot.length == 0\">{{\'cm.msg.31\' | translate}}</div>\r\n  </div></script><script type=text/ng-template id=spInfo.html><div class=\"text-left\">\r\n    <div>{{\'cl.p_c.m6.1\' | translate}}</div>\r\n    <div class=\"spaceH2\"></div>\r\n    <div>{{\'cl.p_c.m6.2\' | translate:{spSize:(auth.strg.s | filesize)} }}</div>\r\n    <div class=\"spaceH\"></div>\r\n    <div>{{\'cl.p_c.m6.3\' | translate}}</div>\r\n  </div></script>");
$templateCache.put("app/contentLibrary/popup/reprocess.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.btn.22\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-75\" uib-tooltip={{ngDialogData.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ngDialogData.label}}</span> ]</span></header><div class=panel-body><div class=\"msg-warning marB15\" lang={{auth.lang}}>{{\'cl.msg.26\' | translate}}</div><div class=form-group><label>{{\'cl.label.13\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=optimOpt ng-model=ngDialogData.isOptimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marL5><input type=radio role=radio name=optimOpt ng-model=ngDialogData.isOptimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"reprocessVideoFx(ngDialogData.id, ngDialogData.isOptimize);\" ng-disabled=\"reprocessRequested || (contentBrief.isOptimize == ngDialogData.isOptimize)\"><span class=fa ng-class=\"reprocessRequested?\'fa-spin fa-repeat\':\'fa-check\'\" aria-hidden=true></span>{{reprocessRequested?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=btn-link ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/scheduleCountList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.2\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-35\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!scheduleCountList.schedules.length><div class=\"table table-scroll\" ng-if=scheduleCountList.schedules.length><div class=\"row th\" ng-if=filteredList.length><div ng-class=\"scheduleCountList.info.isEditable?\'col-xs-6\':\'col-xs-8\'\">{{\'cm.brief.1\' | translate}}</div><div class=\"col-xs-4 text-capitalize\">{{\'cm.label.9\' | translate}}</div><div class=\"col-xs-2 text-right\" ng-if=scheduleCountList.info.isEditable>{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"sl in filteredList = (scheduleCountList.schedules | customSearch:{key:searchTextPopup, module:\'sls\'})\"><div class=text-ellipsis-wrap ng-class=\"scheduleCountList.info.isEditable?\'col-xs-6\':\'col-xs-8\'\">{{sl.label}}</div><div class=\"col-xs-4 text-ellipsis text-sm\">{{sl.startDate}} - {{sl.endDate}}</div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && sl.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-2 text-right\" ng-if=scheduleCountList.info.isEditable><div class=btn-group uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(sl.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li><a ng-if=auth.upermissions.se.np role=button ng-click=\"editScheduleFx(sl.id, \'np\');\">{{\'cm.brief.1\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.s role=button ng-click=\"editScheduleFx(sl.id, \'s\');\">{{\'cm.label.3\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.c role=button ng-click=\"editScheduleFx(sl.id, \'c\');\">{{\'cm.label.1\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" role=button ng-click=\"editScheduleFx(sl.id, \'d\');\">{{\'cm.label.4\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.f && sl.schType == 0\" role=button ng-click=\"editScheduleFx(sl.id, \'f\');\">{{\'s.body.4\' | translate}}</a></li></ul></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/scheduleList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.2\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-45\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'schedule\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=!popupLoading><div class=col-xs-12><div class=\"table table-scroll dTable\" role=table><div class=\"row th\" ng-if=\"filtered.a.length + filtered.i.length\"><div ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{\'cm.brief.1\' | translate}}</div><div ng-class=\"countList.info.isEditable?\'col-xs-5\':\'col-xs-6\'\">{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"col-xs-3 text-right\" ng-if=countList.info.isEditable>{{\'cm.label.25\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=scrollQuad callback=sortCallback() ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.a = (countList.schedules.a | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\"><!-- Sortable --> {{count.label}}</div><div class=\"text-ellipsis text-sm\" ng-class=\"countList.info.isEditable?\'col-xs-5\':\'col-xs-6\'\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right\" ng-if=countList.info.isEditable><div class=btn-group ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li role=menuitem class=divider role=separator></li><li role=menuitem><a ng-if=auth.upermissions.se.np role=button ng-click=\"editScheduleFx(count.id, \'np\');\">{{\'cm.brief.1\' | translate}}</a></li><li role=menuitem><a ng-if=auth.upermissions.se.s role=button ng-click=\"editScheduleFx(count.id, \'s\');\">{{\'cm.label.3\' | translate}}</a></li><li role=menuitem><a ng-if=auth.upermissions.se.c role=button ng-click=\"editScheduleFx(count.id, \'c\');\">{{\'cm.label.1\' | translate}}</a></li><li role=menuitem><a ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" role=button ng-click=\"editScheduleFx(count.id, \'d\');\">{{\'cm.label.4\' | translate}}</a></li><li role=menuitem><a ng-if=\"auth.upermissions.se.f && count.schType == 0\" role=button ng-click=\"editScheduleFx(count.id, \'f\');\">{{\'s.body.4\' | translate}}</a></li></ul></div></div></div><div ng-if=countList.schedules.i.length class=marT10 ng-class=\"{\'marT20\':filtered.a.length}\"><div class=panel-inner-tab ng-if=filtered.i.length>{{\'d.p_h.8\' | translate}}</div><div class=\"table table-scroll\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.i = (countList.schedules.i | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{count.label}}</div><div class=\"col-xs-6 text-ellipsis text-sm\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-2 text-right\" ng-if=countList.info.isEditable><div class=btn-group ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li role=menuitem class=divider role=separator></li><li role=menuitem><a ng-if=auth.upermissions.se.np role=button ng-click=\"editScheduleFx(count.id, \'np\');\">{{\'cm.brief.1\' | translate}}</a></li><li role=menuitem><a ng-if=auth.upermissions.se.s role=button ng-click=\"editScheduleFx(count.id, \'s\');\">{{\'cm.label.3\' | translate}}</a></li><li role=menuitem><a ng-if=auth.upermissions.se.c role=button ng-click=\"editScheduleFx(count.id, \'c\');\">{{\'cm.label.1\' | translate}}</a></li><li role=menuitem><a ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" role=button ng-click=\"editScheduleFx(count.id, \'d\');\">{{\'cm.label.4\' | translate}}</a></li><li role=menuitem><a ng-if=\"auth.upermissions.se.f && count.schType == 0\" role=button ng-click=\"editScheduleFx(count.id, \'f\');\">{{\'s.body.4\' | translate}}</a></li></ul></div></div></div></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><!-- Sortable --> <button type=button role=button class=btn ng-click=closeThisDialog(); ng-class=\"isSorted?\'btn-link\':\'btn-default\'\" data-dismiss=modal>{{isSorted?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/shortcut.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cl.btn.17\" | translate | camelCase}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=moveLoading><div ng-if=!moveLoading><div class=form-group><div><label class=text-unbold><input type=checkbox ng-model=confirmObj.admin role=checkbox aria-label=\"{{\'cl.msg.57\' | translate}}\" aria-labelledby=\"{{\'cl.msg.57\' | translate}}\"><label></label>{{\'cl.msg.57\' | translate}}</label></div></div><label class=noMarB><a href=\"\" role=link ng-click=\"treeOpen=treeOpen?false:true\">{{\'t.body.6\' | translate}} <span class=fa ng-class=\"treeOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div id=target class=\"bg-light moveTreeContainer\" ng-attr-style=max-height:{{getAvailableHeight(420)}}px ng-if=treeOpen><div><label ng-class=\"{\'disabledRow\':!auth.upermissions.ar}\" for=treeOpt><input type=radio role=radio name=treeOpt value=0 ng-checked=auth.upermissions.ar ng-disabled=!auth.upermissions.ar id=treeOpt aria-label=treeOpt aria-labelledby=treeOpt><label></label>{{\'cl.p_m.6\' | translate}}</label><tree list=treeObj.curServerTree check-disable=true class=\"list-unstyled moveTree\" role=tree aria-orientation=vertical></tree></div></div></div></div><footer class=panel-footer><button type=button role=button class=\"btn btn-success\" ng-click=shortcutCreateFx(treeObj); ng-disabled=saveProcessing><span ng-if=!ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span> <span ng-if=ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></footer></section>");
$templateCache.put("app/contentLibrary/popup/versions.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.p_v.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-70\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span></header><div class=\"panel-body pad10\"><img alt=Loading src=assets/images/loading.gif ng-if=!versions.content.length><ul class=\"list-inline thumb-list scrollQuad\" ng-if=versions.content ng-attr-style=max-height:{{getAvailableHeight(334)}}px><li ng-repeat=\"content in versions.content\" ng-class=\"{\'unapprovedFile\': content.isApproved === 0}\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true ng-click=\"selectContentFx($event, content.id, content.current, content.isCompleted, content.isApproved, versions.info.approval);\">{{curTooltip = getTooltip(content.isApproved);\"\"}}<div class=\"thumb-img w135\" ng-class=\"{\'overflow-hidden\':content.isblur}\"><span class=thumb-inner><!-- Audio --> <img alt=\"\" ng-src={{vDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"><!-- Flash --> <img alt=\"\" ng-src={{vDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"><!-- Images --> <img alt=\"\" ng-src=\"{{vTim + vBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type != \'Audio\' && content.type != \'Flash\'  && content.isCompleted\" ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=\"\" ng-src=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/n/processing_thumb.png ng-if=!content.isCompleted class=img-responsive> <span class=thumb-icon><span ng-if=content.ss class=webpage aria-hidden=true></span> <span ng-if=content.isblur class=sensitiveContent aria-hidden=true></span> <span ng-if=\"content.type !== \'folder\' && !content.isblur\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-center text-muted text-sm\">{{content.createdOn}}</div><div ng-if=!content.current class=btn-group><a href=\"\" role=link ng-if=\"content.type == \'Video\'\" class=\"btn btn-default btn-xs\" ng-click=\"fbVideoFx(vDetailBucket + content.pUrl, versions.info.label);\" uib-tooltip=\"{{\'cm.btn.21\' | translate}}\" tooltip-popup-delay=1000><span class=\"fa fa-eye noMarR\" aria-hidden=true></span></a> <a ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=button ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\" class=\"btn btn-default btn-xs\" fancyboxable=fbTitleInside uib-tooltip=\"{{\'cm.btn.21\' | translate}}\" tooltip-popup-delay=1000><span class=\"fa fa-eye noMarR\" aria-hidden=true></span></a> <a ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=button ng-if=\"content.extn == \'WEBP\' && content.isCompleted\" class=\"btn btn-default btn-xs\" fancyboxable=fbTitleInside uib-tooltip=\"{{\'cm.btn.21\' | translate}}\" tooltip-popup-delay=1000><span class=\"fa fa-eye noMarR\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"content.type != \'Widget\' && content.type != \'template\'\" class=\"btn btn-default btn-xs\" ng-click=versionContentOpen(content); uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-popup-delay=1000><span class=\"fa fa-download noMarR\" aria-hidden=true></span></a></div><div class=\"thumb-label w135 noMar bg-success pad2\" ng-if=content.current>{{\'cl.p_v.2\' | translate}}</div></li></ul></div><footer class=panel-footer ng-if=versions.content><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=useConfirmOpen(); ng-disabled=useProcessing><span class=fa ng-class=\"useProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.p_v.3\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</span> <span ng-if=\"errType==\'selectable\'\" aria-live=polite role=status>{{\'cl.p_v.m1\' | translate}}</span> <span ng-if=\"errType==\'pWriteProtected\'\" aria-live=polite role=status>{{\'cl.p_v.m2\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.info.v1\' | translate}}</h1></header><div class=panel-body><iframe width=560 height=315 src=\"https://www.youtube.com/embed/oawOTT9nQhw?autoplay=1&amp;rel=0&amp;showinfo=0\" frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/contentLibrary/thirdParty/tpuDbox.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.p_c.10\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuDrive.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.p_c.11\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuFb.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fb.1\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuFtp.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.p_c.12\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL hide\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=file.paused role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuInsta.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.instagram.1\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuTw.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.twitter.1\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=\"uploadQueue quadBdr overflow-auto\" style=min-height:100px;height:{{winH}}px><div class=uploadMsg ng-if=\"curSelected.length == 0\"><div><img alt=\"\" src=assets/images/upload_files_icon.png></div></div><div class=\"table no-th\" ng-if=\"curSelected.length > 0\"><div class=row ng-repeat=\"file in curSelected\"><div ng-if=\"!file.unsupported && !file.isSupportedFormat\"><div class=\"col-xs-9 text-ellipsis\"><div><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/ppt.png ng-if=\"file.extn == \'ppt\' || file.extn == \'pptx\' || file.extn == \'pps\' || file.extn == \'ppsx\' || file.extn == \'odp\'\"> <img alt=\"\" ng-src=assets/images/default/video.png ng-if=\"itemInArray(sFiles.vid, file.extn.toLowerCase()) || vidFormatRegExp.test(file.file.type, \'gi\')\"> <img alt=\"\" src-error=assets/images/default/img.png ng-src={{file.thumb}} ng-if=\"itemInArray(sFiles.img, file.extn.toLowerCase())\"> <img alt=\"\" ng-src=assets/images/default/word.png ng-if=\"file.extn == \'doc\' || file.extn == \'docx\' || file.extn == \'odt\'\"> <img alt=\"\" ng-src=assets/images/default/audio.png ng-if=\"itemInArray(sFiles.aud, file.extension.toLowerCase())\"><!-- <img alt=\"\" ng-src=\"assets/images/default/swf.png\" ng-if=\"file.extn == \'swf\'\" /> --> <img alt=\"\" ng-src=assets/images/default/pdf.png ng-if=\"file.extn == \'pdf\'\"></div><span ng-hide=file.isEdit ng-if=\"file.label && file.size <= 512000\">{{file.label}} {{file.optimizeVideo}}</span> <span ng-hide=file.isEdit class=\"text-bold text-danger\" ng-if=\"file.label && file.size > 512000\">{{\'cm.msg.24\' | translate: {fileSize:\'512MB\'} }}</span></div><div class=\"text-sm text-muted hide\"><span>{{file.size | filesize}}</span> <span class=\"marL10 padL10 bdrL\" ng-if=\"auth.upermissions.o && (file.file.type == \'mp4\' || file.file.type == \'video\' || file.extn == \'f4v\' || file.extn == \'mxf\' || file.extn == \'flv\' || vidFormatRegExp.test(file.file.type, \'gi\'))\"><label class=marR5>{{\'cl.p_r.3\' | translate}}:</label><span><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 1\">{{\'cm.btn.2\' | translate}}</label><label class=\"bg-muted text-sm text-bold\" ng-if=\"file.optimize == 0\">{{\'cm.btn.3\' | translate}}</label></span><span ng-hide=\"$flow.isUploading() || file.paused\" role=radiogroup aria-labelledby=radiogroup><label class=marR5 uib-tooltip=\"{{\'cl.p_c.m3\' | translate}}\" tooltip-append-to-body=true><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=1><label></label>{{\'cm.btn.2\' | translate}}</label><label class=marR5><input type=radio role=radio name=optimizeOpt_{{$index}} ng-model=file.optimize value=0><label></label>{{\'cm.btn.3\' | translate}}</label></span></span></div></div><div class=col-xs-3><div class=text-right><button type=button role=button class=\"btn btn-xs btn-danger\" ng-click=cancelFileFx($index); ng-if=\"file.size <= 512000\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index); ng-if=\"file.size > 512000\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button> <span ng-show=file.error uib-tooltip=\"{{\'cm.msg.3\' | translate}}\" tooltip-enable=isPermissionOpen tooltip-placement=left><button type=button role=button class=\"btn btn-xs btn-info\" ng-click=file.retry(); ng-disabled=isPermissionOpen>{{\'cl.p_c.7\' | translate}}</button></span></div></div></div><div ng-if=\"file.unsupported || file.isSupportedFormat\" class=col-xs-12><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=cancelFileFx($index);><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button><div class=flowThumb><span class=helper></span> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=\"!itemInArray(supportedFiles, file.extn.toLowerCase()) && file.unsupported\"> <img alt=\"\" ng-src=assets/images/default/unknown.png ng-if=file.isSupportedFormat></div><div><div>{{file.name}}</div><div class=\"text-bold text-danger\">{{file.unsupported?\'cl.p_c.m2\':\'cl.p_c.m4\' | translate}}</div></div></div></div></div></div><div class=spaceH></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/thirdParty/tpuUrl.html","<div class=text-big><span><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.cm.10\' | translate}}</span></div><div>&nbsp;</div><div class=row><div class=\"col-lg-12 overflow-auto\" style=height:{{getAvailableHeight(315)}}px>{{getAvailableHeight(385); \"\"}}<div class=col-xs-7><div class=form-groups><label for=tpUrl>{{\"cl.widget.cm.10\" | translate}}</label><input type=text id=tpUrl class=form-control ng-model=url.url aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div></div><div class=\"col-xs-12 marT10\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tpuPermissionExpiry.permission pid=0 module=\"\'content\'\" is-disabled=isFileUploading></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tpuPermissionExpiry.activePeriod is-disabled=isFileUploading></ng-active-period></div></div></div></div>");
$templateCache.put("app/contentLibrary/widgets/achievers.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.achievers.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.achievers.2\' | translate}} &nbsp; <span ng-if=achievers.label>[ {{achievers.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=achievers.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=eventType>{{\'cl.widget.achievers.6\' | translate}}</label><select id=eventType class=form-control ng-model=achievers.eventType aria-label=\"{{\'cl.widget.achievers.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.achievers.6.1\' | translate}}\"><option value=all>{{\'cm.tool.2.1\' | translate}}</option><option value=achievement>{{\'cl.widget.achievers.4\' | translate}}</option><option value=activation>{{\'cl.widget.achievers.7\' | translate}}</option><option value=award>{{\'cl.widget.achievers.8\' | translate}}</option><option value=campaign>{{\'cl.widget.achievers.9\' | translate}}</option><option value=claim>{{\'cl.widget.achievers.10\' | translate}}</option><option value=event>{{\'cl.widget.achievers.11\' | translate}}</option><option value=recognition>{{\'cl.widget.achievers.5\' | translate}}</option><option value=redemption>{{\'cl.widget.achievers.12\' | translate}}</option></select></div><div class=form-group><label for=post>{{\'cl.widget.instagram.6\' | translate}}</label><select id=post class=form-control ng-options=\"p for p in postList track by p\" ng-model=achievers.count aria-label=\"{{\'cl.widget.instagram.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.instagram.6\' | translate}}\"></select></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=achievers.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=achievers.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"achievers.settings.rotationOpt == \'c\'\"><input type=number id=tRotate class=form-control ng-model=achievers.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.headerText selected-type=achievers.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=achievers.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-4><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=achievers.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.yammer.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.dateText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.dateText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.dateText selected-type=achievers.ctype.dateText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=dateFont>{{\'cl.widget.yammer.16\' | translate}}</label><select id=dateFont class=form-control ng-model=achievers.settings.dateFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-4><label for=dateSize>{{\'cl.widget.yammer.17\' | translate}}</label><input type=number id=dateSize class=form-control ng-model=achievers.settings.dateSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.48\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.participantText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.participantText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.participantText selected-type=achievers.ctype.participantText ng-if=colorPicker.pt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=participantFont>{{\'cl.widget.cm.49\' | translate}}</label><select id=participantFont class=form-control ng-model=achievers.settings.participantFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-4><label for=participantSize>{{\'cl.widget.cm.50\' | translate}}</label><input type=number id=participantSize class=form-control ng-model=achievers.settings.participantSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.titleText selected-type=achievers.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=achievers.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=achievers.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dct=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.descText selected-type=achievers.ctype.descText ng-if=colorPicker.dct></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=descFont>{{\'cl.widget.survey.8\' | translate}}</label><select id=descFont class=form-control ng-model=achievers.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.8\' | translate}}\"></select></div><div class=col-xs-4><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=achievers.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.51\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.creatorText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.creatorText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ct=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.creatorText selected-type=achievers.ctype.creatorText ng-if=colorPicker.ct></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=creatorFont>{{\'cl.widget.cm.52\' | translate}}</label><select id=creatorFont class=form-control ng-model=achievers.settings.creatorFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-4><label for=creatorSize>{{\'cl.widget.cm.53\' | translate}}</label><input type=number id=creatorSize class=form-control ng-model=achievers.settings.creatorSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.54\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cot><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':achievers.settings.createdOnText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"achievers.settings.createdOnText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cot=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=achievers.settings.createdOnText selected-type=achievers.ctype.createdOnText ng-if=colorPicker.cot></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=createdOnFont>{{\'cl.widget.cm.55\' | translate}}</label><select id=createdOnFont class=form-control ng-model=achievers.settings.createdOnFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-4><label for=createdOnSize>{{\'cl.widget.cm.56\' | translate}}</label><input type=number id=createdOnSize class=form-control ng-model=achievers.settings.createdOnSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=achievers.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=achievers.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=achieversFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'hSize\'\">{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType == \'dtSize\'\">{{\'cl.widget.msg.30\' | translate}}</div><div ng-if=\"errType == \'pSize\'\">{{\'cl.widget.msg.31\' | translate}}</div><div ng-if=\"errType == \'tSize\'\">{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType == \'dSize\'\">{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType == \'cSize\'\">{{\'cl.widget.msg.32\' | translate}}</div><div ng-if=\"errType == \'coSize\'\">{{\'cl.widget.msg.33\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType == \'rotate\'\">{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'headerText\'\">{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType == \'sSize\'\">{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType == \'rotation\'\">{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/agc.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list aria-label=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.agc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.agc.2\' | translate}} &nbsp; <span ng-if=agc.label>[ {{agc.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=agc.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input id=url type=text class=form-control ng-model=agc.url aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div class=form-group><label for=wc>{{\'cl.widget.agc.3\' | translate}}</label><select class=form-control id=wc ng-model=agc.wc ng-options=\"wc.label for wc in wcList track by wc.label\" aria-label=\"{{\'cl.widget.agc.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.agc.3\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.agc.3.1\' | translate}}</option></select></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=reloadOptA class=\"noMarB marR10\"><input type=radio role=radio id=reloadOptA ng-model=agc.settings.reloadOpt name=reloadOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label for=reloadOptC class=noMarB><input type=radio role=radio id=reloadOptC ng-model=agc.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"agc.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=agc.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><label>{{\'cm.label.58\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=agc.settings.rotateOpt name=rotateOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=agc.settings.rotateOpt name=rotateOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"agc.settings.rotateOpt == \'c\'\"><input type=number id=rotate class=form-control ng-model=agc.settings.rotate min=1 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"><div class=\"input-group-addon no-length\">{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':agc.settings.bg, opacity:agc.settings.bga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"agc.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{agc.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.bg selected-type=agc.ctype.bg is-alpha=true selected-alpha=agc.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div><div class=row><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':agc.settings.headerBg, opacity:agc.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{agc.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.headerBg selected-type=agc.ctype.headerBg is-alpha=true selected-alpha=agc.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':agc.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.headerText selected-type=agc.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=agc.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=agc.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':agc.settings.rowBg, opacity:agc.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{agc.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.rowBg selected-type=agc.ctype.rowBg is-alpha=true selected-alpha=agc.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':agc.settings.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.rowText selected-type=agc.ctype.rowText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=agc.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-3><label for=rowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rowSize class=form-control ng-model=agc.settings.rowSize min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':agc.settings.altBg, opacity:agc.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{agc.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.altBg selected-type=agc.ctype.altBg is-alpha=true selected-alpha=agc.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.art><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':agc.settings.altText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"agc.settings.altText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.art=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=agc.settings.altText selected-type=agc.ctype.altText ng-if=colorPicker.art></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=altFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altFont class=form-control ng-model=agc.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div><div class=col-xs-3><label for=altSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=altSize class=form-control ng-model=agc.settings.altSize min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=agc.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=agc.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=agcFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'wc\'\" aria-live=polite role=status>{{\'cl.widget.agc.m1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'rSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'aSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.18\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/alert.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list aria-label=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.alert.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.alert.2\' | translate}} &nbsp; <span ng-if=alert.label>[ {{alert.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=alert.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=alert.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=form-group><label>{{\'em.body.1\' | translate}}</label><div class=marB10 role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=dTypeOpt value=t ng-model=alert.dType><label></label>{{\'cm.label.64\' | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=dTypeOpt value=c ng-model=alert.dType><label></label>{{\'cm.label.1\' | translate}}</label></div><wysiwyg ng-if=\"alert.dType == \'t\'\" textarea-id=question textarea-class=form-control textarea-height=200px textarea-name=textareaQuestion textarea-required ng-model=alert.description enable-bootstrap-title=false textarea-menu=toolbar></wysiwyg><div ng-if=\"alert.dType == \'c\'\"><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!alert.isHidden && alert.content.type != \'video\' && (alert.content.thumb || alert.content.type == \'SharePointC\' || alert.content.type == \'OneDriveC\' || alert.content.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeContentFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=alert.content.thumb ng-href=\"{{cDetailBucket + alert.content.thumb | secureThumb}}\" role=button data-access={{alert.content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(alert.content.path + (alert.content.path.length > 1 ? \' / \' : \' \') + alert.content.label)}}\" ng-show=alert.content.thumb><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + alert.content.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"alert.content.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"alert.content.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"alert.content.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=\"!alert.isHidden && alert.content.type == \'video\' && alert.content.thumb\"><a href=\"\" role=link class=thumb-close ng-click=removeContentFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + alert.content.url, alert.content.path + (alert.content.path.length > 1 ? \' / \' : \' \') + alert.content.label);\" data-access={{alert.content.isAccessible}}><img alt=\"\" ng-src=\"{{tim + cBucket + alert.content.thumb + inputImgThumbParam}}\"></a></div><div class=\"pull-left relative\" ng-if=\"alert.isHidden && alert.content.type != \'video\'\"><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><div class=\"pull-left relative\" ng-if=\"alert.isHidden && alert.content.type == \'video\'\"><img alt=\"\" uib-tooltip=\"{{\'cl.widget.msg.28\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button id=content class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.32\' | translate | camelCase}}</button></div></div></div><div class=form-group><label>{{\'cl.widget.alert.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=displayOpt ng-model=alert.whenDisplay value=i><label></label>{{\'cl.widget.alert.3.1\' | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=displayOpt ng-model=alert.whenDisplay value=a><label></label>{{\'cl.widget.alert.3.2\' | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=displayOpt ng-model=alert.whenDisplay value=s><label></label>{{\'cl.widget.alert.3.3\' | translate}}</label></div></div><div class=form-group><label class=noMarB><input type=checkbox role=checkbox ng-model=alert.deleteOnceRead><label></label>{{\'cl.widget.alert.4\' | translate}}</label></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=alert.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=alert.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=alertFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'text\'\" aria-live=polite role=status>{{\'cl.widget.text.m1\' | translate}}</div><div ng-if=\"errType==\'content\'\" aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/amazonQuickSight.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.aqs.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.aqs.2\' | translate}} &nbsp; <span ng-if=aqs.label>[ {{aqs.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=aqs.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div ng-if=status.ds><div class=form-group><label for=dashboard>{{\'cm.menu.0\' | translate}}</label><div ng-if=status.dl><img src=assets/images/loading-xs.gif></div><select id=dashboard class=form-control ng-if=!status.dl ng-options=\"d.l for d in dList track by d.id\" ng-model=aqs.d ng-change=\"getList(\'s\')\" aria-label=\"{{\'cl.widget.pBI.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.16\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.pBI.16\' | translate | capitalize}}</option></select></div><div class=form-group ng-if=status.ss><label>{{\'cm.label.69\' | translate}}</label><div class=marB10 role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=dTypeOpt value=s ng-model=aqs.dType><label></label>{{\'cl.widget.aqs.4\' | translate}}</label><label class=\"noMarB marL10\"><input type=radio role=radio name=dTypeOpt value=v ng-model=aqs.dType ng-change=\"getList(\'vc\')\"><label></label>{{\'cl.widget.aqs.5\' | translate}}</label></div><label for=sheet>{{\'cl.widget.aqs.4\' | translate}}</label><div ng-if=status.sl><img src=assets/images/loading-xs.gif></div><select id=sheet class=form-control ng-if=!status.sl ng-options=\"s.l for s in sList track by s.id\" ng-model=aqs.s ng-change=\"getList(\'v\')\" aria-label=\"{{\'cl.widget.aqs.3.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqs.3.1\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.aqs.4.1\' | translate}}</option></select></div><div class=form-group ng-if=\"status.sv && aqs.dType == \'v\'\"><label for=visual>{{\'cl.widget.aqs.5\' | translate}}</label><select id=visual class=form-control ng-options=\"v.l for v in vList track by v.id\" ng-model=aqs.v aria-label=\"{{\'cl.widget.aqs.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqs.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.aqs.5.1\' | translate}}</option></select></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=aqs.settings.reloadOpt name=reloadOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=aqs.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"aqs.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=aqs.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=aqs.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=aqs.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=aqsFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'dashboard\'\" aria-live=polite role=status>{{\'cl.widget.aqs.m1\' | translate}}</div><div ng-if=\"errType == \'sheet\'\" aria-live=polite role=status>{{\'cl.widget.aqs.m2\' | translate}}</div><div ng-if=\"errType == \'visual\'\" aria-live=polite role=status>{{\'cl.widget.aqs.m3\' | translate}}</div><div ng-if=\"errType == \'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/aqi.html","<div ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><span ng-if=tabView><a href=\"\" class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\"></span></a>{{\'cl.widget.aqi.1\' | translate}}</span> <span ng-if=!tabView>{{\'cl.widget.aqi.2\' | translate}} &nbsp; <span ng-if=aqi.label>[ {{aqi.label}} ]</span></span></div><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\"><li ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" ng-click=\"tabFx(1, \'tabFx\');loadMap();\"><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" ng-click=AQIFx(1);><span class=badge>2</span>{{\'cm.label.2s\' | translate}}</a></li><div class=\"pull-right dataSource\">{{\'cl.widget.aqi.3\' | translate}}</div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=name>{{\'cl.label.1\' | translate}}</label><input type=text id=name class=form-control ng-model=aqi.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><select id=lang class=form-control ng-model=aqi.settings.lang aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=pt_PT>Portuguese / Portugal</option><option value=es_ES>Spanish / Spain</option></select></div><div class=row><div class=col-xs-6><div class=form-group><label for=lat>{{\'db.p_map.3\' | translate}}</label><input type=number id=lat class=form-control ng-model=aqi.lat ng-change=changeForMap(); aria-label=\"{{\'db.p_map.3\' | translate}}\" aria-labelledby=\"{{\'db.p_map.3\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=lng>{{\'db.p_map.4\' | translate}}</label><input type=number id=lng class=form-control ng-model=aqi.lng ng-change=changeForMap(); aria-label=\"{{\'db.p_map.4\' | translate}}\" aria-labelledby=\"{{\'db.p_map.4\' | translate}}\"></div></div><div class=col-xs-12><div ng-if=\"auth.uservices.m == \'g\'\"><ng-map center={{mapCenter}} zoom={{aqi.zoom}} on-click=addMarker(); on-zoom_changed=zoomChanged() map-initialized=mapLoaded(map)><marker ng-repeat=\"pos in positions\" position=\"{{pos.lat}}, {{pos.lng}}\"></marker><traffic-layer></traffic-layer></ng-map></div><div ng-if=\"auth.uservices.m == \'b\'\" id=azMap style=height:300px></div></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label for=forecast>{{\'cl.widget.cm.20\' | translate}}</label><select id=forecast class=form-control ng-model=aqi.settings.forecast focus-me=true ng-change=\"typeFx(\'f\');\" aria-label=\"{{\'cl.widget.cm.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.20\' | translate}}\"><option value=0>{{\'cl.widget.weather.3.1\' | translate}}</option><option value=1>{{\'cl.widget.weather.3.2\' | translate}}</option><option value=2>{{\'cl.widget.aqi.24\' | translate}}</option></select></div></div><div class=col-xs-12><div class=form-group ng-if=\"aqi.settings.forecast != 0\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div><label class=marR10><input type=radio name=dOpt ng-model=aqi.settings.orientation value=h ng-change=typeFx();><label></label>{{\'ms.label.10.2\' | translate}}</label><label><input type=radio name=dOpt ng-model=aqi.settings.orientation value=v ng-change=typeFx();><label></label>{{\'ms.label.10.1\' | translate}}</label></div></div><div class=spaceH></div><div ng-if=\"aqi.settings.forecast == \'0\'\"><label>{{\'cl.widget.cm.7\' | translate}}</label><div class=clear></div><div class=\"pull-left marR10\"><label><img src=\"assets/images/widget/templates/aqi1_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=aqi1.png><div class=clear></div><input type=radio ng-model=aqi.settings.template value=t1><label></label>{{\'cl.widget.cm.8\' | translate:{count:\'1\'}}}</label></div><div class=\"pull-left marL10\"><label><img src=\"assets/images/widget/templates/aqi2_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=aqi2.png><div class=clear></div><input type=radio ng-model=aqi.settings.template value=t2><label></label>{{\'cl.widget.cm.8\' | translate:{count:\'2\'}}}</label></div></div></div><div class=col-xs-12 ng-if=\"aqi.settings.forecast != \'0\'\"><label>{{\'cl.widget.weather.5\' | translate}}</label><div ng-if=\"aqi.settings.forecast == \'1\'\"><img src=\"assets/images/widget/templates/aqi_forecast_h1_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=forecast1.png class=img-responsive ng-if=\"aqi.settings.orientation == \'h\'\"> <img src=\"assets/images/widget/templates/aqi_forecast_v1_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=forecast1.png class=img-responsive ng-if=\"aqi.settings.orientation == \'v\'\"></div><div ng-if=\"aqi.settings.forecast==\'2\'\"><img src=\"assets/images/widget/templates/aqi_forecast_h2_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=forecast2.png class=img-responsive ng-if=\"aqi.settings.orientation == \'h\'\"> <img src=\"assets/images/widget/templates/aqi_forecast_v2_{{aqi.settings.lang.split(\'_\')[0]}}.png\" alt=forecast2.png class=img-responsive ng-if=\"aqi.settings.orientation == \'v\'\"></div></div><div class=\"col-xs-10 marT15\"><div class=\"form-group noMarB\"><a href=\"\" class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- AQI Color --><div class=\"panel-inner-tab marB10\">{{\'cl.widget.aqi.4\' | translate}}</div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aqi.settings.bg, opacity:aqi.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aqi.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.bg selected-type=aqi.ctype.bg is-alpha=true selected-alpha=aqi.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.aqi.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sbg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aqi.settings.sbg, opacity:aqi.settings.sbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.sbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sbg=true\" readonly aria-label=\"{{\'cl.widget.aqi.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.5\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aqi.settings.sbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.sbg selected-type=aqi.ctype.sbg is-alpha=true selected-alpha=aqi.settings.sbga ng-if=colorPicker.sbg></ng-hub-color-picker></div></div></div></div><div class=\"panel-inner-tab marB10 marT25\">{{\'cl.widget.aqi.6\' | translate}}</div><div class=row><div class=\"col-xs-12 marB10\"><div class=form-group><div class=\"marT15 marB10\"><label class=noMarB>{{\'cl.widget.aqi.7\' | translate}}</label><div class=pull-right><button type=button role=button id=addRowBtn class=\"btn btn-success btn-xs\" ng-disabled=addScaleDisable ng-click=addRowFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=bdr-top-dashed><div ng-if=\"aqi.settings.scale.length > 0\"><div class=mainRowScale><div ng-repeat=\"scale in aqi.settings.scale\" style=flex:1><div class=wraperScale id=scaleWidth><ul class=containerScale ng-style=\"{\'border-top-color\':scale.src}\"><li class=linkScale><span style=\"display:flex;border:1px solid gray\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.src><div class=\"input-group input-colorPicker\" style=height:24px><span class=input-group-addon style=padding:3px><span class=trBg><span ng-style=\"{\'background-color\':scale.src, opacity:scale.srca}\" class=picker ng-value=\"scale.src | uppercase\" uib-dropdown-toggle ng-click=\"color.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=scale.src selected-type=aqi.ctype.src is-alpha=true selected-alpha=scale.srca ng-if=color.src></ng-hub-color-picker></div></div><input type=number ng-model=scale.value min=0 style=\"width:50px;border:none;border-left:1px solid gray;border-right:1px solid gray\"> <span><a href=\"\" class=\"pad7 text-danger\" ng-click=\"confirmOpen($index, scale.value, scale.src);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove marT5\"></span></a></span></span></li></ul></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"aqi.settings.scale.length == 0\">{{\'cl.widget.aqi.m1\' | translate}}</div></div></div></div></div><!-- Other settings --><div class=\"panel-inner-tab marB10\">{{\'cl.widget.aqi.8\' | translate}}</div><div class=row><div class=col-xs-3><label for=lp>{{\'cl.widget.wf45.11.5\' | translate}}</label><select id=lp class=form-control ng-model=aqi.settings.p aria-label=\"{{\'cl.widget.wf45.11.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.11.5\' | translate}}\"><option value=t>{{\'cl.widget.count.4.1\' | translate}}</option><option value=r>{{\'cl.widget.count.4.2\' | translate}}</option><option value=b>{{\'cl.widget.count.4.3\' | translate}}</option><option value=l>{{\'cl.widget.count.4.4\' | translate}}</option></select></div><div class=col-xs-3><label for=label>{{\'d.label.10\' | translate}} <span class=text-muted>({{\'cm.label.26\' | translate}})</span></label><input type=text id=label class=form-control ng-model=aqi.settings.label maxlength={{inputLimit}} aria-label=\"{{\'d.label.10\' | translate}}\" aria-labelledby=\"{{\'d.label.10\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aqi.settings.lt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.lt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lt=true\" readonly aria-label=\"{{\'cl.widget.aqi.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.lt selected-type=aqi.ctype.lt ng-if=colorPicker.lt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=lf>{{\'cl.widget.aqi.10\' | translate}}</label><select id=lf class=form-control ng-model=aqi.settings.lf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.aqi.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.10\' | translate}}\"></select></div><div class=col-xs-4><label for=ls>{{\'cl.widget.aqi.11\' | translate}}</label><input type=number id=ls class=form-control ng-model=aqi.settings.ls min=1 aria-label=\"{{\'cl.widget.aqi.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.11\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aqi.settings.st}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.st | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly aria-label=\"{{\'cl.widget.aqi.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.st selected-type=aqi.ctype.st ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=sf>{{\'cl.widget.aqi.13\' | translate}}</label><select id=sf class=form-control ng-model=aqi.settings.sf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.aqi.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.13\' | translate}}\"></select></div><div class=col-xs-4><label for=ss>{{\'cl.widget.aqi.14\' | translate}}</label><input type=number id=ss class=form-control ng-model=aqi.settings.ss min=1 aria-label=\"{{\'cl.widget.aqi.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.14\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aqi.settings.sat}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.sat | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sat=true\" readonly aria-label=\"{{\'cl.widget.aqi.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.sat selected-type=aqi.ctype.sat ng-if=colorPicker.sat></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=saf>{{\'cl.widget.aqi.16\' | translate}}</label><select id=saf class=form-control ng-model=aqi.settings.saf ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label for=sas>{{\'cl.widget.aqi.17\' | translate}}</label><input type=number id=sas class=form-control ng-model=aqi.settings.sas min=1 aria-label=\"{{\'cl.widget.aqi.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.17\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.18\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.vt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aqi.settings.vt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aqi.settings.vt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.vt=true\" readonly aria-label=\"{{\'cl.widget.aqi.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.18\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.vt selected-type=aqi.ctype.vt ng-if=colorPicker.vt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=vf>{{\'cl.widget.aqi.19\' | translate}}</label><select id=vf class=form-control ng-model=aqi.settings.vf ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label for=vs>{{\'cl.widget.aqi.20\' | translate}}</label><input type=number id=vs class=form-control ng-model=aqi.settings.vs min=1 aria-label=\"{{\'cl.widget.aqi.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.20\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.21\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.vat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aqi.settings.vat}\"></span></span> <input type=text id=vat class=\"form-control picker\" ng-value=\"aqi.settings.vat | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.vat=true\" readonly aria-label=\"{{\'cl.widget.aqi.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.21\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aqi.settings.vat selected-type=aqi.ctype.vat ng-if=colorPicker.vat></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=vaf>{{\'cl.widget.aqi.22\' | translate}}</label><select id=vaf class=form-control ng-model=aqi.settings.vaf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.aqi.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.22\' | translate}}\"></select></div><div class=col-xs-4><label for=vas>{{\'cl.widget.aqi.23\' | translate}}</label><input type=number id=vas class=form-control ng-model=aqi.settings.vas min=1 aria-label=\"{{\'cl.widget.aqi.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.23\' | translate}}\"></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=aqi.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=aqi.activePeriod></ng-active-period></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=\"backBtnFx(); loadMap();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=AQIFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"AQIFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'latlong\'\" aria-live=polite role=status>{{\'cl.widget.msg.8\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'sameValue\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m2\' | translate}}</div><div ng-if=\"errType==\'sameScaleColor\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m3\' | translate}}</div><div ng-if=\"errType==\'scaleRange\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m4\' | translate}}</div><div ng-if=\"errType==\'scale\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m5\' | translate}}</div><div ng-if=\"errType==\'value\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m6\' | translate}}</div><div ng-if=\"errType==\'ls\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m7\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m8\' | translate}}</div><div ng-if=\"errType==\'sas\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m9\' | translate}}</div><div ng-if=\"errType==\'vs\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m10\' | translate}}</div><div ng-if=\"errType==\'vas\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m11\' | translate}}</div></div><div class=clearfix></div></div><script type=text/javascript src=\"https://www.bing.com/api/maps/mapcontrol?key=AtDjw-SHCn_Y0-zfHLxgaXMgLHOnhBVWJK_zKZM2kuCz8CNkW6zAcbTQVdLhJBFG\" async defer></script>");
$templateCache.put("app/contentLibrary/widgets/autoLogin.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\" role=heading><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.al.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.al.2\' | translate}} &nbsp; <span ng-if=al.label>[ {{al.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=al.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=al.url ng-disabled=!isCred maxlength=1000 placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div ng-if=isCred><div class=form-group><label for=uName>{{\'cl.widget.al.5\' | translate}}</label><input type=text id=uName class=form-control ng-model=al.u aria-label=\"{{\'cl.widget.al.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.al.4\' | translate}}\"></div><div class=form-group><label for=pass>{{\'cl.widget.telax.9.3\' | translate}}</label><input type=password id=pass class=form-control ng-model=al.p aria-label=\"{{\'cl.widget.telax.9.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.9.3\' | translate}}\"></div><div class=form-group><label for=cPass>{{\'cl.widget.telax.9.4\' | translate}}</label><input type=password id=cPass class=form-control ng-model=al.cp aria-label=\"{{\'cl.widget.telax.9.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.9.4\' | translate}}\"></div></div><div class=form-group ng-if=!isCred><label>{{\'cl.widget.al.4\' | translate}}</label><div><button type=reset role=button class=\"btn btn-primary btn-xs\" ng-click=resetFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></div></div><div class=\"form-group marB10\"><label>{{\'ms.label.6.1\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=al.ssType name=thumbOpt value=g><label></label>{{\'cl.widget.queue.1b\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=al.ssType name=thumbOpt value=s><label></label>{{\'cl.widget.iMenu.18\' | translate}}</label></div></div><div class=form-group ng-if=\"al.ssType == \'s\'\"><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!al.isHidden && (al.clImg.thumb || al.clImg.type == \'SharePointC\' || al.clImg.type == \'OneDriveC\' || al.clImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'t\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=al.clImg.thumb ng-href=\"{{cDetailBucket + al.clImg.thumb | secureThumb}}\" role=button data-access={{al.clImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(al.clImg.path + (al.clImg.path.length > 1 ? \' / \' : \' \') + al.clImg.label)}}\" ng-show=al.clImg.thumb><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + al.clImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"al.clImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"al.clImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"al.clImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=al.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-sm></div><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"selectContentOpen(\'t\');\">{{\'cm.label.30\' | translate | camelCase}}</button></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.al.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=al.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=al.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"al.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=al.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.al.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.al.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':al.settings.bg, opacity:al.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"al.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{al.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=al.settings.bg selected-type=al.settings.ctype.bg is-alpha=true selected-alpha=al.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=al.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=al.activePeriod></ng-active-period></div></div></div><!-- Preview --><div class=col-xs-3 ng-if=\"(al.ssType == \'g\' && al.ss) || (al.ssType == \'s\' && al.ss && !al.isHidden)\"><label>{{\'cl.widget.ss.7\' | translate}}</label><div class=\"pad5 bg-light text-center\"><a href=\"\" role=link ng-href=\"{{cDetailBucket + al.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{al.label}}><img alt=Preview ng-src=\"{{thumbHost + tim + cBucket + al.ssImg+\'?v\'+timestamp + thumbBigParam}}\"></a></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=alFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'clImg\'\" aria-live=polite role=status>{{\'cl.widget.msg.29\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.al.m1\' | translate}}</div><div ng-if=\"errType==\'reloadEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><span ng-if=\"errType==\'uName\'\" aria-live=polite role=status>{{\'cl.widget.al.m4\' | translate}}</span> <span ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'cl.widget.jci.m3\' | translate | lowercase}}</span> <span ng-if=\"errType==\'cPass\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m14\' | translate}}</span> <span ng-if=\"errType==\'match\'\" aria-live=polite role=status>{{\'cl.widget.al.m5\' | translate}}</span></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/blank.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.bk.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.bk.1.1\' | translate}} &nbsp; <span ng-if=blank.label>[ {{blank.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label id=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=blank.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=blank.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=blank.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=blankSaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/cisco.html","<div ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><span ng-if=tabView><a href=\"\" class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\"></span></a>{{\'cl.widget.cisco.1\' | translate}}</span> <span ng-if=!tabView>{{\'cl.widget.cisco.2\' | translate}} &nbsp; <span ng-if=cisco.label>[ {{cisco.label}} ]</span></span></div><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=cisco.label maxlength={{inputLimit}} focus-me=true></div><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=netLoading><div ng-if=!netLoading><label for=net>{{\'cl.widget.cisco.3\' | translate}}</label><select class=form-control id=net ng-model=cisco.network ng-options=\"net.name for net in networkList track by net.name\" ng-change=sensorListFx()><option value=\"\" disabled>{{\'cl.widget.cisco.3.1\' | translate}}</option></select></div></div><!-- <div class=\"form-group\">\r\n        <label for=\"device\">{{\'cm.label.4\' | translate}}</label>\r\n        <select class=\"form-control\" id=\"device\" ng-model=\"cisco.device\" ng-options=\"d.label for d in deviceList track by d.label\">\r\n          <option value=\"\" disabled>{{\'cm.label.31\' | translate}}</option>\r\n        </select>\r\n      </div> --><div class=form-group ng-if=cisco.network><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=sLoading><div ng-if=!sLoading><label for=sensor>{{\'cl.widget.cisco.4\' | translate}}</label><select class=form-control id=sensor ng-model=cisco.sensor ng-options=\"sen as (sen.mac +\' [\'+sen.model+\']\') for sen in sensorList track by sen.model\" ng-change=readingListFx()><option value=\"\" disabled>{{\'cl.widget.cisco.4.1\' | translate}}</option></select></div></div><div class=form-group ng-if=cisco.sensor><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=rLoading><div ng-if=!rLoading><label for=net>{{\'cl.widget.cisco.14\' | translate}}</label><div ng-if=cisco.readings.length><label ng-repeat=\"reading in cisco.readings track by reading.name\" class=\"noMarB marR10\"><input type=checkbox name=reading.name ng-model=reading.value value=reading.value ng-change=readTypeFx(reading)><label></label>{{reading.name | capitalize | uppercase}}</label></div><div ng-if=!cisco.readings.length class=text-muted>N/A</div></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=cisco.dType value=hl ng-change=\"dTypeChange(\'hl\')\"><label></label>{{\'cl.widget.cisco.15\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=cisco.dType value=vl ng-change=\"dTypeChange(\'vl\')\"><label></label>{{\'cl.widget.cisco.16\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=cisco.dType value=ss ng-change=\"dTypeChange(\'ss\')\"><label></label>{{\'cl.widget.cisco.17\' | translate}}</label></div></div><div class=form-group><div class=\"marR20 marB20\" ng-if=\"cisco.dType == \'hl\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/cisco-hl.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"cisco.dType == \'vl\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/cisco-vl.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"cisco.dType == \'ss\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/cisco-ss.png alt=\"Template 3\"></label></div></div></div><div class=col-xs-9><div class=form-group><a href=\"\" class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\"></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\"></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"cisco.dType == \'hl\' || cisco.dType == \'vl\'\"><div class=form-group><label class=marB10>{{\'cl.widget.aqi.7\' | translate}}</label><div ng-if=\"hvl.settings.readList.length > 0\"><div class=mainRowReading><div ng-repeat=\"list in hvl.settings.readList\"><div ng-repeat=\"(key, data) in list\" class=bdr-top-dashed style=\"flex: 1\"><div class=form-group ng-if=\"key == \'temperature\'\"><label>{{\'cl.widget.cisco.18\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dUnitOpt ng-model=hvl.settings.unit value=f ng-change=\"changeUnit(\'f\')\"><label></label>{{\'cl.widget.weather.8.2\' | translate:{deg: \"(&deg;F)\"} }}</label><label class=noMarB><input type=radio name=dUnitOpt ng-model=hvl.settings.unit value=c ng-change=\"changeUnit(\'c\')\"><label></label>{{\'cl.widget.weather.8.1\' | translate:{deg: \"(&deg;C)\"} }}</label></div></div><label class=marB25 for=readName ng-if=\"key == \'temperature\'\">TEMPERATURE</label><label class=marB25 for=readName ng-if=\"key == \'humidity\'\">HUMIDITY</label><label class=marB25 for=readName ng-if=\"key == \'tvoc\'\">TVOC</label><label class=marB25 for=readName ng-if=\"key == \'pm25\'\">PM2.5</label><label class=marB25 for=readName ng-if=\"key == \'noise\'\">AMBIENT NOISE</label><label class=marB25 for=readName ng-if=\"key == \'indoorAirQuality\'\">INDOOR AIR QUALITY</label><label class=marB25 for=readName ng-if=\"key == \'eco2\'\">ECO2</label><label class=marB25 for=readName ng-if=\"key == \'battery\'\">BATTERY</label><div class=wraperReading id=rangeWidth ng-if=\"key == \'temperature\'\"><span class=scaleDeg>{{hvl.settings.unit == \'f\' ? \'&deg;F\' : \'&deg;C\'}}</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=hvl.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=hvl.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=hvl.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=hvl.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=hvl.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=hvl.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=hvl.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=hvl.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'humidity\'\"><span class=scaleDeg>%RH</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=hvl.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=hvl.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=hvl.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=hvl.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=hvl.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=hvl.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=hvl.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=hvl.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'indoorAirQuality\'\"><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=hvl.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=hvl.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=hvl.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=hvl.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'battery\'\"><span class=scaleDeg>%</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=hvl.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=hvl.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=hvl.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=hvl.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0 max=99></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'eco2\'\"><span class=scaleDeg ng-if=\"key == \'eco2\'\">ppm</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=hvl.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=hvl.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=hvl.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key != \'temperature\' && key != \'humidity\' && key != \'indoorAirQuality\' && key != \'battery\' && key != \'eco2\'\"><span class=scaleDeg ng-if=\"key == \'tvoc\'\">&#956;g/m&#179;</span> <span class=scaleDeg ng-if=\"key == \'pm25\'\">&#956;g/m&#179;</span> <span class=scaleDeg ng-if=\"key == \'noise\'\">dBA</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=hvl.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=hvl.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=hvl.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=hvl.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=hvl.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"hvl.settings.readList.length == 0\">{{\'cl.widget.cisco.m10\' | translate}}</div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':hvl.settings.hvbg, opacity:hvl.settings.hvbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"hvl.settings.hvbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{hvl.settings.hvbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=hvl.settings.hvbg selected-type=hvl.ctype.hvbg is-alpha=true selected-alpha=hvl.settings.hvbga ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><!-- <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.news.6\' | translate}}</label>\r\n                <div>\r\n                  <label class=\"noMarB marR10\"><input type=\"radio\" ng-model=\"hvl.settings.rotationOpt\" name=\"rotationOpt\" value=\"a\"><label></label> {{\'cl.widget.news.6.1\' | translate}}</label>\r\n                  <label class=\"noMarB\"><input type=\"radio\" ng-model=\"hvl.settings.rotationOpt\" name=\"rotationOpt\" value=\"c\"><label></label> {{\'cm.label.17\' | translate}}</label>\r\n                </div>\r\n                <div class=\"form-inline marT5\">\r\n                  <div class=\"input-group\" ng-if=\"hvl.settings.rotationOpt == \'c\'\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"hvl.settings.rotate\" focus-me=\"true\" min=\"1\">\r\n                    <div class=\"input-group-addon\">{{\'cm.label.27s\' | translate}}</div>\r\n                  </div>\r\n                </div>\r\n              </div> --></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hvt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':hvl.settings.hvt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"hvl.settings.hvt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hvt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=hvl.settings.hvt selected-type=hvl.ctype.hvt ng-if=colorPicker.hvt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.count.9\' | translate}}</label><input type=number class=form-control ng-model=hvl.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.count.10\' | translate}}</label><select class=form-control ng-model=hvl.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.18\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hvv><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':hvl.settings.hvv}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"hvl.settings.hvv | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hvv=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=hvl.settings.hvv selected-type=hvl.ctype.hvv ng-if=colorPicker.hvv></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.aqi.20\' | translate | capitalize}}</label><input type=number class=form-control ng-model=hvl.settings.valueSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.aqi.19\' | translate | capitalize}}</label><select class=form-control ng-model=hvl.settings.valueFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hvu><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':hvl.settings.hvu}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"hvl.settings.hvu | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hvu=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=hvl.settings.hvu selected-type=hvl.ctype.hvu ng-if=colorPicker.hvu></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.6\' | translate}}</label><input type=number class=form-control ng-model=hvl.settings.unitSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.7\' | translate}}</label><select class=form-control ng-model=hvl.settings.unitFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div ng-if=\"cisco.dType == \'ss\'\"><div class=form-group><label class=marB10>{{\'cl.widget.aqi.7\' | translate}}</label><div ng-if=\"slide.settings.readList.length > 0\"><div class=mainRowReading><div ng-repeat=\"list in slide.settings.readList\"><div ng-repeat=\"(key, data) in list\" class=bdr-top-dashed style=\"flex: 1\"><div class=form-group ng-if=\"key == \'temperature\'\"><label>{{\'cl.widget.cisco.18\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dUnitOpt ng-model=slide.settings.unit value=f ng-change=\"changeUnit(\'f\')\"><label></label>{{\'cl.widget.weather.8.2\' | translate:{deg: \"(&deg;F)\"} }}</label><label class=noMarB><input type=radio name=dUnitOpt ng-model=slide.settings.unit value=c ng-change=\"changeUnit(\'c\')\"><label></label>{{\'cl.widget.weather.8.1\' | translate:{deg: \"(&deg;C)\"} }}</label></div></div><label class=marB25 for=readName ng-if=\"key == \'temperature\'\">TEMPERATURE</label><label class=marB25 for=readName ng-if=\"key == \'humidity\'\">HUMIDITY</label><label class=marB25 for=readName ng-if=\"key == \'tvoc\'\">TVOC</label><label class=marB25 for=readName ng-if=\"key == \'pm25\'\">PM2.5</label><label class=marB25 for=readName ng-if=\"key == \'noise\'\">AMBIENT NOISE</label><label class=marB25 for=readName ng-if=\"key == \'indoorAirQuality\'\">INDOOR AIR QUALITY</label><label class=marB25 for=readName ng-if=\"key == \'eco2\'\">ECO2</label><label class=marB25 for=readName ng-if=\"key == \'battery\'\">BATTERY</label><div class=wraperReading id=rangeWidth ng-if=\"key == \'temperature\'\"><span class=scaleDeg>{{slide.settings.unit == \'f\' ? \'&deg;F\' : \'&deg;C\'}}</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=slide.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=slide.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=slide.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=slide.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=slide.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=slide.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=slide.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=slide.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'humidity\'\"><span class=scaleDeg>%RH</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=slide.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=slide.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=slide.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=slide.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=slide.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=slide.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=slide.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=slide.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'indoorAirQuality\'\"><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=slide.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=slide.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=slide.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=slide.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'battery\'\"><span class=scaleDeg>%</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.li.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.li.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.li.src, opacity:data.li.srca}\" class=picker ng-value=\"data.li.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.li.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.li.src selected-type=slide.ctype.li is-alpha=true selected-alpha=data.li.srca ng-if=color.data.li.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.li.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lp.src, opacity:data.lp.srca}\" class=picker ng-value=\"data.lp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lp.src selected-type=slide.ctype.lp is-alpha=true selected-alpha=data.lp.srca ng-if=color.data.lp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lp.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lf.src, opacity:data.lf.srca}\" class=picker ng-value=\"data.lf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lf.src selected-type=slide.ctype.lf is-alpha=true selected-alpha=data.lf.srca ng-if=color.data.lf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lf.value min=0 max=100></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.lg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.lg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.lg.src, opacity:data.lg.srca}\" class=picker ng-value=\"data.lg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.lg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.lg.src selected-type=slide.ctype.lg is-alpha=true selected-alpha=data.lg.srca ng-if=color.data.lg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.lg.value min=0 max=99></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key == \'eco2\'\"><span class=scaleDeg ng-if=\"key == \'eco2\'\">ppm</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=slide.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=slide.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=slide.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div><div class=wraperReading id=rangeWidth ng-if=\"key != \'temperature\' && key != \'humidity\' && key != \'indoorAirQuality\' && key != \'battery\' && key != \'eco2\'\"><span class=scaleDeg ng-if=\"key == \'tvoc\'\">&#956;g/m&#179;</span> <span class=scaleDeg ng-if=\"key == \'pm25\'\">&#956;g/m&#179;</span> <span class=scaleDeg ng-if=\"key == \'noise\'\">dBA</span><ul class=containerReading ng-style=\"{\'border-top-color\':data.ex.src}\"><div class=rangeName>{{\'cl.widget.cisco.23\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.ex.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.ex.src, opacity:data.ex.srca}\" class=picker ng-value=\"data.ex.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.ex.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.ex.src selected-type=slide.ctype.ex is-alpha=true selected-alpha=data.ex.srca ng-if=color.data.ex.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.ex.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hg.src}\"><div class=rangeName>{{\'cl.widget.cisco.22\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hg.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hg.src, opacity:data.hg.srca}\" class=picker ng-value=\"data.hg.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hg.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hg.src selected-type=slide.ctype.hg is-alpha=true selected-alpha=data.hg.srca ng-if=color.data.hg.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hg.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hf.src}\"><div class=rangeName>{{\'cl.widget.cisco.21\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hf.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hf.src, opacity:data.hf.srca}\" class=picker ng-value=\"data.hf.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hf.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hf.src selected-type=slide.ctype.hf is-alpha=true selected-alpha=data.hf.srca ng-if=color.data.hf.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hf.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hp.src}\"><div class=rangeName>{{\'cl.widget.cisco.20\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hp.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hp.src, opacity:data.hp.srca}\" class=picker ng-value=\"data.hp.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hp.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hp.src selected-type=slide.ctype.hp is-alpha=true selected-alpha=data.hp.srca ng-if=color.data.hp.src></ng-hub-color-picker></div></div><input type=number style=\"width: 50px; border: none; border-left: 1px solid gray;background-color: transparent\" ng-model=data.hp.value min=0></span></li></ul><ul class=containerReading ng-style=\"{\'border-top-color\':data.hi.src}\"><div class=rangeName>{{\'cl.widget.cisco.19\' | translate}}</div><li class=linkReading><span style=\"display: flex; border: 1px solid gray;margin-right: -1px\"><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=color.data.hi.src><div class=\"input-group input-colorPicker\" style=\"height: 24px\"><span class=input-group-addon style=\"padding: 3px\"><span class=trBg><span ng-style=\"{\'background-color\':data.hi.src, opacity:data.hi.srca}\" class=picker ng-value=\"data.hi.src | uppercase\" uib-dropdown-toggle ng-click=\"color.data.hi.src=true\"></span></span></span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=data.hi.src selected-type=slide.ctype.hi is-alpha=true selected-alpha=data.hi.srca ng-if=color.data.hi.src></ng-hub-color-picker></div></div></span></li></ul></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"slide.settings.readList.length == 0\">{{\'cl.widget.cisco.m10\' | translate}}</div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sbc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':slide.settings.sbg, opacity:slide.settings.sbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.sbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{slide.settings.sbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.sbg selected-type=slide.ctype.sbg is-alpha=true selected-alpha=slide.settings.sbga ng-if=colorPicker.sbc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=slide.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio ng-model=slide.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"slide.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=slide.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.sht}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.sht | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sht=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.sht selected-type=slide.ctype.sht ng-if=colorPicker.sht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.28\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.headerSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.29\' | translate}}</label><select class=form-control ng-model=slide.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.srt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.srt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.srt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.srt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.srt selected-type=slide.ctype.srt ng-if=colorPicker.srt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.9\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.readSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.10\' | translate}}</label><select class=form-control ng-model=slide.settings.readFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.srv><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.srv}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.srv | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.srv=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.srv selected-type=slide.ctype.srv ng-if=colorPicker.srv></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.12\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.readVSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.13\' | translate}}</label><select class=form-control ng-model=slide.settings.readVFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sru><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.sru}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.sru | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sru=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.sru selected-type=slide.ctype.sru ng-if=colorPicker.sru></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.31\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.readUSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.32\' | translate}}</label><select class=form-control ng-model=slide.settings.readUFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.24\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.st}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.st | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.st selected-type=slide.ctype.st ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.25\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.26\' | translate}}</label><select class=form-control ng-model=slide.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.aqi.18\' | translate | capitalize}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sv><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.sv}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.sv | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sv=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.sv selected-type=slide.ctype.sv ng-if=colorPicker.sv></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.aqi.20\' | translate | capitalize}}</label><input type=number class=form-control ng-model=slide.settings.valueSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.aqi.19\' | translate | capitalize}}</label><select class=form-control ng-model=slide.settings.valueFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cisco.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.su><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slide.settings.su}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"slide.settings.su | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.su=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slide.settings.su selected-type=slide.ctype.su ng-if=colorPicker.su></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cisco.6\' | translate}}</label><input type=number class=form-control ng-model=slide.settings.unitSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cisco.7\' | translate}}</label><select class=form-control ng-model=slide.settings.unitFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=cisco.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=cisco.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"ciscoFx(\'save\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'network\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m1\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'sc.bug.m3\' | translate}}</div><div ng-if=\"errType==\'sensor\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m2\' | translate}}</div><div ng-if=\"errType==\'reading\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m5\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m8\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'vSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m3\' | translate}}</div><div ng-if=\"errType==\'uSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m4\' | translate}}</div><div ng-if=\"errType==\'rSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m6\' | translate}}</div><div ng-if=\"errType==\'rvSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m7\' | translate}}</div><div ng-if=\"errType==\'ruSize\'\" aria-live=polite role=status>{{\'cl.widget.cisco.m9\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'sameValue\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m2\' | translate}}</div><div ng-if=\"errType==\'sameScaleColor\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m3\' | translate}}</div><div ng-if=\"errType==\'scaleRange\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m4\' | translate}}</div><div ng-if=\"errType==\'value\'\" aria-live=polite role=status>{{\'cl.widget.aqi.m6\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/cloudCoverMusic.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list aria-label=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.ccm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.ccm.2\' | translate}} &nbsp; <span ng-if=ccm.label>[ {{ccm.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=tab ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=tab ng-click=ccmFx(1);><span class=badge>2</span>{{\'cl.widget.mc.4\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=ccm.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=\"col-xs-12 marT10\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=ccm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=ccm.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12 ng-attr-style=height:{{getAvailableHeight(390)}}px><iframe src=https://tune.d.cloudcovermusic.com/#/login border=0 height=100% width=100% class=ccm-iframe></iframe></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=ccmFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.mc.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"ccmFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/cloudFarm.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list aria-label=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.clFarm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.clFarm.2\' | translate}} &nbsp; <span ng-if=cloudFarm.label>[ {{cloudFarm.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=cloudFarm.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input id=url type=text class=form-control ng-model=cloudFarm.settings.url aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div class=form-group><div class=row><div class=col-xs-6><label for=uName>{{\'cl.widget.jci.4.1\' | translate}}</label><input id=uName type=text class=form-control ng-model=cloudFarm.settings.uName aria-label=\"{{\'cl.widget.jci.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.jci.4.1\' | translate}}\" autocomplete=off></div><div class=col-xs-6><label for=pass>{{\'cl.widget.jci.4.2\' | translate}}</label><div class=\"inner-addon right-addon\"><span id=eyeIcon class=glyphicon ng-class=\"isPassShow ? \'glyphicon-eye-close\' : \'glyphicon-eye-open\'\" ng-mousedown=showPassFx(true); ng-mouseup=showPassFx(false);></span> <input id=pass type=password class=\"form-control padR30\" ng-model=cloudFarm.settings.pass aria-label=\"{{\'cl.widget.jci.4.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.jci.4.2\' | translate}}\" autocomplete=off></div></div></div></div><div class=form-group><label for=fId>{{\'cl.widget.clFarm.3\' | translate}}</label><input id=fId type=text class=form-control ng-model=cloudFarm.settings.fId aria-label=\"{{\'cl.widget.clFarm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.clFarm.3\' | translate}}\" autocomplete=off></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label for=reloadOptA class=\"noMarB marR10\"><input type=radio role=radio id=reloadOptA ng-model=cloudFarm.settings.reloadOpt name=reloadOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label for=reloadOptC class=noMarB><input type=radio role=radio id=reloadOptC ng-model=cloudFarm.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"cloudFarm.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=cloudFarm.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=cloudFarm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=cloudFarm.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=cloudFarmFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'url\'\">{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType == \'uname\'\">{{\'cl.widget.jci.m2\' | translate}}</div><div ng-if=\"errType == \'pass\'\">{{\'cl.widget.jci.m3\' | translate}}</div><div ng-if=\"errType == \'fId\'\">{{\'cl.widget.clFarm.m1\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.msg.21\' | translate}}</div><!-- <div ng-if=\"errType == \'rotate\'\">{{\'cl.widget.msg.22\' | translate}}</div> --><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/codButton.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.codBtn.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.codBtn.2\' | translate}} &nbsp; <span ng-if=codBtn.label>[ {{codBtn.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=codBtn.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\" s ng-class=\"{\'disabled\': !widgetList.contentOnDemand}\" uib-tooltip=\"{{\'cm.msg.52\' | translate}}\" tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=500 tooltip-enable=!widgetList.contentOnDemand ng-cloak><input type=radio role=radio ng-model=codBtn.type ng-change=\"resetImgFx(\'content\')\" name=thumbOpt value=cod ng-change=\"codBtn.tContent = \'\'\" ng-disabled=!widgetList.contentOnDemand><label></label>{{\'cl.widget.cod.1\' | translate}}</label><label ng-if=\"(!encId && widgetList.intelJciMap) || (encId && widgetList.intelJciMap || codBtn.settings.type==\'jci\')\" class=\"noMarB marR10\" ng-class=\"{\'disabled\': !widgetList.intelJciMap}\" uib-tooltip=\"{{\'cm.msg.52\' | translate}}\" tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=500 tooltip-enable=!widgetList.intelJciMap ng-cloak><input type=radio role=radio ng-model=codBtn.type ng-change=\"resetImgFx(\'content\')\" name=thumbOpt value=jci ng-change=\"codBtn.tContent = \'\'\" ng-disabled=!widgetList.intelJciMap><label></label>{{\'cl.widget.jci.1\' | translate}}</label><label ng-if=\"(!encId && widgetList.intelSmartBuilding) || (encId && widgetList.intelSmartBuilding || codBtn.settings.type==\'sb\')\" class=\"noMarB marR10\" ng-class=\"{\'disabled\': !widgetList.intelSmartBuilding}\" uib-tooltip=\"{{\'cm.msg.52\' | translate}}\" tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=500 tooltip-enable=!widgetList.intelSmartBuilding ng-cloak><input type=radio role=radio ng-model=codBtn.type ng-change=\"resetImgFx(\'content\')\" name=thumbOpt value=sb ng-change=\"codBtn.tContent = \'\'\" ng-disabled=!widgetList.intelSmartBuilding><label></label>{{\'cl.widget.isb.1\' | translate}}</label><label ng-if=\"(!encId && widgetList.webPage) || (encId && widgetList.webPage || codBtn.settings.type==\'url\')\" class=noMarB ng-class=\"{\'disabled\': !widgetList.webPage}\" uib-tooltip=\"{{\'cm.msg.52\' | translate}}\" tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=500 tooltip-enable=!widgetList.webPage ng-cloak><input type=radio role=radio ng-model=codBtn.type ng-change=\"resetImgFx(\'content\')\" name=thumbOpt value=url ng-change=\"codBtn.tContent = \'\'\" ng-disabled=!widgetList.webPage><label></label>{{\'cl.widget.wp.1\' | translate}}</label></div></div><div class=form-group ng-if=\"codBtn.type != \'cod\'\"><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!codBtn.tContent.isHidden && (codBtn.tContent.thumb || codBtn.tContent.type == \'SharePointC\' || codBtn.tContent.type == \'OneDriveC\' || codBtn.tContent.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeTBgFx();><span class=\"fa fa-times-circle\"></span></a> <a href=\"\" role=link class=cursorDefault><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/xs/{{codBtn.tContent.thumb}}.png?{{inputImgThumbParam}} class=\"img-responsive center-block img-widget\"> </a><img alt=\"\" ng-if=\"codBtn.tContent.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"codBtn.tContent.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"codBtn.tContent.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=codBtn.tContent.isHidden><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button ng-if=\"(codBtn.type == \'cod\' && widgetList.contentOnDemand) || (codBtn.type == \'jci\' && widgetList.intelJciMap) || (codBtn.type == \'sb\' && widgetList.intelSmartBuilding) || (codBtn.type == \'url\' && widgetList.webPage)\" type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"selectContentPopOpen(\'content\');\">{{\'cm.label.32\' | translate | camelCase}}</button></div></div></div><div class=col-xs-10 ng-class=\"{\'marT10\': codBtn.tContent != \'\'}\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"checkScrollFx();settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group ng-if=\"codBtn.type != \'cod\'\"><label class=\"noMarB marR10\"><input type=checkbox ng-model=codBtn.settings.closeBtn ng-change=selCloseBtnFx() role=checkbox><label></label>{{\'cl.widget.codBtn.5\' | translate}}</label></div><div class=form-group ng-if=\"codBtn.type != \'cod\'\"><label>{{\'cl.widget.codBtn.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\" ng-class=\"{\'disabled\':timeoutDisable}\"><input type=radio role=radio ng-model=codBtn.settings.idleTimeout name=reloadOpt value=n ng-disabled=timeoutDisable><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=codBtn.settings.idleTimeout name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"codBtn.settings.idleTimeout == \'c\'\"><input type=number id=cReload class=form-control ng-model=codBtn.settings.timeout focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"panel-inner-tab marB10\">{{\'cl.widget.codBtn.3\' | translate}}</div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=codBtn.settings.bType ng-change=resetImgFx() name=btnOpt value=i ng-change=\"codBtn.tContent = \'\'\"><label></label>{{\'cm.label.30\' | translate | camelCase}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=codBtn.settings.bType ng-change=resetImgFx() name=btnOpt value=c ng-change=\"codBtn.tContent = \'\'\"><label></label>{{\'cm.label.17\' | translate}}</label></div></div><div ng-if=\"codBtn.settings.bType == \'c\' || codBtn.settings.bType == \'i\'\"><div class=row><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.codBtn.3.1\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!codBtn.iconImg.isHidden && (codBtn.iconImg.thumb || codBtn.iconImg.type == \'SharePointC\' || codBtn.iconImg.type == \'OneDriveC\' || codBtn.iconImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeBgFx();><span class=\"fa fa-times-circle\"></span></a> <a ng-if=codBtn.iconImg.thumb ng-href=\"{{cDetailBucket + codBtn.iconImg.thumb | secureThumb}}\" role=link data-access={{codBtn.iconImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(codBtn.iconImg.path + (codBtn.iconImg.path.length > 1 ? \' / \' : \' \') + codBtn.iconImg.label)}}\" ng-show=codBtn.iconImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + codBtn.iconImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"codBtn.iconImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"codBtn.iconImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"codBtn.iconImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=codBtn.iconImg.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentPopOpen();>{{\'cm.label.30\' | translate | camelCase}}</button></div></div></div><div class=col-xs-4 ng-if=\"codBtn.settings.bType == \'c\'\"><div class=form-group><label for=iconP>{{\'cl.widget.iMenu.14\' | translate}}</label><select id=iconP class=form-control ng-model=codBtn.settings.iconP ng-disabled=\"codBtn.iconImg ==\'\'\" ng-change=checkScrollFx(); aria-label=\"{{\'cl.widget.iMenu.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.14\' | translate}}\"><option value=t>{{\'cl.widget.count.4.1\' | translate}}</option><option value=b>{{\'cl.widget.count.4.3\' | translate}}</option><option value=l>{{\'cl.widget.count.4.4\' | translate}}</option><option value=r>{{\'cl.widget.count.4.2\' | translate}}</option></select></div></div><div class=col-xs-4 ng-if=\"codBtn.settings.bType == \'c\'\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':codBtn.settings.bg, opacity:codBtn.settings.bga}\"></span></span></span> <input type=text aria-label=bgColor name=bgColor class=\"form-control picker\" ng-value=\"codBtn.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{codBtn.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=codBtn.settings.bg selected-type=codBtn.ctype.bg is-alpha=true selected-alpha=codBtn.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\" ng-if=\"codBtn.settings.bType == \'c\'\"><div class=col-xs-4><div class=form-group><label for=btnLabel>{{\'cl.widget.codBtn.3.2\' | translate}}</label><input type=text id=btnLabel class=form-control ng-model=codBtn.settings.text maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.codBtn.3.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.codBtn.3.2\' | translate}}\"></div></div><div class=\"col-xs-4 hide\"><div class=form-group><label for=textStyle>{{\'cl.widget.codBtn.3.3\' | translate}}</label><select id=textStyle class=form-control ng-model=codBtn.settings.textStyle aria-label=\"{{\'cl.widget.codBtn.3.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.codBtn.3.3\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.codBtn.3.5\' | translate}}</option><option value=b>{{\'cm.editor.10.1\' | translate}}</option><option value=i>{{\'cm.editor.10.2\' | translate}}</option><option value=u>{{\'cm.editor.10.3\' | translate}}</option></select></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':codBtn.settings.textColor}\"></span></span> <input type=text aria-label=btTitleText class=\"form-control picker\" name=btTitleText ng-value=\"codBtn.settings.textColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=codBtn.settings.textColor selected-type=codBtn.ctype.textColor is-alpha=true selected-alpha=codBtn.settings.textColor ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=textSize>{{\'cl.widget.codBtn.3.4\' | translate}}</label><input type=number id=textSize min=1 class=form-control ng-model=codBtn.settings.textSize ng-change=checkScrollFx(); aria-label=\"{{\'cl.widget.codBtn.3.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.codBtn.3.4\' | translate}}\"></div></div><div class=row ng-if=\"codBtn.settings.bType == \'c\'\"><div class=col-xs-4><label for=textFont>{{\'cm.label.24\' | translate}}</label><select id=textFont class=form-control ng-model=codBtn.settings.textFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div></div><div ng-if=\"(codBtn.settings.bType == \'c\' && (codBtn.iconImg != \'\' || codBtn.settings.text != \'\')) || (codBtn.settings.bType == \'i\' && codBtn.iconImg != \'\')\" class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.codBtn.4\' | translate}}</div><div class=\"row marT15\" ng-if=\"(codBtn.settings.bType == \'c\' && (codBtn.iconImg != \'\' || codBtn.settings.text != \'\')) || (codBtn.settings.bType == \'i\' && codBtn.iconImg != \'\')\"><div class=pad10><div class=\"col-xs-12 previewBox\" style=\"background-color:{{codBtn.settings.bg | colorWithOpacity:codBtn.settings.bga}}\" ng-class=\"{\'b-c\':(codBtn.settings.iconP==\'b\' && codBtn.iconImg != \'\'),\'t-c\':(codBtn.settings.iconP==\'t\' && codBtn.iconImg != \'\'),\'r-c\':(codBtn.settings.iconP==\'r\' && codBtn.iconImg != \'\'),\'l-c\':(codBtn.settings.iconP==\'l\' && codBtn.iconImg != \'\'), \'d-flex\':codBtn.iconImg != \'\',\'justify-center\':(codBtn.settings.iconP == \'l\' || codBtn.settings.iconP == \'r\')}\"><div id=btnText ng-if=\"codBtn.settings.bType == \'c\' && codBtn.settings.text != \'\'\" class=padLR10 ng-class=\"{\'text-bold\':codBtn.settings.textStyle==\'b\',\'text-italic\':codBtn.settings.textStyle==\'i\', \'text-underline\':codBtn.settings.textStyle==\'u\'}\" style=color:{{codBtn.settings.textColor}};font-size:{{codBtn.settings.textSize}}px;margin:revert;font-family:{{codBtn.settings.textFont.value}}>{{codBtn.settings.text}}</div><img alt=\"\" id=iconImg ng-if=\"codBtn.iconImg.thumb && !codBtn.iconImg.isHidden\" ng-src=\"{{cDetailBucket + codBtn.iconImg.thumb | secureThumb}}\"> <img alt=\"\" id=iconImg ng-if=codBtn.iconImg.isHidden uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png></div></div></div></div></div></div><!-- below image used to get width only for preview --> <img alt=\"\" id=iconImg2 style=display:none ng-if=\"codBtn.iconImg.thumb && !codBtn.iconImg.isHidden\" ng-src=\"{{cDetailBucket + codBtn.iconImg.thumb}}\"> <img alt=\"\" id=iconImg2 style=display:none ng-if=codBtn.iconImg.isHidden uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=codBtn.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=codBtn.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=codBtnFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'iconText\'\" aria-live=polite role=status>{{\'cl.widget.codBtn.m1\' | translate}}</div><div ng-if=\"errType==\'textSize\'\" aria-live=polite role=status>{{\'cl.widget.codBtn.m2\' | translate}}</div><div ng-if=\"errType==\'cEmpty\'\" aria-live=polite role=status>{{\'t.msg.13\' | translate}}</div><div ng-if=\"errType==\'iEmpty\'\" aria-live=polite role=status>{{\'cl.widget.codBtn.m3\' | translate}}</div><div ng-if=\"errType==\'timeoutEmpty\'\" aria-live=polite role=status>{{\'cl.widget.codBtn.m4\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/coe.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list aria-label=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.coe.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.coe.2\' | translate}} &nbsp; <span ng-if=coe.info.label>[ {{coe.info.label}} ]</span></h1><div class=\"pull-right marL5 marT-5\" ng-show=\"!tabView && id\"><button type=button role=button class=\"btn btn-sm btn-default\" ng-click=createView();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.coe.6\' | translate}}</button></div></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=tab ng-click=tabFx(1); ng-disabled=reponseLoad><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=tab ng-click=coeFx(1); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>2</span>{{\'cl.widget.coe.3\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=tab ng-click=coeFx(2); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'4\'}\"><a href=\"\" role=tab ng-click=coeFx(3); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>4</span>{{\'cl.widget.meeting.7\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'m\'); editMForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.coe.5\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'r\'); editRForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'4\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.20\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-6><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=coe.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- Roomboard--><div class=\"panel-inner-tab marB10\">{{\'cl.widget.oc.4\' | translate}}</div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.rb.bg, opacity:coe.info.settings.rb.bga}\"></span></span></span> <input type=text name=rbBgColor class=\"form-control picker\" ng-value=\"coe.info.settings.rb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.rb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.rb.bg selected-type=coe.info.ctype.rb.bg is-alpha=true selected-alpha=coe.info.settings.rb.bga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rs><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.rb.ssbg, opacity:coe.info.settings.rb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" name=rbSsbgColor ng-value=\"coe.info.settings.rb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rs=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.rb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.rb.ssbg selected-type=coe.info.ctype.rb.ssbg is-alpha=true selected-alpha=coe.info.settings.rb.ssbga ng-if=colorPicker.rs></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoRBOpt ng-model=coe.info.settings.rb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoRBOpt ng-model=coe.info.settings.rb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.rb.titleText}\"></span></span> <input type=text class=\"form-control picker\" name=rbTitleText ng-value=\"coe.info.settings.rb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.rb.titleText selected-type=coe.info.ctype.rb.titleText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=coe.info.settings.rb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=coe.info.settings.rb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rst><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.rb.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" name=rbSubtitleText ng-value=\"coe.info.settings.rb.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rst=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.rb.subtitleText selected-type=coe.info.ctype.rb.subtitleText ng-if=colorPicker.rst></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.oc.14\' | translate}}</label><select class=form-control ng-model=coe.info.settings.rb.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubTSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubTSize class=form-control ng-model=coe.info.settings.rb.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.rb.timeText}\"></span></span> <input type=text class=\"form-control picker\" name=rbTimeText ng-value=\"coe.info.settings.rb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.rb.timeText selected-type=coe.info.ctype.rb.timeText ng-if=colorPicker.rtm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.oc.17\' | translate}}</label><select class=form-control ng-model=coe.info.settings.rb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=coe.info.settings.rb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=coe.info.settings.rb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=coe.info.settings.rb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"coe.info.settings.rb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosP class=form-control ng-model=coe.info.settings.rb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=coe.info.settings.rb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=coe.info.settings.rb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"coe.info.settings.rb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosA class=form-control ng-model=coe.info.settings.rb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Wallboard --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.oc.5\' | translate}}</div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL noMarR\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=coe.info.settings.wb.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=coe.info.settings.wb.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"coe.info.settings.wb.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=coe.info.settings.wb.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=flex1></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.wb.bg, opacity:coe.info.settings.wb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" name=wbBgColor ng-value=\"coe.info.settings.wb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.wb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.bg selected-type=coe.info.ctype.wb.bg is-alpha=true selected-alpha=coe.info.settings.wb.bga ng-if=colorPicker.wb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ws><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.wb.ssbg, opacity:coe.info.settings.wb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" name=wbSsbgColor ng-value=\"coe.info.settings.wb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ws=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.wb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.ssbg selected-type=coe.info.ctype.wb.ssbg is-alpha=true selected-alpha=coe.info.settings.wb.ssbga ng-if=colorPicker.ws></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoWBOpt ng-model=coe.info.settings.wb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoWBOpt ng-model=coe.info.settings.wb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=coe.info.settings.wb.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=coe.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label for=wbTitle>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=wbTitle class=\"form-control input-sm\" ng-model=coe.info.settings.wb.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=coe.info.settings.wb.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbTime>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=wbTime class=\"form-control input-sm\" ng-model=coe.info.settings.wb.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=coe.info.settings.wb.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbRoom>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=wbRoom class=\"form-control input-sm\" ng-model=coe.info.settings.wb.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=coe.info.settings.wb.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=coe.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.whb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.wb.headerBg, opacity:coe.info.settings.wb.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" name=wbHBgColor ng-value=\"coe.info.settings.wb.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.whb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.wb.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.headerBg selected-type=coe.info.ctype.wb.headerBg is-alpha=true selected-alpha=coe.info.settings.wb.headerBga ng-if=colorPicker.whb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.headerText}\"></span></span> <input type=text class=\"form-control picker\" name=wbHTextColor ng-value=\"coe.info.settings.wb.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.headerText selected-type=coe.info.ctype.wb.headerText ng-if=colorPicker.wht></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control ng-model=coe.info.settings.wb.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=wbHSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wbHSize class=form-control ng-model=coe.info.settings.wb.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.titleText}\"></span></span> <input type=text class=\"form-control picker\" name=wbTitleTextColor ng-value=\"coe.info.settings.wb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.titleText selected-type=coe.info.ctype.wb.titleText ng-if=colorPicker.wt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" name=wbAltTitlwText ng-value=\"coe.info.settings.wb.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wat=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.altTitleText selected-type=coe.info.ctype.wb.altTitleText ng-if=colorPicker.wat></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=coe.info.settings.wb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=wbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wbTitleSize class=form-control ng-model=coe.info.settings.wb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=coe.info.settings.wb.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox role=checkbox ng-model=coe.info.settings.wb.isTime><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=coe.info.settings.wb.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.timeText}\"></span></span> <input type=text class=\"form-control picker\" name=wbTimeText ng-value=\"coe.info.settings.wb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.timeText selected-type=coe.info.ctype.wb.timeText ng-if=colorPicker.wtm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.watm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" name=wbAltTimeText ng-value=\"coe.info.settings.wb.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.watm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.altTimeText selected-type=coe.info.ctype.wb.altTimeText ng-if=colorPicker.watm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.17\' | translate}}</label><select class=form-control ng-model=coe.info.settings.wb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=coe.info.settings.wb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=coe.info.settings.wb.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox role=checkbox ng-model=coe.info.settings.wb.isRoom><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=coe.info.settings.wb.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wr><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.roomText}\"></span></span> <input type=text class=\"form-control picker\" name=wbRoomText ng-value=\"coe.info.settings.wb.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wr=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.roomText selected-type=coe.info.ctype.wb.roomText ng-if=colorPicker.wr></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.war><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coe.info.settings.wb.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" name=wbAltRoomText ng-value=\"coe.info.settings.wb.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.war=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.altRoomText selected-type=coe.info.ctype.wb.altRoomText ng-if=colorPicker.war></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.28\' | translate}}</label><select class=form-control name=wbRoomFont ng-model=coe.info.settings.wb.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=wbRoomSize class=form-control ng-model=coe.info.settings.wb.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=coe.info.settings.wb.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.wb.rowBg, opacity:coe.info.settings.wb.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" name=wbRowBg ng-value=\"coe.info.settings.wb.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.wb.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.rowBg selected-type=coe.info.ctype.wb.rowBg is-alpha=true selected-alpha=coe.info.settings.wb.rowBga ng-if=colorPicker.wrb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.warb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coe.info.settings.wb.altBg, opacity:coe.info.settings.wb.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" name=wbRowAltBg ng-value=\"coe.info.settings.wb.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.warb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coe.info.settings.wb.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coe.info.settings.wb.altBg selected-type=coe.info.ctype.wb.altBg is-alpha=true selected-alpha=coe.info.settings.wb.altBga ng-if=colorPicker.warb></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=coe.info.settings.wb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=coe.info.settings.wb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"coe.info.settings.wb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosP class=form-control ng-model=coe.info.settings.wb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=coe.info.settings.wb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=coe.info.settings.wb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"coe.info.settings.wb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosA class=form-control ng-model=coe.info.settings.wb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=coe.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=coe.info.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editMForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-8><div class=row><div class=col-xs-12><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=addEvent.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div></div><div ng-class=\"addEvent.roomOpt == \'c\'?\'col-xs-8\':\'col-xs-12\'\"><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=roomOpt ng-model=addEvent.roomOpt value=d><label></label>{{\'cl.widget.oc.10\' | translate}}</label><label class=noMarB><input type=radio role=radio name=roomOpt ng-model=addEvent.roomOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><!-- TODO Added new btn --><div class=marT5 ng-if=\"addEvent.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT10\">{{addEvent.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-sm marT4 marL5\" ng-click=\"roomListView(addEvent.mId ? \'u\' : \'n\', addEvent.mId);\">{{\'cl.widget.tRoom.4\' | translate}}</button></div><div class=marT5 ng-if=\"addEvent.roomOpt == \'c\'\"><input type=text id=roomLabel class=form-control ng-model=addEvent.roomLabel maxlength={{inputLimit}} focus-me=true aria-label=\"Room Label\" aria-labelledby=\"Room Label\"></div></div></div><div class=col-xs-4 ng-if=\"addEvent.roomOpt == \'c\'\"><div class=form-group><label>{{\'cl.widget.meeting.8\' | translate}}</label><input type=text class=form-control ng-model=addEvent.roomFloor aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker\" ng-model=addEvent.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=start class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addEvent.startTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addEvent.startTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=end class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addEvent.endTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addEvent.endTime hour-step=1 minute-step=5></div></div></span></div></div></div></div><div class=col-xs-4 ng-if=\"(coe.info.settings.rb.logoOpt || coe.info.settings.wb.logoOpt)\"><div class=form-group><label>{{\'cl.widget.meeting.9\' | translate}} <span class=\"text-muted text-sm\">(80x80)</span></label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addEvent.isHidden && (addEvent.logo.thumb || addEvent.logo.type == \'SharePointC\' || addEvent.logo.type == \'OneDriveC\' || addEvent.logo.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'l\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-href=\"{{cDetailBucket + addEvent.logo.thumb | secureThumb}}\" role=button ng-if=addEvent.logo.thumb data-access={{addEvent.logo.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addEvent.logo.path + (addEvent.logo.path.length > 1 ? \' / \' : \' \') + addEvent.logo.label)}}\" ng-show=addEvent.logo.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addEvent.logo.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addEvent.logo.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addEvent.logo.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addEvent.logo.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate | camelCase}}</button></div></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editMForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addEventFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addEventFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'m\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editMForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addEventFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editMForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'room\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\"><a href=\"\" role=link ng-class=\"{\'selected\':subTab==1}\" ng-click=\"subTabFx(1); searchText=\'\'\">{{\'em.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTab==2}\" ng-click=\"subTabFx(2); searchText=\'\'\">{{\'em.body.2\' | translate}}</a><div class=\"pull-right panel-tools noBdr marL5\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'title\' && eventListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'asc\', eventList, eventListInfo, \'widgetcoesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'title\' && eventListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'desc\', eventList, eventListInfo, \'widgetcoesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cl.widget.meeting.26\' | translate}}</li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'startdate\' && eventListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'asc\', eventList, eventListInfo, \'widgetcoesort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'startdate\' && eventListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'desc\', eventList, eventListInfo, \'widgetcoesort\');\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-scroll\" ng-if=\"eventList.length > 0\"><div class=\"row th\" ng-if=\"filtereEventList.length > 0\"><div class=col-xs-4>{{\'cm.label.23\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.12\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.13\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><!-- Normal --><div class=row ng-repeat=\"m in filtereEventList = (eventList | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=col-xs-4><div class=user-tumb ng-if=\"(coe.info.settings.rb.logoOpt || coe.info.settings.wb.logoOpt)\"><a ng-href=\"{{cDetailBucket + m.logo.thumb | secureThumb}}\" role=button data-access={{m.logo.isAccessible}} fancyboxable=fbTitleWithHome data-fancybox-title=\"{{m.logo.path + (m.logo.path.length > 1 ? \' / \' : \' \') + m.logo.label}}\" ng-if=\"m.logo.thumb && m.logo.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"m.logo.type != \'SharePointC\' && m.logo.type != \'OneDriveC\' && m.logo.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"m.logo.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"m.logo.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"m.logo.type == \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Flash\'\" class=img-responsive> </a><img alt=\"\" src=assets/images/default/na.png class=img-responsive ng-if=\"!m.logo.thumb && !m.logo.label && !m.logo.isAccessible\"><div class=\"pull-left relative\" ng-if=\"m.logo.thumb && !m.logo.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{m.title}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.title}}</div></div><!-- TODO Added some changes --><div class=col-xs-2 ng-if=\"m.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT8\">{{m.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-xs marT6 marL5\" ng-click=\"roomListView(\'v\', m.mId);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-ellipsis hide\" ng-if=\"m.roomOpt == \'d\'\" uib-tooltip-template=\"\'list.html\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=!$last>,</span></span></div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"m.roomOpt == \'c\'\" uib-tooltip={{m.roomLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.roomLabel}}</div><div class=col-xs-3>{{m.date.startDate | date:\'mediumDate\'}} - {{m.date.endDate | date:\'mediumDate\'}}</div><div class=col-xs-1>{{m.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-1>{{m.endTime | date:\'hh:mm a\'}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"saveCoeFx(5, m.title);\" uib-tooltip=\"{{\'cl.widget.coe.4\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 tooltip-placement=left ng-if=m.isAdvertise><span class=\"fa fa-external-link noMarR\" aria-hidden=true></span></a> <a href=\"\" role=link class=marR5 ng-class=\"!m.visible.rb && !m.visible.wb && !m.visible.cl?\'text-danger\':\'text-primary\'\" ng-click=setVisibility(m); uib-tooltip=\"{{\'cl.widget.coe.7\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 tooltip-placement=left><span class=fa ng-class=\"m.visible.rb && m.visible.wb && m.visible.cl?\'fa-eye\':\'fa-eye-slash\'\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'m\', m);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'m\', m.mId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div><script type=text/ng-template id=list.html><div class=\"text-left\">\r\n                        <span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=\"!$last\">, </span></span>\r\n                      </div></script></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filtereEventList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"eventList.length == 0\">{{subTab==1?\'cl.widget.coe.m1\':\'cl.widget.coe.m1.1\' | translate}}</div></div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=screenName>{{\'cm.brief.1\' | translate}}</label><input type=text id=screenName class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=col-xs-2><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span><!-- TODO added parameters in the btn --> <button type=button role=button id=deviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=sDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=sDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}}<!-- TODO Added parameters btn --> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div><div ng-if=\"selectedT==\'4\'\" class=marL10><div class=\"bg-light pad10 marB15\" ng-show=editRForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=room>{{\'cl.widget.oc.10\' | translate}}</label><!-- TODO change the key name --> <input type=text class=form-control id=room ng-model=roomCU.l focus-me=true ng-if=\"roomCU.type == \'r\'\" aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <input type=text class=form-control id=room ng-model=roomCU.l ng-if=\"roomCU.type != \'r\'\" readonly aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=floor>{{\'cl.widget.meeting.8\' | translate}}</label><!-- TODO change the key name --> <input type=text id=floor class=form-control ng-model=roomCU.fl aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=dType>{{\'cl.widget.cm.9\' | translate}}</label><!-- TODO change the key name --><select id=dType class=form-control ng-model=roomCU.dt aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editRForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"roomCUFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'r\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editRForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'e\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=\"btn-link btn-sm\" ng-click=\"editRForm.isShow = false\" ng-disabled=\"addProcessing || addMoreProcessing\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'room\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><!-- TODO added scroll feature changes and added new tabs --><div class=\"form-group marT20\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchText sanitize-input ng-change=\"searchChangeDataDyn(searchText, \'rl\');\" ng-disabled=\"!allScrollDataList.rl.length && !curRoomList.length\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText = \'\';searchChangeDataDyn(searchText, \'rl\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':subTabRL==1}\" ng-click=\"subTabRLFx(1); searchText=\'\'\" ng-disabled=reponseLoad>{{\'cm.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTabRL==2}\" ng-click=\"subTabRLFx(2); searchText=\'\'\" ng-disabled=reponseLoad>{{\'cl.widget.meeting.17\' | translate}}</a></div><img class=\"marT10 marL10\" alt=Loading src=assets/images/loading.gif ng-if=roomListLoading><div class=\"table table-scroll marT5 marB15\" ng-if=!roomListLoading><div class=\"row th\"><div class=col-xs-5>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-4>{{\'cl.widget.meeting.8\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.cm.9\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><!-- ng-attr-style=\"max-height:{{getAvailableHeight(465)}}px\" --><div class=scrollQuad ng-attr-style=\"{{ editRForm.isShow ? \'height:\' + (winH-250) + \'px\' : \'height:\' + (winH-110) + \'px\' }}\" id=scroll-container-rl dynamic-scroll-list st=stIndex.rl et=etIndex.rl list-data=scrollDataList.rl search-data=searchText have-more-data=haveMoreData.rl search-scroll=searchScroll.rl clone-data=allScrollDataList.rl have-more-search-data=haveMoreSearchData.rl quad-id=\"\'rl\'\" dd-open=true ng-if=\"subTabRL == 1\"><div class=\"row rowObj-rl\" id={{room.id}} ng-repeat=\"room in filteredDeviceList = (visibleData.rl)\" ng-if=!loadingPaging.rl><div ng-class=\"room.show? \'col-xs-4\' : \'col-xs-5\'\"><span ng-if=!room.show><div class=\"marR5 deviceStatus {{room.status}}\" uib-tooltip=\"{{room.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{room.l}}</span> <input type=text class=form-control ng-model=room.l ng-if=room.show readonly aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div><div class=col-xs-4><span ng-if=!room.show>{{room.fl}}</span> <input type=text class=form-control ng-model=room.fl ng-if=room.show aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div><div class=col-xs-2><span ng-if=!room.show><span ng-if=\"room.dt == \'rb\'\">{{\'cl.widget.oc.4\' | translate}}</span> <span ng-if=\"room.dt == \'wb\'\">{{\'cl.widget.oc.5\' | translate}}</span></span><select class=form-control ng-model=room.dt ng-if=room.show aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select></div><div class=text-right ng-class=\"room.show? \'col-xs-2 noPad\' : \'col-xs-1\'\"><a href=\"\" role=link class=\"text-primary marR5\" ng-if=!room.show ng-click=\"room.show = !room.show; roomUCFx(\'e\', room)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-danger marR5\" ng-click=\"deleteOpen(\'r\', room.id);\" ng-if=\"room.type == \'r\'\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn btn-success\" ng-show=room.show ng-click=\"roomUCFx(\'u\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-link\" ng-show=room.show ng-click=\"roomUCFx(\'c\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && !loadingMore.rl\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && loadingMore.rl\"> <img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.rl><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.rl.length > 0 && filteredDeviceList.length == 0 && !loadingPaging.rl\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!allScrollDataList.rl.length>{{\'d.msg.1\' | translate}}</div></div><div class=scrollQuad ng-attr-style=\"{{ editRForm.isShow ? \'height:\' + (winH-250) + \'px\' : \'height:\' + (winH-110) + \'px\' }}\" ng-if=\"subTabRL == 2\"><div class=row ng-repeat=\"room in filteredRoomList = (curRoomList | customSearch:{key:searchText, module:\'mRoom\'}) | orderBy:room\"><div ng-class=\"room.show? \'col-xs-4\' : \'col-xs-5\'\"><span ng-if=!room.show><!-- <div class=\"marR5 deviceStatus {{room.status}}\" uib-tooltip=\"{{room.status | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div> --> {{room.l}}</span> <input type=text class=form-control ng-model=room.l ng-if=room.show readonly aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div><div class=col-xs-4><span ng-if=!room.show>{{room.fl}}</span> <input type=text class=form-control ng-model=room.fl ng-if=room.show aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div><div class=col-xs-2><span ng-if=!room.show><span ng-if=\"room.dt == \'rb\'\">{{\'cl.widget.oc.4\' | translate}}</span> <span ng-if=\"room.dt == \'wb\'\">{{\'cl.widget.oc.5\' | translate}}</span></span><select class=form-control ng-model=room.dt ng-if=room.show aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select></div><div class=text-right ng-class=\"room.show? \'col-xs-2 noPad\' : \'col-xs-1\'\"><a href=\"\" role=link class=\"text-primary marR5\" ng-if=!room.show ng-click=\"room.show = !room.show; roomUCFx(\'e\', room)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-danger marR5\" ng-click=\"deleteOpen(\'r\', room.id);\" ng-if=\"room.type == \'r\'\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn btn-success\" ng-show=room.show ng-click=\"roomUCFx(\'u\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-link\" ng-show=room.show ng-click=\"roomUCFx(\'c\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"curRoomList.length > 0 && filteredRoomList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!curRoomList.length>{{\'d.msg.1\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\" ng-disabled=reponseLoad><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=coeFx(1); ng-disabled=\"nextProcessing || detailLoading\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.coe.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=coeFx(2); ng-disabled=\"nextProcessing || detailLoading\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'3\'\" ng-click=coeFx(3); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"coeFx(0, \'save\');\" ng-if=\"encId || selectedT==\'4\'\" ng-disabled=\"nextProcessing || saveProcessing || detailLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div><div ng-if=\"errType==\'rbSubTSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/coev.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.coev.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.coev.2\' | translate}} &nbsp; <span ng-if=coev.info.label>[ {{coev.info.label}} ]</span></h1><div class=\"pull-right marT-5\"><div class=\"btn-group marL5\" uib-dropdown><button type=button role=button class=\"btn btn-sm btn-default\" ng-click=meetingPrint(coev.info.type); ng-disabled=detailLoading><span class=\"fa fa-print\" aria-hidden=true></span>Print</button></div></div></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=meetingFx(1); ng-disabled=detailLoading><span class=badge>2</span>{{\'cl.widget.coe.3\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=meetingFx(2); ng-disabled=detailLoading><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-10><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=coev.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div class=clearfix></div><span class=\"bg-default pad2\"><span ng-if=\"coev.info.type == \'d\'\">{{\"cl.widget.sc.3\" | translate}}</span> <span ng-if=\"coev.info.type == \'w\'\">{{\"cl.widget.sc.4\" | translate}}</span> <span ng-if=\"coev.info.type == \'m\'\">{{\"cl.widget.sc.5\" | translate}}</span></span></div></div><div class=col-xs-6><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"coev.info.type == \'d\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.headerBg, opacity:coev.info.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.headerBg selected-type=coev.info.ctype.hBg is-alpha=true selected-alpha=coev.info.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.headerText selected-type=coev.info.ctype.hText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.rowBg, opacity:coev.info.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.rowBg selected-type=coev.info.ctype.rowBg is-alpha=true selected-alpha=coev.info.settings.rowBga ng-if=colorPicker.cb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.oc.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.et><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.eventText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.eventText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.et=true\" readonly aria-label=\"{{\'cl.widget.oc.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.eventText selected-type=coev.info.ctype.eText ng-if=colorPicker.et></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.roomText selected-type=coev.info.ctype.rText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.oc.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.timeBg, opacity:coev.info.settings.timeBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.timeBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tb=true\" readonly aria-label=\"{{\'cl.widget.oc.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.30\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.timeBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.timeBg selected-type=coev.info.ctype.tBg is-alpha=true selected-alpha=coev.info.settings.timeBga ng-if=colorPicker.tb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.timeText selected-type=coev.info.ctype.tText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"coev.info.type != \'d\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.headerBg, opacity:coev.info.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.headerBg selected-type=coev.info.ctype.hBg is-alpha=true selected-alpha=coev.info.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.headerText selected-type=coev.info.ctype.hText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.coev.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.db><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.dayNameBg, opacity:coev.info.settings.dayNameBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.dayNameBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.db=true\" readonly aria-label=\"{{\'cl.widget.coev.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.coev.3\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.dayNameBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.dayNameBg selected-type=coev.info.ctype.dnBg is-alpha=true selected-alpha=coev.info.settings.dayNameBga ng-if=colorPicker.db></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.coev.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.dayNameText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.dayNameText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.coev.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.coev.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.dayNameText selected-type=coev.info.ctype.dnText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.coev.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':coev.info.settings.cellBg, opacity:coev.info.settings.cellBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.cellBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cb=true\" readonly aria-label=\"{{\'cl.widget.coev.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.coev.5\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{coev.info.settings.cellBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.cellBg selected-type=coev.info.ctype.cBg is-alpha=true selected-alpha=coev.info.settings.cellBga ng-if=colorPicker.cb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.oc.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.et><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.eventText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.eventText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.et=true\" readonly aria-label=\"{{\'cl.widget.oc.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.eventText selected-type=coev.info.ctype.eText ng-if=colorPicker.et></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.roomText selected-type=coev.info.ctype.rText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':coev.info.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"coev.info.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=coev.info.settings.timeText selected-type=coev.info.ctype.tText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=coev.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=coev.info.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\"><a href=\"\" role=link ng-class=\"{\'selected\':subTab==1}\" ng-click=\"subTabFx(1); searchText=\'\'\">{{\'em.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTab==2}\" ng-click=\"subTabFx(2); searchText=\'\'\">{{\'em.body.2\' | translate}}</a><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-scroll\" ng-if=\"meetingList.length > 0\"><div class=\"row th\" ng-if=\"filteredMeetingList.length > 0\"><div class=col-xs-4>{{\'cm.label.23\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.12\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.13\' | translate | camelCase}}</div></div><div class=overflow-auto><div class=row ng-repeat=\"m in filteredMeetingList = (meetingList | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=col-xs-4><div class=user-tumb><a ng-href=\"{{cDetailBucket + m.logo.thumb | secureThumb}}\" role=button data-access={{m.logo.isAccessible}} fancyboxable=fbTitleWithHome data-fancybox-title=\"{{m.logo.path + (m.logo.path.length > 1 ? \' / \' : \' \') + m.logo.label}}\" ng-if=\"m.logo.thumb && m.logo.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Flash\'\" class=img-responsive> </a><img alt=\"\" src=assets/images/default/na.png class=img-responsive ng-if=\"!m.logo.thumb && !m.logo.label && !m.logo.isAccessible\"><div class=\"pull-left relative\" ng-if=\"m.logo.thumb && !m.logo.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{m.title}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.title}}</div></div><!-- TODO Added some changes --><div class=col-xs-3 ng-if=\"m.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT8\">{{m.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-xs marT6 marL5\" ng-click=\"roomListView(\'v\', m.mId);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-3 text-ellipsis hide\" ng-if=\"m.roomOpt == \'d\'\" uib-tooltip-template=\"\'list.html\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=!$last>,</span></span></div><div class=\"col-xs-3 text-ellipsis\" ng-if=\"m.roomOpt == \'c\'\" uib-tooltip={{m.roomLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000><span>{{m.roomLabel}}</span></div><div class=\"col-xs-3 text-sm\">{{m.date.startDate | date:\'mediumDate\'}} - {{m.date.endDate | date:\'mediumDate\'}}</div><div class=col-xs-1>{{m.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-1>{{m.endTime | date:\'hh:mm a\'}}</div><script type=text/ng-template id=list.html><div class=\"text-left\">\r\n                        <span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=\"!$last\">, </span></span>\r\n                      </div></script></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredMeetingList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"meetingList.length == 0\">{{subTab==1?\'cl.widget.coe.m1\':\'cl.widget.coe.m1.1\' | translate}}</div></div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-8>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-4>{{\'cm.label.49\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\"><li class=row ng-repeat=\"ss in ssList | reverse\"><div class=col-xs-8><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.isAccessible\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-4>{{ss.ss.duration}}</div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=meetingFx(1); ng-disabled=\"nextProcessing || detailLoading\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.coe.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=meetingFx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"meetingFx(0, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing || detailLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/comEvent.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.aNet.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.aNet.2\' | translate}} &nbsp; <span ng-if=aNet.label>[ {{aNet.label}}]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-n tab-e tab-ss\" aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-n role=tab aria-selected=true><a href=\"\" role=link ng-click=\"tabFx(1);editEForm.isShow=false;\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-if=isEditable ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-e role=tab aria-selected=false><a href=\"\" role=link ng-click=aNetFx(1); ng-disabled=detailLoading><span class=badge>2</span>{{\'cl.widget.coe.3\' | translate}}</a></li><li ng-if=!auth.upermissions.cfo ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-ss role=tab aria-selected=false><a href=\"\" role=link ng-click=aNetFx(2); ng-disabled=detailLoading><span class=badge>{{isEditable?\'3\':\'2\'}}</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'e\'); editEForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"aNet.com.cv && selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.coe.5\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div><div class=pull-right ng-show=\"selectedT==\'2\'\"></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=name>{{\'cl.label.1\' | translate}}</label><input type=text id=name class=form-control ng-model=aNet.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" ng-disabled=auth.upermissions.cfo aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=\"row hide\"><div class=col-xs-6><div class=form-group><label>{{\'aNet.label.13\' | translate}}</label><select aria-label=complexList class=form-control ng-model=aNet.com ng-change=getFacilityFx(aNet.com.id) ng-options=\"option.label for option in complexList | orderBy:\'label\' track by option.label\"><option value=\"\" disabled>{{\'an.label.13.1\' | translate}}</option></select></div></div><div class=col-xs-6><div class=form-group><label>{{\'aNet.label.14\' | translate}}</label><select aria-label=facilityList class=form-control ng-model=aNet.fac ng-options=\"option.label for option in facilityList | orderBy:\'label\' track by option.label\"><option value=\"\" disabled>{{\'aNet.label.14.1\' | translate}}</option></select></div></div></div><!-- display Type --><div class=\"form-group hide\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=aNet.dType value=r ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'an.label.4\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=aNet.dType value=d><label></label>{{\'an.label.5\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=aNet.dType value=c><label></label>{{\'an.label.6\' | translate}}</label></div></div><!-- template --><div class=\"form-group hide\"><div class=\"marR20 marB20\" ng-if=\"aNet.dType == \'r\'\"><label class=noMarB><img ng-src=assets/images/widget/comEvents/rs.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"aNet.dType == \'d\'\"><label class=noMarB><img ng-src=assets/images/widget/comEvents/ds.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"aNet.dType == \'c\'\"><label class=noMarB><img ng-src=assets/images/widget/comEvents/ccs.png alt=\"Template 3\"></label></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><fieldset ng-disabled=auth.upermissions.cfo class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-4><div><div><label>{{\'cl.widget.meeting.28\' | translate}}</label></div><label class=marR10><input type=radio name=rbSsosOpt ng-model=aNet.settings.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio name=rbSsosOpt ng-model=aNet.settings.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"aNet.settings.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=aNet.settings.sos.prior min=1> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><div><div><label>{{\'cl.widget.meeting.29\' | translate}}</label></div><label class=marR10><input type=radio name=rbEsosOpt ng-model=aNet.settings.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio name=rbEsosOpt ng-model=aNet.settings.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"aNet.settings.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=aNet.settings.sos.after min=1> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Rink Schedule --><div class=\"panel-inner-tab marB10 marT15\">{{\'cl.widget.aNet.3\' | translate}}</div><div class=row><div class=\"col-xs-12 form-group\"><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=aNet.settings.rs.rotationOpt name=rotationOptRS value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB for=cRotate><input type=radio role=radio ng-model=aNet.settings.rs.rotationOpt name=rotationOptRS value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"aNet.settings.rs.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=aNet.settings.rs.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.rs.bg, opacity:aNet.settings.rs.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.rs.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.rs.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.bg selected-type=aNet.ctype.rs.bg is-alpha=true selected-alpha=aNet.settings.rs.bga ng-if=colorPicker.rsb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rssbg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.rs.ssbg, opacity:aNet.settings.rs.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.rs.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rssbg=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.rs.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.ssbg selected-type=aNet.ctype.rs.ssbg is-alpha=true selected-alpha=aNet.settings.rs.ssbga ng-if=colorPicker.rssbg></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=headCol1RS>{{\'cl.widget.aNet.6\' | translate}}</label><input type=text id=headCol1RS class=form-control ng-model=aNet.settings.rs.column1 aria-label=\"{{\'cl.widget.aNet.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.6\' | translate}}\"></div><div class=col-xs-3><label for=headCol2RS>{{\'cl.widget.aNet.7\' | translate}}</label><input type=text id=headCol2RS class=form-control ng-model=aNet.settings.rs.column2 aria-label=\"{{\'cl.widget.aNet.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.7\' | translate}}\"></div><div class=col-xs-3><label for=headCol3RS>{{\'cl.widget.aNet.8\' | translate}}</label><input type=text id=headCol3RS class=form-control ng-model=aNet.settings.rs.column3 aria-label=\"{{\'cl.widget.aNet.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.8\' | translate}}\"></div><div class=col-xs-3><label for=headCol4RS>{{\'cl.widget.aNet.9\' | translate}}</label><input type=text id=headCol4RS class=form-control ng-model=aNet.settings.rs.column4 aria-label=\"{{\'cl.widget.aNet.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.9\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=headCol5RS>{{\'cl.widget.aNet.10\' | translate}}</label><input type=text id=headCol5RS class=form-control ng-model=aNet.settings.rs.column5 aria-label=\"{{\'cl.widget.aNet.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.10\' | translate}}\"></div><div class=col-xs-3><label for=headCol6RS>{{\'cl.widget.aNet.11\' | translate}}</label><input type=text id=headCol6RS class=form-control ng-model=aNet.settings.rs.column6 aria-label=\"{{\'cl.widget.aNet.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.11\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rshb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.rs.hb, opacity:aNet.settings.rs.hba}\"></span></span></span> <input type=text id=rsHeaderBg class=\"form-control picker\" ng-value=\"aNet.settings.rs.hb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rshb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.rs.hba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.hb selected-type=aNet.ctype.rs.hb is-alpha=true selected-alpha=aNet.settings.rs.hba selected-rgba=rgbaS1.hb ng-if=colorPicker.rshb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.rs.ht}\"></span></span> <input type=text id=rsHeaderText class=\"form-control picker\" ng-value=\"aNet.settings.rs.ht | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.ht selected-type=aNet.ctype.rs.ht ng-if=colorPicker.rsht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rsHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=rsHeaderFont class=form-control ng-model=aNet.settings.rs.hf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=rsHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=rsHeaderSize class=form-control ng-model=aNet.settings.rs.hs min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.38\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsrt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.rs.rt}\"></span></span> <input type=text id=rsRowText class=\"form-control picker\" ng-value=\"aNet.settings.rs.rt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsrt=true\" readonly aria-label=\"{{\'cl.widget.cm.38\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.38\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.rt selected-type=aNet.ctype.rs.rt ng-if=colorPicker.rsrt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.40\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsart><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.rs.art}\"></span></span> <input type=text id=rsAltRowText class=\"form-control picker\" ng-value=\"aNet.settings.rs.art | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsart=true\" readonly aria-label=\"{{\'cl.widget.cm.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.40\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.art selected-type=aNet.ctype.rs.art ng-if=colorPicker.rsart></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rsRowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=rsRowFont class=form-control ng-model=aNet.settings.rs.rf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.39\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.39\' | translate}}\"></select></div><div class=col-xs-3><label for=rsAltRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=rsAltRowFont class=form-control ng-model=aNet.settings.rs.arf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=rsRowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rsRowSize class=form-control ng-model=aNet.settings.rs.rs min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div><div class=col-xs-3><label for=rsAltRowSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=rsAltRowSize class=form-control ng-model=aNet.settings.rs.ars min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.rs.rb, opacity:aNet.settings.rs.rba}\"></span></span></span> <input type=text id=rsRowBg class=\"form-control picker\" ng-value=\"aNet.settings.rs.rb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.rs.rba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.rb selected-type=aNet.ctype.rs.rb is-alpha=true selected-alpha=aNet.settings.rs.rba ng-if=colorPicker.rsrb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsarb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.rs.ab, opacity:aNet.settings.rs.aba}\"></span></span></span> <input type=text id=rsAltRowBg class=\"form-control picker\" ng-value=\"aNet.settings.rs.ab | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsarb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.rs.aba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.rs.ab selected-type=aNet.ctype.rs.ab is-alpha=true selected-alpha=aNet.settings.rs.aba selected-rgba=rgbaS1.ab ng-if=colorPicker.rsarb></ng-hub-color-picker></div></div></div></div><!-- Day Schedule --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.aNet.4\' | translate}}</div><div class=row><div class=\"col-xs-3 form-group\"><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=aNet.settings.ds.rotationOpt name=rotationOptDS value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB for=cRotate><input type=radio role=radio ng-model=aNet.settings.ds.rotationOpt name=rotationOptDS value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"aNet.settings.ds.rotationOpt == \'c\'\"><input type=number id=dsCRotate class=form-control ng-model=aNet.settings.ds.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.ds.bg, opacity:aNet.settings.ds.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.ds.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.bg selected-type=aNet.ctype.ds.bg is-alpha=true selected-alpha=aNet.settings.ds.bga ng-if=colorPicker.dsb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dssbg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.ds.ssbg, opacity:aNet.settings.ds.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dssbg=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.ds.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.ssbg selected-type=aNet.ctype.ds.ssbg is-alpha=true selected-alpha=aNet.settings.ds.ssbga ng-if=colorPicker.dssbg></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=dsHeader>{{\'cl.widget.aNet.12\' | translate}}</label><input type=text id=dsHeader class=form-control ng-model=aNet.settings.ds.header aria-label=\"{{\'cl.widget.aNet.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.12\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dshb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.ds.hb, opacity:aNet.settings.ds.hba}\"></span></span></span> <input aria-label=headerBg type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.hb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dshb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.ds.hba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.hb selected-type=aNet.ctype.ds.hb is-alpha=true selected-alpha=aNet.settings.ds.hba selected-rgba=rgbaS2.hb ng-if=colorPicker.dshb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.ds.ht}\"></span></span> <input aria-label=headerText type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.ht | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.ht selected-type=aNet.ctype.ds.ht ng-if=colorPicker.dsht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=dsHeader>{{\'cl.widget.cm.13\' | translate}}</label><select id=dsHeader class=form-control ng-model=aNet.settings.ds.hf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=dsHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=dsHeaderSize class=form-control ng-model=aNet.settings.ds.hs min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.38\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsrt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.ds.rt}\"></span></span> <input aria-label=rowText type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.rt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsrt=true\" readonly aria-label=\"{{\'cl.widget.cm.38\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.38\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.rt selected-type=aNet.ctype.ds.rt ng-if=colorPicker.dsrt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.40\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsart><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.ds.art}\"></span></span> <input aria-label=rowText type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.art | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsart=true\" readonly aria-label=\"{{\'cl.widget.cm.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.40\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.art selected-type=aNet.ctype.ds.art ng-if=colorPicker.dsart></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=dsRowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=dsRowFont class=form-control ng-model=aNet.settings.ds.rf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.39\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.39\' | translate}}\"></select></div><div class=col-xs-3><label for=dsAltRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=dsAltRowFont class=form-control ng-model=aNet.settings.ds.arf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=dsRowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=dsRowSize class=form-control ng-model=aNet.settings.ds.rs min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div><div class=col-xs-3><label for=dsAltRowSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=dsAltRowSize class=form-control ng-model=aNet.settings.ds.ars min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.ds.rb, opacity:aNet.settings.ds.rba}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.rb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.ds.rba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.rb selected-type=aNet.ctype.ds.rb is-alpha=true selected-alpha=aNet.settings.ds.rba ng-if=colorPicker.dsrb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dsarb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.ds.ab, opacity:aNet.settings.ds.aba}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.ds.ab | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dsarb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.ds.aba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.ds.ab selected-type=aNet.ctype.ds.ab is-alpha=true selected-alpha=aNet.settings.ds.aba selected-rgba=rgbaS2.ab ng-if=colorPicker.dsarb></ng-hub-color-picker></div></div></div></div><!-- Civic Committee Schedule --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.aNet.5\' | translate}}</div><div class=row><div class=\"col-xs-3 form-group\"><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=aNet.settings.cs.rotationOpt name=rotationOptCS value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB for=cRotate><input type=radio role=radio ng-model=aNet.settings.cs.rotationOpt name=rotationOptCS value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"aNet.settings.cs.rotationOpt == \'c\'\"><input type=number id=dsCRotate class=form-control ng-model=aNet.settings.cs.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.csb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.cs.bg, opacity:aNet.settings.cs.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.csb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.cs.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.bg selected-type=aNet.ctype.cs.bg is-alpha=true selected-alpha=aNet.settings.cs.bga selected-rgba=rgbaS3.bg ng-if=colorPicker.csb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cssbg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':aNet.settings.cs.ssbg, opacity:aNet.settings.cs.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cssbg=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{aNet.settings.cs.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.ssbg selected-type=aNet.ctype.cs.ssbg is-alpha=true selected-alpha=aNet.settings.cs.ssbga ng-if=colorPicker.cssbg></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=csHeadCol1>{{\'cl.widget.aNet.6\' | translate}}</label><input type=text id=csHeadCol1 class=form-control ng-model=aNet.settings.cs.column1 aria-label=\"{{\'cl.widget.aNet.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.6\' | translate}}\"></div><div class=col-xs-3><label for=csHeadCol2>{{\'cl.widget.aNet.7\' | translate}}</label><input type=text id=csHeadCol2 class=form-control ng-model=aNet.settings.cs.column2 aria-label=\"{{\'cl.widget.aNet.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.7\' | translate}}\"></div><div class=col-xs-3><label for=csHeadCol3>{{\'cl.widget.aNet.8\' | translate}}</label><input type=text id=csHeadCol3 class=form-control ng-model=aNet.settings.cs.column3 aria-label=\"{{\'cl.widget.aNet.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.8\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.csht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.cs.ht}\"></span></span> <input aria-label=headerText type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.ht | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.csht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.ht selected-type=aNet.ctype.cs.ht ng-if=colorPicker.csht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=csHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=csHeaderFont class=form-control ng-model=aNet.settings.cs.hf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=csHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=csHeaderSize class=form-control ng-model=aNet.settings.cs.hs min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=csTitle>{{\'cm.label.23\' | translate}}</label><input type=text id=csTitle class=form-control ng-model=aNet.settings.cs.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=col-xs-3><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.cs.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.titleText selected-type=aNet.ctype.cs.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=csTitleSize>{{\'cl.widget.count.9\' | translate}}</label><input type=number id=csTitleSize min=1 class=form-control ng-model=aNet.settings.cs.titleSize aria-label=\"{{\'cl.widget.count.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.9\' | translate}}\"></div><div class=col-xs-3><label for=csTitleFont>{{\'cl.widget.count.10\' | translate}}</label><select id=csTitleFont class=form-control ng-model=aNet.settings.cs.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.count.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.10\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.38\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.csrt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.cs.rt}\"></span></span> <input aria-label=rowText type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.rt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.csrt=true\" readonly aria-label=\"{{\'cl.widget.cm.38\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.38\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.rt selected-type=aNet.ctype.cs.rt ng-if=colorPicker.csrt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.40\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.csart><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':aNet.settings.cs.art}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"aNet.settings.cs.art | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.csart=true\" readonly aria-label=\"{{\'cl.widget.cm.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.40\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=aNet.settings.cs.art selected-type=aNet.ctype.cs.art ng-if=colorPicker.csart></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=csRowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=csRowFont class=form-control ng-model=aNet.settings.cs.rf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.39\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.39\' | translate}}\"></select></div><div class=col-xs-3><label for=csAltRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=csAltRowFont class=form-control ng-model=aNet.settings.cs.arf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=csRowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=csRowSize class=form-control ng-model=aNet.settings.cs.rs min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div><div class=col-xs-3><label for=csAltRowSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=csAltRowSize class=form-control ng-model=aNet.settings.cs.ars min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div></div></fieldset></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=aNet.permission pid=decId cfo=auth.upermissions.cfo module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=aNet.activePeriod cfo=auth.upermissions.cfo></ng-active-period></div></div></div><!-- Event List --><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editEForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><div class=form-group><label for=activityName>{{\'cl.widget.aNet.24\' | translate}}</label><input type=text id=activityName class=form-control ng-model=addEvent.ht aria-label=\"{{\'cl.widget.aNet.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.24\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker\" id=date ng-model=addEvent.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=sdr uib-dropdown-toggle ng-value=\"addEvent.startDateTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addEvent.startDateTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=edr uib-dropdown-toggle ng-value=\"addEvent.endDateTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addEvent.endDateTime hour-step=1 minute-step=5></div></div></span></div></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=homeTeam>{{\'cl.widget.aNet.16\' | translate}}</label><input type=text id=homeTeam class=form-control ng-model=addEvent.activityName aria-label=\"{{\'cl.widget.aNet.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.16\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=homeTeamRoom>{{\'cl.widget.aNet.17\' | translate}}</label><input type=text id=homeTeamRoom class=form-control ng-model=addEvent.htr aria-label=\"{{\'cl.widget.aNet.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.17\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=visitorTeam>{{\'cl.widget.aNet.18\' | translate}}</label><input type=text id=visitorTeam class=form-control ng-model=addEvent.vt aria-label=\"{{\'cl.widget.aNet.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.18\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=visitorTeamRoom>{{\'cl.widget.aNet.19\' | translate}}</label><input type=text id=visitorTeamRoom class=form-control ng-model=addEvent.vtr aria-label=\"{{\'cl.widget.aNet.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aNet.19\' | translate}}\"></div></div></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editEForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addEventFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addEventFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'e\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editEForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addEventFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editEForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'aName\'\" aria-live=polite role=status>{{\'cl.widget.aNet.m9\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-8><div class=row><div class=col-xs-6><div class=form-group><div class=\"pull-right hide\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"syncComFacFx(\'c\');\"><span class=\"noMarR fa\" ng-class=\"syncingCom ? \'fa-refresh fa-spin\':\'fa-refresh\'\" aria-hidden=true uib-tooltip=\"{{\'cl.widget.aNet.22\' | translate}}\" tooltip-append-to-body=true></span></a></div><label for=complexList>{{\'cl.widget.aNet.13\' | translate}}</label><div id=com class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchFocus(\'c\');\" aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=\"aNet && !isSelectCom\">{{\'cl.widget.aNet.13.1\' | translate}}</span> <span ng-if=\"aNet && isSelectCom\">{{aNet.com.clabel}}</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=\"margin-right:-7px;font-size: 16px;font-weight: 600\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=complexList.length><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"complexList.length > 5\"><div class=\"searchTbx input-xs findCSearch\"><input type=text class=form-control ng-model=searchCom.label sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchCom.label.length ng-click=\"searchCom.label=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=\"complexList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"c in complex = (complexList | filter:{\'clabel\': searchCom.label}) | orderBy: \'clabel\' track by c.clabel\" tabindex=$index><label ng-model=aNet.com ng-click=selComplex(c)>{{c.clabel}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"complex.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchCom.label)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div class=col-xs-6><div class=form-group><div class=\"pull-right hide\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"syncComFacFx(\'f\');\"><span class=\"noMarR fa\" ng-class=\"syncingFac ? \'fa-refresh fa-spin\':\'fa-refresh\'\" aria-hidden=true uib-tooltip=\"{{\'cl.widget.aNet.22\' | translate}}\" tooltip-append-to-body=true></span></a></div><label for=facilityList>{{\'cl.widget.aNet.14\' | translate}}</label><div id=fac class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchFocus(\'f\');\" aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=\"aNet && !isSelectFac\">{{\'cl.widget.aNet.14.1\' | translate}}</span> <span ng-if=\"aNet && isSelectFac\">{{aNet.fac.flabel}}</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=\"margin-right:-7px;font-size: 16px;font-weight: 600\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=facilityList.length><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"facilityList.length > 5\"><div class=\"searchTbx input-xs findFSearch\"><input type=text class=form-control ng-model=searchFac.label sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchFac.label.length ng-click=\"searchFac.label=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=\"facilityList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"f in facility = (facilityList | filter:{\'flabel\': searchFac.label}) | orderBy: \'flabel\' track by f.flabel\" tabindex=$index><label ng-model=aNet.fac ng-click=selFacility(f)>{{f.flabel}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"facility.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchFac.label)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\"><a href=\"\" role=link ng-class=\"{\'selected\':subTab==1}\" ng-click=\"subTabFx(1); searchText=\'\'\">{{\'em.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTab==2}\" ng-click=\"subTabFx(2); searchText=\'\'\">{{\'em.body.2\' | translate}}</a><div class=\"pull-right panel-tools noBdr marL5\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'title\' && eventListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'asc\', eventList, eventListInfo, \'widgetcomeventsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'title\' && eventListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'desc\', eventList, eventListInfo, \'widgetcomeventsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cl.widget.meeting.26\' | translate}}</li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'startdate\' && eventListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'asc\', eventList, eventListInfo, \'widgetcomeventsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': eventListInfo.sortType === \'startdate\' && eventListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'desc\', eventList, eventListInfo, \'widgetcomeventsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-scroll\" ng-if=\"eventList.length > 0\"><div class=\"row th\" ng-if=\"filtereEventList.length > 0\"><div class=col-xs-2>{{\'cl.widget.aNet.24\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.aNet.16\' | translate}}</div><div class=col-xs-1>{{\'cl.widget.aNet.17\' | translate}}</div><div class=col-xs-1>{{\'cl.widget.aNet.18\' | translate}}</div><div class=col-xs-1>{{\'cl.widget.aNet.19\' | translate}}</div><div class=col-xs-2>{{\'cm.label.10\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.11\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><ul role=list class=\"overflow-auto event-list\"><!-- Normal --><li class=row role=listitem ng-repeat=\"ev in filtereEventList = (eventList | customSearch:{key:searchText, module:\'comEvent\'})\" data-bookingid={{ev.bookingId}}><div class=col-xs-2><!-- <div class=\"text-ellipsis\" uib-tooltip=\"{{ev.label}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{ev.activityName}}</div> --><div class=text-ellipsis uib-tooltip={{ev.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ev.ht}}</div><div ng-if=!ev.ht class=\"text-muted text-sm\">N/A</div></div><div class=col-xs-2><!-- <div ng-if=\"ev.ht\" class=\"text-ellipsis\">{{ev.ht}}</div><div ng-if=\"!ev.ht\" class=\"text-muted text-sm\">N/A</div> --><div ng-if=ev.activityName class=text-ellipsis>{{ev.activityName}}</div><div ng-if=!ev.activityName class=\"text-muted text-sm\">N/A</div></div><div class=col-xs-1><div ng-if=ev.htr class=text-ellipsis>{{ev.htr}}</div><div ng-if=!ev.htr class=\"text-muted text-sm\">N/A</div></div><div class=col-xs-1><div ng-if=ev.vt class=text-ellipsis>{{ev.vt}}</div><div ng-if=!ev.vt class=\"text-muted text-sm\">N/A</div></div><div class=col-xs-1><div ng-if=ev.vtr class=text-ellipsis>{{ev.vtr}}</div><div ng-if=!ev.vtr class=\"text-muted text-sm\">N/A</div></div><div class=col-xs-2>{{(ev.startDateTime) | date:\"MMM d, y h:mm a\"}}</div><div class=col-xs-2>{{(ev.endDateTime) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link ng-if=\"ev.isUp && ev.isUp == 1\" class=\"text-primary marR5\" ng-click=\"syncOpen(ev.bookingId, \'s\');\"><span class=\"fa fa-refresh noMarR\" aria-hidden=true uib-tooltip=\"{{\'cl.widget.oc.9\' | translate}}\" tooltip-append-to-body=true></span></a> <a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'ev\', ev);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=marR5 ng-class=\"(ev.isHid && ev.isHid==1)?\'text-disabled\':\'text-primary\'\" ng-click=setVisibilityOpen(ev); uib-tooltip=\"{{(ev.isHid && ev.isHid==1) ? \'d.tool.19\':\'d.tool.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-eye\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-primary ng-class=\"{\'marR5\': ev.isCustom}\" ng-click=duplicateOpen(ev); uib-tooltip=\"{{\'cm.btn.30\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-copy\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=ev.isCustom class=text-danger ng-click=\"syncOpen(ev.bookingId, \'r\');\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"filtereEventList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"eventList.length == 0\">{{(aNet.fac == null || aNet.fac.length == 0) ?\'cl.widget.aNet.m4\':\'cl.widget.aNet.m5\' | translate}}</div> --><div class=msg-warning lang={{auth.lang}} ng-if=\"eventList.length == 0 && (aNet.fac == null || aNet.fac.length == 0)\">{{\'cl.widget.aNet.m4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"eventList.length == 0 && aNet.fac != null\">{{subTab == 1 ? \'cl.widget.aNet.m8\' : \'cl.widget.aNet.m5\' | translate}}</div></div></div></div></div></div><!-- Screen saver --><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=screenName>{{\'cm.brief.1\' | translate}}</label><input type=text id=screenName class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=col-xs-2><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=sDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=sDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div><!-- Civic Content --><div ng-if=\"selectedT==\'4\'\" class=marL10><div class=\"bg-light pad10 marB15\"><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-12>Civic Content</div></div></div><div class=clearfix></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\' || selectedT==\'4\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\' && isEditable\" ng-click=aNetFx(1); ng-disabled=\"nextProcessing || detailLoading\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.coe.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"(selectedT==\'2\' || (selectedT==\'1\' && !isEditable)) && !auth.upermissions.cfo\" ng-click=aNetFx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button><!-- <button type=\"button\" class=\"btn btn-primary\" ng-if=\"selectedT==\'3\'\" ng-click=\"aNetFx(3);\" ng-disabled=\"nextProcessing\"> {{\'cm.btn.12\' | translate}}: {{\'cl.widget.aNet.4\' | translate}}<span class=\"fa fa-chevron-right\"></span></button> --> <button type=button role=button class=\"btn btn-success\" ng-click=\"aNetFx(0, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing || detailLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'cName\'\" aria-live=polite role=status>{{\'an.msg.1\' | translate}}</div><div ng-if=\"errType==\'fName\'\" aria-live=polite role=status>{{\'an.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'rSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'arSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.18\' | translate}}</div><div ng-if=\"errType==\'headCol\'\" aria-live=polite role=status>{{\'cl.widget.aNet.m1\' | translate}}</div><div ng-if=\"errType==\'dsHeader\'\" aria-live=polite role=status>{{\'cl.widget.aNet.m2\' | translate}}</div><div ng-if=\"errType==\'csHeader\'\" aria-live=polite role=status>{{\'cl.widget.aNet.m3\' | translate}}</div><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'sosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'sosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/comPylonText.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.pylonText.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.pylonText.2\' | translate}} &nbsp; <span ng-if=pylonText.label>[ {{pylonText.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-8><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=pylonText.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><div class=row><div class=col-xs-3><!-- ng-class=\"textEdit.edit ? \'col-xs-6\' : \'col-xs-6\'\" --><label>{{\'cm.label.64\' | translate}}</label><input type=text id=addText class=form-control ng-model=addText.text maxlength=500 aria-label=\"{{\'cm.label.64\' | translate}}\" aria-labelledby=\"{{\'cm.label.64\' | translate}}\"></div><div class=col-xs-3><div class=form-group><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=amDate class=\"form-control picker\" ng-model=addText.dateRange format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div></div><div class=col-xs-2><div class=\"form-group timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=startTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"customTime.startTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=customTime.startTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-2><div class=\"form-group timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=endTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"customTime.endTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=customTime.endTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-2><label>&nbsp;</label><div ng-if=!textEdit.edit><button type=button role=button class=\"btn btn-primary w100\" ng-click=addTextFx(); ng-disabled=!addText.text><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div><div ng-if=textEdit.edit class=\"d-flex justify-spaceB\"><!-- <button type=\"button\" role=\"button\" class=\"btn btn-primary w100\" ng-click=\"addTextFx();\" ng-disabled=\"!addText.text\"><span class=\"fa fa-plus-circle\" aria-hidden=\"true\"></span>{{\'cm.btn.19\' | translate}}</button> --> <button type=button role=button class=\"btn btn-success w100\" ng-click=saveTextFx(addText); ng-disabled=tl.text>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default w100\" ng-click=\"cancelTextFx($event);textEdit.edit != textEdit.edit\">{{\'cm.btn.9\' | translate}}</button></div></div></div></div><div class=form-group><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\"><a href=\"\" role=link ng-class=\"{\'selected\':subTab==1}\" ng-click=\"subTabFx(1); searchText=\'\'\">{{\'em.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTab==2}\" ng-click=\"subTabFx(2); searchText=\'\'\">{{\'em.body.2\' | translate}}</a><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-md\" ng-if=subTabList.length><div class=\"row th\"><div class=col-xs-4>{{\'cl.widget.text.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate}}</div><div class=col-xs-2>{{\'cm.label.12\' | translate}}</div><div class=col-xs-2>{{\'cm.label.13\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=sortable-containment sortable callback=sortCallback()><!-- class=\"scrollQuad crawlingList\" --><div class=\"row sortable-item\" ng-repeat=\"tl in filteredPylonText = (subTabList | filter:searchText)\" data-id={{tl.id}} data-start=\"{{tl.dateRange.startDate | date:\'yyyy-MM-dd\'}}\" data-end=\"{{tl.dateRange.endDate | date:\'yyyy-MM-dd\'}}\" data-st={{tl.st}} data-et={{tl.et}}><div class=\"col-xs-4 codeQuad\"><div class=\"codeText text-ellipsis-wrap\" ng-show=!tl.show>{{tl.text}}</div></div><div class=col-xs-3><span ng-if=\"tl.dateRange.startDate != null\" class=startDate>{{ tl.dateRange.startDate | dateFormat}}<span ng-if=\"tl.dateRange.endDate != null\" class=endDate>&nbsp;&nbsp;-&nbsp;&nbsp;{{tl.dateRange.endDate | dateFormat}}</span></span> <span ng-if=\"tl.dateRange.startDate == null && tl.dateRange.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-2>{{tl.st | changeTimeFormat}}</div><div class=col-xs-2>{{tl.et | changeTimeFormat}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=editFx(tl) uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deleteTextOpen(tl.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning ng-if=\"filteredPylonText.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div class=msg-warning ng-if=\"subTabList.length == 0\">{{subTab==1?\'cl.widget.pylonText.m5\':\"cl.widget.pylonText.m6\" | translate}}</div></div></div></div></div><div class=\"form-group hide\" ng-if=\"pylonText.textList.length > 0\"><div class=\"table table-md\"><div class=\"row th\"><div class=col-xs-4>{{\'cl.widget.text.3\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate}}</div><div class=col-xs-2>{{\'cm.label.12\' | translate}}</div><div class=col-xs-2>{{\'cm.label.13\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=sortable-containment sortable callback=sortCallback()><!-- class=\"scrollQuad crawlingList\" --><div class=\"row sortable-item\" ng-repeat=\"tl in pylonText.textList\" data-id={{tl.id}} data-start=\"{{tl.dateRange.startDate | date:\'yyyy-MM-dd\'}}\" data-end=\"{{tl.dateRange.endDate | date:\'yyyy-MM-dd\'}}\" data-st={{tl.st}} data-et={{tl.et}}><div class=\"col-xs-4 codeQuad\"><div class=\"codeText text-ellipsis-wrap\" ng-show=!tl.show>{{tl.text}}</div></div><div class=col-xs-3><span ng-if=\"tl.dateRange.startDate != null\" class=startDate>{{ tl.dateRange.startDate | dateFormat}}<span ng-if=\"tl.dateRange.endDate != null\" class=endDate>&nbsp;&nbsp;-&nbsp;&nbsp;{{tl.dateRange.endDate | dateFormat}}</span></span> <span ng-if=\"tl.dateRange.startDate == null && tl.dateRange.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-2>{{tl.st | changeTimeFormat}}</div><div class=col-xs-2>{{tl.et | changeTimeFormat}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=editFx(tl) uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deleteTextOpen(tl.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=fontSize class=form-control ng-model=pylonText.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div><!-- <div class=\"col-xs-4\">\r\n                <label for=\"speed\">{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label>\r\n                <input type=\"number\" id=\"speed\" class=\"form-control\" ng-model=\"pylonText.settings.speed\" min=\"1\" aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\">\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label for=\"width\">{{\'cl.widget.pylonText.3\' | translate}}</label>\r\n                <input type=\"number\" id=\"width\" class=\"form-control\" ng-model=\"pylonText.settings.width\" min=\"1\" aria-label=\"{{\'cl.widget.pylonText.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pylonText.3\' | translate}}\">\r\n              </div> --><div class=col-xs-6><label for=noOfLines>{{\'cl.widget.pylonText.4\' | translate}}</label><input type=number id=noOfLines class=form-control ng-model=pylonText.settings.noOfLines min=1 aria-label=\"{{\'cl.widget.pylonText.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pylonText.4\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=pylonText.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=pylonText.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=pylonTextFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'crawl\'\">{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType == \'text\'\">{{\'cl.widget.qr.m2\' | translate}}</div><div ng-if=\"errType == \'width\'\">{{\'cl.widget.pylonText.m1\' | translate}}</div><div ng-if=\"errType == \'noOfLines\'\">{{\'cl.widget.pylonText.m2\' | translate}}</div><div ng-if=\"errType == \'fSize\'\">{{\'cl.widget.pylonText.m3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'startEnd\'\">{{\'cm.msg.16\' | translate}}</div><!-- <div ng-if=\"errType == \'invFSize\'\">{{\'cl.widget.pylonText.m4\' | translate}}</div> --></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/contentGroup.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link name=list class=sidebar-toggle aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.cg.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.cg.2\' | translate}} &nbsp; <span ng-if=contentGroup.label>[ {{contentGroup.label}} ]</span></h1><span ng-if=\"selectedT==\'2\' && cgSize.isShow\" class=\"pull-right marL5\"><span class=\"fa fa-info-circle\" uib-tooltip=\"{{\'cl.widget.cod.m6\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left aria-hidden=true></span> </span><span ng-if=\"selectedT==\'2\' && cgSize.size != null\" class=\"pull-right text-sm pad2 padLR5\" ng-class=\"{\'text-danger bg-blink\':(cgSize.size > allowedSize.size), \'text-bold\':!tabView}\"><span ng-if=\"cgSize.size <= allowedSize.size\">{{cgSize.size | filesize}}</span> <span ng-if=\"cgSize.size > allowedSize.size\">{{allowSize = (allowedSize.size | filesize); \"\"}} {{\'cl.widget.cod.16\' | translate:{size:allowSize} }}</span></span></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=contentGroupFx(1);><span class=badge>2</span>{{\'cm.label.32\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label ng-model=contentGroup.label class=form-control maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=contentGroup.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=contentGroup.activePeriod></ng-active-period></div></div></div><div class=col-xs-12 ng-if=\"selectedT==\'2\'\"><div class=row><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=\"advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)\" class=\"col-xs-12 noPad marB10\"></advanced-search>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown><a href=\"\" id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'w-cg\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div ng-class=\"{\'noMarB\':auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{quadHeight}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"!contentLibraryLoading && !advSearch && (folderList.length > 0 || contentList.length > 0)\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=contentLibrary.info.sp class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=contentLibrary.info.od class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=contentLibrary.info.gd class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'t\'\" element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'l\'\" element-height=quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{contentGroupCount = (contentGroup.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-model=selectedSearchText sanitize-input autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <span ng-if=contentGroup.content>[ {{contentGroupCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{selectedHeight}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && contentGroup.content.length > 0 || (contentGroup.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback() ng-if=\"auth.upreferences.contentView == \'t\'\"><li ng-repeat=\"cl in contentGroup.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=sortable-item ng-if=!cl.hidden><a href=\"\" role=link class=thumb-close ng-click=\"closeFilteredFx(cl.id, cl.wcgid, cl.tempId, $index)\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner ng-class=\"{\'overflow-hidden\':cl.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{cl.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000 tooltip-enable=cl.path><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && !cl.ss && cl.isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a ng-href=\"{{cDetailBucket + cl.ssImg | secureThumb:timestamp}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && cl.ss && cl.isCompleted\"><img alt=\"\" ng-src=\"{{tim + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbBigParam}}\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Images --> <a ng-if=\"cl.type == \'Image\'\" role=button ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}}><img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}}><img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Other --> <img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/sp.png ng-if=\"cl.type == \'SharePointC\'\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/od.png ng-if=\"cl.type == \'OneDriveC\'\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/gd.png ng-if=\"cl.type == \'GoogleDriveC\'\" class=img-responsive> <span class=thumb-icon><span class=cgDuration ng-if=\"cl.pSize != null\">{{cl.pSize | filesize}}</span> <span class=cgDuration ng-if=\"cl.pSize == null && cl.size != null\">{{(cl.size*1024) | filesize}}</span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"cl.type !== \'Folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{cl.label}}</div><div class=form-inline ng-hide=\"cl.extn == \'Music Choice\'\"><div class=\"form-group text-ellipsis text-left w100\"><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number id=duration-{{$index}} class=\"form-control input-sm duration\" ng-model=cl.duration min=1> <span class=\"text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</span></div><div class=\"fullScreen text-left\" ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\'\"><label class=noMarB><input type=checkbox ng-model=cl.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul><ul class=\"table table-md list-unstyled sortable-containment\" sortable callback=sortCallback() containment=\"\'parent\'\" ng-if=\"auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-5>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in contentGroup.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-if=!cl.hidden><div class=\"col-xs-5 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=assets/images/default/word-xs.png ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=assets/images/default/pdf-xs.png ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.pn{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}g\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=col-xs-3>{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div><div class=col-xs-2><input type=number class=\"form-control input-sm duration\" ng-model=cl.duration min=1></div><div class=\"col-xs-2 text-right\"><span class=\"text-left marR10\" ng-hide=\"cl.extn == \'Music Choice\'\"><label class=noMarB ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\'\"><input type=checkbox ng-model=cl.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></span><a href=\"\" class=text-danger ng-click=\"closeFilteredFx(cl.id, cl.wcgid, cl.tempId, $index)\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && contentGroupCount.length == 0\">{{\'cm.msg.4\' | translate}}<span ng-if=hiddenContent>{{\'s.p_s.msg.11\' | translate}}</span></div><div class=msg-warning lang={{auth.lang}} ng-if=\"contentGroupCount.length > 0 && (contentGroup.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=contentGroupFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.32\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"contentGroupFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'durationEmpty\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div>{{size = (allowedSize.size | filesize); \"\"}}<div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.cod.m5\' | translate:{size:size} }}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/contentOnDemand.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.cod.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.cod.2\' | translate}} &nbsp; <span ng-if=cod.info.label>[ {{cod.info.label}} ]</span></h1><span ng-if=\"selectedT==\'2\' && categorySize.isShow\" class=\"pull-right marL5\"><span class=\"fa fa-info-circle\" uib-tooltip=\"{{\'cl.widget.cod.m6\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left aria-hidden=true></span> </span><span ng-if=\"selectedT==\'2\' && categorySize.size != null\" class=\"pull-right text-sm pad2 padLR5\" ng-class=\"{\'text-danger bg-blink\':(categorySize.size > allowedSize.size), \'text-bold\':!tabView}\"><span ng-if=\"categorySize.size <= allowedSize.size\">{{categorySize.size | filesize}}</span> <span ng-if=\"categorySize.size > allowedSize.size\">{{allowSize = (allowedSize.size | filesize); \"\"}} {{\'cl.widget.cod.16\' | translate:{size:allowSize}}}</span></span></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=codFx(1);><span class=badge>2</span>{{\'cl.widget.cod.3\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(); editCForm = {isShow:true, isAdd:true, isEdit:false, curWinH:195}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.cod.5\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label ng-model=cod.info.label class=form-control maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=\"col-xs-10 hide\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><div class=row><div class=col-xs-3><label>{{\'cl.widget.cod.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':cod.info.settings.listBg}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"cod.info.settings.listBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lb=true\" readonly aria-label=\"{{\'cl.widget.cod.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cod.info.settings.listBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cod.info.settings.listBg selected-type=cod.info.ctype.listBg ng-if=colorPicker.lb></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cod.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':cod.info.settings.contentBg, opacity:cod.info.settings.contentBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"cod.info.settings.contentBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cb=true\" readonly aria-label=\"{{\'cl.widget.cod.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.9\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cod.info.settings.contentBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cod.info.settings.contentBg selected-type=cod.info.ctype.contentBg is-alpha=true selected-alpha=cod.info.settings.contentBga ng-if=colorPicker.cb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cod.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':cod.info.settings.thumbBg, opacity:cod.info.settings.thumbBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"cod.info.settings.thumbBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tBg=true\" readonly aria-label=\"{{\'cl.widget.cod.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.10\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{cod.info.settings.thumbBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=cod.info.settings.thumbBg selected-type=cod.info.ctype.thumbBg is-alpha=true selected-alpha=cod.info.settings.thumbBga ng-if=colorPicker.tBg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=thumbFont>{{\'cl.widget.cod.11\' | translate}}</label><select id=thumbFont class=form-control ng-model=cod.info.settings.thumbFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cod.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.11\' | translate}}\"></select></div><div class=col-xs-3><label for=thumbSize>{{\'cl.widget.cod.12\' | translate}}</label><input type=number id=thumbSize class=form-control ng-model=cod.info.settings.thumbSize min=1 aria-label=\"{{\'cl.widget.cod.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.12\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=cod.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=cod.info.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\" class=col-xs-12><div class=\"bg-light pad10 marB15\" ng-show=editCForm.isShow><div class=row><div class=col-xs-6><div class=form-group><label for=cName>{{\'cl.widget.cod.6\' | translate}}</label><input type=text id=cName ng-model=addCategory.label class=form-control maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cod.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.6\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label>{{\'cm.label.1\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{(addCategory.content | filter:{hidden:0}).length}}</span> <button type=button role=button id=contentBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=selectContent(addCategory);>{{\'r.btn.3\' | translate}}</button></div></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editCForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'m\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editCForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editCForm.isShow = false; editCForm.curWinH = 55\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'cName\'\" aria-live=polite role=status>{{\'cl.widget.cod.m1\' | translate}}</div><div ng-if=\"errType==\'cNameExists\'\" aria-live=polite role=status>{{\'cl.widget.cod.m2\' | translate}}</div><div ng-if=\"errType==\'content\'\" aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div></div></div></div></div><header class=\"panel-inner-tab marT10 marB10\">{{\'cl.widget.cod.4\' | translate}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 ng-change=codFilterFx(search.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger ng-hide\" ng-show=search.text.length ng-click=\"search.text=\'\'; codFilterFx(search.text)\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif ng-if=categoryLoading><div ng-if=!categoryLoading class=overflow-auto ng-attr-style=height:{{winH-editCForm.curWinH}}px><!-- Display Filtered Categories and Content --><div ng-repeat=\"cat in filteredCategories = (category.category | filter: customSearchFx)\" data-id={{cat.id}} class=\"marB15 sortable-category\"><div><label class=text-md>{{cat.label}} <span class=\"text-muted text-sm\" ng-if=\"(cat.content | filter:{hidden:0}).length\">[ {{(cat.content | filter:{hidden:0}).length}} ]</span></label><a href=\"\" class=\"text-primary marL10\" ng-click=\"editFx(cat); codFilterFx();\"><span class=\"fa fa-pencil\"></span></a> <a href=\"\" class=\"text-danger marL5\" ng-click=\"deleteOpen(\'c\', cat.id); search.text=\'\'; codFilterFx()\"><span class=\"fa fa-close\"></span></a> <a href=\"\" class=marL5 ng-click=\"moveFx(\'up\', $index); search.text=\'\'; codFilterFx()\" ng-if=!$first uib-tooltip=\"{{\'cl.widget.cod.14\' | translate}}\"><span class=\"fa fa-arrow-up\" aria-hidden=true></span></a> <a href=\"\" class=marL5 ng-click=\"moveFx(\'down\', $index); search.text=\'\'; codFilterFx()\" ng-if=!$last uib-tooltip=\"{{\'cl.widget.cod.15\' | translate}}\"><span class=\"fa fa-arrow-down\" aria-hidden=true></span></a></div><ul ng-if=\"cat.content.length > 0\" class=\"category-list sortable-containment\" sortable containment=\"\'parent\'\" callback=sortCallback()><!-- Show all content items if category matches, otherwise filter --><li ng-repeat=\"content in cat.content | filter: (cat.categoryMatches ? \'\' : customSearchFx) track by $index\" data-id=\"{{cat.id +\'-\'+ content.wcodid}}\" class=sortable-item ng-class=\"{\'codHidden\':content.hidden}\" ng-hide=content.hidden><div class=thumb-md><div class=thumb-img><a href=\"\" class=thumb-close ng-click=\"deleteOpen(\'i\', cat.id, content.wcodid); search.text=\'\'; codFilterFx()\"><span class=\"fa fa-times-circle\"></span></a><!-- Images --> <a ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} ng-if=\"content.thumb && (content.type == \'Image\' || content.type == \'Vector\' || content.type == \'POWERPOINT\' || content.type == \'WORD\')\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" ng-if=\"content.type != \'SharePointC\' && content.type != \'OneDriveC\'\" src-error=\"{{thumbHost + tim + \'assets/images/default/processing_selected.png\'}}&h=120&w=180&q=80&zc=3\"> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/sp.png\'}}&h=120&w=180&q=80&zc=3\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/od.png\'}}&h=120&w=180&q=80&zc=3\" ng-if=\"content.type == \'OneDriveC\'\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\" ng-if=\"content.isCompleted && content.type == \'Video\'\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/processing_selected.png\'}}&h=120&w=180&q=80&zc=3\"> </a><!-- Flash --> <a href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\" ng-if=\"content.type == \'Flash\'\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/processing_selected.png\'}}&h=120&w=180&q=80&zc=3\"> </a><!-- YouTube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}} uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Widget --> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/md/\' + content.thumb + \'.png\' + \'&h=120&w=180&q=80&zc=3\'}}\" ng-if=\"content.type == \'Widget\' && content.thumb != \'webPage\' && content.isCompleted\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.thumb == \'webPage\' && !content.ss && content.isCompleted\" ng-src=\"{{thumbHost + tim + cBucket + \'widgets/thumbs/md/\' + content.thumb + \'.png\' + \'&h=120&w=180&q=80&zc=3\'}}\" class=\"img-responsive center-block img-widget\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000> <a ng-href=\"{{cDetailBucket + content.ssImg | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} ng-if=\"content.type == \'Widget\' && content.thumb == \'webPage\' && content.ss && content.isCompleted\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.ssImg +\'&h=120&w=180&q=80&zc=3&v=\'+ timestamp}}\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000> </a><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/sp.png\'}}&h=120&w=180&q=80&zc=3\" ng-if=\"!content.thumb && content.type == \'SharePointC\'\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + \'&h=120&w=180&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/od.png\'}}&h=120&w=180&q=80&zc=3\" ng-if=\"!content.thumb && content.type == \'OneDriveC\'\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000> <img alt=\"\" ng-src=\"{{thumbHost + tim + \'assets/images/default/na.png\' + \'&h=120&w=101&q=80&zc=3\'}}\" ng-if=\"!content.thumb && content.type != \'SharePointC\' && content.type != \'OneDriveC\'\" uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000> <span class=codSize ng-if=\"content.pSize != null\">{{content.pSize | filesize}}</span> <span class=codSize ng-if=\"content.pSize == null && content.size != null\">{{(content.size*1024) | filesize}}</span> <span class=\"thumb-icon cl\"><span class=codVDuration ng-if=\"content.type == \'Video\' || content.type == \'Audio\' || (content.type == \'Widget\' && content.extn  == \'YouTube\' || content.extn  == \'Vimeo\')\" uib-tooltip=\"{{\'cm.label.49\' | translate}}\" tooltip-append-to-body=true>{{content.duration | durations}}</span> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type != \'folder\' && content.type != \'Sharepoint\' && content.type != \'Onedrive\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></div></div><div class=thumb-label uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</div><div class=\"fullScreen text-left\" ng-if=\"content.type == \'Video\' || content.thumb == \'livestream\'\"><label class=noMarB ng-if=\"content.type == \'Video\' || content.thumb == \'livestream\'\"><input type=checkbox ng-model=content.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label><label class=noMarB><input type=checkbox ng-disabled=\"content.caption == 0\" ng-model=content.isCaption><label></label><span class=valign-inherit>{{\'cl.label.10\' | translate}}</span></label></div><div class=form-inline ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><div class=\"fullScreen text-left noMar\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><label class=noMarB><input type=checkbox ng-model=content.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul><!-- No Content Message --><div class=msg-warning lang={{auth.lang}} ng-if=\"cat.content.length === 0\">{{\'db.msg.10\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"category.category.length == 0\">{{\'cl.widget.cod.m3\' | translate}}</div></div><!-- No Results Message --><div class=\"msg-warning pad10\" lang={{auth.lang}} ng-if=\"search.text && filteredCategories.length === 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=codFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cod.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"codFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div>{{size = (allowedSize.size | filesize); \"\"}}<div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.cod.m5\' | translate:{size:size} }}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/count.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.count.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.count.2\' | translate}} &nbsp; <span ng-if=count.label>[ {{count.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=count.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.count.24\' | translate}}</label><select class=form-control ng-model=count.settings.type aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=d>{{\'cl.widget.count.12\' | translate}}</option><option value=u>{{\'cl.widget.count.11\' | translate}}</option></select></div></div><div class=col-xs-6><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><select class=form-control ng-model=count.settings.ct ng-change=previewCount(); aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=dt>{{\'cl.widget.dt.1\' | translate}}</option><option value=no>{{\'cl.widget.count.17\' | translate}}</option></select></div></div></div><div class=\"row marB15\" ng-if=\"count.settings.ct == \'no\'\"><div class=col-xs-6><label for=sCount>{{\'cl.widget.count.18\' | translate}}</label><input type=number id=sCount class=form-control ng-model=count.settings.stc aria-label=\"{{\'cl.widget.count.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.18\' | translate}}\"></div><div class=col-xs-6><label for=eCount>{{\'cl.widget.count.14\' | translate}}</label><input type=number id=eCount class=form-control ng-model=count.settings.etc aria-label=\"{{\'cl.widget.count.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.18\' | translate}}\"></div></div><div class=\"row marB15\" ng-if=\"count.settings.ct == \'dt\'\"><div class=col-xs-6><label ng-if=\"count.settings.type == \'d\'\">{{\'cm.label.11\' | translate}}</label><label ng-if=\"count.settings.type == \'u\'\">{{\'cm.label.10\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=ctDate class=\"form-control picker down\" ng-model=count.settings.date ng-change=previewCount(); singledatepicker=true format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.11\' | translate}}\" aria-labelledby=\"{{\'cm.label.11\' | translate}}\"></div></div><div class=\"col-xs-6 timepicker\"><label ng-if=\"count.settings.type == \'d\'\">{{\'cm.label.13\' | translate}}</label><label ng-if=\"count.settings.type == \'u\'\">{{\'cm.label.12\' | translate}}</label><!-- <div class=\"input-group\">\r\n            <span class=\"input-group-addon\"><span class=\"fa fa-clock-o\" aria-hidden=\"true\"></span></span>              \r\n            <input type=\"text\" class=\"form-control\" ng-model=\"count.settings.time\" min=\"1\" ui-mask=\"99:99:99\" placeholder=\"HH:MM:SS\" id=\"time\" aria-label=\"time\" aria-labelledby=\"time\">\r\n          </div> --> <span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"count.settings.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=count.settings.time ng-change=previewCount(); hour-step=1 minute-step=5></div></div></span></div></div><div class=row><div class=col-xs-6 ng-if=\"count.settings.ct == \'dt\'\"><div class=form-group><label>{{\'cl.widget.count.25\' | translate}}</label><select class=form-control ng-model=count.settings.dType aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=ddhhmmss>DD:HH:MM:SS</option><option value=hhmmss>HH:MM:SS</option><option value=hhmm>HH:MM</option><option value=mmss>MM:SS</option><option value=ss>{{\'cl.widget.count.20\' | translate}}</option><option value=mm>{{\'cl.widget.count.21\' | translate}}</option><option value=hh>{{\'cl.widget.count.22\' | translate}}</option><option value=dd>{{\'cl.widget.count.23\' | translate}}</option></select></div></div><div class=col-xs-6 ng-if=\"count.settings.ct == \'no\'\"><div class=form-group><label>{{\'cl.widget.count.19\' | translate}}</label><select class=form-control ng-model=count.settings.tt aria-label=\"{{\'cl.widget.count.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.3\' | translate}}\"><option value=ss>{{\'cm.label.27s\' | translate}}</option><option value=mm>{{\'cm.label.28s\' | translate}}</option><option value=hh>{{\'cm.label.29s\' | translate}}</option></select></div></div></div></div><div class=col-xs-8><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- TODO Preview --><div class=form-group><label>{{\'d.btn.7\' | translate}}</label><div style=padding:15px;background-color:#000><div ng-if=count.settings.isHeader style=\"display: flex;justify-content: center;color:{{count.settings.headerText}};font-size:{{count.settings.headerSize}}px;font-family:{{count.settings.headerFont.value}}\">{{count.settings.hText}}</div><div class=marTB10 style=\"display: flex;justify-content: center\"><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'ddhhmmss\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{dayPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Días\':count.settings.lang == \'fr_FR\'? \'Jours\':\'Days\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{hoursPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Horas\':count.settings.lang == \'fr_FR\'? \'Heures\':\'Hours\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{minutesPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Minutos\':count.settings.lang == \'fr_FR\'? \'Minutes\':\'Minutes\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{secondsPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Segundos\':count.settings.lang == \'fr_FR\'? \'Secondes\':\'Seconds\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'hhmmss\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{hoursPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Horas\':count.settings.lang == \'fr_FR\'? \'Heures\':\'Hours\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{minutesPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Minutos\':count.settings.lang == \'fr_FR\'? \'Minutes\':\'Minutes\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{secondsPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Segundos\':count.settings.lang == \'fr_FR\'? \'Secondes\':\'Seconds\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'mmss\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{minutesPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Minutos\':count.settings.lang == \'fr_FR\'? \'Minutes\':\'Minutes\'}}</div></div><span class=marLR5>:</span><div style=\"display: flex;flex-direction: column;align-items: center\">{{secondsPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Segundos\':count.settings.lang == \'fr_FR\'? \'Secondes\':\'Seconds\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'s\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{secondsPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Segundos\':count.settings.lang == \'fr_FR\'? \'Secondes\':\'Seconds\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'m\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{minutesPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Minutos\':count.settings.lang == \'fr_FR\'? \'Minutes\':\'Minutes\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'h\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{hoursPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Horas\':count.settings.lang == \'fr_FR\'? \'Heures\':\'Hours\'}}</div></div></div><div ng-if=\"count.settings.ct == \'dt\' && count.settings.dType == \'d\'\" style=\"display: flex;color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}\"><div style=\"display: flex;flex-direction: column;align-items: center\">{{dayPreview}}<div ng-if=count.settings.isLabel style=color:{{count.settings.labelText}};font-size:{{count.settings.labelSize}}px;font-family:{{count.settings.labelFont.value}}>{{count.settings.lang == \'es_ES\'?\'Días\':count.settings.lang == \'fr_FR\'? \'Jours\':\'Days\'}}</div></div></div><div ng-if=\"count.settings.ct == \'no\'\" style=color:{{count.settings.countText}};font-size:{{count.settings.countSize}}px;font-family:{{count.settings.countFont.value}}>{{count.settings.type == \'d\'?count.settings.etc : count.settings.stc}}</div></div><div ng-if=count.settings.isFooter style=\"display: flex;justify-content: center;color:{{count.settings.footerText}};font-size:{{count.settings.footerSize}}px;font-family:{{count.settings.footerFont.value}}\">{{count.settings.fText}}</div></div></div><!-- TODO Background --><div class=\"row marB15 hide\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':count.settings.bg, opacity:count.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"count.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{count.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=count.settings.bg selected-type=count.settings.ctype.bg selected-rgba=count.settings.bg is-alpha=true selected-alpha=count.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div></div><!-- TODO Header --><div class=row><div class=col-xs-4><div class=form-group><label class=noMarB for=isHeader><input type=checkbox id=isHeader ng-model=count.settings.isHeader role=checkbox aria-label=isHeader aria-labelledby=isHeader><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div></div><div class=row ng-if=count.settings.isHeader><div class=col-xs-8><div class=form-group><label for=hText>{{\'cl.widget.cm.12\' | translate}}</label><input type=text id=hText class=form-control ng-model=count.settings.hText maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div></div><div class=\"row marB15\" ng-if=count.settings.isHeader><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':count.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"count.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=count.settings.headerText selected-type=count.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize min=1 class=form-control ng-model=count.settings.headerSize aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control id=headerFont ng-model=count.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><!-- TODO Count --><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cl.widget.count.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':count.settings.countText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"count.settings.countText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ct=true\" readonly aria-label=\"{{\'cl.widget.count.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=count.settings.countText selected-type=count.ctype.countText ng-if=colorPicker.ct></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=countSize>{{\'cl.widget.count.6\' | translate}}</label><input type=number id=countSize min=1 class=form-control ng-model=count.settings.countSize aria-label=\"{{\'cl.widget.count.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.6\' | translate}}\"></div><div class=col-xs-4><label for=countFont>{{\'cl.widget.count.7\' | translate}}</label><select id=countFont class=form-control ng-model=count.settings.countFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.count.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.7\' | translate}}\"></select></div></div><!-- TODO Label --><div class=row ng-if=\"count.settings.ct == \'dt\'\"><div class=col-xs-4><div class=form-group><label class=noMarB for=isLabel><input type=checkbox id=isLabel ng-model=count.settings.isLabel role=checkbox aria-label=isLabel aria-labelledby=isLabel><label></label>{{\'d.label.10\' | translate}}</label></div></div></div><div class=row ng-if=\"count.settings.isLabel && count.settings.ct == \'dt\'\"><div class=col-xs-6><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><select id=lang class=form-control ng-model=count.settings.lang aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=es_ES>Spanish / Spain</option></select></div></div></div><div class=\"row marB15\" ng-if=\"count.settings.isLabel && count.settings.ct == \'dt\'\"><div class=col-xs-4><label>{{\'cl.widget.aqi.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':count.settings.labelText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"count.settings.labelText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lt=true\" readonly aria-label=\"{{\'cl.widget.aqi.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=count.settings.labelText selected-type=count.ctype.labelText ng-if=colorPicker.lt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=labelSize>{{\'cl.widget.aqi.11\' | translate}}</label><input type=number id=labelSize min=1 class=form-control ng-model=count.settings.labelSize aria-label=\"{{\'cl.widget.aqi.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.11\' | translate}}\"></div><div class=col-xs-4><label for=labelFont>{{\'cl.widget.aqi.10\' | translate}}</label><select class=form-control id=labelFont ng-model=count.settings.labelFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.aqi.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.aqi.10\' | translate}}\"></select></div></div><!-- TODO Footer --><div class=row><div class=col-xs-4><div class=form-group><label class=noMarB for=isFooter><input type=checkbox id=isFooter ng-model=count.settings.isFooter role=checkbox aria-label=isFooter aria-labelledby=isFooter><label></label>{{\'cl.widget.cm.36\' | translate}}</label></div></div></div><div class=row ng-if=count.settings.isFooter><div class=col-xs-8><div class=form-group><label for=hText>{{\'cl.widget.cm.36\' | translate}}</label><input type=text id=hText class=form-control ng-model=count.settings.fText maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.cm.36\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.36\' | translate}}\"></div></div></div><div class=\"row marB15\" ng-if=count.settings.isFooter><div class=col-xs-4><label>{{\'cl.widget.cm.36\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':count.settings.footerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"count.settings.footerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.cm.36\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.36\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=count.settings.footerText selected-type=count.ctype.footerText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=footerSize>{{\'cl.widget.cm.37.1\' | translate}}</label><input type=number id=footerSize min=1 class=form-control ng-model=count.settings.footerSize aria-label=\"{{\'cl.widget.cm.37.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37.1\' | translate}}\"></div><div class=col-xs-4><label for=footerFont>{{\'cl.widget.cm.37\' | translate}}</label><select class=form-control id=footerFont ng-model=count.settings.footerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.37\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=count.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=count.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=countFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'countSize\'\" aria-live=polite role=status>{{\'cl.widget.count.m1\' | translate}}</div><div ng-if=\"errType==\'eCount\'\" aria-live=polite role=status>{{\'cl.widget.count.m1\' | translate}}</div><div ng-if=\"errType==\'stc\'\" aria-live=polite role=status>{{\'cl.widget.count.m3\' | translate}}</div><div ng-if=\"errType==\'etc\'\" aria-live=polite role=status>{{\'cl.widget.count.m2\' | translate}}</div><div ng-if=\"errType==\'headerSize\'\" aria-live=polite role=status>{{\'cl.widget.count.m4\' | translate}}</div><div ng-if=\"errType==\'labelSize\'\" aria-live=polite role=status>{{\'cl.widget.count.m5\' | translate}}</div><div ng-if=\"errType==\'footerSize\'\" aria-live=polite role=status>{{\'cl.widget.count.m6\' | translate}}</div><div ng-if=\"errType==\'stcValidL\'\" aria-live=polite role=status>{{\'cl.widget.count.m7\' | translate}}</div><div ng-if=\"errType==\'stcValidG\'\" aria-live=polite role=status>{{\'cl.widget.count.m8\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/dateTime.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.dt.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.dt.2\' | translate}} &nbsp; <span ng-if=dateTime.label>[ {{dateTime.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=dateTimeFx(1);><span class=badge>2</span>{{\'cm.label.2s\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=dateTime.labelOpt value=a><label></label>{{\'cl.widget.dt.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=dateTime.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"dateTime.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=dateTime.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div ng-class=\"{\'form-group\':dateTime.timezoneOpt == \'dz\'}\" role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cm.label.88\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=timezoneOpt ng-model=dateTime.timezoneOpt value=z><label></label>{{\'cm.label.33\' | translate}}</label><label><input type=radio role=radio name=timezoneOpt ng-model=dateTime.timezoneOpt value=dz><label></label>{{\'cm.label.33.1\' | translate}}</label></div><ng-timezone timezone=dateTime.timezone label=false ng-if=\"dateTime.timezoneOpt == \'z\'\" timezone-list=timezoneList></ng-timezone><div class=row><div class=col-xs-6><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><select id=lang class=form-control ng-model=dateTime.settings.lang ng-change=\"formatFx(\'n\');\" aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=pt_PT>Portuguese / Portugal</option><option value=es_ES>Spanish / Spain</option><option value=de_DE>German / Germany</option><option value=pl_PL>Polish / Poland</option></select></div></div><div class=col-xs-6><div class=form-group><label for=format>{{\'cl.widget.dt.9\' | translate}}</label><select id=format class=form-control ng-model=dateTime.settings.format aria-label=\"{{\'cl.widget.dt.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.9\' | translate}}\"><option ng-repeat=\"format in formats\" value={{format.value}}>{{format.label}}</option></select></div></div></div></div><div class=\"col-xs-12 marT10\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=dateTime.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=dateTime.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div><label>{{\'cl.widget.cm.7\' | translate}}</label></div><div class=form-group><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 1\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time1.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t1\')\" value=t1><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 2\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time2.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t2\')\" value=t2><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 7\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time7.png?{{curTS}}\"><div class=marT5 ng-if=\"dateTime.settings.lang == \'en_US\' || dateTime.settings.lang == \'es_ES\' || dateTime.settings.lang == \'pt_PT\' || dateTime.settings.lang == \'de_DE\' || dateTime.settings.lang == \'pl_PL\'\"><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t7\')\" value=t7><label></label>{{\'cl.widget.dt.11\' | translate}}</div><div class=marT5 ng-if=\"dateTime.settings.lang == \'fr_FR\'\"><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t7\')\" value=t7><label></label>{{\'cl.widget.dt.12\' | translate}}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 3\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time3.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t3\')\" value=t3><label></label>{{\'cl.widget.dt.5\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 4\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time4.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t4\')\" value=t4><label></label>{{\'cl.widget.dt.5\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 5\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time5.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t5\')\" value=t5><label></label>{{\'cl.widget.dt.6\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 6\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time6.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t6\')\" value=t6><label></label>{{\'cl.widget.dt.6\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 8\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time8.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t8\')\" value=t8><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'8\'} }}</div></label></div><div class=\"pull-left marR20 marB20\"><label class=noMarB><img alt=\"Template 9\" ng-src=\"assets/images/widget/templates/{{dateTime.settings.lang.split(\'_\')[0]}}/{{dateTime.settings.format}}/time9.png?{{curTS}}\"><div class=marT5><input type=radio role=radio ng-model=dateTime.settings.template ng-change=\"changeTemplate(\'t9\')\" value=t9><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'9\'} }}</div></label></div></div></div><div class=col-xs-7 ng-if=\"dateTime.settings.template != \'t8\' && dateTime.settings.template != \'t9\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6 ng-if=\"dateTime.settings.template == \'t1\' || dateTime.settings.template == \'t3\'\"><div class=form-group><label>{{\'cl.widget.dt.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':dateTime.settings.bg, opacity:dateTime.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.dt.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.10\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{dateTime.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.bg selected-type=dateTime.ctype.bg is-alpha=true selected-alpha=dateTime.settings.bga ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div></div><div class=col-xs-6 ng-if=\"dateTime.settings.template != \'t3\' && dateTime.settings.template != \'t4\'\"><div class=form-group><label>{{\'cl.widget.dt.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.dateText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.dateText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dc=true\" readonly aria-label=\"{{\'cl.widget.dt.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.dateText selected-type=dateTime.ctype.date ng-if=colorPicker.dc></ng-hub-color-picker></div></div></div></div><div class=col-xs-6 ng-if=\"dateTime.settings.template != \'t5\' && dateTime.settings.template != \'t6\'\"><div class=form-group><label>{{\'cl.widget.dt.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.dt.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.timeText selected-type=dateTime.ctype.time ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=dateTime.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div></div></div></div></div><div class=col-xs-7 ng-if=\"dateTime.settings.template == \'t8\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- day setting --><div class=row><div class=col-xs-6><label>{{\'cl.widget.dt.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dac><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.dayText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.dayText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dac=true\" readonly aria-label=\"{{\'cl.widget.dt.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.dayText selected-type=dateTime.ctype.date ng-if=colorPicker.dac></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=dayFont>{{\'cl.widget.dt.15\' | translate}}</label><select id=dayFont class=form-control ng-model=dateTime.settings.dayFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.dt.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.15\' | translate}}\"></select></div></div><!-- month setting --><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.dt.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.monthText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.monthText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mc=true\" readonly aria-label=\"{{\'cl.widget.dt.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.monthText selected-type=dateTime.ctype.date ng-if=colorPicker.mc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=monthFont>{{\'cl.widget.dt.16\' | translate}}</label><select id=monthFont class=form-control ng-model=dateTime.settings.monthFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.dt.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.16\' | translate}}\"></select></div></div><!-- time setting --><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.dt.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.dt.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.timeText selected-type=dateTime.ctype.date ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=dateTime.settings.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div></div><!-- date setting --><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.dt.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.dateText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.dateText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dc=true\" readonly aria-label=\"{{\'cl.widget.dt.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.dateText selected-type=dateTime.ctype.date ng-if=colorPicker.dc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=dateFont>{{\'cl.widget.dt.17\' | translate}}</label><select id=dateFont class=form-control ng-model=dateTime.settings.dateFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.dt.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.17\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-7 ng-if=\"dateTime.settings.template == \'t9\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- day setting --><div class=row><div class=col-xs-6><label>{{\'cl.widget.dt.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dac><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.dayText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.dayText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dac=true\" readonly aria-label=\"{{\'cl.widget.dt.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.dayText selected-type=dateTime.ctype.date ng-if=colorPicker.dac></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=dayFont>{{\'cl.widget.dt.15\' | translate}}</label><select id=dayFont class=form-control ng-model=dateTime.settings.dayFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.dt.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.15\' | translate}}\"></select></div></div><!-- time setting --><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.dt.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.dt.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.timeText selected-type=dateTime.ctype.date ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=dateTime.settings.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div></div><!-- date setting --><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.dt.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':dateTime.settings.dateText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"dateTime.settings.dateText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dc=true\" readonly aria-label=\"{{\'cl.widget.dt.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=dateTime.settings.dateText selected-type=dateTime.ctype.date ng-if=colorPicker.dc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=dateFont>{{\'cl.widget.dt.17\' | translate}}</label><select id=dateFont class=form-control ng-model=dateTime.settings.dateFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.dt.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.17\' | translate}}\"></select></div></div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=dateTimeFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"dateTimeFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/delimitedText.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.dText.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.dText.2\' | translate}} &nbsp; <span ng-if=delimitedText.label>[ {{delimitedText.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=tabFx(2);><span class=badge>2</span>{{\'cl.widget.cm.22\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=tabFx(3);><span class=badge>3</span>{{\'cl.widget.dText.3\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=delimitedText.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=\"row noMar\"><div class=\"form-group col-xs-9 noPadL\"><label for=dataSource>{{\'cl.widget.dText.4\' | translate}}</label><input type=text id=dataSource class=form-control ng-model=delimitedText.dataSource placeholder=http://example.com/file.ext aria-label=\"{{\'cl.widget.dText.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.4\' | translate}}\"></div><div class=\"form-group col-xs-3 noPadR\"><label for=refreshInterval>{{\'cl.widget.dText.5\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=refreshInterval class=form-control ng-model=delimitedText.refreshInterval min=1 aria-label=\"{{\'cl.widget.dText.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.5\' | translate}}\"></div></div><div class=\"row noMar\"><div class=\"form-group col-xs-3 noPadL\"><label>{{\'cl.widget.dText.6\' | translate}}</label><select class=form-control ng-model=delimitedText.delimiter aria-label=\"{{\'cl.widget.dText.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.6\' | translate}}\"><option value=comma>{{\'cl.widget.dText.6.1\' | translate}}</option><option value=semicolon>{{\'cl.widget.dText.6.2\' | translate}}</option><option value=tab>{{\'cl.widget.dText.6.3\' | translate}}</option></select></div><div class=\"form-group col-xs-3\"><label>{{\'cl.widget.dText.7\' | translate}}</label><select class=form-control ng-model=delimitedText.chartType aria-label=\"{{\'cl.widget.dText.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.7\' | translate}}\"><option value=table>{{\'cl.widget.dText.7.1\' | translate}}</option><option value=freeForm>{{\'cl.widget.dText.7.2\' | translate}}</option></select></div><div class=\"form-group col-xs-3\"><label for=fWidth>{{\'cl.widget.dText.8\' | translate}}</label><input type=number id=fWidth class=form-control ng-model=delimitedText.fWidth min=1 aria-label=\"{{\'cl.widget.dText.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.8\' | translate}}\"></div><div class=\"form-group col-xs-3 noPadR\"><label for=fHeight>{{\'cl.widget.dText.9\' | translate}}</label><input type=number id=fHeight class=form-control ng-model=delimitedText.fHeight min=1 aria-label=\"{{\'cl.widget.dText.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.9\' | translate}}\"></div></div><div class=\"row noMar\"><div class=\"form-group col-xs-6 noPadL\"><label>{{\'cl.widget.dText.10\' | translate}}</label><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file aria-label=sampleDataB ng-file-model=delimitedText.sampleData> <input type=text aria-label=sampleDataName class=form-control ng-model=delimitedText.sampleData.name readonly aria-label=\"{{\'cl.widget.dText.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.10\' | translate}}\"></div></div><div class=\"form-group col-xs-6 noPadR\"><label>{{\'cl.widget.cm.19\' | translate}}</label><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file aria-label=bgImgB ng-file-model=delimitedText.bgImg> <input type=text aria-label=bgImgName class=form-control ng-model=delimitedText.bgImg.name readonly aria-label=\"{{\'cl.widget.cm.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.19\' | translate}}\"></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=delimitedText.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=delimitedText.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7>{{\'cl.widget.cm.22\' | translate}}</div></div><div ng-if=\"selectedT==\'3\'\"><div class=col-xs-7>{{\'cl.widget.dText.3\' | translate}}</div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=tabFx(2);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.22\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=tabFx(3);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.dText.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=delimitedTextFx(); ng-if=\"encId || selectedT==\'3\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/empty.html","<!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" translate=\"{{\'cl.msg.32\'}}\" translate-values=\"{htmlTagO: \'<a href=\\\'mailto:support@lsquared.com\\\'>\', htmlTagC:\'</a>\'}\"></div> -->");
$templateCache.put("app/contentLibrary/widgets/excelSheet.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.es.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.es.2\' | translate}} &nbsp; <span ng-if=excelSheet.label>[ {{excelSheet.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=excelSheet.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=\"col-xs-12 marB15\"><div class=\"bg-light pad10\"><label><input type=radio role=radio ng-model=excelSheet.gType value=f name=fOpt ng-disabled=encId ng-change=\"changeType(\'gType\');\"><label></label>{{\'cl.widget.queue.16\' | translate}}</label><label class=marL10><input type=radio role=radio ng-model=excelSheet.gType value=g name=fOpt ng-disabled=encId ng-change=\"changeType(\'gType\');\"><label></label>{{\'cl.widget.queue.15\' | translate}}</label><label class=marL10><input type=radio role=radio ng-model=excelSheet.gType value=img name=fOpt ng-disabled=encId ng-change=\"changeType(\'imgType\');\"><label></label>{{\'cl.widget.es.3\' | translate}}</label><div class=row><div class=col-xs-12 ng-if=\"excelSheet.gType == \'f\'\"><div class=row><div class=col-xs-3><div class=\"form-group noMarB marT5\"><span class=\"btn btn-primary btn-file\" ng-disabled=fileModelLoading><span class=fa ng-class=\"fileModelLoading?\'fa-repeat fa-spin\':\'fa-arrow-down\'\" aria-hidden=true></span> {{\'cl.widget.cm.24\' | translate}} <input type=file id=fileBtn file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading aria-label=importFile></span></div></div></div></div><div class=col-xs-12 ng-if=\"excelSheet.gType == \'img\'\"><div class=\"form-group noMarB marT5\"><div class=\"marB5 text-bold\">{{curData.name}}</div><span class=\"btn btn-primary btn-file\" ng-disabled=fileModelLoading>{{\'cl.btn.5\' | translate | capitalize}}<!-- <input type=\"file\" id=\"fileBtn\" file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=\"fileModelLoading\" ng-if=\"!isFileUploading\" aria-label=\"importFile\"> --> <input type=file id=fileBtn file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading></span></div></div><div class=col-xs-6 ng-if=\"excelSheet.gType == \'g\'\"><div class=\"form-group noMarB\"><label>{{\'cl.widget.queue.17\' | translate}}</label><div class=input-group><input type=number id=columns class=form-control ng-model=excelSheet.columns min=1 aria-label=\"{{\'cl.widget.queue.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.17\' | translate}}\"><div class=input-group-btn><button type=button role=button id=generateBtn class=\"btn btn-primary\" ng-click=generateFx(); ng-disabled=generateProcessing><span class=fa ng-class=\"generateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{generateProcessing?\'cl.widget.queue.1bi\':\'cl.widget.queue.1b\' | translate}}</button></div></div></div></div></div></div></div></div><div class=marB18 ng-if=\"excelSheet.gType == \'f\' && !fileModelLoading\"><div class=\"bg-warning text-warning padTB10 padLR10\"><span class=\"fa fa-exclamation-triangle marR5\" aria-hidden=true></span><span>{{\"cl.widget.es.m1\" | translate}}</span></div></div><img class=marB15 alt=Loading src=assets/images/loading.gif ng-if=fileModelLoading></div><div ng-if=\"excelSheet.gType != \'img\' && excelSheet.table[0].d.length > 0\"><div class=\"col-xs-7 marB5\"><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=addRowFx(); ng-disabled=addRowBtn><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cl.widget.queue.2b\' | translate}}</button> <button type=button role=button class=\"btn btn-danger btn-sm\" ng-click=deleteOpen(); ng-disabled=deleteBtn><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.13\' | translate}}</button></div><div class=\"col-xs-5 noPadR text-right d-flex justify-end\"><div class=\"marR10 d-flex\" ng-if=\"excelSheet.gType == \'f\'\"><a ng-if=\"excelSheet.excelDUrl != null\" href=\"\" role=link target=_blank ng-click=downloadSheetFx(excelSheet.excelDUrl); uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true download class=\"btn btn-link text-lg marT-4\"><span class=\"fa fa-download\" aria-hidden=true></span></a><select class=\"form-control marT-2\" id=wc ng-model=excelSheet.sheet ng-options=\"wc.l for wc in excelSheet.table track by wc.l\" aria-label=\"{{\'t.label.24\' | translate}}\" aria-labelledby=\"{{\'t.label.24\' | translate}}\" ng-change=\"changeSheetFx(); searchQu.text = \'\'\"><option value=\"\" data-ind=2 disabled>{{\'t.label.24\' | translate}}</option></select></div><div class=\"searchTbx marT-2\"><input type=text class=\"form-control h34\" ng-model=searchQu.text sanitize-input maxlength=250 ng-disabled=!excelSheet.table[0].d.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchQu.text.length ng-click=\"searchQu.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"col-xs-12 noPadR\"><div class=\"overflow-x marB10\"><table class=\"table queueTbl\"><thead><tr><th class=noBdr><label class=\"marT5 padL5\"><input type=checkbox ng-model=isChecked.selectAll ng-change=\"isCheckedFx(\'all\');\" role=checkbox><label></label></label></th><th class=noBdr colspan={{tbl.label.cs}} rowspan={{tbl.label.rs}} ng-style=tbl.label.s ng-repeat=\"tbl in excelSheet.table[excelSheet.sheetIndex].d[0].row track by $index\"><input ng-if=\"excelSheet.gType == \'g\'\" type=text ng-style=tbl.label.f class=\"form-control input-sm\" value={{tbl.label}} ng-model=tbl.label aria-label={{tbl.label}} aria-labelledby={{tbl.label}}> <input ng-if=\"excelSheet.gType == \'f\'\" type=text ng-style=tbl.label.f class=\"form-control input-sm\" value={{tbl.label.t}} ng-model=tbl.label.t aria-label={{tbl.label.t}} aria-labelledby={{tbl.label.t}}></th></tr></thead><tbody class=sortable-containment ng-if=\"!searchQu.text || searchQu.text && (excelSheet.table[excelSheet.sheetIndex].d | filter:searchQu.text).length\"><tr ng-repeat=\"d in filteredRow = (excelSheet.table[excelSheet.sheetIndex].d.slice(1) | filter:searchQu.text) track by $index\" class=sortable-item data-id={{d.id}}><!-- ng-if=\"($index != 0 && !searchQu.text && filteredRow.length > 1) || (searchQu.text && filteredRow.length >= 1)\" --><td><label class=\"marT5 padL5\"><input type=checkbox ng-model=d.isChecked ng-change=isCheckedFx(); role=checkbox><label></label></label></td><!-- ng-style=\"{{col.label.style}}\" --><td ng-if=!col.label.d class=\"noBdr relative\" colspan={{col.label.cs}} rowspan={{col.label.rs}} ng-style=col.label.s ng-repeat=\"col in d.row track by $index;\"><input type=text ng-style=col.label.f class=\"form-control input-sm absoluteTd\" ng-model=col.label.t aria-label={{col.label.t}} aria-labelledby={{col.label.t}}></td></tr></tbody></table><div class=msg-warning lang={{auth.lang}} ng-if=\"searchQu.text && (excelSheet.table[excelSheet.sheetIndex].d | filter:searchQu.text).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchQu.text)}}&quot;</b>\'}\"></div></div></div></div><div class=col-xs-9><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=excelSheet.settings.reloadOpt name=reloadOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=excelSheet.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"excelSheet.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=excelSheet.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><label>{{\'cm.label.58\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=excelSheet.settings.rotateOpt name=rotateOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=excelSheet.settings.rotateOpt name=rotateOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"excelSheet.settings.rotateOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=excelSheet.settings.rotate min=1 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"><div class=\"input-group-addon no-length\">{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':excelSheet.settings.bg, opacity:excelSheet.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{excelSheet.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.bg selected-type=excelSheet.ctype.bg is-alpha=true selected-alpha=excelSheet.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div><div class=row><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':excelSheet.settings.headerBg, opacity:excelSheet.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{excelSheet.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.headerBg selected-type=excelSheet.ctype.headerBg is-alpha=true selected-alpha=excelSheet.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':excelSheet.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.headerText selected-type=excelSheet.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control ng-model=excelSheet.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.pw.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':excelSheet.settings.footerBg, opacity:excelSheet.settings.footerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.footerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fb=true\" readonly aria-label=\"{{\'cl.widget.pw.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{excelSheet.settings.footerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.footerBg selected-type=excelSheet.ctype.footerBg is-alpha=true selected-alpha=excelSheet.settings.footerBga ng-if=colorPicker.fb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.pw.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':excelSheet.settings.footerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.footerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.pw.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.footerText selected-type=excelSheet.ctype.footerText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.37\' | translate}}</label><select class=form-control ng-model=excelSheet.settings.footerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.37\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':excelSheet.settings.rowBg, opacity:excelSheet.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{excelSheet.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.rowBg selected-type=excelSheet.ctype.rowBg is-alpha=true selected-alpha=excelSheet.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':excelSheet.settings.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.rowText selected-type=excelSheet.ctype.rowText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.8\' | translate}}</label><select class=form-control ng-model=excelSheet.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':excelSheet.settings.altBg, opacity:excelSheet.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{excelSheet.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.altBg selected-type=excelSheet.ctype.altBg is-alpha=true selected-alpha=excelSheet.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':excelSheet.settings.altText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"excelSheet.settings.altText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=excelSheet.settings.altText selected-type=excelSheet.ctype.altText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.10\' | translate}}</label><select class=form-control ng-model=excelSheet.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=excelSheet.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=excelSheet.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=excelSheetFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'columns\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8\' | translate}}</div><div ng-if=\"errType==\'grid\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8.1\' | translate}}</div><div ng-if=\"errType==\'file\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8.2\' | translate}}</div><div ng-if=\"errType==\'upFile\'\" aria-live=polite role=status>{{\'d.p_dg.m8\' | translate}}</div><div ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</div><div ng-if=\"errType==\'maxCol\'\" aria-live=polite role=status>{{\'t.msg.35\' | translate}}</div><div ng-if=\"errType==\'unDelete\'\" aria-live=polite role=status>{{\'cl.widget.es.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/extInput.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.ei.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.ei.2\' | translate}} &nbsp; <span ng-if=extInput.label>[ {{extInput.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=extInput.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=inputSrc>{{\'cl.widget.ei.3\' | translate}}</label><select class=form-control id=inputSrc ng-model=extInput.inputSrc aria-label=\"{{\'cl.widget.ei.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ei.3\' | translate}}\"><option value=ext://hdmi:1>{{\'cl.widget.ei.3.1\' | translate}}</option><option value=ext://hdmi:2>{{\'cl.widget.ei.3.2\' | translate}}</option><option value=ext://dvi:1>{{\'cl.widget.ei.3.3\' | translate}}</option><option value=ext://dp:1 class=hide>{{\'cl.widget.ei.3.4\' | translate}}</option><option value=LG-Presenter class=hide>{{\'cl.widget.ei.3.5\' | translate}}</option></select></div><div class=form-group><label class=noMar><input type=checkbox ng-model=extInput.mute role=checkbox><label></label>{{\'cm.label.67\' | translate}}</label></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=extInput.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=extInput.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=extInputFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.16\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.16.1\' | translate}} &nbsp; <span ng-if=f45.label>[ {{f45.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=f45Fx(1);><span class=badge>2</span>{{\'cl.widget.wf45.16.3\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=f45Fx(2);><span class=badge>3</span>{{\'cm.label.31s\' | translate | camelCase}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(); editWForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.wf45.16.4\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-6><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editWForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-12><div class=row><div class=col-xs-3><div class=form-group><label for=dateRange>{{\'cm.label.7\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control picker\" ng-model=addWorkout.dateRange format=MM/DD/YYYY min-date={{minDate}} opens=right singledatepicker=true readonly aria-label=\"{{\'cm.label.7\' | translate}}\" aria-labelledby=\"{{\'cm.label.7\' | translate}}\"></div></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label for=startTime>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=startTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addWorkout.startTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addWorkout.startTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label for=endTime>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=endTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addWorkout.endTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addWorkout.endTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=form-group><label>&nbsp;</label><div class=quotesImg><div class=noMarR><div class=\"pull-left relative marR5\" ng-if=\"!addWorkout.isHidden && addWorkout.widget.thumb\"><a href=\"\" role=link class=thumb-close ng-click=removeContentFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <img alt=\"\" ng-if=\"addWorkout.widget.extn == \'F45 Workout\'\" ng-src={{cDetailBucket}}widgets/thumbs/xs/{{addWorkout.widget.thumb}}.png class=\"img-responsive center-block\"></div><button type=button role=button id=storyBtn class=\"btn btn-default btn-sm\" ng-click=selectContentOpen();>{{\'cl.widget.wf45.16.8\' | translate}}</button></div></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editWForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addF45Fx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addF45Fx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=resetFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editWForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addF45Fx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editWForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div><div ng-if=\"errType==\'widget\'\" aria-live=polite role=status>{{\'cl.widget.wf45.m4\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\">{{\'cl.widget.wf45.17.2\' | translate}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-scroll\" ng-if=\"workoutList.length > 0\"><div class=\"row th\" ng-if=\"filteredWorkoutList.length > 0\"><div class=col-xs-4>{{\'cl.widget.wf45.17.2\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.7\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.12\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.13\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><div class=folder-content><div class=row ng-repeat=\"wo in filteredWorkoutList = (workoutList | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=col-xs-4><div class=\"pull-left relative\" ng-if=!wo.widget.extn><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/na_sm.png class=emptyThumb-md></div><div class=\"pull-left relative\" ng-if=wo.widget.extn><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/xs/{{wo.widget.thumb}}.png> {{wo.widget.label}}</div></div><div class=col-xs-3>{{wo.date | date:\'mediumDate\'}}</div><div class=col-xs-2>{{wo.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-2>{{wo.endTime | date:\'hh:mm a\'}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=editFx(wo);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deleteOpen(wo.id);><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredWorkoutList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"workoutList.length == 0\">{{\'cl.widget.wf45.m3\' | translate}}</div></div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=relative ng-if=!detailLoading><div class=noPad ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=pull-right uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\">{{deviceViewText}}</a></li><li><a href=\"\" role=link ng-click=\"checkboxFx(\'all\'); selectAllSDFx()\" ng-if=\"!deviceTypes.types.length || (selectedT == \'2\' || selectedT == \'3\')\">{{\'cm.btn.44\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchTextS.text sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchChangeFx(\'empty\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab><a href=\"\" role=link class=selected>{{\'cm.label.4s\' | translate}}</a></div></div><div class=\"overflow-auto bg-light pad10\" ng-attr-style=height:{{quadHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><div ng-if=\"!deviceListLoading && deviceList.devices.length > 0\"><ul class=\"list-inline thumb-list dType-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredDTypes = (deviceTypes.types | customSearch:{key:searchText, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_selected_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && deviceTypes.types.length && !filteredDTypes.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><div ng-if=\"!deviceListLoading && breadCrumbs.length\" class=breadcrumb><a href=\"\" role=link ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div><span ng-if=\"!deviceListLoading && devices.devices.length > 0 && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\" element-height=quadHeight><ng-device-thumb class=show selectable=selection selectable-list=\"devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!deviceListLoading && devices.devices.length > 0 && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=\"devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && !advSearchInfo.isEmpty\">{{\'d.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div></div></div><div class=noPad ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"removeFilteredFx(\'all\'); closeAllFx(); selectedSearchText=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\"> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{f45.devices.length>1?\'cm.body.7s\':\'cm.body.7\' | translate}} [ {{f45.devices.length}} ]</div></div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{selectedHeight}}px;max-height:{{selectedHeight}}px;><div ng-if=\"f45.devices.length > 0\"><ul class=\"list-inline multiple-selected\"><li ng-repeat=\"device in scheduleDevice = (f45.devices | customSearch:{key:selectedSearchText, module:\'d\'})\" data-id={{device.id}} data-type=device ng-if=\"f45.devices.length > 0\"><a href=\"\" role=link class=thumb-close ng-click=\"removeFilteredFx(device.id, \'d\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><a ng-href=\"{{dDetailBucket + (device.mac | removeColon) + \'.jpg?\' + device.thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{device.label}} ng-if=\"device.thumbV != undefined && device.thumbV != 0\"><img alt=\"\" ng-src=\"{{tim + dBucket + (device.mac | removeColon) + \'.jpg&\' + device.thumbV + thumbBigParam}}\" src-error=assets/images/default/device_selected_{{device.dType}}.png> </a><img alt=\"\" ng-if=\"device.thumbV != undefined && device.thumbV == 0\" src=assets/images/default/device_selected_{{device.dType}}.png></div><div class=\"text-ellipsis marT5\">{{device.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"f45.devices.length > 0 && scheduleDevice.length + scheduleDeviceTag.length + scheduleDeviceGrp.length + scheduleDeviceSearch.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"f45.devices.length == 0\">{{\'cm.msg.4\' | translate}} <span ng-if=hiddenDevices>{{\'s.p_s.msg.14\' | translate}}</span></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=f45Fx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.wf45.16.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=f45Fx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cm.label.31s\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"f45Fx(0, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45Animation.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.18\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.18\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true></div><div class=form-group><label for=animation>{{\'cl.widget.anima.1\' | translate}}</label><select id=animation class=form-control ng-model=f45Data.animation><option value=none>{{\'cl.widget.anima.3\' | translate}}</option><option value=pulse>{{\'cl.widget.anima.4\' | translate}}</option></select></div><div class=form-group><label for=svgCode>{{\'cl.widget.anima.2\' | translate}}</label><textarea type=text id=svgCode class=form-control ng-model=f45Data.svgcode rows=5></textarea></div><div ng-if=f45Data.svgcode.length><label>{{\'cl.widget.ss.7\' | translate}}</label><div><div ng-class=\"f45Data.animation == \'pulse\'?\'pulseAnimation\':\'pulseAnimationNone\'\" ng-bind-html=\"f45Data.svgcode | trustHtml\"></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'svgCode\'\" aria-live=polite role=status>{{\'cl.widget.wf45.m6\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45ContentScroller.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.1.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=f45SaveFx(1);><span class=badge>2</span>{{\'cm.label.32\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cl.widget.wf45.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cl.widget.wf45.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.10\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\" class=col-xs-12><div class=row><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div ng-class=\"{\'noMarB\': auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{quadHeight}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=contentLibrary.info.sp class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=contentLibrary.info.od class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=contentLibrary.info.gd class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=!contentLibraryLoading element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{contentCount = (f45Data.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\"> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <span ng-if=f45Data.content>[ {{contentCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{selectedHeight}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && f45Data.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback()><li ng-repeat=\"content in f45Data.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=sortable-item ng-if=!content.hidden><a href=\"\" role=link class=thumb-close ng-click=\"removeContentFx(content.id, $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/sp.png class=img-responsive ng-if=\"!content.thumb && content.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/od.png class=img-responsive ng-if=\"!content.thumb && content.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/gd.png class=img-responsive ng-if=\"!content.thumb && content.type == \'GoogleDriveC\'\"><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' || content.isCompleted == 0\" ng-src=assets/images/default/{{content.thumb}}_selected.png class=\"img-responsive center-block\"><!-- Images --> <a ng-if=\"content.type == \'Image\'\" href=\"\" role=button ng-click=fbGalleryFx($index);><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Youtube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\'\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{cDetailBucket + content.thumb}}\" class=\"img-responsive center-block\"> </a><span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{content.label}}</div><div class=form-inline><div class=form-group><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number class=\"form-control input-sm\" ng-model=content.duration min=1></div><div class=\"form-group text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</div><div class=\"fullScreen text-left\" ng-if=\"content.type == \'Video\'\"><label class=noMarB ng-if=\"content.type == \'Video\'\"><input type=checkbox ng-model=content.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && contentCount.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"contentCount.length > 0 && (f45Data.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=f45SaveFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cm.label.32\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"f45SaveFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'height\'\" aria-live=polite role=status>{{\'cl.widget.wf45.m1\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45ContentTile.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.11\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.11.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\'); getTileList(); tilePreviewFx();\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=f45SaveFx(1);><span class=badge>2</span>{{\'cm.label.32\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=\"detailLoading && tileLoading\"><div class=\"row noMarR\" ng-if=\"!detailLoading && !tileLoading\"><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=tileType>{{\'cl.widget.wf45.11.2\' | translate}}</label><select id=tileType class=form-control ng-change=tilePreviewFx(); ng-model=f45Data.settings.tileType ng-options=\"tile.label for tile in tileList track by tile.id\" aria-label=\"{{\'cl.widget.wf45.11.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.11.2\' | translate}}\"><option value=\"\">{{\'fl.p_cfl.label.25.1\' | translate}}</option></select></div></div><div class=col-xs-1></div><div class=col-xs-4 ng-if=f45Data.settings.tileType><label>{{\'fl.p_cfl.label.25\' | translate}}</label><div><img alt=\"\" ng-if=!tileImg.thumb src=assets/images/default/incomplete.png class=\"img-responsive center-block img-incomplete pull-left\"> <a ng-href=\"{{cDetailBucket + tileImg.thumb + \'?\' + tileImg.thumbV}}\" role=link fancyboxable=fbTitleInside caption={{tileImg.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + tileImg.thumb + thumbBigParam + \'&\' + tileImg.thumbV}}\" class=\"img-responsive center-block pull-left\"></a></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT10\"><div class=col-xs-3><label>{{\'cl.widget.wf45.11.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.lBg}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.lBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lb=true\" readonly aria-label=\"{{\'cl.widget.wf45.11.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.11.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.lBg selected-type=f45Data.ctype.lBg ng-if=colorPicker.lb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.cm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.c></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=size>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=size class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT10\"><div class=col-xs-3><label for=lPosition>{{\'cl.widget.wf45.11.5\' | translate}}</label><select id=lPosition class=form-control ng-model=f45Data.settings.p aria-label=\"{{\'cl.widget.wf45.11.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.11.5\' | translate}}\"><option value=t>{{\'cl.widget.count.4.1\' | translate}}</option><option value=r>{{\'cl.widget.count.4.2\' | translate}}</option><option value=b>{{\'cl.widget.count.4.3\' | translate}}</option><option value=l>{{\'cl.widget.count.4.4\' | translate}}</option></select></div><div class=col-xs-3 ng-if=\"f45Data.settings.p == \'r\' || f45Data.settings.p == \'l\'\"><label for=lWidth>{{\'cl.widget.wf45.11.6\' | translate}}</label><input type=number id=lWidth class=form-control ng-model=f45Data.settings.w min=1 aria-label=\"{{\'cl.widget.wf45.11.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.11.6\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\" class=col-xs-12><div class=row><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a aria-label=crossAvlSearch href=\"\" role=button class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div ng-class=\"{\'noMarB\': auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{quadHeight}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=contentLibrary.info.sp class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=contentLibrary.info.od class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=contentLibrary.info.gd class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=!contentLibraryLoading element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{contentCount = (f45Data.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\"> <a aria-label=crossSelSearch href=\"\" role=button class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <span ng-if=f45Data.content>[ {{contentCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{selectedHeight}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && f45Data.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback()><li ng-repeat=\"content in f45Data.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=sortable-item ng-if=!content.hidden><a href=\"\" role=link class=thumb-close ng-click=\"removeContentFx(content.id, $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/sp.png class=img-responsive ng-if=\"!content.thumb && content.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/od.png class=img-responsive ng-if=\"!content.thumb && content.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/gd.png class=img-responsive ng-if=\"!content.thumb && content.type == \'GoogleDriveC\'\"><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' || content.isCompleted == 0\" ng-src=assets/images/default/{{content.thumb}}_selected.png class=\"img-responsive center-block\"><!-- Images --> <a ng-if=\"content.type == \'Image\'\" href=\"\" role=button ng-click=fbGalleryFx($index);><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Youtube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\'\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{cDetailBucket + content.thumb}}\" class=\"img-responsive center-block\"> </a><span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{content.label}}</div><div class=form-inline><div class=form-group><span class=valign-inherit>{{\'d.label.10\' | translate}}:</span> <input type=type class=\"wlAuto form-control input-sm\" ng-model=content.cLabel></div><div class=\"form-group text-ellipsis text-left w100 marT5\"><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number class=\"form-control input-sm duration\" ng-model=content.duration min=1> <span class=\"text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</span></div><div class=\"fullScreen text-left\" ng-if=\"content.type == \'Video\'\"><label class=noMarB ng-if=\"content.type == \'Video\'\"><input type=checkbox ng-model=content.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && contentCount.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"contentCount.length > 0 && (f45Data.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx(); getTileList(); tilePreviewFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=f45SaveFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cm.label.32\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"f45SaveFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'lWidth\'\" aria-live=polite role=status>{{\'cl.widget.wf45.m6\' | translate}}</div><div ng-if=\"errType==\'eTile\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.13\' | translate}}</div><div ng-if=\"errType==\'tile\'\" aria-live=polite role=status>{{\'fl.p_cfl.msg.12\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45CountdownCircle.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.2\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.2.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=duration>{{\'cm.label.49\' | translate}}</label><div class=form-inline><div class=input-group><input type=number id=duration class=form-control ng-model=f45Data.settings.d min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.barBg, opacity:f45Data.settings.barBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.barBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bb=true\" readonly aria-label=\"{{\'cl.widget.wf45.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.7\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.barBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.barBg selected-type=f45Data.ctype.barBg is-alpha=true selected-alpha=f45Data.settings.barBga ng-if=colorPicker.bb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.f><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.fill}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.fill | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.f=true\" readonly aria-label=\"{{\'cl.widget.wf45.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.fill selected-type=f45Data.ctype.fill ng-if=colorPicker.f></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=fontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=fontSize class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=strokeSize>{{\'cl.widget.wf45.19\' | translate}}</label><input type=number id=strokeSize class=form-control ng-model=f45Data.settings.st min=1 aria-label=\"{{\'cl.widget.wf45.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.19\' | translate}}\"></div><div class=col-xs-3><label>&nbsp;</label><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=f45Data.settings.rc role=checkbox><label></label>{{\'cl.widget.wf45.20\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=f45Data.settings.gl role=checkbox><label></label>{{\'cl.widget.wf45.21\' | translate}}</label></div></div></div><div class=\"row marT5\" ng-if=f45Data.settings.gl><div class=col-xs-3><label>{{\'cl.widget.wf45.22\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.gc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.glc}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.glc | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.gc=true\" readonly aria-label=\"{{\'cl.widget.wf45.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.22\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.glc selected-type=f45Data.ctype.glc ng-if=colorPicker.gc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=hOff>{{\'cl.widget.wf45.23\' | translate}}</label><input type=number id=hOff class=form-control ng-model=f45Data.settings.hoff aria-label=\"{{\'cl.widget.wf45.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.23\' | translate}}\"></div><div class=col-xs-3><label for=vOff>{{\'cl.widget.wf45.24\' | translate}}</label><input type=number id=vOff class=form-control ng-model=f45Data.settings.voff aria-label=\"{{\'cl.widget.wf45.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.24\' | translate}}\"></div><div class=col-xs-3><label for=blur>{{\'cl.widget.wf45.25\' | translate}}</label><input type=number id=blur class=form-control ng-model=f45Data.settings.blr min=0 aria-label=\"{{\'cl.widget.wf45.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.25\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45Hydrate.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.3\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.3.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=titleTxt>{{\'cl.widget.count.8\' | translate}}</label><input type=text id=titleTxt class=form-control ng-model=f45Data.settings.txt maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.pw.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.icColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.icColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.pw.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.icColor selected-type=f45Data.ctype.icColor ng-if=colorPicker.c></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=settingsP>{{\'cl.widget.count.4\' | translate}}</label><select id=settingsP class=form-control ng-model=f45Data.settings.p aria-label=\"{{\'cl.widget.count.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.4\' | translate}}\"><option value=t>{{\'fl.p_cfl.label.20\' | translate}}</option><option value=b>{{\'fl.p_cfl.label.22\' | translate}}</option></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45MoveStation.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.4\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.4.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=txt>{{\'cl.widget.count.8\' | translate}}</label><input type=text id=txt class=form-control ng-model=f45Data.settings.txt maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.pw.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.icColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.icColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.pw.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.icColor selected-type=f45Data.ctype.icColor ng-if=colorPicker.c></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=size>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=size class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=placement>{{\'cl.widget.count.4\' | translate}}</label><select id=placement class=form-control ng-model=f45Data.settings.p aria-label=\"{{\'cl.widget.count.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.4\' | translate}}\"><option value=t>{{\'fl.p_cfl.label.20\' | translate}}</option><option value=b>{{\'fl.p_cfl.label.22\' | translate}}</option></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45ProgressBar.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.5\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.5.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=duration>{{\'cm.label.49\' | translate}}</label><div class=form-inline><div class=input-group><input type=number id=duration class=form-control ng-model=f45Data.settings.d min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cl.widget.wf45.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cl.widget.wf45.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.7\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.fill}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.fill | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.wf45.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.fill selected-type=f45Data.ctype.fill ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=st>{{\'cl.widget.wf45.19\' | translate}}</label><input type=number id=st class=form-control ng-model=f45Data.settings.st min=1 aria-label=\"{{\'cl.widget.wf45.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.19\' | translate}}\"></div><div class=col-xs-3><label>&nbsp;</label><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=f45Data.settings.rc role=checkbox><label></label>{{\'cl.widget.wf45.20\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=f45Data.settings.gl role=checkbox><label></label>{{\'cl.widget.wf45.21\' | translate}}</label></div></div></div><div class=\"row marT5\" ng-if=f45Data.settings.gl><div class=col-xs-3><label>{{\'cl.widget.wf45.22\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.gc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.glc}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.glc | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.gc=true\" readonly aria-label=\"{{\'cl.widget.wf45.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.22\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.glc selected-type=f45Data.ctype.glc ng-if=colorPicker.gc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=hoff>{{\'cl.widget.wf45.23\' | translate}}</label><input type=number id=hoff class=form-control ng-model=f45Data.settings.hoff aria-label=\"{{\'cl.widget.wf45.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.23\' | translate}}\"></div><div class=col-xs-3><label for=voff>{{\'cl.widget.wf45.24\' | translate}}</label><input type=number id=voff class=form-control ng-model=f45Data.settings.voff aria-label=\"{{\'cl.widget.wf45.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.24\' | translate}}\"></div><div class=col-xs-3><label for=blr>{{\'cl.widget.wf45.25\' | translate}}</label><input type=number id=blr class=form-control ng-model=f45Data.settings.blr min=0 aria-label=\"{{\'cl.widget.wf45.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.25\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45ProgressBarWithBreak.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.6\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.6.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=\"form-group bg-light pad10\"><div class=row><div class=col-xs-5><label for=curDataType>{{\'cm.label.69\' | translate}}</label><select class=form-control id=curDataType ng-model=curData.type aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=Bar>{{\'cl.widget.wf45.6.2\' | translate}}</option><option value=Break>{{\'cl.widget.wf45.6.3\' | translate}}</option><option value=Hydrate>{{\'cl.widget.wf45.6.4\' | translate}}</option></select></div><div class=col-xs-5><label for=curDataD>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.75\' | translate}})</span></label><input type=number id=curDataD class=form-control ng-model=curData.d min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div><div class=col-xs-2><label>&nbsp;</label><button type=button role=button class=\"btn btn-primary btn-block\" ng-click=addFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cm.btn.19\' | translate}}</button></div></div><div class=\"errMsg pull-right marT10\" ng-if=addErr aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div class=clearfix></div></div><div class=form-group ng-if=\"f45Data.list.length > 0\"><div class=\"table table-md\"><div class=\"row th\"><div class=col-xs-5>{{\'cm.label.69\' | translate}}</div><div class=col-xs-4>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.75\' | translate}})</span></div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=sortable-containment sortable callback=sortCallback()><div class=\"row sortable-item item-row\" ng-repeat=\"item in f45Data.list\" data-id={{item.id}}><div class=col-xs-5><div class=\"codeType text-ellipsis-wrap\" ng-show=!item.show>{{item.type}}</div><select id=type class=\"form-control input-sm\" value={{item.type}} ng-keyup=inputCallbackFx($event); ng-blur=inputCallbackFx($event); ng-show=item.show><option value=Bar data-select=\"{{item.type == \'Bar\'?true:false}}\">{{\'cl.widget.wf45.6.2\' | translate}}</option><option value=Break data-select=\"{{item.type == \'Break\'?true:false}}\">{{\'cl.widget.wf45.6.3\' | translate}}</option><option value=Hydrate data-select=\"{{item.type == \'Hydrate\'?true:false}}\">{{\'cl.widget.wf45.6.4\' | translate}}</option></select></div><div ng-class=\"item.show?\'col-xs-4\':\'col-xs-5\'\"><div class=\"codeDuration text-ellipsis-wrap\" ng-show=!item.show>{{item.d}}</div><input type=number id=duration class=\"form-control input-sm\" value={{item.d}} min=1 ng-keyup=inputCallbackFx($event); ng-blur=inputCallbackFx($event); ng-show=item.show></div><div class=text-right ng-class=\"item.show?\'col-xs-3\':\'col-xs-2\'\"><div class=\"btn-group btn-group-sm\" ng-if=item.show><button type=button role=button class=\"btn btn-success\" ng-click=saveItemFx($event); ng-disabled=!item.d>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"cancelItemFx($event, item.show = !item.show);\">{{\'cm.btn.9\' | translate}}</button></div><span ng-if=!item.show><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx($event); item.show = !item.show\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deleteOpen(item.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></span></div></div></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.f><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.fill}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.fill | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.f=true\" readonly aria-label=\"{{\'cl.widget.wf45.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.fill selected-type=f45Data.ctype.fill ng-if=colorPicker.f></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.6.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bk><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.break}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.break | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bk=true\" readonly aria-label=\"{{\'cl.widget.wf45.6.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.6.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.break selected-type=f45Data.ctype.break ng-if=colorPicker.bk></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45Stay.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.13\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.13.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=txt>{{\'cl.widget.count.8\' | translate}}</label><input type=text id=txt class=form-control ng-model=f45Data.settings.txt maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=form-group><label for=dType>{{\'cl.widget.cm.9\' | translate}}</label><select id=dType class=form-control ng-model=f45Data.settings.dType aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=h>{{\'cl.widget.wf45.13.2\' | translate}}</option><option value=hf>{{\'cl.widget.wf45.13.5\' | translate}}</option><option value=hwh>{{\'cl.widget.wf45.13.3\' | translate}}</option><option value=hwt>{{\'cl.widget.wf45.13.4\' | translate}}</option></select></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.pw.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.icColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.icColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.pw.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.icColor selected-type=f45Data.ctype.icColor ng-if=colorPicker.c></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=size>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=size class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=placement>{{\'cl.widget.count.4\' | translate}}</label><select id=placement class=form-control ng-model=f45Data.settings.p aria-label=\"{{\'cl.widget.count.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.4\' | translate}}\"><option value=t>{{\'fl.p_cfl.label.20\' | translate}}</option><option value=b>{{\'fl.p_cfl.label.22\' | translate}}</option></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45Story.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.14\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.14.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=f45SaveFx(1);><span class=badge>2</span>{{\'cl.widget.wf45.15\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\" class=col-xs-12><header class=\"panel-inner-tab marB10\"><a href=\"\" role=link ng-repeat=\"screen in f45Data.screens track by $index\" ng-class=\"{\'selected\':subTab==$index+1}\" ng-click=\"subTabFx($index+1); searchText=\'\'; selectedSearchText=\'\'\">{{\'cl.widget.wf45.16.5\' | translate:{no:$index+1 } }}</a></header><div class=row><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cl.widget.wf45.15.1\' | translate}}</div><div ng-class=\"{\'noMarB\':auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{tabView?(quadHeight-50):(quadHeight-25)}}px><img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><ul class=\"list-inline thumb-list\" ng-if=\"!templatesLoading && templateList.length > 0\" element-height=tabView?(quadHeight-50):(quadHeight-25)><ng-template-listing class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"templateList | filter:searchText\"></ng-template-listing></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!templatesLoading && templateList.length == 0\">{{\'t.msg.23\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{templateCount = (curScreen.scene | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cl.widget.wf45.15.2\' | translate}} <span ng-if=curScreen.scene>[ {{templateCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{tabView?(selectedHeight-50):(selectedHeight-25)}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && curScreen.scene.length > 0 || (curScreen.scene | customSearch:{key:selectedSearchText, module:\'cl\'}).length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback()><li ng-repeat=\"cl in curScreen.scene | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=sortable-item ng-if=!cl.hidden><a href=\"\" role=link class=thumb-close ng-click=\"closeFilteredFx(cl.id, $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{cl.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000 tooltip-enable=cl.path><!-- Template --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><span class=thumb-icon><span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"cl.type !== \'Folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{cl.label}}</div><div class=form-inline ng-hide=\"cl.extn == \'Music Choice\' || schedule.info.ls==3\"><div class=\"form-group text-ellipsis text-left w100\"><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number class=\"form-control input-sm duration\" ng-model=cl.duration min=1 ng-keypress=filterValue($event)> <span class=\"text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</span></div></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && templateCount.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"templateCount.length > 0 && (curScreen.scene | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=f45SaveFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.wf45.15\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"f45SaveFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'durationEmpty\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/f45Work.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wf45.12\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wf45.12.1\' | translate}} &nbsp; <span ng-if=f45Data.label>[ {{f45Data.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=f45Data.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=txt>{{\'cl.widget.count.8\' | translate}}</label><input type=text id=txt class=form-control ng-model=f45Data.settings.txt maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':f45Data.settings.bg, opacity:f45Data.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{f45Data.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.bg selected-type=f45Data.ctype.bg is-alpha=true selected-alpha=f45Data.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.pw.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.icColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.icColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.pw.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.icColor selected-type=f45Data.ctype.icColor ng-if=colorPicker.c></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.count.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':f45Data.settings.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"f45Data.settings.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cl.widget.count.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.count.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=f45Data.settings.text selected-type=f45Data.ctype.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=font class=form-control ng-model=f45Data.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=size>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=size class=form-control ng-model=f45Data.settings.size min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=placement>{{\'cl.widget.count.4\' | translate}}</label><select id=placement class=form-control ng-model=f45Data.settings.p><option value=t>{{\'fl.p_cfl.label.20\' | translate}}</option><option value=b>{{\'fl.p_cfl.label.22\' | translate}}</option></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=f45Data.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=f45Data.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=f45SaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/facebook.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fb.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.fb.2\' | translate}} &nbsp; <span ng-if=facebook.label>[ {{facebook.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList ng-if=\"facebook.dType!=\'v\' && !detailLoading\"><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=facebookFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=\"height:{{facebook.dType==\'v\'?winH+49:winH}}px\"><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label for=label>{{\'cl.label.1\' | translate}}</label></div><div class=marT5><input type=text id=label class=form-control ng-model=facebook.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=facebook.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.fb.5\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=facebook.dType value=m><label></label>{{\'cl.widget.fb.6\' | translate}}</label><label class=noMarB><input type=radio role=radio name=dTypeOpt ng-model=facebook.dType value=v ng-change=\"dTypeChange(\'v\')\"><label></label>{{\'cl.widget.fb.7\' | translate}}</label></div></div><div ng-if=\"facebook.dType==\'v\'\"><div class=form-group><label for=url>{{\'cl.widget.fb.4\' | translate}}</label><input type=text id=url class=form-control ng-model=facebook.url maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.fb.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fb.4\' | translate}}\"></div><div class=form-group><label><input type=checkbox ng-model=settingsV.mute role=checkbox><label></label>{{\'cm.label.67\' | translate}}</label></div></div></div><div class=col-xs-8><div class=form-group ng-if=\"facebook.dType==\'t\'\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebook.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=facebook.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"facebook.settings.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=facebook.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebook.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebook.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=facebook.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"facebook.settings.hTextOpt==\'c\'\"><input type=text id=headerText class=form-control ng-model=facebook.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"facebook.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebook.settings.headerBg, opacity:facebook.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebook.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.headerBg selected-type=facebook.ctype.headerBg is-alpha=true selected-alpha=facebook.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebook.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.headerText selected-type=facebook.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=facebook.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebook.settings.bg, opacity:facebook.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebook.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.bg selected-type=facebook.ctype.bg is-alpha=true selected-alpha=facebook.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=facebook.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=col-xs-4><label for=tSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=tSize class=form-control ng-model=facebook.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebook.settings.rowBg, opacity:facebook.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebook.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.rowBg selected-type=facebook.ctype.rowBg is-alpha=true selected-alpha=facebook.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebook.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.titleText selected-type=facebook.ctype.titleText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=facebook.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebook.settings.altBg, opacity:facebook.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebook.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.altBg selected-type=facebook.ctype.altBg is-alpha=true selected-alpha=facebook.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebook.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebook.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebook.settings.altTitleText selected-type=facebook.ctype.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=altRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altRowFont class=form-control ng-model=facebook.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=facebook.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=facebook.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.fb.8\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=pListShow>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{pListShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button></div></div><div class=form-group ng-if=pListShow><label for=page>{{\'cl.widget.fb.9\' | translate}}</label><select id=page class=form-control ng-model=facebook.page ng-options=\"page.label for page in pList track by page.id\" aria-label=\"{{\'cl.widget.fb.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fb.9\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.fb.9.1\' | translate}}</option></select></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\' && facebook.dType!=\'v\'\" ng-click=facebookFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"facebookFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\' || facebook.dType==\'v\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.fb.m1\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.fb.m2\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'pList\'\" aria-live=polite role=status>{{\'cl.widget.fb.m3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/facebookWorkplace.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fwp.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.fwp.2\' | translate}} &nbsp; <span ng-if=facebookWp.label>[ {{facebookWp.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label for=label>{{\'cl.label.1\' | translate}}</label></div><div class=marT5><input type=text id=label class=form-control ng-model=facebookWp.label maxlength={{inputLimit}} autocomplete=off focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=facebookWp.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.fb.5\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=facebookWp.dType value=m><label></label>{{\'cl.widget.fb.6\' | translate}}</label></div></div><div class=form-group><div><label for=accessToken>{{\'cl.widget.fwp.4\' | translate}}</label></div><div class=marT5><textarea type=text id=accessToken class=form-control ng-model=facebookWp.accessToken autocomplete=off rows=3 aria-label=\"{{\'cl.widget.fwp.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fwp.4\' | translate}}\"></textarea></div></div><div class=form-group><div><label for=appId>{{\'cl.widget.fwp.6\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\'| translate}})</span></label></div><div class=marT5><input type=text id=appId class=form-control ng-model=facebookWp.appId autocomplete=off aria-label=\"{{\'cl.widget.fwp.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fwp.6\' | translate}}\"></div></div><div class=form-group><label class=noMarB><input type=checkbox ng-model=facebookWp.isAppSecret ng-change=resetGrp(); role=checkbox><label></label>{{\'cl.widget.fwp.7\' | translate}}</label></div><div class=form-group ng-if=facebookWp.isAppSecret><div><label for=appSecret>{{\'cl.widget.fwp.5\' | translate}}</label></div><div class=marT5><input type=password id=appSecret class=form-control ng-model=facebookWp.appSecret autocomplete=off aria-label=\"{{\'cl.widget.fwp.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fwp.5\' | translate}}\"></div></div><div class=form-group><div class=marT5><button type=button role=button id=searchGroupBtn class=\"btn btn-primary\" ng-click=searchGroupFx()>{{\'cm.btn.48\' | translate}}</button></div></div><div class=form-group ng-if=\"groupList.length>0\"><label for=wGroupSel>{{\'cl.widget.fwp.8\' | translate}}</label><select id=wGroupSel class=form-control ng-model=facebookWp.wGroupSel ng-options=\"group.name for group in groupList track by group.id\" aria-label=\"{{\'cl.widget.fwp.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fwp.8\' | translate}}\"><option value=\"\">{{\'cl.widget.fwp.8\' | translate}}</option></select></div></div><div class=col-xs-8><div class=form-group ng-if=\"facebookWp.dType==\'t\'\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebookWp.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=facebookWp.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"facebookWp.settings.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=facebookWp.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebookWp.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=facebookWp.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=facebookWp.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"facebookWp.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=facebookWp.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"facebookWp.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebookWp.settings.headerBg, opacity:facebookWp.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebookWp.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.headerBg selected-type=facebookWp.ctype.headerBg is-alpha=true selected-alpha=facebookWp.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebookWp.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.headerText selected-type=facebookWp.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=facebookWp.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebookWp.settings.bg, opacity:facebookWp.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebookWp.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.bg selected-type=facebookWp.ctype.bg is-alpha=true selected-alpha=facebookWp.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=facebookWp.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=col-xs-4><label for=tSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=tSize class=form-control ng-model=facebookWp.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebookWp.settings.rowBg, opacity:facebookWp.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebookWp.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.rowBg selected-type=facebookWp.ctype.rowBg is-alpha=true selected-alpha=facebookWp.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebookWp.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.titleText selected-type=facebookWp.ctype.titleText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=facebookWp.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':facebookWp.settings.altBg, opacity:facebookWp.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{facebookWp.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.altBg selected-type=facebookWp.ctype.altBg is-alpha=true selected-alpha=facebookWp.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':facebookWp.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"facebookWp.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=facebookWp.settings.altTitleText selected-type=facebookWp.ctype.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.10\' | translate}}</label><select id=altRowFont class=form-control ng-model=facebookWp.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=facebookWp.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=facebookWp.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"facebookWpFx(\'save\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.fb.m1\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.fb.m2\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'pList\'\" aria-live=polite role=status>{{\'cl.widget.fb.m3\' | translate}}</div><div ng-if=\"errType==\'accessToken\'\" aria-live=polite role=status>{{\'cl.widget.fwp.m1\' | translate}}</div><div ng-if=\"errType==\'appSecret\'\" aria-live=polite role=status>{{\'cl.widget.fwp.m2\' | translate}}</div><div ng-if=\"errType==\'group\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m3\' | translate}}</div><div ng-if=\"errType==\'noGrp\'\" aria-live=polite role=status>{{\'u.p_invite.6\' | translate}}</div><div ng-if=\"errType==\'invalid\'\" aria-live=polite role=status>{{\'cl.widget.fwp.m4\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/fifa.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>FIFA World Cup</h1><h1 ng-if=!tabView>{{\'cl.widget.fsc.2\' | translate}} &nbsp; <span ng-if=fifa.label>[ {{fsChrome.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=fifa.label maxlength={{inputLimit}} focus-me=true></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=fifa.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=fifa.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=fifaFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/fillerContent.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.fc.2\' | translate}} &nbsp; <span ng-if=fillerContent.label>[ {{fillerContent.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=fillerContentFx(1);><span class=badge>2</span>{{\'cm.label.32\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input id=label type=text ng-model=fillerContent.label class=form-control maxlength={{inputLimit}} focus-me=true></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.fc.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio ng-model=fillerContent.settings.pbs name=pbsOpt value=r><label></label>{{\'cl.widget.fc.3.1\' | translate}}</label><label class=\"noMarB marRL10\"><input type=radio role=radio ng-model=fillerContent.settings.pbs name=pbsOpt value=o><label></label>{{\'cl.widget.fc.3.2\' | translate}}</label><label class=noMarB ng-if=auth.upermissions.dmb_c><input type=radio role=radio ng-model=fillerContent.settings.pbs name=pbsOpt value=s><label></label>{{\'cl.widget.sp.3\' | translate}}</label></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=fillerContent.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=fillerContent.activePeriod></ng-active-period></div></div></div><div class=col-xs-12 ng-if=\"selectedT==\'2\'\"><div class=row><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=\"advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)\" class=\"col-xs-12 noPad marB10\"></advanced-search>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown><a href=\"\" id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'w-fc\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link aria-label=crossAvlTxt class=text-danger ng-show=search.text.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div ng-class=\"{\'noMarB\': auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{quadHeight}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"!contentLibraryLoading && !advSearch && (folderList.length > 0 || contentList.length > 0)\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=contentLibrary.info.sp class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=contentLibrary.info.od class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=contentLibrary.info.gd class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'t\'\" element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'l\'\" element-height=quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{fillerContentCount = (fillerContent.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link aria-label=crossSelTxt class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <span ng-if=fillerContent.content>[ {{fillerContentCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{selectedHeight}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && fillerContent.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback() ng-if=\"auth.upreferences.contentView == \'t\'\"><li ng-repeat=\"cl in fillerContent.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=sortable-item ng-if=!cl.hidden><a href=\"\" role=link class=thumb-close ng-click=\"removeContentFx(cl.id, $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner ng-class=\"{\'overflow-hidden\':cl.isblur}\" uib-tooltip-html=\"cl.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{cl.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/sp.png class=img-responsive ng-if=\"!cl.thumb && cl.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/od.png class=img-responsive ng-if=\"!cl.thumb && cl.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/gd.png class=img-responsive ng-if=\"!cl.thumb && cl.type == \'GoogleDriveC\'\"><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && !cl.ss\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png?v{{timestamp}}\" class=\"img-responsive center-block img-widget\"> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && cl.ss\" ng-href=\"{{cDetailBucket + cl.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a ng-if=\"cl.type == \'Image\'\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Youtube & Vimeo --> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}}><img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\"><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':cl.isblur}\"> </a><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\" ng-src=\"{{thumbHost + tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted && cl.type != \'template\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/sp.png ng-if=\"cl.type == \'SharePointC\'\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/od.png ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\" class=img-responsive> <img alt=\"\" ng-src=assets/images/default/thumbs/lg/gd.png ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\" class=img-responsive> <span class=thumb-icon><span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.ss class=webpage aria-hidden=true></span> <span ng-if=\"cl.type !== \'Folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{cl.label}}</div><div class=form-inline><div class=form-group><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number class=\"form-control input-sm duration\" ng-model=cl.duration min=1></div><div class=\"form-group text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</div><div class=\"fullScreen text-left\" ng-if=\"cl.type == \'Video\'\"><label class=noMarB ng-if=\"cl.type == \'Video\'\"><input type=checkbox ng-model=cl.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul><ul class=\"table table-md list-unstyled sortable-containment\" sortable callback=sortCallback() containment=\"\'parent\'\" ng-if=\"auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-5>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></div><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in fillerContent.content | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-if=!cl.hidden><div class=\"col-xs-5 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"><!-- <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=\"assets/images/default/processing_selected.png\" class=\"img-responsive center-block\"> --><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=col-xs-3>{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div><div class=col-xs-2><input type=number class=\"form-control input-sm duration\" ng-model=cl.duration min=1></div><div class=\"col-xs-2 text-right\"><span class=\"text-left marR10\" ng-hide=\"cl.extn == \'Music Choice\'\"><label class=noMarB ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\'\"><input type=checkbox ng-model=cl.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></span><a href=\"\" class=text-danger ng-click=\"removeContentFx(cl.id, $index);\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && fillerContentCount.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"fillerContentCount.length > 0 && (fillerContent.content | filter:{label:selectedSearchText}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=fillerContentFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.32\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"fillerContentFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'playback\'\" aria-live=polite role=status>{{\'cl.widget.fc.m1\' | translate}}</div><div ng-if=\"errType==\'durationEmpty\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/flightSchedule.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fs.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.fs.2\' | translate}} &nbsp; <span ng-if=flight.label>[ {{flight.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=flight.labelOpt value=a><label></label>{{\'cl.widget.fs.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=flight.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"flight.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=flight.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR10 noMarB\"><input type=radio role=radio name=display ng-model=flight.dType value=Arrival><label></label>{{\'cl.widget.fs.5\' | translate}}</label><label class=noMarB><input type=radio role=radio name=display ng-model=flight.dType value=Departure><label></label>{{\'cl.widget.fs.6\' | translate}}</label></div></div><div class=form-group><label for=airport>{{\'cl.widget.fs.4\' | translate}}</label><input type=text id=airport class=form-control ng-model=flight.airport uib-typeahead=\"ac.airport for ac in airportCodes | filter:$viewValue | limitTo:8\" typeahead-on-select=onSelect($model) typeahead-min-length=3 focus-me=true aria-label=\"{{\'cl.widget.fs.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.4\' | translate}}\"></div></div><div class=col-xs-9><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':flight.settings.bg, opacity:flight.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{flight.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.bg selected-type=flight.ctype.bg is-alpha=true selected-alpha=flight.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':flight.settings.headerBg, opacity:flight.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{flight.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.headerBg selected-type=flight.ctype.headerBg is-alpha=true selected-alpha=flight.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.headerText selected-type=flight.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=flight.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':flight.settings.rowBg, opacity:flight.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{flight.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.rowBg selected-type=flight.ctype.rowBg is-alpha=true selected-alpha=flight.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=flight.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-4><label for=rowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rowSize class=form-control ng-model=flight.settings.rowSize min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':flight.settings.altBg, opacity:flight.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{flight.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.altBg selected-type=flight.ctype.altBg is-alpha=true selected-alpha=flight.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=altFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altFont class=form-control ng-model=flight.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div><div class=col-xs-4><label for=altSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=altSize class=form-control ng-model=flight.settings.altSize min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.flight}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.flight | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fc=true\" readonly aria-label=\"{{\'cl.widget.fs.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.flight selected-type=flight.ctype.flight ng-if=colorPicker.fc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.an><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.airline}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.airline | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.an=true\" readonly aria-label=\"{{\'cl.widget.fs.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.airline selected-type=flight.ctype.airline ng-if=colorPicker.an></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.city}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.city | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly aria-label=\"{{\'cl.widget.fs.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.city selected-type=flight.ctype.city ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.18\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.time}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.time | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.fs.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.18\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.time selected-type=flight.ctype.time ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.19\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.te><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.terminal}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.terminal | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.te=true\" readonly aria-label=\"{{\'cl.widget.fs.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.19\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.terminal selected-type=flight.ctype.terminal ng-if=colorPicker.te></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.20\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sd><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.statusDefault}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.statusDefault | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sd=true\" readonly aria-label=\"{{\'cl.widget.fs.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.20\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.statusDefault selected-type=flight.ctype.statusDefault ng-if=colorPicker.sd></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.os><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.ontimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.ontimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.os=true\" readonly aria-label=\"{{\'cl.widget.fs.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.11\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.ontimeText selected-type=flight.ctype.ontime ng-if=colorPicker.os></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ca><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.canceledText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.canceledText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ca=true\" readonly aria-label=\"{{\'cl.widget.fs.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.canceledText selected-type=flight.ctype.canceled ng-if=colorPicker.ca></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.de><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.delayedText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.delayedText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.de=true\" readonly aria-label=\"{{\'cl.widget.fs.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.delayedText selected-type=flight.ctype.delayed ng-if=colorPicker.de></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ad><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':flight.settings.arrivedText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"flight.settings.arrivedText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ad=true\" readonly aria-label=\"{{\'cl.widget.fs.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=flight.settings.arrivedText selected-type=flight.ctype.arrived ng-if=colorPicker.ad></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=flight.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=flight.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=flightFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'airport\'\" aria-live=polite role=status>{{\'cl.widget.fs.m1\' | translate}}</div><div ng-if=\"errType==\'rowSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'altSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.18\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/freeForm.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>Free Form</h1><h1 ng-if=!tabView>Edit Free Form Widget &nbsp; <span ng-if=freeForm.label>[ {{freeForm.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);><span class=badge>1</span>Settings</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=tabFx(2);><span class=badge>2</span>Edit Format</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=freeForm.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=\"form-group col-xs-6\"><label for=frameW>Frame width</label><input type=number id=frameW class=form-control ng-model=freeForm.frameW min=1 aria-label=\"Frame width\" aria-labelledby=\"Frame width\"></div><div class=\"form-group col-xs-6\"><label for=frameH>Frame height</label><input type=number id=frameH class=form-control ng-model=freeForm.frameH min=1 aria-label=\"Frame height\" aria-labelledby=\"Frame height\"></div></div><div class=form-group><label>Background image</label><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">Browse...</button> <input type=file file-model options=\"{size:8390000, format:[\'imgOnly\'], callback:true}\" accept=image/* data-file> <input type=text class=form-control ng-model=freeForm.bgImg.name readonly aria-label=\"Background image\" aria-labelledby=\"Background image\"></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=freeForm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=freeForm.activePeriod></ng-active-period></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7>Edit Format</div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=tabFx(2);>{{\'cm.btn.12\' | translate}}: Edit Format<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=freeFormFx(); ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/fsChrome.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.fsc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.fsc.2\' | translate}} &nbsp; <span ng-if=fsChrome.label>[ {{fsChrome.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=fsChrome.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=fsChrome.url maxlength=1000 placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\" aria-placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=fsChrome.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=fsChrome.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=fsChromeFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/ftp.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>FTP</h1><h1 ng-if=!tabView>Edit FTP Widget &nbsp; <span ng-if=ftp.label>[ {{ftp.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=ftp.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=host>Host name</label><input type=text id=host class=form-control ng-model=ftp.host aria-label=\"Host name\" aria-labelledby=\"Host name\"></div><div class=form-group><label for=user>FTP user name</label><input type=text id=user class=form-control ng-model=ftp.user aria-label=\"FTP user name\" aria-labelledby=\"FTP user name\"></div><div class=form-group><label for=pass>FTP password</label><input type=password id=pass class=form-control ng-model=ftp.pass aria-label=\"FTP password\" aria-labelledby=\"FTP password\"></div><div class=form-group><label for=cPass>Confirm FTP password</label><input type=password id=cPass class=form-control ng-model=ftp.cPass aria-label=\"Confirm FTP password\" aria-labelledby=\"Confirm FTP password\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=ftp.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=ftp.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=ftpFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'allFields\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'pass\'\" aria-live=polite role=status>These passwords don\'t match.</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/gCalendar.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.gc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.gc.2\' | translate}} &nbsp; <span ng-if=gCalendar.label>[ {{gCalendar.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-n tab-au tab-ss\" aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-n role=tab aria-selected=true><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-au role=tab aria-selected=false><a href=\"\" role=link ng-click=gCalendarFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-ss role=tab aria-selected=false><a href=\"\" role=link ng-click=gCalendarFx(2);><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-8><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=gCalendar.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=typeOpt ng-model=gCalendar.dType value=r><label></label>{{\'cl.widget.oc.4\' | translate}}</label><label class=marR10><input type=radio role=radio name=typeOpt ng-model=gCalendar.dType value=wc><label></label>{{\'cl.widget.oc.5\' | translate}}</label><label><input type=radio role=radio name=typeOpt ng-model=gCalendar.dType value=ae><label></label>{{\'cl.widget.oc.35\' | translate}}</label></div><div class=\"form-group marT5\" ng-if=\"gCalendar.dType == \'r\'\"><label for=roomboard>{{\'cl.widget.oc.4.1\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span> <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.oc.m14\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label><input type=text id=roomboard class=form-control ng-model=gCalendar.roomId aria-label=\"{{\'cl.widget.oc.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.4.1\' | translate}}\"></div><div class=\"form-group marT5\" ng-if=\"gCalendar.dType == \'wc\'\"><div class=\"marT15 marB10\"><label class=noMarB>{{\'cl.widget.oc.5.1\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span> <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.oc.m14\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label><div class=pull-right><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=addRowFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=bdr-top-dashed><div class=table ng-if=\"gCalendar.wallboardList.length > 0\"><div class=\"row th\"><div class=col-xs-5>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-5>{{\'cm.label.47\' | translate}}</div><div class=\"col-xs-2 noPadL text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad><div class=row ng-repeat=\"w in gCalendar.wallboardList\"><div class=col-xs-5><input type=text class=\"form-control input-sm\" ng-model=w.label ng-if=w.edited aria-label=name aria-labelledby=name> <span ng-if=!w.edited>{{w.label}}</span></div><div class=col-xs-5><input type=email class=\"form-control input-sm\" ng-model=w.email ng-if=w.edited aria-label=email aria-labelledby=email> <span ng-if=!w.edited>{{w.email}}</span></div><div class=\"col-xs-2 noPadL text-right\" ng-class=\"{\'marT5\':w.edited}\"><a href=\"\" role=link aria-label=editList class=\"pad2 text-primary\" ng-click=editWallFx($index); ng-if=!w.edited uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link aria-label=removeList class=\"pad2 text-danger\" ng-click=\"confirmOpen($index, w.label, w.email);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"gCalendar.wallboardList.length == 0\">{{\'cl.widget.oc.m5\' | translate}}</div></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"gCalendar.dType == \'r\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsRB.bg, opacity:settingsRB.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsRB.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.bg selected-type=ctypeRB.bg is-alpha=true selected-alpha=settingsRB.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.titleText selected-type=ctypeRB.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=rbTitleFont class=form-control ng-model=settingsRB.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=settingsRB.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.subtitleText selected-type=ctypeRB.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbSubTitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select id=rbSubTitleFont class=form-control ng-model=settingsRB.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubtTitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubtTitleSize class=form-control ng-model=settingsRB.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.timeText selected-type=ctypeRB.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=rbTimeFont class=form-control ng-model=settingsRB.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=settingsRB.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosP class=form-control ng-model=settingsRB.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22.1.2\' | translate}}\" aria-labelledby=\"\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosA class=form-control ng-model=settingsRB.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div><div ng-if=\"gCalendar.dType == \'wc\'\"><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsWB.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsWB.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsWB.rotationOpt == \'c\'\"><input type=number id=wbRotation class=form-control ng-model=settingsWB.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.bg, opacity:settingsWB.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.bg selected-type=ctypeWB.bg is-alpha=true selected-alpha=settingsWB.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWB.header.active><div class=\"flex1 noMarL\"><label for=wbTitle>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=wbTitle class=\"form-control input-sm\" ng-model=settingsWB.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWB.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbTime>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=wbTime class=\"form-control input-sm\" ng-model=settingsWB.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWB.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbRoom>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=wbRoom class=\"form-control input-sm\" ng-model=settingsWB.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWB.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWB.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.headerBg, opacity:settingsWB.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.headerBg selected-type=ctypeWB.headerBg is-alpha=true selected-alpha=settingsWB.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.headerText selected-type=ctypeWB.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wbHeaderFont class=form-control ng-model=settingsWB.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=wbHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wbHeaderSize class=form-control ng-model=settingsWB.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.titleText selected-type=ctypeWB.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altTitleText selected-type=ctypeWB.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=wbTitleFont class=form-control ng-model=settingsWB.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=wbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wbTitleSize class=form-control ng-model=settingsWB.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=settingsWB.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWB.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.timeText selected-type=ctypeWB.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.atm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.atm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altTimeText selected-type=ctypeWB.altTimeText ng-if=colorPicker.atm></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=wbTimeFont class=form-control ng-model=settingsWB.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=settingsWB.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=settingsWB.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWB.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.roomText selected-type=ctypeWB.roomText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ar><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ar=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altRoomText selected-type=ctypeWB.altRoomText ng-if=colorPicker.ar></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wbRoomFont class=form-control ng-model=settingsWB.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=wbRoomSize class=form-control ng-model=settingsWB.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=settingsWB.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.rowBg, opacity:settingsWB.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.rowBg selected-type=ctypeWB.rowBg is-alpha=true selected-alpha=settingsWB.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.altBg, opacity:settingsWB.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altBg selected-type=ctypeWB.altBg is-alpha=true selected-alpha=settingsWB.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=settingsWB.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=settingsWB.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"settingsWB.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosP class=form-control ng-model=settingsWB.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22.1.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.1.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=settingsWB.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=settingsWB.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"settingsWB.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosA class=form-control ng-model=settingsWB.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div><div ng-if=\"gCalendar.dType == \'ae\'\"><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsAE.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsAE.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsAE.rotationOpt == \'c\'\"><input type=number id=aeRotation class=form-control ng-model=settingsAE.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsAE.bg, opacity:settingsAE.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsAE.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.bg selected-type=ctypeAE.bg is-alpha=true selected-alpha=settingsAE.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsAE.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsAE.header.active><div class=\"flex1 noMarL\"><label for=aeTitle>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=aeTitle class=\"form-control input-sm\" ng-model=settingsAE.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsAE.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=arTime>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=arTime class=\"form-control input-sm\" ng-model=settingsAE.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsAE.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=aeRoom>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=aeRoom class=\"form-control input-sm\" ng-model=settingsAE.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsAE.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsAE.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsAE.headerBg, opacity:settingsAE.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsAE.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.headerBg selected-type=ctypeAE.headerBg is-alpha=true selected-alpha=settingsAE.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.headerText selected-type=ctypeAE.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=flex1><label for=aeHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=aeHeaderFont class=form-control ng-model=settingsAE.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=aeHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=aeHeaderSize class=form-control ng-model=settingsAE.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div></div><!-- <div class=\"row marT15\" ng-if=\"settingsAE.header.active\">\r\n                <div class=\"col-xs-3\">\r\n                  <label>{{\'cl.widget.cm.11\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.hb\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span class=\"trBg\"><span ng-style=\"{\'background-color\':settingsAE.headerBg, opacity:settingsAE.headerBga}\"></span></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"settingsAE.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly=\"\" aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\">\r\n                      <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=\"true\">{{settingsAE.headerBga}}</span>\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"settingsAE.headerBg\" selected-type=\"ctypeAE.headerBg\" is-alpha=\"true\" selected-alpha=\"settingsAE.headerBga\" ng-if=\"colorPicker.hb\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <label>{{\'cl.widget.cm.12\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.ht\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':settingsAE.headerText}\"></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"settingsAE.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly=\"\" aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\">\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"settingsAE.headerText\" selected-type=\"ctypeAE.headerText\" ng-if=\"colorPicker.ht\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <label for=\"aeHeaderFont\">{{\'cl.widget.cm.13\' | translate}}</label>\r\n                  <select id=\"aeHeaderFont\" class=\"form-control\" ng-model=\"settingsAE.headerFont\" ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select>\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <label for=\"aeHeaderSize\">{{\'cl.widget.cm.31\' | translate}}</label>\r\n                  <input type=\"number\" id=\"aeHeaderSize\" class=\"form-control\" ng-model=\"settingsAE.headerSize\" min=\"1\" aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\">\r\n                </div>\r\n              </div> --><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.titleText selected-type=ctypeAE.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.altTitleText selected-type=ctypeAE.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=flex1><label for=aeTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=aeTitleFont class=form-control ng-model=settingsAE.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=aeTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=aeTitleSize class=form-control ng-model=settingsAE.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=settingsAE.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsAE.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsAE.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.timeText selected-type=ctypeAE.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.atm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.atm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.altTimeText selected-type=ctypeAE.altTimeText ng-if=colorPicker.atm></ng-hub-color-picker></div></div></div><div class=flex1><label for=aeTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=aeTimeFont class=form-control ng-model=settingsAE.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=aeTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=aeTimeSize class=form-control ng-model=settingsAE.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=settingsAE.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsAE.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsAE.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.roomText selected-type=ctypeAE.roomText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ar><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsAE.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ar=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.altRoomText selected-type=ctypeAE.altRoomText ng-if=colorPicker.ar></ng-hub-color-picker></div></div></div><div class=flex1><label for=aeRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=aeRoomFont class=form-control ng-model=settingsAE.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=aeRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=aeRoomSize class=form-control ng-model=settingsAE.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=settingsAE.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsAE.rowBg, opacity:settingsAE.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsAE.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.rowBg selected-type=ctypeAE.rowBg is-alpha=true selected-alpha=settingsAE.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsAE.altBg, opacity:settingsAE.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsAE.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsAE.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsAE.altBg selected-type=ctypeAE.altBg is-alpha=true selected-alpha=settingsAE.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=aeSsosOpt ng-model=settingsAE.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=aeSsosOpt ng-model=settingsAE.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"settingsAE.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=aeSosP class=form-control ng-model=settingsAE.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22.1.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.1.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio name=aeEsosOpt ng-model=settingsAE.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio name=aeEsosOpt ng-model=settingsAE.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"settingsAE.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=aeSosA class=form-control ng-model=settingsAE.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=gCalendar.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=gCalendar.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-8><div class=form-group><label>{{\'cl.widget.gc.3\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=gCalendar.isAuthorized>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><!-- <button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{cListShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> --><!-- {{gCalendar}} --> <button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{!gCalendar.isAuthorized?\'cl.widget.cm.25\':\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button ng-if=gCalendar.isAuthorized class=\"btn btn-default marR10\" ng-click=\"openUrlFx(626, 450, \'ou\');\">{{\'cl.widget.cm.25.2\'| translate}}</button></div></div><div class=form-group ng-if=cListShow><label for=calendar>{{\'cl.widget.gc.4\' | translate}}</label><select id=calendar class=form-control ng-model=gCalendar.calendar ng-options=\"calendar.label for calendar in cList track by calendar.id\" ng-change=getCListFx() aria-label=\"{{\'cl.widget.gc.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.gc.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.gc.4.1\' | translate}}</option></select></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=ssLabel>{{\'cm.brief.1\' | translate}}</label><input type=text id=ssLabel class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=ssContentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=\"col-xs-2 noPadR\"><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span> <button type=button role=button id=ssDeviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=ssDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=ssDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=gCalendarFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=gCalendarFx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"gCalendarFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\' || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'roomId\'\" aria-live=polite role=status>{{\'cl.widget.oc.m1\' | translate}}</div><div ng-if=\"errType==\'calendar\'\" aria-live=polite role=status>{{\'cl.widget.gc.m2\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.gc.m1\' | translate}}</div><div ng-if=\"errType==\'wallEmpty\'\" aria-live=polite role=status>{{\'cl.widget.oc.m6\' | translate}}</div><div ng-if=\"errType==\'wallFieldEmply\'\" aria-live=polite role=status>{{\'cl.widget.oc.m7\' | translate}}</div><div ng-if=\"errType==\'sameEmail\'\" aria-live=polite role=status>{{\'cl.widget.msg.12\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/gSlide.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.gs.1\' | translate | camelCase}}</h1><h1 ng-if=!tabView>{{\'cl.widget.gs.2\' | translate}} &nbsp; <span ng-if=gSlide.label>[ {{gSlide.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=gSlide.label maxlength={{inputLimit}} focus-me=true></div><div class=form-group><label for=url>{{\'cl.widget.gs.3\' | translate}}</label><input type=text id=url class=form-control ng-model=gSlide.url placeholder=\"\"></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"form-group noMarB\"><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=gSlide.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=gSlide.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=row ng-if=\"gSlide.settings.reloadOpt == \'c\'\"><div class=col-xs-12><div class=input-group><input type=number id=reload class=form-control ng-model=gSlide.settings.reload step=30 focus-me=true aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div></div><div class=\"col-xs-8 hide\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cm.label.58\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=gSlide.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=gSlide.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"gSlide.settings.rotationOpt == \'c\'\"><input type=number id=rotate class=form-control ng-model=gSlide.settings.rotate focus-me=true min=1 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"form-group noMarB\"><label><input type=checkbox ng-model=gSlide.settings.toolbar role=checkbox><label></label>{{\'cl.widget.gs.4\' | translate}}</label></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=gSlide.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=gSlide.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=gSlideFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.gs.m1\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'reloadEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.wp.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/grafana.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\" role=heading><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.grafana.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.grafana.2\' | translate}} &nbsp; <span ng-if=grafana.label>[ {{grafana.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=grafana.labelOpt value=a><label></label>{{\'cl.widget.grafana.6\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=grafana.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"grafana.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=grafana.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=listLoading><div ng-if=!listLoading><label for=sensor>{{\'cl.widget.pBI.5\' | translate}}</label><select class=form-control id=sensor ng-model=grafana.dashboard ng-options=\"db.title for db in dList track by db.id\"><option value=\"\" disabled>{{\'cl.widget.pBI.16\' | translate}}</option></select></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=grafana.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=grafana.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"grafana.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=grafana.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=grafana.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=grafana.activePeriod></ng-active-period></div></div></div><div class=col-xs-3 ng-if=\"(grafana.ssType == \'g\' && grafana.ss) || (grafana.ssType == \'s\' && grafana.ss && !grafana.isHidden)\"><label>{{\'cl.widget.ss.7\' | translate}}</label><div class=\"pad5 bg-light text-center\"><a href=\"\" role=link ng-href=\"{{cDetailBucket + grafana.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{grafana.label}}><img alt=Preview ng-src=\"{{tim + cBucket + grafana.ssImg+\'?v\'+timestamp + thumbBigParam}}\"></a></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=grafanaFx(); ng-disabled=\"saveProcessing || listLoading || dList.length == 0\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'db\'\">{{\'cl.widget.pBI.m9\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.wp.m1\' | translate}}</div><div ng-if=\"errType == \'reloadEmpty\'\">{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/hdSteth.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.steth.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.steth.2\' | translate}} &nbsp; <span ng-if=steth.info.label>[ {{steth.info.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1); ng-disabled=reponseLoad><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=stethFx(1); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>2</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=stethFx(2); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>3</span>{{\'cl.widget.steth.3\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'4\'}\"><a href=\"\" role=link ng-click=stethFx(3); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>4</span>{{\'cl.widget.steth.4\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'a\'); editAForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.steth.3.1\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-6><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=steth.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6><div><label for=iTime>{{\'cl.widget.steth.6\' | translate}}</label></div><div class=input-group><input type=number id=iTime class=form-control ng-model=steth.info.settings.iTime min=1 aria-label=\"{{\'cl.widget.steth.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.steth.6\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.27s\' | translate}}</span></div></div><div class=col-xs-6><div><label for=rTime>{{\'cl.widget.steth.7\' | translate}}</label></div><select id=rTime class=form-control ng-model=steth.info.settings.rTime aria-label=\"{{\'cl.widget.steth.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.steth.7\' | translate}}\"><option ng-value=\"\" disabled>{{\'cl.widget.steth.7.1\' | translate}}</option><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=15>15</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=30>30</option><option ng-value=35>35</option><option ng-value=40>40</option><option ng-value=45>45</option><option ng-value=50>50</option><option ng-value=55>55</option><option ng-value=60>60</option></select></div></div><div class=\"row marT15\"><div class=col-xs-6><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><select id=lang class=form-control ng-model=steth.info.settings.lang ng-change=\"formatFx(\'n\');\" aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=pt_PT>Portuguese / Portugal</option><option value=es_ES>Spanish / Spain</option></select></div></div><div class=col-xs-6><div class=form-group><label for=format>{{\'cl.widget.dt.9\' | translate}}</label><select id=format class=form-control ng-model=steth.info.settings.format aria-label=\"{{\'cl.widget.dt.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.9\' | translate}}\"><option ng-repeat=\"format in formats\" value={{format.value}}>{{format.label}}</option></select></div></div></div></div><div class=\"marT5 bdr-top-dashed bg-light pad10 hide\" ng-if=settingsOpen><!-- Roomboard--><div class=\"panel-inner-tab marB10\">{{\'cl.widget.oc.4\' | translate}}</div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.rb.bg, opacity:steth.info.settings.rb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.rb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.rb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.rb.bg selected-type=steth.info.ctype.rb.bg is-alpha=true selected-alpha=steth.info.settings.rb.bga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rs><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.rb.ssbg, opacity:steth.info.settings.rb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.rb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rs=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.rb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.rb.ssbg selected-type=steth.info.ctype.rb.ssbg is-alpha=true selected-alpha=steth.info.settings.rb.ssbga ng-if=colorPicker.rs></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoRBOpt ng-model=steth.info.settings.rb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoRBOpt ng-model=steth.info.settings.rb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.rb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.rb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.rb.titleText selected-type=steth.info.ctype.rb.titleText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=steth.info.settings.rb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=steth.info.settings.rb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rst><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.rb.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.rb.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rst=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.rb.subtitleText selected-type=steth.info.ctype.rb.subtitleText ng-if=colorPicker.rst></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=subtitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select class=form-control id=subtitleFont ng-model=steth.info.settings.rb.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=subtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=subtitleSize class=form-control ng-model=steth.info.settings.rb.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.rb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.rb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.rb.timeText selected-type=steth.info.ctype.rb.timeText ng-if=colorPicker.rtm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select class=form-control id=timeFont ng-model=steth.info.settings.rb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=timeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=timeSize class=form-control ng-model=steth.info.settings.rb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=steth.info.settings.rb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=steth.info.settings.rb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"steth.info.settings.rb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=steth.info.settings.rb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=steth.info.settings.rb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=steth.info.settings.rb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"steth.info.settings.rb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=steth.info.settings.rb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Wallboard --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.oc.5\' | translate}}</div><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=steth.info.settings.wb.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=steth.info.settings.wb.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"steth.info.settings.wb.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=steth.info.settings.wb.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.wb.bg, opacity:steth.info.settings.wb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.wb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.bg selected-type=steth.info.ctype.wb.bg is-alpha=true selected-alpha=steth.info.settings.wb.bga ng-if=colorPicker.wb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ws><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.wb.ssbg, opacity:steth.info.settings.wb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ws=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.wb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.ssbg selected-type=steth.info.ctype.wb.ssbg is-alpha=true selected-alpha=steth.info.settings.wb.ssbga ng-if=colorPicker.ws></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoWBOpt ng-model=steth.info.settings.wb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoWBOpt ng-model=steth.info.settings.wb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=steth.info.settings.wb.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"row marT15\" ng-if=steth.info.settings.wb.header.active><div class=col-xs-3><label for=\"{{\'cm.label.23\' | translate}}\">{{\'cm.label.23\' | translate}}</label><input type=text id=column1 class=\"form-control input-sm\" ng-model=steth.info.settings.wb.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=col-xs-3><label for=\"{{\'cm.label.8\' | translate}}\">{{\'cm.label.8\' | translate}}</label><input type=text id=column2 class=\"form-control input-sm\" ng-model=steth.info.settings.wb.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"></div><div class=col-xs-3><label for=\"{{\'cl.widget.oc.10\' | translate}}\">{{\'cl.widget.oc.10\' | translate}}</label><input type=text id=column3 class=\"form-control input-sm\" ng-model=steth.info.settings.wb.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=steth.info.settings.wb.header.active><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.whb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.wb.headerBg, opacity:steth.info.settings.wb.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.whb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.wb.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.headerBg selected-type=steth.info.ctype.wb.headerBg is-alpha=true selected-alpha=steth.info.settings.wb.headerBga ng-if=colorPicker.whb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.headerText selected-type=steth.info.ctype.wb.headerText ng-if=colorPicker.wht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=steth.info.settings.wb.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=steth.info.settings.wb.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.titleText selected-type=steth.info.ctype.wb.titleText ng-if=colorPicker.wt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wat=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.altTitleText selected-type=steth.info.ctype.wb.altTitleText ng-if=colorPicker.wat></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=steth.info.settings.wb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=steth.info.settings.wb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=steth.info.settings.wb.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"row marT15\" ng-if=steth.info.settings.wb.isTime><div class=col-xs-3><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.timeText selected-type=steth.info.ctype.wb.timeText ng-if=colorPicker.wtm></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.watm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.watm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.altTimeText selected-type=steth.info.ctype.wb.altTimeText ng-if=colorPicker.watm></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=wbTimeFont class=form-control ng-model=steth.info.settings.wb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-3><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=steth.info.settings.wb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=steth.info.settings.wb.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"row marT15\" ng-if=steth.info.settings.wb.isRoom><div class=col-xs-3><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wr><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wr=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.roomText selected-type=steth.info.ctype.wb.roomText ng-if=colorPicker.wr></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.war><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':steth.info.settings.wb.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.war=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.altRoomText selected-type=steth.info.ctype.wb.altRoomText ng-if=colorPicker.war></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wbRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wbRoomFont class=form-control ng-model=steth.info.settings.wb.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=col-xs-3><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=wbRoomSize class=form-control ng-model=steth.info.settings.wb.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.wb.rowBg, opacity:steth.info.settings.wb.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.wb.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.rowBg selected-type=steth.info.ctype.wb.rowBg is-alpha=true selected-alpha=steth.info.settings.wb.rowBga ng-if=colorPicker.wrb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.warb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':steth.info.settings.wb.altBg, opacity:steth.info.settings.wb.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"steth.info.settings.wb.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.warb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{steth.info.settings.wb.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=steth.info.settings.wb.altBg selected-type=steth.info.ctype.wb.altBg is-alpha=true selected-alpha=steth.info.settings.wb.altBga ng-if=colorPicker.warb></ng-hub-color-picker></div></div></div><div class=col-xs-4></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=steth.info.settings.wb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=steth.info.settings.wb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"steth.info.settings.wb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=steth.info.settings.wb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=steth.info.settings.wb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=steth.info.settings.wb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"steth.info.settings.wb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number class=form-control ng-model=steth.info.settings.wb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=steth.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=steth.info.activePeriod></ng-active-period></div></div></div><!-- ScreenSaver --><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=ssLabel>{{\'cm.brief.1\' | translate}}</label><input type=text id=ssLabel class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=ssContentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=\"col-xs-2 noPadR\"><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span> <button type=button role=button id=ssDeviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=duration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=ssDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div><!-- Advertisement --><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editAForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addAdvt.isHidden && (addAdvt.advt.thumb || addAdvt.advt.type == \'SharePointC\' || addAdvt.advt.type == \'OneDriveC\' || addAdvt.advt.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addAdvt.advt.thumb ng-href=\"{{cDetailBucket + addAdvt.advt.thumb | secureThumb}}\" role=button data-access={{addAdvt.advt.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addAdvt.advt.path + (addAdvt.advt.path.length > 1 ? \' / \' : \' \') + addAdvt.advt.label)}}\" ng-show=addAdvt.advt.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addAdvt.advt.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addAdvt.advt.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addAdvt.advt.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addAdvt.advt.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.steth.3.2\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=tOpt ng-model=addAdvt.type value=content><label></label>{{\'cl.widget.meeting.24\' | translate}}</label><label class=noMarB><input type=radio role=radio name=tOpt ng-model=addAdvt.type value=url><label></label>{{\'cl.widget.cm.10\' | translate}}</label></div></div></div><div class=col-xs-4><div class=form-group><label>{{(addAdvt.type==\'content\'?\'cl.widget.steth.3.3\':\'cl.widget.steth.3.4\') | translate}}</label><div class=quotesImg ng-if=\"addAdvt.type == \'content\'\"><div class=\"pull-left relative\" ng-if=\"!addAdvt.isHidden && (addAdvt.target.thumb || addAdvt.target.type == \'SharePointC\' || addAdvt.target.type == \'OneDriveC\' || addAdvt.target.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addAdvt.target.thumb ng-href=\"{{cDetailBucket + addAdvt.target.thumb | secureThumb}}\" role=button data-access={{addAdvt.target.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addAdvt.target.path + (addAdvt.target.path.length > 1 ? \' / \' : \' \') + addAdvt.target.label)}}\" ng-show=addAdvt.target.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addAdvt.target.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addAdvt.target.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addAdvt.target.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addAdvt.target.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=tContentBtn class=\"btn btn-default btn-xs marT6\" ng-click=\"selectContentOpen(\'target\');\">{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div><div ng-if=\"addAdvt.type == \'url\'\"><input type=text id=url class=form-control ng-model=addAdvt.url focus-me=true aria-label=\"{{\'cl.widget.steth.3.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.steth.3.4\' | translate}}\"></div></div></div><div class=col-xs-2><label for=duration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=duration class=\"form-control w135\" ng-model=addAdvt.advt.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editAForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addAdvtFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addAdvtFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'a\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editAForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addAdvtFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editAForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'advt\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'target\'\" aria-live=polite role=status>{{\'cl.widget.steth.m2\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.steth.m3\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-4>{{\'cl.widget.steth.3\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.steth.3.2\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.steth.5\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"advtList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"advt in advtList\" data-id={{advt.aId}}><div class=col-xs-4><div class=user-tumb><a ng-href=\"{{cDetailBucket + advt.advt.thumb | secureThumb}}\" role=button data-access={{advt.advt.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"advt.advt.thumb && !advt.advt.url && advt.advt.isAccessible\" data-fancybox-title=\"{{advt.advt.path + (advt.advt.path.length > 1 ? \' / \' : \' \') + advt.advt.label}}\"><img ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"advt.advt.type != \'SharePointC\' && advt.advt.type != \'OneDriveC\' && advt.advt.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"advt.advt.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"advt.advt.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"advt.advt.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + advt.advt.url, advt.advt.path + (advt.advt.path.length > 1 ? \' / \' : \' \') + advt.advt.label);\" ng-if=\"advt.advt.thumb && advt.advt.url && advt.advt.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!advt.advt.thumb && advt.advt.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!advt.advt.thumb && advt.advt.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.advt.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!advt.advt.thumb && advt.advt.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!advt.advt.thumb && advt.advt.type != \'SharePointC\' && advt.advt.type != \'OneDriveC\' && advt.advt.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!advt.advt.isAccessible><img uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{advt.advt.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{advt.advt.label}}</div></div><div class=col-xs-2><span ng-if=\"advt.type==\'url\'\">{{advt.type | uppercase}}</span><span ng-if=\"advt.type!=\'url\'\">{{advt.type | capitalize}}</span></div><div class=col-xs-3><div ng-if=\"advt.type!=\'url\'\"><div class=user-tumb><a ng-href=\"{{cDetailBucket + advt.target.thumb | secureThumb}}\" role=button data-access={{advt.target.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"advt.target.thumb && !advt.target.url && advt.target.isAccessible\" data-fancybox-title=\"{{advt.target.path + (advt.target.path.length > 1 ? \' / \' : \' \') + advt.target.label}}\"><img ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"advt.target.type != \'SharePointC\' && advt.target.type != \'OneDriveC\' && advt.target.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"advt.target.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"advt.target.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"advt.target.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + advt.target.url, advt.target.path + (advt.target.path.length > 1 ? \' / \' : \' \') + advt.target.label);\" ng-if=\"advt.target.thumb && advt.target.url && advt.target.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!advt.target.thumb && advt.target.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!advt.target.thumb && advt.target.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + advt.target.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!advt.target.thumb && advt.target.type == \'GoogleDriveC\'\"> <img src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!advt.target.thumb && advt.target.type != \'SharePointC\' && advt.target.type != \'OneDriveC\' && advt.target.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!advt.target.isAccessible><img uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{advt.target.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{advt.target.label}}</div></div><div ng-if=\"advt.type==\'url\'\" class=text-ellipsis>{{advt.url}}</div></div><div class=col-xs-2>{{advt.advt.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'a\', advt);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'a\', advt.aId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"advtList.length == 0\">{{\'cl.widget.steth.m1\' | translate}}</div></div></div></div></div><!-- Mapping --><div ng-if=\"selectedT==\'4\'\" class=marL10><div class=\"bg-light pad10 marB15\" ng-show=editRForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=room>{{\'cl.widget.oc.10\' | translate}}</label><input type=text id=room class=form-control ng-model=roomCU.room focus-me=true ng-if=\"roomCU.type == \'r\'\" aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <input type=text id=room class=form-control ng-model=roomCU.room ng-if=\"roomCU.type != \'r\'\" readonly aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=floor>{{\'cl.widget.meeting.8\' | translate}}</label><input type=text id=floor class=form-control ng-model=roomCU.floor aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=dType>{{\'cl.widget.cm.9\' | translate}}</label><select id=dType class=form-control ng-model=roomCU.dType aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editRForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"roomCUFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'r\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editRForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'e\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=\"btn-link btn-sm\" ng-click=\"editRForm.isShow = false\" ng-disabled=\"addProcessing || addMoreProcessing\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'room\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><!-- TODO added scroll feature changes and added new tabs --><div class=\"form-group marT20\" ng-if=\"allScrollDataList.rl.length > 0\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchText sanitize-input ng-change=\"searchChangeDataDyn(searchText, \'rl\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText = \'\';searchChangeDataDyn(searchText, \'rl\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cl.widget.steth.4.1\' | translate}}</div><div class=\"table table-scroll marT5 marB15\" ng-if=\"allScrollDataList.rl.length || mapList.length\"><div class=\"row th\"><div class=col-xs-6>{{\'cm.label.4\' | translate}}</div><div class=col-xs-4>{{\'cl.widget.steth.4.2\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(495)}}px id=scroll-container-rl dynamic-scroll-list st=stIndex.rl et=etIndex.rl list-data=scrollDataList.rl search-data=searchText have-more-data=haveMoreData.rl search-scroll=searchScroll.rl clone-data=allScrollDataList.rl have-more-search-data=haveMoreSearchData.rl quad-id=\"\'rl\'\" dd-open=true><div class=\"row rowObj-rl\" id={{device.id}} ng-repeat=\"device in filteredMapList = (visibleData.rl)\" ng-if=!device.isHidden><div class=col-xs-6><span ng-if=!device.show><div class=\"marR5 deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{device.l}} </span><input type=text class=form-control ng-model=device.l ng-if=device.show readonly></div><div class=col-xs-4><span ng-if=\"!device.dr && !device.show\" class=text-muted>N/A</span> <span class=text-ellipsis ng-if=\"device.dr!=\'\' && !device.show\">{{device.dr}}</span> <input type=text class=form-control ng-model=device.dr ng-if=device.show></div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-if=!device.show ng-click=\"device.show = !device.show; deviceMapFx(\'e\', device)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn btn-success\" ng-show=device.show ng-click=\"deviceMapFx(\'u\', device, $index);\" ng-disabled=mapProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-link\" ng-show=device.show ng-click=\"deviceMapFx(\'c\', device, $index);\" ng-disabled=mapProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && !loadingMore.rl\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && loadingMore.rl\"> <img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.rl></div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.rl.length > 0 && filteredMapList.length == 0 && !loadingPaging.rl\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!allScrollDataList.rl.length>{{\'d.msg.1\' | translate}}</div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\' || selectedT==\'4\'\" ng-click=\"backBtnFx(); selectedTabFx();\" ng-disabled=reponseLoad><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=stethFx(1); ng-disabled=\"nextProcessing || detailLoading || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=stethFx(2); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.steth.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'3\'\" ng-click=stethFx(3); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.steth.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"stethFx(0, \'save\');\" ng-if=\"encId || selectedT==\'4\'\" ng-disabled=\"nextProcessing || saveProcessing || detailLoading || reponseLoad\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'iTime\'\" aria-live=polite role=status>{{\'cl.widget.steth.m5\' | translate}}</div><div ng-if=\"errType==\'rTime\'\" aria-live=polite role=status>{{\'cl.widget.steth.m6\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/iFrame.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.iFrame.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.iFrame.2\' | translate}} &nbsp; <span ng-if=iFrame.label>[ {{iFrame.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=iFrame.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=wData>{{\'cl.widget.iFrame.3\' | translate}} <span class=\"text-muted text-sm\">( {{\'cl.widget.iFrame.4\' | translate}}: &lt;iframe&gt; {{\'cm.label.42\' | translate}} &lt;embed&gt; )</span></label><textarea id=wData class=\"form-control txtAreaBig\" ng-model=iFrame.frameData aria-label=\"{{\'cl.widget.iFrame.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iFrame.3\' | translate}}\"></textarea></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=iFrame.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=iFrame.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=iFrameFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'data\'\" aria-live=polite role=status>{{\'cl.widget.iFrame.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/instagram.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.instagram.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.instagram.2\' | translate}} &nbsp; <span ng-if=instagram.label>[ {{instagram.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=instagramFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=instagram.labelOpt value=a><label></label>{{\'cl.widget.instagram.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=instagram.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"instagram.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=instagram.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=\"form-group hide\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=instagram.dType value=l><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label></div></div><div class=row><div class=col-xs-5><div class=form-group><label for=post>{{\'cl.widget.instagram.6\' | translate}}</label><select id=post class=form-control ng-options=\"p for p in postList track by p\" ng-model=instagram.post aria-label=\"{{\'cl.widget.instagram.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.instagram.6\' | translate}}\"></select></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=instagram.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=instagram.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"instagram.settings.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=instagram.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=instagram.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=instagram.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=instagram.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"instagram.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=instagram.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div></div></div><div class=row><div class=\"col-xs-3 hide\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':instagram.settings.headerBg, opacity:instagram.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"instagram.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{instagram.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=instagram.settings.headerBg selected-type=instagram.ctype.headerBg is-alpha=true selected-alpha=instagram.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':instagram.settings.bg, opacity:instagram.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"instagram.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{instagram.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=instagram.settings.bg selected-type=instagram.ctype.bg is-alpha=true selected-alpha=instagram.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3 ng-if=\"instagram.settings.hTextOpt!=\'n\'\"><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':instagram.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"instagram.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=instagram.settings.headerText selected-type=instagram.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3 ng-if=\"instagram.settings.hTextOpt!=\'n\'\"><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=instagram.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3 ng-if=\"instagram.settings.hTextOpt!=\'n\'\"><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=instagram.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.36\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':instagram.settings.footerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"instagram.settings.footerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.cm.36\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.36\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=instagram.settings.footerText selected-type=instagram.ctype.footerText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=fFont>{{\'cl.widget.cm.37\' | translate}}</label><select id=fFont class=form-control ng-model=instagram.settings.footerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.37\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37\' | translate}}\"></select></div><div class=col-xs-3><label for=fSize>{{\'cl.widget.cm.37.1\' | translate}}</label><input type=number id=fSize class=form-control ng-model=instagram.settings.footerSize min=1 aria-label=\"{{\'cl.widget.cm.37.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37.1\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=instagram.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=instagram.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.instagram.7\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=pListShow>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button id=authBtn class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{pListShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=instagramFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"instagramFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'fSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m5\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.fb.m2\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'userTag\'\" aria-live=polite role=status>{{instagram.dType==\'Hashtag\'?\'cl.widget.instagram.m1\':\'cl.widget.instagram.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/intelCircuitRss.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.inC.1\' | translate | camelCase}}</h1><h1 ng-if=!tabView>{{\'cl.widget.inC.2\' | translate}} &nbsp; <span ng-if=iCircuit.label>[ {{iCircuit.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=iCircuit.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=iCircuit.dType ng-change=\"changeDType(\'normal\')\" value=normal ng-if=\"widgetList.rssFeedCrawl || (iCircuit.id && dTypeCopy == \'crawl\')\"><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=noMarB ng-if=\"widgetList.rssFeedCrawl || (iCircuit.id && dTypeCopy == \'crawl\')\"><input type=radio role=radio name=dTypeOpt ng-model=iCircuit.dType ng-change=\"changeDType(\'crawl\')\" value=crawl><label></label>{{\'cl.widget.cm.23\' | translate}}</label></div></div><!-- <div class=\"form-group\">\r\n        <label for=\"feed\">{{\'cl.widget.inC.1\' | translate}}</label>\r\n        <input type=\"text\" id=\"feed\" class=\"form-control\" ng-model=\"iCircuit.feed\" placeholder=\"{{\'cm.ph.3\' | translate}}: http://iCircuit.cnn.com/rss/edition.rss\" aria-label=\"{{\'cl.widget.inC.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.inC.1\' | translate}}\">\r\n      </div> --></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"iCircuit.dType == \'normal\'\"><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=iCircuit.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=iCircuit.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"iCircuit.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=iCircuit.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=iCircuit.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=iCircuit.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=iCircuit.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"iCircuit.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=iCircuit.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"iCircuit.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.headerBg, opacity:iCircuit.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.headerBg selected-type=iCircuit.ctype.headerBg is-alpha=true selected-alpha=iCircuit.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.headerText selected-type=iCircuit.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=iCircuit.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=iCircuit.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.bg, opacity:iCircuit.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.bg selected-type=iCircuit.ctype.bg is-alpha=true selected-alpha=iCircuit.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=iCircuit.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=iCircuit.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.rowBg, opacity:iCircuit.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.rowBg selected-type=iCircuit.ctype.rowBg is-alpha=true selected-alpha=iCircuit.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.cm.15\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.arb\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span class=\"trBg\"><span ng-style=\"{\'background-color\':iCircuit.settings.altBg, opacity:iCircuit.settings.altBga}\"></span></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"iCircuit.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly=\"\" aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\">\r\n                    <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=\"true\">{{iCircuit.settings.altBga}}</span>\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"iCircuit.settings.altBg\" selected-type=\"iCircuit.ctype.altBg\" is-alpha=\"true\" selected-alpha=\"iCircuit.settings.altBga\" ng-if=\"colorPicker.arb\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.titleText selected-type=iCircuit.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.cm.16.1\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.att\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':iCircuit.settings.altTitleText}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"iCircuit.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly=\"\" aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"iCircuit.settings.altTitleText\" selected-type=\"iCircuit.ctype.altTitleText\" ng-if=\"colorPicker.att\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.descText selected-type=iCircuit.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cm.label.24\' | translate}}</label><select id=rowFont class=form-control ng-model=iCircuit.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=row><div class=col-xs-3><div class=form-group><label>&nbsp;</label><div><label class=noMarB><input type=checkbox role=checkbox ng-model=iCircuit.settings.takeover><label></label>{{\'cl.widget.inC.4\' | translate}}</label></div></div></div></div><!-- Take over settings --><div ng-if=iCircuit.settings.takeover class=row><div class=col-xs-12><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.takeoverS.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.takeoverS.bg, opacity:iCircuit.settings.takeoverS.bga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"iCircuit.settings.takeoverS.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.takeoverS.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.takeoverS.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.takeoverS.bg selected-type=iCircuit.settings.takeoverS.ctype.bg is-alpha=true selected-alpha=iCircuit.settings.takeoverS.bga ng-if=colorPicker.takeoverS.b></ng-hub-color-picker></div></div></div></div></div><div class=row><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.takeoverS.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.takeoverS.hBg, opacity:iCircuit.settings.takeoverS.hBga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"iCircuit.settings.takeoverS.hBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.takeoverS.hb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.takeoverS.hBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.takeoverS.hBg selected-type=iCircuit.settings.takeoverS.ctype.hb is-alpha=true selected-alpha=iCircuit.settings.takeoverS.hBga ng-if=colorPicker.takeoverS.hb></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.takeoverS.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.takeoverS.hText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.takeoverS.hText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.takeoverS.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.takeoverS.hText selected-type=iCircuit.settings.takeoverS.ctype.ht ng-if=colorPicker.takeoverS.ht></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=iCircuit.settings.takeoverS.hFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=col-xs-3><div class=form-group><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=iCircuit.settings.takeoverS.hSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div><!--  --><div class=row><div class=col-xs-3><div class=form-group><label for=mBgColor>{{\'em.label.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.takeoverS.mb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.takeoverS.mBg, opacity:iCircuit.settings.takeoverS.mBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.takeoverS.mBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.takeoverS.mb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.takeoverS.mBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.takeoverS.mBg selected-type=iCircuit.settings.takeoverS.ctype.mb is-alpha=true selected-alpha=iCircuit.settings.takeoverS.mBga ng-if=colorPicker.takeoverS.mb></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=mTextColor>{{\'em.label.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.takeoverS.mt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.takeoverS.mText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.takeoverS.mText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.takeoverS.mt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.takeoverS.mText selected-type=iCircuit.settings.takeoverS.ctype.mt ng-if=colorPicker.takeoverS.mt></ng-hub-color-picker></div></div></div></div><div class=col-xs-3><div class=form-group><label for=mFont>{{\'em.label.11\' | translate}}</label><select id=mFont class=form-control ng-model=iCircuit.settings.takeoverS.mFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=col-xs-3><div class=form-group><label for=mSize>{{\'em.label.13\' | translate}}</label><input type=number id=mSize class=form-control ng-model=iCircuit.settings.takeoverS.mSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div></div></div><!-- <div class=\"row marT15\">\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.twitter.6\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.dt\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':iCircuit.settings.descText}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"iCircuit.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly=\"\" aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"iCircuit.settings.descText\" selected-type=\"iCircuit.ctype.descText\" ng-if=\"colorPicker.dt\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.twitter.6.1\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.adt\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':iCircuit.settings.altDescText}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"iCircuit.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly=\"\" aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"iCircuit.settings.altDescText\" selected-type=\"iCircuit.ctype.altDescText\" ng-if=\"colorPicker.adt\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-xs-3\">\r\n                <label for=\"rowFont\">{{\'cm.label.24\' | translate}}</label>\r\n                <select id=\"rowFont\" class=\"form-control\" ng-model=\"iCircuit.settings.rowFont\" ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select>\r\n              </div>\r\n\r\n              <div class=\"col-xs-3\">\r\n                <label for=\"altRowFont\">{{\'cm.label.24.1\' | translate}}</label>\r\n                <select id=\"altRowFont\" class=\"form-control\" ng-model=\"iCircuit.settings.altRowFont\" ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.24.1\' | translate}}\"></select>\r\n              </div>\r\n            </div> --></div><div ng-if=\"iCircuit.dType == \'crawl\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.text.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=iCircuit.settings.dir value=rl><label></label>{{\'cl.widget.text.5\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=iCircuit.settings.dir value=bt ng-change=directionFx()><label></label>{{\'cl.widget.text.6\' | translate}}</label></div></div><div class=col-xs-6 ng-if=\"iCircuit.settings.dir == \'bt\'\"><label>{{\'cl.widget.text.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=aOpt ng-model=iCircuit.settings.align value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=aOpt ng-model=iCircuit.settings.align value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label><input type=radio role=radio name=aOpt ng-model=iCircuit.settings.align value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=speed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=speed class=form-control ng-model=iCircuit.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iCircuit.settings.bg, opacity:iCircuit.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iCircuit.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.bg selected-type=iCircuit.ctype.bg is-alpha=true selected-alpha=iCircuit.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"iCircuit.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.bullet}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.bullet selected-type=iCircuit.ctype.bullet ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"iCircuit.settings.dir == \'bt\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.titleText selected-type=iCircuit.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4 ng-if=\"iCircuit.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iCircuit.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iCircuit.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iCircuit.settings.titleText selected-type=iCircuit.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=iCircuit.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-4 ng-if=\"iCircuit.settings.dir == \'bt\'\"><label for=fontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=fontSize class=form-control ng-model=iCircuit.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"iCircuit.settings.dir == \'rl\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=iCircuit.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label><input type=radio role=radio name=fsOpt ng-model=iCircuit.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"iCircuit.settings.fontSizeOpt == \'c\'\"><input type=number id=fontSize class=form-control ng-model=iCircuit.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=iCircuit.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=iCircuit.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=rssFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'feed\'\" aria-live=polite role=status>{{\'cl.widget.inC.m1\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'fSizeText\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'mSize\'\" aria-live=polite role=status>{{\'em.msg.14\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/intelSmartBuilding.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.isb.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.isb.2\' | translate}} &nbsp; <span ng-if=sb.label>[ {{sb.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><div class=marT5><input type=text id=label class=form-control ng-model=sb.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div></div><div class=col-xs-12><div class=form-group><div class=panel-inner-tab><label class=noMarB>{{\'cl.widget.isb.3\' | translate}}</label><button type=button role=button class=\"btn btn-primary btn-sm pull-right btn-xs\" ng-click=\"btnActionsFx({c:\'a\'})\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cm.btn.19\' | translate}}</button></div><div class=marT5><div class=\"bg-light pad10\"><div class=\"table bg-white no-th\"><div class=\"row th bg-white\"><div class=col-xs-1>{{\'cl.widget.codBtn.3.1\' | translate}}</div><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.1\' | translate}}</div><div class=col-xs-2>{{\'cl.brief.8\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=\"scrollQuad sortable-containment\" id=intelSmartBtn style=max-height:{{getAvailableHeight(610)}}px sortable callback=sortCallback()><div class=\"row sortable-item\" ng-repeat=\"list in sb.settings.btnList\" for=sb{{$index}} data-id={{list.id}}><div class=col-xs-1><div><div class=\"col-xs-2 noPadL cursor-grab sortGrab marT6\"><img alt=\"\" ng-src=assets/images/sortGrab.svg></div><div class=\"col-xs-10 noPad\"><div class=quotesImg><div class=\"pull-left relative intel-list-icon-bg\" ng-if=\"list.icon.id && list.icon.isAccessible && (list.icon.thumb || list.icon.type == \'SharePointC\' || list.icon.type == \'OneDriveC\' || list.icon.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeIconFx(list.id, \'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=list.icon.thumb ng-href=\"{{cDetailBucket + list.icon.thumb | secureThumb}}\" role=button data-access={{list.icon.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(list.icon.path + (list.icon.path.length > 1 ? \' / \' : \' \') + list.icon.label)}}\" ng-show=list.icon.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + list.icon.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"list.icon.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"list.icon.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"list.icon.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=\"list.icon.id && !list.icon.isAccessible && list.icon.thumb\"><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><div class=\"pull-left relative cursorPointer marT3 noMarR\" ng-if=!list.icon.id ng-click=\"selectContentOpen(list.id , \'i\');\"><img alt=\"\" uib-tooltip=\"{{\'cm.label.30\' | translate | camelCase}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/select.svg class=selectBtn></div></div></div></div></div><div class=col-xs-4><input type=text class=\"form-control input-sm\" ng-model=list.label aria-label=label aria-labelledby=label></div><div class=col-xs-4><div class=quotesImg ng-if=list.isRemovable><div class=\"pull-left relative bdrIcon\" ng-if=\"list.content.id && list.content.isAccessible && (list.content.thumb || list.content.type == \'SharePointC\' || list.content.type == \'OneDriveC\' || list.content.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeIconFx(list.id, \'c\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=\"list.content.thumb && (!list.content.url ||  list.content.type != \'Video\') && list.content.type != \'Widget\'\" ng-href=\"{{cDetailBucket + list.content.thumb | secureThumb}}\" role=button data-access={{list.content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(list.content.path + (list.content.path.length > 1 ? \' / \' : \' \') + list.content.label)}}\" ng-show=list.content.thumb><img ng-if=\"content.type != \'Widget\'\" alt=\"\" ng-src=\"{{tim + cBucket + list.content.thumb + inputImgThumbParam}}\"> </a><span ng-if=\"list.content.type == \'Widget\'\" class=\"qr-clIcon boxContent\"><span class=\"icon {{list.content.thumb}}\" ng-if=\"list.content.type == \'Widget\'&& (list.content.extn != \'YouTube\' && list.content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"list.content.type == \'Widget\' && list.content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"list.content.type == \'Widget\' && list.content.extn == \'YouTube\'\"></span> </span><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + list.content.url, list.content.path + (list.content.path.length > 1 ? \' / \' : \' \') + list.content.label);\" ng-if=\"list.content.thumb && list.content.url && list.content.type == \'Video\'\"><img alt=\"\" ng-src=\"{{tim + cBucket + list.content.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-if=\"!list.content.thumb && list.content.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"!list.content.thumb && list.content.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"!list.content.thumb && list.content.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=\"list.content.id && !list.content.isAccessible && list.content.thumb\"><img uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><div class=\"pull-left relative maxW80 marR10 padT6 text-ellipsis\" ng-if=list.content.id uib-tooltip={{list.content.label}} tooltip-popup-delay=500 tooltip-append-to-body=true>{{list.content.label}}</div><button type=button role=button id=contentBtn class=\"btn btn-primary btn-sm\" ng-if=!list.content.id ng-click=\"selectContentOpen(list.id, \'c\');\">{{\'cm.label.32\' | translate}}</button></div><div class=quotesImg ng-if=!list.isRemovable><div class=\"pull-left relative bdrIcon\"><span class=\"qr-clIcon boxContent\"><span class=\"icon intelSmartBuilding\"></span></span></div><div class=\"pull-left relative maxW80 marR10 padT6 text-ellipsis\" uib-tooltip=\"{{\'cl.widget.isb.1\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{\'cl.widget.isb.1\' | translate}}</div></div><div ng-if=!list.isRemovable class=\"valign-sub padT6 hide\">{{\'cl.widget.isb.1\' | translate}}</div></div><div class=col-xs-2><div class=\"pull-left relative w100 marR10 padT6 text-ellipsis\" ng-if=\"list.content.id && list.isRemovable && list.content.isAccessible\" uib-tooltip={{list.content.path}} tooltip-popup-delay=500 tooltip-append-to-body=true><a href=\"\" role=link ng-click=\"openContentFolderFx(list.content.id, list.content.fid, list.content.type, list.content.splId, list.content.splType, list.content.gid, list.content.gType);\" ng-if=\"(auth.uservices.c && list.content.type != \'template\')\"><span class=\"glyphicon glyphicon-home marR5\" aria-hidden=true></span>{{list.content.path}}</a></div><div ng-if=\"!list.isRemovable || !list.content.id || (list.content.id && !list.content.isAccessible)\" class=\"text-muted valign-sub padT6\">N/A</div></div><div class=\"col-xs-1 text-right padT5\"><div><div class=\"col-xs-11 noPadL padT2\"><label><input type=radio role=radio ng-model=sb.settings.isDefault id=sb{{$index}} ng-value=list.id uib-tooltip=\"{{\'fl.p_cfl.label.19\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true name=\"Set as Default\" aria-label=\"Set as Default\" aria-labelledby=\"Set as Default\"><label></label></label></div><div class=\"col-xs-1 noPad\"><a href=\"\" role=link class=text-danger ng-click=\"btnActionsFx({c: !list.isRemovable ? \'\' :\'cp\', id:list.id});\" ng-class=\"{\'cursorDisabled\' : !list.isRemovable}\" uib-tooltip=\"{{ !list.isRemovable ? \'cl.widget.isb.m5\' : \'cm.btn.20\' | translate}}\" tooltip-popup-delay=500 tooltip-placement=left tooltip-append-to-body=true aria-label=Remove><span class=\"fa fa-remove padT5\" aria-hidden=true></span></a></div></div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=sb.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=sb.activePeriod></ng-active-period></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"sbFx(\'save\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button> </span><!-- <span class=\"btnQuad\">\r\n    <button type=\"button\" role=\"button\" class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=\"backBtnFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span>{{\'cm.btn.11\' | translate}}</button>\r\n    <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=\"sbFx(1);\">{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span></button>\r\n    <button type=\"button\" role=\"button\" class=\"btn btn-success\" ng-click=\"sbFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing\"><span class=\"fa\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=\"true\"></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button>\r\n    <button type=\"button\" role=\"button\" class=\"btn btn-link\" ui-sref=\"hub.contentLibrary.c\" ng-click=\"popupCloseFx();\">{{\'cm.btn.9\' | translate}}</button>\r\n  </span> --><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'st\'\">{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'url\'\">{{\'cl.widget.isb.m2\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'stol\'\">{{\'cl.widget.isb.m3\' | translate}}</div><div ng-if=\"errType == \'ssEmpty\'\">{{\'cl.widget.isb.m4\' | translate}}</div><div ng-if=\"errType == \'label\'\">{{\'cl.widget.isb.m1\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/interactiveMenu.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.iMenu.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.iMenu.2\' | translate}} &nbsp; <span ng-if=iMenu.label>[ {{iMenu.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=iMenuFx(1);><span class=badge>2</span>{{\'cl.widget.iMenu.1\' | translate}}</a></li><button type=button role=button class=\"btn btn-primary btn-sm pull-right\" ng-click=addMenuFx(addMenu); ng-if=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.iMenu.b1\' | translate}}</button></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=iMenu.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=\"col-xs-12 marB10\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"row noMar\"><div><div class=\"form-group col-xs-4 noPadL\"><label for=btnW>{{\'cl.widget.iMenu.3\'| translate}}</label><input type=number id=btnW class=form-control ng-model=iMenu.settings.btnW min=1 aria-label=\"{{\'cl.widget.iMenu.3\'| translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.3\'| translate}}\"></div><div class=\"form-group col-xs-4\"><label for=btnH>{{\'cl.widget.iMenu.4\'| translate}}</label><input type=number id=btnH class=form-control ng-model=iMenu.settings.btnH min=1 aria-label=\"{{\'cl.widget.iMenu.4\'| translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.4\'| translate}}\"></div><div class=\"form-group col-xs-4 noPadR\"><label>{{\'cl.widget.iMenu.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iMenu.settings.btnBg, opacity:iMenu.settings.btnBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iMenu.settings.btnBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.iMenu.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.5\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iMenu.settings.btnBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iMenu.settings.btnBg selected-type=iMenu.ctype.btnBg is-alpha=true selected-alpha=iMenu.settings.btnBga ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div></div><div><div class=\"form-group col-xs-4 noPadL\"><label for=btnFontSize>{{\'cl.widget.iMenu.6\' | translate}}</label><input type=number id=btnFontSize class=form-control ng-model=iMenu.settings.btnFontSize min=1 aria-label=\"{{\'cl.widget.iMenu.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.6\' | translate}}\"></div><div class=\"form-group col-xs-4\"><label>{{\'cl.widget.iMenu.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iMenu.settings.btnTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iMenu.settings.btnTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bt=true\" readonly aria-label=\"{{\'cl.widget.iMenu.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iMenu.settings.btnTxt selected-type=iMenu.ctype.btnText ng-if=colorPicker.bt></ng-hub-color-picker></div></div></div><div class=\"form-group col-xs-4 noPadR\"><label for=btnTxtAlign>{{\'cl.widget.iMenu.8\' | translate}}</label><select id=btnTxtAlign class=form-control ng-model=iMenu.settings.btnTxtAlign aria-label=\"{{\'cl.widget.iMenu.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.8\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option></select></div></div><div><div class=form-group><label class=noMarB><input type=checkbox ng-model=iMenu.settings.btnBdrOpt role=checkbox><label></label>{{\'cl.widget.iMenu.9\' | translate}}</label><div class=\"row noMarL noMarR marT5\" ng-if=iMenu.settings.btnBdrOpt><div class=\"col-xs-4 noPadL\"><label>{{\'cl.widget.iMenu.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iMenu.settings.btnBdr}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iMenu.settings.btnBdr | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bb=true\" readonly aria-label=\"{{\'cl.widget.iMenu.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.10\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iMenu.settings.btnBdr selected-type=iMenu.ctype.btnBdr ng-if=colorPicker.bb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=btnBdrSize>{{\'cl.widget.iMenu.11\' | translate}}</label><input type=number id=btnBdrSize class=form-control ng-model=iMenu.settings.btnBdrSize min=1 aria-label=\"{{\'cl.widget.iMenu.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.11\' | translate}}\"></div><div class=\"col-xs-4 noPadR\"><label for=btnBdrRadius>{{\'cl.widget.iMenu.12\' | translate}}</label><input type=number id=btnBdrRadius class=form-control ng-model=iMenu.settings.btnBdrRadius min=1 aria-label=\"{{\'cl.widget.iMenu.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.12\' | translate}}\"></div></div></div></div><div><div class=form-group><label class=noMarB><input type=checkbox ng-model=iMenu.settings.icon role=checkbox><label></label>{{\'cl.widget.iMenu.13\' | translate}}</label><span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.iMenu.13.1\' | translate}}\" tooltip-placement=right aria-hidden=true></span><div class=marT5 ng-if=iMenu.settings.icon><label for=iconPosition>{{\'cl.widget.iMenu.14\' | translate}}</label><select id=iconPosition class=form-control ng-model=iMenu.settings.iconPosition aria-label=\"{{\'cl.widget.iMenu.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iMenu.14\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=iMenu.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=iMenu.activePeriod></ng-active-period></div></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div class=\"row noMarL\"><div class=\"col-xs-9 noPadL\"><div class=\"table table-scroll\"><div class=\"row th\"><div class=noPadR ng-class=\"iMenu.settings.icon?\'col-xs-3\':\'col-xs-4\'\">{{\'cm.label.23\' | translate}}</div><div class=\"col-xs-3 noPadR\" ng-if=iMenu.settings.icon>{{\'cl.widget.iMenu.13\' | translate}}</div><div class=noPadR ng-class=\"iMenu.settings.icon?\'col-xs-2\':\'col-xs-4\'\">{{\'cl.widget.iMenu.15\' | translate}}</div><div class=\"col-xs-3 noPadR\">{{\'cl.widget.iMenu.16\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto ng-attr-style=max-height:{{getAvailableHeight(410)}}px;><div class=\"row noMargin\" ng-repeat=\"m in iMenu.menus\" id={{m.id}} ng-mouseenter=menuHighlight($event,m.id)><div class=noPadR ng-class=\"iMenu.settings.icon?\'col-xs-3\':\'col-xs-4\'\"><input type=text class=\"form-control input-sm\" ng-model=m.label aria-label=title aria-labelledby=title></div><div class=\"col-xs-3 noPadR\" ng-if=iMenu.settings.icon><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!m.icon.hidden && (m.icon.thumb || m.icon.type == \'SharePointC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeContentFx(m.id, \'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=m.icon.thumb ng-href=\"{{cDetailBucket + m.icon.thumb | secureThumb}}\" role=button data-access={{m.icon.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(m.icon.path + (m.icon.path.length > 1 ? \' / \' : \' \') + m.icon.label)}}\" ng-show=m.icon.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + m.icon.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"m.icon.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png></div><div class=\"pull-left relative\" ng-if=m.icon.hidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div><button type=button role=button class=\"btn btn-primary btn-xs marT4\" ng-click=\"selectContentOpen(m.id, \'i\');\">{{\'cm.label.30\' | translate | camelCase}}</button></div></div><div class=noPadR ng-class=\"iMenu.settings.icon?\'col-xs-2\':\'col-xs-4\'\"><select class=\"form-control input-sm\" ng-model=m.parent ng-change=parentChange(); aria-label=parent aria-labelledby=parent><option value=\"\">{{\'cl.widget.iMenu.17\' | translate}}</option><option ng-repeat=\"opt in iMenu.menus\" value={{opt.id}} ng-disabled=\"opt.id==m.id\">{{opt.label}}</option></select></div><div class=\"col-xs-3 noPadR\"><div class=marT4><span class=\"pull-left marT2 marR5\">{{m.target.length - m.curCount}}</span> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"selectContentOpen(m.id, \'t\');\">{{\'cm.label.32\' | translate | camelCase}}</button></div></div><div class=\"col-xs-1 noPadL text-right\"><a href=\"\" role=link name=removeList class=text-danger ng-class=\"{\'text-muted\':iMenu.menus.length <= 1}\" ng-disabled=\"iMenu.menus.length <= 1\" ng-click=removeMenuRow($index);><span class=\"fa fa-remove noMarR marT8\" aria-hidden=true></span></a></div></div></div></div></div><div class=\"col-xs-3 noPadR\"><div class=quadHeading>{{\'cl.widget.iMenu.19\' | translate}}</div><div class=\"overflow-auto quadContainer\" ng-attr-style=max-height:{{getAvailableHeight(410)}}px;><div class=msg-warning lang={{auth.lang}} ng-if=treeErr><span class=\"fa fa-warning text-warning marR5\" aria-hidden=true></span>{{\'cl.widget.msg.20\' | translate}}</div><div class=treeQuad ng-if=!treeErr bind-html-compile=htmStr></div></div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=iMenuFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.iMenu.1\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"iMenuFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'allFields\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'tree\'\" aria-live=polite role=status>{{\'cl.widget.msg.20\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/iotButton.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.iot.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.iot.2\' | translate}} &nbsp; <span ng-if=iot.label>[ {{iot.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-n tab-pm tab-ss\" aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-n role=tab aria-selected=true><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-pm role=tab aria-selected=false><a href=\"\" role=link ng-click=iotFx(1);><span class=badge>2</span>{{\'cl.widget.iot.3\' | translate | camelCase}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-ss role=tab aria-selected=false><a href=\"\" role=link ng-click=iotFx(3);><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'pm\'); editForm={isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.iot.5\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm={isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=!detailLoading><div class=\"row noMarR\" ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><div><label for=label>{{\'cl.label.1\' | translate}}</label></div><div class=marT5><input type=text id=label class=form-control ng-model=iot.label maxlength={{inputLimit}} autocomplete=off focus-me=true></div></div><div class=form-group><div><label>{{\'cl.widget.cm.7\' | translate}}</label></div><div class=\"pull-left marR20 text-center\" role=radiogroup aria-labelledby=radiogroup><label class=noMarB><img alt=\"Template 1\" class=bdr src=assets/images/widget/templates/iot_thumb1.png><div class=marT5><input type=radio role=radio ng-model=iot.settings.orientation value=l><label style=float:inherit;padding-right:10px;vertical-align:bottom></label>{{\'cl.widget.cm.8\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20 text-center\" role=radiogroup aria-labelledby=radiogroup><label class=noMarB><img alt=\"Template 2\" class=bdr src=assets/images/widget/templates/iot_thumb2.png><div class=marT5><input type=radio role=radio ng-model=iot.settings.orientation value=p><label style=float:inherit;padding-right:10px;vertical-align:bottom></label>{{\'cl.widget.cm.8\' | translate:{count: \'2\'} }}</div></label></div></div></div><div class=\"col-xs-8 marT15\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iot.settings.bg, opacity:iot.settings.bg}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iot.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.bg selected-type=iot.ctype.bg is-alpha=true selected-alpha=iot.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.cm.19\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!iot.isHidden && (iot.bgImg.thumb || iot.bgImg.type == \'SharePointC\' || iot.bgImg.type == \'OneDriveC\' || iot.bgImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeImgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=iot.bgImg.thumb ng-href=\"{{cDetailBucket + iot.bgImg.thumb | secureThumb}}\" role=button data-access={{iot.bgImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(iot.bgImg.path + (iot.bgImg.path.length > 1 ? \' / \' : \' \') + iot.bgImg.label)}}\" ng-show=iot.bgImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + iot.bgImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"iot.bgImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"iot.bgImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"iot.bgImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=iot.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button id=contentBtn class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div></div><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.iot.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div><div class=\"pull-left relative\" ng-if=iot.sound.isAccessible><span class=thumb-inner><a href=\"\" role=link class=thumb-close ng-click=removeAudioFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/sm/\' + iot.sound.thumb}}.png\"> <span class=\"thumb-icon cl\"><span ng-if=\"iot.sound.type == \'Audio\'\" class=vDuration>{{iot.sound.duration | durations}}</span></span></span><div>{{iot.sound.label}}</div></div><div class=clearfix></div><button type=button role=button id=audioBtn class=\"btn btn-primary btn-xs marT6\" ng-click=\"selectContentOpen(\'audio\');\">{{\'cl.widget.iot.8.1\' | translate}}</button></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=orientation>{{\'cl.widget.iot.4.11\' | translate}}</label><select id=orientation class=form-control ng-model=iot.settings.orientation aria-label=\"{{\'cl.widget.iot.4.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.11\' | translate}}\"><option value=l>{{\'fl.p_cfl.label.1.1\' | translate}}</option><option value=p>{{\'fl.p_cfl.label.1.2\' | translate}}</option></select></div><div class=col-xs-4><label for=grid>{{iot.settings.orientation==\'l\'?\'cl.widget.iot.4.12\':\'cl.widget.iot.4.13\' | translate}} <span class=\"text-muted text-sm\">(%)</span></label><input type=number id=grid class=form-control ng-model=iot.settings.grid min=1 max=100 aria-label=\"{{iot.settings.orientation==\'l\'?\'cl.widget.iot.4.12\':\'cl.widget.iot.4.13\' | translate}}\" aria-labelledby=\"{{iot.settings.orientation==\'l\'?\'cl.widget.iot.4.12\':\'cl.widget.iot.4.13\' | translate}}\"></div><div class=col-xs-4><label for=qcol>{{\'cl.widget.iot.4.14\' | translate}}</label><input type=number id=qcol class=form-control ng-model=iot.settings.qcol min=1 aria-label=\"{{\'cl.widget.iot.4.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.14\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=qmax>{{\'cl.widget.iot.4.15\' | translate}}</label><input type=number id=qmax class=form-control ng-model=iot.settings.qmax min=1 aria-label=\"{{\'cl.widget.iot.4.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.15\' | translate}}\"></div><div class=col-xs-4><label for=sTimeOut>{{\'cl.widget.iot.4.17\' | translate}} <span class=\"text-muted text-sm\">({{iot.settings.hd>1?\'cm.label.27s\':\'cm.label.27\' | translate}})</span></label><input type=number id=sTimeOut class=form-control ng-model=iot.settings.hd min=1 aria-label=\"{{\'cl.widget.iot.4.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.17\' | translate}}\"></div><div class=col-xs-4><label>{{\'cl.widget.iot.4.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sep><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.sep}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.sep | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sep=true\" readonly aria-label=\"{{\'cl.widget.iot.4.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.sep selected-type=iot.ctype.sep ng-if=colorPicker.sep></ng-hub-color-picker></div></div></div></div><div class=\"panel-inner-tab marB10 marT25\">{{\'cl.widget.iot.6\' | translate}}</div><div class=\"row marT15\"><div class=col-xs-12><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=iot.settings.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.titleText selected-type=iot.ctype.tt ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=iot.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=iot.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.iot.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.numText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.numText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nt=true\" readonly aria-label=\"{{\'cl.widget.iot.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.numText selected-type=iot.ctype.nt ng-if=colorPicker.nt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=numFont>{{\'cl.widget.iot.4.2\' | translate}}</label><select id=numFont class=form-control ng-model=iot.settings.numFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.iot.4.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.2\' | translate}}\"></select></div><div class=col-xs-4><label for=numSize>{{\'cl.widget.iot.4.3\' | translate}}</label><input type=number id=numSize class=form-control ng-model=iot.settings.numSize min=1 aria-label=\"{{\'cl.widget.iot.4.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.3\' | translate}}\"></div></div><div class=\"panel-inner-tab marB10 marT25\">{{\'cl.widget.iot.7\' | translate}}</div><div class=row><div class=col-xs-12><label for=qTitle>{{\'cm.label.23\' | translate}}</label><input type=text id=qTitle class=form-control ng-model=iot.settings.qTitle aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div></div><div class=\"row marT25\"><div class=col-xs-3><label>{{\'cl.widget.iot.4.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.qtt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.qtText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.qtText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.qtt=true\" readonly aria-label=\"{{\'cl.widget.iot.4.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.qtText selected-type=iot.ctype.qtt ng-if=colorPicker.qtt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=qtFont>{{\'cl.widget.iot.4.5\' | translate}}</label><select id=qtFont class=form-control ng-model=iot.settings.qtFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.iot.4.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.5\' | translate}}\"></select></div><div class=col-xs-3><label for=qtSize>{{\'cl.widget.iot.4.6\' | translate}}</label><input type=number id=qtSize class=form-control ng-model=iot.settings.qtSize min=1 aria-label=\"{{\'cl.widget.iot.4.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.6\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.qBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iot.settings.qBg, opacity:iot.settings.qBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.qBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.qBg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iot.settings.qBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.qBg selected-type=iot.ctype.qBg is-alpha=true selected-alpha=iot.settings.qBga ng-if=colorPicker.qBg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cm.label.64\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.qt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.qText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.qText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.qt=true\" readonly aria-label=\"{{\'cm.label.64\' | translate}}\" aria-labelledby=\"{{\'cm.label.64\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.qText selected-type=iot.ctype.qText ng-if=colorPicker.qt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=qFont>{{\'cm.label.24\' | translate}}</label><select id=qFont class=form-control ng-model=iot.settings.qFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=qSize>{{\'cm.label.83\' | translate}}</label><input id=qSize type=number class=form-control ng-model=iot.settings.qSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.iot.4.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':iot.settings.altBg, opacity:iot.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.iot.4.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.7\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{iot.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.altBg selected-type=iot.ctype.altBg is-alpha=true selected-alpha=iot.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.iot.4.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':iot.settings.altText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"iot.settings.altText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.iot.4.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=iot.settings.altText selected-type=iot.ctype.altText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=altFont>{{\'cl.widget.iot.4.9\' | translate}}</label><select id=altFont class=form-control ng-model=iot.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.iot.4.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.9\' | translate}}\"></select></div><div class=col-xs-3><label for=altSize>{{\'cl.widget.iot.4.10\' | translate}}</label><input type=number id=altSize class=form-control ng-model=iot.settings.altSize min=1 aria-label=\"{{\'cl.widget.iot.4.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.4.10\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=iot.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=iot.activePeriod></ng-active-period></div></div></div><!-- Placement Mapping --><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editForm.isShow><div class=row><div class=col-xs-4><label for=placement>{{\'cl.widget.iot.5.1\' | translate}}</label><input type=text id=placement class=form-control ng-model=addIoT.p aria-label=\"{{\'cl.widget.iot.5.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.5.1\' | translate}}\"></div><div class=col-xs-4><label for=screenVal>{{\'cl.widget.iot.5.2\' | translate}}</label><input type=text id=screenVal class=form-control ng-model=addIoT.v aria-label=\"{{\'cl.widget.iot.5.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iot.5.2\' | translate}}\"></div><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.iot.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div><div class=\"pull-left relative\" ng-if=addIoT.s><div><span class=thumb-inner><a href=\"\" role=link class=thumb-close ng-click=\"removeAudioFx(\'pm\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/sm/\' + addIoT.s.thumb}}.png\"> <span class=\"thumb-icon cl\"><span ng-if=\"addIoT.s.type == \'Audio\'\" class=vDuration>{{addIoT.s.duration | durations}}</span></span></span></div><span>{{addIoT.s.label}}</span></div><div class=clearfix></div><button type=button role=button class=\"btn btn-primary btn-xs marT6\" ng-click=\"selectContentOpen(\'audio\');\">{{\'cl.widget.iot.8.1\' | translate}}</button></div></div></div></div><div class=\"row marT15\"><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addPMFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addPMFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'pm\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addPMFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'placement\'\" aria-live=polite role=status>{{\'cl.widget.iot.m11\' | translate}}</div><div ng-if=\"errType==\'value\'\" aria-live=polite role=status>{{\'cl.widget.iot.m12\' | translate}}</div></div></div></div><div class=clearfix></div></div><div class=form-group><div class=\"table table-md\"><div class=\"row th\"><div class=col-xs-2>{{\'cl.widget.iot.5.1\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.iot.5.2\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.iot.8\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.fwp.6\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div ng-if=\"iot.list.length>0\"><div class=row ng-repeat=\"pm in iot.list | reverse\"><div class=col-xs-2>{{pm.p}}</div><div class=col-xs-2>{{pm.v}}</div><div class=col-xs-3><span class=text-ellipsis ng-if=\"pm.s.label != \'\'\">{{pm.s.label}}</span> <span class=text-muted ng-if=!pm.s.label>N/A</span></div><div class=\"col-xs-3 word-break\"><span ng-if=\"pm.encId && pm.encId!=\'\'\"><button type=button role=button class=\"btn btn-default btn-xs noMarT marR10 pull-left\" ngclipboard data-clipboard-text={{pm.encId}} uib-tooltip=\"{{\'d.tool.17\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-xs fa-files-o noMar\" aria-hidden=true></span></button>{{pm.encId}} </span><span class=text-muted ng-if=!pm.encId>N/A</span></div><div class=\"col-xs-2 text-right\"><a ng-if=\"pm.encId && pm.encId!=\'\'\" href=\"{{iot.urlPre + pm.encId}}\" class=\"text-primary marR5\" target=_blank uib-tooltip=\"{{\'cl.widget.cm.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-external-link\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'pm\', pm);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'pm\', pm.id);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"iot.list.length == 0\">{{\'cl.widget.iot.m13\' | translate}}</div></div></div></div><!-- screen saver --><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=asLabel>{{\'cm.brief.1\' | translate}}</label><input type=text id=asLabel class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=asContentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=col-xs-4><label for=asDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=asDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-4>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-4>{{ss.ss.duration}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=backBtnFx(); ng-disabled=nextProcessing><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=iotFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.iot.3\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=iotFx(3); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"iotFx(0, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'grid\'\" aria-live=polite role=status>{{iot.settings.orientation==\'l\'?\'cl.widget.iot.m1\':\'cl.widget.iot.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.iot.m6\' | translate}}</div><div ng-if=\"errType==\'altSize\'\" aria-live=polite role=status>{{\'cl.widget.iot.m10\' | translate}}</div><div ng-if=\"errType==\'numSize\'\" aria-live=polite role=status>{{\'cl.widget.iot.m7\' | translate}}</div><div ng-if=\"errType==\'qtSize\'\" aria-live=polite role=status>{{\'cl.widget.iot.m8\' | translate}}</div><div ng-if=\"errType==\'qSize\'\" aria-live=polite role=status>{{\'cl.widget.iot.m9\' | translate}}</div><div ng-if=\"errType==\'qcol\'\" aria-live=polite role=status>{{\'cl.widget.iot.m3\' | translate}}</div><div ng-if=\"errType==\'qmax\'\" aria-live=polite role=status>{{\'cl.widget.iot.m4\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'hd\'\" aria-live=polite role=status>{{\'cl.widget.iot.m5\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/jciMap.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.jci.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.jci.2\' | translate}} &nbsp; <span ng-if=jci.label>[ {{jci.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=jci.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\" aria-placeholder=\"{{\'cl.label.1\' | translate}}\"></div><!-- <div class=\"form-group hide\">\r\n        <label for=\"k\">{{\'cl.widget.jci.3\' | translate}}</label>\r\n        <div class=\"form-group\" >\r\n          <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"chLoading\">\r\n          <div class=\"dropdown customSelect customSelectKiosk\" uib-dropdown auto-close=\"outsideClick\" ng-if=\"!chLoading\">\r\n            <span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"kioskSearchFocus();\" aria-placeholder=\"{{\'cl.widget.jci.3.1\' | translate}}\">\r\n              {{jci.kiosk.kioskName}}\r\n              <span ng-if=\"jci.kiosk== \'\'\">{{\'cl.widget.jci.3.1\' | translate}}</span>\r\n              <span class=\"caret\"></span>\r\n            </span>\r\n            <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" ng-if=\"kioskList.k.length > 1\">\r\n              <li class=\"dropdown-header noMar\" ng-if=\"kioskList.k.length > 5\">\r\n                <div class=\"searchTbx findSearch\">\r\n                  <input type=\"text\" class=\"form-control\" ng-model=\"searchKiosk.kioskName\" placeholder=\"{{\'cm.ph.1\' | translate}}\"  aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\">\r\n                  <a href=\"\" role=\"link\" class=\"text-danger\" ng-show=\"searchKiosk.kioskName.length\" ng-click=\"searchKiosk.kioskName=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"  aria-hidden=\"true\"></span></a>\r\n                </div>\r\n              </li>\r\n              <li class=\"divider\" role=\"separator\" ng-if=\"kioskList.k.length > 5\"></li>\r\n              <div class=\"list-scroll ng-cloak\">\r\n                <li ng-repeat=\"k in kiosk = (kioskList.k | orderBy: \'kioskName\' | kioskFilter:searchKiosk.kioskName)\" tabindex=\"$index\">\r\n                  <label ng-model=\"k.selected\" ng-click=\"changeKioskSetting(k);\"> <label></label> {{k.kioskName}}</label>\r\n                </li>\r\n                <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"kiosk.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{searchKiosk.kioskName}}&quot;</b>\'}\"></div>\r\n              </div>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div> --><div class=form-group><div><label for=kType><input type=checkbox role=checkbox aria-labelledby=kType ng-model=jci.settings.kType><label></label><span translate=\"{{\'cl.widget.jci.5\'}}\" translate-values=\"{htmlTagO:\'<u>\', htmlTagC:\'</u>\'}\"></span></label></div></div><div class=form-group ng-if=!jci.settings.kType><label for=k>{{\'cl.widget.jci.3\' | translate}}</label><div class=form-group ng-if=chLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick ng-if=!chLoading><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=kioskSearchFocus(); aria-placeholder=\"{{\'cl.widget.jci.3.1\' | translate}}\"><span ng-if=\"jci.kiosk== \'\'\">{{\'cl.widget.jci.3.1\' | translate}}</span> <span ng-if=\"jci.kiosk!= \'\'\">{{jci.kiosk.kioskName}}<span class=\"text-muted text-sm inline\"> - ({{jci.kiosk.kioskId}})</span></span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"kioskList.k.length > 5\"><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchKiosk.kioskName sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger noMarT\" ng-show=searchKiosk.kioskName.length ng-click=\"searchKiosk.kioskName=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"kioskList.k.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"k in kiosk = (kioskList.k | orderBy: \'kioskName\' | kioskFilter:searchKiosk.kioskName:\'widget\')\" tabindex=$index><label><input type=radio role=radio name=kOpt value=\"{{ {kioskId:k.kioskId, kioskName:k.kioskName} }}\" ng-checked=\"k.kioskId == jci.kiosk.kioskId\" ng-model=jci.kiosk ng-change=singleKioskFx(k) ng-disabled=\"k.kioskId == jci.kiosk.kioskId\"><label></label>{{k.kioskName}}<span class=\"text-muted text-sm inline\"> - ({{k.kioskId}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"kiosk.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchKiosk.kioskName)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div class=\"form-group hide\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=jci.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.sc.11\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=jci.dType value=l><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=jci.dType value=m><label></label>{{\'cl.widget.sc.10\' | translate}}</label></div></div><div class=\"form-group hide\"><div class=\"marR20 marB20\" ng-if=\"jci.dType == \'t\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/textMedia.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"jci.dType == \'l\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/list.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"jci.dType == \'m\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/media.png alt=\"Template 3\"></label></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\"></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=jci.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio ng-model=jci.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"jci.settings.reloadOpt == \'c\'\"><input type=number class=form-control ng-model=jci.settings.reload focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=hide ng-if=\"jci.dType == \'t\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"textMedia.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=textMedia.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.bg, opacity:textMedia.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.bg selected-type=jci.ctype.bg is-alpha=true selected-alpha=textMedia.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.textBg, opacity:textMedia.settings.textBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.textBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.textBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.textBg selected-type=jci.ctype.textBg is-alpha=true selected-alpha=textMedia.settings.textBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.9\' | translate}}</label><select class=form-control ng-model=textMedia.settings.align><option value=l>{{\'cm.editor.10.4\' | translate}}</option><option value=c>{{\'cm.editor.10.5\' | translate}}</option><option value=r>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.titleText selected-type=jci.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=textMedia.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.descText selected-type=jci.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.descSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.survey.8\' | translate}}</label><select class=form-control ng-model=textMedia.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div class=hide ng-if=\"jci.dType == \'l\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=list.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio ng-model=list.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"list.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=list.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio ng-model=list.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio ng-model=list.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio ng-model=list.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"list.settings.hTextOpt==\'c\'\"><input type=text class=form-control ng-model=list.settings.hText maxlength={{inputLimit}} focus-me=true></div></div><div class=row ng-if=\"list.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.headerBg, opacity:list.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerBg selected-type=jci.ctype.headerBg is-alpha=true selected-alpha=list.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerText selected-type=jci.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control ng-model=list.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.bg, opacity:list.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.bg selected-type=jci.ctype.bg is-alpha=true selected-alpha=list.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.rowBg, opacity:list.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.rowBg selected-type=jci.ctype.rowBg is-alpha=true selected-alpha=list.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.altBg, opacity:list.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altBg selected-type=jci.ctype.altBg is-alpha=true selected-alpha=list.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.8\' | translate}}</label><select class=form-control ng-model=list.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.fs.10\' | translate}}</label><select class=form-control ng-model=list.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.cm.31\' | translate}}</label><input type=number class=form-control ng-model=list.settings.headerSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.titleText selected-type=jci.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.subtitleText selected-type=jci.ctype.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.descText selected-type=jci.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altTitleText selected-type=jci.ctype.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ast><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altSubtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altSubtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ast=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altSubtitleText selected-type=jci.ctype.altSubtitleText ng-if=colorPicker.ast></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altDescText selected-type=jci.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=list.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.oc.15\' | translate}}</label><input type=number class=form-control ng-model=list.settings.subtitleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=list.settings.descSize min=1></div></div></div><div class=hide ng-if=\"jci.dType == \'m\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':media.settings.bg, opacity:media.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"media.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{media.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=media.settings.bg selected-type=jci.ctype.bg is-alpha=true selected-alpha=media.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"media.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=media.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=jci.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=jci.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=jciMapFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'kiosk\'\" aria-live=polite role=status>{{\'cl.widget.jci.m1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'sSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'reloadEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.wp.m1\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/linkedIn.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.in.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.in.2\' | translate}} &nbsp; <span ng-if=in.label>[ {{in.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=inFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=in.labelOpt value=a><label></label>{{\'cl.widget.in.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=in.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"in.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=in.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=pc>{{\'Post count\' | translate}}</label><input type=number id=pc class=form-control ng-model=in.postCount min=1 max=60 aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div></div><!-- <div class=\"form-group\">\r\n          <label>{{\'cl.widget.cm.9\' | translate}}</label>\r\n          <div role=\"radiogroup\" aria-labelledby=\"radiogroup\">\r\n            <label class=\"noMarB marR10\"><input type=\"radio\" role=\"radio\" name=\"dTypeOpt\" ng-model=\"in.dType\" value=\"t\"><label></label> {{\'cl.widget.fb.5\' | translate}}</label>\r\n            <label class=\"noMarB\"><input type=\"radio\" role=\"radio\" name=\"dTypeOpt\" ng-model=\"in.dType\" value=\"m\"><label></label> {{\'cl.widget.fb.6\' | translate}}</label>\r\n          </div>\r\n        </div> --></div><div class=col-xs-8 ng-if=\"in.dType == \'t\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=in.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=in.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"in.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=in.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=in.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=in.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=in.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"in.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=in.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"in.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':in.settings.headerBg, opacity:in.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{in.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.headerBg selected-type=in.ctype.headerBg is-alpha=true selected-alpha=in.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':in.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.headerText selected-type=in.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=in.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':in.settings.bg, opacity:in.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{in.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.bg selected-type=in.ctype.bg is-alpha=true selected-alpha=in.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':in.settings.rowBg, opacity:in.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{in.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.rowBg selected-type=in.ctype.rowBg is-alpha=true selected-alpha=in.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':in.settings.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.rowText selected-type=in.ctype.rowText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=in.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':in.settings.altBg, opacity:in.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{in.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.altBg selected-type=in.ctype.altBg is-alpha=true selected-alpha=in.settings.altBga ng-if=colorPicker.ab></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':in.settings.altRowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"in.settings.altRowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=in.settings.altRowText selected-type=in.ctype.altRowText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=altRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altRowFont class=form-control ng-model=in.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=in.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=in.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.in.4\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=companyShow>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div class=\"d-flex align-items-center\"><button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{companyShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button><span ng-if=in.auth class=\"bg-success text-success text-sm bdr-rad-2 marL10 padTB5 padLR10\" uib-tooltip=\"{{\'cl.widget.cm.83\' | translate}}\" tooltip-popup-delay=500><span class=\"fa fa-check marR5\"></span>{{in.auth}}</span></div></div><div class=form-group ng-if=companyShow><label for=company>{{\'cl.widget.in.5\' | translate}}</label><select id=company class=form-control ng-model=in.company ng-options=\"company.label for company in companyList track by company.id\" aria-label=\"{{\'cl.widget.in.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.in.5\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.in.5.1\' | translate}}</option></select></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=inFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"inFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'pc\'\" aria-live=polite role=status>{{\'cl.widget.in.m3\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.in.m7\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.in.m1\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'companyEmpty\'\" aria-live=polite role=status>{{\'cl.widget.in.m2\' | translate}}</div><div ng-if=\"errType==\'company\'\" aria-live=polite role=status>{{\'cl.widget.in.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/liveStreaming.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.ls.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.ls.2\' | translate}} &nbsp; <span ng-if=liveS.label>[ {{liveS.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=liveS.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=sType>{{\'cl.widget.ls.4\' | translate}} <a href=\"\" ng-click=infoOpen(); uib-tooltip=\"{{\'cl.widget.ls.p.1\' | translate}}\" tooltip-placement=right tooltip-popup-delay=500><span class=\"fa fa-info-circle\"></span></a></label><select id=sType class=form-control ng-model=liveS.type ng-change=setPlaceHolderFx(); aria-label=\"{{\'cl.widget.ls.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ls.4\' | translate}}\"><option value=hls>{{\'cl.widget.ls.4-1\' | translate}}</option><option value=https>{{\'cl.widget.ls.4-2\' | translate}}</option><option value=rtsp>{{\'cl.widget.ls.4-3\' | translate}}</option><option value=udp>{{\'cl.widget.ls.4-5\' | translate}}</option><option value=yt>{{\'cl.widget.ls.4-4\' | translate}}</option></select></div><div class=form-group><label for=url>{{\'cl.widget.ls.3\' | translate}}</label><input type=text id=url class=form-control ng-model=liveS.url placeholder=\"{{\'cm.ph.3\' | translate}}: {{placeHolder}}\" aria-label=\"{{\'cl.widget.ls.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ls.3\' | translate}}\"></div></div><div class=col-xs-7 ng-if=\"liveS.type == \'hls\'\"><div class=form-group><button type=button role=button class=\"btn btn-primary btn-xs pull-right\" ng-click=openLanguageFx(); ng-if=settingsOpen>Add Language</button> <a href=\"\" role=link class=\"btn btn-link btn-xs pull-right marR5\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=\"col-xs-12 marB10\"><div class=form-group><div class=\"marT15 marB10\"><label class=noMarB>{{\'cl.label.10\' | translate}}</label><div class=pull-right><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=addRowFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=bdr-top-dashed><div class=table ng-if=\"liveS.caption.length > 0\"><div class=\"row th\"><div class=col-xs-4>{{\'cl.widget.oh.8\' | translate}}</div><div class=col-xs-7>{{\'cl.widget.cm.10\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.ls.9\' | translate}})</span></div><div class=\"col-xs-1 noPadL text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad><div class=row ng-repeat=\"cap in liveS.caption\"><div class=col-xs-4><select id=lang class=\"form-control lsSelect\" ng-model=cap.lang ng-options=\"lang.label for lang in langObj.languages track by lang.id\" aria-label=languages aria-labelledby=languages><option value=\"\">{{\'cm.label.34\' | translate}}</option></select></div><div class=col-xs-7><input type=text id=url class=\"form-control input-sm\" ng-model=cap.url aria-label=url aria-labelledby=url></div><div class=\"col-xs-1 noPadL text-right\"><a href=\"\" role=link name=remove class=\"pad2 text-danger\" ng-click=\"confirmOpen($index, cap.label, cap.email);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"liveS.caption.length == 0\">{{\'cl.widget.ls.m2\' | translate}}</div></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':liveS.settings.bg, opacity:liveS.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"liveS.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{liveS.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=liveS.settings.bg selected-type=liveS.ctype.bg is-alpha=true selected-alpha=liveS.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=capFont>{{\'cl.widget.ls.6\' | translate}}</label><select id=capFont class=form-control ng-model=liveS.settings.capFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.ls.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ls.6\' | translate}}\"></select></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.ls.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':liveS.settings.capTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"liveS.settings.capTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.ls.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ls.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=liveS.settings.capTxt selected-type=liveS.ctype.hour ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=capSize>{{\'cl.widget.ls.7\' | translate}}</label><input type=number id=capSize class=form-control ng-model=liveS.settings.capSize min=1 aria-label=\"{{\'cl.widget.ls.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ls.7\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=liveS.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=liveS.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=liveStreamingFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.ls.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'capSize\'\" aria-live=polite role=status>{{\'cl.widget.ls.m3\' | translate}}</div><div ng-if=\"errType==\'eLang\'\" aria-live=polite role=status>{{\'cl.msg.41\' | translate}}</div><div ng-if=\"errType==\'eURL\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'langExist\'\" aria-live=polite role=status>{{\'cl.widget.ls.m5\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/meeting.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.meeting.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.meeting.2\' | translate}} &nbsp; <span ng-if=meeting.info.label>[ {{meeting.info.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-n tab-m tab-ss tab-rl\" aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-n role=tab aria-selected=true><a href=\"\" role=link ng-click=tabFx(1); ng-disabled=reponseLoad><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-m role=tab aria-selected=false><a href=\"\" role=link ng-click=meetingFx(1); ng-disabled=reponseLoad><span class=badge>2</span>{{\'cl.widget.meeting.3\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-ss role=tab aria-selected=false><a href=\"\" role=link ng-click=meetingFx(3); ng-disabled=reponseLoad><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'4\'}\" id=tab-rl role=tab aria-selected=false><a href=\"\" role=link ng-click=meetingFx(4); ng-disabled=reponseLoad><span class=badge>4</span>{{\'cl.widget.meeting.7\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'m\'); editMForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'2\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.5\' | translate}}</button><div class=\"btn-group marL5\" uib-dropdown ng-show=\"selectedT==\'2\'\"><button type=button role=button class=\"btn btn-default btn-xs\" uib-dropdown-toggle><span class=\"fa fa-print\" aria-hidden=true></span>Print</button><ul role=menu class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu><li role=menuitem><a href=\"\" role=link ng-click=\"meetingPrint(\'d\')\">{{\'cl.widget.meeting.14\' | translate}}</a></li><li role=menuitem><a href=\"\" role=link ng-click=\"meetingPrint(\'w\')\">{{\'cl.widget.meeting.15\' | translate}}</a></li><li role=menuitem><a href=\"\" role=link ng-click=\"meetingPrint(\'m\')\">{{\'cl.widget.meeting.16\' | translate}}</a></li></ul></div><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'r\'); editRForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'4\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.20\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-6><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=meeting.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-11><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- Roomboard--><div class=\"panel-inner-tab marB10\">{{\'cl.widget.oc.4\' | translate}}</div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.rb.bg, opacity:meeting.info.settings.rb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.rb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.rb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.rb.bg selected-type=meeting.info.ctype.rb.bg is-alpha=true selected-alpha=meeting.info.settings.rb.bga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.rb.ssbg, opacity:meeting.info.settings.rb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.rb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.rb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.rb.ssbg selected-type=meeting.info.ctype.rb.ssbg is-alpha=true selected-alpha=meeting.info.settings.rb.ssbga ng-if=colorPicker.rsb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoRBOpt ng-model=meeting.info.settings.rb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoRBOpt ng-model=meeting.info.settings.rb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.rb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.rb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.rb.titleText selected-type=meeting.info.ctype.rb.titleText ng-if=colorPicker.rtt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=rbTitleFont class=form-control ng-model=meeting.info.settings.rb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=meeting.info.settings.rb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rst><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.rb.subtitleText}\"></span></span> <input type=text id=rbSubtitleText class=\"form-control picker\" ng-value=\"meeting.info.settings.rb.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rst=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.rb.subtitleText selected-type=meeting.info.ctype.rb.subtitleText ng-if=colorPicker.rst></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbSubtitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select id=rbSubtitleFont class=form-control ng-model=meeting.info.settings.rb.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubtitleSize class=form-control ng-model=meeting.info.settings.rb.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.rb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.rb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.rb.timeText selected-type=meeting.info.ctype.rb.timeText ng-if=colorPicker.rtm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=rbTimeFont class=form-control ng-model=meeting.info.settings.rb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=meeting.info.settings.rb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.28\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=meeting.info.settings.rb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=meeting.info.settings.rb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"meeting.info.settings.rb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbPrior class=form-control ng-model=meeting.info.settings.rb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.28\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.29\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=meeting.info.settings.rb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=meeting.info.settings.rb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"meeting.info.settings.rb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbAfter class=form-control ng-model=meeting.info.settings.rb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.29\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.29\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Wallboard --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.oc.5\' | translate}}</div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=meeting.info.settings.wb.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=meeting.info.settings.wb.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"meeting.info.settings.wb.rotationOpt == \'c\'\"><input type=number id=wbCRotate class=form-control ng-model=meeting.info.settings.wb.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=flex1></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.wb.bg, opacity:meeting.info.settings.wb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.wb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.bg selected-type=meeting.info.ctype.wb.bg is-alpha=true selected-alpha=meeting.info.settings.wb.bga ng-if=colorPicker.wb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.wb.ssbg, opacity:meeting.info.settings.wb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wsb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.wb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.ssbg selected-type=meeting.info.ctype.wb.ssbg is-alpha=true selected-alpha=meeting.info.settings.wb.ssbga ng-if=colorPicker.wsb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoWBOpt ng-model=meeting.info.settings.wb.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoWBOpt ng-model=meeting.info.settings.wb.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div><div class=flex1></div><div class=flex1></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=meeting.info.settings.wb.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=meeting.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label for=wbTitle>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=wbTitle class=\"form-control input-sm\" ng-model=meeting.info.settings.wb.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=meeting.info.settings.wb.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbTime>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=wbTime class=\"form-control input-sm\" ng-model=meeting.info.settings.wb.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=meeting.info.settings.wb.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbRoom>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=wbRoom class=\"form-control input-sm\" ng-model=meeting.info.settings.wb.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=meeting.info.settings.wb.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbFloor>{{\'cl.widget.meeting.8\' | translate}}</label><div class=input-group><input type=text id=wbFloor class=\"form-control input-sm\" ng-model=meeting.info.settings.wb.header.column4 aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col4TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=meeting.info.settings.wb.header.col4TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=meeting.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.whb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.wb.headerBg, opacity:meeting.info.settings.wb.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.whb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.wb.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.headerBg selected-type=meeting.info.ctype.wb.headerBg is-alpha=true selected-alpha=meeting.info.settings.wb.headerBga ng-if=colorPicker.whb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.headerText selected-type=meeting.info.ctype.wb.headerText ng-if=colorPicker.wht></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wbHeaderFont class=form-control ng-model=meeting.info.settings.wb.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=wbHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wbHeaderSize class=form-control ng-model=meeting.info.settings.wb.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div><!-- <div class=\"flex1 noMarR\">\r\n                <label for=\"btnTxtAlign\">{{\'cl.widget.oc.41\' | translate}}</label>\r\n                <select id=\"btnTxtAlign\" class=\"form-control\" ng-model=\"meeting.info.settings.wb.headerTxtAlign\" aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\">\r\n                  <option value=\"left\">{{\'cm.editor.10.4\' | translate}}</option>\r\n                  <option value=\"right\">{{\'cm.editor.10.6\' | translate}}</option>\r\n                  <option value=\"center\">{{\'cm.editor.10.5\' | translate}}</option>\r\n                </select>\r\n              </div> --></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.titleText selected-type=meeting.info.ctype.wb.titleText ng-if=colorPicker.wtt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wat=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.altTitleText selected-type=meeting.info.ctype.wb.altTitleText ng-if=colorPicker.wat></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=wbTitleFont class=form-control ng-model=meeting.info.settings.wb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=wbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wbTitleSize class=form-control ng-model=meeting.info.settings.wb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=meeting.info.settings.wb.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=meeting.info.settings.wb.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=meeting.info.settings.wb.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.timeText selected-type=meeting.info.ctype.wb.timeText ng-if=colorPicker.wtm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.watm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.watm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.altTimeText selected-type=meeting.info.ctype.wb.altTimeText ng-if=colorPicker.watm></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=wbTimeFont class=form-control ng-model=meeting.info.settings.wb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=meeting.info.settings.wb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=meeting.info.settings.wb.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=meeting.info.settings.wb.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=meeting.info.settings.wb.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.roomText selected-type=meeting.info.ctype.wb.roomText ng-if=colorPicker.wrt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wart><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wart=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.altRoomText selected-type=meeting.info.ctype.wb.altRoomText ng-if=colorPicker.wart></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wbRoomFont class=form-control ng-model=meeting.info.settings.wb.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input id=wbRoomSize type=number class=form-control ng-model=meeting.info.settings.wb.roomSize min=1></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=meeting.info.settings.wb.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=meeting.info.settings.wb.isFloor role=checkbox><label></label>{{\'cl.widget.meeting.31\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=meeting.info.settings.wb.isFloor><div class=\"flex1 noMarL\"><label>{{\'cl.widget.meeting.31.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.floorText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.floorText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wft=true\" readonly aria-label=\"{{\'cl.widget.meeting.31.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.31.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.floorText selected-type=meeting.info.ctype.wb.floorText ng-if=colorPicker.wft></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.31.2\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.waft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':meeting.info.settings.wb.altFloorText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.altFloorText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.waft=true\" readonly aria-label=\"{{\'cl.widget.meeting.31.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.31.2\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.altFloorText selected-type=meeting.info.ctype.wb.altFloorText ng-if=colorPicker.waft></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbFloorFont>{{\'cl.widget.meeting.31.3\' | translate}}</label><select id=wbFloorFont class=form-control ng-model=meeting.info.settings.wb.floorFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.meeting.31.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.31.3\' | translate}}\"></select></div><div class=flex1><label for=wbFloorSize>{{\'cl.widget.meeting.31.4\' | translate}}</label><input type=number id=wbFloorSize class=form-control ng-model=meeting.info.settings.wb.floorSize min=1 aria-label=\"{{\'cl.widget.meeting.31.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.31.4\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=floorTxtAlign>{{\'cl.widget.oc.44\' | translate}}</label><select id=floorTxtAlign class=form-control ng-model=meeting.info.settings.wb.floorTxtAlign aria-label=\"{{\'cl.widget.oc.44\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.44\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\" ng-if=\"meeting.info.settings.wb.isRoom && meeting.info.settings.wb.isFloor\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=meeting.info.settings.wb.isRF role=checkbox><label></label>{{\'cl.widget.meeting.32\' | translate}}</label></div></div></div><div class=\"marT20 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.wb.rowBg, opacity:meeting.info.settings.wb.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.wb.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.rowBg selected-type=meeting.info.ctype.wb.rowBg is-alpha=true selected-alpha=meeting.info.settings.wb.rowBga ng-if=colorPicker.wrb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':meeting.info.settings.wb.altBg, opacity:meeting.info.settings.wb.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"meeting.info.settings.wb.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{meeting.info.settings.wb.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=meeting.info.settings.wb.altBg selected-type=meeting.info.ctype.wb.altBg is-alpha=true selected-alpha=meeting.info.settings.wb.altBga ng-if=colorPicker.wab></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.30\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wdmOpt ng-model=meeting.info.settings.wb.wdmOpt value=d><label></label>{{\'cl.widget.meeting.30.1\' | translate}}</label><label class=marR10><input type=radio role=radio name=wdmOpt ng-model=meeting.info.settings.wb.wdmOpt value=w><label></label>{{\'cl.widget.meeting.30.2\' | translate}}</label><label><input type=radio role=radio name=wdmOpt ng-model=meeting.info.settings.wb.wdmOpt value=m><label></label>{{\'cl.widget.meeting.30.3\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.28\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=meeting.info.settings.wb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=meeting.info.settings.wb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"meeting.info.settings.wb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbPrior class=form-control ng-model=meeting.info.settings.wb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.28\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.29\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=meeting.info.settings.wb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=meeting.info.settings.wb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"meeting.info.settings.wb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbAfter class=form-control ng-model=meeting.info.settings.wb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.29\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.29\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Meetings --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.oc.38\' | translate}}</div><div class=row><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.27\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=mdrOpt ng-model=meeting.info.settings.mt.draType value=p><label></label>{{\'cl.widget.meeting.27.1\' | translate}}</label><label><input type=radio role=radio name=mdrOpt ng-model=meeting.info.settings.mt.draType value=o><label></label>{{\'cl.widget.meeting.27.2\' | translate}}</label></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=meeting.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=meeting.info.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=\"bg-light pad10 marB15\" ng-show=editMForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-8><div class=row><div class=col-xs-12><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=addMeeting.title aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div></div><div ng-class=\"addMeeting.roomOpt == \'c\'?\'col-xs-8\':\'col-xs-12\'\"><div class=form-group><label class=marR10><input type=radio role=radio name=roomOpt ng-model=addMeeting.roomOpt value=d><label></label>{{\'cl.widget.oc.10\' | translate}}</label><label class=noMarB><input type=radio role=radio name=roomOpt ng-model=addMeeting.roomOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><!-- TODO Added new btn --><div class=marT5 ng-if=\"addMeeting.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT10\">{{addMeeting.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-sm marT4 marL5\" ng-click=\"roomListView(addMeeting.mId ? \'u\' : \'n\', addMeeting.mId);\">{{\'cl.widget.tRoom.4\' | translate}}</button></div><div ng-if=\"addMeeting.roomOpt == \'c\'\"><input type=text id=roomLabel class=form-control ng-model=addMeeting.roomLabel maxlength={{inputLimit}} focus-me=true aria-label=\"room label\" aria-labelledby=\"room label\"></div></div></div><div class=col-xs-4 ng-if=\"addMeeting.roomOpt == \'c\'\"><div class=form-group><label for=roomFloor>{{\'cl.widget.meeting.8\' | translate}}</label><input type=text id=roomFloor class=form-control ng-model=addMeeting.roomFloor aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=amDate class=\"form-control picker\" ng-model=addMeeting.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=startTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addMeeting.startTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addMeeting.startTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=endTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"addMeeting.endTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=addMeeting.endTime hour-step=1 minute-step=5></div></div></span></div></div></div><div class=row><div class=\"col-xs-12 form-group\"><label class=noMar><input type=checkbox ng-model=addMeeting.showOnScreen role=checkbox><label></label>{{\'cl.widget.meeting.18\' | translate}}</label></div></div><div class=row><div class=\"col-xs-12 form-group\"><label class=noMar><input type=checkbox ng-model=addMeeting.showOnWB><label></label>{{\'cl.widget.meeting.35\' | translate}}</label></div></div></div><div class=col-xs-4 ng-if=\"(meeting.info.settings.rb.logoOpt || meeting.info.settings.wb.logoOpt)\"><div class=form-group><label>{{\'cl.widget.meeting.9\' | translate}} <span class=\"text-muted text-sm\">(80x80)</span></label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addMeeting.isHidden && (addMeeting.logo.thumb || addMeeting.logo.type == \'SharePointC\' || addMeeting.logo.type == \'OneDriveC\' || addMeeting.logo.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'l\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addMeeting.logo.thumb ng-href=\"{{cDetailBucket + addMeeting.logo.thumb | secureThumb}}\" role=button data-access={{addMeeting.logo.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addMeeting.logo.path + (addMeeting.logo.path.length > 1 ? \' / \' : \' \') + addMeeting.logo.label)}}\" ng-show=addMeeting.logo.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addMeeting.logo.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addMeeting.logo.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addMeeting.logo.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addMeeting.logo.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate | camelCase}}</button></div></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editMForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addMeetingFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addMeetingFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'m\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editMForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addMeetingFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editMForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'room\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=row><div class=\"col-xs-12 noPadR\"><header class=\"panel-inner-tab marT10 marB10\"><a href=\"\" role=link ng-class=\"{\'selected\':subTab==1}\" ng-click=\"subTabFx(1); searchText=\'\'\">{{\'em.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTab==2}\" ng-click=\"subTabFx(2); searchText=\'\'\">{{\'em.body.2\' | translate}}</a><div class=\"pull-right panel-tools noBdr marL5\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': meetingListInfo.sortType === \'title\' && meetingListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'asc\', meetingList, meetingListInfo, \'widgetmeetingsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': meetingListInfo.sortType === \'title\' && meetingListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'title\', \'desc\', meetingList, meetingListInfo, \'widgetmeetingsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cl.widget.meeting.26\' | translate}}</li><li ng-class=\"{\'selected\': meetingListInfo.sortType === \'startdate\' && meetingListInfo.sortVal === \'asc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'asc\', meetingList, meetingListInfo, \'widgetmeetingsort\');\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': meetingListInfo.sortType === \'startdate\' && meetingListInfo.sortVal === \'desc\'}\"><a href=\"\" role=link ng-click=\"sortFx(\'startdate\', \'desc\', meetingList, meetingListInfo, \'widgetmeetingsort\');\">{{\'cm.tool.1.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><img alt=Loading src=assets/images/loading.gif class=marT5 ng-if=subLoading><div ng-if=!subLoading><div class=\"table table-scroll\" ng-if=\"meetingList.length > 0\"><div class=\"row th\" ng-if=\"filteredMeetingList.length > 0\"><div class=col-xs-4>{{\'cm.label.23\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.12\' | translate | camelCase}}</div><div class=\"col-xs-1 noPadR\">{{\'cm.label.13\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><div ng-show=widgetList.meetingGT><div ng-repeat=\"filteredMeeting in groupedMeetingList\" ng-if=\"filteredMeetingList.length > 0\"><!-- Group --><div class=\"folderQuad treeDotIc mGroup\" ng-if=\"filteredMeeting.type == \'m\' && (filteredMeeting.meeting | customSearch:{key:searchText, module:\'mMeeting\'}).length\"><div class=folder-heading><div class=col-xs-12><div class=\"text-ellipsis text-bold\">{{filteredMeeting.title}}</div></div></div><div class=folder-content><div class=row ng-repeat=\"m in filteredMeetingList = (filteredMeeting.meeting | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=panel-body><div class=col-xs-4 style=min-height:18px><div class=\"user-tumb d-flex align-items-center\" ng-if=\"(meeting.info.settings.rb.logoOpt || meeting.info.settings.wb.logoOpt)\"><a ng-href=\"{{cDetailBucket + m.logo.thumb | secureThumb}}\" role=button data-access={{m.logo.isAccessible}} fancyboxable=fbTitleWithHome data-fancybox-title=\"{{m.logo.path + (m.logo.path.length > 1 ? \' / \' : \' \') + m.logo.label}}\" ng-if=\"m.logo.thumb && m.logo.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"m.logo.type != \'SharePointC\' && m.logo.type != \'OneDriveC\' && m.logo.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"m.logo.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"m.logo.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"m.logo.type == \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Flash\'\" class=img-responsive> </a><img alt=\"\" src=assets/images/default/na.png class=img-responsive ng-if=\"!m.logo.thumb && !m.logo.label && !m.logo.isAccessible\"><div class=\"pull-left relative\" ng-if=\"m.logo.thumb && !m.logo.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div></div><!-- TODO Added some changes --><div class=col-xs-2 ng-if=\"m.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT8\">{{m.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-xs marT6 marL5\" ng-click=\"roomListView(\'v\', m.mId);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-ellipsis hide\" ng-if=\"m.roomOpt == \'d\'\" uib-tooltip-template=\"\'list.html\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=!$last>,</span></span></div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"m.roomOpt == \'c\'\" uib-tooltip={{m.roomLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.roomLabel}}</div><div class=col-xs-3>{{m.date.startDate | date:\'mediumDate\'}} - {{m.date.endDate | date:\'mediumDate\'}}</div><div class=col-xs-1>{{m.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-1>{{m.endTime | date:\'hh:mm a\'}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'m\', m);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'m\', m.mId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div><script type=text/ng-template id=list.html><div class=\"text-left\">\r\n                                  <span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=\"!$last\">, </span></span>\r\n                                </div></script></div></div></div></div><!-- Single --><div ng-if=\"filteredMeeting.type == \'s\'\"><div class=folder-content><div class=\"row sRow\" ng-repeat=\"m in filteredMeetingList = (filteredMeeting.meeting | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=col-xs-4><div class=user-tumb ng-if=\"(meeting.info.settings.rb.logoOpt || meeting.info.settings.wb.logoOpt)\"><a ng-href=\"{{cDetailBucket + m.logo.thumb | secureThumb}}\" role=button data-access={{m.logo.isAccessible}} fancyboxable=fbTitleWithHome data-fancybox-title=\"{{m.logo.path + (m.logo.path.length > 1 ? \' / \' : \' \') + m.logo.label}}\" ng-if=\"m.logo.thumb && m.logo.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"m.logo.type != \'SharePointC\' && m.logo.type != \'OneDriveC\' && m.logo.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"m.logo.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"m.logo.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"m.logo.type == \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Flash\'\" class=img-responsive> </a><img alt=\"\" src=assets/images/default/na.png class=img-responsive ng-if=\"!m.logo.thumb && !m.logo.label && !m.logo.isAccessible\"><div class=\"pull-left relative\" ng-if=\"m.logo.thumb && !m.logo.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div ng-if=\"(meetingList | filter:{title:m.title}:true).length == 1\" class=text-ellipsis uib-tooltip={{m.title}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.title}}</div></div><!-- TODO Added some changes --><div class=col-xs-2 ng-if=\"m.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT8\">{{m.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-xs marT6 marL5\" ng-click=\"roomListView(\'v\', m.mId);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-ellipsis hide\" ng-if=\"m.roomOpt == \'d\'\" uib-tooltip-template=\"\'list.html\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=!$last>,</span></span></div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"m.roomOpt == \'c\'\" uib-tooltip={{m.roomLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.roomLabel}}</div><div class=col-xs-3>{{m.date.startDate | date:\'mediumDate\'}} - {{m.date.endDate | date:\'mediumDate\'}}</div><div class=col-xs-1>{{m.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-1>{{m.endTime | date:\'hh:mm a\'}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'m\', m);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'m\', m.mId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div><script type=text/ng-template id=list.html><div class=\"text-left\">\r\n                                <span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=\"!$last\">, </span></span>\r\n                              </div></script></div></div></div></div></div><!-- Normal --><div class=folder-content ng-show=!widgetList.meetingGT><div class=row ng-repeat=\"m in filteredMeetingList = (meetingList | customSearch:{key:searchText, module:\'mMeeting\'})\"><div class=col-xs-4><div class=user-tumb ng-if=\"(meeting.info.settings.rb.logoOpt || meeting.info.settings.wb.logoOpt)\"><a ng-href=\"{{cDetailBucket + m.logo.thumb | secureThumb}}\" role=button data-access={{m.logo.isAccessible}} fancyboxable=fbTitleWithHome data-fancybox-title=\"{{m.logo.path + (m.logo.path.length > 1 ? \' / \' : \' \') + m.logo.label}}\" ng-if=\"m.logo.thumb && m.logo.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"m.logo.type != \'SharePointC\' && m.logo.type != \'OneDriveC\' && m.logo.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"m.logo.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"m.logo.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + m.logo.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"m.logo.type == \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Flash\'\" class=img-responsive> </a><img alt=\"\" src=assets/images/default/na.png class=img-responsive ng-if=\"!m.logo.thumb && !m.logo.label && !m.logo.isAccessible\"><div class=\"pull-left relative\" ng-if=\"m.logo.thumb && !m.logo.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{m.title}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.title}}</div></div><!-- TODO Added some changes --><div class=col-xs-2 ng-if=\"m.roomOpt == \'d\'\"><span class=\"text-bold pull-left marT8\">{{m.rc}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-default btn-xs marT6 marL5\" ng-click=\"roomListView(\'v\', m.mId);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-2 text-ellipsis hide\" ng-if=\"m.roomOpt == \'d\'\" uib-tooltip-template=\"\'list.html\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=!$last>, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=!$last>,</span></span></div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"m.roomOpt == \'c\'\" uib-tooltip={{m.roomLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{m.roomLabel}}</div><div class=col-xs-3>{{m.date.startDate | date:\'mediumDate\'}} - {{m.date.endDate | date:\'mediumDate\'}}</div><div class=col-xs-1>{{m.startTime | date:\'hh:mm a\'}}</div><div class=col-xs-1>{{m.endTime | date:\'hh:mm a\'}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'m\', m);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'m\', m.mId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div><script type=text/ng-template id=list.html><div class=\"text-left\">\r\n                          <span ng-repeat=\"device in m.room.d\">{{device.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"group in m.room.g\"><span ng-if=\"$first && m.room.d.length\">, </span>{{group.room}}<span ng-if=\"!$last\">, </span></span><span ng-repeat=\"room in m.room.r\"><span ng-if=\"$first && (m.room.d.length || m.room.g.length)\">, </span>{{room.room}}<span ng-if=\"!$last\">, </span></span>\r\n                        </div></script></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredMeetingList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"meetingList.length == 0\">{{subTab==1?\'cl.widget.meeting.m2\':\'cl.widget.meeting.m2.1\' | translate}}</div></div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=label>{{\'cm.brief.1\' | translate}}</label><input type=text id=label class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=\"col-xs-2 noPadR\"><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span><!-- TODO added parameters in the btn --> <button type=button role=button id=deviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=duration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=duration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + ss.ss.url, ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}}<!-- TODO Added parameters btn --> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div><div ng-if=\"selectedT==\'4\'\" class=marL10><div class=\"bg-light pad10 marB15\" ng-show=editRForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.oc.10\' | translate}}</label><!-- TODO change the key name --> <input type=text id=room class=form-control ng-model=roomCU.l focus-me=true ng-if=\"roomCU.type == \'r\'\" aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <input type=text id=room class=form-control ng-model=roomCU.l ng-if=\"roomCU.type != \'r\'\" readonly aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=floor>{{\'cl.widget.meeting.8\' | translate}}</label><!-- TODO change the key name --> <input type=text id=floor class=form-control ng-model=roomCU.fl aria-label=\"{{\'cl.widget.meeting.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.8\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label for=dType>{{\'cl.widget.cm.9\' | translate}}</label><!-- TODO change the key name --><select id=dType class=form-control ng-model=roomCU.dt aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select></div></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editRForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"roomCUFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'r\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editRForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"roomCUFx(\'e\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=\"btn-link btn-sm\" ng-click=\"editRForm.isShow = false\" ng-disabled=\"addProcessing || addMoreProcessing\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'room\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m1\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><!-- TODO added scroll feature changes and added new tabs --><div class=\"form-group marT20\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchText sanitize-input ng-change=\"searchChangeDataDyn(searchText, \'rl\');\" ng-disabled=\"!allScrollDataList.rl.length && !curRoomList.length\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText = \'\';searchChangeDataDyn(searchText, \'rl\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':subTabRL==1}\" ng-click=\"subTabRLFx(1); searchText=\'\'\" ng-disabled=reponseLoad>{{\'cm.body.3\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':subTabRL==2}\" ng-click=\"subTabRLFx(2); searchText=\'\'\" ng-disabled=reponseLoad>{{\'cl.widget.meeting.17\' | translate}}</a></div><img class=\"marT10 marL10\" alt=Loading src=assets/images/loading.gif ng-if=roomListLoading><div class=\"table table-scroll marT5 marB15\" ng-if=!roomListLoading><div class=\"row th\"><div class=col-xs-5>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-4>{{\'cl.widget.meeting.8\' | translate}}</div><div class=col-xs-2>{{\'cl.widget.cm.9\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=\"{{ editRForm.isShow ? \'height:\' + (winH-250) + \'px\' : \'height:\' + (winH-110) + \'px\' }}\" id=scroll-container-rl dynamic-scroll-list st=stIndex.rl et=etIndex.rl list-data=scrollDataList.rl search-data=searchText have-more-data=haveMoreData.rl search-scroll=searchScroll.rl clone-data=allScrollDataList.rl have-more-search-data=haveMoreSearchData.rl quad-id=\"\'rl\'\" dd-open=true ng-if=\"subTabRL == 1\"><div class=\"row rowObj-rl\" id={{room.id}} ng-repeat=\"room in filteredDeviceList = (visibleData.rl)\" ng-if=\"!loadingPaging.rl && !room.isHidden\"><div ng-class=\"room.show? \'col-xs-4\' : \'col-xs-5\'\"><span ng-if=!room.show><div class=\"marR5 deviceStatus {{room.status}}\" uib-tooltip=\"{{room.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{room.l}}</span> <input type=text class=form-control ng-model=room.l ng-if=room.show readonly aria-label=\"room name\" aria-labelledby=\"room name\"></div><div class=col-xs-4><span ng-if=!room.show>{{room.fl}}</span> <input type=text class=form-control ng-model=room.fl ng-if=room.show aria-label=\"room floor\" aria-labelledby=\"room floor\"></div><div class=col-xs-2><span ng-if=!room.show><span ng-if=\"room.dt == \'rb\'\">{{\'cl.widget.oc.4\' | translate}}</span> <span ng-if=\"room.dt == \'wb\'\">{{\'cl.widget.oc.5\' | translate}}</span></span><div class=\"marT5 text-muted text-sm\" ng-if=\"!room.show && room.dt == \'wb\' && room.ae\">[{{\'cl.widget.meeting.34\' | translate}}]</div><select aria-label=displayType class=form-control ng-model=room.dt ng-if=room.show><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select><div class=marT5 ng-if=\"room.show && room.dt == \'wb\'\" uib-tooltip=\"{{\'cl.widget.meeting.33\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><label><input type=checkbox ng-model=room.ae role=checkbox><label></label>{{\'cl.widget.meeting.34\' | translate}}</label></div></div><div class=text-right ng-class=\"room.show? \'col-xs-2 noPad\' : \'col-xs-1\'\"><a href=\"\" role=link name=editRoom class=\"text-primary marR5\" ng-if=!room.show ng-click=\"room.show = !room.show; roomUCFx(\'e\', room)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-danger marR5\" ng-click=\"deleteOpen(\'r\', room.id);\" ng-if=\"room.type == \'r\'\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn btn-success\" ng-show=room.show ng-click=\"roomUCFx(\'u\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-link\" ng-show=room.show ng-click=\"roomUCFx(\'c\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && !loadingMore.rl\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && loadingMore.rl\"> <img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.rl><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.rl.length > 0 && filteredDeviceList.length == 0 && !loadingPaging.rl\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!allScrollDataList.rl.length>{{\'d.msg.1\' | translate}}</div></div><div class=scrollQuad ng-attr-style=\"{{ editRForm.isShow ? \'height:\' + (winH-250) + \'px\' : \'height:\' + (winH-110) + \'px\' }}\" ng-if=\"subTabRL == 2 && !room.isHidden\"><div class=row ng-repeat=\"room in filteredRoomList = (curRoomList | customSearch:{key:searchText, module:\'mRoom\'}) | orderBy:\'room\'\"><div ng-class=\"room.show? \'col-xs-4\' : \'col-xs-5\'\"><span ng-if=!room.show><!-- <div class=\"marR5 deviceStatus {{room.status}}\" uib-tooltip=\"{{room.status | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div> --> {{room.l}}</span> <input type=text class=form-control ng-model=room.l ng-if=room.show readonly aria-label=\"room name\" aria-labelledby=\"room name\"></div><div class=col-xs-4><span ng-if=!room.show>{{room.fl}}</span> <input type=text class=form-control ng-model=room.fl ng-if=room.show aria-label=\"room floor\" aria-labelledby=\"room floor\"></div><div class=col-xs-2><span ng-if=!room.show><span ng-if=\"room.dt == \'rb\'\">{{\'cl.widget.oc.4\' | translate}}</span> <span ng-if=\"room.dt == \'wb\'\">{{\'cl.widget.oc.5\' | translate}}</span></span><div class=\"marT5 text-muted text-sm\" ng-if=\"!room.show && room.dt == \'wb\' && room.ae\">[{{\'cl.widget.meeting.34\' | translate}}]</div><select aria-label=displayType class=form-control ng-model=room.dt ng-if=room.show><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select><div class=\"marT5 hide\" ng-if=\"room.show && room.dt == \'wb\'\" uib-tooltip=\"{{\'cl.widget.meeting.33\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><label><input type=checkbox ng-model=room.ae role=checkbox><label></label>{{\'cl.widget.meeting.34\' | translate}}</label></div></div><div class=text-right ng-class=\"room.show? \'col-xs-2 noPad\' : \'col-xs-1\'\"><a href=\"\" role=link name=editRoom class=\"text-primary marR5\" ng-if=!room.show ng-click=\"room.show = !room.show; roomUCFx(\'e\', room)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-danger marR5\" ng-click=\"deleteOpen(\'r\', room.id);\" ng-if=\"room.type == \'r\'\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn btn-success\" ng-show=room.show ng-click=\"roomUCFx(\'u\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-link\" ng-show=room.show ng-click=\"roomUCFx(\'c\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"curRoomList.length > 0 && filteredRoomList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=!curRoomList.length>{{\'d.msg.1\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\" ng-disabled=reponseLoad><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=meetingFx(1); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=meetingFx(3); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'3\'\" ng-click=meetingFx(4); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"meetingFx(0, \'save\');\" ng-if=\"encId || selectedT==\'4\'\" ng-disabled=\"nextProcessing || saveProcessing || reponseLoad\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div><div ng-if=\"errType==\'roomExists\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m6\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/message.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.message.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.message.2\' | translate}} &nbsp; <span ng-if=message.label>[ {{message.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=message.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=form-control ng-model=message.title maxlength={{inputLimit}} aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=form-group><label for=desc>{{\'cm.label.85\' | translate}}</label><textarea id=desc class=\"form-control txtAreaBig\" ng-model=message.desc maxlength={{descriptionLimit}} aria-label=\"{{\'cm.label.85\' | translate}}\" aria-labelledby=\"{{\'cm.label.85\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - message.desc.length}} ]</span></div></div><div class=col-xs-12><div class=row><div class=col-xs-7><div class=form-group><label>{{\'cm.label.44\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!message.isHidden && (message.content.thumb || message.content.type == \'SharePointC\' || message.content.type == \'OneDriveC\' || message.content.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeImgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=message.content.thumb ng-href=\"{{cDetailBucket + message.content.thumb | secureThumb}}\" role=button data-access={{message.content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(message.content.path + (message.content.path.length > 1 ? \' / \' : \' \') + message.content.label)}}\" ng-show=message.content.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + message.content.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"message.content.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"message.content.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"message.content.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=message.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button id=contentBtn class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div><!-- For popover image show --><script type=text/ng-template id=bgImg.html><img alt=\"\" ng-src=\"{{tim + cBucket + message.content.thumb}}&h=135&w=215&q=80&zc=3\">\r\n            <div class=\"marT5\"><span class=\"glyphicon glyphicon-home marR5\" aria-hidden=\"true\"></span>{{message.content.path}}</div></script></div></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label for=imgPosition>{{\'cl.widget.message.3\' | translate}}</label><div class=row><div class=col-xs-4><select id=imgPosition class=form-control ng-model=message.settings.imgPosition aria-label=\"{{\'cl.widget.message.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.message.3\' | translate}}\"><option value=t>{{\'cl.widget.message.3.1\' | translate}}</option><option value=r>{{\'cl.widget.message.3.2\' | translate}}</option><option value=b>{{\'cl.widget.message.3.3\' | translate}}</option><option value=l>{{\'cl.widget.message.3.4\' | translate}}</option><option value=bg>{{\'cl.widget.message.3.6\' | translate}}</option></select></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':message.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"message.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=message.settings.titleText selected-type=message.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=titleSize class=form-control ng-model=message.settings.titleSize min=1 max=125 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=message.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.survey.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':message.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"message.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.survey.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.10\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=message.settings.descText selected-type=message.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=descSize>{{\'cl.widget.cm.42\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=descSize class=form-control ng-model=message.settings.descSize min=1 max=125 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div><div class=col-xs-4><label for=descFont>{{\'cl.widget.survey.8\' | translate}}</label><select id=descFont class=form-control ng-model=message.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.8\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=message.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=message.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=messageFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'desc\'\" aria-live=polite role=status>{{\'cs.msg.5\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.msg.4\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'content\'\" aria-live=polite role=status>{{\'cl.widget.msg.29\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'info\'\" aria-live=polite role=status>{{\'cl.widget.msg.27\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/msTeams.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.msTeams.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.msTeams.2\' | translate}} &nbsp; <span ng-if=msTeams.label>[ {{msTeams.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=msTeams.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio ng-model=msTeams.dType value=m name=dTypeOpt><label></label>{{\'cl.widget.msTeams.3\' | translate}}</label><label class=\"marL10 noMarB\"><input type=radio role=radio ng-model=msTeams.dType value=gm name=dTypeOpt><label></label>{{\'cl.widget.msTeams.3.1\' | translate}}</label></div></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=msTeams.url maxlength=1000 aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=msTeams.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=msTeams.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=msTeamsFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/musicChoice.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.mc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.mc.2\' | translate}} &nbsp; <span ng-if=mcName.label>[ {{mcName.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=musicChoiceFx(1);><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=musicChoiceFx(2);><span class=badge>2</span>{{\'cl.widget.mc.3\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=musicChoiceFx(3);><span class=badge>3</span>{{\'cl.widget.mc.4\' | translate}}</a></li><div class=pull-right ng-if=\"selectedT==\'3\'\"><a href=\"\" role=link ng-click=openDoNotPlaylist(); class=\"btn btn-primary btn-xs\">{{\'cl.widget.mc.12\' | translate}}</a></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=\"msg-warning marB10\" lang={{auth.lang}}>{{\'cl.widget.mc.m10\' | translate}}</div><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=mcName.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label class=noMarB><input type=checkbox ng-model=mcName.isRandom role=checkbox><label></label>{{\'cl.widget.mc.5\' | translate}}</label></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=mcName.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=mcName.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div class=\"musicCBox row\"><div class=col-xs-5><label>{{\'cl.widget.mc.6\' | translate}} <span class=\"text-sm text-muted\">[ {{categories.availableCategories.length}} ]</span></label><ul class=\"list-unstyled list-striped overflow-y bg-light bdr\" ng-attr-style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.99)}}px;\"><li ng-repeat=\"ac in categories.availableCategories\" uib-tooltip=\"{{\'cl.widget.mc.t1\' | translate}}\" tooltip-enable=!ac.totalCount ng-class=\"{\'disabledRow\': !ac.totalCount}\"><label class=noMarB><input type=checkbox ng-model=ac.isSelected ng-disabled=!ac.totalCount role=checkbox><label></label>{{ac.CategoryName}} - <span class=\"text-sm text-muted\">[ {{ac.totalCount}} ]</span></label></li></ul></div><div class=\"col-xs-1 jBtnQuad text-center\" ng-attr-style=\"margin-top:{{getAvailableHeight(360) * (tabView?0.92:0.91) / 2}}px;\"><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=addCategoryFx();>{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button></div><div class=col-xs-6><label>{{\'cl.widget.mc.7\' | translate}} <span class=\"text-sm text-muted\">[ {{categories.selectedCategories.length}} ]</span></label><ul class=\"list-unstyled overflow-y bdr selectList\" ng-attr-style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.99)}}px;\"><div class=msg-warning lang={{auth.lang}} ng-if=\"categories.selectedCategories.length == 0\">{{\'cl.widget.mc.m1\' | translate}}</div><li ng-repeat=\"sc in categories.selectedCategories\"><div class=row><div class=\"col-xs-12 noPadR text-bold marB2\">{{sc.CategoryName | capitalize}}</div><div class=\"col-xs-4 col-lg-3\"><div class=input-group><input type=number class=\"form-control input-xs\" ng-model=sc.count min=0 max={{sc.totalCount}}> <span class=input-group-addon>{{\'cl.widget.mc.8\' | translate}}</span></div></div><div class=\"col-xs-8 col-lg-9 text-right\"><a href=\"\" role=link ng-click=\"openCategoriesFx(sc.CategoryNumber, sc.count, sc.CategoryName);\" class=\"btn btn-xs btn-primary\" ng-class=\"{\'disabled\':!sc.count}\">{{\'cl.widget.mc.9\' | translate}}</a> <a href=\"\" role=link class=\"btn btn-xs btn-danger\" ng-click=\"removeOpen(\'sc\', sc.CategoryNumber);\" ng-class=\"{\'disabled text-muted\':selectedSongsLoading}\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div><div class=clearfix></div><span class=msg-warning lang={{auth.lang}} ng-if=!sc.count>{{\'cl.widget.mc.m6\' | translate}}</span></div></li></ul></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"col-xs-12 marT10\"><div class=\"musicCBox row\"><div class=\"col-xs-12 col-md-5 playList\"><div class=row><div class=\"col-xs-8 text-bold text-ellipsis\"><label class=noMarB ng-class=\"{\'disabled\':!playList.playSongs.length}\"><input type=checkbox ng-model=chkList.playList ng-change=\"checkAllFx(\'playList\', chkList.playList);\" ng-disabled=!playList.playSongs.length role=checkbox><label class=noMarB></label></label>{{\'cl.widget.mc.4\' | translate}} <span class=\"text-sm text-muted\">[ {{playList.playSongs.length + \" / \" + playList.songsCount}} ]</span></div><div class=\"col-xs-4 text-right\"><div class=searchTbx><input type=text class=form-control ng-model=pLSearch.playList sanitize-input ng-disabled=\"playList.playSongs.length == 0\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=pLSearch.playList ng-click=\"pLSearch.playList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"overflow-y bg-light bdr\" ng-attr-style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.91)}}px;\" ng-if=\"searchedSongs.length > 0 || searchedEmpty\"><img alt=Loading src=assets/images/loading.gif ng-if=playListLoading><div class=msg-warning lang={{auth.lang}}>{{searchedEmpty?\'cl.widget.mc.m8\':\'cl.widget.mc.m7\' | translate}} <a href=\"\" role=link class=\"pull-right btn-link\" ng-click=clearSearchFx();>{{\'cl.widget.mc.11\' | translate}}</a></div><ul class=\"list-unstyled list-striped noMarB\" ng-if=\"!playListLoading && !searchedEmpty\"><li ng-repeat=\"pl in searchedSongs\"><label class=noMarB><input type=checkbox ng-model=pl.isSelected role=checkbox><label></label>{{pl.SongName | capitalize}}</label><div class=\"text-sm text-muted\">{{pl.AlbumName | capitalize}} | {{pl.ArtistName | capitalize}} | {{pl.DurationSeconds | durations}}</div><div class=\"text-sm text-muted\">{{pl.CategoryName}}</div></li></ul></div><div class=\"overflow-y bg-light bdr\" ng-attr-style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.91)}}px;\" when-scrolled=loadMoreLogs(); ng-if=\"!searchedSongs.length && !searchedEmpty\"><img alt=Loading src=assets/images/loading.gif ng-if=playListLoading><ul class=\"list-unstyled list-striped noMarB\" ng-if=\"!playListLoading && playList.playSongs.length > 0\"><li ng-repeat=\"pl in playList.playSongs | filter:pLSearch.playList\"><label class=noMarB><input type=checkbox ng-model=pl.isSelected ng-click=\"checkboxFx(\'pl\');\" role=checkbox><label></label>{{pl.SongName | capitalize}}</label><div class=\"text-sm text-muted\">{{pl.CategoryName}} | {{pl.DurationSeconds | durations}}</div><div class=\"text-sm text-muted\">{{pl.AlbumName | capitalize}} | {{pl.ArtistName | capitalize}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(playList.playSongs | filter:pLSearch.playList).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(pLSearch.playList)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!playListLoading && playList.playSongs.length == 0\">{{\'cl.widget.mc.m2\' | translate}}</div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuad\" ng-attr-style=\"margin-top:{{getAvailableHeight(360) * (tabView?0.92:0.91) / 2 - 100}}px;\"><button type=button role=button ng-click=\"checkboxListManipulateFx(\'add\', playList.playSongs, playList.dontPlaySongs);\" class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !playList.playSongs.length}\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button></div><div class=\"col-xs-12 col-md-5 dontPlayList noPadR\"><div><div class=\"col-xs-7 text-bold noPadL\"><label class=noMarB ng-class=\"{\'disabled\':playList.dontPlaySongs.length <= 0}\"><input type=checkbox ng-model=chkList.dontPlay ng-change=\"checkAllFx(\'dontPlay\', chkList.dontPlay);\" ng-disabled=\"playList.dontPlaySongs.length <= 0\" role=checkbox><label class=noMarB></label></label>{{\'cl.widget.mc.10\' | translate}} <span class=\"text-sm text-muted\">[ {{playList.dontPlaySongs.length}} ]</span></div><div class=\"col-xs-1 text-right noPadR\"><a href=\"\" role=link ng-click=\"removeOpen(\'dp\');\" class=deleteBtn ng-class=\"donotPlayDeleteBtn?\'text-primary\':\'text-muted\'\" ng-disabled=!donotPlayDeleteBtn uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-trash noMarR\" aria-hidden=true></span></a></div><div class=\"col-xs-4 text-right noPadR\"><div class=searchTbx><input type=text class=form-control ng-model=pLSearch.dontPlay sanitize-input ng-disabled=\"playList.dontPlaySongs.length <= 0\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=pLSearch.dontPlay ng-click=\"pLSearch.dontPlay=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"overflow-y bg-light bdr\" ng-attr-style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.91)}}px;\"><img alt=Loading src=assets/images/loading.gif ng-if=dontLoading><ul class=\"list-unstyled list-striped noMarB\" ng-if=\"!dontLoading && playList.dontPlaySongs.length > 0\"><li ng-repeat=\"dp in playList.dontPlaySongs | filter:pLSearch.dontPlay\"><div class=row><div class=col-xs-11><label class=noMarB><input type=checkbox ng-model=dp.isSelected ng-click=\"checkboxFx(\'dp\');\" role=checkbox><label></label>{{dp.SongName | capitalize}}</label></div><div class=col-xs-1><a href=\"\" role=link ng-click=\"removeOpen(\'dp\', dp.SongID);\" class=text-danger><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"text-sm text-muted\">{{dp.CategoryName}} | {{dp.DurationSeconds | durations}}</div><div class=\"text-sm text-muted\">{{dp.AlbumName | capitalize}} | {{dp.ArtistName | capitalize}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(playList.dontPlaySongs | filter:pLSearch.dontPlay).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(pLSearch.dontPlay)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!dontLoading && playList.dontPlaySongs.length == 0\">{{\'cl.widget.mc.m3\' | translate}}</div></div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=\"backBtnFx(); selectedTabFx();\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=musicChoiceFx(2); ng-disabled=tabProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.mc.3\' | translate | camelCase}}<span class=fa ng-class=\"tabProcessing?\'fa-repeat fa-spin marL5\':\'fa-chevron-right\'\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=musicChoiceFx(3); ng-disabled=tabProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.mc.4\' | translate | camelCase}}<span class=fa ng-class=\"tabProcessing?\'fa-repeat fa-spin marL5\':\'fa-chevron-right\'\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"musicChoiceFx(3, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'addMsg\'\" aria-live=polite role=status>{{\'cl.widget.mc.m4\' | translate}}</div><div ng-if=\"errType==\'songsCount\'\" aria-live=polite role=status>{{\'cl.widget.mc.m9\' | translate}}</div><div ng-if=\"errType==\'maxCount\'\" aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div ng-if=\"errType==\'minCount\'\" aria-live=polite role=status>{{\'cl.widget.mc.m14\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/news.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.news.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.news.2\' | translate}} &nbsp; <span ng-if=news.label>[ {{news.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=\"msg-warning marB10 hide\" lang={{auth.lang}}>{{\'cl.widget.news.m4\' | translate}}</div><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=news.labelOpt value=a><label></label>{{\'cl.widget.news.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=news.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"news.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=news.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group ng-if=\"widgetList.newsCrawl || (news.id && dTypeCopy == \'crawl\')\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=news.dType ng-change=\"changeDType(\'normal\')\" value=normal ng-if=\"widgetList.newsCrawl || (news.id && dTypeCopy == \'crawl\')\"><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=noMarB ng-if=\"widgetList.newsCrawl || (news.id && dTypeCopy == \'crawl\')\"><input type=radio role=radio name=dTypeOpt ng-model=news.dType ng-change=\"changeDType(\'crawl\')\" value=crawl><label></label>{{\'cl.widget.cm.23\' | translate}}</label></div></div><div class=row><div class=\"form-group col-xs-6\"><label for=provider>{{\'cl.widget.news.4\' | translate}}</label><select id=provider class=form-control ng-model=news.provider ng-change=newsProviderFx(); aria-label=\"{{\'cl.widget.news.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.news.4.1\' | translate}}</option><option value=BBC>{{\'cl.widget.news.4.2\' | translate}}</option><option value=Bing ng-if=\"widgetList.newsB || news.provider == \'Bing\'\">{{\'cl.widget.news.4.8\' | translate}}</option><option value=CBC>{{\'cl.widget.news.4.3\' | translate}}</option><option value=CNN>{{\'cl.widget.news.4.4\' | translate}}</option><option value=ESPN>{{\'cl.widget.news.4.5\' | translate}}</option><option value=\"Fox News\">{{\'cl.widget.news.4.6\' | translate}}</option><option value=\"US Nuclear\">{{\'cl.widget.news.4.7\' | translate}}</option></select></div><div class=\"form-group col-xs-6\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=categoryLoading class=marT35> <span ng-if=\"categorys.feed && !categoryLoading\"><label for=category>{{\'cl.widget.news.5\' | translate}}</label><select id=category class=form-control ng-model=news.category ng-options=\"nc.label for nc in categorys.feed track by nc.id\" aria-label=\"{{\'cl.widget.news.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.5\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.news.5.1\' | translate}}</option></select></span></div></div><div class=row ng-if=\"news.provider == \'Bing\'\"><div class=\"form-group col-xs-6\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=countryLoading> <span ng-if=!countryLoading><label for=country>{{\'db.p_map.8\' | translate}}</label><select id=country class=form-control ng-model=news.country ng-options=\"cu.label for cu in countrys track by cu.code\" aria-label=\"{{\'db.p_map.8\' | translate}}\" aria-labelledby=\"{{\'db.p_map.8\' | translate}}\"><option value=\"\" disabled>{{\'db.p_map.8.1\' | translate}}</option></select></span></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"news.dType == \'normal\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=news.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=news.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"news.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=news.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=news.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=news.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=news.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"news.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=news.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"news.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':news.settings.headerBg, opacity:news.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{news.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.headerBg selected-type=news.ctype.headerBg is-alpha=true selected-alpha=news.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.headerText selected-type=news.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=news.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=news.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':news.settings.bg, opacity:news.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{news.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.bg selected-type=news.ctype.bg is-alpha=true selected-alpha=news.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=news.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=news.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':news.settings.rowBg, opacity:news.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{news.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.rowBg selected-type=news.ctype.rowBg is-alpha=true selected-alpha=news.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':news.settings.altBg, opacity:news.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{news.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.altBg selected-type=news.ctype.altBg is-alpha=true selected-alpha=news.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.titleText selected-type=news.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.att><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.altTitleText selected-type=news.ctype.altTitleText ng-if=colorPicker.att></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.descText selected-type=news.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.altDescText selected-type=news.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cm.label.24\' | translate}}</label><select id=rowFont class=form-control ng-model=news.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=altRowFont>{{\'cm.label.24.1\' | translate}}</label><select id=altRowFont class=form-control ng-model=news.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.24.1\' | translate}}\"></select></div></div></div><div ng-if=\"news.dType == \'crawl\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.text.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=news.settings.dir value=rl><label></label>{{\'cl.widget.text.5\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=news.settings.dir value=bt ng-change=directionFx()><label></label>{{\'cl.widget.text.6\' | translate}}</label></div></div><div class=col-xs-6 ng-if=\"news.settings.dir == \'bt\'\"><label>{{\'cl.widget.text.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=aOpt ng-model=news.settings.align value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=aOpt ng-model=news.settings.align value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label><input type=radio role=radio name=aOpt ng-model=news.settings.align value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=speed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=speed class=form-control ng-model=news.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':news.settings.bg, opacity:news.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{news.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.bg selected-type=news.ctype.bg is-alpha=true selected-alpha=news.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"news.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.bullet}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.bullet selected-type=news.ctype.bullet ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"news.settings.dir == \'bt\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.titleText selected-type=news.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4 ng-if=\"news.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':news.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"news.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=news.settings.titleText selected-type=news.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=news.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-4 ng-if=\"news.settings.dir == \'bt\'\"><label for=btFontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=btFontSize class=form-control ng-model=news.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"news.settings.dir == \'rl\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=news.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label><input type=radio role=radio name=fsOpt ng-model=news.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"news.settings.fontSizeOpt == \'c\'\"><input type=number id=rlFontSize class=form-control ng-model=news.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=news.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=news.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=newsFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'provider\'\" aria-live=polite role=status>{{\'cl.widget.news.m1\' | translate}}</div><div ng-if=\"errType==\'category\'\" aria-live=polite role=status>{{\'cl.widget.news.m2\' | translate}}</div><div ng-if=\"errType==\'fSizeText\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/nextBus.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.nb.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.nb.2\' | translate}} &nbsp; <span ng-if=nextBus.label>[ {{nextBus.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=nextBus.labelOpt value=a><label></label>{{\'cl.widget.nb.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=nextBus.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"nextBus.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=nextBus.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div ng-if=!encId role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=typeOpt ng-model=nextBus.dType value=r ng-change=typeFx()><label></label>{{\'cl.widget.nb.8\' | translate}}</label><label><input type=radio role=radio name=typeOpt ng-model=nextBus.dType value=s ng-change=typeFx()><label></label>{{\'cl.widget.nb.9\' | translate}}</label></div><div ng-if=encId><span class=\"bg-default pad2\" ng-if=\"nextBus.dType==\'r\'\">{{\'cl.widget.nb.8\' | translate}}</span> <span class=\"bg-default pad2\" ng-if=\"nextBus.dType==\'s\'\">{{\'cl.widget.nb.9\' | translate}}</span></div></div><div class=form-group><label for=agency>{{\'cl.widget.nb.4\' | translate}}</label><select id=agency class=form-control ng-model=nextBus.nextBus.agency ng-change=\"getListFx(\'r\', true)\" ng-options=\"aList.label for aList in agencyList track by aList.tag\" aria-label=\"{{\'cl.widget.nb.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.nb.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.nb.4.1\' | translate}}</option></select></div><div class=form-group ng-if=\"routeLoading || routeList.length\"><label for=route>{{\'cl.widget.nb.5\' | translate}}</label><div ng-if=routeLoading><img alt=Loading src=assets/images/loading-xs.gif></div><select id=route class=form-control ng-if=!routeLoading ng-model=nextBus.nextBus.route ng-change=\"getListFx(\'d\', true)\" ng-options=\"rList.label for rList in routeList track by rList.tag\" aria-label=\"{{\'cl.widget.nb.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.nb.5\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.nb.5.1\' | translate}}</option></select></div><div class=form-group ng-if=\"(directionsLoading || directionsList.length) && nextBus.dType == \'s\'\"><label for=direction>{{\'cl.widget.nb.6\' | translate}}</label><div ng-if=directionsLoading><img alt=Loading src=assets/images/loading-xs.gif></div><select id=direction class=form-control ng-if=!directionsLoading ng-model=nextBus.nextBus.direction ng-change=\"getListFx(\'s\', true)\" ng-options=\"dList.label for dList in directionsList track by dList.tag\" aria-label=\"{{\'cl.widget.nb.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.nb.6\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.nb.6.1\' | translate}}</option></select></div><div class=form-group ng-if=\"(stopLoading || stopsList.length) && nextBus.dType == \'s\'\"><label for=stop>{{\'cl.widget.nb.7\' | translate}}</label><div ng-if=stopLoading><img alt=Loading src=assets/images/loading-xs.gif></div><select id=stop class=form-control ng-if=!stopLoading ng-model=nextBus.nextBus.stop ng-options=\"sList.label for sList in stopsList track by sList.tag\" aria-label=\"{{\'cl.widget.nb.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.nb.7\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.nb.7.1\' | translate}}</option></select></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=nextBus.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=nextBus.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\" ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=nextBusFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'agency\'\" aria-live=polite role=status>{{\'cl.widget.nb.m1\' | translate}}</div><div ng-if=\"errType==\'route\'\" aria-live=polite role=status>{{\'cl.widget.nb.m2\' | translate}}</div><div ng-if=\"errType==\'direction\'\" aria-live=polite role=status>{{\'cl.widget.nb.m3\' | translate}}</div><div ng-if=\"errType==\'stop\'\" aria-live=polite role=status>{{\'cl.widget.nb.m4\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/nextVehicle.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.nv.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.nv.2\' | translate}} &nbsp; <span ng-if=nextVehicle.label>[ {{nextVehicle.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=nextVehicle.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=address>{{\'cs.p_i.3\' | translate}}</label><input type=text id=address class=form-control ng-map-autocomplete ng-model=nextVehicle.place details=details aria-label=\"{{\'cs.p_i.3\' | translate}}\" aria-labelledby=\"{{\'cs.p_i.3\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=nextVehicle.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=nextVehicle.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=nextVehicleFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/onlineRadio.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.or.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.or.2\' | translate}} &nbsp; <span ng-if=radio.label>[ {{radio.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=\"msg-warning marB10\" lang={{auth.lang}}>{{\'cl.widget.or.m2\' | translate}}</div><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=radio.labelOpt value=a><label></label>{{\'cl.widget.or.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=radio.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"radio.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=radio.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.or.m2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.or.m2\' | translate}}\"></div></div><div class=form-group><label for=station>{{\'cl.widget.or.4\' | translate}}</label><div ng-if=stationLoading><img alt=Loading src=assets/images/loading-xs.gif></div><select id=station ng-if=!stationLoading class=form-control ng-model=radio.station ng-options=\"station.name group by station.lang for station in stations track by station.value\" aria-label=\"{{\'cl.widget.or.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.or.4\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.or.4.1\' | translate}}</option></select></div><div class=row><div class=\"col-xs-6 form-group\"><label for=volume>{{\'cl.widget.or.5\' | translate}}</label><input type=range id=volume min=0 max=10 ng-model=radio.volume uib-tooltip={{radio.volume}} tooltip-placement=right aria-label=\"{{\'cl.widget.or.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.or.5\' | translate}}\"></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=radio.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=radio.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=onlineRadioFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'station\'\" aria-live=polite role=status>{{\'cl.widget.or.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/openHours.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.oh.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.oh.2\' | translate}} &nbsp; <span ng-if=openHours.label>[ {{openHours.label}} ]</span></h1></header><div>&nbsp;</div><!-- todo Added tab for the list start --><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1); ng-disabled=reponseLoad><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=openHoursFx(1); ng-disabled=\"detailLoading || reponseLoad\"><span class=badge>2</span>{{\'cm.body.3\' | translate}}</a></li></ul><!-- todo Added tab for the list end --> {{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><!-- Name and permission --><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=openHours.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=col-xs-4><div class=form-group><label for=hoursEn>{{\'cl.widget.oh.3\' | translate}}</label><input type=text id=hoursEn class=form-control ng-model=openHours.settings.hoursEn aria-label=\"{{\'cl.widget.oh.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.3\' | translate}}\"></div><div class=form-group><label for=pickupEn>{{\'cl.widget.oh.4\' | translate}}</label><input type=text id=pickupEn class=form-control ng-model=openHours.settings.pickupEn aria-label=\"{{\'cl.widget.oh.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.4\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=hoursFr>{{\'cl.widget.oh.3.1\' | translate}}</label><input type=text id=hoursFr class=form-control ng-model=openHours.settings.hoursFr aria-label=\"{{\'cl.widget.oh.3.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.3.1\' | translate}}\"></div><div class=form-group><label for=pickupFr>{{\'cl.widget.oh.4.1\' | translate}}</label><input type=text id=pickupFr class=form-control ng-model=openHours.settings.pickupFr aria-label=\"{{\'cl.widget.oh.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.4.1\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=hoursEs>{{\'cl.widget.oh.3.2\' | translate}}</label><input type=text id=hoursEs class=form-control ng-model=openHours.settings.hoursEs aria-label=\"{{\'cl.widget.oh.3.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.3.2\' | translate}}\"></div><div class=form-group><label for=pickupEs>{{\'cl.widget.oh.4.2\' | translate}}</label><input type=text id=pickupEs class=form-control ng-model=openHours.settings.pickupEs aria-label=\"{{\'cl.widget.oh.4.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.4.2\' | translate}}\"></div></div></div><div class=form-group><label>{{\'cl.widget.oh.5\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!openHours.isHidden && (openHours.footerImg.thumb || openHours.footerImg.type == \'SharePointC\' || openHours.footerImg.type == \'OneDriveC\' || openHours.footerImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeBgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=openHours.footerImg.thumb ng-href=\"{{cDetailBucket + openHours.footerImg.thumb | secureThumb}}\" role=button data-access={{openHours.footerImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(openHours.footerImg.path + (openHours.footerImg.path.length > 1 ? \' / \' : \' \') + openHours.footerImg.label)}}\" ng-show=openHours.footerImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + openHours.footerImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"openHours.footerImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"openHours.footerImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"openHours.footerImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=openHours.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div><!-- Settings --><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':openHours.settings.bg, opacity:openHours.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"openHours.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{openHours.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=openHours.settings.bg selected-type=openHours.ctype.bg is-alpha=true selected-alpha=openHours.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.pw.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':openHours.settings.footerBg, opacity:openHours.settings.footerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"openHours.settings.footerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fb=true\" readonly aria-label=\"{{\'cl.widget.pw.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{openHours.settings.footerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=openHours.settings.footerBg selected-type=openHours.ctype.footer is-alpha=true selected-alpha=openHours.settings.footerBga ng-if=colorPicker.fb></ng-hub-color-picker></div></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.oh.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':openHours.settings.hourTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"openHours.settings.hourTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.oh.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=openHours.settings.hourTxt selected-type=openHours.ctype.hour ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=hourFont>{{\'cl.widget.oh.10\' | translate}}</label><select id=hourFont class=form-control ng-model=openHours.settings.hourFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oh.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.10\' | translate}}\"></select></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.oh.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':openHours.settings.pickuptTxt}\"></span></span> <input id=pickuptTxt type=text class=\"form-control picker\" ng-value=\"openHours.settings.pickuptTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pt=true\" readonly aria-label=\"{{\'cl.widget.oh.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.11\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=openHours.settings.pickuptTxt selected-type=openHours.ctype.pickupt ng-if=colorPicker.pt></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=pickupFont>{{\'cl.widget.oh.12\' | translate}}</label><select id=pickupFont class=form-control ng-model=openHours.settings.pickupFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oh.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.12\' | translate}}\"></select></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':openHours.settings.rowTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"openHours.settings.rowTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=openHours.settings.rowTxt selected-type=openHours.ctype.row ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div></div><div class=col-xs-6><div class=form-group><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=openHours.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=openHours.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=openHours.activePeriod></ng-active-period></div></div></div><!-- Device list --><div ng-if=\"selectedT==\'2\'\"><div class=\"form-group marL10 marT10\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" ng-model=searchQu.text sanitize-input ng-change=searchChangeData(searchQu.text); ng-disabled=!allScrollDataList.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchQu.text.length ng-click=\"searchQu.text = \'\';searchChangeData(searchQu.text);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.3\' | translate}}</div><img class=pad10 alt=Loading src=assets/images/loading.gif ng-if=dLoading><div class=newContainer ng-if=\"allScrollDataList.length && !dLoading\"><div class=\"rowline header padR12\"><div class=\"column column-1\">{{\'cm.brief.1\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.1\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.2\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.3\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.4\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.5\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.6\' | translate}}</div><div class=\"column column-2\">{{\'s.p_s.label.4.2.7\' | translate}}</div><div class=\"column column-2\">{{\'cl.widget.oh.6\' | translate}}</div><div class=\"column column-2\">{{\'cl.widget.oh.7\' | translate}}</div><div class=\"column column-2\">{{\'cl.widget.oh.8\' | translate}}</div><div class=\"column column-3 text-right hide\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad id=scroll-container ng-attr-style=max-height:{{getAvailableHeight(460)}}px ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=rowline id={{openList.id}} ng-repeat=\"openList in device = (visibleData)\" ng-if=!dListLoading><div class=\"column column-1 word-break\"><span class=\"marR5 deviceStatus {{openList.status}}\" uib-tooltip=\"{{openList.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{openList.l}}</div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.mo aria-label=\"{{\'s.p_s.label.4.2.1\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.1\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.tu aria-label=\"{{\'s.p_s.label.4.2.2\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.2\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.we aria-label=\"{{\'s.p_s.label.4.2.3\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.3\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.th aria-label=\"{{\'s.p_s.label.4.2.4\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.4\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.fr aria-label=\"{{\'s.p_s.label.4.2.5\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.5\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.sa aria-label=\"{{\'s.p_s.label.4.2.6\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.6\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.su aria-label=\"{{\'s.p_s.label.4.2.7\' | translate}}\" aria-labelledby=\"{{\'s.p_s.label.4.2.7\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.pd aria-label=\"{{\'cl.widget.oh.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.6\' | translate}}\"></div><div class=\"column column-2\"><input type=text class=\"form-control input-sm\" ng-model=openList.pt aria-label=\"{{\'cl.widget.oh.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.7\' | translate}}\"></div><div class=\"column column-2\"><select class=\"form-control input-sm\" ng-model=openList.la aria-label=\"{{\'cl.widget.oh.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.8\' | translate}}\"><option value=\"\">{{\'cm.label.34\' | translate}}</option><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=es_ES>Spanish / Spain</option></select></div><div class=\"column column-3 text-right hide\"><a href=\"\" role=link class=\"text-primary marR5\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" ng-if=!openList.show ng-click=\"openList.show = !openList.show; updateDeviceDataFx(\'e\', openList)\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-primary marR5\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" ng-show=openList.show ng-click=\"updateDeviceDataFx(\'u\', openList, $index);\" ng-disabled=updateProcessing tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-check\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"text-danger marR5\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" ng-show=openList.show ng-click=\"updateDeviceDataFx(\'c\', openList, $index);\" ng-disabled=updateProcessing tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-times\" aria-hidden=true></span></a><!-- <a href=\"\" role=\"link\" class=\"text-primary marR5\" ng-if=\"!device.show\" ng-click=\"device.show = !device.show; deviceMapFx(\'e\', device)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"><span class=\"fa fa-pencil\" aria-hidden=\"true\"></span></a> --><!-- <a href=\"\" role=\"link\" class=\"btn btn-success\" ng-show=\"device.show\" ng-click=\"deviceMapFx(\'u\', device, $index);\" ng-disabled=\"mapProcessing\">{{\'cm.btn.15\' | translate}}</a>\r\n                <a href=\"\" role=\"link\" class=\"btn btn-link\" ng-show=\"device.show\" ng-click=\"deviceMapFx(\'c\', device, $index);\" ng-disabled=\"mapProcessing\">{{\'cm.btn.9\' | translate}}</a> --></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex && !loadingMore\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=form-group ng-if=\"dListLoading || ((!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex && loadingMore)\"><img alt=Loading src=assets/images/loading-xs.gif></div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.length > 0 && device.length == 0 && !dListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchQu.text)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!allScrollDataList.length && !dLoading\">{{\'d.msg.1\' | translate}}</div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=\"backBtnFx(); selectedTabFx();\" ng-disabled=reponseLoad><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=openHoursFx(1); ng-disabled=\"nextProcessing || detailLoading || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cm.body.3\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"openHoursFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing || saveProcessing || detailLoading || reponseLoad\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/outlookCalendar.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.oc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.oc.2\' | translate}} &nbsp; <span ng-if=outlook.label>[ {{outlook.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\" ng-if=\"outlook.version.value == \'Office365\'\"><a href=\"\" role=link ng-click=outlookFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\"><a href=\"\" role=link ng-click=outlookFx(2);><span class=badge>{{outlook.version.value != \'Office365\'?2:3}}</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"col-xs-12 marB10 hide\" role=radiogroup aria-labelledby=radiogroup><label class=marR10 ng-if=!encId><input type=radio role=radio name=wTypeOpt ng-model=outlook.wType value=o><label></label>{{\'cl.widget.oc.21\' | translate}}</label><label ng-if=!encId><input type=radio role=radio name=wTypeOpt ng-model=outlook.wType value=e><label></label>{{\'cl.widget.oc.22\' | translate}}</label><span class=\"bg-default pad2\" ng-if=\"encId && outlook.wType == \'o\'\">{{\'cl.widget.oc.21\' | translate}}</span> <span class=\"bg-default pad2\" ng-if=\"encId && outlook.wType == \'e\'\">{{\'cl.widget.oc.22\' | translate}}</span></div><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=outlook.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=version>{{\'cl.widget.oc.26\' | translate}}</label><select id=version class=form-control ng-model=outlook.version ng-options=\"v.label for v in versionList track by v.value\" aria-label=\"{{\'cl.widget.oc.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.26\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.oc.26.1\' | translate}}</option></select></div><div ng-if=\"outlook.version.value && outlook.version.value != \'Office365\'\"><div class=form-group><label for=host>{{\'cl.widget.oc.23\' | translate}}</label><input type=text id=host class=form-control ng-model=outlook.host aria-label=\"{{\'cl.widget.oc.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.23\' | translate}}\"></div><div class=row><div class=col-xs-4><div class=form-group><label for=userName>{{\'cl.widget.cm.28\' | translate}}</label><input type=text id=userName class=form-control ng-model=outlook.userName aria-label=\"{{\'cl.widget.cm.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.28\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=password>{{\'cl.widget.oc.24\' | translate}}</label><input type=password id=password class=form-control ng-model=outlook.password autocomplete=off aria-label=\"{{\'cl.widget.oc.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.24\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=retypePassword>{{\'cl.widget.oc.25\' | translate}}</label><input type=password id=retypePassword class=form-control ng-model=outlook.retypePassword autocomplete=off aria-label=\"{{\'cl.widget.oc.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.25\' | translate}}\"></div></div></div></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=typeOpt ng-model=outlook.dType value=r><label></label>{{\'cl.widget.oc.4\' | translate}}</label><label><input type=radio role=radio name=typeOpt ng-model=outlook.dType value=wc><label></label>{{\'cl.widget.oc.5\' | translate}}</label></div><div class=\"form-group marT5\" ng-if=\"outlook.dType == \'r\'\"><label for=roomEmail>{{\'cl.widget.oc.4.1\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span> <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.oc.m14\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label><input type=text id=roomEmail class=form-control ng-model=outlook.rId aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"></div><div class=form-group ng-if=\"outlook.dType == \'wc\'\"><div class=marT10><label>{{\'cl.widget.cm.7\' | translate}}</label><div class=\"col-xs-12 noPad\"><div class=\"pull-left marR10 marB10\"><label><img src=assets/images/widget/templates/outlook1.png alt=template1.png><div class=marT3><input type=radio role=radio name=templateOpt ng-model=outlook.template value=t1><label></label>{{\'cl.widget.cm.8\' | translate:{count:\'1\'} }}</div></label></div><div class=\"pull-left marL10 marB10\"><label><img src=assets/images/widget/templates/outlook2.png alt=template2.png><div class=marT3><input type=radio role=radio name=templateOpt ng-model=outlook.template value=t2><label></label>{{\'cl.widget.cm.8\' | translate:{count:\'2\'} }}</div></label></div></div></div><div class=marB10><label class=noMarB>{{\'cl.widget.oc.5.1\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span> <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.oc.m14\' | translate}}\" tooltip-placement=right></span></label><div class=pull-right><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=addRowFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></div></div><div class=bdr-top-dashed><div class=table ng-if=\"outlook.wallboardList.length > 0\"><div class=\"row th\"><div class=col-xs-10>{{\'cm.label.47\' | translate}}</div><div class=\"col-xs-2 noPadL text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad><div class=row id=wbL ng-repeat=\"w in outlook.wallboardList\"><div class=col-xs-10><input type=email class=\"form-control input-sm\" ng-model=w.email ng-if=w.edited aria-label=Email aria-labelledby=Email> <span ng-if=!w.edited>{{w.email}}</span></div><div class=\"col-xs-2 noPadL text-right\" ng-class=\"{\'marT5\':w.edited}\"><a href=\"\" role=link name=editBtn class=\"pad2 text-primary\" ng-click=editWallFx($index); ng-if=!w.edited uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link name=removeBtn class=\"pad2 text-danger\" ng-click=confirmOpen($index); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"outlook.wallboardList.length == 0\">{{\'cl.widget.oc.m5\' | translate}}</div></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"outlook.dType == \'r\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsRB.bg, opacity:settingsRB.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsRB.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.bg selected-type=ctypeRB.bg is-alpha=true selected-alpha=settingsRB.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.titleText selected-type=ctypeRB.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=rbTitleFont class=form-control ng-model=settingsRB.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=settingsRB.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.subtitleText selected-type=ctypeRB.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbSubtitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select id=rbSubtitleFont class=form-control ng-model=settingsRB.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubtitleSize class=form-control ng-model=settingsRB.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.timeText selected-type=ctypeRB.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=settingsRB.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=settingsRB.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosP class=form-control ng-model=settingsRB.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosA class=form-control ng-model=settingsRB.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div><div ng-if=\"outlook.dType == \'wc\'\"><div ng-if=\"outlook.template == \'t1\'\"><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsWBT1.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsWBT1.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsWBT1.rotationOpt == \'c\'\"><input type=number id=wb1Rotation class=form-control ng-model=settingsWBT1.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT1.bg, opacity:settingsWBT1.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT1.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.bg selected-type=ctypeWBT1.bg is-alpha=true selected-alpha=settingsWBT1.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=flex1></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWBT1.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWBT1.header.active><div class=\"flex1 noMarL\"><label for=title>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=wb1Title class=\"form-control input-sm\" ng-model=settingsWBT1.header.column1 aria-label=\">{{\'cm.label.23\' | translate}}\" aria-labelledby=\">{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWBT1.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=time>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=wb1Time class=\"form-control input-sm\" ng-model=settingsWBT1.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWBT1.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=room>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=wb1Room class=\"form-control input-sm\" ng-model=settingsWBT1.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=settingsWBT1.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWBT1.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT1.headerBg, opacity:settingsWBT1.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT1.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.headerBg selected-type=ctypeWBT1.headerBg is-alpha=true selected-alpha=settingsWBT1.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.headerText selected-type=ctypeWBT1.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=flex1><label for=wb1HeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wb1HeaderFont class=form-control ng-model=settingsWBT1.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=wb1HeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wb1HeaderSize class=form-control ng-model=settingsWBT1.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.titleText selected-type=ctypeWBT1.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.att><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.altTitleText selected-type=ctypeWBT1.altTitleText ng-if=colorPicker.att></ng-hub-color-picker></div></div></div><div class=flex1><label for=wb1TitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=wb1TitleFont class=form-control ng-model=settingsWBT1.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=wb1TitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wb1TitleSize class=form-control ng-model=settingsWBT1.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=settingsWBT1.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWBT1.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWBT1.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.timeText selected-type=ctypeWBT1.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.atm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.atm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.altTimeText selected-type=ctypeWBT1.altTimeText ng-if=colorPicker.atm></ng-hub-color-picker></div></div></div><div class=flex1><label for=wb1TimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=wb1TimeFont class=form-control ng-model=settingsWBT1.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=wb1TimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wb1TimeSize class=form-control ng-model=settingsWBT1.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=settingsWBT1.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWBT1.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=settingsWBT1.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.roomText selected-type=ctypeWBT1.roomText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.atr><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT1.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.atr=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.altRoomText selected-type=ctypeWBT1.altRoomText ng-if=colorPicker.atr></ng-hub-color-picker></div></div></div><div class=flex1><label for=wb1RoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wb1RoomFont class=form-control ng-model=settingsWBT1.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=wb1RoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=wb1RoomSize class=form-control ng-model=settingsWBT1.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=settingsWBT1.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT1.rowBg, opacity:settingsWBT1.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" redonly=\"\" aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT1.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.rowBg selected-type=ctypeWBT1.rowBg is-alpha=true selected-alpha=settingsWBT1.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT1.altBg, opacity:settingsWBT1.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT1.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" redonly=\"\" aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT1.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT1.altBg selected-type=ctypeWBT1.altBg is-alpha=true selected-alpha=settingsWBT1.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=\"flex1 noMarR\"><label>{{\'cl.widget.oc.39\' | translate}}</label><div class=input-group><input type=number id=futureDateEv class=form-control ng-model=settingsWBT1.futureDateEv min=1> <span class=input-group-addon>{{\'r.label.18\' | translate}}</span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=settingsWBT1.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=settingsWBT1.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"settingsWBT1.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wb1SosP class=form-control ng-model=settingsWBT1.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=settingsWBT1.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=settingsWBT1.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"settingsWBT1.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wb1SosA class=form-control ng-model=settingsWBT1.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div><div ng-if=\"outlook.template == \'t2\'\"><div class=row><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsWBT2.rotationOpt name=rotationOptwb2 value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsWBT2.rotationOpt name=rotationOptwb2 value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsWBT2.rotationOpt == \'c\'\"><input type=number id=wb2Rotation class=form-control ng-model=settingsWBT2.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.thb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT2.headerBg, opacity:settingsWBT2.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.thb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT2.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.headerBg selected-type=ctypeWBT2.headerBg is-alpha=true selected-alpha=settingsWBT2.headerBga ng-if=colorPicker.thb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.headerText selected-type=ctypeWBT2.headerText ng-if=colorPicker.tht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wb2HeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wb2HeaderFont class=form-control ng-model=settingsWBT2.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=wb2HeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wb2HeaderSize class=form-control ng-model=settingsWBT2.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.oc.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tlb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT2.leftBg, opacity:settingsWBT2.leftBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.leftBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tlb=true\" readonly aria-label=\"{{\'cl.widget.oc.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT2.leftBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.leftBg selected-type=ctypeWBT2.leftBg is-alpha=true selected-alpha=settingsWBT2.leftBga ng-if=colorPicker.tlb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tlt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.leftText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.leftText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tlt=true\" readonly aria-label=\"{{\'cl.widget.oc.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.leftText selected-type=ctypeWBT2.leftText ng-if=colorPicker.tlt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=leftFont>{{\'cl.widget.oc.13\' | translate}}</label><select id=leftFont class=form-control ng-model=settingsWBT2.leftFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.13\' | translate}}\"></select></div><div class=col-xs-3><label for=wb2LeftSize>{{\'cl.widget.oc.13.1\' | translate}}</label><input type=number id=wb2LeftSize class=form-control ng-model=settingsWBT2.leftSize min=1 aria-label=\"{{\'cl.widget.oc.13.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.13.1\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.38\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.trt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.trt=true\" readonly aria-label=\"{{\'cl.widget.cm.38\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.38\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.rowText selected-type=ctypeWBT2.rowText ng-if=colorPicker.trt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.40\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.altRowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.altRowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tat=true\" readonly aria-label=\"{{\'cl.widget.cm.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.40\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.altRowText selected-type=ctypeWBT2.altRowText ng-if=colorPicker.tat></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wb2RowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=wb2RowFont class=form-control ng-model=settingsWBT2.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.39\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.39\' | translate}}\"></select></div><div class=col-xs-3><label for=wb2RowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=wb2RowSize class=form-control ng-model=settingsWBT2.rowSize min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.trb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT2.rowBg, opacity:settingsWBT2.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.trb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT2.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.rowBg selected-type=ctypeWBT2.rowBg is-alpha=true selected-alpha=settingsWBT2.rowBga ng-if=colorPicker.trb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT2.altBg, opacity:settingsWBT2.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT2.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.altBg selected-type=ctypeWBT2.altBg is-alpha=true selected-alpha=settingsWBT2.altBga ng-if=colorPicker.tab></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.33\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.teb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWBT2.eventBg, opacity:settingsWBT2.eventBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.eventBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.teb=true\" readonly aria-label=\"{{\'cl.widget.oc.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.33\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWBT2.eventBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.eventBg selected-type=ctypeWBT2.eventBg is-alpha=true selected-alpha=settingsWBT2.eventBga ng-if=colorPicker.teb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tet><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.eventText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.eventText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tet=true\" readonly aria-label=\"{{\'cl.widget.oc.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.eventText selected-type=ctypeWBT2.eventText ng-if=colorPicker.tet></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label><input type=checkbox ng-model=settingsWBT2.isRowBdr role=checkbox><label></label>{{\'cl.widget.oc.32\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.trbo><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWBT2.rowBdr}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWBT2.rowBdr | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.trbo=true\" readonly ng-disabled=!settingsWBT2.isRowBdr aria-label=\"{{\'cl.widget.oc.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.32\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWBT2.rowBdr selected-type=ctypeWBT2.rowBdr ng-if=colorPicker.trbo></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.39\' | translate}}</label><div class=input-group><input type=number id=futureDateEv class=form-control ng-model=settingsWBT2.futureDateEv min=1> <span class=input-group-addon>{{\'r.label.18\' | translate}}</span></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=settingsWBT2.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=settingsWBT2.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"settingsWBT2.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wb2SosP class=form-control ng-model=settingsWBT2.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=settingsWBT2.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=settingsWBT2.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"settingsWBT2.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wb2SosA class=form-control ng-model=settingsWBT2.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=outlook.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=outlook.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.oc.6\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=outlook.isAuthorized>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button ng-if=!outlook.isAuthorized class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button ng-if=outlook.isAuthorized class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button ng-if=outlook.isAuthorized class=\"btn btn-default marR10\" ng-click=\"openUrlFx(626, 450, \'otherUserAuth\');\">{{\'cl.widget.cm.25.2\'| translate}}</button></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=ssLabel>{{\'cm.brief.1\' | translate}}</label><input type=text id=ssLabel class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=\"col-xs-2 noPadR\"><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=ssDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=ssDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'duration\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoFx(cDetailBucket + ss.ss.url, ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/sp.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/od.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=assets/images/default/thumbs/xs/gd.png class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\" ng-if=!detailLoading><span class=btnQuad><span ng-if=\"outlook.version.value != \'Office365\'\"><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=outlookFx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"outlookFx(0, \'save\');\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> </span><span ng-if=\"outlook.version.value == \'Office365\'\"><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=outlookFx(1); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=outlookFx(2); ng-disabled=nextProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"outlookFx(0, \'save\');\" ng-if=\"encId || selectedT==\'2\' || selectedT==\'3\'\" ng-disabled=\"nextProcessing || saveProcessing\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> </span><button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'roomId\'\" aria-live=polite role=status>{{\'cl.widget.oc.m1\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.oc.m3\' | translate}}</div><div ng-if=\"errType==\'wallEmpty\'\" aria-live=polite role=status>{{\'cl.widget.oc.m6\' | translate}}</div><div ng-if=\"errType==\'wallFieldEmply\'\" aria-live=polite role=status>{{\'cl.widget.oc.m7.1\' | translate}}</div><div ng-if=\"errType==\'host\'\" aria-live=polite role=status>{{\'cl.widget.oc.m8\' | translate}}</div><div ng-if=\"errType==\'uName\'\" aria-live=polite role=status>{{\'cl.widget.oc.m9\' | translate}}</div><div ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'cl.widget.oc.m10\' | translate}}</div><div ng-if=\"errType==\'retypePass\'\" aria-live=polite role=status>{{\'cl.widget.oc.m11\' | translate}}</div><div ng-if=\"errType==\'passNotMach\'\" aria-live=polite role=status>{{\'cl.widget.oc.m12\' | translate}}</div><div ng-if=\"errType==\'version\'\" aria-live=polite role=status>{{\'cl.widget.oc.m13\' | translate}}</div><div ng-if=\"errType==\'sameEmail\'\" aria-live=polite role=status>{{\'cl.widget.msg.12\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div><div ng-if=\"errType==\'fSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m5\' | translate}}</div><div ng-if=\"errType==\'lSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m3\' | translate}}</div><div ng-if=\"errType==\'rSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'futureDate\'\" aria-live=polite role=status>{{\'cl.widget.oc.m15\' | translate}}</div><div ng-if=\"errType==\'futureDateInvalid\'\" aria-live=polite role=status>{{\'cl.widget.oc.m16\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/patientWait.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.pw.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.pw.2\' | translate}} &nbsp; <span ng-if=patientWait.label>[ {{patientWait.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-se tab-sm tab-temp\" aria-labelledby=navList><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-se role=tab aria-selected=true><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-sm role=tab aria-selected=false><a href=\"\" role=link ng-click=patientWaitFx(1);><span class=badge>2</span>{{\'cl.widget.pw.19\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-temp role=tab aria-selected=false ng-if=\"patientWait.dType == \'q\'\"><a href=\"\" role=link ng-click=patientWaitFx(2);><span class=badge>3</span>{{\'cm.label.2s\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=patientWait.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=typeOpt ng-model=patientWait.dType value=a><label></label>{{\'cl.widget.pw.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=patientWait.dType value=q><label></label>{{\'cl.widget.queue.1\' | translate}}</label></div></div><div class=row ng-if=\"patientWait.dType == \'a\'\"><div class=col-xs-12><div class=form-group><label for=hText>{{\'cl.widget.cm.12\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=hText class=form-control ng-model=settingsA.header.hText maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div></div><div class=row ng-if=\"patientWait.dType == \'q\'\"><div class=col-xs-12><div class=form-group><label for=hText>{{\'cl.widget.cm.12\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=hText class=form-control ng-model=settingsQ.header.hText maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=form-group><label for=fText>{{\'cl.widget.pw.9\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=fText class=form-control ng-model=settingsQ.footer.fText maxlength={{commentLimit}} aria-label=\"{{\'cl.widget.pw.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.9\' | translate}}\"> <span class=\"text-muted text-sm\">[{{commentLimit - settingsQ.footer.fText.length}}]</span></div></div></div></div><div class=col-xs-7 ng-if=\"patientWait.dType == \'a\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen = settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsA.header.bg, opacity:settingsA.header.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsA.header.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsA.header.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsA.header.bg selected-type=ctypeA.headerBg is-alpha=true selected-alpha=settingsA.header.bga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsA.header.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsA.header.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsA.header.text selected-type=ctypeA.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=settingsA.header.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-6><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=settingsA.header.size min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsA.bg, opacity:settingsA.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsA.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsA.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsA.bg selected-type=ctypeA.bg is-alpha=true selected-alpha=settingsA.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cm.label.64\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsA.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsA.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cm.label.64\' | translate}}\" aria-labelledby=\"{{\'cm.label.64\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsA.text selected-type=ctypeA.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=settingsA.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-6><label for=size>{{\'cm.label.83\' | translate}}</label><input type=number id=size class=form-control ng-model=settingsA.size min=1 aria-label=\"{{\'cm.label.83\' | translate}}\" aria-labelledby=\"{{\'cm.label.83\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label id=reload>{{\'cl.widget.wp.3\' | translate}}</label><div class=input-group><input type=number id=reload class=form-control ng-model=settingsA.reload min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div><div class=col-xs-6><label for=environment>Environment</label><select id=environment class=form-control ng-model=settingsA.environment aria-label=Environment aria-labelledby=Environment><option value=p>{{\'cl.widget.pw.25.2\' | translate}}</option><option value=t>{{\'cl.widget.pw.25.1\' | translate}}</option><option value=tr>{{\'cl.widget.pw.25.3\' | translate}}</option></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=patientWait.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=patientWait.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><div><label>{{\'cl.widget.pw.12\' | translate}}</label></div><div class=\"bg-light pad10 marB15\"><div class=row><div class=col-xs-3><div class=\"form-group marB5\"><label for=fType>{{\'cl.brief.6\' | translate}}</label><select id=fType class=form-control ng-model=patientWait.fType ng-change=\"changeType(\'fType\');\" aria-label=\"{{\'cl.brief.6\' | translate}}\" aria-labelledby=\"{{\'cl.brief.6\' | translate}}\"><option value=excel>Excel</option><option value=csv>CSV</option></select></div><span class=text-sm><a href={{auth.bucket}}cl/widgets/patientwait/sample.xlsx role=link target=_blank download class=btn-link ng-if=\"patientWait.fType == \'excel\'\">{{\'cm.label.41\' | translate}} Excel</a> <a href={{auth.bucket}}cl/widgets/patientwait/sample.csv role=link target=_blank download class=btn-link ng-if=\"patientWait.fType == \'csv\'\">{{\'cm.label.41\' | translate}} CSV</a></span></div><div class=col-xs-4 ng-if=\"patientWait.fType == \'csv\'\"><div class=\"form-group noMarB\"><label for=delimiter>{{\'cl.widget.queue.18\' | translate}}</label><select id=delimiter class=form-control ng-model=patientWait.delimiter aria-label=\"{{\'cl.widget.queue.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.18\' | translate}}\"><option value=comma>{{\'cl.widget.queue.18.1\' | translate}}</option><option value=semicolon>{{\'cl.widget.queue.18.2\' | translate}}</option><option value=tab>{{\'cl.widget.queue.18.3\' | translate}}</option></select></div></div><div class=\"col-xs-3 noPadL\"><div class=\"form-group noMarB\"><label>&nbsp;</label><div><span class=\"btn btn-primary btn-file\" ng-disabled=fileModelLoading><span class=fa ng-class=\"fileModelLoading?\'fa-repeat fa-spin\':\'fa-arrow-down\'\" aria-hidden=true></span> {{\'cl.widget.cm.24\' | translate}} <input type=file file-model options=\"{format:[\'{{patientWait.fType}}\'], callback:true}\" accept=\"{{patientWait.fType == \'csv\'?\'.csv\':\'\' || patientWait.fType == \'excel\'?\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\':\'\'}}\" ng-disabled=fileModelLoading ng-if=!isFileUploading></span></div></div></div></div></div></div></div><div><div class=\"col-xs-9 col-lg-10 marB5\"><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=addRowFx(); ng-disabled=addRowBtn><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cl.widget.queue.2b\' | translate}}</button> <button type=button role=button class=\"btn btn-danger btn-xs\" ng-click=deleteOpen(); ng-disabled=!deletableItem.length><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.13\' | translate}}</button></div><div class=\"col-xs-3 col-lg-2 noPadR text-right\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchQu.text sanitize-input maxlength=250 ng-change=searchChangeFx(); ng-disabled=!patientWait.table.row.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchQu.text.length ng-click=\"searchChangeFx(); searchQu.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"col-xs-12 noPadR\"><div class=\"overflow-x marB10\"><table class=\"table table-striped queueTbl\"><thead><tr><th><label class=\"marT5 padL5\"><input type=checkbox ng-model=isChecked.selectAll ng-click=\"isCheckedFx(\'all\', $event);\" ng-disabled=isChecked.disabled role=checkbox><label></label></label></th><th class=\"valign-middle padL10\">{{\'d.label.2\' | translate}}</th><th class=\"valign-middle padL10\">{{\'cl.widget.pw.16\' | translate}}</th></tr></thead><tbody class=sortable-containment ng-if=\"!searchQu.text || (patientWait.table.row | filter:searchQu.text).length != 0\"><tr ng-repeat=\"row in filteredList = (patientWait.table.row | filter:searchQu.text)\" data-id={{row.id}}><td><label class=\"marT5 padL5\"><input type=checkbox ng-model=row.isChecked ng-click=isCheckedFx(); role=checkbox><label></label></label></td><td ng-repeat=\"cal in row.columns\"><input aria-label=label type=text class=\"form-control input-sm\" ng-model=cal.label></td></tr></tbody></table><div class=msg-warning lang={{auth.lang}} ng-if=\"searchQu.text && (patientWait.table.row | filter:searchQu.text).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchQu.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"patientWait.table.row.length == 0\">{{\'cl.widget.pw.m12\' | translate}}</div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=col-xs-12><div><label>{{\'cl.widget.pw.18\' | translate}}</label></div><div class=form-group role=radiogroup aria-labelledby=radiogroup><div class=\"pull-left marR20 marB20 pw-icon\"><label class=noMarB><span class=\"icon1 {{settingsQ.iconA}}\"></span> <span class=\"icon2 {{settingsQ.iconW}}\"></span> <img alt=\"Template 1\" ng-src=assets/images/widget/templates/pw_t1.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div>1. {{\'cl.widget.pw.m9.1\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>2. {{\'cl.widget.pw.m9.2\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>3. {{\'cl.widget.pw.m9.3\' | translate}}</div></div>\'\" tooltip-append-to-body=true> <img alt=\"Template 1\" ng-src=assets/images/widget/templates/pw_t1.1.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV_1\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'>{{\'cl.widget.pw.m9.1\' | translate}}</div>\'\" tooltip-append-to-body=true><div class=marT5><input type=radio role=radio name=templateOpt ng-model=settingsQ.template value=t1><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20 marB20 pw-icon\"><label class=noMarB><span class=\"icon1 {{settingsQ.iconA}}\"></span> <span class=\"icon2 {{settingsQ.iconW}}\"></span> <img alt=\"Template 2\" ng-src=assets/images/widget/templates/pw_t2.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div>1. {{\'cl.widget.pw.m10.1\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>2. {{\'cl.widget.pw.m10.2\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>3. {{\'cl.widget.pw.m10.3\' | translate}}</div></div>\'\" tooltip-append-to-body=true> <img alt=\"Template 2\" ng-src=assets/images/widget/templates/pw_t2.1.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV_1\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'>{{\'cl.widget.pw.m10.1\' | translate}}</div>\'\" tooltip-append-to-body=true><div class=marT5><input type=radio role=radio name=templateOpt ng-model=settingsQ.template value=t2><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20 marB20 pw-icon\"><label class=noMarB><span class=\"icon1 {{settingsQ.iconA}}\"></span> <span class=\"icon2 {{settingsQ.iconW}}\"></span> <img alt=\"Template 3\" ng-src=assets/images/widget/templates/pw_t3.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'><div>1. {{\'cl.widget.pw.m11.1\' | translate}}</div><div class=\'+\'spaceH2\'+\'></div><div>2. {{\'cl.widget.pw.m11.2\' | translate}}</div></div>\'\" tooltip-append-to-body=true> <img alt=\"Template 3\" ng-src=assets/images/widget/templates/pw_t3.1.png?1.0 ng-if=\"settingsQ.ep == \'GetPatientQueueForPSCTV_1\'\" uib-tooltip-html=\"\'<div class=\'+\'text-left\'+\'>{{\'cl.widget.pw.m11.1\' | translate}}</div>\'\" tooltip-append-to-body=true><div class=marT5><input type=radio role=radio name=templateOpt ng-model=settingsQ.template value=t3><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'3\'} }}</div></label></div></div></div><div class=col-xs-12><div><label>{{\'cl.widget.pw.17\' | translate}}</label></div><div class=\"col-xs-7 bg-light marB15\"><div class=padTB10><div><label>{{\'cl.widget.pw.17.1\' | translate}}</label></div><div class=form-group><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 1\" ng-src=assets/images/widget/templates/pw_a1.png><div class=marT5><input type=radio role=radio name=iconAOpt ng-model=settingsQ.iconA value=a1><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 2\" ng-src=assets/images/widget/templates/pw_a2.png><div class=marT5><input type=radio role=radio name=iconAOpt ng-model=settingsQ.iconA value=a2><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 3\" ng-src=assets/images/widget/templates/pw_a3.png><div class=marT5><input type=radio role=radio name=iconAOpt ng-model=settingsQ.iconA value=a3><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'3\'} }}</div></label></div></div><div class=clearfix></div></div><div class=\"bdr-top-dashed noPad\"></div><div class=padTB10><div><label>{{\'cl.widget.pw.17.2\' | translate}}</label></div><div class=form-group><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 1\" ng-src=assets/images/widget/templates/pw_w1.png><div class=marT5><input type=radio role=radio name=iconWOpt ng-model=settingsQ.iconW value=w1><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 2\" ng-src=assets/images/widget/templates/pw_w2.png><div class=marT5><input type=radio role=radio name=iconWOpt ng-model=settingsQ.iconW value=w2><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 3\" ng-src=assets/images/widget/templates/pw_w3.png><div class=marT5><input type=radio role=radio name=iconWOpt ng-model=settingsQ.iconW value=w3><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'3\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 4\" ng-src=assets/images/widget/templates/pw_w4.png><div class=marT5><input type=radio role=radio name=iconWOpt ng-model=settingsQ.iconW value=w4><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'4\'} }}</div></label></div></div><div class=clearfix></div></div><div class=\"bdr-top-dashed noPad\"></div><div class=padTB10><div><label>{{\'cl.widget.pw.17.3\' | translate}}</label></div><div class=form-group><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 1\" ng-src=assets/images/widget/templates/pw_c1.png><div class=marT5><input type=radio role=radio name=iconCOpt ng-model=settingsQ.iconC value=c1><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'1\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 2\" ng-src=assets/images/widget/templates/pw_w1.png><div class=marT5><input type=radio role=radio name=iconCOpt ng-model=settingsQ.iconC value=w1><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'2\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 3\" ng-src=assets/images/widget/templates/pw_w2.png><div class=marT5><input type=radio role=radio name=iconCOpt ng-model=settingsQ.iconC value=w2><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'3\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 4\" ng-src=assets/images/widget/templates/pw_w3.png><div class=marT5><input type=radio role=radio name=iconCOpt ng-model=settingsQ.iconC value=w3><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'4\'} }}</div></label></div><div class=\"pull-left marR20\"><label class=noMarB role=radiogroup aria-labelledby=radiogroup><img alt=\"Icon 5\" ng-src=assets/images/widget/templates/pw_w4.png><div class=marT5><input type=radio role=radio name=iconCOpt ng-model=settingsQ.iconC value=w4><label></label>{{\'cl.widget.iMenu.13\' | translate:{count: \'5\'} }}</div></label></div></div><div class=clearfix></div></div></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen = settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=spaceH2></div><div class=\"row marB15\"><div class=col-xs-6><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.bg, opacity:settingsQ.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.bg selected-type=ctypeQ.bg is-alpha=true selected-alpha=settingsQ.bga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=reload>{{\'cl.widget.wp.3\' | translate}}</label><div class=input-group><input type=number id=reload class=form-control ng-model=settingsQ.reload min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.header.bg, opacity:settingsQ.header.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.header.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.header.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.header.bg selected-type=ctypeQ.headerBg is-alpha=true selected-alpha=settingsQ.header.bga ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.header.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.header.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.header.text selected-type=ctypeQ.headerText ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=settingsQ.header.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-6><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=settingsQ.header.size aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.rowBg, opacity:settingsQ.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.rowBg selected-type=ctypeQ.rowBg is-alpha=true selected-alpha=settingsQ.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.altBg, opacity:settingsQ.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.altBg selected-type=ctypeQ.altBg is-alpha=true selected-alpha=settingsQ.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=settingsQ.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-6><label for=rowSize>{{\'cl.widget.cm.32\' | translate}}</label><input id=rowSize type=number class=form-control ng-model=settingsQ.rowSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.numberBg, opacity:settingsQ.numberBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.numberBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nb=true\" readonly aria-label=\"{{\'cl.widget.pw.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.4\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.numberBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.numberBg selected-type=ctypeQ.numberBg is-alpha=true selected-alpha=settingsQ.numberBga ng-if=colorPicker.nb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.numberText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.numberText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nt=true\" readonly aria-label=\"{{\'cl.widget.pw.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.numberText selected-type=ctypeQ.numberText ng-if=colorPicker.nt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=numberFont>{{\'cl.widget.pw.6\' | translate}}</label><select id=numberFont class=form-control ng-model=settingsQ.numberFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.pw.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.6\' | translate}}\"></select></div><div class=col-xs-6><label for=numberSize>{{\'cl.widget.pw.7\' | translate}}</label><input type=number id=numberSize class=form-control ng-model=settingsQ.numberSize aria-label=\"{{\'cl.widget.pw.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.7\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ic><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.iconColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.iconColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ic=true\" readonly aria-label=\"{{\'cl.widget.pw.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.iconColor selected-type=ctypeQ.iconColor ng-if=colorPicker.ic></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.aic><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.altIconColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.altIconColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.aic=true\" readonly aria-label=\"{{\'cl.widget.pw.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.altIconColor selected-type=ctypeQ.altIconColor ng-if=colorPicker.aic></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.footer.bg, opacity:settingsQ.footer.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.footer.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fb=true\" readonly aria-label=\"{{\'cl.widget.pw.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.footer.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.footer.bg selected-type=ctypeQ.footerBg is-alpha=true selected-alpha=settingsQ.footer.bga ng-if=colorPicker.fb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.footer.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.footer.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.pw.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.footer.text selected-type=ctypeQ.footerText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=footerFont>{{\'cl.widget.cm.37\' | translate}}</label><select id=footerFont class=form-control ng-model=settingsQ.footer.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.37\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37\' | translate}}\"></select></div><div class=col-xs-6><label for=footerSize>{{\'cl.widget.cm.37.1\' | translate}}</label><input type=number id=footerSize class=form-control ng-model=settingsQ.footer.size aria-label=\"{{\'cl.widget.cm.37.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37.1\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.20\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.arrived}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.arrived | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.pw.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.20\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.arrived selected-type=ctypeQ.arrived ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.uat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.unarrived}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.unarrived | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.uat=true\" readonly aria-label=\"{{\'cl.widget.pw.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.unarrived selected-type=ctypeQ.unarrived ng-if=colorPicker.uat></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.21\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.walkIn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.walkIn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wt=true\" readonly aria-label=\"{{\'cl.widget.pw.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.21\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.walkIn selected-type=ctypeQ.walkIn ng-if=colorPicker.wt></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.23\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.as><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.aCheckIn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.aCheckIn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.as=true\" readonly aria-label=\"{{\'cl.widget.pw.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.23\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.aCheckIn selected-type=ctypeQ.aCheckIn ng-if=colorPicker.as></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.24\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.uas><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.uCheckIn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.uCheckIn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.uas=true\" readonly aria-label=\"{{\'cl.widget.pw.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.24\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.uCheckIn selected-type=ctypeQ.uCheckIn ng-if=colorPicker.uas></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=textFormate>{{\'cl.widget.pw.22\' | translate}}</label><select id=textFormate class=form-control ng-model=settingsQ.textFormat aria-label=\"{{\'cl.widget.pw.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.22\' | translate}}\"><option value=d>{{\'cm.label.90\' | translate}}</option><option value=u>{{\'cl.widget.pw.22.1\' | translate}}</option><option value=l>{{\'cl.widget.pw.22.2\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=environment>{{\'cl.widget.pw.25\' | translate}}</label><select id=environment class=form-control ng-model=settingsQ.environment aria-label=\"{{\'cl.widget.pw.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.25\' | translate}}\"><option value=p>{{\'cl.widget.pw.25.2\' | translate}}</option><option value=t>{{\'cl.widget.pw.25.1\' | translate}}</option><option value=tr>{{\'cl.widget.pw.25.3\' | translate}}</option></select></div><div class=col-xs-6><label for=ep>{{\'cl.widget.pw.27\' | translate}}</label><select id=ep class=form-control ng-model=settingsQ.ep aria-label=\"{{\'cl.widget.pw.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.27\' | translate}}\"><option value=GetPatientQueueForPSCTV>GetPatientQueueForPSCTV</option><option value=GetPatientQueueForPSCTV_1>GetPatientQueueForPSCTV_1</option></select></div></div><div class=\"row marT15\"><div class=col-xs-6 ng-if=\"auth.uType == 0\"><label for=onWS>{{\'cl.widget.pw.26\' | translate}}</label><select id=onWS class=form-control ng-model=settingsQ.onWS aria-label=\"{{\'cl.widget.pw.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.26\' | translate}}\"><option value=1>{{\'cl.widget.pw.26.1\' | translate}}</option><option value=0>{{\'cl.widget.pw.26.2\' | translate}}</option></select></div></div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=patientWaitFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.pw.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"patientWait.dType == \'q\' && selectedT==\'2\'\" ng-click=patientWaitFx(2);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-if=\"encId || (patientWait.dType == \'a\' && selectedT==\'2\') || (patientWait.dType == \'q\' && selectedT==\'3\')\" ng-click=\"patientWaitFx(3, \'save\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'file\'\" aria-live=polite role=status>{{\'cl.widget.pw.m6\' | translate}}</div><div ng-if=\"errType==\'fileValid\'\" aria-live=polite role=status>{{\'cl.widget.pw.m8\' | translate}}</div><div ng-if=\"errType==\'headerSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.pw.m2\' | translate}}</div><div ng-if=\"errType==\'rowSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'numberSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m4\' | translate}}</div><div ng-if=\"errType==\'footerSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m5\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/powerBI.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.pBI.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.pBI.2\' | translate}} &nbsp; <span ng-if=powerBI.info.label>[ {{powerBI.info.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\" ng-if=\"powerBI.info.wType != \'epu\' && !detailLoading\"><a href=\"\" role=link ng-click=powerBIFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\" ng-if=\"powerBI.info.wType != \'epu\' && auth.upermissions.pbf && powerBI.powerbi.type == \'reports\' && selType != \'custom\' && !detailLoading\"><a href=\"\" role=link ng-click=powerBIFx(2);><span class=badge>3</span>{{\'cm.editor.11\' | translate}}</a></li><div class=\"pull-right d-flex\" ng-show=\"selectedT==\'3\'\"><div class=\"searchTbx marR5\" ng-if=\"filterList.length && !loadFilter.p && !loadFilter.f\"><input type=text class=\"form-control input-sm\" ng-model=searchText.f sanitize-input placeholder=\"{{\'cm.ph.2\' | translate}}\" aria-label=\"{{\'cm.ph.2\' | translate}}\" aria-labelledby=\"{{\'cm.ph.2\' | translate}}\" aria-placeholder=\"{{\'cm.ph.2\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.f.length ng-click=\"searchText.f = \'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=\"loadReport(\'load\');\" ng-if=\"!loadFilter.p && !loadFilter.f\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.pBI.30\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-4><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=powerBI.info.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.pBI.24\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=wTypeOpt ng-model=powerBI.info.wType value=ac ng-click=resetFx(); ng-disabled=\"encId != \'\'\"><label></label>{{\'cl.widget.pBI.24.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=wTypeOpt ng-model=powerBI.info.wType value=epu ng-click=resetFx(); ng-disabled=\"encId != \'\'\"><label></label>{{\'cl.widget.pBI.24.2\' | translate}}</label></div></div><div class=form-group ng-if=\"powerBI.info.wType == \'epu\'\"><label for=wData>{{\'cl.widget.iFrame.3\' | translate}} <span class=\"text-muted text-sm\">( {{\'cl.widget.iFrame.4\' | translate}}: &lt;iframe&gt; {{\'cm.label.42\' | translate}} &lt;embed&gt; )</span></label><textarea id=wData class=\"form-control txtAreaBig\" ng-model=powerBI.info.frameData aria-label=\"{{\'cl.widget.iFrame.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iFrame.3\' | translate}}\"></textarea></div><div ng-if=\"powerBI.powerbi.powerBIApp == \'ca\'\"><div ng-if=\"powerBI.info.wType != \'epu\'\"><div class=form-group><label>{{\'cl.widget.pBI.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=typeOpt ng-model=powerBI.powerbi.credential.auth value=u ng-disabled=\"encId != \'\' || groupShow\"><label></label>{{\'cl.widget.pBI.23.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=powerBI.powerbi.credential.auth value=sp ng-disabled=\"encId != \'\' || groupShow\"><label></label>{{\'cl.widget.pBI.23.2\' | translate}}</label></div></div><!-- {{auth.upermissions.pba == \"ca\"}}\r\n            {{auth.upermissions.pbcred}} --><div ng-if=\"auth.upermissions.pba == \'ca\' && !auth.upermissions.pbcred\"><div class=form-group><label for=tenantId>{{\'cl.widget.pBI.9\' | translate}}</label><input type=text id=tenantId class=form-control ng-model=powerBI.powerbi.credential.tenantId maxlength=140 ng-disabled=groupShow aria-label=\"{{\'cl.widget.pBI.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.9\' | translate}}\"></div><div class=form-group><label for=clientId>{{\'cl.widget.pBI.10\' | translate}}</label><input type=text id=clientId class=form-control ng-model=powerBI.powerbi.credential.clientId maxlength=140 ng-disabled=groupShow aria-label=\"{{\'cl.widget.pBI.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.10\' | translate}}\"></div><div class=form-group><label for=secret>{{\'cl.widget.pBI.11\' | translate}}</label><input type=password id=secret class=form-control ng-model=powerBI.powerbi.credential.secret autocomplete=off maxlength=140 ng-disabled=groupShow aria-label=\"{{\'cl.widget.pBI.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.11\' | translate}}\"></div></div></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group ng-if=\"auth.upermissions.pbi && powerBI.info.wType==\'ac\'\"><!-- ng-class=\"{\'noMar\':powerBI.info.pbi}\" --><label class=noMarB><input type=checkbox role=checkbox ng-model=powerBI.info.pbi ng-disabled=\"selType == \'custom\'\"><label></label>{{\'cl.widget.pBI.34\' | translate}}</label></div><div class=\"form-group noMarB\" ng-if=\"(powerBI.info.wType==\'ac\' && !powerBI.info.pbi) || powerBI.info.wType==\'epu\'\"><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=powerBI.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=powerBI.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"powerBI.settings.reloadOpt==\'c\'\"><input type=number id=cReload class=form-control ng-model=powerBI.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"form-group marT5 noMarB\" ng-if=\"powerBI.info.pbi && powerBI.info.wType==\'ac\'\"><label>{{\'s.p_s.label.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=powerBI.info.imggentime.f name=ctOpt value=d><label></label>{{\'s.p_s.label.4.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=powerBI.info.imggentime.f name=ctOpt value=w><label></label>{{\'s.p_s.label.4.2\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=powerBI.info.imggentime.f name=ctOpt value=di><label></label>{{\'s.p_s.label.4.4\' | translate}}</label></div><div class=\"form-group noMarB marT15\" ng-if=\"powerBI.info.imggentime.f==\'w\'\"><label for=wSelect>{{\'s.p_s.label.7\' | translate}}</label><div><select id=wSelect class=form-control ng-model=imgGenTimeObj.w><option value=\"\" disabled>{{\'cl.widget.pBI.35\' | translate}}</option><option value=mon>{{\'s.p_s.label.4.2.1\' | translate}}</option><option value=tue>{{\'s.p_s.label.4.2.2\' | translate}}</option><option value=wed>{{\'s.p_s.label.4.2.3\' | translate}}</option><option value=thu>{{\'s.p_s.label.4.2.4\' | translate}}</option><option value=fri>{{\'s.p_s.label.4.2.5\' | translate}}</option><option value=sat>{{\'s.p_s.label.4.2.6\' | translate}}</option><option value=sun>{{\'s.p_s.label.4.2.7\' | translate}}</option></select></div></div><div class=\"form-group noMarB marT15\" ng-if=\"powerBI.info.imggentime.f==\'di\'\"><label for=ctM translate=cl.widget.pBI.36 translate-values=\"{htmlTagO: \'<sup>\', htmlTagC: \'</sup>\'}\"></label><input type=number id=ctM class=form-control ng-model=imgGenTimeObj.di min=1 max=30 aria-label=\"{{\'cl.widget.pBI.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.3\' | translate}}\"></div></div></div></div><div><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=powerBI.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=powerBI.activePeriod></ng-active-period></div></div></div><div class=col-xs-4></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=msg-warning lang={{auth.lang}} ng-if=spWarnMsg>{{\'cl.widget.pBI.m13\' | translate}}</div><div ng-if=\"powerBI.powerbi.credential.auth != \'sp\'\" class=form-group><label>{{\'cl.widget.pBI.4\' | translate}}</label><div><button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'at\');\" ng-if=!groupShow ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"reAuthOpen(\'re\');\" ng-if=groupShow>{{groupShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"reAuthOpen(\'ou\');\" ng-if=groupShow>{{\'cl.widget.cm.25.2\' | translate}}</button></div></div><div ng-if=groupShow><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=typeOpt ng-change=getVisualizationFx(); ng-model=powerBI.powerbi.type value=dashboards><label></label>{{\'cl.widget.pBI.5\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-change=getVisualizationFx(); ng-model=powerBI.powerbi.type value=reports><label></label>{{\'cl.widget.pBI.6\' | translate}}</label></div><div class=form-group><label for=group>{{\'cl.widget.pBI.7\' | translate}}</label><select id=group class=\"form-control w50\" ng-model=powerBI.powerbi.group ng-options=\"group.name for group in groupList track by group.id\" ng-change=\"getVisualizationFx(\'change\'); clearFilersFx(\'w\')\" aria-label=\"{{\'cl.widget.pBI.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.7\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.pBI.7.1\' | translate}}</option></select></div><div ng-if=isWorkspace class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=selOpt ng-model=selType ng-change=\"selTypeFx(\'s\');\" value=single ng-disabled=powerBI.info.pbi><label></label>{{powerBI.powerbi.type == \'dashboards\' ? \'cl.widget.pBI.16\': \'cl.widget.pBI.17\' | translate}}</label><label class=noMarB><input type=radio role=radio name=selOpt ng-model=selType ng-change=\"selTypeFx(\'c\');\" value=custom ng-disabled=powerBI.info.pbi><label></label>{{\'cl.widget.pBI.18\' | translate}} &nbsp;&nbsp; <span class=\"fa fa-question-circle\" uib-tooltip=\"{{powerBI.powerbi.type == \'dashboards\'?\'cl.widget.pBI.m12\':\'cl.widget.pBI.m12.1\' | translate}}\" tooltip-append-to-body=true aria-hidden=true></span></label></div><div class=form-group ng-if=\"!isLoading && isWorkspace && selType==\'single\'\"><select id=visualization class=\"form-control w50\" ng-model=powerBI.powerbi.visualization ng-options=\"powerBI.powerbi.type==\'dashboards\'?visualization.displayName : visualization.name for visualization in visualizationList track by visualization.id\" ng-change=\"getTabList(powerBI.powerbi.visualization.id); clearFilersFx(\'r\');\" aria-label=visualization aria-labelledby=visualization><option value=\"\" disabled>{{powerBI.powerbi.type==\'dashboards\'?\'cl.widget.pBI.16\':\'cl.widget.pBI.17\' | translate}}</option></select></div><img alt=Loading src=assets/images/loading.gif ng-if=\"isPLoading && pages.length==0 && powerBI.powerbi.type == \'reports\' && visualizationList.length\"><div ng-if=\"!isLoading && powerBI.powerbi.type == \'reports\' && selType == \'single\' && !isPLoading && visualizationList.length\"><!-- <div ng-if=\"!isLoading && powerBI.powerbi.type == \'reports\' && selType == \'single\' && !isPLoading\"> --><div class=form-group><label for=tab>{{ pages.length == 1 || !pages.length ? \'cl.widget.pBI.33\' : \'cl.brief.9\' | translate}}</label><div ng-if=\"pages.length == 1 || !pages.length\"><span class=\"bg-default padLR4\">{{powerBI.powerbi.tab.displayname}}</span></div><div class=\"dropdown customSelect w50\" uib-dropdown auto-close=outsideClick is-open=status.isopen ng-if=\"pages.length > 1\"><span id=propD class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchText.p=\'\'\"><span ng-if=!powerBI.powerbi.tab.displayname>{{\'cl.widget.fb.9.1\' | translate}}</span> <span>{{powerBI.powerbi.tab.displayname}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\" ng-if=\"pages.length > 5\"><input type=text class=form-control ng-model=searchText.p sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger padT2\" ng-show=searchText.p.length ng-click=\"searchText.p=\'\'\"><span class=\"fa fa-remove valign-tBot\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"pages.length > 5\"></li><div class=list-scroll><li data-id={{pg.id}} ng-repeat=\"pg in filterepages = (pages | filter:searchText.p)\" ng-click=\"selectPageFx(pg); status.isopen=false\" ng-class=\"{\'bdrB\':pg.id == \'01first\', \'bdrT\':pg.id == \'02last\'}\"><label ng-class=\"{\'selected\': pg.id == powerBI.powerbi.tab.id}\">{{pg.displayname}}</label></li><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=\"pages.length && filterepages.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.p)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div><!-- <select id=\"tab\" class=\"form-control w50\" ng-model=\"powerBI.powerbi.tab\" ng-options=\"page.displayname for page in pages track by page.id\" aria-label=\"{{\'cl.widget.dText.6.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dText.6.3\' | translate}}\">\r\n                <option value=\"\">{{\'cl.widget.pBI.22\' | translate}}</option>\r\n              </select> --></div><div class=form-group ng-if=\"powerBI.powerbi.tab && powerBI.powerbi.tab.id == \'02last\'\"><label>{{\'cl.widget.quotes.4\' | translate}}</label><div class=form-inline><div class=input-group><input type=number id=cRotation class=form-control ng-model=powerBI.powerbi.rotDur min=10 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=form-group ng-if=\"!isLoading && isWorkspace && selType==\'custom\'\"><table class=\"table table-bordered\"><thead><tr class=bg-light><th>{{\'cl.widget.pBI.19\' | translate}}</th><th>{{\'cl.widget.pBI.20\' | translate}}</th></tr></thead><tbody><tr><td>{{powerBI.powerbi.type==\'dashboards\'?\'cl.widget.pBI.5\':\'cl.widget.pBI.6\' | translate}}</td><td><input type=text class=form-control ng-model=customData.item aria-label=\"{{\'cl.widget.pBI.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.20\' | translate}}\"></td></tr><tr ng-if=\"powerBI.powerbi.type==\'reports\'\"><td>{{\'cl.widget.dText.6.3\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></td><td><input type=text class=form-control ng-model=customData.tab aria-label=\"{{\'cl.widget.pBI.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.20\' | translate}}\"></td></tr></tbody></table></div><img alt=Loading src=assets/images/loading.gif ng-if=isLoading></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=col-xs-12><!-- Power BI Container --><div class=vHide id=powerbi-container style=\"width:0;height: 0\"></div><!-- <div id=\"powerbi-container\" style=\"width:100%;height: 500px;\"></div> --><!-- <button class=\"btn btn-primary\" ng-click=\"setDefaultTab()\">Set Default</button> --> <img alt=Loading src=assets/images/loading.gif ng-if=\"loadFilter.p || loadFilter.f\"><div class=form-group ng-if=\"!loadFilter.p && !loadFilter.f\"><!-- <div class=\"panel-inner-tab\">{{\'cl.widget.pBI.29\' | translate}}</div> --><div class=table><div class=\"row th\" ng-if=\"filteredFilLlist.length > 0\"><div class=col-xs-8>{{\'cl.widget.pBI.20\' | translate}}</div><div class=col-xs-4>{{\'ms.p_s.tab.8\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"fil in filteredFilLlist = (filterList | filter:searchText.f)\"><div class=\"col-xs-8 text-ellipsis-wrap padT8\">{{fil.target.column}} <span class=\"text-muted text-sm\">({{fil.target.table}})</span></div><div class=col-xs-4><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.isopen><span id=propD-{{$index}} class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList.d=\'\'\"><span ng-if=!fil.prop.label>{{\'ms.label.40\' | translate}}</span> <span>{{fil.prop.label}}</span> <span class=caret></span></span><ul class=\"dropdown-menu bg-white\" uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\" ng-if=\"dProperties.length > 5\"><input type=text class=form-control ng-model=searchList.d sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\'\"><span class=\"fa fa-remove valign-tBot\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"dProperties.length > 5\"></li><div class=\"list-scroll ng-cloak\"><div class=table><ul><li class=\"row pad5i\" data-id=\"\"><label class=\"fw-normal noMarB\"><input type=radio role=radio name=dpObj-{{$parent.$index}} ng-checked=!fil.prop.id ng-model=fil.prop ng-disabled=!fil.prop.id ng-change=\"singleFilFx(\'\', fil); status.isopen=false\"><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label></li><li class=\"row pad5i\" data-id={{dp.id}} ng-repeat=\"dp in filteredProperties = (dProperties | customSearch:{key:searchList.d, module:\'dp\'})\" tabindex=$index><label class=\"fw-normal noMarB\"><!-- <input type=\"checkbox\" ng-model=\"dp.selected\" role=\"checkbox\"> --> <input type=radio role=radio name=dpObj-{{$parent.$index}} value={{dp}} ng-checked=\"dp.id == fil.prop.id\" ng-model=fil.prop ng-disabled=\"dp.id == fil.prop.id\" ng-change=\"singleFilFx(dp, fil); status.isopen=false\"><label></label>{{dp.label}}</label></li></ul><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=!dProperties.length>{{\'ms.p_s.dp.m3\' | translate}}</div><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=\"dProperties.length && filteredProperties.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=!filterList.length>{{\'cl.widget.pBI.m16\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"filterList.length && filteredFilLlist.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText.f.replace(searchRegExp, searchReplaceChar))}}&quot;</b>\'}\"></div></ul></div></div></div><!-- Button to Get Filters --><!-- <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-click=\"getFilters()\">Get Filters</button> --><!-- Button to Get Filters --><!-- <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-click=\"setFilters()\">Set Filters</button> --><!-- <div class=\"col-xs-4\"> --><!-- <div class=\"col-xs-4 vHide\"> --><!-- Power BI Container --><!-- <div id=\"powerbi-container\"></div> --><!-- </div> --></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><span ng-if=\"powerBI.info.wType != \'epu\' && !detailLoading\"><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=\"tabFx(1, \'tabFx\');\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'3\'\" ng-click=\"tabFx(2, \'tabFx\');\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=powerBIFx(1); ng-disabled=saveProcessing>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\' && auth.upermissions.pbf && auth.uType != 4 && powerBI.powerbi.type == \'reports\' && selType != \'custom\'\" ng-click=powerBIFx(2); ng-disabled=saveProcessing>{{\'cm.btn.12\' | translate}}: {{\'cm.editor.11\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"powerBIFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\' || selectedT==\'3\'\" ng-disabled=\"saveProcessing || !visualizShow || (spWarnMsg && (selectedT == \'2\' ||selectedT==\'3\'))\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> </span><button type=button role=button class=\"btn btn-success\" ng-click=\"powerBIUrlFx(\'save\');\" ng-if=\"powerBI.info.wType == \'epu\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'allEmpty\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m1\' | translate}}</div><div ng-if=\"errType==\'groupEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m3\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'visualizEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m5\' | translate}}</div><div ng-if=\"errType==\'groupListEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m2\' | translate}}</div><div ng-if=\"errType==\'visualizListEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m4\' | translate}}</div><div ng-if=\"errType==\'selDEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m9\' | translate}}</div><div ng-if=\"errType==\'selREmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m10\' | translate}}</div><div ng-if=\"errType==\'custEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m11\' | translate}}</div><div ng-if=\"errType==\'data\'\" aria-live=polite role=status>{{\'cl.widget.iFrame.m1\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m14\' | translate}}</div><div ng-if=\"errType==\'haveNoFil\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m15\' | translate}}</div><div ng-if=\"errType==\'di\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m17\' | translate}}</div><div ng-if=\"errType==\'pages\'\" aria-live=polite role=status>{{\'cl.widget.pBI.m18\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/prayer.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.prayer.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.prayer.2\' | translate}} &nbsp; <span ng-if=prayer.label>[ {{prayer.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=\"msg-warning marB10 hide\" lang={{auth.lang}} translate=\"{{\'cl.widget.sp.m1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></div><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=prayer.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=religious>{{\'cl.widget.prayer.3\' | translate}}</label><select id=religious class=form-control ng-model=prayer.religion aria-label=\"{{\'cl.widget.prayer.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.prayer.3\' | translate}}\" ng-change=selReligionFx()><option value=\"\" disabled>{{\'cl.widget.prayer.3.1\' | translate}}</option><option value=is>{{\'cl.widget.prayer.3.2\' | translate}}</option></select></div><img alt=Loading src=assets/images/loading.gif ng-if=listLoading><div ng-if=!listLoading><div class=form-group ng-if=\"methodList.length > 0 && !listLoading\"><label for=method>{{\'cl.widget.prayer.5\' | translate}}</label><select id=method class=form-control ng-model=prayer.method aria-label=\"{{\'cl.widget.prayer.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.prayer.5\' | translate}}\" ng-options=\"option.label for option in methodList | orderBy:\'label\' track by option.id\"><option value=\"\" disabled>{{\'cl.widget.prayer.5.1\' | translate}}</option></select></div><div ng-if=\"prayer.religion != \'\'\"><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=onAddOpt ng-model=prayer.aType value=c ng-change=addressType();><label></label>{{\'db.p_map.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=onAddOpt ng-model=prayer.aType value=a ng-change=addressType();><label></label>{{\'db.p_map.2\' | translate}}</label><label ng-class=\"{\'noMarB\':prayer.aType == \'d\'}\"><input type=radio role=radio name=onAddOpt ng-model=prayer.aType value=d ng-change=addressType()><label></label>{{\'cl.widget.weather.11\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.weather.m2\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label></div><div ng-if=\"prayer.aType == \'c\'\"><div class=form-group><div class=row><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'db.p_map.3\' | translate}}</span> <input type=number id=lat class=form-control ng-model=prayer.addr.lat maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.3\' | translate}}\" aria-labelledby=\"{{\'db.p_map.3\' | translate}}\"></div></div><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'db.p_map.4\' | translate}}</span> <input type=number id=lng class=form-control ng-model=prayer.addr.lng maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.4\' | translate}}\" aria-labelledby=\"{{\'db.p_map.4\' | translate}}\"></div></div></div></div><label>{{\'db.p_map.5\' | translate}}</label><div class=\"mapContainer marLR-5 marB10\"><ng-map center={{mapCenter}} zoom=5 on-click=vm.addMarker(); map-initialized=mapLoaded(map) ng-if=\"auth.uservices.m == \'g\'\"><marker ng-repeat=\"pos in vm.positions\" position=\"{{pos.lat}}, {{pos.lng}}\"></marker></ng-map><div ng-if=\"auth.uservices.m == \'b\'\" id=azMap style=height:300px></div></div></div><div ng-if=\"prayer.aType == \'a\'\"><div class=form-group><label for=address>{{\'db.p_map.2\' | translate}}</label><input type=text id=address class=form-control ng-map-autocomplete ng-model=prayer.addr.address details=details aria-label=\"{{\'db.p_map.2\' | translate}}\" aria-labelledby=\"{{\'db.p_map.2\' | translate}}\"></div><div class=row><div class=col-xs-6><div class=form-group><label for=city>{{\'cm.label.45\' | translate}}</label><input type=text id=city class=form-control ng-model=prayer.addr.city maxlength={{inputLimit}} aria-label=\"{{\'cm.label.45\' | translate}}\" aria-labelledby=\"{{\'cm.label.45\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=province>{{\'db.p_map.6\' | translate}}</label><input type=text id=province class=form-control ng-model=prayer.addr.province maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.6\' | translate}}\" aria-labelledby=\"{{\'db.p_map.6\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=zipCode>{{\'db.p_map.7\' | translate}}</label><input type=text id=zipCode class=form-control ng-model=prayer.addr.zipCode maxlength=20 aria-label=\"{{\'db.p_map.7\' | translate}}\" aria-labelledby=\"{{\'db.p_map.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=country>{{\'db.p_map.8\' | translate}}</label><input type=text id=country class=form-control ng-model=prayer.addr.country maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.8\' | translate}}\" aria-labelledby=\"{{\'db.p_map.8\' | translate}}\"></div></div></div></div></div><div class=form-group ng-if=\"prayer.religion != \'\'\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR10 noMarB\"><input type=radio role=radio name=dTypeOpt value=l ng-model=prayer.dType><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=dTypeOpt value=c ng-model=prayer.dType><label></label>{{\'cl.widget.prayer.4\' | translate}}</label></div></div><div ng-if=\"prayer.religion != \'\' && prayer.dType == \'l\'\" class=form-group><img alt=weather1.png class=pull-left src=assets/images/widget/prayer/is_list.png></div><div ng-if=\"prayer.religion != \'\' && prayer.dType == \'c\'\" class=form-group><img alt=weather1.png class=pull-left src=assets/images/widget/prayer/is_countdown.png></div></div></div><div class=col-xs-10 ng-class=\"{\'marT15\':prayer.religion != \'\'}\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"prayer.dType == \'l\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"list.settings.rotationOpt == \'c\'\"><input type=number id=lRotate class=form-control ng-model=list.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.bg, opacity:list.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.bg selected-type=list.ctype.bg is-alpha=true selected-alpha=list.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.titleText selected-type=list.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=list.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=list.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.timeText selected-type=list.ctype.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=list.settings.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=list.settings.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.descText selected-type=list.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=descFont>{{\'cl.widget.survey.8\' | translate}}</label><select id=descFont class=form-control ng-model=list.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=list.settings.descSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div></div><!-- Countdown --><div ng-if=\"prayer.dType == \'c\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':countdown.settings.bg, opacity:countdown.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"countdown.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{countdown.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=countdown.settings.bg selected-type=countdown.ctype.bg is-alpha=true selected-alpha=countdown.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':countdown.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"countdown.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=countdown.settings.titleText selected-type=countdown.ctype.text ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=countdown.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=countdown.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':countdown.settings.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"countdown.settings.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=countdown.settings.timeText selected-type=countdown.ctype.time ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=countdown.settings.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=countdown.settings.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=prayer.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=prayer.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=prayerFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'tmSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'religion\'\" aria-live=polite role=status>{{\'cl.widget.prayer.m1\' | translate}}</div><div ng-if=\"errType==\'method\'\" aria-live=polite role=status>{{\'cl.widget.prayer.m2\' | translate}}</div><div ng-if=\"errType==\'latLng\'\" aria-live=polite role=status>{{\'db.msg.7\' | translate}}</div><div ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</div><div ng-if=\"errType==\'city\'\" aria-live=polite role=status>{{\'db.msg.4\' | translate}}</div><div ng-if=\"errType==\'province\'\" aria-live=polite role=status>{{\'db.msg.5\' | translate}}</div><div ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</div><div ng-if=\"errType==\'addrNotVlid\'\" aria-live=polite role=status>{{\'db.msg.8\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/progressBar.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.pb.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.pb.2\' | translate}} &nbsp; <span ng-if=pb.label>[ {{pb.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=pb.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cl.widget.pb.7\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=orientationOpt ng-model=pb.settings.orientation value=h><label></label>{{\'ms.label.10.2\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=orientationOpt ng-model=pb.settings.orientation value=v><label></label>{{\'ms.label.10.1\' | translate}}</label></div></div><div class=col-xs-3><label>{{\'cl.widget.pb.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=fTypeOpt ng-model=pb.settings.fValType value=d><label></label>{{\'cl.widget.pb.5\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=fTypeOpt ng-model=pb.settings.fValType value=s><label></label>{{\'cl.widget.weather.9.1\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.wf45.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':pb.settings.fill}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"pb.settings.fill | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.wf45.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=pb.settings.fill selected-type=pb.ctype.fill ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.wf45.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':pb.settings.bg, opacity:pb.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"pb.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cl.widget.wf45.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.7\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{pb.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=pb.settings.bg selected-type=pb.ctype.bg is-alpha=true selected-alpha=pb.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3 ng-if=\"pb.settings.fValType == \'s\'\"><label for=fValue>{{\'cl.widget.pb.6\' | translate}}</label><div class=form-inline><div class=\"input-group w100\"><input type=number id=fValue class=form-control ng-model=pb.settings.fVal min=1 aria-label=\"{{\'cl.widget.pb.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pb.6\' | translate}}\"><div class=input-group-addon>%</div></div></div></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=pb.settings.gl role=checkbox><label></label>{{\'cl.widget.wf45.21\' | translate}}</label></div></div></div><div class=\"row marT5\" ng-if=pb.settings.gl><div class=col-xs-3><label>{{\'cl.widget.wf45.22\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.gc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':pb.settings.glc}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"pb.settings.glc | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.gc=true\" readonly aria-label=\"{{\'cl.widget.wf45.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.22\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=pb.settings.glc selected-type=pb.ctype.glc ng-if=colorPicker.gc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=hoff>{{\'cl.widget.wf45.23\' | translate}}</label><input type=number id=hoff class=form-control ng-model=pb.settings.hoff aria-label=\"{{\'cl.widget.wf45.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.23\' | translate}}\"></div><div class=col-xs-3><label for=voff>{{\'cl.widget.wf45.24\' | translate}}</label><input type=number id=voff class=form-control ng-model=pb.settings.voff aria-label=\"{{\'cl.widget.wf45.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.24\' | translate}}\"></div><div class=col-xs-3><label for=blr>{{\'cl.widget.wf45.25\' | translate}}</label><input type=number id=blr class=form-control ng-model=pb.settings.blr min=0 aria-label=\"{{\'cl.widget.wf45.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wf45.25\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><div><label class=noMarB><input type=checkbox ng-model=pb.settings.rc role=checkbox><label></label>{{\'cl.widget.wf45.20\' | translate}} <span ng-if=pb.settings.rc class=\"text-muted text-sm\">({{\'cl.widget.pb.3.1\' | translate}})</span></label></div><input ng-if=pb.settings.rc type=number id=rcs class=\"form-control marT5\" ng-model=pb.settings.rcs min=1 aria-label=\"{{\'cl.widget.pb.3.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pb.3.1\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=pb.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=pb.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=pbSaveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'rcs\'\">{{\'cl.widget.pb.m1\' | translate}}</div><div ng-if=\"errType == \'fVal\'\">{{\'cl.widget.pb.m2\' | translate}}</div><div ng-if=\"errType == \'invFVal\'\">{{\'cl.widget.pb.m3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/qlik.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.qlik.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.qlik.2\' | translate}} &nbsp; <span ng-if=qlik.label>[ {{qlik.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\" ng-if=\"qlik.info.wType != \'epu\' && !detailLoading\"><a href=\"\" role=link ng-click=qlikFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=\"detailLoading || appsLoading\"><div class=\"row noMarR\" ng-if=\"!detailLoading && !appsLoading\"><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-8><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=qlik.labelOpt value=a><label></label>{{\'cl.widget.qlik.4\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=qlik.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"qlik.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=qlik.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=qlik.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=qlik.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"qlik.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=qlik.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':qlik.settings.bg, opacity:qlik.settings.bga}\"></span></span></span> <input type=text name=bgColor class=\"form-control picker\" ng-value=\"qlik.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{qlik.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=qlik.settings.bg selected-type=qlik.settings.ctype.bg is-alpha=true selected-alpha=qlik.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div><div><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=qlik.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=qlik.activePeriod></ng-active-period></div></div></div><div class=col-xs-4></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.qlik.13\' | translate}}</label><div class=\"msg-warning marB10\" ng-if=channel.isAuth>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'at\');\" ng-if=!appListShow ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-success\" ng-click=\"reAuthOpen(\'re\');\" ng-if=appListShow>{{appListShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-default\" ng-click=\"reAuthOpen(\'ou\');\" ng-if=appListShow>{{\'cl.widget.cm.25.2\' | translate}}</button></div></div><div class=form-group ng-if=appListShow><label for=app>{{\'cl.widget.qlik.8\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=al.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=appSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.5.1\' | translate}}\">{{qlik.apps.name}} <span ng-if=\"qlik.apps == \'\'\">{{\'cl.widget.qlik.8.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=appList.length><li class=\"dropdown-header noMar\" ng-if=\"appList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchApp.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchApp.name.length ng-click=\"searchApp.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"appList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"app in filteredApps = (appList | customSearch:{key:searchApp.name, module:\'qlik\'})\" tabindex=$index ng-class=\"{\'selected disabled\': app.id == qlik.apps.id}\"><label class=optInline ng-model=qlik.apps ng-click=selAppFx(app);><label></label><span>{{app.name}}</span> <span class=\"text-sm text-muted marL10\">({{app.id}})</span></label></li><div class=msg-warning ng-if=\"filteredApps.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchApp.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=form-group ng-if=\"appList.length && appListShow\"><label for=sheet>{{\'cl.widget.qlik.11\' | translate}}</label><input type=text id=sheet class=form-control ng-model=qlik.sheet.name maxlength=140 aria-label=\"{{\'cl.widget.qlik.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qlik.11\' | translate}}\"></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=qlikFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"qlikFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing || authSaveDisable || appsLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType == \'app\'\" aria-live=polite role=status>{{\'cl.widget.qlik.m7\' | translate}}</div><div ng-if=\"errType == \'sheet\'\" aria-live=polite role=status>{{\'cl.widget.qlik.m8\' | translate}}</div><div ng-if=\"errType == \'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType == \'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.qlik.m9\' | translate}}</div><div ng-if=\"errType == \'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'data\'\" aria-live=polite role=status>{{\'cl.widget.iFrame.m1\' | translate}}</div><div ng-if=\"errType == \'invTenant\'\" aria-live=polite role=status>{{\'cl.widget.qlik.m1\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/qrCode.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.qr.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.qr.2\' | translate}} &nbsp; <span ng-if=qr.label>[ {{qr.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=qr.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=dType>{{\'cl.widget.cm.9\' | translate}}</label><select id=dType class=form-control ng-model=qr.dType ng-change=setTypeFx(qr.dType); aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.cm.20\' | translate}}</option><option value=event>{{\'cl.widget.qr.11\' | translate}}</option><option value=call>{{\'cl.widget.cm.45\' | translate}}</option><option value=content>{{\'cm.label.1\' | translate}}</option><option value=dp>{{\'d.btn.11\' | translate}}</option><option value=email>{{\'cm.label.47\' | translate}}</option><option value=location>{{\'cl.widget.qr.11.3\' | translate}}</option><option value=txt>{{\'cl.widget.qr.9\' | translate}}</option><option value=sms>{{\'cl.widget.cm.46\' | translate}}</option><option value=url>{{\'cl.widget.cm.10\' | translate}}</option><option value=vCard>{{\'cl.widget.qr.12\' | translate}}</option><option value=wifi>{{\'cl.widget.cm.47\' | translate}}</option></select></div><!-- <div class=\"form-group\" ng-if=\"qr.dType == \'dp\'\">\r\n        <label for=\"dataQR\">{{\'cm.label.4\' | translate}}</label>\r\n        <div ng-if=\"dpLoading\"><img alt=\"loading\" src=\"assets/images/loading-xs.gif\"></div>\r\n        <select id=\"device\" class=\"form-control\" ng-options=\"d.label for d in devicesList track by d.id\" ng-model=\"qr.dataQR\" ng-hide=\"dpLoading\" aria-label=\"{{\'cm.label.4\' | translate}}\" aria-labelledby=\"{{\'cm.label.4\' | translate}}\">\r\n          <option value=\"\" disabled>{{\'cm.label.31\' | translate}}</option>\r\n        </select>\r\n      </div> --><div class=form-group ng-if=\"qr.dType == \'dp\'\"><label for=d>{{\'cm.label.4\' | translate}}</label><div class=form-group ng-if=dpLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=dl.isOpen ng-if=!dpLoading><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=deviceSearchFocus(); aria-placeholder=\"{{\'cm.label.31\' | translate}}\"><span ng-if=\"qr.dataQR && isSelectDevice\">{{\'cm.label.31\' | translate}}</span> <span ng-if=\"qr.dataQR && !isSelectDevice\">{{qr.dataQR.label}}</span> <span class=\"fa pull-right marT2 fa-angle-down\" style=\"margin-right:-7px;font-size: 16px;font-weight: 600\"></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"allScrollDataList.length > 5\"><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchDevice.label sanitize-input ng-change=searchChangeData(searchDevice.label); placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=\"text-danger noMarT\" ng-show=searchDevice.label.length ng-click=\"searchDevice.label=\'\';searchChangeData(searchDevice.label);\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider role=separator ng-if=\"allScrollDataList.length > 5\"></li><div class=\"list-scroll ng-cloak scrollQuad\" id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchDevice.label have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=false><li class=rowObj id={{d.id}} ng-repeat=\"d in device = (visibleData)\" tabindex=$index ng-if=!dListLoading><label ng-model=qr.dataQR ng-click=singleDeviceFx(d)><div class=\"marR5 deviceStatus {{d.status}}\" uib-tooltip=\"{{d.status | capitalize}}\" tooltip-popup-delay=500></div><label></label>{{d.l}}</label></li><!-- <li ng-repeat=\"d in device = (devicesList | customSearch:{key:searchDevice.label, module:\'dSelOp\'}) | orderBy: \'l\'\" tabindex=\"$index\">\r\n                  <label ng-model=\"qr.dataQR\" ng-click=\"singleDeviceFx(d)\"><div class=\"marR5 deviceStatus {{d.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{d.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"></div><label></label>{{d.l}}</label>\r\n                  </li> --><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex && !loadingMore\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=form-group ng-if=\"dListLoading || ((!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex && loadingMore)\"><img alt=Loading src=assets/images/loading-xs.gif></div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.length > 0 && device.length == 0 && !dListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDevice.label)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.length == 0\">{{\'db.msg.1\' | translate}}</div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"device.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{searchDevice.label}}&quot;</b>\'}\">\r\n                  </div> --></div></div></div></div></ul></div></div><div class=form-group ng-if=\"qr.dType == \'dp\' && !dpLoading\"><label class=noMar><input type=checkbox ng-model=qr.dataQR.isControls><label></label>{{\"d.label.28\" | translate}}</label></div><!-- text --><div class=form-group ng-if=\"qr.dType == \'txt\'\"><label for=txt>{{\'cl.widget.qr.9.1\' | translate}}</label><input type=text id=txt class=form-control ng-model=qr.dataQR.txt aria-label=\"{{\'cl.widget.qr.9.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.9.1\' | translate}}\"></div><!-- url --><div class=form-group ng-if=\"qr.dType == \'url\'\"><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=qr.dataQR.url aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><!-- call --><div class=form-group ng-if=\"qr.dType == \'call\'\"><label for=contact>{{\'cm.label.48\' | translate}}</label><input type=text id=contact class=form-control ng-model=qr.dataQR.no aria-label=\"{{\'cm.label.48\' | translate}}\" aria-labelledby=\"{{\'cm.label.48\' | translate}}\"></div><!-- content --><div class=form-group ng-if=\"qr.dType == \'content\'\"><label>{{\'cm.label.32\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!qr.dataQR.isHidden && (qr.dataQR.content.thumb || qr.dataQR.content.type == \'SharePointC\' || qr.dataQR.content.type == \'OneDriveC\' || qr.dataQR.content.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeBgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><!-- {{qr.dataQR.content}} --><!-- {{qr.dataQR.content.url}} --> <a ng-if=\"qr.dataQR.content.thumb && !qr.dataQR.content.url && qr.dataQR.content.type != \'Widget\'\" ng-href=\"{{cDetailBucket + qr.dataQR.content.thumb | secureThumb}}\" role=button data-access={{qr.dataQR.content.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(qr.dataQR.content.path + (qr.dataQR.content.path.length > 1 ? \' / \' : \' \') + qr.dataQR.content.label)}}\" ng-show=qr.dataQR.content.thumb><img ng-if=\"content.type != \'Widget\'\" alt=\"\" ng-src=\"{{tim + cBucket + qr.dataQR.content.thumb + inputImgThumbParam}}\"> </a><span ng-if=\"qr.dataQR.content.type == \'Widget\'\" class=qr-clIcon><span class=\"icon {{qr.dataQR.content.thumb}}\" ng-if=\"qr.dataQR.content.type == \'Widget\'&& (qr.dataQR.content.extn != \'YouTube\' && qr.dataQR.content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"qr.dataQR.content.type == \'Widget\' && qr.dataQR.content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"qr.dataQR.content.type == \'Widget\' && qr.dataQR.content.extn == \'YouTube\'\"></span> </span><a href=\"\" role=link ng-click=\"fbVideoWithTitleFx(cDetailBucket + qr.dataQR.content.url, qr.dataQR.content.path + (qr.dataQR.content.path.length > 1 ? \' / \' : \' \') + qr.dataQR.content.label);\" ng-if=\"qr.dataQR.content.thumb && qr.dataQR.content.url\"><img alt=\"\" ng-src=\"{{tim + cBucket + qr.dataQR.content.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-if=\"!qr.dataQR.content.thumb && qr.dataQR.content.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"!qr.dataQR.content.thumb && qr.dataQR.content.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"!qr.dataQR.content.thumb && qr.dataQR.content.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=qr.dataQR.isHidden><img uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button id=contentBtn class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.32\' | translate}}</button></div></div><!-- content controls --><!-- <div class=\"form-group\" ng-if=\"qr.dType == \'content\'\">\r\n        <label class=\"noMar\">\r\n          <input type=\"checkbox\" ng-model=\"qr.dataQR.isControls\">\r\n          <label></label> {{\"d.label.28\" | translate}}\r\n        </label>\r\n      </div> --><!-- email --><div ng-if=\"qr.dType == \'email\'\"><div class=form-group><div class=row><div class=col-xs-6><label for=email>{{\'cm.label.47\' | translate}}</label><input type=email id=email class=form-control ng-model=qr.dataQR.email aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"></div><div class=col-xs-6><label for=eSub>{{\'sc.mail.3\' | translate}}</label><input type=text id=eSub class=form-control ng-model=qr.dataQR.sub maxlength={{inputLimit}} aria-label=\"{{\'sc.mail.3\' | translate}}\" aria-labelledby=\"{{\'sc.mail.3\' | translate}}\"></div></div></div><div class=form-group><label for=eMsg>{{\'em.body.1\' | translate}}</label><textarea id=eMsg class=form-control ng-model=qr.dataQR.msg autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'em.body.1\' | translate}}\" aria-labelledby=\"{{\'em.body.1\' | translate}}\"></textarea></div></div><!-- sms --><div ng-if=\"qr.dType == \'sms\'\"><div class=form-group><label for=smsContact>{{\'cm.label.48\' | translate}}</label><input type=text id=smsContact class=form-control ng-model=qr.dataQR.no aria-label=\"{{\'cm.label.48\' | translate}}\" aria-labelledby=\"{{\'cm.label.48\' | translate}}\"></div><div class=form-group><label for=sMsg>{{\'em.body.1\' | translate}}</label><textarea id=sMsg class=form-control ng-model=qr.dataQR.msg autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'em.body.1\' | translate}}\" aria-labelledby=\"{{\'em.body.1\' | translate}}\"></textarea></div></div><!-- wi-fi --><div ng-if=\"qr.dType == \'wifi\'\"><div class=form-group><div class=row><div class=col-xs-6><label for=ssId>{{\'cl.widget.qr.3\' | translate}}</label><input type=text id=ssId class=form-control ng-model=qr.dataQR.ssId maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.3\' | translate}}\"></div><div class=col-xs-6><label for=pwd>{{\'cl.widget.wl.5\' | translate}}</label><input type=password id=pwd autocomplete=new-password class=form-control ng-model=qr.dataQR.pwd maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.wl.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.5\' | translate}}\"></div></div></div><div class=form-group><div class=row><div class=col-xs-6><label for=nType>{{\'cl.widget.qr.4\' | translate}}</label><select id=nType class=form-control ng-model=qr.dataQR.nType aria-label=\"{{\'cl.widget.qr.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.4\' | translate}}\"><option value=WEP>{{\'cl.widget.qr.6\' | translate}}</option><option value=WPA>{{\'cl.widget.qr.7\' | translate}}</option><option value=\"\">{{\'cl.widget.qr.8\' | translate}}</option></select></div></div></div><div class=form-group><label><input type=checkbox ng-model=qr.dataQR.isHidden role=checkbox><label></label>{{\'cl.widget.qr.5\' | translate}}</label></div></div><!-- Geo location --><div ng-if=\"qr.dType == \'location\'\"><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=onMapOpt ng-model=qr.dataQR.info.type value=c ng-change=addressType();><label></label>{{\'db.p_map.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=onMapOpt ng-model=qr.dataQR.info.type value=a ng-change=addressType();><label></label>{{\'db.p_map.2\' | translate}}</label></div><div ng-if=\"qr.dataQR.info.type == \'c\'\"><div class=form-group><div class=row><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'db.p_map.3\' | translate}}</span> <input type=number id=lat class=form-control ng-model=qr.dataQR.lat maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.3\' | translate}}\" aria-labelledby=\"{{\'db.p_map.3\' | translate}}\"></div></div><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'db.p_map.4\' | translate}}</span> <input type=number id=lng class=form-control ng-model=qr.dataQR.lng maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.4\' | translate}}\" aria-labelledby=\"{{\'db.p_map.4\' | translate}}\"></div></div></div></div><label>{{\'db.p_map.5\' | translate}}</label><div class=\"mapContainer marLR-5 marB10\"><ng-map center={{mapCenter}} zoom=5 on-click=vm.addMarker(); map-initialized=mapLoaded(map) ng-if=\"auth.uservices.m == \'g\'\"><marker ng-repeat=\"pos in vm.positions\" position=\"{{pos.lat}}, {{pos.lng}}\"></marker></ng-map><div ng-if=\"auth.uservices.m == \'b\'\" id=azMap style=height:300px></div></div></div><div ng-if=\"qr.dataQR.info.type == \'a\'\"><div class=form-group><label for=address>{{\'db.p_map.2\' | translate}}</label><input type=text id=address class=form-control ng-map-autocomplete ng-model=qr.dataQR.address details=details aria-label=\"{{\'db.p_map.2\' | translate}}\" aria-labelledby=\"{{\'db.p_map.2\' | translate}}\"></div><div class=row><div class=col-xs-6><div class=form-group><label for=city>{{\'cm.label.45\' | translate}}</label><input type=text id=city class=form-control ng-model=qr.dataQR.city maxlength={{inputLimit}} aria-label=\"{{\'cm.label.45\' | translate}}\" aria-labelledby=\"{{\'cm.label.45\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=province>{{\'db.p_map.6\' | translate}}</label><input type=text id=province class=form-control ng-model=qr.dataQR.province maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.6\' | translate}}\" aria-labelledby=\"{{\'db.p_map.6\' | translate}}\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=zipCode>{{\'db.p_map.7\' | translate}}</label><input type=text id=zipCode class=form-control ng-model=qr.dataQR.zipCode maxlength=20 aria-label=\"{{\'db.p_map.7\' | translate}}\" aria-labelledby=\"{{\'db.p_map.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=country>{{\'db.p_map.8\' | translate}}</label><input type=text id=country class=form-control ng-model=qr.dataQR.country maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.8\' | translate}}\" aria-labelledby=\"{{\'db.p_map.8\' | translate}}\"></div></div></div></div></div><!-- Calendar Event --><div ng-if=\"qr.dType == \'event\'\"><div class=form-group><label><input type=checkbox ng-model=qr.dataQR.isAllDay ng-change=resetWarnMsgFx(); role=checkbox><label></label>{{\'cl.widget.qr.11.1\' | translate}}</label></div><div class=form-group><div class=row><div class=col-xs-6><label for=title>{{\'cl.widget.qr.11.2\' | translate}}</label><input type=text id=title class=form-control ng-model=qr.dataQR.title maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.11.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.11.2\' | translate}}\"></div><div class=col-xs-6><label for=loc>{{\'cl.widget.qr.11.3\' | translate}}</label><input type=text id=loc class=form-control ng-model=qr.dataQR.loc maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.11.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.11.3\' | translate}}\"></div></div></div><div class=form-group><div class=row><div class=col-xs-12><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange class=\"form-control picker\" ng-model=qr.dataQR.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\"></div></div></div></div><div class=form-group ng-if=!qr.dataQR.isAllDay><div class=row><div class=\"col-xs-6 timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=sTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"qr.dataQR.sTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=qr.dataQR.sTime hour-step=1 minute-step=5></div></div></span></div><div class=\"col-xs-6 timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=eTime class=\"form-control picker\" uib-dropdown-toggle ng-value=\"qr.dataQR.eTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=qr.dataQR.eTime hour-step=1 minute-step=5></div></div></span></div></div></div><div class=form-group ng-if=!qr.dataQR.isAllDay><ng-timezone timezone=qr.dataQR.tz label=true timezone-list=timezoneList></ng-timezone></div><div class=form-group><label for=desc>{{\'cs.body.18\' | translate}}</label><textarea type=text id=desc class=form-control ng-model=qr.dataQR.desc autocomplete=off aria-label=\"{{\'cs.body.18\' | translate}}\" aria-labelledby=\"{{\'cs.body.18\' | translate}}\"></textarea></div></div><!-- VCard --><div ng-if=\"qr.dType == \'vCard\'\"><!-- Personal --><div class=form-group><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cl.widget.qr.12.1\' | translate}}</h5></div><div class=col-xs-4><label for=fName>{{\'ms.label.1\' | translate}}</label><input type=text id=fName class=form-control ng-model=qr.dataQR.fName maxlength=20 aria-label=\"{{\'ms.label.1\' | translate}}\" aria-labelledby=\"{{\'ms.label.1\' | translate}}\"></div><div class=col-xs-4><label for=mName>{{\'cl.widget.qr.12.1.1\' | translate}}</label><input type=text id=mName class=form-control ng-model=qr.dataQR.mName maxlength=20 aria-label=\"{{\'cl.widget.qr.12.1.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.1.1\' | translate}}\"></div><div class=col-xs-4><label for=lName>{{\'ms.label.2\' | translate}}</label><input type=text id=lName class=form-control ng-model=qr.dataQR.lName maxlength=20 aria-label=\"{{\'ms.label.2\' | translate}}\" aria-labelledby=\"{{\'ms.label.2\' | translate}}\"></div><div class=\"col-xs-4 marT10\"><label for=nName>{{\'cl.widget.qr.12.1.2\' | translate}}</label><input type=text id=nName class=form-control ng-model=qr.dataQR.nName maxlength=20 aria-label=\"{{\'cl.widget.qr.12.1.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.1.2\' | translate}}\"></div><div class=\"col-xs-4 marT10\"><label for=dobDate>{{\'cl.widget.qr.12.1.3\' | translate}}</label><div class=input-group ng-click=open1()><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text id=dobDate class=form-control uib-datepicker-popup=MM/dd/yyyy ng-model=qr.dataQR.dobDate is-open=popup1.opened datepicker-options=dateOptions show-button-bar=false ng-required=true close-text=Close aria-label=\"{{\'cl.widget.qr.12.1.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.1.3\' | translate}}\"></div></div></div></div><!-- Contacts --><div class=form-group><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cl.widget.qr.12.3\' | translate}}</h5></div><div class=col-xs-4><label for=contactM>{{\'cl.widget.qr.12.3.1\' | translate}}</label><input type=text id=contactM class=form-control ng-model=qr.dataQR.contactM aria-label=\"{{\'cl.widget.qr.12.3.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.3.1\' | translate}}\"></div><div class=col-xs-4><label for=contactH>{{\'cl.widget.qr.12.3.2\' | translate}}</label><input type=text id=contactH class=form-control ng-model=qr.dataQR.contactH aria-label=\"{{\'cl.widget.qr.12.3.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.3.2\' | translate}}\"></div><div class=col-xs-4><label for=contactW>{{\'cl.widget.qr.12.2.2\' | translate}}</label><input type=text id=contactW class=form-control ng-model=qr.dataQR.contactW aria-label=\"{{\'cl.widget.qr.12.2.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.2.2\' | translate}}\"></div></div></div><!-- Emails --><div class=form-group><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cl.widget.qr.12.2\' | translate}}</h5></div><div class=col-xs-6><label for=emailP>{{\'cl.widget.qr.12.2.1\' | translate}}</label><input type=text id=emailP class=form-control ng-model=qr.dataQR.emailP aria-label=\"{{\'cl.widget.qr.12.2.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.2.1\' | translate}}\"></div><div class=col-xs-6><label for=emailW>{{\'cl.widget.qr.12.2.2\' | translate}}</label><input type=text id=emailW class=form-control ng-model=qr.dataQR.emailW aria-label=\"{{\'cl.widget.qr.12.2.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.2.2\' | translate}}\"></div></div></div><!-- Work --><div class=form-group><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cl.widget.qr.12.4\' | translate}}</h5></div><div class=col-xs-12><label for=org>{{\'cl.widget.qr.12.4.1\' | translate}}</label><input type=text id=org class=form-control ng-model=qr.dataQR.org maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.12.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.4.1\' | translate}}\"></div><div class=\"col-xs-6 marT10\"><label for=jobTitle>{{\'cl.widget.qr.12.4.2\' | translate}}</label><input type=text id=jobTitle class=form-control ng-model=qr.dataQR.jobTitle maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.12.4.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.4.2\' | translate}}\"></div><div class=\"col-xs-6 marT10\"><label for=website>{{\'cs.p_i.2\' | translate}}</label><input type=text id=website class=form-control ng-model=qr.dataQR.website maxlength={{inputLimit}} aria-label=\"{{\'cs.p_i.2\' | translate}}\" aria-labelledby=\"{{\'cs.p_i.2\' | translate}}\"></div></div></div><div class=row><!-- Home address --><div class=col-xs-6><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\"><label class=noMar><input type=checkbox ng-model=qr.dataQR.isHomeAdd ng-change=resetHomeAddFx(); role=checkbox><label></label>{{\'cl.widget.qr.12.5\' | translate}}</label></h5></div><div class=col-xs-12><div class=form-group><label for=addressH>{{\'cs.p_i.3\' | translate}}</label><input type=text id=addressH class=form-control ng-model=qr.dataQR.addressH.address ng-disabled=!qr.dataQR.isHomeAdd maxlength={{inputLimit}} aria-label=\"{{\'cs.p_i.3\' | translate}}\" aria-labelledby=\"{{\'cs.p_i.3\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=cityH>{{\'cm.label.45\' | translate}}</label><input type=text id=cityH class=form-control ng-model=qr.dataQR.addressH.city ng-disabled=!qr.dataQR.isHomeAdd maxlength={{inputLimit}} aria-label=\"{{\'cm.label.45\' | translate}}\" aria-labelledby=\"{{\'cm.label.45\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=stateH>{{\'db.p_map.6\' | translate}}</label><input type=text id=stateH class=form-control ng-model=qr.dataQR.addressH.state ng-disabled=!qr.dataQR.isHomeAdd maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.6\' | translate}}\" aria-labelledby=\"{{\'db.p_map.6\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=zipH>{{\'db.p_map.7\' | translate}}</label><input type=text id=zipH class=form-control ng-model=qr.dataQR.addressH.zip ng-disabled=!qr.dataQR.isHomeAdd maxlength=20 aria-label=\"{{\'db.p_map.7\' | translate}}\" aria-labelledby=\"{{\'db.p_map.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=countryH>{{\'db.p_map.8\' | translate}}</label><input type=text id=countryH class=form-control ng-model=qr.dataQR.addressH.country ng-disabled=!qr.dataQR.isHomeAdd maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.8\' | translate}}\" aria-labelledby=\"{{\'db.p_map.8\' | translate}}\"></div></div></div></div><!-- Work address --><div class=col-xs-6><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\"><label class=noMar><input type=checkbox ng-model=qr.dataQR.isWorkAdd ng-change=resetWorkAddFx(); role=checkbox><label></label>{{\'cl.widget.qr.12.6\' | translate}}</label></h5></div><div class=col-xs-12><div class=form-group><label for=addressW>{{\'cs.p_i.3\' | translate}}</label><input type=text id=addressW class=form-control ng-model=qr.dataQR.addressW.address ng-disabled=!qr.dataQR.isWorkAdd maxlength={{inputLimit}} aria-label=\"{{\'cs.p_i.3\' | translate}}\" aria-labelledby=\"{{\'cs.p_i.3\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=cityW>{{\'cm.label.45\' | translate}}</label><input type=text id=cityW class=form-control ng-model=qr.dataQR.addressW.city ng-disabled=!qr.dataQR.isWorkAdd maxlength={{inputLimit}} aria-label=\"{{\'cm.label.45\' | translate}}\" aria-labelledby=\"{{\'cm.label.45\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=stateW>{{\'db.p_map.6\' | translate}}</label><input type=text id=stateW class=form-control ng-model=qr.dataQR.addressW.state ng-disabled=!qr.dataQR.isWorkAdd maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.6\' | translate}}\" aria-labelledby=\"{{\'db.p_map.6\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=zipW>{{\'db.p_map.7\' | translate}}</label><input type=text id=zipW class=form-control ng-model=qr.dataQR.addressW.zip ng-disabled=!qr.dataQR.isWorkAdd maxlength=20 aria-label=\"{{\'db.p_map.7\' | translate}}\" aria-labelledby=\"{{\'db.p_map.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=countryW>{{\'db.p_map.8\' | translate}}</label><input type=text id=countryW class=form-control ng-model=qr.dataQR.addressW.country ng-disabled=!qr.dataQR.isWorkAdd maxlength={{inputLimit}} aria-label=\"{{\'db.p_map.8\' | translate}}\" aria-labelledby=\"{{\'db.p_map.8\' | translate}}\"></div></div></div></div></div><!-- Notes --><div class=row><div class=\"col-xs-12 marT5\"><h5 class=\"panel-inner-tab marB10\">{{\'cm.menu.57\' | translate}}</h5></div><div class=col-xs-12><div class=form-group><label for=note>{{\'cl.widget.qr.12.7\' | translate}}</label><textarea type=text id=note class=form-control ng-model=qr.dataQR.note autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.qr.12.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.qr.12.7\' | translate}}\"></textarea></div></div></div></div><div class=form-group ng-if=qr.dType><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=qrPreviewFx(); ng-disabled=previewLoading><span class=\"fa fa-repeat fa-spin\" ng-if=previewLoading aria-hidden=true></span>{{\'cl.widget.ss.7\' | translate}}</button></div><div class=form-group ng-if=\"qr.dType && isPreview\"><label>{{\'cl.widget.ss.7\' | translate}}</label><div><a ng-href=\"{{cDetailBucket + qrPreview.url | secureThumb}}\" role=link fancyboxable=fbTitleInside caption=\"\" ng-if=!previewLoading><img alt=perThumb ng-src=\"{{qrPreview.timthumb + cBucket + qrPreview.url + thumbBigParamZc3+\'?\'+ timestamp}}\"> </a><img alt=Loading src=assets/images/loading-xs.gif ng-if=previewLoading></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=qr.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=qr.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=qrFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'type\'\" aria-live=polite role=status>{{\'cl.widget.qr.m1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'txt\'\" aria-live=polite role=status>{{\'cl.widget.qr.m2\' | translate}}</div><div ng-if=\"errType==\'contact\'\" aria-live=polite role=status>{{\'cs.msg.6\' | translate}}</div><div ng-if=\"errType==\'contactInv\'\" aria-live=polite role=status>{{\'cs.msg.7\' | translate}}</div><div ng-if=\"errType==\'content\'\" aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div ng-if=\"errType==\'sMsg\' || errType == \'eMsg\'\" aria-live=polite role=status>{{\'em.msg.3\' | translate}}</div><div ng-if=\"errType==\'email\'\" aria-live=polite role=status>{{\'cl.widget.qr.m14\' | translate}}</div><div ng-if=\"errType==\'eSub\'\" aria-live=polite role=status>{{\'cl.widget.qr.m4\' | translate}}</div><div ng-if=\"errType==\'emailInv\'\" aria-live=polite role=status>{{\'cl.widget.qr.m13\' | translate}}</div><div ng-if=\"errType==\'ssId\'\" aria-live=polite role=status>{{\'cl.widget.qr.m5\' | translate}}</div><div ng-if=\"errType==\'pwd\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'cl.widget.qr.m6\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cm.msg.16\' | translate}}</div><div ng-if=\"errType==\'fName\'\" aria-live=polite role=status>{{\'cl.widget.qr.m7\' | translate}}</div><div ng-if=\"errType==\'lName\'\" aria-live=polite role=status>{{\'cl.widget.qr.m8\' | translate}}</div><div ng-if=\"errType==\'emailsInv\'\" aria-live=polite role=status>{{\'cl.widget.qr.m13s\' | translate}}</div><div ng-if=\"errType==\'addressH\'\" aria-live=polite role=status>{{\'cl.widget.qr.m10\' | translate}}</div><div ng-if=\"errType==\'addressW\'\" aria-live=polite role=status>{{\'cl.widget.qr.m11\' | translate}}</div><div ng-if=\"errType==\'latLng\'\" aria-live=polite role=status>{{\'db.msg.7\' | translate}}</div><div ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</div><div ng-if=\"errType==\'city\'\" aria-live=polite role=status>{{\'db.msg.4\' | translate}}</div><div ng-if=\"errType==\'province\'\" aria-live=polite role=status>{{\'db.msg.5\' | translate}}</div><div ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</div><div ng-if=\"errType==\'addrNotVlid\'\" aria-live=polite role=status>{{\'db.msg.8\' | translate}}</div><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'db.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/queue.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.queue.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.queue.2\' | translate}} &nbsp; <span ng-if=queue.label>[ {{queue.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=queue.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div ng-if=\"encId!=\'\'\"><span class=\"bg-default pad2\" ng-if=\"queue.dType == \'normal\'\">{{\'cl.widget.cm.9.1\' | translate}}</span> <span class=\"bg-default pad2\" ng-if=\"queue.dType == \'tabular\'\">{{\'cl.widget.queue.11\' | translate}}</span> <span class=\"bg-default pad2\" ng-if=\"queue.dType == \'tabular3p\'\">{{\'cl.widget.queue.12\' | translate}}</span></div><select id=dType class=form-control ng-model=queue.dType ng-change=\"changeType(\'dType\');\" ng-if=\"encId==\'\'\" aria-label=\"{{\'cl.widget.cm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.9\' | translate}}\"><option value=normal>{{\'cl.widget.cm.9.1\' | translate}}</option><option value=tabular>{{\'cl.widget.queue.11\' | translate}}</option><option value=tabular3p>{{\'cl.widget.queue.12\' | translate}}</option></select></div><div ng-if=\"queue.dType == \'normal\'\"><div class=row><div class=col-xs-4><div class=form-group><label for=starting>{{\'cl.widget.queue.5\' | translate}}</label><input type=number id=starting class=form-control ng-model=queue.starting min=1 aria-label=\"{{\'cl.widget.queue.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.5\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=ending>{{\'cl.widget.queue.6\' | translate}}</label><input type=number id=ending class=form-control ng-model=queue.ending min=1 aria-label=\"{{\'cl.widget.queue.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.6\' | translate}}\"></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label for=prefix>{{\'cl.widget.queue.7\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=prefix class=form-control ng-model=queue.prefix aria-label=\"{{\'cl.widget.queue.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.7\' | translate}}\"></div></div><div class=col-xs-12><div class=form-group><label for=suffix>{{\'cl.widget.queue.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=suffix class=form-control ng-model=queue.suffix aria-label=\"{{\'cl.widget.queue.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.8\' | translate}}\"></div></div></div></div><div ng-if=\"queue.dType == \'tabular\' || queue.dType == \'tabular3p\'\"><div class=row><div class=col-xs-12 ng-if=\"queue.dType == \'tabular3p\'\"><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=queue.url aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div></div><div class=\"col-xs-12 marB15\" ng-if=\"queue.dType == \'tabular\'\"><div class=\"bg-light pad10\"><label><input type=radio role=radio ng-model=queue.gType value=g name=fOpt ng-change=\"changeType(\'gType\');\"><label></label>{{\'cl.widget.queue.15\' | translate}}</label><label class=marL10><input type=radio role=radio ng-model=queue.gType value=f name=fOpt ng-change=\"changeType(\'gType\');\"><label></label>{{\'cl.widget.queue.16\' | translate}}</label><div class=row><div class=col-xs-6 ng-if=\"queue.gType == \'g\'\"><div class=\"form-group noMarB\"><label>{{\'cl.widget.queue.17\' | translate}}</label><div class=input-group><input type=number id=columns class=form-control ng-model=queue.columns min=1 aria-label=\"{{\'cl.widget.queue.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.17\' | translate}}\"><div class=input-group-btn><button type=button role=button class=\"btn btn-primary\" ng-click=generateFx(); ng-disabled=generateProcessing><span class=fa ng-class=\"generateProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{generateProcessing?\'cl.widget.queue.1bi\':\'cl.widget.queue.1b\' | translate}}</button></div></div></div></div><div class=col-xs-12 ng-if=\"queue.gType == \'f\'\"><div class=row><div class=col-xs-3><div class=\"form-group noMarB\"><label for=fType>{{\'cl.brief.6\' | translate}}</label><select id=fType class=form-control ng-model=queue.fType ng-change=\"changeType(\'fType\');\" aria-label=\"{{\'cl.brief.6\' | translate}}\" aria-labelledby=\"{{\'cl.brief.6\' | translate}}\"><option value=csv>CSV</option><option value=excel>Excel</option><option value=xml>XML</option></select></div></div><div class=col-xs-3 ng-if=\"queue.fType == \'csv\'\"><div class=\"form-group noMarB\"><label for=delimiter>{{\'cl.widget.queue.18\' | translate}}</label><select id=delimiter class=form-control ng-model=queue.delimiter aria-label=\"{{\'cl.widget.queue.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.18\' | translate}}\"><option value=comma>{{\'cl.widget.queue.18.1\' | translate}}</option><option value=semicolon>{{\'cl.widget.queue.18.2\' | translate}}</option><option value=tab>{{\'cl.widget.queue.18.3\' | translate}}</option></select></div></div><div class=col-xs-3><div class=\"form-group noMarB\"><label>&nbsp;</label><div><span class=\"btn btn-primary btn-file\" ng-disabled=fileModelLoading><span class=fa ng-class=\"fileModelLoading?\'fa-repeat fa-spin\':\'fa-arrow-down\'\" aria-hidden=true></span> {{\'cl.widget.cm.24\' | translate}} <input type=file file-model options=\"{format:[\'{{queue.fType}}\'], callback:true}\" accept=\"{{queue.fType == \'csv\'?\'.csv\':\'\' || queue.fType == \'excel\'?\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\':\'\' || queue.fType == \'xml\'?\'text/xml\':\'\'}}\" ng-disabled=fileModelLoading ng-if=!isFileUploading></span></div></div></div></div></div></div></div></div></div></div></div><div ng-if=\"queue.dType == \'tabular\' && queue.table.head.columns.length > 0\"><div class=\"col-xs-9 col-lg-10 marB5\"><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=addRowFx(); ng-disabled=addRowBtn><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cl.widget.queue.2b\' | translate}}</button> <button type=button role=button class=\"btn btn-danger btn-sm\" ng-click=deleteOpen(); ng-disabled=deleteBtn><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.13\' | translate}}</button></div><div class=\"col-xs-3 col-lg-2 noPadR text-right\"><div class=searchTbx><input type=text class=form-control ng-model=searchQu.text sanitize-input maxlength=250 ng-disabled=!queue.table.row.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchQu.text.length ng-click=\"searchQu.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"col-xs-12 noPadR\"><div class=\"overflow-x marB10\"><table class=\"table table-striped queueTbl\"><thead><tr><th><label class=\"marT5 padL5\"><input type=checkbox ng-model=isChecked.selectAll ng-change=\"isCheckedFx(\'all\');\" role=checkbox><label></label></label></th><th ng-repeat=\"tbl in queue.table.head.columns\"><label class=marT5><input type=checkbox ng-model=tbl.hide role=checkbox><label></label>{{\'cl.widget.queue.1t\' | translate}}</label><input type=text class=\"form-control input-sm\" value={{tbl.label}} ng-model=tbl.label></th><th><label class=hideCal><input type=checkbox ng-model=queue.table.head.hide role=checkbox><label></label>{{\'cl.widget.queue.1t\' | translate}}</label></th></tr></thead><tbody class=sortable-containment ng-if=\"!searchQu.text || (queue.table.row | filter:searchQu.text).length != 0\"><tr ng-repeat=\"row in queue.table.row | filter:searchQu.text track by $index\" class=sortable-item data-id={{row.id}}><td><label class=\"marT5 padL5\"><input type=checkbox ng-model=row.isChecked ng-change=isCheckedFx(); role=checkbox><label></label></label></td><td ng-repeat=\"cal in row.columns\"><input type=text class=\"form-control input-sm\" ng-model=cal.label></td><td><label class=hideCal><input type=checkbox ng-model=row.hide role=checkbox><label></label>{{\'cl.widget.queue.1t\' | translate}}</label></td></tr></tbody></table><div class=msg-warning lang={{auth.lang}} ng-if=\"searchQu.text && (queue.table.row | filter:searchQu.text).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchQu.text)}}&quot;</b>\'}\"></div></div></div></div><div class=col-xs-9><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=queue.settings.reloadOpt name=reloadOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=queue.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"queue.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=queue.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group ng-if=\"queue.dType == \'tabular\' || queue.dType == \'tabular3p\'\"><label>{{\'cm.label.58\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=queue.settings.rotateOpt name=rotateOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=queue.settings.rotateOpt name=rotateOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"queue.settings.rotateOpt == \'c\'\"><input type=number id=rotate class=form-control ng-model=queue.settings.rotate min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=\"input-group-addon no-length\">{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':queue.settings.bg, opacity:queue.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{queue.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.bg selected-type=queue.ctype.bg is-alpha=true selected-alpha=queue.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div ng-if=\"queue.dType == \'normal\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.titleText selected-type=queue.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=titleFont>{{\'cm.label.24\' | translate}}</label><select id=titleFont class=form-control ng-model=queue.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.queue.7.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.prefixText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.prefixText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pc=true\" readonly aria-label=\"{{\'cl.widget.queue.7.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.7.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.prefixText selected-type=queue.ctype.prefixText ng-if=colorPicker.pc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=prefixFont>{{\'cl.widget.queue.7.2\' | translate}}</label><select id=prefixFont class=form-control ng-model=queue.settings.prefixFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.queue.7.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.7.2\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.queue.8.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.suffixText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.suffixText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sc=true\" readonly aria-label=\"{{\'cl.widget.queue.8.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.8.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.suffixText selected-type=queue.ctype.suffixText ng-if=colorPicker.sc></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.queue.8.2\' | translate}}</label><select id=suffixFont class=form-control ng-model=queue.settings.suffixFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.queue.8.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.8.2\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.queue.19\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.curText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.curText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly aria-label=\"{{\'cl.widget.queue.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.19\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.curText selected-type=queue.ctype.curText ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.queue.19.1\' | translate}}</label><select id=curFont class=form-control ng-model=queue.settings.curFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.queue.19.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.queue.19.1\' | translate}}\"></select></div></div></div><div ng-if=\"queue.dType != \'normal\'\"><div class=row><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':queue.settings.headerBg, opacity:queue.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{queue.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.headerBg selected-type=queue.ctype.headerBg is-alpha=true selected-alpha=queue.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.headerText selected-type=queue.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=queue.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.pw.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':queue.settings.footerBg, opacity:queue.settings.footerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.footerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fb=true\" readonly aria-label=\"{{\'cl.widget.pw.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{queue.settings.footerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.footerBg selected-type=queue.ctype.footerBg is-alpha=true selected-alpha=queue.settings.footerBga ng-if=colorPicker.fb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.pw.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.footerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.footerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.pw.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.footerText selected-type=queue.ctype.footerText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=footerFont>{{\'cl.widget.cm.37\' | translate}}</label><select id=footerFont class=form-control ng-model=queue.settings.footerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.37\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.37\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':queue.settings.rowBg, opacity:queue.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{queue.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.rowBg selected-type=queue.ctype.rowBg is-alpha=true selected-alpha=queue.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.rowText selected-type=queue.ctype.rowText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=queue.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':queue.settings.altBg, opacity:queue.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{queue.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.altBg selected-type=queue.ctype.altBg is-alpha=true selected-alpha=queue.settings.altBga ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.art><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':queue.settings.altText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"queue.settings.altText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.art=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=queue.settings.altText selected-type=queue.ctype.altText ng-if=colorPicker.art></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=altFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altFont class=form-control ng-model=queue.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=queue.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=queue.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=queueFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'start\'\" aria-live=polite role=status>{{\'cl.widget.queue.m1\' | translate}}</div><div ng-if=\"errType==\'end\'\" aria-live=polite role=status>{{\'cl.widget.queue.m2\' | translate}}</div><div ng-if=\"errType==\'startEnd\'\" aria-live=polite role=status>{{\'cl.widget.queue.m3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'columns\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8\' | translate}}</div><div ng-if=\"errType==\'grid\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8.1\' | translate}}</div><div ng-if=\"errType==\'file\'\" aria-live=polite role=status>{{\'cl.widget.queue.m8.2\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/quotes.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.quotes.1s\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.quotes.2\' | translate}} &nbsp; <span ng-if=quotes.label>[ {{quotes.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=quotesFx(1);><span class=badge>2</span>{{\'cl.widget.quotes.3\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=quotes.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.cm.19\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!quotes.isHidden && (quotes.bgImg.thumb || quotes.bgImg.type == \'SharePointC\' || quotes.bgImg.type == \'OneDriveC\' || quotes.bgImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=removeImgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=quotes.bgImg.thumb ng-href=\"{{cDetailBucket + quotes.bgImg.thumb | secureThumb}}\" role=button data-access={{quotes.bgImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(quotes.bgImg.path + (quotes.bgImg.path.length > 1 ? \' / \' : \' \') + quotes.bgImg.label)}}\" ng-show=quotes.bgImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + quotes.bgImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"quotes.bgImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"quotes.bgImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"quotes.bgImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=quotes.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=\"emptyThumb-sm marT6\"></div><button type=button role=button class=\"btn btn-primary btn-xs marT6\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div></div></div></div><div class=col-xs-9><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=quotes.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=quotes.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"quotes.settings.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=quotes.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div class=row><div class=col-xs-4><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':quotes.settings.bg, opacity:quotes.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"quotes.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{quotes.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=quotes.settings.bg selected-type=quotes.ctype.bg is-alpha=true selected-alpha=quotes.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=quotesFont>{{\'cl.widget.quotes.5\' | translate}}</label><select id=quotesFont class=form-control ng-model=quotes.settings.quotesFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.quotes.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.5\' | translate}}\"></select></div><div class=col-xs-4><label for=quotesSize>{{\'cl.widget.quotes.6\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=quotesSize class=form-control ng-model=quotes.settings.quotesSize min=1 max=125 aria-label=\"{{\'cl.widget.quotes.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.6\' | translate}}\"></div><div class=col-xs-4><label>{{\'cl.widget.quotes.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.qt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':quotes.settings.quotesText}\"></span></span> <input type=text id=quotesText class=\"form-control picker\" ng-value=\"quotes.settings.quotesText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.qt=true\" readonly aria-label=\"{{\'cl.widget.quotes.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=quotes.settings.quotesText selected-type=quotes.ctype.quotesText ng-if=colorPicker.qt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=authorFont>{{\'cl.widget.quotes.8\' | translate}}</label><select id=authorFont class=form-control ng-model=quotes.settings.authorFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.quotes.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.8\' | translate}}\"></select></div><div class=col-xs-4><label for=authorSize>{{\'cl.widget.quotes.9\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=authorSize class=form-control ng-model=quotes.settings.authorSize min=1 max=125 aria-label=\"{{\'cl.widget.quotes.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.9\' | translate}}\"></div><div class=col-xs-4><label>{{\'cl.widget.quotes.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':quotes.settings.authorText}\"></span></span> <input type=text id=authorText class=\"form-control picker\" ng-value=\"quotes.settings.authorText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.quotes.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.10\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=quotes.settings.authorText selected-type=quotes.ctype.authorText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=quotes.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=quotes.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=quoteOpt ng-model=quoteOpt value=addNew><label></label>{{\'cl.widget.quotes.11\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=quoteOpt ng-model=quoteOpt value=library><label></label>{{\'cl.widget.quotes.12\' | translate}}</label><label class=noMarB><input type=radio role=radio name=quoteOpt ng-model=quoteOpt value=chatGPTlibrary><label></label>{{\'cl.widget.quotes.17\' | translate}} <img src=\"assets/images/{{themeSwitch.btn?\'chatGPT-logo-dk\':\'chatGPT-logo\'}}.png\" width=16px height=16px alt=chatgptLogo style=\"position: absolute;margin-left: 5px\"></label><button type=button role=button class=\"btn btn-primary btn-xs pull-right\" ng-if=\"quoteOpt == \'library\'\" ng-click=\"selectQuoteFx(\'all\');\">{{\'cm.btn.44\' | translate}}</button> <button type=button role=button class=\"btn btn-primary btn-xs pull-right\" ng-if=\"quoteOpt == \'chatGPTlibrary\' && !selectAll\" ng-click=\"addChatGPTQuoteFx(\'all\');\">{{\'cm.btn.44\' | translate}}</button></div><div ng-if=\"quoteOpt==\'addNew\'\"><div class=form-group><label for=quote>{{\'cl.widget.quotes.1\' | translate}}</label><textarea id=quote class=form-control ng-model=addQuote.quote maxlength={{descriptionLimit}} aria-label=\"{{\'cl.widget.quotes.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.1\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - addQuote.quote.length}} ]</span></div><div class=form-group><label for=author>{{\'cl.widget.quotes.15\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=author class=form-control ng-model=addQuote.author maxlength={{inputLimit}} aria-label=\"{{\'cl.widget.quotes.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.quotes.15\' | translate}}\"></div><div class=form-group><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=addQuoteFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=resetQuoteFx();>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'quote\'\" aria-live=polite role=status>{{\'cl.widget.quotes.m1\' | translate}}</div></div></div></div><div class=form-group ng-if=\"quoteOpt==\'chatGPTlibrary\'\"><div class=\"row padL10\"><div class=col-xs-4 style=\"display: flex;align-items: center\"><img src=assets/images/chatgpt-icon.svg width=34px height=34px alt=chatgptLogo style=\"position: absolute\"> <input type=text class=form-control id=chatGPT ng-keypress=\"$event.keyCode == 13 && getQuotesChatGPT();\" placeholder=\"{{\'cl.widget.quotes.m7\' | translate}}\" ng-model=chatGPT.text ng-change=quotesTextChange() focus-me=true aria-label=\"Send a message\" maxlength={{inputLimit}} aria-labelledby=\"Send a message\" style=\"padding-left: 38px;border-top-left-radius:5px;border-bottom-left-radius:5px;padding-right: 34px\"> <span style=\"position: absolute;right: 16px\"><img src=assets/images/sendChatGPT.png id=sendText ng-click=getQuotesChatGPT(); width=24px height=24px alt=sendChatGPT style=\"border-radius: 5px\" ng-if=chatGPT.text> <img src=assets/images/sendChatGPTDisabled.png width=24px height=24px alt=sendChatGPT style=\"border-radius: 5px\" ng-if=!chatGPT.text></span></div></div></div><div ng-if=\"quoteOpt==\'library\'\"><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-9>{{\'cl.widget.quotes.13s\' | translate}} <span class=text-sm>({{\'cl.widget.quotes.14\' | translate}})</span></div><div class=col-xs-3>{{\'cl.widget.quotes.15\' | translate}}</div></div><div class=overflow-auto ng-attr-style=\"height:{{getAvailableHeight(400) * 0.40}}px;\"><ul><li class=\"row cursorDefault\" ng-repeat=\"ql in quoteLibrary\" ng-click=selectQuoteFx(ql.id);><div class=col-xs-9>{{ql.quote}}</div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=\"ql.author != \'\'\">{{ql.author}}</span> <span ng-if=\"ql.author == \'\'\" class=\"text-muted text-sm\">N/A</span></div></li></ul></div></div><div>&nbsp;</div></div><img alt=Loading src=assets/images/loading.gif ng-if=\"quotesLoading && quoteOpt==\'chatGPTlibrary\'\"><div ng-if=\"getQuoteChatGPTLibrary && quoteOpt==\'chatGPTlibrary\'\"><div class=\"table table-scroll\" ng-if=!quotesLoading><div class=\"row th\"><div class=col-xs-9>{{\'cl.widget.quotes.18\' | translate}} <span class=text-sm>({{\'cl.widget.quotes.14\' | translate}})</span></div><div class=col-xs-3>{{\'cl.widget.quotes.15\' | translate}}</div></div><div class=overflow-auto ng-attr-style=\"quoteChatGPTLibrary.length <= 0 ? 40px : height:{{getAvailableHeight(400) * 0.40}}px\"><ul><li class=\"row cursorDefault\" ng-repeat=\"ql in quoteChatGPTLibrary\" ng-click=addChatGPTQuoteFx(ql);><div class=col-xs-9>{{ql.quote}}</div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=\"ql.author != \'\'\">{{ql.author}}</span> <span ng-if=\"ql.author == \'\'\" class=\"text-muted text-sm\">N/A</span></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"quoteChatGPTLibrary.length <= 0\">{{\'cl.widget.quotes.m8\' | translate}}</div></div></div><div>&nbsp;</div></div><div class=spaceH2></div><div class=bdr-top-dashed></div><button type=button role=button class=\"btn btn-danger btn-xs pull-right\" ng-click=\"removeQuoteOpen(\'all\');\" ng-if=\"quotes.quoteList.length > 0\">{{\'cm.btn.45\' | translate}}</button><div class=clearfix></div><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-8>{{\'cl.widget.quotes.16\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cl.widget.quotes.15\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto ng-style=\"{\'max-height\':((quoteOpt==\'library\')?\'{{getAvailableHeight(400) * 0.37}}px\':\'{{getAvailableHeight(400) * 0.48}}px\')}\"><ul ng-if=\"quotes.quoteList.length > 0\"><li class=row ng-repeat=\"q in quotes.quoteList\"><div class=\"col-xs-8 text-ellipsis-wrap\">{{q.quote}}</div><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=\"q.author != \'\'\">{{q.author}}</span> <span ng-if=\"q.author == \'\'\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><button type=button role=button class=\"btn btn-danger btn-xs\" ng-click=removeQuoteOpen($index);><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></button></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"quotes.quoteList.length <= 0\">{{\'cl.widget.quotes.m2\' | translate}}</div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=quotesFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.quotes.13s\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"quotesFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'qFSize\'\" aria-live=polite role=status>{{\'cl.widget.quotes.m4\' | translate}}</div><div ng-if=\"errType==\'aFSize\'\" aria-live=polite role=status>{{\'cl.widget.quotes.m5\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/readerBoard.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>Readerboard</h1><h1 ng-if=!tabView>Edit Readerboard Widget &nbsp; <span ng-if=readerBoard.label>[ {{readerBoard.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=readerBoard.label maxlength={{inputLimit}} focus-me=true></div><div class=form-group><label>Type</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=readerBoard.dType value=r><label></label>Roomboard</label><label class=\"noMarB marL10 marR10\"><input type=radio role=radio name=typeOpt ng-model=readerBoard.dType value=wc><label></label>Wallboard collapsed</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=readerBoard.dType value=we><label></label>Wallboard expanded</label></div></div><div class=form-group><label for=url>Feed URL</label><input type=text id=feed class=form-control ng-model=readerBoard.feedUrl placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\"></div><div class=form-group><label for=logoPath>Logo directory path</label><input type=text id=logoPath class=form-control ng-model=readerBoard.logoPath></div><div class=form-group><label for=screenPath>Screensaver directory path</label><input type=text id=screenPath class=form-control ng-model=readerBoard.screenPath></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=readerBoard.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=readerBoard.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=readerBoardFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'feed\'\" aria-live=polite role=status>{{\'cl.widget.msg.7\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/rssFeed.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.rss.1\' | translate | camelCase}}</h1><h1 ng-if=!tabView>{{\'cl.widget.rss.2\' | translate}} &nbsp; <span ng-if=rss.label>[ {{rss.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=rss.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=rss.dType ng-change=\"changeDType(\'normal\')\" value=normal ng-if=\"widgetList.rssFeedCrawl || (rss.id && dTypeCopy == \'crawl\')\"><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=noMarB ng-if=\"widgetList.rssFeedCrawl || (rss.id && dTypeCopy == \'crawl\')\"><input type=radio role=radio name=dTypeOpt ng-model=rss.dType ng-change=\"changeDType(\'crawl\')\" value=crawl><label></label>{{\'cl.widget.cm.23\' | translate}}</label></div></div><div class=form-group><label for=feed>{{\'cl.widget.rss.1\' | translate}}</label><input type=text id=feed class=form-control ng-model=rss.feed placeholder=\"{{\'cm.ph.3\' | translate}}: http://rss.cnn.com/rss/edition.rss\" aria-label=\"{{\'cl.widget.rss.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.rss.1\' | translate}}\"></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"rss.dType == \'normal\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=rss.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=rss.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"rss.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=rss.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=rss.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=rss.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=rss.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"rss.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=rss.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"rss.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':rss.settings.headerBg, opacity:rss.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{rss.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.headerBg selected-type=rss.ctype.headerBg is-alpha=true selected-alpha=rss.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.headerText selected-type=rss.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=rss.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=rss.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':rss.settings.bg, opacity:rss.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{rss.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.bg selected-type=rss.ctype.bg is-alpha=true selected-alpha=rss.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=rss.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=rss.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':rss.settings.rowBg, opacity:rss.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{rss.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.rowBg selected-type=rss.ctype.rowBg is-alpha=true selected-alpha=rss.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':rss.settings.altBg, opacity:rss.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{rss.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.altBg selected-type=rss.ctype.altBg is-alpha=true selected-alpha=rss.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.titleText selected-type=rss.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.att><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.altTitleText selected-type=rss.ctype.altTitleText ng-if=colorPicker.att></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.descText selected-type=rss.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.altDescText selected-type=rss.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cm.label.24\' | translate}}</label><select id=rowFont class=form-control ng-model=rss.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=altRowFont>{{\'cm.label.24.1\' | translate}}</label><select id=altRowFont class=form-control ng-model=rss.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.24.1\' | translate}}\"></select></div></div></div><div ng-if=\"rss.dType == \'crawl\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.text.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=rss.settings.dir value=rl><label></label>{{\'cl.widget.text.5\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=rss.settings.dir value=bt ng-change=directionFx()><label></label>{{\'cl.widget.text.6\' | translate}}</label></div></div><div class=col-xs-6 ng-if=\"rss.settings.dir == \'bt\'\"><label>{{\'cl.widget.text.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=aOpt ng-model=rss.settings.align value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=aOpt ng-model=rss.settings.align value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label><input type=radio role=radio name=aOpt ng-model=rss.settings.align value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=speed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=speed class=form-control ng-model=rss.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':rss.settings.bg, opacity:rss.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{rss.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.bg selected-type=rss.ctype.bg is-alpha=true selected-alpha=rss.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"rss.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.bullet}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.bullet selected-type=rss.ctype.bullet ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"rss.settings.dir == \'bt\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.titleText selected-type=rss.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4 ng-if=\"rss.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':rss.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"rss.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=rss.settings.titleText selected-type=rss.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=rss.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-4 ng-if=\"rss.settings.dir == \'bt\'\"><label for=fontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=fontSize class=form-control ng-model=rss.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"rss.settings.dir == \'rl\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=rss.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label><input type=radio role=radio name=fsOpt ng-model=rss.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"rss.settings.fontSizeOpt == \'c\'\"><input type=number id=fontSize class=form-control ng-model=rss.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=rss.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=rss.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=rssFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'feed\'\" aria-live=polite role=status>{{\'cl.widget.rss.m1\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'fSizeText\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/scheduleCalendar.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.sc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.sc.2\' | translate}} &nbsp; <span ng-if=scheduleCalendar.label>[ {{scheduleCalendar.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-owns=\"tab-setting tab-ss tab-temp\" aria-labelledby=navList><button type=button role=button class=\"btn btn-primary pull-right\" ng-if=\"selectedT==\'3\'\" ng-click=previewFx(); ng-disabled=previewProcessing><span class=\"fa fa-film\" aria-hidden=true></span>{{\'d.btn.7\' | translate}} / {{\'cs.btn.5\' | translate}}</button><li ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-setting role=tab aria-selected=true><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-ss role=tab aria-selected=false><a href=\"\" role=link ng-click=\"scheduleCalendarFx(2, \'tabFx\');\"><span class=badge>2</span>{{\'cl.widget.sc.7\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-temp role=tab aria-selected=false><a href=\"\" role=link ng-click=\"scheduleCalendarFx(3, \'tabFx\');\" ng-class=\"{\'text-muted\': scheduleCalendar.schedules.length==0}\" ng-disabled=\"scheduleCalendar.schedules.length==0\"><span class=badge>3</span>{{\'cm.label.2s\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><div class=marT5><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=scheduleCalendar.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div></div><div class=\"col-xs-12 marT10\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=scheduleCalendar.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=scheduleCalendar.activePeriod></ng-active-period></div></div></div><div class=col-xs-12 ng-if=\"selectedT==\'2\'\"><div class=row><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 noPadR\'\"><ul class=\"list-unstyled table table-md\"><div class=\"row th\" ng-if=\"schedulesList.groups.length > 0 || schedulesList.schedules.length > 0\"><div class=col-xs-6>{{\'s.body.1\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.10\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.11\' | translate | camelCase}}</div></div><div class=overflow-auto ng-attr-style=height:{{quadHeight}}px;max-height:{{quadHeight}}px;><div selectable=selection selectable-list=schedulesList.schedules selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"><div class=folderQuad ng-repeat=\"s in scheduleGroup = schedulesList.groups\" ng-if=schedulesList.groups><div ng-if=s.label class=nonSelectable><!--Folder--><div class=folder-heading><div class=\"col-xs-11 text-bold text-ellipsis\" ng-click=folderFx($event);><a href=\"\" role=link><span class=\"fa fa-folder marR5\" aria-hidden=true></span>{{s.label}} <span class=\"text-muted text-unbold text-sm\">({{curGrpSchedule.length}})</span></a></div></div></div>{{curGrpSchedule = (schedulesList.schedules | sameValue:([s.gid, \'sg\']));\"\"}}<div class=\"folder-content hide\"><li class=row ng-repeat=\"cgs in curGrpSchedule\" data-id={{cgs.id}}><div class=panel-body><div class=\"col-xs-6 text-ellipsis\"><input type=checkbox ng-click=\"checkboxFx($event, cgs.id);\" role=checkbox><label></label><span class=\"fa fa-warning text-warning hide\" aria-hidden=true></span> {{cgs.label}}</div><div class=col-xs-3><span ng-if=\"cgs.startDate != null\">{{(cgs.startDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"cgs.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-3><span ng-if=\"cgs.startDate != null\">{{(cgs.endDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"cgs.endDate == null\" class=\"text-muted text-sm\">N/A</span></div></div></li><div class=\"msg-warning mar5 nonSelectable\" lang={{auth.lang}} ng-if=\"curGrpSchedule.length == 0\">{{\'s.msg.5\' | translate}}</div></div></div><li class=row ng-repeat=\"s in scheduleItem = schedulesList.schedules\" ng-if=!s.gid data-id={{s.id}}><div class=\"col-xs-6 text-ellipsis\"><input type=checkbox ng-click=\"checkboxFx($event, s.id);\" role=checkbox><label></label><span class=\"fa fa-warning text-warning hide\" aria-hidden=true></span> {{s.label}}</div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{(s.startDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{(s.endDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div></li></div></div></ul></div><div class=noPadR ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=\"selectedQuad panel-body\" ng-class=\"auth.upreferences.isSplitV?\'noPadL noPadR\':\'noPad\'\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'s.brief.1\' | translate | capitalize}} [ {{scheduleCalendar.schedules.length}} ]</div><section class=noMarB><div class=\"overflow-auto padT10\" ng-attr-style=height:{{selectedHeight}}px><div ng-if=\"scheduleCalendar.schedules.length > 0\"><div class=\"list-inline table table-md1\"><div class=row ng-repeat=\"s in filteredSchedules = (scheduleCalendar.schedules | customSearch:{key:selectedSearchText, module:\'s\'})\" data-id={{s.id}} ng-if=\"scheduleCalendar.schedules.length > 0\"><div class=\"col-xs-5 text-ellipsis\">{{s.label}}</div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{(s.startDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=col-xs-3><span ng-if=\"s.startDate != null\">{{(s.endDate * 1000) | date:\"MMM d, y\"}}</span> <span ng-if=\"s.endDate == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=text-danger ng-click=\"removeFx(\'selected-schedule\', s.id)\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"scheduleCalendar.schedules.length > 0 && filteredSchedules.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"scheduleCalendar.schedules.length == 0\">{{\'cm.msg.4\' | translate}}</div></div></section></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=col-xs-12><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=scheduleCalendar.dType value=d><label></label>{{\'cl.widget.sc.3\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=scheduleCalendar.dType value=w><label></label>{{\'cl.widget.sc.4\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=scheduleCalendar.dType value=m><label></label>{{\'cl.widget.sc.5\' | translate}}</label></div></div><div ng-if=\"scheduleCalendar.dType ==\'d\'\"><div class=row><div class=col-xs-6><div class=\"bdr-btm-dashed marB0\"><label>Select dates</label></div><div class=form-group style=width:300px><multiple-date-picker day-click=departureDatepickerClick ng-model=selectedDay></multiple-date-picker></div></div><div class=col-xs-6><div class=\"bdr-btm-dashed marB0\"><label>Selected dates</label></div><ul class=\"list-unstyled list-striped\"><div class=table-scroll><li ng-repeat=\"date in selectedDay | orderBy\"><div class=row><div class=col-xs-10>{{date | momentTimeZone}}</div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=text-danger ng-click=removeDateFx(date);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></li></div></ul></div><div class=clearfix></div></div></div><div ng-if=\"scheduleCalendar.dType ==\'w\'\"><div class=\"form-group marB20\"><label>Select days</label><div><label class=\"noMarB marR10\" ng-repeat=\"day in weekdays\"><input type=checkbox ng-model=scheduleCalendar.selectedWeekDays[$index] ng-checked=scheduleCalendar.selectedWeekDays[$index] value={{day}} role=checkbox><label></label>{{\'s.p_s.label.4.2.\' + day | translate}}</label></div></div><div class=row><div class=col-xs-6><div class=form-group><div class=\"bdr-btm-dashed marB0\"><div class=pull-right><a href=\"\" role=link ng-click=generateWeekCalendar(-1) class=marR5><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></a>{{curYear}}<a href=\"\" role=link ng-click=generateWeekCalendar(+1); class=marL5><span class=\"fa fa-chevron-right noMarR\" aria-hidden=true></span></a></div><label>Select weeks</label></div><div class=\"table overflow-auto\" ng-attr-style=height:{{getAvailableHeight(510)}}px;max-height:{{getAvailableHeight(510)}}px;><div class=\"row padL5\" ng-repeat=\"week in weeks\"><div class=col-xs-12><a href=\"\" role=link ng-click=\"selectWeekFx(week.sd + \'|\' + week.ed)\">{{week.sd | momentTimeZone}} - {{week.ed | momentTimeZone}}</a></div></div></div></div></div><div class=col-xs-6><div class=form-group><div class=\"bdr-btm-dashed marB0\"><label>Selected weeks</label></div><div class=\"table overflow-auto\" ng-attr-style=height:{{getAvailableHeight(510)}}px;max-height:{{getAvailableHeight(510)}}px;><div class=row ng-repeat=\"week in scheduleCalendar.selectedWeeks\"><div class=col-xs-12><a href=\"\" role=link class=\"pull-right text-danger\" ng-click=\"removeFx(\'selected-week\', week.split(\'|\')[0])\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> {{week.split(\"|\")[0] | momentTimeZone}} - {{week.split(\"|\")[1] | momentTimeZone}}</div></div></div></div></div></div></div><div class=form-group ng-if=\"scheduleCalendar.dType ==\'m\'\"><div class=row><div class=col-xs-6><div class=form-group><div class=\"bdr-btm-dashed marB0\"><div class=pull-right><a href=\"\" role=link ng-click=generateMonthCalendar(-1) class=marR5><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></a>{{curYear}}<a href=\"\" role=link ng-click=generateMonthCalendar(+1); class=marL5><span class=\"fa fa-chevron-right noMarR\" aria-hidden=true></span></a></div><label>Select months</label></div><div class=\"table overflow-auto\" ng-attr-style=max-height:{{getAvailableHeight(500)}}px;><div class=\"row padL5\" ng-repeat=\"month in months\"><div class=col-xs-12><a href=\"\" role=link ng-click=\"selectMonthFx(month + \'|\' + curYear)\">{{\'s.p_s.label.11.\' + month | translate}} {{curYear}}</a></div></div></div></div></div><div class=col-xs-6><div class=form-group><div class=\"bdr-btm-dashed marB0\"><label>Selected months</label></div><div class=\"table overflow-auto\" ng-attr-style=max-height:{{getAvailableHeight(500)}}px;><div class=row ng-repeat=\"month in scheduleCalendar.selectedMonths\"><div class=col-xs-12><a href=\"\" role=link class=\"pull-right text-danger\" ng-click=\"removeFx(\'selected-month\', month)\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> {{\'s.p_s.label.11.\' + month.split(\"|\")[0] | translate}} {{month.split(\"|\")[1]}}</div></div></div></div></div></div></div></div></div></div><!-- multiple-date-picker is a hide only for register --><multiple-date-picker ng-model=selectedDay ng-hide=true></multiple-date-picker></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\' || selectedT==\'3\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=\"scheduleCalendarFx(2, \'tabFx\');\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.sc.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=\"scheduleCalendarFx(3, \'tabFx\');\">{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"scheduleCalendarFx(3, \'save\');\" ng-if=\"encId || selectedT==\'3\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'schedules\'\" aria-live=polite role=status>{{\'cl.widget.sc.m1\' | translate}}</div><div ng-if=\"errType==\'selected-dates\'\" aria-live=polite role=status>{{\'cl.widget.sc.m2\' | translate}}</div><div ng-if=\"errType==\'selected-weeks\'\" aria-live=polite role=status>{{\'cl.widget.sc.m3\' | translate}}</div><div ng-if=\"errType==\'selected-months\'\" aria-live=polite role=status>{{\'cl.widget.sc.m4\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/selectSocialMedia.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.ssm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.ssm.2\' | translate}} &nbsp; <span ng-if=ssm.label>[ {{ssm.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=ssm.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=ssm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=ssm.activePeriod></ng-active-period></div></div><div class=col-xs-12><div class=marT15><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <button type=button role=button class=\"btn btn-primary btn-xs pull-right\" ng-click=openSelectQuad();>{{\'cm.label.32\' | translate | camelCase}}</button></div></div><div class=\"table no-th\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(500)}}px><div class=row ng-repeat=\"list in filteredItems = (selectSocialIems.widgets)\" ng-if=\"selectSocialIems.widgets.length > 0\"><div class=\"col-xs-11 word-break\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/xs/{{list.thumb}}.png class=marR5>{{list.label}}</div><div class=\"col-xs-1 text-right padT5\"><a href=\"\" role=link class=text-danger ng-click=\"removeInArray(filteredItems, list.id);\"><span class=\"fa fa-remove no marR\" aria-hidden=true></span></a></div></div><div ng-if=\"selectSocialIems.widgets.length == 0\" class=msg-warning lang={{auth.lang}}>{{\'cm.msg.36\' | translate}}</div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=ssmFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/slack.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.slack.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.slack.2\' | translate}} &nbsp; <span ng-if=slack.label>[ {{slack.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=slackFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=slack.labelOpt value=a><label></label>{{\'cl.widget.slack.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=slack.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"slack.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=slack.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':slack.settings.headerBg, opacity:slack.settings.headerBga}\"></span></span></span> <input type=text id=headerBg class=\"form-control picker\" ng-value=\"slack.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{slack.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.headerBg selected-type=slack.ctype.headerBg is-alpha=true selected-alpha=slack.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slack.settings.headerText}\"></span></span> <input type=text id=headerText class=\"form-control picker\" ng-value=\"slack.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.headerText selected-type=slack.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=slack.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=slack.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':slack.settings.rowBg, opacity:slack.settings.rowBga}\"></span></span></span> <input type=text id=rowBg class=\"form-control picker\" ng-value=\"slack.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{slack.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.rowBg selected-type=slack.ctype.rowBg is-alpha=true selected-alpha=slack.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':slack.settings.altBg, opacity:slack.settings.altBga}\"></span></span></span> <input type=text id=altBg class=\"form-control picker\" ng-value=\"slack.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{slack.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.altBg selected-type=slack.ctype.altBg is-alpha=true selected-alpha=slack.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=slack.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=rowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rowSize class=form-control ng-model=slack.settings.rowSize min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.slack.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.uc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slack.settings.userText}\"></span></span> <input type=text id=userText class=\"form-control picker\" ng-value=\"slack.settings.userText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.uc=true\" readonly aria-label=\"{{\'cl.widget.slack.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.slack.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.userText selected-type=slack.ctype.userText ng-if=colorPicker.uc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.dt.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slack.settings.dateText}\"></span></span> <input type=text id=dateText class=\"form-control picker\" ng-value=\"slack.settings.dateText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dc=true\" readonly aria-label=\"{{\'cl.widget.dt.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.dateText selected-type=slack.ctype.dateText ng-if=colorPicker.dc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.slack.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':slack.settings.msgText}\"></span></span> <input type=text id=msgText class=\"form-control picker\" ng-value=\"slack.settings.msgText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mc=true\" readonly aria-label=\"{{\'cl.widget.slack.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.slack.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=slack.settings.msgText selected-type=slack.ctype.msgText ng-if=colorPicker.mc></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=slack.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=slack.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.slack.5\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=channelShow>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{channelShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button></div></div><div class=form-group ng-if=channelShow><label for=channel>{{\'cl.widget.slack.7\' | translate}}</label><select id=channel class=form-control ng-model=slack.channel ng-options=\"channel.label for channel in channelList track by channel.id\" aria-label=\"{{\'cl.widget.slack.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.slack.7\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.slack.7.1\' | translate}}</option></select></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=slackFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"slackFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'headerSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'rowSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.slack.m2\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'channel\'\" aria-live=polite role=status>{{\'cl.widget.slack.m3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/socialChorus.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.sch.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.sch.2\' | translate}} &nbsp; <span ng-if=sch.label>[ {{sch.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=sch.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=ch>{{\'cl.widget.sch.3\' | translate}}</label><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=chLoading><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick ng-if=!chLoading><span id=channel class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=channelSearchFocus(); aria-placeholder=\"{{\'cl.widget.sch.3.1\' | translate}}\">{{sch.channel.name}} <span ng-if=\"sch.channel== \'\'\">{{\'cl.widget.sch.3.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"channelList.ch.length > 1\"><li class=\"dropdown-header noMar\" ng-if=\"channelList.ch.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchChannel.name sanitize-input maxlength=250 maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchChannel.name.length ng-click=\"searchChannel.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"channelList.ch.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"ch in channel = (channelList.ch | customSearch:{key:searchChannel.name, module:\'ch\', filterType:filter}) | orderBy: \'name\'\" tabindex=$index><label ng-model=ch.selected ng-click=changeChannelSetting(ch);><label></label>{{ch.name}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"channel.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchChannel.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=sch.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.sc.11\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=sch.dType value=l ng-change=\"dTypeChange(\'l\')\"><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=sch.dType value=m ng-change=\"dTypeChange(\'m\')\"><label></label>{{\'cl.widget.sc.10\' | translate}}</label></div></div><div class=form-group><div class=\"marR20 marB20\" ng-if=\"sch.dType == \'t\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/textMedia.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"sch.dType == \'l\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/list.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"sch.dType == \'m\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/media.png alt=\"Template 3\"></label></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"sch.dType == \'t\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"textMedia.settings.rotationOpt == \'c\'\"><input type=number id=tRotate class=form-control ng-model=textMedia.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.bg, opacity:textMedia.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.bg selected-type=textMedia.ctype.bg is-alpha=true selected-alpha=textMedia.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.textBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.textBg, opacity:textMedia.settings.textBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.textBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.textBg=true\" readonly aria-label=\"{{\'cl.widget.sc.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sc.8\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.textBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.textBg selected-type=textMedia.ctype.textBg is-alpha=true selected-alpha=textMedia.settings.textBga ng-if=colorPicker.textBg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=align>{{\'cl.widget.sc.9\' | translate}}</label><select id=align class=form-control ng-model=textMedia.settings.align aria-label=\"{{\'cl.widget.sc.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sc.9\' | translate}}\"><option value=l>{{\'cm.editor.10.4\' | translate}}</option><option value=c>{{\'cm.editor.10.5\' | translate}}</option><option value=r>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.titleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.titleText=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.titleText selected-type=textMedia.ctype.titleText ng-if=colorPicker.titleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=textMedia.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=textMedia.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.descText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.descText=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.descText selected-type=textMedia.ctype.descText ng-if=colorPicker.descText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=descFont>{{\'cl.widget.survey.8\' | translate}}</label><select id=descFont class=form-control ng-model=textMedia.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.8\' | translate}}\"></select></div><div class=col-xs-4><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=textMedia.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div></div><div ng-if=\"sch.dType == \'l\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"list.settings.rotationOpt == \'c\'\"><input type=number id=lRotate class=form-control ng-model=list.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"list.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=list.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"list.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.headerBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.headerBg, opacity:list.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.headerBg=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerBg selected-type=list.ctype.headerBg is-alpha=true selected-alpha=list.settings.headerBga ng-if=colorPicker.headerBg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.headerText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.headerText=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerText selected-type=list.ctype.headerText ng-if=colorPicker.headerText></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=list.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=list.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.bg, opacity:list.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.bg selected-type=list.ctype.bg is-alpha=true selected-alpha=list.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=list.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=subtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=subtitleSize class=form-control ng-model=list.settings.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=list.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rowBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.rowBg, opacity:list.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rowBg=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.rowBg selected-type=list.ctype.rowBg is-alpha=true selected-alpha=list.settings.rowBga ng-if=colorPicker.rowBg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.altBg, opacity:list.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altBg=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altBg selected-type=list.ctype.altBg is-alpha=true selected-alpha=list.settings.altBga ng-if=colorPicker.altBg></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.titleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.titleText=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.titleText selected-type=list.ctype.titleText ng-if=colorPicker.titleText></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altTitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altTitleText=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altTitleText selected-type=list.ctype.altTitleText ng-if=colorPicker.altTitleText></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.subtitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.subtitleText=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.subtitleText selected-type=list.ctype.subtitleText ng-if=colorPicker.subtitleText></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.17.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altSubtitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altSubtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altSubtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altSubtitleText=true\" readonly aria-label=\"{{\'cl.widget.cm.17.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altSubtitleText selected-type=list.ctype.altSubtitleText ng-if=colorPicker.altSubtitleText></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.descText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.descText=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.descText selected-type=list.ctype.descText ng-if=colorPicker.descText></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altDescText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altDescText=true\" readonly aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altDescText selected-type=list.ctype.altDescText ng-if=colorPicker.altDescText></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=list.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-3><label for=altRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altRowFont class=form-control ng-model=list.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div><div ng-if=\"sch.dType == \'m\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':media.settings.bg, opacity:media.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"media.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{media.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=media.settings.bg selected-type=media.ctype.bg is-alpha=true selected-alpha=media.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=media.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=media.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"media.settings.rotationOpt == \'c\'\"><input type=number id=mRotate class=form-control ng-model=media.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=sch.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=sch.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=schFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'channel\'\" aria-live=polite role=status>{{\'cl.widget.sch.m1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'sSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/stockPrice.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.sp.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.sp.2\' | translate}} &nbsp; <span ng-if=stockPrice.label>[ {{stockPrice.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=\"msg-warning marB10 hide\" lang={{auth.lang}} translate=\"{{\'cl.widget.sp.m1\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></div><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=stockPrice.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"marR10 noMarB\"><input type=radio role=radio name=typeOpt value=s ng-model=stockPrice.type ng-change=\"typeChange(\'s\')\"><label></label>{{\'cl.widget.sp.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt value=m ng-model=stockPrice.type ng-change=\"typeChange(\'m\')\"><label></label>{{\'cl.widget.sp.4\' | translate}}</label></div></div><div class=form-group><label for=countryList>{{\'cl.widget.sp.10\' | translate}}</label><select id=countryList class=form-control ng-model=stockPrice.stockExc ng-change=\"getListFx(\'symE\')\" ng-options=\"option.nl for option in stockExcList | orderBy:\'nl\' track by option.ns\" aria-label=\"{{\'cl.widget.sp.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.10\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.sp.10.1\' | translate}}</option></select></div><div class=form-group ng-if=\"stockPrice.type == \'s\' && stockPrice.stockExc\"><label>{{\'cl.widget.sp.11\' | translate}}</label><div class=form-group ng-if=stockSymLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick ng-if=!stockSymLoading><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle id=symbol ng-click=\"searchList=\'\'\"><span ng-if=!curStock.sym>{{\'cl.widget.sp.11.1\' | translate}}</span> <span ng-if=curStock.sym>{{curStock.sym.name}}<span class=\"text-muted text-sm inline\"> - ({{curStock.sym.sym}})</span></span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"sym in filteredSList = (stockSymList | filter:searchList) | orderBy: \'name\'\" tabindex=$index><label><input type=radio role=radio name=symOpt value=\"{{ {id:sym.id, name:sym.name, sym:sym.sym} }}\" ng-checked=\"sym.id == curStock.sym.id\" ng-model=curStock.sym ng-change=singleSymFx() ng-disabled=\"sym.id == curStock.sym.id\"><label></label>{{sym.name}}<span class=\"text-muted text-sm inline\"> - ({{sym.sym}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div ng-if=\"stockPrice.type == \'s\'\"><div><label>{{\'cl.widget.cm.7\' | translate}}</label></div><label class=\"text-unbold marR20\"><div class=\"text-ellipsis trBg\"><div class=pad20 style=background-color:{{rgbaS1.bg}}><div class=text-bold style=\"font-size: 20px;color:{{settingsS1.settings.s}};font-family:{{settingsS1.settings.sFont.value}}\">LI</div><div style=\"padding: 4px 0;font-size:20px;color:{{settingsS1.settings.n}};font-family:{{settingsS1.settings.nFont.value}}\">Lorem Ipsum</div><div><span style=font-size:52px;color:{{settingsS1.settings.p}};font-family:{{settingsS1.settings.pFont.value}}>45.47</span> <span style=\"float: right;font-size: 20px;margin-top: 32px;color:{{settingsS1.settings.cp}};font-family:{{settingsS1.settings.cpnFont.value}}\"><i class=\"fa fa-arrow-up marR5\" aria-hidden=true></i>0.01</span></div></div></div><div class=marT5><label class=marR10><input type=radio name=tempOpt value=t1 ng-model=stockPrice.template><label></label>{{\'cl.widget.sp.42\' | translate}}</label></div></label><label class=text-unbold><div class=\"text-ellipsis trBg\"><div class=pad20 style=background-color:{{rgbaS2.bg}}><div><span style=\"font-size: 20px;color:{{settingsS2.settings.s}};font-family:{{settingsS2.settings.sFont.value}}\">LI</span> <span class=marT5 style=\"float: right;color:{{settingsS2.settings.cn}};font-family:{{settingsS2.settings.cpnFont.value}}\">-0.60</span></div><div class=text-center style=font-size:52px;color:{{settingsS2.settings.p}};font-family:{{settingsS2.settings.pFont.value}}>34.78</div><div><span style=color:{{settingsS2.settings.hp}};font-family:{{settingsS2.settings.hpFont.value}}><span ng-if=\"settingsS2.settings.lang === \'en_US\'\">High</span> <span ng-if=\"settingsS2.settings.lang === \'fr_FR\'\">Haute</span> <span ng-if=\"settingsS2.settings.lang === \'es_ES\'\">Alto</span> </span><span class=marR5>&nbsp;&nbsp;</span> <span style=\"float: right;color:{{settingsS2.settings.hpv}};font-family:{{settingsS2.settings.hpFont.value}}\">35.30</span></div><div><span style=color:{{settingsS2.settings.lp}};font-family:{{settingsS2.settings.lpFont.value}}><span ng-if=\"settingsS2.settings.lang === \'en_US\'\">Low</span> <span ng-if=\"settingsS2.settings.lang === \'fr_FR\'\">Bas</span> <span ng-if=\"settingsS2.settings.lang === \'es_ES\'\">Bajo</span> </span><span class=marR5>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> <span style=\"float: right;color:{{settingsS2.settings.lpv}};font-family:{{settingsS2.settings.lpFont.value}}\">34.70</span></div></div></div><div class=marT5><label class=marR10><input type=radio name=tempOpt value=t2 ng-model=stockPrice.template><label></label>{{\'cl.widget.sp.43\' | translate}}</label></div></label></div><div class=form-group ng-if=\"stockPrice.type == \'m\' && stockPrice.stockExc\"><label>{{\'cl.widget.sp.11\' | translate}}</label><div class=form-group ng-if=stockSymLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick ng-if=!stockSymLoading><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\">{{symSelected = (stockSymList | filter:{selected:true}); \"\"}} <span ng-if=!symSelected.length>{{\'cl.widget.sp.11.1\' | translate}}</span> <span ng-repeat=\"sym in symSelected\">{{sym.name}}<span class=\"text-muted text-sm inline\"> - ({{sym.sym}})</span><span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"sym in filteredSList = (stockSymList | filter:searchList) | orderBy: \'name\'\" tabindex=$index><label><input type=checkbox ng-model=sym.selected role=checkbox><label></label>{{sym.name}}<span class=\"text-muted text-sm inline\"> - ({{sym.sym}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div ng-if=\"stockPrice.type == \'m\'\"><div><label>{{\'cl.widget.cm.7\' | translate}}</label></div><label class=text-unbold><div class=\"text-ellipsis trBg\"><div class=pad10 ng-style=\"{\'background-color\':rgbaMC.bg}\"><div ng-style=\"{\'color\':settingsMC.settings.s, \'font-family\':settingsMC.settings.font.value}\"><span class=marR5 ng-style=\"{\'color\':settingsMC.settings.b}\">&#9724;</span><span class=text-bold ng-style=\"{\'color\':settingsMC.settings.s}\">MSFT:US</span> <span ng-style=\"{\'color\':settingsMC.settings.n}\">Microsoft Corp</span>, <span class=text-bold ng-style=\"{\'color\':settingsMC.settings.p}\">125.73</span>, <span class=text-bold ng-style=\"{\'color\':settingsMC.settings.cp}\">+0.79</span> <span class=\"marL10 marR5\" ng-style=\"{\'color\':settingsMC.settings.b}\">&#9724;</span><span class=text-bold ng-style=\"{\'color\':settingsMC.settings.s}\">CAJ:US</span> <span ng-style=\"{\'color\':settingsMC.settings.n}\">Canon Inc</span>, <span class=text-bold ng-style=\"{\'color\':settingsMC.settings.p}\">14.35</span>, <span class=text-bold ng-style=\"{\'color\':settingsMC.settings.cn}\">-0.06</span></div></div></div><div class=marT5><label class=marR10><input type=radio role=radio name=tempOpt value=t1 ng-model=stockPrice.template><label></label>{{\'cl.widget.cm.23\' | translate}}</label></div></label><div class=form-group><label class=noMarB><table class=\"table table-bordered trBg\"><thead><tr ng-style=\"{\'background-color\':rgbaML.hb, \'font-family\':settingsML.settings.hf.value}\"><th style=width:40% ng-style=\"{\'color\':settingsML.settings.ht}\">NAME</th><th style=width:20% ng-style=\"{\'color\':settingsML.settings.ht}\">VALUE</th><th style=width:20% ng-style=\"{\'color\':settingsML.settings.ht}\">NET CHANGE</th><th style=width:20% ng-style=\"{\'color\':settingsML.settings.ht}\">% CHANGE</th></tr></thead><tbody ng-style=\"{\'font-family\':settingsML.settings.rf.value}\"><tr ng-style=\"{\'background-color\':rgbaML.rb}\"><td ng-style=\"{\'color\':settingsML.settings.n}\"><div ng-style=\"{\'color\':settingsML.settings.s}\">MSFT:US</div>Microsoft Corp</td><td ng-style=\"{\'color\':settingsML.settings.p}\">125.73</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.79</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.63%</td></tr><tr ng-style=\"{\'background-color\':rgbaML.ab}\"><td ng-style=\"{\'color\':settingsML.settings.n}\"><div ng-style=\"{\'color\':settingsML.settings.s}\">CAJ:US</div>Canon Inc</td><td ng-style=\"{\'color\':settingsML.settings.p}\">28.14</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.13</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.46%</td></tr><tr ng-style=\"{\'background-color\':rgbaML.rb}\"><td ng-style=\"{\'color\':settingsML.settings.n}\"><div ng-style=\"{\'color\':settingsML.settings.s}\">LNVGY:US</div>Lenovo Group Ltd</td><td ng-style=\"{\'color\':settingsML.settings.p}\">14.35</td><td ng-style=\"{\'color\':settingsML.settings.cn}\">-0.06</td><td ng-style=\"{\'color\':settingsML.settings.cn}\">-0.42%</td></tr><tr ng-style=\"{\'background-color\':rgbaML.ab}\"><td ng-style=\"{\'color\':settingsML.settings.n}\"><div ng-style=\"{\'color\':settingsML.settings.s}\">DELL:US</div>Dell Techno.Inc</td><td ng-style=\"{\'color\':settingsML.settings.p}\">66.41</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.21</td><td ng-style=\"{\'color\':settingsML.settings.cp}\">+0.32%</td></tr></tbody></table><div class=marT5><input type=radio role=radio name=tempOpt value=t2 ng-model=stockPrice.template><label></label>{{\'cm.tool.6\' | translate}}</div></label></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"stockPrice.type == \'s\' && stockPrice.template == \'t1\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsS1.settings.bg, opacity:settingsS1.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsS1.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.bg selected-type=settingsS1.ctype.bg selected-rgba=rgbaS1.bg is-alpha=true selected-alpha=settingsS1.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><!-- Symbol --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.sp.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.s><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS1.settings.s}\"></span></span> <input aria-label=symbol type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.s | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.s=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.s selected-type=settingsS1.ctype.s ng-if=colorPicker.s></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.20\' | translate}}</label><input type=number class=form-control ng-model=settingsS1.settings.sSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.sp.21\' | translate}}</label><select class=form-control ng-model=settingsS1.settings.sFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Name --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.brief.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.n><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS1.settings.n}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.n | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.n=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.n selected-type=settingsS1.ctype.n ng-if=colorPicker.n></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.22\' | translate}}</label><input type=number class=form-control ng-model=settingsS1.settings.nSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.sp.23\' | translate}}</label><select class=form-control ng-model=settingsS1.settings.nFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Price --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.sp.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.p><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS1.settings.p}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.p | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.p=true\" readonly aria-label=\"{{\'cl.widget.sp.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.p selected-type=settingsS1.ctype.p ng-if=colorPicker.p></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.24\' | translate}}</label><input type=number class=form-control ng-model=settingsS1.settings.pSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.sp.25\' | translate}}</label><select class=form-control ng-model=settingsS1.settings.pFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Country --><!-- <div class=\"row marT15\">\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.sp.10\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.e\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':settingsS1.settings.cp}\"></span></span>\r\n                    <input aria-label=\"cPositive\" type=\"text\" class=\"form-control picker\" ng-value=\"settingsS1.settings.cp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cp=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"settingsS1.settings.e\" selected-type=\"settingsS1.ctype.e\" ng-if=\"colorPicker.e\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.sp.38\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"settingsS1.settings.eSize\" min=\"1\">\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.sp.39\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"settingsS1.settings.eFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div>\r\n            </div> --><!-- Positive/Negative --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.sp.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS1.settings.cp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.cp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cp=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.cp selected-type=settingsS1.ctype.cp ng-if=colorPicker.cp></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS1.settings.cn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS1.settings.cn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly aria-label=\"{{\'cl.widget.sp.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS1.settings.cn selected-type=settingsS1.ctype.cn ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.40\' | translate}}</label><input type=number class=form-control ng-model=settingsS1.settings.cpnSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.sp.41\' | translate}}</label><select class=form-control ng-model=settingsS1.settings.cpnFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div ng-if=\"stockPrice.type == \'s\' && stockPrice.template == \'t2\'\"><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsS2.settings.bg, opacity:settingsS2.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cl.widget.sp.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.10\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsS2.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.bg selected-type=settingsS2.ctype.bg is-alpha=true selected-alpha=settingsS2.settings.bga selected-rgba=rgbaS2.bg ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.sp.46\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.lang ng-change=\"formatFx(\'n\');\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=es_ES>Spanish / Spain</option></select></div></div></div><!-- Symbol --><div class=row><div class=col-xs-3><label>{{\'cl.widget.sp.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.s><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.s}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.s | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.s=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.s selected-type=settingsS2.ctype.s ng-if=colorPicker.s></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.20\' | translate}}</label><input type=number class=form-control ng-model=settingsS2.settings.sSize min=1></div><div class=col-xs-3><label>{{\'cl.widget.sp.21\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.sFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Name --><!-- <div class=\"row marT15\">\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cm.brief.1\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.n\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':settingsS2.settings.n}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"settingsS2.settings.n | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.n=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"settingsS2.settings.n\" selected-type=\"settingsS2.ctype.n\" ng-if=\"colorPicker.n\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.22\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"settingsS2.settings.nSize\" min=\"1\">\r\n              </div>\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.23\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"settingsS2.settings.nFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div>\r\n            </div> --><!-- Price --><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.sp.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.p><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.p}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.p | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.p=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.p selected-type=settingsS2.ctype.p ng-if=colorPicker.p></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.24\' | translate}}</label><input type=number class=form-control ng-model=settingsS2.settings.pSize min=1></div><div class=col-xs-3><label>{{\'cl.widget.sp.25\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.pFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- High Price --><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.sp.26\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.hp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.hp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hp=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.hp selected-type=settingsS2.ctype.hp ng-if=colorPicker.hp></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.32\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hpv><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.hpv}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.hpv | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hpv=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.hpv selected-type=settingsS2.ctype.hpv ng-if=colorPicker.hpv></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.27\' | translate}}</label><input type=number class=form-control ng-model=settingsS2.settings.hpSize min=1></div><div class=col-xs-3><label>{{\'cl.widget.sp.28\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.hpFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Hoght Price value --><!-- <div class=\"row marT15\"> --><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.33\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"settingsS2.settings.hpvSize\" min=\"1\">\r\n              </div> --><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.34\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"settingsS2.settings.hpvFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div> --><!-- </div> --><!-- Low Price --><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.sp.29\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.lp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.lp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lp=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.lp selected-type=settingsS2.ctype.lp ng-if=colorPicker.lp></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.35\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.lpv><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.lpv}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.lpv | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.lpv=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.lpv selected-type=settingsS2.ctype.lpv ng-if=colorPicker.lpv></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.30\' | translate}}</label><input type=number class=form-control ng-model=settingsS2.settings.lpSize min=1></div><div class=col-xs-3><label>{{\'cl.widget.sp.31\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.lpFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><!-- Low Price value --><!-- <div class=\"row marT15\"> --><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.36\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"settingsS2.settings.lpvSize\" min=\"1\">\r\n              </div> --><!-- <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.37\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"settingsS2.settings.lpvFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div> --><!-- </div> --><!-- Country --><!-- <div class=\"row marT15\">\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.10\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.e\">\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':settingsS2.settings.e}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"settingsS2.settings.e | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.e=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"settingsS2.settings.e\" selected-type=\"settingsS2.ctype.e\" ng-if=\"colorPicker.e\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.38\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"settingsS2.settings.eSize\" min=\"1\">\r\n              </div>\r\n              <div class=\"col-xs-3\">\r\n                <label>{{\'cl.widget.sp.39\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"settingsS2.settings.eFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div>\r\n            </div> --><!-- Positive/Negative --><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.sp.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.cp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.cp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cp=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.cp selected-type=settingsS2.ctype.cp ng-if=colorPicker.cp></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsS2.settings.cn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsS2.settings.cn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsS2.settings.cn selected-type=settingsS2.ctype.cn ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.40\' | translate}}</label><input type=number class=form-control ng-model=settingsS2.settings.cpnSize min=1></div><div class=col-xs-3><label>{{\'cl.widget.sp.41\' | translate}}</label><select class=form-control ng-model=settingsS2.settings.cpnFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div ng-if=\"stockPrice.type == \'m\' && stockPrice.template == \'t1\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsMC.settings.bg, opacity:settingsMC.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsMC.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.bg selected-type=settingsMC.ctype.bg is-alpha=true selected-alpha=settingsMC.settings.bga selected-rgba=rgbaMC.bg ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.s><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.s}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.s | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.s=true\" readonly aria-label=\"{{\'cl.widget.sp.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.s selected-type=settingsMC.ctype.s ng-if=colorPicker.s></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cm.brief.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.n><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.n}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.n | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.n=true\" readonly aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.n selected-type=settingsMC.ctype.n ng-if=colorPicker.n></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.sp.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.p><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.p}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.p | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.p=true\" readonly aria-label=\"{{\'cl.widget.sp.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.p selected-type=settingsMC.ctype.p ng-if=colorPicker.p></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.cp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.cp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cp=true\" readonly aria-label=\"{{\'cl.widget.sp.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.cp selected-type=settingsMC.ctype.cp ng-if=colorPicker.cp></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sp.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.cn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.cn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly aria-label=\"{{\'cl.widget.sp.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.cn selected-type=settingsMC.ctype.cn ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsMC.settings.b}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsMC.settings.b | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsMC.settings.b selected-type=settingsMC.ctype.b ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 class=\"row marT15\"><label for=mcSpeed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=mcSpeed class=form-control ng-model=settingsMC.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4 class=\"row marT15\"><label for=mcFont>{{\'cm.label.24\' | translate}}</label><select id=mcFont class=form-control ng-model=settingsMC.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=settingsMC.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label for=fontSize><input type=radio role=radio name=fsOpt ng-model=settingsMC.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"settingsMC.settings.fontSizeOpt == \'c\'\"><input type=number id=mcFontSize class=form-control ng-model=settingsMC.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div><div ng-if=\"stockPrice.type == \'m\' && stockPrice.template == \'t2\'\"><div class=row><div class=\"col-xs-12 form-group\"><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsML.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsML.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsML.settings.rotationOpt == \'c\'\"><input type=number id=rotate class=form-control ng-model=settingsML.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cl.widget.sp.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.s><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.s}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.s | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.s=true\" readonly aria-label=\"{{\'cl.widget.sp.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.s selected-type=settingsML.ctype.s ng-if=colorPicker.s></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cm.brief.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.n><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.n}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.n | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.n=true\" readonly aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.n selected-type=settingsML.ctype.n ng-if=colorPicker.n></ng-hub-color-picker></div></div></div><div class=col-xs-6></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.sp.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.p><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.p}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.p | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.p=true\" readonly aria-label=\"{{\'cl.widget.sp.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.p selected-type=settingsML.ctype.p ng-if=colorPicker.p></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cp><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.cp}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.cp | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cp=true\" readonly aria-label=\"{{\'cl.widget.sp.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.cp selected-type=settingsML.ctype.cp ng-if=colorPicker.cp></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.sp.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cn><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.cn}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.cn | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cn=true\" readonly aria-label=\"{{\'cl.widget.sp.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.15\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.cn selected-type=settingsML.ctype.cn ng-if=colorPicker.cn></ng-hub-color-picker></div></div></div><div class=col-xs-3></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=settingsML.settings.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"row marT15\" ng-if=settingsML.settings.header.active><div class=col-xs-3><label for=headerName>{{\'cl.widget.sp.16\' | translate}}</label><input type=text id=headerName class=\"form-control input-sm\" ng-model=settingsML.settings.header.column1 aria-label=\"{{\'cl.widget.sp.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.16\' | translate}}\"></div><div class=col-xs-3><label for=headerValue>{{\'cl.widget.sp.17\' | translate}}</label><input type=text id=headerValue class=\"form-control input-sm\" ng-model=settingsML.settings.header.column2 aria-label=\"{{\'cl.widget.sp.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.17\' | translate}}\"></div><div class=col-xs-3><label for=netChange>{{\'cl.widget.sp.18\' | translate}}</label><input type=text id=netChange class=\"form-control input-sm\" ng-model=settingsML.settings.header.column3 aria-label=\"{{\'cl.widget.sp.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.18\' | translate}}\"></div><div class=col-xs-3><label for=change>{{\'cl.widget.sp.19\' | translate}}</label><input type=text id=change class=\"form-control input-sm\" ng-model=settingsML.settings.header.column4 aria-label=\"{{\'cl.widget.sp.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.sp.19\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=settingsML.settings.header.active><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsML.settings.hb, opacity:settingsML.settings.hba}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.hb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsML.settings.hba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.hb selected-type=settingsML.ctype.hb is-alpha=true selected-alpha=settingsML.settings.hba selected-rgba=rgbaML.hb ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsML.settings.ht}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.ht | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.ht selected-type=settingsML.ctype.ht ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=settingsML.settings.hf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=settingsML.settings.hs min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsML.settings.rb, opacity:settingsML.settings.rba}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.rb | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsML.settings.rba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.rb selected-type=settingsML.ctype.rb is-alpha=true selected-alpha=settingsML.settings.rba selected-rgba=rgbaML.rb ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsML.settings.ab, opacity:settingsML.settings.aba}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsML.settings.ab | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsML.settings.aba}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsML.settings.ab selected-type=settingsML.ctype.ab is-alpha=true selected-alpha=settingsML.settings.aba selected-rgba=rgbaML.ab ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=rowFont class=form-control ng-model=settingsML.settings.rf ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.39\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.39\' | translate}}\"></select></div><div class=col-xs-3><label for=rowSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rowSize class=form-control ng-model=settingsML.settings.rs min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=stockPrice.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=stockPrice.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=stockFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'symbol\'\" aria-live=polite role=status>{{\'cl.widget.sp.m4\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'exchange\'\" aria-live=polite role=status>{{\'cl.widget.sp.m3\' | translate}}</div><div ng-if=\"errType==\'sSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m5\' | translate}}</div><div ng-if=\"errType==\'nSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m6\' | translate}}</div><div ng-if=\"errType==\'pSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m7\' | translate}}</div><div ng-if=\"errType==\'eSize\'\" aria-live=polite role=status>Please provide country size</div><div ng-if=\"errType==\'cpnSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m8\' | translate}}</div><div ng-if=\"errType==\'hpSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m9\' | translate}}</div><div ng-if=\"errType==\'lpSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m10\' | translate}}</div><div ng-if=\"errType==\'hpvSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m11\' | translate}}</div><div ng-if=\"errType==\'lpvSize\'\" aria-live=polite role=status>{{\'cl.widget.sp.m12\' | translate}}</div><div ng-if=\"errType==\'fSize\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/storm.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\" role=heading><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.storm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.storm.2\' | translate}} &nbsp; <span ng-if=storm.label>[ {{storm.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=storm.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div ng-if=isCred><div class=form-group><label for=uName>{{\'cl.widget.storm.5\' | translate}}</label><input type=text id=uName class=form-control ng-model=storm.u aria-label=\"{{\'cl.widget.storm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.storm.4\' | translate}}\"></div><div class=form-group><label for=pass>{{\'cl.widget.telax.9.3\' | translate}}</label><input type=password id=pass class=form-control ng-model=storm.p aria-label=\"{{\'cl.widget.telax.9.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.9.3\' | translate}}\"></div><div class=form-group><label for=cPass>{{\'cl.widget.telax.9.4\' | translate}}</label><input type=password id=cPass class=form-control ng-model=storm.cp aria-label=\"{{\'cl.widget.telax.9.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.9.4\' | translate}}\"></div></div><div class=form-group ng-if=!isCred><label>{{\'cl.widget.storm.4\' | translate}}</label><div><button type=reset role=button class=\"btn btn-primary btn-xs\" ng-click=resetFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button></div></div><div class=form-group><label for=did>{{\'cl.widget.storm.6\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=did class=form-control ng-model=storm.did maxlength=1000 aria-label=\"{{\'cl.widget.storm.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.storm.6\' | translate}}\"></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.storm.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=storm.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=storm.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"storm.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=storm.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.storm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.storm.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':storm.settings.bg, opacity:storm.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"storm.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{storm.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=storm.settings.bg selected-type=storm.settings.ctype.bg is-alpha=true selected-alpha=storm.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=storm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=storm.activePeriod></ng-active-period></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=stormFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.storm.m1\' | translate}}</div><div ng-if=\"errType==\'reloadEmpty\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><span ng-if=\"errType==\'uName\'\" aria-live=polite role=status>{{\'cl.widget.storm.m4\' | translate}}</span> <span ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'cl.widget.jci.m3\' | translate | lowercase}}</span> <span ng-if=\"errType==\'cPass\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m14\' | translate}}</span> <span ng-if=\"errType==\'match\'\" aria-live=polite role=status>{{\'cl.widget.storm.m5\' | translate}}</span></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/survey.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" class=sidebar-toggle role=link ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.survey.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.survey.2\' | translate}} &nbsp; <span ng-if=survey.info.label>[ {{survey.info.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=tabFx(1);><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=surveyFx(2);><span class=badge>2</span>{{\'cl.widget.survey.3s\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\" ng-if=\"encId && survey.info.locked==1\"><a href=\"\" role=link ng-click=surveyFx(3);><span class=badge>3</span>{{\'cl.widget.survey.12\' | translate}}</a></li><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=exportFx(0); ng-if=\"selectedT==\'3\' && results.length > 0\" uib-tooltip=\"{{\'r.btn.4\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-download noMarR\" aria-hidden=true></span></button></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label ng-if=\"survey.info.statusType!=1\" class=form-control ng-model=survey.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"><div ng-if=\"survey.info.statusType==1\">{{survey.info.label}}</div></div><div class=form-group><label for=title ng-if=\"survey.info.statusType!=1 || (survey.info.statusType==1 && survey.info.settings.title !=null)\">{{\'cm.label.23\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=title ng-if=\"survey.info.statusType!=1 && survey.info.locked!=1\" class=form-control ng-model=survey.info.settings.title maxlength={{inputLimit}} aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"><div ng-if=\"(survey.info.statusType!=1 && survey.info.settings.title !=null && survey.info.locked==1) || (survey.info.statusType==1 && survey.info.settings.title !=null && survey.info.locked!=1)\">{{survey.info.settings.title}}</div></div><div class=form-group><label for=desc ng-if=\"survey.info.statusType!=1 || (survey.info.statusType==1 && survey.info.settings.desc !=null)\">{{\'cm.label.85\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><textarea id=desc ng-if=\"survey.info.statusType!=1 && survey.info.locked!=1\" class=\"form-control txtAreaBig\" ng-model=survey.info.settings.desc maxlength={{descriptionLimit}} aria-label=\"{{\'cm.label.85\' | translate}}\" aria-labelledby=\"{{\'cm.label.85\' | translate}}\"></textarea><span ng-if=\"survey.info.statusType!=1 && survey.info.locked!=1\" class=\"text-muted text-sm\">[ {{descriptionLimit - survey.info.settings.desc.length}} ]</span><div ng-if=\"(survey.info.statusType!=1 && survey.info.settings.desc !=null && survey.info.locked==1) || (survey.info.statusType==1 && survey.info.settings.desc !=null && survey.info.locked!=1)\">{{survey.info.settings.desc}}</div></div><div class=form-group><label ng-if=\"survey.info.statusType!=1 && survey.info.locked!=1\" class=noMarB><input type=checkbox ng-model=survey.info.showResult ng-true-value=1 ng-false-value=0 role=checkbox><label></label>{{\'cl.widget.survey.26\' | translate}}</label></div></div><div class=col-xs-5 ng-if=decId><div class=form-group><label>{{\'cl.widget.survey.11\' | translate}}</label><div class=\"word-break marB5\"><a href={{survey.info.url}} role=link target=_blank>{{survey.info.url}}</a> <a href=\"\" role=link class=\"btn-link btn-xs\" ngclipboard data-clipboard-text={{survey.info.url}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-files-o\" aria-hidden=true></span></a></div><img alt=\"\" ng-src=\"{{survey.info.timthumb + survey.info.bucket +\'widgets/survey/\'+ decId +\'.png&h=200&q=100&zc=3\'}}\" src-error=assets/images/default/na.png class=\"img-responsive bdr\"></div></div><div class=col-xs-9><div class=form-group ng-if=\"survey.info.statusType!=1\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"panel-inner-tab marB10\">{{\'cl.widget.survey.15\' | translate}}</div><div class=form-group><label>{{\'cm.label.87\' | translate}}</label><div class=row><div class=col-xs-4><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':survey.info.settings.info.bg, opacity:survey.info.settings.info.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.info.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{survey.info.settings.info.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.info.bg selected-type=survey.info.ctype.info.bg is-alpha=true selected-alpha=survey.info.settings.info.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.info.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.info.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.info.titleText selected-type=survey.info.ctype.info.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=titleSize class=form-control ng-model=survey.info.settings.info.titleSize min=1 max=125 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control id=titleFont ng-model=survey.info.settings.info.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.survey.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.info.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.info.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.survey.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.10\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.info.descText selected-type=survey.info.ctype.info.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=descSize>{{\'cl.widget.cm.42\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.43\' | translate}} 125)</span></label><input type=number id=descSize class=form-control ng-model=survey.info.settings.info.descSize min=1 max=125 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div><div class=col-xs-4><label for=descFont>{{\'cl.widget.survey.8\' | translate}}</label><select class=form-control id=descFont ng-model=survey.info.settings.info.descFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.8\' | translate}}\"></select></div></div><div class=\"panel-inner-tab marT15 marB10\">{{\'cl.widget.survey.16\' | translate}}</div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':survey.info.settings.result.bg, opacity:survey.info.settings.result.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{survey.info.settings.result.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.bg selected-type=survey.info.ctype.result.bg is-alpha=true selected-alpha=survey.info.settings.result.bga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.oc.20\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':survey.info.settings.result.altBg, opacity:survey.info.settings.result.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rab=true\" readonly aria-label=\"{{\'cl.widget.oc.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.20\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{survey.info.settings.result.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.altBg selected-type=survey.info.ctype.result.altBg is-alpha=true selected-alpha=survey.info.settings.result.altBga ng-if=colorPicker.rab></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.survey.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.qc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.result.qColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.qColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.qc=true\" readonly aria-label=\"{{\'cl.widget.survey.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.qColor selected-type=survey.info.ctype.result.qColor ng-if=colorPicker.qc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=resultQSize>{{\'cl.widget.survey.18\' | translate}}</label><input type=number id=resultQSize class=form-control ng-model=survey.info.settings.result.qSize min=1 aria-label=\"{{\'cl.widget.survey.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.18\' | translate}}\"></div><div class=col-xs-4><label for=srqFont>{{\'cl.widget.survey.19\' | translate}}</label><select class=form-control id=srqFont ng-model=survey.info.settings.result.qFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.19\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.survey.20\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ac><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.result.aColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.aColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ac=true\" readonly aria-label=\"{{\'cl.widget.survey.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.20\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.aColor selected-type=survey.info.ctype.result.aColor ng-if=colorPicker.ac></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=resultASize>{{\'cl.widget.survey.21\' | translate}}</label><input type=number id=resultASize class=form-control ng-model=survey.info.settings.result.aSize min=1 aria-label=\"{{\'cl.widget.survey.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.21\' | translate}}\"></div><div class=col-xs-4><label for=sraFont>{{\'cl.widget.survey.22\' | translate}}</label><select id=sraFont class=form-control ng-model=survey.info.settings.result.aFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.survey.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.22\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.survey.23\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':survey.info.settings.result.pBarBg, opacity:survey.info.settings.result.pBarBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.pBarBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pb=true\" readonly aria-label=\"{{\'cl.widget.survey.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.23\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{survey.info.settings.result.pBarBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.pBarBg selected-type=survey.info.ctype.result.pBarBg is-alpha=true selected-alpha=survey.info.settings.result.pBarBga ng-if=colorPicker.pb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.survey.24\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.p><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.result.pBg}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.pBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.p=true\" readonly aria-label=\"{{\'cl.widget.survey.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.24\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.pBg selected-type=survey.info.ctype.result.pBg ng-if=colorPicker.p></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.survey.25\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':survey.info.settings.result.pColor}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"survey.info.settings.result.pColor | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pc=true\" readonly aria-label=\"{{\'cl.widget.survey.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.survey.25\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=survey.info.settings.result.pColor selected-type=survey.info.ctype.result.pColor ng-if=colorPicker.pc></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=survey.permission pid=decId module=\"\'content\'\" is-disabled=\"survey.info.statusType==1\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=survey.activePeriod is-disabled=\"survey.info.statusType==1\"></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-12><div ng-if=\"survey.info.statusType!=1\"><div ng-if=\"survey.info.locked!=1\" class=form-group><label>{{\'cl.widget.survey.27\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=qTypeOpt ng-model=addQuestion.selType ng-value=0 ng-change=queTypeFx(0)><label></label>{{\'cl.widget.survey.28\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=qTypeOpt ng-model=addQuestion.selType ng-value=1 ng-change=queTypeFx(1)><label></label>{{\'cl.widget.survey.29\' | translate}}</label><label class=noMarB><input type=radio role=radio name=qTypeOpt ng-model=addQuestion.selType ng-value=2 ng-change=queTypeFx(2)><label></label>{{\'cl.widget.survey.30\' | translate}}</label></div></div><div ng-if=\"survey.info.locked!=1\" class=\"row bg-light pad10\"><div class=col-xs-12><div class=form-group><label for=question>{{\'cl.widget.survey.3\' | translate}}</label><textarea type=text id=question class=form-control focus-me=true ng-model=addQuestion.question maxlength={{descriptionLimit}}></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - addQuestion.question.length}} ]</span></div><div class=row ng-if=!isQDesc><div class=col-xs-12><div class=bdr-btm-dashed><div class=\"col-xs-7 noPadL\"><label>{{\'Options\' | translate}}</label></div><div class=\"col-xs-5 noPadR text-right\" ng-if=!isQDesc><button type=button role=button ng-click=addMoreOptFx($index); class=\"btn btn-primary btn-xs\" id=addOther><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.label.91\' | translate}}</button></div><div class=clearfix></div></div></div></div><div class=row ng-if=!isQDesc><div class=other><div ng-repeat=\"option in optArr\"><div class=col-xs-6><div class=form-group><label>{{option.label}}</label><div class=\"input-group w100\"><input type=text id=opt-{{$index}} class=form-control ng-model=option.opt maxlength={{inputLimit}} aria-label={{option.label}} aria-labelledby={{option.label}}> <a href=\"\" role=link ng-if=\"optArr.length > 1\" class=\"input-group-addon delOptBtn\" ng-click=delOpt($index); uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-popup-delay=1000><span class=\"text-danger fa fa-times\" aria-hidden=true></span></a></div></div></div></div></div></div><div class=form-group><button type=button role=button ng-if=!editQForm.isEdit class=\"btn btn-success btn-sm\" ng-click=addQuestionFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button> <button type=button role=button ng-if=editQForm.isEdit class=\"btn btn-success btn-sm\" ng-click=\"addQuestionFx(\'e\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> <button type=reset role=button ng-if=!editQForm.isEdit class=\"btn btn-default btn-sm\" ng-click=resetQuestionFx();>{{\'cm.btn.34\' | translate}}</button> <button type=reset role=button ng-if=editQForm.isEdit class=btn-link ng-click=\"editQForm.isEdit = false; resetQuestionFx();\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr aria-live=polite role=status><div ng-if=\"errType==\'question\'\" aria-live=polite role=status>{{\'cl.widget.survey.m1\' | translate}}</div><div ng-if=\"errType==\'opt\'\" aria-live=polite role=status>{{\'cl.widget.survey.m2\' | translate}}</div><div ng-if=\"errType==\'maxopt\'\" aria-live=polite role=status>{{\'cl.widget.survey.m12\' | translate}}</div></div></div></div></div><div class=spaceH2></div><div ng-if=\"survey.questionList.length > 0 && survey.info.locked!=1\" class=bdr-top-dashed></div></div><div class=\"table table-scroll\" ng-if=\"survey.questionList.length > 0\"><div class=\"row th\"><div class=col-xs-2 ng-class=\"{\'col-xs-2\':survey.info.statusType==1}\">{{\'cl.widget.survey.3\' | translate}}</div><div class=col-xs-9><div class=w100 style=display:flex><div ng-repeat=\"n in columnArr\" ng-style=colWidthStyle>{{\'cl.widget.survey.4\' | translate }} {{n.label}}</div></div></div><div class=\"col-xs-1 text-right\" ng-if=\"survey.info.statusType!=1\"><span ng-if=\"survey.info.locked!=1\">{{\'cm.label.25\' | translate}}</span></div></div><div class=overflow-auto ng-style=\"survey.info.statusType!=1 && {\'max-height\':\'{{getAvailableHeight(survey.info.locked!=1 ? 400 : 0) * 0.45}}px\'}\"><ul ng-class=\"survey.info.locked!=1?\'layer-container sortable-containment\':\'\'\" sortable axis=\"\'y\'\" ng-if=\"survey.questionList.length > 0\" callback=sortCallback()><li class=row ng-class=\"survey.info.locked!=1?\'layer sortable-item\':\'\'\" ng-repeat=\"q in survey.questionList\" data-id={{q.id}}><div class=\"col-xs-2 word-break\" ng-class=\"{\'col-xs-2\':survey.info.statusType==1}\">{{q.question}}</div><div class=\"col-xs-9 word-break\"><div class=w100 style=display:flex><div ng-repeat=\"opt in q.opt\" ng-style=colWidthStyle>{{opt.opt}}</div></div></div><div class=\"col-xs-1 text-right\" ng-if=\"survey.info.statusType!=1\"><a href=\"\" role=link ng-if=\"survey.info.locked!=1\" class=\"text-primary marR5\" ng-click=editQFx(q);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"survey.info.locked!=1\" class=text-danger ng-click=questionOpen($index);><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"survey.questionList.length <= 0\">{{\'cl.widget.survey.m3\' | translate}}</div></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"col-xs-12 noPadR\"><div class=\"table table-striped\"><ul><div class=surveyQuad ng-repeat=\"rvg in results\"><div class=folder-heading><div class=\"col-xs-11 text-bold text-ellipsis\" ng-click=\"folderFx($event, rvg.id, curResultGrp.length);\"><a role=button><span class=\"replace-icon fa icon-close marR5\" ng-class=\"{\'icon-open text-primary\': $first}\"></span>{{rvg.label}}<span class=\"text-muted text-unbold text-sm\"><span class=\"fa fa-minus mar5\" aria-hidden=true></span>{{(rvg.startDate * 1000) | date:\"MMM d, y h:mm a\"}} <span ng-if=rvg.endDate>- {{(rvg.endDate * 1000) | date:\"MMM d, y h:mm a\"}}</span></span></a></div><div class=\"col-xs-1 noPadL text-right\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"refreshFx($event, rvg.id);\" ng-disabled=refreshLoading uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-if=$first><span class=\"fa fa-refresh noMarR\" ng-class=\"{\'fa-spin\':refreshLoading}\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=exportFx(rvg.id); uib-tooltip=\"{{\'r.btn.4\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-download noMarR\" aria-hidden=true></span></button></div></div>{{curResultGrp = (rvg.result | filter:{id:s.id}:s.id);\"\"}}<div class=\"folder-content hide\" ng-class=\"{\'show\': $first}\"><li class=row ng-repeat=\"r in curResultGrp\"><div class=panel-body><div class=padR10><div class=\"text-bold word-break marB5\">{{$index + 1 + \". \" + r.label}}</div><span ng-repeat=\"opt in r.options\"><div class=\"col-xs-6 word-break\" ng-if=\"opt.label != \'\'\"><div class=marB5><span class=\"text-bold pull-left marR5\">[{{opt.label}}]</span> <span>{{opt.opt}}</span></div><div class=progress><div class=progress-bar role=progressbar aria-valuenow={{opt.percent}} aria-valuemin=0 aria-valuemax=100 style=width:{{opt.percent}}%>{{opt.percent}}%</div></div></div><div class=clearfix ng-if=$odd></div></span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"curResultGrp.length == 0\">{{\'cl.widget.survey.m9\' | translate}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"results.length <= 0\">{{\'cl.widget.survey.m9\' | translate}}</div></ul></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\" ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=surveyFx(2);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.survey.3s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\' && encId && survey.info.locked==1\" ng-click=surveyFx(3);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.survey.12\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"surveyFx(\'save\');\" ng-if=\"(survey.info.statusType!=1 && encId) || (survey.info.statusType==0 && selectedT==\'2\')\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-if=\"survey.info.statusType!=1 && encId\" ng-click=\"statusOpen(\'f\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cl.widget.survey.13\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-if=\"survey.info.statusType==1 && encId\" ng-click=\"statusOpen(\'r\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cl.widget.survey.14\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'qSize\'\" aria-live=polite role=status>{{\'cl.widget.survey.m10\' | translate}}</div><div ng-if=\"errType==\'aSize\'\" aria-live=polite role=status>{{\'cl.widget.survey.m11\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/tableau.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 role=heading aria-level=1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list aria-label=\"{{\'cl.widget.tb.1\' | translate}}\" ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tb.1\' | translate}}</h1><h1 role=heading aria-level=1 ng-if=!tabView>{{\'cl.widget.tb.2\' | translate}} &nbsp; <span ng-if=tableau.info.label>[ {{tableau.info.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-8><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=tableau.info.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=\"form-group marT20\"><label for=sTab><input type=checkbox role=checkbox id=sTab ng-model=tableau.tableau.showTab aria-checked={{tableau.tableau.showTab?true:false}} aria-label=\"{{\'cl.widget.tb.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tb.6\' | translate}}\"><label></label>{{\'cl.widget.tb.6\' | translate}}</label><label for=sToolbar class=marL10><input type=checkbox role=checkbox id=sToolbar ng-model=tableau.tableau.showToolBar aria-checked={{tableau.tableau.showToolBar?true:false}} aria-label=\"{{\'cl.widget.gs.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.gs.4\' | translate}}\"><label></label>{{\'cl.widget.gs.4\' | translate}}</label></div><div class=form-group><label>{{\'cl.widget.pBI.24\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=wTypeOpt ng-model=tableau.info.wType value=ac ng-click=resetFx(); ng-disabled=\"encId != \'\'\" aria-checked={{tableau.info.wType?true:false}} aria-label=\"{{\'cl.widget.pBI.24.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.24.1\' | translate}}\"><label></label>{{\'cl.widget.pBI.24.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=wTypeOpt ng-model=tableau.info.wType value=epu ng-click=resetFx(); ng-disabled=\"encId != \'\'\" aria-checked={{tableau.info.wType?true:false}} aria-label=\"{{\'cl.widget.pBI.24.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.24.2\' | translate}}\"><label></label>{{\'cl.widget.pBI.24.2\' | translate}}</label></div></div><div class=form-group ng-if=\"tableau.info.wType == \'epu\'\"><label for=wData>{{\'cl.widget.iFrame.3\' | translate}} <span class=\"text-muted text-sm\">( {{\'cl.widget.iFrame.4\' | translate}}: &lt;iframe&gt; {{\'cm.label.42\' | translate}} &lt;embed&gt; )</span></label><textarea id=wData class=\"form-control txtAreaBig\" ng-model=tableau.info.frameData aria-label=\"{{\'cl.widget.iFrame.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.iFrame.3\' | translate}}\"></textarea></div><div ng-if=\"tableau.info.wType == \'ac\'\"><div class=form-group><label for=pro>{{\'cl.widget.tb.3\' | translate}}</label><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=proLoading><div class=\"dropdown customSelect customProject\" uib-dropdown auto-close=outsideClick ng-if=!proLoading><span id=project class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"itemSearchFocus(\'p\');\" aria-placeholder=\"{{\'cl.widget.tb.3.1\' | translate}}\">{{tableau.tableau.project.name}} <span ng-if=\"tableau.tableau.project== \'\'\">{{\'cl.widget.tb.3.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"projectList.projects.length > 1\"><li class=\"dropdown-header noMar\" ng-if=\"projectList.projects.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchItem.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchItem.name.length ng-click=\"searchItem.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"projectList.projects.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"pro in projects = (projectList.projects | filter:{name:searchItem.project}) | orderBy: \'name\'\" tabindex=$index><label ng-model=pro.selected ng-click=\"selectItem(pro,\'p\');\"><label></label>{{pro.name | capitalize}}</label></li><div class=msg-warning ng-if=\"projects.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchItem.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=form-group ng-if=\"tableau.tableau.project != \'\' && !proLoading\"><label for=wb>{{\'cl.widget.tb.4\' | translate}}</label><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=wbLoading><div class=\"dropdown customSelect customWB\" uib-dropdown auto-close=outsideClick ng-if=!wbLoading><span id=workbook class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"itemSearchFocus(\'w\');searchItem.name=\'\'\" aria-placeholder=\"{{\'cl.widget.tb.4.1\' | translate}}\">{{tableau.tableau.workbook.name}} <span ng-if=\"tableau.tableau.workbook== \'\'\">{{\'cl.widget.tb.4.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"wbList.workbooks.length > 1\"><li class=\"dropdown-header noMar\" ng-if=\"wbList.workbooks.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchItem.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchItem.name.length ng-click=\"searchItem.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"wbList.workbooks.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"wb in workbooks = (wbList.workbooks | customSearch:{key:searchItem.name, module:\'ch\', filterType:filter}) | orderBy: \'name\'\" tabindex=$index><label ng-model=wb.selected ng-click=\"selectItem(wb,\'w\');\"><label></label>{{wb.name | capitalize}}</label></li><div class=msg-warning ng-if=\"workbooks.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchItem.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=form-group ng-if=\"tableau.tableau.workbook != \'\' && !proLoading && !wbLoading\"><label for=wb>{{\'cl.widget.tb.5\' | translate}}</label><div class=form-group><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=viewLoading><div class=\"dropdown customSelect customView\" uib-dropdown auto-close=outsideClick ng-if=!viewLoading><span id=views class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"itemSearchFocus(\'v\');\" aria-placeholder=\"{{\'cl.widget.tb.5.1\' | translate}}\">{{tableau.tableau.view.name}} <span ng-if=\"tableau.tableau.view== \'\'\">{{\'cl.widget.tb.5.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=\"viewList.views.length > 1\"><li class=\"dropdown-header noMar\" ng-if=\"viewList.views.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchItem.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchItem.name.length ng-click=\"searchItem.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"viewList.views.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"view in filteredViewList = (viewList.views | customSearch:{key:searchItem.name, module:\'ch\', filterType:filter}) | orderBy: \'name\'\" tabindex=$index><label ng-model=view.selected ng-click=selectItem(view);><label></label>{{view.name | capitalize}}</label></li><div class=msg-warning ng-if=\"filteredViewList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchItem.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"form-group noMarB\"><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=tableau.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=tableau.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"tableau.settings.reloadOpt == \'c\'\"><input type=number id=reload class=form-control ng-model=tableau.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tableau.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tableau.activePeriod></ng-active-period></div></div></div><div class=col-xs-4></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><!-- <button type=\"button\" role=\"button\" class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=\"tabFx(1, \'tabFx\');\"><span class=\"fa fa-chevron-left\" aria-hidden=\"true\"></span>{{\'cm.btn.11\' | translate}}</button> --><!-- <button type=\"button\" role=\"button\" class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=\"tableauFx(1);\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=\"true\"></span></button> --> <button type=button role=button class=\"btn btn-success\" ng-click=\"tableauFx(\'save\');\" ng-disabled=\"saveProcessing || proLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'proId\'\">{{\'cl.widget.tb.m1\' | translate}}</div><div ng-if=\"errType == \'wbId\'\">{{\'cl.widget.tb.m2\' | translate}}</div><div ng-if=\"errType == \'viewId\'\">{{\'cl.widget.tb.m3\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType == \'data\'\">{{\'cl.widget.iFrame.m1\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'invInfo\'\">{{\'cl.widget.tb.m4\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/teamsChannel.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tChannel.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.tChannel.2\' | translate}} &nbsp; <span ng-if=channel.label>[ {{channel.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=channelFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=channel.labelOpt value=a><label></label>{{\'cl.widget.tChannel.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=channel.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"channel.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=channel.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=\"form-group hide\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=channel.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.sc.11\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=channel.dType value=l><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=channel.dType value=m><label></label>{{\'cl.widget.sc.10\' | translate}}</label></div></div><div class=\"form-group hide\"><div class=\"marR20 marB20\" ng-if=\"channel.dType == \'t\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/textMedia.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"channel.dType == \'l\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/list.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"channel.dType == \'m\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/media.png alt=\"Template 3\"></label></div></div><div class=form-group><label for=post>{{\'cl.widget.instagram.6\' | translate}}</label><select id=post class=form-control ng-options=\"p for p in postList track by p\" ng-model=channel.post aria-label=\"{{\'cl.widget.instagram.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.instagram.6\' | translate}}\"></select></div><div ng-if=\"channel.teamsChannelReq.teamsChannelApp == \'ca\'\"><div class=form-group><label for=tenantId>{{\'cl.widget.pBI.9\' | translate}}</label><input type=text id=tenantId class=form-control ng-model=channel.teamsChannelReq.tenantId maxlength=140 ng-disabled=\"encId != \'\' && channel.isAuth\" aria-label=\"{{\'cl.widget.pBI.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.9\' | translate}}\"></div><div class=form-group><label for=clientId>{{\'cl.widget.pBI.10\' | translate}}</label><input type=text id=clientId class=form-control ng-model=channel.teamsChannelReq.clientId maxlength=140 ng-disabled=\"encId != \'\' && channel.isAuth\" aria-label=\"{{\'cl.widget.pBI.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.10\' | translate}}\"></div><div class=form-group><label for=secret>{{\'cl.widget.pBI.11\' | translate}}</label><input type=password id=secret class=form-control ng-model=channel.teamsChannelReq.secret maxlength=140 ng-disabled=\"encId != \'\' && channel.isAuth\" aria-label=\"{{\'cl.widget.pBI.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.11\' | translate}}\"></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"channel.dType == \'t\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"textMedia.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=textMedia.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.bg, opacity:textMedia.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.bg selected-type=channel.ctype.bg is-alpha=true selected-alpha=textMedia.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.textBg, opacity:textMedia.settings.textBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.textBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.textBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.textBg selected-type=channel.ctype.textBg is-alpha=true selected-alpha=textMedia.settings.textBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.9\' | translate}}</label><select class=form-control ng-model=textMedia.settings.align><option value=l>{{\'cm.editor.10.4\' | translate}}</option><option value=c>{{\'cm.editor.10.5\' | translate}}</option><option value=r>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.titleText selected-type=textMedia.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=textMedia.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.descText selected-type=channel.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.descSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.survey.8\' | translate}}</label><select class=form-control ng-model=textMedia.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div ng-if=\"channel.dType == \'l\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"list.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=list.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"list.settings.hTextOpt==\'c\'\"><input type=text class=form-control ng-model=list.settings.hText maxlength={{inputLimit}} focus-me=true></div></div><div class=row ng-if=\"list.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.headerBg, opacity:list.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerBg selected-type=list.ctype.headerBg is-alpha=true selected-alpha=list.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerText selected-type=list.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control ng-model=list.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.bg, opacity:list.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.bg selected-type=list.ctype.bg is-alpha=true selected-alpha=list.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.rowBg, opacity:list.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.rowBg selected-type=list.ctype.rowBg is-alpha=true selected-alpha=list.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.altBg, opacity:list.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altBg selected-type=list.ctype.altBg is-alpha=true selected-alpha=list.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.8\' | translate}}</label><select class=form-control ng-model=list.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.fs.10\' | translate}}</label><select class=form-control ng-model=list.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.cm.31\' | translate}}</label><input type=number class=form-control ng-model=list.settings.headerSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.titleText selected-type=list.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.subtitleText selected-type=list.ctype.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.descText selected-type=list.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altTitleText selected-type=list.ctype.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ast><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altSubtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altSubtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ast=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altSubtitleText selected-type=list.ctype.altSubtitleText ng-if=colorPicker.ast></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altDescText selected-type=list.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=list.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.oc.15\' | translate}}</label><input type=number class=form-control ng-model=list.settings.subtitleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=list.settings.descSize min=1></div></div></div><div ng-if=\"channel.dType == \'m\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':media.settings.bg, opacity:media.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"media.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{media.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=media.settings.bg selected-type=channel.ctype.bg is-alpha=true selected-alpha=media.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"media.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=media.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=channel.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=channel.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.tChannel.5\' | translate}}</label><div class=\"msg-warning marB10\" ng-if=channel.isAuth>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'at\');\" ng-if=!teamsShow ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-success\" ng-click=\"reAuthOpen(\'re\');\" ng-if=teamsShow>{{teamsShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-default\" ng-click=\"reAuthOpen(\'ou\');\" ng-if=teamsShow>{{\'cl.widget.cm.25.2\' | translate}}</button></div></div><div class=form-group ng-if=\"teamsShow && showTeamsList\"><label for=net>{{\'cl.widget.tChannel.4\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=tl.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"teamsSearchFocus();searchTeams.teamName=\'\';\" aria-placeholder=\"{{\'cl.widget.yammer.5.1\' | translate}}\">{{channel.teams.team_name}} <span ng-if=\"channel.teams == \'\'\">{{\'cl.widget.tChannel.4.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=teamsList.length><li class=\"dropdown-header noMar\" ng-if=\"teamsList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchTeams.teamName sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTeams.teamName.length ng-click=\"searchTeams.teamName=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"teamsList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"team in teams = (teamsList | filter:{team_name:searchTeams.teamName})\" tabindex=$index ng-class=\"{\'selected disabled\': team.team_id == channel.teams.team_id}\"><label ng-model=team.selected ng-click=selTeamsFx(team);><label></label>{{team.team_name}}</label></li><div class=msg-warning ng-if=\"teams.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTeams.teamName)}}&quot;</b>\'}\"></div></div></ul></div></div></div><img ng-if=channelLoading alt=Loading src=assets\\images\\loading.gif><div class=form-group ng-if=\"teamsShow && showTeamsList && showChannelList && !channelLoading\"><label for=channel>{{\'cl.widget.sch.3\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=cl.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=channelSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.6.1\' | translate}}\">{{channel.channel.displayName}} <span ng-if=\"channel.channel == \'\'\">{{\'cl.widget.sch.3.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=channelList.length><li class=\"dropdown-header noMar\" ng-if=\"channelList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchChannel.displayName sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchChannel.displayName.length ng-click=\"searchChannel.displayName=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"channelList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"ch in channels = (channelList | filter: { displayName: searchChannel.displayName })\" tabindex=$index ng-class=\"{\'selected disabled\': ch.id == channel.channel.id}\"><label ng-model=ch.selected ng-click=selChannelFx(ch);><label></label>{{ch.displayName}}</label></li><div class=msg-warning ng-if=\"ch.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchChannel.displayName)}}&quot;</b>\'}\"></div></div></ul></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=channelFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"channelFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing || authSaveDisable\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'channel\'\">{{\'cl.widget.sch.m1\' | translate}}</div><div ng-if=\"errType == \'hSize\'\">{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType == \'tSize\'\">{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType == \'dSize\'\">{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType == \'rotate\'\">{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType == \'headerText\'\">{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType == \'sSize\'\">{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType == \'rotation\'\">{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'authEmpty\'\">{{\'cl.widget.tChannel.m2\' | translate}}</div><div ng-if=\"errType == \'authFailed\'\">{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType == \'teamsEmpty\'\">{{\'cl.widget.tChannel.m1\' | translate}}</div><div ng-if=\"errType == \'invalid\'\">{{\'cm.msg.45\' | translate}}</div><div ng-if=\"errType == \'allEmpty\'\">{{\'cm.msg.5\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/teamsRoom.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tRoom.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.tRoom.2\' | translate}} &nbsp; <span ng-if=teams.info.label>[ {{teams.info.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\" id=tab-n role=tab><a href=\"\" role=link ng-click=tabFx(1); ng-disabled=reponseLoad><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\" id=tab-a role=tab><a href=\"\" role=link ng-click=teamsFx(1); ng-disabled=reponseLoad><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'3\'}\" id=tab-ss role=tab><a href=\"\" role=link ng-click=teamsFx(3); ng-disabled=reponseLoad><span class=badge>3</span>{{\'cl.widget.meeting.4\' | translate}}</a></li><li ng-class=\"{\'active\':selectedT==\'4\'}\" id=tab-rl role=tab aria-selected=false><a href=\"\" role=link ng-click=teamsFx(4); ng-disabled=reponseLoad><span class=badge>4</span>{{\'cl.widget.meeting.7\' | translate}}</a></li><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"resetFx(\'s\'); editSForm = {isShow:true, isAdd:true, isEdit:false}\" ng-show=\"selectedT==\'3\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cl.widget.meeting.6\' | translate}}</button></div></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=teams.info.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div ng-if=\"teams.info.teamsrooms.teamsroomsApp == \'ca\'\"><div class=form-group><label for=tenantId>{{\'cl.widget.pBI.9\' | translate}}</label><input type=text id=tenantId class=form-control ng-model=teams.info.teamsrooms.credential.tenantId maxlength=140 ng-disabled=\"encId != \'\' && teams.isAuthorized\" aria-label=\"{{\'cl.widget.pBI.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.9\' | translate}}\"></div><div class=form-group><label for=clientId>{{\'cl.widget.pBI.10\' | translate}}</label><input type=text id=clientId class=form-control ng-model=teams.info.teamsrooms.credential.clientId maxlength=140 ng-disabled=\"encId != \'\' && teams.isAuthorized\" aria-label=\"{{\'cl.widget.pBI.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.10\' | translate}}\"></div><div class=form-group><label for=secret>{{\'cl.widget.pBI.11\' | translate}}</label><input type=password id=secret class=form-control ng-model=teams.info.teamsrooms.credential.secret maxlength=140 ng-disabled=\"encId != \'\' && teams.isAuthorized\" aria-label=\"{{\'cl.widget.pBI.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pBI.11\' | translate}}\"></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- Roomboard--><div class=\"panel-inner-tab marB10\">{{\'cl.widget.oc.4\' | translate}}</div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.rb.bg, opacity:teams.info.settings.rb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.rb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.rb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.rb.bg selected-type=teams.info.ctype.rb.bg is-alpha=true selected-alpha=teams.info.settings.rb.bga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.rb.ssbg, opacity:teams.info.settings.rb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.rb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rsb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.rb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.rb.ssbg selected-type=teams.info.ctype.rb.ssbg is-alpha=true selected-alpha=teams.info.settings.rb.ssbga ng-if=colorPicker.rsb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.rb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.rb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.rb.titleText selected-type=teams.info.ctype.rb.titleText ng-if=colorPicker.rtt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=rbTitleFont class=form-control ng-model=teams.info.settings.rb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=teams.info.settings.rb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rst><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.rb.subtitleText}\"></span></span> <input type=text id=rbSubtitleText class=\"form-control picker\" ng-value=\"teams.info.settings.rb.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rst=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.rb.subtitleText selected-type=teams.info.ctype.rb.subtitleText ng-if=colorPicker.rst></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbSubtitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select id=rbSubtitleFont class=form-control ng-model=teams.info.settings.rb.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubtitleSize class=form-control ng-model=teams.info.settings.rb.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.rb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.rb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.rb.timeText selected-type=teams.info.ctype.rb.timeText ng-if=colorPicker.rtm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=rbTimeFont class=form-control ng-model=teams.info.settings.rb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=rbTimeSize class=form-control ng-model=teams.info.settings.rb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.28\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=teams.info.settings.rb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=teams.info.settings.rb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"teams.info.settings.rb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbPrior class=form-control ng-model=teams.info.settings.rb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.28\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.29\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=teams.info.settings.rb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=teams.info.settings.rb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"teams.info.settings.rb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbAfter class=form-control ng-model=teams.info.settings.rb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.29\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.29\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div><!-- Wallboard --><div class=\"panel-inner-tab marB10 marT35\">{{\'cl.widget.oc.5\' | translate}}</div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=teams.info.settings.wb.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=teams.info.settings.wb.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"teams.info.settings.wb.rotationOpt == \'c\'\"><input type=number id=wbCRotate class=form-control ng-model=teams.info.settings.wb.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div><div class=flex1></div></div><div class=\"d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.wb.bg, opacity:teams.info.settings.wb.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.wb.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.bg selected-type=teams.info.ctype.wb.bg is-alpha=true selected-alpha=teams.info.settings.wb.bga ng-if=colorPicker.wb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wsb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.wb.ssbg, opacity:teams.info.settings.wb.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wsb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.wb.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.ssbg selected-type=teams.info.ctype.wb.ssbg is-alpha=true selected-alpha=teams.info.settings.wb.ssbga ng-if=colorPicker.wsb></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=flex1></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=teams.info.settings.wb.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=teams.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label for=wbTitle>{{\'cm.label.23\' | translate}}</label><div class=input-group><input type=text id=wbTitle class=\"form-control input-sm\" ng-model=teams.info.settings.wb.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col1TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=teams.info.settings.wb.header.col1TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbTime>{{\'cm.label.8\' | translate}}</label><div class=input-group><input type=text id=wbTime class=\"form-control input-sm\" ng-model=teams.info.settings.wb.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col2TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=teams.info.settings.wb.header.col2TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1><label for=wbRoom>{{\'cl.widget.oc.10\' | translate}}</label><div class=input-group><input type=text id=wbRoom class=\"form-control input-sm\" ng-model=teams.info.settings.wb.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"> <span class=\"input-group-addon noPad noBdr\"><select id=col3TxtAlign class=\"input-sm noBdrRadTL noBdrRadBL noBdrL bdrLightGray\" ng-model=teams.info.settings.wb.header.col3TxtAlign aria-label=\"{{\'cl.widget.oc.41\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.41\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></span></div></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=teams.info.settings.wb.header.active><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.whb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.wb.headerBg, opacity:teams.info.settings.wb.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.whb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.wb.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.headerBg selected-type=teams.info.ctype.wb.headerBg is-alpha=true selected-alpha=teams.info.settings.wb.headerBga ng-if=colorPicker.whb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.headerText selected-type=teams.info.ctype.wb.headerText ng-if=colorPicker.wht></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wbHeaderFont class=form-control ng-model=teams.info.settings.wb.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=flex1><label for=wbHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wbHeaderSize class=form-control ng-model=teams.info.settings.wb.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div><div class=\"flex1 noMarR\"></div></div><div class=\"marT15 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.titleText selected-type=teams.info.ctype.wb.titleText ng-if=colorPicker.wtt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wat><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wat=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.altTitleText selected-type=teams.info.ctype.wb.altTitleText ng-if=colorPicker.wat></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=wbTitleFont class=form-control ng-model=teams.info.settings.wb.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=flex1><label for=wbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wbTitleSize class=form-control ng-model=teams.info.settings.wb.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=titleTxtAlign>{{\'cl.widget.oc.40\' | translate}}</label><select id=titleTxtAlign class=form-control ng-model=teams.info.settings.wb.titleTxtAlign aria-label=\"{{\'cl.widget.oc.40\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.40\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=teams.info.settings.wb.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=teams.info.settings.wb.isTime><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.timeText selected-type=teams.info.ctype.wb.timeText ng-if=colorPicker.wtm></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.watm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.watm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.altTimeText selected-type=teams.info.ctype.wb.altTimeText ng-if=colorPicker.watm></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=wbTimeFont class=form-control ng-model=teams.info.settings.wb.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=flex1><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=teams.info.settings.wb.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div><div class=\"flex1 noMarR\"><label for=timeTxtAlign>{{\'cl.widget.oc.42\' | translate}}</label><select id=timeTxtAlign class=form-control ng-model=teams.info.settings.wb.timeTxtAlign aria-label=\"{{\'cl.widget.oc.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.42\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=teams.info.settings.wb.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"marT15 d-flex justify-spaceB\" ng-if=teams.info.settings.wb.isRoom><div class=\"flex1 noMarL\"><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.roomText selected-type=teams.info.ctype.wb.roomText ng-if=colorPicker.wrt></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wart><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':teams.info.settings.wb.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wart=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.altRoomText selected-type=teams.info.ctype.wb.altRoomText ng-if=colorPicker.wart></ng-hub-color-picker></div></div></div><div class=flex1><label for=wbRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wbRoomFont class=form-control ng-model=teams.info.settings.wb.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=flex1><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input id=wbRoomSize type=number class=form-control ng-model=teams.info.settings.wb.roomSize min=1></div><div class=\"flex1 noMarR\"><label for=roomTxtAlign>{{\'cl.widget.oc.43\' | translate}}</label><select id=roomTxtAlign class=form-control ng-model=teams.info.settings.wb.roomTxtAlign aria-label=\"{{\'cl.widget.oc.43\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.43\' | translate}}\"><option value=left>{{\'cm.editor.10.4\' | translate}}</option><option value=center>{{\'cm.editor.10.5\' | translate}}</option><option value=right>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"marT20 d-flex justify-spaceB\"><div class=\"flex1 noMarL\"><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wrb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.wb.rowBg, opacity:teams.info.settings.wb.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wrb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.wb.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.rowBg selected-type=teams.info.ctype.wb.rowBg is-alpha=true selected-alpha=teams.info.settings.wb.rowBga ng-if=colorPicker.wrb></ng-hub-color-picker></div></div></div><div class=flex1><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wab><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':teams.info.settings.wb.altBg, opacity:teams.info.settings.wb.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"teams.info.settings.wb.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wab=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{teams.info.settings.wb.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=teams.info.settings.wb.altBg selected-type=teams.info.ctype.wb.altBg is-alpha=true selected-alpha=teams.info.settings.wb.altBga ng-if=colorPicker.wab></ng-hub-color-picker></div></div></div><div class=flex1></div><div class=flex1></div><div class=\"flex1 noMarR\"></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.30\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wdmOpt ng-model=teams.info.settings.wb.wdmOpt value=d><label></label>{{\'cl.widget.meeting.30.1\' | translate}}</label><label class=\"marR10 hide\"><input type=radio role=radio name=wdmOpt ng-model=teams.info.settings.wb.wdmOpt value=w><label></label>{{\'cl.widget.meeting.30.2\' | translate}}</label><label class=hide><input type=radio role=radio name=wdmOpt ng-model=teams.info.settings.wb.wdmOpt value=m><label></label>{{\'cl.widget.meeting.30.3\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.28\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=teams.info.settings.wb.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=teams.info.settings.wb.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"teams.info.settings.wb.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbPrior class=form-control ng-model=teams.info.settings.wb.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.28\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.29\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=teams.info.settings.wb.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=teams.info.settings.wb.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"teams.info.settings.wb.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbAfter class=form-control ng-model=teams.info.settings.wb.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.29\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.29\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=teams.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=teams.info.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.tRoom.3\' | translate}}</label><div class=\"msg-warning marB10\" ng-if=teams.isAuthorized>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button ng-if=!teams.isAuthorized class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button ng-if=teams.isAuthorized class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450);\">{{\'cl.widget.cm.25.1\' | translate}}</button> <button type=button role=button ng-if=teams.isAuthorized class=\"btn btn-default marR10\" ng-click=\"openUrlFx(626, 450, \'otherUserAuth\');\">{{\'cl.widget.cm.25.2\'| translate}}</button></div></div><div class=form-group ng-if=dListShow><label for=roomList>{{\'cl.widget.meeting.7\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span id=roomD class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList.d=\'\'\">{{curDSelected = (allRoomList | filter:{selected:true}); \"\"}} <span ng-if=!curDSelected.length>{{\'cl.widget.tRoom.4\' | translate}}</span> <span ng-repeat=\"device in curDSelected\">{{device.displayName}}<span ng-if=!$last>, </span></span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.d sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><div class=table><ul><li class=\"row padTB3\" ng-repeat=\"device in filteredDList = (allRoomList | filter:searchList.d | orderBy: \'displayName\')\" tabindex=$index><label class=fw-normal><input type=checkbox ng-model=device.selected role=checkbox><label></label>{{device.displayName}}</label></li></ul><div class=\"msg-warning text-sm pad5\" ng-if=!allRoomList.length>{{\'cl.widget.meeting.m9\' | translate}}</div><div class=\"msg-warning text-sm pad5\" ng-if=\"allRoomList.length && filteredDList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div></div></div></div></div></div></ul></div></div></div></div><div ng-if=\"selectedT==\'3\'\"><div class=\"bg-light pad10 marB15\" ng-show=editSForm.isShow><div class=\"col-xs-12 noPadR\"><div class=row><div class=col-xs-4><div class=form-group><label for=ssLabel>{{\'cm.brief.1\' | translate}}</label><input type=text id=ssLabel class=form-control ng-model=addScreen.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div></div><div class=col-xs-3><div class=form-group><label>{{\'cl.widget.meeting.24\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!addScreen.isHidden && (addScreen.ss.thumb || addScreen.ss.type == \'SharePointC\' || addScreen.ss.type == \'OneDriveC\' || addScreen.ss.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'i\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=addScreen.ss.thumb ng-href=\"{{cDetailBucket + addScreen.ss.thumb | secureThumb}}\" role=button data-access={{addScreen.ss.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(addScreen.ss.path + (addScreen.ss.path.length > 1 ? \' / \' : \' \') + addScreen.ss.label)}}\" ng-show=addScreen.ss.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + addScreen.ss.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"addScreen.ss.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"addScreen.ss.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><button type=button role=button id=contentBtn class=\"btn btn-default btn-xs marT6\" ng-click=selectContentOpen();>{{\'cl.widget.meeting.24.1\' | translate | camelCase}}</button></div></div></div><div class=\"col-xs-2 noPadR\"><div class=form-group><label>{{\'cl.widget.meeting.12\' | translate}}</label><div><span class=\"text-bold pull-left marT8\">{{addScreen.d.length}}</span> <button type=button role=button id=deviceBtn class=\"btn btn-primary btn-xs marT6 marL5\" ng-click=\"devicesView(addScreen.sId ? \'u\' : \'n\', addScreen);\">{{\'cm.label.4s\' | translate}}</button></div></div></div><div class=col-xs-3><label for=ssDuration>{{\'cm.label.49\' | translate}}&nbsp;<span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=ssDuration class=\"form-control w135\" ng-model=addScreen.ss.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div></div><div class=row><div class=\"col-xs-12 bdr-top-dashed\"><span ng-if=editSForm.isAdd><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=submit role=button class=\"btn btn-default btn-sm\" ng-click=\"addScreensaverFx(\'sm\');\" ng-disabled=\"addProcessing || addMoreProcessing\"><span class=fa ng-class=\"addMoreProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cl.widget.meeting.11\' | translate}}</button> <button type=reset role=button class=\"btn btn-default btn-sm\" ng-click=\"resetFx(\'s\');\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> </span><span ng-if=editSForm.isEdit><button type=submit role=button class=\"btn btn-success btn-sm\" ng-click=\"addScreensaverFx(\'s\');\" ng-disabled=addProcessing><span class=fa ng-class=\"addProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</button> </span><button type=reset role=button class=btn-link ng-click=\"editSForm.isShow = false\">{{\'cm.btn.9\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasListErr><div ng-if=\"errType == \'label\'\">{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType == \'duration\'\">{{\'cm.msg.11\' | translate}}</div><div ng-if=\"errType == \'ss\'\">{{\'cl.widget.meeting.m4\' | translate}}</div><div ng-if=\"errType == \'device\'\">{{\'cl.widget.meeting.m5\' | translate}}</div></div></div></div></div><div class=clearfix></div></div><div class=col-xs-12><div class=\"table table-scroll\"><div class=\"row th\"><div class=col-xs-6>{{\'cl.widget.meeting.4\' | translate}}</div><div class=col-xs-3>{{\'cm.label.4s\' | translate}}</div><div class=col-xs-2>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=overflow-auto><ul ng-if=\"ssList.length > 0\" class=sortable-containment sortable callback=sortCallback()><li class=\"row sortable-item\" ng-repeat=\"ss in ssList\" data-id={{ss.sId}}><div class=col-xs-6><div class=user-tumb><a ng-href=\"{{cDetailBucket + ss.ss.thumb | secureThumb}}\" role=button data-access={{ss.ss.isAccessible}} fancyboxable=fbTitleWithHome ng-if=\"ss.ss.thumb && !ss.ss.url && ss.ss.isAccessible\" data-fancybox-title=\"{{ss.ss.path + (ss.ss.path.length > 1 ? \' / \' : \' \') + ss.ss.label}}\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/sp.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/od.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/gd.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"ss.ss.type == \'GoogleDriveC\'\"> </a><a href=\"\" role=link ng-click=\"fbVideoFx(cDetailBucket + ss.ss.url, ss.ss.label);\" ng-if=\"ss.ss.thumb && ss.ss.url && ss.ss.isAccessible\"><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive> </a><img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/sp.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/od.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + ss.ss.thumb + \'&h=30&w=30&q=80&zc=3\'}}\" src-error=\"{{tim + \'assets/images/default/thumbs/n/gd.png\'}}&h=28&w=28&q=80&zc=2\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type == \'GoogleDriveC\'\"> <img alt=\"\" src=\"{{tim + \'assets/images/default/na.png\' + \'&h=30&w=30&q=80&zc=3\'}}\" class=img-responsive ng-if=\"!ss.ss.thumb && ss.ss.type != \'SharePointC\' && ss.ss.type != \'OneDriveC\' && ss.ss.type != \'GoogleDriveC\'\"><div class=\"pull-left relative\" ng-if=!ss.ss.isAccessible><img alt=\"\" uib-tooltip=\"{{\'cm.msg.39\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-md></div></div><div class=text-ellipsis uib-tooltip={{ss.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ss.label}}</div></div><div class=col-xs-3>{{ss.d.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"devicesView(\'v\', ss);\">{{\'cm.btn.21\' | translate}}</button></div><div class=col-xs-2>{{ss.ss.duration}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"editFx(\'s\', ss);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=\"deleteOpen(\'s\', ss.sId);\"><span class=\"fa fa-remove noMarR\" aria-hidden=true></span></a></div></li></ul><div class=msg-warning ng-if=\"ssList.length == 0\">{{\'cl.widget.meeting.m3\' | translate}}</div></div></div></div></div><div ng-if=\"selectedT==\'4\'\" class=marL10><!-- TODO added scroll feature changes and added new tabs --><div class=\"form-group marT20\" ng-if=\"allScrollDataList.rl.length > 0\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text placeholder=\"{{\'cm.ph.1\' | translate}}\" class=\"form-control input-sm\" ng-model=searchText sanitize-input ng-change=\"searchChangeDataDyn(searchText, \'rl\');\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchText.length ng-click=\"searchText = \'\';searchChangeDataDyn(searchText, \'rl\');\"><span class=\"fa fa-remove\"></span></a></div><div class=panel-inner-tab>{{\'cl.widget.meeting.7\' | translate}}</div><div class=\"table table-scroll marT5 marB15\" ng-if=\"allScrollDataList.rl.length || curRoomList.length\"><div class=\"row th\"><div class=col-xs-7>{{\'cl.widget.oc.10\' | translate}}</div><div class=col-xs-3>{{\'cl.widget.cm.9\' | translate}}</div><div class=col-xs-1>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-1 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(495)}}px id=scroll-container-rl dynamic-scroll-list st=stIndex.rl et=etIndex.rl list-data=scrollDataList.rl search-data=searchText have-more-data=haveMoreData.rl search-scroll=searchScroll.rl clone-data=allScrollDataList.rl have-more-search-data=haveMoreSearchData.rl quad-id=\"\'rl\'\" dd-open=true><div class=\"row rowObj-rl\" id={{room.id}} ng-repeat=\"room in filteredRoomList = (visibleData.rl)\" ng-if=!room.isHidden><div class=col-xs-7><span ng-if=!room.show><div class=\"marR5 deviceStatus {{room.status}}\" uib-tooltip=\"{{room.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{room.l}}</span> <input type=text class=form-control ng-model=room.l ng-if=room.show readonly></div><div class=col-xs-3><span ng-if=!room.show><span ng-if=\"room.dt == \'rb\'\">{{\'cl.widget.oc.4\' | translate}}</span> <span ng-if=\"room.dt == \'wb\'\">{{\'cl.widget.oc.5\' | translate}}</span></span><select class=form-control ng-model=room.dt ng-if=room.show><option value=rb>{{\'cl.widget.oc.4\' | translate}}</option><option value=wb>{{\'cl.widget.oc.5\' | translate}}</option></select><select id=adType ng-if=\"room.show && room.dt == \'rb\'\" class=\"form-control marT10\" ng-model=room.rm ng-options=\"list.emailAddress as list.displayName for list in curDRoomList\" aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.tRoom.4\' | translate}}</option></select></div><div class=col-xs-1 ng-if=!room.show>{{room.type==\'r\'?\'cm.label.17\':\'cm.label.4\' | translate}}</div><div class=\"col-xs-1 text-right\" ng-class=\"{\'col-xs-2 noPad\':room.show}\"><a href=\"\" class=\"text-primary marR5\" ng-if=!room.show ng-click=\"room.show = !room.show; roomUCFx(\'e\', room)\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\"></span></a> <a href=\"\" class=\"btn btn-success\" ng-show=room.show ng-click=\"roomUCFx(\'u\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.15\' | translate}}</a> <a href=\"\" class=\"btn btn-link\" ng-show=room.show ng-click=\"roomUCFx(\'c\', room, $index);\" ng-disabled=roomUProcessing>{{\'cm.btn.9\' | translate}}</a></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && !loadingMore.rl\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreData.rl || !haveMoreSearchData.rl) && scrollDataList.rl.length >= 300 && scrollDataList.rl.length == etIndex.rl && loadingMore.rl\"> <img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.rl></div><div class=msg-warning ng-if=\"allScrollDataList.rl.length > 0 && filteredRoomList.length == 0 && !loadingPaging.rl\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning ng-if=!allScrollDataList.rl.length>{{\'d.msg.1\' | translate}}</div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\" ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=\"backBtnFx(); selectedTabFx();\" ng-disabled=reponseLoad><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=teamsFx(1); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'2\'\" ng-click=teamsFx(3); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.4\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'3\'\" ng-click=teamsFx(4); ng-disabled=\"nextProcessing || reponseLoad\">{{\'cm.btn.12\' | translate}}: {{\'cl.widget.meeting.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"teamsFx(0, \'save\');\" ng-if=\"encId || selectedT==\'4\' || teams.isAuthorized\" ng-disabled=\"nextProcessing || saveProcessing || reponseLoad\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'authFailed\'\">{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType == \'authEmpty\'\">{{\'cl.widget.tRoom.m1\' | translate}}</div><div ng-if=\"errType == \'tSize\'\">{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType == \'stSize\'\">{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType == \'tsSize\'\">{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType == \'rotation\'\">{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType == \'rbSosP\'\">{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType == \'rbSosA\'\">{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType == \'wbSosP\'\">{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType == \'wbSosA\'\">{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'hSize\'\">{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType == \'titleSize\'\">{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType == \'timeSize\'\">{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType == \'roomSize\'\">{{\'cl.widget.msg.24\' | translate}}</div><div ng-if=\"errType == \'fSize\'\">{{\'cl.widget.pw.m5\' | translate}}</div><div ng-if=\"errType == \'lSize\'\">{{\'cl.widget.pw.m3\' | translate}}</div><div ng-if=\"errType == \'rSize\'\">{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType == \'allEmpty\'\">{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType == \'invalid\'\">{{\'cm.msg.45\' | translate}}</div><div ng-if=\"errType == \'room\'\">{{\'cl.widget.tRoom.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/telax.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.telax.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.telax.2\' | translate}} &nbsp; <span ng-if=telax.label>[ {{telax.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=telax.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.telax.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio name=reportType ng-model=telax.reportType value=agent><label></label>{{\'cl.widget.telax.4\' | translate}}</label><label class=\"noMarB marL10 marR10\"><input type=radio role=radio name=reportType ng-model=telax.reportType value=queue><label></label>{{\'cl.widget.telax.5\' | translate}}</label><label class=noMarB><input type=radio role=radio name=reportType ng-model=telax.reportType value=cops><label></label>{{\'cl.widget.telax.6\' | translate}}</label></div></div><div ng-if=\"telax.reportType==\'cops\'\"><div class=row><div class=col-xs-12><div class=form-group><label>{{\'cm.label.44\' | translate}}</label><div class=form-group><a ng-if=\"!telax.isHidden && telax.img.thumb\" ng-href=\"{{cDetailBucket + telax.img.thumb | secureThumb}}\" role=button data-access={{telax.img.isAccessible}} fancyboxable=fbTitleInside ng-show=telax.img.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + telax.img.thumb + thumbParam}}\"></a><div ng-if=telax.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=serverThumb></div></div><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button> <input type=file file-model=curImg.img options=\"{size:2100000, format:[\'imgOnly\']}\" accept=image/*> <input type=text class=form-control ng-value=curImg.img.name readonly aria-label=\"{{\'cm.label.44\' | translate}}\" aria-labelledby=\"{{\'cm.label.44\' | translate}}\"></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=limit1>{{\'cl.widget.telax.7\' | translate}}</label><input type=number id=limit1 class=form-control ng-model=telax.limit1 value=0 min=0 readonly aria-label=\"{{\'cl.widget.telax.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label>{{\'cl.widget.cm.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c1><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':telax.color1}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"telax.color1 | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c1=true\" readonly aria-label=\"{{\'cl.widget.cm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=telax.color1 selected-type=telax.c1Type ng-if=colorPicker.c1></ng-hub-color-picker></div></div></div></div></div><div class=spaceH></div><div class=row><div class=col-xs-6><div class=form-group><input type=number id=limit2 class=form-control ng-model=telax.limit2 value=10 min=1 aria-label=\"{{\'cl.widget.telax.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c2><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':telax.color2}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"telax.color2 | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c2=true\" readonly aria-label=\"{{\'cl.widget.cm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=telax.color2 selected-type=telax.c2Type ng-if=colorPicker.c2></ng-hub-color-picker></div></div></div></div></div><div class=spaceH></div><div class=row><div class=col-xs-6><div class=form-group><input type=number id=limit3 class=form-control ng-model=telax.limit3 value=15 min=2 aria-label=\"{{\'cl.widget.telax.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.telax.7\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c3><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':telax.color3}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"telax.color3 | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c3=true\" readonly aria-label=\"{{\'cl.widget.cm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=telax.color3 selected-type=telax.c3Type ng-if=colorPicker.c3></ng-hub-color-picker></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=telax.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=telax.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=telaxFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'limit\'\" aria-live=polite role=status>{{\'cl.widget.telax.m1\' | translate}}</div><div ng-if=\"errType==\'limitU\'\" aria-live=polite role=status>{{\'cl.widget.telax.m1\' | translate}}</div><div ng-if=\"errType==\'limitEqual\'\" aria-live=polite role=status>{{\'cl.widget.telax.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/text.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.text.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.text.2\' | translate}} &nbsp; <span ng-if=text.info.label>[ {{text.info.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=text.info.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.64\' | translate}}</label><div class=input-group><input type=text id=addText class=form-control ng-model=addText.text maxlength=500 aria-label=\"{{\'cm.label.64\' | translate}}\" aria-labelledby=\"{{\'cm.label.64\' | translate}}\"> <span class=input-group-btn><button type=button role=button class=\"btn btn-primary\" ng-click=addTextFx(); ng-disabled=!addText.text><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button></span></div></div><div class=form-group ng-if=\"text.textList.length > 0\"><div class=\"table table-md\"><div class=\"row th\"><div class=col-xs-10>{{\'cl.widget.text.3\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=sortable-containment sortable callback=sortCallback()><!-- class=\"scrollQuad crawlingList\" --><div class=\"row sortable-item\" ng-repeat=\"tl in text.textList\" data-id={{tl.id}}><div class=\"col-xs-10 codeQuad\"><div class=\"codeText text-ellipsis-wrap\" ng-show=!tl.show>{{tl.text}}</div><span class=\"input-group input-group-sm\" ng-show=tl.show><input class=form-control value={{tl.text}} ng-keyup=inputCallbackFx($event); ng-blur=inputCallbackFx($event); maxlength=500><div class=input-group-btn><button type=button role=button class=\"btn btn-success\" ng-click=saveTextFx($event); ng-disabled=tl.text>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"cancelTextFx($event, tl.show = !tl.show);\">{{\'cm.btn.9\' | translate}}</button></div></span></div><div class=\"col-xs-2 text-right\"><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"tl.show = !tl.show\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deleteTextOpen(tl.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=text.info.dType ng-change=\"changeDType(\'c\')\" value=c><label></label>{{\'cl.widget.text.7\' | translate}}</label><label class=noMarB><input type=radio role=radio name=dTypeOpt ng-model=text.info.dType ng-change=\"changeDType(\'s\')\" value=s><label></label>{{\'cl.widget.text.8\' | translate}}</label></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"text.info.dType == \'c\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.text.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=settingsCrawl.settings.dir value=rl><label></label>{{\'cl.widget.text.5\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=settingsCrawl.settings.dir value=bt ng-change=directionFx()><label></label>{{\'cl.widget.text.6\' | translate}}</label></div></div><div class=col-xs-6 ng-if=\"settingsCrawl.settings.dir == \'bt\'\"><label>{{\'cl.widget.text.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=aOpt ng-model=settingsCrawl.settings.align value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=aOpt ng-model=settingsCrawl.settings.align value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label><input type=radio role=radio name=aOpt ng-model=settingsCrawl.settings.align value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=speed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=speed class=form-control ng-model=settingsCrawl.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsCrawl.settings.bg, opacity:settingsCrawl.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsCrawl.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsCrawl.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsCrawl.settings.bg selected-type=settingsCrawl.ctype.bg is-alpha=true selected-alpha=settingsCrawl.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"settingsCrawl.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsCrawl.settings.bullet}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsCrawl.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsCrawl.settings.bullet selected-type=settingsCrawl.ctype.bullet ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"settingsCrawl.settings.dir == \'bt\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsCrawl.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsCrawl.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsCrawl.settings.titleText selected-type=settingsCrawl.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4 ng-if=\"settingsCrawl.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsCrawl.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsCrawl.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsCrawl.settings.titleText selected-type=settingsCrawl.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=settingsCrawl.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-4 ng-if=\"settingsCrawl.settings.dir == \'bt\'\"><label for=fontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=fontSize class=form-control ng-model=settingsCrawl.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"settingsCrawl.settings.dir == \'rl\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=settingsCrawl.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label><input type=radio role=radio name=fsOpt ng-model=settingsCrawl.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"settingsCrawl.settings.fontSizeOpt == \'c\'\"><input type=number id=fontSize class=form-control ng-model=settingsCrawl.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div><div ng-if=\"text.info.dType == \'s\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsStatic.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsStatic.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsStatic.settings.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=settingsStatic.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-5><label>{{\'cl.widget.text.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio ng-model=settingsStatic.settings.align name=hAlignOpt value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"noMarB marL10 marR10\"><input type=radio role=radio ng-model=settingsStatic.settings.align name=hAlignOpt value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsStatic.settings.align name=hAlignOpt value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div><div class=col-xs-5><label>{{\'cl.widget.text.10\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=noMarB><input type=radio role=radio ng-model=settingsStatic.settings.vAlign name=vAlignOpt value=t><label></label>{{\'fl.p_cfl.label.20\' | translate}}</label><label class=\"noMarB marL10 marR10\"><input type=radio role=radio ng-model=settingsStatic.settings.vAlign name=vAlignOpt value=m><label></label>{{\'fl.p_cfl.label.21\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsStatic.settings.vAlign name=vAlignOpt value=b><label></label>{{\'fl.p_cfl.label.22\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-5><label for=size>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=size class=form-control ng-model=settingsStatic.settings.size min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div><div class=col-xs-5><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsStatic.settings.bg, opacity:settingsStatic.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsStatic.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsStatic.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsStatic.settings.bg selected-type=settingsStatic.ctype.bg is-alpha=true selected-alpha=settingsStatic.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4></div></div><div class=\"row marT15\"><div class=col-xs-5><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsStatic.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsStatic.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsStatic.settings.titleText selected-type=settingsStatic.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-5><label for=ssfont>{{\'cm.label.24\' | translate}}</label><select id=ssfont class=form-control ng-model=settingsStatic.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div></div></div></div><!-- <div class=\"form-group\">\r\n        <a href=\"\" role=\"link\" class=\"btn btn-link btn-xs pull-right\" ng-click=\"settingsDefault()\" ng-if=\"settingsOpen\"><span class=\"fa fa-undo\" aria-hidden=\"true\"></span>{{\'cm.label.90\' | translate}}</a>\r\n        <label class=\"noMarB\"><a href=\"\" role=\"link\" ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=\"fa\" ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\"></span></a></label>\r\n        <div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=\"settingsOpen\">\r\n          <div ng-if=\"text.info.dType == \'c\'\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.cm.18\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"text.info.settings.speed\" min=\"1\">\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label><input type=\"checkbox\" ng-model=\"text.info.settings.isBg\"><label></label>{{\'cm.label.87\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':text.info.settings.bg}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"text.info.settings.bg | uppercase\" uib-dropdown-toggle ng-disabled=\"!text.info.settings.isBg\" ng-click=\"colorPicker=true\" readonly=\"\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.cm.34\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':text.info.settings.bullet}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"text.info.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"text.info.settings.bullet\" selected-type=\"text.info.ctype.bullet\" ng-if=\"colorPicker\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row marT15\">\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.cm.4\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':text.info.settings.titleText}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"text.info.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"text.info.settings.titleText\" selected-type=\"text.info.ctype.titleText\" ng-if=\"colorPicker\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cm.label.24\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"text.info.settings.font\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div ng-if=\"text.info.dType == \'s\'\">\r\n            <div class=\"form-group\">\r\n              <label>{{\'cl.widget.news.6\' | translate}}</label>\r\n              <div>\r\n                <label class=\"noMarB marR10\"><input type=\"radio\" ng-model=\"text.info.settings.rotationOpt\" name=\"rotationOpt\" value=\"a\"><label></label> {{\'cl.widget.news.6.1\' | translate}}</label>\r\n                <label class=\"noMarB\"><input type=\"radio\" ng-model=\"text.info.settings.rotationOpt\" name=\"rotationOpt\" value=\"c\"><label></label> {{\'cm.label.17\' | translate}}</label>\r\n              </div>\r\n              <div class=\"form-inline marT5\">\r\n                <div class=\"input-group\" ng-if=\"text.info.settings.rotationOpt == \'c\'\">\r\n                  <input type=\"number\" class=\"form-control\" ng-model=\"text.info.settings.rotate\" focus-me=\"true\" min=\"1\">\r\n                  <div class=\"input-group-addon\">{{\'cm.label.27s\' | translate}}</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.cm.26\' | translate}}</label>\r\n                <input type=\"number\" class=\"form-control\" ng-model=\"text.info.settings.size\" min=\"1\">\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label><label></label>{{\'cm.label.61\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':text.info.settings.bg}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"text.info.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"text.info.settings.bg\" selected-type=\"text.info.ctype.bg\" ng-if=\"colorPicker\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-4\"></div>\r\n            </div>\r\n            <div class=\"row marT15\">\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cl.widget.cm.4\' | translate}}</label>\r\n                <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body>\r\n                  <div class=\"input-group input-colorPicker\">\r\n                    <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':text.info.settings.titleText}\"></span></span>\r\n                    <input type=\"text\" class=\"form-control picker\" ng-value=\"text.info.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker=true\" readonly=\"\">\r\n                  </div>\r\n                  <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                    <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                    <ng-hub-color-picker selected-color=\"text.info.settings.titleText\" selected-type=\"text.info.ctype.titleText\" ng-if=\"colorPicker\"></ng-hub-color-picker>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-xs-4\">\r\n                <label>{{\'cm.label.24\' | translate}}</label>\r\n                <select class=\"form-control\" ng-model=\"text.info.settings.font\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div> --></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=text.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=text.info.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=textFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'crawlText\'\" aria-live=polite role=status>{{\'cl.widget.text.m1\' | translate}}</div><div ng-if=\"errType==\'fSizeText\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/touchLink.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tl.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.tl.2\' | translate}} &nbsp; <span ng-if=touchLink.label>[ {{touchLink.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=!detailLoading><div class=\"row noMarR\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=touchLink.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=dTypeOpt ng-model=touchLink.dType value=r><label></label>{{\'cl.widget.ub.3\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=dTypeOpt ng-model=touchLink.dType value=wc><label></label>{{\'cl.widget.ub.4\' | translate}}</label><label><input type=radio role=radio name=dTypeOpt ng-model=touchLink.dType value=we><label></label>{{\'cl.widget.ub.5\' | translate}}</label></div></div><div class=form-group><label for=url>{{\'cm.label.56\' | translate}}</label><input type=text id=url class=form-control ng-model=touchLink.settings.feed.url placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cm.label.56\' | translate}}\" aria-labelledby=\"{{\'cm.label.56\' | translate}}\"></div><div class=form-group><label for=logo>{{\'cl.widget.ub.6\' | translate}}</label><input type=text id=logo class=form-control ng-model=touchLink.settings.feed.logo aria-label=\"{{\'cl.widget.ub.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ub.6\' | translate}}\"></div><div class=form-group><label for=ss>{{\'cl.widget.ub.7\' | translate}}</label><input type=text id=ss class=form-control ng-model=touchLink.settings.feed.ss aria-label=\"{{\'cl.widget.ub.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.ub.7\' | translate}}\"></div></div></div><div class=\"row noMarR\"><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"touchLink.dType == \'r\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsRB.bg, opacity:settingsRB.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsRB.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.bg selected-type=ctypeRB.bg is-alpha=true selected-alpha=settingsRB.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsRB.ssbg, opacity:settingsRB.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsRB.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.ssbg selected-type=ctypeRB.ssbg is-alpha=true selected-alpha=settingsRB.ssbga ng-if=colorPicker.sb></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoRBOpt ng-model=settingsRB.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoRBOpt ng-model=settingsRB.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.titleText selected-type=ctypeRB.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=titleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=titleFont class=form-control ng-model=settingsRB.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=rbTitleSize class=form-control ng-model=settingsRB.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.subtitleText selected-type=ctypeRB.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=subtitleFont>{{\'cl.widget.oc.14\' | translate}}</label><select id=subtitleFont class=form-control ng-model=settingsRB.subtitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.14\' | translate}}\"></select></div><div class=col-xs-4><label for=rbSubtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=rbSubtitleSize class=form-control ng-model=settingsRB.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsRB.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsRB.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsRB.timeText selected-type=ctypeRB.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=rbTimeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=rbTimeFont class=form-control ng-model=settingsRB.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-4><label for=rbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input id=rbTimeSize type=number class=form-control ng-model=settingsRB.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label><label><input type=radio role=radio name=rbSsosOpt ng-model=settingsRB.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosP class=form-control ng-model=settingsRB.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label><label><input type=radio role=radio name=rbEsosOpt ng-model=settingsRB.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label></div><div class=row ng-if=\"settingsRB.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=rbSosA class=form-control ng-model=settingsRB.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div><div ng-if=\"touchLink.dType != \'r\'\"><div class=row><div class=\"col-md-6 col-lg-3\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsWB.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsWB.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"settingsWB.rotationOpt == \'c\'\"><input type=number id=rotation class=form-control ng-model=settingsWB.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div><div class=row><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.bg, opacity:settingsWB.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.bg selected-type=ctypeWB.bg is-alpha=true selected-alpha=settingsWB.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.4.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.sb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.ssbg, opacity:settingsWB.ssbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.ssbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.sb=true\" readonly aria-label=\"{{\'cl.widget.meeting.4.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.4.1\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.ssbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.ssbg selected-type=ctypeWB.ssbg is-alpha=true selected-alpha=settingsWB.ssbga ng-if=colorPicker.sb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.meeting.23\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=logoWBOpt ng-model=settingsWB.logoOpt ng-value=true><label></label>{{\'cl.widget.cm.43\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=logoWBOpt ng-model=settingsWB.logoOpt ng-value=false><label></label>{{\'cl.widget.cm.44\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-12><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.header.active role=checkbox><label></label>{{\'cl.widget.cm.12\' | translate}}</label></div></div><div class=\"row marT15\" ng-if=settingsWB.header.active><div class=col-xs-3><label for=title>{{\'cm.label.23\' | translate}}</label><input type=text id=title class=\"form-control input-sm\" ng-model=settingsWB.header.column1 aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\"></div><div class=col-xs-3><label for=time>{{\'cm.label.8\' | translate}}</label><input type=text id=time class=\"form-control input-sm\" ng-model=settingsWB.header.column2 aria-label=\"{{\'cm.label.8\' | translate}}\" aria-labelledby=\"{{\'cm.label.8\' | translate}}\"></div><div class=col-xs-3><label for=room>{{\'cl.widget.oc.10\' | translate}}</label><input type=text id=room class=\"form-control input-sm\" ng-model=settingsWB.header.column3 aria-label=\"{{\'cl.widget.oc.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.10\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=settingsWB.header.active><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.headerBg, opacity:settingsWB.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.headerBg selected-type=ctypeWB.headerBg is-alpha=true selected-alpha=settingsWB.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.headerText selected-type=ctypeWB.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wbHeaderFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=wbHeaderFont class=form-control ng-model=settingsWB.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=wbHeaderSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=wbHeaderSize class=form-control ng-model=settingsWB.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.titleText selected-type=ctypeWB.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.att><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altTitleText selected-type=ctypeWB.altTitleText ng-if=colorPicker.att></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wbTitleFont>{{\'cl.widget.cm.16.2\' | translate}}</label><select id=wbTitleFont class=form-control ng-model=settingsWB.titleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.16.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.2\' | translate}}\"></select></div><div class=col-xs-3><label for=wbTitleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=wbTitleSize class=form-control ng-model=settingsWB.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.isTime role=checkbox><label></label>{{\'cl.widget.oc.36\' | translate}}</label></div></div></div><div class=\"row marT15\" ng-if=settingsWB.isTime><div class=col-xs-3><label>{{\'cl.widget.cm.30\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tm=true\" readonly aria-label=\"{{\'cl.widget.cm.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.timeText selected-type=ctypeWB.timeText ng-if=colorPicker.tm></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.30.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.atm><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altTimeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altTimeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.atm=true\" readonly aria-label=\"{{\'cl.widget.cm.30.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.30.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altTimeText selected-type=ctypeWB.altTimeText ng-if=colorPicker.atm></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=timeFont>{{\'cl.widget.oc.17\' | translate}}</label><select id=timeFont class=form-control ng-model=settingsWB.timeFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.17\' | translate}}\"></select></div><div class=col-xs-3><label for=wbTimeSize>{{\'cl.widget.oc.18\' | translate}}</label><input type=number id=wbTimeSize class=form-control ng-model=settingsWB.timeSize min=1 aria-label=\"{{\'cl.widget.oc.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.18\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-12><div><label class=\"marT5 noMarB\"><input type=checkbox ng-model=settingsWB.isRoom role=checkbox><label></label>{{\'cl.widget.oc.37\' | translate}}</label></div></div></div><div class=\"row marT15\" ng-if=settingsWB.isRoom><div class=col-xs-3><label>{{\'cl.widget.oc.27\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.roomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.roomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.oc.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.roomText selected-type=ctypeWB.roomText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.oc.27.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.art><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsWB.altRoomText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altRoomText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.art=true\" readonly aria-label=\"{{\'cl.widget.oc.27.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.27.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altRoomText selected-type=ctypeWB.altRoomText ng-if=colorPicker.art></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=wbRoomFont>{{\'cl.widget.oc.28\' | translate}}</label><select id=wbRoomFont class=form-control ng-model=settingsWB.roomFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.oc.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28\' | translate}}\"></select></div><div class=col-xs-3><label for=wbRoomSize>{{\'cl.widget.oc.28.1\' | translate}}</label><input type=number id=wbRoomSize class=form-control ng-model=settingsWB.roomSize min=1 aria-label=\"{{\'cl.widget.oc.28.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.28.1\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.rowBg, opacity:settingsWB.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.rowBg selected-type=ctypeWB.rowBg is-alpha=true selected-alpha=settingsWB.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsWB.altBg, opacity:settingsWB.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsWB.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsWB.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsWB.altBg selected-type=ctypeWB.altBg is-alpha=true selected-alpha=settingsWB.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-6></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.meeting.22\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.1\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbSsosOpt ng-model=settingsWB.sos.sType value=s><label></label>{{\'cl.widget.meeting.22.1.1\' | translate}}</label><label><input type=radio role=radio name=wbSsosOpt ng-model=settingsWB.sos.sType value=p><label></label>{{\'cl.widget.meeting.22.1.2\' | translate}}</label></div><div class=row ng-if=\"settingsWB.sos.sType == \'p\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosP class=form-control ng-model=settingsWB.sos.prior min=1 aria-label=\"{{\'cl.widget.meeting.22.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div><div class=col-xs-4><label>&nbsp;</label><div role=radiogroup aria-labelledby=radiogroup><div><label>{{\'cl.widget.meeting.22.2\' | translate}}</label></div><label class=marR10><input type=radio role=radio name=wbEsosOpt ng-model=settingsWB.sos.eType value=e><label></label>{{\'cl.widget.meeting.22.2.1\' | translate}}</label><label><input type=radio role=radio name=wbEsosOpt ng-model=settingsWB.sos.eType value=a><label></label>{{\'cl.widget.meeting.22.2.2\' | translate}}</label></div><div class=row ng-if=\"settingsWB.sos.eType == \'a\'\"><div class=col-xs-12><div class=input-group><input type=number id=wbSosA class=form-control ng-model=settingsWB.sos.after min=1 aria-label=\"{{\'cl.widget.meeting.22.2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.meeting.22.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div></div></div></div></div></div></div></div></div><div class=\"row noMarR\"><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=touchLink.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=touchLink.activePeriod></ng-active-period></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=touchLinkFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.msg.7\' | translate}}</div><div ng-if=\"errType==\'logo\'\" aria-live=polite role=status>{{\'cl.widget.tl.m1\' | translate}}</div><div ng-if=\"errType==\'ss\'\" aria-live=polite role=status>{{\'cl.widget.tl.m2\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'stSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'tsSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'rbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'rbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'wbSosP\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m12\' | translate}}</div><div ng-if=\"errType==\'wbSosA\'\" aria-live=polite role=status>{{\'cl.widget.meeting.m13\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'titleSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'timeSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.15\' | translate}}</div><div ng-if=\"errType==\'roomSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.24\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/traffic.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.traffic.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.traffic.2\' | translate}} &nbsp; <span ng-if=traffic.label>[ {{traffic.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=traffic.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=col-xs-4><div class=form-group><label for=lat>{{\'db.p_map.3\' | translate}}</label><input type=number id=lat class=form-control ng-model=traffic.lat ng-change=changeForMap(); aria-label=\"{{\'db.p_map.3\' | translate}}\" aria-labelledby=\"{{\'db.p_map.3\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=long>{{\'db.p_map.4\' | translate}}</label><input type=number id=long class=form-control ng-model=traffic.lng ng-change=changeForMap(); aria-label=\"{{\'db.p_map.4\' | translate}}\" aria-labelledby=\"{{\'db.p_map.4\' | translate}}\"></div></div><div class=col-xs-4><div class=form-group><label for=zoom>{{\'cm.label.57\' | translate}}</label><input type=number id=zoom class=form-control ng-model=traffic.zoom ng-change=changeForMap(); aria-label=\"{{\'cm.label.57\' | translate}}\" aria-labelledby=\"{{\'cm.label.57\' | translate}}\"></div></div><div class=col-xs-12><div ng-if=\"auth.uservices.m == \'g\'\"><ng-map center={{mapCenter}} zoom={{traffic.zoom}} on-click=addMarker(); on-zoom_changed=zoomChanged() map-initialized=mapLoaded(map)><marker ng-repeat=\"pos in positions\" position=\"{{pos.lat}}, {{pos.lng}}\"></marker><traffic-layer></traffic-layer></ng-map></div><div ng-if=\"auth.uservices.m == \'b\'\" id=azMap style=height:300px></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=traffic.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=traffic.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=trafficFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'latlong\'\" aria-live=polite role=status>{{\'cl.widget.msg.8\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div><script type=text/javascript src=\"https://www.bing.com/api/maps/mapcontrol?key=AtDjw-SHCn_Y0-zfHLxgaXMgLHOnhBVWJK_zKZM2kuCz8CNkW6zAcbTQVdLhJBFG\" async defer></script>");
$templateCache.put("app/contentLibrary/widgets/trainingMode.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.tm.2\' | translate}} &nbsp; <span ng-if=tm.label>[ {{tm.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=tmFx(1);><span class=badge>2</span>{{\'cm.label.32\' | translate | camelCase}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto padT6\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label ng-model=tm.label class=form-control maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=tm.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=tm.activePeriod></ng-active-period></div></div></div><div class=col-xs-12 ng-if=\"selectedT==\'2\'\"><div class=row><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div ng-class=\"{\'noMarB\': auth.upreferences.isSplitV}\"><div class=\"overflow-auto bg-light pad10\" style=height:{{quadHeight}}px><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=contentLibrary.info.sp class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=contentLibrary.info.od class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=contentLibrary.info.gd class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=!contentLibraryLoading element-height=quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div></div><div ng-class=\"auth.upreferences.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad>{{tmCount = (tm.content | filter:{hidden:0}:true);\"\"}}<div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} <span ng-if=tm.content>[ {{tmCount.length}} ]</span></div><section><div class=\"padTB10 overflow-auto\" style=height:{{selectedHeight}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"!detailLoading && tm.content.length > 0\"><ul class=\"list-inline multiple-selected\"><li ng-repeat=\"content in tm.content | reverse | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} ng-if=!content.hidden><a href=\"\" role=link class=thumb-close ng-click=removeContentFx($index);><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/sp.png class=img-responsive ng-if=\"!content.thumb && content.type == \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/od.png class=img-responsive ng-if=\"!content.thumb && content.type == \'OneDriveC\'\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" src-error=assets/images/default/thumbs/lg/gd.png class=img-responsive ng-if=\"!content.thumb && content.type == \'GoogleDriveC\'\"><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' || content.isCompleted == 0\" ng-src=assets/images/default/{{content.thumb}}_selected.png class=\"img-responsive center-block\"><!-- Images --> <a ng-if=\"content.type == \'Image\'\" href=\"\" role=button ng-click=fbGalleryFx($index);><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Youtube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\'\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{cDetailBucket + content.thumb}}\" class=\"img-responsive center-block\"> </a><span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{content.label}}</div><div class=form-inline><div class=form-group><span class=valign-inherit>{{\'cm.label.49\' | translate}}:</span> <input type=number class=\"form-control input-sm\" ng-model=content.duration min=1 aria-label=\"{{\'cm.label.49\' | translate}}\" aria-labelledby=\"{{\'cm.label.49\' | translate}}\"></div><div class=\"form-group text-muted text-sm\">[{{\'cm.label.27s\' | translate}}]</div><div class=\"fullScreen text-left\" ng-if=\"content.type == \'Video\'\"><label class=noMarB ng-if=\"content.type == \'Video\'\"><input type=checkbox ng-model=content.mute role=checkbox><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && tmCount.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"tmCount.length > 0 && (tm.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=tmFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.32\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"tmFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'durationEmpty\'\" aria-live=polite role=status>{{\'cm.msg.11\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/tscCountryMile.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.tsccm.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.tsccm.2\' | translate}} &nbsp; <span ng-if=wData.label>[ {{wData.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=wData.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=txtArea>{{\'cl.widget.tsccm.3\' | translate}} <span class=\"text-muted text-sm\">{{\'cl.widget.tsccm.3-1\' | translate}}</span></label><textarea id=txtArea class=form-control ng-model=wData.settings.text maxlength={{inputLimit}} aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></textarea></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=dTypeOpt ng-checked=wData.settings.dType.a ng-click=\"setDTypeFx(\'a\')\" value=a aria-label=\"{{\'cl.widget.tsccm.25-1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.25-1\' | translate}}\"><label></label>{{\'cl.widget.tsccm.25-1\' | translate}}</label><label class=marL10><input type=radio role=radio name=dTypeOpt ng-checked=wData.settings.dType.b ng-click=\"setDTypeFx(\'b\')\" value=b aria-label=\"{{\'cl.widget.tsccm.25-2\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.25-2\' | translate}}\"><label></label>{{\'cl.widget.tsccm.25-2\' | translate}}</label></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><!-- Rotation --><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=wData.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=wData.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"wData.settings.rotationOpt == \'c\'\"><input type=number id=rotate class=form-control ng-model=wData.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><!-- Background --><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':wData.settings.bg, opacity:wData.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{wData.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.bg selected-type=wData.ctype.bg is-alpha=true selected-alpha=wData.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><!-- Sort --><div class=col-xs-4><label for=sort>{{\'cm.tool.1\' | translate}}</label><select id=sort class=form-control ng-model=wData.settings.sort aria-label=\"{{\'cm.tool.1\' | translate}}\" aria-labelledby=\"{{\'cm.tool.1\' | translate}}\"><option value=d>{{\'cl.widget.tsccm.26-1\' | translate}}</option><option value=a>{{\'cl.widget.tsccm.26-2\' | translate}}</option></select></div></div><!-- To label --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.tsccm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tl><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.toLabel}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.toLabel | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tl=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.toLabel selected-type=wData.ctype.toLabel ng-if=colorPicker.tl></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=toLabelFont>{{\'cl.widget.tsccm.5\' | translate}}</label><select id=toLabelFont class=form-control ng-model=wData.settings.toLabelFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.5\' | translate}}\"></select></div><div class=col-xs-4><label for=toLabelSize>{{\'cl.widget.tsccm.6\' | translate}}</label><input type=number id=toLabelSize class=form-control ng-model=wData.settings.toLabelSize min=1 aria-label=\"{{\'cl.widget.tsccm.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.6\' | translate}}\"></div></div><!-- To text --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.tsccm.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.toTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.toTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.toTxt selected-type=wData.ctype.toTxt ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=toTxtFont>{{\'cl.widget.tsccm.8\' | translate}}</label><select id=toTxtFont class=form-control ng-model=wData.settings.toTxtFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.8\' | translate}}\"></select></div><div class=col-xs-4><label for=toTxtSize>{{\'cl.widget.tsccm.9\' | translate}}</label><input type=number id=toTxtSize class=form-control ng-model=wData.settings.toTxtSize min=1 aria-label=\"{{\'cl.widget.tsccm.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.9\' | translate}}\"></div></div><!-- From label --><div class=\"row marT15\" ng-if=wData.settings.dType.b><div class=col-xs-4><label>{{\'cl.widget.tsccm.10\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fl><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.fLabel}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.fLabel | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fl=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.fLabel selected-type=wData.ctype.fLabel ng-if=colorPicker.fl></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=fLabelFont>{{\'cl.widget.tsccm.11\' | translate}}</label><select id=fLabelFont class=form-control ng-model=wData.settings.fLabelFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.11\' | translate}}\"></select></div><div class=col-xs-4><label for=fLabelSize>{{\'cl.widget.tsccm.12\' | translate}}</label><input type=number id=fLabelSize class=form-control ng-model=wData.settings.fLabelSize min=1 aria-label=\"{{\'cl.widget.tsccm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.12\' | translate}}\"></div></div><!-- From text --><div class=\"row marT15\" ng-if=wData.settings.dType.b><div class=col-xs-4><label>{{\'cl.widget.tsccm.13\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.fTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.fTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.fTxt selected-type=wData.ctype.fTxt ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=fTxtFont>{{\'cl.widget.tsccm.14\' | translate}}</label><select id=fTxtFont class=form-control ng-model=wData.settings.fTxtFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.14\' | translate}}\"></select></div><div class=col-xs-4><label for=fTxtSize>{{\'cl.widget.tsccm.15\' | translate}}</label><input type=number id=fTxtSize class=form-control ng-model=wData.settings.fTxtSize min=1 aria-label=\"{{\'cl.widget.tsccm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.15\' | translate}}\"></div></div><!-- Message text --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.tsccm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.mTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.mTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.mTxt selected-type=wData.ctype.mTxt ng-if=colorPicker.mt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=mFont>{{\'cl.widget.tsccm.17\' | translate}}</label><select id=mFont class=form-control ng-model=wData.settings.mFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.17\' | translate}}\"></select></div><div class=col-xs-4><label for=mSize>{{\'cl.widget.tsccm.18\' | translate}}</label><input type=number id=mSize class=form-control ng-model=wData.settings.mSize min=1 aria-label=\"{{\'cl.widget.tsccm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.18\' | translate}}\"></div></div><!-- Default message --><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.tsccm.19\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dmt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.dmTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.dmTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dmt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.dmTxt selected-type=wData.ctype.dmTxt ng-if=colorPicker.dmt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=dmFont>{{\'cl.widget.tsccm.20\' | translate}}</label><select id=dmFont class=form-control ng-model=wData.settings.dmFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.20\' | translate}}\"></select></div><div class=col-xs-4><label for=dmSize>{{\'cl.widget.tsccm.21\' | translate}}</label><input type=number id=dmSize class=form-control ng-model=wData.settings.dmSize min=1 aria-label=\"{{\'cl.widget.tsccm.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.21\' | translate}}\"></div></div><!-- Joining Date --><div class=\"row marT15\" ng-if=wData.settings.dType.a><div class=col-xs-4><label>{{\'cl.widget.tsccm.22\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.jdt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':wData.settings.jdTxt}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"wData.settings.jdTxt | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.jdt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=wData.settings.jdTxt selected-type=wData.ctype.jdTxt ng-if=colorPicker.jdt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=jdFont>{{\'cl.widget.tsccm.23\' | translate}}</label><select id=jdFont class=form-control ng-model=wData.settings.jdFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.tsccm.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.20\' | translate}}\"></select></div><div class=col-xs-4><label for=jdSize>{{\'cl.widget.tsccm.24\' | translate}}</label><input type=number id=jdSize class=form-control ng-model=wData.settings.jdSize min=1 aria-label=\"{{\'cl.widget.tsccm.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.tsccm.21\' | translate}}\"></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=wData.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=wData.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'dType\'\">{{\'cl.widget.tsccm.m1\' | translate}}</div><div ng-if=\"errType == \'toLabelSize\'\">{{\'cl.widget.tsccm.m2\' | translate}}</div><div ng-if=\"errType == \'toTxtSize\'\">{{\'cl.widget.tsccm.m3\' | translate}}</div><div ng-if=\"errType == \'fLabelSize\'\">{{\'cl.widget.tsccm.m4\' | translate}}</div><div ng-if=\"errType == \'fTxtSize\'\">{{\'cl.widget.tsccm.m5\' | translate}}</div><div ng-if=\"errType == \'mSize\'\">{{\'cl.widget.tsccm.m6\' | translate}}</div><div ng-if=\"errType == \'dmSize\'\">{{\'cl.widget.tsccm.m7\' | translate}}</div><div ng-if=\"errType == \'jdSize\'\">{{\'cl.widget.tsccm.m8\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/twitter.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.twitter.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.twitter.2\' | translate}} &nbsp; <span ng-if=twitter.label>[ {{twitter.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=twitterFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT == \'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=twitter.labelOpt value=a><label></label>{{\'cl.widget.twitter.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=twitter.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"twitter.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=twitter.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=tTypeOpt ng-model=twitter.tType value=username><label></label>{{\'cl.widget.twitter.4\' | translate}}</label><label class=noMarB><input type=radio role=radio name=tTypeOpt ng-model=twitter.tType value=hashtag><label></label>{{\'cl.widget.cm.21\' | translate}}</label></div></div><div class=form-group ng-if=\"twitter.tType == \'hashtag\'\"><label for=twitter>{{twitter.tType == \'hashtag\'?\'cl.widget.twitter.5\':\'cl.widget.twitter.5.1\' | translate}}</label><input type=text id=twitter class=form-control ng-model=twitter.twitter maxlength={{inputLimit}} aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=col-xs-5><div class=form-group><label for=post>{{\'cl.widget.instagram.6\' | translate}}</label><select id=post class=form-control ng-options=\"p for p in postList track by p\" ng-model=twitter.post aria-label=\"{{\'cl.widget.instagram.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.instagram.6\' | translate}}\"></select></div></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=twitter.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=twitter.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"twitter.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=twitter.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=twitter.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=twitter.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=twitter.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"twitter.settings.hTextOpt==\'c\'\"><div class=row><div class=col-xs-6><input type=text id=hText class=form-control ng-model=twitter.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div></div></div><div class=row ng-if=\"twitter.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':twitter.settings.headerBg, opacity:twitter.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{twitter.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.headerBg selected-type=twitter.ctype.headerBg is-alpha=true selected-alpha=twitter.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.headerText selected-type=twitter.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=twitter.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3 ng-if=\"twitter.settings.hTextOpt != \'n\'\"><label for=headerSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=headerSize class=form-control ng-model=twitter.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':twitter.settings.bg, opacity:twitter.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{twitter.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.bg selected-type=twitter.ctype.bg is-alpha=true selected-alpha=twitter.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=twitter.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div><div class=col-xs-3><label for=subtitleSize>{{\'cl.widget.oc.15\' | translate}}</label><input type=number id=subtitleSize class=form-control ng-model=twitter.settings.subtitleSize min=1 aria-label=\"{{\'cl.widget.oc.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oc.15\' | translate}}\"></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=twitter.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':twitter.settings.rowBg, opacity:twitter.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{twitter.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.rowBg selected-type=twitter.ctype.rowBg is-alpha=true selected-alpha=twitter.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':twitter.settings.altBg, opacity:twitter.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{twitter.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.altBg selected-type=twitter.ctype.altBg is-alpha=true selected-alpha=twitter.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.titleText selected-type=twitter.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.at><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.at=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.altTitleText selected-type=twitter.ctype.altTitleText ng-if=colorPicker.at></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.st><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.st=true\" readonly aria-label=\"{{\'cl.widget.cm.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.subtitleText selected-type=twitter.ctype.subtitleText ng-if=colorPicker.st></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.17.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ast><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.altSubtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.altSubtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ast=true\" readonly aria-label=\"{{\'cl.widget.cm.17.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.17.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.altSubtitleText selected-type=twitter.ctype.altSubtitleText ng-if=colorPicker.ast></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.descText selected-type=twitter.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':twitter.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"twitter.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=twitter.settings.altDescText selected-type=twitter.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=twitter.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-3><label for=altRowFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altRowFont class=form-control ng-model=twitter.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=twitter.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=twitter.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.twitter.7\' | translate}}</label><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-hide=otherUserAuth ng-if=twitter.isAuthorized>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button role=button ng-if=\"!twitter.isAuthorized || userAuth\" class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450,\'userAuth\');\">{{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button ng-if=twitter.isAuthorized ng-hide=otherUserAuth class=\"btn btn-default\" ng-click=\"openUrlFx(626, 450, \'otherUserAuth\');\">{{\'cl.widget.cm.25.2\'| translate}}</button></div><div class=\"msg-warning marTB10\" lang={{auth.lang}} ng-if=verifyBtn>{{\'cl.widget.twitter.m5\' | translate}}</div><button type=button role=button ng-if=verifyBtn ng-click=verifyAuth(); class=\"btn btn-default\" ng-disabled=authProcessing ng-cloak><span class=fa ng-class=\"authProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>{{\'ms.btn.5\' | translate}}</button></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=twitterFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"twitterFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.gc.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'sSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'tagId\'\" aria-live=polite role=status>{{twitter.tType == \'hashtag\'?\'cl.widget.twitter.m1\':\'cl.widget.twitter.m2\' | translate}}</div><div ng-if=\"errType==\'tagInvalid\'\" aria-live=polite role=status>{{\'cl.widget.twitter.m4\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/unisys.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.unisys.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.unisys.2\' | translate}} &nbsp; <span ng-if=unisys.label>[ {{unisys.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-10><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=unisys.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=row><div class=\"form-group col-xs-6\"><label for=env>{{\'cl.widget.unisys.12\' | translate}}</label><select id=env class=form-control ng-model=unisys.env ng-change=getLocationFx(unisys.env) aria-label=\"{{\'cl.widget.unisys.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.12\' | translate}}\"><option value=\"\" disabled>{{\'cl.widget.unisys.12.1\' | translate}}</option><option value=trd>{{\'cl.widget.unisys.12.2\' | translate}}</option><option value=trp>{{\'cl.widget.unisys.12.3\' | translate}}</option><option value=sd>{{\'cl.widget.unisys.12.4\' | translate}}</option><option value=sp>{{\'cl.widget.unisys.12.5\' | translate}}</option></select></div><div class=\"form-group col-xs-6\"><label for=location>{{\'cl.widget.unisys.16\' | translate}}</label><select id=location class=form-control ng-model=unisys.location ng-disabled=\"!unisys.env || envLoading\" ng-options=\"option.label for option in locationList track by option.id\" aria-label=\"{{\'cl.widget.unisys.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.16\' | translate}}\"><option value=\"\">{{\'cl.widget.unisys.16.1\' | translate}}</option></select></div></div></div><div class=col-xs-10><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=unisys.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=unisys.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"unisys.settings.rotationOpt == \'c\'\"><input type=number id=cRotation class=form-control ng-model=unisys.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.news.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.bg, opacity:unisys.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.bg selected-type=unisys.ctype.bg is-alpha=true selected-alpha=unisys.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.headerBg, opacity:unisys.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.headerBg selected-type=unisys.ctype.headerBg is-alpha=true selected-alpha=unisys.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.headerText selected-type=unisys.ctype.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=headerFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=headerFont class=form-control ng-model=unisys.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=unisys.settings.headerSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.unisys.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cHB><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.colHBg, opacity:unisys.settings.colHBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.colHBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cHB=true\" readonly aria-label=\"{{\'cl.widget.unisys.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.17\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.colHBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.colHBg selected-type=unisys.ctype.colHBg is-alpha=true selected-alpha=unisys.settings.colHBga ng-if=colorPicker.cHB></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.unisys.18\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cHT><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.colHText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.colHText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cHT=true\" readonly aria-label=\"{{\'cl.widget.unisys.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.18\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.colHText selected-type=unisys.ctype.colHText ng-if=colorPicker.cHT></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=colHFont>{{\'cl.widget.unisys.19\' | translate}}</label><select id=colHFont class=form-control ng-model=unisys.settings.colHFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.unisys.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.19\' | translate}}\"></select></div><div class=col-xs-3><label for=colHSize>{{\'cl.widget.unisys.20\' | translate}}</label><input type=number id=colHSize class=form-control ng-model=unisys.settings.colHSize min=1 aria-label=\"{{\'cl.widget.unisys.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.20\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.rowBg, opacity:unisys.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.rowBg selected-type=unisys.ctype.rowBg is-alpha=true selected-alpha=unisys.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.fs.7\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.rowText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.rowText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rt=true\" readonly aria-label=\"{{\'cl.widget.fs.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.7\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.rowText selected-type=unisys.ctype.rowText ng-if=colorPicker.rt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cl.widget.fs.8\' | translate}}</label><select id=rowFont class=form-control ng-model=unisys.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.8\' | translate}}\"></select></div><div class=col-xs-3><label for=rSize>{{\'cl.widget.cm.32\' | translate}}</label><input type=number id=rSize class=form-control ng-model=unisys.settings.rowSize min=1 aria-label=\"{{\'cl.widget.cm.32\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.32\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.altBg, opacity:unisys.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.altBg selected-type=unisys.ctype.altBg is-alpha=true selected-alpha=unisys.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.fs.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.art><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.altText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.altText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.art=true\" readonly aria-label=\"{{\'cl.widget.fs.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.altText selected-type=unisys.ctype.altText ng-if=colorPicker.art></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=altFont>{{\'cl.widget.fs.10\' | translate}}</label><select id=altFont class=form-control ng-model=unisys.settings.altFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.fs.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.fs.10\' | translate}}\"></select></div><div class=col-xs-3><label for=aSize>{{\'cl.widget.cm.33\' | translate}}</label><input type=number id=aSize class=form-control ng-model=unisys.settings.altSize min=1 aria-label=\"{{\'cl.widget.cm.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.33\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.unisys.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':unisys.settings.pagingBg, opacity:unisys.settings.pagingBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.pagingBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pb=true\" readonly aria-label=\"{{\'cl.widget.unisys.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.5\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{unisys.settings.pagingBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.pagingBg selected-type=unisys.ctype.pagingBg is-alpha=true selected-alpha=unisys.settings.pagingBga ng-if=colorPicker.pb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.unisys.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.paging}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.paging | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pc=true\" readonly aria-label=\"{{\'cl.widget.unisys.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.paging selected-type=unisys.ctype.paging ng-if=colorPicker.pc></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=pagingFont>{{\'cl.widget.unisys.7\' | translate}}</label><select id=pagingFont class=form-control ng-model=unisys.settings.pagingFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.unisys.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.7\' | translate}}\"></select></div><div class=col-xs-3><label for=pSize>{{\'cl.widget.unisys.8\' | translate}}</label><input type=number id=pSize class=form-control ng-model=unisys.settings.pagingSize min=1 aria-label=\"{{\'cl.widget.unisys.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.8\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.unisys.9\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ph><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':unisys.settings.pagingHighlight}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"unisys.settings.pagingHighlight | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ph=true\" readonly aria-label=\"{{\'cl.widget.unisys.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.9\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=unisys.settings.pagingHighlight selected-type=unisys.ctype.pagingHighlight ng-if=colorPicker.ph></ng-hub-color-picker></div></div></div><div class=\"col-xs-3 hide\"><label for=tokenType>{{\'cl.widget.unisys.10\' | translate}}</label><input type=text id=tokenType class=form-control ng-model=unisys.settings.tokenType aria-label=\"{{\'cl.widget.unisys.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.10\' | translate}}\"></div><div class=\"col-xs-6 hide\"><label for=token>{{\'cl.widget.unisys.11\' | translate}}</label><textarea type=text id=token class=form-control ng-model=unisys.settings.token aria-label=\"{{\'cl.widget.unisys.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.unisys.11\' | translate}}\"></textarea></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=unisys.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=unisys.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=unisysFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'url\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m1\' | translate}}</div><div ng-if=\"errType==\'no\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m2\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'rSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.17\' | translate}}</div><div ng-if=\"errType==\'aSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.18\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'pSize\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'env\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m4\' | translate}}</div><div ng-if=\"errType==\'laType\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m5\' | translate}}</div><div ng-if=\"errType==\'liType\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m6\' | translate}}</div><div ng-if=\"errType==\'location\'\" aria-live=polite role=status>{{\'cl.widget.unisys.m7\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/verkada.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.verkada.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.verkada.2\' | translate}} &nbsp; <span ng-if=wData.label uib-tooltip={{cam.location}} tooltip-append-to-body=true>[ {{wData.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><!-- widget name --><div><div class=col-xs-7><div class=form-group role=radiogroup aria-labelledby=radiogroup><div><label for=label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=wData.labelOpt value=a><label></label>{{\'cl.widget.verkada.3\' |translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=wData.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"wData.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=wData.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><!-- Start Camear list --><div class=form-group><label>{{\'cl.widget.verkada.7\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle id=symbol ng-click=\"searchList=\'\'\"><span ng-if=!wData.camera.cam_id>{{\'cl.widget.verkada.7.1\' | translate}}</span> <span ng-if=wData.camera.cam_id>{{wData.camera.name}} <span class=\"text-muted text-sm inline inline valign-middle\" uib-tooltip={{wData.camera.location}} tooltip-append-to-body=true>- ({{wData.camera.site}})</span> </span><span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchCamera.searchText sanitize-input maxlength=250 ng-change=searchFrmCameraList(searchCamera.searchText); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchCamera.searchText.length ng-click=\"searchCamera.searchText=\'\';searchFrmCameraList(searchCamera.searchText);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\" when-scrolled=loadMoreCameras()><li ng-repeat=\"cam in filteredSList = (cameraList | filter:searchList) | orderBy:\'name\'\" tabindex=$index><label class=lh-16><input id=vr-{{$index}} type=radio role=radio name=camOpt value=\"{{ cam }}\" ng-checked=\"cam.cam_id == wData.camera.cam_id\" ng-model=wData.camera ng-change=\"cameraThumbFx(); setStreamingOpt(); refinecameraobject()\" ng-disabled=\"cam.cam_id == wData.camera.cam_id\"><label></label><span class=\"fa fa-circle inline text-xs marLR5\" ng-class=\"cam.status == 1 ?\'d-online\':\'d-offline\'\"></span>{{cam.name}} <span class=\"text-muted text-sm inline valign-middle\" uib-tooltip={{cam.location}} tooltip-append-to-body=true>- ({{cam.site}})</span></label></li><div class=form-group ng-if=cameraListLoading><img alt=Loading src=assets/images/loading-xs.gif></div><!-- <div ng-class=\"{\'msg-warning\':!cameraListLoading}\" lang=\"{{auth.lang}}\" ng-hide=\"cameraListLoading\" ng-if=\"wData.next_page == null && filteredSList.length !=0\">\r\n                        <span ng-if=\"!cameraListLoading\">{{\'cl.widget.verkada.m1\'| translate}}</span>\r\n                      </div> --><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0 && !cameraListLoading\" translate=\"{{\'cl.widget.verkada.m9\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchCamera.searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\" searchCamera.searchText.length > 0 && filteredSList.length == 0 && !isSearching && !cameraListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchCamera.searchText)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><!-- Settings  --><div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div><!-- Rotation --><!-- <div class=\"form-group\">\r\n                  <label>{{\'cl.widget.verkada.4\' | translate}}</label>\r\n                  <div role=\"radiogroup\" aria-labelledby=\"radiogroup\">\r\n                    <label class=\"noMarB marR10\"><input type=\"radio\" role=\"radio\" ng-model=\"wData.settings.rotationOpt\" name=\"rotationOpt\" value=\"a\"><label></label> {{\'cl.widget.verkada.4.1\' | translate}}</label>\r\n                    <label class=\"noMarB\"><input type=\"radio\" role=\"radio\" ng-model=\"wData.settings.rotationOpt\" name=\"rotationOpt\" value=\"c\"><label></label> {{\'cl.widget.verkada.4.2\' | translate}}</label>\r\n                  </div>\r\n                  <div class=\"form-inline marT5\">\r\n                    <div class=\"input-group\" ng-if=\"wData.settings.rotationOpt == \'c\'\">\r\n                      <input type=\"number\" id=\"rotate\" class=\"form-control\" ng-model=\"wData.settings.rotate\" aria-labelledby=\"{{\'cl.widget.news.6\' | translate}}\">\r\n                      <div class=\"input-group-addon\">{{\'cm.label.27s\' | translate}}</div>\r\n                    </div>\r\n                  </div>\r\n                </div> --><!-- Resolution radio button --><div class=form-group><label>{{\'cl.widget.verkada.5\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=wData.settings.resolutioOpt name=resolutioOpt value=low_res><label></label>{{\'cl.widget.verkada.5.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=wData.settings.resolutioOpt name=resolutioOpt value=high_res><label></label>{{\'cl.widget.verkada.5.2\' | translate}} <span class=\"marL5 fa fa-info-circle text-dark\" uib-tooltip=\"{{ \'cl.widget.verkada.m8\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right></span></label></div></div><!-- Start and End Time--><div class=form-group><div><label for=label>{{\'cl.widget.verkada.6\' | translate}}</label></div><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input ng-disabled=\"wData.camera.cam_id && wData.camera.status !=1\" type=radio role=radio ng-model=wData.settings.streamingOpt name=streamingOpt value=l><label></label>{{\'cl.widget.verkada.6.1\' | translate}}</label><label class=noMarB><input ng-checked=\"wData.camera.status !=1\" type=radio role=radio ng-model=wData.settings.streamingOpt name=streamingOpt value=h><label></label>{{\'cl.widget.verkada.6.2\' | translate}}</label></div><div class=marT10 ng-if=\"wData.settings.streamingOpt == \'h\'\"><div class=row><div class=col-xs-6><div class=form-group><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input id=timerange type=daterange class=\"form-control picker\" ng-model=timeRangeSetting.date format=MM/DD/YYYY readonly aria-label=\"{{\'cm.label.9\' | translate}}\" aria-labelledby=\"{{\'cm.label.9\' | translate}}\" max-date={{maxDate}}></div></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=sdr uib-dropdown-toggle ng-value=\"timeRangeSetting.start_time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=timeRangeSetting.start_time hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"form-group timepicker\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" id=edr uib-dropdown-toggle ng-value=\"timeRangeSetting.end_time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=timeRangeSetting.end_time hour-step=1 minute-step=5></div></div></span></div></div></div></div></div></div></div></div></div><!-- Permissions --><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=wData.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=wData.activePeriod></ng-active-period></div></div></div><!-- Thumb --><div ng-if=\"wData.camera.cam_id!=\'\'\" class=col-xs-5><div class=thumb-highlight><div class=\"thumb marT15 ng-scope\"><img class=\"img-responsive center-block ng-scope\" alt=Loading src=assets/images/loading.gif ng-if=cameraThumbLoading> <img class=\"img-responsive center-block blackBdr ng-scope\" ng-if=\"!thumbSrc && !cameraThumbLoading \" ng-src=assets/images/default/na_c.png alt={{wData.camera.name}} src=assets/images/default/device_selected_8.png> <img class=\"img-responsive center-block blackBdr ng-scope\" ng-if=thumbSrc style=\"width:215px;height:135px;border:1px solid black\" ng-src=\"{{ thumbSrc }}\" alt=\"{{ wData.camera.name }}\" src=\"{{ thumbSrc }}\"></div><div class=marT5></div></div><div class=\"table no-th no-border ng-scope marT10\"><div class=\"row lh-16\" ng-repeat=\"(key, value) in camera\" ng-if=\"key != \'cam_id\' && key != \'site_id\' && key != \'src\'\"><div class=\"col-xs-4 text-ccase text-right\">{{ value.t | translate}}:</div><div class=\"col-xs-8 text-ccase text-bold\"><span ng-if=\"key == \'status\'\" class=deviceStatus ng-class=\"value.v == 1?\'online\':\'offline\'\"></span>{{ key == \'status\' ? (value.v == 1 ? \'cl.widget.verkada.6.1\':\'d.tool.2\' | translate) : value.v }}</div></div></div></div></div></div></div><!-- Footer --><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveFx(); ng-disabled=\"saveProcessing || detailLoading\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'camerDetail\'\">{{\'cl.widget.verkada.m2\' | translate}}</div><div ng-if=\"errType == \'timerange\'\">{{\'cl.widget.verkada.m3\' | translate}}</div><div ng-if=\"errType == \'negativeTimeRange\'\">{{\'cl.widget.verkada.m4\' | translate}}</div><div ng-if=\"errType == \'zeroTimerange\'\">{{\'cl.widget.verkada.m4\' | translate}}</div><div ng-if=\"errType == \'timeahed\'\">{{\'cl.widget.verkada.m5\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/vimeo.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.vimeo.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.vimeo.2\' | translate}} &nbsp; <span ng-if=vimeo.label>[ {{vimeo.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=vimeo.labelOpt value=a><label></label>{{\'cl.widget.vimeo.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=vimeo.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"vimeo.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=vimeo.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label for=playListId>{{\'cl.widget.youTube.4\' | translate}}</label><div class=form-group><input type=text id=playListId class=form-control ng-model=vimeo.playlistId focus-me=true aria-label=\"{{\'cl.widget.youTube.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.youTube.4\' | translate}}\"></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=vimeo.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=vimeo.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=vimeoFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'id\'\" aria-live=polite role=status>{{\'cl.widget.youTube.m1\' | translate}}</div><div ng-if=\"errType==\'invalid-id\'\" aria-live=polite role=status>{{\'cl.widget.youTube.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/weather.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.weather.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.weather.2\' | translate}} &nbsp; <span ng-if=weather.label>[ {{weather.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1, \'tabFx\');\"><span class=badge>1</span>{{\'cm.label.14\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=weatherFx(1);><span class=badge>2</span>{{\'cm.label.2s\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=spaceH></div><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=weather.labelOpt value=a><label></label>{{\'cl.widget.weather.6\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=weather.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"weather.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=weather.label focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><div><label>{{\'cm.label.45\' | translate}}</label></div><label class=marR10 ng-class=\"{\'noMarB\':weather.cityOpt == \'d\'}\"><input type=radio role=radio name=cityOpt ng-model=weather.cityOpt value=c><label></label>{{\'cl.widget.weather.10\' | translate}}</label><label ng-class=\"{\'noMarB\':weather.cityOpt == \'d\'}\"><input type=radio role=radio name=cityOpt ng-model=weather.cityOpt value=d><label></label>{{\'cl.widget.weather.11\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'cl.widget.weather.m2\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label><input type=text id=weatherCity class=form-control ng-if=\"weather.cityOpt == \'c\'\" placeholder=\"{{\'cl.widget.weather.ph\' | translate}}\" ng-model=weather.city uib-typeahead=\"city as city.label for city in getLocation($viewValue)\" typeahead-loading=loadingLocations typeahead-wait-ms=500 typeahead-no-results=noResults focus-me=true aria-label=\"{{\'cm.label.45\' | translate}}\" aria-labelledby=\"{{\'cm.label.45\' | translate}}\"></div><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}}</label><select id=lang class=form-control ng-model=weather.settings.lang aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=pt_BR>Portuguese / Brazil</option><option value=pt_PT>Portuguese / Portugal</option><option value=es_ES>Spanish / Spain</option><option value=de_DE>German / Germany</option><option value=pl_PL>Polish / Poland</option></select></div><div class=form-group><label>{{\'cl.widget.weather.8\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dUnitOpt ng-model=weather.settings.unit value=c><label></label>{{\'cl.widget.weather.8.1\' | translate:{deg: \"(&deg;C)\"} }}</label><label class=noMarB><input type=radio role=radio name=dUnitOpt ng-model=weather.settings.unit value=f><label></label>{{\'cl.widget.weather.8.2\' | translate:{deg: \"(&deg;F)\"} }}</label></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=weather.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=weather.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label for=forecast>{{\'cl.widget.cm.20\' | translate}}</label><select id=forecast class=form-control ng-model=weather.forecast focus-me=true ng-change=\"typeFx(\'f\');\" aria-label=\"{{\'cl.widget.cm.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.20\' | translate}}\"><option value=0>{{\'cl.widget.weather.3.1\' | translate}}</option><option value=1>{{\'cl.widget.weather.3.2\' | translate}}</option><option value=2>{{\'cl.widget.weather.3.3\' | translate}}</option></select></div></div><div class=col-xs-12><div class=form-group ng-if=\"weather.forecast != 0\"><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=weather.settings.orientation value=h ng-change=typeFx();><label></label>{{\'ms.label.10.2\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=weather.settings.orientation value=v ng-change=typeFx();><label></label>{{\'ms.label.10.1\' | translate}}</label></div></div><div class=form-group><label class=noMarB>{{\'cl.widget.weather.3\' | translate}}</label><span translate=\"{{\'cl.widget.weather.4\'}}\" translate-values=\"{ratio:\'<b>{{ratio}}</b>\'}\"></span></div><div class=spaceH></div><div ng-if=\"weather.forecast == \'0\'\"><label>{{\'cl.widget.cm.7\' | translate}}</label><div class=clear></div><div class=pull-left role=radiogroup aria-labelledby=radiogroup><label><img alt=weather1.png src=\"assets/images/widget/templates/weather1_{{weather.settings.lang.split(\'_\')[0]}}.png?{{curTS}}\"><div class=clear></div><input type=radio role=radio ng-model=weather.settings.template value=t1><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'1\'} }}</label></div><div class=\"pull-left marL10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=weather2.png src=assets/images/widget/templates/weather2.png?{{curTS}}><div class=clear></div><input type=radio role=radio ng-model=weather.settings.template value=t2><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'2\'} }}</label></div><div class=\"pull-left marL10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=weather3.png src=assets/images/widget/templates/weather3.png?{{curTS}}><div class=clear></div><input type=radio role=radio ng-model=weather.settings.template value=t3><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'3\'} }}</label></div><div class=\"pull-left marL10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=weather4.png src=\"assets/images/widget/templates/weather4_{{weather.settings.lang.split(\'_\')[0]}}.png?{{curTS}}\"><div class=clear></div><input type=radio role=radio ng-model=weather.settings.template value=t4><label></label>{{\'cl.widget.cm.8\' | translate:{count: \'4\'} }}</label></div></div></div><div class=col-xs-12 ng-if=\"weather.forecast != \'0\'\"><label>{{\'cl.widget.weather.5\' | translate}}</label><div ng-if=\"weather.forecast == \'1\'\"><img alt=forecast1.png src=\"assets/images/widget/templates/forecast_h1_{{weather.settings.lang.split(\'_\')[0]}}.png?{{curTS}}\" class=img-responsive ng-if=\"weather.settings.orientation == \'h\'\"> <img alt=forecast1.png src=\"assets/images/widget/templates/forecast_v1_{{weather.settings.lang.split(\'_\')[0]}}.png?{{curTS}}\" class=img-responsive ng-if=\"weather.settings.orientation == \'v\'\"></div><div ng-if=\"weather.forecast==\'2\'\"><img alt=forecast2.png src=\"assets/images/widget/templates/{{weather.settings.lang.split(\'_\')[0]}}/forecast_h2_{{weather.settings.wsu}}.png?{{curTS}}\" class=img-responsive ng-if=\"weather.settings.orientation == \'h\'\"> <img alt=forecast2.png src=\"assets/images/widget/templates/{{weather.settings.lang.split(\'_\')[0]}}/forecast_v2_{{weather.settings.wsu}}.png?{{curTS}}\" class=img-responsive ng-if=\"weather.settings.orientation == \'v\'\"></div></div><div class=\"col-xs-7 marT15\"><div class=\"form-group hide\"><label>{{\'cl.widget.weather.9\' | translate}}</label><div class=hide><label class=marR10><input type=radio role=radio name=imgTypeOpt ng-model=weather.settings.imgType value=static ng-change=imgTypeFx();><label></label>{{\'cl.widget.weather.9.1\' | translate}}</label><label><input type=radio role=radio name=imgTypeOpt ng-model=weather.settings.imgType value=animated ng-change=imgTypeFx();><label></label>{{\'cl.widget.weather.9.2\' | translate}}</label></div><div ng-if=\"weather.settings.imgType == \'static\'\"><div class=\"pull-left marR10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=Plain class=bg-black src=assets/images/widget/weather/plain.png><div class=clear></div><input type=radio role=radio name=staticOpt ng-model=weather.settings.imgSubType value=plain><label></label>{{\'cl.widget.weather.9.1.1\' | translate}}</label></div><div class=\"pull-left marR10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=Color-1 class=bg-black src=assets/images/widget/weather/color1.png><div class=clear></div><input type=radio role=radio name=staticOpt ng-model=weather.settings.imgSubType value=color1><label></label>{{\'cl.widget.weather.9.1.2\' | translate: {count:\"-1\"} }}</label></div><div class=pull-left role=radiogroup aria-labelledby=radiogroup><label><img alt=Color-2 class=bg-black src=assets/images/widget/weather/color2.png><div class=clear></div><input type=radio role=radio name=staticOpt ng-model=weather.settings.imgSubType value=color2><label></label>{{\'cl.widget.weather.9.1.2\' | translate: {count:\"-2\"} }}</label></div></div><div class=hide ng-if=\"weather.settings.imgType == \'animated\'\"><div class=\"pull-left marR10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=\"\" class=bg-black src=assets/images/widget/weather/outline.gif><div class=clear></div><input type=radio role=radio name=animatedOpt ng-model=weather.settings.imgSubType value=outline><label></label>{{\'cl.widget.weather.9.2.1\' | translate}}</label></div><div class=\"pull-left marR10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=\"\" class=bg-black src=assets/images/widget/weather/cutout.gif><div class=clear></div><input type=radio role=radio name=animatedOpt ng-model=weather.settings.imgSubType value=cutout><label></label>{{\'cl.widget.weather.9.2.2\' | translate}}</label></div><div class=\"pull-left marR10\" role=radiogroup aria-labelledby=radiogroup><label><img alt=\"\" class=bg-black src=assets/images/widget/weather/plain.gif><div class=clear></div><input type=radio role=radio name=animatedOpt ng-model=weather.settings.imgSubType value=plain><label></label>{{\'cl.widget.weather.9.1.1\' | translate}}</label></div><div class=pull-left role=radiogroup aria-labelledby=radiogroup><label><img alt=\"\" class=bg-black src=assets/images/widget/weather/color.gif><div class=clear></div><input type=radio role=radio name=animatedOpt ng-model=weather.settings.imgSubType value=color><label></label>{{\'cl.widget.weather.9.1.2\' | translate}}</label></div></div><div class=clearfix></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=row><div class=col-xs-6><label>{{\'cl.widget.cm.3\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.c><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':weather.settings.tint}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"weather.settings.tint | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.c=true\" readonly aria-label=\"{{\'cl.widget.cm.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.3\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=weather.settings.tint selected-type=weather.ctype.tint ng-if=colorPicker.c></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=weather.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=\"row marT15\" ng-if=\"weather.forecast == 2\"><div class=col-xs-6><label for=wsu>{{\'cl.widget.weather.12\' | translate}}</label><select id=wsu class=form-control ng-model=weather.settings.wsu aria-label=\"{{\'cl.widget.weather.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.weather.12\' | translate}}\"><option value=kh>{{\'cl.widget.weather.12.3\' | translate}}</option><option value=ms>{{\'cl.widget.weather.12.1\' | translate}}</option><option value=mh>{{\'cl.widget.weather.12.2\' | translate}}</option></select></div></div></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=weatherFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cm.label.2s\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"weatherFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'woeid\'\" aria-live=polite role=status>{{\'cl.widget.weather.m1\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/webCam.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wc.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wc.2\' | translate}} &nbsp; <span ng-if=webCam.label>[ {{webCam.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=webCam.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=col-xs-7><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen = settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=spaceH2></div><div class=\"row marB15\"><div class=col-xs-6><label for=fps>FPS</label><input type=number id=fps class=form-control ng-model=webCam.settings.fps min=0 aria-label=FPS aria-labelledby=FPS></div><div class=col-xs-6><label for=quality>{{\'cl.widget.wc.4\' | translate}}</label><input type=number id=quality class=form-control ng-model=webCam.settings.quality min=0 aria-label=\"{{\'cl.widget.wc.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wc.4\' | translate}}\"></div></div><div><label for=scaleToFill class=\"noMarB marR10\"><input type=checkbox id=scaleToFill ng-model=webCam.settings.fill role=checkbox><label></label>{{\'cl.widget.wc.5\' | translate}}</label></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=webCam.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=webCam.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webCamFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'all\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'quality\'\" aria-live=polite role=status>{{\'cl.widget.wc.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/webLogin.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wl.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wl.2\' | translate}} &nbsp; <span ng-if=webLogin.label>[ {{webLogin.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-8><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=webLogin.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=webLogin.url placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div class=row><div class=\"col-xs-6 form-group\"><label for=uVal>{{\'cl.widget.cm.28\' | translate}}</label><input type=text id=uVal class=form-control ng-model=webLogin.settings.uVal aria-label=\"{{\'cl.widget.cm.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.28\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.4\' | translate}}</label><label><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text class=form-control ng-model=webLogin.settings.uId aria-label=\"{{\'cl.widget.wl.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.4\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label for=pVal>{{\'cl.widget.wl.5\' | translate}}</label><input type=text id=pVal class=form-control ng-model=webLogin.settings.pVal aria-label=\"{{\'cl.widget.wl.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.5\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.6\' | translate}}</label><label><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text class=form-control ng-model=webLogin.settings.pId aria-label=\"{{\'cl.widget.wl.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.6\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.7\' | translate}}</label><label><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text class=form-control ng-model=webLogin.settings.submitId aria-label=\"{{\'cl.widget.wl.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.7\' | translate}}\"></div><div class=col-xs-6><div class=form-group><label for=delay>{{\'cl.widget.wl.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=delay class=form-control ng-model=webLogin.settings.delay min=1 aria-label=\"{{\'cl.widget.wl.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.8\' | translate}}\"></div></div></div><div class=form-group><label for=redirect>{{\'cl.widget.wl.9\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=redirect class=form-control ng-model=webLogin.settings.redirect placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.wl.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.9\' | translate}}\"></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"form-group noMarB\"><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webLogin.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webLogin.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"webLogin.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=webLogin.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=webLogin.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"tableCell bdrRd bdrRL8\"></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=webLogin.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webLoginFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'allFields\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/webLoginChrome.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wl.1.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wl.2.1\' | translate}} &nbsp; <span ng-if=webLogin.label>[ {{webLogin.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-8><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=webLogin.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=webLogin.url placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div class=row><div class=\"col-xs-6 form-group\"><label for=uVal>{{\'cl.widget.cm.28\' | translate}}</label><input type=text id=uVal class=form-control ng-model=webLogin.settings.uVal aria-label=\"{{\'cl.widget.cm.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.28\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.4\' | translate}}</label><label><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=uTypeOpt ng-model=webLogin.settings.uType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text id=uId class=form-control ng-model=webLogin.settings.uId aria-label=\"{{\'cl.widget.wl.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.4\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label for=pVal>{{\'cl.widget.wl.5\' | translate}}</label><input type=text id=pVal class=form-control ng-model=webLogin.settings.pVal aria-label=\"{{\'cl.widget.wl.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.5\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.6\' | translate}}</label><label><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=pTypeOpt ng-model=webLogin.settings.pType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text id=pId class=form-control ng-model=webLogin.settings.pId aria-label=\"{{\'cl.widget.wl.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.6\' | translate}}\"></div></div><div class=row><div class=\"col-xs-6 form-group\"><label class=\"bdrRd bdrRL8\">{{\'cl.widget.wl.7\' | translate}}</label><label><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=id><label></label>{{\'cm.label.80\' | translate}}</label><label class=\"marL5 marR5\"><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=name><label></label>{{\'cm.brief.1\' | translate}}</label><label><input type=radio role=radio name=submitTypeOpt ng-model=webLogin.settings.submitType value=class><label></label>{{\'cl.widget.wl.10\' | translate}}</label><input type=text id=submitId class=form-control ng-model=webLogin.settings.submitId aria-label=\"{{\'cl.widget.wl.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.7\' | translate}}\"></div><div class=col-xs-6><div class=form-group><label for=delay>{{\'cl.widget.wl.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.27s\' | translate}})</span></label><input type=number id=delay class=form-control ng-model=webLogin.settings.delay min=1 aria-label=\"{{\'cl.widget.wl.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.8\' | translate}}\"></div></div></div><div class=form-group><label for=redirect>{{\'cl.widget.wl.9\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><input type=text id=redirect class=form-control ng-model=webLogin.settings.redirect placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.wl.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wl.9\' | translate}}\"></div><div class=\"form-group marT5\"><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=marT5 ng-if=settingsOpen><div class=\"row marT15\"><div class=col-xs-6><div class=form-group><label for=reload>{{\'cl.widget.wp.3\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.26\' | translate}})</span></label><div class=input-group><input type=number id=reload class=form-control ng-model=webLogin.settings.reload min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=col-xs-6>&nbsp;</div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=webLogin.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"tableCell bdrRd bdrRL8\"></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=webLogin.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webLoginFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'allFields\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/webPage.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\" role=heading><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wp.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wp.2\' | translate}} &nbsp; <span ng-if=webPage.label>[ {{webPage.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-9><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=webPage.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=url>{{\'cl.widget.cm.10\' | translate}}</label><input type=text id=url class=form-control ng-model=webPage.url maxlength=1000 placeholder=\"{{\'cm.ph.3\' | translate}}: http://www.example.com\" aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"></div><div class=\"form-group marB10\"><label>{{\'ms.label.6.1\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webPage.ssType name=thumbOpt value=d><label></label>{{\'cm.label.90\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webPage.ssType name=thumbOpt value=g><label></label>{{\'cl.widget.queue.1b\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webPage.ssType name=thumbOpt value=s><label></label>{{\'cl.widget.iMenu.18\' | translate}}</label></div></div><div class=form-group ng-if=\"webPage.ssType == \'s\'\"><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!webPage.isHidden && (webPage.clImg.thumb || webPage.clImg.type == \'SharePointC\' || webPage.clImg.type == \'OneDriveC\' || webPage.clImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'t\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=webPage.clImg.thumb ng-href=\"{{cDetailBucket + webPage.clImg.thumb | secureThumb}}\" role=button data-access={{webPage.clImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(webPage.clImg.path + (webPage.clImg.path.length > 1 ? \' / \' : \' \') + webPage.clImg.label)}}\" ng-show=webPage.clImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + webPage.clImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"webPage.clImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"webPage.clImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"webPage.clImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=webPage.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-sm></div><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=\"selectContentOpen(\'t\');\">{{\'cm.label.30\' | translate | camelCase}}</button></div></div><div class=\"form-group marT5\"><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=form-group><label>{{\'cl.widget.wp.3\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webPage.settings.reloadOpt name=reloadOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webPage.settings.reloadOpt name=reloadOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"webPage.settings.reloadOpt == \'c\'\"><input type=number id=cReload class=form-control ng-model=webPage.settings.reload focus-me=true min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marB15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webPage.settings.bg, opacity:webPage.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webPage.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webPage.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webPage.settings.bg selected-type=webPage.settings.ctype.bg is-alpha=true selected-alpha=webPage.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=row><div class=col-xs-6><div class=row><div class=col-xs-6><div class=form-group><label for=left>{{\'fl.p_cfl.label.8\' | translate}}</label><input type=number id=left class=form-control ng-model=webPage.settings.x aria-label=\"{{\'fl.p_cfl.label.8\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.8\' | translate}}\"></div></div><div class=col-xs-6><div class=form-group><label for=top>{{\'fl.p_cfl.label.9\' | translate}}</label><input type=number id=top class=form-control ng-model=webPage.settings.y aria-label=\"{{\'fl.p_cfl.label.9\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.9\' | translate}}\"></div></div></div></div></div><div><label class=\"noMarB marR10\"><input type=checkbox ng-model=webPage.settings.scroll role=checkbox><label></label>{{\'cl.widget.wp.4\' | translate}}</label></div><div class=\"form-group marT15 marB0\"><label>{{\'cl.widget.wp.5\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webPage.settings.container name=container value=if><label></label>{{\'cl.widget.wp.5.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webPage.settings.container name=container value=wv><label></label>{{\'cl.widget.wp.5.2\' | translate}}<span ng-if=\"webPage.settings.container==\'wv\'\" class=\"fa fa-info-circle text-primary marL5\" uib-tooltip=\"{{\'cl.widget.wp.m6\' | translate}}\" tooltip-placement=top aria-hidden=true></span></label></div></div><div class=\"form-group marT15\" ng-if=\"webPage.settings.container == \'if\'\"><a class=text-underline role=link ng-if=webPage.url href=\"https://dev.lsquared.com/iframeTest/index.html?url={{webPage.url}}\" target=_blank>{{\'cl.widget.wp.7\' | translate}} <a class=text-underline role=link ng-if=!webPage.url href=https://dev.lsquared.com/iframeTest/index.html target=_blank>{{\'cl.widget.wp.7\' | translate}}</a></a></div><div class=\"row marT15 hide\"><div class=col-xs-12><label class=noMarB><input type=checkbox ng-model=webPage.settings.clickable.a role=checkbox><label></label>{{\'cl.widget.wp.6\' | translate}}</label></div></div><div class=\"row marT5\" ng-if=webPage.settings.clickable.a><div class=col-xs-3><label>{{\'cl.widget.wp.6.1\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"!webPage.isHidden && (webPage.fImg.thumb || webPage.fImg.type == \'SharePointC\' || webPage.fImg.type == \'OneDriveC\' || webPage.fImg.type == \'GoogleDriveC\')\"><a href=\"\" role=link class=thumb-close ng-click=\"removeImgFx(\'f\');\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a role=button ng-if=webPage.fImg.thumb ng-href=\"{{cDetailBucket + webPage.fImg.thumb | secureThumb}}\" data-access={{webPage.fImg.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(webPage.fImg.path + (webPage.fImg.path.length > 1 ? \' / \' : \' \') + webPage.fImg.label)}}\" ng-show=webPage.fImg.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + webPage.fImg.thumb + inputImgThumbParam}}\"> </a><img alt=\"\" ng-if=\"webPage.fImg.type == \'SharePointC\'\" src=assets/images/default/thumbs/xs/sp.png> <img alt=\"\" ng-if=\"webPage.fImg.type == \'OneDriveC\'\" src=assets/images/default/thumbs/xs/od.png> <img alt=\"\" ng-if=\"webPage.fImg.type == \'GoogleDriveC\'\" src=assets/images/default/thumbs/xs/gd.png></div><div class=\"pull-left relative\" ng-if=webPage.isHidden><img alt=\"\" uib-tooltip=\"{{\'cl.widget.webPage.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-src=assets/images/default/unknown.png class=emptyThumb-sm></div><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate}}</button></div></div><div class=col-xs-3><label>{{\'cl.widget.wp.6.2\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webPage.settings.clickable.t name=target value=fs><label></label>{{\'cl.widget.wp.6.2.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webPage.settings.clickable.t name=target value=s><label></label>{{\'cl.widget.wp.6.2.2\' | translate}}</label></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=webPage.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=webPage.activePeriod></ng-active-period></div></div></div><div class=col-xs-3 ng-if=\"(webPage.ssType == \'g\' && webPage.ss) || (webPage.ssType == \'s\' && webPage.ss && !webPage.isHidden)\"><label>{{\'cl.widget.ss.7\' | translate}}</label><div class=\"pad5 bg-light text-center\"><a href=\"\" role=link ng-href=\"{{cDetailBucket + webPage.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{webPage.label}}><img alt=Preview ng-src=\"{{thumbHost + tim + cBucket + webPage.ssImg+\'&v\'+timestamp + thumbBigParam}}\"></a></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webPageFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'permission\'\">{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'clImg\'\">{{\'cl.widget.msg.29\' | translate}}</div><div ng-if=\"errType == \'url\'\">{{\'cl.widget.msg.3\' | translate}}</div><div ng-if=\"errType == \'name\'\">{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'fImg\'\">{{\'cl.widget.wp.m3\' | translate}}</div><div ng-if=\"errType == \'reload\'\">{{\'cl.widget.wp.m1\' | translate}}</div><div ng-if=\"errType == \'left\'\">{{\'cl.widget.wp.m4\' | translate}}</div><div ng-if=\"errType == \'top\'\">{{\'cl.widget.wp.m5\' | translate}}</div><div ng-if=\"errType == \'reloadEmpty\'\">{{\'cl.widget.pw.m7\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\">{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/webex.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.webex.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.webex.2\' | translate}} &nbsp; <span ng-if=webex.label>[ {{webex.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=webexFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=webex.labelOpt value=a><label></label>{{\'cl.widget.tChannel.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=webex.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"webex.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=webex.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><!-- Dev --><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=webex.dType ng-change=\"changeDType(\'normal\')\" value=normal><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=dTypeOpt ng-model=webex.dType ng-change=\"changeDType(\'crawl\')\" value=crawl><label></label>{{\'cl.widget.cm.23\' | translate}}</label></div></div><!-- Dev --><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><!-- <div>\r\n              <div class=\"form-group\">\r\n                <label>{{\'cl.widget.webex.6\' | translate}}</label>\r\n                <div role=\"radiogroup\" aria-labelledby=\"radiogroup\">\r\n                  <label class=\"noMarB marR10\"><input type=\"radio\" role=\"radio\" ng-model=\"webex.settings.rotationOpt\" name=\"rotationOpt\" value=\"a\"><label></label> {{\'cl.widget.webex.6.1\' | translate}}</label>\r\n                  <label class=\"noMarB\"><input type=\"radio\" role=\"radio\" ng-model=\"webex.settings.rotationOpt\" name=\"rotationOpt\" value=\"c\"><label></label> {{\'cm.label.17\' | translate}}</label>\r\n                </div>\r\n                <div class=\"form-inline marT5\">\r\n                  <div class=\"input-group\" ng-if=\"webex.settings.rotationOpt == \'c\'\">\r\n                    <input type=\"number\" class=\"form-control\" ng-model=\"webex.settings.rotate\" focus-me=\"true\" min=\"1\">\r\n                    <div class=\"input-group-addon\">{{\'cm.label.27s\' | translate}}</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cm.label.87\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.b\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span class=\"trBg\"><span ng-style=\"{\'background-color\':webex.settings.bg, opacity:webex.settings.bga}\"></span></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"webex.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly=\"\">\r\n                      <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=\"true\">{{webex.settings.bga}}</span>\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"webex.settings.bg\" selected-type=\"webex.ctype.bg\" is-alpha=\"true\" selected-alpha=\"webex.settings.bga\" ng-if=\"colorPicker.b\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.sc.8\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.rb\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span class=\"trBg\"><span ng-style=\"{\'background-color\':webex.settings.textBg, opacity:webex.settings.textBga}\"></span></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"webex.settings.textBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly=\"\">\r\n                      <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=\"true\">{{webex.settings.textBga}}</span>\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"webex.settings.textBg\" selected-type=\"webex.ctype.textBg\" is-alpha=\"true\" selected-alpha=\"webex.settings.textBga\" ng-if=\"colorPicker.rb\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.sc.9\' | translate}}</label>\r\n                  <select class=\"form-control\" ng-model=\"webex.settings.align\">\r\n                    <option value=\"l\">{{\'cm.editor.10.4\' | translate}}</option>\r\n                    <option value=\"c\">{{\'cm.editor.10.5\' | translate}}</option>\r\n                    <option value=\"r\">{{\'cm.editor.10.6\' | translate}}</option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"row marT15\">\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.cm.16\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.tt\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':webex.settings.titleText}\"></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"webex.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly=\"\">\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"webex.settings.titleText\" selected-type=\"webex.ctype.titleText\" ng-if=\"colorPicker.tt\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.cm.16.3\' | translate}}</label>\r\n                  <input type=\"number\" class=\"form-control\" ng-model=\"webex.settings.titleSize\" min=\"1\">\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.cm.16.2\' | translate}}</label>\r\n                  <select class=\"form-control\" ng-model=\"webex.settings.titleFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"row marT15\">\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.twitter.6\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.dt\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':webex.settings.descText}\"></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"webex.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly=\"\">\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"webex.settings.descText\" selected-type=\"webex.ctype.descText\" ng-if=\"colorPicker.dt\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.cm.42\' | translate}}</label>\r\n                  <input type=\"number\" class=\"form-control\" ng-model=\"webex.settings.descSize\" min=\"1\">\r\n                </div>\r\n                <div class=\"col-xs-4\">\r\n                  <label>{{\'cl.widget.survey.8\' | translate}}</label>\r\n                  <select class=\"form-control\" ng-model=\"webex.settings.descFont\" ng-options=\"font.label for font in fontFamily track by font.value\"></select>\r\n                </div>\r\n              </div>\r\n            </div> --><div ng-if=\"webex.dType == \'normal\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webex.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webex.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"webex.settings.rotationOpt == \'c\'\"><input type=number id=cRotate class=form-control ng-model=webex.settings.rotate focus-me=true min=1 aria-label=\"{{\'cl.widget.webex.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.webex.6\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webex.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=webex.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=webex.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"webex.settings.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=webex.settings.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"webex.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.headerBg, opacity:webex.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.headerBg selected-type=webex.ctype.headerBg is-alpha=true selected-alpha=webex.settings.headerBga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><!-- <div class=\"col-xs-3\">\r\n                  <label>{{\'cl.widget.cm.12\' | translate}}</label>\r\n                  <div uib-dropdown auto-close=\"outsideClick\" dropdown-append-to-body is-open=\"colorPicker.ht\">\r\n                    <div class=\"input-group input-colorPicker\">\r\n                      <span class=\"input-group-addon\"><span ng-style=\"{\'background-color\':webex.settings.headerText}\"></span></span>\r\n                      <input type=\"text\" class=\"form-control picker\" ng-value=\"webex.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly=\"\" aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\">\r\n                    </div>\r\n                    <div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu>\r\n                      <img alt=\"Loading\" src=\"assets/images/loading-xs.gif\" ng-if=\"colorPickerOpen\">\r\n                      <ng-hub-color-picker selected-color=\"webex.settings.headerText\" selected-type=\"webex.ctype.headerText\" ng-if=\"colorPicker.ht\"></ng-hub-color-picker>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <label for=\"headerFont\">{{\'cl.widget.cm.13\' | translate}}</label>\r\n                  <select id=\"headerFont\" class=\"form-control\" ng-model=\"webex.settings.headerFont\" ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select>\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <label for=\"headerSize\">{{\'cl.widget.cm.31\' | translate}}</label>\r\n                  <input type=\"number\" id=\"headerSize\" class=\"form-control\" ng-model=\"webex.settings.headerSize\" min=\"1\" aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\">\r\n                </div> --><div class=col-xs-3><label>{{\'cl.widget.cm.77\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.htt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.hTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.hTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.htt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.hTitleText selected-type=webex.ctype.hTitleText ng-if=colorPicker.htt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=hTitleFont>{{\'cl.widget.cm.78\' | translate}}</label><select id=hTitleFont class=form-control ng-model=webex.settings.hTitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=hTitleSize>{{\'cl.widget.cm.79\' | translate}}</label><input type=number id=hTitleSize class=form-control ng-model=webex.settings.hTitleSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"webex.settings.hTextOpt!=\'n\'\"><div class=col-xs-3><label>{{\'cl.widget.cm.80\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hst><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.hSubTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.hSubTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hst=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.hSubTitleText selected-type=webex.ctype.hSubTitleText ng-if=colorPicker.hst></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=hSubTitleFont>{{\'cl.widget.cm.81\' | translate}}</label><select id=hSubTitleFont class=form-control ng-model=webex.settings.hSubTitleFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=hSubTitleSize>{{\'cl.widget.cm.82\' | translate}}</label><input type=number id=hSubTitleSize class=form-control ng-model=webex.settings.hSubTitleSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.bg, opacity:webex.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.bg selected-type=webex.ctype.bg is-alpha=true selected-alpha=webex.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.rowBg, opacity:webex.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.rowBg selected-type=webex.ctype.rowBg is-alpha=true selected-alpha=webex.settings.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.altBg, opacity:webex.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.altBg selected-type=webex.ctype.altBg is-alpha=true selected-alpha=webex.settings.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=rowFont>{{\'cl.widget.cm.39\' | translate}}</label><select id=rowFont class=form-control ng-model=webex.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-3><label for=altRowFont>{{\'cm.label.24.1\' | translate}}</label><select id=altRowFont class=form-control ng-model=webex.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24.1\' | translate}}\" aria-labelledby=\"{{\'cm.label.24.1\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tt=true\" readonly aria-label=\"{{\'cl.widget.cm.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.titleText selected-type=webex.ctype.titleText ng-if=colorPicker.tt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.att><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.att=true\" readonly aria-label=\"{{\'cl.widget.cm.16.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.altTitleText selected-type=webex.ctype.altTitleText ng-if=colorPicker.att></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=titleSize>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number id=titleSize class=form-control ng-model=webex.settings.titleSize min=1 aria-label=\"{{\'cl.widget.cm.16.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.16.3\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.dt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.dt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.descText selected-type=webex.ctype.descText ng-if=colorPicker.dt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.adt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.adt=true\" readonly aria-label=\"{{\'cl.widget.twitter.6.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.twitter.6.1\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.altDescText selected-type=webex.ctype.altDescText ng-if=colorPicker.adt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=descSize>{{\'cl.widget.cm.42\' | translate}}</label><input type=number id=descSize class=form-control ng-model=webex.settings.descSize min=1 aria-label=\"{{\'cl.widget.cm.42\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.42\' | translate}}\"></div></div><!-- Profile --><div class=\"row marT15\"><div class=col-xs-3><label>{{\'cl.widget.cm.73\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.profileBg, opacity:webex.settings.profileBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.profileBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.profileBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.profileBg selected-type=webex.ctype.profileBg is-alpha=true selected-alpha=webex.settings.profileBga ng-if=colorPicker.pb></ng-hub-color-picker></div></div></div><div class=col-xs-3><label>{{\'cl.widget.cm.74\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.pt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.profileText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.profileText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.pt=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.profileText selected-type=webex.ctype.profileText ng-if=colorPicker.pt></ng-hub-color-picker></div></div></div><div class=col-xs-3><label for=profileFont>{{\'cl.widget.cm.75\' | translate}}</label><select id=profileFont class=form-control ng-model=webex.settings.profileFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-3><label for=profileSize>{{\'cl.widget.cm.76\' | translate}}</label><input type=number id=profileSize class=form-control ng-model=webex.settings.profileSize min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div></div><!-- Dev --><div ng-if=\"webex.dType == \'crawl\'\"><div class=row><div class=col-xs-6><label>{{\'cl.widget.text.4\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=dOpt ng-model=webex.settings.dir value=rl><label></label>{{\'cl.widget.text.5\' | translate}}</label><label><input type=radio role=radio name=dOpt ng-model=webex.settings.dir value=bt ng-change=directionFx()><label></label>{{\'cl.widget.text.6\' | translate}}</label></div></div><div class=col-xs-6 ng-if=\"webex.settings.dir == \'bt\'\"><label>{{\'cl.widget.text.11\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label><input type=radio role=radio name=aOpt ng-model=webex.settings.align value=l><label></label>{{\'cm.editor.10.4\' | translate}}</label><label class=\"marL10 marR10\"><input type=radio role=radio name=aOpt ng-model=webex.settings.align value=c><label></label>{{\'cm.editor.10.5\' | translate}}</label><label><input type=radio role=radio name=aOpt ng-model=webex.settings.align value=r><label></label>{{\'cm.editor.10.6\' | translate}}</label></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=speed>{{\'cl.widget.cm.18\' | translate}} <span class=\"text-muted text-sm\">({{\'cl.widget.cm.18.2\' | translate}})</span></label><input type=number id=speed class=form-control ng-model=webex.settings.speed min=1 aria-label=\"{{\'cl.widget.cm.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.18\' | translate}}\"></div><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':webex.settings.bg, opacity:webex.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{webex.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.bg selected-type=webex.ctype.bg is-alpha=true selected-alpha=webex.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"webex.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.34\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.bullet}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.bullet | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bc=true\" readonly aria-label=\"{{\'cl.widget.cm.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.34\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.bullet selected-type=webex.ctype.bullet ng-if=colorPicker.bc></ng-hub-color-picker></div></div></div><div class=col-xs-4 ng-if=\"webex.settings.dir == \'bt\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.titleText selected-type=webex.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4 ng-if=\"webex.settings.dir == \'rl\'\"><label>{{\'cl.widget.cm.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':webex.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"webex.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.cm.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=webex.settings.titleText selected-type=webex.ctype.titleText ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=font>{{\'cm.label.24\' | translate}}</label><select id=font class=form-control ng-model=webex.settings.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-4 ng-if=\"webex.settings.dir == \'bt\'\"><label for=btFontSize>{{\'cl.widget.cm.26\' | translate}}</label><input type=number id=btFontSize class=form-control ng-model=webex.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"webex.settings.dir == \'rl\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.26\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=fsOpt ng-model=webex.settings.fontSizeOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label><input type=radio role=radio name=fsOpt ng-model=webex.settings.fontSizeOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label></div><div ng-if=\"webex.settings.fontSizeOpt == \'c\'\"><input type=number id=rlFontSize class=form-control ng-model=webex.settings.fontSize min=1 aria-label=\"{{\'cl.widget.cm.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.26\' | translate}}\"></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=webex.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=webex.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.webex.5\' | translate}}</label><div class=\"msg-warning marB10\" ng-if=webex.isAuth>{{authSuccess?\'cl.widget.msg.10\':\'cl.widget.msg.10.1\' | translate}}</div><div><button type=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'at\');\" ng-if=!teamsShow ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-success\" ng-click=\"reAuthOpen(\'re\');\" ng-if=teamsShow>{{teamsShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> <button type=button class=\"btn btn-default hide\" ng-click=\"reAuthOpen(\'ou\');\" ng-if=teamsShow>{{\'cl.widget.cm.25.2\' | translate}}</button></div></div><div class=\"form-group lsn-select\" ng-if=\"teamsShow && showTeamsList\"><label for=team>{{\'cl.widget.tChannel.4\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=ss.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=teamsSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.5.1\' | translate}}\">{{webex.teams.name}} <span ng-if=\"webex.teams == \'\'\">{{\'cl.widget.tChannel.4.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=teamsList.length><li class=\"dropdown-header noMar\" ng-if=\"teamsList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchTeams.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTeams.name.length ng-click=\"searchTeams.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"teamsList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"team in teams = (teamsList | filter:{name:searchTeams.name})\" tabindex=$index ng-class=\"{\'selected disabled\': webex.teams.id == team.id}\"><label ng-model=team.selected ng-click=selTeamsFx(team);><label></label>{{team.name}}</label></li><div class=msg-warning ng-if=\"teams.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTeams.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><img ng-if=spaceLoading class=marB15 alt=Loading src=assets\\images\\loading.gif><div class=\"form-group lsn-select\" ng-if=\"teamsShow && showTeamsList && showSpaceList && !spaceLoading\"><label for=space>{{\'cl.widget.webex.7\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick is-open=sp.isOpen on-toggle=toggleCallback(open)><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=spaceSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.6.1\' | translate}}\">{{webex.space.title}} <span ng-if=\"webex.space == \'\'\">{{\'cl.widget.webex.7.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=spaceList.length><li class=\"dropdown-header noMar\" ng-if=\"spaceList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchSpace.name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchSpace.name.length ng-click=\"searchSpace.name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"spaceList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"space in spaces = (spaceList | filter: { title: searchSpace.name })\" tabindex=$index ng-class=\"{\'selected disabled\': webex.space.id == space.id}\"><label ng-model=webex.selected ng-click=selSpaceFx(space);><label></label>{{space.title}}</label></li><div class=msg-warning ng-if=\"spaces.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchSpace.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><div class=msg-warning>{{\'cl.widget.webex.m5\' | translate}}</div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=webexFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"webexFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing || authSaveDisable\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType == \'space\'\" aria-live=polite role=status>{{\'cl.widget.webex.m3\' | translate}}</div><div ng-if=\"errType == \'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType == \'pSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.35\' | translate}}</div><div ng-if=\"errType == \'htSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.36\' | translate}}</div><div ng-if=\"errType == \'hstSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.37\' | translate}}</div><div ng-if=\"errType == \'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType == \'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType == \'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType == \'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType == \'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType == \'sSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType == \'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType == \'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType == \'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType == \'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.webex.m2\' | translate}}</div><div ng-if=\"errType == \'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType == \'teamsEmpty\'\" aria-live=polite role=status>{{\'cl.widget.webex.m1\' | translate}}</div><div ng-if=\"errType == \'invalid\'\" aria-live=polite role=status>{{\'cm.msg.45\' | translate}}</div><div ng-if=\"errType == \'allEmpty\'\" aria-live=polite role=status>{{\'cm.msg.5\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'crawl\'\" aria-live=polite role=status>{{\'cl.widget.msg.5\' | translate}}</div><div ng-if=\"errType==\'fSizeText\'\" aria-live=polite role=status>{{\'cl.widget.text.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/wqMetro.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.wqMetro.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.wqMetro.2\' | translate}} &nbsp; <span ng-if=metro.label>[ {{metro.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=metro.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div><div class=form-group><label for=storeId>{{\'cl.widget.wqMetro.3\' | translate}}</label><input type=text id=storeId class=form-control ng-model=metro.storeId aria-label=\"{{\'cl.widget.wqMetro.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wqMetro.3\' | translate}}\"></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=metro.dType value=q><label></label>{{\'cl.widget.wqMetro.7\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio name=dTypeOpt ng-model=metro.dType value=t><label></label>{{\'cl.widget.wqMetro.8\' | translate}}</label><label class=\"noMarB hide\"><input type=radio role=radio name=dTypeOpt ng-model=metro.dType value=b><label></label>{{\'cl.widget.wqMetro.9\' | translate}}</label></div></div></div><div class=col-xs-8><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen = settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=spaceH2></div><div ng-if=\"metro.dType == \'q\' || metro.dType == \'b\'\"><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsQ.header.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsQ.header.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"settingsQ.header.hTextOpt==\'c\'\"><input type=text id=hText class=form-control ng-model=settingsQ.header.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=\"row marT15\" ng-if=\"settingsQ.header.hTextOpt == \'c\'\"><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.header.bg, opacity:settingsQ.header.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.header.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.header.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.header.bg selected-type=ctypeQ.headerBg is-alpha=true selected-alpha=settingsQ.header.bga ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.header.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.header.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.header.text selected-type=ctypeQ.headerText ng-if=colorPicker.b></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\" ng-if=\"settingsQ.header.hTextOpt == \'c\'\"><div class=col-xs-6><label for=hFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=hFont class=form-control ng-model=settingsQ.header.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-6><label for=hSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=hSize class=form-control ng-model=settingsQ.header.size></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.bg, opacity:settingsQ.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.bg selected-type=ctypeQ.bg is-alpha=true selected-alpha=settingsQ.bga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=reload>{{\'cl.widget.wp.3\' | translate}}</label><div class=input-group><input type=number id=reload class=form-control ng-model=settingsQ.reload min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.rowBg, opacity:settingsQ.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rb=true\" readonly aria-label=\"{{\'cl.widget.cm.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.14\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.rowBg selected-type=ctypeQ.rowBg is-alpha=true selected-alpha=settingsQ.rowBga ng-if=colorPicker.rb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.arb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.altBg, opacity:settingsQ.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.arb=true\" readonly aria-label=\"{{\'cl.widget.cm.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.15\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.altBg selected-type=ctypeQ.altBg is-alpha=true selected-alpha=settingsQ.altBga ng-if=colorPicker.arb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.pw.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsQ.numberBg, opacity:settingsQ.numberBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.numberBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nb=true\" readonly aria-label=\"{{\'cl.widget.pw.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.4\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsQ.numberBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.numberBg selected-type=ctypeQ.numberBg is-alpha=true selected-alpha=settingsQ.numberBga ng-if=colorPicker.nb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.pw.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.nt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.numberText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.numberText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.nt=true\" readonly aria-label=\"{{\'cl.widget.pw.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.numberText selected-type=ctypeQ.numberText ng-if=colorPicker.nt></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=nFont>{{\'cl.widget.pw.6\' | translate}}</label><select id=nFont class=form-control ng-model=settingsQ.numberFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.pw.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.6\' | translate}}\"></select></div><div class=col-xs-6><label for=nSize>{{\'cl.widget.pw.7\' | translate}}</label><input type=number id=nSize class=form-control ng-model=settingsQ.numberSize aria-label=\"{{\'cl.widget.pw.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.pw.7\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cl.widget.wqMetro.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.cText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.cText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ct=true\" readonly aria-label=\"{{\'cl.widget.wqMetro.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wqMetro.4\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.cText selected-type=ctypeQ.cText ng-if=colorPicker.ct></ng-hub-color-picker></div></div></div><div class=col-xs-6><label for=cFont>{{\'cl.widget.wqMetro.5\' | translate}}</label><select id=cFont class=form-control ng-model=settingsQ.cFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.wqMetro.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wqMetro.5\' | translate}}\"></select></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=cSize>{{\'cl.widget.wqMetro.6\' | translate}}</label><input type=number id=cSize class=form-control ng-model=settingsQ.cSize min=1 aria-label=\"{{\'cl.widget.wqMetro.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wqMetro.6\' | translate}}\"></div><div class=col-xs-6 ng-if=\"metro.dType == \'b\'\"><label>{{\'cl.widget.dt.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.tc><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsQ.timeText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsQ.timeText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.tc=true\" readonly aria-label=\"{{\'cl.widget.dt.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.dt.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsQ.timeText selected-type=ctypeQ.time ng-if=colorPicker.tc></ng-hub-color-picker></div></div></div></div></div><div ng-if=\"metro.dType == \'t\'\"><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=settingsT.header.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=settingsT.header.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"settingsT.header.hTextOpt==\'c\'\"><input type=text id=thText class=form-control ng-model=settingsT.header.hText maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div></div><div class=row ng-if=\"settingsT.header.hTextOpt == \'c\'\"><div class=col-xs-6><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.hb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsT.header.bg, opacity:settingsT.header.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsT.header.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.hb=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsT.header.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsT.header.bg selected-type=ctypeT.headerBg is-alpha=true selected-alpha=settingsT.header.bga ng-if=colorPicker.hb></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ht><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsT.header.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsT.header.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ht=true\" readonly aria-label=\"{{\'cl.widget.cm.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsT.header.text selected-type=ctypeT.headerText ng-if=colorPicker.ht></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\" ng-if=\"settingsT.header.hTextOpt == \'c\'\"><div class=col-xs-6><label for=thFont>{{\'cl.widget.cm.13\' | translate}}</label><select id=thFont class=form-control ng-model=settingsT.header.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.cm.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.13\' | translate}}\"></select></div><div class=col-xs-6><label for=thSize>{{\'cl.widget.cm.31\' | translate}}</label><input type=number id=thSize class=form-control ng-model=settingsT.header.size min=1 aria-label=\"{{\'cl.widget.cm.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':settingsT.bg, opacity:settingsT.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsT.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly aria-label=\"{{\'cm.label.87\' | translate}}\" aria-labelledby=\"{{\'cm.label.87\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{settingsT.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsT.bg selected-type=ctypeT.bg is-alpha=true selected-alpha=settingsT.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-6><label>{{\'cm.label.64\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.t><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':settingsT.text}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"settingsT.text | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.t=true\" readonly aria-label=\"{{\'cm.label.64\' | translate}}\" aria-labelledby=\"{{\'cm.label.64\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=settingsT.text selected-type=ctypeT.text ng-if=colorPicker.t></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=tFont>{{\'cm.label.24\' | translate}}</label><select id=tFont class=form-control ng-model=settingsT.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div><div class=col-xs-6><label for=tSize>{{\'cm.label.83\' | translate}}</label><input type=number id=tSize class=form-control ng-model=settingsT.size min=1 aria-label=\"{{\'cm.label.83\' | translate}}\" aria-labelledby=\"{{\'cm.label.83\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=tReload>{{\'cl.widget.wp.3\' | translate}}</label><div class=input-group><input type=number id=tReload class=form-control ng-model=settingsT.reload min=1 aria-label=\"{{\'cl.widget.wp.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.wp.3\' | translate}}\"><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=metro.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=metro.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=metroFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'store\'\" aria-live=polite role=status>{{\'cl.widget.wqMetro.m1\' | translate}}</div><div ng-if=\"errType==\'cSize\'\" aria-live=polite role=status>{{\'cl.widget.wqMetro.m2\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'nSize\'\" aria-live=polite role=status>{{\'cl.widget.pw.m4\' | translate}}</div><div ng-if=\"errType==\'hText\'\" aria-live=polite role=status>{{\'cl.widget.msg.9\' | translate}}</div><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'size\'\" aria-live=polite role=status>{{\'cl.widget.pw.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/xovis.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.xovis.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.xovis.2\' | translate}} &nbsp; <span ng-if=xovis.label>[ {{xovis.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=xovisFx(1);><span class=badge>2</span>{{\'cl.widget.cm.10\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=col-xs-7><div class=form-group><label for=label>{{\'cl.label.1\' | translate}}</label><input type=text id=label class=form-control ng-model=xovis.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=clearfix></div><div class=col-xs-4><div class=form-group><label for=dType>{{\'cm.label.69\' | translate}}</label><select class=form-control id=dType ng-model=xovis.dType aria-label=\"{{\'cm.label.69\' | translate}}\" aria-labelledby=\"{{\'cm.label.69\' | translate}}\"><option value=ec>{{\'Enter/Exit Count\' | translate}}</option><option value=pa>{{\'People in Area\' | translate}}</option><option value=fd>{{\'6 Feet Distance\' | translate}}</option></select></div></div><div class=col-xs-3><div class=form-group><label for=mo>{{\'cl.widget.xovis.3\' | translate}}</label><input type=number id=mo class=form-control ng-model=xovis.mo min=1 aria-label=\"{{\'cl.widget.xovis.3\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.3\' | translate}}\"></div></div><div class=clearfix></div><div class=col-xs-3 ng-if=decId><div class=form-group><button type=button role=button class=\"btn btn-primary marT5\" ng-click=resetOpen();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cl.widget.xovis.36\' | translate}}</button></div></div><div class=col-xs-10 ng-if=\"xovis.dType != \'pa\'\"><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault(); ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><!-- Enter/exit Count --><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=\"settingsOpen && xovis.dType==\'ec\'\"><div class=row><div class=col-xs-4><label>{{\'cl.widget.xovis.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ecb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':xovis.settings.ec.bg, opacity:xovis.settings.ec.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ecb=true\" readonly aria-label=\"{{\'cl.widget.xovis.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.4\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{xovis.settings.ec.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.bg selected-type=xovis.ec.bg is-alpha=true selected-alpha=xovis.settings.ec.bga ng-if=colorPicker.ecb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.5\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.cot><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.coText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.coText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.cot=true\" readonly aria-label=\"{{\'cl.widget.xovis.5\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.5\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.coText selected-type=xovis.ctype.ec.coText ng-if=colorPicker.cot></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=coFont>{{\'cl.widget.xovis.6\' | translate}}</label><select id=coFont class=form-control ng-model=xovis.settings.ec.coFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.6\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.6\' | translate}}\"></select></div><div class=col-xs-4><label for=coSize>{{\'cl.widget.xovis.7\' | translate}}</label><input type=number id=coSize class=form-control ng-model=xovis.settings.ec.coSize min=1 aria-label=\"{{\'cl.widget.xovis.7\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.7\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.coct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.cocText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.cocText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.coct=true\" readonly aria-label=\"{{\'cl.widget.xovis.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.8\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.cocText selected-type=xovis.ctype.ec.cocText ng-if=colorPicker.coct></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=cocFont>{{\'cl.widget.xovis.9\' | translate}}</label><select id=cocFont class=form-control ng-model=xovis.settings.ec.cocFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.9\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.9\' | translate}}\"></select></div><div class=col-xs-4><label for=cocSize>{{\'cl.widget.xovis.10\' | translate}}</label><input type=number id=cocSize class=form-control ng-model=xovis.settings.ec.cocSize min=1 aria-label=\"{{\'cl.widget.xovis.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.10\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.mot><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.moText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.moText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.mot=true\" readonly aria-label=\"{{\'cl.widget.xovis.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.11\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.moText selected-type=xovis.ctype.ec.moText ng-if=colorPicker.mot></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=moFont>{{\'cl.widget.xovis.12\' | translate}}</label><select id=moFont class=form-control ng-model=xovis.settings.ec.moFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.12\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.12\' | translate}}\"></select></div><div class=col-xs-4><label for=moSize>{{\'cl.widget.xovis.13\' | translate}}</label><input type=number id=moSize class=form-control ng-model=xovis.settings.ec.moSize min=1 aria-label=\"{{\'cl.widget.xovis.13\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.13\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.moct><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.mocText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.mocText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.moct=true\" readonly aria-label=\"{{\'cl.widget.xovis.14\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.14\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.mocText selected-type=xovis.ctype.ec.mocText ng-if=colorPicker.moct></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.xovis.15\' | translate}}</label><select id=mocFont class=form-control ng-model=xovis.settings.ec.mocFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.15\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.15\' | translate}}\"></select></div><div class=col-xs-4><label for=mocSize>{{\'cl.widget.xovis.16\' | translate}}</label><input type=number id=mocSize class=form-control ng-model=xovis.settings.ec.mocSize min=1 aria-label=\"{{\'cl.widget.xovis.16\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.16\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wb><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':xovis.settings.ec.wbg, opacity:xovis.settings.ec.wbga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.wbg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wb=true\" readonly aria-label=\"{{\'cl.widget.xovis.17\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.17\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{xovis.settings.ec.wbga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.wbg selected-type=xovis.ctype.ec.wbg is-alpha=true selected-alpha=xovis.settings.ec.wbga ng-if=colorPicker.wb></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.18\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.wText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.wText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wt=true\" readonly aria-label=\"{{\'cl.widget.xovis.18\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.18\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.wText selected-type=xovis.ctype.ec.wText ng-if=colorPicker.wt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=wFont>{{\'cl.widget.xovis.19\' | translate}}</label><select id=wFont class=form-control ng-model=xovis.settings.ec.wFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.19\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.19\' | translate}}\"></select></div><div class=col-xs-4><label for=wSize>{{\'cl.widget.xovis.20\' | translate}}</label><input type=number id=wSize class=form-control ng-model=xovis.settings.ec.wSize min=1 aria-label=\"{{\'cl.widget.xovis.20\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.20\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.21\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wd><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.ec.wdText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.ec.wdText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wd=true\" readonly aria-label=\"{{\'cl.widget.xovis.21\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.21\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.ec.wdText selected-type=xovis.ctype.ec.wdText ng-if=colorPicker.wd></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=wdFont>{{\'cl.widget.xovis.22\' | translate}}</label><select id=wdFont class=form-control ng-model=xovis.settings.ec.wdFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.22\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.22\' | translate}}\"></select></div><div class=col-xs-4><label for=wdSize>{{\'cl.widget.xovis.23\' | translate}}</label><input type=number id=wdSize class=form-control ng-model=xovis.settings.ec.wdSize min=1 aria-label=\"{{\'cl.widget.xovis.23\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.23\' | translate}}\"></div></div></div><!-- Feet Distance --><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=\"settingsOpen && xovis.dType==\'fd\'\"><div class=row><div class=col-xs-4><label>{{\'cl.widget.xovis.4\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fd><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':xovis.settings.fd.bg, opacity:xovis.settings.fd.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.fd.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fd=true\" readonly aria-label=\"{{\'cl.widget.xovis.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.4\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{xovis.settings.fd.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.fd.bg selected-type=xovis.ctype.fd.bg is-alpha=true selected-alpha=xovis.settings.fd.bga ng-if=colorPicker.fd></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=wLabel>{{\'cl.widget.xovis.24\' | translate}}</label><input type=text id=wLabel class=form-control ng-model=xovis.settings.fd.wLabel aria-label=\"{{\'cl.widget.xovis.24\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.24\' | translate}}\"></div><div class=col-xs-4><label for=wTitle>{{\'cl.widget.xovis.28\' | translate}}</label><input type=text id=wTitle class=form-control ng-model=xovis.settings.fd.wTitle aria-label=\"{{\'cl.widget.xovis.28\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.28\' | translate}}\"></div><div class=col-xs-4><div class=form-group><label>{{\'cl.widget.xovis.32\' | translate}}</label><div class=quotesImg><div class=\"pull-left relative\" ng-if=xovis.settings.fd.wLogo.thumb><a href=\"\" role=link class=thumb-close ng-click=removeImgFx();><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <img alt=\"\" ng-if=xovis.settings.fd.wLogo.thumb ng-src=\"{{tim + cBucket + xovis.settings.fd.wLogo.thumb + inputImgThumbParam}}\" uib-popover-template=logoPopover.templateUrl popover-placement=bottom popover-trigger=mouseenter></div><button type=button role=button class=\"btn btn-primary marT5 btn-xs\" ng-click=selectContentOpen();>{{\'cm.label.30\' | translate | camelCase}}</button></div></div><!-- For popover image show --><script type=text/ng-template id=logo.html><img alt=\"\" ng-src=\"{{tim + cBucket + xovis.settings.fd.wLogo.thumb}}&h=135&w=215&q=80&zc=3\">\r\n                  <div class=\"marT5\"><span class=\"glyphicon glyphicon-home marR5\" aria-hidden=\"true\" ng-if=\"xovis.settings.fd.wLogo.isAccessible\"></span>{{xovis.settings.fd.wLogo.isAccessible?xovis.settings.fd.wLogo.path:\'cm.msg.39\' | translate}}</div></script></div></div><div class=\"row marT10\"><div class=col-xs-4><label>{{\'cl.widget.xovis.25\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.wtl><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.fd.wtlText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.fd.wtlText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.wtl=true\" readonly aria-label=\"{{\'cl.widget.xovis.25\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.25\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.fd.wtlText selected-type=xovis.ctype.fd.wtlText ng-if=colorPicker.wtl></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=wtlFont>{{\'cl.widget.xovis.26\' | translate}}</label><select id=wtlFont class=form-control ng-model=xovis.settings.fd.wtlFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.26\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.26\' | translate}}\"></select></div><div class=col-xs-4><label for=wtlSize>{{\'cl.widget.xovis.27\' | translate}}</label><input type=number id=wtlSize class=form-control ng-model=xovis.settings.fd.wtlSize min=1 aria-label=\"{{\'cl.widget.xovis.27\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.27\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.29\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.fwt><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.fd.fwtText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.fd.fwtText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.fwt=true\" readonly aria-label=\"{{\'cl.widget.xovis.29\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.29\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.fd.fwtText selected-type=xovis.ctype.fd.fwtText ng-if=colorPicker.fwt></ng-hub-color-picker></div></div></div><div class=col-xs-4><label for=fwtFont>{{\'cl.widget.xovis.30\' | translate}}</label><select id=fwtFont class=form-control ng-model=xovis.settings.fd.fwtFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.30\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.30\' | translate}}\"></select></div><div class=col-xs-4><label for=fwtSize>{{\'cl.widget.xovis.31\' | translate}}</label><input type=number id=fwtSize class=form-control ng-model=xovis.settings.fd.fwtSize min=1 aria-label=\"{{\'cl.widget.xovis.31\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.31\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label for=fText>{{\'cl.widget.cm.36\' | translate}}</label><input type=text id=fText class=form-control ng-model=xovis.settings.fd.fText aria-label=\"{{\'cl.widget.cm.36\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.36\' | translate}}\"></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.xovis.33\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.ft><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':xovis.settings.fd.ftText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"xovis.settings.fd.ftText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.ft=true\" readonly aria-label=\"{{\'cl.widget.xovis.33\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.33\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=xovis.settings.fd.ftText selected-type=xovis.ctype.fd.ftText ng-if=colorPicker.ft></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.xovis.34\' | translate}}</label><select class=form-control ng-model=xovis.settings.fd.ftFont ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cl.widget.xovis.34\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.34\' | translate}}\"></select></div><div class=col-xs-4><label for=ftSize>{{\'cl.widget.xovis.35\' | translate}}</label><input type=number id=ftSize class=form-control ng-model=xovis.settings.fd.ftSize min=1 aria-label=\"{{\'cl.widget.xovis.35\' | translate}}\" aria-labelledby=\"{{\'cl.widget.xovis.35\' | translate}}\"></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=xovis.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=xovis.activePeriod></ng-active-period></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.cm.10\' | translate}}</label><div class=input-group><input type=text class=\"form-control text-ellipsis\" ng-class=\"auth.upreferences.theme==\'df\'?\'bg-white\':\'\'\" ng-model=rUrl ng-value=rUrl uib-dropdown-toggle readonly aria-label=\"{{\'cl.widget.cm.10\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.10\' | translate}}\"> <span class=input-group-addon><a href=\"\" role=link ngclipboard data-clipboard-text={{rUrl}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-copy\" aria-hidden=true></span></a></span></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\" ng-if=!detailLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT!=\'1\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-disabled=\"nextProcessing || saveProcessing\" ng-if=\"selectedT==\'1\'\" ng-click=xovisFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.10\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"xovisFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'eMO\'\" aria-live=polite role=status>{{\'cl.widget.msg.25\' | translate}}</div><div ng-if=\"errType==\'wTitle\'\" aria-live=polite role=status>{{\'cl.widget.msg.26\' | translate}}</div><div ng-if=\"errType==\'coSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m2\' | translate}}</div><div ng-if=\"errType==\'cocSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m3\' | translate}}</div><div ng-if=\"errType==\'moSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m4\' | translate}}</div><div ng-if=\"errType==\'mocSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m5\' | translate}}</div><div ng-if=\"errType==\'wSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m6\' | translate}}</div><div ng-if=\"errType==\'wdSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m7\' | translate}}</div><div ng-if=\"errType==\'wtlSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m8\' | translate}}</div><div ng-if=\"errType==\'fwtSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m6\' | translate}}</div><div ng-if=\"errType==\'ftSize\'\" aria-live=polite role=status>{{\'cl.widget.xovis.m9\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/yammer.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.yammer.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.yammer.2\' | translate}} &nbsp; <span ng-if=yammer.label>[ {{yammer.label}} ]</span></h1></header><div>&nbsp;</div><ul class=\"nav nav-tabs nav-bar\" role=tablist aria-labelledby=navList><li role=tab ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" role=link ng-click=\"tabFx(1,\'tabFx\');\"><span class=badge>1</span>{{\'cl.widget.cm.2\' | translate}}</a></li><li role=tab ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" role=link ng-click=yammerFx(1);><span class=badge>2</span>{{\'cl.widget.cm.27\' | translate}}</a></li></ul>{{(tabView?getAvailableHeight(387):getAvailableHeight(358)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=yammer.labelOpt value=a><label></label>{{\'cl.widget.yammer.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=yammer.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"yammer.labelOpt == \'c\'\"><input type=text id=label class=form-control ng-model=yammer.label maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label>{{\'cl.widget.cm.9\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=yammer.dType value=t ng-change=\"dTypeChange(\'t\')\"><label></label>{{\'cl.widget.sc.11\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=yammer.dType value=l ng-change=\"dTypeChange(\'l\')\"><label></label>{{\'cl.widget.cm.9.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio name=dTypeOpt ng-model=yammer.dType value=m ng-change=\"dTypeChange(\'m\')\"><label></label>{{\'cl.widget.sc.10\' | translate}}</label></div></div><div class=form-group><div class=\"marR20 marB20\" ng-if=\"yammer.dType == \'t\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/textMedia.png alt=\"Template 1\"></label></div><div class=\"marR20 marB20\" ng-if=\"yammer.dType == \'l\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/list.png alt=\"Template 2\"></label></div><div class=\"marR20 marB20\" ng-if=\"yammer.dType == \'m\'\"><label class=noMarB><img ng-src=assets/images/widget/templates/media.png alt=\"Template 3\"></label></div></div><div class=form-group><a href=\"\" role=link class=\"btn btn-link btn-xs pull-right\" ng-click=settingsDefault() ng-if=settingsOpen><span class=\"fa fa-undo\" aria-hidden=true></span>{{\'cm.label.90\' | translate}}</a><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'cm.label.14\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div ng-if=\"yammer.dType == \'t\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=textMedia.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"textMedia.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=textMedia.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.b><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.bg, opacity:textMedia.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.b=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.bg selected-type=textMedia.ctype.bg is-alpha=true selected-alpha=textMedia.settings.bga ng-if=colorPicker.b></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.8\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.textBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':textMedia.settings.textBg, opacity:textMedia.settings.textBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.textBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.textBg=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{textMedia.settings.textBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.textBg selected-type=textMedia.ctype.textBg is-alpha=true selected-alpha=textMedia.settings.textBga ng-if=colorPicker.textBg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.sc.9\' | translate}}</label><select class=form-control ng-model=textMedia.settings.align><option value=l>{{\'cm.editor.10.4\' | translate}}</option><option value=c>{{\'cm.editor.10.5\' | translate}}</option><option value=r>{{\'cm.editor.10.6\' | translate}}</option></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.titleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.titleText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.titleText selected-type=textMedia.ctype.titleText ng-if=colorPicker.titleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.16.2\' | translate}}</label><select class=form-control ng-model=textMedia.settings.titleFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.descText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':textMedia.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"textMedia.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.descText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=textMedia.settings.descText selected-type=textMedia.ctype.descText ng-if=colorPicker.descText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=textMedia.settings.descSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.survey.8\' | translate}}</label><select class=form-control ng-model=textMedia.settings.descFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div></div><div ng-if=\"yammer.dType == \'l\'\"><div class=form-group><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"list.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=list.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div><div class=form-group><div><label>{{\'cl.widget.cm.12\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=a><label></label>{{\'cl.widget.cm.12.1\' | translate}}</label><label class=\"noMarB marR10\"><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=c><label></label>{{\'cl.widget.cm.12.2\' | translate}}</label><label class=noMarB><input type=radio role=radio ng-model=list.settings.hTextOpt name=hTextOpt value=n><label></label>{{\'cl.widget.cm.12.3\' | translate}}</label><div class=marT5 ng-if=\"list.settings.hTextOpt==\'c\'\"><input type=text class=form-control ng-model=list.settings.hText maxlength={{inputLimit}} focus-me=true></div></div><div class=row ng-if=\"list.settings.hTextOpt!=\'n\'\"><div class=col-xs-4><label>{{\'cl.widget.cm.11\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.headerBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.headerBg, opacity:list.settings.headerBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.headerBg=true\" readonly aria-label=\"{{\'cl.widget.cm.11\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cm.11\' | translate}}\"> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.headerBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerBg selected-type=list.ctype.headerBg is-alpha=true selected-alpha=list.settings.headerBga ng-if=colorPicker.headerBg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.12\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.headerText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.headerText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.headerText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.headerText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.headerText selected-type=list.ctype.headerText ng-if=colorPicker.headerText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.13\' | translate}}</label><select class=form-control ng-model=list.settings.headerFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.bg, opacity:list.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.bg selected-type=list.ctype.bg is-alpha=true selected-alpha=list.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.14\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.rowBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.rowBg, opacity:list.settings.rowBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.rowBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.rowBg=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.rowBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.rowBg selected-type=list.ctype.rowBg is-alpha=true selected-alpha=list.settings.rowBga ng-if=colorPicker.rowBg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.15\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altBg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':list.settings.altBg, opacity:list.settings.altBga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altBg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altBg=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{list.settings.altBga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altBg selected-type=list.ctype.altBg is-alpha=true selected-alpha=list.settings.altBga ng-if=colorPicker.altBg></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.fs.8\' | translate}}</label><select class=form-control ng-model=list.settings.rowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.fs.10\' | translate}}</label><select class=form-control ng-model=list.settings.altRowFont ng-options=\"font.label for font in fontFamily track by font.value\"></select></div><div class=col-xs-4><label>{{\'cl.widget.cm.31\' | translate}}</label><input type=number class=form-control ng-model=list.settings.headerSize min=1></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.titleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.titleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.titleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.titleText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.titleText selected-type=list.ctype.titleText ng-if=colorPicker.titleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.subtitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.subtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.subtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.subtitleText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.subtitleText selected-type=list.ctype.subtitleText ng-if=colorPicker.subtitleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.descText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.descText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.descText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.descText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.descText selected-type=list.ctype.descText ng-if=colorPicker.descText></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altTitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altTitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altTitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altTitleText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altTitleText selected-type=list.ctype.altTitleText ng-if=colorPicker.altTitleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.cm.17.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altSubtitleText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altSubtitleText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altSubtitleText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altSubtitleText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altSubtitleText selected-type=list.ctype.altSubtitleText ng-if=colorPicker.altSubtitleText></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.twitter.6.1\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.altDescText><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span ng-style=\"{\'background-color\':list.settings.altDescText}\"></span></span> <input type=text class=\"form-control picker\" ng-value=\"list.settings.altDescText | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.altDescText=true\" readonly></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=list.settings.altDescText selected-type=list.ctype.altDescText ng-if=colorPicker.altDescText></ng-hub-color-picker></div></div></div></div><div class=\"row marT15\"><div class=col-xs-4><label>{{\'cl.widget.cm.16.3\' | translate}}</label><input type=number class=form-control ng-model=list.settings.titleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.oc.15\' | translate}}</label><input type=number class=form-control ng-model=list.settings.subtitleSize min=1></div><div class=col-xs-4><label>{{\'cl.widget.cm.42\' | translate}}</label><input type=number class=form-control ng-model=list.settings.descSize min=1></div></div></div><div ng-if=\"yammer.dType == \'m\'\"><div class=row><div class=col-xs-4><label>{{\'cm.label.87\' | translate}}</label><div uib-dropdown auto-close=outsideClick dropdown-append-to-body is-open=colorPicker.bg><div class=\"input-group input-colorPicker\"><span class=input-group-addon><span class=trBg><span ng-style=\"{\'background-color\':media.settings.bg, opacity:media.settings.bga}\"></span></span></span> <input type=text class=\"form-control picker\" ng-value=\"media.settings.bg | uppercase\" uib-dropdown-toggle ng-click=\"colorPicker.bg=true\" readonly> <span class=\"input-group-addon colorAlpha\" uib-tooltip=\"{{\'cm.label.93\' | translate}}\" tooltip-append-to-body=true>{{media.settings.bga}}</span></div><div class=\"dropdown-menu dropdown-to-body\" placement=\"left bottom\" uib-dropdown-menu><img alt=Loading src=assets/images/loading-xs.gif ng-if=colorPickerOpen><ng-hub-color-picker selected-color=media.settings.bg selected-type=media.ctype.bg is-alpha=true selected-alpha=media.settings.bga ng-if=colorPicker.bg></ng-hub-color-picker></div></div></div><div class=col-xs-4><label>{{\'cl.widget.news.6\' | translate}}</label><div><label class=\"noMarB marR10\"><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=a><label></label>{{\'cl.widget.news.6.1\' | translate}}</label><label class=noMarB><input type=radio ng-model=media.settings.rotationOpt name=rotationOpt value=c><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=\"form-inline marT5\"><div class=input-group ng-if=\"media.settings.rotationOpt == \'c\'\"><input type=number class=form-control ng-model=media.settings.rotate focus-me=true min=1><div class=input-group-addon>{{\'cm.label.27s\' | translate}}</div></div></div></div></div></div></div></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=yammer.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=yammer.activePeriod></ng-active-period></div></div></div></div><div ng-if=\"selectedT==\'2\'\"><div class=col-xs-7><div class=form-group><label>{{\'cl.widget.yammer.4\' | translate}}</label><div><button type=button role=button class=\"btn btn-success\" ng-click=\"openUrlFx(626, 450, \'at\');\" ng-if=!networkShow ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=authProcessing aria-hidden=true></span> {{\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=\"reAuthOpen(\'re\');\" ng-if=networkShow>{{networkShow?\'cl.widget.cm.25.1\':\'cl.widget.cm.25\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=\"reAuthOpen(\'ou\');\" ng-if=networkShow>{{\'cl.widget.cm.25.2\' | translate}}</button></div></div><div class=form-group ng-if=\"networkShow && showNetList\"><label for=net>{{\'cl.widget.yammer.5\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=networkSearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.5.1\' | translate}}\">{{yammer.net.network_name}} <span ng-if=\"yammer.net == \'\'\">{{\'cl.widget.yammer.5.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=networkList.length><li class=\"dropdown-header noMar\" ng-if=\"networkList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchNetwork.network_name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchNetwork.network_name.length ng-click=\"searchNetwork.network_name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"networkList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"net in network = (networkList | customSearch:{key:searchNetwork.network_name, module:\'net\', filterType:filter})\" tabindex=$index><label ng-model=net.selected ng-click=changeNetworkSetting(net);><label></label>{{net.network_name}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"network.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchNetwork.network_name)}}&quot;</b>\'}\"></div></div></ul></div></div></div><img ng-if=showCommLoading alt=Loading src=assets\\images\\loading.gif><div class=form-group ng-if=\"networkShow && showNetList && showCommList && !showCommLoading\"><label for=comm>{{\'cl.widget.yammer.6\' | translate}}</label><div class=form-group><div class=\"dropdown customSelect customSelectChannel\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=communitySearchFocus(); aria-placeholder=\"{{\'cl.widget.yammer.6.1\' | translate}}\">{{yammer.comm.full_name}} <span ng-if=\"yammer.comm == \'\'\">{{\'cl.widget.yammer.6.1\' | translate}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu ng-if=communityList.length><li class=\"dropdown-header noMar\" ng-if=\"communityList.length > 5\"><div class=\"searchTbx findSearch\"><input type=text class=form-control ng-model=searchCommunity.full_name sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchCommunity.full_name.length ng-click=\"searchCommunity.full_name=\'\'\"><span class=\"fa fa-remove serverSettingSearchRemove\"></span></a></div></li><li class=divider ng-if=\"communityList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"comm in community = (communityList | customSearch:{key:searchCommunity.full_name, module:\'comm\', filterType:filter})\" tabindex=$index><label ng-model=comm.selected ng-click=changeCommunitySetting(comm);><label></label>{{comm.full_name}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"community.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchCommunity.name)}}&quot;</b>\'}\"></div></div></ul></div></div></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"selectedT==\'2\'\" ng-click=backBtnFx();><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"selectedT==\'1\'\" ng-click=yammerFx(1);>{{\'cm.btn.12\' | translate}}: {{\'cl.widget.cm.27\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=\"yammerFx(2, \'save\');\" ng-if=\"encId || selectedT==\'2\'\" ng-disabled=\"saveProcessing || authSaveDisable\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'channel\'\" aria-live=polite role=status>{{\'cl.widget.sch.m1\' | translate}}</div><div ng-if=\"errType==\'hSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.16\' | translate}}</div><div ng-if=\"errType==\'tSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.13\' | translate}}</div><div ng-if=\"errType==\'dSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.23\' | translate}}</div><div ng-if=\"errType==\'reload\'\" aria-live=polite role=status>{{\'cl.widget.msg.21\' | translate}}</div><div ng-if=\"errType==\'rotate\'\" aria-live=polite role=status>{{\'cl.widget.msg.22\' | translate}}</div><div ng-if=\"errType==\'headerText\'\" aria-live=polite role=status>{{\'em.msg.8\' | translate}}</div><div ng-if=\"errType==\'sSize\'\" aria-live=polite role=status>{{\'cl.widget.msg.14\' | translate}}</div><div ng-if=\"errType==\'rotation\'\" aria-live=polite role=status>{{\'cl.widget.msg.19\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div><div ng-if=\"errType==\'authEmpty\'\" aria-live=polite role=status>{{\'cl.widget.yammer.m1\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div><div ng-if=\"errType==\'networkEmpty\'\" aria-live=polite role=status>{{\'cl.widget.yammer.m2\' | translate}}</div><div ng-if=\"errType==\'network\'\" aria-live=polite role=status>{{\'cl.widget.yammer.m2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/contentLibrary/widgets/youTube.html","<header ng-class=\"tabView?\'text-big\':\'panel-heading\'\"><h1 ng-if=tabView><a href=\"\" role=link class=sidebar-toggle name=list ng-click=listOpenFx();><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span></a>{{\'cl.widget.youTube.1\' | translate}}</h1><h1 ng-if=!tabView>{{\'cl.widget.youTube.2\' | translate}} &nbsp; <span ng-if=youtube.label>[ {{youtube.label}} ]</span></h1></header><div>&nbsp;</div>{{(tabView?getAvailableHeight(338):getAvailableHeight(309)); \"\"}}<div class=\"widgetForm overflow-auto\" ng-attr-style=height:{{winH}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=\"row noMarR\" ng-if=!detailLoading><div class=col-xs-7><div class=\"msg-warning marB10\" lang={{auth.lang}}>{{\'cl.widget.youTube.m4\' | translate}}</div><div class=form-group><div><label>{{\'cl.label.1\' | translate}}</label></div><label class=\"noMarB marR10\"><input type=radio role=radio name=labelOpt ng-model=youtube.labelOpt value=a><label></label>{{\'cl.widget.youTube.3\' | translate}}</label><label class=noMarB><input type=radio role=radio name=labelOpt ng-model=youtube.labelOpt value=c><label></label>{{\'cl.widget.cm.6\' | translate}}</label><div class=marT5 ng-if=\"youtube.labelOpt==\'c\'\"><input type=text id=label class=form-control ng-model=youtube.label maxlength=140 focus-me=true aria-label=\"{{\'cl.label.1\' | translate}}\" aria-labelledby=\"{{\'cl.label.1\' | translate}}\"></div></div><div class=form-group><label for=playListId>{{\'cl.widget.youTube.4\' | translate}}</label><div class=form-group><input type=text id=playListId class=form-control ng-model=youtube.playlistId focus-me=true aria-label=\"{{\'cl.widget.youTube.4\' | translate}}\" aria-labelledby=\"{{\'cl.widget.youTube.4\' | translate}}\"></div></div><div class=\"form-group hide\"><label><input type=checkbox ng-model=youtube.settings.cc role=checkbox><label></label>{{\'cl.widget.youTube.5\' | translate}}<span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'cl.widget.youTube.m3\' | translate}}\" tooltip-placement=right aria-hidden=true></span></label></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=youtube.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=youtube.activePeriod></ng-active-period></div></div></div></div><div ng-class=\"tabView?\'bdr-top-dashed marT10\':\'panel-footer\'\"><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=youtubeFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ui-sref=hub.contentLibrary.c ng-click=popupCloseFx();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.widget.msg.1\' | translate}}</div><div ng-if=\"errType==\'id\'\" aria-live=polite role=status>{{\'cl.widget.youTube.m1\' | translate}}</div><div ng-if=\"errType==\'invalid-id\'\" aria-live=polite role=status>{{\'cl.widget.youTube.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'activePeriod\'\" aria-live=polite role=status>{{\'cl.widget.msg.2\' | translate}}</div></div><div class=clearfix></div></div>");
$templateCache.put("app/creativeServices/popup/info.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cs.tool.1\' | translate}}</h1></header><div class=panel-body><span translate=\"{{\'cs.info.1\'}}\" translate-values=\"{lsn: \'L&nbsp;Squared\'}\"></span><div class=marT25><img alt=\"\" src=assets/images/info/cs.png></div></div></section>");
$templateCache.put("app/creativeServices/popup/payment.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cs.body.3\' | translate}}</h1></header><div class=panel-body><iframe width=100% height=600 ng-src=\"{{paymentData.url | trustUrl}}\"></iframe></div></section>");
$templateCache.put("app/creativeServices/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.menu.9\' | translate}}</h1></header><div class=video-body><iframe width=560 height=315 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/emergencyMsg/popup/info.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'em.tool.1\' | translate}}</h1></header><div class=panel-body>{{\'em.info.1\' | translate}}<div class=marT25><img alt=\"\" src=assets/images/info/em.gif></div></div></section>");
$templateCache.put("app/emergencyMsg/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.menu.7\' | translate}}</h1></header><div class=panel-body><iframe width=560 height=315 src=\"https://www.youtube.com/embed/n5PR0ASZWNE?autoplay=1&amp;rel=0&amp;showinfo=0\" frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/devices/dir/deviceBrief.html","<div class=selectedQuad><!--For Selected Item Brief--><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><header class=panel-heading><h2><span ng-if=\"$state.includes(\'hub.devices.d\') === true\"><span ng-if=\"selectedItems[0].type == \'device\' || selectedItems[0].type == \'folder\'\">{{selectedItems.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate}} </span><span ng-if=\"selectedItems[0].type !== \'device\' && selectedItems[0].type != \'folder\'\">{{\'d.brief.22\' | translate}}</span> </span><span ng-if=\"$state.includes(\'hub.devices.dt\') === true\">{{selectedItems.length > 1?\'d.brief.21s\':\'d.brief.21\' | translate}}</span> <span ng-if=\"$state.includes(\'hub.devices.dg\') === true\">{{selectedItems.length > 1?\'d.brief.1s\':\'d.brief.1\' | translate}}</span> <span ng-if=\"$state.includes(\'hub.devices.dvw\') === true\">{{selectedItems.length > 1?\'d.brief.28s\':\'d.brief.28\' | translate}}</span></h2><span class=marL5>[ {{selectedItems.length}} ]</span><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=closeAllFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></header><div class=panel-body><div ng-if=\"selectedItems.length == 1\">{{curDevice = (brief.devices | filter:{id:selectedItems[0].id, type:selectedItems[0].subType}:true | orderBy: \'id\');\"\"}} {{curGroups = (devices.groups | filter:{id:selectedItems[0].id, type:selectedItems[0].subType}:true | orderBy: \'id\');\"\"}}<!-- {{curFolder = (folderList | folderBrief:selectedItems[0] | orderBy:\'id\');\"\"}} --> {{curFolder = (folderList | folderBrief:selectedItems[0] | orderBy:\'id\');\"\"}} {{curSearches = (devices.searches | filter:{id:selectedItems[0].id, type:selectedItems[0].subType}:true | orderBy: \'id\');\"\"}} {{curWall = (devices.walls | filter:{id:selectedItems[0].id, type:selectedItems[0].subType}:true | orderBy: \'id\');\"\"}}<ul class=\"list-unstyled single-selected\"><div class=row><div class=col-xs-3><div class=\"msg-warning text-center text-bold\" lang={{auth.lang}} ng-if=\"curFolder[0].type != \'Folder\' && deviceBrief != \'\' && deviceBrief.ss == 0 && curDevice[0].t != 8\">{{\'d.brief.17\' | translate}}</div><div class=thumb-highlight><!-- Folder --><!-- {{curFolder[0]}} --> <img alt=Folder ng-if=\"selectedTab == \'hub.devices.d\' && curFolder[0].type == \'Folder\' || curDevice[0].type == \'Folder\'\" src=assets/images/default/folder_selected.png class=\"noOutline img-responsive center-block img-folder\"><div class=thumb ng-class=\"{\'mcPlayer\': curDevice[0].t == 7}\" ng-if=\"curFolder[0].type != \'Folder\' && curDevice[0].type != \'Folder\'\"><img alt=Loading src=assets/images/loading.gif ng-if=\"curDevice[0].thumb && (!imageLoaded && !srcErrorShow)\"> <a ng-if=\"curDevice[0].tv != null && curDevice[0].tv != 0 && deviceBrief != \'\'\" ng-href=\"{{detailBucket + curDevice[0].h+\'.jpg?v=\'+curTimestamp | secureThumb:curDevice[0].tv}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{curDevice[0].l}} ng-class=\"!imageLoaded ? \'hide\': imageLoaded\"><img alt=d_{{curDevice[0].h}} ng-src=\"{{tim + bucket + (curDevice[0].h | removeColon) + \'.jpg&\' + curDevice[0].tv + thumbBigParamZc3}}\" src-error=assets/images/default/device_selected_{{curDevice[0].t}}.png class=\"img-responsive center-block blackOutline\" ng-class=\"{\'blackBdr\': !srcErrorShow}\"> </a><img alt=Folder ng-if=\"selectedItems[0].subType == \'folder\'\" ng-src=assets/images/default/folder_selected_{{selectedItems[0].type}}.png class=\"img-responsive center-block\"> <img alt=ds_{{curDevice[0].t}} ng-if=srcErrorShow ng-src=assets/images/default/device_selected_{{curDevice[0].t}}.png class=\"img-responsive center-block blackBdr\"> <img alt=ds_{{curDevice[0].t}} ng-if=\"((auth.upreferences.deviceView == \'l\' && !curDevice[0].tv) || (auth.upreferences.deviceView == \'t\' && curDevice[0].tv == 0)) && curDevice[0].type == \'device\'\" ng-src=assets/images/default/device_selected_{{curDevice[0].t}}.png class=\"img-responsive center-block blackBdr\"> <img alt=dts ng-if=\"curDevice[0].type == \'tag\' && !auth.upermissions.dtc\" src=assets/images/default/device_tag_selected.png class=\"img-responsive center-block img-tag\"> <svg alt=dts ng-if=\"curDevice[0].type == \'tag\' && auth.upermissions.dtc\" xmlns=http://www.w3.org/2000/svg width=215 height=135 viewBox=\"0 0 215 135\"><defs></defs><path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#57aee3\'}\" d=M2,2H213V133H2V2Z /><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#57aee3\'}\" d=M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z /></svg><!-- <span ng-if=\"curDevice[0].type == \'group\'\" class=\"thumb-group-img\"> --> <span ng-if=\"curGroups[0].type == \'group\'\" class=thumb-group-img><img alt=dgs src=assets/images/default/device_group_selected.png class=\"img-responsive center-block\"> </span><span ng-if=\"curWall[0].type == \'videowall\'\" class=\"thumb-group-img relative\"><span class=\"matrix-badge big\" ng-if=\"deviceBrief != \'\'\">{{deviceBrief.matrix}}</span> <img class=bdrDark alt=dgs src=assets/images/default/device_videowall_selected.png class=\"img-responsive center-block\"> </span><img alt=dss ng-if=\"curSearches[0].type == \'search\'\" src=assets/images/default/device_search_selected.png class=\"img-responsive center-block\"></div><div class=marT5><div class=text-ellipsis uib-tooltip={{curFolder[0].l}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curFolder[0].l}}</div><div class=text-ellipsis uib-tooltip={{curGroups[0].label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curGroups[0].label}}</div><div class=text-ellipsis ng-if=\"curDevice[0].l && selectedTab!=\'hub.devices.dg\'\" uib-tooltip={{curDevice[0].l}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curDevice[0].l}}</div><div class=text-ellipsis ng-if=\"curDevice[0].label && selectedTab!=\'hub.devices.dg\'\" uib-tooltip={{curDevice[0].label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curDevice[0].label}}</div><div class=text-ellipsis uib-tooltip={{curSearches[0].label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curSearches[0].label}}</div><div class=text-ellipsis ng-if=\"selectedItems[0].subType == \'folder\' && selectedItems[0].l\" uib-tooltip={{selectedItems[0].l}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{selectedItems[0].l}}</div><div class=text-ellipsis ng-if=\"selectedItems[0].subType == \'folder\' && selectedItems[0].label\" uib-tooltip={{selectedItems[0].label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{selectedItems[0].label}}</div><div class=text-ellipsis uib-tooltip={{curWall[0].label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{curWall[0].label}}</div></div><div class=\"text-ellipsis bdr-top-dashed\" ng-if=\"deviceBrief.tv != null && deviceBrief.tv != 0 && curFolder[0].type != \'Folder\' && curDevice[0].type != \'Folder\'\"><label class=noMarB>{{\'d.brief.18\' | translate}}</label><div>{{(deviceBrief.tv * 1000) | date:\"MMM d, y h:mm a\"}}</div></div><div class=marT2 ng-if=\"curDevice[0].t != 10 && curDevice[0].t != 11 && curDevice[0].t != 8 && deviceBrief.status == \'online\' && curFolder[0].type != \'Folder\' && curDevice[0].type != \'Folder\'\"><a href=\"\" role=link class=btn-link ng-if=!deviceBrief.ssProcessing ng-click=screenshotFx(curDevice[0].id);>{{\'d.btn.12\' | translate}}</a> <span class=text-muted ng-if=deviceBrief.ssProcessing>{{\'cm.btn.15i\' | translate}} <img src=assets\\images\\loading-xs.gif></span></div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.devices.d\' && selectedItems[0].subType == \'folder\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\" ng-if=selectedItems[0].l>{{selectedItems[0].l}}</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\" ng-if=selectedItems[0].label>{{selectedItems[0].label}}</div></div></div></div><!-- {{selectedItems}} --><!-- {{curDevice[0]}} --><!-- {{curFolder[0]}} --><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.devices.d\' && curDevice[0].t != 7 && selectedItems[0].subType != \'folder\' && curFolder[0].type != \'Folder\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\"><span>{{curDevice[0].l}}</span> <span>{{curDevice[0].label}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=curDevice[0].l ngclipboard data-clipboard-text={{curDevice[0].l}} uib-tooltip=\"{{\'d.tool.17\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-files-o noMar\" aria-hidden=true></span></button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span class=word-break>{{curDevice[0].h}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"deviceBrief.de && (curDevice[0].t != 10 && curDevice[0].t != 11)\" ng-click=\"deviceIdOpen(curDevice[0].id,curDevice[0].l,curDevice[0].h,\'brief\');\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-pencil noMar\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=deviceBrief.de ngclipboard data-clipboard-text={{curDevice[0].h}} uib-tooltip=\"{{\'d.tool.17\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-files-o noMar\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"deviceBrief.de && deviceBrief.history && (curDevice[0].t != 10 && curDevice[0].t != 11)\" ng-click=devicePCOpen(curDevice[0].id,curDevice[0].l,curDevice[0].h); uib-tooltip=\"{{\'d.tool.18\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-history noMar\" aria-hidden=true></span></button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.16.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.cName != null\">{{deviceBrief.cName}}</span> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.cName == null\">N/A</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"deviceBrief != \'\' && deviceBrief.cName != null\" ngclipboard data-clipboard-text={{deviceBrief.cName}} uib-tooltip=\"{{\'d.tool.17\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-files-o noMar\" aria-hidden=true></span></button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.label.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"curDevice[0].t == 1\">{{\'d.label.1.1\' | translate}}</span> <span ng-if=\"curDevice[0].t == 2\">{{\'d.label.1.5\' | translate}}</span> <span ng-if=\"curDevice[0].t == 3\">{{\'d.label.1.6\' | translate}}</span> <span ng-if=\"curDevice[0].t == 7\">{{\'d.label.1.4\' | translate}}</span> <span ng-if=\"curDevice[0].t == 10\">{{\'d.label.1.2\' | translate}}</span> <span ng-if=\"curDevice[0].t == 11\">{{\'d.label.1.3\' | translate}}</span> <span ng-if=\"curDevice[0].t == 8\">{{\'d.label.1.7\' | translate}}</span> <span ng-if=\"curDevice[0].t == 9\">{{\'d.label.1.8\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><!-- license details --><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.label.58.2\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.licId.lt}} <span class=\"marL5 valign-middle\" ng-if=\"deviceBrief != \'\'\" uib-tooltip=\"{{\'d.btn.33\' | translate}}\" tooltip-append-to-body=true><a href=\"\" role=link id=info aria-label=info ng-click=\"licInfoOpen(deviceBrief.licId, curDevice[0].l)\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></span> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.licId.lt\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.label.58\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.licId.id}} <span class=\"marL5 valign-middle\" ng-if=\"deviceBrief != \'\'\" uib-tooltip=\"{{\'d.btn.33\' | translate}}\" tooltip-append-to-body=true><a href=\"\" role=link id=info aria-label=info uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" ng-click=\"licInfoOpen(deviceBrief.licId, curDevice[0].l)\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span></a></span> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.licId.id\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=!deviceBrief.createdOn> <span ng-if=deviceBrief.createdOn>{{(deviceBrief.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.9\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"!deviceBrief.client && deviceBrief.os == 1 && deviceBrief.slide\">Legacy: <span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.slide}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.slide?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief.client == 1 && deviceBrief.slide\">ESlide: <span ng-if=\"deviceBrief.os == 1\" ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.eSW}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.eSW?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> <span ng-if=\"deviceBrief.os == 5\" ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.eSL}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.eSL?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> <span ng-if=\"deviceBrief.os == 6\" ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.eSM}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.eSM?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief.client == 10 && deviceBrief.os == 1 && deviceBrief.slide\"><span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.slide}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.slide?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"(!deviceBrief.client || deviceBrief.client == 2) && deviceBrief.os == 2 && devices.info.webos\">WSlide: <span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.webos}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.webos?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"(!deviceBrief.client || deviceBrief.client == 3) && deviceBrief.os == 3 && devices.info.tzn\">TSlide: <span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.tzn}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.tzn?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"(!deviceBrief.client || deviceBrief.client == 4) && deviceBrief.os == 4 && devices.info.chrm\">CSlide: <span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.chrm}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.chrm?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief.client == 7 && deviceBrief.os == 7\">{{isInfoSteth ? \'HDS:\': \'ASlide:\'}} <span ng-class=\"{\'text-danger\':deviceBrief.slide != devices.info.adrd}\" uib-tooltip=\"{{deviceBrief.slide != devices.info.adrd?\'d.tool.8.1\':\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief.slide && deviceBrief.watcher\">|</span> <span ng-if=\"!deviceBrief.client && deviceBrief.watcher\" ng-class=\"{\'text-danger\':deviceBrief.watcher != devices.info.watcher}\" uib-tooltip=\"{{deviceBrief.watcher != devices.info.watcher?\'d.tool.9.1\':\'d.tool.9\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.watcher}}</span> <span ng-if=\"deviceBrief.client == 1 && deviceBrief.watcher\"><span ng-if=\"deviceBrief.os == 1\" ng-class=\"{\'text-danger\':deviceBrief.watcher != devices.info.eWW}\" uib-tooltip=\"{{deviceBrief.watcher != devices.info.eWW?\'d.tool.9.1\':\'d.tool.9\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.watcher}}</span> <span ng-if=\"deviceBrief.os == 5\" ng-class=\"{\'text-danger\':deviceBrief.watcher != devices.info.eWL}\" uib-tooltip=\"{{deviceBrief.watcher != devices.info.eWL?\'d.tool.9.1\':\'d.tool.9\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.watcher}}</span> <span ng-if=\"deviceBrief.os == 6\" ng-class=\"{\'text-danger\':deviceBrief.watcher != devices.info.eWM}\" uib-tooltip=\"{{deviceBrief.watcher != devices.info.eWM?\'d.tool.9.1\':\'d.tool.9\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.watcher}}</span> </span><span ng-if=\"deviceBrief.client == 9 && deviceBrief.os == 9\">RSlide: <span uib-tooltip=\"{{\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief.client == 11 && deviceBrief.os == 5\">BSlide: <span uib-tooltip=\"{{\'d.tool.8\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.slide}}</span> </span><span ng-if=\"deviceBrief != \'\' && !deviceBrief.slide && !deviceBrief.watcher && deviceBrief.os != 0\" class=\"text-muted text-sm\">N/A</span> <span ng-if=\"deviceBrief != \'\' && !deviceBrief.slide && !deviceBrief.watcher && deviceBrief.os == 0\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"curDevice[0].t == 8\">{{\'d.brief.23\' | translate}}</span> <span ng-if=\"curDevice[0].t != 8\">{{deviceBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.10\' | translate}}:</div><div class=\"col-xs-7 brief-col text-capitalize\"><!-- {{curDevice[0].lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}} --><!-- {{deviceBrief.status}} --> <span ng-if=deviceBrief.status>{{deviceBrief.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}} </span><span class=\"text-muted text-sm\" ng-if=curDevice[0].lp uib-tooltip=\"{{curDevice[0].lp * 1000 | date:\'MMM d, y h:mm a\'}}\" tooltip-append-to-body=true>| {{curDevice[0].lp * 1000 | date:\"MMM d, y h:mm a\"}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.editedOn\">{{(deviceBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curDevice[0].id, \'device\', curDevice[0].l);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.70\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.os == 1\">Windows</span> <span ng-if=\"deviceBrief.os == 2\">LG WebOS <span ng-if=deviceBrief.osv class=text-muted>| {{deviceBrief.osv}}</span></span> <span ng-if=\"deviceBrief.os == 3\">Samsung Tizen</span> <span ng-if=\"deviceBrief.os == 4\">Chrome OS</span> <span ng-if=\"deviceBrief.os == 5\">Linux</span> <span ng-if=\"deviceBrief.os == 6\">MacOS</span> <span ng-if=\"deviceBrief.os == 7\">Android</span> <span ng-if=\"deviceBrief.os == 9\">Raspberry Pi</span> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && (!deviceBrief.os || deviceBrief.os == 0)\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.11\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.localIP uib-tooltip=\"{{\'d.brief.11.1\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.localIP}}</span> <span ng-if=\"deviceBrief.localIP && deviceBrief.publicIP\">|</span> <span ng-if=deviceBrief.publicIP uib-tooltip=\"{{\'d.brief.11.2\' | translate}}\" tooltip-append-to-body=true>{{deviceBrief.publicIP}}</span> <span ng-if=\"deviceBrief != \'\' && !deviceBrief.localIP && !deviceBrief.publicIP\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.3\' | translate}}:</div><div class=col-xs-7><span ng-if=!auth.upermissions.cau><span class=brief-col>{{deviceBrief.update? (\'cm.btn.4\' | translate | capitalize) : (\'cm.btn.5\' | translate | capitalize) }}</span> <span class=\"valign-middle glyphicon glyphicon-info-sign marT-4 text-primary\" aria-hidden=true ng-if=\"deviceBrief != \'\'\" uib-tooltip=\"{{\'d.brief.29\' | translate:  {htmlTagO: \'L&nbsp;Squared\'} }}\" tooltip-append-to-body=true></span></span><switch role=switch class=switch-sm ng-if=\"deviceBrief != \'\' && auth.upermissions.cau\" ng-model=deviceBrief.update aria-checked={{deviceBrief.update?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=autoUpdateFx(curDevice[0].id)></switch><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.2\' | translate}}:</div><div class=\"col-xs-7 brief-col ng-cloak\">{{deviceBrief.res}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.res\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"> <button type=button role=button class=\"btn btn-default btn-xs hide\" ng-click=\"changeResOpen(curDevice[0].id, curDevice[0].l, deviceBrief.res);\" ng-if=\"deviceBrief != \'\' && (curDevice[0].t == 1 || curDevice[0].t == 3 || curDevice[0].t == 2)\">{{\'u.btn.7\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.4\' | translate}}:</div><div class=col-xs-7><switch role=switch class=switch-sm ng-if=\"deviceBrief != \'\'\" ng-model=deviceBrief.offlineReboot aria-checked={{deviceBrief.offlineReboot?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=offlineRebootFx(curDevice[0].id)></switch><span class=\"fa fa-question-circle text-primary marL5\" ng-if=\"deviceBrief != \'\'\" uib-tooltip=\"{{\'d.brief.4.1\' | translate}}\" tooltip-append-to-body=true tooltip-placement=right aria-hidden=true></span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.88\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.timezone uib-tooltip=\"{{deviceBrief.timezone | timezoneLabel:timezoneList}}\" tooltip-append-to-body=true>{{deviceBrief.timezone | timezoneLabel:timezoneList}}</span> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.timezone == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.tag > 0\">{{deviceBrief.tag}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'tag\', curDevice[0].l);\" ng-if=\"deviceBrief.tag > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.tag == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.content.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.content.a}}</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.content.a == 0 && deviceBrief.content.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.content.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.content.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"contentCountFx(curDevice[0].id, curDevice[0].l, curDevice[0].h, deviceBrief.content,curDevice[0].t);\" ng-if=\"deviceBrief.content.a + deviceBrief.content.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.content.a + deviceBrief.content.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.adapters.length > 0\">{{deviceBrief.adapters.length}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=adaptersList(deviceBrief.adapters); ng-if=\"deviceBrief.adapters.length > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.adapters.length == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'fl.tab.1\' | translate | capitalize}}:</div><div class=\"col-xs-7 brief-col ng-cloak\"><span ng-if=\"deviceBrief.frameLayout > 0\">{{deviceBrief.frameLayout}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'frame\', curDevice[0].l);\" ng-if=\"deviceBrief.frameLayout > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.frameLayout == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6 ng-if=\"auth.upermissions.dc && curDevice[0].t != 8\"><div class=\"col-xs-5 text-right\">{{\'d.brief.13\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deviceControlOpen(curDevice[0].id, curDevice[0].l, curDevice[0].t, deviceBrief.os);\"><span class=\"glyphicon glyphicon-cog\" aria-hidden=true></span>{{\'cm.btn.32\' | translate}}</button></div></div><div class=col-xs-6 ng-if=!auth.upermissions.dc><div class=\"col-xs-5 text-right\">{{\'d.brief.12\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default hide\" ng-click=dataUsageOpen(curDevice[0].id,curDevice[0].l);>{{\'cm.btn.31\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=dataUsageSettingOpen(curDevice[0].id,curDevice[0].l);><span class=\"glyphicon glyphicon-cog\" aria-hidden=true></span>{{\'cm.btn.32\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"curDevice[0].t == 8\"><div class=\"col-xs-5 text-right\">{{\'d.brief.24.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span class=\"text-muted text-sm marR5\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count == 0\">N/A</span> <span ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{deviceBriefTicket.count}}</span> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(deviceBriefTicket.ticket,curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button><!-- <button type=\"button\" role=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button> --> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=bugsOpen(curDevice[0].id); ng-if=\"deviceBriefTicket != \'\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBriefTicket == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.3s\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.schedule.a}}</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a == 0 && deviceBrief.schedule.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.schedule.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'schedule\', curDevice[0].l, deviceBrief.schedule);\" ng-if=\"deviceBrief.schedule.a + deviceBrief.schedule.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a + deviceBrief.schedule.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief.length == 0\"></div></div></div><div class=row ng-if=\"curDevice[0].t == 8 && (auth.uType == 0 || auth.uType == 1)\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=deviceLogOpen(curDevice[0].l);>{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row ng-if=\"auth.upermissions.dc && curDevice[0].t != 8\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.12\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default hide\" ng-click=dataUsageOpen(curDevice[0].id,curDevice[0].l);>{{\'cm.btn.31\' | translate}}</button> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=dataUsageSettingOpen(curDevice[0].id,curDevice[0].l);><span class=\"glyphicon glyphicon-cog\" aria-hidden=true></span>{{\'cm.btn.32\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"auth.uType == 0 || auth.uType == 1\"><div class=\"col-xs-5 text-right\">{{\'d.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=deviceLogOpen(curDevice[0].l);>{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.body.16\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.dsk.t><span ng-if=deviceBrief.dsk.u uib-tooltip=\"{{\'d.body.16.1\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.dsk.u*1024) | filesize}} / </span><span uib-tooltip=\"{{\'d.body.16.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.dsk.t*1024) | filesize}}</span> </span><span ng-if=!deviceBrief.dsk.t class=\"text-sm text-muted\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'b.o.26\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.mem.t><span ng-if=deviceBrief.mem.u uib-tooltip=\"{{\'d.body.16.1\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.mem.u*1024) | filesize}} / </span><span uib-tooltip=\"{{\'d.body.16.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.mem.t*1024) | filesize}}</span> </span><span ng-if=!deviceBrief.mem.t class=\"text-sm text-muted\">N/A</span></div></div></div><div class=row><div class=col-xs-6 ng-if=\"curDevice[0].t != 8\"><div class=\"col-xs-5 text-right\">{{\'d.brief.24.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span class=\"text-muted text-sm marR5\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count == 0\">N/A</span> <span ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{deviceBriefTicket.count}}</span> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(deviceBriefTicket.ticket,curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button><!-- <button type=\"button\" role=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button> --> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=bugsOpen(curDevice[0].id); ng-if=\"deviceBriefTicket != \'\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBriefTicket == \'\'\"></div></div><!-- Device info --><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.tool.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"countListFx(curDevice[0].id, \'dbInfo\', curDevice[0].l, deviceBrief.schedule);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row ng-if=\"auth.upermissions.rpoh && curDevice[0].t == 2\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.25\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"powerHistoryOpen(curDevice[0].l, curDevice[0].h);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><!-- User Groups --><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'u.tab.2\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.uGroup > 0\">{{deviceBrief.uGroup}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'uGroup\', curDevice[0].l);\" ng-if=\"deviceBrief.uGroup > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=text-muted ng-if=\"deviceBrief != \'\' && deviceBrief.uGroup == 0\">{{\'cm.label.19\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><!-- <span class=\"fa fa-home marR5\"></span>{{curContent[0].path}} {{curContent[0].path}} --> <span class=\"fa fa-home marR5\" ng-if=\"deviceBrief != \'\' && deviceBrief.path\" aria-hidden=true></span>{{deviceBrief.path}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.path == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div></div><!-- ?New: Added Folder brief --><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.devices.d\' && selectedItems[0].type == \'folder\' && auth.upreferences.deviceView != \'l\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFolder[0].l}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.menu.5\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{dFolderBrief.deviceCount}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"dFolderBrief.deviceCount > 0\" ng-click=\"folderDeviceListFx(curFolder[0].id, curFolder[0].l);\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"dFolderBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=dFolderBrief.createdOn>{{(dFolderBrief.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"dFolderBrief.createdOn == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab != \'hub.templates.ut\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curTemplate[0].approvedOn>{{(curTemplate[0].approvedOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curTemplate[0].approvedOn == null\">N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=dFolderBrief.createdBy>{{dFolderBrief.createdBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"dFolderBrief != \'\' && !dFolderBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"dFolderBrief== \'\'\"></div></div><!-- <div class=\"col-xs-6\" ng-if=\"selectedTab != \'hub.templates.ut\' && curTemplate.length\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.5\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 brief-col\">\r\n                      <span ng-if=\"templateBrief.approvedBy\">{{templateBrief.approvedBy}}</span>\r\n                      <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.approvedBy == null\">N/A</span>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"templateBrief == \'\'\">\r\n                    </div>\r\n                  </div> --></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"dFolderBrief != \'\' && dFolderBrief.editedOn\">{{(dFolderBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} </span><span class=\"text-muted text-sm\" ng-if=\"dFolderBrief != \'\' && !dFolderBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"dFolderBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"dFolderBrief.editedBy && dFolderBrief.editedBy != 0\">{{dFolderBrief.editedBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"dFolderBrief != \'\' && (!dFolderBrief.editedBy || dFolderBrief.editedBy == 0)\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"dFolderBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><!-- <span class=\"fa fa-home marR5\"></span>{{curContent[0].path}} {{curContent[0].path}} --> <span class=\"fa fa-home marR5\" ng-if=\"dFolderBrief != \'\' && dFolderBrief.path\" aria-hidden=true></span>{{dFolderBrief.path}} <span class=\"text-muted text-sm\" ng-if=\"dFolderBrief != \'\' && dFolderBrief.path == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"dFolderBrief == \'\'\"></div></div></div></div><!-- Device --><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.devices.d\' && curDevice[0].t == 7 && selectedItems[0].subType != \'folder\' && curFolder[0].type != \'Folder\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curDevice[0].l}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span>{{curDevice[0].h}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"deviceBrief.de && (curDevice[0].t == 1 || curDevice[0].t == 7 || curDevice[0].t == 3 || curDevice[0].t == 2)\" ng-click=\"deviceIdOpen(curDevice[0].id,curDevice[0].l,curDevice[0].h,\'brief\');\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-pencil noMar\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=deviceBrief.de ngclipboard data-clipboard-text={{curDevice[0].h}} uib-tooltip=\"{{\'d.tool.17\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-files-o noMar\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"deviceBrief.de && deviceBrief.history\" ng-click=devicePCOpen(curDevice[0].id,curDevice[0].l,curDevice[0].h); uib-tooltip=\"{{\'d.tool.18\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-history noMar\" aria-hidden=true></span></button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=!deviceBrief.createdOn> <span ng-if=deviceBrief.createdOn>{{(deviceBrief.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.label.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{\'d.label.1.4\' | translate}}</div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.content.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.content.a}}</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.content.a == 0 && deviceBrief.content.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.content.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.content.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"contentCountFx(curDevice[0].id, curDevice[0].l, curDevice[0].h, deviceBrief.content, curDevice[0].t);\" ng-if=\"deviceBrief.content.a + deviceBrief.content.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.content.a + deviceBrief.content.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.editedOn\">{{(deviceBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curDevice[0].id, \'device\', curDevice[0].l);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.3s\' | translate}}:</div><!-- <div class=\"col-xs-7 brief-col ng-cloak\">\r\n                      <span ng-if=\"deviceBrief.schedule > 0\">{{deviceBrief.schedule}}</span>\r\n                      <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'schedule\', curDevice[0].l);\" ng-if=\"deviceBrief.schedule > 0\">{{\'cm.btn.21\' | translate}}</button>\r\n                      <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.schedule == 0\">N/A</span>\r\n                    </div> --><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.schedule.a}}</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a == 0 && deviceBrief.schedule.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceBrief.schedule.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'schedule\', curDevice[0].l, deviceBrief.schedule);\" ng-if=\"deviceBrief.schedule.a + deviceBrief.schedule.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.schedule.a + deviceBrief.schedule.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief.length == 0\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.tag > 0\">{{deviceBrief.tag}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'tag\', curDevice[0].l);\" ng-if=\"deviceBrief.tag > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && deviceBrief.tag == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row ng-if=\"curDevice[0].t!=7\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.body.16\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.dsk.t><span ng-if=deviceBrief.dsk.u uib-tooltip=\"{{\'d.body.16.1\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.dsk.u*1024) | filesize}} / </span><span uib-tooltip=\"{{\'d.body.16.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.dsk.t*1024) | filesize}}</span> </span><span ng-if=!deviceBrief.dsk.t class=\"text-sm text-muted\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'b.o.26\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=deviceBrief.mem.t><span ng-if=deviceBrief.mem.u uib-tooltip=\"{{\'d.body.16.1\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.mem.u*1024) | filesize}} / </span><span uib-tooltip=\"{{\'d.body.16.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true>{{(deviceBrief.mem.t*1024) | filesize}}</span> </span><span ng-if=!deviceBrief.mem.t class=\"text-sm text-muted\">N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.19\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"configOpen(curDevice[0].l, curDevice[0].h);\">{{\'cm.btn.21\' | translate}}</button></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.brief.24.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span class=\"text-muted text-sm marR5\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count == 0\">N/A</span> <span ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{deviceBriefTicket.count}}</span> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(deviceBriefTicket.ticket,curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button><!-- <button type=\"button\" role=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"deviceTicketOpen(curDevice[0].id, curDevice[0].l);\" ng-if=\"deviceBriefTicket != \'\' && deviceBriefTicket.count > 0\">{{\'cm.btn.21\' | translate}}</button> --> <button type=button role=button class=\"btn btn-xs btn-default\" ng-click=bugsOpen(curDevice[0].id); ng-if=\"deviceBriefTicket != \'\'\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBriefTicket == \'\'\"></div></div></div><!-- User Groups --><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'u.tab.2\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"deviceBrief.uGroup > 0\">{{deviceBrief.uGroup}}</span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'uGroup\', curDevice[0].l);\" ng-if=\"deviceBrief.uGroup > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=text-muted ng-if=\"deviceBrief != \'\' && deviceBrief.uGroup == 0\">{{\'cm.label.19\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.tool.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><button type=button role=button class=\"btn btn-xs btn-default\" ng-click=\"countListFx(curDevice[0].id, \'dbInfo\', curDevice[0].l, deviceBrief.schedule);\">{{\'cm.btn.21\' | translate}}</button></div></div></div></div><!-- Device tags --><div class=\"table no-th no-border\" ng-if=\"selectedTab != \'hub.devices.d\' && curDevice[0].type == \'tag\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curDevice[0].label}} <span class=\"text-muted text-sm\" ng-if=!curDevice[0].label>N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{curDevice[0].deviceCount}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'device\', curDevice[0].label);\" ng-if=\"curDevice[0].deviceCount > 0\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{(curDevice[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.label.33\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"curDevice[0].deviceCount == 0\" class=\"text-muted text-sm\">N/A</span> <button ng-if=\"curDevice[0].deviceCount != 0\" type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id,\'userGroup\', curDevice[0].label);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{curDevice[0].createdBy}} <span class=\"text-muted text-sm\" ng-if=!curDevice[0].createdBy>N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curDevice[0].editedOn>{{(curDevice[0].editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curDevice[0].id, \'deviceGroup\', curDevice[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=!curDevice[0].editedOn>N/A</span></div></div><div class=col-xs-6></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{curDevice[0].editedBy}} <span class=\"text-muted text-sm\" ng-if=!curDevice[0].editedBy>N/A</span></div></div><div class=col-xs-6></div></div></div><!-- Devices Groups --><div class=\"table no-th no-border\" ng-if=\"selectedTab != \'hub.devices.d\' && curGroups[0].type == \'group\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curGroups[0].label}} <span class=\"text-muted text-sm\" ng-if=!curGroups[0].label>N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.deviceCount}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curGroups[0].id, \'device\', curGroups[0].label);\" ng-if=\"deviceBrief.deviceCount > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{(curGroups[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.editedOn\">{{(deviceBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curGroups[0].id, \'deviceGroup\', curGroups[0].l);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6></div></div></div><!-- <div class=\"table no-th no-border\" ng-if=\"selectedTab != \'hub.devices.d\' && curDevice[0].type == \'group\'\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 text-bold text-ellipsis-wrap\">\r\n                      {{curDevice[0].label}}\r\n                      <span class=\"text-muted text-sm\" ng-if=\"!curDevice[0].label\">N/A</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 brief-col\">\r\n                      {{deviceBrief.deviceCount}}\r\n                      <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curDevice[0].id, \'device\', curDevice[0].l);\" ng-if=\"deviceBrief.deviceCount > 0\">{{\'cm.btn.21\' | translate}}</button>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"deviceBrief == \'\'\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 brief-col\">{{(curDevice[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 brief-col\">\r\n                      {{deviceBrief.createdBy}}\r\n                      <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"deviceBrief == \'\'\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 text-bold\">\r\n                      <span ng-if=\"deviceBrief != \'\' && deviceBrief.editedOn\">\r\n                        {{(deviceBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}}\r\n                        <a href=\"\" role=\"link\" class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curDevice[0].id, \'deviceGroup\', curDevice[0].l);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a>\r\n                      </span>\r\n                      <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedOn\">N/A</span>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"deviceBrief == \'\'\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-6\"></div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-6\">\r\n                    <div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div>\r\n                    <div class=\"col-xs-7 brief-col\">\r\n                      {{deviceBrief.editedBy}}\r\n                      <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedBy\">N/A</span>\r\n                      <img alt=\"Loading\" src=\"assets\\images\\loading-xs.gif\" ng-if=\"deviceBrief == \'\'\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-xs-6\"></div>\r\n                </div>\r\n              </div> --><!-- Saved search --><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.devices.dg\' && curSearches[0].type == \'search\'\"><div class=col-xs-6><div class=row><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{curSearches[0].label}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !curSearches[0].label\">N/A</span></div></div><div class=row><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=curSearches[0].createdOn>{{(curSearches[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=!curSearches[0].createdOn>N/A</span></div></div><div class=row><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.devices}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(deviceBrief, \'search\', curSearches[0].label);\" ng-if=\"deviceBrief.devices != 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=col-xs-3><div class=bg-light style=height:170px><div class=\"pad5 bdr-btm-dashed marB5\"><label class=noMarB><span class=\"fa fa-tag marR5\" aria-hidden=true></span>{{\'as.label.6\' | translate}} <span ng-if=deviceBrief.iType>| {{deviceBrief.iType | uppercase}}</span></label></div><ul class=\"list-unstyled scrollQuad\" style=max-height:130px><li class=pad5 ng-class=\"{\'d-flex align-items-center\':auth.upermissions.dtc}\" ng-repeat=\"inc in deviceBrief.include\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{inc.tagColor}}></ng-tag-icon></span>{{inc.label}}</li></ul><div class=\"padL5 padB5\"><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.include.length\">N/A</span></div></div></div><div class=col-xs-3><div class=bg-light style=height:170px><div class=\"pad5 bdr-btm-dashed marB5\"><label class=noMarB><span class=\"fa fa-tag marR5\" aria-hidden=true></span>{{\'as.label.7\' | translate}} <span ng-if=deviceBrief.eType>| {{deviceBrief.eType | uppercase}}</span></label></div><ul class=\"list-unstyled scrollQuad\" style=max-height:130px><li class=pad5 ng-class=\"{\'d-flex align-items-center\':auth.upermissions.dtc}\" ng-repeat=\"exc in deviceBrief.exclude\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{exc.tagColor}}></ng-tag-icon></span>{{exc.label}}</li></ul><div class=\"padL5 padB5\"><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"> <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.exclude.length\">N/A</span></div></div></div></div><!-- Devices Video Wall --><div class=\"table no-th no-border\" role=table ng-if=\"selectedTab == \'hub.devices.dvw\' && curWall[0].type == \'videowall\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curWall[0].label}} <span class=\"text-muted text-sm\" ng-if=!curWall[0].label>N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.deviceCount}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curWall[0].id, \'videowall\', curWall[0].label);\" ng-if=\"deviceBrief.deviceCount > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.6\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{(curWall[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.7\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.createdBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"deviceBrief != \'\' && deviceBrief.editedOn\">{{(deviceBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curWall[0].id, \'deviceGroup\', curWall[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{deviceBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"deviceBrief != \'\' && !deviceBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"deviceBrief == \'\'\"></div></div><div class=col-xs-6></div></div></div></div></div></ul></div><!--For Multiple selected--><div class=\"thumb-list hoverContainer\" ng-if=\"selectedItems.length > 1\"><li ng-init=\"curDevice = (devices.devices | filter:{id:selectedItems[$index].id, type:selectedItems[$index].subType}:true | orderBy: \'id\')\" ng-repeat=\"device in selectedItems\" data-id={{device.id}} class=\"device valign-top\">{{curFolder = (folderList | folderBrief:selectedItems[$index] | orderBy:\'id\');\"\"}} {{curSearches = (devices.searches | filter:{id:selectedItems[$index].id, type:selectedItems[$index].subType}:true | orderBy: \'id\');\"\"}} {{curWall = (devices.walls | filter:{id:selectedItems[$index].id, type:selectedItems[$index].subType}:true | orderBy: \'id\');\"\"}}<div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"closeFx(device.id, device.type);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (curDevice[0].t && curDevice[0].t != 7),\'thumb-group\': item.t == \'g\', \'mcPlayer\': curDevice[0].t && curDevice[0].t == 7}\"><!-- ?New: Folder --> <img alt=Folder ng-if=\"selectedTab == \'hub.devices.d\' && curFolder[0].type == \'Folder\'\" src=assets/images/default/folder_{{thumbSize}}.png> <a ng-if=\"curDevice[0].tv != 0 && (curDevice[0].t == 1 || curDevice[0].t == 3 || curDevice[0].t == 2 || curDevice[0].t == 11 || curDevice[0].t == 10 || curDevice[0].t == 7 || curDevice[0].t == 9)\" ng-href=\"{{thumbHost + detailBucket + curDevice[0].h + \'.jpg\' | secureThumb:curDevice[0].tv}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{curDevice[0].l}}><img alt=\"\" ng-class=\"{\'thumb-multi\': (curDevice[0].t && curDevice[0].t != 7)}\" ng-src=\"{{thumbHost + tim + bucket + curDevice[0].h + \'.jpg&\' + (curDevice[0].tv?curDevice[0].tv:curTimestamp) + dThumbParam}}\" src-error={{thumbHost}}/assets/images/default/device_{{curDevice[0].t}}.png class=\"img-responsive center-block blackOutline\"> </a><img alt=ds_{{curDevice[0].t}} ng-if=\"curDevice[0].tv == 0 && selectedTab != \'hub.devices.dg\' && selectedTab != \'hub.devices.dt\'\" ng-src={{thumbHost}}/assets/images/default/device_{{curDevice[0].t}}.png class=\"img-responsive center-block blackOutline img-device\"><!-- <img alt=\"ds_{{curDevice[0].t}}\" ng-if=\"((!curDevice[0].tv && auth.upreferences.deviceView == \'l\') || curDevice[0].tv == 0) && selectedTab != \'hub.devices.dg\' && selectedTab != \'hub.devices.dt\'\" ng-src=\"assets/images/default/device_selected_{{curDevice[0].t}}.png\" class=\"img-responsive center-block blackOutline img-device\"> --> <img alt=dts ng-if=\"curDevice[0].type == \'tag\' && !auth.upermissions.dtc\" src=assets/images/default/device_tag_selected.png class=\"img-responsive center-block blackOutline img-tag\"><!-- <svg alt=\"dts\" ng-if=\"curDevice[0].type == \'tag\' && auth.upermissions.dtc\" class=\"img-responsive center-block blackOutline img-tag\" xmlns=\"http://www.w3.org/2000/svg\" width=\"215\" height=\"135\" viewBox=\"0 0 215 135\">\r\n                  <defs></defs>\r\n                  <path class=\"tagSvgCls rule\" ng-style=\"{\'stroke\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#57aee3\'}\" d=\"M2,2H213V133H2V2Z\"/>\r\n                  <path id=\"Forma_1\" data-name=\"Forma 1\" ng-style=\"{\'fill\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#57aee3\'}\" d=\"M148.506,75.751a7.371,7.371,0,0,0-1.991-5.115L108.054,30.511a16.592,16.592,0,0,0-5.487-3.625A16.017,16.017,0,0,0,96.273,25.4H73.9a6.482,6.482,0,0,0-4.841,2.135A7.066,7.066,0,0,0,67.01,32.59V55.969a18,18,0,0,0,1.425,6.575,16.865,16.865,0,0,0,3.47,5.676l38.462,40.237a6.448,6.448,0,0,0,4.841,2.08,6.734,6.734,0,0,0,4.895-2.08l26.412-27.649A7.044,7.044,0,0,0,148.506,75.751ZM89.092,48.466a6.675,6.675,0,0,1-9.737,0,7.421,7.421,0,0,1,0-10.171,6.676,6.676,0,0,1,9.737,0A7.42,7.42,0,0,1,89.092,48.466Z\"/>\r\n                </svg> --> <svg alt=\"\" ng-if=\"curDevice[0].type == \'tag\' && auth.upermissions.dtc\" class=\"img-responsive center-block blackOutline img-tag\" xmlns=http://www.w3.org/2000/svg width=64 height=38 viewBox=\"0 0 64 38\"><rect x=1 y=1 width=62 height=36 ng-style=\"{\'fill\':\'#FFFFFF\',\'stroke\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#53a7da\',\'stroke-width\':\'2\',\'stroke-miterlimit\':\'10\'}\"/><path id=Forma_1 data-name=\"Forma 1\" ng-style=\"{\'fill\':(curDevice[0].tagColor)?curDevice[0].tagColor:\'#53a7da\'}\" d=\"M41.72,20.86c0-0.46-0.16-0.87-0.47-1.22l-9.18-9.58c-0.33-0.34-0.76-0.63-1.31-0.87 c-0.55-0.24-1.05-0.36-1.5-0.36h-5.34c-0.44,0-0.83,0.17-1.16,0.51c-0.33,0.34-0.49,0.74-0.49,1.21v5.58c0,0.47,0.11,1,0.34,1.57 c0.23,0.57,0.5,1.02,0.83,1.35l9.18,9.6c0.32,0.33,0.7,0.5,1.16,0.5c0.45,0,0.83-0.17,1.17-0.5l6.3-6.6 C41.57,21.73,41.72,21.33,41.72,20.86z M27.55,14.35c-0.32,0.34-0.71,0.5-1.16,0.5c-0.45,0-0.84-0.17-1.16-0.5 c-0.32-0.34-0.48-0.74-0.48-1.21c0-0.47,0.16-0.88,0.48-1.21c0.32-0.34,0.71-0.5,1.16-0.5c0.45,0,0.84,0.17,1.16,0.5 c0.32,0.34,0.48,0.74,0.48,1.21C28.03,13.61,27.87,14.01,27.55,14.35z\"/></svg> <span ng-if=\"curDevice[0].type == \'group\'\" class=thumb-group-img><img alt=dgs src=assets/images/default/device_group.png class=\"img-responsive center-block blackOutline\"> </span><span ng-if=\"curWall[0].type == \'videowall\'\" class=\"thumb-group-img relative\"><span class=matrix-badge ng-class=\"{selectedItems.length > 1?\'small\':\'big\'}\" ng-if=\"curWall[0].matrix != \'\'\">{{curWall[0].matrix}}</span> <img class=bdrDark alt=dgs src=assets/images/default/device_videowall.png class=\"img-responsive center-block blackOutline\"> </span><img alt=dss ng-if=\"curSearches[0].type == \'search\'\" src=assets/images/default/device_search_selected_sm.png></span></div><div class=thumb-label ng-if=curFolder[0].l uib-tooltip={{curFolder[0].l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curFolder[0].l}}</div><div class=thumb-label ng-if=curDevice[0].l uib-tooltip={{curDevice[0].l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curDevice[0].l}}</div><div class=thumb-label ng-if=curDevice[0].label uib-tooltip={{curDevice[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curDevice[0].label}}</div><div class=thumb-label ng-if=curSearches[0].label uib-tooltip={{curSearches[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curSearches[0].label}}</div><div class=thumb-label ng-if=curWall[0].label uib-tooltip={{curWall[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curWall[0].label}}</div></div></li></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=\"deviceBtn.length==0\"> <a href=\"\" role=link id=dInfo class=\"pull-left marT6\" ng-click=btnInfoOpen(deviceBtn.info); ng-if=deviceBtn.info.length><img src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"deviceBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=deviceBtn><!-- TODO: added for button --><li class=\"btn-group dropup\" uib-dropdown ng-if=\"deviceBtn.buttons.length && selectedItems[0].type == \'folder\'\"><!-- <div ng-if=\"dBtn.key==\'dMove\'\">\r\n            <button type=\"button\" ng-click=\"moveOpen(selectedItems[0].id);\" class=\"btn btn-default\"><span class=\"fa fa-folder-open\"></span>{{\'cl.btn.6\' | translate}}</button>\r\n          </div> --><!-- <button type=\"button\" class=\"btn btn-default marR5\" uib-dropdown-toggle ng-disabled=\"disabled\">\r\n            {{\'cm.btn.23\' | translate}} <span class=\"caret\"></span>\r\n          </button>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu>\r\n            <li ng-repeat=\"mBtn in deviceBtn.buttons\">\r\n              <a href=\"\" id=\"tEdit\" ng-if=\"mBtn.key==\'dEditFolder\'\" ng-click=\"folderCUOpen(\'n\', \'edit\');\"><span class=\"fa fa-pencil marR10\"></span>{{\'cm.btn.22\' | translate}}</a>\r\n              <a href=\"\" id=\"tMove\" ng-if=\"mBtn.key==\'dMove\'\" ng-click=\"moveOpen(selectedItems[0].id);\"><span class=\"fa fa-folder-open marR10\"></span>{{\'cl.btn.6\' | translate}}</a>\r\n            </li>\r\n          </ul> --> <span ng-repeat=\"dBtn in deviceBtn.buttons\"><button type=button role=button ng-if=\"dBtn.key==\'dEditFolder\'\" ng-click=\"folderCUOpen(\'n\', \'edit\');\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dMove\'\" ng-click=moveOpen(selectedItems[0].id); class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.6\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dOpenFolder\'\" ng-click=folderContentFx(selectedItems[0].id); class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dAddToGroup\'\" ng-click=addToGrpOpen(); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.29\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dDelete\' || dBtn.key==\'dDeleteFolder\'\" ng-click=\"deleteOpen(\'device\', selectedItems[0].id, selectedItems);\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dPin\'\" ng-click=\"pinToDBFx(selectedItems[0],\'d\');\" class=\"btn btn-default\"><span class=\"fa fa-thumb-tack\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</button></span></li><!-- TODO: added for button --><li class=hide><button type=button role=button class=\"btn btn-primary\" ui-sref=\"hub.dContainer.pl({id: encId})\"><span class=\"fa fa-play\" aria-hidden=true></span>{{\'d.btn.8\' | translate}}</button></li><!-- this is only test --><li class=hide><button type=button role=button class=\"btn btn-primary\" ui-sref=\"hub.dContainer.plLsn({id: encId})\"><span class=\"fa fa-play\" aria-hidden=true></span>{{\'d.btn.8\' | translate}}-LSN</button></li><!-- this is only test --><li ng-repeat=\"dBtn in deviceBtn.buttons\" ng-if=\"selectedItems[0].type != \'folder\'\"><div ng-if=\"dBtn.key==\'dEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.dContainer.dName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button uib-dropdown-toggle class=\"btn btn-primary\"><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in dBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'dStep1\'\" ui-sref=\"hub.dContainer.dName({id: encId})\">{{\'d.btn.4\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'dStep2\'\" ui-sref=\"hub.dContainer.dFrameLayout({id: encId})\">{{\'d.btn.5\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'dStep3\'\" ui-sref=\"hub.dContainer.dTag({id: encId})\">{{\'d.btn.6\' | translate}}</a></li></ul></div><div ng-if=\"dBtn.key==\'tEdit\'\" class=\"btn-group dropup hide\" uib-dropdown><button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=\"fa fa-tags\" aria-hidden=true></span>{{\'d.tab.3\' | translate}} <span class=caret></span></button><ul uib-dropdown-menu role=menu><li ng-repeat=\"step in dBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'tStep1\'\" ng-click=\"addRemoveTagOpen(\'a\');\">{{\'fl.btn.5\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'tStep2\'\" ng-click=\"addRemoveTagOpen(\'r\');\">{{\'cm.btn.20\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"dBtn.key==\'tEdit\'\" ng-click=assignTagOpen(); class=\"btn btn-primary\"><span class=\"fa fa-tags\" aria-hidden=true></span>{{\'d.tab.3\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dAddToGroup\'\" ng-click=addToGrpOpen(); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.29\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dSimilar\'\" ng-click=similarOpen(); class=\"btn btn-default\"><span class=\"fa fa-object-group\" aria-hidden=true></span>{{\'d.btn.10\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dPreview\'\" ng-click=previewOpen(); class=\"btn btn-default\"><span class=\"fa fa-film\" aria-hidden=true></span>{{\'d.btn.7\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dDelete\'\" ng-click=\"deleteOpen(\'device\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button><!-- TODO: adding button for folder --><div ng-if=\"dBtn.key==\'dMove\'\"><button type=button role=button ng-click=moveOpen(selectedItems[0].id); class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.6\' | translate}}</button></div><!--Button Quad for Group Start  uib-dropdown--><div ng-if=\"dBtn.key==\'dgEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.dContainer.dgName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button uib-dropdown-toggle class=\"btn btn-primary\"><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in dBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'dgStep1\'\" ui-sref=\"hub.dContainer.dgName({id: encId})\">{{\'cm.brief.1\' | translate}}</a><!-- With tag --> <a href=\"\" role=link ng-if=\"step.key==\'dgStep2\'\" ui-sref=\"hub.dContainer.dgDevice({id: encId})\">{{\'d.btn.13\' | translate | camelCase}}</a><!-- Without tag --></li></ul></div><!--Button Quad for Tags Start  uib-dropdown--><div ng-if=\"dBtn.key==\'dtEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.dContainer.dtName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button uib-dropdown-toggle class=\"btn btn-primary\"><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in dBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'dtStep1\'\" ui-sref=\"hub.dContainer.dtName({id: encId})\">{{\'cm.brief.1\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'dtStep2\'\" ui-sref=\"hub.dContainer.dtDevice({id: encId})\">{{\'cm.label.31\' | translate | camelCase}}</a></li></ul></div><button type=button role=button ng-if=\"dBtn.key==\'seEdit\'\" ng-click=seEditFx(); class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dtDelete\'\" ng-click=\"deleteOpen(\'tag\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dgDelete\'\" ng-click=\"deleteOpen(\'group\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dsDelete\'\" ng-click=\"deleteOpen(\'search\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dtOpen\'\" ng-click=\"openTypeFx(selectedItems[0], 0);\" class=\"btn btn-default\"><span class=\"fa fa-folder-open marR10\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dPin\'\" ng-click=\"pinToDBFx(selectedItems[0],\'d\');\" class=\"btn btn-default\"><span class=\"fa fa-thumb-tack\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dvwEdit\'\" ui-sref=\"hub.dContainer.dvwName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"dBtn.key==\'dvwDelete\'\" ng-click=\"deleteOpen(\'videowall\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button></li></ul></div><!--Button Quad End--></section></div>");
$templateCache.put("app/devices/dir/deviceGroupThumb.html","<img alt=Loading src=assets/images/loading.gif ng-if=\"selectedTab == \'hub.devices.d\' && moreDeviceLoading\"><!-- Schedule group section start--> <span ng-if=\"selectedTab != \'hub.devices.dg\'\"><div ng-if=!moreDeviceLoading><li ng-repeat=\"device in filteredDeviceList = (sDeviceList.groups | customSearch:{key:searchTextS.text, module:\'d\'}) | filter: (((selectedT==\'1\' && selectedTab != \'hub.devices.dg\') || (selectedT==\'4\' && vwBreadCrumbs.length))?{status:filterType}:\'\')\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'device\': selectedTab == \'hub.devices.d\', \'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" context-menu=contextMenuOpt><!-- Bellow condition applied li tag but its not usable also creating issue --><!--  ng-if=\"filter == \'all\' || filter == device.status || auth.upermissions.dp\" --> {{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': device.type === \'device\',\'thumb-group\': device.type == \'group\', \'mcPlayer\': device.t == 7}\"><img alt={{device.t}} ng-if=\"device.tv != 0 && (device.t == 1 || device.t == 3 || device.t == 2)\" ng-src=\"{{tim + bucket + (device.h | removeColon) + \'.jpg\' + \'&\' + device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png> <img alt=d_{{device.t}} ng-if=\"device.tv == 0 || (!device.tv && device.type === \'device\' && device.t != 1 && device.t != 3 && device.t != 2)\" ng-src=assets/images/default/device_{{device.t}}.png> <img alt=dg ng-if=\"device.type === \'group\'\" src=assets/images/default/device_group.png> <img alt=ds ng-if=\"device.type === \'search\'\" src=assets/images/default/device_search.png><!-- (auth.uType == 0 || auth.uType == 1) && device.space != null && device.space < 51200  removed space key--> <span class=\"thumb-icon space\" ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\"><span class=\"fa fa-exclamation-triangle text-danger\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 aria-hidden=true></span></span><!-- <span class=\"thumb-icon status\" role=\"status\" ng-if=\"device.status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.status}}\"></span></span> --> <span class=\"thumb-icon status\" role=status ng-if=device.status title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span></span></div><!-- <div class=\"downloadedBar\" ng-if=\"showDownload\" uib-tooltip=\"{{\'d.ph.3\' | translate:{no:device.dp} }}\" tooltip-enable=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\">\r\n                <div style=\"width:{{device.dp}}%\" ng-if=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\"></div>\r\n            </div> --><div class=thumb-label ng-if=device.l uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div><div class=thumb-label ng-if=device.label uib-tooltip={{device.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.label}}</div></li><li ng-repeat=\"search in filteredSearchList = (sDeviceList.searches | customSearch:{key:searchTextS.text, module:\'d\'}) | filter: ((selectedT==\'1\' && selectedTab != \'hub.devices.dg\')?{status:filterType}:\'\')\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)\" data-id={{search.id}} data-type={{search.type}} data-sub-type={{search.type}} ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)}\" context-menu=contextMenuOpt class=tabIndex>{{curMsg = ((search.isConflict != 0 && search.isConflict == 1)?\'\'+conflictSearchMsg+\'\':\'\'+conflictSearchMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner><img alt=ds src=assets/images/default/device_search_selected_sm.png></span></div><div class=thumb-label uib-tooltip={{search.label}} tooltip-append-to-body=true tooltip-placement=top tooltip-class=tooltip-break tooltip-popup-delay=1000>{{search.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredDeviceList.length + filteredSearchList.length == 0\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextS.text)}}&quot;</b>\'}\"></div></div></span><!-- Schedule group section end--><!-- Device group section start--> <span ng-if=\"selectedTab == \'hub.devices.dg\'\"><div ng-if=!moreDeviceLoading><li ng-repeat=\"device in filteredDeviceList = (devices.devices | customSearch:{key:search.text, module:\'d\'}) | filter: (((selectedT==\'1\' && selectedTab != \'hub.devices.dg\') || (selectedT==\'4\' && vwBreadCrumbs.length))?{status:filterType}:\'\')\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'device\': selectedTab == \'hub.devices.d\', \'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" context-menu=contextMenuOpt><!-- Bellow condition applied li tag but its not usable also creating issue --><!--  ng-if=\"filter == \'all\' || filter == device.status || auth.upermissions.dp\" --> {{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': device.type === \'device\',\'thumb-group\': device.type == \'group\', \'mcPlayer\': device.t == 7}\"><img alt={{device.t}} ng-if=\"device.tv != 0 && (device.t == 1 || device.t == 3 || device.t == 2)\" ng-src=\"{{tim + bucket + (device.h | removeColon) + \'.jpg\' + \'&\' + device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png> <img alt=d_{{device.t}} ng-if=\"device.tv == 0 || (!device.tv && device.type === \'device\' && device.t != 1 && device.t != 3 && device.t != 2)\" ng-src=assets/images/default/device_{{device.t}}.png> <img alt=dg ng-if=\"device.type === \'group\'\" src=assets/images/default/device_group.png> <img alt=ds ng-if=\"device.type === \'search\'\" src=assets/images/default/device_search.png><!-- (auth.uType == 0 || auth.uType == 1) && device.space != null && device.space < 51200  removed space key--> <span class=\"thumb-icon space\" ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\"><span class=\"fa fa-exclamation-triangle text-danger\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 aria-hidden=true></span></span><!-- <span class=\"thumb-icon status\" role=\"status\" ng-if=\"device.status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.status}}\"></span></span> --> <span class=\"thumb-icon status\" role=status ng-if=device.status title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span></span></div><!-- <div class=\"downloadedBar\" ng-if=\"showDownload\" uib-tooltip=\"{{\'d.ph.3\' | translate:{no:device.dp} }}\" tooltip-enable=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\">\r\n                <div style=\"width:{{device.dp}}%\" ng-if=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\"></div>\r\n            </div> --><div class=thumb-label ng-if=device.l uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div><div class=thumb-label ng-if=device.label uib-tooltip={{device.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.label}}</div></li><li ng-repeat=\"search in filteredSearchList = (devices.searches | customSearch:{key:search.text, module:\'d\'}) | filter: ((selectedT==\'1\' && selectedTab != \'hub.devices.dg\')?{status:filterType}:\'\')\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)\" data-id={{search.id}} data-type={{search.type}} data-sub-type={{search.type}} ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)}\" context-menu=contextMenuOpt class=tabIndex>{{curMsg = ((search.isConflict != 0 && search.isConflict == 1)?\'\'+conflictSearchMsg+\'\':\'\'+conflictSearchMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner><img alt=ds src=assets/images/default/device_search_selected_sm.png></span></div><div class=thumb-label uib-tooltip={{search.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{search.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredDeviceList.length + filteredSearchList.length == 0 && devices.groups.length + devices.searches.length > 0\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div></div></span><!-- Device group section end-->");
$templateCache.put("app/devices/dir/deviceList.html","<div class=\"panel-body noPadT noPadB dTable\" role=table><!-- Folder List start --><div ng-class=\"{\'marB40\': (filteredFolderList.length > 0 && !advSearchInfo.isEmpty)}\"><div class=\"row th\" ng-if=\"filteredFolderList.length > 0 && !advSearchInfo.isEmpty\"><div class=col-xs-10>{{\'cl.p_f.3\' | translate | camelCase}}</div><div class=\"col-xs-2 text-right noPadL\" ng-if=\"!$state.includes(\'hub.reports.c\') && !$state.includes(\'hub.reports.d\') && !$state.includes(\'hub.sContainer.sDevice\') && !$state.includes(\'hub.dContainer.dtDevice\') && !$state.includes(\'hub.dContainer.dgDevice\') && !$state.includes(\'hub.flContainer.flaDevice\') && !$state.includes(\'hub.sContainer.sDevice\') && (auth.upermissions.dfag || auth.upermissions.dfm || auth.upermissions.dfe || auth.upermissions.dfd) && !$state.includes(\'hub.reports.hds\') && !$state.includes(\'hub.dContainer.dvwName\')\">{{\'d.tab.6\' | translate}}</div></div><div><div class=\"folderQuad nonSelectable\" ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'df\'})\" ng-if=\"folderList.length && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && (!advSearchInfo.isEmpty)\"><div class=nonSelectable><!--Folder--><div class=folder-heading data-id={{folder.id}} ng-class=\"{\'text-muted\':!folder.isActive}\"><div ng-class=\"(!$state.includes(\'hub.reports.c\') && !$state.includes(\'hub.reports.d\') && !$state.includes(\'hub.sContainer.sDevice\') && !$state.includes(\'hub.dContainer.dtDevice\') && !$state.includes(\'hub.dContainer.dgDevice\') && !$state.includes(\'hub.flContainer.flaDevice\') && !$state.includes(\'hub.reports\') && !$state.includes(\'hub.dContainer.dvwName\')) ? \'col-xs-10\':\'col-xs-12\'\" class=\"text-bold text-ellipsis folder\" ng-click=folderContentFx(folder.id); data-id={{folder.id}}><a role=button><span class=\"fa fa-folder marR5\"></span>{{folder.l}} <span class=\"text-muted text-unbold text-sm\">&nbsp;</span></a></div><div class=\"col-xs-2 text-right\" ng-if=\"!$state.includes(\'hub.reports.c\') && !$state.includes(\'hub.reports.d\') && !$state.includes(\'hub.sContainer.sDevice\') && !$state.includes(\'hub.dContainer.dtDevice\') && !$state.includes(\'hub.dContainer.dgDevice\') && !$state.includes(\'hub.flContainer.flaDevice\') && !$state.includes(\'hub.reports\') && !$state.includes(\'hub.dContainer.dvwName\')\"><a ng-if=dbPinStatus href=\"\" class=\"text-primary marR5\" ng-click=\"pinToDBFx(folder,\'dl\');\" uib-tooltip=\"{{\'cm.label.98\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-thumb-tack\"></span></a> <a ng-if=auth.upermissions.dfag href=\"\" class=\"text-primary marR5\" ng-click=\"addToGrpOpen(\'lvFolder\', folder);\" uib-tooltip=\"{{\'cm.btn.29\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-plus-circle\"></span></a> <a ng-if=auth.upermissions.dfm href=\"\" class=\"text-primary marR5\" ng-click=\"moveOpen(folder, \'lvFolder\');\" uib-tooltip=\"{{\'cl.btn.6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-folder-open\"></span></a> <a ng-if=auth.upermissions.dfe href=\"\" class=\"text-primary marR5\" ng-click=\"lvFolderCUOpen(\'n\', folder.id);\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-pencil\"></span></a> <a ng-if=auth.upermissions.dfd href=\"\" class=text-danger ng-click=\"deleteOpen(\'lvFolder\', 0, folder);\" uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><span class=\"fa fa-close\"></span></a></div></div></div></div></div></div><!-- Folder List end --><div class=\"other-controller nonSelectable\" ng-if=\"auth.upreferences.deviceView == \'l\'\"><div class=\"d-flex align-items-center justify-end\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> {{isAdv = (advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)); \"\"}} <span ng-if=\"!devicesLoading && rdc\" uib-tooltip=\"{{isAdv?\'d.tool.26\':filter==\'online\'?\'d.tool.24\':filter==\'offline\'?\'d.tool.25\':\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left class=device-count>{{visibleDevices}} / {{rdc}}</span><dir-pagination-controls boundary-links=paginationControls.boundaryLinks max-size=paginationControls.maxSize on-page-change=pageChangeHandler(newPageNumber) max-page=totalPages load-more=isPageApiLoad></dir-pagination-controls></div></div><!-- Device List start --><div class=\"row th\" ng-if=\"!isSearchMsg && !isAdvSearchMsg && !isFilterMsg && devices.devices.length\"><!-- ng-if=\"(filteredDeviceList.length > 0)\" && filterCount != 0--><div ng-class=\"deviceLastPing?\'col-xs-4\':\'col-xs-8\'\">{{\'cm.label.71\' | translate | camelCase}}</div><div ng-class=\"{\'col-xs-3\':(deviceLastPing && showDownload), \'col-xs-4\':(!showDownload)}\">{{\'d.label.2\' | translate}}</div><div class=col-xs-2 ng-if=showDownload>{{\'cm.btn.17i\' | translate}}</div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{\'b.o.26\' | translate}}</div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{\'d.body.17\' | translate}}</div><div class=\"col-xs-2 text-right noPadL\" ng-if=deviceLastPing>{{\'d.body.10\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif class=marT10 ng-if=\"selectedTab == \'hub.devices.d\' && moreDeviceLoading\"><ul ng-if=!moreDeviceLoading><li dir-paginate=\"device in filteredDeviceList = ((devices.devices) | filter:{q:q, status:(selectedTab==\'hub.devices.d\'?filterType:\'\')} | itemsPerPage:paginationControls.pageSize | limitTo:50) track by device.id\" current-page=paginationControls.currPage uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status={{device.status}} data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'nonSelectable disabledRow\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" class=\"row tabIndex dListLiTag\" context-menu=contextMenuOpt>{{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=dListLiFirstDiv ng-class=\"deviceLastPing?\'col-xs-4\':\'col-xs-8\'\"><div class=text-ellipsis><input type=checkbox ng-click=\"checkboxFx($event, device.id);\" role=checkbox><label></label><span ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 class=\"fa fa-exclamation-triangle text-danger marR5\" aria-hidden=true></span><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" role=\"status\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span> --> <span class=\"deviceStatus {{device.status}}\" title=\"{{device.status | capitalize}}\" role=status aria-label={{device.status}}></span> {{device.l}}</div><div ng-if=\"auth.upermissions.dtc && curState==\'hub.devices.d\' && device.tl.length\" class=\"pull-right nonSelectable padT3 d-flex\" ng-class=\"{\'marR20\':device.tl.length > 5}\"><span ng-repeat=\"c in device.tl | limitTo:-5\" uib-tooltip={{devices.t[c].label}} tooltip-append-to-body=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{devices.t[c].tagColor}}></ng-tag-icon></span><a href ng-click=\"countListFx(device.id, \'tag\', device.l);\" ng-if=\"device.tl.length > 5\" class=colorCountBox ng-class=\"((device.tl.length + device.tln.length) - 5) < 99 ? \'w25\' : \'w35\'\" uib-tooltip=\"{{\'d.btn.29\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 data-count=\"+{{(device.tl.length + device.tln.length) - 5}}\"></a></div></div><div class=text-ellipsis ng-class=\"{\'col-xs-3\':(deviceLastPing && showDownload), \'col-xs-4\':(!showDownload)}\">{{device.h}}</div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{curMem = ((device.mem.u/device.mem.t)*100); \"\"}} <span ng-if=device.mem.t class=circle-pie style=\"background:radial-gradient({{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}} 36%, transparent 40%), conic-gradient(#5cb85c {{curMem}}%, #cccccc 0%)\" uib-tooltip=\"{{(device.mem.u*1024) | filesize}} / {{(device.mem.t*1024) | filesize}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=!device.mem class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{curDisk = ((device.dsk.u/device.dsk.t)*100); \"\"}} <span ng-if=device.dsk.t class=circle-pie style=\"background:radial-gradient({{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}} 36%, transparent 40%), conic-gradient(#5cb85c {{curDisk}}%, #cccccc 0%)\" uib-tooltip=\"{{(device.dsk.u*1024) | filesize}} / {{(device.dsk.t*1024) | filesize}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=!device.dsk class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-2 text-right noPadL\" ng-if=deviceLastPing><span ng-if=device.lp>{{(device.lp * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=!device.lp class=\"text-sm text-muted\">N/A</span></div></li><li dir-paginate=\"device in filteredDeviceList = ((devices.devices) | filter:{q:q, status:(selectedTab==\'hub.devices.d\'?filterType:\'\')} | remainItemPerPage:paginationControls.pageSize) track by device.id\" current-page=paginationControls.currPage uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status={{device.status}} data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'nonSelectable disabledRow\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" class=\"row tabIndex dListLiTag remDeviceList\" context-menu=contextMenuOpt ng-if=!showRemainingList>{{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=dListLiFirstDiv ng-class=\"deviceLastPing?\'col-xs-4\':\'col-xs-8\'\"><div class=text-ellipsis><input type=checkbox ng-click=\"checkboxFx($event, device.id);\" role=checkbox><label></label><span ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 class=\"fa fa-exclamation-triangle text-danger marR5\" aria-hidden=true></span><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" role=\"status\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span> --> <span class=\"deviceStatus {{device.status}}\" title=\"{{device.status | capitalize}}\" role=status aria-label={{device.status}}></span> {{device.l}}</div><div ng-if=\"auth.upermissions.dtc && curState==\'hub.devices.d\' && device.tl.length\" class=\"pull-right nonSelectable padT4\" ng-class=\"{\'marR20\':device.tl.length > 5}\"><span ng-repeat=\"c in device.tl | limitTo:-5\" uib-tooltip={{devices.t[c].label}} tooltip-append-to-body=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{devices.t[c].tagColor}}></ng-tag-icon></span><a href ng-click=\"countListFx(device.id, \'tag\', device.l);\" ng-if=\"device.tl.length > 5\" class=colorCountBox ng-class=\"((device.tl.length + device.tln.length) - 5) < 99 ? \'w25\' : \'w35\'\" uib-tooltip=\"{{\'d.btn.29\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 data-count=\"+{{(device.tl.length + device.tln.length) - 5}}\"></a></div></div><div class=text-ellipsis ng-class=\"{\'col-xs-3\':(deviceLastPing && showDownload), \'col-xs-4\':(!showDownload)}\">{{device.h}}</div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{curMem = ((device.mem.u/device.mem.t)*100); \"\"}} <span ng-if=device.mem.t class=circle-pie style=\"background:radial-gradient({{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}} 36%, transparent 40%), conic-gradient(#5cb85c {{curMem}}%, #cccccc 0%)\" uib-tooltip=\"{{(device.mem.u*1024) | filesize}} / {{(device.mem.t*1024) | filesize}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=!device.mem class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-1 text-center\" ng-if=\"selectedTab === \'hub.devices.d\'\">{{curDisk = ((device.dsk.u/device.dsk.t)*100); \"\"}} <span ng-if=device.dsk.t class=circle-pie style=\"background:radial-gradient({{myTheme.theme==\'dk\'?\'#272526\':\'#ffffff\'}} 36%, transparent 40%), conic-gradient(#5cb85c {{curDisk}}%, #cccccc 0%)\" uib-tooltip=\"{{(device.dsk.u*1024) | filesize}} / {{(device.dsk.t*1024) | filesize}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=!device.dsk class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-2 text-right noPadL\" ng-if=deviceLastPing><span ng-if=device.lp>{{(device.lp * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=!device.lp class=\"text-sm text-muted\">N/A</span></div></li></ul><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && $state.includes(\'hub.devices\')\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && $state.includes(\'hub.devices\')\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && $state.includes(\'hub.devices\')\">{{\'as.msg.2\' | translate}}</div></div>");
$templateCache.put("app/devices/dir/deviceThumb.html","<!-- Folder List start --><div ng-if=\"filteredFolderList.length && (selectedT==1||selectedT==2) && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.reports\') || $state.includes(\'hub.dContainer.dvwName\')) && !isAdvSearchMsg\" class=\"bdr-btm-dashed marT10 fw6\">{{\'d.label.32\' | translate}}</div><li ng-if=\"folderList.length > 0 && (selectedT==1||selectedT==2) && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.reports\') || $state.includes(\'hub.dContainer.dvwName\')) && !isAdvSearchMsg\" ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'df\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index context-menu=contextMenuOpt ng-class=\"{\'nonSelectable\':!$state.includes(\'hub.devices.d\')}\" ng-dblclick=folderContentFx(folder.id)><div ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label uib-tooltip={{folder.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{folder.l}}</div></div></li><!-- Folder List end --><!-- ng-if=\"filteredDeviceList.length && (selectedT==1||selectedT==2) && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.reports\'))\" --><!-- <div ng-class=\"(folderList.length && filteredFolderList.length && (selectedT==1||selectedT==2)) ? \'marT35\' : \'marT10\'\" ng-if=\"(selectedT==1||selectedT==2) && $state.includes(\'hub.devices.d\')\">\r\n  <div class=\"bdr-btm-dashed fw6\" ng-class=\"{\'marT20\':folderList.length}\">{{\'cm.label.4s\' | translate}}\r\n    <div class=\"pull-right marT-15 nonSelectable\" ng-if=\"auth.upreferences.deviceView == \'t\'\">\r\n      <div class=\"other-controller\">\r\n        <div class=\"d-flex align-items-center\">\r\n          <dir-pagination-controls boundary-links=\"paginationControls.boundaryLinks\" max-size=\"paginationControls.maxSize\" on-page-change=\"pageChangeHandler(newPageNumber)\" max-page=\"totalPages\"></dir-pagination-controls>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div> --><div class=marT10 ng-class=\"{\'marT35\':(folderList.length && filteredFolderList.length && (selectedT==1||selectedT==2)), \'noMarT\':$state.includes(\'hub.sContainer.sDevice\')}\" ng-if=\"(selectedT==1||selectedT==2) && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.reports\') || $state.includes(\'hub.dContainer.dvwName\')) && devices.devices.length > 0\"><div class=\"bdr-btm-dashed fw6\" ng-class=\"{\'marT20\':folderList.length, \'d-flex align-items-center justify-spaceB noPadB noMarB\':$state.includes(\'hub.sContainer.sDevice\')}\">{{\'cm.label.4s\' | translate}}<div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':$state.includes(\'hub.sContainer.sDevice\')}\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable page-min-height\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> {{isAdv = (advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)); \"\"}} <span ng-if=\"!devicesLoading && rdc\" uib-tooltip=\"{{isAdv?\'d.tool.26\':filter==\'online\'?\'d.tool.24\':filter==\'offline\'?\'d.tool.25\':\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left class=device-count>{{visibleDevices}} / {{rdc}}</span><dir-pagination-controls boundary-links=paginationControls.boundaryLinks max-size=paginationControls.maxSize on-page-change=pageChangeHandler(newPageNumber) max-page=totalPages load-more=isPageApiLoad></dir-pagination-controls></div></div></div></div></div><!-- Top pagination start --><!-- {{auth.upreferences.sd}} --><!-- <div ng-hide=\"fCount.length==0 || (!auth.upreferences.sfdl && selectedTab==\'hub.devices.d\') || (!auth.upreferences.sfop && selectedTab!=\'hub.devices.d\')\" ng-class=\"(folderList.length && filteredFolderList.length && (selectedT==1||selectedT==2)) ? \'marT35\' : \'marT10\'\" ng-if=\"filteredDeviceList.length && (selectedT==1||selectedT==2) && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.reports\'))\">\r\n  <div class=\"bdr-btm-dashed fw6\" ng-class=\"{\'marT20\':folderList.length}\">{{\'cm.label.4s\' | translate}}\r\n    <div ng-if=\"!paginationLoading && !devicesLoading && devices.devices.length && selectedTab==\'hub.devices.d\'\" class=\"pull-right marT-20 nonSelectable\">\r\n      <div class=\"noPad noMar nonSelectable\">\r\n        <div class=\"deviceTopPaging marL10\" ng-class=\"{\'disabled\': paginationLoading}\">\r\n          <uib-pagination class=\"pagination-sm\" ng-model=\"currentPage\" ng-change=\"pageChangedFx(currentPage)\"\r\n          total-items=\"devices.info.count\" items-per-page=\"devices.info.pl\" max-size=\"5\" num-pages=\"numPages\"\r\n          boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\">\r\n          </uib-pagination>\r\n        </div>\r\n        <div class=\"pull-right text-unbold text-muted\" ng-class=\"(devices.info.count/devices.info.pl > 1) ? \'marT15\':\'marT20\'\">{{deviceRange ? deviceRange : (curCount + \' - \' + devices.info.pl)}} of {{devices.info.count ? devices.info.count : devices.devices.length}}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div> --><!-- Top pagination end --><!-- Device List start --><!-- total-items=\"10000\" --> <img alt=Loading src=assets/images/loading.gif ng-if=\"selectedTab == \'hub.devices.d\' && moreDeviceLoading\"><div ng-if=!moreDeviceLoading><!-- device in filteredDeviceList = ((devices.devices) | filter:{q:q, (((selectedT==\'1\' && selectedTab != \'hub.devices.dg\') || (selectedT==\'4\' && vwBreadCrumbs.length))?(status:filterType):\'\')} | itemsPerPage:paginationControls.pageSize) track by device.id --><li dir-paginate=\"device in filteredDeviceList = ((devices.devices) | filter:{q:q, status:(selectedTab==\'hub.devices.d\'?filterType:\'\')} | itemsPerPage:paginationControls.pageSize) track by device.id\" current-page=paginationControls.currPage uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status={{device.status}} data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'device\': selectedTab == \'hub.devices.d\', \'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" context-menu=contextMenuOpt><!-- Bellow condition applied li tag but its not usable also creating issue --><!--  ng-if=\"filter == \'all\' || filter == device.status || auth.upermissions.dp\" --> {{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9?epdDeviceConflictMsg:deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': device.type === \'device\',\'thumb-group\': device.type == \'group\', \'mcPlayer\': device.t == 7}\"><img alt={{device.t}} ng-if=\"device.tv != 0 && (device.t == 1 || device.t == 3 || device.t == 2)\" ng-src=\"{{thumbHost + tim + bucket + (device.h | removeColon) + \'.jpg\' + \'&\' + device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png loading=lazy> <img alt=d_{{device.t}} ng-if=\"device.tv == 0 || (!device.tv && device.type === \'device\' && device.t != 1 && device.t != 3 && device.t != 2)\" ng-src=assets/images/default/device_{{device.t}}.png loading=lazy> <img alt=dg ng-if=\"device.type === \'group\'\" src=assets/images/default/device_group.png loading=lazy> <img alt=ds ng-if=\"device.type === \'search\'\" src=assets/images/default/device_search.png loading=lazy><!-- (auth.uType == 0 || auth.uType == 1) && device.space != null && device.space < 51200  removed space key--> <span class=\"thumb-icon space\" ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\"><span class=\"fa fa-exclamation-triangle text-danger\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 aria-hidden=true></span></span><!-- <span class=\"thumb-icon status\" role=\"status\" ng-if=\"device.status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.status}}\"></span></span> --><!-- <span class=\"thumb-icon status\" role=\"status\" ng-if=\"device.status\" title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span> --> <span class=\"thumb-icon status\" role=status ng-if=device.status title=\"{{device.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" aria-label={{device.status}}><span class={{device.status}}></span></span></span></div><!-- <div class=\"downloadedBar\" ng-if=\"showDownload\" uib-tooltip=\"{{\'d.ph.3\' | translate:{no:device.dp} }}\" tooltip-enable=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\">\r\n      <div style=\"width:{{device.dp}}%\" ng-if=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\"></div>\r\n    </div> --><div class=thumb-label ng-if=device.l uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div><div class=thumb-label ng-if=device.label uib-tooltip={{device.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{device.label}}</div></li></div><li ng-repeat=\"search in filteredSearchList = (devices.searches | customSearch:{key:searchText, module:\'d\'}) | filter: ((selectedT==\'1\' && selectedTab != \'hub.devices.dg\')?{status:filterType}:\'\')\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)\" data-id={{search.id}} data-type={{search.type}} data-sub-type={{search.type}} ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && search.isConflict != null && (search.isConflict == 1 || search.isConflict == 2)}\" context-menu=contextMenuOpt class=tabIndex>{{curMsg = ((search.isConflict != 0 && search.isConflict == 1)?\'\'+conflictSearchMsg+\'\':\'\'+conflictSearchMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner><img alt=ds src=assets/images/default/device_search.png></span></div><div class=thumb-label uib-tooltip={{search.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{search.label}}</div></li><!-- For Video wall list --><li ng-repeat=\"wall in filteredWallList = (devices.walls | customSearch:{key:search.text, module:\'d\'})\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && wall.isConflict != null && (wall.isConflict == 1 || wall.isConflict == 2)\" data-id={{wall.id}} data-type={{wall.type}} data-sub-type={{wall.type}} ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && wall.isConflict != null && (wall.isConflict == 1 || wall.isConflict == 2)}\" context-menu=contextMenuOpt class=tabIndex>{{curMsg = ((search.isConflict != 0 && search.isConflict == 1)?\'\'+conflictSearchMsg+\'\':\'\'+conflictSearchMsg1+\'\');\"\"}}<div class=thumb-img><span class=\"thumb-inner relative\"><span class=matrix-badge>{{wall.matrix}}</span> <img class=bdrDark alt=videowall src=assets/images/default/device_videowall.png></span></div><div class=thumb-label>{{wall.label}}</div></li><!-- For Video wall list search message --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" ng-if=\"filteredWallList.length == 0 && selectedTab==\'hub.devices.dvw\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div> --><div class=msg-warning lang={{auth.lang}} ng-class=\"{\'marB10\':auth.upermissions.dp}\" ng-if=\"filteredWallList.length == 0 && selectedTab==\'hub.devices.dvw\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><!-- {{filteredDeviceList.length}} {{devices.devices.length}} / {{filterCount}} --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" ng-if=\"((!auth.upermissions.dgrp.dgrp && filteredDeviceList.length + filteredSearchList.length + filteredWallList.length == 0 && (filterCount > 0 && (selectedTab==\'hub.devices.d\' || selectedTab==\'hub.devices.dg\') || !filterCount && selectedTab!=\'hub.devices.d\')) || (filteredDeviceList.length + filteredSearchList.length + filteredWallList.length == 0 && filterCount > 0 && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'dt\')) && selectedTab !=\'hub.devices.dvw\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div> --><!-- {{filteredDeviceList.length}} {{devices.devices.length}} / {{filterCount}} --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" ng-if=\"(!auth.upermissions.dgrp.dgrp && filteredDeviceList.length + filteredSearchList.length == 0 && (filterCount > 0 && (selectedTab==\'hub.devices.d\' || selectedTab==\'hub.devices.dg\') || !filterCount && selectedTab!=\'hub.devices.d\')) || (filteredDeviceList.length + filteredSearchList.length == 0 && filterCount > 0 && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type == \'dt\')\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div> --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" ng-if=\"((selectedTab==\'hub.devices.d\' || selectedTab==\'hub.devices.dg\') || selectedTab!=\'hub.devices.d\') && search.text.length && device.devices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div> --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(((filterCount == 0 && (filteredDeviceList.length > 0 || devices.devices.length > 0)) && !auth.upermissions.dp) || (devices.devices.length == 0 && auth.upermissions.dp && auth.upreferences.deviceView == \'t\'&&!advSearchInfo.isEmpty) || (devices.devices.length > 0 && filterCount == 0)) && selectedTab == \'hub.devices.d\' && !isGbdt && filter!=\'all\' && devices.info.tc > 0\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- Search warning message device folder for list and thumb both --><!-- {{filteredFolderList.length}} {{filteredDeviceList.length}} {{filteredSearchList.length}} {{fCount.length}} --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && filteredFolderList.length + filteredDeviceList.length + filteredSearchList.length == 0 && (devices.devices.length > 0 || folderList.length > 0) && ((fCount.length > 0) || (devices.devices.length == 0 && filter==\'all\'))\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && $state.includes(\'hub.devices\') && selectedTab !=\'hub.devices.dvw\'\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(isFilterMsg && $state.includes(\'hub.devices\') && !search.text.length) || ($state.includes(\'hub.devices\') && isSearchMsg && firstApply.search && filter != \'all\')\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && $state.includes(\'hub.devices\') && selectedTab !=\'hub.devices.dvw\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(isSearchMsg && $state.includes(\'hub.devices\') && search.text.length > 0) || ($state.includes(\'hub.devices\') && isFilterMsg && firstApply.filter && && filter == \'all\')\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div> --><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && $state.includes(\'hub.devices\') && selectedTab !=\'hub.devices.dvw\'\">{{\'as.msg.2\' | translate}}</div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(selectedTab == \'hub.devices.d\' && !devices.devices.length) && !isGbdt && filter!=\'all\' && search.text.length == 0 && devices.info.tc > 0\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div>\r\n\r\n<div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(selectedTab==\'hub.devices.d\' && search.text.length > 0) && devices.info.tc > 0\" ng-class=\"{\'marB10\':auth.upermissions.dp}\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div> -->");
$templateCache.put("app/devices/popup/adaptersList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'ms.p_s.tab.4\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" ng-style=\"{\'max-height\':{{getAvailableHeight(304)}}+\'px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=!dataObj.length><div class=\"table table-scroll\" ng-if=dataObj.length><div class=\"row th\"><div class=col-xs-6>{{\'d.brief.15\' | translate}}</div><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div></div><div class=scrollQuad ng-style=\"{\'max-height\':{{getAvailableHeight(371)}}+\'px\'}\"><div class=row ng-repeat=\"ad in dataObj\"><div class=\"col-xs-6 word-break\">{{ad.mac}}</div><div class=\"col-xs-6 word-break\">{{ad.description}}</div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/addRemoveTag.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.15\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning ng-if=\"!popupLoading && !curTag.availableTags.length && !curTag.assignedTags.length\">{{\'cm.msg.44\' | translate}}</div><div class=row ng-if=\"!popupLoading  && curTag.availableTags.length || curTag.assignedTags.length\"><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link aria-label=sorting id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aTagSort.type === \'label\' && aTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link aria-label=vMenu1 id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'a\', curTag.availableTags | customSearch:{key:avlTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'a\', curTag.availableTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curTag.availableTags.length > 1?\'d.label.5s\':\'d.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{curTag.availableTags.length}} ]</span></label>{{curATEM = (curTag.availableTags | customSearch:{key:avlTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curTag.availableTags.length ng-model=avlTList sanitize-input maxlength={{inputLimit}} placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlTList.length ng-click=\"avlTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" style=margin:1px ng-if=\"curTag.availableTags.length && !curATEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curTag.availableTags | customSearch:{key:avlTList, module:\'cdtg\'} | orderBy:aTagSort.type:aTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'a\', option, curTag.availableTags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-block marT8\" ng-click=\"listManipulateFx(\'add\', curTag.availableTags, curTag.assignedTags, curTags.availableTags,\'\',\'\',\'t\'); asTList=\'\';\" ng-class=\"{\'disabled\': !curTag.availableTags.length}\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-block\" ng-click=\"listManipulateFx(\'remove\', curTag.availableTags, curTag.assignedTags, curTags.assignedTags,\'\',\'\',\'t\'); asTList=\'\';\" ng-class=\"{\'disabled\': !curTag.assignedTags.length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link aria-label=sorting1 id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'asc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sTagSort.type === \'label\' && sTagSort.val === \'desc\' && sTagSort.lType === \'tag\'}\"><a href=\"\" role=link ng-click=\"tagSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link aria-label=vMenu2 id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllTagFx(\'s\', curTag.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllTagFx(\'s\', curTag.assignedTags);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curTag.assignedTags.length > 1?\'d.label.6s\':\'d.label.6\' | translate}} <span class=\"text-sm text-muted\">[ {{curTag.assignedTags.length}} ]</span></label>{{curASTEM = (curTag.assignedTags | customSearch:{key:asTList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curTag.assignedTags.length ng-model=asTList sanitize-input maxlength={{inputLimit}} placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asTList.length ng-click=\"asTList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" style=margin:1px ng-if=\"curTag.assignedTags.length && !curASTEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asTList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curTag.assignedTags | customSearch:{key:asTList, module:\'cdtg\'} | orderBy:sTagSort.type:sTagSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selTagFx(\'s\', option, curTag.assignedTags)\"><span ng-if=auth.upermissions.dtc class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{option.tagColor}}></ng-tag-icon></span>{{option.label}}</div></div></div></div></div></div></div></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><span ng-if=\"curTag.availableTags.length > 0 || auth.upermissions.dt\"><button type=button role=button class=\"btn btn-success\" ng-if=\"curTag.availableTags.length || curTag.assignedTags.length\" ng-click=saveDeviceTagFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); resetT();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button> </span><button type=button role=button class=\"btn btn-default\" ng-if=\"curTag.availableTags.length == 0 && !auth.upermissions.dt\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.1\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr><div ng-if=\"errType == \'form\'\">{{\'d.p_tag.m1\' | translate}}</div><div ng-if=\"errType == \'mcDevice\'\">{{\'d.p_dg.m11\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/addToGroup.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_adg.1\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=\"!isGroupEmpty && !isGroupAvailable\"><div class=\"form-group hide\" ng-if=\"!isGroupEmpty && isGroupAvailable && auth.upermissions.dg\" role=radiogroup aria-labelledby=radiogroup><label class=marR10 ng-click=\"tabFx(1, \'tabFx\');removeMsg();\"><input type=radio role=radio name=grpOpt ng-model=curGroup.grpOpt value=updateGrp><label></label>{{\'cm.label.81\' | translate}}</label><label ng-click=tabFx(2);removeMsg();><input type=radio role=radio name=grpOpt ng-model=curGroup.grpOpt value=newGrp><label></label>{{\'cm.label.82\' | translate}}</label></div><div class=form-group ng-if=\"isGroupEmpty || curGroup.grpOpt == \'newGrp\'\"><p ng-if=isGroupEmpty>{{\'d.p_adg.m1\' | translate}} <span ng-if=auth.upermissions.dg>{{\'d.p_adg.m2\' | translate}}</span></p><div ng-if=auth.upermissions.dg><label for=newGroup>{{\'cm.label.78\' | translate}}</label><input type=text id=newGroup class=form-control ng-model=curGroup.newGroup maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'cm.label.78\' | translate}}\" aria-labelledby=\"{{\'cm.label.78\' | translate}}\"></div></div><div class=row ng-if=\"curGroup.grpOpt == \'updateGrp\'\"><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'label\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'asc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': aGroupSort.type === \'createdOn\' && aGroupSort.val === \'desc\' && aGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'a\', curGroup.availableGroups | customSearch:{key:avlGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'a\', curGroup.availableGroups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curGroup.availableGroups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{curGroup.availableGroups.length}} ]</span></label>{{curAGEM = (curGroup.availableGroups | customSearch:{key:avlGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlGList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlGList.length ng-click=\"avlGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curGroup.availableGroups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curGroup.availableGroups | customSearch:{key:avlGList, module:\'cdtg\'} | orderBy:aGroupSort.type:aGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGroupFx(\'a\', option, curGroup.availableGroups)\">{{option.label}}</div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curGroup.availableGroups.length}\" ng-click=\"listManipulateFx(\'add\', curGroup.availableGroups, curGroup.groups, curGroups.availableGroups,\'\',\'\',\'g\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curGroup.groups.length}\" ng-click=\"listManipulateFx(\'remove\', curGroup.availableGroups, curGroup.groups, curGroups.assignedGroups,\'\',\'\',\'g\'); asGList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'label\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'label\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'asc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': sGroupSort.type === \'createdOn\' && sGroupSort.val === \'desc\' && sGroupSort.lType === \'group\'}\"><a href=\"\" role=link ng-click=\"groupSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllGroupFx(\'s\', curGroup.groups | customSearch:{key:asGList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllGroupFx(\'s\', curGroup.groups);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curGroup.groups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}} <span class=\"text-sm text-muted\">[ {{curGroup.groups.length}} ]</span></label>{{curAGEM = (curGroup.groups | customSearch:{key:asGList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=asGList sanitize-input ng-disabled=!curGroup.groups.length placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asGList.length ng-click=\"asGList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curGroup.groups.length && !curAGEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asGList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curGroup.groups | customSearch:{key:asGList, module:\'cdtg\'} | orderBy:sGroupSort.type:sGroupSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selGroupFx(\'s\', option, curGroup.groups)\">{{option.label}}</div></div></div></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><span ng-if=\"curGroup.availableGroups.length > 0 || auth.upermissions.dg\"><button type=button role=button class=\"btn btn-success\" ng-click=saveUserGrpFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); resetSelDGTList();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button> </span><button type=button role=button class=\"btn btn-default\" ng-if=\"curGroup.availableGroups.length == 0 && !auth.upermissions.dg\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.1\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_dg.m1\' | translate}}</div><div ng-if=\"errType==\'exists\'\" aria-live=polite role=status>{{\'d.p_dg.m2\' | translate}}</div><div ng-if=\"errType==\'mcDevice\'\" aria-live=polite role=status>{{\'d.p_dg.m3\' | translate}}</div><div ng-if=\"errType==\'eslError\'\" aria-live=polite role=status>{{\'d.p_dg.m12\' | translate}}</div><div ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.p_dg.m18\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'dEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'tEdit\'||btn.key==\'dtEdit\'\">{{\'u.p_role.6.8\' | translate}}</span> <span ng-if=\"btn.key==\'dPreview\'\">{{\'d.btn.7\' | translate}}</span> <span ng-if=\"btn.key==\'dAddToGroup\'\">{{\'cm.btn.29\' | translate}}</span> <span ng-if=\"btn.key==\'dSimilar\'\">{{\'d.btn.10\' | translate}}</span> <span ng-if=\"btn.key==\'dDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'dDeleteFolder\'\">{{\'u.p_role.4.9\' | translate}}</span> <span ng-if=\"btn.key==\'dEditFolder\'\">{{\'u.p_role.4.8\' | translate}}</span> <span ng-if=\"btn.key==\'dgEdit\' || btn.key==\'dvwEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'editTags\'\">{{\'d.tab.3\' | translate}}</span> <span ng-if=\"btn.key==\'dgDelete\' || btn.key==\'dvwDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'dMove\'\">{{\'u.p_role.4.10\' | translate}}</span></div><div class=text-ellipsis-wrap>{{\'btnInfo.\'+ btn.code | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/changeRes.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_res.1\' | translate}}</h1><span class=\"text-muted text-sm\">[ {{deviceResObj.label}} ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div ng-if=!popupLoading><div class=form-group ng-if=!deviceRes.displayModes>{{\'d.p_res.m1\' | translate}}</div><div class=form-group ng-if=\"!deviceRes.requested && deviceRes.acknowledged == \'w\'\">bn{{\'d.p_res.m2\' | translate:{dateTime: deviceRes.requested} }}</div><div class=\"form-group noMarB\" ng-if=deviceRes.displayModes><label for=resolution>{{\'d.brief.2\' | translate}}</label><select class=form-control id=resolution ng-model=deviceResObj.resolution ng-options=\"option for option in deviceRes.displayModes\" aria-label=\"{{\'d.brief.2\' | translate}}\" aria-labelledby=\"{{\'d.brief.2\' | translate}}\"></select></div></div></div><footer class=panel-footer ng-if=!popupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=changeResFx(); ng-if=deviceRes.displayModes><span class=\"fa fa-check\" aria-hidden=true></span>{{\'d.p_res.b1\' | translate}}</button> <button type=button role=button class=btn ng-click=closeThisDialog(); data-dismiss=modal ng-class=\"!deviceRes.displayModes?\'btn-default\':\'btn-link\'\">{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/config.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.brief.19\' | translate}}</h1><span class=\"text-sm text-muted marL5\">[{{configObj.label}}]</span></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><img alt=Loading src=assets/images/loading.gif ng-if=configLoading><div class=\"table table-scroll\" ng-if=\"!configLoading && configObj.configList.length\"><div class=\"row th\"><div class=col-xs-4>{{\'d.p_config.1\' | translate}}</div><div class=col-xs-2>{{\'cm.label.3s\' | translate}}</div><div class=col-xs-3>{{\'d.p_config.4\' | translate}}</div><div class=col-xs-3>{{\'d.p_config.5\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"cf in configObj.configList\"><div class=\"col-xs-4 word-break\">{{cf.ConfigurationID}}</div><div class=\"col-xs-2 word-break\">{{cf.s.length}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"cf.s.length>0\" ng-click=scheduleListOpen(cf.s);>{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-3 word-break\">{{cf.createDate}}</div><div class=\"col-xs-3 word-break\">{{cf.loadDate}}</div><div class=\"col-xs-1 text-right hide\"><a href=\"\" role=link class=text-danger ng-click=deleteConfigOpen(cf.ConfigurationID);><span class=\"fa fa-close\" aria-hidden=true></span></a></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!configLoading && !configObj.configList.length\">{{\'d.p_config.m1\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/contentList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"refreshObj.b && auth.upermissions.edl\" class=\"padR10 padL5 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=downloadCCFx(); ng-disabled=\"loading || loadDownload\"><span class=\"fa fa-download\" aria-hidden=true></span></a> <a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-class=\"{\'marL5\': marginLoad}\" ng-click=\"refreshPopupListFx(\'content\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><!-- <div class=\"searchTbx bdrR\">\r\n      <input type=\"text\" class=\"form-control\" placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-model=\"searchTextPopup\">\r\n      <a href=\"\" class=\"text-danger\" ng-show=\"searchTextPopup.length\" ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\"></span></a>\r\n    </div> --> {{viewType = (uPreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx input-group bdrR\" style=width:200px><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\"></span></a> <span class=input-group-btn uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><!-- <li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'tcl\');\">{{\'cm.body.10\' | translate}}</a></li> --><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType);\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !refreshObj.b && filtered.a.length + filtered.i.length + filtered.e.length == 0\">{{\'db.msg.1\' | translate}}</div><div class=row ng-if=!popupLoading><div class=col-xs-8 ng-class=\"{\'col-xs-12\':contentList.framelayout.length == 0}\"><div class=\"scrollQuad pad2\" ng-attr-style=max-height:{{getAvailableHeight(335)}}px><ul class=\"list-inline thumb-list noHover\" ng-if=\"uPreferences.contentView == \'t\'\"><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length + filtered.e == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><li class=\"noMar contentItem\" ng-repeat=\"cl in filtered.a = (contentList.content.a | filter:{label:searchTextPopup})\" data-id={{cl.frameid}} ng-mouseover=\"highlightFx(cl.frameid, \'item\')\" ng-mouseleave=unhilightFx()><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':cl.isblur}\"><!-- Audio, Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"(cl.type == \'Audio\' || cl.type == \'Flash\') && cl.isCompleted\"><!-- Images, Video --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"(cl.type == \'Image\' || cl.type == \'Video\') && cl.isCompleted\" ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- YouTube --> <img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Widget --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\'\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\')\" ng-src=\"{{cl.ss?(contentList.info.timthumb + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbParam):(cDetailBucket+\'widgets/thumbs/md/\'+cl.thumb+\'.png?v\'+ timestamp)}}\" class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + cl.thumb + thumbParam + \'&\' + cl.thumbV}}\" class=img-responsive ng-if=\"cl.type == \'template\' && cl.isCompleted\"><!-- Other --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\" ng-class=\"{\'blurry-img\':cl.isblur}\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\"><div class=hoverOverlay><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"cl.type == \'Image\' && cl.isCompleted\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a ng-if=\"cl.type == \'template\' && cl.isCompleted\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'Image\' && cl.type != \'Video\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.type != \'template\'}\" ng-click=contentInfoOpen(cl); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><span class=duration>{{cl.duration}}</span> <span class=thumb-icon><span ng-if=\"cl.type !== \'folder\' && !cl.confirmed && contentList.info.restrict.isActive && cl.size > contentList.info.restrict.size\" class=warning-icon></span> <span ng-if=\"cl.type !== \'folder\' && cl.confirmed\" class=check-icon uib-tooltip={{cl.downloadedOn}} tooltip-enable=cl.downloadedOn></span> <span ng-if=cl.ss class=webpage></span> <span ng-if=\"cl.type !== \'folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{cl.label}} tooltip-popup-delay=1500>{{cl.label}}</div></li><div class=\"panel-inner-tab marB5\" ng-if=filtered.i.length ng-class=\"{\'marT20\':filtered.a.length}\">{{\'d.p_h.9\' | translate}}</div><li class=\"noMar contentItem\" ng-repeat=\"cl in filtered.i = (contentList.content.i | filter:{label:searchTextPopup})\" data-id={{cl.frameid}} ng-mouseover=\"highlightFx(cl.frameid, \'item\')\" ng-mouseleave=unhilightFx()><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Audio, Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"(cl.type == \'Audio\' || cl.type == \'Flash\') && cl.isCompleted\"><!-- Images, Video --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"(cl.type == \'Image\' || cl.type == \'Video\') && cl.isCompleted\"><!-- YouTube --> <img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\"><!-- Widget --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\'\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + cl.thumb + thumbParam + \'&\' + cl.thumbV}}\" class=img-responsive ng-if=\"cl.type == \'template\' && cl.isCompleted\"><!-- Other --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\"><div class=hoverOverlay><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"cl.type == \'Image\' && cl.isCompleted\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a ng-if=\"cl.type == \'template\' && cl.isCompleted\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'Image\' && cl.type != \'Video\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.type != \'template\'}\" ng-click=contentInfoOpen(cl); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><span class=duration>{{cl.duration}}</span> <span class=thumb-icon><span ng-if=\"cl.type !== \'folder\' && cl.confirmed\" class=check-icon></span> <span ng-if=cl.ss class=webpage></span> <span ng-if=\"cl.type !== \'folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{cl.label}} tooltip-popup-delay=1500>{{cl.label}}</div></li><!-- Expired Content --><div class=\"panel-inner-tab marB5\" ng-if=filtered.e.length ng-class=\"{\'marT20\':filtered.a.length + filtered.i.length}\">{{\'d.label.57\' | translate}}</div><li class=\"noMar contentItem\" ng-repeat=\"cl in filtered.e = (contentList.content.e | filter:{label:searchTextPopup})\" data-id={{cl.frameid}} ng-mouseover=\"highlightFx(cl.frameid, \'item\')\" ng-mouseleave=unhilightFx()><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Audio, Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"(cl.type == \'Audio\' || cl.type == \'Flash\') && cl.isCompleted\"><!-- Images, Video --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"(cl.type == \'Image\' || cl.type == \'Video\') && cl.isCompleted\"><!-- YouTube --> <img alt=\"\" ng-src={{cl.thumb}} class=\"img-responsive center-block\" ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\"><!-- Widget --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.thumb}}.png class=\"img-responsive center-block img-widget\" ng-if=\"cl.type == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\'\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + cl.thumb + thumbParam + \'&\' + cl.thumbV}}\" class=img-responsive ng-if=\"cl.type == \'template\' && cl.isCompleted\"><!-- Other --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + cBucket + cl.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.isCompleted\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\"><div class=hoverOverlay><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"cl.type == \'Image\' && cl.isCompleted\" ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a ng-if=\"cl.type == \'Video\' && cl.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a ng-if=\"cl.type == \'template\' && cl.isCompleted\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'Image\' && cl.type != \'Video\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.type != \'template\'}\" ng-click=contentInfoOpen(cl); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><span class=duration>{{cl.duration}}</span> <span class=thumb-icon><span ng-if=\"cl.type !== \'folder\' && cl.confirmed\" class=check-icon></span> <span ng-if=cl.ss class=webpage></span> <span ng-if=\"cl.type !== \'folder\'\" class=\"{{cl.type.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{cl.label}} tooltip-popup-delay=1500>{{cl.label}}</div></li></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"uPreferences.contentView == \'l\'\"><span ng-if=\"filtered.a.length + filtered.i.length + filtered.e.length == 0\"><div class=\"row th\"><div class=col-xs-6><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><!-- <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdon\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.2\' | translate}}</span>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.3\' | translate}}</span>\r\n                </div> --><div class=col-xs-3><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><!-- <div class=\"col-xs-1 text-right noPad\">{{\'cm.brief.12\' | translate}}</div>\r\n                <div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div> --><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length + filtered.e.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></span><span ng-show=filtered.a.length><div class=\"row th\" ng-if=\"filtered.a.length > 0\"><div class=col-xs-6><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><!-- <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdon\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.2\' | translate}}</span>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.3\' | translate}}</span>\r\n                </div> --><div class=col-xs-3><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList.content.a, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><li class=\"row contentItem\" ng-repeat=\"content in filtered.a = (contentList.content.a | filter:{label:searchTextPopup})\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt data-id={{content.frameid}} ng-mouseover=\"highlightFx(content.frameid, \'item\')\" ng-mouseleave=unhilightFx()>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && !content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type !== \'Video\' && content.type != \'Flash\'\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=img-responsive ng-if=\"content.type == \'template\' && content.isCompleted\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\"> <span class=\"thumb-icon cl\"><!-- <span ng-if=\"content.type !== \'folder\' && !content.confirmed && contentList.info.restrict.isActive && content.size > contentList.info.restrict.size\" class=\"warning-icon\"></span> --> <span ng-if=\"content.type !== \'folder\' && content.confirmed\" class=check-icon uib-tooltip={{content.downloadedOn}} tooltip-enable=content.downloadedOn></span><!-- <span ng-if=\"content.type !== \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span> --> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> <span ng-if=content.gd class=googleDrive></span> <span ng-if=content.ss class=webpage></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n                <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-3 text-right text-sm\"><!-- Audio --> <a class=marR5 ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Flash --> <a class=marR5 ng-if=\"content.type == \'Flash\' && content.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Images --> <a class=marR5 ng-if=\"content.type == \'Image\' && content.isCompleted\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Video --> <a class=marR5 ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- YouTube --> <a class=marR5 ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Template  --> <a class=marR5 ng-if=\"content.type == \'template\' && content.isCompleted\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Info --> <a href=\"\" ng-class=\"{\'isSingle\': content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'Image\' &&content.type != \'Video\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.type != \'template\'}\" ng-click=contentInfoOpen(content); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\"></span></a></div></li></span><div class=\"panel-inner-tab marB5\" ng-if=filtered.i.length ng-class=\"{\'marT20\':filtered.a.length}\">{{\'d.p_h.9\' | translate}}</div><span ng-show=filtered.i.length><div class=\"row th\" ng-if=\"filtered.i.length > 0\"><div class=col-xs-6><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><!-- <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdon\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.2\' | translate}}</span>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.3\' | translate}}</span>\r\n                </div> --><div class=col-xs-3><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><li class=\"row contentItem\" ng-repeat=\"content in filtered.i = (contentList.content.i | filter:{label:searchTextPopup})\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt data-id={{content.frameid}} ng-mouseover=\"highlightFx(content.frameid, \'item\')\" ng-mouseleave=unhilightFx()>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && !content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type !== \'Video\' && content.type != \'Flash\'\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=img-responsive ng-if=\"content.type == \'template\' && content.isCompleted\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\"> <span class=\"thumb-icon cl\"><!-- <span ng-if=\"content.type !== \'folder\' && !content.confirmed && contentList.info.restrict.isActive && content.size > contentList.info.restrict.size\" class=\"warning-icon\"></span> --> <span ng-if=\"content.type !== \'folder\' && content.confirmed\" class=check-icon uib-tooltip={{content.downloadedOn}} tooltip-enable=content.downloadedOn></span><!-- <span ng-if=\"content.type !== \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span> --> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> <span ng-if=content.ss class=webpage></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n                <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-3 text-right text-sm\"><!-- Audio --> <a class=marR5 ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Flash --> <a class=marR5 ng-if=\"content.type == \'Flash\' && content.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Images --> <a class=marR5 ng-if=\"content.type == \'Image\' && content.isCompleted\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Video --> <a class=marR5 ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- YouTube --> <a class=marR5 ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Template  --> <a class=marR5 ng-if=\"content.type == \'template\' && content.isCompleted\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Info --> <a href=\"\" ng-class=\"{\'isSingle\': content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'Image\' &&content.type != \'Video\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.type != \'template\'}\" ng-click=contentInfoOpen(content); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\"></span></a></div></li></span><!-- Expired Content --><div class=\"panel-inner-tab marB5\" ng-if=filtered.e.length ng-class=\"{\'marT20\':filtered.a.length + filtered.i.length}\">{{\'d.label.57\' | translate}}</div><span ng-show=filtered.e.length><div class=\"row th\" ng-if=\"filtered.e.length > 0\"><div class=col-xs-6><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><!-- <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdon\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.2\' | translate}}</span>\r\n                </div>\r\n                <div class=\"col-xs-2\">\r\n                  <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n                  <span ng-if=\"!isSorting\">{{\'cm.brief.3\' | translate}}</span>\r\n                </div> --><div class=col-xs-3><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList.content.i, contentList.info, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><li class=\"row contentItem\" ng-repeat=\"content in filtered.e = (contentList.content.e | filter:{label:searchTextPopup})\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt data-id={{content.frameid}} ng-mouseover=\"highlightFx(content.frameid, \'item\')\" ng-mouseleave=unhilightFx()>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && !content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type !== \'Video\' && content.type != \'Flash\'\"><!-- Template  --> <img alt=\"\" ng-src=\"{{contentList.info.timthumb + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=img-responsive ng-if=\"content.type == \'template\' && content.isCompleted\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\"> <span class=\"thumb-icon cl\"><!-- <span ng-if=\"content.type !== \'folder\' && !content.confirmed && contentList.info.restrict.isActive && content.size > contentList.info.restrict.size\" class=\"warning-icon\"></span> --> <span ng-if=\"content.type !== \'folder\' && content.confirmed\" class=check-icon uib-tooltip={{content.downloadedOn}} tooltip-enable=content.downloadedOn></span><!-- <span ng-if=\"content.type !== \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span> --> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> <span ng-if=content.ss class=webpage></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n                <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-3 text-right text-sm\"><!-- Audio --> <a class=marR5 ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Flash --> <a class=marR5 ng-if=\"content.type == \'Flash\' && content.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Images --> <a class=marR5 ng-if=\"content.type == \'Image\' && content.isCompleted\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Video --> <a class=marR5 ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- YouTube --> <a class=marR5 ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Template  --> <a class=marR5 ng-if=\"content.type == \'template\' && content.isCompleted\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\"></span></a><!-- Info --> <a href=\"\" ng-class=\"{\'isSingle\': content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'Image\' &&content.type != \'Video\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.type != \'template\'}\" ng-click=contentInfoOpen(content); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\"></span></a></div></li></span></ul></div></div><div class=col-xs-4 ng-if=\"contentList.framelayout.length > 0\"><div class=\"flPreview bg-light pad10\"><div class=\"panel noMarB\"><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist><li class=tab-success ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" ng-click=tabFx(1);scaleFrameLayout()>{{\'cm.menu.4\' | translate}}</a></li><li class=tab-primary ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" ng-click=tabFx(2);>{{\'fl.p_cfl.tab.2\' | translate}}</a></li></ul></header><div class=scrollQuad-y ng-attr-style=\"visibility:hidden;max-height:{{getAvailableHeight(397) + \'px\';}}\"><div class=pad10 ng-show=\"selectedT==\'1\'\"><div class=marB10 ng-repeat=\"fl in contentList.framelayout\"><div class=marB5>{{fl.info.label}}</div><div class=fcont style=height:130px><div class=\"flGrid framesContainer\" ng-attr-style=\"width:{{fl.info.w}}px; height:{{fl.info.h}}px;\"><div ng-repeat=\"frame in fl.frames\" class=absolute ng-attr-style=left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}}; ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=unhilightFx() ng-click=highlightSelectFx(frame.id)>{{brTL = (frame.settings.br.tl?(frame.settings.br.tl)+\'px\':0);\"\"}} {{brTR = (frame.settings.br.tr?(frame.settings.br.tr)+\'px\':0);\"\"}} {{brBL = (frame.settings.br.bl?(frame.settings.br.bl)+\'px\':0);\"\"}} {{brBR = (frame.settings.br.br?(frame.settings.br.br)+\'px\':0);\"\"}}<div data-id={{frame.id}} data-index={{$index}} class=frame ng-attr-style=\"width:{{frame.width}}px;height:{{frame.height}}px;transform:rotate({{frame.rotation}}deg);background-color:{{frame.rgba}};border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}}\" ng-click=selectFrame(frame.id)></div></div></div></div></div></div><div class=pad10 ng-show=\"selectedT==\'2\'\"><div class=tab-body><ul class=\"layer-container list-unstyled noMar\" callback=sortCallback()><li ng-repeat=\"fl in contentList.framelayout\" class=\"layer sortable-item\" data-id={{frame.id}}><div class=layerLabel>{{fl.info.label}}</div><div class=\"text-ellipsis flList padTB4\" ng-repeat=\"frame in fl.frames\" data-id={{frame.id}} ng-attr-style=\"left:{{frame.x*0.1}}px;top:{{frame.y*0.1}}px;z-index:{{frame.z}};border-bottom:1px solid #dddddd;cursor:default\" ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=unhilightFx() ng-click=highlightSelectFx(frame.id);><label class=\"pull-left noMarB\"><input type=radio name=layer ng-model=currentSelectFrame ng-value=frame.id style=\"cursor: default\"><label></label></label><!-- <label class=\"pull-left noMarB\"><input type=\"radio\" disabled name=\"layer\" ng-model=\"currentSelectFrame\" ng-value=\"frame.id\" ng-change=\"highlightSelectFx(frame.id)\" style=\"cursor: default;\"><label></label></label> --> <span class=layerBg><span ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.rgba}\"></span> </span><span class=layerFrameLabel>{{frame.label}}</span></div></li></ul></div></div></div></div></div><!-- <div class=\"scrollQuad-y \" ng-attr-style=\"visibility:hidden;max-height:{{getAvailableHeight(371) + \'px\'}}\">\r\n          <div class=\"panel-inner-tab padB6 marB10\">{{\'cm.menu.4\' | translate}}</div>\r\n          <div class=\"marB10\" ng-repeat=\"fl in contentList.framelayout\">\r\n            <div class=\"marB5\">{{fl.info.label}}</div>\r\n            <div class=\"fcont\" style=\"height:130px;\">\r\n              <div class=\"flGrid framesContainer\" ng-attr-style=\"width:{{fl.info.w}}px; height:{{fl.info.h}}px;\">\r\n                <div ng-repeat=\"frame in fl.frames\" class=\"absolute\" ng-attr-style=\"left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}};\" ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=\"unhilightFx()\" ng-click=\"highlightSelectFx(frame.id, \'content\')\">\r\n                  {{brTL = (frame.settings.br.tl?(frame.settings.br.tl)+\'px\':0);\"\"}}\r\n                  {{brTR = (frame.settings.br.tr?(frame.settings.br.tr)+\'px\':0);\"\"}}\r\n                  {{brBL = (frame.settings.br.bl?(frame.settings.br.bl)+\'px\':0);\"\"}}\r\n                  {{brBR = (frame.settings.br.br?(frame.settings.br.br)+\'px\':0);\"\"}}\r\n                  <div data-id=\"{{frame.id}}\" data-index=\"{{$index}}\" class=\"frame\" ng-attr-style=\"width:{{frame.width}}px;height:{{frame.height}}px;transform:rotate({{frame.rotation}}deg);background-color:{{frame.rgba}};border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}}\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div> --></div><!-- <div class=\"col-xs-4\" ng-if=\"contentList.framelayout.length > 0\">\r\n        <div class=\"scrollQuad-y flPreview bg-light pad10\" ng-attr-style=\"visibility:hidden;max-height:{{getAvailableHeight(371) + \'px\'}}\">\r\n          <div class=\"panel-inner-tab padB6 marB10\">{{\'cm.menu.4\' | translate}}</div>\r\n          <div class=\"marB10\" ng-repeat=\"fl in contentList.framelayout\">\r\n            <div class=\"marB5\">{{fl.info.label}}</div>\r\n            <div class=\"fcont\" style=\"height:130px;\">\r\n              <div class=\"flGrid framesContainer\" ng-attr-style=\"width:{{fl.info.w}}px; height:{{fl.info.h}}px;\">\r\n                <div ng-repeat=\"frame in fl.frames\" class=\"absolute\" ng-attr-style=\"left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}};\" ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=\"unhilightFx()\" ng-click=\"highlightSelectFx(frame.id, \'content\')\">\r\n                  {{brTL = (frame.settings.br.tl?(frame.settings.br.tl)+\'px\':0);\"\"}}\r\n                  {{brTR = (frame.settings.br.tr?(frame.settings.br.tr)+\'px\':0);\"\"}}\r\n                  {{brBL = (frame.settings.br.bl?(frame.settings.br.bl)+\'px\':0);\"\"}}\r\n                  {{brBR = (frame.settings.br.br?(frame.settings.br.br)+\'px\':0);\"\"}}\r\n                  <div data-id=\"{{frame.id}}\" data-index=\"{{$index}}\" class=\"frame\" ng-attr-style=\"width:{{frame.width}}px;height:{{frame.height}}px;transform:rotate({{frame.rotation}}deg);background-color:{{frame.rgba}};border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}}\"></div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div> --></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"checkIconQuad text-muted pull-right text-sm marT6\"><span class=\"fa fa-check-circle\" aria-hidden=true></span>{{\'d.body.14\' | translate}}</div><div class=\"checkIconQuad text-muted pull-right text-sm marT6 marR10\" ng-if=\"contentList.info.restrict.isActive && deviceType != \'desktop\'\"><span class=\"warning-icon marR3\"></span>{{\'d.body.18\' | translate:{size:contentList.info.restrict.size/1024} }}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/dSearchEdit.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.10\' | translate}}</h1></header><div class=\"panel-body advSearchQuad\"><img alt=Loading src=assets/images/loading.gif ng-if=dSearchLoading><div class=row ng-if=!dSearchLoading><div class=col-xs-12><div class=form-group><label for=label>{{\'cm.brief.1\' | translate}}</label><input type=text id=label class=form-control ng-model=curDSearch.label aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=\"row word-break\"><div class=col-xs-4><label>{{\'as.label.5\' | translate}} <span class=\"text-sm text-muted\">[ {{dSearch.tagList.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curDSearchModel.availableTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-2></div><div class=col-xs-3><label>{{\'as.label.6\' | translate}} <span class=\"text-sm text-muted\">[ {{curDSearch.tag.include.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curDSearchModel.includeTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div><div class=col-xs-3><label>{{\'as.label.7\' | translate}} <span class=\"text-sm text-muted\">[ {{curDSearch.tag.exclude.length}} ]</span></label><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curDSearchModel.excludeTag = []\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button></div></div><div class=row><div class=col-xs-4><select id=availableTag class=form-control ng-model=curDSearchModel.availableTag ng-options=\"option.label for option in dSearch.tagList | orderBy:\'label\' track by option.id\" multiple aria-label=\"{{\'d.label.5\' | translate}}\" aria-labelledby=\"{{\'d.label.5\' | translate}}\"></select></div><div class=\"col-xs-2 actionQuad noPadL noPadR\"><button type=button role=button ng-click=\"listManipulateFx(\'add\', dSearch.tagList, curDSearch.tag.include, curDSearchModel.availableTag);\" class=\"btn btn-success btn-xs btn-block\" ng-class=\"{\'disabled\':!curDSearchModel.availableTag.length}\">{{\'as.label.6\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'add\', dSearch.tagList, curDSearch.tag.exclude, curDSearchModel.availableTag);\" class=\"btn btn-danger btn-xs btn-block\" ng-class=\"{\'disabled\':!curDSearchModel.availableTag.length}\">{{\'as.label.7\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'remove\', dSearch.tagList, curDSearch.tag.include, curDSearchModel.includeTag, curDSearch.tag.exclude, curDSearchModel.excludeTag);\" class=\"btn btn-default btn-xs btn-block\" ng-class=\"{\'disabled\':!(curDSearchModel.includeTag + curDSearchModel.excludeTag).length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=col-xs-3><select id=includeTag class=form-control ng-model=curDSearchModel.includeTag ng-options=\"option.label for option in curDSearch.tag.include | orderBy:\'label\' track by option.id\" multiple aria-label=\"include tag\" aria-labelledby=\"include tag\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=marR5 ng-class=\"{\'disabled\':curDSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curDSearch.tag.iType value=or ng-disabled=\"curDSearch.tag.include.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label ng-class=\"{\'disabled\':curDSearch.tag.include.length <= 1}\"><input type=radio role=radio name=iOpt ng-model=curDSearch.tag.iType value=and ng-disabled=\"curDSearch.tag.include.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div><div class=col-xs-3><select id=excludeTag class=form-control ng-model=curDSearchModel.excludeTag ng-options=\"option.label for option in curDSearch.tag.exclude | orderBy:\'label\' track by option.id\" multiple aria-label=\"exclude tag\" aria-labelledby=\"exclude tag\"></select><div role=radiogroup aria-labelledby=radiogroup><label class=marR5 ng-class=\"{\'disabled\':curDSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curDSearch.tag.eType value=or ng-disabled=\"curDSearch.tag.exclude.length <= 1\"><label></label>{{\'cm.label.42\' | translate | uppercase}}</label><label ng-class=\"{\'disabled\':curDSearch.tag.exclude.length <= 1}\"><input type=radio role=radio name=eOpt ng-model=curDSearch.tag.eType value=and ng-disabled=\"curDSearch.tag.exclude.length <= 1\"><label></label>{{\'as.label.9\' | translate}}</label></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveDSearchFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=resetSearchFx();><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'cm.btn.34\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(\'close\');\">{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'tag\'\" aria-live=polite role=status>{{\'as.msg.1\' | translate}}</div><div ng-if=\"errType==\'deviceErr\'\" aria-live=polite role=status>{{\'as.msg.3\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/dataUsage.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.brief.12\' | translate | camelCase}}</h1><span class=\"text-muted text-sm\">[ {{ngDialogData.label}} ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!dataUsage><div ng-if=dataUsage><div class=\"pull-left marR10\"><label>{{\'d.p_du.1\' | translate}}:</label><span class=\"text-muted marL10\" ng-if=totalDataUsageTillDate>[{{\'d.p_du.1.1\' | translate}} {{dataUsage.totalDataUsageTillDate}}]</span></div><div><span class=text-muted>{{\'cm.btn.16\' | translate}}:</span><label><span class=\"fa fa-arrow-up text-warning\" aria-hidden=true></span> {{dataUsage.upload}}</label><span class=\"text-muted marL10\">{{\'cm.btn.17\' | translate}}:</span><label><span class=\"fa fa-arrow-down text-success\" aria-hidden=true></span> {{dataUsage.download}}</label></div><div class=row><div class=\"col-xs-12 marTB10\"><div class=bdr-top-dashed></div></div><div class=col-xs-3><label>{{\'d.p_du.2\' | translate}}:</label><div><span class=\"fa fa-arrow-up text-warning\" aria-hidden=true></span> {{dataUsage.thisWeekDownload}}</div><div><span class=\"fa fa-arrow-down text-success\" aria-hidden=true></span> {{dataUsage.thisWeekUpload}}</div></div><div class=\"col-xs-3 bdrL\"><label>{{\'d.p_du.3\' | translate}}:</label><div><span class=\"fa fa-arrow-up text-warning\" aria-hidden=true></span> {{dataUsage.thisMonthDownload}}</div><div><span class=\"fa fa-arrow-down text-success\" aria-hidden=true></span> {{dataUsage.thisMonthUpload}}</div></div><div class=\"col-xs-3 bdrL\"><label>{{\'d.p_du.4\' | translate}}:</label><div><span class=\"fa fa-arrow-up text-warning\" aria-hidden=true></span> {{dataUsage.lastTwoWeeksDownload}}</div><div><span class=\"fa fa-arrow-down text-success\" aria-hidden=true></span> {{dataUsage.lastTwoWeeksUpload}}</div></div><div class=\"col-xs-3 bdrL\"><label>{{\'d.p_du.5\' | translate}}:</label><div><span class=\"fa fa-arrow-up text-warning\" aria-hidden=true></span> {{dataUsage.lastTwoMonthsDownload}}</div><div><span class=\"fa fa-arrow-down text-success\" aria-hidden=true></span> {{dataUsage.lastTwoMonthsUpload}}</div></div></div><div class=spaceH></div><div class=\"text-bold marT15\">{{\'d.p_du.6\' | translate}}:</div><div class=\"bdr-top-dashed marT5\"></div><div class=\"form-group marT5\"><label>{{\'cm.label.9\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange date-range-picker class=\"form-control picker\" ng-model=date.range format=MM/DD/YYYY> <span class=input-group-btn><button type=button role=button ng-click=customDataUsageFx(); class=\"btn btn-info\">{{\'d.p_du.7\' | translate}}</button></span></div></div><div class=row ng-if=customDataUsage><div class=col-xs-12><label>{{\'d.p_du.8\' | translate}}: <span class=\"fa fa-arrow-up text-warning marL5\" aria-hidden=true></span> {{customDataUsage.customDataUpload}} <span class=\"fa fa-arrow-down text-success marL10\" aria-hidden=true></span> {{customDataUsage.customDataDownload}}</label></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/dataUsageSetting.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_dus.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{ngDialogData.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{ngDialogData.label}}</span> ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!dataUsage><div ng-if=dataUsage><div class=bdrBtm><div class=form-group><label>{{\'d.p_dus.2\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=dataUsage.screenshots aria-checked={{dataUsage.screenshots?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=form-group ng-if=dataUsage.screenshots><div class=row><div class=col-xs-12><label>{{\'d.p_dus.3\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.76\' | translate}} 120)</span></label></div><div class=col-xs-6><div class=input-group><input type=number class=form-control ng-model=dataUsage.uploadInterval min=120 step=30 aria-label=\"{{\'d.p_dus.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dus.3\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.27s\' | translate}}</span></div></div><div class=\"col-xs-6 text-muted\"><div class=marT8 ng-if=dataUsage.uploadInterval>{{dataUsage.uploadInterval/60 | setDecimal:2}} {{(dataUsage.uploadInterval/60) > 1?\'cm.label.28s\':\'cm.label.28\' | translate | lowercase}}</div><div class=marT8 ng-if=!dataUsage.uploadInterval>{{\'d.p_dus.3.1\' | translate}}</div></div></div></div></div><div><div class=form-group><label>{{\'d.p_dus.4\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=dataUsage.restriction aria-checked={{dataUsage.restriction?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"form-group row\" ng-if=dataUsage.restriction><div class=\"col-xs-12 text-bold\">{{\'d.p_dus.5\' | translate}}:</div><div class=col-xs-3><div class=\"timepicker noMarB\"><label>{{\'cm.label.12\' | translate}}</label><span uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"dataUsage.startTime | date:\'shortTime\'\" readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" uib-dropdown-menu><div uib-timepicker ng-model=dataUsage.startTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-3><div class=\"timepicker noMarB\"><label>{{\'cm.label.13\' | translate}}</label><span uib-dropdown auto-close=outsideClick dropdown-append-to-body><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"dataUsage.endTime | date:\'shortTime\'\" readonly aria-label=\"{{\'cm.label.13\' | translate}}\" aria-labelledby=\"{{\'cm.label.13\' | translate}}\"></div><div class=\"dropdown-menu dropdown-to-body\" uib-dropdown-menu><div uib-timepicker ng-model=dataUsage.endTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-6><div class=noMarB><label>{{\'d.p_dus.6\' | translate}} <span tooltip-placement=top uib-tooltip=\"{{\'d.p_dus.7\' | translate}}\"><span class=\"fa fa-question-circle\" aria-hidden=true></span></span></label><div class=input-group><input type=number class=form-control ng-model=dataUsage.overrideFS min=0 aria-label=\"{{\'d.p_dus.6\' | translate}}\" aria-labelledby=\"{{\'d.p_dus.6\' | translate}}\"> <span class=input-group-addon>MB</span></div></div></div></div></div><div class=\"form-group noMarB hide\"><div class=row><div class=col-xs-12><label>{{\'d.p_dus.8\' | translate}} <span class=\"text-muted text-sm\">({{\'cm.label.76\' | translate}} 30)</span></label></div><div class=col-xs-6><div class=input-group><input type=number class=form-control ng-model=dataUsage.pollingDuration min=30 step=30 aria-label=\"{{\'d.p_dus.8\' | translate}}\" aria-labelledby=\"{{\'d.p_dus.8\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.27s\' | translate}}</span></div></div><div class=\"col-xs-6 text-muted\"><div class=marT8 ng-if=dataUsage.pollingDuration>{{dataUsage.pollingDuration/60 | setDecimal:2}} {{(dataUsage.pollingDuration/60) > 1?\'cm.label.28s\':\'cm.label.28\' | translate | lowercase}}</div><div class=marT8 ng-if=!dataUsage.pollingDuration>{{\'d.p_dus.3.1\' | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=dataUsageSettingFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'screenshot\'\" aria-live=polite role=status>{{\'d.p_dus.m1\' | translate}}</div><div ng-if=\"errType==\'dStart\'\" aria-live=polite role=status>{{\'cm.msg.8\' | translate}}</div><div ng-if=\"errType==\'dEnd\'\" aria-live=polite role=status>{{\'cm.msg.9\' | translate}}</div><div ng-if=\"errType==\'dStartEnd\'\" aria-live=polite role=status>{{\'d.p_dus.m2\' | translate}}</div><div ng-if=\"errType==\'dFSize\'\" aria-live=polite role=status>{{\'d.p_dus.m3\' | translate}}</div><div ng-if=\"errType==\'polling\'\" aria-live=polite role=status>{{\'d.p_dus.m4\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceControl.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.brief.13\' | translate | camelCase}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-70\" uib-tooltip={{curDeviceControl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{curDeviceControl.label}}</span> ]</span></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(310)}}px><img alt=Loading src=assets/images/loading.gif ng-if=controlLoading><div ng-if=!controlLoading><header class=\"panel-inner-tab marB10\" ng-if=auth.upermissions.webos><a href=\"\" role=link ng-class=\"{\'selected\':selectedTPop==\'1\'}\" ng-click=tabPopFx(1);>{{\'d.brief.13\' | translate | camelCase}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedTPop==\'2\'}\" ng-click=tabPopFx(2);>{{\'d.p_dc.17\' | translate}}</a> <button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=setDefaultFx(); ng-if=\"selectedTPop==2\" ng-disabled=defautProcessing><span class=\"fa fa-repeat\" ng-class=\"defautProcessing?\'fa-spin\':\'\'\" aria-hidden=true></span>{{\'em.btn.3\' | translate}}</button></header><div ng-if=\"selectedTPop == 1\"><img alt=Loading src=assets/images/loading.gif ng-if=tabLoading><div ng-if=!tabLoading><div class=row><div class=col-xs-12 ng-if=\"curDeviceControl.dType == \'mc\'\"><div class=msg-warning lang={{auth.lang}}>{{\'d.p_dc.m4\' | translate}}</div></div></div><div ng-if=\"curDeviceControl.dType != \'mc\'\"><div class=row><div class=col-xs-12><label>{{\'d.p_dc.1\' | translate}}</label></div><div class=col-xs-5><div>{{\'d.p_dc.2\' | translate}}</div><div><span ng-if=\"deviceControl.lastReboot != null\" class=text-sm>{{(deviceControl.lastReboot * 1000) | date:\"medium\"}}</span> <span ng-if=\"deviceControl.lastReboot == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div></div><div class=col-xs-4><div>{{\'d.p_dc.3\' | translate}}</div><span ng-if=\"deviceControl.reboot != \'w\' && deviceControl.reboot != null\" class=\"text-success text-sm\">{{(deviceControl.reboot * 1000) | date:\"medium\"}} <span class=\"fa fa-check text-sm\" aria-hidden=true></span></span> <span ng-if=\"deviceControl.reboot == \'w\'\" class=\"text-muted text-sm\">{{\'d.p_dc.4\' | translate}}</span> <span ng-if=\"deviceControl.reboot == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=col-xs-3 uib-tooltip=\"{{\'d.p_dc.15\' | translate}}\" tooltip-enable=\"deviceControl.reboot == \'w\'\"><button type=button role=button class=\"btn btn-primary btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'reboot\');\" ng-disabled=\"deviceControl.reboot == \'w\'\"><span class=\"fa fa-power-off\" aria-hidden=true></span>{{\'d.p_dc.5\' | translate}}</button></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label>{{\'d.p_dc.8\' | translate}}</label></div><div class=col-xs-5><div>{{\'d.p_dc.8.1\' | translate}}</div><span ng-if=\"deviceControl.lastRelaunch != null\" class=text-sm>{{(deviceControl.lastRelaunch * 1000) | date:\"medium\"}}</span> <span ng-if=\"deviceControl.lastRelaunch == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=col-xs-4><div>{{\'d.p_dc.8.2\' | translate}}</div><span ng-if=\"deviceControl.relaunch != \'w\' && deviceControl.relaunch != null\" class=\"text-success text-sm\">{{(deviceControl.relaunch * 1000) | date:\"medium\"}} <span class=\"fa fa-check text-sm\" aria-hidden=true></span></span> <span ng-if=\"deviceControl.relaunch == \'w\'\" class=\"text-muted text-sm\">{{\'d.p_dc.6.1\' | translate}}</span> <span ng-if=\"deviceControl.relaunch == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=col-xs-3 uib-tooltip=\"{{\'d.p_dc.15\' | translate}}\" tooltip-enable=\"deviceControl.relaunch == \'w\'\"><button type=button role=button class=\"btn btn-primary btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'relaunch\');\" ng-disabled=\"deviceControl.relaunch == \'w\'\"><span class=\"fa fa-repeat\" aria-hidden=true></span>{{\'d.p_dc.6\' | translate}}</button></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label>{{\'d.p_dc.9\' | translate}}</label></div><div class=col-xs-5><div>{{\'d.p_dc.9.1\' | translate}}</div><span ng-if=\"deviceControl.lastDownload != null\" class=text-sm>{{(deviceControl.lastDownload * 1000) | date:\"medium\"}}</span> <span ng-if=\"deviceControl.lastDownload == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=col-xs-4><div>{{\'d.p_dc.9.2\' | translate}}</div><span ng-if=\"deviceControl.download != \'w\' && deviceControl.download != null\" class=\"text-success text-sm\">{{(deviceControl.download * 1000) | date:\"medium\"}} <span class=\"fa fa-check text-sm\" aria-hidden=true></span></span> <span ng-if=\"deviceControl.download == \'w\'\" class=\"text-muted text-sm\">{{\'d.p_dc.7\' | translate}}</span> <span ng-if=\"deviceControl.download == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=col-xs-3 uib-tooltip=\"{{\'d.p_dc.15\' | translate}}\" tooltip-enable=\"deviceControl.download == \'w\'\"><button type=button role=button class=\"btn btn-primary btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'download\');\" ng-disabled=\"deviceControl.download == \'w\'\"><span class=\"fa fa-download\" aria-hidden=true></span>{{\'d.p_dc.9\' | translate | camelCase}}</button></div></div><div ng-if=deviceControl.isCod><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label>{{\'cl.widget.cod.1\' | translate}}</label></div><div class=col-xs-5><label for=widgetCodITime>{{\'cl.widget.cod.14.1\' | translate}}</label><div class=input-group><input type=text id=widgetCodITime class=form-control ng-model=deviceControl.widgetCodITime maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'cl.widget.cod.14.1\' | translate}}\" aria-labelledby=\"{{\'cl.widget.cod.14.1\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div><div class=col-xs-4><label for=widgetCodPass>{{\'lock.1\' | translate}}</label><input type=text id=widgetCodPass class=form-control ng-model=deviceControl.widgetCodPass maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'lock.1\' | translate}}\" aria-labelledby=\"{{\'lock.1\' | translate}}\"></div><div class=col-xs-3><label>&nbsp;</label><button type=button role=button class=\"btn btn-success btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'cod\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button></div></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label>{{\'ms.p_am.1\' | translate}}</label></div><div class=col-xs-5><label for=iTime>{{\'ms.p_am.2\' | translate}}</label><div class=input-group><input type=text id=iTime class=form-control ng-model=deviceControl.iTime maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'ms.p_am.2\' | translate}}\" aria-labelledby=\"{{\'ms.p_am.2\' | translate}}\"> <span class=input-group-addon>{{\'cm.label.28s\' | translate}}</span></div></div><div class=col-xs-4><label for=pass>{{\'lock.1\' | translate}}</label><input type=text id=pass class=form-control ng-model=deviceControl.pass maxlength={{inputLimit}} onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" aria-label=\"{{\'lock.1\' | translate}}\" aria-labelledby=\"{{\'lock.1\' | translate}}\"></div><div class=col-xs-3><label>&nbsp;</label><button type=button role=button class=\"btn btn-success btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'am\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label>{{\'d.p_dc.14\' | translate}}</label></div><div ng-if=!deviceControl.playback_list.length class=\"col-xs-12 text-muted text-sm\">N/A</div><div ng-if=deviceControl.playback_list.length><div class=col-xs-9><div class=\"dropdown customSelect\" uib-dropdown><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-disabled=\"deviceControl.playback == \'w\'\"><span ng-if=!curPb.s>{{\'d.p_dc.14.1\' | translate}}</span> <span ng-if=curPb.s>{{curPb.s.name}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR5><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"pb in deviceControl.playback_list | orderBy: \'name\'\" tabindex=$index><label ng-class=\"{\'selected\':curPb.s.name == pb.name}\"><input type=radio role=radio name=pbOpt value={{pb}} ng-checked=\"curPb.s.name == pb.name\" ng-model=curPb.s ng-change=pbChangeFx() class=hide aria-label=curPbs{{$index}} aria-labelledby=curPbs{{$index}}> {{pb.name}}<span class=\"text-muted text-sm inline\" ng-if=pb.selected> - ({{\'cl.widget.queue.3\' | translate}})</span></label></li></div></div></div></div></ul></div></div><div class=col-xs-3 uib-tooltip=\"{{deviceControl.playback == \'w\'?\'d.p_dc.15\':\'d.p_dc.16\' | translate}}\" tooltip-enable=\"curPb.s.selected || deviceControl.playback == \'w\'\"><button type=button role=button class=\"btn btn-primary btn-block btn-sm\" ng-click=\"deviceConfirmOpen(\'playback\');\" ng-disabled=\"!curPb.s || curPb.s.selected || deviceControl.playback == \'w\'\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'u.btn.7\' | translate}}</button></div><div class=\"col-xs-5 marT10\"><div>{{\'d.p_dc.14.2\' | translate}}</div><span ng-if=\"deviceControl.lastPlayback != null\" class=text-sm>{{(deviceControl.lastPlayback * 1000) | date:\"medium\"}}</span> <span ng-if=\"deviceControl.lastPlayback == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div><div class=\"col-xs-4 marT10\"><div>{{\'d.p_dc.14.3\' | translate}}</div><span ng-if=\"deviceControl.playback != \'w\' && deviceControl.playback != null\" class=\"text-success text-sm\">{{(deviceControl.playback * 1000) | date:\"medium\"}} <span class=\"fa fa-check text-sm\" aria-hidden=true></span></span> <span ng-if=\"deviceControl.playback == \'w\'\" class=\"text-muted text-sm\">{{\'d.p_dc.14.4\' | translate}}</span> <span ng-if=\"deviceControl.playback == null\" class=\"text-muted text-sm\">{{\'cm.label.18\' | translate}}</span></div></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=row><div class=col-xs-12><label><input type=checkbox ng-model=deviceControl.isReboot role=checkbox aria-label=isReboot aria-labelledby=isReboot><label></label>{{\'d.p_dc.19\' | translate}}</label><button type=button role=button class=\"btn btn-success btn-xs marL10\" ng-click=\"deviceConfirmOpen(\'rebootTime\');\" ng-disabled=\"deviceControl.isReboot == isReboot\" ng-if=!deviceControl.isReboot><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button></div><div class=\"col-xs-3 noPadR\" ng-if=deviceControl.isReboot><div class=\"form-group timepicker\"><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker input-sm\" uib-dropdown-toggle ng-value=\"deviceControl.rebootTime | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"reboot time\" aria-labelledby=\"reboot time\"></div><div class=\"dropdown-menu noMarL\" uib-dropdown-menu><div uib-timepicker ng-model=deviceControl.rebootTime hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-1 ng-if=deviceControl.isReboot><button type=button role=button class=\"btn btn-success btn-sm\" ng-click=\"deviceConfirmOpen(\'rebootTime\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=\"form-group noMarB\"><label>{{\'d.p_dc.10\' | translate}}</label><div role=radiogroup aria-labelledby=radiogroup><label class=marR10 for=transitionf><input type=radio role=radio name=transitionOpt ng-model=deviceControl.transition id=transitionf value=f><label></label>{{\'d.p_dc.10.1\' | translate}}</label><label class=marR10 for=transitionn><input type=radio role=radio name=transitionOpt ng-model=deviceControl.transition id=transitionn value=n><label></label>{{\'d.p_dc.10.2\' | translate}}</label><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=\"deviceConfirmOpen(\'transition\');\" ng-disabled=\"deviceControl.transition == transition\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button></div></div><div>&nbsp;</div><div>&nbsp;</div><div class=\"form-group noMarB\"><label for=positionTop>{{\'d.p_dc.11\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=deviceControl.positionTop id=positionTop aria-checked={{deviceControl.positionTop?true:false}} ng-change=\"deviceConfirmFx(\'position\')\" on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div>&nbsp;</div><div class=\"form-group noMarB\"><label for=blankScreen>{{\'d.p_dc.12\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=deviceControl.blankScreen id=blankScreen aria-checked={{deviceControl.blankScreen?true:false}} ng-change=\"deviceConfirmFx(\'blankScreen\')\" on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div></div></div><div ng-if=\"selectedTPop == 2\"><img alt=Loading src=assets/images/loading.gif ng-if=tabLoading><div class=row ng-if=!tabLoading><div class=col-xs-12><div class=\"msg-warning marB10\" lang={{auth.lang}}>{{\'d.p_dc.wos.1\' | translate}}</div><div class=\"panel-inner-tab marB5\">{{\'d.p_dc.wos.12\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div ng-class=\"webOS.fw.mdls.length?\'col-xs-4\':\'col-xs-6\'\"><label>{{\'cl.p_v.2\' | translate}}</label><div>{{webOS.fw.cur.version}}<span class=\"text-muted text-sm\" ng-if=!webOS.fw.cur.version>N/A</span></div></div><div class=col-xs-3 ng-if=webOS.fw.mdls.length><label for=curMdv>{{\'d.p_dc.wos.12.7\' | translate}}</label><select id=curMdv class=form-control ng-model=curMd.v ng-options=\"md for md in webOS.fw.mdls\" ng-change=fwVersionFx(md) aria-label=\"{{\'d.p_dc.wos.12.7\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.12.7\' | translate}}\"></select></div><div ng-class=\"webOS.fw.mdls.length?\'col-xs-5\':\'col-xs-6\'\"><label>{{\'d.p_dc.wos.12.1\' | translate}}</label><div ng-if=mdlsLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div class=\"form-group noMarB\" ng-if=\"webOS.fw.upg.length && !mdlsLoading\"><div class=input-group><div class=\"dropdown customSelect initial\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle><span ng-if=!curFwu.fw>{{\'d.p_dc.wos.12.2\' | translate}}</span> <span ng-if=curFwu.fw>{{curFwu.fw.version}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"fw in webOS.fw.upg | orderBy:-\'version\'\" tabindex=$index><label for=curFwufw-{{$index}}><input type=radio role=radio name=mpOpt value=\"{{ {id:fw.id, version:fw.version, url:fw.url, direction:fw.direction} }}\" ng-checked=\"fw.version == curFwu.fw.version\" ng-model=curFwu.fw id=curFwufw-{{$index}} ng-change=singleFwFx()><label></label>{{fw.version}}<span ng-if=\"fw.version == webOS.fw.cur.version\" class=\"text-muted text-sm inline\"> - ({{\'cl.widget.queue.3\' | translate}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"webOS.fw.upg.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div><span class=input-group-btn><button type=button role=button class=\"btn btn-primary\" ng-click=fwUpgradesOpen(); ng-disabled=\"fwProcessing || curFwu.fw.version == webOS.fw.cur.version\"><span ng-if=fwProcessing class=\"fa fa-repeat fa-spin\" aria-hidden=true></span> <span ng-if=\"!curFwu.fw.version || !webOS.fw.cur.version || curFwu.fw.version > webOS.fw.cur.version\">{{\'d.p_dc.wos.12.3\' | translate}}</span> <span ng-if=\"webOS.fw.cur.version && curFwu.fw.version < webOS.fw.cur.version\">{{\'d.p_dc.wos.12.6\' | translate}}</span> <span ng-if=\"curFwu.fw.version == webOS.fw.cur.version\">{{\'cl.widget.queue.3\' | translate}}</span></button></span></div></div></div></div><!-- <div class=\"msg-success marT5\" ng-if=\"fwSaved\">{{\'d.p_dc.wos.m8\' | translate}}</div> --><div class=\"errMsg pull-right marT5\" ng-if=hasPopErr aria-live=polite role=status><div ng-if=\"errPopType==\'emptyV\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m6\' | translate}}</div><div ng-if=\"errPopType==\'sameV\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m7\' | translate}}</div></div><div class=clearfix></div><div class=\"row marT10\" ng-if=webOS.fw.req><div class=col-xs-6>{{\'d.p_dc.wos.12.4\' | translate}}<div class=\"text-muted text-sm\"><span ng-if=webOS.fw.req>{{(webOS.fw.req * 1000) | date:\'medium\'}}</span> <span ng-if=!webOS.fw.req>{{\'cm.label.18\' | translate}}</span></div></div><div class=col-xs-6>{{\'d.p_dc.wos.12.5\' | translate}}<div class=\"text-muted text-sm\"><span class=text-success ng-if=\"webOS.fw.ack > webOS.fw.req\">{{(webOS.fw.ack * 1000) | date:\'medium\'}}</span> <span ng-if=\"!webOS.fw.ack || webOS.fw.ack < webOS.fw.req\">{{\'cm.label.18\' | translate}}</span></div></div></div><div class=\"panel-inner-tab padB5 marB10 marT10\"></div><div class=text-muted>{{\'d.p_dc.wos.m8\' | translate}}</div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB5\">{{\'d.p_dc.wos.2\' | translate}}</div><div class=\"bg-light pad10\"><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.3\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label for=gsmenu>{{\'d.p_dc.wos.3.1\' | translate}}</label><select id=gsmenu class=form-control ng-model=webOS.gs.l.menu ng-options=\"opt.language for opt in localeList track by opt.languageCode\" aria-label=\"{{\'d.p_dc.wos.3.1\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.3.1\' | translate}}\"></select></div><div class=\"col-xs-6 form-group\"><label for=gskey>{{\'d.p_dc.wos.3.2\' | translate}}</label><select id=gskey class=form-control ng-model=webOS.gs.l.key ng-options=\"opt.language for opt in localeList track by opt.languageCode\" aria-label=\"{{\'d.p_dc.wos.3.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.3.2\' | translate}}\"></select></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.4\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label for=sis>{{\'d.p_dc.wos.4.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.si.s id=sis aria-checked={{webOS.gs.si.s?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.7\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label for=signal>{{\'d.p_dc.wos.7.1\' | translate}} <span class=\"text-muted text-sm\">(15&nbsp;{{\'cm.label.28s\' | translate}})</span></label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.signal id=signal aria-checked={{webOS.gs.p.signal?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gspir>{{\'d.p_dc.wos.7.2\' | translate}} <span class=\"text-muted text-sm\">(4&nbsp;{{\'cm.label.29s\' | translate}})</span></label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.ir id=gspir aria-checked={{webOS.gs.p.ir?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gsdpm>{{\'d.p_dc.wos.7.3\' | translate}}</label><select id=gsdpm class=form-control ng-model=webOS.gs.p.dpm ng-options=\"opt.tl for opt in dpmList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.3\' | translate}}\"></select></div></div><div class=row><div class=\"col-xs-4 form-group timepicker\"><label for=gswakeUp>{{\'d.p_dc.wos.7.4\' | translate}}</label><select id=gswakeUp class=form-control ng-model=webOS.gs.p.wakeUp ng-options=\"opt.tl for opt in dpmWakeList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.4\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gspm>{{\'d.p_dc.wos.7.5\' | translate}}</label><select id=gspm class=form-control ng-model=webOS.gs.p.pm ng-options=\"opt.tl for opt in pmModeList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.5\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.5\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gsdelay>{{\'d.p_dc.wos.7.6\' | translate}} <span class=\"text-muted text-sm\">(0-250)</span></label><input type=number id=gsdelay class=form-control ng-model=webOS.gs.p.delay min=0 max=250 aria-label=\"{{\'d.p_dc.wos.7.6\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.6\' | translate}}\"></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=gsstatus>{{\'d.p_dc.wos.7.7\' | translate}}</label><select id=gsstatus class=form-control ng-model=webOS.gs.p.status ng-options=\"opt.tl for opt in pStatusList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.7.7\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.7.7\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=gswired>{{\'d.p_dc.wos.7.8\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.wired id=gswired aria-checked={{webOS.gs.p.wired?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gswireless>{{\'d.p_dc.wos.7.9\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.p.wireless id=gswireless aria-checked={{webOS.gs.p.wireless?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.8\' | translate}}</div><div><label class=text-md>{{\'d.p_dc.wos.8.1\' | translate}}</label><div class=row><div class=\"col-xs-12 form-group\"><label for=gswired>{{\'d.p_dc.wos.8.1.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.n.lan.wired id=gswired aria-checked={{webOS.gs.n.lan.wired?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><label class=text-md>{{\'d.p_dc.wos.8.2\' | translate}}</label><div class=row><div class=\"col-xs-6 form-group\"><label for=gsip>{{\'d.p_dc.wos.8.2.1\' | translate}}</label><input type=text id=gsip class=form-control ng-model=webOS.gs.n.cpc.ip aria-label=\"{{\'d.p_dc.wos.8.2.1\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.1\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsmask>{{\'d.p_dc.wos.8.2.2\' | translate}}</label><input type=text id=gsmask class=form-control ng-model=webOS.gs.n.cpc.mask aria-label=\"{{\'d.p_dc.wos.8.2.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.2\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsgateway>{{\'d.p_dc.wos.8.2.3\' | translate}}</label><input type=text id=gsgateway class=form-control ng-model=webOS.gs.n.cpc.gateway aria-label=\"{{\'d.p_dc.wos.8.2.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.3\' | translate}}\"></div><div class=\"col-xs-6 form-group\"><label for=gsdns>{{\'d.p_dc.wos.8.2.4\' | translate}}</label><input type=text id=gsdns class=form-control ng-model=webOS.gs.n.cpc.dns aria-label=\"{{\'d.p_dc.wos.8.2.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.8.2.4\' | translate}}\"></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.9\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label for=gsb>{{\'d.p_dc.wos.9.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.as.b id=gsb aria-checked={{webOS.gs.as.b?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=gsw>{{\'d.tool.9\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.gs.as.w id=gsw aria-checked={{webOS.gs.as.w?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=col-xs-12><div><label class=noMar for=gstvt><input type=checkbox ng-model=webOS.gs.as.tvt id=gstvt role=checkbox><label></label>{{\'d.p_dc.wos.9.2\' | translate}}</label></div><div class=padLR20 ng-if=webOS.gs.as.tvt><div class=\"row flex-wrap\"><div class=\"col-xs-6 marT10\" ng-repeat=\"day in webOS.gs.as.days\"><div class=row><div class=\"col-xs-12 marB10\"><label for=gsdays-{{$index}}><input type=checkbox ng-model=day.val role=checkbox id=gsdays-{{$index}} aria-label=gsdays-{{$index}} aria-labelledby=gsdays-{{$index}}><label></label>{{\'s.p_s.label.4.2.\'+day.label | translate}}</label><span class=marL5 ng-if=\"day.name==\'Mon\' || day.name==\'Sat\'\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"setTvTimerFx(day.name, day);\" ng-disabled=defautProcessing>{{(day.name==\'Mon\'?\'d.p_dc.wos.13\':\'d.p_dc.wos.15\') | translate}}</button> <button type=button role=button ng-if=\"day.name==\'Mon\'\" class=\"btn btn-default btn-xs\" ng-click=\"setTvTimerFx(\'all\', day);\" ng-disabled=defautProcessing>{{\'d.p_dc.wos.14\' | translate}}</button></span></div><div class=col-xs-6 ng-if=day.val><div class=\"form-group timepicker noMarB\"><label for=\"\">{{\'d.p_dc.wos.9.3\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"day.st | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'d.p_dc.wos.9.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.9.3\' | translate}}\"></div><div class=\"dropdown-menu noMarL\" uib-dropdown-menu style=left:-81px><div uib-timepicker ng-model=day.st hour-step=1 minute-step=5></div></div></span></div></div><div class=col-xs-6 ng-if=day.val><div class=\"form-group timepicker noMarB\"><label for=\"\">{{\'d.p_dc.wos.9.4\' | translate}}</label><span uib-dropdown auto-close=outsideClick><div class=input-group><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"day.et | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'d.p_dc.wos.9.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.9.4\' | translate}}\"></div><div class=\"dropdown-menu noMarL\" uib-dropdown-menu style=left:-82px><div uib-timepicker ng-model=day.et hour-step=1 minute-step=5></div></div></span></div></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.10\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=\"col-xs-4 form-group\"><label for=ash>{{\'d.p_dc.wos.10.1\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.h id=ash aria-checked={{webOS.as.h?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=asusb>{{\'d.p_dc.wos.10.2\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.usb id=asusb aria-checked={{webOS.as.usb?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div><div class=\"col-xs-4 form-group\"><label for=asosd>{{\'d.p_dc.wos.10.3\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.osd id=asosd aria-checked={{webOS.as.osd?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=asir>{{\'d.p_dc.wos.10.4\' | translate}}</label><select id=asir class=form-control ng-model=webOS.as.ir ng-options=\"opt.tl for opt in irLockList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.10.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.10.4\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=aslocal>{{\'d.p_dc.wos.10.5\' | translate}}</label><select id=aslocal class=form-control ng-model=webOS.as.local ng-options=\"opt.tl for opt in irLockList track by opt.value\" aria-label=\"{{\'d.p_dc.wos.10.5\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.10.5\' | translate}}\"></select></div><div class=\"col-xs-4 form-group\"><label for=aswifi>{{\'d.p_dc.wos.10.6\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.wifi id=aswifi aria-checked={{webOS.as.wifi?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label for=curpwd>{{\'ms.label.13\' | translate}}</label><input type=password id=curpwd class=form-control ng-model=webOSPwdObj.curpwd maxlength={{inputLimit}} autocomplete=new-password aria-label=\"{{\'ms.label.13\' | translate}}\" aria-labelledby=\"{{\'ms.label.13\' | translate}}\"></div><div class=\"col-xs-4 form-group\"><label for=newpwd>{{\'ms.label.14\' | translate}}<span class=\"fa fa-question-circle text-primary marL5\" uib-tooltip=\"{{\'d.p_dc.wos.m15\' | translate}}\" tooltip-placement=top aria-hidden=true></span></label><input type=password id=newpwd class=form-control ng-disabled=!webOSPwdObj.curpwd.length ng-model=webOSPwdObj.newpwd maxlength={{inputLimit}} autocomplete=off aria-label=\"{{\'ms.label.14\' | translate}}\" aria-labelledby=\"{{\'ms.label.14\' | translate}}\"></div><div class=\"col-xs-4 form-group\"><label for=conpwd>{{\'ms.label.15\' | translate}}</label><input type=password id=conpwd class=form-control ng-disabled=!webOSPwdObj.newpwd.length ng-model=webOSPwdObj.conpwd maxlength={{inputLimit}} autocomplete=off aria-label=\"{{\'ms.label.15\' | translate}}\" aria-labelledby=\"{{\'ms.label.15\' | translate}}\"></div></div><div class=row><div class=col-xs-6><label for=asss>{{\'d.p_dc.wos.10.7\' | translate}}</label><div><switch role=switch class=switch-sm ng-model=webOS.as.ss id=asss aria-checked={{webOS.as.ss?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\"></switch></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.11\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=col-xs-12><div class=\"text-bold marB10\">{{\'d.p_dc.wos.11.1\' | translate}} <span class=\"text-muted text-sm\">({{\'d.p_dc.wos.11.1.1\' | translate}})</span><div class=pull-right><button type=button role=button class=\"btn btn-primary btn-xs\" ng-click=blockAddFx(); ng-disabled=\"webOS.ns.port.length > 29\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span> {{\'cm.btn.19\' | translate}}</button></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!blockAdd && !webOS.ns.port.length\">{{\'d.p_dc.wos.m2\' | translate}}</div><div class=row ng-if=blockAdd><div class=col-xs-4><label for=blockObjp>{{\'d.p_dc.wos.11.1.2\' | translate}} <span class=\"text-muted text-sm\">(0-66355)</span></label><input type=number id=blockObjp class=form-control ng-model=blockObj.p min=0 max=66355 aria-label=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\"></div><div class=col-xs-3><label for=blockObjd>{{\'d.p_dc.wos.11.1.3\' | translate}}</label><select id=blockObjd class=form-control ng-model=blockObj.d aria-label=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\"><option value=in>{{\'d.p_dc.wos.11.1.3.1\' | translate}}</option><option value=out>{{\'d.p_dc.wos.11.1.3.2\' | translate}}</option><option value=all>{{\'d.p_dc.wos.11.1.3.3\' | translate}}</option></select></div><div class=col-xs-3><label for=blockObjpr>{{\'d.p_dc.wos.11.1.4\' | translate}}</label><select id=blockObjpr class=form-control ng-model=blockObj.pr aria-label=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\"><option value=TCP>TCP</option><option value=UDP>UDP</option></select></div><div class=col-xs-2><label class=w100>&nbsp;</label><button type=button role=button class=\"btn btn-success btn-block\" ng-click=\"savePortFx(\'a\');\" ng-disabled=!blockObj.p><span class=\"fa fa-check\" aria-hidden=true></span> {{\'cm.btn.7\' | translate}}</button></div></div><div class=\"table table-md marT10\" ng-if=webOS.ns.port.length><div class=\"row th\"><div class=col-xs-4>{{\'d.p_dc.wos.11.1.2\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.3\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.4\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><div class=row ng-repeat=\"port in webOS.ns.port\"><div class=col-xs-4><span ng-show=!port.show>{{port.p}}</span> <input type=number id=portp-{{$index}} class=form-control ng-model=port.p ng-show=port.show min=0 max=66355 aria-label=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.2\' | translate}}\"></div><div class=col-xs-3><span ng-if=!port.show><span ng-if=\"port.d == \'in\'\">{{\'d.p_dc.wos.11.1.3.1\' | translate}}</span> <span ng-if=\"port.d == \'out\'\">{{\'d.p_dc.wos.11.1.3.2\' | translate}}</span> <span ng-if=\"port.d == \'all\'\">{{\'d.p_dc.wos.11.1.3.3\' | translate}}</span></span><select id=portd-{{$index}} class=form-control ng-model=port.d ng-if=port.show aria-label=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.3\' | translate}}\"><option value=in>{{\'d.p_dc.wos.11.1.3.1\' | translate}}</option><option value=out>{{\'d.p_dc.wos.11.1.3.2\' | translate}}</option><option value=all>{{\'d.p_dc.wos.11.1.3.3\' | translate}}</option></select></div><div class=col-xs-3><span ng-if=!port.show>{{port.pr}}</span><select id=portshow-{{$index}} class=form-control ng-model=port.pr ng-if=port.show aria-label=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\" aria-labelledby=\"{{\'d.p_dc.wos.11.1.4\' | translate}}\"><option value=TCP>TCP</option><option value=UDP>UDP</option></select></div><div class=\"col-xs-2 noPadL text-right\"><span ng-if=!port.show><a href=\"\" role=link class=\"text-primary marR5\" ng-click=\"savePortFx(\'e\', port); port.show = !port.show\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=deletePortOpen($index);><span class=\"fa fa-remove\" aria-hidden=true></span></a></span><div class=\"input-group-btn blockListBtn\" ng-if=port.show><button type=button role=button class=\"btn btn-success btn-sm marR5\" ng-click=\"savePortFx(\'s\', port);\" ng-disabled=!port.p>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-default btn-sm\" ng-click=\"cancelEditFx(port.id,  port.show = !port.show);\">{{\'cm.btn.9\' | translate}}</button></div></div></div></div></div></div></div></div></div></div></div></div><footer class=panel-footer ng-if=!controlLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=webOSFx(); ng-if=\"selectedTPop==2\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=btn ng-class=\"selectedTPop==2?\'btn-link\':\'btn-default\'\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'offTime\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m10\' | translate}}</div><div ng-if=\"errType==\'eOpened\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m5\' | translate}}</div><div ng-if=\"errType==\'onTime\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m9\' | translate}}</div><div ng-if=\"errType==\'check\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m11\' | translate}}</div><div ng-if=\"errType==\'pEmpty\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m3\' | translate}}</div><div ng-if=\"errType==\'pSame\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m4\' | translate}}</div><div ng-if=\"errType==\'tzCT\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m1\' | translate}}</div><div ng-if=\"errType==\'tzCI\'\" aria-live=polite role=status>{{\'db.msg.4\' | translate}}</div><div ng-if=\"errType==\'iTime\'\" aria-live=polite role=status>{{\'ms.p_am.m1\' | translate}}</div><div ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errType==\'newPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m13\' | translate}}</div><div ng-if=\"errType==\'conPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m14\' | translate}}</div><div ng-if=\"errType==\'match\'\" aria-live=polite role=status>{{\'ms.msg.12\' | translate}}</div><div ng-if=\"errType==\'curPwd\'\" aria-live=polite role=status>{{\'ms.msg.13\' | translate}}</div><div ng-if=\"errType==\'same\'\" aria-live=polite role=status>{{\'ms.msg.14\' | translate}}</div><div ng-if=\"errType==\'noPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m15\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceId.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_mac.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{deviceId.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{deviceId.label}}</span> ]</span></header><div class=panel-body><div class=form-group><div><label for=reason>{{\'d.label.27\' | translate}}</label></div><select class=form-control id=reason ng-model=deviceId.reason aria-label=\"{{\'d.label.27\' | translate}}\" aria-labelledby=\"{{\'d.label.27\' | translate}}\"><option value=\"\" disabled>{{\'d.label.27.1\' | translate}}</option><option value=1>{{\'d.label.27.2\' | translate}}</option><option value=2>{{\'d.label.27.3\' | translate}}</option></select></div><div class=form-group ng-if=deviceId.reason><label for=mac>{{\'d.label.2\' | translate}}</label><input type=text id=mac class=form-control ng-model=deviceId.mac alpha-num alpha-num maxlength=50 aria-label=\"{{\'d.label.2\' | translate}}\" aria-labelledby=\"{{\'d.label.2\' | translate}}\"> <span class=\"text-muted text-sm marR5\">({{\'d.label.2.2\' | translate}})</span><span class=\"fa fa-question-circle\" uib-tooltip=\"{{\'d.msg.4\' | translate}}\" tooltip-placement=right tooltip-append-to-body=true aria-hidden=true></span></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-disabled=\"!deviceId.reason || saveProcessing\" ng-click=deviceIdFx(dataObj.caller);><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'idExists\'\" aria-live=polite role=status>{{\'d.msg.5\' | translate}}</div><div ng-if=\"errType==\'idInvalid\'\" aria-live=polite role=status>{{\'d.msg.11\' | translate}}</div><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_mac.m1\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.tool.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-65\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><!-- <div class=\"searchTbx bdrR\">\r\n        <input type=\"text\" class=\"form-control input-sm\" ng-model=\"searchDInfo.text\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength=\"250\">\r\n        <a href=\"\" role=\"link\" class=\"text-danger ng-hide\" ng-show=\"searchDInfo.text.length\" ng-click=\"searchDInfo.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n      </div> --><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'dbInfo\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loadingInfo><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingInfo}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchDInfo.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger ng-hide\" ng-show=searchDInfo.text.length ng-click=\"searchDInfo.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=\"panel-body scrollQuad\" ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><img alt=Loading src=assets/images/loading.gif ng-if=detailsLoading><!-- device properties --><div class=form-group ng-if=\"auth.upermissions.da.dp && !detailsLoading\"><div class=\"row d-flex align-items-center\"><div class=col-xs-7><label class=\"noMarB marT5\"><a href=\"\" role=link ng-click=\"dpOpen=dpOpen?false:true\">{{\'d.tab.6.8\' | translate}} <span class=fa ng-class=\"dpOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label></div></div><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=dpOpen><div ng-if=device.info.properties.length><div class=\"row th\"><div class=col-xs-6>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"dp in filteredProperties = (device.info.properties | customSearch:{key:searchDInfo.text, module:\'dp\'})\"><div class=\"col-xs-6 text-ellipsis-wrap\">{{dp.label}} <span ng-if=\"dp.desc != null && dp.desc != \'\'\" class=\"fa fa-info-circle text-primary marL5\" uib-tooltip={{dp.desc}} tooltip-placement=top tooltip-append-to-body=true aria-hidden=true></span></div><div class=col-xs-6><div ng-if=\"dp.vType != \'d\' && dp.vType != \'dt\' && dp.vType != \'ti\'\"><input type=text ng-if=!dp.editable class=\"form-control input-sm\" ng-model=dp.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}> <span ng-if=dp.editable>{{dp.value}}</span></div><!-- Date time format --><div ng-if=\"dp.vType != \'t\'\" ng-class=\"{\'d-flex justify-spaceB\':dp.vType == \'dt\'}\"><div ng-if=\"dp.vType != \'ti\'\" class=input-group ng-class=\"{\'marR10\':dp.vType == \'dt\'}\"><span class=input-group-addon ng-click=selectDateFx(dp)><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input ng-show=dp.isblank ng-click=selectDateFx(dp) type=text id=pDateRange class=\"form-control input-sm\" aria-label=pDateRange aria-labelledby=pDateRange> <input ng-show=!dp.isblank type=daterange id=pDateRange class=\"form-control input-sm picker\" ng-model=dp.dateRange format=MM/DD/YYYY singledatepicker=true readonly aria-label=pDateRange aria-labelledby=pDateRange> <span class=input-group-btn><button class=\"btn btn-sm btn-default height30 noPadT noPadB\" ng-show=!dp.isblank ng-click=clearDateFx(dp); type=button>{{\'cl.widget.mc.11\' | translate}}</button></span></div><span class=timepicker uib-dropdown auto-close=outsideClick ng-if=\"dp.vType == \'dt\' || dp.vType == \'ti\'\"><div class=input-group ng-class=\"{\'marL10\': dp.vType==\'dt\'}\"><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=pTime class=\"form-control input-sm picker\" uib-dropdown-toggle ng-value=\"dp.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=dp.time hour-step=1 minute-step=5></div></div></span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"searchDInfo.text.length && (device.info.properties | customSearch:{key:searchDInfo.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDInfo.text)}}&quot;</b>\'}\"></div></ul></div><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=!device.info.properties.length>{{\'ms.p_s.dp.m3\' | translate}}</div></div></div><div class=form-group ng-if=!detailsLoading><!-- device other info --><div class=\"row d-flex align-items-center\"><div class=col-xs-5><label class=noMarB><a href=\"\" role=link ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.label.9\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label></div><div class=col-xs-7><div ng-if=settingsOpen class=\"btn-group dropdown marT-2 pull-right\" uib-dropdown><button type=button role=button uib-dropdown-toggle class=\"btn btn-default btn-xs\"><span class=\"fa fa-plus noMarR pad5\" aria-hidden=true></span></button><!-- <button type=\"button\" role=\"button\" uib-dropdown-toggle class=\"btn btn-primary btn-xs\">\r\n                <span class=\"fa fa-ellipsis-v marL2 marR3 marT2 marB2\" aria-hidden=\"true\"></span>\r\n                <span class=\"sr-only\">Toggle Dropdown</span>\r\n              </button> --><!-- ng-click=\"addCustomInfo(valueType); searchDInfo.text=\'\';\" --><ul uib-dropdown-menu role=menu><li><a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'t\';addCustomInfo(valueType); searchDInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'t\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.15\' | translate}}</a> <a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'f\';addCustomInfo(valueType); searchDInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'f\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.16\' | translate}}</a> <a href=\"\" role=link class=\"noPadL noPadR\" ng-click=\"valueType=\'dt\';addCustomInfo(valueType); searchDInfo.text=\'\'\"><span class=\"fa fa-check marLR5\" ng-class=\"valueType==\'dt\'?\'vShow\':\'vHide\'\" aria-hidden=true></span>{{\'d.label.49\' | translate}}</a></li></ul></div><!-- <div ng-if=\"settingsOpen\" class=\"padLR5 padT5 marT-5 pull-right marLR5 bdrR\">\r\n              <a href=\"\" role=\"link\" id=\"refresh\" ng-click=\"refreshOInfoFx();\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=\"loadingInfo\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingInfo}\" aria-hidden=\"true\"></span></a>\r\n            </div> --></div></div><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=settingsOpen><div class=\"row th\"><div class=col-xs-5>{{\'d.label.10\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"i in filteredDeviceInfo = (device.info.info | customSearch:{key:searchDInfo.text, module:\'dp\'})\"><div ng-if=i.isEditable><div class=col-xs-5><input type=text class=\"form-control input-sm\" ng-model=i.label aria-label=\"{{\'d.label.10\' | translate}}\" aria-labelledby=\"{{\'d.label.10\' | translate}}\"></div><div ng-if=\"i.vType!=\'f\' && i.vType!=\'dt\'\" class=col-xs-6><input type=text class=\"form-control input-sm\" ng-model=i.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}></div><div ng-if=\"i.vType==\'f\'\" class=col-xs-6><div class=quotesImg><div class=\"pull-left relative\" ng-if=\"i.vFile.thumb && i.vFile.isAccessible\"><a href=\"\" role=link class=thumb-close ng-click=removeImgFx($index);><span class=\"fa fa-times-circle\" aria-hidden=true></span></a> <a ng-if=i.vFile.thumb ng-href=\"{{cDetailBucket + i.vFile.thumb | secureThumb}}\" role=button data-access={{i.vFile.isAccessible}} fancyboxable=fbTitleWithHome caption=\"{{(i.vFile.path + (i.vFile.path.length > 1 ? \' / \' : \' \') + i.vFile.label)}}\" ng-show=i.vFile.thumb><img alt=\"\" ng-src=\"{{tim + cBucket + i.vFile.thumb + inputImgThumbParam}}\"></a></div><div class=\"pull-left relative\" ng-if=\"i.vFile && !i.vFile.isAccessible\"><img alt=\"\" uib-tooltip=\"{{\'cl.widget.quotes.m6\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 alt=\"\" ng-src=assets/images/default/unknown.png class=emptyThumb-md></div><button type=button role=button class=\"btn btn-primary marT5 btn-xs\" ng-click=\"selectContentOpen($index);searchInfo.text=\'\'\">{{\'cl.btn.5\' | translate | camelCase}}</button></div></div><div ng-if=\"i.vType==\'dt\'\" class=\"col-xs-6 d-flex justify-spaceB\"><div class=\"input-group marR10\"><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=daterange id=dateRange class=\"form-control input-sm picker\" ng-model=i.dateRange format=MM/DD/YYYY singledatepicker=true readonly aria-label=dateRange aria-labelledby=dateRange></div><span class=timepicker uib-dropdown auto-close=outsideClick><div class=\"input-group marL10\"><span class=input-group-addon><span class=\"fa fa-clock-o\" aria-hidden=true></span></span> <input type=text id=time class=\"form-control input-sm picker\" uib-dropdown-toggle ng-value=\"i.time | date:\'shortTime\'\" placeholder=HH:mm readonly aria-label=\"{{\'cm.label.12\' | translate}}\" aria-labelledby=\"{{\'cm.label.12\' | translate}}\"></div><div class=dropdown-menu uib-dropdown-menu><div uib-timepicker ng-model=i.time hour-step=1 minute-step=5></div></div></span></div><div class=col-xs-1><a href=\"\" role=link ng-click=removeCustomInfo(i.id)><span class=\"fa fa-remove text-danger marT7\" aria-hidden=true></span></a></div></div><div ng-if=!i.isEditable><div class=col-xs-5>{{i.label}}</div><div class=\"col-xs-6 text-ellipsis-wrap\">{{i.value}}</div><div class=col-xs-1></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"searchDInfo.text.length && (device.info.info | customSearch:{key:searchDInfo.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDInfo.text)}}&quot;</b>\'}\"></div></ul></div></div><!-- App Switches --><div class=form-group ng-if=\"(auth.uType==0 || auth.uType==1) && device.info.switches && !detailsLoading\"><label class=noMarB><a href=\"\" role=link ng-click=\"dInfoSwitchOpen=dInfoSwitchOpen?false:true\">{{\'ms.p_s.tab.12\' | translate}} <span class=fa ng-class=\"dInfoSwitchOpen?\'fa-chevron-up\':\'fa-chevron-down\'\" aria-hidden=true></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10 noPadT table table-md\" ng-if=dInfoSwitchOpen><div ng-if=device.info.switches.length><div class=\"row th\"><div class=col-xs-6>{{\'ms.p_s.dp.2\' | translate}}</div><div class=col-xs-6>{{\'d.label.11\' | translate}}</div></div><ul class=table><li class=row ng-repeat=\"as in filteredswitches = (device.info.switches | customSearch:{key:searchDInfo.text, module:\'dp\'})\"><div class=\"col-xs-6 text-ellipsis-wrap\">{{as.label}} <span ng-if=\"as.desc != null && as.desc != \'\'\" class=\"fa fa-info-circle text-primary marL5\" uib-tooltip={{as.desc}} tooltip-placement=top tooltip-append-to-body=true aria-hidden=true></span></div><div class=col-xs-6><div><input type=text ng-if=!as.editable class=\"form-control input-sm\" ng-model=as.value aria-label=\"{{\'d.label.11\' | translate}}\" aria-labelledby=\"{{\'d.label.11\' | translate}}\" maxlength={{devicePropInfoLimit}}> <span ng-if=as.editable>{{as.value}}</span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"searchDInfo.text.length && (device.info.switches | customSearch:{key:searchDInfo.text, module:\'dp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDInfo.text)}}&quot;</b>\'}\"></div></ul></div><div class=\"msg-warning marT10\" lang={{auth.lang}} ng-if=!device.info.switches.length>{{\'ms.p_s.as.m1\' | translate}}</div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-if=device.info.isCompleted ng-click=\"saveDeviceInfoFx(\'\', \'info\')\" ng-disabled=saveDInfoProcessing><span class=fa ng-class=\"saveDInfoProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'label\'\" aria-live=polite role=status>{{\'d.msg.32\' | translate}}</div><div ng-if=\"errType == \'haveOne\'\" aria-live=polite role=status>{{\'ms.p_s.dp.m6\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceList.html","<section class=panel role=dialog><header class=panel-heading>{{\'cm.body.3\' | translate}} <span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-45\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><!-- <a href=\"\" ng-if=\"scrollDataList.length\" class=\"btn-link padL5 marL5\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=\"true\" ng-click=\"openGroupDevices(\'\', deviceList);\"><span class=\"fa fa-arrow-down\"></span></a> --> <a href=\"\" ng-if=\"scrollDataList.length && auth.upermissions.edl\" ng-disabled=loading class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=Download tooltip-append-to-body=true ng-click=\"openGroupDevices(\'dView\', allScrollDataList, deviceListObj.id);\"><span class=\"fa fa-download\"></span> </a><a href=\"\" id=refresh class=\"pad5 marLR5\" ng-class=\"{\'marLeft\': marRemove}\" ng-click=\"refreshPopupListFx(\'fDevices\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\"></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><!-- <span class=\"scrollSearchTooltip\" ng-if=\"searchTextPopup && searchTextPopup.length < 3\"><span translate=\"{{\'cm.msg.53\'}}\" translate-values=\"{count: {{3 - searchTextPopup.length}}}\"></span></span> --> <a href=\"\" class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\"></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><div class=msg-warning lang={{auth.lang}} ng-if=\"!refreshObj.l && !refreshObj.b\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll\" ng-if=!refreshObj.l><!-- <div class=\"table table-scroll\" ng-if=\"scrollDataList.length\"> --><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-4>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><div class=col-xs-4>{{\'d.label.31\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'s.body.4\' | translate}}</div> --></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{d.id}} ng-repeat=\"d in filteredList = (visibleData)\"><div class=\"col-xs-4 text-ellipsis-wrap\"><span class=\"deviceStatus {{d.status}}\" uib-tooltip=\"{{d.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{d.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{d.l}}</span></div><div class=\"col-xs-4 text-ellipsis-wrap\"><span uib-tooltip={{d.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{d.h}}</span> <span class=\"text-muted text-sm\" ng-if=!d.h>N/A</span></div><div class=\"col-xs-4 text-ellipsis-wrap\"><span class=\"fa fa-home marR5\" ng-if=d.path></span>{{d.path}} <span class=\"text-muted text-sm\" ng-if=!d.path>N/A</span></div><!-- <div class=\"col-xs-4 text-ellipsis-wrap text-sm\" ng-class=\"{\'text-danger\':d.error == \'expired\'}\">\r\n              <span uib-tooltip=\"{{\'db.body.8\' | translate}}\" tooltip-enable=\"d.error == \'expired\'\" tooltip-append-to-body=\"true\">{{d.range}}</span>\r\n              <span class=\"text-muted text-sm\" ng-if=\"!d.range\">N/A</span>\r\n            </div> --><!-- <div class=\"col-xs-2 text-ellipsis-wrap\">\r\n              {{sd.frame}}\r\n              <span class=\"text-muted text-sm\" ng-if=\"!sd.frame\">N/A</span>\r\n            </div> --></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog();>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceTagCount.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.name != \'videowall\'\" role=heading aria-level=1>{{(ngDialogData.name == \'device\' || ngDialogData.name == \'search\')?\'cm.body.3\':\'d.body.8\' | translate}}</h1><h1 ng-if=\"ngDialogData.name == \'videowall\'\" role=heading aria-level=1>{{\'Video Wall List\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a class=\"padL5 padR10 marL5 bdrR\" ng-if=\"refreshObj.b && auth.upermissions.edl && (selectedTab != \'hub.devices.d\')\" ng-disabled=loading href=\"\" role=button uib-tooltip=\"{{\'d.tool.14\' | translate}}\" ng-click=\"openGroupDevices(ngDialogData.name==\'search\'?\'searches\':selectedTab, \'\', ngDialogData.id);\"><span class=\"fa fa-download\" aria-hidden=true></span></a> <a href=\"\" role=link id=refresh class=\"pad5 marR5\" ng-class=\"{\'marL5\': marginLoad}\" ng-click=\"refreshPopupListFx(\'device\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><!-- <span class=\"scrollSearchTooltip\" ng-if=\"searchTextPopup && searchTextPopup.length < 3\"><span translate=\"{{\'cm.msg.53\'}}\" translate-values=\"{count: {{3 - searchTextPopup.length}}}\"></span></span> --> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><div class=msg-warning lang={{auth.lang}} ng-if=\"!refreshObj.l && !refreshObj.b\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!refreshObj.l && ngDialogData.name != \'videowall\' && (ngDialogData.name == \'device\' || ngDialogData.name == \'search\')\"><div class=\"row th\" ng-if=\"(ngDialogData.name == \'device\' || ngDialogData.name == \'search\') && filteredList.length\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.80\' | translate}}</div></div><div class=scrollQuad id=scroll-container ng-attr-style=max-height:{{getAvailableHeight(371)}}px ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{count.id}} ng-repeat=\"count in filteredList = (visibleData)\"><!-- <div class=\"row rowObj\" ng-repeat=\"count in filteredList = (visibleData | customSearch:{key:searchTextPopup, module:\'sdList\'})\"> --><div class=word-break ng-class=\"ngDialogData.name == \'tag\'?\'col-xs-12\':\'col-xs-8\'\"><span class=deviceStatus ng-class=\"count.status == \'online\'?\'online\':\'offline\'\" ng-if=\"ngDialogData.name == \'device\' || ngDialogData.name == \'search\'\" uib-tooltip=\"{{count.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=\"ngDialogData.name == \'tag\' && auth.upermissions.dtc\" ng-class=\"{\'noColorBox\':!count.tagColor}\" class=\"colorBox marR6\" style=vertical-align:bottom ng-style=\"{\'background-color\':count.tagColor}\" aria-hidden=true></span> <span class=\"fa fa-tag marR5\" ng-if=\"ngDialogData.name == \'tag\' && !auth.upermissions.dtc\" aria-hidden=true></span> {{count.l}}</div><div class=\"col-xs-4 word-break\" ng-if=\"(ngDialogData.name == \'device\' || ngDialogData.name == \'search\')\">{{count.h}}</div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"table table-scroll\" ng-if=\"countList.length && ngDialogData.name != \'videowall\' && ngDialogData.name != \'device\' && ngDialogData.name != \'search\'\"><div class=\"row th\" ng-if=\"(ngDialogData.name == \'device\' || ngDialogData.name == \'search\') && filteredList.length\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.80\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"count in filteredList = (countList | customSearch:{key:searchTextPopup, module:\'dl\'})\"><div class=word-break ng-class=\"ngDialogData.name == \'tag\'?\'col-xs-12\':\'col-xs-8\'\"><span class=deviceStatus ng-class=\"count.status == \'online\'?\'online\':\'offline\'\" ng-if=\"ngDialogData.name == \'device\' || ngDialogData.name == \'search\'\" uib-tooltip=\"{{count.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=\"ngDialogData.name == \'tag\' && auth.upermissions.dtc\" class=\"marR6 marT2\"><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{count.tagColor}}></ng-tag-icon></span><span class=\"fa fa-tag marR5\" ng-if=\"ngDialogData.name == \'tag\' && !auth.upermissions.dtc\" aria-hidden=true></span> {{count.label}}</div><div class=\"col-xs-4 word-break\" ng-if=\"(ngDialogData.name == \'device\' || ngDialogData.name == \'search\')\">{{count.mac}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=\"table table-md table-scroll\" ng-if=\"countList.length && ngDialogData.name == \'videowall\'\"><div class=\"row th\" ng-if=filteredList.length><div class=\"col-xs-2 padL25\">{{\'d.body.15\' | translate}}</div><div class=col-xs-4>{{\'cm.label.4\' | translate}}</div><div class=col-xs-3>{{\'d.label.2\' | translate}}</div><div class=col-xs-3>{{\'d.brief.11\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=\"row d-flex align-items-center\" ng-repeat=\"count in filteredList = (countList | orderBy:[\'-isMaster\', \'id\'] | customSearch:{key:searchTextPopup, module:\'dl\'})\"><div class=\"col-xs-2 word-break padL25\"><span class=\"master-wall-sm marR3\" ng-if=count.isMaster><span class=\"fa fa-star\" uib-tooltip=\"{{\'an.tab.3\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 aria-hidden=true role=status aria-label=\"{{\'an.tab.3\' | translate}}\"></span></span>{{count.cell}}</div><div class=\"col-xs-4 word-break\"><span class=deviceStatus ng-class=\"count.status == \'online\'?\'online\':\'offline\'\" uib-tooltip=\"{{count.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> <span ng-if=\"ngDialogData.name == \'tag\' && auth.upermissions.dtc\" class=marR5 aria-hidden=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{count.tagColor}}></ng-tag-icon></span><span class=\"fa fa-tag marR5\" ng-if=\"ngDialogData.name == \'tag\' && !auth.upermissions.dtc\" aria-hidden=true></span> {{count.label}}</div><div class=\"col-xs-3 word-break\">{{count.mac}}</div><div class=\"col-xs-3 word-break\"><span ng-if=count.localIp>{{count.localIp}}</span> <span ng-if=!count.localIp class=\"text-muted text-sm\">N/A</span></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/deviceUserGroup.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.label.36\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a class=\"padL5 padR10 marL5 bdrR\" ng-if=\"refreshObj.b && (selectedTab != \'hub.devices.d\')\" ng-disabled=loading href=\"\" role=button uib-tooltip=\"{{\'d.tool.14\' | translate}}\" ng-click=downloadUserGroup();><span class=\"fa fa-download\" aria-hidden=true></span></a> <a href=\"\" role=link id=refresh class=\"pad5 marR5\" ng-class=\"{\'marL5\': marginLoad}\" ng-click=\"refreshPopupListFx(\'device\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!refreshObj.l && !refreshObj.b\">{{\'u.msg.15\' | translate}}</div> --><div class=msg-warning lang={{auth.lang}} ng-if=\"!countList.length && !refreshObj.l && !refreshObj.b\">{{\'d.msg.61\' | translate}}</div><div class=\"form-group bg-light pad10\" ng-if=countList.length><label for=checkAccess>{{\'d.label.34\' | translate}}</label><div class=d-flex><div class=w100><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=userListSearchFocus(); aria-placeholder=\"{{\'as.label.3\' | translate}}\"><span ng-if=\"userDetail== \'\'\">{{\'as.label.3\' | translate}}</span> <span ng-if=\"userDetail!= \'\'\">{{userDetail.label ? userDetail.label : userDetail.email}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-if=\"userList.length > 5\"><div class=\"searchTbx input-xs findSearch\"><input type=text class=form-control ng-model=searchUserList.uLabel sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger noMarT\" ng-show=searchUserList.uLabel.length ng-click=\"searchUserList.uLabel=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-if=\"userList.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"u in user = (userList | filter:searchUserList.uLabel) | orderBy: \'email\'\" tabindex=$index><label><input type=radio role=radio name=uOpt value=\"{{ {uId:u.id ,uEmail:u.email,uLabel:u.label} }}\" ng-model=userDetail ng-click=singleUserListFx(u)><label></label>{{u.label ? u.label : u.email}} <span class=\"text-muted text-sm inline\" ng-if=u.label>- ({{u.email}})</span></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"user.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchUserList.uLabel)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div><div class=marL15><span class=input-grouop-btn><button type=button role=button class=\"btn btn-primary\" ng-disabled=!userDetail ng-click=getUserAccess(userDetail);>{{\"cm.btn.42\" | translate}}</button></span></div></div></div><div class=\"table table-scroll\" ng-if=countList.length><div class=\"row th\" ng-if=\"(ngDialogData.name == \'userGroup\') && filteredList.length\"><div class=col-xs-10>{{\'d.label.35\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.4s\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(430)}}px><div class=\"row noHover ugList\" ng-repeat=\"count in filteredList = (countList | customSearch:{key:searchTextPopup, module:\'dl\'})\" data-id={{count.id}} ng-class=\"count.noAccess?\'noAccess\':\'\'\"><div class=\"word-break col-xs-10\">{{count.label}}</div><div class=\"col-xs-2 text-right\"><button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"deviceListOpen(count.id, count.label);\">{{\'cm.btn.21\' | translate}}</button></div><!-- <div class=\"col-xs-4 word-break\" ng-if=\"(ngDialogData.name == \'userGroup\')\">{{count.mac}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"pull-right d-flex\" ng-if=legend><div class=marR10><span class=legend-green></span>{{\'d.label.37\' | translate}}</div><div><span class=legend-red></span>{{\'d.label.38\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/folderCU.html","<section class=panel role=dialog><header class=panel-heading><span ng-if=!ngDialogData.id><span ng-if=\"folder.info.fType==\'n\' ||  folder.info.fType == \'device\'\" role=heading aria-level=1>{{\'cl.p_f.1\' | translate}}</span> </span><span ng-if=ngDialogData.id><span ng-if=\"folder.info.fType==\'n\' ||  folder.info.fType == \'device\'\" role=heading aria-level=1>{{\'cl.p_f.2\' | translate}}</span></span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=lvPopLoading><div ng-if=!lvPopLoading><div class=form-group><label for=label>{{\'cl.p_f.3\' | translate}}</label><input type=text id=label class=form-control ng-model=folder.info.label autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'cl.p_f.3\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.3\' | translate}}\"></div><div class=\"form-group marT10\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=folder.permission pid=decId module=\"\'dFolder\'\"></ng-permission-brief></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=folderCUFx(); ng-disabled=saveProcessing><span ng-if=!ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span> <span ng-if=ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.p_f.m1\' | translate}}</div><div ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'cl.p_f.m4\' | translate}}</div><div ng-if=\"errType==\'library\'\" aria-live=polite role=status>{{\'cl.p_f.m3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/devices/popup/frameCount.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.body.7\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-65\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'frame\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':loading}\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!countList.frameLayouts.length><div class=\"table table-scroll\" ng-if=countList.frameLayouts.length><div class=\"row th\"><div class=col-xs-4>{{\'cm.label.72\' | translate | camelCase}}</div><div ng-class=\"countList.info.editable?\'col-xs-4\':\'col-xs-5\'\">{{\'fl.body.3\' | translate | camelCase}}</div><div class=\"col-xs-3 noPadR\">{{\'cm.label.9\' | translate | camelCase}}</div><div class=\"col-xs-1 text-right\" ng-if=countList.info.editable>{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=row ng-repeat=\"count in countList.frameLayouts\" ng-class=\"{\'bg-danger\' : count.isExpired == 1}\"><div class=\"col-xs-4 text-ellipsis-wrap\"><span class=\"fa fa-exclamation-triangle text-danger marR5\" uib-tooltip=\"{{\'fl.tool.6\' | translate}}\" tooltip-append-to-body=true ng-if=\"count.isExpired == 1\" aria-hidden=true></span> {{count.fla}}</div><div class=text-ellipsis-wrap ng-class=\"countList.info.editable?\'col-xs-4\':\'col-xs-5\'\"><a href=\"\" role=link class=btn-link ng-href=\"{{flBucket + count.id + \'.png\' | secureThumb:count.thumbV}}\" fancyboxable=fbTitleInside data-fancybox-title={{count.label}}>{{count.label}}</a></div><div class=\"col-xs-3 text-sm noPadR\" ng-class=\"{\'text-danger text-bold\' : count.isExpired == 1}\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div><div class=\"col-xs-1 text-right\" ng-if=countList.info.editable><a href=\"\" role=link ng-click=editAssignment(count.flaId);><span class=\"fa fa-pencil\" aria-hidden=true></span></a></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/groupCount.html","<section class=panel><header class=panel-heading><h1>{{\'d.label.36\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marR5 marL5\" ng-class=\"{\'marL5\': marginLoad}\" ng-click=\"refreshPopupListFx(\'uGroup\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.u><div class=msg-warning ng-if=\"!refreshObj.u && !uGroupList.length\">{{\'u.msg.15\' | translate}}</div><div class=\"table table-scroll\" ng-if=uGroupList.length><div class=\"row th\"><div class=col-xs-12>{{\'cm.brief.1\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"group in filteredList = (uGroupList | customSearch:{key:searchTextPopup, module:\'u\'})\"><div class=\"word-break col-xs-12\">{{group.label}}</div><div class=\"col-xs-4 word-break\" ng-if=\"(ngDialogData.name == \'device\' || ngDialogData.name == \'search\')\">{{group.mac}}</div></div><div class=msg-warning ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'d\'\" role=heading aria-level=1>{{\'d.tool.3\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'dg\'\" role=heading aria-level=1>{{\'d.tool.5\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'dt\'\" role=heading aria-level=1>{{\'d.tool.6\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'dvw\'\" role=heading aria-level=1>{{\'d.tool.22\' | translate}}</h1></header><div class=panel-body><span ng-if=\"ngDialogData.tabName==\'d\'\" role=img><p lang={{auth.lang}}>{{\'d.info.d1\' | translate}}</p><p lang={{auth.lang}}><span class=text-bold>{{\'d.info.d2\' | translate}}:</span> {{\'d.info.d2.1\' | translate}}</p><p lang={{auth.lang}}><span class=text-bold>{{\'d.info.d3\' | translate}}:</span> {{\'d.info.d3.1\' | translate}}</p><div class=marT25><img alt=\"\" src=assets/images/info/d.png></div></span><span ng-if=\"ngDialogData.tabName==\'dg\'\" role=img><p lang={{auth.lang}}>{{\'d.info.dg1\' | translate}}</p><div class=marT25><img alt=\"\" src=assets/images/info/dg.png></div></span><span ng-if=\"ngDialogData.tabName==\'dt\'\" role=img><p lang={{auth.lang}}>{{\'d.info.dt1\' | translate}}</p><p lang={{auth.lang}}>{{\'d.info.dt2\' | translate}}</p><p lang={{auth.lang}}>{{\'d.info.dt3\' | translate}}</p><div class=marT25><img alt=\"\" src=assets/images/info/dt.png></div></span><span ng-if=\"ngDialogData.tabName==\'dvw\'\" role=img><p lang={{auth.lang}}>{{\'d.info.dvw1\' | translate}}</p><div class=\"marT25 d-flex justify-center\"><img alt=\"\" src=assets/images/info/dvw.png></div></span></div></section>");
$templateCache.put("app/devices/popup/licInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.label.69\' | translate}}</h1><span class=\"text-sm marL5\" ng-if=\"logObj.info.label != \' \'\">[ <span class=\"text-ellipsis hTitle w-65\" uib-tooltip={{licObj.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{licObj.label}}</span> ]</span></header><div class=panel-body><div class=\"scrollQuad table no-th\" ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.58\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=licObj.info.id>{{licObj.info.id}}</span><span ng-if=!licObj.info.id class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.58.2\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=licObj.info.lt>{{licObj.info.lt}}</span><span ng-if=!licObj.info.lt class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.69.1\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=licObj.info.aOn>{{(licObj.info.aOn * 1000) | date:\"MMM d, y\"}}</span><span ng-if=!licObj.info.aOn class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.69.6\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=licObj.info.gld>{{(licObj.info.gld * 1000) | date:\"MMM d, y\"}}</span><span ng-if=!licObj.info.gld class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.69.2\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=\"licObj.info.bf==\'m\'\">{{\'b.o.2.3\' | translate}}</span> <span ng-if=\"licObj.info.bf==\'y\'\">{{\'b.o.2.4\' | translate}}</span> <span ng-if=!licObj.info.bf class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.69.3\' | translate}}</div><div class=\"col-xs-6 text-ellipsis\"><span ng-if=licObj.info.bsd>{{(licObj.info.bsd * 1000) | date:\"MMM d, y\"}}</span><span ng-if=!licObj.info.bsd class=\"text-muted text-sm\">N/A</span></div></div><div class=row><div class=\"col-xs-6 word-break\">{{\'d.label.69.5\' | translate}}</div><div class=col-xs-6><div ng-if=licObj.info.ie ng-repeat=\"be in licObj.emails\">{{be}}</div><span ng-if=!licObj.info.ie class=\"text-muted text-sm\">N/A</span></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/move.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.btn.6\' | translate}}</h1></header><!-- t.body.3 --><div class=panel-body><div class=\"panel-inner-tab marB10 hide\"><a href=\"\" ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'cl.p_m.2\' | translate}}</a><!-- <a href=\"\" ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\">{{\'cl.p_m.3\' | translate}}</a> --></div><!-- <div class=\"form-group\">\r\n        <div class=\"bg-light pad5\">\r\n          <label class=\"noMarB marR10\"><input type=\"radio\" name=\"typeOpt\" ng-model=\"moveObj.type\" value=\"move\" ng-change=\"changeTypeFx()\"><label></label> {{\'cl.p_m.4\' | translate}}</label>\r\n          <label class=\"noMarB\"><input type=\"radio\" name=\"typeOpt\" ng-model=\"moveObj.type\" value=\"copy\" ng-change=\"changeTypeFx()\"><label></label> {{\'cl.p_m.5\' | translate}}</label>\r\n        </div>\r\n      </div> --> <img alt=Loading src=assets/images/loading.gif ng-if=\"moveLoading || lvPopLoading\"><div ng-if=\"selectedT==\'1\' && !lvPopLoading\"><div class=\"bg-light moveTreeContainer\"><div><label><input type=radio name=treeOpt value=0 ng-checked=true><label></label>{{\'cl.p_m.6\' | translate}}</label><!-- <label><input type=\"radio\" name=\"treeOpt\" value=\"0\" ng-checked=\"auth.upermissions.ar\"><label></label> {{\'cl.p_m.6\' | translate}}</label> --><tree list=moveObj.curServerTree check-disable=true class=\"list-unstyled moveTree\"></tree></div></div></div><!-- <div ng-if=\"!moveLoading && selectedT==\'2\'\">\r\n        <div class=\"form-group noMarB\">\r\n          <label>{{\'cl.p_m.7\' | translate}}</label>\r\n          <select class=\"form-control\" ng-model=\"moveObj.server\" ng-change=\"changeServerFx()\" ng-options=\"server.label for server in serverList | orderBy:\'label\' track by server.id\">\r\n            <option value=\"\">{{\'cl.p_m.7\' | translate}}</option>\r\n          </select>\r\n        </div>\r\n      </div> --><div class=\"marT15 errMsg\" ng-if=\"arError || fError || cError || wError\"><p><span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.m3\' | translate}}:</span><!-- <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.m4\' | translate}}:</span> --></p><div ng-if=arError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m5\' | translate}}</div><div ng-if=fError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m6\' | translate}}</div><div ng-if=cError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m7\' | translate}}</div><div ng-if=wError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m8\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button ng-click=moveFx(moveObj.type); class=\"btn btn-success\" ng-disabled=\"arError || fError || cError || wError || moveProcessing\"><span class=\"fa fa-check\" ng-if=!moveProcessing aria-hidden=true></span> <span class=\"fa fa-repeat fa-spin\" ng-if=moveProcessing aria-hidden=true></span> <span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.4\' | translate}}</span><!-- <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.5\' | translate}}</span> --></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'cl.p_m.m1\' | translate}}</div><div ng-if=\"errType==\'server\'\" aria-live=polite role=status>{{\'cl.p_m.m2\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/phList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.brief.25\' | translate | camelCase}}</h1><span class=\"marL5 text-sm\" ng-if=\"phObj.info.label != \' \'\">[ <span class=\"text-ellipsis hTitle w-65\" uib-tooltip={{phObj.info.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{phObj.info.label}}</span> ]</span><div class=\"pull-right bdrR\" ng-if=\"phObj.list.length > 0\"><a href=\"\" role=link id=refresh class=\"btn-link padLR5\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-click=\"loadMorePHFx(\'refresh\');\" ng-disabled=refreshLoading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': refreshLoading}\" aria-hidden=true></span></a> <a href=\"\" role=link class=\"btn-link padLR5\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=downloadPHOpen();><span class=\"fa fa-arrow-down\" aria-hidden=true></span></a> <a href=\"\" role=link class=padLR5 uib-tooltip-template=\"\'phInfo.html\'\" tooltip-placement=bottom tooltip-append-to-body=true><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div></header><div class=panel-body><div class=table><div class=\"row th\"><div class=col-xs-3>{{\'cm.label.7\' | translate}}</div><div class=col-xs-9>{{\'cm.tool.3\' | translate}}</div></div><img alt=Loading src=assets/images/loading.gif ng-if=phLoading class=marT5><div class=scrollQuad ng-if=\"!phLoading && phObj.list.length > 0\" when-scrolled=loadMorePHFx() ng-attr-style=max-height:{{getAvailableHeight(370)}}px><div class=row ng-repeat=\"ph in phObj.list\"><div class=col-xs-3>{{(ph.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-9 word-break\">{{ph.label | capitalize}}</div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!phLoading && phObj.list.length <= 0\">{{\'d.msg.55\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section><style>.tooltip-inner{max-width:100%}</style><script type=text/ng-template id=phInfo.html><div class=\"text-left\">\r\n    <div>\r\n      <div class=\"text-bold\">localKey</div>\r\n      <div>{{\'r.tool.8\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">offTimer</div>\r\n      <div>{{\'r.tool.9\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">remoteKey</div>\r\n      <div>{{\'r.tool.10\' | translate}}</div>\r\n      <div class=\"spaceH\"></div>\r\n    </div>\r\n    <div>\r\n      <div class=\"text-bold\">unknown</div>\r\n      <div>{{\'r.tool.11\' | translate}}</div>\r\n    </div>\r\n  </div></script>");
$templateCache.put("app/devices/popup/previousChanges.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.tool.18\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{dataCHObj.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dataCHObj.label}}</span> ]</span></header><div class=\"panel-body scrollQuad\" ng-style=\"{\'max-height\':{{getAvailableHeight(304)}}+\'px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !dataCHObj.history.length\">{{\'d.p_h.m1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!popupLoading && dataCHObj.history.length\"><div class=\"row th\"><div class=col-xs-2>{{\'d.p_h.1\' | translate}}</div><div class=col-xs-2>{{\'d.p_h.2\' | translate}}</div><div class=col-xs-3>{{\'d.p_h.3\' | translate}}</div><div class=col-xs-2>{{\'d.p_h.4\' | translate}}</div><div class=col-xs-3>{{\'d.p_h.5\' | translate}}</div></div><div class=scrollQuad ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=row ng-repeat=\"list in dataCHObj.history\"><div class=\"col-xs-2 word-break\">{{list.from}}</div><div class=\"col-xs-2 word-break\">{{list.to}}</div><div class=col-xs-3>{{list.by}}</div><div class=\"col-xs-2 text-sm\">{{(list.on * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=col-xs-3><span ng-if=\"list.reason == 1\">{{\'d.p_h.6\' | translate}}</span> <span ng-if=\"list.reason == 2\">{{\'d.p_h.7\' | translate}}</span></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/scheduleList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.2\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'schedule\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=!popupLoading><div class=col-xs-9 ng-class=\"{\'col-xs-12\':countList.framelayout.length == 0}\"><div class=\"table table-scroll\"><div class=\"row th\" ng-if=\"filtered.a.length + filtered.i.length\"><div ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{\'cm.brief.1\' | translate}}</div><div class=col-xs-3>{{\'cm.label.9\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-3 text-right\" ng-if=countList.info.isEditable>{{\'cm.label.25\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=scrollQuad callback=sortCallback() ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.a = (countList.schedules.a | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{count.label}}</div><div class=\"col-xs-3 text-ellipsis text-sm\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div><div class=col-xs-2>{{count.isCustom?\'cm.label.17\':\'s.brief.2\' | translate}}</div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right noPadL d-flex justify-content-flex-end\" ng-if=countList.info.isEditable><!-- <a href=\"\" role=\"link\" ng-click=\"editScheduleFx(count.id);\"><span class=\"fa fa-pencil\" aria-hidden=\"true\"></span></a> --><div class=\"btn-group marR5\" ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li><a ng-if=auth.upermissions.se.np ng-click=\"editScheduleFx(count.id, \'np\');\" role=button>{{\'cm.brief.1\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.s ng-click=\"editScheduleFx(count.id, \'s\');\" role=button>{{\'cm.label.3\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.c ng-click=\"editScheduleFx(count.id, \'c\');\" role=button>{{\'cm.label.1\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" ng-click=\"editScheduleFx(count.id, \'d\');\" role=button>{{\'cm.label.4\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.f && count.schType == 0\" ng-click=\"editScheduleFx(count.id, \'f\');\" role=button>{{\'s.body.4\' | translate}}</a></li></ul></div><switch class=\"switch-sm nonSelectable switchSc\" ng-model=count.isActive on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{count.id}} ng-change=statusFx(count.id)></switch></div></div><div ng-if=countList.schedules.i.length class=marT10 ng-class=\"{\'marT20\':filtered.a.length}\"><div class=panel-inner-tab ng-if=filtered.i.length>{{\'d.p_h.8\' | translate}}</div><div class=\"table table-scroll\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.i = (countList.schedules.i | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{count.label}}</div><div class=\"col-xs-3 text-ellipsis text-sm\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div><div class=col-xs-2>{{count.isCustom?\'cm.label.17\':\'s.brief.2\' | translate}}</div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right noPadL d-flex justify-content-flex-end\" ng-if=countList.info.isEditable><div class=\"btn-group marR5\" ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li><a ng-if=auth.upermissions.se.np ng-click=\"editScheduleFx(count.id, \'np\');\" role=button>{{\'cm.brief.1\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.s ng-click=\"editScheduleFx(count.id, \'s\');\" role=button>{{\'cm.label.3\' | translate}}</a></li><li><a ng-if=auth.upermissions.se.c ng-click=\"editScheduleFx(count.id, \'c\');\" role=button>{{\'cm.label.1\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" ng-click=\"editScheduleFx(count.id, \'d\');\" role=button>{{\'cm.label.4\' | translate}}</a></li><li><a ng-if=\"auth.upermissions.se.f && count.schType == 0\" ng-click=\"editScheduleFx(count.id, \'f\');\" role=button>{{\'s.body.4\' | translate}}</a></li></ul></div><switch class=\"switch-sm nonSelectable switchSc\" ng-model=count.isActive on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{count.id}} ng-change=statusFx(count.id)></switch></div></div></div></div></div></div></div><div class=col-xs-3 ng-if=\"countList.framelayout.length > 0\"><div class=\"bg-light pad10 flPreview\"><div class=\"panel noMarB\"><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist><li class=tab-success ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" ng-click=tabFx(1);scaleFrameLayout()>{{\'cm.menu.4\' | translate}}</a></li><li class=tab-primary ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" ng-click=tabFx(2);>{{\'fl.p_cfl.tab.2\' | translate}}</a></li></ul></header><div class=scrollQuad-y ng-attr-style=\"visibility:hidden;max-height:{{getAvailableHeight(397) + \'px\';}}\"><div class=pad10 ng-show=\"selectedT==\'1\'\"><div class=marB10 ng-repeat=\"fl in countList.framelayout\"><div class=marB5>{{fl.info.label}}</div><div class=fcont style=height:130px><div class=\"flGrid framesContainer\" ng-attr-style=\"width:{{fl.info.w}}px; height:{{fl.info.h}}px;\"><div ng-repeat=\"frame in fl.frames\" class=absolute ng-attr-style=left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}}; ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=unhilightFx() ng-click=highlightSelectFx(frame.id)>{{brTL = (frame.settings.br.tl?(frame.settings.br.tl)+\'px\':0);\"\"}} {{brTR = (frame.settings.br.tr?(frame.settings.br.tr)+\'px\':0);\"\"}} {{brBL = (frame.settings.br.bl?(frame.settings.br.bl)+\'px\':0);\"\"}} {{brBR = (frame.settings.br.br?(frame.settings.br.br)+\'px\':0);\"\"}}<div data-id={{frame.id}} data-index={{$index}} class=frame ng-attr-style=\"width:{{frame.width}}px;height:{{frame.height}}px;transform:rotate({{frame.rotation}}deg);;background-color:{{frame.rgba}};border-radius:{{brTL +\' \'+ brTR +\' \'+ brBR +\' \'+ brBL}}\" ng-click=selectFrame(frame.id)></div></div></div></div></div></div><div class=pad10 ng-show=\"selectedT==\'2\'\"><div class=tab-body><ul class=\"layer-container list-unstyled noMar\" callback=sortCallback()><li ng-repeat=\"fl in countList.framelayout\" class=\"layer sortable-item\" data-id={{frame.id}}><div class=layerLabel>{{fl.info.label}}</div><div class=\"text-ellipsis flList padTB4\" ng-repeat=\"frame in fl.frames\" data-id={{frame.id}} ng-attr-style=\"left:{{frame.x*0.1}}px;top:{{frame.y*0.1}}px;z-index:{{frame.z}};border-bottom:1px solid #dddddd;cursor:default\" ng-mouseover=\"highlightFx(frame.id.toString(), \'frame\')\" ng-mouseleave=unhilightFx() ng-click=highlightSelectFx(frame.id);><label class=\"pull-left noMarB\"><input type=radio name=layer ng-model=currentSelectFrame ng-value=frame.id style=\"cursor: default\"><label></label></label><!-- <label class=\"pull-left noMarB\"><input type=\"radio\" disabled name=\"layer\" ng-model=\"currentSelectFrame\" ng-value=\"frame.id\" ng-change=\"highlightSelectFx(frame.id)\" style=\"cursor: default;\"><label></label></label> --> <span class=layerBg><span ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.rgba}\"></span> </span><span class=layerFrameLabel>{{frame.label}}</span></div></li></ul></div></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><!-- Sortable --> <button type=button role=button class=btn ng-click=closeThisDialog(); ng-class=\"isSorted?\'btn-link\':\'btn-default\'\" data-dismiss=modal>{{isSorted?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/selectSingleDevice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.31\' | translate}}</h1></header><div class=row><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo class=col-xs-12 ng-if=isAdvSearch></advanced-search><div class=col-xs-12><div class=panel-body><div class=\"customHeader advSearch\"><div class=\"pull-right marRL10 filterIcon\" ng-if=!isGbdt uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad}\"><!-- <a href=\"\" id=\"filter\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\"></span></a> --> <a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link id=advSearch ng-click=\"advancedSearchOpen(\'d\', \'d\', deviceObj.dvwId, \'videowall\');\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link id=deviceView ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\" ng-if=!deviceTypes.types.length>{{deviceViewText}}</a></li><!-- <li><a href=\"\" role=\"link\" id=\"selectAll\" ng-click=\"checkboxFx(\'all\'); selectAllSDFx()\" ng-if=\"!deviceTypes.types.length\">{{\'cm.btn.44\' | translate}}</a></li> --></ul></div><div class=pull-right><label for=adSearch class=\"lableHidden absolute\">search</label><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" id=adSearch ng-model=searchDevice.text sanitize-input maxlength=250 ng-change=searchChangeFx(searchDevice.text) placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchDevice.text.length ng-click=\"searchDevice.text=\'\';searchChangeFx();\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=panel-inner-tab>{{devices.devices.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate}}</div><div class=\"overflow-auto pad10\" ng-attr-style=height:{{getAvailableHeight(420)}}px><div ng-if=\"!deviceListLoading && deviceTypes.types.length > 0\"><ul class=\"list-inline thumb-list dType-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredDTypes = (deviceTypes.types | customSearch:{key:searchDevice.text, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_selected_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && deviceTypes.types.length && !filteredDTypes.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDevice.text)}}&quot;</b>\'}\"></div></ul></div><!-- {{breadCrumbs.length}} --><div ng-if=\"!deviceListLoading && breadCrumbs.length\" class=breadcrumb><!-- <a href=\"\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\"></span></a> --> <a href=\"\" role=link ng-if=\"!auth.upermissions.dgrp.dgrp || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\"></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><!-- <a href=\"\" ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last\">{{breadcrumb.label}}</a> --> <a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && (!auth.upermissions.dgrp.dgrp || auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\') && auth.upermissions.dvw\">{{breadcrumb.label}}</a> <a href=\"\" role=link ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span>{{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><!-- Thumb view --><ul class=\"list-inline thumb-list\" ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'t\'\"><div class=marT10 ng-class=\"{\'marT35\':(folderList.length && filteredFolderList.length && (selectedT==1||selectedT==2)), \'noMarT\':$state.includes(\'hub.sContainer.sDevice\')}\" ng-if=\"(selectedT==1||selectedT==2) && !auth.upermissions.dgrp.dgrp && ($state.includes(\'hub.devices.d\') || $state.includes(\'hub.reports.c\') || $state.includes(\'hub.reports.d\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.dContainer.dtDevice\') || $state.includes(\'hub.dContainer.dgDevice\') || $state.includes(\'hub.flContainer.flaDevice\') || $state.includes(\'hub.sContainer.sDevice\') || $state.includes(\'hub.reports\') || $state.includes(\'hub.dContainer.dvwName\')) && devices.devices.length > 0\"><div class=\"bdr-btm-dashed fw6\" ng-class=\"{\'marT20\':folderList.length, \'d-flex align-items-center justify-spaceB noPadB noMarB\':$state.includes(\'hub.sContainer.sDevice\')}\">{{\'cm.label.4s\' | translate}}<div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':$state.includes(\'hub.sContainer.sDevice\')}\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable page-min-height\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> {{isAdv = (advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)); \"\"}} <span ng-if=\"!devicesLoading && rdc\" uib-tooltip=\"{{isAdv?\'d.tool.26\':filter==\'online\'?\'d.tool.24\':filter==\'offline\'?\'d.tool.25\':\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left class=device-count>{{visibleDevices}} / {{rdc}}</span><dir-pagination-controls boundary-links=paginationControls.boundaryLinks max-size=paginationControls.maxSize on-page-change=pageChangeHandler(newPageNumber) max-page=totalPages load-more=isPageApiLoad></dir-pagination-controls></div></div></div></div></div><!-- Folder List start --><div ng-if=\"filteredFolderList.length && (!advSearchInfo.isEmpty)\" class=\"bdr-btm-dashed marT10 fw6\">{{\'d.label.32\' | translate}}</div><li ng-if=\"folderList.length > 0 && (!advSearchInfo.isEmpty)\" ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'df\', filterType:filter})\" ng-dblclick=folderContentFx(folder.id); data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index context-menu=contextMenuOpt><div ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.l}}</div></div></li><!-- Folder List end --><!-- Top pagination start --><!-- {{auth.upreferences.sd}} --><div ng-hide=\"fCount.length==0\" ng-class=\"(folderList.length && filteredFolderList.length) ? \'marT35\' : \'marT10\'\" ng-if=\"filteredDeviceList.length && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\"><div ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" class=\"bdr-btm-dashed fw6\" ng-class=\"{\'marT20\':folderList.length}\">{{\'cm.label.4s\' | translate}}<div class=\"pull-right marT-15 nonSelectable\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> {{isAdv = (advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)); \"\"}} <span ng-if=\"!devicesLoading && rdc\" uib-tooltip=\"{{isAdv?\'d.tool.26\':filter==\'online\'?\'d.tool.24\':filter==\'offline\'?\'d.tool.25\':\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left class=device-count>{{visibleDevices}} / {{rdc}}</span><dir-pagination-controls boundary-links=paginationControls.boundaryLinks max-size=paginationControls.maxSize on-page-change=pageChangeHandler(newPageNumber) max-page=totalPages load-more=isPageApiLoad></dir-pagination-controls></div></div></div><div ng-if=\"!paginationLoading && !devicesLoading && devices.devices.length && auth.upermissions.dp\" class=\"pull-right marT-20 hide nonSelectable\"><div class=\"noPad noMar nonSelectable\"><!-- ng-if=\"!devicesLoading && !paginationLoading && (devices.info.count/devices.info.pl > 1) && devices.devices.length && devices.info.pl != 0\" --><div ng-if=\"!devicesLoading && !paginationLoading && (auth.upreferences.dpc > 0 && devices.info.count > auth.upreferences.dpc)\" class=\"deviceTopPaging marL10\" ng-class=\"{\'disabled\': paginationLoading}\"><uib-pagination class=pagination-sm ng-model=currentPage ng-change=pageChangedFx(currentPage) total-items=devices.info.count items-per-page=devices.info.pl max-size=5 num-pages=numPages boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></uib-pagination></div><div class=\"pull-right text-unbold text-muted\" ng-class=\"(devices.info.count/devices.info.pl > 1) ? \'marT15\':\'marT20\'\">{{deviceRange ? deviceRange : (curCount + \' - \' + devices.info.pl)}} of {{devices.info.count ? devices.info.count : devices.devices.length}}</div></div></div></div></div><!-- Top pagination end --><!-- Device List start --><!-- ng-repeat=\"device in filteredDeviceList = (devices.devices | customSearch:{key:searchText, module:\'d\'}) | filter: (((selectedT==\'1\' && selectedTab != \'hub.devices.dg\') || (selectedT==\'4\' && vwBreadCrumbs.length))?{status:filterType}:\'\')\" --><li dir-paginate=\"device in filteredDeviceList = ((devices.devices) | filter:{q:q, status:(selectedTab==\'hub.devices.d\'?filterType:\'\')} | itemsPerPage:paginationControls.pageSize) track by device.id\" ng-click=\"selectFx($event, device.id, device.type, null, device);\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-mac={{device.h}} data-id={{device.id}} data-status=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" data-type={{device.type}} data-sub-type={{device.type}} ng-class=\"{\'device\': selectedTab == \'hub.devices.d\', \'nonSelectable unapprovedFile\': selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" context-menu=contextMenuOpt><!-- Bellow condition applied li tag but its not usable also creating issue --><!--  ng-if=\"filter == \'all\' || filter == device.status || auth.upermissions.dp\" --> {{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': device.type === \'device\',\'thumb-group\': device.type == \'group\', \'mcPlayer\': device.t == 7}\"><img alt={{device.t}} ng-if=\"device.tv != 0 && (device.t == 1 || device.t == 3 || device.t == 2)\" ng-src=\"{{tim + bucket + (device.h | removeColon) + \'.jpg\' + \'&\' + device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png> <img alt=d_{{device.t}} ng-if=\"device.tv == 0 || (!device.tv && device.type === \'device\' && device.t != 1 && device.t != 3 && device.t != 2)\" ng-src=assets/images/default/device_{{device.t}}.png> <img alt=dg ng-if=\"device.type === \'group\'\" src=assets/images/default/device_group.png> <img alt=ds ng-if=\"device.type === \'search\'\" src=assets/images/default/device_search.png><!-- (auth.uType == 0 || auth.uType == 1) && device.space != null && device.space < 51200  removed space key--> <span class=\"thumb-icon space\" ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\"><span class=\"fa fa-exclamation-triangle text-danger\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 aria-hidden=true></span></span><!-- <span class=\"thumb-icon status\" role=\"status\" ng-if=\"device.status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=\"500\"><span class=\"{{device.status}}\"></span></span> --> <span class=\"thumb-icon status\" role=status ng-if=device.status title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"><span class=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span></span></span></div><!-- <div class=\"downloadedBar\" ng-if=\"showDownload\" uib-tooltip=\"{{\'d.ph.3\' | translate:{no:device.dp} }}\" tooltip-enable=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\">\r\n					<div style=\"width:{{device.dp}}%\" ng-if=\"showDownload && device.status == \'online\' && device.dp > 1 && device.dp <= 100\"></div>\r\n				</div> --><div class=thumb-label ng-if=device.l>{{device.l}}</div><div class=thumb-label ng-if=device.label>{{device.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(((filterCount == 0 && (filteredDeviceList.length > 0 || devices.devices.length > 0)) && !auth.upermissions.dp) || (devices.devices.length == 0 && auth.upermissions.dp && auth.upreferences.deviceView == \'t\'&&!advSearchInfo.isEmpty) || (devices.devices.length > 0 && filterCount == 0)) && selectedTab == \'hub.devices.d\' && !isGbdt && filter!=\'all\' && devices.info.tc > 0\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><div class=msg-warning lang={{auth.lang}} ng-if=\"$state.includes(\'hub.dContainer.dvwName\')&& ((auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\') ||  !auth.upermissions.dgrp.dgrp) && filteredDeviceList.length == 0 && filteredFolderList.length == 0 && (devices.devices.length > 0 || folderList.length > 0) && ((fCount.length > 0) || (devices.devices.length == 0 && dfilter==\'all\'))\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul><!-- List view --><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'l\'\"><!-- Folder List start --><div ng-class=\"{\'marB40\': (filteredFolderList.length > 0 && !advSearchInfo.isEmpty)}\"><div class=\"row th\" ng-if=\"filteredFolderList.length > 0 && !advSearchInfo.isEmpty\"><div class=col-xs-10>{{\'cl.p_f.3\' | translate | camelCase}}</div></div><div><div class=\"folderQuad nonSelectable\" ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'df\'})\" ng-if=\"folderList.length && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\' && (!advSearchInfo.isEmpty)\"><div class=nonSelectable><!--Folder--><div class=folder-heading data-id={{folder.id}} ng-class=\"{\'text-muted\':!folder.isActive}\"><div class=\"col-xs-12 text-bold text-ellipsis folder\" ng-click=folderContentFx(folder.id); data-id={{folder.id}}><a role=button><span class=\"fa fa-folder marR5\"></span>{{folder.l}} <span class=\"text-muted text-unbold text-sm\">&nbsp;</span></a></div></div></div></div></div></div><!-- Folder List end --><div class=\"other-controller nonSelectable\"><div class=\"d-flex align-items-center justify-end\"><img alt=Loading src=assets/images/loading-xs.gif ng-if=devicesLoading> {{isAdv = (advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)); \"\"}} <span ng-if=\"!devicesLoading && rdc\" uib-tooltip=\"{{isAdv?\'d.tool.26\':filter==\'online\'?\'d.tool.24\':filter==\'offline\'?\'d.tool.25\':\'cm.menu.5\' | translate}}\" tooltip-append-to-body=true tooltip-placement=left class=device-count>{{visibleDevices}} / {{rdc}}</span><dir-pagination-controls boundary-links=paginationControls.boundaryLinks max-size=paginationControls.maxSize on-page-change=pageChangeHandler(newPageNumber) max-page=totalPages load-more=isPageApiLoad></dir-pagination-controls></div></div><!-- Device List start --><div class=\"row th\" ng-if=\"!isSearchMsg && !isAdvSearchMsg && !isFilterMsg && devices.devices.length\"><!-- && filterCount != 0--><div ng-class=\"deviceLastPing?\'col-xs-4\':\'col-xs-8\'\">{{\'cm.label.71\' | translate | camelCase}}</div><div ng-class=\"{\'col-xs-3\':(deviceLastPing && showDownload), \'col-xs-4\':(!showDownload)}\">{{\'d.label.2\' | translate}}</div></div><ul><li class=\"row tabIndex d-flex align-items-center\" dir-paginate=\"device in filteredDeviceList = ((devices.devices) | filter:{q:q, status:(selectedTab==\'hub.devices.d\'?filterType:\'\')} | itemsPerPage:paginationControls.pageSize) track by device.id\" ng-click=\"selectFx($event, device.id, device.type, null, device);\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-id={{device.id}} data-status=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" data-type={{device.type}} data-sub-type={{device.type}} ng-if=\"filter == \'all\' || filter == device.status\" ng-class=\"{\'nonSelectable disabledRow\': (selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)) || (selectedTab == \'hub.flContainer.flaDevice\' && device.isSelected)}\" context-menu=contextMenuOpt>{{curMsg = ((device.isConflict == 1)?\'\'+(device.t == 9 ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=text-ellipsis ng-class=\"deviceLastPing?\'col-xs-4\':\'col-xs-8\'\"><div class=\"d-flex align-items-center justify-spaceB noBdr noPad\" style=background-color:transparent><div class=text-ellipsis><input type=checkbox ng-click=\"checkboxFx($event, device.id);\" role=checkbox ng-if=\"!$state.includes(\'hub.dContainer.dvwName\')\"><label></label><input type=radio role=radio value=device.id ng-checked=\"device.id == wallSelectedItems.devices.id\" ng-if=\"$state.includes(\'hub.dContainer.dvwName\')\"><label></label><span ng-if=\"(auth.uType == 0 || auth.uType == 1) && (device.dsk.t - device.dsk.u > 0) && (device.dsk.t - device.dsk.u < 51200)\" uib-tooltip=\"{{\'d.tool.10\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 class=\"fa fa-exclamation-triangle text-danger marR5\" aria-hidden=true></span> <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" title=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" role=status aria-label=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"></span> {{device.l}}</div><div ng-if=\"auth.upermissions.dtc && curState==\'hub.devices.d\' && device.tl.length\"><span class=\"pull-right nonSelectable padT4\"><span class=marL3 ng-repeat=\"c in device.tl | limitTo:-5\" ng-style=\"{\'background-color\':devices.t[c].tagColor}\" uib-tooltip={{devices.t[c].label}} tooltip-append-to-body=true><ng-tag-icon type={{auth.upermissions.dtcS.type}} color={{devices.t[c].tagColor}}></ng-tag-icon></span><a href ng-click=\"countListFx(device.id, \'tag\', device.l);\" ng-if=\"device.tl.length > 5\" class=colorCountBox ng-class=\"((device.tl.length + device.tln.length) - 5) < 99 ? \'w25\' : \'w35\'\" uib-tooltip=\"{{\'d.btn.29\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500 data-count=\"+{{(device.tl.length + device.tln.length) - 5}}\"></a></span></div></div></div><div class=text-ellipsis ng-class=\"{\'col-xs-3\':(deviceLastPing && showDownload), \'col-xs-4\':(!showDownload)}\">{{device.h}}</div></li></ul><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"(((filterCount == 0 && (filteredDeviceList.length > 0 || devices.devices.length > 0)) && !auth.upermissions.dp) || (devices.devices.length == 0 && auth.upermissions.dp && auth.upreferences.deviceView == \'l\' && !advSearchInfo.isEmpty)  || (devices.devices.length > 0 && filterCount == 0)) && selectedTab == \'hub.devices.d\' && !isGbdt && filter!=\'all\' && devices.info.tc > 0\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- Search warning message device folder for list and thumb both --><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"$state.includes(\'hub.dContainer.dvwName\') && ((auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\') ||  !auth.upermissions.dgrp.dgrp) && filteredDeviceList.length == 0 && filteredFolderList.length == 0 && (devices.devices.length > 0 || folderList.length > 0) && ((fCount.length > 0) || (devices.devices.length == 0 && dfilter==\'all\'))\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div> --></ul><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !deviceListLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !deviceListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchDevice.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !deviceListLoading\">{{\'as.msg.2\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!--\r\n			<div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && advSearchInfo.isEmpty && dfilter ==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n			<div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && fCount.length == 0 && dfilter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=\"addWallFx(); removeAdvSearchFilterFx();\">{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); removeAdvSearchFilterFx();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'db.msg.2\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/similar.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.10\' | translate}}</h1></header><div class=panel-body><div class=row><div class=\"col-xs-12 marB15 text-bold\">{{\'d.p_similar.1\' | translate}}:</div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.dGroup role=checkbox><label></label>{{\'d.p_similar.2\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.cGroup role=checkbox><label></label>{{\'d.p_similar.3\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.aDate role=checkbox><label></label>{{\'cm.brief.6\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.os role=checkbox><label></label>{{\'d.p_similar.5\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.res role=checkbox><label></label>{{\'d.p_similar.6\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.ip role=checkbox><label></label>{{\'d.brief.11.2\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.tags role=checkbox><label></label>{{\'d.brief.6\' | translate}}</label></div></div><div class=col-xs-6><div class=form-group><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.fl role=checkbox><label></label>{{\'fl.body.3\' | translate | camelCase}}</label></div></div><div class=col-xs-6><div class=\"form-group noMarB\"><label class=\"text-unbold noMarB\"><input type=checkbox ng-model=similarFilter.dRestriction role=checkbox><label></label>{{\'d.p_similar.7\' | translate}}</label></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=filterSimilarDevices(); ng-disabled=deviceProcessing><span class=fa ng-class=\"deviceProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span></footer></section>");
$templateCache.put("app/devices/popup/tagCU.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{ngDialogData.id?\'d.p_tag.1\':\'d.btn.3\' | translate}}</h1></header><div class=panel-body><div class=form-group><label>{{\'d.label.4\' | translate}}</label><input type=text class=form-control ng-model=tag.label autocomplete=off maxlength={{inputLimit}}></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=tagCUFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> <span ng-if=!ngDialogData.id>{{saveProcessing?\'cm.btn.14i\':\'cm.btn.14\' | translate}}</span> <span ng-if=ngDialogData.id>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'d.p_tag.m1\' | translate}}</div><div ng-if=\"errType==\'tag\'\" aria-live=polite role=status>{{\'d.p_tag.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/taskList.html","<section class=panel><header class=panel-heading><!-- {{allTask = (taskDetails.queued_task | filter:{\'iscompleted\':1}).length;\"\"}}\r\n    {{allTask}} --><h1>{{\'d.label.41\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'task\');\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><!-- {{taskDetails.queued_task | filter:task.iscompleted == 1}} --> <img alt=Loading src=assets/images/loading.gif ng-if=!taskDetails.queued_task.length><div class=\"table table-scroll\" ng-if=taskDetails.queued_task.length><div class=\"row th\"><div class=col-xs-5>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-3>{{\'cm.label.46\' | translate | camelCase}}</div><div class=col-xs-3>{{\'d.label.39\' | translate | camelCase}}</div><div class=col-xs-1>&nbsp;</div></div><div class=scrollQuad ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><!-- Complete Task --><div class=\"row noPad\" ng-if=\"filteredCompleteTaskList.length && completeTask.length\"><div class=\"noPad col-xs-12 text-ellipsis\"><div class=\"cCount cursorPointer\" ng-click=cDToggleFx($event);><span class=\"marR5 fa\" ng-class=\"cOpen ? \'fa-chevron-down\': \'fa-chevron-up\'\"></span>{{completeTask.length>1?\'d.label.54s\':\'d.label.54\' | translate}} <span class=\"text-sm text-muted\">[{{filteredCompleteTaskList.length}}]</span></div></div></div><div class=\"row completed-device hide\" ng-repeat=\"t1 in filteredCompleteTaskList = (completeTask | filter:{label:searchTextPopup, iscompleted:1})\"><div class=\"col-xs-5 text-ellipsis-wrap\">{{t1.label}}</div><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=\"t1.iscompleted == -1\"><a href=\"\" class=text-danger ng-click=taskFailInfoFx(t1) uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{\'d.label.40\' | translate}}</a></span><!-- <span ng-if=\"t1.iscompleted == 0\" class=\"text-warning\">{{\'em.body.8\' | translate}}</span> --> <span ng-if=\"t1.iscompleted == 1\" class=text-success>{{\'cs.body.12\' | translate}}</span></div><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=t1.completedon>{{t1.completedon}}</span> <span ng-if=!t1.completedon class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-1 text-right\"><span ng-if=\"t1.iscompleted == 1\" class=\"fa fa-check text-success\" aria-hidden=true></span><!-- <span ng-if=\"t1.iscompleted == -1\" class=\"fa fa-exclamation-circle text-danger\" aria-hidden=\"true\"></span> --></div></div><!-- Pending Task --><div class=\"row noPad\" ng-if=\"filteredPendingTaskList.length && pendingTask.length\"><div class=\"noPad col-xs-12 text-ellipsis\"><div class=\"pCount cursorPointer\" ng-click=pDToggleFx($event);><span class=\"marR5 fa\" ng-class=\"pOpen ? \'fa-chevron-down\': \'fa-chevron-up\'\"></span>{{pendingTask.length>1?\'d.label.55s\':\'d.label.55\' | translate}} <span class=\"text-sm text-muted\">[{{filteredPendingTaskList.length}}]</span></div></div></div><div class=\"row pending-device\" ng-repeat=\"t2 in filteredPendingTaskList = (pendingTask | filter:{label:searchTextPopup, iscompleted:0})\"><div class=\"col-xs-5 text-ellipsis-wrap\">{{t2.label}}</div><div class=\"col-xs-3 text-ellipsis-wrap\"><!-- <span ng-if=\"t2.iscompleted == 0\"><a href=\"\" class=\"text-danger\" ng-click=\"taskFailInfoFx(t2)\" uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{\'d.label.40\' | translate}}</a></span> --> <span ng-if=\"t2.iscompleted == 0\" class=text-warning>{{\'em.body.8\' | translate}}</span><!-- <span ng-if=\"t2.iscompleted == 1\" class=\"text-success\">{{\'cs.body.12\' | translate}}</span> --></div><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=t2.completedon>{{t2.completedon}}</span> <span ng-if=!t2.completedon class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-1 text-right\"><!-- <span ng-if=\"t2.iscompleted == 1\" class=\"fa fa-check text-success\" aria-hidden=\"true\"></span> --><!-- <span class=\"fa fa-exclamation-triangle text-warning\" aria-hidden=\"true\"></span> --></div></div><!-- Failed Task --><div class=\"row noPad\" ng-if=\"filteredFailedTaskList.length && failedTask.length\"><div class=\"noPad col-xs-12 text-ellipsis\"><div class=\"fCount cursorPointer\" ng-click=fDToggleFx($event);><span class=\"marR5 fa\" ng-class=\"fOpen ? \'fa-chevron-down\': \'fa-chevron-up\'\"></span>{{failedTask.length>1?\'d.label.56s\':\'d.label.56\' | translate}} <span class=\"text-sm text-muted\">[{{filteredFailedTaskList.length}}]</span></div></div></div><div class=\"row failed-device\" ng-repeat=\"t3 in filteredFailedTaskList = (failedTask | filter:{label:searchTextPopup, iscompleted:-1})\"><div class=\"col-xs-5 text-ellipsis-wrap\">{{t3.label}}</div><div class=\"col-xs-3 text-ellipsis-wrap\"><span><a href=\"\" class=text-danger ng-click=taskFailInfoFx(t3) uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{\'d.label.40\' | translate}}</a></span><!-- <span ng-if=\"t3.iscompleted == 0\" class=\"text-warning\">{{\'em.body.8\' | translate}}</span> --><!-- <span ng-if=\"t3.iscompleted == 1\" class=\"text-success\">{{\'cs.body.12\' | translate}}</span> --></div><div class=\"col-xs-3 text-ellipsis-wrap\"><span ng-if=t3.completedon>{{t3.completedon}}</span> <span ng-if=!t3.completedon class=\"text-sm text-muted\">N/A</span></div><div class=\"col-xs-1 text-right\"><!-- <span ng-if=\"t3.iscompleted == 1\" class=\"fa fa-check text-success\" aria-hidden=\"true\"></span> --> <span aria-hidden=true><a href=\"\" class=\"fa fa-exclamation-circle text-danger\" ng-click=taskFailInfoFx(t3) uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></a></span></div></div><!-- <div class=\"row\" ng-repeat=\"task in filteredTaskList = (taskDetails.queued_task | filter:{label:searchTextPopup})\">\r\n          <div class=\"col-xs-5 text-ellipsis-wrap\">{{task.label}}</div>\r\n          <div class=\"col-xs-3 text-ellipsis-wrap\">\r\n            <span ng-if=\"task.iscompleted == -1\"><a href=\"\" class=\"text-danger\" ng-click=\"taskFailInfoFx(task)\" uib-tooltip=\"{{\'cm.tool.3\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{\'d.label.40\' | translate}}</a></span>\r\n            <span ng-if=\"task.iscompleted == 0\" class=\"text-warning\">{{\'em.body.8\' | translate}}</span>\r\n            <span ng-if=\"task.iscompleted == 1\" class=\"text-success\">{{\'cs.body.12\' | translate}}</span>\r\n          </div>\r\n          <div class=\"col-xs-3 text-ellipsis-wrap\">\r\n            <span ng-if=\"task.completedon\">{{task.completedon}}</span>\r\n            <span ng-if=\"!task.completedon\" class=\"text-sm text-muted\">N/A</span>\r\n          </div>\r\n          <div class=\"col-xs-1 text-right\">\r\n            <span ng-if=\"task.iscompleted == 1\" class=\"fa fa-check text-success\" aria-hidden=\"true\"></span>\r\n            <span ng-if=\"task.iscompleted == -1\" class=\"fa fa-exclamation-circle text-danger\" aria-hidden=\"true\"></span>\r\n          </div>\r\n        </div> --><div class=msg-warning ng-if=\"filteredCompleteTaskList.length == 0 && filteredPendingTaskList.length == 0 && filteredFailedTaskList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/ticketDetails.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_tk.6\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{dataTkDetails.tid}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dataTkDetails.tid}}</span> ]</span></header><div class=panel-body><iframe ng-src=\"{{dataTkDetails.iFrameUrl | trustUrl}}\" class=\"relative scrollQuad\" style=border:none;width:100% ng-style=\"{\'height\':{{getAvailableHeight(200)}}+\'px\'}\"></iframe></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/tickets.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_tk.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-35\" uib-tooltip={{dataTkObj.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dataTkObj.label}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'ticket\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=\"pull-right bdrR padLR5 marR5 marT-5\"><button type=button role=button class=\"btn btn-sm btn-default\" ng-click=bugsOpen(dataTkObj.id);><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</button></div></header><div class=\"panel-body scrollQuad\" ng-style=\"{\'max-height\':{{getAvailableHeight(304)}}+\'px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !dataTkObj.ticket.length\">{{\'d.p_tk.m1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!popupLoading && dataTkObj.ticket.length\"><div class=scrollQuad ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=msg-warning ng-if=!filtered.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=\"row stickyHeader\" ng-if=filtered.length><div class=\"col-xs-2 noPadR\">{{\'d.p_tk.2\' | translate}}</div><div class=col-xs-5>{{\'sc.mail.3\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.brief.2\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.46\' | translate}}</div><!-- <div class=\"col-xs-2 text-right\">{{\'cm.brief.11\' | translate}}</div> --></div><div class=row ng-repeat=\"list in filtered = (dataTkObj.ticket | customSearch:{key:searchTextPopup, module:\'ticket\'})\"><!-- <div class=\"col-xs-2 noPadR\"><a href=\"\" role=\"link\" ng-click=\"ticketDetailsOpen(list.thid, list.tid, list.d);\">{{list.tid}}</a></div> --><div class=\"col-xs-2 noPadR\">{{list.tid}}</div><div class=\"col-xs-5 text-ellipsis\" uib-tooltip={{list.sub}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{list.sub}} <span ng-if=!list.sub class=\"text-muted text-sm\">N/A</span></div><!-- <div class=\"col-xs-2 text-ellipsis\">{{list.label}} <span ng-if=\"!list.label\" class=\"text-muted text-sm\">N/A</span></div> --><div class=\"col-xs-3 text-sm\">{{(list.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-right\"><span ng-if=\"list.status == \'a\'\"><span ng-if=list.exResDate class=text-sm>ETA: {{list.exResDate | toDate | date:\'MMM d, y\'}} </span><span ng-if=!list.exResDate>{{\'d.p_tk.3\' | translate}}</span> </span><span ng-if=\"list.status == \'o\'\"><span ng-if=list.exResDate class=text-sm>ETA: {{list.exResDate | toDate | date:\'MMM d, y\'}} </span><span ng-if=!list.exResDate>{{\'d.p_tk.4\' | translate}}</span> </span><span ng-if=\"list.status == \'r\'\" class=text-success>{{\'d.p_tk.5\' | translate}}</span></div><!-- <div class=\"col-xs-2 text-right\">\r\n          <span ng-if=\"list.d.length\">{{list.d.length}}</span>\r\n          <span ng-if=\"!list.d.length\" class=\"text-muted text-sm\">N/A</span>\r\n          <button type=\"button\" role=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"detailsOpen(\'ot\', \'device\', list.d, list.status, list.name, list.tid, \'\', list.isDeviceIdExists);\" ng-if=\"list.d.length > 0\">{{\'cm.btn.21\' | translate}}</button>\r\n        </div> --></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/userGroupDeviceList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-35\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'ugDevice\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=ugDeviceloading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': ugDeviceloading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off><!-- <span class=\"scrollSearchTooltip\" ng-if=\"searchTextPopup && searchTextPopup.length < 3\"><span translate=\"{{\'cm.msg.53\'}}\" translate-values=\"{count: {{3 - searchTextPopup.length}}}\"></span></span> --> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=ugDevicePopupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!ugDevicePopupLoading && !allScrollDataList.length\">{{\'d.msg.26\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!ugDevicePopupLoading && allScrollDataList.length\"><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.80\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{dl.id}} ng-repeat=\"dl in filteredList = (visibleData)\"><div class=\"col-xs-8 word-break\"><span class=deviceStatus ng-class=dl.status uib-tooltip=\"{{dl.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> {{dl.l}}</div><div class=\"col-xs-4 word-break\">{{dl.h}}</div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName == \'d\'\" role=heading aria-level=1>{{\'d.info.1\' | translate}}</h1></header><div class=video-body><iframe width=560 height=315 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/devices/popup/viewSettings.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.14\' | translate}}</h1><span class=\"text-muted marL10\">[ {{viewData.label}} ]</span></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(310)}}px><header class=\"panel-inner-tab marB15\" ng-if=auth.upermissions.webos><a href=\"\" role=link ng-class=\"{\'selected\':selectedTPop ==\'1\'}\" ng-click=tabPopFx(1);>{{\'d.brief.13\' | translate | camelCase}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedTPop ==\'2\'}\" ng-click=tabPopFx(2);>{{\'d.p_dc.17\' | translate}}</a></header><img alt=Loading src=assets/images/loading.gif ng-if=tabLoading><div ng-if=\"selectedTPop == 1 && !tabLoading\"><div class=form-group><label>{{\'d.p_dc.10\' | translate}}</label><div>{{viewData.info.transition == \'f\'?\'d.p_dc.10.1\':\'d.p_dc.10.2\' | translate | camelCase}}</div></div><div class=form-group><label>{{\'d.p_dc.11\' | translate}}</label><div>{{viewData.info.positionTop?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=form-group><label>{{\'d.p_dc.12\' | translate}}</label><div>{{viewData.info.blankScreen?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><div ng-if=\"selectedTPop == 2 && !tabLoading\"><div class=row><div class=col-xs-12><div class=\"panel-inner-tab marB5\">{{\'d.p_dc.wos.2\' | translate}}</div><div class=\"bg-light pad10\"><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.3\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.3.1\' | translate}}</label><div>{{webOS.gs.l.menu.language}}</div></div><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.3.2\' | translate}}</label><div>{{webOS.gs.l.key.language}}</div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.4\' | translate}}</div><div class=row><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.4.1\' | translate}}</label><div>{{webOS.gs.si.s?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.7\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.1\' | translate}} <span class=\"text-muted text-sm\">(15&nbsp;{{\'cm.label.28s\' | translate}})</span></label><div>{{webOS.gs.p.signal?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.2\' | translate}} <span class=\"text-muted text-sm\">(4&nbsp;{{\'cm.label.29s\' | translate}})</span></label><div>{{webOS.gs.p.ir?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.3\' | translate}}</label><div>{{webOS.gs.p.dpm.label}}</div></div></div><div class=row><div class=\"col-xs-4 form-group timepicker\"><label>{{\'d.p_dc.wos.7.4\' | translate}}</label><div>{{webOS.gs.p.wakeUp.label}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.5\' | translate}}</label><div>{{webOS.gs.p.pm.label}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.6\' | translate}} <span class=\"text-muted text-sm\">(0-250)</span></label><div>{{webOS.gs.p.delay}}</div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.7\' | translate}}</label><div>{{webOS.gs.p.status.label}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.8\' | translate}}</label><div>{{webOS.gs.p.wired?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.7.9\' | translate}}</label><div>{{webOS.gs.p.wireless?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.8\' | translate}}</div><div><label class=text-md>{{\'d.p_dc.wos.8.1\' | translate}}</label><div class=row><div class=\"col-xs-12 form-group\"><label>{{\'d.p_dc.wos.8.1.1\' | translate}}</label><div>{{webOS.gs.n.lan.wired?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><label class=text-md>{{\'d.p_dc.wos.8.2\' | translate}}</label><div class=row><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.8.2.1\' | translate}}</label><div>{{webOS.gs.n.cpc.ip}}<span class=\"text-muted text-sm\" ng-if=\"webOS.gs.n.cpc.ip == \'\'\">N/A</span></div></div><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.8.2.2\' | translate}}</label><div>{{webOS.gs.n.cpc.mask}}<span class=\"text-muted text-sm\" ng-if=\"webOS.gs.n.cpc.mask == \'\'\">N/A</span></div></div><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.8.2.3\' | translate}}</label><div>{{webOS.gs.n.cpc.gateway}}<span class=\"text-muted text-sm\" ng-if=\"webOS.gs.n.cpc.gateway == \'\'\">N/A</span></div></div><div class=\"col-xs-6 form-group\"><label>{{\'d.p_dc.wos.8.2.4\' | translate}}</label><div>{{webOS.gs.n.cpc.dns}}<span class=\"text-muted text-sm\" ng-if=\"webOS.gs.n.cpc.dns == \'\'\">N/A</span></div></div></div></div><div class=\"panel-inner-tab padB5 marB5\">{{\'d.p_dc.wos.9\' | translate}}</div><div class=row><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.9.1\' | translate}}</label><div>{{webOS.gs.as.b?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.tool.9\' | translate}}</label><div>{{webOS.gs.as.w?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=col-xs-12><div><label class=noMar>{{\'d.p_dc.wos.9.2\' | translate}}</label></div><div class=padLR20 ng-if=webOS.gs.as.tvt><div class=row><div class=\"col-xs-6 marT10\" ng-repeat=\"day in webOS.gs.as.days\"><div class=row><div class=col-xs-12 ng-if=day.val>{{\'s.p_s.label.4.2.\'+day.label | translate}}</div><div class=col-xs-6 ng-if=day.val><div class=\"form-group noMarB\"><label>{{\'d.p_dc.wos.9.3\' | translate}}</label><div><span ng-if=day.st>{{day.st | date:\'shortTime\'}}</span> <span ng-if=!day.st class=\"text-muted text-sm\">N/A</span></div></div></div><div class=col-xs-6 ng-if=day.val><div class=\"form-group noMarB\"><label>{{\'d.p_dc.wos.9.4\' | translate}}</label><div><span ng-if=day.et>{{day.et | date:\'shortTime\'}}</span> <span ng-if=!day.et class=\"text-muted text-sm\">N/A</span></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.10\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.1\' | translate}}</label><div>{{webOS.as.h?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.2\' | translate}}</label><div>{{webOS.as.usb?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.3\' | translate}}</label><div>{{webOS.as.osd?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><div class=row><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.4\' | translate}}</label><div>{{webOS.as.ir.label}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.5\' | translate}}</label><div>{{webOS.as.local.label}}</div></div><div class=\"col-xs-4 form-group\"><label>{{\'d.p_dc.wos.10.6\' | translate}}</label><div>{{webOS.as.wifi?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div><div class=row><div class=col-xs-6><label>{{\'d.p_dc.wos.10.7\' | translate}}</label><div>{{webOS.as.ss?\'cm.btn.4\':\'cm.btn.5\' | translate | camelCase}}</div></div></div></div></div><div class=\"col-xs-12 marT15\"><div class=\"panel-inner-tab marB10\">{{\'d.p_dc.wos.11\' | translate}}</div><div class=\"bg-light pad10\"><div class=row><div class=col-xs-12><label>{{\'d.p_dc.wos.11.1\' | translate}}</label><div class=msg-warning lang={{auth.lang}} ng-if=!webOS.ns.port.length>{{\'d.p_dc.wos.m2\' | translate}}</div><div class=\"table table-md marT10\" ng-if=webOS.ns.port.length><div class=\"row th\"><div class=col-xs-6>{{\'d.p_dc.wos.11.1.2\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.3\' | translate}}</div><div class=col-xs-3>{{\'d.p_dc.wos.11.1.4\' | translate}}</div></div><div class=row ng-repeat=\"port in webOS.ns.port\"><div class=col-xs-6>{{port.p}}</div><div class=col-xs-3><span ng-if=\"port.d == \'in\'\">{{\'d.p_dc.wos.11.1.3.1\' | translate}}</span> <span ng-if=\"port.d == \'out\'\">{{\'d.p_dc.wos.11.1.3.2\' | translate}}</span> <span ng-if=\"port.d == \'all\'\">{{\'d.p_dc.wos.11.1.3.3\' | translate}}</span></div><div class=col-xs-3>{{port.pr}}</div></div></div></div></div></div></div></div></div></div><footer class=panel-footer ng-if=!controlLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errType==\'pass\'\" aria-live=polite role=status>{{\'lock.m1\' | translate}}</div><div ng-if=\"errType==\'newPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m13\' | translate}}</div><div ng-if=\"errType==\'conPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m14\' | translate}}</div><div ng-if=\"errType==\'match\'\" aria-live=polite role=status>{{\'ms.msg.12\' | translate}}</div><div ng-if=\"errType==\'curPwd\'\" aria-live=polite role=status>{{\'ms.msg.13\' | translate}}</div><div ng-if=\"errType==\'same\'\" aria-live=polite role=status>{{\'ms.msg.14\' | translate}}</div><div ng-if=\"errType==\'noPwd\'\" aria-live=polite role=status>{{\'d.p_dc.wos.m15\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/popup/wmDeviceList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-30\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"refreshObj.b && auth.upermissions.edl\" class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"openGroupDevices(\'schedule\', deviceList);\" ng-disabled=loading><span class=\"fa fa-download\" aria-hidden=true></span> </a><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'wmDevices\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><div class=msg-warning lang={{auth.lang}} ng-if=\"!refreshObj.l && !refreshObj.b\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"deviceList.length && !refreshObj.l\"><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-8>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate }}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"dl in filteredList = (deviceList | customSearch:{key:searchTextPopup, module:\'d\'})\"><div class=\"col-xs-8 word-break\"><span class=deviceStatus ng-class=\"dl.status == \'online\'?\'online\':\'offline\'\" uib-tooltip=\"{{dl.status == 1?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> {{dl.label}}</div><div class=\"col-xs-4 word-break\">{{dl.mac}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/devices/preview/preview.html","<section style=min-width:280px class=panel role=dialog><header class=\"panel-heading toolbar\"><h1 role=heading aria-level=1>{{\'d.btn.11\' | translate}}</h1><span class=\"text-sm text-muted marL5\">[ {{curPreviewObj.label}} ]</span></header><div class=panel-body><div id=canvas class=\"flashContainer overflow-hidden\" ng-style=\"{\'max-height\':{{previewHeight}}+\'px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=previewLoading><div ng-if=\"!previewLoading && !feed.layout\" class=\"msg-warning pad10\" lang={{auth.lang}}><div ng-if=!em.messages lang={{auth.lang}}>{{\'d.msg.10\' | translate}}</div></div><iframe ng-if=\"!previewLoading && feed.layout\" ng-src=\"{{curPreviewObj.iFrameUrl | trustUrl}}\" class=\"bg-black relative\" data-size=\"{{feed.layout[0].w*canvas.zoom + 30}}\" ng-attr-style=\"height:{{feed.layout[0].h}}px;width:{{feed.layout[0].w}}px;background:{{hexToRgbA(feed.layout[0].bg, feed.layout[0].bga)}};transform: scale({{canvas.zoom}});transform-origin:top left;border:none\"></iframe></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=\"previewOpen(\'back\');\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/dashboard/popup/adpopup.html","<section class=panel role=dialog><!-- <header class=\"panel-heading\" style=\"padding:14px;\">\r\n    <h1 role=\"heading\" aria-level=\"1\">{{adCampaign[0].label}}</h1>\r\n  </header> --><div class=\"panel-body noPad\"><div ng-click=closeAdPopup();><span class=\"fa fa-remove ad-popup\"></span></div><img class=pad15 alt=Loading src=assets/images/loading.gif ng-show=isAdLoading> <a ng-if=\"adCampaign[0].data[0].href && adCampaign[0].data.length == 1\" ng-href={{adCampaign[0].data[0].href}} target=_blank><img alt=AdCampaign src={{adCampaign[0].data[0].img}} width=100% height=100% image-load=adImageLoaded() ng-hide=isAdLoading> </a><a ng-if=\"!adCampaign[0].data[0].href && adCampaign[0].data.length == 1\"><img alt=AdCampaign src={{adCampaign[0].data[0].img}} width=100% height=100% image-load=adImageLoaded() ng-hide=isAdLoading></a><div class=sliderQuad ng-if=\"adCampaign[0].data.length > 1\" style=\"overflow: hidden\"><div id=sliderAd><button type=button role=button class=control_prev ng-click=prevAdSlider()><span class=\"fa fa-chevron-left\" aria-hidden=true></span></button> <a ng-if=adCampaign[0].data[currentAdIndex].href ng-href={{adCampaign[0].data[currentAdIndex].href}} target=_blank><img alt=AdCampaign ng-src={{adCampaign[0].data[currentAdIndex].img}} width=100% height=100% image-load=adImageLoaded() ng-hide=isAdLoading> </a><a ng-if=!adCampaign[0].data[currentAdIndex].href><img alt=AdCampaign ng-src={{adCampaign[0].data[currentAdIndex].img}} width=100% height=100% image-load=adImageLoaded() ng-hide=isAdLoading> </a><button type=button role=button class=control_next ng-click=nextAdSlider()><span class=\"fa fa-chevron-right\" aria-hidden=true></span></button></div></div></div><div class=\"panel-footer padT7\"><div class=\"btnQuad pull-right marB8\"><label for=dashboardAD><input type=checkbox role=checkbox ng-model=dontShowAdAgain ng-change=dontShowAd(); aria-labelledby=dashboardAD id=dashboardAD><label class=pointer></label>{{\'cm.label.100\' | translate}}</label><button type=button role=button class=\"btn btn-default marL10\" ng-click=closeAdPopup();>{{\'cm.btn.10\' | translate}}</button></div><div class=clearfix></div></div></section>");
$templateCache.put("app/dashboard/popup/ccDevice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"db.body.17.1\" | translate}}</h1><div class=\"pull-right bdrR\" ng-if=auth.upermissions.edl><a href=\"\" role=link class=\"pad5 marLR5\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"downloadListFx(\'cclp\');\"><span class=\"fa fa-download\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchTextPopup, quadId);\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeDataDyn(searchTextPopup, quadId);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist><li class=tab-success ng-class=\"{\'active\':selectedT==\'1\'}\"><a href=\"\" ng-click=\"changeTabFx(1);searchTextPopup=\'\';\">{{\'db.ccl.3\' | translate}}</a></li><li class=tab-warning ng-class=\"{\'active\':selectedT==\'2\'}\"><a href=\"\" ng-click=\"changeTabFx(2);searchTextPopup=\'\';\">{{\'db.ccl.4\' | translate}}</a></li></ul></header><div class=\"panel noMarB pad10\"><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!detailLoading && !allScrollDataList[quadId].length\">{{ selectedT==\'1\' ? \'db.msg.12\' : \'db.msg.13\' | translate}}</div><div class=\"tab-body table\" ng-if=\"!detailLoading && allScrollDataList[quadId].length\"><div class=\"row th\"><div class=col-xs-8>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(385)}}px id=scroll-container-{{quadId}} dynamic-scroll-list st=stIndex[quadId] et=etIndex[quadId] list-data=scrollDataList[quadId] search-data=searchTextPopup have-more-data=haveMoreData[quadId] search-scroll=searchScroll[quadId] clone-data=allScrollDataList[quadId] have-more-search-data=haveMoreSearchData[quadId] quad-id=quadId dd-open=true><div class=\"row rowObj-{{quadId}}\" ng-class=\"{\'confirm-device\': selectedT == \'1\', \'not-confirm-device\': selectedT != \'1\'}\" id={{device.id}} ng-repeat=\"device in filteredList = (visibleData[quadId])\"><div class=\"col-xs-8 text-ellipsis\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.l}}</span></div><div class=\"col-xs-4 text-ellipsis\" uib-tooltip={{device.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.h}}</div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData[quadId] || !haveMoreSearchData[quadId]) && scrollDataList[quadId].length >= 300 && scrollDataList[quadId].length == etIndex[quadId]\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button ng-if=\"auth.uType==0 && (filteredCDeviceList.length + filteredNCDeviceList.length)\" class=\"btn btn-primary\" ng-click=\"dRestrictFx(\'cc\', filteredNCDeviceList);\" ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-spin fa-repeat\':\'\'\" aria-hidden=true></span>{{\'db.btn.4\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.10\" | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/dashboard/popup/detailList.html","<section class=panel role=dialog><header class=\"pannel-height-header panel-heading\"><div id=source ng-class=\"textValue.length > 56 ?\'text-ellipsis-popup-two\':\'text-ellipsis-popup\'\"><span ng-if=\"detailsObj.caller == \'ssdt\' || detailsObj.caller == \'ssodt\' || detailsObj.caller == \'ssdpt\'\">{{detailsObj.status | capitalize}} </span>{{\'cm.body.3\' | translate}} <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ds\' && (detailsObj.label) == (\'d.tool.1\' | translate)\">[ {{\'d.tool.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ds\' && (detailsObj.label) == (\'d.tool.2\' | translate)\">[ {{\'d.tool.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ds\' && (detailsObj.label) == (\'d.tool.21\' | translate)\">[ {{\'d.tool.21\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ds\' && (detailsObj.label | lowercase) == \'total\'\">[ {{\'r.body.9\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ot\'\">[ {{detailsObj.tId}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'mp\'\">[ {{\'d.label.1.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'webos\'\">[ {{\'d.label.1.5\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'tizen\'\">[ {{\'d.label.1.6\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'mc\'\">[ {{\'d.label.1.4\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'gf\'\">[ {{\'d.label.1.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'v\'\">[ {{\'d.label.1.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'desktop\'\">[ {{\'d.label.1.7\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'epd\'\">[ {{\'d.label.1.8\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'n\'\">[ {{\'db.body.14.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'c\'\">[ {{\'db.body.14.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.label == \'d\'\">[ {{\'db.body.14.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ccs\'\">[ {{detailsObj.label | capitalize}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dps\' || detailsObj.caller == \'dpts\'\">[ <span class=\"detailsObj.label != \'\'\">{{detailsObj.label | capitalize}} : </span>{{detailsObj.name}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'ssdt\' || detailsObj.caller == \'ssodt\' || detailsObj.caller == \'ssdpt\'\">[ {{detailsObj.label}} <span class=\"detailsObj.name != \'\'\">: {{detailsObj.name}}</span> ]</span><!-- Pie --> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'cc\'\">[ {{\'db.body.21.8\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'poncc\'\">[ {{\'db.body.21.8.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'pofcc\'\">[ {{\'db.body.21.8.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'oncc\'\">[ {{\'db.body.21.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'ofcc\'\">[ {{\'db.body.21.3\' | translate}} ]</span><!-- Pie --> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'ncc\'\">[ {{\'db.body.21.7.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'ponncc\'\">[ {{\'db.body.21.7.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'pofncc\'\">[ {{\'db.body.21.7.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'onncc\'\">[ {{\'db.body.21.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'ofncc\'\">[ {{\'db.body.21.4\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'nsd\'\">[ {{\'db.body.21.6\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'onnsd\'\">[ {{\'db.body.21.6.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'ofnsd\'\">[ {{\'db.body.21.6.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailsObj.caller == \'dccl\' && detailsObj.label == \'offline\'\">[ {{\'db.body.21.5\' | translate}} ]</span></div><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"detailsObj.deviceDetails.length && detailsObj.caller != \'ot\' && detailsObj.caller != \'dccl\' && auth.upermissions.edl\" ng-disabled=loadingDetail class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"openGroupDevices(detailsObj.caller, detailsObj.deviceDetails, \'\', detailsObj, \'\', detailsObj.name, \'dashboard\');\"><!--downloadDbListFx(detailsObj.caller, detailsObj.name, detailsObj.deviceDetails, detailsObj.label);--> <span class=\"fa fa-download\" aria-hidden=true></span> </a><!-- No change for content confirmation quad : start --> <a href=\"\" role=link ng-if=\"detailsObj.deviceDetails.length && detailsObj.caller != \'ot\' && detailsObj.caller == \'dccl\' && auth.upermissions.edl\" ng-disabled=loadingDetail class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"downloadDbListFx(detailsObj.caller, detailsObj.name, detailsObj.deviceDetails, detailsObj.label);\"><span class=\"fa fa-download\"></span> </a><!-- No change for content confirmation quad  : end --> <a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(detailsObj.caller, stringIds, detailsObj.fType, detailsObj.isDeviceId); searchTextPopup=\'\'\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=\"loadingDetail ||  (detailsObj.caller != \'ot\' && !detailsObj.deviceDetails.length)\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingDetail}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-show=!detailLoading><div class=\"msg-warning marB10\" lang={{auth.lang}} ng-if=\"detailsObj.caller == \'ot\' && detailsObj.dCount !== detailsObj.deviceDetails.length\">{{\'d.p_tk.m2\' | translate}}</div><div ng-if=detailsObj.deviceDetails.length><div class=table><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=\"row stickyHeader\"><div class=col-xs-8>{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div></div><div class=row ng-repeat=\"device in filteredDeviceList = (detailsObj.deviceDetails | customSearch:{key:searchTextPopup, module:\'cdtgSort\'})\"><div class=\"col-xs-8 text-ellipsis\"><span class=\"deviceStatus {{device.s}}\" uib-tooltip=\"{{device.s | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.l}}</span></div><div class=\"col-xs-4 text-ellipsis\" uib-tooltip={{device.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.h}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredDeviceList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"detailsObj.caller == \'ot\' && !detailsObj.dCount && !detailsObj.deviceDetails.length\">{{\'db.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"detailsObj.caller != \'ot\' && !detailsObj.deviceDetails.length\">{{\'db.msg.1\' | translate}}</div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button ng-if=\"detailsObj.caller==\'dccl\' && auth.uType==0 && detailsObj.deviceDetails.length\" class=\"btn btn-primary\" ng-click=\"dRestrictFx(\'ccd\', detailsObj);\" ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-spin fa-repeat\':\'\'\" aria-hidden=true></span>{{\'db.btn.4\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/dashboard/popup/detailListClick.html","<section class=panel role=dialog><header class=\"pannel-height-header panel-heading\"><div id=source ng-class=\"textValue.length > 56 ?\'text-ellipsis-popup-two\':\'text-ellipsis-popup\'\"><span ng-if=\"detailListObj[quadId].caller == \'ssdt\' || detailListObj[quadId].caller == \'ssdpt\' || detailListObj[quadId].caller == \'ssodt\'\"><span ng-if=\"detailListObj[quadId].status == \'onc\'\">{{\'d.tool.1\' | translate}}</span> <span ng-if=\"detailListObj[quadId].status == \'offdc\'\">{{\'d.tool.2\' | translate}}</span> <span ng-if=\"detailListObj[quadId].status == \'ncdc\'\">{{\'d.tool.21\' | translate}}</span> </span>{{\'cm.body.3\' | translate}} <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dps\' || detailListObj[quadId].caller == \'dpts\'\">[ <span class=\"detailListObj[quadId].label != \'\'\">{{detailListObj[quadId].name | capitalize}} : </span>{{detailListObj[quadId].value}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ssdt\' || detailListObj[quadId].caller == \'ssdpt\'\">[ {{detailListObj[quadId].name}} <span class=\"detailListObj[quadId].value != \'\'\">: {{detailListObj[quadId].value}}</span> ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ds\' && (detailListObj[quadId].value == \'ondc\')\">[ {{\'d.tool.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ds\' && (detailListObj[quadId].value == \'offdc\')\">[ {{\'d.tool.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ds\' && (detailListObj[quadId].value == \'ncdc\')\">[ {{\'d.tool.21\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ds\' && (detailListObj[quadId].value | lowercase) == \'total\'\">[ {{\'r.body.9\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ot\'\">[ {{detailListObj[quadId].tId}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'mp\'\">[ {{\'d.label.1.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'webos\'\">[ {{\'d.label.1.5\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'tizen\'\">[ {{\'d.label.1.6\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'mc\'\">[ {{\'d.label.1.4\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'gf\'\">[ {{\'d.label.1.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'v\'\">[ {{\'d.label.1.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'desktop\'\">[ {{\'d.label.1.7\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'epd\'\">[ {{\'d.label.1.8\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'n\'\">[ {{\'db.body.14.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'c\'\">[ {{\'db.body.14.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].name == \'d\'\">[ {{\'db.body.14.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'ccs\'\">[ <span ng-if=\"detailListObj[quadId].name == \'no\'\">{{\'db.body.13.3\' | translate | capitalize}}</span><span ng-if=\"detailListObj[quadId].name == \'rem\'\">{{\'db.body.13.2\' | translate | capitalize}}</span><span ng-if=\"detailListObj[quadId].name == \'down\'\">{{\'db.body.13.1\' | translate | capitalize}}</span><span ng-if=\"detailListObj[quadId].name == \'total\'\">{{\'r.body.9\' | translate}}</span> ]</span><!-- Pie --> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'cc\'\">[ {{\'db.body.21.8\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'poncc\'\">[ {{\'db.body.21.8.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'pofcc\'\">[ {{\'db.body.21.8.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'oncc\'\">[ {{\'db.body.21.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'ofcc\'\">[ {{\'db.body.21.3\' | translate}} ]</span><!-- Pie --> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'ncc\'\">[ {{\'db.body.21.7.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'ponncc\'\">[ {{\'db.body.21.7.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'pofncc\'\">[ {{\'db.body.21.7.3\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'onncc\'\">[ {{\'db.body.21.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'ofncc\'\">[ {{\'db.body.21.4\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'nsd\'\">[ {{\'db.body.21.6\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'onnsd\'\">[ {{\'db.body.21.6.1\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'ofnsd\'\">[ {{\'db.body.21.6.2\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'dccl\' && detailListObj[quadId].name == \'offline\'\">[ {{\'db.body.21.5\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'wgws\' && detailListObj[quadId].name == \'act\'\">[ {{\'db.wgw.6\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'wgws\' && detailListObj[quadId].name == \'exp\'\">[ {{\'db.wgw.7\' | translate}} ]</span> <span class=\"text-sm text-muted\" ng-if=\"detailListObj[quadId].caller == \'wgws\' && detailListObj[quadId].name == \'nw\'\">[ {{\'db.wgw.8\' | translate}} ]</span></div><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"allScrollDataList[quadId].length && detailListObj[quadId].caller != \'ot\' && detailListObj[quadId].caller != \'wgws\' && auth.upermissions.edl\" ng-disabled=loadingDetail class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"openGroupDevices(detailListObj[quadId].caller, allScrollDataList[quadId], \'\', detailListObj[quadId], \'\', detailListObj[quadId].name, \'\',\'dashboardPopup\');\"><span class=\"fa fa-download\" aria-hidden=true></span> </a><a href=\"\" role=link ng-if=\"allScrollDataList[quadId].length && detailListObj[quadId].caller == \'wgws\' && auth.upermissions.edl\" ng-disabled=loadingDetail class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"exportWgwDeviceSheet(detailListObj[quadId].caller, detailListObj[quadId].name);\"><span class=\"fa fa-download\" aria-hidden=true></span> </a><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListClickFx(detailListObj[quadId]); searchTextPopup=\'\'\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=\"loadingDetail ||  (detailListObj[quadId].caller != \'ot\' && !allScrollDataList[quadId].length)\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loadingDetail}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchTextPopup, quadId);\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeDataDyn(searchTextPopup, quadId);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"detailListObj[quadId].caller != \'ot\' && !allScrollDataList[quadId].length && !detailLoading\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!detailLoading && allScrollDataList[quadId].length\"><div class=\"row th\" ng-if=\"filteredDeviceList.length > 0\"><div class=col-xs-8 ng-if=\"detailListObj[quadId].caller != \'wgws\'\">{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-4 ng-if=\"detailListObj[quadId].caller != \'wgws\'\">{{\'d.label.2\' | translate}}</div><!-- todo for the White Glove Warrnaty --><div class=col-xs-3 ng-if=\"detailListObj[quadId].caller == \'wgws\'\">{{\'cm.label.71\' | translate | camelCase}}</div><div class=col-xs-3 ng-if=\"detailListObj[quadId].caller == \'wgws\'\">{{\'d.label.2\' | translate}}</div><div class=col-xs-3 ng-if=\"detailListObj[quadId].caller == \'wgws\'\">{{\'db.wgw.9\' | translate}}</div><div class=\"col-xs-3 text-right\" ng-if=\"detailListObj[quadId].caller == \'wgws\'\">{{\'db.wgw.4\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container-{{quadId}} dynamic-scroll-list st=stIndex[quadId] et=etIndex[quadId] list-data=scrollDataList[quadId] search-data=searchTextPopup have-more-data=haveMoreData[quadId] search-scroll=searchScroll[quadId] clone-data=allScrollDataList[quadId] have-more-search-data=haveMoreSearchData[quadId] quad-id=quadId dd-open=true><div class=\"row rowObj-{{quadId}}\" id={{device.id}} ng-repeat=\"device in filteredDeviceList = (visibleData[quadId])\"><div class=\"col-xs-8 text-ellipsis\" ng-if=\"detailListObj[quadId].caller != \'wgws\'\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.l}}</span></div><div class=\"col-xs-4 text-ellipsis\" ng-if=\"detailListObj[quadId].caller != \'wgws\'\" uib-tooltip={{device.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.h}}</div><!-- todo for the White Glove Warrnaty --><div class=\"col-xs-3 text-ellipsis\" ng-if=\"detailListObj[quadId].caller == \'wgws\'\"><span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{device.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.l}}</span></div><div class=\"col-xs-3 text-ellipsis\" ng-if=\"detailListObj[quadId].caller == \'wgws\'\" uib-tooltip={{device.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{device.h}}</div><div class=col-xs-3 ng-if=\"detailListObj[quadId].caller == \'wgws\'\" tooltip-enable=device.reg uib-tooltip={{device.reg}} tooltip-append-to-body=true tooltip-popup-delay=500><div ng-if=device.reg><div class=text-ellipsis>{{device.reg}}</div></div><div ng-if=!device.reg><span class=\"text-muted text-sm\">N/A</span></div></div><div class=\"col-xs-3 text-right\" ng-if=\"detailListObj[quadId].caller == \'wgws\'\" tooltip-enable=device.exp uib-tooltip={{device.exp}} tooltip-append-to-body=true tooltip-popup-delay=500><div ng-if=device.exp><div class=text-ellipsis>{{device.exp}}</div></div><div ng-if=!device.exp><span class=\"text-muted text-sm\">N/A</span></div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData[quadId] || !haveMoreSearchData[quadId]) && scrollDataList[quadId].length >= 300 && scrollDataList[quadId].length == etIndex[quadId]\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredDeviceList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/dashboard/popup/detailedLog.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'db.p_dl.1\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading><div ng-if=!detailLoading class=scrollQuad ng-style=\"{\'max-height\':{{getAvailableHeight(371)}}+\'px\'}\"><div class=marB10><div>{{detailedLog.obj.data}}</div><div class=\"text-muted text-sm\">{{detailedLog.obj.user}}</div><div class=\"text-muted text-sm\">{{detailedLog.obj.logDate}} - {{detailedLog.obj.logTime | uppercase}}</div></div><div class=table><div ng-repeat=\"data in detailedLog.list\" ng-if=\"data.list.length > 1\" ng-class=\"{\'marT25\':!$first}\"><div class=\"row th\">{{data.title | capitalize}}</div><div class=row ng-repeat=\"list in data.list track by $index\"><div class=col-xs-12>{{list}}</div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'db.msg.2\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/dashboard/popup/registerOnMap.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'db.btn.1\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(310)}}px><div><div class=\"form-group lsn-select\"><label ng-cloak>{{\'cm.label.31\' | translate}}</label><div class=dropdown uib-dropdown auto-close=outsideClick is-open=ds.isOpen on-toggle=toggleCallback(open)><a href=\"\" role=link id=selectDevice class=dropdown-toggle uib-dropdown-toggle ng-click=\"deviceSearchFocus();search.dList=\'\';searchChangeDataDyn(search.dList, \'dom\');\" focus-me=true><span class=pull-left ng-if=onMap.info.device.l>{{onMap.info.device.l}}</span><span class=pull-left ng-if=!onMap.info.device.l>{{\'cm.label.31\' | translate}}</span><span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><img class=padL10 alt=Loading src=assets/images/loading-xs.gif ng-if=detailLoading> <span ng-if=!detailLoading><li class=\"dropdown-header padLR10\" ng-show=\"allScrollDataList.dom.length > 5\"><label for=sdS class=\"lableHidden absolute\">sdS</label><div class=\"searchTbx input-xs\"><input type=text id=sdS class=form-control ng-model=search.dList sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(search.dList, \'dom\');\" autocomplete=off placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=sdR class=text-danger ng-show=search.dList.length ng-click=\"search.dList=\'\';searchChangeDataDyn(search.dList, \'dom\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator ng-show=\"allScrollDataList.dom.length > 5\"></li><!-- <div class=\"d-flex padLR10 padTB5 text-sm\">\r\n                <div class=\"marR10\"><span class=\"legend-registered\"></span>Registered</div>\r\n                <div><span class=\"legend-unregistered\"></span>Unregistered</div>\r\n              </div>\r\n              <li class=\"divider\" role=\"separator\"></li> --><div class=\"list-scroll ng-cloak\" id=scroll-container-dom dynamic-scroll-list st=stIndex.dom et=etIndex.dom list-data=scrollDataList.dom search-data=searchText.dom have-more-data=haveMoreData.dom search-scroll=searchScroll.dom clone-data=allScrollDataList.dom have-more-search-data=haveMoreSearchData.dom quad-id=\"\'dom\'\" dd-open=ds.isOpen>{{rCount = (filteredDeviceList | filter:{reg:1});\"\"}} {{urCount = (filteredDeviceList | filter:{reg:0});\"\"}}<div class=rCount ng-if=\"filteredDeviceList.length && rCount.length && stIndex.dom == 0\">{{rCount.length>1?\'db.p_map.9s\':\'db.p_map.9\' | translate}}</div><li class=rowObj-dom id={{dList.id}} ng-repeat=\"dList in filteredDeviceList = (visibleData.dom)\" ng-if=dList.reg tabindex={{$index}} ng-class=\"{\'selected disabled\':dList.id == onMap.info.device.id}\"><a href=\"\" role=link id=rdL-{{$index}} ng-click=deviceSelectionFx(dList); ng-if=\"dList.id != onMap.info.device.id && dList.reg\"><div class=\"marR5 deviceStatus {{dList.status}}\" uib-tooltip=\"{{dList.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{dList.l}}</a> <a href=\"\" role=link id=rdLS-{{$index}} ng-if=\"dList.id == onMap.info.device.id && dList.reg\"><div class=\"marR5 deviceStatus {{dList.status}}\" uib-tooltip=\"{{dList.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{dList.l}}</a></li><div class=urCount ng-if=\"filteredDeviceList.length && urCount.length\">{{urCount.length>1?\'db.p_map.10s\':\'db.p_map.10\' | translate}}</div><li class=rowObj-dom id={{dList.id}} ng-repeat=\"dList in filteredDeviceList = (visibleData.dom)\" ng-if=!dList.reg tabindex={{$index}} ng-class=\"{\'selected disabled\':dList.id == onMap.info.device.id}\"><a href=\"\" role=link id=udL-{{$index}} ng-click=deviceSelectionFx(dList); ng-if=\"dList.id != onMap.info.device.id && !dList.reg\"><div class=\"marR5 deviceStatus {{dList.status}}\" uib-tooltip=\"{{dList.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{dList.l}}</a> <a href=\"\" role=link id=udLS-{{$index}} ng-if=\"dList.id == onMap.info.device.id && !dList.reg\"><div class=\"marR5 deviceStatus {{dList.status}}\" uib-tooltip=\"{{dList.status==\'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{dList.l}}</a></li><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.dom || !haveMoreSearchData.dom) && scrollDataList.dom.length >= 300 && scrollDataList.dom.length == etIndex.dom\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.dom.length > 0 && filteredDeviceList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.dList)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataList.dom.length == 0\">{{\'db.msg.1\' | translate}}</div></div></span></ul></div></div><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=onMapOpt ng-model=onMap.info.type value=c ng-change=addressType();><label></label>{{\'db.p_map.1\' | translate}}</label><label class=noMarB><input type=radio role=radio name=onMapOpt ng-model=onMap.info.type value=a ng-change=addressType();><label></label>{{\'db.p_map.2\' | translate}}</label></div><div ng-if=\"onMap.info.type == \'c\'\"><div class=form-group><div class=row><div class=col-xs-6><label for=lat class=\"lableHidden absolute\">lat</label><div class=input-group><span class=input-group-addon>{{\'db.p_map.3\' | translate}}</span> <input type=number id=lat class=form-control ng-model=onMap.info.device.lat maxlength={{inputLimit}}></div></div><div class=col-xs-6><label for=lng class=\"lableHidden absolute\">lng</label><div class=input-group><span class=input-group-addon>{{\'db.p_map.4\' | translate}}</span> <input type=number id=lng class=form-control ng-model=onMap.info.device.lng maxlength={{inputLimit}}></div></div></div></div><label>{{\'db.p_map.5\' | translate}}</label><div class=\"mapContainer marLR-5\"><ng-map center={{mapCenter}} zoom=5 on-click=vm.addMarker(); map-initialized=mapLoaded(map) ng-if=\"auth.uservices.m == \'g\'\"><marker ng-repeat=\"pos in vm.positions\" position=\"{{pos.lat}}, {{pos.lng}}\"></marker></ng-map><div id=azMapPopup style=width:100%;height:100% ng-if=\"auth.uservices.m == \'b\'\"></div></div></div><div ng-if=\"onMap.info.type == \'a\'\"><div class=form-group><label for=address>{{\'db.p_map.2\' | translate}}</label><input type=text id=address class=form-control ng-map-autocomplete ng-model=onMap.info.device.address details=details ng-disabled=!onMap.info.device></div><div class=row><div class=col-xs-6><div class=form-group><label for=city>{{\'cm.label.45\' | translate}}</label><input type=text id=city class=form-control ng-model=onMap.info.device.city ng-disabled=!onMap.info.device maxlength={{inputLimit}}></div></div><div class=col-xs-6><div class=form-group><label for=province>{{\'db.p_map.6\' | translate}}</label><input type=text id=province class=form-control ng-model=onMap.info.device.province ng-disabled=!onMap.info.device maxlength={{inputLimit}}></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=zipCode>{{\'db.p_map.7\' | translate}}</label><input type=text id=zipCode class=form-control ng-model=onMap.info.device.zipCode ng-disabled=!onMap.info.device maxlength=20></div></div><div class=col-xs-6><div class=form-group><label for=country>{{\'db.p_map.8\' | translate}}</label><input type=text id=country class=form-control ng-model=onMap.info.device.country ng-disabled=!onMap.info.device maxlength={{inputLimit}}></div></div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=registerOnMapFx(); ng-disabled=registerProcessing><span ng-class=\"registerProcessing?\'fa fa-repeat fa-spin\':\'glyphicon glyphicon-check\'\" aria-hidden=true></span>{{\'db.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'device\'\" aria-live=polite role=status>{{\'db.msg.2\' | translate}}</div><div ng-if=\"errType==\'address\'\" aria-live=polite role=status>{{\'db.msg.3\' | translate}}</div><div ng-if=\"errType==\'city\'\" aria-live=polite role=status>{{\'db.msg.4\' | translate}}</div><div ng-if=\"errType==\'province\'\" aria-live=polite role=status>{{\'db.msg.5\' | translate}}</div><div ng-if=\"errType==\'country\'\" aria-live=polite role=status>{{\'db.msg.6\' | translate}}</div><div ng-if=\"errType==\'latLng\'\" aria-live=polite role=status>{{\'db.msg.7\' | translate}}</div><div ng-if=\"errType==\'zipCode\'\" aria-live=polite role=status>{{\'b.msg.4\' | translate}}</div><div ng-if=\"errType==\'addrNotVlid\'\" aria-live=polite role=status>{{\'db.msg.8\' | translate}}</div></div><div class=clearfix></div></div></section><!-- <div class=\"rCount\" ng-if=\"filteredRDeviceList.length\">{{rCount.length>1?\'db.p_map.9s\':\'db.p_map.9\' | translate}}</div>\r\n<li ng-repeat=\"dList in filteredRDeviceList = (rCount | customSearch:{key:search.dList, module:\'dSelOp\'}) | orderBy:\'l\'\" tabindex=\"{{$index}}\" ng-class=\"{\'selected disabled\':dList.id == onMap.info.device.id}\">\r\n  <a href=\"\" role=\"link\" id=\"rdL-{{$index}}\" ng-click=\"deviceSelectionFx(dList);\" ng-if=\"dList.id != onMap.info.device.id\"><div class=\"marR5 deviceStatus {{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"uib-tooltip=\"{{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{dList.l}}</a>\r\n  <a href=\"\" role=\"link\" id=\"rdLS-{{$index}}\" ng-if=\"dList.id == onMap.info.device.id\"><div class=\"marR5 deviceStatus {{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"uib-tooltip=\"{{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{dList.l}}</a>\r\n</li>\r\n<div class=\"urCount\" ng-if=\"filteredURDeviceList.length && rCount.length\">{{urCount.length>1?\'db.p_map.10s\':\'db.p_map.10\' | translate}}</div>\r\n<li ng-repeat=\"dList in filteredURDeviceList = (urCount | customSearch:{key:search.dList, module:\'dSelOp\'}) | orderBy:\'l\'\" tabindex=\"{{$index}}\" ng-class=\"{\'selected disabled\':dList.id == onMap.info.device.id}\">\r\n  <a href=\"\" role=\"link\" id=\"udL-{{$index}}\" ng-click=\"deviceSelectionFx(dList);\" ng-if=\"dList.id != onMap.info.device.id\"><div class=\"marR5 deviceStatus {{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"uib-tooltip=\"{{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{dList.l}}</a>\r\n  <a href=\"\" role=\"link\" id=\"udLS-{{$index}}\" ng-if=\"dList.id == onMap.info.device.id\"><div class=\"marR5 deviceStatus {{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\"uib-tooltip=\"{{dList.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>{{dList.l}}</a>\r\n</li>  -->");
$templateCache.put("app/dashboard/popup/ticketDetails.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_tk.6\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{dataTkDetails.tid}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dataTkDetails.tid}}</span> ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupInLoading><iframe class=\"relative scrollQuad\" ng-if=!popupInLoading ng-src=\"{{dataTkDetails.iFrameUrl | trustUrl}}\" style=border:none;width:100% ng-style=\"{\'height\':{{getAvailableHeight(200)}}+\'px\'}\"></iframe></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/dashboard/popup/tickets.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.p_tk.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{dataTkObj.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{dataTkObj.label}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'ticket\'); searchTextPopup=\'\'\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=\"pull-right bdrR padLR5 marR5 marT-5\"><button type=button role=button class=\"btn btn-sm btn-default\" ng-click=bugsOpen(dataTkObj.id);><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</button></div></header><div class=\"panel-body scrollQuad\" ng-style=\"{\'max-height\':{{getAvailableHeight(304)}}+\'px\'}\"><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !dataTkObj.ticket.length\">{{\'d.p_tk.m1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!popupLoading && dataTkObj.ticket.length\"><div class=scrollQuad ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=msg-warning lang={{auth.lang}} ng-if=!filtered.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=\"row stickyHeader\" ng-if=filtered.length><div class=\"col-xs-2 noPadR\">{{\'d.p_tk.2\' | translate}}</div><div class=col-xs-3>{{\'sc.mail.3\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.brief.2\' | translate}}</div><div class=col-xs-2>{{\'cm.label.46\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.brief.11\' | translate}}</div></div><div class=row ng-repeat=\"list in filtered = (dataTkObj.ticket | customSearch:{key:searchTextPopup, module:\'ticket\'})\"><!-- <div class=\"col-xs-2 noPadR\"><a href=\"\" role=\"link\" ng-click=\"ticketDetailsOpen(list.thid, list.tid, list.d);\">{{list.tid}}</a></div> --><div class=\"col-xs-2 noPadR\">{{list.tid}}</div><div class=\"col-xs-3 text-ellipsis\">{{list.sub}} <span ng-if=!list.sub class=\"text-muted text-sm\">N/A</span></div><!-- <div class=\"col-xs-2 text-ellipsis\">{{list.label}} <span ng-if=\"!list.label\" class=\"text-muted text-sm\">N/A</span></div> --><div class=\"col-xs-3 text-sm\">{{(list.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=col-xs-2><span ng-if=\"list.status == \'a\'\"><span ng-if=list.exResDate class=text-sm>ETA: {{list.exResDate | toDate | date:\'MMM d, y\'}} </span><span ng-if=!list.exResDate>{{\'d.p_tk.3\' | translate}}</span> </span><span ng-if=\"list.status == \'o\'\"><span ng-if=list.exResDate class=text-sm>ETA: {{list.exResDate | toDate | date:\'MMM d, y\'}} </span><span ng-if=!list.exResDate>{{\'d.p_tk.4\' | translate}}</span> </span><span ng-if=\"list.status == \'r\'\" class=text-success>{{\'d.p_tk.5\' | translate}}</span></div><div class=\"col-xs-2 text-right\"><span ng-if=list.d.length>{{list.d.length}}</span> <span ng-if=!list.d.length class=\"text-muted text-sm\">N/A</span> <button type=button role=button class=\"btn btn-info btn-xs\" ng-click=\"detailsOpen(\'ot\', \'device\', list.d, list.status, list.name, list.tid, \'\', list.isDeviceIdExists);\" ng-if=\"list.d.length > 0\">{{\'cm.btn.21\' | translate}}</button></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/inventory/dir/invList.html","<div context-menu=contextMenuBase><!-- <div class=\"tab-pane dScrollQuad \" ng-if=\"!inventoryLoading && inventory.length > 0\" when-scrolled=\"loadMoreList()\" ng-attr-style=\"max-height:{{getAvailableHeight(680)}}px\"> --><div class=\"tab-pane dScrollQuad\" ng-if=\"!inventoryLoading && inventory.length > 0\" ng-attr-style=max-height:{{getAvailableHeight(680)}}px>{{curKeyName = (info.col | filter:{\"key\":\"name\"}:true);\"\"}} {{curKeyType = (info.col | filter:{\"key\":\"type\"}:true);\"\"}} {{curKeyModel = (info.col | filter:{\"key\":\"model\"}:true);\"\"}} {{curKeyMF = (info.col | filter:{\"key\":\"mf\"}:true);\"\"}} {{curKeySerial = (info.col | filter:{\"key\":\"serial\"}:true);\"\"}} {{curKeyPO = (info.col | filter:{\"key\":\"po\"}:true);\"\"}} {{curKeyL = (info.col | filter:{\"key\":\"l\"}:true);\"\"}} {{curKeyPOn = (info.col | filter:{\"key\":\"pOn\"}:true);\"\"}} {{curKeyIOn = (info.col | filter:{\"key\":\"iOn\"}:true);\"\"}} {{curKeyROn = (info.col | filter:{\"key\":\"rOn\"}:true);\"\"}} {{curKeyDOn = (info.col | filter:{\"key\":\"dOn\"}:true);\"\"}} {{curKeyW = (info.col | filter:{\"key\":\"w\"}:true);\"\"}} {{curKeyEW = (info.col | filter:{\"key\":\"ew\"}:true);\"\"}} {{curKeyRW = (info.col | filter:{\"key\":\"rw\"}:true);\"\"}} {{curKeyStatus = (info.col | filter:{\"key\":\"status\"}:true);\"\"}} {{curKeyCost = (info.col | filter:{\"key\":\"cost\"}:true);\"\"}}<table id=invListTable class=\"table table-md table-striped\"><thead><tr><th ng-show=\"selectedTab != \'hub.inventory.others\'\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'name\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"inventorySort.type==\'name\'\"><span ng-class=\"isSort?\'fa fa fa-chevron-up\':\'fa fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th ng-show=\"selectedTab != \'hub.inventory.others\'\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'mac\');\">{{\'cm.label.80\' | translate}} <span ng-if=\"inventorySort.type==\'mac\'\"><span ng-class=\"isSort?\'fa fa fa-chevron-up\':\'fa fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'tlabel\');\">{{\'in.p_i.2\' | translate}} <span ng-if=\"inventorySort.type==\'tlabel\'\"><span ng-class=\"isSort?\'fa fa fa-chevron-up\':\'fa fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'model\');\">{{\'in.p_i.3\' | translate}} <span ng-if=\"inventorySort.type==\'model\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'mf\');\">{{\'in.p_i.4\' | translate}} <span ng-if=\"inventorySort.type==\'mf\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'serial\');\">{{\'in.p_i.5\' | translate}} <span ng-if=\"inventorySort.type==\'serial\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'l\');\">{{\'in.p_i.7\' | translate}} <span ng-if=\"inventorySort.type==\'l\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'crOn\');\">{{\'in.p_i.21\' | translate}} <span ng-if=\"inventorySort.type==\'crOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th ng-show=\"selectedT == 2 || selectedT == 3\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'iOn\');\">{{\'in.p_i.19\' | translate}} <span ng-if=\"inventorySort.type==\'iOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th ng-show=\"selectedT == 3\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'rOn\');\">{{\'in.p_i.20\' | translate}} <span ng-if=\"inventorySort.type==\'rOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th><a href=\"\" role=link ng-click=\"sortTypeInv(\'w\');\">{{\'in.p_i.12\' | translate}} <span ng-if=\"inventorySort.type==\'w\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th ng-show=\"selectedTab == \'hub.inventory.others\'\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'ew\');\">{{\'in.p_i.13\' | translate}} <span ng-if=\"inventorySort.type==\'ew\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th ng-show=\"selectedT == 2 || selectedT == 3\"><a href=\"\" role=link ng-click=\"sortTypeInv(\'rw\');\">{{\'in.p_i.14\' | translate}} <span ng-if=\"inventorySort.type==\'rw\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\" aria-hidden=true></span></span></a></th><th class=text-right ng-show=\"selectedTab == \'hub.inventory.others\' && (auth.upermissions.inv.ed || auth.upermissions.inv.dlt)\"><a href=\"\" role=link>{{\'cm.label.25\' | translate}}</a></th></tr></thead><tbody><tr ng-repeat=\"inv in filteredInvList = (inventory | filter:searchInvText.text)\" context-menu=contextMenuOpt><td ng-show=\"selectedTab != \'hub.inventory.others\'\" style=max-width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap><span class=\"deviceStatus {{inv.isActive?\'online\':\'offline\'}}\" uib-tooltip=\"{{inv.isActive?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> <span uib-tooltip={{inv.name}} tooltip-append-to-body=true tooltip-popup-delay=500>{{inv.name}}</span></td><!--name--><td ng-show=\"selectedTab != \'hub.inventory.others\'\" style=max-width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap><span uib-tooltip={{inv.mac}} tooltip-append-to-body=true tooltip-popup-delay=500>{{inv.mac}}</span> <span class=\"text-muted text-sm\" ng-if=!inv.mac>N/A</span></td><!--Id--><td><span ng-if=\"inv.tlabel == \'mp\'\">{{\'d.label.1.1\' | translate}}</span> <span ng-if=\"inv.tlabel == \'desktop\'\">{{\'d.label.1.7\' | translate}}</span> <span ng-if=\"inv.tlabel == \'webos\'\">{{\'d.label.1.5\' | translate}}</span> <span ng-if=\"inv.tlabel == \'tizen\'\">{{\'d.label.1.6\' | translate}}</span> <span ng-if=\"inv.tlabel == \'mc\'\">{{\'d.label.1.4\' | translate}}</span> <span ng-if=\"inv.tlabel == \'gf\'\">{{\'d.label.1.2\' | translate}}</span> <span ng-if=\"inv.tlabel == \'v\'\">{{\'d.label.1.3\' | translate}}</span> <span ng-if=\"inv.tlabel == \'epd\'\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"inv.tlabel != \'mp\' && inv.tlabel != \'desktop\' && inv.tlabel != \'webos\'&& inv.tlabel != \'tizen\' && inv.tlabel != \'mc\'&& inv.tlabel != \'gf\' && inv.tlabel != \'v\' && inv.tlabel != \'epd\'\">{{inv.tlabel}}</span> <span class=\"text-muted text-sm\" ng-if=!inv.tlabel>N/A</span></td><!--Type--><td>{{inv.model}} <span class=\"text-muted text-sm\" ng-if=!inv.model>N/A</span></td><!--Model--><td>{{inv.mf}} <span class=\"text-muted text-sm\" ng-if=!inv.mf>N/A</span></td><!--manufacturer--><td>{{inv.serial}} <span class=\"text-muted text-sm\" ng-if=!inv.serial>N/A</span></td><!--serial--><td><!-- {{inv.city}}{{inv.city && inv.prvn ? \',\' : \' \'}}{{inv.prvn}} --> {{inv.l}} <span class=\"text-muted text-sm\" ng-if=!inv.l>N/A</span><!-- <span class=\"text-muted text-sm\" ng-if=\"!inv.l && !inv.city && !inv.prvn\">N/A</span> --></td><!--location--><td><span class=\"text-ellipsis text-sm\" ng-if=inv.crOn>{{(inv.crOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"inv.crOn == null || !inv.crOn\">N/A</span></td><!--Added on--><td ng-show=\"selectedT == 2 || selectedT == 3\"><span class=\"text-ellipsis text-sm\" ng-if=inv.iOn>{{(inv.iOn * 1000) | date:\"MMM d, y\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"inv.iOn == null || !inv.iOn\">N/A</span></td><!--Installed on--><td ng-show=\"selectedT == 3\"><span class=\"text-ellipsis text-sm\" ng-if=inv.rOn>{{(inv.rOn * 1000) | date:\"MMM d, y\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"inv.rOn == null || !inv.rOn\">N/A</span></td><!--Removed on--><td><span ng-if=\"inv.w || inv.w == 0\">{{inv.w}} <span ng-if=\"inv.wt == \'d\'\">{{inv.w>1?\'in.p_i.12.1s\':\'in.p_i.12.1\' | translate}}</span> <span ng-if=\"inv.wt == \'m\'\">{{\'in.p_i.12.2\' | translate}}</span> <span ng-if=\"inv.wt == \'y\'\">{{\'in.p_i.12.3\' | translate}}</span> </span><span class=\"text-muted text-sm\" ng-if=\"!inv.w && inv.w != 0\">N/A</span></td><!--warranty--><td ng-show=\"selectedTab == \'hub.inventory.others\'\"><span ng-if=inv.ew>{{inv.ew}} <span ng-if=\"inv.ewt == \'d\'\">{{inv.ew>1?\'in.p_i.12.1s\':\'in.p_i.12.1\' | translate}}</span> <span ng-if=\"inv.ewt == \'m\'\">{{\'in.p_i.12.2\' | translate}}</span> <span ng-if=\"inv.ewt == \'y\'\">{{\'in.p_i.12.3\' | translate}}</span> </span><span class=\"text-muted text-sm\" ng-if=!inv.ew>N/A</span></td><!--Ext. Warranty--><td ng-show=\"selectedT == 2 || selectedT == 3\"><!-- <span ng-if=\"inv.invType == \'other\'\"> --> <span ng-if=\"inv.rw || inv.rw == 0\">{{inv.rw}} <span ng-if=\"inv.wt == \'d\'\">{{inv.rw>1?\'in.p_i.12.1s\':\'in.p_i.12.1\' | translate}}</span> <span ng-if=\"inv.wt == \'m\'\">{{\'in.p_i.12.2\' | translate}}</span> <span ng-if=\"inv.wt == \'y\'\">{{\'in.p_i.12.3\' | translate}}</span> </span><span class=\"text-muted text-sm\" ng-if=\"!inv.rw && inv.rw != 0\">N/A</span><!-- <span ng-if=\"inv.invType == \'device\'\">{{inv.War}} {{inv.War>1?\'in.p_i.12.1s\':\'in.p_i.12.1\' | translate}}\r\n            <span class=\"text-muted text-sm\" ng-if=\"inv.War == null\">N/A</span>\r\n            </span> --></td><!--Remaining Warranty--><td class=text-right ng-show=\"inv.invType == \'other\' && (auth.upermissions.inv.ed || auth.upermissions.inv.dlt)\"><a href=\"\" role=link class=\"text-primary marR5 hide\" ng-click=historyOpen(inv); uib-tooltip=\"{{\'d.tool.18\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-history\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=auth.upermissions.inv.ed class=\"text-primary marR5\" uib-tooltip=\"{{\'cm.btn.22\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000 ng-click=inventoryCUOpen({status:selectedT,id:inv.id});><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=auth.upermissions.inv.dlt class=text-danger ng-click=deleteOpen(inv.id); uib-tooltip=\"{{\'cm.btn.13\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000><span class=\"fa fa-close\" aria-hidden=true></span></a> <span class=\"text-muted text-sm\" ng-if=\"inv.invType != \'other\'\">N/A</span></td><!--Action--></tr></tbody></table><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredInvList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchInvText.text)}}&quot;</b>\'}\"></div></div><div ng-if=\"!paginationLoading && !inventoryLoading && inventory.length && invFilter.length && auth.upermissions.dp\" class=\"marT10 marB5 noPad d-flex justify-end\" ng-class=\"{\'bdr-top-dashed\':!paginationLoading && !inventoryLoading && auth.upermissions.dp && inventory.length && invFilter.length}\"><div><div ng-if=\"!inventoryLoading && !paginationLoading && (invinfo.info.tc/invinfo.info.pl > 1) && (inventory.length || pageList.length) && invinfo.info.pl != 0\" class=\"devicePaging marL10\" ng-class=\"{\'disabled\': paginationLoading}\"><uib-pagination class=pagination-sm ng-model=currentPage ng-change=pageChangedFx(currentPage) total-items=invinfo.info.tc items-per-page=invinfo.info.pl max-size=5 num-pages=numPages boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></uib-pagination></div><div class=\"pull-right text-muted marT15\" ng-class=\"(invinfo.info.tc/invinfo.info.pl > 1) ? \'marT15\':\'marT12\'\">{{inventoryRange ? inventoryRange : (curCount + \' - \' + invinfo.info.pl)}} of {{invinfo.info.tc ? invinfo.info.tc : inventory.length}}</div></div></div><!-- <div ng-if=\"inoAvail\" class=\"msg-warning ng-binding ng-scope\" lang=\"{{auth.lang}}\">{{\'in.msg.2\' | translate}}</div>\r\n  <div ng-if=\"noDeploy\" class=\"msg-warning ng-binding ng-scope\" lang=\"{{auth.lang}}\">{{\'in.msg.3\' | translate}}</div>\r\n  <div ng-if=\"noRetir\" class=\"msg-warning ng-binding ng-scope\" lang=\"{{auth.lang}}\">{{\'in.msg.4\' | translate}}</div> --></div><!-- <div class=\"table bg-white no-th marT-20\">\r\n  <div class=\"row th bg-white\">\r\n    <div class=\"col\" ng-show=\"curKeyName[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'name\';isSort=!isSort\">{{\'cm.brief.1\' | translate}} <span ng-if=\"sortType==\'name\'\"><span ng-class=\"isSort?\'fa fa fa-chevron-up\':\'fa fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyType[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'tlabel\';isSort=!isSort\">{{\'in.p_i.2\' | translate}} <span ng-if=\"sortType==\'tlabel\'\"><span ng-class=\"isSort?\'fa fa fa-chevron-up\':\'fa fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyModel[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'model\';isSort=!isSort\">{{\'in.p_i.3\' | translate}} <span ng-if=\"sortType==\'model\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyMF[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'mf\';isSort=!isSort\">{{\'in.p_i.4\' | translate}} <span ng-if=\"sortType==\'mf\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeySerial[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'serial\';isSort=!isSort\">{{\'in.p_i.5\' | translate}} <span ng-if=\"sortType==\'serial\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyPO[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'po\';isSort=!isSort\">{{\'in.p_i.6\' | translate}} <span ng-if=\"sortType==\'po\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyL[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'l\';isSort=!isSort\">{{\'in.p_i.7\' | translate}} <span ng-if=\"sortType==\'l\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyPOn[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'pOn\';isSort=!isSort\">{{\'in.p_i.8\' | translate}} <span ng-if=\"sortType==\'pOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyIOn[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'iOn\';isSort=!isSort\">{{\'in.p_i.9\' | translate}} <span ng-if=\"sortType==\'iOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyROn[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'rOn\';isSort=!isSort\">{{\'in.p_i.10\' | translate}} <span ng-if=\"sortType==\'rOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyDOn[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'dOn\';isSort=!isSort\">{{\'in.p_i.11\' | translate}} <span ng-if=\"sortType==\'dOn\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyW[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'w\';isSort=!isSort\">{{\'in.p_i.12\' | translate}} <span ng-if=\"sortType==\'w\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyEW[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'ew\';isSort=!isSort\">{{\'in.p_i.13\' | translate}} <span ng-if=\"sortType==\'ew\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyRW[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'rw\';isSort=!isSort\">{{\'in.p_i.14\' | translate}} <span ng-if=\"sortType==\'rw\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyStatus[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'status\';isSort=!isSort\">{{\'in.p_i.15\' | translate}} <span ng-if=\"sortType==\'status\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n    <div class=\"col\" ng-show=\"curKeyCost[0].isSelected\"><a href=\"\" ng-click=\"sortType=\'cost\';isSort=!isSort\">{{\'in.p_i.17\' | translate}} <span ng-if=\"sortType==\'status\'\"><span ng-class=\"isSort?\'fa fa-chevron-up\':\'fa fa-chevron-down\'\"></span></span></a></div>\r\n  </div>\r\n  <div ng-if=\"\">\r\n    <div class=\"scrollQuad\" style=\"max-height:{{getAvailableHeight(440)}}px\">\r\n      <div class=\"row\" ng-repeat=\"lang in langObj.languages\">\r\n        <div class=\"col-xs-7 word-break\">{{lang.label}}</div>\r\n        <div class=\"col-xs-5 text-right\">\r\n          <a href=\"\" ng-if=\"!lang.isDef\" class=\"text-primary marR10\" ng-click=\"langEditFx(lang);\"><span class=\"fa fa-pencil\"></span></a>\r\n          <a href=\"\" ng-if=\"!lang.isDef\" class=\"text-danger\" ng-click=\"langDeleteOpen(lang.id);\"><span class=\"fa fa-remove\"></span></a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div> -->");
$templateCache.put("app/inventory/popup/addType.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'in.p_i.22\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(350)}}px><div class=\"bg-light pad10\"><div class=row><div class=col-xs-6><label>{{\'cm.label.69\' | translate}}</label><input type=text class=form-control ng-model=addType autocomplete=off maxlength={{inputLimit}}></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=createType(addType) ng-disabled=addTypeProcessing><span><span class=fa ng-class=\"addTypeProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrType aria-live=polite role=status><span ng-if=\"errAddType==\'typeExists\'\" aria-live=polite role=status>{{\'cm.msg.19\' | translate}}</span> <span ng-if=\"errAddType==\'addType\'\" aria-live=polite role=status>{{\'cl.widget.qr.m1\' | translate}}</span></div><div class=clearfix></div></div></section>");
$templateCache.put("app/inventory/popup/export.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cm.btn.17\" | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=loadProcessing><div ng-if=!loadProcessing><div><label class=\"text-15 text-unbold\" for=status>Status</label><div class=marL10><label class=text-unbold><input type=radio name=status ng-disabled=\"confirmObj.advSearch && confirmObj.status != 3\" ng-model=confirmObj.status value=3><label></label>{{\'cm.tool.2.1\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio name=status ng-disabled=\"confirmObj.advSearch && confirmObj.status != 0\" ng-model=confirmObj.status value=0><label></label>{{\'in.p_i.15.0\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio name=status ng-disabled=\"confirmObj.advSearch && confirmObj.status != 1\" ng-model=confirmObj.status value=1><label></label>{{\'in.p_i.15.1\' | translate}}</label><label class=\"text-unbold marL10\"><input type=radio name=status ng-disabled=\"confirmObj.advSearch && confirmObj.status != 2\" ng-model=confirmObj.status value=2><label></label>{{\'in.p_i.15.2\' | translate}}</label></div></div><label class=\"noMarB marT5\" ng-show=\"confirmObj.type == \'h\'\"><a href=\"\" ng-click=\"settingsOpen=settingsOpen?false:true\">{{\'d.p_dc.wos.9\' | translate}} <span class=fa ng-class=\"settingsOpen?\'fa-chevron-up\':\'fa-chevron-down\'\"></span></a></label><div class=\"marT5 bdr-top-dashed bg-light pad10\" ng-if=settingsOpen><div class=\"row dg-list\"><div class=col-xs-4><div ng-repeat=\"col1 in dColumnOneList\"><label class=marB5><input type=checkbox ng-model=col1.checkbox ng-change=TypeFx(col1)><label></label>{{col1.label}}</label></div></div><div class=col-xs-4><div ng-repeat=\"col2 in dColumnTwoList\"><label class=marB5><input type=checkbox ng-model=col2.checkbox ng-change=TypeFx(col2)><label></label>{{col2.label}}</label></div></div><div class=col-xs-4><div ng-repeat=\"col3 in dColumnThreeList\"><label class=marB5><input type=checkbox ng-model=col3.checkbox ng-change=TypeFx(col3)><label></label>{{col3.label}}</label></div></div></div></div></div></div><footer class=\"panel-footer padB10\"><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=downloadFx(confirmObj.status,confirmObj.type); ng-disabled=loadProcessing>{{\"d.btn.24\" | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm ng-binding\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></footer></section>");
$templateCache.put("app/inventory/popup/history.html","<section class=panel><header class=panel-heading>{{\'d.tool.18\' | translate}} <span class=\"marL5 text-sm\" ng-if=history.info.type.label>[ {{history.info.type.label}} ]</span><!-- <div class=\"pull-right bdrR\" ng-if=\"!historyLoading && history.list.length\"><a href=\"\" class=\"padR10 marL5\" uib-tooltip=\"Download\" tooltip-append-to-body=\"true\"><span class=\"fa fa-download\"></span></a></div> --></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(350)}}px><img src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"!historyLoading && history.list.length>0\"><div ng-repeat=\"comment in history.list\" style=\"border-left:1px dashed #ccc;padding-left:10px;margin-left:4px\"><div class=\"badge badge-info\">{{getToday(comment.date)?(\'od.label.23\' | translate):comment.date}}</div><div ng-repeat=\"log in comment.logs\" style=\"padding:10px 0;position:relative\"><div class=word-break><span class=\"fa fa-circle text-muted\" style=\"font-size:8px;margin:7px 0 0 -14px;position:absolute\"></span><span ng-bind-html=log.comment></span></div><div class=\"word-break text-sm text-bold text-muted\">{{log.crBy.label}} | {{log.crOn | date:\'shortTime\'}}</div></div></div></div><div ng-if=\"!historyLoading && !history.list.length\" class=msg-warning lang={{auth.lang}}>{{\'cm.p_h.m1\' | translate}}</div></div><div class=panel-footer ng-if=!historyLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/inventory/popup/import.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.btn.16\' | translate}}</h1></header><div class=panel-body><label>{{\'cl.btn.5\' | translate}}</label><span class=\"padL10 hide\"><a href=\"\" ng-click=sampleFile();>{{\'cm.btn.49\' | translate}}</a></span><div class=btn-file><button type=button role=button class=\"btn btn-primary btn-sm ng-binding\" ng-disabled=saveProcessing>{{\'cm.btn.36\' | translate}}</button><!-- <input type=\"file\" file-model=\"importObj\" options=\"{size:2147482548, format:[\'xls\', \'xlsx\'], sFiles:true, errorPop:false}\" accept=\"excel/*\" ng-disabled=\"saveProcessing\" class=\"ng-isolate-scope\"> --> <input id=excelFile type=file file-model options=\"{format:[\'excel\'], callback:true}\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" ng-disabled=fileModelLoading ng-if=!isFileUploading> <input type=text class=\"form-control text-bold\" ng-value=curData.name readonly maxlength=250></div><!-- <div class=\"btn-file\">\r\n      <button type=\"button\" role=\"button\" class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button>\r\n      <input type=\"file\" id=\"fileDefault\" file-model=\"curFileDete\" options=\"{size:2147482548, format:[\'imgOnly\'], callback:true, value:\'default\'}\" accept=\"image/*\" ng-disabled=\"defaultImg.default.uploading || saveProcessing\">\r\n      <input type=\"text\" class=\"form-control\" ng-value=\"defaultImg.default.label\" readonly=\"\">\r\n    </div> --></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=uploadFx(); ng-disabled=\"uploadProcessing || !curData.name\"><span ng-class=\"uploadProcessing?\'fa fa-repeat fa-spin\':\'fa fa-upload\'\" aria-hidden=true></span>{{\'cm.btn.16\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'dEmpty\'\" aria-live=polite role=status>{{\'d.msg.20\' | translate}}</span> <span ng-if=\"errType==\'gtEmpty\'\" aria-live=polite role=status>{{\'d.msg.21\' | translate}}</span> <span ng-if=\"errType==\'exIssue\'\" aria-live=polite role=status>{{\'d.msg.31\' | translate}}</span> <span ng-if=\"errType==\'exOrder\'\" aria-live=polite role=status>{{\'d.msg.42\' | translate}}</span> <span ng-if=\"errType==\'noDevice\'\" aria-live=polite role=status>{{\'d.msg.54\' | translate}}</span></div><div class=clearfix></div></div></section>");
$templateCache.put("app/inventory/popup/otherInv.html","<!-- <div class=\"pageHeading\" ng-if=\"auth.upreferences.isPopup\">\r\n    <a href class=\"marR10\" ui-sref=\"hub.inventory.devices\">{{\'cm.menu.11\' | translate}}</a>/<span class=\"marL10 marR10\" ng-if=\"!detailLoading\">{{invObj.id?\'in.p_i.1\':\'in.btn.1\' | translate}}</span>\r\n  </div> --><section class=panel role=dialog ng-class=\"{\'popup-panel\': !auth.upreferences.isPopup}\"><header class=panel-heading><h1 role=heading aria-level=1>{{invObj.id?\'in.p_i.1\':\'in.btn.1\' | translate}}</h1></header><div class=\"panel-body scrollQuad\"><img src=assets/images/loading.gif ng-if=invPopuLoading><div ng-if=!invPopuLoading><div ng-if=invObj.id><section><header class=panel-inner-tab><a href=\"\" role=link ng-class=\"{\'selected\':subTab==\'1\'}\" aria-hidden=true aria-label=details ng-click=subTabFx(1);>{{\'cm.btn.31\' | translate}}</a><!-- <a href=\"\" ng-class=\"{\'selected\':subTab==\'2\'}\" ng-click=\"subTabFx(2);\" >{{\'cs.tab.5\' | translate}}</a> --><!-- <a href=\"\" role=\"link\" ng-class=\"{\'selected\':subTab==\'3\'}\" aria-hidden=\"true\" aria-label=\"history\" ng-click=\"subTabFx(3);\" >{{\'d.tool.18\' | translate}}</a> --><div class=pull-right ng-if=\"subTab==\'2\'\"><div class=\"btn-file marT-5\"><button type=button role=button class=\"btn btn-primary btn-xs\" style=margin-bottom:-8px><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.19\' | translate}}</button> <input type=file file-model=curFile options=\"{size:102430000, format:[\'inventory\'], callback:true, multiple:true, caller:\'c\'}\" multiple style=height:28px></div></div><div class=clearfix></div></header></section></div><div class=marT10 ng-if=\"subTab==\'1\'\" ng-attr-style=max-height:{{getAvailableHeight(480)}}px><div class=row><div class=col-xs-6><label for=serial>{{\'in.p_i.5\' | translate}}</label><input type=text id=serial class=form-control ng-model=invObj.serial autocomplete=off maxlength={{inputLimit}} aria-label=serial aria-labelledby=serial></div><div class=\"col-xs-6 type-select\"><label>{{\'in.p_i.2\' | translate}}</label><span class=\"marL10 text-sm\"><a href=\"\" role=link aria-hidden=true aria-label=createType ng-click=addNewType();>{{\'in.p_i.22\' | translate}}</a></span><!-- <select class=\"form-control\" ng-model=\"invObj.type\" ng-options=\"option.label for option in inventoryType | orderBy:\'label\' track by option.id\" ></select> --><!-- <div class=\"lsn-select\"> --><div class=dropdown uib-dropdown auto-close=outsideClick is-open=st.isOpen on-toggle=\"toggleCallbackType(open);searchTList=\'\'\"><a href=\"\" role=link id=selectedtype class=dropdown-toggle uib-dropdown-toggle aria-hidden=true aria-label=typeDropdown ng-click=typeSearchFocus();><span class=\"pull-left padL5\">{{invObj.type.label}}</span> <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=\"dropdown-header padLR10\" ng-show=\"inventoryType.length > 5\"><label for=stSearch class=lableHidden>dtpl</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=stSearch ng-model=searchTList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=searchTList class=text-danger ng-show=searchTList.length aria-hidden=true aria-label=typeSearch ng-click=\"searchTList=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider ng-show=\"inventoryType.length > 5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"tList in filteredTypeList = (inventoryType | filter:searchTList) | orderBy: \'label\'\" tabindex={{$index}} ng-class=\"{\'selected\': tList.id == invObj.type.id}\"><a href=\"\" role=link id=st{{$index}} aria-hidden=true aria-label=type ng-click=\"selectTypeFx(tList, $event);\">{{tList.label}}</a><!-- <span>{{tList.label}}</span> --></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTypeList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTList)}}&quot;</b>\'}\"></div></div></ul></div><!-- </div> --></div><div class=\"col-xs-6 marT15\" ng-if=\"invObj.type.isDev || invObj.type.isQty\"><label>{{invObj.type.isDev?\'cm.label.4\':\'b.o.19\' | translate}}</label><select class=form-control ng-model=invObj.d ng-options=\"option.label for option in devicesList | orderBy:\'label\' track by option.id\" ng-if=invObj.type.isDev></select><input type=text class=form-control ng-model=invObj.qty autocomplete=off maxlength={{inputLimit}} ng-if=invObj.type.isQty></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=mf>{{\'in.p_i.4\' | translate}}</label><input type=text id=mf class=form-control ng-model=invObj.mf autocomplete=off maxlength={{inputLimit}} aria-label=mf aria-labelledby=mf></div><div class=col-xs-6><label for=model>{{\'in.p_i.3\' | translate}}</label><input type=text id=model class=form-control ng-model=invObj.model autocomplete=off maxlength={{inputLimit}} aria-label=model aria-labelledby=model></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=loc>{{\'in.p_i.7\' | translate}}</label><input type=text id=loc class=form-control ng-model=invObj.l autocomplete=off maxlength={{inputLimit}} aria-label=loc aria-labelledby=loc></div><div class=\"col-xs-6 type-select\"><label>{{\'in.p_i.15\' | translate}}</label><div class=dropdown uib-dropdown auto-close=outsideClick is-open=status.isOpen on-toggle=toggleCallback(open)><a href=\"\" role=link id=selectedStatus class=dropdown-toggle uib-dropdown-toggle><span class=\"pull-left padL5\" ng-if=\"invObj.status == 0\">{{\'in.p_i.15.0\' | translate}}</span> <span class=\"pull-left padL5\" ng-if=\"invObj.status == 1\">{{\'in.p_i.15.1\' | translate}}</span> <span class=\"pull-left padL5\" ng-if=\"invObj.status == 2\">{{\'in.p_i.15.2\' | translate}}</span> <span class=caret></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=list-scroll><li value=0 ng-class=\"{\'selected\': \'0\' == invObj.status}\"><a href=\"\" role=link aria-hidden=true aria-label=available ng-click=selectStatusFx(0);>{{\'in.p_i.15.0\' | translate}}</a></li><li value=1 ng-class=\"{\'selected\': \'1\' == invObj.status}\"><a href=\"\" role=link aria-hidden=true aria-label=deployed ng-click=selectStatusFx(1);>{{\'in.p_i.15.1\' | translate}}</a></li><li value=2 ng-if=invObj.id ng-class=\"{\'selected\': \'2\' == invObj.status}\"><a href=\"\" role=link aria-hidden=true aria-label=retired ng-click=selectStatusFx(2);>{{\'in.p_i.15.2\' | translate}}</a></li></div></ul></div><!-- <select type=\"text\" class=\"form-control\" ng-model=\"invObj.status\">\r\n                <option value=\"0\">{{\'in.p_i.15.0\' | translate}}</option>\r\n                <option value=\"1\">{{\'in.p_i.15.1\' | translate}}</option>\r\n                <option value=\"2\" ng-if=\"invObj.id\">{{\'in.p_i.15.2\' | translate}}</option>\r\n              </select> --></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=descr>{{\'cm.label.85\' | translate}}</label><input type=text id=descr class=form-control ng-model=invObj.descr autocomplete=off maxlength={{inputLimit}} aria-label=descr aria-labelledby=descr></div><div class=col-xs-6><label for=pOn>{{\'in.p_i.8\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=pOn class=\"form-control picker up\" ng-model=invObj.pOn singledatepicker=true format=MM/DD/YYYY readonly aria-label=pOn aria-labelledby=pOn></div></div></div><div class=\"row marT15\"><div class=col-xs-6 ng-if=\"invObj.status == 1 || invObj.status == 2\"><label for=iOn>{{\'in.p_i.19\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=iOn class=\"form-control picker up\" ng-model=invObj.iOn singledatepicker=true format=MM/DD/YYYY readonly aria-label=iOn aria-labelledby=iOn></div></div><div class=col-xs-6 ng-if=\"invObj.status == 2 && invObj.id\"><label for=rOn>{{\'in.p_i.20\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input id=rOn type=daterange class=\"form-control picker up\" ng-model=invObj.rOn singledatepicker=true format=MM/DD/YYYY readonly aria-label=rOn aria-labelledby=rOn></div></div></div><div class=\"bg-light pad10 marT15\"><div class=row><div class=col-xs-6><label for=w>{{\'in.p_i.12\' | translate}}</label><input type=number id=w class=form-control ng-model=invObj.w min=0 aria-label=w aria-labelledby=w></div><div class=col-xs-6><label for=ew>{{\'in.p_i.13\' | translate}}</label><input type=number id=ew class=form-control ng-model=invObj.ew min=0 aria-label=ew aria-labelledby=ew></div></div><div class=\"row marT15\"><div class=col-xs-6><label for=wStOn>{{\'in.p_i.16\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\"></span></span> <input type=daterange id=wStOn class=\"form-control picker up\" ng-model=invObj.wStOn singledatepicker=true format=MM/DD/YYYY readonly aria-label=wStOn aria-labelledby=wStOn></div></div></div></div><!-- </div> --><!-- <div class=\"marT15\" ng-if=\"!invObj.id\">\r\n            <div class=\"bdrBtm marB10 padB2\">\r\n              <label>{{curFiles.length}} {{\'cs.tab.5\' | translate}}</label>\r\n              <div class=\"btn-file pull-right\">\r\n                <button type=\"button\" class=\"btn btn-primary btn-xs\"><span class=\"fa fa-plus-circle\"></span>{{\'cm.btn.19\' | translate}}</button>\r\n                <input type=\"file\" file-model=\"curFile\" options=\"{size:102430000, format:[\'inventory\'], callback:true, multiple:true, caller:\'c\'}\" multiple>\r\n              </div>\r\n            </div>\r\n            <div class=\"marB10\" ng-if=\"curFiles.length\">\r\n              <div class=\"row attachList\" ng-repeat=\"sFile in curFiles\">\r\n                <div class=\"col-xs-11 noPadL noPadR text-ellipsis\">\r\n                  {{ext = (sFile.type | fileExt:sFile.name); \"\"}}\r\n                  <span class=\"fa marR5 padL5\" ng-class=\"{\'fa-file-image-o\':ext==\'image\',\'fa-file-text-o\':ext==\'text\',\'fa-file-pdf-o\':ext==\'pdf\',\'fa-file-word-o\':ext==\'doc\',\'fa-file-powerpoint-o\':ext==\'ppt\',\'fa-file-o\':ext==\'file\',\'fa-file-video-o\':ext==\'video\', \'fa-file-archive-o\':ext==\'zip\'}\"></span>\r\n                  <a href=\"{{order.poPath + sFile.nameTemp}}\" target=\"_blank\" download ng-if=\"sFile.id\">{{sFile.name | limitTo:90}}</a>\r\n                  <span ng-if=\"!sFile.id\">{{sFile.name | limitTo:90}}</span>\r\n                  <span ng-if=\"sFile.name.length > 90\">...</span><span class=\"text-muted marL5\">({{sFile.size | filesize}})</span>\r\n                </div>\r\n                <div class=\"col-xs-1 text-right padR5\">\r\n                  <a href=\"{{invObj.poPath + sFile.nameTemp}}\" target=\"_blank\" download class=\"marR5 text-sm\" ng-if=\"sFile.id\"><span class=\"fa fa-download\"></span></a>\r\n                  <a href=\"\" class=\"text-danger\" ng-click=\"deleteOpen($index, sFile.id);\" ng-disabled=\"deleteProcessing\"><span class=\"fa fa-times\"></span></a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!curFiles.length\" class=\"msg-warning\" lang=\"{{auth.lang}}\">{{\'cs.msg.8\' | translate}}</div>\r\n          </div> --></div><!-- <div class=\"marT10\" ng-if=\"subTab==\'2\'\" ng-attr-style=\"max-height:{{getAvailableHeight(480)}}px\">\r\n          <div class=\"marT15\">\r\n\r\n            <div class=\"marB10\" ng-if=\"curFiles.length\">\r\n              <div class=\"row attachList\" ng-repeat=\"sFile in curFiles\">\r\n                <div class=\"col-xs-11 noPadL noPadR text-ellipsis\">\r\n                  {{ext = (sFile.type | fileExt:sFile.name); \"\"}}\r\n                  <span class=\"fa marR5 padL5\" ng-class=\"{\'fa-file-image-o\':ext==\'image\',\'fa-file-text-o\':ext==\'text\',\'fa-file-pdf-o\':ext==\'pdf\',\'fa-file-word-o\':ext==\'doc\',\'fa-file-powerpoint-o\':ext==\'ppt\',\'fa-file-o\':ext==\'file\',\'fa-file-video-o\':ext==\'video\', \'fa-file-archive-o\':ext==\'zip\'}\"></span>\r\n                  <a href=\"{{detailBucket + sFile.nameTemp}}\" ng-if=\"sFile.id && ext==\'image\'\" ng-href=\"{{detailBucket + sFile.nameTemp}}\" fancyboxable=\"fbTitleInside\" data-fancybox-title=\"{{sFile.name}}\">{{sFile.name | limitTo:90}}</a>\r\n                  <a href=\"{{detailBucket + sFile.nameTemp}}\" ng-if=\"sFile.id && ext!=\'image\'\" href=\"{{detailBucket + sFile.nameTemp}}\" target=\"_blank\" download>{{sFile.name | limitTo:90}}</a>\r\n                  <span ng-if=\"!sFile.id\">{{sFile.name | limitTo:90}}</span>\r\n                  <span ng-if=\"sFile.name.length > 90\">...</span><span class=\"text-muted marL5\">({{sFile.size | filesize}})</span>\r\n                </div>\r\n                <div class=\"col-xs-1 text-right padR5\">\r\n                  <a href=\"{{detailBucket + sFile.nameTemp}}\" target=\"_blank\" download class=\"marR5 text-sm\" ng-if=\"sFile.id\"><span class=\"fa fa-download\"></span></a>\r\n                  <a href=\"\" class=\"text-danger\" ng-click=\"deleteOpen($index, sFile.id);\" ng-disabled=\"deleteProcessing\"><span class=\"fa fa-times\"></span></a>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"!curFiles.length\" class=\"msg-warning\" lang=\"{{auth.lang}}\">{{\'cs.msg.8\' | translate}}</div>\r\n          </div>\r\n        </div> --><div class=marT10 ng-if=\"subTab==\'3\'\" ng-attr-style=max-height:{{getAvailableHeight(480)}}px><img src=assets/images/loading.gif ng-if=historyLoading><div ng-if=\"!historyLoading && history.list.length>0\"><div ng-repeat=\"comment in history.list\" style=\"border-left:1px dashed #ccc;padding-left:10px;margin-left:4px\"><div class=\"badge badge-info\">{{getToday(comment.date)?(\'od.label.23\' | translate):comment.date}}</div><div ng-repeat=\"log in comment.logs\" style=\"padding:10px 0;position:relative\"><div class=word-break><span class=\"fa fa-circle text-muted\" style=\"font-size:8px;margin:7px 0 0 -14px;position:absolute\"></span><span ng-bind-html=log.comment></span></div><div class=\"word-break text-sm text-bold text-muted\">{{log.crBy.label}} | {{log.crOn | date:\'shortTime\'}}</div></div></div></div><div ng-if=\"!historyLoading && !history.list.length\" class=msg-warning lang={{auth.lang}}>{{\'cm.p_h.m1\' | translate}}</div></div></div></div><div class=panel-footer ng-if=!invPopuLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=inventoryCUFx(); ng-disabled=saveProcessing ng-if=\"subTab!=\'3\'\"><span ng-if=!invObj.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span> <span ng-if=\"invObj.id && subTab ==\'1\'\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</span> <span ng-if=\"invObj.id && subTab ==\'2\'\"><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-arrow-up\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</span><!-- <span ng-if=\"!invObj.id\"><span class=\"fa\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\"></span>{{\'cm.btn.14\' | translate}}</span>\r\n          <span ng-if=\"invObj.id && subTab==\'1\'\"><span class=\"fa\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\"></span>{{saveProcessing?\'cm.btn.15i\':\'cm.btn.15\' | translate}}</span>\r\n          <span ng-if=\"invObj.id && subTab==\'2\'\"><span class=\"fa\" ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-arrow-up\'\"></span>{{saveProcessing?\'cm.btn.16i\':\'cm.btn.16\' | translate}}</span> --></button><!-- <a href=\"\" class=\"btn btn-link\" ui-sref=\"hub.inventory.others\" ng-if=\"subTab!=\'3\'\">{{\'cm.btn.9\' | translate}}</a>\r\n        <a href=\"\" class=\"btn btn-default\" ui-sref=\"hub.inventory.others\" ng-if=\"subTab==\'3\'\">{{\'cm.btn.10\' | translate}}</a> --> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); ng-if=\"subTab!=\'3\'\">{{\'cm.btn.9\' | translate}}</button> <button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); ng-if=\"subTab==\'3\'\">{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cm.msg.37\' | translate}}</div><div ng-if=\"errType==\'type\'\" aria-live=polite role=status>{{\'in.p_i.m1\' | translate}}</div><div ng-if=\"errType==\'model\'\" aria-live=polite role=status>{{\'in.p_i.m2\' | translate}}</div><div ng-if=\"errType==\'manufacturer\'\" aria-live=polite role=status>{{\'in.p_i.m3\' | translate}}</div><div ng-if=\"errType==\'serial\'\" aria-live=polite role=status>{{\'in.p_i.m4\' | translate}}</div><div ng-if=\"errType==\'serialExist\'\" aria-live=polite role=status>{{\'in.p_i.m15\' | translate}}</div><div ng-if=\"errType==\'location\'\" aria-live=polite role=status>{{\'in.p_i.m6\' | translate}}</div><div ng-if=\"errType==\'desc\'\" aria-live=polite role=status>{{\'in.p_i.m10\' | translate}}</div><div ng-if=\"errType==\'cost\'\" aria-live=polite role=status>{{\'in.p_i.m11\' | translate}}</div><div ng-if=\"errType==\'pFrom\'\" aria-live=polite role=status>{{\'in.p_i.m12\' | translate}}</div><div ng-if=\"errType==\'warranty\'\" aria-live=polite role=status>{{\'in.p_i.m13\' | translate}}</div><div ng-if=\"errType==\'extWarranty\'\" aria-live=polite role=status>{{\'in.p_i.m14\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/frameLayouts/dir/assignableDevices.html","Assignable Devices {{selectedT}}");
$templateCache.put("app/frameLayouts/dir/frameLayoutBrief.html","<div class=selectedQuad><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><div class=panel-heading><h2 ng-if=\"selectedTab != \'hub.frameLayouts.fla\'\">{{selectedItems.length > 1?\'fl.brief.1s\':\'fl.brief.1\' | translate}} [ {{selectedItems.length}} ]</h2><h2 ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\">{{selectedItems.length > 1?\'fl.brief.2s\':\'fl.brief.2\' | translate}} [ {{selectedItems.length}} ]</h2><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=closeAllFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></div><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-show=briefLoading><div ng-if=\"selectedItems.length == 1\">{{curFrameLayout = (frameLayouts.frameLayouts | filter:{id:selectedItems[0].id}:true | orderBy: \'id\');\"\"}}<ul class=\"list-unstyled single-selected\" ng-hide=briefLoading><div class=row><div class=col-xs-3><div class=thumb-highlight><img alt=\"\" ng-if=\"curFrameLayout[0].type == \'Folder\'\" src=assets/images/default/folder_selected.png class=\"noOutline img-responsive center-block img-folder\"> <span ng-if=\"curFrameLayout[0].type != \'Folder\'\"><img alt=\"\" ng-if=\"curFrameLayout[0].thumbV == 0\" src=assets/images/default/incomplete.png class=\"img-responsive center-block img-incomplete\"> <a ng-if=\"curFrameLayout[0].thumbV != 0 && selectedTab != \'hub.frameLayouts.fla\'\" ng-href=\"{{detailBucket + curFrameLayout[0].id + \'.png\' | secureThumb:curFrameLayout[0].thumbV}}\" role=link fancyboxable=fbTitleInside caption={{curFrameLayout[0].label}}><img alt=\"\" ng-src=\"{{tim + bucket + curFrameLayout[0].id + \'.png\' + thumbBigParam + \'&\' + curFrameLayout[0].thumbV}}\" class=\"img-responsive center-block\"> </a><a ng-if=\"curFrameLayout[0].thumbV != 0 && selectedTab == \'hub.frameLayouts.fla\'\" ng-href=\"{{detailBucket + curFrameLayout[0].flId + \'.png\' | secureThumb:curFrameLayout[0].thumbV}}\" role=link fancyboxable=fbTitleInside caption={{curFrameLayout[0].label}}><img alt=\"\" ng-src=\"{{tim + bucket + curFrameLayout[0].flId + \'.png\' + thumbBigParam + \'&\' + curFrameLayout[0].thumbV}}\" class=\"img-responsive center-block\"></a></span><div class=\"text-ellipsis marT5\" uib-tooltip={{curFrameLayout[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curFrameLayout[0].label}}</div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\"><div class=row ng-if=\"curFrameLayout[0].type == \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFrameLayout[0].label}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'fl.brief.7\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curFrameLayout[0].count}}</div></div></div><div class=row ng-if=\"curFrameLayout[0].type != \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFrameLayout[0].label}}</div></div><div class=col-xs-6 ng-if=\"selectedTab !== \'hub.frameLayouts.fla\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{frameBrief.dimension}} <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\"><!--Assignment--><div class=\"col-xs-5 text-right\">{{\'fl.body.3\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFrameLayout[0].flName}}</div></div></div><div class=row ng-if=\"curFrameLayout[0].type != \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curFrameLayout[0].createdOn != null\">{{(curFrameLayout[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=\"curFrameLayout[0].createdOn == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{frameBrief.deviceCount}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"frameBrief.deviceCount > 0\" ng-click=\"deviceListFx(curFrameLayout[0].id, curFrameLayout[0].label);\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\"><!--Assignment--><div class=\"col-xs-5 text-right\">{{\'cm.label.12\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curFrameLayout[0].startDate != null\">{{curFrameLayout[0].startDate}}</span> <span class=\"text-muted text-sm\" ng-if=\"curFrameLayout[0].startDate == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fll\'\"><!--library--><div class=\"col-xs-5 text-right\">{{\'fl.brief.5\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{frameBrief.frameCount}} <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div></div><!--library--><div class=row ng-if=\"curFrameLayout[0].type != \'Folder\' && selectedTab == \'hub.frameLayouts.fll\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'fl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{frameBrief.usageCount}} <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div></div><div ng-if=\"selectedTab !== \'hub.frameLayouts.fll\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{frameBrief.createdBy}} <span ng-if=\"frameBrief != \'\' && frameBrief.createdBy == null\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\"><!--Assignment--><div class=\"col-xs-5 text-right\">{{\'cm.label.13\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curFrameLayout[0].endDate != null\">{{curFrameLayout[0].endDate}}</span> <span class=\"text-muted text-sm\" ng-if=\"curFrameLayout[0].endDate == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\"><!--Assignment--><div class=\"col-xs-5 text-right\">{{\'fl.brief.3\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{frameBrief.fla}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"frameBrief.fla > 0\" ng-click=\"assignmentListFx(frameBrief.id, curFrameLayout[0].label);\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"frameBrief != \'\' && frameBrief.editedOn\">{{(frameBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curFrameLayout[0].id, selectedTab==\'hub.frameLayouts.fla\'?\'frameLayoutAssignment\':\'frameLayout\', curFrameLayout[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"frameBrief != \'\' && !frameBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"curFrameLayout[0].approvedOn != null\">{{(curFrameLayout[0].approvedOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curFrameLayout[0].approvedOn == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fla\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curFrameLayout[0].devices}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"curFrameLayout[0].devices > 0\" ng-click=\"deviceListFx(curFrameLayout[0].id, curFrameLayout[0].label);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{frameBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"frameBrief != \'\' && !frameBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.frameLayouts.fl\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{frameBrief.approvedBy}} <span class=\"text-muted text-sm\" ng-if=\"frameBrief != \'\' && frameBrief.approvedBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"frameBrief == \'\'\"></div></div></div></div></div></div></div></ul></div><!--For Multiple selected--><div ng-if=\"selectedItems.length > 1\"><div class=\"thumb-list hoverContainer\"><li ng-repeat=\"frame in selectedItems\" class=\"device valign-top\">{{curFrameLayout = (frameLayouts.frameLayouts | filter:{id:selectedItems[$index].id}:true | orderBy: \'id\');\"\"}}<div class=\"relative padT4 padB1\"><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=\"closeFx(frame.id, \'\', \'flaRemove\')\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner><img alt=Incomplete ng-if=\"curFrameLayout[0].thumbV == 0\" src=assets/images/default/incomplete.png class=\"img-responsive center-block img-incomplete\"> <a ng-if=\"curFrameLayout[0].thumbV != 0 && selectedTab != \'hub.frameLayouts.fla\'\" ng-href=\"{{detailBucket + curFrameLayout[0].id + \'.png\' | secureThumb:curFrameLayout[0].thumbV}}\" role=link fancyboxable=fbTitleInside caption={{curFrameLayout[0].label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + curFrameLayout[0].id + \'.png\' + thumbParam + \'&\' + curFrameLayout[0].thumbV}}\" class=\"img-responsive center-block\"> </a><a ng-if=\"curFrameLayout[0].thumbV != 0 && selectedTab == \'hub.frameLayouts.fla\'\" ng-href=\"{{detailBucket + curFrameLayout[0].flId + \'.png\' | secureThumb:curFrameLayout[0].thumbV}}\" role=link fancyboxable=fbTitleInside caption={{curFrameLayout[0].label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + curFrameLayout[0].flId + \'.png\' + thumbParam + \'&\' + curFrameLayout[0].thumbV}}\" class=\"img-responsive center-block\"></a></span></div><div class=\"thumb-label noMar\" uib-tooltip={{curFrameLayout[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curFrameLayout[0].label}}</div></div></li></div></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=btnLoading> <a href=\"\" role=link class=\"pull-left marT6\" ng-click=btnInfoOpen(frameBtn.info); ng-if=frameBtn.info.length><img alt=\"\" src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"frameBtn.buttons.length == 0 && !btnLoading\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=frameBtn><li ng-repeat=\"fBtn in frameBtn.buttons\"><div ng-if=\"fBtn.key==\'flEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.flContainer.flName({type: encType, id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in fBtn.steps\"><a ng-if=\"step.key==\'flStep1\'\" ui-sref=\"hub.flContainer.flName({type: encType, id: encId})\" role=button>{{\'fl.btn.3\' | translate}}</a> <a ng-if=\"step.key==\'flStep2\'\" ui-sref=\"hub.flContainer.flDesign({type: encType, id: encId})\" role=button>{{\'fl.btn.4\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"fBtn.key==\'flDuplicate\'\" ng-click=duplicateFx(); class=\"btn btn-default\"><span class=\"fa fa-files-o\" aria-hidden=true></span>{{\'cm.btn.50\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flAssign\'\" ng-click=addAssignFx(); class=\"btn btn-success\"><span class=\"fa fa-calendar\" aria-hidden=true></span>{{\'fl.btn.5\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flApprove\'\" ng-click=approveFrameFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flUnapprove\'\" ng-click=\"confirmFrameOpen(\'unapprove\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flDelete\'\" ng-click=\"confirmFrameOpen(\'delete\');\" tooltip-append-to-body=true class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button><!--Assignment Btn--><div ng-if=\"fBtn.key==\'flaEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.flContainer.flaName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button uib-dropdown-toggle class=\"btn btn-primary\"><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu text-left\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in fBtn.steps\"><a ng-if=\"step.key==\'flaStep1\'\" ui-sref=\"hub.flContainer.flaName({id: encId})\" role=button>{{\'cm.label.72\' | translate | camelCase}}</a> <a ng-if=\"step.key==\'flaStep2\'\" ui-sref=\"hub.flContainer.flaSchedule({id: encId})\" role=button>{{\'cm.btn.27\' | translate}}</a> <a ng-if=\"step.key==\'flaStep3\'\" ui-sref=\"hub.flContainer.flaDevice({id: encId})\" role=button>{{\'cm.label.31\' | translate | camelCase}}</a> <a ng-if=\"step.key==\'flaStep4\'\" ui-sref=\"hub.flContainer.flaThreshold({id: encId})\" role=button>{{\'fl.btn.13\' | translate}}</a> <a ng-if=\"step.key==\'flaStep4.1\'\" ui-sref=\"hub.flContainer.flaThreshold({id: encId})\" role=button>{{\'fl.btn.14\' | translate}}</a> <a ng-if=\"step.key==\'flaStep4.2\'\" ui-sref=\"hub.flContainer.flaThreshold({id: encId})\" role=button>{{\'fl.btn.15\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"fBtn.key==\'flaApprove\'\" ng-click=approveAssignFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flaUnapprove\'\" ng-click=\"confirmAssignOpen(\'unapprove\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'flaDelete\'\" ng-click=\"confirmAssignOpen(\'delete\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'fllUse\'\" ng-click=useFrameLayoutFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'fl.btn.12\' | translate}}</button> <button type=button role=button ng-if=\"fBtn.key==\'fllOpen\'\" ng-click=openFolderFx(selectedItems[0].id); class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button></li></ul></div></section></div>");
$templateCache.put("app/frameLayouts/dir/frameLayoutList.html","<li ng-repeat=\"frame in filteredFramelayoutList = (frameLayouts.frameLayouts | customSearch:{key:searchText, module:\'fl\'})\" single-selection data-id={{frame.id}} data-type={{frameLayouts.info.type}} ng-class=\"{\'unapprovedFile\':selectedTab === \'hub.frameLayouts.ufl\', \'nonSelectable\':selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)}\" uib-tooltip=\"{{frame.hfr?\'fl.p_assign.msg.11\':\'d.tool.13\' | translate}}\" tooltip-enable=\"selectedTab === \'hub.dContainer.dFrameLayout\' && (!frame.hfr || frame.sffl)\" context-menu=contextMenuOpt class=tabIndex><div class=thumb-img><img alt=\"\" src=assets/images/default/incomplete.png ng-if=\"frame.thumbV == 0\" class=img-incomplete> <img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + frame.id + \'.png\' + thumbParam + \'&\' + frame.thumbV}}\" ng-if=\"frame.thumbV != 0\"></div><!-- <div class=\"thumb-label\">{{frame.label}}</div> --><div class=thumb-label uib-tooltip={{frame.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{frame.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFramelayoutList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div>");
$templateCache.put("app/frameLayouts/popup/assignmentList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'fl.label.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'assignment\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!assignmentList.length><div class=\"table table-scroll\" ng-if=assignmentList.length><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div ng-class=\"auth.upermissions.flae?\'col-xs-7\':\'col-xs-8\'\">{{\'cm.label.72\' | translate}}</div><div class=col-xs-2>{{\'cm.label.10\' | translate}}</div><div class=col-xs-2>{{\'cm.label.11\' | translate}}</div><div class=\"col-xs-1 text-right\" ng-if=auth.upermissions.flae>{{\'cm.label.25\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"fla in filteredList = (assignmentList | customSearch:{key:searchTextPopup, module:\'flals\'})\" ng-if=assignmentList ng-class=\"{\'bg-danger\' : fla.isExpired == 1}\"><div class=text-ellipsis-wrap ng-class=\"auth.upermissions.flae?\'col-xs-7\':\'col-xs-8\'\"><span class=\"fa fa-exclamation-triangle text-danger marR5\" uib-tooltip=\"{{\'fl.tool.6\' | translate}}\" tooltip-append-to-body=true ng-if=\"fla.isExpired == 1\" aria-hidden=true></span> {{fla.fla}}</div><div class=col-xs-2>{{fla.st}}</div><div class=col-xs-2 ng-class=\"{\'text-danger text-bold\' : fla.isExpired == 1}\">{{fla.et}}</div><div class=\"col-xs-1 text-right\" ng-if=auth.upermissions.flae><a href=\"\" role=link ng-click=editAssignment(fla.id)><span class=\"fa fa-pencil noMarR\" aria-hidden=true></span></a></div></div><!-- <div class=\"row\" ng-repeat=\"fla in filteredList = (assignmentList | customSearch:{key:searchTextPopup, module:\'flals\'})\" ng-if=\"assignmentList\">\r\n          <div class=\"text-ellipsis-wrap\" ng-class=\"auth.upermissions.flae?\'col-xs-7\':\'col-xs-8\'\">{{fla.fla}}</div>\r\n          <div class=\"col-xs-2\">{{fla.st}}</div>\r\n          <div class=\"col-xs-2\" ng-class=\"{\'text-danger\' : fla.isExpired == 1}\" uib-tooltip=\"{{\'db.body.8\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-enable=\"fla.isExpired\">{{fla.et}}</div>\r\n          <div class=\"col-xs-1 text-right\" ng-if=\"auth.upermissions.flae\"><a href=\"\" role=\"link\" ng-click=\"editAssignment(fla.id)\"><span class=\"fa fa-pencil noMarR\" aria-hidden=\"true\"></span></a></div>\r\n        </div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"assignmentList.length && !filteredList.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'flEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'flDuplicate\'\">{{\'cm.btn.50\' | translate}}</span> <span ng-if=\"btn.key==\'flAssign\'\">{{\'fl.btn.5\' | translate}}</span> <span ng-if=\"btn.key==\'flApprove\'\">{{\'cm.btn.24\' | translate}}</span> <span ng-if=\"btn.key==\'flUnapprove\'\">{{\'cm.btn.25\' | translate}}</span> <span ng-if=\"btn.key==\'flDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'flaEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'flaApprove\'\">{{\'cm.btn.24\' | translate}}</span> <span ng-if=\"btn.key==\'flaUnapprove\'\">{{\'cm.btn.25\' | translate}}</span> <span ng-if=\"btn.key==\'flaDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'fllUse\'\">{{\'fl.btn.12\' | translate}}</span></div><div class=text-ellipsis-wrap>{{\'btnInfo.\'+ btn.code | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/confirmFl.html","<section class=panel role=dialog><div class=panel-body><span ng-if=\"!ngDialogData.list || ngDialogData.list.frameLayouts.length == 0\"><span ng-if=\"ngDialogData.action == \'unapprove\'\" translate=\"{{selectedItems.length > 1?\'fl.msg.8s\':\'fl.msg.8\'}}\"></span> <span ng-if=\"ngDialogData.action == \'delete\'\" translate=\"{{selectedItems.length > 1?\'fl.msg.9s\':\'fl.msg.9\'}}\"></span> </span><span ng-if=\"ngDialogData.list && ngDialogData.list.frameLayouts.length > 0\"><p class=text-bold>{{\'fl.body.1\' | translate}}</p><p ng-if=\"ngDialogData.action == \'unapprove\'\" translate=\"{{selectedItems.length.length > 1?\'fl.msg.10s\':\'fl.msg.10\'}}\"></p><p ng-if=\"ngDialogData.action == \'delete\'\" translate=\"{{selectedItems.length > 1?\'fl.msg.11s\':\'fl.msg.11\'}}\"></p><p ng-if=\"ngDialogData.action == \'move\'\" translate=\"{{selectedItems.length > 1?\'fl.msg.17s\':\'fl.msg.17\'}}\"></p><div ng-if=\"ngDialogData.list.frameLayouts.length > 0\" class=marT25>{{\'fl.body.2\' | translate}}:<div class=\"table marT5\"><div class=\"row th\"><div class=col-xs-6>{{\'fl.body.3\' | translate}}</div><div class=col-xs-6>{{\'fl.body.4\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(450)}}px><div class=row ng-repeat=\"fl in ngDialogData.list.frameLayouts\" ng-if=assignmentList><div class=\"col-xs-6 text-ellipsis\">{{fl.fl}}</div><div class=\"col-xs-6 text-ellipsis\">{{fl.fla}}</div></div></div></div></div></span><span ng-if=\"ngDialogData.action==\'category\'\">{{\"fl.msg.16\" | translate}}</span></div><footer class=panel-footer><span ng-if=\"!ngDialogData.list || ngDialogData.list.frameLayouts.length == 0\"><button type=button role=button class=\"btn btn-warning btn-sm\" ng-class=\"{\'btn-danger\': ngDialogData.action!=\'unapprove\'}\" ng-click=confirmFrameFx(); ng-disabled=flProcessing focus-me=true><span class=\"fa fa-repeat fa-spin\" ng-if=flProcessing aria-hidden=true></span>{{\'cm.btn.2\' | translate}}</button> <button type=button role=button class=\"btn btn-link btn-sm\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button> </span><span ng-if=\"ngDialogData.list.frameLayouts.length > 0\"><button type=button role=button class=\"btn btn-default btn-sm\" ng-click=closeThisDialog(); focus-me=true data-dismiss=modal>{{\'cm.btn.1\' | translate}}</button></span></footer></section>");
$templateCache.put("app/frameLayouts/popup/deviceList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-20\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"refreshObj.b && auth.upermissions.edl\" class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"openGroupDevices(\'flDevices\', deviceList, deviceRefObj.id, \'\', \'\', popupLabel);\" ng-disabled=loading><!--downloadDeviceListFx(deviceList);--> <span class=\"fa fa-download\" aria-hidden=true></span> </a><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'device\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><div class=msg-warning lang={{auth.lang}} ng-if=\"!refreshObj.l && !refreshObj.b && !allScrollDataList.length\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!refreshObj.l && allScrollDataList.length\"><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.80\' | translate}}</div></div><!-- <div class=\"scrollQuad\" ng-attr-style=\"max-height:{{getAvailableHeight(371)}}px\">\r\n        <div class=\"row\" ng-repeat=\"dl in filteredList = (deviceList | customSearch:{key:searchTextPopup, module:\'d\'})\">\r\n          <div class=\"col-xs-8 word-break\">\r\n            <span class=\"deviceStatus\" ng-class=\"dl.status == 1?\'online\':\'offline\'\" uib-tooltip=\"{{dl.status == 1?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=\"500\" tooltip-append-to-body=\"true\"></span>\r\n            {{dl.label}}</div>\r\n          <div class=\"col-xs-4 word-break\">{{dl.mac}}</div>\r\n        </div>\r\n      </div> --><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{d.id}} ng-repeat=\"d in filteredList = (visibleData)\"><div class=\"col-xs-8 text-ellipsis-wrap\"><span class=\"deviceStatus {{d.status}}\" uib-tooltip=\"{{d.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=1000></span> <span uib-tooltip={{d.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{d.l}}</span></div><div class=\"col-xs-4 text-ellipsis-wrap\"><span uib-tooltip={{d.h}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{d.h}}</span> <span class=\"text-muted text-sm\" ng-if=!d.h>N/A</span></div><!-- <div class=\"col-xs-4 text-ellipsis-wrap\">\r\n            <span class=\"fa fa-home marR5\" ng-if=\"d.path\"></span>{{d.path}}\r\n            <span class=\"text-muted text-sm\" ng-if=\"!d.path\">N/A</span>\r\n          </div> --><!-- <div class=\"col-xs-4 text-ellipsis-wrap text-sm\" ng-class=\"{\'text-danger\':d.error == \'expired\'}\">\r\n            <span uib-tooltip=\"{{\'db.body.8\' | translate}}\" tooltip-enable=\"d.error == \'expired\'\" tooltip-append-to-body=\"true\">{{d.range}}</span>\r\n            <span class=\"text-muted text-sm\" ng-if=\"!d.range\">N/A</span>\r\n          </div> --><!-- <div class=\"col-xs-2 text-ellipsis-wrap\">\r\n            {{sd.frame}}\r\n            <span class=\"text-muted text-sm\" ng-if=\"!sd.frame\">N/A</span>\r\n          </div> --></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'fl\'\" role=heading aria-level=1>{{\'fl.tool.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'fla\'\" role=heading aria-level=1>{{\'fl.tool.3\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ufl\'\" role=heading aria-level=1>{{\'fl.tool.4\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ifl\'\" role=heading aria-level=1>{{\'fl.tool.5\' | translate}}</h1></header><div class=panel-body><div ng-if=\"ngDialogData.tabName==\'fl\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'fl.info.fl1\' | translate}}</p><img alt=\"\" src=assets/images/info/fl.png></div><div ng-if=\"ngDialogData.tabName==\'fla\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'fl.info.fla1\' | translate}}</p><img alt=\"\" src=assets/images/info/fla.png></div><div ng-if=\"ngDialogData.tabName==\'ufl\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'fl.info.ufl1\' | translate}}</p><img alt=\"\" src=assets/images/info/ufl.png></div><div ng-if=\"ngDialogData.tabName==\'ifl\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'fl.info.ifl1\' | translate}}</p><img alt=\"\" src=assets/images/info/ifl.png></div></div></section>");
$templateCache.put("app/frameLayouts/popup/move.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{copyObj.sType==\'move\'?\'cl.p_m.4\':\'cl.p_m.5\' | translate}}</h1></header><div class=panel-body><div class=\"panel-inner-tab marB10\" ng-if=\"authServer.length > 1\"><a href=\"\" ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');\">{{\'cl.p_m.2\' | translate}}</a> <a href=\"\" ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');\">{{\'cl.p_m.3\' | translate}}</a></div><div class=\"form-group marT10\"><!-- <label for=\"action\">{{\'cm.label.25\' | translate}}</label> --><div id=action class=\"bg-light pad5\"><label class=\"noMarB marR10\"><input type=radio name=subOpt ng-model=copyObj.sType value=copy ng-change=changeTypeFx()><label></label>{{\'cl.p_m.5\' | translate}}</label><label ng-if=\"selectedT==\'2\'\" class=noMarB><input type=radio name=subOpt ng-model=copyObj.sType value=move ng-change=changeTypeFx()><label></label>{{\'cl.p_m.4\' | translate}}</label></div></div><img alt=Loading src=assets/images/loading.gif ng-if=listLoading><div ng-if=\"!listLoading && selectedT==\'2\'\"><div class=\"form-group noMarB\"><label>{{\'cl.p_m.7\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick is-open=status.isopen><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle><span ng-if=!copyObj.server.label>{{\'cl.p_m.7\' | translate}}</span> <span ng-if=copyObj.server.label>{{copyObj.server.label}}</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\" ng-show=\"serverList.length>5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\"></span></a></div></li><li class=divider ng-if=\"serverList.length>5\"></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"server in filteredSList = (serverList | filter:searchList) | orderBy:\'label\'\" tabindex=$index><label><input type=radio name=serverOpt ng-value=server ng-checked=\"server.id == copyObj.server.id\" ng-model=copyObj.server ng-change=\"changeServerFx();status.isopen=false\"><label></label>{{server.label}}</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div></div><div class=\"marT15 errMsg\" ng-if=fcError><p><span ng-if=\"copyObj.sType == \'move\'\">{{\'cl.p_m.m3\' | translate}}:</span> <span ng-if=\"copyObj.sType == \'copy\'\">{{\'cl.p_m.m4\' | translate}}:</span></p><div ng-if=fcError><span class=\"fa fa-circle valign-middle text-xs marR5\"></span>{{\'cl.p_m.m12\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button ng-click=confirmDuplicateFx(); class=\"btn btn-success\" ng-disabled=\"fcError || flProcessing\"><span class=\"fa fa-check\" ng-if=!flProcessing aria-hidden=true></span> <span class=\"fa fa-repeat fa-spin\" ng-if=flProcessing aria-hidden=true></span> <span ng-if=\"copyObj.sType == \'move\'\">{{\'cl.p_m.4\' | translate}}</span> <span ng-if=\"copyObj.sType == \'copy\'\">{{\'cl.p_m.5\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog();>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType == \'server\'\" aria-live=polite role=status>{{\'cl.p_m.m2\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/selectFolder.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'fl.p_assign.body.10\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=treeLoading><div ng-if=!treeLoading><div ng-if=!folderList class=msg-warning lang={{auth.lang}}>{{\'fl.p_assign.msg.7\' | translate}}</div><div class=\"bg-light moveTreeContainer\" ng-if=folderList><div><label><input type=radio role=radio name=treeOpt value=0 checked><label></label>{{\'fl.p_assign.body.9\' | translate}}</label><tree list=folderList check-disable=false selectednode=ngDialogData.folder class=\"list-unstyled moveTree\"></tree></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=selectRestrictedFolder(ngDialogData.frame); ng-disabled=\"!folderList || selectProcessing\"><span class=\"fa fa-check\" ng-if=!selectProcessing aria-hidden=true></span><span class=\"fa fa-repeat fa-spin\" ng-if=selectProcessing aria-hidden=true></span>{{\'fl.p_assign.body.11\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/selectGroups.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'fl.p_group.1\' | translate}}</h1></header><div class=row><div ng-class=\"ngDialogData.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{users.users.length?\'cm.label.21s\':\'cm.label.21\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{ngDialogData.tabHeight}}px;><img alt=Loading src=assets/images/loading.gif ng-if=groupListLoading><div class=row ng-if=\"!groupListLoading && users.users.length > 0\"><div class=col-xs-12><ul class=\"list-inline thumb-list\"><ng-user-list class=show selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=users.users></ng-user-list></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!groupListLoading && users.users.length == 0\">{{\'fl.p_group.m1\' | translate}}</div></div></div></div><div ng-class=\"ngDialogData.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=\"selectedQuad panel-body\"><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{ngDialogData.groups.length > 1?\'fl.p_group.2s\':\'fl.p_group.2\' | translate}}</div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{ngDialogData.selectedHeight}}px;><div ng-if=\"ngDialogData.groups.length > 0\"><div class=\"thumb-list hoverContainer\"><li ng-repeat=\"group in selectedFilteredGroups = (ngDialogData.groups | filter:selectedSearchText)\" data-id={{group.id}} class=device><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=closeFilteredFx(group.id)><span class=\"fa fa-times-circle\"></span></a><div class=thumb-inner><img alt=\"\" ng-if=\"myTheme.clientTheme == \'\'\" ng-src=assets/images/default/user_group.png class=img-user> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" ng-src=../theme/{{domainName}}/user_group.png class=img-user></div><div class=thumb-label><span uib-tooltip={{group.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{group.label}}</span></div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedFilteredGroups.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"ngDialogData.groups.length == 0\">{{\'cm.msg.4\' | translate}}</div></div></section></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"selectRestrictedGroups(ngDialogData.frame, ngDialogData.groups);\" ng-disabled=selectProcessing><span class=\"fa fa-check\" ng-if=!selectProcessing aria-hidden=true></span><span class=\"fa fa-repeat fa-spin\" ng-if=selectProcessing aria-hidden=true></span>{{\'fl.p_assign.body.11\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeGroupPopup(ngDialogData.frame); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/frameLayouts/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName==\'fl\'\" role=heading aria-level=1>{{\'fl.info.v1\' | translate}}</h1></header><div class=video-body><iframe width=560 height=315 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/reports/popup/info.html","<section class=panel role=dialog><header class=panel-heading><span ng-if=\"ngDialogData.tabName==\'cc\'\" role=heading aria-level=1>{{\'r.tool.1.1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'cs\'\" role=heading aria-level=1>{{\'r.tool.1.2\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'pp\'\" role=heading aria-level=1>{{\'r.tool.1.3\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'ds\'\" role=heading aria-level=1>{{\'r.tool.2.1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'hg\'\" role=heading aria-level=1>{{\'r.tool.2.2\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'ir\'\" role=heading aria-level=1>{{\'r.tool.2.5\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'od\'\" role=heading aria-level=1>{{\'r.tool.2.3\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'op\'\" role=heading aria-level=1>{{\'r.tool.2.4\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'dst\'\" role=heading aria-level=1>{{\'r.tool.2.6\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'poh\'\" role=heading aria-level=1>{{\'r.tool.2.7\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'hpp\'\" role=heading aria-level=1>{{\'r.tool.1.3\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'hk\'\" role=heading aria-level=1>{{\'r.tool.2.8\' | translate}}</span></header><div class=panel-body role=heading aria-level=1><span ng-if=\"ngDialogData.tabName==\'cc\'\"></span> <span ng-if=\"ngDialogData.tabName==\'cs\'\"></span> <span ng-if=\"ngDialogData.tabName==\'pp\'\" lang={{auth.lang}}>{{\'r.info.pp1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'ds\'\" lang={{auth.lang}}>{{\'r.info.ds1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'hg\'\"></span> <span ng-if=\"ngDialogData.tabName==\'od\'\"></span> <span ng-if=\"ngDialogData.tabName==\'op\'\"></span> <span ng-if=\"ngDialogData.tabName==\'dst\'\" lang={{auth.lang}}>{{\'r.info.dst1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'poh\'\" lang={{auth.lang}}>{{\'r.info.poh1\' | translate}}</span> <span ng-if=\"ngDialogData.tabName==\'hpp\'\" lang={{auth.lang}}>{{\'r.info.hpp\' | translate}}</span><div ng-if=\"ngDialogData.tabName!=\'dst\' && ngDialogData.tabName!=\'poh\'\" class=marT25 role=img><img alt=\"\" src=assets/images/info/r.png></div><div ng-if=\"ngDialogData.tabName==\'dst\'\" class=marT25 role=img><img alt=\"\" src=assets/images/info/dst.png></div><span ng-if=\"ngDialogData.tabName==\'hk\'\"></span></div></section>");
$templateCache.put("app/reports/popup/selectContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'r.body.2\' | translate}}</h1></header><div class=panel-body><div class=row><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=\"advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)\" class=\"col-xs-12 noPad marB10\"></advanced-search>{{viewType = (uPreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'r\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.pText sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.pText.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{contentObj.quadHeight}}px;><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4) ?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div class=\"pad5 msg-success marB10\" ng-if=\"contentLibrary.info.ef || (odSp.auth && odSp.curType==\'ExcelFolder\')\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.gd || (odSp.auth && odSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><ul class=\"list-inline thumb-list\" ng-if=\"!contentLibraryLoading && uPreferences.contentView == \'t\'\" element-height=contentObj.quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLibraryLoading && uPreferences.contentView == \'l\'\" element-height=contentObj.quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div><div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad><div class=pull-right><label for=scSearch class=\"lableHidden absolute\">search</label><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text id=scSearch ng-model=selectedSearchText sanitize-input class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} [ {{reportSelectedItems.content.length}} ]</div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{contentObj.selectedHeight}}px;><div ng-if=\"reportSelectedItems.content.length > 0\"><div class=\"thumb-list hoverContainer\" ng-if=\"uPreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (reportSelectedItems.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=device><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=closeFilteredFx(content.id)><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':content.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png?v7 class=\"img-responsive center-block img-widget\"><!-- Web Page Widget--> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss\" ng-href=\"{{cDetailBucket + content.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside caption={{content.label}}><img alt={{content.type}} ng-src=\"{{tim + cBucket + content.ssImg +\'?v\'+ timestamp + thumbParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis w100px marT4\" uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{content.label}}</div></div></li></div><ul class=\"table table-md list-unstyled\" ng-if=\"uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in selectedFilteredContent = (reportSelectedItems.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-if=!cl.hidden><div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=col-xs-4>{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div><div class=\"col-xs-2 text-right\"><a href=\"\" class=text-danger ng-click=closeFilteredFx(cl.id); uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"reportSelectedItems.content.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"reportSelectedItems.content.length > 0 && (reportSelectedItems.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); focus-me=true data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/reports/popup/selectDevice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'r.body.1\' | translate}}</h1></header><div class=row><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo class=col-xs-12 ng-if=isAdvSearch></advanced-search><div ng-class=\"deviceObj.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=panel-body><div class=\"customHeader advSearch\"><div class=\"pull-right marRL10 filterIcon\" ng-if=!isGbdt uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || deviceListLoading}\"><!-- <a href=\"\" id=\"filter\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\"><span class=\"glyphicon glyphicon-filter\"></span></a> --> <a href=\"\" id=filter uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.2\' | translate}}\" tooltip-append-to-body=true ng-class=\"{\'active\': (filterType==\'online\'||filterType==\'offline\')}\" ng-disabled=\"isPageApiLoad || deviceListLoading\"><span class=\"glyphicon glyphicon-filter\" ng-class=\"{\'filter-highlighted\':(filterType==\'online\'||filterType==\'offline\')}\"></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu id=filter-select><li ng-class=\"{\'selected\': filterType == \'online\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'online\')\">{{\'d.tool.1\' | translate}}</a></li><li ng-class=\"{\'selected\': filterType == \'offline\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'offline\')\">{{\'d.tool.2\' | translate}}</a></li><li class=divider></li><li ng-class=\"{\'selected\': filterType == \'\',\'disabled\':(!isObjectEmpty(advSearchInfo))}\"><a href=\"\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.tool.2.1\' | translate}}</a></li></ul></div><div class=pull-right uib-dropdown ng-class=\"{\'cursorDisabled\':isPageApiLoad || showRemainingList}\"><a href=\"\" role=link id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle ng-disabled=\"isPageApiLoad || showRemainingList\"><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link id=advSearch ng-click=\"advancedSearchOpen(\'r\', \'r\');\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link id=deviceView ng-click=\"preferencesFx(\'deviceView\'); devicePreviewFx()\" ng-if=!deviceTypes.types.length>{{deviceViewText}}</a></li><li><a href=\"\" role=link id=selectAll ng-click=\"checkboxFx(\'all\'); selectAllSDFx(); selectedSearch.text=\'\'\" ng-if=!deviceTypes.types.length>{{\'cm.btn.44\' | translate}}</a></li></ul></div><div class=pull-right><label for=adSearch class=\"lableHidden absolute\">search</label><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=\"form-control input-sm\" id=adSearch ng-model=searchTextR.text sanitize-input maxlength=250 ng-change=\"searchChangeFx(\'\', searchTextR.text)\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" ng-disabled=isPageApiLoad autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextR.text.length ng-click=\"searchChangeFx(\'empty\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=panel-inner-tab>{{devices.devices.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{deviceObj.quadHeight}}px; ng-scroll=timerFxToLoadData();><div ng-if=\"!deviceListLoading && deviceTypes.types.length > 0\"><ul class=\"list-inline thumb-list dType-list\" ng-if=!breadCrumbs.length><div class=dtUnselect ng-click=unselectTypeFx()></div><li ng-repeat=\"type in filteredDTypes = (deviceTypes.types | customSearch:{key:searchText, module:\'d\'})\" ng-click=\"selectTypeFx($event, type);\" ng-dblclick=\"openTypeFx(type, 0);\" data-type=\"{{type.type | lowercase}}\" context-menu=contextMenuOpt><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_selected_{{type.type}}.png></span></div><div class=thumb-label>{{type.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && deviceTypes.types.length && !filteredDTypes.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul></div><!-- {{breadCrumbs.length}} --><div ng-if=\"!deviceListLoading && breadCrumbs.length\" class=breadcrumb><!-- <a href=\"\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\"></span></a> --> <a href=\"\" role=link ng-if=\"!auth.upermissions.dgrp.dgrp || (auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\" ng-click=\"getTypesFx(\'home\');\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <a href=\"\" role=link ng-if=\"auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\" ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\"></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><!-- <a href=\"\" ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last\">{{breadcrumb.label}}</a> --> <a href=\"\" role=link ng-click=\"openTypeFx(breadcrumb.type, 0);\" ng-if=\"!$last && (!auth.upermissions.dgrp.dgrp || auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'dt\')\">{{breadcrumb.label}}</a> <a href=\"\" role=link ng-click=folderContentFx(breadcrumb.id); ng-if=\"!$last && auth.upermissions.dgrp.dgrp && auth.upermissions.dgrp.type==\'df\'\">{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span>{{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=deviceListLoading><div><span ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'t\'\"><ul class=\"list-inline thumb-list\" element-height=deviceObj.quadHeight><ng-device-thumb class=show selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\"></ng-device-thumb></ul></span><div class=row ng-if=\"!deviceListLoading && (devices.devices.length || devices.folders.length) > 0 && auth.upreferences.deviceView == \'l\'\"><ng-device-list class=\"table table-md whiteRow\" selectable=selection selectable-list=\"devices.devices | filter:searchText\" selectable-options=\"{filter:\'li\', cancel:\'input,button,.nonSelectable\'}\"></ng-device-list></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && devices.folders.length == 0 && !isSearchMsg && !isFilterMsg && !isAdvSearchMsg\">{{\'d.msg.1\' | translate}}</div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && !devices.devices.length && !deviceTypes.types.length && advSearchInfo.isEmpty && rFilter ==\'all\'\">{{\'as.msg.2\' | translate}}</div>\r\n          <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"!deviceListLoading && fCount.length == 0 && rFilter !=\'all\'\">{{\'cm.msg.15\' | translate}} <button type=\"button\" role=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div> --><!-- this msg for filter --><div class=msg-warning lang={{auth.lang}} ng-if=\"isFilterMsg && !deviceListLoading\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterUpdateFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div><!-- this msg for search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isSearchMsg && !deviceListLoading\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextR.text)}}&quot;</b>\'}\"></div><!-- this msg for adv search --><div class=msg-warning lang={{auth.lang}} ng-if=\"isAdvSearchMsg && !deviceListLoading\">{{\'as.msg.2\' | translate}}</div></div></div></div><div ng-class=\"deviceObj.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=\"selectedQuad panel-body\"><div class=\"customHeader advSearch\"><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"removeFilteredFx(\'all\'); closeAllFx(); selectedSearch.text=\'\'\">{{\'cm.btn.45\' | translate}}</a></li></ul></div><div class=pull-right><label for=sdSearch class=\"lableHidden absolute\">search</label><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text id=sdSearch ng-model=selectedSearch.text sanitize-input ng-change=resetSelPagination() class=form-control placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearch.text.length ng-click=\"selectedSearch.text=\'\';resetSelFx(); resetSelPagination()\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=panel-inner-tab>{{reportSelectedItems.devices.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate}} [ {{reportSelectedItems.devices.length}} ]</div><!-- {{copySelDevice.length}} --> <img alt=Loading class=pad10 src=assets/images/loading.gif ng-if=firstDeviceLoading><section class=noMarB ng-if=!firstDeviceLoading><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{deviceObj.selectedHeight}}px;><div ng-if=\"reportSelectedItems.devices.length > 0\">{{selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}:true);\"\"}}<div class=\"fw6 padB24\" ng-if=\"(reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}).length > 0\" ng-class=\"{\'bdr-btm-dashed marT10\':auth.upreferences.deviceView == \'t\', \'hide\':reportSelectedItems.devices.length<=auth.upreferences.dpc || selectedFilteredDevices.length<=auth.upreferences.dpc}\"><div class=\"pull-right marT-15 nonSelectable\" ng-class=\"{\'noMar\':auth.upreferences.deviceView == \'l\'}\"><div class=other-controller><div class=\"d-flex align-items-center nonSelectable\" ng-class=\"{\'marT5\':auth.upreferences.deviceView==\'t\'}\"><dir-pagination-controls-clone boundary-links=selPaginationControls.boundaryLinks max-size=selPaginationControls.maxSize on-page-change=selPageChangeHandler(newPageNumber) max-page=totalDPages load-more=isPageApiLoad></dir-pagination-controls-clone></div></div></div></div><div class=\"thumb-list hoverContainer\" ng-if=\"auth.upreferences.deviceView == \'t\'\"><li dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} class=device><!-- <li ng-repeat=\"device in selectedFilteredDevices = (reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}) track by device.id\" data-id=\"{{device.id}}\"> --><div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=closeFilteredFx(device.id)><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner ng-class=\"{\'thumb-device\': (device.t != 7)}\"><a ng-class=\"{\'thumb-device\': (device.t != 7)}\" ng-if=\"device.tv != undefined && device.tv != 0\" ng-href=\"{{dDetailBucket + (device.h | removeColon) + \'.jpg\' | secureThumb:device.tv}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{device.l}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + (device.h | removeColon) + \'.jpg&\' + device.tv + dThumbParam}}\" src-error=assets/images/default/device_{{device.t}}.png> </a><img alt=\"\" ng-if=\"device.tv != undefined && device.tv == 0\" src=assets/images/default/device_{{device.t}}.png><!-- <span class=\"device-thumb-icon status {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-popup-delay=\"500\"></span> --> <span class=\"thumb-icon status\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-popup-delay=500><span class={{device.status}}></span></span></span></div><!-- <div class=\"thumb-label\">{{device.l}}</div> --><div class=\"text-ellipsis w100px marT5\" uib-tooltip={{device.l}} tooltip-class=tooltip-break tooltip-class=tooltip-break tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{device.l}}</div></div></li><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{selectedSearch.text.label}}&quot;</b>\'}\"></div>\r\n                <fancybox box-for=\"[rel=fb_group]\" options=\"fbGroup\"></fancybox> --></div><ul class=\"list-inline multiple-selected\" ng-if=\"auth.upreferences.deviceView == \'l\'\" ng-class=\"{\'marT10\':reportSelectedItems.devices.length>auth.upreferences.dpc}\"><!-- device list view --><div class=\"table table-md whiteRow\" ng-class=\"{\'hide\':selectedFilteredDevices.length == 0}\"><div class=\"row th\"><div class=col-xs-7>{{\'cm.brief.1\' | translate | camelCase}}</div><div class=col-xs-4>{{\'d.label.2\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.69\' | translate}}</div> --><div class=\"col-xs-1 text-right noPadL\">{{\'cm.label.25\' | translate}}</div></div><!-- device list --><li class=row dir-paginate-clone=\"device in selectedFilteredDevices = ((reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}) | itemsPerPageClone:selPaginationControls.pageSize) track by device.id\" data-id={{device.id}} data-type=device data-sub-type={{device.type}} ng-if=\"reportSelectedItems.devices.length > 0\"><div class=\"col-xs-7 text-ellipsis\"><!-- <span class=\"deviceStatus {{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot};}}\" uib-tooltip=\"{{device.lp | isDeviceOnline:{minDeduct: auth.upreferences.dot} | capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> <span class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span> {{device.l}}</div><div class=\"col-xs-4 text-ellipsis\">{{device.h}}</div><!-- <div class=\"col-xs-2\">{{\'cm.label.4\' | translate}}</div> --><div class=\"col-xs-1 text-right\"><a href=\"\" class=text-danger uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true ng-click=closeFilteredFx(device.id)><span class=\"fa fa-remove\"></span></a></div><!-- <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"selectedFilteredDevices.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{selectedSearch.text.label}}&quot;</b>\'}\"></div> --></li></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"reportSelectedItems.devices.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"reportSelectedItems.devices.length > 0 && (reportSelectedItems.devices | customSearch:{key:selectedSearch.text, module:\'dSelOp\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearch.text)}}&quot;</b>\'}\"></div></div></section></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); focus-me=true data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/dir/button-list.html","<span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=backBtn(); ng-if=permission.isBack ng-disabled=\"info.sc || info.sp\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</button><!-- {{info.isc && permission.step != \'f\' && !info.other}} / {{info}} --> <button type=button role=button class=\"btn btn-success\" ng-click=saveCallback(); ng-if=\"info.isCompleted && permission.step != \'f\' && !info.other && permission.nextStep != \'\'\" ng-disabled=\"info.sc || info.sp\"><span class=fa ng-class=\"!info.sc?\'fa-check\':\'fa-repeat fa-spin\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button><!--For Music player devices --> <button type=button role=button class=\"btn btn-success\" ng-click=saveCallback(); ng-if=\"permission.step != \'f\' && info.other && !info.ls\" ng-disabled=\"info.sc || info.sp\"><span class=fa ng-class=\"!info.sc?\'fa-check\':\'fa-repeat fa-spin\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button><!-- added this button for incomplete schedule --><!-- (!permission.f || !info.ls) --> <button type=button role=button class=\"btn btn-success\" ng-click=saveCallback(); ng-if=\"!info.isCompleted && info.onceCompleted && permission.step != \'f\' && (permission.nextStep != \'\')\" ng-disabled=\"info.sc || info.sp\"><span class=fa ng-class=\"!info.sc?\'fa-check\':\'fa-repeat fa-spin\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button><!-- Applied Device List --> <button type=button role=button class=\"btn btn-info\" ng-click=appliedDeviceList(); ng-if=\"permission.step == \'d\' && permission.appliedDeviceBtn\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span> {{\'s.p_s.btn.6\' | translate}}</button><!-- {{info}} // {{permission}} --><!-- {{info}} --> <button type=button role=button class=\"btn btn-primary\" ng-click=nextCallback(); ng-if=\"permission.b && permission.step != \'f\' && !info.other && !info.ls\" ng-disabled=\"info.sc || info.sp\"><span class=\"fa fa-repeat fa-spin\" ng-if=info.sp aria-hidden=true></span>{{\'cm.btn.12\' | translate}}: <span ng-if=permission.c>{{\'cm.label.32\' | translate | camelCase}}</span><span ng-if=permission.d>{{\'cm.label.31\' | translate | camelCase}}</span><span ng-if=permission.s>{{\'cm.label.36\' | translate | camelCase}}</span><span ng-if=permission.f>{{\'s.p_s.body.3\' | translate | camelCase}}</span><span class=\"fa fa-chevron-right\" ng-if=!info.sp aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-success\" ng-click=saveCallback(); ng-if=\"permission.step == \'f\' && info.other || (info.isCompleted == 0 && info.ls || !info.ls && permission.nextStep == \'\' || info.isCompleted == 1 && permission.nextStep == \'\')\" ng-disabled=\"info.sc || info.sp\"><span class=fa ng-class=\"info.sc?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{info.sc?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-click=nextSelect(); ng-if=\"permission.step == \'f\' && !info.other\" ng-disabled=\"info.sc || info.sp\">{{\'cm.btn.12\' | translate | camelCase}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-link\" ng-click=cancelFx(); ng-disabled=\"info.sc || info.sp\">{{\'cm.btn.9\' | translate}}</button> </span>");
$templateCache.put("app/schedules/dir/scheduleBrief.html","<div class=selectedQuad><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><div class=panel-heading><h2>{{selectedItems.length > 1?\'s.brief.1s\':\'s.brief.1\' | translate}}</h2><span class=marL5>[ {{selectedItems.length}} ]</span><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=closeAllFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\':pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></div><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-show=detailLoading><div ng-if=\"selectedItems.length == 1\">{{curSchedule = (schedules.s | filter:{id:selectedItems[0].id}:true | orderBy: \'id\');\"\"}}<!-- {{curSchedule}} --><ul class=\"list-unstyled single-selected\" ng-hide=detailLoading><div class=row><div class=col-xs-3><div class=thumb-highlight><!-- Incomplete --> <img alt=\"\" ng-if=!curSchedule[0].t src=assets/images/default/incomplete.png class=\"noOutline img-responsive center-block img-incomplete\"><!-- Audio --> <a ng-if=\"curSchedule[0].t == \'Audio\'\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"curSchedule[0].t == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l, curSchedule[0].dimension);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"curSchedule[0].t == \'Widget\' && curSchedule[0].extn != \'YouTube\' && curSchedule[0].extn != \'Web Page\' && curSchedule[0].extn != \'Auto Login (Basic Auth)\'\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png?v7\" class=\"img-responsive center-block img-widget\"><!-- Web Page Widget--> <img alt=\"\" ng-if=\"curSchedule[0].t == \'Widget\' && (curSchedule[0].extn == \'Web Page\' || curSchedule[0].extn == \'Auto Login (Basic Auth)\') && !curSchedule[0].ss\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png?v7\" class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"curSchedule[0].t == \'Widget\' && (curSchedule[0].extn == \'Web Page\' || curSchedule[0].extn == \'Auto Login (Basic Auth)\') && curSchedule[0].ss\" ng-href=\"{{cDetailBucket + curSchedule[0].ssImg | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt={{curSchedule[0].t}} ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].ssImg + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a ng-if=\"curSchedule[0].t == \'Image\'\" ng-href=\"{{cDetailBucket + curSchedule[0].th | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube --> <a ng-if=\"curSchedule[0].t == \'Widget\' && curSchedule[0].extn == \'YouTube\'\" ng-href={{curSchedule[0].url}} role=link fancyboxable=fbMedia caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + curSchedule[0].th}}\" class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"curSchedule[0].t == \'Video\' && curSchedule[0].th != \'\'\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l);\"><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"curSchedule[0].t == \'template\'\" ng-href=\"{{tDetailBucket + curSchedule[0].th | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + tim + tBucket + curSchedule[0].th + thumbBigParam + \'&\' + curSchedule[0].thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"curSchedule[0].t && curSchedule[0].t != \'Image\' && curSchedule[0].t != \'Widget\' && curSchedule[0].t != \'Video\' && curSchedule[0].t != \'Audio\' && curSchedule[0].t != \'Flash\' && curSchedule[0].t != \'template\'\" ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"curSchedule[0].t && curSchedule[0].th == \'\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Label --><div class=\"text-ellipsis marT5\" uib-tooltip={{curSchedule[0].l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curSchedule[0].l}}</div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curSchedule[0].l}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.49\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curSchedule[0].isc>{{\'cm.label.17\' | translate}}</span> <span ng-if=!curSchedule[0].isc>{{\'s.brief.2\' | translate}}</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curSchedule[0].co>{{(curSchedule[0].co * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=\"curSchedule[0].co == null\" class=\"text-muted text-sm\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.10\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curSchedule[0].sd>{{curSchedule[0].sd}}</span> <span ng-if=\"curSchedule[0].sd == null\" class=\"text-muted text-sm\">N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"scheduleBrief != \'\' && scheduleBrief.cb\">{{scheduleBrief.cb}}</span> <span class=\"text-muted text-sm\" ng-if=\"scheduleBrief != \'\' && scheduleBrief.cb == null\" class=\"text-muted text-sm\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"scheduleBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.11\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curSchedule[0].ed>{{curSchedule[0].ed}}</span> <span ng-if=\"curSchedule[0].ed == null\" class=\"text-muted text-sm\">N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"scheduleBrief != \'\' && scheduleBrief.eo\">{{(scheduleBrief.eo * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link id=editHistory class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curSchedule[0].id, \'schedule\', curSchedule[0].l);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"scheduleBrief != \'\' && !scheduleBrief.eo\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"scheduleBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.11\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curSchedule[0].dc}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"curSchedule[0].dc > 0\" ng-click=\"deviceListFx(curSchedule[0].id, curSchedule[0].l);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{scheduleBrief.eb}} <span class=\"text-muted text-sm\" ng-if=\"scheduleBrief != \'\' && !scheduleBrief.eb\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"scheduleBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.9\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curSchedule[0].cc}} <button type=button role=button class=\"btn btn-xs btn-default\" ng-if=\"curSchedule[0].cc > 0\" ng-click=\"contentListFx(curSchedule[0].id, curSchedule[0].l);\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row ng-if=\"selectedTab != \'hub.schedules.us\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curSchedule[0].ao>{{(curSchedule[0].ao * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curSchedule[0].ao == null\">N/A</span></div></div></div><div class=row ng-if=\"selectedTab != \'hub.schedules.us\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"scheduleBrief != \'\' && scheduleBrief.ab\">{{scheduleBrief.ab}}</span> <span class=\"text-muted text-sm\" ng-if=\"scheduleBrief != \'\' && scheduleBrief.ab == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"scheduleBrief == \'\'\"></div></div></div></div></div></div></ul></div><!--For Multiple selected--><div ng-if=\"selectedItems.length > 1\"><div class=\"thumb-list hoverContainer\" aria-labelledby=select><li ng-repeat=\"schedule in selectedItems\" data-id={{schedule.id}} class=\"device valign-top\">{{curSchedule = (schedules.s | filter:{id:selectedItems[$index].id}:true | orderBy: \'id\');\"\"}}<div class=\"relative padT4\"><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=closeFx(schedule.id)><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner><!-- Incomplete --> <img alt=\"\" ng-if=!curSchedule[0].t src=assets/images/default/incomplete.png class=\"noOutline img-responsive center-block img-incomplete\"><!-- Audio --> <a ng-if=\"curSchedule[0].t == \'Audio\'\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"curSchedule[0].t == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l, curSchedule[0].dimension);\"><img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png\" class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"curSchedule[0].t == \'Widget\' && curSchedule[0].extn != \'YouTube\' && curSchedule[0].extn != \'Web Page\' && curSchedule[0].extn != \'Auto Login (Basic Auth)\'\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png?v7\" class=\"img-responsive center-block img-widget\"><!-- Web Page Widget--> <img alt=\"\" ng-if=\"curSchedule[0].t == \'Widget\' && (curSchedule[0].extn == \'Web Page\' || curSchedule[0].extn == \'Auto Login (Basic Auth)\') && !curSchedule[0].ss\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{curSchedule[0].th}}.png?v7\" class=\"img-responsive center-block img-widget\"> <a href=\"\" role=link ng-if=\"curSchedule[0].t == \'Widget\' && (curSchedule[0].extn == \'Web Page\' || curSchedule[0].extn == \'Auto Login (Basic Auth)\') && curSchedule[0].ss\" ng-href=\"{{cDetailBucket + curSchedule[0].ssImg | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt={{curSchedule[0].t}} ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].ssImg + thumbBigParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Images --> <a ng-if=\"curSchedule[0].t == \'Image\'\" ng-href=\"{{cDetailBucket + curSchedule[0].th | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube --> <a ng-if=\"curSchedule[0].t == \'Widget\' && curSchedule[0].extn == \'YouTube\'\" ng-href={{curSchedule[0].url}} role=link fancyboxable=fbMedia caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + curSchedule[0].th}}\" class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"curSchedule[0].t == \'Video\' && curSchedule[0].th != \'\'\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + curSchedule[0].url, curSchedule[0].l);\"><img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"curSchedule[0].t == \'template\'\" ng-href=\"{{tDetailBucket + curSchedule[0].th | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curSchedule[0].l}}><img alt=\"\" ng-src=\"{{thumbHost + tim + tBucket + curSchedule[0].th + thumbBigParam + \'&\' + curSchedule[0].thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"curSchedule[0].t && curSchedule[0].t != \'Image\' && curSchedule[0].t != \'Widget\' && curSchedule[0].t != \'Video\' && curSchedule[0].t != \'Audio\' && curSchedule[0].t != \'Flash\' && curSchedule[0].t != \'template\'\" ng-src=\"{{tim + cBucket + curSchedule[0].th + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"curSchedule[0].t && curSchedule[0].th == \'\'\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"></span></div><div class=\"thumb-label noMar\" uib-tooltip={{curSchedule[0].l}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curSchedule[0].l}}</div></div></li></div></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=\"scheduleBtn.length==0\"> <a href=\"\" role=link class=\"pull-left marT6\" ng-click=btnInfoOpen(scheduleBtn.info); ng-if=scheduleBtn.info.length><img alt=\"\" src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"scheduleBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=scheduleBtn><li ng-repeat=\"sBtn in scheduleBtn.buttons\"><div ng-if=\"sBtn.key==\'sEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ng-click=editSchedule(); class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in sBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'sStep1\'\" ui-sref=\"hub.sContainer.sName({type: encType, id: encId})\">{{\'cm.brief.1\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'sStep2\'\" ui-sref=\"hub.sContainer.sSchedule({type: encType, id: encId})\">{{\'cm.label.3\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'sStep3\'\" ui-sref=\"hub.sContainer.sContent({type: encType, id: encId})\">{{\'cm.label.1\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'sStep4\'\" ui-sref=\"hub.sContainer.sDevice({type: encType, id: encId})\">{{\'cm.label.4\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'sStep5\'\" ui-sref=\"hub.sContainer.sFrame({type: encType, id: encId})\">{{\'s.body.4\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"sBtn.key==\'sAssignToGroup\'\" ng-click=\"assignToGrpOpen(scheduleBrief.id, scheduleBrief.gid);\" class=\"btn btn-success\"><span class=\"fa fa-calendar\" aria-hidden=true></span>{{\'s.btn.3\' | translate}}</button> <button type=button role=button ng-if=\"sBtn.key==\'sApprove\'\" ng-click=approveFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</button> <button type=button role=button ng-if=\"sBtn.key==\'sUnapprove\'\" ng-click=\"confirmOpen(\'unapprove\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</button> <button type=button role=button ng-if=\"sBtn.key==\'sDelete\'\" ng-click=\"confirmOpen(\'delete\');\" tooltip-append-to-body=true class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"sBtn.key==\'sPin\'\" ng-click=\"pinToDBFx(selectedItems[0],\'s\');\" class=\"btn btn-default\"><span class=\"fa fa-thumb-tack\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</button></li></ul></div></section></div>");
$templateCache.put("app/schedules/dir/schedulesList.html","<div class=\"table table-md dTable\" role=table><div class=\"row th\" ng-if=\"schedules.g.length > 0 || schedules.s.length > 0\"><div class=col-xs-4 ng-class=\"{\'col-xs-5\': selectedTab != \'hub.schedules.s\'}\">{{\'s.body.1\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.7\' | translate | camelCase}}</div><div class=col-xs-2>{{\'cm.label.69\' | translate}}</div><div class=col-xs-1>{{\'cm.label.49\' | translate}}</div><div class=\"col-xs-1 noPadL text-right\">{{\'cm.label.1\' | translate}}</div><div class=\"col-xs-1 noPadL text-right\">{{\'cm.label.4s\' | translate}}</div><div class=\"col-xs-1 text-right\" ng-if=\"selectedTab == \'hub.schedules.s\'\">{{\'cm.label.25\' | translate}}</div></div><ul id=schedule-list><div class=folderQuad ng-repeat=\"s in scheduleGroup = schedules.g\" ng-if=schedules.g>{{curGrpSchedule = (schedules.s | sameValue:([s.gid, \'sg\']));\"\"}}<!--Folder--><div class=nonSelectable ng-if=s.l><span ng-if=\"selectedTab == \'hub.schedules.s\' || (selectedTab !== \'hub.schedules.s\' && curGrpSchedule.length > 0)\"><div class=folder-heading data-id={{s.id}} ng-class=\"{\'text-muted\':!s.isa}\"><div class=\"col-xs-11 text-bold text-ellipsis folder\" ng-class=\"{\'col-xs-12\': selectedTab != \'hub.schedules.s\'}\" ng-click=folderFx($event); data-id={{s.id}}><a href=\"\" role=link><span class=\"fa fa-folder marR5\" aria-hidden=true></span>{{s.l}} <span class=\"text-muted text-unbold text-sm\">({{curGrpSchedule.length}})</span></a></div><div class=\"col-xs-1 text-right\" ng-if=\"selectedTab == \'hub.schedules.s\'\"><a href=\"\" role=link id=sEdit{{$index}} class=\"text-primary marR5\" ng-if=auth.upermissions.sge ng-click=\"groupCUOpen(s.id, s.l, s.p);\"><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link id=sDelete{{$index}} class=text-danger ng-if=\"(auth.upermissions.sgd && auth.upermissions.sar) || (auth.upermissions.sgd && !auth.upermissions.sar &&  curGrpSchedule.length == 0)\" ng-click=\"confirmOpen(\'group\', s.id);\"><span class=\"fa fa-close\" aria-hidden=true></span></a></div></div></span></div><div class=\"folder-content hide\"><li class=row ng-repeat=\"cgs in curGrpSchedule\" data-id={{cgs.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!cgs.isa}\"><div class=panel-body><div class=\"col-xs-4 text-ellipsis\" ng-class=\"{\'col-xs-5\':selectedTab != \'hub.schedules.s\'}\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-click=\"checkboxFx($event, cgs.id);\" role=checkbox><label></label><button class=\"btn btn-link noPad\" ng-click=\"readMeFx(\'partialSch\')\"><span class=\"fa fa-warning text-warning noMarR\" ng-if=cgs.isp aria-hidden=true></span></button> {{cgs.l}}</label></div><div class=col-xs-2><span ng-if=\"cgs.sd != null\">{{cgs.sd}}<span ng-if=\"cgs.ed != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{cgs.ed}}</span></span> <span ng-if=\"cgs.sd == null && cgs.ed == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=!cgs.ls>{{\'s.p_s.label.22\' | translate}}</span> <span ng-if=\"cgs.ls==1\">{{\'s.p_s.label.14\' | translate}}</span> <span ng-if=\"cgs.ls==2\">{{\'s.p_s.label.15\' | translate}}</span> <span ng-if=\"cgs.ls==3\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"cgs.ls==4\">{{\'cl.widget.cod.1\' | translate}}</span> <span ng-if=\"cgs.ls==5\">{{\'cl.widget.wf45.14\' | translate}}</span> <span ng-if=\"cgs.ls==6\">{{\'s.p_s.label.21\' | translate}}</span></div><div class=\"col-xs-1 text-ellipsis\"><span ng-if=cgs.isc>{{\'cm.label.17\' | translate}}</span> <span ng-if=!cgs.isc>{{\'s.brief.2\' | translate}}</span></div><div class=\"col-xs-1 noPadL text-right\">{{cgs.cc}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"cgs.cc > 0\" ng-click=\"contentListFx(cgs.id, cgs.l);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 noPadL text-right\">{{cgs.dc}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"cgs.dc > 0\" ng-click=\"deviceListFx(cgs.id, cgs.l);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 text-right\" ng-if=\"selectedTab == \'hub.schedules.s\'\"><switch role=switch class=\"switch-sm nonSelectable\" ng-model=cgs.isa on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{cgs.id}} ng-change=statusFx(cgs.id) aria-checked={{cgs.isa?true:false}}></switch></div></div></li><div class=\"msg-warning mar5\" lang={{auth.lang}} ng-if=\"curGrpSchedule.length == 0\">{{\'s.msg.5\' | translate}}</div></div></div><!--Item--><li class=row ng-repeat=\"s in scheduleItem = schedules.s\" ng-if=!s.gid data-id={{s.id}} context-menu=contextMenuOpt ng-class=\"{\'text-muted\':!s.isa}\"><div class=\"col-xs-4 text-ellipsis\" ng-class=\"{\'col-xs-5\': selectedTab != \'hub.schedules.s\'}\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><input type=checkbox ng-click=\"checkboxFx($event, s.id);\" name=nameBox-{{$index}} id=nameBox-{{$index}}><label></label><button class=\"btn btn-link noPad\" ng-click=\"readMeFx(\'partialSch\')\"><span class=\"fa fa-warning text-warning noMarR\" ng-if=s.isp></span></button> {{s.l}}</label></div><div class=col-xs-2><span ng-if=\"s.sd != null\">{{s.sd}}<span ng-if=\"s.ed != null\">&nbsp;&nbsp;-&nbsp;&nbsp;{{s.ed}}</span></span> <span ng-if=\"s.sd == null && s.ed == null\" class=\"text-muted text-sm\">N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=!s.ls>{{\'s.p_s.label.22\' | translate}}</span> <span ng-if=\"s.ls==1\">{{\'s.p_s.label.14\' | translate}}</span> <span ng-if=\"s.ls==2\">{{\'s.p_s.label.15\' | translate}}</span> <span ng-if=\"s.ls==3\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"s.ls==4\">{{\'cl.widget.cod.1\' | translate}}</span> <span ng-if=\"s.ls==5\">{{\'cl.widget.wf45.14\' | translate}}</span> <span ng-if=\"s.ls==6\">{{\'s.p_s.label.21\' | translate}}</span></div><div class=col-xs-1><span ng-if=s.isc>{{\'cm.label.17\' | translate}}</span> <span ng-if=!s.isc>{{\'s.brief.2\' | translate}}</span></div><div class=\"col-xs-1 noPadL text-right\">{{s.cc}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"s.cc > 0\" ng-click=\"contentListFx(s.id, s.l);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 noPadL text-right\">{{s.dc}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-if=\"s.dc > 0\" ng-click=\"deviceListFx(s.id, s.l);\">{{\'cm.btn.21\' | translate}}</button></div><div class=\"col-xs-1 text-right\" ng-if=\"selectedTab == \'hub.schedules.s\'\"><switch role=switch class=\"switch-sm nonSelectable\" ng-model=s.isa aria-checked={{s.isa?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{s.id}} ng-change=statusFx(s.id)></switch></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=searchMsg translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(curSearch)}}&quot;</b>\'}\"></div></div>");
$templateCache.put("app/schedules/popup/assignToGrp.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'s.btn.3\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=grp>{{\'s.p_ag.1\' | translate}}</label><select class=form-control id=grp ng-model=assignGrp.grp ng-options=\"grpOpt.l for grpOpt in ngDialogData.gList | orderBy:\'l\' track by grpOpt.id\" aria-label=\"{{\'s.p_ag.1\' | translate}}\" aria-labelledby=\"{{\'s.p_ag.1\' | translate}}\"><option value=\"\">{{\'s.p_s.label.1.1\' | translate}}</option></select></div><div class=text-bold>{{\'cm.label.66\' | translate}}</div><ul><li>{{\'s.p_ag.m1\' | translate}}</li></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=assignToGrpFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'notFind\'\" aria-live=polite role=status>{{\'s.p_ag.m2\' | translate:{uName:deletedBy} }}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'sEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'sAssignToGroup\'\">{{\'s.btn.3\' | translate}}</span> <span ng-if=\"btn.key==\'sApprove\'\">{{\'cm.btn.24\' | translate}}</span> <span ng-if=\"btn.key==\'sUnapprove\'\">{{\'cm.btn.25\' | translate}}</span> <span ng-if=\"btn.key==\'sDelete\'\">{{\'cm.btn.13\' | translate}}</span></div><div class=text-ellipsis-wrap>{{\'btnInfo.\'+ btn.code | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/popup/contentList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-45\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'content\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\':loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR hide\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\"></span></a></div>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx input-group bdrR\" style=width:200px><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\"></span></a> <span class=input-group-btn uib-dropdown><button type=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><!-- <li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'tcl\');\">{{\'cm.body.10\' | translate}}</a></li> --><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType);\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><img alt=Loading src=assets/images/loading.gif ng-if=!contentList.c.length><ul class=\"list-inline thumb-list noHover\" ng-if=\"contentList.c && auth.upreferences.contentView == \'t\'\"><li class=noMar ng-repeat=\"cl in filteredContentList = (contentList.c | filter:{l:searchTextPopup})\"><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':cl.isblur}\"><!-- Audio, Flash --> <img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.th}}.png\" class=\"img-responsive center-block img-widget\" ng-if=\"(cl.t == \'Audio\' || cl.t == \'Flash\') && cl.isc\"><!-- Images, Video --> <img alt=\"\" ng-src=\"{{thumbHost + contentList.i.tth + cBucket + cl.th + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"(cl.t == \'Image\' || cl.t == \'Video\') && cl.isc\"><!-- YouTube --> <img alt=\"\" ng-src=\"{{thumbHost + cl.th}}\" class=\"img-responsive center-block\" ng-if=\"cl.t == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\"><!-- Widget --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{cl.th}}.png class=\"img-responsive center-block img-widget\" ng-if=\"cl.t == \'Widget\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.extn != \'Web Page\' && cl.extn != \'Auto Login (Basic Auth)\'\"><!-- Web Page Widget --> <img alt=\"\" ng-src=\"{{thumbHost + cDetailBucket}}widgets/thumbs/md/{{cl.th}}.png?v{{timestamp}}\" class=\"img-responsive center-block img-widget\" ng-if=\"cl.t == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && !cl.ss\"> <a ng-if=\"cl.t == \'Widget\' && (cl.extn == \'Web Page\' || cl.extn == \'Auto Login (Basic Auth)\') && cl.ss\" ng-href=\"{{cDetailBucket+cl.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.l}}><img alt=\"\" ng-src=\"{{thumbHost + contentList.i.tth + cBucket + cl.ssImg +\'&v=\'+ timestamp + thumbParam}}\" class=\"img-responsive center-block img-widget\"> </a><!-- Template  --> <img alt=\"\" ng-src=\"{{thumbHost + contentList.i.tth + tBucket + cl.th + thumbParam + \'&\' + cl.thumbV}}\" class=img-responsive ng-if=\"cl.t == \'template\' && cl.isc\"><!-- Other --> <img alt=\"\" ng-src=\"{{thumbHost + contentList.i.tth + cBucket + cl.th + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"cl.t != \'Image\' && cl.t != \'Widget\' && cl.t != \'Video\' && cl.t != \'Audio\' && cl.t != \'Flash\' && cl.t != \'template\' && cl.isc\"> <img alt=\"\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\" ng-if=\"cl.t != \'Widget\' && !cl.isc\"><div class=hoverOverlay><!-- Audio --> <a ng-if=\"cl.t == \'Audio\' && cl.isc\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a ng-if=\"cl.t == \'Flash\' && cl.isc\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.l, cl.di);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a ng-if=\"cl.t == \'Image\' && cl.isc\" ng-href=\"{{cDetailBucket + cl.th | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a ng-if=\"cl.t == \'Video\' && cl.isc\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a ng-if=\"cl.t == \'Widget\' && (cl.extn == \'YouTube\' || cl.extn == \'Vimeo\')\" ng-href={{cl.url}} role=link fancyboxable=fbMedia data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a ng-if=\"cl.t == \'template\' && cl.isc\" ng-href=\"{{tDetailBucket + cl.th | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{cl.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" role=link ng-class=\"{\'isSingle\': cl.t != \'Audio\' && cl.t != \'Flash\' && cl.t != \'Image\' &&cl.t != \'Video\' && cl.extn != \'YouTube\' && cl.extn != \'Vimeo\' && cl.t != \'template\'}\" ng-click=contentInfoOpen(cl); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div><span class=duration>{{cl.du}}</span> <span class=thumb-icon><span ng-if=cl.ss class=webpage></span> <span ng-if=\"cl.t !== \'folder\'\" class=\"{{cl.t.toLowerCase()}} {{cl.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{cl.l}} tooltip-popup-delay=1500>{{cl.l}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"contentList.c.length && filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"contentList.c && auth.upreferences.contentView == \'l\'\"><span ng-show=contentList.c.length><div class=\"row th\" ng-if=\"contentList.c.length > 0\"><div class=col-xs-6><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'label\', \'asc\', contentList.c, contentList.i, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.brief.1\' | translate}}</span></div><!-- <div class=\"col-xs-2\">\r\n            <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdon\', \'asc\', contentList.c, contentList.i, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n            <span ng-if=\"!isSorting\">{{\'cm.brief.2\' | translate}}</span>\r\n          </div>\r\n          <div class=\"col-xs-2\">\r\n            <a href=\"\" ng-if=\"isSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', contentList.c, contentList.i, \'contentsort\', folderList, \'cList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a>\r\n            <span ng-if=\"!isSorting\">{{\'cm.brief.3\' | translate}}</span>\r\n          </div> --><div class=col-xs-3><a href=\"\" ng-if=isSorting ng-click=\"sortFx(\'type\', \'asc\', contentList.c, contentList.i, \'contentsort\', folderList, \'cList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isSorting>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-3 text-right\">{{\'cm.label.25\' | translate}}</div></div><li class=row ng-repeat=\"content in filteredContentList = (contentList.c | filter:{l:searchTextPopup})\" uib-tooltip={{curTooltip}} tooltip-append-to-body=true context-menu=contextMenuOpt>{{curTooltip = getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'photo-xs-white\':\'photo-xs\'}}.png\" ng-if=\"(content.t == \'Image\' && content.extn != \'WEBP\') && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'video-sm-white\':\'video-sm\'}}.png\" ng-if=\"content.t == \'Video\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'ppt-xs-white\':\'ppt-xs\'}}.png\" ng-if=\"content.t == \'POWERPOINT\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'word-xs-white\':\'word-xs\'}}.png\" ng-if=\"content.t == \'WORD\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'pdf-xs-white\':\'pdf-xs\'}}.png\" ng-if=\"content.t == \'Vector\' && content.isc\"> <span class=\"icon {{content.th}}\" ng-if=\"(content.t == \'Widget\' && content.isc) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.t == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.t == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'photo-xs-white\':\'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'swf-xs-white\':\'swf-xs\'}}.png\" ng-if=\"content.t == \'Flash\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'audio-xs-white\':\'audio-xs\'}}.png\" ng-if=\"content.t == \'Audio\' && content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'sp-xs-white\':\'sp-xs\'}}.png\" ng-if=\"content.t == \'SharePointC\'\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'od-xs-white\':\'od-xs\'}}.png\" ng-if=\"content.t == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isc)\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'gd-xs-white\':\'gd-xs\'}}.png\" ng-if=\"content.t == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isc)\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'video-sm-white\':\'video-sm\'}}.png\" ng-if=\"content.t == \'Video\' && !content.isc\"> <img alt={{content.t}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\'?\'photo-xs-white\':\'photo-xs\'}}.png\" ng-if=\"!content.isc && content.t !== \'Video\' && content.t != \'Flash\'\"><!-- Template --> <img alt={{content.t}} ng-src=\"{{thumbHost + contentList.i.tth + tBucket + content.th + thumbParam + \'&\' + content.thV}}\" class=img-responsive ng-if=\"content.t == \'template\' && content.isc\"> <img alt=\"\" ng-if=\"content.t != \'Widget\' && !content.isc\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> </span></span><span uib-tooltip={{content.l}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.l}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n          <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cb}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cb}}</div> --><div class=\"col-xs-3 text-sm\">{{content.t}} <span ng-if=\"content.t==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-3 text-right text-sm\"><!-- Audio --> <a class=marR5 ng-if=\"content.t == \'Audio\' && content.isc\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Flash --> <a class=marR5 ng-if=\"content.t == \'Flash\' && content.isc\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.l, content.di);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Images --> <a class=marR5 ng-if=\"content.t == \'Image\' && content.isc\" ng-href=\"{{cDetailBucket + content.th | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Video --> <a class=marR5 ng-if=\"content.t == \'Video\' && content.isc\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.l);\" title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- YouTube --> <a class=marR5 ng-if=\"content.t == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Template  --> <a class=marR5 ng-if=\"content.t == \'template\' && content.isc\" ng-href=\"{{tDetailBucket + content.th | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.l}} title=\"{{\'cm.btn.21\' | translate}}\"><span class=\"fa fa-eye\" aria-hidden=true></span></a><!-- Info --> <a href=\"\" ng-class=\"{\'isSingle\': content.t != \'Audio\' && content.t != \'Flash\' && content.t != \'Image\' &&content.t != \'Video\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.t != \'template\'}\" ng-click=contentInfoOpen(content); title=\"{{\'cm.tool.3\' | translate}}\"><span class=\"fa fa-info-circle\" aria-hidden=true></span></a></div></li></span><div class=msg-warning lang={{auth.lang}} ng-if=\"contentList.c.length && filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/popup/deviceList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-45\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><span uib-dropdown><!-- <a href=\"\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.3\' | translate}}\"><span class=\"glyphicon glyphicon-info-sign\"></span></a> --> <a href=\"\" role=link ng-if=\"refreshObj.b && auth.upermissions.edl\" class=\"padR10 padL5 marL5 bdrR\" uib-dropdown-toggle uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-disabled=loading><span class=\"fa fa-download\" aria-hidden=true></span></a><ul class=\"dropdown-menu text-sm\" uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=downloadCCFx();><i class=\"glyphicon glyphicon-save-file marR5\" aria-hidden=true></i> {{\'db.body.17\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"openGroupDevices(\'schedule\', allScrollDataList, deviceView.id);\"><i class=\"glyphicon glyphicon-hdd marR5\" aria-hidden=true></i> {{\'cm.body.3\' | translate}}</a></li></ul></span><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-class=\"{\'marLeft\': marRemove}\" ng-click=\"refreshPopupListFx(\'device\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=refreshObj.l><div class=msg-warning lang={{auth.lang}} ng-if=\"!refreshObj.l && !refreshObj.b\">{{\'db.msg.1\' | translate}}</div><div class=\"table table-scroll dTable\" role=table ng-if=!refreshObj.l><!-- <div class=\"table table-scroll dTable\" role=\"table\" ng-if=\"deviceList.length\"> --><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-3>{{\'cm.label.4\' | translate}}</div><div class=col-xs-2>{{\'cm.label.80\' | translate}}</div><div class=col-xs-2>{{\'fl.body.3\' | translate | camelCase}}</div><div class=col-xs-3>{{\'s.body.3\' | translate | camelCase}}</div><div class=col-xs-2>{{\'s.body.4\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{sd.id}} ng-repeat=\"sd in filteredList = (visibleData)\"><!-- <div class=\"row\" ng-repeat=\"sd in filteredList = (deviceList | customSearch:{key:searchTextPopup, module:\'dls\'})\"> --><div class=\"col-xs-3 text-ellipsis-wrap\"><span class=\"deviceStatus {{sd.status}}\" ng-class=\"sd.status == 1?\'online\':\'offline\'\" ng-if=sd.l uib-tooltip=\"{{sd.status == 1?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> {{sd.l}} <span class=\"text-muted text-sm\" ng-if=!sd.l>N/A</span></div><div class=\"col-xs-2 text-ellipsis-wrap\">{{sd.h}} <span class=\"text-muted text-sm\" ng-if=!sd.h>N/A</span></div><div class=\"col-xs-2 text-ellipsis-wrap\">{{sd.fl}} <span class=\"text-muted text-sm\" ng-if=!sd.fl>N/A</span></div><div class=\"col-xs-3 text-ellipsis-wrap text-sm\" ng-class=\"{\'text-danger\':sd.error == \'expired\'}\"><span uib-tooltip=\"{{\'db.body.8\' | translate}}\" tooltip-enable=\"sd.error == \'expired\'\" tooltip-append-to-body=true>{{sd.r}}</span> <span class=\"text-muted text-sm\" ng-if=!sd.r>N/A</span></div><div class=\"col-xs-2 text-ellipsis-wrap\">{{sd.f}} <span class=\"text-muted text-sm\" ng-if=!sd.f>N/A</span></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/popup/exceptionDate.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"s.p_ex.1\" | translate}}</h1></header><div class=panel-body><div class=form-group><label>{{\'s.p_ex.2\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span> <input type=text class=form-control ng-hide=exObj.dRange> <input type=daterange class=\"form-control picker exDate-picker\" ng-model=exObj.dRange ng-show=exObj.dRange format=MM/DD/YYYY min-date={{minDate}} max-date={{maxDate}} opens=center readonly aria-label=\"{{\'s.p_ex.2\' | translate}}\" aria-labelledby=\"{{\'s.p_ex.2\' | translate}}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=exDateFx();><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\"cm.btn.19\" | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><span ng-if=\"errType==\'invDate\'\" aria-live=polite role=status>{{\"s.p_ex.m1\" | translate}}</span> <span ng-if=\"errType==\'sameDate\'\" aria-live=polite role=status>{{\"s.p_ex.m2\" | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/schedules/popup/groupCU.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{sGrp.id?\'s.body.5\':\'s.btn.2\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=sgName>{{\'s.p_sg.1\' | translate}}</label><input type=text id=sgName class=form-control ng-keypress=\"$event.keyCode == 13 && groupCUFx();\" ng-model=sGrp.label maxlength={{inputLimit}}></div><div class=form-group><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=sGrp.permission pid=sGrp.id module=\"\'schedulegroup\'\"></ng-permission-brief></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=groupCUFx(); ng-disabled=saveProcessing><span ng-if=!sGrp.id class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span> <span ng-if=sGrp.id class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{sGrp.id?\'cm.btn.15\':\'cm.btn.14\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'groupExist\'\" aria-live=polite role=status>{{\'s.p_sg.m2\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'s.p_sg.m1\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/schedules/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'s\'\" role=heading aria-level=1>{{\'s.tool.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'us\'\" role=heading aria-level=1>{{\'s.tool.3\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'is\'\" role=heading aria-level=1>{{\'s.tool.4\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'es\'\" role=heading aria-level=1>{{\'s.tool.5\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName == \'partialSch\'\" role=heading aria-level=1>{{\'s.tool.8\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName == \'dimen\'\" role=heading aria-level=1>{{\'s.tool.9\' | translate}}</h1></header><div class=panel-body><div ng-if=\"ngDialogData.tabName==\'s\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'s.info.s1\' | translate}}</p><img alt=\"\" src=assets/images/info/s.png></div><div ng-if=\"ngDialogData.tabName==\'us\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'s.info.us1\' | translate}}</p><img alt=\"\" src=assets/images/info/us.png></div><div ng-if=\"ngDialogData.tabName==\'is\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'s.info.is1\' | translate}}</p><img alt=\"\" src=assets/images/info/is.png></div><div ng-if=\"ngDialogData.tabName==\'es\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'s.info.es1\' | translate}}</p><img alt=\"\" src=assets/images/info/es.png></div><div ng-if=\"ngDialogData.tabName == \'partialSch\'\" role=img>{{\'s.msg.12\' | translate}}<ul class=\"marT10 padL30\"><li><div>{{\'s.msg.13\' | translate}}</div><div translate=\"{{\'s.msg.13.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div></li><li class=marT10><div>{{\'s.msg.14\' | translate}}</div><div translate=\"{{\'s.msg.14.1\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div></li></ul><div class=marT20 translate=\"{{\'s.msg.15\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div></div><div ng-if=\"ngDialogData.tabName == \'dimen\'\" role=img><div><strong>{{\'s.msg.16\' | translate}}</strong></div><div class=marT25>{{\'s.msg.16.1\' | translate}}</div><div class=\"marT50 d-flex justify-center\"><img alt=\"\" src=assets/images/info/dimen.png></div><div class=marT50 translate=\"{{\'s.msg.16.2\'}}\" translate-values=\"{htmlTagO:\'<b>\', htmlTagC:\'</b>\'}\"></div></div></div></section>");
$templateCache.put("app/schedules/popup/previewDates.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'s.p_s.btn.5\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=previewProcessing><div class=msg-warning lang={{auth.lang}} ng-if=\"!previewProcessing && !previewDateList.length\">{{\'s.p_s.msg.38\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!previewProcessing && previewDateList.length\"><div class=\"row th\"><div class=col-xs-6>{{\'cm.label.7\' | translate}}</div><div class=col-xs-3 ng-class=\"{\'noPadL\': previewDateList.length > 12}\">{{\'cm.label.12\' | translate}}</div><div class=col-xs-3 ng-class=\"{\'noPadL\': previewDateList.length > 12}\">{{\'cm.label.13\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"pd in previewDateList\"><div class=col-xs-6>{{pd.date | date:\"EEEE MMM dd, yyyy\"}}</div><div class=col-xs-3>{{pd.st | changeTimeFormat}}</div><div class=col-xs-3>{{pd.et | changeTimeFormat}}</div></div></div></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></div></section>");
$templateCache.put("app/schedules/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName==\'s\'\" role=heading aria-level=1>{{\'s.info.isV1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'us\'\" role=heading aria-level=1>{{\'s.info.isV1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'is\'\" role=heading aria-level=1>{{\'s.info.isV1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'es\'\" role=heading aria-level=1>{{\'s.info.isV1\' | translate}}</h1></header><div class=video-body><iframe width=560 height=315 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/sa/IoT/IoT.html","<section class=wrapper><div class=\"form-group text-center\"><div ng-repeat=\"p in placements\" style=margin-top:50px><div style=margin-bottom:10px><span>{{p.p}}</span></div><button type=button role=button class=\"btn btn-primary btn-lg\" ng-click=updatePlacementFx(p); ng-disabled=\"updateProcessing && curId== p.id\">Next Customer</button></div></div></section>");
$templateCache.put("app/sa/queue/queue.html","<section class=wrapper><nav class=\"navbar navbar-fixed-top navbarTop\"><div class=container-fluid><button type=button role=button class=\"navbar-toggle collapsed hide\" ng-click=\"isCollapsed = !isCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=navbar-header><span class=navbar-brand><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo.png> <img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo_square.png class=hide><!-- Theme --> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/logo.png class=hLogo> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/v-logo.png class=\"hLogo hide\"></span></div></div></nav><div class=\"selectServerContainer queueContainer\"><div class=selectServer><header class=panel-heading ng-cloak>Queue <span ng-if=queue.label>- {{queue.label}}</span></header><img alt=Loading src=assets/images/loading.gif ng-if=detailLoading class=pad10><div class=panel-body ng-if=!detailLoading><div class=msg-warning lang={{auth.lang}} ng-if=notAcces>Item not accessible.</div><div ng-if=!notAcces><div class=\"row marB20\"><div class=col-xs-3><div class=form-group><label>Current</label><div><span class=\"badge bg-muted\">{{queue.current}}</span></div></div></div><div class=col-xs-3><div class=form-group><label>Next</label><div><span class=\"badge bg-muted\">{{queue.next}}</span></div></div></div><div class=col-xs-6><div class=form-group><label>&nbsp;</label><div class=marT15><button type=button role=button class=\"btn btn-success btn-lg\" ng-click=\"incDecResetFx(\'i\');\" ng-disabled=\"updateProcessing || queue.incDisabled\"><span class=\"fa fa-chevron-up\" aria-hidden=true></span>Increment</button> <button type=button role=button class=\"btn btn-danger btn-lg\" ng-click=\"incDecResetFx(\'d\');\" ng-disabled=\"updateProcessing || queue.decDisabled\"><span class=\"fa fa-chevron-down\" aria-hidden=true></span>Decrement</button> <a href=\"\" role=link class=\"btn-link marL10\" ng-click=\"incDecResetFx(\'r\');\" ng-disabled=updateProcessing>Reset</a></div></div></div></div></div></div></div></div></section><footer class=\"footer noMarL padL10\"><span ng-bind-html=copyRight></span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank ng-cloak>{{\'cm.footer.1\' | translate}}</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank ng-cloak>{{\'cm.footer.2\' | translate}}</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/sa/survey/home.html","<section class=wrapper><div ui-view=header></div><section class=container-fluid><nav class=\"navbar navbar-fixed-top navbarTop\" role=navigation aria-labelledby=navList ng-if=\"curState != \'s.login\'\"><div class=container-fluid><button type=button role=button class=\"navbar-toggle collapsed hide\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button><div class=navbar-header><span class=navbar-brand><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo.png> <img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo_square.png class=hide><!-- Theme --> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/logo.png class=hLogo> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/v-logo.png class=\"hLogo hide\"></span></div><ul class=\"nav navbar-nav navbar-right pull-right mob-hide\"><li>{{auth.email | limitTo:25}}</li></ul></div></nav><div class=marT10 ui-view=\"\"></div></section></section><footer class=\"footer noMarL padL10 text-theme\"><span ng-bind-html=copyRight></span><span ng-if=\"myTheme.clientTheme !=\'\'\">&nbsp;{{\"cm.footer.3\" | translate}}</span> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/terms.pdf role=link target=_blank>Terms &amp; Conditions</a> | <a href=https://s3-us-west-2.amazonaws.com/lsquared-hub/doc/privacy.pdf role=link target=_blank>Privacy Policy</a> | V&nbsp;{{uiVersion}}</footer>");
$templateCache.put("app/sa/survey/login.html","<section class=wrapper><div class=container-center><div class=text-center><img alt=\"L Squared Hub\" ng-if=\"myTheme.clientTheme == \'\'\" src=assets/images/logo-index.png> <img alt={{domainName}} ng-if=\"myTheme.clientTheme != \'\'\" src=../theme/{{domainName}}/index.png><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme == \'\'\">Welcome to L Squared Digital Signage Platform</div><div class=\"text-muted marT15\" ng-if=\"myTheme.clientTheme != \'\'\">Welcome to {{dmainPageTitle}} Digital Signage Platform</div></div><form method=post name=retrievePassForm><div class=panel-body><div class=\"errMsg marB10\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'email\'\" aria-live=polite role=status>Please provide Email.</div><div ng-if=\"errType==\'reCaptcha\'\" aria-live=polite role=status>Please validate captcha.</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>Oops! Something went wrong. Please try again later. You can report this issue to<br>L Squared Support by <a href=\"\" role=link>clicking here</a>.</div><div ng-if=\"errType==\'idNotFound\'\" aria-live=polite role=status>Survey not found.</div><div ng-if=\"errType==\'emailAlready\'\" aria-live=polite role=status>This Email Already used for this survey.</div></div><div class=form-group><label>Email</label><input type=email ng-model=credentials.email class=form-control placeholder=Email focus-me=true required></div><div class=form-group><div vc-recaptcha key=publicKey on-create=setWidgetId(widgetId) on-success=setResponse(response) on-expire=cbExpiration()></div></div><button type=button role=button ng-click=loginFx(); class=\"btn btn-primary\" ng-disabled=authProcessing><span class=\"fa fa-repeat fa-spin fa-fw\" ng-if=authProcessing aria-hidden=true></span><span class=\"fa fa-sign-in\" ng-if=!authProcessing aria-hidden=true></span> Login</button></div></form></div></section>");
$templateCache.put("app/sa/survey/participate.html","<section class=panel><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=surveyLoading><div ng-if=hasMsg class=\"pad10 text-md\" ng-class=\"hasType == \'oopsFinished\'?\'bg-danger text-danger\':\'bg-warning text-warning\'\"><span ng-if=\"hasType == \'already\'\">You have already participated in this survey.</span> <span ng-if=\"hasType == \'finished\'\">This survey has been finished.</span> <span ng-if=\"hasType == \'notActive\'\">This survey is not active right now.</span> <span ng-if=\"hasType == \'notFound\'\">Survey not found.</span> <span ng-if=\"hasType == \'oopsFinished\'\">Oops! You are late, the survey has finished.</span></div><div ng-if=\"!surveyLoading && !hasMsg\"><div class=form-group ng-if=\"survey.info.title != null || survey.info.desc != null\"><label>{{survey.info.title}}</label><div>{{survey.info.desc}}</div><hr></div><div class=\"table table-striped tbl-lg\" ng-if=\"survey.questionList.length > 0\"><div class=row ng-repeat=\"s in survey.questionList\"><div class=\"col-xs-12 word-break marB5\"><div class=\"text-bold word-break\">{{$index + 1 + \". \" + s.label}}</div></div><div class=padL10><div class=\"col-xs-12 col-sm-6 col-lg-3 word-break survey\" ng-repeat=\"option in s.opt\" ng-if=\"option.label != \'\'\"><label ng-if=\"s.selType != 2\" class=noMarB>[{{option.label}}]</label><div ng-if=\"s.selType == 0\" ng-init=\"s.isSelected=-1\"><label class=text-normal><input type=radio role=radio name=opt{{option.id}} ng-model=s.isSelected ng-value={{$index}}><label></label>{{option.opt}}</label></div><div ng-if=\"s.selType == 1\"><label class=text-normal><input type=checkbox name=opt{{option.id}} ng-model=option.isCheck ng-value=\"\'opt\'+option.opt\" role=checkbox><label></label>{{option.opt}}</label></div></div><div class=\"col-xs-12 word-break survey\" ng-if=\"s.opt.length == 0\"><div ng-if=\"s.selType == 2\"><textarea class=\"txtAreaBig form-control\" ng-model=s.isSelected></textarea></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"survey.questionList.length <= 0\">You don\'t have any question yet. When you add some, they\'ll appear here.</div></div></div><div class=panel-footer ng-if=\"!surveyLoading && !hasMsg\"><span class=btnQuad ng-if=!hasMsg><button type=button role=button ng-click=surveyFx(); class=\"btn btn-primary\" ng-disabled=surveyProcessing ng-cloak><span class=fa ng-class=\"surveyProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>Submit</button> <button type=button role=button ng-click=resetFx(); class=\"btn btn-default\" ng-cloak><span class=\"fa fa-repeat\" aria-hidden=true></span>Reset</button></span></div><div class=panel-footer ng-if=\"!surveyLoading && hasMsg && (hasType == \'already\' || hasType == \'finished\' || hasType == \'oopsFinished\')\"><span class=btnQuad><button type=button role=button ng-click=showResult(); class=\"btn btn-default\"><span class=\"fa fa-bar-chart\" aria-hidden=true></span>Show Result</button></span></div></section>");
$templateCache.put("app/sa/survey/result.html","<section class=panel><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=resultLoading><div ng-if=hasMsg class=\"bg-warning text-warning pad10 text-md\"><span ng-if=\"hasType == \'already\'\">You have already participated in this survey.</span> <span ng-if=\"hasType == \'finished\'\">This survey has been finished.</span> <span ng-if=\"hasType == \'notActive\'\">This survey is not active right now.</span> <span ng-if=\"hasType == \'notFound\'\">Survey not found.</span></div><div ng-if=!resultLoading><div class=\"table table-striped tbl-lg\" ng-if=\"result.questionList.length > 0\"><ul><div class=surveyQuad><li class=row ng-repeat=\"r in result.questionList\"><div class=\"panel-body padL\"><div class=\"text-bold word-break marB5\">{{$index + 1 + \". \" + r.label}}</div><span ng-repeat=\"opt in r.options\"><div class=\"col-xs-12 col-sm-6 word-break\" ng-if=\"opt.label != \'\'\"><div class=marB5><span class=\"text-bold pull-left marR5\">[{{opt.label}}]</span> <span>{{opt.opt}}</span></div><div class=progress><div class=progress-bar role=progressbar aria-valuenow={{opt.percent}} aria-valuemin=0 aria-valuemax=100 style=width:{{opt.percent}}%>{{opt.percent}}%</div></div></div><div class=clearfix ng-if=$odd></div></span></div></li></div></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"result == \'\' || result.questionList.length <= 0\">Result not found.</div></div></div></section>");
$templateCache.put("app/sa/survey/thanks.html","<section class=panel><div class=panel-body><div class=\"bg-success text-success pad10 text-md marB10\">Your votes has been submitted. Thanks for participating in the survey.</div></div><div class=panel-footer ng-if=\"auth.showResult == 1\"><span class=btnQuad><button type=button role=button ng-click=showResult(); class=\"btn btn-default\"><span class=\"fa fa-bar-chart\" aria-hidden=true></span>Show Result</button></span></div></section>");
$templateCache.put("app/sa/surveyDesktop/home.html","<section class=wrapper style=margin-top:-41px><section class=container-fluid><div ui-view=\"\"></div></section></section>");
$templateCache.put("app/sa/surveyDesktop/login.html","<section class=panel><div class=panel-body><div class=text-center ng-if=authProcessing><img alt=Loading src=assets/images/loading-xs.gif></div><div class=errMsg ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'idMac\'\" aria-live=polite role=status>Please provide survey id and device id.</div><div ng-if=\"errType==\'api\'\" aria-live=polite role=status>Oops! Something went wrong. Please try again later. You can report this issue to<br>L Squared Support by <a href=\"\" role=link>clicking here</a>.</div><div ng-if=\"errType==\'idNotFound\'\" aria-live=polite role=status>Survey not found.</div><div ng-if=\"errType==\'already\'\" aria-live=polite role=status>This device already used for this survey.</div></div></div></section>");
$templateCache.put("app/sa/surveyDesktop/participate.html","<section class=panel><div class=panel-body><div class=text-center ng-if=surveyLoading><img alt=Loading src=assets/images/loading-xs.gif></div><div ng-if=hasMsg class=\"pad10 text-md\" ng-class=\"hasType == \'oopsFinished\'?\'bg-danger text-danger\':\'bg-warning text-warning\'\"><span ng-if=\"hasType == \'already\'\">You have already participated in this survey.</span> <span ng-if=\"hasType == \'finished\'\">This survey has been finished.</span> <span ng-if=\"hasType == \'notActive\'\">This survey is not active right now.</span> <span ng-if=\"hasType == \'notFound\'\">Survey not found.</span> <span ng-if=\"hasType == \'oopsFinished\'\">Oops! You are late, the survey has finished.</span></div><div ng-if=\"!surveyLoading && !hasMsg\"><div class=form-group ng-if=\"survey.info.title != null || survey.info.desc != null\"><label>{{survey.info.title}}</label><div>{{survey.info.desc}}</div><hr></div><div class=\"table table-striped tbl-lg\" ng-if=\"survey.questionList.length > 0\"><div class=row ng-repeat=\"s in survey.questionList\" ng-class=\"{\'noBdr\':$last}\"><div class=\"col-xs-12 word-break marB5\"><div class=\"text-bold word-break\">{{$index + 1 + \". \" + s.label}}</div></div><div class=padL10><div class=\"col-xs-12 col-sm-6 col-lg-3 word-break survey\" ng-repeat=\"option in s.opt\" ng-if=\"option.label != \'\'\"><div ng-if=\"s.selType == 0\" ng-init=\"s.isSelected=-1\"><label class=text-normal><input type=radio role=radio name=opt{{option.id}} ng-model=s.isSelected ng-value={{$index}}><label></label>{{option.opt}}</label></div><div ng-if=\"s.selType == 1\"><label class=text-normal><input type=checkbox name=opt{{option.id}} ng-model=option.isCheck ng-value=\"\'opt\'+option.opt\" role=checkbox><label></label>{{option.opt}}</label></div></div><div class=\"col-xs-12 word-break survey\" ng-if=\"s.opt.length == 0\"><div ng-if=\"s.selType == 2\"><textarea class=\"txtAreaBig form-control\" ng-model=s.isSelected></textarea></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"survey.questionList.length <= 0\">You don\'t have any question yet. When you add some, they\'ll appear here.</div></div></div><div class=panel-footer ng-if=\"!surveyLoading && !hasMsg\"><span class=btnQuad ng-if=!hasMsg><button type=button role=button ng-click=surveyFx(); class=\"btn btn-primary\" ng-disabled=surveyProcessing ng-cloak><span class=fa ng-class=\"surveyProcessing?\'fa-repeat fa-spin fa-fw\':\'fa-check\'\" aria-hidden=true></span>Submit</button> <button type=button role=button ng-click=resetFx(); class=\"btn btn-default\" ng-cloak><span class=\"fa fa-repeat\" aria-hidden=true></span>Reset</button></span></div></section>");
$templateCache.put("app/sa/surveyDesktop/thanks.html","<section class=panel><div class=panel-body><div class=\"bg-success text-success pad10 text-md\">Your votes has been submitted. Thanks for participating in the survey.</div></div><div class=panel-footer ng-if=\"auth.showResult == 1\"><span class=btnQuad><button type=button role=button ng-click=showResult(); class=\"btn btn-default\"><span class=\"fa fa-bar-chart\" aria-hidden=true></span>Show Result</button></span></div></section>");
$templateCache.put("app/templates/dir/templateBrief.html","<div class=selectedQuad><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><header class=panel-heading><h2 ng-if=\"selectedTab != \'hub.templates.ts\'\">{{selectedItems.length>1?\'t.body.1s\':\'t.body.1\' | translate}} [ {{selectedItems.length}} ]</h2><h2 ng-if=\"selectedTab == \'hub.templates.ts\'\">{{selectedItems.length>1?\'t.body.4s\':\'t.body.4\' | translate}} [ {{selectedItems.length}} ]</h2><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=closeAllFx(); ng-if=\"selectedTab !== \'hub.templates.tl\'\" uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a> <a href=\"\" role=link id=closeBrief ng-click=closeBriefFx(); ng-if=\"selectedTab === \'hub.templates.tl\'\" uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-show=briefLoading><div ng-if=\"selectedItems.length == 1\">{{curFolder = (folderList | folderBrief:selectedItems[0] | orderBy:\'id\');\"\"}} {{curTemplate = (templateList | filter:{id:selectedItems[0].id}:true | orderBy: \'id\');\"\"}}<ul class=list-unstyled ng-hide=briefLoading><div class=row><div class=col-xs-3><div class=thumb-highlight><!-- Folder --> <img alt=Folder ng-if=\"curFolder[0].type == \'Folder\' || curTemplate[0].type == \'Folder\'\" src=assets/images/default/folder_selected.png class=\"noOutline img-responsive center-block img-folder\"> <span ng-if=\"curFolder[0].type != \'Folder\' && curTemplate[0].type != \'Folder\'\"><img alt=Incomplete ng-if=!curTemplate[0].thumb src=assets/images/default/incomplete.png class=\"img-responsive center-block img-incomplete\"> <a ng-if=curTemplate[0].thumb ng-href=\"{{tDetailBucket + curTemplate[0].thumb | secureThumb:curTemplate[0].thumbV}}\" role=link fancyboxable=fbTitleInside caption={{curTemplate[0].label}}><img alt=Template ng-src=\"{{thumbHost + tim + tBucket + curTemplate[0].thumb + thumbBigParam + \'&=\' + curTemplate[0].thumbV}}\" class=\"img-responsive center-block\"></a></span><div class=\"text-ellipsis marT5\" uib-tooltip={{curFolder[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curFolder[0].label != \'\'\">{{curFolder[0].label}}</div><div class=\"text-ellipsis marT5\" uib-tooltip={{curTemplate[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curTemplate[0].label != \'\'\">{{curTemplate[0].label}}</div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\" ng-if=\"selectedTab != \'hub.templates.tl\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curFolder[0].label}} {{curTemplate[0].label}}</div></div><div class=col-xs-6 ng-if=curTemplate.length><div class=\"col-xs-5 text-right\">{{\'cm.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{templateBrief.dimension}} <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.dimension == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=!curTemplate.length><div class=\"col-xs-5 text-right\">{{\'t.label.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{templateBrief.templateCount}} <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curTemplate[0].createdOn>{{(curTemplate[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span ng-if=curFolder[0].createdOn>{{(curFolder[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span></div></div><div class=col-xs-6 ng-if=\"selectedTab != \'hub.templates.ut\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curTemplate[0].approvedOn>{{(curTemplate[0].approvedOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curTemplate[0].approvedOn == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.templates.ut\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'t.label.21\' | translate}}:</div><div class=col-xs-7><span ng-if=\"templateBrief.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"templateBrief.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"templateBrief.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"templateBrief.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"templateBrief.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"templateBrief.tType == 6\">{{\'t.label.30\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=templateBrief.createdBy>{{templateBrief.createdBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.createdBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab != \'hub.templates.ut\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.5\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=templateBrief.approvedBy>{{templateBrief.approvedBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.approvedBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"templateBrief != \'\' && templateBrief.editedOn\">{{(templateBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link id=history class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curTemplate[0].id, \'template\', curTemplate[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && !templateBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.templates.t\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'cm.label.3s\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"templateBrief != \'\' && templateBrief.scheduleCount.a > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{templateBrief.scheduleCount.a}}</span> <span ng-if=\"templateBrief != \'\' && templateBrief.scheduleCount.a == 0 && templateBrief.scheduleCount.i > 0\" uib-tooltip=\"{{\'d.tool.19\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>0</span> <span ng-if=\"templateBrief != \'\' && templateBrief.scheduleCount.i > 0\" class=text-muted>| <span uib-tooltip=\"{{\'d.tool.20\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=1000>{{templateBrief.scheduleCount.i}}</span></span> <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"countListFx(curTemplate[0].id, \'schedule\', curTemplate[0].label, templateBrief.scheduleCount);\" ng-if=\"templateBrief.scheduleCount.a + templateBrief.scheduleCount.i > 0\">{{\'cm.btn.21\' | translate}}</button> <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.scheduleCount.a + templateBrief.scheduleCount.i == 0\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.templates.it\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'t.label.21\' | translate}}:</div><div class=col-xs-7><span ng-if=\"templateBrief.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"templateBrief.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"templateBrief.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"templateBrief.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"templateBrief.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"templateBrief.tType == 6\">{{\'t.label.30\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=\"templateBrief.editedBy && templateBrief.editedBy != 0\">{{templateBrief.editedBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && (!templateBrief.editedBy || templateBrief.editedBy == 0)\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.templates.t\' && curTemplate.length\"><div class=\"col-xs-5 text-right\">{{\'t.label.21\' | translate}}:</div><div class=col-xs-7><span ng-if=\"templateBrief.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"templateBrief.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"templateBrief.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"templateBrief.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"templateBrief.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"templateBrief.tType == 6\">{{\'t.label.30\' | translate}}</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cl.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold word-break\"><!-- <span class=\"fa fa-home marR5\"></span>{{curContent[0].path}} {{curContent[0].path}} --> <span class=\"fa fa-home marR5\" ng-if=\"templateBrief != \'\' && templateBrief.path\" aria-hidden=true></span>{{templateBrief.path}} <span class=\"text-muted text-sm\" ng-if=\"templateBrief != \'\' && templateBrief.path == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"templateBrief == \'\'\"></div></div></div></div><!-- For Library --><div class=\"table no-th no-border\" ng-if=\"selectedTab == \'hub.templates.tl\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curTemplate[0].label}}</div></div><div class=col-xs-6 ng-if=\"curTemplate[0].type == \'Folder\'\"><div class=\"col-xs-5 text-right\">{{\'t.label.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curTemplate[0].count}}</div></div><div class=col-xs-6 ng-if=\"curTemplate[0].type != \'Folder\'\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.8\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curTemplate[0].d}}</div></div></div><div class=row ng-if=\"curTemplate[0].type != \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=curTemplate[0].createdOn>{{(curTemplate[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curTemplate[0].createdOn == null\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'fl.brief.5\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curTemplate[0].frameCount}}</div></div></div><div class=row ng-if=\"curTemplate[0].type != \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curTemplate[0].cBy}}</div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'fl.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{curTemplate[0].usageCount}}</div></div></div><div class=row ng-if=\"curTemplate[0].type != \'Folder\'\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'t.label.21\' | translate}}:</div><div class=col-xs-7><span ng-if=\"curTemplate[0].tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"curTemplate[0].tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"curTemplate[0].tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"curTemplate[0].tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"curTemplate[0].tType == 6\">{{\'t.label.30\' | translate}}</span></div></div></div></div></div></div></ul></div><!--For Multiple selected--><div ng-if=\"selectedItems.length > 1\"><div class=\"thumb-list hoverContainer\"><li ng-repeat=\"template in selectedItems\" class=\"device valign-top\">{{curFolder = (folderList | folderBrief:selectedItems[$index] | orderBy:\'id\');\"\"}} {{curTemplate = (selectedTab == \'hub.templates.t\'?templateList:templates.templates | filter:{id:selectedItems[$index].id}:true | orderBy:\'id\');\"\"}}<div class=\"relative padT4 padB1\" ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><a href=\"\" role=link id=close{{template.id}} class=\"thumb-close brief-cl\" ng-click=closeFx(template.id)><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb-img><span class=thumb-inner><!-- Folder --> <img alt=Folder ng-if=\"curFolder[0].type == \'Folder\' || curTemplate[0].type == \'Folder\'\" src=assets/images/default/folder_{{thumbSize}}.png class=\"noOutline img-responsive center-block\"> <span ng-if=\"curFolder[0].type != \'Folder\' && curTemplate[0].type != \'Folder\'\"><img alt=incomplete ng-if=!curTemplate[0].thumb src=assets/images/default/incomplete.png class=\"img-responsive center-block\"> <a ng-if=curTemplate[0].thumb ng-href=\"{{tDetailBucket + curTemplate[0].thumb | secureThumb:curTemplate[0].thumbV}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{curTemplate[0].label}}><img alt=Template ng-src=\"{{thumbHost + tim + tBucket + curTemplate[0].thumb + thumbParam}}\" class=\"img-responsive center-block\"></a></span></span></div><div class=\"thumb-label noMar\" uib-tooltip={{curFolder[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curFolder[0].label != \'\' && template.type == \'folder\'\">{{curFolder[0].label}}</div><div class=\"thumb-label noMar\" uib-tooltip={{curTemplate[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000 ng-if=\"curTemplate[0].label != \'\' && template.type != \'folder\'\">{{curTemplate[0].label}}</div></div></li></div></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=\"templateBtn.length==0\"> <a href=\"\" role=link id=infoBtn class=\"pull-left marT6\" ng-click=btnInfoOpen(templateBtn.info); ng-if=templateBtn.info.length><img alt=info src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"templateBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=templateBtn><span class=\"btn-group dropup marR2\" uib-dropdown ng-if=\"templateBtn.buttons.length > 4\"><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle ng-disabled=disabled>{{\'cm.btn.23\' | translate}} <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu><li ng-repeat=\"mBtn in templateBtn.buttons\"><a href=\"\" role=link id=tEdit ng-if=\"mBtn.key==\'tEdit\' && selectedItems[0].type == \'folder\'\" ng-click=\"folderCUOpen(\'n\', \'edit\');\"><span class=\"fa fa-pencil marR10\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</a> <a href=\"\" role=link id=tMove ng-if=\"mBtn.key==\'tMove\'\" ng-click=moveOpen(selectedItems[0].id);><span class=\"fa fa-copy marR10\" aria-hidden=true></span>{{\'cm.btn.50\' | translate}}</a> <a href=\"\" role=link id=tDuplicate ng-if=\"mBtn.key==\'tDuplicate\'\" ng-click=duplicateFx();><span class=\"fa fa-files-o marR10\" aria-hidden=true></span>{{\'cm.btn.30\' | translate}}</a> <a href=\"\" role=link id=tApprove ng-if=\"mBtn.key==\'tApprove\'\" ng-click=approveTemplateFx();><span class=\"fa fa-check marR10\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</a> <a href=\"\" role=link id=tUnapprove ng-if=\"mBtn.key==\'tUnapprove\'\" ng-click=\"confirmTemplateOpen(\'unapprove\');\"><span class=\"fa fa-ban marR10\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</a> <a href=\"\" role=link id=tPin ng-if=\"mBtn.key==\'tPin\'\" ng-click=\"pinToDBFx(selectedItems[0],\'t\');\"><span class=\"fa fa-thumb-tack marR10\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</a></li></ul></span><span ng-repeat=\"tBtn in templateBtn.buttons\"><div ng-if=\"tBtn.key==\'tEdit\' && selectedItems[0].type != \'folder\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ng-click=\"editFx(\'tName\');\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in tBtn.steps\"><a href=\"\" role=link id=tName ng-if=\"step.key==\'tStep1\'\" ng-click=\"editFx(\'tName\');\">{{\'cm.btn.40\' | translate}}</a> <a href=\"\" role=link id=tDesign ng-if=\"step.key==\'tStep2\'\" ng-click=\"editFx(\'tDesign\');\">{{\'t.btn.3\' | translate}}</a></li></ul></div>{{crelabel = (templateList | filter:{id:selectedItems[0].id}:true | orderBy: \'id\');\"\"}} <button type=button role=button ng-if=\"tBtn.key==\'tEdit\' && selectedItems[0].type == \'folder\' && templateBtn.buttons.length <= 4\" ng-click=\"editFx(\'tName\');\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tOpen\'\" ng-click=\"folderContentFx(selectedItems[0].id, selectedItems[0].splId, selectedItems[0].type);\" class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tDownload\'\" ng-click=dExcelOpen(); class=\"btn btn-default\"><span class=\"fa fa-download\" aria-hidden=true></span>{{\'cm.btn.49\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tEditDText\'\" ng-click=dTextEditOpen(crelabel[0].label); class=\"btn btn-default\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'t.btn.4\' | translate}}</button> <button type=button role=button ng-if=\"(tBtn.key==\'tDuplicate\' && templateBtn.buttons.length <= 4)\" ng-click=duplicateFx(); class=\"btn btn-default\"><span class=\"fa fa-files-o\" aria-hidden=true></span>{{\'cm.btn.30\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tSchedule\'\" ng-click=scheduleFx(); class=\"btn btn-success\"><span class=\"fa fa-calendar\" aria-hidden=true></span>{{\'cm.btn.27\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tAddToSchedule\'\" ng-click=addToScheduleOpen(); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.28\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tMove\' && templateBtn.buttons.length <= 4\" ng-click=moveOpen(selectedItems[0].id); class=\"btn btn-default\"><span class=\"fa fa-copy marR10\" aria-hidden=true></span>{{\'cm.btn.50\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tApprove\' && templateBtn.buttons.length <= 4\" ng-click=approveTemplateFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.24\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tUnapprove\' && templateBtn.buttons.length <= 4\" ng-click=\"confirmTemplateOpen(\'unapprove\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'cm.btn.25\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tDelete\'\" ng-click=\"confirmTemplateOpen(\'delete\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tlUse\'\" ng-click=useTemplateFx(); class=\"btn btn-success\" ng-disabled=useBtnLoading><span class=\"fa fa-check\" ng-class=\"useBtnLoading?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'t.btn.2\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tlOpen\'\" ng-click=\"openFolderFx(\'tl\', selectedItems[0].id);\" class=\"btn btn-default\"><span class=\"fa fa-folder-open\" aria-hidden=true></span>{{\'cl.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"tBtn.key==\'tPin\' && templateBtn.buttons.length <= 4\" ng-click=\"pinToDBFx(selectedItems[0],\'t\');\" class=\"btn btn-default\"><span class=\"fa fa-thumb-tack\" aria-hidden=true></span>{{\'cm.label.98\' | translate}}</button><!-- Scenes --><div ng-if=\"tBtn.key==\'sEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ng-click=\"editFx(\'tName\');\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in tBtn.steps\"><a href=\"\" role=link id=tName ng-if=\"step.key==\'sStep1\'\" ng-click=\"editFx(\'tName\');\">{{\'cm.btn.40\' | translate}}</a> <a href=\"\" role=link id=tDesign ng-if=\"step.key==\'sStep2\'\" ng-click=\"editFx(\'tDesign\');\">{{\'t.btn.5\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"tBtn.key==\'sDelete\'\" ng-click=\"confirmTemplateOpen(\'sDelete\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button></span></ul></div></section></div>");
$templateCache.put("app/templates/dir/templateList.html","<div ng-if=\"selectedTab !== \'hub.templates.t\' && selectedTab !== \'hub.sContainer.sContent\'\"><li ng-repeat=\"template in filteredTemplateList = (templates.templates | customSearch:{key:searchText, module:\'t\'})\" single-selected data-id={{template.id}} data-type=Template ng-class=\"{\'unapprovedFile\': selectedTab === \'hub.templates.ut\'}\" context-menu=contextMenuOpt class=tabIndex><div class=thumb-img><img alt=\"\" src=assets/images/default/incomplete.png ng-if=!template.thumb class=img-incomplete> <img alt=\"\" ng-src=\"{{thumbHost + tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" ng-if=template.thumb></div><div class=thumb-label uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000>{{template.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><div ng-if=\"selectedTab === \'hub.templates.t\' || selectedTab === \'hub.sContainer.sContent\'\"><li ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt class=tabIndex><div ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{folder.label}}</div></div></li><li ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:searchText, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.type}} ng-class=\"{\'unapprovedFile\':template.isApproved === 0, \'nonSelectable unapprovedFile\':isNonSelectable}\" ng-if=\"$state.includes(\'hub.templates.t\') && (filter == \'all\' || (filter == \'myContent\' && template.owner == 1) || (filter == \'approved\' && template.isApproved == 1) || (filter == \'unapproved\' && template.isApproved == 0) || filter == template.type)\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-append-to-body=true context-menu=contextMenuOpt tooltip-enable=\"template.isApproved === 0\"><div ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Incomplete src=assets/images/default/incomplete.png ng-if=!template.thumb> <img alt=Templates ng-src=\"{{thumbHost + tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" ng-if=template.thumb> <img alt=na ng-src=\"{{thumbHost + tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{template.label}}</div></div></li><!-- {{$state.includes(\'hub.templates.t\')}} --><li ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:searchText, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.type}} ng-class=\"{\'unapprovedFile\':template.isApproved === 0, \'nonSelectable unapprovedFile\':isNonSelectable}\" ng-if=\"$state.includes(\'hub.templates.t\') != true && (filter == \'all\' || (filter == \'myContent\' && template.owner == 1) || (filter == \'approved\' && template.isApproved == 1) || filter == template.type) &&  template.isApproved == 1\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-append-to-body=true context-menu=contextMenuOpt tooltip-enable=\"template.isApproved === 0\"><div ng-class=\"{\'thumb-sm\':thumbSize == \'sm\',\'thumb-md\':thumbSize == \'md\',\'thumb-lg\':thumbSize == \'lg\', \'thumb-xl\':thumbSize == \'xl\'}\"><div class=thumb-img><span class=thumb-inner><img alt=Incomplete src=assets/images/default/incomplete.png ng-if=!template.thumb> <img alt=Templates ng-src=\"{{tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" ng-if=template.thumb> <img alt=na ng-src=\"{{tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{template.label}}</div></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(folderList.length || templateList.length) && filteredFolderList.length + filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(filteredFolderList.length == 0 && filteredTemplateList.length > 0 && filterCount == 0) || (filteredFolderList.length == 0 && filteredTemplateList.length > 0 && !filterSearch)\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div></div>");
$templateCache.put("app/templates/dir/templateListView.html","<div ng-if=\"selectedTab != \'hub.templates.t\' && selectedTab != \'hub.sContainer.sContent\'\"><div class=\"row th\" ng-if=\"folderList.length + templateList.length > 0\"><div class=col-xs-4><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'label\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-2><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'createdon\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.2\' | translate}}</span></div><div class=col-xs-2><!-- <a href=\"\" ng-if=\"isTemplateSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> --> <span>{{\'cm.brief.3\' | translate}}</span></div><div class=col-xs-2><!-- <a href=\"\" ng-if=\"isTemplateSorting\" ng-click=\"sortFx(\'type\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> --> <span>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"template in filteredTemplateList = (templates.templates | customSearch:{key:searchText, module:\'t\'})\" data-id={{template.id}} data-type=template ng-class=\"{\'unapprovedFile\': selectedTab === \'hub.templates.ut\'}\" context-menu=contextMenuOpt><div class=\"col-xs-4 text-ellipsis clViwe tList-thumb\"><span class=cl-cIcon><img alt=\"\" src=assets/images/default/incomplete-xs.png ng-if=!template.thumb class=\"img-incomplete img-responsive\"> <img alt={{template.tType}} ng-src=\"{{thumbHost + tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" ng-if=template.thumb class=img-responsive> </span><span uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.label}}</span></div><div class=col-xs-2>{{(template.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" uib-tooltip={{template.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.cBy}}</div><div class=\"col-xs-2 text-sm\"><span ng-if=\"template.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"template.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"template.tType == 6\">{{\'t.label.30\' | translate}}</span></div><div class=\"col-xs-2 text-right text-sm\">{{template.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></div><!-- Folder / template --><div ng-if=\"selectedTab === \'hub.templates.t\' || selectedTab === \'hub.sContainer.sContent\'\"><div class=\"row th\" ng-if=\"folderList.length + templateList.length > 0\"><div ng-class=\"selectedTab != \'hub.sContainer.sContent\' ? \'col-xs-4\' : \'col-xs-6\'\"><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'label\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-2 ng-if=\"selectedTab != \'hub.sContainer.sContent\'\"><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'createdon\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.2\' | translate}}</span></div><div class=col-xs-2 ng-if=\"selectedTab != \'hub.sContainer.sContent\'\"><!-- <a href=\"\" ng-if=\"isTemplateSorting\" ng-click=\"sortFx(\'createdby\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.3\' | translate}} <span ng-if=\"curSort.sortType == \'createdby\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> --> <span>{{\'cm.brief.3\' | translate}}</span></div><div ng-class=\"selectedTab != \'hub.sContainer.sContent\' ? \'col-xs-2\' : \'col-xs-4\'\"><!-- <a href=\"\" ng-if=\"isTemplateSorting\" ng-click=\"sortFx(\'type\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.label.69\' | translate}} <span ng-if=\"curSort.sortType == \'type\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> --> <span>{{\'cm.label.69\' | translate}}</span></div><div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchText, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div class=text-ellipsis ng-class=\"selectedTab != \'hub.sContainer.sContent\' ? \'col-xs-4\' : \'col-xs-6\'\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=col-xs-2 ng-if=\"selectedTab != \'hub.sContainer.sContent\'\">{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"selectedTab != \'hub.sContainer.sContent\'\" uib-tooltip={{folder.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.cBy}}</div><div class=text-sm ng-class=\"selectedTab != \'hub.sContainer.sContent\' ? \'col-xs-2\' : \'col-xs-4\'\">{{folder.type}}</div><div class=\"col-xs-2 text-right text-sm\">{{folder.d}}</div></li><li class=row ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:searchText, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.tType}} data-extn={{template.extn}} ng-class=\"{\'unapprovedFile\':template.isApproved == 0, \'nonSelectable unapprovedFile\':isNonSelectable}\" ng-if=\"$state.includes(\'hub.templates.t\') && (filter == \'all\' || (filter == \'myContent\' && template.owner == 1) || (filter == \'approved\' && template.isApproved == 1) || (filter == \'unapproved\' && template.isApproved == 0) || filter == template.type)\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-enable=\"template.isApproved === 0\" tooltip-append-to-body=true context-menu=contextMenuOpt><div class=\"col-xs-4 text-ellipsis clViwe tList-thumb\"><span class=cl-cIcon><img alt=Incomplete src=assets/images/default/incomplete-xs.png ng-if=!template.thumb> <img alt={{template.tType}} ng-src=\"{{thumbHost + tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" class=img-responsive> <img alt=na ng-src=\"{{thumbHost + tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span> </span></span><span uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.label}}</span></div><div class=col-xs-2>{{(template.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" uib-tooltip={{template.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.cBy}}</div><div class=\"col-xs-2 text-sm\"><span ng-if=\"template.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"template.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"template.tType == 6\">{{\'t.label.30\' | translate}}</span></div><div class=\"col-xs-2 text-right text-sm\">{{template.d}}</div></li><li class=row ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:searchText, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.tType}} data-extn={{template.extn}} ng-class=\"{\'unapprovedFile\':template.isApproved == 0, \'nonSelectable unapprovedFile\':isNonSelectable}\" ng-if=\"$state.includes(\'hub.templates.t\') != true && (filter == \'all\' || (filter == \'myContent\' && template.owner == 1) || (filter == \'approved\' && template.isApproved == 1) || filter == template.type) &&  template.isApproved == 1\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-enable=\"template.isApproved === 0\" tooltip-append-to-body=true context-menu=contextMenuOpt><div class=\"col-xs-6 text-ellipsis clViwe tList-thumb\"><span class=cl-cIcon><img alt=Incomplete src=assets/images/default/incomplete-xs.png ng-if=!template.thumb> <img alt={{template.tType}} ng-src=\"{{thumbHost + tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" class=img-responsive> <img alt=na ng-src=\"{{thumbHost + tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span> </span></span><span uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.label}}</span></div><div class=\"col-xs-4 text-sm\"><span ng-if=\"template.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"template.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"template.tType == 6\">{{\'t.label.30\' | translate}}</span></div><div class=\"col-xs-2 text-right text-sm\">{{template.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredFolderList.length + filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"(filteredFolderList.length == 0 && filteredTemplateList.length > 0 && filterCount == 0 && ftype !=\'sp\') || (filteredFolderList.length == 0 && filteredTemplateList.length > 0 && !filterSearch && ftype !=\'sp\')\">{{\'cm.msg.15\' | translate}} <button type=button role=button class=\"btn btn-default btn-xs\" ng-click=\"filterFx(\'all\');\">{{\'cm.btn.38\' | translate}}</button></div></div>");
$templateCache.put("app/templates/dir/textEditor.html","<div id=clickOutsideTheEditor ng-mouseup=clickOutsideTheEditor()><div id=containerEditor><div><div class=\"pull-left bdrRd bdrRL8 marB5\"><!-- bold  --> <button id=boldEditor class=\"fontStyle bold\" ng-click=boldFont(); uib-tooltip=\"{{\'cm.editor.10.1\' | translate}}\"><i class=\"fa fa-bold\" aria-hidden=true></i></button><!-- italic --> <button id=italicEditor class=\"fontStyle italic\" ng-click=italicFont(); uib-tooltip=\"{{\'cm.editor.10.2\' | translate}}\"><i class=\"fa fa-italic\" aria-hidden=true></i></button><!-- underline --> <button id=underlineEditor class=\"fontStyle underline\" ng-click=underlineFont(); uib-tooltip=\"{{\'cm.editor.10.3\' | translate}}\"><i class=\"fa fa-underline\" aria-hidden=true></i></button><!-- strikethrough --> <button id=lineThroughEditor class=\"fontStyle strikethrough\" ng-click=strikethroughFont(); uib-tooltip=\"{{\'cm.editor.10.13\' | translate}}\"><i class=\"fa fa-strikethrough\" aria-hidden=true></i></button></div><div class=\"pull-left bdrRd bdrRL8 marB5\"><!-- align-left --> <button id=leftAlignEditor class=\"fontStyle align-left\" ng-click=justifyLeftFont(); uib-tooltip=\"{{\'cm.editor.10.4\' | translate}}\"><i class=\"fa fa-align-left\" aria-hidden=true></i></button><!-- align-center --> <button id=centerAlignEditor class=\"fontStyle align-center\" ng-click=justifyCenterFont(); uib-tooltip=\"{{\'cm.editor.10.5\' | translate}}\"><i class=\"fa fa-align-justify\" aria-hidden=true></i></button><!-- align-right --> <button id=rightAlignEditor class=\"fontStyle align-right\" ng-click=justifyRightFont(); uib-tooltip=\"{{\'cm.editor.10.6\' | translate}}\"><i class=\"fa fa-align-right\" aria-hidden=true></i></button></div><div class=\"pull-left bdrRd bdrRL8 marB5\"><!-- orderedlist --> <button id=oLEditor class=\"fontStyle orderedlist\" ng-click=insertOrderedListFont(); uib-tooltip=\"{{\'cm.editor.10.10\' | translate}}\"><i class=\"fa fa-list-ol\" aria-hidden=true></i></button><!-- unorderedlist --> <button id=uLEditor class=\"fontStyle unorderedlist\" ng-click=insertUnorderedListFont() uib-tooltip=\"{{\'cm.editor.10.11\' | translate}}\"><i class=\"fa fa-list-ul\" aria-hidden=true></i></button></div><div class=\"pull-left marB5\"><!-- redo-apply --> <button id=redoEditor class=\"fontStyle redo-apply\" ng-class=\"{\'cursorDisabled\': !history.forward.length}\" ng-click=redoFont(); uib-tooltip=\"{{\'cm.editor.10.8\' | translate}}\"><i class=\"fa fa-repeat\" aria-hidden=true></i></button><!-- undo-apply --> <button id=undoEditor class=\"fontStyle undo-apply\" ng-class=\"{\'cursorDisabled\': !history.back.length}\" ng-click=undoFont(); uib-tooltip=\"{{\'cm.editor.10.9\' | translate}}\"><i class=\"fa fa-undo\" aria-hidden=true></i></button><!-- clear --> <button id=clrFEditor class=\"fontStyle clear\" ng-click=\"clearFont(\'transparent\')\" uib-tooltip=\"{{\'cm.editor.10.12\' | translate}}\"><i class=\"fa fa-ban\" aria-hidden=true></i></button></div><div class=clearfix></div></div><div><div class=pull-left><!-- font-size  --><div style=display:inline-block uib-tooltip=\"{{\'cm.editor.10.16\' | translate}}\"><div class=input-group><span class=input-group-addon>{{\'cm.label.83\' | translate}}:</span> <input type=number ng-model=fontSizeValue id=sizeToInsert class=form-control min=0 style=\"width: 200px;height: 33px; font-size:12px\"> <span class=input-group-btn style=\"float: left\"><button type=button class=size-apply ng-click=insertSize() id=sizeApply class=\"btn btn-default\"><span class=\"fa fa-check\"></span> {{\"Apply Size\" | translate}}</button></span></div></div></div><div class=clearfix></div></div><div><div class=\"pull-left bdrRd bdrRL8 marB5\" style=\"height: 33px\"><!-- fontFaimly-style --><!-- <select id=\"input-font\" class=\"input fontFaimly-style\" ng-click=\"changeFont(this);\" value=\"canadra\" ng-model=\"curFrame.font\" ng-options=\"font.label for font in fontFamily track by font.value\"></select> --><div style=\"position:relative; display:inline-block\" uib-tooltip=\"{{\'cm.editor.10.17\' | translate}}\"><div id=input-font class=input-group><span class=input-group-addon>{{\'cm.label.24\' | translate}}:</span><select id=font class=\"form-control selectTemplate\" ng-change=changeFont(fontFamilyVal); value=canadra ng-model=fontFamilyVal ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div></div><div class=\"pull-left marB5\"><!-- font-color-btn --><div uib-dropdown dropdown-append-to-body auto-close=outsideClick style=\"position:relative; display:inline-block\" uib-tooltip=\"{{\'cm.editor.10.14\' | translate}}\"><button class=\"fontStyle color-btn input-group input-colorPicker\"><i class=\"fa fa-font marR5\" aria-hidden=true></i> <span ng-style=\"{\'background-color\':curText.tc}\" uib-dropdown-toggle ng-click=\"colorPickerOpen($event,\'tc\');\"></span></button><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curText.tc selected-type=curText.tcType selected-elm=\"\'tc\'\"></ng-hub-color-picker></div></div><!-- background-color-btn --><div uib-dropdown dropdown-append-to-body auto-close=outsideClick style=\"position:relative; display:inline-block\" uib-tooltip=\"{{\'cm.editor.10.15\' | translate}}\"><button class=\"fontStyle color-btn input-group input-colorPicker\"><i class=\"fa fa-paint-brush marR5\" aria-hidden=true></i> <span ng-class=\"{\'blankBg\': curText.bg == \'transparent\'}\" ng-style=\"{\'background-color\':curText.bg}\" uib-dropdown-toggle ng-click=\"colorPickerOpen($event,\'bg\');\"></span></button><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curText.bg selected-type=curText.bgType selected-elm=\"\'bg\'\"></ng-hub-color-picker></div></div></div><input type=text id=textEditorHidden><div class=clearfix></div></div><!-- <div id=\"tTextEditor\" contenteditable=\"true\" ng-model=\"curFrame.text\" ng-readonly=\"curFrame.feedRef == 1\" ng-paste=\"removeAllFormate($event)\"></div> --><div id=tTextEditor class=scroll-hidden contenteditable=true ng-model=curFrame.text ng-readonly=\"curFrame.feedRef == 1\" ng-paste=removeAllFormate($event) ng-blur=displayTextInserter(); ng-mouseup=getStyleText(); ng-attr-style=background-color:{{curFrame.rgba}}></div></div></div>");
$templateCache.put("app/templates/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'tEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'tMove\'\">{{\'cm.btn.50\' | translate}}</span> <span ng-if=\"btn.key==\'tApprove\'\">{{\'cm.btn.24\' | translate}}</span> <span ng-if=\"btn.key==\'tUnapprove\'\">{{\'cm.btn.25\' | translate}}</span> <span ng-if=\"btn.key==\'tSchedule\'\">{{\'cm.btn.27\' | translate}}</span> <span ng-if=\"btn.key==\'tAddToSchedule\'\">{{\'cm.btn.28\' | translate}}</span> <span ng-if=\"btn.key==\'tDuplicate\'\">{{\'cm.btn.30\' | translate}}</span> <span ng-if=\"btn.key==\'tDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'tlUse\'\">{{\'t.btn.2\' | translate}}</span></div><div class=text-ellipsis-wrap ng-if=\"btn.key!=\'tlUse\'\">{{\'btnInfo.\'+ btn.code | translate}}</div><div class=text-ellipsis-wrap ng-if=\"btn.key==\'tlUse\'\" translate=\"{{\'btnInfo.\'+ btn.code}}\" translate-values=\"{htmlTag:\'<br>\',htmlTagO:\'<div class=\\\'marL10\\\'>\',htmlTagC:\'</div>\'}\"></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/dSampleExcel.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'t.label.15\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=excelOpenObj.loading><div ng-if=!excelOpenObj.loading class=text-center><div ng-if=!excelOpenObj.url>{{\'r.msg.2\' | translate}}</div><p translate=\"{{\'cm.body.11\'}}\" translate-values=\"{htmlTagO: \'<b>&quot;\', htmlTagC: \'&quot;</b>\'}\"></p><div ng-if=!excelOpenObj.surl><a href={{excelOpenObj.url}} role=link download target=_blank class=\"btn btn-link text-lg\"><span class=\"fa fa-download\" aria-hidden=true></span> {{\'cm.btn.17\' | translate}} <span ng-if=excelOpenObj.size>({{(excelOpenObj.size*1024) | filesize}})</span></a></div><div class=\"row marT15 marRL10 padTB15 text-left bg-light\"><div class=col-xs-12><label>{{\'t.msg.20\' | translate}}</label><ol class=padL20><li><span>{{\'t.step.1\' | translate}}</span></li><li><span>{{\'t.step.2\' | translate}}</span></li><li><span>{{\'t.step.3\' | translate}}</span></li></ol><span class=marT10>{{\'t.step.other\' | translate}}</span></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/dTextList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'t.btn.4\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-35\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!dTextList.dText.length><div class=\"table table-scroll\" ng-if=dTextList.dText.length><div class=\"row th\"><div class=col-xs-4>{{\'cm.label.74\' | translate | capitalize}}</div><div class=col-xs-8>{{\'cl.widget.sp.13\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"menu in filteredList = (dTextList.dText | orderBy:(auth.upreferences.dmbsort == \'d\' ? \'-z\' : \'\') | customSearch:{key:searchTextPopup, module:\'dText\'})\"><div class=col-xs-4>{{menu.name}}</div><div class=col-xs-8><input type=text class=\"form-control input-sm price\" ng-model=menu.frametext maxlength=999999999 ng-if=!menu.isMT><div class=mt-tags ng-if=\"menu.isMT && menu.mt.length\"><div ng-repeat=\"mtItem in menu.mt\" class=mt-tag ng-class=\"{\'editing\':mtItem.editing}\"><span ng-if=!mtItem.editing class=mt-tag-text>{{mtItem.t}}</span> <input type=text ng-if=mtItem.editing class=mt-tag-input ng-model=mtItem.editText maxlength=999999999 ng-keydown=\"handleKeyDown($event, mtItem)\"><div class=mt-tag-actions><a href=\"\" ng-if=!mtItem.editing ng-click=\"mtActionFx(\'e\', mtItem)\"><span class=\"fa fa-pencil\"></span></a> <a href=\"\" ng-if=mtItem.editing ng-click=\"mtActionFx(\'s\', mtItem)\" class=\"padLR2 marL5\"><span class=\"fa fa-check text-success\"></span></a> <a href=\"\" ng-if=mtItem.editing ng-click=\"mtActionFx(\'c\', mtItem)\" class=padLR2><span class=\"fa fa-remove text-danger\"></span></a></div></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer ng-if=dTextList.dText.length><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=dTextEditFx(); ng-disabled=dTextListProcessing><span ng-class=\"dTextListProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{dTextListProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType == \'data\'\" aria-live=polite role=status>{{\'cm.msg.40\' | translate}}</span> <span ng-if=\"errType == \'editMode\'\" aria-live=polite role=status>{{\'t.msg.43\' | translate}}</span> <span ng-if=\"errType == \'editEmpty\'\" aria-live=polite role=status>{{\'t.msg.44\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/folderCU.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"!ngDialogData.id && (folder.info.fType == \'n\' ||  folder.info.fType == \'template\')\" role=heading aria-level=1>{{\'cl.p_f.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.id && (folder.info.fType == \'n\' ||  folder.info.fType == \'template\')\" role=heading aria-level=1>{{\'cl.p_f.2\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=label>{{\'cl.p_f.3\' | translate}}</label><input type=text id=label class=form-control ng-model=folder.info.label autocomplete=off maxlength={{inputLimit}} aria-label=\"{{\'cl.p_f.3\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.3\' | translate}}\"></div><div class=\"form-group marT10\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=folder.permission pid=decId module=\"\'tFolder\'\"></ng-permission-brief></div></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=folderCUFx(); ng-disabled=saveProcessing><span ng-if=!ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-plus-circle\'\" aria-hidden=true></span>{{\'cm.btn.14\' | translate}}</span> <span ng-if=ngDialogData.id><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'cl.p_f.m1\' | translate}}</div><div ng-if=\"errType==\'folder\'\" aria-live=polite role=status>{{\'cl.p_f.m4\' | translate}}</div><div ng-if=\"errType==\'library\'\" aria-live=polite role=status>{{\'cl.p_f.m3\' | translate}}</div><div ng-if=\"errType==\'permission\'\" aria-live=polite role=status>{{\'cm.msg.3\' | translate}}</div><div ng-if=\"errType==\'authFailed\'\" aria-live=polite role=status>{{\'cl.widget.msg.11\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/templates/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'t\'\" role=heading aria-level=1>{{\'t.tool.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ut\'\" role=heading aria-level=1>{{\'t.tool.3\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'it\'\" role=heading aria-level=1>{{\'t.tool.4\' | translate}}</h1></header><div class=panel-body><div ng-if=\"ngDialogData.tabName==\'t\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'t.info.t1\' | translate}}</p><img alt=\"\" src=assets/images/info/t.gif></div><div ng-if=\"ngDialogData.tabName==\'ut\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'t.info.ut1\' | translate}}</p><img alt=\"\" src=assets/images/info/ut.png></div><div ng-if=\"ngDialogData.tabName==\'it\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'t.info.it1\' | translate}}</p><img alt=\"\" src=assets/images/info/it.png></div></div></section>");
$templateCache.put("app/templates/popup/move.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{moveObj.type==\'move\'?\'t.body.4\':\'t.body.8\' | translate}}</h1><div class=\"searchTbx bdrR\" ng-show=\"selectedT==1\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><div class=\"panel-inner-tab marB10 hide\"><a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'1\'}\" ng-click=\"tabFx(1, \'tabFx\');searchTextPopup=\'\'\">{{\'cl.p_m.2\' | translate}}</a> <a href=\"\" role=link ng-class=\"{\'selected\':selectedT==\'2\'}\" ng-click=\"tabFx(2, \'tabFx\');searchTextPopup=\'\'\">{{\'cl.p_m.3\' | translate}}</a></div><div class=form-group><div class=\"bg-light pad5\" role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=typeOpt ng-model=moveObj.type value=move ng-change=changeTypeFx()><label></label>{{\'cl.p_m.4\' | translate}}</label><label class=noMarB><input type=radio role=radio name=typeOpt ng-model=moveObj.type value=copy ng-change=changeTypeFx()><label></label>{{\'cl.p_m.5\' | translate}}</label></div></div><img alt=Loading src=assets/images/loading.gif ng-if=moveLoading><div ng-if=\"selectedT==\'1\'\"><div class=\"bg-light moveTreeContainer\"><div><label ng-class=\"{\'disabledRow\':!auth.upermissions.art}\"><input type=radio role=radio name=treeOpt value=0 ng-checked=auth.upermissions.art ng-disabled=!auth.upermissions.art><label></label>{{\'cl.p_m.6\' | translate}}</label><tree list=moveObj.curServerTree search-text=searchTextPopup check-disable=true class=\"list-unstyled moveTree\"></tree></div></div></div><div ng-if=\"!moveLoading && selectedT==\'2\'\"><div class=\"form-group noMarB\"><label for=server>{{\'cl.p_m.7\' | translate}}</label><select class=form-control id=server ng-model=moveObj.server ng-change=changeServerFx() ng-options=\"server.label for server in serverList | orderBy:\'label\' track by server.id\" aria-label=\"{{\'cl.p_m.7\' | translate}}\" aria-labelledby=\"{{\'cl.p_m.7\' | translate}}\"><option value=\"\">{{\'cl.p_m.7\' | translate}}</option></select></div></div><div class=\"marT15 errMsg\" ng-if=\"arError || fError || cError || wError\"><p><span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.m3\' | translate}}:</span> <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.m4\' | translate}}:</span></p><div ng-if=arError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m5\' | translate}}</div><div ng-if=fError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m6\' | translate}}</div><div ng-if=cError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m11\' | translate}}</div><div ng-if=wError><span class=\"fa fa-circle valign-middle text-xs marR5\" aria-hidden=true></span>{{\'cl.p_m.m8\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button ng-click=moveFx(moveObj.type); class=\"btn btn-success\" ng-disabled=\"arError || fError || cError || wError || moveProcessing\"><span class=\"fa fa-check\" ng-if=!moveProcessing aria-hidden=true></span> <span class=\"fa fa-repeat fa-spin\" ng-if=moveProcessing aria-hidden=true></span> <span ng-if=\"moveObj.type == \'move\'\">{{\'cl.p_m.4\' | translate}}</span> <span ng-if=\"moveObj.type == \'copy\'\">{{\'cl.p_m.5\' | translate}}</span></button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType == \'folder\'\" aria-live=polite role=status>{{\'cl.p_m.m1\' | translate}}</div><div ng-if=\"errType == \'server\'\" aria-live=polite role=status>{{\'cl.p_m.m2\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/odContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup.txt sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.txt.length ng-click=\"searchTextPopup.txt=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=\"panel-body scrollQuad\" style=max-height:{{getAvailableHeight(304)}}px><div class=breadcrumb ng-class=\"{\'marB5\':content.items}\" ng-if=\"breadCrumbs.length > 1 && !openingLoading\"><span ng-repeat=\"breadcrumb in breadCrumbs | reverse\"><a href=\"\" role=link ng-click=\"folderODContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}<span ng-if=\"breadcrumb.label==\'\'\" class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><ul class=\"list-inline thumb-list cl-list\" ng-if=!contentLoading><li ng-repeat=\"folder in filteredContentList = (content.items | customSearch:{key:searchTextPopup.txt, module:\'odc\', filterType:filter})\" ng-if=\"folder.type==\'folder\'\" ng-dblclick=\"selectODFx($event, \'folder\', folder);\"><div><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type == \'folder\'\" class=oneDrive></span></span></span></div><div class=thumb-label>{{folder.name}}</div></div></li><li ng-repeat=\"content in filteredContentList = (content.items | customSearch:{key:searchTextPopup.txt, module:\'odc\', filterType:filter})\" ng-click=\"selectODFx($event, \'content\', content, content.type);\" ng-if=\"content.type==\'content\'\"><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/od.png ng-if=\"content.type == \'OneDriveC\' || content.type==\'content\'\" class=img-responsive></span></div><div class=\"thumb-label text-ellipsis\">{{content.name}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderList.length + content.items.length > 0 && filteredFolderList.length + filteredContentList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup.txt)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && (content.items.length == 0 || !content.items)\">{{\'cl.msg.36\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-if=\"content.items.length > 0\" ng-disabled=ODContentLoading ng-click=saveODContentFx();><span class=\"fa fa-check\" ng-class=\"ODContentLoading?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{ODContentLoading?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-disabled=ODContentLoading ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=useContentErr.empty aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=hasPopErr aria-live=polite role=status><div ng-if=\"errType == \'odContent\'\" aria-live=polite role=status>{{\'t.msg.33\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/scheduleList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.2\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=!popupLoading><div class=col-xs-12><div class=\"table table-scroll dTable\" role=table><div class=\"row th\" ng-if=\"filtered.a.length + filtered.i.length\"><div ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{\'cm.brief.1\' | translate}}</div><div class=col-xs-5>{{\'cm.label.9\' | translate | camelCase}}</div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right\" ng-if=countList.info.isEditable>{{\'cm.label.25\' | translate}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filtered.a.length + filtered.i.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div><div class=scrollQuad callback=sortCallback() ng-attr-style=\"max-height:{{getAvailableHeight(371) + \'px\'}}\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.a = (countList.schedules.a | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\"><!-- Sortable --> {{count.label}}</div><div class=\"col-xs-5 text-ellipsis text-sm\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right noPadL\" ng-if=countList.info.isEditable><div class=btn-group ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.np ng-click=\"editScheduleFx(count.id, \'np\');\">{{\'cm.brief.1\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.s ng-click=\"editScheduleFx(count.id, \'s\');\">{{\'cm.label.3\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.c ng-click=\"editScheduleFx(count.id, \'c\');\">{{\'cm.label.1\' | translate}}</a></li><li><a href=\"\" role=link ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" ng-click=\"editScheduleFx(count.id, \'d\');\">{{\'cm.label.4\' | translate}}</a></li><li><a href=\"\" role=link ng-if=\"auth.upermissions.se.f && count.schType == 0\" ng-click=\"editScheduleFx(count.id, \'f\');\">{{\'s.body.4\' | translate}}</a></li></ul></div></div></div><div ng-if=countList.schedules.i.length class=marT10 ng-class=\"{\'marT20\':filtered.a.length}\"><div class=panel-inner-tab ng-if=filtered.i.length>{{\'d.p_h.8\' | translate}}</div><div class=\"table table-scroll\"><div class=\"row frameRow\" ng-repeat=\"count in filtered.i = (countList.schedules.i | orderBy:count.sortOrder | customSearch:{key:searchTextPopup, module:\'s\'})\" data-ids={{count.id}} data-index=\"{{$index + 1}}\" data-id={{count.fid}} ng-mouseover=\"highlightFx(count.fid, \'item\')\" ng-mouseleave=unhilightFx()><div class=text-ellipsis-wrap ng-class=\"countList.info.isEditable?\'col-xs-4\':\'col-xs-6\'\">{{count.label}}</div><div class=\"col-xs-5 text-ellipsis text-sm\"><span ng-if=count.startDate>{{count.startDate}} - </span><span ng-if=count.endDate>{{count.endDate}}</span></div>{{isEditable = (!auth.upermissions.se.np && !auth.upermissions.se.s && !auth.upermissions.se.c && !auth.upermissions.se.d && !auth.upermissions.se.dt && !auth.upermissions.se.dg && count.schType > 0) ? false : true; \"\"}}<div class=\"col-xs-3 text-right noPadL\" ng-if=countList.info.isEditable><div class=btn-group ng-if=countList.info.isEditable uib-dropdown dropdown-append-to-body><button type=button role=button ng-if=isEditable ng-click=editScheduleFx(count.id); class=\"btn btn-primary btn-xs\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=isEditable class=\"btn btn-primary btn-xs\" uib-dropdown-toggle><span class=caret></span><span class=sr-only>Toggle Dropdown</span></button><ul class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.np ng-click=\"editScheduleFx(count.id, \'np\');\">{{\'cm.brief.1\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.s ng-click=\"editScheduleFx(count.id, \'s\');\">{{\'cm.label.3\' | translate}}</a></li><li><a href=\"\" role=link ng-if=auth.upermissions.se.c ng-click=\"editScheduleFx(count.id, \'c\');\">{{\'cm.label.1\' | translate}}</a></li><li><a href=\"\" role=link ng-if=\"auth.upermissions.se.d || auth.upermissions.se.dt || auth.upermissions.se.dg\" ng-click=\"editScheduleFx(count.id, \'d\');\">{{\'cm.label.4\' | translate}}</a></li><li><a href=\"\" role=link ng-if=\"auth.upermissions.se.f && count.schType == 0\" ng-click=\"editScheduleFx(count.id, \'f\');\">{{\'s.body.4\' | translate}}</a></li></ul></div></div></div></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><!-- Sortable --> <button type=button role=button class=btn ng-click=closeThisDialog(); ng-class=\"isSorted?\'btn-link\':\'btn-default\'\" data-dismiss=modal>{{isSorted?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/selectContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.32\' | translate | camelCase}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"btn-link pad5 marLR5\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-click=\"folderContentFx(curFolderIds, \'\',\'\',\'refresh\'); searchChangeFx(\'empty\')\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx bdrR input-group\" style=width:200px><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li ng-if=\"contentObj.type != \'dmb\'\"><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'tcl\',\'\',template.info.tType);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=panel-body><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><div class=breadcrumb ng-if=\"contentObj.type != \'dmb\' && breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div class=breadcrumb ng-if=\"contentObj.type == \'dmb\' && breadCrumbs.length > 0 && !advSearch\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx( breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=\"!$last && breadcrumb.clickable\">{{breadcrumb.label}}</a> <span ng-if=\"$last || !breadcrumb.clickable\">{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div ng-if=\"!contentLibraryLoading && !advSearch && (folderList.length > 0 || contentList.length > 0)\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4)?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.gd || (odSp.auth && odSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><ul class=\"list-inline thumb-list overflow-auto\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'t\'\" element-height=getAvailableHeight(340) ng-attr-style=max-height:{{getAvailableHeight(400)}}px><ng-content-list class=show id=\"{{contentLibrary.info.writable && (folderList.length > 0 || contentList.length > 0)?\'content-list\':\'\'}}\" ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled overflow-auto\" ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'l\'\" element-height=getAvailableHeight(340) ng-attr-style=max-height:{{getAvailableHeight(400)}}px><ng-content-list-view class=show id=\"{{contentLibrary.info.writable && (folderList.length > 0 || contentList.length > 0)?\'content-list\':\'\'}}\" ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && contentList.length == 0 && folderList.length == 0 && !advSearch\">{{\'cm.msg.7\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/selectFolder.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.p_f.9\' | translate | camelCase}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=folderLoading><div class=\"bg-light moveTreeContainer\" ng-if=!folderLoading><label><span class=\"fa fa-home\" aria-hidden=true></span> {{\'cl.p_m.6\' | translate}}</label><tree list=treeList check-disable=true selectednode=selectednode class=\"list-unstyled moveTree\" role=tree aria-orientation=vertical></tree></div></div><footer class=panel-footer ng-if=!folderLoading><span class=btnQuad><button type=button role=button aria-label=\"{{\'fl.p_assign.body.11\' | translate}}\" class=\"btn btn-success\" ng-click=folderFx(treeList.type); ng-disabled=folderProcessing><span class=fa ng-class=\"folderProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span> {{\'fl.p_assign.body.11\' | translate}}</button> <button type=button role=button aria-label=\"{{\'cm.btn.9\' | translate}}\" class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><span ng-if=\"errTypePop==\'target\'\" aria-live=polite role=status>{{\'cl.p_f.m4\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/selectSingleDContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.32\' | translate | camelCase}}</h1><div class=\"pull-right bdrR marR10\"><a href=\"\" role=link id=refresh class=\"btn-link padLR5 marLR5\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" tooltip-append-to-body=true ng-click=\"folderContentFx(curFolderIds, \'\',\'\',\'refresh\'); search.text=\'\'\" ng-disabled=\"loading || contentLibraryLoading\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx bdrR\" ng-class=\"{\'input-group\':contentObj.type != \'dmb\'}\" style=width:200px><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"search.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"contentObj.type != \'dmb\'\"><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'tcl\');\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=panel-body><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><div class=breadcrumb ng-if=\"contentObj.type != \'dmb\' && breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div class=breadcrumb ng-if=\"contentObj.type == \'dmb\' && breadCrumbs.length > 0 && !advSearch\"><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=\"!$last && breadcrumb.clickable\">{{breadcrumb.label}}</a> <span ng-if=\"$last || !breadcrumb.clickable\">{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLibraryLoading><div ng-if=\"!contentLibraryLoading && !advSearch\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4)?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><!-- googledrive --><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.gd || (odSp.auth && odSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><ul class=\"list-inline thumb-list overflow-auto\" element-height=getAvailableHeight(340) ng-attr-style=max-height:{{getAvailableHeight(400)}}px ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'t\'\"><li ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder, folder.type, folder.splId);\"><div><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type==\'Shortcut\'\" class=shortcut aria-hidden=true></span> <span ng-if=\"folder.type==\'Sharepoint\'\" class=sharepoint aria-hidden=true></span> <span ng-if=\"folder.type==\'Onedrive\'\" class=oneDrive aria-hidden=true></span> <span ng-if=\"folder.type==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type==\'Googledrive\'\" class=googleDrive aria-hidden=true></span> <span ng-if=\"folder.type==\'Folder\' && folder.subtype==\'SharedFolder\'\" class=sharedFolder aria-hidden=true></span> <span ng-if=\"folder.type != \'Shortcut\' && folder.type != \'Sharepoint\' && folder.type != \'Onedrive\' && folder.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.label}}</div></div></li><li ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:search.text, module:\'cl\', filterType:filter})\" ng-click=\"selectFx($event, \'content\', content, content.type);\"><div class=thumb-img><span class=thumb-inner ng-class=\"{\'blurry-img\':content.isblur}\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type != \'SharePointC\'\"> <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type != \'SharePointC\' && content.type == \'Flash\'\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/n/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/n/od.png ng-if=\"content.type == \'OneDriveC\'\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/n/gd.png ng-if=\"content.type == \'GoogleDriveC\'\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type != \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label>{{content.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderList.length + contentList.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && search.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div></ul><ul class=\"table table-md ui-selectable list-unstyled overflow-auto\" element-height=getAvailableHeight(340) ng-attr-style=max-height:{{getAvailableHeight(400)}}px ng-if=\"!contentLibraryLoading && auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.2\' | translate}}</div>\r\n        <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 noPad\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder, folder.type, folder.splId);\"><div class=\"col-xs-4 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><!-- <div class=\"col-xs-2\">{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{folder.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{folder.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{folder.type}}</div><div class=\"col-xs-2 noPad text-sm\">{{(folder.ps) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{folder.d}}</div></li><li class=row ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:search.text, module:\'cl\', filterType:filter})\" ng-click=\"selectFx($event, \'content\', content, content.type);\" ng-if=content.isCompleted><div class=\"col-xs-4 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-2 noPad text-sm\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{content.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderList.length + contentList.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && search.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && folderList.length + contentList.length == 0 && !advSearch\">{{\'cm.msg.7\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLibraryLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/templateList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'t.body.3\' | translate}}</h1><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><img alt=Loading src=assets/images/loading.gif ng-if=!templateCountList.template.length><ul class=\"list-inline thumb-list noHover\" ng-if=templateCountList.template><li class=noMar ng-repeat=\"template in filteredTemplateList = (templateCountList.template | filter:{label:searchTextPopup})\"><div class=thumb-img><span class=thumb-inner uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{template.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><a ng-if=template.isCompleted ng-href=\"{{cDetailBucket + template.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{template.label}}><img alt=\"\" ng-src=\"{{templateCountList.info.timthumb + cBucket + template.thumb + thumbParam}}\" class=\"img-responsive center-block\"></a></span></div><div class=\"thumb-label text-ellipsis\" uib-tooltip={{template.label}}>{{template.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/templates/popup/useTemplate.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'t.btn.2\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(335)}}px><img alt=Loading src=assets/images/loading.gif ng-if=templateLoading><div class=marB15 translate=\"{{\'t.msg.12\'}}\" translate-values=\"{htmlTagO: \'<b>\', htmlTagC:\'</b>\'}\"></div><div class=form-group><label for=name>{{\"t.label.1\" | translate}}</label><input type=text id=name class=form-control ng-model=useTampObj.name maxlength={{inputLimit}} focus-me=true aria-label=\"{{\'t.label.1\' | translate}}\" aria-labelledby=\"{{\'t.label.1\' | translate}}\"></div><div class=form-group><label>{{\"t.label.5.1\" | translate}}</label><div class=\"bg-light moveTreeContainer\" style=max-height:200px><div><label ng-class=\"{\'disabledRow\':!auth.upermissions.art}\"><input type=radio role=radio name=treeOptTF value=0 ng-checked=auth.upermissions.art ng-disabled=!auth.upermissions.art><label></label>{{\"cl.p_m.6\" | translate}}</label><tree-tf list=useTampObj.curFolderTree check-disable=true class=\"list-unstyled moveTree\"></tree-tf></div></div></div><div class=\"form-group msg-warning\" lang={{auth.lang}}>{{\"t.msg.15\" | translate}}</div><div class=form-group><label for=folderName>{{\"cl.p_f.3\" | translate}}</label><input type=text id=folderName class=form-control ng-model=useTampObj.folderName maxlength={{inputLimit}} aria-label=\"{{\'cl.p_f.3\' | translate}}\" aria-labelledby=\"{{\'cl.p_f.3\' | translate}}\"></div><div class=form-group><label>{{\"t.label.5\" | translate}}</label><div class=\"bg-light moveTreeContainer\" style=max-height:200px><div><label ng-class=\"{\'disabledRow\':!auth.upermissions.ar}\"><input type=radio role=radio name=treeOpt value=0 ng-checked=auth.upermissions.ar ng-disabled=!auth.upermissions.ar><label></label>{{\"cl.p_m.6\" | translate}}</label><tree list=useTampObj.curServerTree check-disable=true class=\"list-unstyled moveTree\"></tree></div></div></div><div class=form-group><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=useTampObj.permission pid=decId module=\"\'template\'\"></ng-permission-brief></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=confirmUseFx(); ng-disabled=templateProcessing><span ng-class=\"templateProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{templateProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'name\'\" aria-live=polite role=status>{{\'t.msg.8\' | translate}}</span> <span ng-if=\"errType==\'target\'\" aria-live=polite role=status>{{\'t.msg.17\' | translate}}</span> <span ng-if=\"errType==\'targetTF\'\" aria-live=polite role=status>{{\'t.msg.17.1\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/support/featureRequest/af.html","<img alt=Loading src=assets/images/loading.gif ng-if=featureRLoading><div ng-if=\"!featureRLoading && featureR.length > 0\"><ng-featuer-list></ng-featuer-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!featureRLoading && featureR.length == 0\"><p>{{\'sc.fr.msg.6\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'af\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'sc.fr.msg.7\' | translate}}</a></div></div>");
$templateCache.put("app/support/featureRequest/afv.html","<section class=panel><header class=panel-heading>View Feature Request<a ui-sref=h.requestFeature.acceptedFeaturesTab role=button class=\"btn btn-warning btn-xs pull-right\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.11\' | translate}}</a></header><div class=panel-body><ul class=\"list-inline vote-list\"><li><div class=vote-count><div class=text-ellipsis>3</div><a href=\"\" role=link class=\"btn btn-primary btn-sm\">Vote</a></div><div class=vote-contant><h5>Weather Forecast Widget</h5><div class=\"text-sm text-muted\">Chris</div><div>The current weather widget is good but only lets you know what is happening now. A forecasting widget should also be added (5-7 days out). Tim Horton\'s TV has is a great example.</div><div class=\"marT5 text-sm text-bold\">07 Dec, 2015 08:29 PM</div></div></li></ul></div></section><section class=panel><header class=panel-heading>Comments on Weather Forecast Widget</header><div class=panel-body><div class=msg-warning lang={{auth.lang}}>No Comments found</div><div>&nbsp;</div><ul class=\"list-inline vote-list\"><li><h5>Gaurav</h5><div class=text-ellipsis-wrap>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div><ul class=\"list-inline list-pipe marT5 text-sm\"><li><span class=\"text-bold text-muted\">15 Dec, 2015 12:44 PM</span></li></ul></li><li><h5>Gaurav</h5><div class=text-ellipsis-wrap>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div><ul class=\"list-inline list-pipe marT5 text-sm\"><li><span class=\"text-bold text-muted\">15 Dec, 2015 12:44 PM</span></li></ul></li></ul></div></section>");
$templateCache.put("app/support/featureRequest/featureDetails.html","<div class=pageHeading><a href=\"\" role=link class=marR10 ui-sref=hub.support.fr.rf>{{\'sc.tab.2\' | translate}}</a>/<span class=\"marL10 marR10\">{{\'sc.fr.body.4\' | translate}}</span></div><section class=panel><div class=\"panel-body pad20\"><img alt=Loading src=assets/images/loading.gif ng-if=featureRLoading><div ng-if=!featureRLoading><ul class=\"list-inline vote-list vote-list-inner\"><li><div class=vote-quad><div class=text-muted>{{\'sc.fr.p_comment.body.1\' | translate}}:</div><div class=\"marB5 vote-count\">{{featureR.info.votes}}</div><div uib-tooltip={{votedMsg}} tooltip-enable=\"featureR.info.isVoted || featureR.info.isOwner\" tooltip-placement=left ng-if=\"featureR.info.status != 1 && featureR.info.status != 2\"><!-- Status 1 = Accepted; 2 = Implemented--> <button type=button role=button ng-click=saveVotesFx(); class=\"btn btn-primary btn-block btn-xs\" ng-disabled=\"votesProcessing || featureR.info.isVoted || featureR.info.isOwner\"><span class=\"fa fa-thumbs-o-up\" aria-hidden=true></span>{{\'sc.fr.p_comment.btn.1\' | translate}}</button></div></div><div class=vote-contant><h5 class=word-break><div class=\"pull-left marB2 marR5\">{{featureR.info.title}}</div><div class=\"pull-left bg-info pad2\" ng-if=\"featureR.info.status == 1\">{{\'sc.fr.body.8\' | translate}}</div><div class=\"pull-left bg-success pad2\" ng-if=\"featureR.info.status == 2\">{{\'sc.fr.body.9\' | translate}}</div></h5><div class=\"marT5 text-muted text-sm\">{{featureR.info.label}}</div><div class=\"marB10 text-sm text-bold\">{{(featureR.info.createdOn * 1000) | date:\"medium\"}}</div><div class=word-break>{{featureR.info.description}}</div></div></li></ul><div>&nbsp;</div><header class=\"panel-inner-tab marT25 marB10\">{{\'sc.fr.p_comment.body.2s\' | translate}}</header><ul class=\"list-inline vote-list\" ng-if=\"featureR.comments.length > 0\"><li ng-repeat=\"fc in featureR.comments\"><h5>{{fc.label}}</h5><div class=text-ellipsis-wrap>{{fc.description}}</div><ul class=\"list-inline list-pipe marT5 text-sm\"><li class=\"text-bold text-muted\">{{(fc.createdOn * 1000) | date:\"medium\"}}</li><li ng-if=\"fc.isOwner == 0\"><a href=\"\" role=link class=btn-link ng-click=\"reportRequestFx(fc.id, \'comment\');\" ng-disabled=reportProcessing>{{\'sc.fr.p_comment.body.5\' | translate}}</a></li><li ng-if=\"fc.isOwner || auth.uType == 0\"><a href=\"\" role=link ng-click=\"commentsOpen(fc.id, fc.description);\" class=\"text-primary marR5\"><span class=\"fa fa-pencil\" aria-hidden=true></span> {{\'cm.btn.22\' | translate}}</a> <a href=\"\" role=link ng-click=\"deleteOpen(fc.id, \'comment\');\" class=text-danger><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.13\' | translate}}</a></li></ul></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"featureR.comments.length == 0\">{{\'sc.fr.p_comment.msg.5\' | translate}}</div></div></div></section><section class=panel><header class=panel-heading>{{\'sc.fr.p_comment.body.4\' | translate}}</header><div class=panel-body><textarea class=form-control ng-model=comment id=addNewComment placeholder=\"{{\'cm.ph.4\' | translate}}\" rows=4 maxlength={{commentLimit}} aria-label=\"{{\'cm.ph.4\' | translate}}\" aria-labelledby=\"{{\'cm.ph.4\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{commentLimit - comment.length}} ]</span></div><div class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveCommentsFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.42\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status>{{\'sc.fr.p_comment.msg.4\' | translate}}</div><div class=clearfix></div></div></section>");
$templateCache.put("app/support/featureRequest/featureRequest.html","<div class=spaceH></div><section><header class=panel-inner-tab><a ui-sref-active=selected ui-sref=.rf role=tab aria-selected=\"{{selectedTab===\'hub.support.fr.rf\'}}\" aria-controls=subTab-1 id=subTab-1>{{\'sc.fr.body.2\' | translate}}</a> <a ui-sref-active=selected ui-sref=.af role=tab aria-selected=\"{{selectedTab===\'hub.support.fr.af\'}}\" aria-controls=subTab-2 id=subTab-2>{{\'sc.fr.body.3\' | translate}}</a> <a ui-sref-active=selected ui-sref=.im role=tab aria-selected=\"{{selectedTab===\'hub.support.fr.im\'}}\" aria-controls=subTab-3 id=subTab-3>{{\'sc.fr.body.10\' | translate}}</a><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=\"panel-body marT15\"><div ui-view=tabView role=tabpanel></div></div></section>");
$templateCache.put("app/support/featureRequest/im.html","<img alt=Loading src=assets/images/loading.gif ng-if=featureRLoading><div ng-if=\"!featureRLoading && featureR.length > 0\"><ng-featuer-list></ng-featuer-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!featureRLoading && featureR.length == 0\"><p>{{\'sc.fr.msg.8\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'im\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'sc.fr.msg.9\' | translate}}</a></div></div>");
$templateCache.put("app/support/featureRequest/rf.html","<img alt=Loading src=assets/images/loading.gif ng-if=featureRLoading><div ng-if=\"!featureRLoading && featureR.length > 0\"><ng-featuer-list></ng-featuer-list></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!featureRLoading && featureR.length == 0\"><p>{{\'sc.fr.msg.4\' | translate}}</p><div class=marB5><a href=\"\" role=link ng-click=\"readMeFx(\'rf\');\"><span class=\"fa fa-info-circle\" aria-hidden=true></span> {{\'sc.fr.msg.5\' | translate}}</a></div></div>");
$templateCache.put("app/support/popup/bugs.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'sc.bug.1\' | translate}}</h1></header><div class=panel-body><!-- <img alt=\"Loading\" src=\"assets/images/loading.gif\" ng-if=\"bugsLoading\"> --><!-- <div ng-if=\"!bugsLoading\">\r\n      <p translate=\"{{\'sc.bug.2\'}}\" translate-values=\"{lsn: \'L&nbsp;Squared&nbsp;Hub\'}\"></p>\r\n      <div>&nbsp;</div>\r\n      <div class=\"form-group\">\r\n        <div class=\"form-group noMarB\">\r\n          <label for=\"subject\">{{\'cm.label.23\' | translate}}</label>\r\n          <input type=\"text\" id=\"subject\" class=\"form-control\" ng-model=\"bugs.subject\" aria-label=\"{{\'cm.label.23\' | translate}}\" aria-labelledby=\"{{\'cm.label.23\' | translate}}\">\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label for=\"description\">{{\'cm.label.85\' | translate}}</label>\r\n        <textarea id=\"description\" class=\"form-control\" ng-model=\"bugs.description\" required=\"\" rows=\"5\" maxlength=\"{{descriptionLimit}}\" aria-label=\"{{\'cm.label.85\' | translate}}\" aria-labelledby=\"{{\'cm.label.85\' | translate}}\"></textarea>\r\n        <span class=\"text-muted text-sm\">[ {{descriptionLimit - bugs.description.length}} ]</span>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>{{\'cm.label.31\' | translate}}</label>\r\n        <div class=\"dropdown customSelect\" uib-dropdown auto-close=\"outsideClick\">\r\n          <span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle>\r\n            {{bugs.d = (bugsDevices.devices | filter:{selected:true}); \"\"}}\r\n            <span ng-if=\"!bugs.d.length\">{{\'cm.label.31\' | translate}}</span>\r\n            <span ng-repeat=\"device in bugs.d\">{{device.label}}<span class=\"text-muted text-sm inline\"> - ({{device.mac}})</span><span ng-if=\"!$last\">, </span></span>\r\n            <span class=\"caret\"></span>\r\n          </span>\r\n          <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12\">\r\n                <div class=\"padLR10\">\r\n                  <li class=\"dropdown-header noPad noMar\">\r\n                    <div class=\"searchTbx input-xs\">\r\n                      <input type=\"text\" class=\"form-control\" ng-model=\"searchList\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" focus-me=\"true\">\r\n                      <a href=\"\" role=\"link\" class=\"text-danger\" ng-show=\"searchList.length\" ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=\"true\"></span></a>\r\n                    </div>\r\n                  </li>\r\n                  <li class=\"divider\" role=\"separator\"></li>\r\n                  <div class=\"list-scroll ng-cloak\">\r\n                    <li ng-repeat=\"device in filteredSList = (bugsDevices.devices | filter:searchList) | orderBy:\'label\'\" tabindex=\"$index\">\r\n                      <label>\r\n                        <input type=\"checkbox\" ng-model=\"device.selected\" role=\"checkbox\"><label></label>\r\n                        <div class=\"deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></div>\r\n                        {{device.label}}<span class=\"text-muted text-sm inline\"> - ({{device.mac}})</span>\r\n                      </label>\r\n                    </li>\r\n                    <div class=\"msg-warning\" lang=\"{{auth.lang}}\" ng-if=\"filteredSList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{searchList}}&quot;</b>\'}\"></div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group noMarB\">\r\n        <label>{{\'cs.tab.5\' | translate}}</label>\r\n        <div class=\"btn-file\">\r\n          <button type=\"button\" role=\"button\" class=\"btn btn-primary btn-sm\">{{\'cm.btn.36\' | translate}}</button>\r\n          <input type=\"file\" file-model=\"bugs.img\" options=\"{size:4190000, format:[\'imgOnly\']}\" accept=\"image/*\">\r\n          <input type=\"text\" class=\"form-control\" ng-value=\"bugs.img.name\" readonly=\"\" aria-label=\"{{\'cs.tab.5\' | translate}}\" aria-labelledby=\"{{\'cs.tab.5\' | translate}}\">\r\n        </div>\r\n      </div>\r\n    </div> --><iframe ng-src=\"{{auth.hs | trustUrl}}\" style=border:none;width:100% ng-style=\"{\'height\':{{getAvailableHeight(400)}}+\'px\'}\"></iframe></div><footer class=panel-footer><span class=btnQuad><!-- <button type=\"button\" role=\"button\" class=\"btn btn-success\" ng-click=\"saveBugsFx();\" ng-disabled=\"bugsProcessing\"><span class=\"fa\" ng-class=\"bugsProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=\"true\"></span>{{bugsProcessing?\'cm.btn.35i\':\'cm.btn.42\' | translate}}</button>\r\n      <button type=\"button\" role=\"button\" class=\"btn btn-link\" ng-click=\"closeThisDialog();\" data-dismiss=\"modal\">{{\'cm.btn.9\' | translate}}</ --> <button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button> </span><!-- <div class=\"errMsg pull-right\" ng-if=\"hasErr\">\r\n      <span ng-if=\"errType == \'title\'\">{{\'sc.bug.m1\' | translate}}</span>\r\n      <span ng-if=\"errType == \'des\'\">{{\'sc.bug.m2\' | translate}}</span>\r\n      <span ng-if=\"errType == \'device\'\">{{\'sc.bug.m3\' | translate}}</span>\r\n    </div> --><div class=clearfix></div></footer></section>");
$templateCache.put("app/support/popup/feedback.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'sc.fb.1\' | translate}}</h1></header><div class=panel-body><p>{{\'sc.fb.2\' | translate}}</p><div class=form-group><label for=feedback>{{\'sc.fb.3\' | translate}}</label><textarea class=form-control ng-model=feedback.feedback id=feedback required rows=5 maxlength={{descriptionLimit}} aria-label=\"{{\'sc.fb.3\' | translate}}\" aria-labelledby=\"{{\'sc.fb.3\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - feedback.feedback.length}} ]</span></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveFeedbackFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.35i\':\'cm.btn.42\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status>{{\'sc.fb.m1\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/support/popup/info.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName==\'fr\'\" role=heading aria-level=1>{{\'sc.fr.body.1\' | translate}}</h1></header><div class=panel-body><span ng-if=\"ngDialogData.tabName==\'fr\'\" translate=\"{{\'sc.fr.info.1\'}}\" translate-values=\"{lsnh: \'L Squared Hub\'}\" lang={{auth.lang}}></span></div></section>");
$templateCache.put("app/support/popup/mailToSupport.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'sc.mail.1\' | translate}}</h1></header><div class=panel-body><div class=marB20 translate=\"{{\'sc.mail.2\'}}\" translate-values=\"{lsn: \'L&nbsp;Squared&nbsp;Hub\'}\">{{\'sc.mail.2\' | translate}}</div><div class=form-group><label for=subject>{{\'sc.mail.3\' | translate}}</label><input type=text id=subject class=form-control ng-model=mail.subject maxlength={{inputLimit}} aria-label=\"{{\'sc.mail.3\' | translate}}\" aria-labelledby=\"{{\'sc.mail.3\' | translate}}\"></div><div class=form-group><label for=message>{{\'em.body.1\' | translate}}</label><textarea class=form-control ng-model=mail.message id=message required rows=5 maxlength={{descriptionLimit}} aria-label=\"{{\'em.body.1\' | translate}}\" aria-labelledby=\"{{\'em.body.1\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - mail.message.length}} ]</span></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveMailSupportFx(); ng-disabled=savePopProcessing><span class=fa ng-class=\"savePopProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{savePopProcessing?\'cm.btn.35i\':\'cm.btn.35\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasPopErr aria-live=polite role=status><span ng-if=\"errPopType==\'subject\'\" aria-live=polite role=status>{{\'sc.mail.m1\' | translate}}</span> <span ng-if=\"errPopType==\'message\'\" aria-live=polite role=status>{{\'sc.mail.m2\' | translate}}</span><div class=clearfix></div></div></footer></section>");
$templateCache.put("app/support/popup/releaseNotes.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'sc.ts.btn.15\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle\">{{reNotes.l}}</span> ]</span></header><div class=panel-body><img src=assets/images/loading.gif alt=loading ng-if=reNotesLoading><div class=\"scrollQuad release-notes-quad\" style=max-height:{{getAvailableHeight(350)}}px ng-if=!reNotesLoading><!-- For Publisher --><div class=\"marB15 bg-light pad10\" ng-if=\"reNotes.isDown && reNotes.id == 7\"><div class=marB10><div class=marB5>{{\"sc.ts.body.6\" | translate}}</div><div class=\"form-group marB10\"><div class=\"input-group input-group-sm\"><input type=text class=\"form-control picker\" value={{reNotes.key}} readonly aria-label=\"{{\'sc.ts.body.6\' | translate}}\" aria-labelledby=\"{{\'sc.ts.body.6\' | translate}}\"><div class=input-group-btn><button type=button role=button class=\"btn btn-default\" ngclipboard data-clipboard-text={{reNotes.key}} uib-tooltip=\"{{\'cl.p_m.5\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-files-o text-primary\" aria-hidden=true></span></button></div></div></div></div></div><div class=row ng-repeat=\"list in (reNotes.list.rn | filter:{showReleaseList:1})\" ng-class=\"{\'bdr-top-dashed padT35\':!$first}\"><div class=col-xs-12 ng-class=\"{\'marB20\':!$last}\"><div class=marB15><div class=d-flex><span style=font-size:22px;color:#38b6ff class=version>{{list.version}}<!-- <span class=\"marL10\" ng-if=\"reNotes.cv == list.version\">( {{\'cl.widget.queue.3\' | translate}} )</span> --></span></div><div class=marT10 style=color:#6b6767><span>{{list.releaseDate.startDate | dateFormat}}</span> <span class=\"padL10 marL10 bdr-l-dashed\" ng-if=\"reNotes.isDown && list.downloadURL\"><!-- <span class=\"padL10 marL10 bdr-l-dashed\" ng-if=\"!reNotes.isStoreLink && reNotes.id != 5 && reNotes.id != 14 && list.downloadURL\"> --> <a href=\"{{appHost +\'/\'+ list.downloadURL+\'?\'+ timestamp}}\" target=_blank class=\"btn-link noPad\" ng-if=!list.releaseTags.vulnerable>{{\'cm.btn.17\' | translate}}</a> <span ng-if=list.releaseTags.vulnerable class=\"text-grey text-line-through cursor-not-allowed\">{{\'cm.btn.17\' | translate}}</span> </span><!-- For Tizen & PWA--> <span class=\"padL10 marL10 bdr-l-dashed\" ng-if=\"!reNotes.isStoreLink && (reNotes.id == 5 || reNotes.id == 14) && list.downloadURL\"><a href=\"\" ngclipboard data-clipboard-text=\"{{appHost +\'/\'+ list.downloadURL}}\" uib-tooltip=\"{{\'d.tool.17.1\' | translate}}\" tooltip-append-to-body=true tooltip-enable=isCopied tooltip-is-open=isCopied ng-click=\"isCopied=true\" class=\"btn-link noPad\" ng-if=!list.releaseTags.vulnerable>{{\'sc.ts.reNotes.9\' | translate}}<span class=\"fa fa-clone marL5\"></span></a> <span ng-if=list.releaseTags.vulnerable class=\"text-grey text-line-through cursor-not-allowed\">{{\'sc.ts.reNotes.9\' | translate}}</span> </span><span ng-if=\"list.linkURL && reNotes.id != 7 && reNotes.id != 11 && reNotes.id != 12 && (auth.uType == 0 || auth.uType == 1 || auth.uType == 2)\" class=\"padL10 marL10 bdr-l-dashed\"><a href=\"\" ngclipboard data-clipboard-text={{list.linkURL}} uib-tooltip=\"{{\'d.tool.17.1\' | translate}}\" tooltip-append-to-body=true tooltip-enable=isCopied tooltip-is-open=isCopied ng-click=\"isCopied=true\" class=\"btn-link noPad\" ng-if=!list.releaseTags.vulnerable>{{\'sc.ts.reNotes.8\' | translate}} <span class=\"fa fa-clone marL5\"></span></a> <span ng-if=list.releaseTags.vulnerable class=\"text-grey text-line-through cursor-not-allowed\">{{\'sc.ts.reNotes.8\' | translate}} <span class=\"fa fa-clone marL5\"></span></span> </span><!-- ASlide (Play Store) --><!-- ng-if=\"reNotes.isStoreLink && list.linkURL && (auth.uType == 0 || auth.uType == 1 || auth.uType == 2 || auth.uType == 3)\" --> <span ng-if=\"reNotes.isStoreLink && list.linkURL\" class=\"padL10 marL10 bdr-l-dashed\"><a href=\"{{list.linkURL + appName}}\" class=\"btn-link noPad\" target=_blank>{{\"sc.ts.reNotes.7\" | translate}} <span class=\"fa fa-external-link marL5\"></span></a> </span><!-- Release Tags --> <span class=\"padL10 marL10 bdr-l-dashed\" ng-if=!isArray(list.releaseTags)><span class=\"release-tag stable\" ng-if=list.releaseTags.stable>{{\"sc.ts.reNotes.1\" | translate}}</span> <span class=\"release-tag latest\" ng-if=list.releaseTags.latest>{{\"sc.ts.reNotes.2\" | translate}}</span> <span class=\"release-tag deprecated\" ng-if=list.releaseTags.deprecated>{{\"sc.ts.reNotes.3\" | translate}}</span> <span class=\"release-tag vulnerable\" ng-if=list.releaseTags.vulnerable>{{\"sc.ts.reNotes.4\" | translate}}</span> <span class=\"release-tag prerelease\" ng-if=list.releaseTags.prerelease>{{\"sc.ts.reNotes.5\" | translate}}</span> <span class=\"release-tag nightly\" ng-if=list.releaseTags.nightly>{{\"sc.ts.reNotes.6\" | translate}}</span></span></div></div><div class=re-html ng-bind-html=list.descr|trustHtml></div></div></div></div><div class=msg-warning ng-if=\"!reNotesLoading && !reNotes.list.rn.length\">{{\'r.msg.1\' | translate}}</div></div><footer class=panel-footer ng-if=!reNotesLoading><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/support/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{ngDialogData.label}}</h1></header><div class=video-body><iframe width=800 height=452 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/support/reportBug/ci.html","Closed");
$templateCache.put("app/support/reportBug/oi.html","Open");
$templateCache.put("app/support/reportBug/rb.html","<section class=panel-inner-tab><header class=panel-inner-tab><a ui-sref-active=selected ui-sref=.oi role=button>Open Issues</a><a ui-sref-active=selected ui-sref=.ci role=button>Closed Issues</a></header><div class=panel-body><div ui-view=rbView></div></div></section>");
$templateCache.put("app/users/dir/addToGroup.html","<div class=row ng-if=isGroupAvailable><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curUserGrp.availableGroups=[]\">{{\'cm.tool.7\' | translate}}</button><label for=availableGroups>{{curGroups.availableGroups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{curGroups.availableGroups.length}} ]</span></label><select id=availableGroups class=form-control ng-model=curUserGrp.availableGroups ng-options=\"option.label for option in curGroups.availableGroups | orderBy:\'label\' track by option.id\" multiple size=7 aria-label=\"{{curGroups.availableGroups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}}\" aria-labelledby=\"{{curGroups.availableGroups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}}\"></select></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuad\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curGroups.availableGroups.length}\" ng-click=\"listManipulateFx(\'add\', curGroups.availableGroups, curGroups.groups, curUserGrp.availableGroups);updatePrimaryGroup();\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curGroups.groups.length}\" ng-click=\"listManipulateFx(\'remove\', curGroups.availableGroups, curGroups.groups, curUserGrp.groups);\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=\"form-group noMarB\"><button type=button role=button class=\"btn btn-default btn-xs pull-right\" ng-click=\"curUserGrp.groups=[]\">{{\'cm.tool.7\' | translate}}</button><label for=groups>{{curGroups.groups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}} <span class=\"text-sm text-muted\">[ {{curGroups.groups.length}} ]</span></label><select id=groups class=form-control ng-model=curUserGrp.groups ng-options=\"option.label for option in curGroups.groups | orderBy:\'label\' track by option.id\" multiple size=7 aria-label=\"{{curGroups.groups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}}\" aria-labelledby=\"{{curGroups.groups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}}\"></select></div></div></div>");
$templateCache.put("app/users/dir/userBrief.html","<div class=selectedQuad><!--For Selected Item Brief--><section class=panel ng-class=\"{\'pinQuad\': pinStatus == 1}\" ng-style=\"pinStatus == 1 && {\'width\': mainContainerWidth(5)}\"><header class=panel-heading><h2><span ng-if=\"$state.includes(\'hub.users.ug\') != true\">{{selectedItems.length > 1?\'u.brief.1s\':\'u.brief.1\' | translate}}</span> <span ng-if=\"$state.includes(\'hub.users.ug\') == true\">{{selectedItems.length > 1?\'u.brief.2s\':\'u.brief.2\' | translate}}</span> [ {{selectedItems.length}} ]</h2><div class=panel-tools><div class=pull-right><a href=\"\" role=link id=closeAll ng-click=closeAllFx(); uib-tooltip=\"{{\'cm.btn.10\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span></a></div><div class=pull-right><a href=\"\" role=link id=isPin ng-click=\"preferencesFx(\'isPin\');\" ng-class=\"{\'active\': pinStatus == 1}\" uib-tooltip=\"{{pinStatus?\'cm.tool.9\':\'cm.tool.8\' | translate}}\" tooltip-append-to-body=true><span class=\"glyphicon glyphicon-pushpin\" aria-hidden=true></span></a></div></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-show=detailLoading><div ng-if=\"selectedItems.length == 1\">{{curUser = (users.users | filter:{id:selectedItems[0].id}:true | orderBy: \'id\');\"\"}}<ul class=\"list-unstyled single-selected\" ng-hide=detailLoading><div class=row><div class=col-xs-3><div class=thumb-highlight ng-class=\"{\'unapprovedFile\': selectedTab == \'hub.users.uu\'}\"><div class=thumb ng-class=\"{\'unapprovedFile\': selectedTab == \'hub.users.uu\'}\"><!-- Group --> <img alt=\"\" ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme == \'\'\" src=assets/images/default/user_group_selected.png class=\"noOutline img-responsive center-block img-user\"><!-- <img alt=\"{{domainName}}\" ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme != \'\'\" src=\"../theme/{{domainName}}/user_group_selected.png\" class=\"noOutline img-responsive center-block img-user bg-user-group\"> --><div ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme != \'\'\" class=\"userThumb bg-user-group\"><span><i class=\"fa fa-users multiUser\" aria-hidden=true></i></span></div><!-- User --> <a ng-if=curUser[0].thumb ng-href=\"{{detailBucket + curUser[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curUser[0].label}}><img alt=\"\" ng-src=\"{{tim + bucket + curUser[0].thumb + thumbBigParam}}\" class=\"img-responsive center-block\"></a><div ng-if=\"!curUser[0].thumb && selectedTab != \'hub.users.ug\'\" class=userThumb><span ng-if=\"!curUser[0].label || curUser[0].label == \' \'\">{{curUser[0].email | limitTo:1}}</span> <span ng-if=\"curUser[0].label != \' \'\">{{curUser[0].label | limitTo:1}}</span></div></div><div ng-if=\"!curUser[0].label || curUser[0].label == \'\'\" class=\"text-ellipsis marT5\" uib-tooltip={{curUser[0].email}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curUser[0].email}}</div><div ng-if=\"curUser[0].label != \'\'\" class=\"text-ellipsis marT5\" uib-tooltip={{curUser[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curUser[0].label}}</div></div></div><div class=\"col-xs-9 noPadL\"><div class=\"table no-th no-border\"><div ng-if=\"selectedTab != \'hub.users.ug\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.47\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curUser[0].email}} <span class=\"text-muted text-sm\" ng-if=\"curUser[0].email == null\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'u.brief.8\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=curUser[0].createdOn>{{(curUser[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curUser[0].createdOn == null\">N/A</span></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curUser[0].label}} <span class=\"text-muted text-sm\" ng-if=\"curUser[0].label == null || curUser[0].label == \'\'\">N/A</span></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'u.brief.9\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{userBrief.createdBy}} <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && userBrief.createdBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6 ng-if=\"selectedT != 2\"><div class=\"col-xs-5 text-right\">{{\'u.brief.3\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\"><span ng-repeat=\"userGrp in userBrief.userGroups | limitTo:5\">{{userGrp.label}}<span ng-if=!$last>, </span></span><span ng-if=\"userBrief.userGroups.length > 5\">... <a href=\"\" role=link class=text-underline ng-click=groupListOpen();>+{{userBrief.userGroups.length - 5}} {{\'cm.btn.23\' | translate | lowercase}}</a></span> <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && userBrief.userGroups == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.users.mb\' && selectedT == 2\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"userBrief != \'\' && userBrief.editedOn\">{{(userBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curUser[0].id, selectedTab == \'hub.users.ug\'?\'userGroup\':\'user\', curUser[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && !userBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'u.brief.5\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"userBrief.login != null\">{{userBrief.login}}</span> <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && userBrief.login == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6 ng-if=\"selectedT != 2\"><div class=\"col-xs-5 text-right\">{{\'cm.label.50\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{userBrief.primaryGroup.label}} <span class=\"text-muted text-sm\" ng-if=\"userBrief.userGroups && userBrief.primaryGroup == null\">{{\'cm.label.51\' | translate}}</span> <span class=\"text-muted text-sm\" ng-if=\"(userBrief != \'\' && userBrief.userGroups == null && userBrief.primaryGroup == null) || userBrief.primaryGroup == \'hidden\'\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"> <button type=button role=button class=\"btn btn-xs btn-default marL5\" ng-click=primaryGrpOpen(); ng-if=\"(userBrief.userGroups != null && auth.uType != 4) || (userBrief.userGroups != null && curUser[0].self)\">{{\'u.btn.7\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.users.mb\' && selectedT == 2\"><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{userBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && !userBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.label.53\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><button type=button role=button ng-click=userLogOpen(curUser[0].label); class=\"btn btn-xs btn-default\">{{\'cm.btn.21\' | translate}}</button></div></div></div><div class=row><div class=col-xs-6 ng-if=\"selectedT != 2\"><div class=\"col-xs-5 text-right\">{{\'u.brief.4\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\"><span ng-if=userBrief.key ng-repeat=\"r in userBrief.key\">{{\'roles.\' + r | translate}}<span ng-if=!$last>, </span></span><span ng-if=!userBrief.key>{{userBrief.roles}}</span> <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && userBrief.roles == null && userBrief.key == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'d.tab.1\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><button type=button role=button ng-click=\"deviceListOpen(userBrief.id, curUser[0].label);\" class=\"btn btn-xs btn-default\">{{\'cm.btn.21\' | translate}}</button></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.users.mb\' && selectedT == 2 && (auth.uType != 4 || curUser[0].self) && userBrief.isVerified\"><div class=\"col-xs-5 text-right\">{{\'u.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><button type=button role=button ng-click=\"confirmSendPassword(curUser[0].email, curUser[0].id, userBrief.isSso);\" class=\"btn btn-xs btn-default\">{{\'cm.btn.35\' | translate}}</button></div></div></div></div><!-- User Group --><div ng-if=\"selectedTab == \'hub.users.ug\'\"><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.1\' | translate}}:</div><div class=\"col-xs-7 text-bold text-ellipsis-wrap\">{{curUser[0].label}} <span class=\"text-muted text-sm\" ng-if=\"curUser[0].label == null\">N/A</span></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.users.ug\'\"><div class=\"col-xs-5 text-right\">{{\'u.brief.7\' | translate}}:</div><div class=\"col-xs-7 text-bold\">{{userBrief.userCount}} <button type=button role=button ng-click=\"userCountListFx(curUser[0].id, curUser[0].label);\" class=\"btn btn-xs btn-default marL5\" ng-if=\"userBrief.userCount > 0\">{{\'cm.btn.21\' | translate}}</button> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.2\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=curUser[0].createdOn>{{(curUser[0].createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</span> <span class=\"text-muted text-sm\" ng-if=\"curUser[0].createdOn == null\">N/A</span></div></div><div class=col-xs-6></div></div><div class=row><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.3\' | translate}}:</div><div class=\"col-xs-7 brief-col\"><span ng-if=userBrief.createdBy>{{userBrief.createdBy}}</span> <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && userBrief.createdBy == null\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6></div></div></div><div class=row ng-if=\"selectedT != 2\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.14\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><span ng-if=\"userBrief != \'\' && userBrief.editedOn\">{{(userBrief.editedOn * 1000) | date:\"MMM d, y h:mm a\"}} <a href=\"\" role=link class=\"fa fa-hourglass-half btn-link marL5\" ng-click=\"editHistoryFx(curUser[0].id, selectedTab == \'hub.users.ug\'?\'userGroup\':\'user\', curUser[0].label);\" uib-tooltip=\"{{\'cm.p_h.1\' | translate}}\"></a> </span><span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && !userBrief.editedOn\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab != \'hub.users.ug\' && (auth.uType != 4 || curUser[0].self) && userBrief.isVerified\"><div class=\"col-xs-5 text-right\">{{\'u.brief.6\' | translate}}:</div><div class=\"col-xs-7 text-bold\"><button type=button role=button ng-click=\"confirmSendPassword(curUser[0].email, curUser[0].id, userBrief.isSso);\" class=\"btn btn-xs btn-default\">{{\'cm.btn.35\' | translate}}</button></div></div></div><div class=row ng-if=\"selectedT != 2\"><div class=col-xs-6><div class=\"col-xs-5 text-right\">{{\'cm.brief.15\' | translate}}:</div><div class=\"col-xs-7 brief-col\">{{userBrief.editedBy}} <span class=\"text-muted text-sm\" ng-if=\"userBrief != \'\' && !userBrief.editedBy\">N/A</span> <img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"></div></div><div class=col-xs-6 ng-if=\"selectedTab == \'hub.users.au\' && auth.upermissions.dmb && userBrief.key[0] == \'4\' && auth.uType != 4\"><div class=\"col-xs-5 text-right\">{{\'cm.dmb.10\' | translate}}:</div><div class=col-xs-7><img alt=Loading src=assets\\images\\loading-xs.gif ng-if=\"userBrief == \'\'\"><switch role=switch class=switch-sm ng-if=\"userBrief != \'\'\" ng-model=userBrief.isDmbAdmin aria-checked={{userBrief.isDmbAdmin?true:false}} on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" ng-change=\"mbAdminFx(curUser[0].id, userBrief.isDmbAdmin)\"></switch></div></div></div></div></div></div></ul></div><!--For Multiple selected--><div ng-if=\"selectedItems.length > 1\"><div class=\"thumb-list hoverContainer\"><li ng-repeat=\"user in selectedItems\" data-id={{user.id}} class=\"device valign-top\">{{curUser = (users.users | filter:selectedItems[$index].id:true);\"\"}}<div class=relative><a href=\"\" role=link class=\"thumb-close brief-cl\" ng-click=closeFx(user.id)><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=\"thumb-img thumb-block\" ng-class=\"{\'unapprovedFile\': selectedTab == \'hub.users.uu\'}\"><div class=thumb-inner><!-- Group --> <img alt=\"\" ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme == \'\'\" src=assets/images/default/user_group.png class=\"noOutline img-responsive center-block img-user\"><!-- <img alt=\"{{domainName}}\" ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme != \'\'\" src=\"../theme/{{domainName}}/user_group_selected.png\" class=\"noOutline img-responsive center-block img-user bg-user-group\"> --><div ng-if=\"selectedTab == \'hub.users.ug\' && myTheme.clientTheme != \'\'\" class=\"userThumb-sm bg-user-group\"><span><i class=\"fa fa-users multiUser\" aria-hidden=true></i></span></div><!-- User --> <a ng-if=curUser[0].thumb ng-href=\"{{detailBucket + curUser[0].thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside caption={{curUser[0].label}}><img alt=\"\" ng-src=\"{{thumbHost + tim + bucket + curUser[0].thumb + thumbParam}}\" class=\"img-responsive center-block\"></a><div ng-if=\"!curUser[0].thumb && selectedTab != \'hub.users.ug\'\" class=userThumb-sm><span ng-if=\"!curUser[0].label || curUser[0].label == \'\'\">{{curUser[0].email | limitTo:1}}</span> <span ng-if=\"curUser[0].label != \'\'\">{{curUser[0].label | limitTo:1}}</span></div></div><div class=thumb-label><span ng-if=\"!curUser[0].label || curUser[0].label == \'\'\" uib-tooltip={{curUser[0].email}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curUser[0].email}}</span> <span ng-if=\"curUser[0].label != \'\'\" uib-tooltip={{curUser[0].label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{curUser[0].label}}</span></div></div></div></li></div></div></div><!--Button Quad--><div class=\"panel-footer text-right\"><img alt=Loading src=assets/images/loading.gif ng-if=\"userBtn.length==0\"> <a href=\"\" role=link class=\"pull-left marT6\" ng-click=btnInfoOpen(userBtn.info); ng-if=userBtn.info.length><img alt=\"\" src=assets/images/info-circle.png></a><div class=\"text-muted text-italic marT5\" ng-if=\"userBtn.buttons.length == 0\">{{\'cm.brief.13\' | translate}}</div><ul class=list-inline ng-if=userBtn><li ng-repeat=\"uBtn in userBtn.buttons\"><button type=button role=button ng-if=\"uBtn.key==\'uInviteAgain\'\" ng-click=\"inviteAgainOpen(userBrief.id, userBrief.email, userBrief.lang);\" class=\"btn btn-primary\"><span class=\"fa fa-share\" aria-hidden=true></span>{{\'u.btn.6\' | translate}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uEdit\'\" ui-sref=\"hub.uContainer.userCU({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uGroup\'\" ng-click=addToGrpOpen(userBrief.id); class=\"btn btn-success\"><span class=\"fa fa-plus-circle\" aria-hidden=true></span>{{\'cm.btn.29\' | translate}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uInactive\'\" ng-click=\"confirmOpen(\'deactivate\');\" class=\"btn btn-warning\"><span class=\"fa fa-ban\" aria-hidden=true></span>{{\'u.btn.8\' | translate}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uApprove\'\" ng-click=approveUserFx(userBrief.id); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{uBtn.label}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uActive\'\" ng-click=activateUserFx(); class=\"btn btn-success\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'u.btn.9\' | translate}}</button> <button type=button role=button ng-if=\"uBtn.key==\'uDelete\'\" ng-click=\"confirmOpen(\'inactive\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button><!--Button Quad for User Group--><div ng-if=\"uBtn.key==\'uGEdit\'\" class=\"btn-group dropup\" uib-dropdown><button type=button role=button ui-sref=\"hub.uContainer.ugName({id: encId})\" class=\"btn btn-primary\"><span class=\"fa fa-pencil\" aria-hidden=true></span>{{\'cm.btn.22\' | translate}}</button> <button type=button role=button uib-dropdown-toggle class=\"btn btn-primary\"><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.btn.39\' | translate}}</li><li class=divider role=separator></li><li ng-repeat=\"step in uBtn.steps\"><a href=\"\" role=link ng-if=\"step.key==\'uGStep1\'\" ui-sref=\"hub.uContainer.ugName({id: encId})\">{{\'cm.brief.1\' | translate}}</a> <a href=\"\" role=link ng-if=\"step.key==\'uGStep2\'\" ui-sref=\"hub.uContainer.ugUsers({id: encId})\">{{\'u.btn.10\' | translate}}</a></li></ul></div><button type=button role=button ng-if=\"uBtn.key==\'uGDelete\'\" ng-click=\"confirmOpen(\'group\');\" class=\"btn btn-danger\"><span class=\"fa fa-remove\" aria-hidden=true></span>{{\'cm.btn.13\' | translate}}</button></li></ul></div><!--Button Quad End--></section></div>");
$templateCache.put("app/users/dir/userList.html","<li ng-repeat=\"user in filteredUserList = (users.users | customSearch:{key:searchText, module:\'u\'})\" data-id={{user.id}} uib-tooltip=\"{{\'u.body.7\' | translate}}\" tooltip-append-to-body=true tooltip-enable=\"selectedTab == \'hub.uContainer.ugUsers\' && user.uType != 4\" ng-class=\"{\'nonSelectable unapprovedFile\': selectedTab == \'hub.uContainer.ugUsers\' && user.uType !== 4}\" context-menu=contextMenuOpt class=tabIndex><div class=thumb-inner><img alt=\"\" ng-if=user.thumb ng-src=\"{{thumbHost + tim + bucket + user.thumb + thumbParam + \'&\' + user.thumbV}}\"> <img alt=\"\" src=assets/images/default/user_group.png ng-if=\"users.info.type == \'ug\' && myTheme.clientTheme == \'\'\" class=img-user><!-- <img alt=\"{{domainName}}\" src=\"../theme/{{domainName}}/user_group.png\" ng-if=\"users.info.type == \'ug\' && myTheme.clientTheme != \'\'\" class=\"img-user bg-user-group\"> --><div ng-if=\"users.info.type == \'ug\' && myTheme.clientTheme != \'\'\" class=userThumb><span><i class=\"fa fa-users multiUser\" aria-hidden=true></i></span></div><div ng-if=\"!user.thumb && users.info.type != \'ug\'\" class=userThumb ng-class=\"{\'userPrime\':user.uType==2}\"><span ng-if=\"!user.label || user.label == \' \'\">{{user.email | limitTo:1}}</span> <span ng-if=\"user.label != \' \'\">{{user.label | limitTo:1}}</span></div><span ng-if=\"user.uType == 2\" class=\"thumb-icon cl prime-user\"><span class=\"fa fa-star\" aria-hidden=true></span></span></div><div class=thumb-label><span ng-if=user.self class=text-bold>{{\'u.body.8\' | translate}}:</span><span ng-if=\"!user.label || user.label == \'\'\" uib-tooltip={{user.email}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{user.email}}</span> <span ng-if=\"user.label != \'\'\" uib-tooltip={{user.label}} tooltip-append-to-body=true tooltip-class=tooltip-break tooltip-placement=top tooltip-popup-delay=1000>{{user.label}}</span></div><!-- <div ng-if=\"user.self\" class=\"d-flex align-items-center marT5 w100px\">\r\n    <div class=\"text-bold\">{{\'u.body.8\' | translate}}:</div>\r\n    <div class=\"text-ellipsis w100px\" ng-if=\"!user.label || user.label == \'\'\" uib-tooltip=\"{{user.email}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\" class=\"text-ellipsis w100px marT5\">{{user.email}}</div>\r\n    <div class=\"text-ellipsis w100px\" ng-if=\"user.label != \'\'\" uib-tooltip=\"{{user.label}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\">{{user.label}}</div>\r\n  </div>\r\n  <div ng-if=\"!user.self\" class=\"marT5 w100px\">\r\n    <div class=\"text-ellipsis\" ng-if=\"!user.label || user.label == \'\'\" uib-tooltip=\"{{user.email}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\" class=\"text-ellipsis w100px marT5\">{{user.email}}</div>\r\n    <div class=\"text-ellipsis\" ng-if=\"user.label != \'\'\" uib-tooltip=\"{{user.label}}\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltip-break\" tooltip-placement=\"top\" tooltip-popup-delay=\"500\">{{user.label}}</div>\r\n  </div> --></li><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredUserList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div>");
$templateCache.put("app/users/popup/addToGroup.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.btn.29\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=\"!isGroupEmpty && !isGroupAvailable\"><div class=form-group ng-if=\"!isGroupEmpty && isGroupAvailable && auth.upermissions.ug\" role=radiogroup aria-labelledby=radiogroup><label class=\"noMarB marR10\"><input type=radio role=radio name=grpOpt ng-model=curGroup.type value=addGrp><label></label>{{\'cm.label.81\' | translate}}</label><label class=noMarB><input type=radio role=radio name=grpOpt ng-model=curGroup.type value=newGrp><label></label>{{\'cm.label.82\' | translate}}</label></div><ng-add-to-group ng-show=\"curGroup.type == \'addGrp\'\"></ng-add-to-group><div class=form-group ng-if=\"isGroupEmpty || curGroup.type == \'newGrp\'\"><p ng-if=isGroupEmpty>{{\'u.msg.14\' | translate}}</p><label for=label>{{\'cm.label.78\' | translate}}</label><input type=text id=label class=form-control ng-model=curGroup.label maxlength={{inputLimit}} aria-label=\"{{\'cm.label.78\' | translate}}\" aria-labelledby=\"{{\'cm.label.78\' | translate}}\"></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveUserGrpFx(\'name\', \'sc\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'form\'\" aria-live=polite role=status>{{\'u.p_group.m1\' | translate}}</div><div ng-if=\"errType==\'duplicate\'\" aria-live=polite role=status>{{\'u.p_group.m2\' | translate}}</div><div ng-if=\"errType==\'group\'\" aria-live=polite role=status>{{\'u.msg.15\' | translate}}</div></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/btnInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.17\' | translate}}</h1></header><div class=panel-body><div class=marB15>{{\'cm.msg.30\' | translate}}</div><div class=\"table table-scroll\"><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"btn in btnInfo\"><div class=col-xs-12><div class=text-bold><span ng-if=\"btn.key==\'uInviteAgain\'\">{{\'u.btn.6\' | translate}}</span> <span ng-if=\"btn.key==\'uEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'uGroup\'\">{{\'cm.btn.29\' | translate}}</span> <span ng-if=\"btn.key==\'uInactive\'\">{{\'u.btn.8\' | translate}}</span> <span ng-if=\"btn.key==\'uActive\'\">{{\'u.btn.9\' | translate}}</span> <span ng-if=\"btn.key==\'uDelete\'\">{{\'cm.btn.13\' | translate}}</span> <span ng-if=\"btn.key==\'uGEdit\'\">{{\'cm.btn.22\' | translate}}</span> <span ng-if=\"btn.key==\'uGDelete\'\">{{\'cm.btn.13\' | translate}}</span></div><div class=text-ellipsis-wrap>{{\'btnInfo.\'+ btn.code | translate}}</div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/countList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'u.body.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'count\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!countList.length><div class=\"table table-scroll\" ng-if=countList.length><div class=\"row th\" ng-if=filteredList.length><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.47\' | translate}}</div><div class=col-xs-4>{{\'u.body.2\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"cl in filteredList = (countList | customSearch:{key:searchTextPopup, module:\'u\'})\" ng-class=\"{\'disabledRow\':!cl.active}\" uib-tooltip=\"{{\'u.body.6\' | translate}}\" tooltip-enable=!cl.active><div class=\"col-xs-4 text-ellipsis-wrap\">{{cl.label}} <span class=\"text-muted text-sm\" ng-if=\"cl.label == null\">N/A</span></div><div class=\"col-xs-4 text-ellipsis-wrap\">{{cl.email}}</div><div class=\"col-xs-4 text-ellipsis-wrap\">{{cl.roles}}</div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/deviceList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-35\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link ng-if=\"!popupLoading && allScrollDataList.length && auth.upermissions.edl\" class=\"padL5 padR7 marL5 bdrR\" uib-tooltip=\"{{\'cm.btn.17\' | translate}}\" tooltip-append-to-body=true ng-click=\"openGroupDevices(\'uDevices\', allScrollDataList, deviceListUserObj.uid, \'\', \'\', popupLabel);\" ng-disabled=loading><!--downloadDeviceListFx(deviceList);--> <span class=\"fa fa-download\" aria-hidden=true></span> </a><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'device\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 ng-change=searchChangeData(searchTextPopup); placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\';searchChangeData(searchTextPopup);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=msg-warning lang={{auth.lang}} ng-if=\"!popupLoading && !allScrollDataList.length\">{{\'d.msg.26\' | translate}}</div><div class=\"table table-scroll\" ng-if=\"!popupLoading && allScrollDataList.length\"><div class=\"row th\" ng-if=\"filteredList.length > 0\"><div class=col-xs-8>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.80\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px id=scroll-container ng-scroll-list st=stIndex et=etIndex list-data=scrollDataList search-data=searchTextPopup have-more-data=haveMoreData search-scroll=searchScroll clone-data=allScrollDataList have-more-search-data=haveMoreSearchData dd-open=true><div class=\"row rowObj\" id={{dl.id}} ng-repeat=\"dl in filteredList = (visibleData)\"><div class=\"col-xs-8 word-break\"><span class=\"deviceStatus {{dl.status}}\" ng-class=dl.status uib-tooltip=\"{{dl.status == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}\" tooltip-popup-delay=500 tooltip-append-to-body=true></span> {{dl.l}}</div><div class=\"col-xs-4 word-break\">{{dl.h}}</div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData || !haveMoreSearchData) && scrollDataList.length >= 300 && scrollDataList.length == etIndex\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><!-- <div ng-if=\"!haveMoreData && allScrollDataList.length >= 300 && allScrollDataList.length == etIndex && !searchScroll\" class=\"end-of-data-tag\">{{\'cm.msg.54\' | translate}}</div> --></div><div class=msg-warning lang={{auth.lang}} ng-if=\"filteredList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/groupsList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'u.tab.2\' | translate}}</h1><!-- <h1>{{\'u.tab.2\' | translate}} -hsad</h1> --> <span class=text-sm>[ {{\'r.body.9\' | translate}}: {{curGroups.userGroups.length}} ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!curGroups.userGroups.length><div class=\"table no-th\" ng-if=curGroups.userGroups.length><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"ug in curGroups.userGroups\"><div class=\"col-xs-12 text-ellipsis-wrap\">{{ug.label}}</div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/info.html","<section class=panel role=dialog><header class=panel-heading role=heading aria-level=1><h1 ng-if=\"ngDialogData.tabName==\'ug\'\" role=heading aria-level=1>{{\'u.tool.1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'bu\'\" role=heading aria-level=1>{{\'u.tool.2\' | translate}}</h1></header><div class=panel-body><div ng-if=\"ngDialogData.tabName==\'ug\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'u.info.ug1\' | translate}}</p><img alt=\"\" src=assets/images/info/ug.png></div><div ng-if=\"ngDialogData.tabName==\'bu\'\" role=img><p class=marB25 lang={{auth.lang}}>{{\'u.info.bu1\' | translate}}</p><img alt=\"\" src=assets/images/info/bu.png></div></div></section>");
$templateCache.put("app/users/popup/inviteAgain.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'u.p_invite.7\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=email>{{\'cm.label.47\' | translate}}</label><input id=email type=email class=form-control ng-model=inviteObj.email autocomplete=off readonly maxlength=250 aria-label=\"{{\'cm.label.47\' | translate}}\" aria-labelledby=\"{{\'cm.label.47\' | translate}}\"></div><div class=form-group><label for=lang>{{\'cm.label.34\' | translate}} <span class=\"fa fa-question-circle text-primary\" uib-tooltip=\"{{\'u.p_invite.m1\' | translate: {brand:\'L&nbsp;Squared&nbsp;Hub\'} }}\" tooltip-placement=right tooltip-append-to-body=true aria-hidden=true></span></label><select id=lang class=form-control ng-model=inviteObj.lang aria-label=\"{{\'cm.label.34\' | translate}}\" aria-labelledby=\"{{\'cm.label.34\' | translate}}\"><option value=en_US>English / USA</option><option value=fr_FR>French / France</option><option value=es_ES>Spanish / Spain</option></select></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=inviteAgainFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-share\'\" aria-hidden=true></span>{{saveProcessing?\'u.btn.5\':\'u.btn.4\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/primaryGrp.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'u.p_pgroup.1\' | translate}}</h1></header><div class=panel-body><div class=form-group role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=primaryGrp ng-model=primaryGrp.permission value=p><label></label>{{\'cm.label.51\' | translate}}</label><label><input type=radio role=radio name=primaryGrp ng-model=primaryGrp.permission value=c><label></label>{{\'cm.label.52\' | translate}}</label></div><div class=form-group ng-if=\"primaryGrp.permission == \'c\'\"><label for=userPrimGrp>{{\'u.p_pgroup.2\' | translate}}</label><select id=userPrimGrp class=form-control ng-model=primaryGrp.userPrimGrp ng-options=\"grpOpt.label for grpOpt in primaryGrp.userGroups | orderBy:\'label\' track by grpOpt.id\" aria-label=\"{{\'u.p_pgroup.2\' | translate}}\" aria-labelledby=\"{{\'u.p_pgroup.2\' | translate}}\"></select></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=savePrimaryGrpFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/roleUserList.html","<section class=panel role=dialog><header class=\"panel-heading text-ellipsis-wrap\"><h1 role=heading aria-level=1>{{\'u.body.1\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-40\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'roleUser\'); searchTextPopup=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=!countList.user.length><div class=\"table table-scroll\" ng-if=countList.user.length><div class=\"row th\" ng-if=filteredList.length><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-6>{{\'cm.label.47\' | translate}}</div></div><div class=scrollQuad ng-attr-style=max-height:{{getAvailableHeight(371)}}px><div class=row ng-repeat=\"cl in filteredList = (countList.user | customSearch:{key:searchTextPopup, module:\'u\'})\" ng-class=\"{\'disabledRow\':cl.blocked}\" uib-tooltip=\"{{\'u.body.6\' | translate}}\" tooltip-enable=cl.blocked><div class=\"col-xs-6 text-ellipsis-wrap\">{{cl.label}} <span class=\"text-muted text-sm\" ng-if=\"cl.label == null\">N/A</span></div><div class=\"col-xs-6 text-ellipsis-wrap\">{{cl.email}}</div></div><div class=msg-warning lang={{auth.lang}} ng-if=!filteredList.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/selectDevice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.3\' | translate}}</h1><span class=\"marL5 text-sm\">[ <span class=\"text-ellipsis hTitle w-70\" uib-tooltip={{popupLabel}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{popupLabel}}</span> ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=popupLoading><div class=row ng-if=\"!popupLoading && allScrollDataListDyn.a.length\"><ng-device-store-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=\"\'dmbU\'\" total-count=totalDeviceCount store-data-list=storeDataList></ng-device-store-assignable></div><div ng-if=\"!allScrollDataListDyn.a.length && !popupLoading\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveAvailAndAssinDevicesFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-spin fa-repeat\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); resetD();\" data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/users/popup/video.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName==\'u\'\" role=heading aria-level=1>{{\'u.info.uv1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ug\'\" role=heading aria-level=1>{{\'u.info.ugv1\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'ur\'\" role=heading aria-level=1>{{\'u.info.urv1\' | translate}}</h1></header><div class=video-body><iframe width=560 height=315 ng-src={{ngDialogData.url}} frameborder=0 allowfullscreen referrerpolicy=strict-origin-when-cross-origin></iframe></div></section>");
$templateCache.put("app/common/dir/tmpl/activePeriod.html","<div ng-if=!editExpiry><span class=\"badge bg-muted marR5\" ng-if=\"activePeriod.type==\'a\'\">{{\'cm.label.16\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"activePeriod.type==\'c\'\">{{\'cm.label.17\' | translate}}</span> <a href=\"\" ng-if=!auth.upermissions.cfo role=link class=\"fa fa-pencil\" name=activePEdit aria-hidden=true aria-label=activePEdit ng-click=\"activePeriodFx(\'edit\');\" ng-disabled=isDisabled ng-class=\"{\'text-muted\':isDisabled}\"></a></div><div class=expiryDetails ng-if=editExpiry><div role=radiogroup aria-labelledby=radiogroup><label class=marR10><input type=radio role=radio name=activePeriodType ng-model=curPeriod.type value=a checked aria-label=curPeriodA aria-labelledby=curPeriodA><label></label>{{\'cm.label.16\' | translate}}</label><label><input type=radio role=radio name=activePeriodType ng-model=curPeriod.type value=c aria-label=curPeriodC aria-labelledby=curPeriodC><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=spaceH></div><div class=row><div class=\"col-xs-8 form-group\"><label for=activeperiod>{{\'cm.label.7\' | translate}}</label><div class=input-group><span class=input-group-addon><span class=\"fa fa-calendar\" aria-hidden=true></span></span><!-- <input type=\"daterange\" id=\"activeperiod\" class=\"form-control picker\" ng-model=\"curPeriod.date\" format=\"MM/DD/YYYY\" readonly=\"\" ng-disabled=\"curPeriod.type==\'a\'\"> --> <input type=daterange class=\"form-control picker\" id=activeperiod name=datetimes ng-model=curPeriod.date format=MM/DD/YYYY ng-focus=setDate(); readonly ng-disabled=\"curPeriod.type==\'a\'\" aria-label=dateRange></div></div></div><div class=form-group><label><a href=\"\" role=link class=\"bdr-btm-dashed noPadB\" ng-click=\"isWhatAP = !isWhatAP\">{{\'cl.msg.35\' | translate}}</a></label><div ng-if=isWhatAP>{{\'cl.msg.35.1\' | translate}}</div></div><div><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=\"activePeriodFx(\'save\');\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link btn-xs\" ng-click=\"activePeriodFx(\'cancel\');\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></div></div>");
$templateCache.put("app/common/dir/tmpl/advancedSearch.html","<div class=panel-body ng-if=\"advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)\"><div class=filterQuad><div ng-class=\"{\'col-xs-11 noPadL padR40\': (auth.uservices.ss && advSearchInfo.module == \'s\')}\"><ul class=list-inline><li class=word-break ng-if=advSearchInfo.type uib-tooltip=\"{{\'cm.label.69\' | translate}}\" tooltip-append-to-body=true><span ng-if=\"advSearchInfo.type!=0 && advSearchInfo.type!=1 && advSearchInfo.type!=2 && advSearchInfo.type!=3 && advSearchInfo.type!=4 && advSearchInfo.type!=5 && advSearchInfo.type!=6\">{{advSearchInfo.type.label}}</span> <span ng-if=\"advSearchInfo.type==0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"advSearchInfo.type==1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"advSearchInfo.type==2\">{{\'fl.p_cfl.label.24\' | translate}}</span><!-- <span ng-if=\"advSearchInfo.type==3\">{{\'fl.p_cfl.label.25\' | translate}}</span> --> <span ng-if=\"advSearchInfo.type==3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"advSearchInfo.type==4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"advSearchInfo.type==5\">{{\'fl.p_cfl.label.27\' | translate}}</span> <span ng-if=\"advSearchInfo.type==6\">{{\'t.label.30\' | translate}}</span> <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'ct\');\" ng-disabled=\"advSearchInfo.opt == \'ls\' && (advSearchInfo.creationRange || advSearchInfo.createdBy || advSearchInfo.name)\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.name uib-tooltip=\"{{\'cm.brief.1\' | translate}}\" tooltip-append-to-body=true>{{advSearchInfo.name}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'cn\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.dName uib-tooltip=\"{{\'d.label.46\' | translate}}\" tooltip-append-to-body=true>{{advSearchInfo.dName}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'dn\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=\"advSearchInfo.prop && advSearchInfo.prop.value\" uib-tooltip=\"{{\'d.label.45\' | translate}}\" tooltip-append-to-body=true>{{advSearchInfo.prop.label}}: {{advSearchInfo.prop.value}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'pv\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=\"advSearchInfo.creationRange && advSearchInfo.module != \'inv\'\" uib-tooltip=\"{{\'as.label.1\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-calendar-check-o marR5\"></span>{{advSearchInfo.creationDateRange.startDate}} - {{advSearchInfo.creationDateRange.endDate}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'cr\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=\"advSearchInfo.creationRange && advSearchInfo.module == \'inv\'\" uib-tooltip=\"{{\'in.p_i.21\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-calendar-check-o marR5\"></span>{{advSearchInfo.creationDateRange.startDate}} - {{advSearchInfo.creationDateRange.endDate}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'cr\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.scheduleRange uib-tooltip=\"{{\'as.label.2\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-calendar-check-o marR5\" aria-hidden=true></span>{{advSearchInfo.scheduleDateRange.startDate}} - {{advSearchInfo.scheduleDateRange.endDate}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'sr\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.createdBy uib-tooltip=\"{{\'cm.brief.3\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-user-o marR5\" aria-hidden=true></span>{{advSearchInfo.createdBy.label}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'cb\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.sName uib-tooltip=\"{{\'as.label.4\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-calendar marR5\" aria-hidden=true></span>{{advSearchInfo.sName}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'sn\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.os uib-tooltip=\"{{\'cm.label.70\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-hdd-o marR5\" aria-hidden=true></span> <span ng-if=\"advSearchInfo.os==1\">Windows</span> <span ng-if=\"advSearchInfo.os==2\">LG WebOS</span> <span ng-if=\"advSearchInfo.os==3\">Samsung Tizen</span> <span ng-if=\"advSearchInfo.os==4\">Chrome OS</span> <span ng-if=\"advSearchInfo.os==5\">Linux</span> <span ng-if=\"advSearchInfo.os==6\">MacOS</span> <span ng-if=\"advSearchInfo.os==7\">Android</span> <span ng-if=\"advSearchInfo.os==9\">Raspberry Pi</span> <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'os\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.client uib-tooltip=\"{{\'d.brief.9\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-hdd-o marR5\" aria-hidden=true></span> <span ng-if=\"advSearchInfo.client==0\">FSS</span> <span ng-if=\"advSearchInfo.client==1\">Electron</span> <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'client\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li><li class=word-break ng-if=advSearchInfo.dType uib-tooltip=\"{{\'cm.label.69\' | translate}}\" tooltip-append-to-body=true><span ng-if=\"advSearchInfo.dType== \'mp\'\">{{\'d.label.1.1\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'webos\'\">{{\'d.label.1.5\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'tiz\'\">{{\'d.label.1.6\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'mc\'\">{{\'d.label.1.4\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'gf\'\">{{\'d.label.1.2\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'v\'\">{{\'d.label.1.3\' | translate}}</span> <span ng-if=\"advSearchInfo.dType== \'epd\'\">{{\'d.label.1.8\' | translate}}</span> <a href=\"\" ng-click=\"removeAdvSearchFilterFx(\'dt\');\"><span class=\"fa fa-remove\"></span></a></li><li class=word-break ng-if=advSearchInfo.oType uib-tooltip=\"{{\'cm.label.69\' | translate}}\" tooltip-append-to-body=true><span>{{advSearchInfo.oType.label}}</span> <a href=\"\" ng-click=\"removeAdvSearchFilterFx(\'ot\');\"><span class=\"fa fa-remove\"></span></a></li><li class=word-break ng-if=advSearchInfo.serial uib-tooltip=\"{{\'in.p_i.5\' | translate}}\" tooltip-append-to-body=true><span>{{advSearchInfo.serial}}</span> <a href=\"\" ng-click=\"removeAdvSearchFilterFx(\'serial\');\"><span class=\"fa fa-remove\"></span></a></li><li class=word-break ng-if=advSearchInfo.searchId uib-tooltip=\"{{\'cm.label.80\' | translate}}\" tooltip-append-to-body=true><span>{{advSearchInfo.searchId}}</span> <a href=\"\" ng-click=\"removeAdvSearchFilterFx(\'searchId\');\"><span class=\"fa fa-remove\"></span></a></li><li class=noBg ng-if=\"advSearchInfo.tag.include.length > 0\"><ul class=\"list-inline includeList\"><li class=word-break ng-repeat=\"inc in advSearchInfo.tag.include\" uib-tooltip=\"{{\'as.label.8\' | translate}} - {{\'as.label.6\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-tag marR5\" aria-hidden=true></span>{{inc.label}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'ti\', inc.id);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li></ul></li><li class=noBg ng-if=\"advSearchInfo.tag.exclude.length > 0\"><ul class=\"list-inline excludeList\"><li class=word-break ng-repeat=\"exc in advSearchInfo.tag.exclude\" uib-tooltip=\"{{\'as.label.8\' | translate}} - {{\'as.label.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-tag marR5\" aria-hidden=true></span>{{exc.label}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'te\', exc.id);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li></ul></li><li class=noBg ng-if=\"advSearchInfo.userGroup.include.length > 0\"><ul class=\"list-inline includeList\"><li class=word-break ng-repeat=\"inc in advSearchInfo.userGroup.include\" uib-tooltip=\"{{\'cm.label.97\' | translate}} - {{\'as.label.6\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-users marR5\" aria-hidden=true></span>{{inc.label}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'ugi\', inc.id);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li></ul></li><li class=noBg ng-if=\"advSearchInfo.userGroup.exclude.length > 0\"><ul class=\"list-inline excludeList\"><li class=word-break ng-repeat=\"exc in advSearchInfo.userGroup.exclude\" uib-tooltip=\"{{\'cm.label.97\' | translate}} - {{\'as.label.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-users marR5\" aria-hidden=true></span>{{exc.label}} <a href=\"\" role=link ng-click=\"removeAdvSearchFilterFx(\'uge\', exc.id);\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></li></ul></li><li class=word-break ng-if=\"advSearchInfo.module != \'cl\' && advSearchInfo.module != \'t\' && advSearchInfo.module != \'sm\' && (advSearchInfo.fil == \'online\' || advSearchInfo.fil == \'offline\')\" uib-tooltip=\"{{\'d.brief.10\' | translate}}\" tooltip-append-to-body=true><!-- <span>{{advSearchInfo.fil}}</span> --> <span>{{advSearchInfo.fil == \'online\'?\'d.tool.1\':\'d.tool.2\' | translate}}</span> <a href=\"\" ng-click=\"removeAdvSearchFilterFx(\'fil\');\"><span class=\"fa fa-remove\"></span></a></li></ul></div></div></div>");
$templateCache.put("app/common/dir/tmpl/deviceAssignable.html","<div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': avlSort.type === \'l\' && avlSort.val === \'asc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'l\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': avlSort.type === \'l\' && avlSort.val === \'desc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'l\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': avlSort.type === \'createdon\' && avlSort.val === \'asc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'createdon\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': avlSort.type === \'createdon\' && avlSort.val === \'desc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'createdon\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'a\', scrollDataListDyn.a);\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'a\', scrollDataListDyn.a);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{allScrollDataListDyn.a.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{allScrollDataListDyn.a.length+\' / \'+totalCount}} ]</span></label><div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=daSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=daSearch ng-model=searchTextDyn.a sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchTextDyn.a, \'a\');\" ng-disabled=\"!allScrollDataListDyn.a.length && totalCount == 0\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextDyn.a.length ng-click=\"searchTextDyn.a=\'\';searchChangeDataDyn(searchTextDyn.a, \'a\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\" id=scroll-container-a dynamic-scroll-list st=stIndexDyn.a et=etIndexDyn.a list-data=scrollDataListDyn.a search-data=searchTextDyn.a have-more-data=haveMoreDataDyn.a search-scroll=searchScrollDyn.a clone-data=allScrollDataListDyn.a have-more-search-data=haveMoreSearchDataDyn.a quad-id=\"\'a\'\" dd-open=false style=\"max-height: 1702px\"><div class=\"row padTB5 rowObj-a\" id={{option.id}} ng-class=\"option.disabled ? \'disabled cursorDisabled disabledOP\':(option.selected ? \'selectedD\' : \'\')\" ng-repeat=\"option in filteredavlDList = (visibleDataDyn.a)\" ng-if=!loadingPaging.a tooltip-enable=option.disabled uib-tooltip=\"{{\'cm.msg.55\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><div class=col-xs-12><div class=\"padTB2 word-break wordBreakAll\" ng-class=\"{\'cursorDefault\': !option.disabled}\" ng-click=\"selDeviceFx(\'a\', option, visibleDataDyn.a)\"><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.l}}</div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreDataDyn.a || !haveMoreSearchDataDyn.a) && scrollDataListDyn.a.length >= 300 && scrollDataListDyn.a.length == etIndexDyn.a\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"(allScrollDataListDyn.a.length > 0 || totalCount != 0) && filteredavlDList.length == 0 && !loadingPaging.a\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextDyn.a)}}&quot;</b>\'}\"></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.a></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=\"!allScrollDataListDyn.a.length || disabledAddBtn\" ng-click=\"listManipulateFx(\'add\', scrollDataListDyn.a, scrollDataListDyn.s, curDevicesDyn.availableDevicesDyn, \'\', \'\', \'d\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!allScrollDataListDyn.s.length ng-click=\"listManipulateFx(\'remove\', scrollDataListDyn.a, allScrollDataListDyn.s, curDevicesDyn.assignedDevicesDyn, \'\', \'\', \'d\'); asDList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting2 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': selSort.type === \'l\' && selSort.val === \'asc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'l\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': selSort.type === \'l\' && selSort.val === \'desc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'l\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': selSort.type === \'id\' && selSort.val === \'asc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': selSort.type === \'id\' && selSort.val === \'desc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'s\', scrollDataListDyn.s);\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'s\', scrollDataListDyn.s);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{allScrollDataListDyn.s.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{allScrollDataListDyn.s.length}} ]</span></label><div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=dsSearch class=lableHidden>Search</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=dsSearch ng-model=searchTextDyn.s sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchTextDyn.s, \'s\');\" ng-disabled=!allScrollDataListDyn.s.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextDyn.s.length ng-click=\"searchTextDyn.s=\'\';searchChangeDataDyn(searchTextDyn.s, \'s\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\" id=scroll-container-s dynamic-scroll-list st=stIndexDyn.s et=etIndexDyn.s list-data=scrollDataListDyn.s search-data=searchTextDyn.s have-more-data=haveMoreDataDyn.s search-scroll=searchScrollDyn.s clone-data=allScrollDataListDyn.s have-more-search-data=haveMoreSearchDataDyn.s quad-id=\"\'s\'\" dd-open=false style=\"max-height: 1702px\"><div class=\"row padTB5 rowObj-s\" id={{option.id}} ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredasDList = (visibleDataDyn.s)\" ng-if=!loadingPaging.s><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break wordBreakAll\" ng-click=\"selDeviceFx(\'s\', option, visibleDataDyn.s)\"><!-- <span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status |  capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> {{option.l}}</div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreDataDyn.s || !haveMoreSearchDataDyn.s) && scrollDataListDyn.s.length >= 300 && scrollDataListDyn.s.length == etIndexDyn.s\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataListDyn.s.length > 0 && filteredasDList.length == 0 && !loadingPaging.s\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextDyn.s)}}&quot;</b>\'}\"></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.s></div><div class=resize-handle resizable-height></div></div></div></div></div>");
$templateCache.put("app/common/dir/tmpl/deviceStoreAssignable.html","<div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': avlSort.type === \'l\' && avlSort.val === \'asc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'l\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': avlSort.type === \'l\' && avlSort.val === \'desc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'l\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': avlSort.type === \'createdon\' && avlSort.val === \'asc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'createdon\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': avlSort.type === \'createdon\' && avlSort.val === \'desc\' && avlSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'a\', \'createdon\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'a\', scrollDataListDyn.a);\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'a\', scrollDataListDyn.a);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{allScrollDataListDyn.a.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{allScrollDataListDyn.a.length+\' / \'+totalCount.a}} ]</span></label><div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=daSearch class=\"lableHidden hide\">Search</label><div class=\"searchTbx input-xs\"><input type=text id=daSearch class=form-control ng-disabled=\"!allScrollDataListDyn.a.length && totalCount.a == 0\" ng-model=searchTextDyn.a sanitize-input ng-change=\"searchChangeDataDyn(searchTextDyn.a, \'a\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextDyn.a.length ng-click=\"searchTextDyn.a=\'\';searchChangeDataDyn(searchTextDyn.a, \'a\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\" id=scroll-container-a dynamic-scroll-list st=stIndexDyn.a et=etIndexDyn.a list-data=scrollDataListDyn.a search-data=searchTextDyn.a have-more-data=haveMoreDataDyn.a search-scroll=searchScrollDyn.a clone-data=allScrollDataListDyn.a have-more-search-data=haveMoreSearchDataDyn.a quad-id=\"\'a\'\" dd-open=false style=\"max-height: 500px\"><div class=\"row padTB5 rowObj-a\" id={{option.id}} ng-class=\"option.disabled ? \'disabled cursorDisabled disabledOP\':(option.selected ? \'selectedD\' : \'\')\" ng-repeat=\"option in filteredavlDList = (visibleDataDyn.a)\" ng-if=!loadingPaging.a tooltip-enable=option.disabled uib-tooltip=\"{{\'cm.msg.55\' | translate}}\" tooltip-append-to-body=true tooltip-popup-delay=500><div class=col-xs-12><div class=\"padTB2 word-break wordBreakAll\" ng-class=\"{\'cursorDefault\': !option.disabled}\" ng-click=\"selDeviceFx(\'a\', option, visibleDataDyn.a)\"><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.l}}</div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreDataDyn.a || !haveMoreSearchDataDyn.a) && scrollDataListDyn.a.length >= 300 && scrollDataListDyn.a.length == etIndexDyn.a && !loadingMore.a\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreDataDyn.a || !haveMoreSearchDataDyn.a) && scrollDataListDyn.a.length >= 300 && scrollDataListDyn.a.length == etIndexDyn.a && loadingMore.a\"><div class=msg-warning lang={{auth.lang}} ng-if=\"(allScrollDataListDyn.a.length > 0 || totalCount.a != 0) && filteredavlDList.length == 0 && !loadingPaging.a\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextDyn.a)}}&quot;</b>\'}\"></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.a></div><div class=resize-handle resizable-height></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-disabled=\"!allScrollDataListDyn.a.length || disabledAddBtn\" ng-click=\"listManipulateFx(\'add\', scrollDataListDyn.a, scrollDataListDyn.s, curDevicesDyn.availableDevicesDyn, \'\', \'\', \'d\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-disabled=!allScrollDataListDyn.s.length ng-click=\"listManipulateFx(\'remove\', scrollDataListDyn.a, allScrollDataListDyn.s, curDevicesDyn.assignedDevicesDyn, \'\', \'\', \'d\'); asDList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting2 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': selSort.type === \'l\' && selSort.val === \'asc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'l\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': selSort.type === \'l\' && selSort.val === \'desc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'l\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': selSort.type === \'id\' && selSort.val === \'asc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': selSort.type === \'id\' && selSort.val === \'desc\' && selSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"deviceSortFx(\'s\', \'id\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'s\', scrollDataListDyn.s);\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'s\', scrollDataListDyn.s);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{allScrollDataListDyn.s.length > 1?\'cm.body.7s\':\'cm.body.7\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{allScrollDataListDyn.s.length}} ]</span></label><div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><label for=dsSearch class=\"lableHidden hide\">Search</label><div class=\"searchTbx input-xs\"><input type=text class=form-control id=dsSearch ng-model=searchTextDyn.s sanitize-input maxlength=250 ng-change=\"searchChangeDataDyn(searchTextDyn.s, \'s\');\" ng-disabled=!allScrollDataListDyn.s.length placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextDyn.s.length ng-click=\"searchTextDyn.s=\'\';searchChangeDataDyn(searchTextDyn.s, \'s\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=\"panel-body table no-th pad5 noPadB\"><div class=\"padT2 resizable\" id=scroll-container-s dynamic-scroll-list st=stIndexDyn.s et=etIndexDyn.s list-data=scrollDataListDyn.s search-data=searchTextDyn.s have-more-data=haveMoreDataDyn.s search-scroll=searchScrollDyn.s clone-data=allScrollDataListDyn.s have-more-search-data=haveMoreSearchDataDyn.s quad-id=\"\'s\'\" dd-open=false style=\"max-height: 500px\"><div class=\"row padTB5 rowObj-s\" id={{option.id}} ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in filteredasDList = (visibleDataDyn.s)\" ng-if=!loadingPaging.s><div class=col-xs-12><div class=\"padTB2 cursorDefault word-break wordBreakAll\" ng-click=\"selDeviceFx(\'s\', option, visibleDataDyn.s)\"><!-- <span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status |  capitalize}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"500\"></span> --> {{option.l}}</div></div></div><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreDataDyn.s || !haveMoreSearchDataDyn.s) && scrollDataListDyn.s.length >= 300 && scrollDataListDyn.s.length == etIndexDyn.s && !loadingMore.s\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreDataDyn.s || !haveMoreSearchDataDyn.s) && scrollDataListDyn.s.length >= 300 && scrollDataListDyn.s.length == etIndexDyn.s && loadingMore.s\"><div class=msg-warning lang={{auth.lang}} ng-if=\"allScrollDataListDyn.s.length > 0 && filteredasDList.length == 0 && !loadingPaging.s\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextDyn.s)}}&quot;</b>\'}\"></div><img alt=Loading src=assets/images/loading-xs.gif ng-if=loadingPaging.s></div><div class=resize-handle resizable-height></div></div></div></div></div>");
$templateCache.put("app/common/dir/tmpl/hubColorPicker.html","<div class=\"row colorPicker\"><div class=col-xs-6><div><label>{{\'cm.label.62\' | translate}}:</label></div><div class=marB5><a href=\"\" role=link id=monochromePallet ng-repeat=\"color in monochromePallet\" uib-tooltip=\"{{color | uppercase}}\" ng-class=\"{\'selected\':color === selectedColor && selectedType === \'monochrome\'}\" tooltip-popup-delay=1000 style=background-color:{{color}} ng-click=\"applyColor($index, \'monochrome\')\"></a></div><div class=marB5><a href=\"\" role=link id=basicPallet ng-repeat=\"color in basicPallet\" uib-tooltip=\"{{color | uppercase}}\" ng-class=\"{\'selected\':color === selectedColor && selectedType === \'basic\'}\" tooltip-popup-delay=1000 style=background-color:{{color}} ng-click=\"applyColor($index, \'basic\')\"></a></div><div><a href=\"\" role=link id=defaultPallet ng-repeat=\"color in defaultPallet\" uib-tooltip=\"{{color | uppercase}}\" ng-class=\"{\'selected\':color === selectedColor && selectedType === \'default\'}\" tooltip-popup-delay=1000 style=background-color:{{color}} ng-click=\"applyColor($index, \'default\')\"></a></div></div><div class=col-xs-6><div><label for=addColor>{{\'cm.label.63\' | translate}}:</label></div><div class=\"input-group input-group-sm\" ng-class=\"{\'marB18\':(!colorDuplicate == !invalidColorCode)}\" style=width:150px><input type=text id=addColor class=form-control ng-model=addColor ng-change=checkEmpty(); aria-label=addColor aria-labelledby=addColor> <span class=input-group-btn><button type=button role=button class=\"btn btn-default\" ng-click=addColorFx(); ng-disabled=!addColor>{{\'cm.btn.19\' | translate}}</button></span></div><div ng-if=colorDuplicate class=\"msg-warning colorErr\" lang={{auth.lang}}>{{\'cm.msg.19\' | translate}}</div><div ng-if=invalidColorCode class=\"msg-warning colorErr\" lang={{auth.lang}}>{{\'cm.msg.20\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=customPalletLoading class=valign-top><div ng-if=!customPalletLoading><a href=\"\" role=link ng-repeat=\"color in customPallet | reverseAndSplice:48\" uib-tooltip=\"{{color | uppercase}}\" ng-class=\"{\'selected\':color===selectedColor && selectedType === \'custom\'}\" tooltip-popup-delay=1000 style=background-color:{{color}} ng-click=\"applyColor(customPallet.length - ($index + 1), \'custom\')\"></a></div></div><div class=\"col-xs-12 marT5 marB5\" ng-show=isAlpha><label for=alphaRange>{{\'cm.label.93\' | translate}}:</label><input type=range id=alphaRange min=0 max=1 step=0.1 ng-model=selectedAlpha ng-change=\"applyAlpha(\'alpha\')\" aria-label=selectedAlpha aria-labelledby=selectedAlpha></div></div>");
$templateCache.put("app/common/dir/tmpl/permissionsBrief.html","<div><img alt=Loading src=assets/images/loading-xs.gif ng-if=!permission></div><div ng-if=\"permission && !$root.isPermissionOpen && (permission.type != \'p\' || curAuth.uType != 4)\"><span class=\"badge bg-muted marR5\" ng-if=\"permission.type==\'p\'\">{{\'cm.label.19\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"permission.type==\'i\' && other.sig!=\'sig\'\">{{\'cm.label.20\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"permission.type==\'i\' && other.sig==\'sig\'\">{{\'s.p_s.label.2.1\' | translate}}</span> <span class=\"badge bg-muted marR5\" ng-if=\"permission.type==\'c\'\">{{\'cm.label.17\' | translate}}</span> <a href=\"\" ng-if=!cfo role=link name=pEdit aria-label=pEdit id=permissionFx class=\"fa fa-pencil\" aria-hidden=true ng-click=\"permissionFx(\'edit\');\" ng-disabled=isDisabled ng-class=\"{\'text-muted\':isDisabled}\"></a></div><div><div class=\"badge bg-muted\" ng-if=\"permission.type == \'p\' && curAuth.uType == 4\"><div class=\"text-bold text-left marB5\">{{\'cm.body.14\' | translate}}</div><div>{{\'cm.body.14.1\' | translate}}</div></div></div><ng-permission-details ng-if=$root.isPermissionOpen></ng-permission-details>");
$templateCache.put("app/common/dir/tmpl/permissionsDetails.html","<div><img alt=Loading src=assets/images/loading-xs.gif ng-if=permissionLoading></div><div class=permissionDetails ng-if=!permissionLoading><div role=radiogroup aria-labelledby=radiogroup><label class=marR10 ng-if=\"curAuth.uType != 4 && curPermisson.other != \'sig\'\"><input type=radio role=radio name=permission ng-model=curPermisson.type value=p checked aria-label=typeP aria-labelledby=typeP><label></label>{{\'cm.label.19\' | translate}}</label><label class=marR10 ng-if=\"curAuth.uType == 4 && curPermisson.other != \'sig\'\"><input type=radio role=radio name=permission ng-model=curPermisson.type value=i checked aria-label=typeI aria-labelledby=typeI><label></label>{{\'cm.label.20\' | translate}}</label><label class=marR10 ng-if=\"curPermisson.other == \'sig\'\"><input type=radio role=radio name=permission ng-model=curPermisson.type value=i checked aria-label=typeI aria-labelledby=typeI><label></label>{{\'s.p_s.label.2.1\' | translate}}</label><label><input type=radio role=radio name=permission ng-model=curPermisson.type value=c aria-label=typeC aria-labelledby=typeC><label></label>{{\'cm.label.17\' | translate}}</label></div><div class=spaceH></div><div class=row><div class=\"col-xs-12 col-md-5\"><div class=form-group><button type=button role=button id=avaGroup aria-label=avaGroup aria-labelledby=avaGroup class=\"btn btn-default btn-xs pull-right\" ng-click=\"curPermissonModel.availableGroups = []\" ng-disabled=\"curPermisson.type == \'p\' || curPermisson.type == \'i\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button><label for=availableGroups>{{curPermisson.availableGroups.length > 1?\'cm.label.21s\':\'cm.label.21\' | translate}} <span class=\"text-sm text-muted\">[ {{curPermisson.availableGroups.length}} ]</span></label><select class=form-control id=availableGroups ng-model=curPermissonModel.availableGroups ng-disabled=\"curPermisson.type == \'p\' || curPermisson.type == \'i\'\" ng-options=\"option.label for option in curPermisson.availableGroups | orderBy:\'label\' track by option.id\" multiple size=7></select></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuad\"><button type=button role=button ng-click=\"listManipulateFx(\'add\', curPermisson.availableGroups, curPermisson.groups, curPermissonModel.availableGroups);\" class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curPermisson.availableGroups.length}\" ng-disabled=\"curPermisson.type==\'p\' || curPermisson.type==\'i\'\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"listManipulateFx(\'remove\', curPermisson.availableGroups, curPermisson.groups, curPermissonModel.assignedGroups);\" class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curPermisson.groups.length}\" ng-disabled=\"curPermisson.type==\'p\' || curPermisson.type==\'i\'\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><button type=button role=button id=assGroup aria-label=assGroup aria-labelledby=assGroup class=\"btn btn-default btn-xs pull-right\" ng-click=\"curPermissonModel.assignedGroups = []\" ng-disabled=\"curPermisson.type == \'p\' || curPermisson.type == \'i\'\" uib-tooltip=\"{{\'cm.tool.7\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-refresh noMarR\" aria-hidden=true></span></button><label for=assignedGroups>{{curPermisson.groups.length > 1?\'cm.label.22s\':\'cm.label.22\' | translate}} <span class=\"text-sm text-muted\">[ {{curPermisson.groups.length}} ]</span></label><select class=form-control id=assignedGroups ng-model=curPermissonModel.assignedGroups ng-disabled=\"curPermisson.type == \'p\' || curPermisson.type == \'i\'\" ng-options=\"option.label for option in curPermisson.groups | orderBy:\'label\' track by option.id\" multiple size=7></select></div></div></div><div><button type=button role=button class=\"btn btn-success btn-xs\" ng-click=\"permissionFx(\'save\');\" ng-disabled=\"curPermisson.type == \'c\' && curPermisson.groups.length == 0\"><span class=\"fa fa-check\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link btn-xs\" ng-click=\"permissionFx(\'cancel\');\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></div></div>");
$templateCache.put("app/common/dir/tmpl/pinItems.html","<div class=\"bg-light pad10\"><label for=dSearch3_{{$index}} class=lableHidden>device</label><div class=searchTbx><input type=text class=form-control id=dSearch3_{{$index}} ng-model=searchPin.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link id=deviceSR3_{{$index}} class=text-danger ng-show=searchPin.text.length ng-click=\"searchPin.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><img alt=Loading class=pad15 src=assets/images/loading-xs.gif ng-if=pinItemsLoading><div class=\"panel-body dashDevice table no-th dashDeviceBg\" ng-if=!pinItemsLoading><div class=\"dbScrollQuad pinTable\"><div class=bg-white><div element-height=getAvailableHeight(345) delay=true><div ng-if=!pinItemsLoading><!-- {{templates.templates}} --><!-- ========================== --> {{curItem = (([].concat(contentList, folderList, devices.folders, devices.devices, schedules.schedules, templates.folders, templates.templates)) | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}} {{curContentItem = (([].concat(contentList, folderList)) | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}} {{curDeviceItem = (([].concat(devices.devices, devices.folders)) | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}} {{curSchItem = (schedules.schedules | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}}<!-- {{curTempItem = (([].concat(templates.folders, templates.templates)) | filter:searchPin.text); \'\'}} --><!-- {{curTempItem = ([].concat(templates.folders, templates.templates) | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}} --> {{curTempItem = ([].concat(templates.templates, templates.folders) | customSearch:{key:searchPin.text, module:\'pinItem\'}); \'\'}}<!-- {{contentList}} // {{folderList}} // {{devices.folders}} // {{devices.devices}} // {{schedules.schedules}} // {{templates.folders}} // {{templates.templates}} --><ul ng-if=\"!pinItemsLoading && curItem.length\" class=\"table table-md ui-selectable list-unstyled\" uib-dropdown-menu dropdown-append-to-body><!-- Content Library --><div class=marB40 ng-if=\"(folderList.length || contentList.length)\"><div class=\"bdr-btm-dashed noMarB\"><div class=text-bold>{{\"cm.menu.1\" | translate}}</div></div><div class=\"row th\"><div class=col-xs-5><span>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-3><span>{{\'cm.label.69\' | translate}}</span></div><div class=col-xs-2><span>{{\'cm.label.46\' | translate}}</span></div><div class=col-xs-2><span class=pull-right>{{\'cm.label.25\' | translate}}</span></div></div><ul id=content-list><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:searchPin.text, module:\'pinItem\'})\" ng-if=\"folderList.length > 0\"><div class=\"col-xs-5 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=\"col-xs-3 text-ellipsis\">{{folder.type}}</div><div class=\"col-xs-2 text-ellipsis\"><!-- <span ng-if=\"folder.status\">{{folder.status | capitalize}}</span> --> <span class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(folder,\'folder\')\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(folder,context[1], \'content\', \'folder\')\">{{context[0]}}</a></li></ul></div></div></li><li id={{content.id}} class=row ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:searchPin.text, module:\'pinItem\'})\" data-id={{content.id}} data-type=\"{{content.type == \'Widget\'?\'widget\':content.type==\'SharePointC\'?\'SharePointC\':content.type==\'OneDriveC\'?\'OneDriveC\':content.type==\'GoogleDriveC\'?\'GoogleDriveC\':\'content\'}}\" data-sub-type={{content.type}} data-extn={{content.extn}} ng-class=\"{\'unapprovedFile\':content.isApproved === 0, \'nonSelectable unapprovedFile\':(content.type == \'Widget\' && (content.extn == \'Music Choice\' || content.extn == \'Zkong\') && isNonSelectable)}\" ng-if=contentList.length uib-tooltip={{curTooltip}} tooltip-append-to-body=true>{{curTooltip =getTooltip(content.isApproved, content.expiring, content.extn);\"\"}}<div class=\"col-xs-5 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-sm-white\' : \'ppt-sm\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && !content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type !== \'Video\' && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><div class=\"col-xs-3 text-ellipsis\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=content.status>{{content.status | capitalize}}</span> <span ng-if=!content.status class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} data-id={{content.id}} ng-click=\"getActionBtns(content, \'content\', $event);\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(content, context[1], \'content\', \'content\');\">{{context[0]}}</a></li></ul></div></div></li></ul><div ng-if=\"!pinItems.content || (!folderList.length && !contentList.length)\" class=msg-warning>{{\'cm.msg.47\' | translate}}</div><div class=msg-warning ng-if=\"curItem.length && curContentItem.length == 0 && (folderList.length || contentList.length)\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPin.text)}}&quot;</b>\'}\"></div></div><!-- Templates --><div class=marB40 ng-if=\"(templates.templates.length || templates.folders.length)\"><div class=bdr-btm-dashed><div class=text-bold>{{\"cm.menu.2\" | translate}}</div></div><div class=\"row th\"><div class=col-xs-5><span>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-3><span>{{\'cm.label.69\' | translate}}</span></div><div class=col-xs-2><span>{{\'cm.label.46\' | translate}}</span></div><div class=col-xs-2><span class=pull-right>{{\'cm.label.25\' | translate}}</span></div></div><ul id=template-list><!--Item--><li class=row ng-repeat=\"folder in filteredTFolderList = (templates.folders | customSearch:{key:searchPin.text, module:\'pinItem\'})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"templates.folders.length > 0\" class=tabIndex><div class=\"col-xs-5 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=\"col-xs-3 text-ellipsis\"><span>{{folder.type}}</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=folder.status>{{folder.status | capitalize}}</span> <span ng-if=!folder.status class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(folder, \'template\')\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(folder, context[1],\'template\',\'folder\');\">{{context[0]}}</a></li></ul></div></div></li><li class=row ng-repeat=\"template in filteredtemplates.templates = (templates.templates | customSearch:{key:searchPin.text, module:\'pinItem\'}) | orderBy:orderVal\" ng-if=templates.templates.length><div class=\"col-xs-5 text-ellipsis clViwe tList-thumb\"><span class=cl-cIcon><img alt=Incomplete src=assets/images/default/incomplete-xs.png ng-if=!template.thumb> <img alt={{template.tType}} ng-src=\"{{tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" class=img-responsive ng-if=template.thumb> <img alt=na ng-src=\"{{tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span> </span></span><span uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.label}}</span></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=\"template.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"template.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span> <span ng-if=\"template.tType == 6\">{{\'t.label.30\' | translate}}</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=template.status>{{template.status | capitalize}}</span> <span ng-if=!template.status class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(template, \'template\')\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(template, context[1],\'template\',\'template\');\">{{context[0]}} <strong ng-show=context[2].length style=font-family:monospace;font-weight:bold;float:right>&gt;</strong></a><ul ng-show=context[2].length class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"step in context[2]\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performStepFx(template, step[1], \'template\');\">{{step[0]}}</a></li></ul></li></ul></div></div></li></ul><div ng-if=\"!pinItems.templates || (!templates.templates.length && !templates.folders.length)\" class=msg-warning>{{\'cm.msg.47\' | translate}}</div><div class=msg-warning ng-if=\"curItem.length && curTempItem.length == 0 && (templates.folders.length || templates.templates.length)\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPin.text)}}&quot;</b>\'}\"></div></div><!-- Schedules --><div class=marB40 ng-if=schedules.schedules.length><div class=bdr-btm-dashed><div class=text-bold>{{\"cm.menu.3\" | translate}}</div></div><div class=\"row th\"><div class=col-xs-5><span>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-3><span>{{\'cm.label.69\' | translate}}</span></div><div class=col-xs-2><span>{{\'cm.label.46\' | translate}}</span></div><div class=col-xs-2><span class=pull-right>{{\'cm.label.25\' | translate}}</span></div></div><ul id=schedule-list><!--Item--><li class=row ng-repeat=\"s in filteredScheduleList = (schedules.schedules | filter:{\'label\':searchPin.text})\" data-id={{s.id}} ng-class=\"{\'text-muted\':!s.isActive}\"><div class=\"col-xs-5 text-ellipsis\"><label class=text-unbold aria-label=nameBox-{{$index}} aria-labelledby=nameBox-{{$index}}><span class=\"fa fa-warning text-warning\" ng-if=s.isPartial></span> {{s.label}}</label></div><div class=\"col-xs-3 text-ellipsis\"><span ng-if=s.isCustom>{{\'cm.label.17\' | translate}}</span> <span ng-if=!s.isCustom>{{\'s.brief.2\' | translate}}</span></div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=s.status>{{s.status | capitalize}}</span> <span ng-if=!s.status class=text-sm>N/A</span></div><div class=col-xs-2><span class=\"pull-right d-flex\"><switch ng-if=\"s.status.toLowerCase() == \'approved\'\" role=switch class=\"switch-sm nonSelectable\" ng-model=s.isActive on=\"{{\'cm.btn.4\' | translate}}\" off=\"{{\'cm.btn.5\' | translate}}\" data-id={{s.id}} ng-change=statusFx(s.id) aria-checked={{s.isActive?true:false}}></switch><div uib-dropdown dropdown-append-to-body class=marL10><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(s, \'schedule\')\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(s, context[1],\'schedule\',\'schedule\');\">{{context[0]}} <strong ng-show=context[2].length style=font-family:monospace;font-weight:bold;float:right>&gt;</strong></a><ul ng-show=context[2].length class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"step in context[2]\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performStepFx(s, step[1], \'schedule\');\">{{step[0]}}</a></li></ul></li></ul></div></span></div></li></ul><div ng-if=\"!pinItems.schedules || !schedules.schedules.length\" class=msg-warning>{{\'cm.msg.47\' | translate}}</div><div class=msg-warning ng-if=\"curItem.length && curSchItem.length == 0 && (schedules.schedules.length)\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPin.text)}}&quot;</b>\'}\"></div></div><!-- Device --><div ng-if=\"(devices.devices.length || devices.folders.length)\"><div class=bdr-btm-dashed><div class=text-bold>{{\"cm.menu.5\" | translate}}</div></div><div class=\"row th\"><div class=col-xs-5><span>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-3><span>{{\'cm.label.69\' | translate}}</span></div><div class=col-xs-2><span>{{\'cm.label.46\' | translate}}</span></div><div class=col-xs-2><span class=pull-right>{{\'cm.label.25\' | translate}}</span></div></div><ul id=device-list><li class=row ng-repeat=\"folder in deviceFolderList = (devices.folders | customSearch:{key:searchPin.text, module:\'pinItem\'})\" ng-if=\"devices.folders.length > 0\"><div class=\"col-xs-5 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=\"col-xs-3 text-ellipsis\">{{folder.type}}</div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=folder.status>{{folder.status | capitalize}}</span> <span ng-if=!folder.status class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(folder, \'device\')\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(folder, context[1],\'device\',\'folder\');\">{{context[0]}}</a></li></ul></div></div></li><li class=\"row tabIndex\" ng-repeat=\"device in filteredDeviceList = (devices.devices | customSearch:{key:searchPin.text, module:\'pinItem\'})\" uib-tooltip={{curMsg}} tooltip-append-to-body=true tooltip-enable=\"selectedTab != \'hub.dContainer.dgDevice\' && device.isConflict != null && (device.isConflict == 1 || device.isConflict == 2)\" data-id={{device.id}} data-type={{device.type}} data-sub-type={{device.type}}>{{curMsg = ((device.isConflict == 1)?\'\'+(device.dType == \"epd\" ? epdDeviceConflictMsg :deviceConflictMsg)+\'\':\'\'+deviceConflictMsg1+\'\');\"\"}}<div class=\"col-xs-5 text-ellipsis\"><span class=\"deviceStatus {{device.status}}\" title=\"{{device.status | capitalize}}\" role=status aria-label={{device.status}}></span> {{device.label}}</div><div class=\"col-xs-3 text-ellipsis\">{{device.type | capitalize}}</div><div class=\"col-xs-2 text-ellipsis\"><span ng-if=device.status>{{device.status | capitalize}}</span> <span ng-if=!device.status class=text-sm>N/A</span></div><div class=\"col-xs-2 text-ellipsis\"><div class=pull-right uib-dropdown dropdown-append-to-body><a href=\"\" role=link id=vMenu3_{{$index}} ng-click=\"getActionBtns(device, \'device\');\" aria-label=deviceList uib-dropdown-toggle=\"\" class=\"dropdown-toggle pad5\"><span class=\"fa fa-ellipsis-v\" aria-hidden=true></span></a><ul ng-show=!loadMenuItems class=\"dropdown-menu popup-dropdown dropdown-menu-right\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"context in contextMenuOpt\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performActionFx(device, context[1],\'device\',\'device\');\">{{context[0]}} <strong ng-show=context[2].length style=font-family:monospace;font-weight:bold;float:right>&gt;</strong></a><ul ng-show=context[2].length class=\"dropdown-menu popup-dropdown dropdown-menu-left\" uib-dropdown-menu role=menu><li class=dropdown-submenu ng-repeat=\"step in context[2]\"><a href=\"\" role=link id=dlR3_{{$index}} ng-click=\"performStepFx(device, step[1], \'device\');\">{{step[0]}}</a></li></ul></li></ul></div></div></li></ul><div ng-if=\"!pinItems.devices || (!devices.devices.length && !devices.folders.length)\" class=msg-warning>{{\'cm.msg.47\' | translate}}</div><div class=msg-warning ng-if=\"curItem.length && curDeviceItem.length == 0 && (devices.devices.length || devices.folders.length)\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPin.text)}}&quot;</b>\'}\"></div></div></ul><div class=msg-warning ng-if=\"curItem.length == 0 && (folderList.length > 0 || contentList.length > 0 || schedules.schedules.length > 0 || devices.devices.length > 0 || devices.folders.length > 0 || templates.folders.length > 0 || templates.templates.length > 0)\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchPin.text)}}&quot;</b>\'}\"></div><div class=msg-warning ng-if=\"!pinItemsLoading && !folderList.length && !contentList.length && !schedules.schedules.length && !devices.devices.length && !devices.folders.length && !templates.folders.length && !templates.templates.length\">{{\'cm.msg.47\' | translate}}</div></div></div></div></div></div>");
$templateCache.put("app/common/dir/tmpl/tagIcon.html","<svg ng-if=\"type == \'o\' && color\" fill={{color}} xmlns=http://www.w3.org/2000/svg width=16 height=16 class=valign-sub viewBox=\"0 0 16 16\"><path d=\"M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0\"/><path d=\"M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1m0 5.586 7 7L13.586 9l-7-7H2z\"/></svg> <svg ng-if=\"type == \'f\' && color\" xmlns=http://www.w3.org/2000/svg width=16 height=16 fill={{color}} class=valign-sub viewBox=\"0 0 16 16\"><path d=\"M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0\"/></svg> <svg ng-if=!color class=valign-middle aria-label=dts uib-tooltip=\"{{\'t.label.34\' | translate}}\" tooltip-append-to-body=true tooltip-placement=top tooltip-popup-delay=1000 width=18 height=18 version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16\" xml:space=preserve><style type=text/css>.st0{fill:#B6B6B6;}</style><path class=st0 d=\"M5.3,4.2c0,0.7-0.6,1.4-1.4,1.4S2.6,4.9,2.6,4.2S3.2,2.8,4,2.8S5.3,3.4,5.3,4.2 M4.4,4.2c0-0.2-0.2-0.5-0.5-0.5\r\n  S3.5,3.9,3.5,4.2c0,0.2,0.2,0.5,0.5,0.5S4.4,4.4,4.4,4.2\"/><path class=st0 d=\"M1.7,1h4.1c0.2,0,0.5,0.1,0.6,0.3l6.3,6.3c0.4,0.4,0.4,0.9,0,1.3L8.7,13c-0.4,0.4-0.9,0.4-1.3,0L1.1,6.7\r\n  C0.9,6.5,0.8,6.3,0.8,6.1V1.9C0.8,1.4,1.2,1,1.7,1 M1.7,6.1L8,12.4l4.1-4.1L5.8,1.9H1.7V6.1z\"/></svg>");
$templateCache.put("app/common/dir/tmpl/timeZone.html","<div class=form-group><label ng-if=label>{{\'cm.label.33\' | translate}}</label><div class=\"dropdown customSelect\" uib-dropdown auto-close=outsideClick><span class=\"dropdown-toggle form-control text-ellipsis\" uib-dropdown-toggle ng-click=\"searchList=\'\'\"><span ng-if=!curTimeZone.label>{{\'cm.label.33\' | translate}}</span> <span ng-if=curTimeZone.label>{{curTimeZone.label}} - {{curTimeZone.zone}} ({{curTimeZone.tag}})</span> <span class=caret></span></span><ul class=dropdown-menu uib-dropdown-menu role=menu><div class=row><div class=col-xs-12><div class=padLR10><li class=\"dropdown-header noPad noMar\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=\"text-danger noMarT\" ng-show=searchList.length ng-click=\"searchList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></li><li class=divider role=separator></li><div class=\"list-scroll ng-cloak\"><li ng-repeat=\"tz in filteredTZList = (timezoneList | filter: searchFilter)\" tabindex=$index><label><input type=radio role=radio name=tzOpt value=\"{{ {id:tz.id, label:tz.label, zone:tz.zone, tag:tz.tag, offset:tz.offset} }}\" ng-checked=\"tz.id == curTimeZone.id\" ng-model=timezone.label ng-change=selectTimeZone(tz) ng-disabled=\"tz.id == curTimeZone.id\"><label></label>{{tz.label}} - {{tz.zone}} ({{tz.tag}})</label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(timezoneList | filter:searchFilter).length === 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList)}}&quot;</b>\'}\"></div></div></div></div></div></ul></div></div>");
$templateCache.put("app/contentLibrary/widgets/popup/captionLanguages.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cl.label.21\" | translate}}</h1></header><div class=panel-body><img alt=\"\" ng-if=popupLoading src=assets/images/loading.gif><div ng-if=!popupLoading><div class=\"bg-light pad10 marB20\"><div class=row><div class=col-xs-12><label for=language>{{\'cl.widget.oh.8\' | translate}}</label><input type=text id=language class=form-control ng-model=curLangObj.label aria-label=\"{{\'cl.widget.oh.8\' | translate}}\" aria-labelledby=\"{{\'cl.widget.oh.8\' | translate}}\"></div><div class=col-xs-12><div class=\"bdr-top-dashed marT15\"><button type=button role=button class=\"btn btn-success\" ng-click=langAddFx(); ng-disabled=langProcessing><span ng-if=!curLangObj.id><span ng-class=\"langProcessing?\'fa fa-repeat fa-spin\':\'fa fa-plus-circle\'\" aria-hidden=true></span>{{\'cl.btn.23\' | translate}}</span> <span ng-if=curLangObj.id><span ng-class=\"langProcessing?\'fa fa-repeat fa-spin\':\'fa fa-check\'\" aria-hidden=true></span>{{\'cm.btn.15\' | translate}}</span></button> <button type=reset role=button class=\"btn btn-link\" ng-click=langResetFx(); ng-disabled=langProcessing>{{\'cm.btn.34\' | translate}}</button><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><div ng-if=\"errTypePop==\'label\'\" aria-live=polite role=status>{{\'cl.msg.41\' | translate}}</div><div ng-if=\"errTypePop==\'same\'\" aria-live=polite role=status>{{\'cl.msg.42\' | translate}}</div></div></div></div></div></div><div class=\"table bg-white no-th\"><div class=\"row th bg-white\"><div class=col-xs-7>{{\'cl.widget.oh.8\' | translate}}</div><div class=\"col-xs-5 text-right\">{{\'cm.label.25\' | translate}}</div></div><img alt=\"\" ng-if=langDataLoading src=assets/images/loading.gif class=pad10><div ng-if=!langDataLoading><div class=scrollQuad style=max-height:{{getAvailableHeight(540)}}px><div class=row ng-repeat=\"lang in langObj.languages\"><div class=\"col-xs-7 word-break\">{{lang.label}}</div><div class=\"col-xs-5 text-right\"><a href=\"\" role=link class=\"text-primary marR10\" ng-click=langEditFx(lang);><span class=\"fa fa-pencil\" aria-hidden=true></span></a> <a href=\"\" role=link class=text-danger ng-click=langDeleteOpen(lang.id);><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!langDataLoading && !langObj.languages.length\">{{\'cl.msg.43\' | translate}}</div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=resetImportFx();closeThisDialog(); data-dismiss=modal>{{\"cm.btn.10\" | translate}}</button></span></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/codContentSelect.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.cod.13\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=row ng-if=!openPopupLoading><!-- Advanced Search --><advanced-search adv-search-info=advSearchInfo ng-if=\"advSearchInfo.dName || advSearchInfo.creationRange || advSearchInfo.scheduleRange || advSearchInfo.createdBy || advSearchInfo.sName || advSearchInfo.os || advSearchInfo.client || advSearchInfo.tag.include.length > 0 || advSearchInfo.tag.exclude.length > 0 || advSearchInfo.name || advSearchInfo.type || advSearchInfo.dType || advSearchInfo.searchId || advSearchInfo.oType || advSearchInfo.serial || (advSearchInfo.prop && advSearchInfo.prop.value) || advSearchInfo.userGroup.include.length > 0 || advSearchInfo.userGroup.exclude.length > 0 || (advSearchInfo.module != \'cl\' && advSearchInfo.fil)\" class=\"col-xs-12 noPad marB10\"></advanced-search>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown ng-if=\"contentObj.type != \'dmb\'\"><a href=\"\" id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'w-cod\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.pText sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.pText.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" ng-attr-style=height:{{contentObj.quadHeight}}px;><div class=breadcrumb ng-if=\"breadCrumbs.length > 0\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><div ng-if=\"!contentLoading && !advSearch && (folderList.length > 0 || contentList.length > 0)\"><div ng-if=contentLibrary.info.wp class=\"pad4 marB10\" ng-class=\"(auth.uType == 3 || auth.uType == 4)?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.sp || (odSp.auth && odSp.curType==\'SharePoint\')\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.od || (odSp.auth && odSp.curType==\'OneDrive\')\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div class=\"pad5 msg-info marB10\" ng-if=\"contentLibrary.info.gd || (odSp.auth && odSp.curType==\'Googledrive\')\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><ul class=\"list-inline thumb-list overflow-auto\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'t\'\" element-height=contentObj.quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'l\'\" element-height=contentObj.quadHeight><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentList.length == 0 && folderList.length == 0\">{{\'as.msg.2\' | translate}}</div></div></div><div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} [ {{(addCategory.content | filter:{hidden:0}).length}} ]</div><section class=noMarB><div class=\"padTB10 overflow-auto\" ng-attr-style=height:{{contentObj.selectedHeight}}px;><div ng-if=\"addCategory.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=\"sortCallback(\'popup\')\" containment=\"\'parent\'\" ng-if=\"auth.upreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (addCategory.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=sortable-item ng-class=\"{\'codHidden\':content.hidden}\" ng-hide=content.hidden><a href class=thumb-close ng-click=\"closeFilteredFx(content.id, content.wcodid, content.tempId)\"><span class=\"fa fa-times-circle\"></span></a><div class=thumb><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isblur}\" uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\')\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss\" ng-href=\"{{cDetailBucket+content.ssImg | secureThumb:timestamp}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + content.ssImg+\'&v=\'+timestamp + thumbBigParam}}\" class=\"img-responsive center-block img-widget\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Images --> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- YouTube & Vimeo --> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbBigParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\" ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\" uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</div><div class=form-inline ng-if=\"content.type == \'Video\' || content.thumb == \'livestream\'\"><div class=\"fullScreen text-left noMar\" ng-if=\"content.type == \'Video\' || content.thumb == \'livestream\'\"><label class=noMarB><input type=checkbox ng-model=content.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label><label class=noMarB><input type=checkbox ng-disabled=\"content.caption == 0\" ng-model=content.isCaption><label></label><span class=valign-inherit>{{\'cl.label.10\' | translate}}</span></label></div></div><div class=form-inline ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><div class=\"fullScreen text-left noMar\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><label class=noMarB><input type=checkbox ng-model=content.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></div></div></li></ul><ul class=\"table table-md list-unstyled sortable-containment\" sortable callback=\"sortCallback(\'popup\')\" containment=\"\'parent\'\" ng-if=\"auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.2\' | translate}}</div> --><!-- <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-4>{{\'cm.label.69\' | translate}}</div><!-- <div class=\"col-xs-1\">{{\'cm.brief.12\' | translate}}</div> --><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in selectedFilteredContent = (addCategory.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-class=\"{\'codHidden\':cl.hidden}\" ng-hide=cl.hidden><div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=col-xs-4>{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div><div class=\"col-xs-2 text-right\"><span ng-hide=\"cl.extn == \'Music Choice\'\"><span class=marR10 ng-if=\"cl.type == \'Audio\' || cl.type == \'Video\' || cl.extn == \'YouTube\' || cl.extn == \'Vimeo\' || cl.extn == \'Online Radio\'\"><label class=noMarB><input type=checkbox ng-model=cl.mute><label></label><span class=valign-inherit>{{\'cm.label.67\' | translate}}</span></label></span></span><a href=\"\" class=text-danger ng-click=\"closeFilteredFx(cl.id, cl.wcodid, cl.tempId)\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"addCategory.content.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"addCategory.content.length > 0 && (addCategory.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); focus-me=true data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/coevPreview.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.7\' | translate}} / {{\'cs.btn.5\' | translate}}</h1><span class=\"marL5 text-sm\">[{{coev.info.label}}]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=row ng-if=\"!openPopupLoading && preview.calendar.length\"><div class=col-xs-8><div class=templateToolbar><div class=\"pull-left bdrRd bdrRL8\"><button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.5\' | translate}}\" ng-click=\"addFrame(\'content\');\"><span class=\"fa fa-image noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.1\' | translate}}\" ng-click=\"addFrame(\'text\');\"><span class=\"fa fa-font noMarR\" aria-hidden=true></span></button></div><div class=pull-left><button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.2\' | translate}}\" ng-click=\"addFrame(\'rectangle\');\"><span class=\"fa fa-square-o noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.editor.3\' | translate}}\" ng-click=\"addFrame(\'circle\');\"><span class=\"fa fa-circle-o noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrLd bdrLR8\"><button type=button role=button class=\"btn btn-default\" ng-click=duplicateFrame(); ng-if=\"curFrame && curFrame.type != \'table\'\"><span class=\"fa fa-object-ungroup\" aria-hidden=true></span> {{\'cm.btn.30\' | translate}}</button></div><div class=pull-right><button type=button role=button class=\"btn btn-default\" uib-tooltip=\"{{\'cm.btn.47\' | translate}}\" ng-click=printDiv(previewItem.label);><span class=\"fa fa-print noMarR\" aria-hidden=true></span></button></div><div class=clearfix></div></div><div id=canvas class=\"overflow-auto canvasBg\" ng-click=deselectAllFrames() style=height:{{getAvailableHeight(300)}}px;max-height:{{getAvailableHeight(300)}}px><div class=flGrid style=width:1000px><div ng-if=\"preview.type == \'d\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><style>.frame.circle{border-radius:50%}</style><div draggable ng-repeat=\"frame in preview.frames\" ng-if=\"frame.type != \'table\'\" data-index={{$index}} class=frameDrag style=left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}};position:absolute><div resizable on-resize=\"frameResize($event, $ui, $index)\" data-id={{frame.id}} data-index={{$index}} class=\"frame {{frame.type}}\" ng-click=\"selectFrame($event, frame, $index);\" style=width:{{frame.width}}px;height:{{frame.height}}px;background-color:{{frame.bg}};-webkit-print-color-adjust:exact;transform:rotate({{frame.rotation}}deg)><div ng-if=\"frame.type === \'text\'\" class=text-ellipsis-wrap style=font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};overflow:unset;line-height:normal>{{frame.text}}</div><!--white-space:pre-wrap;--><div ng-if=\"frame.type === \'content\'\" class=contentPh><span ng-if=\"frame.content[0].type != \'SharePointC\'\"><img alt=\"\" src=\"{{tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb + \'.png\' + thumbParam}}\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn != \'YouTube\' && frame.content.length > 0\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb+\'.png\'}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && (frame.content[frame.content.length -1].type == \'Flash\' || frame.content[frame.content.length -1].type == \'Audio\')\"> <img alt=\"\" src=\"{{tim + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height}}&w={{frame.width * canvas.zoom}}&q=80&zc=3\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn == \'YouTube\' && frame.content.length > 0\"> </span><img alt=\"\" ng-src=assets/images/default/sp.png ng-if=\"frame.content[0].type == \'SharePointC\'\" width=90px></div></div></div><div style=position:relative;z-index:{{tableZ}}><div class=\"text-center nav-bar text-big pad10 bg-light\" style=\"background:{{coev.info.settings.headerBg}};-webkit-print-color-adjust:exact;color:{{coev.info.settings.headerText}};padding:10px;text-align:center;border-bottom:1px solid #d5d5d5;margin:0 0 15px 0\">{{previewItem.label}}</div><div ng-repeat=\"meeting in previewItem.meetings\" class=\"bdr-btm-dashed padTB10 noMarB\" style=padding-top:10px;padding-bottom:10px><table class=table><tr><td style=\"background:{{coev.info.settings.rowBg}};-webkit-print-color-adjust:exact;padding-left:10px;border:1px solid {{coev.info.settings.rowBg}};border-left:4px solid {{coev.info.settings.timeBg}}\"><div style=font-size:18px;margin-bottom:10px;color:{{coev.info.settings.eventText}}>{{meeting.label}}</div><div style=color:{{coev.info.settings.roomText}}>{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div></td><td class=text-center style=\"font-size:18px;width:150px;background:{{coev.info.settings.timeBg}};-webkit-print-color-adjust:exact;border:1px solid {{coev.info.settings.timeBg}};color:{{coev.info.settings.timeText}};vertical-align:middle\"><div>{{meeting.st}}</div><div style=height:10px;line-height:7px>-</div><div>{{meeting.et}}</div></td></tr></table></div></div></div><div ng-if=\"preview.type == \'w\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><style>.frame.circle{border-radius:50%}</style><div draggable ng-repeat=\"frame in preview.frames\" ng-if=\"frame.type != \'table\'\" data-index={{$index}} class=frameDrag style=left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}};position:absolute><div resizable on-resize=\"frameResize($event, $ui, $index)\" data-id={{frame.id}} data-index={{$index}} class=\"frame {{frame.type}}\" ng-click=\"selectFrame($event, frame, $index);\" style=width:{{frame.width}}px;height:{{frame.height}}px;background-color:{{frame.bg}};-webkit-print-color-adjust:exact;transform:rotate({{frame.rotation}}deg)><div ng-if=\"frame.type === \'text\'\" class=text-ellipsis-wrap style=font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};overflow:unset;line-height:normal>{{frame.text}}</div><!--white-space:pre-wrap;--><div ng-if=\"frame.type === \'content\'\" class=contentPh style=text-align:center><span ng-if=\"frame.content[0].type != \'SharePointC\'\"><img alt=\"\" src=\"{{tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb + \'.png\' + thumbParam}}\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn != \'YouTube\' && frame.content.length > 0\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb+\'.png\'}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && (frame.content[frame.content.length -1].type == \'Flash\' || frame.content[frame.content.length -1].type == \'Audio\')\"> <img alt=\"\" src=\"{{tim + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.heigh}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn == \'YouTube\' && frame.content.length > 0\"> </span><img alt=\"\" ng-src=assets/images/default/sp.png ng-if=\"frame.content[0].type == \'SharePointC\'\" width=90px></div></div></div><div style=position:relative;z-index:{{tableZ}}><div class=\"text-center nav-bar text-big pad10 bg-light\" style=\"background:{{coev.info.settings.headerBg}};-webkit-print-color-adjust:exact;padding:10px;text-align:center;border-bottom:1px solid #d5d5d5;margin:0 0 15px 0;color:{{coev.info.settings.headerText}}\">{{previewItem.label}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in preview.weekdays\" class=\"text-center bg-info\" style=\"background:{{coev.info.settings.dayNameBg}};-webkit-print-color-adjust:exact;border:1px solid #b1ccda;color:{{coev.info.settings.dayNameText}};width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr><td ng-repeat=\"days in previewItem.meetings\" style=\"width:{{100 / preview.weekdays.length}}%;background:{{coev.info.settings.cellBg}}\"><div ng-repeat=\"meeting in days.meeting\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=\"text-bold marB5\" style=font-weight:600;color:{{coev.info.settings.eventText}}>{{meeting.label}}</div><div class=\"text-sm marB5\" style=color:{{coev.info.settings.roomText}}>{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div><div class=text-sm style=color:{{coev.info.settings.timeText}}>{{meeting.st}} - {{meeting.et}}</div></div></td></tr></table></div></div><div ng-if=\"preview.type == \'m\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><style>.frame.circle{border-radius:50%}</style><div draggable ng-repeat=\"frame in preview.frames\" ng-if=\"frame.type != \'table\'\" data-index={{$index}} class=frameDrag style=left:{{frame.x}}px;top:{{frame.y}}px;z-index:{{frame.z}};position:absolute><div resizable on-resize=\"frameResize($event, $ui, $index)\" data-id={{frame.id}} data-index={{$index}} class=\"frame {{frame.type}}\" ng-click=\"selectFrame($event, frame, $index);\" style=width:{{frame.width}}px;height:{{frame.height}}px;background-color:{{frame.bg}};-webkit-print-color-adjust:exact;transform:rotate({{frame.rotation}}deg)><div ng-if=\"frame.type === \'text\'\" class=text-ellipsis-wrap style=font-family:{{frame.font.value}};font-weight:{{frame.bold}};font-size:{{frame.size}}px;color:{{frame.color}};text-decoration:{{frame.underline}};font-style:{{frame.italic}};text-align:{{frame.align}};overflow:unset;line-height:normal>{{frame.text}}</div><!--white-space:pre-wrap;--><div ng-if=\"frame.type === \'content\'\" class=contentPh><span ng-if=\"frame.content[0].type != \'SharePointC\'\"><img alt=\"\" src=\"{{tim + cBucket + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && frame.content[frame.content.length -1].type != \'Widget\' && frame.content[frame.content.length -1].type != \'Flash\' && frame.content[frame.content.length -1].type != \'Audio\'\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb + \'.png\' + thumbParam}}\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn != \'YouTube\' && frame.content.length > 0\"> <img alt=\"\" src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + frame.content[frame.content.length - 1].thumb+\'.png\'}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content.length > 0 && (frame.content[frame.content.length -1].type == \'Flash\' || frame.content[frame.content.length -1].type == \'Audio\')\"> <img alt=\"\" src=\"{{tim + frame.content[frame.content.length - 1].thumb}}&a=t&h={{frame.height}}&w={{frame.width}}&q=80&zc=3\" ng-if=\"frame.content[frame.content.length -1].type == \'Widget\' && frame.content[frame.content.length -1].extn == \'YouTube\' && frame.content.length > 0\"> </span><img alt=\"\" ng-src=assets/images/default/sp.png ng-if=\"frame.content[0].type == \'SharePointC\'\" width=90px></div></div></div><div style=position:relative;z-index:{{tableZ}}><div class=\"text-center nav-bar text-big pad10 bg-light\" style=\"background:{{coev.info.settings.headerBg}};-webkit-print-color-adjust:exact;padding:10px;text-align:center;border-bottom:1px solid #d5d5d5;margin:0 0 15px 0;color:{{coev.info.settings.headerText}}\">{{\'s.p_s.label.11.\' + previewItem.label.split(\"|\")[0] | translate}} {{previewItem.label.split(\"|\")[1]}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in weekdays\" class=text-center style=\"background:{{coev.info.settings.dayNameBg}};-webkit-print-color-adjust:exact;border:1px solid #b1ccda;color:{{coev.info.settings.dayNameText}};width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr ng-repeat=\"week in curCalendar\"><td ng-repeat=\"date in week.days\" style=\"width:{{100 / weekdays.length}}%;background:{{coev.info.settings.cellBg}}\" ng-class=\"{\'text-muted\':date.month() != curMonth}\" ng-style=\"date.month() != curMonth && {\'background\':\'#f8f8f8\',\'-webkit-print-color-adjust\':\'exact\'}\"><div class=marB5>{{date.date()}}</div><div ng-if=\"date.month() == curMonth\" ng-repeat=\"meeting in preview.calendar[currentPage].meetings[date.date()-1].meeting\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=text-bold style=font-weight:600;color:{{coev.info.settings.eventText}}>{{meeting.label}}</div><div class=\"text-sm marB5\" style=color:{{coev.info.settings.roomText}}>{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div><div class=text-sm style=color:{{coev.info.settings.timeText}}>{{meeting.st}} - {{meeting.et}}</div></div></td></tr></table></div></div></div></div></div><div class=col-xs-4><div class=\"panel noMarB\"><header class=\"panel-heading panel-tab panel-tab-line\"><ul class=\"nav nav-tabs\" role=tablist aria-owns=\"tab-1 tab-2 tab-3 tab-4\" aria-labelledby=navList><li class=tab-success id=tab-1 role=tab aria-selected=true ng-class=\"{\'active\':popupTab==\'1\'}\"><a href=\"\" role=link ng-click=popupTabFx(1);>{{\'t.label.3\' | translate}}</a></li><li class=tab-success id=tab-2 role=tab aria-selected=false ng-class=\"{\'active\':popupTab==\'2\'}\"><a href=\"\" role=link ng-click=popupTabFx(2);>{{\'fl.p_cfl.tab.2\' | translate}}</a></li><li class=tab-primary id=tab-3 role=tab aria-selected=false ng-class=\"{\'active\':popupTab==\'3\'}\" ng-if=\"curFrame.type == \'content\'\"><a href=\"\" role=link ng-click=popupTabFx(3);>{{\'cm.label.1\' | translate}}</a></li><li class=tab-primary id=tab-4 role=tab aria-selected=false ng-class=\"{\'active\':popupTab==\'4\'}\" ng-if=\"curFrame.type == \'text\'\"><a href=\"\" role=link ng-click=popupTabFx(4);>{{\'cm.label.64\' | translate}}</a></li></ul></header><div class=pad10 ng-show=\"popupTab==\'1\'\"><div class=tab-body><div ng-if=!curFrame class=\"text-muted text-sm\">{{\'cm.msg.6\' | translate}}</div><div ng-if=curFrame><div class=\"form-group row\"><div class=col-xs-6><label class=noPadT>{{\'cm.brief.1\' | translate}}:</label><input type=text id=frameName class=\"form-control input-sm\" ng-model=curFrame.label maxlength={{inputLimit}} aria-label=\"{{\'cm.brief.1\' | translate}}\" aria-labelledby=\"{{\'cm.brief.1\' | translate}}\"></div><div class=col-xs-6><label class=noPadT>{{\'cm.label.58\' | translate}}:</label><input type=number id=rotation class=\"form-control input-sm\" ng-model=curFrame.rotation min=-360 max=360 aria-label=\"{{\'cm.label.58\' | translate}}\" aria-labelledby=\"{{\'cm.label.58\' | translate}}\"></div></div><div class=\"form-group row\"><div class=col-xs-6><label for=xPos>{{\'fl.p_cfl.label.8\' | translate}}:</label><input type=number id=xPos class=\"form-control input-sm\" ng-model=curFrame.x maxlength=5 aria-label=\"{{\'fl.p_cfl.label.8\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.8\' | translate}}\"></div><div class=col-xs-6><label for=yPos>{{\'fl.p_cfl.label.9\' | translate}}:</label><input type=number id=yPos class=\"form-control input-sm\" ng-model=curFrame.y maxlength=5 aria-label=\"{{\'fl.p_cfl.label.9\' | translate}}\" aria-labelledby=\"{{\'fl.p_cfl.label.9\' | translate}}\"></div></div><div class=\"form-group row\"><div class=col-xs-6><label for=frameWidth>{{\'cm.label.59\' | translate}}:</label><input type=number id=frameWidth class=\"form-control input-sm\" ng-model=curFrame.width min=1 maxlength=5 aria-label=\"{{\'cm.label.59\' | translate}}\" aria-labelledby=\"{{\'cm.label.59\' | translate}}\"></div><div class=col-xs-6><label for=frameHeight>{{\'cm.label.60\' | translate}}:</label><input type=number id=frameHeight class=\"form-control input-sm\" ng-model=curFrame.height min=1 maxlength=5 aria-label=\"{{\'cm.label.60\' | translate}}\" aria-labelledby=\"{{\'cm.label.60\' | translate}}\"></div></div><div class=form-group ng-class=\"frameBg.isChecked?\'\':\'marB5\'\"><label ng-click=frameBgFx($event);><input type=checkbox ng-model=frameBg.isChecked role=checkbox><label></label>{{\'cm.label.61\' | translate}}</label><div uib-dropdown dropdown-append-to-body auto-close=outsideClick is-open=colorPicker.isOpen ng-show=frameBg.isChecked><input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.bg | uppercase\" ng-click=colorPickerOpen($event); readonly aria-label=\"{{\'cm.label.61\' | translate}}\" aria-labelledby=\"{{\'cm.label.61\' | translate}}\"><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.bg selected-type=curFrame.bgType></ng-hub-color-picker></div></div></div></div></div></div><div class=pad10 ng-show=\"popupTab==\'2\'\"><div class=\"tab-body overflow-auto\" style=max-height:{{getAvailableHeight(335)}}px><ul class=\"layer-container sortable-containment list-unstyled noMar\" sortable axis=\"\'y\'\" callback=sortCallback()><li ng-repeat=\"frame in preview.frames | orderBy: \'z\':true\" class=\"layer sortable-item\" data-id={{frame.id}} ng-click=\"selectFrame($event, frame, (preview.frames.length - $index - 1))\"><button type=button role=button class=\"btn btn-link btn-sm pull-right\" ng-if=\"frame.type != \'table\'\" ng-click=\"removePlaceholder(frame.id, \'l\')\"><span class=\"fa fa-remove noMarR text-danger\" aria-hidden=true></span></button><div class=text-ellipsis><span class=layerBg ng-style=\"frame.bg != \'rgba(0, 150, 255, 0.4)\' && {\'background\':frame.bg}\"></span> <span class=layerFrameLabel>{{frame.label}}</span></div></li><div ng-if=!preview.frames.length class=\"text-muted text-sm\">{{\'cm.msg.6\' | translate}}</div></ul></div></div><div class=pad10 ng-show=\"popupTab==\'3\'\"><div ng-if=\"!curFrame || curFrame.type != \'content\'\" class=\"text-muted text-sm\" translate=\"{{\'cm.msg.6\'}}\" translate-values=\"{str: \'<b>Content</b>\'}\"></div><div class=\"marT5 marB10\" ng-show=\"curFrame.type == \'content\'\"><button type=button role=button class=\"btn btn-primary btn-sm\" ng-click=\"selectContentOpen(); searchText=\'\'\">{{\'cm.label.32\' | translate | camelCase}}</button></div><div class=cList1 ng-if=\"curFrame.type == \'content\'\"><div class=\"list-container table\"><div class=msg-warning lang={{auth.lang}} ng-if=\"curFrame.content.length == 0\">{{\'t.msg.13\' | translate}}</div><div class=\"row th\" ng-if=\"curFrame.content.length != 0\"><div class=col-xs-10>{{\'cm.label.1\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.label.25\' | translate}}</div></div><ul class=overflow-auto style=max-height:{{getAvailableHeight(410)}}px><li class=row ng-repeat=\"content in curFrame.content\" ng-if=!content.hidden><div class=\"col-xs-11 text-ellipsis\"><span ng-if=\"content.type != \'SharePointC\'\"><img alt=\"\" class=marR5 src=\"{{tim + cBucket + content.thumb}}&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type != \'Widget\' && content.type != \'Audio\' && content.type != \'Flash\'\"> <img alt=\"\" class=marR5 src=\"{{tim + cBucket + \'widgets/thumbs/n/\' + content.thumb}}.png&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type != \'Widget\' && (content.type == \'Audio\' || content.type == \'Flash\')\"> <img alt=\"\" class=marR5 src=\"{{tim + cBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\'\"> <img alt=\"\" class=marR5 src=\"{{tim + content.thumb}}&a=t&h=24&w=25&q=80&zc=2\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"> </span><img alt=\"\" ng-src=assets/images/default/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" width=25px> {{content.label}}</div><div class=\"col-xs-1 text-right\"><a href=\"\" role=link ng-click=removeContentFx($index);><span class=\"fa fa-remove noMarR text-danger\" aria-hidden=true></span></a></div></li></ul></div></div></div><div class=pad10 ng-show=\"popupTab==\'4\'\"><div class=tab-body><div ng-if=\"!curFrame || curFrame.type != \'text\'\" class=\"text-muted text-sm\" translate=\"{{\'cm.msg.6\'}}\" translate-values=\"{str: \'<b>Text</b>\'}\"></div><div ng-if=\"curFrame.type == \'text\'\"><div class=text-toolbar><div><div class=\"pull-left bdrRd bdrRL8\"><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.1\' | translate}}\" ng-click=\"textPropFx(\'bold\');\"><span class=\"fa fa-bold noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.2\' | translate}}\" ng-click=\"textPropFx(\'italic\');\"><span class=\"fa fa-italic noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.3\' | translate}}\" ng-click=\"textPropFx(\'underline\');\"><span class=\"fa fa-underline noMarR\" aria-hidden=true></span></button></div><div class=\"pull-left bdrRd bdrRL8\"><button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.4\' | translate}}\" ng-click=\"textPropFx(\'left\');\"><span class=\"fa fa-align-left noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.5\' | translate}}\" ng-click=\"textPropFx(\'center\');\"><span class=\"fa fa-align-center noMarR\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-sm btn-default\" uib-tooltip=\"{{\'cm.editor.10.6\' | translate}}\" ng-click=\"textPropFx(\'right\');\"><span class=\"fa fa-align-right noMarR\" aria-hidden=true></span></button></div><div class=pull-left><div uib-dropdown auto-close=outsideClick dropdown-append-to-body><input type=text class=\"form-control picker\" uib-dropdown-toggle ng-value=\"curFrame.color | uppercase\" ng-click=\"colorPicker = true\" style=width:85px readonly><div class=\"dropdown-menu dropdown-to-body\" placement=\"left center\" uib-dropdown-menu><ng-hub-color-picker selected-color=curFrame.color selected-type=curFrame.bgType ng-if=colorPicker></ng-hub-color-picker></div></div></div><div class=clearfix></div></div><div class=spaceH></div><div class=row><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.24\' | translate}}:</span><select id=font class=form-control ng-model=curFrame.font ng-options=\"font.label for font in fontFamily track by font.value\" aria-label=\"{{\'cm.label.24\' | translate}}\" aria-labelledby=\"{{\'cm.label.24\' | translate}}\"></select></div></div><div class=col-xs-6><div class=input-group><span class=input-group-addon>{{\'cm.label.83\' | translate}}:</span> <input type=number id=size class=form-control number-converter ng-model=curFrame.size min=0 aria-label=\"{{\'cm.label.83\' | translate}}\" aria-labelledby=\"{{\'cm.label.83\' | translate}}\"></div></div></div></div><div class=spaceH></div><div><textarea class=\"form-control txtAreaBig\" ng-model=curFrame.text ng-readonly=\"curFrame.feedRef == 1\"></textarea></div></div></div></div><div class=\"panel-body hide\"><div ui-view=tabView></div></div></div><!-- temporary showing captured image --><div id=img-out></div></div></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!openPopupLoading && !preview.calendar.length\">{{\'cl.widget.coev.m1\' | translate}}</div></div><footer class=panel-footer ng-show=\"!openPopupLoading && !preview.calendar.length\"><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span></footer><footer class=panel-footer ng-show=\"!openPopupLoading && preview.calendar.length\"><div class=pull-right ng-show=\"preview.type != \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=updateCurrentPage(-1)><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=updateCurrentPage(+1)><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><div class=pull-right ng-show=\"preview.type == \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=showCalendarFx(-1)><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=showCalendarFx(+1)><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=\"savePrintFx(\'s\');\" ng-disabled=printSProcessing><span class=fa ng-class=\"printSProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-success\" ng-click=\"savePrintFx(\'sc\');\" ng-disabled=printSCProcessing><span class=fa ng-class=\"printSCProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.8\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasSelectErr aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=maxCountPop aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/createView.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\"cl.widget.coe.6\" | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div class=row ng-if=!devicesLoading><div class=col-xs-12><div class=form-group><label>{{\"cl.widget.coe.8\" | translate}}</label><input type=text class=form-control ng-model=viewObj.info.label></div><div class=form-group><label>{{\'cm.label.69\' | translate}}</label><select class=form-control ng-model=viewObj.info.type><option value=\"\" disabled>{{\'cl.widget.cm.20\' | translate}}</option><option value=d>{{\'cl.widget.sc.3\' | translate}}</option><option value=w>{{\'cl.widget.sc.4\' | translate}}</option><option value=m>{{\'cl.widget.sc.5\' | translate}}</option></select></div></div><div class=col-xs-12><div class=\"form-group pull-left bdrRd padR20 marR20\" ng-class=\"{\'noMarR\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cm.label.15\' | translate}}</label><ng-permission-brief permission=viewObj.info.permission pid=decId module=\"\'content\'\"></ng-permission-brief></div><div class=\"form-group pull-left\" ng-class=\"{\'bdrLd padL20 marL-1\':!isPermissionOpen && activePeriodOpen}\"><label>{{\'cl.brief.5\' | translate}}</label><ng-active-period active-period=viewObj.info.activePeriod></ng-active-period></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=createViewFx(); ng-disabled=viewProcessing><span class=fa ng-class=\"viewProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{viewProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\"cm.btn.9\" | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErrPop aria-live=polite role=status><span ng-if=\"errTypePop==\'name\'\" aria-live=polite role=status>{{\'cl.widget.coe.m2\' | translate}}</span> <span ng-if=\"errTypePop==\'type\'\" aria-live=polite role=status>{{\'cl.widget.coe.m3\' | translate}}</span></div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/devices.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.meeting.12\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div class=row ng-if=\"!devicesLoading && allScrollDataListDyn.a.length\"><ng-device-store-assignable assignable-list-data=scrollDataListDyn have-more-assignable-data=haveMoreDataDyn clone-assignable-data=allScrollDataListDyn assignable-scroll-obj=scrollObjDyn min-deduct=auth.upreferences.dot page-tab=pageTab total-count=totalDeviceCount store-data-list=storeDataList></ng-device-store-assignable></div><div ng-if=\"!allScrollDataListDyn.a.length && !devicesLoading\" class=msg-warning lang={{auth.lang}}>{{\'d.msg.1\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveDevicesFx(\'s\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(\'c\'); resetD();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=popupErr aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/iMenuContentList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.32\' | translate | camelCase}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=\"contentLoading && openingLoading\"> {{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=row ng-if=!openingLoading><div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12\'\"><div class=advSearch><div class=pull-right uib-dropdown><a href=\"\" id=vMenu1 class=\"btn btn-default btn-sm marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'w-sc\', \'w-alert\' , default);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></div><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 ng-change=searchChangeFx() placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=search.text.length ng-click=\"searchChangeFx(\'empty\')\"><span class=\"fa fa-remove\"></span></a></div></div><div class=panel-inner-tab>{{\'cm.body.4\' | translate}}</div><div class=\"overflow-auto pad10 bg-light\" style=height:{{contentObj.quadHeight}}px><div class=breadcrumb ng-class=\"{\'marB5\':contentLibrary.info.wp || contentLibrary.info.sp}\" ng-if=\"breadCrumbs.length > 0 && !openingLoading\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"contentLibrary.info.wp && !openingLoading\" class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=\"contentLibrary.info.sp && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=\"contentLibrary.info.od && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=\"contentLibrary.info.gd && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><ul class=\"list-inline thumb-list\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'t\'\" element-height=contentObj.quadHeight><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'l\'\" element-height=getAvailableHeight(340) style=max-height:{{getAvailableHeight(340)}}px><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentList.length == 0 && folderList.length == 0\">{{\'cm.msg.7\' | translate}}</div></div></div><div ng-class=\"contentObj.isSplitV?\'col-xs-6\':\'col-xs-12 marT25\'\"><div class=selectedQuad><div class=\"pull-right searchTbx selectedQuadSearch\"><input type=text class=form-control ng-model=selectedSearchText sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=selectedSearchText.length ng-click=\"selectedSearchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div><div class=panel-inner-tab>{{\'cm.body.5\' | translate}} [ {{selectedContent.content.length - selectedContent.count}} ]</div><section class=noMarB><div class=\"padTB10 overflow-auto\" style=height:{{contentObj.selectedHeight}}px><div ng-if=\"selectedContent.content.length > 0\"><ul class=\"list-inline multiple-selected sortable-containment\" sortable callback=sortCallback() ng-if=\"auth.upreferences.contentView == \'t\'\"><li ng-repeat=\"content in selectedFilteredContent = (selectedContent.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{content.id}} class=sortable-item ng-if=!content.hidden><a href=\"\" role=link class=thumb-close ng-click=\"removeContentFx(content.id, \'t\', $index);\"><span class=\"fa fa-times-circle\" aria-hidden=true></span></a><div class=thumb><span class=thumb-inner uib-tooltip-html=\"content.isAccessible?\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span>{{content.path}}\':\'{{\'cm.msg.39\' | translate}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <a ng-if=\"content.type == \'Audio\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbAudioFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Flash --> <a ng-if=\"content.type == \'Flash\'\" href=\"\" role=button ng-click=\"fbFlashFx(cDetailBucket + content.url, content.label, content.dimension);\"><img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"> </a><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\'\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png class=\"img-responsive center-block img-widget\"><!-- Images --> <a ng-if=\"content.type == \'Image\'\" ng-href=\"{{cDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- YouTube & Vimeo--> <a ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" ng-href={{content.url}} role=link fancyboxable=fbMedia data-fancybox-title={{content.label}}><img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\"> </a><!-- Video --> <a ng-if=\"content.type == \'Video\' && content.isCompleted\" href=\"\" role=button ng-click=\"fbVideoFx(cDetailBucket + content.url, content.label);\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> </a><!-- Template --> <a ng-if=\"content.type == \'template\'\" ng-href=\"{{tDetailBucket + content.thumb | secureThumb}}\" role=link fancyboxable=fbTitleInside data-fancybox-title={{content.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbBigParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\"> </a><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <span class=thumb-icon><span ng-if=content.ss class=webpage></span> <span ng-if=\"content.wp == 1\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=\"text-ellipsis marT5\">{{content.label}}</div></li></ul><ul class=\"table table-md ui-selectable list-unstyled cl-list\" sortable callback=sortCallback() ng-if=\"auth.upreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-6>{{\'cm.brief.1\' | translate}}</div><div class=col-xs-4>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'d.tab.6\' | translate}}</div></div><li ng-repeat=\"cl in selectedFilteredContent = (selectedContent.content) | customSearch:{key:selectedSearchText, module:\'cl\'}\" data-id={{cl.id}} class=\"row sortable-item\" ng-class=\"{\'codHidden\':cl.hidden}\" ng-hide=cl.hidden><div class=\"col-xs-6 text-ellipsis clViwe\"><span class=cl-cIcon><!-- Images --> <a ng-href=\"{{cDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}} ng-if=\"(cl.type == \'Image\' && cl.extn != \'WEBP\') && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\"> </a><!-- Video --> <a href=\"\" ng-click=\"fbVideoFx(cDetailBucket + cl.url, cl.label);\" ng-if=\"cl.type == \'Video\' && cl.isCompleted\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\"> </a><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"cl.type == \'POWERPOINT\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"cl.type == \'WORD\' && cl.isCompleted\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"cl.type == \'Vector\' && cl.isCompleted\"><!-- Vimeo --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'Vimeo\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon vimeoIcon\"></span> </a><!-- YouTube --> <a ng-if=\"cl.type == \'Widget\' && cl.extn == \'YouTube\'\" ng-href={{cl.url}} fancyboxable=fbMedia data-fancybox-title={{cl.label}}><span class=\"icon youTube\"></span> </a><!-- Audio --> <a ng-if=\"cl.type == \'Audio\' && cl.isCompleted\" href=\"\" ng-click=\"fbAudioFx(cDetailBucket + cl.url, cl.label);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\"> </a><!-- Flash --> <a ng-if=\"cl.type == \'Flash\' && cl.isCompleted\" href=\"\" ng-click=\"fbFlashFx(cDetailBucket + cl.url, cl.label, cl.dimension);\"><img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\"> </a><!-- Widget --> <span class=\"icon {{cl.thumb}}\" ng-if=\"(cl.type == \'Widget\' && cl.isCompleted) && (cl.extn != \'YouTube\' && cl.extn != \'Vimeo\')\"></span><!-- Template --> <a ng-if=\"cl.type == \'template\'\" ng-href=\"{{tDetailBucket + cl.thumb | secureThumb}}\" fancyboxable=fbTitleInside data-fancybox-title={{cl.label}}><img alt=\"\" ng-src=\"{{tim + tBucket + cl.thumb + thumbBigParam + \'&\' + cl.thumbV}}\" class=\"img-responsive center-block\"> </a><img alt=\"\" ng-if=\"cl.type != \'Image\' && cl.type != \'Widget\' && cl.type != \'Video\' && cl.type != \'Audio\' && cl.type != \'Flash\' && cl.type != \'template\' && cl.type != \'POWERPOINT\' && cl.type != \'WORD\' && cl.type != \'Vector\' && cl.isCompleted\" ng-src=\"{{tim + cBucket + cl.thumb + thumbBigParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"cl.type != \'Widget\' && !cl.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"><!-- Other --> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"cl.type == \'SharePointC\'\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"cl.type == \'OneDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"cl.type == \'GoogleDriveC\' && (cl.extn != \'WEBP\' && cl.isCompleted)\"> <img alt={{cl.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"cl.extn == \'WEBP\' && cl.isCompleted\"><!-- <img alt=\"{{cl.type}}\" ng-src=\"assets/images/default/photo-xs.png\" ng-if=\"!cl.isCompleted && cl.type != \'Flash\'\"> --> <span class=\"thumb-icon cl\"><span ng-if=cl.expiring class=expiring></span> <span ng-if=cl.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=cl.sp class=sharepoint></span> <span ng-if=cl.od class=oneDrive></span> <span ng-if=cl.sf class=sharedFolder></span> </span></span><span uib-tooltip={{cl.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{cl.label}}</span></div><div class=col-xs-4>{{cl.type}} <span ng-if=\"cl.type==\'Widget\'\">[&nbsp;{{(cl.extn == \'Button\' ? cl.extn +\' - \' + cl.btnExtn : cl.extn)}}&nbsp;]</span></div><div class=\"col-xs-2 text-right\"><a href=\"\" class=text-danger ng-click=\"removeContentFx(cl.id, \'t\', $index);\" uib-tooltip=\"{{\'cm.btn.20\' | translate}}\" tooltip-append-to-body=true><span class=\"fa fa-remove\"></span></a></div></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedContent.content.length == 0\">{{\'cm.msg.4\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"selectedContent.content.length > 0 && (selectedContent.content | customSearch:{key:selectedSearchText, module:\'cl\'}).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(selectedSearchText)}}&quot;</b>\'}\"></div></div></section></div></div></div></div><footer class=panel-footer ng-if=!openingLoading><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=\"useContentFx(\'t\');\">{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/iotDevices.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.meeting.12\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=devicesLoading><div class=row ng-if=!devicesLoading><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': (mADeviceSort.type === \'label\' || mADeviceSort.type === \'room\') && mADeviceSort.val === \'asc\' && mADeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'a\', (curDeviceObj.caller ==\'coe\'?\'label\':\'room\'), \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': (mADeviceSort.type === \'label\' || mADeviceSort.type === \'room\') && mADeviceSort.val === \'desc\' && mADeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'a\', (curDeviceObj.caller ==\'coe\'?\'label\':\'room\'), \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': mADeviceSort.type === \'createdOn\' && mADeviceSort.val === \'asc\' && mADeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'a\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': mADeviceSort.type === \'createdOn\' && mADeviceSort.val === \'desc\' && mADeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'a\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu1 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'a\', curDeviceObj.availableDevices | customSearch:{key:avlDList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'a\', curDeviceObj.availableDevices);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curDeviceObj.availableDevices.length > 1?\'cm.body.6s\':\'cm.body.6\' | translate | capitalize}} <span class=\"text-sm text-muted\">[ {{curDeviceObj.availableDevices.length}} ]</span></label>{{curADEM = (curDeviceObj.availableDevices | customSearch:{key:avlDList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=avlDList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=avlDList.length ng-click=\"avlDList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curDeviceObj.availableDevices.length && !curADEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(avlDList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curDeviceObj.availableDevices | customSearch:{key:avlDList, module:\'cdtg\'} | orderBy:mADeviceSort.type:mADeviceSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selDeviceFx(\'a\', option, curDeviceObj.availableDevices)\"><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.label}}</div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuadDTG\"><button type=button role=button class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curDeviceObj.availableDevices.length}\" ng-click=\"manipulateFx(\'add\', curDeviceObj.availableDevices, curDeviceObj.devices, curDevices.availableDevices, \'d\');\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curDeviceObj.devices.length}\" ng-click=\"manipulateFx(\'remove\', curDeviceObj.availableDevices, curDeviceObj.devices, curDevices.assignedDevices,\'d\');asDList=\'\';\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=form-group><div class=\"pull-right device-sort\" uib-dropdown><a href=\"\" role=link id=sorting1 uib-dropdown-toggle uib-tooltip=\"{{\'cm.tool.1\' | translate}}\"><span class=\"glyphicon glyphicon-sort\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=dropdown-header>{{\'cm.tool.1.1\' | translate}}</li><li ng-class=\"{\'selected\': (mSDeviceSort.type === \'label\' || mSDeviceSort.type === \'room\') && mSDeviceSort.val === \'asc\' && mSDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'s\', (curDeviceObj.caller ==\'coe\'?\'label\':\'room\'), \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': (mSDeviceSort.type === \'label\' || mSDeviceSort.type === \'room\') && mSDeviceSort.val === \'desc\' && mSDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'s\', (curDeviceObj.caller ==\'coe\'?\'label\':\'room\'), \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li><li class=divider role=separator></li><li class=dropdown-header>{{\'cm.tool.1.3\' | translate}}</li><li ng-class=\"{\'selected\': mSDeviceSort.type === \'createdOn\' && mSDeviceSort.val === \'asc\' && mSDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'s\', \'createdOn\', \'asc\', false);\">{{\'cm.tool.1.4\' | translate}}</a></li><li ng-class=\"{\'selected\': mSDeviceSort.type === \'createdOn\' && mSDeviceSort.val === \'desc\' && mSDeviceSort.lType === \'device\'}\"><a href=\"\" role=link ng-click=\"mDeviceSortFx(\'s\', \'createdOn\', \'desc\', true);\">{{\'cm.tool.1.5\' | translate}}</a></li></ul><div class=\"pull-right dropdown\" uib-dropdown><a href=\"\" role=link id=vMenu2 class=\"padLR5 marL5 marT-6\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"selAllDeviceFx(\'s\', curDeviceObj.devices | customSearch:{key:asDList, module:\'cdtg\'});\">{{\'cm.btn.44\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"deSelAllDeviceFx(\'s\', curDeviceObj.devices);\">{{\'cm.tool.7\' | translate}}</a></li></ul></div></div><label>{{curDeviceObj.devices.length > 1?\'em.label.7s\':\'em.label.7\' | translate}} <span class=\"text-sm text-muted\">[ {{curDeviceObj.devices.length}} ]</span></label>{{curASDEM = (curDeviceObj.devices | customSearch:{key:asDList, module:\'cdtg\'});\"\"}}<div class=bdrGray device-scroll-quad offset=20><div class=\"bg-light pad10\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-disabled=!curDeviceObj.devices.length ng-model=asDList sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" maxlength={{inputLimit}} autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=asDList.length ng-click=\"asDList=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a><div class=\"msg-warning absolute\" lang={{auth.lang}} style=margin:1px ng-if=\"curDeviceObj.devices.length && !curASDEM.length\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(asDList)}}&quot;</b>\'}\"></div></div></div><div class=\"panel-body table no-th pad5\"><div class=\"dScrollQuad padTB2\"><div class=\"row padTB3\" ng-class=\"{\'selectedD\':option.selected}\" ng-repeat=\"option in curDeviceObj.devices | customSearch:{key:asDList, module:\'cdtg\'} | orderBy:mSDeviceSort.type:mSDeviceSort.reverse track by option.id\"><div class=col-xs-12><div class=\"padTB2 cursorDefault\" ng-click=\"selDeviceFx(\'s\', option, curDeviceObj.devices)\"><span class=\"marR5 deviceStatus {{option.status}}\" uib-tooltip=\"{{option.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></span>{{option.label}}</div></div></div></div></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveDevicesFx(\'s\');\" ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveProcessing?\'cm.btn.7i\':\'cm.btn.7\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(\'c\'); resetD();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=popupErr aria-live=polite role=status>{{\'cl.widget.meeting.m5\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/mcDoNotPlaylist.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.mc.12\' | translate | camelCase}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=scrollQuad style=max-height:{{getAvailableHeight(335)}}px ng-if=!openPopupLoading><div ng-if=mcWidgets.length><label>{{\'cl.widget.mc.13\' | translate}}</label><div class=\"bg-light pad5\"><ul class=\"list-unstyled noMarB\"><li class=\"branch text-ellipsis-wrap\" ng-repeat=\"mcList in mcWidgets\"><label uib-tooltip=\"{{\'cl.widget.mc.14\' | translate}}\" tooltip-enable=!mcList.isDontPlaySong ng-class=\"{\'disabled\':!mcList.isDontPlaySong}\"><input type=checkbox ng-model=isChecked[mcList.id] ng-change=checkedFx(mcList.id); ng-disabled=!mcList.isDontPlaySong role=checkbox><label></label>{{mcList.label}}</label></li></ul></div></div><div class=msg-warning lang={{auth.lang}} ng-if=!mcWidgets.length>{{\'cl.widget.mc.m11\' | translate}}</div></div></div><div class=panel-footer ng-if=!openPopupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-if=mcWidgets.length ng-click=doNotPlaylistFx(); ng-disabled=saveDoNotPlayProcessing><span class=fa ng-class=\"saveDoNotPlayProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{saveDoNotPlayProcessing?\'cl.widget.cm.24i\':\'cl.widget.cm.24\' | translate}}</button> <button type=button role=button class=btn ng-class=\"mcWidgets.length?\'btn-link\':\'btn-default\'\" ng-click=closeThisDialog(); data-dismiss=modal>{{mcWidgets.length?\'cm.btn.9\':\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><div ng-if=\"errType==\'empty\'\" aria-live=polite role=status>{{\'cm.msg.38\' | translate}}</div></div><div class=clearfix></div></div></section>");
$templateCache.put("app/contentLibrary/widgets/popup/meetingPreview.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.7\' | translate}} / {{\'cs.btn.5\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=row ng-if=!openPopupLoading><div class=col-xs-12><div class=msg-warning lang={{auth.lang}} ng-if=!preview.calendar.length>{{\'cl.widget.meeting.m2\' | translate}}</div></div><div class=\"col-xs-12 scrollQuad\" style=max-height:{{getAvailableHeight(300)}}px><div ng-if=\"preview.type == \'d\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{previewItem.label}}</div><div ng-repeat=\"meeting in previewItem.meetings\" class=\"bdr-btm-dashed padTB10 noMarB\"><table class=table><tr><td style=\"background:#f8f8f8;-webkit-print-color-adjust:exact;padding-left:10px;border:1px solid #f8f8f8;border-left:4px solid #d9edf7\"><div style=font-size:18px;margin-bottom:10px>{{meeting.label}}</div><div class=text-muted>{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div></td><td class=text-center style=\"font-size:18px;width:150px;background:#d9edf7;-webkit-print-color-adjust:exact;border:1px solid #d9edf7;vertical-align:middle\"><div>{{meeting.st}}</div><div style=height:10px;line-height:7px>-</div><div>{{meeting.et}}</div></td></tr></table></div></div><div ng-if=\"preview.type == \'w\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{previewItem.label}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in preview.weekdays\" class=\"text-center bg-info\" style=\"background:#d9edf7;-webkit-print-color-adjust:exact;border:1px solid #b1ccda;color:#456f84;width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr><td ng-repeat=\"days in previewItem.meetings\" style=\"width:{{100 / preview.weekdays.length}}%\"><div ng-repeat=\"meeting in days.meeting\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=\"text-bold marB5\">{{meeting.label}}</div><div class=\"text-muted text-sm marB5\">{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div><div class=text-sm>{{meeting.st}} - {{meeting.et}}</div></div></td></tr></table></div><div ng-if=\"preview.type == \'m\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{\'s.p_s.label.11.\' + previewItem.label.split(\"|\")[0] | translate}} {{previewItem.label.split(\"|\")[1]}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in weekdays\" class=text-center style=\"background:#d9edf7;-webkit-print-color-adjust:exact;border:1px solid #b1ccda;color:#456f84;width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr ng-repeat=\"week in curCalendar\"><td ng-repeat=\"date in week.days\" style=\"width:{{100 / weekdays.length}}%\" ng-class=\"{\'text-muted\':date.month() != curMonth}\" ng-style=\"date.month() != curMonth && {\'background\':\'#f8f8f8\',\'-webkit-print-color-adjust\':\'exact\'}\"><div class=marB5>{{date.date()}}</div><div ng-if=\"date.month() == curMonth\" ng-repeat=\"meeting in preview.calendar[currentPage].meetings[date.date()-1].meeting\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=text-bold>{{meeting.label}}</div><div class=\"text-muted text-sm marB5\">{{meeting.room}}<span ng-if=\"meeting.floor != \'\'\"><span class=\"marL5 marR5\">|</span>{{meeting.floor}}</span></div><div class=text-sm>{{meeting.st}} - {{meeting.et}}</div></div></td></tr></table></div></div></div></div><footer class=panel-footer ng-show=!openPopupLoading><div class=pull-right ng-show=\"preview.type != \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\"><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=\"currentPage=currentPage+1\"><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><div class=pull-right ng-show=\"preview.type == \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=showCalendarFx(-1)><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=showCalendarFx(+1)><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasSelectErr aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=maxCountPop aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/musicChoice.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.mc.9\' | translate | camelCase}}</h1><span class=\"marL5 text-sm\">[ {{curCategorySongs.categoryName}} ]</span></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=row ng-if=!openPopupLoading><div class=\"col-xs-12 col-md-5\"><div class=row><div class=\"col-xs-8 text-bold\"><label class=noMarB ng-class=\"{\'disabled\':curCategorySongs.availableSongs.length <= 0}\"><input type=checkbox ng-model=chkList.aSongs ng-change=\"checkAllFx(\'aSongs\', chkList.aSongs);\" ng-disabled=\"curCategorySongs.availableSongs.length <= 0\" role=checkbox><label class=noMarB></label></label>{{\'cl.widget.mc.8.1\' | translate}} <span class=\"text-sm text-muted\">[ {{curCategorySongs.availableSongs.length}} ]</span></div><div class=\"col-xs-4 text-right musicCBox\"><div class=searchTbx><input type=text class=form-control ng-model=search.asTbx sanitize-input maxlength=250 ng-disabled=\"curCategorySongs.availableSongs.length <= 0\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.asTbx ng-click=\"search.asTbx=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"bg-light overflow-y bdr musicCBox playList\" style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.91)}}px\"><ul class=\"list-unstyled list-striped\" ng-if=\"curCategorySongs.availableSongs.length > 0\"><li ng-repeat=\"as in curCategorySongs.availableSongs | orderBy:\'SongName\' | filter:search.asTbx\" ng-class=\"{\'disabledRow\': as.isDontPlay}\" uib-tooltip=\"{{\'cl.widget.mc.t2\' | translate}}\" tooltip-enable=as.isDontPlay><label class=noMarB><input type=checkbox ng-model=as.isSelected ng-disabled=as.isDontPlay ng-click=\"checkboxFx(\'as\');\" role=checkbox><label></label>{{as.SongName | capitalize}}</label><div class=\"text-sm text-muted\">{{as.AlbumName | capitalize}} | {{as.ArtistName | capitalize}} | {{as.DurationSeconds | durations}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(curCategorySongs.availableSongs | filter:search.asTbx).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.asTbx)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"curCategorySongs.availableSongs.length == 0\">{{\'cl.widget.mc.m3\' | translate}}</div></div></div><div class=\"col-xs-12 col-md-2 addRemoveBtnQuad\" style=\"margin-top:{{getAvailableHeight(360) * (tabView?0.92:0.91) / 2 - 100}}px\"><button type=button role=button ng-click=\"checkboxListManipulateFx(\'add\', curCategorySongs.availableSongs, curCategorySongs.selectedSongs); aSongs=false\" class=\"btn btn-success btn-sm btn-block\" ng-class=\"{\'disabled\': !curCategorySongs.availableSongs.length}\">{{\'cm.btn.19\' | translate}}<span class=\"fa fa-chevron-right\" aria-hidden=true></span></button> <button type=button role=button ng-click=\"checkboxListManipulateFx(\'remove\', curCategorySongs.availableSongs, curCategorySongs.selectedSongs); sSongs=false\" class=\"btn btn-danger btn-sm btn-block\" ng-class=\"{\'disabled\': !curCategorySongs.selectedSongs.length}\"><span class=\"fa fa-chevron-left\" aria-hidden=true></span>{{\'cm.btn.20\' | translate}}</button></div><div class=\"col-xs-12 col-md-5\"><div class=row><div class=\"col-xs-8 text-bold\"><label class=noMarB ng-class=\"{\'disabled\':curCategorySongs.selectedSongs.length <= 0}\"><input type=checkbox ng-model=chkList.sSongs ng-change=\"checkAllFx(\'sSongs\', chkList.sSongs);\" ng-disabled=\"curCategorySongs.selectedSongs.length <= 0\" role=checkbox><label class=noMarB></label></label>{{\'cl.widget.mc.8.2\' | translate}} <span class=\"text-sm text-muted\">[ {{curCategorySongs.selectedSongs.length}} ]</span></div><div class=\"col-xs-4 text-right musicCBox\"><div class=searchTbx><input type=text class=form-control ng-model=search.ssTbx sanitize-input maxlength=250 ng-disabled=\"curCategorySongs.selectedSongs.length <= 0\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.ssTbx ng-click=\"search.ssTbx=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div></div><div class=\"overflow-y bg-light bdr musicCBox playList\" style=\"height:{{getAvailableHeight(360) * (tabView?0.92:0.91)}}px\"><ul class=\"list-unstyled list-striped\" ng-if=\"curCategorySongs.selectedSongs.length > 0\"><li ng-repeat=\"ss in curCategorySongs.selectedSongs | orderBy:\'SongName\' | filter:search.ssTbx\"><label class=noMarB><input type=checkbox ng-model=ss.isSelected ng-click=\"checkboxFx(\'ss\');\" role=checkbox><label></label>{{ss.SongName | capitalize}}<div class=\"text-sm text-muted\">{{ss.AlbumName | capitalize}} | {{ss.ArtistName | capitalize}} | {{ss.DurationSeconds | durations}}</div></label></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(curCategorySongs.selectedSongs  | filter:search.ssTbx).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.ssTbx)}}&quot;</b>\'}\"></div></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"curCategorySongs.selectedSongs.length == 0\">{{\'cl.widget.mc.m2\' | translate}}</div></div></div></div></div><footer class=panel-footer ng-if=!openPopupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=selectedSongsFx(); ng-disabled=songsProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=songsProcessing aria-hidden=true></span>{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasSelectErr aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=maxCountPop aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/roomList.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cl.widget.meeting.7\' | translate}}</h1></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><img alt=Loading src=assets/images/loading.gif ng-if=detailPopupLoading><div class=row ng-if=!detailPopupLoading><div class=col-xs-4><div><label ng-class=\"{\'noMarB\': (allScrollDataList.ev.length <= 5)}\">{{\'d.tab.1\' | translate}}</label></div><div class=\"noPad noMar\" ng-if=\"allScrollDataList.ev.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.d sanitize-input ng-change=\"searchChangeDataDyn(searchList.d, \'ev\');\" placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.d.length ng-click=\"searchList.d=\'\';searchChangeDataDyn(searchList.d, \'ev\');\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=separator role=separator></div><div class=\"list-scroll ng-cloak\" id=scroll-container-ev dynamic-scroll-list st=stIndex.ev et=etIndex.ev list-data=scrollDataList.ev search-data=searchList.d have-more-data=haveMoreData.ev search-scroll=searchScroll.ev clone-data=allScrollDataList.ev have-more-search-data=haveMoreSearchData.ev quad-id=\"\'ev\'\" dd-open=ev.isOpen><div class=table><ul><li class=\"row padTB3 rowObj-ev\" id={{device.id}} ng-repeat=\"device in filteredDList = (visibleData.ev)\" tabindex=$index ng-if=!loading.ev><!-- <li class=\"row padTB3 rowObj-ev\" id=\"{{device.id}}\" ng-repeat=\"device in filteredDList = (visibleData.ev)\" tabindex=\"$index\" ng-if=\"!loading.ev\" ng-class=\"{\'cursorDisabled\': roomViewObj.caller && roomViewObj.caller == \'v\'}\"> --><!-- <li class=\"row padTB3\" ng-repeat=\"device in filteredDList = (dgList.d | customSearch:{key:searchList.d, module:\'cdtg\'}) | orderBy:\'room\'\" tabindex=\"$index\"> --><label class=\"fw-normal word-break wordBreakAll\" ng-class=\"{\'cursorDisabled\': roomViewObj.caller && roomViewObj.caller == \'v\'}\" ng-if=\"roomViewObj.caller != \'v\'\"><input type=checkbox role=checkbox ng-model=device.selected ng-disabled=\"roomViewObj.caller && roomViewObj.caller == \'v\' ? true: false\" ng-change=\"selectRoomItem(\'d\', device.selected, device.id)\"><label></label><div class=\"marR5 deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{device.l}}</label><label class=\"fw-normal word-break wordBreakAll\" for=dName ng-if=\"roomViewObj.caller == \'v\'\"><label></label><div class=\"marR5 deviceStatus {{device.status}}\" uib-tooltip=\"{{device.status | capitalize}}\" tooltip-append-to-body=true tooltip-popup-delay=500></div>{{device.l}}</label></li><!-- Conditionally add \"End of Records\" after the last item --><div ng-if=\"(!haveMoreData.ev || !haveMoreSearchData.ev) && scrollDataList.ev.length >= 300 && scrollDataList.ev.length == etIndex.ev && !loadingMore.ev\" class=end-of-data-tag>{{\'cm.msg.54\' | translate}}</div><img alt=Loading src=assets/images/loading-xs.gif ng-if=\"(!haveMoreData.ev || !haveMoreSearchData.ev) && scrollDataList.ev.length >= 300 && scrollDataList.ev.length == etIndex.ev && loadingMore.ev\"> <img alt=Loading src=assets/images/loading-xs.gif ng-if=loading.ev></ul><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=!allScrollDataList.ev.length>{{roomViewObj.caller == \'v\'? \'cl.widget.meeting.m14\' :\'cl.widget.meeting.m9\' | translate}}</div><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=\"allScrollDataList.ev.length && filteredDList.length == 0 && !loading.ev\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.d)}}&quot;</b>\'}\"></div></div></div></div><div class=col-xs-4><div><label ng-class=\"{\'noMarB\': (dgList.g.length <= 5)}\">{{\'d.tab.2\' | translate}}</label></div><div class=\"noPad noMar\" ng-if=\"dgList.g.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.g sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.g.length ng-click=\"searchList.g=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=separator role=separator></div><div class=\"list-scroll ng-cloak\"><div class=table><ul><li class=\"row padTB3\" ng-repeat=\"group in filteredGList = (dgList.g | customSearch:{key:searchList.g, module:\'cdtg\'}) | orderBy: \'label\'\" tabindex=$index><!-- <li class=\"row padTB3\" ng-repeat=\"group in filteredGList = (dgList.g | customSearch:{key:searchList.g, module:\'cdtg\'}) | orderBy: \'label\'\" tabindex=\"$index\" ng-class=\"{\'cursorDisabled\': roomViewObj.caller && roomViewObj.caller == \'v\'}\"> --><label class=\"fw-normal word-break wordBreakAll\" ng-class=\"{\'cursorDisabled\': roomViewObj.caller && roomViewObj.caller == \'v\'}\" ng-if=\"roomViewObj.caller != \'v\'\"><input type=checkbox role=checkbox ng-model=group.selected ng-disabled=\"roomViewObj.caller && roomViewObj.caller == \'v\' ? true: false\" ng-change=\"selectRoomItem(\'dg\', group.selected, group.id)\"><label></label>{{group.label}}</label><label class=\"fw-normal word-break wordBreakAll padL5\" for=gName ng-if=\"roomViewObj.caller == \'v\'\"><label></label>{{group.label}}</label></li></ul><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=!dgList.g.length>{{roomViewObj.caller == \'v\'? \'cl.widget.meeting.m15\' :\'cl.widget.meeting.m10\' | translate}}</div><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=\"dgList.g.length && filteredGList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.g)}}&quot;</b>\'}\"></div></div></div></div><div class=col-xs-4><div><label ng-class=\"{\'noMarB\': dgList.r.length <= 5}\">{{\'cl.widget.meeting.19\' | translate}}</label></div><div class=\"noPad noMar\" ng-if=\"dgList.r.length > 5\"><div class=\"searchTbx input-xs\"><input type=text class=form-control ng-model=searchList.r sanitize-input placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchList.r.length ng-click=\"searchList.r=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></div><div class=separator role=separator></div><div class=\"list-scroll ng-cloak\"><div class=table><ul><li class=\"row padTB3\" ng-repeat=\"room in filteredRList = (dgList.r | customSearch:{key:searchList.r, module:\'cdtg\'}) | orderBy: \'label\'\" tabindex=$index><label class=\"fw-normal word-break wordBreakAll\" ng-class=\"{\'cursorDisabled\': roomViewObj.caller && roomViewObj.caller == \'v\'}\" ng-if=\"roomViewObj.caller != \'v\'\"><input type=checkbox role=checkbox ng-model=room.selected ng-disabled=\"roomViewObj.caller && roomViewObj.caller == \'v\' ? true: false\" ng-change=\"selectRoomItem(\'r\', room.selected, room.id)\"><label></label>{{room.room}}<span class=\"text-muted text-sm inline\" ng-if=room.floor> | Floor: {{room.floor}}</span></label><label class=\"fw-normal word-break wordBreakAll padL5\" for=rName ng-if=\"roomViewObj.caller == \'v\'\"><label></label>{{room.room}}<span class=\"text-muted text-sm inline\" ng-if=room.floor> | Floor: {{room.floor}}</span></label></li></ul><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=!dgList.r.length>{{roomViewObj.caller == \'v\'? \'cl.widget.meeting.m16\' :\'cl.widget.meeting.m11\' | translate}}</div><div class=\"msg-warning text-sm pad5\" lang={{auth.lang}} ng-if=\"dgList.r.length && filteredRList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchList.r)}}&quot;</b>\'}\"></div></div></div></div></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-if=\"roomViewObj.caller == \'v\'\" ng-click=\"closeThisDialog(\'c\');\" data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button> <button type=button role=button class=\"btn btn-primary\" ng-if=\"roomViewObj.caller != \'v\'\" ng-click=\"selectRoomListFx(\'s\')\">{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-if=\"roomViewObj.caller != \'v\'\" ng-click=\"closeThisDialog(\'c\');\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/scPreview.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'d.btn.7\' | translate}} / {{\'cs.btn.5\' | translate}}</h1></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=openPopupLoading><div class=row ng-if=!openPopupLoading><div class=\"col-xs-12 scrollQuad\" style=max-height:{{getAvailableHeight(300)}}px><div ng-if=\"preview.type == \'d\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{previewItem.label}}</div><div ng-repeat=\"schedule in previewItem.schedules\" class=\"bdr-btm-dashed pad10\"><div class=\"text-lg marB5\">{{schedule.label}}</div><div ng-repeat=\"time in schedule.time\">{{time.st}} - {{time.et}}</div></div></div><div ng-if=\"preview.type == \'w\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{previewItem.label}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in preview.weekdays\" class=text-center style=\"width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr><td ng-repeat=\"days in previewItem.days\" style=\"width:{{100 / preview.weekdays.length}}%\"><div ng-repeat=\"schedule in days.schedules\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=text-bold>{{schedule.label}}</div><div class=text-sm ng-repeat=\"time in schedule.time\">{{time.st}} - {{time.et}}</div></div></td></tr></table></div><div ng-if=\"preview.type == \'m\'\" ng-repeat=\"previewItem in preview.calendar | startFrom:currentPage | limitTo:1\" class=marB25 id=cal{{$index}}><div class=\"text-center nav-bar text-big pad10 bg-light\"><a class=pull-right href=\"\" role=button ng-click=\"printDiv(\'cal\' + $index, previewItem.label);\"><span class=\"fa fa-print text-black\" aria-hidden=true></span></a>{{\'s.p_s.label.11.\' + previewItem.label.split(\"|\")[0] | translate}} {{previewItem.label.split(\"|\")[1]}}</div><table class=\"table table-bordered\"><tr><th ng-repeat=\"day in weekdays\" class=text-center style=\"width:{{100 / preview.weekdays.length}}%\">{{\'s.p_s.label.4.2.\' + day | translate}}</th></tr><tr ng-repeat=\"week in curCalendar\"><td ng-repeat=\"date in week.days\" style=\"width:{{100 / weekdays.length}}%\" ng-class=\"{\'text-muted\':date.month() != curMonth}\"><div class=marB5>{{date.date()}}</div><div ng-if=\"date.month() == curMonth\" ng-repeat=\"schedule in preview.calendar[currentPage].days[date.date()-1].schedules\" ng-class=\"{\'bdr-btm-dashed\':!$last}\"><div class=text-bold>{{schedule.label}}</div><div class=text-sm ng-repeat=\"time in schedule.time\">{{time.st}} - {{time.et}}</div></div></td></tr></table></div></div></div></div><footer class=panel-footer ng-show=!openPopupLoading><div class=pull-right ng-show=\"preview.type != \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=\"currentPage=currentPage-1\"><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=\"currentPage=currentPage+1\"><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><div class=pull-right ng-show=\"preview.type == \'m\'\"><button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage == 0\" ng-click=showCalendarFx(-1)><span class=\"fa fa-chevron-left noMarR\" aria-hidden=true></span></button> <span class=\"marL5 marR5\">{{currentPage+1}}/{{preview.calendar.length}}</span> <button type=button role=button class=\"btn btn-default\" ng-disabled=\"currentPage >= preview.calendar.length - 1\" ng-click=showCalendarFx(+1)><span class=\"fa fa-chevron-right noMarL\" aria-hidden=true></span></button></div><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasSelectErr aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=maxCountPop aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/selectContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.label.32\' | translate | camelCase}}</h1>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx input-group bdrR\" style=width:200px><input type=text class=form-control ng-model=searchText sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchText.length ng-click=\"searchText=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" ng-click=\"advancedSearchOpen(\'cl\', \'tcl\');\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{auth.upreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=panel-body><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><div class=breadcrumb ng-if=\"breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=contentLoading><ul class=\"list-inline thumb-list overflow-auto\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'t\'\" element-height=getAvailableHeight(340) style=max-height:{{getAvailableHeight(340)}}px><ng-content-list class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list></ul><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!contentLoading && auth.upreferences.contentView == \'l\'\" element-height=getAvailableHeight(340) style=max-height:{{getAvailableHeight(340)}}px><ng-content-list-view class=show ng-if=\"folderList.length > 0 || contentList.length > 0\" selectable=selection selectable-options=\"{filter:\'li\', cancel:\'input,button,a,.nonSelectable\'}\" selectable-list=\"contentList | filter:searchText\"></ng-content-list-view></ul><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentList.length == 0 && folderList.length == 0 && !advSearch\">{{\'cm.msg.7\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/selectSingleContent.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(); search.text=\'\'\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=\"loading || contentLoading\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div>{{viewType = (uPreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx bdrR\" ng-class=\"{\'input-group\':contentObj.type != \'dmb\'}\" style=width:200px><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"search.text= \'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"contentObj.type != \'dmb\'\"><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'w-sc\', \'w-alert\' , default);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=\"panel-body scrollQuad\" style=max-height:{{getAvailableHeight(304)}}px><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchInfo class=tASearch></advanced-search><div class=breadcrumb ng-class=\"{\'marB5\':contentLibrary.info.wp || contentLibrary.info.sp}\" ng-if=\"breadCrumbs.length > 0 && !openingLoading  && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"!contentLoading  && !advSearch\"><div ng-if=\"contentLibrary.info.wp && !openingLoading\" class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=\"contentLibrary.info.sp && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=\"contentLibrary.info.od && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=\"contentLibrary.info.gd && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><img alt=\"\" src=assets/images/loading.gif ng-if=contentLoading><!-- {{orderType = ((contentLibrary.info.sortType == \'label\') ? \'label\' : (contentLibrary.info.sortType == \'approvedon\') ? \'approvedOn\' : (contentLibrary.info.sortType == \'createdon\') ? \'createdOn\' : (contentLibrary.info.sortType == \'editedon\') ? \'editedOn\' : (contentLibrary.info.sortType == \'createdby\') ? \'cBy\' : (contentLibrary.info.sortType == \'type\') ? \'type\' : \'\');\'\'}} --><!-- {{orderVal = (contentLibrary.info.sortVal == \'desc\' ? \'-\'+orderType : orderType); \'\'}} --><ul class=\"list-inline thumb-list cl-list\" ng-if=\"!contentLoading && uPreferences.contentView == \'t\'\"><li ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder.id, folder.type, folder.splId);\"><div><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'Googledrive\'\" class=googleDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type != \'Shortcut\' && folder.type != \'Sharepoint\' && folder.type != \'Onedrive\' && folder.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.label}}</div></div></li><li ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:search.text, module:\'cl\', filterType:filter}) | orderBy:orderVal\" ng-click=\"selectFx($event, \'content\', content.id, content.type, null, content);\" ng-if=content.isCompleted><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':content.isblur}\" ng-if=!showAllTypeContent><img alt={{content.type}} ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam + curToken}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || content.type == \'Video\' || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam + curToken}}\" src-error=\"{{cDetailBucket +\'widgets/thumbs/\'+ thumbSize +\'/na_thumb.png\'}}\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v7\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt=Processing ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize}}/processing_thumb.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"> <img alt={{content.type}} ng-src=\"{{content.thumb | trustUrl}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" class=img-responsive ng-class=\"{\'blurry-img\':content.isblur}\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss && content.isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"><!-- <a ng-href=\"{{cDetailBucket + content.ssImg | secureThumb:timestamp}}\" fancyboxable=\"fbTitleInside\" data-fancybox-title=\"{{content.label}}\" ng-if=\"content.type == \'Widget\' && content.extn == \'Web Page\' && content.ss && content.isCompleted\"> --> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.ssImg +\'&v=\'+ timestamp + thumbParam}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss && content.isCompleted\" ng-class=\"{\'blurry-img\':content.isblur}\"><!-- </a> --> <img alt=sp ng-src=assets/images/default/thumbs/n/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=od ng-src=assets/images/default/thumbs/n/od.png ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=od ng-src=assets/images/default/thumbs/n/gd.png ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=\"content.type == \'Video\' || content.type == \'Audio\' || (content.type == \'Widget\' && content.extn  == \'YouTube\' || content.extn  == \'Vimeo\')\" class=vDuration>{{content.duration | durations}}</span> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.gd class=googleDrive></span> <span ng-if=content.sf class=sharedFolder></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type != \'folder\' && content.type != \'Sharepoint\' && content.type != \'Onedrive\' && content.type != \'SharedFolder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span> </span><!-- <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type != \'SharePointC\' && content.type != \'Audio\'\">\r\n            <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type != \'SharePointC\' && content.type == \'Flash\'\" class=\"img-responsive\">\r\n            <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Audio\'\" class=\"img-responsive\">\r\n            <img alt=\"\" src=\"assets/images/default/sp.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=\"img-responsive\">\r\n            <img alt=\"\" src=\"assets/images/default/od.png\" ng-if=\"content.type == \'OneDriveC\'\" class=\"img-responsive\">\r\n            <span class=\"thumb-icon cl\">\r\n              <span ng-if=\"content.type == \'Audio\'\" class=\"vDuration\">{{content.duration | durations}}</span>\r\n              <span ng-if=\"content.expiring\" class=\"expiring\"></span>\r\n              <span ng-if=\"content.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span>\r\n              <span ng-if=\"content.type != \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span>\r\n            </span> --> </span><!-- F45 --> <span class=thumb-inner ng-if=showAllTypeContent uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"><!-- Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type != \'SharePointC\' && content.type == \'Flash\'\"><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss && content.isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.ssImg +\'&v=\'+ timestamp + thumbParam}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss && content.isCompleted\"><!-- Images --> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam | secureThumb}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'Image\'\"><!-- YouTube & Vimeo --> <img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><!-- Video --> <img alt=\"\" ng-src=\"{{thumbHost + tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'Video\' && content.isCompleted\"><!-- Template --> <img alt=\"\" ng-src=\"{{thumbHost + tim + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'template\'\"><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" src=assets/images/default/thumbs/lg/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/lg/od.png ng-if=\"content.type == \'OneDriveC\'\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/lg/gd.png ng-if=\"content.type == \'GoogleDriveC\'\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.ss class=webpage></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label>{{content.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderList.length + contentList.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && search.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentList.length == 0 && folderList.length == 0 && !advSearch\">{{\'cl.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></ul><ul class=\"table table-md ui-selectable list-unstyled cl-list\" ng-if=\"!contentLoading && uPreferences.contentView == \'l\'\"><div class=\"row th\" ng-if=\"folderList.length + contentList.length > 0\"><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.2\' | translate}}</div>\r\n        <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 text-right noPad\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder.id, folder.type, folder.splId);\"><div class=\"col-xs-4 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'Googledrive\'\" class=googleDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><!-- <div class=\"col-xs-2\">{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{folder.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{folder.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{folder.type}}</div><div class=\"col-xs-2 text-right noPad text-sm\">{{(folder.ps) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{folder.d}}</div></li><li class=row ng-repeat=\"content in filteredContentList = (contentList | customSearch:{key:search.text, module:\'cl\', filterType:filter}) | orderBy:orderVal\" ng-click=\"selectFx($event, \'content\', content.id, content.type, null, content);\" ng-if=content.isCompleted><div class=\"col-xs-4 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]]</span></div><div class=\"col-xs-2 text-right noPad text-sm\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{content.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderList.length + contentList.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && search.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentList.length == 0 && folderList.length == 0 && !advSearch\">{{\'cl.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && advSearch && advSearchInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=\"useContentFx(); removeAdvSearchFilterFx();\">{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); removeAdvSearchFilterFx();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=useContentErr.empty aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/selectSingleContentDInfo.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'cm.body.1\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(); searchInfo.text=\'\'\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=\"loading || contentLoading\"><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div>{{viewType = (uPreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx bdrR\" ng-class=\"{\'input-group\':contentObj.type != \'dmb\'}\" style=width:200px><input type=text class=form-control ng-model=searchInfo.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchInfo.text.length ng-click=\"searchInfo.text= \'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a> <span class=input-group-btn uib-dropdown ng-if=\"contentObj.type != \'dmb\'\"><button type=button role=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'cl\', \'w-sc\', \'w-alert\' , default);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); contentViewReloadFx()\">{{uPreferences.contentView == \'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=\"panel-body scrollQuad\" style=max-height:{{getAvailableHeight(304)}}px><!-- Advanced Search --><div class=clearfix></div><advanced-search adv-search-info=advSearchDInfo class=tASearch ng-if=advSearchDInfo></advanced-search><div class=breadcrumb ng-class=\"{\'marB5\':contentLibrary.info.wp || contentLibrary.info.sp}\" ng-if=\"breadCrumbsDBInfo.length > 0 && !openingLoading  && !advSearchDI && isDBInfo\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbsDBInfo\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><div ng-if=\"!contentLoading  && !advSearchDI\"><div ng-if=\"contentLibrary.info.wp && !openingLoading\" class=\"pad4 marB10\" ng-class=\"auth.uType == 4?\'msg-warning\':\'msg-success\'\" lang={{auth.lang}}><span ng-if=\"auth.uType != 4\"><span class=\"writable marR5\"></span>{{\'cl.msg.11\' | translate}}</span> <span ng-if=\"auth.uType == 4\"><span class=\"nonwritable marR5\"></span>{{\'cl.msg.12\' | translate}}</span></div><div ng-if=\"contentLibrary.info.sp && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"sharepoint marR5\"></span>{{\'cl.msg.27\' | translate}}</div><div ng-if=\"contentLibrary.info.od && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"oneDrive marR5\"></span>{{\'cl.msg.29\' | translate}}</div><div ng-if=\"contentLibrary.info.gd && !openingLoading\" class=\"pad5 msg-info marB10\"><span class=\"googleDrive marR5\"></span>{{\'cl.msg.61\' | translate}}</div></div><img alt=\"\" src=assets/images/loading.gif ng-if=contentLoading><!-- {{orderType = ((contentLibrary.info.sortType == \'label\') ? \'label\' : (contentLibrary.info.sortType == \'approvedon\') ? \'approvedOn\' : (contentLibrary.info.sortType == \'createdon\') ? \'createdOn\' : (contentLibrary.info.sortType == \'editedon\') ? \'editedOn\' : (contentLibrary.info.sortType == \'createdby\') ? \'cBy\' : (contentLibrary.info.sortType == \'type\') ? \'type\' : \'\');\'\'}} --><!-- {{orderVal = (contentLibrary.info.sortVal == \'desc\' ? \'-\'+orderType : orderType); \'\'}} --><ul class=\"list-inline thumb-list cl-list\" ng-if=\"!contentLoading && uPreferences.contentView == \'t\' && isDBInfo\"><li ng-repeat=\"folder in filteredFolderList = (folderListDBInfo | customSearch:{key:searchInfo.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder.id, folder.type, folder.splId);\"><div><div class=thumb-img><span class=thumb-inner><img alt=\"\" src=assets/images/default/folder_{{thumbSize}}.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type != \'Shortcut\' && folder.type != \'Sharepoint\' && folder.type != \'Onedrive\' && folder.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.label}}</div></div></li><li ng-repeat=\"content in filteredContentList = (contentListDBInfo | customSearch:{key:searchInfo.text, module:\'cl\', filterType:filter}) | orderBy:orderVal\" ng-click=\"selectFx($event, \'content\', content.id, content.type, null, content);\" ng-if=content.isCompleted><div class=thumb-img><span class=thumb-inner ng-if=!showAllTypeContent><img alt={{content.type}} ng-src=\"{{tim + cBucket + content.thumb + thumbParam + curToken}}\" ng-if=\"((content.type == \'Image\' && content.extn != \'WEBP\') || content.type == \'Video\' || content.type == \'POWERPOINT\' || content.type == \'WORD\' || content.type == \'Vector\') && content.isCompleted\" class=img-responsive> <img alt={{content.type}} ng-src=\"{{tim + cBucket + content.thumb + thumbParam + curToken}}\" src-error=\"{{cDetailBucket +\'widgets/thumbs/\'+ thumbSize +\'/na_thumb.png\'}}\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\" class=img-responsive> <img alt={{content.type}} ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png?v7\" ng-if=\"((content.type == \'Widget\' && content.isCompleted) || content.type == \'Flash\' || (content.type == \'Audio\' && content.isCompleted)) && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" class=img-responsive> <img alt=Processing ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize}}/processing_thumb.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\" class=img-responsive> <img alt={{content.type}} ng-src=\"{{content.thumb | trustUrl}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\" class=img-responsive><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss && content.isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <a ng-href=\"{{cDetailBucket + content.ssImg | secureThumb:timestamp}}\" fancyboxable=fbTitleInside data-fancybox-title={{content.label}} ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss && content.isCompleted\"><img alt=\"\" ng-src=\"{{tim + cBucket + content.ssImg +\'&v=\'+ timestamp + thumbParam}}\"> </a><img alt=sp ng-src=assets/images/default/thumbs/lg/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=od ng-src=assets/images/default/thumbs/lg/od.png ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=od ng-src=assets/images/default/thumbs/lg/gd.png ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=\"content.type == \'Video\' || content.type == \'Audio\' || (content.type == \'Widget\' && content.extn  == \'YouTube\' || content.extn  == \'Vimeo\')\" class=vDuration>{{content.duration | durations}}</span> <span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> <span ng-if=content.ss class=webpage></span> <span ng-if=\"content.type != \'folder\' && content.type != \'Sharepoint\' && content.type != \'Onedrive\' && content.type != \'SharedFolder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span> </span><!-- <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type != \'SharePointC\' && content.type != \'Audio\'\">\r\n            <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type != \'SharePointC\' && content.type == \'Flash\'\" class=\"img-responsive\">\r\n            <img alt=\"\" ng-src=\"{{cDetailBucket + \'widgets/thumbs/\' + thumbSize + \'/\' + content.thumb}}.png\" ng-if=\"content.type == \'Audio\'\" class=\"img-responsive\">\r\n            <img alt=\"\" src=\"assets/images/default/sp.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=\"img-responsive\">\r\n            <img alt=\"\" src=\"assets/images/default/od.png\" ng-if=\"content.type == \'OneDriveC\'\" class=\"img-responsive\">\r\n            <span class=\"thumb-icon cl\">\r\n              <span ng-if=\"content.type == \'Audio\'\" class=\"vDuration\">{{content.duration | durations}}</span>\r\n              <span ng-if=\"content.expiring\" class=\"expiring\"></span>\r\n              <span ng-if=\"content.wp\" ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span>\r\n              <span ng-if=\"content.type != \'folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span>\r\n            </span> --> </span><!-- F45 --> <span class=thumb-inner ng-if=showAllTypeContent uib-tooltip-html=\"\'<span class=\\\'glyphicon glyphicon-home marR5\\\' aria-hidden=\\\'true\\\'></span> {{content.path}}\'\" tooltip-append-to-body=true tooltip-popup-delay=1000><!-- Audio --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"><!-- Flash --> <img alt=\"\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\" ng-if=\"content.type != \'SharePointC\' && content.type == \'Flash\'\"><!-- Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && content.extn != \'YouTube\' && content.extn != \'Vimeo\' && content.extn != \'Web Page\' && content.extn != \'Auto Login (Basic Auth)\'\" ng-src={{cDetailBucket}}widgets/thumbs/n/{{content.thumb}}.png class=\"img-responsive center-block\"><!-- Web Page Widget --> <img alt=\"\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && !content.ss && content.isCompleted\" ng-src={{cDetailBucket}}widgets/thumbs/md/{{content.thumb}}.png?v{{timestamp}} class=\"img-responsive center-block img-widget\"> <img alt=\"\" ng-src=\"{{tim + cBucket + content.ssImg +\'&v=\'+ timestamp + thumbParam}}\" ng-if=\"content.type == \'Widget\' && (content.extn == \'Web Page\' || content.extn == \'Auto Login (Basic Auth)\') && content.ss && content.isCompleted\"><!-- Images --> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'Image\'\"><!-- YouTube & Vimeo --> <img alt=\"\" ng-src={{content.thumb}} class=\"img-responsive center-block\" ng-if=\"content.type == \'Widget\' && (content.extn == \'YouTube\' || content.extn == \'Vimeo\')\"><!-- Video --> <img alt=\"\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'Video\' && content.isCompleted\"><!-- Template --> <img alt=\"\" ng-src=\"{{tim + tBucket + content.thumb + thumbParam + \'&\' + content.thumbV}}\" class=\"img-responsive center-block\" ng-if=\"content.type == \'template\'\"><!-- Other --> <img alt=\"\" ng-if=\"content.type != \'Image\' && content.type != \'Widget\' && content.type != \'Video\' && content.type != \'Audio\' && content.type != \'Flash\' && content.type != \'template\' && content.isCompleted\" ng-src=\"{{tim + cBucket + content.thumb + thumbParam}}\" class=\"img-responsive center-block\"> <img alt=\"\" ng-if=\"content.type != \'Widget\' && !content.isCompleted\" ng-src=assets/images/default/processing_selected.png class=\"img-responsive center-block\"> <img alt=\"\" src=assets/images/default/thumbs/lg/sp.png ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/lg/od.png ng-if=\"content.type == \'OneDriveC\'\" class=img-responsive> <img alt=\"\" src=assets/images/default/thumbs/lg/gd.png ng-if=\"content.type == \'GoogleDriveC\'\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.ss class=webpage></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"content.type !== \'Folder\'\" class=\"{{content.type.toLowerCase()}} {{content.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label>{{content.label}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderListDBInfo.length + contentListDBInfo.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && searchInfo.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchInfo.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentListDBInfo.length == 0 && folderListDBInfo.length == 0 && !advSearchDI\">{{\'cl.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && advSearchDI && advSearchDInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></ul><ul class=\"table table-md ui-selectable list-unstyled cl-list\" ng-if=\"!contentLoading && uPreferences.contentView == \'l\' && isDBInfo\"><div class=\"row th\" ng-if=\"folderListDBInfo.length + contentListDBInfo.length > 0\"><div class=col-xs-4>{{\'cm.brief.1\' | translate}}</div><!-- <div class=\"col-xs-2\">{{\'cm.brief.2\' | translate}}</div>\r\n        <div class=\"col-xs-2\">{{\'cm.brief.3\' | translate}}</div> --><div class=col-xs-3>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 text-right noPad\">{{\'cm.brief.12\' | translate}}</div><div class=\"col-xs-3 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><li class=row ng-repeat=\"folder in filteredFolderList = (folderListDBInfo | customSearch:{key:searchInfo.text, module:\'clf\', filterType:filter})\" ng-dblclick=\"selectFx($event, \'folder\', folder.id, folder.type, folder.splId);\"><div class=\"col-xs-4 text-ellipsis\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><!-- <div class=\"col-xs-2\">{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{folder.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{folder.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{folder.type}}</div><div class=\"col-xs-2 text-right noPad text-sm\">{{(folder.ps) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{folder.d}}</div></li><li class=row ng-repeat=\"content in filteredContentList = (contentListDBInfo | customSearch:{key:searchInfo.text, module:\'cl\', filterType:filter}) | orderBy:orderVal\" ng-click=\"selectFx($event, \'content\', content.id, content.type, null, content);\" ng-if=content.isCompleted><div class=\"col-xs-4 text-ellipsis clViwe\"><span class=cl-cIcon><img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"(content.type == \'Image\' && content.extn != \'WEBP\') && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'video-sm-white\' : \'video-sm\'}}.png\" ng-if=\"content.type == \'Video\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'ppt-xs-white\' : \'ppt-xs\'}}.png\" ng-if=\"content.type == \'POWERPOINT\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'word-xs-white\' : \'word-xs\'}}.png\" ng-if=\"content.type == \'WORD\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'pdf-xs-white\' : \'pdf-xs\'}}.png\" ng-if=\"content.type == \'Vector\' && content.isCompleted\"> <span class=\"icon {{content.thumb}}\" ng-if=\"(content.type == \'Widget\' && content.isCompleted) && (content.extn != \'YouTube\' && content.extn != \'Vimeo\')\"></span> <span class=\"icon vimeoIcon\" ng-if=\"content.type == \'Widget\' && content.extn == \'Vimeo\'\"></span> <span class=\"icon youTube\" ng-if=\"content.type == \'Widget\' && content.extn == \'YouTube\'\"></span> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"content.extn == \'WEBP\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'swf-xs-white\' : \'swf-xs\'}}.png\" ng-if=\"content.type == \'Flash\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'audio-xs-white\' : \'audio-xs\'}}.png\" ng-if=\"content.type == \'Audio\' && content.isCompleted\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'sp-xs-white\' : \'sp-xs\'}}.png\" ng-if=\"content.type == \'SharePointC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'od-xs-white\' : \'od-xs\'}}.png\" ng-if=\"content.type == \'OneDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'gd-xs-white\' : \'gd-xs\'}}.png\" ng-if=\"content.type == \'GoogleDriveC\' && (content.extn != \'WEBP\' && content.isCompleted)\"> <img alt={{content.type}} ng-src=\"assets/images/default/{{myTheme.theme==\'dk\' ? \'photo-xs-white\' : \'photo-xs\'}}.png\" ng-if=\"!content.isCompleted && content.type != \'Flash\'\"> <span class=\"thumb-icon cl\"><span ng-if=content.expiring class=expiring></span> <span ng-if=content.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=content.sp class=sharepoint></span> <span ng-if=content.od class=oneDrive></span> <span ng-if=content.sf class=sharedFolder></span> </span></span><span uib-tooltip={{content.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{content.label}}</span></div><!-- <div class=\"col-xs-2\">{{(content.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div>\r\n        <div class=\"col-xs-2 text-ellipsis\" uib-tooltip=\"{{content.cBy}}\" tooltip-append-to-body=\"true\" tooltip-popup-delay=\"1000\">{{content.cBy}}</div> --><div class=\"col-xs-3 text-sm\">{{content.type}} <span ng-if=\"content.type==\'Widget\'\">[{{(content.extn == \'Button\' ? content.extn + \' - \' + content.btnExtn : content.extn)}}]</span></div><div class=\"col-xs-2 text-right noPad text-sm\">{{(content.pSize) | filesize}}</div><div class=\"col-xs-3 text-right text-sm\">{{content.d}}</div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"folderListDBInfo.length + contentListDBInfo.length > 0 && filteredFolderList.length + filteredContentList.length == 0 && searchInfo.text !=\'\'\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchInfo.text)}}&quot;</b>\'}\"></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && contentListDBInfo.length == 0 && folderListDBInfo.length == 0 && !advSearchDI\">{{\'cl.msg.1\' | translate}}</div><div class=msg-warning lang={{auth.lang}} ng-if=\"!contentLoading && advSearchDI && advSearchDInfo.isEmpty\">{{\'as.msg.2\' | translate}}</div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=\"useContentFx(); removeAdvSearchFilterFx();\">{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(); removeAdvSearchFilterFx();\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=useContentErr.empty aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/stocksList.html","<section class=panel role=dialog><header class=panel-heading>All Stocks {{\'\' | translate}}<div class=\"searchTbx bdrR\"><input type=text class=form-control ng-model=searchTextPopup sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=searchTextPopup.length ng-click=\"searchTextPopup=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div></header><div class=panel-body><img alt=Loading src=assets/images/loading.gif ng-if=\"openPopupLoading || pageLoading\"><div ng-if=!openPopupLoading><div class=scrollQuad ng-if=filteredStock.length style=max-height:{{getAvailableHeight(390)}}px><ul class=list-inline><li ng-repeat=\"stock in filteredStocks = (filteredStock | customSearch:{key:searchTextPopup, module:\'stock\'})\" class=w50 ng-if=\"stock.name !== \'\'\"><div class=text-ellipsis><label><input type=checkbox ng-model=stock.selected role=checkbox><label></label>{{stock.symbol}} - {{stock.name}}</label></div></li></ul><div class=msg-warning lang={{auth.lang}} ng-if=!filteredStocks.length translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText: \'<b>&quot;{{escapeSearchText(searchTextPopup)}}&quot;</b>\'}\"></div></div><div class=\"pagination noMarB\"><ul class=\"pagination-sm pagination noMar\"><li ng-class=\"{disabled:curPage == 0}\"><a href=\"\" role=link ng-click=\"selectPageFx(\'f\');\"><span class=\"fa fa-angle-double-left\" aria-hidden=true></span></a></li><li ng-class=\"{disabled:curPage == 0}\"><a href=\"\" role=link ng-click=\"selectPageFx(\'p\')\"><span class=\"fa fa-angle-left\" aria-hidden=true></span></a></li><li ng-repeat=\"page in alphabet track by $index\" ng-class=\"{active: $index == curPage}\"><a href=\"\" role=link ng-click=\"selectPageFx(\'s\')\">{{page | uppercase}}</a></li><li ng-class=\"{disabled:(curPage) == alphabet.length - 1}\"><a href=\"\" role=link ng-click=\"selectPageFx(\'n\')\"><span class=\"fa fa-angle-right\" aria-hidden=true></span></a></li><li ng-class=\"{disabled:(curPage) == alphabet.length - 1}\"><a href=\"\" role=link ng-click=\"selectPageFx(\'l\')\"><span class=\"fa fa-angle-double-right\" aria-hidden=true></span></a></li></ul></div><div class=msg-warning lang={{auth.lang}} ng-if=\"!pageLoading && !filteredStock.length\">{{\'cm.msg.36\' | translate}}</div></div></div><footer class=panel-footer ng-if=!openPopupLoading><span class=btnQuad><button type=button role=button class=\"btn btn-primary\" ng-click=selectStockFx(); ng-disabled=songsProcessing><span class=\"fa fa-repeat fa-spin\" ng-if=songsProcessing aria-hidden=true></span>{{\'cm.btn.1\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=\"closeThisDialog(\'c\');\" data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasSelectErr aria-live=polite role=status>{{\'cl.msg.17\' | translate}}</div><div class=\"errMsg pull-right\" ng-if=maxCountPop aria-live=polite role=status>{{\'cl.widget.mc.m10\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/contentLibrary/widgets/popup/templateList.html","<section class=panel><header class=panel-heading><h1>{{\'t.body.3\' | translate}}</h1><div class=\"pull-right bdrR\"><a href=\"\" role=link id=refresh class=\"pad5 marLR5\" ng-click=\"refreshPopupListFx(\'content\',contentCountList.brief); search.text=\'\';\" uib-tooltip=\"{{\'cm.btn.33\' | translate}}\" ng-disabled=loading><span class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\" aria-hidden=true></span></a></div><div class=\"searchTbx bdrR hide\"><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" role=link class=text-danger ng-show=search.text.length ng-click=\"search.text=\'\'\"><span class=\"fa fa-remove\" aria-hidden=true></span></a></div>{{viewType = (auth.upreferences.contentView == \'t\' ? \'l\' : \'t\'); \'\'}}<div class=\"searchTbx input-group bdrR\" style=width:200px><input type=text class=form-control ng-model=search.text sanitize-input maxlength=250 placeholder=\"{{\'cm.ph.1\' | translate}}\" aria-label=\"{{\'cm.ph.1\' | translate}}\" aria-labelledby=\"{{\'cm.ph.1\' | translate}}\" aria-placeholder=\"{{\'cm.ph.1\' | translate}}\" autocomplete=off> <a href=\"\" class=text-danger ng-show=search.text.length ng-click=\"search.text=\'\'\"><span class=\"fa fa-remove\"></span></a> <span class=input-group-btn uib-dropdown><button type=button class=\"btn btn-default\" uib-dropdown-toggle><span class=\"fa fa-ellipsis-v noMarR\" aria-hidden=true></span></button><ul class=dropdown-menu-right uib-dropdown-menu role=menu><li><a href=\"\" role=link ng-click=\"advancedSearchOpen(\'t\', \'stm\', decId);\">{{\'cm.body.10\' | translate}}</a></li><li><a href=\"\" role=link ng-click=\"preferencesFx(\'contentView\', viewType); \">{{auth.upreferences.contentView==\'t\'?\'cm.tool.6\':\'cm.tool.5\' | translate}}</a></li></ul></span></div></header><div class=\"panel-body scrollQuad\" ng-attr-style=max-height:{{getAvailableHeight(304)}}px><advanced-search adv-search-info=advSearchInfo ng-if=\"!templatesLoading && advancedShow\" class=\"tASearch padLR5\"></advanced-search><div class=breadcrumb ng-if=\"!templatesLoading && breadCrumbs.length > 0 && !advSearch\"><a href=\"\" role=link ng-click=folderContentFx(0);><span class=\"glyphicon glyphicon-home\" aria-hidden=true></span></a> <span class=slash-icon>/</span> <span ng-repeat=\"breadcrumb in breadCrumbs\"><a href=\"\" role=link ng-click=\"folderContentFx(breadcrumb.id, breadcrumb.splId, breadcrumb.type);\" ng-if=!$last>{{breadcrumb.label}}</a> <span ng-if=$last>{{breadcrumb.label}}</span> <span class=slash-icon ng-if=!$last>/</span> </span><a href=\"\" role=link class=\"pull-right hide\"><span class=\"glyphicon glyphicon-chevron-up\" aria-hidden=true></span> {{\'cm.btn.41\' | translate}}</a></div><img alt=Loading src=assets/images/loading.gif ng-if=templatesLoading><!-- Thumb View --><ul class=\"list-inline thumb-list\" ng-if=\"!templatesLoading && uPreferences.templateView == \'t\'\" element-height=quadHeight selectable=selection selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\" selectable-list=\"templateList | filter:search.text\"><!-- folderList --><li ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt class=tabIndex><div class=thumb-img><span class=thumb-inner><img alt=Folder src=assets/images/default/folder_n.png> <span class=thumb-icon><span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span></span></span></div><div class=thumb-label>{{folder.label}}</div></li><!-- templateList --><li ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:search.text, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.type}} ng-class=\"{\'nonSelectable unapprovedFile\':template.isApproved === 0}\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-append-to-body=true context-menu=contextMenuOpt tooltip-enable=\"template.isApproved === 0\"><div class=thumb-img><span class=thumb-inner ng-class=\"{\'overflow-hidden\':template.isblur}\"><img alt=Incomplete src=assets/images/default/incomplete.png ng-if=!template.thumb> <img alt=Templates ng-src=\"{{tim + tBucket + template.thumb +\'?v\'+ template.thumbV + thumbParam}}\" ng-if=template.thumb ng-class=\"{\'blurry-img\':template.isblur}\"> <img alt=na ng-src=\"{{tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/n/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span></span></span></div><div class=thumb-label>{{template.label}}</div></li><div class=msg-warning ng-if=\"(folderList.length || templateList.length) && filteredFolderList.length + filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><div class=msg-warning ng-if=\"!templatesLoading && (!folderList.length && !templateList.length)\">{{\'t.msg.1\' | translate}}</div></ul><!-- List View --><ul class=\"table table-md ui-selectable list-unstyled\" ng-if=\"!templatesLoading && uPreferences.templateView == \'l\'\" element-height=quadHeight selectable=selection selectable-options=\"{filter:\'li\', cancel:\'.nonSelectable\'}\" selectable-list=\"templateList | filter:search.text\"><div class=\"row th\" ng-if=\"folderList.length + templateList.length > 0\"><div class=col-xs-4><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'label\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.1\' | translate}} <span ng-if=\"curSort.sortType == \'label\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.1\' | translate}}</span></div><div class=col-xs-2><a href=\"\" ng-if=isTemplateSorting ng-click=\"sortFx(\'createdon\', \'asc\', templateList, templates.info, \'templatesort\', folderList, \'tList\');\">{{\'cm.brief.2\' | translate}} <span ng-if=\"curSort.sortType == \'createdon\'\" ng-class=\"curSort.sortVal==\'asc\'?\'fa fa-caret-up\':\'fa fa-caret-down\'\"></span></a> <span ng-if=!isTemplateSorting>{{\'cm.brief.2\' | translate}}</span></div><div class=col-xs-2>{{\'cm.brief.3\' | translate}}</div><div class=col-xs-2>{{\'cm.label.69\' | translate}}</div><div class=\"col-xs-2 text-right\">{{\'cm.brief.8\' | translate}} <span class=\"text-muted text-sm\">(WxH)</span></div></div><!-- folderList --><li class=row ng-repeat=\"folder in filteredFolderList = (folderList | customSearch:{key:search.text, module:\'clf\', filterType:filter})\" data-id={{folder.id}} data-type=\"{{folder.type | lowercase}}\" data-sub-type=f data-spl-id={{folder.splId}} data-spid={{folder.spid}} data-pid={{folder.pid}} data-index=$index ng-if=\"folderList.length > 0\" context-menu=contextMenuOpt><div class=\"text-ellipsis col-xs-4\"><span class=cl-fIcon><img alt=Folder src=assets/images/default/folder-xs.png> <span class=thumb-icon><span ng-if=\"folder.type == \'Shortcut\'\" class=shortcut></span> <span ng-if=\"folder.type == \'Sharepoint\'\" class=sharepoint></span> <span ng-if=\"folder.type == \'Onedrive\'\" class=oneDrive></span> <span ng-if=\"folder.type == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=\"folder.type == \'Folder\' && folder.subtype == \'SharedFolder\'\" class=sharedFolder></span> <span ng-if=folder.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> </span></span><span uib-tooltip={{folder.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.label}}</span></div><div class=col-xs-2 ng-if=\"selectedTab != \'hub.sContainer.sContent\'\">{{(folder.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" ng-if=\"selectedTab != \'hub.sContainer.sContent\'\" uib-tooltip={{folder.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{folder.cBy}}</div><div class=\"col-xs-2 text-sm\">{{folder.type}}</div><div class=\"col-xs-2 text-right text-sm\">{{folder.d}}</div></li><!-- templateList --><li class=row ng-repeat=\"template in filteredTemplateList = (templateList | customSearch:{key:search.text, module:\'t\', filterType:filter})\" data-id={{template.id}} data-type=template data-sub-type={{template.tType}} data-extn={{template.extn}} ng-class=\"{\'nonSelectable unapprovedFile\':template.isApproved == 0}\" uib-tooltip=\"{{\'cl.tool.11\' | translate}}\" tooltip-enable=\"template.isApproved === 0\" tooltip-append-to-body=true context-menu=contextMenuOpt><div class=\"col-xs-4 text-ellipsis clViwe tList-thumb\"><span class=cl-cIcon><img alt=Incomplete src=assets/images/default/incomplete-xs.png ng-if=!template.thumb> <img alt={{template.tType}} ng-src=\"{{tim + tBucket + template.thumb + thumbParam + \'&\' + template.thumbV}}\" class=img-responsive> <img alt=na ng-src=\"{{tim + cBucket + template.thumb + thumbParam + curToken}}\" src-error=https://s3-us-west-2.amazonaws.com/dev-lsquared-hub/cl/widgets/thumbs/{{thumbSize}}/na_thumb.png ng-if=\"template.extn == \'WEBP\' && template.isCompleted\" class=img-responsive> <span class=\"thumb-icon cl\"><span ng-if=template.expiring class=expiring></span> <span ng-if=template.wp ng-class=\"auth.uType == 4?\'nonwritable\':\'writable\'\"></span> <span ng-if=\"template.type != \'folder\' && template.type != \'Sharepoint\' && template.type != \'Onedrive\'\" class=\"{{template.type.toLowerCase()}} {{template.extn.toLowerCase()}}\"></span> </span></span><span uib-tooltip={{template.label}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.label}}</span></div><div class=col-xs-2>{{(template.createdOn * 1000) | date:\"MMM d, y h:mm a\"}}</div><div class=\"col-xs-2 text-ellipsis\" uib-tooltip={{template.cBy}} tooltip-append-to-body=true tooltip-popup-delay=1000>{{template.cBy}}</div><div class=\"col-xs-2 text-sm\"><span ng-if=\"template.tType == 0\">{{\'cl.tool.2\' | translate}}</span> <span ng-if=\"template.tType == 1\">{{\'d.label.1.8\' | translate}}</span> <span ng-if=\"template.tType == 2\">{{\'fl.p_cfl.label.24\' | translate}}</span> <span ng-if=\"template.tType == 3\">{{\'t.label.22\' | translate}}</span> <span ng-if=\"template.tType == 4\">{{\'fl.p_cfl.label.26\' | translate}}</span></div><div class=\"col-xs-2 text-right text-sm\">{{template.d}}</div></li><div class=msg-warning ng-if=\"(folderList.length || templateList.length) && filteredFolderList.length + filteredTemplateList.length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(search.text)}}&quot;</b>\'}\"></div><div class=msg-warning ng-if=\"!templatesLoading && (!folderList.length && !templateList.length)\">{{\'t.msg.1\' | translate}}</div></ul></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-default\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.10\' | translate}}</button></span><div class=clearfix></div></footer></section>");
$templateCache.put("app/reports/dir/tmpl/csChart.html","<div ng-repeat=\"item in csChartData\"><div ng-if=!item.isEmpty><div class=quadTitle>{{item.n}}</div><highchart config=item.cfg></highchart><div class=\"highcharts-cPoint marB20\"><span style=background-color:blue></span> {{\'r.body.10\' | translate}} <span style=background-color:green></span> {{\'r.body.11\' | translate}} <span style=background-color:#CC0000></span> {{\'r.body.12\' | translate}} <span style=background-color:gray></span> {{\'r.body.13\' | translate}}</div></div><div class=padL10 ng-if=item.isEmpty><div class=quadTitle>{{item.title}}</div><div class=\"msg-warning marB20\" lang={{auth.lang}}>{{\'r.msg.2\' | translate}}</div></div><hr class=marTB10 ng-if=!$last></div>");
$templateCache.put("app/support/featureRequest/dir/featuerList.html","<ul class=\"list-inline vote-list\" role=list><li ng-repeat=\"fr in featureR | filter: searchText\" role=listitem><div class=vote-quad><div class=\"vote-count marB5\">{{fr.votes}}</div><div class=text-muted>{{fr.votes > 1?\'sc.fr.body.5s\':\'sc.fr.body.5\' | translate}}</div></div><div class=vote-contant><h5 class=\"text-ellipsis text-16\"><div class=\"pull-left marB2 marR5\"><a ui-sref=\"hub.featureDetails({id: hubEncrypt(fr.id)})\" role=button>{{fr.title}}</a></div><div class=\"pull-left bg-info pad2\" ng-if=\"fr.status == 1\">{{\'sc.fr.body.8\' | translate}}</div><div class=\"pull-left bg-success pad2\" ng-if=\"fr.status == 2\">{{\'sc.fr.body.9\' | translate}}</div></h5><div class=\"text-ellipsis text-muted text-sm marT3\">{{fr.label}}</div><div class=\"text-ellipsis marT3\">{{fr.description}}</div><ul class=\"list-inline list-pipe marT5 text-sm\"><li><span class=\"text-bold text-muted\">{{(fr.createdOn * 1000) | date:\"medium\"}}</span></li><li><a class=btn-link ui-sref=\"hub.featureDetails({id: hubEncrypt(fr.id)})\">{{fr.comments}} {{fr.comments > 1?\'sc.fr.p_comment.body.2s\':\'sc.fr.p_comment.body.2\' | translate}}</a></li><li ng-if=\"fr.isOwner == 0\"><a href=\"\" role=link class=btn-link ng-click=\"reportRequestFx(fr.id, \'request\');\" ng-disabled=reportProcessing>{{\'sc.fr.body.7\' | translate}}</a></li><li ng-if=\"fr.isOwner  || auth.uType == 0\"><a href=\"\" role=link ng-click=\"requestOpen(\'edit\', fr.id);\" class=\"text-primary marR5\"><span class=\"fa fa-pencil\" aria-hidden=true></span> {{\'cm.btn.22\' | translate}}</a> <a href=\"\" role=link ng-click=\"deleteOpen(fr.id, \'request\');\" class=text-danger><span class=\"fa fa-remove\" aria-hidden=true></span> {{\'cm.btn.13\' | translate}}</a></li></ul></div></li><div class=msg-warning lang={{auth.lang}} ng-if=\"(featureR | filter:searchText).length == 0\" translate=\"{{\'cm.msg.14\'}}\" translate-values=\"{searchText:\'<b>&quot;{{escapeSearchText(searchText)}}&quot;</b>\'}\"></div></ul>");
$templateCache.put("app/support/featureRequest/popup/comments.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{\'sc.fr.p_comment.body.3\' | translate}}</h1></header><div class=panel-body><div class=form-group><label for=comment>{{\'sc.fr.p_add.3\' | translate}}</label><textarea class=form-control ng-model=commentObj.comment id=comment required rows=4 maxlength={{commentLimit}} aria-label=\"{{\'sc.fr.p_add.3\' | translate}}\" aria-labelledby=\"{{\'sc.fr.p_add.3\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{commentLimit - commentObj.comment.length}} ]</span></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=\"saveCommentsFx(\'popup\');\" ng-disabled=popupProcessing><span class=fa ng-class=\"popupProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{\'cm.btn.42\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasPopupErr aria-live=polite role=status>{{\'sc.fr.p_comment.msg.4\' | translate}}</div><div class=clearfix></div></footer></section>");
$templateCache.put("app/support/featureRequest/popup/info.html","<section class=panel role=dialog><header class=panel-heading><h1 ng-if=\"ngDialogData.tabName==\'rf\'\" role=heading aria-level=1>{{\'sc.fr.msg.5\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'af\'\" role=heading aria-level=1>{{\'sc.fr.msg.7\' | translate}}</h1><h1 ng-if=\"ngDialogData.tabName==\'im\'\" role=heading aria-level=1>{{\'sc.fr.msg.9\' | translate}}</h1></header><div class=panel-body><p ng-if=\"ngDialogData.tabName==\'rf\'\" translate=\"{{\'sc.fr.info.2\'}}\" translate-values=\"{lsnh: \'L Squared Hub\'}\"></p><p ng-if=\"ngDialogData.tabName==\'af\'\" translate=\"{{\'sc.fr.info.3\'}}\" translate-values=\"{lsn: \'L Squared\'}\"></p><p ng-if=\"ngDialogData.tabName==\'im\'\" translate=\"{{\'sc.fr.info.4\'}}\"></p></div></section>");
$templateCache.put("app/support/featureRequest/popup/request.html","<section class=panel role=dialog><header class=panel-heading><h1 role=heading aria-level=1>{{request.id?\'sc.fr.btn.2\':\'sc.fr.btn.1\' | translate}}</h1></header><div class=panel-body><div class=marB20>{{\'sc.fr.p_add.1\' | translate}}</div><div class=form-group><label for=title>{{\'sc.fr.p_add.2\' | translate}}</label><input type=text id=title class=form-control ng-model=request.title maxlength={{inputLimit}} aria-label=\"{{\'sc.fr.p_add.2\' | translate}}\" aria-labelledby=\"{{\'sc.fr.p_add.2\' | translate}}\"></div><div class=form-group><label for=description>{{\'sc.fr.p_add.3\' | translate}}</label><textarea class=form-control ng-model=request.description id=description required rows=5 maxlength={{descriptionLimit}} aria-label=\"{{\'sc.fr.p_add.3\' | translate}}\" aria-labelledby=\"{{\'sc.fr.p_add.3\' | translate}}\"></textarea><span class=\"text-muted text-sm\">[ {{descriptionLimit - request.description.length}} ]</span></div></div><footer class=panel-footer><span class=btnQuad><button type=button role=button class=\"btn btn-success\" ng-click=saveRequestFx(); ng-disabled=saveProcessing><span class=fa ng-class=\"saveProcessing?\'fa-repeat fa-spin\':\'fa-check\'\" aria-hidden=true></span>{{bugsProcessing?\'cm.btn.35i\':\'cm.btn.42\' | translate}}</button> <button type=button role=button class=\"btn btn-link\" ng-click=closeThisDialog(); data-dismiss=modal>{{\'cm.btn.9\' | translate}}</button></span><div class=\"errMsg pull-right\" ng-if=hasErr aria-live=polite role=status><span ng-if=\"errType==\'title\'\" aria-live=polite role=status>{{\'sc.fr.p_add.m1\' | translate}}</span> <span ng-if=\"errType==\'description\'\" aria-live=polite role=status>{{\'sc.fr.msg.1\' | translate}}</span></div><div class=clearfix></div></footer></section>");}]);